import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Json: any;
  Placeholder: any;
};

export type AcceptUserInvitationInput = {
  invitationCode: Scalars['String'];
};

export type AcceptUserInvitationResponse = {
  __typename?: 'AcceptUserInvitationResponse';
  token?: Maybe<Scalars['String']>;
};

export type ActiveIngredient = {
  __typename?: 'ActiveIngredient';
  chemicalCompound: ChemicalCompound;
  chemicalCompoundId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  product: Product;
  productId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ActiveIngredientAvgAggregateOutputType = {
  __typename?: 'ActiveIngredientAvgAggregateOutputType';
  massPerDose?: Maybe<Scalars['Float']>;
};

export type ActiveIngredientAvgOrderByAggregateInput = {
  massPerDose?: Maybe<SortOrder>;
};

export type ActiveIngredientCountAggregateOutputType = {
  __typename?: 'ActiveIngredientCountAggregateOutputType';
  _all: Scalars['Int'];
  chemicalCompoundId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  massPerDose: Scalars['Int'];
  massPerDoseUnit: Scalars['Int'];
  productId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ActiveIngredientCountOrderByAggregateInput = {
  chemicalCompoundId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massPerDose?: Maybe<SortOrder>;
  massPerDoseUnit?: Maybe<SortOrder>;
  productId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ActiveIngredientCreateInput = {
  chemicalCompound: ChemicalCompoundCreateNestedOneWithoutActiveIngredientsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  product: ProductCreateNestedOneWithoutActiveIngredientsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientCreateManyChemicalCompoundInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientCreateManyChemicalCompoundInputEnvelope = {
  data: Array<ActiveIngredientCreateManyChemicalCompoundInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ActiveIngredientCreateManyInput = {
  chemicalCompoundId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientCreateManyProductInput = {
  chemicalCompoundId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientCreateManyProductInputEnvelope = {
  data: Array<ActiveIngredientCreateManyProductInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ActiveIngredientCreateNestedManyWithoutChemicalCompoundInput = {
  connect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ActiveIngredientCreateOrConnectWithoutChemicalCompoundInput>>;
  create?: Maybe<Array<ActiveIngredientCreateWithoutChemicalCompoundInput>>;
  createMany?: Maybe<ActiveIngredientCreateManyChemicalCompoundInputEnvelope>;
};

export type ActiveIngredientCreateNestedManyWithoutProductInput = {
  connect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ActiveIngredientCreateOrConnectWithoutProductInput>>;
  create?: Maybe<Array<ActiveIngredientCreateWithoutProductInput>>;
  createMany?: Maybe<ActiveIngredientCreateManyProductInputEnvelope>;
};

export type ActiveIngredientCreateOrConnectWithoutChemicalCompoundInput = {
  create: ActiveIngredientCreateWithoutChemicalCompoundInput;
  where: ActiveIngredientWhereUniqueInput;
};

export type ActiveIngredientCreateOrConnectWithoutProductInput = {
  create: ActiveIngredientCreateWithoutProductInput;
  where: ActiveIngredientWhereUniqueInput;
};

export type ActiveIngredientCreateWithoutChemicalCompoundInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  product: ProductCreateNestedOneWithoutActiveIngredientsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientCreateWithoutProductInput = {
  chemicalCompound: ChemicalCompoundCreateNestedOneWithoutActiveIngredientsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientGroupByOutputType = {
  __typename?: 'ActiveIngredientGroupByOutputType';
  _avg?: Maybe<ActiveIngredientAvgAggregateOutputType>;
  _count?: Maybe<ActiveIngredientCountAggregateOutputType>;
  _max?: Maybe<ActiveIngredientMaxAggregateOutputType>;
  _min?: Maybe<ActiveIngredientMinAggregateOutputType>;
  _sum?: Maybe<ActiveIngredientSumAggregateOutputType>;
  chemicalCompoundId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ActiveIngredientListRelationFilter = {
  every?: Maybe<ActiveIngredientWhereInput>;
  none?: Maybe<ActiveIngredientWhereInput>;
  some?: Maybe<ActiveIngredientWhereInput>;
};

export type ActiveIngredientMaxAggregateOutputType = {
  __typename?: 'ActiveIngredientMaxAggregateOutputType';
  chemicalCompoundId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientMaxOrderByAggregateInput = {
  chemicalCompoundId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massPerDose?: Maybe<SortOrder>;
  massPerDoseUnit?: Maybe<SortOrder>;
  productId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ActiveIngredientMinAggregateOutputType = {
  __typename?: 'ActiveIngredientMinAggregateOutputType';
  chemicalCompoundId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientMinOrderByAggregateInput = {
  chemicalCompoundId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massPerDose?: Maybe<SortOrder>;
  massPerDoseUnit?: Maybe<SortOrder>;
  productId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ActiveIngredientOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ActiveIngredientOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ActiveIngredientOrderByRelevanceInput>;
  chemicalCompound?: Maybe<ChemicalCompoundOrderByWithRelationInput>;
  chemicalCompoundId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massPerDose?: Maybe<SortOrder>;
  massPerDoseUnit?: Maybe<SortOrder>;
  product?: Maybe<ProductOrderByWithRelationInput>;
  productId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ActiveIngredientOrderByRelevanceFieldEnum {
  ChemicalCompoundId = 'chemicalCompoundId',
  Id = 'id',
  MassPerDoseUnit = 'massPerDoseUnit',
  ProductId = 'productId'
}

export type ActiveIngredientOrderByRelevanceInput = {
  fields: Array<ActiveIngredientOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ActiveIngredientOrderByWithAggregationInput = {
  _avg?: Maybe<ActiveIngredientAvgOrderByAggregateInput>;
  _count?: Maybe<ActiveIngredientCountOrderByAggregateInput>;
  _max?: Maybe<ActiveIngredientMaxOrderByAggregateInput>;
  _min?: Maybe<ActiveIngredientMinOrderByAggregateInput>;
  _sum?: Maybe<ActiveIngredientSumOrderByAggregateInput>;
  chemicalCompoundId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massPerDose?: Maybe<SortOrder>;
  massPerDoseUnit?: Maybe<SortOrder>;
  productId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ActiveIngredientOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ActiveIngredientOrderByRelevanceInput>;
  chemicalCompound?: Maybe<ChemicalCompoundOrderByWithRelationInput>;
  chemicalCompoundId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massPerDose?: Maybe<SortOrder>;
  massPerDoseUnit?: Maybe<SortOrder>;
  product?: Maybe<ProductOrderByWithRelationInput>;
  productId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ActiveIngredientOrderByWithRelationInput = {
  _relevance?: Maybe<ActiveIngredientOrderByRelevanceInput>;
  chemicalCompound?: Maybe<ChemicalCompoundOrderByWithRelationInput>;
  chemicalCompoundId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massPerDose?: Maybe<SortOrder>;
  massPerDoseUnit?: Maybe<SortOrder>;
  product?: Maybe<ProductOrderByWithRelationInput>;
  productId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ActiveIngredientScalarFieldEnum {
  ChemicalCompoundId = 'chemicalCompoundId',
  CreatedAt = 'createdAt',
  Id = 'id',
  MassPerDose = 'massPerDose',
  MassPerDoseUnit = 'massPerDoseUnit',
  ProductId = 'productId',
  UpdatedAt = 'updatedAt'
}

export type ActiveIngredientScalarWhereInput = {
  AND?: Maybe<Array<ActiveIngredientScalarWhereInput>>;
  NOT?: Maybe<Array<ActiveIngredientScalarWhereInput>>;
  OR?: Maybe<Array<ActiveIngredientScalarWhereInput>>;
  chemicalCompoundId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  massPerDose?: Maybe<FloatNullableFilter>;
  massPerDoseUnit?: Maybe<StringNullableFilter>;
  productId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ActiveIngredientScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ActiveIngredientScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ActiveIngredientScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ActiveIngredientScalarWhereWithAggregatesInput>>;
  chemicalCompoundId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  massPerDose?: Maybe<FloatNullableWithAggregatesFilter>;
  massPerDoseUnit?: Maybe<StringNullableWithAggregatesFilter>;
  productId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ActiveIngredientSumAggregateOutputType = {
  __typename?: 'ActiveIngredientSumAggregateOutputType';
  massPerDose?: Maybe<Scalars['Float']>;
};

export type ActiveIngredientSumOrderByAggregateInput = {
  massPerDose?: Maybe<SortOrder>;
};

export type ActiveIngredientUncheckedCreateInput = {
  chemicalCompoundId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUncheckedCreateNestedManyWithoutChemicalCompoundInput = {
  connect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ActiveIngredientCreateOrConnectWithoutChemicalCompoundInput>>;
  create?: Maybe<Array<ActiveIngredientCreateWithoutChemicalCompoundInput>>;
  createMany?: Maybe<ActiveIngredientCreateManyChemicalCompoundInputEnvelope>;
};

export type ActiveIngredientUncheckedCreateNestedManyWithoutProductInput = {
  connect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ActiveIngredientCreateOrConnectWithoutProductInput>>;
  create?: Maybe<Array<ActiveIngredientCreateWithoutProductInput>>;
  createMany?: Maybe<ActiveIngredientCreateManyProductInputEnvelope>;
};

export type ActiveIngredientUncheckedCreateWithoutChemicalCompoundInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUncheckedCreateWithoutProductInput = {
  chemicalCompoundId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUncheckedUpdateInput = {
  chemicalCompoundId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUncheckedUpdateManyInput = {
  chemicalCompoundId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUncheckedUpdateManyWithoutChemicalCompoundInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUncheckedUpdateManyWithoutChemicalCompoundNestedInput = {
  connect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ActiveIngredientCreateOrConnectWithoutChemicalCompoundInput>>;
  create?: Maybe<Array<ActiveIngredientCreateWithoutChemicalCompoundInput>>;
  createMany?: Maybe<ActiveIngredientCreateManyChemicalCompoundInputEnvelope>;
  delete?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ActiveIngredientScalarWhereInput>>;
  disconnect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  set?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  update?: Maybe<Array<ActiveIngredientUpdateWithWhereUniqueWithoutChemicalCompoundInput>>;
  updateMany?: Maybe<Array<ActiveIngredientUpdateManyWithWhereWithoutChemicalCompoundInput>>;
  upsert?: Maybe<Array<ActiveIngredientUpsertWithWhereUniqueWithoutChemicalCompoundInput>>;
};

export type ActiveIngredientUncheckedUpdateManyWithoutProductInput = {
  chemicalCompoundId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUncheckedUpdateManyWithoutProductNestedInput = {
  connect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ActiveIngredientCreateOrConnectWithoutProductInput>>;
  create?: Maybe<Array<ActiveIngredientCreateWithoutProductInput>>;
  createMany?: Maybe<ActiveIngredientCreateManyProductInputEnvelope>;
  delete?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ActiveIngredientScalarWhereInput>>;
  disconnect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  set?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  update?: Maybe<Array<ActiveIngredientUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: Maybe<Array<ActiveIngredientUpdateManyWithWhereWithoutProductInput>>;
  upsert?: Maybe<Array<ActiveIngredientUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ActiveIngredientUncheckedUpdateWithoutChemicalCompoundInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUncheckedUpdateWithoutProductInput = {
  chemicalCompoundId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUpdateInput = {
  chemicalCompound?: Maybe<ChemicalCompoundUpdateOneRequiredWithoutActiveIngredientsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUpdateOneRequiredWithoutActiveIngredientsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUpdateManyWithWhereWithoutChemicalCompoundInput = {
  data: ActiveIngredientUpdateManyMutationInput;
  where: ActiveIngredientScalarWhereInput;
};

export type ActiveIngredientUpdateManyWithWhereWithoutProductInput = {
  data: ActiveIngredientUpdateManyMutationInput;
  where: ActiveIngredientScalarWhereInput;
};

export type ActiveIngredientUpdateManyWithoutChemicalCompoundNestedInput = {
  connect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ActiveIngredientCreateOrConnectWithoutChemicalCompoundInput>>;
  create?: Maybe<Array<ActiveIngredientCreateWithoutChemicalCompoundInput>>;
  createMany?: Maybe<ActiveIngredientCreateManyChemicalCompoundInputEnvelope>;
  delete?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ActiveIngredientScalarWhereInput>>;
  disconnect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  set?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  update?: Maybe<Array<ActiveIngredientUpdateWithWhereUniqueWithoutChemicalCompoundInput>>;
  updateMany?: Maybe<Array<ActiveIngredientUpdateManyWithWhereWithoutChemicalCompoundInput>>;
  upsert?: Maybe<Array<ActiveIngredientUpsertWithWhereUniqueWithoutChemicalCompoundInput>>;
};

export type ActiveIngredientUpdateManyWithoutProductNestedInput = {
  connect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ActiveIngredientCreateOrConnectWithoutProductInput>>;
  create?: Maybe<Array<ActiveIngredientCreateWithoutProductInput>>;
  createMany?: Maybe<ActiveIngredientCreateManyProductInputEnvelope>;
  delete?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ActiveIngredientScalarWhereInput>>;
  disconnect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  set?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  update?: Maybe<Array<ActiveIngredientUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: Maybe<Array<ActiveIngredientUpdateManyWithWhereWithoutProductInput>>;
  upsert?: Maybe<Array<ActiveIngredientUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ActiveIngredientUpdateWithWhereUniqueWithoutChemicalCompoundInput = {
  data: ActiveIngredientUpdateWithoutChemicalCompoundInput;
  where: ActiveIngredientWhereUniqueInput;
};

export type ActiveIngredientUpdateWithWhereUniqueWithoutProductInput = {
  data: ActiveIngredientUpdateWithoutProductInput;
  where: ActiveIngredientWhereUniqueInput;
};

export type ActiveIngredientUpdateWithoutChemicalCompoundInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUpdateOneRequiredWithoutActiveIngredientsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUpdateWithoutProductInput = {
  chemicalCompound?: Maybe<ChemicalCompoundUpdateOneRequiredWithoutActiveIngredientsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveIngredientUpsertWithWhereUniqueWithoutChemicalCompoundInput = {
  create: ActiveIngredientCreateWithoutChemicalCompoundInput;
  update: ActiveIngredientUpdateWithoutChemicalCompoundInput;
  where: ActiveIngredientWhereUniqueInput;
};

export type ActiveIngredientUpsertWithWhereUniqueWithoutProductInput = {
  create: ActiveIngredientCreateWithoutProductInput;
  update: ActiveIngredientUpdateWithoutProductInput;
  where: ActiveIngredientWhereUniqueInput;
};

export type ActiveIngredientWhereInput = {
  AND?: Maybe<Array<ActiveIngredientWhereInput>>;
  NOT?: Maybe<Array<ActiveIngredientWhereInput>>;
  OR?: Maybe<Array<ActiveIngredientWhereInput>>;
  chemicalCompound?: Maybe<ChemicalCompoundScalarRelationFilter>;
  chemicalCompoundId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  massPerDose?: Maybe<FloatNullableFilter>;
  massPerDoseUnit?: Maybe<StringNullableFilter>;
  product?: Maybe<ProductScalarRelationFilter>;
  productId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ActiveIngredientWhereUniqueInput = {
  AND?: Maybe<Array<ActiveIngredientWhereInput>>;
  NOT?: Maybe<Array<ActiveIngredientWhereInput>>;
  OR?: Maybe<Array<ActiveIngredientWhereInput>>;
  chemicalCompound?: Maybe<ChemicalCompoundScalarRelationFilter>;
  chemicalCompoundId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  massPerDose?: Maybe<FloatNullableFilter>;
  massPerDoseUnit?: Maybe<StringNullableFilter>;
  product?: Maybe<ProductScalarRelationFilter>;
  productId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AggregateActiveIngredient = {
  __typename?: 'AggregateActiveIngredient';
  _avg?: Maybe<ActiveIngredientAvgAggregateOutputType>;
  _count?: Maybe<ActiveIngredientCountAggregateOutputType>;
  _max?: Maybe<ActiveIngredientMaxAggregateOutputType>;
  _min?: Maybe<ActiveIngredientMinAggregateOutputType>;
  _sum?: Maybe<ActiveIngredientSumAggregateOutputType>;
};

export type AggregateAiRecapPimsWritebackLogEntry = {
  __typename?: 'AggregateAiRecapPimsWritebackLogEntry';
  _count?: Maybe<AiRecapPimsWritebackLogEntryCountAggregateOutputType>;
  _max?: Maybe<AiRecapPimsWritebackLogEntryMaxAggregateOutputType>;
  _min?: Maybe<AiRecapPimsWritebackLogEntryMinAggregateOutputType>;
};

export type AggregateApiKey = {
  __typename?: 'AggregateApiKey';
  _count?: Maybe<ApiKeyCountAggregateOutputType>;
  _max?: Maybe<ApiKeyMaxAggregateOutputType>;
  _min?: Maybe<ApiKeyMinAggregateOutputType>;
};

export type AggregateAppointment = {
  __typename?: 'AggregateAppointment';
  _avg?: Maybe<AppointmentAvgAggregateOutputType>;
  _count?: Maybe<AppointmentCountAggregateOutputType>;
  _max?: Maybe<AppointmentMaxAggregateOutputType>;
  _min?: Maybe<AppointmentMinAggregateOutputType>;
  _sum?: Maybe<AppointmentSumAggregateOutputType>;
};

export type AggregateAppointmentAvailability = {
  __typename?: 'AggregateAppointmentAvailability';
  _count?: Maybe<AppointmentAvailabilityCountAggregateOutputType>;
  _max?: Maybe<AppointmentAvailabilityMaxAggregateOutputType>;
  _min?: Maybe<AppointmentAvailabilityMinAggregateOutputType>;
};

export type AggregateAppointmentNoteTemplate = {
  __typename?: 'AggregateAppointmentNoteTemplate';
  _count?: Maybe<AppointmentNoteTemplateCountAggregateOutputType>;
  _max?: Maybe<AppointmentNoteTemplateMaxAggregateOutputType>;
  _min?: Maybe<AppointmentNoteTemplateMinAggregateOutputType>;
};

export type AggregateAppointmentType = {
  __typename?: 'AggregateAppointmentType';
  _avg?: Maybe<AppointmentTypeAvgAggregateOutputType>;
  _count?: Maybe<AppointmentTypeCountAggregateOutputType>;
  _max?: Maybe<AppointmentTypeMaxAggregateOutputType>;
  _min?: Maybe<AppointmentTypeMinAggregateOutputType>;
  _sum?: Maybe<AppointmentTypeSumAggregateOutputType>;
};

export type AggregateAutomationRun = {
  __typename?: 'AggregateAutomationRun';
  _count?: Maybe<AutomationRunCountAggregateOutputType>;
  _max?: Maybe<AutomationRunMaxAggregateOutputType>;
  _min?: Maybe<AutomationRunMinAggregateOutputType>;
};

export type AggregateAutomationRunAction = {
  __typename?: 'AggregateAutomationRunAction';
  _avg?: Maybe<AutomationRunActionAvgAggregateOutputType>;
  _count?: Maybe<AutomationRunActionCountAggregateOutputType>;
  _max?: Maybe<AutomationRunActionMaxAggregateOutputType>;
  _min?: Maybe<AutomationRunActionMinAggregateOutputType>;
  _sum?: Maybe<AutomationRunActionSumAggregateOutputType>;
};

export type AggregateAxionClinicConfiguration = {
  __typename?: 'AggregateAxionClinicConfiguration';
  _count?: Maybe<AxionClinicConfigurationCountAggregateOutputType>;
  _max?: Maybe<AxionClinicConfigurationMaxAggregateOutputType>;
  _min?: Maybe<AxionClinicConfigurationMinAggregateOutputType>;
};

export type AggregateAxionClinicUserConfiguration = {
  __typename?: 'AggregateAxionClinicUserConfiguration';
  _count?: Maybe<AxionClinicUserConfigurationCountAggregateOutputType>;
  _max?: Maybe<AxionClinicUserConfigurationMaxAggregateOutputType>;
  _min?: Maybe<AxionClinicUserConfigurationMinAggregateOutputType>;
};

export type AggregateBedrockInference = {
  __typename?: 'AggregateBedrockInference';
  _count?: Maybe<BedrockInferenceCountAggregateOutputType>;
  _max?: Maybe<BedrockInferenceMaxAggregateOutputType>;
  _min?: Maybe<BedrockInferenceMinAggregateOutputType>;
};

export type AggregateBitwerxHealthcheck = {
  __typename?: 'AggregateBitwerxHealthcheck';
  _count?: Maybe<BitwerxHealthcheckCountAggregateOutputType>;
  _max?: Maybe<BitwerxHealthcheckMaxAggregateOutputType>;
  _min?: Maybe<BitwerxHealthcheckMinAggregateOutputType>;
};

export type AggregateBitwerxIntegration = {
  __typename?: 'AggregateBitwerxIntegration';
  _count?: Maybe<BitwerxIntegrationCountAggregateOutputType>;
  _max?: Maybe<BitwerxIntegrationMaxAggregateOutputType>;
  _min?: Maybe<BitwerxIntegrationMinAggregateOutputType>;
};

export type AggregateBitwerxPaymentHealthcheckResult = {
  __typename?: 'AggregateBitwerxPaymentHealthcheckResult';
  _avg?: Maybe<BitwerxPaymentHealthcheckResultAvgAggregateOutputType>;
  _count?: Maybe<BitwerxPaymentHealthcheckResultCountAggregateOutputType>;
  _max?: Maybe<BitwerxPaymentHealthcheckResultMaxAggregateOutputType>;
  _min?: Maybe<BitwerxPaymentHealthcheckResultMinAggregateOutputType>;
  _sum?: Maybe<BitwerxPaymentHealthcheckResultSumAggregateOutputType>;
};

export type AggregateBitwerxPaymentHealthcheckRun = {
  __typename?: 'AggregateBitwerxPaymentHealthcheckRun';
  _avg?: Maybe<BitwerxPaymentHealthcheckRunAvgAggregateOutputType>;
  _count?: Maybe<BitwerxPaymentHealthcheckRunCountAggregateOutputType>;
  _max?: Maybe<BitwerxPaymentHealthcheckRunMaxAggregateOutputType>;
  _min?: Maybe<BitwerxPaymentHealthcheckRunMinAggregateOutputType>;
  _sum?: Maybe<BitwerxPaymentHealthcheckRunSumAggregateOutputType>;
};

export type AggregateBitwerxPaymentWritebackConfiguration = {
  __typename?: 'AggregateBitwerxPaymentWritebackConfiguration';
  _count?: Maybe<BitwerxPaymentWritebackConfigurationCountAggregateOutputType>;
  _max?: Maybe<BitwerxPaymentWritebackConfigurationMaxAggregateOutputType>;
  _min?: Maybe<BitwerxPaymentWritebackConfigurationMinAggregateOutputType>;
};

export type AggregateBoardFilterColumn = {
  __typename?: 'AggregateBoardFilterColumn';
  _count?: Maybe<BoardFilterColumnCountAggregateOutputType>;
  _max?: Maybe<BoardFilterColumnMaxAggregateOutputType>;
  _min?: Maybe<BoardFilterColumnMinAggregateOutputType>;
};

export type AggregateBoardFilterSpecificDateRange = {
  __typename?: 'AggregateBoardFilterSpecificDateRange';
  _count?: Maybe<BoardFilterSpecificDateRangeCountAggregateOutputType>;
  _max?: Maybe<BoardFilterSpecificDateRangeMaxAggregateOutputType>;
  _min?: Maybe<BoardFilterSpecificDateRangeMinAggregateOutputType>;
};

export type AggregateBoehringerIngelheimCustomerAlignment = {
  __typename?: 'AggregateBoehringerIngelheimCustomerAlignment';
  _avg?: Maybe<BoehringerIngelheimCustomerAlignmentAvgAggregateOutputType>;
  _count?: Maybe<BoehringerIngelheimCustomerAlignmentCountAggregateOutputType>;
  _max?: Maybe<BoehringerIngelheimCustomerAlignmentMaxAggregateOutputType>;
  _min?: Maybe<BoehringerIngelheimCustomerAlignmentMinAggregateOutputType>;
  _sum?: Maybe<BoehringerIngelheimCustomerAlignmentSumAggregateOutputType>;
};

export type AggregateBoehringerIngelheimTerritory = {
  __typename?: 'AggregateBoehringerIngelheimTerritory';
  _count?: Maybe<BoehringerIngelheimTerritoryCountAggregateOutputType>;
  _max?: Maybe<BoehringerIngelheimTerritoryMaxAggregateOutputType>;
  _min?: Maybe<BoehringerIngelheimTerritoryMinAggregateOutputType>;
};

export type AggregateBreed = {
  __typename?: 'AggregateBreed';
  _count?: Maybe<BreedCountAggregateOutputType>;
  _max?: Maybe<BreedMaxAggregateOutputType>;
  _min?: Maybe<BreedMinAggregateOutputType>;
};

export type AggregateCallHistory = {
  __typename?: 'AggregateCallHistory';
  _avg?: Maybe<CallHistoryAvgAggregateOutputType>;
  _count?: Maybe<CallHistoryCountAggregateOutputType>;
  _max?: Maybe<CallHistoryMaxAggregateOutputType>;
  _min?: Maybe<CallHistoryMinAggregateOutputType>;
  _sum?: Maybe<CallHistorySumAggregateOutputType>;
};

export type AggregateCallParticipant = {
  __typename?: 'AggregateCallParticipant';
  _count?: Maybe<CallParticipantCountAggregateOutputType>;
  _max?: Maybe<CallParticipantMaxAggregateOutputType>;
  _min?: Maybe<CallParticipantMinAggregateOutputType>;
};

export type AggregateCallRecording = {
  __typename?: 'AggregateCallRecording';
  _avg?: Maybe<CallRecordingAvgAggregateOutputType>;
  _count?: Maybe<CallRecordingCountAggregateOutputType>;
  _max?: Maybe<CallRecordingMaxAggregateOutputType>;
  _min?: Maybe<CallRecordingMinAggregateOutputType>;
  _sum?: Maybe<CallRecordingSumAggregateOutputType>;
};

export type AggregateCampaignRegistryCampaign = {
  __typename?: 'AggregateCampaignRegistryCampaign';
  _count?: Maybe<CampaignRegistryCampaignCountAggregateOutputType>;
  _max?: Maybe<CampaignRegistryCampaignMaxAggregateOutputType>;
  _min?: Maybe<CampaignRegistryCampaignMinAggregateOutputType>;
};

export type AggregateCanonicalBreed = {
  __typename?: 'AggregateCanonicalBreed';
  _avg?: Maybe<CanonicalBreedAvgAggregateOutputType>;
  _count?: Maybe<CanonicalBreedCountAggregateOutputType>;
  _max?: Maybe<CanonicalBreedMaxAggregateOutputType>;
  _min?: Maybe<CanonicalBreedMinAggregateOutputType>;
  _sum?: Maybe<CanonicalBreedSumAggregateOutputType>;
};

export type AggregateCanonicalCanineBreedProfile = {
  __typename?: 'AggregateCanonicalCanineBreedProfile';
  _avg?: Maybe<CanonicalCanineBreedProfileAvgAggregateOutputType>;
  _count?: Maybe<CanonicalCanineBreedProfileCountAggregateOutputType>;
  _max?: Maybe<CanonicalCanineBreedProfileMaxAggregateOutputType>;
  _min?: Maybe<CanonicalCanineBreedProfileMinAggregateOutputType>;
  _sum?: Maybe<CanonicalCanineBreedProfileSumAggregateOutputType>;
};

export type AggregateCanonicalService = {
  __typename?: 'AggregateCanonicalService';
  _count?: Maybe<CanonicalServiceCountAggregateOutputType>;
  _max?: Maybe<CanonicalServiceMaxAggregateOutputType>;
  _min?: Maybe<CanonicalServiceMinAggregateOutputType>;
};

export type AggregateCanonicalSpecies = {
  __typename?: 'AggregateCanonicalSpecies';
  _count?: Maybe<CanonicalSpeciesCountAggregateOutputType>;
  _max?: Maybe<CanonicalSpeciesMaxAggregateOutputType>;
  _min?: Maybe<CanonicalSpeciesMinAggregateOutputType>;
};

export type AggregateCareAccountCreditIntent = {
  __typename?: 'AggregateCareAccountCreditIntent';
  _avg?: Maybe<CareAccountCreditIntentAvgAggregateOutputType>;
  _count?: Maybe<CareAccountCreditIntentCountAggregateOutputType>;
  _max?: Maybe<CareAccountCreditIntentMaxAggregateOutputType>;
  _min?: Maybe<CareAccountCreditIntentMinAggregateOutputType>;
  _sum?: Maybe<CareAccountCreditIntentSumAggregateOutputType>;
};

export type AggregateCareAccountCreditPimsWritebackLogEntry = {
  __typename?: 'AggregateCareAccountCreditPimsWritebackLogEntry';
  _count?: Maybe<CareAccountCreditPimsWritebackLogEntryCountAggregateOutputType>;
  _max?: Maybe<CareAccountCreditPimsWritebackLogEntryMaxAggregateOutputType>;
  _min?: Maybe<CareAccountCreditPimsWritebackLogEntryMinAggregateOutputType>;
};

export type AggregateCareAddonEnrollment = {
  __typename?: 'AggregateCareAddonEnrollment';
  _count?: Maybe<CareAddonEnrollmentCountAggregateOutputType>;
  _max?: Maybe<CareAddonEnrollmentMaxAggregateOutputType>;
  _min?: Maybe<CareAddonEnrollmentMinAggregateOutputType>;
};

export type AggregateCareAddonPackage = {
  __typename?: 'AggregateCareAddonPackage';
  _avg?: Maybe<CareAddonPackageAvgAggregateOutputType>;
  _count?: Maybe<CareAddonPackageCountAggregateOutputType>;
  _max?: Maybe<CareAddonPackageMaxAggregateOutputType>;
  _min?: Maybe<CareAddonPackageMinAggregateOutputType>;
  _sum?: Maybe<CareAddonPackageSumAggregateOutputType>;
};

export type AggregateCareAddonPackageBenefit = {
  __typename?: 'AggregateCareAddonPackageBenefit';
  _avg?: Maybe<CareAddonPackageBenefitAvgAggregateOutputType>;
  _count?: Maybe<CareAddonPackageBenefitCountAggregateOutputType>;
  _max?: Maybe<CareAddonPackageBenefitMaxAggregateOutputType>;
  _min?: Maybe<CareAddonPackageBenefitMinAggregateOutputType>;
  _sum?: Maybe<CareAddonPackageBenefitSumAggregateOutputType>;
};

export type AggregateCareAuthorizationRequest = {
  __typename?: 'AggregateCareAuthorizationRequest';
  _count?: Maybe<CareAuthorizationRequestCountAggregateOutputType>;
  _max?: Maybe<CareAuthorizationRequestMaxAggregateOutputType>;
  _min?: Maybe<CareAuthorizationRequestMinAggregateOutputType>;
};

export type AggregateCareBenefit = {
  __typename?: 'AggregateCareBenefit';
  _avg?: Maybe<CareBenefitAvgAggregateOutputType>;
  _count?: Maybe<CareBenefitCountAggregateOutputType>;
  _max?: Maybe<CareBenefitMaxAggregateOutputType>;
  _min?: Maybe<CareBenefitMinAggregateOutputType>;
  _sum?: Maybe<CareBenefitSumAggregateOutputType>;
};

export type AggregateCareBenefitUsage = {
  __typename?: 'AggregateCareBenefitUsage';
  _avg?: Maybe<CareBenefitUsageAvgAggregateOutputType>;
  _count?: Maybe<CareBenefitUsageCountAggregateOutputType>;
  _max?: Maybe<CareBenefitUsageMaxAggregateOutputType>;
  _min?: Maybe<CareBenefitUsageMinAggregateOutputType>;
  _sum?: Maybe<CareBenefitUsageSumAggregateOutputType>;
};

export type AggregateCareBenefitUsageFollowup = {
  __typename?: 'AggregateCareBenefitUsageFollowup';
  _avg?: Maybe<CareBenefitUsageFollowupAvgAggregateOutputType>;
  _count?: Maybe<CareBenefitUsageFollowupCountAggregateOutputType>;
  _max?: Maybe<CareBenefitUsageFollowupMaxAggregateOutputType>;
  _min?: Maybe<CareBenefitUsageFollowupMinAggregateOutputType>;
  _sum?: Maybe<CareBenefitUsageFollowupSumAggregateOutputType>;
};

export type AggregateCareBenefitUsageFollowupStep = {
  __typename?: 'AggregateCareBenefitUsageFollowupStep';
  _avg?: Maybe<CareBenefitUsageFollowupStepAvgAggregateOutputType>;
  _count?: Maybe<CareBenefitUsageFollowupStepCountAggregateOutputType>;
  _max?: Maybe<CareBenefitUsageFollowupStepMaxAggregateOutputType>;
  _min?: Maybe<CareBenefitUsageFollowupStepMinAggregateOutputType>;
  _sum?: Maybe<CareBenefitUsageFollowupStepSumAggregateOutputType>;
};

export type AggregateCareBenefitUsageToInvoiceLineItem = {
  __typename?: 'AggregateCareBenefitUsageToInvoiceLineItem';
  _avg?: Maybe<CareBenefitUsageToInvoiceLineItemAvgAggregateOutputType>;
  _count?: Maybe<CareBenefitUsageToInvoiceLineItemCountAggregateOutputType>;
  _max?: Maybe<CareBenefitUsageToInvoiceLineItemMaxAggregateOutputType>;
  _min?: Maybe<CareBenefitUsageToInvoiceLineItemMinAggregateOutputType>;
  _sum?: Maybe<CareBenefitUsageToInvoiceLineItemSumAggregateOutputType>;
};

export type AggregateCareCreditPreapprovalCheck = {
  __typename?: 'AggregateCareCreditPreapprovalCheck';
  _avg?: Maybe<CareCreditPreapprovalCheckAvgAggregateOutputType>;
  _count?: Maybe<CareCreditPreapprovalCheckCountAggregateOutputType>;
  _max?: Maybe<CareCreditPreapprovalCheckMaxAggregateOutputType>;
  _min?: Maybe<CareCreditPreapprovalCheckMinAggregateOutputType>;
  _sum?: Maybe<CareCreditPreapprovalCheckSumAggregateOutputType>;
};

export type AggregateCareEnrollmentPayment = {
  __typename?: 'AggregateCareEnrollmentPayment';
  _avg?: Maybe<CareEnrollmentPaymentAvgAggregateOutputType>;
  _count?: Maybe<CareEnrollmentPaymentCountAggregateOutputType>;
  _max?: Maybe<CareEnrollmentPaymentMaxAggregateOutputType>;
  _min?: Maybe<CareEnrollmentPaymentMinAggregateOutputType>;
  _sum?: Maybe<CareEnrollmentPaymentSumAggregateOutputType>;
};

export type AggregateCareEnrollmentToStripeInvoiceItem = {
  __typename?: 'AggregateCareEnrollmentToStripeInvoiceItem';
  _count?: Maybe<CareEnrollmentToStripeInvoiceItemCountAggregateOutputType>;
  _max?: Maybe<CareEnrollmentToStripeInvoiceItemMaxAggregateOutputType>;
  _min?: Maybe<CareEnrollmentToStripeInvoiceItemMinAggregateOutputType>;
};

export type AggregateCareLapsedPayment = {
  __typename?: 'AggregateCareLapsedPayment';
  _count?: Maybe<CareLapsedPaymentCountAggregateOutputType>;
  _max?: Maybe<CareLapsedPaymentMaxAggregateOutputType>;
  _min?: Maybe<CareLapsedPaymentMinAggregateOutputType>;
};

export type AggregateCarePlan = {
  __typename?: 'AggregateCarePlan';
  _avg?: Maybe<CarePlanAvgAggregateOutputType>;
  _count?: Maybe<CarePlanCountAggregateOutputType>;
  _max?: Maybe<CarePlanMaxAggregateOutputType>;
  _min?: Maybe<CarePlanMinAggregateOutputType>;
  _sum?: Maybe<CarePlanSumAggregateOutputType>;
};

export type AggregateCarePlanBenefit = {
  __typename?: 'AggregateCarePlanBenefit';
  _avg?: Maybe<CarePlanBenefitAvgAggregateOutputType>;
  _count?: Maybe<CarePlanBenefitCountAggregateOutputType>;
  _max?: Maybe<CarePlanBenefitMaxAggregateOutputType>;
  _min?: Maybe<CarePlanBenefitMinAggregateOutputType>;
  _sum?: Maybe<CarePlanBenefitSumAggregateOutputType>;
};

export type AggregateCarePlanBenefitEnrollmentCarryover = {
  __typename?: 'AggregateCarePlanBenefitEnrollmentCarryover';
  _avg?: Maybe<CarePlanBenefitEnrollmentCarryoverAvgAggregateOutputType>;
  _count?: Maybe<CarePlanBenefitEnrollmentCarryoverCountAggregateOutputType>;
  _max?: Maybe<CarePlanBenefitEnrollmentCarryoverMaxAggregateOutputType>;
  _min?: Maybe<CarePlanBenefitEnrollmentCarryoverMinAggregateOutputType>;
  _sum?: Maybe<CarePlanBenefitEnrollmentCarryoverSumAggregateOutputType>;
};

export type AggregateCarePlanEnrollment = {
  __typename?: 'AggregateCarePlanEnrollment';
  _count?: Maybe<CarePlanEnrollmentCountAggregateOutputType>;
  _max?: Maybe<CarePlanEnrollmentMaxAggregateOutputType>;
  _min?: Maybe<CarePlanEnrollmentMinAggregateOutputType>;
};

export type AggregateCarePlanPricing = {
  __typename?: 'AggregateCarePlanPricing';
  _avg?: Maybe<CarePlanPricingAvgAggregateOutputType>;
  _count?: Maybe<CarePlanPricingCountAggregateOutputType>;
  _max?: Maybe<CarePlanPricingMaxAggregateOutputType>;
  _min?: Maybe<CarePlanPricingMinAggregateOutputType>;
  _sum?: Maybe<CarePlanPricingSumAggregateOutputType>;
};

export type AggregateCarePlanProviderGroup = {
  __typename?: 'AggregateCarePlanProviderGroup';
  _count?: Maybe<CarePlanProviderGroupCountAggregateOutputType>;
  _max?: Maybe<CarePlanProviderGroupMaxAggregateOutputType>;
  _min?: Maybe<CarePlanProviderGroupMinAggregateOutputType>;
};

export type AggregateCareStripeSubscription = {
  __typename?: 'AggregateCareStripeSubscription';
  _avg?: Maybe<CareStripeSubscriptionAvgAggregateOutputType>;
  _count?: Maybe<CareStripeSubscriptionCountAggregateOutputType>;
  _max?: Maybe<CareStripeSubscriptionMaxAggregateOutputType>;
  _min?: Maybe<CareStripeSubscriptionMinAggregateOutputType>;
  _sum?: Maybe<CareStripeSubscriptionSumAggregateOutputType>;
};

export type AggregateCareSubscriptionTrueUp = {
  __typename?: 'AggregateCareSubscriptionTrueUp';
  _avg?: Maybe<CareSubscriptionTrueUpAvgAggregateOutputType>;
  _count?: Maybe<CareSubscriptionTrueUpCountAggregateOutputType>;
  _max?: Maybe<CareSubscriptionTrueUpMaxAggregateOutputType>;
  _min?: Maybe<CareSubscriptionTrueUpMinAggregateOutputType>;
  _sum?: Maybe<CareSubscriptionTrueUpSumAggregateOutputType>;
};

export type AggregateCareSubscriptionTrueUpLogEntry = {
  __typename?: 'AggregateCareSubscriptionTrueUpLogEntry';
  _avg?: Maybe<CareSubscriptionTrueUpLogEntryAvgAggregateOutputType>;
  _count?: Maybe<CareSubscriptionTrueUpLogEntryCountAggregateOutputType>;
  _max?: Maybe<CareSubscriptionTrueUpLogEntryMaxAggregateOutputType>;
  _min?: Maybe<CareSubscriptionTrueUpLogEntryMinAggregateOutputType>;
  _sum?: Maybe<CareSubscriptionTrueUpLogEntrySumAggregateOutputType>;
};

export type AggregateChannel = {
  __typename?: 'AggregateChannel';
  _count?: Maybe<ChannelCountAggregateOutputType>;
  _max?: Maybe<ChannelMaxAggregateOutputType>;
  _min?: Maybe<ChannelMinAggregateOutputType>;
};

export type AggregateChannelAutomationStatus = {
  __typename?: 'AggregateChannelAutomationStatus';
  _count?: Maybe<ChannelAutomationStatusCountAggregateOutputType>;
  _max?: Maybe<ChannelAutomationStatusMaxAggregateOutputType>;
  _min?: Maybe<ChannelAutomationStatusMinAggregateOutputType>;
};

export type AggregateChannelCreationSource = {
  __typename?: 'AggregateChannelCreationSource';
  _count?: Maybe<ChannelCreationSourceCountAggregateOutputType>;
  _max?: Maybe<ChannelCreationSourceMaxAggregateOutputType>;
  _min?: Maybe<ChannelCreationSourceMinAggregateOutputType>;
};

export type AggregateChannelFilterSelection = {
  __typename?: 'AggregateChannelFilterSelection';
  _count?: Maybe<ChannelFilterSelectionCountAggregateOutputType>;
  _max?: Maybe<ChannelFilterSelectionMaxAggregateOutputType>;
  _min?: Maybe<ChannelFilterSelectionMinAggregateOutputType>;
};

export type AggregateChannelMember = {
  __typename?: 'AggregateChannelMember';
  _avg?: Maybe<ChannelMemberAvgAggregateOutputType>;
  _count?: Maybe<ChannelMemberCountAggregateOutputType>;
  _max?: Maybe<ChannelMemberMaxAggregateOutputType>;
  _min?: Maybe<ChannelMemberMinAggregateOutputType>;
  _sum?: Maybe<ChannelMemberSumAggregateOutputType>;
};

export type AggregateChannelMessage = {
  __typename?: 'AggregateChannelMessage';
  _avg?: Maybe<ChannelMessageAvgAggregateOutputType>;
  _count?: Maybe<ChannelMessageCountAggregateOutputType>;
  _max?: Maybe<ChannelMessageMaxAggregateOutputType>;
  _min?: Maybe<ChannelMessageMinAggregateOutputType>;
  _sum?: Maybe<ChannelMessageSumAggregateOutputType>;
};

export type AggregateChannelMessageAttachment = {
  __typename?: 'AggregateChannelMessageAttachment';
  _count?: Maybe<ChannelMessageAttachmentCountAggregateOutputType>;
  _max?: Maybe<ChannelMessageAttachmentMaxAggregateOutputType>;
  _min?: Maybe<ChannelMessageAttachmentMinAggregateOutputType>;
};

export type AggregateChannelMessageAutoResponse = {
  __typename?: 'AggregateChannelMessageAutoResponse';
  _count?: Maybe<ChannelMessageAutoResponseCountAggregateOutputType>;
  _max?: Maybe<ChannelMessageAutoResponseMaxAggregateOutputType>;
  _min?: Maybe<ChannelMessageAutoResponseMinAggregateOutputType>;
};

export type AggregateChannelMessageReaction = {
  __typename?: 'AggregateChannelMessageReaction';
  _count?: Maybe<ChannelMessageReactionCountAggregateOutputType>;
  _max?: Maybe<ChannelMessageReactionMaxAggregateOutputType>;
  _min?: Maybe<ChannelMessageReactionMinAggregateOutputType>;
};

export type AggregateChannelPin = {
  __typename?: 'AggregateChannelPin';
  _count?: Maybe<ChannelPinCountAggregateOutputType>;
  _max?: Maybe<ChannelPinMaxAggregateOutputType>;
  _min?: Maybe<ChannelPinMinAggregateOutputType>;
};

export type AggregateChannelSelection = {
  __typename?: 'AggregateChannelSelection';
  _count?: Maybe<ChannelSelectionCountAggregateOutputType>;
  _max?: Maybe<ChannelSelectionMaxAggregateOutputType>;
  _min?: Maybe<ChannelSelectionMinAggregateOutputType>;
};

export type AggregateChannelStatus = {
  __typename?: 'AggregateChannelStatus';
  _avg?: Maybe<ChannelStatusAvgAggregateOutputType>;
  _count?: Maybe<ChannelStatusCountAggregateOutputType>;
  _max?: Maybe<ChannelStatusMaxAggregateOutputType>;
  _min?: Maybe<ChannelStatusMinAggregateOutputType>;
  _sum?: Maybe<ChannelStatusSumAggregateOutputType>;
};

export type AggregateChannelStatusChannelAssignee = {
  __typename?: 'AggregateChannelStatusChannelAssignee';
  _count?: Maybe<ChannelStatusChannelAssigneeCountAggregateOutputType>;
  _max?: Maybe<ChannelStatusChannelAssigneeMaxAggregateOutputType>;
  _min?: Maybe<ChannelStatusChannelAssigneeMinAggregateOutputType>;
};

export type AggregateChemicalCompound = {
  __typename?: 'AggregateChemicalCompound';
  _count?: Maybe<ChemicalCompoundCountAggregateOutputType>;
  _max?: Maybe<ChemicalCompoundMaxAggregateOutputType>;
  _min?: Maybe<ChemicalCompoundMinAggregateOutputType>;
};

export type AggregateClientConnectIntegration = {
  __typename?: 'AggregateClientConnectIntegration';
  _count?: Maybe<ClientConnectIntegrationCountAggregateOutputType>;
  _max?: Maybe<ClientConnectIntegrationMaxAggregateOutputType>;
  _min?: Maybe<ClientConnectIntegrationMinAggregateOutputType>;
};

export type AggregateClinic = {
  __typename?: 'AggregateClinic';
  _avg?: Maybe<ClinicAvgAggregateOutputType>;
  _count?: Maybe<ClinicCountAggregateOutputType>;
  _max?: Maybe<ClinicMaxAggregateOutputType>;
  _min?: Maybe<ClinicMinAggregateOutputType>;
  _sum?: Maybe<ClinicSumAggregateOutputType>;
};

export type AggregateClinicBlockedPhoneNumber = {
  __typename?: 'AggregateClinicBlockedPhoneNumber';
  _count?: Maybe<ClinicBlockedPhoneNumberCountAggregateOutputType>;
  _max?: Maybe<ClinicBlockedPhoneNumberMaxAggregateOutputType>;
  _min?: Maybe<ClinicBlockedPhoneNumberMinAggregateOutputType>;
};

export type AggregateClinicCustomPayoutsSetup = {
  __typename?: 'AggregateClinicCustomPayoutsSetup';
  _count?: Maybe<ClinicCustomPayoutsSetupCountAggregateOutputType>;
  _max?: Maybe<ClinicCustomPayoutsSetupMaxAggregateOutputType>;
  _min?: Maybe<ClinicCustomPayoutsSetupMinAggregateOutputType>;
};

export type AggregateClinicDirectBookingSetting = {
  __typename?: 'AggregateClinicDirectBookingSetting';
  _avg?: Maybe<ClinicDirectBookingSettingAvgAggregateOutputType>;
  _count?: Maybe<ClinicDirectBookingSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicDirectBookingSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicDirectBookingSettingMinAggregateOutputType>;
  _sum?: Maybe<ClinicDirectBookingSettingSumAggregateOutputType>;
};

export type AggregateClinicEmailCampaignSetting = {
  __typename?: 'AggregateClinicEmailCampaignSetting';
  _count?: Maybe<ClinicEmailCampaignSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicEmailCampaignSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicEmailCampaignSettingMinAggregateOutputType>;
};

export type AggregateClinicEmployee = {
  __typename?: 'AggregateClinicEmployee';
  _count?: Maybe<ClinicEmployeeCountAggregateOutputType>;
  _max?: Maybe<ClinicEmployeeMaxAggregateOutputType>;
  _min?: Maybe<ClinicEmployeeMinAggregateOutputType>;
};

export type AggregateClinicEmployeeAppointmentTypeSetting = {
  __typename?: 'AggregateClinicEmployeeAppointmentTypeSetting';
  _count?: Maybe<ClinicEmployeeAppointmentTypeSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicEmployeeAppointmentTypeSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicEmployeeAppointmentTypeSettingMinAggregateOutputType>;
};

export type AggregateClinicEmployeeToWorkflowEventSetting = {
  __typename?: 'AggregateClinicEmployeeToWorkflowEventSetting';
  _count?: Maybe<ClinicEmployeeToWorkflowEventSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicEmployeeToWorkflowEventSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicEmployeeToWorkflowEventSettingMinAggregateOutputType>;
};

export type AggregateClinicEntityPhoneNumber = {
  __typename?: 'AggregateClinicEntityPhoneNumber';
  _count?: Maybe<ClinicEntityPhoneNumberCountAggregateOutputType>;
  _max?: Maybe<ClinicEntityPhoneNumberMaxAggregateOutputType>;
  _min?: Maybe<ClinicEntityPhoneNumberMinAggregateOutputType>;
};

export type AggregateClinicModule = {
  __typename?: 'AggregateClinicModule';
  _count?: Maybe<ClinicModuleCountAggregateOutputType>;
  _max?: Maybe<ClinicModuleMaxAggregateOutputType>;
  _min?: Maybe<ClinicModuleMinAggregateOutputType>;
};

export type AggregateClinicOfficeHour = {
  __typename?: 'AggregateClinicOfficeHour';
  _avg?: Maybe<ClinicOfficeHourAvgAggregateOutputType>;
  _count?: Maybe<ClinicOfficeHourCountAggregateOutputType>;
  _max?: Maybe<ClinicOfficeHourMaxAggregateOutputType>;
  _min?: Maybe<ClinicOfficeHourMinAggregateOutputType>;
  _sum?: Maybe<ClinicOfficeHourSumAggregateOutputType>;
};

export type AggregateClinicOnboarding = {
  __typename?: 'AggregateClinicOnboarding';
  _count?: Maybe<ClinicOnboardingCountAggregateOutputType>;
  _max?: Maybe<ClinicOnboardingMaxAggregateOutputType>;
  _min?: Maybe<ClinicOnboardingMinAggregateOutputType>;
};

export type AggregateClinicPaymentFeeConfiguration = {
  __typename?: 'AggregateClinicPaymentFeeConfiguration';
  _avg?: Maybe<ClinicPaymentFeeConfigurationAvgAggregateOutputType>;
  _count?: Maybe<ClinicPaymentFeeConfigurationCountAggregateOutputType>;
  _max?: Maybe<ClinicPaymentFeeConfigurationMaxAggregateOutputType>;
  _min?: Maybe<ClinicPaymentFeeConfigurationMinAggregateOutputType>;
  _sum?: Maybe<ClinicPaymentFeeConfigurationSumAggregateOutputType>;
};

export type AggregateClinicPet = {
  __typename?: 'AggregateClinicPet';
  _avg?: Maybe<ClinicPetAvgAggregateOutputType>;
  _count?: Maybe<ClinicPetCountAggregateOutputType>;
  _max?: Maybe<ClinicPetMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetMinAggregateOutputType>;
  _sum?: Maybe<ClinicPetSumAggregateOutputType>;
};

export type AggregateClinicPetAlert = {
  __typename?: 'AggregateClinicPetAlert';
  _count?: Maybe<ClinicPetAlertCountAggregateOutputType>;
  _max?: Maybe<ClinicPetAlertMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetAlertMinAggregateOutputType>;
};

export type AggregateClinicPetCustomFieldValue = {
  __typename?: 'AggregateClinicPetCustomFieldValue';
  _count?: Maybe<ClinicPetCustomFieldValueCountAggregateOutputType>;
  _max?: Maybe<ClinicPetCustomFieldValueMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetCustomFieldValueMinAggregateOutputType>;
};

export type AggregateClinicPetParent = {
  __typename?: 'AggregateClinicPetParent';
  _count?: Maybe<ClinicPetParentCountAggregateOutputType>;
  _max?: Maybe<ClinicPetParentMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetParentMinAggregateOutputType>;
};

export type AggregateClinicPetParentAddress = {
  __typename?: 'AggregateClinicPetParentAddress';
  _count?: Maybe<ClinicPetParentAddressCountAggregateOutputType>;
  _max?: Maybe<ClinicPetParentAddressMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetParentAddressMinAggregateOutputType>;
};

export type AggregateClinicPetParentCustomFieldValue = {
  __typename?: 'AggregateClinicPetParentCustomFieldValue';
  _count?: Maybe<ClinicPetParentCustomFieldValueCountAggregateOutputType>;
  _max?: Maybe<ClinicPetParentCustomFieldValueMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetParentCustomFieldValueMinAggregateOutputType>;
};

export type AggregateClinicPetParentDevice = {
  __typename?: 'AggregateClinicPetParentDevice';
  _count?: Maybe<ClinicPetParentDeviceCountAggregateOutputType>;
  _max?: Maybe<ClinicPetParentDeviceMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetParentDeviceMinAggregateOutputType>;
};

export type AggregateClinicPetParentPimsSyncStatus = {
  __typename?: 'AggregateClinicPetParentPimsSyncStatus';
  _avg?: Maybe<ClinicPetParentPimsSyncStatusAvgAggregateOutputType>;
  _count?: Maybe<ClinicPetParentPimsSyncStatusCountAggregateOutputType>;
  _max?: Maybe<ClinicPetParentPimsSyncStatusMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetParentPimsSyncStatusMinAggregateOutputType>;
  _sum?: Maybe<ClinicPetParentPimsSyncStatusSumAggregateOutputType>;
};

export type AggregateClinicPetPimsSyncStatus = {
  __typename?: 'AggregateClinicPetPimsSyncStatus';
  _avg?: Maybe<ClinicPetPimsSyncStatusAvgAggregateOutputType>;
  _count?: Maybe<ClinicPetPimsSyncStatusCountAggregateOutputType>;
  _max?: Maybe<ClinicPetPimsSyncStatusMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetPimsSyncStatusMinAggregateOutputType>;
  _sum?: Maybe<ClinicPetPimsSyncStatusSumAggregateOutputType>;
};

export type AggregateClinicPhoneNumber = {
  __typename?: 'AggregateClinicPhoneNumber';
  _count?: Maybe<ClinicPhoneNumberCountAggregateOutputType>;
  _max?: Maybe<ClinicPhoneNumberMaxAggregateOutputType>;
  _min?: Maybe<ClinicPhoneNumberMinAggregateOutputType>;
};

export type AggregateClinicPimsIntegration = {
  __typename?: 'AggregateClinicPimsIntegration';
  _count?: Maybe<ClinicPimsIntegrationCountAggregateOutputType>;
  _max?: Maybe<ClinicPimsIntegrationMaxAggregateOutputType>;
  _min?: Maybe<ClinicPimsIntegrationMinAggregateOutputType>;
};

export type AggregateClinicPimsIntegrationCapability = {
  __typename?: 'AggregateClinicPimsIntegrationCapability';
  _avg?: Maybe<ClinicPimsIntegrationCapabilityAvgAggregateOutputType>;
  _count?: Maybe<ClinicPimsIntegrationCapabilityCountAggregateOutputType>;
  _max?: Maybe<ClinicPimsIntegrationCapabilityMaxAggregateOutputType>;
  _min?: Maybe<ClinicPimsIntegrationCapabilityMinAggregateOutputType>;
  _sum?: Maybe<ClinicPimsIntegrationCapabilitySumAggregateOutputType>;
};

export type AggregateClinicPimsIntegrationCapabilityHistoryEntry = {
  __typename?: 'AggregateClinicPimsIntegrationCapabilityHistoryEntry';
  _avg?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryAvgAggregateOutputType>;
  _count?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCountAggregateOutputType>;
  _max?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryMaxAggregateOutputType>;
  _min?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryMinAggregateOutputType>;
  _sum?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntrySumAggregateOutputType>;
};

export type AggregateClinicPostcardSetting = {
  __typename?: 'AggregateClinicPostcardSetting';
  _count?: Maybe<ClinicPostcardSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicPostcardSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicPostcardSettingMinAggregateOutputType>;
};

export type AggregateClinicRoom = {
  __typename?: 'AggregateClinicRoom';
  _count?: Maybe<ClinicRoomCountAggregateOutputType>;
  _max?: Maybe<ClinicRoomMaxAggregateOutputType>;
  _min?: Maybe<ClinicRoomMinAggregateOutputType>;
};

export type AggregateClinicRoomToWorkflowEventSetting = {
  __typename?: 'AggregateClinicRoomToWorkflowEventSetting';
  _count?: Maybe<ClinicRoomToWorkflowEventSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicRoomToWorkflowEventSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicRoomToWorkflowEventSettingMinAggregateOutputType>;
};

export type AggregateClinicSetting = {
  __typename?: 'AggregateClinicSetting';
  _avg?: Maybe<ClinicSettingAvgAggregateOutputType>;
  _count?: Maybe<ClinicSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicSettingMinAggregateOutputType>;
  _sum?: Maybe<ClinicSettingSumAggregateOutputType>;
};

export type AggregateClinicUserFilter = {
  __typename?: 'AggregateClinicUserFilter';
  _count?: Maybe<ClinicUserFilterCountAggregateOutputType>;
  _max?: Maybe<ClinicUserFilterMaxAggregateOutputType>;
  _min?: Maybe<ClinicUserFilterMinAggregateOutputType>;
};

export type AggregateClinicWidgetRequest = {
  __typename?: 'AggregateClinicWidgetRequest';
  _count?: Maybe<ClinicWidgetRequestCountAggregateOutputType>;
  _max?: Maybe<ClinicWidgetRequestMaxAggregateOutputType>;
  _min?: Maybe<ClinicWidgetRequestMinAggregateOutputType>;
};

export type AggregateClinicWidgetRequestType = {
  __typename?: 'AggregateClinicWidgetRequestType';
  _avg?: Maybe<ClinicWidgetRequestTypeAvgAggregateOutputType>;
  _count?: Maybe<ClinicWidgetRequestTypeCountAggregateOutputType>;
  _max?: Maybe<ClinicWidgetRequestTypeMaxAggregateOutputType>;
  _min?: Maybe<ClinicWidgetRequestTypeMinAggregateOutputType>;
  _sum?: Maybe<ClinicWidgetRequestTypeSumAggregateOutputType>;
};

export type AggregateClinicWidgetSetting = {
  __typename?: 'AggregateClinicWidgetSetting';
  _count?: Maybe<ClinicWidgetSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicWidgetSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicWidgetSettingMinAggregateOutputType>;
};

export type AggregateClinicWorkflowType = {
  __typename?: 'AggregateClinicWorkflowType';
  _count?: Maybe<ClinicWorkflowTypeCountAggregateOutputType>;
  _max?: Maybe<ClinicWorkflowTypeMaxAggregateOutputType>;
  _min?: Maybe<ClinicWorkflowTypeMinAggregateOutputType>;
};

export type AggregateColor = {
  __typename?: 'AggregateColor';
  _count?: Maybe<ColorCountAggregateOutputType>;
  _max?: Maybe<ColorMaxAggregateOutputType>;
  _min?: Maybe<ColorMinAggregateOutputType>;
};

export type AggregateCondition = {
  __typename?: 'AggregateCondition';
  _count?: Maybe<ConditionCountAggregateOutputType>;
  _max?: Maybe<ConditionMaxAggregateOutputType>;
  _min?: Maybe<ConditionMinAggregateOutputType>;
};

export type AggregateConditionSet = {
  __typename?: 'AggregateConditionSet';
  _count?: Maybe<ConditionSetCountAggregateOutputType>;
  _max?: Maybe<ConditionSetMaxAggregateOutputType>;
  _min?: Maybe<ConditionSetMinAggregateOutputType>;
};

export type AggregateConditionalEntityEvaluation = {
  __typename?: 'AggregateConditionalEntityEvaluation';
  _count?: Maybe<ConditionalEntityEvaluationCountAggregateOutputType>;
  _max?: Maybe<ConditionalEntityEvaluationMaxAggregateOutputType>;
  _min?: Maybe<ConditionalEntityEvaluationMinAggregateOutputType>;
};

export type AggregateConsultation = {
  __typename?: 'AggregateConsultation';
  _avg?: Maybe<ConsultationAvgAggregateOutputType>;
  _count?: Maybe<ConsultationCountAggregateOutputType>;
  _max?: Maybe<ConsultationMaxAggregateOutputType>;
  _min?: Maybe<ConsultationMinAggregateOutputType>;
  _sum?: Maybe<ConsultationSumAggregateOutputType>;
};

export type AggregateConsultationChat = {
  __typename?: 'AggregateConsultationChat';
  _count?: Maybe<ConsultationChatCountAggregateOutputType>;
  _max?: Maybe<ConsultationChatMaxAggregateOutputType>;
  _min?: Maybe<ConsultationChatMinAggregateOutputType>;
};

export type AggregateConsultationRequest = {
  __typename?: 'AggregateConsultationRequest';
  _count?: Maybe<ConsultationRequestCountAggregateOutputType>;
  _max?: Maybe<ConsultationRequestMaxAggregateOutputType>;
  _min?: Maybe<ConsultationRequestMinAggregateOutputType>;
};

export type AggregateCustomFieldDefinition = {
  __typename?: 'AggregateCustomFieldDefinition';
  _count?: Maybe<CustomFieldDefinitionCountAggregateOutputType>;
  _max?: Maybe<CustomFieldDefinitionMaxAggregateOutputType>;
  _min?: Maybe<CustomFieldDefinitionMinAggregateOutputType>;
};

export type AggregateCustomFieldPimsWritebackLogEntry = {
  __typename?: 'AggregateCustomFieldPimsWritebackLogEntry';
  _count?: Maybe<CustomFieldPimsWritebackLogEntryCountAggregateOutputType>;
  _max?: Maybe<CustomFieldPimsWritebackLogEntryMaxAggregateOutputType>;
  _min?: Maybe<CustomFieldPimsWritebackLogEntryMinAggregateOutputType>;
};

export type AggregateDataPointIntegration = {
  __typename?: 'AggregateDataPointIntegration';
  _count?: Maybe<DataPointIntegrationCountAggregateOutputType>;
  _max?: Maybe<DataPointIntegrationMaxAggregateOutputType>;
  _min?: Maybe<DataPointIntegrationMinAggregateOutputType>;
};

export type AggregateDirectBookingAppointmentTypeSetting = {
  __typename?: 'AggregateDirectBookingAppointmentTypeSetting';
  _avg?: Maybe<DirectBookingAppointmentTypeSettingAvgAggregateOutputType>;
  _count?: Maybe<DirectBookingAppointmentTypeSettingCountAggregateOutputType>;
  _max?: Maybe<DirectBookingAppointmentTypeSettingMaxAggregateOutputType>;
  _min?: Maybe<DirectBookingAppointmentTypeSettingMinAggregateOutputType>;
  _sum?: Maybe<DirectBookingAppointmentTypeSettingSumAggregateOutputType>;
};

export type AggregateDirectBookingExclusionRule = {
  __typename?: 'AggregateDirectBookingExclusionRule';
  _count?: Maybe<DirectBookingExclusionRuleCountAggregateOutputType>;
  _max?: Maybe<DirectBookingExclusionRuleMaxAggregateOutputType>;
  _min?: Maybe<DirectBookingExclusionRuleMinAggregateOutputType>;
};

export type AggregateDirectBookingExclusionTimeSlot = {
  __typename?: 'AggregateDirectBookingExclusionTimeSlot';
  _avg?: Maybe<DirectBookingExclusionTimeSlotAvgAggregateOutputType>;
  _count?: Maybe<DirectBookingExclusionTimeSlotCountAggregateOutputType>;
  _max?: Maybe<DirectBookingExclusionTimeSlotMaxAggregateOutputType>;
  _min?: Maybe<DirectBookingExclusionTimeSlotMinAggregateOutputType>;
  _sum?: Maybe<DirectBookingExclusionTimeSlotSumAggregateOutputType>;
};

export type AggregateDisbursement = {
  __typename?: 'AggregateDisbursement';
  _avg?: Maybe<DisbursementAvgAggregateOutputType>;
  _count?: Maybe<DisbursementCountAggregateOutputType>;
  _max?: Maybe<DisbursementMaxAggregateOutputType>;
  _min?: Maybe<DisbursementMinAggregateOutputType>;
  _sum?: Maybe<DisbursementSumAggregateOutputType>;
};

export type AggregateDocumentation = {
  __typename?: 'AggregateDocumentation';
  _count?: Maybe<DocumentationCountAggregateOutputType>;
  _max?: Maybe<DocumentationMaxAggregateOutputType>;
  _min?: Maybe<DocumentationMinAggregateOutputType>;
};

export type AggregateEmailCampaign = {
  __typename?: 'AggregateEmailCampaign';
  _avg?: Maybe<EmailCampaignAvgAggregateOutputType>;
  _count?: Maybe<EmailCampaignCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignMinAggregateOutputType>;
  _sum?: Maybe<EmailCampaignSumAggregateOutputType>;
};

export type AggregateEmailCampaignCustomList = {
  __typename?: 'AggregateEmailCampaignCustomList';
  _avg?: Maybe<EmailCampaignCustomListAvgAggregateOutputType>;
  _count?: Maybe<EmailCampaignCustomListCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignCustomListMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignCustomListMinAggregateOutputType>;
  _sum?: Maybe<EmailCampaignCustomListSumAggregateOutputType>;
};

export type AggregateEmailCampaignCustomListRecipient = {
  __typename?: 'AggregateEmailCampaignCustomListRecipient';
  _count?: Maybe<EmailCampaignCustomListRecipientCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignCustomListRecipientMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignCustomListRecipientMinAggregateOutputType>;
};

export type AggregateEmailCampaignCustomListUploadHistory = {
  __typename?: 'AggregateEmailCampaignCustomListUploadHistory';
  _count?: Maybe<EmailCampaignCustomListUploadHistoryCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignCustomListUploadHistoryMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignCustomListUploadHistoryMinAggregateOutputType>;
};

export type AggregateEmailCampaignLog = {
  __typename?: 'AggregateEmailCampaignLog';
  _count?: Maybe<EmailCampaignLogCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignLogMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignLogMinAggregateOutputType>;
};

export type AggregateEmailCampaignTemplate = {
  __typename?: 'AggregateEmailCampaignTemplate';
  _count?: Maybe<EmailCampaignTemplateCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignTemplateMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignTemplateMinAggregateOutputType>;
};

export type AggregateEmailCampaignUnsubscribe = {
  __typename?: 'AggregateEmailCampaignUnsubscribe';
  _count?: Maybe<EmailCampaignUnsubscribeCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignUnsubscribeMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignUnsubscribeMinAggregateOutputType>;
};

export type AggregateEmailProviderLog = {
  __typename?: 'AggregateEmailProviderLog';
  _count?: Maybe<EmailProviderLogCountAggregateOutputType>;
  _max?: Maybe<EmailProviderLogMaxAggregateOutputType>;
  _min?: Maybe<EmailProviderLogMinAggregateOutputType>;
};

export type AggregateEmailTemplate = {
  __typename?: 'AggregateEmailTemplate';
  _avg?: Maybe<EmailTemplateAvgAggregateOutputType>;
  _count?: Maybe<EmailTemplateCountAggregateOutputType>;
  _max?: Maybe<EmailTemplateMaxAggregateOutputType>;
  _min?: Maybe<EmailTemplateMinAggregateOutputType>;
  _sum?: Maybe<EmailTemplateSumAggregateOutputType>;
};

export type AggregateEmailTemplateVersion = {
  __typename?: 'AggregateEmailTemplateVersion';
  _avg?: Maybe<EmailTemplateVersionAvgAggregateOutputType>;
  _count?: Maybe<EmailTemplateVersionCountAggregateOutputType>;
  _max?: Maybe<EmailTemplateVersionMaxAggregateOutputType>;
  _min?: Maybe<EmailTemplateVersionMinAggregateOutputType>;
  _sum?: Maybe<EmailTemplateVersionSumAggregateOutputType>;
};

export type AggregateEmergencyClinics = {
  __typename?: 'AggregateEmergencyClinics';
  _avg?: Maybe<EmergencyClinicsAvgAggregateOutputType>;
  _count?: Maybe<EmergencyClinicsCountAggregateOutputType>;
  _max?: Maybe<EmergencyClinicsMaxAggregateOutputType>;
  _min?: Maybe<EmergencyClinicsMinAggregateOutputType>;
  _sum?: Maybe<EmergencyClinicsSumAggregateOutputType>;
};

export type AggregateEncryptedClinicUpload = {
  __typename?: 'AggregateEncryptedClinicUpload';
  _count?: Maybe<EncryptedClinicUploadCountAggregateOutputType>;
  _max?: Maybe<EncryptedClinicUploadMaxAggregateOutputType>;
  _min?: Maybe<EncryptedClinicUploadMinAggregateOutputType>;
};

export type AggregateEnrollmentSupportEvent = {
  __typename?: 'AggregateEnrollmentSupportEvent';
  _avg?: Maybe<EnrollmentSupportEventAvgAggregateOutputType>;
  _count?: Maybe<EnrollmentSupportEventCountAggregateOutputType>;
  _max?: Maybe<EnrollmentSupportEventMaxAggregateOutputType>;
  _min?: Maybe<EnrollmentSupportEventMinAggregateOutputType>;
  _sum?: Maybe<EnrollmentSupportEventSumAggregateOutputType>;
};

export type AggregateEzyVetIntegration = {
  __typename?: 'AggregateEzyVetIntegration';
  _count?: Maybe<EzyVetIntegrationCountAggregateOutputType>;
  _max?: Maybe<EzyVetIntegrationMaxAggregateOutputType>;
  _min?: Maybe<EzyVetIntegrationMinAggregateOutputType>;
};

export type AggregateFeatureFlag = {
  __typename?: 'AggregateFeatureFlag';
  _count?: Maybe<FeatureFlagCountAggregateOutputType>;
  _max?: Maybe<FeatureFlagMaxAggregateOutputType>;
  _min?: Maybe<FeatureFlagMinAggregateOutputType>;
};

export type AggregateFinancialAdjustment = {
  __typename?: 'AggregateFinancialAdjustment';
  _avg?: Maybe<FinancialAdjustmentAvgAggregateOutputType>;
  _count?: Maybe<FinancialAdjustmentCountAggregateOutputType>;
  _max?: Maybe<FinancialAdjustmentMaxAggregateOutputType>;
  _min?: Maybe<FinancialAdjustmentMinAggregateOutputType>;
  _sum?: Maybe<FinancialAdjustmentSumAggregateOutputType>;
};

export type AggregateFinancialTransaction = {
  __typename?: 'AggregateFinancialTransaction';
  _count?: Maybe<FinancialTransactionCountAggregateOutputType>;
  _max?: Maybe<FinancialTransactionMaxAggregateOutputType>;
  _min?: Maybe<FinancialTransactionMinAggregateOutputType>;
};

export type AggregateFirebaseStructure = {
  __typename?: 'AggregateFirebaseStructure';
  _count?: Maybe<FirebaseStructureCountAggregateOutputType>;
  _max?: Maybe<FirebaseStructureMaxAggregateOutputType>;
  _min?: Maybe<FirebaseStructureMinAggregateOutputType>;
};

export type AggregateFormSubmission = {
  __typename?: 'AggregateFormSubmission';
  _count?: Maybe<FormSubmissionCountAggregateOutputType>;
  _max?: Maybe<FormSubmissionMaxAggregateOutputType>;
  _min?: Maybe<FormSubmissionMinAggregateOutputType>;
};

export type AggregateFormTemplate = {
  __typename?: 'AggregateFormTemplate';
  _count?: Maybe<FormTemplateCountAggregateOutputType>;
  _max?: Maybe<FormTemplateMaxAggregateOutputType>;
  _min?: Maybe<FormTemplateMinAggregateOutputType>;
};

export type AggregateGlobalPetParent = {
  __typename?: 'AggregateGlobalPetParent';
  _count?: Maybe<GlobalPetParentCountAggregateOutputType>;
  _max?: Maybe<GlobalPetParentMaxAggregateOutputType>;
  _min?: Maybe<GlobalPetParentMinAggregateOutputType>;
};

export type AggregateGooglePlace = {
  __typename?: 'AggregateGooglePlace';
  _count?: Maybe<GooglePlaceCountAggregateOutputType>;
  _max?: Maybe<GooglePlaceMaxAggregateOutputType>;
  _min?: Maybe<GooglePlaceMinAggregateOutputType>;
};

export type AggregateHillsToHomeApiLog = {
  __typename?: 'AggregateHillsToHomeAPILog';
  _count?: Maybe<HillsToHomeApiLogCountAggregateOutputType>;
  _max?: Maybe<HillsToHomeApiLogMaxAggregateOutputType>;
  _min?: Maybe<HillsToHomeApiLogMinAggregateOutputType>;
};

export type AggregateImage = {
  __typename?: 'AggregateImage';
  _count?: Maybe<ImageCountAggregateOutputType>;
  _max?: Maybe<ImageMaxAggregateOutputType>;
  _min?: Maybe<ImageMinAggregateOutputType>;
};

export type AggregateInformAudienceDefinition = {
  __typename?: 'AggregateInformAudienceDefinition';
  _count?: Maybe<InformAudienceDefinitionCountAggregateOutputType>;
  _max?: Maybe<InformAudienceDefinitionMaxAggregateOutputType>;
  _min?: Maybe<InformAudienceDefinitionMinAggregateOutputType>;
};

export type AggregateInformAudienceMember = {
  __typename?: 'AggregateInformAudienceMember';
  _count?: Maybe<InformAudienceMemberCountAggregateOutputType>;
  _max?: Maybe<InformAudienceMemberMaxAggregateOutputType>;
  _min?: Maybe<InformAudienceMemberMinAggregateOutputType>;
};

export type AggregateInformAudienceMemberMessage = {
  __typename?: 'AggregateInformAudienceMemberMessage';
  _count?: Maybe<InformAudienceMemberMessageCountAggregateOutputType>;
  _max?: Maybe<InformAudienceMemberMessageMaxAggregateOutputType>;
  _min?: Maybe<InformAudienceMemberMessageMinAggregateOutputType>;
};

export type AggregateInformAutomationCampaign = {
  __typename?: 'AggregateInformAutomationCampaign';
  _count?: Maybe<InformAutomationCampaignCountAggregateOutputType>;
  _max?: Maybe<InformAutomationCampaignMaxAggregateOutputType>;
  _min?: Maybe<InformAutomationCampaignMinAggregateOutputType>;
};

export type AggregateInformCampaign = {
  __typename?: 'AggregateInformCampaign';
  _count?: Maybe<InformCampaignCountAggregateOutputType>;
  _max?: Maybe<InformCampaignMaxAggregateOutputType>;
  _min?: Maybe<InformCampaignMinAggregateOutputType>;
};

export type AggregateInformCampaignEnrollment = {
  __typename?: 'AggregateInformCampaignEnrollment';
  _count?: Maybe<InformCampaignEnrollmentCountAggregateOutputType>;
  _max?: Maybe<InformCampaignEnrollmentMaxAggregateOutputType>;
  _min?: Maybe<InformCampaignEnrollmentMinAggregateOutputType>;
};

export type AggregateInformCampaignEnrollmentCanonicalService = {
  __typename?: 'AggregateInformCampaignEnrollmentCanonicalService';
  _count?: Maybe<InformCampaignEnrollmentCanonicalServiceCountAggregateOutputType>;
  _max?: Maybe<InformCampaignEnrollmentCanonicalServiceMaxAggregateOutputType>;
  _min?: Maybe<InformCampaignEnrollmentCanonicalServiceMinAggregateOutputType>;
};

export type AggregateInformCampaignExecution = {
  __typename?: 'AggregateInformCampaignExecution';
  _count?: Maybe<InformCampaignExecutionCountAggregateOutputType>;
  _max?: Maybe<InformCampaignExecutionMaxAggregateOutputType>;
  _min?: Maybe<InformCampaignExecutionMinAggregateOutputType>;
};

export type AggregateInformCampaignGroup = {
  __typename?: 'AggregateInformCampaignGroup';
  _count?: Maybe<InformCampaignGroupCountAggregateOutputType>;
  _max?: Maybe<InformCampaignGroupMaxAggregateOutputType>;
  _min?: Maybe<InformCampaignGroupMinAggregateOutputType>;
};

export type AggregateInformCommunicationOptOut = {
  __typename?: 'AggregateInformCommunicationOptOut';
  _count?: Maybe<InformCommunicationOptOutCountAggregateOutputType>;
  _max?: Maybe<InformCommunicationOptOutMaxAggregateOutputType>;
  _min?: Maybe<InformCommunicationOptOutMinAggregateOutputType>;
};

export type AggregateInformControlGroupParticipant = {
  __typename?: 'AggregateInformControlGroupParticipant';
  _count?: Maybe<InformControlGroupParticipantCountAggregateOutputType>;
  _max?: Maybe<InformControlGroupParticipantMaxAggregateOutputType>;
  _min?: Maybe<InformControlGroupParticipantMinAggregateOutputType>;
};

export type AggregateInformEmailTemplate = {
  __typename?: 'AggregateInformEmailTemplate';
  _count?: Maybe<InformEmailTemplateCountAggregateOutputType>;
  _max?: Maybe<InformEmailTemplateMaxAggregateOutputType>;
  _min?: Maybe<InformEmailTemplateMinAggregateOutputType>;
};

export type AggregateInformEntityHistory = {
  __typename?: 'AggregateInformEntityHistory';
  _count?: Maybe<InformEntityHistoryCountAggregateOutputType>;
  _max?: Maybe<InformEntityHistoryMaxAggregateOutputType>;
  _min?: Maybe<InformEntityHistoryMinAggregateOutputType>;
};

export type AggregateInformEventDrivenCampaign = {
  __typename?: 'AggregateInformEventDrivenCampaign';
  _count?: Maybe<InformEventDrivenCampaignCountAggregateOutputType>;
  _max?: Maybe<InformEventDrivenCampaignMaxAggregateOutputType>;
  _min?: Maybe<InformEventDrivenCampaignMinAggregateOutputType>;
};

export type AggregateInformEventListener = {
  __typename?: 'AggregateInformEventListener';
  _count?: Maybe<InformEventListenerCountAggregateOutputType>;
  _max?: Maybe<InformEventListenerMaxAggregateOutputType>;
  _min?: Maybe<InformEventListenerMinAggregateOutputType>;
};

export type AggregateInformNotificationRecipient = {
  __typename?: 'AggregateInformNotificationRecipient';
  _count?: Maybe<InformNotificationRecipientCountAggregateOutputType>;
  _max?: Maybe<InformNotificationRecipientMaxAggregateOutputType>;
  _min?: Maybe<InformNotificationRecipientMinAggregateOutputType>;
};

export type AggregateInformPartner = {
  __typename?: 'AggregateInformPartner';
  _count?: Maybe<InformPartnerCountAggregateOutputType>;
  _max?: Maybe<InformPartnerMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerMinAggregateOutputType>;
};

export type AggregateInformPartnerCustomer = {
  __typename?: 'AggregateInformPartnerCustomer';
  _count?: Maybe<InformPartnerCustomerCountAggregateOutputType>;
  _max?: Maybe<InformPartnerCustomerMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerCustomerMinAggregateOutputType>;
};

export type AggregateInformPartnerCustomerPharmacyProvider = {
  __typename?: 'AggregateInformPartnerCustomerPharmacyProvider';
  _count?: Maybe<InformPartnerCustomerPharmacyProviderCountAggregateOutputType>;
  _max?: Maybe<InformPartnerCustomerPharmacyProviderMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerCustomerPharmacyProviderMinAggregateOutputType>;
};

export type AggregateInformPartnerIntegration = {
  __typename?: 'AggregateInformPartnerIntegration';
  _count?: Maybe<InformPartnerIntegrationCountAggregateOutputType>;
  _max?: Maybe<InformPartnerIntegrationMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerIntegrationMinAggregateOutputType>;
};

export type AggregateInformPartnerIntegrationModel = {
  __typename?: 'AggregateInformPartnerIntegrationModel';
  _avg?: Maybe<InformPartnerIntegrationModelAvgAggregateOutputType>;
  _count?: Maybe<InformPartnerIntegrationModelCountAggregateOutputType>;
  _max?: Maybe<InformPartnerIntegrationModelMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerIntegrationModelMinAggregateOutputType>;
  _sum?: Maybe<InformPartnerIntegrationModelSumAggregateOutputType>;
};

export type AggregateInformPartnerProgram = {
  __typename?: 'AggregateInformPartnerProgram';
  _count?: Maybe<InformPartnerProgramCountAggregateOutputType>;
  _max?: Maybe<InformPartnerProgramMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerProgramMinAggregateOutputType>;
};

export type AggregateInformPartnerProgramEnrollment = {
  __typename?: 'AggregateInformPartnerProgramEnrollment';
  _count?: Maybe<InformPartnerProgramEnrollmentCountAggregateOutputType>;
  _max?: Maybe<InformPartnerProgramEnrollmentMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerProgramEnrollmentMinAggregateOutputType>;
};

export type AggregateInformPartnerUser = {
  __typename?: 'AggregateInformPartnerUser';
  _count?: Maybe<InformPartnerUserCountAggregateOutputType>;
  _max?: Maybe<InformPartnerUserMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerUserMinAggregateOutputType>;
};

export type AggregateInformPartnerUserRole = {
  __typename?: 'AggregateInformPartnerUserRole';
  _count?: Maybe<InformPartnerUserRoleCountAggregateOutputType>;
  _max?: Maybe<InformPartnerUserRoleMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerUserRoleMinAggregateOutputType>;
};

export type AggregateInformScheduledCampaign = {
  __typename?: 'AggregateInformScheduledCampaign';
  _count?: Maybe<InformScheduledCampaignCountAggregateOutputType>;
  _max?: Maybe<InformScheduledCampaignMaxAggregateOutputType>;
  _min?: Maybe<InformScheduledCampaignMinAggregateOutputType>;
};

export type AggregateInformSession = {
  __typename?: 'AggregateInformSession';
  _count?: Maybe<InformSessionCountAggregateOutputType>;
  _max?: Maybe<InformSessionMaxAggregateOutputType>;
  _min?: Maybe<InformSessionMinAggregateOutputType>;
};

export type AggregateInformSessionEvent = {
  __typename?: 'AggregateInformSessionEvent';
  _count?: Maybe<InformSessionEventCountAggregateOutputType>;
  _max?: Maybe<InformSessionEventMaxAggregateOutputType>;
  _min?: Maybe<InformSessionEventMinAggregateOutputType>;
};

export type AggregateInstinctIntegration = {
  __typename?: 'AggregateInstinctIntegration';
  _count?: Maybe<InstinctIntegrationCountAggregateOutputType>;
  _max?: Maybe<InstinctIntegrationMaxAggregateOutputType>;
  _min?: Maybe<InstinctIntegrationMinAggregateOutputType>;
};

export type AggregateInsuranceIntegration = {
  __typename?: 'AggregateInsuranceIntegration';
  _count?: Maybe<InsuranceIntegrationCountAggregateOutputType>;
  _max?: Maybe<InsuranceIntegrationMaxAggregateOutputType>;
  _min?: Maybe<InsuranceIntegrationMinAggregateOutputType>;
};

export type AggregateIntegrationOutageHistoryEntry = {
  __typename?: 'AggregateIntegrationOutageHistoryEntry';
  _count?: Maybe<IntegrationOutageHistoryEntryCountAggregateOutputType>;
  _max?: Maybe<IntegrationOutageHistoryEntryMaxAggregateOutputType>;
  _min?: Maybe<IntegrationOutageHistoryEntryMinAggregateOutputType>;
};

export type AggregateInterchangeRate = {
  __typename?: 'AggregateInterchangeRate';
  _avg?: Maybe<InterchangeRateAvgAggregateOutputType>;
  _count?: Maybe<InterchangeRateCountAggregateOutputType>;
  _max?: Maybe<InterchangeRateMaxAggregateOutputType>;
  _min?: Maybe<InterchangeRateMinAggregateOutputType>;
  _sum?: Maybe<InterchangeRateSumAggregateOutputType>;
};

export type AggregateInvoice = {
  __typename?: 'AggregateInvoice';
  _avg?: Maybe<InvoiceAvgAggregateOutputType>;
  _count?: Maybe<InvoiceCountAggregateOutputType>;
  _max?: Maybe<InvoiceMaxAggregateOutputType>;
  _min?: Maybe<InvoiceMinAggregateOutputType>;
  _sum?: Maybe<InvoiceSumAggregateOutputType>;
};

export type AggregateInvoiceLineItem = {
  __typename?: 'AggregateInvoiceLineItem';
  _avg?: Maybe<InvoiceLineItemAvgAggregateOutputType>;
  _count?: Maybe<InvoiceLineItemCountAggregateOutputType>;
  _max?: Maybe<InvoiceLineItemMaxAggregateOutputType>;
  _min?: Maybe<InvoiceLineItemMinAggregateOutputType>;
  _sum?: Maybe<InvoiceLineItemSumAggregateOutputType>;
};

export type AggregateInvoicePimsWritebackLogEntry = {
  __typename?: 'AggregateInvoicePimsWritebackLogEntry';
  _count?: Maybe<InvoicePimsWritebackLogEntryCountAggregateOutputType>;
  _max?: Maybe<InvoicePimsWritebackLogEntryMaxAggregateOutputType>;
  _min?: Maybe<InvoicePimsWritebackLogEntryMinAggregateOutputType>;
};

export type AggregateLabPanel = {
  __typename?: 'AggregateLabPanel';
  _count?: Maybe<LabPanelCountAggregateOutputType>;
  _max?: Maybe<LabPanelMaxAggregateOutputType>;
  _min?: Maybe<LabPanelMinAggregateOutputType>;
};

export type AggregateLabResult = {
  __typename?: 'AggregateLabResult';
  _count?: Maybe<LabResultCountAggregateOutputType>;
  _max?: Maybe<LabResultMaxAggregateOutputType>;
  _min?: Maybe<LabResultMinAggregateOutputType>;
};

export type AggregateLapsedPetParentTriggers = {
  __typename?: 'AggregateLapsedPetParentTriggers';
  _count?: Maybe<LapsedPetParentTriggersCountAggregateOutputType>;
  _max?: Maybe<LapsedPetParentTriggersMaxAggregateOutputType>;
  _min?: Maybe<LapsedPetParentTriggersMinAggregateOutputType>;
};

export type AggregateLegalEntity = {
  __typename?: 'AggregateLegalEntity';
  _count?: Maybe<LegalEntityCountAggregateOutputType>;
  _max?: Maybe<LegalEntityMaxAggregateOutputType>;
  _min?: Maybe<LegalEntityMinAggregateOutputType>;
};

export type AggregateLoyaltyAccount = {
  __typename?: 'AggregateLoyaltyAccount';
  _avg?: Maybe<LoyaltyAccountAvgAggregateOutputType>;
  _count?: Maybe<LoyaltyAccountCountAggregateOutputType>;
  _max?: Maybe<LoyaltyAccountMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyAccountMinAggregateOutputType>;
  _sum?: Maybe<LoyaltyAccountSumAggregateOutputType>;
};

export type AggregateLoyaltyAccountHolder = {
  __typename?: 'AggregateLoyaltyAccountHolder';
  _count?: Maybe<LoyaltyAccountHolderCountAggregateOutputType>;
  _max?: Maybe<LoyaltyAccountHolderMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyAccountHolderMinAggregateOutputType>;
};

export type AggregateLoyaltyAccountMerger = {
  __typename?: 'AggregateLoyaltyAccountMerger';
  _count?: Maybe<LoyaltyAccountMergerCountAggregateOutputType>;
  _max?: Maybe<LoyaltyAccountMergerMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyAccountMergerMinAggregateOutputType>;
};

export type AggregateLoyaltyInvoicePointGranter = {
  __typename?: 'AggregateLoyaltyInvoicePointGranter';
  _count?: Maybe<LoyaltyInvoicePointGranterCountAggregateOutputType>;
  _max?: Maybe<LoyaltyInvoicePointGranterMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyInvoicePointGranterMinAggregateOutputType>;
};

export type AggregateLoyaltyPointDelta = {
  __typename?: 'AggregateLoyaltyPointDelta';
  _avg?: Maybe<LoyaltyPointDeltaAvgAggregateOutputType>;
  _count?: Maybe<LoyaltyPointDeltaCountAggregateOutputType>;
  _max?: Maybe<LoyaltyPointDeltaMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyPointDeltaMinAggregateOutputType>;
  _sum?: Maybe<LoyaltyPointDeltaSumAggregateOutputType>;
};

export type AggregateLoyaltyPointGrantingService = {
  __typename?: 'AggregateLoyaltyPointGrantingService';
  _count?: Maybe<LoyaltyPointGrantingServiceCountAggregateOutputType>;
  _max?: Maybe<LoyaltyPointGrantingServiceMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyPointGrantingServiceMinAggregateOutputType>;
};

export type AggregateLoyaltyPointGrantingServiceCategory = {
  __typename?: 'AggregateLoyaltyPointGrantingServiceCategory';
  _count?: Maybe<LoyaltyPointGrantingServiceCategoryCountAggregateOutputType>;
  _max?: Maybe<LoyaltyPointGrantingServiceCategoryMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyPointGrantingServiceCategoryMinAggregateOutputType>;
};

export type AggregateLoyaltyPointUserGrant = {
  __typename?: 'AggregateLoyaltyPointUserGrant';
  _avg?: Maybe<LoyaltyPointUserGrantAvgAggregateOutputType>;
  _count?: Maybe<LoyaltyPointUserGrantCountAggregateOutputType>;
  _max?: Maybe<LoyaltyPointUserGrantMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyPointUserGrantMinAggregateOutputType>;
  _sum?: Maybe<LoyaltyPointUserGrantSumAggregateOutputType>;
};

export type AggregateLoyaltyProgram = {
  __typename?: 'AggregateLoyaltyProgram';
  _avg?: Maybe<LoyaltyProgramAvgAggregateOutputType>;
  _count?: Maybe<LoyaltyProgramCountAggregateOutputType>;
  _max?: Maybe<LoyaltyProgramMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyProgramMinAggregateOutputType>;
  _sum?: Maybe<LoyaltyProgramSumAggregateOutputType>;
};

export type AggregateLoyaltyProgramStatusHistory = {
  __typename?: 'AggregateLoyaltyProgramStatusHistory';
  _count?: Maybe<LoyaltyProgramStatusHistoryCountAggregateOutputType>;
  _max?: Maybe<LoyaltyProgramStatusHistoryMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyProgramStatusHistoryMinAggregateOutputType>;
};

export type AggregateLoyaltyReward = {
  __typename?: 'AggregateLoyaltyReward';
  _avg?: Maybe<LoyaltyRewardAvgAggregateOutputType>;
  _count?: Maybe<LoyaltyRewardCountAggregateOutputType>;
  _max?: Maybe<LoyaltyRewardMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyRewardMinAggregateOutputType>;
  _sum?: Maybe<LoyaltyRewardSumAggregateOutputType>;
};

export type AggregateLoyaltyRewardRedemption = {
  __typename?: 'AggregateLoyaltyRewardRedemption';
  _count?: Maybe<LoyaltyRewardRedemptionCountAggregateOutputType>;
  _max?: Maybe<LoyaltyRewardRedemptionMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyRewardRedemptionMinAggregateOutputType>;
};

export type AggregateLoyaltyRewardRedemptionHistoryEntry = {
  __typename?: 'AggregateLoyaltyRewardRedemptionHistoryEntry';
  _count?: Maybe<LoyaltyRewardRedemptionHistoryEntryCountAggregateOutputType>;
  _max?: Maybe<LoyaltyRewardRedemptionHistoryEntryMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyRewardRedemptionHistoryEntryMinAggregateOutputType>;
};

export type AggregateMassTextAlert = {
  __typename?: 'AggregateMassTextAlert';
  _count?: Maybe<MassTextAlertCountAggregateOutputType>;
  _max?: Maybe<MassTextAlertMaxAggregateOutputType>;
  _min?: Maybe<MassTextAlertMinAggregateOutputType>;
};

export type AggregateMassTextAlertEntry = {
  __typename?: 'AggregateMassTextAlertEntry';
  _count?: Maybe<MassTextAlertEntryCountAggregateOutputType>;
  _max?: Maybe<MassTextAlertEntryMaxAggregateOutputType>;
  _min?: Maybe<MassTextAlertEntryMinAggregateOutputType>;
};

export type AggregateMassTextAlertEntryAppointment = {
  __typename?: 'AggregateMassTextAlertEntryAppointment';
  _count?: Maybe<MassTextAlertEntryAppointmentCountAggregateOutputType>;
  _max?: Maybe<MassTextAlertEntryAppointmentMaxAggregateOutputType>;
  _min?: Maybe<MassTextAlertEntryAppointmentMinAggregateOutputType>;
};

export type AggregateMedia = {
  __typename?: 'AggregateMedia';
  _avg?: Maybe<MediaAvgAggregateOutputType>;
  _count?: Maybe<MediaCountAggregateOutputType>;
  _max?: Maybe<MediaMaxAggregateOutputType>;
  _min?: Maybe<MediaMinAggregateOutputType>;
  _sum?: Maybe<MediaSumAggregateOutputType>;
};

export type AggregateMedicalHistory = {
  __typename?: 'AggregateMedicalHistory';
  _count?: Maybe<MedicalHistoryCountAggregateOutputType>;
  _max?: Maybe<MedicalHistoryMaxAggregateOutputType>;
  _min?: Maybe<MedicalHistoryMinAggregateOutputType>;
};

export type AggregateMessageTemplate = {
  __typename?: 'AggregateMessageTemplate';
  _count?: Maybe<MessageTemplateCountAggregateOutputType>;
  _max?: Maybe<MessageTemplateMaxAggregateOutputType>;
  _min?: Maybe<MessageTemplateMinAggregateOutputType>;
};

export type AggregateMessagingCampaign = {
  __typename?: 'AggregateMessagingCampaign';
  _count?: Maybe<MessagingCampaignCountAggregateOutputType>;
  _max?: Maybe<MessagingCampaignMaxAggregateOutputType>;
  _min?: Maybe<MessagingCampaignMinAggregateOutputType>;
};

export type AggregateMessagingPartner = {
  __typename?: 'AggregateMessagingPartner';
  _count?: Maybe<MessagingPartnerCountAggregateOutputType>;
  _max?: Maybe<MessagingPartnerMaxAggregateOutputType>;
  _min?: Maybe<MessagingPartnerMinAggregateOutputType>;
};

export type AggregateModule = {
  __typename?: 'AggregateModule';
  _count?: Maybe<ModuleCountAggregateOutputType>;
  _max?: Maybe<ModuleMaxAggregateOutputType>;
  _min?: Maybe<ModuleMinAggregateOutputType>;
};

export type AggregateNeoIntegration = {
  __typename?: 'AggregateNeoIntegration';
  _count?: Maybe<NeoIntegrationCountAggregateOutputType>;
  _max?: Maybe<NeoIntegrationMaxAggregateOutputType>;
  _min?: Maybe<NeoIntegrationMinAggregateOutputType>;
};

export type AggregateNonPrismaSchemaScriptRan = {
  __typename?: 'AggregateNonPrismaSchemaScriptRan';
  _count?: Maybe<NonPrismaSchemaScriptRanCountAggregateOutputType>;
  _max?: Maybe<NonPrismaSchemaScriptRanMaxAggregateOutputType>;
  _min?: Maybe<NonPrismaSchemaScriptRanMinAggregateOutputType>;
};

export type AggregateNotificationEventToMessage = {
  __typename?: 'AggregateNotificationEventToMessage';
  _count?: Maybe<NotificationEventToMessageCountAggregateOutputType>;
  _max?: Maybe<NotificationEventToMessageMaxAggregateOutputType>;
  _min?: Maybe<NotificationEventToMessageMinAggregateOutputType>;
};

export type AggregateOrganization = {
  __typename?: 'AggregateOrganization';
  _count?: Maybe<OrganizationCountAggregateOutputType>;
  _max?: Maybe<OrganizationMaxAggregateOutputType>;
  _min?: Maybe<OrganizationMinAggregateOutputType>;
};

export type AggregateOrganizationCareBenefitToClinicService = {
  __typename?: 'AggregateOrganizationCareBenefitToClinicService';
  _count?: Maybe<OrganizationCareBenefitToClinicServiceCountAggregateOutputType>;
  _max?: Maybe<OrganizationCareBenefitToClinicServiceMaxAggregateOutputType>;
  _min?: Maybe<OrganizationCareBenefitToClinicServiceMinAggregateOutputType>;
};

export type AggregateOrganizationCareBenefitToClinicServiceCategory = {
  __typename?: 'AggregateOrganizationCareBenefitToClinicServiceCategory';
  _count?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCountAggregateOutputType>;
  _max?: Maybe<OrganizationCareBenefitToClinicServiceCategoryMaxAggregateOutputType>;
  _min?: Maybe<OrganizationCareBenefitToClinicServiceCategoryMinAggregateOutputType>;
};

export type AggregateOrganizationPet = {
  __typename?: 'AggregateOrganizationPet';
  _count?: Maybe<OrganizationPetCountAggregateOutputType>;
  _max?: Maybe<OrganizationPetMaxAggregateOutputType>;
  _min?: Maybe<OrganizationPetMinAggregateOutputType>;
};

export type AggregateOrganizationPetParent = {
  __typename?: 'AggregateOrganizationPetParent';
  _count?: Maybe<OrganizationPetParentCountAggregateOutputType>;
  _max?: Maybe<OrganizationPetParentMaxAggregateOutputType>;
  _min?: Maybe<OrganizationPetParentMinAggregateOutputType>;
};

export type AggregateOrganizationPetToOrganizationPetParent = {
  __typename?: 'AggregateOrganizationPetToOrganizationPetParent';
  _count?: Maybe<OrganizationPetToOrganizationPetParentCountAggregateOutputType>;
  _max?: Maybe<OrganizationPetToOrganizationPetParentMaxAggregateOutputType>;
  _min?: Maybe<OrganizationPetToOrganizationPetParentMinAggregateOutputType>;
};

export type AggregateOwnerInfo = {
  __typename?: 'AggregateOwnerInfo';
  _count?: Maybe<OwnerInfoCountAggregateOutputType>;
  _max?: Maybe<OwnerInfoMaxAggregateOutputType>;
  _min?: Maybe<OwnerInfoMinAggregateOutputType>;
};

export type AggregatePpcIntegration = {
  __typename?: 'AggregatePPCIntegration';
  _count?: Maybe<PpcIntegrationCountAggregateOutputType>;
  _max?: Maybe<PpcIntegrationMaxAggregateOutputType>;
  _min?: Maybe<PpcIntegrationMinAggregateOutputType>;
};

export type AggregatePaymentPimsWritebackLogEntry = {
  __typename?: 'AggregatePaymentPimsWritebackLogEntry';
  _count?: Maybe<PaymentPimsWritebackLogEntryCountAggregateOutputType>;
  _max?: Maybe<PaymentPimsWritebackLogEntryMaxAggregateOutputType>;
  _min?: Maybe<PaymentPimsWritebackLogEntryMinAggregateOutputType>;
};

export type AggregatePaymentsReportTransaction = {
  __typename?: 'AggregatePaymentsReportTransaction';
  _avg?: Maybe<PaymentsReportTransactionAvgAggregateOutputType>;
  _count?: Maybe<PaymentsReportTransactionCountAggregateOutputType>;
  _max?: Maybe<PaymentsReportTransactionMaxAggregateOutputType>;
  _min?: Maybe<PaymentsReportTransactionMinAggregateOutputType>;
  _sum?: Maybe<PaymentsReportTransactionSumAggregateOutputType>;
};

export type AggregatePayoutBatchingPeriod = {
  __typename?: 'AggregatePayoutBatchingPeriod';
  _count?: Maybe<PayoutBatchingPeriodCountAggregateOutputType>;
  _max?: Maybe<PayoutBatchingPeriodMaxAggregateOutputType>;
  _min?: Maybe<PayoutBatchingPeriodMinAggregateOutputType>;
};

export type AggregatePayoutBatchingSchedule = {
  __typename?: 'AggregatePayoutBatchingSchedule';
  _avg?: Maybe<PayoutBatchingScheduleAvgAggregateOutputType>;
  _count?: Maybe<PayoutBatchingScheduleCountAggregateOutputType>;
  _max?: Maybe<PayoutBatchingScheduleMaxAggregateOutputType>;
  _min?: Maybe<PayoutBatchingScheduleMinAggregateOutputType>;
  _sum?: Maybe<PayoutBatchingScheduleSumAggregateOutputType>;
};

export type AggregatePayoutBatchingSetting = {
  __typename?: 'AggregatePayoutBatchingSetting';
  _count?: Maybe<PayoutBatchingSettingCountAggregateOutputType>;
  _max?: Maybe<PayoutBatchingSettingMaxAggregateOutputType>;
  _min?: Maybe<PayoutBatchingSettingMinAggregateOutputType>;
};

export type AggregatePermission = {
  __typename?: 'AggregatePermission';
  _count?: Maybe<PermissionCountAggregateOutputType>;
  _max?: Maybe<PermissionMaxAggregateOutputType>;
  _min?: Maybe<PermissionMinAggregateOutputType>;
};

export type AggregatePet = {
  __typename?: 'AggregatePet';
  _avg?: Maybe<PetAvgAggregateOutputType>;
  _count?: Maybe<PetCountAggregateOutputType>;
  _max?: Maybe<PetMaxAggregateOutputType>;
  _min?: Maybe<PetMinAggregateOutputType>;
  _sum?: Maybe<PetSumAggregateOutputType>;
};

export type AggregatePetParentSetting = {
  __typename?: 'AggregatePetParentSetting';
  _count?: Maybe<PetParentSettingCountAggregateOutputType>;
  _max?: Maybe<PetParentSettingMaxAggregateOutputType>;
  _min?: Maybe<PetParentSettingMinAggregateOutputType>;
};

export type AggregatePetPortalSetting = {
  __typename?: 'AggregatePetPortalSetting';
  _count?: Maybe<PetPortalSettingCountAggregateOutputType>;
  _max?: Maybe<PetPortalSettingMaxAggregateOutputType>;
  _min?: Maybe<PetPortalSettingMinAggregateOutputType>;
};

export type AggregatePhoneNumberLookupRequest = {
  __typename?: 'AggregatePhoneNumberLookupRequest';
  _count?: Maybe<PhoneNumberLookupRequestCountAggregateOutputType>;
  _max?: Maybe<PhoneNumberLookupRequestMaxAggregateOutputType>;
  _min?: Maybe<PhoneNumberLookupRequestMinAggregateOutputType>;
};

export type AggregatePhoneNumberLookupResult = {
  __typename?: 'AggregatePhoneNumberLookupResult';
  _avg?: Maybe<PhoneNumberLookupResultAvgAggregateOutputType>;
  _count?: Maybe<PhoneNumberLookupResultCountAggregateOutputType>;
  _max?: Maybe<PhoneNumberLookupResultMaxAggregateOutputType>;
  _min?: Maybe<PhoneNumberLookupResultMinAggregateOutputType>;
  _sum?: Maybe<PhoneNumberLookupResultSumAggregateOutputType>;
};

export type AggregatePimsInvoice = {
  __typename?: 'AggregatePimsInvoice';
  _count?: Maybe<PimsInvoiceCountAggregateOutputType>;
  _max?: Maybe<PimsInvoiceMaxAggregateOutputType>;
  _min?: Maybe<PimsInvoiceMinAggregateOutputType>;
};

export type AggregatePimsInvoiceLineItem = {
  __typename?: 'AggregatePimsInvoiceLineItem';
  _count?: Maybe<PimsInvoiceLineItemCountAggregateOutputType>;
  _max?: Maybe<PimsInvoiceLineItemMaxAggregateOutputType>;
  _min?: Maybe<PimsInvoiceLineItemMinAggregateOutputType>;
};

export type AggregatePimsPaymentType = {
  __typename?: 'AggregatePimsPaymentType';
  _count?: Maybe<PimsPaymentTypeCountAggregateOutputType>;
  _max?: Maybe<PimsPaymentTypeMaxAggregateOutputType>;
  _min?: Maybe<PimsPaymentTypeMinAggregateOutputType>;
};

export type AggregatePimsWritebackLogEntry = {
  __typename?: 'AggregatePimsWritebackLogEntry';
  _avg?: Maybe<PimsWritebackLogEntryAvgAggregateOutputType>;
  _count?: Maybe<PimsWritebackLogEntryCountAggregateOutputType>;
  _max?: Maybe<PimsWritebackLogEntryMaxAggregateOutputType>;
  _min?: Maybe<PimsWritebackLogEntryMinAggregateOutputType>;
  _sum?: Maybe<PimsWritebackLogEntrySumAggregateOutputType>;
};

export type AggregatePrescription = {
  __typename?: 'AggregatePrescription';
  _avg?: Maybe<PrescriptionAvgAggregateOutputType>;
  _count?: Maybe<PrescriptionCountAggregateOutputType>;
  _max?: Maybe<PrescriptionMaxAggregateOutputType>;
  _min?: Maybe<PrescriptionMinAggregateOutputType>;
  _sum?: Maybe<PrescriptionSumAggregateOutputType>;
};

export type AggregateProduct = {
  __typename?: 'AggregateProduct';
  _avg?: Maybe<ProductAvgAggregateOutputType>;
  _count?: Maybe<ProductCountAggregateOutputType>;
  _max?: Maybe<ProductMaxAggregateOutputType>;
  _min?: Maybe<ProductMinAggregateOutputType>;
  _sum?: Maybe<ProductSumAggregateOutputType>;
};

export type AggregateProductPackage = {
  __typename?: 'AggregateProductPackage';
  _count?: Maybe<ProductPackageCountAggregateOutputType>;
  _max?: Maybe<ProductPackageMaxAggregateOutputType>;
  _min?: Maybe<ProductPackageMinAggregateOutputType>;
};

export type AggregateProductPackageSubscription = {
  __typename?: 'AggregateProductPackageSubscription';
  _count?: Maybe<ProductPackageSubscriptionCountAggregateOutputType>;
  _max?: Maybe<ProductPackageSubscriptionMaxAggregateOutputType>;
  _min?: Maybe<ProductPackageSubscriptionMinAggregateOutputType>;
};

export type AggregatePromoCode = {
  __typename?: 'AggregatePromoCode';
  _avg?: Maybe<PromoCodeAvgAggregateOutputType>;
  _count?: Maybe<PromoCodeCountAggregateOutputType>;
  _max?: Maybe<PromoCodeMaxAggregateOutputType>;
  _min?: Maybe<PromoCodeMinAggregateOutputType>;
  _sum?: Maybe<PromoCodeSumAggregateOutputType>;
};

export type AggregateProviderAppointmentTypeRoomMap = {
  __typename?: 'AggregateProviderAppointmentTypeRoomMap';
  _count?: Maybe<ProviderAppointmentTypeRoomMapCountAggregateOutputType>;
  _max?: Maybe<ProviderAppointmentTypeRoomMapMaxAggregateOutputType>;
  _min?: Maybe<ProviderAppointmentTypeRoomMapMinAggregateOutputType>;
};

export type AggregatePushNotificationLog = {
  __typename?: 'AggregatePushNotificationLog';
  _count?: Maybe<PushNotificationLogCountAggregateOutputType>;
  _max?: Maybe<PushNotificationLogMaxAggregateOutputType>;
  _min?: Maybe<PushNotificationLogMinAggregateOutputType>;
};

export type AggregateRecap = {
  __typename?: 'AggregateRecap';
  _avg?: Maybe<RecapAvgAggregateOutputType>;
  _count?: Maybe<RecapCountAggregateOutputType>;
  _max?: Maybe<RecapMaxAggregateOutputType>;
  _min?: Maybe<RecapMinAggregateOutputType>;
  _sum?: Maybe<RecapSumAggregateOutputType>;
};

export type AggregateReview = {
  __typename?: 'AggregateReview';
  _avg?: Maybe<ReviewAvgAggregateOutputType>;
  _count?: Maybe<ReviewCountAggregateOutputType>;
  _max?: Maybe<ReviewMaxAggregateOutputType>;
  _min?: Maybe<ReviewMinAggregateOutputType>;
  _sum?: Maybe<ReviewSumAggregateOutputType>;
};

export type AggregateReviewTag = {
  __typename?: 'AggregateReviewTag';
  _count?: Maybe<ReviewTagCountAggregateOutputType>;
  _max?: Maybe<ReviewTagMaxAggregateOutputType>;
  _min?: Maybe<ReviewTagMinAggregateOutputType>;
};

export type AggregateRules = {
  __typename?: 'AggregateRules';
  _count?: Maybe<RulesCountAggregateOutputType>;
  _max?: Maybe<RulesMaxAggregateOutputType>;
  _min?: Maybe<RulesMinAggregateOutputType>;
};

export type AggregateSegment = {
  __typename?: 'AggregateSegment';
  _avg?: Maybe<SegmentAvgAggregateOutputType>;
  _count?: Maybe<SegmentCountAggregateOutputType>;
  _max?: Maybe<SegmentMaxAggregateOutputType>;
  _min?: Maybe<SegmentMinAggregateOutputType>;
  _sum?: Maybe<SegmentSumAggregateOutputType>;
};

export type AggregateSentTrupanionExamDayOffer = {
  __typename?: 'AggregateSentTrupanionExamDayOffer';
  _count?: Maybe<SentTrupanionExamDayOfferCountAggregateOutputType>;
  _max?: Maybe<SentTrupanionExamDayOfferMaxAggregateOutputType>;
  _min?: Maybe<SentTrupanionExamDayOfferMinAggregateOutputType>;
};

export type AggregateService = {
  __typename?: 'AggregateService';
  _avg?: Maybe<ServiceAvgAggregateOutputType>;
  _count?: Maybe<ServiceCountAggregateOutputType>;
  _max?: Maybe<ServiceMaxAggregateOutputType>;
  _min?: Maybe<ServiceMinAggregateOutputType>;
  _sum?: Maybe<ServiceSumAggregateOutputType>;
};

export type AggregateServiceCategory = {
  __typename?: 'AggregateServiceCategory';
  _count?: Maybe<ServiceCategoryCountAggregateOutputType>;
  _max?: Maybe<ServiceCategoryMaxAggregateOutputType>;
  _min?: Maybe<ServiceCategoryMinAggregateOutputType>;
};

export type AggregateServicePurchaseSummary = {
  __typename?: 'AggregateServicePurchaseSummary';
  _avg?: Maybe<ServicePurchaseSummaryAvgAggregateOutputType>;
  _count?: Maybe<ServicePurchaseSummaryCountAggregateOutputType>;
  _max?: Maybe<ServicePurchaseSummaryMaxAggregateOutputType>;
  _min?: Maybe<ServicePurchaseSummaryMinAggregateOutputType>;
  _sum?: Maybe<ServicePurchaseSummarySumAggregateOutputType>;
};

export type AggregateServiceReminder = {
  __typename?: 'AggregateServiceReminder';
  _count?: Maybe<ServiceReminderCountAggregateOutputType>;
  _max?: Maybe<ServiceReminderMaxAggregateOutputType>;
  _min?: Maybe<ServiceReminderMinAggregateOutputType>;
};

export type AggregateServiceReminderNotification = {
  __typename?: 'AggregateServiceReminderNotification';
  _count?: Maybe<ServiceReminderNotificationCountAggregateOutputType>;
  _max?: Maybe<ServiceReminderNotificationMaxAggregateOutputType>;
  _min?: Maybe<ServiceReminderNotificationMinAggregateOutputType>;
};

export type AggregateServiceReminderTiming = {
  __typename?: 'AggregateServiceReminderTiming';
  _avg?: Maybe<ServiceReminderTimingAvgAggregateOutputType>;
  _count?: Maybe<ServiceReminderTimingCountAggregateOutputType>;
  _max?: Maybe<ServiceReminderTimingMaxAggregateOutputType>;
  _min?: Maybe<ServiceReminderTimingMinAggregateOutputType>;
  _sum?: Maybe<ServiceReminderTimingSumAggregateOutputType>;
};

export type AggregateSex = {
  __typename?: 'AggregateSex';
  _count?: Maybe<SexCountAggregateOutputType>;
  _max?: Maybe<SexMaxAggregateOutputType>;
  _min?: Maybe<SexMinAggregateOutputType>;
};

export type AggregateSmsNotificationStatus = {
  __typename?: 'AggregateSmsNotificationStatus';
  _count?: Maybe<SmsNotificationStatusCountAggregateOutputType>;
  _max?: Maybe<SmsNotificationStatusMaxAggregateOutputType>;
  _min?: Maybe<SmsNotificationStatusMinAggregateOutputType>;
};

export type AggregateSpecies = {
  __typename?: 'AggregateSpecies';
  _count?: Maybe<SpeciesCountAggregateOutputType>;
  _max?: Maybe<SpeciesMaxAggregateOutputType>;
  _min?: Maybe<SpeciesMinAggregateOutputType>;
};

export type AggregateStaffRole = {
  __typename?: 'AggregateStaffRole';
  _count?: Maybe<StaffRoleCountAggregateOutputType>;
  _max?: Maybe<StaffRoleMaxAggregateOutputType>;
  _min?: Maybe<StaffRoleMinAggregateOutputType>;
};

export type AggregateStripeCustomer = {
  __typename?: 'AggregateStripeCustomer';
  _count?: Maybe<StripeCustomerCountAggregateOutputType>;
  _max?: Maybe<StripeCustomerMaxAggregateOutputType>;
  _min?: Maybe<StripeCustomerMinAggregateOutputType>;
};

export type AggregateStripeDispute = {
  __typename?: 'AggregateStripeDispute';
  _avg?: Maybe<StripeDisputeAvgAggregateOutputType>;
  _count?: Maybe<StripeDisputeCountAggregateOutputType>;
  _max?: Maybe<StripeDisputeMaxAggregateOutputType>;
  _min?: Maybe<StripeDisputeMinAggregateOutputType>;
  _sum?: Maybe<StripeDisputeSumAggregateOutputType>;
};

export type AggregateStripeInvoice = {
  __typename?: 'AggregateStripeInvoice';
  _avg?: Maybe<StripeInvoiceAvgAggregateOutputType>;
  _count?: Maybe<StripeInvoiceCountAggregateOutputType>;
  _max?: Maybe<StripeInvoiceMaxAggregateOutputType>;
  _min?: Maybe<StripeInvoiceMinAggregateOutputType>;
  _sum?: Maybe<StripeInvoiceSumAggregateOutputType>;
};

export type AggregateStripeInvoiceItem = {
  __typename?: 'AggregateStripeInvoiceItem';
  _avg?: Maybe<StripeInvoiceItemAvgAggregateOutputType>;
  _count?: Maybe<StripeInvoiceItemCountAggregateOutputType>;
  _max?: Maybe<StripeInvoiceItemMaxAggregateOutputType>;
  _min?: Maybe<StripeInvoiceItemMinAggregateOutputType>;
  _sum?: Maybe<StripeInvoiceItemSumAggregateOutputType>;
};

export type AggregateStripePaymentIntent = {
  __typename?: 'AggregateStripePaymentIntent';
  _avg?: Maybe<StripePaymentIntentAvgAggregateOutputType>;
  _count?: Maybe<StripePaymentIntentCountAggregateOutputType>;
  _max?: Maybe<StripePaymentIntentMaxAggregateOutputType>;
  _min?: Maybe<StripePaymentIntentMinAggregateOutputType>;
  _sum?: Maybe<StripePaymentIntentSumAggregateOutputType>;
};

export type AggregateStripePaymentMethod = {
  __typename?: 'AggregateStripePaymentMethod';
  _avg?: Maybe<StripePaymentMethodAvgAggregateOutputType>;
  _count?: Maybe<StripePaymentMethodCountAggregateOutputType>;
  _max?: Maybe<StripePaymentMethodMaxAggregateOutputType>;
  _min?: Maybe<StripePaymentMethodMinAggregateOutputType>;
  _sum?: Maybe<StripePaymentMethodSumAggregateOutputType>;
};

export type AggregateStripePayout = {
  __typename?: 'AggregateStripePayout';
  _avg?: Maybe<StripePayoutAvgAggregateOutputType>;
  _count?: Maybe<StripePayoutCountAggregateOutputType>;
  _max?: Maybe<StripePayoutMaxAggregateOutputType>;
  _min?: Maybe<StripePayoutMinAggregateOutputType>;
  _sum?: Maybe<StripePayoutSumAggregateOutputType>;
};

export type AggregateStripePayoutAccount = {
  __typename?: 'AggregateStripePayoutAccount';
  _count?: Maybe<StripePayoutAccountCountAggregateOutputType>;
  _max?: Maybe<StripePayoutAccountMaxAggregateOutputType>;
  _min?: Maybe<StripePayoutAccountMinAggregateOutputType>;
};

export type AggregateStripeReceipt = {
  __typename?: 'AggregateStripeReceipt';
  _count?: Maybe<StripeReceiptCountAggregateOutputType>;
  _max?: Maybe<StripeReceiptMaxAggregateOutputType>;
  _min?: Maybe<StripeReceiptMinAggregateOutputType>;
};

export type AggregateStripeReceiptHistory = {
  __typename?: 'AggregateStripeReceiptHistory';
  _count?: Maybe<StripeReceiptHistoryCountAggregateOutputType>;
  _max?: Maybe<StripeReceiptHistoryMaxAggregateOutputType>;
  _min?: Maybe<StripeReceiptHistoryMinAggregateOutputType>;
};

export type AggregateStripeRefund = {
  __typename?: 'AggregateStripeRefund';
  _avg?: Maybe<StripeRefundAvgAggregateOutputType>;
  _count?: Maybe<StripeRefundCountAggregateOutputType>;
  _max?: Maybe<StripeRefundMaxAggregateOutputType>;
  _min?: Maybe<StripeRefundMinAggregateOutputType>;
  _sum?: Maybe<StripeRefundSumAggregateOutputType>;
};

export type AggregateStripeTerminal = {
  __typename?: 'AggregateStripeTerminal';
  _count?: Maybe<StripeTerminalCountAggregateOutputType>;
  _max?: Maybe<StripeTerminalMaxAggregateOutputType>;
  _min?: Maybe<StripeTerminalMinAggregateOutputType>;
};

export type AggregateStripeTerminalHealthcheck = {
  __typename?: 'AggregateStripeTerminalHealthcheck';
  _count?: Maybe<StripeTerminalHealthcheckCountAggregateOutputType>;
  _max?: Maybe<StripeTerminalHealthcheckMaxAggregateOutputType>;
  _min?: Maybe<StripeTerminalHealthcheckMinAggregateOutputType>;
};

export type AggregateStripeTerminalLocation = {
  __typename?: 'AggregateStripeTerminalLocation';
  _count?: Maybe<StripeTerminalLocationCountAggregateOutputType>;
  _max?: Maybe<StripeTerminalLocationMaxAggregateOutputType>;
  _min?: Maybe<StripeTerminalLocationMinAggregateOutputType>;
};

export type AggregateSurveyAppointmentTypeSetting = {
  __typename?: 'AggregateSurveyAppointmentTypeSetting';
  _avg?: Maybe<SurveyAppointmentTypeSettingAvgAggregateOutputType>;
  _count?: Maybe<SurveyAppointmentTypeSettingCountAggregateOutputType>;
  _max?: Maybe<SurveyAppointmentTypeSettingMaxAggregateOutputType>;
  _min?: Maybe<SurveyAppointmentTypeSettingMinAggregateOutputType>;
  _sum?: Maybe<SurveyAppointmentTypeSettingSumAggregateOutputType>;
};

export type AggregateSurveyResult = {
  __typename?: 'AggregateSurveyResult';
  _avg?: Maybe<SurveyResultAvgAggregateOutputType>;
  _count?: Maybe<SurveyResultCountAggregateOutputType>;
  _max?: Maybe<SurveyResultMaxAggregateOutputType>;
  _min?: Maybe<SurveyResultMinAggregateOutputType>;
  _sum?: Maybe<SurveyResultSumAggregateOutputType>;
};

export type AggregateSurveySetting = {
  __typename?: 'AggregateSurveySetting';
  _avg?: Maybe<SurveySettingAvgAggregateOutputType>;
  _count?: Maybe<SurveySettingCountAggregateOutputType>;
  _max?: Maybe<SurveySettingMaxAggregateOutputType>;
  _min?: Maybe<SurveySettingMinAggregateOutputType>;
  _sum?: Maybe<SurveySettingSumAggregateOutputType>;
};

export type AggregateSyncVetIntegration = {
  __typename?: 'AggregateSyncVetIntegration';
  _count?: Maybe<SyncVetIntegrationCountAggregateOutputType>;
  _max?: Maybe<SyncVetIntegrationMaxAggregateOutputType>;
  _min?: Maybe<SyncVetIntegrationMinAggregateOutputType>;
};

export type AggregateSyncVetService = {
  __typename?: 'AggregateSyncVetService';
  _count?: Maybe<SyncVetServiceCountAggregateOutputType>;
  _max?: Maybe<SyncVetServiceMaxAggregateOutputType>;
  _min?: Maybe<SyncVetServiceMinAggregateOutputType>;
};

export type AggregateSynchronyClinicConfiguration = {
  __typename?: 'AggregateSynchronyClinicConfiguration';
  _count?: Maybe<SynchronyClinicConfigurationCountAggregateOutputType>;
  _max?: Maybe<SynchronyClinicConfigurationMaxAggregateOutputType>;
  _min?: Maybe<SynchronyClinicConfigurationMinAggregateOutputType>;
};

export type AggregateSynchronyEvent = {
  __typename?: 'AggregateSynchronyEvent';
  _count?: Maybe<SynchronyEventCountAggregateOutputType>;
  _max?: Maybe<SynchronyEventMaxAggregateOutputType>;
  _min?: Maybe<SynchronyEventMinAggregateOutputType>;
};

export type AggregateTask = {
  __typename?: 'AggregateTask';
  _count?: Maybe<TaskCountAggregateOutputType>;
  _max?: Maybe<TaskMaxAggregateOutputType>;
  _min?: Maybe<TaskMinAggregateOutputType>;
};

export type AggregateTaxonomy = {
  __typename?: 'AggregateTaxonomy';
  _count?: Maybe<TaxonomyCountAggregateOutputType>;
  _max?: Maybe<TaxonomyMaxAggregateOutputType>;
  _min?: Maybe<TaxonomyMinAggregateOutputType>;
};

export type AggregateTaxonomyToInformAudienceDefinition = {
  __typename?: 'AggregateTaxonomyToInformAudienceDefinition';
  _count?: Maybe<TaxonomyToInformAudienceDefinitionCountAggregateOutputType>;
  _max?: Maybe<TaxonomyToInformAudienceDefinitionMaxAggregateOutputType>;
  _min?: Maybe<TaxonomyToInformAudienceDefinitionMinAggregateOutputType>;
};

export type AggregateTinyUrl = {
  __typename?: 'AggregateTinyUrl';
  _count?: Maybe<TinyUrlCountAggregateOutputType>;
  _max?: Maybe<TinyUrlMaxAggregateOutputType>;
  _min?: Maybe<TinyUrlMinAggregateOutputType>;
};

export type AggregateTransaction = {
  __typename?: 'AggregateTransaction';
  _avg?: Maybe<TransactionAvgAggregateOutputType>;
  _count?: Maybe<TransactionCountAggregateOutputType>;
  _max?: Maybe<TransactionMaxAggregateOutputType>;
  _min?: Maybe<TransactionMinAggregateOutputType>;
  _sum?: Maybe<TransactionSumAggregateOutputType>;
};

export type AggregateTrupanionCertificateAvailability = {
  __typename?: 'AggregateTrupanionCertificateAvailability';
  _avg?: Maybe<TrupanionCertificateAvailabilityAvgAggregateOutputType>;
  _count?: Maybe<TrupanionCertificateAvailabilityCountAggregateOutputType>;
  _max?: Maybe<TrupanionCertificateAvailabilityMaxAggregateOutputType>;
  _min?: Maybe<TrupanionCertificateAvailabilityMinAggregateOutputType>;
  _sum?: Maybe<TrupanionCertificateAvailabilitySumAggregateOutputType>;
};

export type AggregateTrupanionIntegratedAppointmentType = {
  __typename?: 'AggregateTrupanionIntegratedAppointmentType';
  _count?: Maybe<TrupanionIntegratedAppointmentTypeCountAggregateOutputType>;
  _max?: Maybe<TrupanionIntegratedAppointmentTypeMaxAggregateOutputType>;
  _min?: Maybe<TrupanionIntegratedAppointmentTypeMinAggregateOutputType>;
};

export type AggregateTrupanionIntegration = {
  __typename?: 'AggregateTrupanionIntegration';
  _count?: Maybe<TrupanionIntegrationCountAggregateOutputType>;
  _max?: Maybe<TrupanionIntegrationMaxAggregateOutputType>;
  _min?: Maybe<TrupanionIntegrationMinAggregateOutputType>;
};

export type AggregateTwilioCallRecording = {
  __typename?: 'AggregateTwilioCallRecording';
  _avg?: Maybe<TwilioCallRecordingAvgAggregateOutputType>;
  _count?: Maybe<TwilioCallRecordingCountAggregateOutputType>;
  _max?: Maybe<TwilioCallRecordingMaxAggregateOutputType>;
  _min?: Maybe<TwilioCallRecordingMinAggregateOutputType>;
  _sum?: Maybe<TwilioCallRecordingSumAggregateOutputType>;
};

export type AggregateTwilioConfiguration = {
  __typename?: 'AggregateTwilioConfiguration';
  _count?: Maybe<TwilioConfigurationCountAggregateOutputType>;
  _max?: Maybe<TwilioConfigurationMaxAggregateOutputType>;
  _min?: Maybe<TwilioConfigurationMinAggregateOutputType>;
};

export type AggregateTwilioVerification = {
  __typename?: 'AggregateTwilioVerification';
  _count?: Maybe<TwilioVerificationCountAggregateOutputType>;
  _max?: Maybe<TwilioVerificationMaxAggregateOutputType>;
  _min?: Maybe<TwilioVerificationMinAggregateOutputType>;
};

export type AggregateUnlayerSetting = {
  __typename?: 'AggregateUnlayerSetting';
  _avg?: Maybe<UnlayerSettingAvgAggregateOutputType>;
  _count?: Maybe<UnlayerSettingCountAggregateOutputType>;
  _max?: Maybe<UnlayerSettingMaxAggregateOutputType>;
  _min?: Maybe<UnlayerSettingMinAggregateOutputType>;
  _sum?: Maybe<UnlayerSettingSumAggregateOutputType>;
};

export type AggregateUser = {
  __typename?: 'AggregateUser';
  _count?: Maybe<UserCountAggregateOutputType>;
  _max?: Maybe<UserMaxAggregateOutputType>;
  _min?: Maybe<UserMinAggregateOutputType>;
};

export type AggregateUserAppointmentGrouping = {
  __typename?: 'AggregateUserAppointmentGrouping';
  _count?: Maybe<UserAppointmentGroupingCountAggregateOutputType>;
  _max?: Maybe<UserAppointmentGroupingMaxAggregateOutputType>;
  _min?: Maybe<UserAppointmentGroupingMinAggregateOutputType>;
};

export type AggregateUserBoardFilter = {
  __typename?: 'AggregateUserBoardFilter';
  _count?: Maybe<UserBoardFilterCountAggregateOutputType>;
  _max?: Maybe<UserBoardFilterMaxAggregateOutputType>;
  _min?: Maybe<UserBoardFilterMinAggregateOutputType>;
};

export type AggregateUserChannelFilterSelection = {
  __typename?: 'AggregateUserChannelFilterSelection';
  _count?: Maybe<UserChannelFilterSelectionCountAggregateOutputType>;
  _max?: Maybe<UserChannelFilterSelectionMaxAggregateOutputType>;
  _min?: Maybe<UserChannelFilterSelectionMinAggregateOutputType>;
};

export type AggregateUserImpersonation = {
  __typename?: 'AggregateUserImpersonation';
  _count?: Maybe<UserImpersonationCountAggregateOutputType>;
  _max?: Maybe<UserImpersonationMaxAggregateOutputType>;
  _min?: Maybe<UserImpersonationMinAggregateOutputType>;
};

export type AggregateUserNotificationSetting = {
  __typename?: 'AggregateUserNotificationSetting';
  _count?: Maybe<UserNotificationSettingCountAggregateOutputType>;
  _max?: Maybe<UserNotificationSettingMaxAggregateOutputType>;
  _min?: Maybe<UserNotificationSettingMinAggregateOutputType>;
};

export type AggregateUserSetting = {
  __typename?: 'AggregateUserSetting';
  _count?: Maybe<UserSettingCountAggregateOutputType>;
  _max?: Maybe<UserSettingMaxAggregateOutputType>;
  _min?: Maybe<UserSettingMinAggregateOutputType>;
};

export type AggregateUserTaskList = {
  __typename?: 'AggregateUserTaskList';
  _count?: Maybe<UserTaskListCountAggregateOutputType>;
  _max?: Maybe<UserTaskListMaxAggregateOutputType>;
  _min?: Maybe<UserTaskListMinAggregateOutputType>;
};

export type AggregateUserTaskListFilter = {
  __typename?: 'AggregateUserTaskListFilter';
  _count?: Maybe<UserTaskListFilterCountAggregateOutputType>;
  _max?: Maybe<UserTaskListFilterMaxAggregateOutputType>;
  _min?: Maybe<UserTaskListFilterMinAggregateOutputType>;
};

export type AggregateVaccination = {
  __typename?: 'AggregateVaccination';
  _count?: Maybe<VaccinationCountAggregateOutputType>;
  _max?: Maybe<VaccinationMaxAggregateOutputType>;
  _min?: Maybe<VaccinationMinAggregateOutputType>;
};

export type AggregateVetAvailability = {
  __typename?: 'AggregateVetAvailability';
  _count?: Maybe<VetAvailabilityCountAggregateOutputType>;
  _max?: Maybe<VetAvailabilityMaxAggregateOutputType>;
  _min?: Maybe<VetAvailabilityMinAggregateOutputType>;
};

export type AggregateVetAvailabilityClinicRoomMap = {
  __typename?: 'AggregateVetAvailabilityClinicRoomMap';
  _count?: Maybe<VetAvailabilityClinicRoomMapCountAggregateOutputType>;
  _max?: Maybe<VetAvailabilityClinicRoomMapMaxAggregateOutputType>;
  _min?: Maybe<VetAvailabilityClinicRoomMapMinAggregateOutputType>;
};

export type AggregateVetAvailabilityMap = {
  __typename?: 'AggregateVetAvailabilityMap';
  _count?: Maybe<VetAvailabilityMapCountAggregateOutputType>;
  _max?: Maybe<VetAvailabilityMapMaxAggregateOutputType>;
  _min?: Maybe<VetAvailabilityMapMinAggregateOutputType>;
};

export type AggregateVetDataIntegration = {
  __typename?: 'AggregateVetDataIntegration';
  _count?: Maybe<VetDataIntegrationCountAggregateOutputType>;
  _max?: Maybe<VetDataIntegrationMaxAggregateOutputType>;
  _min?: Maybe<VetDataIntegrationMinAggregateOutputType>;
};

export type AggregateVetInfo = {
  __typename?: 'AggregateVetInfo';
  _count?: Maybe<VetInfoCountAggregateOutputType>;
  _max?: Maybe<VetInfoMaxAggregateOutputType>;
  _min?: Maybe<VetInfoMinAggregateOutputType>;
};

export type AggregateVetLicense = {
  __typename?: 'AggregateVetLicense';
  _count?: Maybe<VetLicenseCountAggregateOutputType>;
  _max?: Maybe<VetLicenseMaxAggregateOutputType>;
  _min?: Maybe<VetLicenseMinAggregateOutputType>;
};

export type AggregateVetsourceCodeTag = {
  __typename?: 'AggregateVetsourceCodeTag';
  _avg?: Maybe<VetsourceCodeTagAvgAggregateOutputType>;
  _count?: Maybe<VetsourceCodeTagCountAggregateOutputType>;
  _max?: Maybe<VetsourceCodeTagMaxAggregateOutputType>;
  _min?: Maybe<VetsourceCodeTagMinAggregateOutputType>;
  _sum?: Maybe<VetsourceCodeTagSumAggregateOutputType>;
};

export type AggregateVetsourceInstallation = {
  __typename?: 'AggregateVetsourceInstallation';
  _count?: Maybe<VetsourceInstallationCountAggregateOutputType>;
  _max?: Maybe<VetsourceInstallationMaxAggregateOutputType>;
  _min?: Maybe<VetsourceInstallationMinAggregateOutputType>;
};

export type AggregateVetsourcePharmacyIntegration = {
  __typename?: 'AggregateVetsourcePharmacyIntegration';
  _count?: Maybe<VetsourcePharmacyIntegrationCountAggregateOutputType>;
  _max?: Maybe<VetsourcePharmacyIntegrationMaxAggregateOutputType>;
  _min?: Maybe<VetsourcePharmacyIntegrationMinAggregateOutputType>;
};

export type AggregateVetsourceRevenueCategory = {
  __typename?: 'AggregateVetsourceRevenueCategory';
  _avg?: Maybe<VetsourceRevenueCategoryAvgAggregateOutputType>;
  _count?: Maybe<VetsourceRevenueCategoryCountAggregateOutputType>;
  _max?: Maybe<VetsourceRevenueCategoryMaxAggregateOutputType>;
  _min?: Maybe<VetsourceRevenueCategoryMinAggregateOutputType>;
  _sum?: Maybe<VetsourceRevenueCategorySumAggregateOutputType>;
};

export type AggregateVetterIntegration = {
  __typename?: 'AggregateVetterIntegration';
  _count?: Maybe<VetterIntegrationCountAggregateOutputType>;
  _max?: Maybe<VetterIntegrationMaxAggregateOutputType>;
  _min?: Maybe<VetterIntegrationMinAggregateOutputType>;
};

export type AggregateWorkflowEventAction = {
  __typename?: 'AggregateWorkflowEventAction';
  _avg?: Maybe<WorkflowEventActionAvgAggregateOutputType>;
  _count?: Maybe<WorkflowEventActionCountAggregateOutputType>;
  _max?: Maybe<WorkflowEventActionMaxAggregateOutputType>;
  _min?: Maybe<WorkflowEventActionMinAggregateOutputType>;
  _sum?: Maybe<WorkflowEventActionSumAggregateOutputType>;
};

export type AggregateWorkflowEventSetting = {
  __typename?: 'AggregateWorkflowEventSetting';
  _avg?: Maybe<WorkflowEventSettingAvgAggregateOutputType>;
  _count?: Maybe<WorkflowEventSettingCountAggregateOutputType>;
  _max?: Maybe<WorkflowEventSettingMaxAggregateOutputType>;
  _min?: Maybe<WorkflowEventSettingMinAggregateOutputType>;
  _sum?: Maybe<WorkflowEventSettingSumAggregateOutputType>;
};

export type AggregateWorkflowTrigger = {
  __typename?: 'AggregateWorkflowTrigger';
  _count?: Maybe<WorkflowTriggerCountAggregateOutputType>;
  _max?: Maybe<WorkflowTriggerMaxAggregateOutputType>;
  _min?: Maybe<WorkflowTriggerMinAggregateOutputType>;
};

export enum AiConverseRole {
  Assistant = 'assistant',
  User = 'user'
}

export type AiRecapPimsWritebackLogEntry = {
  __typename?: 'AiRecapPimsWritebackLogEntry';
  appointment: Appointment;
  appointmentId: Scalars['String'];
  writebackLog: PimsWritebackLogEntry;
  writebackLogId: Scalars['String'];
};

export type AiRecapPimsWritebackLogEntryCountAggregateOutputType = {
  __typename?: 'AiRecapPimsWritebackLogEntryCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentId: Scalars['Int'];
  writebackLogId: Scalars['Int'];
};

export type AiRecapPimsWritebackLogEntryCountOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type AiRecapPimsWritebackLogEntryCreateInput = {
  appointment: AppointmentCreateNestedOneWithoutAiRecapPimsWritebackLogEntryInput;
  writebackLog: PimsWritebackLogEntryCreateNestedOneWithoutAiRecapPimsWritebackLogEntryInput;
};

export type AiRecapPimsWritebackLogEntryCreateManyAppointmentInput = {
  writebackLogId: Scalars['String'];
};

export type AiRecapPimsWritebackLogEntryCreateManyAppointmentInputEnvelope = {
  data: Array<AiRecapPimsWritebackLogEntryCreateManyAppointmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AiRecapPimsWritebackLogEntryCreateManyInput = {
  appointmentId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AiRecapPimsWritebackLogEntryCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<AiRecapPimsWritebackLogEntryCreateWithoutAppointmentInput>>;
  createMany?: Maybe<AiRecapPimsWritebackLogEntryCreateManyAppointmentInputEnvelope>;
};

export type AiRecapPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput = {
  connect?: Maybe<AiRecapPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<AiRecapPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<AiRecapPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
};

export type AiRecapPimsWritebackLogEntryCreateOrConnectWithoutAppointmentInput = {
  create: AiRecapPimsWritebackLogEntryCreateWithoutAppointmentInput;
  where: AiRecapPimsWritebackLogEntryWhereUniqueInput;
};

export type AiRecapPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput = {
  create: AiRecapPimsWritebackLogEntryCreateWithoutWritebackLogInput;
  where: AiRecapPimsWritebackLogEntryWhereUniqueInput;
};

export type AiRecapPimsWritebackLogEntryCreateWithoutAppointmentInput = {
  writebackLog: PimsWritebackLogEntryCreateNestedOneWithoutAiRecapPimsWritebackLogEntryInput;
};

export type AiRecapPimsWritebackLogEntryCreateWithoutWritebackLogInput = {
  appointment: AppointmentCreateNestedOneWithoutAiRecapPimsWritebackLogEntryInput;
};

export type AiRecapPimsWritebackLogEntryGroupByOutputType = {
  __typename?: 'AiRecapPimsWritebackLogEntryGroupByOutputType';
  _count?: Maybe<AiRecapPimsWritebackLogEntryCountAggregateOutputType>;
  _max?: Maybe<AiRecapPimsWritebackLogEntryMaxAggregateOutputType>;
  _min?: Maybe<AiRecapPimsWritebackLogEntryMinAggregateOutputType>;
  appointmentId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type AiRecapPimsWritebackLogEntryListRelationFilter = {
  every?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
  none?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
  some?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
};

export type AiRecapPimsWritebackLogEntryMaxAggregateOutputType = {
  __typename?: 'AiRecapPimsWritebackLogEntryMaxAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type AiRecapPimsWritebackLogEntryMaxOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type AiRecapPimsWritebackLogEntryMinAggregateOutputType = {
  __typename?: 'AiRecapPimsWritebackLogEntryMinAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type AiRecapPimsWritebackLogEntryMinOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type AiRecapPimsWritebackLogEntryNullableScalarRelationFilter = {
  AND?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereInput>>;
  appointment?: Maybe<AppointmentScalarRelationFilter>;
  appointmentId?: Maybe<StringFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type AiRecapPimsWritebackLogEntryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type AiRecapPimsWritebackLogEntryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AiRecapPimsWritebackLogEntryOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export enum AiRecapPimsWritebackLogEntryOrderByRelevanceFieldEnum {
  AppointmentId = 'appointmentId',
  WritebackLogId = 'writebackLogId'
}

export type AiRecapPimsWritebackLogEntryOrderByRelevanceInput = {
  fields: Array<AiRecapPimsWritebackLogEntryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type AiRecapPimsWritebackLogEntryOrderByWithAggregationInput = {
  _count?: Maybe<AiRecapPimsWritebackLogEntryCountOrderByAggregateInput>;
  _max?: Maybe<AiRecapPimsWritebackLogEntryMaxOrderByAggregateInput>;
  _min?: Maybe<AiRecapPimsWritebackLogEntryMinOrderByAggregateInput>;
  appointmentId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type AiRecapPimsWritebackLogEntryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AiRecapPimsWritebackLogEntryOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export type AiRecapPimsWritebackLogEntryOrderByWithRelationInput = {
  _relevance?: Maybe<AiRecapPimsWritebackLogEntryOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export enum AiRecapPimsWritebackLogEntryScalarFieldEnum {
  AppointmentId = 'appointmentId',
  WritebackLogId = 'writebackLogId'
}

export type AiRecapPimsWritebackLogEntryScalarWhereInput = {
  AND?: Maybe<Array<AiRecapPimsWritebackLogEntryScalarWhereInput>>;
  NOT?: Maybe<Array<AiRecapPimsWritebackLogEntryScalarWhereInput>>;
  OR?: Maybe<Array<AiRecapPimsWritebackLogEntryScalarWhereInput>>;
  appointmentId?: Maybe<StringFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type AiRecapPimsWritebackLogEntryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<AiRecapPimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<AiRecapPimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<AiRecapPimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  appointmentId?: Maybe<StringWithAggregatesFilter>;
  writebackLogId?: Maybe<StringWithAggregatesFilter>;
};

export type AiRecapPimsWritebackLogEntryUncheckedCreateInput = {
  appointmentId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AiRecapPimsWritebackLogEntryCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<AiRecapPimsWritebackLogEntryCreateWithoutAppointmentInput>>;
  createMany?: Maybe<AiRecapPimsWritebackLogEntryCreateManyAppointmentInputEnvelope>;
};

export type AiRecapPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput = {
  connect?: Maybe<AiRecapPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<AiRecapPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<AiRecapPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
};

export type AiRecapPimsWritebackLogEntryUncheckedCreateWithoutAppointmentInput = {
  writebackLogId: Scalars['String'];
};

export type AiRecapPimsWritebackLogEntryUncheckedCreateWithoutWritebackLogInput = {
  appointmentId: Scalars['String'];
};

export type AiRecapPimsWritebackLogEntryUncheckedUpdateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type AiRecapPimsWritebackLogEntryUncheckedUpdateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentInput = {
  writebackLogId?: Maybe<Scalars['String']>;
};

export type AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AiRecapPimsWritebackLogEntryCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<AiRecapPimsWritebackLogEntryCreateWithoutAppointmentInput>>;
  createMany?: Maybe<AiRecapPimsWritebackLogEntryCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AiRecapPimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<AiRecapPimsWritebackLogEntryUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<AiRecapPimsWritebackLogEntryUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<AiRecapPimsWritebackLogEntryUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type AiRecapPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput = {
  connect?: Maybe<AiRecapPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<AiRecapPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<AiRecapPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
  delete?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
  disconnect?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
  update?: Maybe<AiRecapPimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput>;
  upsert?: Maybe<AiRecapPimsWritebackLogEntryUpsertWithoutWritebackLogInput>;
};

export type AiRecapPimsWritebackLogEntryUncheckedUpdateWithoutAppointmentInput = {
  writebackLogId?: Maybe<Scalars['String']>;
};

export type AiRecapPimsWritebackLogEntryUncheckedUpdateWithoutWritebackLogInput = {
  appointmentId?: Maybe<Scalars['String']>;
};

export type AiRecapPimsWritebackLogEntryUpdateInput = {
  appointment?: Maybe<AppointmentUpdateOneRequiredWithoutAiRecapPimsWritebackLogEntryNestedInput>;
  writebackLog?: Maybe<PimsWritebackLogEntryUpdateOneRequiredWithoutAiRecapPimsWritebackLogEntryNestedInput>;
};

export type AiRecapPimsWritebackLogEntryUpdateManyMutationInput = {
  appointmentId?: Maybe<StringNullableFilter>;
  writebackLogId?: Maybe<StringNullableFilter>;
};

export type AiRecapPimsWritebackLogEntryUpdateManyWithWhereWithoutAppointmentInput = {
  data: AiRecapPimsWritebackLogEntryUpdateManyMutationInput;
  where: AiRecapPimsWritebackLogEntryScalarWhereInput;
};

export type AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AiRecapPimsWritebackLogEntryCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<AiRecapPimsWritebackLogEntryCreateWithoutAppointmentInput>>;
  createMany?: Maybe<AiRecapPimsWritebackLogEntryCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AiRecapPimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<AiRecapPimsWritebackLogEntryUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<AiRecapPimsWritebackLogEntryUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<AiRecapPimsWritebackLogEntryUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type AiRecapPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput = {
  connect?: Maybe<AiRecapPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<AiRecapPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<AiRecapPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AiRecapPimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput>;
  upsert?: Maybe<AiRecapPimsWritebackLogEntryUpsertWithoutWritebackLogInput>;
};

export type AiRecapPimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput = {
  data: AiRecapPimsWritebackLogEntryUpdateWithoutWritebackLogInput;
  where?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
};

export type AiRecapPimsWritebackLogEntryUpdateWithWhereUniqueWithoutAppointmentInput = {
  data: AiRecapPimsWritebackLogEntryUpdateWithoutAppointmentInput;
  where: AiRecapPimsWritebackLogEntryWhereUniqueInput;
};

export type AiRecapPimsWritebackLogEntryUpdateWithoutAppointmentInput = {
  writebackLog?: Maybe<PimsWritebackLogEntryUpdateOneRequiredWithoutAiRecapPimsWritebackLogEntryNestedInput>;
};

export type AiRecapPimsWritebackLogEntryUpdateWithoutWritebackLogInput = {
  appointment?: Maybe<AppointmentUpdateOneRequiredWithoutAiRecapPimsWritebackLogEntryNestedInput>;
};

export type AiRecapPimsWritebackLogEntryUpsertWithWhereUniqueWithoutAppointmentInput = {
  create: AiRecapPimsWritebackLogEntryCreateWithoutAppointmentInput;
  update: AiRecapPimsWritebackLogEntryUpdateWithoutAppointmentInput;
  where: AiRecapPimsWritebackLogEntryWhereUniqueInput;
};

export type AiRecapPimsWritebackLogEntryUpsertWithoutWritebackLogInput = {
  create: AiRecapPimsWritebackLogEntryCreateWithoutWritebackLogInput;
  update: AiRecapPimsWritebackLogEntryUpdateWithoutWritebackLogInput;
  where?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
};

export type AiRecapPimsWritebackLogEntryWhereInput = {
  AND?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereInput>>;
  appointment?: Maybe<AppointmentScalarRelationFilter>;
  appointmentId?: Maybe<StringFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type AiRecapPimsWritebackLogEntryWhereUniqueInput = {
  AND?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<AiRecapPimsWritebackLogEntryWhereInput>>;
  appointment?: Maybe<AppointmentScalarRelationFilter>;
  appointmentId?: Maybe<StringFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<Scalars['String']>;
  writebackLogId_appointmentId?: Maybe<AiRecapPimsWritebackLogEntryWritebackLogIdAppointmentIdCompoundUniqueInput>;
};

export type AiRecapPimsWritebackLogEntryWritebackLogIdAppointmentIdCompoundUniqueInput = {
  appointmentId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export enum AmericanKennelClubBreedGroup {
  FoundationStockService = 'FOUNDATION_STOCK_SERVICE',
  HerdingGroup = 'HERDING_GROUP',
  HoundGroup = 'HOUND_GROUP',
  MiscellaneousClass = 'MISCELLANEOUS_CLASS',
  NonSportingGroup = 'NON_SPORTING_GROUP',
  SportingGroup = 'SPORTING_GROUP',
  TerrierGroup = 'TERRIER_GROUP',
  WorkingGroup = 'WORKING_GROUP'
}

export enum AmericanKennelClubBreedTemperament {
  Active = 'ACTIVE',
  Adaptable = 'ADAPTABLE',
  Adventurous = 'ADVENTUROUS',
  Affectionate = 'AFFECTIONATE',
  Agile = 'AGILE',
  Alert = 'ALERT',
  AlertAndIntelligent = 'ALERT_AND_INTELLIGENT',
  Amiable = 'AMIABLE',
  Amusing = 'AMUSING',
  Aristocratic = 'ARISTOCRATIC',
  Athletic = 'ATHLETIC',
  Attentive = 'ATTENTIVE',
  Boisterous = 'BOISTEROUS',
  Bold = 'BOLD',
  Bouncy = 'BOUNCY',
  Brave = 'BRAVE',
  Bright = 'BRIGHT',
  Busy = 'BUSY',
  Calm = 'CALM',
  Canny = 'CANNY',
  Charismatic = 'CHARISMATIC',
  Charming = 'CHARMING',
  Cheerful = 'CHEERFUL',
  Clever = 'CLEVER',
  Comical = 'COMICAL',
  Confident = 'CONFIDENT',
  ConfidentGuardian = 'CONFIDENT_GUARDIAN',
  Courageous = 'COURAGEOUS',
  Courteous = 'COURTEOUS',
  Curious = 'CURIOUS',
  Dashing = 'DASHING',
  DeeplyAffectionate = 'DEEPLY_AFFECTIONATE',
  DeeplyDevoted = 'DEEPLY_DEVOTED',
  Dependable = 'DEPENDABLE',
  Determined = 'DETERMINED',
  Devoted = 'DEVOTED',
  Dignified = 'DIGNIFIED',
  Docile = 'DOCILE',
  Eager = 'EAGER',
  EagerToPlease = 'EAGER_TO_PLEASE',
  EasyGoing = 'EASY_GOING',
  Energetic = 'ENERGETIC',
  Entertaining = 'ENTERTAINING',
  Enthusiastic = 'ENTHUSIASTIC',
  EvenTempered = 'EVEN_TEMPERED',
  Exuberant = 'EXUBERANT',
  Faithful = 'FAITHFUL',
  FamilyOriented = 'FAMILY_ORIENTED',
  FamouslyFunny = 'FAMOUSLY_FUNNY',
  Fearless = 'FEARLESS',
  Friendly = 'FRIENDLY',
  Frollicking = 'FROLLICKING',
  Funny = 'FUNNY',
  FunLoving = 'FUN_LOVING',
  Gentle = 'GENTLE',
  Gentlemanly = 'GENTLEMANLY',
  GoodHumored = 'GOOD_HUMORED',
  GoodNatured = 'GOOD_NATURED',
  GoodTempered = 'GOOD_TEMPERED',
  Graceful = 'GRACEFUL',
  Gregarious = 'GREGARIOUS',
  Happy = 'HAPPY',
  HappyGoLucky = 'HAPPY_GO_LUCKY',
  Hardworking = 'HARDWORKING',
  HomeLoving = 'HOME_LOVING',
  Humble = 'HUMBLE',
  Independent = 'INDEPENDENT',
  IndependentMinded = 'INDEPENDENT_MINDED',
  Inquisitive = 'INQUISITIVE',
  Intelligent = 'INTELLIGENT',
  Keen = 'KEEN',
  KeenlyAlert = 'KEENLY_ALERT',
  KeenlyObservant = 'KEENLY_OBSERVANT',
  Kind = 'KIND',
  Lively = 'LIVELY',
  Lovable = 'LOVABLE',
  Loving = 'LOVING',
  LowKey = 'LOW_KEY',
  Loyal = 'LOYAL',
  Majestic = 'MAJESTIC',
  Mellow = 'MELLOW',
  Merry = 'MERRY',
  Mischievous = 'MISCHIEVOUS',
  Noble = 'NOBLE',
  Obedient = 'OBEDIENT',
  Observant = 'OBSERVANT',
  Optimistic = 'OPTIMISTIC',
  Outgoing = 'OUTGOING',
  Patient = 'PATIENT',
  PeopleOriented = 'PEOPLE_ORIENTED',
  Peppy = 'PEPPY',
  Perceptive = 'PERCEPTIVE',
  Perky = 'PERKY',
  Playful = 'PLAYFUL',
  PlayfulButAlsoWorkOrientedVeryActiveAndUpbeat = 'PLAYFUL_BUT_ALSO_WORK_ORIENTED_VERY_ACTIVE_AND_UPBEAT',
  Pleasant = 'PLEASANT',
  Plucky = 'PLUCKY',
  Poised = 'POISED',
  Polite = 'POLITE',
  Positive = 'POSITIVE',
  Powerful = 'POWERFUL',
  ProfoundlyLoyal = 'PROFOUNDLY_LOYAL',
  Proud = 'PROUD',
  Quick = 'QUICK',
  ReadyToWork = 'READY_TO_WORK',
  Regal = 'REGAL',
  RegallyDignified = 'REGALLY_DIGNIFIED',
  RegalInManner = 'REGAL_IN_MANNER',
  Reserved = 'RESERVED',
  ReservedWithStrangers = 'RESERVED_WITH_STRANGERS',
  Responsive = 'RESPONSIVE',
  Sassy = 'SASSY',
  SelfConfident = 'SELF_CONFIDENT',
  SenseOfHumor = 'SENSE_OF_HUMOR',
  Sensitive = 'SENSITIVE',
  SeriousMinded = 'SERIOUS_MINDED',
  Smart = 'SMART',
  Sociable = 'SOCIABLE',
  Spirited = 'SPIRITED',
  Sprightly = 'SPRIGHTLY',
  Spunky = 'SPUNKY',
  Strong = 'STRONG',
  StrongWilled = 'STRONG_WILLED',
  Sweet = 'SWEET',
  SweetNatured = 'SWEET_NATURED',
  SweetTempered = 'SWEET_TEMPERED',
  Tenacious = 'TENACIOUS',
  Tenderhearted = 'TENDERHEARTED',
  Tomboyish = 'TOMBOYISH',
  Trainable = 'TRAINABLE',
  Undemanding = 'UNDEMANDING',
  Upbeat = 'UPBEAT',
  Versatile = 'VERSATILE',
  VerySmart = 'VERY_SMART',
  Vigilant = 'VIGILANT',
  Vivacious = 'VIVACIOUS',
  Watchful = 'WATCHFUL',
  WickedlySmart = 'WICKEDLY_SMART',
  WillingToPlease = 'WILLING_TO_PLEASE',
  WorkOriented = 'WORK_ORIENTED'
}

export enum AmericanKennelClubDemeanorCategory {
  AlertResponsive = 'ALERT_RESPONSIVE',
  AloofWary = 'ALOOF_WARY',
  Friendly = 'FRIENDLY',
  Outgoing = 'OUTGOING',
  ReservedWithStrangers = 'RESERVED_WITH_STRANGERS'
}

export enum AmericanKennelClubEnergyLevelCategory {
  Calm = 'CALM',
  CouchPotato = 'COUCH_POTATO',
  Energetic = 'ENERGETIC',
  NeedsLotsOfActivity = 'NEEDS_LOTS_OF_ACTIVITY',
  RegularExercise = 'REGULAR_EXERCISE'
}

export enum AmericanKennelClubGroomingFrequencyCategory {
  DailyBrushing = 'DAILY_BRUSHING',
  OccasionalBathBrush = 'OCCASIONAL_BATH_BRUSH',
  SpecialtyProfessional = 'SPECIALTY_PROFESSIONAL',
  TwoToThreeTimesPerWeekBrushing = 'TWO_TO_THREE_TIMES_PER_WEEK_BRUSHING',
  WeeklyBrushing = 'WEEKLY_BRUSHING'
}

export enum AmericanKennelClubSheddingCategory {
  Frequent = 'FREQUENT',
  Infrequent = 'INFREQUENT',
  Occasional = 'OCCASIONAL',
  Regularly = 'REGULARLY',
  Seasonal = 'SEASONAL'
}

export enum AmericanKennelClubTrainabilityCategory {
  Agreeable = 'AGREEABLE',
  EagerToPlease = 'EAGER_TO_PLEASE',
  EasyTraining = 'EASY_TRAINING',
  Independent = 'INDEPENDENT',
  MayBeStubborn = 'MAY_BE_STUBBORN'
}

export type ApiKey = {
  __typename?: 'ApiKey';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationType?: Maybe<IntegrationType>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ApiKeyCountAggregateOutputType = {
  __typename?: 'ApiKeyCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  integrationType: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ApiKeyCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ApiKeyCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationType?: Maybe<IntegrationType>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ApiKeyCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationType?: Maybe<IntegrationType>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ApiKeyGroupByOutputType = {
  __typename?: 'ApiKeyGroupByOutputType';
  _count?: Maybe<ApiKeyCountAggregateOutputType>;
  _max?: Maybe<ApiKeyMaxAggregateOutputType>;
  _min?: Maybe<ApiKeyMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationType?: Maybe<IntegrationType>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ApiKeyMaxAggregateOutputType = {
  __typename?: 'ApiKeyMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationType?: Maybe<IntegrationType>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ApiKeyMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ApiKeyMinAggregateOutputType = {
  __typename?: 'ApiKeyMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationType?: Maybe<IntegrationType>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ApiKeyMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ApiKeyOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ApiKeyOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ApiKeyOrderByRelevanceFieldEnum {
  Id = 'id',
  Name = 'name'
}

export type ApiKeyOrderByRelevanceInput = {
  fields: Array<ApiKeyOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ApiKeyOrderByWithAggregationInput = {
  _count?: Maybe<ApiKeyCountOrderByAggregateInput>;
  _max?: Maybe<ApiKeyMaxOrderByAggregateInput>;
  _min?: Maybe<ApiKeyMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ApiKeyOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ApiKeyOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ApiKeyOrderByWithRelationInput = {
  _relevance?: Maybe<ApiKeyOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ApiKeyScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IntegrationType = 'integrationType',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type ApiKeyScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ApiKeyScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ApiKeyScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ApiKeyScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationType?: Maybe<EnumIntegrationTypeNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ApiKeyUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationType?: Maybe<IntegrationType>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ApiKeyUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationType?: Maybe<IntegrationType>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ApiKeyUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationType?: Maybe<IntegrationType>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ApiKeyUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationType?: Maybe<IntegrationType>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ApiKeyUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationType?: Maybe<IntegrationType>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ApiKeyWhereInput = {
  AND?: Maybe<Array<ApiKeyWhereInput>>;
  NOT?: Maybe<Array<ApiKeyWhereInput>>;
  OR?: Maybe<Array<ApiKeyWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationType?: Maybe<EnumIntegrationTypeNullableFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ApiKeyWhereUniqueInput = {
  AND?: Maybe<Array<ApiKeyWhereInput>>;
  NOT?: Maybe<Array<ApiKeyWhereInput>>;
  OR?: Maybe<Array<ApiKeyWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  integrationType?: Maybe<EnumIntegrationTypeNullableFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Appointment = {
  __typename?: 'Appointment';
  _count: AppointmentCountOutputType;
  aiRecapPimsWritebackLogEntry: Array<AiRecapPimsWritebackLogEntry>;
  appointmentType?: Maybe<AppointmentType>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns: Array<AutomationRun>;
  channel?: Maybe<Channel>;
  channelAutomationStatuses: Array<ChannelAutomationStatus>;
  channelId?: Maybe<Scalars['String']>;
  clinic?: Maybe<Clinic>;
  clinicEmployees: Array<ClinicEmployee>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents: Array<ClinicPetParent>;
  /** Deprecated: use pimsExportConsultationId for Conversation Exports */
  consultation?: Maybe<Consultation>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequest>;
  durationInMinutes: Scalars['Int'];
  formSubmissions: Array<FormSubmission>;
  hash?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments: Array<MassTextAlertEntryAppointment>;
  /** Replacement for consultation_id for Conversation Exports */
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs: Array<PushNotificationLog>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<User>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps: Array<Recap>;
  room?: Maybe<ClinicRoom>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status: AppointmentStatus;
  surveyResults: Array<SurveyResult>;
  tasks: Array<Task>;
  taxonomy?: Maybe<Taxonomy>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  workflow?: Maybe<WorkflowType>;
  workflowTriggers: Array<WorkflowTrigger>;
  workflows: Array<WorkflowEventSetting>;
};


export type AppointmentAiRecapPimsWritebackLogEntryArgs = {
  cursor?: Maybe<AiRecapPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AiRecapPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AiRecapPimsWritebackLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
};


export type AppointmentAppointmentTypeArgs = {
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type AppointmentAutomationRunsArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type AppointmentChannelArgs = {
  where?: Maybe<ChannelWhereInput>;
};


export type AppointmentChannelAutomationStatusesArgs = {
  cursor?: Maybe<ChannelAutomationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelAutomationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelAutomationStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type AppointmentClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type AppointmentClinicEmployeesArgs = {
  cursor?: Maybe<ClinicEmployeeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type AppointmentClinicPetArgs = {
  where?: Maybe<ClinicPetWhereInput>;
};


export type AppointmentClinicPetParentsArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type AppointmentConsultationArgs = {
  where?: Maybe<ConsultationWhereInput>;
};


export type AppointmentDirectBookingWidgetRequestArgs = {
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type AppointmentFormSubmissionsArgs = {
  cursor?: Maybe<FormSubmissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormSubmissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormSubmissionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormSubmissionWhereInput>;
};


export type AppointmentIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type AppointmentMassTextAlertEntryAppointmentsArgs = {
  cursor?: Maybe<MassTextAlertEntryAppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertEntryAppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertEntryAppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertEntryAppointmentWhereInput>;
};


export type AppointmentPushNotificationLogsArgs = {
  cursor?: Maybe<PushNotificationLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PushNotificationLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PushNotificationLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PushNotificationLogWhereInput>;
};


export type AppointmentRecapNotesUpdatedByArgs = {
  where?: Maybe<UserWhereInput>;
};


export type AppointmentRecapsArgs = {
  cursor?: Maybe<RecapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<RecapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<RecapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RecapWhereInput>;
};


export type AppointmentRoomArgs = {
  where?: Maybe<ClinicRoomWhereInput>;
};


export type AppointmentSurveyResultsArgs = {
  cursor?: Maybe<SurveyResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveyResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveyResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyResultWhereInput>;
};


export type AppointmentTasksArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaskScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaskOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaskWhereInput>;
};


export type AppointmentTaxonomyArgs = {
  where?: Maybe<TaxonomyWhereInput>;
};


export type AppointmentWorkflowTriggersArgs = {
  cursor?: Maybe<WorkflowTriggerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowTriggerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowTriggerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowTriggerWhereInput>;
};


export type AppointmentWorkflowsArgs = {
  cursor?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type AppointmentAppointmentPimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type AppointmentAvailability = {
  __typename?: 'AppointmentAvailability';
  availabilities: Array<Scalars['DateTime']>;
  clinic?: Maybe<Clinic>;
  clinicEmployee?: Maybe<ClinicEmployee>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  room?: Maybe<ClinicRoom>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type AppointmentAvailabilityClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type AppointmentAvailabilityClinicEmployeeArgs = {
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type AppointmentAvailabilityIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type AppointmentAvailabilityRoomArgs = {
  where?: Maybe<ClinicRoomWhereInput>;
};

export type AppointmentAvailabilityAvailabilityPimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type AppointmentAvailabilityCountAggregateOutputType = {
  __typename?: 'AppointmentAvailabilityCountAggregateOutputType';
  _all: Scalars['Int'];
  availabilities: Scalars['Int'];
  clinicEmployeeId: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isProvider: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  roomId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type AppointmentAvailabilityCountOrderByAggregateInput = {
  availabilities?: Maybe<SortOrder>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isProvider?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AppointmentAvailabilityCreateInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentAvailabilitiesInput>;
  clinicEmployee?: Maybe<ClinicEmployeeCreateNestedOneWithoutAppointmentAvailabilitiesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAvailabilitiesInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentAvailabilityInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityCreateManyClinicEmployeeInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityCreateManyClinicEmployeeInputEnvelope = {
  data: Array<AppointmentAvailabilityCreateManyClinicEmployeeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentAvailabilityCreateManyClinicInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityCreateManyClinicInputEnvelope = {
  data: Array<AppointmentAvailabilityCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentAvailabilityCreateManyInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityCreateManyIntegrationInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityCreateManyIntegrationInputEnvelope = {
  data: Array<AppointmentAvailabilityCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentAvailabilityCreateManyRoomInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityCreateManyRoomInputEnvelope = {
  data: Array<AppointmentAvailabilityCreateManyRoomInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyClinicEmployeeInputEnvelope>;
};

export type AppointmentAvailabilityCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyClinicInputEnvelope>;
};

export type AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutIntegrationInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyIntegrationInputEnvelope>;
};

export type AppointmentAvailabilityCreateNestedManyWithoutRoomInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutRoomInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutRoomInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyRoomInputEnvelope>;
};

export type AppointmentAvailabilityCreateOrConnectWithoutClinicEmployeeInput = {
  create: AppointmentAvailabilityCreateWithoutClinicEmployeeInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};

export type AppointmentAvailabilityCreateOrConnectWithoutClinicInput = {
  create: AppointmentAvailabilityCreateWithoutClinicInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};

export type AppointmentAvailabilityCreateOrConnectWithoutIntegrationInput = {
  create: AppointmentAvailabilityCreateWithoutIntegrationInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};

export type AppointmentAvailabilityCreateOrConnectWithoutRoomInput = {
  create: AppointmentAvailabilityCreateWithoutRoomInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};

export type AppointmentAvailabilityCreateWithoutClinicEmployeeInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentAvailabilitiesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAvailabilitiesInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentAvailabilityInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityCreateWithoutClinicInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployee?: Maybe<ClinicEmployeeCreateNestedOneWithoutAppointmentAvailabilitiesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAvailabilitiesInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentAvailabilityInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityCreateWithoutIntegrationInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentAvailabilitiesInput>;
  clinicEmployee?: Maybe<ClinicEmployeeCreateNestedOneWithoutAppointmentAvailabilitiesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentAvailabilityInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityCreateWithoutRoomInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentAvailabilitiesInput>;
  clinicEmployee?: Maybe<ClinicEmployeeCreateNestedOneWithoutAppointmentAvailabilitiesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAvailabilitiesInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityCreateavailabilitiesInput = {
  set: Array<Scalars['DateTime']>;
};

export type AppointmentAvailabilityGroupByOutputType = {
  __typename?: 'AppointmentAvailabilityGroupByOutputType';
  _count?: Maybe<AppointmentAvailabilityCountAggregateOutputType>;
  _max?: Maybe<AppointmentAvailabilityMaxAggregateOutputType>;
  _min?: Maybe<AppointmentAvailabilityMinAggregateOutputType>;
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type AppointmentAvailabilityListRelationFilter = {
  every?: Maybe<AppointmentAvailabilityWhereInput>;
  none?: Maybe<AppointmentAvailabilityWhereInput>;
  some?: Maybe<AppointmentAvailabilityWhereInput>;
};

export type AppointmentAvailabilityMaxAggregateOutputType = {
  __typename?: 'AppointmentAvailabilityMaxAggregateOutputType';
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityMaxOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isProvider?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AppointmentAvailabilityMinAggregateOutputType = {
  __typename?: 'AppointmentAvailabilityMinAggregateOutputType';
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityMinOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isProvider?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AppointmentAvailabilityOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type AppointmentAvailabilityOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AppointmentAvailabilityOrderByRelevanceInput>;
  availabilities?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isProvider?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  room?: Maybe<ClinicRoomOrderByWithRelationInput>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum AppointmentAvailabilityOrderByRelevanceFieldEnum {
  ClinicEmployeeId = 'clinicEmployeeId',
  ClinicId = 'clinicId',
  Id = 'id',
  IntegrationId = 'integrationId',
  PimsId = 'pimsId',
  RoomId = 'roomId'
}

export type AppointmentAvailabilityOrderByRelevanceInput = {
  fields: Array<AppointmentAvailabilityOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type AppointmentAvailabilityOrderByWithAggregationInput = {
  _count?: Maybe<AppointmentAvailabilityCountOrderByAggregateInput>;
  _max?: Maybe<AppointmentAvailabilityMaxOrderByAggregateInput>;
  _min?: Maybe<AppointmentAvailabilityMinOrderByAggregateInput>;
  availabilities?: Maybe<SortOrder>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isProvider?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AppointmentAvailabilityOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AppointmentAvailabilityOrderByRelevanceInput>;
  availabilities?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isProvider?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  room?: Maybe<ClinicRoomOrderByWithRelationInput>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AppointmentAvailabilityOrderByWithRelationInput = {
  _relevance?: Maybe<AppointmentAvailabilityOrderByRelevanceInput>;
  availabilities?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isProvider?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  room?: Maybe<ClinicRoomOrderByWithRelationInput>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum AppointmentAvailabilityScalarFieldEnum {
  Availabilities = 'availabilities',
  ClinicEmployeeId = 'clinicEmployeeId',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsDeleted = 'isDeleted',
  IsProvider = 'isProvider',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  RoomId = 'roomId',
  UpdatedAt = 'updatedAt'
}

export type AppointmentAvailabilityScalarWhereInput = {
  AND?: Maybe<Array<AppointmentAvailabilityScalarWhereInput>>;
  NOT?: Maybe<Array<AppointmentAvailabilityScalarWhereInput>>;
  OR?: Maybe<Array<AppointmentAvailabilityScalarWhereInput>>;
  availabilities?: Maybe<DateTimeNullableListFilter>;
  clinicEmployeeId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isProvider?: Maybe<BoolNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  roomId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AppointmentAvailabilityScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<AppointmentAvailabilityScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<AppointmentAvailabilityScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<AppointmentAvailabilityScalarWhereWithAggregatesInput>>;
  availabilities?: Maybe<DateTimeNullableListFilter>;
  clinicEmployeeId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  isProvider?: Maybe<BoolNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  roomId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type AppointmentAvailabilityUncheckedCreateInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyClinicEmployeeInputEnvelope>;
};

export type AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyClinicInputEnvelope>;
};

export type AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutIntegrationInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyIntegrationInputEnvelope>;
};

export type AppointmentAvailabilityUncheckedCreateNestedManyWithoutRoomInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutRoomInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutRoomInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyRoomInputEnvelope>;
};

export type AppointmentAvailabilityUncheckedCreateWithoutClinicEmployeeInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedCreateWithoutClinicInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedCreateWithoutIntegrationInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedCreateWithoutRoomInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedUpdateInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedUpdateManyInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentAvailabilityUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<AppointmentAvailabilityUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<AppointmentAvailabilityUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type AppointmentAvailabilityUncheckedUpdateManyWithoutClinicInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentAvailabilityUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<AppointmentAvailabilityUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<AppointmentAvailabilityUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutIntegrationInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentAvailabilityUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<AppointmentAvailabilityUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<AppointmentAvailabilityUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type AppointmentAvailabilityUncheckedUpdateManyWithoutRoomInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedUpdateManyWithoutRoomNestedInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutRoomInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutRoomInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyRoomInputEnvelope>;
  delete?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentAvailabilityUpdateWithWhereUniqueWithoutRoomInput>>;
  updateMany?: Maybe<Array<AppointmentAvailabilityUpdateManyWithWhereWithoutRoomInput>>;
  upsert?: Maybe<Array<AppointmentAvailabilityUpsertWithWhereUniqueWithoutRoomInput>>;
};

export type AppointmentAvailabilityUncheckedUpdateWithoutClinicEmployeeInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedUpdateWithoutClinicInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedUpdateWithoutIntegrationInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUncheckedUpdateWithoutRoomInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUpdateInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentAvailabilitiesNestedInput>;
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneWithoutAppointmentAvailabilitiesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAvailabilitiesNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentAvailabilityNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUpdateManyMutationInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUpdateManyWithWhereWithoutClinicEmployeeInput = {
  data: AppointmentAvailabilityUpdateManyMutationInput;
  where: AppointmentAvailabilityScalarWhereInput;
};

export type AppointmentAvailabilityUpdateManyWithWhereWithoutClinicInput = {
  data: AppointmentAvailabilityUpdateManyMutationInput;
  where: AppointmentAvailabilityScalarWhereInput;
};

export type AppointmentAvailabilityUpdateManyWithWhereWithoutIntegrationInput = {
  data: AppointmentAvailabilityUpdateManyMutationInput;
  where: AppointmentAvailabilityScalarWhereInput;
};

export type AppointmentAvailabilityUpdateManyWithWhereWithoutRoomInput = {
  data: AppointmentAvailabilityUpdateManyMutationInput;
  where: AppointmentAvailabilityScalarWhereInput;
};

export type AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentAvailabilityUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<AppointmentAvailabilityUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<AppointmentAvailabilityUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type AppointmentAvailabilityUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentAvailabilityUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<AppointmentAvailabilityUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<AppointmentAvailabilityUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutIntegrationInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentAvailabilityUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<AppointmentAvailabilityUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<AppointmentAvailabilityUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type AppointmentAvailabilityUpdateManyWithoutRoomNestedInput = {
  connect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentAvailabilityCreateOrConnectWithoutRoomInput>>;
  create?: Maybe<Array<AppointmentAvailabilityCreateWithoutRoomInput>>;
  createMany?: Maybe<AppointmentAvailabilityCreateManyRoomInputEnvelope>;
  delete?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentAvailabilityUpdateWithWhereUniqueWithoutRoomInput>>;
  updateMany?: Maybe<Array<AppointmentAvailabilityUpdateManyWithWhereWithoutRoomInput>>;
  upsert?: Maybe<Array<AppointmentAvailabilityUpsertWithWhereUniqueWithoutRoomInput>>;
};

export type AppointmentAvailabilityUpdateWithWhereUniqueWithoutClinicEmployeeInput = {
  data: AppointmentAvailabilityUpdateWithoutClinicEmployeeInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};

export type AppointmentAvailabilityUpdateWithWhereUniqueWithoutClinicInput = {
  data: AppointmentAvailabilityUpdateWithoutClinicInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};

export type AppointmentAvailabilityUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: AppointmentAvailabilityUpdateWithoutIntegrationInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};

export type AppointmentAvailabilityUpdateWithWhereUniqueWithoutRoomInput = {
  data: AppointmentAvailabilityUpdateWithoutRoomInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};

export type AppointmentAvailabilityUpdateWithoutClinicEmployeeInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentAvailabilitiesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAvailabilitiesNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentAvailabilityNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUpdateWithoutClinicInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneWithoutAppointmentAvailabilitiesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAvailabilitiesNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentAvailabilityNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUpdateWithoutIntegrationInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentAvailabilitiesNestedInput>;
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneWithoutAppointmentAvailabilitiesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentAvailabilityNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUpdateWithoutRoomInput = {
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentAvailabilitiesNestedInput>;
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneWithoutAppointmentAvailabilitiesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAvailabilitiesNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentAvailabilityUpdateavailabilitiesInput = {
  push?: Maybe<Array<Scalars['DateTime']>>;
  set?: Maybe<Array<Scalars['DateTime']>>;
};

export type AppointmentAvailabilityUpsertWithWhereUniqueWithoutClinicEmployeeInput = {
  create: AppointmentAvailabilityCreateWithoutClinicEmployeeInput;
  update: AppointmentAvailabilityUpdateWithoutClinicEmployeeInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};

export type AppointmentAvailabilityUpsertWithWhereUniqueWithoutClinicInput = {
  create: AppointmentAvailabilityCreateWithoutClinicInput;
  update: AppointmentAvailabilityUpdateWithoutClinicInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};

export type AppointmentAvailabilityUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: AppointmentAvailabilityCreateWithoutIntegrationInput;
  update: AppointmentAvailabilityUpdateWithoutIntegrationInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};

export type AppointmentAvailabilityUpsertWithWhereUniqueWithoutRoomInput = {
  create: AppointmentAvailabilityCreateWithoutRoomInput;
  update: AppointmentAvailabilityUpdateWithoutRoomInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};

export type AppointmentAvailabilityWhereInput = {
  AND?: Maybe<Array<AppointmentAvailabilityWhereInput>>;
  NOT?: Maybe<Array<AppointmentAvailabilityWhereInput>>;
  OR?: Maybe<Array<AppointmentAvailabilityWhereInput>>;
  availabilities?: Maybe<DateTimeNullableListFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployee?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isProvider?: Maybe<BoolNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  room?: Maybe<ClinicRoomNullableScalarRelationFilter>;
  roomId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AppointmentAvailabilityWhereUniqueInput = {
  AND?: Maybe<Array<AppointmentAvailabilityWhereInput>>;
  NOT?: Maybe<Array<AppointmentAvailabilityWhereInput>>;
  OR?: Maybe<Array<AppointmentAvailabilityWhereInput>>;
  availabilities?: Maybe<DateTimeNullableListFilter>;
  availabilityPimsIdAndIntegrationId?: Maybe<AppointmentAvailabilityAvailabilityPimsIdAndIntegrationIdCompoundUniqueInput>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployee?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isProvider?: Maybe<BoolNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  room?: Maybe<ClinicRoomNullableScalarRelationFilter>;
  roomId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AppointmentAvgAggregateOutputType = {
  __typename?: 'AppointmentAvgAggregateOutputType';
  durationInMinutes?: Maybe<Scalars['Float']>;
};

export type AppointmentAvgOrderByAggregateInput = {
  durationInMinutes?: Maybe<SortOrder>;
};

export type AppointmentCountAggregateOutputType = {
  __typename?: 'AppointmentCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentTypeId: Scalars['Int'];
  channelId: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  consultationId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  durationInMinutes: Scalars['Int'];
  hash: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  pimsExportConsultationId: Scalars['Int'];
  pimsId: Scalars['Int'];
  pimsStatus: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  recapNotes: Scalars['Int'];
  recapNotesUpdatedAt: Scalars['Int'];
  recapNotesUpdatedByUserId: Scalars['Int'];
  roomId: Scalars['Int'];
  startAt: Scalars['Int'];
  status: Scalars['Int'];
  taxonomyId: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
  workflow: Scalars['Int'];
};

export type AppointmentCountOrderByAggregateInput = {
  appointmentTypeId?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  durationInMinutes?: Maybe<SortOrder>;
  hash?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  pimsExportConsultationId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsStatus?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  recapNotes?: Maybe<SortOrder>;
  recapNotesUpdatedAt?: Maybe<SortOrder>;
  recapNotesUpdatedByUserId?: Maybe<SortOrder>;
  roomId?: Maybe<SortOrder>;
  startAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflow?: Maybe<SortOrder>;
};

export type AppointmentCountOutputType = {
  __typename?: 'AppointmentCountOutputType';
  aiRecapPimsWritebackLogEntry: Scalars['Int'];
  automationRuns: Scalars['Int'];
  channelAutomationStatuses: Scalars['Int'];
  clinicEmployees: Scalars['Int'];
  clinicPetParents: Scalars['Int'];
  formSubmissions: Scalars['Int'];
  massTextAlertEntryAppointments: Scalars['Int'];
  pushNotificationLogs: Scalars['Int'];
  recaps: Scalars['Int'];
  surveyResults: Scalars['Int'];
  tasks: Scalars['Int'];
  workflowTriggers: Scalars['Int'];
  workflows: Scalars['Int'];
};

export type AppointmentCreateInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateManyAppointmentTypeInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentCreateManyAppointmentTypeInputEnvelope = {
  data: Array<AppointmentCreateManyAppointmentTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentCreateManyChannelInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentCreateManyChannelInputEnvelope = {
  data: Array<AppointmentCreateManyChannelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentCreateManyClinicInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentCreateManyClinicInputEnvelope = {
  data: Array<AppointmentCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentCreateManyClinicPetInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentCreateManyClinicPetInputEnvelope = {
  data: Array<AppointmentCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentCreateManyConsultationInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentCreateManyConsultationInputEnvelope = {
  data: Array<AppointmentCreateManyConsultationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentCreateManyInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentCreateManyIntegrationInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentCreateManyIntegrationInputEnvelope = {
  data: Array<AppointmentCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentCreateManyRecapNotesUpdatedByInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentCreateManyRecapNotesUpdatedByInputEnvelope = {
  data: Array<AppointmentCreateManyRecapNotesUpdatedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentCreateManyRoomInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentCreateManyRoomInputEnvelope = {
  data: Array<AppointmentCreateManyRoomInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentCreateManyTaxonomyInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentCreateManyTaxonomyInputEnvelope = {
  data: Array<AppointmentCreateManyTaxonomyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentCreateNestedManyWithoutAppointmentTypeInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<AppointmentCreateManyAppointmentTypeInputEnvelope>;
};

export type AppointmentCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutChannelInput>>;
  createMany?: Maybe<AppointmentCreateManyChannelInputEnvelope>;
};

export type AppointmentCreateNestedManyWithoutClinicEmployeesInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicEmployeesInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicEmployeesInput>>;
};

export type AppointmentCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentCreateManyClinicInputEnvelope>;
};

export type AppointmentCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicPetInput>>;
  createMany?: Maybe<AppointmentCreateManyClinicPetInputEnvelope>;
};

export type AppointmentCreateNestedManyWithoutClinicPetParentsInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicPetParentsInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicPetParentsInput>>;
};

export type AppointmentCreateNestedManyWithoutConsultationInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutConsultationInput>>;
  createMany?: Maybe<AppointmentCreateManyConsultationInputEnvelope>;
};

export type AppointmentCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutIntegrationInput>>;
  createMany?: Maybe<AppointmentCreateManyIntegrationInputEnvelope>;
};

export type AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutRecapNotesUpdatedByInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutRecapNotesUpdatedByInput>>;
  createMany?: Maybe<AppointmentCreateManyRecapNotesUpdatedByInputEnvelope>;
};

export type AppointmentCreateNestedManyWithoutRoomInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutRoomInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutRoomInput>>;
  createMany?: Maybe<AppointmentCreateManyRoomInputEnvelope>;
};

export type AppointmentCreateNestedManyWithoutTaxonomyInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<AppointmentCreateManyTaxonomyInputEnvelope>;
};

export type AppointmentCreateNestedManyWithoutWorkflowsInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutWorkflowsInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutWorkflowsInput>>;
};

export type AppointmentCreateNestedOneWithoutAiRecapPimsWritebackLogEntryInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutAiRecapPimsWritebackLogEntryInput>;
  create?: Maybe<AppointmentCreateWithoutAiRecapPimsWritebackLogEntryInput>;
};

export type AppointmentCreateNestedOneWithoutAutomationRunsInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<AppointmentCreateWithoutAutomationRunsInput>;
};

export type AppointmentCreateNestedOneWithoutChannelAutomationStatusesInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<AppointmentCreateWithoutChannelAutomationStatusesInput>;
};

export type AppointmentCreateNestedOneWithoutDirectBookingWidgetRequestInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutDirectBookingWidgetRequestInput>;
  create?: Maybe<AppointmentCreateWithoutDirectBookingWidgetRequestInput>;
};

export type AppointmentCreateNestedOneWithoutFormSubmissionsInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutFormSubmissionsInput>;
  create?: Maybe<AppointmentCreateWithoutFormSubmissionsInput>;
};

export type AppointmentCreateNestedOneWithoutMassTextAlertEntryAppointmentsInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutMassTextAlertEntryAppointmentsInput>;
  create?: Maybe<AppointmentCreateWithoutMassTextAlertEntryAppointmentsInput>;
};

export type AppointmentCreateNestedOneWithoutPushNotificationLogsInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutPushNotificationLogsInput>;
  create?: Maybe<AppointmentCreateWithoutPushNotificationLogsInput>;
};

export type AppointmentCreateNestedOneWithoutRecapsInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutRecapsInput>;
  create?: Maybe<AppointmentCreateWithoutRecapsInput>;
};

export type AppointmentCreateNestedOneWithoutSurveyResultsInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutSurveyResultsInput>;
  create?: Maybe<AppointmentCreateWithoutSurveyResultsInput>;
};

export type AppointmentCreateNestedOneWithoutTasksInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutTasksInput>;
  create?: Maybe<AppointmentCreateWithoutTasksInput>;
};

export type AppointmentCreateNestedOneWithoutWorkflowTriggersInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutWorkflowTriggersInput>;
  create?: Maybe<AppointmentCreateWithoutWorkflowTriggersInput>;
};

export type AppointmentCreateOrConnectWithoutAiRecapPimsWritebackLogEntryInput = {
  create: AppointmentCreateWithoutAiRecapPimsWritebackLogEntryInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutAppointmentTypeInput = {
  create: AppointmentCreateWithoutAppointmentTypeInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutAutomationRunsInput = {
  create: AppointmentCreateWithoutAutomationRunsInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutChannelAutomationStatusesInput = {
  create: AppointmentCreateWithoutChannelAutomationStatusesInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutChannelInput = {
  create: AppointmentCreateWithoutChannelInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutClinicEmployeesInput = {
  create: AppointmentCreateWithoutClinicEmployeesInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutClinicInput = {
  create: AppointmentCreateWithoutClinicInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutClinicPetInput = {
  create: AppointmentCreateWithoutClinicPetInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutClinicPetParentsInput = {
  create: AppointmentCreateWithoutClinicPetParentsInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutConsultationInput = {
  create: AppointmentCreateWithoutConsultationInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutDirectBookingWidgetRequestInput = {
  create: AppointmentCreateWithoutDirectBookingWidgetRequestInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutFormSubmissionsInput = {
  create: AppointmentCreateWithoutFormSubmissionsInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutIntegrationInput = {
  create: AppointmentCreateWithoutIntegrationInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutMassTextAlertEntryAppointmentsInput = {
  create: AppointmentCreateWithoutMassTextAlertEntryAppointmentsInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutPushNotificationLogsInput = {
  create: AppointmentCreateWithoutPushNotificationLogsInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutRecapNotesUpdatedByInput = {
  create: AppointmentCreateWithoutRecapNotesUpdatedByInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutRecapsInput = {
  create: AppointmentCreateWithoutRecapsInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutRoomInput = {
  create: AppointmentCreateWithoutRoomInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutSurveyResultsInput = {
  create: AppointmentCreateWithoutSurveyResultsInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutTasksInput = {
  create: AppointmentCreateWithoutTasksInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutTaxonomyInput = {
  create: AppointmentCreateWithoutTaxonomyInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutWorkflowTriggersInput = {
  create: AppointmentCreateWithoutWorkflowTriggersInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateOrConnectWithoutWorkflowsInput = {
  create: AppointmentCreateWithoutWorkflowsInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateWithoutAiRecapPimsWritebackLogEntryInput = {
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutAppointmentTypeInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutAutomationRunsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutChannelAutomationStatusesInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutChannelInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutClinicEmployeesInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutClinicInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutClinicPetInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutClinicPetParentsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutConsultationInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutDirectBookingWidgetRequestInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutFormSubmissionsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutIntegrationInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutMassTextAlertEntryAppointmentsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutPushNotificationLogsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutRecapNotesUpdatedByInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutRecapsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutRoomInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutSurveyResultsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutTasksInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutTaxonomyInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutWorkflowTriggersInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentCreateWithoutWorkflowsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedManyWithoutAppointmentInput>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutAppointmentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutAppointmentInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutAppointmentsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppointmentsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutAppointmentsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAppointmentsInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutAppointmentsInput>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutAppointmentInput>;
  room?: Maybe<ClinicRoomCreateNestedOneWithoutAppointmentsInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAppointmentInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentsInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutAppointmentInput>;
};

export enum AppointmentDateRangeType {
  Custom = 'Custom',
  NextWeek = 'Next_Week',
  ThisMonth = 'This_Month',
  ThisWeek = 'This_Week',
  Today = 'Today',
  Tomorrow = 'Tomorrow'
}

export type AppointmentFilter = {
  __typename?: 'AppointmentFilter';
  currentDay: Scalars['Date'];
  daysAheadInterval: Scalars['Int'];
  defaultAppointmentDurationInMinutes: Scalars['Int'];
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export type AppointmentGroupByOutputType = {
  __typename?: 'AppointmentGroupByOutputType';
  _avg?: Maybe<AppointmentAvgAggregateOutputType>;
  _count?: Maybe<AppointmentCountAggregateOutputType>;
  _max?: Maybe<AppointmentMaxAggregateOutputType>;
  _min?: Maybe<AppointmentMinAggregateOutputType>;
  _sum?: Maybe<AppointmentSumAggregateOutputType>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status: AppointmentStatus;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentListRelationFilter = {
  every?: Maybe<AppointmentWhereInput>;
  none?: Maybe<AppointmentWhereInput>;
  some?: Maybe<AppointmentWhereInput>;
};

export type AppointmentMaxAggregateOutputType = {
  __typename?: 'AppointmentMaxAggregateOutputType';
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentMaxOrderByAggregateInput = {
  appointmentTypeId?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  durationInMinutes?: Maybe<SortOrder>;
  hash?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  pimsExportConsultationId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsStatus?: Maybe<SortOrder>;
  recapNotes?: Maybe<SortOrder>;
  recapNotesUpdatedAt?: Maybe<SortOrder>;
  recapNotesUpdatedByUserId?: Maybe<SortOrder>;
  roomId?: Maybe<SortOrder>;
  startAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflow?: Maybe<SortOrder>;
};

export type AppointmentMinAggregateOutputType = {
  __typename?: 'AppointmentMinAggregateOutputType';
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentMinOrderByAggregateInput = {
  appointmentTypeId?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  durationInMinutes?: Maybe<SortOrder>;
  hash?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  pimsExportConsultationId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsStatus?: Maybe<SortOrder>;
  recapNotes?: Maybe<SortOrder>;
  recapNotesUpdatedAt?: Maybe<SortOrder>;
  recapNotesUpdatedByUserId?: Maybe<SortOrder>;
  roomId?: Maybe<SortOrder>;
  startAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflow?: Maybe<SortOrder>;
};

export type AppointmentNoteTemplate = {
  __typename?: 'AppointmentNoteTemplate';
  body: Scalars['String'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
};


export type AppointmentNoteTemplateUpdatedByArgs = {
  where?: Maybe<UserWhereInput>;
};

export type AppointmentNoteTemplateCountAggregateOutputType = {
  __typename?: 'AppointmentNoteTemplateCountAggregateOutputType';
  _all: Scalars['Int'];
  body: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
  updatedById: Scalars['Int'];
};

export type AppointmentNoteTemplateCountOrderByAggregateInput = {
  body?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedById?: Maybe<SortOrder>;
};

export type AppointmentNoteTemplateCreateInput = {
  body: Scalars['String'];
  clinic: ClinicCreateNestedOneWithoutAppointmentNoteTemplateInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentNoteTemplateInput>;
};

export type AppointmentNoteTemplateCreateManyClinicInput = {
  body: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type AppointmentNoteTemplateCreateManyClinicInputEnvelope = {
  data: Array<AppointmentNoteTemplateCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentNoteTemplateCreateManyInput = {
  body: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type AppointmentNoteTemplateCreateManyUpdatedByInput = {
  body: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentNoteTemplateCreateManyUpdatedByInputEnvelope = {
  data: Array<AppointmentNoteTemplateCreateManyUpdatedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentNoteTemplateCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentNoteTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentNoteTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentNoteTemplateCreateManyClinicInputEnvelope>;
};

export type AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput = {
  connect?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentNoteTemplateCreateOrConnectWithoutUpdatedByInput>>;
  create?: Maybe<Array<AppointmentNoteTemplateCreateWithoutUpdatedByInput>>;
  createMany?: Maybe<AppointmentNoteTemplateCreateManyUpdatedByInputEnvelope>;
};

export type AppointmentNoteTemplateCreateOrConnectWithoutClinicInput = {
  create: AppointmentNoteTemplateCreateWithoutClinicInput;
  where: AppointmentNoteTemplateWhereUniqueInput;
};

export type AppointmentNoteTemplateCreateOrConnectWithoutUpdatedByInput = {
  create: AppointmentNoteTemplateCreateWithoutUpdatedByInput;
  where: AppointmentNoteTemplateWhereUniqueInput;
};

export type AppointmentNoteTemplateCreateWithoutClinicInput = {
  body: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserCreateNestedOneWithoutAppointmentNoteTemplateInput>;
};

export type AppointmentNoteTemplateCreateWithoutUpdatedByInput = {
  body: Scalars['String'];
  clinic: ClinicCreateNestedOneWithoutAppointmentNoteTemplateInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentNoteTemplateGroupByOutputType = {
  __typename?: 'AppointmentNoteTemplateGroupByOutputType';
  _count?: Maybe<AppointmentNoteTemplateCountAggregateOutputType>;
  _max?: Maybe<AppointmentNoteTemplateMaxAggregateOutputType>;
  _min?: Maybe<AppointmentNoteTemplateMinAggregateOutputType>;
  body: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedById?: Maybe<Scalars['String']>;
};

export type AppointmentNoteTemplateListRelationFilter = {
  every?: Maybe<AppointmentNoteTemplateWhereInput>;
  none?: Maybe<AppointmentNoteTemplateWhereInput>;
  some?: Maybe<AppointmentNoteTemplateWhereInput>;
};

export type AppointmentNoteTemplateMaxAggregateOutputType = {
  __typename?: 'AppointmentNoteTemplateMaxAggregateOutputType';
  body?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type AppointmentNoteTemplateMaxOrderByAggregateInput = {
  body?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedById?: Maybe<SortOrder>;
};

export type AppointmentNoteTemplateMinAggregateOutputType = {
  __typename?: 'AppointmentNoteTemplateMinAggregateOutputType';
  body?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type AppointmentNoteTemplateMinOrderByAggregateInput = {
  body?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedById?: Maybe<SortOrder>;
};

export type AppointmentNoteTemplateOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type AppointmentNoteTemplateOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AppointmentNoteTemplateOrderByRelevanceInput>;
  body?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedBy?: Maybe<UserOrderByWithRelationInput>;
  updatedById?: Maybe<SortOrder>;
};

export enum AppointmentNoteTemplateOrderByRelevanceFieldEnum {
  Body = 'body',
  ClinicId = 'clinicId',
  Id = 'id',
  Name = 'name',
  UpdatedById = 'updatedById'
}

export type AppointmentNoteTemplateOrderByRelevanceInput = {
  fields: Array<AppointmentNoteTemplateOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type AppointmentNoteTemplateOrderByWithAggregationInput = {
  _count?: Maybe<AppointmentNoteTemplateCountOrderByAggregateInput>;
  _max?: Maybe<AppointmentNoteTemplateMaxOrderByAggregateInput>;
  _min?: Maybe<AppointmentNoteTemplateMinOrderByAggregateInput>;
  body?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedById?: Maybe<SortOrder>;
};

export type AppointmentNoteTemplateOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AppointmentNoteTemplateOrderByRelevanceInput>;
  body?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedBy?: Maybe<UserOrderByWithRelationInput>;
  updatedById?: Maybe<SortOrder>;
};

export type AppointmentNoteTemplateOrderByWithRelationInput = {
  _relevance?: Maybe<AppointmentNoteTemplateOrderByRelevanceInput>;
  body?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedBy?: Maybe<UserOrderByWithRelationInput>;
  updatedById?: Maybe<SortOrder>;
};

export enum AppointmentNoteTemplateScalarFieldEnum {
  Body = 'body',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  UpdatedById = 'updatedById'
}

export type AppointmentNoteTemplateScalarWhereInput = {
  AND?: Maybe<Array<AppointmentNoteTemplateScalarWhereInput>>;
  NOT?: Maybe<Array<AppointmentNoteTemplateScalarWhereInput>>;
  OR?: Maybe<Array<AppointmentNoteTemplateScalarWhereInput>>;
  body?: Maybe<StringFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  updatedById?: Maybe<StringNullableFilter>;
};

export type AppointmentNoteTemplateScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<AppointmentNoteTemplateScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<AppointmentNoteTemplateScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<AppointmentNoteTemplateScalarWhereWithAggregatesInput>>;
  body?: Maybe<StringWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  updatedById?: Maybe<StringNullableWithAggregatesFilter>;
};

export type AppointmentNoteTemplateUncheckedCreateInput = {
  body: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentNoteTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentNoteTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentNoteTemplateCreateManyClinicInputEnvelope>;
};

export type AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput = {
  connect?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentNoteTemplateCreateOrConnectWithoutUpdatedByInput>>;
  create?: Maybe<Array<AppointmentNoteTemplateCreateWithoutUpdatedByInput>>;
  createMany?: Maybe<AppointmentNoteTemplateCreateManyUpdatedByInputEnvelope>;
};

export type AppointmentNoteTemplateUncheckedCreateWithoutClinicInput = {
  body: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type AppointmentNoteTemplateUncheckedCreateWithoutUpdatedByInput = {
  body: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentNoteTemplateUncheckedUpdateInput = {
  body?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type AppointmentNoteTemplateUncheckedUpdateManyInput = {
  body?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicInput = {
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentNoteTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentNoteTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentNoteTemplateCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentNoteTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentNoteTemplateUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<AppointmentNoteTemplateUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<AppointmentNoteTemplateUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByInput = {
  body?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput = {
  connect?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentNoteTemplateCreateOrConnectWithoutUpdatedByInput>>;
  create?: Maybe<Array<AppointmentNoteTemplateCreateWithoutUpdatedByInput>>;
  createMany?: Maybe<AppointmentNoteTemplateCreateManyUpdatedByInputEnvelope>;
  delete?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentNoteTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentNoteTemplateUpdateWithWhereUniqueWithoutUpdatedByInput>>;
  updateMany?: Maybe<Array<AppointmentNoteTemplateUpdateManyWithWhereWithoutUpdatedByInput>>;
  upsert?: Maybe<Array<AppointmentNoteTemplateUpsertWithWhereUniqueWithoutUpdatedByInput>>;
};

export type AppointmentNoteTemplateUncheckedUpdateWithoutClinicInput = {
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type AppointmentNoteTemplateUncheckedUpdateWithoutUpdatedByInput = {
  body?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentNoteTemplateUpdateInput = {
  body?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAppointmentNoteTemplateNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserUpdateOneWithoutAppointmentNoteTemplateNestedInput>;
};

export type AppointmentNoteTemplateUpdateManyMutationInput = {
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentNoteTemplateUpdateManyWithWhereWithoutClinicInput = {
  data: AppointmentNoteTemplateUpdateManyMutationInput;
  where: AppointmentNoteTemplateScalarWhereInput;
};

export type AppointmentNoteTemplateUpdateManyWithWhereWithoutUpdatedByInput = {
  data: AppointmentNoteTemplateUpdateManyMutationInput;
  where: AppointmentNoteTemplateScalarWhereInput;
};

export type AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentNoteTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentNoteTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentNoteTemplateCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentNoteTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentNoteTemplateUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<AppointmentNoteTemplateUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<AppointmentNoteTemplateUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput = {
  connect?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentNoteTemplateCreateOrConnectWithoutUpdatedByInput>>;
  create?: Maybe<Array<AppointmentNoteTemplateCreateWithoutUpdatedByInput>>;
  createMany?: Maybe<AppointmentNoteTemplateCreateManyUpdatedByInputEnvelope>;
  delete?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentNoteTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentNoteTemplateWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentNoteTemplateUpdateWithWhereUniqueWithoutUpdatedByInput>>;
  updateMany?: Maybe<Array<AppointmentNoteTemplateUpdateManyWithWhereWithoutUpdatedByInput>>;
  upsert?: Maybe<Array<AppointmentNoteTemplateUpsertWithWhereUniqueWithoutUpdatedByInput>>;
};

export type AppointmentNoteTemplateUpdateWithWhereUniqueWithoutClinicInput = {
  data: AppointmentNoteTemplateUpdateWithoutClinicInput;
  where: AppointmentNoteTemplateWhereUniqueInput;
};

export type AppointmentNoteTemplateUpdateWithWhereUniqueWithoutUpdatedByInput = {
  data: AppointmentNoteTemplateUpdateWithoutUpdatedByInput;
  where: AppointmentNoteTemplateWhereUniqueInput;
};

export type AppointmentNoteTemplateUpdateWithoutClinicInput = {
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserUpdateOneWithoutAppointmentNoteTemplateNestedInput>;
};

export type AppointmentNoteTemplateUpdateWithoutUpdatedByInput = {
  body?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAppointmentNoteTemplateNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentNoteTemplateUpsertWithWhereUniqueWithoutClinicInput = {
  create: AppointmentNoteTemplateCreateWithoutClinicInput;
  update: AppointmentNoteTemplateUpdateWithoutClinicInput;
  where: AppointmentNoteTemplateWhereUniqueInput;
};

export type AppointmentNoteTemplateUpsertWithWhereUniqueWithoutUpdatedByInput = {
  create: AppointmentNoteTemplateCreateWithoutUpdatedByInput;
  update: AppointmentNoteTemplateUpdateWithoutUpdatedByInput;
  where: AppointmentNoteTemplateWhereUniqueInput;
};

export type AppointmentNoteTemplateWhereInput = {
  AND?: Maybe<Array<AppointmentNoteTemplateWhereInput>>;
  NOT?: Maybe<Array<AppointmentNoteTemplateWhereInput>>;
  OR?: Maybe<Array<AppointmentNoteTemplateWhereInput>>;
  body?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  updatedBy?: Maybe<UserNullableScalarRelationFilter>;
  updatedById?: Maybe<StringNullableFilter>;
};

export type AppointmentNoteTemplateWhereUniqueInput = {
  AND?: Maybe<Array<AppointmentNoteTemplateWhereInput>>;
  NOT?: Maybe<Array<AppointmentNoteTemplateWhereInput>>;
  OR?: Maybe<Array<AppointmentNoteTemplateWhereInput>>;
  body?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  updatedBy?: Maybe<UserNullableScalarRelationFilter>;
  updatedById?: Maybe<StringNullableFilter>;
};

export type AppointmentNullableScalarRelationFilter = {
  AND?: Maybe<Array<AppointmentWhereInput>>;
  NOT?: Maybe<Array<AppointmentWhereInput>>;
  OR?: Maybe<Array<AppointmentWhereInput>>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryListRelationFilter>;
  appointmentType?: Maybe<AppointmentTypeNullableScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringNullableFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  consultation?: Maybe<ConsultationNullableScalarRelationFilter>;
  consultationId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  durationInMinutes?: Maybe<IntFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  hash?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentListRelationFilter>;
  pimsExportConsultationId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsStatus?: Maybe<StringNullableFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  recapNotes?: Maybe<StringNullableFilter>;
  recapNotesUpdatedAt?: Maybe<DateTimeNullableFilter>;
  recapNotesUpdatedBy?: Maybe<UserNullableScalarRelationFilter>;
  recapNotesUpdatedByUserId?: Maybe<StringNullableFilter>;
  recaps?: Maybe<RecapListRelationFilter>;
  room?: Maybe<ClinicRoomNullableScalarRelationFilter>;
  roomId?: Maybe<StringNullableFilter>;
  startAt?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumAppointmentStatusFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  title?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflow?: Maybe<EnumWorkflowTypeNullableFilter>;
  workflowTriggers?: Maybe<WorkflowTriggerListRelationFilter>;
  workflows?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type AppointmentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type AppointmentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AppointmentOrderByRelevanceInput>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryOrderByRelationAggregateInput>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployees?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  consultation?: Maybe<ConsultationOrderByWithRelationInput>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  durationInMinutes?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  hash?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentOrderByRelationAggregateInput>;
  pimsExportConsultationId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsStatus?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  rawPimsValue?: Maybe<SortOrder>;
  recapNotes?: Maybe<SortOrder>;
  recapNotesUpdatedAt?: Maybe<SortOrder>;
  recapNotesUpdatedBy?: Maybe<UserOrderByWithRelationInput>;
  recapNotesUpdatedByUserId?: Maybe<SortOrder>;
  recaps?: Maybe<RecapOrderByRelationAggregateInput>;
  room?: Maybe<ClinicRoomOrderByWithRelationInput>;
  roomId?: Maybe<SortOrder>;
  startAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  surveyResults?: Maybe<SurveyResultOrderByRelationAggregateInput>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflow?: Maybe<SortOrder>;
  workflowTriggers?: Maybe<WorkflowTriggerOrderByRelationAggregateInput>;
  workflows?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum AppointmentOrderByRelevanceFieldEnum {
  AppointmentTypeId = 'appointmentTypeId',
  ChannelId = 'channelId',
  ClinicId = 'clinicId',
  ClinicPetId = 'clinicPetId',
  ConsultationId = 'consultationId',
  Description = 'description',
  Hash = 'hash',
  Id = 'id',
  IntegrationId = 'integrationId',
  PimsExportConsultationId = 'pimsExportConsultationId',
  PimsId = 'pimsId',
  PimsStatus = 'pimsStatus',
  RecapNotes = 'recapNotes',
  RecapNotesUpdatedByUserId = 'recapNotesUpdatedByUserId',
  RoomId = 'roomId',
  TaxonomyId = 'taxonomyId',
  Title = 'title'
}

export type AppointmentOrderByRelevanceInput = {
  fields: Array<AppointmentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type AppointmentOrderByWithAggregationInput = {
  _avg?: Maybe<AppointmentAvgOrderByAggregateInput>;
  _count?: Maybe<AppointmentCountOrderByAggregateInput>;
  _max?: Maybe<AppointmentMaxOrderByAggregateInput>;
  _min?: Maybe<AppointmentMinOrderByAggregateInput>;
  _sum?: Maybe<AppointmentSumOrderByAggregateInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  durationInMinutes?: Maybe<SortOrder>;
  hash?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  pimsExportConsultationId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsStatus?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  recapNotes?: Maybe<SortOrder>;
  recapNotesUpdatedAt?: Maybe<SortOrder>;
  recapNotesUpdatedByUserId?: Maybe<SortOrder>;
  roomId?: Maybe<SortOrder>;
  startAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflow?: Maybe<SortOrder>;
};

export type AppointmentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AppointmentOrderByRelevanceInput>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryOrderByRelationAggregateInput>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployees?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  consultation?: Maybe<ConsultationOrderByWithRelationInput>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  durationInMinutes?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  hash?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentOrderByRelationAggregateInput>;
  pimsExportConsultationId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsStatus?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  rawPimsValue?: Maybe<SortOrder>;
  recapNotes?: Maybe<SortOrder>;
  recapNotesUpdatedAt?: Maybe<SortOrder>;
  recapNotesUpdatedBy?: Maybe<UserOrderByWithRelationInput>;
  recapNotesUpdatedByUserId?: Maybe<SortOrder>;
  recaps?: Maybe<RecapOrderByRelationAggregateInput>;
  room?: Maybe<ClinicRoomOrderByWithRelationInput>;
  roomId?: Maybe<SortOrder>;
  startAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  surveyResults?: Maybe<SurveyResultOrderByRelationAggregateInput>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflow?: Maybe<SortOrder>;
  workflowTriggers?: Maybe<WorkflowTriggerOrderByRelationAggregateInput>;
  workflows?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export type AppointmentOrderByWithRelationInput = {
  _relevance?: Maybe<AppointmentOrderByRelevanceInput>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryOrderByRelationAggregateInput>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployees?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  consultation?: Maybe<ConsultationOrderByWithRelationInput>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  durationInMinutes?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  hash?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentOrderByRelationAggregateInput>;
  pimsExportConsultationId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsStatus?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  rawPimsValue?: Maybe<SortOrder>;
  recapNotes?: Maybe<SortOrder>;
  recapNotesUpdatedAt?: Maybe<SortOrder>;
  recapNotesUpdatedBy?: Maybe<UserOrderByWithRelationInput>;
  recapNotesUpdatedByUserId?: Maybe<SortOrder>;
  recaps?: Maybe<RecapOrderByRelationAggregateInput>;
  room?: Maybe<ClinicRoomOrderByWithRelationInput>;
  roomId?: Maybe<SortOrder>;
  startAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  surveyResults?: Maybe<SurveyResultOrderByRelationAggregateInput>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflow?: Maybe<SortOrder>;
  workflowTriggers?: Maybe<WorkflowTriggerOrderByRelationAggregateInput>;
  workflows?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum AppointmentScalarFieldEnum {
  AppointmentTypeId = 'appointmentTypeId',
  ChannelId = 'channelId',
  ClinicId = 'clinicId',
  ClinicPetId = 'clinicPetId',
  ConsultationId = 'consultationId',
  CreatedAt = 'createdAt',
  Description = 'description',
  DurationInMinutes = 'durationInMinutes',
  Hash = 'hash',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  PimsExportConsultationId = 'pimsExportConsultationId',
  PimsId = 'pimsId',
  PimsStatus = 'pimsStatus',
  RawPimsValue = 'rawPimsValue',
  RecapNotes = 'recapNotes',
  RecapNotesUpdatedAt = 'recapNotesUpdatedAt',
  RecapNotesUpdatedByUserId = 'recapNotesUpdatedByUserId',
  RoomId = 'roomId',
  StartAt = 'startAt',
  Status = 'status',
  TaxonomyId = 'taxonomyId',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  Workflow = 'workflow'
}

export type AppointmentScalarRelationFilter = {
  AND?: Maybe<Array<AppointmentWhereInput>>;
  NOT?: Maybe<Array<AppointmentWhereInput>>;
  OR?: Maybe<Array<AppointmentWhereInput>>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryListRelationFilter>;
  appointmentType?: Maybe<AppointmentTypeNullableScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringNullableFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  consultation?: Maybe<ConsultationNullableScalarRelationFilter>;
  consultationId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  durationInMinutes?: Maybe<IntFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  hash?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentListRelationFilter>;
  pimsExportConsultationId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsStatus?: Maybe<StringNullableFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  recapNotes?: Maybe<StringNullableFilter>;
  recapNotesUpdatedAt?: Maybe<DateTimeNullableFilter>;
  recapNotesUpdatedBy?: Maybe<UserNullableScalarRelationFilter>;
  recapNotesUpdatedByUserId?: Maybe<StringNullableFilter>;
  recaps?: Maybe<RecapListRelationFilter>;
  room?: Maybe<ClinicRoomNullableScalarRelationFilter>;
  roomId?: Maybe<StringNullableFilter>;
  startAt?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumAppointmentStatusFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  title?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflow?: Maybe<EnumWorkflowTypeNullableFilter>;
  workflowTriggers?: Maybe<WorkflowTriggerListRelationFilter>;
  workflows?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type AppointmentScalarWhereInput = {
  AND?: Maybe<Array<AppointmentScalarWhereInput>>;
  NOT?: Maybe<Array<AppointmentScalarWhereInput>>;
  OR?: Maybe<Array<AppointmentScalarWhereInput>>;
  appointmentTypeId?: Maybe<StringNullableFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  consultationId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  durationInMinutes?: Maybe<IntFilter>;
  hash?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  pimsExportConsultationId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsStatus?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  recapNotes?: Maybe<StringNullableFilter>;
  recapNotesUpdatedAt?: Maybe<DateTimeNullableFilter>;
  recapNotesUpdatedByUserId?: Maybe<StringNullableFilter>;
  roomId?: Maybe<StringNullableFilter>;
  startAt?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumAppointmentStatusFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  title?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflow?: Maybe<EnumWorkflowTypeNullableFilter>;
};

export type AppointmentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<AppointmentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<AppointmentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<AppointmentScalarWhereWithAggregatesInput>>;
  appointmentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  channelId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetId?: Maybe<StringNullableWithAggregatesFilter>;
  consultationId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  durationInMinutes?: Maybe<IntWithAggregatesFilter>;
  hash?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  isActive?: Maybe<BoolNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolNullableWithAggregatesFilter>;
  pimsExportConsultationId?: Maybe<StringNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  pimsStatus?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  recapNotes?: Maybe<StringNullableWithAggregatesFilter>;
  recapNotesUpdatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  recapNotesUpdatedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  roomId?: Maybe<StringNullableWithAggregatesFilter>;
  startAt?: Maybe<DateTimeWithAggregatesFilter>;
  status?: Maybe<EnumAppointmentStatusWithAggregatesFilter>;
  taxonomyId?: Maybe<StringNullableWithAggregatesFilter>;
  title?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  workflow?: Maybe<EnumWorkflowTypeNullableWithAggregatesFilter>;
};

export enum AppointmentStatus {
  ArrivalConfirmed = 'ArrivalConfirmed',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Confirmed = 'Confirmed',
  Pending = 'Pending',
  Reschedule = 'Reschedule'
}

export type AppointmentSumAggregateOutputType = {
  __typename?: 'AppointmentSumAggregateOutputType';
  durationInMinutes?: Maybe<Scalars['Int']>;
};

export type AppointmentSumOrderByAggregateInput = {
  durationInMinutes?: Maybe<SortOrder>;
};

export type AppointmentType = {
  __typename?: 'AppointmentType';
  ProviderAppointmentTypeRoomMap: Array<ProviderAppointmentTypeRoomMap>;
  _count: AppointmentTypeCountOutputType;
  appointmentTypeVisibility: AppointmentTypeVisibility;
  appointments: Array<Appointment>;
  clinic?: Maybe<Clinic>;
  clinicEmployeeAppointmentTypeSettings: Array<ClinicEmployeeAppointmentTypeSetting>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes: Array<ClinicWorkflowType>;
  createdAt: Scalars['DateTime'];
  defaultDurationInMinutes: Scalars['Int'];
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount: Scalars['Int'];
  depositCurrency: Currency;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSetting>;
  directBookingExclusionRules: Array<DirectBookingExclusionRule>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit: Scalars['Boolean'];
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  markPaymentAsDeposit: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers: Array<SentTrupanionExamDayOffer>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal: Scalars['Boolean'];
  surveyAppointmentTypeSettings: Array<SurveyAppointmentTypeSetting>;
  taxonomy?: Maybe<Taxonomy>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentType>;
  updatedAt: Scalars['DateTime'];
  userAppointmentGroupings: Array<UserAppointmentGrouping>;
  workflows: Array<WorkflowEventSetting>;
};


export type AppointmentTypeProviderAppointmentTypeRoomMapArgs = {
  cursor?: Maybe<ProviderAppointmentTypeRoomMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProviderAppointmentTypeRoomMapWhereInput>;
};


export type AppointmentTypeAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type AppointmentTypeClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type AppointmentTypeClinicEmployeeAppointmentTypeSettingsArgs = {
  cursor?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeAppointmentTypeSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereInput>;
};


export type AppointmentTypeClinicWorkflowTypesArgs = {
  cursor?: Maybe<ClinicWorkflowTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWorkflowTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWorkflowTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWorkflowTypeWhereInput>;
};


export type AppointmentTypeDirectBookingAppointmentTypeSettingArgs = {
  where?: Maybe<DirectBookingAppointmentTypeSettingWhereInput>;
};


export type AppointmentTypeDirectBookingExclusionRulesArgs = {
  cursor?: Maybe<DirectBookingExclusionRuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingExclusionRuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingExclusionRuleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingExclusionRuleWhereInput>;
};


export type AppointmentTypeIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type AppointmentTypeRelatedTrupanionExamDayOffersArgs = {
  cursor?: Maybe<SentTrupanionExamDayOfferWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SentTrupanionExamDayOfferScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SentTrupanionExamDayOfferOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};


export type AppointmentTypeSurveyAppointmentTypeSettingsArgs = {
  cursor?: Maybe<SurveyAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveyAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveyAppointmentTypeSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyAppointmentTypeSettingWhereInput>;
};


export type AppointmentTypeTaxonomyArgs = {
  where?: Maybe<TaxonomyWhereInput>;
};


export type AppointmentTypeTrupanionIntegratedAppointmentTypeArgs = {
  where?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
};


export type AppointmentTypeUserAppointmentGroupingsArgs = {
  cursor?: Maybe<UserAppointmentGroupingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserAppointmentGroupingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserAppointmentGroupingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAppointmentGroupingWhereInput>;
};


export type AppointmentTypeWorkflowsArgs = {
  cursor?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type AppointmentTypeAppointmentTypePimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type AppointmentTypeAvgAggregateOutputType = {
  __typename?: 'AppointmentTypeAvgAggregateOutputType';
  defaultDurationInMinutes?: Maybe<Scalars['Float']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Float']>;
  delayedStartTime?: Maybe<Scalars['Float']>;
  depositAmount?: Maybe<Scalars['Float']>;
  displayOrder?: Maybe<Scalars['Float']>;
};

export type AppointmentTypeAvgOrderByAggregateInput = {
  defaultDurationInMinutes?: Maybe<SortOrder>;
  defaultSoonestAvailableBookingInHours?: Maybe<SortOrder>;
  delayedStartTime?: Maybe<SortOrder>;
  depositAmount?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
};

export type AppointmentTypeClinicEmployee = {
  __typename?: 'AppointmentTypeClinicEmployee';
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
};

export type AppointmentTypeClinicEmployeeMapping = {
  __typename?: 'AppointmentTypeClinicEmployeeMapping';
  clinicEmployee: AppointmentTypeClinicEmployee;
};

export type AppointmentTypeCountAggregateOutputType = {
  __typename?: 'AppointmentTypeCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentTypeVisibility: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  defaultDurationInMinutes: Scalars['Int'];
  defaultSoonestAvailableBookingInHours: Scalars['Int'];
  delayedStartTime: Scalars['Int'];
  depositAmount: Scalars['Int'];
  depositCurrency: Scalars['Int'];
  description: Scalars['Int'];
  displayName: Scalars['Int'];
  displayOrder: Scalars['Int'];
  hasDeposit: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isAvailableForDirectBooking: Scalars['Int'];
  isVisible: Scalars['Int'];
  markPaymentAsDeposit: Scalars['Int'];
  name: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  resourceUid: Scalars['Int'];
  showInPetPortal: Scalars['Int'];
  taxonomyId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type AppointmentTypeCountOrderByAggregateInput = {
  appointmentTypeVisibility?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultDurationInMinutes?: Maybe<SortOrder>;
  defaultSoonestAvailableBookingInHours?: Maybe<SortOrder>;
  delayedStartTime?: Maybe<SortOrder>;
  depositAmount?: Maybe<SortOrder>;
  depositCurrency?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  hasDeposit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isAvailableForDirectBooking?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  markPaymentAsDeposit?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  showInPetPortal?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AppointmentTypeCountOutputType = {
  __typename?: 'AppointmentTypeCountOutputType';
  ProviderAppointmentTypeRoomMap: Scalars['Int'];
  appointments: Scalars['Int'];
  clinicEmployeeAppointmentTypeSettings: Scalars['Int'];
  clinicWorkflowTypes: Scalars['Int'];
  directBookingExclusionRules: Scalars['Int'];
  relatedTrupanionExamDayOffers: Scalars['Int'];
  surveyAppointmentTypeSettings: Scalars['Int'];
  userAppointmentGroupings: Scalars['Int'];
  workflows: Scalars['Int'];
};

export type AppointmentTypeCreateInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateManyClinicInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeCreateManyClinicInputEnvelope = {
  data: Array<AppointmentTypeCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentTypeCreateManyInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeCreateManyIntegrationInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeCreateManyIntegrationInputEnvelope = {
  data: Array<AppointmentTypeCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentTypeCreateManyTaxonomyInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeCreateManyTaxonomyInputEnvelope = {
  data: Array<AppointmentTypeCreateManyTaxonomyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AppointmentTypeCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentTypeCreateManyClinicInputEnvelope>;
};

export type AppointmentTypeCreateNestedManyWithoutDirectBookingExclusionRulesInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutDirectBookingExclusionRulesInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutDirectBookingExclusionRulesInput>>;
};

export type AppointmentTypeCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutIntegrationInput>>;
  createMany?: Maybe<AppointmentTypeCreateManyIntegrationInputEnvelope>;
};

export type AppointmentTypeCreateNestedManyWithoutTaxonomyInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<AppointmentTypeCreateManyTaxonomyInputEnvelope>;
};

export type AppointmentTypeCreateNestedManyWithoutUserAppointmentGroupingsInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutUserAppointmentGroupingsInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutUserAppointmentGroupingsInput>>;
};

export type AppointmentTypeCreateNestedManyWithoutWorkflowsInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutWorkflowsInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutWorkflowsInput>>;
};

export type AppointmentTypeCreateNestedOneWithoutAppointmentsInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<AppointmentTypeCreateWithoutAppointmentsInput>;
};

export type AppointmentTypeCreateNestedOneWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutClinicEmployeeAppointmentTypeSettingsInput>;
  create?: Maybe<AppointmentTypeCreateWithoutClinicEmployeeAppointmentTypeSettingsInput>;
};

export type AppointmentTypeCreateNestedOneWithoutClinicWorkflowTypesInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutClinicWorkflowTypesInput>;
  create?: Maybe<AppointmentTypeCreateWithoutClinicWorkflowTypesInput>;
};

export type AppointmentTypeCreateNestedOneWithoutDirectBookingAppointmentTypeSettingInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutDirectBookingAppointmentTypeSettingInput>;
  create?: Maybe<AppointmentTypeCreateWithoutDirectBookingAppointmentTypeSettingInput>;
};

export type AppointmentTypeCreateNestedOneWithoutProviderAppointmentTypeRoomMapInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutProviderAppointmentTypeRoomMapInput>;
  create?: Maybe<AppointmentTypeCreateWithoutProviderAppointmentTypeRoomMapInput>;
};

export type AppointmentTypeCreateNestedOneWithoutRelatedTrupanionExamDayOffersInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutRelatedTrupanionExamDayOffersInput>;
  create?: Maybe<AppointmentTypeCreateWithoutRelatedTrupanionExamDayOffersInput>;
};

export type AppointmentTypeCreateNestedOneWithoutSurveyAppointmentTypeSettingsInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutSurveyAppointmentTypeSettingsInput>;
  create?: Maybe<AppointmentTypeCreateWithoutSurveyAppointmentTypeSettingsInput>;
};

export type AppointmentTypeCreateNestedOneWithoutTrupanionIntegratedAppointmentTypeInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutTrupanionIntegratedAppointmentTypeInput>;
  create?: Maybe<AppointmentTypeCreateWithoutTrupanionIntegratedAppointmentTypeInput>;
};

export type AppointmentTypeCreateOrConnectWithoutAppointmentsInput = {
  create: AppointmentTypeCreateWithoutAppointmentsInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  create: AppointmentTypeCreateWithoutClinicEmployeeAppointmentTypeSettingsInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutClinicInput = {
  create: AppointmentTypeCreateWithoutClinicInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutClinicWorkflowTypesInput = {
  create: AppointmentTypeCreateWithoutClinicWorkflowTypesInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutDirectBookingAppointmentTypeSettingInput = {
  create: AppointmentTypeCreateWithoutDirectBookingAppointmentTypeSettingInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutDirectBookingExclusionRulesInput = {
  create: AppointmentTypeCreateWithoutDirectBookingExclusionRulesInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutIntegrationInput = {
  create: AppointmentTypeCreateWithoutIntegrationInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutProviderAppointmentTypeRoomMapInput = {
  create: AppointmentTypeCreateWithoutProviderAppointmentTypeRoomMapInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutRelatedTrupanionExamDayOffersInput = {
  create: AppointmentTypeCreateWithoutRelatedTrupanionExamDayOffersInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutSurveyAppointmentTypeSettingsInput = {
  create: AppointmentTypeCreateWithoutSurveyAppointmentTypeSettingsInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutTaxonomyInput = {
  create: AppointmentTypeCreateWithoutTaxonomyInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutTrupanionIntegratedAppointmentTypeInput = {
  create: AppointmentTypeCreateWithoutTrupanionIntegratedAppointmentTypeInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutUserAppointmentGroupingsInput = {
  create: AppointmentTypeCreateWithoutUserAppointmentGroupingsInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateOrConnectWithoutWorkflowsInput = {
  create: AppointmentTypeCreateWithoutWorkflowsInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeCreateWithoutAppointmentsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutClinicInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutClinicWorkflowTypesInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutDirectBookingAppointmentTypeSettingInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutDirectBookingExclusionRulesInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutIntegrationInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutProviderAppointmentTypeRoomMapInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutRelatedTrupanionExamDayOffersInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutSurveyAppointmentTypeSettingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutTaxonomyInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutTrupanionIntegratedAppointmentTypeInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutUserAppointmentGroupingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeCreateWithoutWorkflowsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutAppointmentTypeInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutAppoinmentTypesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutAppointmentTypesInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeGroupByOutputType = {
  __typename?: 'AppointmentTypeGroupByOutputType';
  _avg?: Maybe<AppointmentTypeAvgAggregateOutputType>;
  _count?: Maybe<AppointmentTypeCountAggregateOutputType>;
  _max?: Maybe<AppointmentTypeMaxAggregateOutputType>;
  _min?: Maybe<AppointmentTypeMinAggregateOutputType>;
  _sum?: Maybe<AppointmentTypeSumAggregateOutputType>;
  appointmentTypeVisibility: AppointmentTypeVisibility;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultDurationInMinutes: Scalars['Int'];
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount: Scalars['Int'];
  depositCurrency: Currency;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit: Scalars['Boolean'];
  id: Scalars['String'];
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  markPaymentAsDeposit: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal: Scalars['Boolean'];
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type AppointmentTypeListRelationFilter = {
  every?: Maybe<AppointmentTypeWhereInput>;
  none?: Maybe<AppointmentTypeWhereInput>;
  some?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeMaxAggregateOutputType = {
  __typename?: 'AppointmentTypeMaxAggregateOutputType';
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeMaxOrderByAggregateInput = {
  appointmentTypeVisibility?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultDurationInMinutes?: Maybe<SortOrder>;
  defaultSoonestAvailableBookingInHours?: Maybe<SortOrder>;
  delayedStartTime?: Maybe<SortOrder>;
  depositAmount?: Maybe<SortOrder>;
  depositCurrency?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  hasDeposit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isAvailableForDirectBooking?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  markPaymentAsDeposit?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  showInPetPortal?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AppointmentTypeMinAggregateOutputType = {
  __typename?: 'AppointmentTypeMinAggregateOutputType';
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeMinOrderByAggregateInput = {
  appointmentTypeVisibility?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultDurationInMinutes?: Maybe<SortOrder>;
  defaultSoonestAvailableBookingInHours?: Maybe<SortOrder>;
  delayedStartTime?: Maybe<SortOrder>;
  depositAmount?: Maybe<SortOrder>;
  depositCurrency?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  hasDeposit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isAvailableForDirectBooking?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  markPaymentAsDeposit?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  showInPetPortal?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AppointmentTypeNullableScalarRelationFilter = {
  AND?: Maybe<Array<AppointmentTypeWhereInput>>;
  NOT?: Maybe<Array<AppointmentTypeWhereInput>>;
  OR?: Maybe<Array<AppointmentTypeWhereInput>>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapListRelationFilter>;
  appointmentTypeVisibility?: Maybe<EnumAppointmentTypeVisibilityFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultDurationInMinutes?: Maybe<IntFilter>;
  defaultSoonestAvailableBookingInHours?: Maybe<IntNullableFilter>;
  delayedStartTime?: Maybe<IntNullableFilter>;
  depositAmount?: Maybe<IntFilter>;
  depositCurrency?: Maybe<EnumCurrencyFilter>;
  description?: Maybe<StringNullableFilter>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingNullableScalarRelationFilter>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleListRelationFilter>;
  displayName?: Maybe<StringNullableFilter>;
  displayOrder?: Maybe<IntNullableFilter>;
  hasDeposit?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isAvailableForDirectBooking?: Maybe<BoolFilter>;
  isVisible?: Maybe<BoolFilter>;
  markPaymentAsDeposit?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  showInPetPortal?: Maybe<BoolFilter>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingListRelationFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeNullableScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  workflows?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type AppointmentTypeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type AppointmentTypeOrderByRelationAndSearchRelevanceInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapOrderByRelationAggregateInput>;
  _relevance?: Maybe<AppointmentTypeOrderByRelevanceInput>;
  appointmentTypeVisibility?: Maybe<SortOrder>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  defaultDurationInMinutes?: Maybe<SortOrder>;
  defaultSoonestAvailableBookingInHours?: Maybe<SortOrder>;
  delayedStartTime?: Maybe<SortOrder>;
  depositAmount?: Maybe<SortOrder>;
  depositCurrency?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingOrderByWithRelationInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleOrderByRelationAggregateInput>;
  displayName?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  hasDeposit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isAvailableForDirectBooking?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  markPaymentAsDeposit?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  resourceUid?: Maybe<SortOrder>;
  showInPetPortal?: Maybe<SortOrder>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingOrderByRelationAggregateInput>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  workflows?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum AppointmentTypeOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Description = 'description',
  DisplayName = 'displayName',
  Id = 'id',
  IntegrationId = 'integrationId',
  Name = 'name',
  PimsId = 'pimsId',
  ResourceUid = 'resourceUid',
  TaxonomyId = 'taxonomyId'
}

export type AppointmentTypeOrderByRelevanceInput = {
  fields: Array<AppointmentTypeOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type AppointmentTypeOrderByWithAggregationInput = {
  _avg?: Maybe<AppointmentTypeAvgOrderByAggregateInput>;
  _count?: Maybe<AppointmentTypeCountOrderByAggregateInput>;
  _max?: Maybe<AppointmentTypeMaxOrderByAggregateInput>;
  _min?: Maybe<AppointmentTypeMinOrderByAggregateInput>;
  _sum?: Maybe<AppointmentTypeSumOrderByAggregateInput>;
  appointmentTypeVisibility?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultDurationInMinutes?: Maybe<SortOrder>;
  defaultSoonestAvailableBookingInHours?: Maybe<SortOrder>;
  delayedStartTime?: Maybe<SortOrder>;
  depositAmount?: Maybe<SortOrder>;
  depositCurrency?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  hasDeposit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isAvailableForDirectBooking?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  markPaymentAsDeposit?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  showInPetPortal?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AppointmentTypeOrderByWithRelationAndSearchRelevanceInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapOrderByRelationAggregateInput>;
  _relevance?: Maybe<AppointmentTypeOrderByRelevanceInput>;
  appointmentTypeVisibility?: Maybe<SortOrder>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  defaultDurationInMinutes?: Maybe<SortOrder>;
  defaultSoonestAvailableBookingInHours?: Maybe<SortOrder>;
  delayedStartTime?: Maybe<SortOrder>;
  depositAmount?: Maybe<SortOrder>;
  depositCurrency?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingOrderByWithRelationInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleOrderByRelationAggregateInput>;
  displayName?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  hasDeposit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isAvailableForDirectBooking?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  markPaymentAsDeposit?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  resourceUid?: Maybe<SortOrder>;
  showInPetPortal?: Maybe<SortOrder>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingOrderByRelationAggregateInput>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  workflows?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export type AppointmentTypeOrderByWithRelationInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapOrderByRelationAggregateInput>;
  _relevance?: Maybe<AppointmentTypeOrderByRelevanceInput>;
  appointmentTypeVisibility?: Maybe<SortOrder>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  defaultDurationInMinutes?: Maybe<SortOrder>;
  defaultSoonestAvailableBookingInHours?: Maybe<SortOrder>;
  delayedStartTime?: Maybe<SortOrder>;
  depositAmount?: Maybe<SortOrder>;
  depositCurrency?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingOrderByWithRelationInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleOrderByRelationAggregateInput>;
  displayName?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  hasDeposit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isAvailableForDirectBooking?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  markPaymentAsDeposit?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  resourceUid?: Maybe<SortOrder>;
  showInPetPortal?: Maybe<SortOrder>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingOrderByRelationAggregateInput>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  workflows?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum AppointmentTypeScalarFieldEnum {
  AppointmentTypeVisibility = 'appointmentTypeVisibility',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  DefaultDurationInMinutes = 'defaultDurationInMinutes',
  DefaultSoonestAvailableBookingInHours = 'defaultSoonestAvailableBookingInHours',
  DelayedStartTime = 'delayedStartTime',
  DepositAmount = 'depositAmount',
  DepositCurrency = 'depositCurrency',
  Description = 'description',
  DisplayName = 'displayName',
  DisplayOrder = 'displayOrder',
  HasDeposit = 'hasDeposit',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsAvailableForDirectBooking = 'isAvailableForDirectBooking',
  IsVisible = 'isVisible',
  MarkPaymentAsDeposit = 'markPaymentAsDeposit',
  Name = 'name',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  ResourceUid = 'resourceUid',
  ShowInPetPortal = 'showInPetPortal',
  TaxonomyId = 'taxonomyId',
  UpdatedAt = 'updatedAt'
}

export type AppointmentTypeScalarRelationFilter = {
  AND?: Maybe<Array<AppointmentTypeWhereInput>>;
  NOT?: Maybe<Array<AppointmentTypeWhereInput>>;
  OR?: Maybe<Array<AppointmentTypeWhereInput>>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapListRelationFilter>;
  appointmentTypeVisibility?: Maybe<EnumAppointmentTypeVisibilityFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultDurationInMinutes?: Maybe<IntFilter>;
  defaultSoonestAvailableBookingInHours?: Maybe<IntNullableFilter>;
  delayedStartTime?: Maybe<IntNullableFilter>;
  depositAmount?: Maybe<IntFilter>;
  depositCurrency?: Maybe<EnumCurrencyFilter>;
  description?: Maybe<StringNullableFilter>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingNullableScalarRelationFilter>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleListRelationFilter>;
  displayName?: Maybe<StringNullableFilter>;
  displayOrder?: Maybe<IntNullableFilter>;
  hasDeposit?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isAvailableForDirectBooking?: Maybe<BoolFilter>;
  isVisible?: Maybe<BoolFilter>;
  markPaymentAsDeposit?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  showInPetPortal?: Maybe<BoolFilter>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingListRelationFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeNullableScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  workflows?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type AppointmentTypeScalarWhereInput = {
  AND?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  NOT?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  OR?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  appointmentTypeVisibility?: Maybe<EnumAppointmentTypeVisibilityFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultDurationInMinutes?: Maybe<IntFilter>;
  defaultSoonestAvailableBookingInHours?: Maybe<IntNullableFilter>;
  delayedStartTime?: Maybe<IntNullableFilter>;
  depositAmount?: Maybe<IntFilter>;
  depositCurrency?: Maybe<EnumCurrencyFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  displayOrder?: Maybe<IntNullableFilter>;
  hasDeposit?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isAvailableForDirectBooking?: Maybe<BoolFilter>;
  isVisible?: Maybe<BoolFilter>;
  markPaymentAsDeposit?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  showInPetPortal?: Maybe<BoolFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AppointmentTypeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<AppointmentTypeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<AppointmentTypeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<AppointmentTypeScalarWhereWithAggregatesInput>>;
  appointmentTypeVisibility?: Maybe<EnumAppointmentTypeVisibilityWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  defaultDurationInMinutes?: Maybe<IntWithAggregatesFilter>;
  defaultSoonestAvailableBookingInHours?: Maybe<IntNullableWithAggregatesFilter>;
  delayedStartTime?: Maybe<IntNullableWithAggregatesFilter>;
  depositAmount?: Maybe<IntWithAggregatesFilter>;
  depositCurrency?: Maybe<EnumCurrencyWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  displayName?: Maybe<StringNullableWithAggregatesFilter>;
  displayOrder?: Maybe<IntNullableWithAggregatesFilter>;
  hasDeposit?: Maybe<BoolWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  isAvailableForDirectBooking?: Maybe<BoolWithAggregatesFilter>;
  isVisible?: Maybe<BoolWithAggregatesFilter>;
  markPaymentAsDeposit?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  resourceUid?: Maybe<StringNullableWithAggregatesFilter>;
  showInPetPortal?: Maybe<BoolWithAggregatesFilter>;
  taxonomyId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type AppointmentTypeSumAggregateOutputType = {
  __typename?: 'AppointmentTypeSumAggregateOutputType';
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  displayOrder?: Maybe<Scalars['Int']>;
};

export type AppointmentTypeSumOrderByAggregateInput = {
  defaultDurationInMinutes?: Maybe<SortOrder>;
  defaultSoonestAvailableBookingInHours?: Maybe<SortOrder>;
  delayedStartTime?: Maybe<SortOrder>;
  depositAmount?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
};

export type AppointmentTypeUncheckedCreateInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentTypeCreateManyClinicInputEnvelope>;
};

export type AppointmentTypeUncheckedCreateNestedManyWithoutDirectBookingExclusionRulesInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutDirectBookingExclusionRulesInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutDirectBookingExclusionRulesInput>>;
};

export type AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutIntegrationInput>>;
  createMany?: Maybe<AppointmentTypeCreateManyIntegrationInputEnvelope>;
};

export type AppointmentTypeUncheckedCreateNestedManyWithoutTaxonomyInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<AppointmentTypeCreateManyTaxonomyInputEnvelope>;
};

export type AppointmentTypeUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutUserAppointmentGroupingsInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutUserAppointmentGroupingsInput>>;
};

export type AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutWorkflowsInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutWorkflowsInput>>;
};

export type AppointmentTypeUncheckedCreateWithoutAppointmentsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutClinicInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutClinicWorkflowTypesInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutDirectBookingAppointmentTypeSettingInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutDirectBookingExclusionRulesInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutIntegrationInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutProviderAppointmentTypeRoomMapInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutRelatedTrupanionExamDayOffersInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutSurveyAppointmentTypeSettingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutTaxonomyInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutTrupanionIntegratedAppointmentTypeInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutUserAppointmentGroupingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedCreateWithoutWorkflowsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput>;
};

export type AppointmentTypeUncheckedUpdateInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateManyInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeUncheckedUpdateManyWithoutClinicInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentTypeCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentTypeUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<AppointmentTypeUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<AppointmentTypeUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type AppointmentTypeUncheckedUpdateManyWithoutDirectBookingExclusionRulesInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeUncheckedUpdateManyWithoutDirectBookingExclusionRulesNestedInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutDirectBookingExclusionRulesInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutDirectBookingExclusionRulesInput>>;
  delete?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentTypeUpdateWithWhereUniqueWithoutDirectBookingExclusionRulesInput>>;
  updateMany?: Maybe<Array<AppointmentTypeUpdateManyWithWhereWithoutDirectBookingExclusionRulesInput>>;
  upsert?: Maybe<Array<AppointmentTypeUpsertWithWhereUniqueWithoutDirectBookingExclusionRulesInput>>;
};

export type AppointmentTypeUncheckedUpdateManyWithoutIntegrationInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutIntegrationInput>>;
  createMany?: Maybe<AppointmentTypeCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentTypeUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<AppointmentTypeUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<AppointmentTypeUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type AppointmentTypeUncheckedUpdateManyWithoutTaxonomyInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeUncheckedUpdateManyWithoutTaxonomyNestedInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<AppointmentTypeCreateManyTaxonomyInputEnvelope>;
  delete?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentTypeUpdateWithWhereUniqueWithoutTaxonomyInput>>;
  updateMany?: Maybe<Array<AppointmentTypeUpdateManyWithWhereWithoutTaxonomyInput>>;
  upsert?: Maybe<Array<AppointmentTypeUpsertWithWhereUniqueWithoutTaxonomyInput>>;
};

export type AppointmentTypeUncheckedUpdateManyWithoutUserAppointmentGroupingsInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutUserAppointmentGroupingsInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutUserAppointmentGroupingsInput>>;
  delete?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentTypeUpdateWithWhereUniqueWithoutUserAppointmentGroupingsInput>>;
  updateMany?: Maybe<Array<AppointmentTypeUpdateManyWithWhereWithoutUserAppointmentGroupingsInput>>;
  upsert?: Maybe<Array<AppointmentTypeUpsertWithWhereUniqueWithoutUserAppointmentGroupingsInput>>;
};

export type AppointmentTypeUncheckedUpdateManyWithoutWorkflowsInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutWorkflowsInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutWorkflowsInput>>;
  delete?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentTypeUpdateWithWhereUniqueWithoutWorkflowsInput>>;
  updateMany?: Maybe<Array<AppointmentTypeUpdateManyWithWhereWithoutWorkflowsInput>>;
  upsert?: Maybe<Array<AppointmentTypeUpsertWithWhereUniqueWithoutWorkflowsInput>>;
};

export type AppointmentTypeUncheckedUpdateWithoutAppointmentsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutClinicInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutClinicWorkflowTypesInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutDirectBookingAppointmentTypeSettingInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutDirectBookingExclusionRulesInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutIntegrationInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutProviderAppointmentTypeRoomMapInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutRelatedTrupanionExamDayOffersInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutSurveyAppointmentTypeSettingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutTaxonomyInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutTrupanionIntegratedAppointmentTypeInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutUserAppointmentGroupingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUncheckedUpdateWithoutWorkflowsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateManyMutationInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentTypeUpdateManyWithWhereWithoutClinicInput = {
  data: AppointmentTypeUpdateManyMutationInput;
  where: AppointmentTypeScalarWhereInput;
};

export type AppointmentTypeUpdateManyWithWhereWithoutDirectBookingExclusionRulesInput = {
  data: AppointmentTypeUpdateManyMutationInput;
  where: AppointmentTypeScalarWhereInput;
};

export type AppointmentTypeUpdateManyWithWhereWithoutIntegrationInput = {
  data: AppointmentTypeUpdateManyMutationInput;
  where: AppointmentTypeScalarWhereInput;
};

export type AppointmentTypeUpdateManyWithWhereWithoutTaxonomyInput = {
  data: AppointmentTypeUpdateManyMutationInput;
  where: AppointmentTypeScalarWhereInput;
};

export type AppointmentTypeUpdateManyWithWhereWithoutUserAppointmentGroupingsInput = {
  data: AppointmentTypeUpdateManyMutationInput;
  where: AppointmentTypeScalarWhereInput;
};

export type AppointmentTypeUpdateManyWithWhereWithoutWorkflowsInput = {
  data: AppointmentTypeUpdateManyMutationInput;
  where: AppointmentTypeScalarWhereInput;
};

export type AppointmentTypeUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentTypeCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentTypeUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<AppointmentTypeUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<AppointmentTypeUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type AppointmentTypeUpdateManyWithoutDirectBookingExclusionRulesNestedInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutDirectBookingExclusionRulesInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutDirectBookingExclusionRulesInput>>;
  delete?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentTypeUpdateWithWhereUniqueWithoutDirectBookingExclusionRulesInput>>;
  updateMany?: Maybe<Array<AppointmentTypeUpdateManyWithWhereWithoutDirectBookingExclusionRulesInput>>;
  upsert?: Maybe<Array<AppointmentTypeUpsertWithWhereUniqueWithoutDirectBookingExclusionRulesInput>>;
};

export type AppointmentTypeUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutIntegrationInput>>;
  createMany?: Maybe<AppointmentTypeCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentTypeUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<AppointmentTypeUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<AppointmentTypeUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type AppointmentTypeUpdateManyWithoutTaxonomyNestedInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<AppointmentTypeCreateManyTaxonomyInputEnvelope>;
  delete?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentTypeUpdateWithWhereUniqueWithoutTaxonomyInput>>;
  updateMany?: Maybe<Array<AppointmentTypeUpdateManyWithWhereWithoutTaxonomyInput>>;
  upsert?: Maybe<Array<AppointmentTypeUpsertWithWhereUniqueWithoutTaxonomyInput>>;
};

export type AppointmentTypeUpdateManyWithoutUserAppointmentGroupingsNestedInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutUserAppointmentGroupingsInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutUserAppointmentGroupingsInput>>;
  delete?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentTypeUpdateWithWhereUniqueWithoutUserAppointmentGroupingsInput>>;
  updateMany?: Maybe<Array<AppointmentTypeUpdateManyWithWhereWithoutUserAppointmentGroupingsInput>>;
  upsert?: Maybe<Array<AppointmentTypeUpsertWithWhereUniqueWithoutUserAppointmentGroupingsInput>>;
};

export type AppointmentTypeUpdateManyWithoutWorkflowsNestedInput = {
  connect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentTypeCreateOrConnectWithoutWorkflowsInput>>;
  create?: Maybe<Array<AppointmentTypeCreateWithoutWorkflowsInput>>;
  delete?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentTypeUpdateWithWhereUniqueWithoutWorkflowsInput>>;
  updateMany?: Maybe<Array<AppointmentTypeUpdateManyWithWhereWithoutWorkflowsInput>>;
  upsert?: Maybe<Array<AppointmentTypeUpsertWithWhereUniqueWithoutWorkflowsInput>>;
};

export type AppointmentTypeUpdateOneRequiredWithoutClinicEmployeeAppointmentTypeSettingsNestedInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutClinicEmployeeAppointmentTypeSettingsInput>;
  create?: Maybe<AppointmentTypeCreateWithoutClinicEmployeeAppointmentTypeSettingsInput>;
  update?: Maybe<AppointmentTypeUpdateToOneWithWhereWithoutClinicEmployeeAppointmentTypeSettingsInput>;
  upsert?: Maybe<AppointmentTypeUpsertWithoutClinicEmployeeAppointmentTypeSettingsInput>;
};

export type AppointmentTypeUpdateOneRequiredWithoutDirectBookingAppointmentTypeSettingNestedInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutDirectBookingAppointmentTypeSettingInput>;
  create?: Maybe<AppointmentTypeCreateWithoutDirectBookingAppointmentTypeSettingInput>;
  update?: Maybe<AppointmentTypeUpdateToOneWithWhereWithoutDirectBookingAppointmentTypeSettingInput>;
  upsert?: Maybe<AppointmentTypeUpsertWithoutDirectBookingAppointmentTypeSettingInput>;
};

export type AppointmentTypeUpdateOneRequiredWithoutSurveyAppointmentTypeSettingsNestedInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutSurveyAppointmentTypeSettingsInput>;
  create?: Maybe<AppointmentTypeCreateWithoutSurveyAppointmentTypeSettingsInput>;
  update?: Maybe<AppointmentTypeUpdateToOneWithWhereWithoutSurveyAppointmentTypeSettingsInput>;
  upsert?: Maybe<AppointmentTypeUpsertWithoutSurveyAppointmentTypeSettingsInput>;
};

export type AppointmentTypeUpdateOneRequiredWithoutTrupanionIntegratedAppointmentTypeNestedInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutTrupanionIntegratedAppointmentTypeInput>;
  create?: Maybe<AppointmentTypeCreateWithoutTrupanionIntegratedAppointmentTypeInput>;
  update?: Maybe<AppointmentTypeUpdateToOneWithWhereWithoutTrupanionIntegratedAppointmentTypeInput>;
  upsert?: Maybe<AppointmentTypeUpsertWithoutTrupanionIntegratedAppointmentTypeInput>;
};

export type AppointmentTypeUpdateOneWithoutAppointmentsNestedInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<AppointmentTypeCreateWithoutAppointmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AppointmentTypeUpdateToOneWithWhereWithoutAppointmentsInput>;
  upsert?: Maybe<AppointmentTypeUpsertWithoutAppointmentsInput>;
};

export type AppointmentTypeUpdateOneWithoutClinicWorkflowTypesNestedInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutClinicWorkflowTypesInput>;
  create?: Maybe<AppointmentTypeCreateWithoutClinicWorkflowTypesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AppointmentTypeUpdateToOneWithWhereWithoutClinicWorkflowTypesInput>;
  upsert?: Maybe<AppointmentTypeUpsertWithoutClinicWorkflowTypesInput>;
};

export type AppointmentTypeUpdateOneWithoutProviderAppointmentTypeRoomMapNestedInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutProviderAppointmentTypeRoomMapInput>;
  create?: Maybe<AppointmentTypeCreateWithoutProviderAppointmentTypeRoomMapInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AppointmentTypeUpdateToOneWithWhereWithoutProviderAppointmentTypeRoomMapInput>;
  upsert?: Maybe<AppointmentTypeUpsertWithoutProviderAppointmentTypeRoomMapInput>;
};

export type AppointmentTypeUpdateOneWithoutRelatedTrupanionExamDayOffersNestedInput = {
  connect?: Maybe<AppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentTypeCreateOrConnectWithoutRelatedTrupanionExamDayOffersInput>;
  create?: Maybe<AppointmentTypeCreateWithoutRelatedTrupanionExamDayOffersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AppointmentTypeUpdateToOneWithWhereWithoutRelatedTrupanionExamDayOffersInput>;
  upsert?: Maybe<AppointmentTypeUpsertWithoutRelatedTrupanionExamDayOffersInput>;
};

export type AppointmentTypeUpdateToOneWithWhereWithoutAppointmentsInput = {
  data: AppointmentTypeUpdateWithoutAppointmentsInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpdateToOneWithWhereWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  data: AppointmentTypeUpdateWithoutClinicEmployeeAppointmentTypeSettingsInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpdateToOneWithWhereWithoutClinicWorkflowTypesInput = {
  data: AppointmentTypeUpdateWithoutClinicWorkflowTypesInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpdateToOneWithWhereWithoutDirectBookingAppointmentTypeSettingInput = {
  data: AppointmentTypeUpdateWithoutDirectBookingAppointmentTypeSettingInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpdateToOneWithWhereWithoutProviderAppointmentTypeRoomMapInput = {
  data: AppointmentTypeUpdateWithoutProviderAppointmentTypeRoomMapInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpdateToOneWithWhereWithoutRelatedTrupanionExamDayOffersInput = {
  data: AppointmentTypeUpdateWithoutRelatedTrupanionExamDayOffersInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpdateToOneWithWhereWithoutSurveyAppointmentTypeSettingsInput = {
  data: AppointmentTypeUpdateWithoutSurveyAppointmentTypeSettingsInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpdateToOneWithWhereWithoutTrupanionIntegratedAppointmentTypeInput = {
  data: AppointmentTypeUpdateWithoutTrupanionIntegratedAppointmentTypeInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpdateWithWhereUniqueWithoutClinicInput = {
  data: AppointmentTypeUpdateWithoutClinicInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeUpdateWithWhereUniqueWithoutDirectBookingExclusionRulesInput = {
  data: AppointmentTypeUpdateWithoutDirectBookingExclusionRulesInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: AppointmentTypeUpdateWithoutIntegrationInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeUpdateWithWhereUniqueWithoutTaxonomyInput = {
  data: AppointmentTypeUpdateWithoutTaxonomyInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeUpdateWithWhereUniqueWithoutUserAppointmentGroupingsInput = {
  data: AppointmentTypeUpdateWithoutUserAppointmentGroupingsInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeUpdateWithWhereUniqueWithoutWorkflowsInput = {
  data: AppointmentTypeUpdateWithoutWorkflowsInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeUpdateWithoutAppointmentsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutClinicInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutClinicWorkflowTypesInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutDirectBookingAppointmentTypeSettingInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutDirectBookingExclusionRulesInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutIntegrationInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutProviderAppointmentTypeRoomMapInput = {
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutRelatedTrupanionExamDayOffersInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutSurveyAppointmentTypeSettingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutTaxonomyInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutTrupanionIntegratedAppointmentTypeInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutUserAppointmentGroupingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpdateWithoutWorkflowsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput>;
  appointmentTypeVisibility?: Maybe<AppointmentTypeVisibility>;
  appointments?: Maybe<AppointmentUpdateManyWithoutAppointmentTypeNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppoinmentTypesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput>;
  isAvailableForDirectBooking?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal?: Maybe<Scalars['Boolean']>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentTypesNestedInput>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput>;
};

export type AppointmentTypeUpsertWithWhereUniqueWithoutClinicInput = {
  create: AppointmentTypeCreateWithoutClinicInput;
  update: AppointmentTypeUpdateWithoutClinicInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeUpsertWithWhereUniqueWithoutDirectBookingExclusionRulesInput = {
  create: AppointmentTypeCreateWithoutDirectBookingExclusionRulesInput;
  update: AppointmentTypeUpdateWithoutDirectBookingExclusionRulesInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: AppointmentTypeCreateWithoutIntegrationInput;
  update: AppointmentTypeUpdateWithoutIntegrationInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeUpsertWithWhereUniqueWithoutTaxonomyInput = {
  create: AppointmentTypeCreateWithoutTaxonomyInput;
  update: AppointmentTypeUpdateWithoutTaxonomyInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeUpsertWithWhereUniqueWithoutUserAppointmentGroupingsInput = {
  create: AppointmentTypeCreateWithoutUserAppointmentGroupingsInput;
  update: AppointmentTypeUpdateWithoutUserAppointmentGroupingsInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeUpsertWithWhereUniqueWithoutWorkflowsInput = {
  create: AppointmentTypeCreateWithoutWorkflowsInput;
  update: AppointmentTypeUpdateWithoutWorkflowsInput;
  where: AppointmentTypeWhereUniqueInput;
};

export type AppointmentTypeUpsertWithoutAppointmentsInput = {
  create: AppointmentTypeCreateWithoutAppointmentsInput;
  update: AppointmentTypeUpdateWithoutAppointmentsInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpsertWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  create: AppointmentTypeCreateWithoutClinicEmployeeAppointmentTypeSettingsInput;
  update: AppointmentTypeUpdateWithoutClinicEmployeeAppointmentTypeSettingsInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpsertWithoutClinicWorkflowTypesInput = {
  create: AppointmentTypeCreateWithoutClinicWorkflowTypesInput;
  update: AppointmentTypeUpdateWithoutClinicWorkflowTypesInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpsertWithoutDirectBookingAppointmentTypeSettingInput = {
  create: AppointmentTypeCreateWithoutDirectBookingAppointmentTypeSettingInput;
  update: AppointmentTypeUpdateWithoutDirectBookingAppointmentTypeSettingInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpsertWithoutProviderAppointmentTypeRoomMapInput = {
  create: AppointmentTypeCreateWithoutProviderAppointmentTypeRoomMapInput;
  update: AppointmentTypeUpdateWithoutProviderAppointmentTypeRoomMapInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpsertWithoutRelatedTrupanionExamDayOffersInput = {
  create: AppointmentTypeCreateWithoutRelatedTrupanionExamDayOffersInput;
  update: AppointmentTypeUpdateWithoutRelatedTrupanionExamDayOffersInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpsertWithoutSurveyAppointmentTypeSettingsInput = {
  create: AppointmentTypeCreateWithoutSurveyAppointmentTypeSettingsInput;
  update: AppointmentTypeUpdateWithoutSurveyAppointmentTypeSettingsInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type AppointmentTypeUpsertWithoutTrupanionIntegratedAppointmentTypeInput = {
  create: AppointmentTypeCreateWithoutTrupanionIntegratedAppointmentTypeInput;
  update: AppointmentTypeUpdateWithoutTrupanionIntegratedAppointmentTypeInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};

export enum AppointmentTypeVisibility {
  HideAll = 'HideAll',
  HideFromCalendarOnly = 'HideFromCalendarOnly',
  HideFromDropDownOnly = 'HideFromDropDownOnly',
  ShowAll = 'ShowAll'
}

export type AppointmentTypeWhereInput = {
  AND?: Maybe<Array<AppointmentTypeWhereInput>>;
  NOT?: Maybe<Array<AppointmentTypeWhereInput>>;
  OR?: Maybe<Array<AppointmentTypeWhereInput>>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapListRelationFilter>;
  appointmentTypeVisibility?: Maybe<EnumAppointmentTypeVisibilityFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultDurationInMinutes?: Maybe<IntFilter>;
  defaultSoonestAvailableBookingInHours?: Maybe<IntNullableFilter>;
  delayedStartTime?: Maybe<IntNullableFilter>;
  depositAmount?: Maybe<IntFilter>;
  depositCurrency?: Maybe<EnumCurrencyFilter>;
  description?: Maybe<StringNullableFilter>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingNullableScalarRelationFilter>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleListRelationFilter>;
  displayName?: Maybe<StringNullableFilter>;
  displayOrder?: Maybe<IntNullableFilter>;
  hasDeposit?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isAvailableForDirectBooking?: Maybe<BoolFilter>;
  isVisible?: Maybe<BoolFilter>;
  markPaymentAsDeposit?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  showInPetPortal?: Maybe<BoolFilter>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingListRelationFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeNullableScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  workflows?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type AppointmentTypeWhereUniqueInput = {
  AND?: Maybe<Array<AppointmentTypeWhereInput>>;
  NOT?: Maybe<Array<AppointmentTypeWhereInput>>;
  OR?: Maybe<Array<AppointmentTypeWhereInput>>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapListRelationFilter>;
  appointmentTypePimsIdAndIntegrationId?: Maybe<AppointmentTypeAppointmentTypePimsIdAndIntegrationIdCompoundUniqueInput>;
  appointmentTypeVisibility?: Maybe<EnumAppointmentTypeVisibilityFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultDurationInMinutes?: Maybe<IntFilter>;
  defaultSoonestAvailableBookingInHours?: Maybe<IntNullableFilter>;
  delayedStartTime?: Maybe<IntNullableFilter>;
  depositAmount?: Maybe<IntFilter>;
  depositCurrency?: Maybe<EnumCurrencyFilter>;
  description?: Maybe<StringNullableFilter>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingNullableScalarRelationFilter>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleListRelationFilter>;
  displayName?: Maybe<StringNullableFilter>;
  displayOrder?: Maybe<IntNullableFilter>;
  hasDeposit?: Maybe<BoolFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isAvailableForDirectBooking?: Maybe<BoolFilter>;
  isVisible?: Maybe<BoolFilter>;
  markPaymentAsDeposit?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  relatedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  showInPetPortal?: Maybe<BoolFilter>;
  surveyAppointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingListRelationFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  trupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentTypeNullableScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  workflows?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type AppointmentTypeWithOrder = {
  displayOrder: Scalars['Int'];
  id: Scalars['String'];
};

export type AppointmentTypeWithOrderResponse = {
  __typename?: 'AppointmentTypeWithOrderResponse';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AppointmentUncheckedCreateInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateNestedManyWithoutAppointmentTypeInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<AppointmentCreateManyAppointmentTypeInputEnvelope>;
};

export type AppointmentUncheckedCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutChannelInput>>;
  createMany?: Maybe<AppointmentCreateManyChannelInputEnvelope>;
};

export type AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicEmployeesInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicEmployeesInput>>;
};

export type AppointmentUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentCreateManyClinicInputEnvelope>;
};

export type AppointmentUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicPetInput>>;
  createMany?: Maybe<AppointmentCreateManyClinicPetInputEnvelope>;
};

export type AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicPetParentsInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicPetParentsInput>>;
};

export type AppointmentUncheckedCreateNestedManyWithoutConsultationInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutConsultationInput>>;
  createMany?: Maybe<AppointmentCreateManyConsultationInputEnvelope>;
};

export type AppointmentUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutIntegrationInput>>;
  createMany?: Maybe<AppointmentCreateManyIntegrationInputEnvelope>;
};

export type AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutRecapNotesUpdatedByInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutRecapNotesUpdatedByInput>>;
  createMany?: Maybe<AppointmentCreateManyRecapNotesUpdatedByInputEnvelope>;
};

export type AppointmentUncheckedCreateNestedManyWithoutRoomInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutRoomInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutRoomInput>>;
  createMany?: Maybe<AppointmentCreateManyRoomInputEnvelope>;
};

export type AppointmentUncheckedCreateNestedManyWithoutTaxonomyInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<AppointmentCreateManyTaxonomyInputEnvelope>;
};

export type AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutWorkflowsInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutWorkflowsInput>>;
};

export type AppointmentUncheckedCreateWithoutAiRecapPimsWritebackLogEntryInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutAppointmentTypeInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutAutomationRunsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutChannelAutomationStatusesInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutChannelInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutClinicEmployeesInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutClinicInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutClinicPetInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutClinicPetParentsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutConsultationInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutDirectBookingWidgetRequestInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutFormSubmissionsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutIntegrationInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutMassTextAlertEntryAppointmentsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutPushNotificationLogsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutRecapNotesUpdatedByInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutRecapsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutRoomInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutSurveyResultsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutTasksInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutTaxonomyInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutWorkflowTriggersInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput>;
};

export type AppointmentUncheckedCreateWithoutWorkflowsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedManyWithoutAppointmentInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput>;
  durationInMinutes: Scalars['Int'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutAppointmentInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAppointmentInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput>;
};

export type AppointmentUncheckedUpdateInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateManyInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutAppointmentTypeInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<AppointmentCreateManyAppointmentTypeInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutAppointmentTypeInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutAppointmentTypeInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutAppointmentTypeInput>>;
};

export type AppointmentUncheckedUpdateManyWithoutChannelInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutChannelInput>>;
  createMany?: Maybe<AppointmentCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type AppointmentUncheckedUpdateManyWithoutClinicEmployeesInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicEmployeesInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicEmployeesInput>>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutClinicEmployeesInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutClinicEmployeesInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutClinicEmployeesInput>>;
};

export type AppointmentUncheckedUpdateManyWithoutClinicInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type AppointmentUncheckedUpdateManyWithoutClinicPetInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicPetInput>>;
  createMany?: Maybe<AppointmentCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type AppointmentUncheckedUpdateManyWithoutClinicPetParentsInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicPetParentsInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicPetParentsInput>>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutClinicPetParentsInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutClinicPetParentsInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutClinicPetParentsInput>>;
};

export type AppointmentUncheckedUpdateManyWithoutConsultationInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutConsultationNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutConsultationInput>>;
  createMany?: Maybe<AppointmentCreateManyConsultationInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutConsultationInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutConsultationInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutConsultationInput>>;
};

export type AppointmentUncheckedUpdateManyWithoutIntegrationInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutIntegrationInput>>;
  createMany?: Maybe<AppointmentCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutRecapNotesUpdatedByInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutRecapNotesUpdatedByInput>>;
  createMany?: Maybe<AppointmentCreateManyRecapNotesUpdatedByInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutRecapNotesUpdatedByInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutRecapNotesUpdatedByInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutRecapNotesUpdatedByInput>>;
};

export type AppointmentUncheckedUpdateManyWithoutRoomInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutRoomNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutRoomInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutRoomInput>>;
  createMany?: Maybe<AppointmentCreateManyRoomInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutRoomInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutRoomInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutRoomInput>>;
};

export type AppointmentUncheckedUpdateManyWithoutTaxonomyInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutTaxonomyNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<AppointmentCreateManyTaxonomyInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutTaxonomyInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutTaxonomyInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutTaxonomyInput>>;
};

export type AppointmentUncheckedUpdateManyWithoutWorkflowsInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutWorkflowsInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutWorkflowsInput>>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutWorkflowsInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutWorkflowsInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutWorkflowsInput>>;
};

export type AppointmentUncheckedUpdateWithoutAiRecapPimsWritebackLogEntryInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutAppointmentTypeInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutAutomationRunsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutChannelAutomationStatusesInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutChannelInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutClinicEmployeesInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutClinicInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutClinicPetInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutClinicPetParentsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutConsultationInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutDirectBookingWidgetRequestInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutFormSubmissionsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutIntegrationInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutMassTextAlertEntryAppointmentsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutPushNotificationLogsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutRecapNotesUpdatedByInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutRecapsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutRoomInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutSurveyResultsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutTasksInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutTaxonomyInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutWorkflowTriggersInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUncheckedUpdateWithoutWorkflowsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateManyWithoutAppointmentNestedInput>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput>;
  channelId?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutAppointmentNestedInput>;
  roomId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAppointmentNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput>;
};

export type AppointmentUpdateInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
};

export type AppointmentUpdateManyWithWhereWithoutAppointmentTypeInput = {
  data: AppointmentUpdateManyMutationInput;
  where: AppointmentScalarWhereInput;
};

export type AppointmentUpdateManyWithWhereWithoutChannelInput = {
  data: AppointmentUpdateManyMutationInput;
  where: AppointmentScalarWhereInput;
};

export type AppointmentUpdateManyWithWhereWithoutClinicEmployeesInput = {
  data: AppointmentUpdateManyMutationInput;
  where: AppointmentScalarWhereInput;
};

export type AppointmentUpdateManyWithWhereWithoutClinicInput = {
  data: AppointmentUpdateManyMutationInput;
  where: AppointmentScalarWhereInput;
};

export type AppointmentUpdateManyWithWhereWithoutClinicPetInput = {
  data: AppointmentUpdateManyMutationInput;
  where: AppointmentScalarWhereInput;
};

export type AppointmentUpdateManyWithWhereWithoutClinicPetParentsInput = {
  data: AppointmentUpdateManyMutationInput;
  where: AppointmentScalarWhereInput;
};

export type AppointmentUpdateManyWithWhereWithoutConsultationInput = {
  data: AppointmentUpdateManyMutationInput;
  where: AppointmentScalarWhereInput;
};

export type AppointmentUpdateManyWithWhereWithoutIntegrationInput = {
  data: AppointmentUpdateManyMutationInput;
  where: AppointmentScalarWhereInput;
};

export type AppointmentUpdateManyWithWhereWithoutRecapNotesUpdatedByInput = {
  data: AppointmentUpdateManyMutationInput;
  where: AppointmentScalarWhereInput;
};

export type AppointmentUpdateManyWithWhereWithoutRoomInput = {
  data: AppointmentUpdateManyMutationInput;
  where: AppointmentScalarWhereInput;
};

export type AppointmentUpdateManyWithWhereWithoutTaxonomyInput = {
  data: AppointmentUpdateManyMutationInput;
  where: AppointmentScalarWhereInput;
};

export type AppointmentUpdateManyWithWhereWithoutWorkflowsInput = {
  data: AppointmentUpdateManyMutationInput;
  where: AppointmentScalarWhereInput;
};

export type AppointmentUpdateManyWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<AppointmentCreateManyAppointmentTypeInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutAppointmentTypeInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutAppointmentTypeInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutAppointmentTypeInput>>;
};

export type AppointmentUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutChannelInput>>;
  createMany?: Maybe<AppointmentCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type AppointmentUpdateManyWithoutClinicEmployeesNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicEmployeesInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicEmployeesInput>>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutClinicEmployeesInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutClinicEmployeesInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutClinicEmployeesInput>>;
};

export type AppointmentUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicInput>>;
  createMany?: Maybe<AppointmentCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type AppointmentUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicPetInput>>;
  createMany?: Maybe<AppointmentCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type AppointmentUpdateManyWithoutClinicPetParentsNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutClinicPetParentsInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutClinicPetParentsInput>>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutClinicPetParentsInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutClinicPetParentsInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutClinicPetParentsInput>>;
};

export type AppointmentUpdateManyWithoutConsultationNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutConsultationInput>>;
  createMany?: Maybe<AppointmentCreateManyConsultationInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutConsultationInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutConsultationInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutConsultationInput>>;
};

export type AppointmentUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutIntegrationInput>>;
  createMany?: Maybe<AppointmentCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutRecapNotesUpdatedByInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutRecapNotesUpdatedByInput>>;
  createMany?: Maybe<AppointmentCreateManyRecapNotesUpdatedByInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutRecapNotesUpdatedByInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutRecapNotesUpdatedByInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutRecapNotesUpdatedByInput>>;
};

export type AppointmentUpdateManyWithoutRoomNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutRoomInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutRoomInput>>;
  createMany?: Maybe<AppointmentCreateManyRoomInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutRoomInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutRoomInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutRoomInput>>;
};

export type AppointmentUpdateManyWithoutTaxonomyNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<AppointmentCreateManyTaxonomyInputEnvelope>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutTaxonomyInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutTaxonomyInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutTaxonomyInput>>;
};

export type AppointmentUpdateManyWithoutWorkflowsNestedInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AppointmentCreateOrConnectWithoutWorkflowsInput>>;
  create?: Maybe<Array<AppointmentCreateWithoutWorkflowsInput>>;
  delete?: Maybe<Array<AppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
  update?: Maybe<Array<AppointmentUpdateWithWhereUniqueWithoutWorkflowsInput>>;
  updateMany?: Maybe<Array<AppointmentUpdateManyWithWhereWithoutWorkflowsInput>>;
  upsert?: Maybe<Array<AppointmentUpsertWithWhereUniqueWithoutWorkflowsInput>>;
};

export type AppointmentUpdateOneRequiredWithoutAiRecapPimsWritebackLogEntryNestedInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutAiRecapPimsWritebackLogEntryInput>;
  create?: Maybe<AppointmentCreateWithoutAiRecapPimsWritebackLogEntryInput>;
  update?: Maybe<AppointmentUpdateToOneWithWhereWithoutAiRecapPimsWritebackLogEntryInput>;
  upsert?: Maybe<AppointmentUpsertWithoutAiRecapPimsWritebackLogEntryInput>;
};

export type AppointmentUpdateOneRequiredWithoutMassTextAlertEntryAppointmentsNestedInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutMassTextAlertEntryAppointmentsInput>;
  create?: Maybe<AppointmentCreateWithoutMassTextAlertEntryAppointmentsInput>;
  update?: Maybe<AppointmentUpdateToOneWithWhereWithoutMassTextAlertEntryAppointmentsInput>;
  upsert?: Maybe<AppointmentUpsertWithoutMassTextAlertEntryAppointmentsInput>;
};

export type AppointmentUpdateOneRequiredWithoutSurveyResultsNestedInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutSurveyResultsInput>;
  create?: Maybe<AppointmentCreateWithoutSurveyResultsInput>;
  update?: Maybe<AppointmentUpdateToOneWithWhereWithoutSurveyResultsInput>;
  upsert?: Maybe<AppointmentUpsertWithoutSurveyResultsInput>;
};

export type AppointmentUpdateOneWithoutAutomationRunsNestedInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<AppointmentCreateWithoutAutomationRunsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AppointmentUpdateToOneWithWhereWithoutAutomationRunsInput>;
  upsert?: Maybe<AppointmentUpsertWithoutAutomationRunsInput>;
};

export type AppointmentUpdateOneWithoutChannelAutomationStatusesNestedInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<AppointmentCreateWithoutChannelAutomationStatusesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AppointmentUpdateToOneWithWhereWithoutChannelAutomationStatusesInput>;
  upsert?: Maybe<AppointmentUpsertWithoutChannelAutomationStatusesInput>;
};

export type AppointmentUpdateOneWithoutDirectBookingWidgetRequestNestedInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutDirectBookingWidgetRequestInput>;
  create?: Maybe<AppointmentCreateWithoutDirectBookingWidgetRequestInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AppointmentUpdateToOneWithWhereWithoutDirectBookingWidgetRequestInput>;
  upsert?: Maybe<AppointmentUpsertWithoutDirectBookingWidgetRequestInput>;
};

export type AppointmentUpdateOneWithoutFormSubmissionsNestedInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutFormSubmissionsInput>;
  create?: Maybe<AppointmentCreateWithoutFormSubmissionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AppointmentUpdateToOneWithWhereWithoutFormSubmissionsInput>;
  upsert?: Maybe<AppointmentUpsertWithoutFormSubmissionsInput>;
};

export type AppointmentUpdateOneWithoutPushNotificationLogsNestedInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutPushNotificationLogsInput>;
  create?: Maybe<AppointmentCreateWithoutPushNotificationLogsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AppointmentUpdateToOneWithWhereWithoutPushNotificationLogsInput>;
  upsert?: Maybe<AppointmentUpsertWithoutPushNotificationLogsInput>;
};

export type AppointmentUpdateOneWithoutRecapsNestedInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutRecapsInput>;
  create?: Maybe<AppointmentCreateWithoutRecapsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AppointmentUpdateToOneWithWhereWithoutRecapsInput>;
  upsert?: Maybe<AppointmentUpsertWithoutRecapsInput>;
};

export type AppointmentUpdateOneWithoutTasksNestedInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutTasksInput>;
  create?: Maybe<AppointmentCreateWithoutTasksInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AppointmentUpdateToOneWithWhereWithoutTasksInput>;
  upsert?: Maybe<AppointmentUpsertWithoutTasksInput>;
};

export type AppointmentUpdateOneWithoutWorkflowTriggersNestedInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  connectOrCreate?: Maybe<AppointmentCreateOrConnectWithoutWorkflowTriggersInput>;
  create?: Maybe<AppointmentCreateWithoutWorkflowTriggersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AppointmentUpdateToOneWithWhereWithoutWorkflowTriggersInput>;
  upsert?: Maybe<AppointmentUpsertWithoutWorkflowTriggersInput>;
};

export type AppointmentUpdateToOneWithWhereWithoutAiRecapPimsWritebackLogEntryInput = {
  data: AppointmentUpdateWithoutAiRecapPimsWritebackLogEntryInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpdateToOneWithWhereWithoutAutomationRunsInput = {
  data: AppointmentUpdateWithoutAutomationRunsInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpdateToOneWithWhereWithoutChannelAutomationStatusesInput = {
  data: AppointmentUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpdateToOneWithWhereWithoutDirectBookingWidgetRequestInput = {
  data: AppointmentUpdateWithoutDirectBookingWidgetRequestInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpdateToOneWithWhereWithoutFormSubmissionsInput = {
  data: AppointmentUpdateWithoutFormSubmissionsInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpdateToOneWithWhereWithoutMassTextAlertEntryAppointmentsInput = {
  data: AppointmentUpdateWithoutMassTextAlertEntryAppointmentsInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpdateToOneWithWhereWithoutPushNotificationLogsInput = {
  data: AppointmentUpdateWithoutPushNotificationLogsInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpdateToOneWithWhereWithoutRecapsInput = {
  data: AppointmentUpdateWithoutRecapsInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpdateToOneWithWhereWithoutSurveyResultsInput = {
  data: AppointmentUpdateWithoutSurveyResultsInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpdateToOneWithWhereWithoutTasksInput = {
  data: AppointmentUpdateWithoutTasksInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpdateToOneWithWhereWithoutWorkflowTriggersInput = {
  data: AppointmentUpdateWithoutWorkflowTriggersInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpdateWithWhereUniqueWithoutAppointmentTypeInput = {
  data: AppointmentUpdateWithoutAppointmentTypeInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateWithWhereUniqueWithoutChannelInput = {
  data: AppointmentUpdateWithoutChannelInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateWithWhereUniqueWithoutClinicEmployeesInput = {
  data: AppointmentUpdateWithoutClinicEmployeesInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateWithWhereUniqueWithoutClinicInput = {
  data: AppointmentUpdateWithoutClinicInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: AppointmentUpdateWithoutClinicPetInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateWithWhereUniqueWithoutClinicPetParentsInput = {
  data: AppointmentUpdateWithoutClinicPetParentsInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateWithWhereUniqueWithoutConsultationInput = {
  data: AppointmentUpdateWithoutConsultationInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: AppointmentUpdateWithoutIntegrationInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateWithWhereUniqueWithoutRecapNotesUpdatedByInput = {
  data: AppointmentUpdateWithoutRecapNotesUpdatedByInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateWithWhereUniqueWithoutRoomInput = {
  data: AppointmentUpdateWithoutRoomInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateWithWhereUniqueWithoutTaxonomyInput = {
  data: AppointmentUpdateWithoutTaxonomyInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateWithWhereUniqueWithoutWorkflowsInput = {
  data: AppointmentUpdateWithoutWorkflowsInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateWithoutAiRecapPimsWritebackLogEntryInput = {
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutAppointmentTypeInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutAutomationRunsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutChannelAutomationStatusesInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutChannelInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutClinicEmployeesInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutClinicInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutClinicPetInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutClinicPetParentsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutConsultationInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutDirectBookingWidgetRequestInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutFormSubmissionsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutIntegrationInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutMassTextAlertEntryAppointmentsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutPushNotificationLogsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutRecapNotesUpdatedByInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutRecapsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutRoomInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutSurveyResultsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutTasksInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutTaxonomyInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutWorkflowTriggersInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput>;
};

export type AppointmentUpdateWithoutWorkflowsInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateManyWithoutAppointmentNestedInput>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutAppointmentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutAppointmentNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutAppointmentsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutAppointmentsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAppointmentsNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutAppointmentsNestedInput>;
  consultation?: Maybe<ConsultationUpdateOneWithoutAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutAppointmentNestedInput>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutAppointmentNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutAppointmentNestedInput>;
  room?: Maybe<ClinicRoomUpdateOneWithoutAppointmentsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AppointmentStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAppointmentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAppointmentNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutAppointmentsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowType>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutAppointmentNestedInput>;
};

export type AppointmentUpsertWithWhereUniqueWithoutAppointmentTypeInput = {
  create: AppointmentCreateWithoutAppointmentTypeInput;
  update: AppointmentUpdateWithoutAppointmentTypeInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpsertWithWhereUniqueWithoutChannelInput = {
  create: AppointmentCreateWithoutChannelInput;
  update: AppointmentUpdateWithoutChannelInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpsertWithWhereUniqueWithoutClinicEmployeesInput = {
  create: AppointmentCreateWithoutClinicEmployeesInput;
  update: AppointmentUpdateWithoutClinicEmployeesInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpsertWithWhereUniqueWithoutClinicInput = {
  create: AppointmentCreateWithoutClinicInput;
  update: AppointmentUpdateWithoutClinicInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: AppointmentCreateWithoutClinicPetInput;
  update: AppointmentUpdateWithoutClinicPetInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpsertWithWhereUniqueWithoutClinicPetParentsInput = {
  create: AppointmentCreateWithoutClinicPetParentsInput;
  update: AppointmentUpdateWithoutClinicPetParentsInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpsertWithWhereUniqueWithoutConsultationInput = {
  create: AppointmentCreateWithoutConsultationInput;
  update: AppointmentUpdateWithoutConsultationInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: AppointmentCreateWithoutIntegrationInput;
  update: AppointmentUpdateWithoutIntegrationInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpsertWithWhereUniqueWithoutRecapNotesUpdatedByInput = {
  create: AppointmentCreateWithoutRecapNotesUpdatedByInput;
  update: AppointmentUpdateWithoutRecapNotesUpdatedByInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpsertWithWhereUniqueWithoutRoomInput = {
  create: AppointmentCreateWithoutRoomInput;
  update: AppointmentUpdateWithoutRoomInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpsertWithWhereUniqueWithoutTaxonomyInput = {
  create: AppointmentCreateWithoutTaxonomyInput;
  update: AppointmentUpdateWithoutTaxonomyInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpsertWithWhereUniqueWithoutWorkflowsInput = {
  create: AppointmentCreateWithoutWorkflowsInput;
  update: AppointmentUpdateWithoutWorkflowsInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpsertWithoutAiRecapPimsWritebackLogEntryInput = {
  create: AppointmentCreateWithoutAiRecapPimsWritebackLogEntryInput;
  update: AppointmentUpdateWithoutAiRecapPimsWritebackLogEntryInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpsertWithoutAutomationRunsInput = {
  create: AppointmentCreateWithoutAutomationRunsInput;
  update: AppointmentUpdateWithoutAutomationRunsInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpsertWithoutChannelAutomationStatusesInput = {
  create: AppointmentCreateWithoutChannelAutomationStatusesInput;
  update: AppointmentUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpsertWithoutDirectBookingWidgetRequestInput = {
  create: AppointmentCreateWithoutDirectBookingWidgetRequestInput;
  update: AppointmentUpdateWithoutDirectBookingWidgetRequestInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpsertWithoutFormSubmissionsInput = {
  create: AppointmentCreateWithoutFormSubmissionsInput;
  update: AppointmentUpdateWithoutFormSubmissionsInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpsertWithoutMassTextAlertEntryAppointmentsInput = {
  create: AppointmentCreateWithoutMassTextAlertEntryAppointmentsInput;
  update: AppointmentUpdateWithoutMassTextAlertEntryAppointmentsInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpsertWithoutPushNotificationLogsInput = {
  create: AppointmentCreateWithoutPushNotificationLogsInput;
  update: AppointmentUpdateWithoutPushNotificationLogsInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpsertWithoutRecapsInput = {
  create: AppointmentCreateWithoutRecapsInput;
  update: AppointmentUpdateWithoutRecapsInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpsertWithoutSurveyResultsInput = {
  create: AppointmentCreateWithoutSurveyResultsInput;
  update: AppointmentUpdateWithoutSurveyResultsInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpsertWithoutTasksInput = {
  create: AppointmentCreateWithoutTasksInput;
  update: AppointmentUpdateWithoutTasksInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentUpsertWithoutWorkflowTriggersInput = {
  create: AppointmentCreateWithoutWorkflowTriggersInput;
  update: AppointmentUpdateWithoutWorkflowTriggersInput;
  where?: Maybe<AppointmentWhereInput>;
};

export type AppointmentWhereInput = {
  AND?: Maybe<Array<AppointmentWhereInput>>;
  NOT?: Maybe<Array<AppointmentWhereInput>>;
  OR?: Maybe<Array<AppointmentWhereInput>>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryListRelationFilter>;
  appointmentType?: Maybe<AppointmentTypeNullableScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringNullableFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  consultation?: Maybe<ConsultationNullableScalarRelationFilter>;
  consultationId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  durationInMinutes?: Maybe<IntFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  hash?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentListRelationFilter>;
  pimsExportConsultationId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsStatus?: Maybe<StringNullableFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  recapNotes?: Maybe<StringNullableFilter>;
  recapNotesUpdatedAt?: Maybe<DateTimeNullableFilter>;
  recapNotesUpdatedBy?: Maybe<UserNullableScalarRelationFilter>;
  recapNotesUpdatedByUserId?: Maybe<StringNullableFilter>;
  recaps?: Maybe<RecapListRelationFilter>;
  room?: Maybe<ClinicRoomNullableScalarRelationFilter>;
  roomId?: Maybe<StringNullableFilter>;
  startAt?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumAppointmentStatusFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  title?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflow?: Maybe<EnumWorkflowTypeNullableFilter>;
  workflowTriggers?: Maybe<WorkflowTriggerListRelationFilter>;
  workflows?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type AppointmentWhereUniqueInput = {
  AND?: Maybe<Array<AppointmentWhereInput>>;
  NOT?: Maybe<Array<AppointmentWhereInput>>;
  OR?: Maybe<Array<AppointmentWhereInput>>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryListRelationFilter>;
  appointmentPimsIdAndIntegrationId?: Maybe<AppointmentAppointmentPimsIdAndIntegrationIdCompoundUniqueInput>;
  appointmentType?: Maybe<AppointmentTypeNullableScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringNullableFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  consultation?: Maybe<ConsultationNullableScalarRelationFilter>;
  consultationId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  directBookingWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  durationInMinutes?: Maybe<IntFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  hash?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  massTextAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentListRelationFilter>;
  pimsExportConsultationId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsStatus?: Maybe<StringNullableFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  recapNotes?: Maybe<StringNullableFilter>;
  recapNotesUpdatedAt?: Maybe<DateTimeNullableFilter>;
  recapNotesUpdatedBy?: Maybe<UserNullableScalarRelationFilter>;
  recapNotesUpdatedByUserId?: Maybe<StringNullableFilter>;
  recaps?: Maybe<RecapListRelationFilter>;
  room?: Maybe<ClinicRoomNullableScalarRelationFilter>;
  roomId?: Maybe<StringNullableFilter>;
  startAt?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumAppointmentStatusFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  title?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflow?: Maybe<EnumWorkflowTypeNullableFilter>;
  workflowTriggers?: Maybe<WorkflowTriggerListRelationFilter>;
  workflows?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type AuthLinkEmailMatch = {
  __typename?: 'AuthLinkEmailMatch';
  id: Scalars['String'];
  redacted: Scalars['String'];
};

export type AuthLinkRequestInput = {
  clinicId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  queryParams?: Maybe<Scalars['Json']>;
};

export type AuthLinkRequestResult = {
  __typename?: 'AuthLinkRequestResult';
  emails?: Maybe<Array<Maybe<AuthLinkEmailMatch>>>;
  message?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export enum AutoResponseSuggestionStatus {
  Discarded = 'Discarded',
  Edited = 'Edited',
  Generated = 'Generated',
  Used = 'Used'
}

export enum AutomatedTriggerType {
  After = 'After',
  Before = 'Before'
}

export type AutomationRun = {
  __typename?: 'AutomationRun';
  HillsToHomeAPILog: Array<HillsToHomeApiLog>;
  _count: AutomationRunCountOutputType;
  actions: Array<AutomationRunAction>;
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheck>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessage;
  channelMessageId: Scalars['String'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  formSubmission?: Maybe<FormSubmission>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invioceLineItem?: Maybe<InvoiceLineItem>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentBy?: Maybe<User>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomation: WorkflowEventSetting;
  originAutomationId: Scalars['String'];
  returnToAutomationAction?: Maybe<WorkflowEventAction>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType: AutomationRunType;
  serviceReminder?: Maybe<ServiceReminder>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status: AutomationRunStatus;
  surveyResults: Array<SurveyResult>;
  tasks: Array<Task>;
  updatedAt: Scalars['DateTime'];
};


export type AutomationRunHillsToHomeApiLogArgs = {
  cursor?: Maybe<HillsToHomeApiLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<HillsToHomeApiLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<HillsToHomeApiLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<HillsToHomeApiLogWhereInput>;
};


export type AutomationRunActionsArgs = {
  cursor?: Maybe<AutomationRunActionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunActionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunActionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type AutomationRunAppointmentArgs = {
  where?: Maybe<AppointmentWhereInput>;
};


export type AutomationRunCareCreditPreapprovalCheckArgs = {
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};


export type AutomationRunClinicWidgetRequestArgs = {
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type AutomationRunFormSubmissionArgs = {
  where?: Maybe<FormSubmissionWhereInput>;
};


export type AutomationRunInvioceLineItemArgs = {
  where?: Maybe<InvoiceLineItemWhereInput>;
};


export type AutomationRunManuallySentByArgs = {
  where?: Maybe<UserWhereInput>;
};


export type AutomationRunReturnToAutomationActionArgs = {
  where?: Maybe<WorkflowEventActionWhereInput>;
};


export type AutomationRunServiceReminderArgs = {
  where?: Maybe<ServiceReminderWhereInput>;
};


export type AutomationRunSurveyResultsArgs = {
  cursor?: Maybe<SurveyResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveyResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveyResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyResultWhereInput>;
};


export type AutomationRunTasksArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaskScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaskOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaskWhereInput>;
};

export type AutomationRunAction = {
  __typename?: 'AutomationRunAction';
  actionType: AutomationRunActionType;
  attachments: Scalars['Json'];
  automationAction?: Maybe<WorkflowEventAction>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRun: AutomationRun;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons: Scalars['Json'];
  channelStatusChange?: Maybe<ChannelStatus>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  formSubmission?: Maybe<FormSubmission>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  order: Scalars['Int'];
  paymentIntent?: Maybe<StripePaymentIntent>;
  paymentIntentId?: Maybe<Scalars['String']>;
  pet?: Maybe<ClinicPet>;
  petId?: Maybe<Scalars['String']>;
  petParent?: Maybe<ClinicPetParent>;
  petParentId?: Maybe<Scalars['String']>;
  promptType: AutomationRunActionPromptType;
  updatedAt: Scalars['DateTime'];
};


export type AutomationRunActionAutomationActionArgs = {
  where?: Maybe<WorkflowEventActionWhereInput>;
};


export type AutomationRunActionChannelStatusChangeArgs = {
  where?: Maybe<ChannelStatusWhereInput>;
};


export type AutomationRunActionFormSubmissionArgs = {
  where?: Maybe<FormSubmissionWhereInput>;
};


export type AutomationRunActionPaymentIntentArgs = {
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type AutomationRunActionPetArgs = {
  where?: Maybe<ClinicPetWhereInput>;
};


export type AutomationRunActionPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type AutomationRunActionAvgAggregateOutputType = {
  __typename?: 'AutomationRunActionAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type AutomationRunActionAvgOrderByAggregateInput = {
  order?: Maybe<SortOrder>;
};

export type AutomationRunActionCountAggregateOutputType = {
  __typename?: 'AutomationRunActionCountAggregateOutputType';
  _all: Scalars['Int'];
  actionType: Scalars['Int'];
  attachments: Scalars['Int'];
  automationActionId: Scalars['Int'];
  automationRunId: Scalars['Int'];
  body: Scalars['Int'];
  buttons: Scalars['Int'];
  channelStatusChangeId: Scalars['Int'];
  createdAt: Scalars['Int'];
  formSubmissionId: Scalars['Int'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  paymentIntentId: Scalars['Int'];
  petId: Scalars['Int'];
  petParentId: Scalars['Int'];
  promptType: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type AutomationRunActionCountOrderByAggregateInput = {
  actionType?: Maybe<SortOrder>;
  attachments?: Maybe<SortOrder>;
  automationActionId?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  buttons?: Maybe<SortOrder>;
  channelStatusChangeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  paymentIntentId?: Maybe<SortOrder>;
  petId?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AutomationRunActionCreateInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutAutomationRunActionsInput>;
  automationRun: AutomationRunCreateNestedOneWithoutActionsInput;
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutAutomationRunActionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunActionInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutAutomationRunActionInput>;
  pet?: Maybe<ClinicPetCreateNestedOneWithoutAutomationRunActionsInput>;
  petParent?: Maybe<ClinicPetParentCreateNestedOneWithoutAutomationRunActionsInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateManyAutomationActionInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateManyAutomationActionInputEnvelope = {
  data: Array<AutomationRunActionCreateManyAutomationActionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunActionCreateManyAutomationRunInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateManyAutomationRunInputEnvelope = {
  data: Array<AutomationRunActionCreateManyAutomationRunInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunActionCreateManyChannelStatusChangeInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateManyChannelStatusChangeInputEnvelope = {
  data: Array<AutomationRunActionCreateManyChannelStatusChangeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunActionCreateManyInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateManyPetInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateManyPetInputEnvelope = {
  data: Array<AutomationRunActionCreateManyPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunActionCreateManyPetParentInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateManyPetParentInputEnvelope = {
  data: Array<AutomationRunActionCreateManyPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunActionCreateNestedManyWithoutAutomationActionInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutAutomationActionInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutAutomationActionInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyAutomationActionInputEnvelope>;
};

export type AutomationRunActionCreateNestedManyWithoutAutomationRunInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyAutomationRunInputEnvelope>;
};

export type AutomationRunActionCreateNestedManyWithoutChannelStatusChangeInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutChannelStatusChangeInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutChannelStatusChangeInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyChannelStatusChangeInputEnvelope>;
};

export type AutomationRunActionCreateNestedManyWithoutPetInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutPetInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutPetInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyPetInputEnvelope>;
};

export type AutomationRunActionCreateNestedManyWithoutPetParentInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutPetParentInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutPetParentInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyPetParentInputEnvelope>;
};

export type AutomationRunActionCreateNestedOneWithoutFormSubmissionInput = {
  connect?: Maybe<AutomationRunActionWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunActionCreateOrConnectWithoutFormSubmissionInput>;
  create?: Maybe<AutomationRunActionCreateWithoutFormSubmissionInput>;
};

export type AutomationRunActionCreateNestedOneWithoutPaymentIntentInput = {
  connect?: Maybe<AutomationRunActionWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunActionCreateOrConnectWithoutPaymentIntentInput>;
  create?: Maybe<AutomationRunActionCreateWithoutPaymentIntentInput>;
};

export type AutomationRunActionCreateOrConnectWithoutAutomationActionInput = {
  create: AutomationRunActionCreateWithoutAutomationActionInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionCreateOrConnectWithoutAutomationRunInput = {
  create: AutomationRunActionCreateWithoutAutomationRunInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionCreateOrConnectWithoutChannelStatusChangeInput = {
  create: AutomationRunActionCreateWithoutChannelStatusChangeInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionCreateOrConnectWithoutFormSubmissionInput = {
  create: AutomationRunActionCreateWithoutFormSubmissionInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionCreateOrConnectWithoutPaymentIntentInput = {
  create: AutomationRunActionCreateWithoutPaymentIntentInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionCreateOrConnectWithoutPetInput = {
  create: AutomationRunActionCreateWithoutPetInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionCreateOrConnectWithoutPetParentInput = {
  create: AutomationRunActionCreateWithoutPetParentInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionCreateWithoutAutomationActionInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationRun: AutomationRunCreateNestedOneWithoutActionsInput;
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutAutomationRunActionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunActionInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutAutomationRunActionInput>;
  pet?: Maybe<ClinicPetCreateNestedOneWithoutAutomationRunActionsInput>;
  petParent?: Maybe<ClinicPetParentCreateNestedOneWithoutAutomationRunActionsInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateWithoutAutomationRunInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutAutomationRunActionsInput>;
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutAutomationRunActionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunActionInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutAutomationRunActionInput>;
  pet?: Maybe<ClinicPetCreateNestedOneWithoutAutomationRunActionsInput>;
  petParent?: Maybe<ClinicPetParentCreateNestedOneWithoutAutomationRunActionsInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateWithoutChannelStatusChangeInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutAutomationRunActionsInput>;
  automationRun: AutomationRunCreateNestedOneWithoutActionsInput;
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunActionInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutAutomationRunActionInput>;
  pet?: Maybe<ClinicPetCreateNestedOneWithoutAutomationRunActionsInput>;
  petParent?: Maybe<ClinicPetParentCreateNestedOneWithoutAutomationRunActionsInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateWithoutFormSubmissionInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutAutomationRunActionsInput>;
  automationRun: AutomationRunCreateNestedOneWithoutActionsInput;
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutAutomationRunActionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutAutomationRunActionInput>;
  pet?: Maybe<ClinicPetCreateNestedOneWithoutAutomationRunActionsInput>;
  petParent?: Maybe<ClinicPetParentCreateNestedOneWithoutAutomationRunActionsInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateWithoutPaymentIntentInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutAutomationRunActionsInput>;
  automationRun: AutomationRunCreateNestedOneWithoutActionsInput;
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutAutomationRunActionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunActionInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pet?: Maybe<ClinicPetCreateNestedOneWithoutAutomationRunActionsInput>;
  petParent?: Maybe<ClinicPetParentCreateNestedOneWithoutAutomationRunActionsInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateWithoutPetInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutAutomationRunActionsInput>;
  automationRun: AutomationRunCreateNestedOneWithoutActionsInput;
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutAutomationRunActionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunActionInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutAutomationRunActionInput>;
  petParent?: Maybe<ClinicPetParentCreateNestedOneWithoutAutomationRunActionsInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionCreateWithoutPetParentInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutAutomationRunActionsInput>;
  automationRun: AutomationRunCreateNestedOneWithoutActionsInput;
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutAutomationRunActionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunActionInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutAutomationRunActionInput>;
  pet?: Maybe<ClinicPetCreateNestedOneWithoutAutomationRunActionsInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionGroupByOutputType = {
  __typename?: 'AutomationRunActionGroupByOutputType';
  _avg?: Maybe<AutomationRunActionAvgAggregateOutputType>;
  _count?: Maybe<AutomationRunActionCountAggregateOutputType>;
  _max?: Maybe<AutomationRunActionMaxAggregateOutputType>;
  _min?: Maybe<AutomationRunActionMinAggregateOutputType>;
  _sum?: Maybe<AutomationRunActionSumAggregateOutputType>;
  actionType: AutomationRunActionType;
  attachments: Scalars['Json'];
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons: Scalars['Json'];
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  order: Scalars['Int'];
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType: AutomationRunActionPromptType;
  updatedAt: Scalars['DateTime'];
};

export type AutomationRunActionListRelationFilter = {
  every?: Maybe<AutomationRunActionWhereInput>;
  none?: Maybe<AutomationRunActionWhereInput>;
  some?: Maybe<AutomationRunActionWhereInput>;
};

export type AutomationRunActionMaxAggregateOutputType = {
  __typename?: 'AutomationRunActionMaxAggregateOutputType';
  actionType?: Maybe<AutomationRunActionType>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionMaxOrderByAggregateInput = {
  actionType?: Maybe<SortOrder>;
  automationActionId?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  channelStatusChangeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  paymentIntentId?: Maybe<SortOrder>;
  petId?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AutomationRunActionMinAggregateOutputType = {
  __typename?: 'AutomationRunActionMinAggregateOutputType';
  actionType?: Maybe<AutomationRunActionType>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionMinOrderByAggregateInput = {
  actionType?: Maybe<SortOrder>;
  automationActionId?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  channelStatusChangeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  paymentIntentId?: Maybe<SortOrder>;
  petId?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AutomationRunActionNullableScalarRelationFilter = {
  AND?: Maybe<Array<AutomationRunActionWhereInput>>;
  NOT?: Maybe<Array<AutomationRunActionWhereInput>>;
  OR?: Maybe<Array<AutomationRunActionWhereInput>>;
  actionType?: Maybe<EnumAutomationRunActionTypeFilter>;
  attachments?: Maybe<JsonFilter>;
  automationAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  automationActionId?: Maybe<StringNullableFilter>;
  automationRun?: Maybe<AutomationRunScalarRelationFilter>;
  automationRunId?: Maybe<StringFilter>;
  body?: Maybe<StringFilter>;
  buttons?: Maybe<JsonFilter>;
  channelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusChangeId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  order?: Maybe<IntFilter>;
  paymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  paymentIntentId?: Maybe<StringNullableFilter>;
  pet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  petId?: Maybe<StringNullableFilter>;
  petParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  promptType?: Maybe<EnumAutomationRunActionPromptTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AutomationRunActionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type AutomationRunActionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AutomationRunActionOrderByRelevanceInput>;
  actionType?: Maybe<SortOrder>;
  attachments?: Maybe<SortOrder>;
  automationAction?: Maybe<WorkflowEventActionOrderByWithRelationInput>;
  automationActionId?: Maybe<SortOrder>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  buttons?: Maybe<SortOrder>;
  channelStatusChange?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusChangeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  paymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  paymentIntentId?: Maybe<SortOrder>;
  pet?: Maybe<ClinicPetOrderByWithRelationInput>;
  petId?: Maybe<SortOrder>;
  petParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  petParentId?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum AutomationRunActionOrderByRelevanceFieldEnum {
  AutomationActionId = 'automationActionId',
  AutomationRunId = 'automationRunId',
  Body = 'body',
  ChannelStatusChangeId = 'channelStatusChangeId',
  FormSubmissionId = 'formSubmissionId',
  Id = 'id',
  PaymentIntentId = 'paymentIntentId',
  PetId = 'petId',
  PetParentId = 'petParentId'
}

export type AutomationRunActionOrderByRelevanceInput = {
  fields: Array<AutomationRunActionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type AutomationRunActionOrderByWithAggregationInput = {
  _avg?: Maybe<AutomationRunActionAvgOrderByAggregateInput>;
  _count?: Maybe<AutomationRunActionCountOrderByAggregateInput>;
  _max?: Maybe<AutomationRunActionMaxOrderByAggregateInput>;
  _min?: Maybe<AutomationRunActionMinOrderByAggregateInput>;
  _sum?: Maybe<AutomationRunActionSumOrderByAggregateInput>;
  actionType?: Maybe<SortOrder>;
  attachments?: Maybe<SortOrder>;
  automationActionId?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  buttons?: Maybe<SortOrder>;
  channelStatusChangeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  paymentIntentId?: Maybe<SortOrder>;
  petId?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AutomationRunActionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AutomationRunActionOrderByRelevanceInput>;
  actionType?: Maybe<SortOrder>;
  attachments?: Maybe<SortOrder>;
  automationAction?: Maybe<WorkflowEventActionOrderByWithRelationInput>;
  automationActionId?: Maybe<SortOrder>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  buttons?: Maybe<SortOrder>;
  channelStatusChange?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusChangeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  paymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  paymentIntentId?: Maybe<SortOrder>;
  pet?: Maybe<ClinicPetOrderByWithRelationInput>;
  petId?: Maybe<SortOrder>;
  petParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  petParentId?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AutomationRunActionOrderByWithRelationInput = {
  _relevance?: Maybe<AutomationRunActionOrderByRelevanceInput>;
  actionType?: Maybe<SortOrder>;
  attachments?: Maybe<SortOrder>;
  automationAction?: Maybe<WorkflowEventActionOrderByWithRelationInput>;
  automationActionId?: Maybe<SortOrder>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  buttons?: Maybe<SortOrder>;
  channelStatusChange?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusChangeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  paymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  paymentIntentId?: Maybe<SortOrder>;
  pet?: Maybe<ClinicPetOrderByWithRelationInput>;
  petId?: Maybe<SortOrder>;
  petParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  petParentId?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum AutomationRunActionPromptType {
  Buttons = 'Buttons',
  Form = 'Form',
  Payment = 'Payment',
  Prompt = 'Prompt',
  Statement = 'Statement'
}

export enum AutomationRunActionScalarFieldEnum {
  ActionType = 'actionType',
  Attachments = 'attachments',
  AutomationActionId = 'automationActionId',
  AutomationRunId = 'automationRunId',
  Body = 'body',
  Buttons = 'buttons',
  ChannelStatusChangeId = 'channelStatusChangeId',
  CreatedAt = 'createdAt',
  FormSubmissionId = 'formSubmissionId',
  Id = 'id',
  Order = 'order',
  PaymentIntentId = 'paymentIntentId',
  PetId = 'petId',
  PetParentId = 'petParentId',
  PromptType = 'promptType',
  UpdatedAt = 'updatedAt'
}

export type AutomationRunActionScalarWhereInput = {
  AND?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  NOT?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  OR?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  actionType?: Maybe<EnumAutomationRunActionTypeFilter>;
  attachments?: Maybe<JsonFilter>;
  automationActionId?: Maybe<StringNullableFilter>;
  automationRunId?: Maybe<StringFilter>;
  body?: Maybe<StringFilter>;
  buttons?: Maybe<JsonFilter>;
  channelStatusChangeId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  order?: Maybe<IntFilter>;
  paymentIntentId?: Maybe<StringNullableFilter>;
  petId?: Maybe<StringNullableFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  promptType?: Maybe<EnumAutomationRunActionPromptTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AutomationRunActionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<AutomationRunActionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<AutomationRunActionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<AutomationRunActionScalarWhereWithAggregatesInput>>;
  actionType?: Maybe<EnumAutomationRunActionTypeWithAggregatesFilter>;
  attachments?: Maybe<JsonWithAggregatesFilter>;
  automationActionId?: Maybe<StringNullableWithAggregatesFilter>;
  automationRunId?: Maybe<StringWithAggregatesFilter>;
  body?: Maybe<StringWithAggregatesFilter>;
  buttons?: Maybe<JsonWithAggregatesFilter>;
  channelStatusChangeId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  formSubmissionId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  order?: Maybe<IntWithAggregatesFilter>;
  paymentIntentId?: Maybe<StringNullableWithAggregatesFilter>;
  petId?: Maybe<StringNullableWithAggregatesFilter>;
  petParentId?: Maybe<StringNullableWithAggregatesFilter>;
  promptType?: Maybe<EnumAutomationRunActionPromptTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type AutomationRunActionSubscription = {
  __typename?: 'AutomationRunActionSubscription';
  mutation: MutationType;
  node: AutomationRunAction;
};

export type AutomationRunActionSumAggregateOutputType = {
  __typename?: 'AutomationRunActionSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type AutomationRunActionSumOrderByAggregateInput = {
  order?: Maybe<SortOrder>;
};

export enum AutomationRunActionType {
  Automated = 'Automated',
  PetParent = 'PetParent',
  System = 'System'
}

export type AutomationRunActionUncheckedCreateInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedCreateNestedManyWithoutAutomationActionInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutAutomationActionInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutAutomationActionInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyAutomationActionInputEnvelope>;
};

export type AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyAutomationRunInputEnvelope>;
};

export type AutomationRunActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutChannelStatusChangeInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutChannelStatusChangeInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyChannelStatusChangeInputEnvelope>;
};

export type AutomationRunActionUncheckedCreateNestedManyWithoutPetInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutPetInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutPetInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyPetInputEnvelope>;
};

export type AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutPetParentInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutPetParentInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyPetParentInputEnvelope>;
};

export type AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput = {
  connect?: Maybe<AutomationRunActionWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunActionCreateOrConnectWithoutFormSubmissionInput>;
  create?: Maybe<AutomationRunActionCreateWithoutFormSubmissionInput>;
};

export type AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput = {
  connect?: Maybe<AutomationRunActionWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunActionCreateOrConnectWithoutPaymentIntentInput>;
  create?: Maybe<AutomationRunActionCreateWithoutPaymentIntentInput>;
};

export type AutomationRunActionUncheckedCreateWithoutAutomationActionInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedCreateWithoutAutomationRunInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedCreateWithoutChannelStatusChangeInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedCreateWithoutFormSubmissionInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedCreateWithoutPaymentIntentInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedCreateWithoutPetInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedCreateWithoutPetParentInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateManyInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateManyWithoutAutomationActionInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateManyWithoutAutomationActionNestedInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutAutomationActionInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutAutomationActionInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyAutomationActionInputEnvelope>;
  delete?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunActionUpdateWithWhereUniqueWithoutAutomationActionInput>>;
  updateMany?: Maybe<Array<AutomationRunActionUpdateManyWithWhereWithoutAutomationActionInput>>;
  upsert?: Maybe<Array<AutomationRunActionUpsertWithWhereUniqueWithoutAutomationActionInput>>;
};

export type AutomationRunActionUncheckedUpdateManyWithoutAutomationRunInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyAutomationRunInputEnvelope>;
  delete?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunActionUpdateWithWhereUniqueWithoutAutomationRunInput>>;
  updateMany?: Maybe<Array<AutomationRunActionUpdateManyWithWhereWithoutAutomationRunInput>>;
  upsert?: Maybe<Array<AutomationRunActionUpsertWithWhereUniqueWithoutAutomationRunInput>>;
};

export type AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutChannelStatusChangeInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutChannelStatusChangeInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyChannelStatusChangeInputEnvelope>;
  delete?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunActionUpdateWithWhereUniqueWithoutChannelStatusChangeInput>>;
  updateMany?: Maybe<Array<AutomationRunActionUpdateManyWithWhereWithoutChannelStatusChangeInput>>;
  upsert?: Maybe<Array<AutomationRunActionUpsertWithWhereUniqueWithoutChannelStatusChangeInput>>;
};

export type AutomationRunActionUncheckedUpdateManyWithoutPetInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutPetInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutPetInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyPetInputEnvelope>;
  delete?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunActionUpdateWithWhereUniqueWithoutPetInput>>;
  updateMany?: Maybe<Array<AutomationRunActionUpdateManyWithWhereWithoutPetInput>>;
  upsert?: Maybe<Array<AutomationRunActionUpsertWithWhereUniqueWithoutPetInput>>;
};

export type AutomationRunActionUncheckedUpdateManyWithoutPetParentInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutPetParentInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutPetParentInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyPetParentInputEnvelope>;
  delete?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunActionUpdateWithWhereUniqueWithoutPetParentInput>>;
  updateMany?: Maybe<Array<AutomationRunActionUpdateManyWithWhereWithoutPetParentInput>>;
  upsert?: Maybe<Array<AutomationRunActionUpsertWithWhereUniqueWithoutPetParentInput>>;
};

export type AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput = {
  connect?: Maybe<AutomationRunActionWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunActionCreateOrConnectWithoutFormSubmissionInput>;
  create?: Maybe<AutomationRunActionCreateWithoutFormSubmissionInput>;
  delete?: Maybe<AutomationRunActionWhereInput>;
  disconnect?: Maybe<AutomationRunActionWhereInput>;
  update?: Maybe<AutomationRunActionUpdateToOneWithWhereWithoutFormSubmissionInput>;
  upsert?: Maybe<AutomationRunActionUpsertWithoutFormSubmissionInput>;
};

export type AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput = {
  connect?: Maybe<AutomationRunActionWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunActionCreateOrConnectWithoutPaymentIntentInput>;
  create?: Maybe<AutomationRunActionCreateWithoutPaymentIntentInput>;
  delete?: Maybe<AutomationRunActionWhereInput>;
  disconnect?: Maybe<AutomationRunActionWhereInput>;
  update?: Maybe<AutomationRunActionUpdateToOneWithWhereWithoutPaymentIntentInput>;
  upsert?: Maybe<AutomationRunActionUpsertWithoutPaymentIntentInput>;
};

export type AutomationRunActionUncheckedUpdateWithoutAutomationActionInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateWithoutAutomationRunInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateWithoutChannelStatusChangeInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateWithoutFormSubmissionInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateWithoutPaymentIntentInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateWithoutPetInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUncheckedUpdateWithoutPetParentInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  petId?: Maybe<Scalars['String']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUpdateInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionUpdateOneWithoutAutomationRunActionsNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneRequiredWithoutActionsNestedInput>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutAutomationRunActionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunActionNestedInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutAutomationRunActionNestedInput>;
  pet?: Maybe<ClinicPetUpdateOneWithoutAutomationRunActionsNestedInput>;
  petParent?: Maybe<ClinicPetParentUpdateOneWithoutAutomationRunActionsNestedInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUpdateManyMutationInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUpdateManyWithWhereWithoutAutomationActionInput = {
  data: AutomationRunActionUpdateManyMutationInput;
  where: AutomationRunActionScalarWhereInput;
};

export type AutomationRunActionUpdateManyWithWhereWithoutAutomationRunInput = {
  data: AutomationRunActionUpdateManyMutationInput;
  where: AutomationRunActionScalarWhereInput;
};

export type AutomationRunActionUpdateManyWithWhereWithoutChannelStatusChangeInput = {
  data: AutomationRunActionUpdateManyMutationInput;
  where: AutomationRunActionScalarWhereInput;
};

export type AutomationRunActionUpdateManyWithWhereWithoutPetInput = {
  data: AutomationRunActionUpdateManyMutationInput;
  where: AutomationRunActionScalarWhereInput;
};

export type AutomationRunActionUpdateManyWithWhereWithoutPetParentInput = {
  data: AutomationRunActionUpdateManyMutationInput;
  where: AutomationRunActionScalarWhereInput;
};

export type AutomationRunActionUpdateManyWithoutAutomationActionNestedInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutAutomationActionInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutAutomationActionInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyAutomationActionInputEnvelope>;
  delete?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunActionUpdateWithWhereUniqueWithoutAutomationActionInput>>;
  updateMany?: Maybe<Array<AutomationRunActionUpdateManyWithWhereWithoutAutomationActionInput>>;
  upsert?: Maybe<Array<AutomationRunActionUpsertWithWhereUniqueWithoutAutomationActionInput>>;
};

export type AutomationRunActionUpdateManyWithoutAutomationRunNestedInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyAutomationRunInputEnvelope>;
  delete?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunActionUpdateWithWhereUniqueWithoutAutomationRunInput>>;
  updateMany?: Maybe<Array<AutomationRunActionUpdateManyWithWhereWithoutAutomationRunInput>>;
  upsert?: Maybe<Array<AutomationRunActionUpsertWithWhereUniqueWithoutAutomationRunInput>>;
};

export type AutomationRunActionUpdateManyWithoutChannelStatusChangeNestedInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutChannelStatusChangeInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutChannelStatusChangeInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyChannelStatusChangeInputEnvelope>;
  delete?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunActionUpdateWithWhereUniqueWithoutChannelStatusChangeInput>>;
  updateMany?: Maybe<Array<AutomationRunActionUpdateManyWithWhereWithoutChannelStatusChangeInput>>;
  upsert?: Maybe<Array<AutomationRunActionUpsertWithWhereUniqueWithoutChannelStatusChangeInput>>;
};

export type AutomationRunActionUpdateManyWithoutPetNestedInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutPetInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutPetInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyPetInputEnvelope>;
  delete?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunActionUpdateWithWhereUniqueWithoutPetInput>>;
  updateMany?: Maybe<Array<AutomationRunActionUpdateManyWithWhereWithoutPetInput>>;
  upsert?: Maybe<Array<AutomationRunActionUpsertWithWhereUniqueWithoutPetInput>>;
};

export type AutomationRunActionUpdateManyWithoutPetParentNestedInput = {
  connect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunActionCreateOrConnectWithoutPetParentInput>>;
  create?: Maybe<Array<AutomationRunActionCreateWithoutPetParentInput>>;
  createMany?: Maybe<AutomationRunActionCreateManyPetParentInputEnvelope>;
  delete?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunActionScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunActionWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunActionUpdateWithWhereUniqueWithoutPetParentInput>>;
  updateMany?: Maybe<Array<AutomationRunActionUpdateManyWithWhereWithoutPetParentInput>>;
  upsert?: Maybe<Array<AutomationRunActionUpsertWithWhereUniqueWithoutPetParentInput>>;
};

export type AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput = {
  connect?: Maybe<AutomationRunActionWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunActionCreateOrConnectWithoutFormSubmissionInput>;
  create?: Maybe<AutomationRunActionCreateWithoutFormSubmissionInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AutomationRunActionUpdateToOneWithWhereWithoutFormSubmissionInput>;
  upsert?: Maybe<AutomationRunActionUpsertWithoutFormSubmissionInput>;
};

export type AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput = {
  connect?: Maybe<AutomationRunActionWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunActionCreateOrConnectWithoutPaymentIntentInput>;
  create?: Maybe<AutomationRunActionCreateWithoutPaymentIntentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AutomationRunActionUpdateToOneWithWhereWithoutPaymentIntentInput>;
  upsert?: Maybe<AutomationRunActionUpsertWithoutPaymentIntentInput>;
};

export type AutomationRunActionUpdateToOneWithWhereWithoutFormSubmissionInput = {
  data: AutomationRunActionUpdateWithoutFormSubmissionInput;
  where?: Maybe<AutomationRunActionWhereInput>;
};

export type AutomationRunActionUpdateToOneWithWhereWithoutPaymentIntentInput = {
  data: AutomationRunActionUpdateWithoutPaymentIntentInput;
  where?: Maybe<AutomationRunActionWhereInput>;
};

export type AutomationRunActionUpdateWithWhereUniqueWithoutAutomationActionInput = {
  data: AutomationRunActionUpdateWithoutAutomationActionInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionUpdateWithWhereUniqueWithoutAutomationRunInput = {
  data: AutomationRunActionUpdateWithoutAutomationRunInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionUpdateWithWhereUniqueWithoutChannelStatusChangeInput = {
  data: AutomationRunActionUpdateWithoutChannelStatusChangeInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionUpdateWithWhereUniqueWithoutPetInput = {
  data: AutomationRunActionUpdateWithoutPetInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionUpdateWithWhereUniqueWithoutPetParentInput = {
  data: AutomationRunActionUpdateWithoutPetParentInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionUpdateWithoutAutomationActionInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationRun?: Maybe<AutomationRunUpdateOneRequiredWithoutActionsNestedInput>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutAutomationRunActionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunActionNestedInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutAutomationRunActionNestedInput>;
  pet?: Maybe<ClinicPetUpdateOneWithoutAutomationRunActionsNestedInput>;
  petParent?: Maybe<ClinicPetParentUpdateOneWithoutAutomationRunActionsNestedInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUpdateWithoutAutomationRunInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionUpdateOneWithoutAutomationRunActionsNestedInput>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutAutomationRunActionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunActionNestedInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutAutomationRunActionNestedInput>;
  pet?: Maybe<ClinicPetUpdateOneWithoutAutomationRunActionsNestedInput>;
  petParent?: Maybe<ClinicPetParentUpdateOneWithoutAutomationRunActionsNestedInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUpdateWithoutChannelStatusChangeInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionUpdateOneWithoutAutomationRunActionsNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneRequiredWithoutActionsNestedInput>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunActionNestedInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutAutomationRunActionNestedInput>;
  pet?: Maybe<ClinicPetUpdateOneWithoutAutomationRunActionsNestedInput>;
  petParent?: Maybe<ClinicPetParentUpdateOneWithoutAutomationRunActionsNestedInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUpdateWithoutFormSubmissionInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionUpdateOneWithoutAutomationRunActionsNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneRequiredWithoutActionsNestedInput>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutAutomationRunActionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutAutomationRunActionNestedInput>;
  pet?: Maybe<ClinicPetUpdateOneWithoutAutomationRunActionsNestedInput>;
  petParent?: Maybe<ClinicPetParentUpdateOneWithoutAutomationRunActionsNestedInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUpdateWithoutPaymentIntentInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionUpdateOneWithoutAutomationRunActionsNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneRequiredWithoutActionsNestedInput>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutAutomationRunActionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunActionNestedInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pet?: Maybe<ClinicPetUpdateOneWithoutAutomationRunActionsNestedInput>;
  petParent?: Maybe<ClinicPetParentUpdateOneWithoutAutomationRunActionsNestedInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUpdateWithoutPetInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionUpdateOneWithoutAutomationRunActionsNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneRequiredWithoutActionsNestedInput>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutAutomationRunActionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunActionNestedInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutAutomationRunActionNestedInput>;
  petParent?: Maybe<ClinicPetParentUpdateOneWithoutAutomationRunActionsNestedInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUpdateWithoutPetParentInput = {
  actionType?: Maybe<AutomationRunActionType>;
  attachments?: Maybe<Scalars['Json']>;
  automationAction?: Maybe<WorkflowEventActionUpdateOneWithoutAutomationRunActionsNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneRequiredWithoutActionsNestedInput>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Scalars['Json']>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutAutomationRunActionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunActionNestedInput>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutAutomationRunActionNestedInput>;
  pet?: Maybe<ClinicPetUpdateOneWithoutAutomationRunActionsNestedInput>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunActionUpsertWithWhereUniqueWithoutAutomationActionInput = {
  create: AutomationRunActionCreateWithoutAutomationActionInput;
  update: AutomationRunActionUpdateWithoutAutomationActionInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionUpsertWithWhereUniqueWithoutAutomationRunInput = {
  create: AutomationRunActionCreateWithoutAutomationRunInput;
  update: AutomationRunActionUpdateWithoutAutomationRunInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionUpsertWithWhereUniqueWithoutChannelStatusChangeInput = {
  create: AutomationRunActionCreateWithoutChannelStatusChangeInput;
  update: AutomationRunActionUpdateWithoutChannelStatusChangeInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionUpsertWithWhereUniqueWithoutPetInput = {
  create: AutomationRunActionCreateWithoutPetInput;
  update: AutomationRunActionUpdateWithoutPetInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionUpsertWithWhereUniqueWithoutPetParentInput = {
  create: AutomationRunActionCreateWithoutPetParentInput;
  update: AutomationRunActionUpdateWithoutPetParentInput;
  where: AutomationRunActionWhereUniqueInput;
};

export type AutomationRunActionUpsertWithoutFormSubmissionInput = {
  create: AutomationRunActionCreateWithoutFormSubmissionInput;
  update: AutomationRunActionUpdateWithoutFormSubmissionInput;
  where?: Maybe<AutomationRunActionWhereInput>;
};

export type AutomationRunActionUpsertWithoutPaymentIntentInput = {
  create: AutomationRunActionCreateWithoutPaymentIntentInput;
  update: AutomationRunActionUpdateWithoutPaymentIntentInput;
  where?: Maybe<AutomationRunActionWhereInput>;
};

export type AutomationRunActionWhereInput = {
  AND?: Maybe<Array<AutomationRunActionWhereInput>>;
  NOT?: Maybe<Array<AutomationRunActionWhereInput>>;
  OR?: Maybe<Array<AutomationRunActionWhereInput>>;
  actionType?: Maybe<EnumAutomationRunActionTypeFilter>;
  attachments?: Maybe<JsonFilter>;
  automationAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  automationActionId?: Maybe<StringNullableFilter>;
  automationRun?: Maybe<AutomationRunScalarRelationFilter>;
  automationRunId?: Maybe<StringFilter>;
  body?: Maybe<StringFilter>;
  buttons?: Maybe<JsonFilter>;
  channelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusChangeId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  order?: Maybe<IntFilter>;
  paymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  paymentIntentId?: Maybe<StringNullableFilter>;
  pet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  petId?: Maybe<StringNullableFilter>;
  petParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  promptType?: Maybe<EnumAutomationRunActionPromptTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AutomationRunActionWhereUniqueInput = {
  AND?: Maybe<Array<AutomationRunActionWhereInput>>;
  NOT?: Maybe<Array<AutomationRunActionWhereInput>>;
  OR?: Maybe<Array<AutomationRunActionWhereInput>>;
  actionType?: Maybe<EnumAutomationRunActionTypeFilter>;
  attachments?: Maybe<JsonFilter>;
  automationAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  automationActionId?: Maybe<StringNullableFilter>;
  automationRun?: Maybe<AutomationRunScalarRelationFilter>;
  automationRunId?: Maybe<StringFilter>;
  body?: Maybe<StringFilter>;
  buttons?: Maybe<JsonFilter>;
  channelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusChangeId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<IntFilter>;
  paymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  paymentIntentId?: Maybe<Scalars['String']>;
  pet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  petId?: Maybe<StringNullableFilter>;
  petParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  promptType?: Maybe<EnumAutomationRunActionPromptTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AutomationRunCountAggregateOutputType = {
  __typename?: 'AutomationRunCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentId: Scalars['Int'];
  automationEvent: Scalars['Int'];
  careCreditPreapprovalCheckId: Scalars['Int'];
  channelMessageId: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  clinicWidgetRequestId: Scalars['Int'];
  completedAt: Scalars['Int'];
  createdAt: Scalars['Int'];
  formSubmissionId: Scalars['Int'];
  id: Scalars['Int'];
  invoiceLineItemId: Scalars['Int'];
  manuallySentById: Scalars['Int'];
  originAutomationId: Scalars['Int'];
  returnToAutomationActionId: Scalars['Int'];
  runType: Scalars['Int'];
  serviceReminderId: Scalars['Int'];
  startedAt: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type AutomationRunCountOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  automationEvent?: Maybe<SortOrder>;
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  channelMessageId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItemId?: Maybe<SortOrder>;
  manuallySentById?: Maybe<SortOrder>;
  originAutomationId?: Maybe<SortOrder>;
  returnToAutomationActionId?: Maybe<SortOrder>;
  runType?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AutomationRunCountOutputType = {
  __typename?: 'AutomationRunCountOutputType';
  HillsToHomeAPILog: Scalars['Int'];
  actions: Scalars['Int'];
  surveyResults: Scalars['Int'];
  tasks: Scalars['Int'];
};

export type AutomationRunCreateInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateManyAppointmentInput = {
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateManyAppointmentInputEnvelope = {
  data: Array<AutomationRunCreateManyAppointmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunCreateManyClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateManyClinicInputEnvelope = {
  data: Array<AutomationRunCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunCreateManyClinicPetParentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateManyClinicPetParentInputEnvelope = {
  data: Array<AutomationRunCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunCreateManyClinicWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateManyClinicWidgetRequestInputEnvelope = {
  data: Array<AutomationRunCreateManyClinicWidgetRequestInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunCreateManyFormSubmissionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateManyFormSubmissionInputEnvelope = {
  data: Array<AutomationRunCreateManyFormSubmissionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunCreateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateManyInvioceLineItemInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateManyInvioceLineItemInputEnvelope = {
  data: Array<AutomationRunCreateManyInvioceLineItemInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunCreateManyManuallySentByInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateManyManuallySentByInputEnvelope = {
  data: Array<AutomationRunCreateManyManuallySentByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunCreateManyOriginAutomationInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateManyOriginAutomationInputEnvelope = {
  data: Array<AutomationRunCreateManyOriginAutomationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunCreateManyReturnToAutomationActionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateManyReturnToAutomationActionInputEnvelope = {
  data: Array<AutomationRunCreateManyReturnToAutomationActionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunCreateManyServiceReminderInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateManyServiceReminderInputEnvelope = {
  data: Array<AutomationRunCreateManyServiceReminderInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AutomationRunCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutAppointmentInput>>;
  createMany?: Maybe<AutomationRunCreateManyAppointmentInputEnvelope>;
};

export type AutomationRunCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutClinicInput>>;
  createMany?: Maybe<AutomationRunCreateManyClinicInputEnvelope>;
};

export type AutomationRunCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<AutomationRunCreateManyClinicPetParentInputEnvelope>;
};

export type AutomationRunCreateNestedManyWithoutClinicWidgetRequestInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<AutomationRunCreateManyClinicWidgetRequestInputEnvelope>;
};

export type AutomationRunCreateNestedManyWithoutFormSubmissionInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<AutomationRunCreateManyFormSubmissionInputEnvelope>;
};

export type AutomationRunCreateNestedManyWithoutInvioceLineItemInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutInvioceLineItemInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutInvioceLineItemInput>>;
  createMany?: Maybe<AutomationRunCreateManyInvioceLineItemInputEnvelope>;
};

export type AutomationRunCreateNestedManyWithoutManuallySentByInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutManuallySentByInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutManuallySentByInput>>;
  createMany?: Maybe<AutomationRunCreateManyManuallySentByInputEnvelope>;
};

export type AutomationRunCreateNestedManyWithoutOriginAutomationInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutOriginAutomationInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutOriginAutomationInput>>;
  createMany?: Maybe<AutomationRunCreateManyOriginAutomationInputEnvelope>;
};

export type AutomationRunCreateNestedManyWithoutReturnToAutomationActionInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutReturnToAutomationActionInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutReturnToAutomationActionInput>>;
  createMany?: Maybe<AutomationRunCreateManyReturnToAutomationActionInputEnvelope>;
};

export type AutomationRunCreateNestedManyWithoutServiceReminderInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<AutomationRunCreateManyServiceReminderInputEnvelope>;
};

export type AutomationRunCreateNestedOneWithoutActionsInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutActionsInput>;
  create?: Maybe<AutomationRunCreateWithoutActionsInput>;
};

export type AutomationRunCreateNestedOneWithoutCareCreditPreapprovalCheckInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutCareCreditPreapprovalCheckInput>;
  create?: Maybe<AutomationRunCreateWithoutCareCreditPreapprovalCheckInput>;
};

export type AutomationRunCreateNestedOneWithoutChannelMessageInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutChannelMessageInput>;
  create?: Maybe<AutomationRunCreateWithoutChannelMessageInput>;
};

export type AutomationRunCreateNestedOneWithoutHillsToHomeApiLogInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutHillsToHomeApiLogInput>;
  create?: Maybe<AutomationRunCreateWithoutHillsToHomeApiLogInput>;
};

export type AutomationRunCreateNestedOneWithoutSurveyResultsInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutSurveyResultsInput>;
  create?: Maybe<AutomationRunCreateWithoutSurveyResultsInput>;
};

export type AutomationRunCreateNestedOneWithoutTasksInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutTasksInput>;
  create?: Maybe<AutomationRunCreateWithoutTasksInput>;
};

export type AutomationRunCreateOrConnectWithoutActionsInput = {
  create: AutomationRunCreateWithoutActionsInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutAppointmentInput = {
  create: AutomationRunCreateWithoutAppointmentInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutCareCreditPreapprovalCheckInput = {
  create: AutomationRunCreateWithoutCareCreditPreapprovalCheckInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutChannelMessageInput = {
  create: AutomationRunCreateWithoutChannelMessageInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutClinicInput = {
  create: AutomationRunCreateWithoutClinicInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutClinicPetParentInput = {
  create: AutomationRunCreateWithoutClinicPetParentInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutClinicWidgetRequestInput = {
  create: AutomationRunCreateWithoutClinicWidgetRequestInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutFormSubmissionInput = {
  create: AutomationRunCreateWithoutFormSubmissionInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutHillsToHomeApiLogInput = {
  create: AutomationRunCreateWithoutHillsToHomeApiLogInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutInvioceLineItemInput = {
  create: AutomationRunCreateWithoutInvioceLineItemInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutManuallySentByInput = {
  create: AutomationRunCreateWithoutManuallySentByInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutOriginAutomationInput = {
  create: AutomationRunCreateWithoutOriginAutomationInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutReturnToAutomationActionInput = {
  create: AutomationRunCreateWithoutReturnToAutomationActionInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutServiceReminderInput = {
  create: AutomationRunCreateWithoutServiceReminderInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutSurveyResultsInput = {
  create: AutomationRunCreateWithoutSurveyResultsInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateOrConnectWithoutTasksInput = {
  create: AutomationRunCreateWithoutTasksInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunCreateWithoutActionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutAppointmentInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutCareCreditPreapprovalCheckInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutChannelMessageInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutClinicInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutClinicPetParentInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutClinicWidgetRequestInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutFormSubmissionInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutHillsToHomeApiLogInput = {
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutInvioceLineItemInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutManuallySentByInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutOriginAutomationInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutReturnToAutomationActionInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutServiceReminderInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutSurveyResultsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunCreateWithoutTasksInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationRunInput>;
  appointment?: Maybe<AppointmentCreateNestedOneWithoutAutomationRunsInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessageCreateNestedOneWithoutAutomationRunInput;
  clinic: ClinicCreateNestedOneWithoutAutomationRunsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAutomationRunsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutAutomationRunsInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutAutomationRunInput>;
  manuallySentBy?: Maybe<UserCreateNestedOneWithoutManuallySentAutomationRunsInput>;
  originAutomation: WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput;
  returnToAutomationAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutAutomationRunsInput>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunGroupByOutputType = {
  __typename?: 'AutomationRunGroupByOutputType';
  _count?: Maybe<AutomationRunCountAggregateOutputType>;
  _max?: Maybe<AutomationRunMaxAggregateOutputType>;
  _min?: Maybe<AutomationRunMinAggregateOutputType>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType: AutomationRunType;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status: AutomationRunStatus;
  updatedAt: Scalars['DateTime'];
};

export type AutomationRunListRelationFilter = {
  every?: Maybe<AutomationRunWhereInput>;
  none?: Maybe<AutomationRunWhereInput>;
  some?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunMaxAggregateOutputType = {
  __typename?: 'AutomationRunMaxAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunMaxOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  automationEvent?: Maybe<SortOrder>;
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  channelMessageId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItemId?: Maybe<SortOrder>;
  manuallySentById?: Maybe<SortOrder>;
  originAutomationId?: Maybe<SortOrder>;
  returnToAutomationActionId?: Maybe<SortOrder>;
  runType?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AutomationRunMinAggregateOutputType = {
  __typename?: 'AutomationRunMinAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunMinOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  automationEvent?: Maybe<SortOrder>;
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  channelMessageId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItemId?: Maybe<SortOrder>;
  manuallySentById?: Maybe<SortOrder>;
  originAutomationId?: Maybe<SortOrder>;
  returnToAutomationActionId?: Maybe<SortOrder>;
  runType?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AutomationRunNullableScalarRelationFilter = {
  AND?: Maybe<Array<AutomationRunWhereInput>>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<AutomationRunWhereInput>>;
  OR?: Maybe<Array<AutomationRunWhereInput>>;
  actions?: Maybe<AutomationRunActionListRelationFilter>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  automationEvent?: Maybe<EnumWorkflowEventFilter>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckNullableScalarRelationFilter>;
  careCreditPreapprovalCheckId?: Maybe<StringNullableFilter>;
  channelMessage?: Maybe<ChannelMessageScalarRelationFilter>;
  channelMessageId?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invioceLineItem?: Maybe<InvoiceLineItemNullableScalarRelationFilter>;
  invoiceLineItemId?: Maybe<StringNullableFilter>;
  manuallySentBy?: Maybe<UserNullableScalarRelationFilter>;
  manuallySentById?: Maybe<StringNullableFilter>;
  originAutomation?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  originAutomationId?: Maybe<StringFilter>;
  returnToAutomationAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  returnToAutomationActionId?: Maybe<StringNullableFilter>;
  runType?: Maybe<EnumAutomationRunTypeFilter>;
  serviceReminder?: Maybe<ServiceReminderNullableScalarRelationFilter>;
  serviceReminderId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumAutomationRunStatusFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AutomationRunOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type AutomationRunOrderByRelationAndSearchRelevanceInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  _relevance?: Maybe<AutomationRunOrderByRelevanceInput>;
  actions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  automationEvent?: Maybe<SortOrder>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckOrderByWithRelationInput>;
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  channelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  channelMessageId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invioceLineItem?: Maybe<InvoiceLineItemOrderByWithRelationInput>;
  invoiceLineItemId?: Maybe<SortOrder>;
  manuallySentBy?: Maybe<UserOrderByWithRelationInput>;
  manuallySentById?: Maybe<SortOrder>;
  originAutomation?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  originAutomationId?: Maybe<SortOrder>;
  returnToAutomationAction?: Maybe<WorkflowEventActionOrderByWithRelationInput>;
  returnToAutomationActionId?: Maybe<SortOrder>;
  runType?: Maybe<SortOrder>;
  serviceReminder?: Maybe<ServiceReminderOrderByWithRelationInput>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  surveyResults?: Maybe<SurveyResultOrderByRelationAggregateInput>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum AutomationRunOrderByRelevanceFieldEnum {
  AppointmentId = 'appointmentId',
  CareCreditPreapprovalCheckId = 'careCreditPreapprovalCheckId',
  ChannelMessageId = 'channelMessageId',
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  ClinicWidgetRequestId = 'clinicWidgetRequestId',
  FormSubmissionId = 'formSubmissionId',
  Id = 'id',
  InvoiceLineItemId = 'invoiceLineItemId',
  ManuallySentById = 'manuallySentById',
  OriginAutomationId = 'originAutomationId',
  ReturnToAutomationActionId = 'returnToAutomationActionId',
  ServiceReminderId = 'serviceReminderId'
}

export type AutomationRunOrderByRelevanceInput = {
  fields: Array<AutomationRunOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type AutomationRunOrderByWithAggregationInput = {
  _count?: Maybe<AutomationRunCountOrderByAggregateInput>;
  _max?: Maybe<AutomationRunMaxOrderByAggregateInput>;
  _min?: Maybe<AutomationRunMinOrderByAggregateInput>;
  appointmentId?: Maybe<SortOrder>;
  automationEvent?: Maybe<SortOrder>;
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  channelMessageId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItemId?: Maybe<SortOrder>;
  manuallySentById?: Maybe<SortOrder>;
  originAutomationId?: Maybe<SortOrder>;
  returnToAutomationActionId?: Maybe<SortOrder>;
  runType?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AutomationRunOrderByWithRelationAndSearchRelevanceInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  _relevance?: Maybe<AutomationRunOrderByRelevanceInput>;
  actions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  automationEvent?: Maybe<SortOrder>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckOrderByWithRelationInput>;
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  channelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  channelMessageId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invioceLineItem?: Maybe<InvoiceLineItemOrderByWithRelationInput>;
  invoiceLineItemId?: Maybe<SortOrder>;
  manuallySentBy?: Maybe<UserOrderByWithRelationInput>;
  manuallySentById?: Maybe<SortOrder>;
  originAutomation?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  originAutomationId?: Maybe<SortOrder>;
  returnToAutomationAction?: Maybe<WorkflowEventActionOrderByWithRelationInput>;
  returnToAutomationActionId?: Maybe<SortOrder>;
  runType?: Maybe<SortOrder>;
  serviceReminder?: Maybe<ServiceReminderOrderByWithRelationInput>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  surveyResults?: Maybe<SurveyResultOrderByRelationAggregateInput>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type AutomationRunOrderByWithRelationInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  _relevance?: Maybe<AutomationRunOrderByRelevanceInput>;
  actions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  automationEvent?: Maybe<SortOrder>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckOrderByWithRelationInput>;
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  channelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  channelMessageId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invioceLineItem?: Maybe<InvoiceLineItemOrderByWithRelationInput>;
  invoiceLineItemId?: Maybe<SortOrder>;
  manuallySentBy?: Maybe<UserOrderByWithRelationInput>;
  manuallySentById?: Maybe<SortOrder>;
  originAutomation?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  originAutomationId?: Maybe<SortOrder>;
  returnToAutomationAction?: Maybe<WorkflowEventActionOrderByWithRelationInput>;
  returnToAutomationActionId?: Maybe<SortOrder>;
  runType?: Maybe<SortOrder>;
  serviceReminder?: Maybe<ServiceReminderOrderByWithRelationInput>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  surveyResults?: Maybe<SurveyResultOrderByRelationAggregateInput>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum AutomationRunScalarFieldEnum {
  AppointmentId = 'appointmentId',
  AutomationEvent = 'automationEvent',
  CareCreditPreapprovalCheckId = 'careCreditPreapprovalCheckId',
  ChannelMessageId = 'channelMessageId',
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  ClinicWidgetRequestId = 'clinicWidgetRequestId',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  FormSubmissionId = 'formSubmissionId',
  Id = 'id',
  InvoiceLineItemId = 'invoiceLineItemId',
  ManuallySentById = 'manuallySentById',
  OriginAutomationId = 'originAutomationId',
  ReturnToAutomationActionId = 'returnToAutomationActionId',
  RunType = 'runType',
  ServiceReminderId = 'serviceReminderId',
  StartedAt = 'startedAt',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type AutomationRunScalarRelationFilter = {
  AND?: Maybe<Array<AutomationRunWhereInput>>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<AutomationRunWhereInput>>;
  OR?: Maybe<Array<AutomationRunWhereInput>>;
  actions?: Maybe<AutomationRunActionListRelationFilter>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  automationEvent?: Maybe<EnumWorkflowEventFilter>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckNullableScalarRelationFilter>;
  careCreditPreapprovalCheckId?: Maybe<StringNullableFilter>;
  channelMessage?: Maybe<ChannelMessageScalarRelationFilter>;
  channelMessageId?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invioceLineItem?: Maybe<InvoiceLineItemNullableScalarRelationFilter>;
  invoiceLineItemId?: Maybe<StringNullableFilter>;
  manuallySentBy?: Maybe<UserNullableScalarRelationFilter>;
  manuallySentById?: Maybe<StringNullableFilter>;
  originAutomation?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  originAutomationId?: Maybe<StringFilter>;
  returnToAutomationAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  returnToAutomationActionId?: Maybe<StringNullableFilter>;
  runType?: Maybe<EnumAutomationRunTypeFilter>;
  serviceReminder?: Maybe<ServiceReminderNullableScalarRelationFilter>;
  serviceReminderId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumAutomationRunStatusFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AutomationRunScalarWhereInput = {
  AND?: Maybe<Array<AutomationRunScalarWhereInput>>;
  NOT?: Maybe<Array<AutomationRunScalarWhereInput>>;
  OR?: Maybe<Array<AutomationRunScalarWhereInput>>;
  appointmentId?: Maybe<StringNullableFilter>;
  automationEvent?: Maybe<EnumWorkflowEventFilter>;
  careCreditPreapprovalCheckId?: Maybe<StringNullableFilter>;
  channelMessageId?: Maybe<StringFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invoiceLineItemId?: Maybe<StringNullableFilter>;
  manuallySentById?: Maybe<StringNullableFilter>;
  originAutomationId?: Maybe<StringFilter>;
  returnToAutomationActionId?: Maybe<StringNullableFilter>;
  runType?: Maybe<EnumAutomationRunTypeFilter>;
  serviceReminderId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumAutomationRunStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AutomationRunScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<AutomationRunScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<AutomationRunScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<AutomationRunScalarWhereWithAggregatesInput>>;
  appointmentId?: Maybe<StringNullableWithAggregatesFilter>;
  automationEvent?: Maybe<EnumWorkflowEventWithAggregatesFilter>;
  careCreditPreapprovalCheckId?: Maybe<StringNullableWithAggregatesFilter>;
  channelMessageId?: Maybe<StringWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableWithAggregatesFilter>;
  completedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  formSubmissionId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  invoiceLineItemId?: Maybe<StringNullableWithAggregatesFilter>;
  manuallySentById?: Maybe<StringNullableWithAggregatesFilter>;
  originAutomationId?: Maybe<StringWithAggregatesFilter>;
  returnToAutomationActionId?: Maybe<StringNullableWithAggregatesFilter>;
  runType?: Maybe<EnumAutomationRunTypeWithAggregatesFilter>;
  serviceReminderId?: Maybe<StringNullableWithAggregatesFilter>;
  startedAt?: Maybe<DateTimeWithAggregatesFilter>;
  status?: Maybe<EnumAutomationRunStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum AutomationRunStatus {
  Completed = 'Completed',
  Sent = 'Sent',
  Started = 'Started'
}

export type AutomationRunSubscription = {
  __typename?: 'AutomationRunSubscription';
  mutation: MutationType;
  node: AutomationRun;
};

export enum AutomationRunType {
  Automated = 'Automated',
  Manual = 'Manual'
}

export type AutomationRunUncheckedCreateInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutAppointmentInput>>;
  createMany?: Maybe<AutomationRunCreateManyAppointmentInputEnvelope>;
};

export type AutomationRunUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutClinicInput>>;
  createMany?: Maybe<AutomationRunCreateManyClinicInputEnvelope>;
};

export type AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<AutomationRunCreateManyClinicPetParentInputEnvelope>;
};

export type AutomationRunUncheckedCreateNestedManyWithoutClinicWidgetRequestInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<AutomationRunCreateManyClinicWidgetRequestInputEnvelope>;
};

export type AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<AutomationRunCreateManyFormSubmissionInputEnvelope>;
};

export type AutomationRunUncheckedCreateNestedManyWithoutInvioceLineItemInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutInvioceLineItemInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutInvioceLineItemInput>>;
  createMany?: Maybe<AutomationRunCreateManyInvioceLineItemInputEnvelope>;
};

export type AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutManuallySentByInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutManuallySentByInput>>;
  createMany?: Maybe<AutomationRunCreateManyManuallySentByInputEnvelope>;
};

export type AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutOriginAutomationInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutOriginAutomationInput>>;
  createMany?: Maybe<AutomationRunCreateManyOriginAutomationInputEnvelope>;
};

export type AutomationRunUncheckedCreateNestedManyWithoutReturnToAutomationActionInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutReturnToAutomationActionInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutReturnToAutomationActionInput>>;
  createMany?: Maybe<AutomationRunCreateManyReturnToAutomationActionInputEnvelope>;
};

export type AutomationRunUncheckedCreateNestedManyWithoutServiceReminderInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<AutomationRunCreateManyServiceReminderInputEnvelope>;
};

export type AutomationRunUncheckedCreateNestedOneWithoutChannelMessageInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutChannelMessageInput>;
  create?: Maybe<AutomationRunCreateWithoutChannelMessageInput>;
};

export type AutomationRunUncheckedCreateWithoutActionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutAppointmentInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutCareCreditPreapprovalCheckInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutChannelMessageInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutClinicInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutClinicPetParentInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutClinicWidgetRequestInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutFormSubmissionInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutHillsToHomeApiLogInput = {
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutInvioceLineItemInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutManuallySentByInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutOriginAutomationInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutReturnToAutomationActionInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutServiceReminderInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutSurveyResultsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedCreateWithoutTasksInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput>;
  actions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationRunInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId: Scalars['String'];
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateManyWithoutAppointmentInput = {
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutAppointmentInput>>;
  createMany?: Maybe<AutomationRunCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type AutomationRunUncheckedUpdateManyWithoutClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutClinicInput>>;
  createMany?: Maybe<AutomationRunCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type AutomationRunUncheckedUpdateManyWithoutClinicPetParentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<AutomationRunCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type AutomationRunUncheckedUpdateManyWithoutClinicWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<AutomationRunCreateManyClinicWidgetRequestInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutClinicWidgetRequestInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutClinicWidgetRequestInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutClinicWidgetRequestInput>>;
};

export type AutomationRunUncheckedUpdateManyWithoutFormSubmissionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<AutomationRunCreateManyFormSubmissionInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutFormSubmissionInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutFormSubmissionInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutFormSubmissionInput>>;
};

export type AutomationRunUncheckedUpdateManyWithoutInvioceLineItemInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateManyWithoutInvioceLineItemNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutInvioceLineItemInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutInvioceLineItemInput>>;
  createMany?: Maybe<AutomationRunCreateManyInvioceLineItemInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutInvioceLineItemInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutInvioceLineItemInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutInvioceLineItemInput>>;
};

export type AutomationRunUncheckedUpdateManyWithoutManuallySentByInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutManuallySentByInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutManuallySentByInput>>;
  createMany?: Maybe<AutomationRunCreateManyManuallySentByInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutManuallySentByInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutManuallySentByInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutManuallySentByInput>>;
};

export type AutomationRunUncheckedUpdateManyWithoutOriginAutomationInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutOriginAutomationInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutOriginAutomationInput>>;
  createMany?: Maybe<AutomationRunCreateManyOriginAutomationInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutOriginAutomationInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutOriginAutomationInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutOriginAutomationInput>>;
};

export type AutomationRunUncheckedUpdateManyWithoutReturnToAutomationActionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateManyWithoutReturnToAutomationActionNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutReturnToAutomationActionInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutReturnToAutomationActionInput>>;
  createMany?: Maybe<AutomationRunCreateManyReturnToAutomationActionInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutReturnToAutomationActionInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutReturnToAutomationActionInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutReturnToAutomationActionInput>>;
};

export type AutomationRunUncheckedUpdateManyWithoutServiceReminderInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateManyWithoutServiceReminderNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<AutomationRunCreateManyServiceReminderInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutServiceReminderInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutServiceReminderInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutServiceReminderInput>>;
};

export type AutomationRunUncheckedUpdateOneWithoutChannelMessageNestedInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutChannelMessageInput>;
  create?: Maybe<AutomationRunCreateWithoutChannelMessageInput>;
  delete?: Maybe<AutomationRunWhereInput>;
  disconnect?: Maybe<AutomationRunWhereInput>;
  update?: Maybe<AutomationRunUpdateToOneWithWhereWithoutChannelMessageInput>;
  upsert?: Maybe<AutomationRunUpsertWithoutChannelMessageInput>;
};

export type AutomationRunUncheckedUpdateWithoutActionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutAppointmentInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutCareCreditPreapprovalCheckInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutChannelMessageInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutClinicInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutClinicPetParentInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutClinicWidgetRequestInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutFormSubmissionInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutHillsToHomeApiLogInput = {
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutInvioceLineItemInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutManuallySentByInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutOriginAutomationInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutReturnToAutomationActionInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutServiceReminderInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutSurveyResultsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUncheckedUpdateWithoutTasksInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomationId?: Maybe<Scalars['String']>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateManyMutationInput = {
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  runType?: Maybe<AutomationRunType>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateManyWithWhereWithoutAppointmentInput = {
  data: AutomationRunUpdateManyMutationInput;
  where: AutomationRunScalarWhereInput;
};

export type AutomationRunUpdateManyWithWhereWithoutClinicInput = {
  data: AutomationRunUpdateManyMutationInput;
  where: AutomationRunScalarWhereInput;
};

export type AutomationRunUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: AutomationRunUpdateManyMutationInput;
  where: AutomationRunScalarWhereInput;
};

export type AutomationRunUpdateManyWithWhereWithoutClinicWidgetRequestInput = {
  data: AutomationRunUpdateManyMutationInput;
  where: AutomationRunScalarWhereInput;
};

export type AutomationRunUpdateManyWithWhereWithoutFormSubmissionInput = {
  data: AutomationRunUpdateManyMutationInput;
  where: AutomationRunScalarWhereInput;
};

export type AutomationRunUpdateManyWithWhereWithoutInvioceLineItemInput = {
  data: AutomationRunUpdateManyMutationInput;
  where: AutomationRunScalarWhereInput;
};

export type AutomationRunUpdateManyWithWhereWithoutManuallySentByInput = {
  data: AutomationRunUpdateManyMutationInput;
  where: AutomationRunScalarWhereInput;
};

export type AutomationRunUpdateManyWithWhereWithoutOriginAutomationInput = {
  data: AutomationRunUpdateManyMutationInput;
  where: AutomationRunScalarWhereInput;
};

export type AutomationRunUpdateManyWithWhereWithoutReturnToAutomationActionInput = {
  data: AutomationRunUpdateManyMutationInput;
  where: AutomationRunScalarWhereInput;
};

export type AutomationRunUpdateManyWithWhereWithoutServiceReminderInput = {
  data: AutomationRunUpdateManyMutationInput;
  where: AutomationRunScalarWhereInput;
};

export type AutomationRunUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutAppointmentInput>>;
  createMany?: Maybe<AutomationRunCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type AutomationRunUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutClinicInput>>;
  createMany?: Maybe<AutomationRunCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type AutomationRunUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<AutomationRunCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type AutomationRunUpdateManyWithoutClinicWidgetRequestNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<AutomationRunCreateManyClinicWidgetRequestInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutClinicWidgetRequestInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutClinicWidgetRequestInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutClinicWidgetRequestInput>>;
};

export type AutomationRunUpdateManyWithoutFormSubmissionNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<AutomationRunCreateManyFormSubmissionInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutFormSubmissionInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutFormSubmissionInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutFormSubmissionInput>>;
};

export type AutomationRunUpdateManyWithoutInvioceLineItemNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutInvioceLineItemInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutInvioceLineItemInput>>;
  createMany?: Maybe<AutomationRunCreateManyInvioceLineItemInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutInvioceLineItemInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutInvioceLineItemInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutInvioceLineItemInput>>;
};

export type AutomationRunUpdateManyWithoutManuallySentByNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutManuallySentByInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutManuallySentByInput>>;
  createMany?: Maybe<AutomationRunCreateManyManuallySentByInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutManuallySentByInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutManuallySentByInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutManuallySentByInput>>;
};

export type AutomationRunUpdateManyWithoutOriginAutomationNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutOriginAutomationInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutOriginAutomationInput>>;
  createMany?: Maybe<AutomationRunCreateManyOriginAutomationInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutOriginAutomationInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutOriginAutomationInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutOriginAutomationInput>>;
};

export type AutomationRunUpdateManyWithoutReturnToAutomationActionNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutReturnToAutomationActionInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutReturnToAutomationActionInput>>;
  createMany?: Maybe<AutomationRunCreateManyReturnToAutomationActionInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutReturnToAutomationActionInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutReturnToAutomationActionInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutReturnToAutomationActionInput>>;
};

export type AutomationRunUpdateManyWithoutServiceReminderNestedInput = {
  connect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AutomationRunCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<AutomationRunCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<AutomationRunCreateManyServiceReminderInputEnvelope>;
  delete?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AutomationRunScalarWhereInput>>;
  disconnect?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  set?: Maybe<Array<AutomationRunWhereUniqueInput>>;
  update?: Maybe<Array<AutomationRunUpdateWithWhereUniqueWithoutServiceReminderInput>>;
  updateMany?: Maybe<Array<AutomationRunUpdateManyWithWhereWithoutServiceReminderInput>>;
  upsert?: Maybe<Array<AutomationRunUpsertWithWhereUniqueWithoutServiceReminderInput>>;
};

export type AutomationRunUpdateOneRequiredWithoutActionsNestedInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutActionsInput>;
  create?: Maybe<AutomationRunCreateWithoutActionsInput>;
  update?: Maybe<AutomationRunUpdateToOneWithWhereWithoutActionsInput>;
  upsert?: Maybe<AutomationRunUpsertWithoutActionsInput>;
};

export type AutomationRunUpdateOneWithoutCareCreditPreapprovalCheckNestedInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutCareCreditPreapprovalCheckInput>;
  create?: Maybe<AutomationRunCreateWithoutCareCreditPreapprovalCheckInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AutomationRunUpdateToOneWithWhereWithoutCareCreditPreapprovalCheckInput>;
  upsert?: Maybe<AutomationRunUpsertWithoutCareCreditPreapprovalCheckInput>;
};

export type AutomationRunUpdateOneWithoutChannelMessageNestedInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutChannelMessageInput>;
  create?: Maybe<AutomationRunCreateWithoutChannelMessageInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AutomationRunUpdateToOneWithWhereWithoutChannelMessageInput>;
  upsert?: Maybe<AutomationRunUpsertWithoutChannelMessageInput>;
};

export type AutomationRunUpdateOneWithoutHillsToHomeApiLogNestedInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutHillsToHomeApiLogInput>;
  create?: Maybe<AutomationRunCreateWithoutHillsToHomeApiLogInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AutomationRunUpdateToOneWithWhereWithoutHillsToHomeApiLogInput>;
  upsert?: Maybe<AutomationRunUpsertWithoutHillsToHomeApiLogInput>;
};

export type AutomationRunUpdateOneWithoutSurveyResultsNestedInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutSurveyResultsInput>;
  create?: Maybe<AutomationRunCreateWithoutSurveyResultsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AutomationRunUpdateToOneWithWhereWithoutSurveyResultsInput>;
  upsert?: Maybe<AutomationRunUpsertWithoutSurveyResultsInput>;
};

export type AutomationRunUpdateOneWithoutTasksNestedInput = {
  connect?: Maybe<AutomationRunWhereUniqueInput>;
  connectOrCreate?: Maybe<AutomationRunCreateOrConnectWithoutTasksInput>;
  create?: Maybe<AutomationRunCreateWithoutTasksInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AutomationRunUpdateToOneWithWhereWithoutTasksInput>;
  upsert?: Maybe<AutomationRunUpsertWithoutTasksInput>;
};

export type AutomationRunUpdateToOneWithWhereWithoutActionsInput = {
  data: AutomationRunUpdateWithoutActionsInput;
  where?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunUpdateToOneWithWhereWithoutCareCreditPreapprovalCheckInput = {
  data: AutomationRunUpdateWithoutCareCreditPreapprovalCheckInput;
  where?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunUpdateToOneWithWhereWithoutChannelMessageInput = {
  data: AutomationRunUpdateWithoutChannelMessageInput;
  where?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunUpdateToOneWithWhereWithoutHillsToHomeApiLogInput = {
  data: AutomationRunUpdateWithoutHillsToHomeApiLogInput;
  where?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunUpdateToOneWithWhereWithoutSurveyResultsInput = {
  data: AutomationRunUpdateWithoutSurveyResultsInput;
  where?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunUpdateToOneWithWhereWithoutTasksInput = {
  data: AutomationRunUpdateWithoutTasksInput;
  where?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunUpdateWithWhereUniqueWithoutAppointmentInput = {
  data: AutomationRunUpdateWithoutAppointmentInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpdateWithWhereUniqueWithoutClinicInput = {
  data: AutomationRunUpdateWithoutClinicInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: AutomationRunUpdateWithoutClinicPetParentInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpdateWithWhereUniqueWithoutClinicWidgetRequestInput = {
  data: AutomationRunUpdateWithoutClinicWidgetRequestInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpdateWithWhereUniqueWithoutFormSubmissionInput = {
  data: AutomationRunUpdateWithoutFormSubmissionInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpdateWithWhereUniqueWithoutInvioceLineItemInput = {
  data: AutomationRunUpdateWithoutInvioceLineItemInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpdateWithWhereUniqueWithoutManuallySentByInput = {
  data: AutomationRunUpdateWithoutManuallySentByInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpdateWithWhereUniqueWithoutOriginAutomationInput = {
  data: AutomationRunUpdateWithoutOriginAutomationInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpdateWithWhereUniqueWithoutReturnToAutomationActionInput = {
  data: AutomationRunUpdateWithoutReturnToAutomationActionInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpdateWithWhereUniqueWithoutServiceReminderInput = {
  data: AutomationRunUpdateWithoutServiceReminderInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpdateWithoutActionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutAppointmentInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutCareCreditPreapprovalCheckInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutChannelMessageInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutClinicInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutClinicPetParentInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutClinicWidgetRequestInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutFormSubmissionInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutHillsToHomeApiLogInput = {
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutInvioceLineItemInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutManuallySentByInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutOriginAutomationInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutReturnToAutomationActionInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutServiceReminderInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutSurveyResultsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  tasks?: Maybe<TaskUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpdateWithoutTasksInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput>;
  actions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationRunNestedInput>;
  appointment?: Maybe<AppointmentUpdateOneWithoutAutomationRunsNestedInput>;
  automationEvent?: Maybe<WorkflowEvent>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutAutomationRunsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput>;
  manuallySentBy?: Maybe<UserUpdateOneWithoutManuallySentAutomationRunsNestedInput>;
  originAutomation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput>;
  returnToAutomationAction?: Maybe<WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput>;
  runType?: Maybe<AutomationRunType>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutAutomationRunsNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationRunStatus>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutAutomationRunNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationRunUpsertWithWhereUniqueWithoutAppointmentInput = {
  create: AutomationRunCreateWithoutAppointmentInput;
  update: AutomationRunUpdateWithoutAppointmentInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpsertWithWhereUniqueWithoutClinicInput = {
  create: AutomationRunCreateWithoutClinicInput;
  update: AutomationRunUpdateWithoutClinicInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: AutomationRunCreateWithoutClinicPetParentInput;
  update: AutomationRunUpdateWithoutClinicPetParentInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpsertWithWhereUniqueWithoutClinicWidgetRequestInput = {
  create: AutomationRunCreateWithoutClinicWidgetRequestInput;
  update: AutomationRunUpdateWithoutClinicWidgetRequestInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpsertWithWhereUniqueWithoutFormSubmissionInput = {
  create: AutomationRunCreateWithoutFormSubmissionInput;
  update: AutomationRunUpdateWithoutFormSubmissionInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpsertWithWhereUniqueWithoutInvioceLineItemInput = {
  create: AutomationRunCreateWithoutInvioceLineItemInput;
  update: AutomationRunUpdateWithoutInvioceLineItemInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpsertWithWhereUniqueWithoutManuallySentByInput = {
  create: AutomationRunCreateWithoutManuallySentByInput;
  update: AutomationRunUpdateWithoutManuallySentByInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpsertWithWhereUniqueWithoutOriginAutomationInput = {
  create: AutomationRunCreateWithoutOriginAutomationInput;
  update: AutomationRunUpdateWithoutOriginAutomationInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpsertWithWhereUniqueWithoutReturnToAutomationActionInput = {
  create: AutomationRunCreateWithoutReturnToAutomationActionInput;
  update: AutomationRunUpdateWithoutReturnToAutomationActionInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpsertWithWhereUniqueWithoutServiceReminderInput = {
  create: AutomationRunCreateWithoutServiceReminderInput;
  update: AutomationRunUpdateWithoutServiceReminderInput;
  where: AutomationRunWhereUniqueInput;
};

export type AutomationRunUpsertWithoutActionsInput = {
  create: AutomationRunCreateWithoutActionsInput;
  update: AutomationRunUpdateWithoutActionsInput;
  where?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunUpsertWithoutCareCreditPreapprovalCheckInput = {
  create: AutomationRunCreateWithoutCareCreditPreapprovalCheckInput;
  update: AutomationRunUpdateWithoutCareCreditPreapprovalCheckInput;
  where?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunUpsertWithoutChannelMessageInput = {
  create: AutomationRunCreateWithoutChannelMessageInput;
  update: AutomationRunUpdateWithoutChannelMessageInput;
  where?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunUpsertWithoutHillsToHomeApiLogInput = {
  create: AutomationRunCreateWithoutHillsToHomeApiLogInput;
  update: AutomationRunUpdateWithoutHillsToHomeApiLogInput;
  where?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunUpsertWithoutSurveyResultsInput = {
  create: AutomationRunCreateWithoutSurveyResultsInput;
  update: AutomationRunUpdateWithoutSurveyResultsInput;
  where?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunUpsertWithoutTasksInput = {
  create: AutomationRunCreateWithoutTasksInput;
  update: AutomationRunUpdateWithoutTasksInput;
  where?: Maybe<AutomationRunWhereInput>;
};

export type AutomationRunWhereInput = {
  AND?: Maybe<Array<AutomationRunWhereInput>>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<AutomationRunWhereInput>>;
  OR?: Maybe<Array<AutomationRunWhereInput>>;
  actions?: Maybe<AutomationRunActionListRelationFilter>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  automationEvent?: Maybe<EnumWorkflowEventFilter>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckNullableScalarRelationFilter>;
  careCreditPreapprovalCheckId?: Maybe<StringNullableFilter>;
  channelMessage?: Maybe<ChannelMessageScalarRelationFilter>;
  channelMessageId?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invioceLineItem?: Maybe<InvoiceLineItemNullableScalarRelationFilter>;
  invoiceLineItemId?: Maybe<StringNullableFilter>;
  manuallySentBy?: Maybe<UserNullableScalarRelationFilter>;
  manuallySentById?: Maybe<StringNullableFilter>;
  originAutomation?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  originAutomationId?: Maybe<StringFilter>;
  returnToAutomationAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  returnToAutomationActionId?: Maybe<StringNullableFilter>;
  runType?: Maybe<EnumAutomationRunTypeFilter>;
  serviceReminder?: Maybe<ServiceReminderNullableScalarRelationFilter>;
  serviceReminderId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumAutomationRunStatusFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AutomationRunWhereUniqueInput = {
  AND?: Maybe<Array<AutomationRunWhereInput>>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<AutomationRunWhereInput>>;
  OR?: Maybe<Array<AutomationRunWhereInput>>;
  actions?: Maybe<AutomationRunActionListRelationFilter>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  automationEvent?: Maybe<EnumWorkflowEventFilter>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckNullableScalarRelationFilter>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageScalarRelationFilter>;
  channelMessageId?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  invioceLineItem?: Maybe<InvoiceLineItemNullableScalarRelationFilter>;
  invoiceLineItemId?: Maybe<StringNullableFilter>;
  manuallySentBy?: Maybe<UserNullableScalarRelationFilter>;
  manuallySentById?: Maybe<StringNullableFilter>;
  originAutomation?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  originAutomationId?: Maybe<StringFilter>;
  returnToAutomationAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  returnToAutomationActionId?: Maybe<StringNullableFilter>;
  runType?: Maybe<EnumAutomationRunTypeFilter>;
  serviceReminder?: Maybe<ServiceReminderNullableScalarRelationFilter>;
  serviceReminderId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumAutomationRunStatusFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum AutomationStatus {
  Cancelled = 'Cancelled',
  ClientVisitAlreadyInitiated = 'ClientVisitAlreadyInitiated',
  Completed = 'Completed',
  Expired = 'Expired',
  Paused = 'Paused',
  Queued = 'Queued',
  Started = 'Started'
}

export enum AxionAction {
  Hangup = 'hangup'
}

export type AxionCall = {
  __typename?: 'AxionCall';
  call_id: Scalars['String'];
  channel: Scalars['String'];
  direction: AxionCallDirection;
  domain: Scalars['String'];
  dst: Scalars['String'];
  sip_call_id: Scalars['String'];
  src: Scalars['String'];
  timestamp: Scalars['String'];
};

export enum AxionCallDirection {
  Inbound = 'Inbound',
  Outbound = 'Outbound'
}

export type AxionCallOutput = {
  __typename?: 'AxionCallOutput';
  result: Scalars['String'];
};

export type AxionClinicConfiguration = {
  __typename?: 'AxionClinicConfiguration';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  domain: Scalars['String'];
  id: Scalars['String'];
  status: AxionClinicConfigurationStatus;
  updatedAt: Scalars['DateTime'];
};

export type AxionClinicConfigurationCountAggregateOutputType = {
  __typename?: 'AxionClinicConfigurationCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  domain: Scalars['Int'];
  id: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type AxionClinicConfigurationCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  domain?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AxionClinicConfigurationCreateInput = {
  clinic: ClinicCreateNestedOneWithoutAxionClinicConfigurationInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  domain: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  domain: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<AxionClinicConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<AxionClinicConfigurationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<AxionClinicConfigurationCreateWithoutClinicInput>;
};

export type AxionClinicConfigurationCreateOrConnectWithoutClinicInput = {
  create: AxionClinicConfigurationCreateWithoutClinicInput;
  where: AxionClinicConfigurationWhereUniqueInput;
};

export type AxionClinicConfigurationCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  domain: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationGroupByOutputType = {
  __typename?: 'AxionClinicConfigurationGroupByOutputType';
  _count?: Maybe<AxionClinicConfigurationCountAggregateOutputType>;
  _max?: Maybe<AxionClinicConfigurationMaxAggregateOutputType>;
  _min?: Maybe<AxionClinicConfigurationMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  domain: Scalars['String'];
  id: Scalars['String'];
  status: AxionClinicConfigurationStatus;
  updatedAt: Scalars['DateTime'];
};

export type AxionClinicConfigurationMaxAggregateOutputType = {
  __typename?: 'AxionClinicConfigurationMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  domain?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AxionClinicConfigurationMinAggregateOutputType = {
  __typename?: 'AxionClinicConfigurationMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  domain?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AxionClinicConfigurationNullableScalarRelationFilter = {
  AND?: Maybe<Array<AxionClinicConfigurationWhereInput>>;
  NOT?: Maybe<Array<AxionClinicConfigurationWhereInput>>;
  OR?: Maybe<Array<AxionClinicConfigurationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  domain?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumAxionClinicConfigurationStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AxionClinicConfigurationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AxionClinicConfigurationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  domain?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum AxionClinicConfigurationOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Domain = 'domain',
  Id = 'id'
}

export type AxionClinicConfigurationOrderByRelevanceInput = {
  fields: Array<AxionClinicConfigurationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type AxionClinicConfigurationOrderByWithAggregationInput = {
  _count?: Maybe<AxionClinicConfigurationCountOrderByAggregateInput>;
  _max?: Maybe<AxionClinicConfigurationMaxOrderByAggregateInput>;
  _min?: Maybe<AxionClinicConfigurationMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  domain?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AxionClinicConfigurationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AxionClinicConfigurationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  domain?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type AxionClinicConfigurationOrderByWithRelationInput = {
  _relevance?: Maybe<AxionClinicConfigurationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  domain?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum AxionClinicConfigurationScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Domain = 'domain',
  Id = 'id',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type AxionClinicConfigurationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<AxionClinicConfigurationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<AxionClinicConfigurationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<AxionClinicConfigurationScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  domain?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumAxionClinicConfigurationStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum AxionClinicConfigurationStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  Paused = 'Paused'
}

export type AxionClinicConfigurationUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  domain: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<AxionClinicConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<AxionClinicConfigurationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<AxionClinicConfigurationCreateWithoutClinicInput>;
};

export type AxionClinicConfigurationUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  domain: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<AxionClinicConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<AxionClinicConfigurationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<AxionClinicConfigurationCreateWithoutClinicInput>;
  delete?: Maybe<AxionClinicConfigurationWhereInput>;
  disconnect?: Maybe<AxionClinicConfigurationWhereInput>;
  update?: Maybe<AxionClinicConfigurationUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<AxionClinicConfigurationUpsertWithoutClinicInput>;
};

export type AxionClinicConfigurationUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAxionClinicConfigurationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<AxionClinicConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<AxionClinicConfigurationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<AxionClinicConfigurationCreateWithoutClinicInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<AxionClinicConfigurationUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<AxionClinicConfigurationUpsertWithoutClinicInput>;
};

export type AxionClinicConfigurationUpdateToOneWithWhereWithoutClinicInput = {
  data: AxionClinicConfigurationUpdateWithoutClinicInput;
  where?: Maybe<AxionClinicConfigurationWhereInput>;
};

export type AxionClinicConfigurationUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<AxionClinicConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicConfigurationUpsertWithoutClinicInput = {
  create: AxionClinicConfigurationCreateWithoutClinicInput;
  update: AxionClinicConfigurationUpdateWithoutClinicInput;
  where?: Maybe<AxionClinicConfigurationWhereInput>;
};

export type AxionClinicConfigurationWhereInput = {
  AND?: Maybe<Array<AxionClinicConfigurationWhereInput>>;
  NOT?: Maybe<Array<AxionClinicConfigurationWhereInput>>;
  OR?: Maybe<Array<AxionClinicConfigurationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  domain?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumAxionClinicConfigurationStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AxionClinicConfigurationWhereUniqueInput = {
  AND?: Maybe<Array<AxionClinicConfigurationWhereInput>>;
  NOT?: Maybe<Array<AxionClinicConfigurationWhereInput>>;
  OR?: Maybe<Array<AxionClinicConfigurationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  domain?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<EnumAxionClinicConfigurationStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type AxionClinicUserConfiguration = {
  __typename?: 'AxionClinicUserConfiguration';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  extension: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type AxionClinicUserConfigurationClinicIdUserIdExtensionCompoundUniqueInput = {
  clinicId: Scalars['String'];
  extension: Scalars['String'];
  userId: Scalars['String'];
};

export type AxionClinicUserConfigurationCountAggregateOutputType = {
  __typename?: 'AxionClinicUserConfigurationCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  extension: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type AxionClinicUserConfigurationCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type AxionClinicUserConfigurationCreateInput = {
  clinic: ClinicCreateNestedOneWithoutAxionClinicUserConfigurationsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAxionClinicUserConfigurationsInput;
};

export type AxionClinicUserConfigurationCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  extension: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type AxionClinicUserConfigurationCreateManyClinicInputEnvelope = {
  data: Array<AxionClinicUserConfigurationCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AxionClinicUserConfigurationCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  extension: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type AxionClinicUserConfigurationCreateManyUserInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  extension: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicUserConfigurationCreateManyUserInputEnvelope = {
  data: Array<AxionClinicUserConfigurationCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AxionClinicUserConfigurationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AxionClinicUserConfigurationCreateWithoutClinicInput>>;
  createMany?: Maybe<AxionClinicUserConfigurationCreateManyClinicInputEnvelope>;
};

export type AxionClinicUserConfigurationCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AxionClinicUserConfigurationCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<AxionClinicUserConfigurationCreateWithoutUserInput>>;
  createMany?: Maybe<AxionClinicUserConfigurationCreateManyUserInputEnvelope>;
};

export type AxionClinicUserConfigurationCreateOrConnectWithoutClinicInput = {
  create: AxionClinicUserConfigurationCreateWithoutClinicInput;
  where: AxionClinicUserConfigurationWhereUniqueInput;
};

export type AxionClinicUserConfigurationCreateOrConnectWithoutUserInput = {
  create: AxionClinicUserConfigurationCreateWithoutUserInput;
  where: AxionClinicUserConfigurationWhereUniqueInput;
};

export type AxionClinicUserConfigurationCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  extension: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAxionClinicUserConfigurationsInput;
};

export type AxionClinicUserConfigurationCreateWithoutUserInput = {
  clinic: ClinicCreateNestedOneWithoutAxionClinicUserConfigurationsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicUserConfigurationGroupByOutputType = {
  __typename?: 'AxionClinicUserConfigurationGroupByOutputType';
  _count?: Maybe<AxionClinicUserConfigurationCountAggregateOutputType>;
  _max?: Maybe<AxionClinicUserConfigurationMaxAggregateOutputType>;
  _min?: Maybe<AxionClinicUserConfigurationMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  extension: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type AxionClinicUserConfigurationListRelationFilter = {
  every?: Maybe<AxionClinicUserConfigurationWhereInput>;
  none?: Maybe<AxionClinicUserConfigurationWhereInput>;
  some?: Maybe<AxionClinicUserConfigurationWhereInput>;
};

export type AxionClinicUserConfigurationMaxAggregateOutputType = {
  __typename?: 'AxionClinicUserConfigurationMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type AxionClinicUserConfigurationMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type AxionClinicUserConfigurationMinAggregateOutputType = {
  __typename?: 'AxionClinicUserConfigurationMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type AxionClinicUserConfigurationMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type AxionClinicUserConfigurationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type AxionClinicUserConfigurationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AxionClinicUserConfigurationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum AxionClinicUserConfigurationOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Extension = 'extension',
  Id = 'id',
  UserId = 'userId'
}

export type AxionClinicUserConfigurationOrderByRelevanceInput = {
  fields: Array<AxionClinicUserConfigurationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type AxionClinicUserConfigurationOrderByWithAggregationInput = {
  _count?: Maybe<AxionClinicUserConfigurationCountOrderByAggregateInput>;
  _max?: Maybe<AxionClinicUserConfigurationMaxOrderByAggregateInput>;
  _min?: Maybe<AxionClinicUserConfigurationMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type AxionClinicUserConfigurationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<AxionClinicUserConfigurationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type AxionClinicUserConfigurationOrderByWithRelationInput = {
  _relevance?: Maybe<AxionClinicUserConfigurationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum AxionClinicUserConfigurationScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Extension = 'extension',
  Id = 'id',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type AxionClinicUserConfigurationScalarWhereInput = {
  AND?: Maybe<Array<AxionClinicUserConfigurationScalarWhereInput>>;
  NOT?: Maybe<Array<AxionClinicUserConfigurationScalarWhereInput>>;
  OR?: Maybe<Array<AxionClinicUserConfigurationScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  extension?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userId?: Maybe<StringFilter>;
};

export type AxionClinicUserConfigurationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<AxionClinicUserConfigurationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<AxionClinicUserConfigurationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<AxionClinicUserConfigurationScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  extension?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userId?: Maybe<StringWithAggregatesFilter>;
};

export type AxionClinicUserConfigurationUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  extension: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AxionClinicUserConfigurationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AxionClinicUserConfigurationCreateWithoutClinicInput>>;
  createMany?: Maybe<AxionClinicUserConfigurationCreateManyClinicInputEnvelope>;
};

export type AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AxionClinicUserConfigurationCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<AxionClinicUserConfigurationCreateWithoutUserInput>>;
  createMany?: Maybe<AxionClinicUserConfigurationCreateManyUserInputEnvelope>;
};

export type AxionClinicUserConfigurationUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  extension: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type AxionClinicUserConfigurationUncheckedCreateWithoutUserInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  extension: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicUserConfigurationUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type AxionClinicUserConfigurationUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AxionClinicUserConfigurationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AxionClinicUserConfigurationCreateWithoutClinicInput>>;
  createMany?: Maybe<AxionClinicUserConfigurationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AxionClinicUserConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<AxionClinicUserConfigurationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<AxionClinicUserConfigurationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<AxionClinicUserConfigurationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AxionClinicUserConfigurationCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<AxionClinicUserConfigurationCreateWithoutUserInput>>;
  createMany?: Maybe<AxionClinicUserConfigurationCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AxionClinicUserConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<AxionClinicUserConfigurationUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<AxionClinicUserConfigurationUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<AxionClinicUserConfigurationUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AxionClinicUserConfigurationUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type AxionClinicUserConfigurationUncheckedUpdateWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicUserConfigurationUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAxionClinicUserConfigurationsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneRequiredWithoutAxionClinicUserConfigurationsNestedInput>;
};

export type AxionClinicUserConfigurationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicUserConfigurationUpdateManyWithWhereWithoutClinicInput = {
  data: AxionClinicUserConfigurationUpdateManyMutationInput;
  where: AxionClinicUserConfigurationScalarWhereInput;
};

export type AxionClinicUserConfigurationUpdateManyWithWhereWithoutUserInput = {
  data: AxionClinicUserConfigurationUpdateManyMutationInput;
  where: AxionClinicUserConfigurationScalarWhereInput;
};

export type AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AxionClinicUserConfigurationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<AxionClinicUserConfigurationCreateWithoutClinicInput>>;
  createMany?: Maybe<AxionClinicUserConfigurationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AxionClinicUserConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<AxionClinicUserConfigurationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<AxionClinicUserConfigurationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<AxionClinicUserConfigurationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AxionClinicUserConfigurationCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<AxionClinicUserConfigurationCreateWithoutUserInput>>;
  createMany?: Maybe<AxionClinicUserConfigurationCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AxionClinicUserConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<AxionClinicUserConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<AxionClinicUserConfigurationUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<AxionClinicUserConfigurationUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<AxionClinicUserConfigurationUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AxionClinicUserConfigurationUpdateWithWhereUniqueWithoutClinicInput = {
  data: AxionClinicUserConfigurationUpdateWithoutClinicInput;
  where: AxionClinicUserConfigurationWhereUniqueInput;
};

export type AxionClinicUserConfigurationUpdateWithWhereUniqueWithoutUserInput = {
  data: AxionClinicUserConfigurationUpdateWithoutUserInput;
  where: AxionClinicUserConfigurationWhereUniqueInput;
};

export type AxionClinicUserConfigurationUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneRequiredWithoutAxionClinicUserConfigurationsNestedInput>;
};

export type AxionClinicUserConfigurationUpdateWithoutUserInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutAxionClinicUserConfigurationsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AxionClinicUserConfigurationUpsertWithWhereUniqueWithoutClinicInput = {
  create: AxionClinicUserConfigurationCreateWithoutClinicInput;
  update: AxionClinicUserConfigurationUpdateWithoutClinicInput;
  where: AxionClinicUserConfigurationWhereUniqueInput;
};

export type AxionClinicUserConfigurationUpsertWithWhereUniqueWithoutUserInput = {
  create: AxionClinicUserConfigurationCreateWithoutUserInput;
  update: AxionClinicUserConfigurationUpdateWithoutUserInput;
  where: AxionClinicUserConfigurationWhereUniqueInput;
};

export type AxionClinicUserConfigurationWhereInput = {
  AND?: Maybe<Array<AxionClinicUserConfigurationWhereInput>>;
  NOT?: Maybe<Array<AxionClinicUserConfigurationWhereInput>>;
  OR?: Maybe<Array<AxionClinicUserConfigurationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  extension?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type AxionClinicUserConfigurationWhereUniqueInput = {
  AND?: Maybe<Array<AxionClinicUserConfigurationWhereInput>>;
  NOT?: Maybe<Array<AxionClinicUserConfigurationWhereInput>>;
  OR?: Maybe<Array<AxionClinicUserConfigurationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicId_userId_extension?: Maybe<AxionClinicUserConfigurationClinicIdUserIdExtensionCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  extension?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type AxionDomain = {
  __typename?: 'AxionDomain';
  domain: Scalars['String'];
  webhook: Scalars['String'];
};

export type AxionGetCallsOutput = {
  __typename?: 'AxionGetCallsOutput';
  calls: Array<AxionCall>;
};

export type AxionGetDomainsOutput = {
  __typename?: 'AxionGetDomainsOutput';
  domains: Array<AxionDomain>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  count: Scalars['Int'];
};

export type BedrockInference = {
  __typename?: 'BedrockInference';
  _count: BedrockInferenceCountOutputType;
  breeds: Array<Breed>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  input: Scalars['String'];
  result: Scalars['String'];
  taxonomy?: Maybe<Taxonomy>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type BedrockInferenceBreedsArgs = {
  cursor?: Maybe<BreedWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BreedScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BreedOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BreedWhereInput>;
};


export type BedrockInferenceTaxonomyArgs = {
  where?: Maybe<TaxonomyWhereInput>;
};

export type BedrockInferenceCountAggregateOutputType = {
  __typename?: 'BedrockInferenceCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  input: Scalars['Int'];
  result: Scalars['Int'];
  taxonomyId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type BedrockInferenceCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  input?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BedrockInferenceCountOutputType = {
  __typename?: 'BedrockInferenceCountOutputType';
  breeds: Scalars['Int'];
};

export type BedrockInferenceCreateInput = {
  breeds?: Maybe<BreedCreateNestedManyWithoutBedrockInferenceInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input: Scalars['String'];
  result: Scalars['String'];
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutBedrockInferencesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input: Scalars['String'];
  result: Scalars['String'];
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceCreateManyTaxonomyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input: Scalars['String'];
  result: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceCreateManyTaxonomyInputEnvelope = {
  data: Array<BedrockInferenceCreateManyTaxonomyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BedrockInferenceCreateNestedManyWithoutTaxonomyInput = {
  connect?: Maybe<Array<BedrockInferenceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BedrockInferenceCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<BedrockInferenceCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<BedrockInferenceCreateManyTaxonomyInputEnvelope>;
};

export type BedrockInferenceCreateNestedOneWithoutBreedsInput = {
  connect?: Maybe<BedrockInferenceWhereUniqueInput>;
  connectOrCreate?: Maybe<BedrockInferenceCreateOrConnectWithoutBreedsInput>;
  create?: Maybe<BedrockInferenceCreateWithoutBreedsInput>;
};

export type BedrockInferenceCreateOrConnectWithoutBreedsInput = {
  create: BedrockInferenceCreateWithoutBreedsInput;
  where: BedrockInferenceWhereUniqueInput;
};

export type BedrockInferenceCreateOrConnectWithoutTaxonomyInput = {
  create: BedrockInferenceCreateWithoutTaxonomyInput;
  where: BedrockInferenceWhereUniqueInput;
};

export type BedrockInferenceCreateWithoutBreedsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input: Scalars['String'];
  result: Scalars['String'];
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutBedrockInferencesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceCreateWithoutTaxonomyInput = {
  breeds?: Maybe<BreedCreateNestedManyWithoutBedrockInferenceInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input: Scalars['String'];
  result: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceGroupByOutputType = {
  __typename?: 'BedrockInferenceGroupByOutputType';
  _count?: Maybe<BedrockInferenceCountAggregateOutputType>;
  _max?: Maybe<BedrockInferenceMaxAggregateOutputType>;
  _min?: Maybe<BedrockInferenceMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  input: Scalars['String'];
  result: Scalars['String'];
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type BedrockInferenceListRelationFilter = {
  every?: Maybe<BedrockInferenceWhereInput>;
  none?: Maybe<BedrockInferenceWhereInput>;
  some?: Maybe<BedrockInferenceWhereInput>;
};

export type BedrockInferenceMaxAggregateOutputType = {
  __typename?: 'BedrockInferenceMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  input?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BedrockInferenceMinAggregateOutputType = {
  __typename?: 'BedrockInferenceMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  input?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BedrockInferenceNullableScalarRelationFilter = {
  AND?: Maybe<Array<BedrockInferenceWhereInput>>;
  NOT?: Maybe<Array<BedrockInferenceWhereInput>>;
  OR?: Maybe<Array<BedrockInferenceWhereInput>>;
  breeds?: Maybe<BreedListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  input?: Maybe<StringFilter>;
  result?: Maybe<StringFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BedrockInferenceOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BedrockInferenceOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BedrockInferenceOrderByRelevanceInput>;
  breeds?: Maybe<BreedOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  input?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BedrockInferenceOrderByRelevanceFieldEnum {
  Id = 'id',
  Input = 'input',
  Result = 'result',
  TaxonomyId = 'taxonomyId'
}

export type BedrockInferenceOrderByRelevanceInput = {
  fields: Array<BedrockInferenceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type BedrockInferenceOrderByWithAggregationInput = {
  _count?: Maybe<BedrockInferenceCountOrderByAggregateInput>;
  _max?: Maybe<BedrockInferenceMaxOrderByAggregateInput>;
  _min?: Maybe<BedrockInferenceMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  input?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BedrockInferenceOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BedrockInferenceOrderByRelevanceInput>;
  breeds?: Maybe<BreedOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  input?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BedrockInferenceOrderByWithRelationInput = {
  _relevance?: Maybe<BedrockInferenceOrderByRelevanceInput>;
  breeds?: Maybe<BreedOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  input?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BedrockInferenceScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Input = 'input',
  Result = 'result',
  TaxonomyId = 'taxonomyId',
  UpdatedAt = 'updatedAt'
}

export type BedrockInferenceScalarWhereInput = {
  AND?: Maybe<Array<BedrockInferenceScalarWhereInput>>;
  NOT?: Maybe<Array<BedrockInferenceScalarWhereInput>>;
  OR?: Maybe<Array<BedrockInferenceScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  input?: Maybe<StringFilter>;
  result?: Maybe<StringFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BedrockInferenceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BedrockInferenceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<BedrockInferenceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BedrockInferenceScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  input?: Maybe<StringWithAggregatesFilter>;
  result?: Maybe<StringWithAggregatesFilter>;
  taxonomyId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type BedrockInferenceUncheckedCreateInput = {
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutBedrockInferenceInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input: Scalars['String'];
  result: Scalars['String'];
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceUncheckedCreateNestedManyWithoutTaxonomyInput = {
  connect?: Maybe<Array<BedrockInferenceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BedrockInferenceCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<BedrockInferenceCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<BedrockInferenceCreateManyTaxonomyInputEnvelope>;
};

export type BedrockInferenceUncheckedCreateWithoutBreedsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input: Scalars['String'];
  result: Scalars['String'];
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceUncheckedCreateWithoutTaxonomyInput = {
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutBedrockInferenceInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input: Scalars['String'];
  result: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceUncheckedUpdateInput = {
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutBedrockInferenceNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceUncheckedUpdateManyWithoutTaxonomyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceUncheckedUpdateManyWithoutTaxonomyNestedInput = {
  connect?: Maybe<Array<BedrockInferenceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BedrockInferenceCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<BedrockInferenceCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<BedrockInferenceCreateManyTaxonomyInputEnvelope>;
  delete?: Maybe<Array<BedrockInferenceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BedrockInferenceScalarWhereInput>>;
  disconnect?: Maybe<Array<BedrockInferenceWhereUniqueInput>>;
  set?: Maybe<Array<BedrockInferenceWhereUniqueInput>>;
  update?: Maybe<Array<BedrockInferenceUpdateWithWhereUniqueWithoutTaxonomyInput>>;
  updateMany?: Maybe<Array<BedrockInferenceUpdateManyWithWhereWithoutTaxonomyInput>>;
  upsert?: Maybe<Array<BedrockInferenceUpsertWithWhereUniqueWithoutTaxonomyInput>>;
};

export type BedrockInferenceUncheckedUpdateWithoutBreedsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceUncheckedUpdateWithoutTaxonomyInput = {
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutBedrockInferenceNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceUpdateInput = {
  breeds?: Maybe<BreedUpdateManyWithoutBedrockInferenceNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutBedrockInferencesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceUpdateManyWithWhereWithoutTaxonomyInput = {
  data: BedrockInferenceUpdateManyMutationInput;
  where: BedrockInferenceScalarWhereInput;
};

export type BedrockInferenceUpdateManyWithoutTaxonomyNestedInput = {
  connect?: Maybe<Array<BedrockInferenceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BedrockInferenceCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<BedrockInferenceCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<BedrockInferenceCreateManyTaxonomyInputEnvelope>;
  delete?: Maybe<Array<BedrockInferenceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BedrockInferenceScalarWhereInput>>;
  disconnect?: Maybe<Array<BedrockInferenceWhereUniqueInput>>;
  set?: Maybe<Array<BedrockInferenceWhereUniqueInput>>;
  update?: Maybe<Array<BedrockInferenceUpdateWithWhereUniqueWithoutTaxonomyInput>>;
  updateMany?: Maybe<Array<BedrockInferenceUpdateManyWithWhereWithoutTaxonomyInput>>;
  upsert?: Maybe<Array<BedrockInferenceUpsertWithWhereUniqueWithoutTaxonomyInput>>;
};

export type BedrockInferenceUpdateOneWithoutBreedsNestedInput = {
  connect?: Maybe<BedrockInferenceWhereUniqueInput>;
  connectOrCreate?: Maybe<BedrockInferenceCreateOrConnectWithoutBreedsInput>;
  create?: Maybe<BedrockInferenceCreateWithoutBreedsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<BedrockInferenceUpdateToOneWithWhereWithoutBreedsInput>;
  upsert?: Maybe<BedrockInferenceUpsertWithoutBreedsInput>;
};

export type BedrockInferenceUpdateToOneWithWhereWithoutBreedsInput = {
  data: BedrockInferenceUpdateWithoutBreedsInput;
  where?: Maybe<BedrockInferenceWhereInput>;
};

export type BedrockInferenceUpdateWithWhereUniqueWithoutTaxonomyInput = {
  data: BedrockInferenceUpdateWithoutTaxonomyInput;
  where: BedrockInferenceWhereUniqueInput;
};

export type BedrockInferenceUpdateWithoutBreedsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutBedrockInferencesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceUpdateWithoutTaxonomyInput = {
  breeds?: Maybe<BreedUpdateManyWithoutBedrockInferenceNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BedrockInferenceUpsertWithWhereUniqueWithoutTaxonomyInput = {
  create: BedrockInferenceCreateWithoutTaxonomyInput;
  update: BedrockInferenceUpdateWithoutTaxonomyInput;
  where: BedrockInferenceWhereUniqueInput;
};

export type BedrockInferenceUpsertWithoutBreedsInput = {
  create: BedrockInferenceCreateWithoutBreedsInput;
  update: BedrockInferenceUpdateWithoutBreedsInput;
  where?: Maybe<BedrockInferenceWhereInput>;
};

export type BedrockInferenceWhereInput = {
  AND?: Maybe<Array<BedrockInferenceWhereInput>>;
  NOT?: Maybe<Array<BedrockInferenceWhereInput>>;
  OR?: Maybe<Array<BedrockInferenceWhereInput>>;
  breeds?: Maybe<BreedListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  input?: Maybe<StringFilter>;
  result?: Maybe<StringFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BedrockInferenceWhereUniqueInput = {
  AND?: Maybe<Array<BedrockInferenceWhereInput>>;
  NOT?: Maybe<Array<BedrockInferenceWhereInput>>;
  OR?: Maybe<Array<BedrockInferenceWhereInput>>;
  breeds?: Maybe<BreedListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  input?: Maybe<StringFilter>;
  result?: Maybe<StringFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BenefitSource = {
  __typename?: 'BenefitSource';
  addonIds: Array<Scalars['String']>;
  planEnrollmentIds: Array<Scalars['String']>;
  planIds: Array<Scalars['String']>;
};

export type BitwerxClientBalance = {
  __typename?: 'BitwerxClientBalance';
  aging30D?: Maybe<Scalars['Float']>;
  aging60D?: Maybe<Scalars['Float']>;
  aging90D?: Maybe<Scalars['Float']>;
  aging120D?: Maybe<Scalars['Float']>;
  agingCurrent?: Maybe<Scalars['Float']>;
  currentBalance?: Maybe<Scalars['Float']>;
};

export type BitwerxHealthcheck = {
  __typename?: 'BitwerxHealthcheck';
  _count: BitwerxHealthcheckCountOutputType;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  paymentHealthcheckRuns: Array<BitwerxPaymentHealthcheckRun>;
  startsAt: Scalars['DateTime'];
  type: BitwerxHealthcheckType;
  updatedAt: Scalars['DateTime'];
};


export type BitwerxHealthcheckPaymentHealthcheckRunsArgs = {
  cursor?: Maybe<BitwerxPaymentHealthcheckRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentHealthcheckRunWhereInput>;
};

export type BitwerxHealthcheckCountAggregateOutputType = {
  __typename?: 'BitwerxHealthcheckCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  endsAt: Scalars['Int'];
  id: Scalars['Int'];
  isEnabled: Scalars['Int'];
  startsAt: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type BitwerxHealthcheckCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxHealthcheckCountOutputType = {
  __typename?: 'BitwerxHealthcheckCountOutputType';
  paymentHealthcheckRuns: Scalars['Int'];
};

export type BitwerxHealthcheckCreateInput = {
  clinic: ClinicCreateNestedOneWithoutBitwerxHealthchecksInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunCreateNestedManyWithoutBitwerxHealthcheckInput>;
  startsAt: Scalars['DateTime'];
  type: BitwerxHealthcheckType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  startsAt: Scalars['DateTime'];
  type: BitwerxHealthcheckType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckCreateManyClinicInputEnvelope = {
  data: Array<BitwerxHealthcheckCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BitwerxHealthcheckCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  startsAt: Scalars['DateTime'];
  type: BitwerxHealthcheckType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<BitwerxHealthcheckWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxHealthcheckCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<BitwerxHealthcheckCreateWithoutClinicInput>>;
  createMany?: Maybe<BitwerxHealthcheckCreateManyClinicInputEnvelope>;
};

export type BitwerxHealthcheckCreateNestedOneWithoutPaymentHealthcheckRunsInput = {
  connect?: Maybe<BitwerxHealthcheckWhereUniqueInput>;
  connectOrCreate?: Maybe<BitwerxHealthcheckCreateOrConnectWithoutPaymentHealthcheckRunsInput>;
  create?: Maybe<BitwerxHealthcheckCreateWithoutPaymentHealthcheckRunsInput>;
};

export type BitwerxHealthcheckCreateOrConnectWithoutClinicInput = {
  create: BitwerxHealthcheckCreateWithoutClinicInput;
  where: BitwerxHealthcheckWhereUniqueInput;
};

export type BitwerxHealthcheckCreateOrConnectWithoutPaymentHealthcheckRunsInput = {
  create: BitwerxHealthcheckCreateWithoutPaymentHealthcheckRunsInput;
  where: BitwerxHealthcheckWhereUniqueInput;
};

export type BitwerxHealthcheckCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunCreateNestedManyWithoutBitwerxHealthcheckInput>;
  startsAt: Scalars['DateTime'];
  type: BitwerxHealthcheckType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckCreateWithoutPaymentHealthcheckRunsInput = {
  clinic: ClinicCreateNestedOneWithoutBitwerxHealthchecksInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  startsAt: Scalars['DateTime'];
  type: BitwerxHealthcheckType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckGroupByOutputType = {
  __typename?: 'BitwerxHealthcheckGroupByOutputType';
  _count?: Maybe<BitwerxHealthcheckCountAggregateOutputType>;
  _max?: Maybe<BitwerxHealthcheckMaxAggregateOutputType>;
  _min?: Maybe<BitwerxHealthcheckMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  startsAt: Scalars['DateTime'];
  type: BitwerxHealthcheckType;
  updatedAt: Scalars['DateTime'];
};

export type BitwerxHealthcheckListRelationFilter = {
  every?: Maybe<BitwerxHealthcheckWhereInput>;
  none?: Maybe<BitwerxHealthcheckWhereInput>;
  some?: Maybe<BitwerxHealthcheckWhereInput>;
};

export type BitwerxHealthcheckMaxAggregateOutputType = {
  __typename?: 'BitwerxHealthcheckMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<BitwerxHealthcheckType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxHealthcheckMinAggregateOutputType = {
  __typename?: 'BitwerxHealthcheckMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<BitwerxHealthcheckType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxHealthcheckOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BitwerxHealthcheckOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BitwerxHealthcheckOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunOrderByRelationAggregateInput>;
  startsAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BitwerxHealthcheckOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id'
}

export type BitwerxHealthcheckOrderByRelevanceInput = {
  fields: Array<BitwerxHealthcheckOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type BitwerxHealthcheckOrderByWithAggregationInput = {
  _count?: Maybe<BitwerxHealthcheckCountOrderByAggregateInput>;
  _max?: Maybe<BitwerxHealthcheckMaxOrderByAggregateInput>;
  _min?: Maybe<BitwerxHealthcheckMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxHealthcheckOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BitwerxHealthcheckOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunOrderByRelationAggregateInput>;
  startsAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxHealthcheckOrderByWithRelationInput = {
  _relevance?: Maybe<BitwerxHealthcheckOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunOrderByRelationAggregateInput>;
  startsAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BitwerxHealthcheckRunStatus {
  Healthy = 'Healthy',
  Mixed = 'Mixed',
  NoResults = 'NoResults',
  Unhealthy = 'Unhealthy'
}

export enum BitwerxHealthcheckScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  EndsAt = 'endsAt',
  Id = 'id',
  IsEnabled = 'isEnabled',
  StartsAt = 'startsAt',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type BitwerxHealthcheckScalarRelationFilter = {
  AND?: Maybe<Array<BitwerxHealthcheckWhereInput>>;
  NOT?: Maybe<Array<BitwerxHealthcheckWhereInput>>;
  OR?: Maybe<Array<BitwerxHealthcheckWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endsAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isEnabled?: Maybe<BoolFilter>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunListRelationFilter>;
  startsAt?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumBitwerxHealthcheckTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BitwerxHealthcheckScalarWhereInput = {
  AND?: Maybe<Array<BitwerxHealthcheckScalarWhereInput>>;
  NOT?: Maybe<Array<BitwerxHealthcheckScalarWhereInput>>;
  OR?: Maybe<Array<BitwerxHealthcheckScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endsAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isEnabled?: Maybe<BoolFilter>;
  startsAt?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumBitwerxHealthcheckTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BitwerxHealthcheckScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BitwerxHealthcheckScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<BitwerxHealthcheckScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BitwerxHealthcheckScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  endsAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isEnabled?: Maybe<BoolWithAggregatesFilter>;
  startsAt?: Maybe<DateTimeWithAggregatesFilter>;
  type?: Maybe<EnumBitwerxHealthcheckTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum BitwerxHealthcheckType {
  Payment = 'Payment'
}

export type BitwerxHealthcheckUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunUncheckedCreateNestedManyWithoutBitwerxHealthcheckInput>;
  startsAt: Scalars['DateTime'];
  type: BitwerxHealthcheckType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<BitwerxHealthcheckWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxHealthcheckCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<BitwerxHealthcheckCreateWithoutClinicInput>>;
  createMany?: Maybe<BitwerxHealthcheckCreateManyClinicInputEnvelope>;
};

export type BitwerxHealthcheckUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunUncheckedCreateNestedManyWithoutBitwerxHealthcheckInput>;
  startsAt: Scalars['DateTime'];
  type: BitwerxHealthcheckType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckUncheckedCreateWithoutPaymentHealthcheckRunsInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  startsAt: Scalars['DateTime'];
  type: BitwerxHealthcheckType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunUncheckedUpdateManyWithoutBitwerxHealthcheckNestedInput>;
  startsAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<BitwerxHealthcheckType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<BitwerxHealthcheckType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<BitwerxHealthcheckType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<BitwerxHealthcheckWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxHealthcheckCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<BitwerxHealthcheckCreateWithoutClinicInput>>;
  createMany?: Maybe<BitwerxHealthcheckCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<BitwerxHealthcheckWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxHealthcheckScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxHealthcheckWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxHealthcheckWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxHealthcheckUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<BitwerxHealthcheckUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<BitwerxHealthcheckUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type BitwerxHealthcheckUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunUncheckedUpdateManyWithoutBitwerxHealthcheckNestedInput>;
  startsAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<BitwerxHealthcheckType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckUncheckedUpdateWithoutPaymentHealthcheckRunsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<BitwerxHealthcheckType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutBitwerxHealthchecksNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunUpdateManyWithoutBitwerxHealthcheckNestedInput>;
  startsAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<BitwerxHealthcheckType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<BitwerxHealthcheckType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckUpdateManyWithWhereWithoutClinicInput = {
  data: BitwerxHealthcheckUpdateManyMutationInput;
  where: BitwerxHealthcheckScalarWhereInput;
};

export type BitwerxHealthcheckUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<BitwerxHealthcheckWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxHealthcheckCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<BitwerxHealthcheckCreateWithoutClinicInput>>;
  createMany?: Maybe<BitwerxHealthcheckCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<BitwerxHealthcheckWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxHealthcheckScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxHealthcheckWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxHealthcheckWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxHealthcheckUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<BitwerxHealthcheckUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<BitwerxHealthcheckUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type BitwerxHealthcheckUpdateOneRequiredWithoutPaymentHealthcheckRunsNestedInput = {
  connect?: Maybe<BitwerxHealthcheckWhereUniqueInput>;
  connectOrCreate?: Maybe<BitwerxHealthcheckCreateOrConnectWithoutPaymentHealthcheckRunsInput>;
  create?: Maybe<BitwerxHealthcheckCreateWithoutPaymentHealthcheckRunsInput>;
  update?: Maybe<BitwerxHealthcheckUpdateToOneWithWhereWithoutPaymentHealthcheckRunsInput>;
  upsert?: Maybe<BitwerxHealthcheckUpsertWithoutPaymentHealthcheckRunsInput>;
};

export type BitwerxHealthcheckUpdateToOneWithWhereWithoutPaymentHealthcheckRunsInput = {
  data: BitwerxHealthcheckUpdateWithoutPaymentHealthcheckRunsInput;
  where?: Maybe<BitwerxHealthcheckWhereInput>;
};

export type BitwerxHealthcheckUpdateWithWhereUniqueWithoutClinicInput = {
  data: BitwerxHealthcheckUpdateWithoutClinicInput;
  where: BitwerxHealthcheckWhereUniqueInput;
};

export type BitwerxHealthcheckUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunUpdateManyWithoutBitwerxHealthcheckNestedInput>;
  startsAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<BitwerxHealthcheckType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckUpdateWithoutPaymentHealthcheckRunsInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutBitwerxHealthchecksNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<BitwerxHealthcheckType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxHealthcheckUpsertWithWhereUniqueWithoutClinicInput = {
  create: BitwerxHealthcheckCreateWithoutClinicInput;
  update: BitwerxHealthcheckUpdateWithoutClinicInput;
  where: BitwerxHealthcheckWhereUniqueInput;
};

export type BitwerxHealthcheckUpsertWithoutPaymentHealthcheckRunsInput = {
  create: BitwerxHealthcheckCreateWithoutPaymentHealthcheckRunsInput;
  update: BitwerxHealthcheckUpdateWithoutPaymentHealthcheckRunsInput;
  where?: Maybe<BitwerxHealthcheckWhereInput>;
};

export type BitwerxHealthcheckWhereInput = {
  AND?: Maybe<Array<BitwerxHealthcheckWhereInput>>;
  NOT?: Maybe<Array<BitwerxHealthcheckWhereInput>>;
  OR?: Maybe<Array<BitwerxHealthcheckWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endsAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isEnabled?: Maybe<BoolFilter>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunListRelationFilter>;
  startsAt?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumBitwerxHealthcheckTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BitwerxHealthcheckWhereUniqueInput = {
  AND?: Maybe<Array<BitwerxHealthcheckWhereInput>>;
  NOT?: Maybe<Array<BitwerxHealthcheckWhereInput>>;
  OR?: Maybe<Array<BitwerxHealthcheckWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endsAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<BoolFilter>;
  paymentHealthcheckRuns?: Maybe<BitwerxPaymentHealthcheckRunListRelationFilter>;
  startsAt?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumBitwerxHealthcheckTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BitwerxIntegration = {
  __typename?: 'BitwerxIntegration';
  clinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isMultiSite: Scalars['Boolean'];
  /** This property is the same as siteId on Vetdata/Datapoint, for multi-location practices */
  locationId?: Maybe<Scalars['String']>;
  practiceId: Scalars['String'];
  system: BitwerxSystem;
  updatedAt: Scalars['DateTime'];
  /** This property references the PIMS PaymentType ID for writebacks */
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};


export type BitwerxIntegrationClinicPimsIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type BitwerxIntegrationCountAggregateOutputType = {
  __typename?: 'BitwerxIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isMultiSite: Scalars['Int'];
  locationId: Scalars['Int'];
  practiceId: Scalars['Int'];
  system: Scalars['Int'];
  updatedAt: Scalars['Int'];
  writebackPaymentTypeId: Scalars['Int'];
};

export type BitwerxIntegrationCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackPaymentTypeId?: Maybe<SortOrder>;
};

export type BitwerxIntegrationCreateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutBitwerxInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId: Scalars['String'];
  system: BitwerxSystem;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId: Scalars['String'];
  system: BitwerxSystem;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<BitwerxIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<BitwerxIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<BitwerxIntegrationCreateWithoutClinicPimsIntegrationInput>;
};

export type BitwerxIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput = {
  create: BitwerxIntegrationCreateWithoutClinicPimsIntegrationInput;
  where: BitwerxIntegrationWhereUniqueInput;
};

export type BitwerxIntegrationCreateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId: Scalars['String'];
  system: BitwerxSystem;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationGroupByOutputType = {
  __typename?: 'BitwerxIntegrationGroupByOutputType';
  _count?: Maybe<BitwerxIntegrationCountAggregateOutputType>;
  _max?: Maybe<BitwerxIntegrationMaxAggregateOutputType>;
  _min?: Maybe<BitwerxIntegrationMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isMultiSite: Scalars['Boolean'];
  locationId?: Maybe<Scalars['String']>;
  practiceId: Scalars['String'];
  system: BitwerxSystem;
  updatedAt: Scalars['DateTime'];
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationMaxAggregateOutputType = {
  __typename?: 'BitwerxIntegrationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  system?: Maybe<BitwerxSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackPaymentTypeId?: Maybe<SortOrder>;
};

export type BitwerxIntegrationMinAggregateOutputType = {
  __typename?: 'BitwerxIntegrationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  system?: Maybe<BitwerxSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackPaymentTypeId?: Maybe<SortOrder>;
};

export type BitwerxIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<BitwerxIntegrationWhereInput>>;
  NOT?: Maybe<Array<BitwerxIntegrationWhereInput>>;
  OR?: Maybe<Array<BitwerxIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isMultiSite?: Maybe<BoolFilter>;
  locationId?: Maybe<StringNullableFilter>;
  practiceId?: Maybe<StringFilter>;
  system?: Maybe<EnumBitwerxSystemFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  writebackPaymentTypeId?: Maybe<StringNullableFilter>;
};

export type BitwerxIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BitwerxIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackPaymentTypeId?: Maybe<SortOrder>;
};

export enum BitwerxIntegrationOrderByRelevanceFieldEnum {
  Id = 'id',
  LocationId = 'locationId',
  PracticeId = 'practiceId',
  WritebackPaymentTypeId = 'writebackPaymentTypeId'
}

export type BitwerxIntegrationOrderByRelevanceInput = {
  fields: Array<BitwerxIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type BitwerxIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<BitwerxIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<BitwerxIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<BitwerxIntegrationMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackPaymentTypeId?: Maybe<SortOrder>;
};

export type BitwerxIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BitwerxIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackPaymentTypeId?: Maybe<SortOrder>;
};

export type BitwerxIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<BitwerxIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackPaymentTypeId?: Maybe<SortOrder>;
};

export enum BitwerxIntegrationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsMultiSite = 'isMultiSite',
  LocationId = 'locationId',
  PracticeId = 'practiceId',
  System = 'system',
  UpdatedAt = 'updatedAt',
  WritebackPaymentTypeId = 'writebackPaymentTypeId'
}

export type BitwerxIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BitwerxIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<BitwerxIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BitwerxIntegrationScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isMultiSite?: Maybe<BoolWithAggregatesFilter>;
  locationId?: Maybe<StringNullableWithAggregatesFilter>;
  practiceId?: Maybe<StringWithAggregatesFilter>;
  system?: Maybe<EnumBitwerxSystemWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  writebackPaymentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type BitwerxIntegrationUncheckedCreateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedOneWithoutBitwerxInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId: Scalars['String'];
  system: BitwerxSystem;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationUncheckedCreateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId: Scalars['String'];
  system: BitwerxSystem;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationUncheckedUpdateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedUpdateOneWithoutBitwerxNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  system?: Maybe<BitwerxSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  system?: Maybe<BitwerxSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationUncheckedUpdateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  system?: Maybe<BitwerxSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationUpdateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutBitwerxNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  system?: Maybe<BitwerxSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  system?: Maybe<BitwerxSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<BitwerxIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<BitwerxIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<BitwerxIntegrationCreateWithoutClinicPimsIntegrationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<BitwerxIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput>;
  upsert?: Maybe<BitwerxIntegrationUpsertWithoutClinicPimsIntegrationInput>;
};

export type BitwerxIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput = {
  data: BitwerxIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<BitwerxIntegrationWhereInput>;
};

export type BitwerxIntegrationUpdateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  system?: Maybe<BitwerxSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type BitwerxIntegrationUpsertWithoutClinicPimsIntegrationInput = {
  create: BitwerxIntegrationCreateWithoutClinicPimsIntegrationInput;
  update: BitwerxIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<BitwerxIntegrationWhereInput>;
};

export type BitwerxIntegrationWhereInput = {
  AND?: Maybe<Array<BitwerxIntegrationWhereInput>>;
  NOT?: Maybe<Array<BitwerxIntegrationWhereInput>>;
  OR?: Maybe<Array<BitwerxIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isMultiSite?: Maybe<BoolFilter>;
  locationId?: Maybe<StringNullableFilter>;
  practiceId?: Maybe<StringFilter>;
  system?: Maybe<EnumBitwerxSystemFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  writebackPaymentTypeId?: Maybe<StringNullableFilter>;
};

export type BitwerxIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<BitwerxIntegrationWhereInput>>;
  NOT?: Maybe<Array<BitwerxIntegrationWhereInput>>;
  OR?: Maybe<Array<BitwerxIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<BoolFilter>;
  locationId?: Maybe<StringNullableFilter>;
  practiceId?: Maybe<StringFilter>;
  system?: Maybe<EnumBitwerxSystemFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  writebackPaymentTypeId?: Maybe<StringNullableFilter>;
};

export enum BitwerxPaymentEndpoint {
  GetBalanceForClient = 'GetBalanceForClient',
  GetInvoicesForClient = 'GetInvoicesForClient'
}

export type BitwerxPaymentHealthcheckResult = {
  __typename?: 'BitwerxPaymentHealthcheckResult';
  bitwerxPaymentHealthcheckRunId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endpoint: BitwerxPaymentEndpoint;
  error?: Maybe<Scalars['String']>;
  healthcheckRun: BitwerxPaymentHealthcheckRun;
  httpCode?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  responseTime: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type BitwerxPaymentHealthcheckResultAvgAggregateOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckResultAvgAggregateOutputType';
  httpCode?: Maybe<Scalars['Float']>;
  responseTime?: Maybe<Scalars['Float']>;
};

export type BitwerxPaymentHealthcheckResultAvgOrderByAggregateInput = {
  httpCode?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckResultCountAggregateOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckResultCountAggregateOutputType';
  _all: Scalars['Int'];
  bitwerxPaymentHealthcheckRunId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  endpoint: Scalars['Int'];
  error: Scalars['Int'];
  httpCode: Scalars['Int'];
  id: Scalars['Int'];
  responseTime: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type BitwerxPaymentHealthcheckResultCountOrderByAggregateInput = {
  bitwerxPaymentHealthcheckRunId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endpoint?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckResultCreateInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutBitwerxPaymentHealthcheckResultsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint: BitwerxPaymentEndpoint;
  error?: Maybe<Scalars['String']>;
  healthcheckRun: BitwerxPaymentHealthcheckRunCreateNestedOneWithoutHealthcheckResultsInput;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultCreateManyClinicPetParentInput = {
  bitwerxPaymentHealthcheckRunId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint: BitwerxPaymentEndpoint;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultCreateManyClinicPetParentInputEnvelope = {
  data: Array<BitwerxPaymentHealthcheckResultCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentHealthcheckResultCreateManyHealthcheckRunInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint: BitwerxPaymentEndpoint;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultCreateManyHealthcheckRunInputEnvelope = {
  data: Array<BitwerxPaymentHealthcheckResultCreateManyHealthcheckRunInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentHealthcheckResultCreateManyInput = {
  bitwerxPaymentHealthcheckRunId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint: BitwerxPaymentEndpoint;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<BitwerxPaymentHealthcheckResultCreateManyClinicPetParentInputEnvelope>;
};

export type BitwerxPaymentHealthcheckResultCreateNestedManyWithoutHealthcheckRunInput = {
  connect?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateOrConnectWithoutHealthcheckRunInput>>;
  create?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateWithoutHealthcheckRunInput>>;
  createMany?: Maybe<BitwerxPaymentHealthcheckResultCreateManyHealthcheckRunInputEnvelope>;
};

export type BitwerxPaymentHealthcheckResultCreateOrConnectWithoutClinicPetParentInput = {
  create: BitwerxPaymentHealthcheckResultCreateWithoutClinicPetParentInput;
  where: BitwerxPaymentHealthcheckResultWhereUniqueInput;
};

export type BitwerxPaymentHealthcheckResultCreateOrConnectWithoutHealthcheckRunInput = {
  create: BitwerxPaymentHealthcheckResultCreateWithoutHealthcheckRunInput;
  where: BitwerxPaymentHealthcheckResultWhereUniqueInput;
};

export type BitwerxPaymentHealthcheckResultCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint: BitwerxPaymentEndpoint;
  error?: Maybe<Scalars['String']>;
  healthcheckRun: BitwerxPaymentHealthcheckRunCreateNestedOneWithoutHealthcheckResultsInput;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultCreateWithoutHealthcheckRunInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutBitwerxPaymentHealthcheckResultsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint: BitwerxPaymentEndpoint;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultGroupByOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckResultGroupByOutputType';
  _avg?: Maybe<BitwerxPaymentHealthcheckResultAvgAggregateOutputType>;
  _count?: Maybe<BitwerxPaymentHealthcheckResultCountAggregateOutputType>;
  _max?: Maybe<BitwerxPaymentHealthcheckResultMaxAggregateOutputType>;
  _min?: Maybe<BitwerxPaymentHealthcheckResultMinAggregateOutputType>;
  _sum?: Maybe<BitwerxPaymentHealthcheckResultSumAggregateOutputType>;
  bitwerxPaymentHealthcheckRunId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endpoint: BitwerxPaymentEndpoint;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  responseTime: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type BitwerxPaymentHealthcheckResultListRelationFilter = {
  every?: Maybe<BitwerxPaymentHealthcheckResultWhereInput>;
  none?: Maybe<BitwerxPaymentHealthcheckResultWhereInput>;
  some?: Maybe<BitwerxPaymentHealthcheckResultWhereInput>;
};

export type BitwerxPaymentHealthcheckResultMaxAggregateOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckResultMaxAggregateOutputType';
  bitwerxPaymentHealthcheckRunId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint?: Maybe<BitwerxPaymentEndpoint>;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultMaxOrderByAggregateInput = {
  bitwerxPaymentHealthcheckRunId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endpoint?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckResultMinAggregateOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckResultMinAggregateOutputType';
  bitwerxPaymentHealthcheckRunId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint?: Maybe<BitwerxPaymentEndpoint>;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultMinOrderByAggregateInput = {
  bitwerxPaymentHealthcheckRunId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endpoint?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckResultOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckResultOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BitwerxPaymentHealthcheckResultOrderByRelevanceInput>;
  bitwerxPaymentHealthcheckRunId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endpoint?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  healthcheckRun?: Maybe<BitwerxPaymentHealthcheckRunOrderByWithRelationInput>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BitwerxPaymentHealthcheckResultOrderByRelevanceFieldEnum {
  BitwerxPaymentHealthcheckRunId = 'bitwerxPaymentHealthcheckRunId',
  ClinicPetParentId = 'clinicPetParentId',
  Error = 'error',
  Id = 'id'
}

export type BitwerxPaymentHealthcheckResultOrderByRelevanceInput = {
  fields: Array<BitwerxPaymentHealthcheckResultOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type BitwerxPaymentHealthcheckResultOrderByWithAggregationInput = {
  _avg?: Maybe<BitwerxPaymentHealthcheckResultAvgOrderByAggregateInput>;
  _count?: Maybe<BitwerxPaymentHealthcheckResultCountOrderByAggregateInput>;
  _max?: Maybe<BitwerxPaymentHealthcheckResultMaxOrderByAggregateInput>;
  _min?: Maybe<BitwerxPaymentHealthcheckResultMinOrderByAggregateInput>;
  _sum?: Maybe<BitwerxPaymentHealthcheckResultSumOrderByAggregateInput>;
  bitwerxPaymentHealthcheckRunId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endpoint?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckResultOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BitwerxPaymentHealthcheckResultOrderByRelevanceInput>;
  bitwerxPaymentHealthcheckRunId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endpoint?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  healthcheckRun?: Maybe<BitwerxPaymentHealthcheckRunOrderByWithRelationInput>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckResultOrderByWithRelationInput = {
  _relevance?: Maybe<BitwerxPaymentHealthcheckResultOrderByRelevanceInput>;
  bitwerxPaymentHealthcheckRunId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endpoint?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  healthcheckRun?: Maybe<BitwerxPaymentHealthcheckRunOrderByWithRelationInput>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BitwerxPaymentHealthcheckResultScalarFieldEnum {
  BitwerxPaymentHealthcheckRunId = 'bitwerxPaymentHealthcheckRunId',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Endpoint = 'endpoint',
  Error = 'error',
  HttpCode = 'httpCode',
  Id = 'id',
  ResponseTime = 'responseTime',
  UpdatedAt = 'updatedAt'
}

export type BitwerxPaymentHealthcheckResultScalarWhereInput = {
  AND?: Maybe<Array<BitwerxPaymentHealthcheckResultScalarWhereInput>>;
  NOT?: Maybe<Array<BitwerxPaymentHealthcheckResultScalarWhereInput>>;
  OR?: Maybe<Array<BitwerxPaymentHealthcheckResultScalarWhereInput>>;
  bitwerxPaymentHealthcheckRunId?: Maybe<StringFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endpoint?: Maybe<EnumBitwerxPaymentEndpointFilter>;
  error?: Maybe<StringNullableFilter>;
  httpCode?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  responseTime?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BitwerxPaymentHealthcheckResultScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BitwerxPaymentHealthcheckResultScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<BitwerxPaymentHealthcheckResultScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BitwerxPaymentHealthcheckResultScalarWhereWithAggregatesInput>>;
  bitwerxPaymentHealthcheckRunId?: Maybe<StringWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  endpoint?: Maybe<EnumBitwerxPaymentEndpointWithAggregatesFilter>;
  error?: Maybe<StringNullableWithAggregatesFilter>;
  httpCode?: Maybe<IntNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  responseTime?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type BitwerxPaymentHealthcheckResultSumAggregateOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckResultSumAggregateOutputType';
  httpCode?: Maybe<Scalars['Int']>;
  responseTime?: Maybe<Scalars['Int']>;
};

export type BitwerxPaymentHealthcheckResultSumOrderByAggregateInput = {
  httpCode?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckResultUncheckedCreateInput = {
  bitwerxPaymentHealthcheckRunId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint: BitwerxPaymentEndpoint;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<BitwerxPaymentHealthcheckResultCreateManyClinicPetParentInputEnvelope>;
};

export type BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutHealthcheckRunInput = {
  connect?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateOrConnectWithoutHealthcheckRunInput>>;
  create?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateWithoutHealthcheckRunInput>>;
  createMany?: Maybe<BitwerxPaymentHealthcheckResultCreateManyHealthcheckRunInputEnvelope>;
};

export type BitwerxPaymentHealthcheckResultUncheckedCreateWithoutClinicPetParentInput = {
  bitwerxPaymentHealthcheckRunId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint: BitwerxPaymentEndpoint;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUncheckedCreateWithoutHealthcheckRunInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint: BitwerxPaymentEndpoint;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUncheckedUpdateInput = {
  bitwerxPaymentHealthcheckRunId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint?: Maybe<BitwerxPaymentEndpoint>;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUncheckedUpdateManyInput = {
  bitwerxPaymentHealthcheckRunId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint?: Maybe<BitwerxPaymentEndpoint>;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentInput = {
  bitwerxPaymentHealthcheckRunId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint?: Maybe<BitwerxPaymentEndpoint>;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<BitwerxPaymentHealthcheckResultCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentHealthcheckResultScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentHealthcheckResultUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentHealthcheckResultUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<BitwerxPaymentHealthcheckResultUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutHealthcheckRunInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint?: Maybe<BitwerxPaymentEndpoint>;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutHealthcheckRunNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateOrConnectWithoutHealthcheckRunInput>>;
  create?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateWithoutHealthcheckRunInput>>;
  createMany?: Maybe<BitwerxPaymentHealthcheckResultCreateManyHealthcheckRunInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentHealthcheckResultScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentHealthcheckResultUpdateWithWhereUniqueWithoutHealthcheckRunInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentHealthcheckResultUpdateManyWithWhereWithoutHealthcheckRunInput>>;
  upsert?: Maybe<Array<BitwerxPaymentHealthcheckResultUpsertWithWhereUniqueWithoutHealthcheckRunInput>>;
};

export type BitwerxPaymentHealthcheckResultUncheckedUpdateWithoutClinicPetParentInput = {
  bitwerxPaymentHealthcheckRunId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint?: Maybe<BitwerxPaymentEndpoint>;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUncheckedUpdateWithoutHealthcheckRunInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint?: Maybe<BitwerxPaymentEndpoint>;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUpdateInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutBitwerxPaymentHealthcheckResultsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint?: Maybe<BitwerxPaymentEndpoint>;
  error?: Maybe<Scalars['String']>;
  healthcheckRun?: Maybe<BitwerxPaymentHealthcheckRunUpdateOneRequiredWithoutHealthcheckResultsNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint?: Maybe<BitwerxPaymentEndpoint>;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: BitwerxPaymentHealthcheckResultUpdateManyMutationInput;
  where: BitwerxPaymentHealthcheckResultScalarWhereInput;
};

export type BitwerxPaymentHealthcheckResultUpdateManyWithWhereWithoutHealthcheckRunInput = {
  data: BitwerxPaymentHealthcheckResultUpdateManyMutationInput;
  where: BitwerxPaymentHealthcheckResultScalarWhereInput;
};

export type BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<BitwerxPaymentHealthcheckResultCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentHealthcheckResultScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentHealthcheckResultUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentHealthcheckResultUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<BitwerxPaymentHealthcheckResultUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type BitwerxPaymentHealthcheckResultUpdateManyWithoutHealthcheckRunNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateOrConnectWithoutHealthcheckRunInput>>;
  create?: Maybe<Array<BitwerxPaymentHealthcheckResultCreateWithoutHealthcheckRunInput>>;
  createMany?: Maybe<BitwerxPaymentHealthcheckResultCreateManyHealthcheckRunInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentHealthcheckResultScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentHealthcheckResultUpdateWithWhereUniqueWithoutHealthcheckRunInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentHealthcheckResultUpdateManyWithWhereWithoutHealthcheckRunInput>>;
  upsert?: Maybe<Array<BitwerxPaymentHealthcheckResultUpsertWithWhereUniqueWithoutHealthcheckRunInput>>;
};

export type BitwerxPaymentHealthcheckResultUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: BitwerxPaymentHealthcheckResultUpdateWithoutClinicPetParentInput;
  where: BitwerxPaymentHealthcheckResultWhereUniqueInput;
};

export type BitwerxPaymentHealthcheckResultUpdateWithWhereUniqueWithoutHealthcheckRunInput = {
  data: BitwerxPaymentHealthcheckResultUpdateWithoutHealthcheckRunInput;
  where: BitwerxPaymentHealthcheckResultWhereUniqueInput;
};

export type BitwerxPaymentHealthcheckResultUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint?: Maybe<BitwerxPaymentEndpoint>;
  error?: Maybe<Scalars['String']>;
  healthcheckRun?: Maybe<BitwerxPaymentHealthcheckRunUpdateOneRequiredWithoutHealthcheckResultsNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUpdateWithoutHealthcheckRunInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutBitwerxPaymentHealthcheckResultsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endpoint?: Maybe<BitwerxPaymentEndpoint>;
  error?: Maybe<Scalars['String']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckResultUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: BitwerxPaymentHealthcheckResultCreateWithoutClinicPetParentInput;
  update: BitwerxPaymentHealthcheckResultUpdateWithoutClinicPetParentInput;
  where: BitwerxPaymentHealthcheckResultWhereUniqueInput;
};

export type BitwerxPaymentHealthcheckResultUpsertWithWhereUniqueWithoutHealthcheckRunInput = {
  create: BitwerxPaymentHealthcheckResultCreateWithoutHealthcheckRunInput;
  update: BitwerxPaymentHealthcheckResultUpdateWithoutHealthcheckRunInput;
  where: BitwerxPaymentHealthcheckResultWhereUniqueInput;
};

export type BitwerxPaymentHealthcheckResultWhereInput = {
  AND?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereInput>>;
  NOT?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereInput>>;
  OR?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereInput>>;
  bitwerxPaymentHealthcheckRunId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endpoint?: Maybe<EnumBitwerxPaymentEndpointFilter>;
  error?: Maybe<StringNullableFilter>;
  healthcheckRun?: Maybe<BitwerxPaymentHealthcheckRunScalarRelationFilter>;
  httpCode?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  responseTime?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BitwerxPaymentHealthcheckResultWhereUniqueInput = {
  AND?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereInput>>;
  NOT?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereInput>>;
  OR?: Maybe<Array<BitwerxPaymentHealthcheckResultWhereInput>>;
  bitwerxPaymentHealthcheckRunId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endpoint?: Maybe<EnumBitwerxPaymentEndpointFilter>;
  error?: Maybe<StringNullableFilter>;
  healthcheckRun?: Maybe<BitwerxPaymentHealthcheckRunScalarRelationFilter>;
  httpCode?: Maybe<IntNullableFilter>;
  id?: Maybe<Scalars['String']>;
  responseTime?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BitwerxPaymentHealthcheckRun = {
  __typename?: 'BitwerxPaymentHealthcheckRun';
  _count: BitwerxPaymentHealthcheckRunCountOutputType;
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheck: BitwerxHealthcheck;
  bitwerxHealthcheckId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  healthcheckResults: Array<BitwerxPaymentHealthcheckResult>;
  historicWeeksBack: Scalars['Int'];
  id: Scalars['String'];
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};


export type BitwerxPaymentHealthcheckRunHealthcheckResultsArgs = {
  cursor?: Maybe<BitwerxPaymentHealthcheckResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentHealthcheckResultWhereInput>;
};

export type BitwerxPaymentHealthcheckRunAvgAggregateOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckRunAvgAggregateOutputType';
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  historicWeeksBack?: Maybe<Scalars['Float']>;
};

export type BitwerxPaymentHealthcheckRunAvgOrderByAggregateInput = {
  averageRequestCount?: Maybe<SortOrder>;
  averageResponseTime?: Maybe<SortOrder>;
  historicWeeksBack?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckRunCountAggregateOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckRunCountAggregateOutputType';
  _all: Scalars['Int'];
  averageRequestCount: Scalars['Int'];
  averageResponseTime: Scalars['Int'];
  bitwerxHealthcheckId: Scalars['Int'];
  createdAt: Scalars['Int'];
  historicWeeksBack: Scalars['Int'];
  id: Scalars['Int'];
  status: Scalars['Int'];
  triggeredAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type BitwerxPaymentHealthcheckRunCountOrderByAggregateInput = {
  averageRequestCount?: Maybe<SortOrder>;
  averageResponseTime?: Maybe<SortOrder>;
  bitwerxHealthcheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  historicWeeksBack?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckRunCountOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckRunCountOutputType';
  healthcheckResults: Scalars['Int'];
};

export type BitwerxPaymentHealthcheckRunCreateInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheck: BitwerxHealthcheckCreateNestedOneWithoutPaymentHealthcheckRunsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutHealthcheckRunInput>;
  historicWeeksBack: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunCreateManyBitwerxHealthcheckInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  historicWeeksBack: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunCreateManyBitwerxHealthcheckInputEnvelope = {
  data: Array<BitwerxPaymentHealthcheckRunCreateManyBitwerxHealthcheckInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentHealthcheckRunCreateManyInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheckId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  historicWeeksBack: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunCreateNestedManyWithoutBitwerxHealthcheckInput = {
  connect?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentHealthcheckRunCreateOrConnectWithoutBitwerxHealthcheckInput>>;
  create?: Maybe<Array<BitwerxPaymentHealthcheckRunCreateWithoutBitwerxHealthcheckInput>>;
  createMany?: Maybe<BitwerxPaymentHealthcheckRunCreateManyBitwerxHealthcheckInputEnvelope>;
};

export type BitwerxPaymentHealthcheckRunCreateNestedOneWithoutHealthcheckResultsInput = {
  connect?: Maybe<BitwerxPaymentHealthcheckRunWhereUniqueInput>;
  connectOrCreate?: Maybe<BitwerxPaymentHealthcheckRunCreateOrConnectWithoutHealthcheckResultsInput>;
  create?: Maybe<BitwerxPaymentHealthcheckRunCreateWithoutHealthcheckResultsInput>;
};

export type BitwerxPaymentHealthcheckRunCreateOrConnectWithoutBitwerxHealthcheckInput = {
  create: BitwerxPaymentHealthcheckRunCreateWithoutBitwerxHealthcheckInput;
  where: BitwerxPaymentHealthcheckRunWhereUniqueInput;
};

export type BitwerxPaymentHealthcheckRunCreateOrConnectWithoutHealthcheckResultsInput = {
  create: BitwerxPaymentHealthcheckRunCreateWithoutHealthcheckResultsInput;
  where: BitwerxPaymentHealthcheckRunWhereUniqueInput;
};

export type BitwerxPaymentHealthcheckRunCreateWithoutBitwerxHealthcheckInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutHealthcheckRunInput>;
  historicWeeksBack: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunCreateWithoutHealthcheckResultsInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheck: BitwerxHealthcheckCreateNestedOneWithoutPaymentHealthcheckRunsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  historicWeeksBack: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunGroupByOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckRunGroupByOutputType';
  _avg?: Maybe<BitwerxPaymentHealthcheckRunAvgAggregateOutputType>;
  _count?: Maybe<BitwerxPaymentHealthcheckRunCountAggregateOutputType>;
  _max?: Maybe<BitwerxPaymentHealthcheckRunMaxAggregateOutputType>;
  _min?: Maybe<BitwerxPaymentHealthcheckRunMinAggregateOutputType>;
  _sum?: Maybe<BitwerxPaymentHealthcheckRunSumAggregateOutputType>;
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheckId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  historicWeeksBack: Scalars['Int'];
  id: Scalars['String'];
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type BitwerxPaymentHealthcheckRunListRelationFilter = {
  every?: Maybe<BitwerxPaymentHealthcheckRunWhereInput>;
  none?: Maybe<BitwerxPaymentHealthcheckRunWhereInput>;
  some?: Maybe<BitwerxPaymentHealthcheckRunWhereInput>;
};

export type BitwerxPaymentHealthcheckRunMaxAggregateOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckRunMaxAggregateOutputType';
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheckId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  historicWeeksBack?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunMaxOrderByAggregateInput = {
  averageRequestCount?: Maybe<SortOrder>;
  averageResponseTime?: Maybe<SortOrder>;
  bitwerxHealthcheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  historicWeeksBack?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckRunMinAggregateOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckRunMinAggregateOutputType';
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheckId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  historicWeeksBack?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunMinOrderByAggregateInput = {
  averageRequestCount?: Maybe<SortOrder>;
  averageResponseTime?: Maybe<SortOrder>;
  bitwerxHealthcheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  historicWeeksBack?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckRunOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckRunOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BitwerxPaymentHealthcheckRunOrderByRelevanceInput>;
  averageRequestCount?: Maybe<SortOrder>;
  averageResponseTime?: Maybe<SortOrder>;
  bitwerxHealthcheck?: Maybe<BitwerxHealthcheckOrderByWithRelationInput>;
  bitwerxHealthcheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultOrderByRelationAggregateInput>;
  historicWeeksBack?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BitwerxPaymentHealthcheckRunOrderByRelevanceFieldEnum {
  BitwerxHealthcheckId = 'bitwerxHealthcheckId',
  Id = 'id'
}

export type BitwerxPaymentHealthcheckRunOrderByRelevanceInput = {
  fields: Array<BitwerxPaymentHealthcheckRunOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type BitwerxPaymentHealthcheckRunOrderByWithAggregationInput = {
  _avg?: Maybe<BitwerxPaymentHealthcheckRunAvgOrderByAggregateInput>;
  _count?: Maybe<BitwerxPaymentHealthcheckRunCountOrderByAggregateInput>;
  _max?: Maybe<BitwerxPaymentHealthcheckRunMaxOrderByAggregateInput>;
  _min?: Maybe<BitwerxPaymentHealthcheckRunMinOrderByAggregateInput>;
  _sum?: Maybe<BitwerxPaymentHealthcheckRunSumOrderByAggregateInput>;
  averageRequestCount?: Maybe<SortOrder>;
  averageResponseTime?: Maybe<SortOrder>;
  bitwerxHealthcheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  historicWeeksBack?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckRunOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BitwerxPaymentHealthcheckRunOrderByRelevanceInput>;
  averageRequestCount?: Maybe<SortOrder>;
  averageResponseTime?: Maybe<SortOrder>;
  bitwerxHealthcheck?: Maybe<BitwerxHealthcheckOrderByWithRelationInput>;
  bitwerxHealthcheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultOrderByRelationAggregateInput>;
  historicWeeksBack?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckRunOrderByWithRelationInput = {
  _relevance?: Maybe<BitwerxPaymentHealthcheckRunOrderByRelevanceInput>;
  averageRequestCount?: Maybe<SortOrder>;
  averageResponseTime?: Maybe<SortOrder>;
  bitwerxHealthcheck?: Maybe<BitwerxHealthcheckOrderByWithRelationInput>;
  bitwerxHealthcheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultOrderByRelationAggregateInput>;
  historicWeeksBack?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BitwerxPaymentHealthcheckRunScalarFieldEnum {
  AverageRequestCount = 'averageRequestCount',
  AverageResponseTime = 'averageResponseTime',
  BitwerxHealthcheckId = 'bitwerxHealthcheckId',
  CreatedAt = 'createdAt',
  HistoricWeeksBack = 'historicWeeksBack',
  Id = 'id',
  Status = 'status',
  TriggeredAt = 'triggeredAt',
  UpdatedAt = 'updatedAt'
}

export type BitwerxPaymentHealthcheckRunScalarRelationFilter = {
  AND?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereInput>>;
  NOT?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereInput>>;
  OR?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereInput>>;
  averageRequestCount?: Maybe<FloatNullableFilter>;
  averageResponseTime?: Maybe<FloatNullableFilter>;
  bitwerxHealthcheck?: Maybe<BitwerxHealthcheckScalarRelationFilter>;
  bitwerxHealthcheckId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultListRelationFilter>;
  historicWeeksBack?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumBitwerxHealthcheckRunStatusNullableFilter>;
  triggeredAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BitwerxPaymentHealthcheckRunScalarWhereInput = {
  AND?: Maybe<Array<BitwerxPaymentHealthcheckRunScalarWhereInput>>;
  NOT?: Maybe<Array<BitwerxPaymentHealthcheckRunScalarWhereInput>>;
  OR?: Maybe<Array<BitwerxPaymentHealthcheckRunScalarWhereInput>>;
  averageRequestCount?: Maybe<FloatNullableFilter>;
  averageResponseTime?: Maybe<FloatNullableFilter>;
  bitwerxHealthcheckId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  historicWeeksBack?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumBitwerxHealthcheckRunStatusNullableFilter>;
  triggeredAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BitwerxPaymentHealthcheckRunScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BitwerxPaymentHealthcheckRunScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<BitwerxPaymentHealthcheckRunScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BitwerxPaymentHealthcheckRunScalarWhereWithAggregatesInput>>;
  averageRequestCount?: Maybe<FloatNullableWithAggregatesFilter>;
  averageResponseTime?: Maybe<FloatNullableWithAggregatesFilter>;
  bitwerxHealthcheckId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  historicWeeksBack?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumBitwerxHealthcheckRunStatusNullableWithAggregatesFilter>;
  triggeredAt?: Maybe<DateTimeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type BitwerxPaymentHealthcheckRunSumAggregateOutputType = {
  __typename?: 'BitwerxPaymentHealthcheckRunSumAggregateOutputType';
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  historicWeeksBack?: Maybe<Scalars['Int']>;
};

export type BitwerxPaymentHealthcheckRunSumOrderByAggregateInput = {
  averageRequestCount?: Maybe<SortOrder>;
  averageResponseTime?: Maybe<SortOrder>;
  historicWeeksBack?: Maybe<SortOrder>;
};

export type BitwerxPaymentHealthcheckRunUncheckedCreateInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheckId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutHealthcheckRunInput>;
  historicWeeksBack: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunUncheckedCreateNestedManyWithoutBitwerxHealthcheckInput = {
  connect?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentHealthcheckRunCreateOrConnectWithoutBitwerxHealthcheckInput>>;
  create?: Maybe<Array<BitwerxPaymentHealthcheckRunCreateWithoutBitwerxHealthcheckInput>>;
  createMany?: Maybe<BitwerxPaymentHealthcheckRunCreateManyBitwerxHealthcheckInputEnvelope>;
};

export type BitwerxPaymentHealthcheckRunUncheckedCreateWithoutBitwerxHealthcheckInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutHealthcheckRunInput>;
  historicWeeksBack: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunUncheckedCreateWithoutHealthcheckResultsInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheckId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  historicWeeksBack: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunUncheckedUpdateInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheckId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutHealthcheckRunNestedInput>;
  historicWeeksBack?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunUncheckedUpdateManyInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheckId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  historicWeeksBack?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunUncheckedUpdateManyWithoutBitwerxHealthcheckInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  historicWeeksBack?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunUncheckedUpdateManyWithoutBitwerxHealthcheckNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentHealthcheckRunCreateOrConnectWithoutBitwerxHealthcheckInput>>;
  create?: Maybe<Array<BitwerxPaymentHealthcheckRunCreateWithoutBitwerxHealthcheckInput>>;
  createMany?: Maybe<BitwerxPaymentHealthcheckRunCreateManyBitwerxHealthcheckInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentHealthcheckRunScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentHealthcheckRunUpdateWithWhereUniqueWithoutBitwerxHealthcheckInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentHealthcheckRunUpdateManyWithWhereWithoutBitwerxHealthcheckInput>>;
  upsert?: Maybe<Array<BitwerxPaymentHealthcheckRunUpsertWithWhereUniqueWithoutBitwerxHealthcheckInput>>;
};

export type BitwerxPaymentHealthcheckRunUncheckedUpdateWithoutBitwerxHealthcheckInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutHealthcheckRunNestedInput>;
  historicWeeksBack?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunUncheckedUpdateWithoutHealthcheckResultsInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheckId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  historicWeeksBack?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunUpdateInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheck?: Maybe<BitwerxHealthcheckUpdateOneRequiredWithoutPaymentHealthcheckRunsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutHealthcheckRunNestedInput>;
  historicWeeksBack?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunUpdateManyMutationInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  historicWeeksBack?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunUpdateManyWithWhereWithoutBitwerxHealthcheckInput = {
  data: BitwerxPaymentHealthcheckRunUpdateManyMutationInput;
  where: BitwerxPaymentHealthcheckRunScalarWhereInput;
};

export type BitwerxPaymentHealthcheckRunUpdateManyWithoutBitwerxHealthcheckNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentHealthcheckRunCreateOrConnectWithoutBitwerxHealthcheckInput>>;
  create?: Maybe<Array<BitwerxPaymentHealthcheckRunCreateWithoutBitwerxHealthcheckInput>>;
  createMany?: Maybe<BitwerxPaymentHealthcheckRunCreateManyBitwerxHealthcheckInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentHealthcheckRunScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentHealthcheckRunUpdateWithWhereUniqueWithoutBitwerxHealthcheckInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentHealthcheckRunUpdateManyWithWhereWithoutBitwerxHealthcheckInput>>;
  upsert?: Maybe<Array<BitwerxPaymentHealthcheckRunUpsertWithWhereUniqueWithoutBitwerxHealthcheckInput>>;
};

export type BitwerxPaymentHealthcheckRunUpdateOneRequiredWithoutHealthcheckResultsNestedInput = {
  connect?: Maybe<BitwerxPaymentHealthcheckRunWhereUniqueInput>;
  connectOrCreate?: Maybe<BitwerxPaymentHealthcheckRunCreateOrConnectWithoutHealthcheckResultsInput>;
  create?: Maybe<BitwerxPaymentHealthcheckRunCreateWithoutHealthcheckResultsInput>;
  update?: Maybe<BitwerxPaymentHealthcheckRunUpdateToOneWithWhereWithoutHealthcheckResultsInput>;
  upsert?: Maybe<BitwerxPaymentHealthcheckRunUpsertWithoutHealthcheckResultsInput>;
};

export type BitwerxPaymentHealthcheckRunUpdateToOneWithWhereWithoutHealthcheckResultsInput = {
  data: BitwerxPaymentHealthcheckRunUpdateWithoutHealthcheckResultsInput;
  where?: Maybe<BitwerxPaymentHealthcheckRunWhereInput>;
};

export type BitwerxPaymentHealthcheckRunUpdateWithWhereUniqueWithoutBitwerxHealthcheckInput = {
  data: BitwerxPaymentHealthcheckRunUpdateWithoutBitwerxHealthcheckInput;
  where: BitwerxPaymentHealthcheckRunWhereUniqueInput;
};

export type BitwerxPaymentHealthcheckRunUpdateWithoutBitwerxHealthcheckInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutHealthcheckRunNestedInput>;
  historicWeeksBack?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunUpdateWithoutHealthcheckResultsInput = {
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheck?: Maybe<BitwerxHealthcheckUpdateOneRequiredWithoutPaymentHealthcheckRunsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  historicWeeksBack?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BitwerxPaymentHealthcheckRunUpsertWithWhereUniqueWithoutBitwerxHealthcheckInput = {
  create: BitwerxPaymentHealthcheckRunCreateWithoutBitwerxHealthcheckInput;
  update: BitwerxPaymentHealthcheckRunUpdateWithoutBitwerxHealthcheckInput;
  where: BitwerxPaymentHealthcheckRunWhereUniqueInput;
};

export type BitwerxPaymentHealthcheckRunUpsertWithoutHealthcheckResultsInput = {
  create: BitwerxPaymentHealthcheckRunCreateWithoutHealthcheckResultsInput;
  update: BitwerxPaymentHealthcheckRunUpdateWithoutHealthcheckResultsInput;
  where?: Maybe<BitwerxPaymentHealthcheckRunWhereInput>;
};

export type BitwerxPaymentHealthcheckRunWhereInput = {
  AND?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereInput>>;
  NOT?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereInput>>;
  OR?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereInput>>;
  averageRequestCount?: Maybe<FloatNullableFilter>;
  averageResponseTime?: Maybe<FloatNullableFilter>;
  bitwerxHealthcheck?: Maybe<BitwerxHealthcheckScalarRelationFilter>;
  bitwerxHealthcheckId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultListRelationFilter>;
  historicWeeksBack?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumBitwerxHealthcheckRunStatusNullableFilter>;
  triggeredAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BitwerxPaymentHealthcheckRunWhereUniqueInput = {
  AND?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereInput>>;
  NOT?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereInput>>;
  OR?: Maybe<Array<BitwerxPaymentHealthcheckRunWhereInput>>;
  averageRequestCount?: Maybe<FloatNullableFilter>;
  averageResponseTime?: Maybe<FloatNullableFilter>;
  bitwerxHealthcheck?: Maybe<BitwerxHealthcheckScalarRelationFilter>;
  bitwerxHealthcheckId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  healthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultListRelationFilter>;
  historicWeeksBack?: Maybe<IntFilter>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<EnumBitwerxHealthcheckRunStatusNullableFilter>;
  triggeredAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BitwerxPaymentWritebackConfiguration = {
  __typename?: 'BitwerxPaymentWritebackConfiguration';
  amexPimsPaymentType?: Maybe<PimsPaymentType>;
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  /** enablement of retries for balance writebacks */
  balanceRetriesEnabled: Scalars['Boolean'];
  careDiscountPimsPaymentType?: Maybe<PimsPaymentType>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  /** enablement of Care discount writebacks */
  careEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  defaultPimsPaymentType?: Maybe<PimsPaymentType>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentType?: Maybe<PimsPaymentType>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredBy?: Maybe<ClinicEmployee>;
  enteredById?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  /** global enablement of writebacks */
  isEnabled: Scalars['Boolean'];
  mastercardPimsPaymentType?: Maybe<PimsPaymentType>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  /** enablement of payment writebacks */
  paymentsEnabled: Scalars['Boolean'];
  /** enablement of retries */
  retriesEnabled: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  visaPimsPaymentType?: Maybe<PimsPaymentType>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  /** are we writing back payments for amounts that are manually entered (replacing "Add credit to account" input) */
  writebackManualPayment: Scalars['Boolean'];
};


export type BitwerxPaymentWritebackConfigurationAmexPimsPaymentTypeArgs = {
  where?: Maybe<PimsPaymentTypeWhereInput>;
};


export type BitwerxPaymentWritebackConfigurationCareDiscountPimsPaymentTypeArgs = {
  where?: Maybe<PimsPaymentTypeWhereInput>;
};


export type BitwerxPaymentWritebackConfigurationDefaultPimsPaymentTypeArgs = {
  where?: Maybe<PimsPaymentTypeWhereInput>;
};


export type BitwerxPaymentWritebackConfigurationDiscoverPimsPaymentTypeArgs = {
  where?: Maybe<PimsPaymentTypeWhereInput>;
};


export type BitwerxPaymentWritebackConfigurationEnteredByArgs = {
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type BitwerxPaymentWritebackConfigurationMastercardPimsPaymentTypeArgs = {
  where?: Maybe<PimsPaymentTypeWhereInput>;
};


export type BitwerxPaymentWritebackConfigurationVisaPimsPaymentTypeArgs = {
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type BitwerxPaymentWritebackConfigurationCountAggregateOutputType = {
  __typename?: 'BitwerxPaymentWritebackConfigurationCountAggregateOutputType';
  _all: Scalars['Int'];
  amexPimsPaymentTypeId: Scalars['Int'];
  balanceRetriesEnabled: Scalars['Int'];
  careDiscountPimsPaymentTypeId: Scalars['Int'];
  careEnabled: Scalars['Int'];
  createdAt: Scalars['Int'];
  defaultPimsPaymentTypeId: Scalars['Int'];
  discoverPimsPaymentTypeId: Scalars['Int'];
  enteredById: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isEnabled: Scalars['Int'];
  mastercardPimsPaymentTypeId: Scalars['Int'];
  paymentsEnabled: Scalars['Int'];
  retriesEnabled: Scalars['Int'];
  updatedAt: Scalars['Int'];
  visaPimsPaymentTypeId: Scalars['Int'];
  writebackManualPayment: Scalars['Int'];
};

export type BitwerxPaymentWritebackConfigurationCountOrderByAggregateInput = {
  amexPimsPaymentTypeId?: Maybe<SortOrder>;
  balanceRetriesEnabled?: Maybe<SortOrder>;
  careDiscountPimsPaymentTypeId?: Maybe<SortOrder>;
  careEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultPimsPaymentTypeId?: Maybe<SortOrder>;
  discoverPimsPaymentTypeId?: Maybe<SortOrder>;
  enteredById?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  mastercardPimsPaymentTypeId?: Maybe<SortOrder>;
  paymentsEnabled?: Maybe<SortOrder>;
  retriesEnabled?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visaPimsPaymentTypeId?: Maybe<SortOrder>;
  writebackManualPayment?: Maybe<SortOrder>;
};

export type BitwerxPaymentWritebackConfigurationCreateInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyAmexPimsPaymentTypeInput = {
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyAmexPimsPaymentTypeInputEnvelope = {
  data: Array<BitwerxPaymentWritebackConfigurationCreateManyAmexPimsPaymentTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyCareDiscountPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyCareDiscountPimsPaymentTypeInputEnvelope = {
  data: Array<BitwerxPaymentWritebackConfigurationCreateManyCareDiscountPimsPaymentTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyDefaultPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyDefaultPimsPaymentTypeInputEnvelope = {
  data: Array<BitwerxPaymentWritebackConfigurationCreateManyDefaultPimsPaymentTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyDiscoverPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyDiscoverPimsPaymentTypeInputEnvelope = {
  data: Array<BitwerxPaymentWritebackConfigurationCreateManyDiscoverPimsPaymentTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyEnteredByInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyEnteredByInputEnvelope = {
  data: Array<BitwerxPaymentWritebackConfigurationCreateManyEnteredByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyIntegrationInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyIntegrationInputEnvelope = {
  data: Array<BitwerxPaymentWritebackConfigurationCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyMastercardPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyMastercardPimsPaymentTypeInputEnvelope = {
  data: Array<BitwerxPaymentWritebackConfigurationCreateManyMastercardPimsPaymentTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyVisaPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateManyVisaPimsPaymentTypeInputEnvelope = {
  data: Array<BitwerxPaymentWritebackConfigurationCreateManyVisaPimsPaymentTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutAmexPimsPaymentTypeInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutAmexPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutAmexPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyAmexPimsPaymentTypeInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutCareDiscountPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutCareDiscountPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyCareDiscountPimsPaymentTypeInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDefaultPimsPaymentTypeInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutDefaultPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutDefaultPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyDefaultPimsPaymentTypeInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDiscoverPimsPaymentTypeInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutDiscoverPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutDiscoverPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyDiscoverPimsPaymentTypeInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutEnteredByInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutEnteredByInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyEnteredByInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutIntegrationInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyIntegrationInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutMastercardPimsPaymentTypeInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutMastercardPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutMastercardPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyMastercardPimsPaymentTypeInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutVisaPimsPaymentTypeInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutVisaPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutVisaPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyVisaPimsPaymentTypeInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutAmexPimsPaymentTypeInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutAmexPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutCareDiscountPimsPaymentTypeInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutCareDiscountPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutDefaultPimsPaymentTypeInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutDefaultPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutDiscoverPimsPaymentTypeInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutDiscoverPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutEnteredByInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutEnteredByInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutIntegrationInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutIntegrationInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutMastercardPimsPaymentTypeInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutMastercardPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutVisaPimsPaymentTypeInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutVisaPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationCreateWithoutAmexPimsPaymentTypeInput = {
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateWithoutCareDiscountPimsPaymentTypeInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateWithoutDefaultPimsPaymentTypeInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateWithoutDiscoverPimsPaymentTypeInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateWithoutEnteredByInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateWithoutIntegrationInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateWithoutMastercardPimsPaymentTypeInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationCreateWithoutVisaPimsPaymentTypeInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeCreateNestedOneWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationGroupByOutputType = {
  __typename?: 'BitwerxPaymentWritebackConfigurationGroupByOutputType';
  _count?: Maybe<BitwerxPaymentWritebackConfigurationCountAggregateOutputType>;
  _max?: Maybe<BitwerxPaymentWritebackConfigurationMaxAggregateOutputType>;
  _min?: Maybe<BitwerxPaymentWritebackConfigurationMinAggregateOutputType>;
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled: Scalars['Boolean'];
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integrationId: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled: Scalars['Boolean'];
  retriesEnabled: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment: Scalars['Boolean'];
};

export type BitwerxPaymentWritebackConfigurationListRelationFilter = {
  every?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
  none?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
  some?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
};

export type BitwerxPaymentWritebackConfigurationMaxAggregateOutputType = {
  __typename?: 'BitwerxPaymentWritebackConfigurationMaxAggregateOutputType';
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationMaxOrderByAggregateInput = {
  amexPimsPaymentTypeId?: Maybe<SortOrder>;
  balanceRetriesEnabled?: Maybe<SortOrder>;
  careDiscountPimsPaymentTypeId?: Maybe<SortOrder>;
  careEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultPimsPaymentTypeId?: Maybe<SortOrder>;
  discoverPimsPaymentTypeId?: Maybe<SortOrder>;
  enteredById?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  mastercardPimsPaymentTypeId?: Maybe<SortOrder>;
  paymentsEnabled?: Maybe<SortOrder>;
  retriesEnabled?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visaPimsPaymentTypeId?: Maybe<SortOrder>;
  writebackManualPayment?: Maybe<SortOrder>;
};

export type BitwerxPaymentWritebackConfigurationMinAggregateOutputType = {
  __typename?: 'BitwerxPaymentWritebackConfigurationMinAggregateOutputType';
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationMinOrderByAggregateInput = {
  amexPimsPaymentTypeId?: Maybe<SortOrder>;
  balanceRetriesEnabled?: Maybe<SortOrder>;
  careDiscountPimsPaymentTypeId?: Maybe<SortOrder>;
  careEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultPimsPaymentTypeId?: Maybe<SortOrder>;
  discoverPimsPaymentTypeId?: Maybe<SortOrder>;
  enteredById?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  mastercardPimsPaymentTypeId?: Maybe<SortOrder>;
  paymentsEnabled?: Maybe<SortOrder>;
  retriesEnabled?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visaPimsPaymentTypeId?: Maybe<SortOrder>;
  writebackManualPayment?: Maybe<SortOrder>;
};

export type BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BitwerxPaymentWritebackConfigurationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelevanceInput>;
  amexPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  amexPimsPaymentTypeId?: Maybe<SortOrder>;
  balanceRetriesEnabled?: Maybe<SortOrder>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  careDiscountPimsPaymentTypeId?: Maybe<SortOrder>;
  careEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  defaultPimsPaymentTypeId?: Maybe<SortOrder>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  discoverPimsPaymentTypeId?: Maybe<SortOrder>;
  enteredBy?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  enteredById?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  mastercardPimsPaymentTypeId?: Maybe<SortOrder>;
  paymentsEnabled?: Maybe<SortOrder>;
  retriesEnabled?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  visaPimsPaymentTypeId?: Maybe<SortOrder>;
  writebackManualPayment?: Maybe<SortOrder>;
};

export enum BitwerxPaymentWritebackConfigurationOrderByRelevanceFieldEnum {
  AmexPimsPaymentTypeId = 'amexPimsPaymentTypeId',
  CareDiscountPimsPaymentTypeId = 'careDiscountPimsPaymentTypeId',
  DefaultPimsPaymentTypeId = 'defaultPimsPaymentTypeId',
  DiscoverPimsPaymentTypeId = 'discoverPimsPaymentTypeId',
  EnteredById = 'enteredById',
  Id = 'id',
  IntegrationId = 'integrationId',
  MastercardPimsPaymentTypeId = 'mastercardPimsPaymentTypeId',
  VisaPimsPaymentTypeId = 'visaPimsPaymentTypeId'
}

export type BitwerxPaymentWritebackConfigurationOrderByRelevanceInput = {
  fields: Array<BitwerxPaymentWritebackConfigurationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type BitwerxPaymentWritebackConfigurationOrderByWithAggregationInput = {
  _count?: Maybe<BitwerxPaymentWritebackConfigurationCountOrderByAggregateInput>;
  _max?: Maybe<BitwerxPaymentWritebackConfigurationMaxOrderByAggregateInput>;
  _min?: Maybe<BitwerxPaymentWritebackConfigurationMinOrderByAggregateInput>;
  amexPimsPaymentTypeId?: Maybe<SortOrder>;
  balanceRetriesEnabled?: Maybe<SortOrder>;
  careDiscountPimsPaymentTypeId?: Maybe<SortOrder>;
  careEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultPimsPaymentTypeId?: Maybe<SortOrder>;
  discoverPimsPaymentTypeId?: Maybe<SortOrder>;
  enteredById?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  mastercardPimsPaymentTypeId?: Maybe<SortOrder>;
  paymentsEnabled?: Maybe<SortOrder>;
  retriesEnabled?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visaPimsPaymentTypeId?: Maybe<SortOrder>;
  writebackManualPayment?: Maybe<SortOrder>;
};

export type BitwerxPaymentWritebackConfigurationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelevanceInput>;
  amexPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  amexPimsPaymentTypeId?: Maybe<SortOrder>;
  balanceRetriesEnabled?: Maybe<SortOrder>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  careDiscountPimsPaymentTypeId?: Maybe<SortOrder>;
  careEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  defaultPimsPaymentTypeId?: Maybe<SortOrder>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  discoverPimsPaymentTypeId?: Maybe<SortOrder>;
  enteredBy?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  enteredById?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  mastercardPimsPaymentTypeId?: Maybe<SortOrder>;
  paymentsEnabled?: Maybe<SortOrder>;
  retriesEnabled?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  visaPimsPaymentTypeId?: Maybe<SortOrder>;
  writebackManualPayment?: Maybe<SortOrder>;
};

export type BitwerxPaymentWritebackConfigurationOrderByWithRelationInput = {
  _relevance?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelevanceInput>;
  amexPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  amexPimsPaymentTypeId?: Maybe<SortOrder>;
  balanceRetriesEnabled?: Maybe<SortOrder>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  careDiscountPimsPaymentTypeId?: Maybe<SortOrder>;
  careEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  defaultPimsPaymentTypeId?: Maybe<SortOrder>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  discoverPimsPaymentTypeId?: Maybe<SortOrder>;
  enteredBy?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  enteredById?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  mastercardPimsPaymentTypeId?: Maybe<SortOrder>;
  paymentsEnabled?: Maybe<SortOrder>;
  retriesEnabled?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeOrderByWithRelationInput>;
  visaPimsPaymentTypeId?: Maybe<SortOrder>;
  writebackManualPayment?: Maybe<SortOrder>;
};

export enum BitwerxPaymentWritebackConfigurationScalarFieldEnum {
  AmexPimsPaymentTypeId = 'amexPimsPaymentTypeId',
  BalanceRetriesEnabled = 'balanceRetriesEnabled',
  CareDiscountPimsPaymentTypeId = 'careDiscountPimsPaymentTypeId',
  CareEnabled = 'careEnabled',
  CreatedAt = 'createdAt',
  DefaultPimsPaymentTypeId = 'defaultPimsPaymentTypeId',
  DiscoverPimsPaymentTypeId = 'discoverPimsPaymentTypeId',
  EnteredById = 'enteredById',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsEnabled = 'isEnabled',
  MastercardPimsPaymentTypeId = 'mastercardPimsPaymentTypeId',
  PaymentsEnabled = 'paymentsEnabled',
  RetriesEnabled = 'retriesEnabled',
  UpdatedAt = 'updatedAt',
  VisaPimsPaymentTypeId = 'visaPimsPaymentTypeId',
  WritebackManualPayment = 'writebackManualPayment'
}

export type BitwerxPaymentWritebackConfigurationScalarWhereInput = {
  AND?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  NOT?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  OR?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  amexPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  balanceRetriesEnabled?: Maybe<BoolFilter>;
  careDiscountPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  careEnabled?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  discoverPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  enteredById?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  isEnabled?: Maybe<BoolFilter>;
  mastercardPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  paymentsEnabled?: Maybe<BoolFilter>;
  retriesEnabled?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visaPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  writebackManualPayment?: Maybe<BoolFilter>;
};

export type BitwerxPaymentWritebackConfigurationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereWithAggregatesInput>>;
  amexPimsPaymentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  balanceRetriesEnabled?: Maybe<BoolWithAggregatesFilter>;
  careDiscountPimsPaymentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  careEnabled?: Maybe<BoolWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  defaultPimsPaymentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  discoverPimsPaymentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  enteredById?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isEnabled?: Maybe<BoolWithAggregatesFilter>;
  mastercardPimsPaymentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  paymentsEnabled?: Maybe<BoolWithAggregatesFilter>;
  retriesEnabled?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  visaPimsPaymentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  writebackManualPayment?: Maybe<BoolWithAggregatesFilter>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutAmexPimsPaymentTypeInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutAmexPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutAmexPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyAmexPimsPaymentTypeInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutCareDiscountPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutCareDiscountPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyCareDiscountPimsPaymentTypeInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDefaultPimsPaymentTypeInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutDefaultPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutDefaultPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyDefaultPimsPaymentTypeInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDiscoverPimsPaymentTypeInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutDiscoverPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutDiscoverPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyDiscoverPimsPaymentTypeInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutEnteredByInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutEnteredByInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyEnteredByInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutIntegrationInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyIntegrationInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutMastercardPimsPaymentTypeInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutMastercardPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutMastercardPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyMastercardPimsPaymentTypeInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutVisaPimsPaymentTypeInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutVisaPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutVisaPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyVisaPimsPaymentTypeInputEnvelope>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateWithoutAmexPimsPaymentTypeInput = {
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateWithoutCareDiscountPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateWithoutDefaultPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateWithoutDiscoverPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateWithoutEnteredByInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateWithoutIntegrationInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateWithoutMastercardPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedCreateWithoutVisaPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutAmexPimsPaymentTypeInput = {
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutAmexPimsPaymentTypeNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutAmexPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutAmexPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyAmexPimsPaymentTypeInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutAmexPimsPaymentTypeInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutAmexPimsPaymentTypeInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutAmexPimsPaymentTypeInput>>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutCareDiscountPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutCareDiscountPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutCareDiscountPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyCareDiscountPimsPaymentTypeInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutCareDiscountPimsPaymentTypeInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutCareDiscountPimsPaymentTypeInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutCareDiscountPimsPaymentTypeInput>>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDefaultPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDefaultPimsPaymentTypeNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutDefaultPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutDefaultPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyDefaultPimsPaymentTypeInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutDefaultPimsPaymentTypeInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutDefaultPimsPaymentTypeInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutDefaultPimsPaymentTypeInput>>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDiscoverPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutDiscoverPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutDiscoverPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyDiscoverPimsPaymentTypeInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutDiscoverPimsPaymentTypeInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutDiscoverPimsPaymentTypeInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutDiscoverPimsPaymentTypeInput>>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutEnteredByInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutEnteredByInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyEnteredByInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutEnteredByInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutEnteredByInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutEnteredByInput>>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutIntegrationInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutMastercardPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutMastercardPimsPaymentTypeNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutMastercardPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutMastercardPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyMastercardPimsPaymentTypeInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutMastercardPimsPaymentTypeInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutMastercardPimsPaymentTypeInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutMastercardPimsPaymentTypeInput>>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutVisaPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutVisaPimsPaymentTypeNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutVisaPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutVisaPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyVisaPimsPaymentTypeInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutVisaPimsPaymentTypeInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutVisaPimsPaymentTypeInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutVisaPimsPaymentTypeInput>>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateWithoutAmexPimsPaymentTypeInput = {
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateWithoutCareDiscountPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateWithoutDefaultPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateWithoutDiscoverPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateWithoutEnteredByInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateWithoutIntegrationInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateWithoutMastercardPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUncheckedUpdateWithoutVisaPimsPaymentTypeInput = {
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredById?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUpdateInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutAmexBitwerxPaymentWritebackConfigurationsNestedInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsNestedInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDefaultBitwerxPaymentWritebackConfigurationsNestedInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsNestedInput>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutMastercardBitwerxPaymentWritebackConfigurationsNestedInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutVisaBitwerxPaymentWritebackConfigurationsNestedInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyMutationInput = {
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutAmexPimsPaymentTypeInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateManyMutationInput;
  where: BitwerxPaymentWritebackConfigurationScalarWhereInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutCareDiscountPimsPaymentTypeInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateManyMutationInput;
  where: BitwerxPaymentWritebackConfigurationScalarWhereInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutDefaultPimsPaymentTypeInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateManyMutationInput;
  where: BitwerxPaymentWritebackConfigurationScalarWhereInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutDiscoverPimsPaymentTypeInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateManyMutationInput;
  where: BitwerxPaymentWritebackConfigurationScalarWhereInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutEnteredByInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateManyMutationInput;
  where: BitwerxPaymentWritebackConfigurationScalarWhereInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutIntegrationInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateManyMutationInput;
  where: BitwerxPaymentWritebackConfigurationScalarWhereInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutMastercardPimsPaymentTypeInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateManyMutationInput;
  where: BitwerxPaymentWritebackConfigurationScalarWhereInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutVisaPimsPaymentTypeInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateManyMutationInput;
  where: BitwerxPaymentWritebackConfigurationScalarWhereInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithoutAmexPimsPaymentTypeNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutAmexPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutAmexPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyAmexPimsPaymentTypeInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutAmexPimsPaymentTypeInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutAmexPimsPaymentTypeInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutAmexPimsPaymentTypeInput>>;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutCareDiscountPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutCareDiscountPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyCareDiscountPimsPaymentTypeInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutCareDiscountPimsPaymentTypeInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutCareDiscountPimsPaymentTypeInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutCareDiscountPimsPaymentTypeInput>>;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithoutDefaultPimsPaymentTypeNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutDefaultPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutDefaultPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyDefaultPimsPaymentTypeInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutDefaultPimsPaymentTypeInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutDefaultPimsPaymentTypeInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutDefaultPimsPaymentTypeInput>>;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutDiscoverPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutDiscoverPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyDiscoverPimsPaymentTypeInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutDiscoverPimsPaymentTypeInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutDiscoverPimsPaymentTypeInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutDiscoverPimsPaymentTypeInput>>;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutEnteredByInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutEnteredByInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyEnteredByInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutEnteredByInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutEnteredByInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutEnteredByInput>>;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutIntegrationInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithoutMastercardPimsPaymentTypeNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutMastercardPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutMastercardPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyMastercardPimsPaymentTypeInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutMastercardPimsPaymentTypeInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutMastercardPimsPaymentTypeInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutMastercardPimsPaymentTypeInput>>;
};

export type BitwerxPaymentWritebackConfigurationUpdateManyWithoutVisaPimsPaymentTypeNestedInput = {
  connect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateOrConnectWithoutVisaPimsPaymentTypeInput>>;
  create?: Maybe<Array<BitwerxPaymentWritebackConfigurationCreateWithoutVisaPimsPaymentTypeInput>>;
  createMany?: Maybe<BitwerxPaymentWritebackConfigurationCreateManyVisaPimsPaymentTypeInputEnvelope>;
  delete?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutVisaPimsPaymentTypeInput>>;
  updateMany?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpdateManyWithWhereWithoutVisaPimsPaymentTypeInput>>;
  upsert?: Maybe<Array<BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutVisaPimsPaymentTypeInput>>;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutAmexPimsPaymentTypeInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateWithoutAmexPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutCareDiscountPimsPaymentTypeInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateWithoutCareDiscountPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutDefaultPimsPaymentTypeInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateWithoutDefaultPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutDiscoverPimsPaymentTypeInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateWithoutDiscoverPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutEnteredByInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateWithoutEnteredByInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateWithoutIntegrationInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutMastercardPimsPaymentTypeInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateWithoutMastercardPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithWhereUniqueWithoutVisaPimsPaymentTypeInput = {
  data: BitwerxPaymentWritebackConfigurationUpdateWithoutVisaPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithoutAmexPimsPaymentTypeInput = {
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsNestedInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDefaultBitwerxPaymentWritebackConfigurationsNestedInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsNestedInput>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutMastercardBitwerxPaymentWritebackConfigurationsNestedInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutVisaBitwerxPaymentWritebackConfigurationsNestedInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithoutCareDiscountPimsPaymentTypeInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutAmexBitwerxPaymentWritebackConfigurationsNestedInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDefaultBitwerxPaymentWritebackConfigurationsNestedInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsNestedInput>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutMastercardBitwerxPaymentWritebackConfigurationsNestedInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutVisaBitwerxPaymentWritebackConfigurationsNestedInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithoutDefaultPimsPaymentTypeInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutAmexBitwerxPaymentWritebackConfigurationsNestedInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsNestedInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsNestedInput>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutMastercardBitwerxPaymentWritebackConfigurationsNestedInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutVisaBitwerxPaymentWritebackConfigurationsNestedInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithoutDiscoverPimsPaymentTypeInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutAmexBitwerxPaymentWritebackConfigurationsNestedInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsNestedInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDefaultBitwerxPaymentWritebackConfigurationsNestedInput>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutMastercardBitwerxPaymentWritebackConfigurationsNestedInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutVisaBitwerxPaymentWritebackConfigurationsNestedInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithoutEnteredByInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutAmexBitwerxPaymentWritebackConfigurationsNestedInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsNestedInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDefaultBitwerxPaymentWritebackConfigurationsNestedInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutMastercardBitwerxPaymentWritebackConfigurationsNestedInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutVisaBitwerxPaymentWritebackConfigurationsNestedInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithoutIntegrationInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutAmexBitwerxPaymentWritebackConfigurationsNestedInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsNestedInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDefaultBitwerxPaymentWritebackConfigurationsNestedInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsNestedInput>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutMastercardBitwerxPaymentWritebackConfigurationsNestedInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutVisaBitwerxPaymentWritebackConfigurationsNestedInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithoutMastercardPimsPaymentTypeInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutAmexBitwerxPaymentWritebackConfigurationsNestedInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsNestedInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDefaultBitwerxPaymentWritebackConfigurationsNestedInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsNestedInput>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutVisaBitwerxPaymentWritebackConfigurationsNestedInput>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUpdateWithoutVisaPimsPaymentTypeInput = {
  amexPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutAmexBitwerxPaymentWritebackConfigurationsNestedInput>;
  balanceRetriesEnabled?: Maybe<Scalars['Boolean']>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsNestedInput>;
  careEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDefaultBitwerxPaymentWritebackConfigurationsNestedInput>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsNestedInput>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBitwerxPaymentWritebackConfigurationsNestedInput>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeUpdateOneWithoutMastercardBitwerxPaymentWritebackConfigurationsNestedInput>;
  paymentsEnabled?: Maybe<Scalars['Boolean']>;
  retriesEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackManualPayment?: Maybe<Scalars['Boolean']>;
};

export type BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutAmexPimsPaymentTypeInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutAmexPimsPaymentTypeInput;
  update: BitwerxPaymentWritebackConfigurationUpdateWithoutAmexPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutCareDiscountPimsPaymentTypeInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutCareDiscountPimsPaymentTypeInput;
  update: BitwerxPaymentWritebackConfigurationUpdateWithoutCareDiscountPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutDefaultPimsPaymentTypeInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutDefaultPimsPaymentTypeInput;
  update: BitwerxPaymentWritebackConfigurationUpdateWithoutDefaultPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutDiscoverPimsPaymentTypeInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutDiscoverPimsPaymentTypeInput;
  update: BitwerxPaymentWritebackConfigurationUpdateWithoutDiscoverPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutEnteredByInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutEnteredByInput;
  update: BitwerxPaymentWritebackConfigurationUpdateWithoutEnteredByInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutIntegrationInput;
  update: BitwerxPaymentWritebackConfigurationUpdateWithoutIntegrationInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutMastercardPimsPaymentTypeInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutMastercardPimsPaymentTypeInput;
  update: BitwerxPaymentWritebackConfigurationUpdateWithoutMastercardPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationUpsertWithWhereUniqueWithoutVisaPimsPaymentTypeInput = {
  create: BitwerxPaymentWritebackConfigurationCreateWithoutVisaPimsPaymentTypeInput;
  update: BitwerxPaymentWritebackConfigurationUpdateWithoutVisaPimsPaymentTypeInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};

export type BitwerxPaymentWritebackConfigurationWhereInput = {
  AND?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereInput>>;
  NOT?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereInput>>;
  OR?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereInput>>;
  amexPimsPaymentType?: Maybe<PimsPaymentTypeNullableScalarRelationFilter>;
  amexPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  balanceRetriesEnabled?: Maybe<BoolFilter>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeNullableScalarRelationFilter>;
  careDiscountPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  careEnabled?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeNullableScalarRelationFilter>;
  defaultPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeNullableScalarRelationFilter>;
  discoverPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  enteredBy?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  enteredById?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isEnabled?: Maybe<BoolFilter>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeNullableScalarRelationFilter>;
  mastercardPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  paymentsEnabled?: Maybe<BoolFilter>;
  retriesEnabled?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeNullableScalarRelationFilter>;
  visaPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  writebackManualPayment?: Maybe<BoolFilter>;
};

export type BitwerxPaymentWritebackConfigurationWhereUniqueInput = {
  AND?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereInput>>;
  NOT?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereInput>>;
  OR?: Maybe<Array<BitwerxPaymentWritebackConfigurationWhereInput>>;
  amexPimsPaymentType?: Maybe<PimsPaymentTypeNullableScalarRelationFilter>;
  amexPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  balanceRetriesEnabled?: Maybe<BoolFilter>;
  careDiscountPimsPaymentType?: Maybe<PimsPaymentTypeNullableScalarRelationFilter>;
  careDiscountPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  careEnabled?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultPimsPaymentType?: Maybe<PimsPaymentTypeNullableScalarRelationFilter>;
  defaultPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  discoverPimsPaymentType?: Maybe<PimsPaymentTypeNullableScalarRelationFilter>;
  discoverPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  enteredBy?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  enteredById?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<BoolFilter>;
  mastercardPimsPaymentType?: Maybe<PimsPaymentTypeNullableScalarRelationFilter>;
  mastercardPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  paymentsEnabled?: Maybe<BoolFilter>;
  retriesEnabled?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visaPimsPaymentType?: Maybe<PimsPaymentTypeNullableScalarRelationFilter>;
  visaPimsPaymentTypeId?: Maybe<StringNullableFilter>;
  writebackManualPayment?: Maybe<BoolFilter>;
};

export enum BitwerxSystem {
  Avimark = 'Avimark',
  Cornerstone = 'Cornerstone',
  Impromed = 'Impromed'
}

export type BoardFilterColumn = {
  __typename?: 'BoardFilterColumn';
  channelStatus?: Maybe<ChannelStatus>;
  channelStatusId: Scalars['String'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  id: Scalars['String'];
  type: BoardFilterColumnType;
  userBoardFilter?: Maybe<UserBoardFilter>;
  userBoardFilterId: Scalars['String'];
};


export type BoardFilterColumnChannelStatusArgs = {
  where?: Maybe<ChannelStatusWhereInput>;
};


export type BoardFilterColumnUserBoardFilterArgs = {
  where?: Maybe<UserBoardFilterWhereInput>;
};

export type BoardFilterColumnCountAggregateOutputType = {
  __typename?: 'BoardFilterColumnCountAggregateOutputType';
  _all: Scalars['Int'];
  channelStatusId: Scalars['Int'];
  clinicId: Scalars['Int'];
  id: Scalars['Int'];
  type: Scalars['Int'];
  userBoardFilterId: Scalars['Int'];
};

export type BoardFilterColumnCountOrderByAggregateInput = {
  channelStatusId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export type BoardFilterColumnCreateInput = {
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutBoardFilterColumnsInput>;
  clinic: ClinicCreateNestedOneWithoutUserBoardFiltersColumnsInput;
  id?: Maybe<Scalars['String']>;
  type: BoardFilterColumnType;
  userBoardFilter?: Maybe<UserBoardFilterCreateNestedOneWithoutColumnsInput>;
};

export type BoardFilterColumnCreateManyChannelStatusInput = {
  clinicId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  type: BoardFilterColumnType;
  userBoardFilterId: Scalars['String'];
};

export type BoardFilterColumnCreateManyChannelStatusInputEnvelope = {
  data: Array<BoardFilterColumnCreateManyChannelStatusInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BoardFilterColumnCreateManyClinicInput = {
  channelStatusId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  type: BoardFilterColumnType;
  userBoardFilterId: Scalars['String'];
};

export type BoardFilterColumnCreateManyClinicInputEnvelope = {
  data: Array<BoardFilterColumnCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BoardFilterColumnCreateManyInput = {
  channelStatusId: Scalars['String'];
  clinicId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  type: BoardFilterColumnType;
  userBoardFilterId: Scalars['String'];
};

export type BoardFilterColumnCreateManyUserBoardFilterInput = {
  channelStatusId: Scalars['String'];
  clinicId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  type: BoardFilterColumnType;
};

export type BoardFilterColumnCreateManyUserBoardFilterInputEnvelope = {
  data: Array<BoardFilterColumnCreateManyUserBoardFilterInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BoardFilterColumnCreateNestedManyWithoutChannelStatusInput = {
  connect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoardFilterColumnCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<BoardFilterColumnCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<BoardFilterColumnCreateManyChannelStatusInputEnvelope>;
};

export type BoardFilterColumnCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoardFilterColumnCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<BoardFilterColumnCreateWithoutClinicInput>>;
  createMany?: Maybe<BoardFilterColumnCreateManyClinicInputEnvelope>;
};

export type BoardFilterColumnCreateNestedManyWithoutUserBoardFilterInput = {
  connect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoardFilterColumnCreateOrConnectWithoutUserBoardFilterInput>>;
  create?: Maybe<Array<BoardFilterColumnCreateWithoutUserBoardFilterInput>>;
  createMany?: Maybe<BoardFilterColumnCreateManyUserBoardFilterInputEnvelope>;
};

export type BoardFilterColumnCreateOrConnectWithoutChannelStatusInput = {
  create: BoardFilterColumnCreateWithoutChannelStatusInput;
  where: BoardFilterColumnWhereUniqueInput;
};

export type BoardFilterColumnCreateOrConnectWithoutClinicInput = {
  create: BoardFilterColumnCreateWithoutClinicInput;
  where: BoardFilterColumnWhereUniqueInput;
};

export type BoardFilterColumnCreateOrConnectWithoutUserBoardFilterInput = {
  create: BoardFilterColumnCreateWithoutUserBoardFilterInput;
  where: BoardFilterColumnWhereUniqueInput;
};

export type BoardFilterColumnCreateWithoutChannelStatusInput = {
  clinic: ClinicCreateNestedOneWithoutUserBoardFiltersColumnsInput;
  id?: Maybe<Scalars['String']>;
  type: BoardFilterColumnType;
  userBoardFilter?: Maybe<UserBoardFilterCreateNestedOneWithoutColumnsInput>;
};

export type BoardFilterColumnCreateWithoutClinicInput = {
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutBoardFilterColumnsInput>;
  id?: Maybe<Scalars['String']>;
  type: BoardFilterColumnType;
  userBoardFilter?: Maybe<UserBoardFilterCreateNestedOneWithoutColumnsInput>;
};

export type BoardFilterColumnCreateWithoutUserBoardFilterInput = {
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutBoardFilterColumnsInput>;
  clinic: ClinicCreateNestedOneWithoutUserBoardFiltersColumnsInput;
  id?: Maybe<Scalars['String']>;
  type: BoardFilterColumnType;
};

export type BoardFilterColumnGroupByOutputType = {
  __typename?: 'BoardFilterColumnGroupByOutputType';
  _count?: Maybe<BoardFilterColumnCountAggregateOutputType>;
  _max?: Maybe<BoardFilterColumnMaxAggregateOutputType>;
  _min?: Maybe<BoardFilterColumnMinAggregateOutputType>;
  channelStatusId: Scalars['String'];
  clinicId: Scalars['String'];
  id: Scalars['String'];
  type: BoardFilterColumnType;
  userBoardFilterId: Scalars['String'];
};

export type BoardFilterColumnListRelationFilter = {
  every?: Maybe<BoardFilterColumnWhereInput>;
  none?: Maybe<BoardFilterColumnWhereInput>;
  some?: Maybe<BoardFilterColumnWhereInput>;
};

export type BoardFilterColumnMaxAggregateOutputType = {
  __typename?: 'BoardFilterColumnMaxAggregateOutputType';
  channelStatusId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export type BoardFilterColumnMaxOrderByAggregateInput = {
  channelStatusId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export type BoardFilterColumnMinAggregateOutputType = {
  __typename?: 'BoardFilterColumnMinAggregateOutputType';
  channelStatusId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export type BoardFilterColumnMinOrderByAggregateInput = {
  channelStatusId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export type BoardFilterColumnOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BoardFilterColumnOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BoardFilterColumnOrderByRelevanceInput>;
  channelStatus?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  userBoardFilter?: Maybe<UserBoardFilterOrderByWithRelationInput>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export enum BoardFilterColumnOrderByRelevanceFieldEnum {
  ChannelStatusId = 'channelStatusId',
  ClinicId = 'clinicId',
  Id = 'id',
  UserBoardFilterId = 'userBoardFilterId'
}

export type BoardFilterColumnOrderByRelevanceInput = {
  fields: Array<BoardFilterColumnOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type BoardFilterColumnOrderByWithAggregationInput = {
  _count?: Maybe<BoardFilterColumnCountOrderByAggregateInput>;
  _max?: Maybe<BoardFilterColumnMaxOrderByAggregateInput>;
  _min?: Maybe<BoardFilterColumnMinOrderByAggregateInput>;
  channelStatusId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export type BoardFilterColumnOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BoardFilterColumnOrderByRelevanceInput>;
  channelStatus?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  userBoardFilter?: Maybe<UserBoardFilterOrderByWithRelationInput>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export type BoardFilterColumnOrderByWithRelationInput = {
  _relevance?: Maybe<BoardFilterColumnOrderByRelevanceInput>;
  channelStatus?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  userBoardFilter?: Maybe<UserBoardFilterOrderByWithRelationInput>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export enum BoardFilterColumnScalarFieldEnum {
  ChannelStatusId = 'channelStatusId',
  ClinicId = 'clinicId',
  Id = 'id',
  Type = 'type',
  UserBoardFilterId = 'userBoardFilterId'
}

export type BoardFilterColumnScalarWhereInput = {
  AND?: Maybe<Array<BoardFilterColumnScalarWhereInput>>;
  NOT?: Maybe<Array<BoardFilterColumnScalarWhereInput>>;
  OR?: Maybe<Array<BoardFilterColumnScalarWhereInput>>;
  channelStatusId?: Maybe<StringFilter>;
  clinicId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  type?: Maybe<EnumBoardFilterColumnTypeFilter>;
  userBoardFilterId?: Maybe<StringFilter>;
};

export type BoardFilterColumnScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BoardFilterColumnScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<BoardFilterColumnScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BoardFilterColumnScalarWhereWithAggregatesInput>>;
  channelStatusId?: Maybe<StringWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumBoardFilterColumnTypeWithAggregatesFilter>;
  userBoardFilterId?: Maybe<StringWithAggregatesFilter>;
};

export enum BoardFilterColumnType {
  Collapsed = 'Collapsed',
  Selected = 'Selected'
}

export type BoardFilterColumnUncheckedCreateInput = {
  channelStatusId: Scalars['String'];
  clinicId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  type: BoardFilterColumnType;
  userBoardFilterId: Scalars['String'];
};

export type BoardFilterColumnUncheckedCreateNestedManyWithoutChannelStatusInput = {
  connect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoardFilterColumnCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<BoardFilterColumnCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<BoardFilterColumnCreateManyChannelStatusInputEnvelope>;
};

export type BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoardFilterColumnCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<BoardFilterColumnCreateWithoutClinicInput>>;
  createMany?: Maybe<BoardFilterColumnCreateManyClinicInputEnvelope>;
};

export type BoardFilterColumnUncheckedCreateNestedManyWithoutUserBoardFilterInput = {
  connect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoardFilterColumnCreateOrConnectWithoutUserBoardFilterInput>>;
  create?: Maybe<Array<BoardFilterColumnCreateWithoutUserBoardFilterInput>>;
  createMany?: Maybe<BoardFilterColumnCreateManyUserBoardFilterInputEnvelope>;
};

export type BoardFilterColumnUncheckedCreateWithoutChannelStatusInput = {
  clinicId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  type: BoardFilterColumnType;
  userBoardFilterId: Scalars['String'];
};

export type BoardFilterColumnUncheckedCreateWithoutClinicInput = {
  channelStatusId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  type: BoardFilterColumnType;
  userBoardFilterId: Scalars['String'];
};

export type BoardFilterColumnUncheckedCreateWithoutUserBoardFilterInput = {
  channelStatusId: Scalars['String'];
  clinicId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  type: BoardFilterColumnType;
};

export type BoardFilterColumnUncheckedUpdateInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export type BoardFilterColumnUncheckedUpdateManyInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export type BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusInput = {
  clinicId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export type BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusNestedInput = {
  connect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoardFilterColumnCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<BoardFilterColumnCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<BoardFilterColumnCreateManyChannelStatusInputEnvelope>;
  delete?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoardFilterColumnScalarWhereInput>>;
  disconnect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  set?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  update?: Maybe<Array<BoardFilterColumnUpdateWithWhereUniqueWithoutChannelStatusInput>>;
  updateMany?: Maybe<Array<BoardFilterColumnUpdateManyWithWhereWithoutChannelStatusInput>>;
  upsert?: Maybe<Array<BoardFilterColumnUpsertWithWhereUniqueWithoutChannelStatusInput>>;
};

export type BoardFilterColumnUncheckedUpdateManyWithoutClinicInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export type BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoardFilterColumnCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<BoardFilterColumnCreateWithoutClinicInput>>;
  createMany?: Maybe<BoardFilterColumnCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoardFilterColumnScalarWhereInput>>;
  disconnect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  set?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  update?: Maybe<Array<BoardFilterColumnUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<BoardFilterColumnUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<BoardFilterColumnUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type BoardFilterColumnUncheckedUpdateManyWithoutUserBoardFilterInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
};

export type BoardFilterColumnUncheckedUpdateManyWithoutUserBoardFilterNestedInput = {
  connect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoardFilterColumnCreateOrConnectWithoutUserBoardFilterInput>>;
  create?: Maybe<Array<BoardFilterColumnCreateWithoutUserBoardFilterInput>>;
  createMany?: Maybe<BoardFilterColumnCreateManyUserBoardFilterInputEnvelope>;
  delete?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoardFilterColumnScalarWhereInput>>;
  disconnect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  set?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  update?: Maybe<Array<BoardFilterColumnUpdateWithWhereUniqueWithoutUserBoardFilterInput>>;
  updateMany?: Maybe<Array<BoardFilterColumnUpdateManyWithWhereWithoutUserBoardFilterInput>>;
  upsert?: Maybe<Array<BoardFilterColumnUpsertWithWhereUniqueWithoutUserBoardFilterInput>>;
};

export type BoardFilterColumnUncheckedUpdateWithoutChannelStatusInput = {
  clinicId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export type BoardFilterColumnUncheckedUpdateWithoutClinicInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export type BoardFilterColumnUncheckedUpdateWithoutUserBoardFilterInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
};

export type BoardFilterColumnUpdateInput = {
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutBoardFilterColumnsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutUserBoardFiltersColumnsNestedInput>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
  userBoardFilter?: Maybe<UserBoardFilterUpdateOneWithoutColumnsNestedInput>;
};

export type BoardFilterColumnUpdateManyMutationInput = {
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
};

export type BoardFilterColumnUpdateManyWithWhereWithoutChannelStatusInput = {
  data: BoardFilterColumnUpdateManyMutationInput;
  where: BoardFilterColumnScalarWhereInput;
};

export type BoardFilterColumnUpdateManyWithWhereWithoutClinicInput = {
  data: BoardFilterColumnUpdateManyMutationInput;
  where: BoardFilterColumnScalarWhereInput;
};

export type BoardFilterColumnUpdateManyWithWhereWithoutUserBoardFilterInput = {
  data: BoardFilterColumnUpdateManyMutationInput;
  where: BoardFilterColumnScalarWhereInput;
};

export type BoardFilterColumnUpdateManyWithoutChannelStatusNestedInput = {
  connect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoardFilterColumnCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<BoardFilterColumnCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<BoardFilterColumnCreateManyChannelStatusInputEnvelope>;
  delete?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoardFilterColumnScalarWhereInput>>;
  disconnect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  set?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  update?: Maybe<Array<BoardFilterColumnUpdateWithWhereUniqueWithoutChannelStatusInput>>;
  updateMany?: Maybe<Array<BoardFilterColumnUpdateManyWithWhereWithoutChannelStatusInput>>;
  upsert?: Maybe<Array<BoardFilterColumnUpsertWithWhereUniqueWithoutChannelStatusInput>>;
};

export type BoardFilterColumnUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoardFilterColumnCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<BoardFilterColumnCreateWithoutClinicInput>>;
  createMany?: Maybe<BoardFilterColumnCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoardFilterColumnScalarWhereInput>>;
  disconnect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  set?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  update?: Maybe<Array<BoardFilterColumnUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<BoardFilterColumnUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<BoardFilterColumnUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type BoardFilterColumnUpdateManyWithoutUserBoardFilterNestedInput = {
  connect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoardFilterColumnCreateOrConnectWithoutUserBoardFilterInput>>;
  create?: Maybe<Array<BoardFilterColumnCreateWithoutUserBoardFilterInput>>;
  createMany?: Maybe<BoardFilterColumnCreateManyUserBoardFilterInputEnvelope>;
  delete?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoardFilterColumnScalarWhereInput>>;
  disconnect?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  set?: Maybe<Array<BoardFilterColumnWhereUniqueInput>>;
  update?: Maybe<Array<BoardFilterColumnUpdateWithWhereUniqueWithoutUserBoardFilterInput>>;
  updateMany?: Maybe<Array<BoardFilterColumnUpdateManyWithWhereWithoutUserBoardFilterInput>>;
  upsert?: Maybe<Array<BoardFilterColumnUpsertWithWhereUniqueWithoutUserBoardFilterInput>>;
};

export type BoardFilterColumnUpdateWithWhereUniqueWithoutChannelStatusInput = {
  data: BoardFilterColumnUpdateWithoutChannelStatusInput;
  where: BoardFilterColumnWhereUniqueInput;
};

export type BoardFilterColumnUpdateWithWhereUniqueWithoutClinicInput = {
  data: BoardFilterColumnUpdateWithoutClinicInput;
  where: BoardFilterColumnWhereUniqueInput;
};

export type BoardFilterColumnUpdateWithWhereUniqueWithoutUserBoardFilterInput = {
  data: BoardFilterColumnUpdateWithoutUserBoardFilterInput;
  where: BoardFilterColumnWhereUniqueInput;
};

export type BoardFilterColumnUpdateWithoutChannelStatusInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutUserBoardFiltersColumnsNestedInput>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
  userBoardFilter?: Maybe<UserBoardFilterUpdateOneWithoutColumnsNestedInput>;
};

export type BoardFilterColumnUpdateWithoutClinicInput = {
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutBoardFilterColumnsNestedInput>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
  userBoardFilter?: Maybe<UserBoardFilterUpdateOneWithoutColumnsNestedInput>;
};

export type BoardFilterColumnUpdateWithoutUserBoardFilterInput = {
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutBoardFilterColumnsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutUserBoardFiltersColumnsNestedInput>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<BoardFilterColumnType>;
};

export type BoardFilterColumnUpsertWithWhereUniqueWithoutChannelStatusInput = {
  create: BoardFilterColumnCreateWithoutChannelStatusInput;
  update: BoardFilterColumnUpdateWithoutChannelStatusInput;
  where: BoardFilterColumnWhereUniqueInput;
};

export type BoardFilterColumnUpsertWithWhereUniqueWithoutClinicInput = {
  create: BoardFilterColumnCreateWithoutClinicInput;
  update: BoardFilterColumnUpdateWithoutClinicInput;
  where: BoardFilterColumnWhereUniqueInput;
};

export type BoardFilterColumnUpsertWithWhereUniqueWithoutUserBoardFilterInput = {
  create: BoardFilterColumnCreateWithoutUserBoardFilterInput;
  update: BoardFilterColumnUpdateWithoutUserBoardFilterInput;
  where: BoardFilterColumnWhereUniqueInput;
};

export type BoardFilterColumnWhereInput = {
  AND?: Maybe<Array<BoardFilterColumnWhereInput>>;
  NOT?: Maybe<Array<BoardFilterColumnWhereInput>>;
  OR?: Maybe<Array<BoardFilterColumnWhereInput>>;
  channelStatus?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusId?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  type?: Maybe<EnumBoardFilterColumnTypeFilter>;
  userBoardFilter?: Maybe<UserBoardFilterNullableScalarRelationFilter>;
  userBoardFilterId?: Maybe<StringFilter>;
};

export type BoardFilterColumnWhereUniqueInput = {
  AND?: Maybe<Array<BoardFilterColumnWhereInput>>;
  NOT?: Maybe<Array<BoardFilterColumnWhereInput>>;
  OR?: Maybe<Array<BoardFilterColumnWhereInput>>;
  channelStatus?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusId?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<EnumBoardFilterColumnTypeFilter>;
  userBoardFilter?: Maybe<UserBoardFilterNullableScalarRelationFilter>;
  userBoardFilterId?: Maybe<StringFilter>;
};

export enum BoardFilterDateRange {
  ThisWeek = 'thisWeek',
  Today = 'today',
  Tomorrow = 'tomorrow',
  Yesterday = 'yesterday'
}

export type BoardFilterSpecificDateRange = {
  __typename?: 'BoardFilterSpecificDateRange';
  gte: Scalars['DateTime'];
  id: Scalars['String'];
  lte: Scalars['DateTime'];
  userBoardFilter?: Maybe<UserBoardFilter>;
  userBoardFilterId: Scalars['String'];
};


export type BoardFilterSpecificDateRangeUserBoardFilterArgs = {
  where?: Maybe<UserBoardFilterWhereInput>;
};

export type BoardFilterSpecificDateRangeCountAggregateOutputType = {
  __typename?: 'BoardFilterSpecificDateRangeCountAggregateOutputType';
  _all: Scalars['Int'];
  gte: Scalars['Int'];
  id: Scalars['Int'];
  lte: Scalars['Int'];
  userBoardFilterId: Scalars['Int'];
};

export type BoardFilterSpecificDateRangeCountOrderByAggregateInput = {
  gte?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lte?: Maybe<SortOrder>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export type BoardFilterSpecificDateRangeCreateInput = {
  gte: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  lte: Scalars['DateTime'];
  userBoardFilter?: Maybe<UserBoardFilterCreateNestedOneWithoutSpecificDateRangeInput>;
};

export type BoardFilterSpecificDateRangeCreateManyInput = {
  gte: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  lte: Scalars['DateTime'];
  userBoardFilterId: Scalars['String'];
};

export type BoardFilterSpecificDateRangeCreateNestedOneWithoutUserBoardFilterInput = {
  connect?: Maybe<BoardFilterSpecificDateRangeWhereUniqueInput>;
  connectOrCreate?: Maybe<BoardFilterSpecificDateRangeCreateOrConnectWithoutUserBoardFilterInput>;
  create?: Maybe<BoardFilterSpecificDateRangeCreateWithoutUserBoardFilterInput>;
};

export type BoardFilterSpecificDateRangeCreateOrConnectWithoutUserBoardFilterInput = {
  create: BoardFilterSpecificDateRangeCreateWithoutUserBoardFilterInput;
  where: BoardFilterSpecificDateRangeWhereUniqueInput;
};

export type BoardFilterSpecificDateRangeCreateWithoutUserBoardFilterInput = {
  gte: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  lte: Scalars['DateTime'];
};

export type BoardFilterSpecificDateRangeGroupByOutputType = {
  __typename?: 'BoardFilterSpecificDateRangeGroupByOutputType';
  _count?: Maybe<BoardFilterSpecificDateRangeCountAggregateOutputType>;
  _max?: Maybe<BoardFilterSpecificDateRangeMaxAggregateOutputType>;
  _min?: Maybe<BoardFilterSpecificDateRangeMinAggregateOutputType>;
  gte: Scalars['DateTime'];
  id: Scalars['String'];
  lte: Scalars['DateTime'];
  userBoardFilterId: Scalars['String'];
};

export type BoardFilterSpecificDateRangeMaxAggregateOutputType = {
  __typename?: 'BoardFilterSpecificDateRangeMaxAggregateOutputType';
  gte?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['DateTime']>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export type BoardFilterSpecificDateRangeMaxOrderByAggregateInput = {
  gte?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lte?: Maybe<SortOrder>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export type BoardFilterSpecificDateRangeMinAggregateOutputType = {
  __typename?: 'BoardFilterSpecificDateRangeMinAggregateOutputType';
  gte?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['DateTime']>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export type BoardFilterSpecificDateRangeMinOrderByAggregateInput = {
  gte?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lte?: Maybe<SortOrder>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export type BoardFilterSpecificDateRangeNullableScalarRelationFilter = {
  AND?: Maybe<Array<BoardFilterSpecificDateRangeWhereInput>>;
  NOT?: Maybe<Array<BoardFilterSpecificDateRangeWhereInput>>;
  OR?: Maybe<Array<BoardFilterSpecificDateRangeWhereInput>>;
  gte?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  lte?: Maybe<DateTimeFilter>;
  userBoardFilter?: Maybe<UserBoardFilterNullableScalarRelationFilter>;
  userBoardFilterId?: Maybe<StringFilter>;
};

export type BoardFilterSpecificDateRangeOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BoardFilterSpecificDateRangeOrderByRelevanceInput>;
  gte?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lte?: Maybe<SortOrder>;
  userBoardFilter?: Maybe<UserBoardFilterOrderByWithRelationInput>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export enum BoardFilterSpecificDateRangeOrderByRelevanceFieldEnum {
  Id = 'id',
  UserBoardFilterId = 'userBoardFilterId'
}

export type BoardFilterSpecificDateRangeOrderByRelevanceInput = {
  fields: Array<BoardFilterSpecificDateRangeOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type BoardFilterSpecificDateRangeOrderByWithAggregationInput = {
  _count?: Maybe<BoardFilterSpecificDateRangeCountOrderByAggregateInput>;
  _max?: Maybe<BoardFilterSpecificDateRangeMaxOrderByAggregateInput>;
  _min?: Maybe<BoardFilterSpecificDateRangeMinOrderByAggregateInput>;
  gte?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lte?: Maybe<SortOrder>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export type BoardFilterSpecificDateRangeOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BoardFilterSpecificDateRangeOrderByRelevanceInput>;
  gte?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lte?: Maybe<SortOrder>;
  userBoardFilter?: Maybe<UserBoardFilterOrderByWithRelationInput>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export type BoardFilterSpecificDateRangeOrderByWithRelationInput = {
  _relevance?: Maybe<BoardFilterSpecificDateRangeOrderByRelevanceInput>;
  gte?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lte?: Maybe<SortOrder>;
  userBoardFilter?: Maybe<UserBoardFilterOrderByWithRelationInput>;
  userBoardFilterId?: Maybe<SortOrder>;
};

export enum BoardFilterSpecificDateRangeScalarFieldEnum {
  Gte = 'gte',
  Id = 'id',
  Lte = 'lte',
  UserBoardFilterId = 'userBoardFilterId'
}

export type BoardFilterSpecificDateRangeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BoardFilterSpecificDateRangeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<BoardFilterSpecificDateRangeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BoardFilterSpecificDateRangeScalarWhereWithAggregatesInput>>;
  gte?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  lte?: Maybe<DateTimeWithAggregatesFilter>;
  userBoardFilterId?: Maybe<StringWithAggregatesFilter>;
};

export type BoardFilterSpecificDateRangeUncheckedCreateInput = {
  gte: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  lte: Scalars['DateTime'];
  userBoardFilterId: Scalars['String'];
};

export type BoardFilterSpecificDateRangeUncheckedCreateNestedOneWithoutUserBoardFilterInput = {
  connect?: Maybe<BoardFilterSpecificDateRangeWhereUniqueInput>;
  connectOrCreate?: Maybe<BoardFilterSpecificDateRangeCreateOrConnectWithoutUserBoardFilterInput>;
  create?: Maybe<BoardFilterSpecificDateRangeCreateWithoutUserBoardFilterInput>;
};

export type BoardFilterSpecificDateRangeUncheckedCreateWithoutUserBoardFilterInput = {
  gte: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  lte: Scalars['DateTime'];
};

export type BoardFilterSpecificDateRangeUncheckedUpdateInput = {
  gte?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['DateTime']>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export type BoardFilterSpecificDateRangeUncheckedUpdateManyInput = {
  gte?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['DateTime']>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export type BoardFilterSpecificDateRangeUncheckedUpdateOneWithoutUserBoardFilterNestedInput = {
  connect?: Maybe<BoardFilterSpecificDateRangeWhereUniqueInput>;
  connectOrCreate?: Maybe<BoardFilterSpecificDateRangeCreateOrConnectWithoutUserBoardFilterInput>;
  create?: Maybe<BoardFilterSpecificDateRangeCreateWithoutUserBoardFilterInput>;
  delete?: Maybe<BoardFilterSpecificDateRangeWhereInput>;
  disconnect?: Maybe<BoardFilterSpecificDateRangeWhereInput>;
  update?: Maybe<BoardFilterSpecificDateRangeUpdateToOneWithWhereWithoutUserBoardFilterInput>;
  upsert?: Maybe<BoardFilterSpecificDateRangeUpsertWithoutUserBoardFilterInput>;
};

export type BoardFilterSpecificDateRangeUncheckedUpdateWithoutUserBoardFilterInput = {
  gte?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['DateTime']>;
};

export type BoardFilterSpecificDateRangeUpdateInput = {
  gte?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['DateTime']>;
  userBoardFilter?: Maybe<UserBoardFilterUpdateOneWithoutSpecificDateRangeNestedInput>;
};

export type BoardFilterSpecificDateRangeUpdateManyMutationInput = {
  gte?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['DateTime']>;
};

export type BoardFilterSpecificDateRangeUpdateOneWithoutUserBoardFilterNestedInput = {
  connect?: Maybe<BoardFilterSpecificDateRangeWhereUniqueInput>;
  connectOrCreate?: Maybe<BoardFilterSpecificDateRangeCreateOrConnectWithoutUserBoardFilterInput>;
  create?: Maybe<BoardFilterSpecificDateRangeCreateWithoutUserBoardFilterInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<BoardFilterSpecificDateRangeUpdateToOneWithWhereWithoutUserBoardFilterInput>;
  upsert?: Maybe<BoardFilterSpecificDateRangeUpsertWithoutUserBoardFilterInput>;
};

export type BoardFilterSpecificDateRangeUpdateToOneWithWhereWithoutUserBoardFilterInput = {
  data: BoardFilterSpecificDateRangeUpdateWithoutUserBoardFilterInput;
  where?: Maybe<BoardFilterSpecificDateRangeWhereInput>;
};

export type BoardFilterSpecificDateRangeUpdateWithoutUserBoardFilterInput = {
  gte?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['DateTime']>;
};

export type BoardFilterSpecificDateRangeUpsertWithoutUserBoardFilterInput = {
  create: BoardFilterSpecificDateRangeCreateWithoutUserBoardFilterInput;
  update: BoardFilterSpecificDateRangeUpdateWithoutUserBoardFilterInput;
  where?: Maybe<BoardFilterSpecificDateRangeWhereInput>;
};

export type BoardFilterSpecificDateRangeWhereInput = {
  AND?: Maybe<Array<BoardFilterSpecificDateRangeWhereInput>>;
  NOT?: Maybe<Array<BoardFilterSpecificDateRangeWhereInput>>;
  OR?: Maybe<Array<BoardFilterSpecificDateRangeWhereInput>>;
  gte?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  lte?: Maybe<DateTimeFilter>;
  userBoardFilter?: Maybe<UserBoardFilterNullableScalarRelationFilter>;
  userBoardFilterId?: Maybe<StringFilter>;
};

export type BoardFilterSpecificDateRangeWhereUniqueInput = {
  AND?: Maybe<Array<BoardFilterSpecificDateRangeWhereInput>>;
  NOT?: Maybe<Array<BoardFilterSpecificDateRangeWhereInput>>;
  OR?: Maybe<Array<BoardFilterSpecificDateRangeWhereInput>>;
  gte?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  lte?: Maybe<DateTimeFilter>;
  userBoardFilter?: Maybe<UserBoardFilterNullableScalarRelationFilter>;
  userBoardFilterId?: Maybe<Scalars['String']>;
};

export enum BoardFilterView {
  Appointments = 'appointments',
  Automations = 'automations',
  Conversations = 'conversations'
}

export type BoehringerIngelheimCustomerAlignment = {
  __typename?: 'BoehringerIngelheimCustomerAlignment';
  boehringerIngelheimTerritory: BoehringerIngelheimTerritory;
  boehringerIngelheimTerritoryId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informPartnerCustomer: InformPartnerCustomer;
  informPartnerCustomerId: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  soldToId: Scalars['Int'];
  status: BoehringerIngelheimCustomerAlignmentStatus;
  territoryName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BoehringerIngelheimCustomerAlignmentAvgAggregateOutputType = {
  __typename?: 'BoehringerIngelheimCustomerAlignmentAvgAggregateOutputType';
  soldToId?: Maybe<Scalars['Float']>;
};

export type BoehringerIngelheimCustomerAlignmentAvgOrderByAggregateInput = {
  soldToId?: Maybe<SortOrder>;
};

export type BoehringerIngelheimCustomerAlignmentCountAggregateOutputType = {
  __typename?: 'BoehringerIngelheimCustomerAlignmentCountAggregateOutputType';
  _all: Scalars['Int'];
  boehringerIngelheimTerritoryId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerCustomerId: Scalars['Int'];
  rawData: Scalars['Int'];
  soldToId: Scalars['Int'];
  status: Scalars['Int'];
  territoryName: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type BoehringerIngelheimCustomerAlignmentCountOrderByAggregateInput = {
  boehringerIngelheimTerritoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  soldToId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BoehringerIngelheimCustomerAlignmentCreateInput = {
  boehringerIngelheimTerritory: BoehringerIngelheimTerritoryCreateNestedOneWithoutBoehringerIngelheimCustomerAlignmentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer: InformPartnerCustomerCreateNestedOneWithoutBoehringerIngelheimCustomerAlignmentsInput;
  rawData?: Maybe<Scalars['Json']>;
  soldToId: Scalars['Int'];
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentCreateManyBoehringerIngelheimTerritoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  soldToId: Scalars['Int'];
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentCreateManyBoehringerIngelheimTerritoryInputEnvelope = {
  data: Array<BoehringerIngelheimCustomerAlignmentCreateManyBoehringerIngelheimTerritoryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BoehringerIngelheimCustomerAlignmentCreateManyInformPartnerCustomerInput = {
  boehringerIngelheimTerritoryId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId: Scalars['Int'];
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentCreateManyInformPartnerCustomerInputEnvelope = {
  data: Array<BoehringerIngelheimCustomerAlignmentCreateManyInformPartnerCustomerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BoehringerIngelheimCustomerAlignmentCreateManyInput = {
  boehringerIngelheimTerritoryId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  soldToId: Scalars['Int'];
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutBoehringerIngelheimTerritoryInput = {
  connect?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateOrConnectWithoutBoehringerIngelheimTerritoryInput>>;
  create?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateWithoutBoehringerIngelheimTerritoryInput>>;
  createMany?: Maybe<BoehringerIngelheimCustomerAlignmentCreateManyBoehringerIngelheimTerritoryInputEnvelope>;
};

export type BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutInformPartnerCustomerInput = {
  connect?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateOrConnectWithoutInformPartnerCustomerInput>>;
  create?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateWithoutInformPartnerCustomerInput>>;
  createMany?: Maybe<BoehringerIngelheimCustomerAlignmentCreateManyInformPartnerCustomerInputEnvelope>;
};

export type BoehringerIngelheimCustomerAlignmentCreateOrConnectWithoutBoehringerIngelheimTerritoryInput = {
  create: BoehringerIngelheimCustomerAlignmentCreateWithoutBoehringerIngelheimTerritoryInput;
  where: BoehringerIngelheimCustomerAlignmentWhereUniqueInput;
};

export type BoehringerIngelheimCustomerAlignmentCreateOrConnectWithoutInformPartnerCustomerInput = {
  create: BoehringerIngelheimCustomerAlignmentCreateWithoutInformPartnerCustomerInput;
  where: BoehringerIngelheimCustomerAlignmentWhereUniqueInput;
};

export type BoehringerIngelheimCustomerAlignmentCreateWithoutBoehringerIngelheimTerritoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer: InformPartnerCustomerCreateNestedOneWithoutBoehringerIngelheimCustomerAlignmentsInput;
  rawData?: Maybe<Scalars['Json']>;
  soldToId: Scalars['Int'];
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentCreateWithoutInformPartnerCustomerInput = {
  boehringerIngelheimTerritory: BoehringerIngelheimTerritoryCreateNestedOneWithoutBoehringerIngelheimCustomerAlignmentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId: Scalars['Int'];
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentGroupByOutputType = {
  __typename?: 'BoehringerIngelheimCustomerAlignmentGroupByOutputType';
  _avg?: Maybe<BoehringerIngelheimCustomerAlignmentAvgAggregateOutputType>;
  _count?: Maybe<BoehringerIngelheimCustomerAlignmentCountAggregateOutputType>;
  _max?: Maybe<BoehringerIngelheimCustomerAlignmentMaxAggregateOutputType>;
  _min?: Maybe<BoehringerIngelheimCustomerAlignmentMinAggregateOutputType>;
  _sum?: Maybe<BoehringerIngelheimCustomerAlignmentSumAggregateOutputType>;
  boehringerIngelheimTerritoryId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informPartnerCustomerId: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  soldToId: Scalars['Int'];
  status: BoehringerIngelheimCustomerAlignmentStatus;
  territoryName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BoehringerIngelheimCustomerAlignmentListRelationFilter = {
  every?: Maybe<BoehringerIngelheimCustomerAlignmentWhereInput>;
  none?: Maybe<BoehringerIngelheimCustomerAlignmentWhereInput>;
  some?: Maybe<BoehringerIngelheimCustomerAlignmentWhereInput>;
};

export type BoehringerIngelheimCustomerAlignmentMaxAggregateOutputType = {
  __typename?: 'BoehringerIngelheimCustomerAlignmentMaxAggregateOutputType';
  boehringerIngelheimTerritoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  soldToId?: Maybe<Scalars['Int']>;
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentMaxOrderByAggregateInput = {
  boehringerIngelheimTerritoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  soldToId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BoehringerIngelheimCustomerAlignmentMinAggregateOutputType = {
  __typename?: 'BoehringerIngelheimCustomerAlignmentMinAggregateOutputType';
  boehringerIngelheimTerritoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  soldToId?: Maybe<Scalars['Int']>;
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentMinOrderByAggregateInput = {
  boehringerIngelheimTerritoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  soldToId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BoehringerIngelheimCustomerAlignmentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BoehringerIngelheimCustomerAlignmentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BoehringerIngelheimCustomerAlignmentOrderByRelevanceInput>;
  boehringerIngelheimTerritory?: Maybe<BoehringerIngelheimTerritoryOrderByWithRelationInput>;
  boehringerIngelheimTerritoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerOrderByWithRelationInput>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  soldToId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BoehringerIngelheimCustomerAlignmentOrderByRelevanceFieldEnum {
  BoehringerIngelheimTerritoryId = 'boehringerIngelheimTerritoryId',
  Id = 'id',
  InformPartnerCustomerId = 'informPartnerCustomerId',
  TerritoryName = 'territoryName'
}

export type BoehringerIngelheimCustomerAlignmentOrderByRelevanceInput = {
  fields: Array<BoehringerIngelheimCustomerAlignmentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type BoehringerIngelheimCustomerAlignmentOrderByWithAggregationInput = {
  _avg?: Maybe<BoehringerIngelheimCustomerAlignmentAvgOrderByAggregateInput>;
  _count?: Maybe<BoehringerIngelheimCustomerAlignmentCountOrderByAggregateInput>;
  _max?: Maybe<BoehringerIngelheimCustomerAlignmentMaxOrderByAggregateInput>;
  _min?: Maybe<BoehringerIngelheimCustomerAlignmentMinOrderByAggregateInput>;
  _sum?: Maybe<BoehringerIngelheimCustomerAlignmentSumOrderByAggregateInput>;
  boehringerIngelheimTerritoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  soldToId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BoehringerIngelheimCustomerAlignmentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BoehringerIngelheimCustomerAlignmentOrderByRelevanceInput>;
  boehringerIngelheimTerritory?: Maybe<BoehringerIngelheimTerritoryOrderByWithRelationInput>;
  boehringerIngelheimTerritoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerOrderByWithRelationInput>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  soldToId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BoehringerIngelheimCustomerAlignmentOrderByWithRelationInput = {
  _relevance?: Maybe<BoehringerIngelheimCustomerAlignmentOrderByRelevanceInput>;
  boehringerIngelheimTerritory?: Maybe<BoehringerIngelheimTerritoryOrderByWithRelationInput>;
  boehringerIngelheimTerritoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerOrderByWithRelationInput>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  soldToId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BoehringerIngelheimCustomerAlignmentScalarFieldEnum {
  BoehringerIngelheimTerritoryId = 'boehringerIngelheimTerritoryId',
  CreatedAt = 'createdAt',
  Id = 'id',
  InformPartnerCustomerId = 'informPartnerCustomerId',
  RawData = 'rawData',
  SoldToId = 'soldToId',
  Status = 'status',
  TerritoryName = 'territoryName',
  UpdatedAt = 'updatedAt'
}

export type BoehringerIngelheimCustomerAlignmentScalarWhereInput = {
  AND?: Maybe<Array<BoehringerIngelheimCustomerAlignmentScalarWhereInput>>;
  NOT?: Maybe<Array<BoehringerIngelheimCustomerAlignmentScalarWhereInput>>;
  OR?: Maybe<Array<BoehringerIngelheimCustomerAlignmentScalarWhereInput>>;
  boehringerIngelheimTerritoryId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informPartnerCustomerId?: Maybe<StringFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  soldToId?: Maybe<IntFilter>;
  status?: Maybe<EnumBoehringerIngelheimCustomerAlignmentStatusFilter>;
  territoryName?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BoehringerIngelheimCustomerAlignmentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BoehringerIngelheimCustomerAlignmentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<BoehringerIngelheimCustomerAlignmentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BoehringerIngelheimCustomerAlignmentScalarWhereWithAggregatesInput>>;
  boehringerIngelheimTerritoryId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerCustomerId?: Maybe<StringWithAggregatesFilter>;
  rawData?: Maybe<JsonNullableWithAggregatesFilter>;
  soldToId?: Maybe<IntWithAggregatesFilter>;
  status?: Maybe<EnumBoehringerIngelheimCustomerAlignmentStatusWithAggregatesFilter>;
  territoryName?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type BoehringerIngelheimCustomerAlignmentSoldToIdTerritoryNameCompoundUniqueInput = {
  soldToId: Scalars['Int'];
  territoryName: Scalars['String'];
};

export enum BoehringerIngelheimCustomerAlignmentStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type BoehringerIngelheimCustomerAlignmentSumAggregateOutputType = {
  __typename?: 'BoehringerIngelheimCustomerAlignmentSumAggregateOutputType';
  soldToId?: Maybe<Scalars['Int']>;
};

export type BoehringerIngelheimCustomerAlignmentSumOrderByAggregateInput = {
  soldToId?: Maybe<SortOrder>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedCreateInput = {
  boehringerIngelheimTerritoryId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  soldToId: Scalars['Int'];
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutBoehringerIngelheimTerritoryInput = {
  connect?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateOrConnectWithoutBoehringerIngelheimTerritoryInput>>;
  create?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateWithoutBoehringerIngelheimTerritoryInput>>;
  createMany?: Maybe<BoehringerIngelheimCustomerAlignmentCreateManyBoehringerIngelheimTerritoryInputEnvelope>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutInformPartnerCustomerInput = {
  connect?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateOrConnectWithoutInformPartnerCustomerInput>>;
  create?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateWithoutInformPartnerCustomerInput>>;
  createMany?: Maybe<BoehringerIngelheimCustomerAlignmentCreateManyInformPartnerCustomerInputEnvelope>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedCreateWithoutBoehringerIngelheimTerritoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  soldToId: Scalars['Int'];
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedCreateWithoutInformPartnerCustomerInput = {
  boehringerIngelheimTerritoryId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId: Scalars['Int'];
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedUpdateInput = {
  boehringerIngelheimTerritoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId?: Maybe<Scalars['Int']>;
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyInput = {
  boehringerIngelheimTerritoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId?: Maybe<Scalars['Int']>;
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutBoehringerIngelheimTerritoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId?: Maybe<Scalars['Int']>;
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutBoehringerIngelheimTerritoryNestedInput = {
  connect?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateOrConnectWithoutBoehringerIngelheimTerritoryInput>>;
  create?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateWithoutBoehringerIngelheimTerritoryInput>>;
  createMany?: Maybe<BoehringerIngelheimCustomerAlignmentCreateManyBoehringerIngelheimTerritoryInputEnvelope>;
  delete?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoehringerIngelheimCustomerAlignmentScalarWhereInput>>;
  disconnect?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  set?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  update?: Maybe<Array<BoehringerIngelheimCustomerAlignmentUpdateWithWhereUniqueWithoutBoehringerIngelheimTerritoryInput>>;
  updateMany?: Maybe<Array<BoehringerIngelheimCustomerAlignmentUpdateManyWithWhereWithoutBoehringerIngelheimTerritoryInput>>;
  upsert?: Maybe<Array<BoehringerIngelheimCustomerAlignmentUpsertWithWhereUniqueWithoutBoehringerIngelheimTerritoryInput>>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutInformPartnerCustomerInput = {
  boehringerIngelheimTerritoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId?: Maybe<Scalars['Int']>;
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput = {
  connect?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateOrConnectWithoutInformPartnerCustomerInput>>;
  create?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateWithoutInformPartnerCustomerInput>>;
  createMany?: Maybe<BoehringerIngelheimCustomerAlignmentCreateManyInformPartnerCustomerInputEnvelope>;
  delete?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoehringerIngelheimCustomerAlignmentScalarWhereInput>>;
  disconnect?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  set?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  update?: Maybe<Array<BoehringerIngelheimCustomerAlignmentUpdateWithWhereUniqueWithoutInformPartnerCustomerInput>>;
  updateMany?: Maybe<Array<BoehringerIngelheimCustomerAlignmentUpdateManyWithWhereWithoutInformPartnerCustomerInput>>;
  upsert?: Maybe<Array<BoehringerIngelheimCustomerAlignmentUpsertWithWhereUniqueWithoutInformPartnerCustomerInput>>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedUpdateWithoutBoehringerIngelheimTerritoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId?: Maybe<Scalars['Int']>;
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUncheckedUpdateWithoutInformPartnerCustomerInput = {
  boehringerIngelheimTerritoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId?: Maybe<Scalars['Int']>;
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUpdateInput = {
  boehringerIngelheimTerritory?: Maybe<BoehringerIngelheimTerritoryUpdateOneRequiredWithoutBoehringerIngelheimCustomerAlignmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneRequiredWithoutBoehringerIngelheimCustomerAlignmentsNestedInput>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId?: Maybe<Scalars['Int']>;
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId?: Maybe<Scalars['Int']>;
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUpdateManyWithWhereWithoutBoehringerIngelheimTerritoryInput = {
  data: BoehringerIngelheimCustomerAlignmentUpdateManyMutationInput;
  where: BoehringerIngelheimCustomerAlignmentScalarWhereInput;
};

export type BoehringerIngelheimCustomerAlignmentUpdateManyWithWhereWithoutInformPartnerCustomerInput = {
  data: BoehringerIngelheimCustomerAlignmentUpdateManyMutationInput;
  where: BoehringerIngelheimCustomerAlignmentScalarWhereInput;
};

export type BoehringerIngelheimCustomerAlignmentUpdateManyWithoutBoehringerIngelheimTerritoryNestedInput = {
  connect?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateOrConnectWithoutBoehringerIngelheimTerritoryInput>>;
  create?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateWithoutBoehringerIngelheimTerritoryInput>>;
  createMany?: Maybe<BoehringerIngelheimCustomerAlignmentCreateManyBoehringerIngelheimTerritoryInputEnvelope>;
  delete?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoehringerIngelheimCustomerAlignmentScalarWhereInput>>;
  disconnect?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  set?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  update?: Maybe<Array<BoehringerIngelheimCustomerAlignmentUpdateWithWhereUniqueWithoutBoehringerIngelheimTerritoryInput>>;
  updateMany?: Maybe<Array<BoehringerIngelheimCustomerAlignmentUpdateManyWithWhereWithoutBoehringerIngelheimTerritoryInput>>;
  upsert?: Maybe<Array<BoehringerIngelheimCustomerAlignmentUpsertWithWhereUniqueWithoutBoehringerIngelheimTerritoryInput>>;
};

export type BoehringerIngelheimCustomerAlignmentUpdateManyWithoutInformPartnerCustomerNestedInput = {
  connect?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateOrConnectWithoutInformPartnerCustomerInput>>;
  create?: Maybe<Array<BoehringerIngelheimCustomerAlignmentCreateWithoutInformPartnerCustomerInput>>;
  createMany?: Maybe<BoehringerIngelheimCustomerAlignmentCreateManyInformPartnerCustomerInputEnvelope>;
  delete?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoehringerIngelheimCustomerAlignmentScalarWhereInput>>;
  disconnect?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  set?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>>;
  update?: Maybe<Array<BoehringerIngelheimCustomerAlignmentUpdateWithWhereUniqueWithoutInformPartnerCustomerInput>>;
  updateMany?: Maybe<Array<BoehringerIngelheimCustomerAlignmentUpdateManyWithWhereWithoutInformPartnerCustomerInput>>;
  upsert?: Maybe<Array<BoehringerIngelheimCustomerAlignmentUpsertWithWhereUniqueWithoutInformPartnerCustomerInput>>;
};

export type BoehringerIngelheimCustomerAlignmentUpdateWithWhereUniqueWithoutBoehringerIngelheimTerritoryInput = {
  data: BoehringerIngelheimCustomerAlignmentUpdateWithoutBoehringerIngelheimTerritoryInput;
  where: BoehringerIngelheimCustomerAlignmentWhereUniqueInput;
};

export type BoehringerIngelheimCustomerAlignmentUpdateWithWhereUniqueWithoutInformPartnerCustomerInput = {
  data: BoehringerIngelheimCustomerAlignmentUpdateWithoutInformPartnerCustomerInput;
  where: BoehringerIngelheimCustomerAlignmentWhereUniqueInput;
};

export type BoehringerIngelheimCustomerAlignmentUpdateWithoutBoehringerIngelheimTerritoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneRequiredWithoutBoehringerIngelheimCustomerAlignmentsNestedInput>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId?: Maybe<Scalars['Int']>;
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUpdateWithoutInformPartnerCustomerInput = {
  boehringerIngelheimTerritory?: Maybe<BoehringerIngelheimTerritoryUpdateOneRequiredWithoutBoehringerIngelheimCustomerAlignmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  soldToId?: Maybe<Scalars['Int']>;
  status?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  territoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimCustomerAlignmentUpsertWithWhereUniqueWithoutBoehringerIngelheimTerritoryInput = {
  create: BoehringerIngelheimCustomerAlignmentCreateWithoutBoehringerIngelheimTerritoryInput;
  update: BoehringerIngelheimCustomerAlignmentUpdateWithoutBoehringerIngelheimTerritoryInput;
  where: BoehringerIngelheimCustomerAlignmentWhereUniqueInput;
};

export type BoehringerIngelheimCustomerAlignmentUpsertWithWhereUniqueWithoutInformPartnerCustomerInput = {
  create: BoehringerIngelheimCustomerAlignmentCreateWithoutInformPartnerCustomerInput;
  update: BoehringerIngelheimCustomerAlignmentUpdateWithoutInformPartnerCustomerInput;
  where: BoehringerIngelheimCustomerAlignmentWhereUniqueInput;
};

export type BoehringerIngelheimCustomerAlignmentWhereInput = {
  AND?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereInput>>;
  NOT?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereInput>>;
  OR?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereInput>>;
  boehringerIngelheimTerritory?: Maybe<BoehringerIngelheimTerritoryScalarRelationFilter>;
  boehringerIngelheimTerritoryId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerScalarRelationFilter>;
  informPartnerCustomerId?: Maybe<StringFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  soldToId?: Maybe<IntFilter>;
  status?: Maybe<EnumBoehringerIngelheimCustomerAlignmentStatusFilter>;
  territoryName?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BoehringerIngelheimCustomerAlignmentWhereUniqueInput = {
  AND?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereInput>>;
  NOT?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereInput>>;
  OR?: Maybe<Array<BoehringerIngelheimCustomerAlignmentWhereInput>>;
  boehringerIngelheimTerritory?: Maybe<BoehringerIngelheimTerritoryScalarRelationFilter>;
  boehringerIngelheimTerritoryId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerScalarRelationFilter>;
  informPartnerCustomerId?: Maybe<StringFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  soldToId?: Maybe<IntFilter>;
  soldToId_territoryName?: Maybe<BoehringerIngelheimCustomerAlignmentSoldToIdTerritoryNameCompoundUniqueInput>;
  status?: Maybe<EnumBoehringerIngelheimCustomerAlignmentStatusFilter>;
  territoryName?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BoehringerIngelheimTerritory = {
  __typename?: 'BoehringerIngelheimTerritory';
  _count: BoehringerIngelheimTerritoryCountOutputType;
  boehringerIngelheimCustomerAlignments: Array<BoehringerIngelheimCustomerAlignment>;
  childTerritories: Array<BoehringerIngelheimTerritory>;
  countryCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartnerUsers: Array<InformPartnerUser>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritory>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type BoehringerIngelheimTerritoryBoehringerIngelheimCustomerAlignmentsArgs = {
  cursor?: Maybe<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoehringerIngelheimCustomerAlignmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoehringerIngelheimCustomerAlignmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoehringerIngelheimCustomerAlignmentWhereInput>;
};


export type BoehringerIngelheimTerritoryChildTerritoriesArgs = {
  cursor?: Maybe<BoehringerIngelheimTerritoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoehringerIngelheimTerritoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoehringerIngelheimTerritoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};


export type BoehringerIngelheimTerritoryInformPartnerUsersArgs = {
  cursor?: Maybe<InformPartnerUserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerUserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserWhereInput>;
};


export type BoehringerIngelheimTerritoryParentTerritoryArgs = {
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};

export type BoehringerIngelheimTerritoryCountAggregateOutputType = {
  __typename?: 'BoehringerIngelheimTerritoryCountAggregateOutputType';
  _all: Scalars['Int'];
  countryCode: Scalars['Int'];
  createdAt: Scalars['Int'];
  endDate: Scalars['Int'];
  enterpriseSegment: Scalars['Int'];
  id: Scalars['Int'];
  parentTerritoryId: Scalars['Int'];
  parentTerritoryName: Scalars['Int'];
  startDate: Scalars['Int'];
  territoryDescription: Scalars['Int'];
  territoryName: Scalars['Int'];
  territoryType: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type BoehringerIngelheimTerritoryCountOrderByAggregateInput = {
  countryCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  enterpriseSegment?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  parentTerritoryId?: Maybe<SortOrder>;
  parentTerritoryName?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  territoryDescription?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  territoryType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BoehringerIngelheimTerritoryCountOutputType = {
  __typename?: 'BoehringerIngelheimTerritoryCountOutputType';
  boehringerIngelheimCustomerAlignments: Scalars['Int'];
  childTerritories: Scalars['Int'];
  informPartnerUsers: Scalars['Int'];
};

export type BoehringerIngelheimTerritoryCreateInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutBoehringerIngelheimTerritoryInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryCreateNestedManyWithoutParentTerritoryInput>;
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutBoehringerIngelheimTerritoriesInput>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryCreateNestedOneWithoutChildTerritoriesInput>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryCreateManyInput = {
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryCreateManyParentTerritoryInput = {
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryCreateManyParentTerritoryInputEnvelope = {
  data: Array<BoehringerIngelheimTerritoryCreateManyParentTerritoryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BoehringerIngelheimTerritoryCreateNestedManyWithoutInformPartnerUsersInput = {
  connect?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimTerritoryCreateOrConnectWithoutInformPartnerUsersInput>>;
  create?: Maybe<Array<BoehringerIngelheimTerritoryCreateWithoutInformPartnerUsersInput>>;
};

export type BoehringerIngelheimTerritoryCreateNestedManyWithoutParentTerritoryInput = {
  connect?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimTerritoryCreateOrConnectWithoutParentTerritoryInput>>;
  create?: Maybe<Array<BoehringerIngelheimTerritoryCreateWithoutParentTerritoryInput>>;
  createMany?: Maybe<BoehringerIngelheimTerritoryCreateManyParentTerritoryInputEnvelope>;
};

export type BoehringerIngelheimTerritoryCreateNestedOneWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  connect?: Maybe<BoehringerIngelheimTerritoryWhereUniqueInput>;
  connectOrCreate?: Maybe<BoehringerIngelheimTerritoryCreateOrConnectWithoutBoehringerIngelheimCustomerAlignmentsInput>;
  create?: Maybe<BoehringerIngelheimTerritoryCreateWithoutBoehringerIngelheimCustomerAlignmentsInput>;
};

export type BoehringerIngelheimTerritoryCreateNestedOneWithoutChildTerritoriesInput = {
  connect?: Maybe<BoehringerIngelheimTerritoryWhereUniqueInput>;
  connectOrCreate?: Maybe<BoehringerIngelheimTerritoryCreateOrConnectWithoutChildTerritoriesInput>;
  create?: Maybe<BoehringerIngelheimTerritoryCreateWithoutChildTerritoriesInput>;
};

export type BoehringerIngelheimTerritoryCreateOrConnectWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  create: BoehringerIngelheimTerritoryCreateWithoutBoehringerIngelheimCustomerAlignmentsInput;
  where: BoehringerIngelheimTerritoryWhereUniqueInput;
};

export type BoehringerIngelheimTerritoryCreateOrConnectWithoutChildTerritoriesInput = {
  create: BoehringerIngelheimTerritoryCreateWithoutChildTerritoriesInput;
  where: BoehringerIngelheimTerritoryWhereUniqueInput;
};

export type BoehringerIngelheimTerritoryCreateOrConnectWithoutInformPartnerUsersInput = {
  create: BoehringerIngelheimTerritoryCreateWithoutInformPartnerUsersInput;
  where: BoehringerIngelheimTerritoryWhereUniqueInput;
};

export type BoehringerIngelheimTerritoryCreateOrConnectWithoutParentTerritoryInput = {
  create: BoehringerIngelheimTerritoryCreateWithoutParentTerritoryInput;
  where: BoehringerIngelheimTerritoryWhereUniqueInput;
};

export type BoehringerIngelheimTerritoryCreateWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  childTerritories?: Maybe<BoehringerIngelheimTerritoryCreateNestedManyWithoutParentTerritoryInput>;
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutBoehringerIngelheimTerritoriesInput>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryCreateNestedOneWithoutChildTerritoriesInput>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryCreateWithoutChildTerritoriesInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutBoehringerIngelheimTerritoryInput>;
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutBoehringerIngelheimTerritoriesInput>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryCreateNestedOneWithoutChildTerritoriesInput>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryCreateWithoutInformPartnerUsersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutBoehringerIngelheimTerritoryInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryCreateNestedManyWithoutParentTerritoryInput>;
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryCreateNestedOneWithoutChildTerritoriesInput>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryCreateWithoutParentTerritoryInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutBoehringerIngelheimTerritoryInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryCreateNestedManyWithoutParentTerritoryInput>;
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutBoehringerIngelheimTerritoriesInput>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryGroupByOutputType = {
  __typename?: 'BoehringerIngelheimTerritoryGroupByOutputType';
  _count?: Maybe<BoehringerIngelheimTerritoryCountAggregateOutputType>;
  _max?: Maybe<BoehringerIngelheimTerritoryMaxAggregateOutputType>;
  _min?: Maybe<BoehringerIngelheimTerritoryMinAggregateOutputType>;
  countryCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BoehringerIngelheimTerritoryListRelationFilter = {
  every?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
  none?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
  some?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};

export type BoehringerIngelheimTerritoryMaxAggregateOutputType = {
  __typename?: 'BoehringerIngelheimTerritoryMaxAggregateOutputType';
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryMaxOrderByAggregateInput = {
  countryCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  enterpriseSegment?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  parentTerritoryId?: Maybe<SortOrder>;
  parentTerritoryName?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  territoryDescription?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  territoryType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BoehringerIngelheimTerritoryMinAggregateOutputType = {
  __typename?: 'BoehringerIngelheimTerritoryMinAggregateOutputType';
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryMinOrderByAggregateInput = {
  countryCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  enterpriseSegment?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  parentTerritoryId?: Maybe<SortOrder>;
  parentTerritoryName?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  territoryDescription?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  territoryType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BoehringerIngelheimTerritoryNullableScalarRelationFilter = {
  AND?: Maybe<Array<BoehringerIngelheimTerritoryWhereInput>>;
  NOT?: Maybe<Array<BoehringerIngelheimTerritoryWhereInput>>;
  OR?: Maybe<Array<BoehringerIngelheimTerritoryWhereInput>>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentListRelationFilter>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryListRelationFilter>;
  countryCode?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endDate?: Maybe<DateTimeNullableFilter>;
  enterpriseSegment?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryNullableScalarRelationFilter>;
  parentTerritoryId?: Maybe<StringNullableFilter>;
  parentTerritoryName?: Maybe<StringNullableFilter>;
  startDate?: Maybe<DateTimeFilter>;
  territoryDescription?: Maybe<StringNullableFilter>;
  territoryName?: Maybe<StringFilter>;
  territoryType?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BoehringerIngelheimTerritoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BoehringerIngelheimTerritoryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BoehringerIngelheimTerritoryOrderByRelevanceInput>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentOrderByRelationAggregateInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryOrderByRelationAggregateInput>;
  countryCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  enterpriseSegment?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerUsers?: Maybe<InformPartnerUserOrderByRelationAggregateInput>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryOrderByWithRelationInput>;
  parentTerritoryId?: Maybe<SortOrder>;
  parentTerritoryName?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  territoryDescription?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  territoryType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BoehringerIngelheimTerritoryOrderByRelevanceFieldEnum {
  CountryCode = 'countryCode',
  EnterpriseSegment = 'enterpriseSegment',
  Id = 'id',
  ParentTerritoryId = 'parentTerritoryId',
  ParentTerritoryName = 'parentTerritoryName',
  TerritoryDescription = 'territoryDescription',
  TerritoryName = 'territoryName',
  TerritoryType = 'territoryType'
}

export type BoehringerIngelheimTerritoryOrderByRelevanceInput = {
  fields: Array<BoehringerIngelheimTerritoryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type BoehringerIngelheimTerritoryOrderByWithAggregationInput = {
  _count?: Maybe<BoehringerIngelheimTerritoryCountOrderByAggregateInput>;
  _max?: Maybe<BoehringerIngelheimTerritoryMaxOrderByAggregateInput>;
  _min?: Maybe<BoehringerIngelheimTerritoryMinOrderByAggregateInput>;
  countryCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  enterpriseSegment?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  parentTerritoryId?: Maybe<SortOrder>;
  parentTerritoryName?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  territoryDescription?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  territoryType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BoehringerIngelheimTerritoryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BoehringerIngelheimTerritoryOrderByRelevanceInput>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentOrderByRelationAggregateInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryOrderByRelationAggregateInput>;
  countryCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  enterpriseSegment?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerUsers?: Maybe<InformPartnerUserOrderByRelationAggregateInput>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryOrderByWithRelationInput>;
  parentTerritoryId?: Maybe<SortOrder>;
  parentTerritoryName?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  territoryDescription?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  territoryType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BoehringerIngelheimTerritoryOrderByWithRelationInput = {
  _relevance?: Maybe<BoehringerIngelheimTerritoryOrderByRelevanceInput>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentOrderByRelationAggregateInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryOrderByRelationAggregateInput>;
  countryCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  enterpriseSegment?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerUsers?: Maybe<InformPartnerUserOrderByRelationAggregateInput>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryOrderByWithRelationInput>;
  parentTerritoryId?: Maybe<SortOrder>;
  parentTerritoryName?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  territoryDescription?: Maybe<SortOrder>;
  territoryName?: Maybe<SortOrder>;
  territoryType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BoehringerIngelheimTerritoryScalarFieldEnum {
  CountryCode = 'countryCode',
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  EnterpriseSegment = 'enterpriseSegment',
  Id = 'id',
  ParentTerritoryId = 'parentTerritoryId',
  ParentTerritoryName = 'parentTerritoryName',
  StartDate = 'startDate',
  TerritoryDescription = 'territoryDescription',
  TerritoryName = 'territoryName',
  TerritoryType = 'territoryType',
  UpdatedAt = 'updatedAt'
}

export type BoehringerIngelheimTerritoryScalarRelationFilter = {
  AND?: Maybe<Array<BoehringerIngelheimTerritoryWhereInput>>;
  NOT?: Maybe<Array<BoehringerIngelheimTerritoryWhereInput>>;
  OR?: Maybe<Array<BoehringerIngelheimTerritoryWhereInput>>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentListRelationFilter>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryListRelationFilter>;
  countryCode?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endDate?: Maybe<DateTimeNullableFilter>;
  enterpriseSegment?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryNullableScalarRelationFilter>;
  parentTerritoryId?: Maybe<StringNullableFilter>;
  parentTerritoryName?: Maybe<StringNullableFilter>;
  startDate?: Maybe<DateTimeFilter>;
  territoryDescription?: Maybe<StringNullableFilter>;
  territoryName?: Maybe<StringFilter>;
  territoryType?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BoehringerIngelheimTerritoryScalarWhereInput = {
  AND?: Maybe<Array<BoehringerIngelheimTerritoryScalarWhereInput>>;
  NOT?: Maybe<Array<BoehringerIngelheimTerritoryScalarWhereInput>>;
  OR?: Maybe<Array<BoehringerIngelheimTerritoryScalarWhereInput>>;
  countryCode?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endDate?: Maybe<DateTimeNullableFilter>;
  enterpriseSegment?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  parentTerritoryId?: Maybe<StringNullableFilter>;
  parentTerritoryName?: Maybe<StringNullableFilter>;
  startDate?: Maybe<DateTimeFilter>;
  territoryDescription?: Maybe<StringNullableFilter>;
  territoryName?: Maybe<StringFilter>;
  territoryType?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BoehringerIngelheimTerritoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BoehringerIngelheimTerritoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<BoehringerIngelheimTerritoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BoehringerIngelheimTerritoryScalarWhereWithAggregatesInput>>;
  countryCode?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  endDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  enterpriseSegment?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  parentTerritoryId?: Maybe<StringNullableWithAggregatesFilter>;
  parentTerritoryName?: Maybe<StringNullableWithAggregatesFilter>;
  startDate?: Maybe<DateTimeWithAggregatesFilter>;
  territoryDescription?: Maybe<StringNullableWithAggregatesFilter>;
  territoryName?: Maybe<StringWithAggregatesFilter>;
  territoryType?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type BoehringerIngelheimTerritoryUncheckedCreateInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutBoehringerIngelheimTerritoryInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutParentTerritoryInput>;
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutBoehringerIngelheimTerritoriesInput>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutInformPartnerUsersInput = {
  connect?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimTerritoryCreateOrConnectWithoutInformPartnerUsersInput>>;
  create?: Maybe<Array<BoehringerIngelheimTerritoryCreateWithoutInformPartnerUsersInput>>;
};

export type BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutParentTerritoryInput = {
  connect?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimTerritoryCreateOrConnectWithoutParentTerritoryInput>>;
  create?: Maybe<Array<BoehringerIngelheimTerritoryCreateWithoutParentTerritoryInput>>;
  createMany?: Maybe<BoehringerIngelheimTerritoryCreateManyParentTerritoryInputEnvelope>;
};

export type BoehringerIngelheimTerritoryUncheckedCreateWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  childTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutParentTerritoryInput>;
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutBoehringerIngelheimTerritoriesInput>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUncheckedCreateWithoutChildTerritoriesInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutBoehringerIngelheimTerritoryInput>;
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutBoehringerIngelheimTerritoriesInput>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUncheckedCreateWithoutInformPartnerUsersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutBoehringerIngelheimTerritoryInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutParentTerritoryInput>;
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUncheckedCreateWithoutParentTerritoryInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutBoehringerIngelheimTerritoryInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutParentTerritoryInput>;
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutBoehringerIngelheimTerritoriesInput>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUncheckedUpdateInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutBoehringerIngelheimTerritoryNestedInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutParentTerritoryNestedInput>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutBoehringerIngelheimTerritoriesNestedInput>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUncheckedUpdateManyInput = {
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutInformPartnerUsersInput = {
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutInformPartnerUsersNestedInput = {
  connect?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimTerritoryCreateOrConnectWithoutInformPartnerUsersInput>>;
  create?: Maybe<Array<BoehringerIngelheimTerritoryCreateWithoutInformPartnerUsersInput>>;
  delete?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoehringerIngelheimTerritoryScalarWhereInput>>;
  disconnect?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  set?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  update?: Maybe<Array<BoehringerIngelheimTerritoryUpdateWithWhereUniqueWithoutInformPartnerUsersInput>>;
  updateMany?: Maybe<Array<BoehringerIngelheimTerritoryUpdateManyWithWhereWithoutInformPartnerUsersInput>>;
  upsert?: Maybe<Array<BoehringerIngelheimTerritoryUpsertWithWhereUniqueWithoutInformPartnerUsersInput>>;
};

export type BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutParentTerritoryInput = {
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutParentTerritoryNestedInput = {
  connect?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimTerritoryCreateOrConnectWithoutParentTerritoryInput>>;
  create?: Maybe<Array<BoehringerIngelheimTerritoryCreateWithoutParentTerritoryInput>>;
  createMany?: Maybe<BoehringerIngelheimTerritoryCreateManyParentTerritoryInputEnvelope>;
  delete?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoehringerIngelheimTerritoryScalarWhereInput>>;
  disconnect?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  set?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  update?: Maybe<Array<BoehringerIngelheimTerritoryUpdateWithWhereUniqueWithoutParentTerritoryInput>>;
  updateMany?: Maybe<Array<BoehringerIngelheimTerritoryUpdateManyWithWhereWithoutParentTerritoryInput>>;
  upsert?: Maybe<Array<BoehringerIngelheimTerritoryUpsertWithWhereUniqueWithoutParentTerritoryInput>>;
};

export type BoehringerIngelheimTerritoryUncheckedUpdateWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  childTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutParentTerritoryNestedInput>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutBoehringerIngelheimTerritoriesNestedInput>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUncheckedUpdateWithoutChildTerritoriesInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutBoehringerIngelheimTerritoryNestedInput>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutBoehringerIngelheimTerritoriesNestedInput>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUncheckedUpdateWithoutInformPartnerUsersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutBoehringerIngelheimTerritoryNestedInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutParentTerritoryNestedInput>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUncheckedUpdateWithoutParentTerritoryInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutBoehringerIngelheimTerritoryNestedInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutParentTerritoryNestedInput>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutBoehringerIngelheimTerritoriesNestedInput>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUpdateInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutBoehringerIngelheimTerritoryNestedInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryUpdateManyWithoutParentTerritoryNestedInput>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutBoehringerIngelheimTerritoriesNestedInput>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryUpdateOneWithoutChildTerritoriesNestedInput>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUpdateManyMutationInput = {
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUpdateManyWithWhereWithoutInformPartnerUsersInput = {
  data: BoehringerIngelheimTerritoryUpdateManyMutationInput;
  where: BoehringerIngelheimTerritoryScalarWhereInput;
};

export type BoehringerIngelheimTerritoryUpdateManyWithWhereWithoutParentTerritoryInput = {
  data: BoehringerIngelheimTerritoryUpdateManyMutationInput;
  where: BoehringerIngelheimTerritoryScalarWhereInput;
};

export type BoehringerIngelheimTerritoryUpdateManyWithoutInformPartnerUsersNestedInput = {
  connect?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimTerritoryCreateOrConnectWithoutInformPartnerUsersInput>>;
  create?: Maybe<Array<BoehringerIngelheimTerritoryCreateWithoutInformPartnerUsersInput>>;
  delete?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoehringerIngelheimTerritoryScalarWhereInput>>;
  disconnect?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  set?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  update?: Maybe<Array<BoehringerIngelheimTerritoryUpdateWithWhereUniqueWithoutInformPartnerUsersInput>>;
  updateMany?: Maybe<Array<BoehringerIngelheimTerritoryUpdateManyWithWhereWithoutInformPartnerUsersInput>>;
  upsert?: Maybe<Array<BoehringerIngelheimTerritoryUpsertWithWhereUniqueWithoutInformPartnerUsersInput>>;
};

export type BoehringerIngelheimTerritoryUpdateManyWithoutParentTerritoryNestedInput = {
  connect?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BoehringerIngelheimTerritoryCreateOrConnectWithoutParentTerritoryInput>>;
  create?: Maybe<Array<BoehringerIngelheimTerritoryCreateWithoutParentTerritoryInput>>;
  createMany?: Maybe<BoehringerIngelheimTerritoryCreateManyParentTerritoryInputEnvelope>;
  delete?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BoehringerIngelheimTerritoryScalarWhereInput>>;
  disconnect?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  set?: Maybe<Array<BoehringerIngelheimTerritoryWhereUniqueInput>>;
  update?: Maybe<Array<BoehringerIngelheimTerritoryUpdateWithWhereUniqueWithoutParentTerritoryInput>>;
  updateMany?: Maybe<Array<BoehringerIngelheimTerritoryUpdateManyWithWhereWithoutParentTerritoryInput>>;
  upsert?: Maybe<Array<BoehringerIngelheimTerritoryUpsertWithWhereUniqueWithoutParentTerritoryInput>>;
};

export type BoehringerIngelheimTerritoryUpdateOneRequiredWithoutBoehringerIngelheimCustomerAlignmentsNestedInput = {
  connect?: Maybe<BoehringerIngelheimTerritoryWhereUniqueInput>;
  connectOrCreate?: Maybe<BoehringerIngelheimTerritoryCreateOrConnectWithoutBoehringerIngelheimCustomerAlignmentsInput>;
  create?: Maybe<BoehringerIngelheimTerritoryCreateWithoutBoehringerIngelheimCustomerAlignmentsInput>;
  update?: Maybe<BoehringerIngelheimTerritoryUpdateToOneWithWhereWithoutBoehringerIngelheimCustomerAlignmentsInput>;
  upsert?: Maybe<BoehringerIngelheimTerritoryUpsertWithoutBoehringerIngelheimCustomerAlignmentsInput>;
};

export type BoehringerIngelheimTerritoryUpdateOneWithoutChildTerritoriesNestedInput = {
  connect?: Maybe<BoehringerIngelheimTerritoryWhereUniqueInput>;
  connectOrCreate?: Maybe<BoehringerIngelheimTerritoryCreateOrConnectWithoutChildTerritoriesInput>;
  create?: Maybe<BoehringerIngelheimTerritoryCreateWithoutChildTerritoriesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<BoehringerIngelheimTerritoryUpdateToOneWithWhereWithoutChildTerritoriesInput>;
  upsert?: Maybe<BoehringerIngelheimTerritoryUpsertWithoutChildTerritoriesInput>;
};

export type BoehringerIngelheimTerritoryUpdateToOneWithWhereWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  data: BoehringerIngelheimTerritoryUpdateWithoutBoehringerIngelheimCustomerAlignmentsInput;
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};

export type BoehringerIngelheimTerritoryUpdateToOneWithWhereWithoutChildTerritoriesInput = {
  data: BoehringerIngelheimTerritoryUpdateWithoutChildTerritoriesInput;
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};

export type BoehringerIngelheimTerritoryUpdateWithWhereUniqueWithoutInformPartnerUsersInput = {
  data: BoehringerIngelheimTerritoryUpdateWithoutInformPartnerUsersInput;
  where: BoehringerIngelheimTerritoryWhereUniqueInput;
};

export type BoehringerIngelheimTerritoryUpdateWithWhereUniqueWithoutParentTerritoryInput = {
  data: BoehringerIngelheimTerritoryUpdateWithoutParentTerritoryInput;
  where: BoehringerIngelheimTerritoryWhereUniqueInput;
};

export type BoehringerIngelheimTerritoryUpdateWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  childTerritories?: Maybe<BoehringerIngelheimTerritoryUpdateManyWithoutParentTerritoryNestedInput>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutBoehringerIngelheimTerritoriesNestedInput>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryUpdateOneWithoutChildTerritoriesNestedInput>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUpdateWithoutChildTerritoriesInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutBoehringerIngelheimTerritoryNestedInput>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutBoehringerIngelheimTerritoriesNestedInput>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryUpdateOneWithoutChildTerritoriesNestedInput>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUpdateWithoutInformPartnerUsersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutBoehringerIngelheimTerritoryNestedInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryUpdateManyWithoutParentTerritoryNestedInput>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryUpdateOneWithoutChildTerritoriesNestedInput>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUpdateWithoutParentTerritoryInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutBoehringerIngelheimTerritoryNestedInput>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryUpdateManyWithoutParentTerritoryNestedInput>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutBoehringerIngelheimTerritoriesNestedInput>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoehringerIngelheimTerritoryUpsertWithWhereUniqueWithoutInformPartnerUsersInput = {
  create: BoehringerIngelheimTerritoryCreateWithoutInformPartnerUsersInput;
  update: BoehringerIngelheimTerritoryUpdateWithoutInformPartnerUsersInput;
  where: BoehringerIngelheimTerritoryWhereUniqueInput;
};

export type BoehringerIngelheimTerritoryUpsertWithWhereUniqueWithoutParentTerritoryInput = {
  create: BoehringerIngelheimTerritoryCreateWithoutParentTerritoryInput;
  update: BoehringerIngelheimTerritoryUpdateWithoutParentTerritoryInput;
  where: BoehringerIngelheimTerritoryWhereUniqueInput;
};

export type BoehringerIngelheimTerritoryUpsertWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  create: BoehringerIngelheimTerritoryCreateWithoutBoehringerIngelheimCustomerAlignmentsInput;
  update: BoehringerIngelheimTerritoryUpdateWithoutBoehringerIngelheimCustomerAlignmentsInput;
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};

export type BoehringerIngelheimTerritoryUpsertWithoutChildTerritoriesInput = {
  create: BoehringerIngelheimTerritoryCreateWithoutChildTerritoriesInput;
  update: BoehringerIngelheimTerritoryUpdateWithoutChildTerritoriesInput;
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};

export type BoehringerIngelheimTerritoryWhereInput = {
  AND?: Maybe<Array<BoehringerIngelheimTerritoryWhereInput>>;
  NOT?: Maybe<Array<BoehringerIngelheimTerritoryWhereInput>>;
  OR?: Maybe<Array<BoehringerIngelheimTerritoryWhereInput>>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentListRelationFilter>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryListRelationFilter>;
  countryCode?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endDate?: Maybe<DateTimeNullableFilter>;
  enterpriseSegment?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryNullableScalarRelationFilter>;
  parentTerritoryId?: Maybe<StringNullableFilter>;
  parentTerritoryName?: Maybe<StringNullableFilter>;
  startDate?: Maybe<DateTimeFilter>;
  territoryDescription?: Maybe<StringNullableFilter>;
  territoryName?: Maybe<StringFilter>;
  territoryType?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BoehringerIngelheimTerritoryWhereUniqueInput = {
  AND?: Maybe<Array<BoehringerIngelheimTerritoryWhereInput>>;
  NOT?: Maybe<Array<BoehringerIngelheimTerritoryWhereInput>>;
  OR?: Maybe<Array<BoehringerIngelheimTerritoryWhereInput>>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentListRelationFilter>;
  childTerritories?: Maybe<BoehringerIngelheimTerritoryListRelationFilter>;
  countryCode?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endDate?: Maybe<DateTimeNullableFilter>;
  enterpriseSegment?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  parentTerritory?: Maybe<BoehringerIngelheimTerritoryNullableScalarRelationFilter>;
  parentTerritoryId?: Maybe<StringNullableFilter>;
  parentTerritoryName?: Maybe<StringNullableFilter>;
  startDate?: Maybe<DateTimeFilter>;
  territoryDescription?: Maybe<StringNullableFilter>;
  territoryName?: Maybe<Scalars['String']>;
  territoryType?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedBoolNullableFilter>;
  _min?: Maybe<NestedBoolNullableFilter>;
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolNullableWithAggregatesFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedBoolFilter>;
  _min?: Maybe<NestedBoolFilter>;
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolWithAggregatesFilter>;
};

export type Breed = {
  __typename?: 'Breed';
  _count: BreedCountOutputType;
  bedrockInference?: Maybe<BedrockInference>;
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreed?: Maybe<CanonicalBreed>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pets: Array<ClinicPet>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<Species>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type BreedBedrockInferenceArgs = {
  where?: Maybe<BedrockInferenceWhereInput>;
};


export type BreedCanonicalBreedArgs = {
  where?: Maybe<CanonicalBreedWhereInput>;
};


export type BreedPetsArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type BreedSpeciesArgs = {
  where?: Maybe<SpeciesWhereInput>;
};

export type BreedCountAggregateOutputType = {
  __typename?: 'BreedCountAggregateOutputType';
  _all: Scalars['Int'];
  bedrockInferenceId: Scalars['Int'];
  canonicalBreedId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  name: Scalars['Int'];
  normalizedName: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  speciesId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type BreedCountOrderByAggregateInput = {
  bedrockInferenceId?: Maybe<SortOrder>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  normalizedName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BreedCountOutputType = {
  __typename?: 'BreedCountOutputType';
  pets: Scalars['Int'];
};

export type BreedCreateInput = {
  bedrockInference?: Maybe<BedrockInferenceCreateNestedOneWithoutBreedsInput>;
  canonicalBreed?: Maybe<CanonicalBreedCreateNestedOneWithoutBreedGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBreedsInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutBreedModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesCreateNestedOneWithoutBreedsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedCreateManyBedrockInferenceInput = {
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedCreateManyBedrockInferenceInputEnvelope = {
  data: Array<BreedCreateManyBedrockInferenceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BreedCreateManyCanonicalBreedInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedCreateManyCanonicalBreedInputEnvelope = {
  data: Array<BreedCreateManyCanonicalBreedInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BreedCreateManyInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedCreateManyIntegrationInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedCreateManyIntegrationInputEnvelope = {
  data: Array<BreedCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BreedCreateManySpeciesInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedCreateManySpeciesInputEnvelope = {
  data: Array<BreedCreateManySpeciesInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BreedCreateNestedManyWithoutBedrockInferenceInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutBedrockInferenceInput>>;
  create?: Maybe<Array<BreedCreateWithoutBedrockInferenceInput>>;
  createMany?: Maybe<BreedCreateManyBedrockInferenceInputEnvelope>;
};

export type BreedCreateNestedManyWithoutCanonicalBreedInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutCanonicalBreedInput>>;
  create?: Maybe<Array<BreedCreateWithoutCanonicalBreedInput>>;
  createMany?: Maybe<BreedCreateManyCanonicalBreedInputEnvelope>;
};

export type BreedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<BreedCreateWithoutIntegrationInput>>;
  createMany?: Maybe<BreedCreateManyIntegrationInputEnvelope>;
};

export type BreedCreateNestedManyWithoutSpeciesInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutSpeciesInput>>;
  create?: Maybe<Array<BreedCreateWithoutSpeciesInput>>;
  createMany?: Maybe<BreedCreateManySpeciesInputEnvelope>;
};

export type BreedCreateNestedOneWithoutPetsInput = {
  connect?: Maybe<BreedWhereUniqueInput>;
  connectOrCreate?: Maybe<BreedCreateOrConnectWithoutPetsInput>;
  create?: Maybe<BreedCreateWithoutPetsInput>;
};

export type BreedCreateOrConnectWithoutBedrockInferenceInput = {
  create: BreedCreateWithoutBedrockInferenceInput;
  where: BreedWhereUniqueInput;
};

export type BreedCreateOrConnectWithoutCanonicalBreedInput = {
  create: BreedCreateWithoutCanonicalBreedInput;
  where: BreedWhereUniqueInput;
};

export type BreedCreateOrConnectWithoutIntegrationInput = {
  create: BreedCreateWithoutIntegrationInput;
  where: BreedWhereUniqueInput;
};

export type BreedCreateOrConnectWithoutPetsInput = {
  create: BreedCreateWithoutPetsInput;
  where: BreedWhereUniqueInput;
};

export type BreedCreateOrConnectWithoutSpeciesInput = {
  create: BreedCreateWithoutSpeciesInput;
  where: BreedWhereUniqueInput;
};

export type BreedCreateWithoutBedrockInferenceInput = {
  canonicalBreed?: Maybe<CanonicalBreedCreateNestedOneWithoutBreedGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBreedsInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutBreedModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesCreateNestedOneWithoutBreedsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedCreateWithoutCanonicalBreedInput = {
  bedrockInference?: Maybe<BedrockInferenceCreateNestedOneWithoutBreedsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBreedsInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutBreedModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesCreateNestedOneWithoutBreedsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedCreateWithoutIntegrationInput = {
  bedrockInference?: Maybe<BedrockInferenceCreateNestedOneWithoutBreedsInput>;
  canonicalBreed?: Maybe<CanonicalBreedCreateNestedOneWithoutBreedGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutBreedModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesCreateNestedOneWithoutBreedsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedCreateWithoutPetsInput = {
  bedrockInference?: Maybe<BedrockInferenceCreateNestedOneWithoutBreedsInput>;
  canonicalBreed?: Maybe<CanonicalBreedCreateNestedOneWithoutBreedGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBreedsInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesCreateNestedOneWithoutBreedsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedCreateWithoutSpeciesInput = {
  bedrockInference?: Maybe<BedrockInferenceCreateNestedOneWithoutBreedsInput>;
  canonicalBreed?: Maybe<CanonicalBreedCreateNestedOneWithoutBreedGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutBreedsInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutBreedModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedGroupByOutputType = {
  __typename?: 'BreedGroupByOutputType';
  _count?: Maybe<BreedCountAggregateOutputType>;
  _max?: Maybe<BreedMaxAggregateOutputType>;
  _min?: Maybe<BreedMinAggregateOutputType>;
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type BreedIntegrationIdPimsIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type BreedListRelationFilter = {
  every?: Maybe<BreedWhereInput>;
  none?: Maybe<BreedWhereInput>;
  some?: Maybe<BreedWhereInput>;
};

export type BreedMaxAggregateOutputType = {
  __typename?: 'BreedMaxAggregateOutputType';
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedMaxOrderByAggregateInput = {
  bedrockInferenceId?: Maybe<SortOrder>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BreedMinAggregateOutputType = {
  __typename?: 'BreedMinAggregateOutputType';
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedMinOrderByAggregateInput = {
  bedrockInferenceId?: Maybe<SortOrder>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BreedNullableScalarRelationFilter = {
  AND?: Maybe<Array<BreedWhereInput>>;
  NOT?: Maybe<Array<BreedWhereInput>>;
  OR?: Maybe<Array<BreedWhereInput>>;
  bedrockInference?: Maybe<BedrockInferenceNullableScalarRelationFilter>;
  bedrockInferenceId?: Maybe<StringNullableFilter>;
  canonicalBreed?: Maybe<CanonicalBreedNullableScalarRelationFilter>;
  canonicalBreedId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  normalizedName?: Maybe<JsonNullableFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  species?: Maybe<SpeciesNullableScalarRelationFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BreedOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BreedOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BreedOrderByRelevanceInput>;
  bedrockInference?: Maybe<BedrockInferenceOrderByWithRelationInput>;
  bedrockInferenceId?: Maybe<SortOrder>;
  canonicalBreed?: Maybe<CanonicalBreedOrderByWithRelationInput>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  normalizedName?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  species?: Maybe<SpeciesOrderByWithRelationInput>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BreedOrderByRelevanceFieldEnum {
  BedrockInferenceId = 'bedrockInferenceId',
  CanonicalBreedId = 'canonicalBreedId',
  Description = 'description',
  Id = 'id',
  IntegrationId = 'integrationId',
  Name = 'name',
  PimsId = 'pimsId',
  SpeciesId = 'speciesId'
}

export type BreedOrderByRelevanceInput = {
  fields: Array<BreedOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type BreedOrderByWithAggregationInput = {
  _count?: Maybe<BreedCountOrderByAggregateInput>;
  _max?: Maybe<BreedMaxOrderByAggregateInput>;
  _min?: Maybe<BreedMinOrderByAggregateInput>;
  bedrockInferenceId?: Maybe<SortOrder>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  normalizedName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BreedOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<BreedOrderByRelevanceInput>;
  bedrockInference?: Maybe<BedrockInferenceOrderByWithRelationInput>;
  bedrockInferenceId?: Maybe<SortOrder>;
  canonicalBreed?: Maybe<CanonicalBreedOrderByWithRelationInput>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  normalizedName?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  species?: Maybe<SpeciesOrderByWithRelationInput>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BreedOrderByWithRelationInput = {
  _relevance?: Maybe<BreedOrderByRelevanceInput>;
  bedrockInference?: Maybe<BedrockInferenceOrderByWithRelationInput>;
  bedrockInferenceId?: Maybe<SortOrder>;
  canonicalBreed?: Maybe<CanonicalBreedOrderByWithRelationInput>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  normalizedName?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  species?: Maybe<SpeciesOrderByWithRelationInput>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum BreedScalarFieldEnum {
  BedrockInferenceId = 'bedrockInferenceId',
  CanonicalBreedId = 'canonicalBreedId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Name = 'name',
  NormalizedName = 'normalizedName',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  SpeciesId = 'speciesId',
  UpdatedAt = 'updatedAt'
}

export type BreedScalarWhereInput = {
  AND?: Maybe<Array<BreedScalarWhereInput>>;
  NOT?: Maybe<Array<BreedScalarWhereInput>>;
  OR?: Maybe<Array<BreedScalarWhereInput>>;
  bedrockInferenceId?: Maybe<StringNullableFilter>;
  canonicalBreedId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  normalizedName?: Maybe<JsonNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BreedScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BreedScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<BreedScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BreedScalarWhereWithAggregatesInput>>;
  bedrockInferenceId?: Maybe<StringNullableWithAggregatesFilter>;
  canonicalBreedId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  normalizedName?: Maybe<JsonNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  speciesId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type BreedUncheckedCreateInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutBreedModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedCreateNestedManyWithoutBedrockInferenceInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutBedrockInferenceInput>>;
  create?: Maybe<Array<BreedCreateWithoutBedrockInferenceInput>>;
  createMany?: Maybe<BreedCreateManyBedrockInferenceInputEnvelope>;
};

export type BreedUncheckedCreateNestedManyWithoutCanonicalBreedInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutCanonicalBreedInput>>;
  create?: Maybe<Array<BreedCreateWithoutCanonicalBreedInput>>;
  createMany?: Maybe<BreedCreateManyCanonicalBreedInputEnvelope>;
};

export type BreedUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<BreedCreateWithoutIntegrationInput>>;
  createMany?: Maybe<BreedCreateManyIntegrationInputEnvelope>;
};

export type BreedUncheckedCreateNestedManyWithoutSpeciesInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutSpeciesInput>>;
  create?: Maybe<Array<BreedCreateWithoutSpeciesInput>>;
  createMany?: Maybe<BreedCreateManySpeciesInputEnvelope>;
};

export type BreedUncheckedCreateWithoutBedrockInferenceInput = {
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutBreedModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedCreateWithoutCanonicalBreedInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutBreedModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedCreateWithoutIntegrationInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutBreedModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedCreateWithoutPetsInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedCreateWithoutSpeciesInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutBreedModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedUpdateInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutBreedModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedUpdateManyInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedUpdateManyWithoutBedrockInferenceInput = {
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedUpdateManyWithoutBedrockInferenceNestedInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutBedrockInferenceInput>>;
  create?: Maybe<Array<BreedCreateWithoutBedrockInferenceInput>>;
  createMany?: Maybe<BreedCreateManyBedrockInferenceInputEnvelope>;
  delete?: Maybe<Array<BreedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BreedScalarWhereInput>>;
  disconnect?: Maybe<Array<BreedWhereUniqueInput>>;
  set?: Maybe<Array<BreedWhereUniqueInput>>;
  update?: Maybe<Array<BreedUpdateWithWhereUniqueWithoutBedrockInferenceInput>>;
  updateMany?: Maybe<Array<BreedUpdateManyWithWhereWithoutBedrockInferenceInput>>;
  upsert?: Maybe<Array<BreedUpsertWithWhereUniqueWithoutBedrockInferenceInput>>;
};

export type BreedUncheckedUpdateManyWithoutCanonicalBreedInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedUpdateManyWithoutCanonicalBreedNestedInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutCanonicalBreedInput>>;
  create?: Maybe<Array<BreedCreateWithoutCanonicalBreedInput>>;
  createMany?: Maybe<BreedCreateManyCanonicalBreedInputEnvelope>;
  delete?: Maybe<Array<BreedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BreedScalarWhereInput>>;
  disconnect?: Maybe<Array<BreedWhereUniqueInput>>;
  set?: Maybe<Array<BreedWhereUniqueInput>>;
  update?: Maybe<Array<BreedUpdateWithWhereUniqueWithoutCanonicalBreedInput>>;
  updateMany?: Maybe<Array<BreedUpdateManyWithWhereWithoutCanonicalBreedInput>>;
  upsert?: Maybe<Array<BreedUpsertWithWhereUniqueWithoutCanonicalBreedInput>>;
};

export type BreedUncheckedUpdateManyWithoutIntegrationInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<BreedCreateWithoutIntegrationInput>>;
  createMany?: Maybe<BreedCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<BreedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BreedScalarWhereInput>>;
  disconnect?: Maybe<Array<BreedWhereUniqueInput>>;
  set?: Maybe<Array<BreedWhereUniqueInput>>;
  update?: Maybe<Array<BreedUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<BreedUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<BreedUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type BreedUncheckedUpdateManyWithoutSpeciesInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedUpdateManyWithoutSpeciesNestedInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutSpeciesInput>>;
  create?: Maybe<Array<BreedCreateWithoutSpeciesInput>>;
  createMany?: Maybe<BreedCreateManySpeciesInputEnvelope>;
  delete?: Maybe<Array<BreedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BreedScalarWhereInput>>;
  disconnect?: Maybe<Array<BreedWhereUniqueInput>>;
  set?: Maybe<Array<BreedWhereUniqueInput>>;
  update?: Maybe<Array<BreedUpdateWithWhereUniqueWithoutSpeciesInput>>;
  updateMany?: Maybe<Array<BreedUpdateManyWithWhereWithoutSpeciesInput>>;
  upsert?: Maybe<Array<BreedUpsertWithWhereUniqueWithoutSpeciesInput>>;
};

export type BreedUncheckedUpdateWithoutBedrockInferenceInput = {
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutBreedModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedUpdateWithoutCanonicalBreedInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutBreedModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedUpdateWithoutIntegrationInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutBreedModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedUpdateWithoutPetsInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUncheckedUpdateWithoutSpeciesInput = {
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutBreedModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUpdateInput = {
  bedrockInference?: Maybe<BedrockInferenceUpdateOneWithoutBreedsNestedInput>;
  canonicalBreed?: Maybe<CanonicalBreedUpdateOneWithoutBreedGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBreedsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutBreedModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesUpdateOneWithoutBreedsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUpdateManyWithWhereWithoutBedrockInferenceInput = {
  data: BreedUpdateManyMutationInput;
  where: BreedScalarWhereInput;
};

export type BreedUpdateManyWithWhereWithoutCanonicalBreedInput = {
  data: BreedUpdateManyMutationInput;
  where: BreedScalarWhereInput;
};

export type BreedUpdateManyWithWhereWithoutIntegrationInput = {
  data: BreedUpdateManyMutationInput;
  where: BreedScalarWhereInput;
};

export type BreedUpdateManyWithWhereWithoutSpeciesInput = {
  data: BreedUpdateManyMutationInput;
  where: BreedScalarWhereInput;
};

export type BreedUpdateManyWithoutBedrockInferenceNestedInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutBedrockInferenceInput>>;
  create?: Maybe<Array<BreedCreateWithoutBedrockInferenceInput>>;
  createMany?: Maybe<BreedCreateManyBedrockInferenceInputEnvelope>;
  delete?: Maybe<Array<BreedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BreedScalarWhereInput>>;
  disconnect?: Maybe<Array<BreedWhereUniqueInput>>;
  set?: Maybe<Array<BreedWhereUniqueInput>>;
  update?: Maybe<Array<BreedUpdateWithWhereUniqueWithoutBedrockInferenceInput>>;
  updateMany?: Maybe<Array<BreedUpdateManyWithWhereWithoutBedrockInferenceInput>>;
  upsert?: Maybe<Array<BreedUpsertWithWhereUniqueWithoutBedrockInferenceInput>>;
};

export type BreedUpdateManyWithoutCanonicalBreedNestedInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutCanonicalBreedInput>>;
  create?: Maybe<Array<BreedCreateWithoutCanonicalBreedInput>>;
  createMany?: Maybe<BreedCreateManyCanonicalBreedInputEnvelope>;
  delete?: Maybe<Array<BreedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BreedScalarWhereInput>>;
  disconnect?: Maybe<Array<BreedWhereUniqueInput>>;
  set?: Maybe<Array<BreedWhereUniqueInput>>;
  update?: Maybe<Array<BreedUpdateWithWhereUniqueWithoutCanonicalBreedInput>>;
  updateMany?: Maybe<Array<BreedUpdateManyWithWhereWithoutCanonicalBreedInput>>;
  upsert?: Maybe<Array<BreedUpsertWithWhereUniqueWithoutCanonicalBreedInput>>;
};

export type BreedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<BreedCreateWithoutIntegrationInput>>;
  createMany?: Maybe<BreedCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<BreedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BreedScalarWhereInput>>;
  disconnect?: Maybe<Array<BreedWhereUniqueInput>>;
  set?: Maybe<Array<BreedWhereUniqueInput>>;
  update?: Maybe<Array<BreedUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<BreedUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<BreedUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type BreedUpdateManyWithoutSpeciesNestedInput = {
  connect?: Maybe<Array<BreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BreedCreateOrConnectWithoutSpeciesInput>>;
  create?: Maybe<Array<BreedCreateWithoutSpeciesInput>>;
  createMany?: Maybe<BreedCreateManySpeciesInputEnvelope>;
  delete?: Maybe<Array<BreedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BreedScalarWhereInput>>;
  disconnect?: Maybe<Array<BreedWhereUniqueInput>>;
  set?: Maybe<Array<BreedWhereUniqueInput>>;
  update?: Maybe<Array<BreedUpdateWithWhereUniqueWithoutSpeciesInput>>;
  updateMany?: Maybe<Array<BreedUpdateManyWithWhereWithoutSpeciesInput>>;
  upsert?: Maybe<Array<BreedUpsertWithWhereUniqueWithoutSpeciesInput>>;
};

export type BreedUpdateOneWithoutPetsNestedInput = {
  connect?: Maybe<BreedWhereUniqueInput>;
  connectOrCreate?: Maybe<BreedCreateOrConnectWithoutPetsInput>;
  create?: Maybe<BreedCreateWithoutPetsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<BreedUpdateToOneWithWhereWithoutPetsInput>;
  upsert?: Maybe<BreedUpsertWithoutPetsInput>;
};

export type BreedUpdateToOneWithWhereWithoutPetsInput = {
  data: BreedUpdateWithoutPetsInput;
  where?: Maybe<BreedWhereInput>;
};

export type BreedUpdateWithWhereUniqueWithoutBedrockInferenceInput = {
  data: BreedUpdateWithoutBedrockInferenceInput;
  where: BreedWhereUniqueInput;
};

export type BreedUpdateWithWhereUniqueWithoutCanonicalBreedInput = {
  data: BreedUpdateWithoutCanonicalBreedInput;
  where: BreedWhereUniqueInput;
};

export type BreedUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: BreedUpdateWithoutIntegrationInput;
  where: BreedWhereUniqueInput;
};

export type BreedUpdateWithWhereUniqueWithoutSpeciesInput = {
  data: BreedUpdateWithoutSpeciesInput;
  where: BreedWhereUniqueInput;
};

export type BreedUpdateWithoutBedrockInferenceInput = {
  canonicalBreed?: Maybe<CanonicalBreedUpdateOneWithoutBreedGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBreedsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutBreedModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesUpdateOneWithoutBreedsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUpdateWithoutCanonicalBreedInput = {
  bedrockInference?: Maybe<BedrockInferenceUpdateOneWithoutBreedsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBreedsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutBreedModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesUpdateOneWithoutBreedsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUpdateWithoutIntegrationInput = {
  bedrockInference?: Maybe<BedrockInferenceUpdateOneWithoutBreedsNestedInput>;
  canonicalBreed?: Maybe<CanonicalBreedUpdateOneWithoutBreedGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutBreedModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesUpdateOneWithoutBreedsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUpdateWithoutPetsInput = {
  bedrockInference?: Maybe<BedrockInferenceUpdateOneWithoutBreedsNestedInput>;
  canonicalBreed?: Maybe<CanonicalBreedUpdateOneWithoutBreedGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBreedsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesUpdateOneWithoutBreedsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUpdateWithoutSpeciesInput = {
  bedrockInference?: Maybe<BedrockInferenceUpdateOneWithoutBreedsNestedInput>;
  canonicalBreed?: Maybe<CanonicalBreedUpdateOneWithoutBreedGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutBreedsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['Json']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutBreedModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BreedUpsertWithWhereUniqueWithoutBedrockInferenceInput = {
  create: BreedCreateWithoutBedrockInferenceInput;
  update: BreedUpdateWithoutBedrockInferenceInput;
  where: BreedWhereUniqueInput;
};

export type BreedUpsertWithWhereUniqueWithoutCanonicalBreedInput = {
  create: BreedCreateWithoutCanonicalBreedInput;
  update: BreedUpdateWithoutCanonicalBreedInput;
  where: BreedWhereUniqueInput;
};

export type BreedUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: BreedCreateWithoutIntegrationInput;
  update: BreedUpdateWithoutIntegrationInput;
  where: BreedWhereUniqueInput;
};

export type BreedUpsertWithWhereUniqueWithoutSpeciesInput = {
  create: BreedCreateWithoutSpeciesInput;
  update: BreedUpdateWithoutSpeciesInput;
  where: BreedWhereUniqueInput;
};

export type BreedUpsertWithoutPetsInput = {
  create: BreedCreateWithoutPetsInput;
  update: BreedUpdateWithoutPetsInput;
  where?: Maybe<BreedWhereInput>;
};

export type BreedWhereInput = {
  AND?: Maybe<Array<BreedWhereInput>>;
  NOT?: Maybe<Array<BreedWhereInput>>;
  OR?: Maybe<Array<BreedWhereInput>>;
  bedrockInference?: Maybe<BedrockInferenceNullableScalarRelationFilter>;
  bedrockInferenceId?: Maybe<StringNullableFilter>;
  canonicalBreed?: Maybe<CanonicalBreedNullableScalarRelationFilter>;
  canonicalBreedId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  normalizedName?: Maybe<JsonNullableFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  species?: Maybe<SpeciesNullableScalarRelationFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BreedWhereUniqueInput = {
  AND?: Maybe<Array<BreedWhereInput>>;
  NOT?: Maybe<Array<BreedWhereInput>>;
  OR?: Maybe<Array<BreedWhereInput>>;
  bedrockInference?: Maybe<BedrockInferenceNullableScalarRelationFilter>;
  bedrockInferenceId?: Maybe<StringNullableFilter>;
  canonicalBreed?: Maybe<CanonicalBreedNullableScalarRelationFilter>;
  canonicalBreedId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  integrationId_pimsId?: Maybe<BreedIntegrationIdPimsIdCompoundUniqueInput>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  normalizedName?: Maybe<JsonNullableFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  species?: Maybe<SpeciesNullableScalarRelationFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BulkPublishWorkflowEventSettingsInput = {
  isPublished: Scalars['Boolean'];
  workflowEventSettingIds: Array<Scalars['String']>;
};

export type BulkPublishWorkflowEventSettingsResponse = {
  __typename?: 'BulkPublishWorkflowEventSettingsResponse';
  count: Scalars['Int'];
};

export type CalculateMultiplePetsBenefitUsageInput = {
  organizationPetIds: Array<Scalars['String']>;
};

export type CalculateMultiplePetsBenefitUsageOutput = {
  __typename?: 'CalculateMultiplePetsBenefitUsageOutput';
  petUsages: Array<PetBenefitUsage>;
};

export type CalculatePetBenefitUsageInput = {
  organizationPetId: Scalars['String'];
};

export type CalculatePetBenefitUsageOutput = {
  __typename?: 'CalculatePetBenefitUsageOutput';
  usages: Array<UsageByBenefit>;
};

export enum CallDirection {
  Inbound = 'Inbound',
  Outbound = 'Outbound'
}

export type CallHistory = {
  __typename?: 'CallHistory';
  _count: CallHistoryCountOutputType;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** Direction of the call from the clinic's perspective */
  direction: CallDirection;
  /** Duration of call in seconds */
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id: Scalars['String'];
  participants: Array<CallParticipant>;
  provider: CallProvider;
  recordings: Array<CallRecording>;
  sourceId: Scalars['String'];
  status: CallStatus;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt: Scalars['DateTime'];
};


export type CallHistoryParticipantsArgs = {
  cursor?: Maybe<CallParticipantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallParticipantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallParticipantOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallParticipantWhereInput>;
};


export type CallHistoryRecordingsArgs = {
  cursor?: Maybe<CallRecordingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallRecordingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallRecordingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallRecordingWhereInput>;
};

export type CallHistoryAvgAggregateOutputType = {
  __typename?: 'CallHistoryAvgAggregateOutputType';
  duration?: Maybe<Scalars['Float']>;
};

export type CallHistoryAvgOrderByAggregateInput = {
  duration?: Maybe<SortOrder>;
};

export type CallHistoryCountAggregateOutputType = {
  __typename?: 'CallHistoryCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  direction: Scalars['Int'];
  duration: Scalars['Int'];
  from: Scalars['Int'];
  id: Scalars['Int'];
  provider: Scalars['Int'];
  sourceId: Scalars['Int'];
  status: Scalars['Int'];
  to: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CallHistoryCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  direction?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  to?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CallHistoryCountOutputType = {
  __typename?: 'CallHistoryCountOutputType';
  participants: Scalars['Int'];
  recordings: Scalars['Int'];
};

export type CallHistoryCreateInput = {
  clinic: ClinicCreateNestedOneWithoutCallsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantCreateNestedManyWithoutCallHistoryInput>;
  provider: CallProvider;
  recordings?: Maybe<CallRecordingCreateNestedManyWithoutCallHistoryInput>;
  sourceId: Scalars['String'];
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  provider: CallProvider;
  sourceId: Scalars['String'];
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryCreateManyClinicInputEnvelope = {
  data: Array<CallHistoryCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CallHistoryCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  provider: CallProvider;
  sourceId: Scalars['String'];
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<CallHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallHistoryCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<CallHistoryCreateWithoutClinicInput>>;
  createMany?: Maybe<CallHistoryCreateManyClinicInputEnvelope>;
};

export type CallHistoryCreateNestedOneWithoutParticipantsInput = {
  connect?: Maybe<CallHistoryWhereUniqueInput>;
  connectOrCreate?: Maybe<CallHistoryCreateOrConnectWithoutParticipantsInput>;
  create?: Maybe<CallHistoryCreateWithoutParticipantsInput>;
};

export type CallHistoryCreateNestedOneWithoutRecordingsInput = {
  connect?: Maybe<CallHistoryWhereUniqueInput>;
  connectOrCreate?: Maybe<CallHistoryCreateOrConnectWithoutRecordingsInput>;
  create?: Maybe<CallHistoryCreateWithoutRecordingsInput>;
};

export type CallHistoryCreateOrConnectWithoutClinicInput = {
  create: CallHistoryCreateWithoutClinicInput;
  where: CallHistoryWhereUniqueInput;
};

export type CallHistoryCreateOrConnectWithoutParticipantsInput = {
  create: CallHistoryCreateWithoutParticipantsInput;
  where: CallHistoryWhereUniqueInput;
};

export type CallHistoryCreateOrConnectWithoutRecordingsInput = {
  create: CallHistoryCreateWithoutRecordingsInput;
  where: CallHistoryWhereUniqueInput;
};

export type CallHistoryCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantCreateNestedManyWithoutCallHistoryInput>;
  provider: CallProvider;
  recordings?: Maybe<CallRecordingCreateNestedManyWithoutCallHistoryInput>;
  sourceId: Scalars['String'];
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryCreateWithoutParticipantsInput = {
  clinic: ClinicCreateNestedOneWithoutCallsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  provider: CallProvider;
  recordings?: Maybe<CallRecordingCreateNestedManyWithoutCallHistoryInput>;
  sourceId: Scalars['String'];
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryCreateWithoutRecordingsInput = {
  clinic: ClinicCreateNestedOneWithoutCallsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantCreateNestedManyWithoutCallHistoryInput>;
  provider: CallProvider;
  sourceId: Scalars['String'];
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryGroupByOutputType = {
  __typename?: 'CallHistoryGroupByOutputType';
  _avg?: Maybe<CallHistoryAvgAggregateOutputType>;
  _count?: Maybe<CallHistoryCountAggregateOutputType>;
  _max?: Maybe<CallHistoryMaxAggregateOutputType>;
  _min?: Maybe<CallHistoryMinAggregateOutputType>;
  _sum?: Maybe<CallHistorySumAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  direction: CallDirection;
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id: Scalars['String'];
  provider: CallProvider;
  sourceId: Scalars['String'];
  status: CallStatus;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt: Scalars['DateTime'];
};

export type CallHistoryListRelationFilter = {
  every?: Maybe<CallHistoryWhereInput>;
  none?: Maybe<CallHistoryWhereInput>;
  some?: Maybe<CallHistoryWhereInput>;
};

export type CallHistoryMaxAggregateOutputType = {
  __typename?: 'CallHistoryMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<CallProvider>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  direction?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  to?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CallHistoryMinAggregateOutputType = {
  __typename?: 'CallHistoryMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<CallProvider>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  direction?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  to?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CallHistoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CallHistoryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CallHistoryOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  direction?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  participants?: Maybe<CallParticipantOrderByRelationAggregateInput>;
  provider?: Maybe<SortOrder>;
  recordings?: Maybe<CallRecordingOrderByRelationAggregateInput>;
  sourceId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  to?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CallHistoryOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  From = 'from',
  Id = 'id',
  SourceId = 'sourceId',
  To = 'to'
}

export type CallHistoryOrderByRelevanceInput = {
  fields: Array<CallHistoryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CallHistoryOrderByWithAggregationInput = {
  _avg?: Maybe<CallHistoryAvgOrderByAggregateInput>;
  _count?: Maybe<CallHistoryCountOrderByAggregateInput>;
  _max?: Maybe<CallHistoryMaxOrderByAggregateInput>;
  _min?: Maybe<CallHistoryMinOrderByAggregateInput>;
  _sum?: Maybe<CallHistorySumOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  direction?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  to?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CallHistoryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CallHistoryOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  direction?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  participants?: Maybe<CallParticipantOrderByRelationAggregateInput>;
  provider?: Maybe<SortOrder>;
  recordings?: Maybe<CallRecordingOrderByRelationAggregateInput>;
  sourceId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  to?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CallHistoryOrderByWithRelationInput = {
  _relevance?: Maybe<CallHistoryOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  direction?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  participants?: Maybe<CallParticipantOrderByRelationAggregateInput>;
  provider?: Maybe<SortOrder>;
  recordings?: Maybe<CallRecordingOrderByRelationAggregateInput>;
  sourceId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  to?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CallHistoryScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Direction = 'direction',
  Duration = 'duration',
  From = 'from',
  Id = 'id',
  Provider = 'provider',
  SourceId = 'sourceId',
  Status = 'status',
  To = 'to',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type CallHistoryScalarRelationFilter = {
  AND?: Maybe<Array<CallHistoryWhereInput>>;
  NOT?: Maybe<Array<CallHistoryWhereInput>>;
  OR?: Maybe<Array<CallHistoryWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  direction?: Maybe<EnumCallDirectionFilter>;
  duration?: Maybe<IntNullableFilter>;
  from?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  participants?: Maybe<CallParticipantListRelationFilter>;
  provider?: Maybe<EnumCallProviderFilter>;
  recordings?: Maybe<CallRecordingListRelationFilter>;
  sourceId?: Maybe<StringFilter>;
  status?: Maybe<EnumCallStatusFilter>;
  to?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumCallHistoryTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CallHistoryScalarWhereInput = {
  AND?: Maybe<Array<CallHistoryScalarWhereInput>>;
  NOT?: Maybe<Array<CallHistoryScalarWhereInput>>;
  OR?: Maybe<Array<CallHistoryScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  direction?: Maybe<EnumCallDirectionFilter>;
  duration?: Maybe<IntNullableFilter>;
  from?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  provider?: Maybe<EnumCallProviderFilter>;
  sourceId?: Maybe<StringFilter>;
  status?: Maybe<EnumCallStatusFilter>;
  to?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumCallHistoryTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CallHistoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CallHistoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CallHistoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CallHistoryScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  direction?: Maybe<EnumCallDirectionWithAggregatesFilter>;
  duration?: Maybe<IntNullableWithAggregatesFilter>;
  from?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  provider?: Maybe<EnumCallProviderWithAggregatesFilter>;
  sourceId?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumCallStatusWithAggregatesFilter>;
  to?: Maybe<StringNullableWithAggregatesFilter>;
  type?: Maybe<EnumCallHistoryTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CallHistorySubscription = {
  __typename?: 'CallHistorySubscription';
  mutation: MutationType;
  node: CallHistory;
};

export type CallHistorySumAggregateOutputType = {
  __typename?: 'CallHistorySumAggregateOutputType';
  duration?: Maybe<Scalars['Int']>;
};

export type CallHistorySumOrderByAggregateInput = {
  duration?: Maybe<SortOrder>;
};

export enum CallHistoryType {
  Video = 'Video',
  Voice = 'Voice'
}

export type CallHistoryUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutCallHistoryInput>;
  provider: CallProvider;
  recordings?: Maybe<CallRecordingUncheckedCreateNestedManyWithoutCallHistoryInput>;
  sourceId: Scalars['String'];
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<CallHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallHistoryCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<CallHistoryCreateWithoutClinicInput>>;
  createMany?: Maybe<CallHistoryCreateManyClinicInputEnvelope>;
};

export type CallHistoryUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutCallHistoryInput>;
  provider: CallProvider;
  recordings?: Maybe<CallRecordingUncheckedCreateNestedManyWithoutCallHistoryInput>;
  sourceId: Scalars['String'];
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUncheckedCreateWithoutParticipantsInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  provider: CallProvider;
  recordings?: Maybe<CallRecordingUncheckedCreateNestedManyWithoutCallHistoryInput>;
  sourceId: Scalars['String'];
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUncheckedCreateWithoutRecordingsInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutCallHistoryInput>;
  provider: CallProvider;
  sourceId: Scalars['String'];
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantUncheckedUpdateManyWithoutCallHistoryNestedInput>;
  provider?: Maybe<CallProvider>;
  recordings?: Maybe<CallRecordingUncheckedUpdateManyWithoutCallHistoryNestedInput>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<CallProvider>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<CallProvider>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<CallHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallHistoryCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<CallHistoryCreateWithoutClinicInput>>;
  createMany?: Maybe<CallHistoryCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<CallHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CallHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<CallHistoryWhereUniqueInput>>;
  set?: Maybe<Array<CallHistoryWhereUniqueInput>>;
  update?: Maybe<Array<CallHistoryUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<CallHistoryUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<CallHistoryUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type CallHistoryUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantUncheckedUpdateManyWithoutCallHistoryNestedInput>;
  provider?: Maybe<CallProvider>;
  recordings?: Maybe<CallRecordingUncheckedUpdateManyWithoutCallHistoryNestedInput>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUncheckedUpdateWithoutParticipantsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<CallProvider>;
  recordings?: Maybe<CallRecordingUncheckedUpdateManyWithoutCallHistoryNestedInput>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUncheckedUpdateWithoutRecordingsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantUncheckedUpdateManyWithoutCallHistoryNestedInput>;
  provider?: Maybe<CallProvider>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutCallsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantUpdateManyWithoutCallHistoryNestedInput>;
  provider?: Maybe<CallProvider>;
  recordings?: Maybe<CallRecordingUpdateManyWithoutCallHistoryNestedInput>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<CallProvider>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUpdateManyWithWhereWithoutClinicInput = {
  data: CallHistoryUpdateManyMutationInput;
  where: CallHistoryScalarWhereInput;
};

export type CallHistoryUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<CallHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallHistoryCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<CallHistoryCreateWithoutClinicInput>>;
  createMany?: Maybe<CallHistoryCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<CallHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CallHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<CallHistoryWhereUniqueInput>>;
  set?: Maybe<Array<CallHistoryWhereUniqueInput>>;
  update?: Maybe<Array<CallHistoryUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<CallHistoryUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<CallHistoryUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type CallHistoryUpdateOneRequiredWithoutParticipantsNestedInput = {
  connect?: Maybe<CallHistoryWhereUniqueInput>;
  connectOrCreate?: Maybe<CallHistoryCreateOrConnectWithoutParticipantsInput>;
  create?: Maybe<CallHistoryCreateWithoutParticipantsInput>;
  update?: Maybe<CallHistoryUpdateToOneWithWhereWithoutParticipantsInput>;
  upsert?: Maybe<CallHistoryUpsertWithoutParticipantsInput>;
};

export type CallHistoryUpdateOneRequiredWithoutRecordingsNestedInput = {
  connect?: Maybe<CallHistoryWhereUniqueInput>;
  connectOrCreate?: Maybe<CallHistoryCreateOrConnectWithoutRecordingsInput>;
  create?: Maybe<CallHistoryCreateWithoutRecordingsInput>;
  update?: Maybe<CallHistoryUpdateToOneWithWhereWithoutRecordingsInput>;
  upsert?: Maybe<CallHistoryUpsertWithoutRecordingsInput>;
};

export type CallHistoryUpdateToOneWithWhereWithoutParticipantsInput = {
  data: CallHistoryUpdateWithoutParticipantsInput;
  where?: Maybe<CallHistoryWhereInput>;
};

export type CallHistoryUpdateToOneWithWhereWithoutRecordingsInput = {
  data: CallHistoryUpdateWithoutRecordingsInput;
  where?: Maybe<CallHistoryWhereInput>;
};

export type CallHistoryUpdateWithWhereUniqueWithoutClinicInput = {
  data: CallHistoryUpdateWithoutClinicInput;
  where: CallHistoryWhereUniqueInput;
};

export type CallHistoryUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantUpdateManyWithoutCallHistoryNestedInput>;
  provider?: Maybe<CallProvider>;
  recordings?: Maybe<CallRecordingUpdateManyWithoutCallHistoryNestedInput>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUpdateWithoutParticipantsInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutCallsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<CallProvider>;
  recordings?: Maybe<CallRecordingUpdateManyWithoutCallHistoryNestedInput>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUpdateWithoutRecordingsInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutCallsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantUpdateManyWithoutCallHistoryNestedInput>;
  provider?: Maybe<CallProvider>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<CallHistoryType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallHistoryUpsertWithWhereUniqueWithoutClinicInput = {
  create: CallHistoryCreateWithoutClinicInput;
  update: CallHistoryUpdateWithoutClinicInput;
  where: CallHistoryWhereUniqueInput;
};

export type CallHistoryUpsertWithoutParticipantsInput = {
  create: CallHistoryCreateWithoutParticipantsInput;
  update: CallHistoryUpdateWithoutParticipantsInput;
  where?: Maybe<CallHistoryWhereInput>;
};

export type CallHistoryUpsertWithoutRecordingsInput = {
  create: CallHistoryCreateWithoutRecordingsInput;
  update: CallHistoryUpdateWithoutRecordingsInput;
  where?: Maybe<CallHistoryWhereInput>;
};

export type CallHistoryWhereInput = {
  AND?: Maybe<Array<CallHistoryWhereInput>>;
  NOT?: Maybe<Array<CallHistoryWhereInput>>;
  OR?: Maybe<Array<CallHistoryWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  direction?: Maybe<EnumCallDirectionFilter>;
  duration?: Maybe<IntNullableFilter>;
  from?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  participants?: Maybe<CallParticipantListRelationFilter>;
  provider?: Maybe<EnumCallProviderFilter>;
  recordings?: Maybe<CallRecordingListRelationFilter>;
  sourceId?: Maybe<StringFilter>;
  status?: Maybe<EnumCallStatusFilter>;
  to?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumCallHistoryTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CallHistoryWhereUniqueInput = {
  AND?: Maybe<Array<CallHistoryWhereInput>>;
  NOT?: Maybe<Array<CallHistoryWhereInput>>;
  OR?: Maybe<Array<CallHistoryWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  direction?: Maybe<EnumCallDirectionFilter>;
  duration?: Maybe<IntNullableFilter>;
  from?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  participants?: Maybe<CallParticipantListRelationFilter>;
  provider?: Maybe<EnumCallProviderFilter>;
  recordings?: Maybe<CallRecordingListRelationFilter>;
  sourceId?: Maybe<Scalars['String']>;
  status?: Maybe<EnumCallStatusFilter>;
  to?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumCallHistoryTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CallParticipant = {
  __typename?: 'CallParticipant';
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistory: CallHistory;
  callHistoryId: Scalars['String'];
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  extension?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};


export type CallParticipantClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type CallParticipantUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type CallParticipantCallHistoryIdClinicPetParentIdCompoundUniqueInput = {
  callHistoryId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
};

export type CallParticipantCallHistoryIdUserIdExtensionCompoundUniqueInput = {
  callHistoryId: Scalars['String'];
  extension: Scalars['String'];
  userId: Scalars['String'];
};

export type CallParticipantCountAggregateOutputType = {
  __typename?: 'CallParticipantCountAggregateOutputType';
  _all: Scalars['Int'];
  axionEndpointId: Scalars['Int'];
  callHistoryId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  extension: Scalars['Int'];
  id: Scalars['Int'];
  number: Scalars['Int'];
  result: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type CallParticipantCountOrderByAggregateInput = {
  axionEndpointId?: Maybe<SortOrder>;
  callHistoryId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type CallParticipantCreateInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistory: CallHistoryCreateNestedOneWithoutParticipantsInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutCallsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutCallsInput>;
};

export type CallParticipantCreateManyCallHistoryInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantCreateManyCallHistoryInputEnvelope = {
  data: Array<CallParticipantCreateManyCallHistoryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CallParticipantCreateManyClinicPetParentInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantCreateManyClinicPetParentInputEnvelope = {
  data: Array<CallParticipantCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CallParticipantCreateManyInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantCreateManyUserInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallParticipantCreateManyUserInputEnvelope = {
  data: Array<CallParticipantCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CallParticipantCreateNestedManyWithoutCallHistoryInput = {
  connect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallParticipantCreateOrConnectWithoutCallHistoryInput>>;
  create?: Maybe<Array<CallParticipantCreateWithoutCallHistoryInput>>;
  createMany?: Maybe<CallParticipantCreateManyCallHistoryInputEnvelope>;
};

export type CallParticipantCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallParticipantCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CallParticipantCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CallParticipantCreateManyClinicPetParentInputEnvelope>;
};

export type CallParticipantCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallParticipantCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<CallParticipantCreateWithoutUserInput>>;
  createMany?: Maybe<CallParticipantCreateManyUserInputEnvelope>;
};

export type CallParticipantCreateOrConnectWithoutCallHistoryInput = {
  create: CallParticipantCreateWithoutCallHistoryInput;
  where: CallParticipantWhereUniqueInput;
};

export type CallParticipantCreateOrConnectWithoutClinicPetParentInput = {
  create: CallParticipantCreateWithoutClinicPetParentInput;
  where: CallParticipantWhereUniqueInput;
};

export type CallParticipantCreateOrConnectWithoutUserInput = {
  create: CallParticipantCreateWithoutUserInput;
  where: CallParticipantWhereUniqueInput;
};

export type CallParticipantCreateWithoutCallHistoryInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutCallsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutCallsInput>;
};

export type CallParticipantCreateWithoutClinicPetParentInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistory: CallHistoryCreateNestedOneWithoutParticipantsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutCallsInput>;
};

export type CallParticipantCreateWithoutUserInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistory: CallHistoryCreateNestedOneWithoutParticipantsInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutCallsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallParticipantGroupByOutputType = {
  __typename?: 'CallParticipantGroupByOutputType';
  _count?: Maybe<CallParticipantCountAggregateOutputType>;
  _max?: Maybe<CallParticipantMaxAggregateOutputType>;
  _min?: Maybe<CallParticipantMinAggregateOutputType>;
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  extension?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantListRelationFilter = {
  every?: Maybe<CallParticipantWhereInput>;
  none?: Maybe<CallParticipantWhereInput>;
  some?: Maybe<CallParticipantWhereInput>;
};

export type CallParticipantMaxAggregateOutputType = {
  __typename?: 'CallParticipantMaxAggregateOutputType';
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantMaxOrderByAggregateInput = {
  axionEndpointId?: Maybe<SortOrder>;
  callHistoryId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type CallParticipantMinAggregateOutputType = {
  __typename?: 'CallParticipantMinAggregateOutputType';
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantMinOrderByAggregateInput = {
  axionEndpointId?: Maybe<SortOrder>;
  callHistoryId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type CallParticipantOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CallParticipantOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CallParticipantOrderByRelevanceInput>;
  axionEndpointId?: Maybe<SortOrder>;
  callHistory?: Maybe<CallHistoryOrderByWithRelationInput>;
  callHistoryId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum CallParticipantOrderByRelevanceFieldEnum {
  AxionEndpointId = 'axionEndpointId',
  CallHistoryId = 'callHistoryId',
  ClinicPetParentId = 'clinicPetParentId',
  Extension = 'extension',
  Id = 'id',
  Number = 'number',
  UserId = 'userId'
}

export type CallParticipantOrderByRelevanceInput = {
  fields: Array<CallParticipantOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CallParticipantOrderByWithAggregationInput = {
  _count?: Maybe<CallParticipantCountOrderByAggregateInput>;
  _max?: Maybe<CallParticipantMaxOrderByAggregateInput>;
  _min?: Maybe<CallParticipantMinOrderByAggregateInput>;
  axionEndpointId?: Maybe<SortOrder>;
  callHistoryId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type CallParticipantOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CallParticipantOrderByRelevanceInput>;
  axionEndpointId?: Maybe<SortOrder>;
  callHistory?: Maybe<CallHistoryOrderByWithRelationInput>;
  callHistoryId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type CallParticipantOrderByWithRelationInput = {
  _relevance?: Maybe<CallParticipantOrderByRelevanceInput>;
  axionEndpointId?: Maybe<SortOrder>;
  callHistory?: Maybe<CallHistoryOrderByWithRelationInput>;
  callHistoryId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum CallParticipantResult {
  Answered = 'Answered',
  Ignored = 'Ignored',
  IgnoredWithMessage = 'IgnoredWithMessage',
  Rejected = 'Rejected'
}

export enum CallParticipantScalarFieldEnum {
  AxionEndpointId = 'axionEndpointId',
  CallHistoryId = 'callHistoryId',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Extension = 'extension',
  Id = 'id',
  Number = 'number',
  Result = 'result',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type CallParticipantScalarWhereInput = {
  AND?: Maybe<Array<CallParticipantScalarWhereInput>>;
  NOT?: Maybe<Array<CallParticipantScalarWhereInput>>;
  OR?: Maybe<Array<CallParticipantScalarWhereInput>>;
  axionEndpointId?: Maybe<StringNullableFilter>;
  callHistoryId?: Maybe<StringFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  extension?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  number?: Maybe<StringNullableFilter>;
  result?: Maybe<EnumCallParticipantResultNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type CallParticipantScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CallParticipantScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CallParticipantScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CallParticipantScalarWhereWithAggregatesInput>>;
  axionEndpointId?: Maybe<StringNullableWithAggregatesFilter>;
  callHistoryId?: Maybe<StringWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  extension?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  number?: Maybe<StringNullableWithAggregatesFilter>;
  result?: Maybe<EnumCallParticipantResultNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type CallParticipantUncheckedCreateInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantUncheckedCreateNestedManyWithoutCallHistoryInput = {
  connect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallParticipantCreateOrConnectWithoutCallHistoryInput>>;
  create?: Maybe<Array<CallParticipantCreateWithoutCallHistoryInput>>;
  createMany?: Maybe<CallParticipantCreateManyCallHistoryInputEnvelope>;
};

export type CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallParticipantCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CallParticipantCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CallParticipantCreateManyClinicPetParentInputEnvelope>;
};

export type CallParticipantUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallParticipantCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<CallParticipantCreateWithoutUserInput>>;
  createMany?: Maybe<CallParticipantCreateManyUserInputEnvelope>;
};

export type CallParticipantUncheckedCreateWithoutCallHistoryInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantUncheckedCreateWithoutClinicPetParentInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantUncheckedCreateWithoutUserInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallParticipantUncheckedUpdateInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantUncheckedUpdateManyInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantUncheckedUpdateManyWithoutCallHistoryInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantUncheckedUpdateManyWithoutCallHistoryNestedInput = {
  connect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallParticipantCreateOrConnectWithoutCallHistoryInput>>;
  create?: Maybe<Array<CallParticipantCreateWithoutCallHistoryInput>>;
  createMany?: Maybe<CallParticipantCreateManyCallHistoryInputEnvelope>;
  delete?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CallParticipantScalarWhereInput>>;
  disconnect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  set?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  update?: Maybe<Array<CallParticipantUpdateWithWhereUniqueWithoutCallHistoryInput>>;
  updateMany?: Maybe<Array<CallParticipantUpdateManyWithWhereWithoutCallHistoryInput>>;
  upsert?: Maybe<Array<CallParticipantUpsertWithWhereUniqueWithoutCallHistoryInput>>;
};

export type CallParticipantUncheckedUpdateManyWithoutClinicPetParentInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallParticipantCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CallParticipantCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CallParticipantCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CallParticipantScalarWhereInput>>;
  disconnect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  set?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  update?: Maybe<Array<CallParticipantUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<CallParticipantUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<CallParticipantUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type CallParticipantUncheckedUpdateManyWithoutUserInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallParticipantUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallParticipantCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<CallParticipantCreateWithoutUserInput>>;
  createMany?: Maybe<CallParticipantCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CallParticipantScalarWhereInput>>;
  disconnect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  set?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  update?: Maybe<Array<CallParticipantUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<CallParticipantUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<CallParticipantUpsertWithWhereUniqueWithoutUserInput>>;
};

export type CallParticipantUncheckedUpdateWithoutCallHistoryInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantUncheckedUpdateWithoutClinicPetParentInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CallParticipantUncheckedUpdateWithoutUserInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistoryId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallParticipantUpdateInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistory?: Maybe<CallHistoryUpdateOneRequiredWithoutParticipantsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutCallsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutCallsNestedInput>;
};

export type CallParticipantUpdateManyMutationInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallParticipantUpdateManyWithWhereWithoutCallHistoryInput = {
  data: CallParticipantUpdateManyMutationInput;
  where: CallParticipantScalarWhereInput;
};

export type CallParticipantUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: CallParticipantUpdateManyMutationInput;
  where: CallParticipantScalarWhereInput;
};

export type CallParticipantUpdateManyWithWhereWithoutUserInput = {
  data: CallParticipantUpdateManyMutationInput;
  where: CallParticipantScalarWhereInput;
};

export type CallParticipantUpdateManyWithoutCallHistoryNestedInput = {
  connect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallParticipantCreateOrConnectWithoutCallHistoryInput>>;
  create?: Maybe<Array<CallParticipantCreateWithoutCallHistoryInput>>;
  createMany?: Maybe<CallParticipantCreateManyCallHistoryInputEnvelope>;
  delete?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CallParticipantScalarWhereInput>>;
  disconnect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  set?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  update?: Maybe<Array<CallParticipantUpdateWithWhereUniqueWithoutCallHistoryInput>>;
  updateMany?: Maybe<Array<CallParticipantUpdateManyWithWhereWithoutCallHistoryInput>>;
  upsert?: Maybe<Array<CallParticipantUpsertWithWhereUniqueWithoutCallHistoryInput>>;
};

export type CallParticipantUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallParticipantCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CallParticipantCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CallParticipantCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CallParticipantScalarWhereInput>>;
  disconnect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  set?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  update?: Maybe<Array<CallParticipantUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<CallParticipantUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<CallParticipantUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type CallParticipantUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallParticipantCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<CallParticipantCreateWithoutUserInput>>;
  createMany?: Maybe<CallParticipantCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CallParticipantScalarWhereInput>>;
  disconnect?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  set?: Maybe<Array<CallParticipantWhereUniqueInput>>;
  update?: Maybe<Array<CallParticipantUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<CallParticipantUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<CallParticipantUpsertWithWhereUniqueWithoutUserInput>>;
};

export type CallParticipantUpdateWithWhereUniqueWithoutCallHistoryInput = {
  data: CallParticipantUpdateWithoutCallHistoryInput;
  where: CallParticipantWhereUniqueInput;
};

export type CallParticipantUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: CallParticipantUpdateWithoutClinicPetParentInput;
  where: CallParticipantWhereUniqueInput;
};

export type CallParticipantUpdateWithWhereUniqueWithoutUserInput = {
  data: CallParticipantUpdateWithoutUserInput;
  where: CallParticipantWhereUniqueInput;
};

export type CallParticipantUpdateWithoutCallHistoryInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutCallsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutCallsNestedInput>;
};

export type CallParticipantUpdateWithoutClinicPetParentInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistory?: Maybe<CallHistoryUpdateOneRequiredWithoutParticipantsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutCallsNestedInput>;
};

export type CallParticipantUpdateWithoutUserInput = {
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistory?: Maybe<CallHistoryUpdateOneRequiredWithoutParticipantsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutCallsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallParticipantUpsertWithWhereUniqueWithoutCallHistoryInput = {
  create: CallParticipantCreateWithoutCallHistoryInput;
  update: CallParticipantUpdateWithoutCallHistoryInput;
  where: CallParticipantWhereUniqueInput;
};

export type CallParticipantUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: CallParticipantCreateWithoutClinicPetParentInput;
  update: CallParticipantUpdateWithoutClinicPetParentInput;
  where: CallParticipantWhereUniqueInput;
};

export type CallParticipantUpsertWithWhereUniqueWithoutUserInput = {
  create: CallParticipantCreateWithoutUserInput;
  update: CallParticipantUpdateWithoutUserInput;
  where: CallParticipantWhereUniqueInput;
};

export type CallParticipantWhereInput = {
  AND?: Maybe<Array<CallParticipantWhereInput>>;
  NOT?: Maybe<Array<CallParticipantWhereInput>>;
  OR?: Maybe<Array<CallParticipantWhereInput>>;
  axionEndpointId?: Maybe<StringNullableFilter>;
  callHistory?: Maybe<CallHistoryScalarRelationFilter>;
  callHistoryId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  extension?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  number?: Maybe<StringNullableFilter>;
  result?: Maybe<EnumCallParticipantResultNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type CallParticipantWhereUniqueInput = {
  AND?: Maybe<Array<CallParticipantWhereInput>>;
  NOT?: Maybe<Array<CallParticipantWhereInput>>;
  OR?: Maybe<Array<CallParticipantWhereInput>>;
  axionEndpointId?: Maybe<StringNullableFilter>;
  callHistory?: Maybe<CallHistoryScalarRelationFilter>;
  callHistoryId?: Maybe<StringFilter>;
  callHistoryId_clinicPetParentId?: Maybe<CallParticipantCallHistoryIdClinicPetParentIdCompoundUniqueInput>;
  callHistoryId_userId_extension?: Maybe<CallParticipantCallHistoryIdUserIdExtensionCompoundUniqueInput>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  extension?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<StringNullableFilter>;
  result?: Maybe<EnumCallParticipantResultNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export enum CallProvider {
  Axion = 'Axion',
  Twilio = 'Twilio'
}

export type CallRecording = {
  __typename?: 'CallRecording';
  callHistory: CallHistory;
  callHistoryId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  downloadStatus: RecordingDownloadStatus;
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  s3Uri: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  twilioCallRecording?: Maybe<TwilioCallRecording>;
  updatedAt: Scalars['DateTime'];
};


export type CallRecordingTwilioCallRecordingArgs = {
  where?: Maybe<TwilioCallRecordingWhereInput>;
};

export type CallRecordingAvgAggregateOutputType = {
  __typename?: 'CallRecordingAvgAggregateOutputType';
  duration?: Maybe<Scalars['Float']>;
};

export type CallRecordingAvgOrderByAggregateInput = {
  duration?: Maybe<SortOrder>;
};

export type CallRecordingCountAggregateOutputType = {
  __typename?: 'CallRecordingCountAggregateOutputType';
  _all: Scalars['Int'];
  callHistoryId: Scalars['Int'];
  createdAt: Scalars['Int'];
  downloadStatus: Scalars['Int'];
  duration: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  s3Uri: Scalars['Int'];
  summary: Scalars['Int'];
  transcription: Scalars['Int'];
  transcriptionS3Uri: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CallRecordingCountOrderByAggregateInput = {
  callHistoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  downloadStatus?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  s3Uri?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transcription?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CallRecordingCreateInput = {
  callHistory: CallHistoryCreateNestedOneWithoutRecordingsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  twilioCallRecording?: Maybe<TwilioCallRecordingCreateNestedOneWithoutCallRecordingInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingCreateManyCallHistoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingCreateManyCallHistoryInputEnvelope = {
  data: Array<CallRecordingCreateManyCallHistoryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CallRecordingCreateManyInput = {
  callHistoryId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingCreateNestedManyWithoutCallHistoryInput = {
  connect?: Maybe<Array<CallRecordingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallRecordingCreateOrConnectWithoutCallHistoryInput>>;
  create?: Maybe<Array<CallRecordingCreateWithoutCallHistoryInput>>;
  createMany?: Maybe<CallRecordingCreateManyCallHistoryInputEnvelope>;
};

export type CallRecordingCreateNestedOneWithoutTwilioCallRecordingInput = {
  connect?: Maybe<CallRecordingWhereUniqueInput>;
  connectOrCreate?: Maybe<CallRecordingCreateOrConnectWithoutTwilioCallRecordingInput>;
  create?: Maybe<CallRecordingCreateWithoutTwilioCallRecordingInput>;
};

export type CallRecordingCreateOrConnectWithoutCallHistoryInput = {
  create: CallRecordingCreateWithoutCallHistoryInput;
  where: CallRecordingWhereUniqueInput;
};

export type CallRecordingCreateOrConnectWithoutTwilioCallRecordingInput = {
  create: CallRecordingCreateWithoutTwilioCallRecordingInput;
  where: CallRecordingWhereUniqueInput;
};

export type CallRecordingCreateWithoutCallHistoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  twilioCallRecording?: Maybe<TwilioCallRecordingCreateNestedOneWithoutCallRecordingInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingCreateWithoutTwilioCallRecordingInput = {
  callHistory: CallHistoryCreateNestedOneWithoutRecordingsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingGroupByOutputType = {
  __typename?: 'CallRecordingGroupByOutputType';
  _avg?: Maybe<CallRecordingAvgAggregateOutputType>;
  _count?: Maybe<CallRecordingCountAggregateOutputType>;
  _max?: Maybe<CallRecordingMaxAggregateOutputType>;
  _min?: Maybe<CallRecordingMinAggregateOutputType>;
  _sum?: Maybe<CallRecordingSumAggregateOutputType>;
  callHistoryId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  downloadStatus: RecordingDownloadStatus;
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  s3Uri: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CallRecordingListRelationFilter = {
  every?: Maybe<CallRecordingWhereInput>;
  none?: Maybe<CallRecordingWhereInput>;
  some?: Maybe<CallRecordingWhereInput>;
};

export type CallRecordingMaxAggregateOutputType = {
  __typename?: 'CallRecordingMaxAggregateOutputType';
  callHistoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingMaxOrderByAggregateInput = {
  callHistoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  downloadStatus?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  s3Uri?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transcription?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CallRecordingMinAggregateOutputType = {
  __typename?: 'CallRecordingMinAggregateOutputType';
  callHistoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingMinOrderByAggregateInput = {
  callHistoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  downloadStatus?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  s3Uri?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transcription?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CallRecordingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CallRecordingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CallRecordingOrderByRelevanceInput>;
  callHistory?: Maybe<CallHistoryOrderByWithRelationInput>;
  callHistoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  downloadStatus?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  s3Uri?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transcription?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  twilioCallRecording?: Maybe<TwilioCallRecordingOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CallRecordingOrderByRelevanceFieldEnum {
  CallHistoryId = 'callHistoryId',
  Id = 'id',
  S3Uri = 's3Uri',
  Summary = 'summary',
  Transcription = 'transcription',
  TranscriptionS3Uri = 'transcriptionS3Uri'
}

export type CallRecordingOrderByRelevanceInput = {
  fields: Array<CallRecordingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CallRecordingOrderByWithAggregationInput = {
  _avg?: Maybe<CallRecordingAvgOrderByAggregateInput>;
  _count?: Maybe<CallRecordingCountOrderByAggregateInput>;
  _max?: Maybe<CallRecordingMaxOrderByAggregateInput>;
  _min?: Maybe<CallRecordingMinOrderByAggregateInput>;
  _sum?: Maybe<CallRecordingSumOrderByAggregateInput>;
  callHistoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  downloadStatus?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  s3Uri?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transcription?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CallRecordingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CallRecordingOrderByRelevanceInput>;
  callHistory?: Maybe<CallHistoryOrderByWithRelationInput>;
  callHistoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  downloadStatus?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  s3Uri?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transcription?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  twilioCallRecording?: Maybe<TwilioCallRecordingOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type CallRecordingOrderByWithRelationInput = {
  _relevance?: Maybe<CallRecordingOrderByRelevanceInput>;
  callHistory?: Maybe<CallHistoryOrderByWithRelationInput>;
  callHistoryId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  downloadStatus?: Maybe<SortOrder>;
  duration?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  s3Uri?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transcription?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  twilioCallRecording?: Maybe<TwilioCallRecordingOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CallRecordingScalarFieldEnum {
  CallHistoryId = 'callHistoryId',
  CreatedAt = 'createdAt',
  DownloadStatus = 'downloadStatus',
  Duration = 'duration',
  Id = 'id',
  IsDeleted = 'isDeleted',
  S3Uri = 's3Uri',
  Summary = 'summary',
  Transcription = 'transcription',
  TranscriptionS3Uri = 'transcriptionS3Uri',
  UpdatedAt = 'updatedAt'
}

export type CallRecordingScalarRelationFilter = {
  AND?: Maybe<Array<CallRecordingWhereInput>>;
  NOT?: Maybe<Array<CallRecordingWhereInput>>;
  OR?: Maybe<Array<CallRecordingWhereInput>>;
  callHistory?: Maybe<CallHistoryScalarRelationFilter>;
  callHistoryId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  downloadStatus?: Maybe<EnumRecordingDownloadStatusFilter>;
  duration?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  s3Uri?: Maybe<StringFilter>;
  summary?: Maybe<StringNullableFilter>;
  transcription?: Maybe<StringNullableFilter>;
  transcriptionS3Uri?: Maybe<StringNullableFilter>;
  twilioCallRecording?: Maybe<TwilioCallRecordingNullableScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CallRecordingScalarWhereInput = {
  AND?: Maybe<Array<CallRecordingScalarWhereInput>>;
  NOT?: Maybe<Array<CallRecordingScalarWhereInput>>;
  OR?: Maybe<Array<CallRecordingScalarWhereInput>>;
  callHistoryId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  downloadStatus?: Maybe<EnumRecordingDownloadStatusFilter>;
  duration?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  s3Uri?: Maybe<StringFilter>;
  summary?: Maybe<StringNullableFilter>;
  transcription?: Maybe<StringNullableFilter>;
  transcriptionS3Uri?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CallRecordingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CallRecordingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CallRecordingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CallRecordingScalarWhereWithAggregatesInput>>;
  callHistoryId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  downloadStatus?: Maybe<EnumRecordingDownloadStatusWithAggregatesFilter>;
  duration?: Maybe<IntNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  s3Uri?: Maybe<StringWithAggregatesFilter>;
  summary?: Maybe<StringNullableWithAggregatesFilter>;
  transcription?: Maybe<StringNullableWithAggregatesFilter>;
  transcriptionS3Uri?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CallRecordingSumAggregateOutputType = {
  __typename?: 'CallRecordingSumAggregateOutputType';
  duration?: Maybe<Scalars['Int']>;
};

export type CallRecordingSumOrderByAggregateInput = {
  duration?: Maybe<SortOrder>;
};

export type CallRecordingUncheckedCreateInput = {
  callHistoryId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  twilioCallRecording?: Maybe<TwilioCallRecordingUncheckedCreateNestedOneWithoutCallRecordingInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingUncheckedCreateNestedManyWithoutCallHistoryInput = {
  connect?: Maybe<Array<CallRecordingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallRecordingCreateOrConnectWithoutCallHistoryInput>>;
  create?: Maybe<Array<CallRecordingCreateWithoutCallHistoryInput>>;
  createMany?: Maybe<CallRecordingCreateManyCallHistoryInputEnvelope>;
};

export type CallRecordingUncheckedCreateWithoutCallHistoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  twilioCallRecording?: Maybe<TwilioCallRecordingUncheckedCreateNestedOneWithoutCallRecordingInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingUncheckedCreateWithoutTwilioCallRecordingInput = {
  callHistoryId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingUncheckedUpdateInput = {
  callHistoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  twilioCallRecording?: Maybe<TwilioCallRecordingUncheckedUpdateOneWithoutCallRecordingNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingUncheckedUpdateManyInput = {
  callHistoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingUncheckedUpdateManyWithoutCallHistoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingUncheckedUpdateManyWithoutCallHistoryNestedInput = {
  connect?: Maybe<Array<CallRecordingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallRecordingCreateOrConnectWithoutCallHistoryInput>>;
  create?: Maybe<Array<CallRecordingCreateWithoutCallHistoryInput>>;
  createMany?: Maybe<CallRecordingCreateManyCallHistoryInputEnvelope>;
  delete?: Maybe<Array<CallRecordingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CallRecordingScalarWhereInput>>;
  disconnect?: Maybe<Array<CallRecordingWhereUniqueInput>>;
  set?: Maybe<Array<CallRecordingWhereUniqueInput>>;
  update?: Maybe<Array<CallRecordingUpdateWithWhereUniqueWithoutCallHistoryInput>>;
  updateMany?: Maybe<Array<CallRecordingUpdateManyWithWhereWithoutCallHistoryInput>>;
  upsert?: Maybe<Array<CallRecordingUpsertWithWhereUniqueWithoutCallHistoryInput>>;
};

export type CallRecordingUncheckedUpdateWithoutCallHistoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  twilioCallRecording?: Maybe<TwilioCallRecordingUncheckedUpdateOneWithoutCallRecordingNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingUncheckedUpdateWithoutTwilioCallRecordingInput = {
  callHistoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingUpdateInput = {
  callHistory?: Maybe<CallHistoryUpdateOneRequiredWithoutRecordingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri?: Maybe<Scalars['String']>;
  status: RecordingControlStatus;
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  twilioCallRecording?: Maybe<TwilioCallRecordingUpdateOneWithoutCallRecordingNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingUpdateManyWithWhereWithoutCallHistoryInput = {
  data: CallRecordingUpdateManyMutationInput;
  where: CallRecordingScalarWhereInput;
};

export type CallRecordingUpdateManyWithoutCallHistoryNestedInput = {
  connect?: Maybe<Array<CallRecordingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CallRecordingCreateOrConnectWithoutCallHistoryInput>>;
  create?: Maybe<Array<CallRecordingCreateWithoutCallHistoryInput>>;
  createMany?: Maybe<CallRecordingCreateManyCallHistoryInputEnvelope>;
  delete?: Maybe<Array<CallRecordingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CallRecordingScalarWhereInput>>;
  disconnect?: Maybe<Array<CallRecordingWhereUniqueInput>>;
  set?: Maybe<Array<CallRecordingWhereUniqueInput>>;
  update?: Maybe<Array<CallRecordingUpdateWithWhereUniqueWithoutCallHistoryInput>>;
  updateMany?: Maybe<Array<CallRecordingUpdateManyWithWhereWithoutCallHistoryInput>>;
  upsert?: Maybe<Array<CallRecordingUpsertWithWhereUniqueWithoutCallHistoryInput>>;
};

export type CallRecordingUpdateOneRequiredWithoutTwilioCallRecordingNestedInput = {
  connect?: Maybe<CallRecordingWhereUniqueInput>;
  connectOrCreate?: Maybe<CallRecordingCreateOrConnectWithoutTwilioCallRecordingInput>;
  create?: Maybe<CallRecordingCreateWithoutTwilioCallRecordingInput>;
  update?: Maybe<CallRecordingUpdateToOneWithWhereWithoutTwilioCallRecordingInput>;
  upsert?: Maybe<CallRecordingUpsertWithoutTwilioCallRecordingInput>;
};

export type CallRecordingUpdateToOneWithWhereWithoutTwilioCallRecordingInput = {
  data: CallRecordingUpdateWithoutTwilioCallRecordingInput;
  where?: Maybe<CallRecordingWhereInput>;
};

export type CallRecordingUpdateWithWhereUniqueWithoutCallHistoryInput = {
  data: CallRecordingUpdateWithoutCallHistoryInput;
  where: CallRecordingWhereUniqueInput;
};

export type CallRecordingUpdateWithoutCallHistoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  twilioCallRecording?: Maybe<TwilioCallRecordingUpdateOneWithoutCallRecordingNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingUpdateWithoutTwilioCallRecordingInput = {
  callHistory?: Maybe<CallHistoryUpdateOneRequiredWithoutRecordingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadStatus?: Maybe<RecordingDownloadStatus>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  s3Uri?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CallRecordingUpsertWithWhereUniqueWithoutCallHistoryInput = {
  create: CallRecordingCreateWithoutCallHistoryInput;
  update: CallRecordingUpdateWithoutCallHistoryInput;
  where: CallRecordingWhereUniqueInput;
};

export type CallRecordingUpsertWithoutTwilioCallRecordingInput = {
  create: CallRecordingCreateWithoutTwilioCallRecordingInput;
  update: CallRecordingUpdateWithoutTwilioCallRecordingInput;
  where?: Maybe<CallRecordingWhereInput>;
};

export type CallRecordingWhereInput = {
  AND?: Maybe<Array<CallRecordingWhereInput>>;
  NOT?: Maybe<Array<CallRecordingWhereInput>>;
  OR?: Maybe<Array<CallRecordingWhereInput>>;
  callHistory?: Maybe<CallHistoryScalarRelationFilter>;
  callHistoryId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  downloadStatus?: Maybe<EnumRecordingDownloadStatusFilter>;
  duration?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  s3Uri?: Maybe<StringFilter>;
  summary?: Maybe<StringNullableFilter>;
  transcription?: Maybe<StringNullableFilter>;
  transcriptionS3Uri?: Maybe<StringNullableFilter>;
  twilioCallRecording?: Maybe<TwilioCallRecordingNullableScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CallRecordingWhereUniqueInput = {
  AND?: Maybe<Array<CallRecordingWhereInput>>;
  NOT?: Maybe<Array<CallRecordingWhereInput>>;
  OR?: Maybe<Array<CallRecordingWhereInput>>;
  callHistory?: Maybe<CallHistoryScalarRelationFilter>;
  callHistoryId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  downloadStatus?: Maybe<EnumRecordingDownloadStatusFilter>;
  duration?: Maybe<IntNullableFilter>;
  id: Scalars['String'];
  isDeleted?: Maybe<BoolFilter>;
  s3Uri?: Maybe<StringFilter>;
  summary?: Maybe<StringNullableFilter>;
  transcription?: Maybe<StringNullableFilter>;
  transcriptionS3Uri?: Maybe<StringNullableFilter>;
  twilioCallRecording?: Maybe<TwilioCallRecordingNullableScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum CallStatus {
  Busy = 'Busy',
  Canceled = 'Canceled',
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
  NoAnswer = 'NoAnswer',
  Queued = 'Queued',
  Ringing = 'Ringing'
}

export enum CampaignRegistryBrandIdentityStatus {
  SelfDeclared = 'SELF_DECLARED',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED',
  VettedVerified = 'VETTED_VERIFIED'
}

export type CampaignRegistryCampaign = {
  __typename?: 'CampaignRegistryCampaign';
  _count: CampaignRegistryCampaignCountOutputType;
  clinicPhoneNumbers: Array<ClinicPhoneNumber>;
  clinicSetting: ClinicSetting;
  clinicSettingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted: Scalars['Boolean'];
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  upstreamCnpId?: Maybe<Scalars['String']>;
};


export type CampaignRegistryCampaignClinicPhoneNumbersArgs = {
  cursor?: Maybe<ClinicPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPhoneNumberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPhoneNumberWhereInput>;
};

export type CampaignRegistryCampaignCountAggregateOutputType = {
  __typename?: 'CampaignRegistryCampaignCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicSettingId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  importedAt: Scalars['Int'];
  isDeleted: Scalars['Int'];
  mnoMetaData: Scalars['Int'];
  settings: Scalars['Int'];
  sharingStatus: Scalars['Int'];
  sourceId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  upstreamCnpId: Scalars['Int'];
};

export type CampaignRegistryCampaignCountOrderByAggregateInput = {
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  importedAt?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  mnoMetaData?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  sharingStatus?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  upstreamCnpId?: Maybe<SortOrder>;
};

export type CampaignRegistryCampaignCountOutputType = {
  __typename?: 'CampaignRegistryCampaignCountOutputType';
  clinicPhoneNumbers: Scalars['Int'];
};

export type CampaignRegistryCampaignCreateInput = {
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutCampaignRegistryCampaignInput>;
  clinicSetting: ClinicSettingCreateNestedOneWithoutCampaignRegistryCampaignsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignCreateManyClinicSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignCreateManyClinicSettingInputEnvelope = {
  data: Array<CampaignRegistryCampaignCreateManyClinicSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CampaignRegistryCampaignCreateManyInput = {
  clinicSettingId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignCreateNestedManyWithoutClinicSettingInput = {
  connect?: Maybe<Array<CampaignRegistryCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CampaignRegistryCampaignCreateOrConnectWithoutClinicSettingInput>>;
  create?: Maybe<Array<CampaignRegistryCampaignCreateWithoutClinicSettingInput>>;
  createMany?: Maybe<CampaignRegistryCampaignCreateManyClinicSettingInputEnvelope>;
};

export type CampaignRegistryCampaignCreateNestedOneWithoutClinicPhoneNumbersInput = {
  connect?: Maybe<CampaignRegistryCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<CampaignRegistryCampaignCreateOrConnectWithoutClinicPhoneNumbersInput>;
  create?: Maybe<CampaignRegistryCampaignCreateWithoutClinicPhoneNumbersInput>;
};

export type CampaignRegistryCampaignCreateOrConnectWithoutClinicPhoneNumbersInput = {
  create: CampaignRegistryCampaignCreateWithoutClinicPhoneNumbersInput;
  where: CampaignRegistryCampaignWhereUniqueInput;
};

export type CampaignRegistryCampaignCreateOrConnectWithoutClinicSettingInput = {
  create: CampaignRegistryCampaignCreateWithoutClinicSettingInput;
  where: CampaignRegistryCampaignWhereUniqueInput;
};

export type CampaignRegistryCampaignCreateWithoutClinicPhoneNumbersInput = {
  clinicSetting: ClinicSettingCreateNestedOneWithoutCampaignRegistryCampaignsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignCreateWithoutClinicSettingInput = {
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutCampaignRegistryCampaignInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignGroupByOutputType = {
  __typename?: 'CampaignRegistryCampaignGroupByOutputType';
  _count?: Maybe<CampaignRegistryCampaignCountAggregateOutputType>;
  _max?: Maybe<CampaignRegistryCampaignMaxAggregateOutputType>;
  _min?: Maybe<CampaignRegistryCampaignMinAggregateOutputType>;
  clinicSettingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted: Scalars['Boolean'];
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignListRelationFilter = {
  every?: Maybe<CampaignRegistryCampaignWhereInput>;
  none?: Maybe<CampaignRegistryCampaignWhereInput>;
  some?: Maybe<CampaignRegistryCampaignWhereInput>;
};

export type CampaignRegistryCampaignMaxAggregateOutputType = {
  __typename?: 'CampaignRegistryCampaignMaxAggregateOutputType';
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignMaxOrderByAggregateInput = {
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  importedAt?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  sharingStatus?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  upstreamCnpId?: Maybe<SortOrder>;
};

export type CampaignRegistryCampaignMinAggregateOutputType = {
  __typename?: 'CampaignRegistryCampaignMinAggregateOutputType';
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignMinOrderByAggregateInput = {
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  importedAt?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  sharingStatus?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  upstreamCnpId?: Maybe<SortOrder>;
};

export type CampaignRegistryCampaignNullableScalarRelationFilter = {
  AND?: Maybe<Array<CampaignRegistryCampaignWhereInput>>;
  NOT?: Maybe<Array<CampaignRegistryCampaignWhereInput>>;
  OR?: Maybe<Array<CampaignRegistryCampaignWhereInput>>;
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberListRelationFilter>;
  clinicSetting?: Maybe<ClinicSettingScalarRelationFilter>;
  clinicSettingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  importedAt?: Maybe<DateTimeNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  mnoMetaData?: Maybe<JsonNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  sharingStatus?: Maybe<EnumCampaignRegistryCampaignSharingStatusNullableFilter>;
  sourceId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  upstreamCnpId?: Maybe<StringNullableFilter>;
};

export type CampaignRegistryCampaignOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CampaignRegistryCampaignOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CampaignRegistryCampaignOrderByRelevanceInput>;
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberOrderByRelationAggregateInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  importedAt?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  mnoMetaData?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  sharingStatus?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  upstreamCnpId?: Maybe<SortOrder>;
};

export enum CampaignRegistryCampaignOrderByRelevanceFieldEnum {
  ClinicSettingId = 'clinicSettingId',
  Id = 'id',
  SourceId = 'sourceId',
  UpstreamCnpId = 'upstreamCnpId'
}

export type CampaignRegistryCampaignOrderByRelevanceInput = {
  fields: Array<CampaignRegistryCampaignOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CampaignRegistryCampaignOrderByWithAggregationInput = {
  _count?: Maybe<CampaignRegistryCampaignCountOrderByAggregateInput>;
  _max?: Maybe<CampaignRegistryCampaignMaxOrderByAggregateInput>;
  _min?: Maybe<CampaignRegistryCampaignMinOrderByAggregateInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  importedAt?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  mnoMetaData?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  sharingStatus?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  upstreamCnpId?: Maybe<SortOrder>;
};

export type CampaignRegistryCampaignOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CampaignRegistryCampaignOrderByRelevanceInput>;
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberOrderByRelationAggregateInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  importedAt?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  mnoMetaData?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  sharingStatus?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  upstreamCnpId?: Maybe<SortOrder>;
};

export type CampaignRegistryCampaignOrderByWithRelationInput = {
  _relevance?: Maybe<CampaignRegistryCampaignOrderByRelevanceInput>;
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberOrderByRelationAggregateInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  importedAt?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  mnoMetaData?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  sharingStatus?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  upstreamCnpId?: Maybe<SortOrder>;
};

export enum CampaignRegistryCampaignScalarFieldEnum {
  ClinicSettingId = 'clinicSettingId',
  CreatedAt = 'createdAt',
  Id = 'id',
  ImportedAt = 'importedAt',
  IsDeleted = 'isDeleted',
  MnoMetaData = 'mnoMetaData',
  Settings = 'settings',
  SharingStatus = 'sharingStatus',
  SourceId = 'sourceId',
  UpdatedAt = 'updatedAt',
  UpstreamCnpId = 'upstreamCnpId'
}

export type CampaignRegistryCampaignScalarWhereInput = {
  AND?: Maybe<Array<CampaignRegistryCampaignScalarWhereInput>>;
  NOT?: Maybe<Array<CampaignRegistryCampaignScalarWhereInput>>;
  OR?: Maybe<Array<CampaignRegistryCampaignScalarWhereInput>>;
  clinicSettingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  importedAt?: Maybe<DateTimeNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  mnoMetaData?: Maybe<JsonNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  sharingStatus?: Maybe<EnumCampaignRegistryCampaignSharingStatusNullableFilter>;
  sourceId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  upstreamCnpId?: Maybe<StringNullableFilter>;
};

export type CampaignRegistryCampaignScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CampaignRegistryCampaignScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CampaignRegistryCampaignScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CampaignRegistryCampaignScalarWhereWithAggregatesInput>>;
  clinicSettingId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  importedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  mnoMetaData?: Maybe<JsonNullableWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  sharingStatus?: Maybe<EnumCampaignRegistryCampaignSharingStatusNullableWithAggregatesFilter>;
  sourceId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  upstreamCnpId?: Maybe<StringNullableWithAggregatesFilter>;
};

export enum CampaignRegistryCampaignSharingStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type CampaignRegistryCampaignUncheckedCreateInput = {
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutCampaignRegistryCampaignInput>;
  clinicSettingId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignUncheckedCreateNestedManyWithoutClinicSettingInput = {
  connect?: Maybe<Array<CampaignRegistryCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CampaignRegistryCampaignCreateOrConnectWithoutClinicSettingInput>>;
  create?: Maybe<Array<CampaignRegistryCampaignCreateWithoutClinicSettingInput>>;
  createMany?: Maybe<CampaignRegistryCampaignCreateManyClinicSettingInputEnvelope>;
};

export type CampaignRegistryCampaignUncheckedCreateWithoutClinicPhoneNumbersInput = {
  clinicSettingId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignUncheckedCreateWithoutClinicSettingInput = {
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutCampaignRegistryCampaignInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignUncheckedUpdateInput = {
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutCampaignRegistryCampaignNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignUncheckedUpdateManyInput = {
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignUncheckedUpdateManyWithoutClinicSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignUncheckedUpdateManyWithoutClinicSettingNestedInput = {
  connect?: Maybe<Array<CampaignRegistryCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CampaignRegistryCampaignCreateOrConnectWithoutClinicSettingInput>>;
  create?: Maybe<Array<CampaignRegistryCampaignCreateWithoutClinicSettingInput>>;
  createMany?: Maybe<CampaignRegistryCampaignCreateManyClinicSettingInputEnvelope>;
  delete?: Maybe<Array<CampaignRegistryCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CampaignRegistryCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<CampaignRegistryCampaignWhereUniqueInput>>;
  set?: Maybe<Array<CampaignRegistryCampaignWhereUniqueInput>>;
  update?: Maybe<Array<CampaignRegistryCampaignUpdateWithWhereUniqueWithoutClinicSettingInput>>;
  updateMany?: Maybe<Array<CampaignRegistryCampaignUpdateManyWithWhereWithoutClinicSettingInput>>;
  upsert?: Maybe<Array<CampaignRegistryCampaignUpsertWithWhereUniqueWithoutClinicSettingInput>>;
};

export type CampaignRegistryCampaignUncheckedUpdateWithoutClinicPhoneNumbersInput = {
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignUncheckedUpdateWithoutClinicSettingInput = {
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutCampaignRegistryCampaignNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignUpdateInput = {
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutCampaignRegistryCampaignNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneRequiredWithoutCampaignRegistryCampaignsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignUpdateManyWithWhereWithoutClinicSettingInput = {
  data: CampaignRegistryCampaignUpdateManyMutationInput;
  where: CampaignRegistryCampaignScalarWhereInput;
};

export type CampaignRegistryCampaignUpdateManyWithoutClinicSettingNestedInput = {
  connect?: Maybe<Array<CampaignRegistryCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CampaignRegistryCampaignCreateOrConnectWithoutClinicSettingInput>>;
  create?: Maybe<Array<CampaignRegistryCampaignCreateWithoutClinicSettingInput>>;
  createMany?: Maybe<CampaignRegistryCampaignCreateManyClinicSettingInputEnvelope>;
  delete?: Maybe<Array<CampaignRegistryCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CampaignRegistryCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<CampaignRegistryCampaignWhereUniqueInput>>;
  set?: Maybe<Array<CampaignRegistryCampaignWhereUniqueInput>>;
  update?: Maybe<Array<CampaignRegistryCampaignUpdateWithWhereUniqueWithoutClinicSettingInput>>;
  updateMany?: Maybe<Array<CampaignRegistryCampaignUpdateManyWithWhereWithoutClinicSettingInput>>;
  upsert?: Maybe<Array<CampaignRegistryCampaignUpsertWithWhereUniqueWithoutClinicSettingInput>>;
};

export type CampaignRegistryCampaignUpdateOneWithoutClinicPhoneNumbersNestedInput = {
  connect?: Maybe<CampaignRegistryCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<CampaignRegistryCampaignCreateOrConnectWithoutClinicPhoneNumbersInput>;
  create?: Maybe<CampaignRegistryCampaignCreateWithoutClinicPhoneNumbersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CampaignRegistryCampaignUpdateToOneWithWhereWithoutClinicPhoneNumbersInput>;
  upsert?: Maybe<CampaignRegistryCampaignUpsertWithoutClinicPhoneNumbersInput>;
};

export type CampaignRegistryCampaignUpdateToOneWithWhereWithoutClinicPhoneNumbersInput = {
  data: CampaignRegistryCampaignUpdateWithoutClinicPhoneNumbersInput;
  where?: Maybe<CampaignRegistryCampaignWhereInput>;
};

export type CampaignRegistryCampaignUpdateWithWhereUniqueWithoutClinicSettingInput = {
  data: CampaignRegistryCampaignUpdateWithoutClinicSettingInput;
  where: CampaignRegistryCampaignWhereUniqueInput;
};

export type CampaignRegistryCampaignUpdateWithoutClinicPhoneNumbersInput = {
  clinicSetting?: Maybe<ClinicSettingUpdateOneRequiredWithoutCampaignRegistryCampaignsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignUpdateWithoutClinicSettingInput = {
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutCampaignRegistryCampaignNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CampaignRegistryCampaignUpsertWithWhereUniqueWithoutClinicSettingInput = {
  create: CampaignRegistryCampaignCreateWithoutClinicSettingInput;
  update: CampaignRegistryCampaignUpdateWithoutClinicSettingInput;
  where: CampaignRegistryCampaignWhereUniqueInput;
};

export type CampaignRegistryCampaignUpsertWithoutClinicPhoneNumbersInput = {
  create: CampaignRegistryCampaignCreateWithoutClinicPhoneNumbersInput;
  update: CampaignRegistryCampaignUpdateWithoutClinicPhoneNumbersInput;
  where?: Maybe<CampaignRegistryCampaignWhereInput>;
};

export type CampaignRegistryCampaignWhereInput = {
  AND?: Maybe<Array<CampaignRegistryCampaignWhereInput>>;
  NOT?: Maybe<Array<CampaignRegistryCampaignWhereInput>>;
  OR?: Maybe<Array<CampaignRegistryCampaignWhereInput>>;
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberListRelationFilter>;
  clinicSetting?: Maybe<ClinicSettingScalarRelationFilter>;
  clinicSettingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  importedAt?: Maybe<DateTimeNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  mnoMetaData?: Maybe<JsonNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  sharingStatus?: Maybe<EnumCampaignRegistryCampaignSharingStatusNullableFilter>;
  sourceId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  upstreamCnpId?: Maybe<StringNullableFilter>;
};

export type CampaignRegistryCampaignWhereUniqueInput = {
  AND?: Maybe<Array<CampaignRegistryCampaignWhereInput>>;
  NOT?: Maybe<Array<CampaignRegistryCampaignWhereInput>>;
  OR?: Maybe<Array<CampaignRegistryCampaignWhereInput>>;
  clinicPhoneNumbers?: Maybe<ClinicPhoneNumberListRelationFilter>;
  clinicSetting?: Maybe<ClinicSettingScalarRelationFilter>;
  clinicSettingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  importedAt?: Maybe<DateTimeNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  mnoMetaData?: Maybe<JsonNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  sharingStatus?: Maybe<EnumCampaignRegistryCampaignSharingStatusNullableFilter>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
  upstreamCnpId?: Maybe<StringNullableFilter>;
};

export type CanManuallyRetryPaymentWritebackOutput = {
  __typename?: 'CanManuallyRetryPaymentWritebackOutput';
  reason?: Maybe<Scalars['String']>;
  retryAvailableAfter?: Maybe<Scalars['Date']>;
  retryable: Scalars['Boolean'];
};

export type CancelCareSubscriptionInput = {
  allowRefund?: Maybe<Scalars['Boolean']>;
  careSubscriptionId: Scalars['String'];
  trueUpInformation?: Maybe<CancellationTrueupInformation>;
};

export type CancelCareSubscriptionResult = {
  __typename?: 'CancelCareSubscriptionResult';
  messages: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum CancelReasonType {
  ChangedMind = 'ChangedMind',
  ClinicInitiatedOther = 'ClinicInitiatedOther',
  ClinicInitiatedUncollectible = 'ClinicInitiatedUncollectible',
  DeceasedPet = 'DeceasedPet',
  FinancialHardship = 'FinancialHardship',
  Moving = 'Moving',
  Other = 'Other',
  PetRehomed = 'PetRehomed'
}

export type CancellationTrueupInformation = {
  finalMonthAmount?: Maybe<Scalars['Int']>;
  firstDueDate: Scalars['Date'];
  monthlyAmount: Scalars['Int'];
  months: Scalars['Int'];
  paymentMethodId?: Maybe<Scalars['String']>;
  trueUpType?: Maybe<CareSubscriptionTrueUpType>;
};

export type CanonicalBreed = {
  __typename?: 'CanonicalBreed';
  _count: CanonicalBreedCountOutputType;
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup: Array<Breed>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfile>;
  canonicalSpecies: CanonicalSpecies;
  canonicalSpeciesId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informAudienceDefinitions: Array<InformAudienceDefinition>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt: Scalars['DateTime'];
};


export type CanonicalBreedBreedGroupArgs = {
  cursor?: Maybe<BreedWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BreedScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BreedOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BreedWhereInput>;
};


export type CanonicalBreedCanonicalCanineBreedProfileArgs = {
  where?: Maybe<CanonicalCanineBreedProfileWhereInput>;
};


export type CanonicalBreedInformAudienceDefinitionsArgs = {
  cursor?: Maybe<InformAudienceDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceDefinitionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};

export type CanonicalBreedAvgAggregateOutputType = {
  __typename?: 'CanonicalBreedAvgAggregateOutputType';
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
};

export type CanonicalBreedAvgOrderByAggregateInput = {
  avgHeightInCm?: Maybe<SortOrder>;
  avgLifeExpectancyInYears?: Maybe<SortOrder>;
  avgWeightInKg?: Maybe<SortOrder>;
  maxHeightInCm?: Maybe<SortOrder>;
  maxLifeExpectancyInYears?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minHeightInCm?: Maybe<SortOrder>;
  minLifeExpectancyInYears?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
};

export type CanonicalBreedCountAggregateOutputType = {
  __typename?: 'CanonicalBreedCountAggregateOutputType';
  _all: Scalars['Int'];
  avgHeightInCm: Scalars['Int'];
  avgLifeExpectancyInYears: Scalars['Int'];
  avgWeightInKg: Scalars['Int'];
  canonicalSpeciesId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  maxHeightInCm: Scalars['Int'];
  maxLifeExpectancyInYears: Scalars['Int'];
  maxWeightInKg: Scalars['Int'];
  minHeightInCm: Scalars['Int'];
  minLifeExpectancyInYears: Scalars['Int'];
  minWeightInKg: Scalars['Int'];
  name: Scalars['Int'];
  source: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CanonicalBreedCountOrderByAggregateInput = {
  avgHeightInCm?: Maybe<SortOrder>;
  avgLifeExpectancyInYears?: Maybe<SortOrder>;
  avgWeightInKg?: Maybe<SortOrder>;
  canonicalSpeciesId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  maxHeightInCm?: Maybe<SortOrder>;
  maxLifeExpectancyInYears?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minHeightInCm?: Maybe<SortOrder>;
  minLifeExpectancyInYears?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalBreedCountOutputType = {
  __typename?: 'CanonicalBreedCountOutputType';
  breedGroup: Scalars['Int'];
  informAudienceDefinitions: Scalars['Int'];
};

export type CanonicalBreedCreateInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedCreateNestedManyWithoutCanonicalBreedInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileCreateNestedOneWithoutCanonicalBreedInput>;
  canonicalSpecies: CanonicalSpeciesCreateNestedOneWithoutCanonicalBreedsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutCanonicalBreedsInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedCreateManyCanonicalSpeciesInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedCreateManyCanonicalSpeciesInputEnvelope = {
  data: Array<CanonicalBreedCreateManyCanonicalSpeciesInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CanonicalBreedCreateManyInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  canonicalSpeciesId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedCreateNestedManyWithoutCanonicalSpeciesInput = {
  connect?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalBreedCreateOrConnectWithoutCanonicalSpeciesInput>>;
  create?: Maybe<Array<CanonicalBreedCreateWithoutCanonicalSpeciesInput>>;
  createMany?: Maybe<CanonicalBreedCreateManyCanonicalSpeciesInputEnvelope>;
};

export type CanonicalBreedCreateNestedManyWithoutInformAudienceDefinitionsInput = {
  connect?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalBreedCreateOrConnectWithoutInformAudienceDefinitionsInput>>;
  create?: Maybe<Array<CanonicalBreedCreateWithoutInformAudienceDefinitionsInput>>;
};

export type CanonicalBreedCreateNestedOneWithoutBreedGroupInput = {
  connect?: Maybe<CanonicalBreedWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalBreedCreateOrConnectWithoutBreedGroupInput>;
  create?: Maybe<CanonicalBreedCreateWithoutBreedGroupInput>;
};

export type CanonicalBreedCreateNestedOneWithoutCanonicalCanineBreedProfileInput = {
  connect?: Maybe<CanonicalBreedWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalBreedCreateOrConnectWithoutCanonicalCanineBreedProfileInput>;
  create?: Maybe<CanonicalBreedCreateWithoutCanonicalCanineBreedProfileInput>;
};

export type CanonicalBreedCreateOrConnectWithoutBreedGroupInput = {
  create: CanonicalBreedCreateWithoutBreedGroupInput;
  where: CanonicalBreedWhereUniqueInput;
};

export type CanonicalBreedCreateOrConnectWithoutCanonicalCanineBreedProfileInput = {
  create: CanonicalBreedCreateWithoutCanonicalCanineBreedProfileInput;
  where: CanonicalBreedWhereUniqueInput;
};

export type CanonicalBreedCreateOrConnectWithoutCanonicalSpeciesInput = {
  create: CanonicalBreedCreateWithoutCanonicalSpeciesInput;
  where: CanonicalBreedWhereUniqueInput;
};

export type CanonicalBreedCreateOrConnectWithoutInformAudienceDefinitionsInput = {
  create: CanonicalBreedCreateWithoutInformAudienceDefinitionsInput;
  where: CanonicalBreedWhereUniqueInput;
};

export type CanonicalBreedCreateWithoutBreedGroupInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileCreateNestedOneWithoutCanonicalBreedInput>;
  canonicalSpecies: CanonicalSpeciesCreateNestedOneWithoutCanonicalBreedsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutCanonicalBreedsInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedCreateWithoutCanonicalCanineBreedProfileInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedCreateNestedManyWithoutCanonicalBreedInput>;
  canonicalSpecies: CanonicalSpeciesCreateNestedOneWithoutCanonicalBreedsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutCanonicalBreedsInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedCreateWithoutCanonicalSpeciesInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedCreateNestedManyWithoutCanonicalBreedInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileCreateNestedOneWithoutCanonicalBreedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutCanonicalBreedsInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedCreateWithoutInformAudienceDefinitionsInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedCreateNestedManyWithoutCanonicalBreedInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileCreateNestedOneWithoutCanonicalBreedInput>;
  canonicalSpecies: CanonicalSpeciesCreateNestedOneWithoutCanonicalBreedsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedGroupByOutputType = {
  __typename?: 'CanonicalBreedGroupByOutputType';
  _avg?: Maybe<CanonicalBreedAvgAggregateOutputType>;
  _count?: Maybe<CanonicalBreedCountAggregateOutputType>;
  _max?: Maybe<CanonicalBreedMaxAggregateOutputType>;
  _min?: Maybe<CanonicalBreedMinAggregateOutputType>;
  _sum?: Maybe<CanonicalBreedSumAggregateOutputType>;
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  canonicalSpeciesId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt: Scalars['DateTime'];
};

export type CanonicalBreedListRelationFilter = {
  every?: Maybe<CanonicalBreedWhereInput>;
  none?: Maybe<CanonicalBreedWhereInput>;
  some?: Maybe<CanonicalBreedWhereInput>;
};

export type CanonicalBreedMaxAggregateOutputType = {
  __typename?: 'CanonicalBreedMaxAggregateOutputType';
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  canonicalSpeciesId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedMaxOrderByAggregateInput = {
  avgHeightInCm?: Maybe<SortOrder>;
  avgLifeExpectancyInYears?: Maybe<SortOrder>;
  avgWeightInKg?: Maybe<SortOrder>;
  canonicalSpeciesId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  maxHeightInCm?: Maybe<SortOrder>;
  maxLifeExpectancyInYears?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minHeightInCm?: Maybe<SortOrder>;
  minLifeExpectancyInYears?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalBreedMinAggregateOutputType = {
  __typename?: 'CanonicalBreedMinAggregateOutputType';
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  canonicalSpeciesId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedMinOrderByAggregateInput = {
  avgHeightInCm?: Maybe<SortOrder>;
  avgLifeExpectancyInYears?: Maybe<SortOrder>;
  avgWeightInKg?: Maybe<SortOrder>;
  canonicalSpeciesId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  maxHeightInCm?: Maybe<SortOrder>;
  maxLifeExpectancyInYears?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minHeightInCm?: Maybe<SortOrder>;
  minLifeExpectancyInYears?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalBreedNameCanonicalSpeciesIdCompoundUniqueInput = {
  canonicalSpeciesId: Scalars['String'];
  name: Scalars['String'];
};

export type CanonicalBreedNullableScalarRelationFilter = {
  AND?: Maybe<Array<CanonicalBreedWhereInput>>;
  NOT?: Maybe<Array<CanonicalBreedWhereInput>>;
  OR?: Maybe<Array<CanonicalBreedWhereInput>>;
  avgHeightInCm?: Maybe<FloatNullableFilter>;
  avgLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  avgWeightInKg?: Maybe<FloatNullableFilter>;
  breedGroup?: Maybe<BreedListRelationFilter>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileNullableScalarRelationFilter>;
  canonicalSpecies?: Maybe<CanonicalSpeciesScalarRelationFilter>;
  canonicalSpeciesId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  maxHeightInCm?: Maybe<FloatNullableFilter>;
  maxLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  maxWeightInKg?: Maybe<FloatNullableFilter>;
  minHeightInCm?: Maybe<FloatNullableFilter>;
  minLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  minWeightInKg?: Maybe<FloatNullableFilter>;
  name?: Maybe<StringFilter>;
  source?: Maybe<EnumCanonicalDataSourceFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CanonicalBreedOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CanonicalBreedOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CanonicalBreedOrderByRelevanceInput>;
  avgHeightInCm?: Maybe<SortOrder>;
  avgLifeExpectancyInYears?: Maybe<SortOrder>;
  avgWeightInKg?: Maybe<SortOrder>;
  breedGroup?: Maybe<BreedOrderByRelationAggregateInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileOrderByWithRelationInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesOrderByWithRelationInput>;
  canonicalSpeciesId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionOrderByRelationAggregateInput>;
  maxHeightInCm?: Maybe<SortOrder>;
  maxLifeExpectancyInYears?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minHeightInCm?: Maybe<SortOrder>;
  minLifeExpectancyInYears?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CanonicalBreedOrderByRelevanceFieldEnum {
  CanonicalSpeciesId = 'canonicalSpeciesId',
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type CanonicalBreedOrderByRelevanceInput = {
  fields: Array<CanonicalBreedOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CanonicalBreedOrderByWithAggregationInput = {
  _avg?: Maybe<CanonicalBreedAvgOrderByAggregateInput>;
  _count?: Maybe<CanonicalBreedCountOrderByAggregateInput>;
  _max?: Maybe<CanonicalBreedMaxOrderByAggregateInput>;
  _min?: Maybe<CanonicalBreedMinOrderByAggregateInput>;
  _sum?: Maybe<CanonicalBreedSumOrderByAggregateInput>;
  avgHeightInCm?: Maybe<SortOrder>;
  avgLifeExpectancyInYears?: Maybe<SortOrder>;
  avgWeightInKg?: Maybe<SortOrder>;
  canonicalSpeciesId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  maxHeightInCm?: Maybe<SortOrder>;
  maxLifeExpectancyInYears?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minHeightInCm?: Maybe<SortOrder>;
  minLifeExpectancyInYears?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalBreedOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CanonicalBreedOrderByRelevanceInput>;
  avgHeightInCm?: Maybe<SortOrder>;
  avgLifeExpectancyInYears?: Maybe<SortOrder>;
  avgWeightInKg?: Maybe<SortOrder>;
  breedGroup?: Maybe<BreedOrderByRelationAggregateInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileOrderByWithRelationInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesOrderByWithRelationInput>;
  canonicalSpeciesId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionOrderByRelationAggregateInput>;
  maxHeightInCm?: Maybe<SortOrder>;
  maxLifeExpectancyInYears?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minHeightInCm?: Maybe<SortOrder>;
  minLifeExpectancyInYears?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalBreedOrderByWithRelationInput = {
  _relevance?: Maybe<CanonicalBreedOrderByRelevanceInput>;
  avgHeightInCm?: Maybe<SortOrder>;
  avgLifeExpectancyInYears?: Maybe<SortOrder>;
  avgWeightInKg?: Maybe<SortOrder>;
  breedGroup?: Maybe<BreedOrderByRelationAggregateInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileOrderByWithRelationInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesOrderByWithRelationInput>;
  canonicalSpeciesId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionOrderByRelationAggregateInput>;
  maxHeightInCm?: Maybe<SortOrder>;
  maxLifeExpectancyInYears?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minHeightInCm?: Maybe<SortOrder>;
  minLifeExpectancyInYears?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CanonicalBreedScalarFieldEnum {
  AvgHeightInCm = 'avgHeightInCm',
  AvgLifeExpectancyInYears = 'avgLifeExpectancyInYears',
  AvgWeightInKg = 'avgWeightInKg',
  CanonicalSpeciesId = 'canonicalSpeciesId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  MaxHeightInCm = 'maxHeightInCm',
  MaxLifeExpectancyInYears = 'maxLifeExpectancyInYears',
  MaxWeightInKg = 'maxWeightInKg',
  MinHeightInCm = 'minHeightInCm',
  MinLifeExpectancyInYears = 'minLifeExpectancyInYears',
  MinWeightInKg = 'minWeightInKg',
  Name = 'name',
  Source = 'source',
  UpdatedAt = 'updatedAt'
}

export type CanonicalBreedScalarRelationFilter = {
  AND?: Maybe<Array<CanonicalBreedWhereInput>>;
  NOT?: Maybe<Array<CanonicalBreedWhereInput>>;
  OR?: Maybe<Array<CanonicalBreedWhereInput>>;
  avgHeightInCm?: Maybe<FloatNullableFilter>;
  avgLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  avgWeightInKg?: Maybe<FloatNullableFilter>;
  breedGroup?: Maybe<BreedListRelationFilter>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileNullableScalarRelationFilter>;
  canonicalSpecies?: Maybe<CanonicalSpeciesScalarRelationFilter>;
  canonicalSpeciesId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  maxHeightInCm?: Maybe<FloatNullableFilter>;
  maxLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  maxWeightInKg?: Maybe<FloatNullableFilter>;
  minHeightInCm?: Maybe<FloatNullableFilter>;
  minLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  minWeightInKg?: Maybe<FloatNullableFilter>;
  name?: Maybe<StringFilter>;
  source?: Maybe<EnumCanonicalDataSourceFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CanonicalBreedScalarWhereInput = {
  AND?: Maybe<Array<CanonicalBreedScalarWhereInput>>;
  NOT?: Maybe<Array<CanonicalBreedScalarWhereInput>>;
  OR?: Maybe<Array<CanonicalBreedScalarWhereInput>>;
  avgHeightInCm?: Maybe<FloatNullableFilter>;
  avgLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  avgWeightInKg?: Maybe<FloatNullableFilter>;
  canonicalSpeciesId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  maxHeightInCm?: Maybe<FloatNullableFilter>;
  maxLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  maxWeightInKg?: Maybe<FloatNullableFilter>;
  minHeightInCm?: Maybe<FloatNullableFilter>;
  minLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  minWeightInKg?: Maybe<FloatNullableFilter>;
  name?: Maybe<StringFilter>;
  source?: Maybe<EnumCanonicalDataSourceFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CanonicalBreedScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CanonicalBreedScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CanonicalBreedScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CanonicalBreedScalarWhereWithAggregatesInput>>;
  avgHeightInCm?: Maybe<FloatNullableWithAggregatesFilter>;
  avgLifeExpectancyInYears?: Maybe<FloatNullableWithAggregatesFilter>;
  avgWeightInKg?: Maybe<FloatNullableWithAggregatesFilter>;
  canonicalSpeciesId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  maxHeightInCm?: Maybe<FloatNullableWithAggregatesFilter>;
  maxLifeExpectancyInYears?: Maybe<FloatNullableWithAggregatesFilter>;
  maxWeightInKg?: Maybe<FloatNullableWithAggregatesFilter>;
  minHeightInCm?: Maybe<FloatNullableWithAggregatesFilter>;
  minLifeExpectancyInYears?: Maybe<FloatNullableWithAggregatesFilter>;
  minWeightInKg?: Maybe<FloatNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  source?: Maybe<EnumCanonicalDataSourceWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CanonicalBreedSumAggregateOutputType = {
  __typename?: 'CanonicalBreedSumAggregateOutputType';
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
};

export type CanonicalBreedSumOrderByAggregateInput = {
  avgHeightInCm?: Maybe<SortOrder>;
  avgLifeExpectancyInYears?: Maybe<SortOrder>;
  avgWeightInKg?: Maybe<SortOrder>;
  maxHeightInCm?: Maybe<SortOrder>;
  maxLifeExpectancyInYears?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minHeightInCm?: Maybe<SortOrder>;
  minLifeExpectancyInYears?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
};

export type CanonicalBreedUncheckedCreateInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedUncheckedCreateNestedManyWithoutCanonicalBreedInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileUncheckedCreateNestedOneWithoutCanonicalBreedInput>;
  canonicalSpeciesId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalBreedsInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUncheckedCreateNestedManyWithoutCanonicalSpeciesInput = {
  connect?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalBreedCreateOrConnectWithoutCanonicalSpeciesInput>>;
  create?: Maybe<Array<CanonicalBreedCreateWithoutCanonicalSpeciesInput>>;
  createMany?: Maybe<CanonicalBreedCreateManyCanonicalSpeciesInputEnvelope>;
};

export type CanonicalBreedUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput = {
  connect?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalBreedCreateOrConnectWithoutInformAudienceDefinitionsInput>>;
  create?: Maybe<Array<CanonicalBreedCreateWithoutInformAudienceDefinitionsInput>>;
};

export type CanonicalBreedUncheckedCreateWithoutBreedGroupInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileUncheckedCreateNestedOneWithoutCanonicalBreedInput>;
  canonicalSpeciesId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalBreedsInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUncheckedCreateWithoutCanonicalCanineBreedProfileInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedUncheckedCreateNestedManyWithoutCanonicalBreedInput>;
  canonicalSpeciesId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalBreedsInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUncheckedCreateWithoutCanonicalSpeciesInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedUncheckedCreateNestedManyWithoutCanonicalBreedInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileUncheckedCreateNestedOneWithoutCanonicalBreedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalBreedsInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUncheckedCreateWithoutInformAudienceDefinitionsInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedUncheckedCreateNestedManyWithoutCanonicalBreedInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileUncheckedCreateNestedOneWithoutCanonicalBreedInput>;
  canonicalSpeciesId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUncheckedUpdateInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedUncheckedUpdateManyWithoutCanonicalBreedNestedInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileUncheckedUpdateOneWithoutCanonicalBreedNestedInput>;
  canonicalSpeciesId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalBreedsNestedInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUncheckedUpdateManyInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  canonicalSpeciesId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUncheckedUpdateManyWithoutCanonicalSpeciesInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUncheckedUpdateManyWithoutCanonicalSpeciesNestedInput = {
  connect?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalBreedCreateOrConnectWithoutCanonicalSpeciesInput>>;
  create?: Maybe<Array<CanonicalBreedCreateWithoutCanonicalSpeciesInput>>;
  createMany?: Maybe<CanonicalBreedCreateManyCanonicalSpeciesInputEnvelope>;
  delete?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CanonicalBreedScalarWhereInput>>;
  disconnect?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  set?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  update?: Maybe<Array<CanonicalBreedUpdateWithWhereUniqueWithoutCanonicalSpeciesInput>>;
  updateMany?: Maybe<Array<CanonicalBreedUpdateManyWithWhereWithoutCanonicalSpeciesInput>>;
  upsert?: Maybe<Array<CanonicalBreedUpsertWithWhereUniqueWithoutCanonicalSpeciesInput>>;
};

export type CanonicalBreedUncheckedUpdateManyWithoutInformAudienceDefinitionsInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  canonicalSpeciesId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput = {
  connect?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalBreedCreateOrConnectWithoutInformAudienceDefinitionsInput>>;
  create?: Maybe<Array<CanonicalBreedCreateWithoutInformAudienceDefinitionsInput>>;
  delete?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CanonicalBreedScalarWhereInput>>;
  disconnect?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  set?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  update?: Maybe<Array<CanonicalBreedUpdateWithWhereUniqueWithoutInformAudienceDefinitionsInput>>;
  updateMany?: Maybe<Array<CanonicalBreedUpdateManyWithWhereWithoutInformAudienceDefinitionsInput>>;
  upsert?: Maybe<Array<CanonicalBreedUpsertWithWhereUniqueWithoutInformAudienceDefinitionsInput>>;
};

export type CanonicalBreedUncheckedUpdateWithoutBreedGroupInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileUncheckedUpdateOneWithoutCanonicalBreedNestedInput>;
  canonicalSpeciesId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalBreedsNestedInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUncheckedUpdateWithoutCanonicalCanineBreedProfileInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedUncheckedUpdateManyWithoutCanonicalBreedNestedInput>;
  canonicalSpeciesId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalBreedsNestedInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUncheckedUpdateWithoutCanonicalSpeciesInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedUncheckedUpdateManyWithoutCanonicalBreedNestedInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileUncheckedUpdateOneWithoutCanonicalBreedNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalBreedsNestedInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUncheckedUpdateWithoutInformAudienceDefinitionsInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedUncheckedUpdateManyWithoutCanonicalBreedNestedInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileUncheckedUpdateOneWithoutCanonicalBreedNestedInput>;
  canonicalSpeciesId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUpdateInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedUpdateManyWithoutCanonicalBreedNestedInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileUpdateOneWithoutCanonicalBreedNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUpdateOneRequiredWithoutCanonicalBreedsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutCanonicalBreedsNestedInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUpdateManyMutationInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUpdateManyWithWhereWithoutCanonicalSpeciesInput = {
  data: CanonicalBreedUpdateManyMutationInput;
  where: CanonicalBreedScalarWhereInput;
};

export type CanonicalBreedUpdateManyWithWhereWithoutInformAudienceDefinitionsInput = {
  data: CanonicalBreedUpdateManyMutationInput;
  where: CanonicalBreedScalarWhereInput;
};

export type CanonicalBreedUpdateManyWithoutCanonicalSpeciesNestedInput = {
  connect?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalBreedCreateOrConnectWithoutCanonicalSpeciesInput>>;
  create?: Maybe<Array<CanonicalBreedCreateWithoutCanonicalSpeciesInput>>;
  createMany?: Maybe<CanonicalBreedCreateManyCanonicalSpeciesInputEnvelope>;
  delete?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CanonicalBreedScalarWhereInput>>;
  disconnect?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  set?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  update?: Maybe<Array<CanonicalBreedUpdateWithWhereUniqueWithoutCanonicalSpeciesInput>>;
  updateMany?: Maybe<Array<CanonicalBreedUpdateManyWithWhereWithoutCanonicalSpeciesInput>>;
  upsert?: Maybe<Array<CanonicalBreedUpsertWithWhereUniqueWithoutCanonicalSpeciesInput>>;
};

export type CanonicalBreedUpdateManyWithoutInformAudienceDefinitionsNestedInput = {
  connect?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalBreedCreateOrConnectWithoutInformAudienceDefinitionsInput>>;
  create?: Maybe<Array<CanonicalBreedCreateWithoutInformAudienceDefinitionsInput>>;
  delete?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CanonicalBreedScalarWhereInput>>;
  disconnect?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  set?: Maybe<Array<CanonicalBreedWhereUniqueInput>>;
  update?: Maybe<Array<CanonicalBreedUpdateWithWhereUniqueWithoutInformAudienceDefinitionsInput>>;
  updateMany?: Maybe<Array<CanonicalBreedUpdateManyWithWhereWithoutInformAudienceDefinitionsInput>>;
  upsert?: Maybe<Array<CanonicalBreedUpsertWithWhereUniqueWithoutInformAudienceDefinitionsInput>>;
};

export type CanonicalBreedUpdateOneRequiredWithoutCanonicalCanineBreedProfileNestedInput = {
  connect?: Maybe<CanonicalBreedWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalBreedCreateOrConnectWithoutCanonicalCanineBreedProfileInput>;
  create?: Maybe<CanonicalBreedCreateWithoutCanonicalCanineBreedProfileInput>;
  update?: Maybe<CanonicalBreedUpdateToOneWithWhereWithoutCanonicalCanineBreedProfileInput>;
  upsert?: Maybe<CanonicalBreedUpsertWithoutCanonicalCanineBreedProfileInput>;
};

export type CanonicalBreedUpdateOneWithoutBreedGroupNestedInput = {
  connect?: Maybe<CanonicalBreedWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalBreedCreateOrConnectWithoutBreedGroupInput>;
  create?: Maybe<CanonicalBreedCreateWithoutBreedGroupInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CanonicalBreedUpdateToOneWithWhereWithoutBreedGroupInput>;
  upsert?: Maybe<CanonicalBreedUpsertWithoutBreedGroupInput>;
};

export type CanonicalBreedUpdateToOneWithWhereWithoutBreedGroupInput = {
  data: CanonicalBreedUpdateWithoutBreedGroupInput;
  where?: Maybe<CanonicalBreedWhereInput>;
};

export type CanonicalBreedUpdateToOneWithWhereWithoutCanonicalCanineBreedProfileInput = {
  data: CanonicalBreedUpdateWithoutCanonicalCanineBreedProfileInput;
  where?: Maybe<CanonicalBreedWhereInput>;
};

export type CanonicalBreedUpdateWithWhereUniqueWithoutCanonicalSpeciesInput = {
  data: CanonicalBreedUpdateWithoutCanonicalSpeciesInput;
  where: CanonicalBreedWhereUniqueInput;
};

export type CanonicalBreedUpdateWithWhereUniqueWithoutInformAudienceDefinitionsInput = {
  data: CanonicalBreedUpdateWithoutInformAudienceDefinitionsInput;
  where: CanonicalBreedWhereUniqueInput;
};

export type CanonicalBreedUpdateWithoutBreedGroupInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileUpdateOneWithoutCanonicalBreedNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUpdateOneRequiredWithoutCanonicalBreedsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutCanonicalBreedsNestedInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUpdateWithoutCanonicalCanineBreedProfileInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedUpdateManyWithoutCanonicalBreedNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUpdateOneRequiredWithoutCanonicalBreedsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutCanonicalBreedsNestedInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUpdateWithoutCanonicalSpeciesInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedUpdateManyWithoutCanonicalBreedNestedInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileUpdateOneWithoutCanonicalBreedNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutCanonicalBreedsNestedInput>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUpdateWithoutInformAudienceDefinitionsInput = {
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  breedGroup?: Maybe<BreedUpdateManyWithoutCanonicalBreedNestedInput>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileUpdateOneWithoutCanonicalBreedNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUpdateOneRequiredWithoutCanonicalBreedsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<CanonicalDataSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalBreedUpsertWithWhereUniqueWithoutCanonicalSpeciesInput = {
  create: CanonicalBreedCreateWithoutCanonicalSpeciesInput;
  update: CanonicalBreedUpdateWithoutCanonicalSpeciesInput;
  where: CanonicalBreedWhereUniqueInput;
};

export type CanonicalBreedUpsertWithWhereUniqueWithoutInformAudienceDefinitionsInput = {
  create: CanonicalBreedCreateWithoutInformAudienceDefinitionsInput;
  update: CanonicalBreedUpdateWithoutInformAudienceDefinitionsInput;
  where: CanonicalBreedWhereUniqueInput;
};

export type CanonicalBreedUpsertWithoutBreedGroupInput = {
  create: CanonicalBreedCreateWithoutBreedGroupInput;
  update: CanonicalBreedUpdateWithoutBreedGroupInput;
  where?: Maybe<CanonicalBreedWhereInput>;
};

export type CanonicalBreedUpsertWithoutCanonicalCanineBreedProfileInput = {
  create: CanonicalBreedCreateWithoutCanonicalCanineBreedProfileInput;
  update: CanonicalBreedUpdateWithoutCanonicalCanineBreedProfileInput;
  where?: Maybe<CanonicalBreedWhereInput>;
};

export type CanonicalBreedWhereInput = {
  AND?: Maybe<Array<CanonicalBreedWhereInput>>;
  NOT?: Maybe<Array<CanonicalBreedWhereInput>>;
  OR?: Maybe<Array<CanonicalBreedWhereInput>>;
  avgHeightInCm?: Maybe<FloatNullableFilter>;
  avgLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  avgWeightInKg?: Maybe<FloatNullableFilter>;
  breedGroup?: Maybe<BreedListRelationFilter>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileNullableScalarRelationFilter>;
  canonicalSpecies?: Maybe<CanonicalSpeciesScalarRelationFilter>;
  canonicalSpeciesId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  maxHeightInCm?: Maybe<FloatNullableFilter>;
  maxLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  maxWeightInKg?: Maybe<FloatNullableFilter>;
  minHeightInCm?: Maybe<FloatNullableFilter>;
  minLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  minWeightInKg?: Maybe<FloatNullableFilter>;
  name?: Maybe<StringFilter>;
  source?: Maybe<EnumCanonicalDataSourceFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CanonicalBreedWhereUniqueInput = {
  AND?: Maybe<Array<CanonicalBreedWhereInput>>;
  NOT?: Maybe<Array<CanonicalBreedWhereInput>>;
  OR?: Maybe<Array<CanonicalBreedWhereInput>>;
  avgHeightInCm?: Maybe<FloatNullableFilter>;
  avgLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  avgWeightInKg?: Maybe<FloatNullableFilter>;
  breedGroup?: Maybe<BreedListRelationFilter>;
  canonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfileNullableScalarRelationFilter>;
  canonicalSpecies?: Maybe<CanonicalSpeciesScalarRelationFilter>;
  canonicalSpeciesId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  maxHeightInCm?: Maybe<FloatNullableFilter>;
  maxLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  maxWeightInKg?: Maybe<FloatNullableFilter>;
  minHeightInCm?: Maybe<FloatNullableFilter>;
  minLifeExpectancyInYears?: Maybe<FloatNullableFilter>;
  minWeightInKg?: Maybe<FloatNullableFilter>;
  name?: Maybe<StringFilter>;
  name_canonicalSpeciesId?: Maybe<CanonicalBreedNameCanonicalSpeciesIdCompoundUniqueInput>;
  source?: Maybe<EnumCanonicalDataSourceFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CanonicalCanineBreedProfile = {
  __typename?: 'CanonicalCanineBreedProfile';
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  canonicalBreed: CanonicalBreed;
  canonicalBreedId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id: Scalars['String'];
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament: Array<AmericanKennelClubBreedTemperament>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt: Scalars['DateTime'];
};

export type CanonicalCanineBreedProfileAvgAggregateOutputType = {
  __typename?: 'CanonicalCanineBreedProfileAvgAggregateOutputType';
  demeanor?: Maybe<Scalars['Float']>;
  energyLevel?: Maybe<Scalars['Float']>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  popularity?: Maybe<Scalars['Float']>;
  sheddingValue?: Maybe<Scalars['Float']>;
  trainability?: Maybe<Scalars['Float']>;
};

export type CanonicalCanineBreedProfileAvgOrderByAggregateInput = {
  demeanor?: Maybe<SortOrder>;
  energyLevel?: Maybe<SortOrder>;
  groomingFrequency?: Maybe<SortOrder>;
  popularity?: Maybe<SortOrder>;
  sheddingValue?: Maybe<SortOrder>;
  trainability?: Maybe<SortOrder>;
};

export type CanonicalCanineBreedProfileCountAggregateOutputType = {
  __typename?: 'CanonicalCanineBreedProfileCountAggregateOutputType';
  _all: Scalars['Int'];
  breedGroup: Scalars['Int'];
  canonicalBreedId: Scalars['Int'];
  createdAt: Scalars['Int'];
  demeanor: Scalars['Int'];
  demeanorCategory: Scalars['Int'];
  energyLevel: Scalars['Int'];
  energyLevelCategory: Scalars['Int'];
  groomingFrequency: Scalars['Int'];
  groomingFrequencyCategory: Scalars['Int'];
  id: Scalars['Int'];
  popularity: Scalars['Int'];
  sheddingCategory: Scalars['Int'];
  sheddingValue: Scalars['Int'];
  temperament: Scalars['Int'];
  trainability: Scalars['Int'];
  trainabilityCategory: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CanonicalCanineBreedProfileCountOrderByAggregateInput = {
  breedGroup?: Maybe<SortOrder>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  demeanor?: Maybe<SortOrder>;
  demeanorCategory?: Maybe<SortOrder>;
  energyLevel?: Maybe<SortOrder>;
  energyLevelCategory?: Maybe<SortOrder>;
  groomingFrequency?: Maybe<SortOrder>;
  groomingFrequencyCategory?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  popularity?: Maybe<SortOrder>;
  sheddingCategory?: Maybe<SortOrder>;
  sheddingValue?: Maybe<SortOrder>;
  temperament?: Maybe<SortOrder>;
  trainability?: Maybe<SortOrder>;
  trainabilityCategory?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalCanineBreedProfileCreateInput = {
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  canonicalBreed: CanonicalBreedCreateNestedOneWithoutCanonicalCanineBreedProfileInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileCreateManyInput = {
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  canonicalBreedId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileCreateNestedOneWithoutCanonicalBreedInput = {
  connect?: Maybe<CanonicalCanineBreedProfileWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalCanineBreedProfileCreateOrConnectWithoutCanonicalBreedInput>;
  create?: Maybe<CanonicalCanineBreedProfileCreateWithoutCanonicalBreedInput>;
};

export type CanonicalCanineBreedProfileCreateOrConnectWithoutCanonicalBreedInput = {
  create: CanonicalCanineBreedProfileCreateWithoutCanonicalBreedInput;
  where: CanonicalCanineBreedProfileWhereUniqueInput;
};

export type CanonicalCanineBreedProfileCreateWithoutCanonicalBreedInput = {
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileCreatetemperamentInput = {
  set: Array<AmericanKennelClubBreedTemperament>;
};

export type CanonicalCanineBreedProfileGroupByOutputType = {
  __typename?: 'CanonicalCanineBreedProfileGroupByOutputType';
  _avg?: Maybe<CanonicalCanineBreedProfileAvgAggregateOutputType>;
  _count?: Maybe<CanonicalCanineBreedProfileCountAggregateOutputType>;
  _max?: Maybe<CanonicalCanineBreedProfileMaxAggregateOutputType>;
  _min?: Maybe<CanonicalCanineBreedProfileMinAggregateOutputType>;
  _sum?: Maybe<CanonicalCanineBreedProfileSumAggregateOutputType>;
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  canonicalBreedId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id: Scalars['String'];
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt: Scalars['DateTime'];
};

export type CanonicalCanineBreedProfileMaxAggregateOutputType = {
  __typename?: 'CanonicalCanineBreedProfileMaxAggregateOutputType';
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileMaxOrderByAggregateInput = {
  breedGroup?: Maybe<SortOrder>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  demeanor?: Maybe<SortOrder>;
  demeanorCategory?: Maybe<SortOrder>;
  energyLevel?: Maybe<SortOrder>;
  energyLevelCategory?: Maybe<SortOrder>;
  groomingFrequency?: Maybe<SortOrder>;
  groomingFrequencyCategory?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  popularity?: Maybe<SortOrder>;
  sheddingCategory?: Maybe<SortOrder>;
  sheddingValue?: Maybe<SortOrder>;
  trainability?: Maybe<SortOrder>;
  trainabilityCategory?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalCanineBreedProfileMinAggregateOutputType = {
  __typename?: 'CanonicalCanineBreedProfileMinAggregateOutputType';
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileMinOrderByAggregateInput = {
  breedGroup?: Maybe<SortOrder>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  demeanor?: Maybe<SortOrder>;
  demeanorCategory?: Maybe<SortOrder>;
  energyLevel?: Maybe<SortOrder>;
  energyLevelCategory?: Maybe<SortOrder>;
  groomingFrequency?: Maybe<SortOrder>;
  groomingFrequencyCategory?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  popularity?: Maybe<SortOrder>;
  sheddingCategory?: Maybe<SortOrder>;
  sheddingValue?: Maybe<SortOrder>;
  trainability?: Maybe<SortOrder>;
  trainabilityCategory?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalCanineBreedProfileNullableScalarRelationFilter = {
  AND?: Maybe<Array<CanonicalCanineBreedProfileWhereInput>>;
  NOT?: Maybe<Array<CanonicalCanineBreedProfileWhereInput>>;
  OR?: Maybe<Array<CanonicalCanineBreedProfileWhereInput>>;
  breedGroup?: Maybe<EnumAmericanKennelClubBreedGroupNullableFilter>;
  canonicalBreed?: Maybe<CanonicalBreedScalarRelationFilter>;
  canonicalBreedId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  demeanor?: Maybe<FloatNullableFilter>;
  demeanorCategory?: Maybe<EnumAmericanKennelClubDemeanorCategoryNullableFilter>;
  energyLevel?: Maybe<FloatNullableFilter>;
  energyLevelCategory?: Maybe<EnumAmericanKennelClubEnergyLevelCategoryNullableFilter>;
  groomingFrequency?: Maybe<FloatNullableFilter>;
  groomingFrequencyCategory?: Maybe<EnumAmericanKennelClubGroomingFrequencyCategoryNullableFilter>;
  id?: Maybe<StringFilter>;
  popularity?: Maybe<IntNullableFilter>;
  sheddingCategory?: Maybe<EnumAmericanKennelClubSheddingCategoryNullableFilter>;
  sheddingValue?: Maybe<FloatNullableFilter>;
  temperament?: Maybe<EnumAmericanKennelClubBreedTemperamentNullableListFilter>;
  trainability?: Maybe<FloatNullableFilter>;
  trainabilityCategory?: Maybe<EnumAmericanKennelClubTrainabilityCategoryNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CanonicalCanineBreedProfileOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CanonicalCanineBreedProfileOrderByRelevanceInput>;
  breedGroup?: Maybe<SortOrder>;
  canonicalBreed?: Maybe<CanonicalBreedOrderByWithRelationInput>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  demeanor?: Maybe<SortOrder>;
  demeanorCategory?: Maybe<SortOrder>;
  energyLevel?: Maybe<SortOrder>;
  energyLevelCategory?: Maybe<SortOrder>;
  groomingFrequency?: Maybe<SortOrder>;
  groomingFrequencyCategory?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  popularity?: Maybe<SortOrder>;
  sheddingCategory?: Maybe<SortOrder>;
  sheddingValue?: Maybe<SortOrder>;
  temperament?: Maybe<SortOrder>;
  trainability?: Maybe<SortOrder>;
  trainabilityCategory?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CanonicalCanineBreedProfileOrderByRelevanceFieldEnum {
  CanonicalBreedId = 'canonicalBreedId',
  Id = 'id'
}

export type CanonicalCanineBreedProfileOrderByRelevanceInput = {
  fields: Array<CanonicalCanineBreedProfileOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CanonicalCanineBreedProfileOrderByWithAggregationInput = {
  _avg?: Maybe<CanonicalCanineBreedProfileAvgOrderByAggregateInput>;
  _count?: Maybe<CanonicalCanineBreedProfileCountOrderByAggregateInput>;
  _max?: Maybe<CanonicalCanineBreedProfileMaxOrderByAggregateInput>;
  _min?: Maybe<CanonicalCanineBreedProfileMinOrderByAggregateInput>;
  _sum?: Maybe<CanonicalCanineBreedProfileSumOrderByAggregateInput>;
  breedGroup?: Maybe<SortOrder>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  demeanor?: Maybe<SortOrder>;
  demeanorCategory?: Maybe<SortOrder>;
  energyLevel?: Maybe<SortOrder>;
  energyLevelCategory?: Maybe<SortOrder>;
  groomingFrequency?: Maybe<SortOrder>;
  groomingFrequencyCategory?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  popularity?: Maybe<SortOrder>;
  sheddingCategory?: Maybe<SortOrder>;
  sheddingValue?: Maybe<SortOrder>;
  temperament?: Maybe<SortOrder>;
  trainability?: Maybe<SortOrder>;
  trainabilityCategory?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalCanineBreedProfileOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CanonicalCanineBreedProfileOrderByRelevanceInput>;
  breedGroup?: Maybe<SortOrder>;
  canonicalBreed?: Maybe<CanonicalBreedOrderByWithRelationInput>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  demeanor?: Maybe<SortOrder>;
  demeanorCategory?: Maybe<SortOrder>;
  energyLevel?: Maybe<SortOrder>;
  energyLevelCategory?: Maybe<SortOrder>;
  groomingFrequency?: Maybe<SortOrder>;
  groomingFrequencyCategory?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  popularity?: Maybe<SortOrder>;
  sheddingCategory?: Maybe<SortOrder>;
  sheddingValue?: Maybe<SortOrder>;
  temperament?: Maybe<SortOrder>;
  trainability?: Maybe<SortOrder>;
  trainabilityCategory?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalCanineBreedProfileOrderByWithRelationInput = {
  _relevance?: Maybe<CanonicalCanineBreedProfileOrderByRelevanceInput>;
  breedGroup?: Maybe<SortOrder>;
  canonicalBreed?: Maybe<CanonicalBreedOrderByWithRelationInput>;
  canonicalBreedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  demeanor?: Maybe<SortOrder>;
  demeanorCategory?: Maybe<SortOrder>;
  energyLevel?: Maybe<SortOrder>;
  energyLevelCategory?: Maybe<SortOrder>;
  groomingFrequency?: Maybe<SortOrder>;
  groomingFrequencyCategory?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  popularity?: Maybe<SortOrder>;
  sheddingCategory?: Maybe<SortOrder>;
  sheddingValue?: Maybe<SortOrder>;
  temperament?: Maybe<SortOrder>;
  trainability?: Maybe<SortOrder>;
  trainabilityCategory?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CanonicalCanineBreedProfileScalarFieldEnum {
  BreedGroup = 'breedGroup',
  CanonicalBreedId = 'canonicalBreedId',
  CreatedAt = 'createdAt',
  Demeanor = 'demeanor',
  DemeanorCategory = 'demeanorCategory',
  EnergyLevel = 'energyLevel',
  EnergyLevelCategory = 'energyLevelCategory',
  GroomingFrequency = 'groomingFrequency',
  GroomingFrequencyCategory = 'groomingFrequencyCategory',
  Id = 'id',
  Popularity = 'popularity',
  SheddingCategory = 'sheddingCategory',
  SheddingValue = 'sheddingValue',
  Temperament = 'temperament',
  Trainability = 'trainability',
  TrainabilityCategory = 'trainabilityCategory',
  UpdatedAt = 'updatedAt'
}

export type CanonicalCanineBreedProfileScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CanonicalCanineBreedProfileScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CanonicalCanineBreedProfileScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CanonicalCanineBreedProfileScalarWhereWithAggregatesInput>>;
  breedGroup?: Maybe<EnumAmericanKennelClubBreedGroupNullableWithAggregatesFilter>;
  canonicalBreedId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  demeanor?: Maybe<FloatNullableWithAggregatesFilter>;
  demeanorCategory?: Maybe<EnumAmericanKennelClubDemeanorCategoryNullableWithAggregatesFilter>;
  energyLevel?: Maybe<FloatNullableWithAggregatesFilter>;
  energyLevelCategory?: Maybe<EnumAmericanKennelClubEnergyLevelCategoryNullableWithAggregatesFilter>;
  groomingFrequency?: Maybe<FloatNullableWithAggregatesFilter>;
  groomingFrequencyCategory?: Maybe<EnumAmericanKennelClubGroomingFrequencyCategoryNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  popularity?: Maybe<IntNullableWithAggregatesFilter>;
  sheddingCategory?: Maybe<EnumAmericanKennelClubSheddingCategoryNullableWithAggregatesFilter>;
  sheddingValue?: Maybe<FloatNullableWithAggregatesFilter>;
  temperament?: Maybe<EnumAmericanKennelClubBreedTemperamentNullableListFilter>;
  trainability?: Maybe<FloatNullableWithAggregatesFilter>;
  trainabilityCategory?: Maybe<EnumAmericanKennelClubTrainabilityCategoryNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CanonicalCanineBreedProfileSumAggregateOutputType = {
  __typename?: 'CanonicalCanineBreedProfileSumAggregateOutputType';
  demeanor?: Maybe<Scalars['Float']>;
  energyLevel?: Maybe<Scalars['Float']>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingValue?: Maybe<Scalars['Float']>;
  trainability?: Maybe<Scalars['Float']>;
};

export type CanonicalCanineBreedProfileSumOrderByAggregateInput = {
  demeanor?: Maybe<SortOrder>;
  energyLevel?: Maybe<SortOrder>;
  groomingFrequency?: Maybe<SortOrder>;
  popularity?: Maybe<SortOrder>;
  sheddingValue?: Maybe<SortOrder>;
  trainability?: Maybe<SortOrder>;
};

export type CanonicalCanineBreedProfileUncheckedCreateInput = {
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  canonicalBreedId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileUncheckedCreateNestedOneWithoutCanonicalBreedInput = {
  connect?: Maybe<CanonicalCanineBreedProfileWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalCanineBreedProfileCreateOrConnectWithoutCanonicalBreedInput>;
  create?: Maybe<CanonicalCanineBreedProfileCreateWithoutCanonicalBreedInput>;
};

export type CanonicalCanineBreedProfileUncheckedCreateWithoutCanonicalBreedInput = {
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileUncheckedUpdateInput = {
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileUncheckedUpdateManyInput = {
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileUncheckedUpdateOneWithoutCanonicalBreedNestedInput = {
  connect?: Maybe<CanonicalCanineBreedProfileWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalCanineBreedProfileCreateOrConnectWithoutCanonicalBreedInput>;
  create?: Maybe<CanonicalCanineBreedProfileCreateWithoutCanonicalBreedInput>;
  delete?: Maybe<CanonicalCanineBreedProfileWhereInput>;
  disconnect?: Maybe<CanonicalCanineBreedProfileWhereInput>;
  update?: Maybe<CanonicalCanineBreedProfileUpdateToOneWithWhereWithoutCanonicalBreedInput>;
  upsert?: Maybe<CanonicalCanineBreedProfileUpsertWithoutCanonicalBreedInput>;
};

export type CanonicalCanineBreedProfileUncheckedUpdateWithoutCanonicalBreedInput = {
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileUpdateInput = {
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  canonicalBreed?: Maybe<CanonicalBreedUpdateOneRequiredWithoutCanonicalCanineBreedProfileNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileUpdateManyMutationInput = {
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileUpdateOneWithoutCanonicalBreedNestedInput = {
  connect?: Maybe<CanonicalCanineBreedProfileWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalCanineBreedProfileCreateOrConnectWithoutCanonicalBreedInput>;
  create?: Maybe<CanonicalCanineBreedProfileCreateWithoutCanonicalBreedInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CanonicalCanineBreedProfileUpdateToOneWithWhereWithoutCanonicalBreedInput>;
  upsert?: Maybe<CanonicalCanineBreedProfileUpsertWithoutCanonicalBreedInput>;
};

export type CanonicalCanineBreedProfileUpdateToOneWithWhereWithoutCanonicalBreedInput = {
  data: CanonicalCanineBreedProfileUpdateWithoutCanonicalBreedInput;
  where?: Maybe<CanonicalCanineBreedProfileWhereInput>;
};

export type CanonicalCanineBreedProfileUpdateWithoutCanonicalBreedInput = {
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  createdAt?: Maybe<Scalars['DateTime']>;
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalCanineBreedProfileUpdatetemperamentInput = {
  push?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  set?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
};

export type CanonicalCanineBreedProfileUpsertWithoutCanonicalBreedInput = {
  create: CanonicalCanineBreedProfileCreateWithoutCanonicalBreedInput;
  update: CanonicalCanineBreedProfileUpdateWithoutCanonicalBreedInput;
  where?: Maybe<CanonicalCanineBreedProfileWhereInput>;
};

export type CanonicalCanineBreedProfileWhereInput = {
  AND?: Maybe<Array<CanonicalCanineBreedProfileWhereInput>>;
  NOT?: Maybe<Array<CanonicalCanineBreedProfileWhereInput>>;
  OR?: Maybe<Array<CanonicalCanineBreedProfileWhereInput>>;
  breedGroup?: Maybe<EnumAmericanKennelClubBreedGroupNullableFilter>;
  canonicalBreed?: Maybe<CanonicalBreedScalarRelationFilter>;
  canonicalBreedId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  demeanor?: Maybe<FloatNullableFilter>;
  demeanorCategory?: Maybe<EnumAmericanKennelClubDemeanorCategoryNullableFilter>;
  energyLevel?: Maybe<FloatNullableFilter>;
  energyLevelCategory?: Maybe<EnumAmericanKennelClubEnergyLevelCategoryNullableFilter>;
  groomingFrequency?: Maybe<FloatNullableFilter>;
  groomingFrequencyCategory?: Maybe<EnumAmericanKennelClubGroomingFrequencyCategoryNullableFilter>;
  id?: Maybe<StringFilter>;
  popularity?: Maybe<IntNullableFilter>;
  sheddingCategory?: Maybe<EnumAmericanKennelClubSheddingCategoryNullableFilter>;
  sheddingValue?: Maybe<FloatNullableFilter>;
  temperament?: Maybe<EnumAmericanKennelClubBreedTemperamentNullableListFilter>;
  trainability?: Maybe<FloatNullableFilter>;
  trainabilityCategory?: Maybe<EnumAmericanKennelClubTrainabilityCategoryNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CanonicalCanineBreedProfileWhereUniqueInput = {
  AND?: Maybe<Array<CanonicalCanineBreedProfileWhereInput>>;
  NOT?: Maybe<Array<CanonicalCanineBreedProfileWhereInput>>;
  OR?: Maybe<Array<CanonicalCanineBreedProfileWhereInput>>;
  breedGroup?: Maybe<EnumAmericanKennelClubBreedGroupNullableFilter>;
  canonicalBreed?: Maybe<CanonicalBreedScalarRelationFilter>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  demeanor?: Maybe<FloatNullableFilter>;
  demeanorCategory?: Maybe<EnumAmericanKennelClubDemeanorCategoryNullableFilter>;
  energyLevel?: Maybe<FloatNullableFilter>;
  energyLevelCategory?: Maybe<EnumAmericanKennelClubEnergyLevelCategoryNullableFilter>;
  groomingFrequency?: Maybe<FloatNullableFilter>;
  groomingFrequencyCategory?: Maybe<EnumAmericanKennelClubGroomingFrequencyCategoryNullableFilter>;
  id?: Maybe<Scalars['String']>;
  popularity?: Maybe<IntNullableFilter>;
  sheddingCategory?: Maybe<EnumAmericanKennelClubSheddingCategoryNullableFilter>;
  sheddingValue?: Maybe<FloatNullableFilter>;
  temperament?: Maybe<EnumAmericanKennelClubBreedTemperamentNullableListFilter>;
  trainability?: Maybe<FloatNullableFilter>;
  trainabilityCategory?: Maybe<EnumAmericanKennelClubTrainabilityCategoryNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum CanonicalDataSource {
  AmericanKennelClub = 'AmericanKennelClub'
}

export type CanonicalService = {
  __typename?: 'CanonicalService';
  _count: CanonicalServiceCountOutputType;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informAudienceDefinitions: Array<InformAudienceDefinition>;
  informCampaignEnrollmentCanonicalServices: Array<InformCampaignEnrollmentCanonicalService>;
  name: Scalars['String'];
  product?: Maybe<Product>;
  services: Array<Service>;
  status: CanonicalServiceStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt: Scalars['DateTime'];
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUser?: Maybe<User>;
  validatedByUserId?: Maybe<Scalars['String']>;
};


export type CanonicalServiceInformAudienceDefinitionsArgs = {
  cursor?: Maybe<InformAudienceDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceDefinitionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};


export type CanonicalServiceInformCampaignEnrollmentCanonicalServicesArgs = {
  cursor?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignEnrollmentCanonicalServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignEnrollmentCanonicalServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereInput>;
};


export type CanonicalServiceProductArgs = {
  where?: Maybe<ProductWhereInput>;
};


export type CanonicalServiceServicesArgs = {
  cursor?: Maybe<ServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceWhereInput>;
};


export type CanonicalServiceValidatedByUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type CanonicalServiceCountAggregateOutputType = {
  __typename?: 'CanonicalServiceCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  displayName: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  status: Scalars['Int'];
  statusMessage: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  validatedAt: Scalars['Int'];
  validatedByUserId: Scalars['Int'];
};

export type CanonicalServiceCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validatedAt?: Maybe<SortOrder>;
  validatedByUserId?: Maybe<SortOrder>;
};

export type CanonicalServiceCountOutputType = {
  __typename?: 'CanonicalServiceCountOutputType';
  informAudienceDefinitions: Scalars['Int'];
  informCampaignEnrollmentCanonicalServices: Scalars['Int'];
  services: Scalars['Int'];
};

export type CanonicalServiceCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutCanonicalServicesInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateNestedManyWithoutCanonicalServiceInput>;
  name: Scalars['String'];
  product?: Maybe<ProductCreateNestedOneWithoutCanonicalServiceInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutCanonicalServiceInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUser?: Maybe<UserCreateNestedOneWithoutValidatedCanonicalServicesInput>;
};

export type CanonicalServiceCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceCreateManyValidatedByUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalServiceCreateManyValidatedByUserInputEnvelope = {
  data: Array<CanonicalServiceCreateManyValidatedByUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CanonicalServiceCreateNestedManyWithoutInformAudienceDefinitionsInput = {
  connect?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalServiceCreateOrConnectWithoutInformAudienceDefinitionsInput>>;
  create?: Maybe<Array<CanonicalServiceCreateWithoutInformAudienceDefinitionsInput>>;
};

export type CanonicalServiceCreateNestedManyWithoutValidatedByUserInput = {
  connect?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalServiceCreateOrConnectWithoutValidatedByUserInput>>;
  create?: Maybe<Array<CanonicalServiceCreateWithoutValidatedByUserInput>>;
  createMany?: Maybe<CanonicalServiceCreateManyValidatedByUserInputEnvelope>;
};

export type CanonicalServiceCreateNestedOneWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  connect?: Maybe<CanonicalServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalServiceCreateOrConnectWithoutInformCampaignEnrollmentCanonicalServicesInput>;
  create?: Maybe<CanonicalServiceCreateWithoutInformCampaignEnrollmentCanonicalServicesInput>;
};

export type CanonicalServiceCreateNestedOneWithoutProductInput = {
  connect?: Maybe<CanonicalServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalServiceCreateOrConnectWithoutProductInput>;
  create?: Maybe<CanonicalServiceCreateWithoutProductInput>;
};

export type CanonicalServiceCreateNestedOneWithoutServicesInput = {
  connect?: Maybe<CanonicalServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalServiceCreateOrConnectWithoutServicesInput>;
  create?: Maybe<CanonicalServiceCreateWithoutServicesInput>;
};

export type CanonicalServiceCreateOrConnectWithoutInformAudienceDefinitionsInput = {
  create: CanonicalServiceCreateWithoutInformAudienceDefinitionsInput;
  where: CanonicalServiceWhereUniqueInput;
};

export type CanonicalServiceCreateOrConnectWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  create: CanonicalServiceCreateWithoutInformCampaignEnrollmentCanonicalServicesInput;
  where: CanonicalServiceWhereUniqueInput;
};

export type CanonicalServiceCreateOrConnectWithoutProductInput = {
  create: CanonicalServiceCreateWithoutProductInput;
  where: CanonicalServiceWhereUniqueInput;
};

export type CanonicalServiceCreateOrConnectWithoutServicesInput = {
  create: CanonicalServiceCreateWithoutServicesInput;
  where: CanonicalServiceWhereUniqueInput;
};

export type CanonicalServiceCreateOrConnectWithoutValidatedByUserInput = {
  create: CanonicalServiceCreateWithoutValidatedByUserInput;
  where: CanonicalServiceWhereUniqueInput;
};

export type CanonicalServiceCreateWithoutInformAudienceDefinitionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateNestedManyWithoutCanonicalServiceInput>;
  name: Scalars['String'];
  product?: Maybe<ProductCreateNestedOneWithoutCanonicalServiceInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutCanonicalServiceInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUser?: Maybe<UserCreateNestedOneWithoutValidatedCanonicalServicesInput>;
};

export type CanonicalServiceCreateWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutCanonicalServicesInput>;
  name: Scalars['String'];
  product?: Maybe<ProductCreateNestedOneWithoutCanonicalServiceInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutCanonicalServiceInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUser?: Maybe<UserCreateNestedOneWithoutValidatedCanonicalServicesInput>;
};

export type CanonicalServiceCreateWithoutProductInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutCanonicalServicesInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateNestedManyWithoutCanonicalServiceInput>;
  name: Scalars['String'];
  services?: Maybe<ServiceCreateNestedManyWithoutCanonicalServiceInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUser?: Maybe<UserCreateNestedOneWithoutValidatedCanonicalServicesInput>;
};

export type CanonicalServiceCreateWithoutServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutCanonicalServicesInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateNestedManyWithoutCanonicalServiceInput>;
  name: Scalars['String'];
  product?: Maybe<ProductCreateNestedOneWithoutCanonicalServiceInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUser?: Maybe<UserCreateNestedOneWithoutValidatedCanonicalServicesInput>;
};

export type CanonicalServiceCreateWithoutValidatedByUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutCanonicalServicesInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateNestedManyWithoutCanonicalServiceInput>;
  name: Scalars['String'];
  product?: Maybe<ProductCreateNestedOneWithoutCanonicalServiceInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutCanonicalServiceInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalServiceGroupByOutputType = {
  __typename?: 'CanonicalServiceGroupByOutputType';
  _count?: Maybe<CanonicalServiceCountAggregateOutputType>;
  _max?: Maybe<CanonicalServiceMaxAggregateOutputType>;
  _min?: Maybe<CanonicalServiceMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  status: CanonicalServiceStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt: Scalars['DateTime'];
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceListRelationFilter = {
  every?: Maybe<CanonicalServiceWhereInput>;
  none?: Maybe<CanonicalServiceWhereInput>;
  some?: Maybe<CanonicalServiceWhereInput>;
};

export type CanonicalServiceMaxAggregateOutputType = {
  __typename?: 'CanonicalServiceMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<CanonicalServiceStatus>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validatedAt?: Maybe<SortOrder>;
  validatedByUserId?: Maybe<SortOrder>;
};

export type CanonicalServiceMinAggregateOutputType = {
  __typename?: 'CanonicalServiceMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<CanonicalServiceStatus>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validatedAt?: Maybe<SortOrder>;
  validatedByUserId?: Maybe<SortOrder>;
};

export type CanonicalServiceNullableScalarRelationFilter = {
  AND?: Maybe<Array<CanonicalServiceWhereInput>>;
  NOT?: Maybe<Array<CanonicalServiceWhereInput>>;
  OR?: Maybe<Array<CanonicalServiceWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceListRelationFilter>;
  name?: Maybe<StringFilter>;
  product?: Maybe<ProductNullableScalarRelationFilter>;
  services?: Maybe<ServiceListRelationFilter>;
  status?: Maybe<EnumCanonicalServiceStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumCanonicalServiceTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  validatedAt?: Maybe<DateTimeNullableFilter>;
  validatedByUser?: Maybe<UserNullableScalarRelationFilter>;
  validatedByUserId?: Maybe<StringNullableFilter>;
};

export type CanonicalServiceOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CanonicalServiceOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CanonicalServiceOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionOrderByRelationAggregateInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  product?: Maybe<ProductOrderByWithRelationInput>;
  services?: Maybe<ServiceOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validatedAt?: Maybe<SortOrder>;
  validatedByUser?: Maybe<UserOrderByWithRelationInput>;
  validatedByUserId?: Maybe<SortOrder>;
};

export enum CanonicalServiceOrderByRelevanceFieldEnum {
  Description = 'description',
  DisplayName = 'displayName',
  Id = 'id',
  Name = 'name',
  ValidatedByUserId = 'validatedByUserId'
}

export type CanonicalServiceOrderByRelevanceInput = {
  fields: Array<CanonicalServiceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CanonicalServiceOrderByWithAggregationInput = {
  _count?: Maybe<CanonicalServiceCountOrderByAggregateInput>;
  _max?: Maybe<CanonicalServiceMaxOrderByAggregateInput>;
  _min?: Maybe<CanonicalServiceMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validatedAt?: Maybe<SortOrder>;
  validatedByUserId?: Maybe<SortOrder>;
};

export type CanonicalServiceOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CanonicalServiceOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionOrderByRelationAggregateInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  product?: Maybe<ProductOrderByWithRelationInput>;
  services?: Maybe<ServiceOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validatedAt?: Maybe<SortOrder>;
  validatedByUser?: Maybe<UserOrderByWithRelationInput>;
  validatedByUserId?: Maybe<SortOrder>;
};

export type CanonicalServiceOrderByWithRelationInput = {
  _relevance?: Maybe<CanonicalServiceOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionOrderByRelationAggregateInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  product?: Maybe<ProductOrderByWithRelationInput>;
  services?: Maybe<ServiceOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validatedAt?: Maybe<SortOrder>;
  validatedByUser?: Maybe<UserOrderByWithRelationInput>;
  validatedByUserId?: Maybe<SortOrder>;
};

export enum CanonicalServiceScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  DisplayName = 'displayName',
  Id = 'id',
  Name = 'name',
  Status = 'status',
  StatusMessage = 'statusMessage',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  ValidatedAt = 'validatedAt',
  ValidatedByUserId = 'validatedByUserId'
}

export type CanonicalServiceScalarRelationFilter = {
  AND?: Maybe<Array<CanonicalServiceWhereInput>>;
  NOT?: Maybe<Array<CanonicalServiceWhereInput>>;
  OR?: Maybe<Array<CanonicalServiceWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceListRelationFilter>;
  name?: Maybe<StringFilter>;
  product?: Maybe<ProductNullableScalarRelationFilter>;
  services?: Maybe<ServiceListRelationFilter>;
  status?: Maybe<EnumCanonicalServiceStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumCanonicalServiceTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  validatedAt?: Maybe<DateTimeNullableFilter>;
  validatedByUser?: Maybe<UserNullableScalarRelationFilter>;
  validatedByUserId?: Maybe<StringNullableFilter>;
};

export type CanonicalServiceScalarWhereInput = {
  AND?: Maybe<Array<CanonicalServiceScalarWhereInput>>;
  NOT?: Maybe<Array<CanonicalServiceScalarWhereInput>>;
  OR?: Maybe<Array<CanonicalServiceScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<EnumCanonicalServiceStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumCanonicalServiceTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  validatedAt?: Maybe<DateTimeNullableFilter>;
  validatedByUserId?: Maybe<StringNullableFilter>;
};

export type CanonicalServiceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CanonicalServiceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CanonicalServiceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CanonicalServiceScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  displayName?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumCanonicalServiceStatusWithAggregatesFilter>;
  statusMessage?: Maybe<JsonNullableWithAggregatesFilter>;
  type?: Maybe<EnumCanonicalServiceTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  validatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  validatedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
};

export enum CanonicalServiceStatus {
  NeedsReview = 'NeedsReview',
  Validated = 'Validated'
}

export enum CanonicalServiceType {
  Product = 'Product'
}

export type CanonicalServiceUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalServicesInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedCreateNestedManyWithoutCanonicalServiceInput>;
  name: Scalars['String'];
  product?: Maybe<ProductUncheckedCreateNestedOneWithoutCanonicalServiceInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutCanonicalServiceInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput = {
  connect?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalServiceCreateOrConnectWithoutInformAudienceDefinitionsInput>>;
  create?: Maybe<Array<CanonicalServiceCreateWithoutInformAudienceDefinitionsInput>>;
};

export type CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput = {
  connect?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalServiceCreateOrConnectWithoutValidatedByUserInput>>;
  create?: Maybe<Array<CanonicalServiceCreateWithoutValidatedByUserInput>>;
  createMany?: Maybe<CanonicalServiceCreateManyValidatedByUserInputEnvelope>;
};

export type CanonicalServiceUncheckedCreateWithoutInformAudienceDefinitionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedCreateNestedManyWithoutCanonicalServiceInput>;
  name: Scalars['String'];
  product?: Maybe<ProductUncheckedCreateNestedOneWithoutCanonicalServiceInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutCanonicalServiceInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceUncheckedCreateWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalServicesInput>;
  name: Scalars['String'];
  product?: Maybe<ProductUncheckedCreateNestedOneWithoutCanonicalServiceInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutCanonicalServiceInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceUncheckedCreateWithoutProductInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalServicesInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedCreateNestedManyWithoutCanonicalServiceInput>;
  name: Scalars['String'];
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutCanonicalServiceInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceUncheckedCreateWithoutServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalServicesInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedCreateNestedManyWithoutCanonicalServiceInput>;
  name: Scalars['String'];
  product?: Maybe<ProductUncheckedCreateNestedOneWithoutCanonicalServiceInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceUncheckedCreateWithoutValidatedByUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalServicesInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedCreateNestedManyWithoutCanonicalServiceInput>;
  name: Scalars['String'];
  product?: Maybe<ProductUncheckedCreateNestedOneWithoutCanonicalServiceInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutCanonicalServiceInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalServiceUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalServicesNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutCanonicalServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUncheckedUpdateOneWithoutCanonicalServiceNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutCanonicalServiceNestedInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceUncheckedUpdateManyWithoutInformAudienceDefinitionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput = {
  connect?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalServiceCreateOrConnectWithoutInformAudienceDefinitionsInput>>;
  create?: Maybe<Array<CanonicalServiceCreateWithoutInformAudienceDefinitionsInput>>;
  delete?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CanonicalServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  set?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  update?: Maybe<Array<CanonicalServiceUpdateWithWhereUniqueWithoutInformAudienceDefinitionsInput>>;
  updateMany?: Maybe<Array<CanonicalServiceUpdateManyWithWhereWithoutInformAudienceDefinitionsInput>>;
  upsert?: Maybe<Array<CanonicalServiceUpsertWithWhereUniqueWithoutInformAudienceDefinitionsInput>>;
};

export type CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput = {
  connect?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalServiceCreateOrConnectWithoutValidatedByUserInput>>;
  create?: Maybe<Array<CanonicalServiceCreateWithoutValidatedByUserInput>>;
  createMany?: Maybe<CanonicalServiceCreateManyValidatedByUserInputEnvelope>;
  delete?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CanonicalServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  set?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  update?: Maybe<Array<CanonicalServiceUpdateWithWhereUniqueWithoutValidatedByUserInput>>;
  updateMany?: Maybe<Array<CanonicalServiceUpdateManyWithWhereWithoutValidatedByUserInput>>;
  upsert?: Maybe<Array<CanonicalServiceUpsertWithWhereUniqueWithoutValidatedByUserInput>>;
};

export type CanonicalServiceUncheckedUpdateWithoutInformAudienceDefinitionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutCanonicalServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUncheckedUpdateOneWithoutCanonicalServiceNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutCanonicalServiceNestedInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceUncheckedUpdateWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalServicesNestedInput>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUncheckedUpdateOneWithoutCanonicalServiceNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutCanonicalServiceNestedInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceUncheckedUpdateWithoutProductInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalServicesNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutCanonicalServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutCanonicalServiceNestedInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceUncheckedUpdateWithoutServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalServicesNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutCanonicalServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUncheckedUpdateOneWithoutCanonicalServiceNestedInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CanonicalServiceUncheckedUpdateWithoutValidatedByUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalServicesNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutCanonicalServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUncheckedUpdateOneWithoutCanonicalServiceNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutCanonicalServiceNestedInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalServiceUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutCanonicalServicesNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUpdateManyWithoutCanonicalServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUpdateOneWithoutCanonicalServiceNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutCanonicalServiceNestedInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUser?: Maybe<UserUpdateOneWithoutValidatedCanonicalServicesNestedInput>;
};

export type CanonicalServiceUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalServiceUpdateManyWithWhereWithoutInformAudienceDefinitionsInput = {
  data: CanonicalServiceUpdateManyMutationInput;
  where: CanonicalServiceScalarWhereInput;
};

export type CanonicalServiceUpdateManyWithWhereWithoutValidatedByUserInput = {
  data: CanonicalServiceUpdateManyMutationInput;
  where: CanonicalServiceScalarWhereInput;
};

export type CanonicalServiceUpdateManyWithoutInformAudienceDefinitionsNestedInput = {
  connect?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalServiceCreateOrConnectWithoutInformAudienceDefinitionsInput>>;
  create?: Maybe<Array<CanonicalServiceCreateWithoutInformAudienceDefinitionsInput>>;
  delete?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CanonicalServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  set?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  update?: Maybe<Array<CanonicalServiceUpdateWithWhereUniqueWithoutInformAudienceDefinitionsInput>>;
  updateMany?: Maybe<Array<CanonicalServiceUpdateManyWithWhereWithoutInformAudienceDefinitionsInput>>;
  upsert?: Maybe<Array<CanonicalServiceUpsertWithWhereUniqueWithoutInformAudienceDefinitionsInput>>;
};

export type CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput = {
  connect?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalServiceCreateOrConnectWithoutValidatedByUserInput>>;
  create?: Maybe<Array<CanonicalServiceCreateWithoutValidatedByUserInput>>;
  createMany?: Maybe<CanonicalServiceCreateManyValidatedByUserInputEnvelope>;
  delete?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CanonicalServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  set?: Maybe<Array<CanonicalServiceWhereUniqueInput>>;
  update?: Maybe<Array<CanonicalServiceUpdateWithWhereUniqueWithoutValidatedByUserInput>>;
  updateMany?: Maybe<Array<CanonicalServiceUpdateManyWithWhereWithoutValidatedByUserInput>>;
  upsert?: Maybe<Array<CanonicalServiceUpsertWithWhereUniqueWithoutValidatedByUserInput>>;
};

export type CanonicalServiceUpdateOneRequiredWithoutInformCampaignEnrollmentCanonicalServicesNestedInput = {
  connect?: Maybe<CanonicalServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalServiceCreateOrConnectWithoutInformCampaignEnrollmentCanonicalServicesInput>;
  create?: Maybe<CanonicalServiceCreateWithoutInformCampaignEnrollmentCanonicalServicesInput>;
  update?: Maybe<CanonicalServiceUpdateToOneWithWhereWithoutInformCampaignEnrollmentCanonicalServicesInput>;
  upsert?: Maybe<CanonicalServiceUpsertWithoutInformCampaignEnrollmentCanonicalServicesInput>;
};

export type CanonicalServiceUpdateOneRequiredWithoutProductNestedInput = {
  connect?: Maybe<CanonicalServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalServiceCreateOrConnectWithoutProductInput>;
  create?: Maybe<CanonicalServiceCreateWithoutProductInput>;
  update?: Maybe<CanonicalServiceUpdateToOneWithWhereWithoutProductInput>;
  upsert?: Maybe<CanonicalServiceUpsertWithoutProductInput>;
};

export type CanonicalServiceUpdateOneWithoutServicesNestedInput = {
  connect?: Maybe<CanonicalServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalServiceCreateOrConnectWithoutServicesInput>;
  create?: Maybe<CanonicalServiceCreateWithoutServicesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CanonicalServiceUpdateToOneWithWhereWithoutServicesInput>;
  upsert?: Maybe<CanonicalServiceUpsertWithoutServicesInput>;
};

export type CanonicalServiceUpdateToOneWithWhereWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  data: CanonicalServiceUpdateWithoutInformCampaignEnrollmentCanonicalServicesInput;
  where?: Maybe<CanonicalServiceWhereInput>;
};

export type CanonicalServiceUpdateToOneWithWhereWithoutProductInput = {
  data: CanonicalServiceUpdateWithoutProductInput;
  where?: Maybe<CanonicalServiceWhereInput>;
};

export type CanonicalServiceUpdateToOneWithWhereWithoutServicesInput = {
  data: CanonicalServiceUpdateWithoutServicesInput;
  where?: Maybe<CanonicalServiceWhereInput>;
};

export type CanonicalServiceUpdateWithWhereUniqueWithoutInformAudienceDefinitionsInput = {
  data: CanonicalServiceUpdateWithoutInformAudienceDefinitionsInput;
  where: CanonicalServiceWhereUniqueInput;
};

export type CanonicalServiceUpdateWithWhereUniqueWithoutValidatedByUserInput = {
  data: CanonicalServiceUpdateWithoutValidatedByUserInput;
  where: CanonicalServiceWhereUniqueInput;
};

export type CanonicalServiceUpdateWithoutInformAudienceDefinitionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUpdateManyWithoutCanonicalServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUpdateOneWithoutCanonicalServiceNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutCanonicalServiceNestedInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUser?: Maybe<UserUpdateOneWithoutValidatedCanonicalServicesNestedInput>;
};

export type CanonicalServiceUpdateWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutCanonicalServicesNestedInput>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUpdateOneWithoutCanonicalServiceNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutCanonicalServiceNestedInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUser?: Maybe<UserUpdateOneWithoutValidatedCanonicalServicesNestedInput>;
};

export type CanonicalServiceUpdateWithoutProductInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutCanonicalServicesNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUpdateManyWithoutCanonicalServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  services?: Maybe<ServiceUpdateManyWithoutCanonicalServiceNestedInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUser?: Maybe<UserUpdateOneWithoutValidatedCanonicalServicesNestedInput>;
};

export type CanonicalServiceUpdateWithoutServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutCanonicalServicesNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUpdateManyWithoutCanonicalServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUpdateOneWithoutCanonicalServiceNestedInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUser?: Maybe<UserUpdateOneWithoutValidatedCanonicalServicesNestedInput>;
};

export type CanonicalServiceUpdateWithoutValidatedByUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutCanonicalServicesNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUpdateManyWithoutCanonicalServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUpdateOneWithoutCanonicalServiceNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutCanonicalServiceNestedInput>;
  status?: Maybe<CanonicalServiceStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<CanonicalServiceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalServiceUpsertWithWhereUniqueWithoutInformAudienceDefinitionsInput = {
  create: CanonicalServiceCreateWithoutInformAudienceDefinitionsInput;
  update: CanonicalServiceUpdateWithoutInformAudienceDefinitionsInput;
  where: CanonicalServiceWhereUniqueInput;
};

export type CanonicalServiceUpsertWithWhereUniqueWithoutValidatedByUserInput = {
  create: CanonicalServiceCreateWithoutValidatedByUserInput;
  update: CanonicalServiceUpdateWithoutValidatedByUserInput;
  where: CanonicalServiceWhereUniqueInput;
};

export type CanonicalServiceUpsertWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  create: CanonicalServiceCreateWithoutInformCampaignEnrollmentCanonicalServicesInput;
  update: CanonicalServiceUpdateWithoutInformCampaignEnrollmentCanonicalServicesInput;
  where?: Maybe<CanonicalServiceWhereInput>;
};

export type CanonicalServiceUpsertWithoutProductInput = {
  create: CanonicalServiceCreateWithoutProductInput;
  update: CanonicalServiceUpdateWithoutProductInput;
  where?: Maybe<CanonicalServiceWhereInput>;
};

export type CanonicalServiceUpsertWithoutServicesInput = {
  create: CanonicalServiceCreateWithoutServicesInput;
  update: CanonicalServiceUpdateWithoutServicesInput;
  where?: Maybe<CanonicalServiceWhereInput>;
};

export type CanonicalServiceWhereInput = {
  AND?: Maybe<Array<CanonicalServiceWhereInput>>;
  NOT?: Maybe<Array<CanonicalServiceWhereInput>>;
  OR?: Maybe<Array<CanonicalServiceWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceListRelationFilter>;
  name?: Maybe<StringFilter>;
  product?: Maybe<ProductNullableScalarRelationFilter>;
  services?: Maybe<ServiceListRelationFilter>;
  status?: Maybe<EnumCanonicalServiceStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumCanonicalServiceTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  validatedAt?: Maybe<DateTimeNullableFilter>;
  validatedByUser?: Maybe<UserNullableScalarRelationFilter>;
  validatedByUserId?: Maybe<StringNullableFilter>;
};

export type CanonicalServiceWhereUniqueInput = {
  AND?: Maybe<Array<CanonicalServiceWhereInput>>;
  NOT?: Maybe<Array<CanonicalServiceWhereInput>>;
  OR?: Maybe<Array<CanonicalServiceWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceListRelationFilter>;
  name?: Maybe<StringFilter>;
  product?: Maybe<ProductNullableScalarRelationFilter>;
  services?: Maybe<ServiceListRelationFilter>;
  status?: Maybe<EnumCanonicalServiceStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumCanonicalServiceTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  validatedAt?: Maybe<DateTimeNullableFilter>;
  validatedByUser?: Maybe<UserNullableScalarRelationFilter>;
  validatedByUserId?: Maybe<StringNullableFilter>;
};

export type CanonicalSpecies = {
  __typename?: 'CanonicalSpecies';
  _count: CanonicalSpeciesCountOutputType;
  canonicalBreeds: Array<CanonicalBreed>;
  class?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informAudienceDefinitions: Array<InformAudienceDefinition>;
  kingdom?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type CanonicalSpeciesCanonicalBreedsArgs = {
  cursor?: Maybe<CanonicalBreedWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalBreedScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalBreedOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalBreedWhereInput>;
};


export type CanonicalSpeciesInformAudienceDefinitionsArgs = {
  cursor?: Maybe<InformAudienceDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceDefinitionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};

export type CanonicalSpeciesCountAggregateOutputType = {
  __typename?: 'CanonicalSpeciesCountAggregateOutputType';
  _all: Scalars['Int'];
  class: Scalars['Int'];
  createdAt: Scalars['Int'];
  family: Scalars['Int'];
  genus: Scalars['Int'];
  id: Scalars['Int'];
  kingdom: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  phylum: Scalars['Int'];
  scientificName: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CanonicalSpeciesCountOrderByAggregateInput = {
  class?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  family?: Maybe<SortOrder>;
  genus?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  kingdom?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  phylum?: Maybe<SortOrder>;
  scientificName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalSpeciesCountOutputType = {
  __typename?: 'CanonicalSpeciesCountOutputType';
  canonicalBreeds: Scalars['Int'];
  informAudienceDefinitions: Scalars['Int'];
};

export type CanonicalSpeciesCreateInput = {
  canonicalBreeds?: Maybe<CanonicalBreedCreateNestedManyWithoutCanonicalSpeciesInput>;
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutCanonicalSpeciesInput>;
  kingdom?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesCreateManyInput = {
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kingdom?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesCreateNestedManyWithoutInformAudienceDefinitionsInput = {
  connect?: Maybe<Array<CanonicalSpeciesWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalSpeciesCreateOrConnectWithoutInformAudienceDefinitionsInput>>;
  create?: Maybe<Array<CanonicalSpeciesCreateWithoutInformAudienceDefinitionsInput>>;
};

export type CanonicalSpeciesCreateNestedOneWithoutCanonicalBreedsInput = {
  connect?: Maybe<CanonicalSpeciesWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalSpeciesCreateOrConnectWithoutCanonicalBreedsInput>;
  create?: Maybe<CanonicalSpeciesCreateWithoutCanonicalBreedsInput>;
};

export type CanonicalSpeciesCreateOrConnectWithoutCanonicalBreedsInput = {
  create: CanonicalSpeciesCreateWithoutCanonicalBreedsInput;
  where: CanonicalSpeciesWhereUniqueInput;
};

export type CanonicalSpeciesCreateOrConnectWithoutInformAudienceDefinitionsInput = {
  create: CanonicalSpeciesCreateWithoutInformAudienceDefinitionsInput;
  where: CanonicalSpeciesWhereUniqueInput;
};

export type CanonicalSpeciesCreateWithoutCanonicalBreedsInput = {
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutCanonicalSpeciesInput>;
  kingdom?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesCreateWithoutInformAudienceDefinitionsInput = {
  canonicalBreeds?: Maybe<CanonicalBreedCreateNestedManyWithoutCanonicalSpeciesInput>;
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kingdom?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesGroupByOutputType = {
  __typename?: 'CanonicalSpeciesGroupByOutputType';
  _count?: Maybe<CanonicalSpeciesCountAggregateOutputType>;
  _max?: Maybe<CanonicalSpeciesMaxAggregateOutputType>;
  _min?: Maybe<CanonicalSpeciesMinAggregateOutputType>;
  class?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  kingdom?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CanonicalSpeciesListRelationFilter = {
  every?: Maybe<CanonicalSpeciesWhereInput>;
  none?: Maybe<CanonicalSpeciesWhereInput>;
  some?: Maybe<CanonicalSpeciesWhereInput>;
};

export type CanonicalSpeciesMaxAggregateOutputType = {
  __typename?: 'CanonicalSpeciesMaxAggregateOutputType';
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kingdom?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesMaxOrderByAggregateInput = {
  class?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  family?: Maybe<SortOrder>;
  genus?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  kingdom?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  phylum?: Maybe<SortOrder>;
  scientificName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalSpeciesMinAggregateOutputType = {
  __typename?: 'CanonicalSpeciesMinAggregateOutputType';
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kingdom?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesMinOrderByAggregateInput = {
  class?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  family?: Maybe<SortOrder>;
  genus?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  kingdom?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  phylum?: Maybe<SortOrder>;
  scientificName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalSpeciesOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CanonicalSpeciesOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CanonicalSpeciesOrderByRelevanceInput>;
  canonicalBreeds?: Maybe<CanonicalBreedOrderByRelationAggregateInput>;
  class?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  family?: Maybe<SortOrder>;
  genus?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionOrderByRelationAggregateInput>;
  kingdom?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  phylum?: Maybe<SortOrder>;
  scientificName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CanonicalSpeciesOrderByRelevanceFieldEnum {
  Class = 'class',
  Family = 'family',
  Genus = 'genus',
  Id = 'id',
  Kingdom = 'kingdom',
  Name = 'name',
  Order = 'order',
  Phylum = 'phylum',
  ScientificName = 'scientificName'
}

export type CanonicalSpeciesOrderByRelevanceInput = {
  fields: Array<CanonicalSpeciesOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CanonicalSpeciesOrderByWithAggregationInput = {
  _count?: Maybe<CanonicalSpeciesCountOrderByAggregateInput>;
  _max?: Maybe<CanonicalSpeciesMaxOrderByAggregateInput>;
  _min?: Maybe<CanonicalSpeciesMinOrderByAggregateInput>;
  class?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  family?: Maybe<SortOrder>;
  genus?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  kingdom?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  phylum?: Maybe<SortOrder>;
  scientificName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalSpeciesOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CanonicalSpeciesOrderByRelevanceInput>;
  canonicalBreeds?: Maybe<CanonicalBreedOrderByRelationAggregateInput>;
  class?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  family?: Maybe<SortOrder>;
  genus?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionOrderByRelationAggregateInput>;
  kingdom?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  phylum?: Maybe<SortOrder>;
  scientificName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CanonicalSpeciesOrderByWithRelationInput = {
  _relevance?: Maybe<CanonicalSpeciesOrderByRelevanceInput>;
  canonicalBreeds?: Maybe<CanonicalBreedOrderByRelationAggregateInput>;
  class?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  family?: Maybe<SortOrder>;
  genus?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionOrderByRelationAggregateInput>;
  kingdom?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  phylum?: Maybe<SortOrder>;
  scientificName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CanonicalSpeciesScalarFieldEnum {
  Class = 'class',
  CreatedAt = 'createdAt',
  Family = 'family',
  Genus = 'genus',
  Id = 'id',
  Kingdom = 'kingdom',
  Name = 'name',
  Order = 'order',
  Phylum = 'phylum',
  ScientificName = 'scientificName',
  UpdatedAt = 'updatedAt'
}

export type CanonicalSpeciesScalarRelationFilter = {
  AND?: Maybe<Array<CanonicalSpeciesWhereInput>>;
  NOT?: Maybe<Array<CanonicalSpeciesWhereInput>>;
  OR?: Maybe<Array<CanonicalSpeciesWhereInput>>;
  canonicalBreeds?: Maybe<CanonicalBreedListRelationFilter>;
  class?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  family?: Maybe<StringNullableFilter>;
  genus?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  kingdom?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  order?: Maybe<StringNullableFilter>;
  phylum?: Maybe<StringNullableFilter>;
  scientificName?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CanonicalSpeciesScalarWhereInput = {
  AND?: Maybe<Array<CanonicalSpeciesScalarWhereInput>>;
  NOT?: Maybe<Array<CanonicalSpeciesScalarWhereInput>>;
  OR?: Maybe<Array<CanonicalSpeciesScalarWhereInput>>;
  class?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  family?: Maybe<StringNullableFilter>;
  genus?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  kingdom?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  order?: Maybe<StringNullableFilter>;
  phylum?: Maybe<StringNullableFilter>;
  scientificName?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CanonicalSpeciesScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CanonicalSpeciesScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CanonicalSpeciesScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CanonicalSpeciesScalarWhereWithAggregatesInput>>;
  class?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  family?: Maybe<StringNullableWithAggregatesFilter>;
  genus?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  kingdom?: Maybe<StringNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  order?: Maybe<StringNullableWithAggregatesFilter>;
  phylum?: Maybe<StringNullableWithAggregatesFilter>;
  scientificName?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CanonicalSpeciesUncheckedCreateInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedCreateNestedManyWithoutCanonicalSpeciesInput>;
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalSpeciesInput>;
  kingdom?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput = {
  connect?: Maybe<Array<CanonicalSpeciesWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalSpeciesCreateOrConnectWithoutInformAudienceDefinitionsInput>>;
  create?: Maybe<Array<CanonicalSpeciesCreateWithoutInformAudienceDefinitionsInput>>;
};

export type CanonicalSpeciesUncheckedCreateWithoutCanonicalBreedsInput = {
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalSpeciesInput>;
  kingdom?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesUncheckedCreateWithoutInformAudienceDefinitionsInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedCreateNestedManyWithoutCanonicalSpeciesInput>;
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kingdom?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesUncheckedUpdateInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedUpdateManyWithoutCanonicalSpeciesNestedInput>;
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalSpeciesNestedInput>;
  kingdom?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesUncheckedUpdateManyInput = {
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kingdom?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesUncheckedUpdateManyWithoutInformAudienceDefinitionsInput = {
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kingdom?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput = {
  connect?: Maybe<Array<CanonicalSpeciesWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalSpeciesCreateOrConnectWithoutInformAudienceDefinitionsInput>>;
  create?: Maybe<Array<CanonicalSpeciesCreateWithoutInformAudienceDefinitionsInput>>;
  delete?: Maybe<Array<CanonicalSpeciesWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CanonicalSpeciesScalarWhereInput>>;
  disconnect?: Maybe<Array<CanonicalSpeciesWhereUniqueInput>>;
  set?: Maybe<Array<CanonicalSpeciesWhereUniqueInput>>;
  update?: Maybe<Array<CanonicalSpeciesUpdateWithWhereUniqueWithoutInformAudienceDefinitionsInput>>;
  updateMany?: Maybe<Array<CanonicalSpeciesUpdateManyWithWhereWithoutInformAudienceDefinitionsInput>>;
  upsert?: Maybe<Array<CanonicalSpeciesUpsertWithWhereUniqueWithoutInformAudienceDefinitionsInput>>;
};

export type CanonicalSpeciesUncheckedUpdateWithoutCanonicalBreedsInput = {
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalSpeciesNestedInput>;
  kingdom?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesUncheckedUpdateWithoutInformAudienceDefinitionsInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedUpdateManyWithoutCanonicalSpeciesNestedInput>;
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kingdom?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesUpdateInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUpdateManyWithoutCanonicalSpeciesNestedInput>;
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutCanonicalSpeciesNestedInput>;
  kingdom?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesUpdateManyMutationInput = {
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kingdom?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesUpdateManyWithWhereWithoutInformAudienceDefinitionsInput = {
  data: CanonicalSpeciesUpdateManyMutationInput;
  where: CanonicalSpeciesScalarWhereInput;
};

export type CanonicalSpeciesUpdateManyWithoutInformAudienceDefinitionsNestedInput = {
  connect?: Maybe<Array<CanonicalSpeciesWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CanonicalSpeciesCreateOrConnectWithoutInformAudienceDefinitionsInput>>;
  create?: Maybe<Array<CanonicalSpeciesCreateWithoutInformAudienceDefinitionsInput>>;
  delete?: Maybe<Array<CanonicalSpeciesWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CanonicalSpeciesScalarWhereInput>>;
  disconnect?: Maybe<Array<CanonicalSpeciesWhereUniqueInput>>;
  set?: Maybe<Array<CanonicalSpeciesWhereUniqueInput>>;
  update?: Maybe<Array<CanonicalSpeciesUpdateWithWhereUniqueWithoutInformAudienceDefinitionsInput>>;
  updateMany?: Maybe<Array<CanonicalSpeciesUpdateManyWithWhereWithoutInformAudienceDefinitionsInput>>;
  upsert?: Maybe<Array<CanonicalSpeciesUpsertWithWhereUniqueWithoutInformAudienceDefinitionsInput>>;
};

export type CanonicalSpeciesUpdateOneRequiredWithoutCanonicalBreedsNestedInput = {
  connect?: Maybe<CanonicalSpeciesWhereUniqueInput>;
  connectOrCreate?: Maybe<CanonicalSpeciesCreateOrConnectWithoutCanonicalBreedsInput>;
  create?: Maybe<CanonicalSpeciesCreateWithoutCanonicalBreedsInput>;
  update?: Maybe<CanonicalSpeciesUpdateToOneWithWhereWithoutCanonicalBreedsInput>;
  upsert?: Maybe<CanonicalSpeciesUpsertWithoutCanonicalBreedsInput>;
};

export type CanonicalSpeciesUpdateToOneWithWhereWithoutCanonicalBreedsInput = {
  data: CanonicalSpeciesUpdateWithoutCanonicalBreedsInput;
  where?: Maybe<CanonicalSpeciesWhereInput>;
};

export type CanonicalSpeciesUpdateWithWhereUniqueWithoutInformAudienceDefinitionsInput = {
  data: CanonicalSpeciesUpdateWithoutInformAudienceDefinitionsInput;
  where: CanonicalSpeciesWhereUniqueInput;
};

export type CanonicalSpeciesUpdateWithoutCanonicalBreedsInput = {
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutCanonicalSpeciesNestedInput>;
  kingdom?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesUpdateWithoutInformAudienceDefinitionsInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUpdateManyWithoutCanonicalSpeciesNestedInput>;
  class?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kingdom?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CanonicalSpeciesUpsertWithWhereUniqueWithoutInformAudienceDefinitionsInput = {
  create: CanonicalSpeciesCreateWithoutInformAudienceDefinitionsInput;
  update: CanonicalSpeciesUpdateWithoutInformAudienceDefinitionsInput;
  where: CanonicalSpeciesWhereUniqueInput;
};

export type CanonicalSpeciesUpsertWithoutCanonicalBreedsInput = {
  create: CanonicalSpeciesCreateWithoutCanonicalBreedsInput;
  update: CanonicalSpeciesUpdateWithoutCanonicalBreedsInput;
  where?: Maybe<CanonicalSpeciesWhereInput>;
};

export type CanonicalSpeciesWhereInput = {
  AND?: Maybe<Array<CanonicalSpeciesWhereInput>>;
  NOT?: Maybe<Array<CanonicalSpeciesWhereInput>>;
  OR?: Maybe<Array<CanonicalSpeciesWhereInput>>;
  canonicalBreeds?: Maybe<CanonicalBreedListRelationFilter>;
  class?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  family?: Maybe<StringNullableFilter>;
  genus?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  kingdom?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  order?: Maybe<StringNullableFilter>;
  phylum?: Maybe<StringNullableFilter>;
  scientificName?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CanonicalSpeciesWhereUniqueInput = {
  AND?: Maybe<Array<CanonicalSpeciesWhereInput>>;
  NOT?: Maybe<Array<CanonicalSpeciesWhereInput>>;
  OR?: Maybe<Array<CanonicalSpeciesWhereInput>>;
  canonicalBreeds?: Maybe<CanonicalBreedListRelationFilter>;
  class?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  family?: Maybe<StringNullableFilter>;
  genus?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  kingdom?: Maybe<StringNullableFilter>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<StringNullableFilter>;
  phylum?: Maybe<StringNullableFilter>;
  scientificName?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum CardBrand {
  Amex = 'Amex',
  Diners = 'Diners',
  Discover = 'Discover',
  Jcb = 'JCB',
  Mastercard = 'Mastercard',
  UnionPay = 'UnionPay',
  Unknown = 'Unknown',
  Visa = 'Visa'
}

export enum CardFunding {
  Credit = 'credit',
  Debit = 'debit',
  Prepaid = 'prepaid',
  Unknown = 'unknown'
}

export type CareAccountCreditIntent = {
  __typename?: 'CareAccountCreditIntent';
  _count: CareAccountCreditIntentCountOutputType;
  careAccountCreditPimsWritebackLogEntries: Array<CareAccountCreditPimsWritebackLogEntry>;
  careBenefitUsages: Array<CareBenefitUsage>;
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: Currency;
  followupStep?: Maybe<CareBenefitUsageFollowupStep>;
  followupStepId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoice?: Maybe<Invoice>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue: Scalars['Int'];
  stripePaymentIntents: Array<StripePaymentIntent>;
  updatedAt: Scalars['DateTime'];
};


export type CareAccountCreditIntentCareAccountCreditPimsWritebackLogEntriesArgs = {
  cursor?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAccountCreditPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAccountCreditPimsWritebackLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
};


export type CareAccountCreditIntentCareBenefitUsagesArgs = {
  cursor?: Maybe<CareBenefitUsageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageWhereInput>;
};


export type CareAccountCreditIntentFollowupStepArgs = {
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};


export type CareAccountCreditIntentInvoiceArgs = {
  where?: Maybe<InvoiceWhereInput>;
};


export type CareAccountCreditIntentStripePaymentIntentsArgs = {
  cursor?: Maybe<StripePaymentIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type CareAccountCreditIntentAvgAggregateOutputType = {
  __typename?: 'CareAccountCreditIntentAvgAggregateOutputType';
  paymentDue?: Maybe<Scalars['Float']>;
};

export type CareAccountCreditIntentAvgOrderByAggregateInput = {
  paymentDue?: Maybe<SortOrder>;
};

export type CareAccountCreditIntentCountAggregateOutputType = {
  __typename?: 'CareAccountCreditIntentCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  currency: Scalars['Int'];
  followupStepId: Scalars['Int'];
  id: Scalars['Int'];
  invoiceId: Scalars['Int'];
  paymentDue: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CareAccountCreditIntentCountOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  followupStepId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  paymentDue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAccountCreditIntentCountOutputType = {
  __typename?: 'CareAccountCreditIntentCountOutputType';
  careAccountCreditPimsWritebackLogEntries: Scalars['Int'];
  careBenefitUsages: Scalars['Int'];
  stripePaymentIntents: Scalars['Int'];
};

export type CareAccountCreditIntentCreateInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedManyWithoutCareAccountCreditIntentInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutCareAccountCreditIntentInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutCareAccountCreditIntentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutCareAccountCreditIntentsInput>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceCreateNestedOneWithoutCareAccountCreditIntentsInput>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutCareAccountCreditIntentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentCreateManyClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentCreateManyClinicPetParentInputEnvelope = {
  data: Array<CareAccountCreditIntentCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareAccountCreditIntentCreateManyFollowupStepInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentCreateManyFollowupStepInputEnvelope = {
  data: Array<CareAccountCreditIntentCreateManyFollowupStepInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareAccountCreditIntentCreateManyInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentCreateManyInvoiceInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentCreateManyInvoiceInputEnvelope = {
  data: Array<CareAccountCreditIntentCreateManyInvoiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditIntentCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CareAccountCreditIntentCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CareAccountCreditIntentCreateManyClinicPetParentInputEnvelope>;
};

export type CareAccountCreditIntentCreateNestedManyWithoutFollowupStepInput = {
  connect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditIntentCreateOrConnectWithoutFollowupStepInput>>;
  create?: Maybe<Array<CareAccountCreditIntentCreateWithoutFollowupStepInput>>;
  createMany?: Maybe<CareAccountCreditIntentCreateManyFollowupStepInputEnvelope>;
};

export type CareAccountCreditIntentCreateNestedManyWithoutInvoiceInput = {
  connect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditIntentCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<CareAccountCreditIntentCreateWithoutInvoiceInput>>;
  createMany?: Maybe<CareAccountCreditIntentCreateManyInvoiceInputEnvelope>;
};

export type CareAccountCreditIntentCreateNestedOneWithoutCareAccountCreditPimsWritebackLogEntriesInput = {
  connect?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAccountCreditIntentCreateOrConnectWithoutCareAccountCreditPimsWritebackLogEntriesInput>;
  create?: Maybe<CareAccountCreditIntentCreateWithoutCareAccountCreditPimsWritebackLogEntriesInput>;
};

export type CareAccountCreditIntentCreateNestedOneWithoutCareBenefitUsagesInput = {
  connect?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAccountCreditIntentCreateOrConnectWithoutCareBenefitUsagesInput>;
  create?: Maybe<CareAccountCreditIntentCreateWithoutCareBenefitUsagesInput>;
};

export type CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput = {
  connect?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAccountCreditIntentCreateOrConnectWithoutStripePaymentIntentsInput>;
  create?: Maybe<CareAccountCreditIntentCreateWithoutStripePaymentIntentsInput>;
};

export type CareAccountCreditIntentCreateOrConnectWithoutCareAccountCreditPimsWritebackLogEntriesInput = {
  create: CareAccountCreditIntentCreateWithoutCareAccountCreditPimsWritebackLogEntriesInput;
  where: CareAccountCreditIntentWhereUniqueInput;
};

export type CareAccountCreditIntentCreateOrConnectWithoutCareBenefitUsagesInput = {
  create: CareAccountCreditIntentCreateWithoutCareBenefitUsagesInput;
  where: CareAccountCreditIntentWhereUniqueInput;
};

export type CareAccountCreditIntentCreateOrConnectWithoutClinicPetParentInput = {
  create: CareAccountCreditIntentCreateWithoutClinicPetParentInput;
  where: CareAccountCreditIntentWhereUniqueInput;
};

export type CareAccountCreditIntentCreateOrConnectWithoutFollowupStepInput = {
  create: CareAccountCreditIntentCreateWithoutFollowupStepInput;
  where: CareAccountCreditIntentWhereUniqueInput;
};

export type CareAccountCreditIntentCreateOrConnectWithoutInvoiceInput = {
  create: CareAccountCreditIntentCreateWithoutInvoiceInput;
  where: CareAccountCreditIntentWhereUniqueInput;
};

export type CareAccountCreditIntentCreateOrConnectWithoutStripePaymentIntentsInput = {
  create: CareAccountCreditIntentCreateWithoutStripePaymentIntentsInput;
  where: CareAccountCreditIntentWhereUniqueInput;
};

export type CareAccountCreditIntentCreateWithoutCareAccountCreditPimsWritebackLogEntriesInput = {
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutCareAccountCreditIntentInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutCareAccountCreditIntentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutCareAccountCreditIntentsInput>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceCreateNestedOneWithoutCareAccountCreditIntentsInput>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutCareAccountCreditIntentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentCreateWithoutCareBenefitUsagesInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedManyWithoutCareAccountCreditIntentInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutCareAccountCreditIntentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutCareAccountCreditIntentsInput>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceCreateNestedOneWithoutCareAccountCreditIntentsInput>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutCareAccountCreditIntentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentCreateWithoutClinicPetParentInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedManyWithoutCareAccountCreditIntentInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutCareAccountCreditIntentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutCareAccountCreditIntentsInput>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceCreateNestedOneWithoutCareAccountCreditIntentsInput>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutCareAccountCreditIntentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentCreateWithoutFollowupStepInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedManyWithoutCareAccountCreditIntentInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutCareAccountCreditIntentInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutCareAccountCreditIntentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceCreateNestedOneWithoutCareAccountCreditIntentsInput>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutCareAccountCreditIntentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentCreateWithoutInvoiceInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedManyWithoutCareAccountCreditIntentInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutCareAccountCreditIntentInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutCareAccountCreditIntentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutCareAccountCreditIntentsInput>;
  id?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutCareAccountCreditIntentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentCreateWithoutStripePaymentIntentsInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedManyWithoutCareAccountCreditIntentInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutCareAccountCreditIntentInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutCareAccountCreditIntentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutCareAccountCreditIntentsInput>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceCreateNestedOneWithoutCareAccountCreditIntentsInput>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentGroupByOutputType = {
  __typename?: 'CareAccountCreditIntentGroupByOutputType';
  _avg?: Maybe<CareAccountCreditIntentAvgAggregateOutputType>;
  _count?: Maybe<CareAccountCreditIntentCountAggregateOutputType>;
  _max?: Maybe<CareAccountCreditIntentMaxAggregateOutputType>;
  _min?: Maybe<CareAccountCreditIntentMinAggregateOutputType>;
  _sum?: Maybe<CareAccountCreditIntentSumAggregateOutputType>;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: Currency;
  followupStepId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CareAccountCreditIntentListRelationFilter = {
  every?: Maybe<CareAccountCreditIntentWhereInput>;
  none?: Maybe<CareAccountCreditIntentWhereInput>;
  some?: Maybe<CareAccountCreditIntentWhereInput>;
};

export type CareAccountCreditIntentMaxAggregateOutputType = {
  __typename?: 'CareAccountCreditIntentMaxAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentMaxOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  followupStepId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  paymentDue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAccountCreditIntentMinAggregateOutputType = {
  __typename?: 'CareAccountCreditIntentMinAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentMinOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  followupStepId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  paymentDue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAccountCreditIntentNullableScalarRelationFilter = {
  AND?: Maybe<Array<CareAccountCreditIntentWhereInput>>;
  NOT?: Maybe<Array<CareAccountCreditIntentWhereInput>>;
  OR?: Maybe<Array<CareAccountCreditIntentWhereInput>>;
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryListRelationFilter>;
  careBenefitUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepNullableScalarRelationFilter>;
  followupStepId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invoice?: Maybe<InvoiceNullableScalarRelationFilter>;
  invoiceId?: Maybe<StringNullableFilter>;
  paymentDue?: Maybe<IntFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAccountCreditIntentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareAccountCreditIntentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareAccountCreditIntentOrderByRelevanceInput>;
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryOrderByRelationAggregateInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepOrderByWithRelationInput>;
  followupStepId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceId?: Maybe<SortOrder>;
  paymentDue?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareAccountCreditIntentOrderByRelevanceFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  FollowupStepId = 'followupStepId',
  Id = 'id',
  InvoiceId = 'invoiceId'
}

export type CareAccountCreditIntentOrderByRelevanceInput = {
  fields: Array<CareAccountCreditIntentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareAccountCreditIntentOrderByWithAggregationInput = {
  _avg?: Maybe<CareAccountCreditIntentAvgOrderByAggregateInput>;
  _count?: Maybe<CareAccountCreditIntentCountOrderByAggregateInput>;
  _max?: Maybe<CareAccountCreditIntentMaxOrderByAggregateInput>;
  _min?: Maybe<CareAccountCreditIntentMinOrderByAggregateInput>;
  _sum?: Maybe<CareAccountCreditIntentSumOrderByAggregateInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  followupStepId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  paymentDue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAccountCreditIntentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareAccountCreditIntentOrderByRelevanceInput>;
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryOrderByRelationAggregateInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepOrderByWithRelationInput>;
  followupStepId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceId?: Maybe<SortOrder>;
  paymentDue?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAccountCreditIntentOrderByWithRelationInput = {
  _relevance?: Maybe<CareAccountCreditIntentOrderByRelevanceInput>;
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryOrderByRelationAggregateInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepOrderByWithRelationInput>;
  followupStepId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceId?: Maybe<SortOrder>;
  paymentDue?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareAccountCreditIntentScalarFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  FollowupStepId = 'followupStepId',
  Id = 'id',
  InvoiceId = 'invoiceId',
  PaymentDue = 'paymentDue',
  UpdatedAt = 'updatedAt'
}

export type CareAccountCreditIntentScalarRelationFilter = {
  AND?: Maybe<Array<CareAccountCreditIntentWhereInput>>;
  NOT?: Maybe<Array<CareAccountCreditIntentWhereInput>>;
  OR?: Maybe<Array<CareAccountCreditIntentWhereInput>>;
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryListRelationFilter>;
  careBenefitUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepNullableScalarRelationFilter>;
  followupStepId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invoice?: Maybe<InvoiceNullableScalarRelationFilter>;
  invoiceId?: Maybe<StringNullableFilter>;
  paymentDue?: Maybe<IntFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAccountCreditIntentScalarWhereInput = {
  AND?: Maybe<Array<CareAccountCreditIntentScalarWhereInput>>;
  NOT?: Maybe<Array<CareAccountCreditIntentScalarWhereInput>>;
  OR?: Maybe<Array<CareAccountCreditIntentScalarWhereInput>>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  followupStepId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invoiceId?: Maybe<StringNullableFilter>;
  paymentDue?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAccountCreditIntentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareAccountCreditIntentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareAccountCreditIntentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareAccountCreditIntentScalarWhereWithAggregatesInput>>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  currency?: Maybe<EnumCurrencyWithAggregatesFilter>;
  followupStepId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  invoiceId?: Maybe<StringNullableWithAggregatesFilter>;
  paymentDue?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CareAccountCreditIntentSumAggregateOutputType = {
  __typename?: 'CareAccountCreditIntentSumAggregateOutputType';
  paymentDue?: Maybe<Scalars['Int']>;
};

export type CareAccountCreditIntentSumOrderByAggregateInput = {
  paymentDue?: Maybe<SortOrder>;
};

export type CareAccountCreditIntentUncheckedCreateInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditIntentCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CareAccountCreditIntentCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CareAccountCreditIntentCreateManyClinicPetParentInputEnvelope>;
};

export type CareAccountCreditIntentUncheckedCreateNestedManyWithoutFollowupStepInput = {
  connect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditIntentCreateOrConnectWithoutFollowupStepInput>>;
  create?: Maybe<Array<CareAccountCreditIntentCreateWithoutFollowupStepInput>>;
  createMany?: Maybe<CareAccountCreditIntentCreateManyFollowupStepInputEnvelope>;
};

export type CareAccountCreditIntentUncheckedCreateNestedManyWithoutInvoiceInput = {
  connect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditIntentCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<CareAccountCreditIntentCreateWithoutInvoiceInput>>;
  createMany?: Maybe<CareAccountCreditIntentCreateManyInvoiceInputEnvelope>;
};

export type CareAccountCreditIntentUncheckedCreateWithoutCareAccountCreditPimsWritebackLogEntriesInput = {
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedCreateWithoutCareBenefitUsagesInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedCreateWithoutClinicPetParentInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedCreateWithoutFollowupStepInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedCreateWithoutInvoiceInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedCreateWithoutStripePaymentIntentsInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedUpdateInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedUpdateManyInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditIntentCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CareAccountCreditIntentCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CareAccountCreditIntentCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAccountCreditIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  set?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  update?: Maybe<Array<CareAccountCreditIntentUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<CareAccountCreditIntentUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<CareAccountCreditIntentUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type CareAccountCreditIntentUncheckedUpdateManyWithoutFollowupStepInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedUpdateManyWithoutFollowupStepNestedInput = {
  connect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditIntentCreateOrConnectWithoutFollowupStepInput>>;
  create?: Maybe<Array<CareAccountCreditIntentCreateWithoutFollowupStepInput>>;
  createMany?: Maybe<CareAccountCreditIntentCreateManyFollowupStepInputEnvelope>;
  delete?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAccountCreditIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  set?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  update?: Maybe<Array<CareAccountCreditIntentUpdateWithWhereUniqueWithoutFollowupStepInput>>;
  updateMany?: Maybe<Array<CareAccountCreditIntentUpdateManyWithWhereWithoutFollowupStepInput>>;
  upsert?: Maybe<Array<CareAccountCreditIntentUpsertWithWhereUniqueWithoutFollowupStepInput>>;
};

export type CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceNestedInput = {
  connect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditIntentCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<CareAccountCreditIntentCreateWithoutInvoiceInput>>;
  createMany?: Maybe<CareAccountCreditIntentCreateManyInvoiceInputEnvelope>;
  delete?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAccountCreditIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  set?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  update?: Maybe<Array<CareAccountCreditIntentUpdateWithWhereUniqueWithoutInvoiceInput>>;
  updateMany?: Maybe<Array<CareAccountCreditIntentUpdateManyWithWhereWithoutInvoiceInput>>;
  upsert?: Maybe<Array<CareAccountCreditIntentUpsertWithWhereUniqueWithoutInvoiceInput>>;
};

export type CareAccountCreditIntentUncheckedUpdateWithoutCareAccountCreditPimsWritebackLogEntriesInput = {
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedUpdateWithoutCareBenefitUsagesInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedUpdateWithoutClinicPetParentInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedUpdateWithoutFollowupStepInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedUpdateWithoutInvoiceInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUncheckedUpdateWithoutStripePaymentIntentsInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStepId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUpdateInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutCareAccountCreditIntentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutCareAccountCreditIntentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneWithoutCareAccountCreditIntentsNestedInput>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: CareAccountCreditIntentUpdateManyMutationInput;
  where: CareAccountCreditIntentScalarWhereInput;
};

export type CareAccountCreditIntentUpdateManyWithWhereWithoutFollowupStepInput = {
  data: CareAccountCreditIntentUpdateManyMutationInput;
  where: CareAccountCreditIntentScalarWhereInput;
};

export type CareAccountCreditIntentUpdateManyWithWhereWithoutInvoiceInput = {
  data: CareAccountCreditIntentUpdateManyMutationInput;
  where: CareAccountCreditIntentScalarWhereInput;
};

export type CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditIntentCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CareAccountCreditIntentCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CareAccountCreditIntentCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAccountCreditIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  set?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  update?: Maybe<Array<CareAccountCreditIntentUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<CareAccountCreditIntentUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<CareAccountCreditIntentUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type CareAccountCreditIntentUpdateManyWithoutFollowupStepNestedInput = {
  connect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditIntentCreateOrConnectWithoutFollowupStepInput>>;
  create?: Maybe<Array<CareAccountCreditIntentCreateWithoutFollowupStepInput>>;
  createMany?: Maybe<CareAccountCreditIntentCreateManyFollowupStepInputEnvelope>;
  delete?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAccountCreditIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  set?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  update?: Maybe<Array<CareAccountCreditIntentUpdateWithWhereUniqueWithoutFollowupStepInput>>;
  updateMany?: Maybe<Array<CareAccountCreditIntentUpdateManyWithWhereWithoutFollowupStepInput>>;
  upsert?: Maybe<Array<CareAccountCreditIntentUpsertWithWhereUniqueWithoutFollowupStepInput>>;
};

export type CareAccountCreditIntentUpdateManyWithoutInvoiceNestedInput = {
  connect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditIntentCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<CareAccountCreditIntentCreateWithoutInvoiceInput>>;
  createMany?: Maybe<CareAccountCreditIntentCreateManyInvoiceInputEnvelope>;
  delete?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAccountCreditIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  set?: Maybe<Array<CareAccountCreditIntentWhereUniqueInput>>;
  update?: Maybe<Array<CareAccountCreditIntentUpdateWithWhereUniqueWithoutInvoiceInput>>;
  updateMany?: Maybe<Array<CareAccountCreditIntentUpdateManyWithWhereWithoutInvoiceInput>>;
  upsert?: Maybe<Array<CareAccountCreditIntentUpsertWithWhereUniqueWithoutInvoiceInput>>;
};

export type CareAccountCreditIntentUpdateOneRequiredWithoutCareAccountCreditPimsWritebackLogEntriesNestedInput = {
  connect?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAccountCreditIntentCreateOrConnectWithoutCareAccountCreditPimsWritebackLogEntriesInput>;
  create?: Maybe<CareAccountCreditIntentCreateWithoutCareAccountCreditPimsWritebackLogEntriesInput>;
  update?: Maybe<CareAccountCreditIntentUpdateToOneWithWhereWithoutCareAccountCreditPimsWritebackLogEntriesInput>;
  upsert?: Maybe<CareAccountCreditIntentUpsertWithoutCareAccountCreditPimsWritebackLogEntriesInput>;
};

export type CareAccountCreditIntentUpdateOneWithoutCareBenefitUsagesNestedInput = {
  connect?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAccountCreditIntentCreateOrConnectWithoutCareBenefitUsagesInput>;
  create?: Maybe<CareAccountCreditIntentCreateWithoutCareBenefitUsagesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareAccountCreditIntentUpdateToOneWithWhereWithoutCareBenefitUsagesInput>;
  upsert?: Maybe<CareAccountCreditIntentUpsertWithoutCareBenefitUsagesInput>;
};

export type CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput = {
  connect?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAccountCreditIntentCreateOrConnectWithoutStripePaymentIntentsInput>;
  create?: Maybe<CareAccountCreditIntentCreateWithoutStripePaymentIntentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareAccountCreditIntentUpdateToOneWithWhereWithoutStripePaymentIntentsInput>;
  upsert?: Maybe<CareAccountCreditIntentUpsertWithoutStripePaymentIntentsInput>;
};

export type CareAccountCreditIntentUpdateToOneWithWhereWithoutCareAccountCreditPimsWritebackLogEntriesInput = {
  data: CareAccountCreditIntentUpdateWithoutCareAccountCreditPimsWritebackLogEntriesInput;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};

export type CareAccountCreditIntentUpdateToOneWithWhereWithoutCareBenefitUsagesInput = {
  data: CareAccountCreditIntentUpdateWithoutCareBenefitUsagesInput;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};

export type CareAccountCreditIntentUpdateToOneWithWhereWithoutStripePaymentIntentsInput = {
  data: CareAccountCreditIntentUpdateWithoutStripePaymentIntentsInput;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};

export type CareAccountCreditIntentUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: CareAccountCreditIntentUpdateWithoutClinicPetParentInput;
  where: CareAccountCreditIntentWhereUniqueInput;
};

export type CareAccountCreditIntentUpdateWithWhereUniqueWithoutFollowupStepInput = {
  data: CareAccountCreditIntentUpdateWithoutFollowupStepInput;
  where: CareAccountCreditIntentWhereUniqueInput;
};

export type CareAccountCreditIntentUpdateWithWhereUniqueWithoutInvoiceInput = {
  data: CareAccountCreditIntentUpdateWithoutInvoiceInput;
  where: CareAccountCreditIntentWhereUniqueInput;
};

export type CareAccountCreditIntentUpdateWithoutCareAccountCreditPimsWritebackLogEntriesInput = {
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutCareAccountCreditIntentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutCareAccountCreditIntentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneWithoutCareAccountCreditIntentsNestedInput>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUpdateWithoutCareBenefitUsagesInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutCareAccountCreditIntentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutCareAccountCreditIntentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneWithoutCareAccountCreditIntentsNestedInput>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUpdateWithoutClinicPetParentInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutCareAccountCreditIntentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneWithoutCareAccountCreditIntentsNestedInput>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUpdateWithoutFollowupStepInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutCareAccountCreditIntentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneWithoutCareAccountCreditIntentsNestedInput>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUpdateWithoutInvoiceInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutCareAccountCreditIntentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutCareAccountCreditIntentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  paymentDue?: Maybe<Scalars['Int']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUpdateWithoutStripePaymentIntentsInput = {
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutCareAccountCreditIntentNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutCareAccountCreditIntentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutCareAccountCreditIntentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneWithoutCareAccountCreditIntentsNestedInput>;
  paymentDue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAccountCreditIntentUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: CareAccountCreditIntentCreateWithoutClinicPetParentInput;
  update: CareAccountCreditIntentUpdateWithoutClinicPetParentInput;
  where: CareAccountCreditIntentWhereUniqueInput;
};

export type CareAccountCreditIntentUpsertWithWhereUniqueWithoutFollowupStepInput = {
  create: CareAccountCreditIntentCreateWithoutFollowupStepInput;
  update: CareAccountCreditIntentUpdateWithoutFollowupStepInput;
  where: CareAccountCreditIntentWhereUniqueInput;
};

export type CareAccountCreditIntentUpsertWithWhereUniqueWithoutInvoiceInput = {
  create: CareAccountCreditIntentCreateWithoutInvoiceInput;
  update: CareAccountCreditIntentUpdateWithoutInvoiceInput;
  where: CareAccountCreditIntentWhereUniqueInput;
};

export type CareAccountCreditIntentUpsertWithoutCareAccountCreditPimsWritebackLogEntriesInput = {
  create: CareAccountCreditIntentCreateWithoutCareAccountCreditPimsWritebackLogEntriesInput;
  update: CareAccountCreditIntentUpdateWithoutCareAccountCreditPimsWritebackLogEntriesInput;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};

export type CareAccountCreditIntentUpsertWithoutCareBenefitUsagesInput = {
  create: CareAccountCreditIntentCreateWithoutCareBenefitUsagesInput;
  update: CareAccountCreditIntentUpdateWithoutCareBenefitUsagesInput;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};

export type CareAccountCreditIntentUpsertWithoutStripePaymentIntentsInput = {
  create: CareAccountCreditIntentCreateWithoutStripePaymentIntentsInput;
  update: CareAccountCreditIntentUpdateWithoutStripePaymentIntentsInput;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};

export type CareAccountCreditIntentWhereInput = {
  AND?: Maybe<Array<CareAccountCreditIntentWhereInput>>;
  NOT?: Maybe<Array<CareAccountCreditIntentWhereInput>>;
  OR?: Maybe<Array<CareAccountCreditIntentWhereInput>>;
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryListRelationFilter>;
  careBenefitUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepNullableScalarRelationFilter>;
  followupStepId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invoice?: Maybe<InvoiceNullableScalarRelationFilter>;
  invoiceId?: Maybe<StringNullableFilter>;
  paymentDue?: Maybe<IntFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAccountCreditIntentWhereUniqueInput = {
  AND?: Maybe<Array<CareAccountCreditIntentWhereInput>>;
  NOT?: Maybe<Array<CareAccountCreditIntentWhereInput>>;
  OR?: Maybe<Array<CareAccountCreditIntentWhereInput>>;
  careAccountCreditPimsWritebackLogEntries?: Maybe<CareAccountCreditPimsWritebackLogEntryListRelationFilter>;
  careBenefitUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  followupStep?: Maybe<CareBenefitUsageFollowupStepNullableScalarRelationFilter>;
  followupStepId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceNullableScalarRelationFilter>;
  invoiceId?: Maybe<StringNullableFilter>;
  paymentDue?: Maybe<IntFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAccountCreditPimsWritebackLogEntry = {
  __typename?: 'CareAccountCreditPimsWritebackLogEntry';
  careAccountCreditIntent: CareAccountCreditIntent;
  careAccountCreditIntentId: Scalars['String'];
  writebackLog: PimsWritebackLogEntry;
  writebackLogId: Scalars['String'];
};

export type CareAccountCreditPimsWritebackLogEntryCountAggregateOutputType = {
  __typename?: 'CareAccountCreditPimsWritebackLogEntryCountAggregateOutputType';
  _all: Scalars['Int'];
  careAccountCreditIntentId: Scalars['Int'];
  writebackLogId: Scalars['Int'];
};

export type CareAccountCreditPimsWritebackLogEntryCountOrderByAggregateInput = {
  careAccountCreditIntentId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type CareAccountCreditPimsWritebackLogEntryCreateInput = {
  careAccountCreditIntent: CareAccountCreditIntentCreateNestedOneWithoutCareAccountCreditPimsWritebackLogEntriesInput;
  writebackLog: PimsWritebackLogEntryCreateNestedOneWithoutCareAccountCreditLogInput;
};

export type CareAccountCreditPimsWritebackLogEntryCreateManyCareAccountCreditIntentInput = {
  writebackLogId: Scalars['String'];
};

export type CareAccountCreditPimsWritebackLogEntryCreateManyCareAccountCreditIntentInputEnvelope = {
  data: Array<CareAccountCreditPimsWritebackLogEntryCreateManyCareAccountCreditIntentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareAccountCreditPimsWritebackLogEntryCreateManyInput = {
  careAccountCreditIntentId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type CareAccountCreditPimsWritebackLogEntryCreateNestedManyWithoutCareAccountCreditIntentInput = {
  connect?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryCreateOrConnectWithoutCareAccountCreditIntentInput>>;
  create?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryCreateWithoutCareAccountCreditIntentInput>>;
  createMany?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateManyCareAccountCreditIntentInputEnvelope>;
};

export type CareAccountCreditPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput = {
  connect?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
};

export type CareAccountCreditPimsWritebackLogEntryCreateOrConnectWithoutCareAccountCreditIntentInput = {
  create: CareAccountCreditPimsWritebackLogEntryCreateWithoutCareAccountCreditIntentInput;
  where: CareAccountCreditPimsWritebackLogEntryWhereUniqueInput;
};

export type CareAccountCreditPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput = {
  create: CareAccountCreditPimsWritebackLogEntryCreateWithoutWritebackLogInput;
  where: CareAccountCreditPimsWritebackLogEntryWhereUniqueInput;
};

export type CareAccountCreditPimsWritebackLogEntryCreateWithoutCareAccountCreditIntentInput = {
  writebackLog: PimsWritebackLogEntryCreateNestedOneWithoutCareAccountCreditLogInput;
};

export type CareAccountCreditPimsWritebackLogEntryCreateWithoutWritebackLogInput = {
  careAccountCreditIntent: CareAccountCreditIntentCreateNestedOneWithoutCareAccountCreditPimsWritebackLogEntriesInput;
};

export type CareAccountCreditPimsWritebackLogEntryGroupByOutputType = {
  __typename?: 'CareAccountCreditPimsWritebackLogEntryGroupByOutputType';
  _count?: Maybe<CareAccountCreditPimsWritebackLogEntryCountAggregateOutputType>;
  _max?: Maybe<CareAccountCreditPimsWritebackLogEntryMaxAggregateOutputType>;
  _min?: Maybe<CareAccountCreditPimsWritebackLogEntryMinAggregateOutputType>;
  careAccountCreditIntentId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type CareAccountCreditPimsWritebackLogEntryListRelationFilter = {
  every?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
  none?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
  some?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
};

export type CareAccountCreditPimsWritebackLogEntryMaxAggregateOutputType = {
  __typename?: 'CareAccountCreditPimsWritebackLogEntryMaxAggregateOutputType';
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type CareAccountCreditPimsWritebackLogEntryMaxOrderByAggregateInput = {
  careAccountCreditIntentId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type CareAccountCreditPimsWritebackLogEntryMinAggregateOutputType = {
  __typename?: 'CareAccountCreditPimsWritebackLogEntryMinAggregateOutputType';
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type CareAccountCreditPimsWritebackLogEntryMinOrderByAggregateInput = {
  careAccountCreditIntentId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type CareAccountCreditPimsWritebackLogEntryNullableScalarRelationFilter = {
  AND?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereInput>>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentScalarRelationFilter>;
  careAccountCreditIntentId?: Maybe<StringFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type CareAccountCreditPimsWritebackLogEntryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareAccountCreditPimsWritebackLogEntryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareAccountCreditPimsWritebackLogEntryOrderByRelevanceInput>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentOrderByWithRelationInput>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export enum CareAccountCreditPimsWritebackLogEntryOrderByRelevanceFieldEnum {
  CareAccountCreditIntentId = 'careAccountCreditIntentId',
  WritebackLogId = 'writebackLogId'
}

export type CareAccountCreditPimsWritebackLogEntryOrderByRelevanceInput = {
  fields: Array<CareAccountCreditPimsWritebackLogEntryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareAccountCreditPimsWritebackLogEntryOrderByWithAggregationInput = {
  _count?: Maybe<CareAccountCreditPimsWritebackLogEntryCountOrderByAggregateInput>;
  _max?: Maybe<CareAccountCreditPimsWritebackLogEntryMaxOrderByAggregateInput>;
  _min?: Maybe<CareAccountCreditPimsWritebackLogEntryMinOrderByAggregateInput>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type CareAccountCreditPimsWritebackLogEntryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareAccountCreditPimsWritebackLogEntryOrderByRelevanceInput>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentOrderByWithRelationInput>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export type CareAccountCreditPimsWritebackLogEntryOrderByWithRelationInput = {
  _relevance?: Maybe<CareAccountCreditPimsWritebackLogEntryOrderByRelevanceInput>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentOrderByWithRelationInput>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export enum CareAccountCreditPimsWritebackLogEntryScalarFieldEnum {
  CareAccountCreditIntentId = 'careAccountCreditIntentId',
  WritebackLogId = 'writebackLogId'
}

export type CareAccountCreditPimsWritebackLogEntryScalarWhereInput = {
  AND?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryScalarWhereInput>>;
  NOT?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryScalarWhereInput>>;
  OR?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryScalarWhereInput>>;
  careAccountCreditIntentId?: Maybe<StringFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type CareAccountCreditPimsWritebackLogEntryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  careAccountCreditIntentId?: Maybe<StringWithAggregatesFilter>;
  writebackLogId?: Maybe<StringWithAggregatesFilter>;
};

export type CareAccountCreditPimsWritebackLogEntryUncheckedCreateInput = {
  careAccountCreditIntentId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput = {
  connect?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryCreateOrConnectWithoutCareAccountCreditIntentInput>>;
  create?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryCreateWithoutCareAccountCreditIntentInput>>;
  createMany?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateManyCareAccountCreditIntentInputEnvelope>;
};

export type CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput = {
  connect?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
};

export type CareAccountCreditPimsWritebackLogEntryUncheckedCreateWithoutCareAccountCreditIntentInput = {
  writebackLogId: Scalars['String'];
};

export type CareAccountCreditPimsWritebackLogEntryUncheckedCreateWithoutWritebackLogInput = {
  careAccountCreditIntentId: Scalars['String'];
};

export type CareAccountCreditPimsWritebackLogEntryUncheckedUpdateInput = {
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type CareAccountCreditPimsWritebackLogEntryUncheckedUpdateManyInput = {
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type CareAccountCreditPimsWritebackLogEntryUncheckedUpdateManyWithoutCareAccountCreditIntentInput = {
  writebackLogId?: Maybe<Scalars['String']>;
};

export type CareAccountCreditPimsWritebackLogEntryUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput = {
  connect?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryCreateOrConnectWithoutCareAccountCreditIntentInput>>;
  create?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryCreateWithoutCareAccountCreditIntentInput>>;
  createMany?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateManyCareAccountCreditIntentInputEnvelope>;
  delete?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryUpdateWithWhereUniqueWithoutCareAccountCreditIntentInput>>;
  updateMany?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryUpdateManyWithWhereWithoutCareAccountCreditIntentInput>>;
  upsert?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryUpsertWithWhereUniqueWithoutCareAccountCreditIntentInput>>;
};

export type CareAccountCreditPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput = {
  connect?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
  delete?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
  disconnect?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
  update?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput>;
  upsert?: Maybe<CareAccountCreditPimsWritebackLogEntryUpsertWithoutWritebackLogInput>;
};

export type CareAccountCreditPimsWritebackLogEntryUncheckedUpdateWithoutCareAccountCreditIntentInput = {
  writebackLogId?: Maybe<Scalars['String']>;
};

export type CareAccountCreditPimsWritebackLogEntryUncheckedUpdateWithoutWritebackLogInput = {
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
};

export type CareAccountCreditPimsWritebackLogEntryUpdateInput = {
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneRequiredWithoutCareAccountCreditPimsWritebackLogEntriesNestedInput>;
  writebackLog?: Maybe<PimsWritebackLogEntryUpdateOneRequiredWithoutCareAccountCreditLogNestedInput>;
};

export type CareAccountCreditPimsWritebackLogEntryUpdateManyMutationInput = {
  careAccountCreditIntentId?: Maybe<StringNullableFilter>;
  writebackLogId?: Maybe<StringNullableFilter>;
};

export type CareAccountCreditPimsWritebackLogEntryUpdateManyWithWhereWithoutCareAccountCreditIntentInput = {
  data: CareAccountCreditPimsWritebackLogEntryUpdateManyMutationInput;
  where: CareAccountCreditPimsWritebackLogEntryScalarWhereInput;
};

export type CareAccountCreditPimsWritebackLogEntryUpdateManyWithoutCareAccountCreditIntentNestedInput = {
  connect?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryCreateOrConnectWithoutCareAccountCreditIntentInput>>;
  create?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryCreateWithoutCareAccountCreditIntentInput>>;
  createMany?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateManyCareAccountCreditIntentInputEnvelope>;
  delete?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryUpdateWithWhereUniqueWithoutCareAccountCreditIntentInput>>;
  updateMany?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryUpdateManyWithWhereWithoutCareAccountCreditIntentInput>>;
  upsert?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryUpsertWithWhereUniqueWithoutCareAccountCreditIntentInput>>;
};

export type CareAccountCreditPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput = {
  connect?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput>;
  upsert?: Maybe<CareAccountCreditPimsWritebackLogEntryUpsertWithoutWritebackLogInput>;
};

export type CareAccountCreditPimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput = {
  data: CareAccountCreditPimsWritebackLogEntryUpdateWithoutWritebackLogInput;
  where?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
};

export type CareAccountCreditPimsWritebackLogEntryUpdateWithWhereUniqueWithoutCareAccountCreditIntentInput = {
  data: CareAccountCreditPimsWritebackLogEntryUpdateWithoutCareAccountCreditIntentInput;
  where: CareAccountCreditPimsWritebackLogEntryWhereUniqueInput;
};

export type CareAccountCreditPimsWritebackLogEntryUpdateWithoutCareAccountCreditIntentInput = {
  writebackLog?: Maybe<PimsWritebackLogEntryUpdateOneRequiredWithoutCareAccountCreditLogNestedInput>;
};

export type CareAccountCreditPimsWritebackLogEntryUpdateWithoutWritebackLogInput = {
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneRequiredWithoutCareAccountCreditPimsWritebackLogEntriesNestedInput>;
};

export type CareAccountCreditPimsWritebackLogEntryUpsertWithWhereUniqueWithoutCareAccountCreditIntentInput = {
  create: CareAccountCreditPimsWritebackLogEntryCreateWithoutCareAccountCreditIntentInput;
  update: CareAccountCreditPimsWritebackLogEntryUpdateWithoutCareAccountCreditIntentInput;
  where: CareAccountCreditPimsWritebackLogEntryWhereUniqueInput;
};

export type CareAccountCreditPimsWritebackLogEntryUpsertWithoutWritebackLogInput = {
  create: CareAccountCreditPimsWritebackLogEntryCreateWithoutWritebackLogInput;
  update: CareAccountCreditPimsWritebackLogEntryUpdateWithoutWritebackLogInput;
  where?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
};

export type CareAccountCreditPimsWritebackLogEntryWhereInput = {
  AND?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereInput>>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentScalarRelationFilter>;
  careAccountCreditIntentId?: Maybe<StringFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type CareAccountCreditPimsWritebackLogEntryWhereUniqueInput = {
  AND?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<CareAccountCreditPimsWritebackLogEntryWhereInput>>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentScalarRelationFilter>;
  careAccountCreditIntentId?: Maybe<StringFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<Scalars['String']>;
  writebackLogId_careAccountCreditIntentId?: Maybe<CareAccountCreditPimsWritebackLogEntryWritebackLogIdCareAccountCreditIntentIdCompoundUniqueInput>;
};

export type CareAccountCreditPimsWritebackLogEntryWritebackLogIdCareAccountCreditIntentIdCompoundUniqueInput = {
  careAccountCreditIntentId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type CareAddonEnrollment = {
  __typename?: 'CareAddonEnrollment';
  _count: CareAddonEnrollmentCountOutputType;
  addOnPackage: CareAddonPackage;
  addOnPackageId: Scalars['String'];
  associatedUsages: Array<CareBenefitUsage>;
  careStripeSubscription?: Maybe<CareStripeSubscription>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  enrollmentPayments: Array<CareEnrollmentPayment>;
  enrollmentToStripeInvoiceItems: Array<CareEnrollmentToStripeInvoiceItem>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  organizationPet: OrganizationPet;
  organizationPetId: Scalars['String'];
  startDate: Scalars['DateTime'];
  status: EnrollmentStatus;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type CareAddonEnrollmentAssociatedUsagesArgs = {
  cursor?: Maybe<CareBenefitUsageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageWhereInput>;
};


export type CareAddonEnrollmentCareStripeSubscriptionArgs = {
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type CareAddonEnrollmentEnrollmentPaymentsArgs = {
  cursor?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareEnrollmentPaymentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentPaymentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};


export type CareAddonEnrollmentEnrollmentToStripeInvoiceItemsArgs = {
  cursor?: Maybe<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentToStripeInvoiceItemWhereInput>;
};

export type CareAddonEnrollmentCountAggregateOutputType = {
  __typename?: 'CareAddonEnrollmentCountAggregateOutputType';
  _all: Scalars['Int'];
  addOnPackageId: Scalars['Int'];
  careStripeSubscriptionId: Scalars['Int'];
  createdAt: Scalars['Int'];
  expirationDate: Scalars['Int'];
  id: Scalars['Int'];
  organizationPetId: Scalars['Int'];
  startDate: Scalars['Int'];
  status: Scalars['Int'];
  stripeSubscriptionItemId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CareAddonEnrollmentCountOrderByAggregateInput = {
  addOnPackageId?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationPetId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonEnrollmentCountOutputType = {
  __typename?: 'CareAddonEnrollmentCountOutputType';
  associatedUsages: Scalars['Int'];
  enrollmentPayments: Scalars['Int'];
  enrollmentToStripeInvoiceItems: Scalars['Int'];
};

export type CareAddonEnrollmentCreateInput = {
  addOnPackage: CareAddonPackageCreateNestedOneWithoutEnrollmentsInput;
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedAddonEnrollmentInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCareAddonEnrollmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCareAddonEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCareAddonEnrollmentsInput;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentCreateManyAddOnPackageInput = {
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentCreateManyAddOnPackageInputEnvelope = {
  data: Array<CareAddonEnrollmentCreateManyAddOnPackageInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareAddonEnrollmentCreateManyCareStripeSubscriptionInput = {
  addOnPackageId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentCreateManyCareStripeSubscriptionInputEnvelope = {
  data: Array<CareAddonEnrollmentCreateManyCareStripeSubscriptionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareAddonEnrollmentCreateManyInput = {
  addOnPackageId: Scalars['String'];
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentCreateManyOrganizationPetInput = {
  addOnPackageId: Scalars['String'];
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentCreateManyOrganizationPetInputEnvelope = {
  data: Array<CareAddonEnrollmentCreateManyOrganizationPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareAddonEnrollmentCreateNestedManyWithoutAddOnPackageInput = {
  connect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonEnrollmentCreateOrConnectWithoutAddOnPackageInput>>;
  create?: Maybe<Array<CareAddonEnrollmentCreateWithoutAddOnPackageInput>>;
  createMany?: Maybe<CareAddonEnrollmentCreateManyAddOnPackageInputEnvelope>;
};

export type CareAddonEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput = {
  connect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonEnrollmentCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CareAddonEnrollmentCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CareAddonEnrollmentCreateManyCareStripeSubscriptionInputEnvelope>;
};

export type CareAddonEnrollmentCreateNestedManyWithoutOrganizationPetInput = {
  connect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonEnrollmentCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<CareAddonEnrollmentCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<CareAddonEnrollmentCreateManyOrganizationPetInputEnvelope>;
};

export type CareAddonEnrollmentCreateNestedOneWithoutAssociatedUsagesInput = {
  connect?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAddonEnrollmentCreateOrConnectWithoutAssociatedUsagesInput>;
  create?: Maybe<CareAddonEnrollmentCreateWithoutAssociatedUsagesInput>;
};

export type CareAddonEnrollmentCreateNestedOneWithoutEnrollmentPaymentsInput = {
  connect?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAddonEnrollmentCreateOrConnectWithoutEnrollmentPaymentsInput>;
  create?: Maybe<CareAddonEnrollmentCreateWithoutEnrollmentPaymentsInput>;
};

export type CareAddonEnrollmentCreateNestedOneWithoutEnrollmentToStripeInvoiceItemsInput = {
  connect?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAddonEnrollmentCreateOrConnectWithoutEnrollmentToStripeInvoiceItemsInput>;
  create?: Maybe<CareAddonEnrollmentCreateWithoutEnrollmentToStripeInvoiceItemsInput>;
};

export type CareAddonEnrollmentCreateOrConnectWithoutAddOnPackageInput = {
  create: CareAddonEnrollmentCreateWithoutAddOnPackageInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};

export type CareAddonEnrollmentCreateOrConnectWithoutAssociatedUsagesInput = {
  create: CareAddonEnrollmentCreateWithoutAssociatedUsagesInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};

export type CareAddonEnrollmentCreateOrConnectWithoutCareStripeSubscriptionInput = {
  create: CareAddonEnrollmentCreateWithoutCareStripeSubscriptionInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};

export type CareAddonEnrollmentCreateOrConnectWithoutEnrollmentPaymentsInput = {
  create: CareAddonEnrollmentCreateWithoutEnrollmentPaymentsInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};

export type CareAddonEnrollmentCreateOrConnectWithoutEnrollmentToStripeInvoiceItemsInput = {
  create: CareAddonEnrollmentCreateWithoutEnrollmentToStripeInvoiceItemsInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};

export type CareAddonEnrollmentCreateOrConnectWithoutOrganizationPetInput = {
  create: CareAddonEnrollmentCreateWithoutOrganizationPetInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};

export type CareAddonEnrollmentCreateWithoutAddOnPackageInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedAddonEnrollmentInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCareAddonEnrollmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCareAddonEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCareAddonEnrollmentsInput;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentCreateWithoutAssociatedUsagesInput = {
  addOnPackage: CareAddonPackageCreateNestedOneWithoutEnrollmentsInput;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCareAddonEnrollmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCareAddonEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCareAddonEnrollmentsInput;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentCreateWithoutCareStripeSubscriptionInput = {
  addOnPackage: CareAddonPackageCreateNestedOneWithoutEnrollmentsInput;
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedAddonEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCareAddonEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCareAddonEnrollmentsInput;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentCreateWithoutEnrollmentPaymentsInput = {
  addOnPackage: CareAddonPackageCreateNestedOneWithoutEnrollmentsInput;
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedAddonEnrollmentInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCareAddonEnrollmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCareAddonEnrollmentsInput;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentCreateWithoutEnrollmentToStripeInvoiceItemsInput = {
  addOnPackage: CareAddonPackageCreateNestedOneWithoutEnrollmentsInput;
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedAddonEnrollmentInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCareAddonEnrollmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCareAddonEnrollmentsInput;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentCreateWithoutOrganizationPetInput = {
  addOnPackage: CareAddonPackageCreateNestedOneWithoutEnrollmentsInput;
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedAddonEnrollmentInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCareAddonEnrollmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCareAddonEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentGroupByOutputType = {
  __typename?: 'CareAddonEnrollmentGroupByOutputType';
  _count?: Maybe<CareAddonEnrollmentCountAggregateOutputType>;
  _max?: Maybe<CareAddonEnrollmentMaxAggregateOutputType>;
  _min?: Maybe<CareAddonEnrollmentMinAggregateOutputType>;
  addOnPackageId: Scalars['String'];
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  organizationPetId: Scalars['String'];
  startDate: Scalars['DateTime'];
  status: EnrollmentStatus;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CareAddonEnrollmentListRelationFilter = {
  every?: Maybe<CareAddonEnrollmentWhereInput>;
  none?: Maybe<CareAddonEnrollmentWhereInput>;
  some?: Maybe<CareAddonEnrollmentWhereInput>;
};

export type CareAddonEnrollmentMaxAggregateOutputType = {
  __typename?: 'CareAddonEnrollmentMaxAggregateOutputType';
  addOnPackageId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentMaxOrderByAggregateInput = {
  addOnPackageId?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationPetId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonEnrollmentMinAggregateOutputType = {
  __typename?: 'CareAddonEnrollmentMinAggregateOutputType';
  addOnPackageId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentMinOrderByAggregateInput = {
  addOnPackageId?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationPetId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonEnrollmentNullableScalarRelationFilter = {
  AND?: Maybe<Array<CareAddonEnrollmentWhereInput>>;
  NOT?: Maybe<Array<CareAddonEnrollmentWhereInput>>;
  OR?: Maybe<Array<CareAddonEnrollmentWhereInput>>;
  addOnPackage?: Maybe<CareAddonPackageScalarRelationFilter>;
  addOnPackageId?: Maybe<StringFilter>;
  associatedUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionNullableScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentListRelationFilter>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemListRelationFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  organizationPet?: Maybe<OrganizationPetScalarRelationFilter>;
  organizationPetId?: Maybe<StringFilter>;
  startDate?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumEnrollmentStatusFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAddonEnrollmentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareAddonEnrollmentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareAddonEnrollmentOrderByRelevanceInput>;
  addOnPackage?: Maybe<CareAddonPackageOrderByWithRelationInput>;
  addOnPackageId?: Maybe<SortOrder>;
  associatedUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentOrderByRelationAggregateInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemOrderByRelationAggregateInput>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  organizationPetId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareAddonEnrollmentOrderByRelevanceFieldEnum {
  AddOnPackageId = 'addOnPackageId',
  CareStripeSubscriptionId = 'careStripeSubscriptionId',
  Id = 'id',
  OrganizationPetId = 'organizationPetId',
  StripeSubscriptionItemId = 'stripeSubscriptionItemId'
}

export type CareAddonEnrollmentOrderByRelevanceInput = {
  fields: Array<CareAddonEnrollmentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareAddonEnrollmentOrderByWithAggregationInput = {
  _count?: Maybe<CareAddonEnrollmentCountOrderByAggregateInput>;
  _max?: Maybe<CareAddonEnrollmentMaxOrderByAggregateInput>;
  _min?: Maybe<CareAddonEnrollmentMinOrderByAggregateInput>;
  addOnPackageId?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationPetId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonEnrollmentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareAddonEnrollmentOrderByRelevanceInput>;
  addOnPackage?: Maybe<CareAddonPackageOrderByWithRelationInput>;
  addOnPackageId?: Maybe<SortOrder>;
  associatedUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentOrderByRelationAggregateInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemOrderByRelationAggregateInput>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  organizationPetId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonEnrollmentOrderByWithRelationInput = {
  _relevance?: Maybe<CareAddonEnrollmentOrderByRelevanceInput>;
  addOnPackage?: Maybe<CareAddonPackageOrderByWithRelationInput>;
  addOnPackageId?: Maybe<SortOrder>;
  associatedUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentOrderByRelationAggregateInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemOrderByRelationAggregateInput>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  organizationPetId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareAddonEnrollmentScalarFieldEnum {
  AddOnPackageId = 'addOnPackageId',
  CareStripeSubscriptionId = 'careStripeSubscriptionId',
  CreatedAt = 'createdAt',
  ExpirationDate = 'expirationDate',
  Id = 'id',
  OrganizationPetId = 'organizationPetId',
  StartDate = 'startDate',
  Status = 'status',
  StripeSubscriptionItemId = 'stripeSubscriptionItemId',
  UpdatedAt = 'updatedAt'
}

export type CareAddonEnrollmentScalarWhereInput = {
  AND?: Maybe<Array<CareAddonEnrollmentScalarWhereInput>>;
  NOT?: Maybe<Array<CareAddonEnrollmentScalarWhereInput>>;
  OR?: Maybe<Array<CareAddonEnrollmentScalarWhereInput>>;
  addOnPackageId?: Maybe<StringFilter>;
  careStripeSubscriptionId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  organizationPetId?: Maybe<StringFilter>;
  startDate?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumEnrollmentStatusFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAddonEnrollmentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareAddonEnrollmentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareAddonEnrollmentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareAddonEnrollmentScalarWhereWithAggregatesInput>>;
  addOnPackageId?: Maybe<StringWithAggregatesFilter>;
  careStripeSubscriptionId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  expirationDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  organizationPetId?: Maybe<StringWithAggregatesFilter>;
  startDate?: Maybe<DateTimeWithAggregatesFilter>;
  status?: Maybe<EnumEnrollmentStatusWithAggregatesFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CareAddonEnrollmentUncheckedCreateInput = {
  addOnPackageId: Scalars['String'];
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedAddonEnrollmentInput>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedCreateNestedManyWithoutAddOnPackageInput = {
  connect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonEnrollmentCreateOrConnectWithoutAddOnPackageInput>>;
  create?: Maybe<Array<CareAddonEnrollmentCreateWithoutAddOnPackageInput>>;
  createMany?: Maybe<CareAddonEnrollmentCreateManyAddOnPackageInputEnvelope>;
};

export type CareAddonEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput = {
  connect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonEnrollmentCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CareAddonEnrollmentCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CareAddonEnrollmentCreateManyCareStripeSubscriptionInputEnvelope>;
};

export type CareAddonEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput = {
  connect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonEnrollmentCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<CareAddonEnrollmentCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<CareAddonEnrollmentCreateManyOrganizationPetInputEnvelope>;
};

export type CareAddonEnrollmentUncheckedCreateWithoutAddOnPackageInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedAddonEnrollmentInput>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedCreateWithoutAssociatedUsagesInput = {
  addOnPackageId: Scalars['String'];
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedCreateWithoutCareStripeSubscriptionInput = {
  addOnPackageId: Scalars['String'];
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedAddonEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedCreateWithoutEnrollmentPaymentsInput = {
  addOnPackageId: Scalars['String'];
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedAddonEnrollmentInput>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedCreateWithoutEnrollmentToStripeInvoiceItemsInput = {
  addOnPackageId: Scalars['String'];
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedAddonEnrollmentInput>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedCreateWithoutOrganizationPetInput = {
  addOnPackageId: Scalars['String'];
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedAddonEnrollmentInput>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedUpdateInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedAddonEnrollmentNestedInput>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedUpdateManyInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedUpdateManyWithoutAddOnPackageInput = {
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedUpdateManyWithoutAddOnPackageNestedInput = {
  connect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonEnrollmentCreateOrConnectWithoutAddOnPackageInput>>;
  create?: Maybe<Array<CareAddonEnrollmentCreateWithoutAddOnPackageInput>>;
  createMany?: Maybe<CareAddonEnrollmentCreateManyAddOnPackageInputEnvelope>;
  delete?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonEnrollmentUpdateWithWhereUniqueWithoutAddOnPackageInput>>;
  updateMany?: Maybe<Array<CareAddonEnrollmentUpdateManyWithWhereWithoutAddOnPackageInput>>;
  upsert?: Maybe<Array<CareAddonEnrollmentUpsertWithWhereUniqueWithoutAddOnPackageInput>>;
};

export type CareAddonEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput = {
  connect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonEnrollmentCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CareAddonEnrollmentCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CareAddonEnrollmentCreateManyCareStripeSubscriptionInputEnvelope>;
  delete?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonEnrollmentUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
  updateMany?: Maybe<Array<CareAddonEnrollmentUpdateManyWithWhereWithoutCareStripeSubscriptionInput>>;
  upsert?: Maybe<Array<CareAddonEnrollmentUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
};

export type CareAddonEnrollmentUncheckedUpdateManyWithoutOrganizationPetInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput = {
  connect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonEnrollmentCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<CareAddonEnrollmentCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<CareAddonEnrollmentCreateManyOrganizationPetInputEnvelope>;
  delete?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonEnrollmentUpdateWithWhereUniqueWithoutOrganizationPetInput>>;
  updateMany?: Maybe<Array<CareAddonEnrollmentUpdateManyWithWhereWithoutOrganizationPetInput>>;
  upsert?: Maybe<Array<CareAddonEnrollmentUpsertWithWhereUniqueWithoutOrganizationPetInput>>;
};

export type CareAddonEnrollmentUncheckedUpdateWithoutAddOnPackageInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedAddonEnrollmentNestedInput>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedUpdateWithoutAssociatedUsagesInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedUpdateWithoutCareStripeSubscriptionInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedAddonEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedUpdateWithoutEnrollmentPaymentsInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedAddonEnrollmentNestedInput>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedUpdateWithoutEnrollmentToStripeInvoiceItemsInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedAddonEnrollmentNestedInput>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUncheckedUpdateWithoutOrganizationPetInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedAddonEnrollmentNestedInput>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUpdateInput = {
  addOnPackage?: Maybe<CareAddonPackageUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedAddonEnrollmentNestedInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCareAddonEnrollmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCareAddonEnrollmentsNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUpdateManyWithWhereWithoutAddOnPackageInput = {
  data: CareAddonEnrollmentUpdateManyMutationInput;
  where: CareAddonEnrollmentScalarWhereInput;
};

export type CareAddonEnrollmentUpdateManyWithWhereWithoutCareStripeSubscriptionInput = {
  data: CareAddonEnrollmentUpdateManyMutationInput;
  where: CareAddonEnrollmentScalarWhereInput;
};

export type CareAddonEnrollmentUpdateManyWithWhereWithoutOrganizationPetInput = {
  data: CareAddonEnrollmentUpdateManyMutationInput;
  where: CareAddonEnrollmentScalarWhereInput;
};

export type CareAddonEnrollmentUpdateManyWithoutAddOnPackageNestedInput = {
  connect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonEnrollmentCreateOrConnectWithoutAddOnPackageInput>>;
  create?: Maybe<Array<CareAddonEnrollmentCreateWithoutAddOnPackageInput>>;
  createMany?: Maybe<CareAddonEnrollmentCreateManyAddOnPackageInputEnvelope>;
  delete?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonEnrollmentUpdateWithWhereUniqueWithoutAddOnPackageInput>>;
  updateMany?: Maybe<Array<CareAddonEnrollmentUpdateManyWithWhereWithoutAddOnPackageInput>>;
  upsert?: Maybe<Array<CareAddonEnrollmentUpsertWithWhereUniqueWithoutAddOnPackageInput>>;
};

export type CareAddonEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput = {
  connect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonEnrollmentCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CareAddonEnrollmentCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CareAddonEnrollmentCreateManyCareStripeSubscriptionInputEnvelope>;
  delete?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonEnrollmentUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
  updateMany?: Maybe<Array<CareAddonEnrollmentUpdateManyWithWhereWithoutCareStripeSubscriptionInput>>;
  upsert?: Maybe<Array<CareAddonEnrollmentUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
};

export type CareAddonEnrollmentUpdateManyWithoutOrganizationPetNestedInput = {
  connect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonEnrollmentCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<CareAddonEnrollmentCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<CareAddonEnrollmentCreateManyOrganizationPetInputEnvelope>;
  delete?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonEnrollmentUpdateWithWhereUniqueWithoutOrganizationPetInput>>;
  updateMany?: Maybe<Array<CareAddonEnrollmentUpdateManyWithWhereWithoutOrganizationPetInput>>;
  upsert?: Maybe<Array<CareAddonEnrollmentUpsertWithWhereUniqueWithoutOrganizationPetInput>>;
};

export type CareAddonEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput = {
  connect?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAddonEnrollmentCreateOrConnectWithoutAssociatedUsagesInput>;
  create?: Maybe<CareAddonEnrollmentCreateWithoutAssociatedUsagesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareAddonEnrollmentUpdateToOneWithWhereWithoutAssociatedUsagesInput>;
  upsert?: Maybe<CareAddonEnrollmentUpsertWithoutAssociatedUsagesInput>;
};

export type CareAddonEnrollmentUpdateOneWithoutEnrollmentPaymentsNestedInput = {
  connect?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAddonEnrollmentCreateOrConnectWithoutEnrollmentPaymentsInput>;
  create?: Maybe<CareAddonEnrollmentCreateWithoutEnrollmentPaymentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareAddonEnrollmentUpdateToOneWithWhereWithoutEnrollmentPaymentsInput>;
  upsert?: Maybe<CareAddonEnrollmentUpsertWithoutEnrollmentPaymentsInput>;
};

export type CareAddonEnrollmentUpdateOneWithoutEnrollmentToStripeInvoiceItemsNestedInput = {
  connect?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAddonEnrollmentCreateOrConnectWithoutEnrollmentToStripeInvoiceItemsInput>;
  create?: Maybe<CareAddonEnrollmentCreateWithoutEnrollmentToStripeInvoiceItemsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareAddonEnrollmentUpdateToOneWithWhereWithoutEnrollmentToStripeInvoiceItemsInput>;
  upsert?: Maybe<CareAddonEnrollmentUpsertWithoutEnrollmentToStripeInvoiceItemsInput>;
};

export type CareAddonEnrollmentUpdateToOneWithWhereWithoutAssociatedUsagesInput = {
  data: CareAddonEnrollmentUpdateWithoutAssociatedUsagesInput;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};

export type CareAddonEnrollmentUpdateToOneWithWhereWithoutEnrollmentPaymentsInput = {
  data: CareAddonEnrollmentUpdateWithoutEnrollmentPaymentsInput;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};

export type CareAddonEnrollmentUpdateToOneWithWhereWithoutEnrollmentToStripeInvoiceItemsInput = {
  data: CareAddonEnrollmentUpdateWithoutEnrollmentToStripeInvoiceItemsInput;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};

export type CareAddonEnrollmentUpdateWithWhereUniqueWithoutAddOnPackageInput = {
  data: CareAddonEnrollmentUpdateWithoutAddOnPackageInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};

export type CareAddonEnrollmentUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput = {
  data: CareAddonEnrollmentUpdateWithoutCareStripeSubscriptionInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};

export type CareAddonEnrollmentUpdateWithWhereUniqueWithoutOrganizationPetInput = {
  data: CareAddonEnrollmentUpdateWithoutOrganizationPetInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};

export type CareAddonEnrollmentUpdateWithoutAddOnPackageInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedAddonEnrollmentNestedInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCareAddonEnrollmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCareAddonEnrollmentsNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUpdateWithoutAssociatedUsagesInput = {
  addOnPackage?: Maybe<CareAddonPackageUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCareAddonEnrollmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCareAddonEnrollmentsNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUpdateWithoutCareStripeSubscriptionInput = {
  addOnPackage?: Maybe<CareAddonPackageUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedAddonEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCareAddonEnrollmentsNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUpdateWithoutEnrollmentPaymentsInput = {
  addOnPackage?: Maybe<CareAddonPackageUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedAddonEnrollmentNestedInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCareAddonEnrollmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCareAddonEnrollmentsNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUpdateWithoutEnrollmentToStripeInvoiceItemsInput = {
  addOnPackage?: Maybe<CareAddonPackageUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedAddonEnrollmentNestedInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCareAddonEnrollmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCareAddonEnrollmentsNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUpdateWithoutOrganizationPetInput = {
  addOnPackage?: Maybe<CareAddonPackageUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedAddonEnrollmentNestedInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCareAddonEnrollmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCareAddonEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonEnrollmentUpsertWithWhereUniqueWithoutAddOnPackageInput = {
  create: CareAddonEnrollmentCreateWithoutAddOnPackageInput;
  update: CareAddonEnrollmentUpdateWithoutAddOnPackageInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};

export type CareAddonEnrollmentUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput = {
  create: CareAddonEnrollmentCreateWithoutCareStripeSubscriptionInput;
  update: CareAddonEnrollmentUpdateWithoutCareStripeSubscriptionInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};

export type CareAddonEnrollmentUpsertWithWhereUniqueWithoutOrganizationPetInput = {
  create: CareAddonEnrollmentCreateWithoutOrganizationPetInput;
  update: CareAddonEnrollmentUpdateWithoutOrganizationPetInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};

export type CareAddonEnrollmentUpsertWithoutAssociatedUsagesInput = {
  create: CareAddonEnrollmentCreateWithoutAssociatedUsagesInput;
  update: CareAddonEnrollmentUpdateWithoutAssociatedUsagesInput;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};

export type CareAddonEnrollmentUpsertWithoutEnrollmentPaymentsInput = {
  create: CareAddonEnrollmentCreateWithoutEnrollmentPaymentsInput;
  update: CareAddonEnrollmentUpdateWithoutEnrollmentPaymentsInput;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};

export type CareAddonEnrollmentUpsertWithoutEnrollmentToStripeInvoiceItemsInput = {
  create: CareAddonEnrollmentCreateWithoutEnrollmentToStripeInvoiceItemsInput;
  update: CareAddonEnrollmentUpdateWithoutEnrollmentToStripeInvoiceItemsInput;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};

export type CareAddonEnrollmentWhereInput = {
  AND?: Maybe<Array<CareAddonEnrollmentWhereInput>>;
  NOT?: Maybe<Array<CareAddonEnrollmentWhereInput>>;
  OR?: Maybe<Array<CareAddonEnrollmentWhereInput>>;
  addOnPackage?: Maybe<CareAddonPackageScalarRelationFilter>;
  addOnPackageId?: Maybe<StringFilter>;
  associatedUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionNullableScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentListRelationFilter>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemListRelationFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  organizationPet?: Maybe<OrganizationPetScalarRelationFilter>;
  organizationPetId?: Maybe<StringFilter>;
  startDate?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumEnrollmentStatusFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAddonEnrollmentWhereUniqueInput = {
  AND?: Maybe<Array<CareAddonEnrollmentWhereInput>>;
  NOT?: Maybe<Array<CareAddonEnrollmentWhereInput>>;
  OR?: Maybe<Array<CareAddonEnrollmentWhereInput>>;
  addOnPackage?: Maybe<CareAddonPackageScalarRelationFilter>;
  addOnPackageId?: Maybe<StringFilter>;
  associatedUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionNullableScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentListRelationFilter>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemListRelationFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetScalarRelationFilter>;
  organizationPetId?: Maybe<StringFilter>;
  startDate?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumEnrollmentStatusFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAddonPackage = {
  __typename?: 'CareAddonPackage';
  _count: CareAddonPackageCountOutputType;
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit: Array<CareAddonPackageBenefit>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle: CarePlanCycleType;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes: Scalars['String'];
  enrollments: Array<CareAddonEnrollment>;
  id: Scalars['String'];
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal: Scalars['Int'];
  published: Scalars['Boolean'];
  renewalCycle: CarePlanCycleType;
  salesTaxCentsPerMonth: Scalars['Int'];
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type CareAddonPackageAddonPackageBenefitArgs = {
  cursor?: Maybe<CareAddonPackageBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonPackageBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonPackageBenefitOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonPackageBenefitWhereInput>;
};


export type CareAddonPackageAssociatedCarePlanProviderGroupArgs = {
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type CareAddonPackageEnrollmentsArgs = {
  cursor?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};


export type CareAddonPackageOrganizationArgs = {
  where?: Maybe<OrganizationWhereInput>;
};

export type CareAddonPackageAvgAggregateOutputType = {
  __typename?: 'CareAddonPackageAvgAggregateOutputType';
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Float']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Float']>;
  pricePerRenewal?: Maybe<Scalars['Float']>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Float']>;
};

export type CareAddonPackageAvgOrderByAggregateInput = {
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
};

export type CareAddonPackageBenefit = {
  __typename?: 'CareAddonPackageBenefit';
  addOnPackage: CareAddonPackage;
  addOnPackageId: Scalars['String'];
  benefit: CareBenefit;
  benefitId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages: Scalars['Int'];
  reportingExpectedValue: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CareAddonPackageBenefitAddOnPackageIdDisplayOrderCompoundUniqueInput = {
  addOnPackageId: Scalars['String'];
  displayOrder: Scalars['Int'];
};

export type CareAddonPackageBenefitAvgAggregateOutputType = {
  __typename?: 'CareAddonPackageBenefitAvgAggregateOutputType';
  displayOrder?: Maybe<Scalars['Float']>;
  includedUses?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Float']>;
};

export type CareAddonPackageBenefitAvgOrderByAggregateInput = {
  displayOrder?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
};

export type CareAddonPackageBenefitCountAggregateOutputType = {
  __typename?: 'CareAddonPackageBenefitCountAggregateOutputType';
  _all: Scalars['Int'];
  addOnPackageId: Scalars['Int'];
  benefitId: Scalars['Int'];
  createdAt: Scalars['Int'];
  displayOrder: Scalars['Int'];
  id: Scalars['Int'];
  includedUses: Scalars['Int'];
  projectedSavings: Scalars['Int'];
  reportingExpectedUsages: Scalars['Int'];
  reportingExpectedValue: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CareAddonPackageBenefitCountOrderByAggregateInput = {
  addOnPackageId?: Maybe<SortOrder>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonPackageBenefitCreateInput = {
  addOnPackage: CareAddonPackageCreateNestedOneWithoutAddonPackageBenefitInput;
  benefit: CareBenefitCreateNestedOneWithoutAddonPackageBenefitsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitCreateManyAddOnPackageInput = {
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitCreateManyAddOnPackageInputEnvelope = {
  data: Array<CareAddonPackageBenefitCreateManyAddOnPackageInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareAddonPackageBenefitCreateManyBenefitInput = {
  addOnPackageId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitCreateManyBenefitInputEnvelope = {
  data: Array<CareAddonPackageBenefitCreateManyBenefitInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareAddonPackageBenefitCreateManyInput = {
  addOnPackageId: Scalars['String'];
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitCreateNestedManyWithoutAddOnPackageInput = {
  connect?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageBenefitCreateOrConnectWithoutAddOnPackageInput>>;
  create?: Maybe<Array<CareAddonPackageBenefitCreateWithoutAddOnPackageInput>>;
  createMany?: Maybe<CareAddonPackageBenefitCreateManyAddOnPackageInputEnvelope>;
};

export type CareAddonPackageBenefitCreateNestedManyWithoutBenefitInput = {
  connect?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageBenefitCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CareAddonPackageBenefitCreateWithoutBenefitInput>>;
  createMany?: Maybe<CareAddonPackageBenefitCreateManyBenefitInputEnvelope>;
};

export type CareAddonPackageBenefitCreateOrConnectWithoutAddOnPackageInput = {
  create: CareAddonPackageBenefitCreateWithoutAddOnPackageInput;
  where: CareAddonPackageBenefitWhereUniqueInput;
};

export type CareAddonPackageBenefitCreateOrConnectWithoutBenefitInput = {
  create: CareAddonPackageBenefitCreateWithoutBenefitInput;
  where: CareAddonPackageBenefitWhereUniqueInput;
};

export type CareAddonPackageBenefitCreateWithoutAddOnPackageInput = {
  benefit: CareBenefitCreateNestedOneWithoutAddonPackageBenefitsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitCreateWithoutBenefitInput = {
  addOnPackage: CareAddonPackageCreateNestedOneWithoutAddonPackageBenefitInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitGroupByOutputType = {
  __typename?: 'CareAddonPackageBenefitGroupByOutputType';
  _avg?: Maybe<CareAddonPackageBenefitAvgAggregateOutputType>;
  _count?: Maybe<CareAddonPackageBenefitCountAggregateOutputType>;
  _max?: Maybe<CareAddonPackageBenefitMaxAggregateOutputType>;
  _min?: Maybe<CareAddonPackageBenefitMinAggregateOutputType>;
  _sum?: Maybe<CareAddonPackageBenefitSumAggregateOutputType>;
  addOnPackageId: Scalars['String'];
  benefitId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages: Scalars['Int'];
  reportingExpectedValue: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CareAddonPackageBenefitListRelationFilter = {
  every?: Maybe<CareAddonPackageBenefitWhereInput>;
  none?: Maybe<CareAddonPackageBenefitWhereInput>;
  some?: Maybe<CareAddonPackageBenefitWhereInput>;
};

export type CareAddonPackageBenefitMaxAggregateOutputType = {
  __typename?: 'CareAddonPackageBenefitMaxAggregateOutputType';
  addOnPackageId?: Maybe<Scalars['String']>;
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitMaxOrderByAggregateInput = {
  addOnPackageId?: Maybe<SortOrder>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonPackageBenefitMinAggregateOutputType = {
  __typename?: 'CareAddonPackageBenefitMinAggregateOutputType';
  addOnPackageId?: Maybe<Scalars['String']>;
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitMinOrderByAggregateInput = {
  addOnPackageId?: Maybe<SortOrder>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonPackageBenefitOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareAddonPackageBenefitOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareAddonPackageBenefitOrderByRelevanceInput>;
  addOnPackage?: Maybe<CareAddonPackageOrderByWithRelationInput>;
  addOnPackageId?: Maybe<SortOrder>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareAddonPackageBenefitOrderByRelevanceFieldEnum {
  AddOnPackageId = 'addOnPackageId',
  BenefitId = 'benefitId',
  Id = 'id',
  ProjectedSavings = 'projectedSavings'
}

export type CareAddonPackageBenefitOrderByRelevanceInput = {
  fields: Array<CareAddonPackageBenefitOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareAddonPackageBenefitOrderByWithAggregationInput = {
  _avg?: Maybe<CareAddonPackageBenefitAvgOrderByAggregateInput>;
  _count?: Maybe<CareAddonPackageBenefitCountOrderByAggregateInput>;
  _max?: Maybe<CareAddonPackageBenefitMaxOrderByAggregateInput>;
  _min?: Maybe<CareAddonPackageBenefitMinOrderByAggregateInput>;
  _sum?: Maybe<CareAddonPackageBenefitSumOrderByAggregateInput>;
  addOnPackageId?: Maybe<SortOrder>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonPackageBenefitOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareAddonPackageBenefitOrderByRelevanceInput>;
  addOnPackage?: Maybe<CareAddonPackageOrderByWithRelationInput>;
  addOnPackageId?: Maybe<SortOrder>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonPackageBenefitOrderByWithRelationInput = {
  _relevance?: Maybe<CareAddonPackageBenefitOrderByRelevanceInput>;
  addOnPackage?: Maybe<CareAddonPackageOrderByWithRelationInput>;
  addOnPackageId?: Maybe<SortOrder>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareAddonPackageBenefitScalarFieldEnum {
  AddOnPackageId = 'addOnPackageId',
  BenefitId = 'benefitId',
  CreatedAt = 'createdAt',
  DisplayOrder = 'displayOrder',
  Id = 'id',
  IncludedUses = 'includedUses',
  ProjectedSavings = 'projectedSavings',
  ReportingExpectedUsages = 'reportingExpectedUsages',
  ReportingExpectedValue = 'reportingExpectedValue',
  UpdatedAt = 'updatedAt'
}

export type CareAddonPackageBenefitScalarWhereInput = {
  AND?: Maybe<Array<CareAddonPackageBenefitScalarWhereInput>>;
  NOT?: Maybe<Array<CareAddonPackageBenefitScalarWhereInput>>;
  OR?: Maybe<Array<CareAddonPackageBenefitScalarWhereInput>>;
  addOnPackageId?: Maybe<StringFilter>;
  benefitId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  displayOrder?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  includedUses?: Maybe<IntNullableFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  reportingExpectedUsages?: Maybe<IntFilter>;
  reportingExpectedValue?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAddonPackageBenefitScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareAddonPackageBenefitScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareAddonPackageBenefitScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareAddonPackageBenefitScalarWhereWithAggregatesInput>>;
  addOnPackageId?: Maybe<StringWithAggregatesFilter>;
  benefitId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  displayOrder?: Maybe<IntNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  includedUses?: Maybe<IntNullableWithAggregatesFilter>;
  projectedSavings?: Maybe<StringNullableWithAggregatesFilter>;
  reportingExpectedUsages?: Maybe<IntWithAggregatesFilter>;
  reportingExpectedValue?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CareAddonPackageBenefitSumAggregateOutputType = {
  __typename?: 'CareAddonPackageBenefitSumAggregateOutputType';
  displayOrder?: Maybe<Scalars['Int']>;
  includedUses?: Maybe<Scalars['Int']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
};

export type CareAddonPackageBenefitSumOrderByAggregateInput = {
  displayOrder?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
};

export type CareAddonPackageBenefitUncheckedCreateInput = {
  addOnPackageId: Scalars['String'];
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUncheckedCreateNestedManyWithoutAddOnPackageInput = {
  connect?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageBenefitCreateOrConnectWithoutAddOnPackageInput>>;
  create?: Maybe<Array<CareAddonPackageBenefitCreateWithoutAddOnPackageInput>>;
  createMany?: Maybe<CareAddonPackageBenefitCreateManyAddOnPackageInputEnvelope>;
};

export type CareAddonPackageBenefitUncheckedCreateNestedManyWithoutBenefitInput = {
  connect?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageBenefitCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CareAddonPackageBenefitCreateWithoutBenefitInput>>;
  createMany?: Maybe<CareAddonPackageBenefitCreateManyBenefitInputEnvelope>;
};

export type CareAddonPackageBenefitUncheckedCreateWithoutAddOnPackageInput = {
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUncheckedCreateWithoutBenefitInput = {
  addOnPackageId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUncheckedUpdateInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUncheckedUpdateManyInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUncheckedUpdateManyWithoutAddOnPackageInput = {
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUncheckedUpdateManyWithoutAddOnPackageNestedInput = {
  connect?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageBenefitCreateOrConnectWithoutAddOnPackageInput>>;
  create?: Maybe<Array<CareAddonPackageBenefitCreateWithoutAddOnPackageInput>>;
  createMany?: Maybe<CareAddonPackageBenefitCreateManyAddOnPackageInputEnvelope>;
  delete?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonPackageBenefitScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonPackageBenefitUpdateWithWhereUniqueWithoutAddOnPackageInput>>;
  updateMany?: Maybe<Array<CareAddonPackageBenefitUpdateManyWithWhereWithoutAddOnPackageInput>>;
  upsert?: Maybe<Array<CareAddonPackageBenefitUpsertWithWhereUniqueWithoutAddOnPackageInput>>;
};

export type CareAddonPackageBenefitUncheckedUpdateManyWithoutBenefitInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUncheckedUpdateManyWithoutBenefitNestedInput = {
  connect?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageBenefitCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CareAddonPackageBenefitCreateWithoutBenefitInput>>;
  createMany?: Maybe<CareAddonPackageBenefitCreateManyBenefitInputEnvelope>;
  delete?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonPackageBenefitScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonPackageBenefitUpdateWithWhereUniqueWithoutBenefitInput>>;
  updateMany?: Maybe<Array<CareAddonPackageBenefitUpdateManyWithWhereWithoutBenefitInput>>;
  upsert?: Maybe<Array<CareAddonPackageBenefitUpsertWithWhereUniqueWithoutBenefitInput>>;
};

export type CareAddonPackageBenefitUncheckedUpdateWithoutAddOnPackageInput = {
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUncheckedUpdateWithoutBenefitInput = {
  addOnPackageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUpdateInput = {
  addOnPackage?: Maybe<CareAddonPackageUpdateOneRequiredWithoutAddonPackageBenefitNestedInput>;
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutAddonPackageBenefitsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUpdateManyWithWhereWithoutAddOnPackageInput = {
  data: CareAddonPackageBenefitUpdateManyMutationInput;
  where: CareAddonPackageBenefitScalarWhereInput;
};

export type CareAddonPackageBenefitUpdateManyWithWhereWithoutBenefitInput = {
  data: CareAddonPackageBenefitUpdateManyMutationInput;
  where: CareAddonPackageBenefitScalarWhereInput;
};

export type CareAddonPackageBenefitUpdateManyWithoutAddOnPackageNestedInput = {
  connect?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageBenefitCreateOrConnectWithoutAddOnPackageInput>>;
  create?: Maybe<Array<CareAddonPackageBenefitCreateWithoutAddOnPackageInput>>;
  createMany?: Maybe<CareAddonPackageBenefitCreateManyAddOnPackageInputEnvelope>;
  delete?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonPackageBenefitScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonPackageBenefitUpdateWithWhereUniqueWithoutAddOnPackageInput>>;
  updateMany?: Maybe<Array<CareAddonPackageBenefitUpdateManyWithWhereWithoutAddOnPackageInput>>;
  upsert?: Maybe<Array<CareAddonPackageBenefitUpsertWithWhereUniqueWithoutAddOnPackageInput>>;
};

export type CareAddonPackageBenefitUpdateManyWithoutBenefitNestedInput = {
  connect?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageBenefitCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CareAddonPackageBenefitCreateWithoutBenefitInput>>;
  createMany?: Maybe<CareAddonPackageBenefitCreateManyBenefitInputEnvelope>;
  delete?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonPackageBenefitScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonPackageBenefitWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonPackageBenefitUpdateWithWhereUniqueWithoutBenefitInput>>;
  updateMany?: Maybe<Array<CareAddonPackageBenefitUpdateManyWithWhereWithoutBenefitInput>>;
  upsert?: Maybe<Array<CareAddonPackageBenefitUpsertWithWhereUniqueWithoutBenefitInput>>;
};

export type CareAddonPackageBenefitUpdateWithWhereUniqueWithoutAddOnPackageInput = {
  data: CareAddonPackageBenefitUpdateWithoutAddOnPackageInput;
  where: CareAddonPackageBenefitWhereUniqueInput;
};

export type CareAddonPackageBenefitUpdateWithWhereUniqueWithoutBenefitInput = {
  data: CareAddonPackageBenefitUpdateWithoutBenefitInput;
  where: CareAddonPackageBenefitWhereUniqueInput;
};

export type CareAddonPackageBenefitUpdateWithoutAddOnPackageInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutAddonPackageBenefitsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUpdateWithoutBenefitInput = {
  addOnPackage?: Maybe<CareAddonPackageUpdateOneRequiredWithoutAddonPackageBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageBenefitUpsertWithWhereUniqueWithoutAddOnPackageInput = {
  create: CareAddonPackageBenefitCreateWithoutAddOnPackageInput;
  update: CareAddonPackageBenefitUpdateWithoutAddOnPackageInput;
  where: CareAddonPackageBenefitWhereUniqueInput;
};

export type CareAddonPackageBenefitUpsertWithWhereUniqueWithoutBenefitInput = {
  create: CareAddonPackageBenefitCreateWithoutBenefitInput;
  update: CareAddonPackageBenefitUpdateWithoutBenefitInput;
  where: CareAddonPackageBenefitWhereUniqueInput;
};

export type CareAddonPackageBenefitWhereInput = {
  AND?: Maybe<Array<CareAddonPackageBenefitWhereInput>>;
  NOT?: Maybe<Array<CareAddonPackageBenefitWhereInput>>;
  OR?: Maybe<Array<CareAddonPackageBenefitWhereInput>>;
  addOnPackage?: Maybe<CareAddonPackageScalarRelationFilter>;
  addOnPackageId?: Maybe<StringFilter>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  displayOrder?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  includedUses?: Maybe<IntNullableFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  reportingExpectedUsages?: Maybe<IntFilter>;
  reportingExpectedValue?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAddonPackageBenefitWhereUniqueInput = {
  AND?: Maybe<Array<CareAddonPackageBenefitWhereInput>>;
  NOT?: Maybe<Array<CareAddonPackageBenefitWhereInput>>;
  OR?: Maybe<Array<CareAddonPackageBenefitWhereInput>>;
  addOnPackage?: Maybe<CareAddonPackageScalarRelationFilter>;
  addOnPackageId?: Maybe<StringFilter>;
  addOnPackageId_displayOrder?: Maybe<CareAddonPackageBenefitAddOnPackageIdDisplayOrderCompoundUniqueInput>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  displayOrder?: Maybe<IntNullableFilter>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<IntNullableFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  reportingExpectedUsages?: Maybe<IntFilter>;
  reportingExpectedValue?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAddonPackageCountAggregateOutputType = {
  __typename?: 'CareAddonPackageCountAggregateOutputType';
  _all: Scalars['Int'];
  addonCancelsAt: Scalars['Int'];
  associatedCarePlanProviderGroupId: Scalars['Int'];
  billingCycle: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  earliestTargetPetAgeInMonths: Scalars['Int'];
  editorNotes: Scalars['Int'];
  id: Scalars['Int'];
  latestTargetPetAgeInMonths: Scalars['Int'];
  organizationId: Scalars['Int'];
  pricePerRenewal: Scalars['Int'];
  published: Scalars['Int'];
  renewalCycle: Scalars['Int'];
  salesTaxCentsPerMonth: Scalars['Int'];
  stripePriceId: Scalars['Int'];
  targetSpecies: Scalars['Int'];
  themeColor: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CareAddonPackageCountOrderByAggregateInput = {
  addonCancelsAt?: Maybe<SortOrder>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonPackageCountOutputType = {
  __typename?: 'CareAddonPackageCountOutputType';
  addonPackageBenefit: Scalars['Int'];
  enrollments: Scalars['Int'];
};

export type CareAddonPackageCreateInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitCreateNestedManyWithoutAddOnPackageInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedAddonPackagesInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutAddOnPackageInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutCareAddonPackageInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageCreateManyAssociatedCarePlanProviderGroupInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageCreateManyAssociatedCarePlanProviderGroupInputEnvelope = {
  data: Array<CareAddonPackageCreateManyAssociatedCarePlanProviderGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareAddonPackageCreateManyInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageCreateManyOrganizationInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageCreateManyOrganizationInputEnvelope = {
  data: Array<CareAddonPackageCreateManyOrganizationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareAddonPackageCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput = {
  connect?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CareAddonPackageCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CareAddonPackageCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
};

export type CareAddonPackageCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CareAddonPackageCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CareAddonPackageCreateManyOrganizationInputEnvelope>;
};

export type CareAddonPackageCreateNestedOneWithoutAddonPackageBenefitInput = {
  connect?: Maybe<CareAddonPackageWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAddonPackageCreateOrConnectWithoutAddonPackageBenefitInput>;
  create?: Maybe<CareAddonPackageCreateWithoutAddonPackageBenefitInput>;
};

export type CareAddonPackageCreateNestedOneWithoutEnrollmentsInput = {
  connect?: Maybe<CareAddonPackageWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAddonPackageCreateOrConnectWithoutEnrollmentsInput>;
  create?: Maybe<CareAddonPackageCreateWithoutEnrollmentsInput>;
};

export type CareAddonPackageCreateOrConnectWithoutAddonPackageBenefitInput = {
  create: CareAddonPackageCreateWithoutAddonPackageBenefitInput;
  where: CareAddonPackageWhereUniqueInput;
};

export type CareAddonPackageCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput = {
  create: CareAddonPackageCreateWithoutAssociatedCarePlanProviderGroupInput;
  where: CareAddonPackageWhereUniqueInput;
};

export type CareAddonPackageCreateOrConnectWithoutEnrollmentsInput = {
  create: CareAddonPackageCreateWithoutEnrollmentsInput;
  where: CareAddonPackageWhereUniqueInput;
};

export type CareAddonPackageCreateOrConnectWithoutOrganizationInput = {
  create: CareAddonPackageCreateWithoutOrganizationInput;
  where: CareAddonPackageWhereUniqueInput;
};

export type CareAddonPackageCreateWithoutAddonPackageBenefitInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedAddonPackagesInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutAddOnPackageInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutCareAddonPackageInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageCreateWithoutAssociatedCarePlanProviderGroupInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitCreateNestedManyWithoutAddOnPackageInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutAddOnPackageInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutCareAddonPackageInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageCreateWithoutEnrollmentsInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitCreateNestedManyWithoutAddOnPackageInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedAddonPackagesInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutCareAddonPackageInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageCreateWithoutOrganizationInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitCreateNestedManyWithoutAddOnPackageInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedAddonPackagesInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutAddOnPackageInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageGroupByOutputType = {
  __typename?: 'CareAddonPackageGroupByOutputType';
  _avg?: Maybe<CareAddonPackageAvgAggregateOutputType>;
  _count?: Maybe<CareAddonPackageCountAggregateOutputType>;
  _max?: Maybe<CareAddonPackageMaxAggregateOutputType>;
  _min?: Maybe<CareAddonPackageMinAggregateOutputType>;
  _sum?: Maybe<CareAddonPackageSumAggregateOutputType>;
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle: CarePlanCycleType;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes: Scalars['String'];
  id: Scalars['String'];
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal: Scalars['Int'];
  published: Scalars['Boolean'];
  renewalCycle: CarePlanCycleType;
  salesTaxCentsPerMonth: Scalars['Int'];
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CareAddonPackageListRelationFilter = {
  every?: Maybe<CareAddonPackageWhereInput>;
  none?: Maybe<CareAddonPackageWhereInput>;
  some?: Maybe<CareAddonPackageWhereInput>;
};

export type CareAddonPackageMaxAggregateOutputType = {
  __typename?: 'CareAddonPackageMaxAggregateOutputType';
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageMaxOrderByAggregateInput = {
  addonCancelsAt?: Maybe<SortOrder>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonPackageMinAggregateOutputType = {
  __typename?: 'CareAddonPackageMinAggregateOutputType';
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageMinOrderByAggregateInput = {
  addonCancelsAt?: Maybe<SortOrder>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonPackageOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareAddonPackageOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareAddonPackageOrderByRelevanceInput>;
  addonCancelsAt?: Maybe<SortOrder>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitOrderByRelationAggregateInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  enrollments?: Maybe<CareAddonEnrollmentOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareAddonPackageOrderByRelevanceFieldEnum {
  AssociatedCarePlanProviderGroupId = 'associatedCarePlanProviderGroupId',
  Description = 'description',
  EditorNotes = 'editorNotes',
  Id = 'id',
  OrganizationId = 'organizationId',
  StripePriceId = 'stripePriceId',
  ThemeColor = 'themeColor',
  Title = 'title'
}

export type CareAddonPackageOrderByRelevanceInput = {
  fields: Array<CareAddonPackageOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareAddonPackageOrderByWithAggregationInput = {
  _avg?: Maybe<CareAddonPackageAvgOrderByAggregateInput>;
  _count?: Maybe<CareAddonPackageCountOrderByAggregateInput>;
  _max?: Maybe<CareAddonPackageMaxOrderByAggregateInput>;
  _min?: Maybe<CareAddonPackageMinOrderByAggregateInput>;
  _sum?: Maybe<CareAddonPackageSumOrderByAggregateInput>;
  addonCancelsAt?: Maybe<SortOrder>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonPackageOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareAddonPackageOrderByRelevanceInput>;
  addonCancelsAt?: Maybe<SortOrder>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitOrderByRelationAggregateInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  enrollments?: Maybe<CareAddonEnrollmentOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAddonPackageOrderByWithRelationInput = {
  _relevance?: Maybe<CareAddonPackageOrderByRelevanceInput>;
  addonCancelsAt?: Maybe<SortOrder>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitOrderByRelationAggregateInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  enrollments?: Maybe<CareAddonEnrollmentOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareAddonPackageScalarFieldEnum {
  AddonCancelsAt = 'addonCancelsAt',
  AssociatedCarePlanProviderGroupId = 'associatedCarePlanProviderGroupId',
  BillingCycle = 'billingCycle',
  CreatedAt = 'createdAt',
  Description = 'description',
  EarliestTargetPetAgeInMonths = 'earliestTargetPetAgeInMonths',
  EditorNotes = 'editorNotes',
  Id = 'id',
  LatestTargetPetAgeInMonths = 'latestTargetPetAgeInMonths',
  OrganizationId = 'organizationId',
  PricePerRenewal = 'pricePerRenewal',
  Published = 'published',
  RenewalCycle = 'renewalCycle',
  SalesTaxCentsPerMonth = 'salesTaxCentsPerMonth',
  StripePriceId = 'stripePriceId',
  TargetSpecies = 'targetSpecies',
  ThemeColor = 'themeColor',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type CareAddonPackageScalarRelationFilter = {
  AND?: Maybe<Array<CareAddonPackageWhereInput>>;
  NOT?: Maybe<Array<CareAddonPackageWhereInput>>;
  OR?: Maybe<Array<CareAddonPackageWhereInput>>;
  addonCancelsAt?: Maybe<DateTimeNullableFilter>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitListRelationFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  earliestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  editorNotes?: Maybe<StringFilter>;
  enrollments?: Maybe<CareAddonEnrollmentListRelationFilter>;
  id?: Maybe<StringFilter>;
  latestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  targetSpecies?: Maybe<EnumSpeciesTypeNullableFilter>;
  themeColor?: Maybe<StringNullableFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAddonPackageScalarWhereInput = {
  AND?: Maybe<Array<CareAddonPackageScalarWhereInput>>;
  NOT?: Maybe<Array<CareAddonPackageScalarWhereInput>>;
  OR?: Maybe<Array<CareAddonPackageScalarWhereInput>>;
  addonCancelsAt?: Maybe<DateTimeNullableFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  earliestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  editorNotes?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  latestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  targetSpecies?: Maybe<EnumSpeciesTypeNullableFilter>;
  themeColor?: Maybe<StringNullableFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAddonPackageScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareAddonPackageScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareAddonPackageScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareAddonPackageScalarWhereWithAggregatesInput>>;
  addonCancelsAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableWithAggregatesFilter>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  earliestTargetPetAgeInMonths?: Maybe<IntNullableWithAggregatesFilter>;
  editorNotes?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  latestTargetPetAgeInMonths?: Maybe<IntNullableWithAggregatesFilter>;
  organizationId?: Maybe<StringNullableWithAggregatesFilter>;
  pricePerRenewal?: Maybe<IntWithAggregatesFilter>;
  published?: Maybe<BoolWithAggregatesFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeWithAggregatesFilter>;
  salesTaxCentsPerMonth?: Maybe<IntWithAggregatesFilter>;
  stripePriceId?: Maybe<StringNullableWithAggregatesFilter>;
  targetSpecies?: Maybe<EnumSpeciesTypeNullableWithAggregatesFilter>;
  themeColor?: Maybe<StringNullableWithAggregatesFilter>;
  title?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CareAddonPackageSumAggregateOutputType = {
  __typename?: 'CareAddonPackageSumAggregateOutputType';
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
};

export type CareAddonPackageSumOrderByAggregateInput = {
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
};

export type CareAddonPackageUncheckedCreateInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitUncheckedCreateNestedManyWithoutAddOnPackageInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutAddOnPackageInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput = {
  connect?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CareAddonPackageCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CareAddonPackageCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
};

export type CareAddonPackageUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CareAddonPackageCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CareAddonPackageCreateManyOrganizationInputEnvelope>;
};

export type CareAddonPackageUncheckedCreateWithoutAddonPackageBenefitInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutAddOnPackageInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUncheckedCreateWithoutAssociatedCarePlanProviderGroupInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitUncheckedCreateNestedManyWithoutAddOnPackageInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutAddOnPackageInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUncheckedCreateWithoutEnrollmentsInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitUncheckedCreateNestedManyWithoutAddOnPackageInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUncheckedCreateWithoutOrganizationInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitUncheckedCreateNestedManyWithoutAddOnPackageInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutAddOnPackageInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUncheckedUpdateInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitUncheckedUpdateManyWithoutAddOnPackageNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutAddOnPackageNestedInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUncheckedUpdateManyInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput = {
  connect?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CareAddonPackageCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CareAddonPackageCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
  delete?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonPackageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonPackageUpdateWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
  updateMany?: Maybe<Array<CareAddonPackageUpdateManyWithWhereWithoutAssociatedCarePlanProviderGroupInput>>;
  upsert?: Maybe<Array<CareAddonPackageUpsertWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
};

export type CareAddonPackageUncheckedUpdateManyWithoutOrganizationInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CareAddonPackageCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CareAddonPackageCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonPackageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonPackageUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<CareAddonPackageUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<CareAddonPackageUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type CareAddonPackageUncheckedUpdateWithoutAddonPackageBenefitInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutAddOnPackageNestedInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUncheckedUpdateWithoutAssociatedCarePlanProviderGroupInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitUncheckedUpdateManyWithoutAddOnPackageNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutAddOnPackageNestedInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUncheckedUpdateWithoutEnrollmentsInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitUncheckedUpdateManyWithoutAddOnPackageNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUncheckedUpdateWithoutOrganizationInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitUncheckedUpdateManyWithoutAddOnPackageNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutAddOnPackageNestedInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUpdateInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitUpdateManyWithoutAddOnPackageNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedAddonPackagesNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutAddOnPackageNestedInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organization?: Maybe<OrganizationUpdateOneWithoutCareAddonPackageNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUpdateManyMutationInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUpdateManyWithWhereWithoutAssociatedCarePlanProviderGroupInput = {
  data: CareAddonPackageUpdateManyMutationInput;
  where: CareAddonPackageScalarWhereInput;
};

export type CareAddonPackageUpdateManyWithWhereWithoutOrganizationInput = {
  data: CareAddonPackageUpdateManyMutationInput;
  where: CareAddonPackageScalarWhereInput;
};

export type CareAddonPackageUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput = {
  connect?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CareAddonPackageCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CareAddonPackageCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
  delete?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonPackageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonPackageUpdateWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
  updateMany?: Maybe<Array<CareAddonPackageUpdateManyWithWhereWithoutAssociatedCarePlanProviderGroupInput>>;
  upsert?: Maybe<Array<CareAddonPackageUpsertWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
};

export type CareAddonPackageUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAddonPackageCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CareAddonPackageCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CareAddonPackageCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAddonPackageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  set?: Maybe<Array<CareAddonPackageWhereUniqueInput>>;
  update?: Maybe<Array<CareAddonPackageUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<CareAddonPackageUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<CareAddonPackageUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type CareAddonPackageUpdateOneRequiredWithoutAddonPackageBenefitNestedInput = {
  connect?: Maybe<CareAddonPackageWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAddonPackageCreateOrConnectWithoutAddonPackageBenefitInput>;
  create?: Maybe<CareAddonPackageCreateWithoutAddonPackageBenefitInput>;
  update?: Maybe<CareAddonPackageUpdateToOneWithWhereWithoutAddonPackageBenefitInput>;
  upsert?: Maybe<CareAddonPackageUpsertWithoutAddonPackageBenefitInput>;
};

export type CareAddonPackageUpdateOneRequiredWithoutEnrollmentsNestedInput = {
  connect?: Maybe<CareAddonPackageWhereUniqueInput>;
  connectOrCreate?: Maybe<CareAddonPackageCreateOrConnectWithoutEnrollmentsInput>;
  create?: Maybe<CareAddonPackageCreateWithoutEnrollmentsInput>;
  update?: Maybe<CareAddonPackageUpdateToOneWithWhereWithoutEnrollmentsInput>;
  upsert?: Maybe<CareAddonPackageUpsertWithoutEnrollmentsInput>;
};

export type CareAddonPackageUpdateToOneWithWhereWithoutAddonPackageBenefitInput = {
  data: CareAddonPackageUpdateWithoutAddonPackageBenefitInput;
  where?: Maybe<CareAddonPackageWhereInput>;
};

export type CareAddonPackageUpdateToOneWithWhereWithoutEnrollmentsInput = {
  data: CareAddonPackageUpdateWithoutEnrollmentsInput;
  where?: Maybe<CareAddonPackageWhereInput>;
};

export type CareAddonPackageUpdateWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput = {
  data: CareAddonPackageUpdateWithoutAssociatedCarePlanProviderGroupInput;
  where: CareAddonPackageWhereUniqueInput;
};

export type CareAddonPackageUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: CareAddonPackageUpdateWithoutOrganizationInput;
  where: CareAddonPackageWhereUniqueInput;
};

export type CareAddonPackageUpdateWithoutAddonPackageBenefitInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedAddonPackagesNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutAddOnPackageNestedInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organization?: Maybe<OrganizationUpdateOneWithoutCareAddonPackageNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUpdateWithoutAssociatedCarePlanProviderGroupInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitUpdateManyWithoutAddOnPackageNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutAddOnPackageNestedInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organization?: Maybe<OrganizationUpdateOneWithoutCareAddonPackageNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUpdateWithoutEnrollmentsInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitUpdateManyWithoutAddOnPackageNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedAddonPackagesNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organization?: Maybe<OrganizationUpdateOneWithoutCareAddonPackageNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUpdateWithoutOrganizationInput = {
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitUpdateManyWithoutAddOnPackageNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedAddonPackagesNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutAddOnPackageNestedInput>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAddonPackageUpsertWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput = {
  create: CareAddonPackageCreateWithoutAssociatedCarePlanProviderGroupInput;
  update: CareAddonPackageUpdateWithoutAssociatedCarePlanProviderGroupInput;
  where: CareAddonPackageWhereUniqueInput;
};

export type CareAddonPackageUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: CareAddonPackageCreateWithoutOrganizationInput;
  update: CareAddonPackageUpdateWithoutOrganizationInput;
  where: CareAddonPackageWhereUniqueInput;
};

export type CareAddonPackageUpsertWithoutAddonPackageBenefitInput = {
  create: CareAddonPackageCreateWithoutAddonPackageBenefitInput;
  update: CareAddonPackageUpdateWithoutAddonPackageBenefitInput;
  where?: Maybe<CareAddonPackageWhereInput>;
};

export type CareAddonPackageUpsertWithoutEnrollmentsInput = {
  create: CareAddonPackageCreateWithoutEnrollmentsInput;
  update: CareAddonPackageUpdateWithoutEnrollmentsInput;
  where?: Maybe<CareAddonPackageWhereInput>;
};

export type CareAddonPackageWhereInput = {
  AND?: Maybe<Array<CareAddonPackageWhereInput>>;
  NOT?: Maybe<Array<CareAddonPackageWhereInput>>;
  OR?: Maybe<Array<CareAddonPackageWhereInput>>;
  addonCancelsAt?: Maybe<DateTimeNullableFilter>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitListRelationFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  earliestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  editorNotes?: Maybe<StringFilter>;
  enrollments?: Maybe<CareAddonEnrollmentListRelationFilter>;
  id?: Maybe<StringFilter>;
  latestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  targetSpecies?: Maybe<EnumSpeciesTypeNullableFilter>;
  themeColor?: Maybe<StringNullableFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAddonPackageWhereUniqueInput = {
  AND?: Maybe<Array<CareAddonPackageWhereInput>>;
  NOT?: Maybe<Array<CareAddonPackageWhereInput>>;
  OR?: Maybe<Array<CareAddonPackageWhereInput>>;
  addonCancelsAt?: Maybe<DateTimeNullableFilter>;
  addonPackageBenefit?: Maybe<CareAddonPackageBenefitListRelationFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  earliestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  editorNotes?: Maybe<StringFilter>;
  enrollments?: Maybe<CareAddonEnrollmentListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  latestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  targetSpecies?: Maybe<EnumSpeciesTypeNullableFilter>;
  themeColor?: Maybe<StringNullableFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAuthorizationRequest = {
  __typename?: 'CareAuthorizationRequest';
  authCode: Scalars['String'];
  claimed: Scalars['Boolean'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  id: Scalars['String'];
  phoneNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CareAuthorizationRequestCountAggregateOutputType = {
  __typename?: 'CareAuthorizationRequestCountAggregateOutputType';
  _all: Scalars['Int'];
  authCode: Scalars['Int'];
  claimed: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  email: Scalars['Int'];
  expiresAt: Scalars['Int'];
  id: Scalars['Int'];
  phoneNumber: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CareAuthorizationRequestCountOrderByAggregateInput = {
  authCode?: Maybe<SortOrder>;
  claimed?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAuthorizationRequestCreateInput = {
  authCode: Scalars['String'];
  claimed: Scalars['Boolean'];
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutCareAuthorizationRequestsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestCreateManyClinicPetParentInput = {
  authCode: Scalars['String'];
  claimed: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestCreateManyClinicPetParentInputEnvelope = {
  data: Array<CareAuthorizationRequestCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareAuthorizationRequestCreateManyInput = {
  authCode: Scalars['String'];
  claimed: Scalars['Boolean'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<CareAuthorizationRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAuthorizationRequestCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CareAuthorizationRequestCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CareAuthorizationRequestCreateManyClinicPetParentInputEnvelope>;
};

export type CareAuthorizationRequestCreateOrConnectWithoutClinicPetParentInput = {
  create: CareAuthorizationRequestCreateWithoutClinicPetParentInput;
  where: CareAuthorizationRequestWhereUniqueInput;
};

export type CareAuthorizationRequestCreateWithoutClinicPetParentInput = {
  authCode: Scalars['String'];
  claimed: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestGroupByOutputType = {
  __typename?: 'CareAuthorizationRequestGroupByOutputType';
  _count?: Maybe<CareAuthorizationRequestCountAggregateOutputType>;
  _max?: Maybe<CareAuthorizationRequestMaxAggregateOutputType>;
  _min?: Maybe<CareAuthorizationRequestMinAggregateOutputType>;
  authCode: Scalars['String'];
  claimed: Scalars['Boolean'];
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  id: Scalars['String'];
  phoneNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CareAuthorizationRequestListRelationFilter = {
  every?: Maybe<CareAuthorizationRequestWhereInput>;
  none?: Maybe<CareAuthorizationRequestWhereInput>;
  some?: Maybe<CareAuthorizationRequestWhereInput>;
};

export type CareAuthorizationRequestMaxAggregateOutputType = {
  __typename?: 'CareAuthorizationRequestMaxAggregateOutputType';
  authCode?: Maybe<Scalars['String']>;
  claimed?: Maybe<Scalars['Boolean']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestMaxOrderByAggregateInput = {
  authCode?: Maybe<SortOrder>;
  claimed?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAuthorizationRequestMinAggregateOutputType = {
  __typename?: 'CareAuthorizationRequestMinAggregateOutputType';
  authCode?: Maybe<Scalars['String']>;
  claimed?: Maybe<Scalars['Boolean']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestMinOrderByAggregateInput = {
  authCode?: Maybe<SortOrder>;
  claimed?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAuthorizationRequestOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareAuthorizationRequestOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareAuthorizationRequestOrderByRelevanceInput>;
  authCode?: Maybe<SortOrder>;
  claimed?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareAuthorizationRequestOrderByRelevanceFieldEnum {
  AuthCode = 'authCode',
  ClinicPetParentId = 'clinicPetParentId',
  Email = 'email',
  Id = 'id',
  PhoneNumber = 'phoneNumber'
}

export type CareAuthorizationRequestOrderByRelevanceInput = {
  fields: Array<CareAuthorizationRequestOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareAuthorizationRequestOrderByWithAggregationInput = {
  _count?: Maybe<CareAuthorizationRequestCountOrderByAggregateInput>;
  _max?: Maybe<CareAuthorizationRequestMaxOrderByAggregateInput>;
  _min?: Maybe<CareAuthorizationRequestMinOrderByAggregateInput>;
  authCode?: Maybe<SortOrder>;
  claimed?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAuthorizationRequestOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareAuthorizationRequestOrderByRelevanceInput>;
  authCode?: Maybe<SortOrder>;
  claimed?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareAuthorizationRequestOrderByWithRelationInput = {
  _relevance?: Maybe<CareAuthorizationRequestOrderByRelevanceInput>;
  authCode?: Maybe<SortOrder>;
  claimed?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareAuthorizationRequestScalarFieldEnum {
  AuthCode = 'authCode',
  Claimed = 'claimed',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Email = 'email',
  ExpiresAt = 'expiresAt',
  Id = 'id',
  PhoneNumber = 'phoneNumber',
  UpdatedAt = 'updatedAt'
}

export type CareAuthorizationRequestScalarWhereInput = {
  AND?: Maybe<Array<CareAuthorizationRequestScalarWhereInput>>;
  NOT?: Maybe<Array<CareAuthorizationRequestScalarWhereInput>>;
  OR?: Maybe<Array<CareAuthorizationRequestScalarWhereInput>>;
  authCode?: Maybe<StringFilter>;
  claimed?: Maybe<BoolFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  expiresAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  phoneNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAuthorizationRequestScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareAuthorizationRequestScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareAuthorizationRequestScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareAuthorizationRequestScalarWhereWithAggregatesInput>>;
  authCode?: Maybe<StringWithAggregatesFilter>;
  claimed?: Maybe<BoolWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  email?: Maybe<StringWithAggregatesFilter>;
  expiresAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  phoneNumber?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CareAuthorizationRequestUncheckedCreateInput = {
  authCode: Scalars['String'];
  claimed: Scalars['Boolean'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<CareAuthorizationRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAuthorizationRequestCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CareAuthorizationRequestCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CareAuthorizationRequestCreateManyClinicPetParentInputEnvelope>;
};

export type CareAuthorizationRequestUncheckedCreateWithoutClinicPetParentInput = {
  authCode: Scalars['String'];
  claimed: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestUncheckedUpdateInput = {
  authCode?: Maybe<Scalars['String']>;
  claimed?: Maybe<Scalars['Boolean']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestUncheckedUpdateManyInput = {
  authCode?: Maybe<Scalars['String']>;
  claimed?: Maybe<Scalars['Boolean']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentInput = {
  authCode?: Maybe<Scalars['String']>;
  claimed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<CareAuthorizationRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAuthorizationRequestCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CareAuthorizationRequestCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CareAuthorizationRequestCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<CareAuthorizationRequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAuthorizationRequestScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAuthorizationRequestWhereUniqueInput>>;
  set?: Maybe<Array<CareAuthorizationRequestWhereUniqueInput>>;
  update?: Maybe<Array<CareAuthorizationRequestUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<CareAuthorizationRequestUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<CareAuthorizationRequestUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type CareAuthorizationRequestUncheckedUpdateWithoutClinicPetParentInput = {
  authCode?: Maybe<Scalars['String']>;
  claimed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestUpdateInput = {
  authCode?: Maybe<Scalars['String']>;
  claimed?: Maybe<Scalars['Boolean']>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutCareAuthorizationRequestsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestUpdateManyMutationInput = {
  authCode?: Maybe<Scalars['String']>;
  claimed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: CareAuthorizationRequestUpdateManyMutationInput;
  where: CareAuthorizationRequestScalarWhereInput;
};

export type CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<CareAuthorizationRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareAuthorizationRequestCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CareAuthorizationRequestCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CareAuthorizationRequestCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<CareAuthorizationRequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareAuthorizationRequestScalarWhereInput>>;
  disconnect?: Maybe<Array<CareAuthorizationRequestWhereUniqueInput>>;
  set?: Maybe<Array<CareAuthorizationRequestWhereUniqueInput>>;
  update?: Maybe<Array<CareAuthorizationRequestUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<CareAuthorizationRequestUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<CareAuthorizationRequestUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type CareAuthorizationRequestUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: CareAuthorizationRequestUpdateWithoutClinicPetParentInput;
  where: CareAuthorizationRequestWhereUniqueInput;
};

export type CareAuthorizationRequestUpdateWithoutClinicPetParentInput = {
  authCode?: Maybe<Scalars['String']>;
  claimed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareAuthorizationRequestUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: CareAuthorizationRequestCreateWithoutClinicPetParentInput;
  update: CareAuthorizationRequestUpdateWithoutClinicPetParentInput;
  where: CareAuthorizationRequestWhereUniqueInput;
};

export type CareAuthorizationRequestWhereInput = {
  AND?: Maybe<Array<CareAuthorizationRequestWhereInput>>;
  NOT?: Maybe<Array<CareAuthorizationRequestWhereInput>>;
  OR?: Maybe<Array<CareAuthorizationRequestWhereInput>>;
  authCode?: Maybe<StringFilter>;
  claimed?: Maybe<BoolFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  expiresAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  phoneNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareAuthorizationRequestWhereUniqueInput = {
  AND?: Maybe<Array<CareAuthorizationRequestWhereInput>>;
  NOT?: Maybe<Array<CareAuthorizationRequestWhereInput>>;
  OR?: Maybe<Array<CareAuthorizationRequestWhereInput>>;
  authCode?: Maybe<StringFilter>;
  claimed?: Maybe<BoolFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  expiresAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareBenefit = {
  __typename?: 'CareBenefit';
  _count: CareBenefitCountOutputType;
  addonPackageBenefits: Array<CareAddonPackageBenefit>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories: Array<OrganizationCareBenefitToClinicServiceCategory>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  editorNotes: Scalars['String'];
  enrollmentCarryovers: Array<CarePlanBenefitEnrollmentCarryover>;
  exhaustible: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  organization: Organization;
  organizationCareBenefitToClinicService: Array<OrganizationCareBenefitToClinicService>;
  organizationId: Scalars['String'];
  planBenefits: Array<CarePlanBenefit>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage: Scalars['Boolean'];
  /** @deprecated */
  reportingExpectedValue: Scalars['Int'];
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type: CareBenefitType;
  updatedAt: Scalars['DateTime'];
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages: Array<CareBenefitUsage>;
};


export type CareBenefitAddonPackageBenefitsArgs = {
  cursor?: Maybe<CareAddonPackageBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonPackageBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonPackageBenefitOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonPackageBenefitWhereInput>;
};


export type CareBenefitAssociatedCarePlanProviderGroupArgs = {
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type CareBenefitConnectedServiceCategoriesArgs = {
  cursor?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereInput>;
};


export type CareBenefitEnrollmentCarryoversArgs = {
  cursor?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereInput>;
};


export type CareBenefitOrganizationCareBenefitToClinicServiceArgs = {
  cursor?: Maybe<OrganizationCareBenefitToClinicServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationCareBenefitToClinicServiceWhereInput>;
};


export type CareBenefitPlanBenefitsArgs = {
  cursor?: Maybe<CarePlanBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitWhereInput>;
};


export type CareBenefitUsagesArgs = {
  cursor?: Maybe<CareBenefitUsageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageWhereInput>;
};

export type CareBenefitAvgAggregateOutputType = {
  __typename?: 'CareBenefitAvgAggregateOutputType';
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Float']>;
};

export type CareBenefitAvgOrderByAggregateInput = {
  providedDiscountPercentage?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
};

export type CareBenefitCountAggregateOutputType = {
  __typename?: 'CareBenefitCountAggregateOutputType';
  _all: Scalars['Int'];
  associatedCarePlanProviderGroupId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  editorNotes: Scalars['Int'];
  exhaustible: Scalars['Int'];
  flowAlias: Scalars['Int'];
  id: Scalars['Int'];
  organizationId: Scalars['Int'];
  providedDiscountPercentage: Scalars['Int'];
  providesTeletriage: Scalars['Int'];
  reportingExpectedValue: Scalars['Int'];
  tangible: Scalars['Int'];
  title: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  usageUnitOfMeasure: Scalars['Int'];
};

export type CareBenefitCountOrderByAggregateInput = {
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  exhaustible?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  providesTeletriage?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  tangible?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageUnitOfMeasure?: Maybe<SortOrder>;
};

export type CareBenefitCountOutputType = {
  __typename?: 'CareBenefitCountOutputType';
  addonPackageBenefits: Scalars['Int'];
  connectedServiceCategories: Scalars['Int'];
  enrollmentCarryovers: Scalars['Int'];
  organizationCareBenefitToClinicService: Scalars['Int'];
  planBenefits: Scalars['Int'];
  usages: Scalars['Int'];
};

export type CareBenefitCreateInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedCareBenefitsInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutCareBenefitsInput;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutBenefitInput>;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitCreateManyAssociatedCarePlanProviderGroupInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitCreateManyAssociatedCarePlanProviderGroupInputEnvelope = {
  data: Array<CareBenefitCreateManyAssociatedCarePlanProviderGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitCreateManyInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitCreateManyOrganizationInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitCreateManyOrganizationInputEnvelope = {
  data: Array<CareBenefitCreateManyOrganizationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput = {
  connect?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CareBenefitCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CareBenefitCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
};

export type CareBenefitCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CareBenefitCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CareBenefitCreateManyOrganizationInputEnvelope>;
};

export type CareBenefitCreateNestedOneWithoutAddonPackageBenefitsInput = {
  connect?: Maybe<CareBenefitWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitCreateOrConnectWithoutAddonPackageBenefitsInput>;
  create?: Maybe<CareBenefitCreateWithoutAddonPackageBenefitsInput>;
};

export type CareBenefitCreateNestedOneWithoutConnectedServiceCategoriesInput = {
  connect?: Maybe<CareBenefitWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitCreateOrConnectWithoutConnectedServiceCategoriesInput>;
  create?: Maybe<CareBenefitCreateWithoutConnectedServiceCategoriesInput>;
};

export type CareBenefitCreateNestedOneWithoutEnrollmentCarryoversInput = {
  connect?: Maybe<CareBenefitWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitCreateOrConnectWithoutEnrollmentCarryoversInput>;
  create?: Maybe<CareBenefitCreateWithoutEnrollmentCarryoversInput>;
};

export type CareBenefitCreateNestedOneWithoutOrganizationCareBenefitToClinicServiceInput = {
  connect?: Maybe<CareBenefitWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitCreateOrConnectWithoutOrganizationCareBenefitToClinicServiceInput>;
  create?: Maybe<CareBenefitCreateWithoutOrganizationCareBenefitToClinicServiceInput>;
};

export type CareBenefitCreateNestedOneWithoutPlanBenefitsInput = {
  connect?: Maybe<CareBenefitWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitCreateOrConnectWithoutPlanBenefitsInput>;
  create?: Maybe<CareBenefitCreateWithoutPlanBenefitsInput>;
};

export type CareBenefitCreateNestedOneWithoutUsagesInput = {
  connect?: Maybe<CareBenefitWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitCreateOrConnectWithoutUsagesInput>;
  create?: Maybe<CareBenefitCreateWithoutUsagesInput>;
};

export type CareBenefitCreateOrConnectWithoutAddonPackageBenefitsInput = {
  create: CareBenefitCreateWithoutAddonPackageBenefitsInput;
  where: CareBenefitWhereUniqueInput;
};

export type CareBenefitCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput = {
  create: CareBenefitCreateWithoutAssociatedCarePlanProviderGroupInput;
  where: CareBenefitWhereUniqueInput;
};

export type CareBenefitCreateOrConnectWithoutConnectedServiceCategoriesInput = {
  create: CareBenefitCreateWithoutConnectedServiceCategoriesInput;
  where: CareBenefitWhereUniqueInput;
};

export type CareBenefitCreateOrConnectWithoutEnrollmentCarryoversInput = {
  create: CareBenefitCreateWithoutEnrollmentCarryoversInput;
  where: CareBenefitWhereUniqueInput;
};

export type CareBenefitCreateOrConnectWithoutOrganizationCareBenefitToClinicServiceInput = {
  create: CareBenefitCreateWithoutOrganizationCareBenefitToClinicServiceInput;
  where: CareBenefitWhereUniqueInput;
};

export type CareBenefitCreateOrConnectWithoutOrganizationInput = {
  create: CareBenefitCreateWithoutOrganizationInput;
  where: CareBenefitWhereUniqueInput;
};

export type CareBenefitCreateOrConnectWithoutPlanBenefitsInput = {
  create: CareBenefitCreateWithoutPlanBenefitsInput;
  where: CareBenefitWhereUniqueInput;
};

export type CareBenefitCreateOrConnectWithoutUsagesInput = {
  create: CareBenefitCreateWithoutUsagesInput;
  where: CareBenefitWhereUniqueInput;
};

export type CareBenefitCreateWithoutAddonPackageBenefitsInput = {
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedCareBenefitsInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutCareBenefitsInput;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutBenefitInput>;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitCreateWithoutAssociatedCarePlanProviderGroupInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitCreateNestedManyWithoutBenefitInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutCareBenefitsInput;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutBenefitInput>;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitCreateWithoutConnectedServiceCategoriesInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedCareBenefitsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutCareBenefitsInput;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutBenefitInput>;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitCreateWithoutEnrollmentCarryoversInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedCareBenefitsInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutCareBenefitsInput;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutBenefitInput>;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitCreateWithoutOrganizationCareBenefitToClinicServiceInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedCareBenefitsInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutCareBenefitsInput;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitCreateWithoutOrganizationInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedCareBenefitsInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutBenefitInput>;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitCreateWithoutPlanBenefitsInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedCareBenefitsInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutCareBenefitsInput;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitCreateWithoutUsagesInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedCareBenefitsInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutCareBenefitsInput;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutBenefitInput>;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitGroupByOutputType = {
  __typename?: 'CareBenefitGroupByOutputType';
  _avg?: Maybe<CareBenefitAvgAggregateOutputType>;
  _count?: Maybe<CareBenefitCountAggregateOutputType>;
  _max?: Maybe<CareBenefitMaxAggregateOutputType>;
  _min?: Maybe<CareBenefitMinAggregateOutputType>;
  _sum?: Maybe<CareBenefitSumAggregateOutputType>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  editorNotes: Scalars['String'];
  exhaustible: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  organizationId: Scalars['String'];
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage: Scalars['Boolean'];
  reportingExpectedValue: Scalars['Int'];
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type: CareBenefitType;
  updatedAt: Scalars['DateTime'];
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitListRelationFilter = {
  every?: Maybe<CareBenefitWhereInput>;
  none?: Maybe<CareBenefitWhereInput>;
  some?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitMaxAggregateOutputType = {
  __typename?: 'CareBenefitMaxAggregateOutputType';
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitMaxOrderByAggregateInput = {
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  exhaustible?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  providesTeletriage?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  tangible?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageUnitOfMeasure?: Maybe<SortOrder>;
};

export type CareBenefitMinAggregateOutputType = {
  __typename?: 'CareBenefitMinAggregateOutputType';
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitMinOrderByAggregateInput = {
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  exhaustible?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  providesTeletriage?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  tangible?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageUnitOfMeasure?: Maybe<SortOrder>;
};

export type CareBenefitOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareBenefitOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareBenefitOrderByRelevanceInput>;
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitOrderByRelationAggregateInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverOrderByRelationAggregateInput>;
  exhaustible?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceOrderByRelationAggregateInput>;
  organizationId?: Maybe<SortOrder>;
  planBenefits?: Maybe<CarePlanBenefitOrderByRelationAggregateInput>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  providesTeletriage?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  tangible?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageUnitOfMeasure?: Maybe<SortOrder>;
  usages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
};

export enum CareBenefitOrderByRelevanceFieldEnum {
  AssociatedCarePlanProviderGroupId = 'associatedCarePlanProviderGroupId',
  Description = 'description',
  EditorNotes = 'editorNotes',
  FlowAlias = 'flowAlias',
  Id = 'id',
  OrganizationId = 'organizationId',
  Title = 'title'
}

export type CareBenefitOrderByRelevanceInput = {
  fields: Array<CareBenefitOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareBenefitOrderByWithAggregationInput = {
  _avg?: Maybe<CareBenefitAvgOrderByAggregateInput>;
  _count?: Maybe<CareBenefitCountOrderByAggregateInput>;
  _max?: Maybe<CareBenefitMaxOrderByAggregateInput>;
  _min?: Maybe<CareBenefitMinOrderByAggregateInput>;
  _sum?: Maybe<CareBenefitSumOrderByAggregateInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  exhaustible?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  providesTeletriage?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  tangible?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageUnitOfMeasure?: Maybe<SortOrder>;
};

export type CareBenefitOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareBenefitOrderByRelevanceInput>;
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitOrderByRelationAggregateInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverOrderByRelationAggregateInput>;
  exhaustible?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceOrderByRelationAggregateInput>;
  organizationId?: Maybe<SortOrder>;
  planBenefits?: Maybe<CarePlanBenefitOrderByRelationAggregateInput>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  providesTeletriage?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  tangible?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageUnitOfMeasure?: Maybe<SortOrder>;
  usages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
};

export type CareBenefitOrderByWithRelationInput = {
  _relevance?: Maybe<CareBenefitOrderByRelevanceInput>;
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitOrderByRelationAggregateInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverOrderByRelationAggregateInput>;
  exhaustible?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceOrderByRelationAggregateInput>;
  organizationId?: Maybe<SortOrder>;
  planBenefits?: Maybe<CarePlanBenefitOrderByRelationAggregateInput>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  providesTeletriage?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  tangible?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageUnitOfMeasure?: Maybe<SortOrder>;
  usages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
};

export enum CareBenefitScalarFieldEnum {
  AssociatedCarePlanProviderGroupId = 'associatedCarePlanProviderGroupId',
  CreatedAt = 'createdAt',
  Description = 'description',
  EditorNotes = 'editorNotes',
  Exhaustible = 'exhaustible',
  FlowAlias = 'flowAlias',
  Id = 'id',
  OrganizationId = 'organizationId',
  ProvidedDiscountPercentage = 'providedDiscountPercentage',
  ProvidesTeletriage = 'providesTeletriage',
  ReportingExpectedValue = 'reportingExpectedValue',
  Tangible = 'tangible',
  Title = 'title',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UsageUnitOfMeasure = 'usageUnitOfMeasure'
}

export type CareBenefitScalarRelationFilter = {
  AND?: Maybe<Array<CareBenefitWhereInput>>;
  NOT?: Maybe<Array<CareBenefitWhereInput>>;
  OR?: Maybe<Array<CareBenefitWhereInput>>;
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitListRelationFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  editorNotes?: Maybe<StringFilter>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverListRelationFilter>;
  exhaustible?: Maybe<BoolFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceListRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  planBenefits?: Maybe<CarePlanBenefitListRelationFilter>;
  providedDiscountPercentage?: Maybe<IntNullableFilter>;
  providesTeletriage?: Maybe<BoolFilter>;
  reportingExpectedValue?: Maybe<IntFilter>;
  tangible?: Maybe<BoolFilter>;
  title?: Maybe<StringFilter>;
  type?: Maybe<EnumCareBenefitTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  usageUnitOfMeasure?: Maybe<EnumCareBenefitUnitOfMeasureNullableFilter>;
  usages?: Maybe<CareBenefitUsageListRelationFilter>;
};

export type CareBenefitScalarWhereInput = {
  AND?: Maybe<Array<CareBenefitScalarWhereInput>>;
  NOT?: Maybe<Array<CareBenefitScalarWhereInput>>;
  OR?: Maybe<Array<CareBenefitScalarWhereInput>>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  editorNotes?: Maybe<StringFilter>;
  exhaustible?: Maybe<BoolFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  organizationId?: Maybe<StringFilter>;
  providedDiscountPercentage?: Maybe<IntNullableFilter>;
  providesTeletriage?: Maybe<BoolFilter>;
  reportingExpectedValue?: Maybe<IntFilter>;
  tangible?: Maybe<BoolFilter>;
  title?: Maybe<StringFilter>;
  type?: Maybe<EnumCareBenefitTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  usageUnitOfMeasure?: Maybe<EnumCareBenefitUnitOfMeasureNullableFilter>;
};

export type CareBenefitScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareBenefitScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareBenefitScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareBenefitScalarWhereWithAggregatesInput>>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  editorNotes?: Maybe<StringWithAggregatesFilter>;
  exhaustible?: Maybe<BoolWithAggregatesFilter>;
  flowAlias?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  organizationId?: Maybe<StringWithAggregatesFilter>;
  providedDiscountPercentage?: Maybe<IntNullableWithAggregatesFilter>;
  providesTeletriage?: Maybe<BoolWithAggregatesFilter>;
  reportingExpectedValue?: Maybe<IntWithAggregatesFilter>;
  tangible?: Maybe<BoolWithAggregatesFilter>;
  title?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumCareBenefitTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  usageUnitOfMeasure?: Maybe<EnumCareBenefitUnitOfMeasureNullableWithAggregatesFilter>;
};

export type CareBenefitSumAggregateOutputType = {
  __typename?: 'CareBenefitSumAggregateOutputType';
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
};

export type CareBenefitSumOrderByAggregateInput = {
  providedDiscountPercentage?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
};

export enum CareBenefitType {
  AccountCredit = 'AccountCredit',
  Discount = 'Discount',
  ExternalAccess = 'ExternalAccess',
  ProvidedService = 'ProvidedService',
  Teletriage = 'Teletriage',
  Unspecified = 'Unspecified'
}

export type CareBenefitUncheckedCreateInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutBenefitInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput = {
  connect?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CareBenefitCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CareBenefitCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
};

export type CareBenefitUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CareBenefitCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CareBenefitCreateManyOrganizationInputEnvelope>;
};

export type CareBenefitUncheckedCreateWithoutAddonPackageBenefitsInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutBenefitInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitUncheckedCreateWithoutAssociatedCarePlanProviderGroupInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutBenefitInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitUncheckedCreateWithoutConnectedServiceCategoriesInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutBenefitInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitUncheckedCreateWithoutEnrollmentCarryoversInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutBenefitInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitUncheckedCreateWithoutOrganizationCareBenefitToClinicServiceInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitUncheckedCreateWithoutOrganizationInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutBenefitInput>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitUncheckedCreateWithoutPlanBenefitsInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutBenefitInput>;
  organizationId: Scalars['String'];
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutBenefitInput>;
};

export type CareBenefitUncheckedCreateWithoutUsagesInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutBenefitInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutBenefitInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutBenefitInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutBenefitInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitUncheckedUpdateInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutBenefitNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUncheckedUpdateManyInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput = {
  connect?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CareBenefitCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CareBenefitCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
  delete?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUpdateWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
  updateMany?: Maybe<Array<CareBenefitUpdateManyWithWhereWithoutAssociatedCarePlanProviderGroupInput>>;
  upsert?: Maybe<Array<CareBenefitUpsertWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
};

export type CareBenefitUncheckedUpdateManyWithoutOrganizationInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CareBenefitCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CareBenefitCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<CareBenefitUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<CareBenefitUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type CareBenefitUncheckedUpdateWithoutAddonPackageBenefitsInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutBenefitNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUncheckedUpdateWithoutAssociatedCarePlanProviderGroupInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutBenefitNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUncheckedUpdateWithoutConnectedServiceCategoriesInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutBenefitNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUncheckedUpdateWithoutEnrollmentCarryoversInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutBenefitNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUncheckedUpdateWithoutOrganizationCareBenefitToClinicServiceInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUncheckedUpdateWithoutOrganizationInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutBenefitNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUncheckedUpdateWithoutPlanBenefitsInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutBenefitNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUncheckedUpdateWithoutUsagesInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutBenefitNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export enum CareBenefitUnitOfMeasure {
  Cents = 'CENTS',
  Occurence = 'OCCURENCE'
}

export type CareBenefitUpdateInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedCareBenefitsNestedInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCareBenefitsNestedInput>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutBenefitNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitUpdateManyWithWhereWithoutAssociatedCarePlanProviderGroupInput = {
  data: CareBenefitUpdateManyMutationInput;
  where: CareBenefitScalarWhereInput;
};

export type CareBenefitUpdateManyWithWhereWithoutOrganizationInput = {
  data: CareBenefitUpdateManyMutationInput;
  where: CareBenefitScalarWhereInput;
};

export type CareBenefitUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput = {
  connect?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CareBenefitCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CareBenefitCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
  delete?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUpdateWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
  updateMany?: Maybe<Array<CareBenefitUpdateManyWithWhereWithoutAssociatedCarePlanProviderGroupInput>>;
  upsert?: Maybe<Array<CareBenefitUpsertWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
};

export type CareBenefitUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CareBenefitCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CareBenefitCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<CareBenefitUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<CareBenefitUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type CareBenefitUpdateOneRequiredWithoutAddonPackageBenefitsNestedInput = {
  connect?: Maybe<CareBenefitWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitCreateOrConnectWithoutAddonPackageBenefitsInput>;
  create?: Maybe<CareBenefitCreateWithoutAddonPackageBenefitsInput>;
  update?: Maybe<CareBenefitUpdateToOneWithWhereWithoutAddonPackageBenefitsInput>;
  upsert?: Maybe<CareBenefitUpsertWithoutAddonPackageBenefitsInput>;
};

export type CareBenefitUpdateOneRequiredWithoutConnectedServiceCategoriesNestedInput = {
  connect?: Maybe<CareBenefitWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitCreateOrConnectWithoutConnectedServiceCategoriesInput>;
  create?: Maybe<CareBenefitCreateWithoutConnectedServiceCategoriesInput>;
  update?: Maybe<CareBenefitUpdateToOneWithWhereWithoutConnectedServiceCategoriesInput>;
  upsert?: Maybe<CareBenefitUpsertWithoutConnectedServiceCategoriesInput>;
};

export type CareBenefitUpdateOneRequiredWithoutEnrollmentCarryoversNestedInput = {
  connect?: Maybe<CareBenefitWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitCreateOrConnectWithoutEnrollmentCarryoversInput>;
  create?: Maybe<CareBenefitCreateWithoutEnrollmentCarryoversInput>;
  update?: Maybe<CareBenefitUpdateToOneWithWhereWithoutEnrollmentCarryoversInput>;
  upsert?: Maybe<CareBenefitUpsertWithoutEnrollmentCarryoversInput>;
};

export type CareBenefitUpdateOneRequiredWithoutOrganizationCareBenefitToClinicServiceNestedInput = {
  connect?: Maybe<CareBenefitWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitCreateOrConnectWithoutOrganizationCareBenefitToClinicServiceInput>;
  create?: Maybe<CareBenefitCreateWithoutOrganizationCareBenefitToClinicServiceInput>;
  update?: Maybe<CareBenefitUpdateToOneWithWhereWithoutOrganizationCareBenefitToClinicServiceInput>;
  upsert?: Maybe<CareBenefitUpsertWithoutOrganizationCareBenefitToClinicServiceInput>;
};

export type CareBenefitUpdateOneRequiredWithoutPlanBenefitsNestedInput = {
  connect?: Maybe<CareBenefitWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitCreateOrConnectWithoutPlanBenefitsInput>;
  create?: Maybe<CareBenefitCreateWithoutPlanBenefitsInput>;
  update?: Maybe<CareBenefitUpdateToOneWithWhereWithoutPlanBenefitsInput>;
  upsert?: Maybe<CareBenefitUpsertWithoutPlanBenefitsInput>;
};

export type CareBenefitUpdateOneRequiredWithoutUsagesNestedInput = {
  connect?: Maybe<CareBenefitWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitCreateOrConnectWithoutUsagesInput>;
  create?: Maybe<CareBenefitCreateWithoutUsagesInput>;
  update?: Maybe<CareBenefitUpdateToOneWithWhereWithoutUsagesInput>;
  upsert?: Maybe<CareBenefitUpsertWithoutUsagesInput>;
};

export type CareBenefitUpdateToOneWithWhereWithoutAddonPackageBenefitsInput = {
  data: CareBenefitUpdateWithoutAddonPackageBenefitsInput;
  where?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitUpdateToOneWithWhereWithoutConnectedServiceCategoriesInput = {
  data: CareBenefitUpdateWithoutConnectedServiceCategoriesInput;
  where?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitUpdateToOneWithWhereWithoutEnrollmentCarryoversInput = {
  data: CareBenefitUpdateWithoutEnrollmentCarryoversInput;
  where?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitUpdateToOneWithWhereWithoutOrganizationCareBenefitToClinicServiceInput = {
  data: CareBenefitUpdateWithoutOrganizationCareBenefitToClinicServiceInput;
  where?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitUpdateToOneWithWhereWithoutPlanBenefitsInput = {
  data: CareBenefitUpdateWithoutPlanBenefitsInput;
  where?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitUpdateToOneWithWhereWithoutUsagesInput = {
  data: CareBenefitUpdateWithoutUsagesInput;
  where?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitUpdateWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput = {
  data: CareBenefitUpdateWithoutAssociatedCarePlanProviderGroupInput;
  where: CareBenefitWhereUniqueInput;
};

export type CareBenefitUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: CareBenefitUpdateWithoutOrganizationInput;
  where: CareBenefitWhereUniqueInput;
};

export type CareBenefitUpdateWithoutAddonPackageBenefitsInput = {
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedCareBenefitsNestedInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCareBenefitsNestedInput>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutBenefitNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUpdateWithoutAssociatedCarePlanProviderGroupInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUpdateManyWithoutBenefitNestedInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCareBenefitsNestedInput>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutBenefitNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUpdateWithoutConnectedServiceCategoriesInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedCareBenefitsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCareBenefitsNestedInput>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutBenefitNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUpdateWithoutEnrollmentCarryoversInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedCareBenefitsNestedInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCareBenefitsNestedInput>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutBenefitNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUpdateWithoutOrganizationCareBenefitToClinicServiceInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedCareBenefitsNestedInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCareBenefitsNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUpdateWithoutOrganizationInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedCareBenefitsNestedInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutBenefitNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUpdateWithoutPlanBenefitsInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedCareBenefitsNestedInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCareBenefitsNestedInput>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
  usages?: Maybe<CareBenefitUsageUpdateManyWithoutBenefitNestedInput>;
};

export type CareBenefitUpdateWithoutUsagesInput = {
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitUpdateManyWithoutBenefitNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedCareBenefitsNestedInput>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutBenefitNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutBenefitNestedInput>;
  exhaustible?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCareBenefitsNestedInput>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutBenefitNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutBenefitNestedInput>;
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage?: Maybe<Scalars['Boolean']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  tangible?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CareBenefitType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CareBenefitUpsertWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput = {
  create: CareBenefitCreateWithoutAssociatedCarePlanProviderGroupInput;
  update: CareBenefitUpdateWithoutAssociatedCarePlanProviderGroupInput;
  where: CareBenefitWhereUniqueInput;
};

export type CareBenefitUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: CareBenefitCreateWithoutOrganizationInput;
  update: CareBenefitUpdateWithoutOrganizationInput;
  where: CareBenefitWhereUniqueInput;
};

export type CareBenefitUpsertWithoutAddonPackageBenefitsInput = {
  create: CareBenefitCreateWithoutAddonPackageBenefitsInput;
  update: CareBenefitUpdateWithoutAddonPackageBenefitsInput;
  where?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitUpsertWithoutConnectedServiceCategoriesInput = {
  create: CareBenefitCreateWithoutConnectedServiceCategoriesInput;
  update: CareBenefitUpdateWithoutConnectedServiceCategoriesInput;
  where?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitUpsertWithoutEnrollmentCarryoversInput = {
  create: CareBenefitCreateWithoutEnrollmentCarryoversInput;
  update: CareBenefitUpdateWithoutEnrollmentCarryoversInput;
  where?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitUpsertWithoutOrganizationCareBenefitToClinicServiceInput = {
  create: CareBenefitCreateWithoutOrganizationCareBenefitToClinicServiceInput;
  update: CareBenefitUpdateWithoutOrganizationCareBenefitToClinicServiceInput;
  where?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitUpsertWithoutPlanBenefitsInput = {
  create: CareBenefitCreateWithoutPlanBenefitsInput;
  update: CareBenefitUpdateWithoutPlanBenefitsInput;
  where?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitUpsertWithoutUsagesInput = {
  create: CareBenefitCreateWithoutUsagesInput;
  update: CareBenefitUpdateWithoutUsagesInput;
  where?: Maybe<CareBenefitWhereInput>;
};

export type CareBenefitUsage = {
  __typename?: 'CareBenefitUsage';
  _count: CareBenefitUsageCountOutputType;
  benefit: CareBenefit;
  benefitId: Scalars['String'];
  careAccountCreditIntent?: Maybe<CareAccountCreditIntent>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollment>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollment>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  invoiceLineItemConnections: Array<CareBenefitUsageToInvoiceLineItem>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<User>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStep>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  usageClinic: Clinic;
  usageClinicId: Scalars['String'];
  usageClinicPet: ClinicPet;
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};


export type CareBenefitUsageCareAccountCreditIntentArgs = {
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};


export type CareBenefitUsageConnectedAddonEnrollmentArgs = {
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};


export type CareBenefitUsageConnectedPlanEnrollmentArgs = {
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type CareBenefitUsageInvoiceLineItemConnectionsArgs = {
  cursor?: Maybe<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
};


export type CareBenefitUsageRecordedByUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type CareBenefitUsageRelatedFollowupStepArgs = {
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};

export type CareBenefitUsageAvgAggregateOutputType = {
  __typename?: 'CareBenefitUsageAvgAggregateOutputType';
  quantityUsed?: Maybe<Scalars['Float']>;
};

export type CareBenefitUsageAvgOrderByAggregateInput = {
  quantityUsed?: Maybe<SortOrder>;
};

export type CareBenefitUsageCountAggregateOutputType = {
  __typename?: 'CareBenefitUsageCountAggregateOutputType';
  _all: Scalars['Int'];
  benefitId: Scalars['Int'];
  careAccountCreditIntentId: Scalars['Int'];
  connectedAddonEnrollmentId: Scalars['Int'];
  connectedPlanEnrollmentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  exhaustsBenefit: Scalars['Int'];
  id: Scalars['Int'];
  quantityUsed: Scalars['Int'];
  reason: Scalars['Int'];
  recordedByUserId: Scalars['Int'];
  relatedFollowupStepId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  usageClinicId: Scalars['Int'];
  usageClinicPetId: Scalars['Int'];
  usedAt: Scalars['Int'];
};

export type CareBenefitUsageCountOrderByAggregateInput = {
  benefitId?: Maybe<SortOrder>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  connectedAddonEnrollmentId?: Maybe<SortOrder>;
  connectedPlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exhaustsBenefit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  quantityUsed?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recordedByUserId?: Maybe<SortOrder>;
  relatedFollowupStepId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageClinicId?: Maybe<SortOrder>;
  usageClinicPetId?: Maybe<SortOrder>;
  usedAt?: Maybe<SortOrder>;
};

export type CareBenefitUsageCountOutputType = {
  __typename?: 'CareBenefitUsageCountOutputType';
  invoiceLineItemConnections: Scalars['Int'];
};

export type CareBenefitUsageCreateInput = {
  benefit: CareBenefitCreateNestedOneWithoutUsagesInput;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutCareBenefitUsagesInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserCreateNestedOneWithoutUsagesRecordedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutRelatedUsagesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic: ClinicCreateNestedOneWithoutBenefitsProvidedInput;
  usageClinicPet: ClinicPetCreateNestedOneWithoutCareBenefitUsagesInput;
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateManyBenefitInput = {
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateManyBenefitInputEnvelope = {
  data: Array<CareBenefitUsageCreateManyBenefitInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageCreateManyCareAccountCreditIntentInput = {
  benefitId: Scalars['String'];
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateManyCareAccountCreditIntentInputEnvelope = {
  data: Array<CareBenefitUsageCreateManyCareAccountCreditIntentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageCreateManyConnectedAddonEnrollmentInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateManyConnectedAddonEnrollmentInputEnvelope = {
  data: Array<CareBenefitUsageCreateManyConnectedAddonEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageCreateManyConnectedPlanEnrollmentInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateManyConnectedPlanEnrollmentInputEnvelope = {
  data: Array<CareBenefitUsageCreateManyConnectedPlanEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageCreateManyInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateManyRecordedByUserInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateManyRecordedByUserInputEnvelope = {
  data: Array<CareBenefitUsageCreateManyRecordedByUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageCreateManyRelatedFollowupStepInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateManyRelatedFollowupStepInputEnvelope = {
  data: Array<CareBenefitUsageCreateManyRelatedFollowupStepInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageCreateManyUsageClinicInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateManyUsageClinicInputEnvelope = {
  data: Array<CareBenefitUsageCreateManyUsageClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageCreateManyUsageClinicPetInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateManyUsageClinicPetInputEnvelope = {
  data: Array<CareBenefitUsageCreateManyUsageClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageCreateNestedManyWithoutBenefitInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutBenefitInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyBenefitInputEnvelope>;
};

export type CareBenefitUsageCreateNestedManyWithoutCareAccountCreditIntentInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutCareAccountCreditIntentInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutCareAccountCreditIntentInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyCareAccountCreditIntentInputEnvelope>;
};

export type CareBenefitUsageCreateNestedManyWithoutConnectedAddonEnrollmentInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutConnectedAddonEnrollmentInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutConnectedAddonEnrollmentInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyConnectedAddonEnrollmentInputEnvelope>;
};

export type CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutConnectedPlanEnrollmentInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutConnectedPlanEnrollmentInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyConnectedPlanEnrollmentInputEnvelope>;
};

export type CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutRecordedByUserInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutRecordedByUserInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyRecordedByUserInputEnvelope>;
};

export type CareBenefitUsageCreateNestedManyWithoutRelatedFollowupStepInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutRelatedFollowupStepInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutRelatedFollowupStepInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyRelatedFollowupStepInputEnvelope>;
};

export type CareBenefitUsageCreateNestedManyWithoutUsageClinicInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutUsageClinicInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutUsageClinicInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyUsageClinicInputEnvelope>;
};

export type CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutUsageClinicPetInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutUsageClinicPetInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyUsageClinicPetInputEnvelope>;
};

export type CareBenefitUsageCreateNestedOneWithoutInvoiceLineItemConnectionsInput = {
  connect?: Maybe<CareBenefitUsageWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitUsageCreateOrConnectWithoutInvoiceLineItemConnectionsInput>;
  create?: Maybe<CareBenefitUsageCreateWithoutInvoiceLineItemConnectionsInput>;
};

export type CareBenefitUsageCreateOrConnectWithoutBenefitInput = {
  create: CareBenefitUsageCreateWithoutBenefitInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageCreateOrConnectWithoutCareAccountCreditIntentInput = {
  create: CareBenefitUsageCreateWithoutCareAccountCreditIntentInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageCreateOrConnectWithoutConnectedAddonEnrollmentInput = {
  create: CareBenefitUsageCreateWithoutConnectedAddonEnrollmentInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageCreateOrConnectWithoutConnectedPlanEnrollmentInput = {
  create: CareBenefitUsageCreateWithoutConnectedPlanEnrollmentInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageCreateOrConnectWithoutInvoiceLineItemConnectionsInput = {
  create: CareBenefitUsageCreateWithoutInvoiceLineItemConnectionsInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageCreateOrConnectWithoutRecordedByUserInput = {
  create: CareBenefitUsageCreateWithoutRecordedByUserInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageCreateOrConnectWithoutRelatedFollowupStepInput = {
  create: CareBenefitUsageCreateWithoutRelatedFollowupStepInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageCreateOrConnectWithoutUsageClinicInput = {
  create: CareBenefitUsageCreateWithoutUsageClinicInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageCreateOrConnectWithoutUsageClinicPetInput = {
  create: CareBenefitUsageCreateWithoutUsageClinicPetInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageCreateWithoutBenefitInput = {
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutCareBenefitUsagesInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserCreateNestedOneWithoutUsagesRecordedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutRelatedUsagesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic: ClinicCreateNestedOneWithoutBenefitsProvidedInput;
  usageClinicPet: ClinicPetCreateNestedOneWithoutCareBenefitUsagesInput;
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateWithoutCareAccountCreditIntentInput = {
  benefit: CareBenefitCreateNestedOneWithoutUsagesInput;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserCreateNestedOneWithoutUsagesRecordedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutRelatedUsagesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic: ClinicCreateNestedOneWithoutBenefitsProvidedInput;
  usageClinicPet: ClinicPetCreateNestedOneWithoutCareBenefitUsagesInput;
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateWithoutConnectedAddonEnrollmentInput = {
  benefit: CareBenefitCreateNestedOneWithoutUsagesInput;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutCareBenefitUsagesInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserCreateNestedOneWithoutUsagesRecordedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutRelatedUsagesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic: ClinicCreateNestedOneWithoutBenefitsProvidedInput;
  usageClinicPet: ClinicPetCreateNestedOneWithoutCareBenefitUsagesInput;
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateWithoutConnectedPlanEnrollmentInput = {
  benefit: CareBenefitCreateNestedOneWithoutUsagesInput;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutCareBenefitUsagesInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserCreateNestedOneWithoutUsagesRecordedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutRelatedUsagesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic: ClinicCreateNestedOneWithoutBenefitsProvidedInput;
  usageClinicPet: ClinicPetCreateNestedOneWithoutCareBenefitUsagesInput;
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateWithoutInvoiceLineItemConnectionsInput = {
  benefit: CareBenefitCreateNestedOneWithoutUsagesInput;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutCareBenefitUsagesInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserCreateNestedOneWithoutUsagesRecordedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutRelatedUsagesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic: ClinicCreateNestedOneWithoutBenefitsProvidedInput;
  usageClinicPet: ClinicPetCreateNestedOneWithoutCareBenefitUsagesInput;
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateWithoutRecordedByUserInput = {
  benefit: CareBenefitCreateNestedOneWithoutUsagesInput;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutCareBenefitUsagesInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutRelatedUsagesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic: ClinicCreateNestedOneWithoutBenefitsProvidedInput;
  usageClinicPet: ClinicPetCreateNestedOneWithoutCareBenefitUsagesInput;
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateWithoutRelatedFollowupStepInput = {
  benefit: CareBenefitCreateNestedOneWithoutUsagesInput;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutCareBenefitUsagesInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserCreateNestedOneWithoutUsagesRecordedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic: ClinicCreateNestedOneWithoutBenefitsProvidedInput;
  usageClinicPet: ClinicPetCreateNestedOneWithoutCareBenefitUsagesInput;
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateWithoutUsageClinicInput = {
  benefit: CareBenefitCreateNestedOneWithoutUsagesInput;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutCareBenefitUsagesInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserCreateNestedOneWithoutUsagesRecordedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutRelatedUsagesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicPet: ClinicPetCreateNestedOneWithoutCareBenefitUsagesInput;
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageCreateWithoutUsageClinicPetInput = {
  benefit: CareBenefitCreateNestedOneWithoutUsagesInput;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutCareBenefitUsagesInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutAssociatedUsagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserCreateNestedOneWithoutUsagesRecordedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepCreateNestedOneWithoutRelatedUsagesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic: ClinicCreateNestedOneWithoutBenefitsProvidedInput;
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageFollowup = {
  __typename?: 'CareBenefitUsageFollowup';
  _count: CareBenefitUsageFollowupCountOutputType;
  careStripeSubscription: CareStripeSubscription;
  careStripeSubscriptionId: Scalars['String'];
  completed: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  followupSteps: Array<CareBenefitUsageFollowupStep>;
  id: Scalars['String'];
  relatedOrganizationPet: OrganizationPet;
  relatedOrganizationPetId: Scalars['String'];
  reportingOriginalInvoiceValueCents: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type CareBenefitUsageFollowupFollowupStepsArgs = {
  cursor?: Maybe<CareBenefitUsageFollowupStepWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageFollowupStepScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageFollowupStepOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};

export type CareBenefitUsageFollowupAvgAggregateOutputType = {
  __typename?: 'CareBenefitUsageFollowupAvgAggregateOutputType';
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Float']>;
};

export type CareBenefitUsageFollowupAvgOrderByAggregateInput = {
  reportingOriginalInvoiceValueCents?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupCountAggregateOutputType = {
  __typename?: 'CareBenefitUsageFollowupCountAggregateOutputType';
  _all: Scalars['Int'];
  careStripeSubscriptionId: Scalars['Int'];
  completed: Scalars['Int'];
  completedAt: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  relatedOrganizationPetId: Scalars['Int'];
  reportingOriginalInvoiceValueCents: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CareBenefitUsageFollowupCountOrderByAggregateInput = {
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  relatedOrganizationPetId?: Maybe<SortOrder>;
  reportingOriginalInvoiceValueCents?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupCountOutputType = {
  __typename?: 'CareBenefitUsageFollowupCountOutputType';
  followupSteps: Scalars['Int'];
};

export type CareBenefitUsageFollowupCreateInput = {
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutCareBenefitUsageFollowupsInput;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutUsageFollowupInput>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPet: OrganizationPetCreateNestedOneWithoutAssociatedBenefitUsageFollowupInput;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupCreateManyCareStripeSubscriptionInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPetId: Scalars['String'];
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupCreateManyCareStripeSubscriptionInputEnvelope = {
  data: Array<CareBenefitUsageFollowupCreateManyCareStripeSubscriptionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageFollowupCreateManyInput = {
  careStripeSubscriptionId: Scalars['String'];
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPetId: Scalars['String'];
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupCreateManyRelatedOrganizationPetInput = {
  careStripeSubscriptionId: Scalars['String'];
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupCreateManyRelatedOrganizationPetInputEnvelope = {
  data: Array<CareBenefitUsageFollowupCreateManyRelatedOrganizationPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageFollowupCreateNestedManyWithoutCareStripeSubscriptionInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupCreateManyCareStripeSubscriptionInputEnvelope>;
};

export type CareBenefitUsageFollowupCreateNestedManyWithoutRelatedOrganizationPetInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupCreateOrConnectWithoutRelatedOrganizationPetInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupCreateWithoutRelatedOrganizationPetInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupCreateManyRelatedOrganizationPetInputEnvelope>;
};

export type CareBenefitUsageFollowupCreateNestedOneWithoutFollowupStepsInput = {
  connect?: Maybe<CareBenefitUsageFollowupWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitUsageFollowupCreateOrConnectWithoutFollowupStepsInput>;
  create?: Maybe<CareBenefitUsageFollowupCreateWithoutFollowupStepsInput>;
};

export type CareBenefitUsageFollowupCreateOrConnectWithoutCareStripeSubscriptionInput = {
  create: CareBenefitUsageFollowupCreateWithoutCareStripeSubscriptionInput;
  where: CareBenefitUsageFollowupWhereUniqueInput;
};

export type CareBenefitUsageFollowupCreateOrConnectWithoutFollowupStepsInput = {
  create: CareBenefitUsageFollowupCreateWithoutFollowupStepsInput;
  where: CareBenefitUsageFollowupWhereUniqueInput;
};

export type CareBenefitUsageFollowupCreateOrConnectWithoutRelatedOrganizationPetInput = {
  create: CareBenefitUsageFollowupCreateWithoutRelatedOrganizationPetInput;
  where: CareBenefitUsageFollowupWhereUniqueInput;
};

export type CareBenefitUsageFollowupCreateWithoutCareStripeSubscriptionInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutUsageFollowupInput>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPet: OrganizationPetCreateNestedOneWithoutAssociatedBenefitUsageFollowupInput;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupCreateWithoutFollowupStepsInput = {
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutCareBenefitUsageFollowupsInput;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPet: OrganizationPetCreateNestedOneWithoutAssociatedBenefitUsageFollowupInput;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupCreateWithoutRelatedOrganizationPetInput = {
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutCareBenefitUsageFollowupsInput;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutUsageFollowupInput>;
  id?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupGroupByOutputType = {
  __typename?: 'CareBenefitUsageFollowupGroupByOutputType';
  _avg?: Maybe<CareBenefitUsageFollowupAvgAggregateOutputType>;
  _count?: Maybe<CareBenefitUsageFollowupCountAggregateOutputType>;
  _max?: Maybe<CareBenefitUsageFollowupMaxAggregateOutputType>;
  _min?: Maybe<CareBenefitUsageFollowupMinAggregateOutputType>;
  _sum?: Maybe<CareBenefitUsageFollowupSumAggregateOutputType>;
  careStripeSubscriptionId: Scalars['String'];
  completed: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  relatedOrganizationPetId: Scalars['String'];
  reportingOriginalInvoiceValueCents: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CareBenefitUsageFollowupListRelationFilter = {
  every?: Maybe<CareBenefitUsageFollowupWhereInput>;
  none?: Maybe<CareBenefitUsageFollowupWhereInput>;
  some?: Maybe<CareBenefitUsageFollowupWhereInput>;
};

export type CareBenefitUsageFollowupMaxAggregateOutputType = {
  __typename?: 'CareBenefitUsageFollowupMaxAggregateOutputType';
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPetId?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupMaxOrderByAggregateInput = {
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  relatedOrganizationPetId?: Maybe<SortOrder>;
  reportingOriginalInvoiceValueCents?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupMinAggregateOutputType = {
  __typename?: 'CareBenefitUsageFollowupMinAggregateOutputType';
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPetId?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupMinOrderByAggregateInput = {
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  relatedOrganizationPetId?: Maybe<SortOrder>;
  reportingOriginalInvoiceValueCents?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareBenefitUsageFollowupOrderByRelevanceInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  relatedOrganizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  relatedOrganizationPetId?: Maybe<SortOrder>;
  reportingOriginalInvoiceValueCents?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareBenefitUsageFollowupOrderByRelevanceFieldEnum {
  CareStripeSubscriptionId = 'careStripeSubscriptionId',
  Id = 'id',
  RelatedOrganizationPetId = 'relatedOrganizationPetId'
}

export type CareBenefitUsageFollowupOrderByRelevanceInput = {
  fields: Array<CareBenefitUsageFollowupOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareBenefitUsageFollowupOrderByWithAggregationInput = {
  _avg?: Maybe<CareBenefitUsageFollowupAvgOrderByAggregateInput>;
  _count?: Maybe<CareBenefitUsageFollowupCountOrderByAggregateInput>;
  _max?: Maybe<CareBenefitUsageFollowupMaxOrderByAggregateInput>;
  _min?: Maybe<CareBenefitUsageFollowupMinOrderByAggregateInput>;
  _sum?: Maybe<CareBenefitUsageFollowupSumOrderByAggregateInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  relatedOrganizationPetId?: Maybe<SortOrder>;
  reportingOriginalInvoiceValueCents?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareBenefitUsageFollowupOrderByRelevanceInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  relatedOrganizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  relatedOrganizationPetId?: Maybe<SortOrder>;
  reportingOriginalInvoiceValueCents?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupOrderByWithRelationInput = {
  _relevance?: Maybe<CareBenefitUsageFollowupOrderByRelevanceInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  relatedOrganizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  relatedOrganizationPetId?: Maybe<SortOrder>;
  reportingOriginalInvoiceValueCents?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareBenefitUsageFollowupScalarFieldEnum {
  CareStripeSubscriptionId = 'careStripeSubscriptionId',
  Completed = 'completed',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  Id = 'id',
  RelatedOrganizationPetId = 'relatedOrganizationPetId',
  ReportingOriginalInvoiceValueCents = 'reportingOriginalInvoiceValueCents',
  UpdatedAt = 'updatedAt'
}

export type CareBenefitUsageFollowupScalarRelationFilter = {
  AND?: Maybe<Array<CareBenefitUsageFollowupWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageFollowupWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageFollowupWhereInput>>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  completed?: Maybe<BoolFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepListRelationFilter>;
  id?: Maybe<StringFilter>;
  relatedOrganizationPet?: Maybe<OrganizationPetScalarRelationFilter>;
  relatedOrganizationPetId?: Maybe<StringFilter>;
  reportingOriginalInvoiceValueCents?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareBenefitUsageFollowupScalarWhereInput = {
  AND?: Maybe<Array<CareBenefitUsageFollowupScalarWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageFollowupScalarWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageFollowupScalarWhereInput>>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  completed?: Maybe<BoolFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  relatedOrganizationPetId?: Maybe<StringFilter>;
  reportingOriginalInvoiceValueCents?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareBenefitUsageFollowupScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareBenefitUsageFollowupScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareBenefitUsageFollowupScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareBenefitUsageFollowupScalarWhereWithAggregatesInput>>;
  careStripeSubscriptionId?: Maybe<StringWithAggregatesFilter>;
  completed?: Maybe<BoolWithAggregatesFilter>;
  completedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  relatedOrganizationPetId?: Maybe<StringWithAggregatesFilter>;
  reportingOriginalInvoiceValueCents?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CareBenefitUsageFollowupStep = {
  __typename?: 'CareBenefitUsageFollowupStep';
  _count: CareBenefitUsageFollowupStepCountOutputType;
  careAccountCreditIntents: Array<CareAccountCreditIntent>;
  completed: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUser?: Maybe<User>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  /** Display order starts at 1, and 0 is used for the default value but marks it as not being set */
  displayOrder: Scalars['Int'];
  id: Scalars['String'];
  relatedUsages: Array<CareBenefitUsage>;
  usageFollowup: CareBenefitUsageFollowup;
  usageFollowupId: Scalars['String'];
};


export type CareBenefitUsageFollowupStepCareAccountCreditIntentsArgs = {
  cursor?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAccountCreditIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAccountCreditIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};


export type CareBenefitUsageFollowupStepCompletedByUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type CareBenefitUsageFollowupStepRelatedUsagesArgs = {
  cursor?: Maybe<CareBenefitUsageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageWhereInput>;
};

export type CareBenefitUsageFollowupStepAvgAggregateOutputType = {
  __typename?: 'CareBenefitUsageFollowupStepAvgAggregateOutputType';
  displayOrder?: Maybe<Scalars['Float']>;
};

export type CareBenefitUsageFollowupStepAvgOrderByAggregateInput = {
  displayOrder?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupStepCountAggregateOutputType = {
  __typename?: 'CareBenefitUsageFollowupStepCountAggregateOutputType';
  _all: Scalars['Int'];
  completed: Scalars['Int'];
  completedAt: Scalars['Int'];
  completedByUserId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  displayOrder: Scalars['Int'];
  id: Scalars['Int'];
  usageFollowupId: Scalars['Int'];
};

export type CareBenefitUsageFollowupStepCountOrderByAggregateInput = {
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  usageFollowupId?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupStepCountOutputType = {
  __typename?: 'CareBenefitUsageFollowupStepCountOutputType';
  careAccountCreditIntents: Scalars['Int'];
  relatedUsages: Scalars['Int'];
};

export type CareBenefitUsageFollowupStepCreateInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutFollowupStepInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUser?: Maybe<UserCreateNestedOneWithoutCompletedBenefitUsageFollowupStepsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutRelatedFollowupStepInput>;
  usageFollowup: CareBenefitUsageFollowupCreateNestedOneWithoutFollowupStepsInput;
};

export type CareBenefitUsageFollowupStepCreateManyCompletedByUserInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  usageFollowupId: Scalars['String'];
};

export type CareBenefitUsageFollowupStepCreateManyCompletedByUserInputEnvelope = {
  data: Array<CareBenefitUsageFollowupStepCreateManyCompletedByUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageFollowupStepCreateManyInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  usageFollowupId: Scalars['String'];
};

export type CareBenefitUsageFollowupStepCreateManyUsageFollowupInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageFollowupStepCreateManyUsageFollowupInputEnvelope = {
  data: Array<CareBenefitUsageFollowupStepCreateManyUsageFollowupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupStepCreateOrConnectWithoutCompletedByUserInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupStepCreateWithoutCompletedByUserInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupStepCreateManyCompletedByUserInputEnvelope>;
};

export type CareBenefitUsageFollowupStepCreateNestedManyWithoutUsageFollowupInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupStepCreateOrConnectWithoutUsageFollowupInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupStepCreateWithoutUsageFollowupInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupStepCreateManyUsageFollowupInputEnvelope>;
};

export type CareBenefitUsageFollowupStepCreateNestedOneWithoutCareAccountCreditIntentsInput = {
  connect?: Maybe<CareBenefitUsageFollowupStepWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitUsageFollowupStepCreateOrConnectWithoutCareAccountCreditIntentsInput>;
  create?: Maybe<CareBenefitUsageFollowupStepCreateWithoutCareAccountCreditIntentsInput>;
};

export type CareBenefitUsageFollowupStepCreateNestedOneWithoutRelatedUsagesInput = {
  connect?: Maybe<CareBenefitUsageFollowupStepWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitUsageFollowupStepCreateOrConnectWithoutRelatedUsagesInput>;
  create?: Maybe<CareBenefitUsageFollowupStepCreateWithoutRelatedUsagesInput>;
};

export type CareBenefitUsageFollowupStepCreateOrConnectWithoutCareAccountCreditIntentsInput = {
  create: CareBenefitUsageFollowupStepCreateWithoutCareAccountCreditIntentsInput;
  where: CareBenefitUsageFollowupStepWhereUniqueInput;
};

export type CareBenefitUsageFollowupStepCreateOrConnectWithoutCompletedByUserInput = {
  create: CareBenefitUsageFollowupStepCreateWithoutCompletedByUserInput;
  where: CareBenefitUsageFollowupStepWhereUniqueInput;
};

export type CareBenefitUsageFollowupStepCreateOrConnectWithoutRelatedUsagesInput = {
  create: CareBenefitUsageFollowupStepCreateWithoutRelatedUsagesInput;
  where: CareBenefitUsageFollowupStepWhereUniqueInput;
};

export type CareBenefitUsageFollowupStepCreateOrConnectWithoutUsageFollowupInput = {
  create: CareBenefitUsageFollowupStepCreateWithoutUsageFollowupInput;
  where: CareBenefitUsageFollowupStepWhereUniqueInput;
};

export type CareBenefitUsageFollowupStepCreateWithoutCareAccountCreditIntentsInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUser?: Maybe<UserCreateNestedOneWithoutCompletedBenefitUsageFollowupStepsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutRelatedFollowupStepInput>;
  usageFollowup: CareBenefitUsageFollowupCreateNestedOneWithoutFollowupStepsInput;
};

export type CareBenefitUsageFollowupStepCreateWithoutCompletedByUserInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutFollowupStepInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutRelatedFollowupStepInput>;
  usageFollowup: CareBenefitUsageFollowupCreateNestedOneWithoutFollowupStepsInput;
};

export type CareBenefitUsageFollowupStepCreateWithoutRelatedUsagesInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutFollowupStepInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUser?: Maybe<UserCreateNestedOneWithoutCompletedBenefitUsageFollowupStepsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  usageFollowup: CareBenefitUsageFollowupCreateNestedOneWithoutFollowupStepsInput;
};

export type CareBenefitUsageFollowupStepCreateWithoutUsageFollowupInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutFollowupStepInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUser?: Maybe<UserCreateNestedOneWithoutCompletedBenefitUsageFollowupStepsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutRelatedFollowupStepInput>;
};

export type CareBenefitUsageFollowupStepGroupByOutputType = {
  __typename?: 'CareBenefitUsageFollowupStepGroupByOutputType';
  _avg?: Maybe<CareBenefitUsageFollowupStepAvgAggregateOutputType>;
  _count?: Maybe<CareBenefitUsageFollowupStepCountAggregateOutputType>;
  _max?: Maybe<CareBenefitUsageFollowupStepMaxAggregateOutputType>;
  _min?: Maybe<CareBenefitUsageFollowupStepMinAggregateOutputType>;
  _sum?: Maybe<CareBenefitUsageFollowupStepSumAggregateOutputType>;
  completed: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  displayOrder: Scalars['Int'];
  id: Scalars['String'];
  usageFollowupId: Scalars['String'];
};

export type CareBenefitUsageFollowupStepListRelationFilter = {
  every?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
  none?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
  some?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};

export type CareBenefitUsageFollowupStepMaxAggregateOutputType = {
  __typename?: 'CareBenefitUsageFollowupStepMaxAggregateOutputType';
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  usageFollowupId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageFollowupStepMaxOrderByAggregateInput = {
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  usageFollowupId?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupStepMinAggregateOutputType = {
  __typename?: 'CareBenefitUsageFollowupStepMinAggregateOutputType';
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  usageFollowupId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageFollowupStepMinOrderByAggregateInput = {
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  usageFollowupId?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupStepNullableScalarRelationFilter = {
  AND?: Maybe<Array<CareBenefitUsageFollowupStepWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageFollowupStepWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageFollowupStepWhereInput>>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentListRelationFilter>;
  completed?: Maybe<BoolFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  completedByUser?: Maybe<UserNullableScalarRelationFilter>;
  completedByUserId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  displayOrder?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  relatedUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  usageFollowup?: Maybe<CareBenefitUsageFollowupScalarRelationFilter>;
  usageFollowupId?: Maybe<StringFilter>;
};

export type CareBenefitUsageFollowupStepOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupStepOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareBenefitUsageFollowupStepOrderByRelevanceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentOrderByRelationAggregateInput>;
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUser?: Maybe<UserOrderByWithRelationInput>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  relatedUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  usageFollowup?: Maybe<CareBenefitUsageFollowupOrderByWithRelationInput>;
  usageFollowupId?: Maybe<SortOrder>;
};

export enum CareBenefitUsageFollowupStepOrderByRelevanceFieldEnum {
  CompletedByUserId = 'completedByUserId',
  Description = 'description',
  Id = 'id',
  UsageFollowupId = 'usageFollowupId'
}

export type CareBenefitUsageFollowupStepOrderByRelevanceInput = {
  fields: Array<CareBenefitUsageFollowupStepOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareBenefitUsageFollowupStepOrderByWithAggregationInput = {
  _avg?: Maybe<CareBenefitUsageFollowupStepAvgOrderByAggregateInput>;
  _count?: Maybe<CareBenefitUsageFollowupStepCountOrderByAggregateInput>;
  _max?: Maybe<CareBenefitUsageFollowupStepMaxOrderByAggregateInput>;
  _min?: Maybe<CareBenefitUsageFollowupStepMinOrderByAggregateInput>;
  _sum?: Maybe<CareBenefitUsageFollowupStepSumOrderByAggregateInput>;
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  usageFollowupId?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupStepOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareBenefitUsageFollowupStepOrderByRelevanceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentOrderByRelationAggregateInput>;
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUser?: Maybe<UserOrderByWithRelationInput>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  relatedUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  usageFollowup?: Maybe<CareBenefitUsageFollowupOrderByWithRelationInput>;
  usageFollowupId?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupStepOrderByWithRelationInput = {
  _relevance?: Maybe<CareBenefitUsageFollowupStepOrderByRelevanceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentOrderByRelationAggregateInput>;
  completed?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUser?: Maybe<UserOrderByWithRelationInput>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  relatedUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  usageFollowup?: Maybe<CareBenefitUsageFollowupOrderByWithRelationInput>;
  usageFollowupId?: Maybe<SortOrder>;
};

export enum CareBenefitUsageFollowupStepScalarFieldEnum {
  Completed = 'completed',
  CompletedAt = 'completedAt',
  CompletedByUserId = 'completedByUserId',
  CreatedAt = 'createdAt',
  Description = 'description',
  DisplayOrder = 'displayOrder',
  Id = 'id',
  UsageFollowupId = 'usageFollowupId'
}

export type CareBenefitUsageFollowupStepScalarWhereInput = {
  AND?: Maybe<Array<CareBenefitUsageFollowupStepScalarWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageFollowupStepScalarWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageFollowupStepScalarWhereInput>>;
  completed?: Maybe<BoolFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  completedByUserId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  displayOrder?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  usageFollowupId?: Maybe<StringFilter>;
};

export type CareBenefitUsageFollowupStepScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareBenefitUsageFollowupStepScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareBenefitUsageFollowupStepScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareBenefitUsageFollowupStepScalarWhereWithAggregatesInput>>;
  completed?: Maybe<BoolWithAggregatesFilter>;
  completedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  completedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  displayOrder?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  usageFollowupId?: Maybe<StringWithAggregatesFilter>;
};

export type CareBenefitUsageFollowupStepSumAggregateOutputType = {
  __typename?: 'CareBenefitUsageFollowupStepSumAggregateOutputType';
  displayOrder?: Maybe<Scalars['Int']>;
};

export type CareBenefitUsageFollowupStepSumOrderByAggregateInput = {
  displayOrder?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupStepUncheckedCreateInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutFollowupStepInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRelatedFollowupStepInput>;
  usageFollowupId: Scalars['String'];
};

export type CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupStepCreateOrConnectWithoutCompletedByUserInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupStepCreateWithoutCompletedByUserInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupStepCreateManyCompletedByUserInputEnvelope>;
};

export type CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutUsageFollowupInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupStepCreateOrConnectWithoutUsageFollowupInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupStepCreateWithoutUsageFollowupInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupStepCreateManyUsageFollowupInputEnvelope>;
};

export type CareBenefitUsageFollowupStepUncheckedCreateWithoutCareAccountCreditIntentsInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRelatedFollowupStepInput>;
  usageFollowupId: Scalars['String'];
};

export type CareBenefitUsageFollowupStepUncheckedCreateWithoutCompletedByUserInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutFollowupStepInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRelatedFollowupStepInput>;
  usageFollowupId: Scalars['String'];
};

export type CareBenefitUsageFollowupStepUncheckedCreateWithoutRelatedUsagesInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutFollowupStepInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  usageFollowupId: Scalars['String'];
};

export type CareBenefitUsageFollowupStepUncheckedCreateWithoutUsageFollowupInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutFollowupStepInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRelatedFollowupStepInput>;
};

export type CareBenefitUsageFollowupStepUncheckedUpdateInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutFollowupStepNestedInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRelatedFollowupStepNestedInput>;
  usageFollowupId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageFollowupStepUncheckedUpdateManyInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  usageFollowupId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  usageFollowupId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupStepCreateOrConnectWithoutCompletedByUserInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupStepCreateWithoutCompletedByUserInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupStepCreateManyCompletedByUserInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageFollowupStepScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageFollowupStepUpdateWithWhereUniqueWithoutCompletedByUserInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageFollowupStepUpdateManyWithWhereWithoutCompletedByUserInput>>;
  upsert?: Maybe<Array<CareBenefitUsageFollowupStepUpsertWithWhereUniqueWithoutCompletedByUserInput>>;
};

export type CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutUsageFollowupInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutUsageFollowupNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupStepCreateOrConnectWithoutUsageFollowupInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupStepCreateWithoutUsageFollowupInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupStepCreateManyUsageFollowupInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageFollowupStepScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageFollowupStepUpdateWithWhereUniqueWithoutUsageFollowupInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageFollowupStepUpdateManyWithWhereWithoutUsageFollowupInput>>;
  upsert?: Maybe<Array<CareBenefitUsageFollowupStepUpsertWithWhereUniqueWithoutUsageFollowupInput>>;
};

export type CareBenefitUsageFollowupStepUncheckedUpdateWithoutCareAccountCreditIntentsInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRelatedFollowupStepNestedInput>;
  usageFollowupId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageFollowupStepUncheckedUpdateWithoutCompletedByUserInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutFollowupStepNestedInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRelatedFollowupStepNestedInput>;
  usageFollowupId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageFollowupStepUncheckedUpdateWithoutRelatedUsagesInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutFollowupStepNestedInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  usageFollowupId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageFollowupStepUncheckedUpdateWithoutUsageFollowupInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutFollowupStepNestedInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRelatedFollowupStepNestedInput>;
};

export type CareBenefitUsageFollowupStepUpdateInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutFollowupStepNestedInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUser?: Maybe<UserUpdateOneWithoutCompletedBenefitUsageFollowupStepsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutRelatedFollowupStepNestedInput>;
  usageFollowup?: Maybe<CareBenefitUsageFollowupUpdateOneRequiredWithoutFollowupStepsNestedInput>;
};

export type CareBenefitUsageFollowupStepUpdateManyMutationInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageFollowupStepUpdateManyWithWhereWithoutCompletedByUserInput = {
  data: CareBenefitUsageFollowupStepUpdateManyMutationInput;
  where: CareBenefitUsageFollowupStepScalarWhereInput;
};

export type CareBenefitUsageFollowupStepUpdateManyWithWhereWithoutUsageFollowupInput = {
  data: CareBenefitUsageFollowupStepUpdateManyMutationInput;
  where: CareBenefitUsageFollowupStepScalarWhereInput;
};

export type CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupStepCreateOrConnectWithoutCompletedByUserInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupStepCreateWithoutCompletedByUserInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupStepCreateManyCompletedByUserInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageFollowupStepScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageFollowupStepUpdateWithWhereUniqueWithoutCompletedByUserInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageFollowupStepUpdateManyWithWhereWithoutCompletedByUserInput>>;
  upsert?: Maybe<Array<CareBenefitUsageFollowupStepUpsertWithWhereUniqueWithoutCompletedByUserInput>>;
};

export type CareBenefitUsageFollowupStepUpdateManyWithoutUsageFollowupNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupStepCreateOrConnectWithoutUsageFollowupInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupStepCreateWithoutUsageFollowupInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupStepCreateManyUsageFollowupInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageFollowupStepScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageFollowupStepWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageFollowupStepUpdateWithWhereUniqueWithoutUsageFollowupInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageFollowupStepUpdateManyWithWhereWithoutUsageFollowupInput>>;
  upsert?: Maybe<Array<CareBenefitUsageFollowupStepUpsertWithWhereUniqueWithoutUsageFollowupInput>>;
};

export type CareBenefitUsageFollowupStepUpdateOneWithoutCareAccountCreditIntentsNestedInput = {
  connect?: Maybe<CareBenefitUsageFollowupStepWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitUsageFollowupStepCreateOrConnectWithoutCareAccountCreditIntentsInput>;
  create?: Maybe<CareBenefitUsageFollowupStepCreateWithoutCareAccountCreditIntentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareBenefitUsageFollowupStepUpdateToOneWithWhereWithoutCareAccountCreditIntentsInput>;
  upsert?: Maybe<CareBenefitUsageFollowupStepUpsertWithoutCareAccountCreditIntentsInput>;
};

export type CareBenefitUsageFollowupStepUpdateOneWithoutRelatedUsagesNestedInput = {
  connect?: Maybe<CareBenefitUsageFollowupStepWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitUsageFollowupStepCreateOrConnectWithoutRelatedUsagesInput>;
  create?: Maybe<CareBenefitUsageFollowupStepCreateWithoutRelatedUsagesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareBenefitUsageFollowupStepUpdateToOneWithWhereWithoutRelatedUsagesInput>;
  upsert?: Maybe<CareBenefitUsageFollowupStepUpsertWithoutRelatedUsagesInput>;
};

export type CareBenefitUsageFollowupStepUpdateToOneWithWhereWithoutCareAccountCreditIntentsInput = {
  data: CareBenefitUsageFollowupStepUpdateWithoutCareAccountCreditIntentsInput;
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};

export type CareBenefitUsageFollowupStepUpdateToOneWithWhereWithoutRelatedUsagesInput = {
  data: CareBenefitUsageFollowupStepUpdateWithoutRelatedUsagesInput;
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};

export type CareBenefitUsageFollowupStepUpdateWithWhereUniqueWithoutCompletedByUserInput = {
  data: CareBenefitUsageFollowupStepUpdateWithoutCompletedByUserInput;
  where: CareBenefitUsageFollowupStepWhereUniqueInput;
};

export type CareBenefitUsageFollowupStepUpdateWithWhereUniqueWithoutUsageFollowupInput = {
  data: CareBenefitUsageFollowupStepUpdateWithoutUsageFollowupInput;
  where: CareBenefitUsageFollowupStepWhereUniqueInput;
};

export type CareBenefitUsageFollowupStepUpdateWithoutCareAccountCreditIntentsInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUser?: Maybe<UserUpdateOneWithoutCompletedBenefitUsageFollowupStepsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutRelatedFollowupStepNestedInput>;
  usageFollowup?: Maybe<CareBenefitUsageFollowupUpdateOneRequiredWithoutFollowupStepsNestedInput>;
};

export type CareBenefitUsageFollowupStepUpdateWithoutCompletedByUserInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutFollowupStepNestedInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutRelatedFollowupStepNestedInput>;
  usageFollowup?: Maybe<CareBenefitUsageFollowupUpdateOneRequiredWithoutFollowupStepsNestedInput>;
};

export type CareBenefitUsageFollowupStepUpdateWithoutRelatedUsagesInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutFollowupStepNestedInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUser?: Maybe<UserUpdateOneWithoutCompletedBenefitUsageFollowupStepsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  usageFollowup?: Maybe<CareBenefitUsageFollowupUpdateOneRequiredWithoutFollowupStepsNestedInput>;
};

export type CareBenefitUsageFollowupStepUpdateWithoutUsageFollowupInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutFollowupStepNestedInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUser?: Maybe<UserUpdateOneWithoutCompletedBenefitUsageFollowupStepsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutRelatedFollowupStepNestedInput>;
};

export type CareBenefitUsageFollowupStepUpsertWithWhereUniqueWithoutCompletedByUserInput = {
  create: CareBenefitUsageFollowupStepCreateWithoutCompletedByUserInput;
  update: CareBenefitUsageFollowupStepUpdateWithoutCompletedByUserInput;
  where: CareBenefitUsageFollowupStepWhereUniqueInput;
};

export type CareBenefitUsageFollowupStepUpsertWithWhereUniqueWithoutUsageFollowupInput = {
  create: CareBenefitUsageFollowupStepCreateWithoutUsageFollowupInput;
  update: CareBenefitUsageFollowupStepUpdateWithoutUsageFollowupInput;
  where: CareBenefitUsageFollowupStepWhereUniqueInput;
};

export type CareBenefitUsageFollowupStepUpsertWithoutCareAccountCreditIntentsInput = {
  create: CareBenefitUsageFollowupStepCreateWithoutCareAccountCreditIntentsInput;
  update: CareBenefitUsageFollowupStepUpdateWithoutCareAccountCreditIntentsInput;
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};

export type CareBenefitUsageFollowupStepUpsertWithoutRelatedUsagesInput = {
  create: CareBenefitUsageFollowupStepCreateWithoutRelatedUsagesInput;
  update: CareBenefitUsageFollowupStepUpdateWithoutRelatedUsagesInput;
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};

export type CareBenefitUsageFollowupStepWhereInput = {
  AND?: Maybe<Array<CareBenefitUsageFollowupStepWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageFollowupStepWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageFollowupStepWhereInput>>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentListRelationFilter>;
  completed?: Maybe<BoolFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  completedByUser?: Maybe<UserNullableScalarRelationFilter>;
  completedByUserId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  displayOrder?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  relatedUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  usageFollowup?: Maybe<CareBenefitUsageFollowupScalarRelationFilter>;
  usageFollowupId?: Maybe<StringFilter>;
};

export type CareBenefitUsageFollowupStepWhereUniqueInput = {
  AND?: Maybe<Array<CareBenefitUsageFollowupStepWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageFollowupStepWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageFollowupStepWhereInput>>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentListRelationFilter>;
  completed?: Maybe<BoolFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  completedByUser?: Maybe<UserNullableScalarRelationFilter>;
  completedByUserId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  displayOrder?: Maybe<IntFilter>;
  id?: Maybe<Scalars['String']>;
  relatedUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  usageFollowup?: Maybe<CareBenefitUsageFollowupScalarRelationFilter>;
  usageFollowupId?: Maybe<StringFilter>;
};

export type CareBenefitUsageFollowupSumAggregateOutputType = {
  __typename?: 'CareBenefitUsageFollowupSumAggregateOutputType';
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
};

export type CareBenefitUsageFollowupSumOrderByAggregateInput = {
  reportingOriginalInvoiceValueCents?: Maybe<SortOrder>;
};

export type CareBenefitUsageFollowupUncheckedCreateInput = {
  careStripeSubscriptionId: Scalars['String'];
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutUsageFollowupInput>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPetId: Scalars['String'];
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupCreateManyCareStripeSubscriptionInputEnvelope>;
};

export type CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutRelatedOrganizationPetInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupCreateOrConnectWithoutRelatedOrganizationPetInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupCreateWithoutRelatedOrganizationPetInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupCreateManyRelatedOrganizationPetInputEnvelope>;
};

export type CareBenefitUsageFollowupUncheckedCreateWithoutCareStripeSubscriptionInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutUsageFollowupInput>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPetId: Scalars['String'];
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUncheckedCreateWithoutFollowupStepsInput = {
  careStripeSubscriptionId: Scalars['String'];
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPetId: Scalars['String'];
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUncheckedCreateWithoutRelatedOrganizationPetInput = {
  careStripeSubscriptionId: Scalars['String'];
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutUsageFollowupInput>;
  id?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUncheckedUpdateInput = {
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutUsageFollowupNestedInput>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPetId?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUncheckedUpdateManyInput = {
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPetId?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUncheckedUpdateManyWithoutCareStripeSubscriptionInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPetId?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupCreateManyCareStripeSubscriptionInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageFollowupScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageFollowupUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageFollowupUpdateManyWithWhereWithoutCareStripeSubscriptionInput>>;
  upsert?: Maybe<Array<CareBenefitUsageFollowupUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
};

export type CareBenefitUsageFollowupUncheckedUpdateManyWithoutRelatedOrganizationPetInput = {
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUncheckedUpdateManyWithoutRelatedOrganizationPetNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupCreateOrConnectWithoutRelatedOrganizationPetInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupCreateWithoutRelatedOrganizationPetInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupCreateManyRelatedOrganizationPetInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageFollowupScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageFollowupUpdateWithWhereUniqueWithoutRelatedOrganizationPetInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageFollowupUpdateManyWithWhereWithoutRelatedOrganizationPetInput>>;
  upsert?: Maybe<Array<CareBenefitUsageFollowupUpsertWithWhereUniqueWithoutRelatedOrganizationPetInput>>;
};

export type CareBenefitUsageFollowupUncheckedUpdateWithoutCareStripeSubscriptionInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutUsageFollowupNestedInput>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPetId?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUncheckedUpdateWithoutFollowupStepsInput = {
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPetId?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUncheckedUpdateWithoutRelatedOrganizationPetInput = {
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutUsageFollowupNestedInput>;
  id?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUpdateInput = {
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutCareBenefitUsageFollowupsNestedInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutUsageFollowupNestedInput>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutAssociatedBenefitUsageFollowupNestedInput>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUpdateManyMutationInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUpdateManyWithWhereWithoutCareStripeSubscriptionInput = {
  data: CareBenefitUsageFollowupUpdateManyMutationInput;
  where: CareBenefitUsageFollowupScalarWhereInput;
};

export type CareBenefitUsageFollowupUpdateManyWithWhereWithoutRelatedOrganizationPetInput = {
  data: CareBenefitUsageFollowupUpdateManyMutationInput;
  where: CareBenefitUsageFollowupScalarWhereInput;
};

export type CareBenefitUsageFollowupUpdateManyWithoutCareStripeSubscriptionNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupCreateManyCareStripeSubscriptionInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageFollowupScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageFollowupUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageFollowupUpdateManyWithWhereWithoutCareStripeSubscriptionInput>>;
  upsert?: Maybe<Array<CareBenefitUsageFollowupUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
};

export type CareBenefitUsageFollowupUpdateManyWithoutRelatedOrganizationPetNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageFollowupCreateOrConnectWithoutRelatedOrganizationPetInput>>;
  create?: Maybe<Array<CareBenefitUsageFollowupCreateWithoutRelatedOrganizationPetInput>>;
  createMany?: Maybe<CareBenefitUsageFollowupCreateManyRelatedOrganizationPetInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageFollowupScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageFollowupWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageFollowupUpdateWithWhereUniqueWithoutRelatedOrganizationPetInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageFollowupUpdateManyWithWhereWithoutRelatedOrganizationPetInput>>;
  upsert?: Maybe<Array<CareBenefitUsageFollowupUpsertWithWhereUniqueWithoutRelatedOrganizationPetInput>>;
};

export type CareBenefitUsageFollowupUpdateOneRequiredWithoutFollowupStepsNestedInput = {
  connect?: Maybe<CareBenefitUsageFollowupWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitUsageFollowupCreateOrConnectWithoutFollowupStepsInput>;
  create?: Maybe<CareBenefitUsageFollowupCreateWithoutFollowupStepsInput>;
  update?: Maybe<CareBenefitUsageFollowupUpdateToOneWithWhereWithoutFollowupStepsInput>;
  upsert?: Maybe<CareBenefitUsageFollowupUpsertWithoutFollowupStepsInput>;
};

export type CareBenefitUsageFollowupUpdateToOneWithWhereWithoutFollowupStepsInput = {
  data: CareBenefitUsageFollowupUpdateWithoutFollowupStepsInput;
  where?: Maybe<CareBenefitUsageFollowupWhereInput>;
};

export type CareBenefitUsageFollowupUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput = {
  data: CareBenefitUsageFollowupUpdateWithoutCareStripeSubscriptionInput;
  where: CareBenefitUsageFollowupWhereUniqueInput;
};

export type CareBenefitUsageFollowupUpdateWithWhereUniqueWithoutRelatedOrganizationPetInput = {
  data: CareBenefitUsageFollowupUpdateWithoutRelatedOrganizationPetInput;
  where: CareBenefitUsageFollowupWhereUniqueInput;
};

export type CareBenefitUsageFollowupUpdateWithoutCareStripeSubscriptionInput = {
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutUsageFollowupNestedInput>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutAssociatedBenefitUsageFollowupNestedInput>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUpdateWithoutFollowupStepsInput = {
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutCareBenefitUsageFollowupsNestedInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutAssociatedBenefitUsageFollowupNestedInput>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUpdateWithoutRelatedOrganizationPetInput = {
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutCareBenefitUsageFollowupsNestedInput>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutUsageFollowupNestedInput>;
  id?: Maybe<Scalars['String']>;
  reportingOriginalInvoiceValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageFollowupUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput = {
  create: CareBenefitUsageFollowupCreateWithoutCareStripeSubscriptionInput;
  update: CareBenefitUsageFollowupUpdateWithoutCareStripeSubscriptionInput;
  where: CareBenefitUsageFollowupWhereUniqueInput;
};

export type CareBenefitUsageFollowupUpsertWithWhereUniqueWithoutRelatedOrganizationPetInput = {
  create: CareBenefitUsageFollowupCreateWithoutRelatedOrganizationPetInput;
  update: CareBenefitUsageFollowupUpdateWithoutRelatedOrganizationPetInput;
  where: CareBenefitUsageFollowupWhereUniqueInput;
};

export type CareBenefitUsageFollowupUpsertWithoutFollowupStepsInput = {
  create: CareBenefitUsageFollowupCreateWithoutFollowupStepsInput;
  update: CareBenefitUsageFollowupUpdateWithoutFollowupStepsInput;
  where?: Maybe<CareBenefitUsageFollowupWhereInput>;
};

export type CareBenefitUsageFollowupWhereInput = {
  AND?: Maybe<Array<CareBenefitUsageFollowupWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageFollowupWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageFollowupWhereInput>>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  completed?: Maybe<BoolFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepListRelationFilter>;
  id?: Maybe<StringFilter>;
  relatedOrganizationPet?: Maybe<OrganizationPetScalarRelationFilter>;
  relatedOrganizationPetId?: Maybe<StringFilter>;
  reportingOriginalInvoiceValueCents?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareBenefitUsageFollowupWhereUniqueInput = {
  AND?: Maybe<Array<CareBenefitUsageFollowupWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageFollowupWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageFollowupWhereInput>>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  completed?: Maybe<BoolFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  followupSteps?: Maybe<CareBenefitUsageFollowupStepListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  relatedOrganizationPet?: Maybe<OrganizationPetScalarRelationFilter>;
  relatedOrganizationPetId?: Maybe<StringFilter>;
  reportingOriginalInvoiceValueCents?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareBenefitUsageGroupByOutputType = {
  __typename?: 'CareBenefitUsageGroupByOutputType';
  _avg?: Maybe<CareBenefitUsageAvgAggregateOutputType>;
  _count?: Maybe<CareBenefitUsageCountAggregateOutputType>;
  _max?: Maybe<CareBenefitUsageMaxAggregateOutputType>;
  _min?: Maybe<CareBenefitUsageMinAggregateOutputType>;
  _sum?: Maybe<CareBenefitUsageSumAggregateOutputType>;
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageListRelationFilter = {
  every?: Maybe<CareBenefitUsageWhereInput>;
  none?: Maybe<CareBenefitUsageWhereInput>;
  some?: Maybe<CareBenefitUsageWhereInput>;
};

export type CareBenefitUsageMaxAggregateOutputType = {
  __typename?: 'CareBenefitUsageMaxAggregateOutputType';
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageMaxOrderByAggregateInput = {
  benefitId?: Maybe<SortOrder>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  connectedAddonEnrollmentId?: Maybe<SortOrder>;
  connectedPlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exhaustsBenefit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  quantityUsed?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recordedByUserId?: Maybe<SortOrder>;
  relatedFollowupStepId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageClinicId?: Maybe<SortOrder>;
  usageClinicPetId?: Maybe<SortOrder>;
  usedAt?: Maybe<SortOrder>;
};

export type CareBenefitUsageMinAggregateOutputType = {
  __typename?: 'CareBenefitUsageMinAggregateOutputType';
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageMinOrderByAggregateInput = {
  benefitId?: Maybe<SortOrder>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  connectedAddonEnrollmentId?: Maybe<SortOrder>;
  connectedPlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exhaustsBenefit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  quantityUsed?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recordedByUserId?: Maybe<SortOrder>;
  relatedFollowupStepId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageClinicId?: Maybe<SortOrder>;
  usageClinicPetId?: Maybe<SortOrder>;
  usedAt?: Maybe<SortOrder>;
};

export type CareBenefitUsageOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareBenefitUsageOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareBenefitUsageOrderByRelevanceInput>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentOrderByWithRelationInput>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentOrderByWithRelationInput>;
  connectedAddonEnrollmentId?: Maybe<SortOrder>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  connectedPlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exhaustsBenefit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  quantityUsed?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recordedByUser?: Maybe<UserOrderByWithRelationInput>;
  recordedByUserId?: Maybe<SortOrder>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepOrderByWithRelationInput>;
  relatedFollowupStepId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageClinic?: Maybe<ClinicOrderByWithRelationInput>;
  usageClinicId?: Maybe<SortOrder>;
  usageClinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  usageClinicPetId?: Maybe<SortOrder>;
  usedAt?: Maybe<SortOrder>;
};

export enum CareBenefitUsageOrderByRelevanceFieldEnum {
  BenefitId = 'benefitId',
  CareAccountCreditIntentId = 'careAccountCreditIntentId',
  ConnectedAddonEnrollmentId = 'connectedAddonEnrollmentId',
  ConnectedPlanEnrollmentId = 'connectedPlanEnrollmentId',
  Id = 'id',
  Reason = 'reason',
  RecordedByUserId = 'recordedByUserId',
  RelatedFollowupStepId = 'relatedFollowupStepId',
  UsageClinicId = 'usageClinicId',
  UsageClinicPetId = 'usageClinicPetId'
}

export type CareBenefitUsageOrderByRelevanceInput = {
  fields: Array<CareBenefitUsageOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareBenefitUsageOrderByWithAggregationInput = {
  _avg?: Maybe<CareBenefitUsageAvgOrderByAggregateInput>;
  _count?: Maybe<CareBenefitUsageCountOrderByAggregateInput>;
  _max?: Maybe<CareBenefitUsageMaxOrderByAggregateInput>;
  _min?: Maybe<CareBenefitUsageMinOrderByAggregateInput>;
  _sum?: Maybe<CareBenefitUsageSumOrderByAggregateInput>;
  benefitId?: Maybe<SortOrder>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  connectedAddonEnrollmentId?: Maybe<SortOrder>;
  connectedPlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exhaustsBenefit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  quantityUsed?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recordedByUserId?: Maybe<SortOrder>;
  relatedFollowupStepId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageClinicId?: Maybe<SortOrder>;
  usageClinicPetId?: Maybe<SortOrder>;
  usedAt?: Maybe<SortOrder>;
};

export type CareBenefitUsageOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareBenefitUsageOrderByRelevanceInput>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentOrderByWithRelationInput>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentOrderByWithRelationInput>;
  connectedAddonEnrollmentId?: Maybe<SortOrder>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  connectedPlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exhaustsBenefit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  quantityUsed?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recordedByUser?: Maybe<UserOrderByWithRelationInput>;
  recordedByUserId?: Maybe<SortOrder>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepOrderByWithRelationInput>;
  relatedFollowupStepId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageClinic?: Maybe<ClinicOrderByWithRelationInput>;
  usageClinicId?: Maybe<SortOrder>;
  usageClinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  usageClinicPetId?: Maybe<SortOrder>;
  usedAt?: Maybe<SortOrder>;
};

export type CareBenefitUsageOrderByWithRelationInput = {
  _relevance?: Maybe<CareBenefitUsageOrderByRelevanceInput>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentOrderByWithRelationInput>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentOrderByWithRelationInput>;
  connectedAddonEnrollmentId?: Maybe<SortOrder>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  connectedPlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exhaustsBenefit?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  quantityUsed?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recordedByUser?: Maybe<UserOrderByWithRelationInput>;
  recordedByUserId?: Maybe<SortOrder>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepOrderByWithRelationInput>;
  relatedFollowupStepId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  usageClinic?: Maybe<ClinicOrderByWithRelationInput>;
  usageClinicId?: Maybe<SortOrder>;
  usageClinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  usageClinicPetId?: Maybe<SortOrder>;
  usedAt?: Maybe<SortOrder>;
};

export enum CareBenefitUsageScalarFieldEnum {
  BenefitId = 'benefitId',
  CareAccountCreditIntentId = 'careAccountCreditIntentId',
  ConnectedAddonEnrollmentId = 'connectedAddonEnrollmentId',
  ConnectedPlanEnrollmentId = 'connectedPlanEnrollmentId',
  CreatedAt = 'createdAt',
  ExhaustsBenefit = 'exhaustsBenefit',
  Id = 'id',
  QuantityUsed = 'quantityUsed',
  Reason = 'reason',
  RecordedByUserId = 'recordedByUserId',
  RelatedFollowupStepId = 'relatedFollowupStepId',
  UpdatedAt = 'updatedAt',
  UsageClinicId = 'usageClinicId',
  UsageClinicPetId = 'usageClinicPetId',
  UsedAt = 'usedAt'
}

export type CareBenefitUsageScalarRelationFilter = {
  AND?: Maybe<Array<CareBenefitUsageWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageWhereInput>>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentNullableScalarRelationFilter>;
  careAccountCreditIntentId?: Maybe<StringNullableFilter>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentNullableScalarRelationFilter>;
  connectedAddonEnrollmentId?: Maybe<StringNullableFilter>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  connectedPlanEnrollmentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  exhaustsBenefit?: Maybe<BoolNullableFilter>;
  id?: Maybe<StringFilter>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  quantityUsed?: Maybe<IntNullableFilter>;
  reason?: Maybe<StringNullableFilter>;
  recordedByUser?: Maybe<UserNullableScalarRelationFilter>;
  recordedByUserId?: Maybe<StringNullableFilter>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepNullableScalarRelationFilter>;
  relatedFollowupStepId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  usageClinic?: Maybe<ClinicScalarRelationFilter>;
  usageClinicId?: Maybe<StringFilter>;
  usageClinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  usageClinicPetId?: Maybe<StringFilter>;
  usedAt?: Maybe<DateTimeFilter>;
};

export type CareBenefitUsageScalarWhereInput = {
  AND?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  benefitId?: Maybe<StringFilter>;
  careAccountCreditIntentId?: Maybe<StringNullableFilter>;
  connectedAddonEnrollmentId?: Maybe<StringNullableFilter>;
  connectedPlanEnrollmentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  exhaustsBenefit?: Maybe<BoolNullableFilter>;
  id?: Maybe<StringFilter>;
  quantityUsed?: Maybe<IntNullableFilter>;
  reason?: Maybe<StringNullableFilter>;
  recordedByUserId?: Maybe<StringNullableFilter>;
  relatedFollowupStepId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  usageClinicId?: Maybe<StringFilter>;
  usageClinicPetId?: Maybe<StringFilter>;
  usedAt?: Maybe<DateTimeFilter>;
};

export type CareBenefitUsageScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareBenefitUsageScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareBenefitUsageScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareBenefitUsageScalarWhereWithAggregatesInput>>;
  benefitId?: Maybe<StringWithAggregatesFilter>;
  careAccountCreditIntentId?: Maybe<StringNullableWithAggregatesFilter>;
  connectedAddonEnrollmentId?: Maybe<StringNullableWithAggregatesFilter>;
  connectedPlanEnrollmentId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  exhaustsBenefit?: Maybe<BoolNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  quantityUsed?: Maybe<IntNullableWithAggregatesFilter>;
  reason?: Maybe<StringNullableWithAggregatesFilter>;
  recordedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  relatedFollowupStepId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  usageClinicId?: Maybe<StringWithAggregatesFilter>;
  usageClinicPetId?: Maybe<StringWithAggregatesFilter>;
  usedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CareBenefitUsageSumAggregateOutputType = {
  __typename?: 'CareBenefitUsageSumAggregateOutputType';
  quantityUsed?: Maybe<Scalars['Int']>;
};

export type CareBenefitUsageSumOrderByAggregateInput = {
  quantityUsed?: Maybe<SortOrder>;
};

export type CareBenefitUsageToInvoiceLineItem = {
  __typename?: 'CareBenefitUsageToInvoiceLineItem';
  adjustedAmount: Scalars['Int'];
  associatedInvoice?: Maybe<Invoice>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsage: CareBenefitUsage;
  careBenefitUsageId: Scalars['String'];
  confirmedBy?: Maybe<User>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftService?: Maybe<Service>;
  draftServiceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoiceLineItem?: Maybe<InvoiceLineItem>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};


export type CareBenefitUsageToInvoiceLineItemAssociatedInvoiceArgs = {
  where?: Maybe<InvoiceWhereInput>;
};


export type CareBenefitUsageToInvoiceLineItemConfirmedByArgs = {
  where?: Maybe<UserWhereInput>;
};


export type CareBenefitUsageToInvoiceLineItemDraftServiceArgs = {
  where?: Maybe<ServiceWhereInput>;
};


export type CareBenefitUsageToInvoiceLineItemInvoiceLineItemArgs = {
  where?: Maybe<InvoiceLineItemWhereInput>;
};

export type CareBenefitUsageToInvoiceLineItemAvgAggregateOutputType = {
  __typename?: 'CareBenefitUsageToInvoiceLineItemAvgAggregateOutputType';
  adjustedAmount?: Maybe<Scalars['Float']>;
};

export type CareBenefitUsageToInvoiceLineItemAvgOrderByAggregateInput = {
  adjustedAmount?: Maybe<SortOrder>;
};

export type CareBenefitUsageToInvoiceLineItemCareBenefitUsageIdInvoiceLineItemIdCompoundUniqueInput = {
  careBenefitUsageId: Scalars['String'];
  invoiceLineItemId: Scalars['String'];
};

export type CareBenefitUsageToInvoiceLineItemCountAggregateOutputType = {
  __typename?: 'CareBenefitUsageToInvoiceLineItemCountAggregateOutputType';
  _all: Scalars['Int'];
  adjustedAmount: Scalars['Int'];
  associatedInvoiceId: Scalars['Int'];
  careBenefitUsageId: Scalars['Int'];
  confirmedByUserId: Scalars['Int'];
  draftServiceId: Scalars['Int'];
  id: Scalars['Int'];
  invoiceLineItemId: Scalars['Int'];
};

export type CareBenefitUsageToInvoiceLineItemCountOrderByAggregateInput = {
  adjustedAmount?: Maybe<SortOrder>;
  associatedInvoiceId?: Maybe<SortOrder>;
  careBenefitUsageId?: Maybe<SortOrder>;
  confirmedByUserId?: Maybe<SortOrder>;
  draftServiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItemId?: Maybe<SortOrder>;
};

export type CareBenefitUsageToInvoiceLineItemCreateInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoice?: Maybe<InvoiceCreateNestedOneWithoutAssociatedCareBenefitCreditsInput>;
  careBenefitUsage: CareBenefitUsageCreateNestedOneWithoutInvoiceLineItemConnectionsInput;
  confirmedBy?: Maybe<UserCreateNestedOneWithoutCareBenefitUsageToInvoiceLineItemsInput>;
  draftService?: Maybe<ServiceCreateNestedOneWithoutDraftCareBenefitUsageToInvoiceLineItemsInput>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutConnectedCareBenefitsInput>;
};

export type CareBenefitUsageToInvoiceLineItemCreateManyAssociatedInvoiceInput = {
  adjustedAmount: Scalars['Int'];
  careBenefitUsageId: Scalars['String'];
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemCreateManyAssociatedInvoiceInputEnvelope = {
  data: Array<CareBenefitUsageToInvoiceLineItemCreateManyAssociatedInvoiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageToInvoiceLineItemCreateManyCareBenefitUsageInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoiceId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemCreateManyCareBenefitUsageInputEnvelope = {
  data: Array<CareBenefitUsageToInvoiceLineItemCreateManyCareBenefitUsageInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageToInvoiceLineItemCreateManyConfirmedByInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId: Scalars['String'];
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemCreateManyConfirmedByInputEnvelope = {
  data: Array<CareBenefitUsageToInvoiceLineItemCreateManyConfirmedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageToInvoiceLineItemCreateManyDraftServiceInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId: Scalars['String'];
  confirmedByUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemCreateManyDraftServiceInputEnvelope = {
  data: Array<CareBenefitUsageToInvoiceLineItemCreateManyDraftServiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageToInvoiceLineItemCreateManyInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId: Scalars['String'];
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemCreateManyInvoiceLineItemInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId: Scalars['String'];
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemCreateManyInvoiceLineItemInputEnvelope = {
  data: Array<CareBenefitUsageToInvoiceLineItemCreateManyInvoiceLineItemInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutAssociatedInvoiceInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutAssociatedInvoiceInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutAssociatedInvoiceInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyAssociatedInvoiceInputEnvelope>;
};

export type CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutCareBenefitUsageInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutCareBenefitUsageInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutCareBenefitUsageInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyCareBenefitUsageInputEnvelope>;
};

export type CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutConfirmedByInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutConfirmedByInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyConfirmedByInputEnvelope>;
};

export type CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutDraftServiceInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutDraftServiceInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyDraftServiceInputEnvelope>;
};

export type CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutInvoiceLineItemInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutInvoiceLineItemInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutInvoiceLineItemInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyInvoiceLineItemInputEnvelope>;
};

export type CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutAssociatedInvoiceInput = {
  create: CareBenefitUsageToInvoiceLineItemCreateWithoutAssociatedInvoiceInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutCareBenefitUsageInput = {
  create: CareBenefitUsageToInvoiceLineItemCreateWithoutCareBenefitUsageInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutConfirmedByInput = {
  create: CareBenefitUsageToInvoiceLineItemCreateWithoutConfirmedByInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutDraftServiceInput = {
  create: CareBenefitUsageToInvoiceLineItemCreateWithoutDraftServiceInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutInvoiceLineItemInput = {
  create: CareBenefitUsageToInvoiceLineItemCreateWithoutInvoiceLineItemInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemCreateWithoutAssociatedInvoiceInput = {
  adjustedAmount: Scalars['Int'];
  careBenefitUsage: CareBenefitUsageCreateNestedOneWithoutInvoiceLineItemConnectionsInput;
  confirmedBy?: Maybe<UserCreateNestedOneWithoutCareBenefitUsageToInvoiceLineItemsInput>;
  draftService?: Maybe<ServiceCreateNestedOneWithoutDraftCareBenefitUsageToInvoiceLineItemsInput>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutConnectedCareBenefitsInput>;
};

export type CareBenefitUsageToInvoiceLineItemCreateWithoutCareBenefitUsageInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoice?: Maybe<InvoiceCreateNestedOneWithoutAssociatedCareBenefitCreditsInput>;
  confirmedBy?: Maybe<UserCreateNestedOneWithoutCareBenefitUsageToInvoiceLineItemsInput>;
  draftService?: Maybe<ServiceCreateNestedOneWithoutDraftCareBenefitUsageToInvoiceLineItemsInput>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutConnectedCareBenefitsInput>;
};

export type CareBenefitUsageToInvoiceLineItemCreateWithoutConfirmedByInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoice?: Maybe<InvoiceCreateNestedOneWithoutAssociatedCareBenefitCreditsInput>;
  careBenefitUsage: CareBenefitUsageCreateNestedOneWithoutInvoiceLineItemConnectionsInput;
  draftService?: Maybe<ServiceCreateNestedOneWithoutDraftCareBenefitUsageToInvoiceLineItemsInput>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutConnectedCareBenefitsInput>;
};

export type CareBenefitUsageToInvoiceLineItemCreateWithoutDraftServiceInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoice?: Maybe<InvoiceCreateNestedOneWithoutAssociatedCareBenefitCreditsInput>;
  careBenefitUsage: CareBenefitUsageCreateNestedOneWithoutInvoiceLineItemConnectionsInput;
  confirmedBy?: Maybe<UserCreateNestedOneWithoutCareBenefitUsageToInvoiceLineItemsInput>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItem?: Maybe<InvoiceLineItemCreateNestedOneWithoutConnectedCareBenefitsInput>;
};

export type CareBenefitUsageToInvoiceLineItemCreateWithoutInvoiceLineItemInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoice?: Maybe<InvoiceCreateNestedOneWithoutAssociatedCareBenefitCreditsInput>;
  careBenefitUsage: CareBenefitUsageCreateNestedOneWithoutInvoiceLineItemConnectionsInput;
  confirmedBy?: Maybe<UserCreateNestedOneWithoutCareBenefitUsageToInvoiceLineItemsInput>;
  draftService?: Maybe<ServiceCreateNestedOneWithoutDraftCareBenefitUsageToInvoiceLineItemsInput>;
  id?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemGroupByOutputType = {
  __typename?: 'CareBenefitUsageToInvoiceLineItemGroupByOutputType';
  _avg?: Maybe<CareBenefitUsageToInvoiceLineItemAvgAggregateOutputType>;
  _count?: Maybe<CareBenefitUsageToInvoiceLineItemCountAggregateOutputType>;
  _max?: Maybe<CareBenefitUsageToInvoiceLineItemMaxAggregateOutputType>;
  _min?: Maybe<CareBenefitUsageToInvoiceLineItemMinAggregateOutputType>;
  _sum?: Maybe<CareBenefitUsageToInvoiceLineItemSumAggregateOutputType>;
  adjustedAmount: Scalars['Int'];
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId: Scalars['String'];
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemListRelationFilter = {
  every?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
  none?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
  some?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
};

export type CareBenefitUsageToInvoiceLineItemMaxAggregateOutputType = {
  __typename?: 'CareBenefitUsageToInvoiceLineItemMaxAggregateOutputType';
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemMaxOrderByAggregateInput = {
  adjustedAmount?: Maybe<SortOrder>;
  associatedInvoiceId?: Maybe<SortOrder>;
  careBenefitUsageId?: Maybe<SortOrder>;
  confirmedByUserId?: Maybe<SortOrder>;
  draftServiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItemId?: Maybe<SortOrder>;
};

export type CareBenefitUsageToInvoiceLineItemMinAggregateOutputType = {
  __typename?: 'CareBenefitUsageToInvoiceLineItemMinAggregateOutputType';
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemMinOrderByAggregateInput = {
  adjustedAmount?: Maybe<SortOrder>;
  associatedInvoiceId?: Maybe<SortOrder>;
  careBenefitUsageId?: Maybe<SortOrder>;
  confirmedByUserId?: Maybe<SortOrder>;
  draftServiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItemId?: Maybe<SortOrder>;
};

export type CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareBenefitUsageToInvoiceLineItemOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelevanceInput>;
  adjustedAmount?: Maybe<SortOrder>;
  associatedInvoice?: Maybe<InvoiceOrderByWithRelationInput>;
  associatedInvoiceId?: Maybe<SortOrder>;
  careBenefitUsage?: Maybe<CareBenefitUsageOrderByWithRelationInput>;
  careBenefitUsageId?: Maybe<SortOrder>;
  confirmedBy?: Maybe<UserOrderByWithRelationInput>;
  confirmedByUserId?: Maybe<SortOrder>;
  draftService?: Maybe<ServiceOrderByWithRelationInput>;
  draftServiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItem?: Maybe<InvoiceLineItemOrderByWithRelationInput>;
  invoiceLineItemId?: Maybe<SortOrder>;
};

export enum CareBenefitUsageToInvoiceLineItemOrderByRelevanceFieldEnum {
  AssociatedInvoiceId = 'associatedInvoiceId',
  CareBenefitUsageId = 'careBenefitUsageId',
  ConfirmedByUserId = 'confirmedByUserId',
  DraftServiceId = 'draftServiceId',
  Id = 'id',
  InvoiceLineItemId = 'invoiceLineItemId'
}

export type CareBenefitUsageToInvoiceLineItemOrderByRelevanceInput = {
  fields: Array<CareBenefitUsageToInvoiceLineItemOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareBenefitUsageToInvoiceLineItemOrderByWithAggregationInput = {
  _avg?: Maybe<CareBenefitUsageToInvoiceLineItemAvgOrderByAggregateInput>;
  _count?: Maybe<CareBenefitUsageToInvoiceLineItemCountOrderByAggregateInput>;
  _max?: Maybe<CareBenefitUsageToInvoiceLineItemMaxOrderByAggregateInput>;
  _min?: Maybe<CareBenefitUsageToInvoiceLineItemMinOrderByAggregateInput>;
  _sum?: Maybe<CareBenefitUsageToInvoiceLineItemSumOrderByAggregateInput>;
  adjustedAmount?: Maybe<SortOrder>;
  associatedInvoiceId?: Maybe<SortOrder>;
  careBenefitUsageId?: Maybe<SortOrder>;
  confirmedByUserId?: Maybe<SortOrder>;
  draftServiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItemId?: Maybe<SortOrder>;
};

export type CareBenefitUsageToInvoiceLineItemOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelevanceInput>;
  adjustedAmount?: Maybe<SortOrder>;
  associatedInvoice?: Maybe<InvoiceOrderByWithRelationInput>;
  associatedInvoiceId?: Maybe<SortOrder>;
  careBenefitUsage?: Maybe<CareBenefitUsageOrderByWithRelationInput>;
  careBenefitUsageId?: Maybe<SortOrder>;
  confirmedBy?: Maybe<UserOrderByWithRelationInput>;
  confirmedByUserId?: Maybe<SortOrder>;
  draftService?: Maybe<ServiceOrderByWithRelationInput>;
  draftServiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItem?: Maybe<InvoiceLineItemOrderByWithRelationInput>;
  invoiceLineItemId?: Maybe<SortOrder>;
};

export type CareBenefitUsageToInvoiceLineItemOrderByWithRelationInput = {
  _relevance?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelevanceInput>;
  adjustedAmount?: Maybe<SortOrder>;
  associatedInvoice?: Maybe<InvoiceOrderByWithRelationInput>;
  associatedInvoiceId?: Maybe<SortOrder>;
  careBenefitUsage?: Maybe<CareBenefitUsageOrderByWithRelationInput>;
  careBenefitUsageId?: Maybe<SortOrder>;
  confirmedBy?: Maybe<UserOrderByWithRelationInput>;
  confirmedByUserId?: Maybe<SortOrder>;
  draftService?: Maybe<ServiceOrderByWithRelationInput>;
  draftServiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceLineItem?: Maybe<InvoiceLineItemOrderByWithRelationInput>;
  invoiceLineItemId?: Maybe<SortOrder>;
};

export enum CareBenefitUsageToInvoiceLineItemScalarFieldEnum {
  AdjustedAmount = 'adjustedAmount',
  AssociatedInvoiceId = 'associatedInvoiceId',
  CareBenefitUsageId = 'careBenefitUsageId',
  ConfirmedByUserId = 'confirmedByUserId',
  DraftServiceId = 'draftServiceId',
  Id = 'id',
  InvoiceLineItemId = 'invoiceLineItemId'
}

export type CareBenefitUsageToInvoiceLineItemScalarWhereInput = {
  AND?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  adjustedAmount?: Maybe<IntFilter>;
  associatedInvoiceId?: Maybe<StringNullableFilter>;
  careBenefitUsageId?: Maybe<StringFilter>;
  confirmedByUserId?: Maybe<StringNullableFilter>;
  draftServiceId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invoiceLineItemId?: Maybe<StringNullableFilter>;
};

export type CareBenefitUsageToInvoiceLineItemScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereWithAggregatesInput>>;
  adjustedAmount?: Maybe<IntWithAggregatesFilter>;
  associatedInvoiceId?: Maybe<StringNullableWithAggregatesFilter>;
  careBenefitUsageId?: Maybe<StringWithAggregatesFilter>;
  confirmedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  draftServiceId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  invoiceLineItemId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type CareBenefitUsageToInvoiceLineItemSumAggregateOutputType = {
  __typename?: 'CareBenefitUsageToInvoiceLineItemSumAggregateOutputType';
  adjustedAmount?: Maybe<Scalars['Int']>;
};

export type CareBenefitUsageToInvoiceLineItemSumOrderByAggregateInput = {
  adjustedAmount?: Maybe<SortOrder>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedCreateInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId: Scalars['String'];
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutAssociatedInvoiceInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutAssociatedInvoiceInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutAssociatedInvoiceInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyAssociatedInvoiceInputEnvelope>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutCareBenefitUsageInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutCareBenefitUsageInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutCareBenefitUsageInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyCareBenefitUsageInputEnvelope>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutConfirmedByInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutConfirmedByInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyConfirmedByInputEnvelope>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutDraftServiceInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutDraftServiceInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyDraftServiceInputEnvelope>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceLineItemInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutInvoiceLineItemInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutInvoiceLineItemInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyInvoiceLineItemInputEnvelope>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedCreateWithoutAssociatedInvoiceInput = {
  adjustedAmount: Scalars['Int'];
  careBenefitUsageId: Scalars['String'];
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedCreateWithoutCareBenefitUsageInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoiceId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedCreateWithoutConfirmedByInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId: Scalars['String'];
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedCreateWithoutDraftServiceInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId: Scalars['String'];
  confirmedByUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedCreateWithoutInvoiceLineItemInput = {
  adjustedAmount: Scalars['Int'];
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId: Scalars['String'];
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  careBenefitUsageId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutAssociatedInvoiceInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutAssociatedInvoiceInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyAssociatedInvoiceInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutAssociatedInvoiceInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutAssociatedInvoiceInput>>;
  upsert?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutAssociatedInvoiceInput>>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutCareBenefitUsageInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutCareBenefitUsageNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutCareBenefitUsageInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutCareBenefitUsageInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyCareBenefitUsageInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutCareBenefitUsageInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutCareBenefitUsageInput>>;
  upsert?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutCareBenefitUsageInput>>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutConfirmedByInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutConfirmedByInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyConfirmedByInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutConfirmedByInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutConfirmedByInput>>;
  upsert?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutConfirmedByInput>>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutDraftServiceInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutDraftServiceInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyDraftServiceInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutDraftServiceInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutDraftServiceInput>>;
  upsert?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutDraftServiceInput>>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutInvoiceLineItemInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutInvoiceLineItemNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutInvoiceLineItemInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutInvoiceLineItemInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyInvoiceLineItemInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutInvoiceLineItemInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutInvoiceLineItemInput>>;
  upsert?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutInvoiceLineItemInput>>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateWithoutAssociatedInvoiceInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  careBenefitUsageId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateWithoutCareBenefitUsageInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateWithoutConfirmedByInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateWithoutDraftServiceInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUncheckedUpdateWithoutInvoiceLineItemInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsageId?: Maybe<Scalars['String']>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftServiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUpdateInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoice?: Maybe<InvoiceUpdateOneWithoutAssociatedCareBenefitCreditsNestedInput>;
  careBenefitUsage?: Maybe<CareBenefitUsageUpdateOneRequiredWithoutInvoiceLineItemConnectionsNestedInput>;
  confirmedBy?: Maybe<UserUpdateOneWithoutCareBenefitUsageToInvoiceLineItemsNestedInput>;
  draftService?: Maybe<ServiceUpdateOneWithoutDraftCareBenefitUsageToInvoiceLineItemsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutConnectedCareBenefitsNestedInput>;
};

export type CareBenefitUsageToInvoiceLineItemUpdateManyMutationInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutAssociatedInvoiceInput = {
  data: CareBenefitUsageToInvoiceLineItemUpdateManyMutationInput;
  where: CareBenefitUsageToInvoiceLineItemScalarWhereInput;
};

export type CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutCareBenefitUsageInput = {
  data: CareBenefitUsageToInvoiceLineItemUpdateManyMutationInput;
  where: CareBenefitUsageToInvoiceLineItemScalarWhereInput;
};

export type CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutConfirmedByInput = {
  data: CareBenefitUsageToInvoiceLineItemUpdateManyMutationInput;
  where: CareBenefitUsageToInvoiceLineItemScalarWhereInput;
};

export type CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutDraftServiceInput = {
  data: CareBenefitUsageToInvoiceLineItemUpdateManyMutationInput;
  where: CareBenefitUsageToInvoiceLineItemScalarWhereInput;
};

export type CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutInvoiceLineItemInput = {
  data: CareBenefitUsageToInvoiceLineItemUpdateManyMutationInput;
  where: CareBenefitUsageToInvoiceLineItemScalarWhereInput;
};

export type CareBenefitUsageToInvoiceLineItemUpdateManyWithoutAssociatedInvoiceNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutAssociatedInvoiceInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutAssociatedInvoiceInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyAssociatedInvoiceInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutAssociatedInvoiceInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutAssociatedInvoiceInput>>;
  upsert?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutAssociatedInvoiceInput>>;
};

export type CareBenefitUsageToInvoiceLineItemUpdateManyWithoutCareBenefitUsageNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutCareBenefitUsageInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutCareBenefitUsageInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyCareBenefitUsageInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutCareBenefitUsageInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutCareBenefitUsageInput>>;
  upsert?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutCareBenefitUsageInput>>;
};

export type CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutConfirmedByInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutConfirmedByInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyConfirmedByInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutConfirmedByInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutConfirmedByInput>>;
  upsert?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutConfirmedByInput>>;
};

export type CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutDraftServiceInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutDraftServiceInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyDraftServiceInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutDraftServiceInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutDraftServiceInput>>;
  upsert?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutDraftServiceInput>>;
};

export type CareBenefitUsageToInvoiceLineItemUpdateManyWithoutInvoiceLineItemNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateOrConnectWithoutInvoiceLineItemInput>>;
  create?: Maybe<Array<CareBenefitUsageToInvoiceLineItemCreateWithoutInvoiceLineItemInput>>;
  createMany?: Maybe<CareBenefitUsageToInvoiceLineItemCreateManyInvoiceLineItemInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutInvoiceLineItemInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpdateManyWithWhereWithoutInvoiceLineItemInput>>;
  upsert?: Maybe<Array<CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutInvoiceLineItemInput>>;
};

export type CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutAssociatedInvoiceInput = {
  data: CareBenefitUsageToInvoiceLineItemUpdateWithoutAssociatedInvoiceInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutCareBenefitUsageInput = {
  data: CareBenefitUsageToInvoiceLineItemUpdateWithoutCareBenefitUsageInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutConfirmedByInput = {
  data: CareBenefitUsageToInvoiceLineItemUpdateWithoutConfirmedByInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutDraftServiceInput = {
  data: CareBenefitUsageToInvoiceLineItemUpdateWithoutDraftServiceInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemUpdateWithWhereUniqueWithoutInvoiceLineItemInput = {
  data: CareBenefitUsageToInvoiceLineItemUpdateWithoutInvoiceLineItemInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemUpdateWithoutAssociatedInvoiceInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  careBenefitUsage?: Maybe<CareBenefitUsageUpdateOneRequiredWithoutInvoiceLineItemConnectionsNestedInput>;
  confirmedBy?: Maybe<UserUpdateOneWithoutCareBenefitUsageToInvoiceLineItemsNestedInput>;
  draftService?: Maybe<ServiceUpdateOneWithoutDraftCareBenefitUsageToInvoiceLineItemsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutConnectedCareBenefitsNestedInput>;
};

export type CareBenefitUsageToInvoiceLineItemUpdateWithoutCareBenefitUsageInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoice?: Maybe<InvoiceUpdateOneWithoutAssociatedCareBenefitCreditsNestedInput>;
  confirmedBy?: Maybe<UserUpdateOneWithoutCareBenefitUsageToInvoiceLineItemsNestedInput>;
  draftService?: Maybe<ServiceUpdateOneWithoutDraftCareBenefitUsageToInvoiceLineItemsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutConnectedCareBenefitsNestedInput>;
};

export type CareBenefitUsageToInvoiceLineItemUpdateWithoutConfirmedByInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoice?: Maybe<InvoiceUpdateOneWithoutAssociatedCareBenefitCreditsNestedInput>;
  careBenefitUsage?: Maybe<CareBenefitUsageUpdateOneRequiredWithoutInvoiceLineItemConnectionsNestedInput>;
  draftService?: Maybe<ServiceUpdateOneWithoutDraftCareBenefitUsageToInvoiceLineItemsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutConnectedCareBenefitsNestedInput>;
};

export type CareBenefitUsageToInvoiceLineItemUpdateWithoutDraftServiceInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoice?: Maybe<InvoiceUpdateOneWithoutAssociatedCareBenefitCreditsNestedInput>;
  careBenefitUsage?: Maybe<CareBenefitUsageUpdateOneRequiredWithoutInvoiceLineItemConnectionsNestedInput>;
  confirmedBy?: Maybe<UserUpdateOneWithoutCareBenefitUsageToInvoiceLineItemsNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItem?: Maybe<InvoiceLineItemUpdateOneWithoutConnectedCareBenefitsNestedInput>;
};

export type CareBenefitUsageToInvoiceLineItemUpdateWithoutInvoiceLineItemInput = {
  adjustedAmount?: Maybe<Scalars['Int']>;
  associatedInvoice?: Maybe<InvoiceUpdateOneWithoutAssociatedCareBenefitCreditsNestedInput>;
  careBenefitUsage?: Maybe<CareBenefitUsageUpdateOneRequiredWithoutInvoiceLineItemConnectionsNestedInput>;
  confirmedBy?: Maybe<UserUpdateOneWithoutCareBenefitUsageToInvoiceLineItemsNestedInput>;
  draftService?: Maybe<ServiceUpdateOneWithoutDraftCareBenefitUsageToInvoiceLineItemsNestedInput>;
  id?: Maybe<Scalars['String']>;
};

export type CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutAssociatedInvoiceInput = {
  create: CareBenefitUsageToInvoiceLineItemCreateWithoutAssociatedInvoiceInput;
  update: CareBenefitUsageToInvoiceLineItemUpdateWithoutAssociatedInvoiceInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutCareBenefitUsageInput = {
  create: CareBenefitUsageToInvoiceLineItemCreateWithoutCareBenefitUsageInput;
  update: CareBenefitUsageToInvoiceLineItemUpdateWithoutCareBenefitUsageInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutConfirmedByInput = {
  create: CareBenefitUsageToInvoiceLineItemCreateWithoutConfirmedByInput;
  update: CareBenefitUsageToInvoiceLineItemUpdateWithoutConfirmedByInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutDraftServiceInput = {
  create: CareBenefitUsageToInvoiceLineItemCreateWithoutDraftServiceInput;
  update: CareBenefitUsageToInvoiceLineItemUpdateWithoutDraftServiceInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemUpsertWithWhereUniqueWithoutInvoiceLineItemInput = {
  create: CareBenefitUsageToInvoiceLineItemCreateWithoutInvoiceLineItemInput;
  update: CareBenefitUsageToInvoiceLineItemUpdateWithoutInvoiceLineItemInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};

export type CareBenefitUsageToInvoiceLineItemWhereInput = {
  AND?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereInput>>;
  adjustedAmount?: Maybe<IntFilter>;
  associatedInvoice?: Maybe<InvoiceNullableScalarRelationFilter>;
  associatedInvoiceId?: Maybe<StringNullableFilter>;
  careBenefitUsage?: Maybe<CareBenefitUsageScalarRelationFilter>;
  careBenefitUsageId?: Maybe<StringFilter>;
  confirmedBy?: Maybe<UserNullableScalarRelationFilter>;
  confirmedByUserId?: Maybe<StringNullableFilter>;
  draftService?: Maybe<ServiceNullableScalarRelationFilter>;
  draftServiceId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invoiceLineItem?: Maybe<InvoiceLineItemNullableScalarRelationFilter>;
  invoiceLineItemId?: Maybe<StringNullableFilter>;
};

export type CareBenefitUsageToInvoiceLineItemWhereUniqueInput = {
  AND?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageToInvoiceLineItemWhereInput>>;
  adjustedAmount?: Maybe<IntFilter>;
  associatedInvoice?: Maybe<InvoiceNullableScalarRelationFilter>;
  associatedInvoiceId?: Maybe<StringNullableFilter>;
  careBenefitUsage?: Maybe<CareBenefitUsageScalarRelationFilter>;
  careBenefitUsageId?: Maybe<StringFilter>;
  careBenefitUsageId_invoiceLineItemId?: Maybe<CareBenefitUsageToInvoiceLineItemCareBenefitUsageIdInvoiceLineItemIdCompoundUniqueInput>;
  confirmedBy?: Maybe<UserNullableScalarRelationFilter>;
  confirmedByUserId?: Maybe<StringNullableFilter>;
  draftService?: Maybe<ServiceNullableScalarRelationFilter>;
  draftServiceId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItem?: Maybe<InvoiceLineItemNullableScalarRelationFilter>;
  invoiceLineItemId?: Maybe<StringNullableFilter>;
};

export type CareBenefitUsageUncheckedCreateInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageUncheckedCreateNestedManyWithoutBenefitInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutBenefitInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyBenefitInputEnvelope>;
};

export type CareBenefitUsageUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutCareAccountCreditIntentInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutCareAccountCreditIntentInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyCareAccountCreditIntentInputEnvelope>;
};

export type CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedAddonEnrollmentInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutConnectedAddonEnrollmentInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutConnectedAddonEnrollmentInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyConnectedAddonEnrollmentInputEnvelope>;
};

export type CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutConnectedPlanEnrollmentInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutConnectedPlanEnrollmentInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyConnectedPlanEnrollmentInputEnvelope>;
};

export type CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutRecordedByUserInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutRecordedByUserInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyRecordedByUserInputEnvelope>;
};

export type CareBenefitUsageUncheckedCreateNestedManyWithoutRelatedFollowupStepInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutRelatedFollowupStepInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutRelatedFollowupStepInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyRelatedFollowupStepInputEnvelope>;
};

export type CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutUsageClinicInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutUsageClinicInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyUsageClinicInputEnvelope>;
};

export type CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutUsageClinicPetInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutUsageClinicPetInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyUsageClinicPetInputEnvelope>;
};

export type CareBenefitUsageUncheckedCreateWithoutBenefitInput = {
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageUncheckedCreateWithoutCareAccountCreditIntentInput = {
  benefitId: Scalars['String'];
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageUncheckedCreateWithoutConnectedAddonEnrollmentInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageUncheckedCreateWithoutConnectedPlanEnrollmentInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageUncheckedCreateWithoutInvoiceLineItemConnectionsInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageUncheckedCreateWithoutRecordedByUserInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageUncheckedCreateWithoutRelatedFollowupStepInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageUncheckedCreateWithoutUsageClinicInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageUncheckedCreateWithoutUsageClinicPetInput = {
  benefitId: Scalars['String'];
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutCareBenefitUsageInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CareBenefitUsageUncheckedUpdateInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateManyInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutBenefitInput = {
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutBenefitNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutBenefitInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyBenefitInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutBenefitInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutBenefitInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutBenefitInput>>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutCareAccountCreditIntentInput = {
  benefitId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutCareAccountCreditIntentInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutCareAccountCreditIntentInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyCareAccountCreditIntentInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutCareAccountCreditIntentInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutCareAccountCreditIntentInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutCareAccountCreditIntentInput>>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutConnectedAddonEnrollmentInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutConnectedAddonEnrollmentNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutConnectedAddonEnrollmentInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutConnectedAddonEnrollmentInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyConnectedAddonEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutConnectedAddonEnrollmentInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutConnectedAddonEnrollmentInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutConnectedAddonEnrollmentInput>>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutConnectedPlanEnrollmentInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutConnectedPlanEnrollmentInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyConnectedPlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutConnectedPlanEnrollmentInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutConnectedPlanEnrollmentInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutConnectedPlanEnrollmentInput>>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutRecordedByUserInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutRecordedByUserInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyRecordedByUserInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutRecordedByUserInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutRecordedByUserInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutRecordedByUserInput>>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutRelatedFollowupStepInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutRelatedFollowupStepNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutRelatedFollowupStepInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutRelatedFollowupStepInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyRelatedFollowupStepInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutRelatedFollowupStepInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutRelatedFollowupStepInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutRelatedFollowupStepInput>>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutUsageClinicInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutUsageClinicInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyUsageClinicInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutUsageClinicInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutUsageClinicInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutUsageClinicInput>>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutUsageClinicPetInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutUsageClinicPetInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyUsageClinicPetInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutUsageClinicPetInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutUsageClinicPetInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutUsageClinicPetInput>>;
};

export type CareBenefitUsageUncheckedUpdateWithoutBenefitInput = {
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateWithoutCareAccountCreditIntentInput = {
  benefitId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateWithoutConnectedAddonEnrollmentInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateWithoutConnectedPlanEnrollmentInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateWithoutInvoiceLineItemConnectionsInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateWithoutRecordedByUserInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateWithoutRelatedFollowupStepInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateWithoutUsageClinicInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicPetId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUncheckedUpdateWithoutUsageClinicPetInput = {
  benefitId?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUpdateInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutUsagesNestedInput>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutCareBenefitUsagesNestedInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserUpdateOneWithoutUsagesRecordedNestedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutRelatedUsagesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic?: Maybe<ClinicUpdateOneRequiredWithoutBenefitsProvidedNestedInput>;
  usageClinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutCareBenefitUsagesNestedInput>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUpdateManyWithWhereWithoutBenefitInput = {
  data: CareBenefitUsageUpdateManyMutationInput;
  where: CareBenefitUsageScalarWhereInput;
};

export type CareBenefitUsageUpdateManyWithWhereWithoutCareAccountCreditIntentInput = {
  data: CareBenefitUsageUpdateManyMutationInput;
  where: CareBenefitUsageScalarWhereInput;
};

export type CareBenefitUsageUpdateManyWithWhereWithoutConnectedAddonEnrollmentInput = {
  data: CareBenefitUsageUpdateManyMutationInput;
  where: CareBenefitUsageScalarWhereInput;
};

export type CareBenefitUsageUpdateManyWithWhereWithoutConnectedPlanEnrollmentInput = {
  data: CareBenefitUsageUpdateManyMutationInput;
  where: CareBenefitUsageScalarWhereInput;
};

export type CareBenefitUsageUpdateManyWithWhereWithoutRecordedByUserInput = {
  data: CareBenefitUsageUpdateManyMutationInput;
  where: CareBenefitUsageScalarWhereInput;
};

export type CareBenefitUsageUpdateManyWithWhereWithoutRelatedFollowupStepInput = {
  data: CareBenefitUsageUpdateManyMutationInput;
  where: CareBenefitUsageScalarWhereInput;
};

export type CareBenefitUsageUpdateManyWithWhereWithoutUsageClinicInput = {
  data: CareBenefitUsageUpdateManyMutationInput;
  where: CareBenefitUsageScalarWhereInput;
};

export type CareBenefitUsageUpdateManyWithWhereWithoutUsageClinicPetInput = {
  data: CareBenefitUsageUpdateManyMutationInput;
  where: CareBenefitUsageScalarWhereInput;
};

export type CareBenefitUsageUpdateManyWithoutBenefitNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutBenefitInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyBenefitInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutBenefitInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutBenefitInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutBenefitInput>>;
};

export type CareBenefitUsageUpdateManyWithoutCareAccountCreditIntentNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutCareAccountCreditIntentInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutCareAccountCreditIntentInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyCareAccountCreditIntentInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutCareAccountCreditIntentInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutCareAccountCreditIntentInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutCareAccountCreditIntentInput>>;
};

export type CareBenefitUsageUpdateManyWithoutConnectedAddonEnrollmentNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutConnectedAddonEnrollmentInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutConnectedAddonEnrollmentInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyConnectedAddonEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutConnectedAddonEnrollmentInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutConnectedAddonEnrollmentInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutConnectedAddonEnrollmentInput>>;
};

export type CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutConnectedPlanEnrollmentInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutConnectedPlanEnrollmentInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyConnectedPlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutConnectedPlanEnrollmentInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutConnectedPlanEnrollmentInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutConnectedPlanEnrollmentInput>>;
};

export type CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutRecordedByUserInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutRecordedByUserInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyRecordedByUserInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutRecordedByUserInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutRecordedByUserInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutRecordedByUserInput>>;
};

export type CareBenefitUsageUpdateManyWithoutRelatedFollowupStepNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutRelatedFollowupStepInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutRelatedFollowupStepInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyRelatedFollowupStepInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutRelatedFollowupStepInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutRelatedFollowupStepInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutRelatedFollowupStepInput>>;
};

export type CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutUsageClinicInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutUsageClinicInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyUsageClinicInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutUsageClinicInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutUsageClinicInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutUsageClinicInput>>;
};

export type CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput = {
  connect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareBenefitUsageCreateOrConnectWithoutUsageClinicPetInput>>;
  create?: Maybe<Array<CareBenefitUsageCreateWithoutUsageClinicPetInput>>;
  createMany?: Maybe<CareBenefitUsageCreateManyUsageClinicPetInputEnvelope>;
  delete?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareBenefitUsageScalarWhereInput>>;
  disconnect?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  set?: Maybe<Array<CareBenefitUsageWhereUniqueInput>>;
  update?: Maybe<Array<CareBenefitUsageUpdateWithWhereUniqueWithoutUsageClinicPetInput>>;
  updateMany?: Maybe<Array<CareBenefitUsageUpdateManyWithWhereWithoutUsageClinicPetInput>>;
  upsert?: Maybe<Array<CareBenefitUsageUpsertWithWhereUniqueWithoutUsageClinicPetInput>>;
};

export type CareBenefitUsageUpdateOneRequiredWithoutInvoiceLineItemConnectionsNestedInput = {
  connect?: Maybe<CareBenefitUsageWhereUniqueInput>;
  connectOrCreate?: Maybe<CareBenefitUsageCreateOrConnectWithoutInvoiceLineItemConnectionsInput>;
  create?: Maybe<CareBenefitUsageCreateWithoutInvoiceLineItemConnectionsInput>;
  update?: Maybe<CareBenefitUsageUpdateToOneWithWhereWithoutInvoiceLineItemConnectionsInput>;
  upsert?: Maybe<CareBenefitUsageUpsertWithoutInvoiceLineItemConnectionsInput>;
};

export type CareBenefitUsageUpdateToOneWithWhereWithoutInvoiceLineItemConnectionsInput = {
  data: CareBenefitUsageUpdateWithoutInvoiceLineItemConnectionsInput;
  where?: Maybe<CareBenefitUsageWhereInput>;
};

export type CareBenefitUsageUpdateWithWhereUniqueWithoutBenefitInput = {
  data: CareBenefitUsageUpdateWithoutBenefitInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpdateWithWhereUniqueWithoutCareAccountCreditIntentInput = {
  data: CareBenefitUsageUpdateWithoutCareAccountCreditIntentInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpdateWithWhereUniqueWithoutConnectedAddonEnrollmentInput = {
  data: CareBenefitUsageUpdateWithoutConnectedAddonEnrollmentInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpdateWithWhereUniqueWithoutConnectedPlanEnrollmentInput = {
  data: CareBenefitUsageUpdateWithoutConnectedPlanEnrollmentInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpdateWithWhereUniqueWithoutRecordedByUserInput = {
  data: CareBenefitUsageUpdateWithoutRecordedByUserInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpdateWithWhereUniqueWithoutRelatedFollowupStepInput = {
  data: CareBenefitUsageUpdateWithoutRelatedFollowupStepInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpdateWithWhereUniqueWithoutUsageClinicInput = {
  data: CareBenefitUsageUpdateWithoutUsageClinicInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpdateWithWhereUniqueWithoutUsageClinicPetInput = {
  data: CareBenefitUsageUpdateWithoutUsageClinicPetInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpdateWithoutBenefitInput = {
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutCareBenefitUsagesNestedInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserUpdateOneWithoutUsagesRecordedNestedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutRelatedUsagesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic?: Maybe<ClinicUpdateOneRequiredWithoutBenefitsProvidedNestedInput>;
  usageClinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutCareBenefitUsagesNestedInput>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUpdateWithoutCareAccountCreditIntentInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutUsagesNestedInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserUpdateOneWithoutUsagesRecordedNestedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutRelatedUsagesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic?: Maybe<ClinicUpdateOneRequiredWithoutBenefitsProvidedNestedInput>;
  usageClinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutCareBenefitUsagesNestedInput>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUpdateWithoutConnectedAddonEnrollmentInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutUsagesNestedInput>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutCareBenefitUsagesNestedInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserUpdateOneWithoutUsagesRecordedNestedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutRelatedUsagesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic?: Maybe<ClinicUpdateOneRequiredWithoutBenefitsProvidedNestedInput>;
  usageClinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutCareBenefitUsagesNestedInput>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUpdateWithoutConnectedPlanEnrollmentInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutUsagesNestedInput>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutCareBenefitUsagesNestedInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserUpdateOneWithoutUsagesRecordedNestedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutRelatedUsagesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic?: Maybe<ClinicUpdateOneRequiredWithoutBenefitsProvidedNestedInput>;
  usageClinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutCareBenefitUsagesNestedInput>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUpdateWithoutInvoiceLineItemConnectionsInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutUsagesNestedInput>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutCareBenefitUsagesNestedInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserUpdateOneWithoutUsagesRecordedNestedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutRelatedUsagesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic?: Maybe<ClinicUpdateOneRequiredWithoutBenefitsProvidedNestedInput>;
  usageClinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutCareBenefitUsagesNestedInput>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUpdateWithoutRecordedByUserInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutUsagesNestedInput>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutCareBenefitUsagesNestedInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutRelatedUsagesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic?: Maybe<ClinicUpdateOneRequiredWithoutBenefitsProvidedNestedInput>;
  usageClinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutCareBenefitUsagesNestedInput>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUpdateWithoutRelatedFollowupStepInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutUsagesNestedInput>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutCareBenefitUsagesNestedInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserUpdateOneWithoutUsagesRecordedNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic?: Maybe<ClinicUpdateOneRequiredWithoutBenefitsProvidedNestedInput>;
  usageClinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutCareBenefitUsagesNestedInput>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUpdateWithoutUsageClinicInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutUsagesNestedInput>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutCareBenefitUsagesNestedInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserUpdateOneWithoutUsagesRecordedNestedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutRelatedUsagesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutCareBenefitUsagesNestedInput>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUpdateWithoutUsageClinicPetInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutUsagesNestedInput>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutCareBenefitUsagesNestedInput>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutCareBenefitUsageNestedInput>;
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<UserUpdateOneWithoutUsagesRecordedNestedInput>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepUpdateOneWithoutRelatedUsagesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageClinic?: Maybe<ClinicUpdateOneRequiredWithoutBenefitsProvidedNestedInput>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

export type CareBenefitUsageUpsertWithWhereUniqueWithoutBenefitInput = {
  create: CareBenefitUsageCreateWithoutBenefitInput;
  update: CareBenefitUsageUpdateWithoutBenefitInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpsertWithWhereUniqueWithoutCareAccountCreditIntentInput = {
  create: CareBenefitUsageCreateWithoutCareAccountCreditIntentInput;
  update: CareBenefitUsageUpdateWithoutCareAccountCreditIntentInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpsertWithWhereUniqueWithoutConnectedAddonEnrollmentInput = {
  create: CareBenefitUsageCreateWithoutConnectedAddonEnrollmentInput;
  update: CareBenefitUsageUpdateWithoutConnectedAddonEnrollmentInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpsertWithWhereUniqueWithoutConnectedPlanEnrollmentInput = {
  create: CareBenefitUsageCreateWithoutConnectedPlanEnrollmentInput;
  update: CareBenefitUsageUpdateWithoutConnectedPlanEnrollmentInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpsertWithWhereUniqueWithoutRecordedByUserInput = {
  create: CareBenefitUsageCreateWithoutRecordedByUserInput;
  update: CareBenefitUsageUpdateWithoutRecordedByUserInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpsertWithWhereUniqueWithoutRelatedFollowupStepInput = {
  create: CareBenefitUsageCreateWithoutRelatedFollowupStepInput;
  update: CareBenefitUsageUpdateWithoutRelatedFollowupStepInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpsertWithWhereUniqueWithoutUsageClinicInput = {
  create: CareBenefitUsageCreateWithoutUsageClinicInput;
  update: CareBenefitUsageUpdateWithoutUsageClinicInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpsertWithWhereUniqueWithoutUsageClinicPetInput = {
  create: CareBenefitUsageCreateWithoutUsageClinicPetInput;
  update: CareBenefitUsageUpdateWithoutUsageClinicPetInput;
  where: CareBenefitUsageWhereUniqueInput;
};

export type CareBenefitUsageUpsertWithoutInvoiceLineItemConnectionsInput = {
  create: CareBenefitUsageCreateWithoutInvoiceLineItemConnectionsInput;
  update: CareBenefitUsageUpdateWithoutInvoiceLineItemConnectionsInput;
  where?: Maybe<CareBenefitUsageWhereInput>;
};

export type CareBenefitUsageWhereInput = {
  AND?: Maybe<Array<CareBenefitUsageWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageWhereInput>>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentNullableScalarRelationFilter>;
  careAccountCreditIntentId?: Maybe<StringNullableFilter>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentNullableScalarRelationFilter>;
  connectedAddonEnrollmentId?: Maybe<StringNullableFilter>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  connectedPlanEnrollmentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  exhaustsBenefit?: Maybe<BoolNullableFilter>;
  id?: Maybe<StringFilter>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  quantityUsed?: Maybe<IntNullableFilter>;
  reason?: Maybe<StringNullableFilter>;
  recordedByUser?: Maybe<UserNullableScalarRelationFilter>;
  recordedByUserId?: Maybe<StringNullableFilter>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepNullableScalarRelationFilter>;
  relatedFollowupStepId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  usageClinic?: Maybe<ClinicScalarRelationFilter>;
  usageClinicId?: Maybe<StringFilter>;
  usageClinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  usageClinicPetId?: Maybe<StringFilter>;
  usedAt?: Maybe<DateTimeFilter>;
};

export type CareBenefitUsageWhereUniqueInput = {
  AND?: Maybe<Array<CareBenefitUsageWhereInput>>;
  NOT?: Maybe<Array<CareBenefitUsageWhereInput>>;
  OR?: Maybe<Array<CareBenefitUsageWhereInput>>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentNullableScalarRelationFilter>;
  careAccountCreditIntentId?: Maybe<StringNullableFilter>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollmentNullableScalarRelationFilter>;
  connectedAddonEnrollmentId?: Maybe<StringNullableFilter>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  connectedPlanEnrollmentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  exhaustsBenefit?: Maybe<BoolNullableFilter>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemConnections?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  quantityUsed?: Maybe<IntNullableFilter>;
  reason?: Maybe<StringNullableFilter>;
  recordedByUser?: Maybe<UserNullableScalarRelationFilter>;
  recordedByUserId?: Maybe<StringNullableFilter>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStepNullableScalarRelationFilter>;
  relatedFollowupStepId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  usageClinic?: Maybe<ClinicScalarRelationFilter>;
  usageClinicId?: Maybe<StringFilter>;
  usageClinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  usageClinicPetId?: Maybe<StringFilter>;
  usedAt?: Maybe<DateTimeFilter>;
};

export type CareBenefitWhereInput = {
  AND?: Maybe<Array<CareBenefitWhereInput>>;
  NOT?: Maybe<Array<CareBenefitWhereInput>>;
  OR?: Maybe<Array<CareBenefitWhereInput>>;
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitListRelationFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  editorNotes?: Maybe<StringFilter>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverListRelationFilter>;
  exhaustible?: Maybe<BoolFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceListRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  planBenefits?: Maybe<CarePlanBenefitListRelationFilter>;
  providedDiscountPercentage?: Maybe<IntNullableFilter>;
  providesTeletriage?: Maybe<BoolFilter>;
  reportingExpectedValue?: Maybe<IntFilter>;
  tangible?: Maybe<BoolFilter>;
  title?: Maybe<StringFilter>;
  type?: Maybe<EnumCareBenefitTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  usageUnitOfMeasure?: Maybe<EnumCareBenefitUnitOfMeasureNullableFilter>;
  usages?: Maybe<CareBenefitUsageListRelationFilter>;
};

export type CareBenefitWhereUniqueInput = {
  AND?: Maybe<Array<CareBenefitWhereInput>>;
  NOT?: Maybe<Array<CareBenefitWhereInput>>;
  OR?: Maybe<Array<CareBenefitWhereInput>>;
  addonPackageBenefits?: Maybe<CareAddonPackageBenefitListRelationFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  connectedServiceCategories?: Maybe<OrganizationCareBenefitToClinicServiceCategoryListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  editorNotes?: Maybe<StringFilter>;
  enrollmentCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverListRelationFilter>;
  exhaustible?: Maybe<BoolFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceListRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  planBenefits?: Maybe<CarePlanBenefitListRelationFilter>;
  providedDiscountPercentage?: Maybe<IntNullableFilter>;
  providesTeletriage?: Maybe<BoolFilter>;
  reportingExpectedValue?: Maybe<IntFilter>;
  tangible?: Maybe<BoolFilter>;
  title?: Maybe<StringFilter>;
  type?: Maybe<EnumCareBenefitTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  usageUnitOfMeasure?: Maybe<EnumCareBenefitUnitOfMeasureNullableFilter>;
  usages?: Maybe<CareBenefitUsageListRelationFilter>;
};

export type CareClinicInfo = {
  __typename?: 'CareClinicInfo';
  careEnabled?: Maybe<Scalars['Boolean']>;
  enabledFeatureFlags: Array<Scalars['String']>;
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<CareOrganizationInfo>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type CareCreditPreapprovalCheck = {
  __typename?: 'CareCreditPreapprovalCheck';
  _count: CareCreditPreapprovalCheckCountOutputType;
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRun?: Maybe<AutomationRun>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  decision?: Maybe<CareCreditPreapprovalDecision>;
  /** Differs from createdAt when the original response was a 202 */
  decisionReachedAt: Scalars['DateTime'];
  events: Array<SynchronyEvent>;
  id: Scalars['String'];
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  /** Primarily used to poll for application status after an initial 202 response */
  offerExternalId?: Maybe<Scalars['String']>;
  /** The pet parent's personalized URL to view their offer */
  preapprovalUrl?: Maybe<Scalars['String']>;
  /** Synchrony Patient Data Service reference ID */
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody: Scalars['Json'];
  responseBody: Scalars['Json'];
  responseStatusCode: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type CareCreditPreapprovalCheckAutomationRunArgs = {
  where?: Maybe<AutomationRunWhereInput>;
};


export type CareCreditPreapprovalCheckEventsArgs = {
  cursor?: Maybe<SynchronyEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SynchronyEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SynchronyEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SynchronyEventWhereInput>;
};

export type CareCreditPreapprovalCheckAvgAggregateOutputType = {
  __typename?: 'CareCreditPreapprovalCheckAvgAggregateOutputType';
  responseStatusCode?: Maybe<Scalars['Float']>;
};

export type CareCreditPreapprovalCheckAvgOrderByAggregateInput = {
  responseStatusCode?: Maybe<SortOrder>;
};

export type CareCreditPreapprovalCheckCountAggregateOutputType = {
  __typename?: 'CareCreditPreapprovalCheckCountAggregateOutputType';
  _all: Scalars['Int'];
  applicationStatus: Scalars['Int'];
  applicationStatusUpdatedAt: Scalars['Int'];
  automationRunId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  decision: Scalars['Int'];
  decisionReachedAt: Scalars['Int'];
  id: Scalars['Int'];
  offerExpiresAt: Scalars['Int'];
  offerExternalId: Scalars['Int'];
  preapprovalUrl: Scalars['Int'];
  referenceExternalId: Scalars['Int'];
  requestBody: Scalars['Int'];
  responseBody: Scalars['Int'];
  responseStatusCode: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CareCreditPreapprovalCheckCountOrderByAggregateInput = {
  applicationStatus?: Maybe<SortOrder>;
  applicationStatusUpdatedAt?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  decision?: Maybe<SortOrder>;
  decisionReachedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  offerExpiresAt?: Maybe<SortOrder>;
  offerExternalId?: Maybe<SortOrder>;
  preapprovalUrl?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  responseBody?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareCreditPreapprovalCheckCountOutputType = {
  __typename?: 'CareCreditPreapprovalCheckCountOutputType';
  events: Scalars['Int'];
};

export type CareCreditPreapprovalCheckCreateInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutCareCreditPreapprovalCheckInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutCareCreditPreapprovalChecksInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<SynchronyEventCreateNestedManyWithoutCareCreditPreapprovalCheckInput>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckCreateManyClinicPetParentInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckCreateManyClinicPetParentInputEnvelope = {
  data: Array<CareCreditPreapprovalCheckCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareCreditPreapprovalCheckCreateManyInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<CareCreditPreapprovalCheckWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareCreditPreapprovalCheckCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CareCreditPreapprovalCheckCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CareCreditPreapprovalCheckCreateManyClinicPetParentInputEnvelope>;
};

export type CareCreditPreapprovalCheckCreateNestedOneWithoutAutomationRunInput = {
  connect?: Maybe<CareCreditPreapprovalCheckWhereUniqueInput>;
  connectOrCreate?: Maybe<CareCreditPreapprovalCheckCreateOrConnectWithoutAutomationRunInput>;
  create?: Maybe<CareCreditPreapprovalCheckCreateWithoutAutomationRunInput>;
};

export type CareCreditPreapprovalCheckCreateNestedOneWithoutEventsInput = {
  connect?: Maybe<CareCreditPreapprovalCheckWhereUniqueInput>;
  connectOrCreate?: Maybe<CareCreditPreapprovalCheckCreateOrConnectWithoutEventsInput>;
  create?: Maybe<CareCreditPreapprovalCheckCreateWithoutEventsInput>;
};

export type CareCreditPreapprovalCheckCreateOrConnectWithoutAutomationRunInput = {
  create: CareCreditPreapprovalCheckCreateWithoutAutomationRunInput;
  where: CareCreditPreapprovalCheckWhereUniqueInput;
};

export type CareCreditPreapprovalCheckCreateOrConnectWithoutClinicPetParentInput = {
  create: CareCreditPreapprovalCheckCreateWithoutClinicPetParentInput;
  where: CareCreditPreapprovalCheckWhereUniqueInput;
};

export type CareCreditPreapprovalCheckCreateOrConnectWithoutEventsInput = {
  create: CareCreditPreapprovalCheckCreateWithoutEventsInput;
  where: CareCreditPreapprovalCheckWhereUniqueInput;
};

export type CareCreditPreapprovalCheckCreateWithoutAutomationRunInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutCareCreditPreapprovalChecksInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<SynchronyEventCreateNestedManyWithoutCareCreditPreapprovalCheckInput>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckCreateWithoutClinicPetParentInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutCareCreditPreapprovalCheckInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<SynchronyEventCreateNestedManyWithoutCareCreditPreapprovalCheckInput>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckCreateWithoutEventsInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutCareCreditPreapprovalCheckInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutCareCreditPreapprovalChecksInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckGroupByOutputType = {
  __typename?: 'CareCreditPreapprovalCheckGroupByOutputType';
  _avg?: Maybe<CareCreditPreapprovalCheckAvgAggregateOutputType>;
  _count?: Maybe<CareCreditPreapprovalCheckCountAggregateOutputType>;
  _max?: Maybe<CareCreditPreapprovalCheckMaxAggregateOutputType>;
  _min?: Maybe<CareCreditPreapprovalCheckMinAggregateOutputType>;
  _sum?: Maybe<CareCreditPreapprovalCheckSumAggregateOutputType>;
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt: Scalars['DateTime'];
  id: Scalars['String'];
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody: Scalars['Json'];
  responseBody: Scalars['Json'];
  responseStatusCode: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CareCreditPreapprovalCheckListRelationFilter = {
  every?: Maybe<CareCreditPreapprovalCheckWhereInput>;
  none?: Maybe<CareCreditPreapprovalCheckWhereInput>;
  some?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};

export type CareCreditPreapprovalCheckMaxAggregateOutputType = {
  __typename?: 'CareCreditPreapprovalCheckMaxAggregateOutputType';
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckMaxOrderByAggregateInput = {
  applicationStatus?: Maybe<SortOrder>;
  applicationStatusUpdatedAt?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  decision?: Maybe<SortOrder>;
  decisionReachedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  offerExpiresAt?: Maybe<SortOrder>;
  offerExternalId?: Maybe<SortOrder>;
  preapprovalUrl?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareCreditPreapprovalCheckMinAggregateOutputType = {
  __typename?: 'CareCreditPreapprovalCheckMinAggregateOutputType';
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckMinOrderByAggregateInput = {
  applicationStatus?: Maybe<SortOrder>;
  applicationStatusUpdatedAt?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  decision?: Maybe<SortOrder>;
  decisionReachedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  offerExpiresAt?: Maybe<SortOrder>;
  offerExternalId?: Maybe<SortOrder>;
  preapprovalUrl?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareCreditPreapprovalCheckNullableScalarRelationFilter = {
  AND?: Maybe<Array<CareCreditPreapprovalCheckWhereInput>>;
  NOT?: Maybe<Array<CareCreditPreapprovalCheckWhereInput>>;
  OR?: Maybe<Array<CareCreditPreapprovalCheckWhereInput>>;
  applicationStatus?: Maybe<EnumSynchronyEventStatusNullableFilter>;
  applicationStatusUpdatedAt?: Maybe<DateTimeNullableFilter>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  automationRunId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  decision?: Maybe<EnumCareCreditPreapprovalDecisionNullableFilter>;
  decisionReachedAt?: Maybe<DateTimeFilter>;
  events?: Maybe<SynchronyEventListRelationFilter>;
  id?: Maybe<StringFilter>;
  offerExpiresAt?: Maybe<DateTimeNullableFilter>;
  offerExternalId?: Maybe<StringNullableFilter>;
  preapprovalUrl?: Maybe<StringNullableFilter>;
  referenceExternalId?: Maybe<StringNullableFilter>;
  requestBody?: Maybe<JsonFilter>;
  responseBody?: Maybe<JsonFilter>;
  responseStatusCode?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareCreditPreapprovalCheckOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareCreditPreapprovalCheckOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareCreditPreapprovalCheckOrderByRelevanceInput>;
  applicationStatus?: Maybe<SortOrder>;
  applicationStatusUpdatedAt?: Maybe<SortOrder>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  decision?: Maybe<SortOrder>;
  decisionReachedAt?: Maybe<SortOrder>;
  events?: Maybe<SynchronyEventOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  offerExpiresAt?: Maybe<SortOrder>;
  offerExternalId?: Maybe<SortOrder>;
  preapprovalUrl?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  responseBody?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareCreditPreapprovalCheckOrderByRelevanceFieldEnum {
  AutomationRunId = 'automationRunId',
  ClinicPetParentId = 'clinicPetParentId',
  Id = 'id',
  OfferExternalId = 'offerExternalId',
  PreapprovalUrl = 'preapprovalUrl',
  ReferenceExternalId = 'referenceExternalId'
}

export type CareCreditPreapprovalCheckOrderByRelevanceInput = {
  fields: Array<CareCreditPreapprovalCheckOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareCreditPreapprovalCheckOrderByWithAggregationInput = {
  _avg?: Maybe<CareCreditPreapprovalCheckAvgOrderByAggregateInput>;
  _count?: Maybe<CareCreditPreapprovalCheckCountOrderByAggregateInput>;
  _max?: Maybe<CareCreditPreapprovalCheckMaxOrderByAggregateInput>;
  _min?: Maybe<CareCreditPreapprovalCheckMinOrderByAggregateInput>;
  _sum?: Maybe<CareCreditPreapprovalCheckSumOrderByAggregateInput>;
  applicationStatus?: Maybe<SortOrder>;
  applicationStatusUpdatedAt?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  decision?: Maybe<SortOrder>;
  decisionReachedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  offerExpiresAt?: Maybe<SortOrder>;
  offerExternalId?: Maybe<SortOrder>;
  preapprovalUrl?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  responseBody?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareCreditPreapprovalCheckOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareCreditPreapprovalCheckOrderByRelevanceInput>;
  applicationStatus?: Maybe<SortOrder>;
  applicationStatusUpdatedAt?: Maybe<SortOrder>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  decision?: Maybe<SortOrder>;
  decisionReachedAt?: Maybe<SortOrder>;
  events?: Maybe<SynchronyEventOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  offerExpiresAt?: Maybe<SortOrder>;
  offerExternalId?: Maybe<SortOrder>;
  preapprovalUrl?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  responseBody?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareCreditPreapprovalCheckOrderByWithRelationInput = {
  _relevance?: Maybe<CareCreditPreapprovalCheckOrderByRelevanceInput>;
  applicationStatus?: Maybe<SortOrder>;
  applicationStatusUpdatedAt?: Maybe<SortOrder>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  decision?: Maybe<SortOrder>;
  decisionReachedAt?: Maybe<SortOrder>;
  events?: Maybe<SynchronyEventOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  offerExpiresAt?: Maybe<SortOrder>;
  offerExternalId?: Maybe<SortOrder>;
  preapprovalUrl?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  responseBody?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareCreditPreapprovalCheckScalarFieldEnum {
  ApplicationStatus = 'applicationStatus',
  ApplicationStatusUpdatedAt = 'applicationStatusUpdatedAt',
  AutomationRunId = 'automationRunId',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Decision = 'decision',
  DecisionReachedAt = 'decisionReachedAt',
  Id = 'id',
  OfferExpiresAt = 'offerExpiresAt',
  OfferExternalId = 'offerExternalId',
  PreapprovalUrl = 'preapprovalUrl',
  ReferenceExternalId = 'referenceExternalId',
  RequestBody = 'requestBody',
  ResponseBody = 'responseBody',
  ResponseStatusCode = 'responseStatusCode',
  UpdatedAt = 'updatedAt'
}

export type CareCreditPreapprovalCheckScalarWhereInput = {
  AND?: Maybe<Array<CareCreditPreapprovalCheckScalarWhereInput>>;
  NOT?: Maybe<Array<CareCreditPreapprovalCheckScalarWhereInput>>;
  OR?: Maybe<Array<CareCreditPreapprovalCheckScalarWhereInput>>;
  applicationStatus?: Maybe<EnumSynchronyEventStatusNullableFilter>;
  applicationStatusUpdatedAt?: Maybe<DateTimeNullableFilter>;
  automationRunId?: Maybe<StringNullableFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  decision?: Maybe<EnumCareCreditPreapprovalDecisionNullableFilter>;
  decisionReachedAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  offerExpiresAt?: Maybe<DateTimeNullableFilter>;
  offerExternalId?: Maybe<StringNullableFilter>;
  preapprovalUrl?: Maybe<StringNullableFilter>;
  referenceExternalId?: Maybe<StringNullableFilter>;
  requestBody?: Maybe<JsonFilter>;
  responseBody?: Maybe<JsonFilter>;
  responseStatusCode?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareCreditPreapprovalCheckScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareCreditPreapprovalCheckScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareCreditPreapprovalCheckScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareCreditPreapprovalCheckScalarWhereWithAggregatesInput>>;
  applicationStatus?: Maybe<EnumSynchronyEventStatusNullableWithAggregatesFilter>;
  applicationStatusUpdatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  automationRunId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  decision?: Maybe<EnumCareCreditPreapprovalDecisionNullableWithAggregatesFilter>;
  decisionReachedAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  offerExpiresAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  offerExternalId?: Maybe<StringNullableWithAggregatesFilter>;
  preapprovalUrl?: Maybe<StringNullableWithAggregatesFilter>;
  referenceExternalId?: Maybe<StringNullableWithAggregatesFilter>;
  requestBody?: Maybe<JsonWithAggregatesFilter>;
  responseBody?: Maybe<JsonWithAggregatesFilter>;
  responseStatusCode?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CareCreditPreapprovalCheckSumAggregateOutputType = {
  __typename?: 'CareCreditPreapprovalCheckSumAggregateOutputType';
  responseStatusCode?: Maybe<Scalars['Int']>;
};

export type CareCreditPreapprovalCheckSumOrderByAggregateInput = {
  responseStatusCode?: Maybe<SortOrder>;
};

export type CareCreditPreapprovalCheckUncheckedCreateInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<SynchronyEventUncheckedCreateNestedManyWithoutCareCreditPreapprovalCheckInput>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<CareCreditPreapprovalCheckWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareCreditPreapprovalCheckCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CareCreditPreapprovalCheckCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CareCreditPreapprovalCheckCreateManyClinicPetParentInputEnvelope>;
};

export type CareCreditPreapprovalCheckUncheckedCreateNestedOneWithoutAutomationRunInput = {
  connect?: Maybe<CareCreditPreapprovalCheckWhereUniqueInput>;
  connectOrCreate?: Maybe<CareCreditPreapprovalCheckCreateOrConnectWithoutAutomationRunInput>;
  create?: Maybe<CareCreditPreapprovalCheckCreateWithoutAutomationRunInput>;
};

export type CareCreditPreapprovalCheckUncheckedCreateWithoutAutomationRunInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<SynchronyEventUncheckedCreateNestedManyWithoutCareCreditPreapprovalCheckInput>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUncheckedCreateWithoutClinicPetParentInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<SynchronyEventUncheckedCreateNestedManyWithoutCareCreditPreapprovalCheckInput>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUncheckedCreateWithoutEventsInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUncheckedUpdateInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<SynchronyEventUncheckedUpdateManyWithoutCareCreditPreapprovalCheckNestedInput>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUncheckedUpdateManyInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<CareCreditPreapprovalCheckWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareCreditPreapprovalCheckCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CareCreditPreapprovalCheckCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CareCreditPreapprovalCheckCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<CareCreditPreapprovalCheckWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareCreditPreapprovalCheckScalarWhereInput>>;
  disconnect?: Maybe<Array<CareCreditPreapprovalCheckWhereUniqueInput>>;
  set?: Maybe<Array<CareCreditPreapprovalCheckWhereUniqueInput>>;
  update?: Maybe<Array<CareCreditPreapprovalCheckUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<CareCreditPreapprovalCheckUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<CareCreditPreapprovalCheckUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type CareCreditPreapprovalCheckUncheckedUpdateOneWithoutAutomationRunNestedInput = {
  connect?: Maybe<CareCreditPreapprovalCheckWhereUniqueInput>;
  connectOrCreate?: Maybe<CareCreditPreapprovalCheckCreateOrConnectWithoutAutomationRunInput>;
  create?: Maybe<CareCreditPreapprovalCheckCreateWithoutAutomationRunInput>;
  delete?: Maybe<CareCreditPreapprovalCheckWhereInput>;
  disconnect?: Maybe<CareCreditPreapprovalCheckWhereInput>;
  update?: Maybe<CareCreditPreapprovalCheckUpdateToOneWithWhereWithoutAutomationRunInput>;
  upsert?: Maybe<CareCreditPreapprovalCheckUpsertWithoutAutomationRunInput>;
};

export type CareCreditPreapprovalCheckUncheckedUpdateWithoutAutomationRunInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<SynchronyEventUncheckedUpdateManyWithoutCareCreditPreapprovalCheckNestedInput>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUncheckedUpdateWithoutClinicPetParentInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<SynchronyEventUncheckedUpdateManyWithoutCareCreditPreapprovalCheckNestedInput>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUncheckedUpdateWithoutEventsInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUpdateInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutCareCreditPreapprovalCheckNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutCareCreditPreapprovalChecksNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<SynchronyEventUpdateManyWithoutCareCreditPreapprovalCheckNestedInput>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUpdateManyMutationInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: CareCreditPreapprovalCheckUpdateManyMutationInput;
  where: CareCreditPreapprovalCheckScalarWhereInput;
};

export type CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<CareCreditPreapprovalCheckWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareCreditPreapprovalCheckCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<CareCreditPreapprovalCheckCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<CareCreditPreapprovalCheckCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<CareCreditPreapprovalCheckWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareCreditPreapprovalCheckScalarWhereInput>>;
  disconnect?: Maybe<Array<CareCreditPreapprovalCheckWhereUniqueInput>>;
  set?: Maybe<Array<CareCreditPreapprovalCheckWhereUniqueInput>>;
  update?: Maybe<Array<CareCreditPreapprovalCheckUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<CareCreditPreapprovalCheckUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<CareCreditPreapprovalCheckUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type CareCreditPreapprovalCheckUpdateOneWithoutAutomationRunNestedInput = {
  connect?: Maybe<CareCreditPreapprovalCheckWhereUniqueInput>;
  connectOrCreate?: Maybe<CareCreditPreapprovalCheckCreateOrConnectWithoutAutomationRunInput>;
  create?: Maybe<CareCreditPreapprovalCheckCreateWithoutAutomationRunInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareCreditPreapprovalCheckUpdateToOneWithWhereWithoutAutomationRunInput>;
  upsert?: Maybe<CareCreditPreapprovalCheckUpsertWithoutAutomationRunInput>;
};

export type CareCreditPreapprovalCheckUpdateOneWithoutEventsNestedInput = {
  connect?: Maybe<CareCreditPreapprovalCheckWhereUniqueInput>;
  connectOrCreate?: Maybe<CareCreditPreapprovalCheckCreateOrConnectWithoutEventsInput>;
  create?: Maybe<CareCreditPreapprovalCheckCreateWithoutEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareCreditPreapprovalCheckUpdateToOneWithWhereWithoutEventsInput>;
  upsert?: Maybe<CareCreditPreapprovalCheckUpsertWithoutEventsInput>;
};

export type CareCreditPreapprovalCheckUpdateToOneWithWhereWithoutAutomationRunInput = {
  data: CareCreditPreapprovalCheckUpdateWithoutAutomationRunInput;
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};

export type CareCreditPreapprovalCheckUpdateToOneWithWhereWithoutEventsInput = {
  data: CareCreditPreapprovalCheckUpdateWithoutEventsInput;
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};

export type CareCreditPreapprovalCheckUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: CareCreditPreapprovalCheckUpdateWithoutClinicPetParentInput;
  where: CareCreditPreapprovalCheckWhereUniqueInput;
};

export type CareCreditPreapprovalCheckUpdateWithoutAutomationRunInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutCareCreditPreapprovalChecksNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<SynchronyEventUpdateManyWithoutCareCreditPreapprovalCheckNestedInput>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUpdateWithoutClinicPetParentInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutCareCreditPreapprovalCheckNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<SynchronyEventUpdateManyWithoutCareCreditPreapprovalCheckNestedInput>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUpdateWithoutEventsInput = {
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutCareCreditPreapprovalCheckNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutCareCreditPreapprovalChecksNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareCreditPreapprovalCheckUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: CareCreditPreapprovalCheckCreateWithoutClinicPetParentInput;
  update: CareCreditPreapprovalCheckUpdateWithoutClinicPetParentInput;
  where: CareCreditPreapprovalCheckWhereUniqueInput;
};

export type CareCreditPreapprovalCheckUpsertWithoutAutomationRunInput = {
  create: CareCreditPreapprovalCheckCreateWithoutAutomationRunInput;
  update: CareCreditPreapprovalCheckUpdateWithoutAutomationRunInput;
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};

export type CareCreditPreapprovalCheckUpsertWithoutEventsInput = {
  create: CareCreditPreapprovalCheckCreateWithoutEventsInput;
  update: CareCreditPreapprovalCheckUpdateWithoutEventsInput;
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};

export type CareCreditPreapprovalCheckWhereInput = {
  AND?: Maybe<Array<CareCreditPreapprovalCheckWhereInput>>;
  NOT?: Maybe<Array<CareCreditPreapprovalCheckWhereInput>>;
  OR?: Maybe<Array<CareCreditPreapprovalCheckWhereInput>>;
  applicationStatus?: Maybe<EnumSynchronyEventStatusNullableFilter>;
  applicationStatusUpdatedAt?: Maybe<DateTimeNullableFilter>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  automationRunId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  decision?: Maybe<EnumCareCreditPreapprovalDecisionNullableFilter>;
  decisionReachedAt?: Maybe<DateTimeFilter>;
  events?: Maybe<SynchronyEventListRelationFilter>;
  id?: Maybe<StringFilter>;
  offerExpiresAt?: Maybe<DateTimeNullableFilter>;
  offerExternalId?: Maybe<StringNullableFilter>;
  preapprovalUrl?: Maybe<StringNullableFilter>;
  referenceExternalId?: Maybe<StringNullableFilter>;
  requestBody?: Maybe<JsonFilter>;
  responseBody?: Maybe<JsonFilter>;
  responseStatusCode?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareCreditPreapprovalCheckWhereUniqueInput = {
  AND?: Maybe<Array<CareCreditPreapprovalCheckWhereInput>>;
  NOT?: Maybe<Array<CareCreditPreapprovalCheckWhereInput>>;
  OR?: Maybe<Array<CareCreditPreapprovalCheckWhereInput>>;
  applicationStatus?: Maybe<EnumSynchronyEventStatusNullableFilter>;
  applicationStatusUpdatedAt?: Maybe<DateTimeNullableFilter>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  decision?: Maybe<EnumCareCreditPreapprovalDecisionNullableFilter>;
  decisionReachedAt?: Maybe<DateTimeFilter>;
  events?: Maybe<SynchronyEventListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  offerExpiresAt?: Maybe<DateTimeNullableFilter>;
  offerExternalId?: Maybe<StringNullableFilter>;
  preapprovalUrl?: Maybe<StringNullableFilter>;
  referenceExternalId?: Maybe<StringNullableFilter>;
  requestBody?: Maybe<JsonFilter>;
  responseBody?: Maybe<JsonFilter>;
  responseStatusCode?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum CareCreditPreapprovalDecision {
  Approved = 'Approved',
  Declined = 'Declined'
}

export type CareEnrollmentData = {
  __typename?: 'CareEnrollmentData';
  carePlanProviderGroupId: Scalars['String'];
  clientName: Scalars['String'];
  isRenewal: Scalars['Boolean'];
  petName: Scalars['String'];
  planName: Scalars['String'];
};

export type CareEnrollmentOutput = {
  __typename?: 'CareEnrollmentOutput';
  isEnrolled: Scalars['Boolean'];
};

export type CareEnrollmentPayment = {
  __typename?: 'CareEnrollmentPayment';
  /** the total amount of the payment (including fee if present) */
  amount: Scalars['Int'];
  /** the fee amount for the payment (part of the amount column) */
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollment?: Maybe<CareAddonEnrollment>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollment?: Maybe<CarePlanEnrollment>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disputedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDispute?: Maybe<StripeDispute>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoice>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefund?: Maybe<StripeRefund>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type CareEnrollmentPaymentCareAddonEnrollmentArgs = {
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};


export type CareEnrollmentPaymentCarePlanEnrollmentArgs = {
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type CareEnrollmentPaymentStripeDisputeArgs = {
  where?: Maybe<StripeDisputeWhereInput>;
};


export type CareEnrollmentPaymentStripeInvoiceArgs = {
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type CareEnrollmentPaymentStripeRefundArgs = {
  where?: Maybe<StripeRefundWhereInput>;
};

export type CareEnrollmentPaymentAvgAggregateOutputType = {
  __typename?: 'CareEnrollmentPaymentAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  ottoPaymentAttempts?: Maybe<Scalars['Float']>;
};

export type CareEnrollmentPaymentAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  applicationFeeAmount?: Maybe<SortOrder>;
  ottoPaymentAttempts?: Maybe<SortOrder>;
};

export type CareEnrollmentPaymentCareAddonEnrollmentIdStripeInvoiceIdCompoundUniqueInput = {
  careAddonEnrollmentId: Scalars['String'];
  stripeInvoiceId: Scalars['String'];
};

export type CareEnrollmentPaymentCarePlanEnrollmentIdStripeInvoiceIdCompoundUniqueInput = {
  carePlanEnrollmentId: Scalars['String'];
  stripeInvoiceId: Scalars['String'];
};

export type CareEnrollmentPaymentCountAggregateOutputType = {
  __typename?: 'CareEnrollmentPaymentCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  applicationFeeAmount: Scalars['Int'];
  careAddonEnrollmentId: Scalars['Int'];
  carePlanEnrollmentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  disputedAt: Scalars['Int'];
  id: Scalars['Int'];
  lastOttoPaymentAttempt: Scalars['Int'];
  lastPaymentAttempt: Scalars['Int'];
  lastPaymentError: Scalars['Int'];
  nextPaymentAttempt: Scalars['Int'];
  ottoPaymentAttempts: Scalars['Int'];
  paidAt: Scalars['Int'];
  refundedAt: Scalars['Int'];
  stripeDisputeId: Scalars['Int'];
  stripeInvoiceId: Scalars['Int'];
  stripeRefundId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CareEnrollmentPaymentCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  applicationFeeAmount?: Maybe<SortOrder>;
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastOttoPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  nextPaymentAttempt?: Maybe<SortOrder>;
  ottoPaymentAttempts?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  refundedAt?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareEnrollmentPaymentCreateInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutEnrollmentPaymentsInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutEnrollmentPaymentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutCareEnrollmentPaymentInput>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutEnrollmentPaymentInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutCareEnrollmentPaymentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentCreateManyCareAddonEnrollmentInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentCreateManyCareAddonEnrollmentInputEnvelope = {
  data: Array<CareEnrollmentPaymentCreateManyCareAddonEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareEnrollmentPaymentCreateManyCarePlanEnrollmentInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentCreateManyCarePlanEnrollmentInputEnvelope = {
  data: Array<CareEnrollmentPaymentCreateManyCarePlanEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareEnrollmentPaymentCreateManyInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentCreateManyStripeInvoiceInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentCreateManyStripeInvoiceInputEnvelope = {
  data: Array<CareEnrollmentPaymentCreateManyStripeInvoiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareEnrollmentPaymentCreateNestedManyWithoutCareAddonEnrollmentInput = {
  connect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentPaymentCreateOrConnectWithoutCareAddonEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentPaymentCreateWithoutCareAddonEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentPaymentCreateManyCareAddonEnrollmentInputEnvelope>;
};

export type CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput = {
  connect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentPaymentCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentPaymentCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentPaymentCreateManyCarePlanEnrollmentInputEnvelope>;
};

export type CareEnrollmentPaymentCreateNestedManyWithoutStripeInvoiceInput = {
  connect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentPaymentCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: Maybe<Array<CareEnrollmentPaymentCreateWithoutStripeInvoiceInput>>;
  createMany?: Maybe<CareEnrollmentPaymentCreateManyStripeInvoiceInputEnvelope>;
};

export type CareEnrollmentPaymentCreateNestedOneWithoutStripeDisputeInput = {
  connect?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareEnrollmentPaymentCreateOrConnectWithoutStripeDisputeInput>;
  create?: Maybe<CareEnrollmentPaymentCreateWithoutStripeDisputeInput>;
};

export type CareEnrollmentPaymentCreateNestedOneWithoutStripeRefundInput = {
  connect?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareEnrollmentPaymentCreateOrConnectWithoutStripeRefundInput>;
  create?: Maybe<CareEnrollmentPaymentCreateWithoutStripeRefundInput>;
};

export type CareEnrollmentPaymentCreateOrConnectWithoutCareAddonEnrollmentInput = {
  create: CareEnrollmentPaymentCreateWithoutCareAddonEnrollmentInput;
  where: CareEnrollmentPaymentWhereUniqueInput;
};

export type CareEnrollmentPaymentCreateOrConnectWithoutCarePlanEnrollmentInput = {
  create: CareEnrollmentPaymentCreateWithoutCarePlanEnrollmentInput;
  where: CareEnrollmentPaymentWhereUniqueInput;
};

export type CareEnrollmentPaymentCreateOrConnectWithoutStripeDisputeInput = {
  create: CareEnrollmentPaymentCreateWithoutStripeDisputeInput;
  where: CareEnrollmentPaymentWhereUniqueInput;
};

export type CareEnrollmentPaymentCreateOrConnectWithoutStripeInvoiceInput = {
  create: CareEnrollmentPaymentCreateWithoutStripeInvoiceInput;
  where: CareEnrollmentPaymentWhereUniqueInput;
};

export type CareEnrollmentPaymentCreateOrConnectWithoutStripeRefundInput = {
  create: CareEnrollmentPaymentCreateWithoutStripeRefundInput;
  where: CareEnrollmentPaymentWhereUniqueInput;
};

export type CareEnrollmentPaymentCreateWithoutCareAddonEnrollmentInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutEnrollmentPaymentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutCareEnrollmentPaymentInput>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutEnrollmentPaymentInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutCareEnrollmentPaymentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentCreateWithoutCarePlanEnrollmentInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutEnrollmentPaymentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutCareEnrollmentPaymentInput>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutEnrollmentPaymentInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutCareEnrollmentPaymentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentCreateWithoutStripeDisputeInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutEnrollmentPaymentsInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutEnrollmentPaymentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutEnrollmentPaymentInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutCareEnrollmentPaymentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentCreateWithoutStripeInvoiceInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutEnrollmentPaymentsInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutEnrollmentPaymentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutCareEnrollmentPaymentInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutCareEnrollmentPaymentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentCreateWithoutStripeRefundInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutEnrollmentPaymentsInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutEnrollmentPaymentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutCareEnrollmentPaymentInput>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutEnrollmentPaymentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentGroupByOutputType = {
  __typename?: 'CareEnrollmentPaymentGroupByOutputType';
  _avg?: Maybe<CareEnrollmentPaymentAvgAggregateOutputType>;
  _count?: Maybe<CareEnrollmentPaymentCountAggregateOutputType>;
  _max?: Maybe<CareEnrollmentPaymentMaxAggregateOutputType>;
  _min?: Maybe<CareEnrollmentPaymentMinAggregateOutputType>;
  _sum?: Maybe<CareEnrollmentPaymentSumAggregateOutputType>;
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disputedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CareEnrollmentPaymentListRelationFilter = {
  every?: Maybe<CareEnrollmentPaymentWhereInput>;
  none?: Maybe<CareEnrollmentPaymentWhereInput>;
  some?: Maybe<CareEnrollmentPaymentWhereInput>;
};

export type CareEnrollmentPaymentMaxAggregateOutputType = {
  __typename?: 'CareEnrollmentPaymentMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  applicationFeeAmount?: Maybe<SortOrder>;
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastOttoPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  nextPaymentAttempt?: Maybe<SortOrder>;
  ottoPaymentAttempts?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  refundedAt?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareEnrollmentPaymentMinAggregateOutputType = {
  __typename?: 'CareEnrollmentPaymentMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  applicationFeeAmount?: Maybe<SortOrder>;
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastOttoPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  nextPaymentAttempt?: Maybe<SortOrder>;
  ottoPaymentAttempts?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  refundedAt?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareEnrollmentPaymentNullableScalarRelationFilter = {
  AND?: Maybe<Array<CareEnrollmentPaymentWhereInput>>;
  NOT?: Maybe<Array<CareEnrollmentPaymentWhereInput>>;
  OR?: Maybe<Array<CareEnrollmentPaymentWhereInput>>;
  amount?: Maybe<IntFilter>;
  applicationFeeAmount?: Maybe<IntNullableFilter>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentNullableScalarRelationFilter>;
  careAddonEnrollmentId?: Maybe<StringNullableFilter>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  carePlanEnrollmentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disputedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  lastOttoPaymentAttempt?: Maybe<DateTimeNullableFilter>;
  lastPaymentAttempt?: Maybe<DateTimeNullableFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableFilter>;
  nextPaymentAttempt?: Maybe<DateTimeNullableFilter>;
  ottoPaymentAttempts?: Maybe<IntNullableFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  refundedAt?: Maybe<DateTimeNullableFilter>;
  stripeDispute?: Maybe<StripeDisputeNullableScalarRelationFilter>;
  stripeDisputeId?: Maybe<StringNullableFilter>;
  stripeInvoice?: Maybe<StripeInvoiceNullableScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripeRefund?: Maybe<StripeRefundNullableScalarRelationFilter>;
  stripeRefundId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareEnrollmentPaymentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareEnrollmentPaymentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareEnrollmentPaymentOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  applicationFeeAmount?: Maybe<SortOrder>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentOrderByWithRelationInput>;
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastOttoPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  nextPaymentAttempt?: Maybe<SortOrder>;
  ottoPaymentAttempts?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  refundedAt?: Maybe<SortOrder>;
  stripeDispute?: Maybe<StripeDisputeOrderByWithRelationInput>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeRefund?: Maybe<StripeRefundOrderByWithRelationInput>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareEnrollmentPaymentOrderByRelevanceFieldEnum {
  CareAddonEnrollmentId = 'careAddonEnrollmentId',
  CarePlanEnrollmentId = 'carePlanEnrollmentId',
  Id = 'id',
  StripeDisputeId = 'stripeDisputeId',
  StripeInvoiceId = 'stripeInvoiceId',
  StripeRefundId = 'stripeRefundId'
}

export type CareEnrollmentPaymentOrderByRelevanceInput = {
  fields: Array<CareEnrollmentPaymentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareEnrollmentPaymentOrderByWithAggregationInput = {
  _avg?: Maybe<CareEnrollmentPaymentAvgOrderByAggregateInput>;
  _count?: Maybe<CareEnrollmentPaymentCountOrderByAggregateInput>;
  _max?: Maybe<CareEnrollmentPaymentMaxOrderByAggregateInput>;
  _min?: Maybe<CareEnrollmentPaymentMinOrderByAggregateInput>;
  _sum?: Maybe<CareEnrollmentPaymentSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  applicationFeeAmount?: Maybe<SortOrder>;
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastOttoPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  nextPaymentAttempt?: Maybe<SortOrder>;
  ottoPaymentAttempts?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  refundedAt?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareEnrollmentPaymentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareEnrollmentPaymentOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  applicationFeeAmount?: Maybe<SortOrder>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentOrderByWithRelationInput>;
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastOttoPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  nextPaymentAttempt?: Maybe<SortOrder>;
  ottoPaymentAttempts?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  refundedAt?: Maybe<SortOrder>;
  stripeDispute?: Maybe<StripeDisputeOrderByWithRelationInput>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeRefund?: Maybe<StripeRefundOrderByWithRelationInput>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareEnrollmentPaymentOrderByWithRelationInput = {
  _relevance?: Maybe<CareEnrollmentPaymentOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  applicationFeeAmount?: Maybe<SortOrder>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentOrderByWithRelationInput>;
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastOttoPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentAttempt?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  nextPaymentAttempt?: Maybe<SortOrder>;
  ottoPaymentAttempts?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  refundedAt?: Maybe<SortOrder>;
  stripeDispute?: Maybe<StripeDisputeOrderByWithRelationInput>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeRefund?: Maybe<StripeRefundOrderByWithRelationInput>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareEnrollmentPaymentScalarFieldEnum {
  Amount = 'amount',
  ApplicationFeeAmount = 'applicationFeeAmount',
  CareAddonEnrollmentId = 'careAddonEnrollmentId',
  CarePlanEnrollmentId = 'carePlanEnrollmentId',
  CreatedAt = 'createdAt',
  DisputedAt = 'disputedAt',
  Id = 'id',
  LastOttoPaymentAttempt = 'lastOttoPaymentAttempt',
  LastPaymentAttempt = 'lastPaymentAttempt',
  LastPaymentError = 'lastPaymentError',
  NextPaymentAttempt = 'nextPaymentAttempt',
  OttoPaymentAttempts = 'ottoPaymentAttempts',
  PaidAt = 'paidAt',
  RefundedAt = 'refundedAt',
  StripeDisputeId = 'stripeDisputeId',
  StripeInvoiceId = 'stripeInvoiceId',
  StripeRefundId = 'stripeRefundId',
  UpdatedAt = 'updatedAt'
}

export type CareEnrollmentPaymentScalarWhereInput = {
  AND?: Maybe<Array<CareEnrollmentPaymentScalarWhereInput>>;
  NOT?: Maybe<Array<CareEnrollmentPaymentScalarWhereInput>>;
  OR?: Maybe<Array<CareEnrollmentPaymentScalarWhereInput>>;
  amount?: Maybe<IntFilter>;
  applicationFeeAmount?: Maybe<IntNullableFilter>;
  careAddonEnrollmentId?: Maybe<StringNullableFilter>;
  carePlanEnrollmentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disputedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  lastOttoPaymentAttempt?: Maybe<DateTimeNullableFilter>;
  lastPaymentAttempt?: Maybe<DateTimeNullableFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableFilter>;
  nextPaymentAttempt?: Maybe<DateTimeNullableFilter>;
  ottoPaymentAttempts?: Maybe<IntNullableFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  refundedAt?: Maybe<DateTimeNullableFilter>;
  stripeDisputeId?: Maybe<StringNullableFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripeRefundId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareEnrollmentPaymentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareEnrollmentPaymentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareEnrollmentPaymentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareEnrollmentPaymentScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntWithAggregatesFilter>;
  applicationFeeAmount?: Maybe<IntNullableWithAggregatesFilter>;
  careAddonEnrollmentId?: Maybe<StringNullableWithAggregatesFilter>;
  carePlanEnrollmentId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  disputedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  lastOttoPaymentAttempt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  lastPaymentAttempt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableWithAggregatesFilter>;
  nextPaymentAttempt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  ottoPaymentAttempts?: Maybe<IntNullableWithAggregatesFilter>;
  paidAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  refundedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  stripeDisputeId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeInvoiceId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeRefundId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CareEnrollmentPaymentSumAggregateOutputType = {
  __typename?: 'CareEnrollmentPaymentSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
};

export type CareEnrollmentPaymentSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  applicationFeeAmount?: Maybe<SortOrder>;
  ottoPaymentAttempts?: Maybe<SortOrder>;
};

export type CareEnrollmentPaymentUncheckedCreateInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput = {
  connect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentPaymentCreateOrConnectWithoutCareAddonEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentPaymentCreateWithoutCareAddonEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentPaymentCreateManyCareAddonEnrollmentInputEnvelope>;
};

export type CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput = {
  connect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentPaymentCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentPaymentCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentPaymentCreateManyCarePlanEnrollmentInputEnvelope>;
};

export type CareEnrollmentPaymentUncheckedCreateNestedManyWithoutStripeInvoiceInput = {
  connect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentPaymentCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: Maybe<Array<CareEnrollmentPaymentCreateWithoutStripeInvoiceInput>>;
  createMany?: Maybe<CareEnrollmentPaymentCreateManyStripeInvoiceInputEnvelope>;
};

export type CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeDisputeInput = {
  connect?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareEnrollmentPaymentCreateOrConnectWithoutStripeDisputeInput>;
  create?: Maybe<CareEnrollmentPaymentCreateWithoutStripeDisputeInput>;
};

export type CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeRefundInput = {
  connect?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareEnrollmentPaymentCreateOrConnectWithoutStripeRefundInput>;
  create?: Maybe<CareEnrollmentPaymentCreateWithoutStripeRefundInput>;
};

export type CareEnrollmentPaymentUncheckedCreateWithoutCareAddonEnrollmentInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedCreateWithoutCarePlanEnrollmentInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedCreateWithoutStripeDisputeInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedCreateWithoutStripeInvoiceInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedCreateWithoutStripeRefundInput = {
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedUpdateManyWithoutCareAddonEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput = {
  connect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentPaymentCreateOrConnectWithoutCareAddonEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentPaymentCreateWithoutCareAddonEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentPaymentCreateManyCareAddonEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareEnrollmentPaymentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  set?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  update?: Maybe<Array<CareEnrollmentPaymentUpdateWithWhereUniqueWithoutCareAddonEnrollmentInput>>;
  updateMany?: Maybe<Array<CareEnrollmentPaymentUpdateManyWithWhereWithoutCareAddonEnrollmentInput>>;
  upsert?: Maybe<Array<CareEnrollmentPaymentUpsertWithWhereUniqueWithoutCareAddonEnrollmentInput>>;
};

export type CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput = {
  connect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentPaymentCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentPaymentCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentPaymentCreateManyCarePlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareEnrollmentPaymentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  set?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  update?: Maybe<Array<CareEnrollmentPaymentUpdateWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
  updateMany?: Maybe<Array<CareEnrollmentPaymentUpdateManyWithWhereWithoutCarePlanEnrollmentInput>>;
  upsert?: Maybe<Array<CareEnrollmentPaymentUpsertWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
};

export type CareEnrollmentPaymentUncheckedUpdateManyWithoutStripeInvoiceInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedUpdateManyWithoutStripeInvoiceNestedInput = {
  connect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentPaymentCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: Maybe<Array<CareEnrollmentPaymentCreateWithoutStripeInvoiceInput>>;
  createMany?: Maybe<CareEnrollmentPaymentCreateManyStripeInvoiceInputEnvelope>;
  delete?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareEnrollmentPaymentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  set?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  update?: Maybe<Array<CareEnrollmentPaymentUpdateWithWhereUniqueWithoutStripeInvoiceInput>>;
  updateMany?: Maybe<Array<CareEnrollmentPaymentUpdateManyWithWhereWithoutStripeInvoiceInput>>;
  upsert?: Maybe<Array<CareEnrollmentPaymentUpsertWithWhereUniqueWithoutStripeInvoiceInput>>;
};

export type CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeDisputeNestedInput = {
  connect?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareEnrollmentPaymentCreateOrConnectWithoutStripeDisputeInput>;
  create?: Maybe<CareEnrollmentPaymentCreateWithoutStripeDisputeInput>;
  delete?: Maybe<CareEnrollmentPaymentWhereInput>;
  disconnect?: Maybe<CareEnrollmentPaymentWhereInput>;
  update?: Maybe<CareEnrollmentPaymentUpdateToOneWithWhereWithoutStripeDisputeInput>;
  upsert?: Maybe<CareEnrollmentPaymentUpsertWithoutStripeDisputeInput>;
};

export type CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeRefundNestedInput = {
  connect?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareEnrollmentPaymentCreateOrConnectWithoutStripeRefundInput>;
  create?: Maybe<CareEnrollmentPaymentCreateWithoutStripeRefundInput>;
  delete?: Maybe<CareEnrollmentPaymentWhereInput>;
  disconnect?: Maybe<CareEnrollmentPaymentWhereInput>;
  update?: Maybe<CareEnrollmentPaymentUpdateToOneWithWhereWithoutStripeRefundInput>;
  upsert?: Maybe<CareEnrollmentPaymentUpsertWithoutStripeRefundInput>;
};

export type CareEnrollmentPaymentUncheckedUpdateWithoutCareAddonEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedUpdateWithoutCarePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedUpdateWithoutStripeDisputeInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedUpdateWithoutStripeInvoiceInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUncheckedUpdateWithoutStripeRefundInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutEnrollmentPaymentsNestedInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutEnrollmentPaymentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutCareEnrollmentPaymentNestedInput>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutEnrollmentPaymentNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutCareEnrollmentPaymentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUpdateManyWithWhereWithoutCareAddonEnrollmentInput = {
  data: CareEnrollmentPaymentUpdateManyMutationInput;
  where: CareEnrollmentPaymentScalarWhereInput;
};

export type CareEnrollmentPaymentUpdateManyWithWhereWithoutCarePlanEnrollmentInput = {
  data: CareEnrollmentPaymentUpdateManyMutationInput;
  where: CareEnrollmentPaymentScalarWhereInput;
};

export type CareEnrollmentPaymentUpdateManyWithWhereWithoutStripeInvoiceInput = {
  data: CareEnrollmentPaymentUpdateManyMutationInput;
  where: CareEnrollmentPaymentScalarWhereInput;
};

export type CareEnrollmentPaymentUpdateManyWithoutCareAddonEnrollmentNestedInput = {
  connect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentPaymentCreateOrConnectWithoutCareAddonEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentPaymentCreateWithoutCareAddonEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentPaymentCreateManyCareAddonEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareEnrollmentPaymentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  set?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  update?: Maybe<Array<CareEnrollmentPaymentUpdateWithWhereUniqueWithoutCareAddonEnrollmentInput>>;
  updateMany?: Maybe<Array<CareEnrollmentPaymentUpdateManyWithWhereWithoutCareAddonEnrollmentInput>>;
  upsert?: Maybe<Array<CareEnrollmentPaymentUpsertWithWhereUniqueWithoutCareAddonEnrollmentInput>>;
};

export type CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput = {
  connect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentPaymentCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentPaymentCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentPaymentCreateManyCarePlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareEnrollmentPaymentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  set?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  update?: Maybe<Array<CareEnrollmentPaymentUpdateWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
  updateMany?: Maybe<Array<CareEnrollmentPaymentUpdateManyWithWhereWithoutCarePlanEnrollmentInput>>;
  upsert?: Maybe<Array<CareEnrollmentPaymentUpsertWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
};

export type CareEnrollmentPaymentUpdateManyWithoutStripeInvoiceNestedInput = {
  connect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentPaymentCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: Maybe<Array<CareEnrollmentPaymentCreateWithoutStripeInvoiceInput>>;
  createMany?: Maybe<CareEnrollmentPaymentCreateManyStripeInvoiceInputEnvelope>;
  delete?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareEnrollmentPaymentScalarWhereInput>>;
  disconnect?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  set?: Maybe<Array<CareEnrollmentPaymentWhereUniqueInput>>;
  update?: Maybe<Array<CareEnrollmentPaymentUpdateWithWhereUniqueWithoutStripeInvoiceInput>>;
  updateMany?: Maybe<Array<CareEnrollmentPaymentUpdateManyWithWhereWithoutStripeInvoiceInput>>;
  upsert?: Maybe<Array<CareEnrollmentPaymentUpsertWithWhereUniqueWithoutStripeInvoiceInput>>;
};

export type CareEnrollmentPaymentUpdateOneWithoutStripeDisputeNestedInput = {
  connect?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareEnrollmentPaymentCreateOrConnectWithoutStripeDisputeInput>;
  create?: Maybe<CareEnrollmentPaymentCreateWithoutStripeDisputeInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareEnrollmentPaymentUpdateToOneWithWhereWithoutStripeDisputeInput>;
  upsert?: Maybe<CareEnrollmentPaymentUpsertWithoutStripeDisputeInput>;
};

export type CareEnrollmentPaymentUpdateOneWithoutStripeRefundNestedInput = {
  connect?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareEnrollmentPaymentCreateOrConnectWithoutStripeRefundInput>;
  create?: Maybe<CareEnrollmentPaymentCreateWithoutStripeRefundInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareEnrollmentPaymentUpdateToOneWithWhereWithoutStripeRefundInput>;
  upsert?: Maybe<CareEnrollmentPaymentUpsertWithoutStripeRefundInput>;
};

export type CareEnrollmentPaymentUpdateToOneWithWhereWithoutStripeDisputeInput = {
  data: CareEnrollmentPaymentUpdateWithoutStripeDisputeInput;
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};

export type CareEnrollmentPaymentUpdateToOneWithWhereWithoutStripeRefundInput = {
  data: CareEnrollmentPaymentUpdateWithoutStripeRefundInput;
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};

export type CareEnrollmentPaymentUpdateWithWhereUniqueWithoutCareAddonEnrollmentInput = {
  data: CareEnrollmentPaymentUpdateWithoutCareAddonEnrollmentInput;
  where: CareEnrollmentPaymentWhereUniqueInput;
};

export type CareEnrollmentPaymentUpdateWithWhereUniqueWithoutCarePlanEnrollmentInput = {
  data: CareEnrollmentPaymentUpdateWithoutCarePlanEnrollmentInput;
  where: CareEnrollmentPaymentWhereUniqueInput;
};

export type CareEnrollmentPaymentUpdateWithWhereUniqueWithoutStripeInvoiceInput = {
  data: CareEnrollmentPaymentUpdateWithoutStripeInvoiceInput;
  where: CareEnrollmentPaymentWhereUniqueInput;
};

export type CareEnrollmentPaymentUpdateWithoutCareAddonEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutEnrollmentPaymentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutCareEnrollmentPaymentNestedInput>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutEnrollmentPaymentNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutCareEnrollmentPaymentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUpdateWithoutCarePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutEnrollmentPaymentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutCareEnrollmentPaymentNestedInput>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutEnrollmentPaymentNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutCareEnrollmentPaymentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUpdateWithoutStripeDisputeInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutEnrollmentPaymentsNestedInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutEnrollmentPaymentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutEnrollmentPaymentNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutCareEnrollmentPaymentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUpdateWithoutStripeInvoiceInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutEnrollmentPaymentsNestedInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutEnrollmentPaymentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutCareEnrollmentPaymentNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutCareEnrollmentPaymentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUpdateWithoutStripeRefundInput = {
  amount?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutEnrollmentPaymentsNestedInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutEnrollmentPaymentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutCareEnrollmentPaymentNestedInput>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutEnrollmentPaymentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareEnrollmentPaymentUpsertWithWhereUniqueWithoutCareAddonEnrollmentInput = {
  create: CareEnrollmentPaymentCreateWithoutCareAddonEnrollmentInput;
  update: CareEnrollmentPaymentUpdateWithoutCareAddonEnrollmentInput;
  where: CareEnrollmentPaymentWhereUniqueInput;
};

export type CareEnrollmentPaymentUpsertWithWhereUniqueWithoutCarePlanEnrollmentInput = {
  create: CareEnrollmentPaymentCreateWithoutCarePlanEnrollmentInput;
  update: CareEnrollmentPaymentUpdateWithoutCarePlanEnrollmentInput;
  where: CareEnrollmentPaymentWhereUniqueInput;
};

export type CareEnrollmentPaymentUpsertWithWhereUniqueWithoutStripeInvoiceInput = {
  create: CareEnrollmentPaymentCreateWithoutStripeInvoiceInput;
  update: CareEnrollmentPaymentUpdateWithoutStripeInvoiceInput;
  where: CareEnrollmentPaymentWhereUniqueInput;
};

export type CareEnrollmentPaymentUpsertWithoutStripeDisputeInput = {
  create: CareEnrollmentPaymentCreateWithoutStripeDisputeInput;
  update: CareEnrollmentPaymentUpdateWithoutStripeDisputeInput;
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};

export type CareEnrollmentPaymentUpsertWithoutStripeRefundInput = {
  create: CareEnrollmentPaymentCreateWithoutStripeRefundInput;
  update: CareEnrollmentPaymentUpdateWithoutStripeRefundInput;
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};

export type CareEnrollmentPaymentWhereInput = {
  AND?: Maybe<Array<CareEnrollmentPaymentWhereInput>>;
  NOT?: Maybe<Array<CareEnrollmentPaymentWhereInput>>;
  OR?: Maybe<Array<CareEnrollmentPaymentWhereInput>>;
  amount?: Maybe<IntFilter>;
  applicationFeeAmount?: Maybe<IntNullableFilter>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentNullableScalarRelationFilter>;
  careAddonEnrollmentId?: Maybe<StringNullableFilter>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  carePlanEnrollmentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disputedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  lastOttoPaymentAttempt?: Maybe<DateTimeNullableFilter>;
  lastPaymentAttempt?: Maybe<DateTimeNullableFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableFilter>;
  nextPaymentAttempt?: Maybe<DateTimeNullableFilter>;
  ottoPaymentAttempts?: Maybe<IntNullableFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  refundedAt?: Maybe<DateTimeNullableFilter>;
  stripeDispute?: Maybe<StripeDisputeNullableScalarRelationFilter>;
  stripeDisputeId?: Maybe<StringNullableFilter>;
  stripeInvoice?: Maybe<StripeInvoiceNullableScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripeRefund?: Maybe<StripeRefundNullableScalarRelationFilter>;
  stripeRefundId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareEnrollmentPaymentWhereUniqueInput = {
  AND?: Maybe<Array<CareEnrollmentPaymentWhereInput>>;
  NOT?: Maybe<Array<CareEnrollmentPaymentWhereInput>>;
  OR?: Maybe<Array<CareEnrollmentPaymentWhereInput>>;
  amount?: Maybe<IntFilter>;
  applicationFeeAmount?: Maybe<IntNullableFilter>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentNullableScalarRelationFilter>;
  careAddonEnrollmentId?: Maybe<StringNullableFilter>;
  careAddonEnrollmentId_stripeInvoiceId?: Maybe<CareEnrollmentPaymentCareAddonEnrollmentIdStripeInvoiceIdCompoundUniqueInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  carePlanEnrollmentId?: Maybe<StringNullableFilter>;
  carePlanEnrollmentId_stripeInvoiceId?: Maybe<CareEnrollmentPaymentCarePlanEnrollmentIdStripeInvoiceIdCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  disputedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  lastOttoPaymentAttempt?: Maybe<DateTimeNullableFilter>;
  lastPaymentAttempt?: Maybe<DateTimeNullableFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableFilter>;
  nextPaymentAttempt?: Maybe<DateTimeNullableFilter>;
  ottoPaymentAttempts?: Maybe<IntNullableFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  refundedAt?: Maybe<DateTimeNullableFilter>;
  stripeDispute?: Maybe<StripeDisputeNullableScalarRelationFilter>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceNullableScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripeRefund?: Maybe<StripeRefundNullableScalarRelationFilter>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareEnrollmentToStripeInvoiceItem = {
  __typename?: 'CareEnrollmentToStripeInvoiceItem';
  careAddonEnrollment?: Maybe<CareAddonEnrollment>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollment?: Maybe<CarePlanEnrollment>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  stripeInvoiceItem: StripeInvoiceItem;
  stripeInvoiceItemId: Scalars['String'];
};


export type CareEnrollmentToStripeInvoiceItemCareAddonEnrollmentArgs = {
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};


export type CareEnrollmentToStripeInvoiceItemCarePlanEnrollmentArgs = {
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CareEnrollmentToStripeInvoiceItemCountAggregateOutputType = {
  __typename?: 'CareEnrollmentToStripeInvoiceItemCountAggregateOutputType';
  _all: Scalars['Int'];
  careAddonEnrollmentId: Scalars['Int'];
  carePlanEnrollmentId: Scalars['Int'];
  id: Scalars['Int'];
  stripeInvoiceItemId: Scalars['Int'];
};

export type CareEnrollmentToStripeInvoiceItemCountOrderByAggregateInput = {
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeInvoiceItemId?: Maybe<SortOrder>;
};

export type CareEnrollmentToStripeInvoiceItemCreateInput = {
  careAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutEnrollmentToStripeInvoiceItemsInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutEnrollmentToStripeInvoiceItemsInput>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItem: StripeInvoiceItemCreateNestedOneWithoutEnrollmentToStripeInvoiceItemsInput;
};

export type CareEnrollmentToStripeInvoiceItemCreateManyCareAddonEnrollmentInput = {
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId: Scalars['String'];
};

export type CareEnrollmentToStripeInvoiceItemCreateManyCareAddonEnrollmentInputEnvelope = {
  data: Array<CareEnrollmentToStripeInvoiceItemCreateManyCareAddonEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareEnrollmentToStripeInvoiceItemCreateManyCarePlanEnrollmentInput = {
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId: Scalars['String'];
};

export type CareEnrollmentToStripeInvoiceItemCreateManyCarePlanEnrollmentInputEnvelope = {
  data: Array<CareEnrollmentToStripeInvoiceItemCreateManyCarePlanEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareEnrollmentToStripeInvoiceItemCreateManyInput = {
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId: Scalars['String'];
};

export type CareEnrollmentToStripeInvoiceItemCreateManyStripeInvoiceItemInput = {
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemCreateManyStripeInvoiceItemInputEnvelope = {
  data: Array<CareEnrollmentToStripeInvoiceItemCreateManyStripeInvoiceItemInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCareAddonEnrollmentInput = {
  connect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutCareAddonEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateWithoutCareAddonEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentToStripeInvoiceItemCreateManyCareAddonEnrollmentInputEnvelope>;
};

export type CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput = {
  connect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentToStripeInvoiceItemCreateManyCarePlanEnrollmentInputEnvelope>;
};

export type CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutStripeInvoiceItemInput = {
  connect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutStripeInvoiceItemInput>>;
  create?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateWithoutStripeInvoiceItemInput>>;
  createMany?: Maybe<CareEnrollmentToStripeInvoiceItemCreateManyStripeInvoiceItemInputEnvelope>;
};

export type CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutCareAddonEnrollmentInput = {
  create: CareEnrollmentToStripeInvoiceItemCreateWithoutCareAddonEnrollmentInput;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};

export type CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutCarePlanEnrollmentInput = {
  create: CareEnrollmentToStripeInvoiceItemCreateWithoutCarePlanEnrollmentInput;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};

export type CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutStripeInvoiceItemInput = {
  create: CareEnrollmentToStripeInvoiceItemCreateWithoutStripeInvoiceItemInput;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};

export type CareEnrollmentToStripeInvoiceItemCreateWithoutCareAddonEnrollmentInput = {
  carePlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutEnrollmentToStripeInvoiceItemsInput>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItem: StripeInvoiceItemCreateNestedOneWithoutEnrollmentToStripeInvoiceItemsInput;
};

export type CareEnrollmentToStripeInvoiceItemCreateWithoutCarePlanEnrollmentInput = {
  careAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutEnrollmentToStripeInvoiceItemsInput>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItem: StripeInvoiceItemCreateNestedOneWithoutEnrollmentToStripeInvoiceItemsInput;
};

export type CareEnrollmentToStripeInvoiceItemCreateWithoutStripeInvoiceItemInput = {
  careAddonEnrollment?: Maybe<CareAddonEnrollmentCreateNestedOneWithoutEnrollmentToStripeInvoiceItemsInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutEnrollmentToStripeInvoiceItemsInput>;
  id?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemGroupByOutputType = {
  __typename?: 'CareEnrollmentToStripeInvoiceItemGroupByOutputType';
  _count?: Maybe<CareEnrollmentToStripeInvoiceItemCountAggregateOutputType>;
  _max?: Maybe<CareEnrollmentToStripeInvoiceItemMaxAggregateOutputType>;
  _min?: Maybe<CareEnrollmentToStripeInvoiceItemMinAggregateOutputType>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  stripeInvoiceItemId: Scalars['String'];
};

export type CareEnrollmentToStripeInvoiceItemListRelationFilter = {
  every?: Maybe<CareEnrollmentToStripeInvoiceItemWhereInput>;
  none?: Maybe<CareEnrollmentToStripeInvoiceItemWhereInput>;
  some?: Maybe<CareEnrollmentToStripeInvoiceItemWhereInput>;
};

export type CareEnrollmentToStripeInvoiceItemMaxAggregateOutputType = {
  __typename?: 'CareEnrollmentToStripeInvoiceItemMaxAggregateOutputType';
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemMaxOrderByAggregateInput = {
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeInvoiceItemId?: Maybe<SortOrder>;
};

export type CareEnrollmentToStripeInvoiceItemMinAggregateOutputType = {
  __typename?: 'CareEnrollmentToStripeInvoiceItemMinAggregateOutputType';
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemMinOrderByAggregateInput = {
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeInvoiceItemId?: Maybe<SortOrder>;
};

export type CareEnrollmentToStripeInvoiceItemOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareEnrollmentToStripeInvoiceItemOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareEnrollmentToStripeInvoiceItemOrderByRelevanceInput>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentOrderByWithRelationInput>;
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeInvoiceItem?: Maybe<StripeInvoiceItemOrderByWithRelationInput>;
  stripeInvoiceItemId?: Maybe<SortOrder>;
};

export enum CareEnrollmentToStripeInvoiceItemOrderByRelevanceFieldEnum {
  CareAddonEnrollmentId = 'careAddonEnrollmentId',
  CarePlanEnrollmentId = 'carePlanEnrollmentId',
  Id = 'id',
  StripeInvoiceItemId = 'stripeInvoiceItemId'
}

export type CareEnrollmentToStripeInvoiceItemOrderByRelevanceInput = {
  fields: Array<CareEnrollmentToStripeInvoiceItemOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareEnrollmentToStripeInvoiceItemOrderByWithAggregationInput = {
  _count?: Maybe<CareEnrollmentToStripeInvoiceItemCountOrderByAggregateInput>;
  _max?: Maybe<CareEnrollmentToStripeInvoiceItemMaxOrderByAggregateInput>;
  _min?: Maybe<CareEnrollmentToStripeInvoiceItemMinOrderByAggregateInput>;
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeInvoiceItemId?: Maybe<SortOrder>;
};

export type CareEnrollmentToStripeInvoiceItemOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareEnrollmentToStripeInvoiceItemOrderByRelevanceInput>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentOrderByWithRelationInput>;
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeInvoiceItem?: Maybe<StripeInvoiceItemOrderByWithRelationInput>;
  stripeInvoiceItemId?: Maybe<SortOrder>;
};

export type CareEnrollmentToStripeInvoiceItemOrderByWithRelationInput = {
  _relevance?: Maybe<CareEnrollmentToStripeInvoiceItemOrderByRelevanceInput>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentOrderByWithRelationInput>;
  careAddonEnrollmentId?: Maybe<SortOrder>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeInvoiceItem?: Maybe<StripeInvoiceItemOrderByWithRelationInput>;
  stripeInvoiceItemId?: Maybe<SortOrder>;
};

export enum CareEnrollmentToStripeInvoiceItemScalarFieldEnum {
  CareAddonEnrollmentId = 'careAddonEnrollmentId',
  CarePlanEnrollmentId = 'carePlanEnrollmentId',
  Id = 'id',
  StripeInvoiceItemId = 'stripeInvoiceItemId'
}

export type CareEnrollmentToStripeInvoiceItemScalarWhereInput = {
  AND?: Maybe<Array<CareEnrollmentToStripeInvoiceItemScalarWhereInput>>;
  NOT?: Maybe<Array<CareEnrollmentToStripeInvoiceItemScalarWhereInput>>;
  OR?: Maybe<Array<CareEnrollmentToStripeInvoiceItemScalarWhereInput>>;
  careAddonEnrollmentId?: Maybe<StringNullableFilter>;
  carePlanEnrollmentId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  stripeInvoiceItemId?: Maybe<StringFilter>;
};

export type CareEnrollmentToStripeInvoiceItemScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareEnrollmentToStripeInvoiceItemScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareEnrollmentToStripeInvoiceItemScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareEnrollmentToStripeInvoiceItemScalarWhereWithAggregatesInput>>;
  careAddonEnrollmentId?: Maybe<StringNullableWithAggregatesFilter>;
  carePlanEnrollmentId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  stripeInvoiceItemId?: Maybe<StringWithAggregatesFilter>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedCreateInput = {
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId: Scalars['String'];
};

export type CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCareAddonEnrollmentInput = {
  connect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutCareAddonEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateWithoutCareAddonEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentToStripeInvoiceItemCreateManyCareAddonEnrollmentInputEnvelope>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput = {
  connect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentToStripeInvoiceItemCreateManyCarePlanEnrollmentInputEnvelope>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceItemInput = {
  connect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutStripeInvoiceItemInput>>;
  create?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateWithoutStripeInvoiceItemInput>>;
  createMany?: Maybe<CareEnrollmentToStripeInvoiceItemCreateManyStripeInvoiceItemInputEnvelope>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedCreateWithoutCareAddonEnrollmentInput = {
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId: Scalars['String'];
};

export type CareEnrollmentToStripeInvoiceItemUncheckedCreateWithoutCarePlanEnrollmentInput = {
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId: Scalars['String'];
};

export type CareEnrollmentToStripeInvoiceItemUncheckedCreateWithoutStripeInvoiceItemInput = {
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedUpdateInput = {
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyInput = {
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCareAddonEnrollmentInput = {
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCareAddonEnrollmentNestedInput = {
  connect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutCareAddonEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateWithoutCareAddonEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentToStripeInvoiceItemCreateManyCareAddonEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareEnrollmentToStripeInvoiceItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  set?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  update?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpdateWithWhereUniqueWithoutCareAddonEnrollmentInput>>;
  updateMany?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpdateManyWithWhereWithoutCareAddonEnrollmentInput>>;
  upsert?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpsertWithWhereUniqueWithoutCareAddonEnrollmentInput>>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentInput = {
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput = {
  connect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentToStripeInvoiceItemCreateManyCarePlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareEnrollmentToStripeInvoiceItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  set?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  update?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpdateWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
  updateMany?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpdateManyWithWhereWithoutCarePlanEnrollmentInput>>;
  upsert?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpsertWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceItemInput = {
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceItemNestedInput = {
  connect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutStripeInvoiceItemInput>>;
  create?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateWithoutStripeInvoiceItemInput>>;
  createMany?: Maybe<CareEnrollmentToStripeInvoiceItemCreateManyStripeInvoiceItemInputEnvelope>;
  delete?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareEnrollmentToStripeInvoiceItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  set?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  update?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpdateWithWhereUniqueWithoutStripeInvoiceItemInput>>;
  updateMany?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpdateManyWithWhereWithoutStripeInvoiceItemInput>>;
  upsert?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpsertWithWhereUniqueWithoutStripeInvoiceItemInput>>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedUpdateWithoutCareAddonEnrollmentInput = {
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedUpdateWithoutCarePlanEnrollmentInput = {
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItemId?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemUncheckedUpdateWithoutStripeInvoiceItemInput = {
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemUpdateInput = {
  careAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutEnrollmentToStripeInvoiceItemsNestedInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutEnrollmentToStripeInvoiceItemsNestedInput>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItem?: Maybe<StripeInvoiceItemUpdateOneRequiredWithoutEnrollmentToStripeInvoiceItemsNestedInput>;
};

export type CareEnrollmentToStripeInvoiceItemUpdateManyMutationInput = {
  id?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemUpdateManyWithWhereWithoutCareAddonEnrollmentInput = {
  data: CareEnrollmentToStripeInvoiceItemUpdateManyMutationInput;
  where: CareEnrollmentToStripeInvoiceItemScalarWhereInput;
};

export type CareEnrollmentToStripeInvoiceItemUpdateManyWithWhereWithoutCarePlanEnrollmentInput = {
  data: CareEnrollmentToStripeInvoiceItemUpdateManyMutationInput;
  where: CareEnrollmentToStripeInvoiceItemScalarWhereInput;
};

export type CareEnrollmentToStripeInvoiceItemUpdateManyWithWhereWithoutStripeInvoiceItemInput = {
  data: CareEnrollmentToStripeInvoiceItemUpdateManyMutationInput;
  where: CareEnrollmentToStripeInvoiceItemScalarWhereInput;
};

export type CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCareAddonEnrollmentNestedInput = {
  connect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutCareAddonEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateWithoutCareAddonEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentToStripeInvoiceItemCreateManyCareAddonEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareEnrollmentToStripeInvoiceItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  set?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  update?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpdateWithWhereUniqueWithoutCareAddonEnrollmentInput>>;
  updateMany?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpdateManyWithWhereWithoutCareAddonEnrollmentInput>>;
  upsert?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpsertWithWhereUniqueWithoutCareAddonEnrollmentInput>>;
};

export type CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput = {
  connect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<CareEnrollmentToStripeInvoiceItemCreateManyCarePlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareEnrollmentToStripeInvoiceItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  set?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  update?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpdateWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
  updateMany?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpdateManyWithWhereWithoutCarePlanEnrollmentInput>>;
  upsert?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpsertWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
};

export type CareEnrollmentToStripeInvoiceItemUpdateManyWithoutStripeInvoiceItemNestedInput = {
  connect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateOrConnectWithoutStripeInvoiceItemInput>>;
  create?: Maybe<Array<CareEnrollmentToStripeInvoiceItemCreateWithoutStripeInvoiceItemInput>>;
  createMany?: Maybe<CareEnrollmentToStripeInvoiceItemCreateManyStripeInvoiceItemInputEnvelope>;
  delete?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareEnrollmentToStripeInvoiceItemScalarWhereInput>>;
  disconnect?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  set?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>>;
  update?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpdateWithWhereUniqueWithoutStripeInvoiceItemInput>>;
  updateMany?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpdateManyWithWhereWithoutStripeInvoiceItemInput>>;
  upsert?: Maybe<Array<CareEnrollmentToStripeInvoiceItemUpsertWithWhereUniqueWithoutStripeInvoiceItemInput>>;
};

export type CareEnrollmentToStripeInvoiceItemUpdateWithWhereUniqueWithoutCareAddonEnrollmentInput = {
  data: CareEnrollmentToStripeInvoiceItemUpdateWithoutCareAddonEnrollmentInput;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};

export type CareEnrollmentToStripeInvoiceItemUpdateWithWhereUniqueWithoutCarePlanEnrollmentInput = {
  data: CareEnrollmentToStripeInvoiceItemUpdateWithoutCarePlanEnrollmentInput;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};

export type CareEnrollmentToStripeInvoiceItemUpdateWithWhereUniqueWithoutStripeInvoiceItemInput = {
  data: CareEnrollmentToStripeInvoiceItemUpdateWithoutStripeInvoiceItemInput;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};

export type CareEnrollmentToStripeInvoiceItemUpdateWithoutCareAddonEnrollmentInput = {
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutEnrollmentToStripeInvoiceItemsNestedInput>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItem?: Maybe<StripeInvoiceItemUpdateOneRequiredWithoutEnrollmentToStripeInvoiceItemsNestedInput>;
};

export type CareEnrollmentToStripeInvoiceItemUpdateWithoutCarePlanEnrollmentInput = {
  careAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutEnrollmentToStripeInvoiceItemsNestedInput>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItem?: Maybe<StripeInvoiceItemUpdateOneRequiredWithoutEnrollmentToStripeInvoiceItemsNestedInput>;
};

export type CareEnrollmentToStripeInvoiceItemUpdateWithoutStripeInvoiceItemInput = {
  careAddonEnrollment?: Maybe<CareAddonEnrollmentUpdateOneWithoutEnrollmentToStripeInvoiceItemsNestedInput>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutEnrollmentToStripeInvoiceItemsNestedInput>;
  id?: Maybe<Scalars['String']>;
};

export type CareEnrollmentToStripeInvoiceItemUpsertWithWhereUniqueWithoutCareAddonEnrollmentInput = {
  create: CareEnrollmentToStripeInvoiceItemCreateWithoutCareAddonEnrollmentInput;
  update: CareEnrollmentToStripeInvoiceItemUpdateWithoutCareAddonEnrollmentInput;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};

export type CareEnrollmentToStripeInvoiceItemUpsertWithWhereUniqueWithoutCarePlanEnrollmentInput = {
  create: CareEnrollmentToStripeInvoiceItemCreateWithoutCarePlanEnrollmentInput;
  update: CareEnrollmentToStripeInvoiceItemUpdateWithoutCarePlanEnrollmentInput;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};

export type CareEnrollmentToStripeInvoiceItemUpsertWithWhereUniqueWithoutStripeInvoiceItemInput = {
  create: CareEnrollmentToStripeInvoiceItemCreateWithoutStripeInvoiceItemInput;
  update: CareEnrollmentToStripeInvoiceItemUpdateWithoutStripeInvoiceItemInput;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};

export type CareEnrollmentToStripeInvoiceItemWhereInput = {
  AND?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereInput>>;
  NOT?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereInput>>;
  OR?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereInput>>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentNullableScalarRelationFilter>;
  careAddonEnrollmentId?: Maybe<StringNullableFilter>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  carePlanEnrollmentId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  stripeInvoiceItem?: Maybe<StripeInvoiceItemScalarRelationFilter>;
  stripeInvoiceItemId?: Maybe<StringFilter>;
};

export type CareEnrollmentToStripeInvoiceItemWhereUniqueInput = {
  AND?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereInput>>;
  NOT?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereInput>>;
  OR?: Maybe<Array<CareEnrollmentToStripeInvoiceItemWhereInput>>;
  careAddonEnrollment?: Maybe<CareAddonEnrollmentNullableScalarRelationFilter>;
  careAddonEnrollmentId?: Maybe<StringNullableFilter>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  carePlanEnrollmentId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceItem?: Maybe<StripeInvoiceItemScalarRelationFilter>;
  stripeInvoiceItemId?: Maybe<StringFilter>;
};

export type CareEnrollmentWhereInput = {
  organizationPetId: Scalars['String'];
};

export type CareEnrollmentsByClinicOutput = {
  __typename?: 'CareEnrollmentsByClinicOutput';
  carePlanProviderGroupId: Scalars['String'];
  dailyTotal: Scalars['Int'];
  enrollmentData: CareEnrollmentData;
  monthlyTotal: Scalars['Int'];
};

export type CareEnrollmentsByClinicWhereInput = {
  carePlanProviderGroupId: Scalars['String'];
};

export type CareLapsedPayment = {
  __typename?: 'CareLapsedPayment';
  createdAt: Scalars['DateTime'];
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status: CareLapsedPaymentStatus;
  stripeInvoice: StripeInvoice;
  stripeInvoiceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CareLapsedPaymentCountAggregateOutputType = {
  __typename?: 'CareLapsedPaymentCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  expiredAt: Scalars['Int'];
  id: Scalars['Int'];
  lastNotifiedAt: Scalars['Int'];
  resolvedAt: Scalars['Int'];
  status: Scalars['Int'];
  stripeInvoiceId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CareLapsedPaymentCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastNotifiedAt?: Maybe<SortOrder>;
  resolvedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareLapsedPaymentCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  stripeInvoice: StripeInvoiceCreateNestedOneWithoutLapsedPaymentInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  stripeInvoiceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentCreateNestedOneWithoutStripeInvoiceInput = {
  connect?: Maybe<CareLapsedPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareLapsedPaymentCreateOrConnectWithoutStripeInvoiceInput>;
  create?: Maybe<CareLapsedPaymentCreateWithoutStripeInvoiceInput>;
};

export type CareLapsedPaymentCreateOrConnectWithoutStripeInvoiceInput = {
  create: CareLapsedPaymentCreateWithoutStripeInvoiceInput;
  where: CareLapsedPaymentWhereUniqueInput;
};

export type CareLapsedPaymentCreateWithoutStripeInvoiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentGroupByOutputType = {
  __typename?: 'CareLapsedPaymentGroupByOutputType';
  _count?: Maybe<CareLapsedPaymentCountAggregateOutputType>;
  _max?: Maybe<CareLapsedPaymentMaxAggregateOutputType>;
  _min?: Maybe<CareLapsedPaymentMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status: CareLapsedPaymentStatus;
  stripeInvoiceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CareLapsedPaymentMaxAggregateOutputType = {
  __typename?: 'CareLapsedPaymentMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastNotifiedAt?: Maybe<SortOrder>;
  resolvedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareLapsedPaymentMinAggregateOutputType = {
  __typename?: 'CareLapsedPaymentMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastNotifiedAt?: Maybe<SortOrder>;
  resolvedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareLapsedPaymentNullableScalarRelationFilter = {
  AND?: Maybe<Array<CareLapsedPaymentWhereInput>>;
  NOT?: Maybe<Array<CareLapsedPaymentWhereInput>>;
  OR?: Maybe<Array<CareLapsedPaymentWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  expiredAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  lastNotifiedAt?: Maybe<DateTimeNullableFilter>;
  resolvedAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumCareLapsedPaymentStatusFilter>;
  stripeInvoice?: Maybe<StripeInvoiceScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareLapsedPaymentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareLapsedPaymentOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastNotifiedAt?: Maybe<SortOrder>;
  resolvedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareLapsedPaymentOrderByRelevanceFieldEnum {
  Id = 'id',
  StripeInvoiceId = 'stripeInvoiceId'
}

export type CareLapsedPaymentOrderByRelevanceInput = {
  fields: Array<CareLapsedPaymentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareLapsedPaymentOrderByWithAggregationInput = {
  _count?: Maybe<CareLapsedPaymentCountOrderByAggregateInput>;
  _max?: Maybe<CareLapsedPaymentMaxOrderByAggregateInput>;
  _min?: Maybe<CareLapsedPaymentMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastNotifiedAt?: Maybe<SortOrder>;
  resolvedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareLapsedPaymentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareLapsedPaymentOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastNotifiedAt?: Maybe<SortOrder>;
  resolvedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareLapsedPaymentOrderByWithRelationInput = {
  _relevance?: Maybe<CareLapsedPaymentOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastNotifiedAt?: Maybe<SortOrder>;
  resolvedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareLapsedPaymentScalarFieldEnum {
  CreatedAt = 'createdAt',
  ExpiredAt = 'expiredAt',
  Id = 'id',
  LastNotifiedAt = 'lastNotifiedAt',
  ResolvedAt = 'resolvedAt',
  Status = 'status',
  StripeInvoiceId = 'stripeInvoiceId',
  UpdatedAt = 'updatedAt'
}

export type CareLapsedPaymentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareLapsedPaymentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareLapsedPaymentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareLapsedPaymentScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  expiredAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  lastNotifiedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  resolvedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  status?: Maybe<EnumCareLapsedPaymentStatusWithAggregatesFilter>;
  stripeInvoiceId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum CareLapsedPaymentStatus {
  Expired = 'Expired',
  Pending = 'Pending',
  Resolved = 'Resolved'
}

export type CareLapsedPaymentUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  stripeInvoiceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentUncheckedCreateNestedOneWithoutStripeInvoiceInput = {
  connect?: Maybe<CareLapsedPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareLapsedPaymentCreateOrConnectWithoutStripeInvoiceInput>;
  create?: Maybe<CareLapsedPaymentCreateWithoutStripeInvoiceInput>;
};

export type CareLapsedPaymentUncheckedCreateWithoutStripeInvoiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentUncheckedUpdateOneWithoutStripeInvoiceNestedInput = {
  connect?: Maybe<CareLapsedPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareLapsedPaymentCreateOrConnectWithoutStripeInvoiceInput>;
  create?: Maybe<CareLapsedPaymentCreateWithoutStripeInvoiceInput>;
  delete?: Maybe<CareLapsedPaymentWhereInput>;
  disconnect?: Maybe<CareLapsedPaymentWhereInput>;
  update?: Maybe<CareLapsedPaymentUpdateToOneWithWhereWithoutStripeInvoiceInput>;
  upsert?: Maybe<CareLapsedPaymentUpsertWithoutStripeInvoiceInput>;
};

export type CareLapsedPaymentUncheckedUpdateWithoutStripeInvoiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneRequiredWithoutLapsedPaymentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentUpdateOneWithoutStripeInvoiceNestedInput = {
  connect?: Maybe<CareLapsedPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<CareLapsedPaymentCreateOrConnectWithoutStripeInvoiceInput>;
  create?: Maybe<CareLapsedPaymentCreateWithoutStripeInvoiceInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareLapsedPaymentUpdateToOneWithWhereWithoutStripeInvoiceInput>;
  upsert?: Maybe<CareLapsedPaymentUpsertWithoutStripeInvoiceInput>;
};

export type CareLapsedPaymentUpdateToOneWithWhereWithoutStripeInvoiceInput = {
  data: CareLapsedPaymentUpdateWithoutStripeInvoiceInput;
  where?: Maybe<CareLapsedPaymentWhereInput>;
};

export type CareLapsedPaymentUpdateWithoutStripeInvoiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CareLapsedPaymentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareLapsedPaymentUpsertWithoutStripeInvoiceInput = {
  create: CareLapsedPaymentCreateWithoutStripeInvoiceInput;
  update: CareLapsedPaymentUpdateWithoutStripeInvoiceInput;
  where?: Maybe<CareLapsedPaymentWhereInput>;
};

export type CareLapsedPaymentWhereInput = {
  AND?: Maybe<Array<CareLapsedPaymentWhereInput>>;
  NOT?: Maybe<Array<CareLapsedPaymentWhereInput>>;
  OR?: Maybe<Array<CareLapsedPaymentWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  expiredAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  lastNotifiedAt?: Maybe<DateTimeNullableFilter>;
  resolvedAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumCareLapsedPaymentStatusFilter>;
  stripeInvoice?: Maybe<StripeInvoiceScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareLapsedPaymentWhereUniqueInput = {
  AND?: Maybe<Array<CareLapsedPaymentWhereInput>>;
  NOT?: Maybe<Array<CareLapsedPaymentWhereInput>>;
  OR?: Maybe<Array<CareLapsedPaymentWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  expiredAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<DateTimeNullableFilter>;
  resolvedAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumCareLapsedPaymentStatusFilter>;
  stripeInvoice?: Maybe<StripeInvoiceScalarRelationFilter>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareOrganizationInfo = {
  __typename?: 'CareOrganizationInfo';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CarePetSignupInput = {
  carePlanId: Scalars['String'];
  carePlanPricingId?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
};

export type CarePlan = {
  __typename?: 'CarePlan';
  _count: CarePlanCountOutputType;
  allowSelfRenewal: Scalars['Boolean'];
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  /** @deprecated use CarePlanPricing instead */
  billingCycle: CarePlanCycleType;
  createdAt: Scalars['DateTime'];
  currentPlanEnrollmentSupportEvents: Array<EnrollmentSupportEvent>;
  /** @deprecated use CarePlanPricing instead */
  defaultRenewalSuccessorPlan?: Maybe<CarePlan>;
  /** @deprecated use CarePlanPricing instead */
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes: Scalars['String'];
  enrollments: Array<CarePlanEnrollment>;
  /** @deprecated use CarePlanPricing instead */
  explicitRenewalSuccessors: Array<CarePlanEnrollment>;
  flowAlias?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isAcceptingPreEnrollments: Scalars['Boolean'];
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  /** Note: we will eventually transform this into proper models once the marketing information gets more nailed down */
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents: Array<EnrollmentSupportEvent>;
  organization: Organization;
  organizationId: Scalars['String'];
  planBenefits: Array<CarePlanBenefit>;
  /** @deprecated use CarePlanPricing instead */
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings: Array<CarePlanPricing>;
  /** @deprecated use CarePlanPricing instead */
  pricePerRenewal: Scalars['Int'];
  /** @deprecated use CarePlanPricing instead */
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  /** @deprecated use CarePlanPricing instead */
  renewalCycle: CarePlanCycleType;
  /** @deprecated use CarePlanPricing instead */
  renewalPredecessorPlan: Array<CarePlan>;
  salesTaxCentsPerMonth: Scalars['Int'];
  /** @deprecated use CarePlanPricing instead */
  selectedByRenewalEmailEnrollments: Array<CarePlanEnrollment>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  /** @deprecated use CarePlanPricing instead */
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type CarePlanAssociatedCarePlanProviderGroupArgs = {
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type CarePlanCurrentPlanEnrollmentSupportEventsArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type CarePlanDefaultRenewalSuccessorPlanArgs = {
  where?: Maybe<CarePlanWhereInput>;
};


export type CarePlanEnrollmentsArgs = {
  cursor?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type CarePlanExplicitRenewalSuccessorsArgs = {
  cursor?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type CarePlanNewPlanEnrollmentSupportEventsArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type CarePlanPlanBenefitsArgs = {
  cursor?: Maybe<CarePlanBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitWhereInput>;
};


export type CarePlanPlanPricingsArgs = {
  cursor?: Maybe<CarePlanPricingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanPricingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanPricingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type CarePlanRenewalPredecessorPlanArgs = {
  cursor?: Maybe<CarePlanWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanWhereInput>;
};


export type CarePlanSelectedByRenewalEmailEnrollmentsArgs = {
  cursor?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanAvgAggregateOutputType = {
  __typename?: 'CarePlanAvgAggregateOutputType';
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Float']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Float']>;
  planDiscount?: Maybe<Scalars['Float']>;
  pricePerRenewal?: Maybe<Scalars['Float']>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Float']>;
  signupFeePricing?: Maybe<Scalars['Float']>;
};

export type CarePlanAvgOrderByAggregateInput = {
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  planDiscount?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  signupFeePricing?: Maybe<SortOrder>;
};

export type CarePlanBenefit = {
  __typename?: 'CarePlanBenefit';
  benefit: CareBenefit;
  benefitId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  includedUses?: Maybe<Scalars['Int']>;
  plan: CarePlan;
  planId: Scalars['String'];
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages: Scalars['Float'];
  reportingExpectedValue: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CarePlanBenefitAvgAggregateOutputType = {
  __typename?: 'CarePlanBenefitAvgAggregateOutputType';
  displayOrder?: Maybe<Scalars['Float']>;
  includedUses?: Maybe<Scalars['Float']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Float']>;
};

export type CarePlanBenefitAvgOrderByAggregateInput = {
  displayOrder?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
};

export type CarePlanBenefitCountAggregateOutputType = {
  __typename?: 'CarePlanBenefitCountAggregateOutputType';
  _all: Scalars['Int'];
  benefitId: Scalars['Int'];
  createdAt: Scalars['Int'];
  displayOrder: Scalars['Int'];
  id: Scalars['Int'];
  includedUses: Scalars['Int'];
  planId: Scalars['Int'];
  projectedSavings: Scalars['Int'];
  providedDiscountPercentage: Scalars['Int'];
  reportingExpectedUsages: Scalars['Int'];
  reportingExpectedValue: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CarePlanBenefitCountOrderByAggregateInput = {
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanBenefitCreateInput = {
  benefit: CareBenefitCreateNestedOneWithoutPlanBenefitsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  plan: CarePlanCreateNestedOneWithoutPlanBenefitsInput;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitCreateManyBenefitInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitCreateManyBenefitInputEnvelope = {
  data: Array<CarePlanBenefitCreateManyBenefitInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanBenefitCreateManyInput = {
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitCreateManyPlanInput = {
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitCreateManyPlanInputEnvelope = {
  data: Array<CarePlanBenefitCreateManyPlanInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanBenefitCreateNestedManyWithoutBenefitInput = {
  connect?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CarePlanBenefitCreateWithoutBenefitInput>>;
  createMany?: Maybe<CarePlanBenefitCreateManyBenefitInputEnvelope>;
};

export type CarePlanBenefitCreateNestedManyWithoutPlanInput = {
  connect?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitCreateOrConnectWithoutPlanInput>>;
  create?: Maybe<Array<CarePlanBenefitCreateWithoutPlanInput>>;
  createMany?: Maybe<CarePlanBenefitCreateManyPlanInputEnvelope>;
};

export type CarePlanBenefitCreateOrConnectWithoutBenefitInput = {
  create: CarePlanBenefitCreateWithoutBenefitInput;
  where: CarePlanBenefitWhereUniqueInput;
};

export type CarePlanBenefitCreateOrConnectWithoutPlanInput = {
  create: CarePlanBenefitCreateWithoutPlanInput;
  where: CarePlanBenefitWhereUniqueInput;
};

export type CarePlanBenefitCreateWithoutBenefitInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  plan: CarePlanCreateNestedOneWithoutPlanBenefitsInput;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitCreateWithoutPlanInput = {
  benefit: CareBenefitCreateNestedOneWithoutPlanBenefitsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryover = {
  __typename?: 'CarePlanBenefitEnrollmentCarryover';
  amount: Scalars['Int'];
  benefit: CareBenefit;
  benefitId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  destinationPlanEnrollment?: Maybe<CarePlanEnrollment>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sourcePlanEnrollment?: Maybe<CarePlanEnrollment>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type CarePlanBenefitEnrollmentCarryoverDestinationPlanEnrollmentArgs = {
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type CarePlanBenefitEnrollmentCarryoverSourcePlanEnrollmentArgs = {
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanBenefitEnrollmentCarryoverAvgAggregateOutputType = {
  __typename?: 'CarePlanBenefitEnrollmentCarryoverAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
};

export type CarePlanBenefitEnrollmentCarryoverAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type CarePlanBenefitEnrollmentCarryoverCountAggregateOutputType = {
  __typename?: 'CarePlanBenefitEnrollmentCarryoverCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  benefitId: Scalars['Int'];
  createdAt: Scalars['Int'];
  destinationPlanEnrollmentId: Scalars['Int'];
  id: Scalars['Int'];
  sourcePlanEnrollmentId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CarePlanBenefitEnrollmentCarryoverCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  destinationPlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  sourcePlanEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateInput = {
  amount?: Maybe<Scalars['Int']>;
  benefit: CareBenefitCreateNestedOneWithoutEnrollmentCarryoversInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutReceivedCarePlanBenefitCarryoversInput>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutForwardedCarePlanBenefitCarryoversInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateManyBenefitInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateManyBenefitInputEnvelope = {
  data: Array<CarePlanBenefitEnrollmentCarryoverCreateManyBenefitInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateManyDestinationPlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateManyDestinationPlanEnrollmentInputEnvelope = {
  data: Array<CarePlanBenefitEnrollmentCarryoverCreateManyDestinationPlanEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateManySourcePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateManySourcePlanEnrollmentInputEnvelope = {
  data: Array<CarePlanBenefitEnrollmentCarryoverCreateManySourcePlanEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutBenefitInput = {
  connect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateWithoutBenefitInput>>;
  createMany?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateManyBenefitInputEnvelope>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput = {
  connect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutDestinationPlanEnrollmentInput>>;
  create?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateWithoutDestinationPlanEnrollmentInput>>;
  createMany?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateManyDestinationPlanEnrollmentInputEnvelope>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput = {
  connect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutSourcePlanEnrollmentInput>>;
  create?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateWithoutSourcePlanEnrollmentInput>>;
  createMany?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateManySourcePlanEnrollmentInputEnvelope>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutBenefitInput = {
  create: CarePlanBenefitEnrollmentCarryoverCreateWithoutBenefitInput;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};

export type CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutDestinationPlanEnrollmentInput = {
  create: CarePlanBenefitEnrollmentCarryoverCreateWithoutDestinationPlanEnrollmentInput;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};

export type CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutSourcePlanEnrollmentInput = {
  create: CarePlanBenefitEnrollmentCarryoverCreateWithoutSourcePlanEnrollmentInput;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};

export type CarePlanBenefitEnrollmentCarryoverCreateWithoutBenefitInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutReceivedCarePlanBenefitCarryoversInput>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutForwardedCarePlanBenefitCarryoversInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateWithoutDestinationPlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  benefit: CareBenefitCreateNestedOneWithoutEnrollmentCarryoversInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutForwardedCarePlanBenefitCarryoversInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverCreateWithoutSourcePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  benefit: CareBenefitCreateNestedOneWithoutEnrollmentCarryoversInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutReceivedCarePlanBenefitCarryoversInput>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverGroupByOutputType = {
  __typename?: 'CarePlanBenefitEnrollmentCarryoverGroupByOutputType';
  _avg?: Maybe<CarePlanBenefitEnrollmentCarryoverAvgAggregateOutputType>;
  _count?: Maybe<CarePlanBenefitEnrollmentCarryoverCountAggregateOutputType>;
  _max?: Maybe<CarePlanBenefitEnrollmentCarryoverMaxAggregateOutputType>;
  _min?: Maybe<CarePlanBenefitEnrollmentCarryoverMinAggregateOutputType>;
  _sum?: Maybe<CarePlanBenefitEnrollmentCarryoverSumAggregateOutputType>;
  amount: Scalars['Int'];
  benefitId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CarePlanBenefitEnrollmentCarryoverListRelationFilter = {
  every?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereInput>;
  none?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereInput>;
  some?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereInput>;
};

export type CarePlanBenefitEnrollmentCarryoverMaxAggregateOutputType = {
  __typename?: 'CarePlanBenefitEnrollmentCarryoverMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  destinationPlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  sourcePlanEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanBenefitEnrollmentCarryoverMinAggregateOutputType = {
  __typename?: 'CarePlanBenefitEnrollmentCarryoverMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  destinationPlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  sourcePlanEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanBenefitEnrollmentCarryoverOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CarePlanBenefitEnrollmentCarryoverOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CarePlanBenefitEnrollmentCarryoverOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  destinationPlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  destinationPlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  sourcePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  sourcePlanEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CarePlanBenefitEnrollmentCarryoverOrderByRelevanceFieldEnum {
  BenefitId = 'benefitId',
  DestinationPlanEnrollmentId = 'destinationPlanEnrollmentId',
  Id = 'id',
  SourcePlanEnrollmentId = 'sourcePlanEnrollmentId'
}

export type CarePlanBenefitEnrollmentCarryoverOrderByRelevanceInput = {
  fields: Array<CarePlanBenefitEnrollmentCarryoverOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CarePlanBenefitEnrollmentCarryoverOrderByWithAggregationInput = {
  _avg?: Maybe<CarePlanBenefitEnrollmentCarryoverAvgOrderByAggregateInput>;
  _count?: Maybe<CarePlanBenefitEnrollmentCarryoverCountOrderByAggregateInput>;
  _max?: Maybe<CarePlanBenefitEnrollmentCarryoverMaxOrderByAggregateInput>;
  _min?: Maybe<CarePlanBenefitEnrollmentCarryoverMinOrderByAggregateInput>;
  _sum?: Maybe<CarePlanBenefitEnrollmentCarryoverSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  destinationPlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  sourcePlanEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanBenefitEnrollmentCarryoverOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CarePlanBenefitEnrollmentCarryoverOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  destinationPlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  destinationPlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  sourcePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  sourcePlanEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanBenefitEnrollmentCarryoverOrderByWithRelationInput = {
  _relevance?: Maybe<CarePlanBenefitEnrollmentCarryoverOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  destinationPlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  destinationPlanEnrollmentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  sourcePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  sourcePlanEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CarePlanBenefitEnrollmentCarryoverScalarFieldEnum {
  Amount = 'amount',
  BenefitId = 'benefitId',
  CreatedAt = 'createdAt',
  DestinationPlanEnrollmentId = 'destinationPlanEnrollmentId',
  Id = 'id',
  SourcePlanEnrollmentId = 'sourcePlanEnrollmentId',
  UpdatedAt = 'updatedAt'
}

export type CarePlanBenefitEnrollmentCarryoverScalarWhereInput = {
  AND?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverScalarWhereInput>>;
  NOT?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverScalarWhereInput>>;
  OR?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverScalarWhereInput>>;
  amount?: Maybe<IntFilter>;
  benefitId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  destinationPlanEnrollmentId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  sourcePlanEnrollmentId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanBenefitEnrollmentCarryoverScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntWithAggregatesFilter>;
  benefitId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  destinationPlanEnrollmentId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  sourcePlanEnrollmentId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CarePlanBenefitEnrollmentCarryoverSourcePlanEnrollmentIdDestinationPlanEnrollmentIdBenefitIdCompoundUniqueInput = {
  benefitId: Scalars['String'];
  destinationPlanEnrollmentId: Scalars['String'];
  sourcePlanEnrollmentId: Scalars['String'];
};

export type CarePlanBenefitEnrollmentCarryoverSumAggregateOutputType = {
  __typename?: 'CarePlanBenefitEnrollmentCarryoverSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
};

export type CarePlanBenefitEnrollmentCarryoverSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedCreateInput = {
  amount?: Maybe<Scalars['Int']>;
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutBenefitInput = {
  connect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateWithoutBenefitInput>>;
  createMany?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateManyBenefitInputEnvelope>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput = {
  connect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutDestinationPlanEnrollmentInput>>;
  create?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateWithoutDestinationPlanEnrollmentInput>>;
  createMany?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateManyDestinationPlanEnrollmentInputEnvelope>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput = {
  connect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutSourcePlanEnrollmentInput>>;
  create?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateWithoutSourcePlanEnrollmentInput>>;
  createMany?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateManySourcePlanEnrollmentInputEnvelope>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedCreateWithoutBenefitInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedCreateWithoutDestinationPlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedCreateWithoutSourcePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutBenefitInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutBenefitNestedInput = {
  connect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateWithoutBenefitInput>>;
  createMany?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateManyBenefitInputEnvelope>;
  delete?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpdateWithWhereUniqueWithoutBenefitInput>>;
  updateMany?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpdateManyWithWhereWithoutBenefitInput>>;
  upsert?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpsertWithWhereUniqueWithoutBenefitInput>>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput = {
  connect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutDestinationPlanEnrollmentInput>>;
  create?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateWithoutDestinationPlanEnrollmentInput>>;
  createMany?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateManyDestinationPlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpdateWithWhereUniqueWithoutDestinationPlanEnrollmentInput>>;
  updateMany?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpdateManyWithWhereWithoutDestinationPlanEnrollmentInput>>;
  upsert?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpsertWithWhereUniqueWithoutDestinationPlanEnrollmentInput>>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput = {
  connect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutSourcePlanEnrollmentInput>>;
  create?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateWithoutSourcePlanEnrollmentInput>>;
  createMany?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateManySourcePlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpdateWithWhereUniqueWithoutSourcePlanEnrollmentInput>>;
  updateMany?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpdateManyWithWhereWithoutSourcePlanEnrollmentInput>>;
  upsert?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpsertWithWhereUniqueWithoutSourcePlanEnrollmentInput>>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedUpdateWithoutBenefitInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedUpdateWithoutDestinationPlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUncheckedUpdateWithoutSourcePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutEnrollmentCarryoversNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutReceivedCarePlanBenefitCarryoversNestedInput>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutForwardedCarePlanBenefitCarryoversNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateManyWithWhereWithoutBenefitInput = {
  data: CarePlanBenefitEnrollmentCarryoverUpdateManyMutationInput;
  where: CarePlanBenefitEnrollmentCarryoverScalarWhereInput;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateManyWithWhereWithoutDestinationPlanEnrollmentInput = {
  data: CarePlanBenefitEnrollmentCarryoverUpdateManyMutationInput;
  where: CarePlanBenefitEnrollmentCarryoverScalarWhereInput;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateManyWithWhereWithoutSourcePlanEnrollmentInput = {
  data: CarePlanBenefitEnrollmentCarryoverUpdateManyMutationInput;
  where: CarePlanBenefitEnrollmentCarryoverScalarWhereInput;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutBenefitNestedInput = {
  connect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateWithoutBenefitInput>>;
  createMany?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateManyBenefitInputEnvelope>;
  delete?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpdateWithWhereUniqueWithoutBenefitInput>>;
  updateMany?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpdateManyWithWhereWithoutBenefitInput>>;
  upsert?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpsertWithWhereUniqueWithoutBenefitInput>>;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput = {
  connect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutDestinationPlanEnrollmentInput>>;
  create?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateWithoutDestinationPlanEnrollmentInput>>;
  createMany?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateManyDestinationPlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpdateWithWhereUniqueWithoutDestinationPlanEnrollmentInput>>;
  updateMany?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpdateManyWithWhereWithoutDestinationPlanEnrollmentInput>>;
  upsert?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpsertWithWhereUniqueWithoutDestinationPlanEnrollmentInput>>;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput = {
  connect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateOrConnectWithoutSourcePlanEnrollmentInput>>;
  create?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverCreateWithoutSourcePlanEnrollmentInput>>;
  createMany?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateManySourcePlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpdateWithWhereUniqueWithoutSourcePlanEnrollmentInput>>;
  updateMany?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpdateManyWithWhereWithoutSourcePlanEnrollmentInput>>;
  upsert?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverUpsertWithWhereUniqueWithoutSourcePlanEnrollmentInput>>;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateWithWhereUniqueWithoutBenefitInput = {
  data: CarePlanBenefitEnrollmentCarryoverUpdateWithoutBenefitInput;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateWithWhereUniqueWithoutDestinationPlanEnrollmentInput = {
  data: CarePlanBenefitEnrollmentCarryoverUpdateWithoutDestinationPlanEnrollmentInput;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateWithWhereUniqueWithoutSourcePlanEnrollmentInput = {
  data: CarePlanBenefitEnrollmentCarryoverUpdateWithoutSourcePlanEnrollmentInput;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateWithoutBenefitInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutReceivedCarePlanBenefitCarryoversNestedInput>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutForwardedCarePlanBenefitCarryoversNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateWithoutDestinationPlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutEnrollmentCarryoversNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutForwardedCarePlanBenefitCarryoversNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUpdateWithoutSourcePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutEnrollmentCarryoversNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationPlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutReceivedCarePlanBenefitCarryoversNestedInput>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitEnrollmentCarryoverUpsertWithWhereUniqueWithoutBenefitInput = {
  create: CarePlanBenefitEnrollmentCarryoverCreateWithoutBenefitInput;
  update: CarePlanBenefitEnrollmentCarryoverUpdateWithoutBenefitInput;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};

export type CarePlanBenefitEnrollmentCarryoverUpsertWithWhereUniqueWithoutDestinationPlanEnrollmentInput = {
  create: CarePlanBenefitEnrollmentCarryoverCreateWithoutDestinationPlanEnrollmentInput;
  update: CarePlanBenefitEnrollmentCarryoverUpdateWithoutDestinationPlanEnrollmentInput;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};

export type CarePlanBenefitEnrollmentCarryoverUpsertWithWhereUniqueWithoutSourcePlanEnrollmentInput = {
  create: CarePlanBenefitEnrollmentCarryoverCreateWithoutSourcePlanEnrollmentInput;
  update: CarePlanBenefitEnrollmentCarryoverUpdateWithoutSourcePlanEnrollmentInput;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};

export type CarePlanBenefitEnrollmentCarryoverWhereInput = {
  AND?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereInput>>;
  NOT?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereInput>>;
  OR?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereInput>>;
  amount?: Maybe<IntFilter>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  destinationPlanEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  destinationPlanEnrollmentId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  sourcePlanEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  sourcePlanEnrollmentId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanBenefitEnrollmentCarryoverWhereUniqueInput = {
  AND?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereInput>>;
  NOT?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereInput>>;
  OR?: Maybe<Array<CarePlanBenefitEnrollmentCarryoverWhereInput>>;
  amount?: Maybe<IntFilter>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  destinationPlanEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  destinationPlanEnrollmentId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  sourcePlanEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  sourcePlanEnrollmentId?: Maybe<StringNullableFilter>;
  sourcePlanEnrollmentId_destinationPlanEnrollmentId_benefitId?: Maybe<CarePlanBenefitEnrollmentCarryoverSourcePlanEnrollmentIdDestinationPlanEnrollmentIdBenefitIdCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanBenefitGroupByOutputType = {
  __typename?: 'CarePlanBenefitGroupByOutputType';
  _avg?: Maybe<CarePlanBenefitAvgAggregateOutputType>;
  _count?: Maybe<CarePlanBenefitCountAggregateOutputType>;
  _max?: Maybe<CarePlanBenefitMaxAggregateOutputType>;
  _min?: Maybe<CarePlanBenefitMinAggregateOutputType>;
  _sum?: Maybe<CarePlanBenefitSumAggregateOutputType>;
  benefitId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  includedUses?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages: Scalars['Float'];
  reportingExpectedValue: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CarePlanBenefitListRelationFilter = {
  every?: Maybe<CarePlanBenefitWhereInput>;
  none?: Maybe<CarePlanBenefitWhereInput>;
  some?: Maybe<CarePlanBenefitWhereInput>;
};

export type CarePlanBenefitMaxAggregateOutputType = {
  __typename?: 'CarePlanBenefitMaxAggregateOutputType';
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitMaxOrderByAggregateInput = {
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanBenefitMinAggregateOutputType = {
  __typename?: 'CarePlanBenefitMinAggregateOutputType';
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitMinOrderByAggregateInput = {
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanBenefitOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CarePlanBenefitOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CarePlanBenefitOrderByRelevanceInput>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  plan?: Maybe<CarePlanOrderByWithRelationInput>;
  planId?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CarePlanBenefitOrderByRelevanceFieldEnum {
  BenefitId = 'benefitId',
  Id = 'id',
  PlanId = 'planId',
  ProjectedSavings = 'projectedSavings'
}

export type CarePlanBenefitOrderByRelevanceInput = {
  fields: Array<CarePlanBenefitOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CarePlanBenefitOrderByWithAggregationInput = {
  _avg?: Maybe<CarePlanBenefitAvgOrderByAggregateInput>;
  _count?: Maybe<CarePlanBenefitCountOrderByAggregateInput>;
  _max?: Maybe<CarePlanBenefitMaxOrderByAggregateInput>;
  _min?: Maybe<CarePlanBenefitMinOrderByAggregateInput>;
  _sum?: Maybe<CarePlanBenefitSumOrderByAggregateInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanBenefitOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CarePlanBenefitOrderByRelevanceInput>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  plan?: Maybe<CarePlanOrderByWithRelationInput>;
  planId?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanBenefitOrderByWithRelationInput = {
  _relevance?: Maybe<CarePlanBenefitOrderByRelevanceInput>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  plan?: Maybe<CarePlanOrderByWithRelationInput>;
  planId?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanBenefitPlanIdDisplayOrderCompoundUniqueInput = {
  displayOrder: Scalars['Int'];
  planId: Scalars['String'];
};

export enum CarePlanBenefitScalarFieldEnum {
  BenefitId = 'benefitId',
  CreatedAt = 'createdAt',
  DisplayOrder = 'displayOrder',
  Id = 'id',
  IncludedUses = 'includedUses',
  PlanId = 'planId',
  ProjectedSavings = 'projectedSavings',
  ProvidedDiscountPercentage = 'providedDiscountPercentage',
  ReportingExpectedUsages = 'reportingExpectedUsages',
  ReportingExpectedValue = 'reportingExpectedValue',
  UpdatedAt = 'updatedAt'
}

export type CarePlanBenefitScalarWhereInput = {
  AND?: Maybe<Array<CarePlanBenefitScalarWhereInput>>;
  NOT?: Maybe<Array<CarePlanBenefitScalarWhereInput>>;
  OR?: Maybe<Array<CarePlanBenefitScalarWhereInput>>;
  benefitId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  displayOrder?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  includedUses?: Maybe<IntNullableFilter>;
  planId?: Maybe<StringFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  providedDiscountPercentage?: Maybe<FloatNullableFilter>;
  reportingExpectedUsages?: Maybe<FloatFilter>;
  reportingExpectedValue?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanBenefitScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CarePlanBenefitScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CarePlanBenefitScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CarePlanBenefitScalarWhereWithAggregatesInput>>;
  benefitId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  displayOrder?: Maybe<IntNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  includedUses?: Maybe<IntNullableWithAggregatesFilter>;
  planId?: Maybe<StringWithAggregatesFilter>;
  projectedSavings?: Maybe<StringNullableWithAggregatesFilter>;
  providedDiscountPercentage?: Maybe<FloatNullableWithAggregatesFilter>;
  reportingExpectedUsages?: Maybe<FloatWithAggregatesFilter>;
  reportingExpectedValue?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CarePlanBenefitSumAggregateOutputType = {
  __typename?: 'CarePlanBenefitSumAggregateOutputType';
  displayOrder?: Maybe<Scalars['Int']>;
  includedUses?: Maybe<Scalars['Int']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
};

export type CarePlanBenefitSumOrderByAggregateInput = {
  displayOrder?: Maybe<SortOrder>;
  includedUses?: Maybe<SortOrder>;
  providedDiscountPercentage?: Maybe<SortOrder>;
  reportingExpectedUsages?: Maybe<SortOrder>;
  reportingExpectedValue?: Maybe<SortOrder>;
};

export type CarePlanBenefitUncheckedCreateInput = {
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUncheckedCreateNestedManyWithoutBenefitInput = {
  connect?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CarePlanBenefitCreateWithoutBenefitInput>>;
  createMany?: Maybe<CarePlanBenefitCreateManyBenefitInputEnvelope>;
};

export type CarePlanBenefitUncheckedCreateNestedManyWithoutPlanInput = {
  connect?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitCreateOrConnectWithoutPlanInput>>;
  create?: Maybe<Array<CarePlanBenefitCreateWithoutPlanInput>>;
  createMany?: Maybe<CarePlanBenefitCreateManyPlanInputEnvelope>;
};

export type CarePlanBenefitUncheckedCreateWithoutBenefitInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUncheckedCreateWithoutPlanInput = {
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUncheckedUpdateInput = {
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUncheckedUpdateManyInput = {
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUncheckedUpdateManyWithoutBenefitInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUncheckedUpdateManyWithoutBenefitNestedInput = {
  connect?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CarePlanBenefitCreateWithoutBenefitInput>>;
  createMany?: Maybe<CarePlanBenefitCreateManyBenefitInputEnvelope>;
  delete?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanBenefitScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanBenefitUpdateWithWhereUniqueWithoutBenefitInput>>;
  updateMany?: Maybe<Array<CarePlanBenefitUpdateManyWithWhereWithoutBenefitInput>>;
  upsert?: Maybe<Array<CarePlanBenefitUpsertWithWhereUniqueWithoutBenefitInput>>;
};

export type CarePlanBenefitUncheckedUpdateManyWithoutPlanInput = {
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUncheckedUpdateManyWithoutPlanNestedInput = {
  connect?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitCreateOrConnectWithoutPlanInput>>;
  create?: Maybe<Array<CarePlanBenefitCreateWithoutPlanInput>>;
  createMany?: Maybe<CarePlanBenefitCreateManyPlanInputEnvelope>;
  delete?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanBenefitScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanBenefitUpdateWithWhereUniqueWithoutPlanInput>>;
  updateMany?: Maybe<Array<CarePlanBenefitUpdateManyWithWhereWithoutPlanInput>>;
  upsert?: Maybe<Array<CarePlanBenefitUpsertWithWhereUniqueWithoutPlanInput>>;
};

export type CarePlanBenefitUncheckedUpdateWithoutBenefitInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUncheckedUpdateWithoutPlanInput = {
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUpdateInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutPlanBenefitsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutPlanBenefitsNestedInput>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUpdateManyWithWhereWithoutBenefitInput = {
  data: CarePlanBenefitUpdateManyMutationInput;
  where: CarePlanBenefitScalarWhereInput;
};

export type CarePlanBenefitUpdateManyWithWhereWithoutPlanInput = {
  data: CarePlanBenefitUpdateManyMutationInput;
  where: CarePlanBenefitScalarWhereInput;
};

export type CarePlanBenefitUpdateManyWithoutBenefitNestedInput = {
  connect?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<CarePlanBenefitCreateWithoutBenefitInput>>;
  createMany?: Maybe<CarePlanBenefitCreateManyBenefitInputEnvelope>;
  delete?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanBenefitScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanBenefitUpdateWithWhereUniqueWithoutBenefitInput>>;
  updateMany?: Maybe<Array<CarePlanBenefitUpdateManyWithWhereWithoutBenefitInput>>;
  upsert?: Maybe<Array<CarePlanBenefitUpsertWithWhereUniqueWithoutBenefitInput>>;
};

export type CarePlanBenefitUpdateManyWithoutPlanNestedInput = {
  connect?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanBenefitCreateOrConnectWithoutPlanInput>>;
  create?: Maybe<Array<CarePlanBenefitCreateWithoutPlanInput>>;
  createMany?: Maybe<CarePlanBenefitCreateManyPlanInputEnvelope>;
  delete?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanBenefitScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanBenefitWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanBenefitUpdateWithWhereUniqueWithoutPlanInput>>;
  updateMany?: Maybe<Array<CarePlanBenefitUpdateManyWithWhereWithoutPlanInput>>;
  upsert?: Maybe<Array<CarePlanBenefitUpsertWithWhereUniqueWithoutPlanInput>>;
};

export type CarePlanBenefitUpdateWithWhereUniqueWithoutBenefitInput = {
  data: CarePlanBenefitUpdateWithoutBenefitInput;
  where: CarePlanBenefitWhereUniqueInput;
};

export type CarePlanBenefitUpdateWithWhereUniqueWithoutPlanInput = {
  data: CarePlanBenefitUpdateWithoutPlanInput;
  where: CarePlanBenefitWhereUniqueInput;
};

export type CarePlanBenefitUpdateWithoutBenefitInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutPlanBenefitsNestedInput>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUpdateWithoutPlanInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutPlanBenefitsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages?: Maybe<Scalars['Float']>;
  reportingExpectedValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanBenefitUpsertWithWhereUniqueWithoutBenefitInput = {
  create: CarePlanBenefitCreateWithoutBenefitInput;
  update: CarePlanBenefitUpdateWithoutBenefitInput;
  where: CarePlanBenefitWhereUniqueInput;
};

export type CarePlanBenefitUpsertWithWhereUniqueWithoutPlanInput = {
  create: CarePlanBenefitCreateWithoutPlanInput;
  update: CarePlanBenefitUpdateWithoutPlanInput;
  where: CarePlanBenefitWhereUniqueInput;
};

export type CarePlanBenefitWhereInput = {
  AND?: Maybe<Array<CarePlanBenefitWhereInput>>;
  NOT?: Maybe<Array<CarePlanBenefitWhereInput>>;
  OR?: Maybe<Array<CarePlanBenefitWhereInput>>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  displayOrder?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  includedUses?: Maybe<IntNullableFilter>;
  plan?: Maybe<CarePlanScalarRelationFilter>;
  planId?: Maybe<StringFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  providedDiscountPercentage?: Maybe<FloatNullableFilter>;
  reportingExpectedUsages?: Maybe<FloatFilter>;
  reportingExpectedValue?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanBenefitWhereUniqueInput = {
  AND?: Maybe<Array<CarePlanBenefitWhereInput>>;
  NOT?: Maybe<Array<CarePlanBenefitWhereInput>>;
  OR?: Maybe<Array<CarePlanBenefitWhereInput>>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  displayOrder?: Maybe<IntNullableFilter>;
  id?: Maybe<Scalars['String']>;
  includedUses?: Maybe<IntNullableFilter>;
  plan?: Maybe<CarePlanScalarRelationFilter>;
  planId?: Maybe<StringFilter>;
  planId_displayOrder?: Maybe<CarePlanBenefitPlanIdDisplayOrderCompoundUniqueInput>;
  projectedSavings?: Maybe<StringNullableFilter>;
  providedDiscountPercentage?: Maybe<FloatNullableFilter>;
  reportingExpectedUsages?: Maybe<FloatFilter>;
  reportingExpectedValue?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanCountAggregateOutputType = {
  __typename?: 'CarePlanCountAggregateOutputType';
  _all: Scalars['Int'];
  allowSelfRenewal: Scalars['Int'];
  associatedCarePlanProviderGroupId: Scalars['Int'];
  billingCycle: Scalars['Int'];
  createdAt: Scalars['Int'];
  defaultRenewalSuccessorPlanId: Scalars['Int'];
  description: Scalars['Int'];
  earliestTargetPetAgeInMonths: Scalars['Int'];
  editorNotes: Scalars['Int'];
  flowAlias: Scalars['Int'];
  id: Scalars['Int'];
  isAcceptingPreEnrollments: Scalars['Int'];
  latestTargetPetAgeInMonths: Scalars['Int'];
  marketingInformation: Scalars['Int'];
  organizationId: Scalars['Int'];
  planDiscount: Scalars['Int'];
  pricePerRenewal: Scalars['Int'];
  projectedSavings: Scalars['Int'];
  publishEndDate: Scalars['Int'];
  publishStartDate: Scalars['Int'];
  published: Scalars['Int'];
  renewalCycle: Scalars['Int'];
  salesTaxCentsPerMonth: Scalars['Int'];
  signupFeePricing: Scalars['Int'];
  signupFeeStripeProductId: Scalars['Int'];
  stripePriceId: Scalars['Int'];
  targetSpecies: Scalars['Int'];
  themeColor: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CarePlanCountOrderByAggregateInput = {
  allowSelfRenewal?: Maybe<SortOrder>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultRenewalSuccessorPlanId?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAcceptingPreEnrollments?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  marketingInformation?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  planDiscount?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  publishEndDate?: Maybe<SortOrder>;
  publishStartDate?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  signupFeePricing?: Maybe<SortOrder>;
  signupFeeStripeProductId?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanCountOutputType = {
  __typename?: 'CarePlanCountOutputType';
  currentPlanEnrollmentSupportEvents: Scalars['Int'];
  enrollments: Scalars['Int'];
  explicitRenewalSuccessors: Scalars['Int'];
  newPlanEnrollmentSupportEvents: Scalars['Int'];
  planBenefits: Scalars['Int'];
  planPricings: Scalars['Int'];
  renewalPredecessorPlan: Scalars['Int'];
  selectedByRenewalEmailEnrollments: Scalars['Int'];
};

export type CarePlanCreateInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedPlansInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanCreateNestedOneWithoutRenewalPredecessorPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanInput>;
  organization: OrganizationCreateNestedOneWithoutCarePlansInput;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateManyAssociatedCarePlanProviderGroupInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  organizationId: Scalars['String'];
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateManyAssociatedCarePlanProviderGroupInputEnvelope = {
  data: Array<CarePlanCreateManyAssociatedCarePlanProviderGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanCreateManyDefaultRenewalSuccessorPlanInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  organizationId: Scalars['String'];
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateManyDefaultRenewalSuccessorPlanInputEnvelope = {
  data: Array<CarePlanCreateManyDefaultRenewalSuccessorPlanInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanCreateManyInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  organizationId: Scalars['String'];
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateManyOrganizationInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateManyOrganizationInputEnvelope = {
  data: Array<CarePlanCreateManyOrganizationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput = {
  connect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CarePlanCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CarePlanCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
};

export type CarePlanCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput = {
  connect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanCreateOrConnectWithoutDefaultRenewalSuccessorPlanInput>>;
  create?: Maybe<Array<CarePlanCreateWithoutDefaultRenewalSuccessorPlanInput>>;
  createMany?: Maybe<CarePlanCreateManyDefaultRenewalSuccessorPlanInputEnvelope>;
};

export type CarePlanCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CarePlanCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CarePlanCreateManyOrganizationInputEnvelope>;
};

export type CarePlanCreateNestedOneWithoutCurrentPlanEnrollmentSupportEventsInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutCurrentPlanEnrollmentSupportEventsInput>;
  create?: Maybe<CarePlanCreateWithoutCurrentPlanEnrollmentSupportEventsInput>;
};

export type CarePlanCreateNestedOneWithoutEnrollmentsInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutEnrollmentsInput>;
  create?: Maybe<CarePlanCreateWithoutEnrollmentsInput>;
};

export type CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutExplicitRenewalSuccessorsInput>;
  create?: Maybe<CarePlanCreateWithoutExplicitRenewalSuccessorsInput>;
};

export type CarePlanCreateNestedOneWithoutNewPlanEnrollmentSupportEventsInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutNewPlanEnrollmentSupportEventsInput>;
  create?: Maybe<CarePlanCreateWithoutNewPlanEnrollmentSupportEventsInput>;
};

export type CarePlanCreateNestedOneWithoutPlanBenefitsInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutPlanBenefitsInput>;
  create?: Maybe<CarePlanCreateWithoutPlanBenefitsInput>;
};

export type CarePlanCreateNestedOneWithoutPlanPricingsInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutPlanPricingsInput>;
  create?: Maybe<CarePlanCreateWithoutPlanPricingsInput>;
};

export type CarePlanCreateNestedOneWithoutRenewalPredecessorPlanInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutRenewalPredecessorPlanInput>;
  create?: Maybe<CarePlanCreateWithoutRenewalPredecessorPlanInput>;
};

export type CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutSelectedByRenewalEmailEnrollmentsInput>;
  create?: Maybe<CarePlanCreateWithoutSelectedByRenewalEmailEnrollmentsInput>;
};

export type CarePlanCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput = {
  create: CarePlanCreateWithoutAssociatedCarePlanProviderGroupInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanCreateOrConnectWithoutCurrentPlanEnrollmentSupportEventsInput = {
  create: CarePlanCreateWithoutCurrentPlanEnrollmentSupportEventsInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanCreateOrConnectWithoutDefaultRenewalSuccessorPlanInput = {
  create: CarePlanCreateWithoutDefaultRenewalSuccessorPlanInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanCreateOrConnectWithoutEnrollmentsInput = {
  create: CarePlanCreateWithoutEnrollmentsInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanCreateOrConnectWithoutExplicitRenewalSuccessorsInput = {
  create: CarePlanCreateWithoutExplicitRenewalSuccessorsInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanCreateOrConnectWithoutNewPlanEnrollmentSupportEventsInput = {
  create: CarePlanCreateWithoutNewPlanEnrollmentSupportEventsInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanCreateOrConnectWithoutOrganizationInput = {
  create: CarePlanCreateWithoutOrganizationInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanCreateOrConnectWithoutPlanBenefitsInput = {
  create: CarePlanCreateWithoutPlanBenefitsInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanCreateOrConnectWithoutPlanPricingsInput = {
  create: CarePlanCreateWithoutPlanPricingsInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanCreateOrConnectWithoutRenewalPredecessorPlanInput = {
  create: CarePlanCreateWithoutRenewalPredecessorPlanInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanCreateOrConnectWithoutSelectedByRenewalEmailEnrollmentsInput = {
  create: CarePlanCreateWithoutSelectedByRenewalEmailEnrollmentsInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanCreateWithoutAssociatedCarePlanProviderGroupInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanCreateNestedOneWithoutRenewalPredecessorPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanInput>;
  organization: OrganizationCreateNestedOneWithoutCarePlansInput;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateWithoutCurrentPlanEnrollmentSupportEventsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedPlansInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanCreateNestedOneWithoutRenewalPredecessorPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanInput>;
  organization: OrganizationCreateNestedOneWithoutCarePlansInput;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateWithoutDefaultRenewalSuccessorPlanInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedPlansInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanInput>;
  organization: OrganizationCreateNestedOneWithoutCarePlansInput;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateWithoutEnrollmentsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedPlansInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanCreateNestedOneWithoutRenewalPredecessorPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanInput>;
  organization: OrganizationCreateNestedOneWithoutCarePlansInput;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateWithoutExplicitRenewalSuccessorsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedPlansInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanCreateNestedOneWithoutRenewalPredecessorPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanInput>;
  organization: OrganizationCreateNestedOneWithoutCarePlansInput;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateWithoutNewPlanEnrollmentSupportEventsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedPlansInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanCreateNestedOneWithoutRenewalPredecessorPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  organization: OrganizationCreateNestedOneWithoutCarePlansInput;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateWithoutOrganizationInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedPlansInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanCreateNestedOneWithoutRenewalPredecessorPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanInput>;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateWithoutPlanBenefitsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedPlansInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanCreateNestedOneWithoutRenewalPredecessorPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanInput>;
  organization: OrganizationCreateNestedOneWithoutCarePlansInput;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateWithoutPlanPricingsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedPlansInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanCreateNestedOneWithoutRenewalPredecessorPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanInput>;
  organization: OrganizationCreateNestedOneWithoutCarePlansInput;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateWithoutRenewalPredecessorPlanInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedPlansInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanCreateNestedOneWithoutRenewalPredecessorPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanInput>;
  organization: OrganizationCreateNestedOneWithoutCarePlansInput;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanCreateWithoutSelectedByRenewalEmailEnrollmentsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedPlansInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanCreateNestedOneWithoutRenewalPredecessorPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanInput>;
  organization: OrganizationCreateNestedOneWithoutCarePlansInput;
  planBenefits?: Maybe<CarePlanBenefitCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum CarePlanCycleType {
  Annually = 'Annually',
  Monthly = 'Monthly',
  Semianually = 'Semianually'
}

export type CarePlanEnrollment = {
  __typename?: 'CarePlanEnrollment';
  _count: CarePlanEnrollmentCountOutputType;
  associatedUsages: Array<CareBenefitUsage>;
  autoRenews: Scalars['Boolean'];
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscription>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps: Array<CareSubscriptionTrueUp>;
  createdAt: Scalars['DateTime'];
  enrollmentPayments: Array<CareEnrollmentPayment>;
  enrollmentSupportEvents: Array<EnrollmentSupportEvent>;
  enrollmentToStripeInvoiceItems: Array<CareEnrollmentToStripeInvoiceItem>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated use CarePlanPricing instead */
  explicitRenewalSucccesorPlan?: Maybe<CarePlan>;
  /** @deprecated use CarePlanPricing instead */
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricing>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers: Array<CarePlanBenefitEnrollmentCarryover>;
  id: Scalars['String'];
  organizationPet: OrganizationPet;
  organizationPetId: Scalars['String'];
  plan: CarePlan;
  planId: Scalars['String'];
  planPricing?: Maybe<CarePlanPricing>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers: Array<CarePlanBenefitEnrollmentCarryover>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated use CarePlanPricing instead */
  renewalEmailSelectedTargetPlan?: Maybe<CarePlan>;
  /** @deprecated use CarePlanPricing instead */
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricing>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollment>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollment>;
  startDate: Scalars['DateTime'];
  status: EnrollmentStatus;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type CarePlanEnrollmentAssociatedUsagesArgs = {
  cursor?: Maybe<CareBenefitUsageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageWhereInput>;
};


export type CarePlanEnrollmentCareStripeSubscriptionArgs = {
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type CarePlanEnrollmentCareSubscriptionTrueUpsArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareSubscriptionTrueUpScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
};


export type CarePlanEnrollmentEnrollmentPaymentsArgs = {
  cursor?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareEnrollmentPaymentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentPaymentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};


export type CarePlanEnrollmentEnrollmentSupportEventsArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type CarePlanEnrollmentEnrollmentToStripeInvoiceItemsArgs = {
  cursor?: Maybe<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentToStripeInvoiceItemWhereInput>;
};


export type CarePlanEnrollmentExplicitRenewalSucccesorPlanArgs = {
  where?: Maybe<CarePlanWhereInput>;
};


export type CarePlanEnrollmentExplicitRenewalSuccessorPlanPricingArgs = {
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type CarePlanEnrollmentForwardedCarePlanBenefitCarryoversArgs = {
  cursor?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereInput>;
};


export type CarePlanEnrollmentPlanPricingArgs = {
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type CarePlanEnrollmentReceivedCarePlanBenefitCarryoversArgs = {
  cursor?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereInput>;
};


export type CarePlanEnrollmentRenewalEmailSelectedTargetPlanArgs = {
  where?: Maybe<CarePlanWhereInput>;
};


export type CarePlanEnrollmentRenewalEmailSelectedTargetPlanPricingArgs = {
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type CarePlanEnrollmentRenewalPredecessorEnrollmentArgs = {
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type CarePlanEnrollmentRenewalSuccessorEnrollmentArgs = {
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentCountAggregateOutputType = {
  __typename?: 'CarePlanEnrollmentCountAggregateOutputType';
  _all: Scalars['Int'];
  autoRenews: Scalars['Int'];
  cancelledAt: Scalars['Int'];
  careStripeSubscriptionId: Scalars['Int'];
  createdAt: Scalars['Int'];
  expirationDate: Scalars['Int'];
  explicitRenewalSuccessorPlanId: Scalars['Int'];
  explicitRenewalSuccessorPlanPricingId: Scalars['Int'];
  id: Scalars['Int'];
  organizationPetId: Scalars['Int'];
  planId: Scalars['Int'];
  planPricingId: Scalars['Int'];
  renewalEmailNoticeSentAt: Scalars['Int'];
  renewalEmailSelectedTargetPlanId: Scalars['Int'];
  renewalEmailSelectedTargetPlanPricingId: Scalars['Int'];
  renewalPredecessorEnrollmentId: Scalars['Int'];
  renewalRejectionReason: Scalars['Int'];
  startDate: Scalars['Int'];
  status: Scalars['Int'];
  stripeSubscriptionItemId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CarePlanEnrollmentCountOrderByAggregateInput = {
  autoRenews?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  explicitRenewalSuccessorPlanId?: Maybe<SortOrder>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationPetId?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  planPricingId?: Maybe<SortOrder>;
  renewalEmailNoticeSentAt?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlanId?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<SortOrder>;
  renewalPredecessorEnrollmentId?: Maybe<SortOrder>;
  renewalRejectionReason?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanEnrollmentCountOutputType = {
  __typename?: 'CarePlanEnrollmentCountOutputType';
  associatedUsages: Scalars['Int'];
  careSubscriptionTrueUps: Scalars['Int'];
  enrollmentPayments: Scalars['Int'];
  enrollmentSupportEvents: Scalars['Int'];
  enrollmentToStripeInvoiceItems: Scalars['Int'];
  forwardedCarePlanBenefitCarryovers: Scalars['Int'];
  receivedCarePlanBenefitCarryovers: Scalars['Int'];
};

export type CarePlanEnrollmentCreateInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateManyCareStripeSubscriptionInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateManyCareStripeSubscriptionInputEnvelope = {
  data: Array<CarePlanEnrollmentCreateManyCareStripeSubscriptionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanEnrollmentCreateManyExplicitRenewalSucccesorPlanInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateManyExplicitRenewalSucccesorPlanInputEnvelope = {
  data: Array<CarePlanEnrollmentCreateManyExplicitRenewalSucccesorPlanInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanEnrollmentCreateManyExplicitRenewalSuccessorPlanPricingInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateManyExplicitRenewalSuccessorPlanPricingInputEnvelope = {
  data: Array<CarePlanEnrollmentCreateManyExplicitRenewalSuccessorPlanPricingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanEnrollmentCreateManyInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateManyOrganizationPetInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateManyOrganizationPetInputEnvelope = {
  data: Array<CarePlanEnrollmentCreateManyOrganizationPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanEnrollmentCreateManyPlanInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateManyPlanInputEnvelope = {
  data: Array<CarePlanEnrollmentCreateManyPlanInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanEnrollmentCreateManyPlanPricingInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateManyPlanPricingInputEnvelope = {
  data: Array<CarePlanEnrollmentCreateManyPlanPricingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanInputEnvelope = {
  data: Array<CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanPricingInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanPricingInputEnvelope = {
  data: Array<CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanPricingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyCareStripeSubscriptionInputEnvelope>;
};

export type CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutExplicitRenewalSucccesorPlanInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutExplicitRenewalSucccesorPlanInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyExplicitRenewalSucccesorPlanInputEnvelope>;
};

export type CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutExplicitRenewalSuccessorPlanPricingInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutExplicitRenewalSuccessorPlanPricingInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyExplicitRenewalSuccessorPlanPricingInputEnvelope>;
};

export type CarePlanEnrollmentCreateNestedManyWithoutOrganizationPetInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyOrganizationPetInputEnvelope>;
};

export type CarePlanEnrollmentCreateNestedManyWithoutPlanInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutPlanInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutPlanInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyPlanInputEnvelope>;
};

export type CarePlanEnrollmentCreateNestedManyWithoutPlanPricingInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutPlanPricingInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutPlanPricingInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyPlanPricingInputEnvelope>;
};

export type CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutRenewalEmailSelectedTargetPlanInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanInputEnvelope>;
};

export type CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanPricingInputEnvelope>;
};

export type CarePlanEnrollmentCreateNestedOneWithoutAssociatedUsagesInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutAssociatedUsagesInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutAssociatedUsagesInput>;
};

export type CarePlanEnrollmentCreateNestedOneWithoutCareSubscriptionTrueUpsInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutCareSubscriptionTrueUpsInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutCareSubscriptionTrueUpsInput>;
};

export type CarePlanEnrollmentCreateNestedOneWithoutEnrollmentPaymentsInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutEnrollmentPaymentsInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutEnrollmentPaymentsInput>;
};

export type CarePlanEnrollmentCreateNestedOneWithoutEnrollmentSupportEventsInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutEnrollmentSupportEventsInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutEnrollmentSupportEventsInput>;
};

export type CarePlanEnrollmentCreateNestedOneWithoutEnrollmentToStripeInvoiceItemsInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutEnrollmentToStripeInvoiceItemsInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutEnrollmentToStripeInvoiceItemsInput>;
};

export type CarePlanEnrollmentCreateNestedOneWithoutForwardedCarePlanBenefitCarryoversInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutForwardedCarePlanBenefitCarryoversInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutForwardedCarePlanBenefitCarryoversInput>;
};

export type CarePlanEnrollmentCreateNestedOneWithoutReceivedCarePlanBenefitCarryoversInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutReceivedCarePlanBenefitCarryoversInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutReceivedCarePlanBenefitCarryoversInput>;
};

export type CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutRenewalPredecessorEnrollmentInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutRenewalPredecessorEnrollmentInput>;
};

export type CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutRenewalSuccessorEnrollmentInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutRenewalSuccessorEnrollmentInput>;
};

export type CarePlanEnrollmentCreateOrConnectWithoutAssociatedUsagesInput = {
  create: CarePlanEnrollmentCreateWithoutAssociatedUsagesInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutCareStripeSubscriptionInput = {
  create: CarePlanEnrollmentCreateWithoutCareStripeSubscriptionInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutCareSubscriptionTrueUpsInput = {
  create: CarePlanEnrollmentCreateWithoutCareSubscriptionTrueUpsInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutEnrollmentPaymentsInput = {
  create: CarePlanEnrollmentCreateWithoutEnrollmentPaymentsInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutEnrollmentSupportEventsInput = {
  create: CarePlanEnrollmentCreateWithoutEnrollmentSupportEventsInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutEnrollmentToStripeInvoiceItemsInput = {
  create: CarePlanEnrollmentCreateWithoutEnrollmentToStripeInvoiceItemsInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutExplicitRenewalSucccesorPlanInput = {
  create: CarePlanEnrollmentCreateWithoutExplicitRenewalSucccesorPlanInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutExplicitRenewalSuccessorPlanPricingInput = {
  create: CarePlanEnrollmentCreateWithoutExplicitRenewalSuccessorPlanPricingInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutForwardedCarePlanBenefitCarryoversInput = {
  create: CarePlanEnrollmentCreateWithoutForwardedCarePlanBenefitCarryoversInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutOrganizationPetInput = {
  create: CarePlanEnrollmentCreateWithoutOrganizationPetInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutPlanInput = {
  create: CarePlanEnrollmentCreateWithoutPlanInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutPlanPricingInput = {
  create: CarePlanEnrollmentCreateWithoutPlanPricingInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutReceivedCarePlanBenefitCarryoversInput = {
  create: CarePlanEnrollmentCreateWithoutReceivedCarePlanBenefitCarryoversInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutRenewalEmailSelectedTargetPlanInput = {
  create: CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutRenewalEmailSelectedTargetPlanPricingInput = {
  create: CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanPricingInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutRenewalPredecessorEnrollmentInput = {
  create: CarePlanEnrollmentCreateWithoutRenewalPredecessorEnrollmentInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateOrConnectWithoutRenewalSuccessorEnrollmentInput = {
  create: CarePlanEnrollmentCreateWithoutRenewalSuccessorEnrollmentInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentCreateWithoutAssociatedUsagesInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutCareStripeSubscriptionInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutCareSubscriptionTrueUpsInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutEnrollmentPaymentsInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutEnrollmentSupportEventsInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutEnrollmentToStripeInvoiceItemsInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutExplicitRenewalSucccesorPlanInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutExplicitRenewalSuccessorPlanPricingInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutForwardedCarePlanBenefitCarryoversInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutOrganizationPetInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutPlanInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutPlanPricingInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutReceivedCarePlanBenefitCarryoversInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanPricingInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutRenewalPredecessorEnrollmentInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentCreateWithoutRenewalSuccessorEnrollmentInput = {
  associatedUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet: OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput;
  plan: CarePlanCreateNestedOneWithoutEnrollmentsInput;
  planPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutEnrollmentsInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentCreateNestedOneWithoutRenewalSuccessorEnrollmentInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentGroupByOutputType = {
  __typename?: 'CarePlanEnrollmentGroupByOutputType';
  _count?: Maybe<CarePlanEnrollmentCountAggregateOutputType>;
  _max?: Maybe<CarePlanEnrollmentMaxAggregateOutputType>;
  _min?: Maybe<CarePlanEnrollmentMinAggregateOutputType>;
  autoRenews: Scalars['Boolean'];
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate: Scalars['DateTime'];
  status: EnrollmentStatus;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CarePlanEnrollmentListRelationFilter = {
  every?: Maybe<CarePlanEnrollmentWhereInput>;
  none?: Maybe<CarePlanEnrollmentWhereInput>;
  some?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentMaxAggregateOutputType = {
  __typename?: 'CarePlanEnrollmentMaxAggregateOutputType';
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentMaxOrderByAggregateInput = {
  autoRenews?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  explicitRenewalSuccessorPlanId?: Maybe<SortOrder>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationPetId?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  planPricingId?: Maybe<SortOrder>;
  renewalEmailNoticeSentAt?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlanId?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<SortOrder>;
  renewalPredecessorEnrollmentId?: Maybe<SortOrder>;
  renewalRejectionReason?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanEnrollmentMinAggregateOutputType = {
  __typename?: 'CarePlanEnrollmentMinAggregateOutputType';
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentMinOrderByAggregateInput = {
  autoRenews?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  explicitRenewalSuccessorPlanId?: Maybe<SortOrder>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationPetId?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  planPricingId?: Maybe<SortOrder>;
  renewalEmailNoticeSentAt?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlanId?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<SortOrder>;
  renewalPredecessorEnrollmentId?: Maybe<SortOrder>;
  renewalRejectionReason?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanEnrollmentNullableScalarRelationFilter = {
  AND?: Maybe<Array<CarePlanEnrollmentWhereInput>>;
  NOT?: Maybe<Array<CarePlanEnrollmentWhereInput>>;
  OR?: Maybe<Array<CarePlanEnrollmentWhereInput>>;
  associatedUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  autoRenews?: Maybe<BoolFilter>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionNullableScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringNullableFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentListRelationFilter>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemListRelationFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  explicitRenewalSuccessorPlanId?: Maybe<StringNullableFilter>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<StringNullableFilter>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverListRelationFilter>;
  id?: Maybe<StringFilter>;
  organizationPet?: Maybe<OrganizationPetScalarRelationFilter>;
  organizationPetId?: Maybe<StringFilter>;
  plan?: Maybe<CarePlanScalarRelationFilter>;
  planId?: Maybe<StringFilter>;
  planPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  planPricingId?: Maybe<StringNullableFilter>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverListRelationFilter>;
  renewalEmailNoticeSentAt?: Maybe<DateTimeNullableFilter>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  renewalEmailSelectedTargetPlanId?: Maybe<StringNullableFilter>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<StringNullableFilter>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  renewalPredecessorEnrollmentId?: Maybe<StringNullableFilter>;
  renewalRejectionReason?: Maybe<EnumRenewalRejectionReasonNullableFilter>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  startDate?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumEnrollmentStatusFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanEnrollmentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CarePlanEnrollmentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CarePlanEnrollmentOrderByRelevanceInput>;
  associatedUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  autoRenews?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentOrderByRelationAggregateInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemOrderByRelationAggregateInput>;
  expirationDate?: Maybe<SortOrder>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  explicitRenewalSuccessorPlanId?: Maybe<SortOrder>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  organizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  organizationPetId?: Maybe<SortOrder>;
  plan?: Maybe<CarePlanOrderByWithRelationInput>;
  planId?: Maybe<SortOrder>;
  planPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  planPricingId?: Maybe<SortOrder>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverOrderByRelationAggregateInput>;
  renewalEmailNoticeSentAt?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  renewalEmailSelectedTargetPlanId?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<SortOrder>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  renewalPredecessorEnrollmentId?: Maybe<SortOrder>;
  renewalRejectionReason?: Maybe<SortOrder>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CarePlanEnrollmentOrderByRelevanceFieldEnum {
  CareStripeSubscriptionId = 'careStripeSubscriptionId',
  ExplicitRenewalSuccessorPlanId = 'explicitRenewalSuccessorPlanId',
  ExplicitRenewalSuccessorPlanPricingId = 'explicitRenewalSuccessorPlanPricingId',
  Id = 'id',
  OrganizationPetId = 'organizationPetId',
  PlanId = 'planId',
  PlanPricingId = 'planPricingId',
  RenewalEmailSelectedTargetPlanId = 'renewalEmailSelectedTargetPlanId',
  RenewalEmailSelectedTargetPlanPricingId = 'renewalEmailSelectedTargetPlanPricingId',
  RenewalPredecessorEnrollmentId = 'renewalPredecessorEnrollmentId',
  StripeSubscriptionItemId = 'stripeSubscriptionItemId'
}

export type CarePlanEnrollmentOrderByRelevanceInput = {
  fields: Array<CarePlanEnrollmentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CarePlanEnrollmentOrderByWithAggregationInput = {
  _count?: Maybe<CarePlanEnrollmentCountOrderByAggregateInput>;
  _max?: Maybe<CarePlanEnrollmentMaxOrderByAggregateInput>;
  _min?: Maybe<CarePlanEnrollmentMinOrderByAggregateInput>;
  autoRenews?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  explicitRenewalSuccessorPlanId?: Maybe<SortOrder>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationPetId?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  planPricingId?: Maybe<SortOrder>;
  renewalEmailNoticeSentAt?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlanId?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<SortOrder>;
  renewalPredecessorEnrollmentId?: Maybe<SortOrder>;
  renewalRejectionReason?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanEnrollmentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CarePlanEnrollmentOrderByRelevanceInput>;
  associatedUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  autoRenews?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentOrderByRelationAggregateInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemOrderByRelationAggregateInput>;
  expirationDate?: Maybe<SortOrder>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  explicitRenewalSuccessorPlanId?: Maybe<SortOrder>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  organizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  organizationPetId?: Maybe<SortOrder>;
  plan?: Maybe<CarePlanOrderByWithRelationInput>;
  planId?: Maybe<SortOrder>;
  planPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  planPricingId?: Maybe<SortOrder>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverOrderByRelationAggregateInput>;
  renewalEmailNoticeSentAt?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  renewalEmailSelectedTargetPlanId?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<SortOrder>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  renewalPredecessorEnrollmentId?: Maybe<SortOrder>;
  renewalRejectionReason?: Maybe<SortOrder>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanEnrollmentOrderByWithRelationInput = {
  _relevance?: Maybe<CarePlanEnrollmentOrderByRelevanceInput>;
  associatedUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  autoRenews?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentOrderByRelationAggregateInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemOrderByRelationAggregateInput>;
  expirationDate?: Maybe<SortOrder>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  explicitRenewalSuccessorPlanId?: Maybe<SortOrder>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  organizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  organizationPetId?: Maybe<SortOrder>;
  plan?: Maybe<CarePlanOrderByWithRelationInput>;
  planId?: Maybe<SortOrder>;
  planPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  planPricingId?: Maybe<SortOrder>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverOrderByRelationAggregateInput>;
  renewalEmailNoticeSentAt?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  renewalEmailSelectedTargetPlanId?: Maybe<SortOrder>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<SortOrder>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  renewalPredecessorEnrollmentId?: Maybe<SortOrder>;
  renewalRejectionReason?: Maybe<SortOrder>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  startDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CarePlanEnrollmentScalarFieldEnum {
  AutoRenews = 'autoRenews',
  CancelledAt = 'cancelledAt',
  CareStripeSubscriptionId = 'careStripeSubscriptionId',
  CreatedAt = 'createdAt',
  ExpirationDate = 'expirationDate',
  ExplicitRenewalSuccessorPlanId = 'explicitRenewalSuccessorPlanId',
  ExplicitRenewalSuccessorPlanPricingId = 'explicitRenewalSuccessorPlanPricingId',
  Id = 'id',
  OrganizationPetId = 'organizationPetId',
  PlanId = 'planId',
  PlanPricingId = 'planPricingId',
  RenewalEmailNoticeSentAt = 'renewalEmailNoticeSentAt',
  RenewalEmailSelectedTargetPlanId = 'renewalEmailSelectedTargetPlanId',
  RenewalEmailSelectedTargetPlanPricingId = 'renewalEmailSelectedTargetPlanPricingId',
  RenewalPredecessorEnrollmentId = 'renewalPredecessorEnrollmentId',
  RenewalRejectionReason = 'renewalRejectionReason',
  StartDate = 'startDate',
  Status = 'status',
  StripeSubscriptionItemId = 'stripeSubscriptionItemId',
  UpdatedAt = 'updatedAt'
}

export type CarePlanEnrollmentScalarRelationFilter = {
  AND?: Maybe<Array<CarePlanEnrollmentWhereInput>>;
  NOT?: Maybe<Array<CarePlanEnrollmentWhereInput>>;
  OR?: Maybe<Array<CarePlanEnrollmentWhereInput>>;
  associatedUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  autoRenews?: Maybe<BoolFilter>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionNullableScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringNullableFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentListRelationFilter>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemListRelationFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  explicitRenewalSuccessorPlanId?: Maybe<StringNullableFilter>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<StringNullableFilter>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverListRelationFilter>;
  id?: Maybe<StringFilter>;
  organizationPet?: Maybe<OrganizationPetScalarRelationFilter>;
  organizationPetId?: Maybe<StringFilter>;
  plan?: Maybe<CarePlanScalarRelationFilter>;
  planId?: Maybe<StringFilter>;
  planPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  planPricingId?: Maybe<StringNullableFilter>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverListRelationFilter>;
  renewalEmailNoticeSentAt?: Maybe<DateTimeNullableFilter>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  renewalEmailSelectedTargetPlanId?: Maybe<StringNullableFilter>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<StringNullableFilter>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  renewalPredecessorEnrollmentId?: Maybe<StringNullableFilter>;
  renewalRejectionReason?: Maybe<EnumRenewalRejectionReasonNullableFilter>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  startDate?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumEnrollmentStatusFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanEnrollmentScalarWhereInput = {
  AND?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  NOT?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  OR?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  autoRenews?: Maybe<BoolFilter>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  careStripeSubscriptionId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  explicitRenewalSuccessorPlanId?: Maybe<StringNullableFilter>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  organizationPetId?: Maybe<StringFilter>;
  planId?: Maybe<StringFilter>;
  planPricingId?: Maybe<StringNullableFilter>;
  renewalEmailNoticeSentAt?: Maybe<DateTimeNullableFilter>;
  renewalEmailSelectedTargetPlanId?: Maybe<StringNullableFilter>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<StringNullableFilter>;
  renewalPredecessorEnrollmentId?: Maybe<StringNullableFilter>;
  renewalRejectionReason?: Maybe<EnumRenewalRejectionReasonNullableFilter>;
  startDate?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumEnrollmentStatusFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanEnrollmentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CarePlanEnrollmentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CarePlanEnrollmentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CarePlanEnrollmentScalarWhereWithAggregatesInput>>;
  autoRenews?: Maybe<BoolWithAggregatesFilter>;
  cancelledAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  careStripeSubscriptionId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  expirationDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  explicitRenewalSuccessorPlanId?: Maybe<StringNullableWithAggregatesFilter>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  organizationPetId?: Maybe<StringWithAggregatesFilter>;
  planId?: Maybe<StringWithAggregatesFilter>;
  planPricingId?: Maybe<StringNullableWithAggregatesFilter>;
  renewalEmailNoticeSentAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  renewalEmailSelectedTargetPlanId?: Maybe<StringNullableWithAggregatesFilter>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<StringNullableWithAggregatesFilter>;
  renewalPredecessorEnrollmentId?: Maybe<StringNullableWithAggregatesFilter>;
  renewalRejectionReason?: Maybe<EnumRenewalRejectionReasonNullableWithAggregatesFilter>;
  startDate?: Maybe<DateTimeWithAggregatesFilter>;
  status?: Maybe<EnumEnrollmentStatusWithAggregatesFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CarePlanEnrollmentUncheckedCreateInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyCareStripeSubscriptionInputEnvelope>;
};

export type CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutExplicitRenewalSucccesorPlanInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutExplicitRenewalSucccesorPlanInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyExplicitRenewalSucccesorPlanInputEnvelope>;
};

export type CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutExplicitRenewalSuccessorPlanPricingInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutExplicitRenewalSuccessorPlanPricingInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyExplicitRenewalSuccessorPlanPricingInputEnvelope>;
};

export type CarePlanEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyOrganizationPetInputEnvelope>;
};

export type CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutPlanInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutPlanInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyPlanInputEnvelope>;
};

export type CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanPricingInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutPlanPricingInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutPlanPricingInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyPlanPricingInputEnvelope>;
};

export type CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutRenewalEmailSelectedTargetPlanInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanInputEnvelope>;
};

export type CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanPricingInputEnvelope>;
};

export type CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutRenewalPredecessorEnrollmentInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutRenewalPredecessorEnrollmentInput>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutAssociatedUsagesInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutCareStripeSubscriptionInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutCareSubscriptionTrueUpsInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutEnrollmentPaymentsInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutEnrollmentSupportEventsInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutEnrollmentToStripeInvoiceItemsInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutExplicitRenewalSucccesorPlanInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutExplicitRenewalSuccessorPlanPricingInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutForwardedCarePlanBenefitCarryoversInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutOrganizationPetInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutPlanInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutPlanPricingInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutReceivedCarePlanBenefitCarryoversInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutRenewalEmailSelectedTargetPlanInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutRenewalEmailSelectedTargetPlanPricingInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutRenewalPredecessorEnrollmentInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedCreateNestedOneWithoutRenewalPredecessorEnrollmentInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedCreateWithoutRenewalSuccessorEnrollmentInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutConnectedPlanEnrollmentInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutSourcePlanEnrollmentInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId: Scalars['String'];
  planId: Scalars['String'];
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedCreateNestedManyWithoutDestinationPlanEnrollmentInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateManyInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyCareStripeSubscriptionInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutCareStripeSubscriptionInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutExplicitRenewalSucccesorPlanInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutExplicitRenewalSucccesorPlanInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyExplicitRenewalSucccesorPlanInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutExplicitRenewalSucccesorPlanInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutExplicitRenewalSucccesorPlanInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutExplicitRenewalSucccesorPlanInput>>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSuccessorPlanPricingInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutExplicitRenewalSuccessorPlanPricingInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutExplicitRenewalSuccessorPlanPricingInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyExplicitRenewalSuccessorPlanPricingInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutExplicitRenewalSuccessorPlanPricingInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutExplicitRenewalSuccessorPlanPricingInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutExplicitRenewalSuccessorPlanPricingInput>>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutOrganizationPetInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyOrganizationPetInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutOrganizationPetInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutOrganizationPetInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutOrganizationPetInput>>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutPlanInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutPlanNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutPlanInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutPlanInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyPlanInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutPlanInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutPlanInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutPlanInput>>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutPlanPricingInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutPlanPricingNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutPlanPricingInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutPlanPricingInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyPlanPricingInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutPlanPricingInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutPlanPricingInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutPlanPricingInput>>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutRenewalEmailSelectedTargetPlanInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutRenewalEmailSelectedTargetPlanInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutRenewalEmailSelectedTargetPlanInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutRenewalEmailSelectedTargetPlanInput>>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanPricingInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
};

export type CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutRenewalPredecessorEnrollmentInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutRenewalPredecessorEnrollmentInput>;
  delete?: Maybe<CarePlanEnrollmentWhereInput>;
  disconnect?: Maybe<CarePlanEnrollmentWhereInput>;
  update?: Maybe<CarePlanEnrollmentUpdateToOneWithWhereWithoutRenewalPredecessorEnrollmentInput>;
  upsert?: Maybe<CarePlanEnrollmentUpsertWithoutRenewalPredecessorEnrollmentInput>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutAssociatedUsagesInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutCareStripeSubscriptionInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutCareSubscriptionTrueUpsInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutEnrollmentPaymentsInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutEnrollmentSupportEventsInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutEnrollmentToStripeInvoiceItemsInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutExplicitRenewalSucccesorPlanInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutExplicitRenewalSuccessorPlanPricingInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutForwardedCarePlanBenefitCarryoversInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutOrganizationPetInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutPlanInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutPlanPricingInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutReceivedCarePlanBenefitCarryoversInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutRenewalEmailSelectedTargetPlanInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutRenewalEmailSelectedTargetPlanPricingInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutRenewalPredecessorEnrollmentInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUncheckedUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUncheckedUpdateWithoutRenewalSuccessorEnrollmentInput = {
  associatedUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planPricingId?: Maybe<Scalars['String']>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUncheckedUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateManyMutationInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateManyWithWhereWithoutCareStripeSubscriptionInput = {
  data: CarePlanEnrollmentUpdateManyMutationInput;
  where: CarePlanEnrollmentScalarWhereInput;
};

export type CarePlanEnrollmentUpdateManyWithWhereWithoutExplicitRenewalSucccesorPlanInput = {
  data: CarePlanEnrollmentUpdateManyMutationInput;
  where: CarePlanEnrollmentScalarWhereInput;
};

export type CarePlanEnrollmentUpdateManyWithWhereWithoutExplicitRenewalSuccessorPlanPricingInput = {
  data: CarePlanEnrollmentUpdateManyMutationInput;
  where: CarePlanEnrollmentScalarWhereInput;
};

export type CarePlanEnrollmentUpdateManyWithWhereWithoutOrganizationPetInput = {
  data: CarePlanEnrollmentUpdateManyMutationInput;
  where: CarePlanEnrollmentScalarWhereInput;
};

export type CarePlanEnrollmentUpdateManyWithWhereWithoutPlanInput = {
  data: CarePlanEnrollmentUpdateManyMutationInput;
  where: CarePlanEnrollmentScalarWhereInput;
};

export type CarePlanEnrollmentUpdateManyWithWhereWithoutPlanPricingInput = {
  data: CarePlanEnrollmentUpdateManyMutationInput;
  where: CarePlanEnrollmentScalarWhereInput;
};

export type CarePlanEnrollmentUpdateManyWithWhereWithoutRenewalEmailSelectedTargetPlanInput = {
  data: CarePlanEnrollmentUpdateManyMutationInput;
  where: CarePlanEnrollmentScalarWhereInput;
};

export type CarePlanEnrollmentUpdateManyWithWhereWithoutRenewalEmailSelectedTargetPlanPricingInput = {
  data: CarePlanEnrollmentUpdateManyMutationInput;
  where: CarePlanEnrollmentScalarWhereInput;
};

export type CarePlanEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyCareStripeSubscriptionInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutCareStripeSubscriptionInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
};

export type CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutExplicitRenewalSucccesorPlanInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutExplicitRenewalSucccesorPlanInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyExplicitRenewalSucccesorPlanInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutExplicitRenewalSucccesorPlanInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutExplicitRenewalSucccesorPlanInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutExplicitRenewalSucccesorPlanInput>>;
};

export type CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutExplicitRenewalSuccessorPlanPricingInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutExplicitRenewalSuccessorPlanPricingInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyExplicitRenewalSuccessorPlanPricingInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutExplicitRenewalSuccessorPlanPricingInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutExplicitRenewalSuccessorPlanPricingInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutExplicitRenewalSuccessorPlanPricingInput>>;
};

export type CarePlanEnrollmentUpdateManyWithoutOrganizationPetNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyOrganizationPetInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutOrganizationPetInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutOrganizationPetInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutOrganizationPetInput>>;
};

export type CarePlanEnrollmentUpdateManyWithoutPlanNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutPlanInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutPlanInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyPlanInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutPlanInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutPlanInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutPlanInput>>;
};

export type CarePlanEnrollmentUpdateManyWithoutPlanPricingNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutPlanPricingInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutPlanPricingInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyPlanPricingInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutPlanPricingInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutPlanPricingInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutPlanPricingInput>>;
};

export type CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutRenewalEmailSelectedTargetPlanInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutRenewalEmailSelectedTargetPlanInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutRenewalEmailSelectedTargetPlanInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutRenewalEmailSelectedTargetPlanInput>>;
};

export type CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput = {
  connect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanEnrollmentCreateOrConnectWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
  create?: Maybe<Array<CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
  createMany?: Maybe<CarePlanEnrollmentCreateManyRenewalEmailSelectedTargetPlanPricingInputEnvelope>;
  delete?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanEnrollmentUpdateWithWhereUniqueWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
  updateMany?: Maybe<Array<CarePlanEnrollmentUpdateManyWithWhereWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
  upsert?: Maybe<Array<CarePlanEnrollmentUpsertWithWhereUniqueWithoutRenewalEmailSelectedTargetPlanPricingInput>>;
};

export type CarePlanEnrollmentUpdateOneRequiredWithoutCareSubscriptionTrueUpsNestedInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutCareSubscriptionTrueUpsInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutCareSubscriptionTrueUpsInput>;
  update?: Maybe<CarePlanEnrollmentUpdateToOneWithWhereWithoutCareSubscriptionTrueUpsInput>;
  upsert?: Maybe<CarePlanEnrollmentUpsertWithoutCareSubscriptionTrueUpsInput>;
};

export type CarePlanEnrollmentUpdateOneRequiredWithoutEnrollmentSupportEventsNestedInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutEnrollmentSupportEventsInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutEnrollmentSupportEventsInput>;
  update?: Maybe<CarePlanEnrollmentUpdateToOneWithWhereWithoutEnrollmentSupportEventsInput>;
  upsert?: Maybe<CarePlanEnrollmentUpsertWithoutEnrollmentSupportEventsInput>;
};

export type CarePlanEnrollmentUpdateOneWithoutAssociatedUsagesNestedInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutAssociatedUsagesInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutAssociatedUsagesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanEnrollmentUpdateToOneWithWhereWithoutAssociatedUsagesInput>;
  upsert?: Maybe<CarePlanEnrollmentUpsertWithoutAssociatedUsagesInput>;
};

export type CarePlanEnrollmentUpdateOneWithoutEnrollmentPaymentsNestedInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutEnrollmentPaymentsInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutEnrollmentPaymentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanEnrollmentUpdateToOneWithWhereWithoutEnrollmentPaymentsInput>;
  upsert?: Maybe<CarePlanEnrollmentUpsertWithoutEnrollmentPaymentsInput>;
};

export type CarePlanEnrollmentUpdateOneWithoutEnrollmentToStripeInvoiceItemsNestedInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutEnrollmentToStripeInvoiceItemsInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutEnrollmentToStripeInvoiceItemsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanEnrollmentUpdateToOneWithWhereWithoutEnrollmentToStripeInvoiceItemsInput>;
  upsert?: Maybe<CarePlanEnrollmentUpsertWithoutEnrollmentToStripeInvoiceItemsInput>;
};

export type CarePlanEnrollmentUpdateOneWithoutForwardedCarePlanBenefitCarryoversNestedInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutForwardedCarePlanBenefitCarryoversInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutForwardedCarePlanBenefitCarryoversInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanEnrollmentUpdateToOneWithWhereWithoutForwardedCarePlanBenefitCarryoversInput>;
  upsert?: Maybe<CarePlanEnrollmentUpsertWithoutForwardedCarePlanBenefitCarryoversInput>;
};

export type CarePlanEnrollmentUpdateOneWithoutReceivedCarePlanBenefitCarryoversNestedInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutReceivedCarePlanBenefitCarryoversInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutReceivedCarePlanBenefitCarryoversInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanEnrollmentUpdateToOneWithWhereWithoutReceivedCarePlanBenefitCarryoversInput>;
  upsert?: Maybe<CarePlanEnrollmentUpsertWithoutReceivedCarePlanBenefitCarryoversInput>;
};

export type CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutRenewalPredecessorEnrollmentInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutRenewalPredecessorEnrollmentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanEnrollmentUpdateToOneWithWhereWithoutRenewalPredecessorEnrollmentInput>;
  upsert?: Maybe<CarePlanEnrollmentUpsertWithoutRenewalPredecessorEnrollmentInput>;
};

export type CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput = {
  connect?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanEnrollmentCreateOrConnectWithoutRenewalSuccessorEnrollmentInput>;
  create?: Maybe<CarePlanEnrollmentCreateWithoutRenewalSuccessorEnrollmentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanEnrollmentUpdateToOneWithWhereWithoutRenewalSuccessorEnrollmentInput>;
  upsert?: Maybe<CarePlanEnrollmentUpsertWithoutRenewalSuccessorEnrollmentInput>;
};

export type CarePlanEnrollmentUpdateToOneWithWhereWithoutAssociatedUsagesInput = {
  data: CarePlanEnrollmentUpdateWithoutAssociatedUsagesInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpdateToOneWithWhereWithoutCareSubscriptionTrueUpsInput = {
  data: CarePlanEnrollmentUpdateWithoutCareSubscriptionTrueUpsInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpdateToOneWithWhereWithoutEnrollmentPaymentsInput = {
  data: CarePlanEnrollmentUpdateWithoutEnrollmentPaymentsInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpdateToOneWithWhereWithoutEnrollmentSupportEventsInput = {
  data: CarePlanEnrollmentUpdateWithoutEnrollmentSupportEventsInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpdateToOneWithWhereWithoutEnrollmentToStripeInvoiceItemsInput = {
  data: CarePlanEnrollmentUpdateWithoutEnrollmentToStripeInvoiceItemsInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpdateToOneWithWhereWithoutForwardedCarePlanBenefitCarryoversInput = {
  data: CarePlanEnrollmentUpdateWithoutForwardedCarePlanBenefitCarryoversInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpdateToOneWithWhereWithoutReceivedCarePlanBenefitCarryoversInput = {
  data: CarePlanEnrollmentUpdateWithoutReceivedCarePlanBenefitCarryoversInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpdateToOneWithWhereWithoutRenewalPredecessorEnrollmentInput = {
  data: CarePlanEnrollmentUpdateWithoutRenewalPredecessorEnrollmentInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpdateToOneWithWhereWithoutRenewalSuccessorEnrollmentInput = {
  data: CarePlanEnrollmentUpdateWithoutRenewalSuccessorEnrollmentInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput = {
  data: CarePlanEnrollmentUpdateWithoutCareStripeSubscriptionInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpdateWithWhereUniqueWithoutExplicitRenewalSucccesorPlanInput = {
  data: CarePlanEnrollmentUpdateWithoutExplicitRenewalSucccesorPlanInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpdateWithWhereUniqueWithoutExplicitRenewalSuccessorPlanPricingInput = {
  data: CarePlanEnrollmentUpdateWithoutExplicitRenewalSuccessorPlanPricingInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpdateWithWhereUniqueWithoutOrganizationPetInput = {
  data: CarePlanEnrollmentUpdateWithoutOrganizationPetInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpdateWithWhereUniqueWithoutPlanInput = {
  data: CarePlanEnrollmentUpdateWithoutPlanInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpdateWithWhereUniqueWithoutPlanPricingInput = {
  data: CarePlanEnrollmentUpdateWithoutPlanPricingInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpdateWithWhereUniqueWithoutRenewalEmailSelectedTargetPlanInput = {
  data: CarePlanEnrollmentUpdateWithoutRenewalEmailSelectedTargetPlanInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpdateWithWhereUniqueWithoutRenewalEmailSelectedTargetPlanPricingInput = {
  data: CarePlanEnrollmentUpdateWithoutRenewalEmailSelectedTargetPlanPricingInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpdateWithoutAssociatedUsagesInput = {
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutCareStripeSubscriptionInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutCareSubscriptionTrueUpsInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutEnrollmentPaymentsInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutEnrollmentSupportEventsInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutEnrollmentToStripeInvoiceItemsInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutExplicitRenewalSucccesorPlanInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutExplicitRenewalSuccessorPlanPricingInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutForwardedCarePlanBenefitCarryoversInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutOrganizationPetInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutPlanInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutPlanPricingInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutReceivedCarePlanBenefitCarryoversInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutRenewalEmailSelectedTargetPlanInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutRenewalEmailSelectedTargetPlanPricingInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutRenewalPredecessorEnrollmentInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalPredecessorEnrollmentNestedInput>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpdateWithoutRenewalSuccessorEnrollmentInput = {
  associatedUsages?: Maybe<CareBenefitUsageUpdateManyWithoutConnectedPlanEnrollmentNestedInput>;
  autoRenews?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutCarePlanEnrollmentNestedInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutSourcePlanEnrollmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  planPricing?: Maybe<CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverUpdateManyWithoutDestinationPlanEnrollmentNestedInput>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentUpdateOneWithoutRenewalSuccessorEnrollmentNestedInput>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnrollmentStatus>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanEnrollmentUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput = {
  create: CarePlanEnrollmentCreateWithoutCareStripeSubscriptionInput;
  update: CarePlanEnrollmentUpdateWithoutCareStripeSubscriptionInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpsertWithWhereUniqueWithoutExplicitRenewalSucccesorPlanInput = {
  create: CarePlanEnrollmentCreateWithoutExplicitRenewalSucccesorPlanInput;
  update: CarePlanEnrollmentUpdateWithoutExplicitRenewalSucccesorPlanInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpsertWithWhereUniqueWithoutExplicitRenewalSuccessorPlanPricingInput = {
  create: CarePlanEnrollmentCreateWithoutExplicitRenewalSuccessorPlanPricingInput;
  update: CarePlanEnrollmentUpdateWithoutExplicitRenewalSuccessorPlanPricingInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpsertWithWhereUniqueWithoutOrganizationPetInput = {
  create: CarePlanEnrollmentCreateWithoutOrganizationPetInput;
  update: CarePlanEnrollmentUpdateWithoutOrganizationPetInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpsertWithWhereUniqueWithoutPlanInput = {
  create: CarePlanEnrollmentCreateWithoutPlanInput;
  update: CarePlanEnrollmentUpdateWithoutPlanInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpsertWithWhereUniqueWithoutPlanPricingInput = {
  create: CarePlanEnrollmentCreateWithoutPlanPricingInput;
  update: CarePlanEnrollmentUpdateWithoutPlanPricingInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpsertWithWhereUniqueWithoutRenewalEmailSelectedTargetPlanInput = {
  create: CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanInput;
  update: CarePlanEnrollmentUpdateWithoutRenewalEmailSelectedTargetPlanInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpsertWithWhereUniqueWithoutRenewalEmailSelectedTargetPlanPricingInput = {
  create: CarePlanEnrollmentCreateWithoutRenewalEmailSelectedTargetPlanPricingInput;
  update: CarePlanEnrollmentUpdateWithoutRenewalEmailSelectedTargetPlanPricingInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};

export type CarePlanEnrollmentUpsertWithoutAssociatedUsagesInput = {
  create: CarePlanEnrollmentCreateWithoutAssociatedUsagesInput;
  update: CarePlanEnrollmentUpdateWithoutAssociatedUsagesInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpsertWithoutCareSubscriptionTrueUpsInput = {
  create: CarePlanEnrollmentCreateWithoutCareSubscriptionTrueUpsInput;
  update: CarePlanEnrollmentUpdateWithoutCareSubscriptionTrueUpsInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpsertWithoutEnrollmentPaymentsInput = {
  create: CarePlanEnrollmentCreateWithoutEnrollmentPaymentsInput;
  update: CarePlanEnrollmentUpdateWithoutEnrollmentPaymentsInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpsertWithoutEnrollmentSupportEventsInput = {
  create: CarePlanEnrollmentCreateWithoutEnrollmentSupportEventsInput;
  update: CarePlanEnrollmentUpdateWithoutEnrollmentSupportEventsInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpsertWithoutEnrollmentToStripeInvoiceItemsInput = {
  create: CarePlanEnrollmentCreateWithoutEnrollmentToStripeInvoiceItemsInput;
  update: CarePlanEnrollmentUpdateWithoutEnrollmentToStripeInvoiceItemsInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpsertWithoutForwardedCarePlanBenefitCarryoversInput = {
  create: CarePlanEnrollmentCreateWithoutForwardedCarePlanBenefitCarryoversInput;
  update: CarePlanEnrollmentUpdateWithoutForwardedCarePlanBenefitCarryoversInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpsertWithoutReceivedCarePlanBenefitCarryoversInput = {
  create: CarePlanEnrollmentCreateWithoutReceivedCarePlanBenefitCarryoversInput;
  update: CarePlanEnrollmentUpdateWithoutReceivedCarePlanBenefitCarryoversInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpsertWithoutRenewalPredecessorEnrollmentInput = {
  create: CarePlanEnrollmentCreateWithoutRenewalPredecessorEnrollmentInput;
  update: CarePlanEnrollmentUpdateWithoutRenewalPredecessorEnrollmentInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentUpsertWithoutRenewalSuccessorEnrollmentInput = {
  create: CarePlanEnrollmentCreateWithoutRenewalSuccessorEnrollmentInput;
  update: CarePlanEnrollmentUpdateWithoutRenewalSuccessorEnrollmentInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanEnrollmentWhereInput = {
  AND?: Maybe<Array<CarePlanEnrollmentWhereInput>>;
  NOT?: Maybe<Array<CarePlanEnrollmentWhereInput>>;
  OR?: Maybe<Array<CarePlanEnrollmentWhereInput>>;
  associatedUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  autoRenews?: Maybe<BoolFilter>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionNullableScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringNullableFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentListRelationFilter>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemListRelationFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  explicitRenewalSuccessorPlanId?: Maybe<StringNullableFilter>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<StringNullableFilter>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverListRelationFilter>;
  id?: Maybe<StringFilter>;
  organizationPet?: Maybe<OrganizationPetScalarRelationFilter>;
  organizationPetId?: Maybe<StringFilter>;
  plan?: Maybe<CarePlanScalarRelationFilter>;
  planId?: Maybe<StringFilter>;
  planPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  planPricingId?: Maybe<StringNullableFilter>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverListRelationFilter>;
  renewalEmailNoticeSentAt?: Maybe<DateTimeNullableFilter>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  renewalEmailSelectedTargetPlanId?: Maybe<StringNullableFilter>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<StringNullableFilter>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  renewalPredecessorEnrollmentId?: Maybe<StringNullableFilter>;
  renewalRejectionReason?: Maybe<EnumRenewalRejectionReasonNullableFilter>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  startDate?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumEnrollmentStatusFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanEnrollmentWhereUniqueInput = {
  AND?: Maybe<Array<CarePlanEnrollmentWhereInput>>;
  NOT?: Maybe<Array<CarePlanEnrollmentWhereInput>>;
  OR?: Maybe<Array<CarePlanEnrollmentWhereInput>>;
  associatedUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  autoRenews?: Maybe<BoolFilter>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionNullableScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringNullableFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enrollmentPayments?: Maybe<CareEnrollmentPaymentListRelationFilter>;
  enrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemListRelationFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  explicitRenewalSuccessorPlanId?: Maybe<StringNullableFilter>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<StringNullableFilter>;
  forwardedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetScalarRelationFilter>;
  organizationPetId?: Maybe<StringFilter>;
  plan?: Maybe<CarePlanScalarRelationFilter>;
  planId?: Maybe<StringFilter>;
  planPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  planPricingId?: Maybe<StringNullableFilter>;
  receivedCarePlanBenefitCarryovers?: Maybe<CarePlanBenefitEnrollmentCarryoverListRelationFilter>;
  renewalEmailNoticeSentAt?: Maybe<DateTimeNullableFilter>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  renewalEmailSelectedTargetPlanId?: Maybe<StringNullableFilter>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<StringNullableFilter>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<EnumRenewalRejectionReasonNullableFilter>;
  renewalSuccessorEnrollment?: Maybe<CarePlanEnrollmentNullableScalarRelationFilter>;
  startDate?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumEnrollmentStatusFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanGroupByOutputType = {
  __typename?: 'CarePlanGroupByOutputType';
  _avg?: Maybe<CarePlanAvgAggregateOutputType>;
  _count?: Maybe<CarePlanCountAggregateOutputType>;
  _max?: Maybe<CarePlanMaxAggregateOutputType>;
  _min?: Maybe<CarePlanMinAggregateOutputType>;
  _sum?: Maybe<CarePlanSumAggregateOutputType>;
  allowSelfRenewal: Scalars['Boolean'];
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle: CarePlanCycleType;
  createdAt: Scalars['DateTime'];
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes: Scalars['String'];
  flowAlias?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isAcceptingPreEnrollments: Scalars['Boolean'];
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  organizationId: Scalars['String'];
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal: Scalars['Int'];
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle: CarePlanCycleType;
  salesTaxCentsPerMonth: Scalars['Int'];
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CarePlanListRelationFilter = {
  every?: Maybe<CarePlanWhereInput>;
  none?: Maybe<CarePlanWhereInput>;
  some?: Maybe<CarePlanWhereInput>;
};

export type CarePlanMaxAggregateOutputType = {
  __typename?: 'CarePlanMaxAggregateOutputType';
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanMaxOrderByAggregateInput = {
  allowSelfRenewal?: Maybe<SortOrder>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultRenewalSuccessorPlanId?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAcceptingPreEnrollments?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  planDiscount?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  publishEndDate?: Maybe<SortOrder>;
  publishStartDate?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  signupFeePricing?: Maybe<SortOrder>;
  signupFeeStripeProductId?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanMinAggregateOutputType = {
  __typename?: 'CarePlanMinAggregateOutputType';
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanMinOrderByAggregateInput = {
  allowSelfRenewal?: Maybe<SortOrder>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultRenewalSuccessorPlanId?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAcceptingPreEnrollments?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  planDiscount?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  publishEndDate?: Maybe<SortOrder>;
  publishStartDate?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  signupFeePricing?: Maybe<SortOrder>;
  signupFeeStripeProductId?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanNullableScalarRelationFilter = {
  AND?: Maybe<Array<CarePlanWhereInput>>;
  NOT?: Maybe<Array<CarePlanWhereInput>>;
  OR?: Maybe<Array<CarePlanWhereInput>>;
  allowSelfRenewal?: Maybe<BoolFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  defaultRenewalSuccessorPlanId?: Maybe<StringNullableFilter>;
  description?: Maybe<StringFilter>;
  earliestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  editorNotes?: Maybe<StringFilter>;
  enrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentListRelationFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isAcceptingPreEnrollments?: Maybe<BoolFilter>;
  latestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  marketingInformation?: Maybe<JsonNullableFilter>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  planBenefits?: Maybe<CarePlanBenefitListRelationFilter>;
  planDiscount?: Maybe<IntNullableFilter>;
  planPricings?: Maybe<CarePlanPricingListRelationFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  publishEndDate?: Maybe<DateTimeNullableFilter>;
  publishStartDate?: Maybe<DateTimeNullableFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  renewalPredecessorPlan?: Maybe<CarePlanListRelationFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  signupFeePricing?: Maybe<IntNullableFilter>;
  signupFeeStripeProductId?: Maybe<StringNullableFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  targetSpecies?: Maybe<EnumSpeciesTypeNullableFilter>;
  themeColor?: Maybe<StringNullableFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CarePlanOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CarePlanOrderByRelevanceInput>;
  allowSelfRenewal?: Maybe<SortOrder>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  defaultRenewalSuccessorPlanId?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  enrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAcceptingPreEnrollments?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  marketingInformation?: Maybe<SortOrder>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  planBenefits?: Maybe<CarePlanBenefitOrderByRelationAggregateInput>;
  planDiscount?: Maybe<SortOrder>;
  planPricings?: Maybe<CarePlanPricingOrderByRelationAggregateInput>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  publishEndDate?: Maybe<SortOrder>;
  publishStartDate?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  renewalPredecessorPlan?: Maybe<CarePlanOrderByRelationAggregateInput>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  signupFeePricing?: Maybe<SortOrder>;
  signupFeeStripeProductId?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CarePlanOrderByRelevanceFieldEnum {
  AssociatedCarePlanProviderGroupId = 'associatedCarePlanProviderGroupId',
  DefaultRenewalSuccessorPlanId = 'defaultRenewalSuccessorPlanId',
  Description = 'description',
  EditorNotes = 'editorNotes',
  FlowAlias = 'flowAlias',
  Id = 'id',
  OrganizationId = 'organizationId',
  ProjectedSavings = 'projectedSavings',
  SignupFeeStripeProductId = 'signupFeeStripeProductId',
  StripePriceId = 'stripePriceId',
  ThemeColor = 'themeColor',
  Title = 'title'
}

export type CarePlanOrderByRelevanceInput = {
  fields: Array<CarePlanOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CarePlanOrderByWithAggregationInput = {
  _avg?: Maybe<CarePlanAvgOrderByAggregateInput>;
  _count?: Maybe<CarePlanCountOrderByAggregateInput>;
  _max?: Maybe<CarePlanMaxOrderByAggregateInput>;
  _min?: Maybe<CarePlanMinOrderByAggregateInput>;
  _sum?: Maybe<CarePlanSumOrderByAggregateInput>;
  allowSelfRenewal?: Maybe<SortOrder>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultRenewalSuccessorPlanId?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAcceptingPreEnrollments?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  marketingInformation?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  planDiscount?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  publishEndDate?: Maybe<SortOrder>;
  publishStartDate?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  signupFeePricing?: Maybe<SortOrder>;
  signupFeeStripeProductId?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CarePlanOrderByRelevanceInput>;
  allowSelfRenewal?: Maybe<SortOrder>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  defaultRenewalSuccessorPlanId?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  enrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAcceptingPreEnrollments?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  marketingInformation?: Maybe<SortOrder>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  planBenefits?: Maybe<CarePlanBenefitOrderByRelationAggregateInput>;
  planDiscount?: Maybe<SortOrder>;
  planPricings?: Maybe<CarePlanPricingOrderByRelationAggregateInput>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  publishEndDate?: Maybe<SortOrder>;
  publishStartDate?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  renewalPredecessorPlan?: Maybe<CarePlanOrderByRelationAggregateInput>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  signupFeePricing?: Maybe<SortOrder>;
  signupFeeStripeProductId?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanOrderByWithRelationInput = {
  _relevance?: Maybe<CarePlanOrderByRelevanceInput>;
  allowSelfRenewal?: Maybe<SortOrder>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  defaultRenewalSuccessorPlanId?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  editorNotes?: Maybe<SortOrder>;
  enrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAcceptingPreEnrollments?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  marketingInformation?: Maybe<SortOrder>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  planBenefits?: Maybe<CarePlanBenefitOrderByRelationAggregateInput>;
  planDiscount?: Maybe<SortOrder>;
  planPricings?: Maybe<CarePlanPricingOrderByRelationAggregateInput>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  publishEndDate?: Maybe<SortOrder>;
  publishStartDate?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  renewalPredecessorPlan?: Maybe<CarePlanOrderByRelationAggregateInput>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  signupFeePricing?: Maybe<SortOrder>;
  signupFeeStripeProductId?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  targetSpecies?: Maybe<SortOrder>;
  themeColor?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanPricing = {
  __typename?: 'CarePlanPricing';
  _count: CarePlanPricingCountOutputType;
  billingCycle: CarePlanCycleType;
  createdAt: Scalars['DateTime'];
  currentPlanPricingEnrollmentSupportEvents: Array<EnrollmentSupportEvent>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricing>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments: Array<CarePlanEnrollment>;
  explicitRenewalSuccessors: Array<CarePlanEnrollment>;
  id: Scalars['String'];
  newPlanPricingEnrollmentSupportEvents: Array<EnrollmentSupportEvent>;
  plan: CarePlan;
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal: Scalars['Int'];
  projectedSavings?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  renewalCycle: CarePlanCycleType;
  renewalPredecessorPlanPricings: Array<CarePlanPricing>;
  salesTaxCentsPerMonth: Scalars['Int'];
  selectedByRenewalEmailEnrollments: Array<CarePlanEnrollment>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type CarePlanPricingCurrentPlanPricingEnrollmentSupportEventsArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type CarePlanPricingDefaultRenewalSuccessorPlanPricingArgs = {
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type CarePlanPricingEnrollmentsArgs = {
  cursor?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type CarePlanPricingExplicitRenewalSuccessorsArgs = {
  cursor?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type CarePlanPricingNewPlanPricingEnrollmentSupportEventsArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type CarePlanPricingRenewalPredecessorPlanPricingsArgs = {
  cursor?: Maybe<CarePlanPricingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanPricingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanPricingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type CarePlanPricingSelectedByRenewalEmailEnrollmentsArgs = {
  cursor?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};

export type CarePlanPricingAvgAggregateOutputType = {
  __typename?: 'CarePlanPricingAvgAggregateOutputType';
  planDiscount?: Maybe<Scalars['Float']>;
  pricePerRenewal?: Maybe<Scalars['Float']>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Float']>;
};

export type CarePlanPricingAvgOrderByAggregateInput = {
  planDiscount?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
};

export type CarePlanPricingCountAggregateOutputType = {
  __typename?: 'CarePlanPricingCountAggregateOutputType';
  _all: Scalars['Int'];
  billingCycle: Scalars['Int'];
  createdAt: Scalars['Int'];
  defaultRenewalSuccessorPlanPricingId: Scalars['Int'];
  id: Scalars['Int'];
  planDiscount: Scalars['Int'];
  planId: Scalars['Int'];
  pricePerRenewal: Scalars['Int'];
  projectedSavings: Scalars['Int'];
  published: Scalars['Int'];
  renewalCycle: Scalars['Int'];
  salesTaxCentsPerMonth: Scalars['Int'];
  stripePriceId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CarePlanPricingCountOrderByAggregateInput = {
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  planDiscount?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanPricingCountOutputType = {
  __typename?: 'CarePlanPricingCountOutputType';
  currentPlanPricingEnrollmentSupportEvents: Scalars['Int'];
  enrollments: Scalars['Int'];
  explicitRenewalSuccessors: Scalars['Int'];
  newPlanPricingEnrollmentSupportEvents: Scalars['Int'];
  renewalPredecessorPlanPricings: Scalars['Int'];
  selectedByRenewalEmailEnrollments: Scalars['Int'];
};

export type CarePlanPricingCreateInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutRenewalPredecessorPlanPricingsInput>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanPricingInput>;
  plan: CarePlanCreateNestedOneWithoutPlanPricingsInput;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingCreateManyDefaultRenewalSuccessorPlanPricingInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingCreateManyDefaultRenewalSuccessorPlanPricingInputEnvelope = {
  data: Array<CarePlanPricingCreateManyDefaultRenewalSuccessorPlanPricingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanPricingCreateManyInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingCreateManyPlanInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingCreateManyPlanInputEnvelope = {
  data: Array<CarePlanPricingCreateManyPlanInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanPricingCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput = {
  connect?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanPricingCreateOrConnectWithoutDefaultRenewalSuccessorPlanPricingInput>>;
  create?: Maybe<Array<CarePlanPricingCreateWithoutDefaultRenewalSuccessorPlanPricingInput>>;
  createMany?: Maybe<CarePlanPricingCreateManyDefaultRenewalSuccessorPlanPricingInputEnvelope>;
};

export type CarePlanPricingCreateNestedManyWithoutPlanInput = {
  connect?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanPricingCreateOrConnectWithoutPlanInput>>;
  create?: Maybe<Array<CarePlanPricingCreateWithoutPlanInput>>;
  createMany?: Maybe<CarePlanPricingCreateManyPlanInputEnvelope>;
};

export type CarePlanPricingCreateNestedOneWithoutCurrentPlanPricingEnrollmentSupportEventsInput = {
  connect?: Maybe<CarePlanPricingWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanPricingCreateOrConnectWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  create?: Maybe<CarePlanPricingCreateWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
};

export type CarePlanPricingCreateNestedOneWithoutEnrollmentsInput = {
  connect?: Maybe<CarePlanPricingWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanPricingCreateOrConnectWithoutEnrollmentsInput>;
  create?: Maybe<CarePlanPricingCreateWithoutEnrollmentsInput>;
};

export type CarePlanPricingCreateNestedOneWithoutExplicitRenewalSuccessorsInput = {
  connect?: Maybe<CarePlanPricingWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanPricingCreateOrConnectWithoutExplicitRenewalSuccessorsInput>;
  create?: Maybe<CarePlanPricingCreateWithoutExplicitRenewalSuccessorsInput>;
};

export type CarePlanPricingCreateNestedOneWithoutNewPlanPricingEnrollmentSupportEventsInput = {
  connect?: Maybe<CarePlanPricingWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanPricingCreateOrConnectWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  create?: Maybe<CarePlanPricingCreateWithoutNewPlanPricingEnrollmentSupportEventsInput>;
};

export type CarePlanPricingCreateNestedOneWithoutRenewalPredecessorPlanPricingsInput = {
  connect?: Maybe<CarePlanPricingWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanPricingCreateOrConnectWithoutRenewalPredecessorPlanPricingsInput>;
  create?: Maybe<CarePlanPricingCreateWithoutRenewalPredecessorPlanPricingsInput>;
};

export type CarePlanPricingCreateNestedOneWithoutSelectedByRenewalEmailEnrollmentsInput = {
  connect?: Maybe<CarePlanPricingWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanPricingCreateOrConnectWithoutSelectedByRenewalEmailEnrollmentsInput>;
  create?: Maybe<CarePlanPricingCreateWithoutSelectedByRenewalEmailEnrollmentsInput>;
};

export type CarePlanPricingCreateOrConnectWithoutCurrentPlanPricingEnrollmentSupportEventsInput = {
  create: CarePlanPricingCreateWithoutCurrentPlanPricingEnrollmentSupportEventsInput;
  where: CarePlanPricingWhereUniqueInput;
};

export type CarePlanPricingCreateOrConnectWithoutDefaultRenewalSuccessorPlanPricingInput = {
  create: CarePlanPricingCreateWithoutDefaultRenewalSuccessorPlanPricingInput;
  where: CarePlanPricingWhereUniqueInput;
};

export type CarePlanPricingCreateOrConnectWithoutEnrollmentsInput = {
  create: CarePlanPricingCreateWithoutEnrollmentsInput;
  where: CarePlanPricingWhereUniqueInput;
};

export type CarePlanPricingCreateOrConnectWithoutExplicitRenewalSuccessorsInput = {
  create: CarePlanPricingCreateWithoutExplicitRenewalSuccessorsInput;
  where: CarePlanPricingWhereUniqueInput;
};

export type CarePlanPricingCreateOrConnectWithoutNewPlanPricingEnrollmentSupportEventsInput = {
  create: CarePlanPricingCreateWithoutNewPlanPricingEnrollmentSupportEventsInput;
  where: CarePlanPricingWhereUniqueInput;
};

export type CarePlanPricingCreateOrConnectWithoutPlanInput = {
  create: CarePlanPricingCreateWithoutPlanInput;
  where: CarePlanPricingWhereUniqueInput;
};

export type CarePlanPricingCreateOrConnectWithoutRenewalPredecessorPlanPricingsInput = {
  create: CarePlanPricingCreateWithoutRenewalPredecessorPlanPricingsInput;
  where: CarePlanPricingWhereUniqueInput;
};

export type CarePlanPricingCreateOrConnectWithoutSelectedByRenewalEmailEnrollmentsInput = {
  create: CarePlanPricingCreateWithoutSelectedByRenewalEmailEnrollmentsInput;
  where: CarePlanPricingWhereUniqueInput;
};

export type CarePlanPricingCreateWithoutCurrentPlanPricingEnrollmentSupportEventsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutRenewalPredecessorPlanPricingsInput>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanPricingInput>;
  plan: CarePlanCreateNestedOneWithoutPlanPricingsInput;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingCreateWithoutDefaultRenewalSuccessorPlanPricingInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanPricingInput>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanPricingInput>;
  plan: CarePlanCreateNestedOneWithoutPlanPricingsInput;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingCreateWithoutEnrollmentsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutRenewalPredecessorPlanPricingsInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanPricingInput>;
  plan: CarePlanCreateNestedOneWithoutPlanPricingsInput;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingCreateWithoutExplicitRenewalSuccessorsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutRenewalPredecessorPlanPricingsInput>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanPricingInput>;
  plan: CarePlanCreateNestedOneWithoutPlanPricingsInput;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingCreateWithoutNewPlanPricingEnrollmentSupportEventsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutRenewalPredecessorPlanPricingsInput>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  plan: CarePlanCreateNestedOneWithoutPlanPricingsInput;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingCreateWithoutPlanInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutRenewalPredecessorPlanPricingsInput>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanPricingInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingCreateWithoutRenewalPredecessorPlanPricingsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutRenewalPredecessorPlanPricingsInput>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanPricingInput>;
  plan: CarePlanCreateNestedOneWithoutPlanPricingsInput;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingCreateWithoutSelectedByRenewalEmailEnrollmentsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutRenewalPredecessorPlanPricingsInput>;
  enrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutNewPlanPricingInput>;
  plan: CarePlanCreateNestedOneWithoutPlanPricingsInput;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingGroupByOutputType = {
  __typename?: 'CarePlanPricingGroupByOutputType';
  _avg?: Maybe<CarePlanPricingAvgAggregateOutputType>;
  _count?: Maybe<CarePlanPricingCountAggregateOutputType>;
  _max?: Maybe<CarePlanPricingMaxAggregateOutputType>;
  _min?: Maybe<CarePlanPricingMinAggregateOutputType>;
  _sum?: Maybe<CarePlanPricingSumAggregateOutputType>;
  billingCycle: CarePlanCycleType;
  createdAt: Scalars['DateTime'];
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal: Scalars['Int'];
  projectedSavings?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  renewalCycle: CarePlanCycleType;
  salesTaxCentsPerMonth: Scalars['Int'];
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CarePlanPricingListRelationFilter = {
  every?: Maybe<CarePlanPricingWhereInput>;
  none?: Maybe<CarePlanPricingWhereInput>;
  some?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingMaxAggregateOutputType = {
  __typename?: 'CarePlanPricingMaxAggregateOutputType';
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingMaxOrderByAggregateInput = {
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  planDiscount?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanPricingMinAggregateOutputType = {
  __typename?: 'CarePlanPricingMinAggregateOutputType';
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingMinOrderByAggregateInput = {
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  planDiscount?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanPricingNullableScalarRelationFilter = {
  AND?: Maybe<Array<CarePlanPricingWhereInput>>;
  NOT?: Maybe<Array<CarePlanPricingWhereInput>>;
  OR?: Maybe<Array<CarePlanPricingWhereInput>>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<StringNullableFilter>;
  enrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentListRelationFilter>;
  id?: Maybe<StringFilter>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  plan?: Maybe<CarePlanScalarRelationFilter>;
  planDiscount?: Maybe<IntNullableFilter>;
  planId?: Maybe<StringFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingListRelationFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanPricingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CarePlanPricingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CarePlanPricingOrderByRelevanceInput>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  enrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  plan?: Maybe<CarePlanOrderByWithRelationInput>;
  planDiscount?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingOrderByRelationAggregateInput>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  stripePriceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CarePlanPricingOrderByRelevanceFieldEnum {
  DefaultRenewalSuccessorPlanPricingId = 'defaultRenewalSuccessorPlanPricingId',
  Id = 'id',
  PlanId = 'planId',
  ProjectedSavings = 'projectedSavings',
  StripePriceId = 'stripePriceId'
}

export type CarePlanPricingOrderByRelevanceInput = {
  fields: Array<CarePlanPricingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CarePlanPricingOrderByWithAggregationInput = {
  _avg?: Maybe<CarePlanPricingAvgOrderByAggregateInput>;
  _count?: Maybe<CarePlanPricingCountOrderByAggregateInput>;
  _max?: Maybe<CarePlanPricingMaxOrderByAggregateInput>;
  _min?: Maybe<CarePlanPricingMinOrderByAggregateInput>;
  _sum?: Maybe<CarePlanPricingSumOrderByAggregateInput>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  planDiscount?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  stripePriceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanPricingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CarePlanPricingOrderByRelevanceInput>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  enrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  plan?: Maybe<CarePlanOrderByWithRelationInput>;
  planDiscount?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingOrderByRelationAggregateInput>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  stripePriceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanPricingOrderByWithRelationInput = {
  _relevance?: Maybe<CarePlanPricingOrderByRelevanceInput>;
  billingCycle?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<SortOrder>;
  enrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  plan?: Maybe<CarePlanOrderByWithRelationInput>;
  planDiscount?: Maybe<SortOrder>;
  planId?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  projectedSavings?: Maybe<SortOrder>;
  published?: Maybe<SortOrder>;
  renewalCycle?: Maybe<SortOrder>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingOrderByRelationAggregateInput>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  stripePriceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CarePlanPricingScalarFieldEnum {
  BillingCycle = 'billingCycle',
  CreatedAt = 'createdAt',
  DefaultRenewalSuccessorPlanPricingId = 'defaultRenewalSuccessorPlanPricingId',
  Id = 'id',
  PlanDiscount = 'planDiscount',
  PlanId = 'planId',
  PricePerRenewal = 'pricePerRenewal',
  ProjectedSavings = 'projectedSavings',
  Published = 'published',
  RenewalCycle = 'renewalCycle',
  SalesTaxCentsPerMonth = 'salesTaxCentsPerMonth',
  StripePriceId = 'stripePriceId',
  UpdatedAt = 'updatedAt'
}

export type CarePlanPricingScalarWhereInput = {
  AND?: Maybe<Array<CarePlanPricingScalarWhereInput>>;
  NOT?: Maybe<Array<CarePlanPricingScalarWhereInput>>;
  OR?: Maybe<Array<CarePlanPricingScalarWhereInput>>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  planDiscount?: Maybe<IntNullableFilter>;
  planId?: Maybe<StringFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanPricingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CarePlanPricingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CarePlanPricingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CarePlanPricingScalarWhereWithAggregatesInput>>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  planDiscount?: Maybe<IntNullableWithAggregatesFilter>;
  planId?: Maybe<StringWithAggregatesFilter>;
  pricePerRenewal?: Maybe<IntWithAggregatesFilter>;
  projectedSavings?: Maybe<StringNullableWithAggregatesFilter>;
  published?: Maybe<BoolWithAggregatesFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeWithAggregatesFilter>;
  salesTaxCentsPerMonth?: Maybe<IntWithAggregatesFilter>;
  stripePriceId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CarePlanPricingSumAggregateOutputType = {
  __typename?: 'CarePlanPricingSumAggregateOutputType';
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
};

export type CarePlanPricingSumOrderByAggregateInput = {
  planDiscount?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
};

export type CarePlanPricingUncheckedCreateInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanPricingInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput = {
  connect?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanPricingCreateOrConnectWithoutDefaultRenewalSuccessorPlanPricingInput>>;
  create?: Maybe<Array<CarePlanPricingCreateWithoutDefaultRenewalSuccessorPlanPricingInput>>;
  createMany?: Maybe<CarePlanPricingCreateManyDefaultRenewalSuccessorPlanPricingInputEnvelope>;
};

export type CarePlanPricingUncheckedCreateNestedManyWithoutPlanInput = {
  connect?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanPricingCreateOrConnectWithoutPlanInput>>;
  create?: Maybe<Array<CarePlanPricingCreateWithoutPlanInput>>;
  createMany?: Maybe<CarePlanPricingCreateManyPlanInputEnvelope>;
};

export type CarePlanPricingUncheckedCreateWithoutCurrentPlanPricingEnrollmentSupportEventsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanPricingInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedCreateWithoutDefaultRenewalSuccessorPlanPricingInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanPricingInput>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanPricingInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedCreateWithoutEnrollmentsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanPricingInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedCreateWithoutExplicitRenewalSuccessorsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanPricingInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedCreateWithoutNewPlanPricingEnrollmentSupportEventsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedCreateWithoutPlanInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanPricingInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedCreateWithoutRenewalPredecessorPlanPricingsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanPricingInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanPricingInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedCreateWithoutSelectedByRenewalEmailEnrollmentsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanPricingInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanPricingInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSuccessorPlanPricingInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanPricingInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanPricingInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedUpdateInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanPricingNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedUpdateManyInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanPricingInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput = {
  connect?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanPricingCreateOrConnectWithoutDefaultRenewalSuccessorPlanPricingInput>>;
  create?: Maybe<Array<CarePlanPricingCreateWithoutDefaultRenewalSuccessorPlanPricingInput>>;
  createMany?: Maybe<CarePlanPricingCreateManyDefaultRenewalSuccessorPlanPricingInputEnvelope>;
  delete?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanPricingScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanPricingUpdateWithWhereUniqueWithoutDefaultRenewalSuccessorPlanPricingInput>>;
  updateMany?: Maybe<Array<CarePlanPricingUpdateManyWithWhereWithoutDefaultRenewalSuccessorPlanPricingInput>>;
  upsert?: Maybe<Array<CarePlanPricingUpsertWithWhereUniqueWithoutDefaultRenewalSuccessorPlanPricingInput>>;
};

export type CarePlanPricingUncheckedUpdateManyWithoutPlanInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedUpdateManyWithoutPlanNestedInput = {
  connect?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanPricingCreateOrConnectWithoutPlanInput>>;
  create?: Maybe<Array<CarePlanPricingCreateWithoutPlanInput>>;
  createMany?: Maybe<CarePlanPricingCreateManyPlanInputEnvelope>;
  delete?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanPricingScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanPricingUpdateWithWhereUniqueWithoutPlanInput>>;
  updateMany?: Maybe<Array<CarePlanPricingUpdateManyWithWhereWithoutPlanInput>>;
  upsert?: Maybe<Array<CarePlanPricingUpsertWithWhereUniqueWithoutPlanInput>>;
};

export type CarePlanPricingUncheckedUpdateWithoutCurrentPlanPricingEnrollmentSupportEventsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanPricingNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedUpdateWithoutDefaultRenewalSuccessorPlanPricingInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanPricingNestedInput>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanPricingNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedUpdateWithoutEnrollmentsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanPricingNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedUpdateWithoutExplicitRenewalSuccessorsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanPricingNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedUpdateWithoutNewPlanPricingEnrollmentSupportEventsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedUpdateWithoutPlanInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanPricingNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedUpdateWithoutRenewalPredecessorPlanPricingsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanPricingNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUncheckedUpdateWithoutSelectedByRenewalEmailEnrollmentsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanPricingNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUpdateInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutRenewalPredecessorPlanPricingsNestedInput>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanPricingNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutPlanPricingsNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUpdateManyMutationInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUpdateManyWithWhereWithoutDefaultRenewalSuccessorPlanPricingInput = {
  data: CarePlanPricingUpdateManyMutationInput;
  where: CarePlanPricingScalarWhereInput;
};

export type CarePlanPricingUpdateManyWithWhereWithoutPlanInput = {
  data: CarePlanPricingUpdateManyMutationInput;
  where: CarePlanPricingScalarWhereInput;
};

export type CarePlanPricingUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput = {
  connect?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanPricingCreateOrConnectWithoutDefaultRenewalSuccessorPlanPricingInput>>;
  create?: Maybe<Array<CarePlanPricingCreateWithoutDefaultRenewalSuccessorPlanPricingInput>>;
  createMany?: Maybe<CarePlanPricingCreateManyDefaultRenewalSuccessorPlanPricingInputEnvelope>;
  delete?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanPricingScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanPricingUpdateWithWhereUniqueWithoutDefaultRenewalSuccessorPlanPricingInput>>;
  updateMany?: Maybe<Array<CarePlanPricingUpdateManyWithWhereWithoutDefaultRenewalSuccessorPlanPricingInput>>;
  upsert?: Maybe<Array<CarePlanPricingUpsertWithWhereUniqueWithoutDefaultRenewalSuccessorPlanPricingInput>>;
};

export type CarePlanPricingUpdateManyWithoutPlanNestedInput = {
  connect?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanPricingCreateOrConnectWithoutPlanInput>>;
  create?: Maybe<Array<CarePlanPricingCreateWithoutPlanInput>>;
  createMany?: Maybe<CarePlanPricingCreateManyPlanInputEnvelope>;
  delete?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanPricingScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanPricingWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanPricingUpdateWithWhereUniqueWithoutPlanInput>>;
  updateMany?: Maybe<Array<CarePlanPricingUpdateManyWithWhereWithoutPlanInput>>;
  upsert?: Maybe<Array<CarePlanPricingUpsertWithWhereUniqueWithoutPlanInput>>;
};

export type CarePlanPricingUpdateOneWithoutCurrentPlanPricingEnrollmentSupportEventsNestedInput = {
  connect?: Maybe<CarePlanPricingWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanPricingCreateOrConnectWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  create?: Maybe<CarePlanPricingCreateWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanPricingUpdateToOneWithWhereWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  upsert?: Maybe<CarePlanPricingUpsertWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
};

export type CarePlanPricingUpdateOneWithoutEnrollmentsNestedInput = {
  connect?: Maybe<CarePlanPricingWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanPricingCreateOrConnectWithoutEnrollmentsInput>;
  create?: Maybe<CarePlanPricingCreateWithoutEnrollmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanPricingUpdateToOneWithWhereWithoutEnrollmentsInput>;
  upsert?: Maybe<CarePlanPricingUpsertWithoutEnrollmentsInput>;
};

export type CarePlanPricingUpdateOneWithoutExplicitRenewalSuccessorsNestedInput = {
  connect?: Maybe<CarePlanPricingWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanPricingCreateOrConnectWithoutExplicitRenewalSuccessorsInput>;
  create?: Maybe<CarePlanPricingCreateWithoutExplicitRenewalSuccessorsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanPricingUpdateToOneWithWhereWithoutExplicitRenewalSuccessorsInput>;
  upsert?: Maybe<CarePlanPricingUpsertWithoutExplicitRenewalSuccessorsInput>;
};

export type CarePlanPricingUpdateOneWithoutNewPlanPricingEnrollmentSupportEventsNestedInput = {
  connect?: Maybe<CarePlanPricingWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanPricingCreateOrConnectWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  create?: Maybe<CarePlanPricingCreateWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanPricingUpdateToOneWithWhereWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  upsert?: Maybe<CarePlanPricingUpsertWithoutNewPlanPricingEnrollmentSupportEventsInput>;
};

export type CarePlanPricingUpdateOneWithoutRenewalPredecessorPlanPricingsNestedInput = {
  connect?: Maybe<CarePlanPricingWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanPricingCreateOrConnectWithoutRenewalPredecessorPlanPricingsInput>;
  create?: Maybe<CarePlanPricingCreateWithoutRenewalPredecessorPlanPricingsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanPricingUpdateToOneWithWhereWithoutRenewalPredecessorPlanPricingsInput>;
  upsert?: Maybe<CarePlanPricingUpsertWithoutRenewalPredecessorPlanPricingsInput>;
};

export type CarePlanPricingUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput = {
  connect?: Maybe<CarePlanPricingWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanPricingCreateOrConnectWithoutSelectedByRenewalEmailEnrollmentsInput>;
  create?: Maybe<CarePlanPricingCreateWithoutSelectedByRenewalEmailEnrollmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanPricingUpdateToOneWithWhereWithoutSelectedByRenewalEmailEnrollmentsInput>;
  upsert?: Maybe<CarePlanPricingUpsertWithoutSelectedByRenewalEmailEnrollmentsInput>;
};

export type CarePlanPricingUpdateToOneWithWhereWithoutCurrentPlanPricingEnrollmentSupportEventsInput = {
  data: CarePlanPricingUpdateWithoutCurrentPlanPricingEnrollmentSupportEventsInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingUpdateToOneWithWhereWithoutEnrollmentsInput = {
  data: CarePlanPricingUpdateWithoutEnrollmentsInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingUpdateToOneWithWhereWithoutExplicitRenewalSuccessorsInput = {
  data: CarePlanPricingUpdateWithoutExplicitRenewalSuccessorsInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingUpdateToOneWithWhereWithoutNewPlanPricingEnrollmentSupportEventsInput = {
  data: CarePlanPricingUpdateWithoutNewPlanPricingEnrollmentSupportEventsInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingUpdateToOneWithWhereWithoutRenewalPredecessorPlanPricingsInput = {
  data: CarePlanPricingUpdateWithoutRenewalPredecessorPlanPricingsInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingUpdateToOneWithWhereWithoutSelectedByRenewalEmailEnrollmentsInput = {
  data: CarePlanPricingUpdateWithoutSelectedByRenewalEmailEnrollmentsInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingUpdateWithWhereUniqueWithoutDefaultRenewalSuccessorPlanPricingInput = {
  data: CarePlanPricingUpdateWithoutDefaultRenewalSuccessorPlanPricingInput;
  where: CarePlanPricingWhereUniqueInput;
};

export type CarePlanPricingUpdateWithWhereUniqueWithoutPlanInput = {
  data: CarePlanPricingUpdateWithoutPlanInput;
  where: CarePlanPricingWhereUniqueInput;
};

export type CarePlanPricingUpdateWithoutCurrentPlanPricingEnrollmentSupportEventsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutRenewalPredecessorPlanPricingsNestedInput>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanPricingNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutPlanPricingsNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUpdateWithoutDefaultRenewalSuccessorPlanPricingInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanPricingNestedInput>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanPricingNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutPlanPricingsNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUpdateWithoutEnrollmentsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutRenewalPredecessorPlanPricingsNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanPricingNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutPlanPricingsNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUpdateWithoutExplicitRenewalSuccessorsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutRenewalPredecessorPlanPricingsNestedInput>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanPricingNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutPlanPricingsNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUpdateWithoutNewPlanPricingEnrollmentSupportEventsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutRenewalPredecessorPlanPricingsNestedInput>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutPlanPricingsNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUpdateWithoutPlanInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutRenewalPredecessorPlanPricingsNestedInput>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanPricingNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUpdateWithoutRenewalPredecessorPlanPricingsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutRenewalPredecessorPlanPricingsNestedInput>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanPricingNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutPlanPricingsNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanPricingNestedInput>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUpdateWithoutSelectedByRenewalEmailEnrollmentsInput = {
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanPricingNestedInput>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutRenewalPredecessorPlanPricingsNestedInput>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanPricingNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSuccessorPlanPricingNestedInput>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanPricingNestedInput>;
  plan?: Maybe<CarePlanUpdateOneRequiredWithoutPlanPricingsNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingUpdateManyWithoutDefaultRenewalSuccessorPlanPricingNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanPricingUpsertWithWhereUniqueWithoutDefaultRenewalSuccessorPlanPricingInput = {
  create: CarePlanPricingCreateWithoutDefaultRenewalSuccessorPlanPricingInput;
  update: CarePlanPricingUpdateWithoutDefaultRenewalSuccessorPlanPricingInput;
  where: CarePlanPricingWhereUniqueInput;
};

export type CarePlanPricingUpsertWithWhereUniqueWithoutPlanInput = {
  create: CarePlanPricingCreateWithoutPlanInput;
  update: CarePlanPricingUpdateWithoutPlanInput;
  where: CarePlanPricingWhereUniqueInput;
};

export type CarePlanPricingUpsertWithoutCurrentPlanPricingEnrollmentSupportEventsInput = {
  create: CarePlanPricingCreateWithoutCurrentPlanPricingEnrollmentSupportEventsInput;
  update: CarePlanPricingUpdateWithoutCurrentPlanPricingEnrollmentSupportEventsInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingUpsertWithoutEnrollmentsInput = {
  create: CarePlanPricingCreateWithoutEnrollmentsInput;
  update: CarePlanPricingUpdateWithoutEnrollmentsInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingUpsertWithoutExplicitRenewalSuccessorsInput = {
  create: CarePlanPricingCreateWithoutExplicitRenewalSuccessorsInput;
  update: CarePlanPricingUpdateWithoutExplicitRenewalSuccessorsInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingUpsertWithoutNewPlanPricingEnrollmentSupportEventsInput = {
  create: CarePlanPricingCreateWithoutNewPlanPricingEnrollmentSupportEventsInput;
  update: CarePlanPricingUpdateWithoutNewPlanPricingEnrollmentSupportEventsInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingUpsertWithoutRenewalPredecessorPlanPricingsInput = {
  create: CarePlanPricingCreateWithoutRenewalPredecessorPlanPricingsInput;
  update: CarePlanPricingUpdateWithoutRenewalPredecessorPlanPricingsInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingUpsertWithoutSelectedByRenewalEmailEnrollmentsInput = {
  create: CarePlanPricingCreateWithoutSelectedByRenewalEmailEnrollmentsInput;
  update: CarePlanPricingUpdateWithoutSelectedByRenewalEmailEnrollmentsInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};

export type CarePlanPricingWhereInput = {
  AND?: Maybe<Array<CarePlanPricingWhereInput>>;
  NOT?: Maybe<Array<CarePlanPricingWhereInput>>;
  OR?: Maybe<Array<CarePlanPricingWhereInput>>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<StringNullableFilter>;
  enrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentListRelationFilter>;
  id?: Maybe<StringFilter>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  plan?: Maybe<CarePlanScalarRelationFilter>;
  planDiscount?: Maybe<IntNullableFilter>;
  planId?: Maybe<StringFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingListRelationFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanPricingWhereUniqueInput = {
  AND?: Maybe<Array<CarePlanPricingWhereInput>>;
  NOT?: Maybe<Array<CarePlanPricingWhereInput>>;
  OR?: Maybe<Array<CarePlanPricingWhereInput>>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<StringNullableFilter>;
  enrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  newPlanPricingEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  plan?: Maybe<CarePlanScalarRelationFilter>;
  planDiscount?: Maybe<IntNullableFilter>;
  planId?: Maybe<StringFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  renewalPredecessorPlanPricings?: Maybe<CarePlanPricingListRelationFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanProviderGroup = {
  __typename?: 'CarePlanProviderGroup';
  _count: CarePlanProviderGroupCountOutputType;
  associatedAddonPackages: Array<CareAddonPackage>;
  associatedCareBenefits: Array<CareBenefit>;
  associatedPlans: Array<CarePlan>;
  associatedSubscriptions: Array<CareStripeSubscription>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  launchStatus: CareProgramLaunchStatus;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics: Array<Clinic>;
  paymentProcessorClinic?: Maybe<Clinic>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type CarePlanProviderGroupAssociatedAddonPackagesArgs = {
  cursor?: Maybe<CareAddonPackageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonPackageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonPackageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonPackageWhereInput>;
};


export type CarePlanProviderGroupAssociatedCareBenefitsArgs = {
  cursor?: Maybe<CareBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitWhereInput>;
};


export type CarePlanProviderGroupAssociatedPlansArgs = {
  cursor?: Maybe<CarePlanWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanWhereInput>;
};


export type CarePlanProviderGroupAssociatedSubscriptionsArgs = {
  cursor?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareStripeSubscriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareStripeSubscriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type CarePlanProviderGroupOrganizationArgs = {
  where?: Maybe<OrganizationWhereInput>;
};


export type CarePlanProviderGroupParticipatingClinicsArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type CarePlanProviderGroupPaymentProcessorClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};

export type CarePlanProviderGroupCountAggregateOutputType = {
  __typename?: 'CarePlanProviderGroupCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  launchStatus: Scalars['Int'];
  organizationId: Scalars['Int'];
  paymentProcessorClinicId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CarePlanProviderGroupCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  launchStatus?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanProviderGroupCountOutputType = {
  __typename?: 'CarePlanProviderGroupCountOutputType';
  associatedAddonPackages: Scalars['Int'];
  associatedCareBenefits: Scalars['Int'];
  associatedPlans: Scalars['Int'];
  associatedSubscriptions: Scalars['Int'];
  participatingClinics: Scalars['Int'];
};

export type CarePlanProviderGroupCreateInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedCareBenefits?: Maybe<CareBenefitCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutCarePlanProviderGroupsInput>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutCarePlanProviderGroupInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutPaymentProcessorForProviderGroupInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupCreateManyOrganizationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupCreateManyOrganizationInputEnvelope = {
  data: Array<CarePlanProviderGroupCreateManyOrganizationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CarePlanProviderGroupCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<CarePlanProviderGroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanProviderGroupCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CarePlanProviderGroupCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CarePlanProviderGroupCreateManyOrganizationInputEnvelope>;
};

export type CarePlanProviderGroupCreateNestedOneWithoutAssociatedAddonPackagesInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutAssociatedAddonPackagesInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutAssociatedAddonPackagesInput>;
};

export type CarePlanProviderGroupCreateNestedOneWithoutAssociatedCareBenefitsInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutAssociatedCareBenefitsInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutAssociatedCareBenefitsInput>;
};

export type CarePlanProviderGroupCreateNestedOneWithoutAssociatedPlansInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutAssociatedPlansInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutAssociatedPlansInput>;
};

export type CarePlanProviderGroupCreateNestedOneWithoutAssociatedSubscriptionsInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutAssociatedSubscriptionsInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutAssociatedSubscriptionsInput>;
};

export type CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutParticipatingClinicsInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutParticipatingClinicsInput>;
};

export type CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutPaymentProcessorClinicInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutPaymentProcessorClinicInput>;
};

export type CarePlanProviderGroupCreateOrConnectWithoutAssociatedAddonPackagesInput = {
  create: CarePlanProviderGroupCreateWithoutAssociatedAddonPackagesInput;
  where: CarePlanProviderGroupWhereUniqueInput;
};

export type CarePlanProviderGroupCreateOrConnectWithoutAssociatedCareBenefitsInput = {
  create: CarePlanProviderGroupCreateWithoutAssociatedCareBenefitsInput;
  where: CarePlanProviderGroupWhereUniqueInput;
};

export type CarePlanProviderGroupCreateOrConnectWithoutAssociatedPlansInput = {
  create: CarePlanProviderGroupCreateWithoutAssociatedPlansInput;
  where: CarePlanProviderGroupWhereUniqueInput;
};

export type CarePlanProviderGroupCreateOrConnectWithoutAssociatedSubscriptionsInput = {
  create: CarePlanProviderGroupCreateWithoutAssociatedSubscriptionsInput;
  where: CarePlanProviderGroupWhereUniqueInput;
};

export type CarePlanProviderGroupCreateOrConnectWithoutOrganizationInput = {
  create: CarePlanProviderGroupCreateWithoutOrganizationInput;
  where: CarePlanProviderGroupWhereUniqueInput;
};

export type CarePlanProviderGroupCreateOrConnectWithoutParticipatingClinicsInput = {
  create: CarePlanProviderGroupCreateWithoutParticipatingClinicsInput;
  where: CarePlanProviderGroupWhereUniqueInput;
};

export type CarePlanProviderGroupCreateOrConnectWithoutPaymentProcessorClinicInput = {
  create: CarePlanProviderGroupCreateWithoutPaymentProcessorClinicInput;
  where: CarePlanProviderGroupWhereUniqueInput;
};

export type CarePlanProviderGroupCreateWithoutAssociatedAddonPackagesInput = {
  associatedCareBenefits?: Maybe<CareBenefitCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutCarePlanProviderGroupsInput>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutCarePlanProviderGroupInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutPaymentProcessorForProviderGroupInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupCreateWithoutAssociatedCareBenefitsInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutCarePlanProviderGroupsInput>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutCarePlanProviderGroupInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutPaymentProcessorForProviderGroupInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupCreateWithoutAssociatedPlansInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedCareBenefits?: Maybe<CareBenefitCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutCarePlanProviderGroupsInput>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutCarePlanProviderGroupInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutPaymentProcessorForProviderGroupInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupCreateWithoutAssociatedSubscriptionsInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedCareBenefits?: Maybe<CareBenefitCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutCarePlanProviderGroupsInput>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutCarePlanProviderGroupInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutPaymentProcessorForProviderGroupInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupCreateWithoutOrganizationInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedCareBenefits?: Maybe<CareBenefitCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutCarePlanProviderGroupInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutPaymentProcessorForProviderGroupInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupCreateWithoutParticipatingClinicsInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedCareBenefits?: Maybe<CareBenefitCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutCarePlanProviderGroupsInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutPaymentProcessorForProviderGroupInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupCreateWithoutPaymentProcessorClinicInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedCareBenefits?: Maybe<CareBenefitCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutCarePlanProviderGroupsInput>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutCarePlanProviderGroupInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupGroupByOutputType = {
  __typename?: 'CarePlanProviderGroupGroupByOutputType';
  _count?: Maybe<CarePlanProviderGroupCountAggregateOutputType>;
  _max?: Maybe<CarePlanProviderGroupMaxAggregateOutputType>;
  _min?: Maybe<CarePlanProviderGroupMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  launchStatus: CareProgramLaunchStatus;
  organizationId?: Maybe<Scalars['String']>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CarePlanProviderGroupListRelationFilter = {
  every?: Maybe<CarePlanProviderGroupWhereInput>;
  none?: Maybe<CarePlanProviderGroupWhereInput>;
  some?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupMaxAggregateOutputType = {
  __typename?: 'CarePlanProviderGroupMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  launchStatus?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanProviderGroupMinAggregateOutputType = {
  __typename?: 'CarePlanProviderGroupMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  launchStatus?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanProviderGroupNullableScalarRelationFilter = {
  AND?: Maybe<Array<CarePlanProviderGroupWhereInput>>;
  NOT?: Maybe<Array<CarePlanProviderGroupWhereInput>>;
  OR?: Maybe<Array<CarePlanProviderGroupWhereInput>>;
  associatedAddonPackages?: Maybe<CareAddonPackageListRelationFilter>;
  associatedCareBenefits?: Maybe<CareBenefitListRelationFilter>;
  associatedPlans?: Maybe<CarePlanListRelationFilter>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  launchStatus?: Maybe<EnumCareProgramLaunchStatusFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  participatingClinics?: Maybe<ClinicListRelationFilter>;
  paymentProcessorClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  paymentProcessorClinicId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanProviderGroupOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CarePlanProviderGroupOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CarePlanProviderGroupOrderByRelevanceInput>;
  associatedAddonPackages?: Maybe<CareAddonPackageOrderByRelationAggregateInput>;
  associatedCareBenefits?: Maybe<CareBenefitOrderByRelationAggregateInput>;
  associatedPlans?: Maybe<CarePlanOrderByRelationAggregateInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  launchStatus?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  participatingClinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  paymentProcessorClinic?: Maybe<ClinicOrderByWithRelationInput>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CarePlanProviderGroupOrderByRelevanceFieldEnum {
  Id = 'id',
  OrganizationId = 'organizationId',
  PaymentProcessorClinicId = 'paymentProcessorClinicId'
}

export type CarePlanProviderGroupOrderByRelevanceInput = {
  fields: Array<CarePlanProviderGroupOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CarePlanProviderGroupOrderByWithAggregationInput = {
  _count?: Maybe<CarePlanProviderGroupCountOrderByAggregateInput>;
  _max?: Maybe<CarePlanProviderGroupMaxOrderByAggregateInput>;
  _min?: Maybe<CarePlanProviderGroupMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  launchStatus?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanProviderGroupOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CarePlanProviderGroupOrderByRelevanceInput>;
  associatedAddonPackages?: Maybe<CareAddonPackageOrderByRelationAggregateInput>;
  associatedCareBenefits?: Maybe<CareBenefitOrderByRelationAggregateInput>;
  associatedPlans?: Maybe<CarePlanOrderByRelationAggregateInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  launchStatus?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  participatingClinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  paymentProcessorClinic?: Maybe<ClinicOrderByWithRelationInput>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CarePlanProviderGroupOrderByWithRelationInput = {
  _relevance?: Maybe<CarePlanProviderGroupOrderByRelevanceInput>;
  associatedAddonPackages?: Maybe<CareAddonPackageOrderByRelationAggregateInput>;
  associatedCareBenefits?: Maybe<CareBenefitOrderByRelationAggregateInput>;
  associatedPlans?: Maybe<CarePlanOrderByRelationAggregateInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  launchStatus?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  participatingClinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  paymentProcessorClinic?: Maybe<ClinicOrderByWithRelationInput>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CarePlanProviderGroupScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  LaunchStatus = 'launchStatus',
  OrganizationId = 'organizationId',
  PaymentProcessorClinicId = 'paymentProcessorClinicId',
  UpdatedAt = 'updatedAt'
}

export type CarePlanProviderGroupScalarWhereInput = {
  AND?: Maybe<Array<CarePlanProviderGroupScalarWhereInput>>;
  NOT?: Maybe<Array<CarePlanProviderGroupScalarWhereInput>>;
  OR?: Maybe<Array<CarePlanProviderGroupScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  launchStatus?: Maybe<EnumCareProgramLaunchStatusFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  paymentProcessorClinicId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanProviderGroupScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CarePlanProviderGroupScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CarePlanProviderGroupScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CarePlanProviderGroupScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  launchStatus?: Maybe<EnumCareProgramLaunchStatusWithAggregatesFilter>;
  organizationId?: Maybe<StringNullableWithAggregatesFilter>;
  paymentProcessorClinicId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CarePlanProviderGroupUncheckedCreateInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedCareBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutCarePlanProviderGroupInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<CarePlanProviderGroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanProviderGroupCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CarePlanProviderGroupCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CarePlanProviderGroupCreateManyOrganizationInputEnvelope>;
};

export type CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutPaymentProcessorClinicInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutPaymentProcessorClinicInput>;
};

export type CarePlanProviderGroupUncheckedCreateWithoutAssociatedAddonPackagesInput = {
  associatedCareBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutCarePlanProviderGroupInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedCreateWithoutAssociatedCareBenefitsInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutCarePlanProviderGroupInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedCreateWithoutAssociatedPlansInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedCareBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutCarePlanProviderGroupInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedCreateWithoutAssociatedSubscriptionsInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedCareBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutCarePlanProviderGroupInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedCreateWithoutOrganizationInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedCareBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutCarePlanProviderGroupInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedCreateWithoutParticipatingClinicsInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedCareBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedCreateWithoutPaymentProcessorClinicInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedCareBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedPlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutCarePlanProviderGroupInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedUpdateInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedCareBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedUpdateManyWithoutOrganizationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<CarePlanProviderGroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanProviderGroupCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CarePlanProviderGroupCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CarePlanProviderGroupCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<CarePlanProviderGroupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanProviderGroupScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanProviderGroupWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanProviderGroupWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanProviderGroupUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<CarePlanProviderGroupUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<CarePlanProviderGroupUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutPaymentProcessorClinicInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutPaymentProcessorClinicInput>;
  delete?: Maybe<CarePlanProviderGroupWhereInput>;
  disconnect?: Maybe<CarePlanProviderGroupWhereInput>;
  update?: Maybe<CarePlanProviderGroupUpdateToOneWithWhereWithoutPaymentProcessorClinicInput>;
  upsert?: Maybe<CarePlanProviderGroupUpsertWithoutPaymentProcessorClinicInput>;
};

export type CarePlanProviderGroupUncheckedUpdateWithoutAssociatedAddonPackagesInput = {
  associatedCareBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedUpdateWithoutAssociatedCareBenefitsInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedUpdateWithoutAssociatedPlansInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedCareBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedUpdateWithoutAssociatedSubscriptionsInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedCareBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedUpdateWithoutOrganizationInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedCareBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedUpdateWithoutParticipatingClinicsInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedCareBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUncheckedUpdateWithoutPaymentProcessorClinicInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedCareBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organizationId?: Maybe<Scalars['String']>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUpdateInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedCareBenefits?: Maybe<CareBenefitUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationUpdateOneWithoutCarePlanProviderGroupsNestedInput>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutPaymentProcessorForProviderGroupNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUpdateManyWithWhereWithoutOrganizationInput = {
  data: CarePlanProviderGroupUpdateManyMutationInput;
  where: CarePlanProviderGroupScalarWhereInput;
};

export type CarePlanProviderGroupUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<CarePlanProviderGroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanProviderGroupCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CarePlanProviderGroupCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CarePlanProviderGroupCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<CarePlanProviderGroupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanProviderGroupScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanProviderGroupWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanProviderGroupWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanProviderGroupUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<CarePlanProviderGroupUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<CarePlanProviderGroupUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type CarePlanProviderGroupUpdateOneWithoutAssociatedAddonPackagesNestedInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutAssociatedAddonPackagesInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutAssociatedAddonPackagesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanProviderGroupUpdateToOneWithWhereWithoutAssociatedAddonPackagesInput>;
  upsert?: Maybe<CarePlanProviderGroupUpsertWithoutAssociatedAddonPackagesInput>;
};

export type CarePlanProviderGroupUpdateOneWithoutAssociatedCareBenefitsNestedInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutAssociatedCareBenefitsInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutAssociatedCareBenefitsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanProviderGroupUpdateToOneWithWhereWithoutAssociatedCareBenefitsInput>;
  upsert?: Maybe<CarePlanProviderGroupUpsertWithoutAssociatedCareBenefitsInput>;
};

export type CarePlanProviderGroupUpdateOneWithoutAssociatedPlansNestedInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutAssociatedPlansInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutAssociatedPlansInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanProviderGroupUpdateToOneWithWhereWithoutAssociatedPlansInput>;
  upsert?: Maybe<CarePlanProviderGroupUpsertWithoutAssociatedPlansInput>;
};

export type CarePlanProviderGroupUpdateOneWithoutAssociatedSubscriptionsNestedInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutAssociatedSubscriptionsInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutAssociatedSubscriptionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanProviderGroupUpdateToOneWithWhereWithoutAssociatedSubscriptionsInput>;
  upsert?: Maybe<CarePlanProviderGroupUpsertWithoutAssociatedSubscriptionsInput>;
};

export type CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutParticipatingClinicsInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutParticipatingClinicsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanProviderGroupUpdateToOneWithWhereWithoutParticipatingClinicsInput>;
  upsert?: Maybe<CarePlanProviderGroupUpsertWithoutParticipatingClinicsInput>;
};

export type CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput = {
  connect?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanProviderGroupCreateOrConnectWithoutPaymentProcessorClinicInput>;
  create?: Maybe<CarePlanProviderGroupCreateWithoutPaymentProcessorClinicInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanProviderGroupUpdateToOneWithWhereWithoutPaymentProcessorClinicInput>;
  upsert?: Maybe<CarePlanProviderGroupUpsertWithoutPaymentProcessorClinicInput>;
};

export type CarePlanProviderGroupUpdateToOneWithWhereWithoutAssociatedAddonPackagesInput = {
  data: CarePlanProviderGroupUpdateWithoutAssociatedAddonPackagesInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupUpdateToOneWithWhereWithoutAssociatedCareBenefitsInput = {
  data: CarePlanProviderGroupUpdateWithoutAssociatedCareBenefitsInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupUpdateToOneWithWhereWithoutAssociatedPlansInput = {
  data: CarePlanProviderGroupUpdateWithoutAssociatedPlansInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupUpdateToOneWithWhereWithoutAssociatedSubscriptionsInput = {
  data: CarePlanProviderGroupUpdateWithoutAssociatedSubscriptionsInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupUpdateToOneWithWhereWithoutParticipatingClinicsInput = {
  data: CarePlanProviderGroupUpdateWithoutParticipatingClinicsInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupUpdateToOneWithWhereWithoutPaymentProcessorClinicInput = {
  data: CarePlanProviderGroupUpdateWithoutPaymentProcessorClinicInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: CarePlanProviderGroupUpdateWithoutOrganizationInput;
  where: CarePlanProviderGroupWhereUniqueInput;
};

export type CarePlanProviderGroupUpdateWithoutAssociatedAddonPackagesInput = {
  associatedCareBenefits?: Maybe<CareBenefitUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationUpdateOneWithoutCarePlanProviderGroupsNestedInput>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutPaymentProcessorForProviderGroupNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUpdateWithoutAssociatedCareBenefitsInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationUpdateOneWithoutCarePlanProviderGroupsNestedInput>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutPaymentProcessorForProviderGroupNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUpdateWithoutAssociatedPlansInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedCareBenefits?: Maybe<CareBenefitUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationUpdateOneWithoutCarePlanProviderGroupsNestedInput>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutPaymentProcessorForProviderGroupNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUpdateWithoutAssociatedSubscriptionsInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedCareBenefits?: Maybe<CareBenefitUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationUpdateOneWithoutCarePlanProviderGroupsNestedInput>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutPaymentProcessorForProviderGroupNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUpdateWithoutOrganizationInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedCareBenefits?: Maybe<CareBenefitUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutPaymentProcessorForProviderGroupNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUpdateWithoutParticipatingClinicsInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedCareBenefits?: Maybe<CareBenefitUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationUpdateOneWithoutCarePlanProviderGroupsNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutPaymentProcessorForProviderGroupNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUpdateWithoutPaymentProcessorClinicInput = {
  associatedAddonPackages?: Maybe<CareAddonPackageUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedCareBenefits?: Maybe<CareBenefitUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedPlans?: Maybe<CarePlanUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<CareProgramLaunchStatus>;
  organization?: Maybe<OrganizationUpdateOneWithoutCarePlanProviderGroupsNestedInput>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutCarePlanProviderGroupNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanProviderGroupUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: CarePlanProviderGroupCreateWithoutOrganizationInput;
  update: CarePlanProviderGroupUpdateWithoutOrganizationInput;
  where: CarePlanProviderGroupWhereUniqueInput;
};

export type CarePlanProviderGroupUpsertWithoutAssociatedAddonPackagesInput = {
  create: CarePlanProviderGroupCreateWithoutAssociatedAddonPackagesInput;
  update: CarePlanProviderGroupUpdateWithoutAssociatedAddonPackagesInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupUpsertWithoutAssociatedCareBenefitsInput = {
  create: CarePlanProviderGroupCreateWithoutAssociatedCareBenefitsInput;
  update: CarePlanProviderGroupUpdateWithoutAssociatedCareBenefitsInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupUpsertWithoutAssociatedPlansInput = {
  create: CarePlanProviderGroupCreateWithoutAssociatedPlansInput;
  update: CarePlanProviderGroupUpdateWithoutAssociatedPlansInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupUpsertWithoutAssociatedSubscriptionsInput = {
  create: CarePlanProviderGroupCreateWithoutAssociatedSubscriptionsInput;
  update: CarePlanProviderGroupUpdateWithoutAssociatedSubscriptionsInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupUpsertWithoutParticipatingClinicsInput = {
  create: CarePlanProviderGroupCreateWithoutParticipatingClinicsInput;
  update: CarePlanProviderGroupUpdateWithoutParticipatingClinicsInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupUpsertWithoutPaymentProcessorClinicInput = {
  create: CarePlanProviderGroupCreateWithoutPaymentProcessorClinicInput;
  update: CarePlanProviderGroupUpdateWithoutPaymentProcessorClinicInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};

export type CarePlanProviderGroupWhereInput = {
  AND?: Maybe<Array<CarePlanProviderGroupWhereInput>>;
  NOT?: Maybe<Array<CarePlanProviderGroupWhereInput>>;
  OR?: Maybe<Array<CarePlanProviderGroupWhereInput>>;
  associatedAddonPackages?: Maybe<CareAddonPackageListRelationFilter>;
  associatedCareBenefits?: Maybe<CareBenefitListRelationFilter>;
  associatedPlans?: Maybe<CarePlanListRelationFilter>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  launchStatus?: Maybe<EnumCareProgramLaunchStatusFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  participatingClinics?: Maybe<ClinicListRelationFilter>;
  paymentProcessorClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  paymentProcessorClinicId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanProviderGroupWhereUniqueInput = {
  AND?: Maybe<Array<CarePlanProviderGroupWhereInput>>;
  NOT?: Maybe<Array<CarePlanProviderGroupWhereInput>>;
  OR?: Maybe<Array<CarePlanProviderGroupWhereInput>>;
  associatedAddonPackages?: Maybe<CareAddonPackageListRelationFilter>;
  associatedCareBenefits?: Maybe<CareBenefitListRelationFilter>;
  associatedPlans?: Maybe<CarePlanListRelationFilter>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  launchStatus?: Maybe<EnumCareProgramLaunchStatusFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  participatingClinics?: Maybe<ClinicListRelationFilter>;
  paymentProcessorClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum CarePlanScalarFieldEnum {
  AllowSelfRenewal = 'allowSelfRenewal',
  AssociatedCarePlanProviderGroupId = 'associatedCarePlanProviderGroupId',
  BillingCycle = 'billingCycle',
  CreatedAt = 'createdAt',
  DefaultRenewalSuccessorPlanId = 'defaultRenewalSuccessorPlanId',
  Description = 'description',
  EarliestTargetPetAgeInMonths = 'earliestTargetPetAgeInMonths',
  EditorNotes = 'editorNotes',
  FlowAlias = 'flowAlias',
  Id = 'id',
  IsAcceptingPreEnrollments = 'isAcceptingPreEnrollments',
  LatestTargetPetAgeInMonths = 'latestTargetPetAgeInMonths',
  MarketingInformation = 'marketingInformation',
  OrganizationId = 'organizationId',
  PlanDiscount = 'planDiscount',
  PricePerRenewal = 'pricePerRenewal',
  ProjectedSavings = 'projectedSavings',
  PublishEndDate = 'publishEndDate',
  PublishStartDate = 'publishStartDate',
  Published = 'published',
  RenewalCycle = 'renewalCycle',
  SalesTaxCentsPerMonth = 'salesTaxCentsPerMonth',
  SignupFeePricing = 'signupFeePricing',
  SignupFeeStripeProductId = 'signupFeeStripeProductId',
  StripePriceId = 'stripePriceId',
  TargetSpecies = 'targetSpecies',
  ThemeColor = 'themeColor',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type CarePlanScalarRelationFilter = {
  AND?: Maybe<Array<CarePlanWhereInput>>;
  NOT?: Maybe<Array<CarePlanWhereInput>>;
  OR?: Maybe<Array<CarePlanWhereInput>>;
  allowSelfRenewal?: Maybe<BoolFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  defaultRenewalSuccessorPlanId?: Maybe<StringNullableFilter>;
  description?: Maybe<StringFilter>;
  earliestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  editorNotes?: Maybe<StringFilter>;
  enrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentListRelationFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isAcceptingPreEnrollments?: Maybe<BoolFilter>;
  latestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  marketingInformation?: Maybe<JsonNullableFilter>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  planBenefits?: Maybe<CarePlanBenefitListRelationFilter>;
  planDiscount?: Maybe<IntNullableFilter>;
  planPricings?: Maybe<CarePlanPricingListRelationFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  publishEndDate?: Maybe<DateTimeNullableFilter>;
  publishStartDate?: Maybe<DateTimeNullableFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  renewalPredecessorPlan?: Maybe<CarePlanListRelationFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  signupFeePricing?: Maybe<IntNullableFilter>;
  signupFeeStripeProductId?: Maybe<StringNullableFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  targetSpecies?: Maybe<EnumSpeciesTypeNullableFilter>;
  themeColor?: Maybe<StringNullableFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanScalarWhereInput = {
  AND?: Maybe<Array<CarePlanScalarWhereInput>>;
  NOT?: Maybe<Array<CarePlanScalarWhereInput>>;
  OR?: Maybe<Array<CarePlanScalarWhereInput>>;
  allowSelfRenewal?: Maybe<BoolFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultRenewalSuccessorPlanId?: Maybe<StringNullableFilter>;
  description?: Maybe<StringFilter>;
  earliestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  editorNotes?: Maybe<StringFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isAcceptingPreEnrollments?: Maybe<BoolFilter>;
  latestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  marketingInformation?: Maybe<JsonNullableFilter>;
  organizationId?: Maybe<StringFilter>;
  planDiscount?: Maybe<IntNullableFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  publishEndDate?: Maybe<DateTimeNullableFilter>;
  publishStartDate?: Maybe<DateTimeNullableFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  signupFeePricing?: Maybe<IntNullableFilter>;
  signupFeeStripeProductId?: Maybe<StringNullableFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  targetSpecies?: Maybe<EnumSpeciesTypeNullableFilter>;
  themeColor?: Maybe<StringNullableFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CarePlanScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CarePlanScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CarePlanScalarWhereWithAggregatesInput>>;
  allowSelfRenewal?: Maybe<BoolWithAggregatesFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableWithAggregatesFilter>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  defaultRenewalSuccessorPlanId?: Maybe<StringNullableWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  earliestTargetPetAgeInMonths?: Maybe<IntNullableWithAggregatesFilter>;
  editorNotes?: Maybe<StringWithAggregatesFilter>;
  flowAlias?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isAcceptingPreEnrollments?: Maybe<BoolWithAggregatesFilter>;
  latestTargetPetAgeInMonths?: Maybe<IntNullableWithAggregatesFilter>;
  marketingInformation?: Maybe<JsonNullableWithAggregatesFilter>;
  organizationId?: Maybe<StringWithAggregatesFilter>;
  planDiscount?: Maybe<IntNullableWithAggregatesFilter>;
  pricePerRenewal?: Maybe<IntWithAggregatesFilter>;
  projectedSavings?: Maybe<StringNullableWithAggregatesFilter>;
  publishEndDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  publishStartDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  published?: Maybe<BoolWithAggregatesFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeWithAggregatesFilter>;
  salesTaxCentsPerMonth?: Maybe<IntWithAggregatesFilter>;
  signupFeePricing?: Maybe<IntNullableWithAggregatesFilter>;
  signupFeeStripeProductId?: Maybe<StringNullableWithAggregatesFilter>;
  stripePriceId?: Maybe<StringNullableWithAggregatesFilter>;
  targetSpecies?: Maybe<EnumSpeciesTypeNullableWithAggregatesFilter>;
  themeColor?: Maybe<StringNullableWithAggregatesFilter>;
  title?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CarePlanSumAggregateOutputType = {
  __typename?: 'CarePlanSumAggregateOutputType';
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
};

export type CarePlanSumOrderByAggregateInput = {
  earliestTargetPetAgeInMonths?: Maybe<SortOrder>;
  latestTargetPetAgeInMonths?: Maybe<SortOrder>;
  planDiscount?: Maybe<SortOrder>;
  pricePerRenewal?: Maybe<SortOrder>;
  salesTaxCentsPerMonth?: Maybe<SortOrder>;
  signupFeePricing?: Maybe<SortOrder>;
};

export type CarePlanUncheckedCreateInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput = {
  connect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CarePlanCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CarePlanCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
};

export type CarePlanUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput = {
  connect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanCreateOrConnectWithoutDefaultRenewalSuccessorPlanInput>>;
  create?: Maybe<Array<CarePlanCreateWithoutDefaultRenewalSuccessorPlanInput>>;
  createMany?: Maybe<CarePlanCreateManyDefaultRenewalSuccessorPlanInputEnvelope>;
};

export type CarePlanUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CarePlanCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CarePlanCreateManyOrganizationInputEnvelope>;
};

export type CarePlanUncheckedCreateWithoutAssociatedCarePlanProviderGroupInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedCreateWithoutCurrentPlanEnrollmentSupportEventsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedCreateWithoutDefaultRenewalSuccessorPlanInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanInput>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedCreateWithoutEnrollmentsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedCreateWithoutExplicitRenewalSuccessorsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedCreateWithoutNewPlanEnrollmentSupportEventsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedCreateWithoutOrganizationInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanInput>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedCreateWithoutPlanBenefitsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanInput>;
  organizationId: Scalars['String'];
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedCreateWithoutPlanPricingsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedCreateWithoutRenewalPredecessorPlanInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutRenewalEmailSelectedTargetPlanInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedCreateWithoutSelectedByRenewalEmailEnrollmentsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutPlanInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutExplicitRenewalSucccesorPlanInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanInput>;
  organizationId: Scalars['String'];
  planBenefits?: Maybe<CarePlanBenefitUncheckedCreateNestedManyWithoutPlanInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedCreateNestedManyWithoutPlanInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedCreateNestedManyWithoutDefaultRenewalSuccessorPlanInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateManyInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  organizationId?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  organizationId?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput = {
  connect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CarePlanCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CarePlanCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
  delete?: Maybe<Array<CarePlanWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanUpdateWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
  updateMany?: Maybe<Array<CarePlanUpdateManyWithWhereWithoutAssociatedCarePlanProviderGroupInput>>;
  upsert?: Maybe<Array<CarePlanUpsertWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
};

export type CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  organizationId?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput = {
  connect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanCreateOrConnectWithoutDefaultRenewalSuccessorPlanInput>>;
  create?: Maybe<Array<CarePlanCreateWithoutDefaultRenewalSuccessorPlanInput>>;
  createMany?: Maybe<CarePlanCreateManyDefaultRenewalSuccessorPlanInputEnvelope>;
  delete?: Maybe<Array<CarePlanWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanUpdateWithWhereUniqueWithoutDefaultRenewalSuccessorPlanInput>>;
  updateMany?: Maybe<Array<CarePlanUpdateManyWithWhereWithoutDefaultRenewalSuccessorPlanInput>>;
  upsert?: Maybe<Array<CarePlanUpsertWithWhereUniqueWithoutDefaultRenewalSuccessorPlanInput>>;
};

export type CarePlanUncheckedUpdateManyWithoutOrganizationInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CarePlanCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CarePlanCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<CarePlanWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<CarePlanUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<CarePlanUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type CarePlanUncheckedUpdateWithoutAssociatedCarePlanProviderGroupInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateWithoutCurrentPlanEnrollmentSupportEventsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateWithoutDefaultRenewalSuccessorPlanInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateWithoutEnrollmentsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateWithoutExplicitRenewalSuccessorsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateWithoutNewPlanEnrollmentSupportEventsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateWithoutOrganizationInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateWithoutPlanBenefitsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateWithoutPlanPricingsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateWithoutRenewalPredecessorPlanInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUncheckedUpdateWithoutSelectedByRenewalEmailEnrollmentsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanNestedInput>;
  organizationId?: Maybe<Scalars['String']>;
  planBenefits?: Maybe<CarePlanBenefitUncheckedUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUncheckedUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUncheckedUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedPlansNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanUpdateOneWithoutRenewalPredecessorPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanNestedInput>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCarePlansNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateManyMutationInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateManyWithWhereWithoutAssociatedCarePlanProviderGroupInput = {
  data: CarePlanUpdateManyMutationInput;
  where: CarePlanScalarWhereInput;
};

export type CarePlanUpdateManyWithWhereWithoutDefaultRenewalSuccessorPlanInput = {
  data: CarePlanUpdateManyMutationInput;
  where: CarePlanScalarWhereInput;
};

export type CarePlanUpdateManyWithWhereWithoutOrganizationInput = {
  data: CarePlanUpdateManyMutationInput;
  where: CarePlanScalarWhereInput;
};

export type CarePlanUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput = {
  connect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CarePlanCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CarePlanCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
  delete?: Maybe<Array<CarePlanWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanUpdateWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
  updateMany?: Maybe<Array<CarePlanUpdateManyWithWhereWithoutAssociatedCarePlanProviderGroupInput>>;
  upsert?: Maybe<Array<CarePlanUpsertWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
};

export type CarePlanUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput = {
  connect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanCreateOrConnectWithoutDefaultRenewalSuccessorPlanInput>>;
  create?: Maybe<Array<CarePlanCreateWithoutDefaultRenewalSuccessorPlanInput>>;
  createMany?: Maybe<CarePlanCreateManyDefaultRenewalSuccessorPlanInputEnvelope>;
  delete?: Maybe<Array<CarePlanWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanUpdateWithWhereUniqueWithoutDefaultRenewalSuccessorPlanInput>>;
  updateMany?: Maybe<Array<CarePlanUpdateManyWithWhereWithoutDefaultRenewalSuccessorPlanInput>>;
  upsert?: Maybe<Array<CarePlanUpsertWithWhereUniqueWithoutDefaultRenewalSuccessorPlanInput>>;
};

export type CarePlanUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CarePlanCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<CarePlanCreateWithoutOrganizationInput>>;
  createMany?: Maybe<CarePlanCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<CarePlanWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CarePlanScalarWhereInput>>;
  disconnect?: Maybe<Array<CarePlanWhereUniqueInput>>;
  set?: Maybe<Array<CarePlanWhereUniqueInput>>;
  update?: Maybe<Array<CarePlanUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<CarePlanUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<CarePlanUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type CarePlanUpdateOneRequiredWithoutEnrollmentsNestedInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutEnrollmentsInput>;
  create?: Maybe<CarePlanCreateWithoutEnrollmentsInput>;
  update?: Maybe<CarePlanUpdateToOneWithWhereWithoutEnrollmentsInput>;
  upsert?: Maybe<CarePlanUpsertWithoutEnrollmentsInput>;
};

export type CarePlanUpdateOneRequiredWithoutPlanBenefitsNestedInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutPlanBenefitsInput>;
  create?: Maybe<CarePlanCreateWithoutPlanBenefitsInput>;
  update?: Maybe<CarePlanUpdateToOneWithWhereWithoutPlanBenefitsInput>;
  upsert?: Maybe<CarePlanUpsertWithoutPlanBenefitsInput>;
};

export type CarePlanUpdateOneRequiredWithoutPlanPricingsNestedInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutPlanPricingsInput>;
  create?: Maybe<CarePlanCreateWithoutPlanPricingsInput>;
  update?: Maybe<CarePlanUpdateToOneWithWhereWithoutPlanPricingsInput>;
  upsert?: Maybe<CarePlanUpsertWithoutPlanPricingsInput>;
};

export type CarePlanUpdateOneWithoutCurrentPlanEnrollmentSupportEventsNestedInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutCurrentPlanEnrollmentSupportEventsInput>;
  create?: Maybe<CarePlanCreateWithoutCurrentPlanEnrollmentSupportEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanUpdateToOneWithWhereWithoutCurrentPlanEnrollmentSupportEventsInput>;
  upsert?: Maybe<CarePlanUpsertWithoutCurrentPlanEnrollmentSupportEventsInput>;
};

export type CarePlanUpdateOneWithoutExplicitRenewalSuccessorsNestedInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutExplicitRenewalSuccessorsInput>;
  create?: Maybe<CarePlanCreateWithoutExplicitRenewalSuccessorsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanUpdateToOneWithWhereWithoutExplicitRenewalSuccessorsInput>;
  upsert?: Maybe<CarePlanUpsertWithoutExplicitRenewalSuccessorsInput>;
};

export type CarePlanUpdateOneWithoutNewPlanEnrollmentSupportEventsNestedInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutNewPlanEnrollmentSupportEventsInput>;
  create?: Maybe<CarePlanCreateWithoutNewPlanEnrollmentSupportEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanUpdateToOneWithWhereWithoutNewPlanEnrollmentSupportEventsInput>;
  upsert?: Maybe<CarePlanUpsertWithoutNewPlanEnrollmentSupportEventsInput>;
};

export type CarePlanUpdateOneWithoutRenewalPredecessorPlanNestedInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutRenewalPredecessorPlanInput>;
  create?: Maybe<CarePlanCreateWithoutRenewalPredecessorPlanInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanUpdateToOneWithWhereWithoutRenewalPredecessorPlanInput>;
  upsert?: Maybe<CarePlanUpsertWithoutRenewalPredecessorPlanInput>;
};

export type CarePlanUpdateOneWithoutSelectedByRenewalEmailEnrollmentsNestedInput = {
  connect?: Maybe<CarePlanWhereUniqueInput>;
  connectOrCreate?: Maybe<CarePlanCreateOrConnectWithoutSelectedByRenewalEmailEnrollmentsInput>;
  create?: Maybe<CarePlanCreateWithoutSelectedByRenewalEmailEnrollmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CarePlanUpdateToOneWithWhereWithoutSelectedByRenewalEmailEnrollmentsInput>;
  upsert?: Maybe<CarePlanUpsertWithoutSelectedByRenewalEmailEnrollmentsInput>;
};

export type CarePlanUpdateToOneWithWhereWithoutCurrentPlanEnrollmentSupportEventsInput = {
  data: CarePlanUpdateWithoutCurrentPlanEnrollmentSupportEventsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpdateToOneWithWhereWithoutEnrollmentsInput = {
  data: CarePlanUpdateWithoutEnrollmentsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpdateToOneWithWhereWithoutExplicitRenewalSuccessorsInput = {
  data: CarePlanUpdateWithoutExplicitRenewalSuccessorsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpdateToOneWithWhereWithoutNewPlanEnrollmentSupportEventsInput = {
  data: CarePlanUpdateWithoutNewPlanEnrollmentSupportEventsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpdateToOneWithWhereWithoutPlanBenefitsInput = {
  data: CarePlanUpdateWithoutPlanBenefitsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpdateToOneWithWhereWithoutPlanPricingsInput = {
  data: CarePlanUpdateWithoutPlanPricingsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpdateToOneWithWhereWithoutRenewalPredecessorPlanInput = {
  data: CarePlanUpdateWithoutRenewalPredecessorPlanInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpdateToOneWithWhereWithoutSelectedByRenewalEmailEnrollmentsInput = {
  data: CarePlanUpdateWithoutSelectedByRenewalEmailEnrollmentsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpdateWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput = {
  data: CarePlanUpdateWithoutAssociatedCarePlanProviderGroupInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanUpdateWithWhereUniqueWithoutDefaultRenewalSuccessorPlanInput = {
  data: CarePlanUpdateWithoutDefaultRenewalSuccessorPlanInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: CarePlanUpdateWithoutOrganizationInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanUpdateWithoutAssociatedCarePlanProviderGroupInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanUpdateOneWithoutRenewalPredecessorPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanNestedInput>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCarePlansNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateWithoutCurrentPlanEnrollmentSupportEventsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedPlansNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanUpdateOneWithoutRenewalPredecessorPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanNestedInput>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCarePlansNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateWithoutDefaultRenewalSuccessorPlanInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedPlansNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanNestedInput>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCarePlansNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateWithoutEnrollmentsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedPlansNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanUpdateOneWithoutRenewalPredecessorPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanNestedInput>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCarePlansNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateWithoutExplicitRenewalSuccessorsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedPlansNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanUpdateOneWithoutRenewalPredecessorPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanNestedInput>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCarePlansNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateWithoutNewPlanEnrollmentSupportEventsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedPlansNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanUpdateOneWithoutRenewalPredecessorPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCarePlansNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateWithoutOrganizationInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedPlansNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanUpdateOneWithoutRenewalPredecessorPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateWithoutPlanBenefitsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedPlansNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanUpdateOneWithoutRenewalPredecessorPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanNestedInput>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCarePlansNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateWithoutPlanPricingsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedPlansNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanUpdateOneWithoutRenewalPredecessorPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanNestedInput>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCarePlansNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateWithoutRenewalPredecessorPlanInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedPlansNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanUpdateOneWithoutRenewalPredecessorPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanNestedInput>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCarePlansNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutRenewalEmailSelectedTargetPlanNestedInput>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpdateWithoutSelectedByRenewalEmailEnrollmentsInput = {
  allowSelfRenewal?: Maybe<Scalars['Boolean']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedPlansNestedInput>;
  billingCycle?: Maybe<CarePlanCycleType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutCurrentPlanNestedInput>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanUpdateOneWithoutRenewalPredecessorPlanNestedInput>;
  description?: Maybe<Scalars['String']>;
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes?: Maybe<Scalars['String']>;
  enrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutPlanNestedInput>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentUpdateManyWithoutExplicitRenewalSucccesorPlanNestedInput>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<Scalars['Boolean']>;
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutNewPlanNestedInput>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutCarePlansNestedInput>;
  planBenefits?: Maybe<CarePlanBenefitUpdateManyWithoutPlanNestedInput>;
  planDiscount?: Maybe<Scalars['Int']>;
  planPricings?: Maybe<CarePlanPricingUpdateManyWithoutPlanNestedInput>;
  pricePerRenewal?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  renewalCycle?: Maybe<CarePlanCycleType>;
  renewalPredecessorPlan?: Maybe<CarePlanUpdateManyWithoutDefaultRenewalSuccessorPlanNestedInput>;
  salesTaxCentsPerMonth?: Maybe<Scalars['Int']>;
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarePlanUpsertWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput = {
  create: CarePlanCreateWithoutAssociatedCarePlanProviderGroupInput;
  update: CarePlanUpdateWithoutAssociatedCarePlanProviderGroupInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanUpsertWithWhereUniqueWithoutDefaultRenewalSuccessorPlanInput = {
  create: CarePlanCreateWithoutDefaultRenewalSuccessorPlanInput;
  update: CarePlanUpdateWithoutDefaultRenewalSuccessorPlanInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: CarePlanCreateWithoutOrganizationInput;
  update: CarePlanUpdateWithoutOrganizationInput;
  where: CarePlanWhereUniqueInput;
};

export type CarePlanUpsertWithoutCurrentPlanEnrollmentSupportEventsInput = {
  create: CarePlanCreateWithoutCurrentPlanEnrollmentSupportEventsInput;
  update: CarePlanUpdateWithoutCurrentPlanEnrollmentSupportEventsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpsertWithoutEnrollmentsInput = {
  create: CarePlanCreateWithoutEnrollmentsInput;
  update: CarePlanUpdateWithoutEnrollmentsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpsertWithoutExplicitRenewalSuccessorsInput = {
  create: CarePlanCreateWithoutExplicitRenewalSuccessorsInput;
  update: CarePlanUpdateWithoutExplicitRenewalSuccessorsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpsertWithoutNewPlanEnrollmentSupportEventsInput = {
  create: CarePlanCreateWithoutNewPlanEnrollmentSupportEventsInput;
  update: CarePlanUpdateWithoutNewPlanEnrollmentSupportEventsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpsertWithoutPlanBenefitsInput = {
  create: CarePlanCreateWithoutPlanBenefitsInput;
  update: CarePlanUpdateWithoutPlanBenefitsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpsertWithoutPlanPricingsInput = {
  create: CarePlanCreateWithoutPlanPricingsInput;
  update: CarePlanUpdateWithoutPlanPricingsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpsertWithoutRenewalPredecessorPlanInput = {
  create: CarePlanCreateWithoutRenewalPredecessorPlanInput;
  update: CarePlanUpdateWithoutRenewalPredecessorPlanInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanUpsertWithoutSelectedByRenewalEmailEnrollmentsInput = {
  create: CarePlanCreateWithoutSelectedByRenewalEmailEnrollmentsInput;
  update: CarePlanUpdateWithoutSelectedByRenewalEmailEnrollmentsInput;
  where?: Maybe<CarePlanWhereInput>;
};

export type CarePlanWhereInput = {
  AND?: Maybe<Array<CarePlanWhereInput>>;
  NOT?: Maybe<Array<CarePlanWhereInput>>;
  OR?: Maybe<Array<CarePlanWhereInput>>;
  allowSelfRenewal?: Maybe<BoolFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  defaultRenewalSuccessorPlanId?: Maybe<StringNullableFilter>;
  description?: Maybe<StringFilter>;
  earliestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  editorNotes?: Maybe<StringFilter>;
  enrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentListRelationFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isAcceptingPreEnrollments?: Maybe<BoolFilter>;
  latestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  marketingInformation?: Maybe<JsonNullableFilter>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  planBenefits?: Maybe<CarePlanBenefitListRelationFilter>;
  planDiscount?: Maybe<IntNullableFilter>;
  planPricings?: Maybe<CarePlanPricingListRelationFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  publishEndDate?: Maybe<DateTimeNullableFilter>;
  publishStartDate?: Maybe<DateTimeNullableFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  renewalPredecessorPlan?: Maybe<CarePlanListRelationFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  signupFeePricing?: Maybe<IntNullableFilter>;
  signupFeeStripeProductId?: Maybe<StringNullableFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  targetSpecies?: Maybe<EnumSpeciesTypeNullableFilter>;
  themeColor?: Maybe<StringNullableFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CarePlanWhereUniqueInput = {
  AND?: Maybe<Array<CarePlanWhereInput>>;
  NOT?: Maybe<Array<CarePlanWhereInput>>;
  OR?: Maybe<Array<CarePlanWhereInput>>;
  allowSelfRenewal?: Maybe<BoolFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  billingCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  defaultRenewalSuccessorPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  defaultRenewalSuccessorPlanId?: Maybe<StringNullableFilter>;
  description?: Maybe<StringFilter>;
  earliestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  editorNotes?: Maybe<StringFilter>;
  enrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  explicitRenewalSuccessors?: Maybe<CarePlanEnrollmentListRelationFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isAcceptingPreEnrollments?: Maybe<BoolFilter>;
  latestTargetPetAgeInMonths?: Maybe<IntNullableFilter>;
  marketingInformation?: Maybe<JsonNullableFilter>;
  newPlanEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  planBenefits?: Maybe<CarePlanBenefitListRelationFilter>;
  planDiscount?: Maybe<IntNullableFilter>;
  planPricings?: Maybe<CarePlanPricingListRelationFilter>;
  pricePerRenewal?: Maybe<IntFilter>;
  projectedSavings?: Maybe<StringNullableFilter>;
  publishEndDate?: Maybe<DateTimeNullableFilter>;
  publishStartDate?: Maybe<DateTimeNullableFilter>;
  published?: Maybe<BoolFilter>;
  renewalCycle?: Maybe<EnumCarePlanCycleTypeFilter>;
  renewalPredecessorPlan?: Maybe<CarePlanListRelationFilter>;
  salesTaxCentsPerMonth?: Maybe<IntFilter>;
  selectedByRenewalEmailEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  signupFeePricing?: Maybe<IntNullableFilter>;
  signupFeeStripeProductId?: Maybe<StringNullableFilter>;
  stripePriceId?: Maybe<StringNullableFilter>;
  targetSpecies?: Maybe<EnumSpeciesTypeNullableFilter>;
  themeColor?: Maybe<StringNullableFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum CareProgramLaunchStatus {
  Archived = 'Archived',
  Churning = 'Churning',
  Draft = 'Draft',
  Live = 'Live',
  Prelaunch = 'Prelaunch'
}

export type CareStripeSubscription = {
  __typename?: 'CareStripeSubscription';
  _count: CareStripeSubscriptionCountOutputType;
  activeSubscriber?: Maybe<OrganizationPetParent>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPet?: Maybe<OrganizationPet>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments: Array<CareAddonEnrollment>;
  careBenefitUsageFollowups: Array<CareBenefitUsageFollowup>;
  carePlanEnrollments: Array<CarePlanEnrollment>;
  careSubscriptionTrueUps: Array<CareSubscriptionTrueUp>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  invoices: Array<StripeInvoice>;
  isTestSubscription: Scalars['Boolean'];
  nextBillingDate: Scalars['DateTime'];
  /** If this subscription originated somewhere else, this allows us to track it */
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwner: OrganizationPetParent;
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type CareStripeSubscriptionActiveSubscriberArgs = {
  where?: Maybe<OrganizationPetParentWhereInput>;
};


export type CareStripeSubscriptionAssociatedCarePlanProviderGroupArgs = {
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type CareStripeSubscriptionAssociatedPetArgs = {
  where?: Maybe<OrganizationPetWhereInput>;
};


export type CareStripeSubscriptionCareAddonEnrollmentsArgs = {
  cursor?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};


export type CareStripeSubscriptionCareBenefitUsageFollowupsArgs = {
  cursor?: Maybe<CareBenefitUsageFollowupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageFollowupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageFollowupOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageFollowupWhereInput>;
};


export type CareStripeSubscriptionCarePlanEnrollmentsArgs = {
  cursor?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type CareStripeSubscriptionCareSubscriptionTrueUpsArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareSubscriptionTrueUpScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
};


export type CareStripeSubscriptionInvoicesArgs = {
  cursor?: Maybe<StripeInvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeInvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeInvoiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type CareStripeSubscriptionStripePaymentMethodArgs = {
  where?: Maybe<StripePaymentMethodWhereInput>;
};

export type CareStripeSubscriptionAvgAggregateOutputType = {
  __typename?: 'CareStripeSubscriptionAvgAggregateOutputType';
  upcomingTotalPrice?: Maybe<Scalars['Float']>;
};

export type CareStripeSubscriptionAvgOrderByAggregateInput = {
  upcomingTotalPrice?: Maybe<SortOrder>;
};

export type CareStripeSubscriptionCountAggregateOutputType = {
  __typename?: 'CareStripeSubscriptionCountAggregateOutputType';
  _all: Scalars['Int'];
  associatedCarePlanProviderGroupId: Scalars['Int'];
  associatedPetId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isTestSubscription: Scalars['Int'];
  nextBillingDate: Scalars['Int'];
  parentCareStripeSubscriptionId: Scalars['Int'];
  paymentStatus: Scalars['Int'];
  stripeCustomerId: Scalars['Int'];
  stripePaymentMethodId: Scalars['Int'];
  stripeSubscriptionId: Scalars['Int'];
  subscriptionOwnerId: Scalars['Int'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CareStripeSubscriptionCountOrderByAggregateInput = {
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  associatedPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isTestSubscription?: Maybe<SortOrder>;
  nextBillingDate?: Maybe<SortOrder>;
  parentCareStripeSubscriptionId?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  subscriptionOwnerId?: Maybe<SortOrder>;
  upcomingTotalPrice?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareStripeSubscriptionCountOutputType = {
  __typename?: 'CareStripeSubscriptionCountOutputType';
  careAddonEnrollments: Scalars['Int'];
  careBenefitUsageFollowups: Scalars['Int'];
  carePlanEnrollments: Scalars['Int'];
  careSubscriptionTrueUps: Scalars['Int'];
  invoices: Scalars['Int'];
};

export type CareStripeSubscriptionCreateInput = {
  activeSubscriber?: Maybe<OrganizationPetParentCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  associatedPet?: Maybe<OrganizationPetCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareStripeSubscriptionsInput>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwner: OrganizationPetParentCreateNestedOneWithoutAllCareStripeSubscriptionsInput;
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateManyAssociatedCarePlanProviderGroupInput = {
  associatedPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateManyAssociatedCarePlanProviderGroupInputEnvelope = {
  data: Array<CareStripeSubscriptionCreateManyAssociatedCarePlanProviderGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareStripeSubscriptionCreateManyAssociatedPetInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateManyAssociatedPetInputEnvelope = {
  data: Array<CareStripeSubscriptionCreateManyAssociatedPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareStripeSubscriptionCreateManyInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateManyStripePaymentMethodInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateManyStripePaymentMethodInputEnvelope = {
  data: Array<CareStripeSubscriptionCreateManyStripePaymentMethodInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareStripeSubscriptionCreateManySubscriptionOwnerInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateManySubscriptionOwnerInputEnvelope = {
  data: Array<CareStripeSubscriptionCreateManySubscriptionOwnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareStripeSubscriptionCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
};

export type CareStripeSubscriptionCreateNestedManyWithoutAssociatedPetInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutAssociatedPetInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutAssociatedPetInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManyAssociatedPetInputEnvelope>;
};

export type CareStripeSubscriptionCreateNestedManyWithoutStripePaymentMethodInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManyStripePaymentMethodInputEnvelope>;
};

export type CareStripeSubscriptionCreateNestedManyWithoutSubscriptionOwnerInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutSubscriptionOwnerInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutSubscriptionOwnerInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManySubscriptionOwnerInputEnvelope>;
};

export type CareStripeSubscriptionCreateNestedOneWithoutActiveSubscriberInput = {
  connect?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<CareStripeSubscriptionCreateOrConnectWithoutActiveSubscriberInput>;
  create?: Maybe<CareStripeSubscriptionCreateWithoutActiveSubscriberInput>;
};

export type CareStripeSubscriptionCreateNestedOneWithoutCareAddonEnrollmentsInput = {
  connect?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<CareStripeSubscriptionCreateOrConnectWithoutCareAddonEnrollmentsInput>;
  create?: Maybe<CareStripeSubscriptionCreateWithoutCareAddonEnrollmentsInput>;
};

export type CareStripeSubscriptionCreateNestedOneWithoutCareBenefitUsageFollowupsInput = {
  connect?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<CareStripeSubscriptionCreateOrConnectWithoutCareBenefitUsageFollowupsInput>;
  create?: Maybe<CareStripeSubscriptionCreateWithoutCareBenefitUsageFollowupsInput>;
};

export type CareStripeSubscriptionCreateNestedOneWithoutCarePlanEnrollmentsInput = {
  connect?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<CareStripeSubscriptionCreateOrConnectWithoutCarePlanEnrollmentsInput>;
  create?: Maybe<CareStripeSubscriptionCreateWithoutCarePlanEnrollmentsInput>;
};

export type CareStripeSubscriptionCreateNestedOneWithoutCareSubscriptionTrueUpsInput = {
  connect?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<CareStripeSubscriptionCreateOrConnectWithoutCareSubscriptionTrueUpsInput>;
  create?: Maybe<CareStripeSubscriptionCreateWithoutCareSubscriptionTrueUpsInput>;
};

export type CareStripeSubscriptionCreateNestedOneWithoutInvoicesInput = {
  connect?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<CareStripeSubscriptionCreateOrConnectWithoutInvoicesInput>;
  create?: Maybe<CareStripeSubscriptionCreateWithoutInvoicesInput>;
};

export type CareStripeSubscriptionCreateOrConnectWithoutActiveSubscriberInput = {
  create: CareStripeSubscriptionCreateWithoutActiveSubscriberInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput = {
  create: CareStripeSubscriptionCreateWithoutAssociatedCarePlanProviderGroupInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionCreateOrConnectWithoutAssociatedPetInput = {
  create: CareStripeSubscriptionCreateWithoutAssociatedPetInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionCreateOrConnectWithoutCareAddonEnrollmentsInput = {
  create: CareStripeSubscriptionCreateWithoutCareAddonEnrollmentsInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionCreateOrConnectWithoutCareBenefitUsageFollowupsInput = {
  create: CareStripeSubscriptionCreateWithoutCareBenefitUsageFollowupsInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionCreateOrConnectWithoutCarePlanEnrollmentsInput = {
  create: CareStripeSubscriptionCreateWithoutCarePlanEnrollmentsInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionCreateOrConnectWithoutCareSubscriptionTrueUpsInput = {
  create: CareStripeSubscriptionCreateWithoutCareSubscriptionTrueUpsInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionCreateOrConnectWithoutInvoicesInput = {
  create: CareStripeSubscriptionCreateWithoutInvoicesInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionCreateOrConnectWithoutStripePaymentMethodInput = {
  create: CareStripeSubscriptionCreateWithoutStripePaymentMethodInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionCreateOrConnectWithoutSubscriptionOwnerInput = {
  create: CareStripeSubscriptionCreateWithoutSubscriptionOwnerInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionCreateWithoutActiveSubscriberInput = {
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  associatedPet?: Maybe<OrganizationPetCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareStripeSubscriptionsInput>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwner: OrganizationPetParentCreateNestedOneWithoutAllCareStripeSubscriptionsInput;
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateWithoutAssociatedCarePlanProviderGroupInput = {
  activeSubscriber?: Maybe<OrganizationPetParentCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedPet?: Maybe<OrganizationPetCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareStripeSubscriptionsInput>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwner: OrganizationPetParentCreateNestedOneWithoutAllCareStripeSubscriptionsInput;
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateWithoutAssociatedPetInput = {
  activeSubscriber?: Maybe<OrganizationPetParentCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareStripeSubscriptionsInput>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwner: OrganizationPetParentCreateNestedOneWithoutAllCareStripeSubscriptionsInput;
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateWithoutCareAddonEnrollmentsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  associatedPet?: Maybe<OrganizationPetCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareStripeSubscriptionsInput>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwner: OrganizationPetParentCreateNestedOneWithoutAllCareStripeSubscriptionsInput;
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateWithoutCareBenefitUsageFollowupsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  associatedPet?: Maybe<OrganizationPetCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareStripeSubscriptionsInput>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwner: OrganizationPetParentCreateNestedOneWithoutAllCareStripeSubscriptionsInput;
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateWithoutCarePlanEnrollmentsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  associatedPet?: Maybe<OrganizationPetCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareStripeSubscriptionsInput>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwner: OrganizationPetParentCreateNestedOneWithoutAllCareStripeSubscriptionsInput;
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateWithoutCareSubscriptionTrueUpsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  associatedPet?: Maybe<OrganizationPetCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareStripeSubscriptionsInput>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwner: OrganizationPetParentCreateNestedOneWithoutAllCareStripeSubscriptionsInput;
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateWithoutInvoicesInput = {
  activeSubscriber?: Maybe<OrganizationPetParentCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  associatedPet?: Maybe<OrganizationPetCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareStripeSubscriptionsInput>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwner: OrganizationPetParentCreateNestedOneWithoutAllCareStripeSubscriptionsInput;
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateWithoutStripePaymentMethodInput = {
  activeSubscriber?: Maybe<OrganizationPetParentCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  associatedPet?: Maybe<OrganizationPetCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwner: OrganizationPetParentCreateNestedOneWithoutAllCareStripeSubscriptionsInput;
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionCreateWithoutSubscriptionOwnerInput = {
  activeSubscriber?: Maybe<OrganizationPetParentCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  associatedPet?: Maybe<OrganizationPetCreateNestedOneWithoutAssociatedSubscriptionsInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareStripeSubscriptionsInput>;
  stripeSubscriptionId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionGroupByOutputType = {
  __typename?: 'CareStripeSubscriptionGroupByOutputType';
  _avg?: Maybe<CareStripeSubscriptionAvgAggregateOutputType>;
  _count?: Maybe<CareStripeSubscriptionCountAggregateOutputType>;
  _max?: Maybe<CareStripeSubscriptionMaxAggregateOutputType>;
  _min?: Maybe<CareStripeSubscriptionMinAggregateOutputType>;
  _sum?: Maybe<CareStripeSubscriptionSumAggregateOutputType>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isTestSubscription: Scalars['Boolean'];
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CareStripeSubscriptionListRelationFilter = {
  every?: Maybe<CareStripeSubscriptionWhereInput>;
  none?: Maybe<CareStripeSubscriptionWhereInput>;
  some?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionMaxAggregateOutputType = {
  __typename?: 'CareStripeSubscriptionMaxAggregateOutputType';
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionMaxOrderByAggregateInput = {
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  associatedPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isTestSubscription?: Maybe<SortOrder>;
  nextBillingDate?: Maybe<SortOrder>;
  parentCareStripeSubscriptionId?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  subscriptionOwnerId?: Maybe<SortOrder>;
  upcomingTotalPrice?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareStripeSubscriptionMinAggregateOutputType = {
  __typename?: 'CareStripeSubscriptionMinAggregateOutputType';
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionMinOrderByAggregateInput = {
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  associatedPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isTestSubscription?: Maybe<SortOrder>;
  nextBillingDate?: Maybe<SortOrder>;
  parentCareStripeSubscriptionId?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  subscriptionOwnerId?: Maybe<SortOrder>;
  upcomingTotalPrice?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareStripeSubscriptionNullableScalarRelationFilter = {
  AND?: Maybe<Array<CareStripeSubscriptionWhereInput>>;
  NOT?: Maybe<Array<CareStripeSubscriptionWhereInput>>;
  OR?: Maybe<Array<CareStripeSubscriptionWhereInput>>;
  activeSubscriber?: Maybe<OrganizationPetParentNullableScalarRelationFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  associatedPet?: Maybe<OrganizationPetNullableScalarRelationFilter>;
  associatedPetId?: Maybe<StringNullableFilter>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentListRelationFilter>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupListRelationFilter>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  invoices?: Maybe<StripeInvoiceListRelationFilter>;
  isTestSubscription?: Maybe<BoolFilter>;
  nextBillingDate?: Maybe<DateTimeFilter>;
  parentCareStripeSubscriptionId?: Maybe<StringNullableFilter>;
  paymentStatus?: Maybe<EnumCareSubscriptionPaymentStatusNullableFilter>;
  stripeCustomerId?: Maybe<StringFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  stripeSubscriptionId?: Maybe<StringFilter>;
  subscriptionOwner?: Maybe<OrganizationPetParentScalarRelationFilter>;
  subscriptionOwnerId?: Maybe<StringFilter>;
  upcomingTotalPrice?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareStripeSubscriptionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareStripeSubscriptionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareStripeSubscriptionOrderByRelevanceInput>;
  activeSubscriber?: Maybe<OrganizationPetParentOrderByWithRelationInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  associatedPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  associatedPetId?: Maybe<SortOrder>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentOrderByRelationAggregateInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupOrderByRelationAggregateInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoices?: Maybe<StripeInvoiceOrderByRelationAggregateInput>;
  isTestSubscription?: Maybe<SortOrder>;
  nextBillingDate?: Maybe<SortOrder>;
  parentCareStripeSubscriptionId?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentMethod?: Maybe<StripePaymentMethodOrderByWithRelationInput>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  subscriptionOwner?: Maybe<OrganizationPetParentOrderByWithRelationInput>;
  subscriptionOwnerId?: Maybe<SortOrder>;
  upcomingTotalPrice?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareStripeSubscriptionOrderByRelevanceFieldEnum {
  AssociatedCarePlanProviderGroupId = 'associatedCarePlanProviderGroupId',
  AssociatedPetId = 'associatedPetId',
  Id = 'id',
  ParentCareStripeSubscriptionId = 'parentCareStripeSubscriptionId',
  StripeCustomerId = 'stripeCustomerId',
  StripePaymentMethodId = 'stripePaymentMethodId',
  StripeSubscriptionId = 'stripeSubscriptionId',
  SubscriptionOwnerId = 'subscriptionOwnerId'
}

export type CareStripeSubscriptionOrderByRelevanceInput = {
  fields: Array<CareStripeSubscriptionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareStripeSubscriptionOrderByWithAggregationInput = {
  _avg?: Maybe<CareStripeSubscriptionAvgOrderByAggregateInput>;
  _count?: Maybe<CareStripeSubscriptionCountOrderByAggregateInput>;
  _max?: Maybe<CareStripeSubscriptionMaxOrderByAggregateInput>;
  _min?: Maybe<CareStripeSubscriptionMinOrderByAggregateInput>;
  _sum?: Maybe<CareStripeSubscriptionSumOrderByAggregateInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  associatedPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isTestSubscription?: Maybe<SortOrder>;
  nextBillingDate?: Maybe<SortOrder>;
  parentCareStripeSubscriptionId?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  subscriptionOwnerId?: Maybe<SortOrder>;
  upcomingTotalPrice?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareStripeSubscriptionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareStripeSubscriptionOrderByRelevanceInput>;
  activeSubscriber?: Maybe<OrganizationPetParentOrderByWithRelationInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  associatedPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  associatedPetId?: Maybe<SortOrder>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentOrderByRelationAggregateInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupOrderByRelationAggregateInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoices?: Maybe<StripeInvoiceOrderByRelationAggregateInput>;
  isTestSubscription?: Maybe<SortOrder>;
  nextBillingDate?: Maybe<SortOrder>;
  parentCareStripeSubscriptionId?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentMethod?: Maybe<StripePaymentMethodOrderByWithRelationInput>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  subscriptionOwner?: Maybe<OrganizationPetParentOrderByWithRelationInput>;
  subscriptionOwnerId?: Maybe<SortOrder>;
  upcomingTotalPrice?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareStripeSubscriptionOrderByWithRelationInput = {
  _relevance?: Maybe<CareStripeSubscriptionOrderByRelevanceInput>;
  activeSubscriber?: Maybe<OrganizationPetParentOrderByWithRelationInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  associatedCarePlanProviderGroupId?: Maybe<SortOrder>;
  associatedPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  associatedPetId?: Maybe<SortOrder>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentOrderByRelationAggregateInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupOrderByRelationAggregateInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoices?: Maybe<StripeInvoiceOrderByRelationAggregateInput>;
  isTestSubscription?: Maybe<SortOrder>;
  nextBillingDate?: Maybe<SortOrder>;
  parentCareStripeSubscriptionId?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentMethod?: Maybe<StripePaymentMethodOrderByWithRelationInput>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  subscriptionOwner?: Maybe<OrganizationPetParentOrderByWithRelationInput>;
  subscriptionOwnerId?: Maybe<SortOrder>;
  upcomingTotalPrice?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareStripeSubscriptionScalarFieldEnum {
  AssociatedCarePlanProviderGroupId = 'associatedCarePlanProviderGroupId',
  AssociatedPetId = 'associatedPetId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsTestSubscription = 'isTestSubscription',
  NextBillingDate = 'nextBillingDate',
  ParentCareStripeSubscriptionId = 'parentCareStripeSubscriptionId',
  PaymentStatus = 'paymentStatus',
  StripeCustomerId = 'stripeCustomerId',
  StripePaymentMethodId = 'stripePaymentMethodId',
  StripeSubscriptionId = 'stripeSubscriptionId',
  SubscriptionOwnerId = 'subscriptionOwnerId',
  UpcomingTotalPrice = 'upcomingTotalPrice',
  UpdatedAt = 'updatedAt'
}

export type CareStripeSubscriptionScalarRelationFilter = {
  AND?: Maybe<Array<CareStripeSubscriptionWhereInput>>;
  NOT?: Maybe<Array<CareStripeSubscriptionWhereInput>>;
  OR?: Maybe<Array<CareStripeSubscriptionWhereInput>>;
  activeSubscriber?: Maybe<OrganizationPetParentNullableScalarRelationFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  associatedPet?: Maybe<OrganizationPetNullableScalarRelationFilter>;
  associatedPetId?: Maybe<StringNullableFilter>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentListRelationFilter>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupListRelationFilter>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  invoices?: Maybe<StripeInvoiceListRelationFilter>;
  isTestSubscription?: Maybe<BoolFilter>;
  nextBillingDate?: Maybe<DateTimeFilter>;
  parentCareStripeSubscriptionId?: Maybe<StringNullableFilter>;
  paymentStatus?: Maybe<EnumCareSubscriptionPaymentStatusNullableFilter>;
  stripeCustomerId?: Maybe<StringFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  stripeSubscriptionId?: Maybe<StringFilter>;
  subscriptionOwner?: Maybe<OrganizationPetParentScalarRelationFilter>;
  subscriptionOwnerId?: Maybe<StringFilter>;
  upcomingTotalPrice?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareStripeSubscriptionScalarWhereInput = {
  AND?: Maybe<Array<CareStripeSubscriptionScalarWhereInput>>;
  NOT?: Maybe<Array<CareStripeSubscriptionScalarWhereInput>>;
  OR?: Maybe<Array<CareStripeSubscriptionScalarWhereInput>>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  associatedPetId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isTestSubscription?: Maybe<BoolFilter>;
  nextBillingDate?: Maybe<DateTimeFilter>;
  parentCareStripeSubscriptionId?: Maybe<StringNullableFilter>;
  paymentStatus?: Maybe<EnumCareSubscriptionPaymentStatusNullableFilter>;
  stripeCustomerId?: Maybe<StringFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  stripeSubscriptionId?: Maybe<StringFilter>;
  subscriptionOwnerId?: Maybe<StringFilter>;
  upcomingTotalPrice?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareStripeSubscriptionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareStripeSubscriptionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareStripeSubscriptionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareStripeSubscriptionScalarWhereWithAggregatesInput>>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableWithAggregatesFilter>;
  associatedPetId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isTestSubscription?: Maybe<BoolWithAggregatesFilter>;
  nextBillingDate?: Maybe<DateTimeWithAggregatesFilter>;
  parentCareStripeSubscriptionId?: Maybe<StringNullableWithAggregatesFilter>;
  paymentStatus?: Maybe<EnumCareSubscriptionPaymentStatusNullableWithAggregatesFilter>;
  stripeCustomerId?: Maybe<StringWithAggregatesFilter>;
  stripePaymentMethodId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeSubscriptionId?: Maybe<StringWithAggregatesFilter>;
  subscriptionOwnerId?: Maybe<StringWithAggregatesFilter>;
  upcomingTotalPrice?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CareStripeSubscriptionSumAggregateOutputType = {
  __typename?: 'CareStripeSubscriptionSumAggregateOutputType';
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
};

export type CareStripeSubscriptionSumOrderByAggregateInput = {
  upcomingTotalPrice?: Maybe<SortOrder>;
};

export type CareStripeSubscriptionUncheckedCreateInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedCarePlanProviderGroupInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
};

export type CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedPetInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutAssociatedPetInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutAssociatedPetInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManyAssociatedPetInputEnvelope>;
};

export type CareStripeSubscriptionUncheckedCreateNestedManyWithoutStripePaymentMethodInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManyStripePaymentMethodInputEnvelope>;
};

export type CareStripeSubscriptionUncheckedCreateNestedManyWithoutSubscriptionOwnerInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutSubscriptionOwnerInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutSubscriptionOwnerInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManySubscriptionOwnerInputEnvelope>;
};

export type CareStripeSubscriptionUncheckedCreateWithoutActiveSubscriberInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedCreateWithoutAssociatedCarePlanProviderGroupInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedCreateWithoutAssociatedPetInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedCreateWithoutCareAddonEnrollmentsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedCreateWithoutCareBenefitUsageFollowupsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedCreateWithoutCarePlanEnrollmentsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedCreateWithoutCareSubscriptionTrueUpsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedCreateWithoutInvoicesInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedCreateWithoutStripePaymentMethodInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedCreateWithoutSubscriptionOwnerInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedCreateNestedOneWithoutActiveCareStripeSubscriptionInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateManyInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupInput = {
  associatedPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
  delete?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareStripeSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<CareStripeSubscriptionUpdateWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
  updateMany?: Maybe<Array<CareStripeSubscriptionUpdateManyWithWhereWithoutAssociatedCarePlanProviderGroupInput>>;
  upsert?: Maybe<Array<CareStripeSubscriptionUpsertWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
};

export type CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedPetInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedPetNestedInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutAssociatedPetInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutAssociatedPetInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManyAssociatedPetInputEnvelope>;
  delete?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareStripeSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<CareStripeSubscriptionUpdateWithWhereUniqueWithoutAssociatedPetInput>>;
  updateMany?: Maybe<Array<CareStripeSubscriptionUpdateManyWithWhereWithoutAssociatedPetInput>>;
  upsert?: Maybe<Array<CareStripeSubscriptionUpsertWithWhereUniqueWithoutAssociatedPetInput>>;
};

export type CareStripeSubscriptionUncheckedUpdateManyWithoutStripePaymentMethodInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateManyWithoutStripePaymentMethodNestedInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManyStripePaymentMethodInputEnvelope>;
  delete?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareStripeSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<CareStripeSubscriptionUpdateWithWhereUniqueWithoutStripePaymentMethodInput>>;
  updateMany?: Maybe<Array<CareStripeSubscriptionUpdateManyWithWhereWithoutStripePaymentMethodInput>>;
  upsert?: Maybe<Array<CareStripeSubscriptionUpsertWithWhereUniqueWithoutStripePaymentMethodInput>>;
};

export type CareStripeSubscriptionUncheckedUpdateManyWithoutSubscriptionOwnerInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateManyWithoutSubscriptionOwnerNestedInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutSubscriptionOwnerInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutSubscriptionOwnerInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManySubscriptionOwnerInputEnvelope>;
  delete?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareStripeSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<CareStripeSubscriptionUpdateWithWhereUniqueWithoutSubscriptionOwnerInput>>;
  updateMany?: Maybe<Array<CareStripeSubscriptionUpdateManyWithWhereWithoutSubscriptionOwnerInput>>;
  upsert?: Maybe<Array<CareStripeSubscriptionUpsertWithWhereUniqueWithoutSubscriptionOwnerInput>>;
};

export type CareStripeSubscriptionUncheckedUpdateWithoutActiveSubscriberInput = {
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateWithoutAssociatedCarePlanProviderGroupInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateWithoutAssociatedPetInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateWithoutCareAddonEnrollmentsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateWithoutCareBenefitUsageFollowupsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateWithoutCarePlanEnrollmentsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateWithoutCareSubscriptionTrueUpsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateWithoutInvoicesInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateWithoutStripePaymentMethodInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwnerId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUncheckedUpdateWithoutSubscriptionOwnerInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUncheckedUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPetId?: Maybe<Scalars['String']>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpdateInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  associatedPet?: Maybe<OrganizationPetUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareStripeSubscriptionsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwner?: Maybe<OrganizationPetParentUpdateOneRequiredWithoutAllCareStripeSubscriptionsNestedInput>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpdateManyWithWhereWithoutAssociatedCarePlanProviderGroupInput = {
  data: CareStripeSubscriptionUpdateManyMutationInput;
  where: CareStripeSubscriptionScalarWhereInput;
};

export type CareStripeSubscriptionUpdateManyWithWhereWithoutAssociatedPetInput = {
  data: CareStripeSubscriptionUpdateManyMutationInput;
  where: CareStripeSubscriptionScalarWhereInput;
};

export type CareStripeSubscriptionUpdateManyWithWhereWithoutStripePaymentMethodInput = {
  data: CareStripeSubscriptionUpdateManyMutationInput;
  where: CareStripeSubscriptionScalarWhereInput;
};

export type CareStripeSubscriptionUpdateManyWithWhereWithoutSubscriptionOwnerInput = {
  data: CareStripeSubscriptionUpdateManyMutationInput;
  where: CareStripeSubscriptionScalarWhereInput;
};

export type CareStripeSubscriptionUpdateManyWithoutAssociatedCarePlanProviderGroupNestedInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutAssociatedCarePlanProviderGroupInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutAssociatedCarePlanProviderGroupInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManyAssociatedCarePlanProviderGroupInputEnvelope>;
  delete?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareStripeSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<CareStripeSubscriptionUpdateWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
  updateMany?: Maybe<Array<CareStripeSubscriptionUpdateManyWithWhereWithoutAssociatedCarePlanProviderGroupInput>>;
  upsert?: Maybe<Array<CareStripeSubscriptionUpsertWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput>>;
};

export type CareStripeSubscriptionUpdateManyWithoutAssociatedPetNestedInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutAssociatedPetInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutAssociatedPetInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManyAssociatedPetInputEnvelope>;
  delete?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareStripeSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<CareStripeSubscriptionUpdateWithWhereUniqueWithoutAssociatedPetInput>>;
  updateMany?: Maybe<Array<CareStripeSubscriptionUpdateManyWithWhereWithoutAssociatedPetInput>>;
  upsert?: Maybe<Array<CareStripeSubscriptionUpsertWithWhereUniqueWithoutAssociatedPetInput>>;
};

export type CareStripeSubscriptionUpdateManyWithoutStripePaymentMethodNestedInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManyStripePaymentMethodInputEnvelope>;
  delete?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareStripeSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<CareStripeSubscriptionUpdateWithWhereUniqueWithoutStripePaymentMethodInput>>;
  updateMany?: Maybe<Array<CareStripeSubscriptionUpdateManyWithWhereWithoutStripePaymentMethodInput>>;
  upsert?: Maybe<Array<CareStripeSubscriptionUpsertWithWhereUniqueWithoutStripePaymentMethodInput>>;
};

export type CareStripeSubscriptionUpdateManyWithoutSubscriptionOwnerNestedInput = {
  connect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareStripeSubscriptionCreateOrConnectWithoutSubscriptionOwnerInput>>;
  create?: Maybe<Array<CareStripeSubscriptionCreateWithoutSubscriptionOwnerInput>>;
  createMany?: Maybe<CareStripeSubscriptionCreateManySubscriptionOwnerInputEnvelope>;
  delete?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareStripeSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<CareStripeSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<CareStripeSubscriptionUpdateWithWhereUniqueWithoutSubscriptionOwnerInput>>;
  updateMany?: Maybe<Array<CareStripeSubscriptionUpdateManyWithWhereWithoutSubscriptionOwnerInput>>;
  upsert?: Maybe<Array<CareStripeSubscriptionUpsertWithWhereUniqueWithoutSubscriptionOwnerInput>>;
};

export type CareStripeSubscriptionUpdateOneRequiredWithoutCareBenefitUsageFollowupsNestedInput = {
  connect?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<CareStripeSubscriptionCreateOrConnectWithoutCareBenefitUsageFollowupsInput>;
  create?: Maybe<CareStripeSubscriptionCreateWithoutCareBenefitUsageFollowupsInput>;
  update?: Maybe<CareStripeSubscriptionUpdateToOneWithWhereWithoutCareBenefitUsageFollowupsInput>;
  upsert?: Maybe<CareStripeSubscriptionUpsertWithoutCareBenefitUsageFollowupsInput>;
};

export type CareStripeSubscriptionUpdateOneRequiredWithoutCareSubscriptionTrueUpsNestedInput = {
  connect?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<CareStripeSubscriptionCreateOrConnectWithoutCareSubscriptionTrueUpsInput>;
  create?: Maybe<CareStripeSubscriptionCreateWithoutCareSubscriptionTrueUpsInput>;
  update?: Maybe<CareStripeSubscriptionUpdateToOneWithWhereWithoutCareSubscriptionTrueUpsInput>;
  upsert?: Maybe<CareStripeSubscriptionUpsertWithoutCareSubscriptionTrueUpsInput>;
};

export type CareStripeSubscriptionUpdateOneRequiredWithoutInvoicesNestedInput = {
  connect?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<CareStripeSubscriptionCreateOrConnectWithoutInvoicesInput>;
  create?: Maybe<CareStripeSubscriptionCreateWithoutInvoicesInput>;
  update?: Maybe<CareStripeSubscriptionUpdateToOneWithWhereWithoutInvoicesInput>;
  upsert?: Maybe<CareStripeSubscriptionUpsertWithoutInvoicesInput>;
};

export type CareStripeSubscriptionUpdateOneWithoutActiveSubscriberNestedInput = {
  connect?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<CareStripeSubscriptionCreateOrConnectWithoutActiveSubscriberInput>;
  create?: Maybe<CareStripeSubscriptionCreateWithoutActiveSubscriberInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareStripeSubscriptionUpdateToOneWithWhereWithoutActiveSubscriberInput>;
  upsert?: Maybe<CareStripeSubscriptionUpsertWithoutActiveSubscriberInput>;
};

export type CareStripeSubscriptionUpdateOneWithoutCareAddonEnrollmentsNestedInput = {
  connect?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<CareStripeSubscriptionCreateOrConnectWithoutCareAddonEnrollmentsInput>;
  create?: Maybe<CareStripeSubscriptionCreateWithoutCareAddonEnrollmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareStripeSubscriptionUpdateToOneWithWhereWithoutCareAddonEnrollmentsInput>;
  upsert?: Maybe<CareStripeSubscriptionUpsertWithoutCareAddonEnrollmentsInput>;
};

export type CareStripeSubscriptionUpdateOneWithoutCarePlanEnrollmentsNestedInput = {
  connect?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<CareStripeSubscriptionCreateOrConnectWithoutCarePlanEnrollmentsInput>;
  create?: Maybe<CareStripeSubscriptionCreateWithoutCarePlanEnrollmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CareStripeSubscriptionUpdateToOneWithWhereWithoutCarePlanEnrollmentsInput>;
  upsert?: Maybe<CareStripeSubscriptionUpsertWithoutCarePlanEnrollmentsInput>;
};

export type CareStripeSubscriptionUpdateToOneWithWhereWithoutActiveSubscriberInput = {
  data: CareStripeSubscriptionUpdateWithoutActiveSubscriberInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionUpdateToOneWithWhereWithoutCareAddonEnrollmentsInput = {
  data: CareStripeSubscriptionUpdateWithoutCareAddonEnrollmentsInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionUpdateToOneWithWhereWithoutCareBenefitUsageFollowupsInput = {
  data: CareStripeSubscriptionUpdateWithoutCareBenefitUsageFollowupsInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionUpdateToOneWithWhereWithoutCarePlanEnrollmentsInput = {
  data: CareStripeSubscriptionUpdateWithoutCarePlanEnrollmentsInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionUpdateToOneWithWhereWithoutCareSubscriptionTrueUpsInput = {
  data: CareStripeSubscriptionUpdateWithoutCareSubscriptionTrueUpsInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionUpdateToOneWithWhereWithoutInvoicesInput = {
  data: CareStripeSubscriptionUpdateWithoutInvoicesInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionUpdateWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput = {
  data: CareStripeSubscriptionUpdateWithoutAssociatedCarePlanProviderGroupInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionUpdateWithWhereUniqueWithoutAssociatedPetInput = {
  data: CareStripeSubscriptionUpdateWithoutAssociatedPetInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionUpdateWithWhereUniqueWithoutStripePaymentMethodInput = {
  data: CareStripeSubscriptionUpdateWithoutStripePaymentMethodInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionUpdateWithWhereUniqueWithoutSubscriptionOwnerInput = {
  data: CareStripeSubscriptionUpdateWithoutSubscriptionOwnerInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionUpdateWithoutActiveSubscriberInput = {
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  associatedPet?: Maybe<OrganizationPetUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareStripeSubscriptionsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwner?: Maybe<OrganizationPetParentUpdateOneRequiredWithoutAllCareStripeSubscriptionsNestedInput>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpdateWithoutAssociatedCarePlanProviderGroupInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedPet?: Maybe<OrganizationPetUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareStripeSubscriptionsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwner?: Maybe<OrganizationPetParentUpdateOneRequiredWithoutAllCareStripeSubscriptionsNestedInput>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpdateWithoutAssociatedPetInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareStripeSubscriptionsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwner?: Maybe<OrganizationPetParentUpdateOneRequiredWithoutAllCareStripeSubscriptionsNestedInput>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpdateWithoutCareAddonEnrollmentsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  associatedPet?: Maybe<OrganizationPetUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareStripeSubscriptionsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwner?: Maybe<OrganizationPetParentUpdateOneRequiredWithoutAllCareStripeSubscriptionsNestedInput>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpdateWithoutCareBenefitUsageFollowupsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  associatedPet?: Maybe<OrganizationPetUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareStripeSubscriptionsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwner?: Maybe<OrganizationPetParentUpdateOneRequiredWithoutAllCareStripeSubscriptionsNestedInput>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpdateWithoutCarePlanEnrollmentsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  associatedPet?: Maybe<OrganizationPetUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareStripeSubscriptionsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwner?: Maybe<OrganizationPetParentUpdateOneRequiredWithoutAllCareStripeSubscriptionsNestedInput>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpdateWithoutCareSubscriptionTrueUpsInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  associatedPet?: Maybe<OrganizationPetUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareStripeSubscriptionsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwner?: Maybe<OrganizationPetParentUpdateOneRequiredWithoutAllCareStripeSubscriptionsNestedInput>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpdateWithoutInvoicesInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  associatedPet?: Maybe<OrganizationPetUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareStripeSubscriptionsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwner?: Maybe<OrganizationPetParentUpdateOneRequiredWithoutAllCareStripeSubscriptionsNestedInput>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpdateWithoutStripePaymentMethodInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  associatedPet?: Maybe<OrganizationPetUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwner?: Maybe<OrganizationPetParentUpdateOneRequiredWithoutAllCareStripeSubscriptionsNestedInput>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpdateWithoutSubscriptionOwnerInput = {
  activeSubscriber?: Maybe<OrganizationPetParentUpdateOneWithoutActiveCareStripeSubscriptionNestedInput>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  associatedPet?: Maybe<OrganizationPetUpdateOneWithoutAssociatedSubscriptionsNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutCareStripeSubscriptionNestedInput>;
  isTestSubscription?: Maybe<Scalars['Boolean']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareStripeSubscriptionsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  upcomingTotalPrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareStripeSubscriptionUpsertWithWhereUniqueWithoutAssociatedCarePlanProviderGroupInput = {
  create: CareStripeSubscriptionCreateWithoutAssociatedCarePlanProviderGroupInput;
  update: CareStripeSubscriptionUpdateWithoutAssociatedCarePlanProviderGroupInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionUpsertWithWhereUniqueWithoutAssociatedPetInput = {
  create: CareStripeSubscriptionCreateWithoutAssociatedPetInput;
  update: CareStripeSubscriptionUpdateWithoutAssociatedPetInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionUpsertWithWhereUniqueWithoutStripePaymentMethodInput = {
  create: CareStripeSubscriptionCreateWithoutStripePaymentMethodInput;
  update: CareStripeSubscriptionUpdateWithoutStripePaymentMethodInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionUpsertWithWhereUniqueWithoutSubscriptionOwnerInput = {
  create: CareStripeSubscriptionCreateWithoutSubscriptionOwnerInput;
  update: CareStripeSubscriptionUpdateWithoutSubscriptionOwnerInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};

export type CareStripeSubscriptionUpsertWithoutActiveSubscriberInput = {
  create: CareStripeSubscriptionCreateWithoutActiveSubscriberInput;
  update: CareStripeSubscriptionUpdateWithoutActiveSubscriberInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionUpsertWithoutCareAddonEnrollmentsInput = {
  create: CareStripeSubscriptionCreateWithoutCareAddonEnrollmentsInput;
  update: CareStripeSubscriptionUpdateWithoutCareAddonEnrollmentsInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionUpsertWithoutCareBenefitUsageFollowupsInput = {
  create: CareStripeSubscriptionCreateWithoutCareBenefitUsageFollowupsInput;
  update: CareStripeSubscriptionUpdateWithoutCareBenefitUsageFollowupsInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionUpsertWithoutCarePlanEnrollmentsInput = {
  create: CareStripeSubscriptionCreateWithoutCarePlanEnrollmentsInput;
  update: CareStripeSubscriptionUpdateWithoutCarePlanEnrollmentsInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionUpsertWithoutCareSubscriptionTrueUpsInput = {
  create: CareStripeSubscriptionCreateWithoutCareSubscriptionTrueUpsInput;
  update: CareStripeSubscriptionUpdateWithoutCareSubscriptionTrueUpsInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionUpsertWithoutInvoicesInput = {
  create: CareStripeSubscriptionCreateWithoutInvoicesInput;
  update: CareStripeSubscriptionUpdateWithoutInvoicesInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};

export type CareStripeSubscriptionWhereInput = {
  AND?: Maybe<Array<CareStripeSubscriptionWhereInput>>;
  NOT?: Maybe<Array<CareStripeSubscriptionWhereInput>>;
  OR?: Maybe<Array<CareStripeSubscriptionWhereInput>>;
  activeSubscriber?: Maybe<OrganizationPetParentNullableScalarRelationFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  associatedPet?: Maybe<OrganizationPetNullableScalarRelationFilter>;
  associatedPetId?: Maybe<StringNullableFilter>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentListRelationFilter>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupListRelationFilter>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  invoices?: Maybe<StripeInvoiceListRelationFilter>;
  isTestSubscription?: Maybe<BoolFilter>;
  nextBillingDate?: Maybe<DateTimeFilter>;
  parentCareStripeSubscriptionId?: Maybe<StringNullableFilter>;
  paymentStatus?: Maybe<EnumCareSubscriptionPaymentStatusNullableFilter>;
  stripeCustomerId?: Maybe<StringFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  stripeSubscriptionId?: Maybe<StringFilter>;
  subscriptionOwner?: Maybe<OrganizationPetParentScalarRelationFilter>;
  subscriptionOwnerId?: Maybe<StringFilter>;
  upcomingTotalPrice?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareStripeSubscriptionWhereUniqueInput = {
  AND?: Maybe<Array<CareStripeSubscriptionWhereInput>>;
  NOT?: Maybe<Array<CareStripeSubscriptionWhereInput>>;
  OR?: Maybe<Array<CareStripeSubscriptionWhereInput>>;
  activeSubscriber?: Maybe<OrganizationPetParentNullableScalarRelationFilter>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  associatedCarePlanProviderGroupId?: Maybe<StringNullableFilter>;
  associatedPet?: Maybe<OrganizationPetNullableScalarRelationFilter>;
  associatedPetId?: Maybe<StringNullableFilter>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentListRelationFilter>;
  careBenefitUsageFollowups?: Maybe<CareBenefitUsageFollowupListRelationFilter>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceListRelationFilter>;
  isTestSubscription?: Maybe<BoolFilter>;
  nextBillingDate?: Maybe<DateTimeFilter>;
  parentCareStripeSubscriptionId?: Maybe<StringNullableFilter>;
  paymentStatus?: Maybe<EnumCareSubscriptionPaymentStatusNullableFilter>;
  stripeCustomerId?: Maybe<StringFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionOwner?: Maybe<OrganizationPetParentScalarRelationFilter>;
  subscriptionOwnerId?: Maybe<StringFilter>;
  upcomingTotalPrice?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum CareSubscriptionPaymentStatus {
  Draft = 'Draft',
  Open = 'Open',
  Paid = 'Paid',
  PastDue = 'PastDue'
}

export type CareSubscriptionTrueUp = {
  __typename?: 'CareSubscriptionTrueUp';
  _count: CareSubscriptionTrueUpCountOutputType;
  amount: Scalars['Int'];
  carePlanEnrollment: CarePlanEnrollment;
  carePlanEnrollmentId: Scalars['String'];
  careStripeSubscription: CareStripeSubscription;
  careStripeSubscriptionId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  currency: Currency;
  dueAt: Scalars['DateTime'];
  id: Scalars['String'];
  logEntries: Array<CareSubscriptionTrueUpLogEntry>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment: Scalars['Boolean'];
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoice>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type: CareSubscriptionTrueUpType;
  updatedAt: Scalars['DateTime'];
};


export type CareSubscriptionTrueUpLogEntriesArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareSubscriptionTrueUpLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpLogEntryWhereInput>;
};


export type CareSubscriptionTrueUpStripeInvoiceArgs = {
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type CareSubscriptionTrueUpStripePaymentMethodArgs = {
  where?: Maybe<StripePaymentMethodWhereInput>;
};

export type CareSubscriptionTrueUpAvgAggregateOutputType = {
  __typename?: 'CareSubscriptionTrueUpAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
};

export type CareSubscriptionTrueUpAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpCountAggregateOutputType = {
  __typename?: 'CareSubscriptionTrueUpCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  carePlanEnrollmentId: Scalars['Int'];
  careStripeSubscriptionId: Scalars['Int'];
  completedAt: Scalars['Int'];
  createdAt: Scalars['Int'];
  currency: Scalars['Int'];
  dueAt: Scalars['Int'];
  id: Scalars['Int'];
  retryAt: Scalars['Int'];
  shouldCancelEnrollment: Scalars['Int'];
  slackMessageTimestamp: Scalars['Int'];
  stripeInvoiceId: Scalars['Int'];
  stripePaymentMethodId: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CareSubscriptionTrueUpCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  retryAt?: Maybe<SortOrder>;
  shouldCancelEnrollment?: Maybe<SortOrder>;
  slackMessageTimestamp?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpCountOutputType = {
  __typename?: 'CareSubscriptionTrueUpCountOutputType';
  logEntries: Scalars['Int'];
};

export type CareSubscriptionTrueUpCreateInput = {
  amount: Scalars['Int'];
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutCareSubscriptionTrueUpsInput;
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutCareSubscriptionTrueUpsInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryCreateNestedManyWithoutCareSubscriptionTrueUpInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutCareSubscriptionTrueUpsInput>;
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareSubscriptionTrueUpsInput>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpCreateManyCarePlanEnrollmentInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpCreateManyCarePlanEnrollmentInputEnvelope = {
  data: Array<CareSubscriptionTrueUpCreateManyCarePlanEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareSubscriptionTrueUpCreateManyCareStripeSubscriptionInput = {
  amount: Scalars['Int'];
  carePlanEnrollmentId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpCreateManyCareStripeSubscriptionInputEnvelope = {
  data: Array<CareSubscriptionTrueUpCreateManyCareStripeSubscriptionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareSubscriptionTrueUpCreateManyInput = {
  amount: Scalars['Int'];
  carePlanEnrollmentId: Scalars['String'];
  careStripeSubscriptionId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpCreateManyStripeInvoiceInput = {
  amount: Scalars['Int'];
  carePlanEnrollmentId: Scalars['String'];
  careStripeSubscriptionId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpCreateManyStripeInvoiceInputEnvelope = {
  data: Array<CareSubscriptionTrueUpCreateManyStripeInvoiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareSubscriptionTrueUpCreateManyStripePaymentMethodInput = {
  amount: Scalars['Int'];
  carePlanEnrollmentId: Scalars['String'];
  careStripeSubscriptionId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpCreateManyStripePaymentMethodInputEnvelope = {
  data: Array<CareSubscriptionTrueUpCreateManyStripePaymentMethodInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareSubscriptionTrueUpCreateNestedManyWithoutCarePlanEnrollmentInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyCarePlanEnrollmentInputEnvelope>;
};

export type CareSubscriptionTrueUpCreateNestedManyWithoutCareStripeSubscriptionInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyCareStripeSubscriptionInputEnvelope>;
};

export type CareSubscriptionTrueUpCreateNestedManyWithoutStripeInvoiceInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutStripeInvoiceInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyStripeInvoiceInputEnvelope>;
};

export type CareSubscriptionTrueUpCreateNestedManyWithoutStripePaymentMethodInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyStripePaymentMethodInputEnvelope>;
};

export type CareSubscriptionTrueUpCreateNestedOneWithoutLogEntriesInput = {
  connect?: Maybe<CareSubscriptionTrueUpWhereUniqueInput>;
  connectOrCreate?: Maybe<CareSubscriptionTrueUpCreateOrConnectWithoutLogEntriesInput>;
  create?: Maybe<CareSubscriptionTrueUpCreateWithoutLogEntriesInput>;
};

export type CareSubscriptionTrueUpCreateOrConnectWithoutCarePlanEnrollmentInput = {
  create: CareSubscriptionTrueUpCreateWithoutCarePlanEnrollmentInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpCreateOrConnectWithoutCareStripeSubscriptionInput = {
  create: CareSubscriptionTrueUpCreateWithoutCareStripeSubscriptionInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpCreateOrConnectWithoutLogEntriesInput = {
  create: CareSubscriptionTrueUpCreateWithoutLogEntriesInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpCreateOrConnectWithoutStripeInvoiceInput = {
  create: CareSubscriptionTrueUpCreateWithoutStripeInvoiceInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpCreateOrConnectWithoutStripePaymentMethodInput = {
  create: CareSubscriptionTrueUpCreateWithoutStripePaymentMethodInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpCreateWithoutCarePlanEnrollmentInput = {
  amount: Scalars['Int'];
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutCareSubscriptionTrueUpsInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryCreateNestedManyWithoutCareSubscriptionTrueUpInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutCareSubscriptionTrueUpsInput>;
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareSubscriptionTrueUpsInput>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpCreateWithoutCareStripeSubscriptionInput = {
  amount: Scalars['Int'];
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutCareSubscriptionTrueUpsInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryCreateNestedManyWithoutCareSubscriptionTrueUpInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutCareSubscriptionTrueUpsInput>;
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareSubscriptionTrueUpsInput>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpCreateWithoutLogEntriesInput = {
  amount: Scalars['Int'];
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutCareSubscriptionTrueUpsInput;
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutCareSubscriptionTrueUpsInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutCareSubscriptionTrueUpsInput>;
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareSubscriptionTrueUpsInput>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpCreateWithoutStripeInvoiceInput = {
  amount: Scalars['Int'];
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutCareSubscriptionTrueUpsInput;
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutCareSubscriptionTrueUpsInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryCreateNestedManyWithoutCareSubscriptionTrueUpInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutCareSubscriptionTrueUpsInput>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpCreateWithoutStripePaymentMethodInput = {
  amount: Scalars['Int'];
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutCareSubscriptionTrueUpsInput;
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutCareSubscriptionTrueUpsInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryCreateNestedManyWithoutCareSubscriptionTrueUpInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutCareSubscriptionTrueUpsInput>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpGroupByOutputType = {
  __typename?: 'CareSubscriptionTrueUpGroupByOutputType';
  _avg?: Maybe<CareSubscriptionTrueUpAvgAggregateOutputType>;
  _count?: Maybe<CareSubscriptionTrueUpCountAggregateOutputType>;
  _max?: Maybe<CareSubscriptionTrueUpMaxAggregateOutputType>;
  _min?: Maybe<CareSubscriptionTrueUpMinAggregateOutputType>;
  _sum?: Maybe<CareSubscriptionTrueUpSumAggregateOutputType>;
  amount: Scalars['Int'];
  carePlanEnrollmentId: Scalars['String'];
  careStripeSubscriptionId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  currency: Currency;
  dueAt: Scalars['DateTime'];
  id: Scalars['String'];
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment: Scalars['Boolean'];
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type: CareSubscriptionTrueUpType;
  updatedAt: Scalars['DateTime'];
};

export type CareSubscriptionTrueUpListRelationFilter = {
  every?: Maybe<CareSubscriptionTrueUpWhereInput>;
  none?: Maybe<CareSubscriptionTrueUpWhereInput>;
  some?: Maybe<CareSubscriptionTrueUpWhereInput>;
};

export type CareSubscriptionTrueUpLogEntry = {
  __typename?: 'CareSubscriptionTrueUpLogEntry';
  careSubscriptionTrueUp: CareSubscriptionTrueUp;
  careSubscriptionTrueUpId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  httpCode?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt: Scalars['Int'];
  status: CareSubscriptionTrueUpStatus;
  updatedAt: Scalars['DateTime'];
};

export type CareSubscriptionTrueUpLogEntryAvgAggregateOutputType = {
  __typename?: 'CareSubscriptionTrueUpLogEntryAvgAggregateOutputType';
  httpCode?: Maybe<Scalars['Float']>;
  retryAttempt?: Maybe<Scalars['Float']>;
};

export type CareSubscriptionTrueUpLogEntryAvgOrderByAggregateInput = {
  httpCode?: Maybe<SortOrder>;
  retryAttempt?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpLogEntryCountAggregateOutputType = {
  __typename?: 'CareSubscriptionTrueUpLogEntryCountAggregateOutputType';
  _all: Scalars['Int'];
  careSubscriptionTrueUpId: Scalars['Int'];
  createdAt: Scalars['Int'];
  httpCode: Scalars['Int'];
  id: Scalars['Int'];
  lastPaymentError: Scalars['Int'];
  retryAttempt: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CareSubscriptionTrueUpLogEntryCountOrderByAggregateInput = {
  careSubscriptionTrueUpId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  retryAttempt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpLogEntryCreateInput = {
  careSubscriptionTrueUp: CareSubscriptionTrueUpCreateNestedOneWithoutLogEntriesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryCreateManyCareSubscriptionTrueUpInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryCreateManyCareSubscriptionTrueUpInputEnvelope = {
  data: Array<CareSubscriptionTrueUpLogEntryCreateManyCareSubscriptionTrueUpInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CareSubscriptionTrueUpLogEntryCreateManyInput = {
  careSubscriptionTrueUpId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryCreateNestedManyWithoutCareSubscriptionTrueUpInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpLogEntryCreateOrConnectWithoutCareSubscriptionTrueUpInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpLogEntryCreateWithoutCareSubscriptionTrueUpInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpLogEntryCreateManyCareSubscriptionTrueUpInputEnvelope>;
};

export type CareSubscriptionTrueUpLogEntryCreateOrConnectWithoutCareSubscriptionTrueUpInput = {
  create: CareSubscriptionTrueUpLogEntryCreateWithoutCareSubscriptionTrueUpInput;
  where: CareSubscriptionTrueUpLogEntryWhereUniqueInput;
};

export type CareSubscriptionTrueUpLogEntryCreateWithoutCareSubscriptionTrueUpInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryGroupByOutputType = {
  __typename?: 'CareSubscriptionTrueUpLogEntryGroupByOutputType';
  _avg?: Maybe<CareSubscriptionTrueUpLogEntryAvgAggregateOutputType>;
  _count?: Maybe<CareSubscriptionTrueUpLogEntryCountAggregateOutputType>;
  _max?: Maybe<CareSubscriptionTrueUpLogEntryMaxAggregateOutputType>;
  _min?: Maybe<CareSubscriptionTrueUpLogEntryMinAggregateOutputType>;
  _sum?: Maybe<CareSubscriptionTrueUpLogEntrySumAggregateOutputType>;
  careSubscriptionTrueUpId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  httpCode?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt: Scalars['Int'];
  status: CareSubscriptionTrueUpStatus;
  updatedAt: Scalars['DateTime'];
};

export type CareSubscriptionTrueUpLogEntryListRelationFilter = {
  every?: Maybe<CareSubscriptionTrueUpLogEntryWhereInput>;
  none?: Maybe<CareSubscriptionTrueUpLogEntryWhereInput>;
  some?: Maybe<CareSubscriptionTrueUpLogEntryWhereInput>;
};

export type CareSubscriptionTrueUpLogEntryMaxAggregateOutputType = {
  __typename?: 'CareSubscriptionTrueUpLogEntryMaxAggregateOutputType';
  careSubscriptionTrueUpId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryMaxOrderByAggregateInput = {
  careSubscriptionTrueUpId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  retryAttempt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpLogEntryMinAggregateOutputType = {
  __typename?: 'CareSubscriptionTrueUpLogEntryMinAggregateOutputType';
  careSubscriptionTrueUpId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryMinOrderByAggregateInput = {
  careSubscriptionTrueUpId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  retryAttempt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpLogEntryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpLogEntryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareSubscriptionTrueUpLogEntryOrderByRelevanceInput>;
  careSubscriptionTrueUp?: Maybe<CareSubscriptionTrueUpOrderByWithRelationInput>;
  careSubscriptionTrueUpId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  retryAttempt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareSubscriptionTrueUpLogEntryOrderByRelevanceFieldEnum {
  CareSubscriptionTrueUpId = 'careSubscriptionTrueUpId',
  Id = 'id'
}

export type CareSubscriptionTrueUpLogEntryOrderByRelevanceInput = {
  fields: Array<CareSubscriptionTrueUpLogEntryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareSubscriptionTrueUpLogEntryOrderByWithAggregationInput = {
  _avg?: Maybe<CareSubscriptionTrueUpLogEntryAvgOrderByAggregateInput>;
  _count?: Maybe<CareSubscriptionTrueUpLogEntryCountOrderByAggregateInput>;
  _max?: Maybe<CareSubscriptionTrueUpLogEntryMaxOrderByAggregateInput>;
  _min?: Maybe<CareSubscriptionTrueUpLogEntryMinOrderByAggregateInput>;
  _sum?: Maybe<CareSubscriptionTrueUpLogEntrySumOrderByAggregateInput>;
  careSubscriptionTrueUpId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  retryAttempt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpLogEntryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareSubscriptionTrueUpLogEntryOrderByRelevanceInput>;
  careSubscriptionTrueUp?: Maybe<CareSubscriptionTrueUpOrderByWithRelationInput>;
  careSubscriptionTrueUpId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  retryAttempt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpLogEntryOrderByWithRelationInput = {
  _relevance?: Maybe<CareSubscriptionTrueUpLogEntryOrderByRelevanceInput>;
  careSubscriptionTrueUp?: Maybe<CareSubscriptionTrueUpOrderByWithRelationInput>;
  careSubscriptionTrueUpId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  retryAttempt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareSubscriptionTrueUpLogEntryScalarFieldEnum {
  CareSubscriptionTrueUpId = 'careSubscriptionTrueUpId',
  CreatedAt = 'createdAt',
  HttpCode = 'httpCode',
  Id = 'id',
  LastPaymentError = 'lastPaymentError',
  RetryAttempt = 'retryAttempt',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type CareSubscriptionTrueUpLogEntryScalarWhereInput = {
  AND?: Maybe<Array<CareSubscriptionTrueUpLogEntryScalarWhereInput>>;
  NOT?: Maybe<Array<CareSubscriptionTrueUpLogEntryScalarWhereInput>>;
  OR?: Maybe<Array<CareSubscriptionTrueUpLogEntryScalarWhereInput>>;
  careSubscriptionTrueUpId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  httpCode?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableFilter>;
  retryAttempt?: Maybe<IntFilter>;
  status?: Maybe<EnumCareSubscriptionTrueUpStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareSubscriptionTrueUpLogEntryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareSubscriptionTrueUpLogEntryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareSubscriptionTrueUpLogEntryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareSubscriptionTrueUpLogEntryScalarWhereWithAggregatesInput>>;
  careSubscriptionTrueUpId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  httpCode?: Maybe<IntNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableWithAggregatesFilter>;
  retryAttempt?: Maybe<IntWithAggregatesFilter>;
  status?: Maybe<EnumCareSubscriptionTrueUpStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CareSubscriptionTrueUpLogEntrySumAggregateOutputType = {
  __typename?: 'CareSubscriptionTrueUpLogEntrySumAggregateOutputType';
  httpCode?: Maybe<Scalars['Int']>;
  retryAttempt?: Maybe<Scalars['Int']>;
};

export type CareSubscriptionTrueUpLogEntrySumOrderByAggregateInput = {
  httpCode?: Maybe<SortOrder>;
  retryAttempt?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpLogEntryUncheckedCreateInput = {
  careSubscriptionTrueUpId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryUncheckedCreateNestedManyWithoutCareSubscriptionTrueUpInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpLogEntryCreateOrConnectWithoutCareSubscriptionTrueUpInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpLogEntryCreateWithoutCareSubscriptionTrueUpInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpLogEntryCreateManyCareSubscriptionTrueUpInputEnvelope>;
};

export type CareSubscriptionTrueUpLogEntryUncheckedCreateWithoutCareSubscriptionTrueUpInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryUncheckedUpdateInput = {
  careSubscriptionTrueUpId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryUncheckedUpdateManyInput = {
  careSubscriptionTrueUpId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryUncheckedUpdateManyWithoutCareSubscriptionTrueUpInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryUncheckedUpdateManyWithoutCareSubscriptionTrueUpNestedInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpLogEntryCreateOrConnectWithoutCareSubscriptionTrueUpInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpLogEntryCreateWithoutCareSubscriptionTrueUpInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpLogEntryCreateManyCareSubscriptionTrueUpInputEnvelope>;
  delete?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareSubscriptionTrueUpLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<CareSubscriptionTrueUpLogEntryUpdateWithWhereUniqueWithoutCareSubscriptionTrueUpInput>>;
  updateMany?: Maybe<Array<CareSubscriptionTrueUpLogEntryUpdateManyWithWhereWithoutCareSubscriptionTrueUpInput>>;
  upsert?: Maybe<Array<CareSubscriptionTrueUpLogEntryUpsertWithWhereUniqueWithoutCareSubscriptionTrueUpInput>>;
};

export type CareSubscriptionTrueUpLogEntryUncheckedUpdateWithoutCareSubscriptionTrueUpInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryUpdateInput = {
  careSubscriptionTrueUp?: Maybe<CareSubscriptionTrueUpUpdateOneRequiredWithoutLogEntriesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryUpdateManyWithWhereWithoutCareSubscriptionTrueUpInput = {
  data: CareSubscriptionTrueUpLogEntryUpdateManyMutationInput;
  where: CareSubscriptionTrueUpLogEntryScalarWhereInput;
};

export type CareSubscriptionTrueUpLogEntryUpdateManyWithoutCareSubscriptionTrueUpNestedInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpLogEntryCreateOrConnectWithoutCareSubscriptionTrueUpInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpLogEntryCreateWithoutCareSubscriptionTrueUpInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpLogEntryCreateManyCareSubscriptionTrueUpInputEnvelope>;
  delete?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareSubscriptionTrueUpLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<CareSubscriptionTrueUpLogEntryUpdateWithWhereUniqueWithoutCareSubscriptionTrueUpInput>>;
  updateMany?: Maybe<Array<CareSubscriptionTrueUpLogEntryUpdateManyWithWhereWithoutCareSubscriptionTrueUpInput>>;
  upsert?: Maybe<Array<CareSubscriptionTrueUpLogEntryUpsertWithWhereUniqueWithoutCareSubscriptionTrueUpInput>>;
};

export type CareSubscriptionTrueUpLogEntryUpdateWithWhereUniqueWithoutCareSubscriptionTrueUpInput = {
  data: CareSubscriptionTrueUpLogEntryUpdateWithoutCareSubscriptionTrueUpInput;
  where: CareSubscriptionTrueUpLogEntryWhereUniqueInput;
};

export type CareSubscriptionTrueUpLogEntryUpdateWithoutCareSubscriptionTrueUpInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt?: Maybe<Scalars['Int']>;
  status?: Maybe<CareSubscriptionTrueUpStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpLogEntryUpsertWithWhereUniqueWithoutCareSubscriptionTrueUpInput = {
  create: CareSubscriptionTrueUpLogEntryCreateWithoutCareSubscriptionTrueUpInput;
  update: CareSubscriptionTrueUpLogEntryUpdateWithoutCareSubscriptionTrueUpInput;
  where: CareSubscriptionTrueUpLogEntryWhereUniqueInput;
};

export type CareSubscriptionTrueUpLogEntryWhereInput = {
  AND?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereInput>>;
  NOT?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereInput>>;
  OR?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereInput>>;
  careSubscriptionTrueUp?: Maybe<CareSubscriptionTrueUpScalarRelationFilter>;
  careSubscriptionTrueUpId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  httpCode?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableFilter>;
  retryAttempt?: Maybe<IntFilter>;
  status?: Maybe<EnumCareSubscriptionTrueUpStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareSubscriptionTrueUpLogEntryWhereUniqueInput = {
  AND?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereInput>>;
  NOT?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereInput>>;
  OR?: Maybe<Array<CareSubscriptionTrueUpLogEntryWhereInput>>;
  careSubscriptionTrueUp?: Maybe<CareSubscriptionTrueUpScalarRelationFilter>;
  careSubscriptionTrueUpId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  httpCode?: Maybe<IntNullableFilter>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableFilter>;
  retryAttempt?: Maybe<IntFilter>;
  status?: Maybe<EnumCareSubscriptionTrueUpStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareSubscriptionTrueUpMaxAggregateOutputType = {
  __typename?: 'CareSubscriptionTrueUpMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  retryAt?: Maybe<SortOrder>;
  shouldCancelEnrollment?: Maybe<SortOrder>;
  slackMessageTimestamp?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpMinAggregateOutputType = {
  __typename?: 'CareSubscriptionTrueUpMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  retryAt?: Maybe<SortOrder>;
  shouldCancelEnrollment?: Maybe<SortOrder>;
  slackMessageTimestamp?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareSubscriptionTrueUpOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryOrderByRelationAggregateInput>;
  retryAt?: Maybe<SortOrder>;
  shouldCancelEnrollment?: Maybe<SortOrder>;
  slackMessageTimestamp?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentMethod?: Maybe<StripePaymentMethodOrderByWithRelationInput>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareSubscriptionTrueUpOrderByRelevanceFieldEnum {
  CarePlanEnrollmentId = 'carePlanEnrollmentId',
  CareStripeSubscriptionId = 'careStripeSubscriptionId',
  Id = 'id',
  SlackMessageTimestamp = 'slackMessageTimestamp',
  StripeInvoiceId = 'stripeInvoiceId',
  StripePaymentMethodId = 'stripePaymentMethodId'
}

export type CareSubscriptionTrueUpOrderByRelevanceInput = {
  fields: Array<CareSubscriptionTrueUpOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CareSubscriptionTrueUpOrderByWithAggregationInput = {
  _avg?: Maybe<CareSubscriptionTrueUpAvgOrderByAggregateInput>;
  _count?: Maybe<CareSubscriptionTrueUpCountOrderByAggregateInput>;
  _max?: Maybe<CareSubscriptionTrueUpMaxOrderByAggregateInput>;
  _min?: Maybe<CareSubscriptionTrueUpMinOrderByAggregateInput>;
  _sum?: Maybe<CareSubscriptionTrueUpSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  retryAt?: Maybe<SortOrder>;
  shouldCancelEnrollment?: Maybe<SortOrder>;
  slackMessageTimestamp?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CareSubscriptionTrueUpOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryOrderByRelationAggregateInput>;
  retryAt?: Maybe<SortOrder>;
  shouldCancelEnrollment?: Maybe<SortOrder>;
  slackMessageTimestamp?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentMethod?: Maybe<StripePaymentMethodOrderByWithRelationInput>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CareSubscriptionTrueUpOrderByWithRelationInput = {
  _relevance?: Maybe<CareSubscriptionTrueUpOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryOrderByRelationAggregateInput>;
  retryAt?: Maybe<SortOrder>;
  shouldCancelEnrollment?: Maybe<SortOrder>;
  slackMessageTimestamp?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentMethod?: Maybe<StripePaymentMethodOrderByWithRelationInput>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CareSubscriptionTrueUpScalarFieldEnum {
  Amount = 'amount',
  CarePlanEnrollmentId = 'carePlanEnrollmentId',
  CareStripeSubscriptionId = 'careStripeSubscriptionId',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  DueAt = 'dueAt',
  Id = 'id',
  RetryAt = 'retryAt',
  ShouldCancelEnrollment = 'shouldCancelEnrollment',
  SlackMessageTimestamp = 'slackMessageTimestamp',
  StripeInvoiceId = 'stripeInvoiceId',
  StripePaymentMethodId = 'stripePaymentMethodId',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type CareSubscriptionTrueUpScalarRelationFilter = {
  AND?: Maybe<Array<CareSubscriptionTrueUpWhereInput>>;
  NOT?: Maybe<Array<CareSubscriptionTrueUpWhereInput>>;
  OR?: Maybe<Array<CareSubscriptionTrueUpWhereInput>>;
  amount?: Maybe<IntFilter>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentScalarRelationFilter>;
  carePlanEnrollmentId?: Maybe<StringFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  dueAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryListRelationFilter>;
  retryAt?: Maybe<DateTimeNullableFilter>;
  shouldCancelEnrollment?: Maybe<BoolFilter>;
  slackMessageTimestamp?: Maybe<StringNullableFilter>;
  stripeInvoice?: Maybe<StripeInvoiceNullableScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumCareSubscriptionTrueUpTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareSubscriptionTrueUpScalarWhereInput = {
  AND?: Maybe<Array<CareSubscriptionTrueUpScalarWhereInput>>;
  NOT?: Maybe<Array<CareSubscriptionTrueUpScalarWhereInput>>;
  OR?: Maybe<Array<CareSubscriptionTrueUpScalarWhereInput>>;
  amount?: Maybe<IntFilter>;
  carePlanEnrollmentId?: Maybe<StringFilter>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  dueAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  retryAt?: Maybe<DateTimeNullableFilter>;
  shouldCancelEnrollment?: Maybe<BoolFilter>;
  slackMessageTimestamp?: Maybe<StringNullableFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumCareSubscriptionTrueUpTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareSubscriptionTrueUpScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CareSubscriptionTrueUpScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CareSubscriptionTrueUpScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CareSubscriptionTrueUpScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntWithAggregatesFilter>;
  carePlanEnrollmentId?: Maybe<StringWithAggregatesFilter>;
  careStripeSubscriptionId?: Maybe<StringWithAggregatesFilter>;
  completedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  currency?: Maybe<EnumCurrencyWithAggregatesFilter>;
  dueAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  retryAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  shouldCancelEnrollment?: Maybe<BoolWithAggregatesFilter>;
  slackMessageTimestamp?: Maybe<StringNullableWithAggregatesFilter>;
  stripeInvoiceId?: Maybe<StringNullableWithAggregatesFilter>;
  stripePaymentMethodId?: Maybe<StringNullableWithAggregatesFilter>;
  type?: Maybe<EnumCareSubscriptionTrueUpTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum CareSubscriptionTrueUpStatus {
  Failure = 'Failure',
  Pending = 'Pending',
  PendingRetryAutomatic = 'Pending_RetryAutomatic',
  Success = 'Success'
}

export type CareSubscriptionTrueUpSubscriptionEnrollmentAndDueAtCompoundUniqueInput = {
  carePlanEnrollmentId: Scalars['String'];
  careStripeSubscriptionId: Scalars['String'];
  dueAt: Scalars['DateTime'];
};

export type CareSubscriptionTrueUpSumAggregateOutputType = {
  __typename?: 'CareSubscriptionTrueUpSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
};

export type CareSubscriptionTrueUpSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export enum CareSubscriptionTrueUpType {
  ClinicAlternativePayment = 'ClinicAlternativePayment',
  ClinicCollections = 'ClinicCollections',
  Internal = 'Internal'
}

export type CareSubscriptionTrueUpUncheckedCreateInput = {
  amount: Scalars['Int'];
  carePlanEnrollmentId: Scalars['String'];
  careStripeSubscriptionId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUncheckedCreateNestedManyWithoutCareSubscriptionTrueUpInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyCarePlanEnrollmentInputEnvelope>;
};

export type CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyCareStripeSubscriptionInputEnvelope>;
};

export type CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripeInvoiceInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutStripeInvoiceInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyStripeInvoiceInputEnvelope>;
};

export type CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripePaymentMethodInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyStripePaymentMethodInputEnvelope>;
};

export type CareSubscriptionTrueUpUncheckedCreateWithoutCarePlanEnrollmentInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUncheckedCreateNestedManyWithoutCareSubscriptionTrueUpInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedCreateWithoutCareStripeSubscriptionInput = {
  amount: Scalars['Int'];
  carePlanEnrollmentId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUncheckedCreateNestedManyWithoutCareSubscriptionTrueUpInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedCreateWithoutLogEntriesInput = {
  amount: Scalars['Int'];
  carePlanEnrollmentId: Scalars['String'];
  careStripeSubscriptionId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedCreateWithoutStripeInvoiceInput = {
  amount: Scalars['Int'];
  carePlanEnrollmentId: Scalars['String'];
  careStripeSubscriptionId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUncheckedCreateNestedManyWithoutCareSubscriptionTrueUpInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedCreateWithoutStripePaymentMethodInput = {
  amount: Scalars['Int'];
  carePlanEnrollmentId: Scalars['String'];
  careStripeSubscriptionId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUncheckedCreateNestedManyWithoutCareSubscriptionTrueUpInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUncheckedUpdateManyWithoutCareSubscriptionTrueUpNestedInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyCarePlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareSubscriptionTrueUpScalarWhereInput>>;
  disconnect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  set?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  update?: Maybe<Array<CareSubscriptionTrueUpUpdateWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
  updateMany?: Maybe<Array<CareSubscriptionTrueUpUpdateManyWithWhereWithoutCarePlanEnrollmentInput>>;
  upsert?: Maybe<Array<CareSubscriptionTrueUpUpsertWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
};

export type CareSubscriptionTrueUpUncheckedUpdateManyWithoutCareStripeSubscriptionInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyCareStripeSubscriptionInputEnvelope>;
  delete?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareSubscriptionTrueUpScalarWhereInput>>;
  disconnect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  set?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  update?: Maybe<Array<CareSubscriptionTrueUpUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
  updateMany?: Maybe<Array<CareSubscriptionTrueUpUpdateManyWithWhereWithoutCareStripeSubscriptionInput>>;
  upsert?: Maybe<Array<CareSubscriptionTrueUpUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
};

export type CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripeInvoiceInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripeInvoiceNestedInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutStripeInvoiceInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyStripeInvoiceInputEnvelope>;
  delete?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareSubscriptionTrueUpScalarWhereInput>>;
  disconnect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  set?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  update?: Maybe<Array<CareSubscriptionTrueUpUpdateWithWhereUniqueWithoutStripeInvoiceInput>>;
  updateMany?: Maybe<Array<CareSubscriptionTrueUpUpdateManyWithWhereWithoutStripeInvoiceInput>>;
  upsert?: Maybe<Array<CareSubscriptionTrueUpUpsertWithWhereUniqueWithoutStripeInvoiceInput>>;
};

export type CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripePaymentMethodInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripePaymentMethodNestedInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyStripePaymentMethodInputEnvelope>;
  delete?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareSubscriptionTrueUpScalarWhereInput>>;
  disconnect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  set?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  update?: Maybe<Array<CareSubscriptionTrueUpUpdateWithWhereUniqueWithoutStripePaymentMethodInput>>;
  updateMany?: Maybe<Array<CareSubscriptionTrueUpUpdateManyWithWhereWithoutStripePaymentMethodInput>>;
  upsert?: Maybe<Array<CareSubscriptionTrueUpUpsertWithWhereUniqueWithoutStripePaymentMethodInput>>;
};

export type CareSubscriptionTrueUpUncheckedUpdateWithoutCarePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUncheckedUpdateManyWithoutCareSubscriptionTrueUpNestedInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedUpdateWithoutCareStripeSubscriptionInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUncheckedUpdateManyWithoutCareSubscriptionTrueUpNestedInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedUpdateWithoutLogEntriesInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedUpdateWithoutStripeInvoiceInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUncheckedUpdateManyWithoutCareSubscriptionTrueUpNestedInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUncheckedUpdateWithoutStripePaymentMethodInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUncheckedUpdateManyWithoutCareSubscriptionTrueUpNestedInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutCareSubscriptionTrueUpsNestedInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutCareSubscriptionTrueUpsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUpdateManyWithoutCareSubscriptionTrueUpNestedInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutCareSubscriptionTrueUpsNestedInput>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareSubscriptionTrueUpsNestedInput>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUpdateManyWithWhereWithoutCarePlanEnrollmentInput = {
  data: CareSubscriptionTrueUpUpdateManyMutationInput;
  where: CareSubscriptionTrueUpScalarWhereInput;
};

export type CareSubscriptionTrueUpUpdateManyWithWhereWithoutCareStripeSubscriptionInput = {
  data: CareSubscriptionTrueUpUpdateManyMutationInput;
  where: CareSubscriptionTrueUpScalarWhereInput;
};

export type CareSubscriptionTrueUpUpdateManyWithWhereWithoutStripeInvoiceInput = {
  data: CareSubscriptionTrueUpUpdateManyMutationInput;
  where: CareSubscriptionTrueUpScalarWhereInput;
};

export type CareSubscriptionTrueUpUpdateManyWithWhereWithoutStripePaymentMethodInput = {
  data: CareSubscriptionTrueUpUpdateManyMutationInput;
  where: CareSubscriptionTrueUpScalarWhereInput;
};

export type CareSubscriptionTrueUpUpdateManyWithoutCarePlanEnrollmentNestedInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyCarePlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareSubscriptionTrueUpScalarWhereInput>>;
  disconnect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  set?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  update?: Maybe<Array<CareSubscriptionTrueUpUpdateWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
  updateMany?: Maybe<Array<CareSubscriptionTrueUpUpdateManyWithWhereWithoutCarePlanEnrollmentInput>>;
  upsert?: Maybe<Array<CareSubscriptionTrueUpUpsertWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
};

export type CareSubscriptionTrueUpUpdateManyWithoutCareStripeSubscriptionNestedInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyCareStripeSubscriptionInputEnvelope>;
  delete?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareSubscriptionTrueUpScalarWhereInput>>;
  disconnect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  set?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  update?: Maybe<Array<CareSubscriptionTrueUpUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
  updateMany?: Maybe<Array<CareSubscriptionTrueUpUpdateManyWithWhereWithoutCareStripeSubscriptionInput>>;
  upsert?: Maybe<Array<CareSubscriptionTrueUpUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
};

export type CareSubscriptionTrueUpUpdateManyWithoutStripeInvoiceNestedInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutStripeInvoiceInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyStripeInvoiceInputEnvelope>;
  delete?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareSubscriptionTrueUpScalarWhereInput>>;
  disconnect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  set?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  update?: Maybe<Array<CareSubscriptionTrueUpUpdateWithWhereUniqueWithoutStripeInvoiceInput>>;
  updateMany?: Maybe<Array<CareSubscriptionTrueUpUpdateManyWithWhereWithoutStripeInvoiceInput>>;
  upsert?: Maybe<Array<CareSubscriptionTrueUpUpsertWithWhereUniqueWithoutStripeInvoiceInput>>;
};

export type CareSubscriptionTrueUpUpdateManyWithoutStripePaymentMethodNestedInput = {
  connect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CareSubscriptionTrueUpCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<CareSubscriptionTrueUpCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<CareSubscriptionTrueUpCreateManyStripePaymentMethodInputEnvelope>;
  delete?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CareSubscriptionTrueUpScalarWhereInput>>;
  disconnect?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  set?: Maybe<Array<CareSubscriptionTrueUpWhereUniqueInput>>;
  update?: Maybe<Array<CareSubscriptionTrueUpUpdateWithWhereUniqueWithoutStripePaymentMethodInput>>;
  updateMany?: Maybe<Array<CareSubscriptionTrueUpUpdateManyWithWhereWithoutStripePaymentMethodInput>>;
  upsert?: Maybe<Array<CareSubscriptionTrueUpUpsertWithWhereUniqueWithoutStripePaymentMethodInput>>;
};

export type CareSubscriptionTrueUpUpdateOneRequiredWithoutLogEntriesNestedInput = {
  connect?: Maybe<CareSubscriptionTrueUpWhereUniqueInput>;
  connectOrCreate?: Maybe<CareSubscriptionTrueUpCreateOrConnectWithoutLogEntriesInput>;
  create?: Maybe<CareSubscriptionTrueUpCreateWithoutLogEntriesInput>;
  update?: Maybe<CareSubscriptionTrueUpUpdateToOneWithWhereWithoutLogEntriesInput>;
  upsert?: Maybe<CareSubscriptionTrueUpUpsertWithoutLogEntriesInput>;
};

export type CareSubscriptionTrueUpUpdateToOneWithWhereWithoutLogEntriesInput = {
  data: CareSubscriptionTrueUpUpdateWithoutLogEntriesInput;
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
};

export type CareSubscriptionTrueUpUpdateWithWhereUniqueWithoutCarePlanEnrollmentInput = {
  data: CareSubscriptionTrueUpUpdateWithoutCarePlanEnrollmentInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput = {
  data: CareSubscriptionTrueUpUpdateWithoutCareStripeSubscriptionInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpUpdateWithWhereUniqueWithoutStripeInvoiceInput = {
  data: CareSubscriptionTrueUpUpdateWithoutStripeInvoiceInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpUpdateWithWhereUniqueWithoutStripePaymentMethodInput = {
  data: CareSubscriptionTrueUpUpdateWithoutStripePaymentMethodInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpUpdateWithoutCarePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutCareSubscriptionTrueUpsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUpdateManyWithoutCareSubscriptionTrueUpNestedInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutCareSubscriptionTrueUpsNestedInput>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareSubscriptionTrueUpsNestedInput>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUpdateWithoutCareStripeSubscriptionInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutCareSubscriptionTrueUpsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUpdateManyWithoutCareSubscriptionTrueUpNestedInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutCareSubscriptionTrueUpsNestedInput>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareSubscriptionTrueUpsNestedInput>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUpdateWithoutLogEntriesInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutCareSubscriptionTrueUpsNestedInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutCareSubscriptionTrueUpsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutCareSubscriptionTrueUpsNestedInput>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareSubscriptionTrueUpsNestedInput>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUpdateWithoutStripeInvoiceInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutCareSubscriptionTrueUpsNestedInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutCareSubscriptionTrueUpsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUpdateManyWithoutCareSubscriptionTrueUpNestedInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutCareSubscriptionTrueUpsNestedInput>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUpdateWithoutStripePaymentMethodInput = {
  amount?: Maybe<Scalars['Int']>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutCareSubscriptionTrueUpsNestedInput>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutCareSubscriptionTrueUpsNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryUpdateManyWithoutCareSubscriptionTrueUpNestedInput>;
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment?: Maybe<Scalars['Boolean']>;
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutCareSubscriptionTrueUpsNestedInput>;
  type?: Maybe<CareSubscriptionTrueUpType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CareSubscriptionTrueUpUpsertWithWhereUniqueWithoutCarePlanEnrollmentInput = {
  create: CareSubscriptionTrueUpCreateWithoutCarePlanEnrollmentInput;
  update: CareSubscriptionTrueUpUpdateWithoutCarePlanEnrollmentInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput = {
  create: CareSubscriptionTrueUpCreateWithoutCareStripeSubscriptionInput;
  update: CareSubscriptionTrueUpUpdateWithoutCareStripeSubscriptionInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpUpsertWithWhereUniqueWithoutStripeInvoiceInput = {
  create: CareSubscriptionTrueUpCreateWithoutStripeInvoiceInput;
  update: CareSubscriptionTrueUpUpdateWithoutStripeInvoiceInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpUpsertWithWhereUniqueWithoutStripePaymentMethodInput = {
  create: CareSubscriptionTrueUpCreateWithoutStripePaymentMethodInput;
  update: CareSubscriptionTrueUpUpdateWithoutStripePaymentMethodInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};

export type CareSubscriptionTrueUpUpsertWithoutLogEntriesInput = {
  create: CareSubscriptionTrueUpCreateWithoutLogEntriesInput;
  update: CareSubscriptionTrueUpUpdateWithoutLogEntriesInput;
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
};

export type CareSubscriptionTrueUpWhereInput = {
  AND?: Maybe<Array<CareSubscriptionTrueUpWhereInput>>;
  NOT?: Maybe<Array<CareSubscriptionTrueUpWhereInput>>;
  OR?: Maybe<Array<CareSubscriptionTrueUpWhereInput>>;
  amount?: Maybe<IntFilter>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentScalarRelationFilter>;
  carePlanEnrollmentId?: Maybe<StringFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  dueAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryListRelationFilter>;
  retryAt?: Maybe<DateTimeNullableFilter>;
  shouldCancelEnrollment?: Maybe<BoolFilter>;
  slackMessageTimestamp?: Maybe<StringNullableFilter>;
  stripeInvoice?: Maybe<StripeInvoiceNullableScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumCareSubscriptionTrueUpTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CareSubscriptionTrueUpWhereUniqueInput = {
  AND?: Maybe<Array<CareSubscriptionTrueUpWhereInput>>;
  NOT?: Maybe<Array<CareSubscriptionTrueUpWhereInput>>;
  OR?: Maybe<Array<CareSubscriptionTrueUpWhereInput>>;
  amount?: Maybe<IntFilter>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentScalarRelationFilter>;
  carePlanEnrollmentId?: Maybe<StringFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  dueAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  logEntries?: Maybe<CareSubscriptionTrueUpLogEntryListRelationFilter>;
  retryAt?: Maybe<DateTimeNullableFilter>;
  shouldCancelEnrollment?: Maybe<BoolFilter>;
  slackMessageTimestamp?: Maybe<StringNullableFilter>;
  stripeInvoice?: Maybe<StripeInvoiceNullableScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  subscriptionEnrollmentAndDueAt?: Maybe<CareSubscriptionTrueUpSubscriptionEnrollmentAndDueAtCompoundUniqueInput>;
  type?: Maybe<EnumCareSubscriptionTrueUpTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChangeCareSubscriptionPaymentMethodInput = {
  careStripePaymentMethodId: Scalars['String'];
  careStripeSubscriptionId: Scalars['String'];
};

export type ChangeCareSubscriptionPaymentMethodOutput = {
  __typename?: 'ChangeCareSubscriptionPaymentMethodOutput';
  success: Scalars['Boolean'];
};

export type Channel = {
  __typename?: 'Channel';
  HillsToHomeAPILog: Array<HillsToHomeApiLog>;
  _count: ChannelCountOutputType;
  appointments: Array<Appointment>;
  assignees: Array<User>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses: Array<ChannelAutomationStatus>;
  channelMembers: Array<ChannelMember>;
  channelPins: Array<ChannelPin>;
  channelStatus?: Maybe<ChannelStatus>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creationSource?: Maybe<ChannelCreationSource>;
  currentWorkflowAction?: Maybe<WorkflowEventAction>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions: Array<FinancialTransaction>;
  friendlyName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessage>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages: Array<ChannelMessage>;
  pets: Array<ClinicPet>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type ChannelHillsToHomeApiLogArgs = {
  cursor?: Maybe<HillsToHomeApiLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<HillsToHomeApiLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<HillsToHomeApiLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<HillsToHomeApiLogWhereInput>;
};


export type ChannelAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type ChannelAssigneesArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type ChannelAutomationStatusesArgs = {
  cursor?: Maybe<ChannelAutomationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelAutomationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelAutomationStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type ChannelChannelMembersArgs = {
  cursor?: Maybe<ChannelMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMemberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMemberWhereInput>;
};


export type ChannelChannelPinsArgs = {
  cursor?: Maybe<ChannelPinWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelPinScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelPinOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelPinWhereInput>;
};


export type ChannelChannelStatusArgs = {
  where?: Maybe<ChannelStatusWhereInput>;
};


export type ChannelClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type ChannelCreationSourceArgs = {
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type ChannelCurrentWorkflowActionArgs = {
  where?: Maybe<WorkflowEventActionWhereInput>;
};


export type ChannelFinancialTransactionsArgs = {
  cursor?: Maybe<FinancialTransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FinancialTransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FinancialTransactionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type ChannelLastMessageArgs = {
  where?: Maybe<ChannelMessageWhereInput>;
};


export type ChannelMessagesArgs = {
  cursor?: Maybe<ChannelMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageWhereInput>;
};


export type ChannelPetsArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ChannelAutomationStatus = {
  __typename?: 'ChannelAutomationStatus';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel: Channel;
  channelId: Scalars['String'];
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  currentWorkflowEventAction?: Maybe<WorkflowEventAction>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmission>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  serviceReminder?: Maybe<ServiceReminder>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status: AutomationStatus;
  updatedAt: Scalars['DateTime'];
  workflowEventSetting: WorkflowEventSetting;
  workflowEventSettingId: Scalars['String'];
};


export type ChannelAutomationStatusAppointmentArgs = {
  where?: Maybe<AppointmentWhereInput>;
};


export type ChannelAutomationStatusClinicPetArgs = {
  where?: Maybe<ClinicPetWhereInput>;
};


export type ChannelAutomationStatusClinicWidgetRequestArgs = {
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type ChannelAutomationStatusCurrentWorkflowEventActionArgs = {
  where?: Maybe<WorkflowEventActionWhereInput>;
};


export type ChannelAutomationStatusFormSubmissionArgs = {
  where?: Maybe<FormSubmissionWhereInput>;
};


export type ChannelAutomationStatusServiceReminderArgs = {
  where?: Maybe<ServiceReminderWhereInput>;
};

export type ChannelAutomationStatusCountAggregateOutputType = {
  __typename?: 'ChannelAutomationStatusCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentId: Scalars['Int'];
  cancelledAt: Scalars['Int'];
  channelId: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  clinicWidgetRequestId: Scalars['Int'];
  clinicWidgetRequestTypeId: Scalars['Int'];
  completedAt: Scalars['Int'];
  createdAt: Scalars['Int'];
  currentWorkflowEventActionId: Scalars['Int'];
  expiredAt: Scalars['Int'];
  formSubmissionId: Scalars['Int'];
  id: Scalars['Int'];
  serviceReminderId: Scalars['Int'];
  startedAt: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
  workflowEventSettingId: Scalars['Int'];
};

export type ChannelAutomationStatusCountOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentWorkflowEventActionId?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type ChannelAutomationStatusCreateInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutChannelAutomationStatusesInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel: ChannelCreateNestedOneWithoutAutomationStatusesInput;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelAutomationStatusesInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting: WorkflowEventSettingCreateNestedOneWithoutChannelAutomationStatusesInput;
};

export type ChannelAutomationStatusCreateManyAppointmentInput = {
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusCreateManyAppointmentInputEnvelope = {
  data: Array<ChannelAutomationStatusCreateManyAppointmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelAutomationStatusCreateManyChannelInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusCreateManyChannelInputEnvelope = {
  data: Array<ChannelAutomationStatusCreateManyChannelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelAutomationStatusCreateManyClinicPetInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusCreateManyClinicPetInputEnvelope = {
  data: Array<ChannelAutomationStatusCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelAutomationStatusCreateManyClinicWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusCreateManyClinicWidgetRequestInputEnvelope = {
  data: Array<ChannelAutomationStatusCreateManyClinicWidgetRequestInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelAutomationStatusCreateManyCurrentWorkflowEventActionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusCreateManyCurrentWorkflowEventActionInputEnvelope = {
  data: Array<ChannelAutomationStatusCreateManyCurrentWorkflowEventActionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelAutomationStatusCreateManyFormSubmissionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusCreateManyFormSubmissionInputEnvelope = {
  data: Array<ChannelAutomationStatusCreateManyFormSubmissionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelAutomationStatusCreateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusCreateManyServiceReminderInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusCreateManyServiceReminderInputEnvelope = {
  data: Array<ChannelAutomationStatusCreateManyServiceReminderInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelAutomationStatusCreateManyWorkflowEventSettingInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelAutomationStatusCreateManyWorkflowEventSettingInputEnvelope = {
  data: Array<ChannelAutomationStatusCreateManyWorkflowEventSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelAutomationStatusCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutAppointmentInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyAppointmentInputEnvelope>;
};

export type ChannelAutomationStatusCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyChannelInputEnvelope>;
};

export type ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyClinicPetInputEnvelope>;
};

export type ChannelAutomationStatusCreateNestedManyWithoutClinicWidgetRequestInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyClinicWidgetRequestInputEnvelope>;
};

export type ChannelAutomationStatusCreateNestedManyWithoutCurrentWorkflowEventActionInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutCurrentWorkflowEventActionInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutCurrentWorkflowEventActionInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyCurrentWorkflowEventActionInputEnvelope>;
};

export type ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyFormSubmissionInputEnvelope>;
};

export type ChannelAutomationStatusCreateNestedManyWithoutServiceReminderInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyServiceReminderInputEnvelope>;
};

export type ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyWorkflowEventSettingInputEnvelope>;
};

export type ChannelAutomationStatusCreateOrConnectWithoutAppointmentInput = {
  create: ChannelAutomationStatusCreateWithoutAppointmentInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusCreateOrConnectWithoutChannelInput = {
  create: ChannelAutomationStatusCreateWithoutChannelInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusCreateOrConnectWithoutClinicPetInput = {
  create: ChannelAutomationStatusCreateWithoutClinicPetInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusCreateOrConnectWithoutClinicWidgetRequestInput = {
  create: ChannelAutomationStatusCreateWithoutClinicWidgetRequestInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusCreateOrConnectWithoutCurrentWorkflowEventActionInput = {
  create: ChannelAutomationStatusCreateWithoutCurrentWorkflowEventActionInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusCreateOrConnectWithoutFormSubmissionInput = {
  create: ChannelAutomationStatusCreateWithoutFormSubmissionInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusCreateOrConnectWithoutServiceReminderInput = {
  create: ChannelAutomationStatusCreateWithoutServiceReminderInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusCreateOrConnectWithoutWorkflowEventSettingInput = {
  create: ChannelAutomationStatusCreateWithoutWorkflowEventSettingInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusCreateWithoutAppointmentInput = {
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel: ChannelCreateNestedOneWithoutAutomationStatusesInput;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelAutomationStatusesInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting: WorkflowEventSettingCreateNestedOneWithoutChannelAutomationStatusesInput;
};

export type ChannelAutomationStatusCreateWithoutChannelInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutChannelAutomationStatusesInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelAutomationStatusesInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting: WorkflowEventSettingCreateNestedOneWithoutChannelAutomationStatusesInput;
};

export type ChannelAutomationStatusCreateWithoutClinicPetInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutChannelAutomationStatusesInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel: ChannelCreateNestedOneWithoutAutomationStatusesInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelAutomationStatusesInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting: WorkflowEventSettingCreateNestedOneWithoutChannelAutomationStatusesInput;
};

export type ChannelAutomationStatusCreateWithoutClinicWidgetRequestInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutChannelAutomationStatusesInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel: ChannelCreateNestedOneWithoutAutomationStatusesInput;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelAutomationStatusesInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting: WorkflowEventSettingCreateNestedOneWithoutChannelAutomationStatusesInput;
};

export type ChannelAutomationStatusCreateWithoutCurrentWorkflowEventActionInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutChannelAutomationStatusesInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel: ChannelCreateNestedOneWithoutAutomationStatusesInput;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelAutomationStatusesInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting: WorkflowEventSettingCreateNestedOneWithoutChannelAutomationStatusesInput;
};

export type ChannelAutomationStatusCreateWithoutFormSubmissionInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutChannelAutomationStatusesInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel: ChannelCreateNestedOneWithoutAutomationStatusesInput;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelAutomationStatusesInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting: WorkflowEventSettingCreateNestedOneWithoutChannelAutomationStatusesInput;
};

export type ChannelAutomationStatusCreateWithoutServiceReminderInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutChannelAutomationStatusesInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel: ChannelCreateNestedOneWithoutAutomationStatusesInput;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  id?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting: WorkflowEventSettingCreateNestedOneWithoutChannelAutomationStatusesInput;
};

export type ChannelAutomationStatusCreateWithoutWorkflowEventSettingInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutChannelAutomationStatusesInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel: ChannelCreateNestedOneWithoutAutomationStatusesInput;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelAutomationStatusesInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelAutomationStatusesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelAutomationStatusesInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelAutomationStatusGroupByOutputType = {
  __typename?: 'ChannelAutomationStatusGroupByOutputType';
  _count?: Maybe<ChannelAutomationStatusCountAggregateOutputType>;
  _max?: Maybe<ChannelAutomationStatusMaxAggregateOutputType>;
  _min?: Maybe<ChannelAutomationStatusMinAggregateOutputType>;
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status: AutomationStatus;
  updatedAt: Scalars['DateTime'];
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusListRelationFilter = {
  every?: Maybe<ChannelAutomationStatusWhereInput>;
  none?: Maybe<ChannelAutomationStatusWhereInput>;
  some?: Maybe<ChannelAutomationStatusWhereInput>;
};

export type ChannelAutomationStatusMaxAggregateOutputType = {
  __typename?: 'ChannelAutomationStatusMaxAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusMaxOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentWorkflowEventActionId?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type ChannelAutomationStatusMinAggregateOutputType = {
  __typename?: 'ChannelAutomationStatusMinAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusMinOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentWorkflowEventActionId?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type ChannelAutomationStatusOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelAutomationStatusOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelAutomationStatusOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionOrderByWithRelationInput>;
  currentWorkflowEventActionId?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminder?: Maybe<ServiceReminderOrderByWithRelationInput>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSetting?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export enum ChannelAutomationStatusOrderByRelevanceFieldEnum {
  AppointmentId = 'appointmentId',
  ChannelId = 'channelId',
  ClinicPetId = 'clinicPetId',
  ClinicWidgetRequestId = 'clinicWidgetRequestId',
  ClinicWidgetRequestTypeId = 'clinicWidgetRequestTypeId',
  CurrentWorkflowEventActionId = 'currentWorkflowEventActionId',
  FormSubmissionId = 'formSubmissionId',
  Id = 'id',
  ServiceReminderId = 'serviceReminderId',
  WorkflowEventSettingId = 'workflowEventSettingId'
}

export type ChannelAutomationStatusOrderByRelevanceInput = {
  fields: Array<ChannelAutomationStatusOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelAutomationStatusOrderByWithAggregationInput = {
  _count?: Maybe<ChannelAutomationStatusCountOrderByAggregateInput>;
  _max?: Maybe<ChannelAutomationStatusMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelAutomationStatusMinOrderByAggregateInput>;
  appointmentId?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentWorkflowEventActionId?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type ChannelAutomationStatusOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelAutomationStatusOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionOrderByWithRelationInput>;
  currentWorkflowEventActionId?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminder?: Maybe<ServiceReminderOrderByWithRelationInput>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSetting?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type ChannelAutomationStatusOrderByWithRelationInput = {
  _relevance?: Maybe<ChannelAutomationStatusOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionOrderByWithRelationInput>;
  currentWorkflowEventActionId?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminder?: Maybe<ServiceReminderOrderByWithRelationInput>;
  serviceReminderId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSetting?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export enum ChannelAutomationStatusScalarFieldEnum {
  AppointmentId = 'appointmentId',
  CancelledAt = 'cancelledAt',
  ChannelId = 'channelId',
  ClinicPetId = 'clinicPetId',
  ClinicWidgetRequestId = 'clinicWidgetRequestId',
  ClinicWidgetRequestTypeId = 'clinicWidgetRequestTypeId',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  CurrentWorkflowEventActionId = 'currentWorkflowEventActionId',
  ExpiredAt = 'expiredAt',
  FormSubmissionId = 'formSubmissionId',
  Id = 'id',
  ServiceReminderId = 'serviceReminderId',
  StartedAt = 'startedAt',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  WorkflowEventSettingId = 'workflowEventSettingId'
}

export type ChannelAutomationStatusScalarWhereInput = {
  AND?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  OR?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  appointmentId?: Maybe<StringNullableFilter>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  channelId?: Maybe<StringFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestTypeId?: Maybe<StringNullableFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentWorkflowEventActionId?: Maybe<StringNullableFilter>;
  expiredAt?: Maybe<DateTimeNullableFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  serviceReminderId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumAutomationStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSettingId?: Maybe<StringFilter>;
};

export type ChannelAutomationStatusScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelAutomationStatusScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelAutomationStatusScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelAutomationStatusScalarWhereWithAggregatesInput>>;
  appointmentId?: Maybe<StringNullableWithAggregatesFilter>;
  cancelledAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  channelId?: Maybe<StringWithAggregatesFilter>;
  clinicPetId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicWidgetRequestTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  completedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  currentWorkflowEventActionId?: Maybe<StringNullableWithAggregatesFilter>;
  expiredAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  formSubmissionId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  serviceReminderId?: Maybe<StringNullableWithAggregatesFilter>;
  startedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  status?: Maybe<EnumAutomationStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  workflowEventSettingId?: Maybe<StringWithAggregatesFilter>;
};

export type ChannelAutomationStatusUncheckedCreateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusUncheckedCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutAppointmentInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyAppointmentInputEnvelope>;
};

export type ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyChannelInputEnvelope>;
};

export type ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyClinicPetInputEnvelope>;
};

export type ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicWidgetRequestInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyClinicWidgetRequestInputEnvelope>;
};

export type ChannelAutomationStatusUncheckedCreateNestedManyWithoutCurrentWorkflowEventActionInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutCurrentWorkflowEventActionInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutCurrentWorkflowEventActionInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyCurrentWorkflowEventActionInputEnvelope>;
};

export type ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyFormSubmissionInputEnvelope>;
};

export type ChannelAutomationStatusUncheckedCreateNestedManyWithoutServiceReminderInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyServiceReminderInputEnvelope>;
};

export type ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyWorkflowEventSettingInputEnvelope>;
};

export type ChannelAutomationStatusUncheckedCreateWithoutAppointmentInput = {
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusUncheckedCreateWithoutChannelInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusUncheckedCreateWithoutClinicPetInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusUncheckedCreateWithoutClinicWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusUncheckedCreateWithoutCurrentWorkflowEventActionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusUncheckedCreateWithoutFormSubmissionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusUncheckedCreateWithoutServiceReminderInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId: Scalars['String'];
};

export type ChannelAutomationStatusUncheckedCreateWithoutWorkflowEventSettingInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelAutomationStatusUncheckedUpdateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentInput = {
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutAppointmentInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutChannelInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutClinicWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyClinicWidgetRequestInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutClinicWidgetRequestInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutClinicWidgetRequestInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutClinicWidgetRequestInput>>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutCurrentWorkflowEventActionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutCurrentWorkflowEventActionNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutCurrentWorkflowEventActionInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutCurrentWorkflowEventActionInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyCurrentWorkflowEventActionInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutCurrentWorkflowEventActionInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutCurrentWorkflowEventActionInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutCurrentWorkflowEventActionInput>>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyFormSubmissionInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutFormSubmissionInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutFormSubmissionInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutFormSubmissionInput>>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutServiceReminderInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutServiceReminderNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyServiceReminderInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutServiceReminderInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutServiceReminderInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutServiceReminderInput>>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyWorkflowEventSettingInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutWorkflowEventSettingInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutWorkflowEventSettingInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutWorkflowEventSettingInput>>;
};

export type ChannelAutomationStatusUncheckedUpdateWithoutAppointmentInput = {
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateWithoutChannelInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateWithoutClinicPetInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateWithoutClinicWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateWithoutCurrentWorkflowEventActionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateWithoutFormSubmissionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateWithoutServiceReminderInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelAutomationStatusUncheckedUpdateWithoutWorkflowEventSettingInput = {
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelAutomationStatusUpdateInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<ChannelUpdateOneRequiredWithoutAutomationStatusesNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutChannelAutomationStatusesNestedInput>;
};

export type ChannelAutomationStatusUpdateManyMutationInput = {
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelAutomationStatusUpdateManyWithWhereWithoutAppointmentInput = {
  data: ChannelAutomationStatusUpdateManyMutationInput;
  where: ChannelAutomationStatusScalarWhereInput;
};

export type ChannelAutomationStatusUpdateManyWithWhereWithoutChannelInput = {
  data: ChannelAutomationStatusUpdateManyMutationInput;
  where: ChannelAutomationStatusScalarWhereInput;
};

export type ChannelAutomationStatusUpdateManyWithWhereWithoutClinicPetInput = {
  data: ChannelAutomationStatusUpdateManyMutationInput;
  where: ChannelAutomationStatusScalarWhereInput;
};

export type ChannelAutomationStatusUpdateManyWithWhereWithoutClinicWidgetRequestInput = {
  data: ChannelAutomationStatusUpdateManyMutationInput;
  where: ChannelAutomationStatusScalarWhereInput;
};

export type ChannelAutomationStatusUpdateManyWithWhereWithoutCurrentWorkflowEventActionInput = {
  data: ChannelAutomationStatusUpdateManyMutationInput;
  where: ChannelAutomationStatusScalarWhereInput;
};

export type ChannelAutomationStatusUpdateManyWithWhereWithoutFormSubmissionInput = {
  data: ChannelAutomationStatusUpdateManyMutationInput;
  where: ChannelAutomationStatusScalarWhereInput;
};

export type ChannelAutomationStatusUpdateManyWithWhereWithoutServiceReminderInput = {
  data: ChannelAutomationStatusUpdateManyMutationInput;
  where: ChannelAutomationStatusScalarWhereInput;
};

export type ChannelAutomationStatusUpdateManyWithWhereWithoutWorkflowEventSettingInput = {
  data: ChannelAutomationStatusUpdateManyMutationInput;
  where: ChannelAutomationStatusScalarWhereInput;
};

export type ChannelAutomationStatusUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutAppointmentInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type ChannelAutomationStatusUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type ChannelAutomationStatusUpdateManyWithoutClinicWidgetRequestNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyClinicWidgetRequestInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutClinicWidgetRequestInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutClinicWidgetRequestInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutClinicWidgetRequestInput>>;
};

export type ChannelAutomationStatusUpdateManyWithoutCurrentWorkflowEventActionNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutCurrentWorkflowEventActionInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutCurrentWorkflowEventActionInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyCurrentWorkflowEventActionInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutCurrentWorkflowEventActionInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutCurrentWorkflowEventActionInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutCurrentWorkflowEventActionInput>>;
};

export type ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyFormSubmissionInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutFormSubmissionInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutFormSubmissionInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutFormSubmissionInput>>;
};

export type ChannelAutomationStatusUpdateManyWithoutServiceReminderNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyServiceReminderInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutServiceReminderInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutServiceReminderInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutServiceReminderInput>>;
};

export type ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput = {
  connect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelAutomationStatusCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<ChannelAutomationStatusCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<ChannelAutomationStatusCreateManyWorkflowEventSettingInputEnvelope>;
  delete?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelAutomationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelAutomationStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelAutomationStatusUpdateWithWhereUniqueWithoutWorkflowEventSettingInput>>;
  updateMany?: Maybe<Array<ChannelAutomationStatusUpdateManyWithWhereWithoutWorkflowEventSettingInput>>;
  upsert?: Maybe<Array<ChannelAutomationStatusUpsertWithWhereUniqueWithoutWorkflowEventSettingInput>>;
};

export type ChannelAutomationStatusUpdateWithWhereUniqueWithoutAppointmentInput = {
  data: ChannelAutomationStatusUpdateWithoutAppointmentInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpdateWithWhereUniqueWithoutChannelInput = {
  data: ChannelAutomationStatusUpdateWithoutChannelInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: ChannelAutomationStatusUpdateWithoutClinicPetInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpdateWithWhereUniqueWithoutClinicWidgetRequestInput = {
  data: ChannelAutomationStatusUpdateWithoutClinicWidgetRequestInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpdateWithWhereUniqueWithoutCurrentWorkflowEventActionInput = {
  data: ChannelAutomationStatusUpdateWithoutCurrentWorkflowEventActionInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpdateWithWhereUniqueWithoutFormSubmissionInput = {
  data: ChannelAutomationStatusUpdateWithoutFormSubmissionInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpdateWithWhereUniqueWithoutServiceReminderInput = {
  data: ChannelAutomationStatusUpdateWithoutServiceReminderInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpdateWithWhereUniqueWithoutWorkflowEventSettingInput = {
  data: ChannelAutomationStatusUpdateWithoutWorkflowEventSettingInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpdateWithoutAppointmentInput = {
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<ChannelUpdateOneRequiredWithoutAutomationStatusesNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutChannelAutomationStatusesNestedInput>;
};

export type ChannelAutomationStatusUpdateWithoutChannelInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutChannelAutomationStatusesNestedInput>;
};

export type ChannelAutomationStatusUpdateWithoutClinicPetInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<ChannelUpdateOneRequiredWithoutAutomationStatusesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutChannelAutomationStatusesNestedInput>;
};

export type ChannelAutomationStatusUpdateWithoutClinicWidgetRequestInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<ChannelUpdateOneRequiredWithoutAutomationStatusesNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutChannelAutomationStatusesNestedInput>;
};

export type ChannelAutomationStatusUpdateWithoutCurrentWorkflowEventActionInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<ChannelUpdateOneRequiredWithoutAutomationStatusesNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutChannelAutomationStatusesNestedInput>;
};

export type ChannelAutomationStatusUpdateWithoutFormSubmissionInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<ChannelUpdateOneRequiredWithoutAutomationStatusesNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutChannelAutomationStatusesNestedInput>;
};

export type ChannelAutomationStatusUpdateWithoutServiceReminderInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<ChannelUpdateOneRequiredWithoutAutomationStatusesNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  id?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutChannelAutomationStatusesNestedInput>;
};

export type ChannelAutomationStatusUpdateWithoutWorkflowEventSettingInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<ChannelUpdateOneRequiredWithoutAutomationStatusesNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelAutomationStatusesNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<AutomationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelAutomationStatusUpsertWithWhereUniqueWithoutAppointmentInput = {
  create: ChannelAutomationStatusCreateWithoutAppointmentInput;
  update: ChannelAutomationStatusUpdateWithoutAppointmentInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpsertWithWhereUniqueWithoutChannelInput = {
  create: ChannelAutomationStatusCreateWithoutChannelInput;
  update: ChannelAutomationStatusUpdateWithoutChannelInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: ChannelAutomationStatusCreateWithoutClinicPetInput;
  update: ChannelAutomationStatusUpdateWithoutClinicPetInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpsertWithWhereUniqueWithoutClinicWidgetRequestInput = {
  create: ChannelAutomationStatusCreateWithoutClinicWidgetRequestInput;
  update: ChannelAutomationStatusUpdateWithoutClinicWidgetRequestInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpsertWithWhereUniqueWithoutCurrentWorkflowEventActionInput = {
  create: ChannelAutomationStatusCreateWithoutCurrentWorkflowEventActionInput;
  update: ChannelAutomationStatusUpdateWithoutCurrentWorkflowEventActionInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpsertWithWhereUniqueWithoutFormSubmissionInput = {
  create: ChannelAutomationStatusCreateWithoutFormSubmissionInput;
  update: ChannelAutomationStatusUpdateWithoutFormSubmissionInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpsertWithWhereUniqueWithoutServiceReminderInput = {
  create: ChannelAutomationStatusCreateWithoutServiceReminderInput;
  update: ChannelAutomationStatusUpdateWithoutServiceReminderInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusUpsertWithWhereUniqueWithoutWorkflowEventSettingInput = {
  create: ChannelAutomationStatusCreateWithoutWorkflowEventSettingInput;
  update: ChannelAutomationStatusUpdateWithoutWorkflowEventSettingInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};

export type ChannelAutomationStatusWhereInput = {
  AND?: Maybe<Array<ChannelAutomationStatusWhereInput>>;
  NOT?: Maybe<Array<ChannelAutomationStatusWhereInput>>;
  OR?: Maybe<Array<ChannelAutomationStatusWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  channel?: Maybe<ChannelScalarRelationFilter>;
  channelId?: Maybe<StringFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestTypeId?: Maybe<StringNullableFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  currentWorkflowEventActionId?: Maybe<StringNullableFilter>;
  expiredAt?: Maybe<DateTimeNullableFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  serviceReminder?: Maybe<ServiceReminderNullableScalarRelationFilter>;
  serviceReminderId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumAutomationStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSetting?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  workflowEventSettingId?: Maybe<StringFilter>;
};

export type ChannelAutomationStatusWhereUniqueInput = {
  AND?: Maybe<Array<ChannelAutomationStatusWhereInput>>;
  NOT?: Maybe<Array<ChannelAutomationStatusWhereInput>>;
  OR?: Maybe<Array<ChannelAutomationStatusWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  channel?: Maybe<ChannelScalarRelationFilter>;
  channelId?: Maybe<StringFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestTypeId?: Maybe<StringNullableFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentWorkflowEventAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  currentWorkflowEventActionId?: Maybe<StringNullableFilter>;
  expiredAt?: Maybe<DateTimeNullableFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderNullableScalarRelationFilter>;
  serviceReminderId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumAutomationStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSetting?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  workflowEventSettingId?: Maybe<StringFilter>;
};

export type ChannelCountAggregateOutputType = {
  __typename?: 'ChannelCountAggregateOutputType';
  _all: Scalars['Int'];
  attributes: Scalars['Int'];
  channelStatusId: Scalars['Int'];
  channelType: Scalars['Int'];
  channelVisibility: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  currentWorkflowActionId: Scalars['Int'];
  friendlyName: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  lastExportAt: Scalars['Int'];
  lastMessageId: Scalars['Int'];
  tags: Scalars['Int'];
  twilioChannelSid: Scalars['Int'];
  uniqueName: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ChannelCountOrderByAggregateInput = {
  attributes?: Maybe<SortOrder>;
  channelStatusId?: Maybe<SortOrder>;
  channelType?: Maybe<SortOrder>;
  channelVisibility?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentWorkflowActionId?: Maybe<SortOrder>;
  friendlyName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastExportAt?: Maybe<SortOrder>;
  lastMessageId?: Maybe<SortOrder>;
  tags?: Maybe<SortOrder>;
  twilioChannelSid?: Maybe<SortOrder>;
  uniqueName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelCountOutputType = {
  __typename?: 'ChannelCountOutputType';
  HillsToHomeAPILog: Scalars['Int'];
  appointments: Scalars['Int'];
  assignees: Scalars['Int'];
  automationStatuses: Scalars['Int'];
  channelMembers: Scalars['Int'];
  channelPins: Scalars['Int'];
  financialTransactions: Scalars['Int'];
  messages: Scalars['Int'];
  pets: Scalars['Int'];
};

export type ChannelCountResult = {
  __typename?: 'ChannelCountResult';
  total: Scalars['Int'];
  unreadChannels: Array<UnreadMessageChannel>;
};

export type ChannelCreateInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateManyChannelStatusInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateManyChannelStatusInputEnvelope = {
  data: Array<ChannelCreateManyChannelStatusInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelCreateManyClinicInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateManyClinicInputEnvelope = {
  data: Array<ChannelCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelCreateManyCurrentWorkflowActionInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateManyCurrentWorkflowActionInputEnvelope = {
  data: Array<ChannelCreateManyCurrentWorkflowActionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelCreateManyInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateManyLastMessageInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateManyLastMessageInputEnvelope = {
  data: Array<ChannelCreateManyLastMessageInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelCreateNestedManyWithoutAssigneesInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<ChannelCreateWithoutAssigneesInput>>;
};

export type ChannelCreateNestedManyWithoutChannelStatusInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<ChannelCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<ChannelCreateManyChannelStatusInputEnvelope>;
};

export type ChannelCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ChannelCreateWithoutClinicInput>>;
  createMany?: Maybe<ChannelCreateManyClinicInputEnvelope>;
};

export type ChannelCreateNestedManyWithoutCurrentWorkflowActionInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutCurrentWorkflowActionInput>>;
  create?: Maybe<Array<ChannelCreateWithoutCurrentWorkflowActionInput>>;
  createMany?: Maybe<ChannelCreateManyCurrentWorkflowActionInputEnvelope>;
};

export type ChannelCreateNestedManyWithoutLastMessageInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutLastMessageInput>>;
  create?: Maybe<Array<ChannelCreateWithoutLastMessageInput>>;
  createMany?: Maybe<ChannelCreateManyLastMessageInputEnvelope>;
};

export type ChannelCreateNestedManyWithoutPetsInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutPetsInput>>;
  create?: Maybe<Array<ChannelCreateWithoutPetsInput>>;
};

export type ChannelCreateNestedOneWithoutAppointmentsInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<ChannelCreateWithoutAppointmentsInput>;
};

export type ChannelCreateNestedOneWithoutAutomationStatusesInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutAutomationStatusesInput>;
  create?: Maybe<ChannelCreateWithoutAutomationStatusesInput>;
};

export type ChannelCreateNestedOneWithoutChannelMembersInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutChannelMembersInput>;
  create?: Maybe<ChannelCreateWithoutChannelMembersInput>;
};

export type ChannelCreateNestedOneWithoutChannelPinsInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutChannelPinsInput>;
  create?: Maybe<ChannelCreateWithoutChannelPinsInput>;
};

export type ChannelCreateNestedOneWithoutCreationSourceInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutCreationSourceInput>;
  create?: Maybe<ChannelCreateWithoutCreationSourceInput>;
};

export type ChannelCreateNestedOneWithoutFinancialTransactionsInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutFinancialTransactionsInput>;
  create?: Maybe<ChannelCreateWithoutFinancialTransactionsInput>;
};

export type ChannelCreateNestedOneWithoutHillsToHomeApiLogInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutHillsToHomeApiLogInput>;
  create?: Maybe<ChannelCreateWithoutHillsToHomeApiLogInput>;
};

export type ChannelCreateNestedOneWithoutMessagesInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutMessagesInput>;
  create?: Maybe<ChannelCreateWithoutMessagesInput>;
};

export type ChannelCreateOrConnectWithoutAppointmentsInput = {
  create: ChannelCreateWithoutAppointmentsInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutAssigneesInput = {
  create: ChannelCreateWithoutAssigneesInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutAutomationStatusesInput = {
  create: ChannelCreateWithoutAutomationStatusesInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutChannelMembersInput = {
  create: ChannelCreateWithoutChannelMembersInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutChannelPinsInput = {
  create: ChannelCreateWithoutChannelPinsInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutChannelStatusInput = {
  create: ChannelCreateWithoutChannelStatusInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutClinicInput = {
  create: ChannelCreateWithoutClinicInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutCreationSourceInput = {
  create: ChannelCreateWithoutCreationSourceInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutCurrentWorkflowActionInput = {
  create: ChannelCreateWithoutCurrentWorkflowActionInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutFinancialTransactionsInput = {
  create: ChannelCreateWithoutFinancialTransactionsInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutHillsToHomeApiLogInput = {
  create: ChannelCreateWithoutHillsToHomeApiLogInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutLastMessageInput = {
  create: ChannelCreateWithoutLastMessageInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutMessagesInput = {
  create: ChannelCreateWithoutMessagesInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateOrConnectWithoutPetsInput = {
  create: ChannelCreateWithoutPetsInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelCreateWithoutAppointmentsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutAssigneesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutAutomationStatusesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutChannelMembersInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutChannelPinsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutChannelStatusInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutClinicInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutCreationSourceInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutCurrentWorkflowActionInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutFinancialTransactionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutHillsToHomeApiLogInput = {
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutLastMessageInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutMessagesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreateWithoutPetsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinCreateNestedManyWithoutChannelInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutChannelsInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutChannelsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceCreateNestedOneWithoutChannelInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionCreateNestedOneWithoutChannelsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageCreateNestedOneWithoutLastMessageChannelInput>;
  messages?: Maybe<ChannelMessageCreateNestedManyWithoutChannelInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelCreationSource = {
  __typename?: 'ChannelCreationSource';
  channel: Channel;
  channelId: Scalars['String'];
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creationSource: ChannelCreationSourceType;
  formSubmission?: Maybe<FormSubmission>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  serviceReminder?: Maybe<ServiceReminder>;
  serviceReminderId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSetting?: Maybe<WorkflowEventSetting>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};


export type ChannelCreationSourceClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type ChannelCreationSourceClinicWidgetRequestArgs = {
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type ChannelCreationSourceFormSubmissionArgs = {
  where?: Maybe<FormSubmissionWhereInput>;
};


export type ChannelCreationSourceServiceReminderArgs = {
  where?: Maybe<ServiceReminderWhereInput>;
};


export type ChannelCreationSourceUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type ChannelCreationSourceWorkflowEventSettingArgs = {
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type ChannelCreationSourceCountAggregateOutputType = {
  __typename?: 'ChannelCreationSourceCountAggregateOutputType';
  _all: Scalars['Int'];
  channelId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  clinicWidgetRequestId: Scalars['Int'];
  createdAt: Scalars['Int'];
  creationSource: Scalars['Int'];
  formSubmissionId: Scalars['Int'];
  id: Scalars['Int'];
  serviceReminderId: Scalars['Int'];
  userId: Scalars['Int'];
  workflowEventSettingId: Scalars['Int'];
};

export type ChannelCreationSourceCountOrderByAggregateInput = {
  channelId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type ChannelCreationSourceCreateInput = {
  channel: ChannelCreateNestedOneWithoutCreationSourceInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutChannelCreationSourcesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelCreationSourcesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelCreationSourcesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelCreationSourcesInput>;
  user?: Maybe<UserCreateNestedOneWithoutChannelCreationSourcesInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutChannelCreationSourcesInput>;
};

export type ChannelCreationSourceCreateManyClinicPetParentInput = {
  channelId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceCreateManyClinicPetParentInputEnvelope = {
  data: Array<ChannelCreationSourceCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelCreationSourceCreateManyClinicWidgetRequestInput = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceCreateManyClinicWidgetRequestInputEnvelope = {
  data: Array<ChannelCreationSourceCreateManyClinicWidgetRequestInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelCreationSourceCreateManyFormSubmissionInput = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceCreateManyFormSubmissionInputEnvelope = {
  data: Array<ChannelCreationSourceCreateManyFormSubmissionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelCreationSourceCreateManyInput = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceCreateManyServiceReminderInput = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceCreateManyServiceReminderInputEnvelope = {
  data: Array<ChannelCreationSourceCreateManyServiceReminderInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelCreationSourceCreateManyUserInput = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceCreateManyUserInputEnvelope = {
  data: Array<ChannelCreationSourceCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelCreationSourceCreateManyWorkflowEventSettingInput = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceCreateManyWorkflowEventSettingInputEnvelope = {
  data: Array<ChannelCreationSourceCreateManyWorkflowEventSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyClinicPetParentInputEnvelope>;
};

export type ChannelCreationSourceCreateNestedManyWithoutClinicWidgetRequestInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyClinicWidgetRequestInputEnvelope>;
};

export type ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyFormSubmissionInputEnvelope>;
};

export type ChannelCreationSourceCreateNestedManyWithoutServiceReminderInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyServiceReminderInputEnvelope>;
};

export type ChannelCreationSourceCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyUserInputEnvelope>;
};

export type ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyWorkflowEventSettingInputEnvelope>;
};

export type ChannelCreationSourceCreateNestedOneWithoutChannelInput = {
  connect?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreationSourceCreateOrConnectWithoutChannelInput>;
  create?: Maybe<ChannelCreationSourceCreateWithoutChannelInput>;
};

export type ChannelCreationSourceCreateOrConnectWithoutChannelInput = {
  create: ChannelCreationSourceCreateWithoutChannelInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceCreateOrConnectWithoutClinicPetParentInput = {
  create: ChannelCreationSourceCreateWithoutClinicPetParentInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceCreateOrConnectWithoutClinicWidgetRequestInput = {
  create: ChannelCreationSourceCreateWithoutClinicWidgetRequestInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceCreateOrConnectWithoutFormSubmissionInput = {
  create: ChannelCreationSourceCreateWithoutFormSubmissionInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceCreateOrConnectWithoutServiceReminderInput = {
  create: ChannelCreationSourceCreateWithoutServiceReminderInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceCreateOrConnectWithoutUserInput = {
  create: ChannelCreationSourceCreateWithoutUserInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceCreateOrConnectWithoutWorkflowEventSettingInput = {
  create: ChannelCreationSourceCreateWithoutWorkflowEventSettingInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceCreateWithoutChannelInput = {
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutChannelCreationSourcesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelCreationSourcesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelCreationSourcesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelCreationSourcesInput>;
  user?: Maybe<UserCreateNestedOneWithoutChannelCreationSourcesInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutChannelCreationSourcesInput>;
};

export type ChannelCreationSourceCreateWithoutClinicPetParentInput = {
  channel: ChannelCreateNestedOneWithoutCreationSourceInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelCreationSourcesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelCreationSourcesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelCreationSourcesInput>;
  user?: Maybe<UserCreateNestedOneWithoutChannelCreationSourcesInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutChannelCreationSourcesInput>;
};

export type ChannelCreationSourceCreateWithoutClinicWidgetRequestInput = {
  channel: ChannelCreateNestedOneWithoutCreationSourceInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutChannelCreationSourcesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelCreationSourcesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelCreationSourcesInput>;
  user?: Maybe<UserCreateNestedOneWithoutChannelCreationSourcesInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutChannelCreationSourcesInput>;
};

export type ChannelCreationSourceCreateWithoutFormSubmissionInput = {
  channel: ChannelCreateNestedOneWithoutCreationSourceInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutChannelCreationSourcesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelCreationSourcesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelCreationSourcesInput>;
  user?: Maybe<UserCreateNestedOneWithoutChannelCreationSourcesInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutChannelCreationSourcesInput>;
};

export type ChannelCreationSourceCreateWithoutServiceReminderInput = {
  channel: ChannelCreateNestedOneWithoutCreationSourceInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutChannelCreationSourcesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelCreationSourcesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelCreationSourcesInput>;
  id?: Maybe<Scalars['String']>;
  user?: Maybe<UserCreateNestedOneWithoutChannelCreationSourcesInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutChannelCreationSourcesInput>;
};

export type ChannelCreationSourceCreateWithoutUserInput = {
  channel: ChannelCreateNestedOneWithoutCreationSourceInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutChannelCreationSourcesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelCreationSourcesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelCreationSourcesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelCreationSourcesInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutChannelCreationSourcesInput>;
};

export type ChannelCreationSourceCreateWithoutWorkflowEventSettingInput = {
  channel: ChannelCreateNestedOneWithoutCreationSourceInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutChannelCreationSourcesInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutChannelCreationSourcesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutChannelCreationSourcesInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderCreateNestedOneWithoutChannelCreationSourcesInput>;
  user?: Maybe<UserCreateNestedOneWithoutChannelCreationSourcesInput>;
};

export type ChannelCreationSourceGroupByOutputType = {
  __typename?: 'ChannelCreationSourceGroupByOutputType';
  _count?: Maybe<ChannelCreationSourceCountAggregateOutputType>;
  _max?: Maybe<ChannelCreationSourceMaxAggregateOutputType>;
  _min?: Maybe<ChannelCreationSourceMinAggregateOutputType>;
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creationSource: ChannelCreationSourceType;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  creationSource: ChannelCreationSourceType;
  formSubmissionId?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceListRelationFilter = {
  every?: Maybe<ChannelCreationSourceWhereInput>;
  none?: Maybe<ChannelCreationSourceWhereInput>;
  some?: Maybe<ChannelCreationSourceWhereInput>;
};

export type ChannelCreationSourceMaxAggregateOutputType = {
  __typename?: 'ChannelCreationSourceMaxAggregateOutputType';
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceMaxOrderByAggregateInput = {
  channelId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type ChannelCreationSourceMinAggregateOutputType = {
  __typename?: 'ChannelCreationSourceMinAggregateOutputType';
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceMinOrderByAggregateInput = {
  channelId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type ChannelCreationSourceNullableScalarRelationFilter = {
  AND?: Maybe<Array<ChannelCreationSourceWhereInput>>;
  NOT?: Maybe<Array<ChannelCreationSourceWhereInput>>;
  OR?: Maybe<Array<ChannelCreationSourceWhereInput>>;
  channel?: Maybe<ChannelScalarRelationFilter>;
  channelId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<EnumChannelCreationSourceTypeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  serviceReminder?: Maybe<ServiceReminderNullableScalarRelationFilter>;
  serviceReminderId?: Maybe<StringNullableFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
  workflowEventSetting?: Maybe<WorkflowEventSettingNullableScalarRelationFilter>;
  workflowEventSettingId?: Maybe<StringNullableFilter>;
};

export type ChannelCreationSourceOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelCreationSourceOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelCreationSourceOrderByRelevanceInput>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminder?: Maybe<ServiceReminderOrderByWithRelationInput>;
  serviceReminderId?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
  workflowEventSetting?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export enum ChannelCreationSourceOrderByRelevanceFieldEnum {
  ChannelId = 'channelId',
  ClinicPetParentId = 'clinicPetParentId',
  ClinicWidgetRequestId = 'clinicWidgetRequestId',
  FormSubmissionId = 'formSubmissionId',
  Id = 'id',
  ServiceReminderId = 'serviceReminderId',
  UserId = 'userId',
  WorkflowEventSettingId = 'workflowEventSettingId'
}

export type ChannelCreationSourceOrderByRelevanceInput = {
  fields: Array<ChannelCreationSourceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelCreationSourceOrderByWithAggregationInput = {
  _count?: Maybe<ChannelCreationSourceCountOrderByAggregateInput>;
  _max?: Maybe<ChannelCreationSourceMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelCreationSourceMinOrderByAggregateInput>;
  channelId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type ChannelCreationSourceOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelCreationSourceOrderByRelevanceInput>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminder?: Maybe<ServiceReminderOrderByWithRelationInput>;
  serviceReminderId?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
  workflowEventSetting?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type ChannelCreationSourceOrderByWithRelationInput = {
  _relevance?: Maybe<ChannelCreationSourceOrderByRelevanceInput>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceReminder?: Maybe<ServiceReminderOrderByWithRelationInput>;
  serviceReminderId?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
  workflowEventSetting?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export enum ChannelCreationSourceScalarFieldEnum {
  ChannelId = 'channelId',
  ClinicPetParentId = 'clinicPetParentId',
  ClinicWidgetRequestId = 'clinicWidgetRequestId',
  CreatedAt = 'createdAt',
  CreationSource = 'creationSource',
  FormSubmissionId = 'formSubmissionId',
  Id = 'id',
  ServiceReminderId = 'serviceReminderId',
  UserId = 'userId',
  WorkflowEventSettingId = 'workflowEventSettingId'
}

export type ChannelCreationSourceScalarWhereInput = {
  AND?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  OR?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  channelId?: Maybe<StringFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<EnumChannelCreationSourceTypeFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  serviceReminderId?: Maybe<StringNullableFilter>;
  userId?: Maybe<StringNullableFilter>;
  workflowEventSettingId?: Maybe<StringNullableFilter>;
};

export type ChannelCreationSourceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelCreationSourceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelCreationSourceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelCreationSourceScalarWhereWithAggregatesInput>>;
  channelId?: Maybe<StringWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  creationSource?: Maybe<EnumChannelCreationSourceTypeWithAggregatesFilter>;
  formSubmissionId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  serviceReminderId?: Maybe<StringNullableWithAggregatesFilter>;
  userId?: Maybe<StringNullableWithAggregatesFilter>;
  workflowEventSettingId?: Maybe<StringNullableWithAggregatesFilter>;
};

export enum ChannelCreationSourceType {
  Automation = 'Automation',
  CallDeflection = 'CallDeflection',
  ClientInitiated = 'ClientInitiated',
  ClinicInitiated = 'ClinicInitiated',
  ClinicWidgetRequest = 'ClinicWidgetRequest',
  ServiceReminder = 'ServiceReminder',
  SystemMessage = 'SystemMessage'
}

export type ChannelCreationSourceUncheckedCreateInput = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyClinicPetParentInputEnvelope>;
};

export type ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicWidgetRequestInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyClinicWidgetRequestInputEnvelope>;
};

export type ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyFormSubmissionInputEnvelope>;
};

export type ChannelCreationSourceUncheckedCreateNestedManyWithoutServiceReminderInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyServiceReminderInputEnvelope>;
};

export type ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyUserInputEnvelope>;
};

export type ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyWorkflowEventSettingInputEnvelope>;
};

export type ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput = {
  connect?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreationSourceCreateOrConnectWithoutChannelInput>;
  create?: Maybe<ChannelCreationSourceCreateWithoutChannelInput>;
};

export type ChannelCreationSourceUncheckedCreateWithoutChannelInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedCreateWithoutClinicPetParentInput = {
  channelId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedCreateWithoutClinicWidgetRequestInput = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedCreateWithoutFormSubmissionInput = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedCreateWithoutServiceReminderInput = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedCreateWithoutUserInput = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedCreateWithoutWorkflowEventSettingInput = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateManyInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  set?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  update?: Maybe<Array<ChannelCreationSourceUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ChannelCreationSourceUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ChannelCreationSourceUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ChannelCreationSourceUncheckedUpdateManyWithoutClinicWidgetRequestInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyClinicWidgetRequestInputEnvelope>;
  delete?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  set?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  update?: Maybe<Array<ChannelCreationSourceUpdateWithWhereUniqueWithoutClinicWidgetRequestInput>>;
  updateMany?: Maybe<Array<ChannelCreationSourceUpdateManyWithWhereWithoutClinicWidgetRequestInput>>;
  upsert?: Maybe<Array<ChannelCreationSourceUpsertWithWhereUniqueWithoutClinicWidgetRequestInput>>;
};

export type ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyFormSubmissionInputEnvelope>;
  delete?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  set?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  update?: Maybe<Array<ChannelCreationSourceUpdateWithWhereUniqueWithoutFormSubmissionInput>>;
  updateMany?: Maybe<Array<ChannelCreationSourceUpdateManyWithWhereWithoutFormSubmissionInput>>;
  upsert?: Maybe<Array<ChannelCreationSourceUpsertWithWhereUniqueWithoutFormSubmissionInput>>;
};

export type ChannelCreationSourceUncheckedUpdateManyWithoutServiceReminderInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateManyWithoutServiceReminderNestedInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyServiceReminderInputEnvelope>;
  delete?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  set?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  update?: Maybe<Array<ChannelCreationSourceUpdateWithWhereUniqueWithoutServiceReminderInput>>;
  updateMany?: Maybe<Array<ChannelCreationSourceUpdateManyWithWhereWithoutServiceReminderInput>>;
  upsert?: Maybe<Array<ChannelCreationSourceUpsertWithWhereUniqueWithoutServiceReminderInput>>;
};

export type ChannelCreationSourceUncheckedUpdateManyWithoutUserInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  set?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  update?: Maybe<Array<ChannelCreationSourceUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ChannelCreationSourceUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ChannelCreationSourceUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyWorkflowEventSettingInputEnvelope>;
  delete?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  set?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  update?: Maybe<Array<ChannelCreationSourceUpdateWithWhereUniqueWithoutWorkflowEventSettingInput>>;
  updateMany?: Maybe<Array<ChannelCreationSourceUpdateManyWithWhereWithoutWorkflowEventSettingInput>>;
  upsert?: Maybe<Array<ChannelCreationSourceUpsertWithWhereUniqueWithoutWorkflowEventSettingInput>>;
};

export type ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput = {
  connect?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreationSourceCreateOrConnectWithoutChannelInput>;
  create?: Maybe<ChannelCreationSourceCreateWithoutChannelInput>;
  delete?: Maybe<ChannelCreationSourceWhereInput>;
  disconnect?: Maybe<ChannelCreationSourceWhereInput>;
  update?: Maybe<ChannelCreationSourceUpdateToOneWithWhereWithoutChannelInput>;
  upsert?: Maybe<ChannelCreationSourceUpsertWithoutChannelInput>;
};

export type ChannelCreationSourceUncheckedUpdateWithoutChannelInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateWithoutClinicPetParentInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateWithoutClinicWidgetRequestInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateWithoutFormSubmissionInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateWithoutServiceReminderInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateWithoutUserInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUncheckedUpdateWithoutWorkflowEventSettingInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUpdateInput = {
  channel?: Maybe<ChannelUpdateOneRequiredWithoutCreationSourceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutChannelCreationSourcesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelCreationSourcesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelCreationSourcesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelCreationSourcesNestedInput>;
  user?: Maybe<UserUpdateOneWithoutChannelCreationSourcesNestedInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutChannelCreationSourcesNestedInput>;
};

export type ChannelCreationSourceUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelCreationSourceUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: ChannelCreationSourceUpdateManyMutationInput;
  where: ChannelCreationSourceScalarWhereInput;
};

export type ChannelCreationSourceUpdateManyWithWhereWithoutClinicWidgetRequestInput = {
  data: ChannelCreationSourceUpdateManyMutationInput;
  where: ChannelCreationSourceScalarWhereInput;
};

export type ChannelCreationSourceUpdateManyWithWhereWithoutFormSubmissionInput = {
  data: ChannelCreationSourceUpdateManyMutationInput;
  where: ChannelCreationSourceScalarWhereInput;
};

export type ChannelCreationSourceUpdateManyWithWhereWithoutServiceReminderInput = {
  data: ChannelCreationSourceUpdateManyMutationInput;
  where: ChannelCreationSourceScalarWhereInput;
};

export type ChannelCreationSourceUpdateManyWithWhereWithoutUserInput = {
  data: ChannelCreationSourceUpdateManyMutationInput;
  where: ChannelCreationSourceScalarWhereInput;
};

export type ChannelCreationSourceUpdateManyWithWhereWithoutWorkflowEventSettingInput = {
  data: ChannelCreationSourceUpdateManyMutationInput;
  where: ChannelCreationSourceScalarWhereInput;
};

export type ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  set?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  update?: Maybe<Array<ChannelCreationSourceUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ChannelCreationSourceUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ChannelCreationSourceUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ChannelCreationSourceUpdateManyWithoutClinicWidgetRequestNestedInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyClinicWidgetRequestInputEnvelope>;
  delete?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  set?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  update?: Maybe<Array<ChannelCreationSourceUpdateWithWhereUniqueWithoutClinicWidgetRequestInput>>;
  updateMany?: Maybe<Array<ChannelCreationSourceUpdateManyWithWhereWithoutClinicWidgetRequestInput>>;
  upsert?: Maybe<Array<ChannelCreationSourceUpsertWithWhereUniqueWithoutClinicWidgetRequestInput>>;
};

export type ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyFormSubmissionInputEnvelope>;
  delete?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  set?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  update?: Maybe<Array<ChannelCreationSourceUpdateWithWhereUniqueWithoutFormSubmissionInput>>;
  updateMany?: Maybe<Array<ChannelCreationSourceUpdateManyWithWhereWithoutFormSubmissionInput>>;
  upsert?: Maybe<Array<ChannelCreationSourceUpsertWithWhereUniqueWithoutFormSubmissionInput>>;
};

export type ChannelCreationSourceUpdateManyWithoutServiceReminderNestedInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyServiceReminderInputEnvelope>;
  delete?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  set?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  update?: Maybe<Array<ChannelCreationSourceUpdateWithWhereUniqueWithoutServiceReminderInput>>;
  updateMany?: Maybe<Array<ChannelCreationSourceUpdateManyWithWhereWithoutServiceReminderInput>>;
  upsert?: Maybe<Array<ChannelCreationSourceUpsertWithWhereUniqueWithoutServiceReminderInput>>;
};

export type ChannelCreationSourceUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  set?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  update?: Maybe<Array<ChannelCreationSourceUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ChannelCreationSourceUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ChannelCreationSourceUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput = {
  connect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreationSourceCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<ChannelCreationSourceCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<ChannelCreationSourceCreateManyWorkflowEventSettingInputEnvelope>;
  delete?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelCreationSourceScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  set?: Maybe<Array<ChannelCreationSourceWhereUniqueInput>>;
  update?: Maybe<Array<ChannelCreationSourceUpdateWithWhereUniqueWithoutWorkflowEventSettingInput>>;
  updateMany?: Maybe<Array<ChannelCreationSourceUpdateManyWithWhereWithoutWorkflowEventSettingInput>>;
  upsert?: Maybe<Array<ChannelCreationSourceUpsertWithWhereUniqueWithoutWorkflowEventSettingInput>>;
};

export type ChannelCreationSourceUpdateOneWithoutChannelNestedInput = {
  connect?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreationSourceCreateOrConnectWithoutChannelInput>;
  create?: Maybe<ChannelCreationSourceCreateWithoutChannelInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelCreationSourceUpdateToOneWithWhereWithoutChannelInput>;
  upsert?: Maybe<ChannelCreationSourceUpsertWithoutChannelInput>;
};

export type ChannelCreationSourceUpdateToOneWithWhereWithoutChannelInput = {
  data: ChannelCreationSourceUpdateWithoutChannelInput;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};

export type ChannelCreationSourceUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: ChannelCreationSourceUpdateWithoutClinicPetParentInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceUpdateWithWhereUniqueWithoutClinicWidgetRequestInput = {
  data: ChannelCreationSourceUpdateWithoutClinicWidgetRequestInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceUpdateWithWhereUniqueWithoutFormSubmissionInput = {
  data: ChannelCreationSourceUpdateWithoutFormSubmissionInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceUpdateWithWhereUniqueWithoutServiceReminderInput = {
  data: ChannelCreationSourceUpdateWithoutServiceReminderInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceUpdateWithWhereUniqueWithoutUserInput = {
  data: ChannelCreationSourceUpdateWithoutUserInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceUpdateWithWhereUniqueWithoutWorkflowEventSettingInput = {
  data: ChannelCreationSourceUpdateWithoutWorkflowEventSettingInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceUpdateWithoutChannelInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutChannelCreationSourcesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelCreationSourcesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelCreationSourcesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelCreationSourcesNestedInput>;
  user?: Maybe<UserUpdateOneWithoutChannelCreationSourcesNestedInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutChannelCreationSourcesNestedInput>;
};

export type ChannelCreationSourceUpdateWithoutClinicPetParentInput = {
  channel?: Maybe<ChannelUpdateOneRequiredWithoutCreationSourceNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelCreationSourcesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelCreationSourcesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelCreationSourcesNestedInput>;
  user?: Maybe<UserUpdateOneWithoutChannelCreationSourcesNestedInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutChannelCreationSourcesNestedInput>;
};

export type ChannelCreationSourceUpdateWithoutClinicWidgetRequestInput = {
  channel?: Maybe<ChannelUpdateOneRequiredWithoutCreationSourceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutChannelCreationSourcesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelCreationSourcesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelCreationSourcesNestedInput>;
  user?: Maybe<UserUpdateOneWithoutChannelCreationSourcesNestedInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutChannelCreationSourcesNestedInput>;
};

export type ChannelCreationSourceUpdateWithoutFormSubmissionInput = {
  channel?: Maybe<ChannelUpdateOneRequiredWithoutCreationSourceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutChannelCreationSourcesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelCreationSourcesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelCreationSourcesNestedInput>;
  user?: Maybe<UserUpdateOneWithoutChannelCreationSourcesNestedInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutChannelCreationSourcesNestedInput>;
};

export type ChannelCreationSourceUpdateWithoutServiceReminderInput = {
  channel?: Maybe<ChannelUpdateOneRequiredWithoutCreationSourceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutChannelCreationSourcesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelCreationSourcesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelCreationSourcesNestedInput>;
  id?: Maybe<Scalars['String']>;
  user?: Maybe<UserUpdateOneWithoutChannelCreationSourcesNestedInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutChannelCreationSourcesNestedInput>;
};

export type ChannelCreationSourceUpdateWithoutUserInput = {
  channel?: Maybe<ChannelUpdateOneRequiredWithoutCreationSourceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutChannelCreationSourcesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelCreationSourcesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelCreationSourcesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelCreationSourcesNestedInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutChannelCreationSourcesNestedInput>;
};

export type ChannelCreationSourceUpdateWithoutWorkflowEventSettingInput = {
  channel?: Maybe<ChannelUpdateOneRequiredWithoutCreationSourceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutChannelCreationSourcesNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutChannelCreationSourcesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceType>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutChannelCreationSourcesNestedInput>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneWithoutChannelCreationSourcesNestedInput>;
  user?: Maybe<UserUpdateOneWithoutChannelCreationSourcesNestedInput>;
};

export type ChannelCreationSourceUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: ChannelCreationSourceCreateWithoutClinicPetParentInput;
  update: ChannelCreationSourceUpdateWithoutClinicPetParentInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceUpsertWithWhereUniqueWithoutClinicWidgetRequestInput = {
  create: ChannelCreationSourceCreateWithoutClinicWidgetRequestInput;
  update: ChannelCreationSourceUpdateWithoutClinicWidgetRequestInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceUpsertWithWhereUniqueWithoutFormSubmissionInput = {
  create: ChannelCreationSourceCreateWithoutFormSubmissionInput;
  update: ChannelCreationSourceUpdateWithoutFormSubmissionInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceUpsertWithWhereUniqueWithoutServiceReminderInput = {
  create: ChannelCreationSourceCreateWithoutServiceReminderInput;
  update: ChannelCreationSourceUpdateWithoutServiceReminderInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceUpsertWithWhereUniqueWithoutUserInput = {
  create: ChannelCreationSourceCreateWithoutUserInput;
  update: ChannelCreationSourceUpdateWithoutUserInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceUpsertWithWhereUniqueWithoutWorkflowEventSettingInput = {
  create: ChannelCreationSourceCreateWithoutWorkflowEventSettingInput;
  update: ChannelCreationSourceUpdateWithoutWorkflowEventSettingInput;
  where: ChannelCreationSourceWhereUniqueInput;
};

export type ChannelCreationSourceUpsertWithoutChannelInput = {
  create: ChannelCreationSourceCreateWithoutChannelInput;
  update: ChannelCreationSourceUpdateWithoutChannelInput;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};

export type ChannelCreationSourceWhereInput = {
  AND?: Maybe<Array<ChannelCreationSourceWhereInput>>;
  NOT?: Maybe<Array<ChannelCreationSourceWhereInput>>;
  OR?: Maybe<Array<ChannelCreationSourceWhereInput>>;
  channel?: Maybe<ChannelScalarRelationFilter>;
  channelId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<EnumChannelCreationSourceTypeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  serviceReminder?: Maybe<ServiceReminderNullableScalarRelationFilter>;
  serviceReminderId?: Maybe<StringNullableFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
  workflowEventSetting?: Maybe<WorkflowEventSettingNullableScalarRelationFilter>;
  workflowEventSettingId?: Maybe<StringNullableFilter>;
};

export type ChannelCreationSourceWhereUniqueInput = {
  AND?: Maybe<Array<ChannelCreationSourceWhereInput>>;
  NOT?: Maybe<Array<ChannelCreationSourceWhereInput>>;
  OR?: Maybe<Array<ChannelCreationSourceWhereInput>>;
  channel?: Maybe<ChannelScalarRelationFilter>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<EnumChannelCreationSourceTypeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  serviceReminder?: Maybe<ServiceReminderNullableScalarRelationFilter>;
  serviceReminderId?: Maybe<StringNullableFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
  workflowEventSetting?: Maybe<WorkflowEventSettingNullableScalarRelationFilter>;
  workflowEventSettingId?: Maybe<StringNullableFilter>;
};

export type ChannelExportWhereInput = {
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  includeNotes?: Maybe<Scalars['Boolean']>;
};

export type ChannelFilterSelection = {
  __typename?: 'ChannelFilterSelection';
  _count: ChannelFilterSelectionCountOutputType;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  filterSelectionType: FilterSelectionType;
  filters: Scalars['Json'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userChannelFilterSelections: Array<UserChannelFilterSelection>;
};


export type ChannelFilterSelectionUserChannelFilterSelectionsArgs = {
  cursor?: Maybe<UserChannelFilterSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserChannelFilterSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserChannelFilterSelectionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserChannelFilterSelectionWhereInput>;
};

export type ChannelFilterSelectionCountAggregateOutputType = {
  __typename?: 'ChannelFilterSelectionCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  filterSelectionType: Scalars['Int'];
  filters: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ChannelFilterSelectionCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  filterSelectionType?: Maybe<SortOrder>;
  filters?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelFilterSelectionCountOutputType = {
  __typename?: 'ChannelFilterSelectionCountOutputType';
  userChannelFilterSelections: Scalars['Int'];
};

export type ChannelFilterSelectionCreateInput = {
  clinic: ClinicCreateNestedOneWithoutChannelFilterSelectionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType: FilterSelectionType;
  filters: Scalars['Json'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutFilterSelectionInput>;
};

export type ChannelFilterSelectionCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType: FilterSelectionType;
  filters: Scalars['Json'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelFilterSelectionCreateManyClinicInputEnvelope = {
  data: Array<ChannelFilterSelectionCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelFilterSelectionCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType: FilterSelectionType;
  filters: Scalars['Json'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelFilterSelectionCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ChannelFilterSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelFilterSelectionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ChannelFilterSelectionCreateWithoutClinicInput>>;
  createMany?: Maybe<ChannelFilterSelectionCreateManyClinicInputEnvelope>;
};

export type ChannelFilterSelectionCreateNestedOneWithoutUserChannelFilterSelectionsInput = {
  connect?: Maybe<ChannelFilterSelectionWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelFilterSelectionCreateOrConnectWithoutUserChannelFilterSelectionsInput>;
  create?: Maybe<ChannelFilterSelectionCreateWithoutUserChannelFilterSelectionsInput>;
};

export type ChannelFilterSelectionCreateOrConnectWithoutClinicInput = {
  create: ChannelFilterSelectionCreateWithoutClinicInput;
  where: ChannelFilterSelectionWhereUniqueInput;
};

export type ChannelFilterSelectionCreateOrConnectWithoutUserChannelFilterSelectionsInput = {
  create: ChannelFilterSelectionCreateWithoutUserChannelFilterSelectionsInput;
  where: ChannelFilterSelectionWhereUniqueInput;
};

export type ChannelFilterSelectionCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType: FilterSelectionType;
  filters: Scalars['Json'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutFilterSelectionInput>;
};

export type ChannelFilterSelectionCreateWithoutUserChannelFilterSelectionsInput = {
  clinic: ClinicCreateNestedOneWithoutChannelFilterSelectionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType: FilterSelectionType;
  filters: Scalars['Json'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelFilterSelectionGroupByOutputType = {
  __typename?: 'ChannelFilterSelectionGroupByOutputType';
  _count?: Maybe<ChannelFilterSelectionCountAggregateOutputType>;
  _max?: Maybe<ChannelFilterSelectionMaxAggregateOutputType>;
  _min?: Maybe<ChannelFilterSelectionMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  filterSelectionType: FilterSelectionType;
  filters: Scalars['Json'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ChannelFilterSelectionListRelationFilter = {
  every?: Maybe<ChannelFilterSelectionWhereInput>;
  none?: Maybe<ChannelFilterSelectionWhereInput>;
  some?: Maybe<ChannelFilterSelectionWhereInput>;
};

export type ChannelFilterSelectionMaxAggregateOutputType = {
  __typename?: 'ChannelFilterSelectionMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType?: Maybe<FilterSelectionType>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelFilterSelectionMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  filterSelectionType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelFilterSelectionMinAggregateOutputType = {
  __typename?: 'ChannelFilterSelectionMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType?: Maybe<FilterSelectionType>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelFilterSelectionMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  filterSelectionType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelFilterSelectionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelFilterSelectionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelFilterSelectionOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  filterSelectionType?: Maybe<SortOrder>;
  filters?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionOrderByRelationAggregateInput>;
};

export enum ChannelFilterSelectionOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  Name = 'name'
}

export type ChannelFilterSelectionOrderByRelevanceInput = {
  fields: Array<ChannelFilterSelectionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelFilterSelectionOrderByWithAggregationInput = {
  _count?: Maybe<ChannelFilterSelectionCountOrderByAggregateInput>;
  _max?: Maybe<ChannelFilterSelectionMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelFilterSelectionMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  filterSelectionType?: Maybe<SortOrder>;
  filters?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelFilterSelectionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelFilterSelectionOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  filterSelectionType?: Maybe<SortOrder>;
  filters?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionOrderByRelationAggregateInput>;
};

export type ChannelFilterSelectionOrderByWithRelationInput = {
  _relevance?: Maybe<ChannelFilterSelectionOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  filterSelectionType?: Maybe<SortOrder>;
  filters?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionOrderByRelationAggregateInput>;
};

export enum ChannelFilterSelectionScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  FilterSelectionType = 'filterSelectionType',
  Filters = 'filters',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type ChannelFilterSelectionScalarRelationFilter = {
  AND?: Maybe<Array<ChannelFilterSelectionWhereInput>>;
  NOT?: Maybe<Array<ChannelFilterSelectionWhereInput>>;
  OR?: Maybe<Array<ChannelFilterSelectionWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  filterSelectionType?: Maybe<EnumFilterSelectionTypeFilter>;
  filters?: Maybe<JsonFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionListRelationFilter>;
};

export type ChannelFilterSelectionScalarWhereInput = {
  AND?: Maybe<Array<ChannelFilterSelectionScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelFilterSelectionScalarWhereInput>>;
  OR?: Maybe<Array<ChannelFilterSelectionScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  filterSelectionType?: Maybe<EnumFilterSelectionTypeFilter>;
  filters?: Maybe<JsonFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChannelFilterSelectionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelFilterSelectionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelFilterSelectionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelFilterSelectionScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  filterSelectionType?: Maybe<EnumFilterSelectionTypeWithAggregatesFilter>;
  filters?: Maybe<JsonWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ChannelFilterSelectionUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType: FilterSelectionType;
  filters: Scalars['Json'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutFilterSelectionInput>;
};

export type ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ChannelFilterSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelFilterSelectionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ChannelFilterSelectionCreateWithoutClinicInput>>;
  createMany?: Maybe<ChannelFilterSelectionCreateManyClinicInputEnvelope>;
};

export type ChannelFilterSelectionUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType: FilterSelectionType;
  filters: Scalars['Json'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutFilterSelectionInput>;
};

export type ChannelFilterSelectionUncheckedCreateWithoutUserChannelFilterSelectionsInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType: FilterSelectionType;
  filters: Scalars['Json'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelFilterSelectionUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType?: Maybe<FilterSelectionType>;
  filters?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutFilterSelectionNestedInput>;
};

export type ChannelFilterSelectionUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType?: Maybe<FilterSelectionType>;
  filters?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelFilterSelectionUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType?: Maybe<FilterSelectionType>;
  filters?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ChannelFilterSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelFilterSelectionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ChannelFilterSelectionCreateWithoutClinicInput>>;
  createMany?: Maybe<ChannelFilterSelectionCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ChannelFilterSelectionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelFilterSelectionScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelFilterSelectionWhereUniqueInput>>;
  set?: Maybe<Array<ChannelFilterSelectionWhereUniqueInput>>;
  update?: Maybe<Array<ChannelFilterSelectionUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ChannelFilterSelectionUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ChannelFilterSelectionUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ChannelFilterSelectionUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType?: Maybe<FilterSelectionType>;
  filters?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutFilterSelectionNestedInput>;
};

export type ChannelFilterSelectionUncheckedUpdateWithoutUserChannelFilterSelectionsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType?: Maybe<FilterSelectionType>;
  filters?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelFilterSelectionUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutChannelFilterSelectionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType?: Maybe<FilterSelectionType>;
  filters?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutFilterSelectionNestedInput>;
};

export type ChannelFilterSelectionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType?: Maybe<FilterSelectionType>;
  filters?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelFilterSelectionUpdateManyWithWhereWithoutClinicInput = {
  data: ChannelFilterSelectionUpdateManyMutationInput;
  where: ChannelFilterSelectionScalarWhereInput;
};

export type ChannelFilterSelectionUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ChannelFilterSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelFilterSelectionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ChannelFilterSelectionCreateWithoutClinicInput>>;
  createMany?: Maybe<ChannelFilterSelectionCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ChannelFilterSelectionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelFilterSelectionScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelFilterSelectionWhereUniqueInput>>;
  set?: Maybe<Array<ChannelFilterSelectionWhereUniqueInput>>;
  update?: Maybe<Array<ChannelFilterSelectionUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ChannelFilterSelectionUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ChannelFilterSelectionUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ChannelFilterSelectionUpdateOneRequiredWithoutUserChannelFilterSelectionsNestedInput = {
  connect?: Maybe<ChannelFilterSelectionWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelFilterSelectionCreateOrConnectWithoutUserChannelFilterSelectionsInput>;
  create?: Maybe<ChannelFilterSelectionCreateWithoutUserChannelFilterSelectionsInput>;
  update?: Maybe<ChannelFilterSelectionUpdateToOneWithWhereWithoutUserChannelFilterSelectionsInput>;
  upsert?: Maybe<ChannelFilterSelectionUpsertWithoutUserChannelFilterSelectionsInput>;
};

export type ChannelFilterSelectionUpdateToOneWithWhereWithoutUserChannelFilterSelectionsInput = {
  data: ChannelFilterSelectionUpdateWithoutUserChannelFilterSelectionsInput;
  where?: Maybe<ChannelFilterSelectionWhereInput>;
};

export type ChannelFilterSelectionUpdateWithWhereUniqueWithoutClinicInput = {
  data: ChannelFilterSelectionUpdateWithoutClinicInput;
  where: ChannelFilterSelectionWhereUniqueInput;
};

export type ChannelFilterSelectionUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType?: Maybe<FilterSelectionType>;
  filters?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutFilterSelectionNestedInput>;
};

export type ChannelFilterSelectionUpdateWithoutUserChannelFilterSelectionsInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutChannelFilterSelectionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filterSelectionType?: Maybe<FilterSelectionType>;
  filters?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelFilterSelectionUpsertWithWhereUniqueWithoutClinicInput = {
  create: ChannelFilterSelectionCreateWithoutClinicInput;
  update: ChannelFilterSelectionUpdateWithoutClinicInput;
  where: ChannelFilterSelectionWhereUniqueInput;
};

export type ChannelFilterSelectionUpsertWithoutUserChannelFilterSelectionsInput = {
  create: ChannelFilterSelectionCreateWithoutUserChannelFilterSelectionsInput;
  update: ChannelFilterSelectionUpdateWithoutUserChannelFilterSelectionsInput;
  where?: Maybe<ChannelFilterSelectionWhereInput>;
};

export type ChannelFilterSelectionWhereInput = {
  AND?: Maybe<Array<ChannelFilterSelectionWhereInput>>;
  NOT?: Maybe<Array<ChannelFilterSelectionWhereInput>>;
  OR?: Maybe<Array<ChannelFilterSelectionWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  filterSelectionType?: Maybe<EnumFilterSelectionTypeFilter>;
  filters?: Maybe<JsonFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionListRelationFilter>;
};

export type ChannelFilterSelectionWhereUniqueInput = {
  AND?: Maybe<Array<ChannelFilterSelectionWhereInput>>;
  NOT?: Maybe<Array<ChannelFilterSelectionWhereInput>>;
  OR?: Maybe<Array<ChannelFilterSelectionWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  filterSelectionType?: Maybe<EnumFilterSelectionTypeFilter>;
  filters?: Maybe<JsonFilter>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionListRelationFilter>;
};

export type ChannelGroupByOutputType = {
  __typename?: 'ChannelGroupByOutputType';
  _count?: Maybe<ChannelCountAggregateOutputType>;
  _max?: Maybe<ChannelMaxAggregateOutputType>;
  _min?: Maybe<ChannelMinAggregateOutputType>;
  attributes?: Maybe<Scalars['Json']>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ChannelListRelationFilter = {
  every?: Maybe<ChannelWhereInput>;
  none?: Maybe<ChannelWhereInput>;
  some?: Maybe<ChannelWhereInput>;
};

export type ChannelMaxAggregateOutputType = {
  __typename?: 'ChannelMaxAggregateOutputType';
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMaxOrderByAggregateInput = {
  channelStatusId?: Maybe<SortOrder>;
  channelType?: Maybe<SortOrder>;
  channelVisibility?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentWorkflowActionId?: Maybe<SortOrder>;
  friendlyName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastExportAt?: Maybe<SortOrder>;
  lastMessageId?: Maybe<SortOrder>;
  twilioChannelSid?: Maybe<SortOrder>;
  uniqueName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelMember = {
  __typename?: 'ChannelMember';
  _count: ChannelMemberCountOutputType;
  attributes?: Maybe<Scalars['Json']>;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['String']>;
  channelMessages: Array<ChannelMessage>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  draft?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification: Scalars['Boolean'];
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};


export type ChannelMemberChannelArgs = {
  where?: Maybe<ChannelWhereInput>;
};


export type ChannelMemberChannelMessagesArgs = {
  cursor?: Maybe<ChannelMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageWhereInput>;
};


export type ChannelMemberClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type ChannelMemberUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type ChannelMemberAvgAggregateOutputType = {
  __typename?: 'ChannelMemberAvgAggregateOutputType';
  lastConsumedMessageIndex?: Maybe<Scalars['Float']>;
};

export type ChannelMemberAvgOrderByAggregateInput = {
  lastConsumedMessageIndex?: Maybe<SortOrder>;
};

export type ChannelMemberCountAggregateOutputType = {
  __typename?: 'ChannelMemberCountAggregateOutputType';
  _all: Scalars['Int'];
  attributes: Scalars['Int'];
  channelId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  draft: Scalars['Int'];
  id: Scalars['Int'];
  lastConsumedMessageIndex: Scalars['Int'];
  lastConsumptionTimestamp: Scalars['Int'];
  removedAt: Scalars['Int'];
  sendMessageNotification: Scalars['Int'];
  twilioIdentity: Scalars['Int'];
  twilioMemberSid: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ChannelMemberCountOrderByAggregateInput = {
  attributes?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draft?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastConsumedMessageIndex?: Maybe<SortOrder>;
  lastConsumptionTimestamp?: Maybe<SortOrder>;
  removedAt?: Maybe<SortOrder>;
  sendMessageNotification?: Maybe<SortOrder>;
  twilioIdentity?: Maybe<SortOrder>;
  twilioMemberSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelMemberCountOutputType = {
  __typename?: 'ChannelMemberCountOutputType';
  channelMessages: Scalars['Int'];
};

export type ChannelMemberCreateInput = {
  attributes?: Maybe<Scalars['Json']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutChannelMembersInput>;
  channelMessages?: Maybe<ChannelMessageCreateNestedManyWithoutAuthorInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutChannelMembersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutChannelMembersInput>;
};

export type ChannelMemberCreateManyChannelInput = {
  attributes?: Maybe<Scalars['Json']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberCreateManyChannelInputEnvelope = {
  data: Array<ChannelMemberCreateManyChannelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelMemberCreateManyClinicPetParentInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberCreateManyClinicPetParentInputEnvelope = {
  data: Array<ChannelMemberCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelMemberCreateManyInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberCreateManyUserInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMemberCreateManyUserInputEnvelope = {
  data: Array<ChannelMemberCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelMemberCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMemberCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelMemberCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelMemberCreateManyChannelInputEnvelope>;
};

export type ChannelMemberCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMemberCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ChannelMemberCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ChannelMemberCreateManyClinicPetParentInputEnvelope>;
};

export type ChannelMemberCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMemberCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelMemberCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelMemberCreateManyUserInputEnvelope>;
};

export type ChannelMemberCreateNestedOneWithoutChannelMessagesInput = {
  connect?: Maybe<ChannelMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMemberCreateOrConnectWithoutChannelMessagesInput>;
  create?: Maybe<ChannelMemberCreateWithoutChannelMessagesInput>;
};

export type ChannelMemberCreateOrConnectWithoutChannelInput = {
  create: ChannelMemberCreateWithoutChannelInput;
  where: ChannelMemberWhereUniqueInput;
};

export type ChannelMemberCreateOrConnectWithoutChannelMessagesInput = {
  create: ChannelMemberCreateWithoutChannelMessagesInput;
  where: ChannelMemberWhereUniqueInput;
};

export type ChannelMemberCreateOrConnectWithoutClinicPetParentInput = {
  create: ChannelMemberCreateWithoutClinicPetParentInput;
  where: ChannelMemberWhereUniqueInput;
};

export type ChannelMemberCreateOrConnectWithoutUserInput = {
  create: ChannelMemberCreateWithoutUserInput;
  where: ChannelMemberWhereUniqueInput;
};

export type ChannelMemberCreateWithoutChannelInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelMessages?: Maybe<ChannelMessageCreateNestedManyWithoutAuthorInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutChannelMembersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutChannelMembersInput>;
};

export type ChannelMemberCreateWithoutChannelMessagesInput = {
  attributes?: Maybe<Scalars['Json']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutChannelMembersInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutChannelMembersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutChannelMembersInput>;
};

export type ChannelMemberCreateWithoutClinicPetParentInput = {
  attributes?: Maybe<Scalars['Json']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutChannelMembersInput>;
  channelMessages?: Maybe<ChannelMessageCreateNestedManyWithoutAuthorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutChannelMembersInput>;
};

export type ChannelMemberCreateWithoutUserInput = {
  attributes?: Maybe<Scalars['Json']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutChannelMembersInput>;
  channelMessages?: Maybe<ChannelMessageCreateNestedManyWithoutAuthorInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutChannelMembersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMemberGroupByOutputType = {
  __typename?: 'ChannelMemberGroupByOutputType';
  _avg?: Maybe<ChannelMemberAvgAggregateOutputType>;
  _count?: Maybe<ChannelMemberCountAggregateOutputType>;
  _max?: Maybe<ChannelMemberMaxAggregateOutputType>;
  _min?: Maybe<ChannelMemberMinAggregateOutputType>;
  _sum?: Maybe<ChannelMemberSumAggregateOutputType>;
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  draft?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification: Scalars['Boolean'];
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberListRelationFilter = {
  every?: Maybe<ChannelMemberWhereInput>;
  none?: Maybe<ChannelMemberWhereInput>;
  some?: Maybe<ChannelMemberWhereInput>;
};

export type ChannelMemberMaxAggregateOutputType = {
  __typename?: 'ChannelMemberMaxAggregateOutputType';
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberMaxOrderByAggregateInput = {
  channelId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastConsumedMessageIndex?: Maybe<SortOrder>;
  lastConsumptionTimestamp?: Maybe<SortOrder>;
  removedAt?: Maybe<SortOrder>;
  sendMessageNotification?: Maybe<SortOrder>;
  twilioIdentity?: Maybe<SortOrder>;
  twilioMemberSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelMemberMinAggregateOutputType = {
  __typename?: 'ChannelMemberMinAggregateOutputType';
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberMinOrderByAggregateInput = {
  channelId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastConsumedMessageIndex?: Maybe<SortOrder>;
  lastConsumptionTimestamp?: Maybe<SortOrder>;
  removedAt?: Maybe<SortOrder>;
  sendMessageNotification?: Maybe<SortOrder>;
  twilioIdentity?: Maybe<SortOrder>;
  twilioMemberSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelMemberNullableScalarRelationFilter = {
  AND?: Maybe<Array<ChannelMemberWhereInput>>;
  NOT?: Maybe<Array<ChannelMemberWhereInput>>;
  OR?: Maybe<Array<ChannelMemberWhereInput>>;
  attributes?: Maybe<JsonNullableFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  channelMessages?: Maybe<ChannelMessageListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draft?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  lastConsumedMessageIndex?: Maybe<IntNullableFilter>;
  lastConsumptionTimestamp?: Maybe<DateTimeNullableFilter>;
  removedAt?: Maybe<DateTimeNullableFilter>;
  sendMessageNotification?: Maybe<BoolFilter>;
  twilioIdentity?: Maybe<StringNullableFilter>;
  twilioMemberSid?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type ChannelMemberOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelMemberOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelMemberOrderByRelevanceInput>;
  attributes?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  channelMessages?: Maybe<ChannelMessageOrderByRelationAggregateInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draft?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastConsumedMessageIndex?: Maybe<SortOrder>;
  lastConsumptionTimestamp?: Maybe<SortOrder>;
  removedAt?: Maybe<SortOrder>;
  sendMessageNotification?: Maybe<SortOrder>;
  twilioIdentity?: Maybe<SortOrder>;
  twilioMemberSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ChannelMemberOrderByRelevanceFieldEnum {
  ChannelId = 'channelId',
  ClinicPetParentId = 'clinicPetParentId',
  Id = 'id',
  TwilioIdentity = 'twilioIdentity',
  TwilioMemberSid = 'twilioMemberSid',
  UserId = 'userId'
}

export type ChannelMemberOrderByRelevanceInput = {
  fields: Array<ChannelMemberOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelMemberOrderByWithAggregationInput = {
  _avg?: Maybe<ChannelMemberAvgOrderByAggregateInput>;
  _count?: Maybe<ChannelMemberCountOrderByAggregateInput>;
  _max?: Maybe<ChannelMemberMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelMemberMinOrderByAggregateInput>;
  _sum?: Maybe<ChannelMemberSumOrderByAggregateInput>;
  attributes?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draft?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastConsumedMessageIndex?: Maybe<SortOrder>;
  lastConsumptionTimestamp?: Maybe<SortOrder>;
  removedAt?: Maybe<SortOrder>;
  sendMessageNotification?: Maybe<SortOrder>;
  twilioIdentity?: Maybe<SortOrder>;
  twilioMemberSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelMemberOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelMemberOrderByRelevanceInput>;
  attributes?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  channelMessages?: Maybe<ChannelMessageOrderByRelationAggregateInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draft?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastConsumedMessageIndex?: Maybe<SortOrder>;
  lastConsumptionTimestamp?: Maybe<SortOrder>;
  removedAt?: Maybe<SortOrder>;
  sendMessageNotification?: Maybe<SortOrder>;
  twilioIdentity?: Maybe<SortOrder>;
  twilioMemberSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type ChannelMemberOrderByWithRelationInput = {
  _relevance?: Maybe<ChannelMemberOrderByRelevanceInput>;
  attributes?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  channelMessages?: Maybe<ChannelMessageOrderByRelationAggregateInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draft?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastConsumedMessageIndex?: Maybe<SortOrder>;
  lastConsumptionTimestamp?: Maybe<SortOrder>;
  removedAt?: Maybe<SortOrder>;
  sendMessageNotification?: Maybe<SortOrder>;
  twilioIdentity?: Maybe<SortOrder>;
  twilioMemberSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ChannelMemberScalarFieldEnum {
  Attributes = 'attributes',
  ChannelId = 'channelId',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Draft = 'draft',
  Id = 'id',
  LastConsumedMessageIndex = 'lastConsumedMessageIndex',
  LastConsumptionTimestamp = 'lastConsumptionTimestamp',
  RemovedAt = 'removedAt',
  SendMessageNotification = 'sendMessageNotification',
  TwilioIdentity = 'twilioIdentity',
  TwilioMemberSid = 'twilioMemberSid',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ChannelMemberScalarWhereInput = {
  AND?: Maybe<Array<ChannelMemberScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelMemberScalarWhereInput>>;
  OR?: Maybe<Array<ChannelMemberScalarWhereInput>>;
  attributes?: Maybe<JsonNullableFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draft?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  lastConsumedMessageIndex?: Maybe<IntNullableFilter>;
  lastConsumptionTimestamp?: Maybe<DateTimeNullableFilter>;
  removedAt?: Maybe<DateTimeNullableFilter>;
  sendMessageNotification?: Maybe<BoolFilter>;
  twilioIdentity?: Maybe<StringNullableFilter>;
  twilioMemberSid?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type ChannelMemberScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelMemberScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelMemberScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelMemberScalarWhereWithAggregatesInput>>;
  attributes?: Maybe<JsonNullableWithAggregatesFilter>;
  channelId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  draft?: Maybe<JsonNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  lastConsumedMessageIndex?: Maybe<IntNullableWithAggregatesFilter>;
  lastConsumptionTimestamp?: Maybe<DateTimeNullableWithAggregatesFilter>;
  removedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  sendMessageNotification?: Maybe<BoolWithAggregatesFilter>;
  twilioIdentity?: Maybe<StringNullableWithAggregatesFilter>;
  twilioMemberSid?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type ChannelMemberSubscription = {
  __typename?: 'ChannelMemberSubscription';
  mutation: MutationType;
  node: ChannelMember;
};

export type ChannelMemberSumAggregateOutputType = {
  __typename?: 'ChannelMemberSumAggregateOutputType';
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
};

export type ChannelMemberSumOrderByAggregateInput = {
  lastConsumedMessageIndex?: Maybe<SortOrder>;
};

export type ChannelMemberUncheckedCreateInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  channelMessages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutAuthorInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberUncheckedCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMemberCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelMemberCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelMemberCreateManyChannelInputEnvelope>;
};

export type ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMemberCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ChannelMemberCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ChannelMemberCreateManyClinicPetParentInputEnvelope>;
};

export type ChannelMemberUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMemberCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelMemberCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelMemberCreateManyUserInputEnvelope>;
};

export type ChannelMemberUncheckedCreateWithoutChannelInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelMessages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutAuthorInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberUncheckedCreateWithoutChannelMessagesInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberUncheckedCreateWithoutClinicPetParentInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  channelMessages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutAuthorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberUncheckedCreateWithoutUserInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  channelMessages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutAuthorInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMemberUncheckedUpdateInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  channelMessages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutAuthorNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberUncheckedUpdateManyInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberUncheckedUpdateManyWithoutChannelInput = {
  attributes?: Maybe<Scalars['Json']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMemberCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelMemberCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelMemberCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMemberUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<ChannelMemberUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<ChannelMemberUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type ChannelMemberUncheckedUpdateManyWithoutClinicPetParentInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMemberCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ChannelMemberCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ChannelMemberCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMemberUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ChannelMemberUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ChannelMemberUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ChannelMemberUncheckedUpdateManyWithoutUserInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMemberUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMemberCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelMemberCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelMemberCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMemberUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ChannelMemberUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ChannelMemberUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChannelMemberUncheckedUpdateWithoutChannelInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelMessages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutAuthorNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberUncheckedUpdateWithoutChannelMessagesInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberUncheckedUpdateWithoutClinicPetParentInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  channelMessages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutAuthorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMemberUncheckedUpdateWithoutUserInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelId?: Maybe<Scalars['String']>;
  channelMessages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutAuthorNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMemberUniqueChannelMemberForPetParentAndChannelCompoundUniqueInput = {
  channelId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
};

export type ChannelMemberUniqueChannelMemberForUserAndChannelCompoundUniqueInput = {
  channelId: Scalars['String'];
  userId: Scalars['String'];
};

export type ChannelMemberUpdateInput = {
  attributes?: Maybe<Scalars['Json']>;
  channel?: Maybe<ChannelUpdateOneWithoutChannelMembersNestedInput>;
  channelMessages?: Maybe<ChannelMessageUpdateManyWithoutAuthorNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutChannelMembersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutChannelMembersNestedInput>;
};

export type ChannelMemberUpdateManyMutationInput = {
  attributes?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMemberUpdateManyWithWhereWithoutChannelInput = {
  data: ChannelMemberUpdateManyMutationInput;
  where: ChannelMemberScalarWhereInput;
};

export type ChannelMemberUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: ChannelMemberUpdateManyMutationInput;
  where: ChannelMemberScalarWhereInput;
};

export type ChannelMemberUpdateManyWithWhereWithoutUserInput = {
  data: ChannelMemberUpdateManyMutationInput;
  where: ChannelMemberScalarWhereInput;
};

export type ChannelMemberUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMemberCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelMemberCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelMemberCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMemberUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<ChannelMemberUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<ChannelMemberUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type ChannelMemberUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMemberCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ChannelMemberCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ChannelMemberCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMemberUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ChannelMemberUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ChannelMemberUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ChannelMemberUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMemberCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelMemberCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelMemberCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMemberWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMemberUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ChannelMemberUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ChannelMemberUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChannelMemberUpdateOneWithoutChannelMessagesNestedInput = {
  connect?: Maybe<ChannelMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMemberCreateOrConnectWithoutChannelMessagesInput>;
  create?: Maybe<ChannelMemberCreateWithoutChannelMessagesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelMemberUpdateToOneWithWhereWithoutChannelMessagesInput>;
  upsert?: Maybe<ChannelMemberUpsertWithoutChannelMessagesInput>;
};

export type ChannelMemberUpdateToOneWithWhereWithoutChannelMessagesInput = {
  data: ChannelMemberUpdateWithoutChannelMessagesInput;
  where?: Maybe<ChannelMemberWhereInput>;
};

export type ChannelMemberUpdateWithWhereUniqueWithoutChannelInput = {
  data: ChannelMemberUpdateWithoutChannelInput;
  where: ChannelMemberWhereUniqueInput;
};

export type ChannelMemberUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: ChannelMemberUpdateWithoutClinicPetParentInput;
  where: ChannelMemberWhereUniqueInput;
};

export type ChannelMemberUpdateWithWhereUniqueWithoutUserInput = {
  data: ChannelMemberUpdateWithoutUserInput;
  where: ChannelMemberWhereUniqueInput;
};

export type ChannelMemberUpdateWithoutChannelInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelMessages?: Maybe<ChannelMessageUpdateManyWithoutAuthorNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutChannelMembersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutChannelMembersNestedInput>;
};

export type ChannelMemberUpdateWithoutChannelMessagesInput = {
  attributes?: Maybe<Scalars['Json']>;
  channel?: Maybe<ChannelUpdateOneWithoutChannelMembersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutChannelMembersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutChannelMembersNestedInput>;
};

export type ChannelMemberUpdateWithoutClinicPetParentInput = {
  attributes?: Maybe<Scalars['Json']>;
  channel?: Maybe<ChannelUpdateOneWithoutChannelMembersNestedInput>;
  channelMessages?: Maybe<ChannelMessageUpdateManyWithoutAuthorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutChannelMembersNestedInput>;
};

export type ChannelMemberUpdateWithoutUserInput = {
  attributes?: Maybe<Scalars['Json']>;
  channel?: Maybe<ChannelUpdateOneWithoutChannelMembersNestedInput>;
  channelMessages?: Maybe<ChannelMessageUpdateManyWithoutAuthorNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutChannelMembersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification?: Maybe<Scalars['Boolean']>;
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMemberUpsertWithWhereUniqueWithoutChannelInput = {
  create: ChannelMemberCreateWithoutChannelInput;
  update: ChannelMemberUpdateWithoutChannelInput;
  where: ChannelMemberWhereUniqueInput;
};

export type ChannelMemberUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: ChannelMemberCreateWithoutClinicPetParentInput;
  update: ChannelMemberUpdateWithoutClinicPetParentInput;
  where: ChannelMemberWhereUniqueInput;
};

export type ChannelMemberUpsertWithWhereUniqueWithoutUserInput = {
  create: ChannelMemberCreateWithoutUserInput;
  update: ChannelMemberUpdateWithoutUserInput;
  where: ChannelMemberWhereUniqueInput;
};

export type ChannelMemberUpsertWithoutChannelMessagesInput = {
  create: ChannelMemberCreateWithoutChannelMessagesInput;
  update: ChannelMemberUpdateWithoutChannelMessagesInput;
  where?: Maybe<ChannelMemberWhereInput>;
};

export type ChannelMemberWhereInput = {
  AND?: Maybe<Array<ChannelMemberWhereInput>>;
  NOT?: Maybe<Array<ChannelMemberWhereInput>>;
  OR?: Maybe<Array<ChannelMemberWhereInput>>;
  attributes?: Maybe<JsonNullableFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  channelMessages?: Maybe<ChannelMessageListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draft?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  lastConsumedMessageIndex?: Maybe<IntNullableFilter>;
  lastConsumptionTimestamp?: Maybe<DateTimeNullableFilter>;
  removedAt?: Maybe<DateTimeNullableFilter>;
  sendMessageNotification?: Maybe<BoolFilter>;
  twilioIdentity?: Maybe<StringNullableFilter>;
  twilioMemberSid?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type ChannelMemberWhereUniqueInput = {
  AND?: Maybe<Array<ChannelMemberWhereInput>>;
  NOT?: Maybe<Array<ChannelMemberWhereInput>>;
  OR?: Maybe<Array<ChannelMemberWhereInput>>;
  attributes?: Maybe<JsonNullableFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  channelMessages?: Maybe<ChannelMessageListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draft?: Maybe<JsonNullableFilter>;
  id?: Maybe<Scalars['String']>;
  lastConsumedMessageIndex?: Maybe<IntNullableFilter>;
  lastConsumptionTimestamp?: Maybe<DateTimeNullableFilter>;
  removedAt?: Maybe<DateTimeNullableFilter>;
  sendMessageNotification?: Maybe<BoolFilter>;
  twilioIdentity?: Maybe<StringNullableFilter>;
  twilioMemberSid?: Maybe<StringNullableFilter>;
  uniqueChannelMemberForPetParentAndChannel?: Maybe<ChannelMemberUniqueChannelMemberForPetParentAndChannelCompoundUniqueInput>;
  uniqueChannelMemberForUserAndChannel?: Maybe<ChannelMemberUniqueChannelMemberForUserAndChannelCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type ChannelMessage = {
  __typename?: 'ChannelMessage';
  _count: ChannelMessageCountOutputType;
  attachments: Array<ChannelMessageAttachment>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMember>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses: Array<ChannelMessageAutoResponse>;
  automationRun?: Maybe<AutomationRun>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  isUnreadEligible: Scalars['Boolean'];
  lastMessageChannel: Array<Channel>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers: Array<User>;
  messageType: MessageType;
  pushNotificationLogs: Array<PushNotificationLog>;
  reactions: Array<ChannelMessageReaction>;
  smsNotifificationStatuses: Array<SmsNotificationStatus>;
  source: MessageSource;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  wasEdited: Scalars['Boolean'];
};


export type ChannelMessageAttachmentsArgs = {
  cursor?: Maybe<ChannelMessageAttachmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageAttachmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageAttachmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageAttachmentWhereInput>;
};


export type ChannelMessageAuthorArgs = {
  where?: Maybe<ChannelMemberWhereInput>;
};


export type ChannelMessageAutoResponsesArgs = {
  cursor?: Maybe<ChannelMessageAutoResponseWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageAutoResponseScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageAutoResponseOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageAutoResponseWhereInput>;
};


export type ChannelMessageAutomationRunArgs = {
  where?: Maybe<AutomationRunWhereInput>;
};


export type ChannelMessageChannelArgs = {
  where?: Maybe<ChannelWhereInput>;
};


export type ChannelMessageLastMessageChannelArgs = {
  cursor?: Maybe<ChannelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelWhereInput>;
};


export type ChannelMessageMentionedUsersArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type ChannelMessagePushNotificationLogsArgs = {
  cursor?: Maybe<PushNotificationLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PushNotificationLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PushNotificationLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PushNotificationLogWhereInput>;
};


export type ChannelMessageReactionsArgs = {
  cursor?: Maybe<ChannelMessageReactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageReactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageReactionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageReactionWhereInput>;
};


export type ChannelMessageSmsNotifificationStatusesArgs = {
  cursor?: Maybe<SmsNotificationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SmsNotificationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SmsNotificationStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SmsNotificationStatusWhereInput>;
};

export type ChannelMessageAttachment = {
  __typename?: 'ChannelMessageAttachment';
  _count: ChannelMessageAttachmentCountOutputType;
  attachmentType: ChannelMessageAttachmentType;
  channelMessage: Array<ChannelMessage>;
  computed_optimizedAttachment?: Maybe<Scalars['String']>;
  computed_urlExpiresAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};


export type ChannelMessageAttachmentChannelMessageArgs = {
  cursor?: Maybe<ChannelMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageWhereInput>;
};


export type ChannelMessageAttachmentMediaArgs = {
  where?: Maybe<MediaWhereInput>;
};

export type ChannelMessageAttachmentCountAggregateOutputType = {
  __typename?: 'ChannelMessageAttachmentCountAggregateOutputType';
  _all: Scalars['Int'];
  attachmentType: Scalars['Int'];
  createdAt: Scalars['Int'];
  entityId: Scalars['Int'];
  entityType: Scalars['Int'];
  filename: Scalars['Int'];
  id: Scalars['Int'];
  mediaId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  uploadStatus: Scalars['Int'];
  url: Scalars['Int'];
};

export type ChannelMessageAttachmentCountOrderByAggregateInput = {
  attachmentType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  filename?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mediaId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploadStatus?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type ChannelMessageAttachmentCountOutputType = {
  __typename?: 'ChannelMessageAttachmentCountOutputType';
  channelMessage: Scalars['Int'];
};

export type ChannelMessageAttachmentCreateInput = {
  attachmentType: ChannelMessageAttachmentType;
  channelMessage?: Maybe<ChannelMessageCreateNestedManyWithoutAttachmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  media?: Maybe<MediaCreateNestedOneWithoutChannelMessageAttachmentsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentCreateManyInput = {
  attachmentType: ChannelMessageAttachmentType;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentCreateManyMediaInput = {
  attachmentType: ChannelMessageAttachmentType;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentCreateManyMediaInputEnvelope = {
  data: Array<ChannelMessageAttachmentCreateManyMediaInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageAttachmentCreateNestedManyWithoutChannelMessageInput = {
  connect?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageAttachmentCreateOrConnectWithoutChannelMessageInput>>;
  create?: Maybe<Array<ChannelMessageAttachmentCreateWithoutChannelMessageInput>>;
};

export type ChannelMessageAttachmentCreateNestedManyWithoutMediaInput = {
  connect?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageAttachmentCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<ChannelMessageAttachmentCreateWithoutMediaInput>>;
  createMany?: Maybe<ChannelMessageAttachmentCreateManyMediaInputEnvelope>;
};

export type ChannelMessageAttachmentCreateOrConnectWithoutChannelMessageInput = {
  create: ChannelMessageAttachmentCreateWithoutChannelMessageInput;
  where: ChannelMessageAttachmentWhereUniqueInput;
};

export type ChannelMessageAttachmentCreateOrConnectWithoutMediaInput = {
  create: ChannelMessageAttachmentCreateWithoutMediaInput;
  where: ChannelMessageAttachmentWhereUniqueInput;
};

export type ChannelMessageAttachmentCreateWithoutChannelMessageInput = {
  attachmentType: ChannelMessageAttachmentType;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  media?: Maybe<MediaCreateNestedOneWithoutChannelMessageAttachmentsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentCreateWithoutMediaInput = {
  attachmentType: ChannelMessageAttachmentType;
  channelMessage?: Maybe<ChannelMessageCreateNestedManyWithoutAttachmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export enum ChannelMessageAttachmentEntityType {
  Appointment = 'Appointment',
  AutomationRun = 'AutomationRun',
  ClinicWidgetRequest = 'ClinicWidgetRequest',
  Form = 'Form',
  ServiceReminderNotification = 'ServiceReminderNotification',
  StripePaymentIntent = 'StripePaymentIntent',
  Transaction = 'Transaction'
}

export type ChannelMessageAttachmentGroupByOutputType = {
  __typename?: 'ChannelMessageAttachmentGroupByOutputType';
  _count?: Maybe<ChannelMessageAttachmentCountAggregateOutputType>;
  _max?: Maybe<ChannelMessageAttachmentMaxAggregateOutputType>;
  _min?: Maybe<ChannelMessageAttachmentMinAggregateOutputType>;
  attachmentType: ChannelMessageAttachmentType;
  createdAt: Scalars['DateTime'];
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mediaId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentListRelationFilter = {
  every?: Maybe<ChannelMessageAttachmentWhereInput>;
  none?: Maybe<ChannelMessageAttachmentWhereInput>;
  some?: Maybe<ChannelMessageAttachmentWhereInput>;
};

export type ChannelMessageAttachmentMaxAggregateOutputType = {
  __typename?: 'ChannelMessageAttachmentMaxAggregateOutputType';
  attachmentType?: Maybe<ChannelMessageAttachmentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentMaxOrderByAggregateInput = {
  attachmentType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  filename?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mediaId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploadStatus?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type ChannelMessageAttachmentMinAggregateOutputType = {
  __typename?: 'ChannelMessageAttachmentMinAggregateOutputType';
  attachmentType?: Maybe<ChannelMessageAttachmentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentMinOrderByAggregateInput = {
  attachmentType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  filename?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mediaId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploadStatus?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type ChannelMessageAttachmentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelMessageAttachmentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelMessageAttachmentOrderByRelevanceInput>;
  attachmentType?: Maybe<SortOrder>;
  channelMessage?: Maybe<ChannelMessageOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  filename?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  media?: Maybe<MediaOrderByWithRelationInput>;
  mediaId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploadStatus?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export enum ChannelMessageAttachmentOrderByRelevanceFieldEnum {
  EntityId = 'entityId',
  Filename = 'filename',
  Id = 'id',
  MediaId = 'mediaId',
  Url = 'url'
}

export type ChannelMessageAttachmentOrderByRelevanceInput = {
  fields: Array<ChannelMessageAttachmentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelMessageAttachmentOrderByWithAggregationInput = {
  _count?: Maybe<ChannelMessageAttachmentCountOrderByAggregateInput>;
  _max?: Maybe<ChannelMessageAttachmentMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelMessageAttachmentMinOrderByAggregateInput>;
  attachmentType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  filename?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mediaId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploadStatus?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type ChannelMessageAttachmentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelMessageAttachmentOrderByRelevanceInput>;
  attachmentType?: Maybe<SortOrder>;
  channelMessage?: Maybe<ChannelMessageOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  filename?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  media?: Maybe<MediaOrderByWithRelationInput>;
  mediaId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploadStatus?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type ChannelMessageAttachmentOrderByWithRelationInput = {
  _relevance?: Maybe<ChannelMessageAttachmentOrderByRelevanceInput>;
  attachmentType?: Maybe<SortOrder>;
  channelMessage?: Maybe<ChannelMessageOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  filename?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  media?: Maybe<MediaOrderByWithRelationInput>;
  mediaId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploadStatus?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export enum ChannelMessageAttachmentScalarFieldEnum {
  AttachmentType = 'attachmentType',
  CreatedAt = 'createdAt',
  EntityId = 'entityId',
  EntityType = 'entityType',
  Filename = 'filename',
  Id = 'id',
  MediaId = 'mediaId',
  UpdatedAt = 'updatedAt',
  UploadStatus = 'uploadStatus',
  Url = 'url'
}

export type ChannelMessageAttachmentScalarWhereInput = {
  AND?: Maybe<Array<ChannelMessageAttachmentScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageAttachmentScalarWhereInput>>;
  OR?: Maybe<Array<ChannelMessageAttachmentScalarWhereInput>>;
  attachmentType?: Maybe<EnumChannelMessageAttachmentTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entityId?: Maybe<StringNullableFilter>;
  entityType?: Maybe<EnumChannelMessageAttachmentEntityTypeNullableFilter>;
  filename?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uploadStatus?: Maybe<EnumChannelMessageAttachmentUploadStatusNullableFilter>;
  url?: Maybe<StringNullableFilter>;
};

export type ChannelMessageAttachmentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelMessageAttachmentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelMessageAttachmentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelMessageAttachmentScalarWhereWithAggregatesInput>>;
  attachmentType?: Maybe<EnumChannelMessageAttachmentTypeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  entityId?: Maybe<StringNullableWithAggregatesFilter>;
  entityType?: Maybe<EnumChannelMessageAttachmentEntityTypeNullableWithAggregatesFilter>;
  filename?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  mediaId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  uploadStatus?: Maybe<EnumChannelMessageAttachmentUploadStatusNullableWithAggregatesFilter>;
  url?: Maybe<StringNullableWithAggregatesFilter>;
};

export type ChannelMessageAttachmentSubscription = {
  __typename?: 'ChannelMessageAttachmentSubscription';
  mutation: MutationType;
  node: ChannelMessageAttachment;
};

export enum ChannelMessageAttachmentType {
  AppointmentArrival = 'AppointmentArrival',
  AppointmentConfirmation = 'AppointmentConfirmation',
  AppointmentReminder = 'AppointmentReminder',
  AutomationRun = 'AutomationRun',
  CallHistory = 'CallHistory',
  CallRequest = 'CallRequest',
  File = 'File',
  FormRequest = 'FormRequest',
  Image = 'Image',
  Invoice = 'Invoice',
  PetParentRequest = 'PetParentRequest',
  ServiceReminderFormSubmission = 'ServiceReminderFormSubmission',
  ServiceReminderNotification = 'ServiceReminderNotification',
  Video = 'Video',
  WidgetRequest = 'WidgetRequest'
}

export type ChannelMessageAttachmentUncheckedCreateInput = {
  attachmentType: ChannelMessageAttachmentType;
  channelMessage?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutAttachmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentUncheckedCreateNestedManyWithoutChannelMessageInput = {
  connect?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageAttachmentCreateOrConnectWithoutChannelMessageInput>>;
  create?: Maybe<Array<ChannelMessageAttachmentCreateWithoutChannelMessageInput>>;
};

export type ChannelMessageAttachmentUncheckedCreateNestedManyWithoutMediaInput = {
  connect?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageAttachmentCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<ChannelMessageAttachmentCreateWithoutMediaInput>>;
  createMany?: Maybe<ChannelMessageAttachmentCreateManyMediaInputEnvelope>;
};

export type ChannelMessageAttachmentUncheckedCreateWithoutChannelMessageInput = {
  attachmentType: ChannelMessageAttachmentType;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentUncheckedCreateWithoutMediaInput = {
  attachmentType: ChannelMessageAttachmentType;
  channelMessage?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutAttachmentsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentUncheckedUpdateInput = {
  attachmentType?: Maybe<ChannelMessageAttachmentType>;
  channelMessage?: Maybe<ChannelMessageUncheckedUpdateManyWithoutAttachmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentUncheckedUpdateManyInput = {
  attachmentType?: Maybe<ChannelMessageAttachmentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentUncheckedUpdateManyWithoutChannelMessageInput = {
  attachmentType?: Maybe<ChannelMessageAttachmentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentUncheckedUpdateManyWithoutChannelMessageNestedInput = {
  connect?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageAttachmentCreateOrConnectWithoutChannelMessageInput>>;
  create?: Maybe<Array<ChannelMessageAttachmentCreateWithoutChannelMessageInput>>;
  delete?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageAttachmentScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageAttachmentUpdateWithWhereUniqueWithoutChannelMessageInput>>;
  updateMany?: Maybe<Array<ChannelMessageAttachmentUpdateManyWithWhereWithoutChannelMessageInput>>;
  upsert?: Maybe<Array<ChannelMessageAttachmentUpsertWithWhereUniqueWithoutChannelMessageInput>>;
};

export type ChannelMessageAttachmentUncheckedUpdateManyWithoutMediaInput = {
  attachmentType?: Maybe<ChannelMessageAttachmentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentUncheckedUpdateManyWithoutMediaNestedInput = {
  connect?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageAttachmentCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<ChannelMessageAttachmentCreateWithoutMediaInput>>;
  createMany?: Maybe<ChannelMessageAttachmentCreateManyMediaInputEnvelope>;
  delete?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageAttachmentScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageAttachmentUpdateWithWhereUniqueWithoutMediaInput>>;
  updateMany?: Maybe<Array<ChannelMessageAttachmentUpdateManyWithWhereWithoutMediaInput>>;
  upsert?: Maybe<Array<ChannelMessageAttachmentUpsertWithWhereUniqueWithoutMediaInput>>;
};

export type ChannelMessageAttachmentUncheckedUpdateWithoutChannelMessageInput = {
  attachmentType?: Maybe<ChannelMessageAttachmentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentUncheckedUpdateWithoutMediaInput = {
  attachmentType?: Maybe<ChannelMessageAttachmentType>;
  channelMessage?: Maybe<ChannelMessageUncheckedUpdateManyWithoutAttachmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentUpdateInput = {
  attachmentType?: Maybe<ChannelMessageAttachmentType>;
  channelMessage?: Maybe<ChannelMessageUpdateManyWithoutAttachmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  media?: Maybe<MediaUpdateOneWithoutChannelMessageAttachmentsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentUpdateManyMutationInput = {
  attachmentType?: Maybe<ChannelMessageAttachmentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentUpdateManyWithWhereWithoutChannelMessageInput = {
  data: ChannelMessageAttachmentUpdateManyMutationInput;
  where: ChannelMessageAttachmentScalarWhereInput;
};

export type ChannelMessageAttachmentUpdateManyWithWhereWithoutMediaInput = {
  data: ChannelMessageAttachmentUpdateManyMutationInput;
  where: ChannelMessageAttachmentScalarWhereInput;
};

export type ChannelMessageAttachmentUpdateManyWithoutChannelMessageNestedInput = {
  connect?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageAttachmentCreateOrConnectWithoutChannelMessageInput>>;
  create?: Maybe<Array<ChannelMessageAttachmentCreateWithoutChannelMessageInput>>;
  delete?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageAttachmentScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageAttachmentUpdateWithWhereUniqueWithoutChannelMessageInput>>;
  updateMany?: Maybe<Array<ChannelMessageAttachmentUpdateManyWithWhereWithoutChannelMessageInput>>;
  upsert?: Maybe<Array<ChannelMessageAttachmentUpsertWithWhereUniqueWithoutChannelMessageInput>>;
};

export type ChannelMessageAttachmentUpdateManyWithoutMediaNestedInput = {
  connect?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageAttachmentCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<ChannelMessageAttachmentCreateWithoutMediaInput>>;
  createMany?: Maybe<ChannelMessageAttachmentCreateManyMediaInputEnvelope>;
  delete?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageAttachmentScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageAttachmentWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageAttachmentUpdateWithWhereUniqueWithoutMediaInput>>;
  updateMany?: Maybe<Array<ChannelMessageAttachmentUpdateManyWithWhereWithoutMediaInput>>;
  upsert?: Maybe<Array<ChannelMessageAttachmentUpsertWithWhereUniqueWithoutMediaInput>>;
};

export type ChannelMessageAttachmentUpdateWithWhereUniqueWithoutChannelMessageInput = {
  data: ChannelMessageAttachmentUpdateWithoutChannelMessageInput;
  where: ChannelMessageAttachmentWhereUniqueInput;
};

export type ChannelMessageAttachmentUpdateWithWhereUniqueWithoutMediaInput = {
  data: ChannelMessageAttachmentUpdateWithoutMediaInput;
  where: ChannelMessageAttachmentWhereUniqueInput;
};

export type ChannelMessageAttachmentUpdateWithoutChannelMessageInput = {
  attachmentType?: Maybe<ChannelMessageAttachmentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  media?: Maybe<MediaUpdateOneWithoutChannelMessageAttachmentsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type ChannelMessageAttachmentUpdateWithoutMediaInput = {
  attachmentType?: Maybe<ChannelMessageAttachmentType>;
  channelMessage?: Maybe<ChannelMessageUpdateManyWithoutAttachmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export enum ChannelMessageAttachmentUploadStatus {
  Error = 'Error',
  InProgress = 'InProgress',
  Pending = 'Pending',
  Success = 'Success'
}

export type ChannelMessageAttachmentUpsertWithWhereUniqueWithoutChannelMessageInput = {
  create: ChannelMessageAttachmentCreateWithoutChannelMessageInput;
  update: ChannelMessageAttachmentUpdateWithoutChannelMessageInput;
  where: ChannelMessageAttachmentWhereUniqueInput;
};

export type ChannelMessageAttachmentUpsertWithWhereUniqueWithoutMediaInput = {
  create: ChannelMessageAttachmentCreateWithoutMediaInput;
  update: ChannelMessageAttachmentUpdateWithoutMediaInput;
  where: ChannelMessageAttachmentWhereUniqueInput;
};

export type ChannelMessageAttachmentWhereInput = {
  AND?: Maybe<Array<ChannelMessageAttachmentWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageAttachmentWhereInput>>;
  OR?: Maybe<Array<ChannelMessageAttachmentWhereInput>>;
  attachmentType?: Maybe<EnumChannelMessageAttachmentTypeFilter>;
  channelMessage?: Maybe<ChannelMessageListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entityId?: Maybe<StringNullableFilter>;
  entityType?: Maybe<EnumChannelMessageAttachmentEntityTypeNullableFilter>;
  filename?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  media?: Maybe<MediaNullableScalarRelationFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uploadStatus?: Maybe<EnumChannelMessageAttachmentUploadStatusNullableFilter>;
  url?: Maybe<StringNullableFilter>;
};

export type ChannelMessageAttachmentWhereUniqueInput = {
  AND?: Maybe<Array<ChannelMessageAttachmentWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageAttachmentWhereInput>>;
  OR?: Maybe<Array<ChannelMessageAttachmentWhereInput>>;
  attachmentType?: Maybe<EnumChannelMessageAttachmentTypeFilter>;
  channelMessage?: Maybe<ChannelMessageListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entityId?: Maybe<StringNullableFilter>;
  entityType?: Maybe<EnumChannelMessageAttachmentEntityTypeNullableFilter>;
  filename?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  media?: Maybe<MediaNullableScalarRelationFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uploadStatus?: Maybe<EnumChannelMessageAttachmentUploadStatusNullableFilter>;
  url?: Maybe<StringNullableFilter>;
};

export type ChannelMessageAutoResponse = {
  __typename?: 'ChannelMessageAutoResponse';
  aiSuggestionMessage: Scalars['String'];
  channelMessage?: Maybe<ChannelMessage>;
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  suggestionStatus: AutoResponseSuggestionStatus;
  updatedAt: Scalars['DateTime'];
};


export type ChannelMessageAutoResponseChannelMessageArgs = {
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageAutoResponseCountAggregateOutputType = {
  __typename?: 'ChannelMessageAutoResponseCountAggregateOutputType';
  _all: Scalars['Int'];
  aiSuggestionMessage: Scalars['Int'];
  channelMessageId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  suggestionStatus: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ChannelMessageAutoResponseCountOrderByAggregateInput = {
  aiSuggestionMessage?: Maybe<SortOrder>;
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  suggestionStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelMessageAutoResponseCreateInput = {
  aiSuggestionMessage: Scalars['String'];
  channelMessage?: Maybe<ChannelMessageCreateNestedOneWithoutAutoResponsesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus: AutoResponseSuggestionStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseCreateManyChannelMessageInput = {
  aiSuggestionMessage: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus: AutoResponseSuggestionStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseCreateManyChannelMessageInputEnvelope = {
  data: Array<ChannelMessageAutoResponseCreateManyChannelMessageInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageAutoResponseCreateManyInput = {
  aiSuggestionMessage: Scalars['String'];
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus: AutoResponseSuggestionStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseCreateNestedManyWithoutChannelMessageInput = {
  connect?: Maybe<Array<ChannelMessageAutoResponseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageAutoResponseCreateOrConnectWithoutChannelMessageInput>>;
  create?: Maybe<Array<ChannelMessageAutoResponseCreateWithoutChannelMessageInput>>;
  createMany?: Maybe<ChannelMessageAutoResponseCreateManyChannelMessageInputEnvelope>;
};

export type ChannelMessageAutoResponseCreateOrConnectWithoutChannelMessageInput = {
  create: ChannelMessageAutoResponseCreateWithoutChannelMessageInput;
  where: ChannelMessageAutoResponseWhereUniqueInput;
};

export type ChannelMessageAutoResponseCreateWithoutChannelMessageInput = {
  aiSuggestionMessage: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus: AutoResponseSuggestionStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseGroupByOutputType = {
  __typename?: 'ChannelMessageAutoResponseGroupByOutputType';
  _count?: Maybe<ChannelMessageAutoResponseCountAggregateOutputType>;
  _max?: Maybe<ChannelMessageAutoResponseMaxAggregateOutputType>;
  _min?: Maybe<ChannelMessageAutoResponseMinAggregateOutputType>;
  aiSuggestionMessage: Scalars['String'];
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  suggestionStatus: AutoResponseSuggestionStatus;
  updatedAt: Scalars['DateTime'];
};

export type ChannelMessageAutoResponseListRelationFilter = {
  every?: Maybe<ChannelMessageAutoResponseWhereInput>;
  none?: Maybe<ChannelMessageAutoResponseWhereInput>;
  some?: Maybe<ChannelMessageAutoResponseWhereInput>;
};

export type ChannelMessageAutoResponseMaxAggregateOutputType = {
  __typename?: 'ChannelMessageAutoResponseMaxAggregateOutputType';
  aiSuggestionMessage?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus?: Maybe<AutoResponseSuggestionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseMaxOrderByAggregateInput = {
  aiSuggestionMessage?: Maybe<SortOrder>;
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  suggestionStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelMessageAutoResponseMinAggregateOutputType = {
  __typename?: 'ChannelMessageAutoResponseMinAggregateOutputType';
  aiSuggestionMessage?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus?: Maybe<AutoResponseSuggestionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseMinOrderByAggregateInput = {
  aiSuggestionMessage?: Maybe<SortOrder>;
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  suggestionStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelMessageAutoResponseOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelMessageAutoResponseOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelMessageAutoResponseOrderByRelevanceInput>;
  aiSuggestionMessage?: Maybe<SortOrder>;
  channelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  suggestionStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ChannelMessageAutoResponseOrderByRelevanceFieldEnum {
  AiSuggestionMessage = 'aiSuggestionMessage',
  ChannelMessageId = 'channelMessageId',
  Id = 'id'
}

export type ChannelMessageAutoResponseOrderByRelevanceInput = {
  fields: Array<ChannelMessageAutoResponseOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelMessageAutoResponseOrderByWithAggregationInput = {
  _count?: Maybe<ChannelMessageAutoResponseCountOrderByAggregateInput>;
  _max?: Maybe<ChannelMessageAutoResponseMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelMessageAutoResponseMinOrderByAggregateInput>;
  aiSuggestionMessage?: Maybe<SortOrder>;
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  suggestionStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelMessageAutoResponseOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelMessageAutoResponseOrderByRelevanceInput>;
  aiSuggestionMessage?: Maybe<SortOrder>;
  channelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  suggestionStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelMessageAutoResponseOrderByWithRelationInput = {
  _relevance?: Maybe<ChannelMessageAutoResponseOrderByRelevanceInput>;
  aiSuggestionMessage?: Maybe<SortOrder>;
  channelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  suggestionStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ChannelMessageAutoResponseScalarFieldEnum {
  AiSuggestionMessage = 'aiSuggestionMessage',
  ChannelMessageId = 'channelMessageId',
  CreatedAt = 'createdAt',
  Id = 'id',
  SuggestionStatus = 'suggestionStatus',
  UpdatedAt = 'updatedAt'
}

export type ChannelMessageAutoResponseScalarWhereInput = {
  AND?: Maybe<Array<ChannelMessageAutoResponseScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageAutoResponseScalarWhereInput>>;
  OR?: Maybe<Array<ChannelMessageAutoResponseScalarWhereInput>>;
  aiSuggestionMessage?: Maybe<StringFilter>;
  channelMessageId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  suggestionStatus?: Maybe<EnumAutoResponseSuggestionStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChannelMessageAutoResponseScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelMessageAutoResponseScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelMessageAutoResponseScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelMessageAutoResponseScalarWhereWithAggregatesInput>>;
  aiSuggestionMessage?: Maybe<StringWithAggregatesFilter>;
  channelMessageId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  suggestionStatus?: Maybe<EnumAutoResponseSuggestionStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ChannelMessageAutoResponseUncheckedCreateInput = {
  aiSuggestionMessage: Scalars['String'];
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus: AutoResponseSuggestionStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseUncheckedCreateNestedManyWithoutChannelMessageInput = {
  connect?: Maybe<Array<ChannelMessageAutoResponseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageAutoResponseCreateOrConnectWithoutChannelMessageInput>>;
  create?: Maybe<Array<ChannelMessageAutoResponseCreateWithoutChannelMessageInput>>;
  createMany?: Maybe<ChannelMessageAutoResponseCreateManyChannelMessageInputEnvelope>;
};

export type ChannelMessageAutoResponseUncheckedCreateWithoutChannelMessageInput = {
  aiSuggestionMessage: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus: AutoResponseSuggestionStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseUncheckedUpdateInput = {
  aiSuggestionMessage?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus?: Maybe<AutoResponseSuggestionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseUncheckedUpdateManyInput = {
  aiSuggestionMessage?: Maybe<Scalars['String']>;
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus?: Maybe<AutoResponseSuggestionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseUncheckedUpdateManyWithoutChannelMessageInput = {
  aiSuggestionMessage?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus?: Maybe<AutoResponseSuggestionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseUncheckedUpdateManyWithoutChannelMessageNestedInput = {
  connect?: Maybe<Array<ChannelMessageAutoResponseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageAutoResponseCreateOrConnectWithoutChannelMessageInput>>;
  create?: Maybe<Array<ChannelMessageAutoResponseCreateWithoutChannelMessageInput>>;
  createMany?: Maybe<ChannelMessageAutoResponseCreateManyChannelMessageInputEnvelope>;
  delete?: Maybe<Array<ChannelMessageAutoResponseWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageAutoResponseScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageAutoResponseWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageAutoResponseWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageAutoResponseUpdateWithWhereUniqueWithoutChannelMessageInput>>;
  updateMany?: Maybe<Array<ChannelMessageAutoResponseUpdateManyWithWhereWithoutChannelMessageInput>>;
  upsert?: Maybe<Array<ChannelMessageAutoResponseUpsertWithWhereUniqueWithoutChannelMessageInput>>;
};

export type ChannelMessageAutoResponseUncheckedUpdateWithoutChannelMessageInput = {
  aiSuggestionMessage?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus?: Maybe<AutoResponseSuggestionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseUpdateInput = {
  aiSuggestionMessage?: Maybe<Scalars['String']>;
  channelMessage?: Maybe<ChannelMessageUpdateOneWithoutAutoResponsesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus?: Maybe<AutoResponseSuggestionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseUpdateManyMutationInput = {
  aiSuggestionMessage?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus?: Maybe<AutoResponseSuggestionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseUpdateManyWithWhereWithoutChannelMessageInput = {
  data: ChannelMessageAutoResponseUpdateManyMutationInput;
  where: ChannelMessageAutoResponseScalarWhereInput;
};

export type ChannelMessageAutoResponseUpdateManyWithoutChannelMessageNestedInput = {
  connect?: Maybe<Array<ChannelMessageAutoResponseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageAutoResponseCreateOrConnectWithoutChannelMessageInput>>;
  create?: Maybe<Array<ChannelMessageAutoResponseCreateWithoutChannelMessageInput>>;
  createMany?: Maybe<ChannelMessageAutoResponseCreateManyChannelMessageInputEnvelope>;
  delete?: Maybe<Array<ChannelMessageAutoResponseWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageAutoResponseScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageAutoResponseWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageAutoResponseWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageAutoResponseUpdateWithWhereUniqueWithoutChannelMessageInput>>;
  updateMany?: Maybe<Array<ChannelMessageAutoResponseUpdateManyWithWhereWithoutChannelMessageInput>>;
  upsert?: Maybe<Array<ChannelMessageAutoResponseUpsertWithWhereUniqueWithoutChannelMessageInput>>;
};

export type ChannelMessageAutoResponseUpdateWithWhereUniqueWithoutChannelMessageInput = {
  data: ChannelMessageAutoResponseUpdateWithoutChannelMessageInput;
  where: ChannelMessageAutoResponseWhereUniqueInput;
};

export type ChannelMessageAutoResponseUpdateWithoutChannelMessageInput = {
  aiSuggestionMessage?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus?: Maybe<AutoResponseSuggestionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageAutoResponseUpsertWithWhereUniqueWithoutChannelMessageInput = {
  create: ChannelMessageAutoResponseCreateWithoutChannelMessageInput;
  update: ChannelMessageAutoResponseUpdateWithoutChannelMessageInput;
  where: ChannelMessageAutoResponseWhereUniqueInput;
};

export type ChannelMessageAutoResponseWhereInput = {
  AND?: Maybe<Array<ChannelMessageAutoResponseWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageAutoResponseWhereInput>>;
  OR?: Maybe<Array<ChannelMessageAutoResponseWhereInput>>;
  aiSuggestionMessage?: Maybe<StringFilter>;
  channelMessage?: Maybe<ChannelMessageNullableScalarRelationFilter>;
  channelMessageId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  suggestionStatus?: Maybe<EnumAutoResponseSuggestionStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChannelMessageAutoResponseWhereUniqueInput = {
  AND?: Maybe<Array<ChannelMessageAutoResponseWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageAutoResponseWhereInput>>;
  OR?: Maybe<Array<ChannelMessageAutoResponseWhereInput>>;
  aiSuggestionMessage?: Maybe<StringFilter>;
  channelMessage?: Maybe<ChannelMessageNullableScalarRelationFilter>;
  channelMessageId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  suggestionStatus?: Maybe<EnumAutoResponseSuggestionStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChannelMessageAvgAggregateOutputType = {
  __typename?: 'ChannelMessageAvgAggregateOutputType';
  index?: Maybe<Scalars['Float']>;
};

export type ChannelMessageAvgOrderByAggregateInput = {
  index?: Maybe<SortOrder>;
};

export type ChannelMessageCountAggregateOutputType = {
  __typename?: 'ChannelMessageCountAggregateOutputType';
  _all: Scalars['Int'];
  attributes: Scalars['Int'];
  authorId: Scalars['Int'];
  body: Scalars['Int'];
  channelId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  forceReadReceipt: Scalars['Int'];
  id: Scalars['Int'];
  index: Scalars['Int'];
  isUnreadEligible: Scalars['Int'];
  lastUpdatedBy: Scalars['Int'];
  media: Scalars['Int'];
  messageType: Scalars['Int'];
  source: Scalars['Int'];
  sourcePhoneNumber: Scalars['Int'];
  twilioMessageSid: Scalars['Int'];
  updatedAt: Scalars['Int'];
  wasEdited: Scalars['Int'];
};

export type ChannelMessageCountOrderByAggregateInput = {
  attributes?: Maybe<SortOrder>;
  authorId?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  forceReadReceipt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  index?: Maybe<SortOrder>;
  isUnreadEligible?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  media?: Maybe<SortOrder>;
  messageType?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  sourcePhoneNumber?: Maybe<SortOrder>;
  twilioMessageSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  wasEdited?: Maybe<SortOrder>;
};

export type ChannelMessageCountOutputType = {
  __typename?: 'ChannelMessageCountOutputType';
  attachments: Scalars['Int'];
  autoResponses: Scalars['Int'];
  lastMessageChannel: Scalars['Int'];
  mentionedUsers: Scalars['Int'];
  pushNotificationLogs: Scalars['Int'];
  reactions: Scalars['Int'];
  smsNotifificationStatuses: Scalars['Int'];
};

export type ChannelMessageCreateInput = {
  attachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberCreateNestedOneWithoutChannelMessagesInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutMessagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateManyAuthorInput = {
  attributes?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType: MessageType;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateManyAuthorInputEnvelope = {
  data: Array<ChannelMessageCreateManyAuthorInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateManyChannelInput = {
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType: MessageType;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateManyChannelInputEnvelope = {
  data: Array<ChannelMessageCreateManyChannelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateManyInput = {
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType: MessageType;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateNestedManyWithoutAttachmentsInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutAttachmentsInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutAttachmentsInput>>;
};

export type ChannelMessageCreateNestedManyWithoutAuthorInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutAuthorInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutAuthorInput>>;
  createMany?: Maybe<ChannelMessageCreateManyAuthorInputEnvelope>;
};

export type ChannelMessageCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelMessageCreateManyChannelInputEnvelope>;
};

export type ChannelMessageCreateNestedManyWithoutMentionedUsersInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutMentionedUsersInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutMentionedUsersInput>>;
};

export type ChannelMessageCreateNestedOneWithoutAutoResponsesInput = {
  connect?: Maybe<ChannelMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMessageCreateOrConnectWithoutAutoResponsesInput>;
  create?: Maybe<ChannelMessageCreateWithoutAutoResponsesInput>;
};

export type ChannelMessageCreateNestedOneWithoutAutomationRunInput = {
  connect?: Maybe<ChannelMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMessageCreateOrConnectWithoutAutomationRunInput>;
  create?: Maybe<ChannelMessageCreateWithoutAutomationRunInput>;
};

export type ChannelMessageCreateNestedOneWithoutLastMessageChannelInput = {
  connect?: Maybe<ChannelMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMessageCreateOrConnectWithoutLastMessageChannelInput>;
  create?: Maybe<ChannelMessageCreateWithoutLastMessageChannelInput>;
};

export type ChannelMessageCreateNestedOneWithoutPushNotificationLogsInput = {
  connect?: Maybe<ChannelMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMessageCreateOrConnectWithoutPushNotificationLogsInput>;
  create?: Maybe<ChannelMessageCreateWithoutPushNotificationLogsInput>;
};

export type ChannelMessageCreateNestedOneWithoutReactionsInput = {
  connect?: Maybe<ChannelMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMessageCreateOrConnectWithoutReactionsInput>;
  create?: Maybe<ChannelMessageCreateWithoutReactionsInput>;
};

export type ChannelMessageCreateNestedOneWithoutSmsNotifificationStatusesInput = {
  connect?: Maybe<ChannelMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMessageCreateOrConnectWithoutSmsNotifificationStatusesInput>;
  create?: Maybe<ChannelMessageCreateWithoutSmsNotifificationStatusesInput>;
};

export type ChannelMessageCreateOrConnectWithoutAttachmentsInput = {
  create: ChannelMessageCreateWithoutAttachmentsInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageCreateOrConnectWithoutAuthorInput = {
  create: ChannelMessageCreateWithoutAuthorInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageCreateOrConnectWithoutAutoResponsesInput = {
  create: ChannelMessageCreateWithoutAutoResponsesInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageCreateOrConnectWithoutAutomationRunInput = {
  create: ChannelMessageCreateWithoutAutomationRunInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageCreateOrConnectWithoutChannelInput = {
  create: ChannelMessageCreateWithoutChannelInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageCreateOrConnectWithoutLastMessageChannelInput = {
  create: ChannelMessageCreateWithoutLastMessageChannelInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageCreateOrConnectWithoutMentionedUsersInput = {
  create: ChannelMessageCreateWithoutMentionedUsersInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageCreateOrConnectWithoutPushNotificationLogsInput = {
  create: ChannelMessageCreateWithoutPushNotificationLogsInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageCreateOrConnectWithoutReactionsInput = {
  create: ChannelMessageCreateWithoutReactionsInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageCreateOrConnectWithoutSmsNotifificationStatusesInput = {
  create: ChannelMessageCreateWithoutSmsNotifificationStatusesInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageCreateWithoutAttachmentsInput = {
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberCreateNestedOneWithoutChannelMessagesInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutMessagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateWithoutAuthorInput = {
  attachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutMessagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateWithoutAutoResponsesInput = {
  attachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberCreateNestedOneWithoutChannelMessagesInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutMessagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateWithoutAutomationRunInput = {
  attachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberCreateNestedOneWithoutChannelMessagesInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseCreateNestedManyWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutMessagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateWithoutChannelInput = {
  attachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberCreateNestedOneWithoutChannelMessagesInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateWithoutLastMessageChannelInput = {
  attachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberCreateNestedOneWithoutChannelMessagesInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutMessagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateWithoutMentionedUsersInput = {
  attachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberCreateNestedOneWithoutChannelMessagesInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutMessagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateWithoutPushNotificationLogsInput = {
  attachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberCreateNestedOneWithoutChannelMessagesInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutMessagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  reactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateWithoutReactionsInput = {
  attachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberCreateNestedOneWithoutChannelMessagesInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutMessagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutSentChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageCreateWithoutSmsNotifificationStatusesInput = {
  attachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberCreateNestedOneWithoutChannelMessagesInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelCreateNestedOneWithoutMessagesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageGroupByOutputType = {
  __typename?: 'ChannelMessageGroupByOutputType';
  _avg?: Maybe<ChannelMessageAvgAggregateOutputType>;
  _count?: Maybe<ChannelMessageCountAggregateOutputType>;
  _max?: Maybe<ChannelMessageMaxAggregateOutputType>;
  _min?: Maybe<ChannelMessageMinAggregateOutputType>;
  _sum?: Maybe<ChannelMessageSumAggregateOutputType>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  isUnreadEligible: Scalars['Boolean'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType: MessageType;
  source: MessageSource;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  wasEdited: Scalars['Boolean'];
};

export type ChannelMessageListRelationFilter = {
  every?: Maybe<ChannelMessageWhereInput>;
  none?: Maybe<ChannelMessageWhereInput>;
  some?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageMaxAggregateOutputType = {
  __typename?: 'ChannelMessageMaxAggregateOutputType';
  authorId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  messageType?: Maybe<MessageType>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageMaxOrderByAggregateInput = {
  authorId?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  forceReadReceipt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  index?: Maybe<SortOrder>;
  isUnreadEligible?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  messageType?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  sourcePhoneNumber?: Maybe<SortOrder>;
  twilioMessageSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  wasEdited?: Maybe<SortOrder>;
};

export type ChannelMessageMinAggregateOutputType = {
  __typename?: 'ChannelMessageMinAggregateOutputType';
  authorId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  messageType?: Maybe<MessageType>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageMinOrderByAggregateInput = {
  authorId?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  forceReadReceipt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  index?: Maybe<SortOrder>;
  isUnreadEligible?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  messageType?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  sourcePhoneNumber?: Maybe<SortOrder>;
  twilioMessageSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  wasEdited?: Maybe<SortOrder>;
};

export type ChannelMessageNullableScalarRelationFilter = {
  AND?: Maybe<Array<ChannelMessageWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageWhereInput>>;
  OR?: Maybe<Array<ChannelMessageWhereInput>>;
  attachments?: Maybe<ChannelMessageAttachmentListRelationFilter>;
  attributes?: Maybe<JsonNullableFilter>;
  author?: Maybe<ChannelMemberNullableScalarRelationFilter>;
  authorId?: Maybe<StringNullableFilter>;
  autoResponses?: Maybe<ChannelMessageAutoResponseListRelationFilter>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  body?: Maybe<StringNullableFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  forceReadReceipt?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  index?: Maybe<IntFilter>;
  isUnreadEligible?: Maybe<BoolFilter>;
  lastMessageChannel?: Maybe<ChannelListRelationFilter>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  media?: Maybe<JsonNullableFilter>;
  mentionedUsers?: Maybe<UserListRelationFilter>;
  messageType?: Maybe<EnumMessageTypeFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  reactions?: Maybe<ChannelMessageReactionListRelationFilter>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusListRelationFilter>;
  source?: Maybe<EnumMessageSourceFilter>;
  sourcePhoneNumber?: Maybe<StringNullableFilter>;
  twilioMessageSid?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  wasEdited?: Maybe<BoolFilter>;
};

export type ChannelMessageOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelMessageOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelMessageOrderByRelevanceInput>;
  attachments?: Maybe<ChannelMessageAttachmentOrderByRelationAggregateInput>;
  attributes?: Maybe<SortOrder>;
  author?: Maybe<ChannelMemberOrderByWithRelationInput>;
  authorId?: Maybe<SortOrder>;
  autoResponses?: Maybe<ChannelMessageAutoResponseOrderByRelationAggregateInput>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  body?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  forceReadReceipt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  index?: Maybe<SortOrder>;
  isUnreadEligible?: Maybe<SortOrder>;
  lastMessageChannel?: Maybe<ChannelOrderByRelationAggregateInput>;
  lastUpdatedBy?: Maybe<SortOrder>;
  media?: Maybe<SortOrder>;
  mentionedUsers?: Maybe<UserOrderByRelationAggregateInput>;
  messageType?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  reactions?: Maybe<ChannelMessageReactionOrderByRelationAggregateInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusOrderByRelationAggregateInput>;
  source?: Maybe<SortOrder>;
  sourcePhoneNumber?: Maybe<SortOrder>;
  twilioMessageSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  wasEdited?: Maybe<SortOrder>;
};

export enum ChannelMessageOrderByRelevanceFieldEnum {
  AuthorId = 'authorId',
  Body = 'body',
  ChannelId = 'channelId',
  Id = 'id',
  LastUpdatedBy = 'lastUpdatedBy',
  SourcePhoneNumber = 'sourcePhoneNumber',
  TwilioMessageSid = 'twilioMessageSid'
}

export type ChannelMessageOrderByRelevanceInput = {
  fields: Array<ChannelMessageOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelMessageOrderByWithAggregationInput = {
  _avg?: Maybe<ChannelMessageAvgOrderByAggregateInput>;
  _count?: Maybe<ChannelMessageCountOrderByAggregateInput>;
  _max?: Maybe<ChannelMessageMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelMessageMinOrderByAggregateInput>;
  _sum?: Maybe<ChannelMessageSumOrderByAggregateInput>;
  attributes?: Maybe<SortOrder>;
  authorId?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  forceReadReceipt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  index?: Maybe<SortOrder>;
  isUnreadEligible?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  media?: Maybe<SortOrder>;
  messageType?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  sourcePhoneNumber?: Maybe<SortOrder>;
  twilioMessageSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  wasEdited?: Maybe<SortOrder>;
};

export type ChannelMessageOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelMessageOrderByRelevanceInput>;
  attachments?: Maybe<ChannelMessageAttachmentOrderByRelationAggregateInput>;
  attributes?: Maybe<SortOrder>;
  author?: Maybe<ChannelMemberOrderByWithRelationInput>;
  authorId?: Maybe<SortOrder>;
  autoResponses?: Maybe<ChannelMessageAutoResponseOrderByRelationAggregateInput>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  body?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  forceReadReceipt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  index?: Maybe<SortOrder>;
  isUnreadEligible?: Maybe<SortOrder>;
  lastMessageChannel?: Maybe<ChannelOrderByRelationAggregateInput>;
  lastUpdatedBy?: Maybe<SortOrder>;
  media?: Maybe<SortOrder>;
  mentionedUsers?: Maybe<UserOrderByRelationAggregateInput>;
  messageType?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  reactions?: Maybe<ChannelMessageReactionOrderByRelationAggregateInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusOrderByRelationAggregateInput>;
  source?: Maybe<SortOrder>;
  sourcePhoneNumber?: Maybe<SortOrder>;
  twilioMessageSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  wasEdited?: Maybe<SortOrder>;
};

export type ChannelMessageOrderByWithRelationInput = {
  _relevance?: Maybe<ChannelMessageOrderByRelevanceInput>;
  attachments?: Maybe<ChannelMessageAttachmentOrderByRelationAggregateInput>;
  attributes?: Maybe<SortOrder>;
  author?: Maybe<ChannelMemberOrderByWithRelationInput>;
  authorId?: Maybe<SortOrder>;
  autoResponses?: Maybe<ChannelMessageAutoResponseOrderByRelationAggregateInput>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  body?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  forceReadReceipt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  index?: Maybe<SortOrder>;
  isUnreadEligible?: Maybe<SortOrder>;
  lastMessageChannel?: Maybe<ChannelOrderByRelationAggregateInput>;
  lastUpdatedBy?: Maybe<SortOrder>;
  media?: Maybe<SortOrder>;
  mentionedUsers?: Maybe<UserOrderByRelationAggregateInput>;
  messageType?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  reactions?: Maybe<ChannelMessageReactionOrderByRelationAggregateInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusOrderByRelationAggregateInput>;
  source?: Maybe<SortOrder>;
  sourcePhoneNumber?: Maybe<SortOrder>;
  twilioMessageSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  wasEdited?: Maybe<SortOrder>;
};

export type ChannelMessageReaction = {
  __typename?: 'ChannelMessageReaction';
  channelMessage: ChannelMessage;
  channelMessageId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  reaction: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type ChannelMessageReactionCountAggregateOutputType = {
  __typename?: 'ChannelMessageReactionCountAggregateOutputType';
  _all: Scalars['Int'];
  channelMessageId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  reaction: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ChannelMessageReactionCountOrderByAggregateInput = {
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  reaction?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelMessageReactionCreateInput = {
  channelMessage: ChannelMessageCreateNestedOneWithoutReactionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutChannelMessageReactionsInput;
};

export type ChannelMessageReactionCreateManyChannelMessageInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type ChannelMessageReactionCreateManyChannelMessageInputEnvelope = {
  data: Array<ChannelMessageReactionCreateManyChannelMessageInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageReactionCreateManyInput = {
  channelMessageId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type ChannelMessageReactionCreateManyUserInput = {
  channelMessageId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageReactionCreateManyUserInputEnvelope = {
  data: Array<ChannelMessageReactionCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageReactionCreateNestedManyWithoutChannelMessageInput = {
  connect?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageReactionCreateOrConnectWithoutChannelMessageInput>>;
  create?: Maybe<Array<ChannelMessageReactionCreateWithoutChannelMessageInput>>;
  createMany?: Maybe<ChannelMessageReactionCreateManyChannelMessageInputEnvelope>;
};

export type ChannelMessageReactionCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageReactionCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelMessageReactionCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelMessageReactionCreateManyUserInputEnvelope>;
};

export type ChannelMessageReactionCreateOrConnectWithoutChannelMessageInput = {
  create: ChannelMessageReactionCreateWithoutChannelMessageInput;
  where: ChannelMessageReactionWhereUniqueInput;
};

export type ChannelMessageReactionCreateOrConnectWithoutUserInput = {
  create: ChannelMessageReactionCreateWithoutUserInput;
  where: ChannelMessageReactionWhereUniqueInput;
};

export type ChannelMessageReactionCreateWithoutChannelMessageInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutChannelMessageReactionsInput;
};

export type ChannelMessageReactionCreateWithoutUserInput = {
  channelMessage: ChannelMessageCreateNestedOneWithoutReactionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageReactionGroupByOutputType = {
  __typename?: 'ChannelMessageReactionGroupByOutputType';
  _count?: Maybe<ChannelMessageReactionCountAggregateOutputType>;
  _max?: Maybe<ChannelMessageReactionMaxAggregateOutputType>;
  _min?: Maybe<ChannelMessageReactionMinAggregateOutputType>;
  channelMessageId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  reaction: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type ChannelMessageReactionListRelationFilter = {
  every?: Maybe<ChannelMessageReactionWhereInput>;
  none?: Maybe<ChannelMessageReactionWhereInput>;
  some?: Maybe<ChannelMessageReactionWhereInput>;
};

export type ChannelMessageReactionMaxAggregateOutputType = {
  __typename?: 'ChannelMessageReactionMaxAggregateOutputType';
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMessageReactionMaxOrderByAggregateInput = {
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  reaction?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelMessageReactionMinAggregateOutputType = {
  __typename?: 'ChannelMessageReactionMinAggregateOutputType';
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMessageReactionMinOrderByAggregateInput = {
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  reaction?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelMessageReactionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelMessageReactionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelMessageReactionOrderByRelevanceInput>;
  channelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  reaction?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ChannelMessageReactionOrderByRelevanceFieldEnum {
  ChannelMessageId = 'channelMessageId',
  Id = 'id',
  Reaction = 'reaction',
  UserId = 'userId'
}

export type ChannelMessageReactionOrderByRelevanceInput = {
  fields: Array<ChannelMessageReactionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelMessageReactionOrderByWithAggregationInput = {
  _count?: Maybe<ChannelMessageReactionCountOrderByAggregateInput>;
  _max?: Maybe<ChannelMessageReactionMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelMessageReactionMinOrderByAggregateInput>;
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  reaction?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelMessageReactionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelMessageReactionOrderByRelevanceInput>;
  channelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  reaction?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type ChannelMessageReactionOrderByWithRelationInput = {
  _relevance?: Maybe<ChannelMessageReactionOrderByRelevanceInput>;
  channelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  channelMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  reaction?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ChannelMessageReactionScalarFieldEnum {
  ChannelMessageId = 'channelMessageId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Reaction = 'reaction',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ChannelMessageReactionScalarWhereInput = {
  AND?: Maybe<Array<ChannelMessageReactionScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageReactionScalarWhereInput>>;
  OR?: Maybe<Array<ChannelMessageReactionScalarWhereInput>>;
  channelMessageId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  reaction?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userId?: Maybe<StringFilter>;
};

export type ChannelMessageReactionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelMessageReactionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelMessageReactionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelMessageReactionScalarWhereWithAggregatesInput>>;
  channelMessageId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  reaction?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userId?: Maybe<StringWithAggregatesFilter>;
};

export type ChannelMessageReactionUncheckedCreateInput = {
  channelMessageId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type ChannelMessageReactionUncheckedCreateNestedManyWithoutChannelMessageInput = {
  connect?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageReactionCreateOrConnectWithoutChannelMessageInput>>;
  create?: Maybe<Array<ChannelMessageReactionCreateWithoutChannelMessageInput>>;
  createMany?: Maybe<ChannelMessageReactionCreateManyChannelMessageInputEnvelope>;
};

export type ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageReactionCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelMessageReactionCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelMessageReactionCreateManyUserInputEnvelope>;
};

export type ChannelMessageReactionUncheckedCreateWithoutChannelMessageInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type ChannelMessageReactionUncheckedCreateWithoutUserInput = {
  channelMessageId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageReactionUncheckedUpdateInput = {
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMessageReactionUncheckedUpdateManyInput = {
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMessageReactionUncheckedUpdateManyWithoutChannelMessageInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMessageReactionUncheckedUpdateManyWithoutChannelMessageNestedInput = {
  connect?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageReactionCreateOrConnectWithoutChannelMessageInput>>;
  create?: Maybe<Array<ChannelMessageReactionCreateWithoutChannelMessageInput>>;
  createMany?: Maybe<ChannelMessageReactionCreateManyChannelMessageInputEnvelope>;
  delete?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageReactionScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageReactionUpdateWithWhereUniqueWithoutChannelMessageInput>>;
  updateMany?: Maybe<Array<ChannelMessageReactionUpdateManyWithWhereWithoutChannelMessageInput>>;
  upsert?: Maybe<Array<ChannelMessageReactionUpsertWithWhereUniqueWithoutChannelMessageInput>>;
};

export type ChannelMessageReactionUncheckedUpdateManyWithoutUserInput = {
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageReactionCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelMessageReactionCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelMessageReactionCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageReactionScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageReactionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ChannelMessageReactionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ChannelMessageReactionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChannelMessageReactionUncheckedUpdateWithoutChannelMessageInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelMessageReactionUncheckedUpdateWithoutUserInput = {
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageReactionUpdateInput = {
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutReactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneRequiredWithoutChannelMessageReactionsNestedInput>;
};

export type ChannelMessageReactionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageReactionUpdateManyWithWhereWithoutChannelMessageInput = {
  data: ChannelMessageReactionUpdateManyMutationInput;
  where: ChannelMessageReactionScalarWhereInput;
};

export type ChannelMessageReactionUpdateManyWithWhereWithoutUserInput = {
  data: ChannelMessageReactionUpdateManyMutationInput;
  where: ChannelMessageReactionScalarWhereInput;
};

export type ChannelMessageReactionUpdateManyWithoutChannelMessageNestedInput = {
  connect?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageReactionCreateOrConnectWithoutChannelMessageInput>>;
  create?: Maybe<Array<ChannelMessageReactionCreateWithoutChannelMessageInput>>;
  createMany?: Maybe<ChannelMessageReactionCreateManyChannelMessageInputEnvelope>;
  delete?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageReactionScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageReactionUpdateWithWhereUniqueWithoutChannelMessageInput>>;
  updateMany?: Maybe<Array<ChannelMessageReactionUpdateManyWithWhereWithoutChannelMessageInput>>;
  upsert?: Maybe<Array<ChannelMessageReactionUpsertWithWhereUniqueWithoutChannelMessageInput>>;
};

export type ChannelMessageReactionUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageReactionCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelMessageReactionCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelMessageReactionCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageReactionScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageReactionWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageReactionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ChannelMessageReactionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ChannelMessageReactionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChannelMessageReactionUpdateWithWhereUniqueWithoutChannelMessageInput = {
  data: ChannelMessageReactionUpdateWithoutChannelMessageInput;
  where: ChannelMessageReactionWhereUniqueInput;
};

export type ChannelMessageReactionUpdateWithWhereUniqueWithoutUserInput = {
  data: ChannelMessageReactionUpdateWithoutUserInput;
  where: ChannelMessageReactionWhereUniqueInput;
};

export type ChannelMessageReactionUpdateWithoutChannelMessageInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneRequiredWithoutChannelMessageReactionsNestedInput>;
};

export type ChannelMessageReactionUpdateWithoutUserInput = {
  channelMessage?: Maybe<ChannelMessageUpdateOneRequiredWithoutReactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMessageReactionUpsertWithWhereUniqueWithoutChannelMessageInput = {
  create: ChannelMessageReactionCreateWithoutChannelMessageInput;
  update: ChannelMessageReactionUpdateWithoutChannelMessageInput;
  where: ChannelMessageReactionWhereUniqueInput;
};

export type ChannelMessageReactionUpsertWithWhereUniqueWithoutUserInput = {
  create: ChannelMessageReactionCreateWithoutUserInput;
  update: ChannelMessageReactionUpdateWithoutUserInput;
  where: ChannelMessageReactionWhereUniqueInput;
};

export type ChannelMessageReactionWhereInput = {
  AND?: Maybe<Array<ChannelMessageReactionWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageReactionWhereInput>>;
  OR?: Maybe<Array<ChannelMessageReactionWhereInput>>;
  channelMessage?: Maybe<ChannelMessageScalarRelationFilter>;
  channelMessageId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  reaction?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type ChannelMessageReactionWhereUniqueInput = {
  AND?: Maybe<Array<ChannelMessageReactionWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageReactionWhereInput>>;
  OR?: Maybe<Array<ChannelMessageReactionWhereInput>>;
  channelMessage?: Maybe<ChannelMessageScalarRelationFilter>;
  channelMessageId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  reaction?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export enum ChannelMessageScalarFieldEnum {
  Attributes = 'attributes',
  AuthorId = 'authorId',
  Body = 'body',
  ChannelId = 'channelId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  ForceReadReceipt = 'forceReadReceipt',
  Id = 'id',
  Index = 'index',
  IsUnreadEligible = 'isUnreadEligible',
  LastUpdatedBy = 'lastUpdatedBy',
  Media = 'media',
  MessageType = 'messageType',
  Source = 'source',
  SourcePhoneNumber = 'sourcePhoneNumber',
  TwilioMessageSid = 'twilioMessageSid',
  UpdatedAt = 'updatedAt',
  WasEdited = 'wasEdited'
}

export type ChannelMessageScalarRelationFilter = {
  AND?: Maybe<Array<ChannelMessageWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageWhereInput>>;
  OR?: Maybe<Array<ChannelMessageWhereInput>>;
  attachments?: Maybe<ChannelMessageAttachmentListRelationFilter>;
  attributes?: Maybe<JsonNullableFilter>;
  author?: Maybe<ChannelMemberNullableScalarRelationFilter>;
  authorId?: Maybe<StringNullableFilter>;
  autoResponses?: Maybe<ChannelMessageAutoResponseListRelationFilter>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  body?: Maybe<StringNullableFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  forceReadReceipt?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  index?: Maybe<IntFilter>;
  isUnreadEligible?: Maybe<BoolFilter>;
  lastMessageChannel?: Maybe<ChannelListRelationFilter>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  media?: Maybe<JsonNullableFilter>;
  mentionedUsers?: Maybe<UserListRelationFilter>;
  messageType?: Maybe<EnumMessageTypeFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  reactions?: Maybe<ChannelMessageReactionListRelationFilter>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusListRelationFilter>;
  source?: Maybe<EnumMessageSourceFilter>;
  sourcePhoneNumber?: Maybe<StringNullableFilter>;
  twilioMessageSid?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  wasEdited?: Maybe<BoolFilter>;
};

export type ChannelMessageScalarWhereInput = {
  AND?: Maybe<Array<ChannelMessageScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageScalarWhereInput>>;
  OR?: Maybe<Array<ChannelMessageScalarWhereInput>>;
  attributes?: Maybe<JsonNullableFilter>;
  authorId?: Maybe<StringNullableFilter>;
  body?: Maybe<StringNullableFilter>;
  channelId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  forceReadReceipt?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  index?: Maybe<IntFilter>;
  isUnreadEligible?: Maybe<BoolFilter>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  media?: Maybe<JsonNullableFilter>;
  messageType?: Maybe<EnumMessageTypeFilter>;
  source?: Maybe<EnumMessageSourceFilter>;
  sourcePhoneNumber?: Maybe<StringNullableFilter>;
  twilioMessageSid?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  wasEdited?: Maybe<BoolFilter>;
};

export type ChannelMessageScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelMessageScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelMessageScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelMessageScalarWhereWithAggregatesInput>>;
  attributes?: Maybe<JsonNullableWithAggregatesFilter>;
  authorId?: Maybe<StringNullableWithAggregatesFilter>;
  body?: Maybe<StringNullableWithAggregatesFilter>;
  channelId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  forceReadReceipt?: Maybe<BoolWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  index?: Maybe<IntWithAggregatesFilter>;
  isUnreadEligible?: Maybe<BoolWithAggregatesFilter>;
  lastUpdatedBy?: Maybe<StringNullableWithAggregatesFilter>;
  media?: Maybe<JsonNullableWithAggregatesFilter>;
  messageType?: Maybe<EnumMessageTypeWithAggregatesFilter>;
  source?: Maybe<EnumMessageSourceWithAggregatesFilter>;
  sourcePhoneNumber?: Maybe<StringNullableWithAggregatesFilter>;
  twilioMessageSid?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  wasEdited?: Maybe<BoolWithAggregatesFilter>;
};

export type ChannelMessageSubscription = {
  __typename?: 'ChannelMessageSubscription';
  mutation: MutationType;
  node: ChannelMessage;
};

export type ChannelMessageSumAggregateOutputType = {
  __typename?: 'ChannelMessageSumAggregateOutputType';
  index?: Maybe<Scalars['Int']>;
};

export type ChannelMessageSumOrderByAggregateInput = {
  index?: Maybe<SortOrder>;
};

export type ChannelMessageUncheckedCreateInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunUncheckedCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedCreateNestedManyWithoutAttachmentsInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutAttachmentsInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutAttachmentsInput>>;
};

export type ChannelMessageUncheckedCreateNestedManyWithoutAuthorInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutAuthorInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutAuthorInput>>;
  createMany?: Maybe<ChannelMessageCreateManyAuthorInputEnvelope>;
};

export type ChannelMessageUncheckedCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelMessageCreateManyChannelInputEnvelope>;
};

export type ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutMentionedUsersInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutMentionedUsersInput>>;
};

export type ChannelMessageUncheckedCreateWithoutAttachmentsInput = {
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunUncheckedCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedCreateWithoutAuthorInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunUncheckedCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedCreateWithoutAutoResponsesInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  automationRun?: Maybe<AutomationRunUncheckedCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedCreateWithoutAutomationRunInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedCreateNestedManyWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedCreateWithoutChannelInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunUncheckedCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedCreateWithoutLastMessageChannelInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunUncheckedCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedCreateWithoutMentionedUsersInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunUncheckedCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedCreateWithoutPushNotificationLogsInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunUncheckedCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  reactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedCreateWithoutReactionsInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunUncheckedCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedCreateWithoutSmsNotifificationStatusesInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutChannelMessageInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedCreateNestedManyWithoutChannelMessageInput>;
  automationRun?: Maybe<AutomationRunUncheckedCreateNestedOneWithoutChannelMessageInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedCreateNestedManyWithoutLastMessageInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedCreateNestedManyWithoutChannelMessagesWithMentionsInput>;
  messageType: MessageType;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutSentChannelMessageInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutChannelMessageInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUncheckedUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateManyInput = {
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType?: Maybe<MessageType>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateManyWithoutAttachmentsInput = {
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType?: Maybe<MessageType>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateManyWithoutAttachmentsNestedInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutAttachmentsInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutAttachmentsInput>>;
  delete?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageUpdateWithWhereUniqueWithoutAttachmentsInput>>;
  updateMany?: Maybe<Array<ChannelMessageUpdateManyWithWhereWithoutAttachmentsInput>>;
  upsert?: Maybe<Array<ChannelMessageUpsertWithWhereUniqueWithoutAttachmentsInput>>;
};

export type ChannelMessageUncheckedUpdateManyWithoutAuthorInput = {
  attributes?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType?: Maybe<MessageType>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateManyWithoutAuthorNestedInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutAuthorInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutAuthorInput>>;
  createMany?: Maybe<ChannelMessageCreateManyAuthorInputEnvelope>;
  delete?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageUpdateWithWhereUniqueWithoutAuthorInput>>;
  updateMany?: Maybe<Array<ChannelMessageUpdateManyWithWhereWithoutAuthorInput>>;
  upsert?: Maybe<Array<ChannelMessageUpsertWithWhereUniqueWithoutAuthorInput>>;
};

export type ChannelMessageUncheckedUpdateManyWithoutChannelInput = {
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType?: Maybe<MessageType>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelMessageCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<ChannelMessageUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<ChannelMessageUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type ChannelMessageUncheckedUpdateManyWithoutMentionedUsersInput = {
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType?: Maybe<MessageType>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutMentionedUsersInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutMentionedUsersInput>>;
  delete?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageUpdateWithWhereUniqueWithoutMentionedUsersInput>>;
  updateMany?: Maybe<Array<ChannelMessageUpdateManyWithWhereWithoutMentionedUsersInput>>;
  upsert?: Maybe<Array<ChannelMessageUpsertWithWhereUniqueWithoutMentionedUsersInput>>;
};

export type ChannelMessageUncheckedUpdateWithoutAttachmentsInput = {
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUncheckedUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateWithoutAuthorInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUncheckedUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateWithoutAutoResponsesInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  automationRun?: Maybe<AutomationRunUncheckedUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateWithoutAutomationRunInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateWithoutChannelInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUncheckedUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateWithoutLastMessageChannelInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUncheckedUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateWithoutMentionedUsersInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUncheckedUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateWithoutPushNotificationLogsInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUncheckedUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  reactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateWithoutReactionsInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUncheckedUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUncheckedUpdateWithoutSmsNotifificationStatusesInput = {
  attachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  authorId?: Maybe<Scalars['String']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUncheckedUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUncheckedUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUncheckedUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUnreadCountResult = {
  __typename?: 'ChannelMessageUnreadCountResult';
  total: Scalars['Int'];
  unreadChannels: Array<UnreadMessageChannel>;
};

export type ChannelMessageUpdateInput = {
  attachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberUpdateOneWithoutChannelMessagesNestedInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelUpdateOneWithoutMessagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUpdateManyMutationInput = {
  attributes?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType?: Maybe<MessageType>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUpdateManyWithWhereWithoutAttachmentsInput = {
  data: ChannelMessageUpdateManyMutationInput;
  where: ChannelMessageScalarWhereInput;
};

export type ChannelMessageUpdateManyWithWhereWithoutAuthorInput = {
  data: ChannelMessageUpdateManyMutationInput;
  where: ChannelMessageScalarWhereInput;
};

export type ChannelMessageUpdateManyWithWhereWithoutChannelInput = {
  data: ChannelMessageUpdateManyMutationInput;
  where: ChannelMessageScalarWhereInput;
};

export type ChannelMessageUpdateManyWithWhereWithoutMentionedUsersInput = {
  data: ChannelMessageUpdateManyMutationInput;
  where: ChannelMessageScalarWhereInput;
};

export type ChannelMessageUpdateManyWithoutAttachmentsNestedInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutAttachmentsInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutAttachmentsInput>>;
  delete?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageUpdateWithWhereUniqueWithoutAttachmentsInput>>;
  updateMany?: Maybe<Array<ChannelMessageUpdateManyWithWhereWithoutAttachmentsInput>>;
  upsert?: Maybe<Array<ChannelMessageUpsertWithWhereUniqueWithoutAttachmentsInput>>;
};

export type ChannelMessageUpdateManyWithoutAuthorNestedInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutAuthorInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutAuthorInput>>;
  createMany?: Maybe<ChannelMessageCreateManyAuthorInputEnvelope>;
  delete?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageUpdateWithWhereUniqueWithoutAuthorInput>>;
  updateMany?: Maybe<Array<ChannelMessageUpdateManyWithWhereWithoutAuthorInput>>;
  upsert?: Maybe<Array<ChannelMessageUpsertWithWhereUniqueWithoutAuthorInput>>;
};

export type ChannelMessageUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelMessageCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<ChannelMessageUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<ChannelMessageUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type ChannelMessageUpdateManyWithoutMentionedUsersNestedInput = {
  connect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelMessageCreateOrConnectWithoutMentionedUsersInput>>;
  create?: Maybe<Array<ChannelMessageCreateWithoutMentionedUsersInput>>;
  delete?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelMessageScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  set?: Maybe<Array<ChannelMessageWhereUniqueInput>>;
  update?: Maybe<Array<ChannelMessageUpdateWithWhereUniqueWithoutMentionedUsersInput>>;
  updateMany?: Maybe<Array<ChannelMessageUpdateManyWithWhereWithoutMentionedUsersInput>>;
  upsert?: Maybe<Array<ChannelMessageUpsertWithWhereUniqueWithoutMentionedUsersInput>>;
};

export type ChannelMessageUpdateOneRequiredWithoutAutomationRunNestedInput = {
  connect?: Maybe<ChannelMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMessageCreateOrConnectWithoutAutomationRunInput>;
  create?: Maybe<ChannelMessageCreateWithoutAutomationRunInput>;
  update?: Maybe<ChannelMessageUpdateToOneWithWhereWithoutAutomationRunInput>;
  upsert?: Maybe<ChannelMessageUpsertWithoutAutomationRunInput>;
};

export type ChannelMessageUpdateOneRequiredWithoutReactionsNestedInput = {
  connect?: Maybe<ChannelMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMessageCreateOrConnectWithoutReactionsInput>;
  create?: Maybe<ChannelMessageCreateWithoutReactionsInput>;
  update?: Maybe<ChannelMessageUpdateToOneWithWhereWithoutReactionsInput>;
  upsert?: Maybe<ChannelMessageUpsertWithoutReactionsInput>;
};

export type ChannelMessageUpdateOneWithoutAutoResponsesNestedInput = {
  connect?: Maybe<ChannelMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMessageCreateOrConnectWithoutAutoResponsesInput>;
  create?: Maybe<ChannelMessageCreateWithoutAutoResponsesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelMessageUpdateToOneWithWhereWithoutAutoResponsesInput>;
  upsert?: Maybe<ChannelMessageUpsertWithoutAutoResponsesInput>;
};

export type ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput = {
  connect?: Maybe<ChannelMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMessageCreateOrConnectWithoutLastMessageChannelInput>;
  create?: Maybe<ChannelMessageCreateWithoutLastMessageChannelInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelMessageUpdateToOneWithWhereWithoutLastMessageChannelInput>;
  upsert?: Maybe<ChannelMessageUpsertWithoutLastMessageChannelInput>;
};

export type ChannelMessageUpdateOneWithoutPushNotificationLogsNestedInput = {
  connect?: Maybe<ChannelMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMessageCreateOrConnectWithoutPushNotificationLogsInput>;
  create?: Maybe<ChannelMessageCreateWithoutPushNotificationLogsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelMessageUpdateToOneWithWhereWithoutPushNotificationLogsInput>;
  upsert?: Maybe<ChannelMessageUpsertWithoutPushNotificationLogsInput>;
};

export type ChannelMessageUpdateOneWithoutSmsNotifificationStatusesNestedInput = {
  connect?: Maybe<ChannelMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelMessageCreateOrConnectWithoutSmsNotifificationStatusesInput>;
  create?: Maybe<ChannelMessageCreateWithoutSmsNotifificationStatusesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelMessageUpdateToOneWithWhereWithoutSmsNotifificationStatusesInput>;
  upsert?: Maybe<ChannelMessageUpsertWithoutSmsNotifificationStatusesInput>;
};

export type ChannelMessageUpdateToOneWithWhereWithoutAutoResponsesInput = {
  data: ChannelMessageUpdateWithoutAutoResponsesInput;
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageUpdateToOneWithWhereWithoutAutomationRunInput = {
  data: ChannelMessageUpdateWithoutAutomationRunInput;
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageUpdateToOneWithWhereWithoutLastMessageChannelInput = {
  data: ChannelMessageUpdateWithoutLastMessageChannelInput;
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageUpdateToOneWithWhereWithoutPushNotificationLogsInput = {
  data: ChannelMessageUpdateWithoutPushNotificationLogsInput;
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageUpdateToOneWithWhereWithoutReactionsInput = {
  data: ChannelMessageUpdateWithoutReactionsInput;
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageUpdateToOneWithWhereWithoutSmsNotifificationStatusesInput = {
  data: ChannelMessageUpdateWithoutSmsNotifificationStatusesInput;
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageUpdateWithWhereUniqueWithoutAttachmentsInput = {
  data: ChannelMessageUpdateWithoutAttachmentsInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageUpdateWithWhereUniqueWithoutAuthorInput = {
  data: ChannelMessageUpdateWithoutAuthorInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageUpdateWithWhereUniqueWithoutChannelInput = {
  data: ChannelMessageUpdateWithoutChannelInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageUpdateWithWhereUniqueWithoutMentionedUsersInput = {
  data: ChannelMessageUpdateWithoutMentionedUsersInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageUpdateWithoutAttachmentsInput = {
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberUpdateOneWithoutChannelMessagesNestedInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelUpdateOneWithoutMessagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUpdateWithoutAuthorInput = {
  attachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelUpdateOneWithoutMessagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUpdateWithoutAutoResponsesInput = {
  attachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberUpdateOneWithoutChannelMessagesNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelUpdateOneWithoutMessagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUpdateWithoutAutomationRunInput = {
  attachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberUpdateOneWithoutChannelMessagesNestedInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUpdateManyWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelUpdateOneWithoutMessagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUpdateWithoutChannelInput = {
  attachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberUpdateOneWithoutChannelMessagesNestedInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUpdateWithoutLastMessageChannelInput = {
  attachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberUpdateOneWithoutChannelMessagesNestedInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelUpdateOneWithoutMessagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUpdateWithoutMentionedUsersInput = {
  attachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberUpdateOneWithoutChannelMessagesNestedInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelUpdateOneWithoutMessagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUpdateWithoutPushNotificationLogsInput = {
  attachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberUpdateOneWithoutChannelMessagesNestedInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelUpdateOneWithoutMessagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  reactions?: Maybe<ChannelMessageReactionUpdateManyWithoutChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUpdateWithoutReactionsInput = {
  attachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberUpdateOneWithoutChannelMessagesNestedInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelUpdateOneWithoutMessagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutSentChannelMessageNestedInput>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutSentChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUpdateWithoutSmsNotifificationStatusesInput = {
  attachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutChannelMessageNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMemberUpdateOneWithoutChannelMessagesNestedInput>;
  autoResponses?: Maybe<ChannelMessageAutoResponseUpdateManyWithoutChannelMessageNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutChannelMessageNestedInput>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelUpdateOneWithoutMessagesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isUnreadEligible?: Maybe<Scalars['Boolean']>;
  lastMessageChannel?: Maybe<ChannelUpdateManyWithoutLastMessageNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  mentionedUsers?: Maybe<UserUpdateManyWithoutChannelMessagesWithMentionsNestedInput>;
  messageType?: Maybe<MessageType>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutSentChannelMessageNestedInput>;
  reactions?: Maybe<ChannelMessageReactionUpdateManyWithoutChannelMessageNestedInput>;
  source?: Maybe<MessageSource>;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasEdited?: Maybe<Scalars['Boolean']>;
};

export type ChannelMessageUpsertWithWhereUniqueWithoutAttachmentsInput = {
  create: ChannelMessageCreateWithoutAttachmentsInput;
  update: ChannelMessageUpdateWithoutAttachmentsInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageUpsertWithWhereUniqueWithoutAuthorInput = {
  create: ChannelMessageCreateWithoutAuthorInput;
  update: ChannelMessageUpdateWithoutAuthorInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageUpsertWithWhereUniqueWithoutChannelInput = {
  create: ChannelMessageCreateWithoutChannelInput;
  update: ChannelMessageUpdateWithoutChannelInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageUpsertWithWhereUniqueWithoutMentionedUsersInput = {
  create: ChannelMessageCreateWithoutMentionedUsersInput;
  update: ChannelMessageUpdateWithoutMentionedUsersInput;
  where: ChannelMessageWhereUniqueInput;
};

export type ChannelMessageUpsertWithoutAutoResponsesInput = {
  create: ChannelMessageCreateWithoutAutoResponsesInput;
  update: ChannelMessageUpdateWithoutAutoResponsesInput;
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageUpsertWithoutAutomationRunInput = {
  create: ChannelMessageCreateWithoutAutomationRunInput;
  update: ChannelMessageUpdateWithoutAutomationRunInput;
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageUpsertWithoutLastMessageChannelInput = {
  create: ChannelMessageCreateWithoutLastMessageChannelInput;
  update: ChannelMessageUpdateWithoutLastMessageChannelInput;
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageUpsertWithoutPushNotificationLogsInput = {
  create: ChannelMessageCreateWithoutPushNotificationLogsInput;
  update: ChannelMessageUpdateWithoutPushNotificationLogsInput;
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageUpsertWithoutReactionsInput = {
  create: ChannelMessageCreateWithoutReactionsInput;
  update: ChannelMessageUpdateWithoutReactionsInput;
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageUpsertWithoutSmsNotifificationStatusesInput = {
  create: ChannelMessageCreateWithoutSmsNotifificationStatusesInput;
  update: ChannelMessageUpdateWithoutSmsNotifificationStatusesInput;
  where?: Maybe<ChannelMessageWhereInput>;
};

export type ChannelMessageWhereInput = {
  AND?: Maybe<Array<ChannelMessageWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageWhereInput>>;
  OR?: Maybe<Array<ChannelMessageWhereInput>>;
  attachments?: Maybe<ChannelMessageAttachmentListRelationFilter>;
  attributes?: Maybe<JsonNullableFilter>;
  author?: Maybe<ChannelMemberNullableScalarRelationFilter>;
  authorId?: Maybe<StringNullableFilter>;
  autoResponses?: Maybe<ChannelMessageAutoResponseListRelationFilter>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  body?: Maybe<StringNullableFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  forceReadReceipt?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  index?: Maybe<IntFilter>;
  isUnreadEligible?: Maybe<BoolFilter>;
  lastMessageChannel?: Maybe<ChannelListRelationFilter>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  media?: Maybe<JsonNullableFilter>;
  mentionedUsers?: Maybe<UserListRelationFilter>;
  messageType?: Maybe<EnumMessageTypeFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  reactions?: Maybe<ChannelMessageReactionListRelationFilter>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusListRelationFilter>;
  source?: Maybe<EnumMessageSourceFilter>;
  sourcePhoneNumber?: Maybe<StringNullableFilter>;
  twilioMessageSid?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  wasEdited?: Maybe<BoolFilter>;
};

export type ChannelMessageWhereUniqueInput = {
  AND?: Maybe<Array<ChannelMessageWhereInput>>;
  NOT?: Maybe<Array<ChannelMessageWhereInput>>;
  OR?: Maybe<Array<ChannelMessageWhereInput>>;
  attachments?: Maybe<ChannelMessageAttachmentListRelationFilter>;
  attributes?: Maybe<JsonNullableFilter>;
  author?: Maybe<ChannelMemberNullableScalarRelationFilter>;
  authorId?: Maybe<StringNullableFilter>;
  autoResponses?: Maybe<ChannelMessageAutoResponseListRelationFilter>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  body?: Maybe<StringNullableFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  forceReadReceipt?: Maybe<BoolFilter>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<IntFilter>;
  isUnreadEligible?: Maybe<BoolFilter>;
  lastMessageChannel?: Maybe<ChannelListRelationFilter>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  media?: Maybe<JsonNullableFilter>;
  mentionedUsers?: Maybe<UserListRelationFilter>;
  messageType?: Maybe<EnumMessageTypeFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  reactions?: Maybe<ChannelMessageReactionListRelationFilter>;
  smsNotifificationStatuses?: Maybe<SmsNotificationStatusListRelationFilter>;
  source?: Maybe<EnumMessageSourceFilter>;
  sourcePhoneNumber?: Maybe<StringNullableFilter>;
  twilioMessageSid?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  wasEdited?: Maybe<BoolFilter>;
};

export type ChannelMinAggregateOutputType = {
  __typename?: 'ChannelMinAggregateOutputType';
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelMinOrderByAggregateInput = {
  channelStatusId?: Maybe<SortOrder>;
  channelType?: Maybe<SortOrder>;
  channelVisibility?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentWorkflowActionId?: Maybe<SortOrder>;
  friendlyName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastExportAt?: Maybe<SortOrder>;
  lastMessageId?: Maybe<SortOrder>;
  twilioChannelSid?: Maybe<SortOrder>;
  uniqueName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelNullableScalarRelationFilter = {
  AND?: Maybe<Array<ChannelWhereInput>>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<ChannelWhereInput>>;
  OR?: Maybe<Array<ChannelWhereInput>>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  assignees?: Maybe<UserListRelationFilter>;
  attributes?: Maybe<JsonNullableFilter>;
  automationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelMembers?: Maybe<ChannelMemberListRelationFilter>;
  channelPins?: Maybe<ChannelPinListRelationFilter>;
  channelStatus?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusId?: Maybe<StringNullableFilter>;
  channelType?: Maybe<EnumChannelTypeNullableFilter>;
  channelVisibility?: Maybe<EnumChannelVisibilityNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<ChannelCreationSourceNullableScalarRelationFilter>;
  currentWorkflowAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  currentWorkflowActionId?: Maybe<StringNullableFilter>;
  financialTransactions?: Maybe<FinancialTransactionListRelationFilter>;
  friendlyName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  lastExportAt?: Maybe<DateTimeNullableFilter>;
  lastMessage?: Maybe<ChannelMessageNullableScalarRelationFilter>;
  lastMessageId?: Maybe<StringNullableFilter>;
  messages?: Maybe<ChannelMessageListRelationFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  tags?: Maybe<JsonNullableFilter>;
  twilioChannelSid?: Maybe<StringNullableFilter>;
  uniqueName?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChannelOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelOrderByRelationAndSearchRelevanceInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  _relevance?: Maybe<ChannelOrderByRelevanceInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  assignees?: Maybe<UserOrderByRelationAggregateInput>;
  attributes?: Maybe<SortOrder>;
  automationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelMembers?: Maybe<ChannelMemberOrderByRelationAggregateInput>;
  channelPins?: Maybe<ChannelPinOrderByRelationAggregateInput>;
  channelStatus?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusId?: Maybe<SortOrder>;
  channelType?: Maybe<SortOrder>;
  channelVisibility?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<ChannelCreationSourceOrderByWithRelationInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionOrderByWithRelationInput>;
  currentWorkflowActionId?: Maybe<SortOrder>;
  financialTransactions?: Maybe<FinancialTransactionOrderByRelationAggregateInput>;
  friendlyName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastExportAt?: Maybe<SortOrder>;
  lastMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  lastMessageId?: Maybe<SortOrder>;
  messages?: Maybe<ChannelMessageOrderByRelationAggregateInput>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  tags?: Maybe<SortOrder>;
  twilioChannelSid?: Maybe<SortOrder>;
  uniqueName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ChannelOrderByRelevanceFieldEnum {
  ChannelStatusId = 'channelStatusId',
  ClinicId = 'clinicId',
  CurrentWorkflowActionId = 'currentWorkflowActionId',
  FriendlyName = 'friendlyName',
  Id = 'id',
  LastMessageId = 'lastMessageId',
  TwilioChannelSid = 'twilioChannelSid',
  UniqueName = 'uniqueName'
}

export type ChannelOrderByRelevanceInput = {
  fields: Array<ChannelOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelOrderByWithAggregationInput = {
  _count?: Maybe<ChannelCountOrderByAggregateInput>;
  _max?: Maybe<ChannelMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelMinOrderByAggregateInput>;
  attributes?: Maybe<SortOrder>;
  channelStatusId?: Maybe<SortOrder>;
  channelType?: Maybe<SortOrder>;
  channelVisibility?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentWorkflowActionId?: Maybe<SortOrder>;
  friendlyName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastExportAt?: Maybe<SortOrder>;
  lastMessageId?: Maybe<SortOrder>;
  tags?: Maybe<SortOrder>;
  twilioChannelSid?: Maybe<SortOrder>;
  uniqueName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelOrderByWithRelationAndSearchRelevanceInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  _relevance?: Maybe<ChannelOrderByRelevanceInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  assignees?: Maybe<UserOrderByRelationAggregateInput>;
  attributes?: Maybe<SortOrder>;
  automationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelMembers?: Maybe<ChannelMemberOrderByRelationAggregateInput>;
  channelPins?: Maybe<ChannelPinOrderByRelationAggregateInput>;
  channelStatus?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusId?: Maybe<SortOrder>;
  channelType?: Maybe<SortOrder>;
  channelVisibility?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<ChannelCreationSourceOrderByWithRelationInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionOrderByWithRelationInput>;
  currentWorkflowActionId?: Maybe<SortOrder>;
  financialTransactions?: Maybe<FinancialTransactionOrderByRelationAggregateInput>;
  friendlyName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastExportAt?: Maybe<SortOrder>;
  lastMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  lastMessageId?: Maybe<SortOrder>;
  messages?: Maybe<ChannelMessageOrderByRelationAggregateInput>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  tags?: Maybe<SortOrder>;
  twilioChannelSid?: Maybe<SortOrder>;
  uniqueName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelOrderByWithRelationInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  _relevance?: Maybe<ChannelOrderByRelevanceInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  assignees?: Maybe<UserOrderByRelationAggregateInput>;
  attributes?: Maybe<SortOrder>;
  automationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelMembers?: Maybe<ChannelMemberOrderByRelationAggregateInput>;
  channelPins?: Maybe<ChannelPinOrderByRelationAggregateInput>;
  channelStatus?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusId?: Maybe<SortOrder>;
  channelType?: Maybe<SortOrder>;
  channelVisibility?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<ChannelCreationSourceOrderByWithRelationInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionOrderByWithRelationInput>;
  currentWorkflowActionId?: Maybe<SortOrder>;
  financialTransactions?: Maybe<FinancialTransactionOrderByRelationAggregateInput>;
  friendlyName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastExportAt?: Maybe<SortOrder>;
  lastMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  lastMessageId?: Maybe<SortOrder>;
  messages?: Maybe<ChannelMessageOrderByRelationAggregateInput>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  tags?: Maybe<SortOrder>;
  twilioChannelSid?: Maybe<SortOrder>;
  uniqueName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelPin = {
  __typename?: 'ChannelPin';
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};


export type ChannelPinChannelArgs = {
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelPinCountAggregateOutputType = {
  __typename?: 'ChannelPinCountAggregateOutputType';
  _all: Scalars['Int'];
  channelId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ChannelPinCountOrderByAggregateInput = {
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelPinCreateInput = {
  channel?: Maybe<ChannelCreateNestedOneWithoutChannelPinsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  user: UserCreateNestedOneWithoutPinnedChannelsInput;
};

export type ChannelPinCreateManyChannelInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ChannelPinCreateManyChannelInputEnvelope = {
  data: Array<ChannelPinCreateManyChannelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelPinCreateManyInput = {
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ChannelPinCreateManyUserInput = {
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelPinCreateManyUserInputEnvelope = {
  data: Array<ChannelPinCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelPinCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelPinCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelPinCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelPinCreateManyChannelInputEnvelope>;
};

export type ChannelPinCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelPinCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelPinCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelPinCreateManyUserInputEnvelope>;
};

export type ChannelPinCreateOrConnectWithoutChannelInput = {
  create: ChannelPinCreateWithoutChannelInput;
  where: ChannelPinWhereUniqueInput;
};

export type ChannelPinCreateOrConnectWithoutUserInput = {
  create: ChannelPinCreateWithoutUserInput;
  where: ChannelPinWhereUniqueInput;
};

export type ChannelPinCreateWithoutChannelInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  user: UserCreateNestedOneWithoutPinnedChannelsInput;
};

export type ChannelPinCreateWithoutUserInput = {
  channel?: Maybe<ChannelCreateNestedOneWithoutChannelPinsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelPinGroupByOutputType = {
  __typename?: 'ChannelPinGroupByOutputType';
  _count?: Maybe<ChannelPinCountAggregateOutputType>;
  _max?: Maybe<ChannelPinMaxAggregateOutputType>;
  _min?: Maybe<ChannelPinMinAggregateOutputType>;
  channelId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  userId: Scalars['String'];
};

export type ChannelPinListRelationFilter = {
  every?: Maybe<ChannelPinWhereInput>;
  none?: Maybe<ChannelPinWhereInput>;
  some?: Maybe<ChannelPinWhereInput>;
};

export type ChannelPinMaxAggregateOutputType = {
  __typename?: 'ChannelPinMaxAggregateOutputType';
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelPinMaxOrderByAggregateInput = {
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelPinMinAggregateOutputType = {
  __typename?: 'ChannelPinMinAggregateOutputType';
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelPinMinOrderByAggregateInput = {
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelPinOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelPinOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelPinOrderByRelevanceInput>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ChannelPinOrderByRelevanceFieldEnum {
  ChannelId = 'channelId',
  Id = 'id',
  UserId = 'userId'
}

export type ChannelPinOrderByRelevanceInput = {
  fields: Array<ChannelPinOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelPinOrderByWithAggregationInput = {
  _count?: Maybe<ChannelPinCountOrderByAggregateInput>;
  _max?: Maybe<ChannelPinMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelPinMinOrderByAggregateInput>;
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelPinOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelPinOrderByRelevanceInput>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type ChannelPinOrderByWithRelationInput = {
  _relevance?: Maybe<ChannelPinOrderByRelevanceInput>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ChannelPinScalarFieldEnum {
  ChannelId = 'channelId',
  CreatedAt = 'createdAt',
  Id = 'id',
  UserId = 'userId'
}

export type ChannelPinScalarWhereInput = {
  AND?: Maybe<Array<ChannelPinScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelPinScalarWhereInput>>;
  OR?: Maybe<Array<ChannelPinScalarWhereInput>>;
  channelId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  userId?: Maybe<StringFilter>;
};

export type ChannelPinScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelPinScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelPinScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelPinScalarWhereWithAggregatesInput>>;
  channelId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  userId?: Maybe<StringWithAggregatesFilter>;
};

export type ChannelPinUncheckedCreateInput = {
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ChannelPinUncheckedCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelPinCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelPinCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelPinCreateManyChannelInputEnvelope>;
};

export type ChannelPinUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelPinCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelPinCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelPinCreateManyUserInputEnvelope>;
};

export type ChannelPinUncheckedCreateWithoutChannelInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ChannelPinUncheckedCreateWithoutUserInput = {
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelPinUncheckedUpdateInput = {
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelPinUncheckedUpdateManyInput = {
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelPinUncheckedUpdateManyWithoutChannelInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelPinUncheckedUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelPinCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelPinCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelPinCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelPinScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  set?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  update?: Maybe<Array<ChannelPinUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<ChannelPinUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<ChannelPinUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type ChannelPinUncheckedUpdateManyWithoutUserInput = {
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelPinUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelPinCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelPinCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelPinCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelPinScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  set?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  update?: Maybe<Array<ChannelPinUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ChannelPinUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ChannelPinUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChannelPinUncheckedUpdateWithoutChannelInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelPinUncheckedUpdateWithoutUserInput = {
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelPinUpdateInput = {
  channel?: Maybe<ChannelUpdateOneWithoutChannelPinsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  user?: Maybe<UserUpdateOneRequiredWithoutPinnedChannelsNestedInput>;
};

export type ChannelPinUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelPinUpdateManyWithWhereWithoutChannelInput = {
  data: ChannelPinUpdateManyMutationInput;
  where: ChannelPinScalarWhereInput;
};

export type ChannelPinUpdateManyWithWhereWithoutUserInput = {
  data: ChannelPinUpdateManyMutationInput;
  where: ChannelPinScalarWhereInput;
};

export type ChannelPinUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelPinCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<ChannelPinCreateWithoutChannelInput>>;
  createMany?: Maybe<ChannelPinCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelPinScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  set?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  update?: Maybe<Array<ChannelPinUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<ChannelPinUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<ChannelPinUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type ChannelPinUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelPinCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelPinCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelPinCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelPinScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  set?: Maybe<Array<ChannelPinWhereUniqueInput>>;
  update?: Maybe<Array<ChannelPinUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ChannelPinUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ChannelPinUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChannelPinUpdateWithWhereUniqueWithoutChannelInput = {
  data: ChannelPinUpdateWithoutChannelInput;
  where: ChannelPinWhereUniqueInput;
};

export type ChannelPinUpdateWithWhereUniqueWithoutUserInput = {
  data: ChannelPinUpdateWithoutUserInput;
  where: ChannelPinWhereUniqueInput;
};

export type ChannelPinUpdateWithoutChannelInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  user?: Maybe<UserUpdateOneRequiredWithoutPinnedChannelsNestedInput>;
};

export type ChannelPinUpdateWithoutUserInput = {
  channel?: Maybe<ChannelUpdateOneWithoutChannelPinsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelPinUpsertWithWhereUniqueWithoutChannelInput = {
  create: ChannelPinCreateWithoutChannelInput;
  update: ChannelPinUpdateWithoutChannelInput;
  where: ChannelPinWhereUniqueInput;
};

export type ChannelPinUpsertWithWhereUniqueWithoutUserInput = {
  create: ChannelPinCreateWithoutUserInput;
  update: ChannelPinUpdateWithoutUserInput;
  where: ChannelPinWhereUniqueInput;
};

export type ChannelPinWhereInput = {
  AND?: Maybe<Array<ChannelPinWhereInput>>;
  NOT?: Maybe<Array<ChannelPinWhereInput>>;
  OR?: Maybe<Array<ChannelPinWhereInput>>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type ChannelPinWhereUniqueInput = {
  AND?: Maybe<Array<ChannelPinWhereInput>>;
  NOT?: Maybe<Array<ChannelPinWhereInput>>;
  OR?: Maybe<Array<ChannelPinWhereInput>>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export enum ChannelScalarFieldEnum {
  Attributes = 'attributes',
  ChannelStatusId = 'channelStatusId',
  ChannelType = 'channelType',
  ChannelVisibility = 'channelVisibility',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  CurrentWorkflowActionId = 'currentWorkflowActionId',
  FriendlyName = 'friendlyName',
  Id = 'id',
  IsActive = 'isActive',
  LastExportAt = 'lastExportAt',
  LastMessageId = 'lastMessageId',
  Tags = 'tags',
  TwilioChannelSid = 'twilioChannelSid',
  UniqueName = 'uniqueName',
  UpdatedAt = 'updatedAt'
}

export type ChannelScalarRelationFilter = {
  AND?: Maybe<Array<ChannelWhereInput>>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<ChannelWhereInput>>;
  OR?: Maybe<Array<ChannelWhereInput>>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  assignees?: Maybe<UserListRelationFilter>;
  attributes?: Maybe<JsonNullableFilter>;
  automationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelMembers?: Maybe<ChannelMemberListRelationFilter>;
  channelPins?: Maybe<ChannelPinListRelationFilter>;
  channelStatus?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusId?: Maybe<StringNullableFilter>;
  channelType?: Maybe<EnumChannelTypeNullableFilter>;
  channelVisibility?: Maybe<EnumChannelVisibilityNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<ChannelCreationSourceNullableScalarRelationFilter>;
  currentWorkflowAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  currentWorkflowActionId?: Maybe<StringNullableFilter>;
  financialTransactions?: Maybe<FinancialTransactionListRelationFilter>;
  friendlyName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  lastExportAt?: Maybe<DateTimeNullableFilter>;
  lastMessage?: Maybe<ChannelMessageNullableScalarRelationFilter>;
  lastMessageId?: Maybe<StringNullableFilter>;
  messages?: Maybe<ChannelMessageListRelationFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  tags?: Maybe<JsonNullableFilter>;
  twilioChannelSid?: Maybe<StringNullableFilter>;
  uniqueName?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChannelScalarWhereInput = {
  AND?: Maybe<Array<ChannelScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelScalarWhereInput>>;
  OR?: Maybe<Array<ChannelScalarWhereInput>>;
  attributes?: Maybe<JsonNullableFilter>;
  channelStatusId?: Maybe<StringNullableFilter>;
  channelType?: Maybe<EnumChannelTypeNullableFilter>;
  channelVisibility?: Maybe<EnumChannelVisibilityNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentWorkflowActionId?: Maybe<StringNullableFilter>;
  friendlyName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  lastExportAt?: Maybe<DateTimeNullableFilter>;
  lastMessageId?: Maybe<StringNullableFilter>;
  tags?: Maybe<JsonNullableFilter>;
  twilioChannelSid?: Maybe<StringNullableFilter>;
  uniqueName?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChannelScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelScalarWhereWithAggregatesInput>>;
  attributes?: Maybe<JsonNullableWithAggregatesFilter>;
  channelStatusId?: Maybe<StringNullableWithAggregatesFilter>;
  channelType?: Maybe<EnumChannelTypeNullableWithAggregatesFilter>;
  channelVisibility?: Maybe<EnumChannelVisibilityNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  currentWorkflowActionId?: Maybe<StringNullableWithAggregatesFilter>;
  friendlyName?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolNullableWithAggregatesFilter>;
  lastExportAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  lastMessageId?: Maybe<StringNullableWithAggregatesFilter>;
  tags?: Maybe<JsonNullableWithAggregatesFilter>;
  twilioChannelSid?: Maybe<StringNullableWithAggregatesFilter>;
  uniqueName?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ChannelSearchOutput = {
  __typename?: 'ChannelSearchOutput';
  channels: Array<Channel>;
  total: Scalars['Int'];
};

export type ChannelSelection = {
  __typename?: 'ChannelSelection';
  _count: ChannelSelectionCountOutputType;
  assignees: Array<User>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  includeUnassigned: Scalars['Boolean'];
  statuses: Array<ChannelStatus>;
  updatedAt: Scalars['DateTime'];
  userSetting?: Maybe<UserSetting>;
};


export type ChannelSelectionAssigneesArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type ChannelSelectionStatusesArgs = {
  cursor?: Maybe<ChannelStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusWhereInput>;
};


export type ChannelSelectionUserSettingArgs = {
  where?: Maybe<UserSettingWhereInput>;
};

export type ChannelSelectionCountAggregateOutputType = {
  __typename?: 'ChannelSelectionCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  includeUnassigned: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ChannelSelectionCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includeUnassigned?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelSelectionCountOutputType = {
  __typename?: 'ChannelSelectionCountOutputType';
  assignees: Scalars['Int'];
  statuses: Scalars['Int'];
};

export type ChannelSelectionCreateInput = {
  assignees?: Maybe<UserCreateNestedManyWithoutChannelSelectionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<ChannelStatusCreateNestedManyWithoutChannelSelectionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutBrowserNotificationFilterInput>;
};

export type ChannelSelectionCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelSelectionCreateNestedManyWithoutAssigneesInput = {
  connect?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelSelectionCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<ChannelSelectionCreateWithoutAssigneesInput>>;
};

export type ChannelSelectionCreateNestedManyWithoutStatusesInput = {
  connect?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelSelectionCreateOrConnectWithoutStatusesInput>>;
  create?: Maybe<Array<ChannelSelectionCreateWithoutStatusesInput>>;
};

export type ChannelSelectionCreateNestedOneWithoutUserSettingInput = {
  connect?: Maybe<ChannelSelectionWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelSelectionCreateOrConnectWithoutUserSettingInput>;
  create?: Maybe<ChannelSelectionCreateWithoutUserSettingInput>;
};

export type ChannelSelectionCreateOrConnectWithoutAssigneesInput = {
  create: ChannelSelectionCreateWithoutAssigneesInput;
  where: ChannelSelectionWhereUniqueInput;
};

export type ChannelSelectionCreateOrConnectWithoutStatusesInput = {
  create: ChannelSelectionCreateWithoutStatusesInput;
  where: ChannelSelectionWhereUniqueInput;
};

export type ChannelSelectionCreateOrConnectWithoutUserSettingInput = {
  create: ChannelSelectionCreateWithoutUserSettingInput;
  where: ChannelSelectionWhereUniqueInput;
};

export type ChannelSelectionCreateWithoutAssigneesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<ChannelStatusCreateNestedManyWithoutChannelSelectionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutBrowserNotificationFilterInput>;
};

export type ChannelSelectionCreateWithoutStatusesInput = {
  assignees?: Maybe<UserCreateNestedManyWithoutChannelSelectionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutBrowserNotificationFilterInput>;
};

export type ChannelSelectionCreateWithoutUserSettingInput = {
  assignees?: Maybe<UserCreateNestedManyWithoutChannelSelectionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<ChannelStatusCreateNestedManyWithoutChannelSelectionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelSelectionGroupByOutputType = {
  __typename?: 'ChannelSelectionGroupByOutputType';
  _count?: Maybe<ChannelSelectionCountAggregateOutputType>;
  _max?: Maybe<ChannelSelectionMaxAggregateOutputType>;
  _min?: Maybe<ChannelSelectionMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  includeUnassigned: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type ChannelSelectionListRelationFilter = {
  every?: Maybe<ChannelSelectionWhereInput>;
  none?: Maybe<ChannelSelectionWhereInput>;
  some?: Maybe<ChannelSelectionWhereInput>;
};

export type ChannelSelectionMaxAggregateOutputType = {
  __typename?: 'ChannelSelectionMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelSelectionMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includeUnassigned?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelSelectionMinAggregateOutputType = {
  __typename?: 'ChannelSelectionMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelSelectionMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includeUnassigned?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelSelectionNullableScalarRelationFilter = {
  AND?: Maybe<Array<ChannelSelectionWhereInput>>;
  NOT?: Maybe<Array<ChannelSelectionWhereInput>>;
  OR?: Maybe<Array<ChannelSelectionWhereInput>>;
  assignees?: Maybe<UserListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  includeUnassigned?: Maybe<BoolFilter>;
  statuses?: Maybe<ChannelStatusListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userSetting?: Maybe<UserSettingNullableScalarRelationFilter>;
};

export type ChannelSelectionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelSelectionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelSelectionOrderByRelevanceInput>;
  assignees?: Maybe<UserOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includeUnassigned?: Maybe<SortOrder>;
  statuses?: Maybe<ChannelStatusOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  userSetting?: Maybe<UserSettingOrderByWithRelationInput>;
};

export enum ChannelSelectionOrderByRelevanceFieldEnum {
  Id = 'id'
}

export type ChannelSelectionOrderByRelevanceInput = {
  fields: Array<ChannelSelectionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelSelectionOrderByWithAggregationInput = {
  _count?: Maybe<ChannelSelectionCountOrderByAggregateInput>;
  _max?: Maybe<ChannelSelectionMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelSelectionMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includeUnassigned?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelSelectionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelSelectionOrderByRelevanceInput>;
  assignees?: Maybe<UserOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includeUnassigned?: Maybe<SortOrder>;
  statuses?: Maybe<ChannelStatusOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  userSetting?: Maybe<UserSettingOrderByWithRelationInput>;
};

export type ChannelSelectionOrderByWithRelationInput = {
  _relevance?: Maybe<ChannelSelectionOrderByRelevanceInput>;
  assignees?: Maybe<UserOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  includeUnassigned?: Maybe<SortOrder>;
  statuses?: Maybe<ChannelStatusOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  userSetting?: Maybe<UserSettingOrderByWithRelationInput>;
};

export enum ChannelSelectionScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IncludeUnassigned = 'includeUnassigned',
  UpdatedAt = 'updatedAt'
}

export type ChannelSelectionScalarWhereInput = {
  AND?: Maybe<Array<ChannelSelectionScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelSelectionScalarWhereInput>>;
  OR?: Maybe<Array<ChannelSelectionScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  includeUnassigned?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChannelSelectionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelSelectionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelSelectionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelSelectionScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  includeUnassigned?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ChannelSelectionUncheckedCreateInput = {
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelSelectionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutChannelSelectionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingUncheckedCreateNestedOneWithoutBrowserNotificationFilterInput>;
};

export type ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput = {
  connect?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelSelectionCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<ChannelSelectionCreateWithoutAssigneesInput>>;
};

export type ChannelSelectionUncheckedCreateNestedManyWithoutStatusesInput = {
  connect?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelSelectionCreateOrConnectWithoutStatusesInput>>;
  create?: Maybe<Array<ChannelSelectionCreateWithoutStatusesInput>>;
};

export type ChannelSelectionUncheckedCreateWithoutAssigneesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutChannelSelectionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingUncheckedCreateNestedOneWithoutBrowserNotificationFilterInput>;
};

export type ChannelSelectionUncheckedCreateWithoutStatusesInput = {
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelSelectionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingUncheckedCreateNestedOneWithoutBrowserNotificationFilterInput>;
};

export type ChannelSelectionUncheckedCreateWithoutUserSettingInput = {
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelSelectionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutChannelSelectionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelSelectionUncheckedUpdateInput = {
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelSelectionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutChannelSelectionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingUncheckedUpdateOneWithoutBrowserNotificationFilterNestedInput>;
};

export type ChannelSelectionUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelSelectionUncheckedUpdateManyWithoutAssigneesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput = {
  connect?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelSelectionCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<ChannelSelectionCreateWithoutAssigneesInput>>;
  delete?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelSelectionScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  set?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  update?: Maybe<Array<ChannelSelectionUpdateWithWhereUniqueWithoutAssigneesInput>>;
  updateMany?: Maybe<Array<ChannelSelectionUpdateManyWithWhereWithoutAssigneesInput>>;
  upsert?: Maybe<Array<ChannelSelectionUpsertWithWhereUniqueWithoutAssigneesInput>>;
};

export type ChannelSelectionUncheckedUpdateManyWithoutStatusesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelSelectionUncheckedUpdateManyWithoutStatusesNestedInput = {
  connect?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelSelectionCreateOrConnectWithoutStatusesInput>>;
  create?: Maybe<Array<ChannelSelectionCreateWithoutStatusesInput>>;
  delete?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelSelectionScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  set?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  update?: Maybe<Array<ChannelSelectionUpdateWithWhereUniqueWithoutStatusesInput>>;
  updateMany?: Maybe<Array<ChannelSelectionUpdateManyWithWhereWithoutStatusesInput>>;
  upsert?: Maybe<Array<ChannelSelectionUpsertWithWhereUniqueWithoutStatusesInput>>;
};

export type ChannelSelectionUncheckedUpdateWithoutAssigneesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutChannelSelectionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingUncheckedUpdateOneWithoutBrowserNotificationFilterNestedInput>;
};

export type ChannelSelectionUncheckedUpdateWithoutStatusesInput = {
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelSelectionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingUncheckedUpdateOneWithoutBrowserNotificationFilterNestedInput>;
};

export type ChannelSelectionUncheckedUpdateWithoutUserSettingInput = {
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelSelectionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutChannelSelectionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelSelectionUpdateInput = {
  assignees?: Maybe<UserUpdateManyWithoutChannelSelectionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<ChannelStatusUpdateManyWithoutChannelSelectionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutBrowserNotificationFilterNestedInput>;
};

export type ChannelSelectionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelSelectionUpdateManyWithWhereWithoutAssigneesInput = {
  data: ChannelSelectionUpdateManyMutationInput;
  where: ChannelSelectionScalarWhereInput;
};

export type ChannelSelectionUpdateManyWithWhereWithoutStatusesInput = {
  data: ChannelSelectionUpdateManyMutationInput;
  where: ChannelSelectionScalarWhereInput;
};

export type ChannelSelectionUpdateManyWithoutAssigneesNestedInput = {
  connect?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelSelectionCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<ChannelSelectionCreateWithoutAssigneesInput>>;
  delete?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelSelectionScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  set?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  update?: Maybe<Array<ChannelSelectionUpdateWithWhereUniqueWithoutAssigneesInput>>;
  updateMany?: Maybe<Array<ChannelSelectionUpdateManyWithWhereWithoutAssigneesInput>>;
  upsert?: Maybe<Array<ChannelSelectionUpsertWithWhereUniqueWithoutAssigneesInput>>;
};

export type ChannelSelectionUpdateManyWithoutStatusesNestedInput = {
  connect?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelSelectionCreateOrConnectWithoutStatusesInput>>;
  create?: Maybe<Array<ChannelSelectionCreateWithoutStatusesInput>>;
  delete?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelSelectionScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  set?: Maybe<Array<ChannelSelectionWhereUniqueInput>>;
  update?: Maybe<Array<ChannelSelectionUpdateWithWhereUniqueWithoutStatusesInput>>;
  updateMany?: Maybe<Array<ChannelSelectionUpdateManyWithWhereWithoutStatusesInput>>;
  upsert?: Maybe<Array<ChannelSelectionUpsertWithWhereUniqueWithoutStatusesInput>>;
};

export type ChannelSelectionUpdateOneWithoutUserSettingNestedInput = {
  connect?: Maybe<ChannelSelectionWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelSelectionCreateOrConnectWithoutUserSettingInput>;
  create?: Maybe<ChannelSelectionCreateWithoutUserSettingInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelSelectionUpdateToOneWithWhereWithoutUserSettingInput>;
  upsert?: Maybe<ChannelSelectionUpsertWithoutUserSettingInput>;
};

export type ChannelSelectionUpdateToOneWithWhereWithoutUserSettingInput = {
  data: ChannelSelectionUpdateWithoutUserSettingInput;
  where?: Maybe<ChannelSelectionWhereInput>;
};

export type ChannelSelectionUpdateWithWhereUniqueWithoutAssigneesInput = {
  data: ChannelSelectionUpdateWithoutAssigneesInput;
  where: ChannelSelectionWhereUniqueInput;
};

export type ChannelSelectionUpdateWithWhereUniqueWithoutStatusesInput = {
  data: ChannelSelectionUpdateWithoutStatusesInput;
  where: ChannelSelectionWhereUniqueInput;
};

export type ChannelSelectionUpdateWithoutAssigneesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<ChannelStatusUpdateManyWithoutChannelSelectionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutBrowserNotificationFilterNestedInput>;
};

export type ChannelSelectionUpdateWithoutStatusesInput = {
  assignees?: Maybe<UserUpdateManyWithoutChannelSelectionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutBrowserNotificationFilterNestedInput>;
};

export type ChannelSelectionUpdateWithoutUserSettingInput = {
  assignees?: Maybe<UserUpdateManyWithoutChannelSelectionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<ChannelStatusUpdateManyWithoutChannelSelectionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelSelectionUpsertWithWhereUniqueWithoutAssigneesInput = {
  create: ChannelSelectionCreateWithoutAssigneesInput;
  update: ChannelSelectionUpdateWithoutAssigneesInput;
  where: ChannelSelectionWhereUniqueInput;
};

export type ChannelSelectionUpsertWithWhereUniqueWithoutStatusesInput = {
  create: ChannelSelectionCreateWithoutStatusesInput;
  update: ChannelSelectionUpdateWithoutStatusesInput;
  where: ChannelSelectionWhereUniqueInput;
};

export type ChannelSelectionUpsertWithoutUserSettingInput = {
  create: ChannelSelectionCreateWithoutUserSettingInput;
  update: ChannelSelectionUpdateWithoutUserSettingInput;
  where?: Maybe<ChannelSelectionWhereInput>;
};

export type ChannelSelectionWhereInput = {
  AND?: Maybe<Array<ChannelSelectionWhereInput>>;
  NOT?: Maybe<Array<ChannelSelectionWhereInput>>;
  OR?: Maybe<Array<ChannelSelectionWhereInput>>;
  assignees?: Maybe<UserListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  includeUnassigned?: Maybe<BoolFilter>;
  statuses?: Maybe<ChannelStatusListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userSetting?: Maybe<UserSettingNullableScalarRelationFilter>;
};

export type ChannelSelectionWhereUniqueInput = {
  AND?: Maybe<Array<ChannelSelectionWhereInput>>;
  NOT?: Maybe<Array<ChannelSelectionWhereInput>>;
  OR?: Maybe<Array<ChannelSelectionWhereInput>>;
  assignees?: Maybe<UserListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  includeUnassigned?: Maybe<BoolFilter>;
  statuses?: Maybe<ChannelStatusListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userSetting?: Maybe<UserSettingNullableScalarRelationFilter>;
};

export type ChannelStatus = {
  __typename?: 'ChannelStatus';
  _count: ChannelStatusCountOutputType;
  automationRunActions: Array<AutomationRunAction>;
  boardFilterColumns: Array<BoardFilterColumn>;
  channelSelections: Array<ChannelSelection>;
  channelStatusAction: ChannelStatusAction;
  channelStatusChannelAssignees: Array<ChannelStatusChannelAssignee>;
  channels: Array<Channel>;
  clinicSetting?: Maybe<ClinicSetting>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType: Array<ClinicWidgetRequestType>;
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedBy?: Maybe<User>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions: Array<WorkflowEventAction>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
  workflowEventAction: Array<WorkflowEventAction>;
  workflowEventSettings: Array<WorkflowEventSetting>;
};


export type ChannelStatusAutomationRunActionsArgs = {
  cursor?: Maybe<AutomationRunActionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunActionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunActionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type ChannelStatusBoardFilterColumnsArgs = {
  cursor?: Maybe<BoardFilterColumnWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoardFilterColumnScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoardFilterColumnOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoardFilterColumnWhereInput>;
};


export type ChannelStatusChannelSelectionsArgs = {
  cursor?: Maybe<ChannelSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelSelectionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelSelectionWhereInput>;
};


export type ChannelStatusChannelStatusChannelAssigneesArgs = {
  cursor?: Maybe<ChannelStatusChannelAssigneeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusChannelAssigneeWhereInput>;
};


export type ChannelStatusChannelsArgs = {
  cursor?: Maybe<ChannelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelWhereInput>;
};


export type ChannelStatusClinicSettingArgs = {
  where?: Maybe<ClinicSettingWhereInput>;
};


export type ChannelStatusClinicWidgetRequestTypeArgs = {
  cursor?: Maybe<ClinicWidgetRequestTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};


export type ChannelStatusDeletedByArgs = {
  where?: Maybe<UserWhereInput>;
};


export type ChannelStatusResponseWorkflowEventActionsArgs = {
  cursor?: Maybe<WorkflowEventActionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventActionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventActionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventActionWhereInput>;
};


export type ChannelStatusWorkflowEventActionArgs = {
  cursor?: Maybe<WorkflowEventActionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventActionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventActionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventActionWhereInput>;
};


export type ChannelStatusWorkflowEventSettingsArgs = {
  cursor?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export enum ChannelStatusAction {
  Active = 'Active',
  Inactive = 'Inactive',
  InactivePermanently = 'InactivePermanently',
  Migrated = 'Migrated'
}

export type ChannelStatusAvgAggregateOutputType = {
  __typename?: 'ChannelStatusAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type ChannelStatusAvgOrderByAggregateInput = {
  order?: Maybe<SortOrder>;
};

export type ChannelStatusChannelAssignee = {
  __typename?: 'ChannelStatusChannelAssignee';
  channelStatus: ChannelStatus;
  channelStatusId: Scalars['String'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type ChannelStatusChannelAssigneeChannelStatusChannelAssigneeChannelStatusIdAndUserIdCompoundUniqueInput = {
  channelStatusId: Scalars['String'];
  userId: Scalars['String'];
};

export type ChannelStatusChannelAssigneeCountAggregateOutputType = {
  __typename?: 'ChannelStatusChannelAssigneeCountAggregateOutputType';
  _all: Scalars['Int'];
  channelStatusId: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ChannelStatusChannelAssigneeCountOrderByAggregateInput = {
  channelStatusId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelStatusChannelAssigneeCreateInput = {
  channelStatus: ChannelStatusCreateNestedOneWithoutChannelStatusChannelAssigneesInput;
  clinic: ClinicCreateNestedOneWithoutChannelStatusChannelAssigneesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  user: UserCreateNestedOneWithoutChannelStatusChannelAssigneesInput;
};

export type ChannelStatusChannelAssigneeCreateManyChannelStatusInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ChannelStatusChannelAssigneeCreateManyChannelStatusInputEnvelope = {
  data: Array<ChannelStatusChannelAssigneeCreateManyChannelStatusInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelStatusChannelAssigneeCreateManyClinicInput = {
  channelStatusId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ChannelStatusChannelAssigneeCreateManyClinicInputEnvelope = {
  data: Array<ChannelStatusChannelAssigneeCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelStatusChannelAssigneeCreateManyInput = {
  channelStatusId: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ChannelStatusChannelAssigneeCreateManyUserInput = {
  channelStatusId: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeCreateManyUserInputEnvelope = {
  data: Array<ChannelStatusChannelAssigneeCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelStatusChannelAssigneeCreateNestedManyWithoutChannelStatusInput = {
  connect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusChannelAssigneeCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<ChannelStatusChannelAssigneeCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<ChannelStatusChannelAssigneeCreateManyChannelStatusInputEnvelope>;
};

export type ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusChannelAssigneeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ChannelStatusChannelAssigneeCreateWithoutClinicInput>>;
  createMany?: Maybe<ChannelStatusChannelAssigneeCreateManyClinicInputEnvelope>;
};

export type ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusChannelAssigneeCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelStatusChannelAssigneeCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelStatusChannelAssigneeCreateManyUserInputEnvelope>;
};

export type ChannelStatusChannelAssigneeCreateOrConnectWithoutChannelStatusInput = {
  create: ChannelStatusChannelAssigneeCreateWithoutChannelStatusInput;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};

export type ChannelStatusChannelAssigneeCreateOrConnectWithoutClinicInput = {
  create: ChannelStatusChannelAssigneeCreateWithoutClinicInput;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};

export type ChannelStatusChannelAssigneeCreateOrConnectWithoutUserInput = {
  create: ChannelStatusChannelAssigneeCreateWithoutUserInput;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};

export type ChannelStatusChannelAssigneeCreateWithoutChannelStatusInput = {
  clinic: ClinicCreateNestedOneWithoutChannelStatusChannelAssigneesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  user: UserCreateNestedOneWithoutChannelStatusChannelAssigneesInput;
};

export type ChannelStatusChannelAssigneeCreateWithoutClinicInput = {
  channelStatus: ChannelStatusCreateNestedOneWithoutChannelStatusChannelAssigneesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  user: UserCreateNestedOneWithoutChannelStatusChannelAssigneesInput;
};

export type ChannelStatusChannelAssigneeCreateWithoutUserInput = {
  channelStatus: ChannelStatusCreateNestedOneWithoutChannelStatusChannelAssigneesInput;
  clinic: ClinicCreateNestedOneWithoutChannelStatusChannelAssigneesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeGroupByOutputType = {
  __typename?: 'ChannelStatusChannelAssigneeGroupByOutputType';
  _count?: Maybe<ChannelStatusChannelAssigneeCountAggregateOutputType>;
  _max?: Maybe<ChannelStatusChannelAssigneeMaxAggregateOutputType>;
  _min?: Maybe<ChannelStatusChannelAssigneeMinAggregateOutputType>;
  channelStatusId: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  userId: Scalars['String'];
};

export type ChannelStatusChannelAssigneeListRelationFilter = {
  every?: Maybe<ChannelStatusChannelAssigneeWhereInput>;
  none?: Maybe<ChannelStatusChannelAssigneeWhereInput>;
  some?: Maybe<ChannelStatusChannelAssigneeWhereInput>;
};

export type ChannelStatusChannelAssigneeMaxAggregateOutputType = {
  __typename?: 'ChannelStatusChannelAssigneeMaxAggregateOutputType';
  channelStatusId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeMaxOrderByAggregateInput = {
  channelStatusId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelStatusChannelAssigneeMinAggregateOutputType = {
  __typename?: 'ChannelStatusChannelAssigneeMinAggregateOutputType';
  channelStatusId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeMinOrderByAggregateInput = {
  channelStatusId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelStatusChannelAssigneeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelStatusChannelAssigneeOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelStatusChannelAssigneeOrderByRelevanceInput>;
  channelStatus?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ChannelStatusChannelAssigneeOrderByRelevanceFieldEnum {
  ChannelStatusId = 'channelStatusId',
  ClinicId = 'clinicId',
  Id = 'id',
  UserId = 'userId'
}

export type ChannelStatusChannelAssigneeOrderByRelevanceInput = {
  fields: Array<ChannelStatusChannelAssigneeOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelStatusChannelAssigneeOrderByWithAggregationInput = {
  _count?: Maybe<ChannelStatusChannelAssigneeCountOrderByAggregateInput>;
  _max?: Maybe<ChannelStatusChannelAssigneeMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelStatusChannelAssigneeMinOrderByAggregateInput>;
  channelStatusId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ChannelStatusChannelAssigneeOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelStatusChannelAssigneeOrderByRelevanceInput>;
  channelStatus?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type ChannelStatusChannelAssigneeOrderByWithRelationInput = {
  _relevance?: Maybe<ChannelStatusChannelAssigneeOrderByRelevanceInput>;
  channelStatus?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ChannelStatusChannelAssigneeScalarFieldEnum {
  ChannelStatusId = 'channelStatusId',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  UserId = 'userId'
}

export type ChannelStatusChannelAssigneeScalarWhereInput = {
  AND?: Maybe<Array<ChannelStatusChannelAssigneeScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelStatusChannelAssigneeScalarWhereInput>>;
  OR?: Maybe<Array<ChannelStatusChannelAssigneeScalarWhereInput>>;
  channelStatusId?: Maybe<StringFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  userId?: Maybe<StringFilter>;
};

export type ChannelStatusChannelAssigneeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelStatusChannelAssigneeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelStatusChannelAssigneeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelStatusChannelAssigneeScalarWhereWithAggregatesInput>>;
  channelStatusId?: Maybe<StringWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  userId?: Maybe<StringWithAggregatesFilter>;
};

export type ChannelStatusChannelAssigneeUncheckedCreateInput = {
  channelStatusId: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutChannelStatusInput = {
  connect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusChannelAssigneeCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<ChannelStatusChannelAssigneeCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<ChannelStatusChannelAssigneeCreateManyChannelStatusInputEnvelope>;
};

export type ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusChannelAssigneeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ChannelStatusChannelAssigneeCreateWithoutClinicInput>>;
  createMany?: Maybe<ChannelStatusChannelAssigneeCreateManyClinicInputEnvelope>;
};

export type ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusChannelAssigneeCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelStatusChannelAssigneeCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelStatusChannelAssigneeCreateManyUserInputEnvelope>;
};

export type ChannelStatusChannelAssigneeUncheckedCreateWithoutChannelStatusInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ChannelStatusChannelAssigneeUncheckedCreateWithoutClinicInput = {
  channelStatusId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ChannelStatusChannelAssigneeUncheckedCreateWithoutUserInput = {
  channelStatusId: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeUncheckedUpdateInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeUncheckedUpdateManyInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusNestedInput = {
  connect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusChannelAssigneeCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<ChannelStatusChannelAssigneeCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<ChannelStatusChannelAssigneeCreateManyChannelStatusInputEnvelope>;
  delete?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelStatusChannelAssigneeScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  set?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  update?: Maybe<Array<ChannelStatusChannelAssigneeUpdateWithWhereUniqueWithoutChannelStatusInput>>;
  updateMany?: Maybe<Array<ChannelStatusChannelAssigneeUpdateManyWithWhereWithoutChannelStatusInput>>;
  upsert?: Maybe<Array<ChannelStatusChannelAssigneeUpsertWithWhereUniqueWithoutChannelStatusInput>>;
};

export type ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusChannelAssigneeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ChannelStatusChannelAssigneeCreateWithoutClinicInput>>;
  createMany?: Maybe<ChannelStatusChannelAssigneeCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelStatusChannelAssigneeScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  set?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  update?: Maybe<Array<ChannelStatusChannelAssigneeUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ChannelStatusChannelAssigneeUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ChannelStatusChannelAssigneeUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusChannelAssigneeCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelStatusChannelAssigneeCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelStatusChannelAssigneeCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelStatusChannelAssigneeScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  set?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  update?: Maybe<Array<ChannelStatusChannelAssigneeUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ChannelStatusChannelAssigneeUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ChannelStatusChannelAssigneeUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChannelStatusChannelAssigneeUncheckedUpdateWithoutChannelStatusInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeUncheckedUpdateWithoutClinicInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeUncheckedUpdateWithoutUserInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeUpdateInput = {
  channelStatus?: Maybe<ChannelStatusUpdateOneRequiredWithoutChannelStatusChannelAssigneesNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutChannelStatusChannelAssigneesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  user?: Maybe<UserUpdateOneRequiredWithoutChannelStatusChannelAssigneesNestedInput>;
};

export type ChannelStatusChannelAssigneeUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeUpdateManyWithWhereWithoutChannelStatusInput = {
  data: ChannelStatusChannelAssigneeUpdateManyMutationInput;
  where: ChannelStatusChannelAssigneeScalarWhereInput;
};

export type ChannelStatusChannelAssigneeUpdateManyWithWhereWithoutClinicInput = {
  data: ChannelStatusChannelAssigneeUpdateManyMutationInput;
  where: ChannelStatusChannelAssigneeScalarWhereInput;
};

export type ChannelStatusChannelAssigneeUpdateManyWithWhereWithoutUserInput = {
  data: ChannelStatusChannelAssigneeUpdateManyMutationInput;
  where: ChannelStatusChannelAssigneeScalarWhereInput;
};

export type ChannelStatusChannelAssigneeUpdateManyWithoutChannelStatusNestedInput = {
  connect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusChannelAssigneeCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<ChannelStatusChannelAssigneeCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<ChannelStatusChannelAssigneeCreateManyChannelStatusInputEnvelope>;
  delete?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelStatusChannelAssigneeScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  set?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  update?: Maybe<Array<ChannelStatusChannelAssigneeUpdateWithWhereUniqueWithoutChannelStatusInput>>;
  updateMany?: Maybe<Array<ChannelStatusChannelAssigneeUpdateManyWithWhereWithoutChannelStatusInput>>;
  upsert?: Maybe<Array<ChannelStatusChannelAssigneeUpsertWithWhereUniqueWithoutChannelStatusInput>>;
};

export type ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusChannelAssigneeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ChannelStatusChannelAssigneeCreateWithoutClinicInput>>;
  createMany?: Maybe<ChannelStatusChannelAssigneeCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelStatusChannelAssigneeScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  set?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  update?: Maybe<Array<ChannelStatusChannelAssigneeUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ChannelStatusChannelAssigneeUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ChannelStatusChannelAssigneeUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusChannelAssigneeCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ChannelStatusChannelAssigneeCreateWithoutUserInput>>;
  createMany?: Maybe<ChannelStatusChannelAssigneeCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelStatusChannelAssigneeScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  set?: Maybe<Array<ChannelStatusChannelAssigneeWhereUniqueInput>>;
  update?: Maybe<Array<ChannelStatusChannelAssigneeUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ChannelStatusChannelAssigneeUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ChannelStatusChannelAssigneeUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChannelStatusChannelAssigneeUpdateWithWhereUniqueWithoutChannelStatusInput = {
  data: ChannelStatusChannelAssigneeUpdateWithoutChannelStatusInput;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};

export type ChannelStatusChannelAssigneeUpdateWithWhereUniqueWithoutClinicInput = {
  data: ChannelStatusChannelAssigneeUpdateWithoutClinicInput;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};

export type ChannelStatusChannelAssigneeUpdateWithWhereUniqueWithoutUserInput = {
  data: ChannelStatusChannelAssigneeUpdateWithoutUserInput;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};

export type ChannelStatusChannelAssigneeUpdateWithoutChannelStatusInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutChannelStatusChannelAssigneesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  user?: Maybe<UserUpdateOneRequiredWithoutChannelStatusChannelAssigneesNestedInput>;
};

export type ChannelStatusChannelAssigneeUpdateWithoutClinicInput = {
  channelStatus?: Maybe<ChannelStatusUpdateOneRequiredWithoutChannelStatusChannelAssigneesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  user?: Maybe<UserUpdateOneRequiredWithoutChannelStatusChannelAssigneesNestedInput>;
};

export type ChannelStatusChannelAssigneeUpdateWithoutUserInput = {
  channelStatus?: Maybe<ChannelStatusUpdateOneRequiredWithoutChannelStatusChannelAssigneesNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutChannelStatusChannelAssigneesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type ChannelStatusChannelAssigneeUpsertWithWhereUniqueWithoutChannelStatusInput = {
  create: ChannelStatusChannelAssigneeCreateWithoutChannelStatusInput;
  update: ChannelStatusChannelAssigneeUpdateWithoutChannelStatusInput;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};

export type ChannelStatusChannelAssigneeUpsertWithWhereUniqueWithoutClinicInput = {
  create: ChannelStatusChannelAssigneeCreateWithoutClinicInput;
  update: ChannelStatusChannelAssigneeUpdateWithoutClinicInput;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};

export type ChannelStatusChannelAssigneeUpsertWithWhereUniqueWithoutUserInput = {
  create: ChannelStatusChannelAssigneeCreateWithoutUserInput;
  update: ChannelStatusChannelAssigneeUpdateWithoutUserInput;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};

export type ChannelStatusChannelAssigneeWhereInput = {
  AND?: Maybe<Array<ChannelStatusChannelAssigneeWhereInput>>;
  NOT?: Maybe<Array<ChannelStatusChannelAssigneeWhereInput>>;
  OR?: Maybe<Array<ChannelStatusChannelAssigneeWhereInput>>;
  channelStatus?: Maybe<ChannelStatusScalarRelationFilter>;
  channelStatusId?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type ChannelStatusChannelAssigneeWhereUniqueInput = {
  AND?: Maybe<Array<ChannelStatusChannelAssigneeWhereInput>>;
  NOT?: Maybe<Array<ChannelStatusChannelAssigneeWhereInput>>;
  OR?: Maybe<Array<ChannelStatusChannelAssigneeWhereInput>>;
  channelStatus?: Maybe<ChannelStatusScalarRelationFilter>;
  channelStatusChannelAssigneeChannelStatusIdAndUserId?: Maybe<ChannelStatusChannelAssigneeChannelStatusChannelAssigneeChannelStatusIdAndUserIdCompoundUniqueInput>;
  channelStatusId?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type ChannelStatusCountAggregateOutputType = {
  __typename?: 'ChannelStatusCountAggregateOutputType';
  _all: Scalars['Int'];
  channelStatusAction: Scalars['Int'];
  clinicSettingId: Scalars['Int'];
  color: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedById: Scalars['Int'];
  deletedOn: Scalars['Int'];
  id: Scalars['Int'];
  isDefault: Scalars['Int'];
  isExportedToPims: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  shouldNotifyChronos: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ChannelStatusCountOrderByAggregateInput = {
  channelStatusAction?: Maybe<SortOrder>;
  clinicSettingId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedById?: Maybe<SortOrder>;
  deletedOn?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isExportedToPims?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  shouldNotifyChronos?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelStatusCountOutputType = {
  __typename?: 'ChannelStatusCountOutputType';
  automationRunActions: Scalars['Int'];
  boardFilterColumns: Scalars['Int'];
  channelSelections: Scalars['Int'];
  channelStatusChannelAssignees: Scalars['Int'];
  channels: Scalars['Int'];
  clinicWidgetRequestType: Scalars['Int'];
  responseWorkflowEventActions: Scalars['Int'];
  workflowEventAction: Scalars['Int'];
  workflowEventSettings: Scalars['Int'];
};

export type ChannelStatusCreateInput = {
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutChannelStatusInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutChannelStatusesInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserCreateNestedOneWithoutChannelStatusesInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusCreateManyClinicSettingInput = {
  channelStatusAction?: Maybe<ChannelStatusAction>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelStatusCreateManyClinicSettingInputEnvelope = {
  data: Array<ChannelStatusCreateManyClinicSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelStatusCreateManyDeletedByInput = {
  channelStatusAction?: Maybe<ChannelStatusAction>;
  clinicSettingId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelStatusCreateManyDeletedByInputEnvelope = {
  data: Array<ChannelStatusCreateManyDeletedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ChannelStatusCreateManyInput = {
  channelStatusAction?: Maybe<ChannelStatusAction>;
  clinicSettingId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelStatusCreateNestedManyWithoutChannelSelectionsInput = {
  connect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusCreateOrConnectWithoutChannelSelectionsInput>>;
  create?: Maybe<Array<ChannelStatusCreateWithoutChannelSelectionsInput>>;
};

export type ChannelStatusCreateNestedManyWithoutClinicSettingInput = {
  connect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusCreateOrConnectWithoutClinicSettingInput>>;
  create?: Maybe<Array<ChannelStatusCreateWithoutClinicSettingInput>>;
  createMany?: Maybe<ChannelStatusCreateManyClinicSettingInputEnvelope>;
};

export type ChannelStatusCreateNestedManyWithoutDeletedByInput = {
  connect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusCreateOrConnectWithoutDeletedByInput>>;
  create?: Maybe<Array<ChannelStatusCreateWithoutDeletedByInput>>;
  createMany?: Maybe<ChannelStatusCreateManyDeletedByInputEnvelope>;
};

export type ChannelStatusCreateNestedOneWithoutAutomationRunActionsInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutAutomationRunActionsInput>;
  create?: Maybe<ChannelStatusCreateWithoutAutomationRunActionsInput>;
};

export type ChannelStatusCreateNestedOneWithoutBoardFilterColumnsInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutBoardFilterColumnsInput>;
  create?: Maybe<ChannelStatusCreateWithoutBoardFilterColumnsInput>;
};

export type ChannelStatusCreateNestedOneWithoutChannelStatusChannelAssigneesInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutChannelStatusChannelAssigneesInput>;
  create?: Maybe<ChannelStatusCreateWithoutChannelStatusChannelAssigneesInput>;
};

export type ChannelStatusCreateNestedOneWithoutChannelsInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutChannelsInput>;
  create?: Maybe<ChannelStatusCreateWithoutChannelsInput>;
};

export type ChannelStatusCreateNestedOneWithoutClinicWidgetRequestTypeInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutClinicWidgetRequestTypeInput>;
  create?: Maybe<ChannelStatusCreateWithoutClinicWidgetRequestTypeInput>;
};

export type ChannelStatusCreateNestedOneWithoutResponseWorkflowEventActionsInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutResponseWorkflowEventActionsInput>;
  create?: Maybe<ChannelStatusCreateWithoutResponseWorkflowEventActionsInput>;
};

export type ChannelStatusCreateNestedOneWithoutWorkflowEventActionInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutWorkflowEventActionInput>;
  create?: Maybe<ChannelStatusCreateWithoutWorkflowEventActionInput>;
};

export type ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutWorkflowEventSettingsInput>;
  create?: Maybe<ChannelStatusCreateWithoutWorkflowEventSettingsInput>;
};

export type ChannelStatusCreateOrConnectWithoutAutomationRunActionsInput = {
  create: ChannelStatusCreateWithoutAutomationRunActionsInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusCreateOrConnectWithoutBoardFilterColumnsInput = {
  create: ChannelStatusCreateWithoutBoardFilterColumnsInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusCreateOrConnectWithoutChannelSelectionsInput = {
  create: ChannelStatusCreateWithoutChannelSelectionsInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusCreateOrConnectWithoutChannelStatusChannelAssigneesInput = {
  create: ChannelStatusCreateWithoutChannelStatusChannelAssigneesInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusCreateOrConnectWithoutChannelsInput = {
  create: ChannelStatusCreateWithoutChannelsInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusCreateOrConnectWithoutClinicSettingInput = {
  create: ChannelStatusCreateWithoutClinicSettingInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusCreateOrConnectWithoutClinicWidgetRequestTypeInput = {
  create: ChannelStatusCreateWithoutClinicWidgetRequestTypeInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusCreateOrConnectWithoutDeletedByInput = {
  create: ChannelStatusCreateWithoutDeletedByInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusCreateOrConnectWithoutResponseWorkflowEventActionsInput = {
  create: ChannelStatusCreateWithoutResponseWorkflowEventActionsInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusCreateOrConnectWithoutWorkflowEventActionInput = {
  create: ChannelStatusCreateWithoutWorkflowEventActionInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusCreateOrConnectWithoutWorkflowEventSettingsInput = {
  create: ChannelStatusCreateWithoutWorkflowEventSettingsInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusCreateWithoutAutomationRunActionsInput = {
  boardFilterColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutChannelStatusInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutChannelStatusesInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserCreateNestedOneWithoutChannelStatusesInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusCreateWithoutBoardFilterColumnsInput = {
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutChannelStatusChangeInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutChannelStatusInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutChannelStatusesInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserCreateNestedOneWithoutChannelStatusesInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusCreateWithoutChannelSelectionsInput = {
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutChannelStatusInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutChannelStatusInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutChannelStatusesInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserCreateNestedOneWithoutChannelStatusesInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusCreateWithoutChannelStatusChannelAssigneesInput = {
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channels?: Maybe<ChannelCreateNestedManyWithoutChannelStatusInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutChannelStatusesInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserCreateNestedOneWithoutChannelStatusesInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusCreateWithoutChannelsInput = {
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutChannelStatusInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutChannelStatusesInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserCreateNestedOneWithoutChannelStatusesInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusCreateWithoutClinicSettingInput = {
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutChannelStatusInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserCreateNestedOneWithoutChannelStatusesInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusCreateWithoutClinicWidgetRequestTypeInput = {
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutChannelStatusInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutChannelStatusesInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserCreateNestedOneWithoutChannelStatusesInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusCreateWithoutDeletedByInput = {
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutChannelStatusInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutChannelStatusesInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusCreateWithoutResponseWorkflowEventActionsInput = {
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutChannelStatusInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutChannelStatusesInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserCreateNestedOneWithoutChannelStatusesInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusCreateWithoutWorkflowEventActionInput = {
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutChannelStatusInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutChannelStatusesInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserCreateNestedOneWithoutChannelStatusesInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusCreateWithoutWorkflowEventSettingsInput = {
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutChannelStatusInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutChannelStatusesInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserCreateNestedOneWithoutChannelStatusesInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionCreateNestedManyWithoutChannelStatusChangeInput>;
};

export enum ChannelStatusEntity {
  Appointment = 'Appointment',
  Automation = 'Automation',
  Channel = 'Channel'
}

export type ChannelStatusGroupByOutputType = {
  __typename?: 'ChannelStatusGroupByOutputType';
  _avg?: Maybe<ChannelStatusAvgAggregateOutputType>;
  _count?: Maybe<ChannelStatusCountAggregateOutputType>;
  _max?: Maybe<ChannelStatusMaxAggregateOutputType>;
  _min?: Maybe<ChannelStatusMinAggregateOutputType>;
  _sum?: Maybe<ChannelStatusSumAggregateOutputType>;
  channelStatusAction: ChannelStatusAction;
  clinicSettingId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type ChannelStatusListRelationFilter = {
  every?: Maybe<ChannelStatusWhereInput>;
  none?: Maybe<ChannelStatusWhereInput>;
  some?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusMaxAggregateOutputType = {
  __typename?: 'ChannelStatusMaxAggregateOutputType';
  channelStatusAction?: Maybe<ChannelStatusAction>;
  clinicSettingId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelStatusMaxOrderByAggregateInput = {
  channelStatusAction?: Maybe<SortOrder>;
  clinicSettingId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedById?: Maybe<SortOrder>;
  deletedOn?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isExportedToPims?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  shouldNotifyChronos?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelStatusMinAggregateOutputType = {
  __typename?: 'ChannelStatusMinAggregateOutputType';
  channelStatusAction?: Maybe<ChannelStatusAction>;
  clinicSettingId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelStatusMinOrderByAggregateInput = {
  channelStatusAction?: Maybe<SortOrder>;
  clinicSettingId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedById?: Maybe<SortOrder>;
  deletedOn?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isExportedToPims?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  shouldNotifyChronos?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelStatusNullableScalarRelationFilter = {
  AND?: Maybe<Array<ChannelStatusWhereInput>>;
  NOT?: Maybe<Array<ChannelStatusWhereInput>>;
  OR?: Maybe<Array<ChannelStatusWhereInput>>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  boardFilterColumns?: Maybe<BoardFilterColumnListRelationFilter>;
  channelSelections?: Maybe<ChannelSelectionListRelationFilter>;
  channelStatusAction?: Maybe<EnumChannelStatusActionFilter>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  clinicSetting?: Maybe<ClinicSettingNullableScalarRelationFilter>;
  clinicSettingId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  color?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedBy?: Maybe<UserNullableScalarRelationFilter>;
  deletedById?: Maybe<StringNullableFilter>;
  deletedOn?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  isDefault?: Maybe<BoolNullableFilter>;
  isExportedToPims?: Maybe<BoolNullableFilter>;
  name?: Maybe<StringFilter>;
  order?: Maybe<IntNullableFilter>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionListRelationFilter>;
  shouldNotifyChronos?: Maybe<BoolNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventAction?: Maybe<WorkflowEventActionListRelationFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type ChannelStatusOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ChannelStatusOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelStatusOrderByRelevanceInput>;
  automationRunActions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnOrderByRelationAggregateInput>;
  channelSelections?: Maybe<ChannelSelectionOrderByRelationAggregateInput>;
  channelStatusAction?: Maybe<SortOrder>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeOrderByRelationAggregateInput>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedBy?: Maybe<UserOrderByWithRelationInput>;
  deletedById?: Maybe<SortOrder>;
  deletedOn?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isExportedToPims?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionOrderByRelationAggregateInput>;
  shouldNotifyChronos?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventAction?: Maybe<WorkflowEventActionOrderByRelationAggregateInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum ChannelStatusOrderByRelevanceFieldEnum {
  ClinicSettingId = 'clinicSettingId',
  Color = 'color',
  DeletedById = 'deletedById',
  Id = 'id',
  Name = 'name'
}

export type ChannelStatusOrderByRelevanceInput = {
  fields: Array<ChannelStatusOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChannelStatusOrderByWithAggregationInput = {
  _avg?: Maybe<ChannelStatusAvgOrderByAggregateInput>;
  _count?: Maybe<ChannelStatusCountOrderByAggregateInput>;
  _max?: Maybe<ChannelStatusMaxOrderByAggregateInput>;
  _min?: Maybe<ChannelStatusMinOrderByAggregateInput>;
  _sum?: Maybe<ChannelStatusSumOrderByAggregateInput>;
  channelStatusAction?: Maybe<SortOrder>;
  clinicSettingId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedById?: Maybe<SortOrder>;
  deletedOn?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isExportedToPims?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  shouldNotifyChronos?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChannelStatusOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChannelStatusOrderByRelevanceInput>;
  automationRunActions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnOrderByRelationAggregateInput>;
  channelSelections?: Maybe<ChannelSelectionOrderByRelationAggregateInput>;
  channelStatusAction?: Maybe<SortOrder>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeOrderByRelationAggregateInput>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedBy?: Maybe<UserOrderByWithRelationInput>;
  deletedById?: Maybe<SortOrder>;
  deletedOn?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isExportedToPims?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionOrderByRelationAggregateInput>;
  shouldNotifyChronos?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventAction?: Maybe<WorkflowEventActionOrderByRelationAggregateInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export type ChannelStatusOrderByWithRelationInput = {
  _relevance?: Maybe<ChannelStatusOrderByRelevanceInput>;
  automationRunActions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnOrderByRelationAggregateInput>;
  channelSelections?: Maybe<ChannelSelectionOrderByRelationAggregateInput>;
  channelStatusAction?: Maybe<SortOrder>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeOrderByRelationAggregateInput>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedBy?: Maybe<UserOrderByWithRelationInput>;
  deletedById?: Maybe<SortOrder>;
  deletedOn?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isExportedToPims?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionOrderByRelationAggregateInput>;
  shouldNotifyChronos?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventAction?: Maybe<WorkflowEventActionOrderByRelationAggregateInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum ChannelStatusScalarFieldEnum {
  ChannelStatusAction = 'channelStatusAction',
  ClinicSettingId = 'clinicSettingId',
  Color = 'color',
  CreatedAt = 'createdAt',
  DeletedById = 'deletedById',
  DeletedOn = 'deletedOn',
  Id = 'id',
  IsDefault = 'isDefault',
  IsExportedToPims = 'isExportedToPims',
  Name = 'name',
  Order = 'order',
  ShouldNotifyChronos = 'shouldNotifyChronos',
  UpdatedAt = 'updatedAt'
}

export type ChannelStatusScalarRelationFilter = {
  AND?: Maybe<Array<ChannelStatusWhereInput>>;
  NOT?: Maybe<Array<ChannelStatusWhereInput>>;
  OR?: Maybe<Array<ChannelStatusWhereInput>>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  boardFilterColumns?: Maybe<BoardFilterColumnListRelationFilter>;
  channelSelections?: Maybe<ChannelSelectionListRelationFilter>;
  channelStatusAction?: Maybe<EnumChannelStatusActionFilter>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  clinicSetting?: Maybe<ClinicSettingNullableScalarRelationFilter>;
  clinicSettingId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  color?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedBy?: Maybe<UserNullableScalarRelationFilter>;
  deletedById?: Maybe<StringNullableFilter>;
  deletedOn?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  isDefault?: Maybe<BoolNullableFilter>;
  isExportedToPims?: Maybe<BoolNullableFilter>;
  name?: Maybe<StringFilter>;
  order?: Maybe<IntNullableFilter>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionListRelationFilter>;
  shouldNotifyChronos?: Maybe<BoolNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventAction?: Maybe<WorkflowEventActionListRelationFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type ChannelStatusScalarWhereInput = {
  AND?: Maybe<Array<ChannelStatusScalarWhereInput>>;
  NOT?: Maybe<Array<ChannelStatusScalarWhereInput>>;
  OR?: Maybe<Array<ChannelStatusScalarWhereInput>>;
  channelStatusAction?: Maybe<EnumChannelStatusActionFilter>;
  clinicSettingId?: Maybe<StringNullableFilter>;
  color?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedById?: Maybe<StringNullableFilter>;
  deletedOn?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  isDefault?: Maybe<BoolNullableFilter>;
  isExportedToPims?: Maybe<BoolNullableFilter>;
  name?: Maybe<StringFilter>;
  order?: Maybe<IntNullableFilter>;
  shouldNotifyChronos?: Maybe<BoolNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChannelStatusScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChannelStatusScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChannelStatusScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChannelStatusScalarWhereWithAggregatesInput>>;
  channelStatusAction?: Maybe<EnumChannelStatusActionWithAggregatesFilter>;
  clinicSettingId?: Maybe<StringNullableWithAggregatesFilter>;
  color?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deletedById?: Maybe<StringNullableWithAggregatesFilter>;
  deletedOn?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDefault?: Maybe<BoolNullableWithAggregatesFilter>;
  isExportedToPims?: Maybe<BoolNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  order?: Maybe<IntNullableWithAggregatesFilter>;
  shouldNotifyChronos?: Maybe<BoolNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ChannelStatusSumAggregateOutputType = {
  __typename?: 'ChannelStatusSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type ChannelStatusSumOrderByAggregateInput = {
  order?: Maybe<SortOrder>;
};

export type ChannelStatusUncheckedCreateInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutChannelStatusInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusUncheckedCreateNestedManyWithoutChannelSelectionsInput = {
  connect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusCreateOrConnectWithoutChannelSelectionsInput>>;
  create?: Maybe<Array<ChannelStatusCreateWithoutChannelSelectionsInput>>;
};

export type ChannelStatusUncheckedCreateNestedManyWithoutClinicSettingInput = {
  connect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusCreateOrConnectWithoutClinicSettingInput>>;
  create?: Maybe<Array<ChannelStatusCreateWithoutClinicSettingInput>>;
  createMany?: Maybe<ChannelStatusCreateManyClinicSettingInputEnvelope>;
};

export type ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput = {
  connect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusCreateOrConnectWithoutDeletedByInput>>;
  create?: Maybe<Array<ChannelStatusCreateWithoutDeletedByInput>>;
  createMany?: Maybe<ChannelStatusCreateManyDeletedByInputEnvelope>;
};

export type ChannelStatusUncheckedCreateWithoutAutomationRunActionsInput = {
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutChannelStatusInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusUncheckedCreateWithoutBoardFilterColumnsInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutChannelStatusInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusUncheckedCreateWithoutChannelSelectionsInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutChannelStatusInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusUncheckedCreateWithoutChannelStatusChannelAssigneesInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutChannelStatusInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusUncheckedCreateWithoutChannelsInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusUncheckedCreateWithoutClinicSettingInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutChannelStatusInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusUncheckedCreateWithoutClinicWidgetRequestTypeInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutChannelStatusInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusUncheckedCreateWithoutDeletedByInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutChannelStatusInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusUncheckedCreateWithoutResponseWorkflowEventActionsInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutChannelStatusInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusUncheckedCreateWithoutWorkflowEventActionInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutChannelStatusInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutInitialChannelStatusChangeInput>;
};

export type ChannelStatusUncheckedCreateWithoutWorkflowEventSettingsInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutStatusesInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutChannelStatusInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutChannelStatusInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutResponseChannelStatusChangeInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput>;
};

export type ChannelStatusUncheckedUpdateInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUncheckedUpdateManyInput = {
  channelStatusAction?: Maybe<ChannelStatusAction>;
  clinicSettingId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelStatusUncheckedUpdateManyWithoutChannelSelectionsInput = {
  channelStatusAction?: Maybe<ChannelStatusAction>;
  clinicSettingId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelStatusUncheckedUpdateManyWithoutChannelSelectionsNestedInput = {
  connect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusCreateOrConnectWithoutChannelSelectionsInput>>;
  create?: Maybe<Array<ChannelStatusCreateWithoutChannelSelectionsInput>>;
  delete?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelStatusUpdateWithWhereUniqueWithoutChannelSelectionsInput>>;
  updateMany?: Maybe<Array<ChannelStatusUpdateManyWithWhereWithoutChannelSelectionsInput>>;
  upsert?: Maybe<Array<ChannelStatusUpsertWithWhereUniqueWithoutChannelSelectionsInput>>;
};

export type ChannelStatusUncheckedUpdateManyWithoutClinicSettingInput = {
  channelStatusAction?: Maybe<ChannelStatusAction>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelStatusUncheckedUpdateManyWithoutClinicSettingNestedInput = {
  connect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusCreateOrConnectWithoutClinicSettingInput>>;
  create?: Maybe<Array<ChannelStatusCreateWithoutClinicSettingInput>>;
  createMany?: Maybe<ChannelStatusCreateManyClinicSettingInputEnvelope>;
  delete?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelStatusUpdateWithWhereUniqueWithoutClinicSettingInput>>;
  updateMany?: Maybe<Array<ChannelStatusUpdateManyWithWhereWithoutClinicSettingInput>>;
  upsert?: Maybe<Array<ChannelStatusUpsertWithWhereUniqueWithoutClinicSettingInput>>;
};

export type ChannelStatusUncheckedUpdateManyWithoutDeletedByInput = {
  channelStatusAction?: Maybe<ChannelStatusAction>;
  clinicSettingId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput = {
  connect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusCreateOrConnectWithoutDeletedByInput>>;
  create?: Maybe<Array<ChannelStatusCreateWithoutDeletedByInput>>;
  createMany?: Maybe<ChannelStatusCreateManyDeletedByInputEnvelope>;
  delete?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelStatusUpdateWithWhereUniqueWithoutDeletedByInput>>;
  updateMany?: Maybe<Array<ChannelStatusUpdateManyWithWhereWithoutDeletedByInput>>;
  upsert?: Maybe<Array<ChannelStatusUpsertWithWhereUniqueWithoutDeletedByInput>>;
};

export type ChannelStatusUncheckedUpdateWithoutAutomationRunActionsInput = {
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUncheckedUpdateWithoutBoardFilterColumnsInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUncheckedUpdateWithoutChannelSelectionsInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUncheckedUpdateWithoutChannelStatusChannelAssigneesInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUncheckedUpdateWithoutChannelsInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUncheckedUpdateWithoutClinicSettingInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUncheckedUpdateWithoutClinicWidgetRequestTypeInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUncheckedUpdateWithoutDeletedByInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUncheckedUpdateWithoutResponseWorkflowEventActionsInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUncheckedUpdateWithoutWorkflowEventActionInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUncheckedUpdateWithoutWorkflowEventSettingsInput = {
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpdateInput = {
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutChannelStatusNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutChannelStatusesNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserUpdateOneWithoutChannelStatusesNestedInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpdateManyMutationInput = {
  channelStatusAction?: Maybe<ChannelStatusAction>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelStatusUpdateManyWithWhereWithoutChannelSelectionsInput = {
  data: ChannelStatusUpdateManyMutationInput;
  where: ChannelStatusScalarWhereInput;
};

export type ChannelStatusUpdateManyWithWhereWithoutClinicSettingInput = {
  data: ChannelStatusUpdateManyMutationInput;
  where: ChannelStatusScalarWhereInput;
};

export type ChannelStatusUpdateManyWithWhereWithoutDeletedByInput = {
  data: ChannelStatusUpdateManyMutationInput;
  where: ChannelStatusScalarWhereInput;
};

export type ChannelStatusUpdateManyWithoutChannelSelectionsNestedInput = {
  connect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusCreateOrConnectWithoutChannelSelectionsInput>>;
  create?: Maybe<Array<ChannelStatusCreateWithoutChannelSelectionsInput>>;
  delete?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelStatusUpdateWithWhereUniqueWithoutChannelSelectionsInput>>;
  updateMany?: Maybe<Array<ChannelStatusUpdateManyWithWhereWithoutChannelSelectionsInput>>;
  upsert?: Maybe<Array<ChannelStatusUpsertWithWhereUniqueWithoutChannelSelectionsInput>>;
};

export type ChannelStatusUpdateManyWithoutClinicSettingNestedInput = {
  connect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusCreateOrConnectWithoutClinicSettingInput>>;
  create?: Maybe<Array<ChannelStatusCreateWithoutClinicSettingInput>>;
  createMany?: Maybe<ChannelStatusCreateManyClinicSettingInputEnvelope>;
  delete?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelStatusUpdateWithWhereUniqueWithoutClinicSettingInput>>;
  updateMany?: Maybe<Array<ChannelStatusUpdateManyWithWhereWithoutClinicSettingInput>>;
  upsert?: Maybe<Array<ChannelStatusUpsertWithWhereUniqueWithoutClinicSettingInput>>;
};

export type ChannelStatusUpdateManyWithoutDeletedByNestedInput = {
  connect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelStatusCreateOrConnectWithoutDeletedByInput>>;
  create?: Maybe<Array<ChannelStatusCreateWithoutDeletedByInput>>;
  createMany?: Maybe<ChannelStatusCreateManyDeletedByInputEnvelope>;
  delete?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  set?: Maybe<Array<ChannelStatusWhereUniqueInput>>;
  update?: Maybe<Array<ChannelStatusUpdateWithWhereUniqueWithoutDeletedByInput>>;
  updateMany?: Maybe<Array<ChannelStatusUpdateManyWithWhereWithoutDeletedByInput>>;
  upsert?: Maybe<Array<ChannelStatusUpsertWithWhereUniqueWithoutDeletedByInput>>;
};

export type ChannelStatusUpdateOneRequiredWithoutChannelStatusChannelAssigneesNestedInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutChannelStatusChannelAssigneesInput>;
  create?: Maybe<ChannelStatusCreateWithoutChannelStatusChannelAssigneesInput>;
  update?: Maybe<ChannelStatusUpdateToOneWithWhereWithoutChannelStatusChannelAssigneesInput>;
  upsert?: Maybe<ChannelStatusUpsertWithoutChannelStatusChannelAssigneesInput>;
};

export type ChannelStatusUpdateOneWithoutAutomationRunActionsNestedInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutAutomationRunActionsInput>;
  create?: Maybe<ChannelStatusCreateWithoutAutomationRunActionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelStatusUpdateToOneWithWhereWithoutAutomationRunActionsInput>;
  upsert?: Maybe<ChannelStatusUpsertWithoutAutomationRunActionsInput>;
};

export type ChannelStatusUpdateOneWithoutBoardFilterColumnsNestedInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutBoardFilterColumnsInput>;
  create?: Maybe<ChannelStatusCreateWithoutBoardFilterColumnsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelStatusUpdateToOneWithWhereWithoutBoardFilterColumnsInput>;
  upsert?: Maybe<ChannelStatusUpsertWithoutBoardFilterColumnsInput>;
};

export type ChannelStatusUpdateOneWithoutChannelsNestedInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutChannelsInput>;
  create?: Maybe<ChannelStatusCreateWithoutChannelsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelStatusUpdateToOneWithWhereWithoutChannelsInput>;
  upsert?: Maybe<ChannelStatusUpsertWithoutChannelsInput>;
};

export type ChannelStatusUpdateOneWithoutClinicWidgetRequestTypeNestedInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutClinicWidgetRequestTypeInput>;
  create?: Maybe<ChannelStatusCreateWithoutClinicWidgetRequestTypeInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelStatusUpdateToOneWithWhereWithoutClinicWidgetRequestTypeInput>;
  upsert?: Maybe<ChannelStatusUpsertWithoutClinicWidgetRequestTypeInput>;
};

export type ChannelStatusUpdateOneWithoutResponseWorkflowEventActionsNestedInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutResponseWorkflowEventActionsInput>;
  create?: Maybe<ChannelStatusCreateWithoutResponseWorkflowEventActionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelStatusUpdateToOneWithWhereWithoutResponseWorkflowEventActionsInput>;
  upsert?: Maybe<ChannelStatusUpsertWithoutResponseWorkflowEventActionsInput>;
};

export type ChannelStatusUpdateOneWithoutWorkflowEventActionNestedInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutWorkflowEventActionInput>;
  create?: Maybe<ChannelStatusCreateWithoutWorkflowEventActionInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelStatusUpdateToOneWithWhereWithoutWorkflowEventActionInput>;
  upsert?: Maybe<ChannelStatusUpsertWithoutWorkflowEventActionInput>;
};

export type ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput = {
  connect?: Maybe<ChannelStatusWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelStatusCreateOrConnectWithoutWorkflowEventSettingsInput>;
  create?: Maybe<ChannelStatusCreateWithoutWorkflowEventSettingsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelStatusUpdateToOneWithWhereWithoutWorkflowEventSettingsInput>;
  upsert?: Maybe<ChannelStatusUpsertWithoutWorkflowEventSettingsInput>;
};

export type ChannelStatusUpdateToOneWithWhereWithoutAutomationRunActionsInput = {
  data: ChannelStatusUpdateWithoutAutomationRunActionsInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpdateToOneWithWhereWithoutBoardFilterColumnsInput = {
  data: ChannelStatusUpdateWithoutBoardFilterColumnsInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpdateToOneWithWhereWithoutChannelStatusChannelAssigneesInput = {
  data: ChannelStatusUpdateWithoutChannelStatusChannelAssigneesInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpdateToOneWithWhereWithoutChannelsInput = {
  data: ChannelStatusUpdateWithoutChannelsInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpdateToOneWithWhereWithoutClinicWidgetRequestTypeInput = {
  data: ChannelStatusUpdateWithoutClinicWidgetRequestTypeInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpdateToOneWithWhereWithoutResponseWorkflowEventActionsInput = {
  data: ChannelStatusUpdateWithoutResponseWorkflowEventActionsInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpdateToOneWithWhereWithoutWorkflowEventActionInput = {
  data: ChannelStatusUpdateWithoutWorkflowEventActionInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpdateToOneWithWhereWithoutWorkflowEventSettingsInput = {
  data: ChannelStatusUpdateWithoutWorkflowEventSettingsInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpdateWithWhereUniqueWithoutChannelSelectionsInput = {
  data: ChannelStatusUpdateWithoutChannelSelectionsInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusUpdateWithWhereUniqueWithoutClinicSettingInput = {
  data: ChannelStatusUpdateWithoutClinicSettingInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusUpdateWithWhereUniqueWithoutDeletedByInput = {
  data: ChannelStatusUpdateWithoutDeletedByInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusUpdateWithoutAutomationRunActionsInput = {
  boardFilterColumns?: Maybe<BoardFilterColumnUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutChannelStatusNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutChannelStatusesNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserUpdateOneWithoutChannelStatusesNestedInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpdateWithoutBoardFilterColumnsInput = {
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutChannelStatusNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutChannelStatusesNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserUpdateOneWithoutChannelStatusesNestedInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpdateWithoutChannelSelectionsInput = {
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUpdateManyWithoutChannelStatusNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutChannelStatusNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutChannelStatusesNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserUpdateOneWithoutChannelStatusesNestedInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpdateWithoutChannelStatusChannelAssigneesInput = {
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channels?: Maybe<ChannelUpdateManyWithoutChannelStatusNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutChannelStatusesNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserUpdateOneWithoutChannelStatusesNestedInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpdateWithoutChannelsInput = {
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutChannelStatusNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutChannelStatusesNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserUpdateOneWithoutChannelStatusesNestedInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpdateWithoutClinicSettingInput = {
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutChannelStatusNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserUpdateOneWithoutChannelStatusesNestedInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpdateWithoutClinicWidgetRequestTypeInput = {
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutChannelStatusNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutChannelStatusesNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserUpdateOneWithoutChannelStatusesNestedInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpdateWithoutDeletedByInput = {
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutChannelStatusNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutChannelStatusesNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpdateWithoutResponseWorkflowEventActionsInput = {
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutChannelStatusNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutChannelStatusesNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserUpdateOneWithoutChannelStatusesNestedInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpdateWithoutWorkflowEventActionInput = {
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutChannelStatusNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutChannelStatusesNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserUpdateOneWithoutChannelStatusesNestedInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutInitialChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpdateWithoutWorkflowEventSettingsInput = {
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutChannelStatusChangeNestedInput>;
  boardFilterColumns?: Maybe<BoardFilterColumnUpdateManyWithoutChannelStatusNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutStatusesNestedInput>;
  channelStatusAction?: Maybe<ChannelStatusAction>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutChannelStatusNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutChannelStatusNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutChannelStatusesNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutChannelStatusNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserUpdateOneWithoutChannelStatusesNestedInput>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutResponseChannelStatusChangeNestedInput>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventAction?: Maybe<WorkflowEventActionUpdateManyWithoutChannelStatusChangeNestedInput>;
};

export type ChannelStatusUpsertWithWhereUniqueWithoutChannelSelectionsInput = {
  create: ChannelStatusCreateWithoutChannelSelectionsInput;
  update: ChannelStatusUpdateWithoutChannelSelectionsInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusUpsertWithWhereUniqueWithoutClinicSettingInput = {
  create: ChannelStatusCreateWithoutClinicSettingInput;
  update: ChannelStatusUpdateWithoutClinicSettingInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusUpsertWithWhereUniqueWithoutDeletedByInput = {
  create: ChannelStatusCreateWithoutDeletedByInput;
  update: ChannelStatusUpdateWithoutDeletedByInput;
  where: ChannelStatusWhereUniqueInput;
};

export type ChannelStatusUpsertWithoutAutomationRunActionsInput = {
  create: ChannelStatusCreateWithoutAutomationRunActionsInput;
  update: ChannelStatusUpdateWithoutAutomationRunActionsInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpsertWithoutBoardFilterColumnsInput = {
  create: ChannelStatusCreateWithoutBoardFilterColumnsInput;
  update: ChannelStatusUpdateWithoutBoardFilterColumnsInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpsertWithoutChannelStatusChannelAssigneesInput = {
  create: ChannelStatusCreateWithoutChannelStatusChannelAssigneesInput;
  update: ChannelStatusUpdateWithoutChannelStatusChannelAssigneesInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpsertWithoutChannelsInput = {
  create: ChannelStatusCreateWithoutChannelsInput;
  update: ChannelStatusUpdateWithoutChannelsInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpsertWithoutClinicWidgetRequestTypeInput = {
  create: ChannelStatusCreateWithoutClinicWidgetRequestTypeInput;
  update: ChannelStatusUpdateWithoutClinicWidgetRequestTypeInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpsertWithoutResponseWorkflowEventActionsInput = {
  create: ChannelStatusCreateWithoutResponseWorkflowEventActionsInput;
  update: ChannelStatusUpdateWithoutResponseWorkflowEventActionsInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpsertWithoutWorkflowEventActionInput = {
  create: ChannelStatusCreateWithoutWorkflowEventActionInput;
  update: ChannelStatusUpdateWithoutWorkflowEventActionInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusUpsertWithoutWorkflowEventSettingsInput = {
  create: ChannelStatusCreateWithoutWorkflowEventSettingsInput;
  update: ChannelStatusUpdateWithoutWorkflowEventSettingsInput;
  where?: Maybe<ChannelStatusWhereInput>;
};

export type ChannelStatusWhereInput = {
  AND?: Maybe<Array<ChannelStatusWhereInput>>;
  NOT?: Maybe<Array<ChannelStatusWhereInput>>;
  OR?: Maybe<Array<ChannelStatusWhereInput>>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  boardFilterColumns?: Maybe<BoardFilterColumnListRelationFilter>;
  channelSelections?: Maybe<ChannelSelectionListRelationFilter>;
  channelStatusAction?: Maybe<EnumChannelStatusActionFilter>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  clinicSetting?: Maybe<ClinicSettingNullableScalarRelationFilter>;
  clinicSettingId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  color?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedBy?: Maybe<UserNullableScalarRelationFilter>;
  deletedById?: Maybe<StringNullableFilter>;
  deletedOn?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  isDefault?: Maybe<BoolNullableFilter>;
  isExportedToPims?: Maybe<BoolNullableFilter>;
  name?: Maybe<StringFilter>;
  order?: Maybe<IntNullableFilter>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionListRelationFilter>;
  shouldNotifyChronos?: Maybe<BoolNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventAction?: Maybe<WorkflowEventActionListRelationFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type ChannelStatusWhereUniqueInput = {
  AND?: Maybe<Array<ChannelStatusWhereInput>>;
  NOT?: Maybe<Array<ChannelStatusWhereInput>>;
  OR?: Maybe<Array<ChannelStatusWhereInput>>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  boardFilterColumns?: Maybe<BoardFilterColumnListRelationFilter>;
  channelSelections?: Maybe<ChannelSelectionListRelationFilter>;
  channelStatusAction?: Maybe<EnumChannelStatusActionFilter>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  clinicSetting?: Maybe<ClinicSettingNullableScalarRelationFilter>;
  clinicSettingId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  color?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedBy?: Maybe<UserNullableScalarRelationFilter>;
  deletedById?: Maybe<StringNullableFilter>;
  deletedOn?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<BoolNullableFilter>;
  isExportedToPims?: Maybe<BoolNullableFilter>;
  name?: Maybe<StringFilter>;
  order?: Maybe<IntNullableFilter>;
  responseWorkflowEventActions?: Maybe<WorkflowEventActionListRelationFilter>;
  shouldNotifyChronos?: Maybe<BoolNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventAction?: Maybe<WorkflowEventActionListRelationFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type ChannelStatusWithOrder = {
  id: Scalars['String'];
  order: Scalars['Int'];
};

export type ChannelStatusWithOrderResponse = {
  __typename?: 'ChannelStatusWithOrderResponse';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ChannelSubscription = {
  __typename?: 'ChannelSubscription';
  mutation: MutationType;
  node: Channel;
};

export type ChannelSuggestedMessageResponse = {
  __typename?: 'ChannelSuggestedMessageResponse';
  parsedJson?: Maybe<Scalars['Json']>;
  response: Scalars['String'];
};

export type ChannelSuggestedMessageWhereInput = {
  channelId: Scalars['String'];
};

export type ChannelSummaryResponse = {
  __typename?: 'ChannelSummaryResponse';
  parsedJson?: Maybe<Scalars['Json']>;
  response: Scalars['String'];
};

export type ChannelSummaryWhereInput = {
  channelId: Scalars['String'];
};

export type ChannelSyncedToSearchWhereInput = {
  channelType?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export enum ChannelType {
  Client = 'Client',
  Team = 'Team'
}

export type ChannelUncheckedCreateInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateNestedManyWithoutAssigneesInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<ChannelCreateWithoutAssigneesInput>>;
};

export type ChannelUncheckedCreateNestedManyWithoutChannelStatusInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<ChannelCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<ChannelCreateManyChannelStatusInputEnvelope>;
};

export type ChannelUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ChannelCreateWithoutClinicInput>>;
  createMany?: Maybe<ChannelCreateManyClinicInputEnvelope>;
};

export type ChannelUncheckedCreateNestedManyWithoutCurrentWorkflowActionInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutCurrentWorkflowActionInput>>;
  create?: Maybe<Array<ChannelCreateWithoutCurrentWorkflowActionInput>>;
  createMany?: Maybe<ChannelCreateManyCurrentWorkflowActionInputEnvelope>;
};

export type ChannelUncheckedCreateNestedManyWithoutLastMessageInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutLastMessageInput>>;
  create?: Maybe<Array<ChannelCreateWithoutLastMessageInput>>;
  createMany?: Maybe<ChannelCreateManyLastMessageInputEnvelope>;
};

export type ChannelUncheckedCreateNestedManyWithoutPetsInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutPetsInput>>;
  create?: Maybe<Array<ChannelCreateWithoutPetsInput>>;
};

export type ChannelUncheckedCreateWithoutAppointmentsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutAssigneesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutAutomationStatusesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutChannelMembersInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutChannelPinsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutChannelStatusInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutClinicInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutCreationSourceInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutCurrentWorkflowActionInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutFinancialTransactionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutHillsToHomeApiLogInput = {
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutLastMessageInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutMessagesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutChannelsInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedCreateWithoutPetsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutChannelInput>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutChannelsInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutChannelInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutChannelInput>;
  channelPins?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutChannelInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedCreateNestedOneWithoutChannelInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutChannelInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateManyInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateManyWithoutAssigneesInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateManyWithoutAssigneesNestedInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<ChannelCreateWithoutAssigneesInput>>;
  delete?: Maybe<Array<ChannelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelWhereUniqueInput>>;
  set?: Maybe<Array<ChannelWhereUniqueInput>>;
  update?: Maybe<Array<ChannelUpdateWithWhereUniqueWithoutAssigneesInput>>;
  updateMany?: Maybe<Array<ChannelUpdateManyWithWhereWithoutAssigneesInput>>;
  upsert?: Maybe<Array<ChannelUpsertWithWhereUniqueWithoutAssigneesInput>>;
};

export type ChannelUncheckedUpdateManyWithoutChannelStatusInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateManyWithoutChannelStatusNestedInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<ChannelCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<ChannelCreateManyChannelStatusInputEnvelope>;
  delete?: Maybe<Array<ChannelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelWhereUniqueInput>>;
  set?: Maybe<Array<ChannelWhereUniqueInput>>;
  update?: Maybe<Array<ChannelUpdateWithWhereUniqueWithoutChannelStatusInput>>;
  updateMany?: Maybe<Array<ChannelUpdateManyWithWhereWithoutChannelStatusInput>>;
  upsert?: Maybe<Array<ChannelUpsertWithWhereUniqueWithoutChannelStatusInput>>;
};

export type ChannelUncheckedUpdateManyWithoutClinicInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ChannelCreateWithoutClinicInput>>;
  createMany?: Maybe<ChannelCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ChannelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelWhereUniqueInput>>;
  set?: Maybe<Array<ChannelWhereUniqueInput>>;
  update?: Maybe<Array<ChannelUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ChannelUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ChannelUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ChannelUncheckedUpdateManyWithoutCurrentWorkflowActionInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateManyWithoutCurrentWorkflowActionNestedInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutCurrentWorkflowActionInput>>;
  create?: Maybe<Array<ChannelCreateWithoutCurrentWorkflowActionInput>>;
  createMany?: Maybe<ChannelCreateManyCurrentWorkflowActionInputEnvelope>;
  delete?: Maybe<Array<ChannelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelWhereUniqueInput>>;
  set?: Maybe<Array<ChannelWhereUniqueInput>>;
  update?: Maybe<Array<ChannelUpdateWithWhereUniqueWithoutCurrentWorkflowActionInput>>;
  updateMany?: Maybe<Array<ChannelUpdateManyWithWhereWithoutCurrentWorkflowActionInput>>;
  upsert?: Maybe<Array<ChannelUpsertWithWhereUniqueWithoutCurrentWorkflowActionInput>>;
};

export type ChannelUncheckedUpdateManyWithoutLastMessageInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateManyWithoutLastMessageNestedInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutLastMessageInput>>;
  create?: Maybe<Array<ChannelCreateWithoutLastMessageInput>>;
  createMany?: Maybe<ChannelCreateManyLastMessageInputEnvelope>;
  delete?: Maybe<Array<ChannelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelWhereUniqueInput>>;
  set?: Maybe<Array<ChannelWhereUniqueInput>>;
  update?: Maybe<Array<ChannelUpdateWithWhereUniqueWithoutLastMessageInput>>;
  updateMany?: Maybe<Array<ChannelUpdateManyWithWhereWithoutLastMessageInput>>;
  upsert?: Maybe<Array<ChannelUpsertWithWhereUniqueWithoutLastMessageInput>>;
};

export type ChannelUncheckedUpdateManyWithoutPetsInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateManyWithoutPetsNestedInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutPetsInput>>;
  create?: Maybe<Array<ChannelCreateWithoutPetsInput>>;
  delete?: Maybe<Array<ChannelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelWhereUniqueInput>>;
  set?: Maybe<Array<ChannelWhereUniqueInput>>;
  update?: Maybe<Array<ChannelUpdateWithWhereUniqueWithoutPetsInput>>;
  updateMany?: Maybe<Array<ChannelUpdateManyWithWhereWithoutPetsInput>>;
  upsert?: Maybe<Array<ChannelUpsertWithWhereUniqueWithoutPetsInput>>;
};

export type ChannelUncheckedUpdateWithoutAppointmentsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutAssigneesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutAutomationStatusesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutChannelMembersInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutChannelPinsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutChannelStatusInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutClinicInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutCreationSourceInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutCurrentWorkflowActionInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutFinancialTransactionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutHillsToHomeApiLogInput = {
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutLastMessageInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutMessagesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUncheckedUpdateWithoutPetsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUncheckedUpdateManyWithoutChannelNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUncheckedUpdateOneWithoutChannelNestedInput>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessageId?: Maybe<Scalars['String']>;
  messages?: Maybe<ChannelMessageUncheckedUpdateManyWithoutChannelNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUnreadMessageCountResult = {
  __typename?: 'ChannelUnreadMessageCountResult';
  client?: Maybe<ChannelCountResult>;
  team?: Maybe<ChannelCountResult>;
  total: Scalars['Int'];
  unreadChannels: Array<UnreadMessageChannel>;
};

export type ChannelUpdateInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateManyMutationInput = {
  attributes?: Maybe<Scalars['Json']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  createdAt?: Maybe<Scalars['DateTime']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateManyWithWhereWithoutAssigneesInput = {
  data: ChannelUpdateManyMutationInput;
  where: ChannelScalarWhereInput;
};

export type ChannelUpdateManyWithWhereWithoutChannelStatusInput = {
  data: ChannelUpdateManyMutationInput;
  where: ChannelScalarWhereInput;
};

export type ChannelUpdateManyWithWhereWithoutClinicInput = {
  data: ChannelUpdateManyMutationInput;
  where: ChannelScalarWhereInput;
};

export type ChannelUpdateManyWithWhereWithoutCurrentWorkflowActionInput = {
  data: ChannelUpdateManyMutationInput;
  where: ChannelScalarWhereInput;
};

export type ChannelUpdateManyWithWhereWithoutLastMessageInput = {
  data: ChannelUpdateManyMutationInput;
  where: ChannelScalarWhereInput;
};

export type ChannelUpdateManyWithWhereWithoutPetsInput = {
  data: ChannelUpdateManyMutationInput;
  where: ChannelScalarWhereInput;
};

export type ChannelUpdateManyWithoutAssigneesNestedInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<ChannelCreateWithoutAssigneesInput>>;
  delete?: Maybe<Array<ChannelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelWhereUniqueInput>>;
  set?: Maybe<Array<ChannelWhereUniqueInput>>;
  update?: Maybe<Array<ChannelUpdateWithWhereUniqueWithoutAssigneesInput>>;
  updateMany?: Maybe<Array<ChannelUpdateManyWithWhereWithoutAssigneesInput>>;
  upsert?: Maybe<Array<ChannelUpsertWithWhereUniqueWithoutAssigneesInput>>;
};

export type ChannelUpdateManyWithoutChannelStatusNestedInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<ChannelCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<ChannelCreateManyChannelStatusInputEnvelope>;
  delete?: Maybe<Array<ChannelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelWhereUniqueInput>>;
  set?: Maybe<Array<ChannelWhereUniqueInput>>;
  update?: Maybe<Array<ChannelUpdateWithWhereUniqueWithoutChannelStatusInput>>;
  updateMany?: Maybe<Array<ChannelUpdateManyWithWhereWithoutChannelStatusInput>>;
  upsert?: Maybe<Array<ChannelUpsertWithWhereUniqueWithoutChannelStatusInput>>;
};

export type ChannelUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ChannelCreateWithoutClinicInput>>;
  createMany?: Maybe<ChannelCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ChannelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelWhereUniqueInput>>;
  set?: Maybe<Array<ChannelWhereUniqueInput>>;
  update?: Maybe<Array<ChannelUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ChannelUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ChannelUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ChannelUpdateManyWithoutCurrentWorkflowActionNestedInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutCurrentWorkflowActionInput>>;
  create?: Maybe<Array<ChannelCreateWithoutCurrentWorkflowActionInput>>;
  createMany?: Maybe<ChannelCreateManyCurrentWorkflowActionInputEnvelope>;
  delete?: Maybe<Array<ChannelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelWhereUniqueInput>>;
  set?: Maybe<Array<ChannelWhereUniqueInput>>;
  update?: Maybe<Array<ChannelUpdateWithWhereUniqueWithoutCurrentWorkflowActionInput>>;
  updateMany?: Maybe<Array<ChannelUpdateManyWithWhereWithoutCurrentWorkflowActionInput>>;
  upsert?: Maybe<Array<ChannelUpsertWithWhereUniqueWithoutCurrentWorkflowActionInput>>;
};

export type ChannelUpdateManyWithoutLastMessageNestedInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutLastMessageInput>>;
  create?: Maybe<Array<ChannelCreateWithoutLastMessageInput>>;
  createMany?: Maybe<ChannelCreateManyLastMessageInputEnvelope>;
  delete?: Maybe<Array<ChannelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelWhereUniqueInput>>;
  set?: Maybe<Array<ChannelWhereUniqueInput>>;
  update?: Maybe<Array<ChannelUpdateWithWhereUniqueWithoutLastMessageInput>>;
  updateMany?: Maybe<Array<ChannelUpdateManyWithWhereWithoutLastMessageInput>>;
  upsert?: Maybe<Array<ChannelUpsertWithWhereUniqueWithoutLastMessageInput>>;
};

export type ChannelUpdateManyWithoutPetsNestedInput = {
  connect?: Maybe<Array<ChannelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ChannelCreateOrConnectWithoutPetsInput>>;
  create?: Maybe<Array<ChannelCreateWithoutPetsInput>>;
  delete?: Maybe<Array<ChannelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ChannelScalarWhereInput>>;
  disconnect?: Maybe<Array<ChannelWhereUniqueInput>>;
  set?: Maybe<Array<ChannelWhereUniqueInput>>;
  update?: Maybe<Array<ChannelUpdateWithWhereUniqueWithoutPetsInput>>;
  updateMany?: Maybe<Array<ChannelUpdateManyWithWhereWithoutPetsInput>>;
  upsert?: Maybe<Array<ChannelUpsertWithWhereUniqueWithoutPetsInput>>;
};

export type ChannelUpdateOneRequiredWithoutAutomationStatusesNestedInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutAutomationStatusesInput>;
  create?: Maybe<ChannelCreateWithoutAutomationStatusesInput>;
  update?: Maybe<ChannelUpdateToOneWithWhereWithoutAutomationStatusesInput>;
  upsert?: Maybe<ChannelUpsertWithoutAutomationStatusesInput>;
};

export type ChannelUpdateOneRequiredWithoutCreationSourceNestedInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutCreationSourceInput>;
  create?: Maybe<ChannelCreateWithoutCreationSourceInput>;
  update?: Maybe<ChannelUpdateToOneWithWhereWithoutCreationSourceInput>;
  upsert?: Maybe<ChannelUpsertWithoutCreationSourceInput>;
};

export type ChannelUpdateOneWithoutAppointmentsNestedInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<ChannelCreateWithoutAppointmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelUpdateToOneWithWhereWithoutAppointmentsInput>;
  upsert?: Maybe<ChannelUpsertWithoutAppointmentsInput>;
};

export type ChannelUpdateOneWithoutChannelMembersNestedInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutChannelMembersInput>;
  create?: Maybe<ChannelCreateWithoutChannelMembersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelUpdateToOneWithWhereWithoutChannelMembersInput>;
  upsert?: Maybe<ChannelUpsertWithoutChannelMembersInput>;
};

export type ChannelUpdateOneWithoutChannelPinsNestedInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutChannelPinsInput>;
  create?: Maybe<ChannelCreateWithoutChannelPinsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelUpdateToOneWithWhereWithoutChannelPinsInput>;
  upsert?: Maybe<ChannelUpsertWithoutChannelPinsInput>;
};

export type ChannelUpdateOneWithoutFinancialTransactionsNestedInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutFinancialTransactionsInput>;
  create?: Maybe<ChannelCreateWithoutFinancialTransactionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelUpdateToOneWithWhereWithoutFinancialTransactionsInput>;
  upsert?: Maybe<ChannelUpsertWithoutFinancialTransactionsInput>;
};

export type ChannelUpdateOneWithoutHillsToHomeApiLogNestedInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutHillsToHomeApiLogInput>;
  create?: Maybe<ChannelCreateWithoutHillsToHomeApiLogInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelUpdateToOneWithWhereWithoutHillsToHomeApiLogInput>;
  upsert?: Maybe<ChannelUpsertWithoutHillsToHomeApiLogInput>;
};

export type ChannelUpdateOneWithoutMessagesNestedInput = {
  connect?: Maybe<ChannelWhereUniqueInput>;
  connectOrCreate?: Maybe<ChannelCreateOrConnectWithoutMessagesInput>;
  create?: Maybe<ChannelCreateWithoutMessagesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ChannelUpdateToOneWithWhereWithoutMessagesInput>;
  upsert?: Maybe<ChannelUpsertWithoutMessagesInput>;
};

export type ChannelUpdateToOneWithWhereWithoutAppointmentsInput = {
  data: ChannelUpdateWithoutAppointmentsInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpdateToOneWithWhereWithoutAutomationStatusesInput = {
  data: ChannelUpdateWithoutAutomationStatusesInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpdateToOneWithWhereWithoutChannelMembersInput = {
  data: ChannelUpdateWithoutChannelMembersInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpdateToOneWithWhereWithoutChannelPinsInput = {
  data: ChannelUpdateWithoutChannelPinsInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpdateToOneWithWhereWithoutCreationSourceInput = {
  data: ChannelUpdateWithoutCreationSourceInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpdateToOneWithWhereWithoutFinancialTransactionsInput = {
  data: ChannelUpdateWithoutFinancialTransactionsInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpdateToOneWithWhereWithoutHillsToHomeApiLogInput = {
  data: ChannelUpdateWithoutHillsToHomeApiLogInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpdateToOneWithWhereWithoutMessagesInput = {
  data: ChannelUpdateWithoutMessagesInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpdateWithWhereUniqueWithoutAssigneesInput = {
  data: ChannelUpdateWithoutAssigneesInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelUpdateWithWhereUniqueWithoutChannelStatusInput = {
  data: ChannelUpdateWithoutChannelStatusInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelUpdateWithWhereUniqueWithoutClinicInput = {
  data: ChannelUpdateWithoutClinicInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelUpdateWithWhereUniqueWithoutCurrentWorkflowActionInput = {
  data: ChannelUpdateWithoutCurrentWorkflowActionInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelUpdateWithWhereUniqueWithoutLastMessageInput = {
  data: ChannelUpdateWithoutLastMessageInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelUpdateWithWhereUniqueWithoutPetsInput = {
  data: ChannelUpdateWithoutPetsInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelUpdateWithoutAppointmentsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutAssigneesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutAutomationStatusesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutChannelMembersInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutChannelPinsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutChannelStatusInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutClinicInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutCreationSourceInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutCurrentWorkflowActionInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutFinancialTransactionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutHillsToHomeApiLogInput = {
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutLastMessageInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutMessagesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutChannelsNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpdateWithoutPetsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutChannelNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutChannelNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutChannelsNestedInput>;
  attributes?: Maybe<Scalars['Json']>;
  automationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutChannelNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutChannelNestedInput>;
  channelPins?: Maybe<ChannelPinUpdateManyWithoutChannelNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutChannelsNestedInput>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<ClinicUpdateOneWithoutChannelsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ChannelCreationSourceUpdateOneWithoutChannelNestedInput>;
  currentWorkflowAction?: Maybe<WorkflowEventActionUpdateOneWithoutChannelsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutChannelNestedInput>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessageUpdateOneWithoutLastMessageChannelNestedInput>;
  messages?: Maybe<ChannelMessageUpdateManyWithoutChannelNestedInput>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChannelUpsertWithWhereUniqueWithoutAssigneesInput = {
  create: ChannelCreateWithoutAssigneesInput;
  update: ChannelUpdateWithoutAssigneesInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelUpsertWithWhereUniqueWithoutChannelStatusInput = {
  create: ChannelCreateWithoutChannelStatusInput;
  update: ChannelUpdateWithoutChannelStatusInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelUpsertWithWhereUniqueWithoutClinicInput = {
  create: ChannelCreateWithoutClinicInput;
  update: ChannelUpdateWithoutClinicInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelUpsertWithWhereUniqueWithoutCurrentWorkflowActionInput = {
  create: ChannelCreateWithoutCurrentWorkflowActionInput;
  update: ChannelUpdateWithoutCurrentWorkflowActionInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelUpsertWithWhereUniqueWithoutLastMessageInput = {
  create: ChannelCreateWithoutLastMessageInput;
  update: ChannelUpdateWithoutLastMessageInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelUpsertWithWhereUniqueWithoutPetsInput = {
  create: ChannelCreateWithoutPetsInput;
  update: ChannelUpdateWithoutPetsInput;
  where: ChannelWhereUniqueInput;
};

export type ChannelUpsertWithoutAppointmentsInput = {
  create: ChannelCreateWithoutAppointmentsInput;
  update: ChannelUpdateWithoutAppointmentsInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpsertWithoutAutomationStatusesInput = {
  create: ChannelCreateWithoutAutomationStatusesInput;
  update: ChannelUpdateWithoutAutomationStatusesInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpsertWithoutChannelMembersInput = {
  create: ChannelCreateWithoutChannelMembersInput;
  update: ChannelUpdateWithoutChannelMembersInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpsertWithoutChannelPinsInput = {
  create: ChannelCreateWithoutChannelPinsInput;
  update: ChannelUpdateWithoutChannelPinsInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpsertWithoutCreationSourceInput = {
  create: ChannelCreateWithoutCreationSourceInput;
  update: ChannelUpdateWithoutCreationSourceInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpsertWithoutFinancialTransactionsInput = {
  create: ChannelCreateWithoutFinancialTransactionsInput;
  update: ChannelUpdateWithoutFinancialTransactionsInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpsertWithoutHillsToHomeApiLogInput = {
  create: ChannelCreateWithoutHillsToHomeApiLogInput;
  update: ChannelUpdateWithoutHillsToHomeApiLogInput;
  where?: Maybe<ChannelWhereInput>;
};

export type ChannelUpsertWithoutMessagesInput = {
  create: ChannelCreateWithoutMessagesInput;
  update: ChannelUpdateWithoutMessagesInput;
  where?: Maybe<ChannelWhereInput>;
};

export enum ChannelVisibility {
  DirectMessage = 'DirectMessage',
  Private = 'Private',
  Public = 'Public'
}

export type ChannelWhereInput = {
  AND?: Maybe<Array<ChannelWhereInput>>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<ChannelWhereInput>>;
  OR?: Maybe<Array<ChannelWhereInput>>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  assignees?: Maybe<UserListRelationFilter>;
  attributes?: Maybe<JsonNullableFilter>;
  automationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelMembers?: Maybe<ChannelMemberListRelationFilter>;
  channelPins?: Maybe<ChannelPinListRelationFilter>;
  channelStatus?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusId?: Maybe<StringNullableFilter>;
  channelType?: Maybe<EnumChannelTypeNullableFilter>;
  channelVisibility?: Maybe<EnumChannelVisibilityNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<ChannelCreationSourceNullableScalarRelationFilter>;
  currentWorkflowAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  currentWorkflowActionId?: Maybe<StringNullableFilter>;
  financialTransactions?: Maybe<FinancialTransactionListRelationFilter>;
  friendlyName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  lastExportAt?: Maybe<DateTimeNullableFilter>;
  lastMessage?: Maybe<ChannelMessageNullableScalarRelationFilter>;
  lastMessageId?: Maybe<StringNullableFilter>;
  messages?: Maybe<ChannelMessageListRelationFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  tags?: Maybe<JsonNullableFilter>;
  twilioChannelSid?: Maybe<StringNullableFilter>;
  uniqueName?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChannelWhereUniqueInput = {
  AND?: Maybe<Array<ChannelWhereInput>>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<ChannelWhereInput>>;
  OR?: Maybe<Array<ChannelWhereInput>>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  assignees?: Maybe<UserListRelationFilter>;
  attributes?: Maybe<JsonNullableFilter>;
  automationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelMembers?: Maybe<ChannelMemberListRelationFilter>;
  channelPins?: Maybe<ChannelPinListRelationFilter>;
  channelStatus?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusId?: Maybe<StringNullableFilter>;
  channelType?: Maybe<EnumChannelTypeNullableFilter>;
  channelVisibility?: Maybe<EnumChannelVisibilityNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<ChannelCreationSourceNullableScalarRelationFilter>;
  currentWorkflowAction?: Maybe<WorkflowEventActionNullableScalarRelationFilter>;
  currentWorkflowActionId?: Maybe<StringNullableFilter>;
  financialTransactions?: Maybe<FinancialTransactionListRelationFilter>;
  friendlyName?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolNullableFilter>;
  lastExportAt?: Maybe<DateTimeNullableFilter>;
  lastMessage?: Maybe<ChannelMessageNullableScalarRelationFilter>;
  lastMessageId?: Maybe<StringNullableFilter>;
  messages?: Maybe<ChannelMessageListRelationFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  tags?: Maybe<JsonNullableFilter>;
  twilioChannelSid?: Maybe<StringNullableFilter>;
  uniqueName?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum ChargeCaptureType {
  Automatic = 'Automatic',
  Manual = 'Manual'
}

export type CheckClinicCareInput = {
  clinicId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type CheckClinicCareStatusResult = {
  __typename?: 'CheckClinicCareStatusResult';
  idClinic?: Maybe<CareClinicInfo>;
  tokenClinic?: Maybe<CareClinicInfo>;
};

export type CheckPhoneVerificationInput = {
  id: Scalars['String'];
};

export type ChemicalCompound = {
  __typename?: 'ChemicalCompound';
  _count: ChemicalCompoundCountOutputType;
  activeIngredients: Array<ActiveIngredient>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  iupacName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type ChemicalCompoundActiveIngredientsArgs = {
  cursor?: Maybe<ActiveIngredientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ActiveIngredientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ActiveIngredientOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ActiveIngredientWhereInput>;
};

export type ChemicalCompoundCountAggregateOutputType = {
  __typename?: 'ChemicalCompoundCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  formula: Scalars['Int'];
  id: Scalars['Int'];
  iupacName: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ChemicalCompoundCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  formula?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  iupacName?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChemicalCompoundCountOutputType = {
  __typename?: 'ChemicalCompoundCountOutputType';
  activeIngredients: Scalars['Int'];
};

export type ChemicalCompoundCreateInput = {
  activeIngredients?: Maybe<ActiveIngredientCreateNestedManyWithoutChemicalCompoundInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundCreateNestedOneWithoutActiveIngredientsInput = {
  connect?: Maybe<ChemicalCompoundWhereUniqueInput>;
  connectOrCreate?: Maybe<ChemicalCompoundCreateOrConnectWithoutActiveIngredientsInput>;
  create?: Maybe<ChemicalCompoundCreateWithoutActiveIngredientsInput>;
};

export type ChemicalCompoundCreateOrConnectWithoutActiveIngredientsInput = {
  create: ChemicalCompoundCreateWithoutActiveIngredientsInput;
  where: ChemicalCompoundWhereUniqueInput;
};

export type ChemicalCompoundCreateWithoutActiveIngredientsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundGroupByOutputType = {
  __typename?: 'ChemicalCompoundGroupByOutputType';
  _count?: Maybe<ChemicalCompoundCountAggregateOutputType>;
  _max?: Maybe<ChemicalCompoundMaxAggregateOutputType>;
  _min?: Maybe<ChemicalCompoundMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  iupacName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ChemicalCompoundMaxAggregateOutputType = {
  __typename?: 'ChemicalCompoundMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  formula?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  iupacName?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChemicalCompoundMinAggregateOutputType = {
  __typename?: 'ChemicalCompoundMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  formula?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  iupacName?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChemicalCompoundOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChemicalCompoundOrderByRelevanceInput>;
  activeIngredients?: Maybe<ActiveIngredientOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  formula?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  iupacName?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ChemicalCompoundOrderByRelevanceFieldEnum {
  Description = 'description',
  Formula = 'formula',
  Id = 'id',
  IupacName = 'iupacName',
  Name = 'name'
}

export type ChemicalCompoundOrderByRelevanceInput = {
  fields: Array<ChemicalCompoundOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ChemicalCompoundOrderByWithAggregationInput = {
  _count?: Maybe<ChemicalCompoundCountOrderByAggregateInput>;
  _max?: Maybe<ChemicalCompoundMaxOrderByAggregateInput>;
  _min?: Maybe<ChemicalCompoundMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  formula?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  iupacName?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChemicalCompoundOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ChemicalCompoundOrderByRelevanceInput>;
  activeIngredients?: Maybe<ActiveIngredientOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  formula?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  iupacName?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ChemicalCompoundOrderByWithRelationInput = {
  _relevance?: Maybe<ChemicalCompoundOrderByRelevanceInput>;
  activeIngredients?: Maybe<ActiveIngredientOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  formula?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  iupacName?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ChemicalCompoundScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Formula = 'formula',
  Id = 'id',
  IupacName = 'iupacName',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type ChemicalCompoundScalarRelationFilter = {
  AND?: Maybe<Array<ChemicalCompoundWhereInput>>;
  NOT?: Maybe<Array<ChemicalCompoundWhereInput>>;
  OR?: Maybe<Array<ChemicalCompoundWhereInput>>;
  activeIngredients?: Maybe<ActiveIngredientListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  formula?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  iupacName?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChemicalCompoundScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ChemicalCompoundScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ChemicalCompoundScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ChemicalCompoundScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  formula?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  iupacName?: Maybe<StringNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ChemicalCompoundUncheckedCreateInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedCreateNestedManyWithoutChemicalCompoundInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundUncheckedCreateWithoutActiveIngredientsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundUncheckedUpdateInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedUpdateManyWithoutChemicalCompoundNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundUncheckedUpdateWithoutActiveIngredientsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundUpdateInput = {
  activeIngredients?: Maybe<ActiveIngredientUpdateManyWithoutChemicalCompoundNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundUpdateOneRequiredWithoutActiveIngredientsNestedInput = {
  connect?: Maybe<ChemicalCompoundWhereUniqueInput>;
  connectOrCreate?: Maybe<ChemicalCompoundCreateOrConnectWithoutActiveIngredientsInput>;
  create?: Maybe<ChemicalCompoundCreateWithoutActiveIngredientsInput>;
  update?: Maybe<ChemicalCompoundUpdateToOneWithWhereWithoutActiveIngredientsInput>;
  upsert?: Maybe<ChemicalCompoundUpsertWithoutActiveIngredientsInput>;
};

export type ChemicalCompoundUpdateToOneWithWhereWithoutActiveIngredientsInput = {
  data: ChemicalCompoundUpdateWithoutActiveIngredientsInput;
  where?: Maybe<ChemicalCompoundWhereInput>;
};

export type ChemicalCompoundUpdateWithoutActiveIngredientsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChemicalCompoundUpsertWithoutActiveIngredientsInput = {
  create: ChemicalCompoundCreateWithoutActiveIngredientsInput;
  update: ChemicalCompoundUpdateWithoutActiveIngredientsInput;
  where?: Maybe<ChemicalCompoundWhereInput>;
};

export type ChemicalCompoundWhereInput = {
  AND?: Maybe<Array<ChemicalCompoundWhereInput>>;
  NOT?: Maybe<Array<ChemicalCompoundWhereInput>>;
  OR?: Maybe<Array<ChemicalCompoundWhereInput>>;
  activeIngredients?: Maybe<ActiveIngredientListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  formula?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  iupacName?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChemicalCompoundWhereUniqueInput = {
  AND?: Maybe<Array<ChemicalCompoundWhereInput>>;
  NOT?: Maybe<Array<ChemicalCompoundWhereInput>>;
  OR?: Maybe<Array<ChemicalCompoundWhereInput>>;
  activeIngredients?: Maybe<ActiveIngredientListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  formula?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  iupacName?: Maybe<StringNullableFilter>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ChurnZeroResponse = {
  __typename?: 'ChurnZeroResponse';
  authToken: Scalars['String'];
};

export type ClaimClinicPetParentAuthCodeRequest = {
  otc: Scalars['String'];
  requestId: Scalars['String'];
};

export type ClaimClinicPetParentAuthCodeResponse = {
  __typename?: 'ClaimClinicPetParentAuthCodeResponse';
  message: Scalars['String'];
  payload?: Maybe<Scalars['Json']>;
  success: Scalars['Boolean'];
};

export type ClearTerminalDisplayResponse = {
  __typename?: 'ClearTerminalDisplayResponse';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  terminal: StripeTerminal;
};

export type ClearUnreadMessagesInput = {
  clinicId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export enum ClientConnectClinicSoftware {
  Avimark = 'AVIMARK',
  Clientrax = 'CLIENTRAX',
  Cornerstone = 'CORNERSTONE',
  CornerstoneCloud = 'CORNERSTONE_CLOUD',
  CovetrusPulse = 'COVETRUS_PULSE',
  Daysmart = 'DAYSMART',
  Dvmax = 'DVMAX',
  DvmManager = 'DVM_MANAGER',
  Ezyvet = 'EZYVET',
  Hippo = 'HIPPO',
  ImpromedAdvantage = 'IMPROMED_ADVANTAGE',
  ImpromedInfinity = 'IMPROMED_INFINITY',
  Infinity = 'INFINITY',
  Intravet = 'INTRAVET',
  Intravetsql = 'INTRAVETSQL',
  Neo = 'NEO',
  Pulse = 'PULSE',
  Rhapsody = 'RHAPSODY',
  ShepherdVeterinarySoftware = 'SHEPHERD_VETERINARY_SOFTWARE',
  Unknown = 'UNKNOWN',
  Unsupported = 'UNSUPPORTED',
  VetechAdvantage = 'VETECH_ADVANTAGE',
  Vetspire = 'VETSPIRE',
  Via = 'VIA',
  VtechPlatinum = 'VTECH_PLATINUM'
}

export type ClientConnectIntegration = {
  __typename?: 'ClientConnectIntegration';
  clientConnectSystem: ClientConnectSystem;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  clinicSoftware: ClientConnectClinicSoftware;
  createdAt: Scalars['DateTime'];
  erpId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isMultiSite: Scalars['Boolean'];
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type ClientConnectIntegrationClinicPimsIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClientConnectIntegrationCountAggregateOutputType = {
  __typename?: 'ClientConnectIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  clientConnectSystem: Scalars['Int'];
  clinicSoftware: Scalars['Int'];
  createdAt: Scalars['Int'];
  erpId: Scalars['Int'];
  id: Scalars['Int'];
  isMultiSite: Scalars['Int'];
  locationNumber: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClientConnectIntegrationCountOrderByAggregateInput = {
  clientConnectSystem?: Maybe<SortOrder>;
  clinicSoftware?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  erpId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClientConnectIntegrationCreateInput = {
  clientConnectSystem: ClientConnectSystem;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutClientConnectInput>;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationCreateManyInput = {
  clientConnectSystem: ClientConnectSystem;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<ClientConnectIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClientConnectIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<ClientConnectIntegrationCreateWithoutClinicPimsIntegrationInput>;
};

export type ClientConnectIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput = {
  create: ClientConnectIntegrationCreateWithoutClinicPimsIntegrationInput;
  where: ClientConnectIntegrationWhereUniqueInput;
};

export type ClientConnectIntegrationCreateWithoutClinicPimsIntegrationInput = {
  clientConnectSystem: ClientConnectSystem;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationGroupByOutputType = {
  __typename?: 'ClientConnectIntegrationGroupByOutputType';
  _count?: Maybe<ClientConnectIntegrationCountAggregateOutputType>;
  _max?: Maybe<ClientConnectIntegrationMaxAggregateOutputType>;
  _min?: Maybe<ClientConnectIntegrationMinAggregateOutputType>;
  clientConnectSystem: ClientConnectSystem;
  clinicSoftware: ClientConnectClinicSoftware;
  createdAt: Scalars['DateTime'];
  erpId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isMultiSite: Scalars['Boolean'];
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ClientConnectIntegrationMaxAggregateOutputType = {
  __typename?: 'ClientConnectIntegrationMaxAggregateOutputType';
  clientConnectSystem?: Maybe<ClientConnectSystem>;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationMaxOrderByAggregateInput = {
  clientConnectSystem?: Maybe<SortOrder>;
  clinicSoftware?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  erpId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClientConnectIntegrationMinAggregateOutputType = {
  __typename?: 'ClientConnectIntegrationMinAggregateOutputType';
  clientConnectSystem?: Maybe<ClientConnectSystem>;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationMinOrderByAggregateInput = {
  clientConnectSystem?: Maybe<SortOrder>;
  clinicSoftware?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  erpId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClientConnectIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClientConnectIntegrationWhereInput>>;
  NOT?: Maybe<Array<ClientConnectIntegrationWhereInput>>;
  OR?: Maybe<Array<ClientConnectIntegrationWhereInput>>;
  clientConnectSystem?: Maybe<EnumClientConnectSystemFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  clinicSoftware?: Maybe<EnumClientConnectClinicSoftwareFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  erpId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isMultiSite?: Maybe<BoolFilter>;
  locationNumber?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClientConnectIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClientConnectIntegrationOrderByRelevanceInput>;
  clientConnectSystem?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  clinicSoftware?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  erpId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClientConnectIntegrationOrderByRelevanceFieldEnum {
  ErpId = 'erpId',
  Id = 'id',
  LocationNumber = 'locationNumber'
}

export type ClientConnectIntegrationOrderByRelevanceInput = {
  fields: Array<ClientConnectIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClientConnectIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<ClientConnectIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<ClientConnectIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<ClientConnectIntegrationMinOrderByAggregateInput>;
  clientConnectSystem?: Maybe<SortOrder>;
  clinicSoftware?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  erpId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClientConnectIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClientConnectIntegrationOrderByRelevanceInput>;
  clientConnectSystem?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  clinicSoftware?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  erpId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClientConnectIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<ClientConnectIntegrationOrderByRelevanceInput>;
  clientConnectSystem?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  clinicSoftware?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  erpId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  locationNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClientConnectIntegrationScalarFieldEnum {
  ClientConnectSystem = 'clientConnectSystem',
  ClinicSoftware = 'clinicSoftware',
  CreatedAt = 'createdAt',
  ErpId = 'erpId',
  Id = 'id',
  IsMultiSite = 'isMultiSite',
  LocationNumber = 'locationNumber',
  UpdatedAt = 'updatedAt'
}

export type ClientConnectIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClientConnectIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClientConnectIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClientConnectIntegrationScalarWhereWithAggregatesInput>>;
  clientConnectSystem?: Maybe<EnumClientConnectSystemWithAggregatesFilter>;
  clinicSoftware?: Maybe<EnumClientConnectClinicSoftwareWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  erpId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isMultiSite?: Maybe<BoolWithAggregatesFilter>;
  locationNumber?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClientConnectIntegrationUncheckedCreateInput = {
  clientConnectSystem: ClientConnectSystem;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedOneWithoutClientConnectInput>;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationUncheckedCreateWithoutClinicPimsIntegrationInput = {
  clientConnectSystem: ClientConnectSystem;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationUncheckedUpdateInput = {
  clientConnectSystem?: Maybe<ClientConnectSystem>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedUpdateOneWithoutClientConnectNestedInput>;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationUncheckedUpdateManyInput = {
  clientConnectSystem?: Maybe<ClientConnectSystem>;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationUncheckedUpdateWithoutClinicPimsIntegrationInput = {
  clientConnectSystem?: Maybe<ClientConnectSystem>;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationUpdateInput = {
  clientConnectSystem?: Maybe<ClientConnectSystem>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutClientConnectNestedInput>;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationUpdateManyMutationInput = {
  clientConnectSystem?: Maybe<ClientConnectSystem>;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<ClientConnectIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClientConnectIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<ClientConnectIntegrationCreateWithoutClinicPimsIntegrationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClientConnectIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput>;
  upsert?: Maybe<ClientConnectIntegrationUpsertWithoutClinicPimsIntegrationInput>;
};

export type ClientConnectIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput = {
  data: ClientConnectIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<ClientConnectIntegrationWhereInput>;
};

export type ClientConnectIntegrationUpdateWithoutClinicPimsIntegrationInput = {
  clientConnectSystem?: Maybe<ClientConnectSystem>;
  clinicSoftware?: Maybe<ClientConnectClinicSoftware>;
  createdAt?: Maybe<Scalars['DateTime']>;
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientConnectIntegrationUpsertWithoutClinicPimsIntegrationInput = {
  create: ClientConnectIntegrationCreateWithoutClinicPimsIntegrationInput;
  update: ClientConnectIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<ClientConnectIntegrationWhereInput>;
};

export type ClientConnectIntegrationWhereInput = {
  AND?: Maybe<Array<ClientConnectIntegrationWhereInput>>;
  NOT?: Maybe<Array<ClientConnectIntegrationWhereInput>>;
  OR?: Maybe<Array<ClientConnectIntegrationWhereInput>>;
  clientConnectSystem?: Maybe<EnumClientConnectSystemFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  clinicSoftware?: Maybe<EnumClientConnectClinicSoftwareFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  erpId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isMultiSite?: Maybe<BoolFilter>;
  locationNumber?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClientConnectIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<ClientConnectIntegrationWhereInput>>;
  NOT?: Maybe<Array<ClientConnectIntegrationWhereInput>>;
  OR?: Maybe<Array<ClientConnectIntegrationWhereInput>>;
  clientConnectSystem?: Maybe<EnumClientConnectSystemFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  clinicSoftware?: Maybe<EnumClientConnectClinicSoftwareFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  erpId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<BoolFilter>;
  locationNumber?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum ClientConnectSystem {
  Allydvm = 'ALLYDVM',
  Idexx = 'IDEXX'
}

export type Clinic = {
  __typename?: 'Clinic';
  AppointmentNoteTemplate: Array<AppointmentNoteTemplate>;
  EmailCampaignLog: Array<EmailCampaignLog>;
  EmailCampaignUnsubscribe: Array<EmailCampaignUnsubscribe>;
  HillsToHomeAPILog: Array<HillsToHomeApiLog>;
  Rules: Array<Rules>;
  _count: ClinicCountOutputType;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes: Array<AppointmentType>;
  appointmentAvailabilities: Array<AppointmentAvailability>;
  appointments: Array<Appointment>;
  /** @deprecated - 1.0 */
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  /** @deprecated - 1.0 */
  automaticSubscriptionReceipts: Scalars['Boolean'];
  automationRuns: Array<AutomationRun>;
  axionClinicConfiguration?: Maybe<AxionClinicConfiguration>;
  axionClinicUserConfigurations: Array<AxionClinicUserConfiguration>;
  benefitsProvided: Array<CareBenefitUsage>;
  bitwerxHealthchecks: Array<BitwerxHealthcheck>;
  blockedPhoneNumbers: Array<ClinicBlockedPhoneNumber>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls: Array<CallHistory>;
  /** @deprecated - 1.0 */
  canceledAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated - 1.0 */
  cancellationNote?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<Organization>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections: Array<ChannelFilterSelection>;
  channelStatusChannelAssignees: Array<ChannelStatusChannelAssignee>;
  channels: Array<Channel>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetup>;
  clinicDirectBookingSettings: Array<ClinicDirectBookingSetting>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings: Array<ClinicEmailCampaignSetting>;
  clinicEmployees: Array<ClinicEmployee>;
  clinicModules: Array<ClinicModule>;
  clinicOfficeHours: Array<ClinicOfficeHour>;
  clinicOnboardings: Array<ClinicOnboarding>;
  clinicPetParents: Array<ClinicPetParent>;
  clinicPets: Array<ClinicPet>;
  clinicPhoneNumber: Array<ClinicPhoneNumber>;
  clinicRooms: Array<ClinicRoom>;
  clinicSetting?: Maybe<ClinicSetting>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters: Array<ClinicUserFilter>;
  clinicWidgetRequests: Array<ClinicWidgetRequest>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSetting>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes: Array<ClinicWorkflowType>;
  /** @deprecated - 1.0 */
  consultationCost?: Maybe<Scalars['Float']>;
  /** @deprecated - 1.0 */
  consultationRequests: Array<ConsultationRequest>;
  /** @deprecated - 1.0 */
  consultations: Array<Consultation>;
  /** @deprecated - 1.0 */
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  crmId?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  crmUrlParams?: Maybe<Scalars['Json']>;
  /** @deprecated - 1.0 */
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules: Array<DirectBookingExclusionRule>;
  emailCampaign: Array<EmailCampaign>;
  emailCampaignTemplate: Array<EmailCampaignTemplate>;
  encryptedClinicUploads: Array<EncryptedClinicUpload>;
  featureFlags: Array<FeatureFlag>;
  financialTransactions: Array<FinancialTransaction>;
  firebaseId?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  firebaseVets?: Maybe<Scalars['Json']>;
  /** @deprecated - 1.0 */
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions: Array<FormSubmission>;
  formTemplates: Array<FormTemplate>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlace>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  /** @deprecated - 1.0 */
  headUserId?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  hours?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** @deprecated - 1.0 */
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember: Array<InformAudienceMember>;
  informPartnerCustomers: Array<InformPartnerCustomer>;
  informPartnerProgramEnrollments: Array<InformPartnerProgramEnrollment>;
  insuranceIntegrations: Array<InsuranceIntegration>;
  /** @deprecated - 1.0 */
  integrationInfo?: Maybe<Scalars['Json']>;
  /** @deprecated - 1.0 */
  integrationSystem?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  integrationType?: Maybe<Scalars['String']>;
  integrations: Array<ClinicPimsIntegration>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive: Scalars['Boolean'];
  isClinicEligibleForPayments: Scalars['Boolean'];
  /** @deprecated - 1.0 */
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  /** @deprecated - 1.0 */
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  /** @deprecated - 1.0 */
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  /** @deprecated - 1.0 */
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  /** @deprecated - 1.0 */
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  /** @deprecated - 1.0 */
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntity>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas: Array<LoyaltyPointDelta>;
  loyaltyProgram?: Maybe<LoyaltyProgram>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions: Array<LoyaltyRewardRedemptionHistoryEntry>;
  /** @deprecated - 1.0 */
  marketEmail?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  /** @deprecated - 1.0 */
  marketFacebookPageId?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts: Array<MassTextAlert>;
  media: Array<Media>;
  messageTemplates: Array<MessageTemplate>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  paymentAddress?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  paymentCity?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  paymentName?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroup>;
  /** @deprecated - 1.0 */
  paymentState?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods: Array<PayoutBatchingPeriod>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSetting>;
  /** @deprecated - 1.0 */
  pets: Array<Pet>;
  /** @deprecated - 1.0 */
  petsId: Array<Pet>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings: Array<ClinicPostcardSetting>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions: Array<Prescription>;
  /** @deprecated - 1.0 */
  printLastOrder?: Maybe<Scalars['DateTime']>;
  /** @deprecated - 1.0 */
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions: Array<ProductPackageSubscription>;
  /** @deprecated - 1.0 */
  promoCodes: Array<PromoCode>;
  recaps: Array<Recap>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  responseTime?: Maybe<Scalars['Float']>;
  roles: Array<StaffRole>;
  sentTrupanionExamDayOffers: Array<SentTrupanionExamDayOffer>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff: Array<VetInfo>;
  staffId: Array<VetInfo>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents: Array<StripePaymentIntent>;
  stripePayoutAccounts: Array<StripePayoutAccount>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations: Array<StripeTerminalLocation>;
  /** @deprecated - 1.0 */
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated - 1.0 */
  submerchantId?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  /** @deprecated - 1.0 */
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  subscribedAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated - 1.0 */
  subscriptionId?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults: Array<SurveyResult>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfiguration>;
  tasks: Array<Task>;
  /** @deprecated - 1.0 */
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfiguration>;
  twilioVerifications: Array<TwilioVerification>;
  unlayerSetting?: Maybe<UnlayerSetting>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  /** @deprecated - 1.0 */
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  userAppointmentGroupings: Array<UserAppointmentGrouping>;
  userBoardFiltersColumns: Array<BoardFilterColumn>;
  userTaskLists: Array<UserTaskList>;
  users: Array<User>;
  usersId?: Maybe<User>;
  vaccinations: Array<Vaccination>;
  vetAvailabilities: Array<VetAvailability>;
  vetsourceInstallation?: Maybe<VetsourceInstallation>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings: Array<WorkflowEventSetting>;
};


export type ClinicAppointmentNoteTemplateArgs = {
  cursor?: Maybe<AppointmentNoteTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentNoteTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentNoteTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentNoteTemplateWhereInput>;
};


export type ClinicEmailCampaignLogArgs = {
  cursor?: Maybe<EmailCampaignLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignLogWhereInput>;
};


export type ClinicEmailCampaignUnsubscribeArgs = {
  cursor?: Maybe<EmailCampaignUnsubscribeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignUnsubscribeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignUnsubscribeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignUnsubscribeWhereInput>;
};


export type ClinicHillsToHomeApiLogArgs = {
  cursor?: Maybe<HillsToHomeApiLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<HillsToHomeApiLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<HillsToHomeApiLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<HillsToHomeApiLogWhereInput>;
};


export type ClinicRulesArgs = {
  cursor?: Maybe<RulesWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<RulesScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<RulesOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RulesWhereInput>;
};


export type ClinicAppoinmentTypesArgs = {
  cursor?: Maybe<AppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type ClinicAppointmentAvailabilitiesArgs = {
  cursor?: Maybe<AppointmentAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentAvailabilityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentAvailabilityWhereInput>;
};


export type ClinicAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type ClinicAutomationRunsArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type ClinicAxionClinicConfigurationArgs = {
  where?: Maybe<AxionClinicConfigurationWhereInput>;
};


export type ClinicAxionClinicUserConfigurationsArgs = {
  cursor?: Maybe<AxionClinicUserConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AxionClinicUserConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AxionClinicUserConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AxionClinicUserConfigurationWhereInput>;
};


export type ClinicBenefitsProvidedArgs = {
  cursor?: Maybe<CareBenefitUsageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageWhereInput>;
};


export type ClinicBitwerxHealthchecksArgs = {
  cursor?: Maybe<BitwerxHealthcheckWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxHealthcheckScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxHealthcheckOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxHealthcheckWhereInput>;
};


export type ClinicBlockedPhoneNumbersArgs = {
  cursor?: Maybe<ClinicBlockedPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
};


export type ClinicCallsArgs = {
  cursor?: Maybe<CallHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallHistoryWhereInput>;
};


export type ClinicCarePayoutOrganizationArgs = {
  where?: Maybe<OrganizationWhereInput>;
};


export type ClinicCarePlanProviderGroupArgs = {
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type ClinicChannelFilterSelectionsArgs = {
  cursor?: Maybe<ChannelFilterSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelFilterSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelFilterSelectionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelFilterSelectionWhereInput>;
};


export type ClinicChannelStatusChannelAssigneesArgs = {
  cursor?: Maybe<ChannelStatusChannelAssigneeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusChannelAssigneeWhereInput>;
};


export type ClinicChannelsArgs = {
  cursor?: Maybe<ChannelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelWhereInput>;
};


export type ClinicClinicCustomPayoutsSetupArgs = {
  where?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
};


export type ClinicClinicDirectBookingSettingsArgs = {
  cursor?: Maybe<ClinicDirectBookingSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicDirectBookingSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicDirectBookingSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicDirectBookingSettingWhereInput>;
};


export type ClinicClinicEmailCampaignSettingsArgs = {
  cursor?: Maybe<ClinicEmailCampaignSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmailCampaignSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmailCampaignSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmailCampaignSettingWhereInput>;
};


export type ClinicClinicEmployeesArgs = {
  cursor?: Maybe<ClinicEmployeeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type ClinicClinicModulesArgs = {
  cursor?: Maybe<ClinicModuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicModuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicModuleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicModuleWhereInput>;
};


export type ClinicClinicOfficeHoursArgs = {
  cursor?: Maybe<ClinicOfficeHourWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicOfficeHourScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOfficeHourOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicOfficeHourWhereInput>;
};


export type ClinicClinicOnboardingsArgs = {
  cursor?: Maybe<ClinicOnboardingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicOnboardingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOnboardingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicOnboardingWhereInput>;
};


export type ClinicClinicPetParentsArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type ClinicClinicPetsArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type ClinicClinicPhoneNumberArgs = {
  cursor?: Maybe<ClinicPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPhoneNumberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPhoneNumberWhereInput>;
};


export type ClinicClinicRoomsArgs = {
  cursor?: Maybe<ClinicRoomWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicRoomScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicRoomOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicRoomWhereInput>;
};


export type ClinicClinicSettingArgs = {
  where?: Maybe<ClinicSettingWhereInput>;
};


export type ClinicClinicUserFiltersArgs = {
  cursor?: Maybe<ClinicUserFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicUserFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicUserFilterOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicUserFilterWhereInput>;
};


export type ClinicClinicWidgetRequestsArgs = {
  cursor?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type ClinicClinicWidgetSettingArgs = {
  where?: Maybe<ClinicWidgetSettingWhereInput>;
};


export type ClinicClinicWorkflowTypesArgs = {
  cursor?: Maybe<ClinicWorkflowTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWorkflowTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWorkflowTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWorkflowTypeWhereInput>;
};


export type ClinicConsultationRequestsArgs = {
  cursor?: Maybe<ConsultationRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationRequestOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationRequestWhereInput>;
};


export type ClinicConsultationsArgs = {
  cursor?: Maybe<ConsultationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationWhereInput>;
};


export type ClinicDirectBookingExclusionRulesArgs = {
  cursor?: Maybe<DirectBookingExclusionRuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingExclusionRuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingExclusionRuleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingExclusionRuleWhereInput>;
};


export type ClinicEmailCampaignArgs = {
  cursor?: Maybe<EmailCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignWhereInput>;
};


export type ClinicEmailCampaignTemplateArgs = {
  cursor?: Maybe<EmailCampaignTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignTemplateWhereInput>;
};


export type ClinicEncryptedClinicUploadsArgs = {
  cursor?: Maybe<EncryptedClinicUploadWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EncryptedClinicUploadScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EncryptedClinicUploadOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};


export type ClinicFeatureFlagsArgs = {
  cursor?: Maybe<FeatureFlagWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FeatureFlagScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FeatureFlagOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FeatureFlagWhereInput>;
};


export type ClinicFinancialTransactionsArgs = {
  cursor?: Maybe<FinancialTransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FinancialTransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FinancialTransactionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type ClinicFormSubmissionsArgs = {
  cursor?: Maybe<FormSubmissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormSubmissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormSubmissionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormSubmissionWhereInput>;
};


export type ClinicFormTemplatesArgs = {
  cursor?: Maybe<FormTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormTemplateWhereInput>;
};


export type ClinicGooglePlaceArgs = {
  where?: Maybe<GooglePlaceWhereInput>;
};


export type ClinicInformAudienceMemberArgs = {
  cursor?: Maybe<InformAudienceMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberWhereInput>;
};


export type ClinicInformPartnerCustomersArgs = {
  cursor?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};


export type ClinicInformPartnerProgramEnrollmentsArgs = {
  cursor?: Maybe<InformPartnerProgramEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};


export type ClinicInsuranceIntegrationsArgs = {
  cursor?: Maybe<InsuranceIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InsuranceIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InsuranceIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InsuranceIntegrationWhereInput>;
};


export type ClinicIntegrationsArgs = {
  cursor?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPimsIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type ClinicLegalEntityArgs = {
  where?: Maybe<LegalEntityWhereInput>;
};


export type ClinicLoyaltyPointDeltasArgs = {
  cursor?: Maybe<LoyaltyPointDeltaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointDeltaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointDeltaOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
};


export type ClinicLoyaltyProgramArgs = {
  where?: Maybe<LoyaltyProgramWhereInput>;
};


export type ClinicLoyaltyRewardRedemptionActionsArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
};


export type ClinicMassTextAlertsArgs = {
  cursor?: Maybe<MassTextAlertWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertWhereInput>;
};


export type ClinicMediaArgs = {
  cursor?: Maybe<MediaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MediaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MediaOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MediaWhereInput>;
};


export type ClinicMessageTemplatesArgs = {
  cursor?: Maybe<MessageTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MessageTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MessageTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessageTemplateWhereInput>;
};


export type ClinicOrganizationArgs = {
  where?: Maybe<OrganizationWhereInput>;
};


export type ClinicPaymentProcessorForProviderGroupArgs = {
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type ClinicPayoutBatchingPeriodsArgs = {
  cursor?: Maybe<PayoutBatchingPeriodWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingPeriodScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingPeriodOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingPeriodWhereInput>;
};


export type ClinicPayoutBatchingSettingArgs = {
  where?: Maybe<PayoutBatchingSettingWhereInput>;
};


export type ClinicPetsArgs = {
  cursor?: Maybe<PetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PetWhereInput>;
};


export type ClinicPetsIdArgs = {
  cursor?: Maybe<PetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PetWhereInput>;
};


export type ClinicPostcardSettingsArgs = {
  cursor?: Maybe<ClinicPostcardSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPostcardSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPostcardSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPostcardSettingWhereInput>;
};


export type ClinicPrescriptionsArgs = {
  cursor?: Maybe<PrescriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PrescriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PrescriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PrescriptionWhereInput>;
};


export type ClinicProductPackageSubscriptionsArgs = {
  cursor?: Maybe<ProductPackageSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductPackageSubscriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductPackageSubscriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductPackageSubscriptionWhereInput>;
};


export type ClinicPromoCodesArgs = {
  cursor?: Maybe<PromoCodeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PromoCodeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PromoCodeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PromoCodeWhereInput>;
};


export type ClinicRecapsArgs = {
  cursor?: Maybe<RecapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<RecapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<RecapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RecapWhereInput>;
};


export type ClinicRolesArgs = {
  cursor?: Maybe<StaffRoleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StaffRoleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StaffRoleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StaffRoleWhereInput>;
};


export type ClinicSentTrupanionExamDayOffersArgs = {
  cursor?: Maybe<SentTrupanionExamDayOfferWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SentTrupanionExamDayOfferScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SentTrupanionExamDayOfferOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};


export type ClinicStaffArgs = {
  cursor?: Maybe<VetInfoWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetInfoScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetInfoOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetInfoWhereInput>;
};


export type ClinicStaffIdArgs = {
  cursor?: Maybe<VetInfoWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetInfoScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetInfoOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetInfoWhereInput>;
};


export type ClinicStripePaymentIntentsArgs = {
  cursor?: Maybe<StripePaymentIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type ClinicStripePayoutAccountsArgs = {
  cursor?: Maybe<StripePayoutAccountWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePayoutAccountScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePayoutAccountOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePayoutAccountWhereInput>;
};


export type ClinicStripeTerminalLocationsArgs = {
  cursor?: Maybe<StripeTerminalLocationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeTerminalLocationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeTerminalLocationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeTerminalLocationWhereInput>;
};


export type ClinicSurveyResultsArgs = {
  cursor?: Maybe<SurveyResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveyResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveyResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyResultWhereInput>;
};


export type ClinicSynchronyClinicConfigurationArgs = {
  where?: Maybe<SynchronyClinicConfigurationWhereInput>;
};


export type ClinicTasksArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaskScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaskOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaskWhereInput>;
};


export type ClinicTwilioConfigurationArgs = {
  where?: Maybe<TwilioConfigurationWhereInput>;
};


export type ClinicTwilioVerificationsArgs = {
  cursor?: Maybe<TwilioVerificationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TwilioVerificationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TwilioVerificationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TwilioVerificationWhereInput>;
};


export type ClinicUnlayerSettingArgs = {
  where?: Maybe<UnlayerSettingWhereInput>;
};


export type ClinicUserAppointmentGroupingsArgs = {
  cursor?: Maybe<UserAppointmentGroupingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserAppointmentGroupingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserAppointmentGroupingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAppointmentGroupingWhereInput>;
};


export type ClinicUserBoardFiltersColumnsArgs = {
  cursor?: Maybe<BoardFilterColumnWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoardFilterColumnScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoardFilterColumnOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoardFilterColumnWhereInput>;
};


export type ClinicUserTaskListsArgs = {
  cursor?: Maybe<UserTaskListWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserTaskListScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserTaskListOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserTaskListWhereInput>;
};


export type ClinicUsersArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type ClinicUsersIdArgs = {
  where?: Maybe<UserWhereInput>;
};


export type ClinicVaccinationsArgs = {
  cursor?: Maybe<VaccinationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VaccinationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VaccinationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VaccinationWhereInput>;
};


export type ClinicVetAvailabilitiesArgs = {
  cursor?: Maybe<VetAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityWhereInput>;
};


export type ClinicVetsourceInstallationArgs = {
  where?: Maybe<VetsourceInstallationWhereInput>;
};


export type ClinicWorkflowEventSettingsArgs = {
  cursor?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type ClinicAvgAggregateOutputType = {
  __typename?: 'ClinicAvgAggregateOutputType';
  consultationCost?: Maybe<Scalars['Float']>;
  followUpCost?: Maybe<Scalars['Float']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  long?: Maybe<Scalars['Float']>;
  marketFacebookNumber?: Maybe<Scalars['Float']>;
  ppcLocationId?: Maybe<Scalars['Float']>;
  printReceivedQuantity?: Maybe<Scalars['Float']>;
  responseTime?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['Float']>;
  unlayerSettingId?: Maybe<Scalars['Float']>;
};

export type ClinicAvgOrderByAggregateInput = {
  consultationCost?: Maybe<SortOrder>;
  followUpCost?: Maybe<SortOrder>;
  lastPrintOrderedQuantity?: Maybe<SortOrder>;
  lat?: Maybe<SortOrder>;
  long?: Maybe<SortOrder>;
  marketFacebookNumber?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  printReceivedQuantity?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  timezone?: Maybe<SortOrder>;
  unlayerSettingId?: Maybe<SortOrder>;
};

export type ClinicBlockedPhoneNumber = {
  __typename?: 'ClinicBlockedPhoneNumber';
  blockedBy?: Maybe<User>;
  blockedByUserId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  unblockedBy?: Maybe<User>;
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type ClinicBlockedPhoneNumberBlockedByArgs = {
  where?: Maybe<UserWhereInput>;
};


export type ClinicBlockedPhoneNumberUnblockedByArgs = {
  where?: Maybe<UserWhereInput>;
};

export type ClinicBlockedPhoneNumberClinicIdAndPhoneNumberCompoundUniqueInput = {
  clinicId: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type ClinicBlockedPhoneNumberCountAggregateOutputType = {
  __typename?: 'ClinicBlockedPhoneNumberCountAggregateOutputType';
  _all: Scalars['Int'];
  blockedByUserId: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  notes: Scalars['Int'];
  phoneNumber: Scalars['Int'];
  unblockedByUserId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicBlockedPhoneNumberCountOrderByAggregateInput = {
  blockedByUserId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  unblockedByUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicBlockedPhoneNumberCreateInput = {
  blockedBy?: Maybe<UserCreateNestedOneWithoutBlockedNumbersInput>;
  clinic: ClinicCreateNestedOneWithoutBlockedPhoneNumbersInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  unblockedBy?: Maybe<UserCreateNestedOneWithoutUnblockedNumbersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberCreateManyBlockedByInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberCreateManyBlockedByInputEnvelope = {
  data: Array<ClinicBlockedPhoneNumberCreateManyBlockedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicBlockedPhoneNumberCreateManyClinicInput = {
  blockedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberCreateManyClinicInputEnvelope = {
  data: Array<ClinicBlockedPhoneNumberCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicBlockedPhoneNumberCreateManyInput = {
  blockedByUserId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberCreateManyUnblockedByInput = {
  blockedByUserId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberCreateManyUnblockedByInputEnvelope = {
  data: Array<ClinicBlockedPhoneNumberCreateManyUnblockedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput = {
  connect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicBlockedPhoneNumberCreateOrConnectWithoutBlockedByInput>>;
  create?: Maybe<Array<ClinicBlockedPhoneNumberCreateWithoutBlockedByInput>>;
  createMany?: Maybe<ClinicBlockedPhoneNumberCreateManyBlockedByInputEnvelope>;
};

export type ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicBlockedPhoneNumberCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicBlockedPhoneNumberCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicBlockedPhoneNumberCreateManyClinicInputEnvelope>;
};

export type ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput = {
  connect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicBlockedPhoneNumberCreateOrConnectWithoutUnblockedByInput>>;
  create?: Maybe<Array<ClinicBlockedPhoneNumberCreateWithoutUnblockedByInput>>;
  createMany?: Maybe<ClinicBlockedPhoneNumberCreateManyUnblockedByInputEnvelope>;
};

export type ClinicBlockedPhoneNumberCreateOrConnectWithoutBlockedByInput = {
  create: ClinicBlockedPhoneNumberCreateWithoutBlockedByInput;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};

export type ClinicBlockedPhoneNumberCreateOrConnectWithoutClinicInput = {
  create: ClinicBlockedPhoneNumberCreateWithoutClinicInput;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};

export type ClinicBlockedPhoneNumberCreateOrConnectWithoutUnblockedByInput = {
  create: ClinicBlockedPhoneNumberCreateWithoutUnblockedByInput;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};

export type ClinicBlockedPhoneNumberCreateWithoutBlockedByInput = {
  clinic: ClinicCreateNestedOneWithoutBlockedPhoneNumbersInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  unblockedBy?: Maybe<UserCreateNestedOneWithoutUnblockedNumbersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberCreateWithoutClinicInput = {
  blockedBy?: Maybe<UserCreateNestedOneWithoutBlockedNumbersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  unblockedBy?: Maybe<UserCreateNestedOneWithoutUnblockedNumbersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberCreateWithoutUnblockedByInput = {
  blockedBy?: Maybe<UserCreateNestedOneWithoutBlockedNumbersInput>;
  clinic: ClinicCreateNestedOneWithoutBlockedPhoneNumbersInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberGroupByOutputType = {
  __typename?: 'ClinicBlockedPhoneNumberGroupByOutputType';
  _count?: Maybe<ClinicBlockedPhoneNumberCountAggregateOutputType>;
  _max?: Maybe<ClinicBlockedPhoneNumberMaxAggregateOutputType>;
  _min?: Maybe<ClinicBlockedPhoneNumberMinAggregateOutputType>;
  blockedByUserId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ClinicBlockedPhoneNumberListRelationFilter = {
  every?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
  none?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
  some?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
};

export type ClinicBlockedPhoneNumberMaxAggregateOutputType = {
  __typename?: 'ClinicBlockedPhoneNumberMaxAggregateOutputType';
  blockedByUserId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberMaxOrderByAggregateInput = {
  blockedByUserId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  unblockedByUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicBlockedPhoneNumberMinAggregateOutputType = {
  __typename?: 'ClinicBlockedPhoneNumberMinAggregateOutputType';
  blockedByUserId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberMinOrderByAggregateInput = {
  blockedByUserId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  unblockedByUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicBlockedPhoneNumberOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicBlockedPhoneNumberOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicBlockedPhoneNumberOrderByRelevanceInput>;
  blockedBy?: Maybe<UserOrderByWithRelationInput>;
  blockedByUserId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  unblockedBy?: Maybe<UserOrderByWithRelationInput>;
  unblockedByUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicBlockedPhoneNumberOrderByRelevanceFieldEnum {
  BlockedByUserId = 'blockedByUserId',
  ClinicId = 'clinicId',
  Id = 'id',
  Notes = 'notes',
  PhoneNumber = 'phoneNumber',
  UnblockedByUserId = 'unblockedByUserId'
}

export type ClinicBlockedPhoneNumberOrderByRelevanceInput = {
  fields: Array<ClinicBlockedPhoneNumberOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicBlockedPhoneNumberOrderByWithAggregationInput = {
  _count?: Maybe<ClinicBlockedPhoneNumberCountOrderByAggregateInput>;
  _max?: Maybe<ClinicBlockedPhoneNumberMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicBlockedPhoneNumberMinOrderByAggregateInput>;
  blockedByUserId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  unblockedByUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicBlockedPhoneNumberOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicBlockedPhoneNumberOrderByRelevanceInput>;
  blockedBy?: Maybe<UserOrderByWithRelationInput>;
  blockedByUserId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  unblockedBy?: Maybe<UserOrderByWithRelationInput>;
  unblockedByUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicBlockedPhoneNumberOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicBlockedPhoneNumberOrderByRelevanceInput>;
  blockedBy?: Maybe<UserOrderByWithRelationInput>;
  blockedByUserId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  unblockedBy?: Maybe<UserOrderByWithRelationInput>;
  unblockedByUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicBlockedPhoneNumberScalarFieldEnum {
  BlockedByUserId = 'blockedByUserId',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Notes = 'notes',
  PhoneNumber = 'phoneNumber',
  UnblockedByUserId = 'unblockedByUserId',
  UpdatedAt = 'updatedAt'
}

export type ClinicBlockedPhoneNumberScalarWhereInput = {
  AND?: Maybe<Array<ClinicBlockedPhoneNumberScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicBlockedPhoneNumberScalarWhereInput>>;
  OR?: Maybe<Array<ClinicBlockedPhoneNumberScalarWhereInput>>;
  blockedByUserId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  notes?: Maybe<StringNullableFilter>;
  phoneNumber?: Maybe<StringFilter>;
  unblockedByUserId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicBlockedPhoneNumberScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicBlockedPhoneNumberScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicBlockedPhoneNumberScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicBlockedPhoneNumberScalarWhereWithAggregatesInput>>;
  blockedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  notes?: Maybe<StringNullableWithAggregatesFilter>;
  phoneNumber?: Maybe<StringWithAggregatesFilter>;
  unblockedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicBlockedPhoneNumberUncheckedCreateInput = {
  blockedByUserId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput = {
  connect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicBlockedPhoneNumberCreateOrConnectWithoutBlockedByInput>>;
  create?: Maybe<Array<ClinicBlockedPhoneNumberCreateWithoutBlockedByInput>>;
  createMany?: Maybe<ClinicBlockedPhoneNumberCreateManyBlockedByInputEnvelope>;
};

export type ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicBlockedPhoneNumberCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicBlockedPhoneNumberCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicBlockedPhoneNumberCreateManyClinicInputEnvelope>;
};

export type ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput = {
  connect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicBlockedPhoneNumberCreateOrConnectWithoutUnblockedByInput>>;
  create?: Maybe<Array<ClinicBlockedPhoneNumberCreateWithoutUnblockedByInput>>;
  createMany?: Maybe<ClinicBlockedPhoneNumberCreateManyUnblockedByInputEnvelope>;
};

export type ClinicBlockedPhoneNumberUncheckedCreateWithoutBlockedByInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUncheckedCreateWithoutClinicInput = {
  blockedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUncheckedCreateWithoutUnblockedByInput = {
  blockedByUserId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUncheckedUpdateInput = {
  blockedByUserId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUncheckedUpdateManyInput = {
  blockedByUserId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput = {
  connect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicBlockedPhoneNumberCreateOrConnectWithoutBlockedByInput>>;
  create?: Maybe<Array<ClinicBlockedPhoneNumberCreateWithoutBlockedByInput>>;
  createMany?: Maybe<ClinicBlockedPhoneNumberCreateManyBlockedByInputEnvelope>;
  delete?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicBlockedPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicBlockedPhoneNumberUpdateWithWhereUniqueWithoutBlockedByInput>>;
  updateMany?: Maybe<Array<ClinicBlockedPhoneNumberUpdateManyWithWhereWithoutBlockedByInput>>;
  upsert?: Maybe<Array<ClinicBlockedPhoneNumberUpsertWithWhereUniqueWithoutBlockedByInput>>;
};

export type ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicInput = {
  blockedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicBlockedPhoneNumberCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicBlockedPhoneNumberCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicBlockedPhoneNumberCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicBlockedPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicBlockedPhoneNumberUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicBlockedPhoneNumberUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicBlockedPhoneNumberUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByInput = {
  blockedByUserId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput = {
  connect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicBlockedPhoneNumberCreateOrConnectWithoutUnblockedByInput>>;
  create?: Maybe<Array<ClinicBlockedPhoneNumberCreateWithoutUnblockedByInput>>;
  createMany?: Maybe<ClinicBlockedPhoneNumberCreateManyUnblockedByInputEnvelope>;
  delete?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicBlockedPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicBlockedPhoneNumberUpdateWithWhereUniqueWithoutUnblockedByInput>>;
  updateMany?: Maybe<Array<ClinicBlockedPhoneNumberUpdateManyWithWhereWithoutUnblockedByInput>>;
  upsert?: Maybe<Array<ClinicBlockedPhoneNumberUpsertWithWhereUniqueWithoutUnblockedByInput>>;
};

export type ClinicBlockedPhoneNumberUncheckedUpdateWithoutBlockedByInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUncheckedUpdateWithoutClinicInput = {
  blockedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUncheckedUpdateWithoutUnblockedByInput = {
  blockedByUserId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUpdateInput = {
  blockedBy?: Maybe<UserUpdateOneWithoutBlockedNumbersNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutBlockedPhoneNumbersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  unblockedBy?: Maybe<UserUpdateOneWithoutUnblockedNumbersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUpdateManyWithWhereWithoutBlockedByInput = {
  data: ClinicBlockedPhoneNumberUpdateManyMutationInput;
  where: ClinicBlockedPhoneNumberScalarWhereInput;
};

export type ClinicBlockedPhoneNumberUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicBlockedPhoneNumberUpdateManyMutationInput;
  where: ClinicBlockedPhoneNumberScalarWhereInput;
};

export type ClinicBlockedPhoneNumberUpdateManyWithWhereWithoutUnblockedByInput = {
  data: ClinicBlockedPhoneNumberUpdateManyMutationInput;
  where: ClinicBlockedPhoneNumberScalarWhereInput;
};

export type ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput = {
  connect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicBlockedPhoneNumberCreateOrConnectWithoutBlockedByInput>>;
  create?: Maybe<Array<ClinicBlockedPhoneNumberCreateWithoutBlockedByInput>>;
  createMany?: Maybe<ClinicBlockedPhoneNumberCreateManyBlockedByInputEnvelope>;
  delete?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicBlockedPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicBlockedPhoneNumberUpdateWithWhereUniqueWithoutBlockedByInput>>;
  updateMany?: Maybe<Array<ClinicBlockedPhoneNumberUpdateManyWithWhereWithoutBlockedByInput>>;
  upsert?: Maybe<Array<ClinicBlockedPhoneNumberUpsertWithWhereUniqueWithoutBlockedByInput>>;
};

export type ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicBlockedPhoneNumberCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicBlockedPhoneNumberCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicBlockedPhoneNumberCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicBlockedPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicBlockedPhoneNumberUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicBlockedPhoneNumberUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicBlockedPhoneNumberUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput = {
  connect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicBlockedPhoneNumberCreateOrConnectWithoutUnblockedByInput>>;
  create?: Maybe<Array<ClinicBlockedPhoneNumberCreateWithoutUnblockedByInput>>;
  createMany?: Maybe<ClinicBlockedPhoneNumberCreateManyUnblockedByInputEnvelope>;
  delete?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicBlockedPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicBlockedPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicBlockedPhoneNumberUpdateWithWhereUniqueWithoutUnblockedByInput>>;
  updateMany?: Maybe<Array<ClinicBlockedPhoneNumberUpdateManyWithWhereWithoutUnblockedByInput>>;
  upsert?: Maybe<Array<ClinicBlockedPhoneNumberUpsertWithWhereUniqueWithoutUnblockedByInput>>;
};

export type ClinicBlockedPhoneNumberUpdateWithWhereUniqueWithoutBlockedByInput = {
  data: ClinicBlockedPhoneNumberUpdateWithoutBlockedByInput;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};

export type ClinicBlockedPhoneNumberUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicBlockedPhoneNumberUpdateWithoutClinicInput;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};

export type ClinicBlockedPhoneNumberUpdateWithWhereUniqueWithoutUnblockedByInput = {
  data: ClinicBlockedPhoneNumberUpdateWithoutUnblockedByInput;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};

export type ClinicBlockedPhoneNumberUpdateWithoutBlockedByInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutBlockedPhoneNumbersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  unblockedBy?: Maybe<UserUpdateOneWithoutUnblockedNumbersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUpdateWithoutClinicInput = {
  blockedBy?: Maybe<UserUpdateOneWithoutBlockedNumbersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  unblockedBy?: Maybe<UserUpdateOneWithoutUnblockedNumbersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUpdateWithoutUnblockedByInput = {
  blockedBy?: Maybe<UserUpdateOneWithoutBlockedNumbersNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutBlockedPhoneNumbersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicBlockedPhoneNumberUpsertWithWhereUniqueWithoutBlockedByInput = {
  create: ClinicBlockedPhoneNumberCreateWithoutBlockedByInput;
  update: ClinicBlockedPhoneNumberUpdateWithoutBlockedByInput;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};

export type ClinicBlockedPhoneNumberUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicBlockedPhoneNumberCreateWithoutClinicInput;
  update: ClinicBlockedPhoneNumberUpdateWithoutClinicInput;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};

export type ClinicBlockedPhoneNumberUpsertWithWhereUniqueWithoutUnblockedByInput = {
  create: ClinicBlockedPhoneNumberCreateWithoutUnblockedByInput;
  update: ClinicBlockedPhoneNumberUpdateWithoutUnblockedByInput;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};

export type ClinicBlockedPhoneNumberWhereInput = {
  AND?: Maybe<Array<ClinicBlockedPhoneNumberWhereInput>>;
  NOT?: Maybe<Array<ClinicBlockedPhoneNumberWhereInput>>;
  OR?: Maybe<Array<ClinicBlockedPhoneNumberWhereInput>>;
  blockedBy?: Maybe<UserNullableScalarRelationFilter>;
  blockedByUserId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  notes?: Maybe<StringNullableFilter>;
  phoneNumber?: Maybe<StringFilter>;
  unblockedBy?: Maybe<UserNullableScalarRelationFilter>;
  unblockedByUserId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicBlockedPhoneNumberWhereUniqueInput = {
  AND?: Maybe<Array<ClinicBlockedPhoneNumberWhereInput>>;
  NOT?: Maybe<Array<ClinicBlockedPhoneNumberWhereInput>>;
  OR?: Maybe<Array<ClinicBlockedPhoneNumberWhereInput>>;
  blockedBy?: Maybe<UserNullableScalarRelationFilter>;
  blockedByUserId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicIdAndPhoneNumber?: Maybe<ClinicBlockedPhoneNumberClinicIdAndPhoneNumberCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<StringNullableFilter>;
  phoneNumber?: Maybe<StringFilter>;
  unblockedBy?: Maybe<UserNullableScalarRelationFilter>;
  unblockedByUserId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicCancellationInput = {
  cancellationNote: Scalars['String'];
  cancellationReason: Scalars['String'];
};

export type ClinicContactInfo = {
  __typename?: 'ClinicContactInfo';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  emergencyClinics?: Maybe<Array<Maybe<EmergencyClinicContactInfo>>>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  fullAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type ClinicCountAggregateOutputType = {
  __typename?: 'ClinicCountAggregateOutputType';
  _all: Scalars['Int'];
  activationDate: Scalars['Int'];
  addressLine1: Scalars['Int'];
  addressLine2: Scalars['Int'];
  allowAllUsersToCloseConsultations: Scalars['Int'];
  autoSubscriptionReceiptEmails: Scalars['Int'];
  automaticSubscriptionReceipts: Scalars['Int'];
  callerIdPhoneNumber: Scalars['Int'];
  canceledAt: Scalars['Int'];
  cancellationNote: Scalars['Int'];
  cancellationReason: Scalars['Int'];
  carePlanProviderGroupId: Scalars['Int'];
  city: Scalars['Int'];
  clinicEmail: Scalars['Int'];
  clinicSettingId: Scalars['Int'];
  clinicWidgetSettingId: Scalars['Int'];
  consultationCost: Scalars['Int'];
  corporateId: Scalars['Int'];
  country: Scalars['Int'];
  createdAt: Scalars['Int'];
  crmId: Scalars['Int'];
  crmUrlParams: Scalars['Int'];
  customerId: Scalars['Int'];
  firebaseId: Scalars['Int'];
  firebaseVets: Scalars['Int'];
  followUpCost: Scalars['Int'];
  fullAddress: Scalars['Int'];
  hasServiceReminders: Scalars['Int'];
  hasSmsConversations: Scalars['Int'];
  headUserId: Scalars['Int'];
  hours: Scalars['Int'];
  id: Scalars['Int'];
  incomeMethod: Scalars['Int'];
  integrationInfo: Scalars['Int'];
  integrationSystem: Scalars['Int'];
  integrationType: Scalars['Int'];
  isAddAppointmentDisabled: Scalars['Int'];
  isCallerIdVerified: Scalars['Int'];
  isClinicActive: Scalars['Int'];
  isClinicEligibleForPayments: Scalars['Int'];
  isConsultationsActive: Scalars['Int'];
  isIntegrationActive: Scalars['Int'];
  isPaymentUsBank: Scalars['Int'];
  isServiceRemindersActive: Scalars['Int'];
  lastPrintOrderedOn: Scalars['Int'];
  lastPrintOrderedQuantity: Scalars['Int'];
  lat: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  logo: Scalars['Int'];
  long: Scalars['Int'];
  loyaltyProgramId: Scalars['Int'];
  marketEmail: Scalars['Int'];
  marketFacebookNumber: Scalars['Int'];
  marketFacebookPageId: Scalars['Int'];
  marketFacebookPageToken: Scalars['Int'];
  name: Scalars['Int'];
  optimizedLogoUrl: Scalars['Int'];
  organizationId: Scalars['Int'];
  paymentAddress: Scalars['Int'];
  paymentBankAccountNumber: Scalars['Int'];
  paymentBankRoutingNumber: Scalars['Int'];
  paymentCity: Scalars['Int'];
  paymentName: Scalars['Int'];
  paymentPhone: Scalars['Int'];
  paymentState: Scalars['Int'];
  paymentZip: Scalars['Int'];
  phone: Scalars['Int'];
  postalCode: Scalars['Int'];
  ppcLocationId: Scalars['Int'];
  printLastOrder: Scalars['Int'];
  printReceivedQuantity: Scalars['Int'];
  remindersIntegrationRequestEmail: Scalars['Int'];
  responseTime: Scalars['Int'];
  smsPhoneNumber: Scalars['Int'];
  state: Scalars['Int'];
  stripeCustomerId: Scalars['Int'];
  stripeSubscriptionId: Scalars['Int'];
  stripeSubscriptionPlan: Scalars['Int'];
  submerchantApprovedAt: Scalars['Int'];
  submerchantId: Scalars['Int'];
  submerchantIsActive: Scalars['Int'];
  submerchantStatus: Scalars['Int'];
  submerchantStripeChargesEnabled: Scalars['Int'];
  submerchantStripeHasCustomPayouts: Scalars['Int'];
  submerchantStripeId: Scalars['Int'];
  submerchantStripePayoutsEnabled: Scalars['Int'];
  submerchantStripeStatus: Scalars['Int'];
  subscribedAt: Scalars['Int'];
  subscriptionId: Scalars['Int'];
  subscriptionPlan: Scalars['Int'];
  timezone: Scalars['Int'];
  timezoneName: Scalars['Int'];
  token: Scalars['Int'];
  unlayerSettingId: Scalars['Int'];
  unsubscribedAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
  websiteUrl: Scalars['Int'];
  widgetSettings: Scalars['Int'];
};

export type ClinicCountOrderByAggregateInput = {
  activationDate?: Maybe<SortOrder>;
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  allowAllUsersToCloseConsultations?: Maybe<SortOrder>;
  autoSubscriptionReceiptEmails?: Maybe<SortOrder>;
  automaticSubscriptionReceipts?: Maybe<SortOrder>;
  callerIdPhoneNumber?: Maybe<SortOrder>;
  canceledAt?: Maybe<SortOrder>;
  cancellationNote?: Maybe<SortOrder>;
  cancellationReason?: Maybe<SortOrder>;
  carePlanProviderGroupId?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicEmail?: Maybe<SortOrder>;
  clinicSettingId?: Maybe<SortOrder>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  consultationCost?: Maybe<SortOrder>;
  corporateId?: Maybe<SortOrder>;
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  crmUrlParams?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firebaseVets?: Maybe<SortOrder>;
  followUpCost?: Maybe<SortOrder>;
  fullAddress?: Maybe<SortOrder>;
  hasServiceReminders?: Maybe<SortOrder>;
  hasSmsConversations?: Maybe<SortOrder>;
  headUserId?: Maybe<SortOrder>;
  hours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomeMethod?: Maybe<SortOrder>;
  integrationInfo?: Maybe<SortOrder>;
  integrationSystem?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  isAddAppointmentDisabled?: Maybe<SortOrder>;
  isCallerIdVerified?: Maybe<SortOrder>;
  isClinicActive?: Maybe<SortOrder>;
  isClinicEligibleForPayments?: Maybe<SortOrder>;
  isConsultationsActive?: Maybe<SortOrder>;
  isIntegrationActive?: Maybe<SortOrder>;
  isPaymentUsBank?: Maybe<SortOrder>;
  isServiceRemindersActive?: Maybe<SortOrder>;
  lastPrintOrderedOn?: Maybe<SortOrder>;
  lastPrintOrderedQuantity?: Maybe<SortOrder>;
  lat?: Maybe<SortOrder>;
  legalEntityId?: Maybe<SortOrder>;
  logo?: Maybe<SortOrder>;
  long?: Maybe<SortOrder>;
  loyaltyProgramId?: Maybe<SortOrder>;
  marketEmail?: Maybe<SortOrder>;
  marketFacebookNumber?: Maybe<SortOrder>;
  marketFacebookPageId?: Maybe<SortOrder>;
  marketFacebookPageToken?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  optimizedLogoUrl?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  paymentAddress?: Maybe<SortOrder>;
  paymentBankAccountNumber?: Maybe<SortOrder>;
  paymentBankRoutingNumber?: Maybe<SortOrder>;
  paymentCity?: Maybe<SortOrder>;
  paymentName?: Maybe<SortOrder>;
  paymentPhone?: Maybe<SortOrder>;
  paymentState?: Maybe<SortOrder>;
  paymentZip?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  printLastOrder?: Maybe<SortOrder>;
  printReceivedQuantity?: Maybe<SortOrder>;
  remindersIntegrationRequestEmail?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  smsPhoneNumber?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  stripeSubscriptionPlan?: Maybe<SortOrder>;
  submerchantApprovedAt?: Maybe<SortOrder>;
  submerchantId?: Maybe<SortOrder>;
  submerchantIsActive?: Maybe<SortOrder>;
  submerchantStatus?: Maybe<SortOrder>;
  submerchantStripeChargesEnabled?: Maybe<SortOrder>;
  submerchantStripeHasCustomPayouts?: Maybe<SortOrder>;
  submerchantStripeId?: Maybe<SortOrder>;
  submerchantStripePayoutsEnabled?: Maybe<SortOrder>;
  submerchantStripeStatus?: Maybe<SortOrder>;
  subscribedAt?: Maybe<SortOrder>;
  subscriptionId?: Maybe<SortOrder>;
  subscriptionPlan?: Maybe<SortOrder>;
  timezone?: Maybe<SortOrder>;
  timezoneName?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  unlayerSettingId?: Maybe<SortOrder>;
  unsubscribedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  websiteUrl?: Maybe<SortOrder>;
  widgetSettings?: Maybe<SortOrder>;
};

export type ClinicCountOutputType = {
  __typename?: 'ClinicCountOutputType';
  AppointmentNoteTemplate: Scalars['Int'];
  EmailCampaignLog: Scalars['Int'];
  EmailCampaignUnsubscribe: Scalars['Int'];
  HillsToHomeAPILog: Scalars['Int'];
  Rules: Scalars['Int'];
  appoinmentTypes: Scalars['Int'];
  appointmentAvailabilities: Scalars['Int'];
  appointments: Scalars['Int'];
  automationRuns: Scalars['Int'];
  axionClinicUserConfigurations: Scalars['Int'];
  benefitsProvided: Scalars['Int'];
  bitwerxHealthchecks: Scalars['Int'];
  blockedPhoneNumbers: Scalars['Int'];
  calls: Scalars['Int'];
  channelFilterSelections: Scalars['Int'];
  channelStatusChannelAssignees: Scalars['Int'];
  channels: Scalars['Int'];
  clinicDirectBookingSettings: Scalars['Int'];
  clinicEmailCampaignSettings: Scalars['Int'];
  clinicEmployees: Scalars['Int'];
  clinicModules: Scalars['Int'];
  clinicOfficeHours: Scalars['Int'];
  clinicOnboardings: Scalars['Int'];
  clinicPetParents: Scalars['Int'];
  clinicPets: Scalars['Int'];
  clinicPhoneNumber: Scalars['Int'];
  clinicRooms: Scalars['Int'];
  clinicUserFilters: Scalars['Int'];
  clinicWidgetRequests: Scalars['Int'];
  clinicWorkflowTypes: Scalars['Int'];
  consultationRequests: Scalars['Int'];
  consultations: Scalars['Int'];
  directBookingExclusionRules: Scalars['Int'];
  emailCampaign: Scalars['Int'];
  emailCampaignTemplate: Scalars['Int'];
  encryptedClinicUploads: Scalars['Int'];
  featureFlags: Scalars['Int'];
  financialTransactions: Scalars['Int'];
  formSubmissions: Scalars['Int'];
  formTemplates: Scalars['Int'];
  informAudienceMember: Scalars['Int'];
  informPartnerCustomers: Scalars['Int'];
  informPartnerProgramEnrollments: Scalars['Int'];
  insuranceIntegrations: Scalars['Int'];
  integrations: Scalars['Int'];
  loyaltyPointDeltas: Scalars['Int'];
  loyaltyRewardRedemptionActions: Scalars['Int'];
  massTextAlerts: Scalars['Int'];
  media: Scalars['Int'];
  messageTemplates: Scalars['Int'];
  payoutBatchingPeriods: Scalars['Int'];
  pets: Scalars['Int'];
  petsId: Scalars['Int'];
  postcardSettings: Scalars['Int'];
  prescriptions: Scalars['Int'];
  productPackageSubscriptions: Scalars['Int'];
  promoCodes: Scalars['Int'];
  recaps: Scalars['Int'];
  roles: Scalars['Int'];
  sentTrupanionExamDayOffers: Scalars['Int'];
  staff: Scalars['Int'];
  staffId: Scalars['Int'];
  stripePaymentIntents: Scalars['Int'];
  stripePayoutAccounts: Scalars['Int'];
  stripeTerminalLocations: Scalars['Int'];
  surveyResults: Scalars['Int'];
  tasks: Scalars['Int'];
  twilioVerifications: Scalars['Int'];
  userAppointmentGroupings: Scalars['Int'];
  userBoardFiltersColumns: Scalars['Int'];
  userTaskLists: Scalars['Int'];
  users: Scalars['Int'];
  vaccinations: Scalars['Int'];
  vetAvailabilities: Scalars['Int'];
  workflowEventSettings: Scalars['Int'];
};

export type ClinicCreateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateManyCarePlanProviderGroupInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicCreateManyCarePlanProviderGroupInputEnvelope = {
  data: Array<ClinicCreateManyCarePlanProviderGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicCreateManyClinicWidgetSettingInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicCreateManyClinicWidgetSettingInputEnvelope = {
  data: Array<ClinicCreateManyClinicWidgetSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicCreateManyInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicCreateManyLegalEntityInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicCreateManyLegalEntityInputEnvelope = {
  data: Array<ClinicCreateManyLegalEntityInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicCreateManyLoyaltyProgramInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicCreateManyLoyaltyProgramInputEnvelope = {
  data: Array<ClinicCreateManyLoyaltyProgramInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicCreateManyOrganizationInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicCreateManyOrganizationInputEnvelope = {
  data: Array<ClinicCreateManyOrganizationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicCreateManyUnlayerSettingInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicCreateManyUnlayerSettingInputEnvelope = {
  data: Array<ClinicCreateManyUnlayerSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicCreateManyUsersIdInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicCreateManyUsersIdInputEnvelope = {
  data: Array<ClinicCreateManyUsersIdInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicCreateNestedManyWithoutCarePlanProviderGroupInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutCarePlanProviderGroupInput>>;
  create?: Maybe<Array<ClinicCreateWithoutCarePlanProviderGroupInput>>;
  createMany?: Maybe<ClinicCreateManyCarePlanProviderGroupInputEnvelope>;
};

export type ClinicCreateNestedManyWithoutClinicWidgetSettingInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutClinicWidgetSettingInput>>;
  create?: Maybe<Array<ClinicCreateWithoutClinicWidgetSettingInput>>;
  createMany?: Maybe<ClinicCreateManyClinicWidgetSettingInputEnvelope>;
};

export type ClinicCreateNestedManyWithoutFeatureFlagsInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutFeatureFlagsInput>>;
  create?: Maybe<Array<ClinicCreateWithoutFeatureFlagsInput>>;
};

export type ClinicCreateNestedManyWithoutLegalEntityInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutLegalEntityInput>>;
  create?: Maybe<Array<ClinicCreateWithoutLegalEntityInput>>;
  createMany?: Maybe<ClinicCreateManyLegalEntityInputEnvelope>;
};

export type ClinicCreateNestedManyWithoutLoyaltyProgramInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutLoyaltyProgramInput>>;
  create?: Maybe<Array<ClinicCreateWithoutLoyaltyProgramInput>>;
  createMany?: Maybe<ClinicCreateManyLoyaltyProgramInputEnvelope>;
};

export type ClinicCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<ClinicCreateWithoutOrganizationInput>>;
  createMany?: Maybe<ClinicCreateManyOrganizationInputEnvelope>;
};

export type ClinicCreateNestedManyWithoutPetsInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutPetsInput>>;
  create?: Maybe<Array<ClinicCreateWithoutPetsInput>>;
};

export type ClinicCreateNestedManyWithoutStaffInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutStaffInput>>;
  create?: Maybe<Array<ClinicCreateWithoutStaffInput>>;
};

export type ClinicCreateNestedManyWithoutStripePayoutAccountsInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutStripePayoutAccountsInput>>;
  create?: Maybe<Array<ClinicCreateWithoutStripePayoutAccountsInput>>;
};

export type ClinicCreateNestedManyWithoutUnlayerSettingInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutUnlayerSettingInput>>;
  create?: Maybe<Array<ClinicCreateWithoutUnlayerSettingInput>>;
  createMany?: Maybe<ClinicCreateManyUnlayerSettingInputEnvelope>;
};

export type ClinicCreateNestedManyWithoutUsersIdInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutUsersIdInput>>;
  create?: Maybe<Array<ClinicCreateWithoutUsersIdInput>>;
  createMany?: Maybe<ClinicCreateManyUsersIdInputEnvelope>;
};

export type ClinicCreateNestedManyWithoutUsersInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutUsersInput>>;
  create?: Maybe<Array<ClinicCreateWithoutUsersInput>>;
};

export type ClinicCreateNestedOneWithoutAppoinmentTypesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAppoinmentTypesInput>;
  create?: Maybe<ClinicCreateWithoutAppoinmentTypesInput>;
};

export type ClinicCreateNestedOneWithoutAppointmentAvailabilitiesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAppointmentAvailabilitiesInput>;
  create?: Maybe<ClinicCreateWithoutAppointmentAvailabilitiesInput>;
};

export type ClinicCreateNestedOneWithoutAppointmentNoteTemplateInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAppointmentNoteTemplateInput>;
  create?: Maybe<ClinicCreateWithoutAppointmentNoteTemplateInput>;
};

export type ClinicCreateNestedOneWithoutAppointmentsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<ClinicCreateWithoutAppointmentsInput>;
};

export type ClinicCreateNestedOneWithoutAutomationRunsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<ClinicCreateWithoutAutomationRunsInput>;
};

export type ClinicCreateNestedOneWithoutAxionClinicConfigurationInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAxionClinicConfigurationInput>;
  create?: Maybe<ClinicCreateWithoutAxionClinicConfigurationInput>;
};

export type ClinicCreateNestedOneWithoutAxionClinicUserConfigurationsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAxionClinicUserConfigurationsInput>;
  create?: Maybe<ClinicCreateWithoutAxionClinicUserConfigurationsInput>;
};

export type ClinicCreateNestedOneWithoutBenefitsProvidedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutBenefitsProvidedInput>;
  create?: Maybe<ClinicCreateWithoutBenefitsProvidedInput>;
};

export type ClinicCreateNestedOneWithoutBitwerxHealthchecksInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutBitwerxHealthchecksInput>;
  create?: Maybe<ClinicCreateWithoutBitwerxHealthchecksInput>;
};

export type ClinicCreateNestedOneWithoutBlockedPhoneNumbersInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutBlockedPhoneNumbersInput>;
  create?: Maybe<ClinicCreateWithoutBlockedPhoneNumbersInput>;
};

export type ClinicCreateNestedOneWithoutCallsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutCallsInput>;
  create?: Maybe<ClinicCreateWithoutCallsInput>;
};

export type ClinicCreateNestedOneWithoutCarePayoutOrganizationInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutCarePayoutOrganizationInput>;
  create?: Maybe<ClinicCreateWithoutCarePayoutOrganizationInput>;
};

export type ClinicCreateNestedOneWithoutChannelFilterSelectionsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutChannelFilterSelectionsInput>;
  create?: Maybe<ClinicCreateWithoutChannelFilterSelectionsInput>;
};

export type ClinicCreateNestedOneWithoutChannelStatusChannelAssigneesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutChannelStatusChannelAssigneesInput>;
  create?: Maybe<ClinicCreateWithoutChannelStatusChannelAssigneesInput>;
};

export type ClinicCreateNestedOneWithoutChannelsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutChannelsInput>;
  create?: Maybe<ClinicCreateWithoutChannelsInput>;
};

export type ClinicCreateNestedOneWithoutClinicCustomPayoutsSetupInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicCustomPayoutsSetupInput>;
  create?: Maybe<ClinicCreateWithoutClinicCustomPayoutsSetupInput>;
};

export type ClinicCreateNestedOneWithoutClinicDirectBookingSettingsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicDirectBookingSettingsInput>;
  create?: Maybe<ClinicCreateWithoutClinicDirectBookingSettingsInput>;
};

export type ClinicCreateNestedOneWithoutClinicEmailCampaignSettingsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicEmailCampaignSettingsInput>;
  create?: Maybe<ClinicCreateWithoutClinicEmailCampaignSettingsInput>;
};

export type ClinicCreateNestedOneWithoutClinicEmployeesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicEmployeesInput>;
  create?: Maybe<ClinicCreateWithoutClinicEmployeesInput>;
};

export type ClinicCreateNestedOneWithoutClinicModulesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicModulesInput>;
  create?: Maybe<ClinicCreateWithoutClinicModulesInput>;
};

export type ClinicCreateNestedOneWithoutClinicOfficeHoursInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicOfficeHoursInput>;
  create?: Maybe<ClinicCreateWithoutClinicOfficeHoursInput>;
};

export type ClinicCreateNestedOneWithoutClinicOnboardingsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicOnboardingsInput>;
  create?: Maybe<ClinicCreateWithoutClinicOnboardingsInput>;
};

export type ClinicCreateNestedOneWithoutClinicPetParentsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicPetParentsInput>;
  create?: Maybe<ClinicCreateWithoutClinicPetParentsInput>;
};

export type ClinicCreateNestedOneWithoutClinicPetsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicPetsInput>;
  create?: Maybe<ClinicCreateWithoutClinicPetsInput>;
};

export type ClinicCreateNestedOneWithoutClinicPhoneNumberInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicPhoneNumberInput>;
  create?: Maybe<ClinicCreateWithoutClinicPhoneNumberInput>;
};

export type ClinicCreateNestedOneWithoutClinicRoomsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicRoomsInput>;
  create?: Maybe<ClinicCreateWithoutClinicRoomsInput>;
};

export type ClinicCreateNestedOneWithoutClinicSettingInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicSettingInput>;
  create?: Maybe<ClinicCreateWithoutClinicSettingInput>;
};

export type ClinicCreateNestedOneWithoutClinicUserFiltersInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicUserFiltersInput>;
  create?: Maybe<ClinicCreateWithoutClinicUserFiltersInput>;
};

export type ClinicCreateNestedOneWithoutClinicWidgetRequestsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicWidgetRequestsInput>;
  create?: Maybe<ClinicCreateWithoutClinicWidgetRequestsInput>;
};

export type ClinicCreateNestedOneWithoutClinicWorkflowTypesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicWorkflowTypesInput>;
  create?: Maybe<ClinicCreateWithoutClinicWorkflowTypesInput>;
};

export type ClinicCreateNestedOneWithoutConsultationRequestsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutConsultationRequestsInput>;
  create?: Maybe<ClinicCreateWithoutConsultationRequestsInput>;
};

export type ClinicCreateNestedOneWithoutConsultationsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutConsultationsInput>;
  create?: Maybe<ClinicCreateWithoutConsultationsInput>;
};

export type ClinicCreateNestedOneWithoutDirectBookingExclusionRulesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutDirectBookingExclusionRulesInput>;
  create?: Maybe<ClinicCreateWithoutDirectBookingExclusionRulesInput>;
};

export type ClinicCreateNestedOneWithoutEmailCampaignInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutEmailCampaignInput>;
  create?: Maybe<ClinicCreateWithoutEmailCampaignInput>;
};

export type ClinicCreateNestedOneWithoutEmailCampaignLogInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutEmailCampaignLogInput>;
  create?: Maybe<ClinicCreateWithoutEmailCampaignLogInput>;
};

export type ClinicCreateNestedOneWithoutEmailCampaignTemplateInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutEmailCampaignTemplateInput>;
  create?: Maybe<ClinicCreateWithoutEmailCampaignTemplateInput>;
};

export type ClinicCreateNestedOneWithoutEmailCampaignUnsubscribeInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutEmailCampaignUnsubscribeInput>;
  create?: Maybe<ClinicCreateWithoutEmailCampaignUnsubscribeInput>;
};

export type ClinicCreateNestedOneWithoutEncryptedClinicUploadsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutEncryptedClinicUploadsInput>;
  create?: Maybe<ClinicCreateWithoutEncryptedClinicUploadsInput>;
};

export type ClinicCreateNestedOneWithoutFinancialTransactionsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutFinancialTransactionsInput>;
  create?: Maybe<ClinicCreateWithoutFinancialTransactionsInput>;
};

export type ClinicCreateNestedOneWithoutFormSubmissionsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutFormSubmissionsInput>;
  create?: Maybe<ClinicCreateWithoutFormSubmissionsInput>;
};

export type ClinicCreateNestedOneWithoutFormTemplatesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutFormTemplatesInput>;
  create?: Maybe<ClinicCreateWithoutFormTemplatesInput>;
};

export type ClinicCreateNestedOneWithoutGooglePlaceInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutGooglePlaceInput>;
  create?: Maybe<ClinicCreateWithoutGooglePlaceInput>;
};

export type ClinicCreateNestedOneWithoutHillsToHomeApiLogInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutHillsToHomeApiLogInput>;
  create?: Maybe<ClinicCreateWithoutHillsToHomeApiLogInput>;
};

export type ClinicCreateNestedOneWithoutInformAudienceMemberInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutInformAudienceMemberInput>;
  create?: Maybe<ClinicCreateWithoutInformAudienceMemberInput>;
};

export type ClinicCreateNestedOneWithoutInformPartnerCustomersInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutInformPartnerCustomersInput>;
  create?: Maybe<ClinicCreateWithoutInformPartnerCustomersInput>;
};

export type ClinicCreateNestedOneWithoutInformPartnerProgramEnrollmentsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutInformPartnerProgramEnrollmentsInput>;
  create?: Maybe<ClinicCreateWithoutInformPartnerProgramEnrollmentsInput>;
};

export type ClinicCreateNestedOneWithoutInsuranceIntegrationsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutInsuranceIntegrationsInput>;
  create?: Maybe<ClinicCreateWithoutInsuranceIntegrationsInput>;
};

export type ClinicCreateNestedOneWithoutIntegrationsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutIntegrationsInput>;
  create?: Maybe<ClinicCreateWithoutIntegrationsInput>;
};

export type ClinicCreateNestedOneWithoutLoyaltyPointDeltasInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutLoyaltyPointDeltasInput>;
  create?: Maybe<ClinicCreateWithoutLoyaltyPointDeltasInput>;
};

export type ClinicCreateNestedOneWithoutLoyaltyRewardRedemptionActionsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutLoyaltyRewardRedemptionActionsInput>;
  create?: Maybe<ClinicCreateWithoutLoyaltyRewardRedemptionActionsInput>;
};

export type ClinicCreateNestedOneWithoutMassTextAlertsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutMassTextAlertsInput>;
  create?: Maybe<ClinicCreateWithoutMassTextAlertsInput>;
};

export type ClinicCreateNestedOneWithoutMediaInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutMediaInput>;
  create?: Maybe<ClinicCreateWithoutMediaInput>;
};

export type ClinicCreateNestedOneWithoutMessageTemplatesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutMessageTemplatesInput>;
  create?: Maybe<ClinicCreateWithoutMessageTemplatesInput>;
};

export type ClinicCreateNestedOneWithoutPaymentProcessorForProviderGroupInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPaymentProcessorForProviderGroupInput>;
  create?: Maybe<ClinicCreateWithoutPaymentProcessorForProviderGroupInput>;
};

export type ClinicCreateNestedOneWithoutPayoutBatchingPeriodsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPayoutBatchingPeriodsInput>;
  create?: Maybe<ClinicCreateWithoutPayoutBatchingPeriodsInput>;
};

export type ClinicCreateNestedOneWithoutPayoutBatchingSettingInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPayoutBatchingSettingInput>;
  create?: Maybe<ClinicCreateWithoutPayoutBatchingSettingInput>;
};

export type ClinicCreateNestedOneWithoutPetsIdInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPetsIdInput>;
  create?: Maybe<ClinicCreateWithoutPetsIdInput>;
};

export type ClinicCreateNestedOneWithoutPostcardSettingsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPostcardSettingsInput>;
  create?: Maybe<ClinicCreateWithoutPostcardSettingsInput>;
};

export type ClinicCreateNestedOneWithoutPrescriptionsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPrescriptionsInput>;
  create?: Maybe<ClinicCreateWithoutPrescriptionsInput>;
};

export type ClinicCreateNestedOneWithoutProductPackageSubscriptionsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutProductPackageSubscriptionsInput>;
  create?: Maybe<ClinicCreateWithoutProductPackageSubscriptionsInput>;
};

export type ClinicCreateNestedOneWithoutPromoCodesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPromoCodesInput>;
  create?: Maybe<ClinicCreateWithoutPromoCodesInput>;
};

export type ClinicCreateNestedOneWithoutRecapsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutRecapsInput>;
  create?: Maybe<ClinicCreateWithoutRecapsInput>;
};

export type ClinicCreateNestedOneWithoutRolesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutRolesInput>;
  create?: Maybe<ClinicCreateWithoutRolesInput>;
};

export type ClinicCreateNestedOneWithoutRulesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutRulesInput>;
  create?: Maybe<ClinicCreateWithoutRulesInput>;
};

export type ClinicCreateNestedOneWithoutSentTrupanionExamDayOffersInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutSentTrupanionExamDayOffersInput>;
  create?: Maybe<ClinicCreateWithoutSentTrupanionExamDayOffersInput>;
};

export type ClinicCreateNestedOneWithoutStaffIdInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutStaffIdInput>;
  create?: Maybe<ClinicCreateWithoutStaffIdInput>;
};

export type ClinicCreateNestedOneWithoutStripePaymentIntentsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutStripePaymentIntentsInput>;
  create?: Maybe<ClinicCreateWithoutStripePaymentIntentsInput>;
};

export type ClinicCreateNestedOneWithoutStripeTerminalLocationsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutStripeTerminalLocationsInput>;
  create?: Maybe<ClinicCreateWithoutStripeTerminalLocationsInput>;
};

export type ClinicCreateNestedOneWithoutSurveyResultsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutSurveyResultsInput>;
  create?: Maybe<ClinicCreateWithoutSurveyResultsInput>;
};

export type ClinicCreateNestedOneWithoutSynchronyClinicConfigurationInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutSynchronyClinicConfigurationInput>;
  create?: Maybe<ClinicCreateWithoutSynchronyClinicConfigurationInput>;
};

export type ClinicCreateNestedOneWithoutTasksInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutTasksInput>;
  create?: Maybe<ClinicCreateWithoutTasksInput>;
};

export type ClinicCreateNestedOneWithoutTwilioConfigurationInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutTwilioConfigurationInput>;
  create?: Maybe<ClinicCreateWithoutTwilioConfigurationInput>;
};

export type ClinicCreateNestedOneWithoutTwilioVerificationsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutTwilioVerificationsInput>;
  create?: Maybe<ClinicCreateWithoutTwilioVerificationsInput>;
};

export type ClinicCreateNestedOneWithoutUserAppointmentGroupingsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutUserAppointmentGroupingsInput>;
  create?: Maybe<ClinicCreateWithoutUserAppointmentGroupingsInput>;
};

export type ClinicCreateNestedOneWithoutUserBoardFiltersColumnsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutUserBoardFiltersColumnsInput>;
  create?: Maybe<ClinicCreateWithoutUserBoardFiltersColumnsInput>;
};

export type ClinicCreateNestedOneWithoutUserTaskListsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutUserTaskListsInput>;
  create?: Maybe<ClinicCreateWithoutUserTaskListsInput>;
};

export type ClinicCreateNestedOneWithoutVaccinationsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutVaccinationsInput>;
  create?: Maybe<ClinicCreateWithoutVaccinationsInput>;
};

export type ClinicCreateNestedOneWithoutVetAvailabilitiesInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutVetAvailabilitiesInput>;
  create?: Maybe<ClinicCreateWithoutVetAvailabilitiesInput>;
};

export type ClinicCreateNestedOneWithoutVetsourceInstallationInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutVetsourceInstallationInput>;
  create?: Maybe<ClinicCreateWithoutVetsourceInstallationInput>;
};

export type ClinicCreateNestedOneWithoutWorkflowEventSettingsInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutWorkflowEventSettingsInput>;
  create?: Maybe<ClinicCreateWithoutWorkflowEventSettingsInput>;
};

export type ClinicCreateOrConnectWithoutAppoinmentTypesInput = {
  create: ClinicCreateWithoutAppoinmentTypesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutAppointmentAvailabilitiesInput = {
  create: ClinicCreateWithoutAppointmentAvailabilitiesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutAppointmentNoteTemplateInput = {
  create: ClinicCreateWithoutAppointmentNoteTemplateInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutAppointmentsInput = {
  create: ClinicCreateWithoutAppointmentsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutAutomationRunsInput = {
  create: ClinicCreateWithoutAutomationRunsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutAxionClinicConfigurationInput = {
  create: ClinicCreateWithoutAxionClinicConfigurationInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutAxionClinicUserConfigurationsInput = {
  create: ClinicCreateWithoutAxionClinicUserConfigurationsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutBenefitsProvidedInput = {
  create: ClinicCreateWithoutBenefitsProvidedInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutBitwerxHealthchecksInput = {
  create: ClinicCreateWithoutBitwerxHealthchecksInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutBlockedPhoneNumbersInput = {
  create: ClinicCreateWithoutBlockedPhoneNumbersInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutCallsInput = {
  create: ClinicCreateWithoutCallsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutCarePayoutOrganizationInput = {
  create: ClinicCreateWithoutCarePayoutOrganizationInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutCarePlanProviderGroupInput = {
  create: ClinicCreateWithoutCarePlanProviderGroupInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutChannelFilterSelectionsInput = {
  create: ClinicCreateWithoutChannelFilterSelectionsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutChannelStatusChannelAssigneesInput = {
  create: ClinicCreateWithoutChannelStatusChannelAssigneesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutChannelsInput = {
  create: ClinicCreateWithoutChannelsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicCustomPayoutsSetupInput = {
  create: ClinicCreateWithoutClinicCustomPayoutsSetupInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicDirectBookingSettingsInput = {
  create: ClinicCreateWithoutClinicDirectBookingSettingsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicEmailCampaignSettingsInput = {
  create: ClinicCreateWithoutClinicEmailCampaignSettingsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicEmployeesInput = {
  create: ClinicCreateWithoutClinicEmployeesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicModulesInput = {
  create: ClinicCreateWithoutClinicModulesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicOfficeHoursInput = {
  create: ClinicCreateWithoutClinicOfficeHoursInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicOnboardingsInput = {
  create: ClinicCreateWithoutClinicOnboardingsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicPetParentsInput = {
  create: ClinicCreateWithoutClinicPetParentsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicPetsInput = {
  create: ClinicCreateWithoutClinicPetsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicPhoneNumberInput = {
  create: ClinicCreateWithoutClinicPhoneNumberInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicRoomsInput = {
  create: ClinicCreateWithoutClinicRoomsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicSettingInput = {
  create: ClinicCreateWithoutClinicSettingInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicUserFiltersInput = {
  create: ClinicCreateWithoutClinicUserFiltersInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicWidgetRequestsInput = {
  create: ClinicCreateWithoutClinicWidgetRequestsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicWidgetSettingInput = {
  create: ClinicCreateWithoutClinicWidgetSettingInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutClinicWorkflowTypesInput = {
  create: ClinicCreateWithoutClinicWorkflowTypesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutConsultationRequestsInput = {
  create: ClinicCreateWithoutConsultationRequestsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutConsultationsInput = {
  create: ClinicCreateWithoutConsultationsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutDirectBookingExclusionRulesInput = {
  create: ClinicCreateWithoutDirectBookingExclusionRulesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutEmailCampaignInput = {
  create: ClinicCreateWithoutEmailCampaignInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutEmailCampaignLogInput = {
  create: ClinicCreateWithoutEmailCampaignLogInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutEmailCampaignTemplateInput = {
  create: ClinicCreateWithoutEmailCampaignTemplateInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutEmailCampaignUnsubscribeInput = {
  create: ClinicCreateWithoutEmailCampaignUnsubscribeInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutEncryptedClinicUploadsInput = {
  create: ClinicCreateWithoutEncryptedClinicUploadsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutFeatureFlagsInput = {
  create: ClinicCreateWithoutFeatureFlagsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutFinancialTransactionsInput = {
  create: ClinicCreateWithoutFinancialTransactionsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutFormSubmissionsInput = {
  create: ClinicCreateWithoutFormSubmissionsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutFormTemplatesInput = {
  create: ClinicCreateWithoutFormTemplatesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutGooglePlaceInput = {
  create: ClinicCreateWithoutGooglePlaceInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutHillsToHomeApiLogInput = {
  create: ClinicCreateWithoutHillsToHomeApiLogInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutInformAudienceMemberInput = {
  create: ClinicCreateWithoutInformAudienceMemberInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutInformPartnerCustomersInput = {
  create: ClinicCreateWithoutInformPartnerCustomersInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutInformPartnerProgramEnrollmentsInput = {
  create: ClinicCreateWithoutInformPartnerProgramEnrollmentsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutInsuranceIntegrationsInput = {
  create: ClinicCreateWithoutInsuranceIntegrationsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutIntegrationsInput = {
  create: ClinicCreateWithoutIntegrationsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutLegalEntityInput = {
  create: ClinicCreateWithoutLegalEntityInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutLoyaltyPointDeltasInput = {
  create: ClinicCreateWithoutLoyaltyPointDeltasInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutLoyaltyProgramInput = {
  create: ClinicCreateWithoutLoyaltyProgramInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutLoyaltyRewardRedemptionActionsInput = {
  create: ClinicCreateWithoutLoyaltyRewardRedemptionActionsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutMassTextAlertsInput = {
  create: ClinicCreateWithoutMassTextAlertsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutMediaInput = {
  create: ClinicCreateWithoutMediaInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutMessageTemplatesInput = {
  create: ClinicCreateWithoutMessageTemplatesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutOrganizationInput = {
  create: ClinicCreateWithoutOrganizationInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutPaymentProcessorForProviderGroupInput = {
  create: ClinicCreateWithoutPaymentProcessorForProviderGroupInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutPayoutBatchingPeriodsInput = {
  create: ClinicCreateWithoutPayoutBatchingPeriodsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutPayoutBatchingSettingInput = {
  create: ClinicCreateWithoutPayoutBatchingSettingInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutPetsIdInput = {
  create: ClinicCreateWithoutPetsIdInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutPetsInput = {
  create: ClinicCreateWithoutPetsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutPostcardSettingsInput = {
  create: ClinicCreateWithoutPostcardSettingsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutPrescriptionsInput = {
  create: ClinicCreateWithoutPrescriptionsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutProductPackageSubscriptionsInput = {
  create: ClinicCreateWithoutProductPackageSubscriptionsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutPromoCodesInput = {
  create: ClinicCreateWithoutPromoCodesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutRecapsInput = {
  create: ClinicCreateWithoutRecapsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutRolesInput = {
  create: ClinicCreateWithoutRolesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutRulesInput = {
  create: ClinicCreateWithoutRulesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutSentTrupanionExamDayOffersInput = {
  create: ClinicCreateWithoutSentTrupanionExamDayOffersInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutStaffIdInput = {
  create: ClinicCreateWithoutStaffIdInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutStaffInput = {
  create: ClinicCreateWithoutStaffInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutStripePaymentIntentsInput = {
  create: ClinicCreateWithoutStripePaymentIntentsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutStripePayoutAccountsInput = {
  create: ClinicCreateWithoutStripePayoutAccountsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutStripeTerminalLocationsInput = {
  create: ClinicCreateWithoutStripeTerminalLocationsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutSurveyResultsInput = {
  create: ClinicCreateWithoutSurveyResultsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutSynchronyClinicConfigurationInput = {
  create: ClinicCreateWithoutSynchronyClinicConfigurationInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutTasksInput = {
  create: ClinicCreateWithoutTasksInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutTwilioConfigurationInput = {
  create: ClinicCreateWithoutTwilioConfigurationInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutTwilioVerificationsInput = {
  create: ClinicCreateWithoutTwilioVerificationsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutUnlayerSettingInput = {
  create: ClinicCreateWithoutUnlayerSettingInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutUserAppointmentGroupingsInput = {
  create: ClinicCreateWithoutUserAppointmentGroupingsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutUserBoardFiltersColumnsInput = {
  create: ClinicCreateWithoutUserBoardFiltersColumnsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutUserTaskListsInput = {
  create: ClinicCreateWithoutUserTaskListsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutUsersIdInput = {
  create: ClinicCreateWithoutUsersIdInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutUsersInput = {
  create: ClinicCreateWithoutUsersInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutVaccinationsInput = {
  create: ClinicCreateWithoutVaccinationsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutVetAvailabilitiesInput = {
  create: ClinicCreateWithoutVetAvailabilitiesInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutVetsourceInstallationInput = {
  create: ClinicCreateWithoutVetsourceInstallationInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateOrConnectWithoutWorkflowEventSettingsInput = {
  create: ClinicCreateWithoutWorkflowEventSettingsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicCreateWithoutAppoinmentTypesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutAppointmentAvailabilitiesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutAppointmentNoteTemplateInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutAppointmentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutAutomationRunsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutAxionClinicConfigurationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutAxionClinicUserConfigurationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutBenefitsProvidedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutBitwerxHealthchecksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutBlockedPhoneNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutCallsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutCarePayoutOrganizationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutCarePlanProviderGroupInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutChannelFilterSelectionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutChannelStatusChannelAssigneesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutChannelsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicCustomPayoutsSetupInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicDirectBookingSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicEmailCampaignSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicEmployeesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicModulesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicOfficeHoursInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicOnboardingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicPetParentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicPetsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicPhoneNumberInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicRoomsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicUserFiltersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicWidgetRequestsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicWidgetSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutClinicWorkflowTypesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutConsultationRequestsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutConsultationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutDirectBookingExclusionRulesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutEmailCampaignInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutEmailCampaignLogInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutEmailCampaignTemplateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutEmailCampaignUnsubscribeInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutEncryptedClinicUploadsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutFeatureFlagsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutFinancialTransactionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutFormSubmissionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutFormTemplatesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutGooglePlaceInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutHillsToHomeApiLogInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutInformAudienceMemberInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutInformPartnerCustomersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutInformPartnerProgramEnrollmentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutInsuranceIntegrationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutIntegrationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutLegalEntityInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutLoyaltyPointDeltasInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutLoyaltyProgramInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutLoyaltyRewardRedemptionActionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutMassTextAlertsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutMediaInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutMessageTemplatesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutOrganizationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutPaymentProcessorForProviderGroupInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutPayoutBatchingPeriodsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutPayoutBatchingSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutPetsIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutPetsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutPostcardSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutPrescriptionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutProductPackageSubscriptionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutPromoCodesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutRecapsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutRolesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutRulesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutSentTrupanionExamDayOffersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutStaffIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutStaffInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutStripePaymentIntentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutStripePayoutAccountsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutStripeTerminalLocationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutSurveyResultsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutSynchronyClinicConfigurationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutTasksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutTwilioConfigurationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutTwilioVerificationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutUnlayerSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutUserAppointmentGroupingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutUserBoardFiltersColumnsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutUserTaskListsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutUsersIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutUsersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutVaccinationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutVetAvailabilitiesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutVetsourceInstallationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutClinicInput>;
};

export type ClinicCreateWithoutWorkflowEventSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutParticipatingClinicsInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomCreateNestedManyWithoutClinicInput>;
  clinicSetting?: Maybe<ClinicSettingCreateNestedOneWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityCreateNestedOneWithoutClinicsInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutClinicsInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationCreateNestedManyWithoutClinicInput>;
  unlayerSetting?: Maybe<UnlayerSettingCreateNestedOneWithoutClinicsInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserCreateNestedManyWithoutClinicsInput>;
  usersId?: Maybe<UserCreateNestedOneWithoutClinicsIdInput>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicCustomPayoutsSetup = {
  __typename?: 'ClinicCustomPayoutsSetup';
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUpload>;
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUpload>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  status: ClinicCustomPayoutsSetupStatus;
  updatedAt: Scalars['DateTime'];
};


export type ClinicCustomPayoutsSetupClinicListEncryptedUploadArgs = {
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};


export type ClinicCustomPayoutsSetupClinicRepresentativeInfoEncryptedUploadArgs = {
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};

export type ClinicCustomPayoutsSetupCountAggregateOutputType = {
  __typename?: 'ClinicCustomPayoutsSetupCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicListEncryptedUploadId: Scalars['Int'];
  clinicRepresentativeInfoEncryptedUploadId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicCustomPayoutsSetupCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicListEncryptedUploadId?: Maybe<SortOrder>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicCustomPayoutsSetupCreateInput = {
  clinic: ClinicCreateNestedOneWithoutClinicCustomPayoutsSetupInput;
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUploadCreateNestedOneWithoutClinicListCustomPayoutsConnectionsInput>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUploadCreateNestedOneWithoutClinicRepresentativeCustomPayoutsConnectionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupCreateManyClinicListEncryptedUploadInput = {
  clinicId: Scalars['String'];
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupCreateManyClinicListEncryptedUploadInputEnvelope = {
  data: Array<ClinicCustomPayoutsSetupCreateManyClinicListEncryptedUploadInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicCustomPayoutsSetupCreateManyClinicRepresentativeInfoEncryptedUploadInput = {
  clinicId: Scalars['String'];
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupCreateManyClinicRepresentativeInfoEncryptedUploadInputEnvelope = {
  data: Array<ClinicCustomPayoutsSetupCreateManyClinicRepresentativeInfoEncryptedUploadInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicCustomPayoutsSetupCreateManyInput = {
  clinicId: Scalars['String'];
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupCreateNestedManyWithoutClinicListEncryptedUploadInput = {
  connect?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicListEncryptedUploadInput>>;
  create?: Maybe<Array<ClinicCustomPayoutsSetupCreateWithoutClinicListEncryptedUploadInput>>;
  createMany?: Maybe<ClinicCustomPayoutsSetupCreateManyClinicListEncryptedUploadInputEnvelope>;
};

export type ClinicCustomPayoutsSetupCreateNestedManyWithoutClinicRepresentativeInfoEncryptedUploadInput = {
  connect?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
  create?: Maybe<Array<ClinicCustomPayoutsSetupCreateWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
  createMany?: Maybe<ClinicCustomPayoutsSetupCreateManyClinicRepresentativeInfoEncryptedUploadInputEnvelope>;
};

export type ClinicCustomPayoutsSetupCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<ClinicCustomPayoutsSetupWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicInput>;
  create?: Maybe<ClinicCustomPayoutsSetupCreateWithoutClinicInput>;
};

export type ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicInput = {
  create: ClinicCustomPayoutsSetupCreateWithoutClinicInput;
  where: ClinicCustomPayoutsSetupWhereUniqueInput;
};

export type ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicListEncryptedUploadInput = {
  create: ClinicCustomPayoutsSetupCreateWithoutClinicListEncryptedUploadInput;
  where: ClinicCustomPayoutsSetupWhereUniqueInput;
};

export type ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicRepresentativeInfoEncryptedUploadInput = {
  create: ClinicCustomPayoutsSetupCreateWithoutClinicRepresentativeInfoEncryptedUploadInput;
  where: ClinicCustomPayoutsSetupWhereUniqueInput;
};

export type ClinicCustomPayoutsSetupCreateWithoutClinicInput = {
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUploadCreateNestedOneWithoutClinicListCustomPayoutsConnectionsInput>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUploadCreateNestedOneWithoutClinicRepresentativeCustomPayoutsConnectionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupCreateWithoutClinicListEncryptedUploadInput = {
  clinic: ClinicCreateNestedOneWithoutClinicCustomPayoutsSetupInput;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUploadCreateNestedOneWithoutClinicRepresentativeCustomPayoutsConnectionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupCreateWithoutClinicRepresentativeInfoEncryptedUploadInput = {
  clinic: ClinicCreateNestedOneWithoutClinicCustomPayoutsSetupInput;
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUploadCreateNestedOneWithoutClinicListCustomPayoutsConnectionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupGroupByOutputType = {
  __typename?: 'ClinicCustomPayoutsSetupGroupByOutputType';
  _count?: Maybe<ClinicCustomPayoutsSetupCountAggregateOutputType>;
  _max?: Maybe<ClinicCustomPayoutsSetupMaxAggregateOutputType>;
  _min?: Maybe<ClinicCustomPayoutsSetupMinAggregateOutputType>;
  clinicId: Scalars['String'];
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  status: ClinicCustomPayoutsSetupStatus;
  updatedAt: Scalars['DateTime'];
};

export type ClinicCustomPayoutsSetupListRelationFilter = {
  every?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
  none?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
  some?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
};

export type ClinicCustomPayoutsSetupMaxAggregateOutputType = {
  __typename?: 'ClinicCustomPayoutsSetupMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicListEncryptedUploadId?: Maybe<SortOrder>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicCustomPayoutsSetupMinAggregateOutputType = {
  __typename?: 'ClinicCustomPayoutsSetupMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicListEncryptedUploadId?: Maybe<SortOrder>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicCustomPayoutsSetupNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicCustomPayoutsSetupWhereInput>>;
  NOT?: Maybe<Array<ClinicCustomPayoutsSetupWhereInput>>;
  OR?: Maybe<Array<ClinicCustomPayoutsSetupWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUploadNullableScalarRelationFilter>;
  clinicListEncryptedUploadId?: Maybe<StringNullableFilter>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUploadNullableScalarRelationFilter>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumClinicCustomPayoutsSetupStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicCustomPayoutsSetupOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicCustomPayoutsSetupOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicCustomPayoutsSetupOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUploadOrderByWithRelationInput>;
  clinicListEncryptedUploadId?: Maybe<SortOrder>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUploadOrderByWithRelationInput>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicCustomPayoutsSetupOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  ClinicListEncryptedUploadId = 'clinicListEncryptedUploadId',
  ClinicRepresentativeInfoEncryptedUploadId = 'clinicRepresentativeInfoEncryptedUploadId',
  Id = 'id'
}

export type ClinicCustomPayoutsSetupOrderByRelevanceInput = {
  fields: Array<ClinicCustomPayoutsSetupOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicCustomPayoutsSetupOrderByWithAggregationInput = {
  _count?: Maybe<ClinicCustomPayoutsSetupCountOrderByAggregateInput>;
  _max?: Maybe<ClinicCustomPayoutsSetupMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicCustomPayoutsSetupMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicListEncryptedUploadId?: Maybe<SortOrder>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicCustomPayoutsSetupOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicCustomPayoutsSetupOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUploadOrderByWithRelationInput>;
  clinicListEncryptedUploadId?: Maybe<SortOrder>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUploadOrderByWithRelationInput>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicCustomPayoutsSetupOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicCustomPayoutsSetupOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUploadOrderByWithRelationInput>;
  clinicListEncryptedUploadId?: Maybe<SortOrder>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUploadOrderByWithRelationInput>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicCustomPayoutsSetupScalarFieldEnum {
  ClinicId = 'clinicId',
  ClinicListEncryptedUploadId = 'clinicListEncryptedUploadId',
  ClinicRepresentativeInfoEncryptedUploadId = 'clinicRepresentativeInfoEncryptedUploadId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type ClinicCustomPayoutsSetupScalarWhereInput = {
  AND?: Maybe<Array<ClinicCustomPayoutsSetupScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicCustomPayoutsSetupScalarWhereInput>>;
  OR?: Maybe<Array<ClinicCustomPayoutsSetupScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  clinicListEncryptedUploadId?: Maybe<StringNullableFilter>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumClinicCustomPayoutsSetupStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicCustomPayoutsSetupScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicCustomPayoutsSetupScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicCustomPayoutsSetupScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicCustomPayoutsSetupScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  clinicListEncryptedUploadId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumClinicCustomPayoutsSetupStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum ClinicCustomPayoutsSetupStatus {
  Complete = 'Complete',
  Pending = 'Pending',
  RequirementsNeeded = 'RequirementsNeeded'
}

export type ClinicCustomPayoutsSetupUncheckedCreateInput = {
  clinicId: Scalars['String'];
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUncheckedCreateNestedManyWithoutClinicListEncryptedUploadInput = {
  connect?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicListEncryptedUploadInput>>;
  create?: Maybe<Array<ClinicCustomPayoutsSetupCreateWithoutClinicListEncryptedUploadInput>>;
  createMany?: Maybe<ClinicCustomPayoutsSetupCreateManyClinicListEncryptedUploadInputEnvelope>;
};

export type ClinicCustomPayoutsSetupUncheckedCreateNestedManyWithoutClinicRepresentativeInfoEncryptedUploadInput = {
  connect?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
  create?: Maybe<Array<ClinicCustomPayoutsSetupCreateWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
  createMany?: Maybe<ClinicCustomPayoutsSetupCreateManyClinicRepresentativeInfoEncryptedUploadInputEnvelope>;
};

export type ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<ClinicCustomPayoutsSetupWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicInput>;
  create?: Maybe<ClinicCustomPayoutsSetupCreateWithoutClinicInput>;
};

export type ClinicCustomPayoutsSetupUncheckedCreateWithoutClinicInput = {
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUncheckedCreateWithoutClinicListEncryptedUploadInput = {
  clinicId: Scalars['String'];
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUncheckedCreateWithoutClinicRepresentativeInfoEncryptedUploadInput = {
  clinicId: Scalars['String'];
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicListEncryptedUploadInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicListEncryptedUploadNestedInput = {
  connect?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicListEncryptedUploadInput>>;
  create?: Maybe<Array<ClinicCustomPayoutsSetupCreateWithoutClinicListEncryptedUploadInput>>;
  createMany?: Maybe<ClinicCustomPayoutsSetupCreateManyClinicListEncryptedUploadInputEnvelope>;
  delete?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicCustomPayoutsSetupScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  set?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  update?: Maybe<Array<ClinicCustomPayoutsSetupUpdateWithWhereUniqueWithoutClinicListEncryptedUploadInput>>;
  updateMany?: Maybe<Array<ClinicCustomPayoutsSetupUpdateManyWithWhereWithoutClinicListEncryptedUploadInput>>;
  upsert?: Maybe<Array<ClinicCustomPayoutsSetupUpsertWithWhereUniqueWithoutClinicListEncryptedUploadInput>>;
};

export type ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadNestedInput = {
  connect?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
  create?: Maybe<Array<ClinicCustomPayoutsSetupCreateWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
  createMany?: Maybe<ClinicCustomPayoutsSetupCreateManyClinicRepresentativeInfoEncryptedUploadInputEnvelope>;
  delete?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicCustomPayoutsSetupScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  set?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  update?: Maybe<Array<ClinicCustomPayoutsSetupUpdateWithWhereUniqueWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
  updateMany?: Maybe<Array<ClinicCustomPayoutsSetupUpdateManyWithWhereWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
  upsert?: Maybe<Array<ClinicCustomPayoutsSetupUpsertWithWhereUniqueWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
};

export type ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<ClinicCustomPayoutsSetupWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicInput>;
  create?: Maybe<ClinicCustomPayoutsSetupCreateWithoutClinicInput>;
  delete?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
  disconnect?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
  update?: Maybe<ClinicCustomPayoutsSetupUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<ClinicCustomPayoutsSetupUpsertWithoutClinicInput>;
};

export type ClinicCustomPayoutsSetupUncheckedUpdateWithoutClinicInput = {
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUncheckedUpdateWithoutClinicListEncryptedUploadInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUncheckedUpdateWithoutClinicRepresentativeInfoEncryptedUploadInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicCustomPayoutsSetupNestedInput>;
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUploadUpdateOneWithoutClinicListCustomPayoutsConnectionsNestedInput>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUploadUpdateOneWithoutClinicRepresentativeCustomPayoutsConnectionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUpdateManyWithWhereWithoutClinicListEncryptedUploadInput = {
  data: ClinicCustomPayoutsSetupUpdateManyMutationInput;
  where: ClinicCustomPayoutsSetupScalarWhereInput;
};

export type ClinicCustomPayoutsSetupUpdateManyWithWhereWithoutClinicRepresentativeInfoEncryptedUploadInput = {
  data: ClinicCustomPayoutsSetupUpdateManyMutationInput;
  where: ClinicCustomPayoutsSetupScalarWhereInput;
};

export type ClinicCustomPayoutsSetupUpdateManyWithoutClinicListEncryptedUploadNestedInput = {
  connect?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicListEncryptedUploadInput>>;
  create?: Maybe<Array<ClinicCustomPayoutsSetupCreateWithoutClinicListEncryptedUploadInput>>;
  createMany?: Maybe<ClinicCustomPayoutsSetupCreateManyClinicListEncryptedUploadInputEnvelope>;
  delete?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicCustomPayoutsSetupScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  set?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  update?: Maybe<Array<ClinicCustomPayoutsSetupUpdateWithWhereUniqueWithoutClinicListEncryptedUploadInput>>;
  updateMany?: Maybe<Array<ClinicCustomPayoutsSetupUpdateManyWithWhereWithoutClinicListEncryptedUploadInput>>;
  upsert?: Maybe<Array<ClinicCustomPayoutsSetupUpsertWithWhereUniqueWithoutClinicListEncryptedUploadInput>>;
};

export type ClinicCustomPayoutsSetupUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadNestedInput = {
  connect?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
  create?: Maybe<Array<ClinicCustomPayoutsSetupCreateWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
  createMany?: Maybe<ClinicCustomPayoutsSetupCreateManyClinicRepresentativeInfoEncryptedUploadInputEnvelope>;
  delete?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicCustomPayoutsSetupScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  set?: Maybe<Array<ClinicCustomPayoutsSetupWhereUniqueInput>>;
  update?: Maybe<Array<ClinicCustomPayoutsSetupUpdateWithWhereUniqueWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
  updateMany?: Maybe<Array<ClinicCustomPayoutsSetupUpdateManyWithWhereWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
  upsert?: Maybe<Array<ClinicCustomPayoutsSetupUpsertWithWhereUniqueWithoutClinicRepresentativeInfoEncryptedUploadInput>>;
};

export type ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<ClinicCustomPayoutsSetupWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCustomPayoutsSetupCreateOrConnectWithoutClinicInput>;
  create?: Maybe<ClinicCustomPayoutsSetupCreateWithoutClinicInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicCustomPayoutsSetupUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<ClinicCustomPayoutsSetupUpsertWithoutClinicInput>;
};

export type ClinicCustomPayoutsSetupUpdateToOneWithWhereWithoutClinicInput = {
  data: ClinicCustomPayoutsSetupUpdateWithoutClinicInput;
  where?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
};

export type ClinicCustomPayoutsSetupUpdateWithWhereUniqueWithoutClinicListEncryptedUploadInput = {
  data: ClinicCustomPayoutsSetupUpdateWithoutClinicListEncryptedUploadInput;
  where: ClinicCustomPayoutsSetupWhereUniqueInput;
};

export type ClinicCustomPayoutsSetupUpdateWithWhereUniqueWithoutClinicRepresentativeInfoEncryptedUploadInput = {
  data: ClinicCustomPayoutsSetupUpdateWithoutClinicRepresentativeInfoEncryptedUploadInput;
  where: ClinicCustomPayoutsSetupWhereUniqueInput;
};

export type ClinicCustomPayoutsSetupUpdateWithoutClinicInput = {
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUploadUpdateOneWithoutClinicListCustomPayoutsConnectionsNestedInput>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUploadUpdateOneWithoutClinicRepresentativeCustomPayoutsConnectionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUpdateWithoutClinicListEncryptedUploadInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicCustomPayoutsSetupNestedInput>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUploadUpdateOneWithoutClinicRepresentativeCustomPayoutsConnectionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUpdateWithoutClinicRepresentativeInfoEncryptedUploadInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicCustomPayoutsSetupNestedInput>;
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUploadUpdateOneWithoutClinicListCustomPayoutsConnectionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ClinicCustomPayoutsSetupStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicCustomPayoutsSetupUpsertWithWhereUniqueWithoutClinicListEncryptedUploadInput = {
  create: ClinicCustomPayoutsSetupCreateWithoutClinicListEncryptedUploadInput;
  update: ClinicCustomPayoutsSetupUpdateWithoutClinicListEncryptedUploadInput;
  where: ClinicCustomPayoutsSetupWhereUniqueInput;
};

export type ClinicCustomPayoutsSetupUpsertWithWhereUniqueWithoutClinicRepresentativeInfoEncryptedUploadInput = {
  create: ClinicCustomPayoutsSetupCreateWithoutClinicRepresentativeInfoEncryptedUploadInput;
  update: ClinicCustomPayoutsSetupUpdateWithoutClinicRepresentativeInfoEncryptedUploadInput;
  where: ClinicCustomPayoutsSetupWhereUniqueInput;
};

export type ClinicCustomPayoutsSetupUpsertWithoutClinicInput = {
  create: ClinicCustomPayoutsSetupCreateWithoutClinicInput;
  update: ClinicCustomPayoutsSetupUpdateWithoutClinicInput;
  where?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
};

export type ClinicCustomPayoutsSetupWhereInput = {
  AND?: Maybe<Array<ClinicCustomPayoutsSetupWhereInput>>;
  NOT?: Maybe<Array<ClinicCustomPayoutsSetupWhereInput>>;
  OR?: Maybe<Array<ClinicCustomPayoutsSetupWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUploadNullableScalarRelationFilter>;
  clinicListEncryptedUploadId?: Maybe<StringNullableFilter>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUploadNullableScalarRelationFilter>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumClinicCustomPayoutsSetupStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicCustomPayoutsSetupWhereUniqueInput = {
  AND?: Maybe<Array<ClinicCustomPayoutsSetupWhereInput>>;
  NOT?: Maybe<Array<ClinicCustomPayoutsSetupWhereInput>>;
  OR?: Maybe<Array<ClinicCustomPayoutsSetupWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<Scalars['String']>;
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUploadNullableScalarRelationFilter>;
  clinicListEncryptedUploadId?: Maybe<StringNullableFilter>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUploadNullableScalarRelationFilter>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<EnumClinicCustomPayoutsSetupStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicDirectBookingSetting = {
  __typename?: 'ClinicDirectBookingSetting';
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation: Scalars['Boolean'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  exclusionRulesEnabled: Scalars['Boolean'];
  id: Scalars['String'];
  isOneTimePasswordEnabled: Scalars['Boolean'];
  isUrgentWarningEnabled: Scalars['Boolean'];
  /** @deprecated use maxTimeInAdvanceValue and maxTimeInAdvanceUnit instead */
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingAvgAggregateOutputType = {
  __typename?: 'ClinicDirectBookingSettingAvgAggregateOutputType';
  appointmentIntervalInMinutes?: Maybe<Scalars['Float']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Float']>;
  bookingDeadlineInHours?: Maybe<Scalars['Float']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Float']>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Float']>;
};

export type ClinicDirectBookingSettingAvgOrderByAggregateInput = {
  appointmentIntervalInMinutes?: Maybe<SortOrder>;
  appointmentIntervalInMinutesDisplay?: Maybe<SortOrder>;
  bookingDeadlineInHours?: Maybe<SortOrder>;
  maxSchedulingRangeInMonths?: Maybe<SortOrder>;
  maxTimeInAdvanceValue?: Maybe<SortOrder>;
};

export type ClinicDirectBookingSettingCountAggregateOutputType = {
  __typename?: 'ClinicDirectBookingSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentIntervalInMinutes: Scalars['Int'];
  appointmentIntervalInMinutesDisplay: Scalars['Int'];
  bookingDeadlineInHours: Scalars['Int'];
  bookingNeedsConfirmation: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  exclusionRulesEnabled: Scalars['Int'];
  id: Scalars['Int'];
  isOneTimePasswordEnabled: Scalars['Int'];
  isUrgentWarningEnabled: Scalars['Int'];
  maxSchedulingRangeInMonths: Scalars['Int'];
  maxTimeInAdvanceUnit: Scalars['Int'];
  maxTimeInAdvanceValue: Scalars['Int'];
  updatedAt: Scalars['Int'];
  urgentWarningKeywords: Scalars['Int'];
  urgentWarningMessage: Scalars['Int'];
};

export type ClinicDirectBookingSettingCountOrderByAggregateInput = {
  appointmentIntervalInMinutes?: Maybe<SortOrder>;
  appointmentIntervalInMinutesDisplay?: Maybe<SortOrder>;
  bookingDeadlineInHours?: Maybe<SortOrder>;
  bookingNeedsConfirmation?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exclusionRulesEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isOneTimePasswordEnabled?: Maybe<SortOrder>;
  isUrgentWarningEnabled?: Maybe<SortOrder>;
  maxSchedulingRangeInMonths?: Maybe<SortOrder>;
  maxTimeInAdvanceUnit?: Maybe<SortOrder>;
  maxTimeInAdvanceValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  urgentWarningKeywords?: Maybe<SortOrder>;
  urgentWarningMessage?: Maybe<SortOrder>;
};

export type ClinicDirectBookingSettingCreateInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  clinic: ClinicCreateNestedOneWithoutClinicDirectBookingSettingsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingCreateManyClinicInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingCreateManyClinicInputEnvelope = {
  data: Array<ClinicDirectBookingSettingCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicDirectBookingSettingCreateManyInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicDirectBookingSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicDirectBookingSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicDirectBookingSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicDirectBookingSettingCreateManyClinicInputEnvelope>;
};

export type ClinicDirectBookingSettingCreateOrConnectWithoutClinicInput = {
  create: ClinicDirectBookingSettingCreateWithoutClinicInput;
  where: ClinicDirectBookingSettingWhereUniqueInput;
};

export type ClinicDirectBookingSettingCreateWithoutClinicInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingGroupByOutputType = {
  __typename?: 'ClinicDirectBookingSettingGroupByOutputType';
  _avg?: Maybe<ClinicDirectBookingSettingAvgAggregateOutputType>;
  _count?: Maybe<ClinicDirectBookingSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicDirectBookingSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicDirectBookingSettingMinAggregateOutputType>;
  _sum?: Maybe<ClinicDirectBookingSettingSumAggregateOutputType>;
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation: Scalars['Boolean'];
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  exclusionRulesEnabled: Scalars['Boolean'];
  id: Scalars['String'];
  isOneTimePasswordEnabled: Scalars['Boolean'];
  isUrgentWarningEnabled: Scalars['Boolean'];
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingListRelationFilter = {
  every?: Maybe<ClinicDirectBookingSettingWhereInput>;
  none?: Maybe<ClinicDirectBookingSettingWhereInput>;
  some?: Maybe<ClinicDirectBookingSettingWhereInput>;
};

export type ClinicDirectBookingSettingMaxAggregateOutputType = {
  __typename?: 'ClinicDirectBookingSettingMaxAggregateOutputType';
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingMaxOrderByAggregateInput = {
  appointmentIntervalInMinutes?: Maybe<SortOrder>;
  appointmentIntervalInMinutesDisplay?: Maybe<SortOrder>;
  bookingDeadlineInHours?: Maybe<SortOrder>;
  bookingNeedsConfirmation?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exclusionRulesEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isOneTimePasswordEnabled?: Maybe<SortOrder>;
  isUrgentWarningEnabled?: Maybe<SortOrder>;
  maxSchedulingRangeInMonths?: Maybe<SortOrder>;
  maxTimeInAdvanceUnit?: Maybe<SortOrder>;
  maxTimeInAdvanceValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  urgentWarningKeywords?: Maybe<SortOrder>;
  urgentWarningMessage?: Maybe<SortOrder>;
};

export type ClinicDirectBookingSettingMinAggregateOutputType = {
  __typename?: 'ClinicDirectBookingSettingMinAggregateOutputType';
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingMinOrderByAggregateInput = {
  appointmentIntervalInMinutes?: Maybe<SortOrder>;
  appointmentIntervalInMinutesDisplay?: Maybe<SortOrder>;
  bookingDeadlineInHours?: Maybe<SortOrder>;
  bookingNeedsConfirmation?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exclusionRulesEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isOneTimePasswordEnabled?: Maybe<SortOrder>;
  isUrgentWarningEnabled?: Maybe<SortOrder>;
  maxSchedulingRangeInMonths?: Maybe<SortOrder>;
  maxTimeInAdvanceUnit?: Maybe<SortOrder>;
  maxTimeInAdvanceValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  urgentWarningKeywords?: Maybe<SortOrder>;
  urgentWarningMessage?: Maybe<SortOrder>;
};

export type ClinicDirectBookingSettingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicDirectBookingSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicDirectBookingSettingOrderByRelevanceInput>;
  appointmentIntervalInMinutes?: Maybe<SortOrder>;
  appointmentIntervalInMinutesDisplay?: Maybe<SortOrder>;
  bookingDeadlineInHours?: Maybe<SortOrder>;
  bookingNeedsConfirmation?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exclusionRulesEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isOneTimePasswordEnabled?: Maybe<SortOrder>;
  isUrgentWarningEnabled?: Maybe<SortOrder>;
  maxSchedulingRangeInMonths?: Maybe<SortOrder>;
  maxTimeInAdvanceUnit?: Maybe<SortOrder>;
  maxTimeInAdvanceValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  urgentWarningKeywords?: Maybe<SortOrder>;
  urgentWarningMessage?: Maybe<SortOrder>;
};

export enum ClinicDirectBookingSettingOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  UrgentWarningKeywords = 'urgentWarningKeywords',
  UrgentWarningMessage = 'urgentWarningMessage'
}

export type ClinicDirectBookingSettingOrderByRelevanceInput = {
  fields: Array<ClinicDirectBookingSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicDirectBookingSettingOrderByWithAggregationInput = {
  _avg?: Maybe<ClinicDirectBookingSettingAvgOrderByAggregateInput>;
  _count?: Maybe<ClinicDirectBookingSettingCountOrderByAggregateInput>;
  _max?: Maybe<ClinicDirectBookingSettingMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicDirectBookingSettingMinOrderByAggregateInput>;
  _sum?: Maybe<ClinicDirectBookingSettingSumOrderByAggregateInput>;
  appointmentIntervalInMinutes?: Maybe<SortOrder>;
  appointmentIntervalInMinutesDisplay?: Maybe<SortOrder>;
  bookingDeadlineInHours?: Maybe<SortOrder>;
  bookingNeedsConfirmation?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exclusionRulesEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isOneTimePasswordEnabled?: Maybe<SortOrder>;
  isUrgentWarningEnabled?: Maybe<SortOrder>;
  maxSchedulingRangeInMonths?: Maybe<SortOrder>;
  maxTimeInAdvanceUnit?: Maybe<SortOrder>;
  maxTimeInAdvanceValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  urgentWarningKeywords?: Maybe<SortOrder>;
  urgentWarningMessage?: Maybe<SortOrder>;
};

export type ClinicDirectBookingSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicDirectBookingSettingOrderByRelevanceInput>;
  appointmentIntervalInMinutes?: Maybe<SortOrder>;
  appointmentIntervalInMinutesDisplay?: Maybe<SortOrder>;
  bookingDeadlineInHours?: Maybe<SortOrder>;
  bookingNeedsConfirmation?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exclusionRulesEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isOneTimePasswordEnabled?: Maybe<SortOrder>;
  isUrgentWarningEnabled?: Maybe<SortOrder>;
  maxSchedulingRangeInMonths?: Maybe<SortOrder>;
  maxTimeInAdvanceUnit?: Maybe<SortOrder>;
  maxTimeInAdvanceValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  urgentWarningKeywords?: Maybe<SortOrder>;
  urgentWarningMessage?: Maybe<SortOrder>;
};

export type ClinicDirectBookingSettingOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicDirectBookingSettingOrderByRelevanceInput>;
  appointmentIntervalInMinutes?: Maybe<SortOrder>;
  appointmentIntervalInMinutesDisplay?: Maybe<SortOrder>;
  bookingDeadlineInHours?: Maybe<SortOrder>;
  bookingNeedsConfirmation?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  exclusionRulesEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isOneTimePasswordEnabled?: Maybe<SortOrder>;
  isUrgentWarningEnabled?: Maybe<SortOrder>;
  maxSchedulingRangeInMonths?: Maybe<SortOrder>;
  maxTimeInAdvanceUnit?: Maybe<SortOrder>;
  maxTimeInAdvanceValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  urgentWarningKeywords?: Maybe<SortOrder>;
  urgentWarningMessage?: Maybe<SortOrder>;
};

export enum ClinicDirectBookingSettingScalarFieldEnum {
  AppointmentIntervalInMinutes = 'appointmentIntervalInMinutes',
  AppointmentIntervalInMinutesDisplay = 'appointmentIntervalInMinutesDisplay',
  BookingDeadlineInHours = 'bookingDeadlineInHours',
  BookingNeedsConfirmation = 'bookingNeedsConfirmation',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  ExclusionRulesEnabled = 'exclusionRulesEnabled',
  Id = 'id',
  IsOneTimePasswordEnabled = 'isOneTimePasswordEnabled',
  IsUrgentWarningEnabled = 'isUrgentWarningEnabled',
  MaxSchedulingRangeInMonths = 'maxSchedulingRangeInMonths',
  MaxTimeInAdvanceUnit = 'maxTimeInAdvanceUnit',
  MaxTimeInAdvanceValue = 'maxTimeInAdvanceValue',
  UpdatedAt = 'updatedAt',
  UrgentWarningKeywords = 'urgentWarningKeywords',
  UrgentWarningMessage = 'urgentWarningMessage'
}

export type ClinicDirectBookingSettingScalarWhereInput = {
  AND?: Maybe<Array<ClinicDirectBookingSettingScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicDirectBookingSettingScalarWhereInput>>;
  OR?: Maybe<Array<ClinicDirectBookingSettingScalarWhereInput>>;
  appointmentIntervalInMinutes?: Maybe<IntNullableFilter>;
  appointmentIntervalInMinutesDisplay?: Maybe<IntNullableFilter>;
  bookingDeadlineInHours?: Maybe<IntNullableFilter>;
  bookingNeedsConfirmation?: Maybe<BoolFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  exclusionRulesEnabled?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  isOneTimePasswordEnabled?: Maybe<BoolFilter>;
  isUrgentWarningEnabled?: Maybe<BoolFilter>;
  maxSchedulingRangeInMonths?: Maybe<IntNullableFilter>;
  maxTimeInAdvanceUnit?: Maybe<EnumTimeUnitNullableFilter>;
  maxTimeInAdvanceValue?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  urgentWarningKeywords?: Maybe<StringNullableFilter>;
  urgentWarningMessage?: Maybe<StringNullableFilter>;
};

export type ClinicDirectBookingSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicDirectBookingSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicDirectBookingSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicDirectBookingSettingScalarWhereWithAggregatesInput>>;
  appointmentIntervalInMinutes?: Maybe<IntNullableWithAggregatesFilter>;
  appointmentIntervalInMinutesDisplay?: Maybe<IntNullableWithAggregatesFilter>;
  bookingDeadlineInHours?: Maybe<IntNullableWithAggregatesFilter>;
  bookingNeedsConfirmation?: Maybe<BoolWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  exclusionRulesEnabled?: Maybe<BoolWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isOneTimePasswordEnabled?: Maybe<BoolWithAggregatesFilter>;
  isUrgentWarningEnabled?: Maybe<BoolWithAggregatesFilter>;
  maxSchedulingRangeInMonths?: Maybe<IntNullableWithAggregatesFilter>;
  maxTimeInAdvanceUnit?: Maybe<EnumTimeUnitNullableWithAggregatesFilter>;
  maxTimeInAdvanceValue?: Maybe<IntNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  urgentWarningKeywords?: Maybe<StringNullableWithAggregatesFilter>;
  urgentWarningMessage?: Maybe<StringNullableWithAggregatesFilter>;
};

export type ClinicDirectBookingSettingSumAggregateOutputType = {
  __typename?: 'ClinicDirectBookingSettingSumAggregateOutputType';
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
};

export type ClinicDirectBookingSettingSumOrderByAggregateInput = {
  appointmentIntervalInMinutes?: Maybe<SortOrder>;
  appointmentIntervalInMinutesDisplay?: Maybe<SortOrder>;
  bookingDeadlineInHours?: Maybe<SortOrder>;
  maxSchedulingRangeInMonths?: Maybe<SortOrder>;
  maxTimeInAdvanceValue?: Maybe<SortOrder>;
};

export type ClinicDirectBookingSettingUncheckedCreateInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicDirectBookingSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicDirectBookingSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicDirectBookingSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicDirectBookingSettingCreateManyClinicInputEnvelope>;
};

export type ClinicDirectBookingSettingUncheckedCreateWithoutClinicInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingUncheckedUpdateInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingUncheckedUpdateManyInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicDirectBookingSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicDirectBookingSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicDirectBookingSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicDirectBookingSettingCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicDirectBookingSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicDirectBookingSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicDirectBookingSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicDirectBookingSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicDirectBookingSettingUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicDirectBookingSettingUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicDirectBookingSettingUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicDirectBookingSettingUncheckedUpdateWithoutClinicInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingUpdateInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicDirectBookingSettingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingUpdateManyMutationInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicDirectBookingSettingUpdateManyMutationInput;
  where: ClinicDirectBookingSettingScalarWhereInput;
};

export type ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicDirectBookingSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicDirectBookingSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicDirectBookingSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicDirectBookingSettingCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicDirectBookingSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicDirectBookingSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicDirectBookingSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicDirectBookingSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicDirectBookingSettingUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicDirectBookingSettingUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicDirectBookingSettingUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicDirectBookingSettingUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicDirectBookingSettingUpdateWithoutClinicInput;
  where: ClinicDirectBookingSettingWhereUniqueInput;
};

export type ClinicDirectBookingSettingUpdateWithoutClinicInput = {
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicDirectBookingSettingUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicDirectBookingSettingCreateWithoutClinicInput;
  update: ClinicDirectBookingSettingUpdateWithoutClinicInput;
  where: ClinicDirectBookingSettingWhereUniqueInput;
};

export type ClinicDirectBookingSettingWhereInput = {
  AND?: Maybe<Array<ClinicDirectBookingSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicDirectBookingSettingWhereInput>>;
  OR?: Maybe<Array<ClinicDirectBookingSettingWhereInput>>;
  appointmentIntervalInMinutes?: Maybe<IntNullableFilter>;
  appointmentIntervalInMinutesDisplay?: Maybe<IntNullableFilter>;
  bookingDeadlineInHours?: Maybe<IntNullableFilter>;
  bookingNeedsConfirmation?: Maybe<BoolFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  exclusionRulesEnabled?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  isOneTimePasswordEnabled?: Maybe<BoolFilter>;
  isUrgentWarningEnabled?: Maybe<BoolFilter>;
  maxSchedulingRangeInMonths?: Maybe<IntNullableFilter>;
  maxTimeInAdvanceUnit?: Maybe<EnumTimeUnitNullableFilter>;
  maxTimeInAdvanceValue?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  urgentWarningKeywords?: Maybe<StringNullableFilter>;
  urgentWarningMessage?: Maybe<StringNullableFilter>;
};

export type ClinicDirectBookingSettingWhereUniqueInput = {
  AND?: Maybe<Array<ClinicDirectBookingSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicDirectBookingSettingWhereInput>>;
  OR?: Maybe<Array<ClinicDirectBookingSettingWhereInput>>;
  appointmentIntervalInMinutes?: Maybe<IntNullableFilter>;
  appointmentIntervalInMinutesDisplay?: Maybe<IntNullableFilter>;
  bookingDeadlineInHours?: Maybe<IntNullableFilter>;
  bookingNeedsConfirmation?: Maybe<BoolFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  exclusionRulesEnabled?: Maybe<BoolFilter>;
  id?: Maybe<Scalars['String']>;
  isOneTimePasswordEnabled?: Maybe<BoolFilter>;
  isUrgentWarningEnabled?: Maybe<BoolFilter>;
  maxSchedulingRangeInMonths?: Maybe<IntNullableFilter>;
  maxTimeInAdvanceUnit?: Maybe<EnumTimeUnitNullableFilter>;
  maxTimeInAdvanceValue?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  urgentWarningKeywords?: Maybe<StringNullableFilter>;
  urgentWarningMessage?: Maybe<StringNullableFilter>;
};

export type ClinicDirectBookingSettingsInput = {
  clinicId: Scalars['String'];
};

export type ClinicDirectBookingSettingsResponse = {
  __typename?: 'ClinicDirectBookingSettingsResponse';
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation?: Maybe<Scalars['Boolean']>;
  exclusionRulesEnabled?: Maybe<Scalars['Boolean']>;
  isOneTimePasswordEnabled?: Maybe<Scalars['Boolean']>;
  isUrgentWarningEnabled?: Maybe<Scalars['Boolean']>;
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type ClinicEmailCampaignSetting = {
  __typename?: 'ClinicEmailCampaignSetting';
  accountId: Scalars['String'];
  careUrlFieldId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  contactListId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  petSpeciesTypeFieldId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userGroupId: Scalars['String'];
};

export type ClinicEmailCampaignSettingCountAggregateOutputType = {
  __typename?: 'ClinicEmailCampaignSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  accountId: Scalars['Int'];
  careUrlFieldId: Scalars['Int'];
  clinicId: Scalars['Int'];
  contactListId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  petSpeciesTypeFieldId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userGroupId: Scalars['Int'];
};

export type ClinicEmailCampaignSettingCountOrderByAggregateInput = {
  accountId?: Maybe<SortOrder>;
  careUrlFieldId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  contactListId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petSpeciesTypeFieldId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGroupId?: Maybe<SortOrder>;
};

export type ClinicEmailCampaignSettingCreateInput = {
  accountId: Scalars['String'];
  careUrlFieldId?: Maybe<Scalars['String']>;
  clinic: ClinicCreateNestedOneWithoutClinicEmailCampaignSettingsInput;
  contactListId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId: Scalars['String'];
};

export type ClinicEmailCampaignSettingCreateManyClinicInput = {
  accountId: Scalars['String'];
  careUrlFieldId?: Maybe<Scalars['String']>;
  contactListId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId: Scalars['String'];
};

export type ClinicEmailCampaignSettingCreateManyClinicInputEnvelope = {
  data: Array<ClinicEmailCampaignSettingCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicEmailCampaignSettingCreateManyInput = {
  accountId: Scalars['String'];
  careUrlFieldId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  contactListId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId: Scalars['String'];
};

export type ClinicEmailCampaignSettingCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicEmailCampaignSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmailCampaignSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicEmailCampaignSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicEmailCampaignSettingCreateManyClinicInputEnvelope>;
};

export type ClinicEmailCampaignSettingCreateOrConnectWithoutClinicInput = {
  create: ClinicEmailCampaignSettingCreateWithoutClinicInput;
  where: ClinicEmailCampaignSettingWhereUniqueInput;
};

export type ClinicEmailCampaignSettingCreateWithoutClinicInput = {
  accountId: Scalars['String'];
  careUrlFieldId?: Maybe<Scalars['String']>;
  contactListId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId: Scalars['String'];
};

export type ClinicEmailCampaignSettingGroupByOutputType = {
  __typename?: 'ClinicEmailCampaignSettingGroupByOutputType';
  _count?: Maybe<ClinicEmailCampaignSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicEmailCampaignSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicEmailCampaignSettingMinAggregateOutputType>;
  accountId: Scalars['String'];
  careUrlFieldId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  contactListId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  petSpeciesTypeFieldId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userGroupId: Scalars['String'];
};

export type ClinicEmailCampaignSettingListRelationFilter = {
  every?: Maybe<ClinicEmailCampaignSettingWhereInput>;
  none?: Maybe<ClinicEmailCampaignSettingWhereInput>;
  some?: Maybe<ClinicEmailCampaignSettingWhereInput>;
};

export type ClinicEmailCampaignSettingMaxAggregateOutputType = {
  __typename?: 'ClinicEmailCampaignSettingMaxAggregateOutputType';
  accountId?: Maybe<Scalars['String']>;
  careUrlFieldId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  contactListId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId?: Maybe<Scalars['String']>;
};

export type ClinicEmailCampaignSettingMaxOrderByAggregateInput = {
  accountId?: Maybe<SortOrder>;
  careUrlFieldId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  contactListId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petSpeciesTypeFieldId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGroupId?: Maybe<SortOrder>;
};

export type ClinicEmailCampaignSettingMinAggregateOutputType = {
  __typename?: 'ClinicEmailCampaignSettingMinAggregateOutputType';
  accountId?: Maybe<Scalars['String']>;
  careUrlFieldId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  contactListId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId?: Maybe<Scalars['String']>;
};

export type ClinicEmailCampaignSettingMinOrderByAggregateInput = {
  accountId?: Maybe<SortOrder>;
  careUrlFieldId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  contactListId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petSpeciesTypeFieldId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGroupId?: Maybe<SortOrder>;
};

export type ClinicEmailCampaignSettingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicEmailCampaignSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicEmailCampaignSettingOrderByRelevanceInput>;
  accountId?: Maybe<SortOrder>;
  careUrlFieldId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  contactListId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petSpeciesTypeFieldId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGroupId?: Maybe<SortOrder>;
};

export enum ClinicEmailCampaignSettingOrderByRelevanceFieldEnum {
  AccountId = 'accountId',
  CareUrlFieldId = 'careUrlFieldId',
  ClinicId = 'clinicId',
  ContactListId = 'contactListId',
  Id = 'id',
  PetSpeciesTypeFieldId = 'petSpeciesTypeFieldId',
  UserGroupId = 'userGroupId'
}

export type ClinicEmailCampaignSettingOrderByRelevanceInput = {
  fields: Array<ClinicEmailCampaignSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicEmailCampaignSettingOrderByWithAggregationInput = {
  _count?: Maybe<ClinicEmailCampaignSettingCountOrderByAggregateInput>;
  _max?: Maybe<ClinicEmailCampaignSettingMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicEmailCampaignSettingMinOrderByAggregateInput>;
  accountId?: Maybe<SortOrder>;
  careUrlFieldId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  contactListId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petSpeciesTypeFieldId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGroupId?: Maybe<SortOrder>;
};

export type ClinicEmailCampaignSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicEmailCampaignSettingOrderByRelevanceInput>;
  accountId?: Maybe<SortOrder>;
  careUrlFieldId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  contactListId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petSpeciesTypeFieldId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGroupId?: Maybe<SortOrder>;
};

export type ClinicEmailCampaignSettingOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicEmailCampaignSettingOrderByRelevanceInput>;
  accountId?: Maybe<SortOrder>;
  careUrlFieldId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  contactListId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petSpeciesTypeFieldId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGroupId?: Maybe<SortOrder>;
};

export enum ClinicEmailCampaignSettingScalarFieldEnum {
  AccountId = 'accountId',
  CareUrlFieldId = 'careUrlFieldId',
  ClinicId = 'clinicId',
  ContactListId = 'contactListId',
  CreatedAt = 'createdAt',
  Id = 'id',
  PetSpeciesTypeFieldId = 'petSpeciesTypeFieldId',
  UpdatedAt = 'updatedAt',
  UserGroupId = 'userGroupId'
}

export type ClinicEmailCampaignSettingScalarWhereInput = {
  AND?: Maybe<Array<ClinicEmailCampaignSettingScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicEmailCampaignSettingScalarWhereInput>>;
  OR?: Maybe<Array<ClinicEmailCampaignSettingScalarWhereInput>>;
  accountId?: Maybe<StringFilter>;
  careUrlFieldId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  contactListId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  petSpeciesTypeFieldId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userGroupId?: Maybe<StringFilter>;
};

export type ClinicEmailCampaignSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicEmailCampaignSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicEmailCampaignSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicEmailCampaignSettingScalarWhereWithAggregatesInput>>;
  accountId?: Maybe<StringWithAggregatesFilter>;
  careUrlFieldId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  contactListId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  petSpeciesTypeFieldId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userGroupId?: Maybe<StringWithAggregatesFilter>;
};

export type ClinicEmailCampaignSettingUncheckedCreateInput = {
  accountId: Scalars['String'];
  careUrlFieldId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  contactListId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId: Scalars['String'];
};

export type ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicEmailCampaignSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmailCampaignSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicEmailCampaignSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicEmailCampaignSettingCreateManyClinicInputEnvelope>;
};

export type ClinicEmailCampaignSettingUncheckedCreateWithoutClinicInput = {
  accountId: Scalars['String'];
  careUrlFieldId?: Maybe<Scalars['String']>;
  contactListId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId: Scalars['String'];
};

export type ClinicEmailCampaignSettingUncheckedUpdateInput = {
  accountId?: Maybe<Scalars['String']>;
  careUrlFieldId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  contactListId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId?: Maybe<Scalars['String']>;
};

export type ClinicEmailCampaignSettingUncheckedUpdateManyInput = {
  accountId?: Maybe<Scalars['String']>;
  careUrlFieldId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  contactListId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId?: Maybe<Scalars['String']>;
};

export type ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicInput = {
  accountId?: Maybe<Scalars['String']>;
  careUrlFieldId?: Maybe<Scalars['String']>;
  contactListId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId?: Maybe<Scalars['String']>;
};

export type ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicEmailCampaignSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmailCampaignSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicEmailCampaignSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicEmailCampaignSettingCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicEmailCampaignSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmailCampaignSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmailCampaignSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmailCampaignSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmailCampaignSettingUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicEmailCampaignSettingUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicEmailCampaignSettingUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicEmailCampaignSettingUncheckedUpdateWithoutClinicInput = {
  accountId?: Maybe<Scalars['String']>;
  careUrlFieldId?: Maybe<Scalars['String']>;
  contactListId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId?: Maybe<Scalars['String']>;
};

export type ClinicEmailCampaignSettingUpdateInput = {
  accountId?: Maybe<Scalars['String']>;
  careUrlFieldId?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicEmailCampaignSettingsNestedInput>;
  contactListId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId?: Maybe<Scalars['String']>;
};

export type ClinicEmailCampaignSettingUpdateManyMutationInput = {
  accountId?: Maybe<Scalars['String']>;
  careUrlFieldId?: Maybe<Scalars['String']>;
  contactListId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId?: Maybe<Scalars['String']>;
};

export type ClinicEmailCampaignSettingUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicEmailCampaignSettingUpdateManyMutationInput;
  where: ClinicEmailCampaignSettingScalarWhereInput;
};

export type ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicEmailCampaignSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmailCampaignSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicEmailCampaignSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicEmailCampaignSettingCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicEmailCampaignSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmailCampaignSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmailCampaignSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmailCampaignSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmailCampaignSettingUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicEmailCampaignSettingUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicEmailCampaignSettingUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicEmailCampaignSettingUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicEmailCampaignSettingUpdateWithoutClinicInput;
  where: ClinicEmailCampaignSettingWhereUniqueInput;
};

export type ClinicEmailCampaignSettingUpdateWithoutClinicInput = {
  accountId?: Maybe<Scalars['String']>;
  careUrlFieldId?: Maybe<Scalars['String']>;
  contactListId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGroupId?: Maybe<Scalars['String']>;
};

export type ClinicEmailCampaignSettingUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicEmailCampaignSettingCreateWithoutClinicInput;
  update: ClinicEmailCampaignSettingUpdateWithoutClinicInput;
  where: ClinicEmailCampaignSettingWhereUniqueInput;
};

export type ClinicEmailCampaignSettingWhereInput = {
  AND?: Maybe<Array<ClinicEmailCampaignSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicEmailCampaignSettingWhereInput>>;
  OR?: Maybe<Array<ClinicEmailCampaignSettingWhereInput>>;
  accountId?: Maybe<StringFilter>;
  careUrlFieldId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  contactListId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  petSpeciesTypeFieldId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userGroupId?: Maybe<StringFilter>;
};

export type ClinicEmailCampaignSettingWhereUniqueInput = {
  AND?: Maybe<Array<ClinicEmailCampaignSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicEmailCampaignSettingWhereInput>>;
  OR?: Maybe<Array<ClinicEmailCampaignSettingWhereInput>>;
  accountId?: Maybe<StringFilter>;
  careUrlFieldId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  contactListId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  petSpeciesTypeFieldId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userGroupId?: Maybe<StringFilter>;
};

export type ClinicEmployee = {
  __typename?: 'ClinicEmployee';
  LabPanel: Array<LabPanel>;
  MedicalHistory: Array<MedicalHistory>;
  ProviderAppointmentTypeRoomMap: Array<ProviderAppointmentTypeRoomMap>;
  _count: ClinicEmployeeCountOutputType;
  appointmentAvailabilities: Array<AppointmentAvailability>;
  appointments: Array<Appointment>;
  bitwerxPaymentWritebackConfigurations: Array<BitwerxPaymentWritebackConfiguration>;
  clinic?: Maybe<Clinic>;
  clinicEmployeeAppointmentTypeSettings: Array<ClinicEmployeeAppointmentTypeSetting>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  directBookingExclusionRules: Array<DirectBookingExclusionRule>;
  enteredByInvoiceLineItems: Array<InvoiceLineItem>;
  firstName: Scalars['String'];
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions: Array<Prescription>;
  providerInvoiceLineItems: Array<InvoiceLineItem>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userAppointmentGroupings: Array<UserAppointmentGrouping>;
  vetAvailabilityMaps: Array<VetAvailabilityMap>;
  workflows: Array<ClinicEmployeeToWorkflowEventSetting>;
};


export type ClinicEmployeeLabPanelArgs = {
  cursor?: Maybe<LabPanelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LabPanelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LabPanelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabPanelWhereInput>;
};


export type ClinicEmployeeMedicalHistoryArgs = {
  cursor?: Maybe<MedicalHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MedicalHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MedicalHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MedicalHistoryWhereInput>;
};


export type ClinicEmployeeProviderAppointmentTypeRoomMapArgs = {
  cursor?: Maybe<ProviderAppointmentTypeRoomMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProviderAppointmentTypeRoomMapWhereInput>;
};


export type ClinicEmployeeAppointmentAvailabilitiesArgs = {
  cursor?: Maybe<AppointmentAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentAvailabilityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentAvailabilityWhereInput>;
};


export type ClinicEmployeeAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type ClinicEmployeeBitwerxPaymentWritebackConfigurationsArgs = {
  cursor?: Maybe<BitwerxPaymentWritebackConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
};


export type ClinicEmployeeClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type ClinicEmployeeClinicEmployeeAppointmentTypeSettingsArgs = {
  cursor?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeAppointmentTypeSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereInput>;
};


export type ClinicEmployeeDirectBookingExclusionRulesArgs = {
  cursor?: Maybe<DirectBookingExclusionRuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingExclusionRuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingExclusionRuleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingExclusionRuleWhereInput>;
};


export type ClinicEmployeeEnteredByInvoiceLineItemsArgs = {
  cursor?: Maybe<InvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceLineItemWhereInput>;
};


export type ClinicEmployeeIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type ClinicEmployeePrescriptionsArgs = {
  cursor?: Maybe<PrescriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PrescriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PrescriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PrescriptionWhereInput>;
};


export type ClinicEmployeeProviderInvoiceLineItemsArgs = {
  cursor?: Maybe<InvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceLineItemWhereInput>;
};


export type ClinicEmployeeUserAppointmentGroupingsArgs = {
  cursor?: Maybe<UserAppointmentGroupingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserAppointmentGroupingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserAppointmentGroupingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAppointmentGroupingWhereInput>;
};


export type ClinicEmployeeVetAvailabilityMapsArgs = {
  cursor?: Maybe<VetAvailabilityMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityMapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityMapWhereInput>;
};


export type ClinicEmployeeWorkflowsArgs = {
  cursor?: Maybe<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeToWorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeToWorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeToWorkflowEventSettingWhereInput>;
};

export type ClinicEmployeeAppointmentTypeSetting = {
  __typename?: 'ClinicEmployeeAppointmentTypeSetting';
  appointmentType: AppointmentType;
  appointmentTypeId: Scalars['String'];
  clinicEmployee: ClinicEmployee;
  clinicEmployeeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ClinicEmployeeAppointmentTypeSettingCountAggregateOutputType = {
  __typename?: 'ClinicEmployeeAppointmentTypeSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentTypeId: Scalars['Int'];
  clinicEmployeeId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicEmployeeAppointmentTypeSettingCountOrderByAggregateInput = {
  appointmentTypeId?: Maybe<SortOrder>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEmployeeAppointmentTypeSettingCreateInput = {
  appointmentType: AppointmentTypeCreateNestedOneWithoutClinicEmployeeAppointmentTypeSettingsInput;
  clinicEmployee: ClinicEmployeeCreateNestedOneWithoutClinicEmployeeAppointmentTypeSettingsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingCreateManyAppointmentTypeInput = {
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingCreateManyAppointmentTypeInputEnvelope = {
  data: Array<ClinicEmployeeAppointmentTypeSettingCreateManyAppointmentTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicEmployeeAppointmentTypeSettingCreateManyClinicEmployeeInput = {
  appointmentTypeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingCreateManyClinicEmployeeInputEnvelope = {
  data: Array<ClinicEmployeeAppointmentTypeSettingCreateManyClinicEmployeeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicEmployeeAppointmentTypeSettingCreateManyInput = {
  appointmentTypeId: Scalars['String'];
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput = {
  connect?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateManyAppointmentTypeInputEnvelope>;
};

export type ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateManyClinicEmployeeInputEnvelope>;
};

export type ClinicEmployeeAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput = {
  create: ClinicEmployeeAppointmentTypeSettingCreateWithoutAppointmentTypeInput;
  where: ClinicEmployeeAppointmentTypeSettingWhereUniqueInput;
};

export type ClinicEmployeeAppointmentTypeSettingCreateOrConnectWithoutClinicEmployeeInput = {
  create: ClinicEmployeeAppointmentTypeSettingCreateWithoutClinicEmployeeInput;
  where: ClinicEmployeeAppointmentTypeSettingWhereUniqueInput;
};

export type ClinicEmployeeAppointmentTypeSettingCreateWithoutAppointmentTypeInput = {
  clinicEmployee: ClinicEmployeeCreateNestedOneWithoutClinicEmployeeAppointmentTypeSettingsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingCreateWithoutClinicEmployeeInput = {
  appointmentType: AppointmentTypeCreateNestedOneWithoutClinicEmployeeAppointmentTypeSettingsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingGroupByOutputType = {
  __typename?: 'ClinicEmployeeAppointmentTypeSettingGroupByOutputType';
  _count?: Maybe<ClinicEmployeeAppointmentTypeSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicEmployeeAppointmentTypeSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicEmployeeAppointmentTypeSettingMinAggregateOutputType>;
  appointmentTypeId: Scalars['String'];
  clinicEmployeeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ClinicEmployeeAppointmentTypeSettingListRelationFilter = {
  every?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereInput>;
  none?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereInput>;
  some?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereInput>;
};

export type ClinicEmployeeAppointmentTypeSettingMaxAggregateOutputType = {
  __typename?: 'ClinicEmployeeAppointmentTypeSettingMaxAggregateOutputType';
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingMaxOrderByAggregateInput = {
  appointmentTypeId?: Maybe<SortOrder>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEmployeeAppointmentTypeSettingMinAggregateOutputType = {
  __typename?: 'ClinicEmployeeAppointmentTypeSettingMinAggregateOutputType';
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingMinOrderByAggregateInput = {
  appointmentTypeId?: Maybe<SortOrder>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEmployeeAppointmentTypeSettingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicEmployeeAppointmentTypeSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicEmployeeAppointmentTypeSettingOrderByRelevanceInput>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicEmployeeAppointmentTypeSettingOrderByRelevanceFieldEnum {
  AppointmentTypeId = 'appointmentTypeId',
  ClinicEmployeeId = 'clinicEmployeeId',
  Id = 'id'
}

export type ClinicEmployeeAppointmentTypeSettingOrderByRelevanceInput = {
  fields: Array<ClinicEmployeeAppointmentTypeSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicEmployeeAppointmentTypeSettingOrderByWithAggregationInput = {
  _count?: Maybe<ClinicEmployeeAppointmentTypeSettingCountOrderByAggregateInput>;
  _max?: Maybe<ClinicEmployeeAppointmentTypeSettingMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicEmployeeAppointmentTypeSettingMinOrderByAggregateInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEmployeeAppointmentTypeSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicEmployeeAppointmentTypeSettingOrderByRelevanceInput>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEmployeeAppointmentTypeSettingOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicEmployeeAppointmentTypeSettingOrderByRelevanceInput>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicEmployeeAppointmentTypeSettingScalarFieldEnum {
  AppointmentTypeId = 'appointmentTypeId',
  ClinicEmployeeId = 'clinicEmployeeId',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type ClinicEmployeeAppointmentTypeSettingScalarWhereInput = {
  AND?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingScalarWhereInput>>;
  OR?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingScalarWhereInput>>;
  appointmentTypeId?: Maybe<StringFilter>;
  clinicEmployeeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicEmployeeAppointmentTypeSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingScalarWhereWithAggregatesInput>>;
  appointmentTypeId?: Maybe<StringWithAggregatesFilter>;
  clinicEmployeeId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedCreateInput = {
  appointmentTypeId: Scalars['String'];
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput = {
  connect?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateManyAppointmentTypeInputEnvelope>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateManyClinicEmployeeInputEnvelope>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedCreateWithoutAppointmentTypeInput = {
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedCreateWithoutClinicEmployeeInput = {
  appointmentTypeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedUpdateInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateManyAppointmentTypeInputEnvelope>;
  delete?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingUpdateWithWhereUniqueWithoutAppointmentTypeInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingUpdateManyWithWhereWithoutAppointmentTypeInput>>;
  upsert?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingUpsertWithWhereUniqueWithoutAppointmentTypeInput>>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedUpdateWithoutAppointmentTypeInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUncheckedUpdateWithoutClinicEmployeeInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUpdateInput = {
  appointmentType?: Maybe<AppointmentTypeUpdateOneRequiredWithoutClinicEmployeeAppointmentTypeSettingsNestedInput>;
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneRequiredWithoutClinicEmployeeAppointmentTypeSettingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUpdateManyWithWhereWithoutAppointmentTypeInput = {
  data: ClinicEmployeeAppointmentTypeSettingUpdateManyMutationInput;
  where: ClinicEmployeeAppointmentTypeSettingScalarWhereInput;
};

export type ClinicEmployeeAppointmentTypeSettingUpdateManyWithWhereWithoutClinicEmployeeInput = {
  data: ClinicEmployeeAppointmentTypeSettingUpdateManyMutationInput;
  where: ClinicEmployeeAppointmentTypeSettingScalarWhereInput;
};

export type ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateManyAppointmentTypeInputEnvelope>;
  delete?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingUpdateWithWhereUniqueWithoutAppointmentTypeInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingUpdateManyWithWhereWithoutAppointmentTypeInput>>;
  upsert?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingUpsertWithWhereUniqueWithoutAppointmentTypeInput>>;
};

export type ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type ClinicEmployeeAppointmentTypeSettingUpdateWithWhereUniqueWithoutAppointmentTypeInput = {
  data: ClinicEmployeeAppointmentTypeSettingUpdateWithoutAppointmentTypeInput;
  where: ClinicEmployeeAppointmentTypeSettingWhereUniqueInput;
};

export type ClinicEmployeeAppointmentTypeSettingUpdateWithWhereUniqueWithoutClinicEmployeeInput = {
  data: ClinicEmployeeAppointmentTypeSettingUpdateWithoutClinicEmployeeInput;
  where: ClinicEmployeeAppointmentTypeSettingWhereUniqueInput;
};

export type ClinicEmployeeAppointmentTypeSettingUpdateWithoutAppointmentTypeInput = {
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneRequiredWithoutClinicEmployeeAppointmentTypeSettingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUpdateWithoutClinicEmployeeInput = {
  appointmentType?: Maybe<AppointmentTypeUpdateOneRequiredWithoutClinicEmployeeAppointmentTypeSettingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeAppointmentTypeSettingUpsertWithWhereUniqueWithoutAppointmentTypeInput = {
  create: ClinicEmployeeAppointmentTypeSettingCreateWithoutAppointmentTypeInput;
  update: ClinicEmployeeAppointmentTypeSettingUpdateWithoutAppointmentTypeInput;
  where: ClinicEmployeeAppointmentTypeSettingWhereUniqueInput;
};

export type ClinicEmployeeAppointmentTypeSettingUpsertWithWhereUniqueWithoutClinicEmployeeInput = {
  create: ClinicEmployeeAppointmentTypeSettingCreateWithoutClinicEmployeeInput;
  update: ClinicEmployeeAppointmentTypeSettingUpdateWithoutClinicEmployeeInput;
  where: ClinicEmployeeAppointmentTypeSettingWhereUniqueInput;
};

export type ClinicEmployeeAppointmentTypeSettingWhereInput = {
  AND?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereInput>>;
  OR?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereInput>>;
  appointmentType?: Maybe<AppointmentTypeScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringFilter>;
  clinicEmployee?: Maybe<ClinicEmployeeScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicEmployeeAppointmentTypeSettingWhereUniqueInput = {
  AND?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereInput>>;
  OR?: Maybe<Array<ClinicEmployeeAppointmentTypeSettingWhereInput>>;
  appointmentType?: Maybe<AppointmentTypeScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringFilter>;
  clinicEmployee?: Maybe<ClinicEmployeeScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicEmployeeClinicEmployeePimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type ClinicEmployeeCountAggregateOutputType = {
  __typename?: 'ClinicEmployeeCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  firstName: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  isDefaultExporter: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isSchedulable: Scalars['Int'];
  isVisible: Scalars['Int'];
  lastName: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  resourceUid: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicEmployeeCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDefaultExporter?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEmployeeCountOutputType = {
  __typename?: 'ClinicEmployeeCountOutputType';
  LabPanel: Scalars['Int'];
  MedicalHistory: Scalars['Int'];
  ProviderAppointmentTypeRoomMap: Scalars['Int'];
  appointmentAvailabilities: Scalars['Int'];
  appointments: Scalars['Int'];
  bitwerxPaymentWritebackConfigurations: Scalars['Int'];
  clinicEmployeeAppointmentTypeSettings: Scalars['Int'];
  directBookingExclusionRules: Scalars['Int'];
  enteredByInvoiceLineItems: Scalars['Int'];
  prescriptions: Scalars['Int'];
  providerInvoiceLineItems: Scalars['Int'];
  userAppointmentGroupings: Scalars['Int'];
  vetAvailabilityMaps: Scalars['Int'];
  workflows: Scalars['Int'];
};

export type ClinicEmployeeCreateInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeCreateManyClinicInputEnvelope = {
  data: Array<ClinicEmployeeCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicEmployeeCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeCreateManyIntegrationInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeCreateManyIntegrationInputEnvelope = {
  data: Array<ClinicEmployeeCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicEmployeeCreateNestedManyWithoutAppointmentsInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutAppointmentsInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutAppointmentsInput>>;
};

export type ClinicEmployeeCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicEmployeeCreateManyClinicInputEnvelope>;
};

export type ClinicEmployeeCreateNestedManyWithoutDirectBookingExclusionRulesInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutDirectBookingExclusionRulesInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutDirectBookingExclusionRulesInput>>;
};

export type ClinicEmployeeCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicEmployeeCreateManyIntegrationInputEnvelope>;
};

export type ClinicEmployeeCreateNestedManyWithoutUserAppointmentGroupingsInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutUserAppointmentGroupingsInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutUserAppointmentGroupingsInput>>;
};

export type ClinicEmployeeCreateNestedOneWithoutAppointmentAvailabilitiesInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutAppointmentAvailabilitiesInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutAppointmentAvailabilitiesInput>;
};

export type ClinicEmployeeCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutBitwerxPaymentWritebackConfigurationsInput>;
};

export type ClinicEmployeeCreateNestedOneWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutClinicEmployeeAppointmentTypeSettingsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutClinicEmployeeAppointmentTypeSettingsInput>;
};

export type ClinicEmployeeCreateNestedOneWithoutEnteredByInvoiceLineItemsInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutEnteredByInvoiceLineItemsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutEnteredByInvoiceLineItemsInput>;
};

export type ClinicEmployeeCreateNestedOneWithoutLabPanelInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutLabPanelInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutLabPanelInput>;
};

export type ClinicEmployeeCreateNestedOneWithoutMedicalHistoryInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutMedicalHistoryInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutMedicalHistoryInput>;
};

export type ClinicEmployeeCreateNestedOneWithoutPrescriptionsInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutPrescriptionsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutPrescriptionsInput>;
};

export type ClinicEmployeeCreateNestedOneWithoutProviderAppointmentTypeRoomMapInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutProviderAppointmentTypeRoomMapInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutProviderAppointmentTypeRoomMapInput>;
};

export type ClinicEmployeeCreateNestedOneWithoutProviderInvoiceLineItemsInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutProviderInvoiceLineItemsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutProviderInvoiceLineItemsInput>;
};

export type ClinicEmployeeCreateNestedOneWithoutVetAvailabilityMapsInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutVetAvailabilityMapsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutVetAvailabilityMapsInput>;
};

export type ClinicEmployeeCreateNestedOneWithoutWorkflowsInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutWorkflowsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutWorkflowsInput>;
};

export type ClinicEmployeeCreateOrConnectWithoutAppointmentAvailabilitiesInput = {
  create: ClinicEmployeeCreateWithoutAppointmentAvailabilitiesInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutAppointmentsInput = {
  create: ClinicEmployeeCreateWithoutAppointmentsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutBitwerxPaymentWritebackConfigurationsInput = {
  create: ClinicEmployeeCreateWithoutBitwerxPaymentWritebackConfigurationsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  create: ClinicEmployeeCreateWithoutClinicEmployeeAppointmentTypeSettingsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutClinicInput = {
  create: ClinicEmployeeCreateWithoutClinicInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutDirectBookingExclusionRulesInput = {
  create: ClinicEmployeeCreateWithoutDirectBookingExclusionRulesInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutEnteredByInvoiceLineItemsInput = {
  create: ClinicEmployeeCreateWithoutEnteredByInvoiceLineItemsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutIntegrationInput = {
  create: ClinicEmployeeCreateWithoutIntegrationInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutLabPanelInput = {
  create: ClinicEmployeeCreateWithoutLabPanelInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutMedicalHistoryInput = {
  create: ClinicEmployeeCreateWithoutMedicalHistoryInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutPrescriptionsInput = {
  create: ClinicEmployeeCreateWithoutPrescriptionsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutProviderAppointmentTypeRoomMapInput = {
  create: ClinicEmployeeCreateWithoutProviderAppointmentTypeRoomMapInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutProviderInvoiceLineItemsInput = {
  create: ClinicEmployeeCreateWithoutProviderInvoiceLineItemsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutUserAppointmentGroupingsInput = {
  create: ClinicEmployeeCreateWithoutUserAppointmentGroupingsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutVetAvailabilityMapsInput = {
  create: ClinicEmployeeCreateWithoutVetAvailabilityMapsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateOrConnectWithoutWorkflowsInput = {
  create: ClinicEmployeeCreateWithoutWorkflowsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeCreateWithoutAppointmentAvailabilitiesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutAppointmentsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutBitwerxPaymentWritebackConfigurationsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutClinicInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutDirectBookingExclusionRulesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutEnteredByInvoiceLineItemsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutIntegrationInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutLabPanelInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutMedicalHistoryInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutPrescriptionsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutProviderAppointmentTypeRoomMapInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutProviderInvoiceLineItemsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutUserAppointmentGroupingsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutVetAvailabilityMapsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeCreateWithoutWorkflowsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutEnteredByInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeGroupByOutputType = {
  __typename?: 'ClinicEmployeeGroupByOutputType';
  _count?: Maybe<ClinicEmployeeCountAggregateOutputType>;
  _max?: Maybe<ClinicEmployeeMaxAggregateOutputType>;
  _min?: Maybe<ClinicEmployeeMinAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ClinicEmployeeListRelationFilter = {
  every?: Maybe<ClinicEmployeeWhereInput>;
  none?: Maybe<ClinicEmployeeWhereInput>;
  some?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeMaxAggregateOutputType = {
  __typename?: 'ClinicEmployeeMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDefaultExporter?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEmployeeMinAggregateOutputType = {
  __typename?: 'ClinicEmployeeMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDefaultExporter?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEmployeeNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicEmployeeWhereInput>>;
  LabPanel?: Maybe<LabPanelListRelationFilter>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ClinicEmployeeWhereInput>>;
  OR?: Maybe<Array<ClinicEmployeeWhereInput>>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapListRelationFilter>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleListRelationFilter>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  firstName?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDefaultExporter?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isSchedulable?: Maybe<BoolNullableFilter>;
  isVisible?: Maybe<BoolNullableFilter>;
  lastName?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapListRelationFilter>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingListRelationFilter>;
};

export type ClinicEmployeeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicEmployeeOrderByRelationAndSearchRelevanceInput = {
  LabPanel?: Maybe<LabPanelOrderByRelationAggregateInput>;
  MedicalHistory?: Maybe<MedicalHistoryOrderByRelationAggregateInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicEmployeeOrderByRelevanceInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleOrderByRelationAggregateInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDefaultExporter?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  rawPimsValue?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapOrderByRelationAggregateInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum ClinicEmployeeOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  FirstName = 'firstName',
  Id = 'id',
  IntegrationId = 'integrationId',
  LastName = 'lastName',
  PimsId = 'pimsId',
  ResourceUid = 'resourceUid',
  Type = 'type'
}

export type ClinicEmployeeOrderByRelevanceInput = {
  fields: Array<ClinicEmployeeOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicEmployeeOrderByWithAggregationInput = {
  _count?: Maybe<ClinicEmployeeCountOrderByAggregateInput>;
  _max?: Maybe<ClinicEmployeeMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicEmployeeMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDefaultExporter?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEmployeeOrderByWithRelationAndSearchRelevanceInput = {
  LabPanel?: Maybe<LabPanelOrderByRelationAggregateInput>;
  MedicalHistory?: Maybe<MedicalHistoryOrderByRelationAggregateInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicEmployeeOrderByRelevanceInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleOrderByRelationAggregateInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDefaultExporter?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  rawPimsValue?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapOrderByRelationAggregateInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingOrderByRelationAggregateInput>;
};

export type ClinicEmployeeOrderByWithRelationInput = {
  LabPanel?: Maybe<LabPanelOrderByRelationAggregateInput>;
  MedicalHistory?: Maybe<MedicalHistoryOrderByRelationAggregateInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicEmployeeOrderByRelevanceInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleOrderByRelationAggregateInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDefaultExporter?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  rawPimsValue?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapOrderByRelationAggregateInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum ClinicEmployeeScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  FirstName = 'firstName',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  IsDefaultExporter = 'isDefaultExporter',
  IsDeleted = 'isDeleted',
  IsSchedulable = 'isSchedulable',
  IsVisible = 'isVisible',
  LastName = 'lastName',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  ResourceUid = 'resourceUid',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type ClinicEmployeeScalarRelationFilter = {
  AND?: Maybe<Array<ClinicEmployeeWhereInput>>;
  LabPanel?: Maybe<LabPanelListRelationFilter>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ClinicEmployeeWhereInput>>;
  OR?: Maybe<Array<ClinicEmployeeWhereInput>>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapListRelationFilter>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleListRelationFilter>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  firstName?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDefaultExporter?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isSchedulable?: Maybe<BoolNullableFilter>;
  isVisible?: Maybe<BoolNullableFilter>;
  lastName?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapListRelationFilter>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingListRelationFilter>;
};

export type ClinicEmployeeScalarWhereInput = {
  AND?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  OR?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  firstName?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDefaultExporter?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isSchedulable?: Maybe<BoolNullableFilter>;
  isVisible?: Maybe<BoolNullableFilter>;
  lastName?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicEmployeeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicEmployeeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicEmployeeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicEmployeeScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  firstName?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  isActive?: Maybe<BoolNullableWithAggregatesFilter>;
  isDefaultExporter?: Maybe<BoolNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolNullableWithAggregatesFilter>;
  isSchedulable?: Maybe<BoolNullableWithAggregatesFilter>;
  isVisible?: Maybe<BoolNullableWithAggregatesFilter>;
  lastName?: Maybe<StringWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  resourceUid?: Maybe<StringNullableWithAggregatesFilter>;
  type?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicEmployeeToWorkflowEventSetting = {
  __typename?: 'ClinicEmployeeToWorkflowEventSetting';
  clinicEmployee: ClinicEmployee;
  clinicEmployeeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  workflow: WorkflowEventSetting;
  workflowId: Scalars['String'];
};

export type ClinicEmployeeToWorkflowEventSettingCountAggregateOutputType = {
  __typename?: 'ClinicEmployeeToWorkflowEventSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicEmployeeId: Scalars['Int'];
  createdAt: Scalars['Int'];
  workflowId: Scalars['Int'];
};

export type ClinicEmployeeToWorkflowEventSettingCountOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflowId?: Maybe<SortOrder>;
};

export type ClinicEmployeeToWorkflowEventSettingCreateInput = {
  clinicEmployee: ClinicEmployeeCreateNestedOneWithoutWorkflowsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  workflow: WorkflowEventSettingCreateNestedOneWithoutClinicEmployeesInput;
};

export type ClinicEmployeeToWorkflowEventSettingCreateManyClinicEmployeeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['String'];
};

export type ClinicEmployeeToWorkflowEventSettingCreateManyClinicEmployeeInputEnvelope = {
  data: Array<ClinicEmployeeToWorkflowEventSettingCreateManyClinicEmployeeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicEmployeeToWorkflowEventSettingCreateManyInput = {
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['String'];
};

export type ClinicEmployeeToWorkflowEventSettingCreateManyWorkflowInput = {
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeToWorkflowEventSettingCreateManyWorkflowInputEnvelope = {
  data: Array<ClinicEmployeeToWorkflowEventSettingCreateManyWorkflowInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateManyClinicEmployeeInputEnvelope>;
};

export type ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput = {
  connect?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateOrConnectWithoutWorkflowInput>>;
  create?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateWithoutWorkflowInput>>;
  createMany?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateManyWorkflowInputEnvelope>;
};

export type ClinicEmployeeToWorkflowEventSettingCreateOrConnectWithoutClinicEmployeeInput = {
  create: ClinicEmployeeToWorkflowEventSettingCreateWithoutClinicEmployeeInput;
  where: ClinicEmployeeToWorkflowEventSettingWhereUniqueInput;
};

export type ClinicEmployeeToWorkflowEventSettingCreateOrConnectWithoutWorkflowInput = {
  create: ClinicEmployeeToWorkflowEventSettingCreateWithoutWorkflowInput;
  where: ClinicEmployeeToWorkflowEventSettingWhereUniqueInput;
};

export type ClinicEmployeeToWorkflowEventSettingCreateWithoutClinicEmployeeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  workflow: WorkflowEventSettingCreateNestedOneWithoutClinicEmployeesInput;
};

export type ClinicEmployeeToWorkflowEventSettingCreateWithoutWorkflowInput = {
  clinicEmployee: ClinicEmployeeCreateNestedOneWithoutWorkflowsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeToWorkflowEventSettingGroupByOutputType = {
  __typename?: 'ClinicEmployeeToWorkflowEventSettingGroupByOutputType';
  _count?: Maybe<ClinicEmployeeToWorkflowEventSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicEmployeeToWorkflowEventSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicEmployeeToWorkflowEventSettingMinAggregateOutputType>;
  clinicEmployeeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  workflowId: Scalars['String'];
};

export type ClinicEmployeeToWorkflowEventSettingListRelationFilter = {
  every?: Maybe<ClinicEmployeeToWorkflowEventSettingWhereInput>;
  none?: Maybe<ClinicEmployeeToWorkflowEventSettingWhereInput>;
  some?: Maybe<ClinicEmployeeToWorkflowEventSettingWhereInput>;
};

export type ClinicEmployeeToWorkflowEventSettingMaxAggregateOutputType = {
  __typename?: 'ClinicEmployeeToWorkflowEventSettingMaxAggregateOutputType';
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type ClinicEmployeeToWorkflowEventSettingMaxOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflowId?: Maybe<SortOrder>;
};

export type ClinicEmployeeToWorkflowEventSettingMinAggregateOutputType = {
  __typename?: 'ClinicEmployeeToWorkflowEventSettingMinAggregateOutputType';
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type ClinicEmployeeToWorkflowEventSettingMinOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflowId?: Maybe<SortOrder>;
};

export type ClinicEmployeeToWorkflowEventSettingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicEmployeeToWorkflowEventSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicEmployeeToWorkflowEventSettingOrderByRelevanceInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflow?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowId?: Maybe<SortOrder>;
};

export enum ClinicEmployeeToWorkflowEventSettingOrderByRelevanceFieldEnum {
  ClinicEmployeeId = 'clinicEmployeeId',
  WorkflowId = 'workflowId'
}

export type ClinicEmployeeToWorkflowEventSettingOrderByRelevanceInput = {
  fields: Array<ClinicEmployeeToWorkflowEventSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicEmployeeToWorkflowEventSettingOrderByWithAggregationInput = {
  _count?: Maybe<ClinicEmployeeToWorkflowEventSettingCountOrderByAggregateInput>;
  _max?: Maybe<ClinicEmployeeToWorkflowEventSettingMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicEmployeeToWorkflowEventSettingMinOrderByAggregateInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflowId?: Maybe<SortOrder>;
};

export type ClinicEmployeeToWorkflowEventSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicEmployeeToWorkflowEventSettingOrderByRelevanceInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflow?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowId?: Maybe<SortOrder>;
};

export type ClinicEmployeeToWorkflowEventSettingOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicEmployeeToWorkflowEventSettingOrderByRelevanceInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflow?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowId?: Maybe<SortOrder>;
};

export enum ClinicEmployeeToWorkflowEventSettingScalarFieldEnum {
  ClinicEmployeeId = 'clinicEmployeeId',
  CreatedAt = 'createdAt',
  WorkflowId = 'workflowId'
}

export type ClinicEmployeeToWorkflowEventSettingScalarWhereInput = {
  AND?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingScalarWhereInput>>;
  OR?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingScalarWhereInput>>;
  clinicEmployeeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  workflowId?: Maybe<StringFilter>;
};

export type ClinicEmployeeToWorkflowEventSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingScalarWhereWithAggregatesInput>>;
  clinicEmployeeId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  workflowId?: Maybe<StringWithAggregatesFilter>;
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedCreateInput = {
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['String'];
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateManyClinicEmployeeInputEnvelope>;
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput = {
  connect?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateOrConnectWithoutWorkflowInput>>;
  create?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateWithoutWorkflowInput>>;
  createMany?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateManyWorkflowInputEnvelope>;
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedCreateWithoutClinicEmployeeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['String'];
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedCreateWithoutWorkflowInput = {
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedUpdateInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateOrConnectWithoutWorkflowInput>>;
  create?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateWithoutWorkflowInput>>;
  createMany?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateManyWorkflowInputEnvelope>;
  delete?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingUpdateWithWhereUniqueWithoutWorkflowInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingUpdateManyWithWhereWithoutWorkflowInput>>;
  upsert?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingUpsertWithWhereUniqueWithoutWorkflowInput>>;
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedUpdateWithoutClinicEmployeeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type ClinicEmployeeToWorkflowEventSettingUncheckedUpdateWithoutWorkflowInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeToWorkflowEventSettingUpdateInput = {
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneRequiredWithoutWorkflowsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutClinicEmployeesNestedInput>;
};

export type ClinicEmployeeToWorkflowEventSettingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeToWorkflowEventSettingUpdateManyWithWhereWithoutClinicEmployeeInput = {
  data: ClinicEmployeeToWorkflowEventSettingUpdateManyMutationInput;
  where: ClinicEmployeeToWorkflowEventSettingScalarWhereInput;
};

export type ClinicEmployeeToWorkflowEventSettingUpdateManyWithWhereWithoutWorkflowInput = {
  data: ClinicEmployeeToWorkflowEventSettingUpdateManyMutationInput;
  where: ClinicEmployeeToWorkflowEventSettingScalarWhereInput;
};

export type ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateOrConnectWithoutWorkflowInput>>;
  create?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingCreateWithoutWorkflowInput>>;
  createMany?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateManyWorkflowInputEnvelope>;
  delete?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingUpdateWithWhereUniqueWithoutWorkflowInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingUpdateManyWithWhereWithoutWorkflowInput>>;
  upsert?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingUpsertWithWhereUniqueWithoutWorkflowInput>>;
};

export type ClinicEmployeeToWorkflowEventSettingUpdateWithWhereUniqueWithoutClinicEmployeeInput = {
  data: ClinicEmployeeToWorkflowEventSettingUpdateWithoutClinicEmployeeInput;
  where: ClinicEmployeeToWorkflowEventSettingWhereUniqueInput;
};

export type ClinicEmployeeToWorkflowEventSettingUpdateWithWhereUniqueWithoutWorkflowInput = {
  data: ClinicEmployeeToWorkflowEventSettingUpdateWithoutWorkflowInput;
  where: ClinicEmployeeToWorkflowEventSettingWhereUniqueInput;
};

export type ClinicEmployeeToWorkflowEventSettingUpdateWithoutClinicEmployeeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutClinicEmployeesNestedInput>;
};

export type ClinicEmployeeToWorkflowEventSettingUpdateWithoutWorkflowInput = {
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneRequiredWithoutWorkflowsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeToWorkflowEventSettingUpsertWithWhereUniqueWithoutClinicEmployeeInput = {
  create: ClinicEmployeeToWorkflowEventSettingCreateWithoutClinicEmployeeInput;
  update: ClinicEmployeeToWorkflowEventSettingUpdateWithoutClinicEmployeeInput;
  where: ClinicEmployeeToWorkflowEventSettingWhereUniqueInput;
};

export type ClinicEmployeeToWorkflowEventSettingUpsertWithWhereUniqueWithoutWorkflowInput = {
  create: ClinicEmployeeToWorkflowEventSettingCreateWithoutWorkflowInput;
  update: ClinicEmployeeToWorkflowEventSettingUpdateWithoutWorkflowInput;
  where: ClinicEmployeeToWorkflowEventSettingWhereUniqueInput;
};

export type ClinicEmployeeToWorkflowEventSettingWhereInput = {
  AND?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereInput>>;
  OR?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereInput>>;
  clinicEmployee?: Maybe<ClinicEmployeeScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  workflow?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  workflowId?: Maybe<StringFilter>;
};

export type ClinicEmployeeToWorkflowEventSettingWhereUniqueInput = {
  AND?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereInput>>;
  OR?: Maybe<Array<ClinicEmployeeToWorkflowEventSettingWhereInput>>;
  clinicEmployee?: Maybe<ClinicEmployeeScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  workflow?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  workflowId?: Maybe<StringFilter>;
  workflowId_clinicEmployeeId?: Maybe<ClinicEmployeeToWorkflowEventSettingWorkflowIdClinicEmployeeIdCompoundUniqueInput>;
};

export type ClinicEmployeeToWorkflowEventSettingWorkflowIdClinicEmployeeIdCompoundUniqueInput = {
  clinicEmployeeId: Scalars['String'];
  workflowId: Scalars['String'];
};

export type ClinicEmployeeUncheckedCreateInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateNestedManyWithoutAppointmentsInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutAppointmentsInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutAppointmentsInput>>;
};

export type ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicEmployeeCreateManyClinicInputEnvelope>;
};

export type ClinicEmployeeUncheckedCreateNestedManyWithoutDirectBookingExclusionRulesInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutDirectBookingExclusionRulesInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutDirectBookingExclusionRulesInput>>;
};

export type ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicEmployeeCreateManyIntegrationInputEnvelope>;
};

export type ClinicEmployeeUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutUserAppointmentGroupingsInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutUserAppointmentGroupingsInput>>;
};

export type ClinicEmployeeUncheckedCreateWithoutAppointmentAvailabilitiesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutAppointmentsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutBitwerxPaymentWritebackConfigurationsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutClinicInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutDirectBookingExclusionRulesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutEnteredByInvoiceLineItemsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutIntegrationInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutLabPanelInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutMedicalHistoryInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutPrescriptionsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutProviderAppointmentTypeRoomMapInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutProviderInvoiceLineItemsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutUserAppointmentGroupingsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutVetAvailabilityMapsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedCreateWithoutWorkflowsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutEnteredByInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput>;
};

export type ClinicEmployeeUncheckedUpdateInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeUncheckedUpdateManyWithoutAppointmentsNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutAppointmentsInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutAppointmentsInput>>;
  delete?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeUpdateWithWhereUniqueWithoutAppointmentsInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeUpdateManyWithWhereWithoutAppointmentsInput>>;
  upsert?: Maybe<Array<ClinicEmployeeUpsertWithWhereUniqueWithoutAppointmentsInput>>;
};

export type ClinicEmployeeUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicEmployeeCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicEmployeeUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicEmployeeUncheckedUpdateManyWithoutDirectBookingExclusionRulesInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeUncheckedUpdateManyWithoutDirectBookingExclusionRulesNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutDirectBookingExclusionRulesInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutDirectBookingExclusionRulesInput>>;
  delete?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeUpdateWithWhereUniqueWithoutDirectBookingExclusionRulesInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeUpdateManyWithWhereWithoutDirectBookingExclusionRulesInput>>;
  upsert?: Maybe<Array<ClinicEmployeeUpsertWithWhereUniqueWithoutDirectBookingExclusionRulesInput>>;
};

export type ClinicEmployeeUncheckedUpdateManyWithoutIntegrationInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicEmployeeCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ClinicEmployeeUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ClinicEmployeeUncheckedUpdateManyWithoutUserAppointmentGroupingsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutUserAppointmentGroupingsInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutUserAppointmentGroupingsInput>>;
  delete?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeUpdateWithWhereUniqueWithoutUserAppointmentGroupingsInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeUpdateManyWithWhereWithoutUserAppointmentGroupingsInput>>;
  upsert?: Maybe<Array<ClinicEmployeeUpsertWithWhereUniqueWithoutUserAppointmentGroupingsInput>>;
};

export type ClinicEmployeeUncheckedUpdateWithoutAppointmentAvailabilitiesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutAppointmentsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutBitwerxPaymentWritebackConfigurationsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutClinicInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutDirectBookingExclusionRulesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutEnteredByInvoiceLineItemsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutIntegrationInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutLabPanelInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutMedicalHistoryInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutPrescriptionsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutProviderAppointmentTypeRoomMapInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutProviderInvoiceLineItemsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutUserAppointmentGroupingsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutVetAvailabilityMapsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUncheckedUpdateWithoutWorkflowsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEmployeeUpdateManyWithWhereWithoutAppointmentsInput = {
  data: ClinicEmployeeUpdateManyMutationInput;
  where: ClinicEmployeeScalarWhereInput;
};

export type ClinicEmployeeUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicEmployeeUpdateManyMutationInput;
  where: ClinicEmployeeScalarWhereInput;
};

export type ClinicEmployeeUpdateManyWithWhereWithoutDirectBookingExclusionRulesInput = {
  data: ClinicEmployeeUpdateManyMutationInput;
  where: ClinicEmployeeScalarWhereInput;
};

export type ClinicEmployeeUpdateManyWithWhereWithoutIntegrationInput = {
  data: ClinicEmployeeUpdateManyMutationInput;
  where: ClinicEmployeeScalarWhereInput;
};

export type ClinicEmployeeUpdateManyWithWhereWithoutUserAppointmentGroupingsInput = {
  data: ClinicEmployeeUpdateManyMutationInput;
  where: ClinicEmployeeScalarWhereInput;
};

export type ClinicEmployeeUpdateManyWithoutAppointmentsNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutAppointmentsInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutAppointmentsInput>>;
  delete?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeUpdateWithWhereUniqueWithoutAppointmentsInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeUpdateManyWithWhereWithoutAppointmentsInput>>;
  upsert?: Maybe<Array<ClinicEmployeeUpsertWithWhereUniqueWithoutAppointmentsInput>>;
};

export type ClinicEmployeeUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicEmployeeCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicEmployeeUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicEmployeeUpdateManyWithoutDirectBookingExclusionRulesNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutDirectBookingExclusionRulesInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutDirectBookingExclusionRulesInput>>;
  delete?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeUpdateWithWhereUniqueWithoutDirectBookingExclusionRulesInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeUpdateManyWithWhereWithoutDirectBookingExclusionRulesInput>>;
  upsert?: Maybe<Array<ClinicEmployeeUpsertWithWhereUniqueWithoutDirectBookingExclusionRulesInput>>;
};

export type ClinicEmployeeUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicEmployeeCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ClinicEmployeeUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ClinicEmployeeUpdateManyWithoutUserAppointmentGroupingsNestedInput = {
  connect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEmployeeCreateOrConnectWithoutUserAppointmentGroupingsInput>>;
  create?: Maybe<Array<ClinicEmployeeCreateWithoutUserAppointmentGroupingsInput>>;
  delete?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEmployeeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEmployeeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEmployeeUpdateWithWhereUniqueWithoutUserAppointmentGroupingsInput>>;
  updateMany?: Maybe<Array<ClinicEmployeeUpdateManyWithWhereWithoutUserAppointmentGroupingsInput>>;
  upsert?: Maybe<Array<ClinicEmployeeUpsertWithWhereUniqueWithoutUserAppointmentGroupingsInput>>;
};

export type ClinicEmployeeUpdateOneRequiredWithoutClinicEmployeeAppointmentTypeSettingsNestedInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutClinicEmployeeAppointmentTypeSettingsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutClinicEmployeeAppointmentTypeSettingsInput>;
  update?: Maybe<ClinicEmployeeUpdateToOneWithWhereWithoutClinicEmployeeAppointmentTypeSettingsInput>;
  upsert?: Maybe<ClinicEmployeeUpsertWithoutClinicEmployeeAppointmentTypeSettingsInput>;
};

export type ClinicEmployeeUpdateOneRequiredWithoutProviderAppointmentTypeRoomMapNestedInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutProviderAppointmentTypeRoomMapInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutProviderAppointmentTypeRoomMapInput>;
  update?: Maybe<ClinicEmployeeUpdateToOneWithWhereWithoutProviderAppointmentTypeRoomMapInput>;
  upsert?: Maybe<ClinicEmployeeUpsertWithoutProviderAppointmentTypeRoomMapInput>;
};

export type ClinicEmployeeUpdateOneRequiredWithoutVetAvailabilityMapsNestedInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutVetAvailabilityMapsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutVetAvailabilityMapsInput>;
  update?: Maybe<ClinicEmployeeUpdateToOneWithWhereWithoutVetAvailabilityMapsInput>;
  upsert?: Maybe<ClinicEmployeeUpsertWithoutVetAvailabilityMapsInput>;
};

export type ClinicEmployeeUpdateOneRequiredWithoutWorkflowsNestedInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutWorkflowsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutWorkflowsInput>;
  update?: Maybe<ClinicEmployeeUpdateToOneWithWhereWithoutWorkflowsInput>;
  upsert?: Maybe<ClinicEmployeeUpsertWithoutWorkflowsInput>;
};

export type ClinicEmployeeUpdateOneWithoutAppointmentAvailabilitiesNestedInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutAppointmentAvailabilitiesInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutAppointmentAvailabilitiesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicEmployeeUpdateToOneWithWhereWithoutAppointmentAvailabilitiesInput>;
  upsert?: Maybe<ClinicEmployeeUpsertWithoutAppointmentAvailabilitiesInput>;
};

export type ClinicEmployeeUpdateOneWithoutBitwerxPaymentWritebackConfigurationsNestedInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutBitwerxPaymentWritebackConfigurationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicEmployeeUpdateToOneWithWhereWithoutBitwerxPaymentWritebackConfigurationsInput>;
  upsert?: Maybe<ClinicEmployeeUpsertWithoutBitwerxPaymentWritebackConfigurationsInput>;
};

export type ClinicEmployeeUpdateOneWithoutEnteredByInvoiceLineItemsNestedInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutEnteredByInvoiceLineItemsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutEnteredByInvoiceLineItemsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicEmployeeUpdateToOneWithWhereWithoutEnteredByInvoiceLineItemsInput>;
  upsert?: Maybe<ClinicEmployeeUpsertWithoutEnteredByInvoiceLineItemsInput>;
};

export type ClinicEmployeeUpdateOneWithoutLabPanelNestedInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutLabPanelInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutLabPanelInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicEmployeeUpdateToOneWithWhereWithoutLabPanelInput>;
  upsert?: Maybe<ClinicEmployeeUpsertWithoutLabPanelInput>;
};

export type ClinicEmployeeUpdateOneWithoutMedicalHistoryNestedInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutMedicalHistoryInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutMedicalHistoryInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicEmployeeUpdateToOneWithWhereWithoutMedicalHistoryInput>;
  upsert?: Maybe<ClinicEmployeeUpsertWithoutMedicalHistoryInput>;
};

export type ClinicEmployeeUpdateOneWithoutPrescriptionsNestedInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutPrescriptionsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutPrescriptionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicEmployeeUpdateToOneWithWhereWithoutPrescriptionsInput>;
  upsert?: Maybe<ClinicEmployeeUpsertWithoutPrescriptionsInput>;
};

export type ClinicEmployeeUpdateOneWithoutProviderInvoiceLineItemsNestedInput = {
  connect?: Maybe<ClinicEmployeeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicEmployeeCreateOrConnectWithoutProviderInvoiceLineItemsInput>;
  create?: Maybe<ClinicEmployeeCreateWithoutProviderInvoiceLineItemsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicEmployeeUpdateToOneWithWhereWithoutProviderInvoiceLineItemsInput>;
  upsert?: Maybe<ClinicEmployeeUpsertWithoutProviderInvoiceLineItemsInput>;
};

export type ClinicEmployeeUpdateToOneWithWhereWithoutAppointmentAvailabilitiesInput = {
  data: ClinicEmployeeUpdateWithoutAppointmentAvailabilitiesInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpdateToOneWithWhereWithoutBitwerxPaymentWritebackConfigurationsInput = {
  data: ClinicEmployeeUpdateWithoutBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpdateToOneWithWhereWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  data: ClinicEmployeeUpdateWithoutClinicEmployeeAppointmentTypeSettingsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpdateToOneWithWhereWithoutEnteredByInvoiceLineItemsInput = {
  data: ClinicEmployeeUpdateWithoutEnteredByInvoiceLineItemsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpdateToOneWithWhereWithoutLabPanelInput = {
  data: ClinicEmployeeUpdateWithoutLabPanelInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpdateToOneWithWhereWithoutMedicalHistoryInput = {
  data: ClinicEmployeeUpdateWithoutMedicalHistoryInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpdateToOneWithWhereWithoutPrescriptionsInput = {
  data: ClinicEmployeeUpdateWithoutPrescriptionsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpdateToOneWithWhereWithoutProviderAppointmentTypeRoomMapInput = {
  data: ClinicEmployeeUpdateWithoutProviderAppointmentTypeRoomMapInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpdateToOneWithWhereWithoutProviderInvoiceLineItemsInput = {
  data: ClinicEmployeeUpdateWithoutProviderInvoiceLineItemsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpdateToOneWithWhereWithoutVetAvailabilityMapsInput = {
  data: ClinicEmployeeUpdateWithoutVetAvailabilityMapsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpdateToOneWithWhereWithoutWorkflowsInput = {
  data: ClinicEmployeeUpdateWithoutWorkflowsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpdateWithWhereUniqueWithoutAppointmentsInput = {
  data: ClinicEmployeeUpdateWithoutAppointmentsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicEmployeeUpdateWithoutClinicInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeUpdateWithWhereUniqueWithoutDirectBookingExclusionRulesInput = {
  data: ClinicEmployeeUpdateWithoutDirectBookingExclusionRulesInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: ClinicEmployeeUpdateWithoutIntegrationInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeUpdateWithWhereUniqueWithoutUserAppointmentGroupingsInput = {
  data: ClinicEmployeeUpdateWithoutUserAppointmentGroupingsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeUpdateWithoutAppointmentAvailabilitiesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutAppointmentsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutBitwerxPaymentWritebackConfigurationsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutClinicInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutDirectBookingExclusionRulesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutEnteredByInvoiceLineItemsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutIntegrationInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutLabPanelInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutMedicalHistoryInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutPrescriptionsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutProviderAppointmentTypeRoomMapInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutProviderInvoiceLineItemsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutUserAppointmentGroupingsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutVetAvailabilityMapsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpdateWithoutWorkflowsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicEmployeeNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicEmployeeNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicEmployeesNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutEnteredByNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicEmployeesNestedInput>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingUpdateManyWithoutClinicEmployeeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutEnteredByNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutProviderNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput>;
};

export type ClinicEmployeeUpsertWithWhereUniqueWithoutAppointmentsInput = {
  create: ClinicEmployeeCreateWithoutAppointmentsInput;
  update: ClinicEmployeeUpdateWithoutAppointmentsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicEmployeeCreateWithoutClinicInput;
  update: ClinicEmployeeUpdateWithoutClinicInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeUpsertWithWhereUniqueWithoutDirectBookingExclusionRulesInput = {
  create: ClinicEmployeeCreateWithoutDirectBookingExclusionRulesInput;
  update: ClinicEmployeeUpdateWithoutDirectBookingExclusionRulesInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: ClinicEmployeeCreateWithoutIntegrationInput;
  update: ClinicEmployeeUpdateWithoutIntegrationInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeUpsertWithWhereUniqueWithoutUserAppointmentGroupingsInput = {
  create: ClinicEmployeeCreateWithoutUserAppointmentGroupingsInput;
  update: ClinicEmployeeUpdateWithoutUserAppointmentGroupingsInput;
  where: ClinicEmployeeWhereUniqueInput;
};

export type ClinicEmployeeUpsertWithoutAppointmentAvailabilitiesInput = {
  create: ClinicEmployeeCreateWithoutAppointmentAvailabilitiesInput;
  update: ClinicEmployeeUpdateWithoutAppointmentAvailabilitiesInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpsertWithoutBitwerxPaymentWritebackConfigurationsInput = {
  create: ClinicEmployeeCreateWithoutBitwerxPaymentWritebackConfigurationsInput;
  update: ClinicEmployeeUpdateWithoutBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpsertWithoutClinicEmployeeAppointmentTypeSettingsInput = {
  create: ClinicEmployeeCreateWithoutClinicEmployeeAppointmentTypeSettingsInput;
  update: ClinicEmployeeUpdateWithoutClinicEmployeeAppointmentTypeSettingsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpsertWithoutEnteredByInvoiceLineItemsInput = {
  create: ClinicEmployeeCreateWithoutEnteredByInvoiceLineItemsInput;
  update: ClinicEmployeeUpdateWithoutEnteredByInvoiceLineItemsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpsertWithoutLabPanelInput = {
  create: ClinicEmployeeCreateWithoutLabPanelInput;
  update: ClinicEmployeeUpdateWithoutLabPanelInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpsertWithoutMedicalHistoryInput = {
  create: ClinicEmployeeCreateWithoutMedicalHistoryInput;
  update: ClinicEmployeeUpdateWithoutMedicalHistoryInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpsertWithoutPrescriptionsInput = {
  create: ClinicEmployeeCreateWithoutPrescriptionsInput;
  update: ClinicEmployeeUpdateWithoutPrescriptionsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpsertWithoutProviderAppointmentTypeRoomMapInput = {
  create: ClinicEmployeeCreateWithoutProviderAppointmentTypeRoomMapInput;
  update: ClinicEmployeeUpdateWithoutProviderAppointmentTypeRoomMapInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpsertWithoutProviderInvoiceLineItemsInput = {
  create: ClinicEmployeeCreateWithoutProviderInvoiceLineItemsInput;
  update: ClinicEmployeeUpdateWithoutProviderInvoiceLineItemsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpsertWithoutVetAvailabilityMapsInput = {
  create: ClinicEmployeeCreateWithoutVetAvailabilityMapsInput;
  update: ClinicEmployeeUpdateWithoutVetAvailabilityMapsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeUpsertWithoutWorkflowsInput = {
  create: ClinicEmployeeCreateWithoutWorkflowsInput;
  update: ClinicEmployeeUpdateWithoutWorkflowsInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};

export type ClinicEmployeeWhereInput = {
  AND?: Maybe<Array<ClinicEmployeeWhereInput>>;
  LabPanel?: Maybe<LabPanelListRelationFilter>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ClinicEmployeeWhereInput>>;
  OR?: Maybe<Array<ClinicEmployeeWhereInput>>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapListRelationFilter>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleListRelationFilter>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  firstName?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDefaultExporter?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isSchedulable?: Maybe<BoolNullableFilter>;
  isVisible?: Maybe<BoolNullableFilter>;
  lastName?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapListRelationFilter>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingListRelationFilter>;
};

export type ClinicEmployeeWhereUniqueInput = {
  AND?: Maybe<Array<ClinicEmployeeWhereInput>>;
  LabPanel?: Maybe<LabPanelListRelationFilter>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ClinicEmployeeWhereInput>>;
  OR?: Maybe<Array<ClinicEmployeeWhereInput>>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapListRelationFilter>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployeeAppointmentTypeSettings?: Maybe<ClinicEmployeeAppointmentTypeSettingListRelationFilter>;
  clinicEmployeePimsIdAndIntegrationId?: Maybe<ClinicEmployeeClinicEmployeePimsIdAndIntegrationIdCompoundUniqueInput>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleListRelationFilter>;
  enteredByInvoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  firstName?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDefaultExporter?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isSchedulable?: Maybe<BoolNullableFilter>;
  isVisible?: Maybe<BoolNullableFilter>;
  lastName?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  providerInvoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapListRelationFilter>;
  workflows?: Maybe<ClinicEmployeeToWorkflowEventSettingListRelationFilter>;
};

export enum ClinicEntityCreationSource {
  ClinicApp = 'ClinicApp',
  DirectBooking = 'DirectBooking',
  InboundSms = 'InboundSms',
  Pims = 'Pims',
  TestEntityAutomation = 'TestEntityAutomation',
  WidgetRequest = 'WidgetRequest'
}

export type ClinicEntityPhoneNumber = {
  __typename?: 'ClinicEntityPhoneNumber';
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  /** whether this number has opted out of messaging */
  isOptedOut: Scalars['Boolean'];
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  /** the last time opt out messaging was sent to this number */
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  /** The last time we tried to send an sms to this number */
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequest>;
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResult>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  /** This is the result from the last time we tried to send */
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt: Scalars['DateTime'];
};


export type ClinicEntityPhoneNumberClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type ClinicEntityPhoneNumberPhoneNumberLookupRequestArgs = {
  where?: Maybe<PhoneNumberLookupRequestWhereInput>;
};


export type ClinicEntityPhoneNumberPhoneNumberLookupResultArgs = {
  where?: Maybe<PhoneNumberLookupResultWhereInput>;
};

export type ClinicEntityPhoneNumberCountAggregateOutputType = {
  __typename?: 'ClinicEntityPhoneNumberCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isMobile: Scalars['Int'];
  isOptedOut: Scalars['Int'];
  isPims: Scalars['Int'];
  isPrimary: Scalars['Int'];
  lastOptOutSendDate: Scalars['Int'];
  lastSmsSendDate: Scalars['Int'];
  number: Scalars['Int'];
  phoneNumberLookupRequestId: Scalars['Int'];
  phoneNumberLookupResultId: Scalars['Int'];
  pimsId: Scalars['Int'];
  smsStatus: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicEntityPhoneNumberCountOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isMobile?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPims?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  lastOptOutSendDate?: Maybe<SortOrder>;
  lastSmsSendDate?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  phoneNumberLookupRequestId?: Maybe<SortOrder>;
  phoneNumberLookupResultId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  smsStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEntityPhoneNumberCreateInput = {
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutPhoneNumbersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequestCreateNestedOneWithoutClinicEntityPhoneNumbersInput>;
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResultCreateNestedOneWithoutClinicEntityPhoneNumbersInput>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberCreateManyClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberCreateManyClinicPetParentInputEnvelope = {
  data: Array<ClinicEntityPhoneNumberCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicEntityPhoneNumberCreateManyInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberCreateManyPhoneNumberLookupRequestInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberCreateManyPhoneNumberLookupRequestInputEnvelope = {
  data: Array<ClinicEntityPhoneNumberCreateManyPhoneNumberLookupRequestInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicEntityPhoneNumberCreateManyPhoneNumberLookupResultInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberCreateManyPhoneNumberLookupResultInputEnvelope = {
  data: Array<ClinicEntityPhoneNumberCreateManyPhoneNumberLookupResultInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEntityPhoneNumberCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicEntityPhoneNumberCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicEntityPhoneNumberCreateManyClinicPetParentInputEnvelope>;
};

export type ClinicEntityPhoneNumberCreateNestedManyWithoutPhoneNumberLookupRequestInput = {
  connect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEntityPhoneNumberCreateOrConnectWithoutPhoneNumberLookupRequestInput>>;
  create?: Maybe<Array<ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupRequestInput>>;
  createMany?: Maybe<ClinicEntityPhoneNumberCreateManyPhoneNumberLookupRequestInputEnvelope>;
};

export type ClinicEntityPhoneNumberCreateNestedManyWithoutPhoneNumberLookupResultInput = {
  connect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEntityPhoneNumberCreateOrConnectWithoutPhoneNumberLookupResultInput>>;
  create?: Maybe<Array<ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupResultInput>>;
  createMany?: Maybe<ClinicEntityPhoneNumberCreateManyPhoneNumberLookupResultInputEnvelope>;
};

export type ClinicEntityPhoneNumberCreateOrConnectWithoutClinicPetParentInput = {
  create: ClinicEntityPhoneNumberCreateWithoutClinicPetParentInput;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};

export type ClinicEntityPhoneNumberCreateOrConnectWithoutPhoneNumberLookupRequestInput = {
  create: ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupRequestInput;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};

export type ClinicEntityPhoneNumberCreateOrConnectWithoutPhoneNumberLookupResultInput = {
  create: ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupResultInput;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};

export type ClinicEntityPhoneNumberCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequestCreateNestedOneWithoutClinicEntityPhoneNumbersInput>;
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResultCreateNestedOneWithoutClinicEntityPhoneNumbersInput>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupRequestInput = {
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutPhoneNumbersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResultCreateNestedOneWithoutClinicEntityPhoneNumbersInput>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupResultInput = {
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutPhoneNumbersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequestCreateNestedOneWithoutClinicEntityPhoneNumbersInput>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberGroupByOutputType = {
  __typename?: 'ClinicEntityPhoneNumberGroupByOutputType';
  _count?: Maybe<ClinicEntityPhoneNumberCountAggregateOutputType>;
  _max?: Maybe<ClinicEntityPhoneNumberMaxAggregateOutputType>;
  _min?: Maybe<ClinicEntityPhoneNumberMinAggregateOutputType>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut: Scalars['Boolean'];
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt: Scalars['DateTime'];
};

export type ClinicEntityPhoneNumberListRelationFilter = {
  every?: Maybe<ClinicEntityPhoneNumberWhereInput>;
  none?: Maybe<ClinicEntityPhoneNumberWhereInput>;
  some?: Maybe<ClinicEntityPhoneNumberWhereInput>;
};

export type ClinicEntityPhoneNumberMaxAggregateOutputType = {
  __typename?: 'ClinicEntityPhoneNumberMaxAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberMaxOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isMobile?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPims?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  lastOptOutSendDate?: Maybe<SortOrder>;
  lastSmsSendDate?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  phoneNumberLookupRequestId?: Maybe<SortOrder>;
  phoneNumberLookupResultId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  smsStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEntityPhoneNumberMinAggregateOutputType = {
  __typename?: 'ClinicEntityPhoneNumberMinAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberMinOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isMobile?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPims?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  lastOptOutSendDate?: Maybe<SortOrder>;
  lastSmsSendDate?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  phoneNumberLookupRequestId?: Maybe<SortOrder>;
  phoneNumberLookupResultId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  smsStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEntityPhoneNumberNumberClinicPetParentIdCompoundUniqueInput = {
  clinicPetParentId: Scalars['String'];
  number: Scalars['String'];
};

export type ClinicEntityPhoneNumberOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicEntityPhoneNumberOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicEntityPhoneNumberOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isMobile?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPims?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  lastOptOutSendDate?: Maybe<SortOrder>;
  lastSmsSendDate?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequestOrderByWithRelationInput>;
  phoneNumberLookupRequestId?: Maybe<SortOrder>;
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResultOrderByWithRelationInput>;
  phoneNumberLookupResultId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  smsStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicEntityPhoneNumberOrderByRelevanceFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  Id = 'id',
  Number = 'number',
  PhoneNumberLookupRequestId = 'phoneNumberLookupRequestId',
  PhoneNumberLookupResultId = 'phoneNumberLookupResultId',
  PimsId = 'pimsId'
}

export type ClinicEntityPhoneNumberOrderByRelevanceInput = {
  fields: Array<ClinicEntityPhoneNumberOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicEntityPhoneNumberOrderByWithAggregationInput = {
  _count?: Maybe<ClinicEntityPhoneNumberCountOrderByAggregateInput>;
  _max?: Maybe<ClinicEntityPhoneNumberMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicEntityPhoneNumberMinOrderByAggregateInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isMobile?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPims?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  lastOptOutSendDate?: Maybe<SortOrder>;
  lastSmsSendDate?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  phoneNumberLookupRequestId?: Maybe<SortOrder>;
  phoneNumberLookupResultId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  smsStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEntityPhoneNumberOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicEntityPhoneNumberOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isMobile?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPims?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  lastOptOutSendDate?: Maybe<SortOrder>;
  lastSmsSendDate?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequestOrderByWithRelationInput>;
  phoneNumberLookupRequestId?: Maybe<SortOrder>;
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResultOrderByWithRelationInput>;
  phoneNumberLookupResultId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  smsStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicEntityPhoneNumberOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicEntityPhoneNumberOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isMobile?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPims?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  lastOptOutSendDate?: Maybe<SortOrder>;
  lastSmsSendDate?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequestOrderByWithRelationInput>;
  phoneNumberLookupRequestId?: Maybe<SortOrder>;
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResultOrderByWithRelationInput>;
  phoneNumberLookupResultId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  smsStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicEntityPhoneNumberScalarFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  IsMobile = 'isMobile',
  IsOptedOut = 'isOptedOut',
  IsPims = 'isPims',
  IsPrimary = 'isPrimary',
  LastOptOutSendDate = 'lastOptOutSendDate',
  LastSmsSendDate = 'lastSmsSendDate',
  Number = 'number',
  PhoneNumberLookupRequestId = 'phoneNumberLookupRequestId',
  PhoneNumberLookupResultId = 'phoneNumberLookupResultId',
  PimsId = 'pimsId',
  SmsStatus = 'smsStatus',
  UpdatedAt = 'updatedAt'
}

export type ClinicEntityPhoneNumberScalarWhereInput = {
  AND?: Maybe<Array<ClinicEntityPhoneNumberScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicEntityPhoneNumberScalarWhereInput>>;
  OR?: Maybe<Array<ClinicEntityPhoneNumberScalarWhereInput>>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isMobile?: Maybe<BoolNullableFilter>;
  isOptedOut?: Maybe<BoolFilter>;
  isPims?: Maybe<BoolNullableFilter>;
  isPrimary?: Maybe<BoolNullableFilter>;
  lastOptOutSendDate?: Maybe<DateTimeNullableFilter>;
  lastSmsSendDate?: Maybe<DateTimeNullableFilter>;
  number?: Maybe<StringFilter>;
  phoneNumberLookupRequestId?: Maybe<StringNullableFilter>;
  phoneNumberLookupResultId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  smsStatus?: Maybe<EnumClinicEntityPhoneNumberSmsStatusNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicEntityPhoneNumberScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicEntityPhoneNumberScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicEntityPhoneNumberScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicEntityPhoneNumberScalarWhereWithAggregatesInput>>;
  clinicPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolNullableWithAggregatesFilter>;
  isMobile?: Maybe<BoolNullableWithAggregatesFilter>;
  isOptedOut?: Maybe<BoolWithAggregatesFilter>;
  isPims?: Maybe<BoolNullableWithAggregatesFilter>;
  isPrimary?: Maybe<BoolNullableWithAggregatesFilter>;
  lastOptOutSendDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  lastSmsSendDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  number?: Maybe<StringWithAggregatesFilter>;
  phoneNumberLookupRequestId?: Maybe<StringNullableWithAggregatesFilter>;
  phoneNumberLookupResultId?: Maybe<StringNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  smsStatus?: Maybe<EnumClinicEntityPhoneNumberSmsStatusNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum ClinicEntityPhoneNumberSmsStatus {
  Delivered = 'Delivered',
  None = 'None',
  PreValidated = 'PreValidated',
  RejectedBecauseInvalidPhoneNumber = 'RejectedBecauseInvalidPhoneNumber',
  RejectedBecauseLandline = 'RejectedBecauseLandline',
  RejectedFilteredByCarrier = 'RejectedFilteredByCarrier',
  RejectedNotInService = 'RejectedNotInService',
  RejectedOptedOut = 'RejectedOptedOut',
  RejectedUnknown = 'RejectedUnknown'
}

export type ClinicEntityPhoneNumberUncheckedCreateInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEntityPhoneNumberCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicEntityPhoneNumberCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicEntityPhoneNumberCreateManyClinicPetParentInputEnvelope>;
};

export type ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutPhoneNumberLookupRequestInput = {
  connect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEntityPhoneNumberCreateOrConnectWithoutPhoneNumberLookupRequestInput>>;
  create?: Maybe<Array<ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupRequestInput>>;
  createMany?: Maybe<ClinicEntityPhoneNumberCreateManyPhoneNumberLookupRequestInputEnvelope>;
};

export type ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutPhoneNumberLookupResultInput = {
  connect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEntityPhoneNumberCreateOrConnectWithoutPhoneNumberLookupResultInput>>;
  create?: Maybe<Array<ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupResultInput>>;
  createMany?: Maybe<ClinicEntityPhoneNumberCreateManyPhoneNumberLookupResultInputEnvelope>;
};

export type ClinicEntityPhoneNumberUncheckedCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUncheckedCreateWithoutPhoneNumberLookupRequestInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUncheckedCreateWithoutPhoneNumberLookupResultInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUncheckedUpdateInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUncheckedUpdateManyInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEntityPhoneNumberCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicEntityPhoneNumberCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicEntityPhoneNumberCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEntityPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEntityPhoneNumberUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ClinicEntityPhoneNumberUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ClinicEntityPhoneNumberUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ClinicEntityPhoneNumberUncheckedUpdateManyWithoutPhoneNumberLookupRequestInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUncheckedUpdateManyWithoutPhoneNumberLookupRequestNestedInput = {
  connect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEntityPhoneNumberCreateOrConnectWithoutPhoneNumberLookupRequestInput>>;
  create?: Maybe<Array<ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupRequestInput>>;
  createMany?: Maybe<ClinicEntityPhoneNumberCreateManyPhoneNumberLookupRequestInputEnvelope>;
  delete?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEntityPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEntityPhoneNumberUpdateWithWhereUniqueWithoutPhoneNumberLookupRequestInput>>;
  updateMany?: Maybe<Array<ClinicEntityPhoneNumberUpdateManyWithWhereWithoutPhoneNumberLookupRequestInput>>;
  upsert?: Maybe<Array<ClinicEntityPhoneNumberUpsertWithWhereUniqueWithoutPhoneNumberLookupRequestInput>>;
};

export type ClinicEntityPhoneNumberUncheckedUpdateManyWithoutPhoneNumberLookupResultInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUncheckedUpdateManyWithoutPhoneNumberLookupResultNestedInput = {
  connect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEntityPhoneNumberCreateOrConnectWithoutPhoneNumberLookupResultInput>>;
  create?: Maybe<Array<ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupResultInput>>;
  createMany?: Maybe<ClinicEntityPhoneNumberCreateManyPhoneNumberLookupResultInputEnvelope>;
  delete?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEntityPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEntityPhoneNumberUpdateWithWhereUniqueWithoutPhoneNumberLookupResultInput>>;
  updateMany?: Maybe<Array<ClinicEntityPhoneNumberUpdateManyWithWhereWithoutPhoneNumberLookupResultInput>>;
  upsert?: Maybe<Array<ClinicEntityPhoneNumberUpsertWithWhereUniqueWithoutPhoneNumberLookupResultInput>>;
};

export type ClinicEntityPhoneNumberUncheckedUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUncheckedUpdateWithoutPhoneNumberLookupRequestInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUncheckedUpdateWithoutPhoneNumberLookupResultInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUpdateInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutPhoneNumbersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequestUpdateOneWithoutClinicEntityPhoneNumbersNestedInput>;
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResultUpdateOneWithoutClinicEntityPhoneNumbersNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: ClinicEntityPhoneNumberUpdateManyMutationInput;
  where: ClinicEntityPhoneNumberScalarWhereInput;
};

export type ClinicEntityPhoneNumberUpdateManyWithWhereWithoutPhoneNumberLookupRequestInput = {
  data: ClinicEntityPhoneNumberUpdateManyMutationInput;
  where: ClinicEntityPhoneNumberScalarWhereInput;
};

export type ClinicEntityPhoneNumberUpdateManyWithWhereWithoutPhoneNumberLookupResultInput = {
  data: ClinicEntityPhoneNumberUpdateManyMutationInput;
  where: ClinicEntityPhoneNumberScalarWhereInput;
};

export type ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEntityPhoneNumberCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicEntityPhoneNumberCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicEntityPhoneNumberCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEntityPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEntityPhoneNumberUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ClinicEntityPhoneNumberUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ClinicEntityPhoneNumberUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ClinicEntityPhoneNumberUpdateManyWithoutPhoneNumberLookupRequestNestedInput = {
  connect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEntityPhoneNumberCreateOrConnectWithoutPhoneNumberLookupRequestInput>>;
  create?: Maybe<Array<ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupRequestInput>>;
  createMany?: Maybe<ClinicEntityPhoneNumberCreateManyPhoneNumberLookupRequestInputEnvelope>;
  delete?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEntityPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEntityPhoneNumberUpdateWithWhereUniqueWithoutPhoneNumberLookupRequestInput>>;
  updateMany?: Maybe<Array<ClinicEntityPhoneNumberUpdateManyWithWhereWithoutPhoneNumberLookupRequestInput>>;
  upsert?: Maybe<Array<ClinicEntityPhoneNumberUpsertWithWhereUniqueWithoutPhoneNumberLookupRequestInput>>;
};

export type ClinicEntityPhoneNumberUpdateManyWithoutPhoneNumberLookupResultNestedInput = {
  connect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicEntityPhoneNumberCreateOrConnectWithoutPhoneNumberLookupResultInput>>;
  create?: Maybe<Array<ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupResultInput>>;
  createMany?: Maybe<ClinicEntityPhoneNumberCreateManyPhoneNumberLookupResultInputEnvelope>;
  delete?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicEntityPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicEntityPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicEntityPhoneNumberUpdateWithWhereUniqueWithoutPhoneNumberLookupResultInput>>;
  updateMany?: Maybe<Array<ClinicEntityPhoneNumberUpdateManyWithWhereWithoutPhoneNumberLookupResultInput>>;
  upsert?: Maybe<Array<ClinicEntityPhoneNumberUpsertWithWhereUniqueWithoutPhoneNumberLookupResultInput>>;
};

export type ClinicEntityPhoneNumberUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: ClinicEntityPhoneNumberUpdateWithoutClinicPetParentInput;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};

export type ClinicEntityPhoneNumberUpdateWithWhereUniqueWithoutPhoneNumberLookupRequestInput = {
  data: ClinicEntityPhoneNumberUpdateWithoutPhoneNumberLookupRequestInput;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};

export type ClinicEntityPhoneNumberUpdateWithWhereUniqueWithoutPhoneNumberLookupResultInput = {
  data: ClinicEntityPhoneNumberUpdateWithoutPhoneNumberLookupResultInput;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};

export type ClinicEntityPhoneNumberUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequestUpdateOneWithoutClinicEntityPhoneNumbersNestedInput>;
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResultUpdateOneWithoutClinicEntityPhoneNumbersNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUpdateWithoutPhoneNumberLookupRequestInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutPhoneNumbersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResultUpdateOneWithoutClinicEntityPhoneNumbersNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUpdateWithoutPhoneNumberLookupResultInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutPhoneNumbersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequestUpdateOneWithoutClinicEntityPhoneNumbersNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicEntityPhoneNumberUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: ClinicEntityPhoneNumberCreateWithoutClinicPetParentInput;
  update: ClinicEntityPhoneNumberUpdateWithoutClinicPetParentInput;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};

export type ClinicEntityPhoneNumberUpsertWithWhereUniqueWithoutPhoneNumberLookupRequestInput = {
  create: ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupRequestInput;
  update: ClinicEntityPhoneNumberUpdateWithoutPhoneNumberLookupRequestInput;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};

export type ClinicEntityPhoneNumberUpsertWithWhereUniqueWithoutPhoneNumberLookupResultInput = {
  create: ClinicEntityPhoneNumberCreateWithoutPhoneNumberLookupResultInput;
  update: ClinicEntityPhoneNumberUpdateWithoutPhoneNumberLookupResultInput;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};

export type ClinicEntityPhoneNumberWhereInput = {
  AND?: Maybe<Array<ClinicEntityPhoneNumberWhereInput>>;
  NOT?: Maybe<Array<ClinicEntityPhoneNumberWhereInput>>;
  OR?: Maybe<Array<ClinicEntityPhoneNumberWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isMobile?: Maybe<BoolNullableFilter>;
  isOptedOut?: Maybe<BoolFilter>;
  isPims?: Maybe<BoolNullableFilter>;
  isPrimary?: Maybe<BoolNullableFilter>;
  lastOptOutSendDate?: Maybe<DateTimeNullableFilter>;
  lastSmsSendDate?: Maybe<DateTimeNullableFilter>;
  number?: Maybe<StringFilter>;
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequestNullableScalarRelationFilter>;
  phoneNumberLookupRequestId?: Maybe<StringNullableFilter>;
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResultNullableScalarRelationFilter>;
  phoneNumberLookupResultId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  smsStatus?: Maybe<EnumClinicEntityPhoneNumberSmsStatusNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicEntityPhoneNumberWhereUniqueInput = {
  AND?: Maybe<Array<ClinicEntityPhoneNumberWhereInput>>;
  NOT?: Maybe<Array<ClinicEntityPhoneNumberWhereInput>>;
  OR?: Maybe<Array<ClinicEntityPhoneNumberWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isMobile?: Maybe<BoolNullableFilter>;
  isOptedOut?: Maybe<BoolFilter>;
  isPims?: Maybe<BoolNullableFilter>;
  isPrimary?: Maybe<BoolNullableFilter>;
  lastOptOutSendDate?: Maybe<DateTimeNullableFilter>;
  lastSmsSendDate?: Maybe<DateTimeNullableFilter>;
  number?: Maybe<StringFilter>;
  number_clinicPetParentId?: Maybe<ClinicEntityPhoneNumberNumberClinicPetParentIdCompoundUniqueInput>;
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequestNullableScalarRelationFilter>;
  phoneNumberLookupRequestId?: Maybe<StringNullableFilter>;
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResultNullableScalarRelationFilter>;
  phoneNumberLookupResultId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  smsStatus?: Maybe<EnumClinicEntityPhoneNumberSmsStatusNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicGroupByOutputType = {
  __typename?: 'ClinicGroupByOutputType';
  _avg?: Maybe<ClinicAvgAggregateOutputType>;
  _count?: Maybe<ClinicCountAggregateOutputType>;
  _max?: Maybe<ClinicMaxAggregateOutputType>;
  _min?: Maybe<ClinicMinAggregateOutputType>;
  _sum?: Maybe<ClinicSumAggregateOutputType>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts: Scalars['Boolean'];
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive: Scalars['Boolean'];
  isClinicEligibleForPayments: Scalars['Boolean'];
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicListRelationFilter = {
  every?: Maybe<ClinicWhereInput>;
  none?: Maybe<ClinicWhereInput>;
  some?: Maybe<ClinicWhereInput>;
};

export type ClinicMaxAggregateOutputType = {
  __typename?: 'ClinicMaxAggregateOutputType';
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type ClinicMaxOrderByAggregateInput = {
  activationDate?: Maybe<SortOrder>;
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  allowAllUsersToCloseConsultations?: Maybe<SortOrder>;
  automaticSubscriptionReceipts?: Maybe<SortOrder>;
  callerIdPhoneNumber?: Maybe<SortOrder>;
  canceledAt?: Maybe<SortOrder>;
  cancellationNote?: Maybe<SortOrder>;
  cancellationReason?: Maybe<SortOrder>;
  carePlanProviderGroupId?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicEmail?: Maybe<SortOrder>;
  clinicSettingId?: Maybe<SortOrder>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  consultationCost?: Maybe<SortOrder>;
  corporateId?: Maybe<SortOrder>;
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  followUpCost?: Maybe<SortOrder>;
  fullAddress?: Maybe<SortOrder>;
  hasServiceReminders?: Maybe<SortOrder>;
  hasSmsConversations?: Maybe<SortOrder>;
  headUserId?: Maybe<SortOrder>;
  hours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomeMethod?: Maybe<SortOrder>;
  integrationSystem?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  isAddAppointmentDisabled?: Maybe<SortOrder>;
  isCallerIdVerified?: Maybe<SortOrder>;
  isClinicActive?: Maybe<SortOrder>;
  isClinicEligibleForPayments?: Maybe<SortOrder>;
  isConsultationsActive?: Maybe<SortOrder>;
  isIntegrationActive?: Maybe<SortOrder>;
  isPaymentUsBank?: Maybe<SortOrder>;
  isServiceRemindersActive?: Maybe<SortOrder>;
  lastPrintOrderedOn?: Maybe<SortOrder>;
  lastPrintOrderedQuantity?: Maybe<SortOrder>;
  lat?: Maybe<SortOrder>;
  legalEntityId?: Maybe<SortOrder>;
  logo?: Maybe<SortOrder>;
  long?: Maybe<SortOrder>;
  loyaltyProgramId?: Maybe<SortOrder>;
  marketEmail?: Maybe<SortOrder>;
  marketFacebookNumber?: Maybe<SortOrder>;
  marketFacebookPageId?: Maybe<SortOrder>;
  marketFacebookPageToken?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  optimizedLogoUrl?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  paymentAddress?: Maybe<SortOrder>;
  paymentBankAccountNumber?: Maybe<SortOrder>;
  paymentBankRoutingNumber?: Maybe<SortOrder>;
  paymentCity?: Maybe<SortOrder>;
  paymentName?: Maybe<SortOrder>;
  paymentPhone?: Maybe<SortOrder>;
  paymentState?: Maybe<SortOrder>;
  paymentZip?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  printLastOrder?: Maybe<SortOrder>;
  printReceivedQuantity?: Maybe<SortOrder>;
  remindersIntegrationRequestEmail?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  smsPhoneNumber?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  stripeSubscriptionPlan?: Maybe<SortOrder>;
  submerchantApprovedAt?: Maybe<SortOrder>;
  submerchantId?: Maybe<SortOrder>;
  submerchantIsActive?: Maybe<SortOrder>;
  submerchantStatus?: Maybe<SortOrder>;
  submerchantStripeChargesEnabled?: Maybe<SortOrder>;
  submerchantStripeHasCustomPayouts?: Maybe<SortOrder>;
  submerchantStripeId?: Maybe<SortOrder>;
  submerchantStripePayoutsEnabled?: Maybe<SortOrder>;
  submerchantStripeStatus?: Maybe<SortOrder>;
  subscribedAt?: Maybe<SortOrder>;
  subscriptionId?: Maybe<SortOrder>;
  subscriptionPlan?: Maybe<SortOrder>;
  timezone?: Maybe<SortOrder>;
  timezoneName?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  unlayerSettingId?: Maybe<SortOrder>;
  unsubscribedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  websiteUrl?: Maybe<SortOrder>;
};

export type ClinicMinAggregateOutputType = {
  __typename?: 'ClinicMinAggregateOutputType';
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type ClinicMinOrderByAggregateInput = {
  activationDate?: Maybe<SortOrder>;
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  allowAllUsersToCloseConsultations?: Maybe<SortOrder>;
  automaticSubscriptionReceipts?: Maybe<SortOrder>;
  callerIdPhoneNumber?: Maybe<SortOrder>;
  canceledAt?: Maybe<SortOrder>;
  cancellationNote?: Maybe<SortOrder>;
  cancellationReason?: Maybe<SortOrder>;
  carePlanProviderGroupId?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicEmail?: Maybe<SortOrder>;
  clinicSettingId?: Maybe<SortOrder>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  consultationCost?: Maybe<SortOrder>;
  corporateId?: Maybe<SortOrder>;
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  followUpCost?: Maybe<SortOrder>;
  fullAddress?: Maybe<SortOrder>;
  hasServiceReminders?: Maybe<SortOrder>;
  hasSmsConversations?: Maybe<SortOrder>;
  headUserId?: Maybe<SortOrder>;
  hours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomeMethod?: Maybe<SortOrder>;
  integrationSystem?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  isAddAppointmentDisabled?: Maybe<SortOrder>;
  isCallerIdVerified?: Maybe<SortOrder>;
  isClinicActive?: Maybe<SortOrder>;
  isClinicEligibleForPayments?: Maybe<SortOrder>;
  isConsultationsActive?: Maybe<SortOrder>;
  isIntegrationActive?: Maybe<SortOrder>;
  isPaymentUsBank?: Maybe<SortOrder>;
  isServiceRemindersActive?: Maybe<SortOrder>;
  lastPrintOrderedOn?: Maybe<SortOrder>;
  lastPrintOrderedQuantity?: Maybe<SortOrder>;
  lat?: Maybe<SortOrder>;
  legalEntityId?: Maybe<SortOrder>;
  logo?: Maybe<SortOrder>;
  long?: Maybe<SortOrder>;
  loyaltyProgramId?: Maybe<SortOrder>;
  marketEmail?: Maybe<SortOrder>;
  marketFacebookNumber?: Maybe<SortOrder>;
  marketFacebookPageId?: Maybe<SortOrder>;
  marketFacebookPageToken?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  optimizedLogoUrl?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  paymentAddress?: Maybe<SortOrder>;
  paymentBankAccountNumber?: Maybe<SortOrder>;
  paymentBankRoutingNumber?: Maybe<SortOrder>;
  paymentCity?: Maybe<SortOrder>;
  paymentName?: Maybe<SortOrder>;
  paymentPhone?: Maybe<SortOrder>;
  paymentState?: Maybe<SortOrder>;
  paymentZip?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  printLastOrder?: Maybe<SortOrder>;
  printReceivedQuantity?: Maybe<SortOrder>;
  remindersIntegrationRequestEmail?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  smsPhoneNumber?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  stripeSubscriptionPlan?: Maybe<SortOrder>;
  submerchantApprovedAt?: Maybe<SortOrder>;
  submerchantId?: Maybe<SortOrder>;
  submerchantIsActive?: Maybe<SortOrder>;
  submerchantStatus?: Maybe<SortOrder>;
  submerchantStripeChargesEnabled?: Maybe<SortOrder>;
  submerchantStripeHasCustomPayouts?: Maybe<SortOrder>;
  submerchantStripeId?: Maybe<SortOrder>;
  submerchantStripePayoutsEnabled?: Maybe<SortOrder>;
  submerchantStripeStatus?: Maybe<SortOrder>;
  subscribedAt?: Maybe<SortOrder>;
  subscriptionId?: Maybe<SortOrder>;
  subscriptionPlan?: Maybe<SortOrder>;
  timezone?: Maybe<SortOrder>;
  timezoneName?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  unlayerSettingId?: Maybe<SortOrder>;
  unsubscribedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  websiteUrl?: Maybe<SortOrder>;
};

export type ClinicModule = {
  __typename?: 'ClinicModule';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  module: Module;
  moduleId: Scalars['String'];
  source: ClinicModuleSource;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ClinicModuleCountAggregateOutputType = {
  __typename?: 'ClinicModuleCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  moduleId: Scalars['Int'];
  source: Scalars['Int'];
  sourceId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicModuleCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  moduleId?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicModuleCreateInput = {
  clinic: ClinicCreateNestedOneWithoutClinicModulesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  module: ModuleCreateNestedOneWithoutClinicModulesInput;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  moduleId: Scalars['String'];
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleCreateManyClinicInputEnvelope = {
  data: Array<ClinicModuleCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicModuleCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  moduleId: Scalars['String'];
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleCreateManyModuleInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleCreateManyModuleInputEnvelope = {
  data: Array<ClinicModuleCreateManyModuleInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicModuleCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicModuleCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicModuleCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicModuleCreateManyClinicInputEnvelope>;
};

export type ClinicModuleCreateNestedManyWithoutModuleInput = {
  connect?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicModuleCreateOrConnectWithoutModuleInput>>;
  create?: Maybe<Array<ClinicModuleCreateWithoutModuleInput>>;
  createMany?: Maybe<ClinicModuleCreateManyModuleInputEnvelope>;
};

export type ClinicModuleCreateOrConnectWithoutClinicInput = {
  create: ClinicModuleCreateWithoutClinicInput;
  where: ClinicModuleWhereUniqueInput;
};

export type ClinicModuleCreateOrConnectWithoutModuleInput = {
  create: ClinicModuleCreateWithoutModuleInput;
  where: ClinicModuleWhereUniqueInput;
};

export type ClinicModuleCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  module: ModuleCreateNestedOneWithoutClinicModulesInput;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleCreateWithoutModuleInput = {
  clinic: ClinicCreateNestedOneWithoutClinicModulesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleGroupByOutputType = {
  __typename?: 'ClinicModuleGroupByOutputType';
  _count?: Maybe<ClinicModuleCountAggregateOutputType>;
  _max?: Maybe<ClinicModuleMaxAggregateOutputType>;
  _min?: Maybe<ClinicModuleMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  moduleId: Scalars['String'];
  source: ClinicModuleSource;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ClinicModuleListRelationFilter = {
  every?: Maybe<ClinicModuleWhereInput>;
  none?: Maybe<ClinicModuleWhereInput>;
  some?: Maybe<ClinicModuleWhereInput>;
};

export type ClinicModuleMaxAggregateOutputType = {
  __typename?: 'ClinicModuleMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  moduleId?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  moduleId?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicModuleMinAggregateOutputType = {
  __typename?: 'ClinicModuleMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  moduleId?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  moduleId?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicModuleOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicModuleOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicModuleOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  module?: Maybe<ModuleOrderByWithRelationInput>;
  moduleId?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicModuleOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  ModuleId = 'moduleId',
  SourceId = 'sourceId'
}

export type ClinicModuleOrderByRelevanceInput = {
  fields: Array<ClinicModuleOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicModuleOrderByWithAggregationInput = {
  _count?: Maybe<ClinicModuleCountOrderByAggregateInput>;
  _max?: Maybe<ClinicModuleMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicModuleMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  moduleId?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicModuleOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicModuleOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  module?: Maybe<ModuleOrderByWithRelationInput>;
  moduleId?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicModuleOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicModuleOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  module?: Maybe<ModuleOrderByWithRelationInput>;
  moduleId?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  sourceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicModuleScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  ModuleId = 'moduleId',
  Source = 'source',
  SourceId = 'sourceId',
  UpdatedAt = 'updatedAt'
}

export type ClinicModuleScalarWhereInput = {
  AND?: Maybe<Array<ClinicModuleScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicModuleScalarWhereInput>>;
  OR?: Maybe<Array<ClinicModuleScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  moduleId?: Maybe<StringFilter>;
  source?: Maybe<EnumClinicModuleSourceFilter>;
  sourceId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicModuleScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicModuleScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicModuleScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicModuleScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  moduleId?: Maybe<StringWithAggregatesFilter>;
  source?: Maybe<EnumClinicModuleSourceWithAggregatesFilter>;
  sourceId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum ClinicModuleSource {
  Direct = 'Direct',
  ProductPackage = 'ProductPackage'
}

export type ClinicModuleUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  moduleId: Scalars['String'];
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicModuleCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicModuleCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicModuleCreateManyClinicInputEnvelope>;
};

export type ClinicModuleUncheckedCreateNestedManyWithoutModuleInput = {
  connect?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicModuleCreateOrConnectWithoutModuleInput>>;
  create?: Maybe<Array<ClinicModuleCreateWithoutModuleInput>>;
  createMany?: Maybe<ClinicModuleCreateManyModuleInputEnvelope>;
};

export type ClinicModuleUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  moduleId: Scalars['String'];
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUncheckedCreateWithoutModuleInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  moduleId?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  moduleId?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  moduleId?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicModuleCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicModuleCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicModuleCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicModuleScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  set?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  update?: Maybe<Array<ClinicModuleUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicModuleUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicModuleUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicModuleUncheckedUpdateManyWithoutModuleInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUncheckedUpdateManyWithoutModuleNestedInput = {
  connect?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicModuleCreateOrConnectWithoutModuleInput>>;
  create?: Maybe<Array<ClinicModuleCreateWithoutModuleInput>>;
  createMany?: Maybe<ClinicModuleCreateManyModuleInputEnvelope>;
  delete?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicModuleScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  set?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  update?: Maybe<Array<ClinicModuleUpdateWithWhereUniqueWithoutModuleInput>>;
  updateMany?: Maybe<Array<ClinicModuleUpdateManyWithWhereWithoutModuleInput>>;
  upsert?: Maybe<Array<ClinicModuleUpsertWithWhereUniqueWithoutModuleInput>>;
};

export type ClinicModuleUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  moduleId?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUncheckedUpdateWithoutModuleInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicModulesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  module?: Maybe<ModuleUpdateOneRequiredWithoutClinicModulesNestedInput>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicModuleUpdateManyMutationInput;
  where: ClinicModuleScalarWhereInput;
};

export type ClinicModuleUpdateManyWithWhereWithoutModuleInput = {
  data: ClinicModuleUpdateManyMutationInput;
  where: ClinicModuleScalarWhereInput;
};

export type ClinicModuleUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicModuleCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicModuleCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicModuleCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicModuleScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  set?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  update?: Maybe<Array<ClinicModuleUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicModuleUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicModuleUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicModuleUpdateManyWithoutModuleNestedInput = {
  connect?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicModuleCreateOrConnectWithoutModuleInput>>;
  create?: Maybe<Array<ClinicModuleCreateWithoutModuleInput>>;
  createMany?: Maybe<ClinicModuleCreateManyModuleInputEnvelope>;
  delete?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicModuleScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  set?: Maybe<Array<ClinicModuleWhereUniqueInput>>;
  update?: Maybe<Array<ClinicModuleUpdateWithWhereUniqueWithoutModuleInput>>;
  updateMany?: Maybe<Array<ClinicModuleUpdateManyWithWhereWithoutModuleInput>>;
  upsert?: Maybe<Array<ClinicModuleUpsertWithWhereUniqueWithoutModuleInput>>;
};

export type ClinicModuleUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicModuleUpdateWithoutClinicInput;
  where: ClinicModuleWhereUniqueInput;
};

export type ClinicModuleUpdateWithWhereUniqueWithoutModuleInput = {
  data: ClinicModuleUpdateWithoutModuleInput;
  where: ClinicModuleWhereUniqueInput;
};

export type ClinicModuleUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  module?: Maybe<ModuleUpdateOneRequiredWithoutClinicModulesNestedInput>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUpdateWithoutModuleInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicModulesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<ClinicModuleSource>;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicModuleUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicModuleCreateWithoutClinicInput;
  update: ClinicModuleUpdateWithoutClinicInput;
  where: ClinicModuleWhereUniqueInput;
};

export type ClinicModuleUpsertWithWhereUniqueWithoutModuleInput = {
  create: ClinicModuleCreateWithoutModuleInput;
  update: ClinicModuleUpdateWithoutModuleInput;
  where: ClinicModuleWhereUniqueInput;
};

export type ClinicModuleWhereInput = {
  AND?: Maybe<Array<ClinicModuleWhereInput>>;
  NOT?: Maybe<Array<ClinicModuleWhereInput>>;
  OR?: Maybe<Array<ClinicModuleWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  module?: Maybe<ModuleScalarRelationFilter>;
  moduleId?: Maybe<StringFilter>;
  source?: Maybe<EnumClinicModuleSourceFilter>;
  sourceId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicModuleWhereUniqueInput = {
  AND?: Maybe<Array<ClinicModuleWhereInput>>;
  NOT?: Maybe<Array<ClinicModuleWhereInput>>;
  OR?: Maybe<Array<ClinicModuleWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  module?: Maybe<ModuleScalarRelationFilter>;
  moduleId?: Maybe<StringFilter>;
  source?: Maybe<EnumClinicModuleSourceFilter>;
  sourceId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicWhereInput>>;
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateListRelationFilter>;
  EmailCampaignLog?: Maybe<EmailCampaignLogListRelationFilter>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeListRelationFilter>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<ClinicWhereInput>>;
  OR?: Maybe<Array<ClinicWhereInput>>;
  Rules?: Maybe<RulesListRelationFilter>;
  activationDate?: Maybe<DateTimeNullableFilter>;
  addressLine1?: Maybe<StringNullableFilter>;
  addressLine2?: Maybe<StringNullableFilter>;
  allowAllUsersToCloseConsultations?: Maybe<BoolNullableFilter>;
  appoinmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  autoSubscriptionReceiptEmails?: Maybe<JsonNullableFilter>;
  automaticSubscriptionReceipts?: Maybe<BoolFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationNullableScalarRelationFilter>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationListRelationFilter>;
  benefitsProvided?: Maybe<CareBenefitUsageListRelationFilter>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckListRelationFilter>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberListRelationFilter>;
  callerIdPhoneNumber?: Maybe<StringNullableFilter>;
  calls?: Maybe<CallHistoryListRelationFilter>;
  canceledAt?: Maybe<DateTimeNullableFilter>;
  cancellationNote?: Maybe<StringNullableFilter>;
  cancellationReason?: Maybe<StringNullableFilter>;
  carePayoutOrganization?: Maybe<OrganizationNullableScalarRelationFilter>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  carePlanProviderGroupId?: Maybe<StringNullableFilter>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionListRelationFilter>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  city?: Maybe<StringNullableFilter>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupNullableScalarRelationFilter>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingListRelationFilter>;
  clinicEmail?: Maybe<StringNullableFilter>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingListRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeListRelationFilter>;
  clinicModules?: Maybe<ClinicModuleListRelationFilter>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourListRelationFilter>;
  clinicOnboardings?: Maybe<ClinicOnboardingListRelationFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberListRelationFilter>;
  clinicRooms?: Maybe<ClinicRoomListRelationFilter>;
  clinicSetting?: Maybe<ClinicSettingNullableScalarRelationFilter>;
  clinicSettingId?: Maybe<StringNullableFilter>;
  clinicUserFilters?: Maybe<ClinicUserFilterListRelationFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingNullableScalarRelationFilter>;
  clinicWidgetSettingId?: Maybe<StringNullableFilter>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeListRelationFilter>;
  consultationCost?: Maybe<FloatNullableFilter>;
  consultationRequests?: Maybe<ConsultationRequestListRelationFilter>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  corporateId?: Maybe<StringNullableFilter>;
  country?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  crmId?: Maybe<StringNullableFilter>;
  crmUrlParams?: Maybe<JsonNullableFilter>;
  customerId?: Maybe<StringNullableFilter>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleListRelationFilter>;
  emailCampaign?: Maybe<EmailCampaignListRelationFilter>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateListRelationFilter>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadListRelationFilter>;
  featureFlags?: Maybe<FeatureFlagListRelationFilter>;
  financialTransactions?: Maybe<FinancialTransactionListRelationFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firebaseVets?: Maybe<JsonNullableFilter>;
  followUpCost?: Maybe<FloatNullableFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  formTemplates?: Maybe<FormTemplateListRelationFilter>;
  fullAddress?: Maybe<StringNullableFilter>;
  googlePlace?: Maybe<GooglePlaceNullableScalarRelationFilter>;
  hasServiceReminders?: Maybe<BoolNullableFilter>;
  hasSmsConversations?: Maybe<BoolNullableFilter>;
  headUserId?: Maybe<StringNullableFilter>;
  hours?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  incomeMethod?: Maybe<StringNullableFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentListRelationFilter>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationListRelationFilter>;
  integrationInfo?: Maybe<JsonNullableFilter>;
  integrationSystem?: Maybe<StringNullableFilter>;
  integrationType?: Maybe<StringNullableFilter>;
  integrations?: Maybe<ClinicPimsIntegrationListRelationFilter>;
  isAddAppointmentDisabled?: Maybe<BoolNullableFilter>;
  isCallerIdVerified?: Maybe<BoolNullableFilter>;
  isClinicActive?: Maybe<BoolFilter>;
  isClinicEligibleForPayments?: Maybe<BoolFilter>;
  isConsultationsActive?: Maybe<BoolNullableFilter>;
  isIntegrationActive?: Maybe<BoolNullableFilter>;
  isPaymentUsBank?: Maybe<BoolNullableFilter>;
  isServiceRemindersActive?: Maybe<BoolNullableFilter>;
  lastPrintOrderedOn?: Maybe<DateTimeNullableFilter>;
  lastPrintOrderedQuantity?: Maybe<IntNullableFilter>;
  lat?: Maybe<FloatNullableFilter>;
  legalEntity?: Maybe<LegalEntityNullableScalarRelationFilter>;
  legalEntityId?: Maybe<StringNullableFilter>;
  logo?: Maybe<StringNullableFilter>;
  long?: Maybe<FloatNullableFilter>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  loyaltyProgram?: Maybe<LoyaltyProgramNullableScalarRelationFilter>;
  loyaltyProgramId?: Maybe<StringNullableFilter>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  marketEmail?: Maybe<StringNullableFilter>;
  marketFacebookNumber?: Maybe<IntNullableFilter>;
  marketFacebookPageId?: Maybe<StringNullableFilter>;
  marketFacebookPageToken?: Maybe<StringNullableFilter>;
  massTextAlerts?: Maybe<MassTextAlertListRelationFilter>;
  media?: Maybe<MediaListRelationFilter>;
  messageTemplates?: Maybe<MessageTemplateListRelationFilter>;
  name?: Maybe<StringFilter>;
  optimizedLogoUrl?: Maybe<StringNullableFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  paymentAddress?: Maybe<StringNullableFilter>;
  paymentBankAccountNumber?: Maybe<StringNullableFilter>;
  paymentBankRoutingNumber?: Maybe<StringNullableFilter>;
  paymentCity?: Maybe<StringNullableFilter>;
  paymentName?: Maybe<StringNullableFilter>;
  paymentPhone?: Maybe<StringNullableFilter>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  paymentState?: Maybe<StringNullableFilter>;
  paymentZip?: Maybe<StringNullableFilter>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodListRelationFilter>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingNullableScalarRelationFilter>;
  pets?: Maybe<PetListRelationFilter>;
  petsId?: Maybe<PetListRelationFilter>;
  phone?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  postcardSettings?: Maybe<ClinicPostcardSettingListRelationFilter>;
  ppcLocationId?: Maybe<IntNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  printLastOrder?: Maybe<DateTimeNullableFilter>;
  printReceivedQuantity?: Maybe<IntNullableFilter>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionListRelationFilter>;
  promoCodes?: Maybe<PromoCodeListRelationFilter>;
  recaps?: Maybe<RecapListRelationFilter>;
  remindersIntegrationRequestEmail?: Maybe<StringNullableFilter>;
  responseTime?: Maybe<FloatNullableFilter>;
  roles?: Maybe<StaffRoleListRelationFilter>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  smsPhoneNumber?: Maybe<StringNullableFilter>;
  staff?: Maybe<VetInfoListRelationFilter>;
  staffId?: Maybe<VetInfoListRelationFilter>;
  state?: Maybe<StringNullableFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountListRelationFilter>;
  stripeSubscriptionId?: Maybe<StringNullableFilter>;
  stripeSubscriptionPlan?: Maybe<StringNullableFilter>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationListRelationFilter>;
  submerchantApprovedAt?: Maybe<DateTimeNullableFilter>;
  submerchantId?: Maybe<StringNullableFilter>;
  submerchantIsActive?: Maybe<BoolNullableFilter>;
  submerchantStatus?: Maybe<StringNullableFilter>;
  submerchantStripeChargesEnabled?: Maybe<BoolNullableFilter>;
  submerchantStripeHasCustomPayouts?: Maybe<BoolNullableFilter>;
  submerchantStripeId?: Maybe<StringNullableFilter>;
  submerchantStripePayoutsEnabled?: Maybe<BoolNullableFilter>;
  submerchantStripeStatus?: Maybe<StringNullableFilter>;
  subscribedAt?: Maybe<DateTimeNullableFilter>;
  subscriptionId?: Maybe<StringNullableFilter>;
  subscriptionPlan?: Maybe<StringNullableFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationNullableScalarRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  timezone?: Maybe<IntNullableFilter>;
  timezoneName?: Maybe<StringNullableFilter>;
  token?: Maybe<StringNullableFilter>;
  twilioConfiguration?: Maybe<TwilioConfigurationNullableScalarRelationFilter>;
  twilioVerifications?: Maybe<TwilioVerificationListRelationFilter>;
  unlayerSetting?: Maybe<UnlayerSettingNullableScalarRelationFilter>;
  unlayerSettingId?: Maybe<IntNullableFilter>;
  unsubscribedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnListRelationFilter>;
  userTaskLists?: Maybe<UserTaskListListRelationFilter>;
  users?: Maybe<UserListRelationFilter>;
  usersId?: Maybe<UserNullableScalarRelationFilter>;
  vaccinations?: Maybe<VaccinationListRelationFilter>;
  vetAvailabilities?: Maybe<VetAvailabilityListRelationFilter>;
  vetsourceInstallation?: Maybe<VetsourceInstallationNullableScalarRelationFilter>;
  websiteUrl?: Maybe<StringNullableFilter>;
  widgetSettings?: Maybe<JsonNullableFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type ClinicOfficeHour = {
  __typename?: 'ClinicOfficeHour';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  closeAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  dayOfWeek: Scalars['Int'];
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  isOpenTwentyFourHours: Scalars['Boolean'];
  openAt: Scalars['DateTime'];
  type: ClinicOfficeHoursType;
  updatedAt: Scalars['DateTime'];
};


export type ClinicOfficeHourClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicOfficeHourAvgAggregateOutputType = {
  __typename?: 'ClinicOfficeHourAvgAggregateOutputType';
  dayOfWeek?: Maybe<Scalars['Float']>;
};

export type ClinicOfficeHourAvgOrderByAggregateInput = {
  dayOfWeek?: Maybe<SortOrder>;
};

export type ClinicOfficeHourCountAggregateOutputType = {
  __typename?: 'ClinicOfficeHourCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  closeAt: Scalars['Int'];
  createdAt: Scalars['Int'];
  dayOfWeek: Scalars['Int'];
  id: Scalars['Int'];
  isEnabled: Scalars['Int'];
  isOpenTwentyFourHours: Scalars['Int'];
  openAt: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicOfficeHourCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  closeAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  isOpenTwentyFourHours?: Maybe<SortOrder>;
  openAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicOfficeHourCreateInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicOfficeHoursInput>;
  closeAt: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt: Scalars['DateTime'];
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourCreateManyClinicInput = {
  closeAt: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt: Scalars['DateTime'];
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourCreateManyClinicInputEnvelope = {
  data: Array<ClinicOfficeHourCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicOfficeHourCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  closeAt: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt: Scalars['DateTime'];
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicOfficeHourWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicOfficeHourCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicOfficeHourCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicOfficeHourCreateManyClinicInputEnvelope>;
};

export type ClinicOfficeHourCreateOrConnectWithoutClinicInput = {
  create: ClinicOfficeHourCreateWithoutClinicInput;
  where: ClinicOfficeHourWhereUniqueInput;
};

export type ClinicOfficeHourCreateWithoutClinicInput = {
  closeAt: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt: Scalars['DateTime'];
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourGroupByOutputType = {
  __typename?: 'ClinicOfficeHourGroupByOutputType';
  _avg?: Maybe<ClinicOfficeHourAvgAggregateOutputType>;
  _count?: Maybe<ClinicOfficeHourCountAggregateOutputType>;
  _max?: Maybe<ClinicOfficeHourMaxAggregateOutputType>;
  _min?: Maybe<ClinicOfficeHourMinAggregateOutputType>;
  _sum?: Maybe<ClinicOfficeHourSumAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  closeAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  dayOfWeek: Scalars['Int'];
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  isOpenTwentyFourHours: Scalars['Boolean'];
  openAt: Scalars['DateTime'];
  type: ClinicOfficeHoursType;
  updatedAt: Scalars['DateTime'];
};

export type ClinicOfficeHourListRelationFilter = {
  every?: Maybe<ClinicOfficeHourWhereInput>;
  none?: Maybe<ClinicOfficeHourWhereInput>;
  some?: Maybe<ClinicOfficeHourWhereInput>;
};

export type ClinicOfficeHourMaxAggregateOutputType = {
  __typename?: 'ClinicOfficeHourMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  closeAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  closeAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  isOpenTwentyFourHours?: Maybe<SortOrder>;
  openAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicOfficeHourMinAggregateOutputType = {
  __typename?: 'ClinicOfficeHourMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  closeAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  closeAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  isOpenTwentyFourHours?: Maybe<SortOrder>;
  openAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicOfficeHourOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicOfficeHourOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicOfficeHourOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  closeAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  isOpenTwentyFourHours?: Maybe<SortOrder>;
  openAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicOfficeHourOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id'
}

export type ClinicOfficeHourOrderByRelevanceInput = {
  fields: Array<ClinicOfficeHourOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicOfficeHourOrderByWithAggregationInput = {
  _avg?: Maybe<ClinicOfficeHourAvgOrderByAggregateInput>;
  _count?: Maybe<ClinicOfficeHourCountOrderByAggregateInput>;
  _max?: Maybe<ClinicOfficeHourMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicOfficeHourMinOrderByAggregateInput>;
  _sum?: Maybe<ClinicOfficeHourSumOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  closeAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  isOpenTwentyFourHours?: Maybe<SortOrder>;
  openAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicOfficeHourOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicOfficeHourOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  closeAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  isOpenTwentyFourHours?: Maybe<SortOrder>;
  openAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicOfficeHourOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicOfficeHourOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  closeAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  isOpenTwentyFourHours?: Maybe<SortOrder>;
  openAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicOfficeHourScalarFieldEnum {
  ClinicId = 'clinicId',
  CloseAt = 'closeAt',
  CreatedAt = 'createdAt',
  DayOfWeek = 'dayOfWeek',
  Id = 'id',
  IsEnabled = 'isEnabled',
  IsOpenTwentyFourHours = 'isOpenTwentyFourHours',
  OpenAt = 'openAt',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type ClinicOfficeHourScalarWhereInput = {
  AND?: Maybe<Array<ClinicOfficeHourScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicOfficeHourScalarWhereInput>>;
  OR?: Maybe<Array<ClinicOfficeHourScalarWhereInput>>;
  clinicId?: Maybe<StringNullableFilter>;
  closeAt?: Maybe<DateTimeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dayOfWeek?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  isEnabled?: Maybe<BoolFilter>;
  isOpenTwentyFourHours?: Maybe<BoolFilter>;
  openAt?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumClinicOfficeHoursTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicOfficeHourScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicOfficeHourScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicOfficeHourScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicOfficeHourScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  closeAt?: Maybe<DateTimeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  dayOfWeek?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isEnabled?: Maybe<BoolWithAggregatesFilter>;
  isOpenTwentyFourHours?: Maybe<BoolWithAggregatesFilter>;
  openAt?: Maybe<DateTimeWithAggregatesFilter>;
  type?: Maybe<EnumClinicOfficeHoursTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicOfficeHourSumAggregateOutputType = {
  __typename?: 'ClinicOfficeHourSumAggregateOutputType';
  dayOfWeek?: Maybe<Scalars['Int']>;
};

export type ClinicOfficeHourSumOrderByAggregateInput = {
  dayOfWeek?: Maybe<SortOrder>;
};

export type ClinicOfficeHourUncheckedCreateInput = {
  clinicId?: Maybe<Scalars['String']>;
  closeAt: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt: Scalars['DateTime'];
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicOfficeHourWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicOfficeHourCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicOfficeHourCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicOfficeHourCreateManyClinicInputEnvelope>;
};

export type ClinicOfficeHourUncheckedCreateWithoutClinicInput = {
  closeAt: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt: Scalars['DateTime'];
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  closeAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  closeAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourUncheckedUpdateManyWithoutClinicInput = {
  closeAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicOfficeHourWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicOfficeHourCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicOfficeHourCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicOfficeHourCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicOfficeHourWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicOfficeHourScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicOfficeHourWhereUniqueInput>>;
  set?: Maybe<Array<ClinicOfficeHourWhereUniqueInput>>;
  update?: Maybe<Array<ClinicOfficeHourUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicOfficeHourUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicOfficeHourUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicOfficeHourUncheckedUpdateWithoutClinicInput = {
  closeAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutClinicOfficeHoursNestedInput>;
  closeAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourUpdateManyMutationInput = {
  closeAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicOfficeHourUpdateManyMutationInput;
  where: ClinicOfficeHourScalarWhereInput;
};

export type ClinicOfficeHourUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicOfficeHourWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicOfficeHourCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicOfficeHourCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicOfficeHourCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicOfficeHourWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicOfficeHourScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicOfficeHourWhereUniqueInput>>;
  set?: Maybe<Array<ClinicOfficeHourWhereUniqueInput>>;
  update?: Maybe<Array<ClinicOfficeHourUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicOfficeHourUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicOfficeHourUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicOfficeHourUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicOfficeHourUpdateWithoutClinicInput;
  where: ClinicOfficeHourWhereUniqueInput;
};

export type ClinicOfficeHourUpdateWithoutClinicInput = {
  closeAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isOpenTwentyFourHours?: Maybe<Scalars['Boolean']>;
  openAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<ClinicOfficeHoursType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOfficeHourUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicOfficeHourCreateWithoutClinicInput;
  update: ClinicOfficeHourUpdateWithoutClinicInput;
  where: ClinicOfficeHourWhereUniqueInput;
};

export type ClinicOfficeHourWhereInput = {
  AND?: Maybe<Array<ClinicOfficeHourWhereInput>>;
  NOT?: Maybe<Array<ClinicOfficeHourWhereInput>>;
  OR?: Maybe<Array<ClinicOfficeHourWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  closeAt?: Maybe<DateTimeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dayOfWeek?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  isEnabled?: Maybe<BoolFilter>;
  isOpenTwentyFourHours?: Maybe<BoolFilter>;
  openAt?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumClinicOfficeHoursTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicOfficeHourWhereUniqueInput = {
  AND?: Maybe<Array<ClinicOfficeHourWhereInput>>;
  NOT?: Maybe<Array<ClinicOfficeHourWhereInput>>;
  OR?: Maybe<Array<ClinicOfficeHourWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  closeAt?: Maybe<DateTimeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dayOfWeek?: Maybe<IntFilter>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<BoolFilter>;
  isOpenTwentyFourHours?: Maybe<BoolFilter>;
  openAt?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumClinicOfficeHoursTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum ClinicOfficeHoursType {
  AutomationHours = 'AutomationHours',
  BusinessHours = 'BusinessHours',
  DirectBookingHours = 'DirectBookingHours'
}

export type ClinicOnboarding = {
  __typename?: 'ClinicOnboarding';
  clinic: Clinic;
  clinicId: Scalars['String'];
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage: Scalars['String'];
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type ClinicOnboardingCountAggregateOutputType = {
  __typename?: 'ClinicOnboardingCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  completionDate: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  kickoffDate: Scalars['Int'];
  pauseUntilDate: Scalars['Int'];
  salesforceOnboardingId: Scalars['Int'];
  stage: Scalars['Int'];
  trainingDate: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicOnboardingCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  completionDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  kickoffDate?: Maybe<SortOrder>;
  pauseUntilDate?: Maybe<SortOrder>;
  salesforceOnboardingId?: Maybe<SortOrder>;
  stage?: Maybe<SortOrder>;
  trainingDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicOnboardingCreateInput = {
  clinic: ClinicCreateNestedOneWithoutClinicOnboardingsInput;
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingCreateManyClinicInput = {
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingCreateManyClinicInputEnvelope = {
  data: Array<ClinicOnboardingCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicOnboardingCreateManyInput = {
  clinicId: Scalars['String'];
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicOnboardingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicOnboardingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicOnboardingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicOnboardingCreateManyClinicInputEnvelope>;
};

export type ClinicOnboardingCreateOrConnectWithoutClinicInput = {
  create: ClinicOnboardingCreateWithoutClinicInput;
  where: ClinicOnboardingWhereUniqueInput;
};

export type ClinicOnboardingCreateWithoutClinicInput = {
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingGroupByOutputType = {
  __typename?: 'ClinicOnboardingGroupByOutputType';
  _count?: Maybe<ClinicOnboardingCountAggregateOutputType>;
  _max?: Maybe<ClinicOnboardingMaxAggregateOutputType>;
  _min?: Maybe<ClinicOnboardingMinAggregateOutputType>;
  clinicId: Scalars['String'];
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage: Scalars['String'];
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type ClinicOnboardingListRelationFilter = {
  every?: Maybe<ClinicOnboardingWhereInput>;
  none?: Maybe<ClinicOnboardingWhereInput>;
  some?: Maybe<ClinicOnboardingWhereInput>;
};

export type ClinicOnboardingMaxAggregateOutputType = {
  __typename?: 'ClinicOnboardingMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  completionDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  kickoffDate?: Maybe<SortOrder>;
  pauseUntilDate?: Maybe<SortOrder>;
  salesforceOnboardingId?: Maybe<SortOrder>;
  stage?: Maybe<SortOrder>;
  trainingDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicOnboardingMinAggregateOutputType = {
  __typename?: 'ClinicOnboardingMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  completionDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  kickoffDate?: Maybe<SortOrder>;
  pauseUntilDate?: Maybe<SortOrder>;
  salesforceOnboardingId?: Maybe<SortOrder>;
  stage?: Maybe<SortOrder>;
  trainingDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicOnboardingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicOnboardingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicOnboardingOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  completionDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  kickoffDate?: Maybe<SortOrder>;
  pauseUntilDate?: Maybe<SortOrder>;
  salesforceOnboardingId?: Maybe<SortOrder>;
  stage?: Maybe<SortOrder>;
  trainingDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicOnboardingOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  SalesforceOnboardingId = 'salesforceOnboardingId',
  Stage = 'stage'
}

export type ClinicOnboardingOrderByRelevanceInput = {
  fields: Array<ClinicOnboardingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicOnboardingOrderByWithAggregationInput = {
  _count?: Maybe<ClinicOnboardingCountOrderByAggregateInput>;
  _max?: Maybe<ClinicOnboardingMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicOnboardingMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  completionDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  kickoffDate?: Maybe<SortOrder>;
  pauseUntilDate?: Maybe<SortOrder>;
  salesforceOnboardingId?: Maybe<SortOrder>;
  stage?: Maybe<SortOrder>;
  trainingDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicOnboardingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicOnboardingOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  completionDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  kickoffDate?: Maybe<SortOrder>;
  pauseUntilDate?: Maybe<SortOrder>;
  salesforceOnboardingId?: Maybe<SortOrder>;
  stage?: Maybe<SortOrder>;
  trainingDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicOnboardingOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicOnboardingOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  completionDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  kickoffDate?: Maybe<SortOrder>;
  pauseUntilDate?: Maybe<SortOrder>;
  salesforceOnboardingId?: Maybe<SortOrder>;
  stage?: Maybe<SortOrder>;
  trainingDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicOnboardingScalarFieldEnum {
  ClinicId = 'clinicId',
  CompletionDate = 'completionDate',
  CreatedAt = 'createdAt',
  Id = 'id',
  KickoffDate = 'kickoffDate',
  PauseUntilDate = 'pauseUntilDate',
  SalesforceOnboardingId = 'salesforceOnboardingId',
  Stage = 'stage',
  TrainingDate = 'trainingDate',
  UpdatedAt = 'updatedAt'
}

export type ClinicOnboardingScalarWhereInput = {
  AND?: Maybe<Array<ClinicOnboardingScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicOnboardingScalarWhereInput>>;
  OR?: Maybe<Array<ClinicOnboardingScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  completionDate?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  kickoffDate?: Maybe<DateTimeNullableFilter>;
  pauseUntilDate?: Maybe<DateTimeNullableFilter>;
  salesforceOnboardingId?: Maybe<StringNullableFilter>;
  stage?: Maybe<StringFilter>;
  trainingDate?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicOnboardingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicOnboardingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicOnboardingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicOnboardingScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  completionDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  kickoffDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  pauseUntilDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  salesforceOnboardingId?: Maybe<StringNullableWithAggregatesFilter>;
  stage?: Maybe<StringWithAggregatesFilter>;
  trainingDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicOnboardingUncheckedCreateInput = {
  clinicId: Scalars['String'];
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicOnboardingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicOnboardingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicOnboardingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicOnboardingCreateManyClinicInputEnvelope>;
};

export type ClinicOnboardingUncheckedCreateWithoutClinicInput = {
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingUncheckedUpdateManyWithoutClinicInput = {
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicOnboardingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicOnboardingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicOnboardingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicOnboardingCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicOnboardingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicOnboardingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicOnboardingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicOnboardingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicOnboardingUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicOnboardingUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicOnboardingUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicOnboardingUncheckedUpdateWithoutClinicInput = {
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicOnboardingsNestedInput>;
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingUpdateManyMutationInput = {
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicOnboardingUpdateManyMutationInput;
  where: ClinicOnboardingScalarWhereInput;
};

export type ClinicOnboardingUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicOnboardingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicOnboardingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicOnboardingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicOnboardingCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicOnboardingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicOnboardingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicOnboardingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicOnboardingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicOnboardingUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicOnboardingUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicOnboardingUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicOnboardingUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicOnboardingUpdateWithoutClinicInput;
  where: ClinicOnboardingWhereUniqueInput;
};

export type ClinicOnboardingUpdateWithoutClinicInput = {
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicOnboardingUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicOnboardingCreateWithoutClinicInput;
  update: ClinicOnboardingUpdateWithoutClinicInput;
  where: ClinicOnboardingWhereUniqueInput;
};

export type ClinicOnboardingWhereInput = {
  AND?: Maybe<Array<ClinicOnboardingWhereInput>>;
  NOT?: Maybe<Array<ClinicOnboardingWhereInput>>;
  OR?: Maybe<Array<ClinicOnboardingWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  completionDate?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  kickoffDate?: Maybe<DateTimeNullableFilter>;
  pauseUntilDate?: Maybe<DateTimeNullableFilter>;
  salesforceOnboardingId?: Maybe<StringNullableFilter>;
  stage?: Maybe<StringFilter>;
  trainingDate?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicOnboardingWhereUniqueInput = {
  AND?: Maybe<Array<ClinicOnboardingWhereInput>>;
  NOT?: Maybe<Array<ClinicOnboardingWhereInput>>;
  OR?: Maybe<Array<ClinicOnboardingWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  completionDate?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  kickoffDate?: Maybe<DateTimeNullableFilter>;
  pauseUntilDate?: Maybe<DateTimeNullableFilter>;
  salesforceOnboardingId?: Maybe<StringNullableFilter>;
  stage?: Maybe<StringFilter>;
  trainingDate?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicOrderByRelationAndSearchRelevanceInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateOrderByRelationAggregateInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogOrderByRelationAggregateInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeOrderByRelationAggregateInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  Rules?: Maybe<RulesOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicOrderByRelevanceInput>;
  activationDate?: Maybe<SortOrder>;
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  allowAllUsersToCloseConsultations?: Maybe<SortOrder>;
  appoinmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  autoSubscriptionReceiptEmails?: Maybe<SortOrder>;
  automaticSubscriptionReceipts?: Maybe<SortOrder>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationOrderByWithRelationInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationOrderByRelationAggregateInput>;
  benefitsProvided?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckOrderByRelationAggregateInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberOrderByRelationAggregateInput>;
  callerIdPhoneNumber?: Maybe<SortOrder>;
  calls?: Maybe<CallHistoryOrderByRelationAggregateInput>;
  canceledAt?: Maybe<SortOrder>;
  cancellationNote?: Maybe<SortOrder>;
  cancellationReason?: Maybe<SortOrder>;
  carePayoutOrganization?: Maybe<OrganizationOrderByWithRelationInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  carePlanProviderGroupId?: Maybe<SortOrder>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionOrderByRelationAggregateInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeOrderByRelationAggregateInput>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  city?: Maybe<SortOrder>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupOrderByWithRelationInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingOrderByRelationAggregateInput>;
  clinicEmail?: Maybe<SortOrder>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingOrderByRelationAggregateInput>;
  clinicEmployees?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  clinicModules?: Maybe<ClinicModuleOrderByRelationAggregateInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourOrderByRelationAggregateInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingOrderByRelationAggregateInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  clinicPets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberOrderByRelationAggregateInput>;
  clinicRooms?: Maybe<ClinicRoomOrderByRelationAggregateInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  clinicUserFilters?: Maybe<ClinicUserFilterOrderByRelationAggregateInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestOrderByRelationAggregateInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingOrderByWithRelationInput>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeOrderByRelationAggregateInput>;
  consultationCost?: Maybe<SortOrder>;
  consultationRequests?: Maybe<ConsultationRequestOrderByRelationAggregateInput>;
  consultations?: Maybe<ConsultationOrderByRelationAggregateInput>;
  corporateId?: Maybe<SortOrder>;
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  crmUrlParams?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleOrderByRelationAggregateInput>;
  emailCampaign?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateOrderByRelationAggregateInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadOrderByRelationAggregateInput>;
  featureFlags?: Maybe<FeatureFlagOrderByRelationAggregateInput>;
  financialTransactions?: Maybe<FinancialTransactionOrderByRelationAggregateInput>;
  firebaseId?: Maybe<SortOrder>;
  firebaseVets?: Maybe<SortOrder>;
  followUpCost?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  formTemplates?: Maybe<FormTemplateOrderByRelationAggregateInput>;
  fullAddress?: Maybe<SortOrder>;
  googlePlace?: Maybe<GooglePlaceOrderByWithRelationInput>;
  hasServiceReminders?: Maybe<SortOrder>;
  hasSmsConversations?: Maybe<SortOrder>;
  headUserId?: Maybe<SortOrder>;
  hours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomeMethod?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentOrderByRelationAggregateInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationOrderByRelationAggregateInput>;
  integrationInfo?: Maybe<SortOrder>;
  integrationSystem?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  integrations?: Maybe<ClinicPimsIntegrationOrderByRelationAggregateInput>;
  isAddAppointmentDisabled?: Maybe<SortOrder>;
  isCallerIdVerified?: Maybe<SortOrder>;
  isClinicActive?: Maybe<SortOrder>;
  isClinicEligibleForPayments?: Maybe<SortOrder>;
  isConsultationsActive?: Maybe<SortOrder>;
  isIntegrationActive?: Maybe<SortOrder>;
  isPaymentUsBank?: Maybe<SortOrder>;
  isServiceRemindersActive?: Maybe<SortOrder>;
  lastPrintOrderedOn?: Maybe<SortOrder>;
  lastPrintOrderedQuantity?: Maybe<SortOrder>;
  lat?: Maybe<SortOrder>;
  legalEntity?: Maybe<LegalEntityOrderByWithRelationInput>;
  legalEntityId?: Maybe<SortOrder>;
  logo?: Maybe<SortOrder>;
  long?: Maybe<SortOrder>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  loyaltyProgramId?: Maybe<SortOrder>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput>;
  marketEmail?: Maybe<SortOrder>;
  marketFacebookNumber?: Maybe<SortOrder>;
  marketFacebookPageId?: Maybe<SortOrder>;
  marketFacebookPageToken?: Maybe<SortOrder>;
  massTextAlerts?: Maybe<MassTextAlertOrderByRelationAggregateInput>;
  media?: Maybe<MediaOrderByRelationAggregateInput>;
  messageTemplates?: Maybe<MessageTemplateOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  optimizedLogoUrl?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  paymentAddress?: Maybe<SortOrder>;
  paymentBankAccountNumber?: Maybe<SortOrder>;
  paymentBankRoutingNumber?: Maybe<SortOrder>;
  paymentCity?: Maybe<SortOrder>;
  paymentName?: Maybe<SortOrder>;
  paymentPhone?: Maybe<SortOrder>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  paymentState?: Maybe<SortOrder>;
  paymentZip?: Maybe<SortOrder>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodOrderByRelationAggregateInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingOrderByWithRelationInput>;
  pets?: Maybe<PetOrderByRelationAggregateInput>;
  petsId?: Maybe<PetOrderByRelationAggregateInput>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  postcardSettings?: Maybe<ClinicPostcardSettingOrderByRelationAggregateInput>;
  ppcLocationId?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  printLastOrder?: Maybe<SortOrder>;
  printReceivedQuantity?: Maybe<SortOrder>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionOrderByRelationAggregateInput>;
  promoCodes?: Maybe<PromoCodeOrderByRelationAggregateInput>;
  recaps?: Maybe<RecapOrderByRelationAggregateInput>;
  remindersIntegrationRequestEmail?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  roles?: Maybe<StaffRoleOrderByRelationAggregateInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  smsPhoneNumber?: Maybe<SortOrder>;
  staff?: Maybe<VetInfoOrderByRelationAggregateInput>;
  staffId?: Maybe<VetInfoOrderByRelationAggregateInput>;
  state?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountOrderByRelationAggregateInput>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  stripeSubscriptionPlan?: Maybe<SortOrder>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationOrderByRelationAggregateInput>;
  submerchantApprovedAt?: Maybe<SortOrder>;
  submerchantId?: Maybe<SortOrder>;
  submerchantIsActive?: Maybe<SortOrder>;
  submerchantStatus?: Maybe<SortOrder>;
  submerchantStripeChargesEnabled?: Maybe<SortOrder>;
  submerchantStripeHasCustomPayouts?: Maybe<SortOrder>;
  submerchantStripeId?: Maybe<SortOrder>;
  submerchantStripePayoutsEnabled?: Maybe<SortOrder>;
  submerchantStripeStatus?: Maybe<SortOrder>;
  subscribedAt?: Maybe<SortOrder>;
  subscriptionId?: Maybe<SortOrder>;
  subscriptionPlan?: Maybe<SortOrder>;
  surveyResults?: Maybe<SurveyResultOrderByRelationAggregateInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationOrderByWithRelationInput>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  timezone?: Maybe<SortOrder>;
  timezoneName?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  twilioConfiguration?: Maybe<TwilioConfigurationOrderByWithRelationInput>;
  twilioVerifications?: Maybe<TwilioVerificationOrderByRelationAggregateInput>;
  unlayerSetting?: Maybe<UnlayerSettingOrderByWithRelationInput>;
  unlayerSettingId?: Maybe<SortOrder>;
  unsubscribedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnOrderByRelationAggregateInput>;
  userTaskLists?: Maybe<UserTaskListOrderByRelationAggregateInput>;
  users?: Maybe<UserOrderByRelationAggregateInput>;
  usersId?: Maybe<UserOrderByWithRelationInput>;
  vaccinations?: Maybe<VaccinationOrderByRelationAggregateInput>;
  vetAvailabilities?: Maybe<VetAvailabilityOrderByRelationAggregateInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationOrderByWithRelationInput>;
  websiteUrl?: Maybe<SortOrder>;
  widgetSettings?: Maybe<SortOrder>;
  workflowEventSettings?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum ClinicOrderByRelevanceFieldEnum {
  AddressLine1 = 'addressLine1',
  AddressLine2 = 'addressLine2',
  CallerIdPhoneNumber = 'callerIdPhoneNumber',
  CancellationNote = 'cancellationNote',
  CancellationReason = 'cancellationReason',
  CarePlanProviderGroupId = 'carePlanProviderGroupId',
  City = 'city',
  ClinicEmail = 'clinicEmail',
  ClinicSettingId = 'clinicSettingId',
  ClinicWidgetSettingId = 'clinicWidgetSettingId',
  CorporateId = 'corporateId',
  Country = 'country',
  CrmId = 'crmId',
  CustomerId = 'customerId',
  FirebaseId = 'firebaseId',
  FullAddress = 'fullAddress',
  HeadUserId = 'headUserId',
  Hours = 'hours',
  Id = 'id',
  IncomeMethod = 'incomeMethod',
  IntegrationSystem = 'integrationSystem',
  IntegrationType = 'integrationType',
  LegalEntityId = 'legalEntityId',
  Logo = 'logo',
  LoyaltyProgramId = 'loyaltyProgramId',
  MarketEmail = 'marketEmail',
  MarketFacebookPageId = 'marketFacebookPageId',
  MarketFacebookPageToken = 'marketFacebookPageToken',
  Name = 'name',
  OptimizedLogoUrl = 'optimizedLogoUrl',
  OrganizationId = 'organizationId',
  PaymentAddress = 'paymentAddress',
  PaymentBankAccountNumber = 'paymentBankAccountNumber',
  PaymentBankRoutingNumber = 'paymentBankRoutingNumber',
  PaymentCity = 'paymentCity',
  PaymentName = 'paymentName',
  PaymentPhone = 'paymentPhone',
  PaymentState = 'paymentState',
  PaymentZip = 'paymentZip',
  Phone = 'phone',
  PostalCode = 'postalCode',
  RemindersIntegrationRequestEmail = 'remindersIntegrationRequestEmail',
  SmsPhoneNumber = 'smsPhoneNumber',
  State = 'state',
  StripeCustomerId = 'stripeCustomerId',
  StripeSubscriptionId = 'stripeSubscriptionId',
  StripeSubscriptionPlan = 'stripeSubscriptionPlan',
  SubmerchantId = 'submerchantId',
  SubmerchantStatus = 'submerchantStatus',
  SubmerchantStripeId = 'submerchantStripeId',
  SubmerchantStripeStatus = 'submerchantStripeStatus',
  SubscriptionId = 'subscriptionId',
  SubscriptionPlan = 'subscriptionPlan',
  TimezoneName = 'timezoneName',
  Token = 'token',
  WebsiteUrl = 'websiteUrl'
}

export type ClinicOrderByRelevanceInput = {
  fields: Array<ClinicOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicOrderByWithAggregationInput = {
  _avg?: Maybe<ClinicAvgOrderByAggregateInput>;
  _count?: Maybe<ClinicCountOrderByAggregateInput>;
  _max?: Maybe<ClinicMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicMinOrderByAggregateInput>;
  _sum?: Maybe<ClinicSumOrderByAggregateInput>;
  activationDate?: Maybe<SortOrder>;
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  allowAllUsersToCloseConsultations?: Maybe<SortOrder>;
  autoSubscriptionReceiptEmails?: Maybe<SortOrder>;
  automaticSubscriptionReceipts?: Maybe<SortOrder>;
  callerIdPhoneNumber?: Maybe<SortOrder>;
  canceledAt?: Maybe<SortOrder>;
  cancellationNote?: Maybe<SortOrder>;
  cancellationReason?: Maybe<SortOrder>;
  carePlanProviderGroupId?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicEmail?: Maybe<SortOrder>;
  clinicSettingId?: Maybe<SortOrder>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  consultationCost?: Maybe<SortOrder>;
  corporateId?: Maybe<SortOrder>;
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  crmUrlParams?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firebaseVets?: Maybe<SortOrder>;
  followUpCost?: Maybe<SortOrder>;
  fullAddress?: Maybe<SortOrder>;
  hasServiceReminders?: Maybe<SortOrder>;
  hasSmsConversations?: Maybe<SortOrder>;
  headUserId?: Maybe<SortOrder>;
  hours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomeMethod?: Maybe<SortOrder>;
  integrationInfo?: Maybe<SortOrder>;
  integrationSystem?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  isAddAppointmentDisabled?: Maybe<SortOrder>;
  isCallerIdVerified?: Maybe<SortOrder>;
  isClinicActive?: Maybe<SortOrder>;
  isClinicEligibleForPayments?: Maybe<SortOrder>;
  isConsultationsActive?: Maybe<SortOrder>;
  isIntegrationActive?: Maybe<SortOrder>;
  isPaymentUsBank?: Maybe<SortOrder>;
  isServiceRemindersActive?: Maybe<SortOrder>;
  lastPrintOrderedOn?: Maybe<SortOrder>;
  lastPrintOrderedQuantity?: Maybe<SortOrder>;
  lat?: Maybe<SortOrder>;
  legalEntityId?: Maybe<SortOrder>;
  logo?: Maybe<SortOrder>;
  long?: Maybe<SortOrder>;
  loyaltyProgramId?: Maybe<SortOrder>;
  marketEmail?: Maybe<SortOrder>;
  marketFacebookNumber?: Maybe<SortOrder>;
  marketFacebookPageId?: Maybe<SortOrder>;
  marketFacebookPageToken?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  optimizedLogoUrl?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  paymentAddress?: Maybe<SortOrder>;
  paymentBankAccountNumber?: Maybe<SortOrder>;
  paymentBankRoutingNumber?: Maybe<SortOrder>;
  paymentCity?: Maybe<SortOrder>;
  paymentName?: Maybe<SortOrder>;
  paymentPhone?: Maybe<SortOrder>;
  paymentState?: Maybe<SortOrder>;
  paymentZip?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  printLastOrder?: Maybe<SortOrder>;
  printReceivedQuantity?: Maybe<SortOrder>;
  remindersIntegrationRequestEmail?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  smsPhoneNumber?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  stripeSubscriptionPlan?: Maybe<SortOrder>;
  submerchantApprovedAt?: Maybe<SortOrder>;
  submerchantId?: Maybe<SortOrder>;
  submerchantIsActive?: Maybe<SortOrder>;
  submerchantStatus?: Maybe<SortOrder>;
  submerchantStripeChargesEnabled?: Maybe<SortOrder>;
  submerchantStripeHasCustomPayouts?: Maybe<SortOrder>;
  submerchantStripeId?: Maybe<SortOrder>;
  submerchantStripePayoutsEnabled?: Maybe<SortOrder>;
  submerchantStripeStatus?: Maybe<SortOrder>;
  subscribedAt?: Maybe<SortOrder>;
  subscriptionId?: Maybe<SortOrder>;
  subscriptionPlan?: Maybe<SortOrder>;
  timezone?: Maybe<SortOrder>;
  timezoneName?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  unlayerSettingId?: Maybe<SortOrder>;
  unsubscribedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  websiteUrl?: Maybe<SortOrder>;
  widgetSettings?: Maybe<SortOrder>;
};

export type ClinicOrderByWithRelationAndSearchRelevanceInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateOrderByRelationAggregateInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogOrderByRelationAggregateInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeOrderByRelationAggregateInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  Rules?: Maybe<RulesOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicOrderByRelevanceInput>;
  activationDate?: Maybe<SortOrder>;
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  allowAllUsersToCloseConsultations?: Maybe<SortOrder>;
  appoinmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  autoSubscriptionReceiptEmails?: Maybe<SortOrder>;
  automaticSubscriptionReceipts?: Maybe<SortOrder>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationOrderByWithRelationInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationOrderByRelationAggregateInput>;
  benefitsProvided?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckOrderByRelationAggregateInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberOrderByRelationAggregateInput>;
  callerIdPhoneNumber?: Maybe<SortOrder>;
  calls?: Maybe<CallHistoryOrderByRelationAggregateInput>;
  canceledAt?: Maybe<SortOrder>;
  cancellationNote?: Maybe<SortOrder>;
  cancellationReason?: Maybe<SortOrder>;
  carePayoutOrganization?: Maybe<OrganizationOrderByWithRelationInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  carePlanProviderGroupId?: Maybe<SortOrder>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionOrderByRelationAggregateInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeOrderByRelationAggregateInput>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  city?: Maybe<SortOrder>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupOrderByWithRelationInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingOrderByRelationAggregateInput>;
  clinicEmail?: Maybe<SortOrder>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingOrderByRelationAggregateInput>;
  clinicEmployees?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  clinicModules?: Maybe<ClinicModuleOrderByRelationAggregateInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourOrderByRelationAggregateInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingOrderByRelationAggregateInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  clinicPets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberOrderByRelationAggregateInput>;
  clinicRooms?: Maybe<ClinicRoomOrderByRelationAggregateInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  clinicUserFilters?: Maybe<ClinicUserFilterOrderByRelationAggregateInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestOrderByRelationAggregateInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingOrderByWithRelationInput>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeOrderByRelationAggregateInput>;
  consultationCost?: Maybe<SortOrder>;
  consultationRequests?: Maybe<ConsultationRequestOrderByRelationAggregateInput>;
  consultations?: Maybe<ConsultationOrderByRelationAggregateInput>;
  corporateId?: Maybe<SortOrder>;
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  crmUrlParams?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleOrderByRelationAggregateInput>;
  emailCampaign?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateOrderByRelationAggregateInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadOrderByRelationAggregateInput>;
  featureFlags?: Maybe<FeatureFlagOrderByRelationAggregateInput>;
  financialTransactions?: Maybe<FinancialTransactionOrderByRelationAggregateInput>;
  firebaseId?: Maybe<SortOrder>;
  firebaseVets?: Maybe<SortOrder>;
  followUpCost?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  formTemplates?: Maybe<FormTemplateOrderByRelationAggregateInput>;
  fullAddress?: Maybe<SortOrder>;
  googlePlace?: Maybe<GooglePlaceOrderByWithRelationInput>;
  hasServiceReminders?: Maybe<SortOrder>;
  hasSmsConversations?: Maybe<SortOrder>;
  headUserId?: Maybe<SortOrder>;
  hours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomeMethod?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentOrderByRelationAggregateInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationOrderByRelationAggregateInput>;
  integrationInfo?: Maybe<SortOrder>;
  integrationSystem?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  integrations?: Maybe<ClinicPimsIntegrationOrderByRelationAggregateInput>;
  isAddAppointmentDisabled?: Maybe<SortOrder>;
  isCallerIdVerified?: Maybe<SortOrder>;
  isClinicActive?: Maybe<SortOrder>;
  isClinicEligibleForPayments?: Maybe<SortOrder>;
  isConsultationsActive?: Maybe<SortOrder>;
  isIntegrationActive?: Maybe<SortOrder>;
  isPaymentUsBank?: Maybe<SortOrder>;
  isServiceRemindersActive?: Maybe<SortOrder>;
  lastPrintOrderedOn?: Maybe<SortOrder>;
  lastPrintOrderedQuantity?: Maybe<SortOrder>;
  lat?: Maybe<SortOrder>;
  legalEntity?: Maybe<LegalEntityOrderByWithRelationInput>;
  legalEntityId?: Maybe<SortOrder>;
  logo?: Maybe<SortOrder>;
  long?: Maybe<SortOrder>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  loyaltyProgramId?: Maybe<SortOrder>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput>;
  marketEmail?: Maybe<SortOrder>;
  marketFacebookNumber?: Maybe<SortOrder>;
  marketFacebookPageId?: Maybe<SortOrder>;
  marketFacebookPageToken?: Maybe<SortOrder>;
  massTextAlerts?: Maybe<MassTextAlertOrderByRelationAggregateInput>;
  media?: Maybe<MediaOrderByRelationAggregateInput>;
  messageTemplates?: Maybe<MessageTemplateOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  optimizedLogoUrl?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  paymentAddress?: Maybe<SortOrder>;
  paymentBankAccountNumber?: Maybe<SortOrder>;
  paymentBankRoutingNumber?: Maybe<SortOrder>;
  paymentCity?: Maybe<SortOrder>;
  paymentName?: Maybe<SortOrder>;
  paymentPhone?: Maybe<SortOrder>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  paymentState?: Maybe<SortOrder>;
  paymentZip?: Maybe<SortOrder>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodOrderByRelationAggregateInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingOrderByWithRelationInput>;
  pets?: Maybe<PetOrderByRelationAggregateInput>;
  petsId?: Maybe<PetOrderByRelationAggregateInput>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  postcardSettings?: Maybe<ClinicPostcardSettingOrderByRelationAggregateInput>;
  ppcLocationId?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  printLastOrder?: Maybe<SortOrder>;
  printReceivedQuantity?: Maybe<SortOrder>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionOrderByRelationAggregateInput>;
  promoCodes?: Maybe<PromoCodeOrderByRelationAggregateInput>;
  recaps?: Maybe<RecapOrderByRelationAggregateInput>;
  remindersIntegrationRequestEmail?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  roles?: Maybe<StaffRoleOrderByRelationAggregateInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  smsPhoneNumber?: Maybe<SortOrder>;
  staff?: Maybe<VetInfoOrderByRelationAggregateInput>;
  staffId?: Maybe<VetInfoOrderByRelationAggregateInput>;
  state?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountOrderByRelationAggregateInput>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  stripeSubscriptionPlan?: Maybe<SortOrder>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationOrderByRelationAggregateInput>;
  submerchantApprovedAt?: Maybe<SortOrder>;
  submerchantId?: Maybe<SortOrder>;
  submerchantIsActive?: Maybe<SortOrder>;
  submerchantStatus?: Maybe<SortOrder>;
  submerchantStripeChargesEnabled?: Maybe<SortOrder>;
  submerchantStripeHasCustomPayouts?: Maybe<SortOrder>;
  submerchantStripeId?: Maybe<SortOrder>;
  submerchantStripePayoutsEnabled?: Maybe<SortOrder>;
  submerchantStripeStatus?: Maybe<SortOrder>;
  subscribedAt?: Maybe<SortOrder>;
  subscriptionId?: Maybe<SortOrder>;
  subscriptionPlan?: Maybe<SortOrder>;
  surveyResults?: Maybe<SurveyResultOrderByRelationAggregateInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationOrderByWithRelationInput>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  timezone?: Maybe<SortOrder>;
  timezoneName?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  twilioConfiguration?: Maybe<TwilioConfigurationOrderByWithRelationInput>;
  twilioVerifications?: Maybe<TwilioVerificationOrderByRelationAggregateInput>;
  unlayerSetting?: Maybe<UnlayerSettingOrderByWithRelationInput>;
  unlayerSettingId?: Maybe<SortOrder>;
  unsubscribedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnOrderByRelationAggregateInput>;
  userTaskLists?: Maybe<UserTaskListOrderByRelationAggregateInput>;
  users?: Maybe<UserOrderByRelationAggregateInput>;
  usersId?: Maybe<UserOrderByWithRelationInput>;
  vaccinations?: Maybe<VaccinationOrderByRelationAggregateInput>;
  vetAvailabilities?: Maybe<VetAvailabilityOrderByRelationAggregateInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationOrderByWithRelationInput>;
  websiteUrl?: Maybe<SortOrder>;
  widgetSettings?: Maybe<SortOrder>;
  workflowEventSettings?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export type ClinicOrderByWithRelationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateOrderByRelationAggregateInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogOrderByRelationAggregateInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeOrderByRelationAggregateInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  Rules?: Maybe<RulesOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicOrderByRelevanceInput>;
  activationDate?: Maybe<SortOrder>;
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  allowAllUsersToCloseConsultations?: Maybe<SortOrder>;
  appoinmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  autoSubscriptionReceiptEmails?: Maybe<SortOrder>;
  automaticSubscriptionReceipts?: Maybe<SortOrder>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationOrderByWithRelationInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationOrderByRelationAggregateInput>;
  benefitsProvided?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckOrderByRelationAggregateInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberOrderByRelationAggregateInput>;
  callerIdPhoneNumber?: Maybe<SortOrder>;
  calls?: Maybe<CallHistoryOrderByRelationAggregateInput>;
  canceledAt?: Maybe<SortOrder>;
  cancellationNote?: Maybe<SortOrder>;
  cancellationReason?: Maybe<SortOrder>;
  carePayoutOrganization?: Maybe<OrganizationOrderByWithRelationInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  carePlanProviderGroupId?: Maybe<SortOrder>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionOrderByRelationAggregateInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeOrderByRelationAggregateInput>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  city?: Maybe<SortOrder>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupOrderByWithRelationInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingOrderByRelationAggregateInput>;
  clinicEmail?: Maybe<SortOrder>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingOrderByRelationAggregateInput>;
  clinicEmployees?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  clinicModules?: Maybe<ClinicModuleOrderByRelationAggregateInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourOrderByRelationAggregateInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingOrderByRelationAggregateInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  clinicPets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberOrderByRelationAggregateInput>;
  clinicRooms?: Maybe<ClinicRoomOrderByRelationAggregateInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  clinicUserFilters?: Maybe<ClinicUserFilterOrderByRelationAggregateInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestOrderByRelationAggregateInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingOrderByWithRelationInput>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeOrderByRelationAggregateInput>;
  consultationCost?: Maybe<SortOrder>;
  consultationRequests?: Maybe<ConsultationRequestOrderByRelationAggregateInput>;
  consultations?: Maybe<ConsultationOrderByRelationAggregateInput>;
  corporateId?: Maybe<SortOrder>;
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  crmUrlParams?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleOrderByRelationAggregateInput>;
  emailCampaign?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateOrderByRelationAggregateInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadOrderByRelationAggregateInput>;
  featureFlags?: Maybe<FeatureFlagOrderByRelationAggregateInput>;
  financialTransactions?: Maybe<FinancialTransactionOrderByRelationAggregateInput>;
  firebaseId?: Maybe<SortOrder>;
  firebaseVets?: Maybe<SortOrder>;
  followUpCost?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  formTemplates?: Maybe<FormTemplateOrderByRelationAggregateInput>;
  fullAddress?: Maybe<SortOrder>;
  googlePlace?: Maybe<GooglePlaceOrderByWithRelationInput>;
  hasServiceReminders?: Maybe<SortOrder>;
  hasSmsConversations?: Maybe<SortOrder>;
  headUserId?: Maybe<SortOrder>;
  hours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomeMethod?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentOrderByRelationAggregateInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationOrderByRelationAggregateInput>;
  integrationInfo?: Maybe<SortOrder>;
  integrationSystem?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  integrations?: Maybe<ClinicPimsIntegrationOrderByRelationAggregateInput>;
  isAddAppointmentDisabled?: Maybe<SortOrder>;
  isCallerIdVerified?: Maybe<SortOrder>;
  isClinicActive?: Maybe<SortOrder>;
  isClinicEligibleForPayments?: Maybe<SortOrder>;
  isConsultationsActive?: Maybe<SortOrder>;
  isIntegrationActive?: Maybe<SortOrder>;
  isPaymentUsBank?: Maybe<SortOrder>;
  isServiceRemindersActive?: Maybe<SortOrder>;
  lastPrintOrderedOn?: Maybe<SortOrder>;
  lastPrintOrderedQuantity?: Maybe<SortOrder>;
  lat?: Maybe<SortOrder>;
  legalEntity?: Maybe<LegalEntityOrderByWithRelationInput>;
  legalEntityId?: Maybe<SortOrder>;
  logo?: Maybe<SortOrder>;
  long?: Maybe<SortOrder>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  loyaltyProgramId?: Maybe<SortOrder>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput>;
  marketEmail?: Maybe<SortOrder>;
  marketFacebookNumber?: Maybe<SortOrder>;
  marketFacebookPageId?: Maybe<SortOrder>;
  marketFacebookPageToken?: Maybe<SortOrder>;
  massTextAlerts?: Maybe<MassTextAlertOrderByRelationAggregateInput>;
  media?: Maybe<MediaOrderByRelationAggregateInput>;
  messageTemplates?: Maybe<MessageTemplateOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  optimizedLogoUrl?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  paymentAddress?: Maybe<SortOrder>;
  paymentBankAccountNumber?: Maybe<SortOrder>;
  paymentBankRoutingNumber?: Maybe<SortOrder>;
  paymentCity?: Maybe<SortOrder>;
  paymentName?: Maybe<SortOrder>;
  paymentPhone?: Maybe<SortOrder>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupOrderByWithRelationInput>;
  paymentState?: Maybe<SortOrder>;
  paymentZip?: Maybe<SortOrder>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodOrderByRelationAggregateInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingOrderByWithRelationInput>;
  pets?: Maybe<PetOrderByRelationAggregateInput>;
  petsId?: Maybe<PetOrderByRelationAggregateInput>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  postcardSettings?: Maybe<ClinicPostcardSettingOrderByRelationAggregateInput>;
  ppcLocationId?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  printLastOrder?: Maybe<SortOrder>;
  printReceivedQuantity?: Maybe<SortOrder>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionOrderByRelationAggregateInput>;
  promoCodes?: Maybe<PromoCodeOrderByRelationAggregateInput>;
  recaps?: Maybe<RecapOrderByRelationAggregateInput>;
  remindersIntegrationRequestEmail?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  roles?: Maybe<StaffRoleOrderByRelationAggregateInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  smsPhoneNumber?: Maybe<SortOrder>;
  staff?: Maybe<VetInfoOrderByRelationAggregateInput>;
  staffId?: Maybe<VetInfoOrderByRelationAggregateInput>;
  state?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountOrderByRelationAggregateInput>;
  stripeSubscriptionId?: Maybe<SortOrder>;
  stripeSubscriptionPlan?: Maybe<SortOrder>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationOrderByRelationAggregateInput>;
  submerchantApprovedAt?: Maybe<SortOrder>;
  submerchantId?: Maybe<SortOrder>;
  submerchantIsActive?: Maybe<SortOrder>;
  submerchantStatus?: Maybe<SortOrder>;
  submerchantStripeChargesEnabled?: Maybe<SortOrder>;
  submerchantStripeHasCustomPayouts?: Maybe<SortOrder>;
  submerchantStripeId?: Maybe<SortOrder>;
  submerchantStripePayoutsEnabled?: Maybe<SortOrder>;
  submerchantStripeStatus?: Maybe<SortOrder>;
  subscribedAt?: Maybe<SortOrder>;
  subscriptionId?: Maybe<SortOrder>;
  subscriptionPlan?: Maybe<SortOrder>;
  surveyResults?: Maybe<SurveyResultOrderByRelationAggregateInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationOrderByWithRelationInput>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  timezone?: Maybe<SortOrder>;
  timezoneName?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  twilioConfiguration?: Maybe<TwilioConfigurationOrderByWithRelationInput>;
  twilioVerifications?: Maybe<TwilioVerificationOrderByRelationAggregateInput>;
  unlayerSetting?: Maybe<UnlayerSettingOrderByWithRelationInput>;
  unlayerSettingId?: Maybe<SortOrder>;
  unsubscribedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnOrderByRelationAggregateInput>;
  userTaskLists?: Maybe<UserTaskListOrderByRelationAggregateInput>;
  users?: Maybe<UserOrderByRelationAggregateInput>;
  usersId?: Maybe<UserOrderByWithRelationInput>;
  vaccinations?: Maybe<VaccinationOrderByRelationAggregateInput>;
  vetAvailabilities?: Maybe<VetAvailabilityOrderByRelationAggregateInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationOrderByWithRelationInput>;
  websiteUrl?: Maybe<SortOrder>;
  widgetSettings?: Maybe<SortOrder>;
  workflowEventSettings?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export type ClinicPaymentActivityOutput = {
  __typename?: 'ClinicPaymentActivityOutput';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  totalRecentCentsProcessed?: Maybe<Scalars['Int']>;
  totalRecentTransactions?: Maybe<Scalars['Int']>;
};

export type ClinicPaymentFeeConfiguration = {
  __typename?: 'ClinicPaymentFeeConfiguration';
  _count: ClinicPaymentFeeConfigurationCountOutputType;
  clinicSetting: ClinicSetting;
  clinicSettingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  disputeFeeCharge: Scalars['Int'];
  feeCollection: FeeCollection;
  id: Scalars['String'];
  interchangeRates: Array<InterchangeRate>;
  onlineClientServiceFeePercent: Scalars['Float'];
  onlineProcessingFeeFlat: Scalars['Int'];
  onlineProcessingFeePercent: Scalars['Float'];
  pricingModel: PricingModel;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent: Scalars['Float'];
  terminalProcessingFeeFlat: Scalars['Int'];
  terminalProcessingFeePercent: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};


export type ClinicPaymentFeeConfigurationInterchangeRatesArgs = {
  cursor?: Maybe<InterchangeRateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InterchangeRateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InterchangeRateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InterchangeRateWhereInput>;
};

export type ClinicPaymentFeeConfigurationAvgAggregateOutputType = {
  __typename?: 'ClinicPaymentFeeConfigurationAvgAggregateOutputType';
  disputeFeeCharge?: Maybe<Scalars['Float']>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Float']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Float']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
};

export type ClinicPaymentFeeConfigurationAvgOrderByAggregateInput = {
  disputeFeeCharge?: Maybe<SortOrder>;
  onlineClientServiceFeePercent?: Maybe<SortOrder>;
  onlineProcessingFeeFlat?: Maybe<SortOrder>;
  onlineProcessingFeePercent?: Maybe<SortOrder>;
  terminalClientServiceFeePercent?: Maybe<SortOrder>;
  terminalProcessingFeeFlat?: Maybe<SortOrder>;
  terminalProcessingFeePercent?: Maybe<SortOrder>;
};

export type ClinicPaymentFeeConfigurationCountAggregateOutputType = {
  __typename?: 'ClinicPaymentFeeConfigurationCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicSettingId: Scalars['Int'];
  createdAt: Scalars['Int'];
  disputeFeeCharge: Scalars['Int'];
  feeCollection: Scalars['Int'];
  id: Scalars['Int'];
  onlineClientServiceFeePercent: Scalars['Int'];
  onlineProcessingFeeFlat: Scalars['Int'];
  onlineProcessingFeePercent: Scalars['Int'];
  pricingModel: Scalars['Int'];
  responsibleForClinicRefundFeesAt: Scalars['Int'];
  terminalClientServiceFeePercent: Scalars['Int'];
  terminalProcessingFeeFlat: Scalars['Int'];
  terminalProcessingFeePercent: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicPaymentFeeConfigurationCountOrderByAggregateInput = {
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputeFeeCharge?: Maybe<SortOrder>;
  feeCollection?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  onlineClientServiceFeePercent?: Maybe<SortOrder>;
  onlineProcessingFeeFlat?: Maybe<SortOrder>;
  onlineProcessingFeePercent?: Maybe<SortOrder>;
  pricingModel?: Maybe<SortOrder>;
  responsibleForClinicRefundFeesAt?: Maybe<SortOrder>;
  terminalClientServiceFeePercent?: Maybe<SortOrder>;
  terminalProcessingFeeFlat?: Maybe<SortOrder>;
  terminalProcessingFeePercent?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPaymentFeeConfigurationCountOutputType = {
  __typename?: 'ClinicPaymentFeeConfigurationCountOutputType';
  interchangeRates: Scalars['Int'];
};

export type ClinicPaymentFeeConfigurationCreateInput = {
  clinicSetting: ClinicSettingCreateNestedOneWithoutPaymentFeeConfigInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  interchangeRates?: Maybe<InterchangeRateCreateNestedManyWithoutClinicPaymentFeeConfigurationInput>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationCreateManyInput = {
  clinicSettingId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationCreateNestedOneWithoutClinicSettingInput = {
  connect?: Maybe<ClinicPaymentFeeConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPaymentFeeConfigurationCreateOrConnectWithoutClinicSettingInput>;
  create?: Maybe<ClinicPaymentFeeConfigurationCreateWithoutClinicSettingInput>;
};

export type ClinicPaymentFeeConfigurationCreateNestedOneWithoutInterchangeRatesInput = {
  connect?: Maybe<ClinicPaymentFeeConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPaymentFeeConfigurationCreateOrConnectWithoutInterchangeRatesInput>;
  create?: Maybe<ClinicPaymentFeeConfigurationCreateWithoutInterchangeRatesInput>;
};

export type ClinicPaymentFeeConfigurationCreateOrConnectWithoutClinicSettingInput = {
  create: ClinicPaymentFeeConfigurationCreateWithoutClinicSettingInput;
  where: ClinicPaymentFeeConfigurationWhereUniqueInput;
};

export type ClinicPaymentFeeConfigurationCreateOrConnectWithoutInterchangeRatesInput = {
  create: ClinicPaymentFeeConfigurationCreateWithoutInterchangeRatesInput;
  where: ClinicPaymentFeeConfigurationWhereUniqueInput;
};

export type ClinicPaymentFeeConfigurationCreateWithoutClinicSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  interchangeRates?: Maybe<InterchangeRateCreateNestedManyWithoutClinicPaymentFeeConfigurationInput>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationCreateWithoutInterchangeRatesInput = {
  clinicSetting: ClinicSettingCreateNestedOneWithoutPaymentFeeConfigInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationGroupByOutputType = {
  __typename?: 'ClinicPaymentFeeConfigurationGroupByOutputType';
  _avg?: Maybe<ClinicPaymentFeeConfigurationAvgAggregateOutputType>;
  _count?: Maybe<ClinicPaymentFeeConfigurationCountAggregateOutputType>;
  _max?: Maybe<ClinicPaymentFeeConfigurationMaxAggregateOutputType>;
  _min?: Maybe<ClinicPaymentFeeConfigurationMinAggregateOutputType>;
  _sum?: Maybe<ClinicPaymentFeeConfigurationSumAggregateOutputType>;
  clinicSettingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  disputeFeeCharge: Scalars['Int'];
  feeCollection: FeeCollection;
  id: Scalars['String'];
  onlineClientServiceFeePercent: Scalars['Float'];
  onlineProcessingFeeFlat: Scalars['Int'];
  onlineProcessingFeePercent: Scalars['Float'];
  pricingModel: PricingModel;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent: Scalars['Float'];
  terminalProcessingFeeFlat: Scalars['Int'];
  terminalProcessingFeePercent: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type ClinicPaymentFeeConfigurationMaxAggregateOutputType = {
  __typename?: 'ClinicPaymentFeeConfigurationMaxAggregateOutputType';
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationMaxOrderByAggregateInput = {
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputeFeeCharge?: Maybe<SortOrder>;
  feeCollection?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  onlineClientServiceFeePercent?: Maybe<SortOrder>;
  onlineProcessingFeeFlat?: Maybe<SortOrder>;
  onlineProcessingFeePercent?: Maybe<SortOrder>;
  pricingModel?: Maybe<SortOrder>;
  responsibleForClinicRefundFeesAt?: Maybe<SortOrder>;
  terminalClientServiceFeePercent?: Maybe<SortOrder>;
  terminalProcessingFeeFlat?: Maybe<SortOrder>;
  terminalProcessingFeePercent?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPaymentFeeConfigurationMinAggregateOutputType = {
  __typename?: 'ClinicPaymentFeeConfigurationMinAggregateOutputType';
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationMinOrderByAggregateInput = {
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputeFeeCharge?: Maybe<SortOrder>;
  feeCollection?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  onlineClientServiceFeePercent?: Maybe<SortOrder>;
  onlineProcessingFeeFlat?: Maybe<SortOrder>;
  onlineProcessingFeePercent?: Maybe<SortOrder>;
  pricingModel?: Maybe<SortOrder>;
  responsibleForClinicRefundFeesAt?: Maybe<SortOrder>;
  terminalClientServiceFeePercent?: Maybe<SortOrder>;
  terminalProcessingFeeFlat?: Maybe<SortOrder>;
  terminalProcessingFeePercent?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPaymentFeeConfigurationNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicPaymentFeeConfigurationWhereInput>>;
  NOT?: Maybe<Array<ClinicPaymentFeeConfigurationWhereInput>>;
  OR?: Maybe<Array<ClinicPaymentFeeConfigurationWhereInput>>;
  clinicSetting?: Maybe<ClinicSettingScalarRelationFilter>;
  clinicSettingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disputeFeeCharge?: Maybe<IntFilter>;
  feeCollection?: Maybe<EnumFeeCollectionFilter>;
  id?: Maybe<StringFilter>;
  interchangeRates?: Maybe<InterchangeRateListRelationFilter>;
  onlineClientServiceFeePercent?: Maybe<FloatFilter>;
  onlineProcessingFeeFlat?: Maybe<IntFilter>;
  onlineProcessingFeePercent?: Maybe<FloatFilter>;
  pricingModel?: Maybe<EnumPricingModelFilter>;
  responsibleForClinicRefundFeesAt?: Maybe<DateTimeNullableFilter>;
  terminalClientServiceFeePercent?: Maybe<FloatFilter>;
  terminalProcessingFeeFlat?: Maybe<IntFilter>;
  terminalProcessingFeePercent?: Maybe<FloatFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPaymentFeeConfigurationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPaymentFeeConfigurationOrderByRelevanceInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputeFeeCharge?: Maybe<SortOrder>;
  feeCollection?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  interchangeRates?: Maybe<InterchangeRateOrderByRelationAggregateInput>;
  onlineClientServiceFeePercent?: Maybe<SortOrder>;
  onlineProcessingFeeFlat?: Maybe<SortOrder>;
  onlineProcessingFeePercent?: Maybe<SortOrder>;
  pricingModel?: Maybe<SortOrder>;
  responsibleForClinicRefundFeesAt?: Maybe<SortOrder>;
  terminalClientServiceFeePercent?: Maybe<SortOrder>;
  terminalProcessingFeeFlat?: Maybe<SortOrder>;
  terminalProcessingFeePercent?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPaymentFeeConfigurationOrderByRelevanceFieldEnum {
  ClinicSettingId = 'clinicSettingId',
  Id = 'id'
}

export type ClinicPaymentFeeConfigurationOrderByRelevanceInput = {
  fields: Array<ClinicPaymentFeeConfigurationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPaymentFeeConfigurationOrderByWithAggregationInput = {
  _avg?: Maybe<ClinicPaymentFeeConfigurationAvgOrderByAggregateInput>;
  _count?: Maybe<ClinicPaymentFeeConfigurationCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPaymentFeeConfigurationMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPaymentFeeConfigurationMinOrderByAggregateInput>;
  _sum?: Maybe<ClinicPaymentFeeConfigurationSumOrderByAggregateInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputeFeeCharge?: Maybe<SortOrder>;
  feeCollection?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  onlineClientServiceFeePercent?: Maybe<SortOrder>;
  onlineProcessingFeeFlat?: Maybe<SortOrder>;
  onlineProcessingFeePercent?: Maybe<SortOrder>;
  pricingModel?: Maybe<SortOrder>;
  responsibleForClinicRefundFeesAt?: Maybe<SortOrder>;
  terminalClientServiceFeePercent?: Maybe<SortOrder>;
  terminalProcessingFeeFlat?: Maybe<SortOrder>;
  terminalProcessingFeePercent?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPaymentFeeConfigurationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPaymentFeeConfigurationOrderByRelevanceInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputeFeeCharge?: Maybe<SortOrder>;
  feeCollection?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  interchangeRates?: Maybe<InterchangeRateOrderByRelationAggregateInput>;
  onlineClientServiceFeePercent?: Maybe<SortOrder>;
  onlineProcessingFeeFlat?: Maybe<SortOrder>;
  onlineProcessingFeePercent?: Maybe<SortOrder>;
  pricingModel?: Maybe<SortOrder>;
  responsibleForClinicRefundFeesAt?: Maybe<SortOrder>;
  terminalClientServiceFeePercent?: Maybe<SortOrder>;
  terminalProcessingFeeFlat?: Maybe<SortOrder>;
  terminalProcessingFeePercent?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPaymentFeeConfigurationOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicPaymentFeeConfigurationOrderByRelevanceInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputeFeeCharge?: Maybe<SortOrder>;
  feeCollection?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  interchangeRates?: Maybe<InterchangeRateOrderByRelationAggregateInput>;
  onlineClientServiceFeePercent?: Maybe<SortOrder>;
  onlineProcessingFeeFlat?: Maybe<SortOrder>;
  onlineProcessingFeePercent?: Maybe<SortOrder>;
  pricingModel?: Maybe<SortOrder>;
  responsibleForClinicRefundFeesAt?: Maybe<SortOrder>;
  terminalClientServiceFeePercent?: Maybe<SortOrder>;
  terminalProcessingFeeFlat?: Maybe<SortOrder>;
  terminalProcessingFeePercent?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPaymentFeeConfigurationScalarFieldEnum {
  ClinicSettingId = 'clinicSettingId',
  CreatedAt = 'createdAt',
  DisputeFeeCharge = 'disputeFeeCharge',
  FeeCollection = 'feeCollection',
  Id = 'id',
  OnlineClientServiceFeePercent = 'onlineClientServiceFeePercent',
  OnlineProcessingFeeFlat = 'onlineProcessingFeeFlat',
  OnlineProcessingFeePercent = 'onlineProcessingFeePercent',
  PricingModel = 'pricingModel',
  ResponsibleForClinicRefundFeesAt = 'responsibleForClinicRefundFeesAt',
  TerminalClientServiceFeePercent = 'terminalClientServiceFeePercent',
  TerminalProcessingFeeFlat = 'terminalProcessingFeeFlat',
  TerminalProcessingFeePercent = 'terminalProcessingFeePercent',
  UpdatedAt = 'updatedAt'
}

export type ClinicPaymentFeeConfigurationScalarRelationFilter = {
  AND?: Maybe<Array<ClinicPaymentFeeConfigurationWhereInput>>;
  NOT?: Maybe<Array<ClinicPaymentFeeConfigurationWhereInput>>;
  OR?: Maybe<Array<ClinicPaymentFeeConfigurationWhereInput>>;
  clinicSetting?: Maybe<ClinicSettingScalarRelationFilter>;
  clinicSettingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disputeFeeCharge?: Maybe<IntFilter>;
  feeCollection?: Maybe<EnumFeeCollectionFilter>;
  id?: Maybe<StringFilter>;
  interchangeRates?: Maybe<InterchangeRateListRelationFilter>;
  onlineClientServiceFeePercent?: Maybe<FloatFilter>;
  onlineProcessingFeeFlat?: Maybe<IntFilter>;
  onlineProcessingFeePercent?: Maybe<FloatFilter>;
  pricingModel?: Maybe<EnumPricingModelFilter>;
  responsibleForClinicRefundFeesAt?: Maybe<DateTimeNullableFilter>;
  terminalClientServiceFeePercent?: Maybe<FloatFilter>;
  terminalProcessingFeeFlat?: Maybe<IntFilter>;
  terminalProcessingFeePercent?: Maybe<FloatFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPaymentFeeConfigurationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPaymentFeeConfigurationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPaymentFeeConfigurationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPaymentFeeConfigurationScalarWhereWithAggregatesInput>>;
  clinicSettingId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  disputeFeeCharge?: Maybe<IntWithAggregatesFilter>;
  feeCollection?: Maybe<EnumFeeCollectionWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  onlineClientServiceFeePercent?: Maybe<FloatWithAggregatesFilter>;
  onlineProcessingFeeFlat?: Maybe<IntWithAggregatesFilter>;
  onlineProcessingFeePercent?: Maybe<FloatWithAggregatesFilter>;
  pricingModel?: Maybe<EnumPricingModelWithAggregatesFilter>;
  responsibleForClinicRefundFeesAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  terminalClientServiceFeePercent?: Maybe<FloatWithAggregatesFilter>;
  terminalProcessingFeeFlat?: Maybe<IntWithAggregatesFilter>;
  terminalProcessingFeePercent?: Maybe<FloatWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicPaymentFeeConfigurationSumAggregateOutputType = {
  __typename?: 'ClinicPaymentFeeConfigurationSumAggregateOutputType';
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
};

export type ClinicPaymentFeeConfigurationSumOrderByAggregateInput = {
  disputeFeeCharge?: Maybe<SortOrder>;
  onlineClientServiceFeePercent?: Maybe<SortOrder>;
  onlineProcessingFeeFlat?: Maybe<SortOrder>;
  onlineProcessingFeePercent?: Maybe<SortOrder>;
  terminalClientServiceFeePercent?: Maybe<SortOrder>;
  terminalProcessingFeeFlat?: Maybe<SortOrder>;
  terminalProcessingFeePercent?: Maybe<SortOrder>;
};

export type ClinicPaymentFeeConfigurationUncheckedCreateInput = {
  clinicSettingId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  interchangeRates?: Maybe<InterchangeRateUncheckedCreateNestedManyWithoutClinicPaymentFeeConfigurationInput>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationUncheckedCreateNestedOneWithoutClinicSettingInput = {
  connect?: Maybe<ClinicPaymentFeeConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPaymentFeeConfigurationCreateOrConnectWithoutClinicSettingInput>;
  create?: Maybe<ClinicPaymentFeeConfigurationCreateWithoutClinicSettingInput>;
};

export type ClinicPaymentFeeConfigurationUncheckedCreateWithoutClinicSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  interchangeRates?: Maybe<InterchangeRateUncheckedCreateNestedManyWithoutClinicPaymentFeeConfigurationInput>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationUncheckedCreateWithoutInterchangeRatesInput = {
  clinicSettingId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationUncheckedUpdateInput = {
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  interchangeRates?: Maybe<InterchangeRateUncheckedUpdateManyWithoutClinicPaymentFeeConfigurationNestedInput>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationUncheckedUpdateManyInput = {
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationUncheckedUpdateOneWithoutClinicSettingNestedInput = {
  connect?: Maybe<ClinicPaymentFeeConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPaymentFeeConfigurationCreateOrConnectWithoutClinicSettingInput>;
  create?: Maybe<ClinicPaymentFeeConfigurationCreateWithoutClinicSettingInput>;
  delete?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
  disconnect?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
  update?: Maybe<ClinicPaymentFeeConfigurationUpdateToOneWithWhereWithoutClinicSettingInput>;
  upsert?: Maybe<ClinicPaymentFeeConfigurationUpsertWithoutClinicSettingInput>;
};

export type ClinicPaymentFeeConfigurationUncheckedUpdateWithoutClinicSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  interchangeRates?: Maybe<InterchangeRateUncheckedUpdateManyWithoutClinicPaymentFeeConfigurationNestedInput>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationUncheckedUpdateWithoutInterchangeRatesInput = {
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationUpdateInput = {
  clinicSetting?: Maybe<ClinicSettingUpdateOneRequiredWithoutPaymentFeeConfigNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  interchangeRates?: Maybe<InterchangeRateUpdateManyWithoutClinicPaymentFeeConfigurationNestedInput>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationUpdateOneRequiredWithoutInterchangeRatesNestedInput = {
  connect?: Maybe<ClinicPaymentFeeConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPaymentFeeConfigurationCreateOrConnectWithoutInterchangeRatesInput>;
  create?: Maybe<ClinicPaymentFeeConfigurationCreateWithoutInterchangeRatesInput>;
  update?: Maybe<ClinicPaymentFeeConfigurationUpdateToOneWithWhereWithoutInterchangeRatesInput>;
  upsert?: Maybe<ClinicPaymentFeeConfigurationUpsertWithoutInterchangeRatesInput>;
};

export type ClinicPaymentFeeConfigurationUpdateOneWithoutClinicSettingNestedInput = {
  connect?: Maybe<ClinicPaymentFeeConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPaymentFeeConfigurationCreateOrConnectWithoutClinicSettingInput>;
  create?: Maybe<ClinicPaymentFeeConfigurationCreateWithoutClinicSettingInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPaymentFeeConfigurationUpdateToOneWithWhereWithoutClinicSettingInput>;
  upsert?: Maybe<ClinicPaymentFeeConfigurationUpsertWithoutClinicSettingInput>;
};

export type ClinicPaymentFeeConfigurationUpdateToOneWithWhereWithoutClinicSettingInput = {
  data: ClinicPaymentFeeConfigurationUpdateWithoutClinicSettingInput;
  where?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
};

export type ClinicPaymentFeeConfigurationUpdateToOneWithWhereWithoutInterchangeRatesInput = {
  data: ClinicPaymentFeeConfigurationUpdateWithoutInterchangeRatesInput;
  where?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
};

export type ClinicPaymentFeeConfigurationUpdateWithoutClinicSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  interchangeRates?: Maybe<InterchangeRateUpdateManyWithoutClinicPaymentFeeConfigurationNestedInput>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationUpdateWithoutInterchangeRatesInput = {
  clinicSetting?: Maybe<ClinicSettingUpdateOneRequiredWithoutPaymentFeeConfigNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFeeCharge?: Maybe<Scalars['Int']>;
  feeCollection?: Maybe<FeeCollection>;
  id?: Maybe<Scalars['String']>;
  onlineClientServiceFeePercent?: Maybe<Scalars['Float']>;
  onlineProcessingFeeFlat?: Maybe<Scalars['Int']>;
  onlineProcessingFeePercent?: Maybe<Scalars['Float']>;
  pricingModel?: Maybe<PricingModel>;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent?: Maybe<Scalars['Float']>;
  terminalProcessingFeeFlat?: Maybe<Scalars['Int']>;
  terminalProcessingFeePercent?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPaymentFeeConfigurationUpsertWithoutClinicSettingInput = {
  create: ClinicPaymentFeeConfigurationCreateWithoutClinicSettingInput;
  update: ClinicPaymentFeeConfigurationUpdateWithoutClinicSettingInput;
  where?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
};

export type ClinicPaymentFeeConfigurationUpsertWithoutInterchangeRatesInput = {
  create: ClinicPaymentFeeConfigurationCreateWithoutInterchangeRatesInput;
  update: ClinicPaymentFeeConfigurationUpdateWithoutInterchangeRatesInput;
  where?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
};

export type ClinicPaymentFeeConfigurationWhereInput = {
  AND?: Maybe<Array<ClinicPaymentFeeConfigurationWhereInput>>;
  NOT?: Maybe<Array<ClinicPaymentFeeConfigurationWhereInput>>;
  OR?: Maybe<Array<ClinicPaymentFeeConfigurationWhereInput>>;
  clinicSetting?: Maybe<ClinicSettingScalarRelationFilter>;
  clinicSettingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disputeFeeCharge?: Maybe<IntFilter>;
  feeCollection?: Maybe<EnumFeeCollectionFilter>;
  id?: Maybe<StringFilter>;
  interchangeRates?: Maybe<InterchangeRateListRelationFilter>;
  onlineClientServiceFeePercent?: Maybe<FloatFilter>;
  onlineProcessingFeeFlat?: Maybe<IntFilter>;
  onlineProcessingFeePercent?: Maybe<FloatFilter>;
  pricingModel?: Maybe<EnumPricingModelFilter>;
  responsibleForClinicRefundFeesAt?: Maybe<DateTimeNullableFilter>;
  terminalClientServiceFeePercent?: Maybe<FloatFilter>;
  terminalProcessingFeeFlat?: Maybe<IntFilter>;
  terminalProcessingFeePercent?: Maybe<FloatFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPaymentFeeConfigurationWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPaymentFeeConfigurationWhereInput>>;
  NOT?: Maybe<Array<ClinicPaymentFeeConfigurationWhereInput>>;
  OR?: Maybe<Array<ClinicPaymentFeeConfigurationWhereInput>>;
  clinicSetting?: Maybe<ClinicSettingScalarRelationFilter>;
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  disputeFeeCharge?: Maybe<IntFilter>;
  feeCollection?: Maybe<EnumFeeCollectionFilter>;
  id?: Maybe<Scalars['String']>;
  interchangeRates?: Maybe<InterchangeRateListRelationFilter>;
  onlineClientServiceFeePercent?: Maybe<FloatFilter>;
  onlineProcessingFeeFlat?: Maybe<IntFilter>;
  onlineProcessingFeePercent?: Maybe<FloatFilter>;
  pricingModel?: Maybe<EnumPricingModelFilter>;
  responsibleForClinicRefundFeesAt?: Maybe<DateTimeNullableFilter>;
  terminalClientServiceFeePercent?: Maybe<FloatFilter>;
  terminalProcessingFeeFlat?: Maybe<IntFilter>;
  terminalProcessingFeePercent?: Maybe<FloatFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPet = {
  __typename?: 'ClinicPet';
  HillsToHomeAPILog: Array<HillsToHomeApiLog>;
  LabPanel: Array<LabPanel>;
  MedicalHistory: Array<MedicalHistory>;
  _count: ClinicPetCountOutputType;
  alerts: Array<ClinicPetAlert>;
  appointments: Array<Appointment>;
  automationRunActions: Array<AutomationRunAction>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  breedModel?: Maybe<Breed>;
  careBenefitUsages: Array<CareBenefitUsage>;
  channelAutomationStatuses: Array<ChannelAutomationStatus>;
  channels: Array<Channel>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus: Array<ClinicPetPimsSyncStatus>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  colorModel?: Maybe<Color>;
  computedIsActive: Scalars['Boolean'];
  computedIsDeceased: Scalars['Boolean'];
  computed_optimizedPhotoUrl?: Maybe<Scalars['String']>;
  computed_rawPimsIsActive?: Maybe<Scalars['Boolean']>;
  computed_rawPimsIsDeceased?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  customFieldValues: Array<ClinicPetCustomFieldValue>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions: Array<FormSubmission>;
  gender?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems: Array<InvoiceLineItem>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders: Scalars['Boolean'];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPet>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents: Array<ClinicPetParent>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions: Array<Prescription>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers: Array<SentTrupanionExamDayOffer>;
  servicePurchaseSummaries: Array<ServicePurchaseSummary>;
  serviceReminders: Array<ServiceReminder>;
  sexId?: Maybe<Scalars['String']>;
  sexModel?: Maybe<Sex>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<Species>;
  speciesType: SpeciesType;
  trupanionCertificateAvailabilities: Array<TrupanionCertificateAvailability>;
  updatedAt: Scalars['DateTime'];
  vaccinations: Array<Vaccination>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};


export type ClinicPetHillsToHomeApiLogArgs = {
  cursor?: Maybe<HillsToHomeApiLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<HillsToHomeApiLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<HillsToHomeApiLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<HillsToHomeApiLogWhereInput>;
};


export type ClinicPetLabPanelArgs = {
  cursor?: Maybe<LabPanelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LabPanelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LabPanelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabPanelWhereInput>;
};


export type ClinicPetMedicalHistoryArgs = {
  cursor?: Maybe<MedicalHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MedicalHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MedicalHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MedicalHistoryWhereInput>;
};


export type ClinicPetAlertsArgs = {
  cursor?: Maybe<ClinicPetAlertWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetAlertScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetAlertOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetAlertWhereInput>;
};


export type ClinicPetAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type ClinicPetAutomationRunActionsArgs = {
  cursor?: Maybe<AutomationRunActionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunActionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunActionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type ClinicPetBreedModelArgs = {
  where?: Maybe<BreedWhereInput>;
};


export type ClinicPetCareBenefitUsagesArgs = {
  cursor?: Maybe<CareBenefitUsageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageWhereInput>;
};


export type ClinicPetChannelAutomationStatusesArgs = {
  cursor?: Maybe<ChannelAutomationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelAutomationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelAutomationStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type ClinicPetChannelsArgs = {
  cursor?: Maybe<ChannelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelWhereInput>;
};


export type ClinicPetClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type ClinicPetClinicPetPimsSyncStatusArgs = {
  cursor?: Maybe<ClinicPetPimsSyncStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetPimsSyncStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetPimsSyncStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetPimsSyncStatusWhereInput>;
};


export type ClinicPetColorModelArgs = {
  where?: Maybe<ColorWhereInput>;
};


export type ClinicPetCustomFieldValuesArgs = {
  cursor?: Maybe<ClinicPetCustomFieldValueWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetCustomFieldValueScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetCustomFieldValueOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetCustomFieldValueWhereInput>;
};


export type ClinicPetFormSubmissionsArgs = {
  cursor?: Maybe<FormSubmissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormSubmissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormSubmissionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormSubmissionWhereInput>;
};


export type ClinicPetIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type ClinicPetInvoiceLineItemsArgs = {
  cursor?: Maybe<InvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceLineItemWhereInput>;
};


export type ClinicPetMediaArgs = {
  where?: Maybe<MediaWhereInput>;
};


export type ClinicPetOrganizationPetArgs = {
  where?: Maybe<OrganizationPetWhereInput>;
};


export type ClinicPetPetParentsArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type ClinicPetPrescriptionsArgs = {
  cursor?: Maybe<PrescriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PrescriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PrescriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PrescriptionWhereInput>;
};


export type ClinicPetReceivedTrupanionExamDayOffersArgs = {
  cursor?: Maybe<SentTrupanionExamDayOfferWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SentTrupanionExamDayOfferScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SentTrupanionExamDayOfferOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};


export type ClinicPetServicePurchaseSummariesArgs = {
  cursor?: Maybe<ServicePurchaseSummaryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServicePurchaseSummaryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServicePurchaseSummaryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};


export type ClinicPetServiceRemindersArgs = {
  cursor?: Maybe<ServiceReminderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderWhereInput>;
};


export type ClinicPetSexModelArgs = {
  where?: Maybe<SexWhereInput>;
};


export type ClinicPetSpeciesModelArgs = {
  where?: Maybe<SpeciesWhereInput>;
};


export type ClinicPetTrupanionCertificateAvailabilitiesArgs = {
  cursor?: Maybe<TrupanionCertificateAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TrupanionCertificateAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TrupanionCertificateAvailabilityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionCertificateAvailabilityWhereInput>;
};


export type ClinicPetVaccinationsArgs = {
  cursor?: Maybe<VaccinationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VaccinationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VaccinationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VaccinationWhereInput>;
};

export type ClinicPetAlert = {
  __typename?: 'ClinicPetAlert';
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};


export type ClinicPetAlertClinicPetArgs = {
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetAlertCountAggregateOutputType = {
  __typename?: 'ClinicPetAlertCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isMedical: Scalars['Int'];
  pimsDate: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  updatedAt: Scalars['Int'];
  value: Scalars['Int'];
};

export type ClinicPetAlertCountOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMedical?: Maybe<SortOrder>;
  pimsDate?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ClinicPetAlertCreateInput = {
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutAlertsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
};

export type ClinicPetAlertCreateManyClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
};

export type ClinicPetAlertCreateManyClinicPetInputEnvelope = {
  data: Array<ClinicPetAlertCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetAlertCreateManyInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
};

export type ClinicPetAlertCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<ClinicPetAlertWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetAlertCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ClinicPetAlertCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ClinicPetAlertCreateManyClinicPetInputEnvelope>;
};

export type ClinicPetAlertCreateOrConnectWithoutClinicPetInput = {
  create: ClinicPetAlertCreateWithoutClinicPetInput;
  where: ClinicPetAlertWhereUniqueInput;
};

export type ClinicPetAlertCreateWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
};

export type ClinicPetAlertGroupByOutputType = {
  __typename?: 'ClinicPetAlertGroupByOutputType';
  _count?: Maybe<ClinicPetAlertCountAggregateOutputType>;
  _max?: Maybe<ClinicPetAlertMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetAlertMinAggregateOutputType>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type ClinicPetAlertListRelationFilter = {
  every?: Maybe<ClinicPetAlertWhereInput>;
  none?: Maybe<ClinicPetAlertWhereInput>;
  some?: Maybe<ClinicPetAlertWhereInput>;
};

export type ClinicPetAlertMaxAggregateOutputType = {
  __typename?: 'ClinicPetAlertMaxAggregateOutputType';
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type ClinicPetAlertMaxOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMedical?: Maybe<SortOrder>;
  pimsDate?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ClinicPetAlertMinAggregateOutputType = {
  __typename?: 'ClinicPetAlertMinAggregateOutputType';
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type ClinicPetAlertMinOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMedical?: Maybe<SortOrder>;
  pimsDate?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ClinicPetAlertOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPetAlertOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetAlertOrderByRelevanceInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMedical?: Maybe<SortOrder>;
  pimsDate?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export enum ClinicPetAlertOrderByRelevanceFieldEnum {
  ClinicPetId = 'clinicPetId',
  Id = 'id',
  PimsId = 'pimsId',
  Value = 'value'
}

export type ClinicPetAlertOrderByRelevanceInput = {
  fields: Array<ClinicPetAlertOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPetAlertOrderByWithAggregationInput = {
  _count?: Maybe<ClinicPetAlertCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPetAlertMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPetAlertMinOrderByAggregateInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMedical?: Maybe<SortOrder>;
  pimsDate?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ClinicPetAlertOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetAlertOrderByRelevanceInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMedical?: Maybe<SortOrder>;
  pimsDate?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ClinicPetAlertOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicPetAlertOrderByRelevanceInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMedical?: Maybe<SortOrder>;
  pimsDate?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export enum ClinicPetAlertScalarFieldEnum {
  ClinicPetId = 'clinicPetId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsMedical = 'isMedical',
  PimsDate = 'pimsDate',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type ClinicPetAlertScalarWhereInput = {
  AND?: Maybe<Array<ClinicPetAlertScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPetAlertScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPetAlertScalarWhereInput>>;
  clinicPetId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isMedical?: Maybe<BoolNullableFilter>;
  pimsDate?: Maybe<DateTimeNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  value?: Maybe<StringFilter>;
};

export type ClinicPetAlertScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPetAlertScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPetAlertScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPetAlertScalarWhereWithAggregatesInput>>;
  clinicPetId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isMedical?: Maybe<BoolNullableWithAggregatesFilter>;
  pimsDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  value?: Maybe<StringWithAggregatesFilter>;
};

export type ClinicPetAlertUncheckedCreateInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
};

export type ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<ClinicPetAlertWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetAlertCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ClinicPetAlertCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ClinicPetAlertCreateManyClinicPetInputEnvelope>;
};

export type ClinicPetAlertUncheckedCreateWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
};

export type ClinicPetAlertUncheckedUpdateInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type ClinicPetAlertUncheckedUpdateManyInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type ClinicPetAlertUncheckedUpdateManyWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<ClinicPetAlertWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetAlertCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ClinicPetAlertCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ClinicPetAlertCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<ClinicPetAlertWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetAlertScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetAlertWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetAlertWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetAlertUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<ClinicPetAlertUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<ClinicPetAlertUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type ClinicPetAlertUncheckedUpdateWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type ClinicPetAlertUpdateInput = {
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutAlertsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type ClinicPetAlertUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type ClinicPetAlertUpdateManyWithWhereWithoutClinicPetInput = {
  data: ClinicPetAlertUpdateManyMutationInput;
  where: ClinicPetAlertScalarWhereInput;
};

export type ClinicPetAlertUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<ClinicPetAlertWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetAlertCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ClinicPetAlertCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ClinicPetAlertCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<ClinicPetAlertWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetAlertScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetAlertWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetAlertWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetAlertUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<ClinicPetAlertUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<ClinicPetAlertUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type ClinicPetAlertUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: ClinicPetAlertUpdateWithoutClinicPetInput;
  where: ClinicPetAlertWhereUniqueInput;
};

export type ClinicPetAlertUpdateWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type ClinicPetAlertUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: ClinicPetAlertCreateWithoutClinicPetInput;
  update: ClinicPetAlertUpdateWithoutClinicPetInput;
  where: ClinicPetAlertWhereUniqueInput;
};

export type ClinicPetAlertWhereInput = {
  AND?: Maybe<Array<ClinicPetAlertWhereInput>>;
  NOT?: Maybe<Array<ClinicPetAlertWhereInput>>;
  OR?: Maybe<Array<ClinicPetAlertWhereInput>>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isMedical?: Maybe<BoolNullableFilter>;
  pimsDate?: Maybe<DateTimeNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  value?: Maybe<StringFilter>;
};

export type ClinicPetAlertWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPetAlertWhereInput>>;
  NOT?: Maybe<Array<ClinicPetAlertWhereInput>>;
  OR?: Maybe<Array<ClinicPetAlertWhereInput>>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isMedical?: Maybe<BoolNullableFilter>;
  pimsDate?: Maybe<DateTimeNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  value?: Maybe<StringFilter>;
};

export type ClinicPetAvgAggregateOutputType = {
  __typename?: 'ClinicPetAvgAggregateOutputType';
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
};

export type ClinicPetAvgOrderByAggregateInput = {
  weight?: Maybe<SortOrder>;
  weightInKg?: Maybe<SortOrder>;
};

export type ClinicPetClinicPetPimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type ClinicPetCountAggregateOutputType = {
  __typename?: 'ClinicPetCountAggregateOutputType';
  _all: Scalars['Int'];
  breed: Scalars['Int'];
  breedId: Scalars['Int'];
  clinicId: Scalars['Int'];
  color: Scalars['Int'];
  colorId: Scalars['Int'];
  createdAt: Scalars['Int'];
  dateOfBirth: Scalars['Int'];
  dateOfDeath: Scalars['Int'];
  gender: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeceased: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isPrivacyProtected: Scalars['Int'];
  isSubscribedToReminders: Scalars['Int'];
  mediaId: Scalars['Int'];
  name: Scalars['Int'];
  organizationPetId: Scalars['Int'];
  photoUrl: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  sexId: Scalars['Int'];
  species: Scalars['Int'];
  speciesId: Scalars['Int'];
  speciesType: Scalars['Int'];
  updatedAt: Scalars['Int'];
  weight: Scalars['Int'];
  weightInKg: Scalars['Int'];
  weightUnit: Scalars['Int'];
};

export type ClinicPetCountOrderByAggregateInput = {
  breed?: Maybe<SortOrder>;
  breedId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  colorId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dateOfBirth?: Maybe<SortOrder>;
  dateOfDeath?: Maybe<SortOrder>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeceased?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  mediaId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationPetId?: Maybe<SortOrder>;
  photoUrl?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  sexId?: Maybe<SortOrder>;
  species?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  speciesType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
  weightInKg?: Maybe<SortOrder>;
  weightUnit?: Maybe<SortOrder>;
};

export type ClinicPetCountOutputType = {
  __typename?: 'ClinicPetCountOutputType';
  HillsToHomeAPILog: Scalars['Int'];
  LabPanel: Scalars['Int'];
  MedicalHistory: Scalars['Int'];
  alerts: Scalars['Int'];
  appointments: Scalars['Int'];
  automationRunActions: Scalars['Int'];
  careBenefitUsages: Scalars['Int'];
  channelAutomationStatuses: Scalars['Int'];
  channels: Scalars['Int'];
  clinicPetPimsSyncStatus: Scalars['Int'];
  customFieldValues: Scalars['Int'];
  formSubmissions: Scalars['Int'];
  invoiceLineItems: Scalars['Int'];
  petParents: Scalars['Int'];
  prescriptions: Scalars['Int'];
  receivedTrupanionExamDayOffers: Scalars['Int'];
  servicePurchaseSummaries: Scalars['Int'];
  serviceReminders: Scalars['Int'];
  trupanionCertificateAvailabilities: Scalars['Int'];
  vaccinations: Scalars['Int'];
};

export type ClinicPetCreateInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateManyBreedModelInput = {
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateManyBreedModelInputEnvelope = {
  data: Array<ClinicPetCreateManyBreedModelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetCreateManyClinicInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateManyClinicInputEnvelope = {
  data: Array<ClinicPetCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetCreateManyColorModelInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateManyColorModelInputEnvelope = {
  data: Array<ClinicPetCreateManyColorModelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetCreateManyInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateManyIntegrationInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateManyIntegrationInputEnvelope = {
  data: Array<ClinicPetCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetCreateManyMediaInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateManyMediaInputEnvelope = {
  data: Array<ClinicPetCreateManyMediaInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetCreateManyOrganizationPetInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateManyOrganizationPetInputEnvelope = {
  data: Array<ClinicPetCreateManyOrganizationPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetCreateManySexModelInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateManySexModelInputEnvelope = {
  data: Array<ClinicPetCreateManySexModelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetCreateManySpeciesModelInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateManySpeciesModelInputEnvelope = {
  data: Array<ClinicPetCreateManySpeciesModelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetCreateNestedManyWithoutBreedModelInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutBreedModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutBreedModelInput>>;
  createMany?: Maybe<ClinicPetCreateManyBreedModelInputEnvelope>;
};

export type ClinicPetCreateNestedManyWithoutChannelsInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutChannelsInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutChannelsInput>>;
};

export type ClinicPetCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPetCreateManyClinicInputEnvelope>;
};

export type ClinicPetCreateNestedManyWithoutColorModelInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutColorModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutColorModelInput>>;
  createMany?: Maybe<ClinicPetCreateManyColorModelInputEnvelope>;
};

export type ClinicPetCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPetCreateManyIntegrationInputEnvelope>;
};

export type ClinicPetCreateNestedManyWithoutInvoiceLineItemsInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutInvoiceLineItemsInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutInvoiceLineItemsInput>>;
};

export type ClinicPetCreateNestedManyWithoutMediaInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutMediaInput>>;
  createMany?: Maybe<ClinicPetCreateManyMediaInputEnvelope>;
};

export type ClinicPetCreateNestedManyWithoutOrganizationPetInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<ClinicPetCreateManyOrganizationPetInputEnvelope>;
};

export type ClinicPetCreateNestedManyWithoutPetParentsInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutPetParentsInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutPetParentsInput>>;
};

export type ClinicPetCreateNestedManyWithoutSexModelInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutSexModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutSexModelInput>>;
  createMany?: Maybe<ClinicPetCreateManySexModelInputEnvelope>;
};

export type ClinicPetCreateNestedManyWithoutSpeciesModelInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutSpeciesModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutSpeciesModelInput>>;
  createMany?: Maybe<ClinicPetCreateManySpeciesModelInputEnvelope>;
};

export type ClinicPetCreateNestedOneWithoutAlertsInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutAlertsInput>;
  create?: Maybe<ClinicPetCreateWithoutAlertsInput>;
};

export type ClinicPetCreateNestedOneWithoutAppointmentsInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<ClinicPetCreateWithoutAppointmentsInput>;
};

export type ClinicPetCreateNestedOneWithoutAutomationRunActionsInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutAutomationRunActionsInput>;
  create?: Maybe<ClinicPetCreateWithoutAutomationRunActionsInput>;
};

export type ClinicPetCreateNestedOneWithoutCareBenefitUsagesInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutCareBenefitUsagesInput>;
  create?: Maybe<ClinicPetCreateWithoutCareBenefitUsagesInput>;
};

export type ClinicPetCreateNestedOneWithoutChannelAutomationStatusesInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<ClinicPetCreateWithoutChannelAutomationStatusesInput>;
};

export type ClinicPetCreateNestedOneWithoutClinicPetPimsSyncStatusInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutClinicPetPimsSyncStatusInput>;
  create?: Maybe<ClinicPetCreateWithoutClinicPetPimsSyncStatusInput>;
};

export type ClinicPetCreateNestedOneWithoutCustomFieldValuesInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutCustomFieldValuesInput>;
  create?: Maybe<ClinicPetCreateWithoutCustomFieldValuesInput>;
};

export type ClinicPetCreateNestedOneWithoutFormSubmissionsInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutFormSubmissionsInput>;
  create?: Maybe<ClinicPetCreateWithoutFormSubmissionsInput>;
};

export type ClinicPetCreateNestedOneWithoutHillsToHomeApiLogInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutHillsToHomeApiLogInput>;
  create?: Maybe<ClinicPetCreateWithoutHillsToHomeApiLogInput>;
};

export type ClinicPetCreateNestedOneWithoutLabPanelInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutLabPanelInput>;
  create?: Maybe<ClinicPetCreateWithoutLabPanelInput>;
};

export type ClinicPetCreateNestedOneWithoutMedicalHistoryInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutMedicalHistoryInput>;
  create?: Maybe<ClinicPetCreateWithoutMedicalHistoryInput>;
};

export type ClinicPetCreateNestedOneWithoutPrescriptionsInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutPrescriptionsInput>;
  create?: Maybe<ClinicPetCreateWithoutPrescriptionsInput>;
};

export type ClinicPetCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutReceivedTrupanionExamDayOffersInput>;
  create?: Maybe<ClinicPetCreateWithoutReceivedTrupanionExamDayOffersInput>;
};

export type ClinicPetCreateNestedOneWithoutServicePurchaseSummariesInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutServicePurchaseSummariesInput>;
  create?: Maybe<ClinicPetCreateWithoutServicePurchaseSummariesInput>;
};

export type ClinicPetCreateNestedOneWithoutServiceRemindersInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutServiceRemindersInput>;
  create?: Maybe<ClinicPetCreateWithoutServiceRemindersInput>;
};

export type ClinicPetCreateNestedOneWithoutTrupanionCertificateAvailabilitiesInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutTrupanionCertificateAvailabilitiesInput>;
  create?: Maybe<ClinicPetCreateWithoutTrupanionCertificateAvailabilitiesInput>;
};

export type ClinicPetCreateNestedOneWithoutVaccinationsInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutVaccinationsInput>;
  create?: Maybe<ClinicPetCreateWithoutVaccinationsInput>;
};

export type ClinicPetCreateOrConnectWithoutAlertsInput = {
  create: ClinicPetCreateWithoutAlertsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutAppointmentsInput = {
  create: ClinicPetCreateWithoutAppointmentsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutAutomationRunActionsInput = {
  create: ClinicPetCreateWithoutAutomationRunActionsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutBreedModelInput = {
  create: ClinicPetCreateWithoutBreedModelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutCareBenefitUsagesInput = {
  create: ClinicPetCreateWithoutCareBenefitUsagesInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutChannelAutomationStatusesInput = {
  create: ClinicPetCreateWithoutChannelAutomationStatusesInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutChannelsInput = {
  create: ClinicPetCreateWithoutChannelsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutClinicInput = {
  create: ClinicPetCreateWithoutClinicInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutClinicPetPimsSyncStatusInput = {
  create: ClinicPetCreateWithoutClinicPetPimsSyncStatusInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutColorModelInput = {
  create: ClinicPetCreateWithoutColorModelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutCustomFieldValuesInput = {
  create: ClinicPetCreateWithoutCustomFieldValuesInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutFormSubmissionsInput = {
  create: ClinicPetCreateWithoutFormSubmissionsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutHillsToHomeApiLogInput = {
  create: ClinicPetCreateWithoutHillsToHomeApiLogInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutIntegrationInput = {
  create: ClinicPetCreateWithoutIntegrationInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutInvoiceLineItemsInput = {
  create: ClinicPetCreateWithoutInvoiceLineItemsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutLabPanelInput = {
  create: ClinicPetCreateWithoutLabPanelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutMediaInput = {
  create: ClinicPetCreateWithoutMediaInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutMedicalHistoryInput = {
  create: ClinicPetCreateWithoutMedicalHistoryInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutOrganizationPetInput = {
  create: ClinicPetCreateWithoutOrganizationPetInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutPetParentsInput = {
  create: ClinicPetCreateWithoutPetParentsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutPrescriptionsInput = {
  create: ClinicPetCreateWithoutPrescriptionsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutReceivedTrupanionExamDayOffersInput = {
  create: ClinicPetCreateWithoutReceivedTrupanionExamDayOffersInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutServicePurchaseSummariesInput = {
  create: ClinicPetCreateWithoutServicePurchaseSummariesInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutServiceRemindersInput = {
  create: ClinicPetCreateWithoutServiceRemindersInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutSexModelInput = {
  create: ClinicPetCreateWithoutSexModelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutSpeciesModelInput = {
  create: ClinicPetCreateWithoutSpeciesModelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutTrupanionCertificateAvailabilitiesInput = {
  create: ClinicPetCreateWithoutTrupanionCertificateAvailabilitiesInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateOrConnectWithoutVaccinationsInput = {
  create: ClinicPetCreateWithoutVaccinationsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetCreateWithoutAlertsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutAppointmentsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutAutomationRunActionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutBreedModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutCareBenefitUsagesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutChannelAutomationStatusesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutChannelsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutClinicInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutClinicPetPimsSyncStatusInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutColorModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutCustomFieldValuesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutFormSubmissionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutHillsToHomeApiLogInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutIntegrationInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutInvoiceLineItemsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutLabPanelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutMediaInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutMedicalHistoryInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutOrganizationPetInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutPetParentsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutPrescriptionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutReceivedTrupanionExamDayOffersInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutServicePurchaseSummariesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutServiceRemindersInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutSexModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutSpeciesModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutTrupanionCertificateAvailabilitiesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetCreateWithoutVaccinationsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedCreateNestedOneWithoutPetsInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutPetsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorCreateNestedOneWithoutPetsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetsInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaCreateNestedOneWithoutClinicPetsInput>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPetCreateNestedOneWithoutClinicPetsInput>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetInput>;
  sexModel?: Maybe<SexCreateNestedOneWithoutPetsInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesCreateNestedOneWithoutPetsInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

/** Custom Values specifically for ClinicPets */
export type ClinicPetCustomFieldValue = {
  __typename?: 'ClinicPetCustomFieldValue';
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fieldDefinition: CustomFieldDefinition;
  fieldDefinitionId: Scalars['String'];
  id: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Json'];
};

export type ClinicPetCustomFieldValueCountAggregateOutputType = {
  __typename?: 'ClinicPetCustomFieldValueCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  createdAt: Scalars['Int'];
  fieldDefinitionId: Scalars['Int'];
  id: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  updatedAt: Scalars['Int'];
  value: Scalars['Int'];
};

export type ClinicPetCustomFieldValueCountOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ClinicPetCustomFieldValueCreateInput = {
  clinicPet: ClinicPetCreateNestedOneWithoutCustomFieldValuesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinition: CustomFieldDefinitionCreateNestedOneWithoutClinicPetFieldValuesInput;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetCustomFieldValueCreateManyClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetCustomFieldValueCreateManyClinicPetInputEnvelope = {
  data: Array<ClinicPetCustomFieldValueCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetCustomFieldValueCreateManyFieldDefinitionInput = {
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetCustomFieldValueCreateManyFieldDefinitionInputEnvelope = {
  data: Array<ClinicPetCustomFieldValueCreateManyFieldDefinitionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetCustomFieldValueCreateManyInput = {
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetCustomFieldValueCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCustomFieldValueCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ClinicPetCustomFieldValueCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ClinicPetCustomFieldValueCreateManyClinicPetInputEnvelope>;
};

export type ClinicPetCustomFieldValueCreateNestedManyWithoutFieldDefinitionInput = {
  connect?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCustomFieldValueCreateOrConnectWithoutFieldDefinitionInput>>;
  create?: Maybe<Array<ClinicPetCustomFieldValueCreateWithoutFieldDefinitionInput>>;
  createMany?: Maybe<ClinicPetCustomFieldValueCreateManyFieldDefinitionInputEnvelope>;
};

export type ClinicPetCustomFieldValueCreateOrConnectWithoutClinicPetInput = {
  create: ClinicPetCustomFieldValueCreateWithoutClinicPetInput;
  where: ClinicPetCustomFieldValueWhereUniqueInput;
};

export type ClinicPetCustomFieldValueCreateOrConnectWithoutFieldDefinitionInput = {
  create: ClinicPetCustomFieldValueCreateWithoutFieldDefinitionInput;
  where: ClinicPetCustomFieldValueWhereUniqueInput;
};

export type ClinicPetCustomFieldValueCreateWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinition: CustomFieldDefinitionCreateNestedOneWithoutClinicPetFieldValuesInput;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetCustomFieldValueCreateWithoutFieldDefinitionInput = {
  clinicPet: ClinicPetCreateNestedOneWithoutCustomFieldValuesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetCustomFieldValueGroupByOutputType = {
  __typename?: 'ClinicPetCustomFieldValueGroupByOutputType';
  _count?: Maybe<ClinicPetCustomFieldValueCountAggregateOutputType>;
  _max?: Maybe<ClinicPetCustomFieldValueMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetCustomFieldValueMinAggregateOutputType>;
  clinicPetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fieldDefinitionId: Scalars['String'];
  id: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Json'];
};

export type ClinicPetCustomFieldValueListRelationFilter = {
  every?: Maybe<ClinicPetCustomFieldValueWhereInput>;
  none?: Maybe<ClinicPetCustomFieldValueWhereInput>;
  some?: Maybe<ClinicPetCustomFieldValueWhereInput>;
};

export type ClinicPetCustomFieldValueMaxAggregateOutputType = {
  __typename?: 'ClinicPetCustomFieldValueMaxAggregateOutputType';
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetCustomFieldValueMaxOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetCustomFieldValueMinAggregateOutputType = {
  __typename?: 'ClinicPetCustomFieldValueMinAggregateOutputType';
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetCustomFieldValueMinOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetCustomFieldValueOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPetCustomFieldValueOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetCustomFieldValueOrderByRelevanceInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinition?: Maybe<CustomFieldDefinitionOrderByWithRelationInput>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export enum ClinicPetCustomFieldValueOrderByRelevanceFieldEnum {
  ClinicPetId = 'clinicPetId',
  FieldDefinitionId = 'fieldDefinitionId',
  Id = 'id'
}

export type ClinicPetCustomFieldValueOrderByRelevanceInput = {
  fields: Array<ClinicPetCustomFieldValueOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPetCustomFieldValueOrderByWithAggregationInput = {
  _count?: Maybe<ClinicPetCustomFieldValueCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPetCustomFieldValueMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPetCustomFieldValueMinOrderByAggregateInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ClinicPetCustomFieldValueOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetCustomFieldValueOrderByRelevanceInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinition?: Maybe<CustomFieldDefinitionOrderByWithRelationInput>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ClinicPetCustomFieldValueOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicPetCustomFieldValueOrderByRelevanceInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinition?: Maybe<CustomFieldDefinitionOrderByWithRelationInput>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export enum ClinicPetCustomFieldValueScalarFieldEnum {
  ClinicPetId = 'clinicPetId',
  CreatedAt = 'createdAt',
  FieldDefinitionId = 'fieldDefinitionId',
  Id = 'id',
  RawPimsValue = 'rawPimsValue',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type ClinicPetCustomFieldValueScalarWhereInput = {
  AND?: Maybe<Array<ClinicPetCustomFieldValueScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPetCustomFieldValueScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPetCustomFieldValueScalarWhereInput>>;
  clinicPetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  fieldDefinitionId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  value?: Maybe<JsonFilter>;
};

export type ClinicPetCustomFieldValueScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPetCustomFieldValueScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPetCustomFieldValueScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPetCustomFieldValueScalarWhereWithAggregatesInput>>;
  clinicPetId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  fieldDefinitionId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  value?: Maybe<JsonWithAggregatesFilter>;
};

export type ClinicPetCustomFieldValueUncheckedCreateInput = {
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCustomFieldValueCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ClinicPetCustomFieldValueCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ClinicPetCustomFieldValueCreateManyClinicPetInputEnvelope>;
};

export type ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutFieldDefinitionInput = {
  connect?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCustomFieldValueCreateOrConnectWithoutFieldDefinitionInput>>;
  create?: Maybe<Array<ClinicPetCustomFieldValueCreateWithoutFieldDefinitionInput>>;
  createMany?: Maybe<ClinicPetCustomFieldValueCreateManyFieldDefinitionInputEnvelope>;
};

export type ClinicPetCustomFieldValueUncheckedCreateWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetCustomFieldValueUncheckedCreateWithoutFieldDefinitionInput = {
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetCustomFieldValueUncheckedUpdateInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetCustomFieldValueUncheckedUpdateManyInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCustomFieldValueCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ClinicPetCustomFieldValueCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ClinicPetCustomFieldValueCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetCustomFieldValueScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetCustomFieldValueUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<ClinicPetCustomFieldValueUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<ClinicPetCustomFieldValueUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type ClinicPetCustomFieldValueUncheckedUpdateManyWithoutFieldDefinitionInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetCustomFieldValueUncheckedUpdateManyWithoutFieldDefinitionNestedInput = {
  connect?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCustomFieldValueCreateOrConnectWithoutFieldDefinitionInput>>;
  create?: Maybe<Array<ClinicPetCustomFieldValueCreateWithoutFieldDefinitionInput>>;
  createMany?: Maybe<ClinicPetCustomFieldValueCreateManyFieldDefinitionInputEnvelope>;
  delete?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetCustomFieldValueScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetCustomFieldValueUpdateWithWhereUniqueWithoutFieldDefinitionInput>>;
  updateMany?: Maybe<Array<ClinicPetCustomFieldValueUpdateManyWithWhereWithoutFieldDefinitionInput>>;
  upsert?: Maybe<Array<ClinicPetCustomFieldValueUpsertWithWhereUniqueWithoutFieldDefinitionInput>>;
};

export type ClinicPetCustomFieldValueUncheckedUpdateWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetCustomFieldValueUncheckedUpdateWithoutFieldDefinitionInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetCustomFieldValueUpdateInput = {
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutCustomFieldValuesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinition?: Maybe<CustomFieldDefinitionUpdateOneRequiredWithoutClinicPetFieldValuesNestedInput>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetCustomFieldValueUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetCustomFieldValueUpdateManyWithWhereWithoutClinicPetInput = {
  data: ClinicPetCustomFieldValueUpdateManyMutationInput;
  where: ClinicPetCustomFieldValueScalarWhereInput;
};

export type ClinicPetCustomFieldValueUpdateManyWithWhereWithoutFieldDefinitionInput = {
  data: ClinicPetCustomFieldValueUpdateManyMutationInput;
  where: ClinicPetCustomFieldValueScalarWhereInput;
};

export type ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCustomFieldValueCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ClinicPetCustomFieldValueCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ClinicPetCustomFieldValueCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetCustomFieldValueScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetCustomFieldValueUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<ClinicPetCustomFieldValueUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<ClinicPetCustomFieldValueUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type ClinicPetCustomFieldValueUpdateManyWithoutFieldDefinitionNestedInput = {
  connect?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCustomFieldValueCreateOrConnectWithoutFieldDefinitionInput>>;
  create?: Maybe<Array<ClinicPetCustomFieldValueCreateWithoutFieldDefinitionInput>>;
  createMany?: Maybe<ClinicPetCustomFieldValueCreateManyFieldDefinitionInputEnvelope>;
  delete?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetCustomFieldValueScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetCustomFieldValueWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetCustomFieldValueUpdateWithWhereUniqueWithoutFieldDefinitionInput>>;
  updateMany?: Maybe<Array<ClinicPetCustomFieldValueUpdateManyWithWhereWithoutFieldDefinitionInput>>;
  upsert?: Maybe<Array<ClinicPetCustomFieldValueUpsertWithWhereUniqueWithoutFieldDefinitionInput>>;
};

export type ClinicPetCustomFieldValueUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: ClinicPetCustomFieldValueUpdateWithoutClinicPetInput;
  where: ClinicPetCustomFieldValueWhereUniqueInput;
};

export type ClinicPetCustomFieldValueUpdateWithWhereUniqueWithoutFieldDefinitionInput = {
  data: ClinicPetCustomFieldValueUpdateWithoutFieldDefinitionInput;
  where: ClinicPetCustomFieldValueWhereUniqueInput;
};

export type ClinicPetCustomFieldValueUpdateWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinition?: Maybe<CustomFieldDefinitionUpdateOneRequiredWithoutClinicPetFieldValuesNestedInput>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetCustomFieldValueUpdateWithoutFieldDefinitionInput = {
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutCustomFieldValuesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetCustomFieldValueUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: ClinicPetCustomFieldValueCreateWithoutClinicPetInput;
  update: ClinicPetCustomFieldValueUpdateWithoutClinicPetInput;
  where: ClinicPetCustomFieldValueWhereUniqueInput;
};

export type ClinicPetCustomFieldValueUpsertWithWhereUniqueWithoutFieldDefinitionInput = {
  create: ClinicPetCustomFieldValueCreateWithoutFieldDefinitionInput;
  update: ClinicPetCustomFieldValueUpdateWithoutFieldDefinitionInput;
  where: ClinicPetCustomFieldValueWhereUniqueInput;
};

export type ClinicPetCustomFieldValueWhereInput = {
  AND?: Maybe<Array<ClinicPetCustomFieldValueWhereInput>>;
  NOT?: Maybe<Array<ClinicPetCustomFieldValueWhereInput>>;
  OR?: Maybe<Array<ClinicPetCustomFieldValueWhereInput>>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  fieldDefinition?: Maybe<CustomFieldDefinitionScalarRelationFilter>;
  fieldDefinitionId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  value?: Maybe<JsonFilter>;
};

export type ClinicPetCustomFieldValueWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPetCustomFieldValueWhereInput>>;
  NOT?: Maybe<Array<ClinicPetCustomFieldValueWhereInput>>;
  OR?: Maybe<Array<ClinicPetCustomFieldValueWhereInput>>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  fieldDefinition?: Maybe<CustomFieldDefinitionScalarRelationFilter>;
  fieldDefinitionId?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  value?: Maybe<JsonFilter>;
};

export type ClinicPetGroupByOutputType = {
  __typename?: 'ClinicPetGroupByOutputType';
  _avg?: Maybe<ClinicPetAvgAggregateOutputType>;
  _count?: Maybe<ClinicPetCountAggregateOutputType>;
  _max?: Maybe<ClinicPetMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetMinAggregateOutputType>;
  _sum?: Maybe<ClinicPetSumAggregateOutputType>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders: Scalars['Boolean'];
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType: SpeciesType;
  updatedAt: Scalars['DateTime'];
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetListRelationFilter = {
  every?: Maybe<ClinicPetWhereInput>;
  none?: Maybe<ClinicPetWhereInput>;
  some?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetMaxAggregateOutputType = {
  __typename?: 'ClinicPetMaxAggregateOutputType';
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetMaxOrderByAggregateInput = {
  breed?: Maybe<SortOrder>;
  breedId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  colorId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dateOfBirth?: Maybe<SortOrder>;
  dateOfDeath?: Maybe<SortOrder>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeceased?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  mediaId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationPetId?: Maybe<SortOrder>;
  photoUrl?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  sexId?: Maybe<SortOrder>;
  species?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  speciesType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
  weightInKg?: Maybe<SortOrder>;
  weightUnit?: Maybe<SortOrder>;
};

export type ClinicPetMinAggregateOutputType = {
  __typename?: 'ClinicPetMinAggregateOutputType';
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetMinOrderByAggregateInput = {
  breed?: Maybe<SortOrder>;
  breedId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  colorId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dateOfBirth?: Maybe<SortOrder>;
  dateOfDeath?: Maybe<SortOrder>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeceased?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  mediaId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationPetId?: Maybe<SortOrder>;
  photoUrl?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  sexId?: Maybe<SortOrder>;
  species?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  speciesType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
  weightInKg?: Maybe<SortOrder>;
  weightUnit?: Maybe<SortOrder>;
};

export type ClinicPetNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicPetWhereInput>>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  LabPanel?: Maybe<LabPanelListRelationFilter>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ClinicPetWhereInput>>;
  OR?: Maybe<Array<ClinicPetWhereInput>>;
  alerts?: Maybe<ClinicPetAlertListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  breed?: Maybe<StringNullableFilter>;
  breedId?: Maybe<StringNullableFilter>;
  breedModel?: Maybe<BreedNullableScalarRelationFilter>;
  careBenefitUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusListRelationFilter>;
  color?: Maybe<StringNullableFilter>;
  colorId?: Maybe<StringNullableFilter>;
  colorModel?: Maybe<ColorNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueListRelationFilter>;
  dateOfBirth?: Maybe<DateTimeNullableFilter>;
  dateOfDeath?: Maybe<DateTimeNullableFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  gender?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  invoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeceased?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isPrivacyProtected?: Maybe<BoolNullableFilter>;
  isSubscribedToReminders?: Maybe<BoolFilter>;
  media?: Maybe<MediaNullableScalarRelationFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  organizationPet?: Maybe<OrganizationPetNullableScalarRelationFilter>;
  organizationPetId?: Maybe<StringNullableFilter>;
  petParents?: Maybe<ClinicPetParentListRelationFilter>;
  photoUrl?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  serviceReminders?: Maybe<ServiceReminderListRelationFilter>;
  sexId?: Maybe<StringNullableFilter>;
  sexModel?: Maybe<SexNullableScalarRelationFilter>;
  species?: Maybe<StringNullableFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  speciesModel?: Maybe<SpeciesNullableScalarRelationFilter>;
  speciesType?: Maybe<EnumSpeciesTypeFilter>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vaccinations?: Maybe<VaccinationListRelationFilter>;
  weight?: Maybe<FloatNullableFilter>;
  weightInKg?: Maybe<FloatNullableFilter>;
  weightUnit?: Maybe<StringNullableFilter>;
};

export type ClinicPetOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPetOrderByRelationAndSearchRelevanceInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  LabPanel?: Maybe<LabPanelOrderByRelationAggregateInput>;
  MedicalHistory?: Maybe<MedicalHistoryOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicPetOrderByRelevanceInput>;
  alerts?: Maybe<ClinicPetAlertOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  automationRunActions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  breed?: Maybe<SortOrder>;
  breedId?: Maybe<SortOrder>;
  breedModel?: Maybe<BreedOrderByWithRelationInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusOrderByRelationAggregateInput>;
  color?: Maybe<SortOrder>;
  colorId?: Maybe<SortOrder>;
  colorModel?: Maybe<ColorOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueOrderByRelationAggregateInput>;
  dateOfBirth?: Maybe<SortOrder>;
  dateOfDeath?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  isActive?: Maybe<SortOrder>;
  isDeceased?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  media?: Maybe<MediaOrderByWithRelationInput>;
  mediaId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  organizationPetId?: Maybe<SortOrder>;
  petParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  photoUrl?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  rawPimsValue?: Maybe<SortOrder>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryOrderByRelationAggregateInput>;
  serviceReminders?: Maybe<ServiceReminderOrderByRelationAggregateInput>;
  sexId?: Maybe<SortOrder>;
  sexModel?: Maybe<SexOrderByWithRelationInput>;
  species?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  speciesModel?: Maybe<SpeciesOrderByWithRelationInput>;
  speciesType?: Maybe<SortOrder>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  vaccinations?: Maybe<VaccinationOrderByRelationAggregateInput>;
  weight?: Maybe<SortOrder>;
  weightInKg?: Maybe<SortOrder>;
  weightUnit?: Maybe<SortOrder>;
};

export enum ClinicPetOrderByRelevanceFieldEnum {
  Breed = 'breed',
  BreedId = 'breedId',
  ClinicId = 'clinicId',
  Color = 'color',
  ColorId = 'colorId',
  Gender = 'gender',
  Id = 'id',
  IntegrationId = 'integrationId',
  MediaId = 'mediaId',
  Name = 'name',
  OrganizationPetId = 'organizationPetId',
  PhotoUrl = 'photoUrl',
  PimsId = 'pimsId',
  SexId = 'sexId',
  Species = 'species',
  SpeciesId = 'speciesId',
  WeightUnit = 'weightUnit'
}

export type ClinicPetOrderByRelevanceInput = {
  fields: Array<ClinicPetOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPetOrderByWithAggregationInput = {
  _avg?: Maybe<ClinicPetAvgOrderByAggregateInput>;
  _count?: Maybe<ClinicPetCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPetMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPetMinOrderByAggregateInput>;
  _sum?: Maybe<ClinicPetSumOrderByAggregateInput>;
  breed?: Maybe<SortOrder>;
  breedId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  colorId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dateOfBirth?: Maybe<SortOrder>;
  dateOfDeath?: Maybe<SortOrder>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeceased?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  mediaId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationPetId?: Maybe<SortOrder>;
  photoUrl?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  sexId?: Maybe<SortOrder>;
  species?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  speciesType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
  weightInKg?: Maybe<SortOrder>;
  weightUnit?: Maybe<SortOrder>;
};

export type ClinicPetOrderByWithRelationAndSearchRelevanceInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  LabPanel?: Maybe<LabPanelOrderByRelationAggregateInput>;
  MedicalHistory?: Maybe<MedicalHistoryOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicPetOrderByRelevanceInput>;
  alerts?: Maybe<ClinicPetAlertOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  automationRunActions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  breed?: Maybe<SortOrder>;
  breedId?: Maybe<SortOrder>;
  breedModel?: Maybe<BreedOrderByWithRelationInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusOrderByRelationAggregateInput>;
  color?: Maybe<SortOrder>;
  colorId?: Maybe<SortOrder>;
  colorModel?: Maybe<ColorOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueOrderByRelationAggregateInput>;
  dateOfBirth?: Maybe<SortOrder>;
  dateOfDeath?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  isActive?: Maybe<SortOrder>;
  isDeceased?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  media?: Maybe<MediaOrderByWithRelationInput>;
  mediaId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  organizationPetId?: Maybe<SortOrder>;
  petParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  photoUrl?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  rawPimsValue?: Maybe<SortOrder>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryOrderByRelationAggregateInput>;
  serviceReminders?: Maybe<ServiceReminderOrderByRelationAggregateInput>;
  sexId?: Maybe<SortOrder>;
  sexModel?: Maybe<SexOrderByWithRelationInput>;
  species?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  speciesModel?: Maybe<SpeciesOrderByWithRelationInput>;
  speciesType?: Maybe<SortOrder>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  vaccinations?: Maybe<VaccinationOrderByRelationAggregateInput>;
  weight?: Maybe<SortOrder>;
  weightInKg?: Maybe<SortOrder>;
  weightUnit?: Maybe<SortOrder>;
};

export type ClinicPetOrderByWithRelationInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  LabPanel?: Maybe<LabPanelOrderByRelationAggregateInput>;
  MedicalHistory?: Maybe<MedicalHistoryOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicPetOrderByRelevanceInput>;
  alerts?: Maybe<ClinicPetAlertOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  automationRunActions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  breed?: Maybe<SortOrder>;
  breedId?: Maybe<SortOrder>;
  breedModel?: Maybe<BreedOrderByWithRelationInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusOrderByRelationAggregateInput>;
  color?: Maybe<SortOrder>;
  colorId?: Maybe<SortOrder>;
  colorModel?: Maybe<ColorOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueOrderByRelationAggregateInput>;
  dateOfBirth?: Maybe<SortOrder>;
  dateOfDeath?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  isActive?: Maybe<SortOrder>;
  isDeceased?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  media?: Maybe<MediaOrderByWithRelationInput>;
  mediaId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  organizationPetId?: Maybe<SortOrder>;
  petParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  photoUrl?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  rawPimsValue?: Maybe<SortOrder>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryOrderByRelationAggregateInput>;
  serviceReminders?: Maybe<ServiceReminderOrderByRelationAggregateInput>;
  sexId?: Maybe<SortOrder>;
  sexModel?: Maybe<SexOrderByWithRelationInput>;
  species?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  speciesModel?: Maybe<SpeciesOrderByWithRelationInput>;
  speciesType?: Maybe<SortOrder>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  vaccinations?: Maybe<VaccinationOrderByRelationAggregateInput>;
  weight?: Maybe<SortOrder>;
  weightInKg?: Maybe<SortOrder>;
  weightUnit?: Maybe<SortOrder>;
};

export type ClinicPetParent = {
  __typename?: 'ClinicPetParent';
  EmailCampaignLog: Array<EmailCampaignLog>;
  EmailCampaignUnsubscribe: Array<EmailCampaignUnsubscribe>;
  HillsToHomeAPILog: Array<HillsToHomeApiLog>;
  _count: ClinicPetParentCountOutputType;
  addresses: Array<ClinicPetParentAddress>;
  appointments: Array<Appointment>;
  automationRunActions: Array<AutomationRunAction>;
  automationRuns: Array<AutomationRun>;
  bitwerxPaymentHealthcheckResults: Array<BitwerxPaymentHealthcheckResult>;
  calls: Array<CallParticipant>;
  careAccountCreditIntents: Array<CareAccountCreditIntent>;
  careAuthorizationRequests: Array<CareAuthorizationRequest>;
  careCreditPreapprovalChecks: Array<CareCreditPreapprovalCheck>;
  channelCreationSources: Array<ChannelCreationSource>;
  channelMembers: Array<ChannelMember>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus: Array<ClinicPetParentPimsSyncStatus>;
  clinicWidgetRequests: Array<ClinicWidgetRequest>;
  createdAt: Scalars['DateTime'];
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues: Array<ClinicPetParentCustomFieldValue>;
  devices: Array<ClinicPetParentDevice>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients: Array<EmailCampaignCustomListRecipient>;
  emailProviderLogs: Array<EmailProviderLog>;
  firstName: Scalars['String'];
  formSubmissions: Array<FormSubmission>;
  globalPetParent?: Maybe<GlobalPetParent>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informAudienceMember: Array<InformAudienceMember>;
  informControlGroupParticipants: Array<InformControlGroupParticipant>;
  informSessions: Array<InformSession>;
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  invoices: Array<Invoice>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers: Array<LapsedPetParentTriggers>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolder>;
  massTextAlertEntries: Array<MassTextAlertEntry>;
  organizationPetParent?: Maybe<OrganizationPetParent>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSetting?: Maybe<PetParentSetting>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets: Array<ClinicPet>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers: Array<ClinicEntityPhoneNumber>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers: Array<SentTrupanionExamDayOffer>;
  servicePurchaseSummaries: Array<ServicePurchaseSummary>;
  serviceReminders: Array<ServiceReminder>;
  /** This is the user-readable ID from the PIMS if one exists */
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomer>;
  /** StripeCustomer can be shared between multiple petParent records - not unique */
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents: Array<StripePaymentIntent>;
  stripePaymentMethods: Array<StripePaymentMethod>;
  surveyResults: Array<SurveyResult>;
  tasks: Array<Task>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  /** Linked to User for testing and onboarding purposes */
  userId?: Maybe<Scalars['String']>;
};


export type ClinicPetParentEmailCampaignLogArgs = {
  cursor?: Maybe<EmailCampaignLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignLogWhereInput>;
};


export type ClinicPetParentEmailCampaignUnsubscribeArgs = {
  cursor?: Maybe<EmailCampaignUnsubscribeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignUnsubscribeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignUnsubscribeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignUnsubscribeWhereInput>;
};


export type ClinicPetParentHillsToHomeApiLogArgs = {
  cursor?: Maybe<HillsToHomeApiLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<HillsToHomeApiLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<HillsToHomeApiLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<HillsToHomeApiLogWhereInput>;
};


export type ClinicPetParentAddressesArgs = {
  cursor?: Maybe<ClinicPetParentAddressWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentAddressScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentAddressOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentAddressWhereInput>;
};


export type ClinicPetParentAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type ClinicPetParentAutomationRunActionsArgs = {
  cursor?: Maybe<AutomationRunActionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunActionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunActionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type ClinicPetParentAutomationRunsArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type ClinicPetParentBitwerxPaymentHealthcheckResultsArgs = {
  cursor?: Maybe<BitwerxPaymentHealthcheckResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentHealthcheckResultWhereInput>;
};


export type ClinicPetParentCallsArgs = {
  cursor?: Maybe<CallParticipantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallParticipantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallParticipantOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallParticipantWhereInput>;
};


export type ClinicPetParentCareAccountCreditIntentsArgs = {
  cursor?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAccountCreditIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAccountCreditIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};


export type ClinicPetParentCareAuthorizationRequestsArgs = {
  cursor?: Maybe<CareAuthorizationRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAuthorizationRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAuthorizationRequestOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAuthorizationRequestWhereInput>;
};


export type ClinicPetParentCareCreditPreapprovalChecksArgs = {
  cursor?: Maybe<CareCreditPreapprovalCheckWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareCreditPreapprovalCheckScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareCreditPreapprovalCheckOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};


export type ClinicPetParentChannelCreationSourcesArgs = {
  cursor?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelCreationSourceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelCreationSourceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type ClinicPetParentChannelMembersArgs = {
  cursor?: Maybe<ChannelMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMemberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMemberWhereInput>;
};


export type ClinicPetParentClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type ClinicPetParentClinicPetParentPimSyncStatusArgs = {
  cursor?: Maybe<ClinicPetParentPimsSyncStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentPimsSyncStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentPimsSyncStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentPimsSyncStatusWhereInput>;
};


export type ClinicPetParentClinicWidgetRequestsArgs = {
  cursor?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type ClinicPetParentCustomFieldValuesArgs = {
  cursor?: Maybe<ClinicPetParentCustomFieldValueWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentCustomFieldValueScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentCustomFieldValueOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentCustomFieldValueWhereInput>;
};


export type ClinicPetParentDevicesArgs = {
  cursor?: Maybe<ClinicPetParentDeviceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentDeviceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentDeviceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentDeviceWhereInput>;
};


export type ClinicPetParentEmailCampaignCustomListRecipientsArgs = {
  cursor?: Maybe<EmailCampaignCustomListRecipientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignCustomListRecipientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListRecipientOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListRecipientWhereInput>;
};


export type ClinicPetParentEmailProviderLogsArgs = {
  cursor?: Maybe<EmailProviderLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailProviderLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailProviderLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailProviderLogWhereInput>;
};


export type ClinicPetParentFormSubmissionsArgs = {
  cursor?: Maybe<FormSubmissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormSubmissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormSubmissionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormSubmissionWhereInput>;
};


export type ClinicPetParentGlobalPetParentArgs = {
  where?: Maybe<GlobalPetParentWhereInput>;
};


export type ClinicPetParentInformAudienceMemberArgs = {
  cursor?: Maybe<InformAudienceMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberWhereInput>;
};


export type ClinicPetParentInformControlGroupParticipantsArgs = {
  cursor?: Maybe<InformControlGroupParticipantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformControlGroupParticipantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformControlGroupParticipantOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformControlGroupParticipantWhereInput>;
};


export type ClinicPetParentInformSessionsArgs = {
  cursor?: Maybe<InformSessionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformSessionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformSessionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionWhereInput>;
};


export type ClinicPetParentIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type ClinicPetParentInvoicesArgs = {
  cursor?: Maybe<InvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceWhereInput>;
};


export type ClinicPetParentLapsedPetParentTriggersArgs = {
  cursor?: Maybe<LapsedPetParentTriggersWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LapsedPetParentTriggersScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LapsedPetParentTriggersOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LapsedPetParentTriggersWhereInput>;
};


export type ClinicPetParentLoyaltyAccountHolderArgs = {
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};


export type ClinicPetParentMassTextAlertEntriesArgs = {
  cursor?: Maybe<MassTextAlertEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertEntryWhereInput>;
};


export type ClinicPetParentOrganizationPetParentArgs = {
  where?: Maybe<OrganizationPetParentWhereInput>;
};


export type ClinicPetParentPetParentSettingArgs = {
  where?: Maybe<PetParentSettingWhereInput>;
};


export type ClinicPetParentPetsArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type ClinicPetParentPhoneNumbersArgs = {
  cursor?: Maybe<ClinicEntityPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEntityPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEntityPhoneNumberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEntityPhoneNumberWhereInput>;
};


export type ClinicPetParentReceivedTrupanionExamDayOffersArgs = {
  cursor?: Maybe<SentTrupanionExamDayOfferWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SentTrupanionExamDayOfferScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SentTrupanionExamDayOfferOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};


export type ClinicPetParentServicePurchaseSummariesArgs = {
  cursor?: Maybe<ServicePurchaseSummaryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServicePurchaseSummaryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServicePurchaseSummaryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};


export type ClinicPetParentServiceRemindersArgs = {
  cursor?: Maybe<ServiceReminderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderWhereInput>;
};


export type ClinicPetParentStripeCustomerArgs = {
  where?: Maybe<StripeCustomerWhereInput>;
};


export type ClinicPetParentStripePaymentIntentsArgs = {
  cursor?: Maybe<StripePaymentIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type ClinicPetParentStripePaymentMethodsArgs = {
  cursor?: Maybe<StripePaymentMethodWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentMethodScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentMethodOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentMethodWhereInput>;
};


export type ClinicPetParentSurveyResultsArgs = {
  cursor?: Maybe<SurveyResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveyResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveyResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyResultWhereInput>;
};


export type ClinicPetParentTasksArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaskScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaskOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaskWhereInput>;
};


export type ClinicPetParentUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type ClinicPetParentAddress = {
  __typename?: 'ClinicPetParentAddress';
  addressType?: Maybe<ClinicPetParentAddressType>;
  city: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut: Scalars['Boolean'];
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ClinicPetParentAddressCountAggregateOutputType = {
  __typename?: 'ClinicPetParentAddressCountAggregateOutputType';
  _all: Scalars['Int'];
  addressType: Scalars['Int'];
  city: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  creationSource: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isOptedOut: Scalars['Int'];
  isPrimary: Scalars['Int'];
  line1: Scalars['Int'];
  line2: Scalars['Int'];
  pimsId: Scalars['Int'];
  postalCode: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  stateProvince: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicPetParentAddressCountOrderByAggregateInput = {
  addressType?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  line1?: Maybe<SortOrder>;
  line2?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  stateProvince?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentAddressCreateInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city: Scalars['String'];
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutAddressesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressCreateManyClinicPetParentInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressCreateManyClinicPetParentInputEnvelope = {
  data: Array<ClinicPetParentAddressCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetParentAddressCreateManyInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ClinicPetParentAddressWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentAddressCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentAddressCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentAddressCreateManyClinicPetParentInputEnvelope>;
};

export type ClinicPetParentAddressCreateOrConnectWithoutClinicPetParentInput = {
  create: ClinicPetParentAddressCreateWithoutClinicPetParentInput;
  where: ClinicPetParentAddressWhereUniqueInput;
};

export type ClinicPetParentAddressCreateWithoutClinicPetParentInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressGroupByOutputType = {
  __typename?: 'ClinicPetParentAddressGroupByOutputType';
  _count?: Maybe<ClinicPetParentAddressCountAggregateOutputType>;
  _max?: Maybe<ClinicPetParentAddressMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetParentAddressMinAggregateOutputType>;
  addressType?: Maybe<ClinicPetParentAddressType>;
  city: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut: Scalars['Boolean'];
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ClinicPetParentAddressListRelationFilter = {
  every?: Maybe<ClinicPetParentAddressWhereInput>;
  none?: Maybe<ClinicPetParentAddressWhereInput>;
  some?: Maybe<ClinicPetParentAddressWhereInput>;
};

export type ClinicPetParentAddressMaxAggregateOutputType = {
  __typename?: 'ClinicPetParentAddressMaxAggregateOutputType';
  addressType?: Maybe<ClinicPetParentAddressType>;
  city?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressMaxOrderByAggregateInput = {
  addressType?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  line1?: Maybe<SortOrder>;
  line2?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  stateProvince?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentAddressMinAggregateOutputType = {
  __typename?: 'ClinicPetParentAddressMinAggregateOutputType';
  addressType?: Maybe<ClinicPetParentAddressType>;
  city?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressMinOrderByAggregateInput = {
  addressType?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  line1?: Maybe<SortOrder>;
  line2?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  stateProvince?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentAddressOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPetParentAddressOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetParentAddressOrderByRelevanceInput>;
  addressType?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  line1?: Maybe<SortOrder>;
  line2?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  stateProvince?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPetParentAddressOrderByRelevanceFieldEnum {
  City = 'city',
  ClinicPetParentId = 'clinicPetParentId',
  Id = 'id',
  Line1 = 'line1',
  Line2 = 'line2',
  PimsId = 'pimsId',
  PostalCode = 'postalCode',
  StateProvince = 'stateProvince'
}

export type ClinicPetParentAddressOrderByRelevanceInput = {
  fields: Array<ClinicPetParentAddressOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPetParentAddressOrderByWithAggregationInput = {
  _count?: Maybe<ClinicPetParentAddressCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPetParentAddressMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPetParentAddressMinOrderByAggregateInput>;
  addressType?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  line1?: Maybe<SortOrder>;
  line2?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  stateProvince?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentAddressOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetParentAddressOrderByRelevanceInput>;
  addressType?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  line1?: Maybe<SortOrder>;
  line2?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  stateProvince?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentAddressOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicPetParentAddressOrderByRelevanceInput>;
  addressType?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isOptedOut?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  line1?: Maybe<SortOrder>;
  line2?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  stateProvince?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPetParentAddressScalarFieldEnum {
  AddressType = 'addressType',
  City = 'city',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  CreationSource = 'creationSource',
  Id = 'id',
  IsDeleted = 'isDeleted',
  IsOptedOut = 'isOptedOut',
  IsPrimary = 'isPrimary',
  Line1 = 'line1',
  Line2 = 'line2',
  PimsId = 'pimsId',
  PostalCode = 'postalCode',
  RawPimsValue = 'rawPimsValue',
  StateProvince = 'stateProvince',
  UpdatedAt = 'updatedAt'
}

export type ClinicPetParentAddressScalarWhereInput = {
  AND?: Maybe<Array<ClinicPetParentAddressScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentAddressScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentAddressScalarWhereInput>>;
  addressType?: Maybe<EnumClinicPetParentAddressTypeNullableFilter>;
  city?: Maybe<StringFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<EnumClinicEntityCreationSourceNullableFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isOptedOut?: Maybe<BoolFilter>;
  isPrimary?: Maybe<BoolNullableFilter>;
  line1?: Maybe<StringFilter>;
  line2?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  stateProvince?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPetParentAddressScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPetParentAddressScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPetParentAddressScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPetParentAddressScalarWhereWithAggregatesInput>>;
  addressType?: Maybe<EnumClinicPetParentAddressTypeNullableWithAggregatesFilter>;
  city?: Maybe<StringWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  creationSource?: Maybe<EnumClinicEntityCreationSourceNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolNullableWithAggregatesFilter>;
  isOptedOut?: Maybe<BoolWithAggregatesFilter>;
  isPrimary?: Maybe<BoolNullableWithAggregatesFilter>;
  line1?: Maybe<StringWithAggregatesFilter>;
  line2?: Maybe<StringNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  postalCode?: Maybe<StringWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  stateProvince?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum ClinicPetParentAddressType {
  Billing = 'Billing',
  Primary = 'Primary',
  Secondary = 'Secondary',
  Unknown = 'Unknown',
  Work = 'Work'
}

export type ClinicPetParentAddressUncheckedCreateInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ClinicPetParentAddressWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentAddressCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentAddressCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentAddressCreateManyClinicPetParentInputEnvelope>;
};

export type ClinicPetParentAddressUncheckedCreateWithoutClinicPetParentInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressUncheckedUpdateInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressUncheckedUpdateManyInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ClinicPetParentAddressWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentAddressCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentAddressCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentAddressCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentAddressWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentAddressScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentAddressWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentAddressWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentAddressUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ClinicPetParentAddressUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ClinicPetParentAddressUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ClinicPetParentAddressUncheckedUpdateWithoutClinicPetParentInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressUniquePimsAddressPerPetParentCompoundUniqueInput = {
  clinicPetParentId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type ClinicPetParentAddressUpdateInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutAddressesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressUpdateManyMutationInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: ClinicPetParentAddressUpdateManyMutationInput;
  where: ClinicPetParentAddressScalarWhereInput;
};

export type ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ClinicPetParentAddressWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentAddressCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentAddressCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentAddressCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentAddressWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentAddressScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentAddressWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentAddressWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentAddressUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ClinicPetParentAddressUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ClinicPetParentAddressUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ClinicPetParentAddressUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: ClinicPetParentAddressUpdateWithoutClinicPetParentInput;
  where: ClinicPetParentAddressWhereUniqueInput;
};

export type ClinicPetParentAddressUpdateWithoutClinicPetParentInput = {
  addressType?: Maybe<ClinicPetParentAddressType>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentAddressUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: ClinicPetParentAddressCreateWithoutClinicPetParentInput;
  update: ClinicPetParentAddressUpdateWithoutClinicPetParentInput;
  where: ClinicPetParentAddressWhereUniqueInput;
};

export type ClinicPetParentAddressWhereInput = {
  AND?: Maybe<Array<ClinicPetParentAddressWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentAddressWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentAddressWhereInput>>;
  addressType?: Maybe<EnumClinicPetParentAddressTypeNullableFilter>;
  city?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<EnumClinicEntityCreationSourceNullableFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isOptedOut?: Maybe<BoolFilter>;
  isPrimary?: Maybe<BoolNullableFilter>;
  line1?: Maybe<StringFilter>;
  line2?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  stateProvince?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPetParentAddressWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPetParentAddressWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentAddressWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentAddressWhereInput>>;
  addressType?: Maybe<EnumClinicPetParentAddressTypeNullableFilter>;
  city?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<EnumClinicEntityCreationSourceNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isOptedOut?: Maybe<BoolFilter>;
  isPrimary?: Maybe<BoolNullableFilter>;
  line1?: Maybe<StringFilter>;
  line2?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  stateProvince?: Maybe<StringFilter>;
  uniquePimsAddressPerPetParent?: Maybe<ClinicPetParentAddressUniquePimsAddressPerPetParentCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPetParentAuthLinkResponse = {
  __typename?: 'ClinicPetParentAuthLinkResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ClinicPetParentClinicPetParentPimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type ClinicPetParentCountAggregateOutputType = {
  __typename?: 'ClinicPetParentCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  creationSource: Scalars['Int'];
  email: Scalars['Int'];
  firstName: Scalars['Int'];
  globalPetParentId: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isPrivacyProtected: Scalars['Int'];
  isTest: Scalars['Int'];
  isVerified: Scalars['Int'];
  lastName: Scalars['Int'];
  organizationPetParentId: Scalars['Int'];
  petParentSettingId: Scalars['Int'];
  phoneNumber: Scalars['Int'];
  pimsAccountId: Scalars['Int'];
  pimsId: Scalars['Int'];
  pimsPhoneNumber: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  sourcePimsId: Scalars['Int'];
  stripeCustomerId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ClinicPetParentCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  globalPetParentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isTest?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  organizationPetParentId?: Maybe<SortOrder>;
  petParentSettingId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  pimsAccountId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsPhoneNumber?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  sourcePimsId?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ClinicPetParentCountOutputType = {
  __typename?: 'ClinicPetParentCountOutputType';
  EmailCampaignLog: Scalars['Int'];
  EmailCampaignUnsubscribe: Scalars['Int'];
  HillsToHomeAPILog: Scalars['Int'];
  addresses: Scalars['Int'];
  appointments: Scalars['Int'];
  automationRunActions: Scalars['Int'];
  automationRuns: Scalars['Int'];
  bitwerxPaymentHealthcheckResults: Scalars['Int'];
  calls: Scalars['Int'];
  careAccountCreditIntents: Scalars['Int'];
  careAuthorizationRequests: Scalars['Int'];
  careCreditPreapprovalChecks: Scalars['Int'];
  channelCreationSources: Scalars['Int'];
  channelMembers: Scalars['Int'];
  clinicPetParentPimSyncStatus: Scalars['Int'];
  clinicWidgetRequests: Scalars['Int'];
  customFieldValues: Scalars['Int'];
  devices: Scalars['Int'];
  emailCampaignCustomListRecipients: Scalars['Int'];
  emailProviderLogs: Scalars['Int'];
  formSubmissions: Scalars['Int'];
  informAudienceMember: Scalars['Int'];
  informControlGroupParticipants: Scalars['Int'];
  informSessions: Scalars['Int'];
  invoices: Scalars['Int'];
  lapsedPetParentTriggers: Scalars['Int'];
  massTextAlertEntries: Scalars['Int'];
  pets: Scalars['Int'];
  phoneNumbers: Scalars['Int'];
  receivedTrupanionExamDayOffers: Scalars['Int'];
  servicePurchaseSummaries: Scalars['Int'];
  serviceReminders: Scalars['Int'];
  stripePaymentIntents: Scalars['Int'];
  stripePaymentMethods: Scalars['Int'];
  surveyResults: Scalars['Int'];
  tasks: Scalars['Int'];
};

export type ClinicPetParentCreateInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentCreateManyClinicInputEnvelope = {
  data: Array<ClinicPetParentCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetParentCreateManyGlobalPetParentInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentCreateManyGlobalPetParentInputEnvelope = {
  data: Array<ClinicPetParentCreateManyGlobalPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetParentCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentCreateManyIntegrationInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentCreateManyIntegrationInputEnvelope = {
  data: Array<ClinicPetParentCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetParentCreateManyOrganizationPetParentInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentCreateManyOrganizationPetParentInputEnvelope = {
  data: Array<ClinicPetParentCreateManyOrganizationPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetParentCreateManyPetParentSettingInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  organizationPetParentId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentCreateManyPetParentSettingInputEnvelope = {
  data: Array<ClinicPetParentCreateManyPetParentSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetParentCreateManyStripeCustomerInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentCreateManyStripeCustomerInputEnvelope = {
  data: Array<ClinicPetParentCreateManyStripeCustomerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetParentCreateManyUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentCreateManyUserInputEnvelope = {
  data: Array<ClinicPetParentCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetParentCreateNestedManyWithoutAppointmentsInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutAppointmentsInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutAppointmentsInput>>;
};

export type ClinicPetParentCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyClinicInputEnvelope>;
};

export type ClinicPetParentCreateNestedManyWithoutGlobalPetParentInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutGlobalPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutGlobalPetParentInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyGlobalPetParentInputEnvelope>;
};

export type ClinicPetParentCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyIntegrationInputEnvelope>;
};

export type ClinicPetParentCreateNestedManyWithoutOrganizationPetParentInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutOrganizationPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutOrganizationPetParentInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyOrganizationPetParentInputEnvelope>;
};

export type ClinicPetParentCreateNestedManyWithoutPetParentSettingInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutPetParentSettingInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutPetParentSettingInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyPetParentSettingInputEnvelope>;
};

export type ClinicPetParentCreateNestedManyWithoutPetsInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutPetsInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutPetsInput>>;
};

export type ClinicPetParentCreateNestedManyWithoutStripeCustomerInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyStripeCustomerInputEnvelope>;
};

export type ClinicPetParentCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutUserInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyUserInputEnvelope>;
};

export type ClinicPetParentCreateNestedOneWithoutAddressesInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutAddressesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutAddressesInput>;
};

export type ClinicPetParentCreateNestedOneWithoutAutomationRunActionsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutAutomationRunActionsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutAutomationRunActionsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutAutomationRunsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutAutomationRunsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutBitwerxPaymentHealthcheckResultsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutBitwerxPaymentHealthcheckResultsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutBitwerxPaymentHealthcheckResultsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutCallsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutCallsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutCallsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutCareAccountCreditIntentsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutCareAccountCreditIntentsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutCareAccountCreditIntentsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutCareAuthorizationRequestsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutCareAuthorizationRequestsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutCareAuthorizationRequestsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutCareCreditPreapprovalChecksInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutCareCreditPreapprovalChecksInput>;
  create?: Maybe<ClinicPetParentCreateWithoutCareCreditPreapprovalChecksInput>;
};

export type ClinicPetParentCreateNestedOneWithoutChannelCreationSourcesInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutChannelCreationSourcesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutChannelCreationSourcesInput>;
};

export type ClinicPetParentCreateNestedOneWithoutChannelMembersInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutChannelMembersInput>;
  create?: Maybe<ClinicPetParentCreateWithoutChannelMembersInput>;
};

export type ClinicPetParentCreateNestedOneWithoutClinicPetParentPimSyncStatusInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutClinicPetParentPimSyncStatusInput>;
  create?: Maybe<ClinicPetParentCreateWithoutClinicPetParentPimSyncStatusInput>;
};

export type ClinicPetParentCreateNestedOneWithoutClinicWidgetRequestsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutClinicWidgetRequestsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutClinicWidgetRequestsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutCustomFieldValuesInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutCustomFieldValuesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutCustomFieldValuesInput>;
};

export type ClinicPetParentCreateNestedOneWithoutDevicesInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutDevicesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutDevicesInput>;
};

export type ClinicPetParentCreateNestedOneWithoutEmailCampaignCustomListRecipientsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutEmailCampaignCustomListRecipientsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutEmailCampaignCustomListRecipientsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutEmailCampaignLogInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutEmailCampaignLogInput>;
  create?: Maybe<ClinicPetParentCreateWithoutEmailCampaignLogInput>;
};

export type ClinicPetParentCreateNestedOneWithoutEmailCampaignUnsubscribeInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutEmailCampaignUnsubscribeInput>;
  create?: Maybe<ClinicPetParentCreateWithoutEmailCampaignUnsubscribeInput>;
};

export type ClinicPetParentCreateNestedOneWithoutEmailProviderLogsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutEmailProviderLogsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutEmailProviderLogsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutFormSubmissionsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutFormSubmissionsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutHillsToHomeApiLogInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutHillsToHomeApiLogInput>;
  create?: Maybe<ClinicPetParentCreateWithoutHillsToHomeApiLogInput>;
};

export type ClinicPetParentCreateNestedOneWithoutInformAudienceMemberInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutInformAudienceMemberInput>;
  create?: Maybe<ClinicPetParentCreateWithoutInformAudienceMemberInput>;
};

export type ClinicPetParentCreateNestedOneWithoutInformControlGroupParticipantsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutInformControlGroupParticipantsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutInformControlGroupParticipantsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutInformSessionsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutInformSessionsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutInformSessionsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutInvoicesInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutInvoicesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutInvoicesInput>;
};

export type ClinicPetParentCreateNestedOneWithoutLapsedPetParentTriggersInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutLapsedPetParentTriggersInput>;
  create?: Maybe<ClinicPetParentCreateWithoutLapsedPetParentTriggersInput>;
};

export type ClinicPetParentCreateNestedOneWithoutLoyaltyAccountHolderInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutLoyaltyAccountHolderInput>;
  create?: Maybe<ClinicPetParentCreateWithoutLoyaltyAccountHolderInput>;
};

export type ClinicPetParentCreateNestedOneWithoutMassTextAlertEntriesInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutMassTextAlertEntriesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutMassTextAlertEntriesInput>;
};

export type ClinicPetParentCreateNestedOneWithoutPhoneNumbersInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutPhoneNumbersInput>;
  create?: Maybe<ClinicPetParentCreateWithoutPhoneNumbersInput>;
};

export type ClinicPetParentCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutReceivedTrupanionExamDayOffersInput>;
  create?: Maybe<ClinicPetParentCreateWithoutReceivedTrupanionExamDayOffersInput>;
};

export type ClinicPetParentCreateNestedOneWithoutServicePurchaseSummariesInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutServicePurchaseSummariesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutServicePurchaseSummariesInput>;
};

export type ClinicPetParentCreateNestedOneWithoutServiceRemindersInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutServiceRemindersInput>;
  create?: Maybe<ClinicPetParentCreateWithoutServiceRemindersInput>;
};

export type ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutStripePaymentIntentsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutStripePaymentIntentsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutStripePaymentMethodsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutStripePaymentMethodsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutStripePaymentMethodsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutSurveyResultsInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutSurveyResultsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutSurveyResultsInput>;
};

export type ClinicPetParentCreateNestedOneWithoutTasksInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutTasksInput>;
  create?: Maybe<ClinicPetParentCreateWithoutTasksInput>;
};

export type ClinicPetParentCreateOrConnectWithoutAddressesInput = {
  create: ClinicPetParentCreateWithoutAddressesInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutAppointmentsInput = {
  create: ClinicPetParentCreateWithoutAppointmentsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutAutomationRunActionsInput = {
  create: ClinicPetParentCreateWithoutAutomationRunActionsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutAutomationRunsInput = {
  create: ClinicPetParentCreateWithoutAutomationRunsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutBitwerxPaymentHealthcheckResultsInput = {
  create: ClinicPetParentCreateWithoutBitwerxPaymentHealthcheckResultsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutCallsInput = {
  create: ClinicPetParentCreateWithoutCallsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutCareAccountCreditIntentsInput = {
  create: ClinicPetParentCreateWithoutCareAccountCreditIntentsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutCareAuthorizationRequestsInput = {
  create: ClinicPetParentCreateWithoutCareAuthorizationRequestsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutCareCreditPreapprovalChecksInput = {
  create: ClinicPetParentCreateWithoutCareCreditPreapprovalChecksInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutChannelCreationSourcesInput = {
  create: ClinicPetParentCreateWithoutChannelCreationSourcesInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutChannelMembersInput = {
  create: ClinicPetParentCreateWithoutChannelMembersInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutClinicInput = {
  create: ClinicPetParentCreateWithoutClinicInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutClinicPetParentPimSyncStatusInput = {
  create: ClinicPetParentCreateWithoutClinicPetParentPimSyncStatusInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutClinicWidgetRequestsInput = {
  create: ClinicPetParentCreateWithoutClinicWidgetRequestsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutCustomFieldValuesInput = {
  create: ClinicPetParentCreateWithoutCustomFieldValuesInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutDevicesInput = {
  create: ClinicPetParentCreateWithoutDevicesInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutEmailCampaignCustomListRecipientsInput = {
  create: ClinicPetParentCreateWithoutEmailCampaignCustomListRecipientsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutEmailCampaignLogInput = {
  create: ClinicPetParentCreateWithoutEmailCampaignLogInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutEmailCampaignUnsubscribeInput = {
  create: ClinicPetParentCreateWithoutEmailCampaignUnsubscribeInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutEmailProviderLogsInput = {
  create: ClinicPetParentCreateWithoutEmailProviderLogsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutFormSubmissionsInput = {
  create: ClinicPetParentCreateWithoutFormSubmissionsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutGlobalPetParentInput = {
  create: ClinicPetParentCreateWithoutGlobalPetParentInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutHillsToHomeApiLogInput = {
  create: ClinicPetParentCreateWithoutHillsToHomeApiLogInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutInformAudienceMemberInput = {
  create: ClinicPetParentCreateWithoutInformAudienceMemberInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutInformControlGroupParticipantsInput = {
  create: ClinicPetParentCreateWithoutInformControlGroupParticipantsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutInformSessionsInput = {
  create: ClinicPetParentCreateWithoutInformSessionsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutIntegrationInput = {
  create: ClinicPetParentCreateWithoutIntegrationInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutInvoicesInput = {
  create: ClinicPetParentCreateWithoutInvoicesInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutLapsedPetParentTriggersInput = {
  create: ClinicPetParentCreateWithoutLapsedPetParentTriggersInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutLoyaltyAccountHolderInput = {
  create: ClinicPetParentCreateWithoutLoyaltyAccountHolderInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutMassTextAlertEntriesInput = {
  create: ClinicPetParentCreateWithoutMassTextAlertEntriesInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutOrganizationPetParentInput = {
  create: ClinicPetParentCreateWithoutOrganizationPetParentInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutPetParentSettingInput = {
  create: ClinicPetParentCreateWithoutPetParentSettingInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutPetsInput = {
  create: ClinicPetParentCreateWithoutPetsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutPhoneNumbersInput = {
  create: ClinicPetParentCreateWithoutPhoneNumbersInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutReceivedTrupanionExamDayOffersInput = {
  create: ClinicPetParentCreateWithoutReceivedTrupanionExamDayOffersInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutServicePurchaseSummariesInput = {
  create: ClinicPetParentCreateWithoutServicePurchaseSummariesInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutServiceRemindersInput = {
  create: ClinicPetParentCreateWithoutServiceRemindersInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutStripeCustomerInput = {
  create: ClinicPetParentCreateWithoutStripeCustomerInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutStripePaymentIntentsInput = {
  create: ClinicPetParentCreateWithoutStripePaymentIntentsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutStripePaymentMethodsInput = {
  create: ClinicPetParentCreateWithoutStripePaymentMethodsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutSurveyResultsInput = {
  create: ClinicPetParentCreateWithoutSurveyResultsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutTasksInput = {
  create: ClinicPetParentCreateWithoutTasksInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateOrConnectWithoutUserInput = {
  create: ClinicPetParentCreateWithoutUserInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentCreateWithoutAddressesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutAppointmentsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutAutomationRunActionsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutAutomationRunsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutBitwerxPaymentHealthcheckResultsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutCallsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutCareAccountCreditIntentsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutCareAuthorizationRequestsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutCareCreditPreapprovalChecksInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutChannelCreationSourcesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutChannelMembersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutClinicInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutClinicPetParentPimSyncStatusInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutClinicWidgetRequestsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutCustomFieldValuesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutDevicesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutEmailCampaignCustomListRecipientsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutEmailCampaignLogInput = {
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutEmailCampaignUnsubscribeInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutEmailProviderLogsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutFormSubmissionsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutGlobalPetParentInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutHillsToHomeApiLogInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutInformAudienceMemberInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutInformControlGroupParticipantsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutInformSessionsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutIntegrationInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutInvoicesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutLapsedPetParentTriggersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutLoyaltyAccountHolderInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutMassTextAlertEntriesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutOrganizationPetParentInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutPetParentSettingInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutPetsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutPhoneNumbersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutReceivedTrupanionExamDayOffersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutServicePurchaseSummariesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutServiceRemindersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutStripeCustomerInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutStripePaymentIntentsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutStripePaymentMethodsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutSurveyResultsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutTasksInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutClinicPetParentsInput>;
};

export type ClinicPetParentCreateWithoutUserInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParent?: Maybe<GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutClinicPetParentInput>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParent?: Maybe<OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutClinicPetParentsInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Custom Values specifically for ClinicPetParent */
export type ClinicPetParentCustomFieldValue = {
  __typename?: 'ClinicPetParentCustomFieldValue';
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fieldDefinition: CustomFieldDefinition;
  fieldDefinitionId: Scalars['String'];
  id: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Json'];
};

export type ClinicPetParentCustomFieldValueCountAggregateOutputType = {
  __typename?: 'ClinicPetParentCustomFieldValueCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  fieldDefinitionId: Scalars['Int'];
  id: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  updatedAt: Scalars['Int'];
  value: Scalars['Int'];
};

export type ClinicPetParentCustomFieldValueCountOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ClinicPetParentCustomFieldValueCreateInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutCustomFieldValuesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinition: CustomFieldDefinitionCreateNestedOneWithoutClinicPetParentFieldValuesInput;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetParentCustomFieldValueCreateManyClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetParentCustomFieldValueCreateManyClinicPetParentInputEnvelope = {
  data: Array<ClinicPetParentCustomFieldValueCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetParentCustomFieldValueCreateManyFieldDefinitionInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetParentCustomFieldValueCreateManyFieldDefinitionInputEnvelope = {
  data: Array<ClinicPetParentCustomFieldValueCreateManyFieldDefinitionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetParentCustomFieldValueCreateManyInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetParentCustomFieldValueCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCustomFieldValueCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentCustomFieldValueCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentCustomFieldValueCreateManyClinicPetParentInputEnvelope>;
};

export type ClinicPetParentCustomFieldValueCreateNestedManyWithoutFieldDefinitionInput = {
  connect?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCustomFieldValueCreateOrConnectWithoutFieldDefinitionInput>>;
  create?: Maybe<Array<ClinicPetParentCustomFieldValueCreateWithoutFieldDefinitionInput>>;
  createMany?: Maybe<ClinicPetParentCustomFieldValueCreateManyFieldDefinitionInputEnvelope>;
};

export type ClinicPetParentCustomFieldValueCreateOrConnectWithoutClinicPetParentInput = {
  create: ClinicPetParentCustomFieldValueCreateWithoutClinicPetParentInput;
  where: ClinicPetParentCustomFieldValueWhereUniqueInput;
};

export type ClinicPetParentCustomFieldValueCreateOrConnectWithoutFieldDefinitionInput = {
  create: ClinicPetParentCustomFieldValueCreateWithoutFieldDefinitionInput;
  where: ClinicPetParentCustomFieldValueWhereUniqueInput;
};

export type ClinicPetParentCustomFieldValueCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinition: CustomFieldDefinitionCreateNestedOneWithoutClinicPetParentFieldValuesInput;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetParentCustomFieldValueCreateWithoutFieldDefinitionInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutCustomFieldValuesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetParentCustomFieldValueGroupByOutputType = {
  __typename?: 'ClinicPetParentCustomFieldValueGroupByOutputType';
  _count?: Maybe<ClinicPetParentCustomFieldValueCountAggregateOutputType>;
  _max?: Maybe<ClinicPetParentCustomFieldValueMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetParentCustomFieldValueMinAggregateOutputType>;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fieldDefinitionId: Scalars['String'];
  id: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Json'];
};

export type ClinicPetParentCustomFieldValueListRelationFilter = {
  every?: Maybe<ClinicPetParentCustomFieldValueWhereInput>;
  none?: Maybe<ClinicPetParentCustomFieldValueWhereInput>;
  some?: Maybe<ClinicPetParentCustomFieldValueWhereInput>;
};

export type ClinicPetParentCustomFieldValueMaxAggregateOutputType = {
  __typename?: 'ClinicPetParentCustomFieldValueMaxAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentCustomFieldValueMaxOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentCustomFieldValueMinAggregateOutputType = {
  __typename?: 'ClinicPetParentCustomFieldValueMinAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentCustomFieldValueMinOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentCustomFieldValueOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPetParentCustomFieldValueOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetParentCustomFieldValueOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinition?: Maybe<CustomFieldDefinitionOrderByWithRelationInput>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export enum ClinicPetParentCustomFieldValueOrderByRelevanceFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  FieldDefinitionId = 'fieldDefinitionId',
  Id = 'id'
}

export type ClinicPetParentCustomFieldValueOrderByRelevanceInput = {
  fields: Array<ClinicPetParentCustomFieldValueOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPetParentCustomFieldValueOrderByWithAggregationInput = {
  _count?: Maybe<ClinicPetParentCustomFieldValueCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPetParentCustomFieldValueMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPetParentCustomFieldValueMinOrderByAggregateInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ClinicPetParentCustomFieldValueOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetParentCustomFieldValueOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinition?: Maybe<CustomFieldDefinitionOrderByWithRelationInput>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ClinicPetParentCustomFieldValueOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicPetParentCustomFieldValueOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fieldDefinition?: Maybe<CustomFieldDefinitionOrderByWithRelationInput>;
  fieldDefinitionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export enum ClinicPetParentCustomFieldValueScalarFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  FieldDefinitionId = 'fieldDefinitionId',
  Id = 'id',
  RawPimsValue = 'rawPimsValue',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type ClinicPetParentCustomFieldValueScalarWhereInput = {
  AND?: Maybe<Array<ClinicPetParentCustomFieldValueScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentCustomFieldValueScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentCustomFieldValueScalarWhereInput>>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  fieldDefinitionId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  value?: Maybe<JsonFilter>;
};

export type ClinicPetParentCustomFieldValueScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPetParentCustomFieldValueScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPetParentCustomFieldValueScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPetParentCustomFieldValueScalarWhereWithAggregatesInput>>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  fieldDefinitionId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  value?: Maybe<JsonWithAggregatesFilter>;
};

export type ClinicPetParentCustomFieldValueUncheckedCreateInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCustomFieldValueCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentCustomFieldValueCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentCustomFieldValueCreateManyClinicPetParentInputEnvelope>;
};

export type ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutFieldDefinitionInput = {
  connect?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCustomFieldValueCreateOrConnectWithoutFieldDefinitionInput>>;
  create?: Maybe<Array<ClinicPetParentCustomFieldValueCreateWithoutFieldDefinitionInput>>;
  createMany?: Maybe<ClinicPetParentCustomFieldValueCreateManyFieldDefinitionInputEnvelope>;
};

export type ClinicPetParentCustomFieldValueUncheckedCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetParentCustomFieldValueUncheckedCreateWithoutFieldDefinitionInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type ClinicPetParentCustomFieldValueUncheckedUpdateInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetParentCustomFieldValueUncheckedUpdateManyInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCustomFieldValueCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentCustomFieldValueCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentCustomFieldValueCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentCustomFieldValueScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentCustomFieldValueUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ClinicPetParentCustomFieldValueUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ClinicPetParentCustomFieldValueUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutFieldDefinitionInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutFieldDefinitionNestedInput = {
  connect?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCustomFieldValueCreateOrConnectWithoutFieldDefinitionInput>>;
  create?: Maybe<Array<ClinicPetParentCustomFieldValueCreateWithoutFieldDefinitionInput>>;
  createMany?: Maybe<ClinicPetParentCustomFieldValueCreateManyFieldDefinitionInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentCustomFieldValueScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentCustomFieldValueUpdateWithWhereUniqueWithoutFieldDefinitionInput>>;
  updateMany?: Maybe<Array<ClinicPetParentCustomFieldValueUpdateManyWithWhereWithoutFieldDefinitionInput>>;
  upsert?: Maybe<Array<ClinicPetParentCustomFieldValueUpsertWithWhereUniqueWithoutFieldDefinitionInput>>;
};

export type ClinicPetParentCustomFieldValueUncheckedUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinitionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetParentCustomFieldValueUncheckedUpdateWithoutFieldDefinitionInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetParentCustomFieldValueUpdateInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutCustomFieldValuesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinition?: Maybe<CustomFieldDefinitionUpdateOneRequiredWithoutClinicPetParentFieldValuesNestedInput>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetParentCustomFieldValueUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetParentCustomFieldValueUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: ClinicPetParentCustomFieldValueUpdateManyMutationInput;
  where: ClinicPetParentCustomFieldValueScalarWhereInput;
};

export type ClinicPetParentCustomFieldValueUpdateManyWithWhereWithoutFieldDefinitionInput = {
  data: ClinicPetParentCustomFieldValueUpdateManyMutationInput;
  where: ClinicPetParentCustomFieldValueScalarWhereInput;
};

export type ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCustomFieldValueCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentCustomFieldValueCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentCustomFieldValueCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentCustomFieldValueScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentCustomFieldValueUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ClinicPetParentCustomFieldValueUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ClinicPetParentCustomFieldValueUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ClinicPetParentCustomFieldValueUpdateManyWithoutFieldDefinitionNestedInput = {
  connect?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCustomFieldValueCreateOrConnectWithoutFieldDefinitionInput>>;
  create?: Maybe<Array<ClinicPetParentCustomFieldValueCreateWithoutFieldDefinitionInput>>;
  createMany?: Maybe<ClinicPetParentCustomFieldValueCreateManyFieldDefinitionInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentCustomFieldValueScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentCustomFieldValueWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentCustomFieldValueUpdateWithWhereUniqueWithoutFieldDefinitionInput>>;
  updateMany?: Maybe<Array<ClinicPetParentCustomFieldValueUpdateManyWithWhereWithoutFieldDefinitionInput>>;
  upsert?: Maybe<Array<ClinicPetParentCustomFieldValueUpsertWithWhereUniqueWithoutFieldDefinitionInput>>;
};

export type ClinicPetParentCustomFieldValueUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: ClinicPetParentCustomFieldValueUpdateWithoutClinicPetParentInput;
  where: ClinicPetParentCustomFieldValueWhereUniqueInput;
};

export type ClinicPetParentCustomFieldValueUpdateWithWhereUniqueWithoutFieldDefinitionInput = {
  data: ClinicPetParentCustomFieldValueUpdateWithoutFieldDefinitionInput;
  where: ClinicPetParentCustomFieldValueWhereUniqueInput;
};

export type ClinicPetParentCustomFieldValueUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldDefinition?: Maybe<CustomFieldDefinitionUpdateOneRequiredWithoutClinicPetParentFieldValuesNestedInput>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetParentCustomFieldValueUpdateWithoutFieldDefinitionInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutCustomFieldValuesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Json']>;
};

export type ClinicPetParentCustomFieldValueUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: ClinicPetParentCustomFieldValueCreateWithoutClinicPetParentInput;
  update: ClinicPetParentCustomFieldValueUpdateWithoutClinicPetParentInput;
  where: ClinicPetParentCustomFieldValueWhereUniqueInput;
};

export type ClinicPetParentCustomFieldValueUpsertWithWhereUniqueWithoutFieldDefinitionInput = {
  create: ClinicPetParentCustomFieldValueCreateWithoutFieldDefinitionInput;
  update: ClinicPetParentCustomFieldValueUpdateWithoutFieldDefinitionInput;
  where: ClinicPetParentCustomFieldValueWhereUniqueInput;
};

export type ClinicPetParentCustomFieldValueWhereInput = {
  AND?: Maybe<Array<ClinicPetParentCustomFieldValueWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentCustomFieldValueWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentCustomFieldValueWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  fieldDefinition?: Maybe<CustomFieldDefinitionScalarRelationFilter>;
  fieldDefinitionId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  value?: Maybe<JsonFilter>;
};

export type ClinicPetParentCustomFieldValueWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPetParentCustomFieldValueWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentCustomFieldValueWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentCustomFieldValueWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  fieldDefinition?: Maybe<CustomFieldDefinitionScalarRelationFilter>;
  fieldDefinitionId?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  value?: Maybe<JsonFilter>;
};

export type ClinicPetParentDevice = {
  __typename?: 'ClinicPetParentDevice';
  _count: ClinicPetParentDeviceCountOutputType;
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deviceName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instanceId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped: Scalars['Boolean'];
  pushNotificationLogs: Array<PushNotificationLog>;
  pushNotificationStatus: PushNotificationStatus;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt: Scalars['DateTime'];
};


export type ClinicPetParentDevicePushNotificationLogsArgs = {
  cursor?: Maybe<PushNotificationLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PushNotificationLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PushNotificationLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PushNotificationLogWhereInput>;
};

export type ClinicPetParentDeviceCountAggregateOutputType = {
  __typename?: 'ClinicPetParentDeviceCountAggregateOutputType';
  _all: Scalars['Int'];
  appVersion: Scalars['Int'];
  brand: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deviceName: Scalars['Int'];
  id: Scalars['Int'];
  instanceId: Scalars['Int'];
  isDeleted: Scalars['Int'];
  lastLogin: Scalars['Int'];
  lastPushAlertTimestamp: Scalars['Int'];
  manufacturer: Scalars['Int'];
  model: Scalars['Int'];
  os: Scalars['Int'];
  osVersion: Scalars['Int'];
  pushModalSkipped: Scalars['Int'];
  pushNotificationStatus: Scalars['Int'];
  snsEndpointArn: Scalars['Int'];
  token: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicPetParentDeviceCountOrderByAggregateInput = {
  appVersion?: Maybe<SortOrder>;
  brand?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deviceName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instanceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastLogin?: Maybe<SortOrder>;
  lastPushAlertTimestamp?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  os?: Maybe<SortOrder>;
  osVersion?: Maybe<SortOrder>;
  pushModalSkipped?: Maybe<SortOrder>;
  pushNotificationStatus?: Maybe<SortOrder>;
  snsEndpointArn?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentDeviceCountOutputType = {
  __typename?: 'ClinicPetParentDeviceCountOutputType';
  pushNotificationLogs: Scalars['Int'];
};

export type ClinicPetParentDeviceCreateInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutDevicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutClinicPetParentDeviceInput>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceCreateManyClinicPetParentInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceCreateManyClinicPetParentInputEnvelope = {
  data: Array<ClinicPetParentDeviceCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetParentDeviceCreateManyInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ClinicPetParentDeviceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentDeviceCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentDeviceCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentDeviceCreateManyClinicPetParentInputEnvelope>;
};

export type ClinicPetParentDeviceCreateNestedOneWithoutPushNotificationLogsInput = {
  connect?: Maybe<ClinicPetParentDeviceWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentDeviceCreateOrConnectWithoutPushNotificationLogsInput>;
  create?: Maybe<ClinicPetParentDeviceCreateWithoutPushNotificationLogsInput>;
};

export type ClinicPetParentDeviceCreateOrConnectWithoutClinicPetParentInput = {
  create: ClinicPetParentDeviceCreateWithoutClinicPetParentInput;
  where: ClinicPetParentDeviceWhereUniqueInput;
};

export type ClinicPetParentDeviceCreateOrConnectWithoutPushNotificationLogsInput = {
  create: ClinicPetParentDeviceCreateWithoutPushNotificationLogsInput;
  where: ClinicPetParentDeviceWhereUniqueInput;
};

export type ClinicPetParentDeviceCreateWithoutClinicPetParentInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutClinicPetParentDeviceInput>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceCreateWithoutPushNotificationLogsInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutDevicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceGroupByOutputType = {
  __typename?: 'ClinicPetParentDeviceGroupByOutputType';
  _count?: Maybe<ClinicPetParentDeviceCountAggregateOutputType>;
  _max?: Maybe<ClinicPetParentDeviceMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetParentDeviceMinAggregateOutputType>;
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deviceName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instanceId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped: Scalars['Boolean'];
  pushNotificationStatus: PushNotificationStatus;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt: Scalars['DateTime'];
};

export type ClinicPetParentDeviceListRelationFilter = {
  every?: Maybe<ClinicPetParentDeviceWhereInput>;
  none?: Maybe<ClinicPetParentDeviceWhereInput>;
  some?: Maybe<ClinicPetParentDeviceWhereInput>;
};

export type ClinicPetParentDeviceMaxAggregateOutputType = {
  __typename?: 'ClinicPetParentDeviceMaxAggregateOutputType';
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceMaxOrderByAggregateInput = {
  appVersion?: Maybe<SortOrder>;
  brand?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deviceName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instanceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastLogin?: Maybe<SortOrder>;
  lastPushAlertTimestamp?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  os?: Maybe<SortOrder>;
  osVersion?: Maybe<SortOrder>;
  pushModalSkipped?: Maybe<SortOrder>;
  pushNotificationStatus?: Maybe<SortOrder>;
  snsEndpointArn?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentDeviceMinAggregateOutputType = {
  __typename?: 'ClinicPetParentDeviceMinAggregateOutputType';
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceMinOrderByAggregateInput = {
  appVersion?: Maybe<SortOrder>;
  brand?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deviceName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instanceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastLogin?: Maybe<SortOrder>;
  lastPushAlertTimestamp?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  os?: Maybe<SortOrder>;
  osVersion?: Maybe<SortOrder>;
  pushModalSkipped?: Maybe<SortOrder>;
  pushNotificationStatus?: Maybe<SortOrder>;
  snsEndpointArn?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentDeviceOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPetParentDeviceOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetParentDeviceOrderByRelevanceInput>;
  appVersion?: Maybe<SortOrder>;
  brand?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deviceName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instanceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastLogin?: Maybe<SortOrder>;
  lastPushAlertTimestamp?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  os?: Maybe<SortOrder>;
  osVersion?: Maybe<SortOrder>;
  pushModalSkipped?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  pushNotificationStatus?: Maybe<SortOrder>;
  snsEndpointArn?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPetParentDeviceOrderByRelevanceFieldEnum {
  AppVersion = 'appVersion',
  Brand = 'brand',
  ClinicPetParentId = 'clinicPetParentId',
  DeviceName = 'deviceName',
  Id = 'id',
  InstanceId = 'instanceId',
  Manufacturer = 'manufacturer',
  Model = 'model',
  OsVersion = 'osVersion',
  SnsEndpointArn = 'snsEndpointArn',
  Token = 'token'
}

export type ClinicPetParentDeviceOrderByRelevanceInput = {
  fields: Array<ClinicPetParentDeviceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPetParentDeviceOrderByWithAggregationInput = {
  _count?: Maybe<ClinicPetParentDeviceCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPetParentDeviceMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPetParentDeviceMinOrderByAggregateInput>;
  appVersion?: Maybe<SortOrder>;
  brand?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deviceName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instanceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastLogin?: Maybe<SortOrder>;
  lastPushAlertTimestamp?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  os?: Maybe<SortOrder>;
  osVersion?: Maybe<SortOrder>;
  pushModalSkipped?: Maybe<SortOrder>;
  pushNotificationStatus?: Maybe<SortOrder>;
  snsEndpointArn?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentDeviceOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetParentDeviceOrderByRelevanceInput>;
  appVersion?: Maybe<SortOrder>;
  brand?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deviceName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instanceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastLogin?: Maybe<SortOrder>;
  lastPushAlertTimestamp?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  os?: Maybe<SortOrder>;
  osVersion?: Maybe<SortOrder>;
  pushModalSkipped?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  pushNotificationStatus?: Maybe<SortOrder>;
  snsEndpointArn?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentDeviceOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicPetParentDeviceOrderByRelevanceInput>;
  appVersion?: Maybe<SortOrder>;
  brand?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deviceName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instanceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastLogin?: Maybe<SortOrder>;
  lastPushAlertTimestamp?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  os?: Maybe<SortOrder>;
  osVersion?: Maybe<SortOrder>;
  pushModalSkipped?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  pushNotificationStatus?: Maybe<SortOrder>;
  snsEndpointArn?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPetParentDeviceScalarFieldEnum {
  AppVersion = 'appVersion',
  Brand = 'brand',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  DeviceName = 'deviceName',
  Id = 'id',
  InstanceId = 'instanceId',
  IsDeleted = 'isDeleted',
  LastLogin = 'lastLogin',
  LastPushAlertTimestamp = 'lastPushAlertTimestamp',
  Manufacturer = 'manufacturer',
  Model = 'model',
  Os = 'os',
  OsVersion = 'osVersion',
  PushModalSkipped = 'pushModalSkipped',
  PushNotificationStatus = 'pushNotificationStatus',
  SnsEndpointArn = 'snsEndpointArn',
  Token = 'token',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type ClinicPetParentDeviceScalarRelationFilter = {
  AND?: Maybe<Array<ClinicPetParentDeviceWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentDeviceWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentDeviceWhereInput>>;
  appVersion?: Maybe<StringNullableFilter>;
  brand?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deviceName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  instanceId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  lastLogin?: Maybe<DateTimeNullableFilter>;
  lastPushAlertTimestamp?: Maybe<DateTimeNullableFilter>;
  manufacturer?: Maybe<StringNullableFilter>;
  model?: Maybe<StringNullableFilter>;
  os?: Maybe<EnumDeviceOsNullableFilter>;
  osVersion?: Maybe<StringNullableFilter>;
  pushModalSkipped?: Maybe<BoolFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  pushNotificationStatus?: Maybe<EnumPushNotificationStatusFilter>;
  snsEndpointArn?: Maybe<StringNullableFilter>;
  token?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumDeviceTypeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPetParentDeviceScalarWhereInput = {
  AND?: Maybe<Array<ClinicPetParentDeviceScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentDeviceScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentDeviceScalarWhereInput>>;
  appVersion?: Maybe<StringNullableFilter>;
  brand?: Maybe<StringNullableFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deviceName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  instanceId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  lastLogin?: Maybe<DateTimeNullableFilter>;
  lastPushAlertTimestamp?: Maybe<DateTimeNullableFilter>;
  manufacturer?: Maybe<StringNullableFilter>;
  model?: Maybe<StringNullableFilter>;
  os?: Maybe<EnumDeviceOsNullableFilter>;
  osVersion?: Maybe<StringNullableFilter>;
  pushModalSkipped?: Maybe<BoolFilter>;
  pushNotificationStatus?: Maybe<EnumPushNotificationStatusFilter>;
  snsEndpointArn?: Maybe<StringNullableFilter>;
  token?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumDeviceTypeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPetParentDeviceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPetParentDeviceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPetParentDeviceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPetParentDeviceScalarWhereWithAggregatesInput>>;
  appVersion?: Maybe<StringNullableWithAggregatesFilter>;
  brand?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deviceName?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  instanceId?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  lastLogin?: Maybe<DateTimeNullableWithAggregatesFilter>;
  lastPushAlertTimestamp?: Maybe<DateTimeNullableWithAggregatesFilter>;
  manufacturer?: Maybe<StringNullableWithAggregatesFilter>;
  model?: Maybe<StringNullableWithAggregatesFilter>;
  os?: Maybe<EnumDeviceOsNullableWithAggregatesFilter>;
  osVersion?: Maybe<StringNullableWithAggregatesFilter>;
  pushModalSkipped?: Maybe<BoolWithAggregatesFilter>;
  pushNotificationStatus?: Maybe<EnumPushNotificationStatusWithAggregatesFilter>;
  snsEndpointArn?: Maybe<StringNullableWithAggregatesFilter>;
  token?: Maybe<StringNullableWithAggregatesFilter>;
  type?: Maybe<EnumDeviceTypeNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicPetParentDeviceUncheckedCreateInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutClinicPetParentDeviceInput>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ClinicPetParentDeviceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentDeviceCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentDeviceCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentDeviceCreateManyClinicPetParentInputEnvelope>;
};

export type ClinicPetParentDeviceUncheckedCreateWithoutClinicPetParentInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutClinicPetParentDeviceInput>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceUncheckedCreateWithoutPushNotificationLogsInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceUncheckedUpdateInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutClinicPetParentDeviceNestedInput>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceUncheckedUpdateManyInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ClinicPetParentDeviceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentDeviceCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentDeviceCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentDeviceCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentDeviceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentDeviceScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentDeviceWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentDeviceWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentDeviceUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ClinicPetParentDeviceUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ClinicPetParentDeviceUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ClinicPetParentDeviceUncheckedUpdateWithoutClinicPetParentInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutClinicPetParentDeviceNestedInput>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceUncheckedUpdateWithoutPushNotificationLogsInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceUniqueInstanceIdPerPetParentCompoundUniqueInput = {
  clinicPetParentId: Scalars['String'];
  instanceId: Scalars['String'];
};

export type ClinicPetParentDeviceUpdateInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutDevicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutClinicPetParentDeviceNestedInput>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceUpdateManyMutationInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: ClinicPetParentDeviceUpdateManyMutationInput;
  where: ClinicPetParentDeviceScalarWhereInput;
};

export type ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ClinicPetParentDeviceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentDeviceCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentDeviceCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentDeviceCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentDeviceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentDeviceScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentDeviceWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentDeviceWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentDeviceUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ClinicPetParentDeviceUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ClinicPetParentDeviceUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ClinicPetParentDeviceUpdateOneRequiredWithoutPushNotificationLogsNestedInput = {
  connect?: Maybe<ClinicPetParentDeviceWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentDeviceCreateOrConnectWithoutPushNotificationLogsInput>;
  create?: Maybe<ClinicPetParentDeviceCreateWithoutPushNotificationLogsInput>;
  update?: Maybe<ClinicPetParentDeviceUpdateToOneWithWhereWithoutPushNotificationLogsInput>;
  upsert?: Maybe<ClinicPetParentDeviceUpsertWithoutPushNotificationLogsInput>;
};

export type ClinicPetParentDeviceUpdateToOneWithWhereWithoutPushNotificationLogsInput = {
  data: ClinicPetParentDeviceUpdateWithoutPushNotificationLogsInput;
  where?: Maybe<ClinicPetParentDeviceWhereInput>;
};

export type ClinicPetParentDeviceUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: ClinicPetParentDeviceUpdateWithoutClinicPetParentInput;
  where: ClinicPetParentDeviceWhereUniqueInput;
};

export type ClinicPetParentDeviceUpdateWithoutClinicPetParentInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutClinicPetParentDeviceNestedInput>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceUpdateWithoutPushNotificationLogsInput = {
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutDevicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped?: Maybe<Scalars['Boolean']>;
  pushNotificationStatus?: Maybe<PushNotificationStatus>;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentDeviceUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: ClinicPetParentDeviceCreateWithoutClinicPetParentInput;
  update: ClinicPetParentDeviceUpdateWithoutClinicPetParentInput;
  where: ClinicPetParentDeviceWhereUniqueInput;
};

export type ClinicPetParentDeviceUpsertWithoutPushNotificationLogsInput = {
  create: ClinicPetParentDeviceCreateWithoutPushNotificationLogsInput;
  update: ClinicPetParentDeviceUpdateWithoutPushNotificationLogsInput;
  where?: Maybe<ClinicPetParentDeviceWhereInput>;
};

export type ClinicPetParentDeviceWhereInput = {
  AND?: Maybe<Array<ClinicPetParentDeviceWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentDeviceWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentDeviceWhereInput>>;
  appVersion?: Maybe<StringNullableFilter>;
  brand?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deviceName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  instanceId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  lastLogin?: Maybe<DateTimeNullableFilter>;
  lastPushAlertTimestamp?: Maybe<DateTimeNullableFilter>;
  manufacturer?: Maybe<StringNullableFilter>;
  model?: Maybe<StringNullableFilter>;
  os?: Maybe<EnumDeviceOsNullableFilter>;
  osVersion?: Maybe<StringNullableFilter>;
  pushModalSkipped?: Maybe<BoolFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  pushNotificationStatus?: Maybe<EnumPushNotificationStatusFilter>;
  snsEndpointArn?: Maybe<StringNullableFilter>;
  token?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumDeviceTypeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPetParentDeviceWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPetParentDeviceWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentDeviceWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentDeviceWhereInput>>;
  appVersion?: Maybe<StringNullableFilter>;
  brand?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deviceName?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  instanceId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  lastLogin?: Maybe<DateTimeNullableFilter>;
  lastPushAlertTimestamp?: Maybe<DateTimeNullableFilter>;
  manufacturer?: Maybe<StringNullableFilter>;
  model?: Maybe<StringNullableFilter>;
  os?: Maybe<EnumDeviceOsNullableFilter>;
  osVersion?: Maybe<StringNullableFilter>;
  pushModalSkipped?: Maybe<BoolFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  pushNotificationStatus?: Maybe<EnumPushNotificationStatusFilter>;
  snsEndpointArn?: Maybe<StringNullableFilter>;
  token?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumDeviceTypeNullableFilter>;
  uniqueInstanceIdPerPetParent?: Maybe<ClinicPetParentDeviceUniqueInstanceIdPerPetParentCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPetParentGroupByOutputType = {
  __typename?: 'ClinicPetParentGroupByOutputType';
  _count?: Maybe<ClinicPetParentCountAggregateOutputType>;
  _max?: Maybe<ClinicPetParentMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetParentMinAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  globalPetParentId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentListRelationFilter = {
  every?: Maybe<ClinicPetParentWhereInput>;
  none?: Maybe<ClinicPetParentWhereInput>;
  some?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentMaxAggregateOutputType = {
  __typename?: 'ClinicPetParentMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  globalPetParentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isTest?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  organizationPetParentId?: Maybe<SortOrder>;
  petParentSettingId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  pimsAccountId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsPhoneNumber?: Maybe<SortOrder>;
  sourcePimsId?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ClinicPetParentMinAggregateOutputType = {
  __typename?: 'ClinicPetParentMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  globalPetParentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isTest?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  organizationPetParentId?: Maybe<SortOrder>;
  petParentSettingId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  pimsAccountId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsPhoneNumber?: Maybe<SortOrder>;
  sourcePimsId?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ClinicPetParentNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicPetParentWhereInput>>;
  EmailCampaignLog?: Maybe<EmailCampaignLogListRelationFilter>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeListRelationFilter>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<ClinicPetParentWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentWhereInput>>;
  addresses?: Maybe<ClinicPetParentAddressListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultListRelationFilter>;
  calls?: Maybe<CallParticipantListRelationFilter>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentListRelationFilter>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestListRelationFilter>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  channelMembers?: Maybe<ChannelMemberListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusListRelationFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<EnumClinicEntityCreationSourceNullableFilter>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueListRelationFilter>;
  devices?: Maybe<ClinicPetParentDeviceListRelationFilter>;
  email?: Maybe<StringNullableFilter>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientListRelationFilter>;
  emailProviderLogs?: Maybe<EmailProviderLogListRelationFilter>;
  firstName?: Maybe<StringFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  globalPetParent?: Maybe<GlobalPetParentNullableScalarRelationFilter>;
  globalPetParentId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantListRelationFilter>;
  informSessions?: Maybe<InformSessionListRelationFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  invoices?: Maybe<InvoiceListRelationFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isPrivacyProtected?: Maybe<BoolNullableFilter>;
  isTest?: Maybe<BoolNullableFilter>;
  isVerified?: Maybe<BoolNullableFilter>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersListRelationFilter>;
  lastName?: Maybe<StringFilter>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderNullableScalarRelationFilter>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryListRelationFilter>;
  organizationPetParent?: Maybe<OrganizationPetParentNullableScalarRelationFilter>;
  organizationPetParentId?: Maybe<StringNullableFilter>;
  petParentSetting?: Maybe<PetParentSettingNullableScalarRelationFilter>;
  petParentSettingId?: Maybe<StringNullableFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberListRelationFilter>;
  pimsAccountId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsPhoneNumber?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  serviceReminders?: Maybe<ServiceReminderListRelationFilter>;
  sourcePimsId?: Maybe<StringNullableFilter>;
  stripeCustomer?: Maybe<StripeCustomerNullableScalarRelationFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  stripePaymentMethods?: Maybe<StripePaymentMethodListRelationFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type ClinicPetParentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPetParentOrderByRelationAndSearchRelevanceInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogOrderByRelationAggregateInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeOrderByRelationAggregateInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicPetParentOrderByRelevanceInput>;
  addresses?: Maybe<ClinicPetParentAddressOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  automationRunActions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultOrderByRelationAggregateInput>;
  calls?: Maybe<CallParticipantOrderByRelationAggregateInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentOrderByRelationAggregateInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestOrderByRelationAggregateInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  channelMembers?: Maybe<ChannelMemberOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusOrderByRelationAggregateInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueOrderByRelationAggregateInput>;
  devices?: Maybe<ClinicPetParentDeviceOrderByRelationAggregateInput>;
  email?: Maybe<SortOrder>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientOrderByRelationAggregateInput>;
  emailProviderLogs?: Maybe<EmailProviderLogOrderByRelationAggregateInput>;
  firstName?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  globalPetParent?: Maybe<GlobalPetParentOrderByWithRelationInput>;
  globalPetParentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantOrderByRelationAggregateInput>;
  informSessions?: Maybe<InformSessionOrderByRelationAggregateInput>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoices?: Maybe<InvoiceOrderByRelationAggregateInput>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isTest?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersOrderByRelationAggregateInput>;
  lastName?: Maybe<SortOrder>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderOrderByWithRelationInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryOrderByRelationAggregateInput>;
  organizationPetParent?: Maybe<OrganizationPetParentOrderByWithRelationInput>;
  organizationPetParentId?: Maybe<SortOrder>;
  petParentSetting?: Maybe<PetParentSettingOrderByWithRelationInput>;
  petParentSettingId?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  phoneNumber?: Maybe<SortOrder>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberOrderByRelationAggregateInput>;
  pimsAccountId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsPhoneNumber?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryOrderByRelationAggregateInput>;
  serviceReminders?: Maybe<ServiceReminderOrderByRelationAggregateInput>;
  sourcePimsId?: Maybe<SortOrder>;
  stripeCustomer?: Maybe<StripeCustomerOrderByWithRelationInput>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodOrderByRelationAggregateInput>;
  surveyResults?: Maybe<SurveyResultOrderByRelationAggregateInput>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ClinicPetParentOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Email = 'email',
  FirstName = 'firstName',
  GlobalPetParentId = 'globalPetParentId',
  Id = 'id',
  IntegrationId = 'integrationId',
  LastName = 'lastName',
  OrganizationPetParentId = 'organizationPetParentId',
  PetParentSettingId = 'petParentSettingId',
  PhoneNumber = 'phoneNumber',
  PimsAccountId = 'pimsAccountId',
  PimsId = 'pimsId',
  PimsPhoneNumber = 'pimsPhoneNumber',
  SourcePimsId = 'sourcePimsId',
  StripeCustomerId = 'stripeCustomerId',
  UserId = 'userId'
}

export type ClinicPetParentOrderByRelevanceInput = {
  fields: Array<ClinicPetParentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPetParentOrderByWithAggregationInput = {
  _count?: Maybe<ClinicPetParentCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPetParentMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPetParentMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  globalPetParentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isTest?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  organizationPetParentId?: Maybe<SortOrder>;
  petParentSettingId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  pimsAccountId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsPhoneNumber?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  sourcePimsId?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ClinicPetParentOrderByWithRelationAndSearchRelevanceInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogOrderByRelationAggregateInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeOrderByRelationAggregateInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicPetParentOrderByRelevanceInput>;
  addresses?: Maybe<ClinicPetParentAddressOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  automationRunActions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultOrderByRelationAggregateInput>;
  calls?: Maybe<CallParticipantOrderByRelationAggregateInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentOrderByRelationAggregateInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestOrderByRelationAggregateInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  channelMembers?: Maybe<ChannelMemberOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusOrderByRelationAggregateInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueOrderByRelationAggregateInput>;
  devices?: Maybe<ClinicPetParentDeviceOrderByRelationAggregateInput>;
  email?: Maybe<SortOrder>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientOrderByRelationAggregateInput>;
  emailProviderLogs?: Maybe<EmailProviderLogOrderByRelationAggregateInput>;
  firstName?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  globalPetParent?: Maybe<GlobalPetParentOrderByWithRelationInput>;
  globalPetParentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantOrderByRelationAggregateInput>;
  informSessions?: Maybe<InformSessionOrderByRelationAggregateInput>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoices?: Maybe<InvoiceOrderByRelationAggregateInput>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isTest?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersOrderByRelationAggregateInput>;
  lastName?: Maybe<SortOrder>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderOrderByWithRelationInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryOrderByRelationAggregateInput>;
  organizationPetParent?: Maybe<OrganizationPetParentOrderByWithRelationInput>;
  organizationPetParentId?: Maybe<SortOrder>;
  petParentSetting?: Maybe<PetParentSettingOrderByWithRelationInput>;
  petParentSettingId?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  phoneNumber?: Maybe<SortOrder>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberOrderByRelationAggregateInput>;
  pimsAccountId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsPhoneNumber?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryOrderByRelationAggregateInput>;
  serviceReminders?: Maybe<ServiceReminderOrderByRelationAggregateInput>;
  sourcePimsId?: Maybe<SortOrder>;
  stripeCustomer?: Maybe<StripeCustomerOrderByWithRelationInput>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodOrderByRelationAggregateInput>;
  surveyResults?: Maybe<SurveyResultOrderByRelationAggregateInput>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type ClinicPetParentOrderByWithRelationInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogOrderByRelationAggregateInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeOrderByRelationAggregateInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicPetParentOrderByRelevanceInput>;
  addresses?: Maybe<ClinicPetParentAddressOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  automationRunActions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultOrderByRelationAggregateInput>;
  calls?: Maybe<CallParticipantOrderByRelationAggregateInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentOrderByRelationAggregateInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestOrderByRelationAggregateInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  channelMembers?: Maybe<ChannelMemberOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusOrderByRelationAggregateInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  creationSource?: Maybe<SortOrder>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueOrderByRelationAggregateInput>;
  devices?: Maybe<ClinicPetParentDeviceOrderByRelationAggregateInput>;
  email?: Maybe<SortOrder>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientOrderByRelationAggregateInput>;
  emailProviderLogs?: Maybe<EmailProviderLogOrderByRelationAggregateInput>;
  firstName?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  globalPetParent?: Maybe<GlobalPetParentOrderByWithRelationInput>;
  globalPetParentId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantOrderByRelationAggregateInput>;
  informSessions?: Maybe<InformSessionOrderByRelationAggregateInput>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoices?: Maybe<InvoiceOrderByRelationAggregateInput>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrivacyProtected?: Maybe<SortOrder>;
  isTest?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersOrderByRelationAggregateInput>;
  lastName?: Maybe<SortOrder>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderOrderByWithRelationInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryOrderByRelationAggregateInput>;
  organizationPetParent?: Maybe<OrganizationPetParentOrderByWithRelationInput>;
  organizationPetParentId?: Maybe<SortOrder>;
  petParentSetting?: Maybe<PetParentSettingOrderByWithRelationInput>;
  petParentSettingId?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  phoneNumber?: Maybe<SortOrder>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberOrderByRelationAggregateInput>;
  pimsAccountId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsPhoneNumber?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryOrderByRelationAggregateInput>;
  serviceReminders?: Maybe<ServiceReminderOrderByRelationAggregateInput>;
  sourcePimsId?: Maybe<SortOrder>;
  stripeCustomer?: Maybe<StripeCustomerOrderByWithRelationInput>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodOrderByRelationAggregateInput>;
  surveyResults?: Maybe<SurveyResultOrderByRelationAggregateInput>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type ClinicPetParentPimsSyncStatus = {
  __typename?: 'ClinicPetParentPimsSyncStatus';
  attempts?: Maybe<Scalars['Int']>;
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status: ProfilePimsSyncStatus;
  updatedAt: Scalars['DateTime'];
};

export type ClinicPetParentPimsSyncStatusAvgAggregateOutputType = {
  __typename?: 'ClinicPetParentPimsSyncStatusAvgAggregateOutputType';
  attempts?: Maybe<Scalars['Float']>;
};

export type ClinicPetParentPimsSyncStatusAvgOrderByAggregateInput = {
  attempts?: Maybe<SortOrder>;
};

export type ClinicPetParentPimsSyncStatusCountAggregateOutputType = {
  __typename?: 'ClinicPetParentPimsSyncStatusCountAggregateOutputType';
  _all: Scalars['Int'];
  attempts: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  details: Scalars['Int'];
  id: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicPetParentPimsSyncStatusCountOrderByAggregateInput = {
  attempts?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentPimsSyncStatusCreateInput = {
  attempts?: Maybe<Scalars['Int']>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutClinicPetParentPimSyncStatusInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status: ProfilePimsSyncStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusCreateManyClinicPetParentInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status: ProfilePimsSyncStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusCreateManyClinicPetParentInputEnvelope = {
  data: Array<ClinicPetParentPimsSyncStatusCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetParentPimsSyncStatusCreateManyInput = {
  attempts?: Maybe<Scalars['Int']>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status: ProfilePimsSyncStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentPimsSyncStatusCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentPimsSyncStatusCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentPimsSyncStatusCreateManyClinicPetParentInputEnvelope>;
};

export type ClinicPetParentPimsSyncStatusCreateOrConnectWithoutClinicPetParentInput = {
  create: ClinicPetParentPimsSyncStatusCreateWithoutClinicPetParentInput;
  where: ClinicPetParentPimsSyncStatusWhereUniqueInput;
};

export type ClinicPetParentPimsSyncStatusCreateWithoutClinicPetParentInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status: ProfilePimsSyncStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusGroupByOutputType = {
  __typename?: 'ClinicPetParentPimsSyncStatusGroupByOutputType';
  _avg?: Maybe<ClinicPetParentPimsSyncStatusAvgAggregateOutputType>;
  _count?: Maybe<ClinicPetParentPimsSyncStatusCountAggregateOutputType>;
  _max?: Maybe<ClinicPetParentPimsSyncStatusMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetParentPimsSyncStatusMinAggregateOutputType>;
  _sum?: Maybe<ClinicPetParentPimsSyncStatusSumAggregateOutputType>;
  attempts?: Maybe<Scalars['Int']>;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status: ProfilePimsSyncStatus;
  updatedAt: Scalars['DateTime'];
};

export type ClinicPetParentPimsSyncStatusListRelationFilter = {
  every?: Maybe<ClinicPetParentPimsSyncStatusWhereInput>;
  none?: Maybe<ClinicPetParentPimsSyncStatusWhereInput>;
  some?: Maybe<ClinicPetParentPimsSyncStatusWhereInput>;
};

export type ClinicPetParentPimsSyncStatusMaxAggregateOutputType = {
  __typename?: 'ClinicPetParentPimsSyncStatusMaxAggregateOutputType';
  attempts?: Maybe<Scalars['Int']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusMaxOrderByAggregateInput = {
  attempts?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentPimsSyncStatusMinAggregateOutputType = {
  __typename?: 'ClinicPetParentPimsSyncStatusMinAggregateOutputType';
  attempts?: Maybe<Scalars['Int']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusMinOrderByAggregateInput = {
  attempts?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentPimsSyncStatusOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPetParentPimsSyncStatusOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetParentPimsSyncStatusOrderByRelevanceInput>;
  attempts?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPetParentPimsSyncStatusOrderByRelevanceFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  Details = 'details',
  Id = 'id'
}

export type ClinicPetParentPimsSyncStatusOrderByRelevanceInput = {
  fields: Array<ClinicPetParentPimsSyncStatusOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPetParentPimsSyncStatusOrderByWithAggregationInput = {
  _avg?: Maybe<ClinicPetParentPimsSyncStatusAvgOrderByAggregateInput>;
  _count?: Maybe<ClinicPetParentPimsSyncStatusCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPetParentPimsSyncStatusMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPetParentPimsSyncStatusMinOrderByAggregateInput>;
  _sum?: Maybe<ClinicPetParentPimsSyncStatusSumOrderByAggregateInput>;
  attempts?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentPimsSyncStatusOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetParentPimsSyncStatusOrderByRelevanceInput>;
  attempts?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetParentPimsSyncStatusOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicPetParentPimsSyncStatusOrderByRelevanceInput>;
  attempts?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPetParentPimsSyncStatusScalarFieldEnum {
  Attempts = 'attempts',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Details = 'details',
  Id = 'id',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type ClinicPetParentPimsSyncStatusScalarWhereInput = {
  AND?: Maybe<Array<ClinicPetParentPimsSyncStatusScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentPimsSyncStatusScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentPimsSyncStatusScalarWhereInput>>;
  attempts?: Maybe<IntNullableFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  details?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumProfilePimsSyncStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPetParentPimsSyncStatusScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPetParentPimsSyncStatusScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPetParentPimsSyncStatusScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPetParentPimsSyncStatusScalarWhereWithAggregatesInput>>;
  attempts?: Maybe<IntNullableWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  details?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumProfilePimsSyncStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicPetParentPimsSyncStatusSumAggregateOutputType = {
  __typename?: 'ClinicPetParentPimsSyncStatusSumAggregateOutputType';
  attempts?: Maybe<Scalars['Int']>;
};

export type ClinicPetParentPimsSyncStatusSumOrderByAggregateInput = {
  attempts?: Maybe<SortOrder>;
};

export type ClinicPetParentPimsSyncStatusUncheckedCreateInput = {
  attempts?: Maybe<Scalars['Int']>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status: ProfilePimsSyncStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentPimsSyncStatusCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentPimsSyncStatusCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentPimsSyncStatusCreateManyClinicPetParentInputEnvelope>;
};

export type ClinicPetParentPimsSyncStatusUncheckedCreateWithoutClinicPetParentInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status: ProfilePimsSyncStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusUncheckedUpdateInput = {
  attempts?: Maybe<Scalars['Int']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusUncheckedUpdateManyInput = {
  attempts?: Maybe<Scalars['Int']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentPimsSyncStatusCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentPimsSyncStatusCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentPimsSyncStatusCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentPimsSyncStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentPimsSyncStatusUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ClinicPetParentPimsSyncStatusUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ClinicPetParentPimsSyncStatusUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ClinicPetParentPimsSyncStatusUncheckedUpdateWithoutClinicPetParentInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusUpdateInput = {
  attempts?: Maybe<Scalars['Int']>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutClinicPetParentPimSyncStatusNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusUpdateManyMutationInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: ClinicPetParentPimsSyncStatusUpdateManyMutationInput;
  where: ClinicPetParentPimsSyncStatusScalarWhereInput;
};

export type ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentPimsSyncStatusCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentPimsSyncStatusCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicPetParentPimsSyncStatusCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentPimsSyncStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentPimsSyncStatusUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ClinicPetParentPimsSyncStatusUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ClinicPetParentPimsSyncStatusUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ClinicPetParentPimsSyncStatusUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: ClinicPetParentPimsSyncStatusUpdateWithoutClinicPetParentInput;
  where: ClinicPetParentPimsSyncStatusWhereUniqueInput;
};

export type ClinicPetParentPimsSyncStatusUpdateWithoutClinicPetParentInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentPimsSyncStatusUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: ClinicPetParentPimsSyncStatusCreateWithoutClinicPetParentInput;
  update: ClinicPetParentPimsSyncStatusUpdateWithoutClinicPetParentInput;
  where: ClinicPetParentPimsSyncStatusWhereUniqueInput;
};

export type ClinicPetParentPimsSyncStatusWhereInput = {
  AND?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereInput>>;
  attempts?: Maybe<IntNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  details?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumProfilePimsSyncStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPetParentPimsSyncStatusWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentPimsSyncStatusWhereInput>>;
  attempts?: Maybe<IntNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  details?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<EnumProfilePimsSyncStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum ClinicPetParentScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  CreationSource = 'creationSource',
  Email = 'email',
  FirstName = 'firstName',
  GlobalPetParentId = 'globalPetParentId',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  IsPrivacyProtected = 'isPrivacyProtected',
  IsTest = 'isTest',
  IsVerified = 'isVerified',
  LastName = 'lastName',
  OrganizationPetParentId = 'organizationPetParentId',
  PetParentSettingId = 'petParentSettingId',
  PhoneNumber = 'phoneNumber',
  PimsAccountId = 'pimsAccountId',
  PimsId = 'pimsId',
  PimsPhoneNumber = 'pimsPhoneNumber',
  RawPimsValue = 'rawPimsValue',
  SourcePimsId = 'sourcePimsId',
  StripeCustomerId = 'stripeCustomerId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ClinicPetParentScalarRelationFilter = {
  AND?: Maybe<Array<ClinicPetParentWhereInput>>;
  EmailCampaignLog?: Maybe<EmailCampaignLogListRelationFilter>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeListRelationFilter>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<ClinicPetParentWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentWhereInput>>;
  addresses?: Maybe<ClinicPetParentAddressListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultListRelationFilter>;
  calls?: Maybe<CallParticipantListRelationFilter>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentListRelationFilter>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestListRelationFilter>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  channelMembers?: Maybe<ChannelMemberListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusListRelationFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<EnumClinicEntityCreationSourceNullableFilter>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueListRelationFilter>;
  devices?: Maybe<ClinicPetParentDeviceListRelationFilter>;
  email?: Maybe<StringNullableFilter>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientListRelationFilter>;
  emailProviderLogs?: Maybe<EmailProviderLogListRelationFilter>;
  firstName?: Maybe<StringFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  globalPetParent?: Maybe<GlobalPetParentNullableScalarRelationFilter>;
  globalPetParentId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantListRelationFilter>;
  informSessions?: Maybe<InformSessionListRelationFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  invoices?: Maybe<InvoiceListRelationFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isPrivacyProtected?: Maybe<BoolNullableFilter>;
  isTest?: Maybe<BoolNullableFilter>;
  isVerified?: Maybe<BoolNullableFilter>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersListRelationFilter>;
  lastName?: Maybe<StringFilter>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderNullableScalarRelationFilter>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryListRelationFilter>;
  organizationPetParent?: Maybe<OrganizationPetParentNullableScalarRelationFilter>;
  organizationPetParentId?: Maybe<StringNullableFilter>;
  petParentSetting?: Maybe<PetParentSettingNullableScalarRelationFilter>;
  petParentSettingId?: Maybe<StringNullableFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberListRelationFilter>;
  pimsAccountId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsPhoneNumber?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  serviceReminders?: Maybe<ServiceReminderListRelationFilter>;
  sourcePimsId?: Maybe<StringNullableFilter>;
  stripeCustomer?: Maybe<StripeCustomerNullableScalarRelationFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  stripePaymentMethods?: Maybe<StripePaymentMethodListRelationFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type ClinicPetParentScalarWhereInput = {
  AND?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<EnumClinicEntityCreationSourceNullableFilter>;
  email?: Maybe<StringNullableFilter>;
  firstName?: Maybe<StringFilter>;
  globalPetParentId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isPrivacyProtected?: Maybe<BoolNullableFilter>;
  isTest?: Maybe<BoolNullableFilter>;
  isVerified?: Maybe<BoolNullableFilter>;
  lastName?: Maybe<StringFilter>;
  organizationPetParentId?: Maybe<StringNullableFilter>;
  petParentSettingId?: Maybe<StringNullableFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  pimsAccountId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsPhoneNumber?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  sourcePimsId?: Maybe<StringNullableFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type ClinicPetParentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPetParentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPetParentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPetParentScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  creationSource?: Maybe<EnumClinicEntityCreationSourceNullableWithAggregatesFilter>;
  email?: Maybe<StringNullableWithAggregatesFilter>;
  firstName?: Maybe<StringWithAggregatesFilter>;
  globalPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  isActive?: Maybe<BoolNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolNullableWithAggregatesFilter>;
  isPrivacyProtected?: Maybe<BoolNullableWithAggregatesFilter>;
  isTest?: Maybe<BoolNullableWithAggregatesFilter>;
  isVerified?: Maybe<BoolNullableWithAggregatesFilter>;
  lastName?: Maybe<StringWithAggregatesFilter>;
  organizationPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  petParentSettingId?: Maybe<StringNullableWithAggregatesFilter>;
  phoneNumber?: Maybe<StringNullableWithAggregatesFilter>;
  pimsAccountId?: Maybe<StringNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  pimsPhoneNumber?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  sourcePimsId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeCustomerId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type ClinicPetParentUncheckedCreateInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateNestedManyWithoutAppointmentsInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutAppointmentsInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutAppointmentsInput>>;
};

export type ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyClinicInputEnvelope>;
};

export type ClinicPetParentUncheckedCreateNestedManyWithoutGlobalPetParentInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutGlobalPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutGlobalPetParentInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyGlobalPetParentInputEnvelope>;
};

export type ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyIntegrationInputEnvelope>;
};

export type ClinicPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutOrganizationPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutOrganizationPetParentInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyOrganizationPetParentInputEnvelope>;
};

export type ClinicPetParentUncheckedCreateNestedManyWithoutPetParentSettingInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutPetParentSettingInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutPetParentSettingInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyPetParentSettingInputEnvelope>;
};

export type ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutPetsInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutPetsInput>>;
};

export type ClinicPetParentUncheckedCreateNestedManyWithoutStripeCustomerInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyStripeCustomerInputEnvelope>;
};

export type ClinicPetParentUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutUserInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyUserInputEnvelope>;
};

export type ClinicPetParentUncheckedCreateWithoutAddressesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutAppointmentsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutAutomationRunActionsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutAutomationRunsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutBitwerxPaymentHealthcheckResultsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutCallsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutCareAccountCreditIntentsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutCareAuthorizationRequestsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutCareCreditPreapprovalChecksInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutChannelCreationSourcesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutChannelMembersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutClinicInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutClinicPetParentPimSyncStatusInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutClinicWidgetRequestsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicPetParentsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSetting?: Maybe<PetParentSettingCreateNestedOneWithoutPetParentInput>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutCustomFieldValuesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutDevicesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutEmailCampaignCustomListRecipientsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutEmailCampaignLogInput = {
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutEmailCampaignUnsubscribeInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutEmailProviderLogsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutFormSubmissionsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutGlobalPetParentInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutHillsToHomeApiLogInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutInformAudienceMemberInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutInformControlGroupParticipantsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutInformSessionsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutIntegrationInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutInvoicesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutLapsedPetParentTriggersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutLoyaltyAccountHolderInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutMassTextAlertEntriesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutOrganizationPetParentInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutPetParentSettingInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutPetsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutPhoneNumbersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutReceivedTrupanionExamDayOffersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutServicePurchaseSummariesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutServiceRemindersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutStripeCustomerInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutStripePaymentIntentsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutStripePaymentMethodsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutSurveyResultsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutTasksInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedCreateWithoutUserInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetParentsInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetParentInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  lastName: Scalars['String'];
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentUncheckedUpdateInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutAppointmentsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutAppointmentsNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutAppointmentsInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutAppointmentsInput>>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutAppointmentsInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutAppointmentsInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutAppointmentsInput>>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutGlobalPetParentInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutGlobalPetParentNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutGlobalPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutGlobalPetParentInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyGlobalPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutGlobalPetParentInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutGlobalPetParentInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutGlobalPetParentInput>>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutIntegrationInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutOrganizationPetParentInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutOrganizationPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutOrganizationPetParentInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyOrganizationPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutOrganizationPetParentInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutOrganizationPetParentInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutOrganizationPetParentInput>>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutPetParentSettingInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutPetParentSettingNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutPetParentSettingInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutPetParentSettingInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyPetParentSettingInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutPetParentSettingInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutPetParentSettingInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutPetParentSettingInput>>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutPetsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutPetsInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutPetsInput>>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutPetsInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutPetsInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutPetsInput>>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutStripeCustomerInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutStripeCustomerNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyStripeCustomerInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutStripeCustomerInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutStripeCustomerInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutStripeCustomerInput>>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutUserInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ClinicPetParentUncheckedUpdateWithoutAddressesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutAppointmentsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutAutomationRunActionsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutAutomationRunsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutBitwerxPaymentHealthcheckResultsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutCallsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutCareAccountCreditIntentsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutCareAuthorizationRequestsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutCareCreditPreapprovalChecksInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutChannelCreationSourcesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutChannelMembersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutClinicInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutClinicPetParentPimSyncStatusInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutClinicWidgetRequestsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutCustomFieldValuesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutDevicesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutEmailCampaignCustomListRecipientsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutEmailCampaignLogInput = {
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutEmailCampaignUnsubscribeInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutEmailProviderLogsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutFormSubmissionsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutGlobalPetParentInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutHillsToHomeApiLogInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutInformAudienceMemberInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutInformControlGroupParticipantsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutInformSessionsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutIntegrationInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutInvoicesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutLapsedPetParentTriggersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutLoyaltyAccountHolderInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutMassTextAlertEntriesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutOrganizationPetParentInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutPetParentSettingInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutPetsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutPhoneNumbersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutReceivedTrupanionExamDayOffersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutServicePurchaseSummariesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutServiceRemindersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutStripeCustomerInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutStripePaymentIntentsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutStripePaymentMethodsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutSurveyResultsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutTasksInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicPetParentUncheckedUpdateWithoutUserInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  integrationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentUpdateInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentUpdateManyWithWhereWithoutAppointmentsInput = {
  data: ClinicPetParentUpdateManyMutationInput;
  where: ClinicPetParentScalarWhereInput;
};

export type ClinicPetParentUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicPetParentUpdateManyMutationInput;
  where: ClinicPetParentScalarWhereInput;
};

export type ClinicPetParentUpdateManyWithWhereWithoutGlobalPetParentInput = {
  data: ClinicPetParentUpdateManyMutationInput;
  where: ClinicPetParentScalarWhereInput;
};

export type ClinicPetParentUpdateManyWithWhereWithoutIntegrationInput = {
  data: ClinicPetParentUpdateManyMutationInput;
  where: ClinicPetParentScalarWhereInput;
};

export type ClinicPetParentUpdateManyWithWhereWithoutOrganizationPetParentInput = {
  data: ClinicPetParentUpdateManyMutationInput;
  where: ClinicPetParentScalarWhereInput;
};

export type ClinicPetParentUpdateManyWithWhereWithoutPetParentSettingInput = {
  data: ClinicPetParentUpdateManyMutationInput;
  where: ClinicPetParentScalarWhereInput;
};

export type ClinicPetParentUpdateManyWithWhereWithoutPetsInput = {
  data: ClinicPetParentUpdateManyMutationInput;
  where: ClinicPetParentScalarWhereInput;
};

export type ClinicPetParentUpdateManyWithWhereWithoutStripeCustomerInput = {
  data: ClinicPetParentUpdateManyMutationInput;
  where: ClinicPetParentScalarWhereInput;
};

export type ClinicPetParentUpdateManyWithWhereWithoutUserInput = {
  data: ClinicPetParentUpdateManyMutationInput;
  where: ClinicPetParentScalarWhereInput;
};

export type ClinicPetParentUpdateManyWithoutAppointmentsNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutAppointmentsInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutAppointmentsInput>>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutAppointmentsInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutAppointmentsInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutAppointmentsInput>>;
};

export type ClinicPetParentUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicPetParentUpdateManyWithoutGlobalPetParentNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutGlobalPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutGlobalPetParentInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyGlobalPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutGlobalPetParentInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutGlobalPetParentInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutGlobalPetParentInput>>;
};

export type ClinicPetParentUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ClinicPetParentUpdateManyWithoutOrganizationPetParentNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutOrganizationPetParentInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutOrganizationPetParentInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyOrganizationPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutOrganizationPetParentInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutOrganizationPetParentInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutOrganizationPetParentInput>>;
};

export type ClinicPetParentUpdateManyWithoutPetParentSettingNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutPetParentSettingInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutPetParentSettingInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyPetParentSettingInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutPetParentSettingInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutPetParentSettingInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutPetParentSettingInput>>;
};

export type ClinicPetParentUpdateManyWithoutPetsNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutPetsInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutPetsInput>>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutPetsInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutPetsInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutPetsInput>>;
};

export type ClinicPetParentUpdateManyWithoutStripeCustomerNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyStripeCustomerInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutStripeCustomerInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutStripeCustomerInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutStripeCustomerInput>>;
};

export type ClinicPetParentUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetParentCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ClinicPetParentCreateWithoutUserInput>>;
  createMany?: Maybe<ClinicPetParentCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetParentWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetParentUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ClinicPetParentUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ClinicPetParentUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ClinicPetParentUpdateOneRequiredWithoutAddressesNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutAddressesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutAddressesInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutAddressesInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutAddressesInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutAutomationRunsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutAutomationRunsInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutAutomationRunsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutAutomationRunsInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutBitwerxPaymentHealthcheckResultsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutBitwerxPaymentHealthcheckResultsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutBitwerxPaymentHealthcheckResultsInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutBitwerxPaymentHealthcheckResultsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutBitwerxPaymentHealthcheckResultsInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutCareAccountCreditIntentsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutCareAccountCreditIntentsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutCareAccountCreditIntentsInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutCareAccountCreditIntentsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutCareAccountCreditIntentsInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutCareAuthorizationRequestsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutCareAuthorizationRequestsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutCareAuthorizationRequestsInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutCareAuthorizationRequestsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutCareAuthorizationRequestsInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutCareCreditPreapprovalChecksNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutCareCreditPreapprovalChecksInput>;
  create?: Maybe<ClinicPetParentCreateWithoutCareCreditPreapprovalChecksInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutCareCreditPreapprovalChecksInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutCareCreditPreapprovalChecksInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutClinicPetParentPimSyncStatusNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutClinicPetParentPimSyncStatusInput>;
  create?: Maybe<ClinicPetParentCreateWithoutClinicPetParentPimSyncStatusInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutClinicPetParentPimSyncStatusInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutClinicPetParentPimSyncStatusInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutCustomFieldValuesNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutCustomFieldValuesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutCustomFieldValuesInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutCustomFieldValuesInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutCustomFieldValuesInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutDevicesNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutDevicesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutDevicesInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutDevicesInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutDevicesInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutEmailCampaignLogNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutEmailCampaignLogInput>;
  create?: Maybe<ClinicPetParentCreateWithoutEmailCampaignLogInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutEmailCampaignLogInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutEmailCampaignLogInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutEmailProviderLogsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutEmailProviderLogsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutEmailProviderLogsInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutEmailProviderLogsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutEmailProviderLogsInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutInformAudienceMemberNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutInformAudienceMemberInput>;
  create?: Maybe<ClinicPetParentCreateWithoutInformAudienceMemberInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutInformAudienceMemberInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutInformAudienceMemberInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutInformControlGroupParticipantsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutInformControlGroupParticipantsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutInformControlGroupParticipantsInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutInformControlGroupParticipantsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutInformControlGroupParticipantsInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutInvoicesNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutInvoicesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutInvoicesInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutInvoicesInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutInvoicesInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutLapsedPetParentTriggersNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutLapsedPetParentTriggersInput>;
  create?: Maybe<ClinicPetParentCreateWithoutLapsedPetParentTriggersInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutLapsedPetParentTriggersInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutLapsedPetParentTriggersInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutLoyaltyAccountHolderNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutLoyaltyAccountHolderInput>;
  create?: Maybe<ClinicPetParentCreateWithoutLoyaltyAccountHolderInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutLoyaltyAccountHolderInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutLoyaltyAccountHolderInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutMassTextAlertEntriesNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutMassTextAlertEntriesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutMassTextAlertEntriesInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutMassTextAlertEntriesInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutMassTextAlertEntriesInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutReceivedTrupanionExamDayOffersInput>;
  create?: Maybe<ClinicPetParentCreateWithoutReceivedTrupanionExamDayOffersInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutReceivedTrupanionExamDayOffersInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutReceivedTrupanionExamDayOffersInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutServicePurchaseSummariesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutServicePurchaseSummariesInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutServicePurchaseSummariesInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutServicePurchaseSummariesInput>;
};

export type ClinicPetParentUpdateOneRequiredWithoutSurveyResultsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutSurveyResultsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutSurveyResultsInput>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutSurveyResultsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutSurveyResultsInput>;
};

export type ClinicPetParentUpdateOneWithoutAutomationRunActionsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutAutomationRunActionsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutAutomationRunActionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutAutomationRunActionsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutAutomationRunActionsInput>;
};

export type ClinicPetParentUpdateOneWithoutCallsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutCallsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutCallsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutCallsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutCallsInput>;
};

export type ClinicPetParentUpdateOneWithoutChannelCreationSourcesNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutChannelCreationSourcesInput>;
  create?: Maybe<ClinicPetParentCreateWithoutChannelCreationSourcesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutChannelCreationSourcesInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutChannelCreationSourcesInput>;
};

export type ClinicPetParentUpdateOneWithoutChannelMembersNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutChannelMembersInput>;
  create?: Maybe<ClinicPetParentCreateWithoutChannelMembersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutChannelMembersInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutChannelMembersInput>;
};

export type ClinicPetParentUpdateOneWithoutClinicWidgetRequestsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutClinicWidgetRequestsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutClinicWidgetRequestsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutClinicWidgetRequestsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutClinicWidgetRequestsInput>;
};

export type ClinicPetParentUpdateOneWithoutEmailCampaignCustomListRecipientsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutEmailCampaignCustomListRecipientsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutEmailCampaignCustomListRecipientsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutEmailCampaignCustomListRecipientsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutEmailCampaignCustomListRecipientsInput>;
};

export type ClinicPetParentUpdateOneWithoutEmailCampaignUnsubscribeNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutEmailCampaignUnsubscribeInput>;
  create?: Maybe<ClinicPetParentCreateWithoutEmailCampaignUnsubscribeInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutEmailCampaignUnsubscribeInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutEmailCampaignUnsubscribeInput>;
};

export type ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutFormSubmissionsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutFormSubmissionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutFormSubmissionsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutFormSubmissionsInput>;
};

export type ClinicPetParentUpdateOneWithoutHillsToHomeApiLogNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutHillsToHomeApiLogInput>;
  create?: Maybe<ClinicPetParentCreateWithoutHillsToHomeApiLogInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutHillsToHomeApiLogInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutHillsToHomeApiLogInput>;
};

export type ClinicPetParentUpdateOneWithoutInformSessionsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutInformSessionsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutInformSessionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutInformSessionsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutInformSessionsInput>;
};

export type ClinicPetParentUpdateOneWithoutPhoneNumbersNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutPhoneNumbersInput>;
  create?: Maybe<ClinicPetParentCreateWithoutPhoneNumbersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutPhoneNumbersInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutPhoneNumbersInput>;
};

export type ClinicPetParentUpdateOneWithoutServiceRemindersNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutServiceRemindersInput>;
  create?: Maybe<ClinicPetParentCreateWithoutServiceRemindersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutServiceRemindersInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutServiceRemindersInput>;
};

export type ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutStripePaymentIntentsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutStripePaymentIntentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutStripePaymentIntentsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutStripePaymentIntentsInput>;
};

export type ClinicPetParentUpdateOneWithoutStripePaymentMethodsNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutStripePaymentMethodsInput>;
  create?: Maybe<ClinicPetParentCreateWithoutStripePaymentMethodsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutStripePaymentMethodsInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutStripePaymentMethodsInput>;
};

export type ClinicPetParentUpdateOneWithoutTasksNestedInput = {
  connect?: Maybe<ClinicPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetParentCreateOrConnectWithoutTasksInput>;
  create?: Maybe<ClinicPetParentCreateWithoutTasksInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetParentUpdateToOneWithWhereWithoutTasksInput>;
  upsert?: Maybe<ClinicPetParentUpsertWithoutTasksInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutAddressesInput = {
  data: ClinicPetParentUpdateWithoutAddressesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutAutomationRunActionsInput = {
  data: ClinicPetParentUpdateWithoutAutomationRunActionsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutAutomationRunsInput = {
  data: ClinicPetParentUpdateWithoutAutomationRunsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutBitwerxPaymentHealthcheckResultsInput = {
  data: ClinicPetParentUpdateWithoutBitwerxPaymentHealthcheckResultsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutCallsInput = {
  data: ClinicPetParentUpdateWithoutCallsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutCareAccountCreditIntentsInput = {
  data: ClinicPetParentUpdateWithoutCareAccountCreditIntentsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutCareAuthorizationRequestsInput = {
  data: ClinicPetParentUpdateWithoutCareAuthorizationRequestsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutCareCreditPreapprovalChecksInput = {
  data: ClinicPetParentUpdateWithoutCareCreditPreapprovalChecksInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutChannelCreationSourcesInput = {
  data: ClinicPetParentUpdateWithoutChannelCreationSourcesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutChannelMembersInput = {
  data: ClinicPetParentUpdateWithoutChannelMembersInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutClinicPetParentPimSyncStatusInput = {
  data: ClinicPetParentUpdateWithoutClinicPetParentPimSyncStatusInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutClinicWidgetRequestsInput = {
  data: ClinicPetParentUpdateWithoutClinicWidgetRequestsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutCustomFieldValuesInput = {
  data: ClinicPetParentUpdateWithoutCustomFieldValuesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutDevicesInput = {
  data: ClinicPetParentUpdateWithoutDevicesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutEmailCampaignCustomListRecipientsInput = {
  data: ClinicPetParentUpdateWithoutEmailCampaignCustomListRecipientsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutEmailCampaignLogInput = {
  data: ClinicPetParentUpdateWithoutEmailCampaignLogInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutEmailCampaignUnsubscribeInput = {
  data: ClinicPetParentUpdateWithoutEmailCampaignUnsubscribeInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutEmailProviderLogsInput = {
  data: ClinicPetParentUpdateWithoutEmailProviderLogsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutFormSubmissionsInput = {
  data: ClinicPetParentUpdateWithoutFormSubmissionsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutHillsToHomeApiLogInput = {
  data: ClinicPetParentUpdateWithoutHillsToHomeApiLogInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutInformAudienceMemberInput = {
  data: ClinicPetParentUpdateWithoutInformAudienceMemberInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutInformControlGroupParticipantsInput = {
  data: ClinicPetParentUpdateWithoutInformControlGroupParticipantsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutInformSessionsInput = {
  data: ClinicPetParentUpdateWithoutInformSessionsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutInvoicesInput = {
  data: ClinicPetParentUpdateWithoutInvoicesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutLapsedPetParentTriggersInput = {
  data: ClinicPetParentUpdateWithoutLapsedPetParentTriggersInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutLoyaltyAccountHolderInput = {
  data: ClinicPetParentUpdateWithoutLoyaltyAccountHolderInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutMassTextAlertEntriesInput = {
  data: ClinicPetParentUpdateWithoutMassTextAlertEntriesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutPhoneNumbersInput = {
  data: ClinicPetParentUpdateWithoutPhoneNumbersInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutReceivedTrupanionExamDayOffersInput = {
  data: ClinicPetParentUpdateWithoutReceivedTrupanionExamDayOffersInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutServicePurchaseSummariesInput = {
  data: ClinicPetParentUpdateWithoutServicePurchaseSummariesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutServiceRemindersInput = {
  data: ClinicPetParentUpdateWithoutServiceRemindersInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutStripePaymentIntentsInput = {
  data: ClinicPetParentUpdateWithoutStripePaymentIntentsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutStripePaymentMethodsInput = {
  data: ClinicPetParentUpdateWithoutStripePaymentMethodsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutSurveyResultsInput = {
  data: ClinicPetParentUpdateWithoutSurveyResultsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateToOneWithWhereWithoutTasksInput = {
  data: ClinicPetParentUpdateWithoutTasksInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpdateWithWhereUniqueWithoutAppointmentsInput = {
  data: ClinicPetParentUpdateWithoutAppointmentsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicPetParentUpdateWithoutClinicInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpdateWithWhereUniqueWithoutGlobalPetParentInput = {
  data: ClinicPetParentUpdateWithoutGlobalPetParentInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: ClinicPetParentUpdateWithoutIntegrationInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpdateWithWhereUniqueWithoutOrganizationPetParentInput = {
  data: ClinicPetParentUpdateWithoutOrganizationPetParentInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpdateWithWhereUniqueWithoutPetParentSettingInput = {
  data: ClinicPetParentUpdateWithoutPetParentSettingInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpdateWithWhereUniqueWithoutPetsInput = {
  data: ClinicPetParentUpdateWithoutPetsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpdateWithWhereUniqueWithoutStripeCustomerInput = {
  data: ClinicPetParentUpdateWithoutStripeCustomerInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpdateWithWhereUniqueWithoutUserInput = {
  data: ClinicPetParentUpdateWithoutUserInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpdateWithoutAddressesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutAppointmentsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutAutomationRunActionsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutAutomationRunsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutBitwerxPaymentHealthcheckResultsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutCallsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutCareAccountCreditIntentsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutCareAuthorizationRequestsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutCareCreditPreapprovalChecksInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutChannelCreationSourcesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutChannelMembersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutClinicInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutClinicPetParentPimSyncStatusInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutClinicWidgetRequestsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutCustomFieldValuesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutDevicesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutEmailCampaignCustomListRecipientsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutEmailCampaignLogInput = {
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutEmailCampaignUnsubscribeInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutEmailProviderLogsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutFormSubmissionsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutGlobalPetParentInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutHillsToHomeApiLogInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutInformAudienceMemberInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutInformControlGroupParticipantsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutInformSessionsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutIntegrationInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutInvoicesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutLapsedPetParentTriggersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutLoyaltyAccountHolderInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutMassTextAlertEntriesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutOrganizationPetParentInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutPetParentSettingInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutPetsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutPhoneNumbersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutReceivedTrupanionExamDayOffersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutServicePurchaseSummariesInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutServiceRemindersInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutStripeCustomerInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutStripePaymentIntentsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutStripePaymentMethodsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutSurveyResultsInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutTasksInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutClinicPetParentsNestedInput>;
};

export type ClinicPetParentUpdateWithoutUserInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput>;
  addresses?: Maybe<ClinicPetParentAddressUpdateManyWithoutClinicPetParentNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetParentsNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetParentNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicPetParentNestedInput>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultUpdateManyWithoutClinicPetParentNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutClinicPetParentNestedInput>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestUpdateManyWithoutClinicPetParentNestedInput>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckUpdateManyWithoutClinicPetParentNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicPetParentNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutClinicPetParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetParentsNestedInput>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusUpdateManyWithoutClinicPetParentNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutClinicPetParentNestedInput>;
  devices?: Maybe<ClinicPetParentDeviceUpdateManyWithoutClinicPetParentNestedInput>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput>;
  emailProviderLogs?: Maybe<EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetParentNestedInput>;
  globalPetParent?: Maybe<GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutClinicPetParentNestedInput>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutClinicPetParentNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput>;
  petParentSetting?: Maybe<PetParentSettingUpdateOneWithoutPetParentNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutPetParentsNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutClinicPetParentNestedInput>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetParentNestedInput>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput>;
  stripePaymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicPetParentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetParentUpsertWithWhereUniqueWithoutAppointmentsInput = {
  create: ClinicPetParentCreateWithoutAppointmentsInput;
  update: ClinicPetParentUpdateWithoutAppointmentsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicPetParentCreateWithoutClinicInput;
  update: ClinicPetParentUpdateWithoutClinicInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpsertWithWhereUniqueWithoutGlobalPetParentInput = {
  create: ClinicPetParentCreateWithoutGlobalPetParentInput;
  update: ClinicPetParentUpdateWithoutGlobalPetParentInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: ClinicPetParentCreateWithoutIntegrationInput;
  update: ClinicPetParentUpdateWithoutIntegrationInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpsertWithWhereUniqueWithoutOrganizationPetParentInput = {
  create: ClinicPetParentCreateWithoutOrganizationPetParentInput;
  update: ClinicPetParentUpdateWithoutOrganizationPetParentInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpsertWithWhereUniqueWithoutPetParentSettingInput = {
  create: ClinicPetParentCreateWithoutPetParentSettingInput;
  update: ClinicPetParentUpdateWithoutPetParentSettingInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpsertWithWhereUniqueWithoutPetsInput = {
  create: ClinicPetParentCreateWithoutPetsInput;
  update: ClinicPetParentUpdateWithoutPetsInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpsertWithWhereUniqueWithoutStripeCustomerInput = {
  create: ClinicPetParentCreateWithoutStripeCustomerInput;
  update: ClinicPetParentUpdateWithoutStripeCustomerInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpsertWithWhereUniqueWithoutUserInput = {
  create: ClinicPetParentCreateWithoutUserInput;
  update: ClinicPetParentUpdateWithoutUserInput;
  where: ClinicPetParentWhereUniqueInput;
};

export type ClinicPetParentUpsertWithoutAddressesInput = {
  create: ClinicPetParentCreateWithoutAddressesInput;
  update: ClinicPetParentUpdateWithoutAddressesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutAutomationRunActionsInput = {
  create: ClinicPetParentCreateWithoutAutomationRunActionsInput;
  update: ClinicPetParentUpdateWithoutAutomationRunActionsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutAutomationRunsInput = {
  create: ClinicPetParentCreateWithoutAutomationRunsInput;
  update: ClinicPetParentUpdateWithoutAutomationRunsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutBitwerxPaymentHealthcheckResultsInput = {
  create: ClinicPetParentCreateWithoutBitwerxPaymentHealthcheckResultsInput;
  update: ClinicPetParentUpdateWithoutBitwerxPaymentHealthcheckResultsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutCallsInput = {
  create: ClinicPetParentCreateWithoutCallsInput;
  update: ClinicPetParentUpdateWithoutCallsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutCareAccountCreditIntentsInput = {
  create: ClinicPetParentCreateWithoutCareAccountCreditIntentsInput;
  update: ClinicPetParentUpdateWithoutCareAccountCreditIntentsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutCareAuthorizationRequestsInput = {
  create: ClinicPetParentCreateWithoutCareAuthorizationRequestsInput;
  update: ClinicPetParentUpdateWithoutCareAuthorizationRequestsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutCareCreditPreapprovalChecksInput = {
  create: ClinicPetParentCreateWithoutCareCreditPreapprovalChecksInput;
  update: ClinicPetParentUpdateWithoutCareCreditPreapprovalChecksInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutChannelCreationSourcesInput = {
  create: ClinicPetParentCreateWithoutChannelCreationSourcesInput;
  update: ClinicPetParentUpdateWithoutChannelCreationSourcesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutChannelMembersInput = {
  create: ClinicPetParentCreateWithoutChannelMembersInput;
  update: ClinicPetParentUpdateWithoutChannelMembersInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutClinicPetParentPimSyncStatusInput = {
  create: ClinicPetParentCreateWithoutClinicPetParentPimSyncStatusInput;
  update: ClinicPetParentUpdateWithoutClinicPetParentPimSyncStatusInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutClinicWidgetRequestsInput = {
  create: ClinicPetParentCreateWithoutClinicWidgetRequestsInput;
  update: ClinicPetParentUpdateWithoutClinicWidgetRequestsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutCustomFieldValuesInput = {
  create: ClinicPetParentCreateWithoutCustomFieldValuesInput;
  update: ClinicPetParentUpdateWithoutCustomFieldValuesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutDevicesInput = {
  create: ClinicPetParentCreateWithoutDevicesInput;
  update: ClinicPetParentUpdateWithoutDevicesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutEmailCampaignCustomListRecipientsInput = {
  create: ClinicPetParentCreateWithoutEmailCampaignCustomListRecipientsInput;
  update: ClinicPetParentUpdateWithoutEmailCampaignCustomListRecipientsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutEmailCampaignLogInput = {
  create: ClinicPetParentCreateWithoutEmailCampaignLogInput;
  update: ClinicPetParentUpdateWithoutEmailCampaignLogInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutEmailCampaignUnsubscribeInput = {
  create: ClinicPetParentCreateWithoutEmailCampaignUnsubscribeInput;
  update: ClinicPetParentUpdateWithoutEmailCampaignUnsubscribeInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutEmailProviderLogsInput = {
  create: ClinicPetParentCreateWithoutEmailProviderLogsInput;
  update: ClinicPetParentUpdateWithoutEmailProviderLogsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutFormSubmissionsInput = {
  create: ClinicPetParentCreateWithoutFormSubmissionsInput;
  update: ClinicPetParentUpdateWithoutFormSubmissionsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutHillsToHomeApiLogInput = {
  create: ClinicPetParentCreateWithoutHillsToHomeApiLogInput;
  update: ClinicPetParentUpdateWithoutHillsToHomeApiLogInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutInformAudienceMemberInput = {
  create: ClinicPetParentCreateWithoutInformAudienceMemberInput;
  update: ClinicPetParentUpdateWithoutInformAudienceMemberInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutInformControlGroupParticipantsInput = {
  create: ClinicPetParentCreateWithoutInformControlGroupParticipantsInput;
  update: ClinicPetParentUpdateWithoutInformControlGroupParticipantsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutInformSessionsInput = {
  create: ClinicPetParentCreateWithoutInformSessionsInput;
  update: ClinicPetParentUpdateWithoutInformSessionsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutInvoicesInput = {
  create: ClinicPetParentCreateWithoutInvoicesInput;
  update: ClinicPetParentUpdateWithoutInvoicesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutLapsedPetParentTriggersInput = {
  create: ClinicPetParentCreateWithoutLapsedPetParentTriggersInput;
  update: ClinicPetParentUpdateWithoutLapsedPetParentTriggersInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutLoyaltyAccountHolderInput = {
  create: ClinicPetParentCreateWithoutLoyaltyAccountHolderInput;
  update: ClinicPetParentUpdateWithoutLoyaltyAccountHolderInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutMassTextAlertEntriesInput = {
  create: ClinicPetParentCreateWithoutMassTextAlertEntriesInput;
  update: ClinicPetParentUpdateWithoutMassTextAlertEntriesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutPhoneNumbersInput = {
  create: ClinicPetParentCreateWithoutPhoneNumbersInput;
  update: ClinicPetParentUpdateWithoutPhoneNumbersInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutReceivedTrupanionExamDayOffersInput = {
  create: ClinicPetParentCreateWithoutReceivedTrupanionExamDayOffersInput;
  update: ClinicPetParentUpdateWithoutReceivedTrupanionExamDayOffersInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutServicePurchaseSummariesInput = {
  create: ClinicPetParentCreateWithoutServicePurchaseSummariesInput;
  update: ClinicPetParentUpdateWithoutServicePurchaseSummariesInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutServiceRemindersInput = {
  create: ClinicPetParentCreateWithoutServiceRemindersInput;
  update: ClinicPetParentUpdateWithoutServiceRemindersInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutStripePaymentIntentsInput = {
  create: ClinicPetParentCreateWithoutStripePaymentIntentsInput;
  update: ClinicPetParentUpdateWithoutStripePaymentIntentsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutStripePaymentMethodsInput = {
  create: ClinicPetParentCreateWithoutStripePaymentMethodsInput;
  update: ClinicPetParentUpdateWithoutStripePaymentMethodsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutSurveyResultsInput = {
  create: ClinicPetParentCreateWithoutSurveyResultsInput;
  update: ClinicPetParentUpdateWithoutSurveyResultsInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentUpsertWithoutTasksInput = {
  create: ClinicPetParentCreateWithoutTasksInput;
  update: ClinicPetParentUpdateWithoutTasksInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type ClinicPetParentWhereInput = {
  AND?: Maybe<Array<ClinicPetParentWhereInput>>;
  EmailCampaignLog?: Maybe<EmailCampaignLogListRelationFilter>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeListRelationFilter>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<ClinicPetParentWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentWhereInput>>;
  addresses?: Maybe<ClinicPetParentAddressListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultListRelationFilter>;
  calls?: Maybe<CallParticipantListRelationFilter>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentListRelationFilter>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestListRelationFilter>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  channelMembers?: Maybe<ChannelMemberListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusListRelationFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<EnumClinicEntityCreationSourceNullableFilter>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueListRelationFilter>;
  devices?: Maybe<ClinicPetParentDeviceListRelationFilter>;
  email?: Maybe<StringNullableFilter>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientListRelationFilter>;
  emailProviderLogs?: Maybe<EmailProviderLogListRelationFilter>;
  firstName?: Maybe<StringFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  globalPetParent?: Maybe<GlobalPetParentNullableScalarRelationFilter>;
  globalPetParentId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantListRelationFilter>;
  informSessions?: Maybe<InformSessionListRelationFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  invoices?: Maybe<InvoiceListRelationFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isPrivacyProtected?: Maybe<BoolNullableFilter>;
  isTest?: Maybe<BoolNullableFilter>;
  isVerified?: Maybe<BoolNullableFilter>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersListRelationFilter>;
  lastName?: Maybe<StringFilter>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderNullableScalarRelationFilter>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryListRelationFilter>;
  organizationPetParent?: Maybe<OrganizationPetParentNullableScalarRelationFilter>;
  organizationPetParentId?: Maybe<StringNullableFilter>;
  petParentSetting?: Maybe<PetParentSettingNullableScalarRelationFilter>;
  petParentSettingId?: Maybe<StringNullableFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberListRelationFilter>;
  pimsAccountId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsPhoneNumber?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  serviceReminders?: Maybe<ServiceReminderListRelationFilter>;
  sourcePimsId?: Maybe<StringNullableFilter>;
  stripeCustomer?: Maybe<StripeCustomerNullableScalarRelationFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  stripePaymentMethods?: Maybe<StripePaymentMethodListRelationFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type ClinicPetParentWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPetParentWhereInput>>;
  EmailCampaignLog?: Maybe<EmailCampaignLogListRelationFilter>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeListRelationFilter>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<ClinicPetParentWhereInput>>;
  OR?: Maybe<Array<ClinicPetParentWhereInput>>;
  addresses?: Maybe<ClinicPetParentAddressListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  bitwerxPaymentHealthcheckResults?: Maybe<BitwerxPaymentHealthcheckResultListRelationFilter>;
  calls?: Maybe<CallParticipantListRelationFilter>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentListRelationFilter>;
  careAuthorizationRequests?: Maybe<CareAuthorizationRequestListRelationFilter>;
  careCreditPreapprovalChecks?: Maybe<CareCreditPreapprovalCheckListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  channelMembers?: Maybe<ChannelMemberListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParentPimSyncStatus?: Maybe<ClinicPetParentPimsSyncStatusListRelationFilter>;
  clinicPetParentPimsIdAndIntegrationId?: Maybe<ClinicPetParentClinicPetParentPimsIdAndIntegrationIdCompoundUniqueInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationSource?: Maybe<EnumClinicEntityCreationSourceNullableFilter>;
  customFieldValues?: Maybe<ClinicPetParentCustomFieldValueListRelationFilter>;
  devices?: Maybe<ClinicPetParentDeviceListRelationFilter>;
  email?: Maybe<StringNullableFilter>;
  emailCampaignCustomListRecipients?: Maybe<EmailCampaignCustomListRecipientListRelationFilter>;
  emailProviderLogs?: Maybe<EmailProviderLogListRelationFilter>;
  firstName?: Maybe<StringFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  globalPetParent?: Maybe<GlobalPetParentNullableScalarRelationFilter>;
  globalPetParentId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informControlGroupParticipants?: Maybe<InformControlGroupParticipantListRelationFilter>;
  informSessions?: Maybe<InformSessionListRelationFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  invoices?: Maybe<InvoiceListRelationFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isPrivacyProtected?: Maybe<BoolNullableFilter>;
  isTest?: Maybe<BoolNullableFilter>;
  isVerified?: Maybe<BoolNullableFilter>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersListRelationFilter>;
  lastName?: Maybe<StringFilter>;
  loyaltyAccountHolder?: Maybe<LoyaltyAccountHolderNullableScalarRelationFilter>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryListRelationFilter>;
  organizationPetParent?: Maybe<OrganizationPetParentNullableScalarRelationFilter>;
  organizationPetParentId?: Maybe<StringNullableFilter>;
  petParentSetting?: Maybe<PetParentSettingNullableScalarRelationFilter>;
  petParentSettingId?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  phoneNumbers?: Maybe<ClinicEntityPhoneNumberListRelationFilter>;
  pimsAccountId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsPhoneNumber?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  serviceReminders?: Maybe<ServiceReminderListRelationFilter>;
  sourcePimsId?: Maybe<StringNullableFilter>;
  stripeCustomer?: Maybe<StripeCustomerNullableScalarRelationFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  stripePaymentMethods?: Maybe<StripePaymentMethodListRelationFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type ClinicPetParentWithJobChainsResponse = {
  __typename?: 'ClinicPetParentWithJobChainsResponse';
  clinicPetParent: ClinicPetParent;
  jobChains?: Maybe<Array<Maybe<JobChain>>>;
};

export type ClinicPetPimsSyncStatus = {
  __typename?: 'ClinicPetPimsSyncStatus';
  attempts?: Maybe<Scalars['Int']>;
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status: ProfilePimsSyncStatus;
  updatedAt: Scalars['DateTime'];
};

export type ClinicPetPimsSyncStatusAvgAggregateOutputType = {
  __typename?: 'ClinicPetPimsSyncStatusAvgAggregateOutputType';
  attempts?: Maybe<Scalars['Float']>;
};

export type ClinicPetPimsSyncStatusAvgOrderByAggregateInput = {
  attempts?: Maybe<SortOrder>;
};

export type ClinicPetPimsSyncStatusCountAggregateOutputType = {
  __typename?: 'ClinicPetPimsSyncStatusCountAggregateOutputType';
  _all: Scalars['Int'];
  attempts: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  createdAt: Scalars['Int'];
  details: Scalars['Int'];
  id: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicPetPimsSyncStatusCountOrderByAggregateInput = {
  attempts?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetPimsSyncStatusCreateInput = {
  attempts?: Maybe<Scalars['Int']>;
  clinicPet: ClinicPetCreateNestedOneWithoutClinicPetPimsSyncStatusInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status: ProfilePimsSyncStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusCreateManyClinicPetInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status: ProfilePimsSyncStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusCreateManyClinicPetInputEnvelope = {
  data: Array<ClinicPetPimsSyncStatusCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPetPimsSyncStatusCreateManyInput = {
  attempts?: Maybe<Scalars['Int']>;
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status: ProfilePimsSyncStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<ClinicPetPimsSyncStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetPimsSyncStatusCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ClinicPetPimsSyncStatusCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ClinicPetPimsSyncStatusCreateManyClinicPetInputEnvelope>;
};

export type ClinicPetPimsSyncStatusCreateOrConnectWithoutClinicPetInput = {
  create: ClinicPetPimsSyncStatusCreateWithoutClinicPetInput;
  where: ClinicPetPimsSyncStatusWhereUniqueInput;
};

export type ClinicPetPimsSyncStatusCreateWithoutClinicPetInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status: ProfilePimsSyncStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusGroupByOutputType = {
  __typename?: 'ClinicPetPimsSyncStatusGroupByOutputType';
  _avg?: Maybe<ClinicPetPimsSyncStatusAvgAggregateOutputType>;
  _count?: Maybe<ClinicPetPimsSyncStatusCountAggregateOutputType>;
  _max?: Maybe<ClinicPetPimsSyncStatusMaxAggregateOutputType>;
  _min?: Maybe<ClinicPetPimsSyncStatusMinAggregateOutputType>;
  _sum?: Maybe<ClinicPetPimsSyncStatusSumAggregateOutputType>;
  attempts?: Maybe<Scalars['Int']>;
  clinicPetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status: ProfilePimsSyncStatus;
  updatedAt: Scalars['DateTime'];
};

export type ClinicPetPimsSyncStatusListRelationFilter = {
  every?: Maybe<ClinicPetPimsSyncStatusWhereInput>;
  none?: Maybe<ClinicPetPimsSyncStatusWhereInput>;
  some?: Maybe<ClinicPetPimsSyncStatusWhereInput>;
};

export type ClinicPetPimsSyncStatusMaxAggregateOutputType = {
  __typename?: 'ClinicPetPimsSyncStatusMaxAggregateOutputType';
  attempts?: Maybe<Scalars['Int']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusMaxOrderByAggregateInput = {
  attempts?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetPimsSyncStatusMinAggregateOutputType = {
  __typename?: 'ClinicPetPimsSyncStatusMinAggregateOutputType';
  attempts?: Maybe<Scalars['Int']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusMinOrderByAggregateInput = {
  attempts?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetPimsSyncStatusOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPetPimsSyncStatusOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetPimsSyncStatusOrderByRelevanceInput>;
  attempts?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPetPimsSyncStatusOrderByRelevanceFieldEnum {
  ClinicPetId = 'clinicPetId',
  Details = 'details',
  Id = 'id'
}

export type ClinicPetPimsSyncStatusOrderByRelevanceInput = {
  fields: Array<ClinicPetPimsSyncStatusOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPetPimsSyncStatusOrderByWithAggregationInput = {
  _avg?: Maybe<ClinicPetPimsSyncStatusAvgOrderByAggregateInput>;
  _count?: Maybe<ClinicPetPimsSyncStatusCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPetPimsSyncStatusMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPetPimsSyncStatusMinOrderByAggregateInput>;
  _sum?: Maybe<ClinicPetPimsSyncStatusSumOrderByAggregateInput>;
  attempts?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetPimsSyncStatusOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPetPimsSyncStatusOrderByRelevanceInput>;
  attempts?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPetPimsSyncStatusOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicPetPimsSyncStatusOrderByRelevanceInput>;
  attempts?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPetPimsSyncStatusScalarFieldEnum {
  Attempts = 'attempts',
  ClinicPetId = 'clinicPetId',
  CreatedAt = 'createdAt',
  Details = 'details',
  Id = 'id',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type ClinicPetPimsSyncStatusScalarWhereInput = {
  AND?: Maybe<Array<ClinicPetPimsSyncStatusScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPetPimsSyncStatusScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPetPimsSyncStatusScalarWhereInput>>;
  attempts?: Maybe<IntNullableFilter>;
  clinicPetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  details?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumProfilePimsSyncStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPetPimsSyncStatusScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPetPimsSyncStatusScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPetPimsSyncStatusScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPetPimsSyncStatusScalarWhereWithAggregatesInput>>;
  attempts?: Maybe<IntNullableWithAggregatesFilter>;
  clinicPetId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  details?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumProfilePimsSyncStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicPetPimsSyncStatusSumAggregateOutputType = {
  __typename?: 'ClinicPetPimsSyncStatusSumAggregateOutputType';
  attempts?: Maybe<Scalars['Int']>;
};

export type ClinicPetPimsSyncStatusSumOrderByAggregateInput = {
  attempts?: Maybe<SortOrder>;
};

export type ClinicPetPimsSyncStatusUncheckedCreateInput = {
  attempts?: Maybe<Scalars['Int']>;
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status: ProfilePimsSyncStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<ClinicPetPimsSyncStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetPimsSyncStatusCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ClinicPetPimsSyncStatusCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ClinicPetPimsSyncStatusCreateManyClinicPetInputEnvelope>;
};

export type ClinicPetPimsSyncStatusUncheckedCreateWithoutClinicPetInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status: ProfilePimsSyncStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusUncheckedUpdateInput = {
  attempts?: Maybe<Scalars['Int']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusUncheckedUpdateManyInput = {
  attempts?: Maybe<Scalars['Int']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<ClinicPetPimsSyncStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetPimsSyncStatusCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ClinicPetPimsSyncStatusCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ClinicPetPimsSyncStatusCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<ClinicPetPimsSyncStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetPimsSyncStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetPimsSyncStatusWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetPimsSyncStatusWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetPimsSyncStatusUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<ClinicPetPimsSyncStatusUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<ClinicPetPimsSyncStatusUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type ClinicPetPimsSyncStatusUncheckedUpdateWithoutClinicPetInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusUpdateInput = {
  attempts?: Maybe<Scalars['Int']>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutClinicPetPimsSyncStatusNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusUpdateManyMutationInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusUpdateManyWithWhereWithoutClinicPetInput = {
  data: ClinicPetPimsSyncStatusUpdateManyMutationInput;
  where: ClinicPetPimsSyncStatusScalarWhereInput;
};

export type ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<ClinicPetPimsSyncStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetPimsSyncStatusCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ClinicPetPimsSyncStatusCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ClinicPetPimsSyncStatusCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<ClinicPetPimsSyncStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetPimsSyncStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetPimsSyncStatusWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetPimsSyncStatusWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetPimsSyncStatusUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<ClinicPetPimsSyncStatusUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<ClinicPetPimsSyncStatusUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type ClinicPetPimsSyncStatusUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: ClinicPetPimsSyncStatusUpdateWithoutClinicPetInput;
  where: ClinicPetPimsSyncStatusWhereUniqueInput;
};

export type ClinicPetPimsSyncStatusUpdateWithoutClinicPetInput = {
  attempts?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<ProfilePimsSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPetPimsSyncStatusUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: ClinicPetPimsSyncStatusCreateWithoutClinicPetInput;
  update: ClinicPetPimsSyncStatusUpdateWithoutClinicPetInput;
  where: ClinicPetPimsSyncStatusWhereUniqueInput;
};

export type ClinicPetPimsSyncStatusWhereInput = {
  AND?: Maybe<Array<ClinicPetPimsSyncStatusWhereInput>>;
  NOT?: Maybe<Array<ClinicPetPimsSyncStatusWhereInput>>;
  OR?: Maybe<Array<ClinicPetPimsSyncStatusWhereInput>>;
  attempts?: Maybe<IntNullableFilter>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  details?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumProfilePimsSyncStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPetPimsSyncStatusWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPetPimsSyncStatusWhereInput>>;
  NOT?: Maybe<Array<ClinicPetPimsSyncStatusWhereInput>>;
  OR?: Maybe<Array<ClinicPetPimsSyncStatusWhereInput>>;
  attempts?: Maybe<IntNullableFilter>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  details?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<EnumProfilePimsSyncStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum ClinicPetScalarFieldEnum {
  Breed = 'breed',
  BreedId = 'breedId',
  ClinicId = 'clinicId',
  Color = 'color',
  ColorId = 'colorId',
  CreatedAt = 'createdAt',
  DateOfBirth = 'dateOfBirth',
  DateOfDeath = 'dateOfDeath',
  Gender = 'gender',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  IsDeceased = 'isDeceased',
  IsDeleted = 'isDeleted',
  IsPrivacyProtected = 'isPrivacyProtected',
  IsSubscribedToReminders = 'isSubscribedToReminders',
  MediaId = 'mediaId',
  Name = 'name',
  OrganizationPetId = 'organizationPetId',
  PhotoUrl = 'photoUrl',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  SexId = 'sexId',
  Species = 'species',
  SpeciesId = 'speciesId',
  SpeciesType = 'speciesType',
  UpdatedAt = 'updatedAt',
  Weight = 'weight',
  WeightInKg = 'weightInKg',
  WeightUnit = 'weightUnit'
}

export type ClinicPetScalarRelationFilter = {
  AND?: Maybe<Array<ClinicPetWhereInput>>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  LabPanel?: Maybe<LabPanelListRelationFilter>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ClinicPetWhereInput>>;
  OR?: Maybe<Array<ClinicPetWhereInput>>;
  alerts?: Maybe<ClinicPetAlertListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  breed?: Maybe<StringNullableFilter>;
  breedId?: Maybe<StringNullableFilter>;
  breedModel?: Maybe<BreedNullableScalarRelationFilter>;
  careBenefitUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusListRelationFilter>;
  color?: Maybe<StringNullableFilter>;
  colorId?: Maybe<StringNullableFilter>;
  colorModel?: Maybe<ColorNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueListRelationFilter>;
  dateOfBirth?: Maybe<DateTimeNullableFilter>;
  dateOfDeath?: Maybe<DateTimeNullableFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  gender?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  invoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeceased?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isPrivacyProtected?: Maybe<BoolNullableFilter>;
  isSubscribedToReminders?: Maybe<BoolFilter>;
  media?: Maybe<MediaNullableScalarRelationFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  organizationPet?: Maybe<OrganizationPetNullableScalarRelationFilter>;
  organizationPetId?: Maybe<StringNullableFilter>;
  petParents?: Maybe<ClinicPetParentListRelationFilter>;
  photoUrl?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  serviceReminders?: Maybe<ServiceReminderListRelationFilter>;
  sexId?: Maybe<StringNullableFilter>;
  sexModel?: Maybe<SexNullableScalarRelationFilter>;
  species?: Maybe<StringNullableFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  speciesModel?: Maybe<SpeciesNullableScalarRelationFilter>;
  speciesType?: Maybe<EnumSpeciesTypeFilter>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vaccinations?: Maybe<VaccinationListRelationFilter>;
  weight?: Maybe<FloatNullableFilter>;
  weightInKg?: Maybe<FloatNullableFilter>;
  weightUnit?: Maybe<StringNullableFilter>;
};

export type ClinicPetScalarWhereInput = {
  AND?: Maybe<Array<ClinicPetScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPetScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPetScalarWhereInput>>;
  breed?: Maybe<StringNullableFilter>;
  breedId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  color?: Maybe<StringNullableFilter>;
  colorId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dateOfBirth?: Maybe<DateTimeNullableFilter>;
  dateOfDeath?: Maybe<DateTimeNullableFilter>;
  gender?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeceased?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isPrivacyProtected?: Maybe<BoolNullableFilter>;
  isSubscribedToReminders?: Maybe<BoolFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  organizationPetId?: Maybe<StringNullableFilter>;
  photoUrl?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  sexId?: Maybe<StringNullableFilter>;
  species?: Maybe<StringNullableFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  speciesType?: Maybe<EnumSpeciesTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  weight?: Maybe<FloatNullableFilter>;
  weightInKg?: Maybe<FloatNullableFilter>;
  weightUnit?: Maybe<StringNullableFilter>;
};

export type ClinicPetScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPetScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPetScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPetScalarWhereWithAggregatesInput>>;
  breed?: Maybe<StringNullableWithAggregatesFilter>;
  breedId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  color?: Maybe<StringNullableWithAggregatesFilter>;
  colorId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  dateOfBirth?: Maybe<DateTimeNullableWithAggregatesFilter>;
  dateOfDeath?: Maybe<DateTimeNullableWithAggregatesFilter>;
  gender?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  isActive?: Maybe<BoolNullableWithAggregatesFilter>;
  isDeceased?: Maybe<BoolNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolNullableWithAggregatesFilter>;
  isPrivacyProtected?: Maybe<BoolNullableWithAggregatesFilter>;
  isSubscribedToReminders?: Maybe<BoolWithAggregatesFilter>;
  mediaId?: Maybe<StringNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  organizationPetId?: Maybe<StringNullableWithAggregatesFilter>;
  photoUrl?: Maybe<StringNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  sexId?: Maybe<StringNullableWithAggregatesFilter>;
  species?: Maybe<StringNullableWithAggregatesFilter>;
  speciesId?: Maybe<StringNullableWithAggregatesFilter>;
  speciesType?: Maybe<EnumSpeciesTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  weight?: Maybe<FloatNullableWithAggregatesFilter>;
  weightInKg?: Maybe<FloatNullableWithAggregatesFilter>;
  weightUnit?: Maybe<StringNullableWithAggregatesFilter>;
};

export type ClinicPetSumAggregateOutputType = {
  __typename?: 'ClinicPetSumAggregateOutputType';
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
};

export type ClinicPetSumOrderByAggregateInput = {
  weight?: Maybe<SortOrder>;
  weightInKg?: Maybe<SortOrder>;
};

export type ClinicPetUncheckedCreateInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateNestedManyWithoutBreedModelInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutBreedModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutBreedModelInput>>;
  createMany?: Maybe<ClinicPetCreateManyBreedModelInputEnvelope>;
};

export type ClinicPetUncheckedCreateNestedManyWithoutChannelsInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutChannelsInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutChannelsInput>>;
};

export type ClinicPetUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPetCreateManyClinicInputEnvelope>;
};

export type ClinicPetUncheckedCreateNestedManyWithoutColorModelInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutColorModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutColorModelInput>>;
  createMany?: Maybe<ClinicPetCreateManyColorModelInputEnvelope>;
};

export type ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPetCreateManyIntegrationInputEnvelope>;
};

export type ClinicPetUncheckedCreateNestedManyWithoutInvoiceLineItemsInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutInvoiceLineItemsInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutInvoiceLineItemsInput>>;
};

export type ClinicPetUncheckedCreateNestedManyWithoutMediaInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutMediaInput>>;
  createMany?: Maybe<ClinicPetCreateManyMediaInputEnvelope>;
};

export type ClinicPetUncheckedCreateNestedManyWithoutOrganizationPetInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<ClinicPetCreateManyOrganizationPetInputEnvelope>;
};

export type ClinicPetUncheckedCreateNestedManyWithoutPetParentsInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutPetParentsInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutPetParentsInput>>;
};

export type ClinicPetUncheckedCreateNestedManyWithoutSexModelInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutSexModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutSexModelInput>>;
  createMany?: Maybe<ClinicPetCreateManySexModelInputEnvelope>;
};

export type ClinicPetUncheckedCreateNestedManyWithoutSpeciesModelInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutSpeciesModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutSpeciesModelInput>>;
  createMany?: Maybe<ClinicPetCreateManySpeciesModelInputEnvelope>;
};

export type ClinicPetUncheckedCreateWithoutAlertsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutAppointmentsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutAutomationRunActionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutBreedModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutCareBenefitUsagesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutChannelAutomationStatusesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutChannelsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutClinicInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutClinicPetPimsSyncStatusInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutColorModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutCustomFieldValuesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutFormSubmissionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutHillsToHomeApiLogInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutIntegrationInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutInvoiceLineItemsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutLabPanelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutMediaInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutMedicalHistoryInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutOrganizationPetInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutPetParentsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutPrescriptionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutReceivedTrupanionExamDayOffersInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutServicePurchaseSummariesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutServiceRemindersInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutSexModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutSpeciesModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutTrupanionCertificateAvailabilitiesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicPetInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedCreateWithoutVaccinationsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput>;
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutClinicPetInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedCreateNestedManyWithoutClinicPetInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicPetInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutPetInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicPetInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutPetsInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedCreateNestedManyWithoutClinicPetInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutClinicPetInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetsInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyWithoutBreedModelInput = {
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyWithoutBreedModelNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutBreedModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutBreedModelInput>>;
  createMany?: Maybe<ClinicPetCreateManyBreedModelInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutBreedModelInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutBreedModelInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutBreedModelInput>>;
};

export type ClinicPetUncheckedUpdateManyWithoutChannelsInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyWithoutChannelsNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutChannelsInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutChannelsInput>>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutChannelsInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutChannelsInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutChannelsInput>>;
};

export type ClinicPetUncheckedUpdateManyWithoutClinicInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPetCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicPetUncheckedUpdateManyWithoutColorModelInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyWithoutColorModelNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutColorModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutColorModelInput>>;
  createMany?: Maybe<ClinicPetCreateManyColorModelInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutColorModelInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutColorModelInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutColorModelInput>>;
};

export type ClinicPetUncheckedUpdateManyWithoutIntegrationInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPetCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ClinicPetUncheckedUpdateManyWithoutInvoiceLineItemsInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyWithoutInvoiceLineItemsNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutInvoiceLineItemsInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutInvoiceLineItemsInput>>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutInvoiceLineItemsInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutInvoiceLineItemsInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutInvoiceLineItemsInput>>;
};

export type ClinicPetUncheckedUpdateManyWithoutMediaInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyWithoutMediaNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutMediaInput>>;
  createMany?: Maybe<ClinicPetCreateManyMediaInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutMediaInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutMediaInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutMediaInput>>;
};

export type ClinicPetUncheckedUpdateManyWithoutOrganizationPetInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyWithoutOrganizationPetNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<ClinicPetCreateManyOrganizationPetInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutOrganizationPetInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutOrganizationPetInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutOrganizationPetInput>>;
};

export type ClinicPetUncheckedUpdateManyWithoutPetParentsInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyWithoutPetParentsNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutPetParentsInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutPetParentsInput>>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutPetParentsInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutPetParentsInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutPetParentsInput>>;
};

export type ClinicPetUncheckedUpdateManyWithoutSexModelInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyWithoutSexModelNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutSexModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutSexModelInput>>;
  createMany?: Maybe<ClinicPetCreateManySexModelInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutSexModelInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutSexModelInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutSexModelInput>>;
};

export type ClinicPetUncheckedUpdateManyWithoutSpeciesModelInput = {
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateManyWithoutSpeciesModelNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutSpeciesModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutSpeciesModelInput>>;
  createMany?: Maybe<ClinicPetCreateManySpeciesModelInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutSpeciesModelInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutSpeciesModelInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutSpeciesModelInput>>;
};

export type ClinicPetUncheckedUpdateWithoutAlertsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutAppointmentsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutAutomationRunActionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutBreedModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutCareBenefitUsagesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutChannelAutomationStatusesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutChannelsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutClinicInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutClinicPetPimsSyncStatusInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutColorModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutCustomFieldValuesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutFormSubmissionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutHillsToHomeApiLogInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutIntegrationInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutInvoiceLineItemsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutLabPanelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutMediaInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutMedicalHistoryInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutOrganizationPetInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutPetParentsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutPrescriptionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutReceivedTrupanionExamDayOffersInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutServicePurchaseSummariesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutServiceRemindersInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutSexModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutSpeciesModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutTrupanionCertificateAvailabilitiesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUncheckedUpdateWithoutVaccinationsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUncheckedUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutPetsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUncheckedUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetId?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput>;
  sexId?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateManyMutationInput = {
  breed?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateManyWithWhereWithoutBreedModelInput = {
  data: ClinicPetUpdateManyMutationInput;
  where: ClinicPetScalarWhereInput;
};

export type ClinicPetUpdateManyWithWhereWithoutChannelsInput = {
  data: ClinicPetUpdateManyMutationInput;
  where: ClinicPetScalarWhereInput;
};

export type ClinicPetUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicPetUpdateManyMutationInput;
  where: ClinicPetScalarWhereInput;
};

export type ClinicPetUpdateManyWithWhereWithoutColorModelInput = {
  data: ClinicPetUpdateManyMutationInput;
  where: ClinicPetScalarWhereInput;
};

export type ClinicPetUpdateManyWithWhereWithoutIntegrationInput = {
  data: ClinicPetUpdateManyMutationInput;
  where: ClinicPetScalarWhereInput;
};

export type ClinicPetUpdateManyWithWhereWithoutInvoiceLineItemsInput = {
  data: ClinicPetUpdateManyMutationInput;
  where: ClinicPetScalarWhereInput;
};

export type ClinicPetUpdateManyWithWhereWithoutMediaInput = {
  data: ClinicPetUpdateManyMutationInput;
  where: ClinicPetScalarWhereInput;
};

export type ClinicPetUpdateManyWithWhereWithoutOrganizationPetInput = {
  data: ClinicPetUpdateManyMutationInput;
  where: ClinicPetScalarWhereInput;
};

export type ClinicPetUpdateManyWithWhereWithoutPetParentsInput = {
  data: ClinicPetUpdateManyMutationInput;
  where: ClinicPetScalarWhereInput;
};

export type ClinicPetUpdateManyWithWhereWithoutSexModelInput = {
  data: ClinicPetUpdateManyMutationInput;
  where: ClinicPetScalarWhereInput;
};

export type ClinicPetUpdateManyWithWhereWithoutSpeciesModelInput = {
  data: ClinicPetUpdateManyMutationInput;
  where: ClinicPetScalarWhereInput;
};

export type ClinicPetUpdateManyWithoutBreedModelNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutBreedModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutBreedModelInput>>;
  createMany?: Maybe<ClinicPetCreateManyBreedModelInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutBreedModelInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutBreedModelInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutBreedModelInput>>;
};

export type ClinicPetUpdateManyWithoutChannelsNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutChannelsInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutChannelsInput>>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutChannelsInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutChannelsInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutChannelsInput>>;
};

export type ClinicPetUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPetCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicPetUpdateManyWithoutColorModelNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutColorModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutColorModelInput>>;
  createMany?: Maybe<ClinicPetCreateManyColorModelInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutColorModelInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutColorModelInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutColorModelInput>>;
};

export type ClinicPetUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPetCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ClinicPetUpdateManyWithoutInvoiceLineItemsNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutInvoiceLineItemsInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutInvoiceLineItemsInput>>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutInvoiceLineItemsInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutInvoiceLineItemsInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutInvoiceLineItemsInput>>;
};

export type ClinicPetUpdateManyWithoutMediaNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutMediaInput>>;
  createMany?: Maybe<ClinicPetCreateManyMediaInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutMediaInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutMediaInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutMediaInput>>;
};

export type ClinicPetUpdateManyWithoutOrganizationPetNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<ClinicPetCreateManyOrganizationPetInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutOrganizationPetInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutOrganizationPetInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutOrganizationPetInput>>;
};

export type ClinicPetUpdateManyWithoutPetParentsNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutPetParentsInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutPetParentsInput>>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutPetParentsInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutPetParentsInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutPetParentsInput>>;
};

export type ClinicPetUpdateManyWithoutSexModelNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutSexModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutSexModelInput>>;
  createMany?: Maybe<ClinicPetCreateManySexModelInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutSexModelInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutSexModelInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutSexModelInput>>;
};

export type ClinicPetUpdateManyWithoutSpeciesModelNestedInput = {
  connect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPetCreateOrConnectWithoutSpeciesModelInput>>;
  create?: Maybe<Array<ClinicPetCreateWithoutSpeciesModelInput>>;
  createMany?: Maybe<ClinicPetCreateManySpeciesModelInputEnvelope>;
  delete?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPetScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPetWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPetUpdateWithWhereUniqueWithoutSpeciesModelInput>>;
  updateMany?: Maybe<Array<ClinicPetUpdateManyWithWhereWithoutSpeciesModelInput>>;
  upsert?: Maybe<Array<ClinicPetUpsertWithWhereUniqueWithoutSpeciesModelInput>>;
};

export type ClinicPetUpdateOneRequiredWithoutCareBenefitUsagesNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutCareBenefitUsagesInput>;
  create?: Maybe<ClinicPetCreateWithoutCareBenefitUsagesInput>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutCareBenefitUsagesInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutCareBenefitUsagesInput>;
};

export type ClinicPetUpdateOneRequiredWithoutClinicPetPimsSyncStatusNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutClinicPetPimsSyncStatusInput>;
  create?: Maybe<ClinicPetCreateWithoutClinicPetPimsSyncStatusInput>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutClinicPetPimsSyncStatusInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutClinicPetPimsSyncStatusInput>;
};

export type ClinicPetUpdateOneRequiredWithoutCustomFieldValuesNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutCustomFieldValuesInput>;
  create?: Maybe<ClinicPetCreateWithoutCustomFieldValuesInput>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutCustomFieldValuesInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutCustomFieldValuesInput>;
};

export type ClinicPetUpdateOneRequiredWithoutPrescriptionsNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutPrescriptionsInput>;
  create?: Maybe<ClinicPetCreateWithoutPrescriptionsInput>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutPrescriptionsInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutPrescriptionsInput>;
};

export type ClinicPetUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutReceivedTrupanionExamDayOffersInput>;
  create?: Maybe<ClinicPetCreateWithoutReceivedTrupanionExamDayOffersInput>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutReceivedTrupanionExamDayOffersInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutReceivedTrupanionExamDayOffersInput>;
};

export type ClinicPetUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutServicePurchaseSummariesInput>;
  create?: Maybe<ClinicPetCreateWithoutServicePurchaseSummariesInput>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutServicePurchaseSummariesInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutServicePurchaseSummariesInput>;
};

export type ClinicPetUpdateOneRequiredWithoutTrupanionCertificateAvailabilitiesNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutTrupanionCertificateAvailabilitiesInput>;
  create?: Maybe<ClinicPetCreateWithoutTrupanionCertificateAvailabilitiesInput>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutTrupanionCertificateAvailabilitiesInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutTrupanionCertificateAvailabilitiesInput>;
};

export type ClinicPetUpdateOneRequiredWithoutVaccinationsNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutVaccinationsInput>;
  create?: Maybe<ClinicPetCreateWithoutVaccinationsInput>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutVaccinationsInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutVaccinationsInput>;
};

export type ClinicPetUpdateOneWithoutAlertsNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutAlertsInput>;
  create?: Maybe<ClinicPetCreateWithoutAlertsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutAlertsInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutAlertsInput>;
};

export type ClinicPetUpdateOneWithoutAppointmentsNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<ClinicPetCreateWithoutAppointmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutAppointmentsInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutAppointmentsInput>;
};

export type ClinicPetUpdateOneWithoutAutomationRunActionsNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutAutomationRunActionsInput>;
  create?: Maybe<ClinicPetCreateWithoutAutomationRunActionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutAutomationRunActionsInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutAutomationRunActionsInput>;
};

export type ClinicPetUpdateOneWithoutChannelAutomationStatusesNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<ClinicPetCreateWithoutChannelAutomationStatusesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutChannelAutomationStatusesInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutChannelAutomationStatusesInput>;
};

export type ClinicPetUpdateOneWithoutFormSubmissionsNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutFormSubmissionsInput>;
  create?: Maybe<ClinicPetCreateWithoutFormSubmissionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutFormSubmissionsInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutFormSubmissionsInput>;
};

export type ClinicPetUpdateOneWithoutHillsToHomeApiLogNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutHillsToHomeApiLogInput>;
  create?: Maybe<ClinicPetCreateWithoutHillsToHomeApiLogInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutHillsToHomeApiLogInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutHillsToHomeApiLogInput>;
};

export type ClinicPetUpdateOneWithoutLabPanelNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutLabPanelInput>;
  create?: Maybe<ClinicPetCreateWithoutLabPanelInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutLabPanelInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutLabPanelInput>;
};

export type ClinicPetUpdateOneWithoutMedicalHistoryNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutMedicalHistoryInput>;
  create?: Maybe<ClinicPetCreateWithoutMedicalHistoryInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutMedicalHistoryInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutMedicalHistoryInput>;
};

export type ClinicPetUpdateOneWithoutServiceRemindersNestedInput = {
  connect?: Maybe<ClinicPetWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPetCreateOrConnectWithoutServiceRemindersInput>;
  create?: Maybe<ClinicPetCreateWithoutServiceRemindersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPetUpdateToOneWithWhereWithoutServiceRemindersInput>;
  upsert?: Maybe<ClinicPetUpsertWithoutServiceRemindersInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutAlertsInput = {
  data: ClinicPetUpdateWithoutAlertsInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutAppointmentsInput = {
  data: ClinicPetUpdateWithoutAppointmentsInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutAutomationRunActionsInput = {
  data: ClinicPetUpdateWithoutAutomationRunActionsInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutCareBenefitUsagesInput = {
  data: ClinicPetUpdateWithoutCareBenefitUsagesInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutChannelAutomationStatusesInput = {
  data: ClinicPetUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutClinicPetPimsSyncStatusInput = {
  data: ClinicPetUpdateWithoutClinicPetPimsSyncStatusInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutCustomFieldValuesInput = {
  data: ClinicPetUpdateWithoutCustomFieldValuesInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutFormSubmissionsInput = {
  data: ClinicPetUpdateWithoutFormSubmissionsInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutHillsToHomeApiLogInput = {
  data: ClinicPetUpdateWithoutHillsToHomeApiLogInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutLabPanelInput = {
  data: ClinicPetUpdateWithoutLabPanelInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutMedicalHistoryInput = {
  data: ClinicPetUpdateWithoutMedicalHistoryInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutPrescriptionsInput = {
  data: ClinicPetUpdateWithoutPrescriptionsInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutReceivedTrupanionExamDayOffersInput = {
  data: ClinicPetUpdateWithoutReceivedTrupanionExamDayOffersInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutServicePurchaseSummariesInput = {
  data: ClinicPetUpdateWithoutServicePurchaseSummariesInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutServiceRemindersInput = {
  data: ClinicPetUpdateWithoutServiceRemindersInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutTrupanionCertificateAvailabilitiesInput = {
  data: ClinicPetUpdateWithoutTrupanionCertificateAvailabilitiesInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateToOneWithWhereWithoutVaccinationsInput = {
  data: ClinicPetUpdateWithoutVaccinationsInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpdateWithWhereUniqueWithoutBreedModelInput = {
  data: ClinicPetUpdateWithoutBreedModelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpdateWithWhereUniqueWithoutChannelsInput = {
  data: ClinicPetUpdateWithoutChannelsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicPetUpdateWithoutClinicInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpdateWithWhereUniqueWithoutColorModelInput = {
  data: ClinicPetUpdateWithoutColorModelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: ClinicPetUpdateWithoutIntegrationInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpdateWithWhereUniqueWithoutInvoiceLineItemsInput = {
  data: ClinicPetUpdateWithoutInvoiceLineItemsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpdateWithWhereUniqueWithoutMediaInput = {
  data: ClinicPetUpdateWithoutMediaInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpdateWithWhereUniqueWithoutOrganizationPetInput = {
  data: ClinicPetUpdateWithoutOrganizationPetInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpdateWithWhereUniqueWithoutPetParentsInput = {
  data: ClinicPetUpdateWithoutPetParentsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpdateWithWhereUniqueWithoutSexModelInput = {
  data: ClinicPetUpdateWithoutSexModelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpdateWithWhereUniqueWithoutSpeciesModelInput = {
  data: ClinicPetUpdateWithoutSpeciesModelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpdateWithoutAlertsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutAppointmentsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutAutomationRunActionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutBreedModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutCareBenefitUsagesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutChannelAutomationStatusesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutChannelsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutClinicInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutClinicPetPimsSyncStatusInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutColorModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutCustomFieldValuesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutFormSubmissionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutHillsToHomeApiLogInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutIntegrationInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutInvoiceLineItemsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutLabPanelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutMediaInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutMedicalHistoryInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutOrganizationPetInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutPetParentsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutPrescriptionsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutReceivedTrupanionExamDayOffersInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutServicePurchaseSummariesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutServiceRemindersInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutSexModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutSpeciesModelInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutTrupanionCertificateAvailabilitiesInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicPetNestedInput>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpdateWithoutVaccinationsInput = {
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput>;
  LabPanel?: Maybe<LabPanelUpdateManyWithoutClinicPetNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutClinicPetNestedInput>;
  alerts?: Maybe<ClinicPetAlertUpdateManyWithoutClinicPetNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicPetNestedInput>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutPetNestedInput>;
  breed?: Maybe<Scalars['String']>;
  breedModel?: Maybe<BreedUpdateOneWithoutPetsNestedInput>;
  careBenefitUsages?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicPetNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicPetNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutPetsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicPetsNestedInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusUpdateManyWithoutClinicPetNestedInput>;
  color?: Maybe<Scalars['String']>;
  colorModel?: Maybe<ColorUpdateOneWithoutPetsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutClinicPetNestedInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicPetNestedInput>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaUpdateOneWithoutClinicPetsNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationPet?: Maybe<OrganizationPetUpdateOneWithoutClinicPetsNestedInput>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutPetsNestedInput>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicPetNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutClinicPetNestedInput>;
  sexModel?: Maybe<SexUpdateOneWithoutPetsNestedInput>;
  species?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<SpeciesUpdateOneWithoutPetsNestedInput>;
  speciesType?: Maybe<SpeciesType>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ClinicPetUpsertWithWhereUniqueWithoutBreedModelInput = {
  create: ClinicPetCreateWithoutBreedModelInput;
  update: ClinicPetUpdateWithoutBreedModelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpsertWithWhereUniqueWithoutChannelsInput = {
  create: ClinicPetCreateWithoutChannelsInput;
  update: ClinicPetUpdateWithoutChannelsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicPetCreateWithoutClinicInput;
  update: ClinicPetUpdateWithoutClinicInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpsertWithWhereUniqueWithoutColorModelInput = {
  create: ClinicPetCreateWithoutColorModelInput;
  update: ClinicPetUpdateWithoutColorModelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: ClinicPetCreateWithoutIntegrationInput;
  update: ClinicPetUpdateWithoutIntegrationInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpsertWithWhereUniqueWithoutInvoiceLineItemsInput = {
  create: ClinicPetCreateWithoutInvoiceLineItemsInput;
  update: ClinicPetUpdateWithoutInvoiceLineItemsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpsertWithWhereUniqueWithoutMediaInput = {
  create: ClinicPetCreateWithoutMediaInput;
  update: ClinicPetUpdateWithoutMediaInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpsertWithWhereUniqueWithoutOrganizationPetInput = {
  create: ClinicPetCreateWithoutOrganizationPetInput;
  update: ClinicPetUpdateWithoutOrganizationPetInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpsertWithWhereUniqueWithoutPetParentsInput = {
  create: ClinicPetCreateWithoutPetParentsInput;
  update: ClinicPetUpdateWithoutPetParentsInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpsertWithWhereUniqueWithoutSexModelInput = {
  create: ClinicPetCreateWithoutSexModelInput;
  update: ClinicPetUpdateWithoutSexModelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpsertWithWhereUniqueWithoutSpeciesModelInput = {
  create: ClinicPetCreateWithoutSpeciesModelInput;
  update: ClinicPetUpdateWithoutSpeciesModelInput;
  where: ClinicPetWhereUniqueInput;
};

export type ClinicPetUpsertWithoutAlertsInput = {
  create: ClinicPetCreateWithoutAlertsInput;
  update: ClinicPetUpdateWithoutAlertsInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutAppointmentsInput = {
  create: ClinicPetCreateWithoutAppointmentsInput;
  update: ClinicPetUpdateWithoutAppointmentsInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutAutomationRunActionsInput = {
  create: ClinicPetCreateWithoutAutomationRunActionsInput;
  update: ClinicPetUpdateWithoutAutomationRunActionsInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutCareBenefitUsagesInput = {
  create: ClinicPetCreateWithoutCareBenefitUsagesInput;
  update: ClinicPetUpdateWithoutCareBenefitUsagesInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutChannelAutomationStatusesInput = {
  create: ClinicPetCreateWithoutChannelAutomationStatusesInput;
  update: ClinicPetUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutClinicPetPimsSyncStatusInput = {
  create: ClinicPetCreateWithoutClinicPetPimsSyncStatusInput;
  update: ClinicPetUpdateWithoutClinicPetPimsSyncStatusInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutCustomFieldValuesInput = {
  create: ClinicPetCreateWithoutCustomFieldValuesInput;
  update: ClinicPetUpdateWithoutCustomFieldValuesInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutFormSubmissionsInput = {
  create: ClinicPetCreateWithoutFormSubmissionsInput;
  update: ClinicPetUpdateWithoutFormSubmissionsInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutHillsToHomeApiLogInput = {
  create: ClinicPetCreateWithoutHillsToHomeApiLogInput;
  update: ClinicPetUpdateWithoutHillsToHomeApiLogInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutLabPanelInput = {
  create: ClinicPetCreateWithoutLabPanelInput;
  update: ClinicPetUpdateWithoutLabPanelInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutMedicalHistoryInput = {
  create: ClinicPetCreateWithoutMedicalHistoryInput;
  update: ClinicPetUpdateWithoutMedicalHistoryInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutPrescriptionsInput = {
  create: ClinicPetCreateWithoutPrescriptionsInput;
  update: ClinicPetUpdateWithoutPrescriptionsInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutReceivedTrupanionExamDayOffersInput = {
  create: ClinicPetCreateWithoutReceivedTrupanionExamDayOffersInput;
  update: ClinicPetUpdateWithoutReceivedTrupanionExamDayOffersInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutServicePurchaseSummariesInput = {
  create: ClinicPetCreateWithoutServicePurchaseSummariesInput;
  update: ClinicPetUpdateWithoutServicePurchaseSummariesInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutServiceRemindersInput = {
  create: ClinicPetCreateWithoutServiceRemindersInput;
  update: ClinicPetUpdateWithoutServiceRemindersInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutTrupanionCertificateAvailabilitiesInput = {
  create: ClinicPetCreateWithoutTrupanionCertificateAvailabilitiesInput;
  update: ClinicPetUpdateWithoutTrupanionCertificateAvailabilitiesInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetUpsertWithoutVaccinationsInput = {
  create: ClinicPetCreateWithoutVaccinationsInput;
  update: ClinicPetUpdateWithoutVaccinationsInput;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ClinicPetWhereInput = {
  AND?: Maybe<Array<ClinicPetWhereInput>>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  LabPanel?: Maybe<LabPanelListRelationFilter>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ClinicPetWhereInput>>;
  OR?: Maybe<Array<ClinicPetWhereInput>>;
  alerts?: Maybe<ClinicPetAlertListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  breed?: Maybe<StringNullableFilter>;
  breedId?: Maybe<StringNullableFilter>;
  breedModel?: Maybe<BreedNullableScalarRelationFilter>;
  careBenefitUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusListRelationFilter>;
  color?: Maybe<StringNullableFilter>;
  colorId?: Maybe<StringNullableFilter>;
  colorModel?: Maybe<ColorNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueListRelationFilter>;
  dateOfBirth?: Maybe<DateTimeNullableFilter>;
  dateOfDeath?: Maybe<DateTimeNullableFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  gender?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  invoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeceased?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isPrivacyProtected?: Maybe<BoolNullableFilter>;
  isSubscribedToReminders?: Maybe<BoolFilter>;
  media?: Maybe<MediaNullableScalarRelationFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  organizationPet?: Maybe<OrganizationPetNullableScalarRelationFilter>;
  organizationPetId?: Maybe<StringNullableFilter>;
  petParents?: Maybe<ClinicPetParentListRelationFilter>;
  photoUrl?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  serviceReminders?: Maybe<ServiceReminderListRelationFilter>;
  sexId?: Maybe<StringNullableFilter>;
  sexModel?: Maybe<SexNullableScalarRelationFilter>;
  species?: Maybe<StringNullableFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  speciesModel?: Maybe<SpeciesNullableScalarRelationFilter>;
  speciesType?: Maybe<EnumSpeciesTypeFilter>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vaccinations?: Maybe<VaccinationListRelationFilter>;
  weight?: Maybe<FloatNullableFilter>;
  weightInKg?: Maybe<FloatNullableFilter>;
  weightUnit?: Maybe<StringNullableFilter>;
};

export type ClinicPetWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPetWhereInput>>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  LabPanel?: Maybe<LabPanelListRelationFilter>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ClinicPetWhereInput>>;
  OR?: Maybe<Array<ClinicPetWhereInput>>;
  alerts?: Maybe<ClinicPetAlertListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  breed?: Maybe<StringNullableFilter>;
  breedId?: Maybe<StringNullableFilter>;
  breedModel?: Maybe<BreedNullableScalarRelationFilter>;
  careBenefitUsages?: Maybe<CareBenefitUsageListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetPimsIdAndIntegrationId?: Maybe<ClinicPetClinicPetPimsIdAndIntegrationIdCompoundUniqueInput>;
  clinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatusListRelationFilter>;
  color?: Maybe<StringNullableFilter>;
  colorId?: Maybe<StringNullableFilter>;
  colorModel?: Maybe<ColorNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customFieldValues?: Maybe<ClinicPetCustomFieldValueListRelationFilter>;
  dateOfBirth?: Maybe<DateTimeNullableFilter>;
  dateOfDeath?: Maybe<DateTimeNullableFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  gender?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  invoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeceased?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isPrivacyProtected?: Maybe<BoolNullableFilter>;
  isSubscribedToReminders?: Maybe<BoolFilter>;
  media?: Maybe<MediaNullableScalarRelationFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  organizationPet?: Maybe<OrganizationPetNullableScalarRelationFilter>;
  organizationPetId?: Maybe<StringNullableFilter>;
  petParents?: Maybe<ClinicPetParentListRelationFilter>;
  photoUrl?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  receivedTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  serviceReminders?: Maybe<ServiceReminderListRelationFilter>;
  sexId?: Maybe<StringNullableFilter>;
  sexModel?: Maybe<SexNullableScalarRelationFilter>;
  species?: Maybe<StringNullableFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  speciesModel?: Maybe<SpeciesNullableScalarRelationFilter>;
  speciesType?: Maybe<EnumSpeciesTypeFilter>;
  trupanionCertificateAvailabilities?: Maybe<TrupanionCertificateAvailabilityListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vaccinations?: Maybe<VaccinationListRelationFilter>;
  weight?: Maybe<FloatNullableFilter>;
  weightInKg?: Maybe<FloatNullableFilter>;
  weightUnit?: Maybe<StringNullableFilter>;
};

export type ClinicPhoneNumber = {
  __typename?: 'ClinicPhoneNumber';
  _count: ClinicPhoneNumberCountOutputType;
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaign>;
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability: ServiceCapability;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUser?: Maybe<User>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  smsNotificationStatuses: Array<SmsNotificationStatus>;
  status: PhoneNumberStatus;
  updatedAt: Scalars['DateTime'];
};


export type ClinicPhoneNumberCampaignRegistryCampaignArgs = {
  where?: Maybe<CampaignRegistryCampaignWhereInput>;
};


export type ClinicPhoneNumberLoaSignedByUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type ClinicPhoneNumberSmsNotificationStatusesArgs = {
  cursor?: Maybe<SmsNotificationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SmsNotificationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SmsNotificationStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SmsNotificationStatusWhereInput>;
};

export type ClinicPhoneNumberCapabilityAndNumberAndProviderCompoundUniqueInput = {
  capability: ServiceCapability;
  number: Scalars['String'];
  provider: ServiceProvider;
};

export type ClinicPhoneNumberCountAggregateOutputType = {
  __typename?: 'ClinicPhoneNumberCountAggregateOutputType';
  _all: Scalars['Int'];
  campaignRegistryCampaignId: Scalars['Int'];
  capability: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  incomingCarrier: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isPrimary: Scalars['Int'];
  isTestSmsDelivered: Scalars['Int'];
  isVerified: Scalars['Int'];
  loaSignedAt: Scalars['Int'];
  loaSignedByUserId: Scalars['Int'];
  loaUrl: Scalars['Int'];
  number: Scalars['Int'];
  portingOrderId: Scalars['Int'];
  portingOrderStatus: Scalars['Int'];
  portingStartAt: Scalars['Int'];
  provider: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicPhoneNumberCountOrderByAggregateInput = {
  campaignRegistryCampaignId?: Maybe<SortOrder>;
  capability?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomingCarrier?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  isTestSmsDelivered?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  loaSignedAt?: Maybe<SortOrder>;
  loaSignedByUserId?: Maybe<SortOrder>;
  loaUrl?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  portingOrderId?: Maybe<SortOrder>;
  portingOrderStatus?: Maybe<SortOrder>;
  portingStartAt?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPhoneNumberCountOutputType = {
  __typename?: 'ClinicPhoneNumberCountOutputType';
  smsNotificationStatuses: Scalars['Int'];
};

export type ClinicPhoneNumberCreateInput = {
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignCreateNestedOneWithoutClinicPhoneNumbersInput>;
  capability: ServiceCapability;
  clinic: ClinicCreateNestedOneWithoutClinicPhoneNumberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUser?: Maybe<UserCreateNestedOneWithoutLoaSignedClinicPhoneNumbersInput>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutClinicPhoneNumberInput>;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberCreateManyCampaignRegistryCampaignInput = {
  capability: ServiceCapability;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberCreateManyCampaignRegistryCampaignInputEnvelope = {
  data: Array<ClinicPhoneNumberCreateManyCampaignRegistryCampaignInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPhoneNumberCreateManyClinicInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability: ServiceCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberCreateManyClinicInputEnvelope = {
  data: Array<ClinicPhoneNumberCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPhoneNumberCreateManyInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability: ServiceCapability;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberCreateManyLoaSignedByUserInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability: ServiceCapability;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberCreateManyLoaSignedByUserInputEnvelope = {
  data: Array<ClinicPhoneNumberCreateManyLoaSignedByUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPhoneNumberCreateNestedManyWithoutCampaignRegistryCampaignInput = {
  connect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPhoneNumberCreateOrConnectWithoutCampaignRegistryCampaignInput>>;
  create?: Maybe<Array<ClinicPhoneNumberCreateWithoutCampaignRegistryCampaignInput>>;
  createMany?: Maybe<ClinicPhoneNumberCreateManyCampaignRegistryCampaignInputEnvelope>;
};

export type ClinicPhoneNumberCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPhoneNumberCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPhoneNumberCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPhoneNumberCreateManyClinicInputEnvelope>;
};

export type ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput = {
  connect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPhoneNumberCreateOrConnectWithoutLoaSignedByUserInput>>;
  create?: Maybe<Array<ClinicPhoneNumberCreateWithoutLoaSignedByUserInput>>;
  createMany?: Maybe<ClinicPhoneNumberCreateManyLoaSignedByUserInputEnvelope>;
};

export type ClinicPhoneNumberCreateNestedOneWithoutSmsNotificationStatusesInput = {
  connect?: Maybe<ClinicPhoneNumberWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPhoneNumberCreateOrConnectWithoutSmsNotificationStatusesInput>;
  create?: Maybe<ClinicPhoneNumberCreateWithoutSmsNotificationStatusesInput>;
};

export type ClinicPhoneNumberCreateOrConnectWithoutCampaignRegistryCampaignInput = {
  create: ClinicPhoneNumberCreateWithoutCampaignRegistryCampaignInput;
  where: ClinicPhoneNumberWhereUniqueInput;
};

export type ClinicPhoneNumberCreateOrConnectWithoutClinicInput = {
  create: ClinicPhoneNumberCreateWithoutClinicInput;
  where: ClinicPhoneNumberWhereUniqueInput;
};

export type ClinicPhoneNumberCreateOrConnectWithoutLoaSignedByUserInput = {
  create: ClinicPhoneNumberCreateWithoutLoaSignedByUserInput;
  where: ClinicPhoneNumberWhereUniqueInput;
};

export type ClinicPhoneNumberCreateOrConnectWithoutSmsNotificationStatusesInput = {
  create: ClinicPhoneNumberCreateWithoutSmsNotificationStatusesInput;
  where: ClinicPhoneNumberWhereUniqueInput;
};

export type ClinicPhoneNumberCreateWithoutCampaignRegistryCampaignInput = {
  capability: ServiceCapability;
  clinic: ClinicCreateNestedOneWithoutClinicPhoneNumberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUser?: Maybe<UserCreateNestedOneWithoutLoaSignedClinicPhoneNumbersInput>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutClinicPhoneNumberInput>;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberCreateWithoutClinicInput = {
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignCreateNestedOneWithoutClinicPhoneNumbersInput>;
  capability: ServiceCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUser?: Maybe<UserCreateNestedOneWithoutLoaSignedClinicPhoneNumbersInput>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutClinicPhoneNumberInput>;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberCreateWithoutLoaSignedByUserInput = {
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignCreateNestedOneWithoutClinicPhoneNumbersInput>;
  capability: ServiceCapability;
  clinic: ClinicCreateNestedOneWithoutClinicPhoneNumberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusCreateNestedManyWithoutClinicPhoneNumberInput>;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberCreateWithoutSmsNotificationStatusesInput = {
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignCreateNestedOneWithoutClinicPhoneNumbersInput>;
  capability: ServiceCapability;
  clinic: ClinicCreateNestedOneWithoutClinicPhoneNumberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUser?: Maybe<UserCreateNestedOneWithoutLoaSignedClinicPhoneNumbersInput>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberGroupByOutputType = {
  __typename?: 'ClinicPhoneNumberGroupByOutputType';
  _count?: Maybe<ClinicPhoneNumberCountAggregateOutputType>;
  _max?: Maybe<ClinicPhoneNumberMaxAggregateOutputType>;
  _min?: Maybe<ClinicPhoneNumberMinAggregateOutputType>;
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability: ServiceCapability;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  status: PhoneNumberStatus;
  updatedAt: Scalars['DateTime'];
};

export type ClinicPhoneNumberListRelationFilter = {
  every?: Maybe<ClinicPhoneNumberWhereInput>;
  none?: Maybe<ClinicPhoneNumberWhereInput>;
  some?: Maybe<ClinicPhoneNumberWhereInput>;
};

export type ClinicPhoneNumberMaxAggregateOutputType = {
  __typename?: 'ClinicPhoneNumberMaxAggregateOutputType';
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability?: Maybe<ServiceCapability>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberMaxOrderByAggregateInput = {
  campaignRegistryCampaignId?: Maybe<SortOrder>;
  capability?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomingCarrier?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  isTestSmsDelivered?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  loaSignedAt?: Maybe<SortOrder>;
  loaSignedByUserId?: Maybe<SortOrder>;
  loaUrl?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  portingOrderId?: Maybe<SortOrder>;
  portingOrderStatus?: Maybe<SortOrder>;
  portingStartAt?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPhoneNumberMinAggregateOutputType = {
  __typename?: 'ClinicPhoneNumberMinAggregateOutputType';
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability?: Maybe<ServiceCapability>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberMinOrderByAggregateInput = {
  campaignRegistryCampaignId?: Maybe<SortOrder>;
  capability?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomingCarrier?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  isTestSmsDelivered?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  loaSignedAt?: Maybe<SortOrder>;
  loaSignedByUserId?: Maybe<SortOrder>;
  loaUrl?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  portingOrderId?: Maybe<SortOrder>;
  portingOrderStatus?: Maybe<SortOrder>;
  portingStartAt?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPhoneNumberNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicPhoneNumberWhereInput>>;
  NOT?: Maybe<Array<ClinicPhoneNumberWhereInput>>;
  OR?: Maybe<Array<ClinicPhoneNumberWhereInput>>;
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignNullableScalarRelationFilter>;
  campaignRegistryCampaignId?: Maybe<StringNullableFilter>;
  capability?: Maybe<EnumServiceCapabilityFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  incomingCarrier?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isPrimary?: Maybe<BoolFilter>;
  isTestSmsDelivered?: Maybe<BoolFilter>;
  isVerified?: Maybe<BoolFilter>;
  loaSignedAt?: Maybe<DateTimeNullableFilter>;
  loaSignedByUser?: Maybe<UserNullableScalarRelationFilter>;
  loaSignedByUserId?: Maybe<StringNullableFilter>;
  loaUrl?: Maybe<StringNullableFilter>;
  number?: Maybe<StringFilter>;
  portingOrderId?: Maybe<StringNullableFilter>;
  portingOrderStatus?: Maybe<StringNullableFilter>;
  portingStartAt?: Maybe<DateTimeNullableFilter>;
  provider?: Maybe<EnumServiceProviderFilter>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusListRelationFilter>;
  status?: Maybe<EnumPhoneNumberStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPhoneNumberOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPhoneNumberOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPhoneNumberOrderByRelevanceInput>;
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignOrderByWithRelationInput>;
  campaignRegistryCampaignId?: Maybe<SortOrder>;
  capability?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomingCarrier?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  isTestSmsDelivered?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  loaSignedAt?: Maybe<SortOrder>;
  loaSignedByUser?: Maybe<UserOrderByWithRelationInput>;
  loaSignedByUserId?: Maybe<SortOrder>;
  loaUrl?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  portingOrderId?: Maybe<SortOrder>;
  portingOrderStatus?: Maybe<SortOrder>;
  portingStartAt?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPhoneNumberOrderByRelevanceFieldEnum {
  CampaignRegistryCampaignId = 'campaignRegistryCampaignId',
  ClinicId = 'clinicId',
  Id = 'id',
  IncomingCarrier = 'incomingCarrier',
  LoaSignedByUserId = 'loaSignedByUserId',
  LoaUrl = 'loaUrl',
  Number = 'number',
  PortingOrderId = 'portingOrderId',
  PortingOrderStatus = 'portingOrderStatus'
}

export type ClinicPhoneNumberOrderByRelevanceInput = {
  fields: Array<ClinicPhoneNumberOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPhoneNumberOrderByWithAggregationInput = {
  _count?: Maybe<ClinicPhoneNumberCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPhoneNumberMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPhoneNumberMinOrderByAggregateInput>;
  campaignRegistryCampaignId?: Maybe<SortOrder>;
  capability?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomingCarrier?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  isTestSmsDelivered?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  loaSignedAt?: Maybe<SortOrder>;
  loaSignedByUserId?: Maybe<SortOrder>;
  loaUrl?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  portingOrderId?: Maybe<SortOrder>;
  portingOrderStatus?: Maybe<SortOrder>;
  portingStartAt?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPhoneNumberOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPhoneNumberOrderByRelevanceInput>;
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignOrderByWithRelationInput>;
  campaignRegistryCampaignId?: Maybe<SortOrder>;
  capability?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomingCarrier?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  isTestSmsDelivered?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  loaSignedAt?: Maybe<SortOrder>;
  loaSignedByUser?: Maybe<UserOrderByWithRelationInput>;
  loaSignedByUserId?: Maybe<SortOrder>;
  loaUrl?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  portingOrderId?: Maybe<SortOrder>;
  portingOrderStatus?: Maybe<SortOrder>;
  portingStartAt?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPhoneNumberOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicPhoneNumberOrderByRelevanceInput>;
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignOrderByWithRelationInput>;
  campaignRegistryCampaignId?: Maybe<SortOrder>;
  capability?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  incomingCarrier?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPrimary?: Maybe<SortOrder>;
  isTestSmsDelivered?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  loaSignedAt?: Maybe<SortOrder>;
  loaSignedByUser?: Maybe<UserOrderByWithRelationInput>;
  loaSignedByUserId?: Maybe<SortOrder>;
  loaUrl?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  portingOrderId?: Maybe<SortOrder>;
  portingOrderStatus?: Maybe<SortOrder>;
  portingStartAt?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPhoneNumberScalarFieldEnum {
  CampaignRegistryCampaignId = 'campaignRegistryCampaignId',
  Capability = 'capability',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IncomingCarrier = 'incomingCarrier',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  IsPrimary = 'isPrimary',
  IsTestSmsDelivered = 'isTestSmsDelivered',
  IsVerified = 'isVerified',
  LoaSignedAt = 'loaSignedAt',
  LoaSignedByUserId = 'loaSignedByUserId',
  LoaUrl = 'loaUrl',
  Number = 'number',
  PortingOrderId = 'portingOrderId',
  PortingOrderStatus = 'portingOrderStatus',
  PortingStartAt = 'portingStartAt',
  Provider = 'provider',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type ClinicPhoneNumberScalarWhereInput = {
  AND?: Maybe<Array<ClinicPhoneNumberScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPhoneNumberScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPhoneNumberScalarWhereInput>>;
  campaignRegistryCampaignId?: Maybe<StringNullableFilter>;
  capability?: Maybe<EnumServiceCapabilityFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  incomingCarrier?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isPrimary?: Maybe<BoolFilter>;
  isTestSmsDelivered?: Maybe<BoolFilter>;
  isVerified?: Maybe<BoolFilter>;
  loaSignedAt?: Maybe<DateTimeNullableFilter>;
  loaSignedByUserId?: Maybe<StringNullableFilter>;
  loaUrl?: Maybe<StringNullableFilter>;
  number?: Maybe<StringFilter>;
  portingOrderId?: Maybe<StringNullableFilter>;
  portingOrderStatus?: Maybe<StringNullableFilter>;
  portingStartAt?: Maybe<DateTimeNullableFilter>;
  provider?: Maybe<EnumServiceProviderFilter>;
  status?: Maybe<EnumPhoneNumberStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPhoneNumberScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPhoneNumberScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPhoneNumberScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPhoneNumberScalarWhereWithAggregatesInput>>;
  campaignRegistryCampaignId?: Maybe<StringNullableWithAggregatesFilter>;
  capability?: Maybe<EnumServiceCapabilityWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  incomingCarrier?: Maybe<StringNullableWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  isPrimary?: Maybe<BoolWithAggregatesFilter>;
  isTestSmsDelivered?: Maybe<BoolWithAggregatesFilter>;
  isVerified?: Maybe<BoolWithAggregatesFilter>;
  loaSignedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  loaSignedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  loaUrl?: Maybe<StringNullableWithAggregatesFilter>;
  number?: Maybe<StringWithAggregatesFilter>;
  portingOrderId?: Maybe<StringNullableWithAggregatesFilter>;
  portingOrderStatus?: Maybe<StringNullableWithAggregatesFilter>;
  portingStartAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  provider?: Maybe<EnumServiceProviderWithAggregatesFilter>;
  status?: Maybe<EnumPhoneNumberStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicPhoneNumberSubscription = {
  __typename?: 'ClinicPhoneNumberSubscription';
  mutation: MutationType;
  node: ClinicPhoneNumber;
};

export type ClinicPhoneNumberUncheckedCreateInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability: ServiceCapability;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutClinicPhoneNumberInput>;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedCreateNestedManyWithoutCampaignRegistryCampaignInput = {
  connect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPhoneNumberCreateOrConnectWithoutCampaignRegistryCampaignInput>>;
  create?: Maybe<Array<ClinicPhoneNumberCreateWithoutCampaignRegistryCampaignInput>>;
  createMany?: Maybe<ClinicPhoneNumberCreateManyCampaignRegistryCampaignInputEnvelope>;
};

export type ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPhoneNumberCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPhoneNumberCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPhoneNumberCreateManyClinicInputEnvelope>;
};

export type ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput = {
  connect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPhoneNumberCreateOrConnectWithoutLoaSignedByUserInput>>;
  create?: Maybe<Array<ClinicPhoneNumberCreateWithoutLoaSignedByUserInput>>;
  createMany?: Maybe<ClinicPhoneNumberCreateManyLoaSignedByUserInputEnvelope>;
};

export type ClinicPhoneNumberUncheckedCreateWithoutCampaignRegistryCampaignInput = {
  capability: ServiceCapability;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutClinicPhoneNumberInput>;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedCreateWithoutClinicInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability: ServiceCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutClinicPhoneNumberInput>;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedCreateWithoutLoaSignedByUserInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability: ServiceCapability;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusUncheckedCreateNestedManyWithoutClinicPhoneNumberInput>;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedCreateWithoutSmsNotificationStatusesInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability: ServiceCapability;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  status: PhoneNumberStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedUpdateInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability?: Maybe<ServiceCapability>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutClinicPhoneNumberNestedInput>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedUpdateManyInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability?: Maybe<ServiceCapability>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedUpdateManyWithoutCampaignRegistryCampaignInput = {
  capability?: Maybe<ServiceCapability>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedUpdateManyWithoutCampaignRegistryCampaignNestedInput = {
  connect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPhoneNumberCreateOrConnectWithoutCampaignRegistryCampaignInput>>;
  create?: Maybe<Array<ClinicPhoneNumberCreateWithoutCampaignRegistryCampaignInput>>;
  createMany?: Maybe<ClinicPhoneNumberCreateManyCampaignRegistryCampaignInputEnvelope>;
  delete?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPhoneNumberUpdateWithWhereUniqueWithoutCampaignRegistryCampaignInput>>;
  updateMany?: Maybe<Array<ClinicPhoneNumberUpdateManyWithWhereWithoutCampaignRegistryCampaignInput>>;
  upsert?: Maybe<Array<ClinicPhoneNumberUpsertWithWhereUniqueWithoutCampaignRegistryCampaignInput>>;
};

export type ClinicPhoneNumberUncheckedUpdateManyWithoutClinicInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability?: Maybe<ServiceCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPhoneNumberCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPhoneNumberCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPhoneNumberCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPhoneNumberUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicPhoneNumberUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicPhoneNumberUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability?: Maybe<ServiceCapability>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput = {
  connect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPhoneNumberCreateOrConnectWithoutLoaSignedByUserInput>>;
  create?: Maybe<Array<ClinicPhoneNumberCreateWithoutLoaSignedByUserInput>>;
  createMany?: Maybe<ClinicPhoneNumberCreateManyLoaSignedByUserInputEnvelope>;
  delete?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPhoneNumberUpdateWithWhereUniqueWithoutLoaSignedByUserInput>>;
  updateMany?: Maybe<Array<ClinicPhoneNumberUpdateManyWithWhereWithoutLoaSignedByUserInput>>;
  upsert?: Maybe<Array<ClinicPhoneNumberUpsertWithWhereUniqueWithoutLoaSignedByUserInput>>;
};

export type ClinicPhoneNumberUncheckedUpdateWithoutCampaignRegistryCampaignInput = {
  capability?: Maybe<ServiceCapability>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutClinicPhoneNumberNestedInput>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedUpdateWithoutClinicInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability?: Maybe<ServiceCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutClinicPhoneNumberNestedInput>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedUpdateWithoutLoaSignedByUserInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability?: Maybe<ServiceCapability>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusUncheckedUpdateManyWithoutClinicPhoneNumberNestedInput>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUncheckedUpdateWithoutSmsNotificationStatusesInput = {
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability?: Maybe<ServiceCapability>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUpdateInput = {
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignUpdateOneWithoutClinicPhoneNumbersNestedInput>;
  capability?: Maybe<ServiceCapability>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicPhoneNumberNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUser?: Maybe<UserUpdateOneWithoutLoaSignedClinicPhoneNumbersNestedInput>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutClinicPhoneNumberNestedInput>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUpdateManyMutationInput = {
  capability?: Maybe<ServiceCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUpdateManyWithWhereWithoutCampaignRegistryCampaignInput = {
  data: ClinicPhoneNumberUpdateManyMutationInput;
  where: ClinicPhoneNumberScalarWhereInput;
};

export type ClinicPhoneNumberUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicPhoneNumberUpdateManyMutationInput;
  where: ClinicPhoneNumberScalarWhereInput;
};

export type ClinicPhoneNumberUpdateManyWithWhereWithoutLoaSignedByUserInput = {
  data: ClinicPhoneNumberUpdateManyMutationInput;
  where: ClinicPhoneNumberScalarWhereInput;
};

export type ClinicPhoneNumberUpdateManyWithoutCampaignRegistryCampaignNestedInput = {
  connect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPhoneNumberCreateOrConnectWithoutCampaignRegistryCampaignInput>>;
  create?: Maybe<Array<ClinicPhoneNumberCreateWithoutCampaignRegistryCampaignInput>>;
  createMany?: Maybe<ClinicPhoneNumberCreateManyCampaignRegistryCampaignInputEnvelope>;
  delete?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPhoneNumberUpdateWithWhereUniqueWithoutCampaignRegistryCampaignInput>>;
  updateMany?: Maybe<Array<ClinicPhoneNumberUpdateManyWithWhereWithoutCampaignRegistryCampaignInput>>;
  upsert?: Maybe<Array<ClinicPhoneNumberUpsertWithWhereUniqueWithoutCampaignRegistryCampaignInput>>;
};

export type ClinicPhoneNumberUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPhoneNumberCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPhoneNumberCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPhoneNumberCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPhoneNumberUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicPhoneNumberUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicPhoneNumberUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput = {
  connect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPhoneNumberCreateOrConnectWithoutLoaSignedByUserInput>>;
  create?: Maybe<Array<ClinicPhoneNumberCreateWithoutLoaSignedByUserInput>>;
  createMany?: Maybe<ClinicPhoneNumberCreateManyLoaSignedByUserInputEnvelope>;
  delete?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPhoneNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPhoneNumberWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPhoneNumberUpdateWithWhereUniqueWithoutLoaSignedByUserInput>>;
  updateMany?: Maybe<Array<ClinicPhoneNumberUpdateManyWithWhereWithoutLoaSignedByUserInput>>;
  upsert?: Maybe<Array<ClinicPhoneNumberUpsertWithWhereUniqueWithoutLoaSignedByUserInput>>;
};

export type ClinicPhoneNumberUpdateOneWithoutSmsNotificationStatusesNestedInput = {
  connect?: Maybe<ClinicPhoneNumberWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPhoneNumberCreateOrConnectWithoutSmsNotificationStatusesInput>;
  create?: Maybe<ClinicPhoneNumberCreateWithoutSmsNotificationStatusesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPhoneNumberUpdateToOneWithWhereWithoutSmsNotificationStatusesInput>;
  upsert?: Maybe<ClinicPhoneNumberUpsertWithoutSmsNotificationStatusesInput>;
};

export type ClinicPhoneNumberUpdateToOneWithWhereWithoutSmsNotificationStatusesInput = {
  data: ClinicPhoneNumberUpdateWithoutSmsNotificationStatusesInput;
  where?: Maybe<ClinicPhoneNumberWhereInput>;
};

export type ClinicPhoneNumberUpdateWithWhereUniqueWithoutCampaignRegistryCampaignInput = {
  data: ClinicPhoneNumberUpdateWithoutCampaignRegistryCampaignInput;
  where: ClinicPhoneNumberWhereUniqueInput;
};

export type ClinicPhoneNumberUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicPhoneNumberUpdateWithoutClinicInput;
  where: ClinicPhoneNumberWhereUniqueInput;
};

export type ClinicPhoneNumberUpdateWithWhereUniqueWithoutLoaSignedByUserInput = {
  data: ClinicPhoneNumberUpdateWithoutLoaSignedByUserInput;
  where: ClinicPhoneNumberWhereUniqueInput;
};

export type ClinicPhoneNumberUpdateWithoutCampaignRegistryCampaignInput = {
  capability?: Maybe<ServiceCapability>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicPhoneNumberNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUser?: Maybe<UserUpdateOneWithoutLoaSignedClinicPhoneNumbersNestedInput>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutClinicPhoneNumberNestedInput>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUpdateWithoutClinicInput = {
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignUpdateOneWithoutClinicPhoneNumbersNestedInput>;
  capability?: Maybe<ServiceCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUser?: Maybe<UserUpdateOneWithoutLoaSignedClinicPhoneNumbersNestedInput>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutClinicPhoneNumberNestedInput>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUpdateWithoutLoaSignedByUserInput = {
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignUpdateOneWithoutClinicPhoneNumbersNestedInput>;
  capability?: Maybe<ServiceCapability>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicPhoneNumberNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusUpdateManyWithoutClinicPhoneNumberNestedInput>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUpdateWithoutSmsNotificationStatusesInput = {
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignUpdateOneWithoutClinicPhoneNumbersNestedInput>;
  capability?: Maybe<ServiceCapability>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicPhoneNumberNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isTestSmsDelivered?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUser?: Maybe<UserUpdateOneWithoutLoaSignedClinicPhoneNumbersNestedInput>;
  loaUrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ServiceProvider>;
  status?: Maybe<PhoneNumberStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPhoneNumberUpsertWithWhereUniqueWithoutCampaignRegistryCampaignInput = {
  create: ClinicPhoneNumberCreateWithoutCampaignRegistryCampaignInput;
  update: ClinicPhoneNumberUpdateWithoutCampaignRegistryCampaignInput;
  where: ClinicPhoneNumberWhereUniqueInput;
};

export type ClinicPhoneNumberUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicPhoneNumberCreateWithoutClinicInput;
  update: ClinicPhoneNumberUpdateWithoutClinicInput;
  where: ClinicPhoneNumberWhereUniqueInput;
};

export type ClinicPhoneNumberUpsertWithWhereUniqueWithoutLoaSignedByUserInput = {
  create: ClinicPhoneNumberCreateWithoutLoaSignedByUserInput;
  update: ClinicPhoneNumberUpdateWithoutLoaSignedByUserInput;
  where: ClinicPhoneNumberWhereUniqueInput;
};

export type ClinicPhoneNumberUpsertWithoutSmsNotificationStatusesInput = {
  create: ClinicPhoneNumberCreateWithoutSmsNotificationStatusesInput;
  update: ClinicPhoneNumberUpdateWithoutSmsNotificationStatusesInput;
  where?: Maybe<ClinicPhoneNumberWhereInput>;
};

export type ClinicPhoneNumberWhereInput = {
  AND?: Maybe<Array<ClinicPhoneNumberWhereInput>>;
  NOT?: Maybe<Array<ClinicPhoneNumberWhereInput>>;
  OR?: Maybe<Array<ClinicPhoneNumberWhereInput>>;
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignNullableScalarRelationFilter>;
  campaignRegistryCampaignId?: Maybe<StringNullableFilter>;
  capability?: Maybe<EnumServiceCapabilityFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  incomingCarrier?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isPrimary?: Maybe<BoolFilter>;
  isTestSmsDelivered?: Maybe<BoolFilter>;
  isVerified?: Maybe<BoolFilter>;
  loaSignedAt?: Maybe<DateTimeNullableFilter>;
  loaSignedByUser?: Maybe<UserNullableScalarRelationFilter>;
  loaSignedByUserId?: Maybe<StringNullableFilter>;
  loaUrl?: Maybe<StringNullableFilter>;
  number?: Maybe<StringFilter>;
  portingOrderId?: Maybe<StringNullableFilter>;
  portingOrderStatus?: Maybe<StringNullableFilter>;
  portingStartAt?: Maybe<DateTimeNullableFilter>;
  provider?: Maybe<EnumServiceProviderFilter>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusListRelationFilter>;
  status?: Maybe<EnumPhoneNumberStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPhoneNumberWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPhoneNumberWhereInput>>;
  NOT?: Maybe<Array<ClinicPhoneNumberWhereInput>>;
  OR?: Maybe<Array<ClinicPhoneNumberWhereInput>>;
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaignNullableScalarRelationFilter>;
  campaignRegistryCampaignId?: Maybe<StringNullableFilter>;
  capability?: Maybe<EnumServiceCapabilityFilter>;
  capabilityAndNumberAndProvider?: Maybe<ClinicPhoneNumberCapabilityAndNumberAndProviderCompoundUniqueInput>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  incomingCarrier?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isPrimary?: Maybe<BoolFilter>;
  isTestSmsDelivered?: Maybe<BoolFilter>;
  isVerified?: Maybe<BoolFilter>;
  loaSignedAt?: Maybe<DateTimeNullableFilter>;
  loaSignedByUser?: Maybe<UserNullableScalarRelationFilter>;
  loaSignedByUserId?: Maybe<StringNullableFilter>;
  loaUrl?: Maybe<StringNullableFilter>;
  number?: Maybe<StringFilter>;
  portingOrderId?: Maybe<StringNullableFilter>;
  portingOrderStatus?: Maybe<StringNullableFilter>;
  portingStartAt?: Maybe<DateTimeNullableFilter>;
  provider?: Maybe<EnumServiceProviderFilter>;
  smsNotificationStatuses?: Maybe<SmsNotificationStatusListRelationFilter>;
  status?: Maybe<EnumPhoneNumberStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPimsIntegration = {
  __typename?: 'ClinicPimsIntegration';
  LabPanel: Array<LabPanel>;
  LabResult: Array<LabResult>;
  MedicalHistory: Array<MedicalHistory>;
  SyncVetService: Array<SyncVetService>;
  _count: ClinicPimsIntegrationCountOutputType;
  appointmentTypes: Array<AppointmentType>;
  appointments: Array<Appointment>;
  availabilities: Array<AppointmentAvailability>;
  bitwerx?: Maybe<BitwerxIntegration>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations: Array<BitwerxPaymentWritebackConfiguration>;
  breeds: Array<Breed>;
  capabilities: Array<ClinicPimsIntegrationCapability>;
  capabilityHistoryEntries: Array<ClinicPimsIntegrationCapabilityHistoryEntry>;
  clientConnect?: Maybe<ClientConnectIntegration>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  colors: Array<Color>;
  createdAt: Scalars['DateTime'];
  customFieldDefinitions: Array<CustomFieldDefinition>;
  datapoint?: Maybe<DataPointIntegration>;
  datapointId?: Maybe<Scalars['String']>;
  employees: Array<ClinicEmployee>;
  ezyvet?: Maybe<EzyVetIntegration>;
  ezyvetId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instinct?: Maybe<InstinctIntegration>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry: Array<IntegrationOutageHistoryEntry>;
  invoices: Array<Invoice>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegration>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents: Array<ClinicPetParent>;
  pets: Array<ClinicPet>;
  pimsInvoiceLineItems: Array<PimsInvoiceLineItem>;
  pimsInvoices: Array<PimsInvoice>;
  pimsPaymentTypes: Array<PimsPaymentType>;
  ppc?: Maybe<PpcIntegration>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions: Array<Prescription>;
  rooms: Array<ClinicRoom>;
  serviceCategories: Array<ServiceCategory>;
  serviceReminders: Array<ServiceReminder>;
  services: Array<Service>;
  sexes: Array<Sex>;
  species: Array<Species>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency: PimsSyncFrequency;
  syncvet?: Maybe<SyncVetIntegration>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt: Scalars['DateTime'];
  vaccinations: Array<Vaccination>;
  vetAvailabilities: Array<VetAvailability>;
  vetdata?: Maybe<VetDataIntegration>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegration>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetter?: Maybe<VetterIntegration>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration: Scalars['Json'];
  writebackLogEntries: Array<PimsWritebackLogEntry>;
};


export type ClinicPimsIntegrationLabPanelArgs = {
  cursor?: Maybe<LabPanelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LabPanelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LabPanelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabPanelWhereInput>;
};


export type ClinicPimsIntegrationLabResultArgs = {
  cursor?: Maybe<LabResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LabResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LabResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabResultWhereInput>;
};


export type ClinicPimsIntegrationMedicalHistoryArgs = {
  cursor?: Maybe<MedicalHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MedicalHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MedicalHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MedicalHistoryWhereInput>;
};


export type ClinicPimsIntegrationSyncVetServiceArgs = {
  cursor?: Maybe<SyncVetServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SyncVetServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SyncVetServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SyncVetServiceWhereInput>;
};


export type ClinicPimsIntegrationAppointmentTypesArgs = {
  cursor?: Maybe<AppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type ClinicPimsIntegrationAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type ClinicPimsIntegrationAvailabilitiesArgs = {
  cursor?: Maybe<AppointmentAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentAvailabilityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentAvailabilityWhereInput>;
};


export type ClinicPimsIntegrationBitwerxArgs = {
  where?: Maybe<BitwerxIntegrationWhereInput>;
};


export type ClinicPimsIntegrationBitwerxPaymentWritebackConfigurationsArgs = {
  cursor?: Maybe<BitwerxPaymentWritebackConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
};


export type ClinicPimsIntegrationBreedsArgs = {
  cursor?: Maybe<BreedWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BreedScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BreedOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BreedWhereInput>;
};


export type ClinicPimsIntegrationCapabilitiesArgs = {
  cursor?: Maybe<ClinicPimsIntegrationCapabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationCapabilityWhereInput>;
};


export type ClinicPimsIntegrationCapabilityHistoryEntriesArgs = {
  cursor?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityHistoryEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>;
};


export type ClinicPimsIntegrationClientConnectArgs = {
  where?: Maybe<ClientConnectIntegrationWhereInput>;
};


export type ClinicPimsIntegrationClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type ClinicPimsIntegrationColorsArgs = {
  cursor?: Maybe<ColorWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ColorScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ColorOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ColorWhereInput>;
};


export type ClinicPimsIntegrationCustomFieldDefinitionsArgs = {
  cursor?: Maybe<CustomFieldDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CustomFieldDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CustomFieldDefinitionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};


export type ClinicPimsIntegrationDatapointArgs = {
  where?: Maybe<DataPointIntegrationWhereInput>;
};


export type ClinicPimsIntegrationEmployeesArgs = {
  cursor?: Maybe<ClinicEmployeeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type ClinicPimsIntegrationEzyvetArgs = {
  where?: Maybe<EzyVetIntegrationWhereInput>;
};


export type ClinicPimsIntegrationInstinctArgs = {
  where?: Maybe<InstinctIntegrationWhereInput>;
};


export type ClinicPimsIntegrationIntegrationOutageHistoryEntryArgs = {
  cursor?: Maybe<IntegrationOutageHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<IntegrationOutageHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<IntegrationOutageHistoryEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<IntegrationOutageHistoryEntryWhereInput>;
};


export type ClinicPimsIntegrationInvoicesArgs = {
  cursor?: Maybe<InvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceWhereInput>;
};


export type ClinicPimsIntegrationNeoArgs = {
  where?: Maybe<NeoIntegrationWhereInput>;
};


export type ClinicPimsIntegrationPetParentsArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type ClinicPimsIntegrationPetsArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type ClinicPimsIntegrationPimsInvoiceLineItemsArgs = {
  cursor?: Maybe<PimsInvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsInvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsInvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsInvoiceLineItemWhereInput>;
};


export type ClinicPimsIntegrationPimsInvoicesArgs = {
  cursor?: Maybe<PimsInvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsInvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsInvoiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsInvoiceWhereInput>;
};


export type ClinicPimsIntegrationPimsPaymentTypesArgs = {
  cursor?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsPaymentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsPaymentTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};


export type ClinicPimsIntegrationPpcArgs = {
  where?: Maybe<PpcIntegrationWhereInput>;
};


export type ClinicPimsIntegrationPrescriptionsArgs = {
  cursor?: Maybe<PrescriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PrescriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PrescriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PrescriptionWhereInput>;
};


export type ClinicPimsIntegrationRoomsArgs = {
  cursor?: Maybe<ClinicRoomWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicRoomScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicRoomOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicRoomWhereInput>;
};


export type ClinicPimsIntegrationServiceCategoriesArgs = {
  cursor?: Maybe<ServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceCategoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceCategoryWhereInput>;
};


export type ClinicPimsIntegrationServiceRemindersArgs = {
  cursor?: Maybe<ServiceReminderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderWhereInput>;
};


export type ClinicPimsIntegrationServicesArgs = {
  cursor?: Maybe<ServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceWhereInput>;
};


export type ClinicPimsIntegrationSexesArgs = {
  cursor?: Maybe<SexWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SexScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SexOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SexWhereInput>;
};


export type ClinicPimsIntegrationSpeciesArgs = {
  cursor?: Maybe<SpeciesWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SpeciesScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SpeciesOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SpeciesWhereInput>;
};


export type ClinicPimsIntegrationSyncvetArgs = {
  where?: Maybe<SyncVetIntegrationWhereInput>;
};


export type ClinicPimsIntegrationVaccinationsArgs = {
  cursor?: Maybe<VaccinationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VaccinationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VaccinationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VaccinationWhereInput>;
};


export type ClinicPimsIntegrationVetAvailabilitiesArgs = {
  cursor?: Maybe<VetAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityWhereInput>;
};


export type ClinicPimsIntegrationVetdataArgs = {
  where?: Maybe<VetDataIntegrationWhereInput>;
};


export type ClinicPimsIntegrationVetsourcePharmacyArgs = {
  where?: Maybe<VetsourcePharmacyIntegrationWhereInput>;
};


export type ClinicPimsIntegrationVetterArgs = {
  where?: Maybe<VetterIntegrationWhereInput>;
};


export type ClinicPimsIntegrationWritebackLogEntriesArgs = {
  cursor?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsWritebackLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};

export type ClinicPimsIntegrationCapability = {
  __typename?: 'ClinicPimsIntegrationCapability';
  capability: PimsIntegrationCapability;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type ClinicPimsIntegrationCapabilityAvgAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationCapabilityAvgAggregateOutputType';
  syncFrequencyInMinutes?: Maybe<Scalars['Float']>;
};

export type ClinicPimsIntegrationCapabilityAvgOrderByAggregateInput = {
  syncFrequencyInMinutes?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityCountAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationCapabilityCountAggregateOutputType';
  _all: Scalars['Int'];
  capability: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  lastSyncedAt: Scalars['Int'];
  status: Scalars['Int'];
  statusChangedAt: Scalars['Int'];
  statusErrorMessage: Scalars['Int'];
  syncFrequencyInMinutes: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicPimsIntegrationCapabilityCountOrderByAggregateInput = {
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityCreateInput = {
  capability: PimsIntegrationCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutCapabilitiesInput;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityCreateManyInput = {
  capability: PimsIntegrationCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityCreateManyIntegrationInput = {
  capability: PimsIntegrationCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityCreateManyIntegrationInputEnvelope = {
  data: Array<ClinicPimsIntegrationCapabilityCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPimsIntegrationCapabilityCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPimsIntegrationCapabilityCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPimsIntegrationCapabilityCreateManyIntegrationInputEnvelope>;
};

export type ClinicPimsIntegrationCapabilityCreateOrConnectWithoutIntegrationInput = {
  create: ClinicPimsIntegrationCapabilityCreateWithoutIntegrationInput;
  where: ClinicPimsIntegrationCapabilityWhereUniqueInput;
};

export type ClinicPimsIntegrationCapabilityCreateWithoutIntegrationInput = {
  capability: PimsIntegrationCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityGroupByOutputType = {
  __typename?: 'ClinicPimsIntegrationCapabilityGroupByOutputType';
  _avg?: Maybe<ClinicPimsIntegrationCapabilityAvgAggregateOutputType>;
  _count?: Maybe<ClinicPimsIntegrationCapabilityCountAggregateOutputType>;
  _max?: Maybe<ClinicPimsIntegrationCapabilityMaxAggregateOutputType>;
  _min?: Maybe<ClinicPimsIntegrationCapabilityMinAggregateOutputType>;
  _sum?: Maybe<ClinicPimsIntegrationCapabilitySumAggregateOutputType>;
  capability: PimsIntegrationCapability;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type ClinicPimsIntegrationCapabilityHistoryEntry = {
  __typename?: 'ClinicPimsIntegrationCapabilityHistoryEntry';
  capability: PimsIntegrationCapability;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  recordsSync: Scalars['Int'];
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryAvgAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationCapabilityHistoryEntryAvgAggregateOutputType';
  recordsSync?: Maybe<Scalars['Float']>;
  syncDuration?: Maybe<Scalars['Float']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryAvgOrderByAggregateInput = {
  recordsSync?: Maybe<SortOrder>;
  syncDuration?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryCountAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationCapabilityHistoryEntryCountAggregateOutputType';
  _all: Scalars['Int'];
  capability: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  recordsSync: Scalars['Int'];
  status: Scalars['Int'];
  statusMessage: Scalars['Int'];
  syncDuration: Scalars['Int'];
};

export type ClinicPimsIntegrationCapabilityHistoryEntryCountOrderByAggregateInput = {
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  recordsSync?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  syncDuration?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryCreateInput = {
  capability: PimsIntegrationCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutCapabilityHistoryEntriesInput;
  recordsSync: Scalars['Int'];
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryCreateManyInput = {
  capability: PimsIntegrationCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  recordsSync: Scalars['Int'];
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryCreateManyIntegrationInput = {
  capability: PimsIntegrationCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  recordsSync: Scalars['Int'];
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryCreateManyIntegrationInputEnvelope = {
  data: Array<ClinicPimsIntegrationCapabilityHistoryEntryCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateManyIntegrationInputEnvelope>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryCreateOrConnectWithoutIntegrationInput = {
  create: ClinicPimsIntegrationCapabilityHistoryEntryCreateWithoutIntegrationInput;
  where: ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryCreateWithoutIntegrationInput = {
  capability: PimsIntegrationCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  recordsSync: Scalars['Int'];
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryGroupByOutputType = {
  __typename?: 'ClinicPimsIntegrationCapabilityHistoryEntryGroupByOutputType';
  _avg?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryAvgAggregateOutputType>;
  _count?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCountAggregateOutputType>;
  _max?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryMaxAggregateOutputType>;
  _min?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryMinAggregateOutputType>;
  _sum?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntrySumAggregateOutputType>;
  capability: PimsIntegrationCapability;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationId: Scalars['String'];
  recordsSync: Scalars['Int'];
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryListRelationFilter = {
  every?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>;
  none?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>;
  some?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryMaxAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationCapabilityHistoryEntryMaxAggregateOutputType';
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  recordsSync?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryMaxOrderByAggregateInput = {
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  recordsSync?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  syncDuration?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryMinAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationCapabilityHistoryEntryMinAggregateOutputType';
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  recordsSync?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryMinOrderByAggregateInput = {
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  recordsSync?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  syncDuration?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryOrderByRelevanceInput>;
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  recordsSync?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  syncDuration?: Maybe<SortOrder>;
};

export enum ClinicPimsIntegrationCapabilityHistoryEntryOrderByRelevanceFieldEnum {
  Id = 'id',
  IntegrationId = 'integrationId',
  Status = 'status',
  StatusMessage = 'statusMessage'
}

export type ClinicPimsIntegrationCapabilityHistoryEntryOrderByRelevanceInput = {
  fields: Array<ClinicPimsIntegrationCapabilityHistoryEntryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryOrderByWithAggregationInput = {
  _avg?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryAvgOrderByAggregateInput>;
  _count?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryMinOrderByAggregateInput>;
  _sum?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntrySumOrderByAggregateInput>;
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  recordsSync?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  syncDuration?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryOrderByRelevanceInput>;
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  recordsSync?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  syncDuration?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryOrderByRelevanceInput>;
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  recordsSync?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  syncDuration?: Maybe<SortOrder>;
};

export enum ClinicPimsIntegrationCapabilityHistoryEntryScalarFieldEnum {
  Capability = 'capability',
  CreatedAt = 'createdAt',
  Id = 'id',
  IntegrationId = 'integrationId',
  RecordsSync = 'recordsSync',
  Status = 'status',
  StatusMessage = 'statusMessage',
  SyncDuration = 'syncDuration'
}

export type ClinicPimsIntegrationCapabilityHistoryEntryScalarWhereInput = {
  AND?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryScalarWhereInput>>;
  capability?: Maybe<EnumPimsIntegrationCapabilityFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  recordsSync?: Maybe<IntFilter>;
  status?: Maybe<StringFilter>;
  statusMessage?: Maybe<StringNullableFilter>;
  syncDuration?: Maybe<IntNullableFilter>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryScalarWhereWithAggregatesInput>>;
  capability?: Maybe<EnumPimsIntegrationCapabilityWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  recordsSync?: Maybe<IntWithAggregatesFilter>;
  status?: Maybe<StringWithAggregatesFilter>;
  statusMessage?: Maybe<StringNullableWithAggregatesFilter>;
  syncDuration?: Maybe<IntNullableWithAggregatesFilter>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntrySumAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationCapabilityHistoryEntrySumAggregateOutputType';
  recordsSync?: Maybe<Scalars['Int']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntrySumOrderByAggregateInput = {
  recordsSync?: Maybe<SortOrder>;
  syncDuration?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateInput = {
  capability: PimsIntegrationCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  recordsSync: Scalars['Int'];
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateManyIntegrationInputEnvelope>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateWithoutIntegrationInput = {
  capability: PimsIntegrationCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  recordsSync: Scalars['Int'];
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  recordsSync?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  recordsSync?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  recordsSync?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateWithoutIntegrationInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  recordsSync?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUpdateInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutCapabilityHistoryEntriesNestedInput>;
  recordsSync?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyMutationInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  recordsSync?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithWhereWithoutIntegrationInput = {
  data: ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyMutationInput;
  where: ClinicPimsIntegrationCapabilityHistoryEntryScalarWhereInput;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: ClinicPimsIntegrationCapabilityHistoryEntryUpdateWithoutIntegrationInput;
  where: ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUpdateWithoutIntegrationInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  recordsSync?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: ClinicPimsIntegrationCapabilityHistoryEntryCreateWithoutIntegrationInput;
  update: ClinicPimsIntegrationCapabilityHistoryEntryUpdateWithoutIntegrationInput;
  where: ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryWhereInput = {
  AND?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>>;
  NOT?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>>;
  capability?: Maybe<EnumPimsIntegrationCapabilityFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  recordsSync?: Maybe<IntFilter>;
  status?: Maybe<StringFilter>;
  statusMessage?: Maybe<StringNullableFilter>;
  syncDuration?: Maybe<IntNullableFilter>;
};

export type ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>>;
  NOT?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>>;
  capability?: Maybe<EnumPimsIntegrationCapabilityFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  recordsSync?: Maybe<IntFilter>;
  status?: Maybe<StringFilter>;
  statusMessage?: Maybe<StringNullableFilter>;
  syncDuration?: Maybe<IntNullableFilter>;
};

export type ClinicPimsIntegrationCapabilityIntegrationIdCapabilityCompoundUniqueInput = {
  capability: PimsIntegrationCapability;
  integrationId: Scalars['String'];
};

export type ClinicPimsIntegrationCapabilityListRelationFilter = {
  every?: Maybe<ClinicPimsIntegrationCapabilityWhereInput>;
  none?: Maybe<ClinicPimsIntegrationCapabilityWhereInput>;
  some?: Maybe<ClinicPimsIntegrationCapabilityWhereInput>;
};

export type ClinicPimsIntegrationCapabilityMaxAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationCapabilityMaxAggregateOutputType';
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityMaxOrderByAggregateInput = {
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityMinAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationCapabilityMinAggregateOutputType';
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityMinOrderByAggregateInput = {
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPimsIntegrationCapabilityOrderByRelevanceInput>;
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPimsIntegrationCapabilityOrderByRelevanceFieldEnum {
  Id = 'id',
  IntegrationId = 'integrationId',
  StatusErrorMessage = 'statusErrorMessage'
}

export type ClinicPimsIntegrationCapabilityOrderByRelevanceInput = {
  fields: Array<ClinicPimsIntegrationCapabilityOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPimsIntegrationCapabilityOrderByWithAggregationInput = {
  _avg?: Maybe<ClinicPimsIntegrationCapabilityAvgOrderByAggregateInput>;
  _count?: Maybe<ClinicPimsIntegrationCapabilityCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPimsIntegrationCapabilityMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPimsIntegrationCapabilityMinOrderByAggregateInput>;
  _sum?: Maybe<ClinicPimsIntegrationCapabilitySumOrderByAggregateInput>;
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPimsIntegrationCapabilityOrderByRelevanceInput>;
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicPimsIntegrationCapabilityOrderByRelevanceInput>;
  capability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPimsIntegrationCapabilityScalarFieldEnum {
  Capability = 'capability',
  CreatedAt = 'createdAt',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  LastSyncedAt = 'lastSyncedAt',
  Status = 'status',
  StatusChangedAt = 'statusChangedAt',
  StatusErrorMessage = 'statusErrorMessage',
  SyncFrequencyInMinutes = 'syncFrequencyInMinutes',
  UpdatedAt = 'updatedAt'
}

export type ClinicPimsIntegrationCapabilityScalarWhereInput = {
  AND?: Maybe<Array<ClinicPimsIntegrationCapabilityScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPimsIntegrationCapabilityScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationCapabilityScalarWhereInput>>;
  capability?: Maybe<EnumPimsIntegrationCapabilityFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumPimsSyncStatusNullableFilter>;
  statusChangedAt?: Maybe<DateTimeNullableFilter>;
  statusErrorMessage?: Maybe<StringNullableFilter>;
  syncFrequencyInMinutes?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPimsIntegrationCapabilityScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPimsIntegrationCapabilityScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPimsIntegrationCapabilityScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationCapabilityScalarWhereWithAggregatesInput>>;
  capability?: Maybe<EnumPimsIntegrationCapabilityWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  status?: Maybe<EnumPimsSyncStatusNullableWithAggregatesFilter>;
  statusChangedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  statusErrorMessage?: Maybe<StringNullableWithAggregatesFilter>;
  syncFrequencyInMinutes?: Maybe<IntNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicPimsIntegrationCapabilitySumAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationCapabilitySumAggregateOutputType';
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
};

export type ClinicPimsIntegrationCapabilitySumOrderByAggregateInput = {
  syncFrequencyInMinutes?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCapabilityUncheckedCreateInput = {
  capability: PimsIntegrationCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPimsIntegrationCapabilityCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPimsIntegrationCapabilityCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPimsIntegrationCapabilityCreateManyIntegrationInputEnvelope>;
};

export type ClinicPimsIntegrationCapabilityUncheckedCreateWithoutIntegrationInput = {
  capability: PimsIntegrationCapability;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityUncheckedUpdateInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityUncheckedUpdateManyInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPimsIntegrationCapabilityCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPimsIntegrationCapabilityCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPimsIntegrationCapabilityCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPimsIntegrationCapabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPimsIntegrationCapabilityUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ClinicPimsIntegrationCapabilityUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ClinicPimsIntegrationCapabilityUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ClinicPimsIntegrationCapabilityUncheckedUpdateWithoutIntegrationInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityUpdateInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutCapabilitiesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityUpdateManyMutationInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityUpdateManyWithWhereWithoutIntegrationInput = {
  data: ClinicPimsIntegrationCapabilityUpdateManyMutationInput;
  where: ClinicPimsIntegrationCapabilityScalarWhereInput;
};

export type ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPimsIntegrationCapabilityCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicPimsIntegrationCapabilityCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicPimsIntegrationCapabilityCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPimsIntegrationCapabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPimsIntegrationCapabilityUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ClinicPimsIntegrationCapabilityUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ClinicPimsIntegrationCapabilityUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ClinicPimsIntegrationCapabilityUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: ClinicPimsIntegrationCapabilityUpdateWithoutIntegrationInput;
  where: ClinicPimsIntegrationCapabilityWhereUniqueInput;
};

export type ClinicPimsIntegrationCapabilityUpdateWithoutIntegrationInput = {
  capability?: Maybe<PimsIntegrationCapability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPimsIntegrationCapabilityUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: ClinicPimsIntegrationCapabilityCreateWithoutIntegrationInput;
  update: ClinicPimsIntegrationCapabilityUpdateWithoutIntegrationInput;
  where: ClinicPimsIntegrationCapabilityWhereUniqueInput;
};

export type ClinicPimsIntegrationCapabilityWhereInput = {
  AND?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereInput>>;
  NOT?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereInput>>;
  capability?: Maybe<EnumPimsIntegrationCapabilityFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumPimsSyncStatusNullableFilter>;
  statusChangedAt?: Maybe<DateTimeNullableFilter>;
  statusErrorMessage?: Maybe<StringNullableFilter>;
  syncFrequencyInMinutes?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPimsIntegrationCapabilityWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereInput>>;
  NOT?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationCapabilityWhereInput>>;
  capability?: Maybe<EnumPimsIntegrationCapabilityFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  integrationId_capability?: Maybe<ClinicPimsIntegrationCapabilityIntegrationIdCapabilityCompoundUniqueInput>;
  isActive?: Maybe<BoolFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumPimsSyncStatusNullableFilter>;
  statusChangedAt?: Maybe<DateTimeNullableFilter>;
  statusErrorMessage?: Maybe<StringNullableFilter>;
  syncFrequencyInMinutes?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPimsIntegrationCountAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  bitwerxId: Scalars['Int'];
  clientConnectId: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  datapointId: Scalars['Int'];
  ezyvetId: Scalars['Int'];
  id: Scalars['Int'];
  instinctId: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  lastBatchSyncedAt: Scalars['Int'];
  lastSyncedAt: Scalars['Int'];
  neoId: Scalars['Int'];
  pauseUntil: Scalars['Int'];
  ppcId: Scalars['Int'];
  status: Scalars['Int'];
  statusChangedAt: Scalars['Int'];
  statusErrorMessage: Scalars['Int'];
  syncFrequency: Scalars['Int'];
  syncvetId: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  vetdataId: Scalars['Int'];
  vetsourcePharmacyId: Scalars['Int'];
  vetterId: Scalars['Int'];
  writebackConfiguration: Scalars['Int'];
};

export type ClinicPimsIntegrationCountOrderByAggregateInput = {
  bitwerxId?: Maybe<SortOrder>;
  clientConnectId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  datapointId?: Maybe<SortOrder>;
  ezyvetId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instinctId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastBatchSyncedAt?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  neoId?: Maybe<SortOrder>;
  pauseUntil?: Maybe<SortOrder>;
  ppcId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequency?: Maybe<SortOrder>;
  syncvetId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetdataId?: Maybe<SortOrder>;
  vetsourcePharmacyId?: Maybe<SortOrder>;
  vetterId?: Maybe<SortOrder>;
  writebackConfiguration?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationCountOutputType = {
  __typename?: 'ClinicPimsIntegrationCountOutputType';
  LabPanel: Scalars['Int'];
  LabResult: Scalars['Int'];
  MedicalHistory: Scalars['Int'];
  SyncVetService: Scalars['Int'];
  appointmentTypes: Scalars['Int'];
  appointments: Scalars['Int'];
  availabilities: Scalars['Int'];
  bitwerxPaymentWritebackConfigurations: Scalars['Int'];
  breeds: Scalars['Int'];
  capabilities: Scalars['Int'];
  capabilityHistoryEntries: Scalars['Int'];
  colors: Scalars['Int'];
  customFieldDefinitions: Scalars['Int'];
  employees: Scalars['Int'];
  integrationOutageHistoryEntry: Scalars['Int'];
  invoices: Scalars['Int'];
  petParents: Scalars['Int'];
  pets: Scalars['Int'];
  pimsInvoiceLineItems: Scalars['Int'];
  pimsInvoices: Scalars['Int'];
  pimsPaymentTypes: Scalars['Int'];
  prescriptions: Scalars['Int'];
  rooms: Scalars['Int'];
  serviceCategories: Scalars['Int'];
  serviceReminders: Scalars['Int'];
  services: Scalars['Int'];
  sexes: Scalars['Int'];
  species: Scalars['Int'];
  vaccinations: Scalars['Int'];
  vetAvailabilities: Scalars['Int'];
  writebackLogEntries: Scalars['Int'];
};

export type ClinicPimsIntegrationCreateInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateManyClinicInput = {
  bitwerxId?: Maybe<Scalars['String']>;
  clientConnectId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  datapointId?: Maybe<Scalars['String']>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  ppcId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
};

export type ClinicPimsIntegrationCreateManyClinicInputEnvelope = {
  data: Array<ClinicPimsIntegrationCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPimsIntegrationCreateManyInput = {
  bitwerxId?: Maybe<Scalars['String']>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  datapointId?: Maybe<Scalars['String']>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  ppcId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
};

export type ClinicPimsIntegrationCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicPimsIntegrationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPimsIntegrationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPimsIntegrationCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPimsIntegrationCreateManyClinicInputEnvelope>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutAppointmentTypesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutAppointmentTypesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutAppointmentTypesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutAppointmentsInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutAppointmentsInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutAvailabilitiesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutAvailabilitiesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutAvailabilitiesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutBitwerxInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutBitwerxInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutBitwerxInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutBitwerxPaymentWritebackConfigurationsInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutBitwerxPaymentWritebackConfigurationsInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutBreedsInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutBreedsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutBreedsInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutCapabilitiesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutCapabilitiesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutCapabilitiesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutCapabilityHistoryEntriesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutCapabilityHistoryEntriesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutCapabilityHistoryEntriesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutClientConnectInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutClientConnectInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutClientConnectInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutColorsInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutColorsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutColorsInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutCustomFieldDefinitionsInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutCustomFieldDefinitionsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutCustomFieldDefinitionsInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutDatapointInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutDatapointInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutDatapointInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutEmployeesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutEmployeesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutEmployeesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutEzyvetInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutEzyvetInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutEzyvetInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutInstinctInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutInstinctInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutInstinctInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutIntegrationOutageHistoryEntryInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutIntegrationOutageHistoryEntryInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutIntegrationOutageHistoryEntryInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutInvoicesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutInvoicesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutInvoicesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutLabPanelInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutLabPanelInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutLabPanelInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutLabResultInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutLabResultInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutLabResultInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutMedicalHistoryInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutMedicalHistoryInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutMedicalHistoryInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutNeoInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutNeoInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutNeoInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutPetParentsInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPetParentsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPetParentsInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutPetsInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPetsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPetsInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutPimsInvoiceLineItemsInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPimsInvoiceLineItemsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPimsInvoiceLineItemsInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutPimsInvoicesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPimsInvoicesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPimsInvoicesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutPimsPaymentTypesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPimsPaymentTypesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPimsPaymentTypesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutPpcInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPpcInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPpcInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutPrescriptionsInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPrescriptionsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPrescriptionsInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutRoomsInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutRoomsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutRoomsInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutServiceCategoriesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutServiceCategoriesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutServiceCategoriesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutServiceRemindersInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutServiceRemindersInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutServiceRemindersInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutServicesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutServicesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutServicesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutSexesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutSexesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutSexesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutSpeciesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutSpeciesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutSpeciesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutSyncVetServiceInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutSyncVetServiceInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutSyncVetServiceInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutSyncvetInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutSyncvetInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutSyncvetInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutVaccinationsInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVaccinationsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVaccinationsInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutVetAvailabilitiesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetAvailabilitiesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetAvailabilitiesInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutVetdataInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetdataInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetdataInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutVetsourcePharmacyInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetsourcePharmacyInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetsourcePharmacyInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutVetterInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetterInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetterInput>;
};

export type ClinicPimsIntegrationCreateNestedOneWithoutWritebackLogEntriesInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutWritebackLogEntriesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutWritebackLogEntriesInput>;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutAppointmentTypesInput = {
  create: ClinicPimsIntegrationCreateWithoutAppointmentTypesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutAppointmentsInput = {
  create: ClinicPimsIntegrationCreateWithoutAppointmentsInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutAvailabilitiesInput = {
  create: ClinicPimsIntegrationCreateWithoutAvailabilitiesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutBitwerxInput = {
  create: ClinicPimsIntegrationCreateWithoutBitwerxInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutBitwerxPaymentWritebackConfigurationsInput = {
  create: ClinicPimsIntegrationCreateWithoutBitwerxPaymentWritebackConfigurationsInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutBreedsInput = {
  create: ClinicPimsIntegrationCreateWithoutBreedsInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutCapabilitiesInput = {
  create: ClinicPimsIntegrationCreateWithoutCapabilitiesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutCapabilityHistoryEntriesInput = {
  create: ClinicPimsIntegrationCreateWithoutCapabilityHistoryEntriesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutClientConnectInput = {
  create: ClinicPimsIntegrationCreateWithoutClientConnectInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutClinicInput = {
  create: ClinicPimsIntegrationCreateWithoutClinicInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutColorsInput = {
  create: ClinicPimsIntegrationCreateWithoutColorsInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutCustomFieldDefinitionsInput = {
  create: ClinicPimsIntegrationCreateWithoutCustomFieldDefinitionsInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutDatapointInput = {
  create: ClinicPimsIntegrationCreateWithoutDatapointInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutEmployeesInput = {
  create: ClinicPimsIntegrationCreateWithoutEmployeesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutEzyvetInput = {
  create: ClinicPimsIntegrationCreateWithoutEzyvetInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutInstinctInput = {
  create: ClinicPimsIntegrationCreateWithoutInstinctInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutIntegrationOutageHistoryEntryInput = {
  create: ClinicPimsIntegrationCreateWithoutIntegrationOutageHistoryEntryInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutInvoicesInput = {
  create: ClinicPimsIntegrationCreateWithoutInvoicesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutLabPanelInput = {
  create: ClinicPimsIntegrationCreateWithoutLabPanelInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutLabResultInput = {
  create: ClinicPimsIntegrationCreateWithoutLabResultInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutMedicalHistoryInput = {
  create: ClinicPimsIntegrationCreateWithoutMedicalHistoryInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutNeoInput = {
  create: ClinicPimsIntegrationCreateWithoutNeoInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutPetParentsInput = {
  create: ClinicPimsIntegrationCreateWithoutPetParentsInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutPetsInput = {
  create: ClinicPimsIntegrationCreateWithoutPetsInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutPimsInvoiceLineItemsInput = {
  create: ClinicPimsIntegrationCreateWithoutPimsInvoiceLineItemsInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutPimsInvoicesInput = {
  create: ClinicPimsIntegrationCreateWithoutPimsInvoicesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutPimsPaymentTypesInput = {
  create: ClinicPimsIntegrationCreateWithoutPimsPaymentTypesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutPpcInput = {
  create: ClinicPimsIntegrationCreateWithoutPpcInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutPrescriptionsInput = {
  create: ClinicPimsIntegrationCreateWithoutPrescriptionsInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutRoomsInput = {
  create: ClinicPimsIntegrationCreateWithoutRoomsInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutServiceCategoriesInput = {
  create: ClinicPimsIntegrationCreateWithoutServiceCategoriesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutServiceRemindersInput = {
  create: ClinicPimsIntegrationCreateWithoutServiceRemindersInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutServicesInput = {
  create: ClinicPimsIntegrationCreateWithoutServicesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutSexesInput = {
  create: ClinicPimsIntegrationCreateWithoutSexesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutSpeciesInput = {
  create: ClinicPimsIntegrationCreateWithoutSpeciesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutSyncVetServiceInput = {
  create: ClinicPimsIntegrationCreateWithoutSyncVetServiceInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutSyncvetInput = {
  create: ClinicPimsIntegrationCreateWithoutSyncvetInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutVaccinationsInput = {
  create: ClinicPimsIntegrationCreateWithoutVaccinationsInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutVetAvailabilitiesInput = {
  create: ClinicPimsIntegrationCreateWithoutVetAvailabilitiesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutVetdataInput = {
  create: ClinicPimsIntegrationCreateWithoutVetdataInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutVetsourcePharmacyInput = {
  create: ClinicPimsIntegrationCreateWithoutVetsourcePharmacyInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutVetterInput = {
  create: ClinicPimsIntegrationCreateWithoutVetterInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateOrConnectWithoutWritebackLogEntriesInput = {
  create: ClinicPimsIntegrationCreateWithoutWritebackLogEntriesInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationCreateWithoutAppointmentTypesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutAppointmentsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutAvailabilitiesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutBitwerxInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutBitwerxPaymentWritebackConfigurationsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutBreedsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutCapabilitiesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutCapabilityHistoryEntriesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutClientConnectInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutClinicInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutColorsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutCustomFieldDefinitionsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutDatapointInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutEmployeesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutEzyvetInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutInstinctInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutIntegrationOutageHistoryEntryInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutInvoicesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutLabPanelInput = {
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutLabResultInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutMedicalHistoryInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutNeoInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutPetParentsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutPetsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutPimsInvoiceLineItemsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutPimsInvoicesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutPimsPaymentTypesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutPpcInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutPrescriptionsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutRoomsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutServiceCategoriesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutServiceRemindersInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutServicesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutSexesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutSpeciesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutSyncVetServiceInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutSyncvetInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutVaccinationsInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutVetAvailabilitiesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutVetdataInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutVetsourcePharmacyInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutVetterInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationCreateWithoutWritebackLogEntriesInput = {
  LabPanel?: Maybe<LabPanelCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutIntegrationInput>;
  bitwerx?: Maybe<BitwerxIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  clientConnect?: Maybe<ClientConnectIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutIntegrationsInput>;
  colors?: Maybe<ColorCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapoint?: Maybe<DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeCreateNestedManyWithoutIntegrationInput>;
  ezyvet?: Maybe<EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeCreateNestedManyWithoutIntegrationInput>;
  ppc?: Maybe<PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityCreateNestedManyWithoutIntegrationInput>;
  vetdata?: Maybe<VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  vetter?: Maybe<VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
};

export type ClinicPimsIntegrationGroupByOutputType = {
  __typename?: 'ClinicPimsIntegrationGroupByOutputType';
  _count?: Maybe<ClinicPimsIntegrationCountAggregateOutputType>;
  _max?: Maybe<ClinicPimsIntegrationMaxAggregateOutputType>;
  _min?: Maybe<ClinicPimsIntegrationMinAggregateOutputType>;
  bitwerxId?: Maybe<Scalars['String']>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  datapointId?: Maybe<Scalars['String']>;
  ezyvetId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instinctId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  ppcId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency: PimsSyncFrequency;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt: Scalars['DateTime'];
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration: Scalars['Json'];
};

export type ClinicPimsIntegrationListRelationFilter = {
  every?: Maybe<ClinicPimsIntegrationWhereInput>;
  none?: Maybe<ClinicPimsIntegrationWhereInput>;
  some?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationMaxAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationMaxAggregateOutputType';
  bitwerxId?: Maybe<Scalars['String']>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  datapointId?: Maybe<Scalars['String']>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  ppcId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
};

export type ClinicPimsIntegrationMaxOrderByAggregateInput = {
  bitwerxId?: Maybe<SortOrder>;
  clientConnectId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  datapointId?: Maybe<SortOrder>;
  ezyvetId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instinctId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastBatchSyncedAt?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  neoId?: Maybe<SortOrder>;
  pauseUntil?: Maybe<SortOrder>;
  ppcId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequency?: Maybe<SortOrder>;
  syncvetId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetdataId?: Maybe<SortOrder>;
  vetsourcePharmacyId?: Maybe<SortOrder>;
  vetterId?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationMinAggregateOutputType = {
  __typename?: 'ClinicPimsIntegrationMinAggregateOutputType';
  bitwerxId?: Maybe<Scalars['String']>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  datapointId?: Maybe<Scalars['String']>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  ppcId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
};

export type ClinicPimsIntegrationMinOrderByAggregateInput = {
  bitwerxId?: Maybe<SortOrder>;
  clientConnectId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  datapointId?: Maybe<SortOrder>;
  ezyvetId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instinctId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastBatchSyncedAt?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  neoId?: Maybe<SortOrder>;
  pauseUntil?: Maybe<SortOrder>;
  ppcId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequency?: Maybe<SortOrder>;
  syncvetId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetdataId?: Maybe<SortOrder>;
  vetsourcePharmacyId?: Maybe<SortOrder>;
  vetterId?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicPimsIntegrationWhereInput>>;
  LabPanel?: Maybe<LabPanelListRelationFilter>;
  LabResult?: Maybe<LabResultListRelationFilter>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ClinicPimsIntegrationWhereInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationWhereInput>>;
  SyncVetService?: Maybe<SyncVetServiceListRelationFilter>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  availabilities?: Maybe<AppointmentAvailabilityListRelationFilter>;
  bitwerx?: Maybe<BitwerxIntegrationNullableScalarRelationFilter>;
  bitwerxId?: Maybe<StringNullableFilter>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  breeds?: Maybe<BreedListRelationFilter>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityListRelationFilter>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryListRelationFilter>;
  clientConnect?: Maybe<ClientConnectIntegrationNullableScalarRelationFilter>;
  clientConnectId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  colors?: Maybe<ColorListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionListRelationFilter>;
  datapoint?: Maybe<DataPointIntegrationNullableScalarRelationFilter>;
  datapointId?: Maybe<StringNullableFilter>;
  employees?: Maybe<ClinicEmployeeListRelationFilter>;
  ezyvet?: Maybe<EzyVetIntegrationNullableScalarRelationFilter>;
  ezyvetId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  instinct?: Maybe<InstinctIntegrationNullableScalarRelationFilter>;
  instinctId?: Maybe<StringNullableFilter>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryListRelationFilter>;
  invoices?: Maybe<InvoiceListRelationFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  lastBatchSyncedAt?: Maybe<DateTimeNullableFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  neo?: Maybe<NeoIntegrationNullableScalarRelationFilter>;
  neoId?: Maybe<StringNullableFilter>;
  pauseUntil?: Maybe<DateTimeNullableFilter>;
  petParents?: Maybe<ClinicPetParentListRelationFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemListRelationFilter>;
  pimsInvoices?: Maybe<PimsInvoiceListRelationFilter>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeListRelationFilter>;
  ppc?: Maybe<PpcIntegrationNullableScalarRelationFilter>;
  ppcId?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  rooms?: Maybe<ClinicRoomListRelationFilter>;
  serviceCategories?: Maybe<ServiceCategoryListRelationFilter>;
  serviceReminders?: Maybe<ServiceReminderListRelationFilter>;
  services?: Maybe<ServiceListRelationFilter>;
  sexes?: Maybe<SexListRelationFilter>;
  species?: Maybe<SpeciesListRelationFilter>;
  status?: Maybe<EnumPimsSyncStatusNullableFilter>;
  statusChangedAt?: Maybe<DateTimeNullableFilter>;
  statusErrorMessage?: Maybe<StringNullableFilter>;
  syncFrequency?: Maybe<EnumPimsSyncFrequencyFilter>;
  syncvet?: Maybe<SyncVetIntegrationNullableScalarRelationFilter>;
  syncvetId?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumClinicPimsIntegrationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vaccinations?: Maybe<VaccinationListRelationFilter>;
  vetAvailabilities?: Maybe<VetAvailabilityListRelationFilter>;
  vetdata?: Maybe<VetDataIntegrationNullableScalarRelationFilter>;
  vetdataId?: Maybe<StringNullableFilter>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationNullableScalarRelationFilter>;
  vetsourcePharmacyId?: Maybe<StringNullableFilter>;
  vetter?: Maybe<VetterIntegrationNullableScalarRelationFilter>;
  vetterId?: Maybe<StringNullableFilter>;
  writebackConfiguration?: Maybe<JsonFilter>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryListRelationFilter>;
};

export type ClinicPimsIntegrationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationOrderByRelationAndSearchRelevanceInput = {
  LabPanel?: Maybe<LabPanelOrderByRelationAggregateInput>;
  LabResult?: Maybe<LabResultOrderByRelationAggregateInput>;
  MedicalHistory?: Maybe<MedicalHistoryOrderByRelationAggregateInput>;
  SyncVetService?: Maybe<SyncVetServiceOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicPimsIntegrationOrderByRelevanceInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  availabilities?: Maybe<AppointmentAvailabilityOrderByRelationAggregateInput>;
  bitwerx?: Maybe<BitwerxIntegrationOrderByWithRelationInput>;
  bitwerxId?: Maybe<SortOrder>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  breeds?: Maybe<BreedOrderByRelationAggregateInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityOrderByRelationAggregateInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryOrderByRelationAggregateInput>;
  clientConnect?: Maybe<ClientConnectIntegrationOrderByWithRelationInput>;
  clientConnectId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  colors?: Maybe<ColorOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionOrderByRelationAggregateInput>;
  datapoint?: Maybe<DataPointIntegrationOrderByWithRelationInput>;
  datapointId?: Maybe<SortOrder>;
  employees?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  ezyvet?: Maybe<EzyVetIntegrationOrderByWithRelationInput>;
  ezyvetId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instinct?: Maybe<InstinctIntegrationOrderByWithRelationInput>;
  instinctId?: Maybe<SortOrder>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryOrderByRelationAggregateInput>;
  invoices?: Maybe<InvoiceOrderByRelationAggregateInput>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastBatchSyncedAt?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  neo?: Maybe<NeoIntegrationOrderByWithRelationInput>;
  neoId?: Maybe<SortOrder>;
  pauseUntil?: Maybe<SortOrder>;
  petParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemOrderByRelationAggregateInput>;
  pimsInvoices?: Maybe<PimsInvoiceOrderByRelationAggregateInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeOrderByRelationAggregateInput>;
  ppc?: Maybe<PpcIntegrationOrderByWithRelationInput>;
  ppcId?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  rooms?: Maybe<ClinicRoomOrderByRelationAggregateInput>;
  serviceCategories?: Maybe<ServiceCategoryOrderByRelationAggregateInput>;
  serviceReminders?: Maybe<ServiceReminderOrderByRelationAggregateInput>;
  services?: Maybe<ServiceOrderByRelationAggregateInput>;
  sexes?: Maybe<SexOrderByRelationAggregateInput>;
  species?: Maybe<SpeciesOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequency?: Maybe<SortOrder>;
  syncvet?: Maybe<SyncVetIntegrationOrderByWithRelationInput>;
  syncvetId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vaccinations?: Maybe<VaccinationOrderByRelationAggregateInput>;
  vetAvailabilities?: Maybe<VetAvailabilityOrderByRelationAggregateInput>;
  vetdata?: Maybe<VetDataIntegrationOrderByWithRelationInput>;
  vetdataId?: Maybe<SortOrder>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationOrderByWithRelationInput>;
  vetsourcePharmacyId?: Maybe<SortOrder>;
  vetter?: Maybe<VetterIntegrationOrderByWithRelationInput>;
  vetterId?: Maybe<SortOrder>;
  writebackConfiguration?: Maybe<SortOrder>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryOrderByRelationAggregateInput>;
};

export enum ClinicPimsIntegrationOrderByRelevanceFieldEnum {
  BitwerxId = 'bitwerxId',
  ClientConnectId = 'clientConnectId',
  ClinicId = 'clinicId',
  DatapointId = 'datapointId',
  EzyvetId = 'ezyvetId',
  Id = 'id',
  InstinctId = 'instinctId',
  NeoId = 'neoId',
  PpcId = 'ppcId',
  StatusErrorMessage = 'statusErrorMessage',
  SyncvetId = 'syncvetId',
  VetdataId = 'vetdataId',
  VetsourcePharmacyId = 'vetsourcePharmacyId',
  VetterId = 'vetterId'
}

export type ClinicPimsIntegrationOrderByRelevanceInput = {
  fields: Array<ClinicPimsIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPimsIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<ClinicPimsIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPimsIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPimsIntegrationMinOrderByAggregateInput>;
  bitwerxId?: Maybe<SortOrder>;
  clientConnectId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  datapointId?: Maybe<SortOrder>;
  ezyvetId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instinctId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastBatchSyncedAt?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  neoId?: Maybe<SortOrder>;
  pauseUntil?: Maybe<SortOrder>;
  ppcId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequency?: Maybe<SortOrder>;
  syncvetId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetdataId?: Maybe<SortOrder>;
  vetsourcePharmacyId?: Maybe<SortOrder>;
  vetterId?: Maybe<SortOrder>;
  writebackConfiguration?: Maybe<SortOrder>;
};

export type ClinicPimsIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  LabPanel?: Maybe<LabPanelOrderByRelationAggregateInput>;
  LabResult?: Maybe<LabResultOrderByRelationAggregateInput>;
  MedicalHistory?: Maybe<MedicalHistoryOrderByRelationAggregateInput>;
  SyncVetService?: Maybe<SyncVetServiceOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicPimsIntegrationOrderByRelevanceInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  availabilities?: Maybe<AppointmentAvailabilityOrderByRelationAggregateInput>;
  bitwerx?: Maybe<BitwerxIntegrationOrderByWithRelationInput>;
  bitwerxId?: Maybe<SortOrder>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  breeds?: Maybe<BreedOrderByRelationAggregateInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityOrderByRelationAggregateInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryOrderByRelationAggregateInput>;
  clientConnect?: Maybe<ClientConnectIntegrationOrderByWithRelationInput>;
  clientConnectId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  colors?: Maybe<ColorOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionOrderByRelationAggregateInput>;
  datapoint?: Maybe<DataPointIntegrationOrderByWithRelationInput>;
  datapointId?: Maybe<SortOrder>;
  employees?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  ezyvet?: Maybe<EzyVetIntegrationOrderByWithRelationInput>;
  ezyvetId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instinct?: Maybe<InstinctIntegrationOrderByWithRelationInput>;
  instinctId?: Maybe<SortOrder>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryOrderByRelationAggregateInput>;
  invoices?: Maybe<InvoiceOrderByRelationAggregateInput>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastBatchSyncedAt?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  neo?: Maybe<NeoIntegrationOrderByWithRelationInput>;
  neoId?: Maybe<SortOrder>;
  pauseUntil?: Maybe<SortOrder>;
  petParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemOrderByRelationAggregateInput>;
  pimsInvoices?: Maybe<PimsInvoiceOrderByRelationAggregateInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeOrderByRelationAggregateInput>;
  ppc?: Maybe<PpcIntegrationOrderByWithRelationInput>;
  ppcId?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  rooms?: Maybe<ClinicRoomOrderByRelationAggregateInput>;
  serviceCategories?: Maybe<ServiceCategoryOrderByRelationAggregateInput>;
  serviceReminders?: Maybe<ServiceReminderOrderByRelationAggregateInput>;
  services?: Maybe<ServiceOrderByRelationAggregateInput>;
  sexes?: Maybe<SexOrderByRelationAggregateInput>;
  species?: Maybe<SpeciesOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequency?: Maybe<SortOrder>;
  syncvet?: Maybe<SyncVetIntegrationOrderByWithRelationInput>;
  syncvetId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vaccinations?: Maybe<VaccinationOrderByRelationAggregateInput>;
  vetAvailabilities?: Maybe<VetAvailabilityOrderByRelationAggregateInput>;
  vetdata?: Maybe<VetDataIntegrationOrderByWithRelationInput>;
  vetdataId?: Maybe<SortOrder>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationOrderByWithRelationInput>;
  vetsourcePharmacyId?: Maybe<SortOrder>;
  vetter?: Maybe<VetterIntegrationOrderByWithRelationInput>;
  vetterId?: Maybe<SortOrder>;
  writebackConfiguration?: Maybe<SortOrder>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryOrderByRelationAggregateInput>;
};

export type ClinicPimsIntegrationOrderByWithRelationInput = {
  LabPanel?: Maybe<LabPanelOrderByRelationAggregateInput>;
  LabResult?: Maybe<LabResultOrderByRelationAggregateInput>;
  MedicalHistory?: Maybe<MedicalHistoryOrderByRelationAggregateInput>;
  SyncVetService?: Maybe<SyncVetServiceOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicPimsIntegrationOrderByRelevanceInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  availabilities?: Maybe<AppointmentAvailabilityOrderByRelationAggregateInput>;
  bitwerx?: Maybe<BitwerxIntegrationOrderByWithRelationInput>;
  bitwerxId?: Maybe<SortOrder>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  breeds?: Maybe<BreedOrderByRelationAggregateInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityOrderByRelationAggregateInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryOrderByRelationAggregateInput>;
  clientConnect?: Maybe<ClientConnectIntegrationOrderByWithRelationInput>;
  clientConnectId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  colors?: Maybe<ColorOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionOrderByRelationAggregateInput>;
  datapoint?: Maybe<DataPointIntegrationOrderByWithRelationInput>;
  datapointId?: Maybe<SortOrder>;
  employees?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  ezyvet?: Maybe<EzyVetIntegrationOrderByWithRelationInput>;
  ezyvetId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instinct?: Maybe<InstinctIntegrationOrderByWithRelationInput>;
  instinctId?: Maybe<SortOrder>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryOrderByRelationAggregateInput>;
  invoices?: Maybe<InvoiceOrderByRelationAggregateInput>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  lastBatchSyncedAt?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  neo?: Maybe<NeoIntegrationOrderByWithRelationInput>;
  neoId?: Maybe<SortOrder>;
  pauseUntil?: Maybe<SortOrder>;
  petParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemOrderByRelationAggregateInput>;
  pimsInvoices?: Maybe<PimsInvoiceOrderByRelationAggregateInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeOrderByRelationAggregateInput>;
  ppc?: Maybe<PpcIntegrationOrderByWithRelationInput>;
  ppcId?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  rooms?: Maybe<ClinicRoomOrderByRelationAggregateInput>;
  serviceCategories?: Maybe<ServiceCategoryOrderByRelationAggregateInput>;
  serviceReminders?: Maybe<ServiceReminderOrderByRelationAggregateInput>;
  services?: Maybe<ServiceOrderByRelationAggregateInput>;
  sexes?: Maybe<SexOrderByRelationAggregateInput>;
  species?: Maybe<SpeciesOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  statusChangedAt?: Maybe<SortOrder>;
  statusErrorMessage?: Maybe<SortOrder>;
  syncFrequency?: Maybe<SortOrder>;
  syncvet?: Maybe<SyncVetIntegrationOrderByWithRelationInput>;
  syncvetId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vaccinations?: Maybe<VaccinationOrderByRelationAggregateInput>;
  vetAvailabilities?: Maybe<VetAvailabilityOrderByRelationAggregateInput>;
  vetdata?: Maybe<VetDataIntegrationOrderByWithRelationInput>;
  vetdataId?: Maybe<SortOrder>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationOrderByWithRelationInput>;
  vetsourcePharmacyId?: Maybe<SortOrder>;
  vetter?: Maybe<VetterIntegrationOrderByWithRelationInput>;
  vetterId?: Maybe<SortOrder>;
  writebackConfiguration?: Maybe<SortOrder>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryOrderByRelationAggregateInput>;
};

export enum ClinicPimsIntegrationScalarFieldEnum {
  BitwerxId = 'bitwerxId',
  ClientConnectId = 'clientConnectId',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  DatapointId = 'datapointId',
  EzyvetId = 'ezyvetId',
  Id = 'id',
  InstinctId = 'instinctId',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  LastBatchSyncedAt = 'lastBatchSyncedAt',
  LastSyncedAt = 'lastSyncedAt',
  NeoId = 'neoId',
  PauseUntil = 'pauseUntil',
  PpcId = 'ppcId',
  Status = 'status',
  StatusChangedAt = 'statusChangedAt',
  StatusErrorMessage = 'statusErrorMessage',
  SyncFrequency = 'syncFrequency',
  SyncvetId = 'syncvetId',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  VetdataId = 'vetdataId',
  VetsourcePharmacyId = 'vetsourcePharmacyId',
  VetterId = 'vetterId',
  WritebackConfiguration = 'writebackConfiguration'
}

export type ClinicPimsIntegrationScalarRelationFilter = {
  AND?: Maybe<Array<ClinicPimsIntegrationWhereInput>>;
  LabPanel?: Maybe<LabPanelListRelationFilter>;
  LabResult?: Maybe<LabResultListRelationFilter>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ClinicPimsIntegrationWhereInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationWhereInput>>;
  SyncVetService?: Maybe<SyncVetServiceListRelationFilter>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  availabilities?: Maybe<AppointmentAvailabilityListRelationFilter>;
  bitwerx?: Maybe<BitwerxIntegrationNullableScalarRelationFilter>;
  bitwerxId?: Maybe<StringNullableFilter>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  breeds?: Maybe<BreedListRelationFilter>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityListRelationFilter>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryListRelationFilter>;
  clientConnect?: Maybe<ClientConnectIntegrationNullableScalarRelationFilter>;
  clientConnectId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  colors?: Maybe<ColorListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionListRelationFilter>;
  datapoint?: Maybe<DataPointIntegrationNullableScalarRelationFilter>;
  datapointId?: Maybe<StringNullableFilter>;
  employees?: Maybe<ClinicEmployeeListRelationFilter>;
  ezyvet?: Maybe<EzyVetIntegrationNullableScalarRelationFilter>;
  ezyvetId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  instinct?: Maybe<InstinctIntegrationNullableScalarRelationFilter>;
  instinctId?: Maybe<StringNullableFilter>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryListRelationFilter>;
  invoices?: Maybe<InvoiceListRelationFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  lastBatchSyncedAt?: Maybe<DateTimeNullableFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  neo?: Maybe<NeoIntegrationNullableScalarRelationFilter>;
  neoId?: Maybe<StringNullableFilter>;
  pauseUntil?: Maybe<DateTimeNullableFilter>;
  petParents?: Maybe<ClinicPetParentListRelationFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemListRelationFilter>;
  pimsInvoices?: Maybe<PimsInvoiceListRelationFilter>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeListRelationFilter>;
  ppc?: Maybe<PpcIntegrationNullableScalarRelationFilter>;
  ppcId?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  rooms?: Maybe<ClinicRoomListRelationFilter>;
  serviceCategories?: Maybe<ServiceCategoryListRelationFilter>;
  serviceReminders?: Maybe<ServiceReminderListRelationFilter>;
  services?: Maybe<ServiceListRelationFilter>;
  sexes?: Maybe<SexListRelationFilter>;
  species?: Maybe<SpeciesListRelationFilter>;
  status?: Maybe<EnumPimsSyncStatusNullableFilter>;
  statusChangedAt?: Maybe<DateTimeNullableFilter>;
  statusErrorMessage?: Maybe<StringNullableFilter>;
  syncFrequency?: Maybe<EnumPimsSyncFrequencyFilter>;
  syncvet?: Maybe<SyncVetIntegrationNullableScalarRelationFilter>;
  syncvetId?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumClinicPimsIntegrationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vaccinations?: Maybe<VaccinationListRelationFilter>;
  vetAvailabilities?: Maybe<VetAvailabilityListRelationFilter>;
  vetdata?: Maybe<VetDataIntegrationNullableScalarRelationFilter>;
  vetdataId?: Maybe<StringNullableFilter>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationNullableScalarRelationFilter>;
  vetsourcePharmacyId?: Maybe<StringNullableFilter>;
  vetter?: Maybe<VetterIntegrationNullableScalarRelationFilter>;
  vetterId?: Maybe<StringNullableFilter>;
  writebackConfiguration?: Maybe<JsonFilter>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryListRelationFilter>;
};

export type ClinicPimsIntegrationScalarWhereInput = {
  AND?: Maybe<Array<ClinicPimsIntegrationScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPimsIntegrationScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationScalarWhereInput>>;
  bitwerxId?: Maybe<StringNullableFilter>;
  clientConnectId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  datapointId?: Maybe<StringNullableFilter>;
  ezyvetId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  instinctId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  lastBatchSyncedAt?: Maybe<DateTimeNullableFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  neoId?: Maybe<StringNullableFilter>;
  pauseUntil?: Maybe<DateTimeNullableFilter>;
  ppcId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumPimsSyncStatusNullableFilter>;
  statusChangedAt?: Maybe<DateTimeNullableFilter>;
  statusErrorMessage?: Maybe<StringNullableFilter>;
  syncFrequency?: Maybe<EnumPimsSyncFrequencyFilter>;
  syncvetId?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumClinicPimsIntegrationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetdataId?: Maybe<StringNullableFilter>;
  vetsourcePharmacyId?: Maybe<StringNullableFilter>;
  vetterId?: Maybe<StringNullableFilter>;
  writebackConfiguration?: Maybe<JsonFilter>;
};

export type ClinicPimsIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPimsIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPimsIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationScalarWhereWithAggregatesInput>>;
  bitwerxId?: Maybe<StringNullableWithAggregatesFilter>;
  clientConnectId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  datapointId?: Maybe<StringNullableWithAggregatesFilter>;
  ezyvetId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  instinctId?: Maybe<StringNullableWithAggregatesFilter>;
  isActive?: Maybe<BoolNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolNullableWithAggregatesFilter>;
  lastBatchSyncedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  neoId?: Maybe<StringNullableWithAggregatesFilter>;
  pauseUntil?: Maybe<DateTimeNullableWithAggregatesFilter>;
  ppcId?: Maybe<StringNullableWithAggregatesFilter>;
  status?: Maybe<EnumPimsSyncStatusNullableWithAggregatesFilter>;
  statusChangedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  statusErrorMessage?: Maybe<StringNullableWithAggregatesFilter>;
  syncFrequency?: Maybe<EnumPimsSyncFrequencyWithAggregatesFilter>;
  syncvetId?: Maybe<StringNullableWithAggregatesFilter>;
  type?: Maybe<EnumClinicPimsIntegrationTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  vetdataId?: Maybe<StringNullableWithAggregatesFilter>;
  vetsourcePharmacyId?: Maybe<StringNullableWithAggregatesFilter>;
  vetterId?: Maybe<StringNullableWithAggregatesFilter>;
  writebackConfiguration?: Maybe<JsonWithAggregatesFilter>;
};

export enum ClinicPimsIntegrationType {
  Bitwerx = 'Bitwerx',
  ClientConnect = 'ClientConnect',
  Datapoint = 'Datapoint',
  Ezyvet = 'Ezyvet',
  Instinct = 'Instinct',
  Neo = 'Neo',
  Ppc = 'PPC',
  SyncVet = 'SyncVet',
  Televet = 'Televet',
  Vetdata = 'Vetdata',
  VetsourcePharmacy = 'VetsourcePharmacy',
  Vetter = 'Vetter'
}

export type ClinicPimsIntegrationUncheckedCreateInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicPimsIntegrationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPimsIntegrationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPimsIntegrationCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPimsIntegrationCreateManyClinicInputEnvelope>;
};

export type ClinicPimsIntegrationUncheckedCreateNestedOneWithoutBitwerxInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutBitwerxInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutBitwerxInput>;
};

export type ClinicPimsIntegrationUncheckedCreateNestedOneWithoutClientConnectInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutClientConnectInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutClientConnectInput>;
};

export type ClinicPimsIntegrationUncheckedCreateNestedOneWithoutDatapointInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutDatapointInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutDatapointInput>;
};

export type ClinicPimsIntegrationUncheckedCreateNestedOneWithoutEzyvetInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutEzyvetInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutEzyvetInput>;
};

export type ClinicPimsIntegrationUncheckedCreateNestedOneWithoutInstinctInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutInstinctInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutInstinctInput>;
};

export type ClinicPimsIntegrationUncheckedCreateNestedOneWithoutNeoInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutNeoInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutNeoInput>;
};

export type ClinicPimsIntegrationUncheckedCreateNestedOneWithoutPpcInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPpcInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPpcInput>;
};

export type ClinicPimsIntegrationUncheckedCreateNestedOneWithoutSyncvetInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutSyncvetInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutSyncvetInput>;
};

export type ClinicPimsIntegrationUncheckedCreateNestedOneWithoutVetdataInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetdataInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetdataInput>;
};

export type ClinicPimsIntegrationUncheckedCreateNestedOneWithoutVetsourcePharmacyInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetsourcePharmacyInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetsourcePharmacyInput>;
};

export type ClinicPimsIntegrationUncheckedCreateNestedOneWithoutVetterInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetterInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetterInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutAppointmentTypesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutAppointmentsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutAvailabilitiesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutBitwerxInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutBitwerxPaymentWritebackConfigurationsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutBreedsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutCapabilitiesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutCapabilityHistoryEntriesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutClientConnectInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutClinicInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutColorsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutCustomFieldDefinitionsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutDatapointInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutEmployeesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutEzyvetInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutInstinctInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutIntegrationOutageHistoryEntryInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutInvoicesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutLabPanelInput = {
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutLabResultInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutMedicalHistoryInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutNeoInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutPetParentsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutPetsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutPimsInvoiceLineItemsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutPimsInvoicesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutPimsPaymentTypesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutPpcInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutPrescriptionsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutRoomsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutServiceCategoriesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutServiceRemindersInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutServicesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutSexesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutSpeciesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutSyncVetServiceInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutSyncvetInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutVaccinationsInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutVetAvailabilitiesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutVetdataInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutVetsourcePharmacyInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutVetterInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
};

export type ClinicPimsIntegrationUncheckedCreateWithoutWritebackLogEntriesInput = {
  LabPanel?: Maybe<LabPanelUncheckedCreateNestedManyWithoutIntegrationInput>;
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutIntegrationInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutIntegrationInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutIntegrationInput>;
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedCreateNestedManyWithoutIntegrationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutIntegrationInput>;
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput>;
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutIntegrationInput>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutIntegrationInput>;
  species?: Maybe<SpeciesUncheckedCreateNestedManyWithoutIntegrationInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
};

export type ClinicPimsIntegrationUncheckedUpdateInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateManyInput = {
  bitwerxId?: Maybe<Scalars['String']>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  datapointId?: Maybe<Scalars['String']>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  ppcId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
};

export type ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicInput = {
  bitwerxId?: Maybe<Scalars['String']>;
  clientConnectId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  datapointId?: Maybe<Scalars['String']>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  ppcId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
};

export type ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicPimsIntegrationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPimsIntegrationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPimsIntegrationCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPimsIntegrationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicPimsIntegrationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPimsIntegrationScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPimsIntegrationWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPimsIntegrationWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPimsIntegrationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicPimsIntegrationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicPimsIntegrationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicPimsIntegrationUncheckedUpdateOneWithoutBitwerxNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutBitwerxInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutBitwerxInput>;
  delete?: Maybe<ClinicPimsIntegrationWhereInput>;
  disconnect?: Maybe<ClinicPimsIntegrationWhereInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutBitwerxInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutBitwerxInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateOneWithoutClientConnectNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutClientConnectInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutClientConnectInput>;
  delete?: Maybe<ClinicPimsIntegrationWhereInput>;
  disconnect?: Maybe<ClinicPimsIntegrationWhereInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutClientConnectInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutClientConnectInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateOneWithoutDatapointNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutDatapointInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutDatapointInput>;
  delete?: Maybe<ClinicPimsIntegrationWhereInput>;
  disconnect?: Maybe<ClinicPimsIntegrationWhereInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutDatapointInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutDatapointInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateOneWithoutEzyvetNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutEzyvetInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutEzyvetInput>;
  delete?: Maybe<ClinicPimsIntegrationWhereInput>;
  disconnect?: Maybe<ClinicPimsIntegrationWhereInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutEzyvetInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutEzyvetInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateOneWithoutInstinctNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutInstinctInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutInstinctInput>;
  delete?: Maybe<ClinicPimsIntegrationWhereInput>;
  disconnect?: Maybe<ClinicPimsIntegrationWhereInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutInstinctInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutInstinctInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateOneWithoutNeoNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutNeoInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutNeoInput>;
  delete?: Maybe<ClinicPimsIntegrationWhereInput>;
  disconnect?: Maybe<ClinicPimsIntegrationWhereInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutNeoInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutNeoInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateOneWithoutPpcNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPpcInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPpcInput>;
  delete?: Maybe<ClinicPimsIntegrationWhereInput>;
  disconnect?: Maybe<ClinicPimsIntegrationWhereInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutPpcInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutPpcInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateOneWithoutSyncvetNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutSyncvetInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutSyncvetInput>;
  delete?: Maybe<ClinicPimsIntegrationWhereInput>;
  disconnect?: Maybe<ClinicPimsIntegrationWhereInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutSyncvetInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutSyncvetInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateOneWithoutVetdataNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetdataInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetdataInput>;
  delete?: Maybe<ClinicPimsIntegrationWhereInput>;
  disconnect?: Maybe<ClinicPimsIntegrationWhereInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutVetdataInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutVetdataInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateOneWithoutVetsourcePharmacyNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetsourcePharmacyInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetsourcePharmacyInput>;
  delete?: Maybe<ClinicPimsIntegrationWhereInput>;
  disconnect?: Maybe<ClinicPimsIntegrationWhereInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutVetsourcePharmacyInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutVetsourcePharmacyInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateOneWithoutVetterNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetterInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetterInput>;
  delete?: Maybe<ClinicPimsIntegrationWhereInput>;
  disconnect?: Maybe<ClinicPimsIntegrationWhereInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutVetterInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutVetterInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutAppointmentTypesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutAppointmentsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutAvailabilitiesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutBitwerxInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutBitwerxPaymentWritebackConfigurationsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutBreedsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutCapabilitiesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutCapabilityHistoryEntriesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutClientConnectInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutClinicInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutColorsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutCustomFieldDefinitionsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutDatapointInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutEmployeesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutEzyvetInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutInstinctInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutIntegrationOutageHistoryEntryInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutInvoicesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutLabPanelInput = {
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutLabResultInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutMedicalHistoryInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutNeoInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutPetParentsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutPetsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutPimsInvoiceLineItemsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutPimsInvoicesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutPimsPaymentTypesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutPpcInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutPrescriptionsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutRoomsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutServiceCategoriesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutServiceRemindersInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutServicesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutSexesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutSpeciesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutSyncVetServiceInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutSyncvetInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutVaccinationsInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutVetAvailabilitiesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutVetdataInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutVetsourcePharmacyInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutVetterInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUncheckedUpdateWithoutWritebackLogEntriesInput = {
  LabPanel?: Maybe<LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  colors?: Maybe<ColorUncheckedUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
};

export type ClinicPimsIntegrationUpdateInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
};

export type ClinicPimsIntegrationUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicPimsIntegrationUpdateManyMutationInput;
  where: ClinicPimsIntegrationScalarWhereInput;
};

export type ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicPimsIntegrationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPimsIntegrationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPimsIntegrationCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPimsIntegrationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicPimsIntegrationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPimsIntegrationScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPimsIntegrationWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPimsIntegrationWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPimsIntegrationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicPimsIntegrationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicPimsIntegrationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutBitwerxPaymentWritebackConfigurationsNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutBitwerxPaymentWritebackConfigurationsInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutBitwerxPaymentWritebackConfigurationsInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutBitwerxPaymentWritebackConfigurationsInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutBreedsNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutBreedsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutBreedsInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutBreedsInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutBreedsInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutCapabilitiesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutCapabilitiesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutCapabilitiesInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutCapabilitiesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutCapabilitiesInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutCapabilityHistoryEntriesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutCapabilityHistoryEntriesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutCapabilityHistoryEntriesInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutCapabilityHistoryEntriesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutCapabilityHistoryEntriesInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutColorsNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutColorsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutColorsInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutColorsInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutColorsInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutCustomFieldDefinitionsNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutCustomFieldDefinitionsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutCustomFieldDefinitionsInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutCustomFieldDefinitionsInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutCustomFieldDefinitionsInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutIntegrationOutageHistoryEntryNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutIntegrationOutageHistoryEntryInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutIntegrationOutageHistoryEntryInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutIntegrationOutageHistoryEntryInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutIntegrationOutageHistoryEntryInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutPimsInvoiceLineItemsNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPimsInvoiceLineItemsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPimsInvoiceLineItemsInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutPimsInvoiceLineItemsInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutPimsInvoiceLineItemsInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutPimsInvoicesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPimsInvoicesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPimsInvoicesInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutPimsInvoicesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutPimsInvoicesInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutPimsPaymentTypesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPimsPaymentTypesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPimsPaymentTypesInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutPimsPaymentTypesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutPimsPaymentTypesInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutPrescriptionsNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPrescriptionsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPrescriptionsInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutPrescriptionsInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutPrescriptionsInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutServiceCategoriesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutServiceCategoriesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutServiceCategoriesInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutServiceCategoriesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutServiceCategoriesInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutServiceRemindersNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutServiceRemindersInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutServiceRemindersInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutServiceRemindersInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutServiceRemindersInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutServicesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutServicesInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutServicesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutServicesInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutSexesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutSexesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutSexesInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutSexesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutSexesInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutSpeciesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutSpeciesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutSpeciesInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutSpeciesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutSpeciesInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutSyncVetServiceNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutSyncVetServiceInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutSyncVetServiceInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutSyncVetServiceInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutSyncVetServiceInput>;
};

export type ClinicPimsIntegrationUpdateOneRequiredWithoutWritebackLogEntriesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutWritebackLogEntriesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutWritebackLogEntriesInput>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutWritebackLogEntriesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutWritebackLogEntriesInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutAppointmentTypesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutAppointmentTypesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutAppointmentTypesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutAppointmentTypesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutAppointmentTypesInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutAppointmentsNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutAppointmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutAppointmentsInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutAppointmentsInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutAvailabilitiesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutAvailabilitiesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutAvailabilitiesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutAvailabilitiesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutAvailabilitiesInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutBitwerxNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutBitwerxInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutBitwerxInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutBitwerxInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutBitwerxInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutClientConnectNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutClientConnectInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutClientConnectInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutClientConnectInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutClientConnectInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutDatapointNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutDatapointInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutDatapointInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutDatapointInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutDatapointInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutEmployeesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutEmployeesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutEmployeesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutEmployeesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutEmployeesInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutEzyvetNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutEzyvetInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutEzyvetInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutEzyvetInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutEzyvetInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutInstinctNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutInstinctInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutInstinctInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutInstinctInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutInstinctInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutInvoicesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutInvoicesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutInvoicesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutInvoicesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutInvoicesInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutLabPanelNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutLabPanelInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutLabPanelInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutLabPanelInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutLabPanelInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutLabResultNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutLabResultInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutLabResultInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutLabResultInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutLabResultInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutMedicalHistoryNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutMedicalHistoryInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutMedicalHistoryInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutMedicalHistoryInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutMedicalHistoryInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutNeoNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutNeoInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutNeoInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutNeoInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutNeoInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutPetParentsNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPetParentsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPetParentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutPetParentsInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutPetParentsInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutPetsNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPetsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPetsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutPetsInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutPetsInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutPpcNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutPpcInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutPpcInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutPpcInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutPpcInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutRoomsNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutRoomsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutRoomsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutRoomsInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutRoomsInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutSyncvetNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutSyncvetInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutSyncvetInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutSyncvetInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutSyncvetInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutVaccinationsNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVaccinationsInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVaccinationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutVaccinationsInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutVaccinationsInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutVetAvailabilitiesNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetAvailabilitiesInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetAvailabilitiesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutVetAvailabilitiesInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutVetAvailabilitiesInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutVetdataNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetdataInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetdataInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutVetdataInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutVetdataInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutVetsourcePharmacyNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetsourcePharmacyInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetsourcePharmacyInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutVetsourcePharmacyInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutVetsourcePharmacyInput>;
};

export type ClinicPimsIntegrationUpdateOneWithoutVetterNestedInput = {
  connect?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicPimsIntegrationCreateOrConnectWithoutVetterInput>;
  create?: Maybe<ClinicPimsIntegrationCreateWithoutVetterInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicPimsIntegrationUpdateToOneWithWhereWithoutVetterInput>;
  upsert?: Maybe<ClinicPimsIntegrationUpsertWithoutVetterInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutAppointmentTypesInput = {
  data: ClinicPimsIntegrationUpdateWithoutAppointmentTypesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutAppointmentsInput = {
  data: ClinicPimsIntegrationUpdateWithoutAppointmentsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutAvailabilitiesInput = {
  data: ClinicPimsIntegrationUpdateWithoutAvailabilitiesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutBitwerxInput = {
  data: ClinicPimsIntegrationUpdateWithoutBitwerxInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutBitwerxPaymentWritebackConfigurationsInput = {
  data: ClinicPimsIntegrationUpdateWithoutBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutBreedsInput = {
  data: ClinicPimsIntegrationUpdateWithoutBreedsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutCapabilitiesInput = {
  data: ClinicPimsIntegrationUpdateWithoutCapabilitiesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutCapabilityHistoryEntriesInput = {
  data: ClinicPimsIntegrationUpdateWithoutCapabilityHistoryEntriesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutClientConnectInput = {
  data: ClinicPimsIntegrationUpdateWithoutClientConnectInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutColorsInput = {
  data: ClinicPimsIntegrationUpdateWithoutColorsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutCustomFieldDefinitionsInput = {
  data: ClinicPimsIntegrationUpdateWithoutCustomFieldDefinitionsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutDatapointInput = {
  data: ClinicPimsIntegrationUpdateWithoutDatapointInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutEmployeesInput = {
  data: ClinicPimsIntegrationUpdateWithoutEmployeesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutEzyvetInput = {
  data: ClinicPimsIntegrationUpdateWithoutEzyvetInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutInstinctInput = {
  data: ClinicPimsIntegrationUpdateWithoutInstinctInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutIntegrationOutageHistoryEntryInput = {
  data: ClinicPimsIntegrationUpdateWithoutIntegrationOutageHistoryEntryInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutInvoicesInput = {
  data: ClinicPimsIntegrationUpdateWithoutInvoicesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutLabPanelInput = {
  data: ClinicPimsIntegrationUpdateWithoutLabPanelInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutLabResultInput = {
  data: ClinicPimsIntegrationUpdateWithoutLabResultInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutMedicalHistoryInput = {
  data: ClinicPimsIntegrationUpdateWithoutMedicalHistoryInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutNeoInput = {
  data: ClinicPimsIntegrationUpdateWithoutNeoInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutPetParentsInput = {
  data: ClinicPimsIntegrationUpdateWithoutPetParentsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutPetsInput = {
  data: ClinicPimsIntegrationUpdateWithoutPetsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutPimsInvoiceLineItemsInput = {
  data: ClinicPimsIntegrationUpdateWithoutPimsInvoiceLineItemsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutPimsInvoicesInput = {
  data: ClinicPimsIntegrationUpdateWithoutPimsInvoicesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutPimsPaymentTypesInput = {
  data: ClinicPimsIntegrationUpdateWithoutPimsPaymentTypesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutPpcInput = {
  data: ClinicPimsIntegrationUpdateWithoutPpcInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutPrescriptionsInput = {
  data: ClinicPimsIntegrationUpdateWithoutPrescriptionsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutRoomsInput = {
  data: ClinicPimsIntegrationUpdateWithoutRoomsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutServiceCategoriesInput = {
  data: ClinicPimsIntegrationUpdateWithoutServiceCategoriesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutServiceRemindersInput = {
  data: ClinicPimsIntegrationUpdateWithoutServiceRemindersInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutServicesInput = {
  data: ClinicPimsIntegrationUpdateWithoutServicesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutSexesInput = {
  data: ClinicPimsIntegrationUpdateWithoutSexesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutSpeciesInput = {
  data: ClinicPimsIntegrationUpdateWithoutSpeciesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutSyncVetServiceInput = {
  data: ClinicPimsIntegrationUpdateWithoutSyncVetServiceInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutSyncvetInput = {
  data: ClinicPimsIntegrationUpdateWithoutSyncvetInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutVaccinationsInput = {
  data: ClinicPimsIntegrationUpdateWithoutVaccinationsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutVetAvailabilitiesInput = {
  data: ClinicPimsIntegrationUpdateWithoutVetAvailabilitiesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutVetdataInput = {
  data: ClinicPimsIntegrationUpdateWithoutVetdataInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutVetsourcePharmacyInput = {
  data: ClinicPimsIntegrationUpdateWithoutVetsourcePharmacyInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutVetterInput = {
  data: ClinicPimsIntegrationUpdateWithoutVetterInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateToOneWithWhereWithoutWritebackLogEntriesInput = {
  data: ClinicPimsIntegrationUpdateWithoutWritebackLogEntriesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicPimsIntegrationUpdateWithoutClinicInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationUpdateWithoutAppointmentTypesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutAppointmentsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutAvailabilitiesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutBitwerxInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutBitwerxPaymentWritebackConfigurationsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutBreedsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutCapabilitiesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutCapabilityHistoryEntriesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutClientConnectInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutClinicInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutColorsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutCustomFieldDefinitionsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutDatapointInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutEmployeesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutEzyvetInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutInstinctInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutIntegrationOutageHistoryEntryInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutInvoicesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutLabPanelInput = {
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutLabResultInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutMedicalHistoryInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutNeoInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutPetParentsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutPetsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutPimsInvoiceLineItemsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutPimsInvoicesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutPimsPaymentTypesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutPpcInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutPrescriptionsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutRoomsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutServiceCategoriesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutServiceRemindersInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutServicesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutSexesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutSpeciesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutSyncVetServiceInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutSyncvetInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutVaccinationsInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutVetAvailabilitiesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutVetdataInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutVetsourcePharmacyInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutVetterInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput>;
};

export type ClinicPimsIntegrationUpdateWithoutWritebackLogEntriesInput = {
  LabPanel?: Maybe<LabPanelUpdateManyWithoutIntegrationNestedInput>;
  LabResult?: Maybe<LabResultUpdateManyWithoutIntegrationNestedInput>;
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutIntegrationNestedInput>;
  SyncVetService?: Maybe<SyncVetServiceUpdateManyWithoutIntegrationNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutIntegrationNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutIntegrationNestedInput>;
  availabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  bitwerx?: Maybe<BitwerxIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutIntegrationNestedInput>;
  breeds?: Maybe<BreedUpdateManyWithoutIntegrationNestedInput>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityUpdateManyWithoutIntegrationNestedInput>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  clientConnect?: Maybe<ClientConnectIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutIntegrationsNestedInput>;
  colors?: Maybe<ColorUpdateManyWithoutIntegrationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput>;
  datapoint?: Maybe<DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  employees?: Maybe<ClinicEmployeeUpdateManyWithoutIntegrationNestedInput>;
  ezyvet?: Maybe<EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput>;
  invoices?: Maybe<InvoiceUpdateManyWithoutIntegrationNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  petParents?: Maybe<ClinicPetParentUpdateManyWithoutIntegrationNestedInput>;
  pets?: Maybe<ClinicPetUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput>;
  pimsInvoices?: Maybe<PimsInvoiceUpdateManyWithoutIntegrationNestedInput>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput>;
  ppc?: Maybe<PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutIntegrationNestedInput>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutIntegrationNestedInput>;
  serviceCategories?: Maybe<ServiceCategoryUpdateManyWithoutIntegrationNestedInput>;
  serviceReminders?: Maybe<ServiceReminderUpdateManyWithoutIntegrationNestedInput>;
  services?: Maybe<ServiceUpdateManyWithoutIntegrationNestedInput>;
  sexes?: Maybe<SexUpdateManyWithoutIntegrationNestedInput>;
  species?: Maybe<SpeciesUpdateManyWithoutIntegrationNestedInput>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency?: Maybe<PimsSyncFrequency>;
  syncvet?: Maybe<SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  type?: Maybe<ClinicPimsIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutIntegrationNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutIntegrationNestedInput>;
  vetdata?: Maybe<VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  vetter?: Maybe<VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput>;
  writebackConfiguration?: Maybe<Scalars['Json']>;
};

export type ClinicPimsIntegrationUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicPimsIntegrationCreateWithoutClinicInput;
  update: ClinicPimsIntegrationUpdateWithoutClinicInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};

export type ClinicPimsIntegrationUpsertWithoutAppointmentTypesInput = {
  create: ClinicPimsIntegrationCreateWithoutAppointmentTypesInput;
  update: ClinicPimsIntegrationUpdateWithoutAppointmentTypesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutAppointmentsInput = {
  create: ClinicPimsIntegrationCreateWithoutAppointmentsInput;
  update: ClinicPimsIntegrationUpdateWithoutAppointmentsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutAvailabilitiesInput = {
  create: ClinicPimsIntegrationCreateWithoutAvailabilitiesInput;
  update: ClinicPimsIntegrationUpdateWithoutAvailabilitiesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutBitwerxInput = {
  create: ClinicPimsIntegrationCreateWithoutBitwerxInput;
  update: ClinicPimsIntegrationUpdateWithoutBitwerxInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutBitwerxPaymentWritebackConfigurationsInput = {
  create: ClinicPimsIntegrationCreateWithoutBitwerxPaymentWritebackConfigurationsInput;
  update: ClinicPimsIntegrationUpdateWithoutBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutBreedsInput = {
  create: ClinicPimsIntegrationCreateWithoutBreedsInput;
  update: ClinicPimsIntegrationUpdateWithoutBreedsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutCapabilitiesInput = {
  create: ClinicPimsIntegrationCreateWithoutCapabilitiesInput;
  update: ClinicPimsIntegrationUpdateWithoutCapabilitiesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutCapabilityHistoryEntriesInput = {
  create: ClinicPimsIntegrationCreateWithoutCapabilityHistoryEntriesInput;
  update: ClinicPimsIntegrationUpdateWithoutCapabilityHistoryEntriesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutClientConnectInput = {
  create: ClinicPimsIntegrationCreateWithoutClientConnectInput;
  update: ClinicPimsIntegrationUpdateWithoutClientConnectInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutColorsInput = {
  create: ClinicPimsIntegrationCreateWithoutColorsInput;
  update: ClinicPimsIntegrationUpdateWithoutColorsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutCustomFieldDefinitionsInput = {
  create: ClinicPimsIntegrationCreateWithoutCustomFieldDefinitionsInput;
  update: ClinicPimsIntegrationUpdateWithoutCustomFieldDefinitionsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutDatapointInput = {
  create: ClinicPimsIntegrationCreateWithoutDatapointInput;
  update: ClinicPimsIntegrationUpdateWithoutDatapointInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutEmployeesInput = {
  create: ClinicPimsIntegrationCreateWithoutEmployeesInput;
  update: ClinicPimsIntegrationUpdateWithoutEmployeesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutEzyvetInput = {
  create: ClinicPimsIntegrationCreateWithoutEzyvetInput;
  update: ClinicPimsIntegrationUpdateWithoutEzyvetInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutInstinctInput = {
  create: ClinicPimsIntegrationCreateWithoutInstinctInput;
  update: ClinicPimsIntegrationUpdateWithoutInstinctInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutIntegrationOutageHistoryEntryInput = {
  create: ClinicPimsIntegrationCreateWithoutIntegrationOutageHistoryEntryInput;
  update: ClinicPimsIntegrationUpdateWithoutIntegrationOutageHistoryEntryInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutInvoicesInput = {
  create: ClinicPimsIntegrationCreateWithoutInvoicesInput;
  update: ClinicPimsIntegrationUpdateWithoutInvoicesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutLabPanelInput = {
  create: ClinicPimsIntegrationCreateWithoutLabPanelInput;
  update: ClinicPimsIntegrationUpdateWithoutLabPanelInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutLabResultInput = {
  create: ClinicPimsIntegrationCreateWithoutLabResultInput;
  update: ClinicPimsIntegrationUpdateWithoutLabResultInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutMedicalHistoryInput = {
  create: ClinicPimsIntegrationCreateWithoutMedicalHistoryInput;
  update: ClinicPimsIntegrationUpdateWithoutMedicalHistoryInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutNeoInput = {
  create: ClinicPimsIntegrationCreateWithoutNeoInput;
  update: ClinicPimsIntegrationUpdateWithoutNeoInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutPetParentsInput = {
  create: ClinicPimsIntegrationCreateWithoutPetParentsInput;
  update: ClinicPimsIntegrationUpdateWithoutPetParentsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutPetsInput = {
  create: ClinicPimsIntegrationCreateWithoutPetsInput;
  update: ClinicPimsIntegrationUpdateWithoutPetsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutPimsInvoiceLineItemsInput = {
  create: ClinicPimsIntegrationCreateWithoutPimsInvoiceLineItemsInput;
  update: ClinicPimsIntegrationUpdateWithoutPimsInvoiceLineItemsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutPimsInvoicesInput = {
  create: ClinicPimsIntegrationCreateWithoutPimsInvoicesInput;
  update: ClinicPimsIntegrationUpdateWithoutPimsInvoicesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutPimsPaymentTypesInput = {
  create: ClinicPimsIntegrationCreateWithoutPimsPaymentTypesInput;
  update: ClinicPimsIntegrationUpdateWithoutPimsPaymentTypesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutPpcInput = {
  create: ClinicPimsIntegrationCreateWithoutPpcInput;
  update: ClinicPimsIntegrationUpdateWithoutPpcInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutPrescriptionsInput = {
  create: ClinicPimsIntegrationCreateWithoutPrescriptionsInput;
  update: ClinicPimsIntegrationUpdateWithoutPrescriptionsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutRoomsInput = {
  create: ClinicPimsIntegrationCreateWithoutRoomsInput;
  update: ClinicPimsIntegrationUpdateWithoutRoomsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutServiceCategoriesInput = {
  create: ClinicPimsIntegrationCreateWithoutServiceCategoriesInput;
  update: ClinicPimsIntegrationUpdateWithoutServiceCategoriesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutServiceRemindersInput = {
  create: ClinicPimsIntegrationCreateWithoutServiceRemindersInput;
  update: ClinicPimsIntegrationUpdateWithoutServiceRemindersInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutServicesInput = {
  create: ClinicPimsIntegrationCreateWithoutServicesInput;
  update: ClinicPimsIntegrationUpdateWithoutServicesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutSexesInput = {
  create: ClinicPimsIntegrationCreateWithoutSexesInput;
  update: ClinicPimsIntegrationUpdateWithoutSexesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutSpeciesInput = {
  create: ClinicPimsIntegrationCreateWithoutSpeciesInput;
  update: ClinicPimsIntegrationUpdateWithoutSpeciesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutSyncVetServiceInput = {
  create: ClinicPimsIntegrationCreateWithoutSyncVetServiceInput;
  update: ClinicPimsIntegrationUpdateWithoutSyncVetServiceInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutSyncvetInput = {
  create: ClinicPimsIntegrationCreateWithoutSyncvetInput;
  update: ClinicPimsIntegrationUpdateWithoutSyncvetInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutVaccinationsInput = {
  create: ClinicPimsIntegrationCreateWithoutVaccinationsInput;
  update: ClinicPimsIntegrationUpdateWithoutVaccinationsInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutVetAvailabilitiesInput = {
  create: ClinicPimsIntegrationCreateWithoutVetAvailabilitiesInput;
  update: ClinicPimsIntegrationUpdateWithoutVetAvailabilitiesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutVetdataInput = {
  create: ClinicPimsIntegrationCreateWithoutVetdataInput;
  update: ClinicPimsIntegrationUpdateWithoutVetdataInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutVetsourcePharmacyInput = {
  create: ClinicPimsIntegrationCreateWithoutVetsourcePharmacyInput;
  update: ClinicPimsIntegrationUpdateWithoutVetsourcePharmacyInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutVetterInput = {
  create: ClinicPimsIntegrationCreateWithoutVetterInput;
  update: ClinicPimsIntegrationUpdateWithoutVetterInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationUpsertWithoutWritebackLogEntriesInput = {
  create: ClinicPimsIntegrationCreateWithoutWritebackLogEntriesInput;
  update: ClinicPimsIntegrationUpdateWithoutWritebackLogEntriesInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type ClinicPimsIntegrationWhereInput = {
  AND?: Maybe<Array<ClinicPimsIntegrationWhereInput>>;
  LabPanel?: Maybe<LabPanelListRelationFilter>;
  LabResult?: Maybe<LabResultListRelationFilter>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ClinicPimsIntegrationWhereInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationWhereInput>>;
  SyncVetService?: Maybe<SyncVetServiceListRelationFilter>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  availabilities?: Maybe<AppointmentAvailabilityListRelationFilter>;
  bitwerx?: Maybe<BitwerxIntegrationNullableScalarRelationFilter>;
  bitwerxId?: Maybe<StringNullableFilter>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  breeds?: Maybe<BreedListRelationFilter>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityListRelationFilter>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryListRelationFilter>;
  clientConnect?: Maybe<ClientConnectIntegrationNullableScalarRelationFilter>;
  clientConnectId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  colors?: Maybe<ColorListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionListRelationFilter>;
  datapoint?: Maybe<DataPointIntegrationNullableScalarRelationFilter>;
  datapointId?: Maybe<StringNullableFilter>;
  employees?: Maybe<ClinicEmployeeListRelationFilter>;
  ezyvet?: Maybe<EzyVetIntegrationNullableScalarRelationFilter>;
  ezyvetId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  instinct?: Maybe<InstinctIntegrationNullableScalarRelationFilter>;
  instinctId?: Maybe<StringNullableFilter>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryListRelationFilter>;
  invoices?: Maybe<InvoiceListRelationFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  lastBatchSyncedAt?: Maybe<DateTimeNullableFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  neo?: Maybe<NeoIntegrationNullableScalarRelationFilter>;
  neoId?: Maybe<StringNullableFilter>;
  pauseUntil?: Maybe<DateTimeNullableFilter>;
  petParents?: Maybe<ClinicPetParentListRelationFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemListRelationFilter>;
  pimsInvoices?: Maybe<PimsInvoiceListRelationFilter>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeListRelationFilter>;
  ppc?: Maybe<PpcIntegrationNullableScalarRelationFilter>;
  ppcId?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  rooms?: Maybe<ClinicRoomListRelationFilter>;
  serviceCategories?: Maybe<ServiceCategoryListRelationFilter>;
  serviceReminders?: Maybe<ServiceReminderListRelationFilter>;
  services?: Maybe<ServiceListRelationFilter>;
  sexes?: Maybe<SexListRelationFilter>;
  species?: Maybe<SpeciesListRelationFilter>;
  status?: Maybe<EnumPimsSyncStatusNullableFilter>;
  statusChangedAt?: Maybe<DateTimeNullableFilter>;
  statusErrorMessage?: Maybe<StringNullableFilter>;
  syncFrequency?: Maybe<EnumPimsSyncFrequencyFilter>;
  syncvet?: Maybe<SyncVetIntegrationNullableScalarRelationFilter>;
  syncvetId?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumClinicPimsIntegrationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vaccinations?: Maybe<VaccinationListRelationFilter>;
  vetAvailabilities?: Maybe<VetAvailabilityListRelationFilter>;
  vetdata?: Maybe<VetDataIntegrationNullableScalarRelationFilter>;
  vetdataId?: Maybe<StringNullableFilter>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationNullableScalarRelationFilter>;
  vetsourcePharmacyId?: Maybe<StringNullableFilter>;
  vetter?: Maybe<VetterIntegrationNullableScalarRelationFilter>;
  vetterId?: Maybe<StringNullableFilter>;
  writebackConfiguration?: Maybe<JsonFilter>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryListRelationFilter>;
};

export type ClinicPimsIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPimsIntegrationWhereInput>>;
  LabPanel?: Maybe<LabPanelListRelationFilter>;
  LabResult?: Maybe<LabResultListRelationFilter>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ClinicPimsIntegrationWhereInput>>;
  OR?: Maybe<Array<ClinicPimsIntegrationWhereInput>>;
  SyncVetService?: Maybe<SyncVetServiceListRelationFilter>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  availabilities?: Maybe<AppointmentAvailabilityListRelationFilter>;
  bitwerx?: Maybe<BitwerxIntegrationNullableScalarRelationFilter>;
  bitwerxId?: Maybe<Scalars['String']>;
  bitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  breeds?: Maybe<BreedListRelationFilter>;
  capabilities?: Maybe<ClinicPimsIntegrationCapabilityListRelationFilter>;
  capabilityHistoryEntries?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryListRelationFilter>;
  clientConnect?: Maybe<ClientConnectIntegrationNullableScalarRelationFilter>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  colors?: Maybe<ColorListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customFieldDefinitions?: Maybe<CustomFieldDefinitionListRelationFilter>;
  datapoint?: Maybe<DataPointIntegrationNullableScalarRelationFilter>;
  datapointId?: Maybe<Scalars['String']>;
  employees?: Maybe<ClinicEmployeeListRelationFilter>;
  ezyvet?: Maybe<EzyVetIntegrationNullableScalarRelationFilter>;
  ezyvetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instinct?: Maybe<InstinctIntegrationNullableScalarRelationFilter>;
  instinctId?: Maybe<Scalars['String']>;
  integrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntryListRelationFilter>;
  invoices?: Maybe<InvoiceListRelationFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  lastBatchSyncedAt?: Maybe<DateTimeNullableFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  neo?: Maybe<NeoIntegrationNullableScalarRelationFilter>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<DateTimeNullableFilter>;
  petParents?: Maybe<ClinicPetParentListRelationFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsInvoiceLineItems?: Maybe<PimsInvoiceLineItemListRelationFilter>;
  pimsInvoices?: Maybe<PimsInvoiceListRelationFilter>;
  pimsPaymentTypes?: Maybe<PimsPaymentTypeListRelationFilter>;
  ppc?: Maybe<PpcIntegrationNullableScalarRelationFilter>;
  ppcId?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  rooms?: Maybe<ClinicRoomListRelationFilter>;
  serviceCategories?: Maybe<ServiceCategoryListRelationFilter>;
  serviceReminders?: Maybe<ServiceReminderListRelationFilter>;
  services?: Maybe<ServiceListRelationFilter>;
  sexes?: Maybe<SexListRelationFilter>;
  species?: Maybe<SpeciesListRelationFilter>;
  status?: Maybe<EnumPimsSyncStatusNullableFilter>;
  statusChangedAt?: Maybe<DateTimeNullableFilter>;
  statusErrorMessage?: Maybe<StringNullableFilter>;
  syncFrequency?: Maybe<EnumPimsSyncFrequencyFilter>;
  syncvet?: Maybe<SyncVetIntegrationNullableScalarRelationFilter>;
  syncvetId?: Maybe<Scalars['String']>;
  type?: Maybe<EnumClinicPimsIntegrationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vaccinations?: Maybe<VaccinationListRelationFilter>;
  vetAvailabilities?: Maybe<VetAvailabilityListRelationFilter>;
  vetdata?: Maybe<VetDataIntegrationNullableScalarRelationFilter>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegrationNullableScalarRelationFilter>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetter?: Maybe<VetterIntegrationNullableScalarRelationFilter>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration?: Maybe<JsonFilter>;
  writebackLogEntries?: Maybe<PimsWritebackLogEntryListRelationFilter>;
};

export type ClinicPostcardSetting = {
  __typename?: 'ClinicPostcardSetting';
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isRemindersEnabled: Scalars['Boolean'];
  reminderTemplate: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ClinicPostcardSettingCountAggregateOutputType = {
  __typename?: 'ClinicPostcardSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  apiKey: Scalars['Int'];
  apiSecret: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isRemindersEnabled: Scalars['Int'];
  reminderTemplate: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicPostcardSettingCountOrderByAggregateInput = {
  apiKey?: Maybe<SortOrder>;
  apiSecret?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isRemindersEnabled?: Maybe<SortOrder>;
  reminderTemplate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPostcardSettingCreateInput = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  clinic: ClinicCreateNestedOneWithoutPostcardSettingsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingCreateManyClinicInput = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingCreateManyClinicInputEnvelope = {
  data: Array<ClinicPostcardSettingCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicPostcardSettingCreateManyInput = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicPostcardSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPostcardSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPostcardSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPostcardSettingCreateManyClinicInputEnvelope>;
};

export type ClinicPostcardSettingCreateOrConnectWithoutClinicInput = {
  create: ClinicPostcardSettingCreateWithoutClinicInput;
  where: ClinicPostcardSettingWhereUniqueInput;
};

export type ClinicPostcardSettingCreateWithoutClinicInput = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingGroupByOutputType = {
  __typename?: 'ClinicPostcardSettingGroupByOutputType';
  _count?: Maybe<ClinicPostcardSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicPostcardSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicPostcardSettingMinAggregateOutputType>;
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isRemindersEnabled: Scalars['Boolean'];
  reminderTemplate: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ClinicPostcardSettingListRelationFilter = {
  every?: Maybe<ClinicPostcardSettingWhereInput>;
  none?: Maybe<ClinicPostcardSettingWhereInput>;
  some?: Maybe<ClinicPostcardSettingWhereInput>;
};

export type ClinicPostcardSettingMaxAggregateOutputType = {
  __typename?: 'ClinicPostcardSettingMaxAggregateOutputType';
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingMaxOrderByAggregateInput = {
  apiKey?: Maybe<SortOrder>;
  apiSecret?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isRemindersEnabled?: Maybe<SortOrder>;
  reminderTemplate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPostcardSettingMinAggregateOutputType = {
  __typename?: 'ClinicPostcardSettingMinAggregateOutputType';
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingMinOrderByAggregateInput = {
  apiKey?: Maybe<SortOrder>;
  apiSecret?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isRemindersEnabled?: Maybe<SortOrder>;
  reminderTemplate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPostcardSettingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicPostcardSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPostcardSettingOrderByRelevanceInput>;
  apiKey?: Maybe<SortOrder>;
  apiSecret?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isRemindersEnabled?: Maybe<SortOrder>;
  reminderTemplate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPostcardSettingOrderByRelevanceFieldEnum {
  ApiKey = 'apiKey',
  ApiSecret = 'apiSecret',
  ClinicId = 'clinicId',
  Id = 'id',
  ReminderTemplate = 'reminderTemplate'
}

export type ClinicPostcardSettingOrderByRelevanceInput = {
  fields: Array<ClinicPostcardSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicPostcardSettingOrderByWithAggregationInput = {
  _count?: Maybe<ClinicPostcardSettingCountOrderByAggregateInput>;
  _max?: Maybe<ClinicPostcardSettingMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicPostcardSettingMinOrderByAggregateInput>;
  apiKey?: Maybe<SortOrder>;
  apiSecret?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isRemindersEnabled?: Maybe<SortOrder>;
  reminderTemplate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPostcardSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicPostcardSettingOrderByRelevanceInput>;
  apiKey?: Maybe<SortOrder>;
  apiSecret?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isRemindersEnabled?: Maybe<SortOrder>;
  reminderTemplate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicPostcardSettingOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicPostcardSettingOrderByRelevanceInput>;
  apiKey?: Maybe<SortOrder>;
  apiSecret?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isRemindersEnabled?: Maybe<SortOrder>;
  reminderTemplate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicPostcardSettingScalarFieldEnum {
  ApiKey = 'apiKey',
  ApiSecret = 'apiSecret',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsRemindersEnabled = 'isRemindersEnabled',
  ReminderTemplate = 'reminderTemplate',
  UpdatedAt = 'updatedAt'
}

export type ClinicPostcardSettingScalarWhereInput = {
  AND?: Maybe<Array<ClinicPostcardSettingScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicPostcardSettingScalarWhereInput>>;
  OR?: Maybe<Array<ClinicPostcardSettingScalarWhereInput>>;
  apiKey?: Maybe<StringFilter>;
  apiSecret?: Maybe<StringFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isRemindersEnabled?: Maybe<BoolFilter>;
  reminderTemplate?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPostcardSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicPostcardSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicPostcardSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicPostcardSettingScalarWhereWithAggregatesInput>>;
  apiKey?: Maybe<StringWithAggregatesFilter>;
  apiSecret?: Maybe<StringWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isRemindersEnabled?: Maybe<BoolWithAggregatesFilter>;
  reminderTemplate?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicPostcardSettingUncheckedCreateInput = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicPostcardSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPostcardSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPostcardSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPostcardSettingCreateManyClinicInputEnvelope>;
};

export type ClinicPostcardSettingUncheckedCreateWithoutClinicInput = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingUncheckedUpdateInput = {
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingUncheckedUpdateManyInput = {
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingUncheckedUpdateManyWithoutClinicInput = {
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicPostcardSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPostcardSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPostcardSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPostcardSettingCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicPostcardSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPostcardSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPostcardSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPostcardSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPostcardSettingUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicPostcardSettingUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicPostcardSettingUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicPostcardSettingUncheckedUpdateWithoutClinicInput = {
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingUpdateInput = {
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutPostcardSettingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingUpdateManyMutationInput = {
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicPostcardSettingUpdateManyMutationInput;
  where: ClinicPostcardSettingScalarWhereInput;
};

export type ClinicPostcardSettingUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicPostcardSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicPostcardSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicPostcardSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicPostcardSettingCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicPostcardSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicPostcardSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicPostcardSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicPostcardSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicPostcardSettingUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicPostcardSettingUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicPostcardSettingUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicPostcardSettingUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicPostcardSettingUpdateWithoutClinicInput;
  where: ClinicPostcardSettingWhereUniqueInput;
};

export type ClinicPostcardSettingUpdateWithoutClinicInput = {
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
  reminderTemplate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicPostcardSettingUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicPostcardSettingCreateWithoutClinicInput;
  update: ClinicPostcardSettingUpdateWithoutClinicInput;
  where: ClinicPostcardSettingWhereUniqueInput;
};

export type ClinicPostcardSettingWhereInput = {
  AND?: Maybe<Array<ClinicPostcardSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicPostcardSettingWhereInput>>;
  OR?: Maybe<Array<ClinicPostcardSettingWhereInput>>;
  apiKey?: Maybe<StringFilter>;
  apiSecret?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isRemindersEnabled?: Maybe<BoolFilter>;
  reminderTemplate?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicPostcardSettingWhereUniqueInput = {
  AND?: Maybe<Array<ClinicPostcardSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicPostcardSettingWhereInput>>;
  OR?: Maybe<Array<ClinicPostcardSettingWhereInput>>;
  apiKey?: Maybe<StringFilter>;
  apiSecret?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isRemindersEnabled?: Maybe<BoolFilter>;
  reminderTemplate?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicRoom = {
  __typename?: 'ClinicRoom';
  ProviderAppointmentTypeRoomMap: Array<ProviderAppointmentTypeRoomMap>;
  _count: ClinicRoomCountOutputType;
  appointmentAvailability: Array<AppointmentAvailability>;
  appointments: Array<Appointment>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userAppointmentGroupings: Array<UserAppointmentGrouping>;
  vetAvailabilityClinicRoomMaps: Array<VetAvailabilityClinicRoomMap>;
  workflows: Array<ClinicRoomToWorkflowEventSetting>;
};


export type ClinicRoomProviderAppointmentTypeRoomMapArgs = {
  cursor?: Maybe<ProviderAppointmentTypeRoomMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProviderAppointmentTypeRoomMapWhereInput>;
};


export type ClinicRoomAppointmentAvailabilityArgs = {
  cursor?: Maybe<AppointmentAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentAvailabilityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentAvailabilityWhereInput>;
};


export type ClinicRoomAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type ClinicRoomClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type ClinicRoomIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type ClinicRoomUserAppointmentGroupingsArgs = {
  cursor?: Maybe<UserAppointmentGroupingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserAppointmentGroupingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserAppointmentGroupingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAppointmentGroupingWhereInput>;
};


export type ClinicRoomVetAvailabilityClinicRoomMapsArgs = {
  cursor?: Maybe<VetAvailabilityClinicRoomMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityClinicRoomMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityClinicRoomMapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityClinicRoomMapWhereInput>;
};


export type ClinicRoomWorkflowsArgs = {
  cursor?: Maybe<ClinicRoomToWorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicRoomToWorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicRoomToWorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicRoomToWorkflowEventSettingWhereInput>;
};

export type ClinicRoomClinicRoomPimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type ClinicRoomCountAggregateOutputType = {
  __typename?: 'ClinicRoomCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isSchedulable: Scalars['Int'];
  isVisible: Scalars['Int'];
  name: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicRoomCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicRoomCountOutputType = {
  __typename?: 'ClinicRoomCountOutputType';
  ProviderAppointmentTypeRoomMap: Scalars['Int'];
  appointmentAvailability: Scalars['Int'];
  appointments: Scalars['Int'];
  userAppointmentGroupings: Scalars['Int'];
  vetAvailabilityClinicRoomMaps: Scalars['Int'];
  workflows: Scalars['Int'];
};

export type ClinicRoomCreateInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutRoomInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicRoomsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutRoomsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomCreateManyClinicInputEnvelope = {
  data: Array<ClinicRoomCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicRoomCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomCreateManyIntegrationInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomCreateManyIntegrationInputEnvelope = {
  data: Array<ClinicRoomCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicRoomCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicRoomCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicRoomCreateManyClinicInputEnvelope>;
};

export type ClinicRoomCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicRoomCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicRoomCreateManyIntegrationInputEnvelope>;
};

export type ClinicRoomCreateNestedManyWithoutUserAppointmentGroupingsInput = {
  connect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomCreateOrConnectWithoutUserAppointmentGroupingsInput>>;
  create?: Maybe<Array<ClinicRoomCreateWithoutUserAppointmentGroupingsInput>>;
};

export type ClinicRoomCreateNestedOneWithoutAppointmentAvailabilityInput = {
  connect?: Maybe<ClinicRoomWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicRoomCreateOrConnectWithoutAppointmentAvailabilityInput>;
  create?: Maybe<ClinicRoomCreateWithoutAppointmentAvailabilityInput>;
};

export type ClinicRoomCreateNestedOneWithoutAppointmentsInput = {
  connect?: Maybe<ClinicRoomWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicRoomCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<ClinicRoomCreateWithoutAppointmentsInput>;
};

export type ClinicRoomCreateNestedOneWithoutProviderAppointmentTypeRoomMapInput = {
  connect?: Maybe<ClinicRoomWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicRoomCreateOrConnectWithoutProviderAppointmentTypeRoomMapInput>;
  create?: Maybe<ClinicRoomCreateWithoutProviderAppointmentTypeRoomMapInput>;
};

export type ClinicRoomCreateNestedOneWithoutVetAvailabilityClinicRoomMapsInput = {
  connect?: Maybe<ClinicRoomWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicRoomCreateOrConnectWithoutVetAvailabilityClinicRoomMapsInput>;
  create?: Maybe<ClinicRoomCreateWithoutVetAvailabilityClinicRoomMapsInput>;
};

export type ClinicRoomCreateNestedOneWithoutWorkflowsInput = {
  connect?: Maybe<ClinicRoomWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicRoomCreateOrConnectWithoutWorkflowsInput>;
  create?: Maybe<ClinicRoomCreateWithoutWorkflowsInput>;
};

export type ClinicRoomCreateOrConnectWithoutAppointmentAvailabilityInput = {
  create: ClinicRoomCreateWithoutAppointmentAvailabilityInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomCreateOrConnectWithoutAppointmentsInput = {
  create: ClinicRoomCreateWithoutAppointmentsInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomCreateOrConnectWithoutClinicInput = {
  create: ClinicRoomCreateWithoutClinicInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomCreateOrConnectWithoutIntegrationInput = {
  create: ClinicRoomCreateWithoutIntegrationInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomCreateOrConnectWithoutProviderAppointmentTypeRoomMapInput = {
  create: ClinicRoomCreateWithoutProviderAppointmentTypeRoomMapInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomCreateOrConnectWithoutUserAppointmentGroupingsInput = {
  create: ClinicRoomCreateWithoutUserAppointmentGroupingsInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomCreateOrConnectWithoutVetAvailabilityClinicRoomMapsInput = {
  create: ClinicRoomCreateWithoutVetAvailabilityClinicRoomMapsInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomCreateOrConnectWithoutWorkflowsInput = {
  create: ClinicRoomCreateWithoutWorkflowsInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomCreateWithoutAppointmentAvailabilityInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutRoomInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicRoomsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutRoomsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomCreateWithoutAppointmentsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutRoomInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicRoomsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutRoomsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomCreateWithoutClinicInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutRoomInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutRoomsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomCreateWithoutIntegrationInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutRoomInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicRoomsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomCreateWithoutProviderAppointmentTypeRoomMapInput = {
  appointmentAvailability?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutRoomInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicRoomsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutRoomsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomCreateWithoutUserAppointmentGroupingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutRoomInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicRoomsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutRoomsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomCreateWithoutVetAvailabilityClinicRoomMapsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutRoomInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicRoomsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutRoomsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutRoomsInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomCreateWithoutWorkflowsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutRoomInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicRoomsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutRoomsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomGroupByOutputType = {
  __typename?: 'ClinicRoomGroupByOutputType';
  _count?: Maybe<ClinicRoomCountAggregateOutputType>;
  _max?: Maybe<ClinicRoomMaxAggregateOutputType>;
  _min?: Maybe<ClinicRoomMinAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ClinicRoomListRelationFilter = {
  every?: Maybe<ClinicRoomWhereInput>;
  none?: Maybe<ClinicRoomWhereInput>;
  some?: Maybe<ClinicRoomWhereInput>;
};

export type ClinicRoomMaxAggregateOutputType = {
  __typename?: 'ClinicRoomMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicRoomMinAggregateOutputType = {
  __typename?: 'ClinicRoomMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicRoomNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicRoomWhereInput>>;
  NOT?: Maybe<Array<ClinicRoomWhereInput>>;
  OR?: Maybe<Array<ClinicRoomWhereInput>>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapListRelationFilter>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isSchedulable?: Maybe<BoolNullableFilter>;
  isVisible?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapListRelationFilter>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingListRelationFilter>;
};

export type ClinicRoomOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicRoomOrderByRelationAndSearchRelevanceInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicRoomOrderByRelevanceInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapOrderByRelationAggregateInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum ClinicRoomOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  IntegrationId = 'integrationId',
  Name = 'name',
  PimsId = 'pimsId',
  Type = 'type'
}

export type ClinicRoomOrderByRelevanceInput = {
  fields: Array<ClinicRoomOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicRoomOrderByWithAggregationInput = {
  _count?: Maybe<ClinicRoomCountOrderByAggregateInput>;
  _max?: Maybe<ClinicRoomMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicRoomMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicRoomOrderByWithRelationAndSearchRelevanceInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicRoomOrderByRelevanceInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapOrderByRelationAggregateInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingOrderByRelationAggregateInput>;
};

export type ClinicRoomOrderByWithRelationInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapOrderByRelationAggregateInput>;
  _relevance?: Maybe<ClinicRoomOrderByRelevanceInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isSchedulable?: Maybe<SortOrder>;
  isVisible?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapOrderByRelationAggregateInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum ClinicRoomScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  IsSchedulable = 'isSchedulable',
  IsVisible = 'isVisible',
  Name = 'name',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type ClinicRoomScalarRelationFilter = {
  AND?: Maybe<Array<ClinicRoomWhereInput>>;
  NOT?: Maybe<Array<ClinicRoomWhereInput>>;
  OR?: Maybe<Array<ClinicRoomWhereInput>>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapListRelationFilter>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isSchedulable?: Maybe<BoolNullableFilter>;
  isVisible?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapListRelationFilter>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingListRelationFilter>;
};

export type ClinicRoomScalarWhereInput = {
  AND?: Maybe<Array<ClinicRoomScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicRoomScalarWhereInput>>;
  OR?: Maybe<Array<ClinicRoomScalarWhereInput>>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isSchedulable?: Maybe<BoolNullableFilter>;
  isVisible?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicRoomScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicRoomScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicRoomScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicRoomScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  isActive?: Maybe<BoolNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolNullableWithAggregatesFilter>;
  isSchedulable?: Maybe<BoolNullableWithAggregatesFilter>;
  isVisible?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  type?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicRoomToWorkflowEventSetting = {
  __typename?: 'ClinicRoomToWorkflowEventSetting';
  clinicRoom: ClinicRoom;
  clinicRoomId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  workflow: WorkflowEventSetting;
  workflowId: Scalars['String'];
};

export type ClinicRoomToWorkflowEventSettingCountAggregateOutputType = {
  __typename?: 'ClinicRoomToWorkflowEventSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicRoomId: Scalars['Int'];
  createdAt: Scalars['Int'];
  workflowId: Scalars['Int'];
};

export type ClinicRoomToWorkflowEventSettingCountOrderByAggregateInput = {
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflowId?: Maybe<SortOrder>;
};

export type ClinicRoomToWorkflowEventSettingCreateInput = {
  clinicRoom: ClinicRoomCreateNestedOneWithoutWorkflowsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  workflow: WorkflowEventSettingCreateNestedOneWithoutClinicRoomsInput;
};

export type ClinicRoomToWorkflowEventSettingCreateManyClinicRoomInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['String'];
};

export type ClinicRoomToWorkflowEventSettingCreateManyClinicRoomInputEnvelope = {
  data: Array<ClinicRoomToWorkflowEventSettingCreateManyClinicRoomInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicRoomToWorkflowEventSettingCreateManyInput = {
  clinicRoomId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['String'];
};

export type ClinicRoomToWorkflowEventSettingCreateManyWorkflowInput = {
  clinicRoomId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomToWorkflowEventSettingCreateManyWorkflowInputEnvelope = {
  data: Array<ClinicRoomToWorkflowEventSettingCreateManyWorkflowInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutClinicRoomInput = {
  connect?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateOrConnectWithoutClinicRoomInput>>;
  create?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateWithoutClinicRoomInput>>;
  createMany?: Maybe<ClinicRoomToWorkflowEventSettingCreateManyClinicRoomInputEnvelope>;
};

export type ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput = {
  connect?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateOrConnectWithoutWorkflowInput>>;
  create?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateWithoutWorkflowInput>>;
  createMany?: Maybe<ClinicRoomToWorkflowEventSettingCreateManyWorkflowInputEnvelope>;
};

export type ClinicRoomToWorkflowEventSettingCreateOrConnectWithoutClinicRoomInput = {
  create: ClinicRoomToWorkflowEventSettingCreateWithoutClinicRoomInput;
  where: ClinicRoomToWorkflowEventSettingWhereUniqueInput;
};

export type ClinicRoomToWorkflowEventSettingCreateOrConnectWithoutWorkflowInput = {
  create: ClinicRoomToWorkflowEventSettingCreateWithoutWorkflowInput;
  where: ClinicRoomToWorkflowEventSettingWhereUniqueInput;
};

export type ClinicRoomToWorkflowEventSettingCreateWithoutClinicRoomInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  workflow: WorkflowEventSettingCreateNestedOneWithoutClinicRoomsInput;
};

export type ClinicRoomToWorkflowEventSettingCreateWithoutWorkflowInput = {
  clinicRoom: ClinicRoomCreateNestedOneWithoutWorkflowsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomToWorkflowEventSettingGroupByOutputType = {
  __typename?: 'ClinicRoomToWorkflowEventSettingGroupByOutputType';
  _count?: Maybe<ClinicRoomToWorkflowEventSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicRoomToWorkflowEventSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicRoomToWorkflowEventSettingMinAggregateOutputType>;
  clinicRoomId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  workflowId: Scalars['String'];
};

export type ClinicRoomToWorkflowEventSettingListRelationFilter = {
  every?: Maybe<ClinicRoomToWorkflowEventSettingWhereInput>;
  none?: Maybe<ClinicRoomToWorkflowEventSettingWhereInput>;
  some?: Maybe<ClinicRoomToWorkflowEventSettingWhereInput>;
};

export type ClinicRoomToWorkflowEventSettingMaxAggregateOutputType = {
  __typename?: 'ClinicRoomToWorkflowEventSettingMaxAggregateOutputType';
  clinicRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type ClinicRoomToWorkflowEventSettingMaxOrderByAggregateInput = {
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflowId?: Maybe<SortOrder>;
};

export type ClinicRoomToWorkflowEventSettingMinAggregateOutputType = {
  __typename?: 'ClinicRoomToWorkflowEventSettingMinAggregateOutputType';
  clinicRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type ClinicRoomToWorkflowEventSettingMinOrderByAggregateInput = {
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflowId?: Maybe<SortOrder>;
};

export type ClinicRoomToWorkflowEventSettingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicRoomToWorkflowEventSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicRoomToWorkflowEventSettingOrderByRelevanceInput>;
  clinicRoom?: Maybe<ClinicRoomOrderByWithRelationInput>;
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflow?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowId?: Maybe<SortOrder>;
};

export enum ClinicRoomToWorkflowEventSettingOrderByRelevanceFieldEnum {
  ClinicRoomId = 'clinicRoomId',
  WorkflowId = 'workflowId'
}

export type ClinicRoomToWorkflowEventSettingOrderByRelevanceInput = {
  fields: Array<ClinicRoomToWorkflowEventSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicRoomToWorkflowEventSettingOrderByWithAggregationInput = {
  _count?: Maybe<ClinicRoomToWorkflowEventSettingCountOrderByAggregateInput>;
  _max?: Maybe<ClinicRoomToWorkflowEventSettingMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicRoomToWorkflowEventSettingMinOrderByAggregateInput>;
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflowId?: Maybe<SortOrder>;
};

export type ClinicRoomToWorkflowEventSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicRoomToWorkflowEventSettingOrderByRelevanceInput>;
  clinicRoom?: Maybe<ClinicRoomOrderByWithRelationInput>;
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflow?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowId?: Maybe<SortOrder>;
};

export type ClinicRoomToWorkflowEventSettingOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicRoomToWorkflowEventSettingOrderByRelevanceInput>;
  clinicRoom?: Maybe<ClinicRoomOrderByWithRelationInput>;
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  workflow?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowId?: Maybe<SortOrder>;
};

export enum ClinicRoomToWorkflowEventSettingScalarFieldEnum {
  ClinicRoomId = 'clinicRoomId',
  CreatedAt = 'createdAt',
  WorkflowId = 'workflowId'
}

export type ClinicRoomToWorkflowEventSettingScalarWhereInput = {
  AND?: Maybe<Array<ClinicRoomToWorkflowEventSettingScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicRoomToWorkflowEventSettingScalarWhereInput>>;
  OR?: Maybe<Array<ClinicRoomToWorkflowEventSettingScalarWhereInput>>;
  clinicRoomId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  workflowId?: Maybe<StringFilter>;
};

export type ClinicRoomToWorkflowEventSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicRoomToWorkflowEventSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicRoomToWorkflowEventSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicRoomToWorkflowEventSettingScalarWhereWithAggregatesInput>>;
  clinicRoomId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  workflowId?: Maybe<StringWithAggregatesFilter>;
};

export type ClinicRoomToWorkflowEventSettingUncheckedCreateInput = {
  clinicRoomId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['String'];
};

export type ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicRoomInput = {
  connect?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateOrConnectWithoutClinicRoomInput>>;
  create?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateWithoutClinicRoomInput>>;
  createMany?: Maybe<ClinicRoomToWorkflowEventSettingCreateManyClinicRoomInputEnvelope>;
};

export type ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput = {
  connect?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateOrConnectWithoutWorkflowInput>>;
  create?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateWithoutWorkflowInput>>;
  createMany?: Maybe<ClinicRoomToWorkflowEventSettingCreateManyWorkflowInputEnvelope>;
};

export type ClinicRoomToWorkflowEventSettingUncheckedCreateWithoutClinicRoomInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['String'];
};

export type ClinicRoomToWorkflowEventSettingUncheckedCreateWithoutWorkflowInput = {
  clinicRoomId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomToWorkflowEventSettingUncheckedUpdateInput = {
  clinicRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type ClinicRoomToWorkflowEventSettingUncheckedUpdateManyInput = {
  clinicRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutClinicRoomInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutClinicRoomNestedInput = {
  connect?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateOrConnectWithoutClinicRoomInput>>;
  create?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateWithoutClinicRoomInput>>;
  createMany?: Maybe<ClinicRoomToWorkflowEventSettingCreateManyClinicRoomInputEnvelope>;
  delete?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicRoomToWorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicRoomToWorkflowEventSettingUpdateWithWhereUniqueWithoutClinicRoomInput>>;
  updateMany?: Maybe<Array<ClinicRoomToWorkflowEventSettingUpdateManyWithWhereWithoutClinicRoomInput>>;
  upsert?: Maybe<Array<ClinicRoomToWorkflowEventSettingUpsertWithWhereUniqueWithoutClinicRoomInput>>;
};

export type ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowInput = {
  clinicRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput = {
  connect?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateOrConnectWithoutWorkflowInput>>;
  create?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateWithoutWorkflowInput>>;
  createMany?: Maybe<ClinicRoomToWorkflowEventSettingCreateManyWorkflowInputEnvelope>;
  delete?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicRoomToWorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicRoomToWorkflowEventSettingUpdateWithWhereUniqueWithoutWorkflowInput>>;
  updateMany?: Maybe<Array<ClinicRoomToWorkflowEventSettingUpdateManyWithWhereWithoutWorkflowInput>>;
  upsert?: Maybe<Array<ClinicRoomToWorkflowEventSettingUpsertWithWhereUniqueWithoutWorkflowInput>>;
};

export type ClinicRoomToWorkflowEventSettingUncheckedUpdateWithoutClinicRoomInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type ClinicRoomToWorkflowEventSettingUncheckedUpdateWithoutWorkflowInput = {
  clinicRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomToWorkflowEventSettingUpdateInput = {
  clinicRoom?: Maybe<ClinicRoomUpdateOneRequiredWithoutWorkflowsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutClinicRoomsNestedInput>;
};

export type ClinicRoomToWorkflowEventSettingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomToWorkflowEventSettingUpdateManyWithWhereWithoutClinicRoomInput = {
  data: ClinicRoomToWorkflowEventSettingUpdateManyMutationInput;
  where: ClinicRoomToWorkflowEventSettingScalarWhereInput;
};

export type ClinicRoomToWorkflowEventSettingUpdateManyWithWhereWithoutWorkflowInput = {
  data: ClinicRoomToWorkflowEventSettingUpdateManyMutationInput;
  where: ClinicRoomToWorkflowEventSettingScalarWhereInput;
};

export type ClinicRoomToWorkflowEventSettingUpdateManyWithoutClinicRoomNestedInput = {
  connect?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateOrConnectWithoutClinicRoomInput>>;
  create?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateWithoutClinicRoomInput>>;
  createMany?: Maybe<ClinicRoomToWorkflowEventSettingCreateManyClinicRoomInputEnvelope>;
  delete?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicRoomToWorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicRoomToWorkflowEventSettingUpdateWithWhereUniqueWithoutClinicRoomInput>>;
  updateMany?: Maybe<Array<ClinicRoomToWorkflowEventSettingUpdateManyWithWhereWithoutClinicRoomInput>>;
  upsert?: Maybe<Array<ClinicRoomToWorkflowEventSettingUpsertWithWhereUniqueWithoutClinicRoomInput>>;
};

export type ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput = {
  connect?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateOrConnectWithoutWorkflowInput>>;
  create?: Maybe<Array<ClinicRoomToWorkflowEventSettingCreateWithoutWorkflowInput>>;
  createMany?: Maybe<ClinicRoomToWorkflowEventSettingCreateManyWorkflowInputEnvelope>;
  delete?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicRoomToWorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicRoomToWorkflowEventSettingUpdateWithWhereUniqueWithoutWorkflowInput>>;
  updateMany?: Maybe<Array<ClinicRoomToWorkflowEventSettingUpdateManyWithWhereWithoutWorkflowInput>>;
  upsert?: Maybe<Array<ClinicRoomToWorkflowEventSettingUpsertWithWhereUniqueWithoutWorkflowInput>>;
};

export type ClinicRoomToWorkflowEventSettingUpdateWithWhereUniqueWithoutClinicRoomInput = {
  data: ClinicRoomToWorkflowEventSettingUpdateWithoutClinicRoomInput;
  where: ClinicRoomToWorkflowEventSettingWhereUniqueInput;
};

export type ClinicRoomToWorkflowEventSettingUpdateWithWhereUniqueWithoutWorkflowInput = {
  data: ClinicRoomToWorkflowEventSettingUpdateWithoutWorkflowInput;
  where: ClinicRoomToWorkflowEventSettingWhereUniqueInput;
};

export type ClinicRoomToWorkflowEventSettingUpdateWithoutClinicRoomInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutClinicRoomsNestedInput>;
};

export type ClinicRoomToWorkflowEventSettingUpdateWithoutWorkflowInput = {
  clinicRoom?: Maybe<ClinicRoomUpdateOneRequiredWithoutWorkflowsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomToWorkflowEventSettingUpsertWithWhereUniqueWithoutClinicRoomInput = {
  create: ClinicRoomToWorkflowEventSettingCreateWithoutClinicRoomInput;
  update: ClinicRoomToWorkflowEventSettingUpdateWithoutClinicRoomInput;
  where: ClinicRoomToWorkflowEventSettingWhereUniqueInput;
};

export type ClinicRoomToWorkflowEventSettingUpsertWithWhereUniqueWithoutWorkflowInput = {
  create: ClinicRoomToWorkflowEventSettingCreateWithoutWorkflowInput;
  update: ClinicRoomToWorkflowEventSettingUpdateWithoutWorkflowInput;
  where: ClinicRoomToWorkflowEventSettingWhereUniqueInput;
};

export type ClinicRoomToWorkflowEventSettingWhereInput = {
  AND?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereInput>>;
  OR?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereInput>>;
  clinicRoom?: Maybe<ClinicRoomScalarRelationFilter>;
  clinicRoomId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  workflow?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  workflowId?: Maybe<StringFilter>;
};

export type ClinicRoomToWorkflowEventSettingWhereUniqueInput = {
  AND?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereInput>>;
  OR?: Maybe<Array<ClinicRoomToWorkflowEventSettingWhereInput>>;
  clinicRoom?: Maybe<ClinicRoomScalarRelationFilter>;
  clinicRoomId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  workflow?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  workflowId?: Maybe<StringFilter>;
  workflowId_clinicRoomId?: Maybe<ClinicRoomToWorkflowEventSettingWorkflowIdClinicRoomIdCompoundUniqueInput>;
};

export type ClinicRoomToWorkflowEventSettingWorkflowIdClinicRoomIdCompoundUniqueInput = {
  clinicRoomId: Scalars['String'];
  workflowId: Scalars['String'];
};

export type ClinicRoomUncheckedCreateInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRoomInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicRoomCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicRoomCreateManyClinicInputEnvelope>;
};

export type ClinicRoomUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicRoomCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicRoomCreateManyIntegrationInputEnvelope>;
};

export type ClinicRoomUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput = {
  connect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomCreateOrConnectWithoutUserAppointmentGroupingsInput>>;
  create?: Maybe<Array<ClinicRoomCreateWithoutUserAppointmentGroupingsInput>>;
};

export type ClinicRoomUncheckedCreateWithoutAppointmentAvailabilityInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRoomInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomUncheckedCreateWithoutAppointmentsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutRoomInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomUncheckedCreateWithoutClinicInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRoomInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomUncheckedCreateWithoutIntegrationInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRoomInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomUncheckedCreateWithoutProviderAppointmentTypeRoomMapInput = {
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRoomInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomUncheckedCreateWithoutUserAppointmentGroupingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRoomInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutClinicRoomInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomUncheckedCreateWithoutVetAvailabilityClinicRoomMapsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRoomInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutRoomsInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomUncheckedCreateWithoutWorkflowsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutRoomInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutRoomInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRoomInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutRoomsInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutClinicRoomInput>;
};

export type ClinicRoomUncheckedUpdateInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutRoomNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicRoomCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicRoomCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicRoomScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  set?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  update?: Maybe<Array<ClinicRoomUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicRoomUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicRoomUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicRoomUncheckedUpdateManyWithoutIntegrationInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicRoomCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicRoomCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicRoomScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  set?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  update?: Maybe<Array<ClinicRoomUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ClinicRoomUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ClinicRoomUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ClinicRoomUncheckedUpdateManyWithoutUserAppointmentGroupingsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput = {
  connect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomCreateOrConnectWithoutUserAppointmentGroupingsInput>>;
  create?: Maybe<Array<ClinicRoomCreateWithoutUserAppointmentGroupingsInput>>;
  delete?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicRoomScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  set?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  update?: Maybe<Array<ClinicRoomUpdateWithWhereUniqueWithoutUserAppointmentGroupingsInput>>;
  updateMany?: Maybe<Array<ClinicRoomUpdateManyWithWhereWithoutUserAppointmentGroupingsInput>>;
  upsert?: Maybe<Array<ClinicRoomUpsertWithWhereUniqueWithoutUserAppointmentGroupingsInput>>;
};

export type ClinicRoomUncheckedUpdateWithoutAppointmentAvailabilityInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutRoomNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUncheckedUpdateWithoutAppointmentsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutRoomNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUncheckedUpdateWithoutClinicInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutRoomNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUncheckedUpdateWithoutIntegrationInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutRoomNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUncheckedUpdateWithoutProviderAppointmentTypeRoomMapInput = {
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutRoomNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUncheckedUpdateWithoutUserAppointmentGroupingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutRoomNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUncheckedUpdateWithoutVetAvailabilityClinicRoomMapsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutRoomNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutRoomsNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUncheckedUpdateWithoutWorkflowsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutRoomNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUpdateInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutRoomNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicRoomsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutRoomsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicRoomUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicRoomUpdateManyMutationInput;
  where: ClinicRoomScalarWhereInput;
};

export type ClinicRoomUpdateManyWithWhereWithoutIntegrationInput = {
  data: ClinicRoomUpdateManyMutationInput;
  where: ClinicRoomScalarWhereInput;
};

export type ClinicRoomUpdateManyWithWhereWithoutUserAppointmentGroupingsInput = {
  data: ClinicRoomUpdateManyMutationInput;
  where: ClinicRoomScalarWhereInput;
};

export type ClinicRoomUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicRoomCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicRoomCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicRoomScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  set?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  update?: Maybe<Array<ClinicRoomUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicRoomUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicRoomUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicRoomUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ClinicRoomCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ClinicRoomCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicRoomScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  set?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  update?: Maybe<Array<ClinicRoomUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ClinicRoomUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ClinicRoomUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ClinicRoomUpdateManyWithoutUserAppointmentGroupingsNestedInput = {
  connect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicRoomCreateOrConnectWithoutUserAppointmentGroupingsInput>>;
  create?: Maybe<Array<ClinicRoomCreateWithoutUserAppointmentGroupingsInput>>;
  delete?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicRoomScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  set?: Maybe<Array<ClinicRoomWhereUniqueInput>>;
  update?: Maybe<Array<ClinicRoomUpdateWithWhereUniqueWithoutUserAppointmentGroupingsInput>>;
  updateMany?: Maybe<Array<ClinicRoomUpdateManyWithWhereWithoutUserAppointmentGroupingsInput>>;
  upsert?: Maybe<Array<ClinicRoomUpsertWithWhereUniqueWithoutUserAppointmentGroupingsInput>>;
};

export type ClinicRoomUpdateOneRequiredWithoutProviderAppointmentTypeRoomMapNestedInput = {
  connect?: Maybe<ClinicRoomWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicRoomCreateOrConnectWithoutProviderAppointmentTypeRoomMapInput>;
  create?: Maybe<ClinicRoomCreateWithoutProviderAppointmentTypeRoomMapInput>;
  update?: Maybe<ClinicRoomUpdateToOneWithWhereWithoutProviderAppointmentTypeRoomMapInput>;
  upsert?: Maybe<ClinicRoomUpsertWithoutProviderAppointmentTypeRoomMapInput>;
};

export type ClinicRoomUpdateOneRequiredWithoutVetAvailabilityClinicRoomMapsNestedInput = {
  connect?: Maybe<ClinicRoomWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicRoomCreateOrConnectWithoutVetAvailabilityClinicRoomMapsInput>;
  create?: Maybe<ClinicRoomCreateWithoutVetAvailabilityClinicRoomMapsInput>;
  update?: Maybe<ClinicRoomUpdateToOneWithWhereWithoutVetAvailabilityClinicRoomMapsInput>;
  upsert?: Maybe<ClinicRoomUpsertWithoutVetAvailabilityClinicRoomMapsInput>;
};

export type ClinicRoomUpdateOneRequiredWithoutWorkflowsNestedInput = {
  connect?: Maybe<ClinicRoomWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicRoomCreateOrConnectWithoutWorkflowsInput>;
  create?: Maybe<ClinicRoomCreateWithoutWorkflowsInput>;
  update?: Maybe<ClinicRoomUpdateToOneWithWhereWithoutWorkflowsInput>;
  upsert?: Maybe<ClinicRoomUpsertWithoutWorkflowsInput>;
};

export type ClinicRoomUpdateOneWithoutAppointmentAvailabilityNestedInput = {
  connect?: Maybe<ClinicRoomWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicRoomCreateOrConnectWithoutAppointmentAvailabilityInput>;
  create?: Maybe<ClinicRoomCreateWithoutAppointmentAvailabilityInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicRoomUpdateToOneWithWhereWithoutAppointmentAvailabilityInput>;
  upsert?: Maybe<ClinicRoomUpsertWithoutAppointmentAvailabilityInput>;
};

export type ClinicRoomUpdateOneWithoutAppointmentsNestedInput = {
  connect?: Maybe<ClinicRoomWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicRoomCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<ClinicRoomCreateWithoutAppointmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicRoomUpdateToOneWithWhereWithoutAppointmentsInput>;
  upsert?: Maybe<ClinicRoomUpsertWithoutAppointmentsInput>;
};

export type ClinicRoomUpdateToOneWithWhereWithoutAppointmentAvailabilityInput = {
  data: ClinicRoomUpdateWithoutAppointmentAvailabilityInput;
  where?: Maybe<ClinicRoomWhereInput>;
};

export type ClinicRoomUpdateToOneWithWhereWithoutAppointmentsInput = {
  data: ClinicRoomUpdateWithoutAppointmentsInput;
  where?: Maybe<ClinicRoomWhereInput>;
};

export type ClinicRoomUpdateToOneWithWhereWithoutProviderAppointmentTypeRoomMapInput = {
  data: ClinicRoomUpdateWithoutProviderAppointmentTypeRoomMapInput;
  where?: Maybe<ClinicRoomWhereInput>;
};

export type ClinicRoomUpdateToOneWithWhereWithoutVetAvailabilityClinicRoomMapsInput = {
  data: ClinicRoomUpdateWithoutVetAvailabilityClinicRoomMapsInput;
  where?: Maybe<ClinicRoomWhereInput>;
};

export type ClinicRoomUpdateToOneWithWhereWithoutWorkflowsInput = {
  data: ClinicRoomUpdateWithoutWorkflowsInput;
  where?: Maybe<ClinicRoomWhereInput>;
};

export type ClinicRoomUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicRoomUpdateWithoutClinicInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: ClinicRoomUpdateWithoutIntegrationInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomUpdateWithWhereUniqueWithoutUserAppointmentGroupingsInput = {
  data: ClinicRoomUpdateWithoutUserAppointmentGroupingsInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomUpdateWithoutAppointmentAvailabilityInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutRoomNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicRoomsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutRoomsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUpdateWithoutAppointmentsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUpdateManyWithoutRoomNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicRoomsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutRoomsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUpdateWithoutClinicInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutRoomNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutRoomsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUpdateWithoutIntegrationInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutRoomNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicRoomsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUpdateWithoutProviderAppointmentTypeRoomMapInput = {
  appointmentAvailability?: Maybe<AppointmentAvailabilityUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutRoomNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicRoomsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutRoomsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUpdateWithoutUserAppointmentGroupingsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutRoomNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicRoomsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutRoomsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUpdateManyWithoutClinicRoomNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUpdateWithoutVetAvailabilityClinicRoomMapsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutRoomNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicRoomsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutRoomsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutRoomsNestedInput>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUpdateWithoutWorkflowsInput = {
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapUpdateManyWithoutRoomNestedInput>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityUpdateManyWithoutRoomNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutRoomNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicRoomsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutRoomsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutRoomsNestedInput>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUpdateManyWithoutClinicRoomNestedInput>;
};

export type ClinicRoomUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicRoomCreateWithoutClinicInput;
  update: ClinicRoomUpdateWithoutClinicInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: ClinicRoomCreateWithoutIntegrationInput;
  update: ClinicRoomUpdateWithoutIntegrationInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomUpsertWithWhereUniqueWithoutUserAppointmentGroupingsInput = {
  create: ClinicRoomCreateWithoutUserAppointmentGroupingsInput;
  update: ClinicRoomUpdateWithoutUserAppointmentGroupingsInput;
  where: ClinicRoomWhereUniqueInput;
};

export type ClinicRoomUpsertWithoutAppointmentAvailabilityInput = {
  create: ClinicRoomCreateWithoutAppointmentAvailabilityInput;
  update: ClinicRoomUpdateWithoutAppointmentAvailabilityInput;
  where?: Maybe<ClinicRoomWhereInput>;
};

export type ClinicRoomUpsertWithoutAppointmentsInput = {
  create: ClinicRoomCreateWithoutAppointmentsInput;
  update: ClinicRoomUpdateWithoutAppointmentsInput;
  where?: Maybe<ClinicRoomWhereInput>;
};

export type ClinicRoomUpsertWithoutProviderAppointmentTypeRoomMapInput = {
  create: ClinicRoomCreateWithoutProviderAppointmentTypeRoomMapInput;
  update: ClinicRoomUpdateWithoutProviderAppointmentTypeRoomMapInput;
  where?: Maybe<ClinicRoomWhereInput>;
};

export type ClinicRoomUpsertWithoutVetAvailabilityClinicRoomMapsInput = {
  create: ClinicRoomCreateWithoutVetAvailabilityClinicRoomMapsInput;
  update: ClinicRoomUpdateWithoutVetAvailabilityClinicRoomMapsInput;
  where?: Maybe<ClinicRoomWhereInput>;
};

export type ClinicRoomUpsertWithoutWorkflowsInput = {
  create: ClinicRoomCreateWithoutWorkflowsInput;
  update: ClinicRoomUpdateWithoutWorkflowsInput;
  where?: Maybe<ClinicRoomWhereInput>;
};

export type ClinicRoomWhereInput = {
  AND?: Maybe<Array<ClinicRoomWhereInput>>;
  NOT?: Maybe<Array<ClinicRoomWhereInput>>;
  OR?: Maybe<Array<ClinicRoomWhereInput>>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapListRelationFilter>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isSchedulable?: Maybe<BoolNullableFilter>;
  isVisible?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapListRelationFilter>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingListRelationFilter>;
};

export type ClinicRoomWhereUniqueInput = {
  AND?: Maybe<Array<ClinicRoomWhereInput>>;
  NOT?: Maybe<Array<ClinicRoomWhereInput>>;
  OR?: Maybe<Array<ClinicRoomWhereInput>>;
  ProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMapListRelationFilter>;
  appointmentAvailability?: Maybe<AppointmentAvailabilityListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicRoomPimsIdAndIntegrationId?: Maybe<ClinicRoomClinicRoomPimsIdAndIntegrationIdCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  isSchedulable?: Maybe<BoolNullableFilter>;
  isVisible?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapListRelationFilter>;
  workflows?: Maybe<ClinicRoomToWorkflowEventSettingListRelationFilter>;
};

export enum ClinicScalarFieldEnum {
  ActivationDate = 'activationDate',
  AddressLine1 = 'addressLine1',
  AddressLine2 = 'addressLine2',
  AllowAllUsersToCloseConsultations = 'allowAllUsersToCloseConsultations',
  AutoSubscriptionReceiptEmails = 'autoSubscriptionReceiptEmails',
  AutomaticSubscriptionReceipts = 'automaticSubscriptionReceipts',
  CallerIdPhoneNumber = 'callerIdPhoneNumber',
  CanceledAt = 'canceledAt',
  CancellationNote = 'cancellationNote',
  CancellationReason = 'cancellationReason',
  CarePlanProviderGroupId = 'carePlanProviderGroupId',
  City = 'city',
  ClinicEmail = 'clinicEmail',
  ClinicSettingId = 'clinicSettingId',
  ClinicWidgetSettingId = 'clinicWidgetSettingId',
  ConsultationCost = 'consultationCost',
  CorporateId = 'corporateId',
  Country = 'country',
  CreatedAt = 'createdAt',
  CrmId = 'crmId',
  CrmUrlParams = 'crmUrlParams',
  CustomerId = 'customerId',
  FirebaseId = 'firebaseId',
  FirebaseVets = 'firebaseVets',
  FollowUpCost = 'followUpCost',
  FullAddress = 'fullAddress',
  HasServiceReminders = 'hasServiceReminders',
  HasSmsConversations = 'hasSmsConversations',
  HeadUserId = 'headUserId',
  Hours = 'hours',
  Id = 'id',
  IncomeMethod = 'incomeMethod',
  IntegrationInfo = 'integrationInfo',
  IntegrationSystem = 'integrationSystem',
  IntegrationType = 'integrationType',
  IsAddAppointmentDisabled = 'isAddAppointmentDisabled',
  IsCallerIdVerified = 'isCallerIdVerified',
  IsClinicActive = 'isClinicActive',
  IsClinicEligibleForPayments = 'isClinicEligibleForPayments',
  IsConsultationsActive = 'isConsultationsActive',
  IsIntegrationActive = 'isIntegrationActive',
  IsPaymentUsBank = 'isPaymentUsBank',
  IsServiceRemindersActive = 'isServiceRemindersActive',
  LastPrintOrderedOn = 'lastPrintOrderedOn',
  LastPrintOrderedQuantity = 'lastPrintOrderedQuantity',
  Lat = 'lat',
  LegalEntityId = 'legalEntityId',
  Logo = 'logo',
  Long = 'long',
  LoyaltyProgramId = 'loyaltyProgramId',
  MarketEmail = 'marketEmail',
  MarketFacebookNumber = 'marketFacebookNumber',
  MarketFacebookPageId = 'marketFacebookPageId',
  MarketFacebookPageToken = 'marketFacebookPageToken',
  Name = 'name',
  OptimizedLogoUrl = 'optimizedLogoUrl',
  OrganizationId = 'organizationId',
  PaymentAddress = 'paymentAddress',
  PaymentBankAccountNumber = 'paymentBankAccountNumber',
  PaymentBankRoutingNumber = 'paymentBankRoutingNumber',
  PaymentCity = 'paymentCity',
  PaymentName = 'paymentName',
  PaymentPhone = 'paymentPhone',
  PaymentState = 'paymentState',
  PaymentZip = 'paymentZip',
  Phone = 'phone',
  PostalCode = 'postalCode',
  PpcLocationId = 'ppcLocationId',
  PrintLastOrder = 'printLastOrder',
  PrintReceivedQuantity = 'printReceivedQuantity',
  RemindersIntegrationRequestEmail = 'remindersIntegrationRequestEmail',
  ResponseTime = 'responseTime',
  SmsPhoneNumber = 'smsPhoneNumber',
  State = 'state',
  StripeCustomerId = 'stripeCustomerId',
  StripeSubscriptionId = 'stripeSubscriptionId',
  StripeSubscriptionPlan = 'stripeSubscriptionPlan',
  SubmerchantApprovedAt = 'submerchantApprovedAt',
  SubmerchantId = 'submerchantId',
  SubmerchantIsActive = 'submerchantIsActive',
  SubmerchantStatus = 'submerchantStatus',
  SubmerchantStripeChargesEnabled = 'submerchantStripeChargesEnabled',
  SubmerchantStripeHasCustomPayouts = 'submerchantStripeHasCustomPayouts',
  SubmerchantStripeId = 'submerchantStripeId',
  SubmerchantStripePayoutsEnabled = 'submerchantStripePayoutsEnabled',
  SubmerchantStripeStatus = 'submerchantStripeStatus',
  SubscribedAt = 'subscribedAt',
  SubscriptionId = 'subscriptionId',
  SubscriptionPlan = 'subscriptionPlan',
  Timezone = 'timezone',
  TimezoneName = 'timezoneName',
  Token = 'token',
  UnlayerSettingId = 'unlayerSettingId',
  UnsubscribedAt = 'unsubscribedAt',
  UpdatedAt = 'updatedAt',
  WebsiteUrl = 'websiteUrl',
  WidgetSettings = 'widgetSettings'
}

export type ClinicScalarRelationFilter = {
  AND?: Maybe<Array<ClinicWhereInput>>;
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateListRelationFilter>;
  EmailCampaignLog?: Maybe<EmailCampaignLogListRelationFilter>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeListRelationFilter>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<ClinicWhereInput>>;
  OR?: Maybe<Array<ClinicWhereInput>>;
  Rules?: Maybe<RulesListRelationFilter>;
  activationDate?: Maybe<DateTimeNullableFilter>;
  addressLine1?: Maybe<StringNullableFilter>;
  addressLine2?: Maybe<StringNullableFilter>;
  allowAllUsersToCloseConsultations?: Maybe<BoolNullableFilter>;
  appoinmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  autoSubscriptionReceiptEmails?: Maybe<JsonNullableFilter>;
  automaticSubscriptionReceipts?: Maybe<BoolFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationNullableScalarRelationFilter>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationListRelationFilter>;
  benefitsProvided?: Maybe<CareBenefitUsageListRelationFilter>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckListRelationFilter>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberListRelationFilter>;
  callerIdPhoneNumber?: Maybe<StringNullableFilter>;
  calls?: Maybe<CallHistoryListRelationFilter>;
  canceledAt?: Maybe<DateTimeNullableFilter>;
  cancellationNote?: Maybe<StringNullableFilter>;
  cancellationReason?: Maybe<StringNullableFilter>;
  carePayoutOrganization?: Maybe<OrganizationNullableScalarRelationFilter>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  carePlanProviderGroupId?: Maybe<StringNullableFilter>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionListRelationFilter>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  city?: Maybe<StringNullableFilter>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupNullableScalarRelationFilter>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingListRelationFilter>;
  clinicEmail?: Maybe<StringNullableFilter>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingListRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeListRelationFilter>;
  clinicModules?: Maybe<ClinicModuleListRelationFilter>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourListRelationFilter>;
  clinicOnboardings?: Maybe<ClinicOnboardingListRelationFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberListRelationFilter>;
  clinicRooms?: Maybe<ClinicRoomListRelationFilter>;
  clinicSetting?: Maybe<ClinicSettingNullableScalarRelationFilter>;
  clinicSettingId?: Maybe<StringNullableFilter>;
  clinicUserFilters?: Maybe<ClinicUserFilterListRelationFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingNullableScalarRelationFilter>;
  clinicWidgetSettingId?: Maybe<StringNullableFilter>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeListRelationFilter>;
  consultationCost?: Maybe<FloatNullableFilter>;
  consultationRequests?: Maybe<ConsultationRequestListRelationFilter>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  corporateId?: Maybe<StringNullableFilter>;
  country?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  crmId?: Maybe<StringNullableFilter>;
  crmUrlParams?: Maybe<JsonNullableFilter>;
  customerId?: Maybe<StringNullableFilter>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleListRelationFilter>;
  emailCampaign?: Maybe<EmailCampaignListRelationFilter>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateListRelationFilter>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadListRelationFilter>;
  featureFlags?: Maybe<FeatureFlagListRelationFilter>;
  financialTransactions?: Maybe<FinancialTransactionListRelationFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firebaseVets?: Maybe<JsonNullableFilter>;
  followUpCost?: Maybe<FloatNullableFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  formTemplates?: Maybe<FormTemplateListRelationFilter>;
  fullAddress?: Maybe<StringNullableFilter>;
  googlePlace?: Maybe<GooglePlaceNullableScalarRelationFilter>;
  hasServiceReminders?: Maybe<BoolNullableFilter>;
  hasSmsConversations?: Maybe<BoolNullableFilter>;
  headUserId?: Maybe<StringNullableFilter>;
  hours?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  incomeMethod?: Maybe<StringNullableFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentListRelationFilter>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationListRelationFilter>;
  integrationInfo?: Maybe<JsonNullableFilter>;
  integrationSystem?: Maybe<StringNullableFilter>;
  integrationType?: Maybe<StringNullableFilter>;
  integrations?: Maybe<ClinicPimsIntegrationListRelationFilter>;
  isAddAppointmentDisabled?: Maybe<BoolNullableFilter>;
  isCallerIdVerified?: Maybe<BoolNullableFilter>;
  isClinicActive?: Maybe<BoolFilter>;
  isClinicEligibleForPayments?: Maybe<BoolFilter>;
  isConsultationsActive?: Maybe<BoolNullableFilter>;
  isIntegrationActive?: Maybe<BoolNullableFilter>;
  isPaymentUsBank?: Maybe<BoolNullableFilter>;
  isServiceRemindersActive?: Maybe<BoolNullableFilter>;
  lastPrintOrderedOn?: Maybe<DateTimeNullableFilter>;
  lastPrintOrderedQuantity?: Maybe<IntNullableFilter>;
  lat?: Maybe<FloatNullableFilter>;
  legalEntity?: Maybe<LegalEntityNullableScalarRelationFilter>;
  legalEntityId?: Maybe<StringNullableFilter>;
  logo?: Maybe<StringNullableFilter>;
  long?: Maybe<FloatNullableFilter>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  loyaltyProgram?: Maybe<LoyaltyProgramNullableScalarRelationFilter>;
  loyaltyProgramId?: Maybe<StringNullableFilter>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  marketEmail?: Maybe<StringNullableFilter>;
  marketFacebookNumber?: Maybe<IntNullableFilter>;
  marketFacebookPageId?: Maybe<StringNullableFilter>;
  marketFacebookPageToken?: Maybe<StringNullableFilter>;
  massTextAlerts?: Maybe<MassTextAlertListRelationFilter>;
  media?: Maybe<MediaListRelationFilter>;
  messageTemplates?: Maybe<MessageTemplateListRelationFilter>;
  name?: Maybe<StringFilter>;
  optimizedLogoUrl?: Maybe<StringNullableFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  paymentAddress?: Maybe<StringNullableFilter>;
  paymentBankAccountNumber?: Maybe<StringNullableFilter>;
  paymentBankRoutingNumber?: Maybe<StringNullableFilter>;
  paymentCity?: Maybe<StringNullableFilter>;
  paymentName?: Maybe<StringNullableFilter>;
  paymentPhone?: Maybe<StringNullableFilter>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  paymentState?: Maybe<StringNullableFilter>;
  paymentZip?: Maybe<StringNullableFilter>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodListRelationFilter>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingNullableScalarRelationFilter>;
  pets?: Maybe<PetListRelationFilter>;
  petsId?: Maybe<PetListRelationFilter>;
  phone?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  postcardSettings?: Maybe<ClinicPostcardSettingListRelationFilter>;
  ppcLocationId?: Maybe<IntNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  printLastOrder?: Maybe<DateTimeNullableFilter>;
  printReceivedQuantity?: Maybe<IntNullableFilter>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionListRelationFilter>;
  promoCodes?: Maybe<PromoCodeListRelationFilter>;
  recaps?: Maybe<RecapListRelationFilter>;
  remindersIntegrationRequestEmail?: Maybe<StringNullableFilter>;
  responseTime?: Maybe<FloatNullableFilter>;
  roles?: Maybe<StaffRoleListRelationFilter>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  smsPhoneNumber?: Maybe<StringNullableFilter>;
  staff?: Maybe<VetInfoListRelationFilter>;
  staffId?: Maybe<VetInfoListRelationFilter>;
  state?: Maybe<StringNullableFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountListRelationFilter>;
  stripeSubscriptionId?: Maybe<StringNullableFilter>;
  stripeSubscriptionPlan?: Maybe<StringNullableFilter>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationListRelationFilter>;
  submerchantApprovedAt?: Maybe<DateTimeNullableFilter>;
  submerchantId?: Maybe<StringNullableFilter>;
  submerchantIsActive?: Maybe<BoolNullableFilter>;
  submerchantStatus?: Maybe<StringNullableFilter>;
  submerchantStripeChargesEnabled?: Maybe<BoolNullableFilter>;
  submerchantStripeHasCustomPayouts?: Maybe<BoolNullableFilter>;
  submerchantStripeId?: Maybe<StringNullableFilter>;
  submerchantStripePayoutsEnabled?: Maybe<BoolNullableFilter>;
  submerchantStripeStatus?: Maybe<StringNullableFilter>;
  subscribedAt?: Maybe<DateTimeNullableFilter>;
  subscriptionId?: Maybe<StringNullableFilter>;
  subscriptionPlan?: Maybe<StringNullableFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationNullableScalarRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  timezone?: Maybe<IntNullableFilter>;
  timezoneName?: Maybe<StringNullableFilter>;
  token?: Maybe<StringNullableFilter>;
  twilioConfiguration?: Maybe<TwilioConfigurationNullableScalarRelationFilter>;
  twilioVerifications?: Maybe<TwilioVerificationListRelationFilter>;
  unlayerSetting?: Maybe<UnlayerSettingNullableScalarRelationFilter>;
  unlayerSettingId?: Maybe<IntNullableFilter>;
  unsubscribedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnListRelationFilter>;
  userTaskLists?: Maybe<UserTaskListListRelationFilter>;
  users?: Maybe<UserListRelationFilter>;
  usersId?: Maybe<UserNullableScalarRelationFilter>;
  vaccinations?: Maybe<VaccinationListRelationFilter>;
  vetAvailabilities?: Maybe<VetAvailabilityListRelationFilter>;
  vetsourceInstallation?: Maybe<VetsourceInstallationNullableScalarRelationFilter>;
  websiteUrl?: Maybe<StringNullableFilter>;
  widgetSettings?: Maybe<JsonNullableFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type ClinicScalarWhereInput = {
  AND?: Maybe<Array<ClinicScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicScalarWhereInput>>;
  OR?: Maybe<Array<ClinicScalarWhereInput>>;
  activationDate?: Maybe<DateTimeNullableFilter>;
  addressLine1?: Maybe<StringNullableFilter>;
  addressLine2?: Maybe<StringNullableFilter>;
  allowAllUsersToCloseConsultations?: Maybe<BoolNullableFilter>;
  autoSubscriptionReceiptEmails?: Maybe<JsonNullableFilter>;
  automaticSubscriptionReceipts?: Maybe<BoolFilter>;
  callerIdPhoneNumber?: Maybe<StringNullableFilter>;
  canceledAt?: Maybe<DateTimeNullableFilter>;
  cancellationNote?: Maybe<StringNullableFilter>;
  cancellationReason?: Maybe<StringNullableFilter>;
  carePlanProviderGroupId?: Maybe<StringNullableFilter>;
  city?: Maybe<StringNullableFilter>;
  clinicEmail?: Maybe<StringNullableFilter>;
  clinicSettingId?: Maybe<StringNullableFilter>;
  clinicWidgetSettingId?: Maybe<StringNullableFilter>;
  consultationCost?: Maybe<FloatNullableFilter>;
  corporateId?: Maybe<StringNullableFilter>;
  country?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  crmId?: Maybe<StringNullableFilter>;
  crmUrlParams?: Maybe<JsonNullableFilter>;
  customerId?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firebaseVets?: Maybe<JsonNullableFilter>;
  followUpCost?: Maybe<FloatNullableFilter>;
  fullAddress?: Maybe<StringNullableFilter>;
  hasServiceReminders?: Maybe<BoolNullableFilter>;
  hasSmsConversations?: Maybe<BoolNullableFilter>;
  headUserId?: Maybe<StringNullableFilter>;
  hours?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  incomeMethod?: Maybe<StringNullableFilter>;
  integrationInfo?: Maybe<JsonNullableFilter>;
  integrationSystem?: Maybe<StringNullableFilter>;
  integrationType?: Maybe<StringNullableFilter>;
  isAddAppointmentDisabled?: Maybe<BoolNullableFilter>;
  isCallerIdVerified?: Maybe<BoolNullableFilter>;
  isClinicActive?: Maybe<BoolFilter>;
  isClinicEligibleForPayments?: Maybe<BoolFilter>;
  isConsultationsActive?: Maybe<BoolNullableFilter>;
  isIntegrationActive?: Maybe<BoolNullableFilter>;
  isPaymentUsBank?: Maybe<BoolNullableFilter>;
  isServiceRemindersActive?: Maybe<BoolNullableFilter>;
  lastPrintOrderedOn?: Maybe<DateTimeNullableFilter>;
  lastPrintOrderedQuantity?: Maybe<IntNullableFilter>;
  lat?: Maybe<FloatNullableFilter>;
  legalEntityId?: Maybe<StringNullableFilter>;
  logo?: Maybe<StringNullableFilter>;
  long?: Maybe<FloatNullableFilter>;
  loyaltyProgramId?: Maybe<StringNullableFilter>;
  marketEmail?: Maybe<StringNullableFilter>;
  marketFacebookNumber?: Maybe<IntNullableFilter>;
  marketFacebookPageId?: Maybe<StringNullableFilter>;
  marketFacebookPageToken?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  optimizedLogoUrl?: Maybe<StringNullableFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  paymentAddress?: Maybe<StringNullableFilter>;
  paymentBankAccountNumber?: Maybe<StringNullableFilter>;
  paymentBankRoutingNumber?: Maybe<StringNullableFilter>;
  paymentCity?: Maybe<StringNullableFilter>;
  paymentName?: Maybe<StringNullableFilter>;
  paymentPhone?: Maybe<StringNullableFilter>;
  paymentState?: Maybe<StringNullableFilter>;
  paymentZip?: Maybe<StringNullableFilter>;
  phone?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  ppcLocationId?: Maybe<IntNullableFilter>;
  printLastOrder?: Maybe<DateTimeNullableFilter>;
  printReceivedQuantity?: Maybe<IntNullableFilter>;
  remindersIntegrationRequestEmail?: Maybe<StringNullableFilter>;
  responseTime?: Maybe<FloatNullableFilter>;
  smsPhoneNumber?: Maybe<StringNullableFilter>;
  state?: Maybe<StringNullableFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripeSubscriptionId?: Maybe<StringNullableFilter>;
  stripeSubscriptionPlan?: Maybe<StringNullableFilter>;
  submerchantApprovedAt?: Maybe<DateTimeNullableFilter>;
  submerchantId?: Maybe<StringNullableFilter>;
  submerchantIsActive?: Maybe<BoolNullableFilter>;
  submerchantStatus?: Maybe<StringNullableFilter>;
  submerchantStripeChargesEnabled?: Maybe<BoolNullableFilter>;
  submerchantStripeHasCustomPayouts?: Maybe<BoolNullableFilter>;
  submerchantStripeId?: Maybe<StringNullableFilter>;
  submerchantStripePayoutsEnabled?: Maybe<BoolNullableFilter>;
  submerchantStripeStatus?: Maybe<StringNullableFilter>;
  subscribedAt?: Maybe<DateTimeNullableFilter>;
  subscriptionId?: Maybe<StringNullableFilter>;
  subscriptionPlan?: Maybe<StringNullableFilter>;
  timezone?: Maybe<IntNullableFilter>;
  timezoneName?: Maybe<StringNullableFilter>;
  token?: Maybe<StringNullableFilter>;
  unlayerSettingId?: Maybe<IntNullableFilter>;
  unsubscribedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  websiteUrl?: Maybe<StringNullableFilter>;
  widgetSettings?: Maybe<JsonNullableFilter>;
};

export type ClinicScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicScalarWhereWithAggregatesInput>>;
  activationDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  addressLine1?: Maybe<StringNullableWithAggregatesFilter>;
  addressLine2?: Maybe<StringNullableWithAggregatesFilter>;
  allowAllUsersToCloseConsultations?: Maybe<BoolNullableWithAggregatesFilter>;
  autoSubscriptionReceiptEmails?: Maybe<JsonNullableWithAggregatesFilter>;
  automaticSubscriptionReceipts?: Maybe<BoolWithAggregatesFilter>;
  callerIdPhoneNumber?: Maybe<StringNullableWithAggregatesFilter>;
  canceledAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  cancellationNote?: Maybe<StringNullableWithAggregatesFilter>;
  cancellationReason?: Maybe<StringNullableWithAggregatesFilter>;
  carePlanProviderGroupId?: Maybe<StringNullableWithAggregatesFilter>;
  city?: Maybe<StringNullableWithAggregatesFilter>;
  clinicEmail?: Maybe<StringNullableWithAggregatesFilter>;
  clinicSettingId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicWidgetSettingId?: Maybe<StringNullableWithAggregatesFilter>;
  consultationCost?: Maybe<FloatNullableWithAggregatesFilter>;
  corporateId?: Maybe<StringNullableWithAggregatesFilter>;
  country?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  crmId?: Maybe<StringNullableWithAggregatesFilter>;
  crmUrlParams?: Maybe<JsonNullableWithAggregatesFilter>;
  customerId?: Maybe<StringNullableWithAggregatesFilter>;
  firebaseId?: Maybe<StringNullableWithAggregatesFilter>;
  firebaseVets?: Maybe<JsonNullableWithAggregatesFilter>;
  followUpCost?: Maybe<FloatNullableWithAggregatesFilter>;
  fullAddress?: Maybe<StringNullableWithAggregatesFilter>;
  hasServiceReminders?: Maybe<BoolNullableWithAggregatesFilter>;
  hasSmsConversations?: Maybe<BoolNullableWithAggregatesFilter>;
  headUserId?: Maybe<StringNullableWithAggregatesFilter>;
  hours?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  incomeMethod?: Maybe<StringNullableWithAggregatesFilter>;
  integrationInfo?: Maybe<JsonNullableWithAggregatesFilter>;
  integrationSystem?: Maybe<StringNullableWithAggregatesFilter>;
  integrationType?: Maybe<StringNullableWithAggregatesFilter>;
  isAddAppointmentDisabled?: Maybe<BoolNullableWithAggregatesFilter>;
  isCallerIdVerified?: Maybe<BoolNullableWithAggregatesFilter>;
  isClinicActive?: Maybe<BoolWithAggregatesFilter>;
  isClinicEligibleForPayments?: Maybe<BoolWithAggregatesFilter>;
  isConsultationsActive?: Maybe<BoolNullableWithAggregatesFilter>;
  isIntegrationActive?: Maybe<BoolNullableWithAggregatesFilter>;
  isPaymentUsBank?: Maybe<BoolNullableWithAggregatesFilter>;
  isServiceRemindersActive?: Maybe<BoolNullableWithAggregatesFilter>;
  lastPrintOrderedOn?: Maybe<DateTimeNullableWithAggregatesFilter>;
  lastPrintOrderedQuantity?: Maybe<IntNullableWithAggregatesFilter>;
  lat?: Maybe<FloatNullableWithAggregatesFilter>;
  legalEntityId?: Maybe<StringNullableWithAggregatesFilter>;
  logo?: Maybe<StringNullableWithAggregatesFilter>;
  long?: Maybe<FloatNullableWithAggregatesFilter>;
  loyaltyProgramId?: Maybe<StringNullableWithAggregatesFilter>;
  marketEmail?: Maybe<StringNullableWithAggregatesFilter>;
  marketFacebookNumber?: Maybe<IntNullableWithAggregatesFilter>;
  marketFacebookPageId?: Maybe<StringNullableWithAggregatesFilter>;
  marketFacebookPageToken?: Maybe<StringNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  optimizedLogoUrl?: Maybe<StringNullableWithAggregatesFilter>;
  organizationId?: Maybe<StringNullableWithAggregatesFilter>;
  paymentAddress?: Maybe<StringNullableWithAggregatesFilter>;
  paymentBankAccountNumber?: Maybe<StringNullableWithAggregatesFilter>;
  paymentBankRoutingNumber?: Maybe<StringNullableWithAggregatesFilter>;
  paymentCity?: Maybe<StringNullableWithAggregatesFilter>;
  paymentName?: Maybe<StringNullableWithAggregatesFilter>;
  paymentPhone?: Maybe<StringNullableWithAggregatesFilter>;
  paymentState?: Maybe<StringNullableWithAggregatesFilter>;
  paymentZip?: Maybe<StringNullableWithAggregatesFilter>;
  phone?: Maybe<StringNullableWithAggregatesFilter>;
  postalCode?: Maybe<StringNullableWithAggregatesFilter>;
  ppcLocationId?: Maybe<IntNullableWithAggregatesFilter>;
  printLastOrder?: Maybe<DateTimeNullableWithAggregatesFilter>;
  printReceivedQuantity?: Maybe<IntNullableWithAggregatesFilter>;
  remindersIntegrationRequestEmail?: Maybe<StringNullableWithAggregatesFilter>;
  responseTime?: Maybe<FloatNullableWithAggregatesFilter>;
  smsPhoneNumber?: Maybe<StringNullableWithAggregatesFilter>;
  state?: Maybe<StringNullableWithAggregatesFilter>;
  stripeCustomerId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeSubscriptionId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeSubscriptionPlan?: Maybe<StringNullableWithAggregatesFilter>;
  submerchantApprovedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  submerchantId?: Maybe<StringNullableWithAggregatesFilter>;
  submerchantIsActive?: Maybe<BoolNullableWithAggregatesFilter>;
  submerchantStatus?: Maybe<StringNullableWithAggregatesFilter>;
  submerchantStripeChargesEnabled?: Maybe<BoolNullableWithAggregatesFilter>;
  submerchantStripeHasCustomPayouts?: Maybe<BoolNullableWithAggregatesFilter>;
  submerchantStripeId?: Maybe<StringNullableWithAggregatesFilter>;
  submerchantStripePayoutsEnabled?: Maybe<BoolNullableWithAggregatesFilter>;
  submerchantStripeStatus?: Maybe<StringNullableWithAggregatesFilter>;
  subscribedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  subscriptionId?: Maybe<StringNullableWithAggregatesFilter>;
  subscriptionPlan?: Maybe<StringNullableWithAggregatesFilter>;
  timezone?: Maybe<IntNullableWithAggregatesFilter>;
  timezoneName?: Maybe<StringNullableWithAggregatesFilter>;
  token?: Maybe<StringNullableWithAggregatesFilter>;
  unlayerSettingId?: Maybe<IntNullableWithAggregatesFilter>;
  unsubscribedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  websiteUrl?: Maybe<StringNullableWithAggregatesFilter>;
  widgetSettings?: Maybe<JsonNullableWithAggregatesFilter>;
};

export type ClinicSetting = {
  __typename?: 'ClinicSetting';
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  _count: ClinicSettingCountOutputType;
  aiRecapWritebackEnabled: Scalars['Boolean'];
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit: Scalars['Int'];
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns: Array<CampaignRegistryCampaign>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses: Array<ChannelStatus>;
  clinic?: Maybe<Clinic>;
  createdAt: Scalars['DateTime'];
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics: Array<EmergencyClinics>;
  emergencyContactsEnabled: Scalars['Boolean'];
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner: Scalars['Boolean'];
  id: Scalars['String'];
  informPrimaryContactUser?: Maybe<User>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  /** When did we last run the loyalty program queueing cron job, if at all? */
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus: MissedCallMessageResponseStatus;
  outOfOfficeEnabled: Scalars['Boolean'];
  outOfOfficeHeadline: Scalars['String'];
  outOfOfficeShowScheduleEnabled: Scalars['Boolean'];
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfiguration>;
  petPortalSetting?: Maybe<PetPortalSetting>;
  processingFeeFlat: Scalars['Int'];
  processingFeePercent: Scalars['Float'];
  savePaymentInfo: Scalars['Boolean'];
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  /** 6-digit pin for terminal setup, padded with one zero for demo, two zeroes for QA, no zeroes for prod */
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  workflowsEnabled: Scalars['Boolean'];
};


export type ClinicSettingCampaignRegistryCampaignsArgs = {
  cursor?: Maybe<CampaignRegistryCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CampaignRegistryCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CampaignRegistryCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CampaignRegistryCampaignWhereInput>;
};


export type ClinicSettingChannelStatusesArgs = {
  cursor?: Maybe<ChannelStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusWhereInput>;
};


export type ClinicSettingClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type ClinicSettingEmergencyClinicsArgs = {
  cursor?: Maybe<EmergencyClinicsWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmergencyClinicsScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmergencyClinicsOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmergencyClinicsWhereInput>;
};


export type ClinicSettingInformPrimaryContactUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type ClinicSettingPaymentFeeConfigArgs = {
  where?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
};


export type ClinicSettingPetPortalSettingArgs = {
  where?: Maybe<PetPortalSettingWhereInput>;
};

export type ClinicSettingAvgAggregateOutputType = {
  __typename?: 'ClinicSettingAvgAggregateOutputType';
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Float']>;
  bulkConversationExportLimit?: Maybe<Scalars['Float']>;
  processingFeeFlat?: Maybe<Scalars['Float']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
};

export type ClinicSettingAvgOrderByAggregateInput = {
  appointmentTimeSlotIncrementInMinutes?: Maybe<SortOrder>;
  bulkConversationExportLimit?: Maybe<SortOrder>;
  processingFeeFlat?: Maybe<SortOrder>;
  processingFeePercent?: Maybe<SortOrder>;
};

export type ClinicSettingCountAggregateOutputType = {
  __typename?: 'ClinicSettingCountAggregateOutputType';
  MissedCallMessageResponseBody: Scalars['Int'];
  _all: Scalars['Int'];
  aiRecapWritebackEnabled: Scalars['Int'];
  aiSuggestPromptSupplement: Scalars['Int'];
  aiSummaryPromptSupplement: Scalars['Int'];
  appointmentTimeSlotIncrementInMinutes: Scalars['Int'];
  bulkConversationExportLimit: Scalars['Int'];
  campaignRegistryBrand: Scalars['Int'];
  campaignRegistryBrandId: Scalars['Int'];
  campaignRegistryBrandIdentityStatus: Scalars['Int'];
  careStatementDescriptor: Scalars['Int'];
  createdAt: Scalars['Int'];
  earliestAllowedLoyaltyInvoiceDate: Scalars['Int'];
  emergencyContactsEnabled: Scalars['Int'];
  financialReportingConfig: Scalars['Int'];
  hasCustomizableFees: Scalars['Int'];
  hideAppointmentsWithoutPetOwner: Scalars['Int'];
  id: Scalars['Int'];
  informPrimaryContactUserId: Scalars['Int'];
  loyaltyProgramLastRunAt: Scalars['Int'];
  merchantIdentifier: Scalars['Int'];
  missedCallMessageResponseStatus: Scalars['Int'];
  outOfOfficeEnabled: Scalars['Int'];
  outOfOfficeHeadline: Scalars['Int'];
  outOfOfficeShowScheduleEnabled: Scalars['Int'];
  processingFeeFlat: Scalars['Int'];
  processingFeePercent: Scalars['Int'];
  savePaymentInfo: Scalars['Int'];
  smsAutoResponseWhenClosed: Scalars['Int'];
  smsAutoResponseWhenOpen: Scalars['Int'];
  tags: Scalars['Int'];
  terminalSetupPin: Scalars['Int'];
  updatedAt: Scalars['Int'];
  workflowsEnabled: Scalars['Int'];
};

export type ClinicSettingCountOrderByAggregateInput = {
  MissedCallMessageResponseBody?: Maybe<SortOrder>;
  aiRecapWritebackEnabled?: Maybe<SortOrder>;
  aiSuggestPromptSupplement?: Maybe<SortOrder>;
  aiSummaryPromptSupplement?: Maybe<SortOrder>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<SortOrder>;
  bulkConversationExportLimit?: Maybe<SortOrder>;
  campaignRegistryBrand?: Maybe<SortOrder>;
  campaignRegistryBrandId?: Maybe<SortOrder>;
  campaignRegistryBrandIdentityStatus?: Maybe<SortOrder>;
  careStatementDescriptor?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<SortOrder>;
  emergencyContactsEnabled?: Maybe<SortOrder>;
  financialReportingConfig?: Maybe<SortOrder>;
  hasCustomizableFees?: Maybe<SortOrder>;
  hideAppointmentsWithoutPetOwner?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPrimaryContactUserId?: Maybe<SortOrder>;
  loyaltyProgramLastRunAt?: Maybe<SortOrder>;
  merchantIdentifier?: Maybe<SortOrder>;
  missedCallMessageResponseStatus?: Maybe<SortOrder>;
  outOfOfficeEnabled?: Maybe<SortOrder>;
  outOfOfficeHeadline?: Maybe<SortOrder>;
  outOfOfficeShowScheduleEnabled?: Maybe<SortOrder>;
  processingFeeFlat?: Maybe<SortOrder>;
  processingFeePercent?: Maybe<SortOrder>;
  savePaymentInfo?: Maybe<SortOrder>;
  smsAutoResponseWhenClosed?: Maybe<SortOrder>;
  smsAutoResponseWhenOpen?: Maybe<SortOrder>;
  tags?: Maybe<SortOrder>;
  terminalSetupPin?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowsEnabled?: Maybe<SortOrder>;
};

export type ClinicSettingCountOutputType = {
  __typename?: 'ClinicSettingCountOutputType';
  campaignRegistryCampaigns: Scalars['Int'];
  channelStatuses: Scalars['Int'];
  emergencyClinics: Scalars['Int'];
};

export type ClinicSettingCreateInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutClinicSettingInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserCreateNestedOneWithoutInformPrimaryContactClinicSettingsInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationCreateNestedOneWithoutClinicSettingInput>;
  petPortalSetting?: Maybe<PetPortalSettingCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingCreateManyInformPrimaryContactUserInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingCreateManyInformPrimaryContactUserInputEnvelope = {
  data: Array<ClinicSettingCreateManyInformPrimaryContactUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingCreateManyInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput = {
  connect?: Maybe<Array<ClinicSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicSettingCreateOrConnectWithoutInformPrimaryContactUserInput>>;
  create?: Maybe<Array<ClinicSettingCreateWithoutInformPrimaryContactUserInput>>;
  createMany?: Maybe<ClinicSettingCreateManyInformPrimaryContactUserInputEnvelope>;
};

export type ClinicSettingCreateNestedOneWithoutCampaignRegistryCampaignsInput = {
  connect?: Maybe<ClinicSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicSettingCreateOrConnectWithoutCampaignRegistryCampaignsInput>;
  create?: Maybe<ClinicSettingCreateWithoutCampaignRegistryCampaignsInput>;
};

export type ClinicSettingCreateNestedOneWithoutChannelStatusesInput = {
  connect?: Maybe<ClinicSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicSettingCreateOrConnectWithoutChannelStatusesInput>;
  create?: Maybe<ClinicSettingCreateWithoutChannelStatusesInput>;
};

export type ClinicSettingCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<ClinicSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicSettingCreateOrConnectWithoutClinicInput>;
  create?: Maybe<ClinicSettingCreateWithoutClinicInput>;
};

export type ClinicSettingCreateNestedOneWithoutEmergencyClinicsInput = {
  connect?: Maybe<ClinicSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicSettingCreateOrConnectWithoutEmergencyClinicsInput>;
  create?: Maybe<ClinicSettingCreateWithoutEmergencyClinicsInput>;
};

export type ClinicSettingCreateNestedOneWithoutPaymentFeeConfigInput = {
  connect?: Maybe<ClinicSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicSettingCreateOrConnectWithoutPaymentFeeConfigInput>;
  create?: Maybe<ClinicSettingCreateWithoutPaymentFeeConfigInput>;
};

export type ClinicSettingCreateNestedOneWithoutPetPortalSettingInput = {
  connect?: Maybe<ClinicSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicSettingCreateOrConnectWithoutPetPortalSettingInput>;
  create?: Maybe<ClinicSettingCreateWithoutPetPortalSettingInput>;
};

export type ClinicSettingCreateOrConnectWithoutCampaignRegistryCampaignsInput = {
  create: ClinicSettingCreateWithoutCampaignRegistryCampaignsInput;
  where: ClinicSettingWhereUniqueInput;
};

export type ClinicSettingCreateOrConnectWithoutChannelStatusesInput = {
  create: ClinicSettingCreateWithoutChannelStatusesInput;
  where: ClinicSettingWhereUniqueInput;
};

export type ClinicSettingCreateOrConnectWithoutClinicInput = {
  create: ClinicSettingCreateWithoutClinicInput;
  where: ClinicSettingWhereUniqueInput;
};

export type ClinicSettingCreateOrConnectWithoutEmergencyClinicsInput = {
  create: ClinicSettingCreateWithoutEmergencyClinicsInput;
  where: ClinicSettingWhereUniqueInput;
};

export type ClinicSettingCreateOrConnectWithoutInformPrimaryContactUserInput = {
  create: ClinicSettingCreateWithoutInformPrimaryContactUserInput;
  where: ClinicSettingWhereUniqueInput;
};

export type ClinicSettingCreateOrConnectWithoutPaymentFeeConfigInput = {
  create: ClinicSettingCreateWithoutPaymentFeeConfigInput;
  where: ClinicSettingWhereUniqueInput;
};

export type ClinicSettingCreateOrConnectWithoutPetPortalSettingInput = {
  create: ClinicSettingCreateWithoutPetPortalSettingInput;
  where: ClinicSettingWhereUniqueInput;
};

export type ClinicSettingCreateWithoutCampaignRegistryCampaignsInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutClinicSettingInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserCreateNestedOneWithoutInformPrimaryContactClinicSettingsInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationCreateNestedOneWithoutClinicSettingInput>;
  petPortalSetting?: Maybe<PetPortalSettingCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingCreateWithoutChannelStatusesInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserCreateNestedOneWithoutInformPrimaryContactClinicSettingsInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationCreateNestedOneWithoutClinicSettingInput>;
  petPortalSetting?: Maybe<PetPortalSettingCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingCreateWithoutClinicInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserCreateNestedOneWithoutInformPrimaryContactClinicSettingsInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationCreateNestedOneWithoutClinicSettingInput>;
  petPortalSetting?: Maybe<PetPortalSettingCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingCreateWithoutEmergencyClinicsInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutClinicSettingInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserCreateNestedOneWithoutInformPrimaryContactClinicSettingsInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationCreateNestedOneWithoutClinicSettingInput>;
  petPortalSetting?: Maybe<PetPortalSettingCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingCreateWithoutInformPrimaryContactUserInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutClinicSettingInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationCreateNestedOneWithoutClinicSettingInput>;
  petPortalSetting?: Maybe<PetPortalSettingCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingCreateWithoutPaymentFeeConfigInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutClinicSettingInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserCreateNestedOneWithoutInformPrimaryContactClinicSettingsInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  petPortalSetting?: Maybe<PetPortalSettingCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingCreateWithoutPetPortalSettingInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutClinicSettingInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserCreateNestedOneWithoutInformPrimaryContactClinicSettingsInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingGroupByOutputType = {
  __typename?: 'ClinicSettingGroupByOutputType';
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  _avg?: Maybe<ClinicSettingAvgAggregateOutputType>;
  _count?: Maybe<ClinicSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicSettingMinAggregateOutputType>;
  _sum?: Maybe<ClinicSettingSumAggregateOutputType>;
  aiRecapWritebackEnabled: Scalars['Boolean'];
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit: Scalars['Int'];
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled: Scalars['Boolean'];
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner: Scalars['Boolean'];
  id: Scalars['String'];
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus: MissedCallMessageResponseStatus;
  outOfOfficeEnabled: Scalars['Boolean'];
  outOfOfficeHeadline: Scalars['String'];
  outOfOfficeShowScheduleEnabled: Scalars['Boolean'];
  processingFeeFlat: Scalars['Int'];
  processingFeePercent: Scalars['Float'];
  savePaymentInfo: Scalars['Boolean'];
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  workflowsEnabled: Scalars['Boolean'];
};

export type ClinicSettingListRelationFilter = {
  every?: Maybe<ClinicSettingWhereInput>;
  none?: Maybe<ClinicSettingWhereInput>;
  some?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingMaxAggregateOutputType = {
  __typename?: 'ClinicSettingMaxAggregateOutputType';
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingMaxOrderByAggregateInput = {
  MissedCallMessageResponseBody?: Maybe<SortOrder>;
  aiRecapWritebackEnabled?: Maybe<SortOrder>;
  aiSuggestPromptSupplement?: Maybe<SortOrder>;
  aiSummaryPromptSupplement?: Maybe<SortOrder>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<SortOrder>;
  bulkConversationExportLimit?: Maybe<SortOrder>;
  campaignRegistryBrandId?: Maybe<SortOrder>;
  campaignRegistryBrandIdentityStatus?: Maybe<SortOrder>;
  careStatementDescriptor?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<SortOrder>;
  emergencyContactsEnabled?: Maybe<SortOrder>;
  hasCustomizableFees?: Maybe<SortOrder>;
  hideAppointmentsWithoutPetOwner?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPrimaryContactUserId?: Maybe<SortOrder>;
  loyaltyProgramLastRunAt?: Maybe<SortOrder>;
  merchantIdentifier?: Maybe<SortOrder>;
  missedCallMessageResponseStatus?: Maybe<SortOrder>;
  outOfOfficeEnabled?: Maybe<SortOrder>;
  outOfOfficeHeadline?: Maybe<SortOrder>;
  outOfOfficeShowScheduleEnabled?: Maybe<SortOrder>;
  processingFeeFlat?: Maybe<SortOrder>;
  processingFeePercent?: Maybe<SortOrder>;
  savePaymentInfo?: Maybe<SortOrder>;
  smsAutoResponseWhenClosed?: Maybe<SortOrder>;
  smsAutoResponseWhenOpen?: Maybe<SortOrder>;
  terminalSetupPin?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowsEnabled?: Maybe<SortOrder>;
};

export type ClinicSettingMinAggregateOutputType = {
  __typename?: 'ClinicSettingMinAggregateOutputType';
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingMinOrderByAggregateInput = {
  MissedCallMessageResponseBody?: Maybe<SortOrder>;
  aiRecapWritebackEnabled?: Maybe<SortOrder>;
  aiSuggestPromptSupplement?: Maybe<SortOrder>;
  aiSummaryPromptSupplement?: Maybe<SortOrder>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<SortOrder>;
  bulkConversationExportLimit?: Maybe<SortOrder>;
  campaignRegistryBrandId?: Maybe<SortOrder>;
  campaignRegistryBrandIdentityStatus?: Maybe<SortOrder>;
  careStatementDescriptor?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<SortOrder>;
  emergencyContactsEnabled?: Maybe<SortOrder>;
  hasCustomizableFees?: Maybe<SortOrder>;
  hideAppointmentsWithoutPetOwner?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPrimaryContactUserId?: Maybe<SortOrder>;
  loyaltyProgramLastRunAt?: Maybe<SortOrder>;
  merchantIdentifier?: Maybe<SortOrder>;
  missedCallMessageResponseStatus?: Maybe<SortOrder>;
  outOfOfficeEnabled?: Maybe<SortOrder>;
  outOfOfficeHeadline?: Maybe<SortOrder>;
  outOfOfficeShowScheduleEnabled?: Maybe<SortOrder>;
  processingFeeFlat?: Maybe<SortOrder>;
  processingFeePercent?: Maybe<SortOrder>;
  savePaymentInfo?: Maybe<SortOrder>;
  smsAutoResponseWhenClosed?: Maybe<SortOrder>;
  smsAutoResponseWhenOpen?: Maybe<SortOrder>;
  terminalSetupPin?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowsEnabled?: Maybe<SortOrder>;
};

export type ClinicSettingNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicSettingWhereInput>>;
  MissedCallMessageResponseBody?: Maybe<StringNullableFilter>;
  NOT?: Maybe<Array<ClinicSettingWhereInput>>;
  OR?: Maybe<Array<ClinicSettingWhereInput>>;
  aiRecapWritebackEnabled?: Maybe<BoolFilter>;
  aiSuggestPromptSupplement?: Maybe<StringNullableFilter>;
  aiSummaryPromptSupplement?: Maybe<StringNullableFilter>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<IntNullableFilter>;
  bulkConversationExportLimit?: Maybe<IntFilter>;
  campaignRegistryBrand?: Maybe<JsonNullableFilter>;
  campaignRegistryBrandId?: Maybe<StringNullableFilter>;
  campaignRegistryBrandIdentityStatus?: Maybe<EnumCampaignRegistryBrandIdentityStatusNullableFilter>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignListRelationFilter>;
  careStatementDescriptor?: Maybe<StringNullableFilter>;
  channelStatuses?: Maybe<ChannelStatusListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<DateTimeNullableFilter>;
  emergencyClinics?: Maybe<EmergencyClinicsListRelationFilter>;
  emergencyContactsEnabled?: Maybe<BoolFilter>;
  financialReportingConfig?: Maybe<JsonNullableFilter>;
  hasCustomizableFees?: Maybe<BoolNullableFilter>;
  hideAppointmentsWithoutPetOwner?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  informPrimaryContactUser?: Maybe<UserNullableScalarRelationFilter>;
  informPrimaryContactUserId?: Maybe<StringNullableFilter>;
  loyaltyProgramLastRunAt?: Maybe<DateTimeNullableFilter>;
  merchantIdentifier?: Maybe<StringNullableFilter>;
  missedCallMessageResponseStatus?: Maybe<EnumMissedCallMessageResponseStatusFilter>;
  outOfOfficeEnabled?: Maybe<BoolFilter>;
  outOfOfficeHeadline?: Maybe<StringFilter>;
  outOfOfficeShowScheduleEnabled?: Maybe<BoolFilter>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationNullableScalarRelationFilter>;
  petPortalSetting?: Maybe<PetPortalSettingNullableScalarRelationFilter>;
  processingFeeFlat?: Maybe<IntFilter>;
  processingFeePercent?: Maybe<FloatFilter>;
  savePaymentInfo?: Maybe<BoolFilter>;
  smsAutoResponseWhenClosed?: Maybe<StringNullableFilter>;
  smsAutoResponseWhenOpen?: Maybe<StringNullableFilter>;
  tags?: Maybe<JsonNullableFilter>;
  terminalSetupPin?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowsEnabled?: Maybe<BoolFilter>;
};

export type ClinicSettingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicSettingOrderByRelationAndSearchRelevanceInput = {
  MissedCallMessageResponseBody?: Maybe<SortOrder>;
  _relevance?: Maybe<ClinicSettingOrderByRelevanceInput>;
  aiRecapWritebackEnabled?: Maybe<SortOrder>;
  aiSuggestPromptSupplement?: Maybe<SortOrder>;
  aiSummaryPromptSupplement?: Maybe<SortOrder>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<SortOrder>;
  bulkConversationExportLimit?: Maybe<SortOrder>;
  campaignRegistryBrand?: Maybe<SortOrder>;
  campaignRegistryBrandId?: Maybe<SortOrder>;
  campaignRegistryBrandIdentityStatus?: Maybe<SortOrder>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignOrderByRelationAggregateInput>;
  careStatementDescriptor?: Maybe<SortOrder>;
  channelStatuses?: Maybe<ChannelStatusOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<SortOrder>;
  emergencyClinics?: Maybe<EmergencyClinicsOrderByRelationAggregateInput>;
  emergencyContactsEnabled?: Maybe<SortOrder>;
  financialReportingConfig?: Maybe<SortOrder>;
  hasCustomizableFees?: Maybe<SortOrder>;
  hideAppointmentsWithoutPetOwner?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPrimaryContactUser?: Maybe<UserOrderByWithRelationInput>;
  informPrimaryContactUserId?: Maybe<SortOrder>;
  loyaltyProgramLastRunAt?: Maybe<SortOrder>;
  merchantIdentifier?: Maybe<SortOrder>;
  missedCallMessageResponseStatus?: Maybe<SortOrder>;
  outOfOfficeEnabled?: Maybe<SortOrder>;
  outOfOfficeHeadline?: Maybe<SortOrder>;
  outOfOfficeShowScheduleEnabled?: Maybe<SortOrder>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationOrderByWithRelationInput>;
  petPortalSetting?: Maybe<PetPortalSettingOrderByWithRelationInput>;
  processingFeeFlat?: Maybe<SortOrder>;
  processingFeePercent?: Maybe<SortOrder>;
  savePaymentInfo?: Maybe<SortOrder>;
  smsAutoResponseWhenClosed?: Maybe<SortOrder>;
  smsAutoResponseWhenOpen?: Maybe<SortOrder>;
  tags?: Maybe<SortOrder>;
  terminalSetupPin?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowsEnabled?: Maybe<SortOrder>;
};

export enum ClinicSettingOrderByRelevanceFieldEnum {
  MissedCallMessageResponseBody = 'MissedCallMessageResponseBody',
  AiSuggestPromptSupplement = 'aiSuggestPromptSupplement',
  AiSummaryPromptSupplement = 'aiSummaryPromptSupplement',
  CampaignRegistryBrandId = 'campaignRegistryBrandId',
  CareStatementDescriptor = 'careStatementDescriptor',
  Id = 'id',
  InformPrimaryContactUserId = 'informPrimaryContactUserId',
  MerchantIdentifier = 'merchantIdentifier',
  OutOfOfficeHeadline = 'outOfOfficeHeadline',
  SmsAutoResponseWhenClosed = 'smsAutoResponseWhenClosed',
  SmsAutoResponseWhenOpen = 'smsAutoResponseWhenOpen',
  TerminalSetupPin = 'terminalSetupPin'
}

export type ClinicSettingOrderByRelevanceInput = {
  fields: Array<ClinicSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicSettingOrderByWithAggregationInput = {
  MissedCallMessageResponseBody?: Maybe<SortOrder>;
  _avg?: Maybe<ClinicSettingAvgOrderByAggregateInput>;
  _count?: Maybe<ClinicSettingCountOrderByAggregateInput>;
  _max?: Maybe<ClinicSettingMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicSettingMinOrderByAggregateInput>;
  _sum?: Maybe<ClinicSettingSumOrderByAggregateInput>;
  aiRecapWritebackEnabled?: Maybe<SortOrder>;
  aiSuggestPromptSupplement?: Maybe<SortOrder>;
  aiSummaryPromptSupplement?: Maybe<SortOrder>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<SortOrder>;
  bulkConversationExportLimit?: Maybe<SortOrder>;
  campaignRegistryBrand?: Maybe<SortOrder>;
  campaignRegistryBrandId?: Maybe<SortOrder>;
  campaignRegistryBrandIdentityStatus?: Maybe<SortOrder>;
  careStatementDescriptor?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<SortOrder>;
  emergencyContactsEnabled?: Maybe<SortOrder>;
  financialReportingConfig?: Maybe<SortOrder>;
  hasCustomizableFees?: Maybe<SortOrder>;
  hideAppointmentsWithoutPetOwner?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPrimaryContactUserId?: Maybe<SortOrder>;
  loyaltyProgramLastRunAt?: Maybe<SortOrder>;
  merchantIdentifier?: Maybe<SortOrder>;
  missedCallMessageResponseStatus?: Maybe<SortOrder>;
  outOfOfficeEnabled?: Maybe<SortOrder>;
  outOfOfficeHeadline?: Maybe<SortOrder>;
  outOfOfficeShowScheduleEnabled?: Maybe<SortOrder>;
  processingFeeFlat?: Maybe<SortOrder>;
  processingFeePercent?: Maybe<SortOrder>;
  savePaymentInfo?: Maybe<SortOrder>;
  smsAutoResponseWhenClosed?: Maybe<SortOrder>;
  smsAutoResponseWhenOpen?: Maybe<SortOrder>;
  tags?: Maybe<SortOrder>;
  terminalSetupPin?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowsEnabled?: Maybe<SortOrder>;
};

export type ClinicSettingOrderByWithRelationAndSearchRelevanceInput = {
  MissedCallMessageResponseBody?: Maybe<SortOrder>;
  _relevance?: Maybe<ClinicSettingOrderByRelevanceInput>;
  aiRecapWritebackEnabled?: Maybe<SortOrder>;
  aiSuggestPromptSupplement?: Maybe<SortOrder>;
  aiSummaryPromptSupplement?: Maybe<SortOrder>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<SortOrder>;
  bulkConversationExportLimit?: Maybe<SortOrder>;
  campaignRegistryBrand?: Maybe<SortOrder>;
  campaignRegistryBrandId?: Maybe<SortOrder>;
  campaignRegistryBrandIdentityStatus?: Maybe<SortOrder>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignOrderByRelationAggregateInput>;
  careStatementDescriptor?: Maybe<SortOrder>;
  channelStatuses?: Maybe<ChannelStatusOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<SortOrder>;
  emergencyClinics?: Maybe<EmergencyClinicsOrderByRelationAggregateInput>;
  emergencyContactsEnabled?: Maybe<SortOrder>;
  financialReportingConfig?: Maybe<SortOrder>;
  hasCustomizableFees?: Maybe<SortOrder>;
  hideAppointmentsWithoutPetOwner?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPrimaryContactUser?: Maybe<UserOrderByWithRelationInput>;
  informPrimaryContactUserId?: Maybe<SortOrder>;
  loyaltyProgramLastRunAt?: Maybe<SortOrder>;
  merchantIdentifier?: Maybe<SortOrder>;
  missedCallMessageResponseStatus?: Maybe<SortOrder>;
  outOfOfficeEnabled?: Maybe<SortOrder>;
  outOfOfficeHeadline?: Maybe<SortOrder>;
  outOfOfficeShowScheduleEnabled?: Maybe<SortOrder>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationOrderByWithRelationInput>;
  petPortalSetting?: Maybe<PetPortalSettingOrderByWithRelationInput>;
  processingFeeFlat?: Maybe<SortOrder>;
  processingFeePercent?: Maybe<SortOrder>;
  savePaymentInfo?: Maybe<SortOrder>;
  smsAutoResponseWhenClosed?: Maybe<SortOrder>;
  smsAutoResponseWhenOpen?: Maybe<SortOrder>;
  tags?: Maybe<SortOrder>;
  terminalSetupPin?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowsEnabled?: Maybe<SortOrder>;
};

export type ClinicSettingOrderByWithRelationInput = {
  MissedCallMessageResponseBody?: Maybe<SortOrder>;
  _relevance?: Maybe<ClinicSettingOrderByRelevanceInput>;
  aiRecapWritebackEnabled?: Maybe<SortOrder>;
  aiSuggestPromptSupplement?: Maybe<SortOrder>;
  aiSummaryPromptSupplement?: Maybe<SortOrder>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<SortOrder>;
  bulkConversationExportLimit?: Maybe<SortOrder>;
  campaignRegistryBrand?: Maybe<SortOrder>;
  campaignRegistryBrandId?: Maybe<SortOrder>;
  campaignRegistryBrandIdentityStatus?: Maybe<SortOrder>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignOrderByRelationAggregateInput>;
  careStatementDescriptor?: Maybe<SortOrder>;
  channelStatuses?: Maybe<ChannelStatusOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<SortOrder>;
  emergencyClinics?: Maybe<EmergencyClinicsOrderByRelationAggregateInput>;
  emergencyContactsEnabled?: Maybe<SortOrder>;
  financialReportingConfig?: Maybe<SortOrder>;
  hasCustomizableFees?: Maybe<SortOrder>;
  hideAppointmentsWithoutPetOwner?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPrimaryContactUser?: Maybe<UserOrderByWithRelationInput>;
  informPrimaryContactUserId?: Maybe<SortOrder>;
  loyaltyProgramLastRunAt?: Maybe<SortOrder>;
  merchantIdentifier?: Maybe<SortOrder>;
  missedCallMessageResponseStatus?: Maybe<SortOrder>;
  outOfOfficeEnabled?: Maybe<SortOrder>;
  outOfOfficeHeadline?: Maybe<SortOrder>;
  outOfOfficeShowScheduleEnabled?: Maybe<SortOrder>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationOrderByWithRelationInput>;
  petPortalSetting?: Maybe<PetPortalSettingOrderByWithRelationInput>;
  processingFeeFlat?: Maybe<SortOrder>;
  processingFeePercent?: Maybe<SortOrder>;
  savePaymentInfo?: Maybe<SortOrder>;
  smsAutoResponseWhenClosed?: Maybe<SortOrder>;
  smsAutoResponseWhenOpen?: Maybe<SortOrder>;
  tags?: Maybe<SortOrder>;
  terminalSetupPin?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowsEnabled?: Maybe<SortOrder>;
};

export enum ClinicSettingScalarFieldEnum {
  MissedCallMessageResponseBody = 'MissedCallMessageResponseBody',
  AiRecapWritebackEnabled = 'aiRecapWritebackEnabled',
  AiSuggestPromptSupplement = 'aiSuggestPromptSupplement',
  AiSummaryPromptSupplement = 'aiSummaryPromptSupplement',
  AppointmentTimeSlotIncrementInMinutes = 'appointmentTimeSlotIncrementInMinutes',
  BulkConversationExportLimit = 'bulkConversationExportLimit',
  CampaignRegistryBrand = 'campaignRegistryBrand',
  CampaignRegistryBrandId = 'campaignRegistryBrandId',
  CampaignRegistryBrandIdentityStatus = 'campaignRegistryBrandIdentityStatus',
  CareStatementDescriptor = 'careStatementDescriptor',
  CreatedAt = 'createdAt',
  EarliestAllowedLoyaltyInvoiceDate = 'earliestAllowedLoyaltyInvoiceDate',
  EmergencyContactsEnabled = 'emergencyContactsEnabled',
  FinancialReportingConfig = 'financialReportingConfig',
  HasCustomizableFees = 'hasCustomizableFees',
  HideAppointmentsWithoutPetOwner = 'hideAppointmentsWithoutPetOwner',
  Id = 'id',
  InformPrimaryContactUserId = 'informPrimaryContactUserId',
  LoyaltyProgramLastRunAt = 'loyaltyProgramLastRunAt',
  MerchantIdentifier = 'merchantIdentifier',
  MissedCallMessageResponseStatus = 'missedCallMessageResponseStatus',
  OutOfOfficeEnabled = 'outOfOfficeEnabled',
  OutOfOfficeHeadline = 'outOfOfficeHeadline',
  OutOfOfficeShowScheduleEnabled = 'outOfOfficeShowScheduleEnabled',
  ProcessingFeeFlat = 'processingFeeFlat',
  ProcessingFeePercent = 'processingFeePercent',
  SavePaymentInfo = 'savePaymentInfo',
  SmsAutoResponseWhenClosed = 'smsAutoResponseWhenClosed',
  SmsAutoResponseWhenOpen = 'smsAutoResponseWhenOpen',
  Tags = 'tags',
  TerminalSetupPin = 'terminalSetupPin',
  UpdatedAt = 'updatedAt',
  WorkflowsEnabled = 'workflowsEnabled'
}

export type ClinicSettingScalarRelationFilter = {
  AND?: Maybe<Array<ClinicSettingWhereInput>>;
  MissedCallMessageResponseBody?: Maybe<StringNullableFilter>;
  NOT?: Maybe<Array<ClinicSettingWhereInput>>;
  OR?: Maybe<Array<ClinicSettingWhereInput>>;
  aiRecapWritebackEnabled?: Maybe<BoolFilter>;
  aiSuggestPromptSupplement?: Maybe<StringNullableFilter>;
  aiSummaryPromptSupplement?: Maybe<StringNullableFilter>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<IntNullableFilter>;
  bulkConversationExportLimit?: Maybe<IntFilter>;
  campaignRegistryBrand?: Maybe<JsonNullableFilter>;
  campaignRegistryBrandId?: Maybe<StringNullableFilter>;
  campaignRegistryBrandIdentityStatus?: Maybe<EnumCampaignRegistryBrandIdentityStatusNullableFilter>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignListRelationFilter>;
  careStatementDescriptor?: Maybe<StringNullableFilter>;
  channelStatuses?: Maybe<ChannelStatusListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<DateTimeNullableFilter>;
  emergencyClinics?: Maybe<EmergencyClinicsListRelationFilter>;
  emergencyContactsEnabled?: Maybe<BoolFilter>;
  financialReportingConfig?: Maybe<JsonNullableFilter>;
  hasCustomizableFees?: Maybe<BoolNullableFilter>;
  hideAppointmentsWithoutPetOwner?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  informPrimaryContactUser?: Maybe<UserNullableScalarRelationFilter>;
  informPrimaryContactUserId?: Maybe<StringNullableFilter>;
  loyaltyProgramLastRunAt?: Maybe<DateTimeNullableFilter>;
  merchantIdentifier?: Maybe<StringNullableFilter>;
  missedCallMessageResponseStatus?: Maybe<EnumMissedCallMessageResponseStatusFilter>;
  outOfOfficeEnabled?: Maybe<BoolFilter>;
  outOfOfficeHeadline?: Maybe<StringFilter>;
  outOfOfficeShowScheduleEnabled?: Maybe<BoolFilter>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationNullableScalarRelationFilter>;
  petPortalSetting?: Maybe<PetPortalSettingNullableScalarRelationFilter>;
  processingFeeFlat?: Maybe<IntFilter>;
  processingFeePercent?: Maybe<FloatFilter>;
  savePaymentInfo?: Maybe<BoolFilter>;
  smsAutoResponseWhenClosed?: Maybe<StringNullableFilter>;
  smsAutoResponseWhenOpen?: Maybe<StringNullableFilter>;
  tags?: Maybe<JsonNullableFilter>;
  terminalSetupPin?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowsEnabled?: Maybe<BoolFilter>;
};

export type ClinicSettingScalarWhereInput = {
  AND?: Maybe<Array<ClinicSettingScalarWhereInput>>;
  MissedCallMessageResponseBody?: Maybe<StringNullableFilter>;
  NOT?: Maybe<Array<ClinicSettingScalarWhereInput>>;
  OR?: Maybe<Array<ClinicSettingScalarWhereInput>>;
  aiRecapWritebackEnabled?: Maybe<BoolFilter>;
  aiSuggestPromptSupplement?: Maybe<StringNullableFilter>;
  aiSummaryPromptSupplement?: Maybe<StringNullableFilter>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<IntNullableFilter>;
  bulkConversationExportLimit?: Maybe<IntFilter>;
  campaignRegistryBrand?: Maybe<JsonNullableFilter>;
  campaignRegistryBrandId?: Maybe<StringNullableFilter>;
  campaignRegistryBrandIdentityStatus?: Maybe<EnumCampaignRegistryBrandIdentityStatusNullableFilter>;
  careStatementDescriptor?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<DateTimeNullableFilter>;
  emergencyContactsEnabled?: Maybe<BoolFilter>;
  financialReportingConfig?: Maybe<JsonNullableFilter>;
  hasCustomizableFees?: Maybe<BoolNullableFilter>;
  hideAppointmentsWithoutPetOwner?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  informPrimaryContactUserId?: Maybe<StringNullableFilter>;
  loyaltyProgramLastRunAt?: Maybe<DateTimeNullableFilter>;
  merchantIdentifier?: Maybe<StringNullableFilter>;
  missedCallMessageResponseStatus?: Maybe<EnumMissedCallMessageResponseStatusFilter>;
  outOfOfficeEnabled?: Maybe<BoolFilter>;
  outOfOfficeHeadline?: Maybe<StringFilter>;
  outOfOfficeShowScheduleEnabled?: Maybe<BoolFilter>;
  processingFeeFlat?: Maybe<IntFilter>;
  processingFeePercent?: Maybe<FloatFilter>;
  savePaymentInfo?: Maybe<BoolFilter>;
  smsAutoResponseWhenClosed?: Maybe<StringNullableFilter>;
  smsAutoResponseWhenOpen?: Maybe<StringNullableFilter>;
  tags?: Maybe<JsonNullableFilter>;
  terminalSetupPin?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowsEnabled?: Maybe<BoolFilter>;
};

export type ClinicSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicSettingScalarWhereWithAggregatesInput>>;
  MissedCallMessageResponseBody?: Maybe<StringNullableWithAggregatesFilter>;
  NOT?: Maybe<Array<ClinicSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicSettingScalarWhereWithAggregatesInput>>;
  aiRecapWritebackEnabled?: Maybe<BoolWithAggregatesFilter>;
  aiSuggestPromptSupplement?: Maybe<StringNullableWithAggregatesFilter>;
  aiSummaryPromptSupplement?: Maybe<StringNullableWithAggregatesFilter>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<IntNullableWithAggregatesFilter>;
  bulkConversationExportLimit?: Maybe<IntWithAggregatesFilter>;
  campaignRegistryBrand?: Maybe<JsonNullableWithAggregatesFilter>;
  campaignRegistryBrandId?: Maybe<StringNullableWithAggregatesFilter>;
  campaignRegistryBrandIdentityStatus?: Maybe<EnumCampaignRegistryBrandIdentityStatusNullableWithAggregatesFilter>;
  careStatementDescriptor?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  emergencyContactsEnabled?: Maybe<BoolWithAggregatesFilter>;
  financialReportingConfig?: Maybe<JsonNullableWithAggregatesFilter>;
  hasCustomizableFees?: Maybe<BoolNullableWithAggregatesFilter>;
  hideAppointmentsWithoutPetOwner?: Maybe<BoolWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPrimaryContactUserId?: Maybe<StringNullableWithAggregatesFilter>;
  loyaltyProgramLastRunAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  merchantIdentifier?: Maybe<StringNullableWithAggregatesFilter>;
  missedCallMessageResponseStatus?: Maybe<EnumMissedCallMessageResponseStatusWithAggregatesFilter>;
  outOfOfficeEnabled?: Maybe<BoolWithAggregatesFilter>;
  outOfOfficeHeadline?: Maybe<StringWithAggregatesFilter>;
  outOfOfficeShowScheduleEnabled?: Maybe<BoolWithAggregatesFilter>;
  processingFeeFlat?: Maybe<IntWithAggregatesFilter>;
  processingFeePercent?: Maybe<FloatWithAggregatesFilter>;
  savePaymentInfo?: Maybe<BoolWithAggregatesFilter>;
  smsAutoResponseWhenClosed?: Maybe<StringNullableWithAggregatesFilter>;
  smsAutoResponseWhenOpen?: Maybe<StringNullableWithAggregatesFilter>;
  tags?: Maybe<JsonNullableWithAggregatesFilter>;
  terminalSetupPin?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  workflowsEnabled?: Maybe<BoolWithAggregatesFilter>;
};

export type ClinicSettingSumAggregateOutputType = {
  __typename?: 'ClinicSettingSumAggregateOutputType';
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
};

export type ClinicSettingSumOrderByAggregateInput = {
  appointmentTimeSlotIncrementInMinutes?: Maybe<SortOrder>;
  bulkConversationExportLimit?: Maybe<SortOrder>;
  processingFeeFlat?: Maybe<SortOrder>;
  processingFeePercent?: Maybe<SortOrder>;
};

export type ClinicSettingUncheckedCreateInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutClinicSettingInput>;
  clinic?: Maybe<ClinicUncheckedCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedCreateNestedOneWithoutClinicSettingInput>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput = {
  connect?: Maybe<Array<ClinicSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicSettingCreateOrConnectWithoutInformPrimaryContactUserInput>>;
  create?: Maybe<Array<ClinicSettingCreateWithoutInformPrimaryContactUserInput>>;
  createMany?: Maybe<ClinicSettingCreateManyInformPrimaryContactUserInputEnvelope>;
};

export type ClinicSettingUncheckedCreateWithoutCampaignRegistryCampaignsInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutClinicSettingInput>;
  clinic?: Maybe<ClinicUncheckedCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedCreateNestedOneWithoutClinicSettingInput>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedCreateWithoutChannelStatusesInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUncheckedCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedCreateNestedOneWithoutClinicSettingInput>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedCreateWithoutClinicInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedCreateNestedOneWithoutClinicSettingInput>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedCreateWithoutEmergencyClinicsInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutClinicSettingInput>;
  clinic?: Maybe<ClinicUncheckedCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedCreateNestedOneWithoutClinicSettingInput>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedCreateWithoutInformPrimaryContactUserInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutClinicSettingInput>;
  clinic?: Maybe<ClinicUncheckedCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedCreateNestedOneWithoutClinicSettingInput>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedCreateWithoutPaymentFeeConfigInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutClinicSettingInput>;
  clinic?: Maybe<ClinicUncheckedCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedCreateWithoutPetPortalSettingInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedCreateNestedManyWithoutClinicSettingInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutClinicSettingInput>;
  clinic?: Maybe<ClinicUncheckedCreateNestedOneWithoutClinicSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedCreateNestedManyWithoutClinicSettingInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedCreateNestedOneWithoutClinicSettingInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedUpdateInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  clinic?: Maybe<ClinicUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedUpdateManyInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput = {
  connect?: Maybe<Array<ClinicSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicSettingCreateOrConnectWithoutInformPrimaryContactUserInput>>;
  create?: Maybe<Array<ClinicSettingCreateWithoutInformPrimaryContactUserInput>>;
  createMany?: Maybe<ClinicSettingCreateManyInformPrimaryContactUserInputEnvelope>;
  delete?: Maybe<Array<ClinicSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicSettingUpdateWithWhereUniqueWithoutInformPrimaryContactUserInput>>;
  updateMany?: Maybe<Array<ClinicSettingUpdateManyWithWhereWithoutInformPrimaryContactUserInput>>;
  upsert?: Maybe<Array<ClinicSettingUpsertWithWhereUniqueWithoutInformPrimaryContactUserInput>>;
};

export type ClinicSettingUncheckedUpdateWithoutCampaignRegistryCampaignsInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  clinic?: Maybe<ClinicUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedUpdateWithoutChannelStatusesInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedUpdateWithoutClinicInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedUpdateWithoutEmergencyClinicsInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  clinic?: Maybe<ClinicUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedUpdateWithoutInformPrimaryContactUserInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  clinic?: Maybe<ClinicUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedUpdateWithoutPaymentFeeConfigInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  clinic?: Maybe<ClinicUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  petPortalSetting?: Maybe<PetPortalSettingUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUncheckedUpdateWithoutPetPortalSettingInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  clinic?: Maybe<ClinicUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUncheckedUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUncheckedUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUpdateInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutClinicSettingNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserUpdateOneWithoutInformPrimaryContactClinicSettingsNestedInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUpdateOneWithoutClinicSettingNestedInput>;
  petPortalSetting?: Maybe<PetPortalSettingUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUpdateManyMutationInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUpdateManyWithWhereWithoutInformPrimaryContactUserInput = {
  data: ClinicSettingUpdateManyMutationInput;
  where: ClinicSettingScalarWhereInput;
};

export type ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput = {
  connect?: Maybe<Array<ClinicSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicSettingCreateOrConnectWithoutInformPrimaryContactUserInput>>;
  create?: Maybe<Array<ClinicSettingCreateWithoutInformPrimaryContactUserInput>>;
  createMany?: Maybe<ClinicSettingCreateManyInformPrimaryContactUserInputEnvelope>;
  delete?: Maybe<Array<ClinicSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicSettingWhereUniqueInput>>;
  set?: Maybe<Array<ClinicSettingWhereUniqueInput>>;
  update?: Maybe<Array<ClinicSettingUpdateWithWhereUniqueWithoutInformPrimaryContactUserInput>>;
  updateMany?: Maybe<Array<ClinicSettingUpdateManyWithWhereWithoutInformPrimaryContactUserInput>>;
  upsert?: Maybe<Array<ClinicSettingUpsertWithWhereUniqueWithoutInformPrimaryContactUserInput>>;
};

export type ClinicSettingUpdateOneRequiredWithoutCampaignRegistryCampaignsNestedInput = {
  connect?: Maybe<ClinicSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicSettingCreateOrConnectWithoutCampaignRegistryCampaignsInput>;
  create?: Maybe<ClinicSettingCreateWithoutCampaignRegistryCampaignsInput>;
  update?: Maybe<ClinicSettingUpdateToOneWithWhereWithoutCampaignRegistryCampaignsInput>;
  upsert?: Maybe<ClinicSettingUpsertWithoutCampaignRegistryCampaignsInput>;
};

export type ClinicSettingUpdateOneRequiredWithoutEmergencyClinicsNestedInput = {
  connect?: Maybe<ClinicSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicSettingCreateOrConnectWithoutEmergencyClinicsInput>;
  create?: Maybe<ClinicSettingCreateWithoutEmergencyClinicsInput>;
  update?: Maybe<ClinicSettingUpdateToOneWithWhereWithoutEmergencyClinicsInput>;
  upsert?: Maybe<ClinicSettingUpsertWithoutEmergencyClinicsInput>;
};

export type ClinicSettingUpdateOneRequiredWithoutPaymentFeeConfigNestedInput = {
  connect?: Maybe<ClinicSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicSettingCreateOrConnectWithoutPaymentFeeConfigInput>;
  create?: Maybe<ClinicSettingCreateWithoutPaymentFeeConfigInput>;
  update?: Maybe<ClinicSettingUpdateToOneWithWhereWithoutPaymentFeeConfigInput>;
  upsert?: Maybe<ClinicSettingUpsertWithoutPaymentFeeConfigInput>;
};

export type ClinicSettingUpdateOneRequiredWithoutPetPortalSettingNestedInput = {
  connect?: Maybe<ClinicSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicSettingCreateOrConnectWithoutPetPortalSettingInput>;
  create?: Maybe<ClinicSettingCreateWithoutPetPortalSettingInput>;
  update?: Maybe<ClinicSettingUpdateToOneWithWhereWithoutPetPortalSettingInput>;
  upsert?: Maybe<ClinicSettingUpsertWithoutPetPortalSettingInput>;
};

export type ClinicSettingUpdateOneWithoutChannelStatusesNestedInput = {
  connect?: Maybe<ClinicSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicSettingCreateOrConnectWithoutChannelStatusesInput>;
  create?: Maybe<ClinicSettingCreateWithoutChannelStatusesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicSettingUpdateToOneWithWhereWithoutChannelStatusesInput>;
  upsert?: Maybe<ClinicSettingUpsertWithoutChannelStatusesInput>;
};

export type ClinicSettingUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<ClinicSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicSettingCreateOrConnectWithoutClinicInput>;
  create?: Maybe<ClinicSettingCreateWithoutClinicInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicSettingUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<ClinicSettingUpsertWithoutClinicInput>;
};

export type ClinicSettingUpdateToOneWithWhereWithoutCampaignRegistryCampaignsInput = {
  data: ClinicSettingUpdateWithoutCampaignRegistryCampaignsInput;
  where?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingUpdateToOneWithWhereWithoutChannelStatusesInput = {
  data: ClinicSettingUpdateWithoutChannelStatusesInput;
  where?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingUpdateToOneWithWhereWithoutClinicInput = {
  data: ClinicSettingUpdateWithoutClinicInput;
  where?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingUpdateToOneWithWhereWithoutEmergencyClinicsInput = {
  data: ClinicSettingUpdateWithoutEmergencyClinicsInput;
  where?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingUpdateToOneWithWhereWithoutPaymentFeeConfigInput = {
  data: ClinicSettingUpdateWithoutPaymentFeeConfigInput;
  where?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingUpdateToOneWithWhereWithoutPetPortalSettingInput = {
  data: ClinicSettingUpdateWithoutPetPortalSettingInput;
  where?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingUpdateWithWhereUniqueWithoutInformPrimaryContactUserInput = {
  data: ClinicSettingUpdateWithoutInformPrimaryContactUserInput;
  where: ClinicSettingWhereUniqueInput;
};

export type ClinicSettingUpdateWithoutCampaignRegistryCampaignsInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutClinicSettingNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserUpdateOneWithoutInformPrimaryContactClinicSettingsNestedInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUpdateOneWithoutClinicSettingNestedInput>;
  petPortalSetting?: Maybe<PetPortalSettingUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUpdateWithoutChannelStatusesInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserUpdateOneWithoutInformPrimaryContactClinicSettingsNestedInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUpdateOneWithoutClinicSettingNestedInput>;
  petPortalSetting?: Maybe<PetPortalSettingUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUpdateWithoutClinicInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserUpdateOneWithoutInformPrimaryContactClinicSettingsNestedInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUpdateOneWithoutClinicSettingNestedInput>;
  petPortalSetting?: Maybe<PetPortalSettingUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUpdateWithoutEmergencyClinicsInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutClinicSettingNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserUpdateOneWithoutInformPrimaryContactClinicSettingsNestedInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUpdateOneWithoutClinicSettingNestedInput>;
  petPortalSetting?: Maybe<PetPortalSettingUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUpdateWithoutInformPrimaryContactUserInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutClinicSettingNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUpdateOneWithoutClinicSettingNestedInput>;
  petPortalSetting?: Maybe<PetPortalSettingUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUpdateWithoutPaymentFeeConfigInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutClinicSettingNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserUpdateOneWithoutInformPrimaryContactClinicSettingsNestedInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  petPortalSetting?: Maybe<PetPortalSettingUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUpdateWithoutPetPortalSettingInput = {
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled?: Maybe<Scalars['Boolean']>;
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit?: Maybe<Scalars['Int']>;
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignUpdateManyWithoutClinicSettingNestedInput>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutClinicSettingNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyClinics?: Maybe<EmergencyClinicsUpdateManyWithoutClinicSettingNestedInput>;
  emergencyContactsEnabled?: Maybe<Scalars['Boolean']>;
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserUpdateOneWithoutInformPrimaryContactClinicSettingsNestedInput>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<MissedCallMessageResponseStatus>;
  outOfOfficeEnabled?: Maybe<Scalars['Boolean']>;
  outOfOfficeHeadline?: Maybe<Scalars['String']>;
  outOfOfficeShowScheduleEnabled?: Maybe<Scalars['Boolean']>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationUpdateOneWithoutClinicSettingNestedInput>;
  processingFeeFlat?: Maybe<Scalars['Int']>;
  processingFeePercent?: Maybe<Scalars['Float']>;
  savePaymentInfo?: Maybe<Scalars['Boolean']>;
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowsEnabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicSettingUpsertWithWhereUniqueWithoutInformPrimaryContactUserInput = {
  create: ClinicSettingCreateWithoutInformPrimaryContactUserInput;
  update: ClinicSettingUpdateWithoutInformPrimaryContactUserInput;
  where: ClinicSettingWhereUniqueInput;
};

export type ClinicSettingUpsertWithoutCampaignRegistryCampaignsInput = {
  create: ClinicSettingCreateWithoutCampaignRegistryCampaignsInput;
  update: ClinicSettingUpdateWithoutCampaignRegistryCampaignsInput;
  where?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingUpsertWithoutChannelStatusesInput = {
  create: ClinicSettingCreateWithoutChannelStatusesInput;
  update: ClinicSettingUpdateWithoutChannelStatusesInput;
  where?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingUpsertWithoutClinicInput = {
  create: ClinicSettingCreateWithoutClinicInput;
  update: ClinicSettingUpdateWithoutClinicInput;
  where?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingUpsertWithoutEmergencyClinicsInput = {
  create: ClinicSettingCreateWithoutEmergencyClinicsInput;
  update: ClinicSettingUpdateWithoutEmergencyClinicsInput;
  where?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingUpsertWithoutPaymentFeeConfigInput = {
  create: ClinicSettingCreateWithoutPaymentFeeConfigInput;
  update: ClinicSettingUpdateWithoutPaymentFeeConfigInput;
  where?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingUpsertWithoutPetPortalSettingInput = {
  create: ClinicSettingCreateWithoutPetPortalSettingInput;
  update: ClinicSettingUpdateWithoutPetPortalSettingInput;
  where?: Maybe<ClinicSettingWhereInput>;
};

export type ClinicSettingWhereInput = {
  AND?: Maybe<Array<ClinicSettingWhereInput>>;
  MissedCallMessageResponseBody?: Maybe<StringNullableFilter>;
  NOT?: Maybe<Array<ClinicSettingWhereInput>>;
  OR?: Maybe<Array<ClinicSettingWhereInput>>;
  aiRecapWritebackEnabled?: Maybe<BoolFilter>;
  aiSuggestPromptSupplement?: Maybe<StringNullableFilter>;
  aiSummaryPromptSupplement?: Maybe<StringNullableFilter>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<IntNullableFilter>;
  bulkConversationExportLimit?: Maybe<IntFilter>;
  campaignRegistryBrand?: Maybe<JsonNullableFilter>;
  campaignRegistryBrandId?: Maybe<StringNullableFilter>;
  campaignRegistryBrandIdentityStatus?: Maybe<EnumCampaignRegistryBrandIdentityStatusNullableFilter>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignListRelationFilter>;
  careStatementDescriptor?: Maybe<StringNullableFilter>;
  channelStatuses?: Maybe<ChannelStatusListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<DateTimeNullableFilter>;
  emergencyClinics?: Maybe<EmergencyClinicsListRelationFilter>;
  emergencyContactsEnabled?: Maybe<BoolFilter>;
  financialReportingConfig?: Maybe<JsonNullableFilter>;
  hasCustomizableFees?: Maybe<BoolNullableFilter>;
  hideAppointmentsWithoutPetOwner?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  informPrimaryContactUser?: Maybe<UserNullableScalarRelationFilter>;
  informPrimaryContactUserId?: Maybe<StringNullableFilter>;
  loyaltyProgramLastRunAt?: Maybe<DateTimeNullableFilter>;
  merchantIdentifier?: Maybe<StringNullableFilter>;
  missedCallMessageResponseStatus?: Maybe<EnumMissedCallMessageResponseStatusFilter>;
  outOfOfficeEnabled?: Maybe<BoolFilter>;
  outOfOfficeHeadline?: Maybe<StringFilter>;
  outOfOfficeShowScheduleEnabled?: Maybe<BoolFilter>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationNullableScalarRelationFilter>;
  petPortalSetting?: Maybe<PetPortalSettingNullableScalarRelationFilter>;
  processingFeeFlat?: Maybe<IntFilter>;
  processingFeePercent?: Maybe<FloatFilter>;
  savePaymentInfo?: Maybe<BoolFilter>;
  smsAutoResponseWhenClosed?: Maybe<StringNullableFilter>;
  smsAutoResponseWhenOpen?: Maybe<StringNullableFilter>;
  tags?: Maybe<JsonNullableFilter>;
  terminalSetupPin?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowsEnabled?: Maybe<BoolFilter>;
};

export type ClinicSettingWhereUniqueInput = {
  AND?: Maybe<Array<ClinicSettingWhereInput>>;
  MissedCallMessageResponseBody?: Maybe<StringNullableFilter>;
  NOT?: Maybe<Array<ClinicSettingWhereInput>>;
  OR?: Maybe<Array<ClinicSettingWhereInput>>;
  aiRecapWritebackEnabled?: Maybe<BoolFilter>;
  aiSuggestPromptSupplement?: Maybe<StringNullableFilter>;
  aiSummaryPromptSupplement?: Maybe<StringNullableFilter>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<IntNullableFilter>;
  bulkConversationExportLimit?: Maybe<IntFilter>;
  campaignRegistryBrand?: Maybe<JsonNullableFilter>;
  campaignRegistryBrandId?: Maybe<StringNullableFilter>;
  campaignRegistryBrandIdentityStatus?: Maybe<EnumCampaignRegistryBrandIdentityStatusNullableFilter>;
  campaignRegistryCampaigns?: Maybe<CampaignRegistryCampaignListRelationFilter>;
  careStatementDescriptor?: Maybe<StringNullableFilter>;
  channelStatuses?: Maybe<ChannelStatusListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  earliestAllowedLoyaltyInvoiceDate?: Maybe<DateTimeNullableFilter>;
  emergencyClinics?: Maybe<EmergencyClinicsListRelationFilter>;
  emergencyContactsEnabled?: Maybe<BoolFilter>;
  financialReportingConfig?: Maybe<JsonNullableFilter>;
  hasCustomizableFees?: Maybe<BoolNullableFilter>;
  hideAppointmentsWithoutPetOwner?: Maybe<BoolFilter>;
  id?: Maybe<Scalars['String']>;
  informPrimaryContactUser?: Maybe<UserNullableScalarRelationFilter>;
  informPrimaryContactUserId?: Maybe<StringNullableFilter>;
  loyaltyProgramLastRunAt?: Maybe<DateTimeNullableFilter>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus?: Maybe<EnumMissedCallMessageResponseStatusFilter>;
  outOfOfficeEnabled?: Maybe<BoolFilter>;
  outOfOfficeHeadline?: Maybe<StringFilter>;
  outOfOfficeShowScheduleEnabled?: Maybe<BoolFilter>;
  paymentFeeConfig?: Maybe<ClinicPaymentFeeConfigurationNullableScalarRelationFilter>;
  petPortalSetting?: Maybe<PetPortalSettingNullableScalarRelationFilter>;
  processingFeeFlat?: Maybe<IntFilter>;
  processingFeePercent?: Maybe<FloatFilter>;
  savePaymentInfo?: Maybe<BoolFilter>;
  smsAutoResponseWhenClosed?: Maybe<StringNullableFilter>;
  smsAutoResponseWhenOpen?: Maybe<StringNullableFilter>;
  tags?: Maybe<JsonNullableFilter>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowsEnabled?: Maybe<BoolFilter>;
};

export type ClinicSubscription = {
  __typename?: 'ClinicSubscription';
  mutation: MutationType;
  node: Clinic;
};

export type ClinicSumAggregateOutputType = {
  __typename?: 'ClinicSumAggregateOutputType';
  consultationCost?: Maybe<Scalars['Float']>;
  followUpCost?: Maybe<Scalars['Float']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  long?: Maybe<Scalars['Float']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  responseTime?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['Int']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
};

export type ClinicSumOrderByAggregateInput = {
  consultationCost?: Maybe<SortOrder>;
  followUpCost?: Maybe<SortOrder>;
  lastPrintOrderedQuantity?: Maybe<SortOrder>;
  lat?: Maybe<SortOrder>;
  long?: Maybe<SortOrder>;
  marketFacebookNumber?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  printReceivedQuantity?: Maybe<SortOrder>;
  responseTime?: Maybe<SortOrder>;
  timezone?: Maybe<SortOrder>;
  unlayerSettingId?: Maybe<SortOrder>;
};

export type ClinicUncheckedCreateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateNestedManyWithoutCarePlanProviderGroupInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutCarePlanProviderGroupInput>>;
  create?: Maybe<Array<ClinicCreateWithoutCarePlanProviderGroupInput>>;
  createMany?: Maybe<ClinicCreateManyCarePlanProviderGroupInputEnvelope>;
};

export type ClinicUncheckedCreateNestedManyWithoutClinicWidgetSettingInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutClinicWidgetSettingInput>>;
  create?: Maybe<Array<ClinicCreateWithoutClinicWidgetSettingInput>>;
  createMany?: Maybe<ClinicCreateManyClinicWidgetSettingInputEnvelope>;
};

export type ClinicUncheckedCreateNestedManyWithoutFeatureFlagsInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutFeatureFlagsInput>>;
  create?: Maybe<Array<ClinicCreateWithoutFeatureFlagsInput>>;
};

export type ClinicUncheckedCreateNestedManyWithoutLegalEntityInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutLegalEntityInput>>;
  create?: Maybe<Array<ClinicCreateWithoutLegalEntityInput>>;
  createMany?: Maybe<ClinicCreateManyLegalEntityInputEnvelope>;
};

export type ClinicUncheckedCreateNestedManyWithoutLoyaltyProgramInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutLoyaltyProgramInput>>;
  create?: Maybe<Array<ClinicCreateWithoutLoyaltyProgramInput>>;
  createMany?: Maybe<ClinicCreateManyLoyaltyProgramInputEnvelope>;
};

export type ClinicUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<ClinicCreateWithoutOrganizationInput>>;
  createMany?: Maybe<ClinicCreateManyOrganizationInputEnvelope>;
};

export type ClinicUncheckedCreateNestedManyWithoutPetsInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutPetsInput>>;
  create?: Maybe<Array<ClinicCreateWithoutPetsInput>>;
};

export type ClinicUncheckedCreateNestedManyWithoutStaffInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutStaffInput>>;
  create?: Maybe<Array<ClinicCreateWithoutStaffInput>>;
};

export type ClinicUncheckedCreateNestedManyWithoutStripePayoutAccountsInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutStripePayoutAccountsInput>>;
  create?: Maybe<Array<ClinicCreateWithoutStripePayoutAccountsInput>>;
};

export type ClinicUncheckedCreateNestedManyWithoutUnlayerSettingInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutUnlayerSettingInput>>;
  create?: Maybe<Array<ClinicCreateWithoutUnlayerSettingInput>>;
  createMany?: Maybe<ClinicCreateManyUnlayerSettingInputEnvelope>;
};

export type ClinicUncheckedCreateNestedManyWithoutUsersIdInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutUsersIdInput>>;
  create?: Maybe<Array<ClinicCreateWithoutUsersIdInput>>;
  createMany?: Maybe<ClinicCreateManyUsersIdInputEnvelope>;
};

export type ClinicUncheckedCreateNestedManyWithoutUsersInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutUsersInput>>;
  create?: Maybe<Array<ClinicCreateWithoutUsersInput>>;
};

export type ClinicUncheckedCreateNestedOneWithoutClinicSettingInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicSettingInput>;
  create?: Maybe<ClinicCreateWithoutClinicSettingInput>;
};

export type ClinicUncheckedCreateWithoutAppoinmentTypesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutAppointmentAvailabilitiesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutAppointmentNoteTemplateInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutAppointmentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutAutomationRunsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutAxionClinicConfigurationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutAxionClinicUserConfigurationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutBenefitsProvidedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutBitwerxHealthchecksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutBlockedPhoneNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutCallsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutCarePayoutOrganizationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutCarePlanProviderGroupInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutChannelFilterSelectionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutChannelStatusChannelAssigneesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutChannelsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicCustomPayoutsSetupInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicDirectBookingSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicEmailCampaignSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicEmployeesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicModulesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicOfficeHoursInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicOnboardingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicPetParentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicPetsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicPhoneNumberInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicRoomsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicUserFiltersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicWidgetRequestsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicWidgetSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutClinicWorkflowTypesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutConsultationRequestsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutConsultationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutDirectBookingExclusionRulesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutEmailCampaignInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutEmailCampaignLogInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutEmailCampaignTemplateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutEmailCampaignUnsubscribeInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutEncryptedClinicUploadsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutFeatureFlagsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutFinancialTransactionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutFormSubmissionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutFormTemplatesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutGooglePlaceInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutHillsToHomeApiLogInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutInformAudienceMemberInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutInformPartnerCustomersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutInformPartnerProgramEnrollmentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutInsuranceIntegrationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutIntegrationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutLegalEntityInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutLoyaltyPointDeltasInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutLoyaltyProgramInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutLoyaltyRewardRedemptionActionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutMassTextAlertsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutMediaInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutMessageTemplatesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutOrganizationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutPaymentProcessorForProviderGroupInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutPayoutBatchingPeriodsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutPayoutBatchingSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutPetsIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutPetsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutPostcardSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutPrescriptionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutProductPackageSubscriptionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutPromoCodesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutRecapsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutRolesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutRulesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutSentTrupanionExamDayOffersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutStaffIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutStaffInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutStripePaymentIntentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutStripePayoutAccountsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutStripeTerminalLocationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutSurveyResultsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutSynchronyClinicConfigurationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutTasksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutTwilioConfigurationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutTwilioVerificationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutUnlayerSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutUserAppointmentGroupingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutUserBoardFiltersColumnsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutUserTaskListsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutUsersIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutUsersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutVaccinationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutVetAvailabilitiesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutVetsourceInstallationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput>;
};

export type ClinicUncheckedCreateWithoutWorkflowEventSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput>;
  Rules?: Maybe<RulesUncheckedCreateNestedManyWithoutClinicInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutClinicInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutClinicInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutClinicInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutUsageClinicInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedCreateNestedManyWithoutClinicInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedCreateNestedManyWithoutClinicInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedCreateNestedManyWithoutClinicInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutClinicInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutClinicInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedOneWithoutClinicInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutClinicInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedCreateNestedManyWithoutClinicInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutClinicInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutClinicInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutClinicInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutClinicInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutClinicInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutClinicInput>;
  formTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedCreateNestedOneWithoutClinicInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedManyWithoutClinicInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutClinicInput>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutClinicInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutClinicInput>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPreviousClinicsInput>;
  petsId?: Maybe<PetUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedCreateNestedManyWithoutClinicInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutClinicInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput>;
  promoCodes?: Maybe<PromoCodeUncheckedCreateNestedManyWithoutClinicInput>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutClinicInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutClinicInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedCreateNestedManyWithoutClinicsInput>;
  staffId?: Maybe<VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedCreateNestedManyWithoutClinicInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutClinicInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutClinicInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutClinicInput>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutClinicsInput>;
  vaccinations?: Maybe<VaccinationUncheckedCreateNestedManyWithoutClinicInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateManyInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutCarePlanProviderGroupInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutCarePlanProviderGroupNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutCarePlanProviderGroupInput>>;
  create?: Maybe<Array<ClinicCreateWithoutCarePlanProviderGroupInput>>;
  createMany?: Maybe<ClinicCreateManyCarePlanProviderGroupInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutCarePlanProviderGroupInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutCarePlanProviderGroupInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutCarePlanProviderGroupInput>>;
};

export type ClinicUncheckedUpdateManyWithoutClinicWidgetSettingInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutClinicWidgetSettingNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutClinicWidgetSettingInput>>;
  create?: Maybe<Array<ClinicCreateWithoutClinicWidgetSettingInput>>;
  createMany?: Maybe<ClinicCreateManyClinicWidgetSettingInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutClinicWidgetSettingInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutClinicWidgetSettingInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutClinicWidgetSettingInput>>;
};

export type ClinicUncheckedUpdateManyWithoutFeatureFlagsInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutFeatureFlagsNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutFeatureFlagsInput>>;
  create?: Maybe<Array<ClinicCreateWithoutFeatureFlagsInput>>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutFeatureFlagsInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutFeatureFlagsInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutFeatureFlagsInput>>;
};

export type ClinicUncheckedUpdateManyWithoutLegalEntityInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutLegalEntityNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutLegalEntityInput>>;
  create?: Maybe<Array<ClinicCreateWithoutLegalEntityInput>>;
  createMany?: Maybe<ClinicCreateManyLegalEntityInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutLegalEntityInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutLegalEntityInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutLegalEntityInput>>;
};

export type ClinicUncheckedUpdateManyWithoutLoyaltyProgramInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutLoyaltyProgramNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutLoyaltyProgramInput>>;
  create?: Maybe<Array<ClinicCreateWithoutLoyaltyProgramInput>>;
  createMany?: Maybe<ClinicCreateManyLoyaltyProgramInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutLoyaltyProgramInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutLoyaltyProgramInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutLoyaltyProgramInput>>;
};

export type ClinicUncheckedUpdateManyWithoutOrganizationInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<ClinicCreateWithoutOrganizationInput>>;
  createMany?: Maybe<ClinicCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type ClinicUncheckedUpdateManyWithoutPetsInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutPetsNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutPetsInput>>;
  create?: Maybe<Array<ClinicCreateWithoutPetsInput>>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutPetsInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutPetsInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutPetsInput>>;
};

export type ClinicUncheckedUpdateManyWithoutStaffInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutStaffNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutStaffInput>>;
  create?: Maybe<Array<ClinicCreateWithoutStaffInput>>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutStaffInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutStaffInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutStaffInput>>;
};

export type ClinicUncheckedUpdateManyWithoutStripePayoutAccountsInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutStripePayoutAccountsNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutStripePayoutAccountsInput>>;
  create?: Maybe<Array<ClinicCreateWithoutStripePayoutAccountsInput>>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutStripePayoutAccountsInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutStripePayoutAccountsInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutStripePayoutAccountsInput>>;
};

export type ClinicUncheckedUpdateManyWithoutUnlayerSettingInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutUnlayerSettingNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutUnlayerSettingInput>>;
  create?: Maybe<Array<ClinicCreateWithoutUnlayerSettingInput>>;
  createMany?: Maybe<ClinicCreateManyUnlayerSettingInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutUnlayerSettingInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutUnlayerSettingInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutUnlayerSettingInput>>;
};

export type ClinicUncheckedUpdateManyWithoutUsersIdInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutUsersIdNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutUsersIdInput>>;
  create?: Maybe<Array<ClinicCreateWithoutUsersIdInput>>;
  createMany?: Maybe<ClinicCreateManyUsersIdInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutUsersIdInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutUsersIdInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutUsersIdInput>>;
};

export type ClinicUncheckedUpdateManyWithoutUsersInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUncheckedUpdateManyWithoutUsersNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutUsersInput>>;
  create?: Maybe<Array<ClinicCreateWithoutUsersInput>>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type ClinicUncheckedUpdateOneWithoutClinicSettingNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicSettingInput>;
  create?: Maybe<ClinicCreateWithoutClinicSettingInput>;
  delete?: Maybe<ClinicWhereInput>;
  disconnect?: Maybe<ClinicWhereInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicSettingInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicSettingInput>;
};

export type ClinicUncheckedUpdateWithoutAppoinmentTypesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutAppointmentAvailabilitiesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutAppointmentNoteTemplateInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutAppointmentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutAutomationRunsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutAxionClinicConfigurationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutAxionClinicUserConfigurationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutBenefitsProvidedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutBitwerxHealthchecksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutBlockedPhoneNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutCallsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutCarePayoutOrganizationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutCarePlanProviderGroupInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutChannelFilterSelectionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutChannelStatusChannelAssigneesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutChannelsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicCustomPayoutsSetupInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicDirectBookingSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicEmailCampaignSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicEmployeesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicModulesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicOfficeHoursInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicOnboardingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicPetParentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicPetsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicPhoneNumberInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicRoomsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicUserFiltersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicWidgetRequestsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicWidgetSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutClinicWorkflowTypesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutConsultationRequestsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutConsultationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutDirectBookingExclusionRulesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutEmailCampaignInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutEmailCampaignLogInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutEmailCampaignTemplateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutEmailCampaignUnsubscribeInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutEncryptedClinicUploadsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutFeatureFlagsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutFinancialTransactionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutFormSubmissionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutFormTemplatesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutGooglePlaceInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutHillsToHomeApiLogInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutInformAudienceMemberInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutInformPartnerCustomersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutInformPartnerProgramEnrollmentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutInsuranceIntegrationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutIntegrationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutLegalEntityInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutLoyaltyPointDeltasInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutLoyaltyProgramInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutLoyaltyRewardRedemptionActionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutMassTextAlertsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutMediaInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutMessageTemplatesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutOrganizationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutPaymentProcessorForProviderGroupInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutPayoutBatchingPeriodsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutPayoutBatchingSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutPetsIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutPetsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutPostcardSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutPrescriptionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutProductPackageSubscriptionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutPromoCodesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutRecapsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutRolesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutRulesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutSentTrupanionExamDayOffersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutStaffIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutStaffInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutStripePaymentIntentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutStripePayoutAccountsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutStripeTerminalLocationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutSurveyResultsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutSynchronyClinicConfigurationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutTasksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutTwilioConfigurationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutTwilioVerificationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutUnlayerSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutUserAppointmentGroupingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutUserBoardFiltersColumnsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutUserTaskListsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutUsersIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutUsersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutVaccinationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutVetAvailabilitiesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutVetsourceInstallationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUncheckedUpdateWithoutWorkflowEventSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUncheckedUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUncheckedUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUncheckedUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUncheckedUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUncheckedUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUncheckedUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUncheckedUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUncheckedUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUncheckedUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUncheckedUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUncheckedUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUncheckedUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUpdateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateManyMutationInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUpdateManyWithWhereWithoutCarePlanProviderGroupInput = {
  data: ClinicUpdateManyMutationInput;
  where: ClinicScalarWhereInput;
};

export type ClinicUpdateManyWithWhereWithoutClinicWidgetSettingInput = {
  data: ClinicUpdateManyMutationInput;
  where: ClinicScalarWhereInput;
};

export type ClinicUpdateManyWithWhereWithoutFeatureFlagsInput = {
  data: ClinicUpdateManyMutationInput;
  where: ClinicScalarWhereInput;
};

export type ClinicUpdateManyWithWhereWithoutLegalEntityInput = {
  data: ClinicUpdateManyMutationInput;
  where: ClinicScalarWhereInput;
};

export type ClinicUpdateManyWithWhereWithoutLoyaltyProgramInput = {
  data: ClinicUpdateManyMutationInput;
  where: ClinicScalarWhereInput;
};

export type ClinicUpdateManyWithWhereWithoutOrganizationInput = {
  data: ClinicUpdateManyMutationInput;
  where: ClinicScalarWhereInput;
};

export type ClinicUpdateManyWithWhereWithoutPetsInput = {
  data: ClinicUpdateManyMutationInput;
  where: ClinicScalarWhereInput;
};

export type ClinicUpdateManyWithWhereWithoutStaffInput = {
  data: ClinicUpdateManyMutationInput;
  where: ClinicScalarWhereInput;
};

export type ClinicUpdateManyWithWhereWithoutStripePayoutAccountsInput = {
  data: ClinicUpdateManyMutationInput;
  where: ClinicScalarWhereInput;
};

export type ClinicUpdateManyWithWhereWithoutUnlayerSettingInput = {
  data: ClinicUpdateManyMutationInput;
  where: ClinicScalarWhereInput;
};

export type ClinicUpdateManyWithWhereWithoutUsersIdInput = {
  data: ClinicUpdateManyMutationInput;
  where: ClinicScalarWhereInput;
};

export type ClinicUpdateManyWithWhereWithoutUsersInput = {
  data: ClinicUpdateManyMutationInput;
  where: ClinicScalarWhereInput;
};

export type ClinicUpdateManyWithoutCarePlanProviderGroupNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutCarePlanProviderGroupInput>>;
  create?: Maybe<Array<ClinicCreateWithoutCarePlanProviderGroupInput>>;
  createMany?: Maybe<ClinicCreateManyCarePlanProviderGroupInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutCarePlanProviderGroupInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutCarePlanProviderGroupInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutCarePlanProviderGroupInput>>;
};

export type ClinicUpdateManyWithoutClinicWidgetSettingNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutClinicWidgetSettingInput>>;
  create?: Maybe<Array<ClinicCreateWithoutClinicWidgetSettingInput>>;
  createMany?: Maybe<ClinicCreateManyClinicWidgetSettingInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutClinicWidgetSettingInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutClinicWidgetSettingInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutClinicWidgetSettingInput>>;
};

export type ClinicUpdateManyWithoutFeatureFlagsNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutFeatureFlagsInput>>;
  create?: Maybe<Array<ClinicCreateWithoutFeatureFlagsInput>>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutFeatureFlagsInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutFeatureFlagsInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutFeatureFlagsInput>>;
};

export type ClinicUpdateManyWithoutLegalEntityNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutLegalEntityInput>>;
  create?: Maybe<Array<ClinicCreateWithoutLegalEntityInput>>;
  createMany?: Maybe<ClinicCreateManyLegalEntityInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutLegalEntityInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutLegalEntityInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutLegalEntityInput>>;
};

export type ClinicUpdateManyWithoutLoyaltyProgramNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutLoyaltyProgramInput>>;
  create?: Maybe<Array<ClinicCreateWithoutLoyaltyProgramInput>>;
  createMany?: Maybe<ClinicCreateManyLoyaltyProgramInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutLoyaltyProgramInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutLoyaltyProgramInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutLoyaltyProgramInput>>;
};

export type ClinicUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<ClinicCreateWithoutOrganizationInput>>;
  createMany?: Maybe<ClinicCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type ClinicUpdateManyWithoutPetsNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutPetsInput>>;
  create?: Maybe<Array<ClinicCreateWithoutPetsInput>>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutPetsInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutPetsInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutPetsInput>>;
};

export type ClinicUpdateManyWithoutStaffNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutStaffInput>>;
  create?: Maybe<Array<ClinicCreateWithoutStaffInput>>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutStaffInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutStaffInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutStaffInput>>;
};

export type ClinicUpdateManyWithoutStripePayoutAccountsNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutStripePayoutAccountsInput>>;
  create?: Maybe<Array<ClinicCreateWithoutStripePayoutAccountsInput>>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutStripePayoutAccountsInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutStripePayoutAccountsInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutStripePayoutAccountsInput>>;
};

export type ClinicUpdateManyWithoutUnlayerSettingNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutUnlayerSettingInput>>;
  create?: Maybe<Array<ClinicCreateWithoutUnlayerSettingInput>>;
  createMany?: Maybe<ClinicCreateManyUnlayerSettingInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutUnlayerSettingInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutUnlayerSettingInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutUnlayerSettingInput>>;
};

export type ClinicUpdateManyWithoutUsersIdNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutUsersIdInput>>;
  create?: Maybe<Array<ClinicCreateWithoutUsersIdInput>>;
  createMany?: Maybe<ClinicCreateManyUsersIdInputEnvelope>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutUsersIdInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutUsersIdInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutUsersIdInput>>;
};

export type ClinicUpdateManyWithoutUsersNestedInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicCreateOrConnectWithoutUsersInput>>;
  create?: Maybe<Array<ClinicCreateWithoutUsersInput>>;
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: Maybe<Array<ClinicUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: Maybe<Array<ClinicUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type ClinicUpdateOneRequiredWithoutAppointmentNoteTemplateNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAppointmentNoteTemplateInput>;
  create?: Maybe<ClinicCreateWithoutAppointmentNoteTemplateInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutAppointmentNoteTemplateInput>;
  upsert?: Maybe<ClinicUpsertWithoutAppointmentNoteTemplateInput>;
};

export type ClinicUpdateOneRequiredWithoutAutomationRunsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<ClinicCreateWithoutAutomationRunsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutAutomationRunsInput>;
  upsert?: Maybe<ClinicUpsertWithoutAutomationRunsInput>;
};

export type ClinicUpdateOneRequiredWithoutAxionClinicConfigurationNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAxionClinicConfigurationInput>;
  create?: Maybe<ClinicCreateWithoutAxionClinicConfigurationInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutAxionClinicConfigurationInput>;
  upsert?: Maybe<ClinicUpsertWithoutAxionClinicConfigurationInput>;
};

export type ClinicUpdateOneRequiredWithoutAxionClinicUserConfigurationsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAxionClinicUserConfigurationsInput>;
  create?: Maybe<ClinicCreateWithoutAxionClinicUserConfigurationsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutAxionClinicUserConfigurationsInput>;
  upsert?: Maybe<ClinicUpsertWithoutAxionClinicUserConfigurationsInput>;
};

export type ClinicUpdateOneRequiredWithoutBenefitsProvidedNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutBenefitsProvidedInput>;
  create?: Maybe<ClinicCreateWithoutBenefitsProvidedInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutBenefitsProvidedInput>;
  upsert?: Maybe<ClinicUpsertWithoutBenefitsProvidedInput>;
};

export type ClinicUpdateOneRequiredWithoutBitwerxHealthchecksNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutBitwerxHealthchecksInput>;
  create?: Maybe<ClinicCreateWithoutBitwerxHealthchecksInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutBitwerxHealthchecksInput>;
  upsert?: Maybe<ClinicUpsertWithoutBitwerxHealthchecksInput>;
};

export type ClinicUpdateOneRequiredWithoutBlockedPhoneNumbersNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutBlockedPhoneNumbersInput>;
  create?: Maybe<ClinicCreateWithoutBlockedPhoneNumbersInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutBlockedPhoneNumbersInput>;
  upsert?: Maybe<ClinicUpsertWithoutBlockedPhoneNumbersInput>;
};

export type ClinicUpdateOneRequiredWithoutCallsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutCallsInput>;
  create?: Maybe<ClinicCreateWithoutCallsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutCallsInput>;
  upsert?: Maybe<ClinicUpsertWithoutCallsInput>;
};

export type ClinicUpdateOneRequiredWithoutChannelFilterSelectionsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutChannelFilterSelectionsInput>;
  create?: Maybe<ClinicCreateWithoutChannelFilterSelectionsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutChannelFilterSelectionsInput>;
  upsert?: Maybe<ClinicUpsertWithoutChannelFilterSelectionsInput>;
};

export type ClinicUpdateOneRequiredWithoutChannelStatusChannelAssigneesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutChannelStatusChannelAssigneesInput>;
  create?: Maybe<ClinicCreateWithoutChannelStatusChannelAssigneesInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutChannelStatusChannelAssigneesInput>;
  upsert?: Maybe<ClinicUpsertWithoutChannelStatusChannelAssigneesInput>;
};

export type ClinicUpdateOneRequiredWithoutClinicCustomPayoutsSetupNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicCustomPayoutsSetupInput>;
  create?: Maybe<ClinicCreateWithoutClinicCustomPayoutsSetupInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicCustomPayoutsSetupInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicCustomPayoutsSetupInput>;
};

export type ClinicUpdateOneRequiredWithoutClinicDirectBookingSettingsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicDirectBookingSettingsInput>;
  create?: Maybe<ClinicCreateWithoutClinicDirectBookingSettingsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicDirectBookingSettingsInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicDirectBookingSettingsInput>;
};

export type ClinicUpdateOneRequiredWithoutClinicEmailCampaignSettingsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicEmailCampaignSettingsInput>;
  create?: Maybe<ClinicCreateWithoutClinicEmailCampaignSettingsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicEmailCampaignSettingsInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicEmailCampaignSettingsInput>;
};

export type ClinicUpdateOneRequiredWithoutClinicModulesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicModulesInput>;
  create?: Maybe<ClinicCreateWithoutClinicModulesInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicModulesInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicModulesInput>;
};

export type ClinicUpdateOneRequiredWithoutClinicOnboardingsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicOnboardingsInput>;
  create?: Maybe<ClinicCreateWithoutClinicOnboardingsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicOnboardingsInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicOnboardingsInput>;
};

export type ClinicUpdateOneRequiredWithoutClinicPhoneNumberNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicPhoneNumberInput>;
  create?: Maybe<ClinicCreateWithoutClinicPhoneNumberInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicPhoneNumberInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicPhoneNumberInput>;
};

export type ClinicUpdateOneRequiredWithoutClinicUserFiltersNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicUserFiltersInput>;
  create?: Maybe<ClinicCreateWithoutClinicUserFiltersInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicUserFiltersInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicUserFiltersInput>;
};

export type ClinicUpdateOneRequiredWithoutDirectBookingExclusionRulesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutDirectBookingExclusionRulesInput>;
  create?: Maybe<ClinicCreateWithoutDirectBookingExclusionRulesInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutDirectBookingExclusionRulesInput>;
  upsert?: Maybe<ClinicUpsertWithoutDirectBookingExclusionRulesInput>;
};

export type ClinicUpdateOneRequiredWithoutEmailCampaignLogNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutEmailCampaignLogInput>;
  create?: Maybe<ClinicCreateWithoutEmailCampaignLogInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutEmailCampaignLogInput>;
  upsert?: Maybe<ClinicUpsertWithoutEmailCampaignLogInput>;
};

export type ClinicUpdateOneRequiredWithoutEmailCampaignNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutEmailCampaignInput>;
  create?: Maybe<ClinicCreateWithoutEmailCampaignInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutEmailCampaignInput>;
  upsert?: Maybe<ClinicUpsertWithoutEmailCampaignInput>;
};

export type ClinicUpdateOneRequiredWithoutEncryptedClinicUploadsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutEncryptedClinicUploadsInput>;
  create?: Maybe<ClinicCreateWithoutEncryptedClinicUploadsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutEncryptedClinicUploadsInput>;
  upsert?: Maybe<ClinicUpsertWithoutEncryptedClinicUploadsInput>;
};

export type ClinicUpdateOneRequiredWithoutFinancialTransactionsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutFinancialTransactionsInput>;
  create?: Maybe<ClinicCreateWithoutFinancialTransactionsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutFinancialTransactionsInput>;
  upsert?: Maybe<ClinicUpsertWithoutFinancialTransactionsInput>;
};

export type ClinicUpdateOneRequiredWithoutHillsToHomeApiLogNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutHillsToHomeApiLogInput>;
  create?: Maybe<ClinicCreateWithoutHillsToHomeApiLogInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutHillsToHomeApiLogInput>;
  upsert?: Maybe<ClinicUpsertWithoutHillsToHomeApiLogInput>;
};

export type ClinicUpdateOneRequiredWithoutInformAudienceMemberNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutInformAudienceMemberInput>;
  create?: Maybe<ClinicCreateWithoutInformAudienceMemberInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutInformAudienceMemberInput>;
  upsert?: Maybe<ClinicUpsertWithoutInformAudienceMemberInput>;
};

export type ClinicUpdateOneRequiredWithoutInformPartnerProgramEnrollmentsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutInformPartnerProgramEnrollmentsInput>;
  create?: Maybe<ClinicCreateWithoutInformPartnerProgramEnrollmentsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutInformPartnerProgramEnrollmentsInput>;
  upsert?: Maybe<ClinicUpsertWithoutInformPartnerProgramEnrollmentsInput>;
};

export type ClinicUpdateOneRequiredWithoutInsuranceIntegrationsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutInsuranceIntegrationsInput>;
  create?: Maybe<ClinicCreateWithoutInsuranceIntegrationsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutInsuranceIntegrationsInput>;
  upsert?: Maybe<ClinicUpsertWithoutInsuranceIntegrationsInput>;
};

export type ClinicUpdateOneRequiredWithoutLoyaltyPointDeltasNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutLoyaltyPointDeltasInput>;
  create?: Maybe<ClinicCreateWithoutLoyaltyPointDeltasInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutLoyaltyPointDeltasInput>;
  upsert?: Maybe<ClinicUpsertWithoutLoyaltyPointDeltasInput>;
};

export type ClinicUpdateOneRequiredWithoutMassTextAlertsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutMassTextAlertsInput>;
  create?: Maybe<ClinicCreateWithoutMassTextAlertsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutMassTextAlertsInput>;
  upsert?: Maybe<ClinicUpsertWithoutMassTextAlertsInput>;
};

export type ClinicUpdateOneRequiredWithoutMessageTemplatesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutMessageTemplatesInput>;
  create?: Maybe<ClinicCreateWithoutMessageTemplatesInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutMessageTemplatesInput>;
  upsert?: Maybe<ClinicUpsertWithoutMessageTemplatesInput>;
};

export type ClinicUpdateOneRequiredWithoutPayoutBatchingPeriodsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPayoutBatchingPeriodsInput>;
  create?: Maybe<ClinicCreateWithoutPayoutBatchingPeriodsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutPayoutBatchingPeriodsInput>;
  upsert?: Maybe<ClinicUpsertWithoutPayoutBatchingPeriodsInput>;
};

export type ClinicUpdateOneRequiredWithoutPayoutBatchingSettingNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPayoutBatchingSettingInput>;
  create?: Maybe<ClinicCreateWithoutPayoutBatchingSettingInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutPayoutBatchingSettingInput>;
  upsert?: Maybe<ClinicUpsertWithoutPayoutBatchingSettingInput>;
};

export type ClinicUpdateOneRequiredWithoutPostcardSettingsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPostcardSettingsInput>;
  create?: Maybe<ClinicCreateWithoutPostcardSettingsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutPostcardSettingsInput>;
  upsert?: Maybe<ClinicUpsertWithoutPostcardSettingsInput>;
};

export type ClinicUpdateOneRequiredWithoutPrescriptionsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPrescriptionsInput>;
  create?: Maybe<ClinicCreateWithoutPrescriptionsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutPrescriptionsInput>;
  upsert?: Maybe<ClinicUpsertWithoutPrescriptionsInput>;
};

export type ClinicUpdateOneRequiredWithoutProductPackageSubscriptionsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutProductPackageSubscriptionsInput>;
  create?: Maybe<ClinicCreateWithoutProductPackageSubscriptionsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutProductPackageSubscriptionsInput>;
  upsert?: Maybe<ClinicUpsertWithoutProductPackageSubscriptionsInput>;
};

export type ClinicUpdateOneRequiredWithoutRecapsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutRecapsInput>;
  create?: Maybe<ClinicCreateWithoutRecapsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutRecapsInput>;
  upsert?: Maybe<ClinicUpsertWithoutRecapsInput>;
};

export type ClinicUpdateOneRequiredWithoutRulesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutRulesInput>;
  create?: Maybe<ClinicCreateWithoutRulesInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutRulesInput>;
  upsert?: Maybe<ClinicUpsertWithoutRulesInput>;
};

export type ClinicUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutSentTrupanionExamDayOffersInput>;
  create?: Maybe<ClinicCreateWithoutSentTrupanionExamDayOffersInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutSentTrupanionExamDayOffersInput>;
  upsert?: Maybe<ClinicUpsertWithoutSentTrupanionExamDayOffersInput>;
};

export type ClinicUpdateOneRequiredWithoutStripeTerminalLocationsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutStripeTerminalLocationsInput>;
  create?: Maybe<ClinicCreateWithoutStripeTerminalLocationsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutStripeTerminalLocationsInput>;
  upsert?: Maybe<ClinicUpsertWithoutStripeTerminalLocationsInput>;
};

export type ClinicUpdateOneRequiredWithoutSurveyResultsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutSurveyResultsInput>;
  create?: Maybe<ClinicCreateWithoutSurveyResultsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutSurveyResultsInput>;
  upsert?: Maybe<ClinicUpsertWithoutSurveyResultsInput>;
};

export type ClinicUpdateOneRequiredWithoutSynchronyClinicConfigurationNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutSynchronyClinicConfigurationInput>;
  create?: Maybe<ClinicCreateWithoutSynchronyClinicConfigurationInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutSynchronyClinicConfigurationInput>;
  upsert?: Maybe<ClinicUpsertWithoutSynchronyClinicConfigurationInput>;
};

export type ClinicUpdateOneRequiredWithoutTasksNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutTasksInput>;
  create?: Maybe<ClinicCreateWithoutTasksInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutTasksInput>;
  upsert?: Maybe<ClinicUpsertWithoutTasksInput>;
};

export type ClinicUpdateOneRequiredWithoutTwilioConfigurationNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutTwilioConfigurationInput>;
  create?: Maybe<ClinicCreateWithoutTwilioConfigurationInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutTwilioConfigurationInput>;
  upsert?: Maybe<ClinicUpsertWithoutTwilioConfigurationInput>;
};

export type ClinicUpdateOneRequiredWithoutTwilioVerificationsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutTwilioVerificationsInput>;
  create?: Maybe<ClinicCreateWithoutTwilioVerificationsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutTwilioVerificationsInput>;
  upsert?: Maybe<ClinicUpsertWithoutTwilioVerificationsInput>;
};

export type ClinicUpdateOneRequiredWithoutUserBoardFiltersColumnsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutUserBoardFiltersColumnsInput>;
  create?: Maybe<ClinicCreateWithoutUserBoardFiltersColumnsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutUserBoardFiltersColumnsInput>;
  upsert?: Maybe<ClinicUpsertWithoutUserBoardFiltersColumnsInput>;
};

export type ClinicUpdateOneRequiredWithoutVaccinationsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutVaccinationsInput>;
  create?: Maybe<ClinicCreateWithoutVaccinationsInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutVaccinationsInput>;
  upsert?: Maybe<ClinicUpsertWithoutVaccinationsInput>;
};

export type ClinicUpdateOneRequiredWithoutVetAvailabilitiesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutVetAvailabilitiesInput>;
  create?: Maybe<ClinicCreateWithoutVetAvailabilitiesInput>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutVetAvailabilitiesInput>;
  upsert?: Maybe<ClinicUpsertWithoutVetAvailabilitiesInput>;
};

export type ClinicUpdateOneWithoutAppoinmentTypesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAppoinmentTypesInput>;
  create?: Maybe<ClinicCreateWithoutAppoinmentTypesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutAppoinmentTypesInput>;
  upsert?: Maybe<ClinicUpsertWithoutAppoinmentTypesInput>;
};

export type ClinicUpdateOneWithoutAppointmentAvailabilitiesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAppointmentAvailabilitiesInput>;
  create?: Maybe<ClinicCreateWithoutAppointmentAvailabilitiesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutAppointmentAvailabilitiesInput>;
  upsert?: Maybe<ClinicUpsertWithoutAppointmentAvailabilitiesInput>;
};

export type ClinicUpdateOneWithoutAppointmentsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<ClinicCreateWithoutAppointmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutAppointmentsInput>;
  upsert?: Maybe<ClinicUpsertWithoutAppointmentsInput>;
};

export type ClinicUpdateOneWithoutCarePayoutOrganizationNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutCarePayoutOrganizationInput>;
  create?: Maybe<ClinicCreateWithoutCarePayoutOrganizationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutCarePayoutOrganizationInput>;
  upsert?: Maybe<ClinicUpsertWithoutCarePayoutOrganizationInput>;
};

export type ClinicUpdateOneWithoutChannelsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutChannelsInput>;
  create?: Maybe<ClinicCreateWithoutChannelsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutChannelsInput>;
  upsert?: Maybe<ClinicUpsertWithoutChannelsInput>;
};

export type ClinicUpdateOneWithoutClinicEmployeesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicEmployeesInput>;
  create?: Maybe<ClinicCreateWithoutClinicEmployeesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicEmployeesInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicEmployeesInput>;
};

export type ClinicUpdateOneWithoutClinicOfficeHoursNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicOfficeHoursInput>;
  create?: Maybe<ClinicCreateWithoutClinicOfficeHoursInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicOfficeHoursInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicOfficeHoursInput>;
};

export type ClinicUpdateOneWithoutClinicPetParentsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicPetParentsInput>;
  create?: Maybe<ClinicCreateWithoutClinicPetParentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicPetParentsInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicPetParentsInput>;
};

export type ClinicUpdateOneWithoutClinicPetsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicPetsInput>;
  create?: Maybe<ClinicCreateWithoutClinicPetsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicPetsInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicPetsInput>;
};

export type ClinicUpdateOneWithoutClinicRoomsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicRoomsInput>;
  create?: Maybe<ClinicCreateWithoutClinicRoomsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicRoomsInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicRoomsInput>;
};

export type ClinicUpdateOneWithoutClinicSettingNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicSettingInput>;
  create?: Maybe<ClinicCreateWithoutClinicSettingInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicSettingInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicSettingInput>;
};

export type ClinicUpdateOneWithoutClinicWidgetRequestsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicWidgetRequestsInput>;
  create?: Maybe<ClinicCreateWithoutClinicWidgetRequestsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicWidgetRequestsInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicWidgetRequestsInput>;
};

export type ClinicUpdateOneWithoutClinicWorkflowTypesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutClinicWorkflowTypesInput>;
  create?: Maybe<ClinicCreateWithoutClinicWorkflowTypesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutClinicWorkflowTypesInput>;
  upsert?: Maybe<ClinicUpsertWithoutClinicWorkflowTypesInput>;
};

export type ClinicUpdateOneWithoutConsultationRequestsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutConsultationRequestsInput>;
  create?: Maybe<ClinicCreateWithoutConsultationRequestsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutConsultationRequestsInput>;
  upsert?: Maybe<ClinicUpsertWithoutConsultationRequestsInput>;
};

export type ClinicUpdateOneWithoutConsultationsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutConsultationsInput>;
  create?: Maybe<ClinicCreateWithoutConsultationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutConsultationsInput>;
  upsert?: Maybe<ClinicUpsertWithoutConsultationsInput>;
};

export type ClinicUpdateOneWithoutEmailCampaignTemplateNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutEmailCampaignTemplateInput>;
  create?: Maybe<ClinicCreateWithoutEmailCampaignTemplateInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutEmailCampaignTemplateInput>;
  upsert?: Maybe<ClinicUpsertWithoutEmailCampaignTemplateInput>;
};

export type ClinicUpdateOneWithoutEmailCampaignUnsubscribeNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutEmailCampaignUnsubscribeInput>;
  create?: Maybe<ClinicCreateWithoutEmailCampaignUnsubscribeInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutEmailCampaignUnsubscribeInput>;
  upsert?: Maybe<ClinicUpsertWithoutEmailCampaignUnsubscribeInput>;
};

export type ClinicUpdateOneWithoutFormSubmissionsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutFormSubmissionsInput>;
  create?: Maybe<ClinicCreateWithoutFormSubmissionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutFormSubmissionsInput>;
  upsert?: Maybe<ClinicUpsertWithoutFormSubmissionsInput>;
};

export type ClinicUpdateOneWithoutFormTemplatesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutFormTemplatesInput>;
  create?: Maybe<ClinicCreateWithoutFormTemplatesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutFormTemplatesInput>;
  upsert?: Maybe<ClinicUpsertWithoutFormTemplatesInput>;
};

export type ClinicUpdateOneWithoutGooglePlaceNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutGooglePlaceInput>;
  create?: Maybe<ClinicCreateWithoutGooglePlaceInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutGooglePlaceInput>;
  upsert?: Maybe<ClinicUpsertWithoutGooglePlaceInput>;
};

export type ClinicUpdateOneWithoutInformPartnerCustomersNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutInformPartnerCustomersInput>;
  create?: Maybe<ClinicCreateWithoutInformPartnerCustomersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutInformPartnerCustomersInput>;
  upsert?: Maybe<ClinicUpsertWithoutInformPartnerCustomersInput>;
};

export type ClinicUpdateOneWithoutIntegrationsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutIntegrationsInput>;
  create?: Maybe<ClinicCreateWithoutIntegrationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutIntegrationsInput>;
  upsert?: Maybe<ClinicUpsertWithoutIntegrationsInput>;
};

export type ClinicUpdateOneWithoutLoyaltyRewardRedemptionActionsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutLoyaltyRewardRedemptionActionsInput>;
  create?: Maybe<ClinicCreateWithoutLoyaltyRewardRedemptionActionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutLoyaltyRewardRedemptionActionsInput>;
  upsert?: Maybe<ClinicUpsertWithoutLoyaltyRewardRedemptionActionsInput>;
};

export type ClinicUpdateOneWithoutMediaNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutMediaInput>;
  create?: Maybe<ClinicCreateWithoutMediaInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutMediaInput>;
  upsert?: Maybe<ClinicUpsertWithoutMediaInput>;
};

export type ClinicUpdateOneWithoutPaymentProcessorForProviderGroupNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPaymentProcessorForProviderGroupInput>;
  create?: Maybe<ClinicCreateWithoutPaymentProcessorForProviderGroupInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutPaymentProcessorForProviderGroupInput>;
  upsert?: Maybe<ClinicUpsertWithoutPaymentProcessorForProviderGroupInput>;
};

export type ClinicUpdateOneWithoutPetsIdNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPetsIdInput>;
  create?: Maybe<ClinicCreateWithoutPetsIdInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutPetsIdInput>;
  upsert?: Maybe<ClinicUpsertWithoutPetsIdInput>;
};

export type ClinicUpdateOneWithoutPromoCodesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutPromoCodesInput>;
  create?: Maybe<ClinicCreateWithoutPromoCodesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutPromoCodesInput>;
  upsert?: Maybe<ClinicUpsertWithoutPromoCodesInput>;
};

export type ClinicUpdateOneWithoutRolesNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutRolesInput>;
  create?: Maybe<ClinicCreateWithoutRolesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutRolesInput>;
  upsert?: Maybe<ClinicUpsertWithoutRolesInput>;
};

export type ClinicUpdateOneWithoutStaffIdNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutStaffIdInput>;
  create?: Maybe<ClinicCreateWithoutStaffIdInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutStaffIdInput>;
  upsert?: Maybe<ClinicUpsertWithoutStaffIdInput>;
};

export type ClinicUpdateOneWithoutStripePaymentIntentsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutStripePaymentIntentsInput>;
  create?: Maybe<ClinicCreateWithoutStripePaymentIntentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutStripePaymentIntentsInput>;
  upsert?: Maybe<ClinicUpsertWithoutStripePaymentIntentsInput>;
};

export type ClinicUpdateOneWithoutUserAppointmentGroupingsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutUserAppointmentGroupingsInput>;
  create?: Maybe<ClinicCreateWithoutUserAppointmentGroupingsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutUserAppointmentGroupingsInput>;
  upsert?: Maybe<ClinicUpsertWithoutUserAppointmentGroupingsInput>;
};

export type ClinicUpdateOneWithoutUserTaskListsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutUserTaskListsInput>;
  create?: Maybe<ClinicCreateWithoutUserTaskListsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutUserTaskListsInput>;
  upsert?: Maybe<ClinicUpsertWithoutUserTaskListsInput>;
};

export type ClinicUpdateOneWithoutVetsourceInstallationNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutVetsourceInstallationInput>;
  create?: Maybe<ClinicCreateWithoutVetsourceInstallationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutVetsourceInstallationInput>;
  upsert?: Maybe<ClinicUpsertWithoutVetsourceInstallationInput>;
};

export type ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicCreateOrConnectWithoutWorkflowEventSettingsInput>;
  create?: Maybe<ClinicCreateWithoutWorkflowEventSettingsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicUpdateToOneWithWhereWithoutWorkflowEventSettingsInput>;
  upsert?: Maybe<ClinicUpsertWithoutWorkflowEventSettingsInput>;
};

export type ClinicUpdateToOneWithWhereWithoutAppoinmentTypesInput = {
  data: ClinicUpdateWithoutAppoinmentTypesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutAppointmentAvailabilitiesInput = {
  data: ClinicUpdateWithoutAppointmentAvailabilitiesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutAppointmentNoteTemplateInput = {
  data: ClinicUpdateWithoutAppointmentNoteTemplateInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutAppointmentsInput = {
  data: ClinicUpdateWithoutAppointmentsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutAutomationRunsInput = {
  data: ClinicUpdateWithoutAutomationRunsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutAxionClinicConfigurationInput = {
  data: ClinicUpdateWithoutAxionClinicConfigurationInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutAxionClinicUserConfigurationsInput = {
  data: ClinicUpdateWithoutAxionClinicUserConfigurationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutBenefitsProvidedInput = {
  data: ClinicUpdateWithoutBenefitsProvidedInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutBitwerxHealthchecksInput = {
  data: ClinicUpdateWithoutBitwerxHealthchecksInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutBlockedPhoneNumbersInput = {
  data: ClinicUpdateWithoutBlockedPhoneNumbersInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutCallsInput = {
  data: ClinicUpdateWithoutCallsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutCarePayoutOrganizationInput = {
  data: ClinicUpdateWithoutCarePayoutOrganizationInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutChannelFilterSelectionsInput = {
  data: ClinicUpdateWithoutChannelFilterSelectionsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutChannelStatusChannelAssigneesInput = {
  data: ClinicUpdateWithoutChannelStatusChannelAssigneesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutChannelsInput = {
  data: ClinicUpdateWithoutChannelsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicCustomPayoutsSetupInput = {
  data: ClinicUpdateWithoutClinicCustomPayoutsSetupInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicDirectBookingSettingsInput = {
  data: ClinicUpdateWithoutClinicDirectBookingSettingsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicEmailCampaignSettingsInput = {
  data: ClinicUpdateWithoutClinicEmailCampaignSettingsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicEmployeesInput = {
  data: ClinicUpdateWithoutClinicEmployeesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicModulesInput = {
  data: ClinicUpdateWithoutClinicModulesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicOfficeHoursInput = {
  data: ClinicUpdateWithoutClinicOfficeHoursInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicOnboardingsInput = {
  data: ClinicUpdateWithoutClinicOnboardingsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicPetParentsInput = {
  data: ClinicUpdateWithoutClinicPetParentsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicPetsInput = {
  data: ClinicUpdateWithoutClinicPetsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicPhoneNumberInput = {
  data: ClinicUpdateWithoutClinicPhoneNumberInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicRoomsInput = {
  data: ClinicUpdateWithoutClinicRoomsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicSettingInput = {
  data: ClinicUpdateWithoutClinicSettingInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicUserFiltersInput = {
  data: ClinicUpdateWithoutClinicUserFiltersInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicWidgetRequestsInput = {
  data: ClinicUpdateWithoutClinicWidgetRequestsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutClinicWorkflowTypesInput = {
  data: ClinicUpdateWithoutClinicWorkflowTypesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutConsultationRequestsInput = {
  data: ClinicUpdateWithoutConsultationRequestsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutConsultationsInput = {
  data: ClinicUpdateWithoutConsultationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutDirectBookingExclusionRulesInput = {
  data: ClinicUpdateWithoutDirectBookingExclusionRulesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutEmailCampaignInput = {
  data: ClinicUpdateWithoutEmailCampaignInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutEmailCampaignLogInput = {
  data: ClinicUpdateWithoutEmailCampaignLogInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutEmailCampaignTemplateInput = {
  data: ClinicUpdateWithoutEmailCampaignTemplateInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutEmailCampaignUnsubscribeInput = {
  data: ClinicUpdateWithoutEmailCampaignUnsubscribeInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutEncryptedClinicUploadsInput = {
  data: ClinicUpdateWithoutEncryptedClinicUploadsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutFinancialTransactionsInput = {
  data: ClinicUpdateWithoutFinancialTransactionsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutFormSubmissionsInput = {
  data: ClinicUpdateWithoutFormSubmissionsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutFormTemplatesInput = {
  data: ClinicUpdateWithoutFormTemplatesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutGooglePlaceInput = {
  data: ClinicUpdateWithoutGooglePlaceInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutHillsToHomeApiLogInput = {
  data: ClinicUpdateWithoutHillsToHomeApiLogInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutInformAudienceMemberInput = {
  data: ClinicUpdateWithoutInformAudienceMemberInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutInformPartnerCustomersInput = {
  data: ClinicUpdateWithoutInformPartnerCustomersInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutInformPartnerProgramEnrollmentsInput = {
  data: ClinicUpdateWithoutInformPartnerProgramEnrollmentsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutInsuranceIntegrationsInput = {
  data: ClinicUpdateWithoutInsuranceIntegrationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutIntegrationsInput = {
  data: ClinicUpdateWithoutIntegrationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutLoyaltyPointDeltasInput = {
  data: ClinicUpdateWithoutLoyaltyPointDeltasInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutLoyaltyRewardRedemptionActionsInput = {
  data: ClinicUpdateWithoutLoyaltyRewardRedemptionActionsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutMassTextAlertsInput = {
  data: ClinicUpdateWithoutMassTextAlertsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutMediaInput = {
  data: ClinicUpdateWithoutMediaInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutMessageTemplatesInput = {
  data: ClinicUpdateWithoutMessageTemplatesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutPaymentProcessorForProviderGroupInput = {
  data: ClinicUpdateWithoutPaymentProcessorForProviderGroupInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutPayoutBatchingPeriodsInput = {
  data: ClinicUpdateWithoutPayoutBatchingPeriodsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutPayoutBatchingSettingInput = {
  data: ClinicUpdateWithoutPayoutBatchingSettingInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutPetsIdInput = {
  data: ClinicUpdateWithoutPetsIdInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutPostcardSettingsInput = {
  data: ClinicUpdateWithoutPostcardSettingsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutPrescriptionsInput = {
  data: ClinicUpdateWithoutPrescriptionsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutProductPackageSubscriptionsInput = {
  data: ClinicUpdateWithoutProductPackageSubscriptionsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutPromoCodesInput = {
  data: ClinicUpdateWithoutPromoCodesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutRecapsInput = {
  data: ClinicUpdateWithoutRecapsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutRolesInput = {
  data: ClinicUpdateWithoutRolesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutRulesInput = {
  data: ClinicUpdateWithoutRulesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutSentTrupanionExamDayOffersInput = {
  data: ClinicUpdateWithoutSentTrupanionExamDayOffersInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutStaffIdInput = {
  data: ClinicUpdateWithoutStaffIdInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutStripePaymentIntentsInput = {
  data: ClinicUpdateWithoutStripePaymentIntentsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutStripeTerminalLocationsInput = {
  data: ClinicUpdateWithoutStripeTerminalLocationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutSurveyResultsInput = {
  data: ClinicUpdateWithoutSurveyResultsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutSynchronyClinicConfigurationInput = {
  data: ClinicUpdateWithoutSynchronyClinicConfigurationInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutTasksInput = {
  data: ClinicUpdateWithoutTasksInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutTwilioConfigurationInput = {
  data: ClinicUpdateWithoutTwilioConfigurationInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutTwilioVerificationsInput = {
  data: ClinicUpdateWithoutTwilioVerificationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutUserAppointmentGroupingsInput = {
  data: ClinicUpdateWithoutUserAppointmentGroupingsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutUserBoardFiltersColumnsInput = {
  data: ClinicUpdateWithoutUserBoardFiltersColumnsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutUserTaskListsInput = {
  data: ClinicUpdateWithoutUserTaskListsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutVaccinationsInput = {
  data: ClinicUpdateWithoutVaccinationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutVetAvailabilitiesInput = {
  data: ClinicUpdateWithoutVetAvailabilitiesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutVetsourceInstallationInput = {
  data: ClinicUpdateWithoutVetsourceInstallationInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateToOneWithWhereWithoutWorkflowEventSettingsInput = {
  data: ClinicUpdateWithoutWorkflowEventSettingsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpdateWithWhereUniqueWithoutCarePlanProviderGroupInput = {
  data: ClinicUpdateWithoutCarePlanProviderGroupInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateWithWhereUniqueWithoutClinicWidgetSettingInput = {
  data: ClinicUpdateWithoutClinicWidgetSettingInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateWithWhereUniqueWithoutFeatureFlagsInput = {
  data: ClinicUpdateWithoutFeatureFlagsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateWithWhereUniqueWithoutLegalEntityInput = {
  data: ClinicUpdateWithoutLegalEntityInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateWithWhereUniqueWithoutLoyaltyProgramInput = {
  data: ClinicUpdateWithoutLoyaltyProgramInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: ClinicUpdateWithoutOrganizationInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateWithWhereUniqueWithoutPetsInput = {
  data: ClinicUpdateWithoutPetsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateWithWhereUniqueWithoutStaffInput = {
  data: ClinicUpdateWithoutStaffInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateWithWhereUniqueWithoutStripePayoutAccountsInput = {
  data: ClinicUpdateWithoutStripePayoutAccountsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateWithWhereUniqueWithoutUnlayerSettingInput = {
  data: ClinicUpdateWithoutUnlayerSettingInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateWithWhereUniqueWithoutUsersIdInput = {
  data: ClinicUpdateWithoutUsersIdInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateWithWhereUniqueWithoutUsersInput = {
  data: ClinicUpdateWithoutUsersInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateWithoutAppoinmentTypesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutAppointmentAvailabilitiesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutAppointmentNoteTemplateInput = {
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutAppointmentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutAutomationRunsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutAxionClinicConfigurationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutAxionClinicUserConfigurationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutBenefitsProvidedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutBitwerxHealthchecksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutBlockedPhoneNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutCallsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutCarePayoutOrganizationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutCarePlanProviderGroupInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutChannelFilterSelectionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutChannelStatusChannelAssigneesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutChannelsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicCustomPayoutsSetupInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicDirectBookingSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicEmailCampaignSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicEmployeesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicModulesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicOfficeHoursInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicOnboardingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicPetParentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicPetsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicPhoneNumberInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicRoomsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicUserFiltersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicWidgetRequestsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicWidgetSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutClinicWorkflowTypesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutConsultationRequestsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutConsultationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutDirectBookingExclusionRulesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutEmailCampaignInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutEmailCampaignLogInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutEmailCampaignTemplateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutEmailCampaignUnsubscribeInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutEncryptedClinicUploadsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutFeatureFlagsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutFinancialTransactionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutFormSubmissionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutFormTemplatesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutGooglePlaceInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutHillsToHomeApiLogInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutInformAudienceMemberInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutInformPartnerCustomersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutInformPartnerProgramEnrollmentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutInsuranceIntegrationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutIntegrationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutLegalEntityInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutLoyaltyPointDeltasInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutLoyaltyProgramInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutLoyaltyRewardRedemptionActionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutMassTextAlertsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutMediaInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutMessageTemplatesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutOrganizationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutPaymentProcessorForProviderGroupInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutPayoutBatchingPeriodsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutPayoutBatchingSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutPetsIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutPetsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutPostcardSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutPrescriptionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutProductPackageSubscriptionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutPromoCodesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutRecapsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutRolesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutRulesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutSentTrupanionExamDayOffersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutStaffIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutStaffInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutStripePaymentIntentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutStripePayoutAccountsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutStripeTerminalLocationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutSurveyResultsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutSynchronyClinicConfigurationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutTasksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutTwilioConfigurationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutTwilioVerificationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutUnlayerSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutUserAppointmentGroupingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutUserBoardFiltersColumnsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutUserTaskListsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutUsersIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutUsersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutVaccinationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutVetAvailabilitiesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutVetsourceInstallationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutClinicNestedInput>;
};

export type ClinicUpdateWithoutWorkflowEventSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutClinicNestedInput>;
  EmailCampaignLog?: Maybe<EmailCampaignLogUpdateManyWithoutClinicNestedInput>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogUpdateManyWithoutClinicNestedInput>;
  Rules?: Maybe<RulesUpdateManyWithoutClinicNestedInput>;
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  appoinmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutClinicNestedInput>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityUpdateManyWithoutClinicNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutClinicNestedInput>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts?: Maybe<Scalars['Boolean']>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicNestedInput>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutClinicNestedInput>;
  benefitsProvided?: Maybe<CareBenefitUsageUpdateManyWithoutUsageClinicNestedInput>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckUpdateManyWithoutClinicNestedInput>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutClinicNestedInput>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryUpdateManyWithoutClinicNestedInput>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePayoutOrganization?: Maybe<OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutParticipatingClinicsNestedInput>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionUpdateManyWithoutClinicNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutClinicNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutClinicNestedInput>;
  city?: Maybe<Scalars['String']>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupUpdateOneWithoutClinicNestedInput>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingUpdateManyWithoutClinicNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutClinicNestedInput>;
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutClinicNestedInput>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourUpdateManyWithoutClinicNestedInput>;
  clinicOnboardings?: Maybe<ClinicOnboardingUpdateManyWithoutClinicNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutClinicNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutClinicNestedInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateManyWithoutClinicNestedInput>;
  clinicRooms?: Maybe<ClinicRoomUpdateManyWithoutClinicNestedInput>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneWithoutClinicNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutClinicNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicNestedInput>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput>;
  consultationCost?: Maybe<Scalars['Float']>;
  consultationRequests?: Maybe<ConsultationRequestUpdateManyWithoutClinicNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutClinicNestedInput>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput>;
  emailCampaign?: Maybe<EmailCampaignUpdateManyWithoutClinicNestedInput>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutClinicNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutClinicNestedInput>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutClinicsNestedInput>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutClinicNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutClinicNestedInput>;
  formTemplates?: Maybe<FormTemplateUpdateManyWithoutClinicNestedInput>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutClinicNestedInput>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutClinicNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutClinicNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationUpdateManyWithoutClinicNestedInput>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrations?: Maybe<ClinicPimsIntegrationUpdateManyWithoutClinicNestedInput>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive?: Maybe<Scalars['Boolean']>;
  isClinicEligibleForPayments?: Maybe<Scalars['Boolean']>;
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntityUpdateOneWithoutClinicsNestedInput>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput>;
  loyaltyProgram?: Maybe<LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutClinicNestedInput>;
  media?: Maybe<MediaUpdateManyWithoutClinicNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutClinicNestedInput>;
  name?: Maybe<Scalars['String']>;
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutClinicsNestedInput>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupUpdateOneWithoutPaymentProcessorClinicNestedInput>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateOneWithoutClinicNestedInput>;
  pets?: Maybe<PetUpdateManyWithoutPreviousClinicsNestedInput>;
  petsId?: Maybe<PetUpdateManyWithoutCurrentClinicNestedInput>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcardSettings?: Maybe<ClinicPostcardSettingUpdateManyWithoutClinicNestedInput>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutClinicNestedInput>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput>;
  promoCodes?: Maybe<PromoCodeUpdateManyWithoutClinicNestedInput>;
  recaps?: Maybe<RecapUpdateManyWithoutClinicNestedInput>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutClinicNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoUpdateManyWithoutClinicsNestedInput>;
  staffId?: Maybe<VetInfoUpdateManyWithoutCurrentClinicNestedInput>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutClinicNestedInput>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountUpdateManyWithoutClinicsNestedInput>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationUpdateManyWithoutClinicNestedInput>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  surveyResults?: Maybe<SurveyResultUpdateManyWithoutClinicNestedInput>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutClinicNestedInput>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  twilioConfiguration?: Maybe<TwilioConfigurationUpdateOneWithoutClinicNestedInput>;
  twilioVerifications?: Maybe<TwilioVerificationUpdateManyWithoutClinicNestedInput>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneWithoutClinicsNestedInput>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutClinicNestedInput>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnUpdateManyWithoutClinicNestedInput>;
  userTaskLists?: Maybe<UserTaskListUpdateManyWithoutClinicNestedInput>;
  users?: Maybe<UserUpdateManyWithoutClinicsNestedInput>;
  usersId?: Maybe<UserUpdateOneWithoutClinicsIdNestedInput>;
  vaccinations?: Maybe<VaccinationUpdateManyWithoutClinicNestedInput>;
  vetAvailabilities?: Maybe<VetAvailabilityUpdateManyWithoutClinicNestedInput>;
  vetsourceInstallation?: Maybe<VetsourceInstallationUpdateOneWithoutClinicNestedInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type ClinicUpsertWithWhereUniqueWithoutCarePlanProviderGroupInput = {
  create: ClinicCreateWithoutCarePlanProviderGroupInput;
  update: ClinicUpdateWithoutCarePlanProviderGroupInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpsertWithWhereUniqueWithoutClinicWidgetSettingInput = {
  create: ClinicCreateWithoutClinicWidgetSettingInput;
  update: ClinicUpdateWithoutClinicWidgetSettingInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpsertWithWhereUniqueWithoutFeatureFlagsInput = {
  create: ClinicCreateWithoutFeatureFlagsInput;
  update: ClinicUpdateWithoutFeatureFlagsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpsertWithWhereUniqueWithoutLegalEntityInput = {
  create: ClinicCreateWithoutLegalEntityInput;
  update: ClinicUpdateWithoutLegalEntityInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpsertWithWhereUniqueWithoutLoyaltyProgramInput = {
  create: ClinicCreateWithoutLoyaltyProgramInput;
  update: ClinicUpdateWithoutLoyaltyProgramInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: ClinicCreateWithoutOrganizationInput;
  update: ClinicUpdateWithoutOrganizationInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpsertWithWhereUniqueWithoutPetsInput = {
  create: ClinicCreateWithoutPetsInput;
  update: ClinicUpdateWithoutPetsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpsertWithWhereUniqueWithoutStaffInput = {
  create: ClinicCreateWithoutStaffInput;
  update: ClinicUpdateWithoutStaffInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpsertWithWhereUniqueWithoutStripePayoutAccountsInput = {
  create: ClinicCreateWithoutStripePayoutAccountsInput;
  update: ClinicUpdateWithoutStripePayoutAccountsInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpsertWithWhereUniqueWithoutUnlayerSettingInput = {
  create: ClinicCreateWithoutUnlayerSettingInput;
  update: ClinicUpdateWithoutUnlayerSettingInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpsertWithWhereUniqueWithoutUsersIdInput = {
  create: ClinicCreateWithoutUsersIdInput;
  update: ClinicUpdateWithoutUsersIdInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpsertWithWhereUniqueWithoutUsersInput = {
  create: ClinicCreateWithoutUsersInput;
  update: ClinicUpdateWithoutUsersInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpsertWithoutAppoinmentTypesInput = {
  create: ClinicCreateWithoutAppoinmentTypesInput;
  update: ClinicUpdateWithoutAppoinmentTypesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutAppointmentAvailabilitiesInput = {
  create: ClinicCreateWithoutAppointmentAvailabilitiesInput;
  update: ClinicUpdateWithoutAppointmentAvailabilitiesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutAppointmentNoteTemplateInput = {
  create: ClinicCreateWithoutAppointmentNoteTemplateInput;
  update: ClinicUpdateWithoutAppointmentNoteTemplateInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutAppointmentsInput = {
  create: ClinicCreateWithoutAppointmentsInput;
  update: ClinicUpdateWithoutAppointmentsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutAutomationRunsInput = {
  create: ClinicCreateWithoutAutomationRunsInput;
  update: ClinicUpdateWithoutAutomationRunsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutAxionClinicConfigurationInput = {
  create: ClinicCreateWithoutAxionClinicConfigurationInput;
  update: ClinicUpdateWithoutAxionClinicConfigurationInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutAxionClinicUserConfigurationsInput = {
  create: ClinicCreateWithoutAxionClinicUserConfigurationsInput;
  update: ClinicUpdateWithoutAxionClinicUserConfigurationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutBenefitsProvidedInput = {
  create: ClinicCreateWithoutBenefitsProvidedInput;
  update: ClinicUpdateWithoutBenefitsProvidedInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutBitwerxHealthchecksInput = {
  create: ClinicCreateWithoutBitwerxHealthchecksInput;
  update: ClinicUpdateWithoutBitwerxHealthchecksInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutBlockedPhoneNumbersInput = {
  create: ClinicCreateWithoutBlockedPhoneNumbersInput;
  update: ClinicUpdateWithoutBlockedPhoneNumbersInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutCallsInput = {
  create: ClinicCreateWithoutCallsInput;
  update: ClinicUpdateWithoutCallsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutCarePayoutOrganizationInput = {
  create: ClinicCreateWithoutCarePayoutOrganizationInput;
  update: ClinicUpdateWithoutCarePayoutOrganizationInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutChannelFilterSelectionsInput = {
  create: ClinicCreateWithoutChannelFilterSelectionsInput;
  update: ClinicUpdateWithoutChannelFilterSelectionsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutChannelStatusChannelAssigneesInput = {
  create: ClinicCreateWithoutChannelStatusChannelAssigneesInput;
  update: ClinicUpdateWithoutChannelStatusChannelAssigneesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutChannelsInput = {
  create: ClinicCreateWithoutChannelsInput;
  update: ClinicUpdateWithoutChannelsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicCustomPayoutsSetupInput = {
  create: ClinicCreateWithoutClinicCustomPayoutsSetupInput;
  update: ClinicUpdateWithoutClinicCustomPayoutsSetupInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicDirectBookingSettingsInput = {
  create: ClinicCreateWithoutClinicDirectBookingSettingsInput;
  update: ClinicUpdateWithoutClinicDirectBookingSettingsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicEmailCampaignSettingsInput = {
  create: ClinicCreateWithoutClinicEmailCampaignSettingsInput;
  update: ClinicUpdateWithoutClinicEmailCampaignSettingsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicEmployeesInput = {
  create: ClinicCreateWithoutClinicEmployeesInput;
  update: ClinicUpdateWithoutClinicEmployeesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicModulesInput = {
  create: ClinicCreateWithoutClinicModulesInput;
  update: ClinicUpdateWithoutClinicModulesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicOfficeHoursInput = {
  create: ClinicCreateWithoutClinicOfficeHoursInput;
  update: ClinicUpdateWithoutClinicOfficeHoursInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicOnboardingsInput = {
  create: ClinicCreateWithoutClinicOnboardingsInput;
  update: ClinicUpdateWithoutClinicOnboardingsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicPetParentsInput = {
  create: ClinicCreateWithoutClinicPetParentsInput;
  update: ClinicUpdateWithoutClinicPetParentsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicPetsInput = {
  create: ClinicCreateWithoutClinicPetsInput;
  update: ClinicUpdateWithoutClinicPetsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicPhoneNumberInput = {
  create: ClinicCreateWithoutClinicPhoneNumberInput;
  update: ClinicUpdateWithoutClinicPhoneNumberInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicRoomsInput = {
  create: ClinicCreateWithoutClinicRoomsInput;
  update: ClinicUpdateWithoutClinicRoomsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicSettingInput = {
  create: ClinicCreateWithoutClinicSettingInput;
  update: ClinicUpdateWithoutClinicSettingInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicUserFiltersInput = {
  create: ClinicCreateWithoutClinicUserFiltersInput;
  update: ClinicUpdateWithoutClinicUserFiltersInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicWidgetRequestsInput = {
  create: ClinicCreateWithoutClinicWidgetRequestsInput;
  update: ClinicUpdateWithoutClinicWidgetRequestsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutClinicWorkflowTypesInput = {
  create: ClinicCreateWithoutClinicWorkflowTypesInput;
  update: ClinicUpdateWithoutClinicWorkflowTypesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutConsultationRequestsInput = {
  create: ClinicCreateWithoutConsultationRequestsInput;
  update: ClinicUpdateWithoutConsultationRequestsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutConsultationsInput = {
  create: ClinicCreateWithoutConsultationsInput;
  update: ClinicUpdateWithoutConsultationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutDirectBookingExclusionRulesInput = {
  create: ClinicCreateWithoutDirectBookingExclusionRulesInput;
  update: ClinicUpdateWithoutDirectBookingExclusionRulesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutEmailCampaignInput = {
  create: ClinicCreateWithoutEmailCampaignInput;
  update: ClinicUpdateWithoutEmailCampaignInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutEmailCampaignLogInput = {
  create: ClinicCreateWithoutEmailCampaignLogInput;
  update: ClinicUpdateWithoutEmailCampaignLogInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutEmailCampaignTemplateInput = {
  create: ClinicCreateWithoutEmailCampaignTemplateInput;
  update: ClinicUpdateWithoutEmailCampaignTemplateInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutEmailCampaignUnsubscribeInput = {
  create: ClinicCreateWithoutEmailCampaignUnsubscribeInput;
  update: ClinicUpdateWithoutEmailCampaignUnsubscribeInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutEncryptedClinicUploadsInput = {
  create: ClinicCreateWithoutEncryptedClinicUploadsInput;
  update: ClinicUpdateWithoutEncryptedClinicUploadsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutFinancialTransactionsInput = {
  create: ClinicCreateWithoutFinancialTransactionsInput;
  update: ClinicUpdateWithoutFinancialTransactionsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutFormSubmissionsInput = {
  create: ClinicCreateWithoutFormSubmissionsInput;
  update: ClinicUpdateWithoutFormSubmissionsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutFormTemplatesInput = {
  create: ClinicCreateWithoutFormTemplatesInput;
  update: ClinicUpdateWithoutFormTemplatesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutGooglePlaceInput = {
  create: ClinicCreateWithoutGooglePlaceInput;
  update: ClinicUpdateWithoutGooglePlaceInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutHillsToHomeApiLogInput = {
  create: ClinicCreateWithoutHillsToHomeApiLogInput;
  update: ClinicUpdateWithoutHillsToHomeApiLogInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutInformAudienceMemberInput = {
  create: ClinicCreateWithoutInformAudienceMemberInput;
  update: ClinicUpdateWithoutInformAudienceMemberInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutInformPartnerCustomersInput = {
  create: ClinicCreateWithoutInformPartnerCustomersInput;
  update: ClinicUpdateWithoutInformPartnerCustomersInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutInformPartnerProgramEnrollmentsInput = {
  create: ClinicCreateWithoutInformPartnerProgramEnrollmentsInput;
  update: ClinicUpdateWithoutInformPartnerProgramEnrollmentsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutInsuranceIntegrationsInput = {
  create: ClinicCreateWithoutInsuranceIntegrationsInput;
  update: ClinicUpdateWithoutInsuranceIntegrationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutIntegrationsInput = {
  create: ClinicCreateWithoutIntegrationsInput;
  update: ClinicUpdateWithoutIntegrationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutLoyaltyPointDeltasInput = {
  create: ClinicCreateWithoutLoyaltyPointDeltasInput;
  update: ClinicUpdateWithoutLoyaltyPointDeltasInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutLoyaltyRewardRedemptionActionsInput = {
  create: ClinicCreateWithoutLoyaltyRewardRedemptionActionsInput;
  update: ClinicUpdateWithoutLoyaltyRewardRedemptionActionsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutMassTextAlertsInput = {
  create: ClinicCreateWithoutMassTextAlertsInput;
  update: ClinicUpdateWithoutMassTextAlertsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutMediaInput = {
  create: ClinicCreateWithoutMediaInput;
  update: ClinicUpdateWithoutMediaInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutMessageTemplatesInput = {
  create: ClinicCreateWithoutMessageTemplatesInput;
  update: ClinicUpdateWithoutMessageTemplatesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutPaymentProcessorForProviderGroupInput = {
  create: ClinicCreateWithoutPaymentProcessorForProviderGroupInput;
  update: ClinicUpdateWithoutPaymentProcessorForProviderGroupInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutPayoutBatchingPeriodsInput = {
  create: ClinicCreateWithoutPayoutBatchingPeriodsInput;
  update: ClinicUpdateWithoutPayoutBatchingPeriodsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutPayoutBatchingSettingInput = {
  create: ClinicCreateWithoutPayoutBatchingSettingInput;
  update: ClinicUpdateWithoutPayoutBatchingSettingInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutPetsIdInput = {
  create: ClinicCreateWithoutPetsIdInput;
  update: ClinicUpdateWithoutPetsIdInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutPostcardSettingsInput = {
  create: ClinicCreateWithoutPostcardSettingsInput;
  update: ClinicUpdateWithoutPostcardSettingsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutPrescriptionsInput = {
  create: ClinicCreateWithoutPrescriptionsInput;
  update: ClinicUpdateWithoutPrescriptionsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutProductPackageSubscriptionsInput = {
  create: ClinicCreateWithoutProductPackageSubscriptionsInput;
  update: ClinicUpdateWithoutProductPackageSubscriptionsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutPromoCodesInput = {
  create: ClinicCreateWithoutPromoCodesInput;
  update: ClinicUpdateWithoutPromoCodesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutRecapsInput = {
  create: ClinicCreateWithoutRecapsInput;
  update: ClinicUpdateWithoutRecapsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutRolesInput = {
  create: ClinicCreateWithoutRolesInput;
  update: ClinicUpdateWithoutRolesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutRulesInput = {
  create: ClinicCreateWithoutRulesInput;
  update: ClinicUpdateWithoutRulesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutSentTrupanionExamDayOffersInput = {
  create: ClinicCreateWithoutSentTrupanionExamDayOffersInput;
  update: ClinicUpdateWithoutSentTrupanionExamDayOffersInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutStaffIdInput = {
  create: ClinicCreateWithoutStaffIdInput;
  update: ClinicUpdateWithoutStaffIdInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutStripePaymentIntentsInput = {
  create: ClinicCreateWithoutStripePaymentIntentsInput;
  update: ClinicUpdateWithoutStripePaymentIntentsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutStripeTerminalLocationsInput = {
  create: ClinicCreateWithoutStripeTerminalLocationsInput;
  update: ClinicUpdateWithoutStripeTerminalLocationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutSurveyResultsInput = {
  create: ClinicCreateWithoutSurveyResultsInput;
  update: ClinicUpdateWithoutSurveyResultsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutSynchronyClinicConfigurationInput = {
  create: ClinicCreateWithoutSynchronyClinicConfigurationInput;
  update: ClinicUpdateWithoutSynchronyClinicConfigurationInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutTasksInput = {
  create: ClinicCreateWithoutTasksInput;
  update: ClinicUpdateWithoutTasksInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutTwilioConfigurationInput = {
  create: ClinicCreateWithoutTwilioConfigurationInput;
  update: ClinicUpdateWithoutTwilioConfigurationInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutTwilioVerificationsInput = {
  create: ClinicCreateWithoutTwilioVerificationsInput;
  update: ClinicUpdateWithoutTwilioVerificationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutUserAppointmentGroupingsInput = {
  create: ClinicCreateWithoutUserAppointmentGroupingsInput;
  update: ClinicUpdateWithoutUserAppointmentGroupingsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutUserBoardFiltersColumnsInput = {
  create: ClinicCreateWithoutUserBoardFiltersColumnsInput;
  update: ClinicUpdateWithoutUserBoardFiltersColumnsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutUserTaskListsInput = {
  create: ClinicCreateWithoutUserTaskListsInput;
  update: ClinicUpdateWithoutUserTaskListsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutVaccinationsInput = {
  create: ClinicCreateWithoutVaccinationsInput;
  update: ClinicUpdateWithoutVaccinationsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutVetAvailabilitiesInput = {
  create: ClinicCreateWithoutVetAvailabilitiesInput;
  update: ClinicUpdateWithoutVetAvailabilitiesInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutVetsourceInstallationInput = {
  create: ClinicCreateWithoutVetsourceInstallationInput;
  update: ClinicUpdateWithoutVetsourceInstallationInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUpsertWithoutWorkflowEventSettingsInput = {
  create: ClinicCreateWithoutWorkflowEventSettingsInput;
  update: ClinicUpdateWithoutWorkflowEventSettingsInput;
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicUserFilter = {
  __typename?: 'ClinicUserFilter';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  filter: Scalars['Json'];
  id: Scalars['String'];
  type: ClinicUserFilterType;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type ClinicUserFilterClinicIdUserIdTypeCompoundUniqueInput = {
  clinicId: Scalars['String'];
  type: ClinicUserFilterType;
  userId: Scalars['String'];
};

export type ClinicUserFilterCountAggregateOutputType = {
  __typename?: 'ClinicUserFilterCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  filter: Scalars['Int'];
  id: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ClinicUserFilterCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  filter?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ClinicUserFilterCreateInput = {
  clinic: ClinicCreateNestedOneWithoutClinicUserFiltersInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type: ClinicUserFilterType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutClinicUserFiltersInput;
};

export type ClinicUserFilterCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type: ClinicUserFilterType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type ClinicUserFilterCreateManyClinicInputEnvelope = {
  data: Array<ClinicUserFilterCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicUserFilterCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type: ClinicUserFilterType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type ClinicUserFilterCreateManyUserInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type: ClinicUserFilterType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicUserFilterCreateManyUserInputEnvelope = {
  data: Array<ClinicUserFilterCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicUserFilterCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicUserFilterCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicUserFilterCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicUserFilterCreateManyClinicInputEnvelope>;
};

export type ClinicUserFilterCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicUserFilterCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ClinicUserFilterCreateWithoutUserInput>>;
  createMany?: Maybe<ClinicUserFilterCreateManyUserInputEnvelope>;
};

export type ClinicUserFilterCreateOrConnectWithoutClinicInput = {
  create: ClinicUserFilterCreateWithoutClinicInput;
  where: ClinicUserFilterWhereUniqueInput;
};

export type ClinicUserFilterCreateOrConnectWithoutUserInput = {
  create: ClinicUserFilterCreateWithoutUserInput;
  where: ClinicUserFilterWhereUniqueInput;
};

export type ClinicUserFilterCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type: ClinicUserFilterType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutClinicUserFiltersInput;
};

export type ClinicUserFilterCreateWithoutUserInput = {
  clinic: ClinicCreateNestedOneWithoutClinicUserFiltersInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type: ClinicUserFilterType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicUserFilterGroupByOutputType = {
  __typename?: 'ClinicUserFilterGroupByOutputType';
  _count?: Maybe<ClinicUserFilterCountAggregateOutputType>;
  _max?: Maybe<ClinicUserFilterMaxAggregateOutputType>;
  _min?: Maybe<ClinicUserFilterMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  filter: Scalars['Json'];
  id: Scalars['String'];
  type: ClinicUserFilterType;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type ClinicUserFilterListRelationFilter = {
  every?: Maybe<ClinicUserFilterWhereInput>;
  none?: Maybe<ClinicUserFilterWhereInput>;
  some?: Maybe<ClinicUserFilterWhereInput>;
};

export type ClinicUserFilterMaxAggregateOutputType = {
  __typename?: 'ClinicUserFilterMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicUserFilterType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicUserFilterMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ClinicUserFilterMinAggregateOutputType = {
  __typename?: 'ClinicUserFilterMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicUserFilterType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicUserFilterMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ClinicUserFilterOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicUserFilterOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicUserFilterOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  filter?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ClinicUserFilterOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  UserId = 'userId'
}

export type ClinicUserFilterOrderByRelevanceInput = {
  fields: Array<ClinicUserFilterOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicUserFilterOrderByWithAggregationInput = {
  _count?: Maybe<ClinicUserFilterCountOrderByAggregateInput>;
  _max?: Maybe<ClinicUserFilterMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicUserFilterMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  filter?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ClinicUserFilterOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicUserFilterOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  filter?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type ClinicUserFilterOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicUserFilterOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  filter?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ClinicUserFilterScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Filter = 'filter',
  Id = 'id',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ClinicUserFilterScalarWhereInput = {
  AND?: Maybe<Array<ClinicUserFilterScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicUserFilterScalarWhereInput>>;
  OR?: Maybe<Array<ClinicUserFilterScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  filter?: Maybe<JsonFilter>;
  id?: Maybe<StringFilter>;
  type?: Maybe<EnumClinicUserFilterTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userId?: Maybe<StringFilter>;
};

export type ClinicUserFilterScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicUserFilterScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicUserFilterScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicUserFilterScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  filter?: Maybe<JsonWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumClinicUserFilterTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userId?: Maybe<StringWithAggregatesFilter>;
};

export enum ClinicUserFilterType {
  TaskManager = 'TaskManager'
}

export type ClinicUserFilterUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type: ClinicUserFilterType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type ClinicUserFilterUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicUserFilterCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicUserFilterCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicUserFilterCreateManyClinicInputEnvelope>;
};

export type ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicUserFilterCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ClinicUserFilterCreateWithoutUserInput>>;
  createMany?: Maybe<ClinicUserFilterCreateManyUserInputEnvelope>;
};

export type ClinicUserFilterUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type: ClinicUserFilterType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type ClinicUserFilterUncheckedCreateWithoutUserInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type: ClinicUserFilterType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicUserFilterUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicUserFilterType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicUserFilterUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicUserFilterType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicUserFilterUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicUserFilterType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicUserFilterUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicUserFilterCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicUserFilterCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicUserFilterCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicUserFilterScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  set?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUserFilterUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicUserFilterUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicUserFilterUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicUserFilterUncheckedUpdateManyWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicUserFilterType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicUserFilterCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ClinicUserFilterCreateWithoutUserInput>>;
  createMany?: Maybe<ClinicUserFilterCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicUserFilterScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  set?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUserFilterUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ClinicUserFilterUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ClinicUserFilterUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ClinicUserFilterUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicUserFilterType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ClinicUserFilterUncheckedUpdateWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicUserFilterType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicUserFilterUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicUserFiltersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicUserFilterType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneRequiredWithoutClinicUserFiltersNestedInput>;
};

export type ClinicUserFilterUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicUserFilterType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicUserFilterUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicUserFilterUpdateManyMutationInput;
  where: ClinicUserFilterScalarWhereInput;
};

export type ClinicUserFilterUpdateManyWithWhereWithoutUserInput = {
  data: ClinicUserFilterUpdateManyMutationInput;
  where: ClinicUserFilterScalarWhereInput;
};

export type ClinicUserFilterUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicUserFilterCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicUserFilterCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicUserFilterCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicUserFilterScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  set?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUserFilterUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicUserFilterUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicUserFilterUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicUserFilterUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicUserFilterCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ClinicUserFilterCreateWithoutUserInput>>;
  createMany?: Maybe<ClinicUserFilterCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicUserFilterScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  set?: Maybe<Array<ClinicUserFilterWhereUniqueInput>>;
  update?: Maybe<Array<ClinicUserFilterUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ClinicUserFilterUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ClinicUserFilterUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ClinicUserFilterUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicUserFilterUpdateWithoutClinicInput;
  where: ClinicUserFilterWhereUniqueInput;
};

export type ClinicUserFilterUpdateWithWhereUniqueWithoutUserInput = {
  data: ClinicUserFilterUpdateWithoutUserInput;
  where: ClinicUserFilterWhereUniqueInput;
};

export type ClinicUserFilterUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicUserFilterType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneRequiredWithoutClinicUserFiltersNestedInput>;
};

export type ClinicUserFilterUpdateWithoutUserInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutClinicUserFiltersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<ClinicUserFilterType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicUserFilterUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicUserFilterCreateWithoutClinicInput;
  update: ClinicUserFilterUpdateWithoutClinicInput;
  where: ClinicUserFilterWhereUniqueInput;
};

export type ClinicUserFilterUpsertWithWhereUniqueWithoutUserInput = {
  create: ClinicUserFilterCreateWithoutUserInput;
  update: ClinicUserFilterUpdateWithoutUserInput;
  where: ClinicUserFilterWhereUniqueInput;
};

export type ClinicUserFilterWhereInput = {
  AND?: Maybe<Array<ClinicUserFilterWhereInput>>;
  NOT?: Maybe<Array<ClinicUserFilterWhereInput>>;
  OR?: Maybe<Array<ClinicUserFilterWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  filter?: Maybe<JsonFilter>;
  id?: Maybe<StringFilter>;
  type?: Maybe<EnumClinicUserFilterTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type ClinicUserFilterWhereUniqueInput = {
  AND?: Maybe<Array<ClinicUserFilterWhereInput>>;
  NOT?: Maybe<Array<ClinicUserFilterWhereInput>>;
  OR?: Maybe<Array<ClinicUserFilterWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicId_userId_type?: Maybe<ClinicUserFilterClinicIdUserIdTypeCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  filter?: Maybe<JsonFilter>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<EnumClinicUserFilterTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type ClinicWhereInput = {
  AND?: Maybe<Array<ClinicWhereInput>>;
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateListRelationFilter>;
  EmailCampaignLog?: Maybe<EmailCampaignLogListRelationFilter>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeListRelationFilter>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<ClinicWhereInput>>;
  OR?: Maybe<Array<ClinicWhereInput>>;
  Rules?: Maybe<RulesListRelationFilter>;
  activationDate?: Maybe<DateTimeNullableFilter>;
  addressLine1?: Maybe<StringNullableFilter>;
  addressLine2?: Maybe<StringNullableFilter>;
  allowAllUsersToCloseConsultations?: Maybe<BoolNullableFilter>;
  appoinmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  autoSubscriptionReceiptEmails?: Maybe<JsonNullableFilter>;
  automaticSubscriptionReceipts?: Maybe<BoolFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationNullableScalarRelationFilter>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationListRelationFilter>;
  benefitsProvided?: Maybe<CareBenefitUsageListRelationFilter>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckListRelationFilter>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberListRelationFilter>;
  callerIdPhoneNumber?: Maybe<StringNullableFilter>;
  calls?: Maybe<CallHistoryListRelationFilter>;
  canceledAt?: Maybe<DateTimeNullableFilter>;
  cancellationNote?: Maybe<StringNullableFilter>;
  cancellationReason?: Maybe<StringNullableFilter>;
  carePayoutOrganization?: Maybe<OrganizationNullableScalarRelationFilter>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  carePlanProviderGroupId?: Maybe<StringNullableFilter>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionListRelationFilter>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  city?: Maybe<StringNullableFilter>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupNullableScalarRelationFilter>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingListRelationFilter>;
  clinicEmail?: Maybe<StringNullableFilter>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingListRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeListRelationFilter>;
  clinicModules?: Maybe<ClinicModuleListRelationFilter>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourListRelationFilter>;
  clinicOnboardings?: Maybe<ClinicOnboardingListRelationFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberListRelationFilter>;
  clinicRooms?: Maybe<ClinicRoomListRelationFilter>;
  clinicSetting?: Maybe<ClinicSettingNullableScalarRelationFilter>;
  clinicSettingId?: Maybe<StringNullableFilter>;
  clinicUserFilters?: Maybe<ClinicUserFilterListRelationFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingNullableScalarRelationFilter>;
  clinicWidgetSettingId?: Maybe<StringNullableFilter>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeListRelationFilter>;
  consultationCost?: Maybe<FloatNullableFilter>;
  consultationRequests?: Maybe<ConsultationRequestListRelationFilter>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  corporateId?: Maybe<StringNullableFilter>;
  country?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  crmId?: Maybe<StringNullableFilter>;
  crmUrlParams?: Maybe<JsonNullableFilter>;
  customerId?: Maybe<StringNullableFilter>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleListRelationFilter>;
  emailCampaign?: Maybe<EmailCampaignListRelationFilter>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateListRelationFilter>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadListRelationFilter>;
  featureFlags?: Maybe<FeatureFlagListRelationFilter>;
  financialTransactions?: Maybe<FinancialTransactionListRelationFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firebaseVets?: Maybe<JsonNullableFilter>;
  followUpCost?: Maybe<FloatNullableFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  formTemplates?: Maybe<FormTemplateListRelationFilter>;
  fullAddress?: Maybe<StringNullableFilter>;
  googlePlace?: Maybe<GooglePlaceNullableScalarRelationFilter>;
  hasServiceReminders?: Maybe<BoolNullableFilter>;
  hasSmsConversations?: Maybe<BoolNullableFilter>;
  headUserId?: Maybe<StringNullableFilter>;
  hours?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  incomeMethod?: Maybe<StringNullableFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentListRelationFilter>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationListRelationFilter>;
  integrationInfo?: Maybe<JsonNullableFilter>;
  integrationSystem?: Maybe<StringNullableFilter>;
  integrationType?: Maybe<StringNullableFilter>;
  integrations?: Maybe<ClinicPimsIntegrationListRelationFilter>;
  isAddAppointmentDisabled?: Maybe<BoolNullableFilter>;
  isCallerIdVerified?: Maybe<BoolNullableFilter>;
  isClinicActive?: Maybe<BoolFilter>;
  isClinicEligibleForPayments?: Maybe<BoolFilter>;
  isConsultationsActive?: Maybe<BoolNullableFilter>;
  isIntegrationActive?: Maybe<BoolNullableFilter>;
  isPaymentUsBank?: Maybe<BoolNullableFilter>;
  isServiceRemindersActive?: Maybe<BoolNullableFilter>;
  lastPrintOrderedOn?: Maybe<DateTimeNullableFilter>;
  lastPrintOrderedQuantity?: Maybe<IntNullableFilter>;
  lat?: Maybe<FloatNullableFilter>;
  legalEntity?: Maybe<LegalEntityNullableScalarRelationFilter>;
  legalEntityId?: Maybe<StringNullableFilter>;
  logo?: Maybe<StringNullableFilter>;
  long?: Maybe<FloatNullableFilter>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  loyaltyProgram?: Maybe<LoyaltyProgramNullableScalarRelationFilter>;
  loyaltyProgramId?: Maybe<StringNullableFilter>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  marketEmail?: Maybe<StringNullableFilter>;
  marketFacebookNumber?: Maybe<IntNullableFilter>;
  marketFacebookPageId?: Maybe<StringNullableFilter>;
  marketFacebookPageToken?: Maybe<StringNullableFilter>;
  massTextAlerts?: Maybe<MassTextAlertListRelationFilter>;
  media?: Maybe<MediaListRelationFilter>;
  messageTemplates?: Maybe<MessageTemplateListRelationFilter>;
  name?: Maybe<StringFilter>;
  optimizedLogoUrl?: Maybe<StringNullableFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  paymentAddress?: Maybe<StringNullableFilter>;
  paymentBankAccountNumber?: Maybe<StringNullableFilter>;
  paymentBankRoutingNumber?: Maybe<StringNullableFilter>;
  paymentCity?: Maybe<StringNullableFilter>;
  paymentName?: Maybe<StringNullableFilter>;
  paymentPhone?: Maybe<StringNullableFilter>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  paymentState?: Maybe<StringNullableFilter>;
  paymentZip?: Maybe<StringNullableFilter>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodListRelationFilter>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingNullableScalarRelationFilter>;
  pets?: Maybe<PetListRelationFilter>;
  petsId?: Maybe<PetListRelationFilter>;
  phone?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  postcardSettings?: Maybe<ClinicPostcardSettingListRelationFilter>;
  ppcLocationId?: Maybe<IntNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  printLastOrder?: Maybe<DateTimeNullableFilter>;
  printReceivedQuantity?: Maybe<IntNullableFilter>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionListRelationFilter>;
  promoCodes?: Maybe<PromoCodeListRelationFilter>;
  recaps?: Maybe<RecapListRelationFilter>;
  remindersIntegrationRequestEmail?: Maybe<StringNullableFilter>;
  responseTime?: Maybe<FloatNullableFilter>;
  roles?: Maybe<StaffRoleListRelationFilter>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  smsPhoneNumber?: Maybe<StringNullableFilter>;
  staff?: Maybe<VetInfoListRelationFilter>;
  staffId?: Maybe<VetInfoListRelationFilter>;
  state?: Maybe<StringNullableFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountListRelationFilter>;
  stripeSubscriptionId?: Maybe<StringNullableFilter>;
  stripeSubscriptionPlan?: Maybe<StringNullableFilter>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationListRelationFilter>;
  submerchantApprovedAt?: Maybe<DateTimeNullableFilter>;
  submerchantId?: Maybe<StringNullableFilter>;
  submerchantIsActive?: Maybe<BoolNullableFilter>;
  submerchantStatus?: Maybe<StringNullableFilter>;
  submerchantStripeChargesEnabled?: Maybe<BoolNullableFilter>;
  submerchantStripeHasCustomPayouts?: Maybe<BoolNullableFilter>;
  submerchantStripeId?: Maybe<StringNullableFilter>;
  submerchantStripePayoutsEnabled?: Maybe<BoolNullableFilter>;
  submerchantStripeStatus?: Maybe<StringNullableFilter>;
  subscribedAt?: Maybe<DateTimeNullableFilter>;
  subscriptionId?: Maybe<StringNullableFilter>;
  subscriptionPlan?: Maybe<StringNullableFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationNullableScalarRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  timezone?: Maybe<IntNullableFilter>;
  timezoneName?: Maybe<StringNullableFilter>;
  token?: Maybe<StringNullableFilter>;
  twilioConfiguration?: Maybe<TwilioConfigurationNullableScalarRelationFilter>;
  twilioVerifications?: Maybe<TwilioVerificationListRelationFilter>;
  unlayerSetting?: Maybe<UnlayerSettingNullableScalarRelationFilter>;
  unlayerSettingId?: Maybe<IntNullableFilter>;
  unsubscribedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnListRelationFilter>;
  userTaskLists?: Maybe<UserTaskListListRelationFilter>;
  users?: Maybe<UserListRelationFilter>;
  usersId?: Maybe<UserNullableScalarRelationFilter>;
  vaccinations?: Maybe<VaccinationListRelationFilter>;
  vetAvailabilities?: Maybe<VetAvailabilityListRelationFilter>;
  vetsourceInstallation?: Maybe<VetsourceInstallationNullableScalarRelationFilter>;
  websiteUrl?: Maybe<StringNullableFilter>;
  widgetSettings?: Maybe<JsonNullableFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type ClinicWhereUniqueInput = {
  AND?: Maybe<Array<ClinicWhereInput>>;
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateListRelationFilter>;
  EmailCampaignLog?: Maybe<EmailCampaignLogListRelationFilter>;
  EmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribeListRelationFilter>;
  HillsToHomeAPILog?: Maybe<HillsToHomeApiLogListRelationFilter>;
  NOT?: Maybe<Array<ClinicWhereInput>>;
  OR?: Maybe<Array<ClinicWhereInput>>;
  Rules?: Maybe<RulesListRelationFilter>;
  activationDate?: Maybe<DateTimeNullableFilter>;
  addressLine1?: Maybe<StringNullableFilter>;
  addressLine2?: Maybe<StringNullableFilter>;
  allowAllUsersToCloseConsultations?: Maybe<BoolNullableFilter>;
  appoinmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  autoSubscriptionReceiptEmails?: Maybe<JsonNullableFilter>;
  automaticSubscriptionReceipts?: Maybe<BoolFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  axionClinicConfiguration?: Maybe<AxionClinicConfigurationNullableScalarRelationFilter>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationListRelationFilter>;
  benefitsProvided?: Maybe<CareBenefitUsageListRelationFilter>;
  bitwerxHealthchecks?: Maybe<BitwerxHealthcheckListRelationFilter>;
  blockedPhoneNumbers?: Maybe<ClinicBlockedPhoneNumberListRelationFilter>;
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  calls?: Maybe<CallHistoryListRelationFilter>;
  canceledAt?: Maybe<DateTimeNullableFilter>;
  cancellationNote?: Maybe<StringNullableFilter>;
  cancellationReason?: Maybe<StringNullableFilter>;
  carePayoutOrganization?: Maybe<OrganizationNullableScalarRelationFilter>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  carePlanProviderGroupId?: Maybe<StringNullableFilter>;
  channelFilterSelections?: Maybe<ChannelFilterSelectionListRelationFilter>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  city?: Maybe<StringNullableFilter>;
  clinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetupNullableScalarRelationFilter>;
  clinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingListRelationFilter>;
  clinicEmail?: Maybe<StringNullableFilter>;
  clinicEmailCampaignSettings?: Maybe<ClinicEmailCampaignSettingListRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeListRelationFilter>;
  clinicModules?: Maybe<ClinicModuleListRelationFilter>;
  clinicOfficeHours?: Maybe<ClinicOfficeHourListRelationFilter>;
  clinicOnboardings?: Maybe<ClinicOnboardingListRelationFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberListRelationFilter>;
  clinicRooms?: Maybe<ClinicRoomListRelationFilter>;
  clinicSetting?: Maybe<ClinicSettingNullableScalarRelationFilter>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicUserFilters?: Maybe<ClinicUserFilterListRelationFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingNullableScalarRelationFilter>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  clinicWorkflowTypes?: Maybe<ClinicWorkflowTypeListRelationFilter>;
  consultationCost?: Maybe<FloatNullableFilter>;
  consultationRequests?: Maybe<ConsultationRequestListRelationFilter>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  corporateId?: Maybe<StringNullableFilter>;
  country?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<JsonNullableFilter>;
  customerId?: Maybe<StringNullableFilter>;
  directBookingExclusionRules?: Maybe<DirectBookingExclusionRuleListRelationFilter>;
  emailCampaign?: Maybe<EmailCampaignListRelationFilter>;
  emailCampaignTemplate?: Maybe<EmailCampaignTemplateListRelationFilter>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadListRelationFilter>;
  featureFlags?: Maybe<FeatureFlagListRelationFilter>;
  financialTransactions?: Maybe<FinancialTransactionListRelationFilter>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<JsonNullableFilter>;
  followUpCost?: Maybe<FloatNullableFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  formTemplates?: Maybe<FormTemplateListRelationFilter>;
  fullAddress?: Maybe<StringNullableFilter>;
  googlePlace?: Maybe<GooglePlaceNullableScalarRelationFilter>;
  hasServiceReminders?: Maybe<BoolNullableFilter>;
  hasSmsConversations?: Maybe<BoolNullableFilter>;
  headUserId?: Maybe<StringNullableFilter>;
  hours?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  incomeMethod?: Maybe<StringNullableFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentListRelationFilter>;
  insuranceIntegrations?: Maybe<InsuranceIntegrationListRelationFilter>;
  integrationInfo?: Maybe<JsonNullableFilter>;
  integrationSystem?: Maybe<StringNullableFilter>;
  integrationType?: Maybe<StringNullableFilter>;
  integrations?: Maybe<ClinicPimsIntegrationListRelationFilter>;
  isAddAppointmentDisabled?: Maybe<BoolNullableFilter>;
  isCallerIdVerified?: Maybe<BoolNullableFilter>;
  isClinicActive?: Maybe<BoolFilter>;
  isClinicEligibleForPayments?: Maybe<BoolFilter>;
  isConsultationsActive?: Maybe<BoolNullableFilter>;
  isIntegrationActive?: Maybe<BoolNullableFilter>;
  isPaymentUsBank?: Maybe<BoolNullableFilter>;
  isServiceRemindersActive?: Maybe<BoolNullableFilter>;
  lastPrintOrderedOn?: Maybe<DateTimeNullableFilter>;
  lastPrintOrderedQuantity?: Maybe<IntNullableFilter>;
  lat?: Maybe<FloatNullableFilter>;
  legalEntity?: Maybe<LegalEntityNullableScalarRelationFilter>;
  legalEntityId?: Maybe<StringNullableFilter>;
  logo?: Maybe<StringNullableFilter>;
  long?: Maybe<FloatNullableFilter>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  loyaltyProgram?: Maybe<LoyaltyProgramNullableScalarRelationFilter>;
  loyaltyProgramId?: Maybe<StringNullableFilter>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  marketEmail?: Maybe<StringNullableFilter>;
  marketFacebookNumber?: Maybe<IntNullableFilter>;
  marketFacebookPageId?: Maybe<StringNullableFilter>;
  marketFacebookPageToken?: Maybe<StringNullableFilter>;
  massTextAlerts?: Maybe<MassTextAlertListRelationFilter>;
  media?: Maybe<MediaListRelationFilter>;
  messageTemplates?: Maybe<MessageTemplateListRelationFilter>;
  name?: Maybe<StringFilter>;
  optimizedLogoUrl?: Maybe<StringNullableFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  paymentAddress?: Maybe<StringNullableFilter>;
  paymentBankAccountNumber?: Maybe<StringNullableFilter>;
  paymentBankRoutingNumber?: Maybe<StringNullableFilter>;
  paymentCity?: Maybe<StringNullableFilter>;
  paymentName?: Maybe<StringNullableFilter>;
  paymentPhone?: Maybe<StringNullableFilter>;
  paymentProcessorForProviderGroup?: Maybe<CarePlanProviderGroupNullableScalarRelationFilter>;
  paymentState?: Maybe<StringNullableFilter>;
  paymentZip?: Maybe<StringNullableFilter>;
  payoutBatchingPeriods?: Maybe<PayoutBatchingPeriodListRelationFilter>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingNullableScalarRelationFilter>;
  pets?: Maybe<PetListRelationFilter>;
  petsId?: Maybe<PetListRelationFilter>;
  phone?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  postcardSettings?: Maybe<ClinicPostcardSettingListRelationFilter>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  printLastOrder?: Maybe<DateTimeNullableFilter>;
  printReceivedQuantity?: Maybe<IntNullableFilter>;
  productPackageSubscriptions?: Maybe<ProductPackageSubscriptionListRelationFilter>;
  promoCodes?: Maybe<PromoCodeListRelationFilter>;
  recaps?: Maybe<RecapListRelationFilter>;
  remindersIntegrationRequestEmail?: Maybe<StringNullableFilter>;
  responseTime?: Maybe<FloatNullableFilter>;
  roles?: Maybe<StaffRoleListRelationFilter>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  staff?: Maybe<VetInfoListRelationFilter>;
  staffId?: Maybe<VetInfoListRelationFilter>;
  state?: Maybe<StringNullableFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  stripePayoutAccounts?: Maybe<StripePayoutAccountListRelationFilter>;
  stripeSubscriptionId?: Maybe<StringNullableFilter>;
  stripeSubscriptionPlan?: Maybe<StringNullableFilter>;
  stripeTerminalLocations?: Maybe<StripeTerminalLocationListRelationFilter>;
  submerchantApprovedAt?: Maybe<DateTimeNullableFilter>;
  submerchantId?: Maybe<StringNullableFilter>;
  submerchantIsActive?: Maybe<BoolNullableFilter>;
  submerchantStatus?: Maybe<StringNullableFilter>;
  submerchantStripeChargesEnabled?: Maybe<BoolNullableFilter>;
  submerchantStripeHasCustomPayouts?: Maybe<BoolNullableFilter>;
  submerchantStripeId?: Maybe<StringNullableFilter>;
  submerchantStripePayoutsEnabled?: Maybe<BoolNullableFilter>;
  submerchantStripeStatus?: Maybe<StringNullableFilter>;
  subscribedAt?: Maybe<DateTimeNullableFilter>;
  subscriptionId?: Maybe<StringNullableFilter>;
  subscriptionPlan?: Maybe<StringNullableFilter>;
  surveyResults?: Maybe<SurveyResultListRelationFilter>;
  synchronyClinicConfiguration?: Maybe<SynchronyClinicConfigurationNullableScalarRelationFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  timezone?: Maybe<IntNullableFilter>;
  timezoneName?: Maybe<StringNullableFilter>;
  token?: Maybe<StringNullableFilter>;
  twilioConfiguration?: Maybe<TwilioConfigurationNullableScalarRelationFilter>;
  twilioVerifications?: Maybe<TwilioVerificationListRelationFilter>;
  unlayerSetting?: Maybe<UnlayerSettingNullableScalarRelationFilter>;
  unlayerSettingId?: Maybe<IntNullableFilter>;
  unsubscribedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  userBoardFiltersColumns?: Maybe<BoardFilterColumnListRelationFilter>;
  userTaskLists?: Maybe<UserTaskListListRelationFilter>;
  users?: Maybe<UserListRelationFilter>;
  usersId?: Maybe<UserNullableScalarRelationFilter>;
  vaccinations?: Maybe<VaccinationListRelationFilter>;
  vetAvailabilities?: Maybe<VetAvailabilityListRelationFilter>;
  vetsourceInstallation?: Maybe<VetsourceInstallationNullableScalarRelationFilter>;
  websiteUrl?: Maybe<StringNullableFilter>;
  widgetSettings?: Maybe<JsonNullableFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type ClinicWidgetRequest = {
  __typename?: 'ClinicWidgetRequest';
  _count: ClinicWidgetRequestCountOutputType;
  automationRuns: Array<AutomationRun>;
  channelAutomationStatuses: Array<ChannelAutomationStatus>;
  channelCreationSources: Array<ChannelCreationSource>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestType>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  directBookingAppointment?: Maybe<Appointment>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmission?: Maybe<FormSubmission>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs: Array<PushNotificationLog>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks: Array<Task>;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};


export type ClinicWidgetRequestAutomationRunsArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type ClinicWidgetRequestChannelAutomationStatusesArgs = {
  cursor?: Maybe<ChannelAutomationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelAutomationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelAutomationStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type ClinicWidgetRequestChannelCreationSourcesArgs = {
  cursor?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelCreationSourceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelCreationSourceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type ClinicWidgetRequestClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type ClinicWidgetRequestClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type ClinicWidgetRequestClinicWidgetRequestTypeArgs = {
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};


export type ClinicWidgetRequestDirectBookingAppointmentArgs = {
  where?: Maybe<AppointmentWhereInput>;
};


export type ClinicWidgetRequestFormSubmissionArgs = {
  where?: Maybe<FormSubmissionWhereInput>;
};


export type ClinicWidgetRequestPushNotificationLogsArgs = {
  cursor?: Maybe<PushNotificationLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PushNotificationLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PushNotificationLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PushNotificationLogWhereInput>;
};


export type ClinicWidgetRequestTasksArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaskScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaskOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaskWhereInput>;
};

export type ClinicWidgetRequestCountAggregateOutputType = {
  __typename?: 'ClinicWidgetRequestCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  clinicWidgetRequestTypeId: Scalars['Int'];
  createdAt: Scalars['Int'];
  directBookingAppointmentId: Scalars['Int'];
  formSubmissionId: Scalars['Int'];
  id: Scalars['Int'];
  isVerified: Scalars['Int'];
  requestFormSubmission: Scalars['Int'];
  updatedAt: Scalars['Int'];
  url: Scalars['Int'];
  verificationMethod: Scalars['Int'];
};

export type ClinicWidgetRequestCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  directBookingAppointmentId?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  requestFormSubmission?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  verificationMethod?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestCountOutputType = {
  __typename?: 'ClinicWidgetRequestCountOutputType';
  automationRuns: Scalars['Int'];
  channelAutomationStatuses: Scalars['Int'];
  channelCreationSources: Scalars['Int'];
  pushNotificationLogs: Scalars['Int'];
  tasks: Scalars['Int'];
};

export type ClinicWidgetRequestCreateInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedOneWithoutClinicWidgetRequestsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentCreateNestedOneWithoutDirectBookingWidgetRequestInput>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutClinicWidgetRequestsInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateManyClinicInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateManyClinicInputEnvelope = {
  data: Array<ClinicWidgetRequestCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicWidgetRequestCreateManyClinicPetParentInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateManyClinicPetParentInputEnvelope = {
  data: Array<ClinicWidgetRequestCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicWidgetRequestCreateManyClinicWidgetRequestTypeInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateManyClinicWidgetRequestTypeInputEnvelope = {
  data: Array<ClinicWidgetRequestCreateManyClinicWidgetRequestTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicWidgetRequestCreateManyFormSubmissionInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateManyFormSubmissionInputEnvelope = {
  data: Array<ClinicWidgetRequestCreateManyFormSubmissionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicWidgetRequestCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyClinicInputEnvelope>;
};

export type ClinicWidgetRequestCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyClinicPetParentInputEnvelope>;
};

export type ClinicWidgetRequestCreateNestedManyWithoutClinicWidgetRequestTypeInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutClinicWidgetRequestTypeInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutClinicWidgetRequestTypeInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyClinicWidgetRequestTypeInputEnvelope>;
};

export type ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyFormSubmissionInputEnvelope>;
};

export type ClinicWidgetRequestCreateNestedOneWithoutAutomationRunsInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutAutomationRunsInput>;
};

export type ClinicWidgetRequestCreateNestedOneWithoutChannelAutomationStatusesInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutChannelAutomationStatusesInput>;
};

export type ClinicWidgetRequestCreateNestedOneWithoutChannelCreationSourcesInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutChannelCreationSourcesInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutChannelCreationSourcesInput>;
};

export type ClinicWidgetRequestCreateNestedOneWithoutDirectBookingAppointmentInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutDirectBookingAppointmentInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutDirectBookingAppointmentInput>;
};

export type ClinicWidgetRequestCreateNestedOneWithoutPushNotificationLogsInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutPushNotificationLogsInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutPushNotificationLogsInput>;
};

export type ClinicWidgetRequestCreateNestedOneWithoutTasksInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutTasksInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutTasksInput>;
};

export type ClinicWidgetRequestCreateOrConnectWithoutAutomationRunsInput = {
  create: ClinicWidgetRequestCreateWithoutAutomationRunsInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestCreateOrConnectWithoutChannelAutomationStatusesInput = {
  create: ClinicWidgetRequestCreateWithoutChannelAutomationStatusesInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestCreateOrConnectWithoutChannelCreationSourcesInput = {
  create: ClinicWidgetRequestCreateWithoutChannelCreationSourcesInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestCreateOrConnectWithoutClinicInput = {
  create: ClinicWidgetRequestCreateWithoutClinicInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestCreateOrConnectWithoutClinicPetParentInput = {
  create: ClinicWidgetRequestCreateWithoutClinicPetParentInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestCreateOrConnectWithoutClinicWidgetRequestTypeInput = {
  create: ClinicWidgetRequestCreateWithoutClinicWidgetRequestTypeInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestCreateOrConnectWithoutDirectBookingAppointmentInput = {
  create: ClinicWidgetRequestCreateWithoutDirectBookingAppointmentInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestCreateOrConnectWithoutFormSubmissionInput = {
  create: ClinicWidgetRequestCreateWithoutFormSubmissionInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestCreateOrConnectWithoutPushNotificationLogsInput = {
  create: ClinicWidgetRequestCreateWithoutPushNotificationLogsInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestCreateOrConnectWithoutTasksInput = {
  create: ClinicWidgetRequestCreateWithoutTasksInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestCreateWithoutAutomationRunsInput = {
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedOneWithoutClinicWidgetRequestsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentCreateNestedOneWithoutDirectBookingWidgetRequestInput>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutClinicWidgetRequestsInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateWithoutChannelAutomationStatusesInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedOneWithoutClinicWidgetRequestsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentCreateNestedOneWithoutDirectBookingWidgetRequestInput>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutClinicWidgetRequestsInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateWithoutChannelCreationSourcesInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedOneWithoutClinicWidgetRequestsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentCreateNestedOneWithoutDirectBookingWidgetRequestInput>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutClinicWidgetRequestsInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateWithoutClinicInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedOneWithoutClinicWidgetRequestsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentCreateNestedOneWithoutDirectBookingWidgetRequestInput>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutClinicWidgetRequestsInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateWithoutClinicPetParentInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedOneWithoutClinicWidgetRequestsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentCreateNestedOneWithoutDirectBookingWidgetRequestInput>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutClinicWidgetRequestsInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateWithoutClinicWidgetRequestTypeInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutClinicWidgetRequestsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentCreateNestedOneWithoutDirectBookingWidgetRequestInput>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutClinicWidgetRequestsInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateWithoutDirectBookingAppointmentInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedOneWithoutClinicWidgetRequestsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutClinicWidgetRequestsInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateWithoutFormSubmissionInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedOneWithoutClinicWidgetRequestsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentCreateNestedOneWithoutDirectBookingWidgetRequestInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateWithoutPushNotificationLogsInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedOneWithoutClinicWidgetRequestsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentCreateNestedOneWithoutDirectBookingWidgetRequestInput>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutClinicWidgetRequestsInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestCreateWithoutTasksInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutClinicWidgetRequestsInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeCreateNestedOneWithoutClinicWidgetRequestsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentCreateNestedOneWithoutDirectBookingWidgetRequestInput>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutClinicWidgetRequestsInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestGroupByOutputType = {
  __typename?: 'ClinicWidgetRequestGroupByOutputType';
  _count?: Maybe<ClinicWidgetRequestCountAggregateOutputType>;
  _max?: Maybe<ClinicWidgetRequestMaxAggregateOutputType>;
  _min?: Maybe<ClinicWidgetRequestMinAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestListRelationFilter = {
  every?: Maybe<ClinicWidgetRequestWhereInput>;
  none?: Maybe<ClinicWidgetRequestWhereInput>;
  some?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestMaxAggregateOutputType = {
  __typename?: 'ClinicWidgetRequestMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  directBookingAppointmentId?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  verificationMethod?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestMinAggregateOutputType = {
  __typename?: 'ClinicWidgetRequestMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  directBookingAppointmentId?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  verificationMethod?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicWidgetRequestWhereInput>>;
  NOT?: Maybe<Array<ClinicWidgetRequestWhereInput>>;
  OR?: Maybe<Array<ClinicWidgetRequestWhereInput>>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeNullableScalarRelationFilter>;
  clinicWidgetRequestTypeId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  directBookingAppointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  directBookingAppointmentId?: Maybe<StringNullableFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isVerified?: Maybe<BoolNullableFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  requestFormSubmission?: Maybe<JsonNullableFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
  verificationMethod?: Maybe<EnumContactVerificationMethodNullableFilter>;
};

export type ClinicWidgetRequestOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicWidgetRequestOrderByRelevanceInput>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  directBookingAppointment?: Maybe<AppointmentOrderByWithRelationInput>;
  directBookingAppointmentId?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  requestFormSubmission?: Maybe<SortOrder>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  verificationMethod?: Maybe<SortOrder>;
};

export enum ClinicWidgetRequestOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  ClinicWidgetRequestTypeId = 'clinicWidgetRequestTypeId',
  DirectBookingAppointmentId = 'directBookingAppointmentId',
  FormSubmissionId = 'formSubmissionId',
  Id = 'id',
  Url = 'url'
}

export type ClinicWidgetRequestOrderByRelevanceInput = {
  fields: Array<ClinicWidgetRequestOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicWidgetRequestOrderByWithAggregationInput = {
  _count?: Maybe<ClinicWidgetRequestCountOrderByAggregateInput>;
  _max?: Maybe<ClinicWidgetRequestMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicWidgetRequestMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  directBookingAppointmentId?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  requestFormSubmission?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  verificationMethod?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicWidgetRequestOrderByRelevanceInput>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  directBookingAppointment?: Maybe<AppointmentOrderByWithRelationInput>;
  directBookingAppointmentId?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  requestFormSubmission?: Maybe<SortOrder>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  verificationMethod?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicWidgetRequestOrderByRelevanceInput>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>;
  clinicWidgetRequestTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  directBookingAppointment?: Maybe<AppointmentOrderByWithRelationInput>;
  directBookingAppointmentId?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVerified?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  requestFormSubmission?: Maybe<SortOrder>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  verificationMethod?: Maybe<SortOrder>;
};

export enum ClinicWidgetRequestScalarFieldEnum {
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  ClinicWidgetRequestTypeId = 'clinicWidgetRequestTypeId',
  CreatedAt = 'createdAt',
  DirectBookingAppointmentId = 'directBookingAppointmentId',
  FormSubmissionId = 'formSubmissionId',
  Id = 'id',
  IsVerified = 'isVerified',
  RequestFormSubmission = 'requestFormSubmission',
  UpdatedAt = 'updatedAt',
  Url = 'url',
  VerificationMethod = 'verificationMethod'
}

export type ClinicWidgetRequestScalarWhereInput = {
  AND?: Maybe<Array<ClinicWidgetRequestScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicWidgetRequestScalarWhereInput>>;
  OR?: Maybe<Array<ClinicWidgetRequestScalarWhereInput>>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestTypeId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  directBookingAppointmentId?: Maybe<StringNullableFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isVerified?: Maybe<BoolNullableFilter>;
  requestFormSubmission?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
  verificationMethod?: Maybe<EnumContactVerificationMethodNullableFilter>;
};

export type ClinicWidgetRequestScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicWidgetRequestScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicWidgetRequestScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicWidgetRequestScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicWidgetRequestTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  directBookingAppointmentId?: Maybe<StringNullableWithAggregatesFilter>;
  formSubmissionId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isVerified?: Maybe<BoolNullableWithAggregatesFilter>;
  requestFormSubmission?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  url?: Maybe<StringWithAggregatesFilter>;
  verificationMethod?: Maybe<EnumContactVerificationMethodNullableWithAggregatesFilter>;
};

export type ClinicWidgetRequestSubscription = {
  __typename?: 'ClinicWidgetRequestSubscription';
  mutation: MutationType;
  node: ClinicWidgetRequest;
};

export type ClinicWidgetRequestType = {
  __typename?: 'ClinicWidgetRequestType';
  _count: ClinicWidgetRequestTypeCountOutputType;
  assignees: Array<User>;
  channelStatus?: Maybe<ChannelStatus>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetRequests: Array<ClinicWidgetRequest>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSetting>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplate>;
  formTemplateId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  /** @deprecated - use formTemplate instead */
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility: WidgetVisibility;
  shouldCreateTask: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  workflows: Array<WorkflowEventSetting>;
};


export type ClinicWidgetRequestTypeAssigneesArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type ClinicWidgetRequestTypeChannelStatusArgs = {
  where?: Maybe<ChannelStatusWhereInput>;
};


export type ClinicWidgetRequestTypeClinicWidgetRequestsArgs = {
  cursor?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type ClinicWidgetRequestTypeClinicWidgetSettingArgs = {
  where?: Maybe<ClinicWidgetSettingWhereInput>;
};


export type ClinicWidgetRequestTypeFormTemplateArgs = {
  where?: Maybe<FormTemplateWhereInput>;
};


export type ClinicWidgetRequestTypeWorkflowsArgs = {
  cursor?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type ClinicWidgetRequestTypeAvgAggregateOutputType = {
  __typename?: 'ClinicWidgetRequestTypeAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type ClinicWidgetRequestTypeAvgOrderByAggregateInput = {
  order?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestTypeCountAggregateOutputType = {
  __typename?: 'ClinicWidgetRequestTypeCountAggregateOutputType';
  _all: Scalars['Int'];
  channelStatusId: Scalars['Int'];
  clinicWidgetSettingId: Scalars['Int'];
  createdAt: Scalars['Int'];
  displayName: Scalars['Int'];
  formTemplateId: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  order: Scalars['Int'];
  requestFormTemplate: Scalars['Int'];
  requestType: Scalars['Int'];
  requestVisibility: Scalars['Int'];
  shouldCreateTask: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicWidgetRequestTypeCountOrderByAggregateInput = {
  channelStatusId?: Maybe<SortOrder>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  requestFormTemplate?: Maybe<SortOrder>;
  requestType?: Maybe<SortOrder>;
  requestVisibility?: Maybe<SortOrder>;
  shouldCreateTask?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestTypeCountOutputType = {
  __typename?: 'ClinicWidgetRequestTypeCountOutputType';
  assignees: Scalars['Int'];
  clinicWidgetRequests: Scalars['Int'];
  workflows: Scalars['Int'];
};

export type ClinicWidgetRequestTypeCreateInput = {
  assignees?: Maybe<UserCreateNestedManyWithoutClinicWidgetRequestTypesInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicWidgetRequestTypesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutClinicWidgetRequestTypesInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutWidgetRequestTypesInput>;
};

export type ClinicWidgetRequestTypeCreateManyChannelStatusInput = {
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeCreateManyChannelStatusInputEnvelope = {
  data: Array<ClinicWidgetRequestTypeCreateManyChannelStatusInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicWidgetRequestTypeCreateManyClinicWidgetSettingInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeCreateManyClinicWidgetSettingInputEnvelope = {
  data: Array<ClinicWidgetRequestTypeCreateManyClinicWidgetSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicWidgetRequestTypeCreateManyFormTemplateInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeCreateManyFormTemplateInputEnvelope = {
  data: Array<ClinicWidgetRequestTypeCreateManyFormTemplateInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicWidgetRequestTypeCreateManyInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutAssigneesInput>>;
};

export type ClinicWidgetRequestTypeCreateNestedManyWithoutChannelStatusInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<ClinicWidgetRequestTypeCreateManyChannelStatusInputEnvelope>;
};

export type ClinicWidgetRequestTypeCreateNestedManyWithoutClinicWidgetSettingInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutClinicWidgetSettingInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutClinicWidgetSettingInput>>;
  createMany?: Maybe<ClinicWidgetRequestTypeCreateManyClinicWidgetSettingInputEnvelope>;
};

export type ClinicWidgetRequestTypeCreateNestedManyWithoutFormTemplateInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutFormTemplateInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutFormTemplateInput>>;
  createMany?: Maybe<ClinicWidgetRequestTypeCreateManyFormTemplateInputEnvelope>;
};

export type ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutWorkflowsInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutWorkflowsInput>>;
};

export type ClinicWidgetRequestTypeCreateNestedOneWithoutClinicWidgetRequestsInput = {
  connect?: Maybe<ClinicWidgetRequestTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestTypeCreateOrConnectWithoutClinicWidgetRequestsInput>;
  create?: Maybe<ClinicWidgetRequestTypeCreateWithoutClinicWidgetRequestsInput>;
};

export type ClinicWidgetRequestTypeCreateOrConnectWithoutAssigneesInput = {
  create: ClinicWidgetRequestTypeCreateWithoutAssigneesInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeCreateOrConnectWithoutChannelStatusInput = {
  create: ClinicWidgetRequestTypeCreateWithoutChannelStatusInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeCreateOrConnectWithoutClinicWidgetRequestsInput = {
  create: ClinicWidgetRequestTypeCreateWithoutClinicWidgetRequestsInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeCreateOrConnectWithoutClinicWidgetSettingInput = {
  create: ClinicWidgetRequestTypeCreateWithoutClinicWidgetSettingInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeCreateOrConnectWithoutFormTemplateInput = {
  create: ClinicWidgetRequestTypeCreateWithoutFormTemplateInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeCreateOrConnectWithoutWorkflowsInput = {
  create: ClinicWidgetRequestTypeCreateWithoutWorkflowsInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeCreateWithoutAssigneesInput = {
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicWidgetRequestTypesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutClinicWidgetRequestTypesInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutWidgetRequestTypesInput>;
};

export type ClinicWidgetRequestTypeCreateWithoutChannelStatusInput = {
  assignees?: Maybe<UserCreateNestedManyWithoutClinicWidgetRequestTypesInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicWidgetRequestTypesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutClinicWidgetRequestTypesInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutWidgetRequestTypesInput>;
};

export type ClinicWidgetRequestTypeCreateWithoutClinicWidgetRequestsInput = {
  assignees?: Maybe<UserCreateNestedManyWithoutClinicWidgetRequestTypesInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicWidgetRequestTypesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutClinicWidgetRequestTypesInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutWidgetRequestTypesInput>;
};

export type ClinicWidgetRequestTypeCreateWithoutClinicWidgetSettingInput = {
  assignees?: Maybe<UserCreateNestedManyWithoutClinicWidgetRequestTypesInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicWidgetRequestTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutClinicWidgetRequestTypesInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutWidgetRequestTypesInput>;
};

export type ClinicWidgetRequestTypeCreateWithoutFormTemplateInput = {
  assignees?: Maybe<UserCreateNestedManyWithoutClinicWidgetRequestTypesInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicWidgetRequestTypesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutWidgetRequestTypesInput>;
};

export type ClinicWidgetRequestTypeCreateWithoutWorkflowsInput = {
  assignees?: Maybe<UserCreateNestedManyWithoutClinicWidgetRequestTypesInput>;
  channelStatus?: Maybe<ChannelStatusCreateNestedOneWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingCreateNestedOneWithoutClinicWidgetRequestTypesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutClinicWidgetRequestTypesInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeGroupByOutputType = {
  __typename?: 'ClinicWidgetRequestTypeGroupByOutputType';
  _avg?: Maybe<ClinicWidgetRequestTypeAvgAggregateOutputType>;
  _count?: Maybe<ClinicWidgetRequestTypeCountAggregateOutputType>;
  _max?: Maybe<ClinicWidgetRequestTypeMaxAggregateOutputType>;
  _min?: Maybe<ClinicWidgetRequestTypeMinAggregateOutputType>;
  _sum?: Maybe<ClinicWidgetRequestTypeSumAggregateOutputType>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility: WidgetVisibility;
  shouldCreateTask: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type ClinicWidgetRequestTypeListRelationFilter = {
  every?: Maybe<ClinicWidgetRequestTypeWhereInput>;
  none?: Maybe<ClinicWidgetRequestTypeWhereInput>;
  some?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};

export type ClinicWidgetRequestTypeMaxAggregateOutputType = {
  __typename?: 'ClinicWidgetRequestTypeMaxAggregateOutputType';
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeMaxOrderByAggregateInput = {
  channelStatusId?: Maybe<SortOrder>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  requestType?: Maybe<SortOrder>;
  requestVisibility?: Maybe<SortOrder>;
  shouldCreateTask?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestTypeMinAggregateOutputType = {
  __typename?: 'ClinicWidgetRequestTypeMinAggregateOutputType';
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeMinOrderByAggregateInput = {
  channelStatusId?: Maybe<SortOrder>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  requestType?: Maybe<SortOrder>;
  requestVisibility?: Maybe<SortOrder>;
  shouldCreateTask?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestTypeNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicWidgetRequestTypeWhereInput>>;
  NOT?: Maybe<Array<ClinicWidgetRequestTypeWhereInput>>;
  OR?: Maybe<Array<ClinicWidgetRequestTypeWhereInput>>;
  assignees?: Maybe<UserListRelationFilter>;
  channelStatus?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusId?: Maybe<StringNullableFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingNullableScalarRelationFilter>;
  clinicWidgetSettingId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  displayName?: Maybe<StringNullableFilter>;
  formTemplate?: Maybe<FormTemplateNullableScalarRelationFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  order?: Maybe<IntFilter>;
  requestFormTemplate?: Maybe<JsonNullableFilter>;
  requestType?: Maybe<EnumWidgetRequestTypeFilter>;
  requestVisibility?: Maybe<EnumWidgetVisibilityFilter>;
  shouldCreateTask?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflows?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type ClinicWidgetRequestTypeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestTypeOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicWidgetRequestTypeOrderByRelevanceInput>;
  assignees?: Maybe<UserOrderByRelationAggregateInput>;
  channelStatus?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusId?: Maybe<SortOrder>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestOrderByRelationAggregateInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingOrderByWithRelationInput>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  formTemplate?: Maybe<FormTemplateOrderByWithRelationInput>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  requestFormTemplate?: Maybe<SortOrder>;
  requestType?: Maybe<SortOrder>;
  requestVisibility?: Maybe<SortOrder>;
  shouldCreateTask?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflows?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum ClinicWidgetRequestTypeOrderByRelevanceFieldEnum {
  ChannelStatusId = 'channelStatusId',
  ClinicWidgetSettingId = 'clinicWidgetSettingId',
  DisplayName = 'displayName',
  FormTemplateId = 'formTemplateId',
  Id = 'id'
}

export type ClinicWidgetRequestTypeOrderByRelevanceInput = {
  fields: Array<ClinicWidgetRequestTypeOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicWidgetRequestTypeOrderByWithAggregationInput = {
  _avg?: Maybe<ClinicWidgetRequestTypeAvgOrderByAggregateInput>;
  _count?: Maybe<ClinicWidgetRequestTypeCountOrderByAggregateInput>;
  _max?: Maybe<ClinicWidgetRequestTypeMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicWidgetRequestTypeMinOrderByAggregateInput>;
  _sum?: Maybe<ClinicWidgetRequestTypeSumOrderByAggregateInput>;
  channelStatusId?: Maybe<SortOrder>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  requestFormTemplate?: Maybe<SortOrder>;
  requestType?: Maybe<SortOrder>;
  requestVisibility?: Maybe<SortOrder>;
  shouldCreateTask?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestTypeOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicWidgetRequestTypeOrderByRelevanceInput>;
  assignees?: Maybe<UserOrderByRelationAggregateInput>;
  channelStatus?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusId?: Maybe<SortOrder>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestOrderByRelationAggregateInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingOrderByWithRelationInput>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  formTemplate?: Maybe<FormTemplateOrderByWithRelationInput>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  requestFormTemplate?: Maybe<SortOrder>;
  requestType?: Maybe<SortOrder>;
  requestVisibility?: Maybe<SortOrder>;
  shouldCreateTask?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflows?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export type ClinicWidgetRequestTypeOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicWidgetRequestTypeOrderByRelevanceInput>;
  assignees?: Maybe<UserOrderByRelationAggregateInput>;
  channelStatus?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusId?: Maybe<SortOrder>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestOrderByRelationAggregateInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingOrderByWithRelationInput>;
  clinicWidgetSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  formTemplate?: Maybe<FormTemplateOrderByWithRelationInput>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  requestFormTemplate?: Maybe<SortOrder>;
  requestType?: Maybe<SortOrder>;
  requestVisibility?: Maybe<SortOrder>;
  shouldCreateTask?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflows?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum ClinicWidgetRequestTypeScalarFieldEnum {
  ChannelStatusId = 'channelStatusId',
  ClinicWidgetSettingId = 'clinicWidgetSettingId',
  CreatedAt = 'createdAt',
  DisplayName = 'displayName',
  FormTemplateId = 'formTemplateId',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Order = 'order',
  RequestFormTemplate = 'requestFormTemplate',
  RequestType = 'requestType',
  RequestVisibility = 'requestVisibility',
  ShouldCreateTask = 'shouldCreateTask',
  UpdatedAt = 'updatedAt'
}

export type ClinicWidgetRequestTypeScalarWhereInput = {
  AND?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  OR?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  channelStatusId?: Maybe<StringNullableFilter>;
  clinicWidgetSettingId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  displayName?: Maybe<StringNullableFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  order?: Maybe<IntFilter>;
  requestFormTemplate?: Maybe<JsonNullableFilter>;
  requestType?: Maybe<EnumWidgetRequestTypeFilter>;
  requestVisibility?: Maybe<EnumWidgetVisibilityFilter>;
  shouldCreateTask?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicWidgetRequestTypeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereWithAggregatesInput>>;
  channelStatusId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicWidgetSettingId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  displayName?: Maybe<StringNullableWithAggregatesFilter>;
  formTemplateId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolNullableWithAggregatesFilter>;
  order?: Maybe<IntWithAggregatesFilter>;
  requestFormTemplate?: Maybe<JsonNullableWithAggregatesFilter>;
  requestType?: Maybe<EnumWidgetRequestTypeWithAggregatesFilter>;
  requestVisibility?: Maybe<EnumWidgetVisibilityWithAggregatesFilter>;
  shouldCreateTask?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicWidgetRequestTypeSumAggregateOutputType = {
  __typename?: 'ClinicWidgetRequestTypeSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type ClinicWidgetRequestTypeSumOrderByAggregateInput = {
  order?: Maybe<SortOrder>;
};

export type ClinicWidgetRequestTypeUncheckedCreateInput = {
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutClinicWidgetRequestTypesInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutWidgetRequestTypesInput>;
};

export type ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutAssigneesInput>>;
};

export type ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutChannelStatusInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<ClinicWidgetRequestTypeCreateManyChannelStatusInputEnvelope>;
};

export type ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutClinicWidgetSettingInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutClinicWidgetSettingInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutClinicWidgetSettingInput>>;
  createMany?: Maybe<ClinicWidgetRequestTypeCreateManyClinicWidgetSettingInputEnvelope>;
};

export type ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutFormTemplateInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutFormTemplateInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutFormTemplateInput>>;
  createMany?: Maybe<ClinicWidgetRequestTypeCreateManyFormTemplateInputEnvelope>;
};

export type ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutWorkflowsInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutWorkflowsInput>>;
};

export type ClinicWidgetRequestTypeUncheckedCreateWithoutAssigneesInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutWidgetRequestTypesInput>;
};

export type ClinicWidgetRequestTypeUncheckedCreateWithoutChannelStatusInput = {
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutClinicWidgetRequestTypesInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutWidgetRequestTypesInput>;
};

export type ClinicWidgetRequestTypeUncheckedCreateWithoutClinicWidgetRequestsInput = {
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutClinicWidgetRequestTypesInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutWidgetRequestTypesInput>;
};

export type ClinicWidgetRequestTypeUncheckedCreateWithoutClinicWidgetSettingInput = {
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutClinicWidgetRequestTypesInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicWidgetRequestTypeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutWidgetRequestTypesInput>;
};

export type ClinicWidgetRequestTypeUncheckedCreateWithoutFormTemplateInput = {
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutClinicWidgetRequestTypesInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutWidgetRequestTypesInput>;
};

export type ClinicWidgetRequestTypeUncheckedCreateWithoutWorkflowsInput = {
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutClinicWidgetRequestTypesInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicWidgetRequestTypeInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateInput = {
  assignees?: Maybe<UserUncheckedUpdateManyWithoutClinicWidgetRequestTypesNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutWidgetRequestTypesNestedInput>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateManyInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutAssigneesInput>>;
  delete?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutAssigneesInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestTypeUpdateManyWithWhereWithoutAssigneesInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutAssigneesInput>>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusInput = {
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateManyWithoutChannelStatusNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<ClinicWidgetRequestTypeCreateManyChannelStatusInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutChannelStatusInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestTypeUpdateManyWithWhereWithoutChannelStatusInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutChannelStatusInput>>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateManyWithoutClinicWidgetSettingInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateManyWithoutClinicWidgetSettingNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutClinicWidgetSettingInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutClinicWidgetSettingInput>>;
  createMany?: Maybe<ClinicWidgetRequestTypeCreateManyClinicWidgetSettingInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutClinicWidgetSettingInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestTypeUpdateManyWithWhereWithoutClinicWidgetSettingInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutClinicWidgetSettingInput>>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateManyWithoutFormTemplateInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateManyWithoutFormTemplateNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutFormTemplateInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutFormTemplateInput>>;
  createMany?: Maybe<ClinicWidgetRequestTypeCreateManyFormTemplateInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutFormTemplateInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestTypeUpdateManyWithWhereWithoutFormTemplateInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutFormTemplateInput>>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutWorkflowsInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutWorkflowsInput>>;
  delete?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutWorkflowsInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestTypeUpdateManyWithWhereWithoutWorkflowsInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutWorkflowsInput>>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateWithoutAssigneesInput = {
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutWidgetRequestTypesNestedInput>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateWithoutChannelStatusInput = {
  assignees?: Maybe<UserUncheckedUpdateManyWithoutClinicWidgetRequestTypesNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutWidgetRequestTypesNestedInput>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateWithoutClinicWidgetRequestsInput = {
  assignees?: Maybe<UserUncheckedUpdateManyWithoutClinicWidgetRequestTypesNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutWidgetRequestTypesNestedInput>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateWithoutClinicWidgetSettingInput = {
  assignees?: Maybe<UserUncheckedUpdateManyWithoutClinicWidgetRequestTypesNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutClinicWidgetRequestTypeNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicWidgetRequestTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutWidgetRequestTypesNestedInput>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateWithoutFormTemplateInput = {
  assignees?: Maybe<UserUncheckedUpdateManyWithoutClinicWidgetRequestTypesNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutWidgetRequestTypesNestedInput>;
};

export type ClinicWidgetRequestTypeUncheckedUpdateWithoutWorkflowsInput = {
  assignees?: Maybe<UserUncheckedUpdateManyWithoutClinicWidgetRequestTypesNestedInput>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeUpdateInput = {
  assignees?: Maybe<UserUpdateManyWithoutClinicWidgetRequestTypesNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutWidgetRequestTypesNestedInput>;
};

export type ClinicWidgetRequestTypeUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeUpdateManyWithWhereWithoutAssigneesInput = {
  data: ClinicWidgetRequestTypeUpdateManyMutationInput;
  where: ClinicWidgetRequestTypeScalarWhereInput;
};

export type ClinicWidgetRequestTypeUpdateManyWithWhereWithoutChannelStatusInput = {
  data: ClinicWidgetRequestTypeUpdateManyMutationInput;
  where: ClinicWidgetRequestTypeScalarWhereInput;
};

export type ClinicWidgetRequestTypeUpdateManyWithWhereWithoutClinicWidgetSettingInput = {
  data: ClinicWidgetRequestTypeUpdateManyMutationInput;
  where: ClinicWidgetRequestTypeScalarWhereInput;
};

export type ClinicWidgetRequestTypeUpdateManyWithWhereWithoutFormTemplateInput = {
  data: ClinicWidgetRequestTypeUpdateManyMutationInput;
  where: ClinicWidgetRequestTypeScalarWhereInput;
};

export type ClinicWidgetRequestTypeUpdateManyWithWhereWithoutWorkflowsInput = {
  data: ClinicWidgetRequestTypeUpdateManyMutationInput;
  where: ClinicWidgetRequestTypeScalarWhereInput;
};

export type ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutAssigneesInput>>;
  delete?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutAssigneesInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestTypeUpdateManyWithWhereWithoutAssigneesInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutAssigneesInput>>;
};

export type ClinicWidgetRequestTypeUpdateManyWithoutChannelStatusNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutChannelStatusInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutChannelStatusInput>>;
  createMany?: Maybe<ClinicWidgetRequestTypeCreateManyChannelStatusInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutChannelStatusInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestTypeUpdateManyWithWhereWithoutChannelStatusInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutChannelStatusInput>>;
};

export type ClinicWidgetRequestTypeUpdateManyWithoutClinicWidgetSettingNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutClinicWidgetSettingInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutClinicWidgetSettingInput>>;
  createMany?: Maybe<ClinicWidgetRequestTypeCreateManyClinicWidgetSettingInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutClinicWidgetSettingInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestTypeUpdateManyWithWhereWithoutClinicWidgetSettingInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutClinicWidgetSettingInput>>;
};

export type ClinicWidgetRequestTypeUpdateManyWithoutFormTemplateNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutFormTemplateInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutFormTemplateInput>>;
  createMany?: Maybe<ClinicWidgetRequestTypeCreateManyFormTemplateInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutFormTemplateInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestTypeUpdateManyWithWhereWithoutFormTemplateInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutFormTemplateInput>>;
};

export type ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestTypeCreateOrConnectWithoutWorkflowsInput>>;
  create?: Maybe<Array<ClinicWidgetRequestTypeCreateWithoutWorkflowsInput>>;
  delete?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutWorkflowsInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestTypeUpdateManyWithWhereWithoutWorkflowsInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutWorkflowsInput>>;
};

export type ClinicWidgetRequestTypeUpdateOneWithoutClinicWidgetRequestsNestedInput = {
  connect?: Maybe<ClinicWidgetRequestTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestTypeCreateOrConnectWithoutClinicWidgetRequestsInput>;
  create?: Maybe<ClinicWidgetRequestTypeCreateWithoutClinicWidgetRequestsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicWidgetRequestTypeUpdateToOneWithWhereWithoutClinicWidgetRequestsInput>;
  upsert?: Maybe<ClinicWidgetRequestTypeUpsertWithoutClinicWidgetRequestsInput>;
};

export type ClinicWidgetRequestTypeUpdateToOneWithWhereWithoutClinicWidgetRequestsInput = {
  data: ClinicWidgetRequestTypeUpdateWithoutClinicWidgetRequestsInput;
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};

export type ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutAssigneesInput = {
  data: ClinicWidgetRequestTypeUpdateWithoutAssigneesInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutChannelStatusInput = {
  data: ClinicWidgetRequestTypeUpdateWithoutChannelStatusInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutClinicWidgetSettingInput = {
  data: ClinicWidgetRequestTypeUpdateWithoutClinicWidgetSettingInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutFormTemplateInput = {
  data: ClinicWidgetRequestTypeUpdateWithoutFormTemplateInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeUpdateWithWhereUniqueWithoutWorkflowsInput = {
  data: ClinicWidgetRequestTypeUpdateWithoutWorkflowsInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeUpdateWithoutAssigneesInput = {
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutWidgetRequestTypesNestedInput>;
};

export type ClinicWidgetRequestTypeUpdateWithoutChannelStatusInput = {
  assignees?: Maybe<UserUpdateManyWithoutClinicWidgetRequestTypesNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutWidgetRequestTypesNestedInput>;
};

export type ClinicWidgetRequestTypeUpdateWithoutClinicWidgetRequestsInput = {
  assignees?: Maybe<UserUpdateManyWithoutClinicWidgetRequestTypesNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutWidgetRequestTypesNestedInput>;
};

export type ClinicWidgetRequestTypeUpdateWithoutClinicWidgetSettingInput = {
  assignees?: Maybe<UserUpdateManyWithoutClinicWidgetRequestTypesNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicWidgetRequestTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutWidgetRequestTypesNestedInput>;
};

export type ClinicWidgetRequestTypeUpdateWithoutFormTemplateInput = {
  assignees?: Maybe<UserUpdateManyWithoutClinicWidgetRequestTypesNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflows?: Maybe<WorkflowEventSettingUpdateManyWithoutWidgetRequestTypesNestedInput>;
};

export type ClinicWidgetRequestTypeUpdateWithoutWorkflowsInput = {
  assignees?: Maybe<UserUpdateManyWithoutClinicWidgetRequestTypesNestedInput>;
  channelStatus?: Maybe<ChannelStatusUpdateOneWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutClinicWidgetRequestTypeNestedInput>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutClinicWidgetRequestTypesNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType?: Maybe<WidgetRequestType>;
  requestVisibility?: Maybe<WidgetVisibility>;
  shouldCreateTask?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutAssigneesInput = {
  create: ClinicWidgetRequestTypeCreateWithoutAssigneesInput;
  update: ClinicWidgetRequestTypeUpdateWithoutAssigneesInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutChannelStatusInput = {
  create: ClinicWidgetRequestTypeCreateWithoutChannelStatusInput;
  update: ClinicWidgetRequestTypeUpdateWithoutChannelStatusInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutClinicWidgetSettingInput = {
  create: ClinicWidgetRequestTypeCreateWithoutClinicWidgetSettingInput;
  update: ClinicWidgetRequestTypeUpdateWithoutClinicWidgetSettingInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutFormTemplateInput = {
  create: ClinicWidgetRequestTypeCreateWithoutFormTemplateInput;
  update: ClinicWidgetRequestTypeUpdateWithoutFormTemplateInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeUpsertWithWhereUniqueWithoutWorkflowsInput = {
  create: ClinicWidgetRequestTypeCreateWithoutWorkflowsInput;
  update: ClinicWidgetRequestTypeUpdateWithoutWorkflowsInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};

export type ClinicWidgetRequestTypeUpsertWithoutClinicWidgetRequestsInput = {
  create: ClinicWidgetRequestTypeCreateWithoutClinicWidgetRequestsInput;
  update: ClinicWidgetRequestTypeUpdateWithoutClinicWidgetRequestsInput;
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};

export type ClinicWidgetRequestTypeWhereInput = {
  AND?: Maybe<Array<ClinicWidgetRequestTypeWhereInput>>;
  NOT?: Maybe<Array<ClinicWidgetRequestTypeWhereInput>>;
  OR?: Maybe<Array<ClinicWidgetRequestTypeWhereInput>>;
  assignees?: Maybe<UserListRelationFilter>;
  channelStatus?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusId?: Maybe<StringNullableFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingNullableScalarRelationFilter>;
  clinicWidgetSettingId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  displayName?: Maybe<StringNullableFilter>;
  formTemplate?: Maybe<FormTemplateNullableScalarRelationFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  order?: Maybe<IntFilter>;
  requestFormTemplate?: Maybe<JsonNullableFilter>;
  requestType?: Maybe<EnumWidgetRequestTypeFilter>;
  requestVisibility?: Maybe<EnumWidgetVisibilityFilter>;
  shouldCreateTask?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflows?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type ClinicWidgetRequestTypeWhereUniqueInput = {
  AND?: Maybe<Array<ClinicWidgetRequestTypeWhereInput>>;
  NOT?: Maybe<Array<ClinicWidgetRequestTypeWhereInput>>;
  OR?: Maybe<Array<ClinicWidgetRequestTypeWhereInput>>;
  assignees?: Maybe<UserListRelationFilter>;
  channelStatus?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusId?: Maybe<StringNullableFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSettingNullableScalarRelationFilter>;
  clinicWidgetSettingId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  displayName?: Maybe<StringNullableFilter>;
  formTemplate?: Maybe<FormTemplateNullableScalarRelationFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  order?: Maybe<IntFilter>;
  requestFormTemplate?: Maybe<JsonNullableFilter>;
  requestType?: Maybe<EnumWidgetRequestTypeFilter>;
  requestVisibility?: Maybe<EnumWidgetVisibilityFilter>;
  shouldCreateTask?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflows?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type ClinicWidgetRequestUncheckedCreateInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyClinicInputEnvelope>;
};

export type ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyClinicPetParentInputEnvelope>;
};

export type ClinicWidgetRequestUncheckedCreateNestedManyWithoutClinicWidgetRequestTypeInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutClinicWidgetRequestTypeInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutClinicWidgetRequestTypeInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyClinicWidgetRequestTypeInputEnvelope>;
};

export type ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyFormSubmissionInputEnvelope>;
};

export type ClinicWidgetRequestUncheckedCreateNestedOneWithoutDirectBookingAppointmentInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutDirectBookingAppointmentInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutDirectBookingAppointmentInput>;
};

export type ClinicWidgetRequestUncheckedCreateWithoutAutomationRunsInput = {
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedCreateWithoutChannelAutomationStatusesInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedCreateWithoutChannelCreationSourcesInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedCreateWithoutClinicInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedCreateWithoutClinicPetParentInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedCreateWithoutClinicWidgetRequestTypeInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedCreateWithoutDirectBookingAppointmentInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedCreateWithoutFormSubmissionInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedCreateWithoutPushNotificationLogsInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutWidgetRequestInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedCreateWithoutTasksInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutClinicWidgetRequestInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateManyWithoutClinicInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ClinicWidgetRequestUncheckedUpdateManyWithoutClinicWidgetRequestTypeInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateManyWithoutClinicWidgetRequestTypeNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutClinicWidgetRequestTypeInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutClinicWidgetRequestTypeInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyClinicWidgetRequestTypeInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestUpdateWithWhereUniqueWithoutClinicWidgetRequestTypeInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestUpdateManyWithWhereWithoutClinicWidgetRequestTypeInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestUpsertWithWhereUniqueWithoutClinicWidgetRequestTypeInput>>;
};

export type ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyFormSubmissionInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestUpdateWithWhereUniqueWithoutFormSubmissionInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestUpdateManyWithWhereWithoutFormSubmissionInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestUpsertWithWhereUniqueWithoutFormSubmissionInput>>;
};

export type ClinicWidgetRequestUncheckedUpdateOneWithoutDirectBookingAppointmentNestedInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutDirectBookingAppointmentInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutDirectBookingAppointmentInput>;
  delete?: Maybe<ClinicWidgetRequestWhereInput>;
  disconnect?: Maybe<ClinicWidgetRequestWhereInput>;
  update?: Maybe<ClinicWidgetRequestUpdateToOneWithWhereWithoutDirectBookingAppointmentInput>;
  upsert?: Maybe<ClinicWidgetRequestUpsertWithoutDirectBookingAppointmentInput>;
};

export type ClinicWidgetRequestUncheckedUpdateWithoutAutomationRunsInput = {
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateWithoutChannelAutomationStatusesInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateWithoutChannelCreationSourcesInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateWithoutClinicInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateWithoutClinicPetParentInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateWithoutClinicWidgetRequestTypeInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateWithoutDirectBookingAppointmentInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateWithoutFormSubmissionInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateWithoutPushNotificationLogsInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUncheckedUpdateWithoutTasksInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpdateInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentUpdateOneWithoutDirectBookingWidgetRequestNestedInput>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicWidgetRequestUpdateManyMutationInput;
  where: ClinicWidgetRequestScalarWhereInput;
};

export type ClinicWidgetRequestUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: ClinicWidgetRequestUpdateManyMutationInput;
  where: ClinicWidgetRequestScalarWhereInput;
};

export type ClinicWidgetRequestUpdateManyWithWhereWithoutClinicWidgetRequestTypeInput = {
  data: ClinicWidgetRequestUpdateManyMutationInput;
  where: ClinicWidgetRequestScalarWhereInput;
};

export type ClinicWidgetRequestUpdateManyWithWhereWithoutFormSubmissionInput = {
  data: ClinicWidgetRequestUpdateManyMutationInput;
  where: ClinicWidgetRequestScalarWhereInput;
};

export type ClinicWidgetRequestUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicWidgetRequestUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ClinicWidgetRequestUpdateManyWithoutClinicWidgetRequestTypeNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutClinicWidgetRequestTypeInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutClinicWidgetRequestTypeInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyClinicWidgetRequestTypeInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestUpdateWithWhereUniqueWithoutClinicWidgetRequestTypeInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestUpdateManyWithWhereWithoutClinicWidgetRequestTypeInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestUpsertWithWhereUniqueWithoutClinicWidgetRequestTypeInput>>;
};

export type ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput = {
  connect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWidgetRequestCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ClinicWidgetRequestCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ClinicWidgetRequestCreateManyFormSubmissionInputEnvelope>;
  delete?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWidgetRequestScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWidgetRequestWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWidgetRequestUpdateWithWhereUniqueWithoutFormSubmissionInput>>;
  updateMany?: Maybe<Array<ClinicWidgetRequestUpdateManyWithWhereWithoutFormSubmissionInput>>;
  upsert?: Maybe<Array<ClinicWidgetRequestUpsertWithWhereUniqueWithoutFormSubmissionInput>>;
};

export type ClinicWidgetRequestUpdateOneWithoutAutomationRunsNestedInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutAutomationRunsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicWidgetRequestUpdateToOneWithWhereWithoutAutomationRunsInput>;
  upsert?: Maybe<ClinicWidgetRequestUpsertWithoutAutomationRunsInput>;
};

export type ClinicWidgetRequestUpdateOneWithoutChannelAutomationStatusesNestedInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutChannelAutomationStatusesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicWidgetRequestUpdateToOneWithWhereWithoutChannelAutomationStatusesInput>;
  upsert?: Maybe<ClinicWidgetRequestUpsertWithoutChannelAutomationStatusesInput>;
};

export type ClinicWidgetRequestUpdateOneWithoutChannelCreationSourcesNestedInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutChannelCreationSourcesInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutChannelCreationSourcesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicWidgetRequestUpdateToOneWithWhereWithoutChannelCreationSourcesInput>;
  upsert?: Maybe<ClinicWidgetRequestUpsertWithoutChannelCreationSourcesInput>;
};

export type ClinicWidgetRequestUpdateOneWithoutDirectBookingAppointmentNestedInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutDirectBookingAppointmentInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutDirectBookingAppointmentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicWidgetRequestUpdateToOneWithWhereWithoutDirectBookingAppointmentInput>;
  upsert?: Maybe<ClinicWidgetRequestUpsertWithoutDirectBookingAppointmentInput>;
};

export type ClinicWidgetRequestUpdateOneWithoutPushNotificationLogsNestedInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutPushNotificationLogsInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutPushNotificationLogsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicWidgetRequestUpdateToOneWithWhereWithoutPushNotificationLogsInput>;
  upsert?: Maybe<ClinicWidgetRequestUpsertWithoutPushNotificationLogsInput>;
};

export type ClinicWidgetRequestUpdateOneWithoutTasksNestedInput = {
  connect?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetRequestCreateOrConnectWithoutTasksInput>;
  create?: Maybe<ClinicWidgetRequestCreateWithoutTasksInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicWidgetRequestUpdateToOneWithWhereWithoutTasksInput>;
  upsert?: Maybe<ClinicWidgetRequestUpsertWithoutTasksInput>;
};

export type ClinicWidgetRequestUpdateToOneWithWhereWithoutAutomationRunsInput = {
  data: ClinicWidgetRequestUpdateWithoutAutomationRunsInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestUpdateToOneWithWhereWithoutChannelAutomationStatusesInput = {
  data: ClinicWidgetRequestUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestUpdateToOneWithWhereWithoutChannelCreationSourcesInput = {
  data: ClinicWidgetRequestUpdateWithoutChannelCreationSourcesInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestUpdateToOneWithWhereWithoutDirectBookingAppointmentInput = {
  data: ClinicWidgetRequestUpdateWithoutDirectBookingAppointmentInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestUpdateToOneWithWhereWithoutPushNotificationLogsInput = {
  data: ClinicWidgetRequestUpdateWithoutPushNotificationLogsInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestUpdateToOneWithWhereWithoutTasksInput = {
  data: ClinicWidgetRequestUpdateWithoutTasksInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicWidgetRequestUpdateWithoutClinicInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: ClinicWidgetRequestUpdateWithoutClinicPetParentInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestUpdateWithWhereUniqueWithoutClinicWidgetRequestTypeInput = {
  data: ClinicWidgetRequestUpdateWithoutClinicWidgetRequestTypeInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestUpdateWithWhereUniqueWithoutFormSubmissionInput = {
  data: ClinicWidgetRequestUpdateWithoutFormSubmissionInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestUpdateWithoutAutomationRunsInput = {
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentUpdateOneWithoutDirectBookingWidgetRequestNestedInput>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpdateWithoutChannelAutomationStatusesInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentUpdateOneWithoutDirectBookingWidgetRequestNestedInput>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpdateWithoutChannelCreationSourcesInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentUpdateOneWithoutDirectBookingWidgetRequestNestedInput>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpdateWithoutClinicInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentUpdateOneWithoutDirectBookingWidgetRequestNestedInput>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpdateWithoutClinicPetParentInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentUpdateOneWithoutDirectBookingWidgetRequestNestedInput>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpdateWithoutClinicWidgetRequestTypeInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentUpdateOneWithoutDirectBookingWidgetRequestNestedInput>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpdateWithoutDirectBookingAppointmentInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpdateWithoutFormSubmissionInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentUpdateOneWithoutDirectBookingWidgetRequestNestedInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpdateWithoutPushNotificationLogsInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentUpdateOneWithoutDirectBookingWidgetRequestNestedInput>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutWidgetRequestNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpdateWithoutTasksInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutClinicWidgetRequestNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutClinicWidgetRequestNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directBookingAppointment?: Maybe<AppointmentUpdateOneWithoutDirectBookingWidgetRequestNestedInput>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutClinicWidgetRequestsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutClinicWidgetRequestNestedInput>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type ClinicWidgetRequestUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicWidgetRequestCreateWithoutClinicInput;
  update: ClinicWidgetRequestUpdateWithoutClinicInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: ClinicWidgetRequestCreateWithoutClinicPetParentInput;
  update: ClinicWidgetRequestUpdateWithoutClinicPetParentInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestUpsertWithWhereUniqueWithoutClinicWidgetRequestTypeInput = {
  create: ClinicWidgetRequestCreateWithoutClinicWidgetRequestTypeInput;
  update: ClinicWidgetRequestUpdateWithoutClinicWidgetRequestTypeInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestUpsertWithWhereUniqueWithoutFormSubmissionInput = {
  create: ClinicWidgetRequestCreateWithoutFormSubmissionInput;
  update: ClinicWidgetRequestUpdateWithoutFormSubmissionInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};

export type ClinicWidgetRequestUpsertWithoutAutomationRunsInput = {
  create: ClinicWidgetRequestCreateWithoutAutomationRunsInput;
  update: ClinicWidgetRequestUpdateWithoutAutomationRunsInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestUpsertWithoutChannelAutomationStatusesInput = {
  create: ClinicWidgetRequestCreateWithoutChannelAutomationStatusesInput;
  update: ClinicWidgetRequestUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestUpsertWithoutChannelCreationSourcesInput = {
  create: ClinicWidgetRequestCreateWithoutChannelCreationSourcesInput;
  update: ClinicWidgetRequestUpdateWithoutChannelCreationSourcesInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestUpsertWithoutDirectBookingAppointmentInput = {
  create: ClinicWidgetRequestCreateWithoutDirectBookingAppointmentInput;
  update: ClinicWidgetRequestUpdateWithoutDirectBookingAppointmentInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestUpsertWithoutPushNotificationLogsInput = {
  create: ClinicWidgetRequestCreateWithoutPushNotificationLogsInput;
  update: ClinicWidgetRequestUpdateWithoutPushNotificationLogsInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestUpsertWithoutTasksInput = {
  create: ClinicWidgetRequestCreateWithoutTasksInput;
  update: ClinicWidgetRequestUpdateWithoutTasksInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type ClinicWidgetRequestWhereInput = {
  AND?: Maybe<Array<ClinicWidgetRequestWhereInput>>;
  NOT?: Maybe<Array<ClinicWidgetRequestWhereInput>>;
  OR?: Maybe<Array<ClinicWidgetRequestWhereInput>>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeNullableScalarRelationFilter>;
  clinicWidgetRequestTypeId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  directBookingAppointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  directBookingAppointmentId?: Maybe<StringNullableFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isVerified?: Maybe<BoolNullableFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  requestFormSubmission?: Maybe<JsonNullableFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
  verificationMethod?: Maybe<EnumContactVerificationMethodNullableFilter>;
};

export type ClinicWidgetRequestWhereUniqueInput = {
  AND?: Maybe<Array<ClinicWidgetRequestWhereInput>>;
  NOT?: Maybe<Array<ClinicWidgetRequestWhereInput>>;
  OR?: Maybe<Array<ClinicWidgetRequestWhereInput>>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestTypeNullableScalarRelationFilter>;
  clinicWidgetRequestTypeId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  directBookingAppointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<BoolNullableFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  requestFormSubmission?: Maybe<JsonNullableFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
  verificationMethod?: Maybe<EnumContactVerificationMethodNullableFilter>;
};

export type ClinicWidgetSetting = {
  __typename?: 'ClinicWidgetSetting';
  _count: ClinicWidgetSettingCountOutputType;
  clinic: Array<Clinic>;
  clinicWidgetRequestTypes: Array<ClinicWidgetRequestType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};


export type ClinicWidgetSettingClinicArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type ClinicWidgetSettingClinicWidgetRequestTypesArgs = {
  cursor?: Maybe<ClinicWidgetRequestTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};

export type ClinicWidgetSettingCountAggregateOutputType = {
  __typename?: 'ClinicWidgetSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isEnabled: Scalars['Int'];
  primaryColor: Scalars['Int'];
  secondaryColor: Scalars['Int'];
  updatedAt: Scalars['Int'];
  welcomeMessage: Scalars['Int'];
  whiteLabelUrls: Scalars['Int'];
};

export type ClinicWidgetSettingCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  primaryColor?: Maybe<SortOrder>;
  secondaryColor?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  welcomeMessage?: Maybe<SortOrder>;
  whiteLabelUrls?: Maybe<SortOrder>;
};

export type ClinicWidgetSettingCountOutputType = {
  __typename?: 'ClinicWidgetSettingCountOutputType';
  clinic: Scalars['Int'];
  clinicWidgetRequestTypes: Scalars['Int'];
};

export type ClinicWidgetSettingCreateInput = {
  clinic?: Maybe<ClinicCreateNestedManyWithoutClinicWidgetSettingInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutClinicWidgetSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<ClinicWidgetSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetSettingCreateOrConnectWithoutClinicInput>;
  create?: Maybe<ClinicWidgetSettingCreateWithoutClinicInput>;
};

export type ClinicWidgetSettingCreateNestedOneWithoutClinicWidgetRequestTypesInput = {
  connect?: Maybe<ClinicWidgetSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetSettingCreateOrConnectWithoutClinicWidgetRequestTypesInput>;
  create?: Maybe<ClinicWidgetSettingCreateWithoutClinicWidgetRequestTypesInput>;
};

export type ClinicWidgetSettingCreateOrConnectWithoutClinicInput = {
  create: ClinicWidgetSettingCreateWithoutClinicInput;
  where: ClinicWidgetSettingWhereUniqueInput;
};

export type ClinicWidgetSettingCreateOrConnectWithoutClinicWidgetRequestTypesInput = {
  create: ClinicWidgetSettingCreateWithoutClinicWidgetRequestTypesInput;
  where: ClinicWidgetSettingWhereUniqueInput;
};

export type ClinicWidgetSettingCreateWithoutClinicInput = {
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutClinicWidgetSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingCreateWithoutClinicWidgetRequestTypesInput = {
  clinic?: Maybe<ClinicCreateNestedManyWithoutClinicWidgetSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingGroupByOutputType = {
  __typename?: 'ClinicWidgetSettingGroupByOutputType';
  _count?: Maybe<ClinicWidgetSettingCountAggregateOutputType>;
  _max?: Maybe<ClinicWidgetSettingMaxAggregateOutputType>;
  _min?: Maybe<ClinicWidgetSettingMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingMaxAggregateOutputType = {
  __typename?: 'ClinicWidgetSettingMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
};

export type ClinicWidgetSettingMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  primaryColor?: Maybe<SortOrder>;
  secondaryColor?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  welcomeMessage?: Maybe<SortOrder>;
};

export type ClinicWidgetSettingMinAggregateOutputType = {
  __typename?: 'ClinicWidgetSettingMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
};

export type ClinicWidgetSettingMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  primaryColor?: Maybe<SortOrder>;
  secondaryColor?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  welcomeMessage?: Maybe<SortOrder>;
};

export type ClinicWidgetSettingNullableScalarRelationFilter = {
  AND?: Maybe<Array<ClinicWidgetSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicWidgetSettingWhereInput>>;
  OR?: Maybe<Array<ClinicWidgetSettingWhereInput>>;
  clinic?: Maybe<ClinicListRelationFilter>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isEnabled?: Maybe<BoolNullableFilter>;
  primaryColor?: Maybe<StringNullableFilter>;
  secondaryColor?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  welcomeMessage?: Maybe<StringNullableFilter>;
  whiteLabelUrls?: Maybe<JsonNullableFilter>;
};

export type ClinicWidgetSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicWidgetSettingOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByRelationAggregateInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  primaryColor?: Maybe<SortOrder>;
  secondaryColor?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  welcomeMessage?: Maybe<SortOrder>;
  whiteLabelUrls?: Maybe<SortOrder>;
};

export enum ClinicWidgetSettingOrderByRelevanceFieldEnum {
  Id = 'id',
  PrimaryColor = 'primaryColor',
  SecondaryColor = 'secondaryColor',
  WelcomeMessage = 'welcomeMessage'
}

export type ClinicWidgetSettingOrderByRelevanceInput = {
  fields: Array<ClinicWidgetSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicWidgetSettingOrderByWithAggregationInput = {
  _count?: Maybe<ClinicWidgetSettingCountOrderByAggregateInput>;
  _max?: Maybe<ClinicWidgetSettingMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicWidgetSettingMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  primaryColor?: Maybe<SortOrder>;
  secondaryColor?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  welcomeMessage?: Maybe<SortOrder>;
  whiteLabelUrls?: Maybe<SortOrder>;
};

export type ClinicWidgetSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicWidgetSettingOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByRelationAggregateInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  primaryColor?: Maybe<SortOrder>;
  secondaryColor?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  welcomeMessage?: Maybe<SortOrder>;
  whiteLabelUrls?: Maybe<SortOrder>;
};

export type ClinicWidgetSettingOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicWidgetSettingOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByRelationAggregateInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isEnabled?: Maybe<SortOrder>;
  primaryColor?: Maybe<SortOrder>;
  secondaryColor?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  welcomeMessage?: Maybe<SortOrder>;
  whiteLabelUrls?: Maybe<SortOrder>;
};

export enum ClinicWidgetSettingScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsEnabled = 'isEnabled',
  PrimaryColor = 'primaryColor',
  SecondaryColor = 'secondaryColor',
  UpdatedAt = 'updatedAt',
  WelcomeMessage = 'welcomeMessage',
  WhiteLabelUrls = 'whiteLabelUrls'
}

export type ClinicWidgetSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicWidgetSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicWidgetSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicWidgetSettingScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isEnabled?: Maybe<BoolNullableWithAggregatesFilter>;
  primaryColor?: Maybe<StringNullableWithAggregatesFilter>;
  secondaryColor?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  welcomeMessage?: Maybe<StringNullableWithAggregatesFilter>;
  whiteLabelUrls?: Maybe<JsonNullableWithAggregatesFilter>;
};

export type ClinicWidgetSettingUncheckedCreateInput = {
  clinic?: Maybe<ClinicUncheckedCreateNestedManyWithoutClinicWidgetSettingInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutClinicWidgetSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingUncheckedCreateWithoutClinicInput = {
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutClinicWidgetSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingUncheckedCreateWithoutClinicWidgetRequestTypesInput = {
  clinic?: Maybe<ClinicUncheckedCreateNestedManyWithoutClinicWidgetSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingUncheckedUpdateInput = {
  clinic?: Maybe<ClinicUncheckedUpdateManyWithoutClinicWidgetSettingNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutClinicWidgetSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingUncheckedUpdateWithoutClinicInput = {
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutClinicWidgetSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingUncheckedUpdateWithoutClinicWidgetRequestTypesInput = {
  clinic?: Maybe<ClinicUncheckedUpdateManyWithoutClinicWidgetSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingUpdateInput = {
  clinic?: Maybe<ClinicUpdateManyWithoutClinicWidgetSettingNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutClinicWidgetSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<ClinicWidgetSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetSettingCreateOrConnectWithoutClinicInput>;
  create?: Maybe<ClinicWidgetSettingCreateWithoutClinicInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicWidgetSettingUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<ClinicWidgetSettingUpsertWithoutClinicInput>;
};

export type ClinicWidgetSettingUpdateOneWithoutClinicWidgetRequestTypesNestedInput = {
  connect?: Maybe<ClinicWidgetSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<ClinicWidgetSettingCreateOrConnectWithoutClinicWidgetRequestTypesInput>;
  create?: Maybe<ClinicWidgetSettingCreateWithoutClinicWidgetRequestTypesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClinicWidgetSettingUpdateToOneWithWhereWithoutClinicWidgetRequestTypesInput>;
  upsert?: Maybe<ClinicWidgetSettingUpsertWithoutClinicWidgetRequestTypesInput>;
};

export type ClinicWidgetSettingUpdateToOneWithWhereWithoutClinicInput = {
  data: ClinicWidgetSettingUpdateWithoutClinicInput;
  where?: Maybe<ClinicWidgetSettingWhereInput>;
};

export type ClinicWidgetSettingUpdateToOneWithWhereWithoutClinicWidgetRequestTypesInput = {
  data: ClinicWidgetSettingUpdateWithoutClinicWidgetRequestTypesInput;
  where?: Maybe<ClinicWidgetSettingWhereInput>;
};

export type ClinicWidgetSettingUpdateWithoutClinicInput = {
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutClinicWidgetSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingUpdateWithoutClinicWidgetRequestTypesInput = {
  clinic?: Maybe<ClinicUpdateManyWithoutClinicWidgetSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type ClinicWidgetSettingUpsertWithoutClinicInput = {
  create: ClinicWidgetSettingCreateWithoutClinicInput;
  update: ClinicWidgetSettingUpdateWithoutClinicInput;
  where?: Maybe<ClinicWidgetSettingWhereInput>;
};

export type ClinicWidgetSettingUpsertWithoutClinicWidgetRequestTypesInput = {
  create: ClinicWidgetSettingCreateWithoutClinicWidgetRequestTypesInput;
  update: ClinicWidgetSettingUpdateWithoutClinicWidgetRequestTypesInput;
  where?: Maybe<ClinicWidgetSettingWhereInput>;
};

export type ClinicWidgetSettingWhereInput = {
  AND?: Maybe<Array<ClinicWidgetSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicWidgetSettingWhereInput>>;
  OR?: Maybe<Array<ClinicWidgetSettingWhereInput>>;
  clinic?: Maybe<ClinicListRelationFilter>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isEnabled?: Maybe<BoolNullableFilter>;
  primaryColor?: Maybe<StringNullableFilter>;
  secondaryColor?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  welcomeMessage?: Maybe<StringNullableFilter>;
  whiteLabelUrls?: Maybe<JsonNullableFilter>;
};

export type ClinicWidgetSettingWhereUniqueInput = {
  AND?: Maybe<Array<ClinicWidgetSettingWhereInput>>;
  NOT?: Maybe<Array<ClinicWidgetSettingWhereInput>>;
  OR?: Maybe<Array<ClinicWidgetSettingWhereInput>>;
  clinic?: Maybe<ClinicListRelationFilter>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<BoolNullableFilter>;
  primaryColor?: Maybe<StringNullableFilter>;
  secondaryColor?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  welcomeMessage?: Maybe<StringNullableFilter>;
  whiteLabelUrls?: Maybe<JsonNullableFilter>;
};

export type ClinicWorkflowType = {
  __typename?: 'ClinicWorkflowType';
  appoinmentTypeId?: Maybe<Scalars['String']>;
  appointmentType?: Maybe<AppointmentType>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultWorkflowType: WorkflowType;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type ClinicWorkflowTypeAppointmentTypeArgs = {
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type ClinicWorkflowTypeClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};

export type ClinicWorkflowTypeCountAggregateOutputType = {
  __typename?: 'ClinicWorkflowTypeCountAggregateOutputType';
  _all: Scalars['Int'];
  appoinmentTypeId: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  defaultWorkflowType: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClinicWorkflowTypeCountOrderByAggregateInput = {
  appoinmentTypeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultWorkflowType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicWorkflowTypeCreateInput = {
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutClinicWorkflowTypesInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicWorkflowTypesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType: WorkflowType;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeCreateManyAppointmentTypeInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType: WorkflowType;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeCreateManyAppointmentTypeInputEnvelope = {
  data: Array<ClinicWorkflowTypeCreateManyAppointmentTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicWorkflowTypeCreateManyClinicInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType: WorkflowType;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeCreateManyClinicInputEnvelope = {
  data: Array<ClinicWorkflowTypeCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ClinicWorkflowTypeCreateManyInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType: WorkflowType;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeCreateNestedManyWithoutAppointmentTypeInput = {
  connect?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWorkflowTypeCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<ClinicWorkflowTypeCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<ClinicWorkflowTypeCreateManyAppointmentTypeInputEnvelope>;
};

export type ClinicWorkflowTypeCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWorkflowTypeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicWorkflowTypeCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicWorkflowTypeCreateManyClinicInputEnvelope>;
};

export type ClinicWorkflowTypeCreateOrConnectWithoutAppointmentTypeInput = {
  create: ClinicWorkflowTypeCreateWithoutAppointmentTypeInput;
  where: ClinicWorkflowTypeWhereUniqueInput;
};

export type ClinicWorkflowTypeCreateOrConnectWithoutClinicInput = {
  create: ClinicWorkflowTypeCreateWithoutClinicInput;
  where: ClinicWorkflowTypeWhereUniqueInput;
};

export type ClinicWorkflowTypeCreateWithoutAppointmentTypeInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutClinicWorkflowTypesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType: WorkflowType;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeCreateWithoutClinicInput = {
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutClinicWorkflowTypesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType: WorkflowType;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeGroupByOutputType = {
  __typename?: 'ClinicWorkflowTypeGroupByOutputType';
  _count?: Maybe<ClinicWorkflowTypeCountAggregateOutputType>;
  _max?: Maybe<ClinicWorkflowTypeMaxAggregateOutputType>;
  _min?: Maybe<ClinicWorkflowTypeMinAggregateOutputType>;
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultWorkflowType: WorkflowType;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ClinicWorkflowTypeListRelationFilter = {
  every?: Maybe<ClinicWorkflowTypeWhereInput>;
  none?: Maybe<ClinicWorkflowTypeWhereInput>;
  some?: Maybe<ClinicWorkflowTypeWhereInput>;
};

export type ClinicWorkflowTypeMaxAggregateOutputType = {
  __typename?: 'ClinicWorkflowTypeMaxAggregateOutputType';
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType?: Maybe<WorkflowType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeMaxOrderByAggregateInput = {
  appoinmentTypeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultWorkflowType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicWorkflowTypeMinAggregateOutputType = {
  __typename?: 'ClinicWorkflowTypeMinAggregateOutputType';
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType?: Maybe<WorkflowType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeMinOrderByAggregateInput = {
  appoinmentTypeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultWorkflowType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicWorkflowTypeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ClinicWorkflowTypeOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicWorkflowTypeOrderByRelevanceInput>;
  appoinmentTypeId?: Maybe<SortOrder>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultWorkflowType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicWorkflowTypeOrderByRelevanceFieldEnum {
  AppoinmentTypeId = 'appoinmentTypeId',
  ClinicId = 'clinicId',
  Id = 'id',
  Name = 'name'
}

export type ClinicWorkflowTypeOrderByRelevanceInput = {
  fields: Array<ClinicWorkflowTypeOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ClinicWorkflowTypeOrderByWithAggregationInput = {
  _count?: Maybe<ClinicWorkflowTypeCountOrderByAggregateInput>;
  _max?: Maybe<ClinicWorkflowTypeMaxOrderByAggregateInput>;
  _min?: Maybe<ClinicWorkflowTypeMinOrderByAggregateInput>;
  appoinmentTypeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultWorkflowType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicWorkflowTypeOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ClinicWorkflowTypeOrderByRelevanceInput>;
  appoinmentTypeId?: Maybe<SortOrder>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultWorkflowType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ClinicWorkflowTypeOrderByWithRelationInput = {
  _relevance?: Maybe<ClinicWorkflowTypeOrderByRelevanceInput>;
  appoinmentTypeId?: Maybe<SortOrder>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultWorkflowType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ClinicWorkflowTypeScalarFieldEnum {
  AppoinmentTypeId = 'appoinmentTypeId',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  DefaultWorkflowType = 'defaultWorkflowType',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type ClinicWorkflowTypeScalarWhereInput = {
  AND?: Maybe<Array<ClinicWorkflowTypeScalarWhereInput>>;
  NOT?: Maybe<Array<ClinicWorkflowTypeScalarWhereInput>>;
  OR?: Maybe<Array<ClinicWorkflowTypeScalarWhereInput>>;
  appoinmentTypeId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultWorkflowType?: Maybe<EnumWorkflowTypeFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicWorkflowTypeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ClinicWorkflowTypeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ClinicWorkflowTypeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ClinicWorkflowTypeScalarWhereWithAggregatesInput>>;
  appoinmentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  defaultWorkflowType?: Maybe<EnumWorkflowTypeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ClinicWorkflowTypeUncheckedCreateInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType: WorkflowType;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUncheckedCreateNestedManyWithoutAppointmentTypeInput = {
  connect?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWorkflowTypeCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<ClinicWorkflowTypeCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<ClinicWorkflowTypeCreateManyAppointmentTypeInputEnvelope>;
};

export type ClinicWorkflowTypeUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWorkflowTypeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicWorkflowTypeCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicWorkflowTypeCreateManyClinicInputEnvelope>;
};

export type ClinicWorkflowTypeUncheckedCreateWithoutAppointmentTypeInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType: WorkflowType;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUncheckedCreateWithoutClinicInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType: WorkflowType;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUncheckedUpdateInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType?: Maybe<WorkflowType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUncheckedUpdateManyInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType?: Maybe<WorkflowType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType?: Maybe<WorkflowType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUncheckedUpdateManyWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWorkflowTypeCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<ClinicWorkflowTypeCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<ClinicWorkflowTypeCreateManyAppointmentTypeInputEnvelope>;
  delete?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWorkflowTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWorkflowTypeUpdateWithWhereUniqueWithoutAppointmentTypeInput>>;
  updateMany?: Maybe<Array<ClinicWorkflowTypeUpdateManyWithWhereWithoutAppointmentTypeInput>>;
  upsert?: Maybe<Array<ClinicWorkflowTypeUpsertWithWhereUniqueWithoutAppointmentTypeInput>>;
};

export type ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType?: Maybe<WorkflowType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWorkflowTypeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicWorkflowTypeCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicWorkflowTypeCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWorkflowTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWorkflowTypeUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicWorkflowTypeUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicWorkflowTypeUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicWorkflowTypeUncheckedUpdateWithoutAppointmentTypeInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType?: Maybe<WorkflowType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUncheckedUpdateWithoutClinicInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType?: Maybe<WorkflowType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUpdateInput = {
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutClinicWorkflowTypesNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutClinicWorkflowTypesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType?: Maybe<WorkflowType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType?: Maybe<WorkflowType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUpdateManyWithWhereWithoutAppointmentTypeInput = {
  data: ClinicWorkflowTypeUpdateManyMutationInput;
  where: ClinicWorkflowTypeScalarWhereInput;
};

export type ClinicWorkflowTypeUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicWorkflowTypeUpdateManyMutationInput;
  where: ClinicWorkflowTypeScalarWhereInput;
};

export type ClinicWorkflowTypeUpdateManyWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWorkflowTypeCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<ClinicWorkflowTypeCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<ClinicWorkflowTypeCreateManyAppointmentTypeInputEnvelope>;
  delete?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWorkflowTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWorkflowTypeUpdateWithWhereUniqueWithoutAppointmentTypeInput>>;
  updateMany?: Maybe<Array<ClinicWorkflowTypeUpdateManyWithWhereWithoutAppointmentTypeInput>>;
  upsert?: Maybe<Array<ClinicWorkflowTypeUpsertWithWhereUniqueWithoutAppointmentTypeInput>>;
};

export type ClinicWorkflowTypeUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ClinicWorkflowTypeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ClinicWorkflowTypeCreateWithoutClinicInput>>;
  createMany?: Maybe<ClinicWorkflowTypeCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ClinicWorkflowTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWorkflowTypeWhereUniqueInput>>;
  update?: Maybe<Array<ClinicWorkflowTypeUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ClinicWorkflowTypeUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ClinicWorkflowTypeUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicWorkflowTypeUpdateWithWhereUniqueWithoutAppointmentTypeInput = {
  data: ClinicWorkflowTypeUpdateWithoutAppointmentTypeInput;
  where: ClinicWorkflowTypeWhereUniqueInput;
};

export type ClinicWorkflowTypeUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicWorkflowTypeUpdateWithoutClinicInput;
  where: ClinicWorkflowTypeWhereUniqueInput;
};

export type ClinicWorkflowTypeUpdateWithoutAppointmentTypeInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutClinicWorkflowTypesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType?: Maybe<WorkflowType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUpdateWithoutClinicInput = {
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutClinicWorkflowTypesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultWorkflowType?: Maybe<WorkflowType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClinicWorkflowTypeUpsertWithWhereUniqueWithoutAppointmentTypeInput = {
  create: ClinicWorkflowTypeCreateWithoutAppointmentTypeInput;
  update: ClinicWorkflowTypeUpdateWithoutAppointmentTypeInput;
  where: ClinicWorkflowTypeWhereUniqueInput;
};

export type ClinicWorkflowTypeUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicWorkflowTypeCreateWithoutClinicInput;
  update: ClinicWorkflowTypeUpdateWithoutClinicInput;
  where: ClinicWorkflowTypeWhereUniqueInput;
};

export type ClinicWorkflowTypeWhereInput = {
  AND?: Maybe<Array<ClinicWorkflowTypeWhereInput>>;
  NOT?: Maybe<Array<ClinicWorkflowTypeWhereInput>>;
  OR?: Maybe<Array<ClinicWorkflowTypeWhereInput>>;
  appoinmentTypeId?: Maybe<StringNullableFilter>;
  appointmentType?: Maybe<AppointmentTypeNullableScalarRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultWorkflowType?: Maybe<EnumWorkflowTypeFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ClinicWorkflowTypeWhereUniqueInput = {
  AND?: Maybe<Array<ClinicWorkflowTypeWhereInput>>;
  NOT?: Maybe<Array<ClinicWorkflowTypeWhereInput>>;
  OR?: Maybe<Array<ClinicWorkflowTypeWhereInput>>;
  appoinmentTypeId?: Maybe<StringNullableFilter>;
  appointmentType?: Maybe<AppointmentTypeNullableScalarRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultWorkflowType?: Maybe<EnumWorkflowTypeFilter>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Color = {
  __typename?: 'Color';
  _count: ColorCountOutputType;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  pets: Array<ClinicPet>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};


export type ColorPetsArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};

export type ColorCountAggregateOutputType = {
  __typename?: 'ColorCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  name: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ColorCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ColorCountOutputType = {
  __typename?: 'ColorCountOutputType';
  pets: Scalars['Int'];
};

export type ColorCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutColorsInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetCreateNestedManyWithoutColorModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorCreateManyIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorCreateManyIntegrationInputEnvelope = {
  data: Array<ColorCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ColorCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ColorWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ColorCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ColorCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ColorCreateManyIntegrationInputEnvelope>;
};

export type ColorCreateNestedOneWithoutPetsInput = {
  connect?: Maybe<ColorWhereUniqueInput>;
  connectOrCreate?: Maybe<ColorCreateOrConnectWithoutPetsInput>;
  create?: Maybe<ColorCreateWithoutPetsInput>;
};

export type ColorCreateOrConnectWithoutIntegrationInput = {
  create: ColorCreateWithoutIntegrationInput;
  where: ColorWhereUniqueInput;
};

export type ColorCreateOrConnectWithoutPetsInput = {
  create: ColorCreateWithoutPetsInput;
  where: ColorWhereUniqueInput;
};

export type ColorCreateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetCreateNestedManyWithoutColorModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorCreateWithoutPetsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutColorsInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorGroupByOutputType = {
  __typename?: 'ColorGroupByOutputType';
  _count?: Maybe<ColorCountAggregateOutputType>;
  _max?: Maybe<ColorMaxAggregateOutputType>;
  _min?: Maybe<ColorMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type ColorIntegrationIdPimsIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type ColorListRelationFilter = {
  every?: Maybe<ColorWhereInput>;
  none?: Maybe<ColorWhereInput>;
  some?: Maybe<ColorWhereInput>;
};

export type ColorMaxAggregateOutputType = {
  __typename?: 'ColorMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ColorMinAggregateOutputType = {
  __typename?: 'ColorMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ColorNullableScalarRelationFilter = {
  AND?: Maybe<Array<ColorWhereInput>>;
  NOT?: Maybe<Array<ColorWhereInput>>;
  OR?: Maybe<Array<ColorWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ColorOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ColorOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ColorOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ColorOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  IntegrationId = 'integrationId',
  Name = 'name',
  PimsId = 'pimsId'
}

export type ColorOrderByRelevanceInput = {
  fields: Array<ColorOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ColorOrderByWithAggregationInput = {
  _count?: Maybe<ColorCountOrderByAggregateInput>;
  _max?: Maybe<ColorMaxOrderByAggregateInput>;
  _min?: Maybe<ColorMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ColorOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ColorOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ColorOrderByWithRelationInput = {
  _relevance?: Maybe<ColorOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ColorScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Name = 'name',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  UpdatedAt = 'updatedAt'
}

export type ColorScalarWhereInput = {
  AND?: Maybe<Array<ColorScalarWhereInput>>;
  NOT?: Maybe<Array<ColorScalarWhereInput>>;
  OR?: Maybe<Array<ColorScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ColorScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ColorScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ColorScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ColorScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ColorUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutColorModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ColorWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ColorCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ColorCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ColorCreateManyIntegrationInputEnvelope>;
};

export type ColorUncheckedCreateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutColorModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorUncheckedCreateWithoutPetsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutColorModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorUncheckedUpdateManyWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ColorWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ColorCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ColorCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ColorCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ColorWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ColorScalarWhereInput>>;
  disconnect?: Maybe<Array<ColorWhereUniqueInput>>;
  set?: Maybe<Array<ColorWhereUniqueInput>>;
  update?: Maybe<Array<ColorUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ColorUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ColorUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ColorUncheckedUpdateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutColorModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorUncheckedUpdateWithoutPetsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutColorsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutColorModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorUpdateManyWithWhereWithoutIntegrationInput = {
  data: ColorUpdateManyMutationInput;
  where: ColorScalarWhereInput;
};

export type ColorUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ColorWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ColorCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ColorCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ColorCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ColorWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ColorScalarWhereInput>>;
  disconnect?: Maybe<Array<ColorWhereUniqueInput>>;
  set?: Maybe<Array<ColorWhereUniqueInput>>;
  update?: Maybe<Array<ColorUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ColorUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ColorUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ColorUpdateOneWithoutPetsNestedInput = {
  connect?: Maybe<ColorWhereUniqueInput>;
  connectOrCreate?: Maybe<ColorCreateOrConnectWithoutPetsInput>;
  create?: Maybe<ColorCreateWithoutPetsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ColorUpdateToOneWithWhereWithoutPetsInput>;
  upsert?: Maybe<ColorUpsertWithoutPetsInput>;
};

export type ColorUpdateToOneWithWhereWithoutPetsInput = {
  data: ColorUpdateWithoutPetsInput;
  where?: Maybe<ColorWhereInput>;
};

export type ColorUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: ColorUpdateWithoutIntegrationInput;
  where: ColorWhereUniqueInput;
};

export type ColorUpdateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutColorModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorUpdateWithoutPetsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutColorsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ColorUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: ColorCreateWithoutIntegrationInput;
  update: ColorUpdateWithoutIntegrationInput;
  where: ColorWhereUniqueInput;
};

export type ColorUpsertWithoutPetsInput = {
  create: ColorCreateWithoutPetsInput;
  update: ColorUpdateWithoutPetsInput;
  where?: Maybe<ColorWhereInput>;
};

export type ColorWhereInput = {
  AND?: Maybe<Array<ColorWhereInput>>;
  NOT?: Maybe<Array<ColorWhereInput>>;
  OR?: Maybe<Array<ColorWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ColorWhereUniqueInput = {
  AND?: Maybe<Array<ColorWhereInput>>;
  NOT?: Maybe<Array<ColorWhereInput>>;
  OR?: Maybe<Array<ColorWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  integrationId_pimsId?: Maybe<ColorIntegrationIdPimsIdCompoundUniqueInput>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Condition = {
  __typename?: 'Condition';
  attribute: ConditionAttribute;
  checksum: Scalars['String'];
  conditionSetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  operand: Scalars['Json'];
  operator: ConditionOperator;
  set: ConditionSet;
  updatedAt: Scalars['DateTime'];
};

export enum ConditionAttribute {
  AppointmentTypeId = 'AppointmentTypeId',
  CareCreditPreapprovalDecision = 'CareCreditPreapprovalDecision',
  CareMembershipStatus = 'CareMembershipStatus',
  ClinicEmployeeId = 'ClinicEmployeeId',
  ClinicRoomId = 'ClinicRoomId',
  PetAgeInYears = 'PetAgeInYears',
  PetDateOfBirth = 'PetDateOfBirth',
  SpeciesType = 'SpeciesType',
  TrupanionCertificateAvailability = 'TrupanionCertificateAvailability'
}

export type ConditionCountAggregateOutputType = {
  __typename?: 'ConditionCountAggregateOutputType';
  _all: Scalars['Int'];
  attribute: Scalars['Int'];
  checksum: Scalars['Int'];
  conditionSetId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  operand: Scalars['Int'];
  operator: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ConditionCountOrderByAggregateInput = {
  attribute?: Maybe<SortOrder>;
  checksum?: Maybe<SortOrder>;
  conditionSetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  operand?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConditionCreateInput = {
  attribute: ConditionAttribute;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand: Scalars['Json'];
  operator: ConditionOperator;
  set: ConditionSetCreateNestedOneWithoutConditionsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionCreateManyInput = {
  attribute: ConditionAttribute;
  checksum: Scalars['String'];
  conditionSetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand: Scalars['Json'];
  operator: ConditionOperator;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionCreateManySetInput = {
  attribute: ConditionAttribute;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand: Scalars['Json'];
  operator: ConditionOperator;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionCreateManySetInputEnvelope = {
  data: Array<ConditionCreateManySetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ConditionCreateNestedManyWithoutSetInput = {
  connect?: Maybe<Array<ConditionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConditionCreateOrConnectWithoutSetInput>>;
  create?: Maybe<Array<ConditionCreateWithoutSetInput>>;
  createMany?: Maybe<ConditionCreateManySetInputEnvelope>;
};

export type ConditionCreateOrConnectWithoutSetInput = {
  create: ConditionCreateWithoutSetInput;
  where: ConditionWhereUniqueInput;
};

export type ConditionCreateWithoutSetInput = {
  attribute: ConditionAttribute;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand: Scalars['Json'];
  operator: ConditionOperator;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum ConditionEvaluationStatus {
  Evaluate = 'Evaluate',
  Ignore = 'Ignore'
}

export type ConditionGroupByOutputType = {
  __typename?: 'ConditionGroupByOutputType';
  _count?: Maybe<ConditionCountAggregateOutputType>;
  _max?: Maybe<ConditionMaxAggregateOutputType>;
  _min?: Maybe<ConditionMinAggregateOutputType>;
  attribute: ConditionAttribute;
  checksum: Scalars['String'];
  conditionSetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  operand: Scalars['Json'];
  operator: ConditionOperator;
  updatedAt: Scalars['DateTime'];
};

export type ConditionListRelationFilter = {
  every?: Maybe<ConditionWhereInput>;
  none?: Maybe<ConditionWhereInput>;
  some?: Maybe<ConditionWhereInput>;
};

export type ConditionMaxAggregateOutputType = {
  __typename?: 'ConditionMaxAggregateOutputType';
  attribute?: Maybe<ConditionAttribute>;
  checksum?: Maybe<Scalars['String']>;
  conditionSetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operator?: Maybe<ConditionOperator>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionMaxOrderByAggregateInput = {
  attribute?: Maybe<SortOrder>;
  checksum?: Maybe<SortOrder>;
  conditionSetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConditionMinAggregateOutputType = {
  __typename?: 'ConditionMinAggregateOutputType';
  attribute?: Maybe<ConditionAttribute>;
  checksum?: Maybe<Scalars['String']>;
  conditionSetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operator?: Maybe<ConditionOperator>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionMinOrderByAggregateInput = {
  attribute?: Maybe<SortOrder>;
  checksum?: Maybe<SortOrder>;
  conditionSetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ConditionOperator {
  Between = 'BETWEEN',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN',
  StartsWith = 'STARTS_WITH'
}

export type ConditionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ConditionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ConditionOrderByRelevanceInput>;
  attribute?: Maybe<SortOrder>;
  checksum?: Maybe<SortOrder>;
  conditionSetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  operand?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  set?: Maybe<ConditionSetOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ConditionOrderByRelevanceFieldEnum {
  Checksum = 'checksum',
  ConditionSetId = 'conditionSetId',
  Id = 'id'
}

export type ConditionOrderByRelevanceInput = {
  fields: Array<ConditionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ConditionOrderByWithAggregationInput = {
  _count?: Maybe<ConditionCountOrderByAggregateInput>;
  _max?: Maybe<ConditionMaxOrderByAggregateInput>;
  _min?: Maybe<ConditionMinOrderByAggregateInput>;
  attribute?: Maybe<SortOrder>;
  checksum?: Maybe<SortOrder>;
  conditionSetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  operand?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConditionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ConditionOrderByRelevanceInput>;
  attribute?: Maybe<SortOrder>;
  checksum?: Maybe<SortOrder>;
  conditionSetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  operand?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  set?: Maybe<ConditionSetOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConditionOrderByWithRelationInput = {
  _relevance?: Maybe<ConditionOrderByRelevanceInput>;
  attribute?: Maybe<SortOrder>;
  checksum?: Maybe<SortOrder>;
  conditionSetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  operand?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  set?: Maybe<ConditionSetOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ConditionScalarFieldEnum {
  Attribute = 'attribute',
  Checksum = 'checksum',
  ConditionSetId = 'conditionSetId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Operand = 'operand',
  Operator = 'operator',
  UpdatedAt = 'updatedAt'
}

export type ConditionScalarWhereInput = {
  AND?: Maybe<Array<ConditionScalarWhereInput>>;
  NOT?: Maybe<Array<ConditionScalarWhereInput>>;
  OR?: Maybe<Array<ConditionScalarWhereInput>>;
  attribute?: Maybe<EnumConditionAttributeFilter>;
  checksum?: Maybe<StringFilter>;
  conditionSetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  operand?: Maybe<JsonFilter>;
  operator?: Maybe<EnumConditionOperatorFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ConditionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ConditionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ConditionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ConditionScalarWhereWithAggregatesInput>>;
  attribute?: Maybe<EnumConditionAttributeWithAggregatesFilter>;
  checksum?: Maybe<StringWithAggregatesFilter>;
  conditionSetId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  operand?: Maybe<JsonWithAggregatesFilter>;
  operator?: Maybe<EnumConditionOperatorWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ConditionSet = {
  __typename?: 'ConditionSet';
  _count: ConditionSetCountOutputType;
  children: Array<ConditionSet>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  conditions: Array<Condition>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  negate: Scalars['Boolean'];
  operator: ConditionSetOperator;
  parent?: Maybe<ConditionSet>;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type ConditionSetChildrenArgs = {
  cursor?: Maybe<ConditionSetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConditionSetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConditionSetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionSetWhereInput>;
};


export type ConditionSetConditionsArgs = {
  cursor?: Maybe<ConditionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConditionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConditionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionWhereInput>;
};


export type ConditionSetParentArgs = {
  where?: Maybe<ConditionSetWhereInput>;
};

export type ConditionSetCountAggregateOutputType = {
  __typename?: 'ConditionSetCountAggregateOutputType';
  _all: Scalars['Int'];
  conditionalEntityId: Scalars['Int'];
  conditionalEntityType: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  negate: Scalars['Int'];
  operator: Scalars['Int'];
  parentConditionSetId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ConditionSetCountOrderByAggregateInput = {
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  negate?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  parentConditionSetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConditionSetCountOutputType = {
  __typename?: 'ConditionSetCountOutputType';
  children: Scalars['Int'];
  conditions: Scalars['Int'];
};

export type ConditionSetCreateInput = {
  children?: Maybe<ConditionSetCreateNestedManyWithoutParentInput>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  conditions?: Maybe<ConditionCreateNestedManyWithoutSetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator: ConditionSetOperator;
  parent?: Maybe<ConditionSetCreateNestedOneWithoutChildrenInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetCreateManyInput = {
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator: ConditionSetOperator;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetCreateManyParentInput = {
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator: ConditionSetOperator;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetCreateManyParentInputEnvelope = {
  data: Array<ConditionSetCreateManyParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ConditionSetCreateNestedManyWithoutParentInput = {
  connect?: Maybe<Array<ConditionSetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConditionSetCreateOrConnectWithoutParentInput>>;
  create?: Maybe<Array<ConditionSetCreateWithoutParentInput>>;
  createMany?: Maybe<ConditionSetCreateManyParentInputEnvelope>;
};

export type ConditionSetCreateNestedOneWithoutChildrenInput = {
  connect?: Maybe<ConditionSetWhereUniqueInput>;
  connectOrCreate?: Maybe<ConditionSetCreateOrConnectWithoutChildrenInput>;
  create?: Maybe<ConditionSetCreateWithoutChildrenInput>;
};

export type ConditionSetCreateNestedOneWithoutConditionsInput = {
  connect?: Maybe<ConditionSetWhereUniqueInput>;
  connectOrCreate?: Maybe<ConditionSetCreateOrConnectWithoutConditionsInput>;
  create?: Maybe<ConditionSetCreateWithoutConditionsInput>;
};

export type ConditionSetCreateOrConnectWithoutChildrenInput = {
  create: ConditionSetCreateWithoutChildrenInput;
  where: ConditionSetWhereUniqueInput;
};

export type ConditionSetCreateOrConnectWithoutConditionsInput = {
  create: ConditionSetCreateWithoutConditionsInput;
  where: ConditionSetWhereUniqueInput;
};

export type ConditionSetCreateOrConnectWithoutParentInput = {
  create: ConditionSetCreateWithoutParentInput;
  where: ConditionSetWhereUniqueInput;
};

export type ConditionSetCreateWithoutChildrenInput = {
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  conditions?: Maybe<ConditionCreateNestedManyWithoutSetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator: ConditionSetOperator;
  parent?: Maybe<ConditionSetCreateNestedOneWithoutChildrenInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetCreateWithoutConditionsInput = {
  children?: Maybe<ConditionSetCreateNestedManyWithoutParentInput>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator: ConditionSetOperator;
  parent?: Maybe<ConditionSetCreateNestedOneWithoutChildrenInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetCreateWithoutParentInput = {
  children?: Maybe<ConditionSetCreateNestedManyWithoutParentInput>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  conditions?: Maybe<ConditionCreateNestedManyWithoutSetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator: ConditionSetOperator;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetGroupByOutputType = {
  __typename?: 'ConditionSetGroupByOutputType';
  _count?: Maybe<ConditionSetCountAggregateOutputType>;
  _max?: Maybe<ConditionSetMaxAggregateOutputType>;
  _min?: Maybe<ConditionSetMinAggregateOutputType>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  negate: Scalars['Boolean'];
  operator: ConditionSetOperator;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ConditionSetListRelationFilter = {
  every?: Maybe<ConditionSetWhereInput>;
  none?: Maybe<ConditionSetWhereInput>;
  some?: Maybe<ConditionSetWhereInput>;
};

export type ConditionSetMaxAggregateOutputType = {
  __typename?: 'ConditionSetMaxAggregateOutputType';
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetMaxOrderByAggregateInput = {
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  negate?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  parentConditionSetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConditionSetMinAggregateOutputType = {
  __typename?: 'ConditionSetMinAggregateOutputType';
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetMinOrderByAggregateInput = {
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  negate?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  parentConditionSetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConditionSetNullableScalarRelationFilter = {
  AND?: Maybe<Array<ConditionSetWhereInput>>;
  NOT?: Maybe<Array<ConditionSetWhereInput>>;
  OR?: Maybe<Array<ConditionSetWhereInput>>;
  children?: Maybe<ConditionSetListRelationFilter>;
  conditionalEntityId?: Maybe<StringFilter>;
  conditionalEntityType?: Maybe<EnumConditionalEntityTypeFilter>;
  conditions?: Maybe<ConditionListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  negate?: Maybe<BoolFilter>;
  operator?: Maybe<EnumConditionSetOperatorFilter>;
  parent?: Maybe<ConditionSetNullableScalarRelationFilter>;
  parentConditionSetId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum ConditionSetOperator {
  And = 'AND',
  Or = 'OR'
}

export type ConditionSetOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ConditionSetOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ConditionSetOrderByRelevanceInput>;
  children?: Maybe<ConditionSetOrderByRelationAggregateInput>;
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  conditions?: Maybe<ConditionOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  negate?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  parent?: Maybe<ConditionSetOrderByWithRelationInput>;
  parentConditionSetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ConditionSetOrderByRelevanceFieldEnum {
  ConditionalEntityId = 'conditionalEntityId',
  Id = 'id',
  ParentConditionSetId = 'parentConditionSetId'
}

export type ConditionSetOrderByRelevanceInput = {
  fields: Array<ConditionSetOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ConditionSetOrderByWithAggregationInput = {
  _count?: Maybe<ConditionSetCountOrderByAggregateInput>;
  _max?: Maybe<ConditionSetMaxOrderByAggregateInput>;
  _min?: Maybe<ConditionSetMinOrderByAggregateInput>;
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  negate?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  parentConditionSetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConditionSetOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ConditionSetOrderByRelevanceInput>;
  children?: Maybe<ConditionSetOrderByRelationAggregateInput>;
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  conditions?: Maybe<ConditionOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  negate?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  parent?: Maybe<ConditionSetOrderByWithRelationInput>;
  parentConditionSetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConditionSetOrderByWithRelationInput = {
  _relevance?: Maybe<ConditionSetOrderByRelevanceInput>;
  children?: Maybe<ConditionSetOrderByRelationAggregateInput>;
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  conditions?: Maybe<ConditionOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  negate?: Maybe<SortOrder>;
  operator?: Maybe<SortOrder>;
  parent?: Maybe<ConditionSetOrderByWithRelationInput>;
  parentConditionSetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ConditionSetScalarFieldEnum {
  ConditionalEntityId = 'conditionalEntityId',
  ConditionalEntityType = 'conditionalEntityType',
  CreatedAt = 'createdAt',
  Id = 'id',
  Negate = 'negate',
  Operator = 'operator',
  ParentConditionSetId = 'parentConditionSetId',
  UpdatedAt = 'updatedAt'
}

export type ConditionSetScalarRelationFilter = {
  AND?: Maybe<Array<ConditionSetWhereInput>>;
  NOT?: Maybe<Array<ConditionSetWhereInput>>;
  OR?: Maybe<Array<ConditionSetWhereInput>>;
  children?: Maybe<ConditionSetListRelationFilter>;
  conditionalEntityId?: Maybe<StringFilter>;
  conditionalEntityType?: Maybe<EnumConditionalEntityTypeFilter>;
  conditions?: Maybe<ConditionListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  negate?: Maybe<BoolFilter>;
  operator?: Maybe<EnumConditionSetOperatorFilter>;
  parent?: Maybe<ConditionSetNullableScalarRelationFilter>;
  parentConditionSetId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ConditionSetScalarWhereInput = {
  AND?: Maybe<Array<ConditionSetScalarWhereInput>>;
  NOT?: Maybe<Array<ConditionSetScalarWhereInput>>;
  OR?: Maybe<Array<ConditionSetScalarWhereInput>>;
  conditionalEntityId?: Maybe<StringFilter>;
  conditionalEntityType?: Maybe<EnumConditionalEntityTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  negate?: Maybe<BoolFilter>;
  operator?: Maybe<EnumConditionSetOperatorFilter>;
  parentConditionSetId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ConditionSetScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ConditionSetScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ConditionSetScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ConditionSetScalarWhereWithAggregatesInput>>;
  conditionalEntityId?: Maybe<StringWithAggregatesFilter>;
  conditionalEntityType?: Maybe<EnumConditionalEntityTypeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  negate?: Maybe<BoolWithAggregatesFilter>;
  operator?: Maybe<EnumConditionSetOperatorWithAggregatesFilter>;
  parentConditionSetId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ConditionSetUncheckedCreateInput = {
  children?: Maybe<ConditionSetUncheckedCreateNestedManyWithoutParentInput>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  conditions?: Maybe<ConditionUncheckedCreateNestedManyWithoutSetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator: ConditionSetOperator;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUncheckedCreateNestedManyWithoutParentInput = {
  connect?: Maybe<Array<ConditionSetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConditionSetCreateOrConnectWithoutParentInput>>;
  create?: Maybe<Array<ConditionSetCreateWithoutParentInput>>;
  createMany?: Maybe<ConditionSetCreateManyParentInputEnvelope>;
};

export type ConditionSetUncheckedCreateWithoutChildrenInput = {
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  conditions?: Maybe<ConditionUncheckedCreateNestedManyWithoutSetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator: ConditionSetOperator;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUncheckedCreateWithoutConditionsInput = {
  children?: Maybe<ConditionSetUncheckedCreateNestedManyWithoutParentInput>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator: ConditionSetOperator;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUncheckedCreateWithoutParentInput = {
  children?: Maybe<ConditionSetUncheckedCreateNestedManyWithoutParentInput>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  conditions?: Maybe<ConditionUncheckedCreateNestedManyWithoutSetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator: ConditionSetOperator;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUncheckedUpdateInput = {
  children?: Maybe<ConditionSetUncheckedUpdateManyWithoutParentNestedInput>;
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  conditions?: Maybe<ConditionUncheckedUpdateManyWithoutSetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUncheckedUpdateManyInput = {
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUncheckedUpdateManyWithoutParentInput = {
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUncheckedUpdateManyWithoutParentNestedInput = {
  connect?: Maybe<Array<ConditionSetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConditionSetCreateOrConnectWithoutParentInput>>;
  create?: Maybe<Array<ConditionSetCreateWithoutParentInput>>;
  createMany?: Maybe<ConditionSetCreateManyParentInputEnvelope>;
  delete?: Maybe<Array<ConditionSetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConditionSetScalarWhereInput>>;
  disconnect?: Maybe<Array<ConditionSetWhereUniqueInput>>;
  set?: Maybe<Array<ConditionSetWhereUniqueInput>>;
  update?: Maybe<Array<ConditionSetUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: Maybe<Array<ConditionSetUpdateManyWithWhereWithoutParentInput>>;
  upsert?: Maybe<Array<ConditionSetUpsertWithWhereUniqueWithoutParentInput>>;
};

export type ConditionSetUncheckedUpdateWithoutChildrenInput = {
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  conditions?: Maybe<ConditionUncheckedUpdateManyWithoutSetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUncheckedUpdateWithoutConditionsInput = {
  children?: Maybe<ConditionSetUncheckedUpdateManyWithoutParentNestedInput>;
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUncheckedUpdateWithoutParentInput = {
  children?: Maybe<ConditionSetUncheckedUpdateManyWithoutParentNestedInput>;
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  conditions?: Maybe<ConditionUncheckedUpdateManyWithoutSetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUpdateInput = {
  children?: Maybe<ConditionSetUpdateManyWithoutParentNestedInput>;
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  conditions?: Maybe<ConditionUpdateManyWithoutSetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  parent?: Maybe<ConditionSetUpdateOneWithoutChildrenNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUpdateManyMutationInput = {
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUpdateManyWithWhereWithoutParentInput = {
  data: ConditionSetUpdateManyMutationInput;
  where: ConditionSetScalarWhereInput;
};

export type ConditionSetUpdateManyWithoutParentNestedInput = {
  connect?: Maybe<Array<ConditionSetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConditionSetCreateOrConnectWithoutParentInput>>;
  create?: Maybe<Array<ConditionSetCreateWithoutParentInput>>;
  createMany?: Maybe<ConditionSetCreateManyParentInputEnvelope>;
  delete?: Maybe<Array<ConditionSetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConditionSetScalarWhereInput>>;
  disconnect?: Maybe<Array<ConditionSetWhereUniqueInput>>;
  set?: Maybe<Array<ConditionSetWhereUniqueInput>>;
  update?: Maybe<Array<ConditionSetUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: Maybe<Array<ConditionSetUpdateManyWithWhereWithoutParentInput>>;
  upsert?: Maybe<Array<ConditionSetUpsertWithWhereUniqueWithoutParentInput>>;
};

export type ConditionSetUpdateOneRequiredWithoutConditionsNestedInput = {
  connect?: Maybe<ConditionSetWhereUniqueInput>;
  connectOrCreate?: Maybe<ConditionSetCreateOrConnectWithoutConditionsInput>;
  create?: Maybe<ConditionSetCreateWithoutConditionsInput>;
  update?: Maybe<ConditionSetUpdateToOneWithWhereWithoutConditionsInput>;
  upsert?: Maybe<ConditionSetUpsertWithoutConditionsInput>;
};

export type ConditionSetUpdateOneWithoutChildrenNestedInput = {
  connect?: Maybe<ConditionSetWhereUniqueInput>;
  connectOrCreate?: Maybe<ConditionSetCreateOrConnectWithoutChildrenInput>;
  create?: Maybe<ConditionSetCreateWithoutChildrenInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ConditionSetUpdateToOneWithWhereWithoutChildrenInput>;
  upsert?: Maybe<ConditionSetUpsertWithoutChildrenInput>;
};

export type ConditionSetUpdateToOneWithWhereWithoutChildrenInput = {
  data: ConditionSetUpdateWithoutChildrenInput;
  where?: Maybe<ConditionSetWhereInput>;
};

export type ConditionSetUpdateToOneWithWhereWithoutConditionsInput = {
  data: ConditionSetUpdateWithoutConditionsInput;
  where?: Maybe<ConditionSetWhereInput>;
};

export type ConditionSetUpdateWithWhereUniqueWithoutParentInput = {
  data: ConditionSetUpdateWithoutParentInput;
  where: ConditionSetWhereUniqueInput;
};

export type ConditionSetUpdateWithoutChildrenInput = {
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  conditions?: Maybe<ConditionUpdateManyWithoutSetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  parent?: Maybe<ConditionSetUpdateOneWithoutChildrenNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUpdateWithoutConditionsInput = {
  children?: Maybe<ConditionSetUpdateManyWithoutParentNestedInput>;
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  parent?: Maybe<ConditionSetUpdateOneWithoutChildrenNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUpdateWithoutParentInput = {
  children?: Maybe<ConditionSetUpdateManyWithoutParentNestedInput>;
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  conditions?: Maybe<ConditionUpdateManyWithoutSetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<ConditionSetOperator>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionSetUpsertWithWhereUniqueWithoutParentInput = {
  create: ConditionSetCreateWithoutParentInput;
  update: ConditionSetUpdateWithoutParentInput;
  where: ConditionSetWhereUniqueInput;
};

export type ConditionSetUpsertWithoutChildrenInput = {
  create: ConditionSetCreateWithoutChildrenInput;
  update: ConditionSetUpdateWithoutChildrenInput;
  where?: Maybe<ConditionSetWhereInput>;
};

export type ConditionSetUpsertWithoutConditionsInput = {
  create: ConditionSetCreateWithoutConditionsInput;
  update: ConditionSetUpdateWithoutConditionsInput;
  where?: Maybe<ConditionSetWhereInput>;
};

export type ConditionSetWhereInput = {
  AND?: Maybe<Array<ConditionSetWhereInput>>;
  NOT?: Maybe<Array<ConditionSetWhereInput>>;
  OR?: Maybe<Array<ConditionSetWhereInput>>;
  children?: Maybe<ConditionSetListRelationFilter>;
  conditionalEntityId?: Maybe<StringFilter>;
  conditionalEntityType?: Maybe<EnumConditionalEntityTypeFilter>;
  conditions?: Maybe<ConditionListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  negate?: Maybe<BoolFilter>;
  operator?: Maybe<EnumConditionSetOperatorFilter>;
  parent?: Maybe<ConditionSetNullableScalarRelationFilter>;
  parentConditionSetId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ConditionSetWhereUniqueInput = {
  AND?: Maybe<Array<ConditionSetWhereInput>>;
  NOT?: Maybe<Array<ConditionSetWhereInput>>;
  OR?: Maybe<Array<ConditionSetWhereInput>>;
  children?: Maybe<ConditionSetListRelationFilter>;
  conditionalEntityId?: Maybe<StringFilter>;
  conditionalEntityType?: Maybe<EnumConditionalEntityTypeFilter>;
  conditions?: Maybe<ConditionListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  negate?: Maybe<BoolFilter>;
  operator?: Maybe<EnumConditionSetOperatorFilter>;
  parent?: Maybe<ConditionSetNullableScalarRelationFilter>;
  parentConditionSetId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ConditionUncheckedCreateInput = {
  attribute: ConditionAttribute;
  checksum: Scalars['String'];
  conditionSetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand: Scalars['Json'];
  operator: ConditionOperator;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionUncheckedCreateNestedManyWithoutSetInput = {
  connect?: Maybe<Array<ConditionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConditionCreateOrConnectWithoutSetInput>>;
  create?: Maybe<Array<ConditionCreateWithoutSetInput>>;
  createMany?: Maybe<ConditionCreateManySetInputEnvelope>;
};

export type ConditionUncheckedCreateWithoutSetInput = {
  attribute: ConditionAttribute;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand: Scalars['Json'];
  operator: ConditionOperator;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionUncheckedUpdateInput = {
  attribute?: Maybe<ConditionAttribute>;
  checksum?: Maybe<Scalars['String']>;
  conditionSetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand?: Maybe<Scalars['Json']>;
  operator?: Maybe<ConditionOperator>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionUncheckedUpdateManyInput = {
  attribute?: Maybe<ConditionAttribute>;
  checksum?: Maybe<Scalars['String']>;
  conditionSetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand?: Maybe<Scalars['Json']>;
  operator?: Maybe<ConditionOperator>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionUncheckedUpdateManyWithoutSetInput = {
  attribute?: Maybe<ConditionAttribute>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand?: Maybe<Scalars['Json']>;
  operator?: Maybe<ConditionOperator>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionUncheckedUpdateManyWithoutSetNestedInput = {
  connect?: Maybe<Array<ConditionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConditionCreateOrConnectWithoutSetInput>>;
  create?: Maybe<Array<ConditionCreateWithoutSetInput>>;
  createMany?: Maybe<ConditionCreateManySetInputEnvelope>;
  delete?: Maybe<Array<ConditionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConditionScalarWhereInput>>;
  disconnect?: Maybe<Array<ConditionWhereUniqueInput>>;
  set?: Maybe<Array<ConditionWhereUniqueInput>>;
  update?: Maybe<Array<ConditionUpdateWithWhereUniqueWithoutSetInput>>;
  updateMany?: Maybe<Array<ConditionUpdateManyWithWhereWithoutSetInput>>;
  upsert?: Maybe<Array<ConditionUpsertWithWhereUniqueWithoutSetInput>>;
};

export type ConditionUncheckedUpdateWithoutSetInput = {
  attribute?: Maybe<ConditionAttribute>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand?: Maybe<Scalars['Json']>;
  operator?: Maybe<ConditionOperator>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionUpdateInput = {
  attribute?: Maybe<ConditionAttribute>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand?: Maybe<Scalars['Json']>;
  operator?: Maybe<ConditionOperator>;
  set?: Maybe<ConditionSetUpdateOneRequiredWithoutConditionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionUpdateManyMutationInput = {
  attribute?: Maybe<ConditionAttribute>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand?: Maybe<Scalars['Json']>;
  operator?: Maybe<ConditionOperator>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionUpdateManyWithWhereWithoutSetInput = {
  data: ConditionUpdateManyMutationInput;
  where: ConditionScalarWhereInput;
};

export type ConditionUpdateManyWithoutSetNestedInput = {
  connect?: Maybe<Array<ConditionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConditionCreateOrConnectWithoutSetInput>>;
  create?: Maybe<Array<ConditionCreateWithoutSetInput>>;
  createMany?: Maybe<ConditionCreateManySetInputEnvelope>;
  delete?: Maybe<Array<ConditionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConditionScalarWhereInput>>;
  disconnect?: Maybe<Array<ConditionWhereUniqueInput>>;
  set?: Maybe<Array<ConditionWhereUniqueInput>>;
  update?: Maybe<Array<ConditionUpdateWithWhereUniqueWithoutSetInput>>;
  updateMany?: Maybe<Array<ConditionUpdateManyWithWhereWithoutSetInput>>;
  upsert?: Maybe<Array<ConditionUpsertWithWhereUniqueWithoutSetInput>>;
};

export type ConditionUpdateWithWhereUniqueWithoutSetInput = {
  data: ConditionUpdateWithoutSetInput;
  where: ConditionWhereUniqueInput;
};

export type ConditionUpdateWithoutSetInput = {
  attribute?: Maybe<ConditionAttribute>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  operand?: Maybe<Scalars['Json']>;
  operator?: Maybe<ConditionOperator>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConditionUpsertWithWhereUniqueWithoutSetInput = {
  create: ConditionCreateWithoutSetInput;
  update: ConditionUpdateWithoutSetInput;
  where: ConditionWhereUniqueInput;
};

export type ConditionWhereInput = {
  AND?: Maybe<Array<ConditionWhereInput>>;
  NOT?: Maybe<Array<ConditionWhereInput>>;
  OR?: Maybe<Array<ConditionWhereInput>>;
  attribute?: Maybe<EnumConditionAttributeFilter>;
  checksum?: Maybe<StringFilter>;
  conditionSetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  operand?: Maybe<JsonFilter>;
  operator?: Maybe<EnumConditionOperatorFilter>;
  set?: Maybe<ConditionSetScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ConditionWhereUniqueInput = {
  AND?: Maybe<Array<ConditionWhereInput>>;
  NOT?: Maybe<Array<ConditionWhereInput>>;
  OR?: Maybe<Array<ConditionWhereInput>>;
  attribute?: Maybe<EnumConditionAttributeFilter>;
  checksum?: Maybe<StringFilter>;
  conditionSetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  operand?: Maybe<JsonFilter>;
  operator?: Maybe<EnumConditionOperatorFilter>;
  set?: Maybe<ConditionSetScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ConditionalEntityEvaluation = {
  __typename?: 'ConditionalEntityEvaluation';
  audit?: Maybe<Scalars['Json']>;
  conditionalEntityChecksum?: Maybe<Scalars['String']>;
  /** The pirmary key (CUID) of the entity whose ConditionSet(s) were evaluated */
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  context?: Maybe<Scalars['Json']>;
  contextEntityChecksum?: Maybe<Scalars['String']>;
  /** The primary key (CUID) of the entity whose derived context was evaluated against the ConditionalEntity */
  contextEntityId: Scalars['String'];
  contextEntityType: ContextEntityType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  result: Scalars['Boolean'];
};

export type ConditionalEntityEvaluationCountAggregateOutputType = {
  __typename?: 'ConditionalEntityEvaluationCountAggregateOutputType';
  _all: Scalars['Int'];
  audit: Scalars['Int'];
  conditionalEntityChecksum: Scalars['Int'];
  conditionalEntityId: Scalars['Int'];
  conditionalEntityType: Scalars['Int'];
  context: Scalars['Int'];
  contextEntityChecksum: Scalars['Int'];
  contextEntityId: Scalars['Int'];
  contextEntityType: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  result: Scalars['Int'];
};

export type ConditionalEntityEvaluationCountOrderByAggregateInput = {
  audit?: Maybe<SortOrder>;
  conditionalEntityChecksum?: Maybe<SortOrder>;
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  context?: Maybe<SortOrder>;
  contextEntityChecksum?: Maybe<SortOrder>;
  contextEntityId?: Maybe<SortOrder>;
  contextEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
};

export type ConditionalEntityEvaluationCreateInput = {
  audit?: Maybe<Scalars['Json']>;
  conditionalEntityChecksum?: Maybe<Scalars['String']>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  context?: Maybe<Scalars['Json']>;
  contextEntityChecksum?: Maybe<Scalars['String']>;
  contextEntityId: Scalars['String'];
  contextEntityType: ContextEntityType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ConditionalEntityEvaluationCreateManyInput = {
  audit?: Maybe<Scalars['Json']>;
  conditionalEntityChecksum?: Maybe<Scalars['String']>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  context?: Maybe<Scalars['Json']>;
  contextEntityChecksum?: Maybe<Scalars['String']>;
  contextEntityId: Scalars['String'];
  contextEntityType: ContextEntityType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ConditionalEntityEvaluationGroupByOutputType = {
  __typename?: 'ConditionalEntityEvaluationGroupByOutputType';
  _count?: Maybe<ConditionalEntityEvaluationCountAggregateOutputType>;
  _max?: Maybe<ConditionalEntityEvaluationMaxAggregateOutputType>;
  _min?: Maybe<ConditionalEntityEvaluationMinAggregateOutputType>;
  audit?: Maybe<Scalars['Json']>;
  conditionalEntityChecksum?: Maybe<Scalars['String']>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  context?: Maybe<Scalars['Json']>;
  contextEntityChecksum?: Maybe<Scalars['String']>;
  contextEntityId: Scalars['String'];
  contextEntityType: ContextEntityType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  result: Scalars['Boolean'];
};

export type ConditionalEntityEvaluationMaxAggregateOutputType = {
  __typename?: 'ConditionalEntityEvaluationMaxAggregateOutputType';
  conditionalEntityChecksum?: Maybe<Scalars['String']>;
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  contextEntityChecksum?: Maybe<Scalars['String']>;
  contextEntityId?: Maybe<Scalars['String']>;
  contextEntityType?: Maybe<ContextEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

export type ConditionalEntityEvaluationMaxOrderByAggregateInput = {
  conditionalEntityChecksum?: Maybe<SortOrder>;
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  contextEntityChecksum?: Maybe<SortOrder>;
  contextEntityId?: Maybe<SortOrder>;
  contextEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
};

export type ConditionalEntityEvaluationMinAggregateOutputType = {
  __typename?: 'ConditionalEntityEvaluationMinAggregateOutputType';
  conditionalEntityChecksum?: Maybe<Scalars['String']>;
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  contextEntityChecksum?: Maybe<Scalars['String']>;
  contextEntityId?: Maybe<Scalars['String']>;
  contextEntityType?: Maybe<ContextEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

export type ConditionalEntityEvaluationMinOrderByAggregateInput = {
  conditionalEntityChecksum?: Maybe<SortOrder>;
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  contextEntityChecksum?: Maybe<SortOrder>;
  contextEntityId?: Maybe<SortOrder>;
  contextEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
};

export type ConditionalEntityEvaluationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ConditionalEntityEvaluationOrderByRelevanceInput>;
  audit?: Maybe<SortOrder>;
  conditionalEntityChecksum?: Maybe<SortOrder>;
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  context?: Maybe<SortOrder>;
  contextEntityChecksum?: Maybe<SortOrder>;
  contextEntityId?: Maybe<SortOrder>;
  contextEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
};

export enum ConditionalEntityEvaluationOrderByRelevanceFieldEnum {
  ConditionalEntityChecksum = 'conditionalEntityChecksum',
  ConditionalEntityId = 'conditionalEntityId',
  ContextEntityChecksum = 'contextEntityChecksum',
  ContextEntityId = 'contextEntityId',
  Id = 'id'
}

export type ConditionalEntityEvaluationOrderByRelevanceInput = {
  fields: Array<ConditionalEntityEvaluationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ConditionalEntityEvaluationOrderByWithAggregationInput = {
  _count?: Maybe<ConditionalEntityEvaluationCountOrderByAggregateInput>;
  _max?: Maybe<ConditionalEntityEvaluationMaxOrderByAggregateInput>;
  _min?: Maybe<ConditionalEntityEvaluationMinOrderByAggregateInput>;
  audit?: Maybe<SortOrder>;
  conditionalEntityChecksum?: Maybe<SortOrder>;
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  context?: Maybe<SortOrder>;
  contextEntityChecksum?: Maybe<SortOrder>;
  contextEntityId?: Maybe<SortOrder>;
  contextEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
};

export type ConditionalEntityEvaluationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ConditionalEntityEvaluationOrderByRelevanceInput>;
  audit?: Maybe<SortOrder>;
  conditionalEntityChecksum?: Maybe<SortOrder>;
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  context?: Maybe<SortOrder>;
  contextEntityChecksum?: Maybe<SortOrder>;
  contextEntityId?: Maybe<SortOrder>;
  contextEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
};

export type ConditionalEntityEvaluationOrderByWithRelationInput = {
  _relevance?: Maybe<ConditionalEntityEvaluationOrderByRelevanceInput>;
  audit?: Maybe<SortOrder>;
  conditionalEntityChecksum?: Maybe<SortOrder>;
  conditionalEntityId?: Maybe<SortOrder>;
  conditionalEntityType?: Maybe<SortOrder>;
  context?: Maybe<SortOrder>;
  contextEntityChecksum?: Maybe<SortOrder>;
  contextEntityId?: Maybe<SortOrder>;
  contextEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
};

export enum ConditionalEntityEvaluationScalarFieldEnum {
  Audit = 'audit',
  ConditionalEntityChecksum = 'conditionalEntityChecksum',
  ConditionalEntityId = 'conditionalEntityId',
  ConditionalEntityType = 'conditionalEntityType',
  Context = 'context',
  ContextEntityChecksum = 'contextEntityChecksum',
  ContextEntityId = 'contextEntityId',
  ContextEntityType = 'contextEntityType',
  CreatedAt = 'createdAt',
  Id = 'id',
  Result = 'result'
}

export type ConditionalEntityEvaluationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ConditionalEntityEvaluationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ConditionalEntityEvaluationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ConditionalEntityEvaluationScalarWhereWithAggregatesInput>>;
  audit?: Maybe<JsonNullableWithAggregatesFilter>;
  conditionalEntityChecksum?: Maybe<StringNullableWithAggregatesFilter>;
  conditionalEntityId?: Maybe<StringWithAggregatesFilter>;
  conditionalEntityType?: Maybe<EnumConditionalEntityTypeWithAggregatesFilter>;
  context?: Maybe<JsonNullableWithAggregatesFilter>;
  contextEntityChecksum?: Maybe<StringNullableWithAggregatesFilter>;
  contextEntityId?: Maybe<StringWithAggregatesFilter>;
  contextEntityType?: Maybe<EnumContextEntityTypeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  result?: Maybe<BoolWithAggregatesFilter>;
};

export type ConditionalEntityEvaluationUncheckedCreateInput = {
  audit?: Maybe<Scalars['Json']>;
  conditionalEntityChecksum?: Maybe<Scalars['String']>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  context?: Maybe<Scalars['Json']>;
  contextEntityChecksum?: Maybe<Scalars['String']>;
  contextEntityId: Scalars['String'];
  contextEntityType: ContextEntityType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ConditionalEntityEvaluationUncheckedUpdateInput = {
  audit?: Maybe<Scalars['Json']>;
  conditionalEntityChecksum?: Maybe<Scalars['String']>;
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  context?: Maybe<Scalars['Json']>;
  contextEntityChecksum?: Maybe<Scalars['String']>;
  contextEntityId?: Maybe<Scalars['String']>;
  contextEntityType?: Maybe<ContextEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

export type ConditionalEntityEvaluationUncheckedUpdateManyInput = {
  audit?: Maybe<Scalars['Json']>;
  conditionalEntityChecksum?: Maybe<Scalars['String']>;
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  context?: Maybe<Scalars['Json']>;
  contextEntityChecksum?: Maybe<Scalars['String']>;
  contextEntityId?: Maybe<Scalars['String']>;
  contextEntityType?: Maybe<ContextEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

export type ConditionalEntityEvaluationUpdateInput = {
  audit?: Maybe<Scalars['Json']>;
  conditionalEntityChecksum?: Maybe<Scalars['String']>;
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  context?: Maybe<Scalars['Json']>;
  contextEntityChecksum?: Maybe<Scalars['String']>;
  contextEntityId?: Maybe<Scalars['String']>;
  contextEntityType?: Maybe<ContextEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

export type ConditionalEntityEvaluationUpdateManyMutationInput = {
  audit?: Maybe<Scalars['Json']>;
  conditionalEntityChecksum?: Maybe<Scalars['String']>;
  conditionalEntityId?: Maybe<Scalars['String']>;
  conditionalEntityType?: Maybe<ConditionalEntityType>;
  context?: Maybe<Scalars['Json']>;
  contextEntityChecksum?: Maybe<Scalars['String']>;
  contextEntityId?: Maybe<Scalars['String']>;
  contextEntityType?: Maybe<ContextEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

export type ConditionalEntityEvaluationWhereInput = {
  AND?: Maybe<Array<ConditionalEntityEvaluationWhereInput>>;
  NOT?: Maybe<Array<ConditionalEntityEvaluationWhereInput>>;
  OR?: Maybe<Array<ConditionalEntityEvaluationWhereInput>>;
  audit?: Maybe<JsonNullableFilter>;
  conditionalEntityChecksum?: Maybe<StringNullableFilter>;
  conditionalEntityId?: Maybe<StringFilter>;
  conditionalEntityType?: Maybe<EnumConditionalEntityTypeFilter>;
  context?: Maybe<JsonNullableFilter>;
  contextEntityChecksum?: Maybe<StringNullableFilter>;
  contextEntityId?: Maybe<StringFilter>;
  contextEntityType?: Maybe<EnumContextEntityTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  result?: Maybe<BoolFilter>;
};

export type ConditionalEntityEvaluationWhereUniqueInput = {
  AND?: Maybe<Array<ConditionalEntityEvaluationWhereInput>>;
  NOT?: Maybe<Array<ConditionalEntityEvaluationWhereInput>>;
  OR?: Maybe<Array<ConditionalEntityEvaluationWhereInput>>;
  audit?: Maybe<JsonNullableFilter>;
  conditionalEntityChecksum?: Maybe<StringNullableFilter>;
  conditionalEntityId?: Maybe<StringFilter>;
  conditionalEntityType?: Maybe<EnumConditionalEntityTypeFilter>;
  context?: Maybe<JsonNullableFilter>;
  contextEntityChecksum?: Maybe<StringNullableFilter>;
  contextEntityId?: Maybe<StringFilter>;
  contextEntityType?: Maybe<EnumContextEntityTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<BoolFilter>;
};

export enum ConditionalEntityType {
  InformAudienceDefinition = 'InformAudienceDefinition',
  WorkflowEventSetting = 'WorkflowEventSetting'
}

export type ConditionalSegmentsInput = {
  definitionVariables: SegmentBuilderDefinitionVariablesInput;
  segmentId: Scalars['String'];
};

/** @deprecated - 1.0 */
export type Consultation = {
  __typename?: 'Consultation';
  _count: ConsultationCountOutputType;
  appointments: Array<Appointment>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats: Array<ConsultationChat>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType: Scalars['String'];
  cost?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfo>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<Pet>;
  petId?: Maybe<Scalars['String']>;
  petParent?: Maybe<OwnerInfo>;
  petParentId?: Maybe<Scalars['String']>;
  pics: Array<Image>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions: Array<Transaction>;
  treat?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vet?: Maybe<VetInfo>;
  veterinarianId?: Maybe<Scalars['String']>;
};


/** @deprecated - 1.0 */
export type ConsultationAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


/** @deprecated - 1.0 */
export type ConsultationChatsArgs = {
  cursor?: Maybe<ConsultationChatWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationChatScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationChatOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationChatWhereInput>;
};


/** @deprecated - 1.0 */
export type ConsultationClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


/** @deprecated - 1.0 */
export type ConsultationNurseArgs = {
  where?: Maybe<VetInfoWhereInput>;
};


/** @deprecated - 1.0 */
export type ConsultationPetArgs = {
  where?: Maybe<PetWhereInput>;
};


/** @deprecated - 1.0 */
export type ConsultationPetParentArgs = {
  where?: Maybe<OwnerInfoWhereInput>;
};


/** @deprecated - 1.0 */
export type ConsultationPicsArgs = {
  cursor?: Maybe<ImageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ImageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ImageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ImageWhereInput>;
};


/** @deprecated - 1.0 */
export type ConsultationTransactionsArgs = {
  cursor?: Maybe<TransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TransactionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TransactionWhereInput>;
};


/** @deprecated - 1.0 */
export type ConsultationVetArgs = {
  where?: Maybe<VetInfoWhereInput>;
};

export type ConsultationAvgAggregateOutputType = {
  __typename?: 'ConsultationAvgAggregateOutputType';
  clientCost?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
};

export type ConsultationAvgOrderByAggregateInput = {
  clientCost?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
};

/** @deprecated - 1.0 */
export type ConsultationChat = {
  __typename?: 'ConsultationChat';
  consultation?: Maybe<Consultation>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


/** @deprecated - 1.0 */
export type ConsultationChatConsultationArgs = {
  where?: Maybe<ConsultationWhereInput>;
};


/** @deprecated - 1.0 */
export type ConsultationChatCreatorArgs = {
  where?: Maybe<UserWhereInput>;
};

export type ConsultationChatCountAggregateOutputType = {
  __typename?: 'ConsultationChatCountAggregateOutputType';
  _all: Scalars['Int'];
  consultationId: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdAtCopy: Scalars['Int'];
  creatorId: Scalars['Int'];
  firebaseId: Scalars['Int'];
  id: Scalars['Int'];
  image: Scalars['Int'];
  isRead: Scalars['Int'];
  text: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ConsultationChatCountOrderByAggregateInput = {
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  creatorId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  image?: Maybe<SortOrder>;
  isRead?: Maybe<SortOrder>;
  text?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConsultationChatCreateInput = {
  consultation?: Maybe<ConsultationCreateNestedOneWithoutChatsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<UserCreateNestedOneWithoutConsultationChatsInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatCreateManyConsultationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatCreateManyConsultationInputEnvelope = {
  data: Array<ConsultationChatCreateManyConsultationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ConsultationChatCreateManyCreatorInput = {
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatCreateManyCreatorInputEnvelope = {
  data: Array<ConsultationChatCreateManyCreatorInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ConsultationChatCreateManyInput = {
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatCreateNestedManyWithoutConsultationInput = {
  connect?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationChatCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<ConsultationChatCreateWithoutConsultationInput>>;
  createMany?: Maybe<ConsultationChatCreateManyConsultationInputEnvelope>;
};

export type ConsultationChatCreateNestedManyWithoutCreatorInput = {
  connect?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationChatCreateOrConnectWithoutCreatorInput>>;
  create?: Maybe<Array<ConsultationChatCreateWithoutCreatorInput>>;
  createMany?: Maybe<ConsultationChatCreateManyCreatorInputEnvelope>;
};

export type ConsultationChatCreateOrConnectWithoutConsultationInput = {
  create: ConsultationChatCreateWithoutConsultationInput;
  where: ConsultationChatWhereUniqueInput;
};

export type ConsultationChatCreateOrConnectWithoutCreatorInput = {
  create: ConsultationChatCreateWithoutCreatorInput;
  where: ConsultationChatWhereUniqueInput;
};

export type ConsultationChatCreateWithoutConsultationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<UserCreateNestedOneWithoutConsultationChatsInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatCreateWithoutCreatorInput = {
  consultation?: Maybe<ConsultationCreateNestedOneWithoutChatsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatGroupByOutputType = {
  __typename?: 'ConsultationChatGroupByOutputType';
  _count?: Maybe<ConsultationChatCountAggregateOutputType>;
  _max?: Maybe<ConsultationChatMaxAggregateOutputType>;
  _min?: Maybe<ConsultationChatMinAggregateOutputType>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ConsultationChatListRelationFilter = {
  every?: Maybe<ConsultationChatWhereInput>;
  none?: Maybe<ConsultationChatWhereInput>;
  some?: Maybe<ConsultationChatWhereInput>;
};

export type ConsultationChatMaxAggregateOutputType = {
  __typename?: 'ConsultationChatMaxAggregateOutputType';
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatMaxOrderByAggregateInput = {
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  creatorId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  image?: Maybe<SortOrder>;
  isRead?: Maybe<SortOrder>;
  text?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConsultationChatMinAggregateOutputType = {
  __typename?: 'ConsultationChatMinAggregateOutputType';
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatMinOrderByAggregateInput = {
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  creatorId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  image?: Maybe<SortOrder>;
  isRead?: Maybe<SortOrder>;
  text?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConsultationChatOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ConsultationChatOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ConsultationChatOrderByRelevanceInput>;
  consultation?: Maybe<ConsultationOrderByWithRelationInput>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  creator?: Maybe<UserOrderByWithRelationInput>;
  creatorId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  image?: Maybe<SortOrder>;
  isRead?: Maybe<SortOrder>;
  text?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ConsultationChatOrderByRelevanceFieldEnum {
  ConsultationId = 'consultationId',
  CreatorId = 'creatorId',
  FirebaseId = 'firebaseId',
  Id = 'id',
  Image = 'image',
  Text = 'text'
}

export type ConsultationChatOrderByRelevanceInput = {
  fields: Array<ConsultationChatOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ConsultationChatOrderByWithAggregationInput = {
  _count?: Maybe<ConsultationChatCountOrderByAggregateInput>;
  _max?: Maybe<ConsultationChatMaxOrderByAggregateInput>;
  _min?: Maybe<ConsultationChatMinOrderByAggregateInput>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  creatorId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  image?: Maybe<SortOrder>;
  isRead?: Maybe<SortOrder>;
  text?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConsultationChatOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ConsultationChatOrderByRelevanceInput>;
  consultation?: Maybe<ConsultationOrderByWithRelationInput>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  creator?: Maybe<UserOrderByWithRelationInput>;
  creatorId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  image?: Maybe<SortOrder>;
  isRead?: Maybe<SortOrder>;
  text?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConsultationChatOrderByWithRelationInput = {
  _relevance?: Maybe<ConsultationChatOrderByRelevanceInput>;
  consultation?: Maybe<ConsultationOrderByWithRelationInput>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  creator?: Maybe<UserOrderByWithRelationInput>;
  creatorId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  image?: Maybe<SortOrder>;
  isRead?: Maybe<SortOrder>;
  text?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ConsultationChatScalarFieldEnum {
  ConsultationId = 'consultationId',
  CreatedAt = 'createdAt',
  CreatedAtCopy = 'createdAtCopy',
  CreatorId = 'creatorId',
  FirebaseId = 'firebaseId',
  Id = 'id',
  Image = 'image',
  IsRead = 'isRead',
  Text = 'text',
  UpdatedAt = 'updatedAt'
}

export type ConsultationChatScalarWhereInput = {
  AND?: Maybe<Array<ConsultationChatScalarWhereInput>>;
  NOT?: Maybe<Array<ConsultationChatScalarWhereInput>>;
  OR?: Maybe<Array<ConsultationChatScalarWhereInput>>;
  consultationId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdAtCopy?: Maybe<DateTimeNullableFilter>;
  creatorId?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  image?: Maybe<StringNullableFilter>;
  isRead?: Maybe<BoolNullableFilter>;
  text?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ConsultationChatScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ConsultationChatScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ConsultationChatScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ConsultationChatScalarWhereWithAggregatesInput>>;
  consultationId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  createdAtCopy?: Maybe<DateTimeNullableWithAggregatesFilter>;
  creatorId?: Maybe<StringNullableWithAggregatesFilter>;
  firebaseId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  image?: Maybe<StringNullableWithAggregatesFilter>;
  isRead?: Maybe<BoolNullableWithAggregatesFilter>;
  text?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ConsultationChatUncheckedCreateInput = {
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUncheckedCreateNestedManyWithoutConsultationInput = {
  connect?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationChatCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<ConsultationChatCreateWithoutConsultationInput>>;
  createMany?: Maybe<ConsultationChatCreateManyConsultationInputEnvelope>;
};

export type ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput = {
  connect?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationChatCreateOrConnectWithoutCreatorInput>>;
  create?: Maybe<Array<ConsultationChatCreateWithoutCreatorInput>>;
  createMany?: Maybe<ConsultationChatCreateManyCreatorInputEnvelope>;
};

export type ConsultationChatUncheckedCreateWithoutConsultationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUncheckedCreateWithoutCreatorInput = {
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUncheckedUpdateInput = {
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUncheckedUpdateManyInput = {
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUncheckedUpdateManyWithoutConsultationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUncheckedUpdateManyWithoutConsultationNestedInput = {
  connect?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationChatCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<ConsultationChatCreateWithoutConsultationInput>>;
  createMany?: Maybe<ConsultationChatCreateManyConsultationInputEnvelope>;
  delete?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationChatScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationChatUpdateWithWhereUniqueWithoutConsultationInput>>;
  updateMany?: Maybe<Array<ConsultationChatUpdateManyWithWhereWithoutConsultationInput>>;
  upsert?: Maybe<Array<ConsultationChatUpsertWithWhereUniqueWithoutConsultationInput>>;
};

export type ConsultationChatUncheckedUpdateManyWithoutCreatorInput = {
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput = {
  connect?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationChatCreateOrConnectWithoutCreatorInput>>;
  create?: Maybe<Array<ConsultationChatCreateWithoutCreatorInput>>;
  createMany?: Maybe<ConsultationChatCreateManyCreatorInputEnvelope>;
  delete?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationChatScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationChatUpdateWithWhereUniqueWithoutCreatorInput>>;
  updateMany?: Maybe<Array<ConsultationChatUpdateManyWithWhereWithoutCreatorInput>>;
  upsert?: Maybe<Array<ConsultationChatUpsertWithWhereUniqueWithoutCreatorInput>>;
};

export type ConsultationChatUncheckedUpdateWithoutConsultationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUncheckedUpdateWithoutCreatorInput = {
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUpdateInput = {
  consultation?: Maybe<ConsultationUpdateOneWithoutChatsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<UserUpdateOneWithoutConsultationChatsNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUpdateManyWithWhereWithoutConsultationInput = {
  data: ConsultationChatUpdateManyMutationInput;
  where: ConsultationChatScalarWhereInput;
};

export type ConsultationChatUpdateManyWithWhereWithoutCreatorInput = {
  data: ConsultationChatUpdateManyMutationInput;
  where: ConsultationChatScalarWhereInput;
};

export type ConsultationChatUpdateManyWithoutConsultationNestedInput = {
  connect?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationChatCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<ConsultationChatCreateWithoutConsultationInput>>;
  createMany?: Maybe<ConsultationChatCreateManyConsultationInputEnvelope>;
  delete?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationChatScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationChatUpdateWithWhereUniqueWithoutConsultationInput>>;
  updateMany?: Maybe<Array<ConsultationChatUpdateManyWithWhereWithoutConsultationInput>>;
  upsert?: Maybe<Array<ConsultationChatUpsertWithWhereUniqueWithoutConsultationInput>>;
};

export type ConsultationChatUpdateManyWithoutCreatorNestedInput = {
  connect?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationChatCreateOrConnectWithoutCreatorInput>>;
  create?: Maybe<Array<ConsultationChatCreateWithoutCreatorInput>>;
  createMany?: Maybe<ConsultationChatCreateManyCreatorInputEnvelope>;
  delete?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationChatScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationChatWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationChatUpdateWithWhereUniqueWithoutCreatorInput>>;
  updateMany?: Maybe<Array<ConsultationChatUpdateManyWithWhereWithoutCreatorInput>>;
  upsert?: Maybe<Array<ConsultationChatUpsertWithWhereUniqueWithoutCreatorInput>>;
};

export type ConsultationChatUpdateWithWhereUniqueWithoutConsultationInput = {
  data: ConsultationChatUpdateWithoutConsultationInput;
  where: ConsultationChatWhereUniqueInput;
};

export type ConsultationChatUpdateWithWhereUniqueWithoutCreatorInput = {
  data: ConsultationChatUpdateWithoutCreatorInput;
  where: ConsultationChatWhereUniqueInput;
};

export type ConsultationChatUpdateWithoutConsultationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<UserUpdateOneWithoutConsultationChatsNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUpdateWithoutCreatorInput = {
  consultation?: Maybe<ConsultationUpdateOneWithoutChatsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationChatUpsertWithWhereUniqueWithoutConsultationInput = {
  create: ConsultationChatCreateWithoutConsultationInput;
  update: ConsultationChatUpdateWithoutConsultationInput;
  where: ConsultationChatWhereUniqueInput;
};

export type ConsultationChatUpsertWithWhereUniqueWithoutCreatorInput = {
  create: ConsultationChatCreateWithoutCreatorInput;
  update: ConsultationChatUpdateWithoutCreatorInput;
  where: ConsultationChatWhereUniqueInput;
};

export type ConsultationChatWhereInput = {
  AND?: Maybe<Array<ConsultationChatWhereInput>>;
  NOT?: Maybe<Array<ConsultationChatWhereInput>>;
  OR?: Maybe<Array<ConsultationChatWhereInput>>;
  consultation?: Maybe<ConsultationNullableScalarRelationFilter>;
  consultationId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdAtCopy?: Maybe<DateTimeNullableFilter>;
  creator?: Maybe<UserNullableScalarRelationFilter>;
  creatorId?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  image?: Maybe<StringNullableFilter>;
  isRead?: Maybe<BoolNullableFilter>;
  text?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ConsultationChatWhereUniqueInput = {
  AND?: Maybe<Array<ConsultationChatWhereInput>>;
  NOT?: Maybe<Array<ConsultationChatWhereInput>>;
  OR?: Maybe<Array<ConsultationChatWhereInput>>;
  consultation?: Maybe<ConsultationNullableScalarRelationFilter>;
  consultationId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdAtCopy?: Maybe<DateTimeNullableFilter>;
  creator?: Maybe<UserNullableScalarRelationFilter>;
  creatorId?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<StringNullableFilter>;
  isRead?: Maybe<BoolNullableFilter>;
  text?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ConsultationCountAggregateOutputType = {
  __typename?: 'ConsultationCountAggregateOutputType';
  _all: Scalars['Int'];
  callType: Scalars['Int'];
  cancelledAt: Scalars['Int'];
  clientCost: Scalars['Int'];
  clinicId: Scalars['Int'];
  consultationState: Scalars['Int'];
  consultationType: Scalars['Int'];
  cost: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdAtCopy: Scalars['Int'];
  details: Scalars['Int'];
  firebaseId: Scalars['Int'];
  id: Scalars['Int'];
  isPhoneAllowed: Scalars['Int'];
  isVetEmailed: Scalars['Int'];
  isVideoAllowed: Scalars['Int'];
  isVideoChat: Scalars['Int'];
  lastMessageAt: Scalars['Int'];
  nurseId: Scalars['Int'];
  openedAt: Scalars['Int'];
  petId: Scalars['Int'];
  petParentId: Scalars['Int'];
  resolvedAt: Scalars['Int'];
  scheduledAt: Scalars['Int'];
  summary: Scalars['Int'];
  transactionId: Scalars['Int'];
  treat: Scalars['Int'];
  updatedAt: Scalars['Int'];
  veterinarianId: Scalars['Int'];
};

export type ConsultationCountOrderByAggregateInput = {
  callType?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  clientCost?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  consultationState?: Maybe<SortOrder>;
  consultationType?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPhoneAllowed?: Maybe<SortOrder>;
  isVetEmailed?: Maybe<SortOrder>;
  isVideoAllowed?: Maybe<SortOrder>;
  isVideoChat?: Maybe<SortOrder>;
  lastMessageAt?: Maybe<SortOrder>;
  nurseId?: Maybe<SortOrder>;
  openedAt?: Maybe<SortOrder>;
  petId?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  resolvedAt?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  treat?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  veterinarianId?: Maybe<SortOrder>;
};

export type ConsultationCountOutputType = {
  __typename?: 'ConsultationCountOutputType';
  appointments: Scalars['Int'];
  chats: Scalars['Int'];
  pics: Scalars['Int'];
  transactions: Scalars['Int'];
};

export type ConsultationCreateInput = {
  appointments?: Maybe<AppointmentCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutConsultationsInput>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoCreateNestedOneWithoutConsultationsIdInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetCreateNestedOneWithoutConsultationsInput>;
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutConsultationsInput>;
  pics?: Maybe<ImageCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoCreateNestedOneWithoutConsultationsInput>;
};

export type ConsultationCreateManyClinicInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationCreateManyClinicInputEnvelope = {
  data: Array<ConsultationCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ConsultationCreateManyInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationCreateManyNurseInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationCreateManyNurseInputEnvelope = {
  data: Array<ConsultationCreateManyNurseInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ConsultationCreateManyPetInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationCreateManyPetInputEnvelope = {
  data: Array<ConsultationCreateManyPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ConsultationCreateManyPetParentInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationCreateManyPetParentInputEnvelope = {
  data: Array<ConsultationCreateManyPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ConsultationCreateManyVetInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationCreateManyVetInputEnvelope = {
  data: Array<ConsultationCreateManyVetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ConsultationCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutClinicInput>>;
  createMany?: Maybe<ConsultationCreateManyClinicInputEnvelope>;
};

export type ConsultationCreateNestedManyWithoutNurseInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutNurseInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutNurseInput>>;
  createMany?: Maybe<ConsultationCreateManyNurseInputEnvelope>;
};

export type ConsultationCreateNestedManyWithoutPetInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutPetInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutPetInput>>;
  createMany?: Maybe<ConsultationCreateManyPetInputEnvelope>;
};

export type ConsultationCreateNestedManyWithoutPetParentInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutPetParentInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutPetParentInput>>;
  createMany?: Maybe<ConsultationCreateManyPetParentInputEnvelope>;
};

export type ConsultationCreateNestedManyWithoutPicsInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutPicsInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutPicsInput>>;
};

export type ConsultationCreateNestedManyWithoutVetInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutVetInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutVetInput>>;
  createMany?: Maybe<ConsultationCreateManyVetInputEnvelope>;
};

export type ConsultationCreateNestedOneWithoutAppointmentsInput = {
  connect?: Maybe<ConsultationWhereUniqueInput>;
  connectOrCreate?: Maybe<ConsultationCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<ConsultationCreateWithoutAppointmentsInput>;
};

export type ConsultationCreateNestedOneWithoutChatsInput = {
  connect?: Maybe<ConsultationWhereUniqueInput>;
  connectOrCreate?: Maybe<ConsultationCreateOrConnectWithoutChatsInput>;
  create?: Maybe<ConsultationCreateWithoutChatsInput>;
};

export type ConsultationCreateNestedOneWithoutTransactionsInput = {
  connect?: Maybe<ConsultationWhereUniqueInput>;
  connectOrCreate?: Maybe<ConsultationCreateOrConnectWithoutTransactionsInput>;
  create?: Maybe<ConsultationCreateWithoutTransactionsInput>;
};

export type ConsultationCreateOrConnectWithoutAppointmentsInput = {
  create: ConsultationCreateWithoutAppointmentsInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationCreateOrConnectWithoutChatsInput = {
  create: ConsultationCreateWithoutChatsInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationCreateOrConnectWithoutClinicInput = {
  create: ConsultationCreateWithoutClinicInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationCreateOrConnectWithoutNurseInput = {
  create: ConsultationCreateWithoutNurseInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationCreateOrConnectWithoutPetInput = {
  create: ConsultationCreateWithoutPetInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationCreateOrConnectWithoutPetParentInput = {
  create: ConsultationCreateWithoutPetParentInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationCreateOrConnectWithoutPicsInput = {
  create: ConsultationCreateWithoutPicsInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationCreateOrConnectWithoutTransactionsInput = {
  create: ConsultationCreateWithoutTransactionsInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationCreateOrConnectWithoutVetInput = {
  create: ConsultationCreateWithoutVetInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationCreateWithoutAppointmentsInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutConsultationsInput>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoCreateNestedOneWithoutConsultationsIdInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetCreateNestedOneWithoutConsultationsInput>;
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutConsultationsInput>;
  pics?: Maybe<ImageCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoCreateNestedOneWithoutConsultationsInput>;
};

export type ConsultationCreateWithoutChatsInput = {
  appointments?: Maybe<AppointmentCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutConsultationsInput>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoCreateNestedOneWithoutConsultationsIdInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetCreateNestedOneWithoutConsultationsInput>;
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutConsultationsInput>;
  pics?: Maybe<ImageCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoCreateNestedOneWithoutConsultationsInput>;
};

export type ConsultationCreateWithoutClinicInput = {
  appointments?: Maybe<AppointmentCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoCreateNestedOneWithoutConsultationsIdInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetCreateNestedOneWithoutConsultationsInput>;
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutConsultationsInput>;
  pics?: Maybe<ImageCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoCreateNestedOneWithoutConsultationsInput>;
};

export type ConsultationCreateWithoutNurseInput = {
  appointments?: Maybe<AppointmentCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutConsultationsInput>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetCreateNestedOneWithoutConsultationsInput>;
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutConsultationsInput>;
  pics?: Maybe<ImageCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoCreateNestedOneWithoutConsultationsInput>;
};

export type ConsultationCreateWithoutPetInput = {
  appointments?: Maybe<AppointmentCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutConsultationsInput>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoCreateNestedOneWithoutConsultationsIdInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutConsultationsInput>;
  pics?: Maybe<ImageCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoCreateNestedOneWithoutConsultationsInput>;
};

export type ConsultationCreateWithoutPetParentInput = {
  appointments?: Maybe<AppointmentCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutConsultationsInput>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoCreateNestedOneWithoutConsultationsIdInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetCreateNestedOneWithoutConsultationsInput>;
  pics?: Maybe<ImageCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoCreateNestedOneWithoutConsultationsInput>;
};

export type ConsultationCreateWithoutPicsInput = {
  appointments?: Maybe<AppointmentCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutConsultationsInput>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoCreateNestedOneWithoutConsultationsIdInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetCreateNestedOneWithoutConsultationsInput>;
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutConsultationsInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoCreateNestedOneWithoutConsultationsInput>;
};

export type ConsultationCreateWithoutTransactionsInput = {
  appointments?: Maybe<AppointmentCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutConsultationsInput>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoCreateNestedOneWithoutConsultationsIdInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetCreateNestedOneWithoutConsultationsInput>;
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutConsultationsInput>;
  pics?: Maybe<ImageCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoCreateNestedOneWithoutConsultationsInput>;
};

export type ConsultationCreateWithoutVetInput = {
  appointments?: Maybe<AppointmentCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutConsultationsInput>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoCreateNestedOneWithoutConsultationsIdInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetCreateNestedOneWithoutConsultationsInput>;
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutConsultationsInput>;
  pics?: Maybe<ImageCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationGroupByOutputType = {
  __typename?: 'ConsultationGroupByOutputType';
  _avg?: Maybe<ConsultationAvgAggregateOutputType>;
  _count?: Maybe<ConsultationCountAggregateOutputType>;
  _max?: Maybe<ConsultationMaxAggregateOutputType>;
  _min?: Maybe<ConsultationMinAggregateOutputType>;
  _sum?: Maybe<ConsultationSumAggregateOutputType>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType: Scalars['String'];
  cost?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationListRelationFilter = {
  every?: Maybe<ConsultationWhereInput>;
  none?: Maybe<ConsultationWhereInput>;
  some?: Maybe<ConsultationWhereInput>;
};

export type ConsultationMaxAggregateOutputType = {
  __typename?: 'ConsultationMaxAggregateOutputType';
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationMaxOrderByAggregateInput = {
  callType?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  clientCost?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  consultationState?: Maybe<SortOrder>;
  consultationType?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPhoneAllowed?: Maybe<SortOrder>;
  isVetEmailed?: Maybe<SortOrder>;
  isVideoAllowed?: Maybe<SortOrder>;
  isVideoChat?: Maybe<SortOrder>;
  lastMessageAt?: Maybe<SortOrder>;
  nurseId?: Maybe<SortOrder>;
  openedAt?: Maybe<SortOrder>;
  petId?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  resolvedAt?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  treat?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  veterinarianId?: Maybe<SortOrder>;
};

export type ConsultationMinAggregateOutputType = {
  __typename?: 'ConsultationMinAggregateOutputType';
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationMinOrderByAggregateInput = {
  callType?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  clientCost?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  consultationState?: Maybe<SortOrder>;
  consultationType?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPhoneAllowed?: Maybe<SortOrder>;
  isVetEmailed?: Maybe<SortOrder>;
  isVideoAllowed?: Maybe<SortOrder>;
  isVideoChat?: Maybe<SortOrder>;
  lastMessageAt?: Maybe<SortOrder>;
  nurseId?: Maybe<SortOrder>;
  openedAt?: Maybe<SortOrder>;
  petId?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  resolvedAt?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  treat?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  veterinarianId?: Maybe<SortOrder>;
};

export type ConsultationNullableScalarRelationFilter = {
  AND?: Maybe<Array<ConsultationWhereInput>>;
  NOT?: Maybe<Array<ConsultationWhereInput>>;
  OR?: Maybe<Array<ConsultationWhereInput>>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  callType?: Maybe<StringNullableFilter>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  chats?: Maybe<ConsultationChatListRelationFilter>;
  clientCost?: Maybe<FloatNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  consultationState?: Maybe<StringFilter>;
  consultationType?: Maybe<StringFilter>;
  cost?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdAtCopy?: Maybe<DateTimeNullableFilter>;
  details?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isPhoneAllowed?: Maybe<BoolNullableFilter>;
  isVetEmailed?: Maybe<BoolNullableFilter>;
  isVideoAllowed?: Maybe<BoolNullableFilter>;
  isVideoChat?: Maybe<BoolNullableFilter>;
  lastMessageAt?: Maybe<DateTimeNullableFilter>;
  nurse?: Maybe<VetInfoNullableScalarRelationFilter>;
  nurseId?: Maybe<StringNullableFilter>;
  openedAt?: Maybe<DateTimeNullableFilter>;
  pet?: Maybe<PetNullableScalarRelationFilter>;
  petId?: Maybe<StringNullableFilter>;
  petParent?: Maybe<OwnerInfoNullableScalarRelationFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  pics?: Maybe<ImageListRelationFilter>;
  resolvedAt?: Maybe<DateTimeNullableFilter>;
  scheduledAt?: Maybe<DateTimeNullableFilter>;
  summary?: Maybe<StringNullableFilter>;
  transactionId?: Maybe<StringNullableFilter>;
  transactions?: Maybe<TransactionListRelationFilter>;
  treat?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vet?: Maybe<VetInfoNullableScalarRelationFilter>;
  veterinarianId?: Maybe<StringNullableFilter>;
};

export type ConsultationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ConsultationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ConsultationOrderByRelevanceInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  callType?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  chats?: Maybe<ConsultationChatOrderByRelationAggregateInput>;
  clientCost?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  consultationState?: Maybe<SortOrder>;
  consultationType?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPhoneAllowed?: Maybe<SortOrder>;
  isVetEmailed?: Maybe<SortOrder>;
  isVideoAllowed?: Maybe<SortOrder>;
  isVideoChat?: Maybe<SortOrder>;
  lastMessageAt?: Maybe<SortOrder>;
  nurse?: Maybe<VetInfoOrderByWithRelationInput>;
  nurseId?: Maybe<SortOrder>;
  openedAt?: Maybe<SortOrder>;
  pet?: Maybe<PetOrderByWithRelationInput>;
  petId?: Maybe<SortOrder>;
  petParent?: Maybe<OwnerInfoOrderByWithRelationInput>;
  petParentId?: Maybe<SortOrder>;
  pics?: Maybe<ImageOrderByRelationAggregateInput>;
  resolvedAt?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  transactions?: Maybe<TransactionOrderByRelationAggregateInput>;
  treat?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vet?: Maybe<VetInfoOrderByWithRelationInput>;
  veterinarianId?: Maybe<SortOrder>;
};

export enum ConsultationOrderByRelevanceFieldEnum {
  CallType = 'callType',
  ClinicId = 'clinicId',
  ConsultationState = 'consultationState',
  ConsultationType = 'consultationType',
  Details = 'details',
  FirebaseId = 'firebaseId',
  Id = 'id',
  NurseId = 'nurseId',
  PetId = 'petId',
  PetParentId = 'petParentId',
  Summary = 'summary',
  TransactionId = 'transactionId',
  Treat = 'treat',
  VeterinarianId = 'veterinarianId'
}

export type ConsultationOrderByRelevanceInput = {
  fields: Array<ConsultationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ConsultationOrderByWithAggregationInput = {
  _avg?: Maybe<ConsultationAvgOrderByAggregateInput>;
  _count?: Maybe<ConsultationCountOrderByAggregateInput>;
  _max?: Maybe<ConsultationMaxOrderByAggregateInput>;
  _min?: Maybe<ConsultationMinOrderByAggregateInput>;
  _sum?: Maybe<ConsultationSumOrderByAggregateInput>;
  callType?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  clientCost?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  consultationState?: Maybe<SortOrder>;
  consultationType?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPhoneAllowed?: Maybe<SortOrder>;
  isVetEmailed?: Maybe<SortOrder>;
  isVideoAllowed?: Maybe<SortOrder>;
  isVideoChat?: Maybe<SortOrder>;
  lastMessageAt?: Maybe<SortOrder>;
  nurseId?: Maybe<SortOrder>;
  openedAt?: Maybe<SortOrder>;
  petId?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  resolvedAt?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  treat?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  veterinarianId?: Maybe<SortOrder>;
};

export type ConsultationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ConsultationOrderByRelevanceInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  callType?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  chats?: Maybe<ConsultationChatOrderByRelationAggregateInput>;
  clientCost?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  consultationState?: Maybe<SortOrder>;
  consultationType?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPhoneAllowed?: Maybe<SortOrder>;
  isVetEmailed?: Maybe<SortOrder>;
  isVideoAllowed?: Maybe<SortOrder>;
  isVideoChat?: Maybe<SortOrder>;
  lastMessageAt?: Maybe<SortOrder>;
  nurse?: Maybe<VetInfoOrderByWithRelationInput>;
  nurseId?: Maybe<SortOrder>;
  openedAt?: Maybe<SortOrder>;
  pet?: Maybe<PetOrderByWithRelationInput>;
  petId?: Maybe<SortOrder>;
  petParent?: Maybe<OwnerInfoOrderByWithRelationInput>;
  petParentId?: Maybe<SortOrder>;
  pics?: Maybe<ImageOrderByRelationAggregateInput>;
  resolvedAt?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  transactions?: Maybe<TransactionOrderByRelationAggregateInput>;
  treat?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vet?: Maybe<VetInfoOrderByWithRelationInput>;
  veterinarianId?: Maybe<SortOrder>;
};

export type ConsultationOrderByWithRelationInput = {
  _relevance?: Maybe<ConsultationOrderByRelevanceInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  callType?: Maybe<SortOrder>;
  cancelledAt?: Maybe<SortOrder>;
  chats?: Maybe<ConsultationChatOrderByRelationAggregateInput>;
  clientCost?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  consultationState?: Maybe<SortOrder>;
  consultationType?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdAtCopy?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPhoneAllowed?: Maybe<SortOrder>;
  isVetEmailed?: Maybe<SortOrder>;
  isVideoAllowed?: Maybe<SortOrder>;
  isVideoChat?: Maybe<SortOrder>;
  lastMessageAt?: Maybe<SortOrder>;
  nurse?: Maybe<VetInfoOrderByWithRelationInput>;
  nurseId?: Maybe<SortOrder>;
  openedAt?: Maybe<SortOrder>;
  pet?: Maybe<PetOrderByWithRelationInput>;
  petId?: Maybe<SortOrder>;
  petParent?: Maybe<OwnerInfoOrderByWithRelationInput>;
  petParentId?: Maybe<SortOrder>;
  pics?: Maybe<ImageOrderByRelationAggregateInput>;
  resolvedAt?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  transactions?: Maybe<TransactionOrderByRelationAggregateInput>;
  treat?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vet?: Maybe<VetInfoOrderByWithRelationInput>;
  veterinarianId?: Maybe<SortOrder>;
};

/** @deprecated - 1.0 */
export type ConsultationRequest = {
  __typename?: 'ConsultationRequest';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  intent: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName: Scalars['String'];
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname: Scalars['String'];
  petParentLastname: Scalars['String'];
  petParentPhone: Scalars['String'];
  petSpecies?: Maybe<Scalars['String']>;
  summary: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


/** @deprecated - 1.0 */
export type ConsultationRequestClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};

export type ConsultationRequestCountAggregateOutputType = {
  __typename?: 'ConsultationRequestCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  consultationFirebaseId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  intent: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isExistingClient: Scalars['Int'];
  petName: Scalars['Int'];
  petParentEmail: Scalars['Int'];
  petParentFirstname: Scalars['Int'];
  petParentLastname: Scalars['Int'];
  petParentPhone: Scalars['Int'];
  petSpecies: Scalars['Int'];
  summary: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ConsultationRequestCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  consultationFirebaseId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  intent?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExistingClient?: Maybe<SortOrder>;
  petName?: Maybe<SortOrder>;
  petParentEmail?: Maybe<SortOrder>;
  petParentFirstname?: Maybe<SortOrder>;
  petParentLastname?: Maybe<SortOrder>;
  petParentPhone?: Maybe<SortOrder>;
  petSpecies?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConsultationRequestCreateInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutConsultationRequestsInput>;
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName: Scalars['String'];
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname: Scalars['String'];
  petParentLastname: Scalars['String'];
  petParentPhone: Scalars['String'];
  petSpecies?: Maybe<Scalars['String']>;
  summary: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestCreateManyClinicInput = {
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName: Scalars['String'];
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname: Scalars['String'];
  petParentLastname: Scalars['String'];
  petParentPhone: Scalars['String'];
  petSpecies?: Maybe<Scalars['String']>;
  summary: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestCreateManyClinicInputEnvelope = {
  data: Array<ConsultationRequestCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ConsultationRequestCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName: Scalars['String'];
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname: Scalars['String'];
  petParentLastname: Scalars['String'];
  petParentPhone: Scalars['String'];
  petSpecies?: Maybe<Scalars['String']>;
  summary: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ConsultationRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationRequestCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ConsultationRequestCreateWithoutClinicInput>>;
  createMany?: Maybe<ConsultationRequestCreateManyClinicInputEnvelope>;
};

export type ConsultationRequestCreateOrConnectWithoutClinicInput = {
  create: ConsultationRequestCreateWithoutClinicInput;
  where: ConsultationRequestWhereUniqueInput;
};

export type ConsultationRequestCreateWithoutClinicInput = {
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName: Scalars['String'];
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname: Scalars['String'];
  petParentLastname: Scalars['String'];
  petParentPhone: Scalars['String'];
  petSpecies?: Maybe<Scalars['String']>;
  summary: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestGroupByOutputType = {
  __typename?: 'ConsultationRequestGroupByOutputType';
  _count?: Maybe<ConsultationRequestCountAggregateOutputType>;
  _max?: Maybe<ConsultationRequestMaxAggregateOutputType>;
  _min?: Maybe<ConsultationRequestMinAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  intent: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName: Scalars['String'];
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname: Scalars['String'];
  petParentLastname: Scalars['String'];
  petParentPhone: Scalars['String'];
  petSpecies?: Maybe<Scalars['String']>;
  summary: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ConsultationRequestListRelationFilter = {
  every?: Maybe<ConsultationRequestWhereInput>;
  none?: Maybe<ConsultationRequestWhereInput>;
  some?: Maybe<ConsultationRequestWhereInput>;
};

export type ConsultationRequestMaxAggregateOutputType = {
  __typename?: 'ConsultationRequestMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName?: Maybe<Scalars['String']>;
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname?: Maybe<Scalars['String']>;
  petParentLastname?: Maybe<Scalars['String']>;
  petParentPhone?: Maybe<Scalars['String']>;
  petSpecies?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  consultationFirebaseId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  intent?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExistingClient?: Maybe<SortOrder>;
  petName?: Maybe<SortOrder>;
  petParentEmail?: Maybe<SortOrder>;
  petParentFirstname?: Maybe<SortOrder>;
  petParentLastname?: Maybe<SortOrder>;
  petParentPhone?: Maybe<SortOrder>;
  petSpecies?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConsultationRequestMinAggregateOutputType = {
  __typename?: 'ConsultationRequestMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName?: Maybe<Scalars['String']>;
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname?: Maybe<Scalars['String']>;
  petParentLastname?: Maybe<Scalars['String']>;
  petParentPhone?: Maybe<Scalars['String']>;
  petSpecies?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  consultationFirebaseId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  intent?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExistingClient?: Maybe<SortOrder>;
  petName?: Maybe<SortOrder>;
  petParentEmail?: Maybe<SortOrder>;
  petParentFirstname?: Maybe<SortOrder>;
  petParentLastname?: Maybe<SortOrder>;
  petParentPhone?: Maybe<SortOrder>;
  petSpecies?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConsultationRequestOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ConsultationRequestOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ConsultationRequestOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  consultationFirebaseId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  intent?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExistingClient?: Maybe<SortOrder>;
  petName?: Maybe<SortOrder>;
  petParentEmail?: Maybe<SortOrder>;
  petParentFirstname?: Maybe<SortOrder>;
  petParentLastname?: Maybe<SortOrder>;
  petParentPhone?: Maybe<SortOrder>;
  petSpecies?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ConsultationRequestOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  ConsultationFirebaseId = 'consultationFirebaseId',
  Id = 'id',
  Intent = 'intent',
  PetName = 'petName',
  PetParentEmail = 'petParentEmail',
  PetParentFirstname = 'petParentFirstname',
  PetParentLastname = 'petParentLastname',
  PetParentPhone = 'petParentPhone',
  PetSpecies = 'petSpecies',
  Summary = 'summary'
}

export type ConsultationRequestOrderByRelevanceInput = {
  fields: Array<ConsultationRequestOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ConsultationRequestOrderByWithAggregationInput = {
  _count?: Maybe<ConsultationRequestCountOrderByAggregateInput>;
  _max?: Maybe<ConsultationRequestMaxOrderByAggregateInput>;
  _min?: Maybe<ConsultationRequestMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  consultationFirebaseId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  intent?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExistingClient?: Maybe<SortOrder>;
  petName?: Maybe<SortOrder>;
  petParentEmail?: Maybe<SortOrder>;
  petParentFirstname?: Maybe<SortOrder>;
  petParentLastname?: Maybe<SortOrder>;
  petParentPhone?: Maybe<SortOrder>;
  petSpecies?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConsultationRequestOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ConsultationRequestOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  consultationFirebaseId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  intent?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExistingClient?: Maybe<SortOrder>;
  petName?: Maybe<SortOrder>;
  petParentEmail?: Maybe<SortOrder>;
  petParentFirstname?: Maybe<SortOrder>;
  petParentLastname?: Maybe<SortOrder>;
  petParentPhone?: Maybe<SortOrder>;
  petSpecies?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ConsultationRequestOrderByWithRelationInput = {
  _relevance?: Maybe<ConsultationRequestOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  consultationFirebaseId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  intent?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExistingClient?: Maybe<SortOrder>;
  petName?: Maybe<SortOrder>;
  petParentEmail?: Maybe<SortOrder>;
  petParentFirstname?: Maybe<SortOrder>;
  petParentLastname?: Maybe<SortOrder>;
  petParentPhone?: Maybe<SortOrder>;
  petSpecies?: Maybe<SortOrder>;
  summary?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ConsultationRequestScalarFieldEnum {
  ClinicId = 'clinicId',
  ConsultationFirebaseId = 'consultationFirebaseId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Intent = 'intent',
  IsDeleted = 'isDeleted',
  IsExistingClient = 'isExistingClient',
  PetName = 'petName',
  PetParentEmail = 'petParentEmail',
  PetParentFirstname = 'petParentFirstname',
  PetParentLastname = 'petParentLastname',
  PetParentPhone = 'petParentPhone',
  PetSpecies = 'petSpecies',
  Summary = 'summary',
  UpdatedAt = 'updatedAt'
}

export type ConsultationRequestScalarWhereInput = {
  AND?: Maybe<Array<ConsultationRequestScalarWhereInput>>;
  NOT?: Maybe<Array<ConsultationRequestScalarWhereInput>>;
  OR?: Maybe<Array<ConsultationRequestScalarWhereInput>>;
  clinicId?: Maybe<StringNullableFilter>;
  consultationFirebaseId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  intent?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isExistingClient?: Maybe<BoolNullableFilter>;
  petName?: Maybe<StringFilter>;
  petParentEmail?: Maybe<StringNullableFilter>;
  petParentFirstname?: Maybe<StringFilter>;
  petParentLastname?: Maybe<StringFilter>;
  petParentPhone?: Maybe<StringFilter>;
  petSpecies?: Maybe<StringNullableFilter>;
  summary?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ConsultationRequestScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ConsultationRequestScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ConsultationRequestScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ConsultationRequestScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  consultationFirebaseId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  intent?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  isExistingClient?: Maybe<BoolNullableWithAggregatesFilter>;
  petName?: Maybe<StringWithAggregatesFilter>;
  petParentEmail?: Maybe<StringNullableWithAggregatesFilter>;
  petParentFirstname?: Maybe<StringWithAggregatesFilter>;
  petParentLastname?: Maybe<StringWithAggregatesFilter>;
  petParentPhone?: Maybe<StringWithAggregatesFilter>;
  petSpecies?: Maybe<StringNullableWithAggregatesFilter>;
  summary?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ConsultationRequestUncheckedCreateInput = {
  clinicId?: Maybe<Scalars['String']>;
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName: Scalars['String'];
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname: Scalars['String'];
  petParentLastname: Scalars['String'];
  petParentPhone: Scalars['String'];
  petSpecies?: Maybe<Scalars['String']>;
  summary: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ConsultationRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationRequestCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ConsultationRequestCreateWithoutClinicInput>>;
  createMany?: Maybe<ConsultationRequestCreateManyClinicInputEnvelope>;
};

export type ConsultationRequestUncheckedCreateWithoutClinicInput = {
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName: Scalars['String'];
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname: Scalars['String'];
  petParentLastname: Scalars['String'];
  petParentPhone: Scalars['String'];
  petSpecies?: Maybe<Scalars['String']>;
  summary: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName?: Maybe<Scalars['String']>;
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname?: Maybe<Scalars['String']>;
  petParentLastname?: Maybe<Scalars['String']>;
  petParentPhone?: Maybe<Scalars['String']>;
  petSpecies?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName?: Maybe<Scalars['String']>;
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname?: Maybe<Scalars['String']>;
  petParentLastname?: Maybe<Scalars['String']>;
  petParentPhone?: Maybe<Scalars['String']>;
  petSpecies?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestUncheckedUpdateManyWithoutClinicInput = {
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName?: Maybe<Scalars['String']>;
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname?: Maybe<Scalars['String']>;
  petParentLastname?: Maybe<Scalars['String']>;
  petParentPhone?: Maybe<Scalars['String']>;
  petSpecies?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ConsultationRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationRequestCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ConsultationRequestCreateWithoutClinicInput>>;
  createMany?: Maybe<ConsultationRequestCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ConsultationRequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationRequestScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationRequestWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationRequestWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationRequestUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ConsultationRequestUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ConsultationRequestUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ConsultationRequestUncheckedUpdateWithoutClinicInput = {
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName?: Maybe<Scalars['String']>;
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname?: Maybe<Scalars['String']>;
  petParentLastname?: Maybe<Scalars['String']>;
  petParentPhone?: Maybe<Scalars['String']>;
  petSpecies?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutConsultationRequestsNestedInput>;
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName?: Maybe<Scalars['String']>;
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname?: Maybe<Scalars['String']>;
  petParentLastname?: Maybe<Scalars['String']>;
  petParentPhone?: Maybe<Scalars['String']>;
  petSpecies?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestUpdateManyMutationInput = {
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName?: Maybe<Scalars['String']>;
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname?: Maybe<Scalars['String']>;
  petParentLastname?: Maybe<Scalars['String']>;
  petParentPhone?: Maybe<Scalars['String']>;
  petSpecies?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestUpdateManyWithWhereWithoutClinicInput = {
  data: ConsultationRequestUpdateManyMutationInput;
  where: ConsultationRequestScalarWhereInput;
};

export type ConsultationRequestUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ConsultationRequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationRequestCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ConsultationRequestCreateWithoutClinicInput>>;
  createMany?: Maybe<ConsultationRequestCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ConsultationRequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationRequestScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationRequestWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationRequestWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationRequestUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ConsultationRequestUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ConsultationRequestUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ConsultationRequestUpdateWithWhereUniqueWithoutClinicInput = {
  data: ConsultationRequestUpdateWithoutClinicInput;
  where: ConsultationRequestWhereUniqueInput;
};

export type ConsultationRequestUpdateWithoutClinicInput = {
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intent?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName?: Maybe<Scalars['String']>;
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname?: Maybe<Scalars['String']>;
  petParentLastname?: Maybe<Scalars['String']>;
  petParentPhone?: Maybe<Scalars['String']>;
  petSpecies?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationRequestUpsertWithWhereUniqueWithoutClinicInput = {
  create: ConsultationRequestCreateWithoutClinicInput;
  update: ConsultationRequestUpdateWithoutClinicInput;
  where: ConsultationRequestWhereUniqueInput;
};

export type ConsultationRequestWhereInput = {
  AND?: Maybe<Array<ConsultationRequestWhereInput>>;
  NOT?: Maybe<Array<ConsultationRequestWhereInput>>;
  OR?: Maybe<Array<ConsultationRequestWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  consultationFirebaseId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  intent?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isExistingClient?: Maybe<BoolNullableFilter>;
  petName?: Maybe<StringFilter>;
  petParentEmail?: Maybe<StringNullableFilter>;
  petParentFirstname?: Maybe<StringFilter>;
  petParentLastname?: Maybe<StringFilter>;
  petParentPhone?: Maybe<StringFilter>;
  petSpecies?: Maybe<StringNullableFilter>;
  summary?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ConsultationRequestWhereUniqueInput = {
  AND?: Maybe<Array<ConsultationRequestWhereInput>>;
  NOT?: Maybe<Array<ConsultationRequestWhereInput>>;
  OR?: Maybe<Array<ConsultationRequestWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  consultationFirebaseId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  intent?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isExistingClient?: Maybe<BoolNullableFilter>;
  petName?: Maybe<StringFilter>;
  petParentEmail?: Maybe<StringNullableFilter>;
  petParentFirstname?: Maybe<StringFilter>;
  petParentLastname?: Maybe<StringFilter>;
  petParentPhone?: Maybe<StringFilter>;
  petSpecies?: Maybe<StringNullableFilter>;
  summary?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum ConsultationScalarFieldEnum {
  CallType = 'callType',
  CancelledAt = 'cancelledAt',
  ClientCost = 'clientCost',
  ClinicId = 'clinicId',
  ConsultationState = 'consultationState',
  ConsultationType = 'consultationType',
  Cost = 'cost',
  CreatedAt = 'createdAt',
  CreatedAtCopy = 'createdAtCopy',
  Details = 'details',
  FirebaseId = 'firebaseId',
  Id = 'id',
  IsPhoneAllowed = 'isPhoneAllowed',
  IsVetEmailed = 'isVetEmailed',
  IsVideoAllowed = 'isVideoAllowed',
  IsVideoChat = 'isVideoChat',
  LastMessageAt = 'lastMessageAt',
  NurseId = 'nurseId',
  OpenedAt = 'openedAt',
  PetId = 'petId',
  PetParentId = 'petParentId',
  ResolvedAt = 'resolvedAt',
  ScheduledAt = 'scheduledAt',
  Summary = 'summary',
  TransactionId = 'transactionId',
  Treat = 'treat',
  UpdatedAt = 'updatedAt',
  VeterinarianId = 'veterinarianId'
}

export type ConsultationScalarWhereInput = {
  AND?: Maybe<Array<ConsultationScalarWhereInput>>;
  NOT?: Maybe<Array<ConsultationScalarWhereInput>>;
  OR?: Maybe<Array<ConsultationScalarWhereInput>>;
  callType?: Maybe<StringNullableFilter>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  clientCost?: Maybe<FloatNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  consultationState?: Maybe<StringFilter>;
  consultationType?: Maybe<StringFilter>;
  cost?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdAtCopy?: Maybe<DateTimeNullableFilter>;
  details?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isPhoneAllowed?: Maybe<BoolNullableFilter>;
  isVetEmailed?: Maybe<BoolNullableFilter>;
  isVideoAllowed?: Maybe<BoolNullableFilter>;
  isVideoChat?: Maybe<BoolNullableFilter>;
  lastMessageAt?: Maybe<DateTimeNullableFilter>;
  nurseId?: Maybe<StringNullableFilter>;
  openedAt?: Maybe<DateTimeNullableFilter>;
  petId?: Maybe<StringNullableFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  resolvedAt?: Maybe<DateTimeNullableFilter>;
  scheduledAt?: Maybe<DateTimeNullableFilter>;
  summary?: Maybe<StringNullableFilter>;
  transactionId?: Maybe<StringNullableFilter>;
  treat?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  veterinarianId?: Maybe<StringNullableFilter>;
};

export type ConsultationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ConsultationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ConsultationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ConsultationScalarWhereWithAggregatesInput>>;
  callType?: Maybe<StringNullableWithAggregatesFilter>;
  cancelledAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  clientCost?: Maybe<FloatNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  consultationState?: Maybe<StringWithAggregatesFilter>;
  consultationType?: Maybe<StringWithAggregatesFilter>;
  cost?: Maybe<FloatNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  createdAtCopy?: Maybe<DateTimeNullableWithAggregatesFilter>;
  details?: Maybe<StringNullableWithAggregatesFilter>;
  firebaseId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isPhoneAllowed?: Maybe<BoolNullableWithAggregatesFilter>;
  isVetEmailed?: Maybe<BoolNullableWithAggregatesFilter>;
  isVideoAllowed?: Maybe<BoolNullableWithAggregatesFilter>;
  isVideoChat?: Maybe<BoolNullableWithAggregatesFilter>;
  lastMessageAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  nurseId?: Maybe<StringNullableWithAggregatesFilter>;
  openedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  petId?: Maybe<StringNullableWithAggregatesFilter>;
  petParentId?: Maybe<StringNullableWithAggregatesFilter>;
  resolvedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  scheduledAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  summary?: Maybe<StringNullableWithAggregatesFilter>;
  transactionId?: Maybe<StringNullableWithAggregatesFilter>;
  treat?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  veterinarianId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type ConsultationSumAggregateOutputType = {
  __typename?: 'ConsultationSumAggregateOutputType';
  clientCost?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
};

export type ConsultationSumOrderByAggregateInput = {
  clientCost?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
};

export type ConsultationUncheckedCreateInput = {
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutClinicInput>>;
  createMany?: Maybe<ConsultationCreateManyClinicInputEnvelope>;
};

export type ConsultationUncheckedCreateNestedManyWithoutNurseInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutNurseInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutNurseInput>>;
  createMany?: Maybe<ConsultationCreateManyNurseInputEnvelope>;
};

export type ConsultationUncheckedCreateNestedManyWithoutPetInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutPetInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutPetInput>>;
  createMany?: Maybe<ConsultationCreateManyPetInputEnvelope>;
};

export type ConsultationUncheckedCreateNestedManyWithoutPetParentInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutPetParentInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutPetParentInput>>;
  createMany?: Maybe<ConsultationCreateManyPetParentInputEnvelope>;
};

export type ConsultationUncheckedCreateNestedManyWithoutPicsInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutPicsInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutPicsInput>>;
};

export type ConsultationUncheckedCreateNestedManyWithoutVetInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutVetInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutVetInput>>;
  createMany?: Maybe<ConsultationCreateManyVetInputEnvelope>;
};

export type ConsultationUncheckedCreateWithoutAppointmentsInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedCreateWithoutChatsInput = {
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedCreateWithoutClinicInput = {
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedCreateWithoutNurseInput = {
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedCreateWithoutPetInput = {
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedCreateWithoutPetParentInput = {
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedCreateWithoutPicsInput = {
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedCreateWithoutTransactionsInput = {
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedCreateWithoutVetInput = {
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutConsultationInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutConsultationInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedCreateNestedManyWithoutConsultationInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedCreateNestedManyWithoutConsultationInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationUncheckedUpdateInput = {
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateManyInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateManyWithoutClinicInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutClinicInput>>;
  createMany?: Maybe<ConsultationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ConsultationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ConsultationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ConsultationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ConsultationUncheckedUpdateManyWithoutNurseInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateManyWithoutNurseNestedInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutNurseInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutNurseInput>>;
  createMany?: Maybe<ConsultationCreateManyNurseInputEnvelope>;
  delete?: Maybe<Array<ConsultationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationUpdateWithWhereUniqueWithoutNurseInput>>;
  updateMany?: Maybe<Array<ConsultationUpdateManyWithWhereWithoutNurseInput>>;
  upsert?: Maybe<Array<ConsultationUpsertWithWhereUniqueWithoutNurseInput>>;
};

export type ConsultationUncheckedUpdateManyWithoutPetInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateManyWithoutPetNestedInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutPetInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutPetInput>>;
  createMany?: Maybe<ConsultationCreateManyPetInputEnvelope>;
  delete?: Maybe<Array<ConsultationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationUpdateWithWhereUniqueWithoutPetInput>>;
  updateMany?: Maybe<Array<ConsultationUpdateManyWithWhereWithoutPetInput>>;
  upsert?: Maybe<Array<ConsultationUpsertWithWhereUniqueWithoutPetInput>>;
};

export type ConsultationUncheckedUpdateManyWithoutPetParentInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateManyWithoutPetParentNestedInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutPetParentInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutPetParentInput>>;
  createMany?: Maybe<ConsultationCreateManyPetParentInputEnvelope>;
  delete?: Maybe<Array<ConsultationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationUpdateWithWhereUniqueWithoutPetParentInput>>;
  updateMany?: Maybe<Array<ConsultationUpdateManyWithWhereWithoutPetParentInput>>;
  upsert?: Maybe<Array<ConsultationUpsertWithWhereUniqueWithoutPetParentInput>>;
};

export type ConsultationUncheckedUpdateManyWithoutPicsInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateManyWithoutPicsNestedInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutPicsInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutPicsInput>>;
  delete?: Maybe<Array<ConsultationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationUpdateWithWhereUniqueWithoutPicsInput>>;
  updateMany?: Maybe<Array<ConsultationUpdateManyWithWhereWithoutPicsInput>>;
  upsert?: Maybe<Array<ConsultationUpsertWithWhereUniqueWithoutPicsInput>>;
};

export type ConsultationUncheckedUpdateManyWithoutVetInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationUncheckedUpdateManyWithoutVetNestedInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutVetInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutVetInput>>;
  createMany?: Maybe<ConsultationCreateManyVetInputEnvelope>;
  delete?: Maybe<Array<ConsultationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationUpdateWithWhereUniqueWithoutVetInput>>;
  updateMany?: Maybe<Array<ConsultationUpdateManyWithWhereWithoutVetInput>>;
  upsert?: Maybe<Array<ConsultationUpsertWithWhereUniqueWithoutVetInput>>;
};

export type ConsultationUncheckedUpdateWithoutAppointmentsInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateWithoutChatsInput = {
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateWithoutClinicInput = {
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateWithoutNurseInput = {
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateWithoutPetInput = {
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateWithoutPetParentInput = {
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateWithoutPicsInput = {
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateWithoutTransactionsInput = {
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type ConsultationUncheckedUpdateWithoutVetInput = {
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petId?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  pics?: Maybe<ImageUncheckedUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationUpdateInput = {
  appointments?: Maybe<AppointmentUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutConsultationsNestedInput>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoUpdateOneWithoutConsultationsIdNestedInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetUpdateOneWithoutConsultationsNestedInput>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutConsultationsNestedInput>;
  pics?: Maybe<ImageUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoUpdateOneWithoutConsultationsNestedInput>;
};

export type ConsultationUpdateManyMutationInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationUpdateManyWithWhereWithoutClinicInput = {
  data: ConsultationUpdateManyMutationInput;
  where: ConsultationScalarWhereInput;
};

export type ConsultationUpdateManyWithWhereWithoutNurseInput = {
  data: ConsultationUpdateManyMutationInput;
  where: ConsultationScalarWhereInput;
};

export type ConsultationUpdateManyWithWhereWithoutPetInput = {
  data: ConsultationUpdateManyMutationInput;
  where: ConsultationScalarWhereInput;
};

export type ConsultationUpdateManyWithWhereWithoutPetParentInput = {
  data: ConsultationUpdateManyMutationInput;
  where: ConsultationScalarWhereInput;
};

export type ConsultationUpdateManyWithWhereWithoutPicsInput = {
  data: ConsultationUpdateManyMutationInput;
  where: ConsultationScalarWhereInput;
};

export type ConsultationUpdateManyWithWhereWithoutVetInput = {
  data: ConsultationUpdateManyMutationInput;
  where: ConsultationScalarWhereInput;
};

export type ConsultationUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutClinicInput>>;
  createMany?: Maybe<ConsultationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ConsultationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ConsultationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ConsultationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ConsultationUpdateManyWithoutNurseNestedInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutNurseInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutNurseInput>>;
  createMany?: Maybe<ConsultationCreateManyNurseInputEnvelope>;
  delete?: Maybe<Array<ConsultationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationUpdateWithWhereUniqueWithoutNurseInput>>;
  updateMany?: Maybe<Array<ConsultationUpdateManyWithWhereWithoutNurseInput>>;
  upsert?: Maybe<Array<ConsultationUpsertWithWhereUniqueWithoutNurseInput>>;
};

export type ConsultationUpdateManyWithoutPetNestedInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutPetInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutPetInput>>;
  createMany?: Maybe<ConsultationCreateManyPetInputEnvelope>;
  delete?: Maybe<Array<ConsultationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationUpdateWithWhereUniqueWithoutPetInput>>;
  updateMany?: Maybe<Array<ConsultationUpdateManyWithWhereWithoutPetInput>>;
  upsert?: Maybe<Array<ConsultationUpsertWithWhereUniqueWithoutPetInput>>;
};

export type ConsultationUpdateManyWithoutPetParentNestedInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutPetParentInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutPetParentInput>>;
  createMany?: Maybe<ConsultationCreateManyPetParentInputEnvelope>;
  delete?: Maybe<Array<ConsultationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationUpdateWithWhereUniqueWithoutPetParentInput>>;
  updateMany?: Maybe<Array<ConsultationUpdateManyWithWhereWithoutPetParentInput>>;
  upsert?: Maybe<Array<ConsultationUpsertWithWhereUniqueWithoutPetParentInput>>;
};

export type ConsultationUpdateManyWithoutPicsNestedInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutPicsInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutPicsInput>>;
  delete?: Maybe<Array<ConsultationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationUpdateWithWhereUniqueWithoutPicsInput>>;
  updateMany?: Maybe<Array<ConsultationUpdateManyWithWhereWithoutPicsInput>>;
  upsert?: Maybe<Array<ConsultationUpsertWithWhereUniqueWithoutPicsInput>>;
};

export type ConsultationUpdateManyWithoutVetNestedInput = {
  connect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ConsultationCreateOrConnectWithoutVetInput>>;
  create?: Maybe<Array<ConsultationCreateWithoutVetInput>>;
  createMany?: Maybe<ConsultationCreateManyVetInputEnvelope>;
  delete?: Maybe<Array<ConsultationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ConsultationScalarWhereInput>>;
  disconnect?: Maybe<Array<ConsultationWhereUniqueInput>>;
  set?: Maybe<Array<ConsultationWhereUniqueInput>>;
  update?: Maybe<Array<ConsultationUpdateWithWhereUniqueWithoutVetInput>>;
  updateMany?: Maybe<Array<ConsultationUpdateManyWithWhereWithoutVetInput>>;
  upsert?: Maybe<Array<ConsultationUpsertWithWhereUniqueWithoutVetInput>>;
};

export type ConsultationUpdateOneWithoutAppointmentsNestedInput = {
  connect?: Maybe<ConsultationWhereUniqueInput>;
  connectOrCreate?: Maybe<ConsultationCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<ConsultationCreateWithoutAppointmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ConsultationUpdateToOneWithWhereWithoutAppointmentsInput>;
  upsert?: Maybe<ConsultationUpsertWithoutAppointmentsInput>;
};

export type ConsultationUpdateOneWithoutChatsNestedInput = {
  connect?: Maybe<ConsultationWhereUniqueInput>;
  connectOrCreate?: Maybe<ConsultationCreateOrConnectWithoutChatsInput>;
  create?: Maybe<ConsultationCreateWithoutChatsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ConsultationUpdateToOneWithWhereWithoutChatsInput>;
  upsert?: Maybe<ConsultationUpsertWithoutChatsInput>;
};

export type ConsultationUpdateOneWithoutTransactionsNestedInput = {
  connect?: Maybe<ConsultationWhereUniqueInput>;
  connectOrCreate?: Maybe<ConsultationCreateOrConnectWithoutTransactionsInput>;
  create?: Maybe<ConsultationCreateWithoutTransactionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ConsultationUpdateToOneWithWhereWithoutTransactionsInput>;
  upsert?: Maybe<ConsultationUpsertWithoutTransactionsInput>;
};

export type ConsultationUpdateToOneWithWhereWithoutAppointmentsInput = {
  data: ConsultationUpdateWithoutAppointmentsInput;
  where?: Maybe<ConsultationWhereInput>;
};

export type ConsultationUpdateToOneWithWhereWithoutChatsInput = {
  data: ConsultationUpdateWithoutChatsInput;
  where?: Maybe<ConsultationWhereInput>;
};

export type ConsultationUpdateToOneWithWhereWithoutTransactionsInput = {
  data: ConsultationUpdateWithoutTransactionsInput;
  where?: Maybe<ConsultationWhereInput>;
};

export type ConsultationUpdateWithWhereUniqueWithoutClinicInput = {
  data: ConsultationUpdateWithoutClinicInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationUpdateWithWhereUniqueWithoutNurseInput = {
  data: ConsultationUpdateWithoutNurseInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationUpdateWithWhereUniqueWithoutPetInput = {
  data: ConsultationUpdateWithoutPetInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationUpdateWithWhereUniqueWithoutPetParentInput = {
  data: ConsultationUpdateWithoutPetParentInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationUpdateWithWhereUniqueWithoutPicsInput = {
  data: ConsultationUpdateWithoutPicsInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationUpdateWithWhereUniqueWithoutVetInput = {
  data: ConsultationUpdateWithoutVetInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationUpdateWithoutAppointmentsInput = {
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutConsultationsNestedInput>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoUpdateOneWithoutConsultationsIdNestedInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetUpdateOneWithoutConsultationsNestedInput>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutConsultationsNestedInput>;
  pics?: Maybe<ImageUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoUpdateOneWithoutConsultationsNestedInput>;
};

export type ConsultationUpdateWithoutChatsInput = {
  appointments?: Maybe<AppointmentUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutConsultationsNestedInput>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoUpdateOneWithoutConsultationsIdNestedInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetUpdateOneWithoutConsultationsNestedInput>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutConsultationsNestedInput>;
  pics?: Maybe<ImageUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoUpdateOneWithoutConsultationsNestedInput>;
};

export type ConsultationUpdateWithoutClinicInput = {
  appointments?: Maybe<AppointmentUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoUpdateOneWithoutConsultationsIdNestedInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetUpdateOneWithoutConsultationsNestedInput>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutConsultationsNestedInput>;
  pics?: Maybe<ImageUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoUpdateOneWithoutConsultationsNestedInput>;
};

export type ConsultationUpdateWithoutNurseInput = {
  appointments?: Maybe<AppointmentUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutConsultationsNestedInput>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetUpdateOneWithoutConsultationsNestedInput>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutConsultationsNestedInput>;
  pics?: Maybe<ImageUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoUpdateOneWithoutConsultationsNestedInput>;
};

export type ConsultationUpdateWithoutPetInput = {
  appointments?: Maybe<AppointmentUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutConsultationsNestedInput>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoUpdateOneWithoutConsultationsIdNestedInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutConsultationsNestedInput>;
  pics?: Maybe<ImageUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoUpdateOneWithoutConsultationsNestedInput>;
};

export type ConsultationUpdateWithoutPetParentInput = {
  appointments?: Maybe<AppointmentUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutConsultationsNestedInput>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoUpdateOneWithoutConsultationsIdNestedInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetUpdateOneWithoutConsultationsNestedInput>;
  pics?: Maybe<ImageUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoUpdateOneWithoutConsultationsNestedInput>;
};

export type ConsultationUpdateWithoutPicsInput = {
  appointments?: Maybe<AppointmentUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutConsultationsNestedInput>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoUpdateOneWithoutConsultationsIdNestedInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetUpdateOneWithoutConsultationsNestedInput>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutConsultationsNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoUpdateOneWithoutConsultationsNestedInput>;
};

export type ConsultationUpdateWithoutTransactionsInput = {
  appointments?: Maybe<AppointmentUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutConsultationsNestedInput>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoUpdateOneWithoutConsultationsIdNestedInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetUpdateOneWithoutConsultationsNestedInput>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutConsultationsNestedInput>;
  pics?: Maybe<ImageUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vet?: Maybe<VetInfoUpdateOneWithoutConsultationsNestedInput>;
};

export type ConsultationUpdateWithoutVetInput = {
  appointments?: Maybe<AppointmentUpdateManyWithoutConsultationNestedInput>;
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chats?: Maybe<ConsultationChatUpdateManyWithoutConsultationNestedInput>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutConsultationsNestedInput>;
  consultationState?: Maybe<Scalars['String']>;
  consultationType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfoUpdateOneWithoutConsultationsIdNestedInput>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<PetUpdateOneWithoutConsultationsNestedInput>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutConsultationsNestedInput>;
  pics?: Maybe<ImageUpdateManyWithoutConsultationNestedInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUpdateManyWithoutConsultationNestedInput>;
  treat?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConsultationUpsertWithWhereUniqueWithoutClinicInput = {
  create: ConsultationCreateWithoutClinicInput;
  update: ConsultationUpdateWithoutClinicInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationUpsertWithWhereUniqueWithoutNurseInput = {
  create: ConsultationCreateWithoutNurseInput;
  update: ConsultationUpdateWithoutNurseInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationUpsertWithWhereUniqueWithoutPetInput = {
  create: ConsultationCreateWithoutPetInput;
  update: ConsultationUpdateWithoutPetInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationUpsertWithWhereUniqueWithoutPetParentInput = {
  create: ConsultationCreateWithoutPetParentInput;
  update: ConsultationUpdateWithoutPetParentInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationUpsertWithWhereUniqueWithoutPicsInput = {
  create: ConsultationCreateWithoutPicsInput;
  update: ConsultationUpdateWithoutPicsInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationUpsertWithWhereUniqueWithoutVetInput = {
  create: ConsultationCreateWithoutVetInput;
  update: ConsultationUpdateWithoutVetInput;
  where: ConsultationWhereUniqueInput;
};

export type ConsultationUpsertWithoutAppointmentsInput = {
  create: ConsultationCreateWithoutAppointmentsInput;
  update: ConsultationUpdateWithoutAppointmentsInput;
  where?: Maybe<ConsultationWhereInput>;
};

export type ConsultationUpsertWithoutChatsInput = {
  create: ConsultationCreateWithoutChatsInput;
  update: ConsultationUpdateWithoutChatsInput;
  where?: Maybe<ConsultationWhereInput>;
};

export type ConsultationUpsertWithoutTransactionsInput = {
  create: ConsultationCreateWithoutTransactionsInput;
  update: ConsultationUpdateWithoutTransactionsInput;
  where?: Maybe<ConsultationWhereInput>;
};

export type ConsultationWhereInput = {
  AND?: Maybe<Array<ConsultationWhereInput>>;
  NOT?: Maybe<Array<ConsultationWhereInput>>;
  OR?: Maybe<Array<ConsultationWhereInput>>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  callType?: Maybe<StringNullableFilter>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  chats?: Maybe<ConsultationChatListRelationFilter>;
  clientCost?: Maybe<FloatNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  consultationState?: Maybe<StringFilter>;
  consultationType?: Maybe<StringFilter>;
  cost?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdAtCopy?: Maybe<DateTimeNullableFilter>;
  details?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isPhoneAllowed?: Maybe<BoolNullableFilter>;
  isVetEmailed?: Maybe<BoolNullableFilter>;
  isVideoAllowed?: Maybe<BoolNullableFilter>;
  isVideoChat?: Maybe<BoolNullableFilter>;
  lastMessageAt?: Maybe<DateTimeNullableFilter>;
  nurse?: Maybe<VetInfoNullableScalarRelationFilter>;
  nurseId?: Maybe<StringNullableFilter>;
  openedAt?: Maybe<DateTimeNullableFilter>;
  pet?: Maybe<PetNullableScalarRelationFilter>;
  petId?: Maybe<StringNullableFilter>;
  petParent?: Maybe<OwnerInfoNullableScalarRelationFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  pics?: Maybe<ImageListRelationFilter>;
  resolvedAt?: Maybe<DateTimeNullableFilter>;
  scheduledAt?: Maybe<DateTimeNullableFilter>;
  summary?: Maybe<StringNullableFilter>;
  transactionId?: Maybe<StringNullableFilter>;
  transactions?: Maybe<TransactionListRelationFilter>;
  treat?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vet?: Maybe<VetInfoNullableScalarRelationFilter>;
  veterinarianId?: Maybe<StringNullableFilter>;
};

export type ConsultationWhereUniqueInput = {
  AND?: Maybe<Array<ConsultationWhereInput>>;
  NOT?: Maybe<Array<ConsultationWhereInput>>;
  OR?: Maybe<Array<ConsultationWhereInput>>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  callType?: Maybe<StringNullableFilter>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  chats?: Maybe<ConsultationChatListRelationFilter>;
  clientCost?: Maybe<FloatNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  consultationState?: Maybe<StringFilter>;
  consultationType?: Maybe<StringFilter>;
  cost?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdAtCopy?: Maybe<DateTimeNullableFilter>;
  details?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPhoneAllowed?: Maybe<BoolNullableFilter>;
  isVetEmailed?: Maybe<BoolNullableFilter>;
  isVideoAllowed?: Maybe<BoolNullableFilter>;
  isVideoChat?: Maybe<BoolNullableFilter>;
  lastMessageAt?: Maybe<DateTimeNullableFilter>;
  nurse?: Maybe<VetInfoNullableScalarRelationFilter>;
  nurseId?: Maybe<StringNullableFilter>;
  openedAt?: Maybe<DateTimeNullableFilter>;
  pet?: Maybe<PetNullableScalarRelationFilter>;
  petId?: Maybe<StringNullableFilter>;
  petParent?: Maybe<OwnerInfoNullableScalarRelationFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  pics?: Maybe<ImageListRelationFilter>;
  resolvedAt?: Maybe<DateTimeNullableFilter>;
  scheduledAt?: Maybe<DateTimeNullableFilter>;
  summary?: Maybe<StringNullableFilter>;
  transactionId?: Maybe<StringNullableFilter>;
  transactions?: Maybe<TransactionListRelationFilter>;
  treat?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vet?: Maybe<VetInfoNullableScalarRelationFilter>;
  veterinarianId?: Maybe<StringNullableFilter>;
};

export enum ContactEntityType {
  ClinicPetParent = 'ClinicPetParent',
  User = 'User'
}

export enum ContactVerificationMethod {
  Email = 'Email',
  Text = 'Text'
}

export enum ContextEntityType {
  Appointment = 'Appointment',
  AutomationRunAction = 'AutomationRunAction'
}

export type CreateCallHistoryInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicPetParentPhoneNumber?: Maybe<Scalars['String']>;
  clinicPhoneNumber?: Maybe<Scalars['String']>;
  direction: CallDirection;
  provider: CallProvider;
  sourceId: Scalars['String'];
  status?: Maybe<CallStatus>;
  type: CallHistoryType;
};

export type CreateCareEnrollmentAndSubscriptionInput = {
  petSignups: Array<CarePetSignupInput>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
};

export type CreateCareEnrollmentAndSubscriptionResult = {
  __typename?: 'CreateCareEnrollmentAndSubscriptionResult';
  message: Scalars['String'];
  paymentError?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreateCarePaymentMethodSetupInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
};

export type CreateChannelFilterSelectionInput = {
  filterSelectionType: FilterSelectionType;
  filters: Scalars['Json'];
  name: Scalars['String'];
};

export type CreateClinicWidgetRequestResponse = {
  __typename?: 'CreateClinicWidgetRequestResponse';
  channelId: Scalars['String'];
  clinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
};

export type CreateEmailTemplateVersionInput = {
  design: Scalars['Json'];
  html: Scalars['String'];
  type: Scalars['String'];
  unlayerId: Scalars['Int'];
};

export type CreateManyActiveIngredientAndReturnOutputType = {
  __typename?: 'CreateManyActiveIngredientAndReturnOutputType';
  chemicalCompound: ChemicalCompound;
  chemicalCompoundId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  massPerDose?: Maybe<Scalars['Float']>;
  massPerDoseUnit?: Maybe<Scalars['String']>;
  product: Product;
  productId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyAiRecapPimsWritebackLogEntryAndReturnOutputType = {
  __typename?: 'CreateManyAiRecapPimsWritebackLogEntryAndReturnOutputType';
  appointment: Appointment;
  appointmentId: Scalars['String'];
  writebackLog: PimsWritebackLogEntry;
  writebackLogId: Scalars['String'];
};

export type CreateManyApiKeyAndReturnOutputType = {
  __typename?: 'CreateManyApiKeyAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationType?: Maybe<IntegrationType>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyAppointmentAndReturnOutputType = {
  __typename?: 'CreateManyAppointmentAndReturnOutputType';
  appointmentType?: Maybe<AppointmentType>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['String']>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  consultation?: Maybe<Consultation>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsExportConsultationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsStatus?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  recapNotes?: Maybe<Scalars['String']>;
  recapNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  recapNotesUpdatedBy?: Maybe<User>;
  recapNotesUpdatedByUserId?: Maybe<Scalars['String']>;
  room?: Maybe<ClinicRoom>;
  roomId?: Maybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  status: AppointmentStatus;
  taxonomy?: Maybe<Taxonomy>;
  taxonomyId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  workflow?: Maybe<WorkflowType>;
};

export type CreateManyAppointmentAvailabilityAndReturnOutputType = {
  __typename?: 'CreateManyAppointmentAvailabilityAndReturnOutputType';
  availabilities?: Maybe<Array<Scalars['DateTime']>>;
  clinic?: Maybe<Clinic>;
  clinicEmployee?: Maybe<ClinicEmployee>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  isProvider?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  room?: Maybe<ClinicRoom>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyAppointmentNoteTemplateAndReturnOutputType = {
  __typename?: 'CreateManyAppointmentNoteTemplateAndReturnOutputType';
  body: Scalars['String'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
};

export type CreateManyAppointmentTypeAndReturnOutputType = {
  __typename?: 'CreateManyAppointmentTypeAndReturnOutputType';
  appointmentTypeVisibility: AppointmentTypeVisibility;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultDurationInMinutes: Scalars['Int'];
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount: Scalars['Int'];
  depositCurrency: Currency;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasDeposit: Scalars['Boolean'];
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isAvailableForDirectBooking: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  markPaymentAsDeposit: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  showInPetPortal: Scalars['Boolean'];
  taxonomy?: Maybe<Taxonomy>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyAutomationRunActionAndReturnOutputType = {
  __typename?: 'CreateManyAutomationRunActionAndReturnOutputType';
  actionType: AutomationRunActionType;
  attachments: Scalars['Json'];
  automationAction?: Maybe<WorkflowEventAction>;
  automationActionId?: Maybe<Scalars['String']>;
  automationRun: AutomationRun;
  automationRunId: Scalars['String'];
  body: Scalars['String'];
  buttons: Scalars['Json'];
  channelStatusChange?: Maybe<ChannelStatus>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  formSubmission?: Maybe<FormSubmission>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  order: Scalars['Int'];
  paymentIntent?: Maybe<StripePaymentIntent>;
  paymentIntentId?: Maybe<Scalars['String']>;
  pet?: Maybe<ClinicPet>;
  petId?: Maybe<Scalars['String']>;
  petParent?: Maybe<ClinicPetParent>;
  petParentId?: Maybe<Scalars['String']>;
  promptType: AutomationRunActionPromptType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyAutomationRunAndReturnOutputType = {
  __typename?: 'CreateManyAutomationRunAndReturnOutputType';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  automationEvent: WorkflowEvent;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  channelMessage: ChannelMessage;
  channelMessageId: Scalars['String'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  formSubmission?: Maybe<FormSubmission>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invioceLineItem?: Maybe<InvoiceLineItem>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  manuallySentBy?: Maybe<User>;
  manuallySentById?: Maybe<Scalars['String']>;
  originAutomation: WorkflowEventSetting;
  originAutomationId: Scalars['String'];
  returnToAutomationAction?: Maybe<WorkflowEventAction>;
  returnToAutomationActionId?: Maybe<Scalars['String']>;
  runType: AutomationRunType;
  serviceReminder?: Maybe<ServiceReminder>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  status: AutomationRunStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyAxionClinicConfigurationAndReturnOutputType = {
  __typename?: 'CreateManyAxionClinicConfigurationAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  domain: Scalars['String'];
  id: Scalars['String'];
  status: AxionClinicConfigurationStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyAxionClinicUserConfigurationAndReturnOutputType = {
  __typename?: 'CreateManyAxionClinicUserConfigurationAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  extension: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type CreateManyBedrockInferenceAndReturnOutputType = {
  __typename?: 'CreateManyBedrockInferenceAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  input: Scalars['String'];
  result: Scalars['String'];
  taxonomy?: Maybe<Taxonomy>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyBitwerxHealthcheckAndReturnOutputType = {
  __typename?: 'CreateManyBitwerxHealthcheckAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  startsAt: Scalars['DateTime'];
  type: BitwerxHealthcheckType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyBitwerxIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyBitwerxIntegrationAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isMultiSite: Scalars['Boolean'];
  locationId?: Maybe<Scalars['String']>;
  practiceId: Scalars['String'];
  system: BitwerxSystem;
  updatedAt: Scalars['DateTime'];
  writebackPaymentTypeId?: Maybe<Scalars['String']>;
};

export type CreateManyBitwerxPaymentHealthcheckResultAndReturnOutputType = {
  __typename?: 'CreateManyBitwerxPaymentHealthcheckResultAndReturnOutputType';
  bitwerxPaymentHealthcheckRunId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endpoint: BitwerxPaymentEndpoint;
  error?: Maybe<Scalars['String']>;
  healthcheckRun: BitwerxPaymentHealthcheckRun;
  httpCode?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  responseTime: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyBitwerxPaymentHealthcheckRunAndReturnOutputType = {
  __typename?: 'CreateManyBitwerxPaymentHealthcheckRunAndReturnOutputType';
  averageRequestCount?: Maybe<Scalars['Float']>;
  averageResponseTime?: Maybe<Scalars['Float']>;
  bitwerxHealthcheck: BitwerxHealthcheck;
  bitwerxHealthcheckId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  historicWeeksBack: Scalars['Int'];
  id: Scalars['String'];
  status?: Maybe<BitwerxHealthcheckRunStatus>;
  triggeredAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyBitwerxPaymentWritebackConfigurationAndReturnOutputType = {
  __typename?: 'CreateManyBitwerxPaymentWritebackConfigurationAndReturnOutputType';
  amexPimsPaymentType?: Maybe<PimsPaymentType>;
  amexPimsPaymentTypeId?: Maybe<Scalars['String']>;
  balanceRetriesEnabled: Scalars['Boolean'];
  careDiscountPimsPaymentType?: Maybe<PimsPaymentType>;
  careDiscountPimsPaymentTypeId?: Maybe<Scalars['String']>;
  careEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  defaultPimsPaymentType?: Maybe<PimsPaymentType>;
  defaultPimsPaymentTypeId?: Maybe<Scalars['String']>;
  discoverPimsPaymentType?: Maybe<PimsPaymentType>;
  discoverPimsPaymentTypeId?: Maybe<Scalars['String']>;
  enteredBy?: Maybe<ClinicEmployee>;
  enteredById?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  mastercardPimsPaymentType?: Maybe<PimsPaymentType>;
  mastercardPimsPaymentTypeId?: Maybe<Scalars['String']>;
  paymentsEnabled: Scalars['Boolean'];
  retriesEnabled: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  visaPimsPaymentType?: Maybe<PimsPaymentType>;
  visaPimsPaymentTypeId?: Maybe<Scalars['String']>;
  writebackManualPayment: Scalars['Boolean'];
};

export type CreateManyBoardFilterColumnAndReturnOutputType = {
  __typename?: 'CreateManyBoardFilterColumnAndReturnOutputType';
  channelStatus?: Maybe<ChannelStatus>;
  channelStatusId: Scalars['String'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  id: Scalars['String'];
  type: BoardFilterColumnType;
  userBoardFilter?: Maybe<UserBoardFilter>;
  userBoardFilterId: Scalars['String'];
};

export type CreateManyBoardFilterSpecificDateRangeAndReturnOutputType = {
  __typename?: 'CreateManyBoardFilterSpecificDateRangeAndReturnOutputType';
  gte: Scalars['DateTime'];
  id: Scalars['String'];
  lte: Scalars['DateTime'];
  userBoardFilter?: Maybe<UserBoardFilter>;
  userBoardFilterId: Scalars['String'];
};

export type CreateManyBoehringerIngelheimCustomerAlignmentAndReturnOutputType = {
  __typename?: 'CreateManyBoehringerIngelheimCustomerAlignmentAndReturnOutputType';
  boehringerIngelheimTerritory: BoehringerIngelheimTerritory;
  boehringerIngelheimTerritoryId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informPartnerCustomer: InformPartnerCustomer;
  informPartnerCustomerId: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  soldToId: Scalars['Int'];
  status: BoehringerIngelheimCustomerAlignmentStatus;
  territoryName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyBoehringerIngelheimTerritoryAndReturnOutputType = {
  __typename?: 'CreateManyBoehringerIngelheimTerritoryAndReturnOutputType';
  countryCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  enterpriseSegment?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  parentTerritory?: Maybe<BoehringerIngelheimTerritory>;
  parentTerritoryId?: Maybe<Scalars['String']>;
  parentTerritoryName?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  territoryDescription?: Maybe<Scalars['String']>;
  territoryName: Scalars['String'];
  territoryType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyBreedAndReturnOutputType = {
  __typename?: 'CreateManyBreedAndReturnOutputType';
  bedrockInference?: Maybe<BedrockInference>;
  bedrockInferenceId?: Maybe<Scalars['String']>;
  canonicalBreed?: Maybe<CanonicalBreed>;
  canonicalBreedId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  normalizedName?: Maybe<Scalars['Json']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<Species>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCallHistoryAndReturnOutputType = {
  __typename?: 'CreateManyCallHistoryAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  direction: CallDirection;
  duration?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  id: Scalars['String'];
  provider: CallProvider;
  sourceId: Scalars['String'];
  status: CallStatus;
  to?: Maybe<Scalars['String']>;
  type: CallHistoryType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCallParticipantAndReturnOutputType = {
  __typename?: 'CreateManyCallParticipantAndReturnOutputType';
  axionEndpointId?: Maybe<Scalars['String']>;
  callHistory: CallHistory;
  callHistoryId: Scalars['String'];
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  extension?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  number?: Maybe<Scalars['String']>;
  result?: Maybe<CallParticipantResult>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type CreateManyCallRecordingAndReturnOutputType = {
  __typename?: 'CreateManyCallRecordingAndReturnOutputType';
  callHistory: CallHistory;
  callHistoryId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  downloadStatus: RecordingDownloadStatus;
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  s3Uri: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCampaignRegistryCampaignAndReturnOutputType = {
  __typename?: 'CreateManyCampaignRegistryCampaignAndReturnOutputType';
  clinicSetting: ClinicSetting;
  clinicSettingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  importedAt?: Maybe<Scalars['DateTime']>;
  isDeleted: Scalars['Boolean'];
  mnoMetaData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  sharingStatus?: Maybe<CampaignRegistryCampaignSharingStatus>;
  sourceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  upstreamCnpId?: Maybe<Scalars['String']>;
};

export type CreateManyCanonicalBreedAndReturnOutputType = {
  __typename?: 'CreateManyCanonicalBreedAndReturnOutputType';
  avgHeightInCm?: Maybe<Scalars['Float']>;
  avgLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  avgWeightInKg?: Maybe<Scalars['Float']>;
  canonicalSpecies: CanonicalSpecies;
  canonicalSpeciesId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  maxHeightInCm?: Maybe<Scalars['Float']>;
  maxLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minHeightInCm?: Maybe<Scalars['Float']>;
  minLifeExpectancyInYears?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  source: CanonicalDataSource;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCanonicalCanineBreedProfileAndReturnOutputType = {
  __typename?: 'CreateManyCanonicalCanineBreedProfileAndReturnOutputType';
  breedGroup?: Maybe<AmericanKennelClubBreedGroup>;
  canonicalBreed: CanonicalBreed;
  canonicalBreedId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  demeanor?: Maybe<Scalars['Float']>;
  demeanorCategory?: Maybe<AmericanKennelClubDemeanorCategory>;
  energyLevel?: Maybe<Scalars['Float']>;
  energyLevelCategory?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  groomingFrequency?: Maybe<Scalars['Float']>;
  groomingFrequencyCategory?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  id: Scalars['String'];
  popularity?: Maybe<Scalars['Int']>;
  sheddingCategory?: Maybe<AmericanKennelClubSheddingCategory>;
  sheddingValue?: Maybe<Scalars['Float']>;
  temperament?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  trainability?: Maybe<Scalars['Float']>;
  trainabilityCategory?: Maybe<AmericanKennelClubTrainabilityCategory>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCanonicalServiceAndReturnOutputType = {
  __typename?: 'CreateManyCanonicalServiceAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  status: CanonicalServiceStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  type: CanonicalServiceType;
  updatedAt: Scalars['DateTime'];
  validatedAt?: Maybe<Scalars['DateTime']>;
  validatedByUser?: Maybe<User>;
  validatedByUserId?: Maybe<Scalars['String']>;
};

export type CreateManyCanonicalSpeciesAndReturnOutputType = {
  __typename?: 'CreateManyCanonicalSpeciesAndReturnOutputType';
  class?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  family?: Maybe<Scalars['String']>;
  genus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  kingdom?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['String']>;
  phylum?: Maybe<Scalars['String']>;
  scientificName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCareAccountCreditIntentAndReturnOutputType = {
  __typename?: 'CreateManyCareAccountCreditIntentAndReturnOutputType';
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: Currency;
  followupStep?: Maybe<CareBenefitUsageFollowupStep>;
  followupStepId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoice?: Maybe<Invoice>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentDue: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCareAccountCreditPimsWritebackLogEntryAndReturnOutputType = {
  __typename?: 'CreateManyCareAccountCreditPimsWritebackLogEntryAndReturnOutputType';
  careAccountCreditIntent: CareAccountCreditIntent;
  careAccountCreditIntentId: Scalars['String'];
  writebackLog: PimsWritebackLogEntry;
  writebackLogId: Scalars['String'];
};

export type CreateManyCareAddonEnrollmentAndReturnOutputType = {
  __typename?: 'CreateManyCareAddonEnrollmentAndReturnOutputType';
  addOnPackage: CareAddonPackage;
  addOnPackageId: Scalars['String'];
  careStripeSubscription?: Maybe<CareStripeSubscription>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  organizationPet: OrganizationPet;
  organizationPetId: Scalars['String'];
  startDate: Scalars['DateTime'];
  status: EnrollmentStatus;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCareAddonPackageAndReturnOutputType = {
  __typename?: 'CreateManyCareAddonPackageAndReturnOutputType';
  addonCancelsAt?: Maybe<Scalars['DateTime']>;
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle: CarePlanCycleType;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes: Scalars['String'];
  id: Scalars['String'];
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  pricePerRenewal: Scalars['Int'];
  published: Scalars['Boolean'];
  renewalCycle: CarePlanCycleType;
  salesTaxCentsPerMonth: Scalars['Int'];
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCareAddonPackageBenefitAndReturnOutputType = {
  __typename?: 'CreateManyCareAddonPackageBenefitAndReturnOutputType';
  addOnPackage: CareAddonPackage;
  addOnPackageId: Scalars['String'];
  benefit: CareBenefit;
  benefitId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  includedUses?: Maybe<Scalars['Int']>;
  projectedSavings?: Maybe<Scalars['String']>;
  reportingExpectedUsages: Scalars['Int'];
  reportingExpectedValue: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCareAuthorizationRequestAndReturnOutputType = {
  __typename?: 'CreateManyCareAuthorizationRequestAndReturnOutputType';
  authCode: Scalars['String'];
  claimed: Scalars['Boolean'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  id: Scalars['String'];
  phoneNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCareBenefitAndReturnOutputType = {
  __typename?: 'CreateManyCareBenefitAndReturnOutputType';
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  editorNotes: Scalars['String'];
  exhaustible: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  organization: Organization;
  organizationId: Scalars['String'];
  providedDiscountPercentage?: Maybe<Scalars['Int']>;
  providesTeletriage: Scalars['Boolean'];
  reportingExpectedValue: Scalars['Int'];
  tangible: Scalars['Boolean'];
  title: Scalars['String'];
  type: CareBenefitType;
  updatedAt: Scalars['DateTime'];
  usageUnitOfMeasure?: Maybe<CareBenefitUnitOfMeasure>;
};

export type CreateManyCareBenefitUsageAndReturnOutputType = {
  __typename?: 'CreateManyCareBenefitUsageAndReturnOutputType';
  benefit: CareBenefit;
  benefitId: Scalars['String'];
  careAccountCreditIntent?: Maybe<CareAccountCreditIntent>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  connectedAddonEnrollment?: Maybe<CareAddonEnrollment>;
  connectedAddonEnrollmentId?: Maybe<Scalars['String']>;
  connectedPlanEnrollment?: Maybe<CarePlanEnrollment>;
  connectedPlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  exhaustsBenefit?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  quantityUsed?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recordedByUser?: Maybe<User>;
  recordedByUserId?: Maybe<Scalars['String']>;
  relatedFollowupStep?: Maybe<CareBenefitUsageFollowupStep>;
  relatedFollowupStepId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  usageClinic: Clinic;
  usageClinicId: Scalars['String'];
  usageClinicPet: ClinicPet;
  usageClinicPetId: Scalars['String'];
  usedAt: Scalars['DateTime'];
};

export type CreateManyCareBenefitUsageFollowupAndReturnOutputType = {
  __typename?: 'CreateManyCareBenefitUsageFollowupAndReturnOutputType';
  careStripeSubscription: CareStripeSubscription;
  careStripeSubscriptionId: Scalars['String'];
  completed: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  relatedOrganizationPet: OrganizationPet;
  relatedOrganizationPetId: Scalars['String'];
  reportingOriginalInvoiceValueCents: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCareBenefitUsageFollowupStepAndReturnOutputType = {
  __typename?: 'CreateManyCareBenefitUsageFollowupStepAndReturnOutputType';
  completed: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUser?: Maybe<User>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  displayOrder: Scalars['Int'];
  id: Scalars['String'];
  usageFollowup: CareBenefitUsageFollowup;
  usageFollowupId: Scalars['String'];
};

export type CreateManyCareBenefitUsageToInvoiceLineItemAndReturnOutputType = {
  __typename?: 'CreateManyCareBenefitUsageToInvoiceLineItemAndReturnOutputType';
  adjustedAmount: Scalars['Int'];
  associatedInvoice?: Maybe<Invoice>;
  associatedInvoiceId?: Maybe<Scalars['String']>;
  careBenefitUsage: CareBenefitUsage;
  careBenefitUsageId: Scalars['String'];
  confirmedBy?: Maybe<User>;
  confirmedByUserId?: Maybe<Scalars['String']>;
  draftService?: Maybe<Service>;
  draftServiceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoiceLineItem?: Maybe<InvoiceLineItem>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
};

export type CreateManyCareCreditPreapprovalCheckAndReturnOutputType = {
  __typename?: 'CreateManyCareCreditPreapprovalCheckAndReturnOutputType';
  applicationStatus?: Maybe<SynchronyEventStatus>;
  applicationStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  automationRun?: Maybe<AutomationRun>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  decision?: Maybe<CareCreditPreapprovalDecision>;
  decisionReachedAt: Scalars['DateTime'];
  id: Scalars['String'];
  offerExpiresAt?: Maybe<Scalars['DateTime']>;
  offerExternalId?: Maybe<Scalars['String']>;
  preapprovalUrl?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  requestBody: Scalars['Json'];
  responseBody: Scalars['Json'];
  responseStatusCode: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCareEnrollmentPaymentAndReturnOutputType = {
  __typename?: 'CreateManyCareEnrollmentPaymentAndReturnOutputType';
  amount: Scalars['Int'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  careAddonEnrollment?: Maybe<CareAddonEnrollment>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollment?: Maybe<CarePlanEnrollment>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disputedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  lastOttoPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentAttempt?: Maybe<Scalars['DateTime']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']>;
  ottoPaymentAttempts?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  stripeDispute?: Maybe<StripeDispute>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoice>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeRefund?: Maybe<StripeRefund>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCareEnrollmentToStripeInvoiceItemAndReturnOutputType = {
  __typename?: 'CreateManyCareEnrollmentToStripeInvoiceItemAndReturnOutputType';
  careAddonEnrollment?: Maybe<CareAddonEnrollment>;
  careAddonEnrollmentId?: Maybe<Scalars['String']>;
  carePlanEnrollment?: Maybe<CarePlanEnrollment>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  stripeInvoiceItem: StripeInvoiceItem;
  stripeInvoiceItemId: Scalars['String'];
};

export type CreateManyCareLapsedPaymentAndReturnOutputType = {
  __typename?: 'CreateManyCareLapsedPaymentAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  status: CareLapsedPaymentStatus;
  stripeInvoice: StripeInvoice;
  stripeInvoiceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCarePlanAndReturnOutputType = {
  __typename?: 'CreateManyCarePlanAndReturnOutputType';
  allowSelfRenewal: Scalars['Boolean'];
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  billingCycle: CarePlanCycleType;
  createdAt: Scalars['DateTime'];
  defaultRenewalSuccessorPlan?: Maybe<CarePlan>;
  defaultRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  earliestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  editorNotes: Scalars['String'];
  flowAlias?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isAcceptingPreEnrollments: Scalars['Boolean'];
  latestTargetPetAgeInMonths?: Maybe<Scalars['Int']>;
  marketingInformation?: Maybe<Scalars['Json']>;
  organization: Organization;
  organizationId: Scalars['String'];
  planDiscount?: Maybe<Scalars['Int']>;
  pricePerRenewal: Scalars['Int'];
  projectedSavings?: Maybe<Scalars['String']>;
  publishEndDate?: Maybe<Scalars['DateTime']>;
  publishStartDate?: Maybe<Scalars['DateTime']>;
  published: Scalars['Boolean'];
  renewalCycle: CarePlanCycleType;
  salesTaxCentsPerMonth: Scalars['Int'];
  signupFeePricing?: Maybe<Scalars['Int']>;
  signupFeeStripeProductId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  targetSpecies?: Maybe<SpeciesType>;
  themeColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCarePlanBenefitAndReturnOutputType = {
  __typename?: 'CreateManyCarePlanBenefitAndReturnOutputType';
  benefit: CareBenefit;
  benefitId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  includedUses?: Maybe<Scalars['Int']>;
  plan: CarePlan;
  planId: Scalars['String'];
  projectedSavings?: Maybe<Scalars['String']>;
  providedDiscountPercentage?: Maybe<Scalars['Float']>;
  reportingExpectedUsages: Scalars['Float'];
  reportingExpectedValue: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCarePlanBenefitEnrollmentCarryoverAndReturnOutputType = {
  __typename?: 'CreateManyCarePlanBenefitEnrollmentCarryoverAndReturnOutputType';
  amount: Scalars['Int'];
  benefit: CareBenefit;
  benefitId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  destinationPlanEnrollment?: Maybe<CarePlanEnrollment>;
  destinationPlanEnrollmentId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sourcePlanEnrollment?: Maybe<CarePlanEnrollment>;
  sourcePlanEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCarePlanEnrollmentAndReturnOutputType = {
  __typename?: 'CreateManyCarePlanEnrollmentAndReturnOutputType';
  autoRenews: Scalars['Boolean'];
  cancelledAt?: Maybe<Scalars['DateTime']>;
  careStripeSubscription?: Maybe<CareStripeSubscription>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  explicitRenewalSucccesorPlan?: Maybe<CarePlan>;
  explicitRenewalSuccessorPlanId?: Maybe<Scalars['String']>;
  explicitRenewalSuccessorPlanPricing?: Maybe<CarePlanPricing>;
  explicitRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  organizationPet: OrganizationPet;
  organizationPetId: Scalars['String'];
  plan: CarePlan;
  planId: Scalars['String'];
  planPricing?: Maybe<CarePlanPricing>;
  planPricingId?: Maybe<Scalars['String']>;
  renewalEmailNoticeSentAt?: Maybe<Scalars['DateTime']>;
  renewalEmailSelectedTargetPlan?: Maybe<CarePlan>;
  renewalEmailSelectedTargetPlanId?: Maybe<Scalars['String']>;
  renewalEmailSelectedTargetPlanPricing?: Maybe<CarePlanPricing>;
  renewalEmailSelectedTargetPlanPricingId?: Maybe<Scalars['String']>;
  renewalPredecessorEnrollment?: Maybe<CarePlanEnrollment>;
  renewalPredecessorEnrollmentId?: Maybe<Scalars['String']>;
  renewalRejectionReason?: Maybe<RenewalRejectionReason>;
  startDate: Scalars['DateTime'];
  status: EnrollmentStatus;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCarePlanPricingAndReturnOutputType = {
  __typename?: 'CreateManyCarePlanPricingAndReturnOutputType';
  billingCycle: CarePlanCycleType;
  createdAt: Scalars['DateTime'];
  defaultRenewalSuccessorPlanPricing?: Maybe<CarePlanPricing>;
  defaultRenewalSuccessorPlanPricingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  plan: CarePlan;
  planDiscount?: Maybe<Scalars['Int']>;
  planId: Scalars['String'];
  pricePerRenewal: Scalars['Int'];
  projectedSavings?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  renewalCycle: CarePlanCycleType;
  salesTaxCentsPerMonth: Scalars['Int'];
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCarePlanProviderGroupAndReturnOutputType = {
  __typename?: 'CreateManyCarePlanProviderGroupAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  launchStatus: CareProgramLaunchStatus;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  paymentProcessorClinic?: Maybe<Clinic>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCareStripeSubscriptionAndReturnOutputType = {
  __typename?: 'CreateManyCareStripeSubscriptionAndReturnOutputType';
  associatedCarePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  associatedCarePlanProviderGroupId?: Maybe<Scalars['String']>;
  associatedPet?: Maybe<OrganizationPet>;
  associatedPetId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isTestSubscription: Scalars['Boolean'];
  nextBillingDate: Scalars['DateTime'];
  parentCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<CareSubscriptionPaymentStatus>;
  stripeCustomerId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSubscriptionId: Scalars['String'];
  subscriptionOwner: OrganizationPetParent;
  subscriptionOwnerId: Scalars['String'];
  upcomingTotalPrice: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCareSubscriptionTrueUpAndReturnOutputType = {
  __typename?: 'CreateManyCareSubscriptionTrueUpAndReturnOutputType';
  amount: Scalars['Int'];
  carePlanEnrollment: CarePlanEnrollment;
  carePlanEnrollmentId: Scalars['String'];
  careStripeSubscription: CareStripeSubscription;
  careStripeSubscriptionId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  currency: Currency;
  dueAt: Scalars['DateTime'];
  id: Scalars['String'];
  retryAt?: Maybe<Scalars['DateTime']>;
  shouldCancelEnrollment: Scalars['Boolean'];
  slackMessageTimestamp?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoice>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  type: CareSubscriptionTrueUpType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCareSubscriptionTrueUpLogEntryAndReturnOutputType = {
  __typename?: 'CreateManyCareSubscriptionTrueUpLogEntryAndReturnOutputType';
  careSubscriptionTrueUp: CareSubscriptionTrueUp;
  careSubscriptionTrueUpId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  httpCode?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  lastPaymentError?: Maybe<StripePaymentError>;
  retryAttempt: Scalars['Int'];
  status: CareSubscriptionTrueUpStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyChannelAndReturnOutputType = {
  __typename?: 'CreateManyChannelAndReturnOutputType';
  attributes?: Maybe<Scalars['Json']>;
  channelStatus?: Maybe<ChannelStatus>;
  channelStatusId?: Maybe<Scalars['String']>;
  channelType?: Maybe<ChannelType>;
  channelVisibility?: Maybe<ChannelVisibility>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currentWorkflowAction?: Maybe<WorkflowEventAction>;
  currentWorkflowActionId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  lastExportAt?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<ChannelMessage>;
  lastMessageId?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  twilioChannelSid?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyChannelAutomationStatusAndReturnOutputType = {
  __typename?: 'CreateManyChannelAutomationStatusAndReturnOutputType';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  channel: Channel;
  channelId: Scalars['String'];
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  currentWorkflowEventAction?: Maybe<WorkflowEventAction>;
  currentWorkflowEventActionId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmission>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  serviceReminder?: Maybe<ServiceReminder>;
  serviceReminderId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status: AutomationStatus;
  updatedAt: Scalars['DateTime'];
  workflowEventSetting: WorkflowEventSetting;
  workflowEventSettingId: Scalars['String'];
};

export type CreateManyChannelCreationSourceAndReturnOutputType = {
  __typename?: 'CreateManyChannelCreationSourceAndReturnOutputType';
  channel: Channel;
  channelId: Scalars['String'];
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creationSource: ChannelCreationSourceType;
  formSubmission?: Maybe<FormSubmission>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  serviceReminder?: Maybe<ServiceReminder>;
  serviceReminderId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  workflowEventSetting?: Maybe<WorkflowEventSetting>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type CreateManyChannelFilterSelectionAndReturnOutputType = {
  __typename?: 'CreateManyChannelFilterSelectionAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  filterSelectionType: FilterSelectionType;
  filters: Scalars['Json'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyChannelMemberAndReturnOutputType = {
  __typename?: 'CreateManyChannelMemberAndReturnOutputType';
  attributes?: Maybe<Scalars['Json']>;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  draft?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  lastConsumptionTimestamp?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sendMessageNotification: Scalars['Boolean'];
  twilioIdentity?: Maybe<Scalars['String']>;
  twilioMemberSid?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type CreateManyChannelMessageAndReturnOutputType = {
  __typename?: 'CreateManyChannelMessageAndReturnOutputType';
  attributes?: Maybe<Scalars['Json']>;
  author?: Maybe<ChannelMember>;
  authorId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  forceReadReceipt: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  isUnreadEligible: Scalars['Boolean'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Json']>;
  messageType: MessageType;
  source: MessageSource;
  sourcePhoneNumber?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  wasEdited: Scalars['Boolean'];
};

export type CreateManyChannelMessageAttachmentAndReturnOutputType = {
  __typename?: 'CreateManyChannelMessageAttachmentAndReturnOutputType';
  attachmentType: ChannelMessageAttachmentType;
  createdAt: Scalars['DateTime'];
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ChannelMessageAttachmentEntityType>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uploadStatus?: Maybe<ChannelMessageAttachmentUploadStatus>;
  url?: Maybe<Scalars['String']>;
};

export type CreateManyChannelMessageAutoResponseAndReturnOutputType = {
  __typename?: 'CreateManyChannelMessageAutoResponseAndReturnOutputType';
  aiSuggestionMessage: Scalars['String'];
  channelMessage?: Maybe<ChannelMessage>;
  channelMessageId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  suggestionStatus: AutoResponseSuggestionStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyChannelMessageReactionAndReturnOutputType = {
  __typename?: 'CreateManyChannelMessageReactionAndReturnOutputType';
  channelMessage: ChannelMessage;
  channelMessageId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  reaction: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type CreateManyChannelPinAndReturnOutputType = {
  __typename?: 'CreateManyChannelPinAndReturnOutputType';
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type CreateManyChannelSelectionAndReturnOutputType = {
  __typename?: 'CreateManyChannelSelectionAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  includeUnassigned: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyChannelStatusAndReturnOutputType = {
  __typename?: 'CreateManyChannelStatusAndReturnOutputType';
  channelStatusAction: ChannelStatusAction;
  clinicSetting?: Maybe<ClinicSetting>;
  clinicSettingId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedBy?: Maybe<User>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isDefault?: Maybe<Scalars['Boolean']>;
  isExportedToPims?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  shouldNotifyChronos?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyChannelStatusChannelAssigneeAndReturnOutputType = {
  __typename?: 'CreateManyChannelStatusChannelAssigneeAndReturnOutputType';
  channelStatus: ChannelStatus;
  channelStatusId: Scalars['String'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type CreateManyChemicalCompoundAndReturnOutputType = {
  __typename?: 'CreateManyChemicalCompoundAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  iupacName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClientConnectIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyClientConnectIntegrationAndReturnOutputType';
  clientConnectSystem: ClientConnectSystem;
  clinicSoftware: ClientConnectClinicSoftware;
  createdAt: Scalars['DateTime'];
  erpId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isMultiSite: Scalars['Boolean'];
  locationNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicAndReturnOutputType = {
  __typename?: 'CreateManyClinicAndReturnOutputType';
  activationDate?: Maybe<Scalars['DateTime']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  allowAllUsersToCloseConsultations?: Maybe<Scalars['Boolean']>;
  autoSubscriptionReceiptEmails?: Maybe<Scalars['Json']>;
  automaticSubscriptionReceipts: Scalars['Boolean'];
  callerIdPhoneNumber?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  carePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  carePlanProviderGroupId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicEmail?: Maybe<Scalars['String']>;
  clinicSetting?: Maybe<ClinicSetting>;
  clinicSettingId?: Maybe<Scalars['String']>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSetting>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  consultationCost?: Maybe<Scalars['Float']>;
  corporateId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  crmId?: Maybe<Scalars['String']>;
  crmUrlParams?: Maybe<Scalars['Json']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firebaseVets?: Maybe<Scalars['Json']>;
  followUpCost?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  hasServiceReminders?: Maybe<Scalars['Boolean']>;
  hasSmsConversations?: Maybe<Scalars['Boolean']>;
  headUserId?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  incomeMethod?: Maybe<Scalars['String']>;
  integrationInfo?: Maybe<Scalars['Json']>;
  integrationSystem?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  isAddAppointmentDisabled?: Maybe<Scalars['Boolean']>;
  isCallerIdVerified?: Maybe<Scalars['Boolean']>;
  isClinicActive: Scalars['Boolean'];
  isClinicEligibleForPayments: Scalars['Boolean'];
  isConsultationsActive?: Maybe<Scalars['Boolean']>;
  isIntegrationActive?: Maybe<Scalars['Boolean']>;
  isPaymentUsBank?: Maybe<Scalars['Boolean']>;
  isServiceRemindersActive?: Maybe<Scalars['Boolean']>;
  lastPrintOrderedOn?: Maybe<Scalars['DateTime']>;
  lastPrintOrderedQuantity?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  legalEntity?: Maybe<LegalEntity>;
  legalEntityId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  loyaltyProgram?: Maybe<LoyaltyProgram>;
  loyaltyProgramId?: Maybe<Scalars['String']>;
  marketEmail?: Maybe<Scalars['String']>;
  marketFacebookNumber?: Maybe<Scalars['Int']>;
  marketFacebookPageId?: Maybe<Scalars['String']>;
  marketFacebookPageToken?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optimizedLogoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentBankAccountNumber?: Maybe<Scalars['String']>;
  paymentBankRoutingNumber?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentZip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['Int']>;
  printLastOrder?: Maybe<Scalars['DateTime']>;
  printReceivedQuantity?: Maybe<Scalars['Int']>;
  remindersIntegrationRequestEmail?: Maybe<Scalars['String']>;
  responseTime?: Maybe<Scalars['Float']>;
  smsPhoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeSubscriptionPlan?: Maybe<Scalars['String']>;
  submerchantApprovedAt?: Maybe<Scalars['DateTime']>;
  submerchantId?: Maybe<Scalars['String']>;
  submerchantIsActive?: Maybe<Scalars['Boolean']>;
  submerchantStatus?: Maybe<Scalars['String']>;
  submerchantStripeChargesEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeHasCustomPayouts?: Maybe<Scalars['Boolean']>;
  submerchantStripeId?: Maybe<Scalars['String']>;
  submerchantStripePayoutsEnabled?: Maybe<Scalars['Boolean']>;
  submerchantStripeStatus?: Maybe<Scalars['String']>;
  subscribedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  unlayerSetting?: Maybe<UnlayerSetting>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  usersId?: Maybe<User>;
  websiteUrl?: Maybe<Scalars['String']>;
  widgetSettings?: Maybe<Scalars['Json']>;
};

export type CreateManyClinicBlockedPhoneNumberAndReturnOutputType = {
  __typename?: 'CreateManyClinicBlockedPhoneNumberAndReturnOutputType';
  blockedBy?: Maybe<User>;
  blockedByUserId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  unblockedBy?: Maybe<User>;
  unblockedByUserId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicCustomPayoutsSetupAndReturnOutputType = {
  __typename?: 'CreateManyClinicCustomPayoutsSetupAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicListEncryptedUpload?: Maybe<EncryptedClinicUpload>;
  clinicListEncryptedUploadId?: Maybe<Scalars['String']>;
  clinicRepresentativeInfoEncryptedUpload?: Maybe<EncryptedClinicUpload>;
  clinicRepresentativeInfoEncryptedUploadId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  status: ClinicCustomPayoutsSetupStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicDirectBookingSettingAndReturnOutputType = {
  __typename?: 'CreateManyClinicDirectBookingSettingAndReturnOutputType';
  appointmentIntervalInMinutes?: Maybe<Scalars['Int']>;
  appointmentIntervalInMinutesDisplay?: Maybe<Scalars['Int']>;
  bookingDeadlineInHours?: Maybe<Scalars['Int']>;
  bookingNeedsConfirmation: Scalars['Boolean'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  exclusionRulesEnabled: Scalars['Boolean'];
  id: Scalars['String'];
  isOneTimePasswordEnabled: Scalars['Boolean'];
  isUrgentWarningEnabled: Scalars['Boolean'];
  maxSchedulingRangeInMonths?: Maybe<Scalars['Int']>;
  maxTimeInAdvanceUnit?: Maybe<TimeUnit>;
  maxTimeInAdvanceValue?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  urgentWarningKeywords?: Maybe<Scalars['String']>;
  urgentWarningMessage?: Maybe<Scalars['String']>;
};

export type CreateManyClinicEmailCampaignSettingAndReturnOutputType = {
  __typename?: 'CreateManyClinicEmailCampaignSettingAndReturnOutputType';
  accountId: Scalars['String'];
  careUrlFieldId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  contactListId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  petSpeciesTypeFieldId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userGroupId: Scalars['String'];
};

export type CreateManyClinicEmployeeAndReturnOutputType = {
  __typename?: 'CreateManyClinicEmployeeAndReturnOutputType';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefaultExporter?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicEmployeeAppointmentTypeSettingAndReturnOutputType = {
  __typename?: 'CreateManyClinicEmployeeAppointmentTypeSettingAndReturnOutputType';
  appointmentType: AppointmentType;
  appointmentTypeId: Scalars['String'];
  clinicEmployee: ClinicEmployee;
  clinicEmployeeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicEmployeeToWorkflowEventSettingAndReturnOutputType = {
  __typename?: 'CreateManyClinicEmployeeToWorkflowEventSettingAndReturnOutputType';
  clinicEmployee: ClinicEmployee;
  clinicEmployeeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  workflow: WorkflowEventSetting;
  workflowId: Scalars['String'];
};

export type CreateManyClinicEntityPhoneNumberAndReturnOutputType = {
  __typename?: 'CreateManyClinicEntityPhoneNumberAndReturnOutputType';
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isOptedOut: Scalars['Boolean'];
  isPims?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastOptOutSendDate?: Maybe<Scalars['DateTime']>;
  lastSmsSendDate?: Maybe<Scalars['DateTime']>;
  number: Scalars['String'];
  phoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequest>;
  phoneNumberLookupRequestId?: Maybe<Scalars['String']>;
  phoneNumberLookupResult?: Maybe<PhoneNumberLookupResult>;
  phoneNumberLookupResultId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicModuleAndReturnOutputType = {
  __typename?: 'CreateManyClinicModuleAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  module: Module;
  moduleId: Scalars['String'];
  source: ClinicModuleSource;
  sourceId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicOfficeHourAndReturnOutputType = {
  __typename?: 'CreateManyClinicOfficeHourAndReturnOutputType';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  closeAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  dayOfWeek: Scalars['Int'];
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  isOpenTwentyFourHours: Scalars['Boolean'];
  openAt: Scalars['DateTime'];
  type: ClinicOfficeHoursType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicOnboardingAndReturnOutputType = {
  __typename?: 'CreateManyClinicOnboardingAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  kickoffDate?: Maybe<Scalars['DateTime']>;
  pauseUntilDate?: Maybe<Scalars['DateTime']>;
  salesforceOnboardingId?: Maybe<Scalars['String']>;
  stage: Scalars['String'];
  trainingDate?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicPaymentFeeConfigurationAndReturnOutputType = {
  __typename?: 'CreateManyClinicPaymentFeeConfigurationAndReturnOutputType';
  clinicSetting: ClinicSetting;
  clinicSettingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  disputeFeeCharge: Scalars['Int'];
  feeCollection: FeeCollection;
  id: Scalars['String'];
  onlineClientServiceFeePercent: Scalars['Float'];
  onlineProcessingFeeFlat: Scalars['Int'];
  onlineProcessingFeePercent: Scalars['Float'];
  pricingModel: PricingModel;
  responsibleForClinicRefundFeesAt?: Maybe<Scalars['DateTime']>;
  terminalClientServiceFeePercent: Scalars['Float'];
  terminalProcessingFeeFlat: Scalars['Int'];
  terminalProcessingFeePercent: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicPetAlertAndReturnOutputType = {
  __typename?: 'CreateManyClinicPetAlertAndReturnOutputType';
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isMedical?: Maybe<Scalars['Boolean']>;
  pimsDate?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type CreateManyClinicPetAndReturnOutputType = {
  __typename?: 'CreateManyClinicPetAndReturnOutputType';
  breed?: Maybe<Scalars['String']>;
  breedId?: Maybe<Scalars['String']>;
  breedModel?: Maybe<Breed>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  colorModel?: Maybe<Color>;
  createdAt: Scalars['DateTime'];
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeceased?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isSubscribedToReminders: Scalars['Boolean'];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPet?: Maybe<OrganizationPet>;
  organizationPetId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexId?: Maybe<Scalars['String']>;
  sexModel?: Maybe<Sex>;
  species?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  speciesModel?: Maybe<Species>;
  speciesType: SpeciesType;
  updatedAt: Scalars['DateTime'];
  weight?: Maybe<Scalars['Float']>;
  weightInKg?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type CreateManyClinicPetCustomFieldValueAndReturnOutputType = {
  __typename?: 'CreateManyClinicPetCustomFieldValueAndReturnOutputType';
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fieldDefinition: CustomFieldDefinition;
  fieldDefinitionId: Scalars['String'];
  id: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Json'];
};

export type CreateManyClinicPetParentAddressAndReturnOutputType = {
  __typename?: 'CreateManyClinicPetParentAddressAndReturnOutputType';
  addressType?: Maybe<ClinicPetParentAddressType>;
  city: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  creationSource?: Maybe<ClinicEntityCreationSource>;
  id: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut: Scalars['Boolean'];
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  stateProvince: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicPetParentAndReturnOutputType = {
  __typename?: 'CreateManyClinicPetParentAndReturnOutputType';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  globalPetParent?: Maybe<GlobalPetParent>;
  globalPetParentId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPrivacyProtected?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  organizationPetParent?: Maybe<OrganizationPetParent>;
  organizationPetParentId?: Maybe<Scalars['String']>;
  petParentSetting?: Maybe<PetParentSetting>;
  petParentSettingId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsAccountId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsPhoneNumber?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sourcePimsId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomer>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type CreateManyClinicPetParentCustomFieldValueAndReturnOutputType = {
  __typename?: 'CreateManyClinicPetParentCustomFieldValueAndReturnOutputType';
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fieldDefinition: CustomFieldDefinition;
  fieldDefinitionId: Scalars['String'];
  id: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Json'];
};

export type CreateManyClinicPetParentDeviceAndReturnOutputType = {
  __typename?: 'CreateManyClinicPetParentDeviceAndReturnOutputType';
  appVersion?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deviceName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instanceId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastPushAlertTimestamp?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceOs>;
  osVersion?: Maybe<Scalars['String']>;
  pushModalSkipped: Scalars['Boolean'];
  pushNotificationStatus: PushNotificationStatus;
  snsEndpointArn?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceType>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicPetParentPimsSyncStatusAndReturnOutputType = {
  __typename?: 'CreateManyClinicPetParentPimsSyncStatusAndReturnOutputType';
  attempts?: Maybe<Scalars['Int']>;
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status: ProfilePimsSyncStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicPetPimsSyncStatusAndReturnOutputType = {
  __typename?: 'CreateManyClinicPetPimsSyncStatusAndReturnOutputType';
  attempts?: Maybe<Scalars['Int']>;
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status: ProfilePimsSyncStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicPhoneNumberAndReturnOutputType = {
  __typename?: 'CreateManyClinicPhoneNumberAndReturnOutputType';
  campaignRegistryCampaign?: Maybe<CampaignRegistryCampaign>;
  campaignRegistryCampaignId?: Maybe<Scalars['String']>;
  capability: ServiceCapability;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  incomingCarrier?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  isTestSmsDelivered: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  loaSignedAt?: Maybe<Scalars['DateTime']>;
  loaSignedByUser?: Maybe<User>;
  loaSignedByUserId?: Maybe<Scalars['String']>;
  loaUrl?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  portingOrderId?: Maybe<Scalars['String']>;
  portingOrderStatus?: Maybe<Scalars['String']>;
  portingStartAt?: Maybe<Scalars['DateTime']>;
  provider: ServiceProvider;
  status: PhoneNumberStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicPimsIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyClinicPimsIntegrationAndReturnOutputType';
  bitwerx?: Maybe<BitwerxIntegration>;
  bitwerxId?: Maybe<Scalars['String']>;
  clientConnect?: Maybe<ClientConnectIntegration>;
  clientConnectId?: Maybe<Scalars['String']>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  datapoint?: Maybe<DataPointIntegration>;
  datapointId?: Maybe<Scalars['String']>;
  ezyvet?: Maybe<EzyVetIntegration>;
  ezyvetId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instinct?: Maybe<InstinctIntegration>;
  instinctId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastBatchSyncedAt?: Maybe<Scalars['DateTime']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  neo?: Maybe<NeoIntegration>;
  neoId?: Maybe<Scalars['String']>;
  pauseUntil?: Maybe<Scalars['DateTime']>;
  ppc?: Maybe<PpcIntegration>;
  ppcId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequency: PimsSyncFrequency;
  syncvet?: Maybe<SyncVetIntegration>;
  syncvetId?: Maybe<Scalars['String']>;
  type: ClinicPimsIntegrationType;
  updatedAt: Scalars['DateTime'];
  vetdata?: Maybe<VetDataIntegration>;
  vetdataId?: Maybe<Scalars['String']>;
  vetsourcePharmacy?: Maybe<VetsourcePharmacyIntegration>;
  vetsourcePharmacyId?: Maybe<Scalars['String']>;
  vetter?: Maybe<VetterIntegration>;
  vetterId?: Maybe<Scalars['String']>;
  writebackConfiguration: Scalars['Json'];
};

export type CreateManyClinicPimsIntegrationCapabilityAndReturnOutputType = {
  __typename?: 'CreateManyClinicPimsIntegrationCapabilityAndReturnOutputType';
  capability: PimsIntegrationCapability;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PimsSyncStatus>;
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusErrorMessage?: Maybe<Scalars['String']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicPimsIntegrationCapabilityHistoryEntryAndReturnOutputType = {
  __typename?: 'CreateManyClinicPimsIntegrationCapabilityHistoryEntryAndReturnOutputType';
  capability: PimsIntegrationCapability;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  recordsSync: Scalars['Int'];
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  syncDuration?: Maybe<Scalars['Int']>;
};

export type CreateManyClinicPostcardSettingAndReturnOutputType = {
  __typename?: 'CreateManyClinicPostcardSettingAndReturnOutputType';
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isRemindersEnabled: Scalars['Boolean'];
  reminderTemplate: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicRoomAndReturnOutputType = {
  __typename?: 'CreateManyClinicRoomAndReturnOutputType';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicRoomToWorkflowEventSettingAndReturnOutputType = {
  __typename?: 'CreateManyClinicRoomToWorkflowEventSettingAndReturnOutputType';
  clinicRoom: ClinicRoom;
  clinicRoomId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  workflow: WorkflowEventSetting;
  workflowId: Scalars['String'];
};

export type CreateManyClinicSettingAndReturnOutputType = {
  __typename?: 'CreateManyClinicSettingAndReturnOutputType';
  MissedCallMessageResponseBody?: Maybe<Scalars['String']>;
  aiRecapWritebackEnabled: Scalars['Boolean'];
  aiSuggestPromptSupplement?: Maybe<Scalars['String']>;
  aiSummaryPromptSupplement?: Maybe<Scalars['String']>;
  appointmentTimeSlotIncrementInMinutes?: Maybe<Scalars['Int']>;
  bulkConversationExportLimit: Scalars['Int'];
  campaignRegistryBrand?: Maybe<Scalars['Json']>;
  campaignRegistryBrandId?: Maybe<Scalars['String']>;
  campaignRegistryBrandIdentityStatus?: Maybe<CampaignRegistryBrandIdentityStatus>;
  careStatementDescriptor?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  earliestAllowedLoyaltyInvoiceDate?: Maybe<Scalars['DateTime']>;
  emergencyContactsEnabled: Scalars['Boolean'];
  financialReportingConfig?: Maybe<Scalars['Json']>;
  hasCustomizableFees?: Maybe<Scalars['Boolean']>;
  hideAppointmentsWithoutPetOwner: Scalars['Boolean'];
  id: Scalars['String'];
  informPrimaryContactUser?: Maybe<User>;
  informPrimaryContactUserId?: Maybe<Scalars['String']>;
  loyaltyProgramLastRunAt?: Maybe<Scalars['DateTime']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  missedCallMessageResponseStatus: MissedCallMessageResponseStatus;
  outOfOfficeEnabled: Scalars['Boolean'];
  outOfOfficeHeadline: Scalars['String'];
  outOfOfficeShowScheduleEnabled: Scalars['Boolean'];
  processingFeeFlat: Scalars['Int'];
  processingFeePercent: Scalars['Float'];
  savePaymentInfo: Scalars['Boolean'];
  smsAutoResponseWhenClosed?: Maybe<Scalars['String']>;
  smsAutoResponseWhenOpen?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['Json']>;
  terminalSetupPin?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  workflowsEnabled: Scalars['Boolean'];
};

export type CreateManyClinicUserFilterAndReturnOutputType = {
  __typename?: 'CreateManyClinicUserFilterAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  filter: Scalars['Json'];
  id: Scalars['String'];
  type: ClinicUserFilterType;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type CreateManyClinicWidgetRequestAndReturnOutputType = {
  __typename?: 'CreateManyClinicWidgetRequestAndReturnOutputType';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestType?: Maybe<ClinicWidgetRequestType>;
  clinicWidgetRequestTypeId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  directBookingAppointment?: Maybe<Appointment>;
  directBookingAppointmentId?: Maybe<Scalars['String']>;
  formSubmission?: Maybe<FormSubmission>;
  formSubmissionId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isVerified?: Maybe<Scalars['Boolean']>;
  requestFormSubmission?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  verificationMethod?: Maybe<ContactVerificationMethod>;
};

export type CreateManyClinicWidgetRequestTypeAndReturnOutputType = {
  __typename?: 'CreateManyClinicWidgetRequestTypeAndReturnOutputType';
  channelStatus?: Maybe<ChannelStatus>;
  channelStatusId?: Maybe<Scalars['String']>;
  clinicWidgetSetting?: Maybe<ClinicWidgetSetting>;
  clinicWidgetSettingId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  formTemplate?: Maybe<FormTemplate>;
  formTemplateId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  requestFormTemplate?: Maybe<Scalars['Json']>;
  requestType: WidgetRequestType;
  requestVisibility: WidgetVisibility;
  shouldCreateTask: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyClinicWidgetSettingAndReturnOutputType = {
  __typename?: 'CreateManyClinicWidgetSettingAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  welcomeMessage?: Maybe<Scalars['String']>;
  whiteLabelUrls?: Maybe<Scalars['Json']>;
};

export type CreateManyClinicWorkflowTypeAndReturnOutputType = {
  __typename?: 'CreateManyClinicWorkflowTypeAndReturnOutputType';
  appoinmentTypeId?: Maybe<Scalars['String']>;
  appointmentType?: Maybe<AppointmentType>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultWorkflowType: WorkflowType;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyColorAndReturnOutputType = {
  __typename?: 'CreateManyColorAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyConditionAndReturnOutputType = {
  __typename?: 'CreateManyConditionAndReturnOutputType';
  attribute: ConditionAttribute;
  checksum: Scalars['String'];
  conditionSetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  operand: Scalars['Json'];
  operator: ConditionOperator;
  set: ConditionSet;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyConditionSetAndReturnOutputType = {
  __typename?: 'CreateManyConditionSetAndReturnOutputType';
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  negate: Scalars['Boolean'];
  operator: ConditionSetOperator;
  parent?: Maybe<ConditionSet>;
  parentConditionSetId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyConditionalEntityEvaluationAndReturnOutputType = {
  __typename?: 'CreateManyConditionalEntityEvaluationAndReturnOutputType';
  audit?: Maybe<Scalars['Json']>;
  conditionalEntityChecksum?: Maybe<Scalars['String']>;
  conditionalEntityId: Scalars['String'];
  conditionalEntityType: ConditionalEntityType;
  context?: Maybe<Scalars['Json']>;
  contextEntityChecksum?: Maybe<Scalars['String']>;
  contextEntityId: Scalars['String'];
  contextEntityType: ContextEntityType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  result: Scalars['Boolean'];
};

export type CreateManyConsultationAndReturnOutputType = {
  __typename?: 'CreateManyConsultationAndReturnOutputType';
  callType?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientCost?: Maybe<Scalars['Float']>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  consultationState: Scalars['String'];
  consultationType: Scalars['String'];
  cost?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isPhoneAllowed?: Maybe<Scalars['Boolean']>;
  isVetEmailed?: Maybe<Scalars['Boolean']>;
  isVideoAllowed?: Maybe<Scalars['Boolean']>;
  isVideoChat?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  nurse?: Maybe<VetInfo>;
  nurseId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<Pet>;
  petId?: Maybe<Scalars['String']>;
  petParent?: Maybe<OwnerInfo>;
  petParentId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  treat?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vet?: Maybe<VetInfo>;
  veterinarianId?: Maybe<Scalars['String']>;
};

export type CreateManyConsultationChatAndReturnOutputType = {
  __typename?: 'CreateManyConsultationChatAndReturnOutputType';
  consultation?: Maybe<Consultation>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdAtCopy?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyConsultationRequestAndReturnOutputType = {
  __typename?: 'CreateManyConsultationRequestAndReturnOutputType';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  consultationFirebaseId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  intent: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isExistingClient?: Maybe<Scalars['Boolean']>;
  petName: Scalars['String'];
  petParentEmail?: Maybe<Scalars['String']>;
  petParentFirstname: Scalars['String'];
  petParentLastname: Scalars['String'];
  petParentPhone: Scalars['String'];
  petSpecies?: Maybe<Scalars['String']>;
  summary: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCustomFieldDefinitionAndReturnOutputType = {
  __typename?: 'CreateManyCustomFieldDefinitionAndReturnOutputType';
  clinicPimsIntegration: ClinicPimsIntegration;
  clinicPimsIntegrationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  designation: CustomFieldDesignation;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyCustomFieldPimsWritebackLogEntryAndReturnOutputType = {
  __typename?: 'CreateManyCustomFieldPimsWritebackLogEntryAndReturnOutputType';
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinition: CustomFieldDefinition;
  customFieldDefinitionId: Scalars['String'];
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLog: PimsWritebackLogEntry;
  writebackLogId: Scalars['String'];
};

export type CreateManyDataPointIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyDataPointIntegrationAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isMultiLocation: Scalars['Boolean'];
  password: Scalars['String'];
  siteId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
};

export type CreateManyDirectBookingAppointmentTypeSettingAndReturnOutputType = {
  __typename?: 'CreateManyDirectBookingAppointmentTypeSettingAndReturnOutputType';
  allowNewClientBooking: Scalars['Boolean'];
  appointmentType: AppointmentType;
  appointmentTypeId: Scalars['String'];
  clientType: DirectBookingAppointmentTypeClientType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isPaymentCollectionEnabled: Scalars['Boolean'];
  paymentAmountToCollect: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyDirectBookingExclusionRuleAndReturnOutputType = {
  __typename?: 'CreateManyDirectBookingExclusionRuleAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyDirectBookingExclusionTimeSlotAndReturnOutputType = {
  __typename?: 'CreateManyDirectBookingExclusionTimeSlotAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['String'];
  exclusionRule: DirectBookingExclusionRule;
  exclusionRuleId: Scalars['String'];
  id: Scalars['String'];
  startTime: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyDisbursementAndReturnOutputType = {
  __typename?: 'CreateManyDisbursementAndReturnOutputType';
  amount: Scalars['Float'];
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId: Scalars['String'];
  id: Scalars['String'];
  source: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyDocumentationAndReturnOutputType = {
  __typename?: 'CreateManyDocumentationAndReturnOutputType';
  category: DocumentationCategory;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  provider: DocumentationProvider;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type CreateManyEmailCampaignAndReturnOutputType = {
  __typename?: 'CreateManyEmailCampaignAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from: Scalars['String'];
  htmlContent?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informCampaignExecution?: Maybe<InformCampaignExecution>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  lastUpdatedByUser?: Maybe<User>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType: EmailCampaignSegmentationType;
  sentByUser?: Maybe<User>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status: EmailCampaignStatus;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type: EmailCampaignType;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type CreateManyEmailCampaignCustomListAndReturnOutputType = {
  __typename?: 'CreateManyEmailCampaignCustomListAndReturnOutputType';
  awsFileKey: Scalars['String'];
  createdAt: Scalars['DateTime'];
  emailCampaign: EmailCampaign;
  emailCampaignId: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  invalidRecipients: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  validRecipients: Scalars['Int'];
};

export type CreateManyEmailCampaignCustomListRecipientAndReturnOutputType = {
  __typename?: 'CreateManyEmailCampaignCustomListRecipientAndReturnOutputType';
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  emailCampaignCustomList: EmailCampaignCustomList;
  emailCampaignCustomListId: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status: EmailCampaignCustomListRecipientStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyEmailCampaignCustomListUploadHistoryAndReturnOutputType = {
  __typename?: 'CreateManyEmailCampaignCustomListUploadHistoryAndReturnOutputType';
  awsFileKey: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  emailCampaign: EmailCampaign;
  emailCampaignId: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyEmailCampaignLogAndReturnOutputType = {
  __typename?: 'CreateManyEmailCampaignLogAndReturnOutputType';
  action: EmailCampaignLogAction;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  emailCampaign: EmailCampaign;
  emailCampaignId: Scalars['String'];
  emailCampaignType: EmailCampaignType;
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  provider: EmailProvider;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variant?: Maybe<Scalars['String']>;
};

export type CreateManyEmailCampaignTemplateAndReturnOutputType = {
  __typename?: 'CreateManyEmailCampaignTemplateAndReturnOutputType';
  User?: Maybe<User>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent: Scalars['String'];
  id: Scalars['String'];
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyEmailCampaignUnsubscribeAndReturnOutputType = {
  __typename?: 'CreateManyEmailCampaignUnsubscribeAndReturnOutputType';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emailCampaign?: Maybe<EmailCampaign>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source: EmailCampaignUnsubscribeSource;
  targetEmail: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyEmailProviderLogAndReturnOutputType = {
  __typename?: 'CreateManyEmailProviderLogAndReturnOutputType';
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  entityId: Scalars['String'];
  entityType: EmailProviderLogEntityType;
  id: Scalars['String'];
  provider: EmailProvider;
  providerEmailTemplateId: Scalars['String'];
  providerMessageId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyEmailTemplateAndReturnOutputType = {
  __typename?: 'CreateManyEmailTemplateAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: EmailTemplateType;
  unlayerSetting: UnlayerSetting;
  unlayerSettingId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyEmailTemplateVersionAndReturnOutputType = {
  __typename?: 'CreateManyEmailTemplateVersionAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  design: Scalars['Json'];
  emailTemplate: EmailTemplate;
  emailTemplateId: Scalars['String'];
  html: Scalars['String'];
  id: Scalars['String'];
  isCurrent: Scalars['Boolean'];
  lastEditedBy?: Maybe<User>;
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
};

export type CreateManyEmergencyClinicsAndReturnOutputType = {
  __typename?: 'CreateManyEmergencyClinicsAndReturnOutputType';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicSetting: ClinicSetting;
  clinicSettingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayOrder: Scalars['Int'];
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyEncryptedClinicUploadAndReturnOutputType = {
  __typename?: 'CreateManyEncryptedClinicUploadAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt: Scalars['DateTime'];
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUser?: Maybe<User>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type CreateManyEnrollmentSupportEventAndReturnOutputType = {
  __typename?: 'CreateManyEnrollmentSupportEventAndReturnOutputType';
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollment;
  carePlanEnrollmentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currentPlan?: Maybe<CarePlan>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricing?: Maybe<CarePlanPricing>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlan>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricing?: Maybe<CarePlanPricing>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<User>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoice?: Maybe<StripeInvoice>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requester?: Maybe<User>;
  requesterId?: Maybe<Scalars['String']>;
  responder?: Maybe<User>;
  responderId?: Maybe<Scalars['String']>;
  status: SupportEventStatus;
  transferFromPet?: Maybe<OrganizationPet>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPet?: Maybe<OrganizationPet>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type CreateManyEzyVetIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyEzyVetIntegrationAndReturnOutputType';
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyFeatureFlagAndReturnOutputType = {
  __typename?: 'CreateManyFeatureFlagAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  key: Scalars['String'];
  state: FeatureFlagState;
  type: FeatureFlagType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyFinancialAdjustmentAndReturnOutputType = {
  __typename?: 'CreateManyFinancialAdjustmentAndReturnOutputType';
  amount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyFinancialTransactionAndReturnOutputType = {
  __typename?: 'CreateManyFinancialTransactionAndReturnOutputType';
  adjustment?: Maybe<FinancialAdjustment>;
  adjustmentId?: Maybe<Scalars['String']>;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  stripeDispute?: Maybe<StripeDispute>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoice>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntent>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayout?: Maybe<StripePayout>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefund?: Maybe<StripeRefund>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyFirebaseStructureAndReturnOutputType = {
  __typename?: 'CreateManyFirebaseStructureAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  structure?: Maybe<Scalars['String']>;
  table: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyFormSubmissionAndReturnOutputType = {
  __typename?: 'CreateManyFormSubmissionAndReturnOutputType';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplate>;
  formTemplateId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyFormTemplateAndReturnOutputType = {
  __typename?: 'CreateManyFormTemplateAndReturnOutputType';
  autoExportEnabled: Scalars['Boolean'];
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateType: FormTemplateType;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyGlobalPetParentAndReturnOutputType = {
  __typename?: 'CreateManyGlobalPetParentAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  primaryPhoneNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyGooglePlaceAndReturnOutputType = {
  __typename?: 'CreateManyGooglePlaceAndReturnOutputType';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  placeId: Scalars['String'];
  response: Scalars['Json'];
};

export type CreateManyHillsToHomeApiLogAndReturnOutputType = {
  __typename?: 'CreateManyHillsToHomeAPILogAndReturnOutputType';
  automationRun?: Maybe<AutomationRun>;
  automationRunId?: Maybe<Scalars['String']>;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyImageAndReturnOutputType = {
  __typename?: 'CreateManyImageAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  source: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformAudienceDefinitionAndReturnOutputType = {
  __typename?: 'CreateManyInformAudienceDefinitionAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartner?: Maybe<InformPartner>;
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformAudienceDefinitionType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformAudienceMemberAndReturnOutputType = {
  __typename?: 'CreateManyInformAudienceMemberAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informCampaignEnrollment: InformCampaignEnrollment;
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecution: InformCampaignExecution;
  informCampaignExecutionId: Scalars['String'];
  servicePurchaseSummary?: Maybe<ServicePurchaseSummary>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformAudienceMemberMessageAndReturnOutputType = {
  __typename?: 'CreateManyInformAudienceMemberMessageAndReturnOutputType';
  audienceMember: InformAudienceMember;
  audienceMemberId: Scalars['String'];
  context: Scalars['Json'];
  courier: InformAudienceMemberMessageCourier;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  executeAt: Scalars['DateTime'];
  id: Scalars['String'];
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceMemberMessageStatus;
  target: Scalars['String'];
  type: InformAudienceMemberMessageType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformAutomationCampaignAndReturnOutputType = {
  __typename?: 'CreateManyInformAutomationCampaignAndReturnOutputType';
  id: Scalars['String'];
  informCampaign: InformCampaign;
  workflowEventSetting: WorkflowEventSetting;
  workflowEventSettingId: Scalars['String'];
};

export type CreateManyInformCampaignAndReturnOutputType = {
  __typename?: 'CreateManyInformCampaignAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informAudienceDefinition: InformAudienceDefinition;
  informAudienceDefinitionId: Scalars['String'];
  informCampaignGroup?: Maybe<InformCampaignGroup>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informPartnerProgram: InformPartnerProgram;
  informPartnerProgramId: Scalars['String'];
  name: Scalars['String'];
  status: InformCampaignStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt: Scalars['DateTime'];
  visibility: InformCampaignVisibility;
};

export type CreateManyInformCampaignEnrollmentAndReturnOutputType = {
  __typename?: 'CreateManyInformCampaignEnrollmentAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informCampaign: InformCampaign;
  informCampaignId: Scalars['String'];
  informPartnerProgramEnrollment: InformPartnerProgramEnrollment;
  informPartnerProgramEnrollmentId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformCampaignEnrollmentCanonicalServiceAndReturnOutputType = {
  __typename?: 'CreateManyInformCampaignEnrollmentCanonicalServiceAndReturnOutputType';
  canonicalService: CanonicalService;
  canonicalServiceId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informCampaignEnrollment: InformCampaignEnrollment;
  informCampaignEnrollmentId: Scalars['String'];
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformCampaignExecutionAndReturnOutputType = {
  __typename?: 'CreateManyInformCampaignExecutionAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  executeAt: Scalars['DateTime'];
  id: Scalars['String'];
  informCampaign: InformCampaign;
  informCampaignId: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformCampaignGroupAndReturnOutputType = {
  __typename?: 'CreateManyInformCampaignGroupAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartner: InformPartner;
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformCommunicationOptOutAndReturnOutputType = {
  __typename?: 'CreateManyInformCommunicationOptOutAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  scope: Scalars['String'];
  status: InformCommunicationOptOutStatus;
  target: Scalars['String'];
  targetType: InformScheduledCampaignCommunicationChannel;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformControlGroupParticipantAndReturnOutputType = {
  __typename?: 'CreateManyInformControlGroupParticipantAndReturnOutputType';
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  controlGroupEntityId: Scalars['String'];
  controlGroupEntityType: InformControlGroupEntityType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformEmailTemplateAndReturnOutputType = {
  __typename?: 'CreateManyInformEmailTemplateAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartner?: Maybe<InformPartner>;
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: InformEmailTemplateStatus;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformEntityHistoryAndReturnOutputType = {
  __typename?: 'CreateManyInformEntityHistoryAndReturnOutputType';
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  id: Scalars['String'];
  state: Scalars['Json'];
};

export type CreateManyInformEventDrivenCampaignAndReturnOutputType = {
  __typename?: 'CreateManyInformEventDrivenCampaignAndReturnOutputType';
  id: Scalars['String'];
  informCampaign: InformCampaign;
  settings?: Maybe<Scalars['Json']>;
};

export type CreateManyInformEventListenerAndReturnOutputType = {
  __typename?: 'CreateManyInformEventListenerAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  informEventDrivenCampaign: InformEventDrivenCampaign;
  informEventDrivenCampaignId: Scalars['String'];
  name: Scalars['String'];
  parentEventListener?: Maybe<InformEventListener>;
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings: Scalars['Json'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformNotificationRecipientAndReturnOutputType = {
  __typename?: 'CreateManyInformNotificationRecipientAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informPartnerProgramEnrollment: InformPartnerProgramEnrollment;
  informPartnerProgramEnrollmentId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type CreateManyInformPartnerAndReturnOutputType = {
  __typename?: 'CreateManyInformPartnerAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformPartnerCustomerAndReturnOutputType = {
  __typename?: 'CreateManyInformPartnerCustomerAndReturnOutputType';
  checksum: Scalars['String'];
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  externalId: Scalars['String'];
  googlePlace?: Maybe<GooglePlace>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartner: InformPartner;
  informPartnerId: Scalars['String'];
  informPartnerIntegration: InformPartnerIntegration;
  informPartnerIntegrationId: Scalars['String'];
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomer>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  visibility: InformPartnerCustomerVisibility;
};

export type CreateManyInformPartnerCustomerPharmacyProviderAndReturnOutputType = {
  __typename?: 'CreateManyInformPartnerCustomerPharmacyProviderAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  externalId: Scalars['String'];
  id: Scalars['String'];
  informPartnerCustomer?: Maybe<InformPartnerCustomer>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerIntegration: InformPartnerIntegration;
  informPartnerIntegrationId: Scalars['String'];
  name: InformPartnerCustomerPharmacyProviderName;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerCustomerPharmacyProviderStatus;
  type: InformPartnerCustomerPharmacyProviderType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformPartnerIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyInformPartnerIntegrationAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  credentials?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  informPartner: InformPartner;
  informPartnerId: Scalars['String'];
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformPartnerIntegrationModelAndReturnOutputType = {
  __typename?: 'CreateManyInformPartnerIntegrationModelAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  executeAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  informPartnerIntegration: InformPartnerIntegration;
  informPartnerIntegrationId: Scalars['String'];
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name: InformPartnerIntegrationModelName;
  status: InformPartnerIntegrationModelStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformPartnerProgramAndReturnOutputType = {
  __typename?: 'CreateManyInformPartnerProgramAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartner: InformPartner;
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerProgramStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformPartnerProgramEnrollmentAndReturnOutputType = {
  __typename?: 'CreateManyInformPartnerProgramEnrollmentAndReturnOutputType';
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUser?: Maybe<User>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  informPartnerProgram: InformPartnerProgram;
  informPartnerProgramId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformPartnerUserAndReturnOutputType = {
  __typename?: 'CreateManyInformPartnerUserAndReturnOutputType';
  checksum: Scalars['String'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartner: InformPartner;
  informPartnerId: Scalars['String'];
  informPartnerIntegration: InformPartnerIntegration;
  informPartnerIntegrationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerUserStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformPartnerUserRoleAndReturnOutputType = {
  __typename?: 'CreateManyInformPartnerUserRoleAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informPartnerCustomer: InformPartnerCustomer;
  informPartnerCustomerId: Scalars['String'];
  informPartnerUser: InformPartnerUser;
  informPartnerUserId: Scalars['String'];
  name: InformPartnerUserRoleName;
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerUserRoleStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformScheduledCampaignAndReturnOutputType = {
  __typename?: 'CreateManyInformScheduledCampaignAndReturnOutputType';
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  informCampaign: InformCampaign;
  informEmailTemplate?: Maybe<InformEmailTemplate>;
  informEmailTemplateId?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type CreateManyInformSessionAndReturnOutputType = {
  __typename?: 'CreateManyInformSessionAndReturnOutputType';
  ClinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informAudienceMember: InformAudienceMember;
  informAudienceMemberId: Scalars['String'];
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessage>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status: InformSessionStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInformSessionEventAndReturnOutputType = {
  __typename?: 'CreateManyInformSessionEventAndReturnOutputType';
  authorId?: Maybe<Scalars['String']>;
  authorType: InformSessionEventAuthorType;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['Json']>;
  eventListener?: Maybe<InformEventListener>;
  id: Scalars['String'];
  informEventListenerId?: Maybe<Scalars['String']>;
  informSessionId: Scalars['String'];
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  session: InformSession;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInstinctIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyInstinctIntegrationAndReturnOutputType';
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locationId?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  subdomain: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
};

export type CreateManyInsuranceIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyInsuranceIntegrationAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  type: InsuranceIntegrationType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyIntegrationOutageHistoryEntryAndReturnOutputType = {
  __typename?: 'CreateManyIntegrationOutageHistoryEntryAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  status: Scalars['String'];
};

export type CreateManyInterchangeRateAndReturnOutputType = {
  __typename?: 'CreateManyInterchangeRateAndReturnOutputType';
  basisPoints: Scalars['Int'];
  centsPerTransaction: Scalars['Int'];
  clinicPaymentFeeConfiguration: ClinicPaymentFeeConfiguration;
  clinicPaymentFeeConfigurationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  fundingSources?: Maybe<Array<CardFunding>>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInvoiceAndReturnOutputType = {
  __typename?: 'CreateManyInvoiceAndReturnOutputType';
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: Currency;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  outstandingBalance: Scalars['Int'];
  sentBy?: Maybe<User>;
  sentByUserId?: Maybe<Scalars['String']>;
  status: InvoiceStatus;
  subtotal: Scalars['Int'];
  taxes: Scalars['Int'];
  total: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInvoiceLineItemAndReturnOutputType = {
  __typename?: 'CreateManyInvoiceLineItemAndReturnOutputType';
  amount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredBy?: Maybe<ClinicEmployee>;
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id: Scalars['String'];
  invoice: Invoice;
  invoiceId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isTaxable: Scalars['Boolean'];
  isVoided: Scalars['Boolean'];
  lineNumber: Scalars['Int'];
  provider?: Maybe<ClinicEmployee>;
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  service?: Maybe<Service>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyInvoicePimsWritebackLogEntryAndReturnOutputType = {
  __typename?: 'CreateManyInvoicePimsWritebackLogEntryAndReturnOutputType';
  action: InvoicePimsWritebackAction;
  invoice: Invoice;
  invoiceId: Scalars['String'];
  writebackLog: PimsWritebackLogEntry;
  writebackLogId: Scalars['String'];
};

export type CreateManyLabPanelAndReturnOutputType = {
  __typename?: 'CreateManyLabPanelAndReturnOutputType';
  clinicEmployee?: Maybe<ClinicEmployee>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLabResultAndReturnOutputType = {
  __typename?: 'CreateManyLabResultAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  indicator?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  labPanel?: Maybe<LabPanel>;
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLapsedPetParentTriggersAndReturnOutputType = {
  __typename?: 'CreateManyLapsedPetParentTriggersAndReturnOutputType';
  automation: WorkflowEventSetting;
  automationId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isQueued: Scalars['Boolean'];
  triggerAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLegalEntityAndReturnOutputType = {
  __typename?: 'CreateManyLegalEntityAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  ein: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: LegalEntityType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLoyaltyAccountAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyAccountAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  leftOverSpend: Scalars['Int'];
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance: Scalars['Int'];
  program: LoyaltyProgram;
  programId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLoyaltyAccountHolderAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyAccountHolderAndReturnOutputType';
  account: LoyaltyAccount;
  accountId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  program: LoyaltyProgram;
  programId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLoyaltyAccountMergerAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyAccountMergerAndReturnOutputType';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  initiatedBy: User;
  mergeDataFromAccount: LoyaltyAccount;
  mergeDataFromAccountId: Scalars['String'];
  mergeDataIntoAccount: LoyaltyAccount;
  mergeDataIntoAccountId: Scalars['String'];
  mergerInitiatorId: Scalars['String'];
  status: LoyaltyAccountMergerStatus;
};

export type CreateManyLoyaltyInvoicePointGranterAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyInvoicePointGranterAndReturnOutputType';
  allowAllServices: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  label: Scalars['String'];
  program: LoyaltyProgram;
  programId: Scalars['String'];
  reduceFromDiscounts: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLoyaltyPointDeltaAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyPointDeltaAndReturnOutputType';
  account: LoyaltyAccount;
  accountId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  grantingInvoice?: Maybe<Invoice>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranter>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount: Scalars['Boolean'];
  relatedClinic: Clinic;
  relatedClinicId: Scalars['String'];
  source: LoyaltyPointDeltaSource;
  updatedAt: Scalars['DateTime'];
  userGrant?: Maybe<LoyaltyPointUserGrant>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type CreateManyLoyaltyPointGrantingServiceAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyPointGrantingServiceAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  granter: LoyaltyInvoicePointGranter;
  granterId: Scalars['String'];
  service: Service;
  serviceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLoyaltyPointGrantingServiceCategoryAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyPointGrantingServiceCategoryAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  granter: LoyaltyInvoicePointGranter;
  granterId: Scalars['String'];
  serviceCategory: ServiceCategory;
  serviceCategoryId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLoyaltyPointUserGrantAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyPointUserGrantAndReturnOutputType';
  amount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  grantingUser: User;
  grantingUserId: Scalars['String'];
  id: Scalars['String'];
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLoyaltyProgramAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyProgramAndReturnOutputType';
  allowOpenInvoices: Scalars['Boolean'];
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  minimumTransactionCents: Scalars['Int'];
  status: LoyaltyProgramStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLoyaltyProgramStatusHistoryAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyProgramStatusHistoryAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  program: LoyaltyProgram;
  programId: Scalars['String'];
  status: LoyaltyProgramStatus;
};

export type CreateManyLoyaltyRewardAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyRewardAndReturnOutputType';
  availability: LoyaltyRewardAvailability;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  internalNotes?: Maybe<Scalars['String']>;
  pointCost: Scalars['Int'];
  program: LoyaltyProgram;
  programId: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLoyaltyRewardRedemptionAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyRewardRedemptionAndReturnOutputType';
  account: LoyaltyAccount;
  accountId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  internalNote: Scalars['String'];
  reward: LoyaltyReward;
  rewardId: Scalars['String'];
  status: LoyaltyRewardRedemptionStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyLoyaltyRewardRedemptionHistoryEntryAndReturnOutputType = {
  __typename?: 'CreateManyLoyaltyRewardRedemptionHistoryEntryAndReturnOutputType';
  actingAccountHolder?: Maybe<LoyaltyAccountHolder>;
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUser?: Maybe<User>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  pointDelta?: Maybe<LoyaltyPointDelta>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemption: LoyaltyRewardRedemption;
  redemptionId: Scalars['String'];
  relatedClinic?: Maybe<Clinic>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status: LoyaltyRewardRedemptionStatus;
};

export type CreateManyMassTextAlertAndReturnOutputType = {
  __typename?: 'CreateManyMassTextAlertAndReturnOutputType';
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByUser: User;
  createdByUserId: Scalars['String'];
  id: Scalars['String'];
  status: MassTextAlertStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyMassTextAlertEntryAndReturnOutputType = {
  __typename?: 'CreateManyMassTextAlertEntryAndReturnOutputType';
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  massTextAlert: MassTextAlert;
  massTextAlertId: Scalars['String'];
  phoneNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyMassTextAlertEntryAppointmentAndReturnOutputType = {
  __typename?: 'CreateManyMassTextAlertEntryAppointmentAndReturnOutputType';
  appointment: Appointment;
  appointmentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  massTextAlertEntry: MassTextAlertEntry;
  massTextAlertEntryId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyMediaAndReturnOutputType = {
  __typename?: 'CreateManyMediaAndReturnOutputType';
  checksum: Scalars['String'];
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  parent?: Maybe<Media>;
  parentMediaId?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type CreateManyMedicalHistoryAndReturnOutputType = {
  __typename?: 'CreateManyMedicalHistoryAndReturnOutputType';
  clinicEmployee?: Maybe<ClinicEmployee>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<Service>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyMessageTemplateAndReturnOutputType = {
  __typename?: 'CreateManyMessageTemplateAndReturnOutputType';
  attachments: Scalars['Json'];
  body: Scalars['String'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  type: MessageTemplateType;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
};

export type CreateManyMessagingCampaignAndReturnOutputType = {
  __typename?: 'CreateManyMessagingCampaignAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  messagingPartner: MessagingPartner;
  messagingPartnerId: Scalars['String'];
  name: Scalars['String'];
  status: MessagingCampaignStatus;
  type: MessagingCampaignType;
  updatedAt: Scalars['DateTime'];
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
};

export type CreateManyMessagingPartnerAndReturnOutputType = {
  __typename?: 'CreateManyMessagingPartnerAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyModuleAndReturnOutputType = {
  __typename?: 'CreateManyModuleAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyNeoIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyNeoIntegrationAndReturnOutputType';
  authToken: Scalars['String'];
  branchId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyNonPrismaSchemaScriptRanAndReturnOutputType = {
  __typename?: 'CreateManyNonPrismaSchemaScriptRanAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  scriptName: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyNotificationEventToMessageAndReturnOutputType = {
  __typename?: 'CreateManyNotificationEventToMessageAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  emailBody: Scalars['String'];
  emailCallToAction: Scalars['String'];
  emailSalutation: Scalars['String'];
  emailSubject: Scalars['String'];
  emailTitle: Scalars['String'];
  event: NotificationEvent;
  id: Scalars['String'];
  smsMessage: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyOrganizationAndReturnOutputType = {
  __typename?: 'CreateManyOrganizationAndReturnOutputType';
  configuration: Scalars['Json'];
  createdAt: Scalars['DateTime'];
  crmId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  paymentProcessorClinic?: Maybe<Clinic>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyOrganizationCareBenefitToClinicServiceAndReturnOutputType = {
  __typename?: 'CreateManyOrganizationCareBenefitToClinicServiceAndReturnOutputType';
  benefit: CareBenefit;
  benefitId: Scalars['String'];
  service: Service;
  serviceId: Scalars['String'];
};

export type CreateManyOrganizationCareBenefitToClinicServiceCategoryAndReturnOutputType = {
  __typename?: 'CreateManyOrganizationCareBenefitToClinicServiceCategoryAndReturnOutputType';
  benefit: CareBenefit;
  benefitId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  serviceCategory: ServiceCategory;
  serviceCategoryId: Scalars['String'];
};

export type CreateManyOrganizationPetAndReturnOutputType = {
  __typename?: 'CreateManyOrganizationPetAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  organization: Organization;
  organizationId: Scalars['String'];
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyOrganizationPetParentAndReturnOutputType = {
  __typename?: 'CreateManyOrganizationPetParentAndReturnOutputType';
  activeCareStripeSubscription?: Maybe<CareStripeSubscription>;
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  organization: Organization;
  organizationId: Scalars['String'];
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomer?: Maybe<StripeCustomer>;
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyOrganizationPetToOrganizationPetParentAndReturnOutputType = {
  __typename?: 'CreateManyOrganizationPetToOrganizationPetParentAndReturnOutputType';
  organizationPet: OrganizationPet;
  organizationPetId: Scalars['String'];
  organizationPetParent: OrganizationPetParent;
  organizationPetParentId: Scalars['String'];
};

export type CreateManyOwnerInfoAndReturnOutputType = {
  __typename?: 'CreateManyOwnerInfoAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPpcIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyPPCIntegrationAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPaymentPimsWritebackLogEntryAndReturnOutputType = {
  __typename?: 'CreateManyPaymentPimsWritebackLogEntryAndReturnOutputType';
  action: PaymentPimsWritebackAction;
  payment: StripePaymentIntent;
  paymentId: Scalars['String'];
  writebackLog: PimsWritebackLogEntry;
  writebackLogId: Scalars['String'];
};

export type CreateManyPaymentsReportTransactionAndReturnOutputType = {
  __typename?: 'CreateManyPaymentsReportTransactionAndReturnOutputType';
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  channelId?: Maybe<Scalars['String']>;
  clientFee?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  clientPetParentEmail?: Maybe<Scalars['String']>;
  clientPetParentId?: Maybe<Scalars['String']>;
  clientPimsId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  financialAdjustmentDescription?: Maybe<Scalars['String']>;
  financialAdjustmentId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceIdentifiers?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  netProceeds?: Maybe<Scalars['Int']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  paymentStatus?: Maybe<Scalars['String']>;
  refundReason?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentIntentPaidAt?: Maybe<Scalars['DateTime']>;
  stripePaymentIntentStripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  terminalId?: Maybe<Scalars['String']>;
  terminalName?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
  transactionId: Scalars['String'];
  type: FinancialTransactionType;
  writebackError?: Maybe<NormalizedWritebackError>;
  writebackStatus?: Maybe<PimsWritebackStatus>;
};

export type CreateManyPayoutBatchingPeriodAndReturnOutputType = {
  __typename?: 'CreateManyPayoutBatchingPeriodAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  id: Scalars['String'];
  startsAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPayoutBatchingScheduleAndReturnOutputType = {
  __typename?: 'CreateManyPayoutBatchingScheduleAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['DateTime'];
  id: Scalars['String'];
  setting: PayoutBatchingSetting;
  settingId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPayoutBatchingSettingAndReturnOutputType = {
  __typename?: 'CreateManyPayoutBatchingSettingAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isAutomated: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  updatedByUser?: Maybe<User>;
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type CreateManyPermissionAndReturnOutputType = {
  __typename?: 'CreateManyPermissionAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  type: PermissionType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPetAndReturnOutputType = {
  __typename?: 'CreateManyPetAndReturnOutputType';
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currentClinic?: Maybe<Clinic>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  petParent?: Maybe<OwnerInfo>;
  petParentId?: Maybe<Scalars['String']>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  weight: Scalars['Float'];
};

export type CreateManyPetParentSettingAndReturnOutputType = {
  __typename?: 'CreateManyPetParentSettingAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  emailNotifications: Scalars['Boolean'];
  emailOptedOutByPetParent: Scalars['Boolean'];
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isSubscribedToReminders: Scalars['Boolean'];
  pushNotifications: Scalars['Boolean'];
  pushOptedOutByPetParent: Scalars['Boolean'];
  sendSurvey: Scalars['Boolean'];
  smsNotifications: Scalars['Boolean'];
  smsOptedOutByPetParent: Scalars['Boolean'];
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPetPortalSettingAndReturnOutputType = {
  __typename?: 'CreateManyPetPortalSettingAndReturnOutputType';
  clinicSetting: ClinicSetting;
  clinicSettingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  showAppointments: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPhoneNumberLookupRequestAndReturnOutputType = {
  __typename?: 'CreateManyPhoneNumberLookupRequestAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  providerRequestId: Scalars['String'];
  status: PhoneNumberLookupRequestStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPhoneNumberLookupResultAndReturnOutputType = {
  __typename?: 'CreateManyPhoneNumberLookupResultAndReturnOutputType';
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  e164Format: Scalars['String'];
  formatted: Scalars['String'];
  id: Scalars['String'];
  lineProvider: Scalars['String'];
  lineType: Scalars['String'];
  lookupRequestId: Scalars['String'];
  message: Scalars['String'];
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  request: PhoneNumberLookupRequest;
  responseCode: Scalars['Int'];
};

export type CreateManyPimsInvoiceAndReturnOutputType = {
  __typename?: 'CreateManyPimsInvoiceAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  invoice: Invoice;
  invoiceId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPimsInvoiceLineItemAndReturnOutputType = {
  __typename?: 'CreateManyPimsInvoiceLineItemAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  invoiceLineItem: InvoiceLineItem;
  invoiceLineItemId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  type: PimsInvoiceLineItemType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPimsPaymentTypeAndReturnOutputType = {
  __typename?: 'CreateManyPimsPaymentTypeAndReturnOutputType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isCreditCard: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isInactive: Scalars['Boolean'];
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
};

export type CreateManyPimsWritebackLogEntryAndReturnOutputType = {
  __typename?: 'CreateManyPimsWritebackLogEntryAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  httpCode?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredBy?: Maybe<User>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type: PimsWritebackType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPrescriptionAndReturnOutputType = {
  __typename?: 'CreateManyPrescriptionAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  instructions?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctor?: Maybe<ClinicEmployee>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<Service>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyProductAndReturnOutputType = {
  __typename?: 'CreateManyProductAndReturnOutputType';
  brand: Scalars['String'];
  canonicalService: CanonicalService;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartner>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parent?: Maybe<Product>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyProductPackageAndReturnOutputType = {
  __typename?: 'CreateManyProductPackageAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyProductPackageSubscriptionAndReturnOutputType = {
  __typename?: 'CreateManyProductPackageSubscriptionAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  packageId: Scalars['String'];
  productPackage: ProductPackage;
  startAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPromoCodeAndReturnOutputType = {
  __typename?: 'CreateManyPromoCodeAndReturnOutputType';
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  created: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  discount: Scalars['Float'];
  expiresAt: Scalars['DateTime'];
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyProviderAppointmentTypeRoomMapAndReturnOutputType = {
  __typename?: 'CreateManyProviderAppointmentTypeRoomMapAndReturnOutputType';
  appoinmentTypeId?: Maybe<Scalars['String']>;
  appointmentType?: Maybe<AppointmentType>;
  clinicEmployee: ClinicEmployee;
  clinicEmployeeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  room: ClinicRoom;
  roomId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyPushNotificationLogAndReturnOutputType = {
  __typename?: 'CreateManyPushNotificationLogAndReturnOutputType';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDevice: ClinicPetParentDevice;
  clinicPetParentDeviceId: Scalars['String'];
  clinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id: Scalars['String'];
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessage>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefund?: Maybe<StripeRefund>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyRecapAndReturnOutputType = {
  __typename?: 'CreateManyRecapAndReturnOutputType';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: User;
  createdByUserId: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  recordingS3Uri?: Maybe<Scalars['String']>;
  source: RecapSource;
  status: RecapStatus;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyReviewAndReturnOutputType = {
  __typename?: 'CreateManyReviewAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  feedbackMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  rating: Scalars['Int'];
  ratingDisplay: Scalars['String'];
  ratingScale: Scalars['Int'];
  relationshipId?: Maybe<Scalars['String']>;
  reviewType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type CreateManyReviewTagAndReturnOutputType = {
  __typename?: 'CreateManyReviewTagAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyRulesAndReturnOutputType = {
  __typename?: 'CreateManyRulesAndReturnOutputType';
  action: RuleActions;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  options: Scalars['Json'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManySegmentAndReturnOutputType = {
  __typename?: 'CreateManySegmentAndReturnOutputType';
  definitionVariables?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  model: SegmentModelType;
  name: Scalars['String'];
  prismaDefinition?: Maybe<Scalars['Json']>;
  rawSqlDefinition?: Maybe<Scalars['String']>;
  sortingOrder: Scalars['Int'];
  type: SegmentType;
};

export type CreateManySentTrupanionExamDayOfferAndReturnOutputType = {
  __typename?: 'CreateManySentTrupanionExamDayOfferAndReturnOutputType';
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentType>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  clinicUser?: Maybe<User>;
  createdAt: Scalars['DateTime'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegration: TrupanionIntegration;
  trupanionIntegrationId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyServiceAndReturnOutputType = {
  __typename?: 'CreateManyServiceAndReturnOutputType';
  canonicalService?: Maybe<CanonicalService>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  formTemplate?: Maybe<FormTemplate>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders: Scalars['Boolean'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isPetPortal: Scalars['Boolean'];
  isPostcard: Scalars['Boolean'];
  isReminderActive: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategory?: Maybe<ServiceCategory>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomy?: Maybe<Taxonomy>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategory>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type CreateManyServiceCategoryAndReturnOutputType = {
  __typename?: 'CreateManyServiceCategoryAndReturnOutputType';
  description: Scalars['String'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategory>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type CreateManyServicePurchaseSummaryAndReturnOutputType = {
  __typename?: 'CreateManyServicePurchaseSummaryAndReturnOutputType';
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  countInvoices: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  invoice: Invoice;
  invoiceDate: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  lastAmount: Scalars['Float'];
  lastQuantity: Scalars['Float'];
  service: Service;
  serviceId: Scalars['String'];
  sumAmount: Scalars['Float'];
  sumQuantity: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyServiceReminderAndReturnOutputType = {
  __typename?: 'CreateManyServiceReminderAndReturnOutputType';
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded: Scalars['Boolean'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isCompleted: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service: Service;
  serviceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyServiceReminderNotificationAndReturnOutputType = {
  __typename?: 'CreateManyServiceReminderNotificationAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  formSubmission?: Maybe<FormSubmission>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded: Scalars['Boolean'];
  id: Scalars['String'];
  notificationType: ServiceReminderNotificationType;
  parentNotification?: Maybe<ServiceReminderNotification>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt: Scalars['DateTime'];
  queued: Scalars['Boolean'];
  serviceReminder: ServiceReminder;
  serviceReminderId: Scalars['String'];
  timing?: Maybe<ServiceReminderTiming>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyServiceReminderTimingAndReturnOutputType = {
  __typename?: 'CreateManyServiceReminderTimingAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  hourOfDay: Scalars['Int'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isEmail: Scalars['Boolean'];
  isPush: Scalars['Boolean'];
  isSms: Scalars['Boolean'];
  minuteOfHour: Scalars['Int'];
  offset: Scalars['Float'];
  offsetUnit: ServiceReminderTimingOffsetUnit;
  service: Service;
  serviceId: Scalars['String'];
  timingType: ServiceReminderTimingType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManySexAndReturnOutputType = {
  __typename?: 'CreateManySexAndReturnOutputType';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<Species>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManySmsNotificationStatusAndReturnOutputType = {
  __typename?: 'CreateManySmsNotificationStatusAndReturnOutputType';
  clinicPhoneNumber?: Maybe<ClinicPhoneNumber>;
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id: Scalars['String'];
  provider: SmsNotificationProvider;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId: Scalars['String'];
  receivingNumber: Scalars['String'];
  sentChannelMessage?: Maybe<ChannelMessage>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId: Scalars['String'];
  sourceContactEntityType: ContactEntityType;
  status: SmsNotificationStatusType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManySpeciesAndReturnOutputType = {
  __typename?: 'CreateManySpeciesAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption: DirectBookingSpeciesOption;
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyStaffRoleAndReturnOutputType = {
  __typename?: 'CreateManyStaffRoleAndReturnOutputType';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  role: Role;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyStripeCustomerAndReturnOutputType = {
  __typename?: 'CreateManyStripeCustomerAndReturnOutputType';
  id: Scalars['String'];
  stripeId: Scalars['String'];
};

export type CreateManyStripeDisputeAndReturnOutputType = {
  __typename?: 'CreateManyStripeDisputeAndReturnOutputType';
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntent>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayout?: Maybe<StripePayout>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyStripeInvoiceAndReturnOutputType = {
  __typename?: 'CreateManyStripeInvoiceAndReturnOutputType';
  amount: Scalars['Int'];
  careStripeSubscription: CareStripeSubscription;
  careStripeSubscriptionId: Scalars['String'];
  collectionMethod: StripeCollectionMethod;
  createdAt: Scalars['DateTime'];
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount: Scalars['Int'];
  serviceFeePercent: Scalars['Float'];
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer: StripeCustomer;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyStripeInvoiceItemAndReturnOutputType = {
  __typename?: 'CreateManyStripeInvoiceItemAndReturnOutputType';
  amount: Scalars['Int'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  quantity: Scalars['Int'];
  stripeId: Scalars['String'];
  stripeInvoice: StripeInvoice;
  stripeInvoiceId: Scalars['String'];
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount: Scalars['Int'];
};

export type CreateManyStripePaymentIntentAndReturnOutputType = {
  __typename?: 'CreateManyStripePaymentIntentAndReturnOutputType';
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType: ChargeCaptureType;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntent>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<User>;
  sentByAutomation: Scalars['Boolean'];
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status: StripePaymentIntentStatus;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayout?: Maybe<StripePayout>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceipt?: Maybe<StripeReceipt>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminal?: Maybe<StripeTerminal>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType: StripePaymentTransferType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyStripePaymentMethodAndReturnOutputType = {
  __typename?: 'CreateManyStripePaymentMethodAndReturnOutputType';
  cardBrand: CardBrand;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isExpired: Scalars['Boolean'];
  isReusable: Scalars['Boolean'];
  last4: Scalars['String'];
  permitsFutureUsage: Scalars['Boolean'];
  stripeCustomer?: Maybe<StripeCustomer>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  type: StripePaymentMethodType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyStripePayoutAccountAndReturnOutputType = {
  __typename?: 'CreateManyStripePayoutAccountAndReturnOutputType';
  bankName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  last4: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyStripePayoutAndReturnOutputType = {
  __typename?: 'CreateManyStripePayoutAndReturnOutputType';
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriod>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeId: Scalars['String'];
  stripePayoutAccount?: Maybe<StripePayoutAccount>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyStripeReceiptAndReturnOutputType = {
  __typename?: 'CreateManyStripeReceiptAndReturnOutputType';
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dedicatedFileName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type CreateManyStripeReceiptHistoryAndReturnOutputType = {
  __typename?: 'CreateManyStripeReceiptHistoryAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  medium: StripeReceiptMedium;
  receipt: StripeReceipt;
  stripeReceiptId: Scalars['String'];
};

export type CreateManyStripeRefundAndReturnOutputType = {
  __typename?: 'CreateManyStripeRefundAndReturnOutputType';
  amount: Scalars['Int'];
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  issuedBy?: Maybe<User>;
  issuedByUserId?: Maybe<Scalars['String']>;
  reason: RefundReason;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntent>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayout?: Maybe<StripePayout>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceipt?: Maybe<StripeReceipt>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyStripeTerminalAndReturnOutputType = {
  __typename?: 'CreateManyStripeTerminalAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  location: StripeTerminalLocation;
  locationId: Scalars['String'];
  model: StripeTerminalModel;
  name: Scalars['String'];
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyStripeTerminalHealthcheckAndReturnOutputType = {
  __typename?: 'CreateManyStripeTerminalHealthcheckAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  ipAddress?: Maybe<Scalars['String']>;
  status: StripeTerminalStatus;
  tapVersion?: Maybe<Scalars['String']>;
  terminal: StripeTerminal;
  terminalId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyStripeTerminalLocationAndReturnOutputType = {
  __typename?: 'CreateManyStripeTerminalLocationAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  stripeId: Scalars['String'];
  type: StripeTerminalLocationType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManySurveyAppointmentTypeSettingAndReturnOutputType = {
  __typename?: 'CreateManySurveyAppointmentTypeSettingAndReturnOutputType';
  appointmentType: AppointmentType;
  appointmentTypeId: Scalars['String'];
  automatedTriggerInMinutes: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  surveySetting: SurveySetting;
  surveySettingId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManySurveyResultAndReturnOutputType = {
  __typename?: 'CreateManySurveyResultAndReturnOutputType';
  appointment: Appointment;
  appointmentId: Scalars['String'];
  automationRun?: Maybe<AutomationRun>;
  automationRunId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type: SurveyType;
  updatedAt: Scalars['DateTime'];
};

export type CreateManySurveySettingAndReturnOutputType = {
  __typename?: 'CreateManySurveySettingAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  frequencyInDays: Scalars['Int'];
  id: Scalars['String'];
  isAutomatedTriggerForAllAppointmentTypes: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview: Scalars['Boolean'];
  showLinkToLeaveReviewNeutral: Scalars['Boolean'];
  showLinkToLeaveReviewSatisfied: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManySyncVetIntegrationAndReturnOutputType = {
  __typename?: 'CreateManySyncVetIntegrationAndReturnOutputType';
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName: Scalars['String'];
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId: Scalars['String'];
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManySyncVetServiceAndReturnOutputType = {
  __typename?: 'CreateManySyncVetServiceAndReturnOutputType';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManySynchronyClinicConfigurationAndReturnOutputType = {
  __typename?: 'CreateManySynchronyClinicConfigurationAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  merchantNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManySynchronyEventAndReturnOutputType = {
  __typename?: 'CreateManySynchronyEventAndReturnOutputType';
  body: Scalars['Json'];
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheck>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  eventType: SynchronyEventType;
  id: Scalars['String'];
  merchantNumber: Scalars['String'];
  referenceExternalId: Scalars['String'];
  status: SynchronyEventStatus;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyTaskAndReturnOutputType = {
  __typename?: 'CreateManyTaskAndReturnOutputType';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  automationRun?: Maybe<AutomationRun>;
  automationRunId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  paymentIntent?: Maybe<StripePaymentIntent>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt: Scalars['DateTime'];
  widgetRequest?: Maybe<ClinicWidgetRequest>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type CreateManyTaxonomyAndReturnOutputType = {
  __typename?: 'CreateManyTaxonomyAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  entity: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyTaxonomyToInformAudienceDefinitionAndReturnOutputType = {
  __typename?: 'CreateManyTaxonomyToInformAudienceDefinitionAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informAudienceDefinition: InformAudienceDefinition;
  informAudienceDefinitionId: Scalars['String'];
  taxonomy: Taxonomy;
  taxonomyId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyTinyUrlAndReturnOutputType = {
  __typename?: 'CreateManyTinyUrlAndReturnOutputType';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type CreateManyTransactionAndReturnOutputType = {
  __typename?: 'CreateManyTransactionAndReturnOutputType';
  amount: Scalars['Float'];
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4: Scalars['String'];
  cardType: Scalars['String'];
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultation?: Maybe<Consultation>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disbursement?: Maybe<Disbursement>;
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source: PaymentSource;
  status: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyTrupanionCertificateAvailabilityAndReturnOutputType = {
  __typename?: 'CreateManyTrupanionCertificateAvailabilityAndReturnOutputType';
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody: Scalars['Json'];
  responseStatusCode: Scalars['Int'];
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type CreateManyTrupanionIntegratedAppointmentTypeAndReturnOutputType = {
  __typename?: 'CreateManyTrupanionIntegratedAppointmentTypeAndReturnOutputType';
  appointmentType: AppointmentType;
  appointmentTypeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  trupanionIntegration: TrupanionIntegration;
  trupanionIntegrationId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyTrupanionIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyTrupanionIntegrationAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  hospitalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insuranceIntegration: InsuranceIntegration;
  insuranceIntegrationId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyTwilioCallRecordingAndReturnOutputType = {
  __typename?: 'CreateManyTwilioCallRecordingAndReturnOutputType';
  callRecording: CallRecording;
  callRecordingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  errorCode?: Maybe<Scalars['Int']>;
  sid: Scalars['String'];
  status: TwilioRecordingStatus;
  updatedAt: Scalars['DateTime'];
  uri: Scalars['String'];
};

export type CreateManyTwilioConfigurationAndReturnOutputType = {
  __typename?: 'CreateManyTwilioConfigurationAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyTwilioVerificationAndReturnOutputType = {
  __typename?: 'CreateManyTwilioVerificationAndReturnOutputType';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  phoneNumber: Scalars['String'];
  status: TwilioVerificationStatus;
  twilioCallSid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyUnlayerSettingAndReturnOutputType = {
  __typename?: 'CreateManyUnlayerSettingAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyUserAndReturnOutputType = {
  __typename?: 'CreateManyUserAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['String'];
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<User>;
  invitedById?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired: Scalars['Boolean'];
  lastName: Scalars['String'];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfo>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type: UserType;
  updatedAt: Scalars['DateTime'];
  userSetting?: Maybe<UserSetting>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfo?: Maybe<VetInfo>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type CreateManyUserAppointmentGroupingAndReturnOutputType = {
  __typename?: 'CreateManyUserAppointmentGroupingAndReturnOutputType';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  label: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type CreateManyUserBoardFilterAndReturnOutputType = {
  __typename?: 'CreateManyUserBoardFilterAndReturnOutputType';
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id: Scalars['String'];
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  user: User;
  userId: Scalars['String'];
};

export type CreateManyUserChannelFilterSelectionAndReturnOutputType = {
  __typename?: 'CreateManyUserChannelFilterSelectionAndReturnOutputType';
  filterSelection: ChannelFilterSelection;
  filterSelectionId: Scalars['String'];
  id: Scalars['String'];
  isFilterOwner: Scalars['Boolean'];
  user: User;
  userId: Scalars['String'];
};

export type CreateManyUserImpersonationAndReturnOutputType = {
  __typename?: 'CreateManyUserImpersonationAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  impersonatedInformPartnerUser?: Maybe<InformPartnerUser>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUser?: Maybe<User>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUser?: Maybe<InformPartnerUser>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type CreateManyUserNotificationSettingAndReturnOutputType = {
  __typename?: 'CreateManyUserNotificationSettingAndReturnOutputType';
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  emailEnabled: Scalars['Boolean'];
  id: Scalars['String'];
  pushNotificationEnabled: Scalars['Boolean'];
  settingType: NotificationSettingType;
  smsEnabled: Scalars['Boolean'];
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userSetting?: Maybe<UserSetting>;
  userSettingId?: Maybe<Scalars['String']>;
};

export type CreateManyUserSettingAndReturnOutputType = {
  __typename?: 'CreateManyUserSettingAndReturnOutputType';
  browserNotificationFilter?: Maybe<ChannelSelection>;
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emailNotifications: Scalars['Boolean'];
  enterAddsNewLine: Scalars['Boolean'];
  hideSummaryButton: Scalars['Boolean'];
  id: Scalars['String'];
  leftNavPanel: Scalars['Boolean'];
  pushNotifications: Scalars['Boolean'];
  skipLoadingAnimation: Scalars['Boolean'];
  smsNotifications: Scalars['Boolean'];
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyUserTaskListAndReturnOutputType = {
  __typename?: 'CreateManyUserTaskListAndReturnOutputType';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type CreateManyUserTaskListFilterAndReturnOutputType = {
  __typename?: 'CreateManyUserTaskListFilterAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  metadata: Scalars['Json'];
  taskType?: Maybe<TaskType>;
  updatedAt: Scalars['DateTime'];
  userTaskList: UserTaskList;
  userTaskListId: Scalars['String'];
};

export type CreateManyVaccinationAndReturnOutputType = {
  __typename?: 'CreateManyVaccinationAndReturnOutputType';
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  virusType?: Maybe<Scalars['String']>;
};

export type CreateManyVetAvailabilityAndReturnOutputType = {
  __typename?: 'CreateManyVetAvailabilityAndReturnOutputType';
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isAvailable: Scalars['Boolean'];
  isRecurring: Scalars['Boolean'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyVetAvailabilityClinicRoomMapAndReturnOutputType = {
  __typename?: 'CreateManyVetAvailabilityClinicRoomMapAndReturnOutputType';
  clinicRoom: ClinicRoom;
  clinicRoomId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  vetAvailability: VetAvailability;
  vetAvailabilityId: Scalars['String'];
};

export type CreateManyVetAvailabilityMapAndReturnOutputType = {
  __typename?: 'CreateManyVetAvailabilityMapAndReturnOutputType';
  clinicEmployee: ClinicEmployee;
  clinicEmployeeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  vetAvailability: VetAvailability;
  vetAvailabilityId: Scalars['String'];
};

export type CreateManyVetDataIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyVetDataIntegrationAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  defaultProviderId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  installationId: Scalars['String'];
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite: Scalars['Boolean'];
  siteId?: Maybe<Scalars['String']>;
  system: VetDataIntegrationSystem;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyVetInfoAndReturnOutputType = {
  __typename?: 'CreateManyVetInfoAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  currentClinic?: Maybe<Clinic>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyVetLicenseAndReturnOutputType = {
  __typename?: 'CreateManyVetLicenseAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  expirationDate: Scalars['DateTime'];
  id: Scalars['String'];
  issuingAuthority: State;
  licenseNumber: Scalars['String'];
  licenseType: VetLicenseType;
  updatedAt: Scalars['DateTime'];
  vetInfo?: Maybe<VetInfo>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type CreateManyVetsourceCodeTagAndReturnOutputType = {
  __typename?: 'CreateManyVetsourceCodeTagAndReturnOutputType';
  externalId: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: VetsourceCodeTagType;
};

export type CreateManyVetsourceInstallationAndReturnOutputType = {
  __typename?: 'CreateManyVetsourceInstallationAndReturnOutputType';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  connectivityState: VetsourceInstallationConnectivityState;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims: Scalars['String'];
  segment: Scalars['String'];
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyVetsourcePharmacyIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyVetsourcePharmacyIntegrationAndReturnOutputType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt: Scalars['DateTime'];
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type CreateManyVetsourceRevenueCategoryAndReturnOutputType = {
  __typename?: 'CreateManyVetsourceRevenueCategoryAndReturnOutputType';
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  externalId: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategory>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateManyVetterIntegrationAndReturnOutputType = {
  __typename?: 'CreateManyVetterIntegrationAndReturnOutputType';
  apiKey: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateManyWorkflowEventActionAndReturnOutputType = {
  __typename?: 'CreateManyWorkflowEventActionAndReturnOutputType';
  actionType: WorkflowActionType;
  channelStatusChange?: Maybe<ChannelStatus>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  config: Scalars['Json'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  order: Scalars['Int'];
  promptType: AutomationRunActionPromptType;
  responseChannelStatusChange?: Maybe<ChannelStatus>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  triggerWorkflow?: Maybe<WorkflowEventSetting>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  workflowEventSetting?: Maybe<WorkflowEventSetting>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type CreateManyWorkflowEventSettingAndReturnOutputType = {
  __typename?: 'CreateManyWorkflowEventSettingAndReturnOutputType';
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus: ConditionEvaluationStatus;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours: Scalars['Int'];
  id: Scalars['String'];
  initialChannelStatusChange?: Maybe<ChannelStatus>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaign?: Maybe<MessagingCampaign>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours: WorkflowSendingHours;
  surveySetting?: Maybe<SurveySetting>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType: WorkflowEventTriggerType;
  updatedAt: Scalars['DateTime'];
  visitType: WorkflowVisitType;
  workflowType: WorkflowType;
};

export type CreateManyWorkflowTriggerAndReturnOutputType = {
  __typename?: 'CreateManyWorkflowTriggerAndReturnOutputType';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  hasTriggered: Scalars['Boolean'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  triggerAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  workflow: WorkflowEventSetting;
  workflowId: Scalars['String'];
};

export type CreateOneAxionCallInput = {
  destination: Scalars['String'];
  userId: Scalars['String'];
};

export type CreatePaymentMethodSetupInputResult = {
  __typename?: 'CreatePaymentMethodSetupInputResult';
  setupIntentSecret: Scalars['String'];
};

export type CreateSalesforceAccountResponse = {
  __typename?: 'CreateSalesforceAccountResponse';
  clinicId: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  salesforceAccountId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreateTeamChannelInput = {
  assigneeIds: Array<Scalars['ID']>;
  channelVisibility?: Maybe<ChannelVisibility>;
  friendlyName: Scalars['String'];
};

export type CreateTwilioTokenInput = {
  identity: Scalars['String'];
};

export type CreateTwilioTokenResponse = {
  __typename?: 'CreateTwilioTokenResponse';
  token: Scalars['String'];
};

export type CreateWorkflowEventSettingAndConditionsInput = {
  conditions: Array<ConditionCreateWithoutSetInput>;
  workflowEventSetting: WorkflowEventSettingCreateInput;
};

export enum Currency {
  Usd = 'usd'
}

export type CurrentEmailTemplateVersionsFindResponse = {
  __typename?: 'CurrentEmailTemplateVersionsFindResponse';
  draft?: Maybe<EmailTemplateVersion>;
  published?: Maybe<EmailTemplateVersion>;
  unlayer: UnlayerUser;
};

export type CustomFieldDefinition = {
  __typename?: 'CustomFieldDefinition';
  _count: CustomFieldDefinitionCountOutputType;
  clinicPetFieldValues: Array<ClinicPetCustomFieldValue>;
  /** Should only have one of these and should match the targetType */
  clinicPetParentFieldValues: Array<ClinicPetParentCustomFieldValue>;
  clinicPimsIntegration: ClinicPimsIntegration;
  clinicPimsIntegrationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  designation: CustomFieldDesignation;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /**
   * isSensitiveData marks a field that contains data we do not want to sync regardless of a the settings a clinic may desire
   * because the information includes information like SSN, Credit Card, etc.
   * this behavior should override any sync settings if there is a conflict
   */
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  /** the DATE of the deletion of the field, not IF the field is deleted */
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  /** Raw Pims data synced from the pims */
  rawPimsValue?: Maybe<Scalars['Json']>;
  /** Used to resolve sync conflicts when pimsSyncType is ReadWrite, if null use latest */
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt: Scalars['DateTime'];
  writebackLogs: Array<CustomFieldPimsWritebackLogEntry>;
};


export type CustomFieldDefinitionClinicPetFieldValuesArgs = {
  cursor?: Maybe<ClinicPetCustomFieldValueWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetCustomFieldValueScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetCustomFieldValueOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetCustomFieldValueWhereInput>;
};


export type CustomFieldDefinitionClinicPetParentFieldValuesArgs = {
  cursor?: Maybe<ClinicPetParentCustomFieldValueWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentCustomFieldValueScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentCustomFieldValueOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentCustomFieldValueWhereInput>;
};


export type CustomFieldDefinitionWritebackLogsArgs = {
  cursor?: Maybe<CustomFieldPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CustomFieldPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CustomFieldPimsWritebackLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
};

export type CustomFieldDefinitionCountAggregateOutputType = {
  __typename?: 'CustomFieldDefinitionCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPimsIntegrationId: Scalars['Int'];
  createdAt: Scalars['Int'];
  designation: Scalars['Int'];
  existsInPims: Scalars['Int'];
  flowAlias: Scalars['Int'];
  id: Scalars['Int'];
  isSensitiveData: Scalars['Int'];
  lastSyncedAt: Scalars['Int'];
  normalizedType: Scalars['Int'];
  pimsCreated: Scalars['Int'];
  pimsDataType: Scalars['Int'];
  pimsDeleted: Scalars['Int'];
  pimsDisplayName: Scalars['Int'];
  pimsId: Scalars['Int'];
  pimsIsDeleted: Scalars['Int'];
  pimsIsInactive: Scalars['Int'];
  pimsIsRequired: Scalars['Int'];
  pimsName: Scalars['Int'];
  pimsSourceId: Scalars['Int'];
  pimsSyncType: Scalars['Int'];
  pimsUpdated: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  source_of_truth: Scalars['Int'];
  targetType: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CustomFieldDefinitionCountOrderByAggregateInput = {
  clinicPimsIntegrationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  designation?: Maybe<SortOrder>;
  existsInPims?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSensitiveData?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  normalizedType?: Maybe<SortOrder>;
  pimsCreated?: Maybe<SortOrder>;
  pimsDataType?: Maybe<SortOrder>;
  pimsDeleted?: Maybe<SortOrder>;
  pimsDisplayName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsIsDeleted?: Maybe<SortOrder>;
  pimsIsInactive?: Maybe<SortOrder>;
  pimsIsRequired?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsSourceId?: Maybe<SortOrder>;
  pimsSyncType?: Maybe<SortOrder>;
  pimsUpdated?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  source_of_truth?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CustomFieldDefinitionCountOutputType = {
  __typename?: 'CustomFieldDefinitionCountOutputType';
  clinicPetFieldValues: Scalars['Int'];
  clinicPetParentFieldValues: Scalars['Int'];
  writebackLogs: Scalars['Int'];
};

export type CustomFieldDefinitionCreateInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPimsIntegration: ClinicPimsIntegrationCreateNestedOneWithoutCustomFieldDefinitionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryCreateNestedManyWithoutCustomFieldDefinitionInput>;
};

export type CustomFieldDefinitionCreateManyClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomFieldDefinitionCreateManyClinicPimsIntegrationInputEnvelope = {
  data: Array<CustomFieldDefinitionCreateManyClinicPimsIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CustomFieldDefinitionCreateManyInput = {
  clinicPimsIntegrationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomFieldDefinitionCreateNestedManyWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<Array<CustomFieldDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CustomFieldDefinitionCreateOrConnectWithoutClinicPimsIntegrationInput>>;
  create?: Maybe<Array<CustomFieldDefinitionCreateWithoutClinicPimsIntegrationInput>>;
  createMany?: Maybe<CustomFieldDefinitionCreateManyClinicPimsIntegrationInputEnvelope>;
};

export type CustomFieldDefinitionCreateNestedOneWithoutClinicPetFieldValuesInput = {
  connect?: Maybe<CustomFieldDefinitionWhereUniqueInput>;
  connectOrCreate?: Maybe<CustomFieldDefinitionCreateOrConnectWithoutClinicPetFieldValuesInput>;
  create?: Maybe<CustomFieldDefinitionCreateWithoutClinicPetFieldValuesInput>;
};

export type CustomFieldDefinitionCreateNestedOneWithoutClinicPetParentFieldValuesInput = {
  connect?: Maybe<CustomFieldDefinitionWhereUniqueInput>;
  connectOrCreate?: Maybe<CustomFieldDefinitionCreateOrConnectWithoutClinicPetParentFieldValuesInput>;
  create?: Maybe<CustomFieldDefinitionCreateWithoutClinicPetParentFieldValuesInput>;
};

export type CustomFieldDefinitionCreateNestedOneWithoutWritebackLogsInput = {
  connect?: Maybe<CustomFieldDefinitionWhereUniqueInput>;
  connectOrCreate?: Maybe<CustomFieldDefinitionCreateOrConnectWithoutWritebackLogsInput>;
  create?: Maybe<CustomFieldDefinitionCreateWithoutWritebackLogsInput>;
};

export type CustomFieldDefinitionCreateOrConnectWithoutClinicPetFieldValuesInput = {
  create: CustomFieldDefinitionCreateWithoutClinicPetFieldValuesInput;
  where: CustomFieldDefinitionWhereUniqueInput;
};

export type CustomFieldDefinitionCreateOrConnectWithoutClinicPetParentFieldValuesInput = {
  create: CustomFieldDefinitionCreateWithoutClinicPetParentFieldValuesInput;
  where: CustomFieldDefinitionWhereUniqueInput;
};

export type CustomFieldDefinitionCreateOrConnectWithoutClinicPimsIntegrationInput = {
  create: CustomFieldDefinitionCreateWithoutClinicPimsIntegrationInput;
  where: CustomFieldDefinitionWhereUniqueInput;
};

export type CustomFieldDefinitionCreateOrConnectWithoutWritebackLogsInput = {
  create: CustomFieldDefinitionCreateWithoutWritebackLogsInput;
  where: CustomFieldDefinitionWhereUniqueInput;
};

export type CustomFieldDefinitionCreateWithoutClinicPetFieldValuesInput = {
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPimsIntegration: ClinicPimsIntegrationCreateNestedOneWithoutCustomFieldDefinitionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryCreateNestedManyWithoutCustomFieldDefinitionInput>;
};

export type CustomFieldDefinitionCreateWithoutClinicPetParentFieldValuesInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPimsIntegration: ClinicPimsIntegrationCreateNestedOneWithoutCustomFieldDefinitionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryCreateNestedManyWithoutCustomFieldDefinitionInput>;
};

export type CustomFieldDefinitionCreateWithoutClinicPimsIntegrationInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutFieldDefinitionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryCreateNestedManyWithoutCustomFieldDefinitionInput>;
};

export type CustomFieldDefinitionCreateWithoutWritebackLogsInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPimsIntegration: ClinicPimsIntegrationCreateNestedOneWithoutCustomFieldDefinitionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomFieldDefinitionGroupByOutputType = {
  __typename?: 'CustomFieldDefinitionGroupByOutputType';
  _count?: Maybe<CustomFieldDefinitionCountAggregateOutputType>;
  _max?: Maybe<CustomFieldDefinitionMaxAggregateOutputType>;
  _min?: Maybe<CustomFieldDefinitionMinAggregateOutputType>;
  clinicPimsIntegrationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  designation: CustomFieldDesignation;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt: Scalars['DateTime'];
};

export type CustomFieldDefinitionListRelationFilter = {
  every?: Maybe<CustomFieldDefinitionWhereInput>;
  none?: Maybe<CustomFieldDefinitionWhereInput>;
  some?: Maybe<CustomFieldDefinitionWhereInput>;
};

export type CustomFieldDefinitionMaxAggregateOutputType = {
  __typename?: 'CustomFieldDefinitionMaxAggregateOutputType';
  clinicPimsIntegrationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomFieldDefinitionMaxOrderByAggregateInput = {
  clinicPimsIntegrationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  designation?: Maybe<SortOrder>;
  existsInPims?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSensitiveData?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  normalizedType?: Maybe<SortOrder>;
  pimsCreated?: Maybe<SortOrder>;
  pimsDataType?: Maybe<SortOrder>;
  pimsDeleted?: Maybe<SortOrder>;
  pimsDisplayName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsIsDeleted?: Maybe<SortOrder>;
  pimsIsInactive?: Maybe<SortOrder>;
  pimsIsRequired?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsSourceId?: Maybe<SortOrder>;
  pimsSyncType?: Maybe<SortOrder>;
  pimsUpdated?: Maybe<SortOrder>;
  source_of_truth?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CustomFieldDefinitionMinAggregateOutputType = {
  __typename?: 'CustomFieldDefinitionMinAggregateOutputType';
  clinicPimsIntegrationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomFieldDefinitionMinOrderByAggregateInput = {
  clinicPimsIntegrationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  designation?: Maybe<SortOrder>;
  existsInPims?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSensitiveData?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  normalizedType?: Maybe<SortOrder>;
  pimsCreated?: Maybe<SortOrder>;
  pimsDataType?: Maybe<SortOrder>;
  pimsDeleted?: Maybe<SortOrder>;
  pimsDisplayName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsIsDeleted?: Maybe<SortOrder>;
  pimsIsInactive?: Maybe<SortOrder>;
  pimsIsRequired?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsSourceId?: Maybe<SortOrder>;
  pimsSyncType?: Maybe<SortOrder>;
  pimsUpdated?: Maybe<SortOrder>;
  source_of_truth?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CustomFieldDefinitionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CustomFieldDefinitionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CustomFieldDefinitionOrderByRelevanceInput>;
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueOrderByRelationAggregateInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueOrderByRelationAggregateInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  clinicPimsIntegrationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  designation?: Maybe<SortOrder>;
  existsInPims?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSensitiveData?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  normalizedType?: Maybe<SortOrder>;
  pimsCreated?: Maybe<SortOrder>;
  pimsDataType?: Maybe<SortOrder>;
  pimsDeleted?: Maybe<SortOrder>;
  pimsDisplayName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsIsDeleted?: Maybe<SortOrder>;
  pimsIsInactive?: Maybe<SortOrder>;
  pimsIsRequired?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsSourceId?: Maybe<SortOrder>;
  pimsSyncType?: Maybe<SortOrder>;
  pimsUpdated?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  source_of_truth?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryOrderByRelationAggregateInput>;
};

export enum CustomFieldDefinitionOrderByRelevanceFieldEnum {
  ClinicPimsIntegrationId = 'clinicPimsIntegrationId',
  FlowAlias = 'flowAlias',
  Id = 'id',
  PimsDataType = 'pimsDataType',
  PimsDisplayName = 'pimsDisplayName',
  PimsId = 'pimsId',
  PimsName = 'pimsName',
  PimsSourceId = 'pimsSourceId'
}

export type CustomFieldDefinitionOrderByRelevanceInput = {
  fields: Array<CustomFieldDefinitionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CustomFieldDefinitionOrderByWithAggregationInput = {
  _count?: Maybe<CustomFieldDefinitionCountOrderByAggregateInput>;
  _max?: Maybe<CustomFieldDefinitionMaxOrderByAggregateInput>;
  _min?: Maybe<CustomFieldDefinitionMinOrderByAggregateInput>;
  clinicPimsIntegrationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  designation?: Maybe<SortOrder>;
  existsInPims?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSensitiveData?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  normalizedType?: Maybe<SortOrder>;
  pimsCreated?: Maybe<SortOrder>;
  pimsDataType?: Maybe<SortOrder>;
  pimsDeleted?: Maybe<SortOrder>;
  pimsDisplayName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsIsDeleted?: Maybe<SortOrder>;
  pimsIsInactive?: Maybe<SortOrder>;
  pimsIsRequired?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsSourceId?: Maybe<SortOrder>;
  pimsSyncType?: Maybe<SortOrder>;
  pimsUpdated?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  source_of_truth?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CustomFieldDefinitionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CustomFieldDefinitionOrderByRelevanceInput>;
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueOrderByRelationAggregateInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueOrderByRelationAggregateInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  clinicPimsIntegrationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  designation?: Maybe<SortOrder>;
  existsInPims?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSensitiveData?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  normalizedType?: Maybe<SortOrder>;
  pimsCreated?: Maybe<SortOrder>;
  pimsDataType?: Maybe<SortOrder>;
  pimsDeleted?: Maybe<SortOrder>;
  pimsDisplayName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsIsDeleted?: Maybe<SortOrder>;
  pimsIsInactive?: Maybe<SortOrder>;
  pimsIsRequired?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsSourceId?: Maybe<SortOrder>;
  pimsSyncType?: Maybe<SortOrder>;
  pimsUpdated?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  source_of_truth?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryOrderByRelationAggregateInput>;
};

export type CustomFieldDefinitionOrderByWithRelationInput = {
  _relevance?: Maybe<CustomFieldDefinitionOrderByRelevanceInput>;
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueOrderByRelationAggregateInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueOrderByRelationAggregateInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  clinicPimsIntegrationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  designation?: Maybe<SortOrder>;
  existsInPims?: Maybe<SortOrder>;
  flowAlias?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSensitiveData?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  normalizedType?: Maybe<SortOrder>;
  pimsCreated?: Maybe<SortOrder>;
  pimsDataType?: Maybe<SortOrder>;
  pimsDeleted?: Maybe<SortOrder>;
  pimsDisplayName?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsIsDeleted?: Maybe<SortOrder>;
  pimsIsInactive?: Maybe<SortOrder>;
  pimsIsRequired?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsSourceId?: Maybe<SortOrder>;
  pimsSyncType?: Maybe<SortOrder>;
  pimsUpdated?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  source_of_truth?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryOrderByRelationAggregateInput>;
};

export type CustomFieldDefinitionPimsIdClinicPimsIntegrationIdCompoundUniqueInput = {
  clinicPimsIntegrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export enum CustomFieldDefinitionScalarFieldEnum {
  ClinicPimsIntegrationId = 'clinicPimsIntegrationId',
  CreatedAt = 'createdAt',
  Designation = 'designation',
  ExistsInPims = 'existsInPims',
  FlowAlias = 'flowAlias',
  Id = 'id',
  IsSensitiveData = 'isSensitiveData',
  LastSyncedAt = 'lastSyncedAt',
  NormalizedType = 'normalizedType',
  PimsCreated = 'pimsCreated',
  PimsDataType = 'pimsDataType',
  PimsDeleted = 'pimsDeleted',
  PimsDisplayName = 'pimsDisplayName',
  PimsId = 'pimsId',
  PimsIsDeleted = 'pimsIsDeleted',
  PimsIsInactive = 'pimsIsInactive',
  PimsIsRequired = 'pimsIsRequired',
  PimsName = 'pimsName',
  PimsSourceId = 'pimsSourceId',
  PimsSyncType = 'pimsSyncType',
  PimsUpdated = 'pimsUpdated',
  RawPimsValue = 'rawPimsValue',
  SourceOfTruth = 'source_of_truth',
  TargetType = 'targetType',
  UpdatedAt = 'updatedAt'
}

export type CustomFieldDefinitionScalarRelationFilter = {
  AND?: Maybe<Array<CustomFieldDefinitionWhereInput>>;
  NOT?: Maybe<Array<CustomFieldDefinitionWhereInput>>;
  OR?: Maybe<Array<CustomFieldDefinitionWhereInput>>;
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueListRelationFilter>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueListRelationFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  clinicPimsIntegrationId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  designation?: Maybe<EnumCustomFieldDesignationFilter>;
  existsInPims?: Maybe<BoolFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isSensitiveData?: Maybe<BoolNullableFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  normalizedType?: Maybe<EnumCustomFieldNormalizedDataTypeFilter>;
  pimsCreated?: Maybe<DateTimeNullableFilter>;
  pimsDataType?: Maybe<StringNullableFilter>;
  pimsDeleted?: Maybe<DateTimeNullableFilter>;
  pimsDisplayName?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsIsDeleted?: Maybe<BoolNullableFilter>;
  pimsIsInactive?: Maybe<BoolNullableFilter>;
  pimsIsRequired?: Maybe<BoolNullableFilter>;
  pimsName?: Maybe<StringNullableFilter>;
  pimsSourceId?: Maybe<StringNullableFilter>;
  pimsSyncType?: Maybe<EnumCustomFieldPimsSyncTypeFilter>;
  pimsUpdated?: Maybe<DateTimeNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  source_of_truth?: Maybe<EnumCustomFieldsDataSourceNullableFilter>;
  targetType?: Maybe<EnumCustomFieldTargetTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryListRelationFilter>;
};

export type CustomFieldDefinitionScalarWhereInput = {
  AND?: Maybe<Array<CustomFieldDefinitionScalarWhereInput>>;
  NOT?: Maybe<Array<CustomFieldDefinitionScalarWhereInput>>;
  OR?: Maybe<Array<CustomFieldDefinitionScalarWhereInput>>;
  clinicPimsIntegrationId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  designation?: Maybe<EnumCustomFieldDesignationFilter>;
  existsInPims?: Maybe<BoolFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isSensitiveData?: Maybe<BoolNullableFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  normalizedType?: Maybe<EnumCustomFieldNormalizedDataTypeFilter>;
  pimsCreated?: Maybe<DateTimeNullableFilter>;
  pimsDataType?: Maybe<StringNullableFilter>;
  pimsDeleted?: Maybe<DateTimeNullableFilter>;
  pimsDisplayName?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsIsDeleted?: Maybe<BoolNullableFilter>;
  pimsIsInactive?: Maybe<BoolNullableFilter>;
  pimsIsRequired?: Maybe<BoolNullableFilter>;
  pimsName?: Maybe<StringNullableFilter>;
  pimsSourceId?: Maybe<StringNullableFilter>;
  pimsSyncType?: Maybe<EnumCustomFieldPimsSyncTypeFilter>;
  pimsUpdated?: Maybe<DateTimeNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  source_of_truth?: Maybe<EnumCustomFieldsDataSourceNullableFilter>;
  targetType?: Maybe<EnumCustomFieldTargetTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CustomFieldDefinitionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CustomFieldDefinitionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CustomFieldDefinitionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CustomFieldDefinitionScalarWhereWithAggregatesInput>>;
  clinicPimsIntegrationId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  designation?: Maybe<EnumCustomFieldDesignationWithAggregatesFilter>;
  existsInPims?: Maybe<BoolWithAggregatesFilter>;
  flowAlias?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isSensitiveData?: Maybe<BoolNullableWithAggregatesFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  normalizedType?: Maybe<EnumCustomFieldNormalizedDataTypeWithAggregatesFilter>;
  pimsCreated?: Maybe<DateTimeNullableWithAggregatesFilter>;
  pimsDataType?: Maybe<StringNullableWithAggregatesFilter>;
  pimsDeleted?: Maybe<DateTimeNullableWithAggregatesFilter>;
  pimsDisplayName?: Maybe<StringNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  pimsIsDeleted?: Maybe<BoolNullableWithAggregatesFilter>;
  pimsIsInactive?: Maybe<BoolNullableWithAggregatesFilter>;
  pimsIsRequired?: Maybe<BoolNullableWithAggregatesFilter>;
  pimsName?: Maybe<StringNullableWithAggregatesFilter>;
  pimsSourceId?: Maybe<StringNullableWithAggregatesFilter>;
  pimsSyncType?: Maybe<EnumCustomFieldPimsSyncTypeWithAggregatesFilter>;
  pimsUpdated?: Maybe<DateTimeNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  source_of_truth?: Maybe<EnumCustomFieldsDataSourceNullableWithAggregatesFilter>;
  targetType?: Maybe<EnumCustomFieldTargetTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CustomFieldDefinitionUncheckedCreateInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPimsIntegrationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedCreateNestedManyWithoutCustomFieldDefinitionInput>;
};

export type CustomFieldDefinitionUncheckedCreateNestedManyWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<Array<CustomFieldDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CustomFieldDefinitionCreateOrConnectWithoutClinicPimsIntegrationInput>>;
  create?: Maybe<Array<CustomFieldDefinitionCreateWithoutClinicPimsIntegrationInput>>;
  createMany?: Maybe<CustomFieldDefinitionCreateManyClinicPimsIntegrationInputEnvelope>;
};

export type CustomFieldDefinitionUncheckedCreateWithoutClinicPetFieldValuesInput = {
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPimsIntegrationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedCreateNestedManyWithoutCustomFieldDefinitionInput>;
};

export type CustomFieldDefinitionUncheckedCreateWithoutClinicPetParentFieldValuesInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPimsIntegrationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedCreateNestedManyWithoutCustomFieldDefinitionInput>;
};

export type CustomFieldDefinitionUncheckedCreateWithoutClinicPimsIntegrationInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutFieldDefinitionInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedCreateNestedManyWithoutCustomFieldDefinitionInput>;
};

export type CustomFieldDefinitionUncheckedCreateWithoutWritebackLogsInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedCreateNestedManyWithoutFieldDefinitionInput>;
  clinicPimsIntegrationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims: Scalars['Boolean'];
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType: CustomFieldNormalizedDataType;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType: CustomFieldPimsSyncType;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType: CustomFieldTargetType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomFieldDefinitionUncheckedUpdateInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPimsIntegrationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedUpdateManyWithoutCustomFieldDefinitionNestedInput>;
};

export type CustomFieldDefinitionUncheckedUpdateManyInput = {
  clinicPimsIntegrationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomFieldDefinitionUncheckedUpdateManyWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<Array<CustomFieldDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CustomFieldDefinitionCreateOrConnectWithoutClinicPimsIntegrationInput>>;
  create?: Maybe<Array<CustomFieldDefinitionCreateWithoutClinicPimsIntegrationInput>>;
  createMany?: Maybe<CustomFieldDefinitionCreateManyClinicPimsIntegrationInputEnvelope>;
  delete?: Maybe<Array<CustomFieldDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CustomFieldDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<CustomFieldDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<CustomFieldDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<CustomFieldDefinitionUpdateWithWhereUniqueWithoutClinicPimsIntegrationInput>>;
  updateMany?: Maybe<Array<CustomFieldDefinitionUpdateManyWithWhereWithoutClinicPimsIntegrationInput>>;
  upsert?: Maybe<Array<CustomFieldDefinitionUpsertWithWhereUniqueWithoutClinicPimsIntegrationInput>>;
};

export type CustomFieldDefinitionUncheckedUpdateWithoutClinicPetFieldValuesInput = {
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPimsIntegrationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedUpdateManyWithoutCustomFieldDefinitionNestedInput>;
};

export type CustomFieldDefinitionUncheckedUpdateWithoutClinicPetParentFieldValuesInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPimsIntegrationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedUpdateManyWithoutCustomFieldDefinitionNestedInput>;
};

export type CustomFieldDefinitionUncheckedUpdateWithoutClinicPimsIntegrationInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutFieldDefinitionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedUpdateManyWithoutCustomFieldDefinitionNestedInput>;
};

export type CustomFieldDefinitionUncheckedUpdateWithoutWritebackLogsInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueUncheckedUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueUncheckedUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPimsIntegrationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomFieldDefinitionUpdateInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutCustomFieldDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryUpdateManyWithoutCustomFieldDefinitionNestedInput>;
};

export type CustomFieldDefinitionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomFieldDefinitionUpdateManyWithWhereWithoutClinicPimsIntegrationInput = {
  data: CustomFieldDefinitionUpdateManyMutationInput;
  where: CustomFieldDefinitionScalarWhereInput;
};

export type CustomFieldDefinitionUpdateManyWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<Array<CustomFieldDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CustomFieldDefinitionCreateOrConnectWithoutClinicPimsIntegrationInput>>;
  create?: Maybe<Array<CustomFieldDefinitionCreateWithoutClinicPimsIntegrationInput>>;
  createMany?: Maybe<CustomFieldDefinitionCreateManyClinicPimsIntegrationInputEnvelope>;
  delete?: Maybe<Array<CustomFieldDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CustomFieldDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<CustomFieldDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<CustomFieldDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<CustomFieldDefinitionUpdateWithWhereUniqueWithoutClinicPimsIntegrationInput>>;
  updateMany?: Maybe<Array<CustomFieldDefinitionUpdateManyWithWhereWithoutClinicPimsIntegrationInput>>;
  upsert?: Maybe<Array<CustomFieldDefinitionUpsertWithWhereUniqueWithoutClinicPimsIntegrationInput>>;
};

export type CustomFieldDefinitionUpdateOneRequiredWithoutClinicPetFieldValuesNestedInput = {
  connect?: Maybe<CustomFieldDefinitionWhereUniqueInput>;
  connectOrCreate?: Maybe<CustomFieldDefinitionCreateOrConnectWithoutClinicPetFieldValuesInput>;
  create?: Maybe<CustomFieldDefinitionCreateWithoutClinicPetFieldValuesInput>;
  update?: Maybe<CustomFieldDefinitionUpdateToOneWithWhereWithoutClinicPetFieldValuesInput>;
  upsert?: Maybe<CustomFieldDefinitionUpsertWithoutClinicPetFieldValuesInput>;
};

export type CustomFieldDefinitionUpdateOneRequiredWithoutClinicPetParentFieldValuesNestedInput = {
  connect?: Maybe<CustomFieldDefinitionWhereUniqueInput>;
  connectOrCreate?: Maybe<CustomFieldDefinitionCreateOrConnectWithoutClinicPetParentFieldValuesInput>;
  create?: Maybe<CustomFieldDefinitionCreateWithoutClinicPetParentFieldValuesInput>;
  update?: Maybe<CustomFieldDefinitionUpdateToOneWithWhereWithoutClinicPetParentFieldValuesInput>;
  upsert?: Maybe<CustomFieldDefinitionUpsertWithoutClinicPetParentFieldValuesInput>;
};

export type CustomFieldDefinitionUpdateOneRequiredWithoutWritebackLogsNestedInput = {
  connect?: Maybe<CustomFieldDefinitionWhereUniqueInput>;
  connectOrCreate?: Maybe<CustomFieldDefinitionCreateOrConnectWithoutWritebackLogsInput>;
  create?: Maybe<CustomFieldDefinitionCreateWithoutWritebackLogsInput>;
  update?: Maybe<CustomFieldDefinitionUpdateToOneWithWhereWithoutWritebackLogsInput>;
  upsert?: Maybe<CustomFieldDefinitionUpsertWithoutWritebackLogsInput>;
};

export type CustomFieldDefinitionUpdateToOneWithWhereWithoutClinicPetFieldValuesInput = {
  data: CustomFieldDefinitionUpdateWithoutClinicPetFieldValuesInput;
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};

export type CustomFieldDefinitionUpdateToOneWithWhereWithoutClinicPetParentFieldValuesInput = {
  data: CustomFieldDefinitionUpdateWithoutClinicPetParentFieldValuesInput;
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};

export type CustomFieldDefinitionUpdateToOneWithWhereWithoutWritebackLogsInput = {
  data: CustomFieldDefinitionUpdateWithoutWritebackLogsInput;
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};

export type CustomFieldDefinitionUpdateWithWhereUniqueWithoutClinicPimsIntegrationInput = {
  data: CustomFieldDefinitionUpdateWithoutClinicPimsIntegrationInput;
  where: CustomFieldDefinitionWhereUniqueInput;
};

export type CustomFieldDefinitionUpdateWithoutClinicPetFieldValuesInput = {
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutCustomFieldDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryUpdateManyWithoutCustomFieldDefinitionNestedInput>;
};

export type CustomFieldDefinitionUpdateWithoutClinicPetParentFieldValuesInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutCustomFieldDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryUpdateManyWithoutCustomFieldDefinitionNestedInput>;
};

export type CustomFieldDefinitionUpdateWithoutClinicPimsIntegrationInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutFieldDefinitionNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryUpdateManyWithoutCustomFieldDefinitionNestedInput>;
};

export type CustomFieldDefinitionUpdateWithoutWritebackLogsInput = {
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueUpdateManyWithoutFieldDefinitionNestedInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutCustomFieldDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  designation?: Maybe<CustomFieldDesignation>;
  existsInPims?: Maybe<Scalars['Boolean']>;
  flowAlias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  normalizedType?: Maybe<CustomFieldNormalizedDataType>;
  pimsCreated?: Maybe<Scalars['DateTime']>;
  pimsDataType?: Maybe<Scalars['String']>;
  pimsDeleted?: Maybe<Scalars['DateTime']>;
  pimsDisplayName?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsIsDeleted?: Maybe<Scalars['Boolean']>;
  pimsIsInactive?: Maybe<Scalars['Boolean']>;
  pimsIsRequired?: Maybe<Scalars['Boolean']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsSourceId?: Maybe<Scalars['String']>;
  pimsSyncType?: Maybe<CustomFieldPimsSyncType>;
  pimsUpdated?: Maybe<Scalars['DateTime']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  source_of_truth?: Maybe<CustomFieldsDataSource>;
  targetType?: Maybe<CustomFieldTargetType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomFieldDefinitionUpsertWithWhereUniqueWithoutClinicPimsIntegrationInput = {
  create: CustomFieldDefinitionCreateWithoutClinicPimsIntegrationInput;
  update: CustomFieldDefinitionUpdateWithoutClinicPimsIntegrationInput;
  where: CustomFieldDefinitionWhereUniqueInput;
};

export type CustomFieldDefinitionUpsertWithoutClinicPetFieldValuesInput = {
  create: CustomFieldDefinitionCreateWithoutClinicPetFieldValuesInput;
  update: CustomFieldDefinitionUpdateWithoutClinicPetFieldValuesInput;
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};

export type CustomFieldDefinitionUpsertWithoutClinicPetParentFieldValuesInput = {
  create: CustomFieldDefinitionCreateWithoutClinicPetParentFieldValuesInput;
  update: CustomFieldDefinitionUpdateWithoutClinicPetParentFieldValuesInput;
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};

export type CustomFieldDefinitionUpsertWithoutWritebackLogsInput = {
  create: CustomFieldDefinitionCreateWithoutWritebackLogsInput;
  update: CustomFieldDefinitionUpdateWithoutWritebackLogsInput;
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};

export type CustomFieldDefinitionWhereInput = {
  AND?: Maybe<Array<CustomFieldDefinitionWhereInput>>;
  NOT?: Maybe<Array<CustomFieldDefinitionWhereInput>>;
  OR?: Maybe<Array<CustomFieldDefinitionWhereInput>>;
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueListRelationFilter>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueListRelationFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  clinicPimsIntegrationId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  designation?: Maybe<EnumCustomFieldDesignationFilter>;
  existsInPims?: Maybe<BoolFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isSensitiveData?: Maybe<BoolNullableFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  normalizedType?: Maybe<EnumCustomFieldNormalizedDataTypeFilter>;
  pimsCreated?: Maybe<DateTimeNullableFilter>;
  pimsDataType?: Maybe<StringNullableFilter>;
  pimsDeleted?: Maybe<DateTimeNullableFilter>;
  pimsDisplayName?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsIsDeleted?: Maybe<BoolNullableFilter>;
  pimsIsInactive?: Maybe<BoolNullableFilter>;
  pimsIsRequired?: Maybe<BoolNullableFilter>;
  pimsName?: Maybe<StringNullableFilter>;
  pimsSourceId?: Maybe<StringNullableFilter>;
  pimsSyncType?: Maybe<EnumCustomFieldPimsSyncTypeFilter>;
  pimsUpdated?: Maybe<DateTimeNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  source_of_truth?: Maybe<EnumCustomFieldsDataSourceNullableFilter>;
  targetType?: Maybe<EnumCustomFieldTargetTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryListRelationFilter>;
};

export type CustomFieldDefinitionWhereUniqueInput = {
  AND?: Maybe<Array<CustomFieldDefinitionWhereInput>>;
  NOT?: Maybe<Array<CustomFieldDefinitionWhereInput>>;
  OR?: Maybe<Array<CustomFieldDefinitionWhereInput>>;
  clinicPetFieldValues?: Maybe<ClinicPetCustomFieldValueListRelationFilter>;
  clinicPetParentFieldValues?: Maybe<ClinicPetParentCustomFieldValueListRelationFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  clinicPimsIntegrationId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  designation?: Maybe<EnumCustomFieldDesignationFilter>;
  existsInPims?: Maybe<BoolFilter>;
  flowAlias?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isSensitiveData?: Maybe<BoolNullableFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  normalizedType?: Maybe<EnumCustomFieldNormalizedDataTypeFilter>;
  pimsCreated?: Maybe<DateTimeNullableFilter>;
  pimsDataType?: Maybe<StringNullableFilter>;
  pimsDeleted?: Maybe<DateTimeNullableFilter>;
  pimsDisplayName?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  pimsId_clinicPimsIntegrationId?: Maybe<CustomFieldDefinitionPimsIdClinicPimsIntegrationIdCompoundUniqueInput>;
  pimsIsDeleted?: Maybe<BoolNullableFilter>;
  pimsIsInactive?: Maybe<BoolNullableFilter>;
  pimsIsRequired?: Maybe<BoolNullableFilter>;
  pimsName?: Maybe<StringNullableFilter>;
  pimsSourceId?: Maybe<StringNullableFilter>;
  pimsSyncType?: Maybe<EnumCustomFieldPimsSyncTypeFilter>;
  pimsUpdated?: Maybe<DateTimeNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  source_of_truth?: Maybe<EnumCustomFieldsDataSourceNullableFilter>;
  targetType?: Maybe<EnumCustomFieldTargetTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  writebackLogs?: Maybe<CustomFieldPimsWritebackLogEntryListRelationFilter>;
};

export enum CustomFieldDesignation {
  ClinicPetParentCareSubscriptionStatus = 'ClinicPetParent_CareSubscriptionStatus',
  ClinicPetCarePlanName = 'ClinicPet_CarePlanName',
  ClinicPetCareSubscriptionStatus = 'ClinicPet_CareSubscriptionStatus',
  Unspecified = 'Unspecified'
}

export enum CustomFieldNormalizedDataType {
  Boolean = 'Boolean',
  Number = 'Number',
  String = 'String',
  Unknown = 'Unknown'
}

export enum CustomFieldPimsSyncType {
  NoSync = 'NoSync',
  ReadOnly = 'ReadOnly',
  ReadWrite = 'ReadWrite',
  WriteOnly = 'WriteOnly'
}

export type CustomFieldPimsWritebackLogEntry = {
  __typename?: 'CustomFieldPimsWritebackLogEntry';
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinition: CustomFieldDefinition;
  customFieldDefinitionId: Scalars['String'];
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLog: PimsWritebackLogEntry;
  writebackLogId: Scalars['String'];
};

export type CustomFieldPimsWritebackLogEntryCountAggregateOutputType = {
  __typename?: 'CustomFieldPimsWritebackLogEntryCountAggregateOutputType';
  _all: Scalars['Int'];
  customEntityId: Scalars['Int'];
  customFieldDefinitionId: Scalars['Int'];
  customFieldValue: Scalars['Int'];
  writebackLogId: Scalars['Int'];
};

export type CustomFieldPimsWritebackLogEntryCountOrderByAggregateInput = {
  customEntityId?: Maybe<SortOrder>;
  customFieldDefinitionId?: Maybe<SortOrder>;
  customFieldValue?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type CustomFieldPimsWritebackLogEntryCreateInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinition: CustomFieldDefinitionCreateNestedOneWithoutWritebackLogsInput;
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLog: PimsWritebackLogEntryCreateNestedOneWithoutCustomFieldsLogInput;
};

export type CustomFieldPimsWritebackLogEntryCreateManyCustomFieldDefinitionInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLogId: Scalars['String'];
};

export type CustomFieldPimsWritebackLogEntryCreateManyCustomFieldDefinitionInputEnvelope = {
  data: Array<CustomFieldPimsWritebackLogEntryCreateManyCustomFieldDefinitionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CustomFieldPimsWritebackLogEntryCreateManyInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinitionId: Scalars['String'];
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLogId: Scalars['String'];
};

export type CustomFieldPimsWritebackLogEntryCreateNestedManyWithoutCustomFieldDefinitionInput = {
  connect?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CustomFieldPimsWritebackLogEntryCreateOrConnectWithoutCustomFieldDefinitionInput>>;
  create?: Maybe<Array<CustomFieldPimsWritebackLogEntryCreateWithoutCustomFieldDefinitionInput>>;
  createMany?: Maybe<CustomFieldPimsWritebackLogEntryCreateManyCustomFieldDefinitionInputEnvelope>;
};

export type CustomFieldPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput = {
  connect?: Maybe<CustomFieldPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<CustomFieldPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<CustomFieldPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
};

export type CustomFieldPimsWritebackLogEntryCreateOrConnectWithoutCustomFieldDefinitionInput = {
  create: CustomFieldPimsWritebackLogEntryCreateWithoutCustomFieldDefinitionInput;
  where: CustomFieldPimsWritebackLogEntryWhereUniqueInput;
};

export type CustomFieldPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput = {
  create: CustomFieldPimsWritebackLogEntryCreateWithoutWritebackLogInput;
  where: CustomFieldPimsWritebackLogEntryWhereUniqueInput;
};

export type CustomFieldPimsWritebackLogEntryCreateWithoutCustomFieldDefinitionInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLog: PimsWritebackLogEntryCreateNestedOneWithoutCustomFieldsLogInput;
};

export type CustomFieldPimsWritebackLogEntryCreateWithoutWritebackLogInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinition: CustomFieldDefinitionCreateNestedOneWithoutWritebackLogsInput;
  customFieldValue?: Maybe<Scalars['Json']>;
};

export type CustomFieldPimsWritebackLogEntryGroupByOutputType = {
  __typename?: 'CustomFieldPimsWritebackLogEntryGroupByOutputType';
  _count?: Maybe<CustomFieldPimsWritebackLogEntryCountAggregateOutputType>;
  _max?: Maybe<CustomFieldPimsWritebackLogEntryMaxAggregateOutputType>;
  _min?: Maybe<CustomFieldPimsWritebackLogEntryMinAggregateOutputType>;
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinitionId: Scalars['String'];
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLogId: Scalars['String'];
};

export type CustomFieldPimsWritebackLogEntryListRelationFilter = {
  every?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
  none?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
  some?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
};

export type CustomFieldPimsWritebackLogEntryMaxAggregateOutputType = {
  __typename?: 'CustomFieldPimsWritebackLogEntryMaxAggregateOutputType';
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinitionId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type CustomFieldPimsWritebackLogEntryMaxOrderByAggregateInput = {
  customEntityId?: Maybe<SortOrder>;
  customFieldDefinitionId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type CustomFieldPimsWritebackLogEntryMinAggregateOutputType = {
  __typename?: 'CustomFieldPimsWritebackLogEntryMinAggregateOutputType';
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinitionId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type CustomFieldPimsWritebackLogEntryMinOrderByAggregateInput = {
  customEntityId?: Maybe<SortOrder>;
  customFieldDefinitionId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type CustomFieldPimsWritebackLogEntryNullableScalarRelationFilter = {
  AND?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereInput>>;
  customEntityId?: Maybe<StringNullableFilter>;
  customFieldDefinition?: Maybe<CustomFieldDefinitionScalarRelationFilter>;
  customFieldDefinitionId?: Maybe<StringFilter>;
  customFieldValue?: Maybe<JsonNullableFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type CustomFieldPimsWritebackLogEntryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CustomFieldPimsWritebackLogEntryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CustomFieldPimsWritebackLogEntryOrderByRelevanceInput>;
  customEntityId?: Maybe<SortOrder>;
  customFieldDefinition?: Maybe<CustomFieldDefinitionOrderByWithRelationInput>;
  customFieldDefinitionId?: Maybe<SortOrder>;
  customFieldValue?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export enum CustomFieldPimsWritebackLogEntryOrderByRelevanceFieldEnum {
  CustomEntityId = 'customEntityId',
  CustomFieldDefinitionId = 'customFieldDefinitionId',
  WritebackLogId = 'writebackLogId'
}

export type CustomFieldPimsWritebackLogEntryOrderByRelevanceInput = {
  fields: Array<CustomFieldPimsWritebackLogEntryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CustomFieldPimsWritebackLogEntryOrderByWithAggregationInput = {
  _count?: Maybe<CustomFieldPimsWritebackLogEntryCountOrderByAggregateInput>;
  _max?: Maybe<CustomFieldPimsWritebackLogEntryMaxOrderByAggregateInput>;
  _min?: Maybe<CustomFieldPimsWritebackLogEntryMinOrderByAggregateInput>;
  customEntityId?: Maybe<SortOrder>;
  customFieldDefinitionId?: Maybe<SortOrder>;
  customFieldValue?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type CustomFieldPimsWritebackLogEntryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<CustomFieldPimsWritebackLogEntryOrderByRelevanceInput>;
  customEntityId?: Maybe<SortOrder>;
  customFieldDefinition?: Maybe<CustomFieldDefinitionOrderByWithRelationInput>;
  customFieldDefinitionId?: Maybe<SortOrder>;
  customFieldValue?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export type CustomFieldPimsWritebackLogEntryOrderByWithRelationInput = {
  _relevance?: Maybe<CustomFieldPimsWritebackLogEntryOrderByRelevanceInput>;
  customEntityId?: Maybe<SortOrder>;
  customFieldDefinition?: Maybe<CustomFieldDefinitionOrderByWithRelationInput>;
  customFieldDefinitionId?: Maybe<SortOrder>;
  customFieldValue?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export enum CustomFieldPimsWritebackLogEntryScalarFieldEnum {
  CustomEntityId = 'customEntityId',
  CustomFieldDefinitionId = 'customFieldDefinitionId',
  CustomFieldValue = 'customFieldValue',
  WritebackLogId = 'writebackLogId'
}

export type CustomFieldPimsWritebackLogEntryScalarWhereInput = {
  AND?: Maybe<Array<CustomFieldPimsWritebackLogEntryScalarWhereInput>>;
  NOT?: Maybe<Array<CustomFieldPimsWritebackLogEntryScalarWhereInput>>;
  OR?: Maybe<Array<CustomFieldPimsWritebackLogEntryScalarWhereInput>>;
  customEntityId?: Maybe<StringNullableFilter>;
  customFieldDefinitionId?: Maybe<StringFilter>;
  customFieldValue?: Maybe<JsonNullableFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type CustomFieldPimsWritebackLogEntryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CustomFieldPimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CustomFieldPimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CustomFieldPimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  customEntityId?: Maybe<StringNullableWithAggregatesFilter>;
  customFieldDefinitionId?: Maybe<StringWithAggregatesFilter>;
  customFieldValue?: Maybe<JsonNullableWithAggregatesFilter>;
  writebackLogId?: Maybe<StringWithAggregatesFilter>;
};

export type CustomFieldPimsWritebackLogEntryUncheckedCreateInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinitionId: Scalars['String'];
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLogId: Scalars['String'];
};

export type CustomFieldPimsWritebackLogEntryUncheckedCreateNestedManyWithoutCustomFieldDefinitionInput = {
  connect?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CustomFieldPimsWritebackLogEntryCreateOrConnectWithoutCustomFieldDefinitionInput>>;
  create?: Maybe<Array<CustomFieldPimsWritebackLogEntryCreateWithoutCustomFieldDefinitionInput>>;
  createMany?: Maybe<CustomFieldPimsWritebackLogEntryCreateManyCustomFieldDefinitionInputEnvelope>;
};

export type CustomFieldPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput = {
  connect?: Maybe<CustomFieldPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<CustomFieldPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<CustomFieldPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
};

export type CustomFieldPimsWritebackLogEntryUncheckedCreateWithoutCustomFieldDefinitionInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLogId: Scalars['String'];
};

export type CustomFieldPimsWritebackLogEntryUncheckedCreateWithoutWritebackLogInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinitionId: Scalars['String'];
  customFieldValue?: Maybe<Scalars['Json']>;
};

export type CustomFieldPimsWritebackLogEntryUncheckedUpdateInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinitionId?: Maybe<Scalars['String']>;
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type CustomFieldPimsWritebackLogEntryUncheckedUpdateManyInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinitionId?: Maybe<Scalars['String']>;
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type CustomFieldPimsWritebackLogEntryUncheckedUpdateManyWithoutCustomFieldDefinitionInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type CustomFieldPimsWritebackLogEntryUncheckedUpdateManyWithoutCustomFieldDefinitionNestedInput = {
  connect?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CustomFieldPimsWritebackLogEntryCreateOrConnectWithoutCustomFieldDefinitionInput>>;
  create?: Maybe<Array<CustomFieldPimsWritebackLogEntryCreateWithoutCustomFieldDefinitionInput>>;
  createMany?: Maybe<CustomFieldPimsWritebackLogEntryCreateManyCustomFieldDefinitionInputEnvelope>;
  delete?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CustomFieldPimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<CustomFieldPimsWritebackLogEntryUpdateWithWhereUniqueWithoutCustomFieldDefinitionInput>>;
  updateMany?: Maybe<Array<CustomFieldPimsWritebackLogEntryUpdateManyWithWhereWithoutCustomFieldDefinitionInput>>;
  upsert?: Maybe<Array<CustomFieldPimsWritebackLogEntryUpsertWithWhereUniqueWithoutCustomFieldDefinitionInput>>;
};

export type CustomFieldPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput = {
  connect?: Maybe<CustomFieldPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<CustomFieldPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<CustomFieldPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
  delete?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
  disconnect?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
  update?: Maybe<CustomFieldPimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput>;
  upsert?: Maybe<CustomFieldPimsWritebackLogEntryUpsertWithoutWritebackLogInput>;
};

export type CustomFieldPimsWritebackLogEntryUncheckedUpdateWithoutCustomFieldDefinitionInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type CustomFieldPimsWritebackLogEntryUncheckedUpdateWithoutWritebackLogInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinitionId?: Maybe<Scalars['String']>;
  customFieldValue?: Maybe<Scalars['Json']>;
};

export type CustomFieldPimsWritebackLogEntryUpdateInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinition?: Maybe<CustomFieldDefinitionUpdateOneRequiredWithoutWritebackLogsNestedInput>;
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLog?: Maybe<PimsWritebackLogEntryUpdateOneRequiredWithoutCustomFieldsLogNestedInput>;
};

export type CustomFieldPimsWritebackLogEntryUpdateManyMutationInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldValue?: Maybe<Scalars['Json']>;
};

export type CustomFieldPimsWritebackLogEntryUpdateManyWithWhereWithoutCustomFieldDefinitionInput = {
  data: CustomFieldPimsWritebackLogEntryUpdateManyMutationInput;
  where: CustomFieldPimsWritebackLogEntryScalarWhereInput;
};

export type CustomFieldPimsWritebackLogEntryUpdateManyWithoutCustomFieldDefinitionNestedInput = {
  connect?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CustomFieldPimsWritebackLogEntryCreateOrConnectWithoutCustomFieldDefinitionInput>>;
  create?: Maybe<Array<CustomFieldPimsWritebackLogEntryCreateWithoutCustomFieldDefinitionInput>>;
  createMany?: Maybe<CustomFieldPimsWritebackLogEntryCreateManyCustomFieldDefinitionInputEnvelope>;
  delete?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CustomFieldPimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<CustomFieldPimsWritebackLogEntryUpdateWithWhereUniqueWithoutCustomFieldDefinitionInput>>;
  updateMany?: Maybe<Array<CustomFieldPimsWritebackLogEntryUpdateManyWithWhereWithoutCustomFieldDefinitionInput>>;
  upsert?: Maybe<Array<CustomFieldPimsWritebackLogEntryUpsertWithWhereUniqueWithoutCustomFieldDefinitionInput>>;
};

export type CustomFieldPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput = {
  connect?: Maybe<CustomFieldPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<CustomFieldPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<CustomFieldPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CustomFieldPimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput>;
  upsert?: Maybe<CustomFieldPimsWritebackLogEntryUpsertWithoutWritebackLogInput>;
};

export type CustomFieldPimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput = {
  data: CustomFieldPimsWritebackLogEntryUpdateWithoutWritebackLogInput;
  where?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
};

export type CustomFieldPimsWritebackLogEntryUpdateWithWhereUniqueWithoutCustomFieldDefinitionInput = {
  data: CustomFieldPimsWritebackLogEntryUpdateWithoutCustomFieldDefinitionInput;
  where: CustomFieldPimsWritebackLogEntryWhereUniqueInput;
};

export type CustomFieldPimsWritebackLogEntryUpdateWithoutCustomFieldDefinitionInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldValue?: Maybe<Scalars['Json']>;
  writebackLog?: Maybe<PimsWritebackLogEntryUpdateOneRequiredWithoutCustomFieldsLogNestedInput>;
};

export type CustomFieldPimsWritebackLogEntryUpdateWithoutWritebackLogInput = {
  customEntityId?: Maybe<Scalars['String']>;
  customFieldDefinition?: Maybe<CustomFieldDefinitionUpdateOneRequiredWithoutWritebackLogsNestedInput>;
  customFieldValue?: Maybe<Scalars['Json']>;
};

export type CustomFieldPimsWritebackLogEntryUpsertWithWhereUniqueWithoutCustomFieldDefinitionInput = {
  create: CustomFieldPimsWritebackLogEntryCreateWithoutCustomFieldDefinitionInput;
  update: CustomFieldPimsWritebackLogEntryUpdateWithoutCustomFieldDefinitionInput;
  where: CustomFieldPimsWritebackLogEntryWhereUniqueInput;
};

export type CustomFieldPimsWritebackLogEntryUpsertWithoutWritebackLogInput = {
  create: CustomFieldPimsWritebackLogEntryCreateWithoutWritebackLogInput;
  update: CustomFieldPimsWritebackLogEntryUpdateWithoutWritebackLogInput;
  where?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
};

export type CustomFieldPimsWritebackLogEntryWhereInput = {
  AND?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereInput>>;
  customEntityId?: Maybe<StringNullableFilter>;
  customFieldDefinition?: Maybe<CustomFieldDefinitionScalarRelationFilter>;
  customFieldDefinitionId?: Maybe<StringFilter>;
  customFieldValue?: Maybe<JsonNullableFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type CustomFieldPimsWritebackLogEntryWhereUniqueInput = {
  AND?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<CustomFieldPimsWritebackLogEntryWhereInput>>;
  customEntityId?: Maybe<StringNullableFilter>;
  customFieldDefinition?: Maybe<CustomFieldDefinitionScalarRelationFilter>;
  customFieldDefinitionId?: Maybe<StringFilter>;
  customFieldValue?: Maybe<JsonNullableFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<Scalars['String']>;
  writebackLogId_customFieldDefinitionId?: Maybe<CustomFieldPimsWritebackLogEntryWritebackLogIdCustomFieldDefinitionIdCompoundUniqueInput>;
};

export type CustomFieldPimsWritebackLogEntryWritebackLogIdCustomFieldDefinitionIdCompoundUniqueInput = {
  customFieldDefinitionId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export enum CustomFieldTargetType {
  ClinicPet = 'ClinicPet',
  ClinicPetParent = 'ClinicPetParent',
  Unknown = 'Unknown'
}

export enum CustomFieldsDataSource {
  Flow = 'Flow',
  Pims = 'Pims'
}

export type CustomFindUniqueUserBoardFilterResponse = {
  __typename?: 'CustomFindUniqueUserBoardFilterResponse';
  collapsedColumnsMap?: Maybe<Scalars['Json']>;
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  selectedChannelStatusIdsMap?: Maybe<Scalars['Json']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<DateRangeOutput>;
};

export type CustomFindUniqueUserBoardFilterWhereInput = {
  userId: Scalars['String'];
};

export type CustomUpsertOneUserBoardFilterDataInput = {
  collapsedColumnsMap?: Maybe<Scalars['Json']>;
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  selectedChannelStatusIdsMap?: Maybe<Scalars['Json']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<DateRangeInput>;
};

export type CustomUpsertOneUserBoardFilterResponse = {
  __typename?: 'CustomUpsertOneUserBoardFilterResponse';
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CustomUpsertOneUserBoardFilterWhereInput = {
  clinicId: Scalars['String'];
  userId: Scalars['String'];
};

export type DashboardSummary = {
  __typename?: 'DashboardSummary';
  Arn?: Maybe<Scalars['String']>;
  CreatedTime?: Maybe<Scalars['String']>;
  DashboardId?: Maybe<Scalars['String']>;
  LastPublishedTime?: Maybe<Scalars['String']>;
  LastUpdatedTime?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  PublishedVersionNumber?: Maybe<Scalars['Int']>;
};

export type DataPointIntegration = {
  __typename?: 'DataPointIntegration';
  clinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  createdAt: Scalars['DateTime'];
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isMultiLocation: Scalars['Boolean'];
  password: Scalars['String'];
  siteId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
};


export type DataPointIntegrationClinicPimsIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type DataPointIntegrationCountAggregateOutputType = {
  __typename?: 'DataPointIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  fixAppointmentTime: Scalars['Int'];
  id: Scalars['Int'];
  isMultiLocation: Scalars['Int'];
  password: Scalars['Int'];
  siteId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  username: Scalars['Int'];
};

export type DataPointIntegrationCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  fixAppointmentTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiLocation?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export type DataPointIntegrationCreateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutDatapointInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password: Scalars['String'];
  siteId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type DataPointIntegrationCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password: Scalars['String'];
  siteId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type DataPointIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<DataPointIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<DataPointIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<DataPointIntegrationCreateWithoutClinicPimsIntegrationInput>;
};

export type DataPointIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput = {
  create: DataPointIntegrationCreateWithoutClinicPimsIntegrationInput;
  where: DataPointIntegrationWhereUniqueInput;
};

export type DataPointIntegrationCreateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password: Scalars['String'];
  siteId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type DataPointIntegrationGroupByOutputType = {
  __typename?: 'DataPointIntegrationGroupByOutputType';
  _count?: Maybe<DataPointIntegrationCountAggregateOutputType>;
  _max?: Maybe<DataPointIntegrationMaxAggregateOutputType>;
  _min?: Maybe<DataPointIntegrationMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isMultiLocation: Scalars['Boolean'];
  password: Scalars['String'];
  siteId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
};

export type DataPointIntegrationMaxAggregateOutputType = {
  __typename?: 'DataPointIntegrationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type DataPointIntegrationMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  fixAppointmentTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiLocation?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export type DataPointIntegrationMinAggregateOutputType = {
  __typename?: 'DataPointIntegrationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type DataPointIntegrationMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  fixAppointmentTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiLocation?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export type DataPointIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<DataPointIntegrationWhereInput>>;
  NOT?: Maybe<Array<DataPointIntegrationWhereInput>>;
  OR?: Maybe<Array<DataPointIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  fixAppointmentTime?: Maybe<BoolNullableFilter>;
  id?: Maybe<StringFilter>;
  isMultiLocation?: Maybe<BoolFilter>;
  password?: Maybe<StringFilter>;
  siteId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  username?: Maybe<StringFilter>;
};

export type DataPointIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<DataPointIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  fixAppointmentTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiLocation?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export enum DataPointIntegrationOrderByRelevanceFieldEnum {
  Id = 'id',
  Password = 'password',
  SiteId = 'siteId',
  Username = 'username'
}

export type DataPointIntegrationOrderByRelevanceInput = {
  fields: Array<DataPointIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type DataPointIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<DataPointIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<DataPointIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<DataPointIntegrationMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  fixAppointmentTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiLocation?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export type DataPointIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<DataPointIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  fixAppointmentTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiLocation?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export type DataPointIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<DataPointIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  fixAppointmentTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMultiLocation?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export enum DataPointIntegrationScalarFieldEnum {
  CreatedAt = 'createdAt',
  FixAppointmentTime = 'fixAppointmentTime',
  Id = 'id',
  IsMultiLocation = 'isMultiLocation',
  Password = 'password',
  SiteId = 'siteId',
  UpdatedAt = 'updatedAt',
  Username = 'username'
}

export type DataPointIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DataPointIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DataPointIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DataPointIntegrationScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  fixAppointmentTime?: Maybe<BoolNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isMultiLocation?: Maybe<BoolWithAggregatesFilter>;
  password?: Maybe<StringWithAggregatesFilter>;
  siteId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  username?: Maybe<StringWithAggregatesFilter>;
};

export type DataPointIntegrationUncheckedCreateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedOneWithoutDatapointInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password: Scalars['String'];
  siteId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type DataPointIntegrationUncheckedCreateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password: Scalars['String'];
  siteId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type DataPointIntegrationUncheckedUpdateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedUpdateOneWithoutDatapointNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type DataPointIntegrationUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type DataPointIntegrationUncheckedUpdateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type DataPointIntegrationUpdateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutDatapointNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type DataPointIntegrationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type DataPointIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<DataPointIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<DataPointIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<DataPointIntegrationCreateWithoutClinicPimsIntegrationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<DataPointIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput>;
  upsert?: Maybe<DataPointIntegrationUpsertWithoutClinicPimsIntegrationInput>;
};

export type DataPointIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput = {
  data: DataPointIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<DataPointIntegrationWhereInput>;
};

export type DataPointIntegrationUpdateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fixAppointmentTime?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type DataPointIntegrationUpsertWithoutClinicPimsIntegrationInput = {
  create: DataPointIntegrationCreateWithoutClinicPimsIntegrationInput;
  update: DataPointIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<DataPointIntegrationWhereInput>;
};

export type DataPointIntegrationWhereInput = {
  AND?: Maybe<Array<DataPointIntegrationWhereInput>>;
  NOT?: Maybe<Array<DataPointIntegrationWhereInput>>;
  OR?: Maybe<Array<DataPointIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  fixAppointmentTime?: Maybe<BoolNullableFilter>;
  id?: Maybe<StringFilter>;
  isMultiLocation?: Maybe<BoolFilter>;
  password?: Maybe<StringFilter>;
  siteId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  username?: Maybe<StringFilter>;
};

export type DataPointIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<DataPointIntegrationWhereInput>>;
  NOT?: Maybe<Array<DataPointIntegrationWhereInput>>;
  OR?: Maybe<Array<DataPointIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  fixAppointmentTime?: Maybe<BoolNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isMultiLocation?: Maybe<BoolFilter>;
  password?: Maybe<StringFilter>;
  siteId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  username?: Maybe<StringFilter>;
};


export type DateRangeInput = {
  gte: Scalars['DateTime'];
  lte: Scalars['DateTime'];
};

export type DateRangeOutput = {
  __typename?: 'DateRangeOutput';
  gte: Scalars['DateTime'];
  lte: Scalars['DateTime'];
};


export type DateTimeFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableListFilter = {
  equals?: Maybe<Array<Scalars['DateTime']>>;
  has?: Maybe<Scalars['DateTime']>;
  hasEvery?: Maybe<Array<Scalars['DateTime']>>;
  hasSome?: Maybe<Array<Scalars['DateTime']>>;
  isEmpty?: Maybe<Scalars['Boolean']>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedDateTimeNullableFilter>;
  _min?: Maybe<NestedDateTimeNullableFilter>;
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedDateTimeFilter>;
  _min?: Maybe<NestedDateTimeFilter>;
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DeleteEmailCampaignCustomListInput = {
  emailCampaignId: Scalars['String'];
};

export enum DeviceOs {
  Android = 'ANDROID',
  Ios = 'IOS',
  Ipados = 'IPADOS',
  Iphoneos = 'IPHONEOS'
}

export enum DeviceType {
  Desktop = 'DESKTOP',
  Gamingconsole = 'GAMINGCONSOLE',
  Handset = 'HANDSET',
  Tablet = 'TABLET',
  Tv = 'TV',
  Unknown = 'UNKNOWN'
}

export type DirectBookingAppointmentResponse = {
  __typename?: 'DirectBookingAppointmentResponse';
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
};

export enum DirectBookingAppointmentTypeClientType {
  Both = 'Both',
  ExistingClients = 'ExistingClients',
  NewClients = 'NewClients'
}

export type DirectBookingAppointmentTypeInput = {
  clinicId: Scalars['String'];
};

export type DirectBookingAppointmentTypeName = {
  name: Scalars['String'];
};

export type DirectBookingAppointmentTypeSetting = {
  __typename?: 'DirectBookingAppointmentTypeSetting';
  allowNewClientBooking: Scalars['Boolean'];
  appointmentType: AppointmentType;
  appointmentTypeId: Scalars['String'];
  clientType: DirectBookingAppointmentTypeClientType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isPaymentCollectionEnabled: Scalars['Boolean'];
  paymentAmountToCollect: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type DirectBookingAppointmentTypeSettingAvgAggregateOutputType = {
  __typename?: 'DirectBookingAppointmentTypeSettingAvgAggregateOutputType';
  paymentAmountToCollect?: Maybe<Scalars['Float']>;
};

export type DirectBookingAppointmentTypeSettingAvgOrderByAggregateInput = {
  paymentAmountToCollect?: Maybe<SortOrder>;
};

export type DirectBookingAppointmentTypeSettingCountAggregateOutputType = {
  __typename?: 'DirectBookingAppointmentTypeSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  allowNewClientBooking: Scalars['Int'];
  appointmentTypeId: Scalars['Int'];
  clientType: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isPaymentCollectionEnabled: Scalars['Int'];
  paymentAmountToCollect: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type DirectBookingAppointmentTypeSettingCountOrderByAggregateInput = {
  allowNewClientBooking?: Maybe<SortOrder>;
  appointmentTypeId?: Maybe<SortOrder>;
  clientType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPaymentCollectionEnabled?: Maybe<SortOrder>;
  paymentAmountToCollect?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingAppointmentTypeSettingCreateInput = {
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  appointmentType: AppointmentTypeCreateNestedOneWithoutDirectBookingAppointmentTypeSettingInput;
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingCreateManyInput = {
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  appointmentTypeId: Scalars['String'];
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingCreateNestedOneWithoutAppointmentTypeInput = {
  connect?: Maybe<DirectBookingAppointmentTypeSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<DirectBookingAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput>;
  create?: Maybe<DirectBookingAppointmentTypeSettingCreateWithoutAppointmentTypeInput>;
};

export type DirectBookingAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput = {
  create: DirectBookingAppointmentTypeSettingCreateWithoutAppointmentTypeInput;
  where: DirectBookingAppointmentTypeSettingWhereUniqueInput;
};

export type DirectBookingAppointmentTypeSettingCreateWithoutAppointmentTypeInput = {
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingGroupByOutputType = {
  __typename?: 'DirectBookingAppointmentTypeSettingGroupByOutputType';
  _avg?: Maybe<DirectBookingAppointmentTypeSettingAvgAggregateOutputType>;
  _count?: Maybe<DirectBookingAppointmentTypeSettingCountAggregateOutputType>;
  _max?: Maybe<DirectBookingAppointmentTypeSettingMaxAggregateOutputType>;
  _min?: Maybe<DirectBookingAppointmentTypeSettingMinAggregateOutputType>;
  _sum?: Maybe<DirectBookingAppointmentTypeSettingSumAggregateOutputType>;
  allowNewClientBooking: Scalars['Boolean'];
  appointmentTypeId: Scalars['String'];
  clientType: DirectBookingAppointmentTypeClientType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isPaymentCollectionEnabled: Scalars['Boolean'];
  paymentAmountToCollect: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type DirectBookingAppointmentTypeSettingMaxAggregateOutputType = {
  __typename?: 'DirectBookingAppointmentTypeSettingMaxAggregateOutputType';
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingMaxOrderByAggregateInput = {
  allowNewClientBooking?: Maybe<SortOrder>;
  appointmentTypeId?: Maybe<SortOrder>;
  clientType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPaymentCollectionEnabled?: Maybe<SortOrder>;
  paymentAmountToCollect?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingAppointmentTypeSettingMinAggregateOutputType = {
  __typename?: 'DirectBookingAppointmentTypeSettingMinAggregateOutputType';
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingMinOrderByAggregateInput = {
  allowNewClientBooking?: Maybe<SortOrder>;
  appointmentTypeId?: Maybe<SortOrder>;
  clientType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPaymentCollectionEnabled?: Maybe<SortOrder>;
  paymentAmountToCollect?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingAppointmentTypeSettingNullableScalarRelationFilter = {
  AND?: Maybe<Array<DirectBookingAppointmentTypeSettingWhereInput>>;
  NOT?: Maybe<Array<DirectBookingAppointmentTypeSettingWhereInput>>;
  OR?: Maybe<Array<DirectBookingAppointmentTypeSettingWhereInput>>;
  allowNewClientBooking?: Maybe<BoolFilter>;
  appointmentType?: Maybe<AppointmentTypeScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringFilter>;
  clientType?: Maybe<EnumDirectBookingAppointmentTypeClientTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isPaymentCollectionEnabled?: Maybe<BoolFilter>;
  paymentAmountToCollect?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DirectBookingAppointmentTypeSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<DirectBookingAppointmentTypeSettingOrderByRelevanceInput>;
  allowNewClientBooking?: Maybe<SortOrder>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  clientType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPaymentCollectionEnabled?: Maybe<SortOrder>;
  paymentAmountToCollect?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum DirectBookingAppointmentTypeSettingOrderByRelevanceFieldEnum {
  AppointmentTypeId = 'appointmentTypeId',
  Id = 'id'
}

export type DirectBookingAppointmentTypeSettingOrderByRelevanceInput = {
  fields: Array<DirectBookingAppointmentTypeSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type DirectBookingAppointmentTypeSettingOrderByWithAggregationInput = {
  _avg?: Maybe<DirectBookingAppointmentTypeSettingAvgOrderByAggregateInput>;
  _count?: Maybe<DirectBookingAppointmentTypeSettingCountOrderByAggregateInput>;
  _max?: Maybe<DirectBookingAppointmentTypeSettingMaxOrderByAggregateInput>;
  _min?: Maybe<DirectBookingAppointmentTypeSettingMinOrderByAggregateInput>;
  _sum?: Maybe<DirectBookingAppointmentTypeSettingSumOrderByAggregateInput>;
  allowNewClientBooking?: Maybe<SortOrder>;
  appointmentTypeId?: Maybe<SortOrder>;
  clientType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPaymentCollectionEnabled?: Maybe<SortOrder>;
  paymentAmountToCollect?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingAppointmentTypeSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<DirectBookingAppointmentTypeSettingOrderByRelevanceInput>;
  allowNewClientBooking?: Maybe<SortOrder>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  clientType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPaymentCollectionEnabled?: Maybe<SortOrder>;
  paymentAmountToCollect?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingAppointmentTypeSettingOrderByWithRelationInput = {
  _relevance?: Maybe<DirectBookingAppointmentTypeSettingOrderByRelevanceInput>;
  allowNewClientBooking?: Maybe<SortOrder>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  clientType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isPaymentCollectionEnabled?: Maybe<SortOrder>;
  paymentAmountToCollect?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum DirectBookingAppointmentTypeSettingScalarFieldEnum {
  AllowNewClientBooking = 'allowNewClientBooking',
  AppointmentTypeId = 'appointmentTypeId',
  ClientType = 'clientType',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsPaymentCollectionEnabled = 'isPaymentCollectionEnabled',
  PaymentAmountToCollect = 'paymentAmountToCollect',
  UpdatedAt = 'updatedAt'
}

export type DirectBookingAppointmentTypeSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DirectBookingAppointmentTypeSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DirectBookingAppointmentTypeSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DirectBookingAppointmentTypeSettingScalarWhereWithAggregatesInput>>;
  allowNewClientBooking?: Maybe<BoolWithAggregatesFilter>;
  appointmentTypeId?: Maybe<StringWithAggregatesFilter>;
  clientType?: Maybe<EnumDirectBookingAppointmentTypeClientTypeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isPaymentCollectionEnabled?: Maybe<BoolWithAggregatesFilter>;
  paymentAmountToCollect?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type DirectBookingAppointmentTypeSettingSelection = {
  __typename?: 'DirectBookingAppointmentTypeSettingSelection';
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  id?: Maybe<Scalars['String']>;
};

export type DirectBookingAppointmentTypeSettingSumAggregateOutputType = {
  __typename?: 'DirectBookingAppointmentTypeSettingSumAggregateOutputType';
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
};

export type DirectBookingAppointmentTypeSettingSumOrderByAggregateInput = {
  paymentAmountToCollect?: Maybe<SortOrder>;
};

export type DirectBookingAppointmentTypeSettingUncheckedCreateInput = {
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  appointmentTypeId: Scalars['String'];
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingUncheckedCreateNestedOneWithoutAppointmentTypeInput = {
  connect?: Maybe<DirectBookingAppointmentTypeSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<DirectBookingAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput>;
  create?: Maybe<DirectBookingAppointmentTypeSettingCreateWithoutAppointmentTypeInput>;
};

export type DirectBookingAppointmentTypeSettingUncheckedCreateWithoutAppointmentTypeInput = {
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingUncheckedUpdateInput = {
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingUncheckedUpdateManyInput = {
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingUncheckedUpdateOneWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<DirectBookingAppointmentTypeSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<DirectBookingAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput>;
  create?: Maybe<DirectBookingAppointmentTypeSettingCreateWithoutAppointmentTypeInput>;
  delete?: Maybe<DirectBookingAppointmentTypeSettingWhereInput>;
  disconnect?: Maybe<DirectBookingAppointmentTypeSettingWhereInput>;
  update?: Maybe<DirectBookingAppointmentTypeSettingUpdateToOneWithWhereWithoutAppointmentTypeInput>;
  upsert?: Maybe<DirectBookingAppointmentTypeSettingUpsertWithoutAppointmentTypeInput>;
};

export type DirectBookingAppointmentTypeSettingUncheckedUpdateWithoutAppointmentTypeInput = {
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingUpdateInput = {
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneRequiredWithoutDirectBookingAppointmentTypeSettingNestedInput>;
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingUpdateManyMutationInput = {
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingUpdateOneWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<DirectBookingAppointmentTypeSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<DirectBookingAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput>;
  create?: Maybe<DirectBookingAppointmentTypeSettingCreateWithoutAppointmentTypeInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<DirectBookingAppointmentTypeSettingUpdateToOneWithWhereWithoutAppointmentTypeInput>;
  upsert?: Maybe<DirectBookingAppointmentTypeSettingUpsertWithoutAppointmentTypeInput>;
};

export type DirectBookingAppointmentTypeSettingUpdateToOneWithWhereWithoutAppointmentTypeInput = {
  data: DirectBookingAppointmentTypeSettingUpdateWithoutAppointmentTypeInput;
  where?: Maybe<DirectBookingAppointmentTypeSettingWhereInput>;
};

export type DirectBookingAppointmentTypeSettingUpdateWithoutAppointmentTypeInput = {
  allowNewClientBooking?: Maybe<Scalars['Boolean']>;
  clientType?: Maybe<DirectBookingAppointmentTypeClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentAmountToCollect?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingAppointmentTypeSettingUpsertWithoutAppointmentTypeInput = {
  create: DirectBookingAppointmentTypeSettingCreateWithoutAppointmentTypeInput;
  update: DirectBookingAppointmentTypeSettingUpdateWithoutAppointmentTypeInput;
  where?: Maybe<DirectBookingAppointmentTypeSettingWhereInput>;
};

export type DirectBookingAppointmentTypeSettingWhereInput = {
  AND?: Maybe<Array<DirectBookingAppointmentTypeSettingWhereInput>>;
  NOT?: Maybe<Array<DirectBookingAppointmentTypeSettingWhereInput>>;
  OR?: Maybe<Array<DirectBookingAppointmentTypeSettingWhereInput>>;
  allowNewClientBooking?: Maybe<BoolFilter>;
  appointmentType?: Maybe<AppointmentTypeScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringFilter>;
  clientType?: Maybe<EnumDirectBookingAppointmentTypeClientTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isPaymentCollectionEnabled?: Maybe<BoolFilter>;
  paymentAmountToCollect?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DirectBookingAppointmentTypeSettingWhereUniqueInput = {
  AND?: Maybe<Array<DirectBookingAppointmentTypeSettingWhereInput>>;
  NOT?: Maybe<Array<DirectBookingAppointmentTypeSettingWhereInput>>;
  OR?: Maybe<Array<DirectBookingAppointmentTypeSettingWhereInput>>;
  allowNewClientBooking?: Maybe<BoolFilter>;
  appointmentType?: Maybe<AppointmentTypeScalarRelationFilter>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clientType?: Maybe<EnumDirectBookingAppointmentTypeClientTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isPaymentCollectionEnabled?: Maybe<BoolFilter>;
  paymentAmountToCollect?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DirectBookingAppointmentTypes = {
  __typename?: 'DirectBookingAppointmentTypes';
  clinicEmployeeAppointmentTypeSettings: Array<AppointmentTypeClinicEmployeeMapping>;
  defaultDurationInMinutes?: Maybe<Scalars['Int']>;
  defaultSoonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
  delayedStartTime?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Int']>;
  depositCurrency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  directBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSettingSelection>;
  displayName?: Maybe<Scalars['String']>;
  hasDeposit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  markPaymentAsDeposit?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type DirectBookingAvailability = {
  __typename?: 'DirectBookingAvailability';
  bookingDate?: Maybe<Scalars['DateTime']>;
  hasAvailability?: Maybe<Scalars['Boolean']>;
  openTimeSlots?: Maybe<Scalars['Json']>;
};

export type DirectBookingClinicEmployeeName = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type DirectBookingClinicRoomName = {
  name: Scalars['String'];
};

export type DirectBookingCreateOneProviderAppointmentTypeRoomMapByNameInput = {
  appointmentType: DirectBookingAppointmentTypeName;
  clinicEmployee: DirectBookingClinicEmployeeName;
  clinicId: Scalars['String'];
  clinicRoom: DirectBookingClinicRoomName;
};

export type DirectBookingCreateOneProviderAppointmentTypeRoomMapByNameResponse = {
  __typename?: 'DirectBookingCreateOneProviderAppointmentTypeRoomMapByNameResponse';
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DirectBookingDateAvailability = {
  __typename?: 'DirectBookingDateAvailability';
  bookingDate: Scalars['String'];
  hasAvailability: Scalars['Boolean'];
  openTimeSlots: Array<Scalars['DateTime']>;
};

export type DirectBookingExclusionRule = {
  __typename?: 'DirectBookingExclusionRule';
  _count: DirectBookingExclusionRuleCountOutputType;
  appointmentTypes: Array<AppointmentType>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  providers: Array<ClinicEmployee>;
  timeSlots: Array<DirectBookingExclusionTimeSlot>;
  updatedAt: Scalars['DateTime'];
};


export type DirectBookingExclusionRuleAppointmentTypesArgs = {
  cursor?: Maybe<AppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type DirectBookingExclusionRuleProvidersArgs = {
  cursor?: Maybe<ClinicEmployeeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type DirectBookingExclusionRuleTimeSlotsArgs = {
  cursor?: Maybe<DirectBookingExclusionTimeSlotWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingExclusionTimeSlotScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingExclusionTimeSlotOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingExclusionTimeSlotWhereInput>;
};

export type DirectBookingExclusionRuleCountAggregateOutputType = {
  __typename?: 'DirectBookingExclusionRuleCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type DirectBookingExclusionRuleCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingExclusionRuleCountOutputType = {
  __typename?: 'DirectBookingExclusionRuleCountOutputType';
  appointmentTypes: Scalars['Int'];
  providers: Scalars['Int'];
  timeSlots: Scalars['Int'];
};

export type DirectBookingExclusionRuleCreateInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  clinic: ClinicCreateNestedOneWithoutDirectBookingExclusionRulesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  providers?: Maybe<ClinicEmployeeCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotCreateNestedManyWithoutExclusionRuleInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleCreateManyClinicInputEnvelope = {
  data: Array<DirectBookingExclusionRuleCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DirectBookingExclusionRuleCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleCreateNestedManyWithoutAppointmentTypesInput = {
  connect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionRuleCreateOrConnectWithoutAppointmentTypesInput>>;
  create?: Maybe<Array<DirectBookingExclusionRuleCreateWithoutAppointmentTypesInput>>;
};

export type DirectBookingExclusionRuleCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionRuleCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<DirectBookingExclusionRuleCreateWithoutClinicInput>>;
  createMany?: Maybe<DirectBookingExclusionRuleCreateManyClinicInputEnvelope>;
};

export type DirectBookingExclusionRuleCreateNestedManyWithoutProvidersInput = {
  connect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionRuleCreateOrConnectWithoutProvidersInput>>;
  create?: Maybe<Array<DirectBookingExclusionRuleCreateWithoutProvidersInput>>;
};

export type DirectBookingExclusionRuleCreateNestedOneWithoutTimeSlotsInput = {
  connect?: Maybe<DirectBookingExclusionRuleWhereUniqueInput>;
  connectOrCreate?: Maybe<DirectBookingExclusionRuleCreateOrConnectWithoutTimeSlotsInput>;
  create?: Maybe<DirectBookingExclusionRuleCreateWithoutTimeSlotsInput>;
};

export type DirectBookingExclusionRuleCreateOrConnectWithoutAppointmentTypesInput = {
  create: DirectBookingExclusionRuleCreateWithoutAppointmentTypesInput;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};

export type DirectBookingExclusionRuleCreateOrConnectWithoutClinicInput = {
  create: DirectBookingExclusionRuleCreateWithoutClinicInput;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};

export type DirectBookingExclusionRuleCreateOrConnectWithoutProvidersInput = {
  create: DirectBookingExclusionRuleCreateWithoutProvidersInput;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};

export type DirectBookingExclusionRuleCreateOrConnectWithoutTimeSlotsInput = {
  create: DirectBookingExclusionRuleCreateWithoutTimeSlotsInput;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};

export type DirectBookingExclusionRuleCreateWithoutAppointmentTypesInput = {
  clinic: ClinicCreateNestedOneWithoutDirectBookingExclusionRulesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  providers?: Maybe<ClinicEmployeeCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotCreateNestedManyWithoutExclusionRuleInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleCreateWithoutClinicInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  providers?: Maybe<ClinicEmployeeCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotCreateNestedManyWithoutExclusionRuleInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleCreateWithoutProvidersInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  clinic: ClinicCreateNestedOneWithoutDirectBookingExclusionRulesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotCreateNestedManyWithoutExclusionRuleInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleCreateWithoutTimeSlotsInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  clinic: ClinicCreateNestedOneWithoutDirectBookingExclusionRulesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  providers?: Maybe<ClinicEmployeeCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleGroupByOutputType = {
  __typename?: 'DirectBookingExclusionRuleGroupByOutputType';
  _count?: Maybe<DirectBookingExclusionRuleCountAggregateOutputType>;
  _max?: Maybe<DirectBookingExclusionRuleMaxAggregateOutputType>;
  _min?: Maybe<DirectBookingExclusionRuleMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DirectBookingExclusionRuleListRelationFilter = {
  every?: Maybe<DirectBookingExclusionRuleWhereInput>;
  none?: Maybe<DirectBookingExclusionRuleWhereInput>;
  some?: Maybe<DirectBookingExclusionRuleWhereInput>;
};

export type DirectBookingExclusionRuleMaxAggregateOutputType = {
  __typename?: 'DirectBookingExclusionRuleMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingExclusionRuleMinAggregateOutputType = {
  __typename?: 'DirectBookingExclusionRuleMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingExclusionRuleOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DirectBookingExclusionRuleOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<DirectBookingExclusionRuleOrderByRelevanceInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  providers?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum DirectBookingExclusionRuleOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  Name = 'name'
}

export type DirectBookingExclusionRuleOrderByRelevanceInput = {
  fields: Array<DirectBookingExclusionRuleOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type DirectBookingExclusionRuleOrderByWithAggregationInput = {
  _count?: Maybe<DirectBookingExclusionRuleCountOrderByAggregateInput>;
  _max?: Maybe<DirectBookingExclusionRuleMaxOrderByAggregateInput>;
  _min?: Maybe<DirectBookingExclusionRuleMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingExclusionRuleOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<DirectBookingExclusionRuleOrderByRelevanceInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  providers?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingExclusionRuleOrderByWithRelationInput = {
  _relevance?: Maybe<DirectBookingExclusionRuleOrderByRelevanceInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  providers?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum DirectBookingExclusionRuleScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type DirectBookingExclusionRuleScalarRelationFilter = {
  AND?: Maybe<Array<DirectBookingExclusionRuleWhereInput>>;
  NOT?: Maybe<Array<DirectBookingExclusionRuleWhereInput>>;
  OR?: Maybe<Array<DirectBookingExclusionRuleWhereInput>>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  providers?: Maybe<ClinicEmployeeListRelationFilter>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DirectBookingExclusionRuleScalarWhereInput = {
  AND?: Maybe<Array<DirectBookingExclusionRuleScalarWhereInput>>;
  NOT?: Maybe<Array<DirectBookingExclusionRuleScalarWhereInput>>;
  OR?: Maybe<Array<DirectBookingExclusionRuleScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DirectBookingExclusionRuleScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DirectBookingExclusionRuleScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DirectBookingExclusionRuleScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DirectBookingExclusionRuleScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type DirectBookingExclusionRuleUncheckedCreateInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  providers?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotUncheckedCreateNestedManyWithoutExclusionRuleInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutAppointmentTypesInput = {
  connect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionRuleCreateOrConnectWithoutAppointmentTypesInput>>;
  create?: Maybe<Array<DirectBookingExclusionRuleCreateWithoutAppointmentTypesInput>>;
};

export type DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionRuleCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<DirectBookingExclusionRuleCreateWithoutClinicInput>>;
  createMany?: Maybe<DirectBookingExclusionRuleCreateManyClinicInputEnvelope>;
};

export type DirectBookingExclusionRuleUncheckedCreateNestedManyWithoutProvidersInput = {
  connect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionRuleCreateOrConnectWithoutProvidersInput>>;
  create?: Maybe<Array<DirectBookingExclusionRuleCreateWithoutProvidersInput>>;
};

export type DirectBookingExclusionRuleUncheckedCreateWithoutAppointmentTypesInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  providers?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotUncheckedCreateNestedManyWithoutExclusionRuleInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedCreateWithoutClinicInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  providers?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotUncheckedCreateNestedManyWithoutExclusionRuleInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedCreateWithoutProvidersInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotUncheckedCreateNestedManyWithoutExclusionRuleInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedCreateWithoutTimeSlotsInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  providers?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutDirectBookingExclusionRulesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedUpdateInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  providers?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotUncheckedUpdateManyWithoutExclusionRuleNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedUpdateManyWithoutAppointmentTypesNestedInput = {
  connect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionRuleCreateOrConnectWithoutAppointmentTypesInput>>;
  create?: Maybe<Array<DirectBookingExclusionRuleCreateWithoutAppointmentTypesInput>>;
  delete?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DirectBookingExclusionRuleScalarWhereInput>>;
  disconnect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  set?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  update?: Maybe<Array<DirectBookingExclusionRuleUpdateWithWhereUniqueWithoutAppointmentTypesInput>>;
  updateMany?: Maybe<Array<DirectBookingExclusionRuleUpdateManyWithWhereWithoutAppointmentTypesInput>>;
  upsert?: Maybe<Array<DirectBookingExclusionRuleUpsertWithWhereUniqueWithoutAppointmentTypesInput>>;
};

export type DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionRuleCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<DirectBookingExclusionRuleCreateWithoutClinicInput>>;
  createMany?: Maybe<DirectBookingExclusionRuleCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DirectBookingExclusionRuleScalarWhereInput>>;
  disconnect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  set?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  update?: Maybe<Array<DirectBookingExclusionRuleUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<DirectBookingExclusionRuleUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<DirectBookingExclusionRuleUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedUpdateManyWithoutProvidersNestedInput = {
  connect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionRuleCreateOrConnectWithoutProvidersInput>>;
  create?: Maybe<Array<DirectBookingExclusionRuleCreateWithoutProvidersInput>>;
  delete?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DirectBookingExclusionRuleScalarWhereInput>>;
  disconnect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  set?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  update?: Maybe<Array<DirectBookingExclusionRuleUpdateWithWhereUniqueWithoutProvidersInput>>;
  updateMany?: Maybe<Array<DirectBookingExclusionRuleUpdateManyWithWhereWithoutProvidersInput>>;
  upsert?: Maybe<Array<DirectBookingExclusionRuleUpsertWithWhereUniqueWithoutProvidersInput>>;
};

export type DirectBookingExclusionRuleUncheckedUpdateWithoutAppointmentTypesInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  providers?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotUncheckedUpdateManyWithoutExclusionRuleNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedUpdateWithoutClinicInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  providers?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotUncheckedUpdateManyWithoutExclusionRuleNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedUpdateWithoutProvidersInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotUncheckedUpdateManyWithoutExclusionRuleNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUncheckedUpdateWithoutTimeSlotsInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  providers?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUpdateInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutDirectBookingExclusionRulesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  providers?: Maybe<ClinicEmployeeUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotUpdateManyWithoutExclusionRuleNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUpdateManyWithWhereWithoutAppointmentTypesInput = {
  data: DirectBookingExclusionRuleUpdateManyMutationInput;
  where: DirectBookingExclusionRuleScalarWhereInput;
};

export type DirectBookingExclusionRuleUpdateManyWithWhereWithoutClinicInput = {
  data: DirectBookingExclusionRuleUpdateManyMutationInput;
  where: DirectBookingExclusionRuleScalarWhereInput;
};

export type DirectBookingExclusionRuleUpdateManyWithWhereWithoutProvidersInput = {
  data: DirectBookingExclusionRuleUpdateManyMutationInput;
  where: DirectBookingExclusionRuleScalarWhereInput;
};

export type DirectBookingExclusionRuleUpdateManyWithoutAppointmentTypesNestedInput = {
  connect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionRuleCreateOrConnectWithoutAppointmentTypesInput>>;
  create?: Maybe<Array<DirectBookingExclusionRuleCreateWithoutAppointmentTypesInput>>;
  delete?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DirectBookingExclusionRuleScalarWhereInput>>;
  disconnect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  set?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  update?: Maybe<Array<DirectBookingExclusionRuleUpdateWithWhereUniqueWithoutAppointmentTypesInput>>;
  updateMany?: Maybe<Array<DirectBookingExclusionRuleUpdateManyWithWhereWithoutAppointmentTypesInput>>;
  upsert?: Maybe<Array<DirectBookingExclusionRuleUpsertWithWhereUniqueWithoutAppointmentTypesInput>>;
};

export type DirectBookingExclusionRuleUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionRuleCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<DirectBookingExclusionRuleCreateWithoutClinicInput>>;
  createMany?: Maybe<DirectBookingExclusionRuleCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DirectBookingExclusionRuleScalarWhereInput>>;
  disconnect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  set?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  update?: Maybe<Array<DirectBookingExclusionRuleUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<DirectBookingExclusionRuleUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<DirectBookingExclusionRuleUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type DirectBookingExclusionRuleUpdateManyWithoutProvidersNestedInput = {
  connect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionRuleCreateOrConnectWithoutProvidersInput>>;
  create?: Maybe<Array<DirectBookingExclusionRuleCreateWithoutProvidersInput>>;
  delete?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DirectBookingExclusionRuleScalarWhereInput>>;
  disconnect?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  set?: Maybe<Array<DirectBookingExclusionRuleWhereUniqueInput>>;
  update?: Maybe<Array<DirectBookingExclusionRuleUpdateWithWhereUniqueWithoutProvidersInput>>;
  updateMany?: Maybe<Array<DirectBookingExclusionRuleUpdateManyWithWhereWithoutProvidersInput>>;
  upsert?: Maybe<Array<DirectBookingExclusionRuleUpsertWithWhereUniqueWithoutProvidersInput>>;
};

export type DirectBookingExclusionRuleUpdateOneRequiredWithoutTimeSlotsNestedInput = {
  connect?: Maybe<DirectBookingExclusionRuleWhereUniqueInput>;
  connectOrCreate?: Maybe<DirectBookingExclusionRuleCreateOrConnectWithoutTimeSlotsInput>;
  create?: Maybe<DirectBookingExclusionRuleCreateWithoutTimeSlotsInput>;
  update?: Maybe<DirectBookingExclusionRuleUpdateToOneWithWhereWithoutTimeSlotsInput>;
  upsert?: Maybe<DirectBookingExclusionRuleUpsertWithoutTimeSlotsInput>;
};

export type DirectBookingExclusionRuleUpdateToOneWithWhereWithoutTimeSlotsInput = {
  data: DirectBookingExclusionRuleUpdateWithoutTimeSlotsInput;
  where?: Maybe<DirectBookingExclusionRuleWhereInput>;
};

export type DirectBookingExclusionRuleUpdateWithWhereUniqueWithoutAppointmentTypesInput = {
  data: DirectBookingExclusionRuleUpdateWithoutAppointmentTypesInput;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};

export type DirectBookingExclusionRuleUpdateWithWhereUniqueWithoutClinicInput = {
  data: DirectBookingExclusionRuleUpdateWithoutClinicInput;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};

export type DirectBookingExclusionRuleUpdateWithWhereUniqueWithoutProvidersInput = {
  data: DirectBookingExclusionRuleUpdateWithoutProvidersInput;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};

export type DirectBookingExclusionRuleUpdateWithoutAppointmentTypesInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutDirectBookingExclusionRulesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  providers?: Maybe<ClinicEmployeeUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotUpdateManyWithoutExclusionRuleNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUpdateWithoutClinicInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  providers?: Maybe<ClinicEmployeeUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotUpdateManyWithoutExclusionRuleNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUpdateWithoutProvidersInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutDirectBookingExclusionRulesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotUpdateManyWithoutExclusionRuleNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUpdateWithoutTimeSlotsInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutDirectBookingExclusionRulesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  providers?: Maybe<ClinicEmployeeUpdateManyWithoutDirectBookingExclusionRulesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionRuleUpsertWithWhereUniqueWithoutAppointmentTypesInput = {
  create: DirectBookingExclusionRuleCreateWithoutAppointmentTypesInput;
  update: DirectBookingExclusionRuleUpdateWithoutAppointmentTypesInput;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};

export type DirectBookingExclusionRuleUpsertWithWhereUniqueWithoutClinicInput = {
  create: DirectBookingExclusionRuleCreateWithoutClinicInput;
  update: DirectBookingExclusionRuleUpdateWithoutClinicInput;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};

export type DirectBookingExclusionRuleUpsertWithWhereUniqueWithoutProvidersInput = {
  create: DirectBookingExclusionRuleCreateWithoutProvidersInput;
  update: DirectBookingExclusionRuleUpdateWithoutProvidersInput;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};

export type DirectBookingExclusionRuleUpsertWithoutTimeSlotsInput = {
  create: DirectBookingExclusionRuleCreateWithoutTimeSlotsInput;
  update: DirectBookingExclusionRuleUpdateWithoutTimeSlotsInput;
  where?: Maybe<DirectBookingExclusionRuleWhereInput>;
};

export type DirectBookingExclusionRuleWhereInput = {
  AND?: Maybe<Array<DirectBookingExclusionRuleWhereInput>>;
  NOT?: Maybe<Array<DirectBookingExclusionRuleWhereInput>>;
  OR?: Maybe<Array<DirectBookingExclusionRuleWhereInput>>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  providers?: Maybe<ClinicEmployeeListRelationFilter>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DirectBookingExclusionRuleWhereUniqueInput = {
  AND?: Maybe<Array<DirectBookingExclusionRuleWhereInput>>;
  NOT?: Maybe<Array<DirectBookingExclusionRuleWhereInput>>;
  OR?: Maybe<Array<DirectBookingExclusionRuleWhereInput>>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  providers?: Maybe<ClinicEmployeeListRelationFilter>;
  timeSlots?: Maybe<DirectBookingExclusionTimeSlotListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DirectBookingExclusionTimeSlot = {
  __typename?: 'DirectBookingExclusionTimeSlot';
  createdAt: Scalars['DateTime'];
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['String'];
  exclusionRule: DirectBookingExclusionRule;
  exclusionRuleId: Scalars['String'];
  id: Scalars['String'];
  startTime: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DirectBookingExclusionTimeSlotAvgAggregateOutputType = {
  __typename?: 'DirectBookingExclusionTimeSlotAvgAggregateOutputType';
  dayOfWeek?: Maybe<Scalars['Float']>;
};

export type DirectBookingExclusionTimeSlotAvgOrderByAggregateInput = {
  dayOfWeek?: Maybe<SortOrder>;
};

export type DirectBookingExclusionTimeSlotCountAggregateOutputType = {
  __typename?: 'DirectBookingExclusionTimeSlotCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['Int'];
  exclusionRuleId: Scalars['Int'];
  id: Scalars['Int'];
  startTime: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type DirectBookingExclusionTimeSlotCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  exclusionRuleId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingExclusionTimeSlotCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['String'];
  exclusionRule: DirectBookingExclusionRuleCreateNestedOneWithoutTimeSlotsInput;
  id?: Maybe<Scalars['String']>;
  startTime: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotCreateManyExclusionRuleInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  startTime: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotCreateManyExclusionRuleInputEnvelope = {
  data: Array<DirectBookingExclusionTimeSlotCreateManyExclusionRuleInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DirectBookingExclusionTimeSlotCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['String'];
  exclusionRuleId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  startTime: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotCreateNestedManyWithoutExclusionRuleInput = {
  connect?: Maybe<Array<DirectBookingExclusionTimeSlotWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionTimeSlotCreateOrConnectWithoutExclusionRuleInput>>;
  create?: Maybe<Array<DirectBookingExclusionTimeSlotCreateWithoutExclusionRuleInput>>;
  createMany?: Maybe<DirectBookingExclusionTimeSlotCreateManyExclusionRuleInputEnvelope>;
};

export type DirectBookingExclusionTimeSlotCreateOrConnectWithoutExclusionRuleInput = {
  create: DirectBookingExclusionTimeSlotCreateWithoutExclusionRuleInput;
  where: DirectBookingExclusionTimeSlotWhereUniqueInput;
};

export type DirectBookingExclusionTimeSlotCreateWithoutExclusionRuleInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  startTime: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotGroupByOutputType = {
  __typename?: 'DirectBookingExclusionTimeSlotGroupByOutputType';
  _avg?: Maybe<DirectBookingExclusionTimeSlotAvgAggregateOutputType>;
  _count?: Maybe<DirectBookingExclusionTimeSlotCountAggregateOutputType>;
  _max?: Maybe<DirectBookingExclusionTimeSlotMaxAggregateOutputType>;
  _min?: Maybe<DirectBookingExclusionTimeSlotMinAggregateOutputType>;
  _sum?: Maybe<DirectBookingExclusionTimeSlotSumAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['String'];
  exclusionRuleId: Scalars['String'];
  id: Scalars['String'];
  startTime: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DirectBookingExclusionTimeSlotListRelationFilter = {
  every?: Maybe<DirectBookingExclusionTimeSlotWhereInput>;
  none?: Maybe<DirectBookingExclusionTimeSlotWhereInput>;
  some?: Maybe<DirectBookingExclusionTimeSlotWhereInput>;
};

export type DirectBookingExclusionTimeSlotMaxAggregateOutputType = {
  __typename?: 'DirectBookingExclusionTimeSlotMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['String']>;
  exclusionRuleId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  exclusionRuleId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingExclusionTimeSlotMinAggregateOutputType = {
  __typename?: 'DirectBookingExclusionTimeSlotMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['String']>;
  exclusionRuleId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  exclusionRuleId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingExclusionTimeSlotOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DirectBookingExclusionTimeSlotOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<DirectBookingExclusionTimeSlotOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  exclusionRule?: Maybe<DirectBookingExclusionRuleOrderByWithRelationInput>;
  exclusionRuleId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum DirectBookingExclusionTimeSlotOrderByRelevanceFieldEnum {
  EndTime = 'endTime',
  ExclusionRuleId = 'exclusionRuleId',
  Id = 'id',
  StartTime = 'startTime'
}

export type DirectBookingExclusionTimeSlotOrderByRelevanceInput = {
  fields: Array<DirectBookingExclusionTimeSlotOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type DirectBookingExclusionTimeSlotOrderByWithAggregationInput = {
  _avg?: Maybe<DirectBookingExclusionTimeSlotAvgOrderByAggregateInput>;
  _count?: Maybe<DirectBookingExclusionTimeSlotCountOrderByAggregateInput>;
  _max?: Maybe<DirectBookingExclusionTimeSlotMaxOrderByAggregateInput>;
  _min?: Maybe<DirectBookingExclusionTimeSlotMinOrderByAggregateInput>;
  _sum?: Maybe<DirectBookingExclusionTimeSlotSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  exclusionRuleId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingExclusionTimeSlotOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<DirectBookingExclusionTimeSlotOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  exclusionRule?: Maybe<DirectBookingExclusionRuleOrderByWithRelationInput>;
  exclusionRuleId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DirectBookingExclusionTimeSlotOrderByWithRelationInput = {
  _relevance?: Maybe<DirectBookingExclusionTimeSlotOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  exclusionRule?: Maybe<DirectBookingExclusionRuleOrderByWithRelationInput>;
  exclusionRuleId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startTime?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum DirectBookingExclusionTimeSlotScalarFieldEnum {
  CreatedAt = 'createdAt',
  DayOfWeek = 'dayOfWeek',
  EndTime = 'endTime',
  ExclusionRuleId = 'exclusionRuleId',
  Id = 'id',
  StartTime = 'startTime',
  UpdatedAt = 'updatedAt'
}

export type DirectBookingExclusionTimeSlotScalarWhereInput = {
  AND?: Maybe<Array<DirectBookingExclusionTimeSlotScalarWhereInput>>;
  NOT?: Maybe<Array<DirectBookingExclusionTimeSlotScalarWhereInput>>;
  OR?: Maybe<Array<DirectBookingExclusionTimeSlotScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  dayOfWeek?: Maybe<IntFilter>;
  endTime?: Maybe<StringFilter>;
  exclusionRuleId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  startTime?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DirectBookingExclusionTimeSlotScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DirectBookingExclusionTimeSlotScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DirectBookingExclusionTimeSlotScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DirectBookingExclusionTimeSlotScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  dayOfWeek?: Maybe<IntWithAggregatesFilter>;
  endTime?: Maybe<StringWithAggregatesFilter>;
  exclusionRuleId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  startTime?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type DirectBookingExclusionTimeSlotSumAggregateOutputType = {
  __typename?: 'DirectBookingExclusionTimeSlotSumAggregateOutputType';
  dayOfWeek?: Maybe<Scalars['Int']>;
};

export type DirectBookingExclusionTimeSlotSumOrderByAggregateInput = {
  dayOfWeek?: Maybe<SortOrder>;
};

export type DirectBookingExclusionTimeSlotUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['String'];
  exclusionRuleId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  startTime: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotUncheckedCreateNestedManyWithoutExclusionRuleInput = {
  connect?: Maybe<Array<DirectBookingExclusionTimeSlotWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionTimeSlotCreateOrConnectWithoutExclusionRuleInput>>;
  create?: Maybe<Array<DirectBookingExclusionTimeSlotCreateWithoutExclusionRuleInput>>;
  createMany?: Maybe<DirectBookingExclusionTimeSlotCreateManyExclusionRuleInputEnvelope>;
};

export type DirectBookingExclusionTimeSlotUncheckedCreateWithoutExclusionRuleInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  startTime: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['String']>;
  exclusionRuleId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['String']>;
  exclusionRuleId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotUncheckedUpdateManyWithoutExclusionRuleInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotUncheckedUpdateManyWithoutExclusionRuleNestedInput = {
  connect?: Maybe<Array<DirectBookingExclusionTimeSlotWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionTimeSlotCreateOrConnectWithoutExclusionRuleInput>>;
  create?: Maybe<Array<DirectBookingExclusionTimeSlotCreateWithoutExclusionRuleInput>>;
  createMany?: Maybe<DirectBookingExclusionTimeSlotCreateManyExclusionRuleInputEnvelope>;
  delete?: Maybe<Array<DirectBookingExclusionTimeSlotWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DirectBookingExclusionTimeSlotScalarWhereInput>>;
  disconnect?: Maybe<Array<DirectBookingExclusionTimeSlotWhereUniqueInput>>;
  set?: Maybe<Array<DirectBookingExclusionTimeSlotWhereUniqueInput>>;
  update?: Maybe<Array<DirectBookingExclusionTimeSlotUpdateWithWhereUniqueWithoutExclusionRuleInput>>;
  updateMany?: Maybe<Array<DirectBookingExclusionTimeSlotUpdateManyWithWhereWithoutExclusionRuleInput>>;
  upsert?: Maybe<Array<DirectBookingExclusionTimeSlotUpsertWithWhereUniqueWithoutExclusionRuleInput>>;
};

export type DirectBookingExclusionTimeSlotUncheckedUpdateWithoutExclusionRuleInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['String']>;
  exclusionRule?: Maybe<DirectBookingExclusionRuleUpdateOneRequiredWithoutTimeSlotsNestedInput>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotUpdateManyWithWhereWithoutExclusionRuleInput = {
  data: DirectBookingExclusionTimeSlotUpdateManyMutationInput;
  where: DirectBookingExclusionTimeSlotScalarWhereInput;
};

export type DirectBookingExclusionTimeSlotUpdateManyWithoutExclusionRuleNestedInput = {
  connect?: Maybe<Array<DirectBookingExclusionTimeSlotWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DirectBookingExclusionTimeSlotCreateOrConnectWithoutExclusionRuleInput>>;
  create?: Maybe<Array<DirectBookingExclusionTimeSlotCreateWithoutExclusionRuleInput>>;
  createMany?: Maybe<DirectBookingExclusionTimeSlotCreateManyExclusionRuleInputEnvelope>;
  delete?: Maybe<Array<DirectBookingExclusionTimeSlotWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DirectBookingExclusionTimeSlotScalarWhereInput>>;
  disconnect?: Maybe<Array<DirectBookingExclusionTimeSlotWhereUniqueInput>>;
  set?: Maybe<Array<DirectBookingExclusionTimeSlotWhereUniqueInput>>;
  update?: Maybe<Array<DirectBookingExclusionTimeSlotUpdateWithWhereUniqueWithoutExclusionRuleInput>>;
  updateMany?: Maybe<Array<DirectBookingExclusionTimeSlotUpdateManyWithWhereWithoutExclusionRuleInput>>;
  upsert?: Maybe<Array<DirectBookingExclusionTimeSlotUpsertWithWhereUniqueWithoutExclusionRuleInput>>;
};

export type DirectBookingExclusionTimeSlotUpdateWithWhereUniqueWithoutExclusionRuleInput = {
  data: DirectBookingExclusionTimeSlotUpdateWithoutExclusionRuleInput;
  where: DirectBookingExclusionTimeSlotWhereUniqueInput;
};

export type DirectBookingExclusionTimeSlotUpdateWithoutExclusionRuleInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectBookingExclusionTimeSlotUpsertWithWhereUniqueWithoutExclusionRuleInput = {
  create: DirectBookingExclusionTimeSlotCreateWithoutExclusionRuleInput;
  update: DirectBookingExclusionTimeSlotUpdateWithoutExclusionRuleInput;
  where: DirectBookingExclusionTimeSlotWhereUniqueInput;
};

export type DirectBookingExclusionTimeSlotWhereInput = {
  AND?: Maybe<Array<DirectBookingExclusionTimeSlotWhereInput>>;
  NOT?: Maybe<Array<DirectBookingExclusionTimeSlotWhereInput>>;
  OR?: Maybe<Array<DirectBookingExclusionTimeSlotWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  dayOfWeek?: Maybe<IntFilter>;
  endTime?: Maybe<StringFilter>;
  exclusionRule?: Maybe<DirectBookingExclusionRuleScalarRelationFilter>;
  exclusionRuleId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  startTime?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DirectBookingExclusionTimeSlotWhereUniqueInput = {
  AND?: Maybe<Array<DirectBookingExclusionTimeSlotWhereInput>>;
  NOT?: Maybe<Array<DirectBookingExclusionTimeSlotWhereInput>>;
  OR?: Maybe<Array<DirectBookingExclusionTimeSlotWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  dayOfWeek?: Maybe<IntFilter>;
  endTime?: Maybe<StringFilter>;
  exclusionRule?: Maybe<DirectBookingExclusionRuleScalarRelationFilter>;
  exclusionRuleId?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DirectBookingOpenTimeSlot2Availability = {
  __typename?: 'DirectBookingOpenTimeSlot2Availability';
  availability: Array<DirectBookingDateAvailability>;
  clinicEmployeeFirstName?: Maybe<Scalars['String']>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicEmployeeLastName?: Maybe<Scalars['String']>;
};

export type DirectBookingOpenTimeSlot2Input = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  clinicId: Scalars['String'];
  dates: Array<Maybe<DirectBookingOpenTimeSlotRange>>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  petParentTimezone?: Maybe<Scalars['String']>;
  showFirstAvailabilityDayOnly?: Maybe<Scalars['Boolean']>;
  soonestAvailableBookingInHours?: Maybe<Scalars['Int']>;
};

export type DirectBookingOpenTimeSlot2Response = {
  __typename?: 'DirectBookingOpenTimeSlot2Response';
  availableTimeSlots?: Maybe<Array<DirectBookingOpenTimeSlot2Availability>>;
  usedTimezone?: Maybe<Scalars['String']>;
};

export type DirectBookingOpenTimeSlotRange = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export enum DirectBookingSpeciesOption {
  NotUsed = 'NotUsed',
  Used = 'Used'
}

export type DirectedAuthLinkInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  loginType?: Maybe<Scalars['String']>;
  organizationPlanId?: Maybe<Scalars['String']>;
};

export type DirectedAuthLinkResult = {
  __typename?: 'DirectedAuthLinkResult';
  success: Scalars['Boolean'];
};

/** @deprecated - 1.0 */
export type Disbursement = {
  __typename?: 'Disbursement';
  _count: DisbursementCountOutputType;
  amount: Scalars['Float'];
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId: Scalars['String'];
  id: Scalars['String'];
  source: Scalars['String'];
  transactions: Array<Transaction>;
  updatedAt: Scalars['DateTime'];
};


/** @deprecated - 1.0 */
export type DisbursementTransactionsArgs = {
  cursor?: Maybe<TransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TransactionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TransactionWhereInput>;
};

export type DisbursementAvgAggregateOutputType = {
  __typename?: 'DisbursementAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
};

export type DisbursementAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type DisbursementCountAggregateOutputType = {
  __typename?: 'DisbursementCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  disbursementDate: Scalars['Int'];
  disbursementId: Scalars['Int'];
  id: Scalars['Int'];
  source: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type DisbursementCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DisbursementCountOutputType = {
  __typename?: 'DisbursementCountOutputType';
  transactions: Scalars['Int'];
};

export type DisbursementCreateInput = {
  amount: Scalars['Float'];
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionCreateNestedManyWithoutDisbursementInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementCreateManyInput = {
  amount: Scalars['Float'];
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementCreateNestedOneWithoutTransactionsInput = {
  connect?: Maybe<DisbursementWhereUniqueInput>;
  connectOrCreate?: Maybe<DisbursementCreateOrConnectWithoutTransactionsInput>;
  create?: Maybe<DisbursementCreateWithoutTransactionsInput>;
};

export type DisbursementCreateOrConnectWithoutTransactionsInput = {
  create: DisbursementCreateWithoutTransactionsInput;
  where: DisbursementWhereUniqueInput;
};

export type DisbursementCreateWithoutTransactionsInput = {
  amount: Scalars['Float'];
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementGroupByOutputType = {
  __typename?: 'DisbursementGroupByOutputType';
  _avg?: Maybe<DisbursementAvgAggregateOutputType>;
  _count?: Maybe<DisbursementCountAggregateOutputType>;
  _max?: Maybe<DisbursementMaxAggregateOutputType>;
  _min?: Maybe<DisbursementMinAggregateOutputType>;
  _sum?: Maybe<DisbursementSumAggregateOutputType>;
  amount: Scalars['Float'];
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId: Scalars['String'];
  id: Scalars['String'];
  source: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DisbursementMaxAggregateOutputType = {
  __typename?: 'DisbursementMaxAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DisbursementMinAggregateOutputType = {
  __typename?: 'DisbursementMinAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DisbursementNullableScalarRelationFilter = {
  AND?: Maybe<Array<DisbursementWhereInput>>;
  NOT?: Maybe<Array<DisbursementWhereInput>>;
  OR?: Maybe<Array<DisbursementWhereInput>>;
  amount?: Maybe<FloatFilter>;
  disbursementDate?: Maybe<DateTimeNullableFilter>;
  disbursementId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  source?: Maybe<StringFilter>;
  transactions?: Maybe<TransactionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DisbursementOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<DisbursementOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  transactions?: Maybe<TransactionOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum DisbursementOrderByRelevanceFieldEnum {
  DisbursementId = 'disbursementId',
  Id = 'id',
  Source = 'source'
}

export type DisbursementOrderByRelevanceInput = {
  fields: Array<DisbursementOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type DisbursementOrderByWithAggregationInput = {
  _avg?: Maybe<DisbursementAvgOrderByAggregateInput>;
  _count?: Maybe<DisbursementCountOrderByAggregateInput>;
  _max?: Maybe<DisbursementMaxOrderByAggregateInput>;
  _min?: Maybe<DisbursementMinOrderByAggregateInput>;
  _sum?: Maybe<DisbursementSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DisbursementOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<DisbursementOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  transactions?: Maybe<TransactionOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type DisbursementOrderByWithRelationInput = {
  _relevance?: Maybe<DisbursementOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  transactions?: Maybe<TransactionOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum DisbursementScalarFieldEnum {
  Amount = 'amount',
  DisbursementDate = 'disbursementDate',
  DisbursementId = 'disbursementId',
  Id = 'id',
  Source = 'source',
  UpdatedAt = 'updatedAt'
}

export type DisbursementScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DisbursementScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DisbursementScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DisbursementScalarWhereWithAggregatesInput>>;
  amount?: Maybe<FloatWithAggregatesFilter>;
  disbursementDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  disbursementId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  source?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type DisbursementSumAggregateOutputType = {
  __typename?: 'DisbursementSumAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
};

export type DisbursementSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type DisbursementUncheckedCreateInput = {
  amount: Scalars['Float'];
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedCreateNestedManyWithoutDisbursementInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementUncheckedCreateWithoutTransactionsInput = {
  amount: Scalars['Float'];
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Float']>;
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUncheckedUpdateManyWithoutDisbursementNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Float']>;
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementUncheckedUpdateWithoutTransactionsInput = {
  amount?: Maybe<Scalars['Float']>;
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementUpdateInput = {
  amount?: Maybe<Scalars['Float']>;
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  transactions?: Maybe<TransactionUpdateManyWithoutDisbursementNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Float']>;
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementUpdateOneWithoutTransactionsNestedInput = {
  connect?: Maybe<DisbursementWhereUniqueInput>;
  connectOrCreate?: Maybe<DisbursementCreateOrConnectWithoutTransactionsInput>;
  create?: Maybe<DisbursementCreateWithoutTransactionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<DisbursementUpdateToOneWithWhereWithoutTransactionsInput>;
  upsert?: Maybe<DisbursementUpsertWithoutTransactionsInput>;
};

export type DisbursementUpdateToOneWithWhereWithoutTransactionsInput = {
  data: DisbursementUpdateWithoutTransactionsInput;
  where?: Maybe<DisbursementWhereInput>;
};

export type DisbursementUpdateWithoutTransactionsInput = {
  amount?: Maybe<Scalars['Float']>;
  disbursementDate?: Maybe<Scalars['DateTime']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DisbursementUpsertWithoutTransactionsInput = {
  create: DisbursementCreateWithoutTransactionsInput;
  update: DisbursementUpdateWithoutTransactionsInput;
  where?: Maybe<DisbursementWhereInput>;
};

export type DisbursementWhereInput = {
  AND?: Maybe<Array<DisbursementWhereInput>>;
  NOT?: Maybe<Array<DisbursementWhereInput>>;
  OR?: Maybe<Array<DisbursementWhereInput>>;
  amount?: Maybe<FloatFilter>;
  disbursementDate?: Maybe<DateTimeNullableFilter>;
  disbursementId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  source?: Maybe<StringFilter>;
  transactions?: Maybe<TransactionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DisbursementWhereUniqueInput = {
  AND?: Maybe<Array<DisbursementWhereInput>>;
  NOT?: Maybe<Array<DisbursementWhereInput>>;
  OR?: Maybe<Array<DisbursementWhereInput>>;
  amount?: Maybe<FloatFilter>;
  disbursementDate?: Maybe<DateTimeNullableFilter>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<StringFilter>;
  transactions?: Maybe<TransactionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Documentation = {
  __typename?: 'Documentation';
  category: DocumentationCategory;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  provider: DocumentationProvider;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export enum DocumentationCategory {
  Birds = 'Birds',
  Cats = 'Cats',
  Dogs = 'Dogs',
  GeneralInformation = 'GeneralInformation',
  Horses = 'Horses',
  Medications = 'Medications',
  Pigs = 'Pigs',
  Reptiles = 'Reptiles',
  Ruminants = 'Ruminants',
  SmallMammals = 'SmallMammals'
}

export type DocumentationCountAggregateOutputType = {
  __typename?: 'DocumentationCountAggregateOutputType';
  _all: Scalars['Int'];
  category: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  provider: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
  url: Scalars['Int'];
};

export type DocumentationCountOrderByAggregateInput = {
  category?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type DocumentationCreateInput = {
  category: DocumentationCategory;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  provider: DocumentationProvider;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type DocumentationCreateManyInput = {
  category: DocumentationCategory;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  provider: DocumentationProvider;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type DocumentationGroupByOutputType = {
  __typename?: 'DocumentationGroupByOutputType';
  _count?: Maybe<DocumentationCountAggregateOutputType>;
  _max?: Maybe<DocumentationMaxAggregateOutputType>;
  _min?: Maybe<DocumentationMinAggregateOutputType>;
  category: DocumentationCategory;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  provider: DocumentationProvider;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type DocumentationMaxAggregateOutputType = {
  __typename?: 'DocumentationMaxAggregateOutputType';
  category?: Maybe<DocumentationCategory>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<DocumentationProvider>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type DocumentationMaxOrderByAggregateInput = {
  category?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type DocumentationMinAggregateOutputType = {
  __typename?: 'DocumentationMinAggregateOutputType';
  category?: Maybe<DocumentationCategory>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<DocumentationProvider>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type DocumentationMinOrderByAggregateInput = {
  category?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type DocumentationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<DocumentationOrderByRelevanceInput>;
  category?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export enum DocumentationOrderByRelevanceFieldEnum {
  Id = 'id',
  Title = 'title',
  Url = 'url'
}

export type DocumentationOrderByRelevanceInput = {
  fields: Array<DocumentationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type DocumentationOrderByWithAggregationInput = {
  _count?: Maybe<DocumentationCountOrderByAggregateInput>;
  _max?: Maybe<DocumentationMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentationMinOrderByAggregateInput>;
  category?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type DocumentationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<DocumentationOrderByRelevanceInput>;
  category?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type DocumentationOrderByWithRelationInput = {
  _relevance?: Maybe<DocumentationOrderByRelevanceInput>;
  category?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export enum DocumentationProvider {
  VeterinaryPartner = 'VeterinaryPartner'
}

export enum DocumentationScalarFieldEnum {
  Category = 'category',
  CreatedAt = 'createdAt',
  Id = 'id',
  Provider = 'provider',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  Url = 'url'
}

export type DocumentationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentationScalarWhereWithAggregatesInput>>;
  category?: Maybe<EnumDocumentationCategoryWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  provider?: Maybe<EnumDocumentationProviderWithAggregatesFilter>;
  title?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  url?: Maybe<StringWithAggregatesFilter>;
};

export type DocumentationUncheckedCreateInput = {
  category: DocumentationCategory;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  provider: DocumentationProvider;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type DocumentationUncheckedUpdateInput = {
  category?: Maybe<DocumentationCategory>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<DocumentationProvider>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type DocumentationUncheckedUpdateManyInput = {
  category?: Maybe<DocumentationCategory>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<DocumentationProvider>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type DocumentationUpdateInput = {
  category?: Maybe<DocumentationCategory>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<DocumentationProvider>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type DocumentationUpdateManyMutationInput = {
  category?: Maybe<DocumentationCategory>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<DocumentationProvider>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type DocumentationWhereInput = {
  AND?: Maybe<Array<DocumentationWhereInput>>;
  NOT?: Maybe<Array<DocumentationWhereInput>>;
  OR?: Maybe<Array<DocumentationWhereInput>>;
  category?: Maybe<EnumDocumentationCategoryFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  provider?: Maybe<EnumDocumentationProviderFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
};

export type DocumentationWhereUniqueInput = {
  AND?: Maybe<Array<DocumentationWhereInput>>;
  NOT?: Maybe<Array<DocumentationWhereInput>>;
  OR?: Maybe<Array<DocumentationWhereInput>>;
  category?: Maybe<EnumDocumentationCategoryFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EnumDocumentationProviderFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
};

export type DuplicateEmailCampaignInput = {
  emailCampaignId: Scalars['String'];
  userId: Scalars['String'];
};

export type EmailCampaign = {
  __typename?: 'EmailCampaign';
  _count: EmailCampaignCountOutputType;
  clinic: Clinic;
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomList>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs: Array<EmailCampaignLog>;
  emailCampaignUnsubscribes: Array<EmailCampaignUnsubscribe>;
  from: Scalars['String'];
  htmlContent?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informCampaignExecution?: Maybe<InformCampaignExecution>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  lastUpdatedByUser?: Maybe<User>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType: EmailCampaignSegmentationType;
  sentByUser?: Maybe<User>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status: EmailCampaignStatus;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type: EmailCampaignType;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  uploads: Array<EmailCampaignCustomListUploadHistory>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};


export type EmailCampaignCreatedByUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type EmailCampaignCustomListArgs = {
  where?: Maybe<EmailCampaignCustomListWhereInput>;
};


export type EmailCampaignEmailCampaignLogsArgs = {
  cursor?: Maybe<EmailCampaignLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignLogWhereInput>;
};


export type EmailCampaignEmailCampaignUnsubscribesArgs = {
  cursor?: Maybe<EmailCampaignUnsubscribeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignUnsubscribeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignUnsubscribeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignUnsubscribeWhereInput>;
};


export type EmailCampaignInformCampaignExecutionArgs = {
  where?: Maybe<InformCampaignExecutionWhereInput>;
};


export type EmailCampaignLastUpdatedByUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type EmailCampaignSentByUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type EmailCampaignUploadsArgs = {
  cursor?: Maybe<EmailCampaignCustomListUploadHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignCustomListUploadHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListUploadHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListUploadHistoryWhereInput>;
};


export type EmailCampaignUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type EmailCampaignAvgAggregateOutputType = {
  __typename?: 'EmailCampaignAvgAggregateOutputType';
  totalSegmentContacts?: Maybe<Scalars['Float']>;
};

export type EmailCampaignAvgOrderByAggregateInput = {
  totalSegmentContacts?: Maybe<SortOrder>;
};

export type EmailCampaignCountAggregateOutputType = {
  __typename?: 'EmailCampaignCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  completedAt: Scalars['Int'];
  contexts: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdByUserId: Scalars['Int'];
  deletedAt: Scalars['Int'];
  from: Scalars['Int'];
  htmlContent: Scalars['Int'];
  id: Scalars['Int'];
  informCampaignExecutionId: Scalars['Int'];
  latUpdatedByUserId: Scalars['Int'];
  name: Scalars['Int'];
  replyTo: Scalars['Int'];
  replyToJson: Scalars['Int'];
  scheduledAt: Scalars['Int'];
  segmentArgs: Scalars['Int'];
  segmentWhere: Scalars['Int'];
  segmentationDefinition: Scalars['Int'];
  segmentationType: Scalars['Int'];
  sentByUserId: Scalars['Int'];
  startedAt: Scalars['Int'];
  startsAt: Scalars['Int'];
  status: Scalars['Int'];
  subject: Scalars['Int'];
  totalSegmentContacts: Scalars['Int'];
  type: Scalars['Int'];
  unlayerJson: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type EmailCampaignCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  contexts?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  from?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  replyTo?: Maybe<SortOrder>;
  replyToJson?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  segmentArgs?: Maybe<SortOrder>;
  segmentWhere?: Maybe<SortOrder>;
  segmentationDefinition?: Maybe<SortOrder>;
  segmentationType?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  totalSegmentContacts?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type EmailCampaignCountOutputType = {
  __typename?: 'EmailCampaignCountOutputType';
  emailCampaignLogs: Scalars['Int'];
  emailCampaignUnsubscribes: Scalars['Int'];
  uploads: Scalars['Int'];
};

export type EmailCampaignCreateInput = {
  clinic: ClinicCreateNestedOneWithoutEmailCampaignInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsCreatedInput>;
  customList?: Maybe<EmailCampaignCustomListCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionCreateNestedOneWithoutEmailCampaignsInput>;
  lastUpdatedByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignUpdatedInput>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsSentInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  typedSegmentArgs?: Maybe<SegmentsArgsInput>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryCreateNestedManyWithoutEmailCampaignInput>;
  user?: Maybe<UserCreateNestedOneWithoutEmailCampaignInput>;
};

export type EmailCampaignCreateManyClinicInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignCreateManyClinicInputEnvelope = {
  data: Array<EmailCampaignCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignCreateManyCreatedByUserInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignCreateManyCreatedByUserInputEnvelope = {
  data: Array<EmailCampaignCreateManyCreatedByUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignCreateManyInformCampaignExecutionInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignCreateManyInformCampaignExecutionInputEnvelope = {
  data: Array<EmailCampaignCreateManyInformCampaignExecutionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignCreateManyInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignCreateManyLastUpdatedByUserInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignCreateManyLastUpdatedByUserInputEnvelope = {
  data: Array<EmailCampaignCreateManyLastUpdatedByUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignCreateManySentByUserInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignCreateManySentByUserInputEnvelope = {
  data: Array<EmailCampaignCreateManySentByUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignCreateManyUserInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCreateManyUserInputEnvelope = {
  data: Array<EmailCampaignCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignCreateManyClinicInputEnvelope>;
};

export type EmailCampaignCreateNestedManyWithoutCreatedByUserInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutCreatedByUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutCreatedByUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManyCreatedByUserInputEnvelope>;
};

export type EmailCampaignCreateNestedManyWithoutInformCampaignExecutionInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutInformCampaignExecutionInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutInformCampaignExecutionInput>>;
  createMany?: Maybe<EmailCampaignCreateManyInformCampaignExecutionInputEnvelope>;
};

export type EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutLastUpdatedByUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutLastUpdatedByUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManyLastUpdatedByUserInputEnvelope>;
};

export type EmailCampaignCreateNestedManyWithoutSentByUserInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutSentByUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutSentByUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManySentByUserInputEnvelope>;
};

export type EmailCampaignCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManyUserInputEnvelope>;
};

export type EmailCampaignCreateNestedOneWithoutCustomListInput = {
  connect?: Maybe<EmailCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCreateOrConnectWithoutCustomListInput>;
  create?: Maybe<EmailCampaignCreateWithoutCustomListInput>;
};

export type EmailCampaignCreateNestedOneWithoutEmailCampaignLogsInput = {
  connect?: Maybe<EmailCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCreateOrConnectWithoutEmailCampaignLogsInput>;
  create?: Maybe<EmailCampaignCreateWithoutEmailCampaignLogsInput>;
};

export type EmailCampaignCreateNestedOneWithoutEmailCampaignUnsubscribesInput = {
  connect?: Maybe<EmailCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCreateOrConnectWithoutEmailCampaignUnsubscribesInput>;
  create?: Maybe<EmailCampaignCreateWithoutEmailCampaignUnsubscribesInput>;
};

export type EmailCampaignCreateNestedOneWithoutUploadsInput = {
  connect?: Maybe<EmailCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCreateOrConnectWithoutUploadsInput>;
  create?: Maybe<EmailCampaignCreateWithoutUploadsInput>;
};

export type EmailCampaignCreateOrConnectWithoutClinicInput = {
  create: EmailCampaignCreateWithoutClinicInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignCreateOrConnectWithoutCreatedByUserInput = {
  create: EmailCampaignCreateWithoutCreatedByUserInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignCreateOrConnectWithoutCustomListInput = {
  create: EmailCampaignCreateWithoutCustomListInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignCreateOrConnectWithoutEmailCampaignLogsInput = {
  create: EmailCampaignCreateWithoutEmailCampaignLogsInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignCreateOrConnectWithoutEmailCampaignUnsubscribesInput = {
  create: EmailCampaignCreateWithoutEmailCampaignUnsubscribesInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignCreateOrConnectWithoutInformCampaignExecutionInput = {
  create: EmailCampaignCreateWithoutInformCampaignExecutionInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignCreateOrConnectWithoutLastUpdatedByUserInput = {
  create: EmailCampaignCreateWithoutLastUpdatedByUserInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignCreateOrConnectWithoutSentByUserInput = {
  create: EmailCampaignCreateWithoutSentByUserInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignCreateOrConnectWithoutUploadsInput = {
  create: EmailCampaignCreateWithoutUploadsInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignCreateOrConnectWithoutUserInput = {
  create: EmailCampaignCreateWithoutUserInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignCreateWithoutClinicInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsCreatedInput>;
  customList?: Maybe<EmailCampaignCustomListCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionCreateNestedOneWithoutEmailCampaignsInput>;
  lastUpdatedByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignUpdatedInput>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsSentInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryCreateNestedManyWithoutEmailCampaignInput>;
  user?: Maybe<UserCreateNestedOneWithoutEmailCampaignInput>;
};

export type EmailCampaignCreateWithoutCreatedByUserInput = {
  clinic: ClinicCreateNestedOneWithoutEmailCampaignInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customList?: Maybe<EmailCampaignCustomListCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionCreateNestedOneWithoutEmailCampaignsInput>;
  lastUpdatedByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignUpdatedInput>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsSentInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryCreateNestedManyWithoutEmailCampaignInput>;
  user?: Maybe<UserCreateNestedOneWithoutEmailCampaignInput>;
};

export type EmailCampaignCreateWithoutCustomListInput = {
  clinic: ClinicCreateNestedOneWithoutEmailCampaignInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsCreatedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionCreateNestedOneWithoutEmailCampaignsInput>;
  lastUpdatedByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignUpdatedInput>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsSentInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryCreateNestedManyWithoutEmailCampaignInput>;
  user?: Maybe<UserCreateNestedOneWithoutEmailCampaignInput>;
};

export type EmailCampaignCreateWithoutEmailCampaignLogsInput = {
  clinic: ClinicCreateNestedOneWithoutEmailCampaignInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsCreatedInput>;
  customList?: Maybe<EmailCampaignCustomListCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionCreateNestedOneWithoutEmailCampaignsInput>;
  lastUpdatedByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignUpdatedInput>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsSentInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryCreateNestedManyWithoutEmailCampaignInput>;
  user?: Maybe<UserCreateNestedOneWithoutEmailCampaignInput>;
};

export type EmailCampaignCreateWithoutEmailCampaignUnsubscribesInput = {
  clinic: ClinicCreateNestedOneWithoutEmailCampaignInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsCreatedInput>;
  customList?: Maybe<EmailCampaignCustomListCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionCreateNestedOneWithoutEmailCampaignsInput>;
  lastUpdatedByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignUpdatedInput>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsSentInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryCreateNestedManyWithoutEmailCampaignInput>;
  user?: Maybe<UserCreateNestedOneWithoutEmailCampaignInput>;
};

export type EmailCampaignCreateWithoutInformCampaignExecutionInput = {
  clinic: ClinicCreateNestedOneWithoutEmailCampaignInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsCreatedInput>;
  customList?: Maybe<EmailCampaignCustomListCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastUpdatedByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignUpdatedInput>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsSentInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryCreateNestedManyWithoutEmailCampaignInput>;
  user?: Maybe<UserCreateNestedOneWithoutEmailCampaignInput>;
};

export type EmailCampaignCreateWithoutLastUpdatedByUserInput = {
  clinic: ClinicCreateNestedOneWithoutEmailCampaignInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsCreatedInput>;
  customList?: Maybe<EmailCampaignCustomListCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionCreateNestedOneWithoutEmailCampaignsInput>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsSentInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryCreateNestedManyWithoutEmailCampaignInput>;
  user?: Maybe<UserCreateNestedOneWithoutEmailCampaignInput>;
};

export type EmailCampaignCreateWithoutSentByUserInput = {
  clinic: ClinicCreateNestedOneWithoutEmailCampaignInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsCreatedInput>;
  customList?: Maybe<EmailCampaignCustomListCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionCreateNestedOneWithoutEmailCampaignsInput>;
  lastUpdatedByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignUpdatedInput>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryCreateNestedManyWithoutEmailCampaignInput>;
  user?: Maybe<UserCreateNestedOneWithoutEmailCampaignInput>;
};

export type EmailCampaignCreateWithoutUploadsInput = {
  clinic: ClinicCreateNestedOneWithoutEmailCampaignInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsCreatedInput>;
  customList?: Maybe<EmailCampaignCustomListCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionCreateNestedOneWithoutEmailCampaignsInput>;
  lastUpdatedByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignUpdatedInput>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsSentInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutEmailCampaignInput>;
};

export type EmailCampaignCreateWithoutUserInput = {
  clinic: ClinicCreateNestedOneWithoutEmailCampaignInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsCreatedInput>;
  customList?: Maybe<EmailCampaignCustomListCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionCreateNestedOneWithoutEmailCampaignsInput>;
  lastUpdatedByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignUpdatedInput>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserCreateNestedOneWithoutEmailCampaignsSentInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryCreateNestedManyWithoutEmailCampaignInput>;
};

export type EmailCampaignCustomList = {
  __typename?: 'EmailCampaignCustomList';
  _count: EmailCampaignCustomListCountOutputType;
  awsFileKey: Scalars['String'];
  createdAt: Scalars['DateTime'];
  emailCampaign: EmailCampaign;
  emailCampaignId: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  invalidRecipients: Scalars['Int'];
  recipients: Array<EmailCampaignCustomListRecipient>;
  updatedAt: Scalars['DateTime'];
  validRecipients: Scalars['Int'];
};


export type EmailCampaignCustomListRecipientsArgs = {
  cursor?: Maybe<EmailCampaignCustomListRecipientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignCustomListRecipientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListRecipientOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListRecipientWhereInput>;
};

export type EmailCampaignCustomListAvgAggregateOutputType = {
  __typename?: 'EmailCampaignCustomListAvgAggregateOutputType';
  invalidRecipients?: Maybe<Scalars['Float']>;
  validRecipients?: Maybe<Scalars['Float']>;
};

export type EmailCampaignCustomListAvgOrderByAggregateInput = {
  invalidRecipients?: Maybe<SortOrder>;
  validRecipients?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListCountAggregateOutputType = {
  __typename?: 'EmailCampaignCustomListCountAggregateOutputType';
  _all: Scalars['Int'];
  awsFileKey: Scalars['Int'];
  createdAt: Scalars['Int'];
  emailCampaignId: Scalars['Int'];
  fileName: Scalars['Int'];
  id: Scalars['Int'];
  invalidRecipients: Scalars['Int'];
  updatedAt: Scalars['Int'];
  validRecipients: Scalars['Int'];
};

export type EmailCampaignCustomListCountOrderByAggregateInput = {
  awsFileKey?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invalidRecipients?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validRecipients?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListCountOutputType = {
  __typename?: 'EmailCampaignCustomListCountOutputType';
  recipients: Scalars['Int'];
};

export type EmailCampaignCustomListCreateInput = {
  awsFileKey: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign: EmailCampaignCreateNestedOneWithoutCustomListInput;
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  recipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutEmailCampaignCustomListInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListCreateManyInput = {
  awsFileKey: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId: Scalars['String'];
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListCreateNestedOneWithoutEmailCampaignInput = {
  connect?: Maybe<EmailCampaignCustomListWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCustomListCreateOrConnectWithoutEmailCampaignInput>;
  create?: Maybe<EmailCampaignCustomListCreateWithoutEmailCampaignInput>;
};

export type EmailCampaignCustomListCreateNestedOneWithoutRecipientsInput = {
  connect?: Maybe<EmailCampaignCustomListWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCustomListCreateOrConnectWithoutRecipientsInput>;
  create?: Maybe<EmailCampaignCustomListCreateWithoutRecipientsInput>;
};

export type EmailCampaignCustomListCreateOrConnectWithoutEmailCampaignInput = {
  create: EmailCampaignCustomListCreateWithoutEmailCampaignInput;
  where: EmailCampaignCustomListWhereUniqueInput;
};

export type EmailCampaignCustomListCreateOrConnectWithoutRecipientsInput = {
  create: EmailCampaignCustomListCreateWithoutRecipientsInput;
  where: EmailCampaignCustomListWhereUniqueInput;
};

export type EmailCampaignCustomListCreateWithoutEmailCampaignInput = {
  awsFileKey: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  recipients?: Maybe<EmailCampaignCustomListRecipientCreateNestedManyWithoutEmailCampaignCustomListInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListCreateWithoutRecipientsInput = {
  awsFileKey: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign: EmailCampaignCreateNestedOneWithoutCustomListInput;
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListGroupByOutputType = {
  __typename?: 'EmailCampaignCustomListGroupByOutputType';
  _avg?: Maybe<EmailCampaignCustomListAvgAggregateOutputType>;
  _count?: Maybe<EmailCampaignCustomListCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignCustomListMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignCustomListMinAggregateOutputType>;
  _sum?: Maybe<EmailCampaignCustomListSumAggregateOutputType>;
  awsFileKey: Scalars['String'];
  createdAt: Scalars['DateTime'];
  emailCampaignId: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  invalidRecipients: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  validRecipients: Scalars['Int'];
};

export type EmailCampaignCustomListMaxAggregateOutputType = {
  __typename?: 'EmailCampaignCustomListMaxAggregateOutputType';
  awsFileKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListMaxOrderByAggregateInput = {
  awsFileKey?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invalidRecipients?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validRecipients?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListMinAggregateOutputType = {
  __typename?: 'EmailCampaignCustomListMinAggregateOutputType';
  awsFileKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListMinOrderByAggregateInput = {
  awsFileKey?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invalidRecipients?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validRecipients?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListNullableScalarRelationFilter = {
  AND?: Maybe<Array<EmailCampaignCustomListWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListWhereInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListWhereInput>>;
  awsFileKey?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaign?: Maybe<EmailCampaignScalarRelationFilter>;
  emailCampaignId?: Maybe<StringFilter>;
  fileName?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  invalidRecipients?: Maybe<IntFilter>;
  recipients?: Maybe<EmailCampaignCustomListRecipientListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  validRecipients?: Maybe<IntFilter>;
};

export type EmailCampaignCustomListOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailCampaignCustomListOrderByRelevanceInput>;
  awsFileKey?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaign?: Maybe<EmailCampaignOrderByWithRelationInput>;
  emailCampaignId?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invalidRecipients?: Maybe<SortOrder>;
  recipients?: Maybe<EmailCampaignCustomListRecipientOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  validRecipients?: Maybe<SortOrder>;
};

export enum EmailCampaignCustomListOrderByRelevanceFieldEnum {
  AwsFileKey = 'awsFileKey',
  EmailCampaignId = 'emailCampaignId',
  FileName = 'fileName',
  Id = 'id'
}

export type EmailCampaignCustomListOrderByRelevanceInput = {
  fields: Array<EmailCampaignCustomListOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EmailCampaignCustomListOrderByWithAggregationInput = {
  _avg?: Maybe<EmailCampaignCustomListAvgOrderByAggregateInput>;
  _count?: Maybe<EmailCampaignCustomListCountOrderByAggregateInput>;
  _max?: Maybe<EmailCampaignCustomListMaxOrderByAggregateInput>;
  _min?: Maybe<EmailCampaignCustomListMinOrderByAggregateInput>;
  _sum?: Maybe<EmailCampaignCustomListSumOrderByAggregateInput>;
  awsFileKey?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invalidRecipients?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validRecipients?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailCampaignCustomListOrderByRelevanceInput>;
  awsFileKey?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaign?: Maybe<EmailCampaignOrderByWithRelationInput>;
  emailCampaignId?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invalidRecipients?: Maybe<SortOrder>;
  recipients?: Maybe<EmailCampaignCustomListRecipientOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  validRecipients?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListOrderByWithRelationInput = {
  _relevance?: Maybe<EmailCampaignCustomListOrderByRelevanceInput>;
  awsFileKey?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaign?: Maybe<EmailCampaignOrderByWithRelationInput>;
  emailCampaignId?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invalidRecipients?: Maybe<SortOrder>;
  recipients?: Maybe<EmailCampaignCustomListRecipientOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  validRecipients?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListRecipient = {
  __typename?: 'EmailCampaignCustomListRecipient';
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  emailCampaignCustomList: EmailCampaignCustomList;
  emailCampaignCustomListId: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status: EmailCampaignCustomListRecipientStatus;
  updatedAt: Scalars['DateTime'];
};


export type EmailCampaignCustomListRecipientClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type EmailCampaignCustomListRecipientCountAggregateOutputType = {
  __typename?: 'EmailCampaignCustomListRecipientCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  email: Scalars['Int'];
  emailCampaignCustomListId: Scalars['Int'];
  firstName: Scalars['Int'];
  id: Scalars['Int'];
  lastName: Scalars['Int'];
  reason: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type EmailCampaignCustomListRecipientCountOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  emailCampaignCustomListId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListRecipientCreateInput = {
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutEmailCampaignCustomListRecipientsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailCampaignCustomList: EmailCampaignCustomListCreateNestedOneWithoutRecipientsInput;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientCreateManyClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailCampaignCustomListId: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientCreateManyClinicPetParentInputEnvelope = {
  data: Array<EmailCampaignCustomListRecipientCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignCustomListRecipientCreateManyEmailCampaignCustomListInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientCreateManyEmailCampaignCustomListInputEnvelope = {
  data: Array<EmailCampaignCustomListRecipientCreateManyEmailCampaignCustomListInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignCustomListRecipientCreateManyInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailCampaignCustomListId: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCustomListRecipientCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailCampaignCustomListRecipientCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailCampaignCustomListRecipientCreateManyClinicPetParentInputEnvelope>;
};

export type EmailCampaignCustomListRecipientCreateNestedManyWithoutEmailCampaignCustomListInput = {
  connect?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCustomListRecipientCreateOrConnectWithoutEmailCampaignCustomListInput>>;
  create?: Maybe<Array<EmailCampaignCustomListRecipientCreateWithoutEmailCampaignCustomListInput>>;
  createMany?: Maybe<EmailCampaignCustomListRecipientCreateManyEmailCampaignCustomListInputEnvelope>;
};

export type EmailCampaignCustomListRecipientCreateOrConnectWithoutClinicPetParentInput = {
  create: EmailCampaignCustomListRecipientCreateWithoutClinicPetParentInput;
  where: EmailCampaignCustomListRecipientWhereUniqueInput;
};

export type EmailCampaignCustomListRecipientCreateOrConnectWithoutEmailCampaignCustomListInput = {
  create: EmailCampaignCustomListRecipientCreateWithoutEmailCampaignCustomListInput;
  where: EmailCampaignCustomListRecipientWhereUniqueInput;
};

export type EmailCampaignCustomListRecipientCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailCampaignCustomList: EmailCampaignCustomListCreateNestedOneWithoutRecipientsInput;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientCreateWithoutEmailCampaignCustomListInput = {
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutEmailCampaignCustomListRecipientsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientGroupByOutputType = {
  __typename?: 'EmailCampaignCustomListRecipientGroupByOutputType';
  _count?: Maybe<EmailCampaignCustomListRecipientCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignCustomListRecipientMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignCustomListRecipientMinAggregateOutputType>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  emailCampaignCustomListId: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status: EmailCampaignCustomListRecipientStatus;
  updatedAt: Scalars['DateTime'];
};

export type EmailCampaignCustomListRecipientListRelationFilter = {
  every?: Maybe<EmailCampaignCustomListRecipientWhereInput>;
  none?: Maybe<EmailCampaignCustomListRecipientWhereInput>;
  some?: Maybe<EmailCampaignCustomListRecipientWhereInput>;
};

export type EmailCampaignCustomListRecipientMaxAggregateOutputType = {
  __typename?: 'EmailCampaignCustomListRecipientMaxAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientMaxOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  emailCampaignCustomListId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListRecipientMinAggregateOutputType = {
  __typename?: 'EmailCampaignCustomListRecipientMinAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientMinOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  emailCampaignCustomListId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListRecipientOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListRecipientOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailCampaignCustomListRecipientOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  emailCampaignCustomList?: Maybe<EmailCampaignCustomListOrderByWithRelationInput>;
  emailCampaignCustomListId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmailCampaignCustomListRecipientOrderByRelevanceFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  Email = 'email',
  EmailCampaignCustomListId = 'emailCampaignCustomListId',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  Reason = 'reason'
}

export type EmailCampaignCustomListRecipientOrderByRelevanceInput = {
  fields: Array<EmailCampaignCustomListRecipientOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EmailCampaignCustomListRecipientOrderByWithAggregationInput = {
  _count?: Maybe<EmailCampaignCustomListRecipientCountOrderByAggregateInput>;
  _max?: Maybe<EmailCampaignCustomListRecipientMaxOrderByAggregateInput>;
  _min?: Maybe<EmailCampaignCustomListRecipientMinOrderByAggregateInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  emailCampaignCustomListId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListRecipientOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailCampaignCustomListRecipientOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  emailCampaignCustomList?: Maybe<EmailCampaignCustomListOrderByWithRelationInput>;
  emailCampaignCustomListId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListRecipientOrderByWithRelationInput = {
  _relevance?: Maybe<EmailCampaignCustomListRecipientOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  emailCampaignCustomList?: Maybe<EmailCampaignCustomListOrderByWithRelationInput>;
  emailCampaignCustomListId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmailCampaignCustomListRecipientScalarFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Email = 'email',
  EmailCampaignCustomListId = 'emailCampaignCustomListId',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  Reason = 'reason',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type EmailCampaignCustomListRecipientScalarWhereInput = {
  AND?: Maybe<Array<EmailCampaignCustomListRecipientScalarWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListRecipientScalarWhereInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListRecipientScalarWhereInput>>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  emailCampaignCustomListId?: Maybe<StringFilter>;
  firstName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  lastName?: Maybe<StringNullableFilter>;
  reason?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumEmailCampaignCustomListRecipientStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailCampaignCustomListRecipientScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EmailCampaignCustomListRecipientScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListRecipientScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListRecipientScalarWhereWithAggregatesInput>>;
  clinicPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  email?: Maybe<StringWithAggregatesFilter>;
  emailCampaignCustomListId?: Maybe<StringWithAggregatesFilter>;
  firstName?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  lastName?: Maybe<StringNullableWithAggregatesFilter>;
  reason?: Maybe<StringNullableWithAggregatesFilter>;
  status?: Maybe<EnumEmailCampaignCustomListRecipientStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum EmailCampaignCustomListRecipientStatus {
  Invalid = 'Invalid',
  Pending = 'Pending',
  Valid = 'Valid'
}

export type EmailCampaignCustomListRecipientUncheckedCreateInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailCampaignCustomListId: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCustomListRecipientCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailCampaignCustomListRecipientCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailCampaignCustomListRecipientCreateManyClinicPetParentInputEnvelope>;
};

export type EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutEmailCampaignCustomListInput = {
  connect?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCustomListRecipientCreateOrConnectWithoutEmailCampaignCustomListInput>>;
  create?: Maybe<Array<EmailCampaignCustomListRecipientCreateWithoutEmailCampaignCustomListInput>>;
  createMany?: Maybe<EmailCampaignCustomListRecipientCreateManyEmailCampaignCustomListInputEnvelope>;
};

export type EmailCampaignCustomListRecipientUncheckedCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailCampaignCustomListId: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUncheckedCreateWithoutEmailCampaignCustomListInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUncheckedUpdateInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUncheckedUpdateManyInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCustomListRecipientCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailCampaignCustomListRecipientCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailCampaignCustomListRecipientCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignCustomListRecipientScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignCustomListRecipientUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<EmailCampaignCustomListRecipientUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<EmailCampaignCustomListRecipientUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutEmailCampaignCustomListInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutEmailCampaignCustomListNestedInput = {
  connect?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCustomListRecipientCreateOrConnectWithoutEmailCampaignCustomListInput>>;
  create?: Maybe<Array<EmailCampaignCustomListRecipientCreateWithoutEmailCampaignCustomListInput>>;
  createMany?: Maybe<EmailCampaignCustomListRecipientCreateManyEmailCampaignCustomListInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignCustomListRecipientScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignCustomListRecipientUpdateWithWhereUniqueWithoutEmailCampaignCustomListInput>>;
  updateMany?: Maybe<Array<EmailCampaignCustomListRecipientUpdateManyWithWhereWithoutEmailCampaignCustomListInput>>;
  upsert?: Maybe<Array<EmailCampaignCustomListRecipientUpsertWithWhereUniqueWithoutEmailCampaignCustomListInput>>;
};

export type EmailCampaignCustomListRecipientUncheckedUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomListId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUncheckedUpdateWithoutEmailCampaignCustomListInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUpdateInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutEmailCampaignCustomListRecipientsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomList?: Maybe<EmailCampaignCustomListUpdateOneRequiredWithoutRecipientsNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: EmailCampaignCustomListRecipientUpdateManyMutationInput;
  where: EmailCampaignCustomListRecipientScalarWhereInput;
};

export type EmailCampaignCustomListRecipientUpdateManyWithWhereWithoutEmailCampaignCustomListInput = {
  data: EmailCampaignCustomListRecipientUpdateManyMutationInput;
  where: EmailCampaignCustomListRecipientScalarWhereInput;
};

export type EmailCampaignCustomListRecipientUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCustomListRecipientCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailCampaignCustomListRecipientCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailCampaignCustomListRecipientCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignCustomListRecipientScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignCustomListRecipientUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<EmailCampaignCustomListRecipientUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<EmailCampaignCustomListRecipientUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type EmailCampaignCustomListRecipientUpdateManyWithoutEmailCampaignCustomListNestedInput = {
  connect?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCustomListRecipientCreateOrConnectWithoutEmailCampaignCustomListInput>>;
  create?: Maybe<Array<EmailCampaignCustomListRecipientCreateWithoutEmailCampaignCustomListInput>>;
  createMany?: Maybe<EmailCampaignCustomListRecipientCreateManyEmailCampaignCustomListInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignCustomListRecipientScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignCustomListRecipientWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignCustomListRecipientUpdateWithWhereUniqueWithoutEmailCampaignCustomListInput>>;
  updateMany?: Maybe<Array<EmailCampaignCustomListRecipientUpdateManyWithWhereWithoutEmailCampaignCustomListInput>>;
  upsert?: Maybe<Array<EmailCampaignCustomListRecipientUpsertWithWhereUniqueWithoutEmailCampaignCustomListInput>>;
};

export type EmailCampaignCustomListRecipientUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: EmailCampaignCustomListRecipientUpdateWithoutClinicPetParentInput;
  where: EmailCampaignCustomListRecipientWhereUniqueInput;
};

export type EmailCampaignCustomListRecipientUpdateWithWhereUniqueWithoutEmailCampaignCustomListInput = {
  data: EmailCampaignCustomListRecipientUpdateWithoutEmailCampaignCustomListInput;
  where: EmailCampaignCustomListRecipientWhereUniqueInput;
};

export type EmailCampaignCustomListRecipientUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailCampaignCustomList?: Maybe<EmailCampaignCustomListUpdateOneRequiredWithoutRecipientsNestedInput>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUpdateWithoutEmailCampaignCustomListInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutEmailCampaignCustomListRecipientsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCampaignCustomListRecipientStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListRecipientUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: EmailCampaignCustomListRecipientCreateWithoutClinicPetParentInput;
  update: EmailCampaignCustomListRecipientUpdateWithoutClinicPetParentInput;
  where: EmailCampaignCustomListRecipientWhereUniqueInput;
};

export type EmailCampaignCustomListRecipientUpsertWithWhereUniqueWithoutEmailCampaignCustomListInput = {
  create: EmailCampaignCustomListRecipientCreateWithoutEmailCampaignCustomListInput;
  update: EmailCampaignCustomListRecipientUpdateWithoutEmailCampaignCustomListInput;
  where: EmailCampaignCustomListRecipientWhereUniqueInput;
};

export type EmailCampaignCustomListRecipientWhereInput = {
  AND?: Maybe<Array<EmailCampaignCustomListRecipientWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListRecipientWhereInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListRecipientWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  emailCampaignCustomList?: Maybe<EmailCampaignCustomListScalarRelationFilter>;
  emailCampaignCustomListId?: Maybe<StringFilter>;
  firstName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  lastName?: Maybe<StringNullableFilter>;
  reason?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumEmailCampaignCustomListRecipientStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailCampaignCustomListRecipientWhereUniqueInput = {
  AND?: Maybe<Array<EmailCampaignCustomListRecipientWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListRecipientWhereInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListRecipientWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  emailCampaignCustomList?: Maybe<EmailCampaignCustomListScalarRelationFilter>;
  emailCampaignCustomListId?: Maybe<StringFilter>;
  firstName?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<StringNullableFilter>;
  reason?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumEmailCampaignCustomListRecipientStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailCampaignCustomListResponse = {
  __typename?: 'EmailCampaignCustomListResponse';
  customList?: Maybe<EmailCampaignCustomList>;
  customListHistory?: Maybe<EmailCampaignCustomListUploadHistory>;
};

export enum EmailCampaignCustomListScalarFieldEnum {
  AwsFileKey = 'awsFileKey',
  CreatedAt = 'createdAt',
  EmailCampaignId = 'emailCampaignId',
  FileName = 'fileName',
  Id = 'id',
  InvalidRecipients = 'invalidRecipients',
  UpdatedAt = 'updatedAt',
  ValidRecipients = 'validRecipients'
}

export type EmailCampaignCustomListScalarRelationFilter = {
  AND?: Maybe<Array<EmailCampaignCustomListWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListWhereInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListWhereInput>>;
  awsFileKey?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaign?: Maybe<EmailCampaignScalarRelationFilter>;
  emailCampaignId?: Maybe<StringFilter>;
  fileName?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  invalidRecipients?: Maybe<IntFilter>;
  recipients?: Maybe<EmailCampaignCustomListRecipientListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  validRecipients?: Maybe<IntFilter>;
};

export type EmailCampaignCustomListScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EmailCampaignCustomListScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListScalarWhereWithAggregatesInput>>;
  awsFileKey?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  emailCampaignId?: Maybe<StringWithAggregatesFilter>;
  fileName?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  invalidRecipients?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  validRecipients?: Maybe<IntWithAggregatesFilter>;
};

export type EmailCampaignCustomListSumAggregateOutputType = {
  __typename?: 'EmailCampaignCustomListSumAggregateOutputType';
  invalidRecipients?: Maybe<Scalars['Int']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListSumOrderByAggregateInput = {
  invalidRecipients?: Maybe<SortOrder>;
  validRecipients?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListUncheckedCreateInput = {
  awsFileKey: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId: Scalars['String'];
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  recipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutEmailCampaignCustomListInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListUncheckedCreateNestedOneWithoutEmailCampaignInput = {
  connect?: Maybe<EmailCampaignCustomListWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCustomListCreateOrConnectWithoutEmailCampaignInput>;
  create?: Maybe<EmailCampaignCustomListCreateWithoutEmailCampaignInput>;
};

export type EmailCampaignCustomListUncheckedCreateWithoutEmailCampaignInput = {
  awsFileKey: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  recipients?: Maybe<EmailCampaignCustomListRecipientUncheckedCreateNestedManyWithoutEmailCampaignCustomListInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListUncheckedCreateWithoutRecipientsInput = {
  awsFileKey: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId: Scalars['String'];
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListUncheckedUpdateInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  recipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutEmailCampaignCustomListNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListUncheckedUpdateManyInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListUncheckedUpdateOneWithoutEmailCampaignNestedInput = {
  connect?: Maybe<EmailCampaignCustomListWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCustomListCreateOrConnectWithoutEmailCampaignInput>;
  create?: Maybe<EmailCampaignCustomListCreateWithoutEmailCampaignInput>;
  delete?: Maybe<EmailCampaignCustomListWhereInput>;
  disconnect?: Maybe<EmailCampaignCustomListWhereInput>;
  update?: Maybe<EmailCampaignCustomListUpdateToOneWithWhereWithoutEmailCampaignInput>;
  upsert?: Maybe<EmailCampaignCustomListUpsertWithoutEmailCampaignInput>;
};

export type EmailCampaignCustomListUncheckedUpdateWithoutEmailCampaignInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  recipients?: Maybe<EmailCampaignCustomListRecipientUncheckedUpdateManyWithoutEmailCampaignCustomListNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListUncheckedUpdateWithoutRecipientsInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListUpdateInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign?: Maybe<EmailCampaignUpdateOneRequiredWithoutCustomListNestedInput>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  recipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutEmailCampaignCustomListNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListUpdateManyMutationInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListUpdateOneRequiredWithoutRecipientsNestedInput = {
  connect?: Maybe<EmailCampaignCustomListWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCustomListCreateOrConnectWithoutRecipientsInput>;
  create?: Maybe<EmailCampaignCustomListCreateWithoutRecipientsInput>;
  update?: Maybe<EmailCampaignCustomListUpdateToOneWithWhereWithoutRecipientsInput>;
  upsert?: Maybe<EmailCampaignCustomListUpsertWithoutRecipientsInput>;
};

export type EmailCampaignCustomListUpdateOneWithoutEmailCampaignNestedInput = {
  connect?: Maybe<EmailCampaignCustomListWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCustomListCreateOrConnectWithoutEmailCampaignInput>;
  create?: Maybe<EmailCampaignCustomListCreateWithoutEmailCampaignInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<EmailCampaignCustomListUpdateToOneWithWhereWithoutEmailCampaignInput>;
  upsert?: Maybe<EmailCampaignCustomListUpsertWithoutEmailCampaignInput>;
};

export type EmailCampaignCustomListUpdateToOneWithWhereWithoutEmailCampaignInput = {
  data: EmailCampaignCustomListUpdateWithoutEmailCampaignInput;
  where?: Maybe<EmailCampaignCustomListWhereInput>;
};

export type EmailCampaignCustomListUpdateToOneWithWhereWithoutRecipientsInput = {
  data: EmailCampaignCustomListUpdateWithoutRecipientsInput;
  where?: Maybe<EmailCampaignCustomListWhereInput>;
};

export type EmailCampaignCustomListUpdateWithoutEmailCampaignInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  recipients?: Maybe<EmailCampaignCustomListRecipientUpdateManyWithoutEmailCampaignCustomListNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListUpdateWithoutRecipientsInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign?: Maybe<EmailCampaignUpdateOneRequiredWithoutCustomListNestedInput>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validRecipients?: Maybe<Scalars['Int']>;
};

export type EmailCampaignCustomListUploadHistory = {
  __typename?: 'EmailCampaignCustomListUploadHistory';
  awsFileKey: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  emailCampaign: EmailCampaign;
  emailCampaignId: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type EmailCampaignCustomListUploadHistoryCountAggregateOutputType = {
  __typename?: 'EmailCampaignCustomListUploadHistoryCountAggregateOutputType';
  _all: Scalars['Int'];
  awsFileKey: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  emailCampaignId: Scalars['Int'];
  expiresAt: Scalars['Int'];
  fileName: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type EmailCampaignCustomListUploadHistoryCountOrderByAggregateInput = {
  awsFileKey?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListUploadHistoryCreateInput = {
  awsFileKey: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign: EmailCampaignCreateNestedOneWithoutUploadsInput;
  expiresAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryCreateManyEmailCampaignInput = {
  awsFileKey: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryCreateManyEmailCampaignInputEnvelope = {
  data: Array<EmailCampaignCustomListUploadHistoryCreateManyEmailCampaignInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignCustomListUploadHistoryCreateManyInput = {
  awsFileKey: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryCreateNestedManyWithoutEmailCampaignInput = {
  connect?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCustomListUploadHistoryCreateOrConnectWithoutEmailCampaignInput>>;
  create?: Maybe<Array<EmailCampaignCustomListUploadHistoryCreateWithoutEmailCampaignInput>>;
  createMany?: Maybe<EmailCampaignCustomListUploadHistoryCreateManyEmailCampaignInputEnvelope>;
};

export type EmailCampaignCustomListUploadHistoryCreateOrConnectWithoutEmailCampaignInput = {
  create: EmailCampaignCustomListUploadHistoryCreateWithoutEmailCampaignInput;
  where: EmailCampaignCustomListUploadHistoryWhereUniqueInput;
};

export type EmailCampaignCustomListUploadHistoryCreateWithoutEmailCampaignInput = {
  awsFileKey: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryGroupByOutputType = {
  __typename?: 'EmailCampaignCustomListUploadHistoryGroupByOutputType';
  _count?: Maybe<EmailCampaignCustomListUploadHistoryCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignCustomListUploadHistoryMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignCustomListUploadHistoryMinAggregateOutputType>;
  awsFileKey: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  emailCampaignId: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type EmailCampaignCustomListUploadHistoryListRelationFilter = {
  every?: Maybe<EmailCampaignCustomListUploadHistoryWhereInput>;
  none?: Maybe<EmailCampaignCustomListUploadHistoryWhereInput>;
  some?: Maybe<EmailCampaignCustomListUploadHistoryWhereInput>;
};

export type EmailCampaignCustomListUploadHistoryMaxAggregateOutputType = {
  __typename?: 'EmailCampaignCustomListUploadHistoryMaxAggregateOutputType';
  awsFileKey?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryMaxOrderByAggregateInput = {
  awsFileKey?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListUploadHistoryMinAggregateOutputType = {
  __typename?: 'EmailCampaignCustomListUploadHistoryMinAggregateOutputType';
  awsFileKey?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryMinOrderByAggregateInput = {
  awsFileKey?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListUploadHistoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListUploadHistoryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailCampaignCustomListUploadHistoryOrderByRelevanceInput>;
  awsFileKey?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaign?: Maybe<EmailCampaignOrderByWithRelationInput>;
  emailCampaignId?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmailCampaignCustomListUploadHistoryOrderByRelevanceFieldEnum {
  AwsFileKey = 'awsFileKey',
  ClinicId = 'clinicId',
  EmailCampaignId = 'emailCampaignId',
  FileName = 'fileName',
  Id = 'id'
}

export type EmailCampaignCustomListUploadHistoryOrderByRelevanceInput = {
  fields: Array<EmailCampaignCustomListUploadHistoryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EmailCampaignCustomListUploadHistoryOrderByWithAggregationInput = {
  _count?: Maybe<EmailCampaignCustomListUploadHistoryCountOrderByAggregateInput>;
  _max?: Maybe<EmailCampaignCustomListUploadHistoryMaxOrderByAggregateInput>;
  _min?: Maybe<EmailCampaignCustomListUploadHistoryMinOrderByAggregateInput>;
  awsFileKey?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListUploadHistoryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailCampaignCustomListUploadHistoryOrderByRelevanceInput>;
  awsFileKey?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaign?: Maybe<EmailCampaignOrderByWithRelationInput>;
  emailCampaignId?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignCustomListUploadHistoryOrderByWithRelationInput = {
  _relevance?: Maybe<EmailCampaignCustomListUploadHistoryOrderByRelevanceInput>;
  awsFileKey?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaign?: Maybe<EmailCampaignOrderByWithRelationInput>;
  emailCampaignId?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  fileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmailCampaignCustomListUploadHistoryScalarFieldEnum {
  AwsFileKey = 'awsFileKey',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  EmailCampaignId = 'emailCampaignId',
  ExpiresAt = 'expiresAt',
  FileName = 'fileName',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type EmailCampaignCustomListUploadHistoryScalarWhereInput = {
  AND?: Maybe<Array<EmailCampaignCustomListUploadHistoryScalarWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListUploadHistoryScalarWhereInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListUploadHistoryScalarWhereInput>>;
  awsFileKey?: Maybe<StringFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaignId?: Maybe<StringFilter>;
  expiresAt?: Maybe<DateTimeFilter>;
  fileName?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailCampaignCustomListUploadHistoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EmailCampaignCustomListUploadHistoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListUploadHistoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListUploadHistoryScalarWhereWithAggregatesInput>>;
  awsFileKey?: Maybe<StringWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  emailCampaignId?: Maybe<StringWithAggregatesFilter>;
  expiresAt?: Maybe<DateTimeWithAggregatesFilter>;
  fileName?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type EmailCampaignCustomListUploadHistoryUncheckedCreateInput = {
  awsFileKey: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryUncheckedCreateNestedManyWithoutEmailCampaignInput = {
  connect?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCustomListUploadHistoryCreateOrConnectWithoutEmailCampaignInput>>;
  create?: Maybe<Array<EmailCampaignCustomListUploadHistoryCreateWithoutEmailCampaignInput>>;
  createMany?: Maybe<EmailCampaignCustomListUploadHistoryCreateManyEmailCampaignInputEnvelope>;
};

export type EmailCampaignCustomListUploadHistoryUncheckedCreateWithoutEmailCampaignInput = {
  awsFileKey: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryUncheckedUpdateInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryUncheckedUpdateManyInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryUncheckedUpdateManyWithoutEmailCampaignInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryUncheckedUpdateManyWithoutEmailCampaignNestedInput = {
  connect?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCustomListUploadHistoryCreateOrConnectWithoutEmailCampaignInput>>;
  create?: Maybe<Array<EmailCampaignCustomListUploadHistoryCreateWithoutEmailCampaignInput>>;
  createMany?: Maybe<EmailCampaignCustomListUploadHistoryCreateManyEmailCampaignInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignCustomListUploadHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignCustomListUploadHistoryUpdateWithWhereUniqueWithoutEmailCampaignInput>>;
  updateMany?: Maybe<Array<EmailCampaignCustomListUploadHistoryUpdateManyWithWhereWithoutEmailCampaignInput>>;
  upsert?: Maybe<Array<EmailCampaignCustomListUploadHistoryUpsertWithWhereUniqueWithoutEmailCampaignInput>>;
};

export type EmailCampaignCustomListUploadHistoryUncheckedUpdateWithoutEmailCampaignInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryUpdateInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign?: Maybe<EmailCampaignUpdateOneRequiredWithoutUploadsNestedInput>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryUpdateManyMutationInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryUpdateManyWithWhereWithoutEmailCampaignInput = {
  data: EmailCampaignCustomListUploadHistoryUpdateManyMutationInput;
  where: EmailCampaignCustomListUploadHistoryScalarWhereInput;
};

export type EmailCampaignCustomListUploadHistoryUpdateManyWithoutEmailCampaignNestedInput = {
  connect?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCustomListUploadHistoryCreateOrConnectWithoutEmailCampaignInput>>;
  create?: Maybe<Array<EmailCampaignCustomListUploadHistoryCreateWithoutEmailCampaignInput>>;
  createMany?: Maybe<EmailCampaignCustomListUploadHistoryCreateManyEmailCampaignInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignCustomListUploadHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignCustomListUploadHistoryUpdateWithWhereUniqueWithoutEmailCampaignInput>>;
  updateMany?: Maybe<Array<EmailCampaignCustomListUploadHistoryUpdateManyWithWhereWithoutEmailCampaignInput>>;
  upsert?: Maybe<Array<EmailCampaignCustomListUploadHistoryUpsertWithWhereUniqueWithoutEmailCampaignInput>>;
};

export type EmailCampaignCustomListUploadHistoryUpdateWithWhereUniqueWithoutEmailCampaignInput = {
  data: EmailCampaignCustomListUploadHistoryUpdateWithoutEmailCampaignInput;
  where: EmailCampaignCustomListUploadHistoryWhereUniqueInput;
};

export type EmailCampaignCustomListUploadHistoryUpdateWithoutEmailCampaignInput = {
  awsFileKey?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignCustomListUploadHistoryUpsertWithWhereUniqueWithoutEmailCampaignInput = {
  create: EmailCampaignCustomListUploadHistoryCreateWithoutEmailCampaignInput;
  update: EmailCampaignCustomListUploadHistoryUpdateWithoutEmailCampaignInput;
  where: EmailCampaignCustomListUploadHistoryWhereUniqueInput;
};

export type EmailCampaignCustomListUploadHistoryWhereInput = {
  AND?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereInput>>;
  awsFileKey?: Maybe<StringFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaign?: Maybe<EmailCampaignScalarRelationFilter>;
  emailCampaignId?: Maybe<StringFilter>;
  expiresAt?: Maybe<DateTimeFilter>;
  fileName?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailCampaignCustomListUploadHistoryWhereUniqueInput = {
  AND?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListUploadHistoryWhereInput>>;
  awsFileKey?: Maybe<StringFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaign?: Maybe<EmailCampaignScalarRelationFilter>;
  emailCampaignId?: Maybe<StringFilter>;
  expiresAt?: Maybe<DateTimeFilter>;
  fileName?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailCampaignCustomListUpsertWithoutEmailCampaignInput = {
  create: EmailCampaignCustomListCreateWithoutEmailCampaignInput;
  update: EmailCampaignCustomListUpdateWithoutEmailCampaignInput;
  where?: Maybe<EmailCampaignCustomListWhereInput>;
};

export type EmailCampaignCustomListUpsertWithoutRecipientsInput = {
  create: EmailCampaignCustomListCreateWithoutRecipientsInput;
  update: EmailCampaignCustomListUpdateWithoutRecipientsInput;
  where?: Maybe<EmailCampaignCustomListWhereInput>;
};

export type EmailCampaignCustomListUrlInput = {
  emailCampaignId?: Maybe<Scalars['String']>;
  historicalUploadId?: Maybe<Scalars['String']>;
};

export type EmailCampaignCustomListWhereInput = {
  AND?: Maybe<Array<EmailCampaignCustomListWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListWhereInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListWhereInput>>;
  awsFileKey?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaign?: Maybe<EmailCampaignScalarRelationFilter>;
  emailCampaignId?: Maybe<StringFilter>;
  fileName?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  invalidRecipients?: Maybe<IntFilter>;
  recipients?: Maybe<EmailCampaignCustomListRecipientListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  validRecipients?: Maybe<IntFilter>;
};

export type EmailCampaignCustomListWhereUniqueInput = {
  AND?: Maybe<Array<EmailCampaignCustomListWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignCustomListWhereInput>>;
  OR?: Maybe<Array<EmailCampaignCustomListWhereInput>>;
  awsFileKey?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaign?: Maybe<EmailCampaignScalarRelationFilter>;
  emailCampaignId?: Maybe<Scalars['String']>;
  fileName?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  invalidRecipients?: Maybe<IntFilter>;
  recipients?: Maybe<EmailCampaignCustomListRecipientListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  validRecipients?: Maybe<IntFilter>;
};

export type EmailCampaignGroupByOutputType = {
  __typename?: 'EmailCampaignGroupByOutputType';
  _avg?: Maybe<EmailCampaignAvgAggregateOutputType>;
  _count?: Maybe<EmailCampaignCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignMinAggregateOutputType>;
  _sum?: Maybe<EmailCampaignSumAggregateOutputType>;
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from: Scalars['String'];
  htmlContent?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType: EmailCampaignSegmentationType;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status: EmailCampaignStatus;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type: EmailCampaignType;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignListRelationFilter = {
  every?: Maybe<EmailCampaignWhereInput>;
  none?: Maybe<EmailCampaignWhereInput>;
  some?: Maybe<EmailCampaignWhereInput>;
};

export type EmailCampaignLog = {
  __typename?: 'EmailCampaignLog';
  action: EmailCampaignLogAction;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  emailCampaign: EmailCampaign;
  emailCampaignId: Scalars['String'];
  emailCampaignType: EmailCampaignType;
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  provider: EmailProvider;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variant?: Maybe<Scalars['String']>;
};

export enum EmailCampaignLogAction {
  Error = 'Error',
  Sent = 'Sent',
  Skipped = 'Skipped'
}

export type EmailCampaignLogCountAggregateOutputType = {
  __typename?: 'EmailCampaignLogCountAggregateOutputType';
  _all: Scalars['Int'];
  action: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  emailCampaignId: Scalars['Int'];
  emailCampaignType: Scalars['Int'];
  error: Scalars['Int'];
  id: Scalars['Int'];
  provider: Scalars['Int'];
  providerTransactionId: Scalars['Int'];
  skipReason: Scalars['Int'];
  targetEmail: Scalars['Int'];
  updatedAt: Scalars['Int'];
  variant: Scalars['Int'];
};

export type EmailCampaignLogCountOrderByAggregateInput = {
  action?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  emailCampaignType?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerTransactionId?: Maybe<SortOrder>;
  skipReason?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  variant?: Maybe<SortOrder>;
};

export type EmailCampaignLogCreateInput = {
  action: EmailCampaignLogAction;
  clinic: ClinicCreateNestedOneWithoutEmailCampaignLogInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutEmailCampaignLogInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign: EmailCampaignCreateNestedOneWithoutEmailCampaignLogsInput;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogCreateManyClinicInput = {
  action: EmailCampaignLogAction;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId: Scalars['String'];
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogCreateManyClinicInputEnvelope = {
  data: Array<EmailCampaignLogCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignLogCreateManyClinicPetParentInput = {
  action: EmailCampaignLogAction;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId: Scalars['String'];
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogCreateManyClinicPetParentInputEnvelope = {
  data: Array<EmailCampaignLogCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignLogCreateManyEmailCampaignInput = {
  action: EmailCampaignLogAction;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogCreateManyEmailCampaignInputEnvelope = {
  data: Array<EmailCampaignLogCreateManyEmailCampaignInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignLogCreateManyInput = {
  action: EmailCampaignLogAction;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId: Scalars['String'];
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignLogCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignLogCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignLogCreateManyClinicInputEnvelope>;
};

export type EmailCampaignLogCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignLogCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailCampaignLogCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailCampaignLogCreateManyClinicPetParentInputEnvelope>;
};

export type EmailCampaignLogCreateNestedManyWithoutEmailCampaignInput = {
  connect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignLogCreateOrConnectWithoutEmailCampaignInput>>;
  create?: Maybe<Array<EmailCampaignLogCreateWithoutEmailCampaignInput>>;
  createMany?: Maybe<EmailCampaignLogCreateManyEmailCampaignInputEnvelope>;
};

export type EmailCampaignLogCreateOrConnectWithoutClinicInput = {
  create: EmailCampaignLogCreateWithoutClinicInput;
  where: EmailCampaignLogWhereUniqueInput;
};

export type EmailCampaignLogCreateOrConnectWithoutClinicPetParentInput = {
  create: EmailCampaignLogCreateWithoutClinicPetParentInput;
  where: EmailCampaignLogWhereUniqueInput;
};

export type EmailCampaignLogCreateOrConnectWithoutEmailCampaignInput = {
  create: EmailCampaignLogCreateWithoutEmailCampaignInput;
  where: EmailCampaignLogWhereUniqueInput;
};

export type EmailCampaignLogCreateWithoutClinicInput = {
  action: EmailCampaignLogAction;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutEmailCampaignLogInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign: EmailCampaignCreateNestedOneWithoutEmailCampaignLogsInput;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogCreateWithoutClinicPetParentInput = {
  action: EmailCampaignLogAction;
  clinic: ClinicCreateNestedOneWithoutEmailCampaignLogInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign: EmailCampaignCreateNestedOneWithoutEmailCampaignLogsInput;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogCreateWithoutEmailCampaignInput = {
  action: EmailCampaignLogAction;
  clinic: ClinicCreateNestedOneWithoutEmailCampaignLogInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutEmailCampaignLogInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogGroupByOutputType = {
  __typename?: 'EmailCampaignLogGroupByOutputType';
  _count?: Maybe<EmailCampaignLogCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignLogMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignLogMinAggregateOutputType>;
  action: EmailCampaignLogAction;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  emailCampaignId: Scalars['String'];
  emailCampaignType: EmailCampaignType;
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  provider: EmailProvider;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogListRelationFilter = {
  every?: Maybe<EmailCampaignLogWhereInput>;
  none?: Maybe<EmailCampaignLogWhereInput>;
  some?: Maybe<EmailCampaignLogWhereInput>;
};

export type EmailCampaignLogMaxAggregateOutputType = {
  __typename?: 'EmailCampaignLogMaxAggregateOutputType';
  action?: Maybe<EmailCampaignLogAction>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogMaxOrderByAggregateInput = {
  action?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  emailCampaignType?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerTransactionId?: Maybe<SortOrder>;
  skipReason?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  variant?: Maybe<SortOrder>;
};

export type EmailCampaignLogMinAggregateOutputType = {
  __typename?: 'EmailCampaignLogMinAggregateOutputType';
  action?: Maybe<EmailCampaignLogAction>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogMinOrderByAggregateInput = {
  action?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  emailCampaignType?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerTransactionId?: Maybe<SortOrder>;
  skipReason?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  variant?: Maybe<SortOrder>;
};

export type EmailCampaignLogOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EmailCampaignLogOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailCampaignLogOrderByRelevanceInput>;
  action?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaign?: Maybe<EmailCampaignOrderByWithRelationInput>;
  emailCampaignId?: Maybe<SortOrder>;
  emailCampaignType?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerTransactionId?: Maybe<SortOrder>;
  skipReason?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  variant?: Maybe<SortOrder>;
};

export enum EmailCampaignLogOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  EmailCampaignId = 'emailCampaignId',
  Error = 'error',
  Id = 'id',
  ProviderTransactionId = 'providerTransactionId',
  TargetEmail = 'targetEmail',
  Variant = 'variant'
}

export type EmailCampaignLogOrderByRelevanceInput = {
  fields: Array<EmailCampaignLogOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EmailCampaignLogOrderByWithAggregationInput = {
  _count?: Maybe<EmailCampaignLogCountOrderByAggregateInput>;
  _max?: Maybe<EmailCampaignLogMaxOrderByAggregateInput>;
  _min?: Maybe<EmailCampaignLogMinOrderByAggregateInput>;
  action?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  emailCampaignType?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerTransactionId?: Maybe<SortOrder>;
  skipReason?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  variant?: Maybe<SortOrder>;
};

export type EmailCampaignLogOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailCampaignLogOrderByRelevanceInput>;
  action?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaign?: Maybe<EmailCampaignOrderByWithRelationInput>;
  emailCampaignId?: Maybe<SortOrder>;
  emailCampaignType?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerTransactionId?: Maybe<SortOrder>;
  skipReason?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  variant?: Maybe<SortOrder>;
};

export type EmailCampaignLogOrderByWithRelationInput = {
  _relevance?: Maybe<EmailCampaignLogOrderByRelevanceInput>;
  action?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaign?: Maybe<EmailCampaignOrderByWithRelationInput>;
  emailCampaignId?: Maybe<SortOrder>;
  emailCampaignType?: Maybe<SortOrder>;
  error?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerTransactionId?: Maybe<SortOrder>;
  skipReason?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  variant?: Maybe<SortOrder>;
};

export enum EmailCampaignLogScalarFieldEnum {
  Action = 'action',
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  EmailCampaignId = 'emailCampaignId',
  EmailCampaignType = 'emailCampaignType',
  Error = 'error',
  Id = 'id',
  Provider = 'provider',
  ProviderTransactionId = 'providerTransactionId',
  SkipReason = 'skipReason',
  TargetEmail = 'targetEmail',
  UpdatedAt = 'updatedAt',
  Variant = 'variant'
}

export type EmailCampaignLogScalarWhereInput = {
  AND?: Maybe<Array<EmailCampaignLogScalarWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignLogScalarWhereInput>>;
  OR?: Maybe<Array<EmailCampaignLogScalarWhereInput>>;
  action?: Maybe<EnumEmailCampaignLogActionFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaignId?: Maybe<StringFilter>;
  emailCampaignType?: Maybe<EnumEmailCampaignTypeFilter>;
  error?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  provider?: Maybe<EnumEmailProviderFilter>;
  providerTransactionId?: Maybe<StringNullableFilter>;
  skipReason?: Maybe<EnumEmailCampaignLogSkipReasonNullableFilter>;
  targetEmail?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  variant?: Maybe<StringNullableFilter>;
};

export type EmailCampaignLogScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EmailCampaignLogScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EmailCampaignLogScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EmailCampaignLogScalarWhereWithAggregatesInput>>;
  action?: Maybe<EnumEmailCampaignLogActionWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  emailCampaignId?: Maybe<StringWithAggregatesFilter>;
  emailCampaignType?: Maybe<EnumEmailCampaignTypeWithAggregatesFilter>;
  error?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  provider?: Maybe<EnumEmailProviderWithAggregatesFilter>;
  providerTransactionId?: Maybe<StringNullableWithAggregatesFilter>;
  skipReason?: Maybe<EnumEmailCampaignLogSkipReasonNullableWithAggregatesFilter>;
  targetEmail?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  variant?: Maybe<StringNullableWithAggregatesFilter>;
};

export enum EmailCampaignLogSkipReason {
  InvalidEmail = 'InvalidEmail',
  Suppressed = 'Suppressed',
  Unsubscribed = 'Unsubscribed'
}

export type EmailCampaignLogUncheckedCreateInput = {
  action: EmailCampaignLogAction;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId: Scalars['String'];
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignLogCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignLogCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignLogCreateManyClinicInputEnvelope>;
};

export type EmailCampaignLogUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignLogCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailCampaignLogCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailCampaignLogCreateManyClinicPetParentInputEnvelope>;
};

export type EmailCampaignLogUncheckedCreateNestedManyWithoutEmailCampaignInput = {
  connect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignLogCreateOrConnectWithoutEmailCampaignInput>>;
  create?: Maybe<Array<EmailCampaignLogCreateWithoutEmailCampaignInput>>;
  createMany?: Maybe<EmailCampaignLogCreateManyEmailCampaignInputEnvelope>;
};

export type EmailCampaignLogUncheckedCreateWithoutClinicInput = {
  action: EmailCampaignLogAction;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId: Scalars['String'];
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUncheckedCreateWithoutClinicPetParentInput = {
  action: EmailCampaignLogAction;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId: Scalars['String'];
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUncheckedCreateWithoutEmailCampaignInput = {
  action: EmailCampaignLogAction;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUncheckedUpdateInput = {
  action?: Maybe<EmailCampaignLogAction>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUncheckedUpdateManyInput = {
  action?: Maybe<EmailCampaignLogAction>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUncheckedUpdateManyWithoutClinicInput = {
  action?: Maybe<EmailCampaignLogAction>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignLogCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignLogCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignLogCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignLogScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignLogUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<EmailCampaignLogUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<EmailCampaignLogUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentInput = {
  action?: Maybe<EmailCampaignLogAction>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignLogCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailCampaignLogCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailCampaignLogCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignLogScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignLogUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<EmailCampaignLogUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<EmailCampaignLogUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type EmailCampaignLogUncheckedUpdateManyWithoutEmailCampaignInput = {
  action?: Maybe<EmailCampaignLogAction>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUncheckedUpdateManyWithoutEmailCampaignNestedInput = {
  connect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignLogCreateOrConnectWithoutEmailCampaignInput>>;
  create?: Maybe<Array<EmailCampaignLogCreateWithoutEmailCampaignInput>>;
  createMany?: Maybe<EmailCampaignLogCreateManyEmailCampaignInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignLogScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignLogUpdateWithWhereUniqueWithoutEmailCampaignInput>>;
  updateMany?: Maybe<Array<EmailCampaignLogUpdateManyWithWhereWithoutEmailCampaignInput>>;
  upsert?: Maybe<Array<EmailCampaignLogUpsertWithWhereUniqueWithoutEmailCampaignInput>>;
};

export type EmailCampaignLogUncheckedUpdateWithoutClinicInput = {
  action?: Maybe<EmailCampaignLogAction>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUncheckedUpdateWithoutClinicPetParentInput = {
  action?: Maybe<EmailCampaignLogAction>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUncheckedUpdateWithoutEmailCampaignInput = {
  action?: Maybe<EmailCampaignLogAction>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUpdateInput = {
  action?: Maybe<EmailCampaignLogAction>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignLogNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutEmailCampaignLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign?: Maybe<EmailCampaignUpdateOneRequiredWithoutEmailCampaignLogsNestedInput>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUpdateManyMutationInput = {
  action?: Maybe<EmailCampaignLogAction>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUpdateManyWithWhereWithoutClinicInput = {
  data: EmailCampaignLogUpdateManyMutationInput;
  where: EmailCampaignLogScalarWhereInput;
};

export type EmailCampaignLogUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: EmailCampaignLogUpdateManyMutationInput;
  where: EmailCampaignLogScalarWhereInput;
};

export type EmailCampaignLogUpdateManyWithWhereWithoutEmailCampaignInput = {
  data: EmailCampaignLogUpdateManyMutationInput;
  where: EmailCampaignLogScalarWhereInput;
};

export type EmailCampaignLogUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignLogCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignLogCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignLogCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignLogScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignLogUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<EmailCampaignLogUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<EmailCampaignLogUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type EmailCampaignLogUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignLogCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailCampaignLogCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailCampaignLogCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignLogScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignLogUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<EmailCampaignLogUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<EmailCampaignLogUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type EmailCampaignLogUpdateManyWithoutEmailCampaignNestedInput = {
  connect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignLogCreateOrConnectWithoutEmailCampaignInput>>;
  create?: Maybe<Array<EmailCampaignLogCreateWithoutEmailCampaignInput>>;
  createMany?: Maybe<EmailCampaignLogCreateManyEmailCampaignInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignLogScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignLogWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignLogUpdateWithWhereUniqueWithoutEmailCampaignInput>>;
  updateMany?: Maybe<Array<EmailCampaignLogUpdateManyWithWhereWithoutEmailCampaignInput>>;
  upsert?: Maybe<Array<EmailCampaignLogUpsertWithWhereUniqueWithoutEmailCampaignInput>>;
};

export type EmailCampaignLogUpdateWithWhereUniqueWithoutClinicInput = {
  data: EmailCampaignLogUpdateWithoutClinicInput;
  where: EmailCampaignLogWhereUniqueInput;
};

export type EmailCampaignLogUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: EmailCampaignLogUpdateWithoutClinicPetParentInput;
  where: EmailCampaignLogWhereUniqueInput;
};

export type EmailCampaignLogUpdateWithWhereUniqueWithoutEmailCampaignInput = {
  data: EmailCampaignLogUpdateWithoutEmailCampaignInput;
  where: EmailCampaignLogWhereUniqueInput;
};

export type EmailCampaignLogUpdateWithoutClinicInput = {
  action?: Maybe<EmailCampaignLogAction>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutEmailCampaignLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign?: Maybe<EmailCampaignUpdateOneRequiredWithoutEmailCampaignLogsNestedInput>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUpdateWithoutClinicPetParentInput = {
  action?: Maybe<EmailCampaignLogAction>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign?: Maybe<EmailCampaignUpdateOneRequiredWithoutEmailCampaignLogsNestedInput>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUpdateWithoutEmailCampaignInput = {
  action?: Maybe<EmailCampaignLogAction>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignLogNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutEmailCampaignLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignType?: Maybe<EmailCampaignType>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerTransactionId?: Maybe<Scalars['String']>;
  skipReason?: Maybe<EmailCampaignLogSkipReason>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type EmailCampaignLogUpsertWithWhereUniqueWithoutClinicInput = {
  create: EmailCampaignLogCreateWithoutClinicInput;
  update: EmailCampaignLogUpdateWithoutClinicInput;
  where: EmailCampaignLogWhereUniqueInput;
};

export type EmailCampaignLogUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: EmailCampaignLogCreateWithoutClinicPetParentInput;
  update: EmailCampaignLogUpdateWithoutClinicPetParentInput;
  where: EmailCampaignLogWhereUniqueInput;
};

export type EmailCampaignLogUpsertWithWhereUniqueWithoutEmailCampaignInput = {
  create: EmailCampaignLogCreateWithoutEmailCampaignInput;
  update: EmailCampaignLogUpdateWithoutEmailCampaignInput;
  where: EmailCampaignLogWhereUniqueInput;
};

export type EmailCampaignLogWhereInput = {
  AND?: Maybe<Array<EmailCampaignLogWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignLogWhereInput>>;
  OR?: Maybe<Array<EmailCampaignLogWhereInput>>;
  action?: Maybe<EnumEmailCampaignLogActionFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaign?: Maybe<EmailCampaignScalarRelationFilter>;
  emailCampaignId?: Maybe<StringFilter>;
  emailCampaignType?: Maybe<EnumEmailCampaignTypeFilter>;
  error?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  provider?: Maybe<EnumEmailProviderFilter>;
  providerTransactionId?: Maybe<StringNullableFilter>;
  skipReason?: Maybe<EnumEmailCampaignLogSkipReasonNullableFilter>;
  targetEmail?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  variant?: Maybe<StringNullableFilter>;
};

export type EmailCampaignLogWhereUniqueInput = {
  AND?: Maybe<Array<EmailCampaignLogWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignLogWhereInput>>;
  OR?: Maybe<Array<EmailCampaignLogWhereInput>>;
  action?: Maybe<EnumEmailCampaignLogActionFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaign?: Maybe<EmailCampaignScalarRelationFilter>;
  emailCampaignId?: Maybe<StringFilter>;
  emailCampaignType?: Maybe<EnumEmailCampaignTypeFilter>;
  error?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EnumEmailProviderFilter>;
  providerTransactionId?: Maybe<StringNullableFilter>;
  skipReason?: Maybe<EnumEmailCampaignLogSkipReasonNullableFilter>;
  targetEmail?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  variant?: Maybe<StringNullableFilter>;
};

export type EmailCampaignMaxAggregateOutputType = {
  __typename?: 'EmailCampaignMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  from?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  replyTo?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  segmentationType?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  totalSegmentContacts?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type EmailCampaignMinAggregateOutputType = {
  __typename?: 'EmailCampaignMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  from?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  replyTo?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  segmentationType?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  totalSegmentContacts?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type EmailCampaignNullableScalarRelationFilter = {
  AND?: Maybe<Array<EmailCampaignWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignWhereInput>>;
  OR?: Maybe<Array<EmailCampaignWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  contexts?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUser?: Maybe<UserNullableScalarRelationFilter>;
  createdByUserId?: Maybe<StringNullableFilter>;
  customList?: Maybe<EmailCampaignCustomListNullableScalarRelationFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  emailCampaignLogs?: Maybe<EmailCampaignLogListRelationFilter>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeListRelationFilter>;
  from?: Maybe<StringFilter>;
  htmlContent?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informCampaignExecution?: Maybe<InformCampaignExecutionNullableScalarRelationFilter>;
  informCampaignExecutionId?: Maybe<StringNullableFilter>;
  lastUpdatedByUser?: Maybe<UserNullableScalarRelationFilter>;
  latUpdatedByUserId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  replyTo?: Maybe<StringNullableFilter>;
  replyToJson?: Maybe<JsonNullableFilter>;
  scheduledAt?: Maybe<DateTimeNullableFilter>;
  segmentArgs?: Maybe<JsonNullableFilter>;
  segmentWhere?: Maybe<JsonNullableFilter>;
  segmentationDefinition?: Maybe<JsonNullableFilter>;
  segmentationType?: Maybe<EnumEmailCampaignSegmentationTypeFilter>;
  sentByUser?: Maybe<UserNullableScalarRelationFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeNullableFilter>;
  startsAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumEmailCampaignStatusFilter>;
  subject?: Maybe<StringNullableFilter>;
  totalSegmentContacts?: Maybe<IntNullableFilter>;
  type?: Maybe<EnumEmailCampaignTypeFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryListRelationFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type EmailCampaignOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EmailCampaignOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailCampaignOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  contexts?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUser?: Maybe<UserOrderByWithRelationInput>;
  createdByUserId?: Maybe<SortOrder>;
  customList?: Maybe<EmailCampaignCustomListOrderByWithRelationInput>;
  deletedAt?: Maybe<SortOrder>;
  emailCampaignLogs?: Maybe<EmailCampaignLogOrderByRelationAggregateInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeOrderByRelationAggregateInput>;
  from?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignExecution?: Maybe<InformCampaignExecutionOrderByWithRelationInput>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  lastUpdatedByUser?: Maybe<UserOrderByWithRelationInput>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  replyTo?: Maybe<SortOrder>;
  replyToJson?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  segmentArgs?: Maybe<SortOrder>;
  segmentWhere?: Maybe<SortOrder>;
  segmentationDefinition?: Maybe<SortOrder>;
  segmentationType?: Maybe<SortOrder>;
  sentByUser?: Maybe<UserOrderByWithRelationInput>;
  sentByUserId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  totalSegmentContacts?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryOrderByRelationAggregateInput>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum EmailCampaignOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  CreatedByUserId = 'createdByUserId',
  From = 'from',
  HtmlContent = 'htmlContent',
  Id = 'id',
  InformCampaignExecutionId = 'informCampaignExecutionId',
  LatUpdatedByUserId = 'latUpdatedByUserId',
  Name = 'name',
  ReplyTo = 'replyTo',
  SentByUserId = 'sentByUserId',
  Subject = 'subject',
  UserId = 'userId'
}

export type EmailCampaignOrderByRelevanceInput = {
  fields: Array<EmailCampaignOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EmailCampaignOrderByWithAggregationInput = {
  _avg?: Maybe<EmailCampaignAvgOrderByAggregateInput>;
  _count?: Maybe<EmailCampaignCountOrderByAggregateInput>;
  _max?: Maybe<EmailCampaignMaxOrderByAggregateInput>;
  _min?: Maybe<EmailCampaignMinOrderByAggregateInput>;
  _sum?: Maybe<EmailCampaignSumOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  contexts?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  from?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  replyTo?: Maybe<SortOrder>;
  replyToJson?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  segmentArgs?: Maybe<SortOrder>;
  segmentWhere?: Maybe<SortOrder>;
  segmentationDefinition?: Maybe<SortOrder>;
  segmentationType?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  totalSegmentContacts?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type EmailCampaignOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailCampaignOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  contexts?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUser?: Maybe<UserOrderByWithRelationInput>;
  createdByUserId?: Maybe<SortOrder>;
  customList?: Maybe<EmailCampaignCustomListOrderByWithRelationInput>;
  deletedAt?: Maybe<SortOrder>;
  emailCampaignLogs?: Maybe<EmailCampaignLogOrderByRelationAggregateInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeOrderByRelationAggregateInput>;
  from?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignExecution?: Maybe<InformCampaignExecutionOrderByWithRelationInput>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  lastUpdatedByUser?: Maybe<UserOrderByWithRelationInput>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  replyTo?: Maybe<SortOrder>;
  replyToJson?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  segmentArgs?: Maybe<SortOrder>;
  segmentWhere?: Maybe<SortOrder>;
  segmentationDefinition?: Maybe<SortOrder>;
  segmentationType?: Maybe<SortOrder>;
  sentByUser?: Maybe<UserOrderByWithRelationInput>;
  sentByUserId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  totalSegmentContacts?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryOrderByRelationAggregateInput>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type EmailCampaignOrderByWithRelationInput = {
  _relevance?: Maybe<EmailCampaignOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  contexts?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUser?: Maybe<UserOrderByWithRelationInput>;
  createdByUserId?: Maybe<SortOrder>;
  customList?: Maybe<EmailCampaignCustomListOrderByWithRelationInput>;
  deletedAt?: Maybe<SortOrder>;
  emailCampaignLogs?: Maybe<EmailCampaignLogOrderByRelationAggregateInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeOrderByRelationAggregateInput>;
  from?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignExecution?: Maybe<InformCampaignExecutionOrderByWithRelationInput>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  lastUpdatedByUser?: Maybe<UserOrderByWithRelationInput>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  replyTo?: Maybe<SortOrder>;
  replyToJson?: Maybe<SortOrder>;
  scheduledAt?: Maybe<SortOrder>;
  segmentArgs?: Maybe<SortOrder>;
  segmentWhere?: Maybe<SortOrder>;
  segmentationDefinition?: Maybe<SortOrder>;
  segmentationType?: Maybe<SortOrder>;
  sentByUser?: Maybe<UserOrderByWithRelationInput>;
  sentByUserId?: Maybe<SortOrder>;
  startedAt?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  totalSegmentContacts?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryOrderByRelationAggregateInput>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum EmailCampaignScalarFieldEnum {
  ClinicId = 'clinicId',
  CompletedAt = 'completedAt',
  Contexts = 'contexts',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  DeletedAt = 'deletedAt',
  From = 'from',
  HtmlContent = 'htmlContent',
  Id = 'id',
  InformCampaignExecutionId = 'informCampaignExecutionId',
  LatUpdatedByUserId = 'latUpdatedByUserId',
  Name = 'name',
  ReplyTo = 'replyTo',
  ReplyToJson = 'replyToJson',
  ScheduledAt = 'scheduledAt',
  SegmentArgs = 'segmentArgs',
  SegmentWhere = 'segmentWhere',
  SegmentationDefinition = 'segmentationDefinition',
  SegmentationType = 'segmentationType',
  SentByUserId = 'sentByUserId',
  StartedAt = 'startedAt',
  StartsAt = 'startsAt',
  Status = 'status',
  Subject = 'subject',
  TotalSegmentContacts = 'totalSegmentContacts',
  Type = 'type',
  UnlayerJson = 'unlayerJson',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type EmailCampaignScalarRelationFilter = {
  AND?: Maybe<Array<EmailCampaignWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignWhereInput>>;
  OR?: Maybe<Array<EmailCampaignWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  contexts?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUser?: Maybe<UserNullableScalarRelationFilter>;
  createdByUserId?: Maybe<StringNullableFilter>;
  customList?: Maybe<EmailCampaignCustomListNullableScalarRelationFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  emailCampaignLogs?: Maybe<EmailCampaignLogListRelationFilter>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeListRelationFilter>;
  from?: Maybe<StringFilter>;
  htmlContent?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informCampaignExecution?: Maybe<InformCampaignExecutionNullableScalarRelationFilter>;
  informCampaignExecutionId?: Maybe<StringNullableFilter>;
  lastUpdatedByUser?: Maybe<UserNullableScalarRelationFilter>;
  latUpdatedByUserId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  replyTo?: Maybe<StringNullableFilter>;
  replyToJson?: Maybe<JsonNullableFilter>;
  scheduledAt?: Maybe<DateTimeNullableFilter>;
  segmentArgs?: Maybe<JsonNullableFilter>;
  segmentWhere?: Maybe<JsonNullableFilter>;
  segmentationDefinition?: Maybe<JsonNullableFilter>;
  segmentationType?: Maybe<EnumEmailCampaignSegmentationTypeFilter>;
  sentByUser?: Maybe<UserNullableScalarRelationFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeNullableFilter>;
  startsAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumEmailCampaignStatusFilter>;
  subject?: Maybe<StringNullableFilter>;
  totalSegmentContacts?: Maybe<IntNullableFilter>;
  type?: Maybe<EnumEmailCampaignTypeFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryListRelationFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type EmailCampaignScalarWhereInput = {
  AND?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  OR?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  contexts?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUserId?: Maybe<StringNullableFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  from?: Maybe<StringFilter>;
  htmlContent?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informCampaignExecutionId?: Maybe<StringNullableFilter>;
  latUpdatedByUserId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  replyTo?: Maybe<StringNullableFilter>;
  replyToJson?: Maybe<JsonNullableFilter>;
  scheduledAt?: Maybe<DateTimeNullableFilter>;
  segmentArgs?: Maybe<JsonNullableFilter>;
  segmentWhere?: Maybe<JsonNullableFilter>;
  segmentationDefinition?: Maybe<JsonNullableFilter>;
  segmentationType?: Maybe<EnumEmailCampaignSegmentationTypeFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeNullableFilter>;
  startsAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumEmailCampaignStatusFilter>;
  subject?: Maybe<StringNullableFilter>;
  totalSegmentContacts?: Maybe<IntNullableFilter>;
  type?: Maybe<EnumEmailCampaignTypeFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type EmailCampaignScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EmailCampaignScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EmailCampaignScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EmailCampaignScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  completedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  contexts?: Maybe<JsonNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  createdByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  from?: Maybe<StringWithAggregatesFilter>;
  htmlContent?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informCampaignExecutionId?: Maybe<StringNullableWithAggregatesFilter>;
  latUpdatedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  replyTo?: Maybe<StringNullableWithAggregatesFilter>;
  replyToJson?: Maybe<JsonNullableWithAggregatesFilter>;
  scheduledAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  segmentArgs?: Maybe<JsonNullableWithAggregatesFilter>;
  segmentWhere?: Maybe<JsonNullableWithAggregatesFilter>;
  segmentationDefinition?: Maybe<JsonNullableWithAggregatesFilter>;
  segmentationType?: Maybe<EnumEmailCampaignSegmentationTypeWithAggregatesFilter>;
  sentByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  startedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  startsAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  status?: Maybe<EnumEmailCampaignStatusWithAggregatesFilter>;
  subject?: Maybe<StringNullableWithAggregatesFilter>;
  totalSegmentContacts?: Maybe<IntNullableWithAggregatesFilter>;
  type?: Maybe<EnumEmailCampaignTypeWithAggregatesFilter>;
  unlayerJson?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userId?: Maybe<StringNullableWithAggregatesFilter>;
};

export enum EmailCampaignSegmentationType {
  AllActiveClients = 'AllActiveClients',
  ClinicPetParentPrismaWhere = 'ClinicPetParentPrismaWhere',
  ClinicPetParentRawSql = 'ClinicPetParentRawSql',
  CustomList = 'CustomList'
}

export enum EmailCampaignStatus {
  Cancelled = 'Cancelled',
  Draft = 'Draft',
  Scheduled = 'Scheduled',
  Sending = 'Sending',
  Sent = 'Sent'
}

export type EmailCampaignSumAggregateOutputType = {
  __typename?: 'EmailCampaignSumAggregateOutputType';
  totalSegmentContacts?: Maybe<Scalars['Int']>;
};

export type EmailCampaignSumOrderByAggregateInput = {
  totalSegmentContacts?: Maybe<SortOrder>;
};

export type EmailCampaignTemplate = {
  __typename?: 'EmailCampaignTemplate';
  User?: Maybe<User>;
  _count: EmailCampaignTemplateCountOutputType;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags: Array<FeatureFlag>;
  htmlContent: Scalars['String'];
  id: Scalars['String'];
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};


export type EmailCampaignTemplateUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type EmailCampaignTemplateClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type EmailCampaignTemplateFeatureFlagsArgs = {
  cursor?: Maybe<FeatureFlagWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FeatureFlagScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FeatureFlagOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FeatureFlagWhereInput>;
};


export type EmailCampaignTemplateOrganizationArgs = {
  where?: Maybe<OrganizationWhereInput>;
};

export type EmailCampaignTemplateCountAggregateOutputType = {
  __typename?: 'EmailCampaignTemplateCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  htmlContent: Scalars['Int'];
  id: Scalars['Int'];
  latUpdatedByUserId: Scalars['Int'];
  name: Scalars['Int'];
  organizationId: Scalars['Int'];
  templateAvailability: Scalars['Int'];
  unlayerJson: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type EmailCampaignTemplateCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  templateAvailability?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignTemplateCountOutputType = {
  __typename?: 'EmailCampaignTemplateCountOutputType';
  featureFlags: Scalars['Int'];
};

export type EmailCampaignTemplateCreateInput = {
  User?: Maybe<UserCreateNestedOneWithoutEmailCampaignTemplateInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutEmailCampaignTemplateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutEmailCampaignTemplatesInput>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<OrganizationCreateNestedOneWithoutEmailCampaignTemplateInput>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateCreateManyClinicInputEnvelope = {
  data: Array<EmailCampaignTemplateCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignTemplateCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateCreateManyOrganizationInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateCreateManyOrganizationInputEnvelope = {
  data: Array<EmailCampaignTemplateCreateManyOrganizationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignTemplateCreateManyUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateCreateManyUserInputEnvelope = {
  data: Array<EmailCampaignTemplateCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignTemplateCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignTemplateCreateManyClinicInputEnvelope>;
};

export type EmailCampaignTemplateCreateNestedManyWithoutFeatureFlagsInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutFeatureFlagsInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutFeatureFlagsInput>>;
};

export type EmailCampaignTemplateCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutOrganizationInput>>;
  createMany?: Maybe<EmailCampaignTemplateCreateManyOrganizationInputEnvelope>;
};

export type EmailCampaignTemplateCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutUserInput>>;
  createMany?: Maybe<EmailCampaignTemplateCreateManyUserInputEnvelope>;
};

export type EmailCampaignTemplateCreateOrConnectWithoutClinicInput = {
  create: EmailCampaignTemplateCreateWithoutClinicInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};

export type EmailCampaignTemplateCreateOrConnectWithoutFeatureFlagsInput = {
  create: EmailCampaignTemplateCreateWithoutFeatureFlagsInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};

export type EmailCampaignTemplateCreateOrConnectWithoutOrganizationInput = {
  create: EmailCampaignTemplateCreateWithoutOrganizationInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};

export type EmailCampaignTemplateCreateOrConnectWithoutUserInput = {
  create: EmailCampaignTemplateCreateWithoutUserInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};

export type EmailCampaignTemplateCreateWithoutClinicInput = {
  User?: Maybe<UserCreateNestedOneWithoutEmailCampaignTemplateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutEmailCampaignTemplatesInput>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<OrganizationCreateNestedOneWithoutEmailCampaignTemplateInput>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateCreateWithoutFeatureFlagsInput = {
  User?: Maybe<UserCreateNestedOneWithoutEmailCampaignTemplateInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutEmailCampaignTemplateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<OrganizationCreateNestedOneWithoutEmailCampaignTemplateInput>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateCreateWithoutOrganizationInput = {
  User?: Maybe<UserCreateNestedOneWithoutEmailCampaignTemplateInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutEmailCampaignTemplateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutEmailCampaignTemplatesInput>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateCreateWithoutUserInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutEmailCampaignTemplateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagCreateNestedManyWithoutEmailCampaignTemplatesInput>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<OrganizationCreateNestedOneWithoutEmailCampaignTemplateInput>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateGroupByOutputType = {
  __typename?: 'EmailCampaignTemplateGroupByOutputType';
  _count?: Maybe<EmailCampaignTemplateCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignTemplateMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignTemplateMinAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent: Scalars['String'];
  id: Scalars['String'];
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type EmailCampaignTemplateListRelationFilter = {
  every?: Maybe<EmailCampaignTemplateWhereInput>;
  none?: Maybe<EmailCampaignTemplateWhereInput>;
  some?: Maybe<EmailCampaignTemplateWhereInput>;
};

export type EmailCampaignTemplateMaxAggregateOutputType = {
  __typename?: 'EmailCampaignTemplateMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  templateAvailability?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignTemplateMinAggregateOutputType = {
  __typename?: 'EmailCampaignTemplateMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  templateAvailability?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignTemplateOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EmailCampaignTemplateOrderByRelationAndSearchRelevanceInput = {
  User?: Maybe<UserOrderByWithRelationInput>;
  _relevance?: Maybe<EmailCampaignTemplateOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  featureFlags?: Maybe<FeatureFlagOrderByRelationAggregateInput>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  templateAvailability?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmailCampaignTemplateOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  HtmlContent = 'htmlContent',
  Id = 'id',
  LatUpdatedByUserId = 'latUpdatedByUserId',
  Name = 'name',
  OrganizationId = 'organizationId'
}

export type EmailCampaignTemplateOrderByRelevanceInput = {
  fields: Array<EmailCampaignTemplateOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EmailCampaignTemplateOrderByWithAggregationInput = {
  _count?: Maybe<EmailCampaignTemplateCountOrderByAggregateInput>;
  _max?: Maybe<EmailCampaignTemplateMaxOrderByAggregateInput>;
  _min?: Maybe<EmailCampaignTemplateMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  templateAvailability?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignTemplateOrderByWithRelationAndSearchRelevanceInput = {
  User?: Maybe<UserOrderByWithRelationInput>;
  _relevance?: Maybe<EmailCampaignTemplateOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  featureFlags?: Maybe<FeatureFlagOrderByRelationAggregateInput>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  templateAvailability?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignTemplateOrderByWithRelationInput = {
  User?: Maybe<UserOrderByWithRelationInput>;
  _relevance?: Maybe<EmailCampaignTemplateOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  featureFlags?: Maybe<FeatureFlagOrderByRelationAggregateInput>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  latUpdatedByUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  templateAvailability?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmailCampaignTemplateScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  HtmlContent = 'htmlContent',
  Id = 'id',
  LatUpdatedByUserId = 'latUpdatedByUserId',
  Name = 'name',
  OrganizationId = 'organizationId',
  TemplateAvailability = 'templateAvailability',
  UnlayerJson = 'unlayerJson',
  UpdatedAt = 'updatedAt'
}

export type EmailCampaignTemplateScalarWhereInput = {
  AND?: Maybe<Array<EmailCampaignTemplateScalarWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignTemplateScalarWhereInput>>;
  OR?: Maybe<Array<EmailCampaignTemplateScalarWhereInput>>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  htmlContent?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  latUpdatedByUserId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  templateAvailability?: Maybe<EnumTemplateAvailabilityFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailCampaignTemplateScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EmailCampaignTemplateScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EmailCampaignTemplateScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EmailCampaignTemplateScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  htmlContent?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  latUpdatedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  organizationId?: Maybe<StringNullableWithAggregatesFilter>;
  templateAvailability?: Maybe<EnumTemplateAvailabilityWithAggregatesFilter>;
  unlayerJson?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type EmailCampaignTemplateUncheckedCreateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutEmailCampaignTemplatesInput>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignTemplateCreateManyClinicInputEnvelope>;
};

export type EmailCampaignTemplateUncheckedCreateNestedManyWithoutFeatureFlagsInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutFeatureFlagsInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutFeatureFlagsInput>>;
};

export type EmailCampaignTemplateUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutOrganizationInput>>;
  createMany?: Maybe<EmailCampaignTemplateCreateManyOrganizationInputEnvelope>;
};

export type EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutUserInput>>;
  createMany?: Maybe<EmailCampaignTemplateCreateManyUserInputEnvelope>;
};

export type EmailCampaignTemplateUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutEmailCampaignTemplatesInput>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedCreateWithoutFeatureFlagsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedCreateWithoutOrganizationInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutEmailCampaignTemplatesInput>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedCreateWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagUncheckedCreateNestedManyWithoutEmailCampaignTemplatesInput>;
  htmlContent: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability: TemplateAvailability;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutEmailCampaignTemplatesNestedInput>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignTemplateCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignTemplateUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<EmailCampaignTemplateUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<EmailCampaignTemplateUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type EmailCampaignTemplateUncheckedUpdateManyWithoutFeatureFlagsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedUpdateManyWithoutFeatureFlagsNestedInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutFeatureFlagsInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutFeatureFlagsInput>>;
  delete?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignTemplateUpdateWithWhereUniqueWithoutFeatureFlagsInput>>;
  updateMany?: Maybe<Array<EmailCampaignTemplateUpdateManyWithWhereWithoutFeatureFlagsInput>>;
  upsert?: Maybe<Array<EmailCampaignTemplateUpsertWithWhereUniqueWithoutFeatureFlagsInput>>;
};

export type EmailCampaignTemplateUncheckedUpdateManyWithoutOrganizationInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutOrganizationInput>>;
  createMany?: Maybe<EmailCampaignTemplateCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignTemplateUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<EmailCampaignTemplateUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<EmailCampaignTemplateUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type EmailCampaignTemplateUncheckedUpdateManyWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutUserInput>>;
  createMany?: Maybe<EmailCampaignTemplateCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignTemplateUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<EmailCampaignTemplateUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<EmailCampaignTemplateUpsertWithWhereUniqueWithoutUserInput>>;
};

export type EmailCampaignTemplateUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutEmailCampaignTemplatesNestedInput>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedUpdateWithoutFeatureFlagsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedUpdateWithoutOrganizationInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutEmailCampaignTemplatesNestedInput>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUncheckedUpdateWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagUncheckedUpdateManyWithoutEmailCampaignTemplatesNestedInput>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUpdateInput = {
  User?: Maybe<UserUpdateOneWithoutEmailCampaignTemplateNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutEmailCampaignTemplateNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutEmailCampaignTemplatesNestedInput>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutEmailCampaignTemplateNestedInput>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUpdateManyWithWhereWithoutClinicInput = {
  data: EmailCampaignTemplateUpdateManyMutationInput;
  where: EmailCampaignTemplateScalarWhereInput;
};

export type EmailCampaignTemplateUpdateManyWithWhereWithoutFeatureFlagsInput = {
  data: EmailCampaignTemplateUpdateManyMutationInput;
  where: EmailCampaignTemplateScalarWhereInput;
};

export type EmailCampaignTemplateUpdateManyWithWhereWithoutOrganizationInput = {
  data: EmailCampaignTemplateUpdateManyMutationInput;
  where: EmailCampaignTemplateScalarWhereInput;
};

export type EmailCampaignTemplateUpdateManyWithWhereWithoutUserInput = {
  data: EmailCampaignTemplateUpdateManyMutationInput;
  where: EmailCampaignTemplateScalarWhereInput;
};

export type EmailCampaignTemplateUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignTemplateCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignTemplateUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<EmailCampaignTemplateUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<EmailCampaignTemplateUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type EmailCampaignTemplateUpdateManyWithoutFeatureFlagsNestedInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutFeatureFlagsInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutFeatureFlagsInput>>;
  delete?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignTemplateUpdateWithWhereUniqueWithoutFeatureFlagsInput>>;
  updateMany?: Maybe<Array<EmailCampaignTemplateUpdateManyWithWhereWithoutFeatureFlagsInput>>;
  upsert?: Maybe<Array<EmailCampaignTemplateUpsertWithWhereUniqueWithoutFeatureFlagsInput>>;
};

export type EmailCampaignTemplateUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutOrganizationInput>>;
  createMany?: Maybe<EmailCampaignTemplateCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignTemplateUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<EmailCampaignTemplateUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<EmailCampaignTemplateUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type EmailCampaignTemplateUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignTemplateCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<EmailCampaignTemplateCreateWithoutUserInput>>;
  createMany?: Maybe<EmailCampaignTemplateCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignTemplateWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignTemplateUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<EmailCampaignTemplateUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<EmailCampaignTemplateUpsertWithWhereUniqueWithoutUserInput>>;
};

export type EmailCampaignTemplateUpdateWithWhereUniqueWithoutClinicInput = {
  data: EmailCampaignTemplateUpdateWithoutClinicInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};

export type EmailCampaignTemplateUpdateWithWhereUniqueWithoutFeatureFlagsInput = {
  data: EmailCampaignTemplateUpdateWithoutFeatureFlagsInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};

export type EmailCampaignTemplateUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: EmailCampaignTemplateUpdateWithoutOrganizationInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};

export type EmailCampaignTemplateUpdateWithWhereUniqueWithoutUserInput = {
  data: EmailCampaignTemplateUpdateWithoutUserInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};

export type EmailCampaignTemplateUpdateWithoutClinicInput = {
  User?: Maybe<UserUpdateOneWithoutEmailCampaignTemplateNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutEmailCampaignTemplatesNestedInput>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutEmailCampaignTemplateNestedInput>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUpdateWithoutFeatureFlagsInput = {
  User?: Maybe<UserUpdateOneWithoutEmailCampaignTemplateNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutEmailCampaignTemplateNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutEmailCampaignTemplateNestedInput>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUpdateWithoutOrganizationInput = {
  User?: Maybe<UserUpdateOneWithoutEmailCampaignTemplateNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutEmailCampaignTemplateNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutEmailCampaignTemplatesNestedInput>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUpdateWithoutUserInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutEmailCampaignTemplateNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  featureFlags?: Maybe<FeatureFlagUpdateManyWithoutEmailCampaignTemplatesNestedInput>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutEmailCampaignTemplateNestedInput>;
  templateAvailability?: Maybe<TemplateAvailability>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignTemplateUpsertWithWhereUniqueWithoutClinicInput = {
  create: EmailCampaignTemplateCreateWithoutClinicInput;
  update: EmailCampaignTemplateUpdateWithoutClinicInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};

export type EmailCampaignTemplateUpsertWithWhereUniqueWithoutFeatureFlagsInput = {
  create: EmailCampaignTemplateCreateWithoutFeatureFlagsInput;
  update: EmailCampaignTemplateUpdateWithoutFeatureFlagsInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};

export type EmailCampaignTemplateUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: EmailCampaignTemplateCreateWithoutOrganizationInput;
  update: EmailCampaignTemplateUpdateWithoutOrganizationInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};

export type EmailCampaignTemplateUpsertWithWhereUniqueWithoutUserInput = {
  create: EmailCampaignTemplateCreateWithoutUserInput;
  update: EmailCampaignTemplateUpdateWithoutUserInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};

export type EmailCampaignTemplateWhereInput = {
  AND?: Maybe<Array<EmailCampaignTemplateWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignTemplateWhereInput>>;
  OR?: Maybe<Array<EmailCampaignTemplateWhereInput>>;
  User?: Maybe<UserNullableScalarRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  featureFlags?: Maybe<FeatureFlagListRelationFilter>;
  htmlContent?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  latUpdatedByUserId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  templateAvailability?: Maybe<EnumTemplateAvailabilityFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailCampaignTemplateWhereUniqueInput = {
  AND?: Maybe<Array<EmailCampaignTemplateWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignTemplateWhereInput>>;
  OR?: Maybe<Array<EmailCampaignTemplateWhereInput>>;
  User?: Maybe<UserNullableScalarRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  featureFlags?: Maybe<FeatureFlagListRelationFilter>;
  htmlContent?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  templateAvailability?: Maybe<EnumTemplateAvailabilityFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum EmailCampaignType {
  ClinicEmailCampaign = 'ClinicEmailCampaign',
  InformScheduledCampaign = 'InformScheduledCampaign'
}

export type EmailCampaignUncheckedCreateInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignCreateManyClinicInputEnvelope>;
};

export type EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutCreatedByUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutCreatedByUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManyCreatedByUserInputEnvelope>;
};

export type EmailCampaignUncheckedCreateNestedManyWithoutInformCampaignExecutionInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutInformCampaignExecutionInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutInformCampaignExecutionInput>>;
  createMany?: Maybe<EmailCampaignCreateManyInformCampaignExecutionInputEnvelope>;
};

export type EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutLastUpdatedByUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutLastUpdatedByUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManyLastUpdatedByUserInputEnvelope>;
};

export type EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutSentByUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutSentByUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManySentByUserInputEnvelope>;
};

export type EmailCampaignUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManyUserInputEnvelope>;
};

export type EmailCampaignUncheckedCreateWithoutClinicInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedCreateWithoutCreatedByUserInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedCreateWithoutCustomListInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedCreateWithoutEmailCampaignLogsInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedCreateWithoutEmailCampaignUnsubscribesInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedCreateWithoutInformCampaignExecutionInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedCreateWithoutLastUpdatedByUserInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedCreateWithoutSentByUserInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedCreateWithoutUploadsInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedCreateWithoutUserInput = {
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedCreateNestedOneWithoutEmailCampaignInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutEmailCampaignInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedCreateNestedManyWithoutEmailCampaignInput>;
};

export type EmailCampaignUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateManyWithoutClinicInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<EmailCampaignUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<EmailCampaignUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type EmailCampaignUncheckedUpdateManyWithoutCreatedByUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutCreatedByUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutCreatedByUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManyCreatedByUserInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: Maybe<Array<EmailCampaignUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: Maybe<Array<EmailCampaignUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type EmailCampaignUncheckedUpdateManyWithoutInformCampaignExecutionInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateManyWithoutInformCampaignExecutionNestedInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutInformCampaignExecutionInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutInformCampaignExecutionInput>>;
  createMany?: Maybe<EmailCampaignCreateManyInformCampaignExecutionInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUpdateWithWhereUniqueWithoutInformCampaignExecutionInput>>;
  updateMany?: Maybe<Array<EmailCampaignUpdateManyWithWhereWithoutInformCampaignExecutionInput>>;
  upsert?: Maybe<Array<EmailCampaignUpsertWithWhereUniqueWithoutInformCampaignExecutionInput>>;
};

export type EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutLastUpdatedByUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutLastUpdatedByUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManyLastUpdatedByUserInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUpdateWithWhereUniqueWithoutLastUpdatedByUserInput>>;
  updateMany?: Maybe<Array<EmailCampaignUpdateManyWithWhereWithoutLastUpdatedByUserInput>>;
  upsert?: Maybe<Array<EmailCampaignUpsertWithWhereUniqueWithoutLastUpdatedByUserInput>>;
};

export type EmailCampaignUncheckedUpdateManyWithoutSentByUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutSentByUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutSentByUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManySentByUserInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUpdateWithWhereUniqueWithoutSentByUserInput>>;
  updateMany?: Maybe<Array<EmailCampaignUpdateManyWithWhereWithoutSentByUserInput>>;
  upsert?: Maybe<Array<EmailCampaignUpsertWithWhereUniqueWithoutSentByUserInput>>;
};

export type EmailCampaignUncheckedUpdateManyWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<EmailCampaignUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<EmailCampaignUpsertWithWhereUniqueWithoutUserInput>>;
};

export type EmailCampaignUncheckedUpdateWithoutClinicInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateWithoutCreatedByUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateWithoutCustomListInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateWithoutEmailCampaignLogsInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateWithoutEmailCampaignUnsubscribesInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateWithoutInformCampaignExecutionInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateWithoutLastUpdatedByUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateWithoutSentByUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateWithoutUploadsInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type EmailCampaignUncheckedUpdateWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  customList?: Maybe<EmailCampaignCustomListUncheckedUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  latUpdatedByUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUserId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUncheckedUpdateManyWithoutEmailCampaignNestedInput>;
};

export type EmailCampaignUnsubscribe = {
  __typename?: 'EmailCampaignUnsubscribe';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emailCampaign?: Maybe<EmailCampaign>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source: EmailCampaignUnsubscribeSource;
  targetEmail: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type EmailCampaignUnsubscribeClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type EmailCampaignUnsubscribeClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type EmailCampaignUnsubscribeEmailCampaignArgs = {
  where?: Maybe<EmailCampaignWhereInput>;
};

export type EmailCampaignUnsubscribeCountAggregateOutputType = {
  __typename?: 'EmailCampaignUnsubscribeCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  emailCampaignId: Scalars['Int'];
  id: Scalars['Int'];
  resubscribedAt: Scalars['Int'];
  source: Scalars['Int'];
  targetEmail: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type EmailCampaignUnsubscribeCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  resubscribedAt?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignUnsubscribeCreateInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutEmailCampaignUnsubscribeInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutEmailCampaignUnsubscribeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedOneWithoutEmailCampaignUnsubscribesInput>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeCreateManyClinicInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeCreateManyClinicInputEnvelope = {
  data: Array<EmailCampaignUnsubscribeCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignUnsubscribeCreateManyClinicPetParentInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeCreateManyClinicPetParentInputEnvelope = {
  data: Array<EmailCampaignUnsubscribeCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignUnsubscribeCreateManyEmailCampaignInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeCreateManyEmailCampaignInputEnvelope = {
  data: Array<EmailCampaignUnsubscribeCreateManyEmailCampaignInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailCampaignUnsubscribeCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignUnsubscribeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignUnsubscribeCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignUnsubscribeCreateManyClinicInputEnvelope>;
};

export type EmailCampaignUnsubscribeCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignUnsubscribeCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailCampaignUnsubscribeCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailCampaignUnsubscribeCreateManyClinicPetParentInputEnvelope>;
};

export type EmailCampaignUnsubscribeCreateNestedManyWithoutEmailCampaignInput = {
  connect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignUnsubscribeCreateOrConnectWithoutEmailCampaignInput>>;
  create?: Maybe<Array<EmailCampaignUnsubscribeCreateWithoutEmailCampaignInput>>;
  createMany?: Maybe<EmailCampaignUnsubscribeCreateManyEmailCampaignInputEnvelope>;
};

export type EmailCampaignUnsubscribeCreateOrConnectWithoutClinicInput = {
  create: EmailCampaignUnsubscribeCreateWithoutClinicInput;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};

export type EmailCampaignUnsubscribeCreateOrConnectWithoutClinicPetParentInput = {
  create: EmailCampaignUnsubscribeCreateWithoutClinicPetParentInput;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};

export type EmailCampaignUnsubscribeCreateOrConnectWithoutEmailCampaignInput = {
  create: EmailCampaignUnsubscribeCreateWithoutEmailCampaignInput;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};

export type EmailCampaignUnsubscribeCreateWithoutClinicInput = {
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutEmailCampaignUnsubscribeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedOneWithoutEmailCampaignUnsubscribesInput>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeCreateWithoutClinicPetParentInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutEmailCampaignUnsubscribeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign?: Maybe<EmailCampaignCreateNestedOneWithoutEmailCampaignUnsubscribesInput>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeCreateWithoutEmailCampaignInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutEmailCampaignUnsubscribeInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutEmailCampaignUnsubscribeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeGroupByOutputType = {
  __typename?: 'EmailCampaignUnsubscribeGroupByOutputType';
  _count?: Maybe<EmailCampaignUnsubscribeCountAggregateOutputType>;
  _max?: Maybe<EmailCampaignUnsubscribeMaxAggregateOutputType>;
  _min?: Maybe<EmailCampaignUnsubscribeMinAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emailCampaignId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source: EmailCampaignUnsubscribeSource;
  targetEmail: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type EmailCampaignUnsubscribeListRelationFilter = {
  every?: Maybe<EmailCampaignUnsubscribeWhereInput>;
  none?: Maybe<EmailCampaignUnsubscribeWhereInput>;
  some?: Maybe<EmailCampaignUnsubscribeWhereInput>;
};

export type EmailCampaignUnsubscribeMaxAggregateOutputType = {
  __typename?: 'EmailCampaignUnsubscribeMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  resubscribedAt?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignUnsubscribeMinAggregateOutputType = {
  __typename?: 'EmailCampaignUnsubscribeMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  resubscribedAt?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignUnsubscribeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EmailCampaignUnsubscribeOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailCampaignUnsubscribeOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaign?: Maybe<EmailCampaignOrderByWithRelationInput>;
  emailCampaignId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  resubscribedAt?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmailCampaignUnsubscribeOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  EmailCampaignId = 'emailCampaignId',
  Id = 'id',
  TargetEmail = 'targetEmail'
}

export type EmailCampaignUnsubscribeOrderByRelevanceInput = {
  fields: Array<EmailCampaignUnsubscribeOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EmailCampaignUnsubscribeOrderByWithAggregationInput = {
  _count?: Maybe<EmailCampaignUnsubscribeCountOrderByAggregateInput>;
  _max?: Maybe<EmailCampaignUnsubscribeMaxOrderByAggregateInput>;
  _min?: Maybe<EmailCampaignUnsubscribeMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaignId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  resubscribedAt?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignUnsubscribeOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailCampaignUnsubscribeOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaign?: Maybe<EmailCampaignOrderByWithRelationInput>;
  emailCampaignId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  resubscribedAt?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailCampaignUnsubscribeOrderByWithRelationInput = {
  _relevance?: Maybe<EmailCampaignUnsubscribeOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailCampaign?: Maybe<EmailCampaignOrderByWithRelationInput>;
  emailCampaignId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  resubscribedAt?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  targetEmail?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmailCampaignUnsubscribeScalarFieldEnum {
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  EmailCampaignId = 'emailCampaignId',
  Id = 'id',
  ResubscribedAt = 'resubscribedAt',
  Source = 'source',
  TargetEmail = 'targetEmail',
  UpdatedAt = 'updatedAt'
}

export type EmailCampaignUnsubscribeScalarWhereInput = {
  AND?: Maybe<Array<EmailCampaignUnsubscribeScalarWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignUnsubscribeScalarWhereInput>>;
  OR?: Maybe<Array<EmailCampaignUnsubscribeScalarWhereInput>>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaignId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  resubscribedAt?: Maybe<DateTimeNullableFilter>;
  source?: Maybe<EnumEmailCampaignUnsubscribeSourceFilter>;
  targetEmail?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailCampaignUnsubscribeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EmailCampaignUnsubscribeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EmailCampaignUnsubscribeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EmailCampaignUnsubscribeScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  emailCampaignId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  resubscribedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  source?: Maybe<EnumEmailCampaignUnsubscribeSourceWithAggregatesFilter>;
  targetEmail?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum EmailCampaignUnsubscribeSource {
  Bounce = 'Bounce',
  SpamReport = 'SpamReport',
  Unsubscribe = 'Unsubscribe'
}

export type EmailCampaignUnsubscribeUncheckedCreateInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignUnsubscribeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignUnsubscribeCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignUnsubscribeCreateManyClinicInputEnvelope>;
};

export type EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignUnsubscribeCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailCampaignUnsubscribeCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailCampaignUnsubscribeCreateManyClinicPetParentInputEnvelope>;
};

export type EmailCampaignUnsubscribeUncheckedCreateNestedManyWithoutEmailCampaignInput = {
  connect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignUnsubscribeCreateOrConnectWithoutEmailCampaignInput>>;
  create?: Maybe<Array<EmailCampaignUnsubscribeCreateWithoutEmailCampaignInput>>;
  createMany?: Maybe<EmailCampaignUnsubscribeCreateManyEmailCampaignInputEnvelope>;
};

export type EmailCampaignUnsubscribeUncheckedCreateWithoutClinicInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUncheckedCreateWithoutClinicPetParentInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUncheckedCreateWithoutEmailCampaignInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignUnsubscribeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignUnsubscribeCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignUnsubscribeCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignUnsubscribeScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUnsubscribeUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<EmailCampaignUnsubscribeUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<EmailCampaignUnsubscribeUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignUnsubscribeCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailCampaignUnsubscribeCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailCampaignUnsubscribeCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignUnsubscribeScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUnsubscribeUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<EmailCampaignUnsubscribeUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<EmailCampaignUnsubscribeUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type EmailCampaignUnsubscribeUncheckedUpdateManyWithoutEmailCampaignInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUncheckedUpdateManyWithoutEmailCampaignNestedInput = {
  connect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignUnsubscribeCreateOrConnectWithoutEmailCampaignInput>>;
  create?: Maybe<Array<EmailCampaignUnsubscribeCreateWithoutEmailCampaignInput>>;
  createMany?: Maybe<EmailCampaignUnsubscribeCreateManyEmailCampaignInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignUnsubscribeScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUnsubscribeUpdateWithWhereUniqueWithoutEmailCampaignInput>>;
  updateMany?: Maybe<Array<EmailCampaignUnsubscribeUpdateManyWithWhereWithoutEmailCampaignInput>>;
  upsert?: Maybe<Array<EmailCampaignUnsubscribeUpsertWithWhereUniqueWithoutEmailCampaignInput>>;
};

export type EmailCampaignUnsubscribeUncheckedUpdateWithoutClinicInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUncheckedUpdateWithoutClinicPetParentInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUncheckedUpdateWithoutEmailCampaignInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutEmailCampaignUnsubscribeNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutEmailCampaignUnsubscribeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign?: Maybe<EmailCampaignUpdateOneWithoutEmailCampaignUnsubscribesNestedInput>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUpdateManyWithWhereWithoutClinicInput = {
  data: EmailCampaignUnsubscribeUpdateManyMutationInput;
  where: EmailCampaignUnsubscribeScalarWhereInput;
};

export type EmailCampaignUnsubscribeUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: EmailCampaignUnsubscribeUpdateManyMutationInput;
  where: EmailCampaignUnsubscribeScalarWhereInput;
};

export type EmailCampaignUnsubscribeUpdateManyWithWhereWithoutEmailCampaignInput = {
  data: EmailCampaignUnsubscribeUpdateManyMutationInput;
  where: EmailCampaignUnsubscribeScalarWhereInput;
};

export type EmailCampaignUnsubscribeUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignUnsubscribeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignUnsubscribeCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignUnsubscribeCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignUnsubscribeScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUnsubscribeUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<EmailCampaignUnsubscribeUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<EmailCampaignUnsubscribeUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type EmailCampaignUnsubscribeUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignUnsubscribeCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailCampaignUnsubscribeCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailCampaignUnsubscribeCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignUnsubscribeScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUnsubscribeUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<EmailCampaignUnsubscribeUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<EmailCampaignUnsubscribeUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type EmailCampaignUnsubscribeUpdateManyWithoutEmailCampaignNestedInput = {
  connect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignUnsubscribeCreateOrConnectWithoutEmailCampaignInput>>;
  create?: Maybe<Array<EmailCampaignUnsubscribeCreateWithoutEmailCampaignInput>>;
  createMany?: Maybe<EmailCampaignUnsubscribeCreateManyEmailCampaignInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignUnsubscribeScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignUnsubscribeWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUnsubscribeUpdateWithWhereUniqueWithoutEmailCampaignInput>>;
  updateMany?: Maybe<Array<EmailCampaignUnsubscribeUpdateManyWithWhereWithoutEmailCampaignInput>>;
  upsert?: Maybe<Array<EmailCampaignUnsubscribeUpsertWithWhereUniqueWithoutEmailCampaignInput>>;
};

export type EmailCampaignUnsubscribeUpdateWithWhereUniqueWithoutClinicInput = {
  data: EmailCampaignUnsubscribeUpdateWithoutClinicInput;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};

export type EmailCampaignUnsubscribeUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: EmailCampaignUnsubscribeUpdateWithoutClinicPetParentInput;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};

export type EmailCampaignUnsubscribeUpdateWithWhereUniqueWithoutEmailCampaignInput = {
  data: EmailCampaignUnsubscribeUpdateWithoutEmailCampaignInput;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};

export type EmailCampaignUnsubscribeUpdateWithoutClinicInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutEmailCampaignUnsubscribeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign?: Maybe<EmailCampaignUpdateOneWithoutEmailCampaignUnsubscribesNestedInput>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUpdateWithoutClinicPetParentInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutEmailCampaignUnsubscribeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaign?: Maybe<EmailCampaignUpdateOneWithoutEmailCampaignUnsubscribesNestedInput>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUpdateWithoutEmailCampaignInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutEmailCampaignUnsubscribeNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutEmailCampaignUnsubscribeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<EmailCampaignUnsubscribeSource>;
  targetEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUnsubscribeUpsertWithWhereUniqueWithoutClinicInput = {
  create: EmailCampaignUnsubscribeCreateWithoutClinicInput;
  update: EmailCampaignUnsubscribeUpdateWithoutClinicInput;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};

export type EmailCampaignUnsubscribeUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: EmailCampaignUnsubscribeCreateWithoutClinicPetParentInput;
  update: EmailCampaignUnsubscribeUpdateWithoutClinicPetParentInput;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};

export type EmailCampaignUnsubscribeUpsertWithWhereUniqueWithoutEmailCampaignInput = {
  create: EmailCampaignUnsubscribeCreateWithoutEmailCampaignInput;
  update: EmailCampaignUnsubscribeUpdateWithoutEmailCampaignInput;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};

export type EmailCampaignUnsubscribeWhereInput = {
  AND?: Maybe<Array<EmailCampaignUnsubscribeWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignUnsubscribeWhereInput>>;
  OR?: Maybe<Array<EmailCampaignUnsubscribeWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaign?: Maybe<EmailCampaignNullableScalarRelationFilter>;
  emailCampaignId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  resubscribedAt?: Maybe<DateTimeNullableFilter>;
  source?: Maybe<EnumEmailCampaignUnsubscribeSourceFilter>;
  targetEmail?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailCampaignUnsubscribeWhereUniqueInput = {
  AND?: Maybe<Array<EmailCampaignUnsubscribeWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignUnsubscribeWhereInput>>;
  OR?: Maybe<Array<EmailCampaignUnsubscribeWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaign?: Maybe<EmailCampaignNullableScalarRelationFilter>;
  emailCampaignId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  resubscribedAt?: Maybe<DateTimeNullableFilter>;
  source?: Maybe<EnumEmailCampaignUnsubscribeSourceFilter>;
  targetEmail?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailCampaignUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsCreatedNestedInput>;
  customList?: Maybe<EmailCampaignCustomListUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneWithoutEmailCampaignsNestedInput>;
  lastUpdatedByUser?: Maybe<UserUpdateOneWithoutEmailCampaignUpdatedNestedInput>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsSentNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  typedSegmentArgs?: Maybe<SegmentsArgsInput>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUpdateManyWithoutEmailCampaignNestedInput>;
  user?: Maybe<UserUpdateOneWithoutEmailCampaignNestedInput>;
};

export type EmailCampaignUpdateManyMutationInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailCampaignUpdateManyWithWhereWithoutClinicInput = {
  data: EmailCampaignUpdateManyMutationInput;
  where: EmailCampaignScalarWhereInput;
};

export type EmailCampaignUpdateManyWithWhereWithoutCreatedByUserInput = {
  data: EmailCampaignUpdateManyMutationInput;
  where: EmailCampaignScalarWhereInput;
};

export type EmailCampaignUpdateManyWithWhereWithoutInformCampaignExecutionInput = {
  data: EmailCampaignUpdateManyMutationInput;
  where: EmailCampaignScalarWhereInput;
};

export type EmailCampaignUpdateManyWithWhereWithoutLastUpdatedByUserInput = {
  data: EmailCampaignUpdateManyMutationInput;
  where: EmailCampaignScalarWhereInput;
};

export type EmailCampaignUpdateManyWithWhereWithoutSentByUserInput = {
  data: EmailCampaignUpdateManyMutationInput;
  where: EmailCampaignScalarWhereInput;
};

export type EmailCampaignUpdateManyWithWhereWithoutUserInput = {
  data: EmailCampaignUpdateManyMutationInput;
  where: EmailCampaignScalarWhereInput;
};

export type EmailCampaignUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutClinicInput>>;
  createMany?: Maybe<EmailCampaignCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<EmailCampaignUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<EmailCampaignUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type EmailCampaignUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutCreatedByUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutCreatedByUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManyCreatedByUserInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: Maybe<Array<EmailCampaignUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: Maybe<Array<EmailCampaignUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type EmailCampaignUpdateManyWithoutInformCampaignExecutionNestedInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutInformCampaignExecutionInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutInformCampaignExecutionInput>>;
  createMany?: Maybe<EmailCampaignCreateManyInformCampaignExecutionInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUpdateWithWhereUniqueWithoutInformCampaignExecutionInput>>;
  updateMany?: Maybe<Array<EmailCampaignUpdateManyWithWhereWithoutInformCampaignExecutionInput>>;
  upsert?: Maybe<Array<EmailCampaignUpsertWithWhereUniqueWithoutInformCampaignExecutionInput>>;
};

export type EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutLastUpdatedByUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutLastUpdatedByUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManyLastUpdatedByUserInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUpdateWithWhereUniqueWithoutLastUpdatedByUserInput>>;
  updateMany?: Maybe<Array<EmailCampaignUpdateManyWithWhereWithoutLastUpdatedByUserInput>>;
  upsert?: Maybe<Array<EmailCampaignUpsertWithWhereUniqueWithoutLastUpdatedByUserInput>>;
};

export type EmailCampaignUpdateManyWithoutSentByUserNestedInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutSentByUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutSentByUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManySentByUserInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUpdateWithWhereUniqueWithoutSentByUserInput>>;
  updateMany?: Maybe<Array<EmailCampaignUpdateManyWithWhereWithoutSentByUserInput>>;
  upsert?: Maybe<Array<EmailCampaignUpsertWithWhereUniqueWithoutSentByUserInput>>;
};

export type EmailCampaignUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailCampaignCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<EmailCampaignCreateWithoutUserInput>>;
  createMany?: Maybe<EmailCampaignCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  set?: Maybe<Array<EmailCampaignWhereUniqueInput>>;
  update?: Maybe<Array<EmailCampaignUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<EmailCampaignUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<EmailCampaignUpsertWithWhereUniqueWithoutUserInput>>;
};

export type EmailCampaignUpdateOneRequiredWithoutCustomListNestedInput = {
  connect?: Maybe<EmailCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCreateOrConnectWithoutCustomListInput>;
  create?: Maybe<EmailCampaignCreateWithoutCustomListInput>;
  update?: Maybe<EmailCampaignUpdateToOneWithWhereWithoutCustomListInput>;
  upsert?: Maybe<EmailCampaignUpsertWithoutCustomListInput>;
};

export type EmailCampaignUpdateOneRequiredWithoutEmailCampaignLogsNestedInput = {
  connect?: Maybe<EmailCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCreateOrConnectWithoutEmailCampaignLogsInput>;
  create?: Maybe<EmailCampaignCreateWithoutEmailCampaignLogsInput>;
  update?: Maybe<EmailCampaignUpdateToOneWithWhereWithoutEmailCampaignLogsInput>;
  upsert?: Maybe<EmailCampaignUpsertWithoutEmailCampaignLogsInput>;
};

export type EmailCampaignUpdateOneRequiredWithoutUploadsNestedInput = {
  connect?: Maybe<EmailCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCreateOrConnectWithoutUploadsInput>;
  create?: Maybe<EmailCampaignCreateWithoutUploadsInput>;
  update?: Maybe<EmailCampaignUpdateToOneWithWhereWithoutUploadsInput>;
  upsert?: Maybe<EmailCampaignUpsertWithoutUploadsInput>;
};

export type EmailCampaignUpdateOneWithoutEmailCampaignUnsubscribesNestedInput = {
  connect?: Maybe<EmailCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailCampaignCreateOrConnectWithoutEmailCampaignUnsubscribesInput>;
  create?: Maybe<EmailCampaignCreateWithoutEmailCampaignUnsubscribesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<EmailCampaignUpdateToOneWithWhereWithoutEmailCampaignUnsubscribesInput>;
  upsert?: Maybe<EmailCampaignUpsertWithoutEmailCampaignUnsubscribesInput>;
};

export type EmailCampaignUpdateToOneWithWhereWithoutCustomListInput = {
  data: EmailCampaignUpdateWithoutCustomListInput;
  where?: Maybe<EmailCampaignWhereInput>;
};

export type EmailCampaignUpdateToOneWithWhereWithoutEmailCampaignLogsInput = {
  data: EmailCampaignUpdateWithoutEmailCampaignLogsInput;
  where?: Maybe<EmailCampaignWhereInput>;
};

export type EmailCampaignUpdateToOneWithWhereWithoutEmailCampaignUnsubscribesInput = {
  data: EmailCampaignUpdateWithoutEmailCampaignUnsubscribesInput;
  where?: Maybe<EmailCampaignWhereInput>;
};

export type EmailCampaignUpdateToOneWithWhereWithoutUploadsInput = {
  data: EmailCampaignUpdateWithoutUploadsInput;
  where?: Maybe<EmailCampaignWhereInput>;
};

export type EmailCampaignUpdateWithWhereUniqueWithoutClinicInput = {
  data: EmailCampaignUpdateWithoutClinicInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignUpdateWithWhereUniqueWithoutCreatedByUserInput = {
  data: EmailCampaignUpdateWithoutCreatedByUserInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignUpdateWithWhereUniqueWithoutInformCampaignExecutionInput = {
  data: EmailCampaignUpdateWithoutInformCampaignExecutionInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignUpdateWithWhereUniqueWithoutLastUpdatedByUserInput = {
  data: EmailCampaignUpdateWithoutLastUpdatedByUserInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignUpdateWithWhereUniqueWithoutSentByUserInput = {
  data: EmailCampaignUpdateWithoutSentByUserInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignUpdateWithWhereUniqueWithoutUserInput = {
  data: EmailCampaignUpdateWithoutUserInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignUpdateWithoutClinicInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsCreatedNestedInput>;
  customList?: Maybe<EmailCampaignCustomListUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneWithoutEmailCampaignsNestedInput>;
  lastUpdatedByUser?: Maybe<UserUpdateOneWithoutEmailCampaignUpdatedNestedInput>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsSentNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUpdateManyWithoutEmailCampaignNestedInput>;
  user?: Maybe<UserUpdateOneWithoutEmailCampaignNestedInput>;
};

export type EmailCampaignUpdateWithoutCreatedByUserInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customList?: Maybe<EmailCampaignCustomListUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneWithoutEmailCampaignsNestedInput>;
  lastUpdatedByUser?: Maybe<UserUpdateOneWithoutEmailCampaignUpdatedNestedInput>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsSentNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUpdateManyWithoutEmailCampaignNestedInput>;
  user?: Maybe<UserUpdateOneWithoutEmailCampaignNestedInput>;
};

export type EmailCampaignUpdateWithoutCustomListInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsCreatedNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneWithoutEmailCampaignsNestedInput>;
  lastUpdatedByUser?: Maybe<UserUpdateOneWithoutEmailCampaignUpdatedNestedInput>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsSentNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUpdateManyWithoutEmailCampaignNestedInput>;
  user?: Maybe<UserUpdateOneWithoutEmailCampaignNestedInput>;
};

export type EmailCampaignUpdateWithoutEmailCampaignLogsInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsCreatedNestedInput>;
  customList?: Maybe<EmailCampaignCustomListUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneWithoutEmailCampaignsNestedInput>;
  lastUpdatedByUser?: Maybe<UserUpdateOneWithoutEmailCampaignUpdatedNestedInput>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsSentNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUpdateManyWithoutEmailCampaignNestedInput>;
  user?: Maybe<UserUpdateOneWithoutEmailCampaignNestedInput>;
};

export type EmailCampaignUpdateWithoutEmailCampaignUnsubscribesInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsCreatedNestedInput>;
  customList?: Maybe<EmailCampaignCustomListUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneWithoutEmailCampaignsNestedInput>;
  lastUpdatedByUser?: Maybe<UserUpdateOneWithoutEmailCampaignUpdatedNestedInput>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsSentNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUpdateManyWithoutEmailCampaignNestedInput>;
  user?: Maybe<UserUpdateOneWithoutEmailCampaignNestedInput>;
};

export type EmailCampaignUpdateWithoutInformCampaignExecutionInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsCreatedNestedInput>;
  customList?: Maybe<EmailCampaignCustomListUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastUpdatedByUser?: Maybe<UserUpdateOneWithoutEmailCampaignUpdatedNestedInput>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsSentNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUpdateManyWithoutEmailCampaignNestedInput>;
  user?: Maybe<UserUpdateOneWithoutEmailCampaignNestedInput>;
};

export type EmailCampaignUpdateWithoutLastUpdatedByUserInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsCreatedNestedInput>;
  customList?: Maybe<EmailCampaignCustomListUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneWithoutEmailCampaignsNestedInput>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsSentNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUpdateManyWithoutEmailCampaignNestedInput>;
  user?: Maybe<UserUpdateOneWithoutEmailCampaignNestedInput>;
};

export type EmailCampaignUpdateWithoutSentByUserInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsCreatedNestedInput>;
  customList?: Maybe<EmailCampaignCustomListUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneWithoutEmailCampaignsNestedInput>;
  lastUpdatedByUser?: Maybe<UserUpdateOneWithoutEmailCampaignUpdatedNestedInput>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUpdateManyWithoutEmailCampaignNestedInput>;
  user?: Maybe<UserUpdateOneWithoutEmailCampaignNestedInput>;
};

export type EmailCampaignUpdateWithoutUploadsInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsCreatedNestedInput>;
  customList?: Maybe<EmailCampaignCustomListUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneWithoutEmailCampaignsNestedInput>;
  lastUpdatedByUser?: Maybe<UserUpdateOneWithoutEmailCampaignUpdatedNestedInput>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsSentNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutEmailCampaignNestedInput>;
};

export type EmailCampaignUpdateWithoutUserInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEmailCampaignNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contexts?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsCreatedNestedInput>;
  customList?: Maybe<EmailCampaignCustomListUpdateOneWithoutEmailCampaignNestedInput>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailCampaignLogs?: Maybe<EmailCampaignLogUpdateManyWithoutEmailCampaignNestedInput>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeUpdateManyWithoutEmailCampaignNestedInput>;
  from?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneWithoutEmailCampaignsNestedInput>;
  lastUpdatedByUser?: Maybe<UserUpdateOneWithoutEmailCampaignUpdatedNestedInput>;
  name?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  replyToJson?: Maybe<Scalars['Json']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  segmentArgs?: Maybe<Scalars['Json']>;
  segmentWhere?: Maybe<Scalars['Json']>;
  segmentationDefinition?: Maybe<Scalars['Json']>;
  segmentationType?: Maybe<EmailCampaignSegmentationType>;
  sentByUser?: Maybe<UserUpdateOneWithoutEmailCampaignsSentNestedInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmailCampaignStatus>;
  subject?: Maybe<Scalars['String']>;
  totalSegmentContacts?: Maybe<Scalars['Int']>;
  type?: Maybe<EmailCampaignType>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryUpdateManyWithoutEmailCampaignNestedInput>;
};

export type EmailCampaignUpsertWithWhereUniqueWithoutClinicInput = {
  create: EmailCampaignCreateWithoutClinicInput;
  update: EmailCampaignUpdateWithoutClinicInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignUpsertWithWhereUniqueWithoutCreatedByUserInput = {
  create: EmailCampaignCreateWithoutCreatedByUserInput;
  update: EmailCampaignUpdateWithoutCreatedByUserInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignUpsertWithWhereUniqueWithoutInformCampaignExecutionInput = {
  create: EmailCampaignCreateWithoutInformCampaignExecutionInput;
  update: EmailCampaignUpdateWithoutInformCampaignExecutionInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignUpsertWithWhereUniqueWithoutLastUpdatedByUserInput = {
  create: EmailCampaignCreateWithoutLastUpdatedByUserInput;
  update: EmailCampaignUpdateWithoutLastUpdatedByUserInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignUpsertWithWhereUniqueWithoutSentByUserInput = {
  create: EmailCampaignCreateWithoutSentByUserInput;
  update: EmailCampaignUpdateWithoutSentByUserInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignUpsertWithWhereUniqueWithoutUserInput = {
  create: EmailCampaignCreateWithoutUserInput;
  update: EmailCampaignUpdateWithoutUserInput;
  where: EmailCampaignWhereUniqueInput;
};

export type EmailCampaignUpsertWithoutCustomListInput = {
  create: EmailCampaignCreateWithoutCustomListInput;
  update: EmailCampaignUpdateWithoutCustomListInput;
  where?: Maybe<EmailCampaignWhereInput>;
};

export type EmailCampaignUpsertWithoutEmailCampaignLogsInput = {
  create: EmailCampaignCreateWithoutEmailCampaignLogsInput;
  update: EmailCampaignUpdateWithoutEmailCampaignLogsInput;
  where?: Maybe<EmailCampaignWhereInput>;
};

export type EmailCampaignUpsertWithoutEmailCampaignUnsubscribesInput = {
  create: EmailCampaignCreateWithoutEmailCampaignUnsubscribesInput;
  update: EmailCampaignUpdateWithoutEmailCampaignUnsubscribesInput;
  where?: Maybe<EmailCampaignWhereInput>;
};

export type EmailCampaignUpsertWithoutUploadsInput = {
  create: EmailCampaignCreateWithoutUploadsInput;
  update: EmailCampaignUpdateWithoutUploadsInput;
  where?: Maybe<EmailCampaignWhereInput>;
};

export type EmailCampaignWhereInput = {
  AND?: Maybe<Array<EmailCampaignWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignWhereInput>>;
  OR?: Maybe<Array<EmailCampaignWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  contexts?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUser?: Maybe<UserNullableScalarRelationFilter>;
  createdByUserId?: Maybe<StringNullableFilter>;
  customList?: Maybe<EmailCampaignCustomListNullableScalarRelationFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  emailCampaignLogs?: Maybe<EmailCampaignLogListRelationFilter>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeListRelationFilter>;
  from?: Maybe<StringFilter>;
  htmlContent?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informCampaignExecution?: Maybe<InformCampaignExecutionNullableScalarRelationFilter>;
  informCampaignExecutionId?: Maybe<StringNullableFilter>;
  lastUpdatedByUser?: Maybe<UserNullableScalarRelationFilter>;
  latUpdatedByUserId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  replyTo?: Maybe<StringNullableFilter>;
  replyToJson?: Maybe<JsonNullableFilter>;
  scheduledAt?: Maybe<DateTimeNullableFilter>;
  segmentArgs?: Maybe<JsonNullableFilter>;
  segmentWhere?: Maybe<JsonNullableFilter>;
  segmentationDefinition?: Maybe<JsonNullableFilter>;
  segmentationType?: Maybe<EnumEmailCampaignSegmentationTypeFilter>;
  sentByUser?: Maybe<UserNullableScalarRelationFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeNullableFilter>;
  startsAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumEmailCampaignStatusFilter>;
  subject?: Maybe<StringNullableFilter>;
  totalSegmentContacts?: Maybe<IntNullableFilter>;
  type?: Maybe<EnumEmailCampaignTypeFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryListRelationFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type EmailCampaignWhereUniqueInput = {
  AND?: Maybe<Array<EmailCampaignWhereInput>>;
  NOT?: Maybe<Array<EmailCampaignWhereInput>>;
  OR?: Maybe<Array<EmailCampaignWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  contexts?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUser?: Maybe<UserNullableScalarRelationFilter>;
  createdByUserId?: Maybe<StringNullableFilter>;
  customList?: Maybe<EmailCampaignCustomListNullableScalarRelationFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  emailCampaignLogs?: Maybe<EmailCampaignLogListRelationFilter>;
  emailCampaignUnsubscribes?: Maybe<EmailCampaignUnsubscribeListRelationFilter>;
  from?: Maybe<StringFilter>;
  htmlContent?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecution?: Maybe<InformCampaignExecutionNullableScalarRelationFilter>;
  informCampaignExecutionId?: Maybe<StringNullableFilter>;
  lastUpdatedByUser?: Maybe<UserNullableScalarRelationFilter>;
  latUpdatedByUserId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  replyTo?: Maybe<StringNullableFilter>;
  replyToJson?: Maybe<JsonNullableFilter>;
  scheduledAt?: Maybe<DateTimeNullableFilter>;
  segmentArgs?: Maybe<JsonNullableFilter>;
  segmentWhere?: Maybe<JsonNullableFilter>;
  segmentationDefinition?: Maybe<JsonNullableFilter>;
  segmentationType?: Maybe<EnumEmailCampaignSegmentationTypeFilter>;
  sentByUser?: Maybe<UserNullableScalarRelationFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  startedAt?: Maybe<DateTimeNullableFilter>;
  startsAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumEmailCampaignStatusFilter>;
  subject?: Maybe<StringNullableFilter>;
  totalSegmentContacts?: Maybe<IntNullableFilter>;
  type?: Maybe<EnumEmailCampaignTypeFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uploads?: Maybe<EmailCampaignCustomListUploadHistoryListRelationFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export enum EmailProvider {
  Sendgrid = 'Sendgrid'
}

export type EmailProviderLog = {
  __typename?: 'EmailProviderLog';
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  entityId: Scalars['String'];
  entityType: EmailProviderLogEntityType;
  id: Scalars['String'];
  provider: EmailProvider;
  providerEmailTemplateId: Scalars['String'];
  providerMessageId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type EmailProviderLogCountAggregateOutputType = {
  __typename?: 'EmailProviderLogCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  entityId: Scalars['Int'];
  entityType: Scalars['Int'];
  id: Scalars['Int'];
  provider: Scalars['Int'];
  providerEmailTemplateId: Scalars['Int'];
  providerMessageId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type EmailProviderLogCountOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerEmailTemplateId?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailProviderLogCreateInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutEmailProviderLogsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['String'];
  entityType: EmailProviderLogEntityType;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId: Scalars['String'];
  providerMessageId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogCreateManyClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['String'];
  entityType: EmailProviderLogEntityType;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId: Scalars['String'];
  providerMessageId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogCreateManyClinicPetParentInputEnvelope = {
  data: Array<EmailProviderLogCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailProviderLogCreateManyInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['String'];
  entityType: EmailProviderLogEntityType;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId: Scalars['String'];
  providerMessageId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<EmailProviderLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailProviderLogCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailProviderLogCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailProviderLogCreateManyClinicPetParentInputEnvelope>;
};

export type EmailProviderLogCreateOrConnectWithoutClinicPetParentInput = {
  create: EmailProviderLogCreateWithoutClinicPetParentInput;
  where: EmailProviderLogWhereUniqueInput;
};

export type EmailProviderLogCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['String'];
  entityType: EmailProviderLogEntityType;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId: Scalars['String'];
  providerMessageId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum EmailProviderLogEntityType {
  Appointment = 'Appointment',
  AutomationRun = 'AutomationRun',
  Channel = 'Channel',
  ChannelMessage = 'ChannelMessage',
  ClinicPetParent = 'ClinicPetParent',
  ClinicWidgetRequest = 'ClinicWidgetRequest',
  ServiceReminderNotification = 'ServiceReminderNotification',
  StripeRefund = 'StripeRefund'
}

export type EmailProviderLogGroupByOutputType = {
  __typename?: 'EmailProviderLogGroupByOutputType';
  _count?: Maybe<EmailProviderLogCountAggregateOutputType>;
  _max?: Maybe<EmailProviderLogMaxAggregateOutputType>;
  _min?: Maybe<EmailProviderLogMinAggregateOutputType>;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  entityId: Scalars['String'];
  entityType: EmailProviderLogEntityType;
  id: Scalars['String'];
  provider: EmailProvider;
  providerEmailTemplateId: Scalars['String'];
  providerMessageId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type EmailProviderLogListRelationFilter = {
  every?: Maybe<EmailProviderLogWhereInput>;
  none?: Maybe<EmailProviderLogWhereInput>;
  some?: Maybe<EmailProviderLogWhereInput>;
};

export type EmailProviderLogMaxAggregateOutputType = {
  __typename?: 'EmailProviderLogMaxAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EmailProviderLogEntityType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogMaxOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerEmailTemplateId?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailProviderLogMinAggregateOutputType = {
  __typename?: 'EmailProviderLogMinAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EmailProviderLogEntityType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogMinOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerEmailTemplateId?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailProviderLogOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EmailProviderLogOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailProviderLogOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerEmailTemplateId?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmailProviderLogOrderByRelevanceFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  EntityId = 'entityId',
  Id = 'id',
  ProviderEmailTemplateId = 'providerEmailTemplateId',
  ProviderMessageId = 'providerMessageId'
}

export type EmailProviderLogOrderByRelevanceInput = {
  fields: Array<EmailProviderLogOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EmailProviderLogOrderByWithAggregationInput = {
  _count?: Maybe<EmailProviderLogCountOrderByAggregateInput>;
  _max?: Maybe<EmailProviderLogMaxOrderByAggregateInput>;
  _min?: Maybe<EmailProviderLogMinOrderByAggregateInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerEmailTemplateId?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailProviderLogOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailProviderLogOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerEmailTemplateId?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailProviderLogOrderByWithRelationInput = {
  _relevance?: Maybe<EmailProviderLogOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerEmailTemplateId?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmailProviderLogScalarFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  EntityId = 'entityId',
  EntityType = 'entityType',
  Id = 'id',
  Provider = 'provider',
  ProviderEmailTemplateId = 'providerEmailTemplateId',
  ProviderMessageId = 'providerMessageId',
  UpdatedAt = 'updatedAt'
}

export type EmailProviderLogScalarWhereInput = {
  AND?: Maybe<Array<EmailProviderLogScalarWhereInput>>;
  NOT?: Maybe<Array<EmailProviderLogScalarWhereInput>>;
  OR?: Maybe<Array<EmailProviderLogScalarWhereInput>>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entityId?: Maybe<StringFilter>;
  entityType?: Maybe<EnumEmailProviderLogEntityTypeFilter>;
  id?: Maybe<StringFilter>;
  provider?: Maybe<EnumEmailProviderFilter>;
  providerEmailTemplateId?: Maybe<StringFilter>;
  providerMessageId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailProviderLogScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EmailProviderLogScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EmailProviderLogScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EmailProviderLogScalarWhereWithAggregatesInput>>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  entityId?: Maybe<StringWithAggregatesFilter>;
  entityType?: Maybe<EnumEmailProviderLogEntityTypeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  provider?: Maybe<EnumEmailProviderWithAggregatesFilter>;
  providerEmailTemplateId?: Maybe<StringWithAggregatesFilter>;
  providerMessageId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type EmailProviderLogUncheckedCreateInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['String'];
  entityType: EmailProviderLogEntityType;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId: Scalars['String'];
  providerMessageId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<EmailProviderLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailProviderLogCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailProviderLogCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailProviderLogCreateManyClinicPetParentInputEnvelope>;
};

export type EmailProviderLogUncheckedCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['String'];
  entityType: EmailProviderLogEntityType;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId: Scalars['String'];
  providerMessageId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogUncheckedUpdateInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EmailProviderLogEntityType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogUncheckedUpdateManyInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EmailProviderLogEntityType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EmailProviderLogEntityType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<EmailProviderLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailProviderLogCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailProviderLogCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailProviderLogCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<EmailProviderLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailProviderLogScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailProviderLogWhereUniqueInput>>;
  set?: Maybe<Array<EmailProviderLogWhereUniqueInput>>;
  update?: Maybe<Array<EmailProviderLogUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<EmailProviderLogUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<EmailProviderLogUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type EmailProviderLogUncheckedUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EmailProviderLogEntityType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogUpdateInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutEmailProviderLogsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EmailProviderLogEntityType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EmailProviderLogEntityType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: EmailProviderLogUpdateManyMutationInput;
  where: EmailProviderLogScalarWhereInput;
};

export type EmailProviderLogUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<EmailProviderLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailProviderLogCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<EmailProviderLogCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<EmailProviderLogCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<EmailProviderLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailProviderLogScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailProviderLogWhereUniqueInput>>;
  set?: Maybe<Array<EmailProviderLogWhereUniqueInput>>;
  update?: Maybe<Array<EmailProviderLogUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<EmailProviderLogUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<EmailProviderLogUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type EmailProviderLogUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: EmailProviderLogUpdateWithoutClinicPetParentInput;
  where: EmailProviderLogWhereUniqueInput;
};

export type EmailProviderLogUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EmailProviderLogEntityType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EmailProvider>;
  providerEmailTemplateId?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailProviderLogUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: EmailProviderLogCreateWithoutClinicPetParentInput;
  update: EmailProviderLogUpdateWithoutClinicPetParentInput;
  where: EmailProviderLogWhereUniqueInput;
};

export type EmailProviderLogWhereInput = {
  AND?: Maybe<Array<EmailProviderLogWhereInput>>;
  NOT?: Maybe<Array<EmailProviderLogWhereInput>>;
  OR?: Maybe<Array<EmailProviderLogWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entityId?: Maybe<StringFilter>;
  entityType?: Maybe<EnumEmailProviderLogEntityTypeFilter>;
  id?: Maybe<StringFilter>;
  provider?: Maybe<EnumEmailProviderFilter>;
  providerEmailTemplateId?: Maybe<StringFilter>;
  providerMessageId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailProviderLogWhereUniqueInput = {
  AND?: Maybe<Array<EmailProviderLogWhereInput>>;
  NOT?: Maybe<Array<EmailProviderLogWhereInput>>;
  OR?: Maybe<Array<EmailProviderLogWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entityId?: Maybe<StringFilter>;
  entityType?: Maybe<EnumEmailProviderLogEntityTypeFilter>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EnumEmailProviderFilter>;
  providerEmailTemplateId?: Maybe<StringFilter>;
  providerMessageId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  _count: EmailTemplateCountOutputType;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  emailTemplatesVersions: Array<EmailTemplateVersion>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: EmailTemplateType;
  unlayerSetting: UnlayerSetting;
  unlayerSettingId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type EmailTemplateEmailTemplatesVersionsArgs = {
  cursor?: Maybe<EmailTemplateVersionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailTemplateVersionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailTemplateVersionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailTemplateVersionWhereInput>;
};

export type EmailTemplateAvgAggregateOutputType = {
  __typename?: 'EmailTemplateAvgAggregateOutputType';
  unlayerSettingId?: Maybe<Scalars['Float']>;
};

export type EmailTemplateAvgOrderByAggregateInput = {
  unlayerSettingId?: Maybe<SortOrder>;
};

export type EmailTemplateCountAggregateOutputType = {
  __typename?: 'EmailTemplateCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  lastPublishedAt: Scalars['Int'];
  name: Scalars['Int'];
  type: Scalars['Int'];
  unlayerSettingId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type EmailTemplateCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastPublishedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  unlayerSettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailTemplateCountOutputType = {
  __typename?: 'EmailTemplateCountOutputType';
  emailTemplatesVersions: Scalars['Int'];
};

export type EmailTemplateCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  emailTemplatesVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutEmailTemplateInput>;
  id?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: EmailTemplateType;
  unlayerSetting: UnlayerSettingCreateNestedOneWithoutEmailTemplatesInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: EmailTemplateType;
  unlayerSettingId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateCreateManyUnlayerSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: EmailTemplateType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateCreateManyUnlayerSettingInputEnvelope = {
  data: Array<EmailTemplateCreateManyUnlayerSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailTemplateCreateNestedManyWithoutUnlayerSettingInput = {
  connect?: Maybe<Array<EmailTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailTemplateCreateOrConnectWithoutUnlayerSettingInput>>;
  create?: Maybe<Array<EmailTemplateCreateWithoutUnlayerSettingInput>>;
  createMany?: Maybe<EmailTemplateCreateManyUnlayerSettingInputEnvelope>;
};

export type EmailTemplateCreateNestedOneWithoutEmailTemplatesVersionsInput = {
  connect?: Maybe<EmailTemplateWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailTemplateCreateOrConnectWithoutEmailTemplatesVersionsInput>;
  create?: Maybe<EmailTemplateCreateWithoutEmailTemplatesVersionsInput>;
};

export type EmailTemplateCreateOrConnectWithoutEmailTemplatesVersionsInput = {
  create: EmailTemplateCreateWithoutEmailTemplatesVersionsInput;
  where: EmailTemplateWhereUniqueInput;
};

export type EmailTemplateCreateOrConnectWithoutUnlayerSettingInput = {
  create: EmailTemplateCreateWithoutUnlayerSettingInput;
  where: EmailTemplateWhereUniqueInput;
};

export type EmailTemplateCreateWithoutEmailTemplatesVersionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: EmailTemplateType;
  unlayerSetting: UnlayerSettingCreateNestedOneWithoutEmailTemplatesInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateCreateWithoutUnlayerSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  emailTemplatesVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutEmailTemplateInput>;
  id?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: EmailTemplateType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateGroupByOutputType = {
  __typename?: 'EmailTemplateGroupByOutputType';
  _avg?: Maybe<EmailTemplateAvgAggregateOutputType>;
  _count?: Maybe<EmailTemplateCountAggregateOutputType>;
  _max?: Maybe<EmailTemplateMaxAggregateOutputType>;
  _min?: Maybe<EmailTemplateMinAggregateOutputType>;
  _sum?: Maybe<EmailTemplateSumAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: EmailTemplateType;
  unlayerSettingId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type EmailTemplateListRelationFilter = {
  every?: Maybe<EmailTemplateWhereInput>;
  none?: Maybe<EmailTemplateWhereInput>;
  some?: Maybe<EmailTemplateWhereInput>;
};

export type EmailTemplateMaxAggregateOutputType = {
  __typename?: 'EmailTemplateMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateType>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastPublishedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  unlayerSettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailTemplateMinAggregateOutputType = {
  __typename?: 'EmailTemplateMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateType>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastPublishedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  unlayerSettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailTemplateOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EmailTemplateOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailTemplateOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  emailTemplatesVersions?: Maybe<EmailTemplateVersionOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastPublishedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  unlayerSetting?: Maybe<UnlayerSettingOrderByWithRelationInput>;
  unlayerSettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmailTemplateOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type EmailTemplateOrderByRelevanceInput = {
  fields: Array<EmailTemplateOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EmailTemplateOrderByWithAggregationInput = {
  _avg?: Maybe<EmailTemplateAvgOrderByAggregateInput>;
  _count?: Maybe<EmailTemplateCountOrderByAggregateInput>;
  _max?: Maybe<EmailTemplateMaxOrderByAggregateInput>;
  _min?: Maybe<EmailTemplateMinOrderByAggregateInput>;
  _sum?: Maybe<EmailTemplateSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastPublishedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  unlayerSettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailTemplateOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailTemplateOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  emailTemplatesVersions?: Maybe<EmailTemplateVersionOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastPublishedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  unlayerSetting?: Maybe<UnlayerSettingOrderByWithRelationInput>;
  unlayerSettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmailTemplateOrderByWithRelationInput = {
  _relevance?: Maybe<EmailTemplateOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  emailTemplatesVersions?: Maybe<EmailTemplateVersionOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  lastPublishedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  unlayerSetting?: Maybe<UnlayerSettingOrderByWithRelationInput>;
  unlayerSettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmailTemplateScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  IsActive = 'isActive',
  LastPublishedAt = 'lastPublishedAt',
  Name = 'name',
  Type = 'type',
  UnlayerSettingId = 'unlayerSettingId',
  UpdatedAt = 'updatedAt'
}

export type EmailTemplateScalarRelationFilter = {
  AND?: Maybe<Array<EmailTemplateWhereInput>>;
  NOT?: Maybe<Array<EmailTemplateWhereInput>>;
  OR?: Maybe<Array<EmailTemplateWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  emailTemplatesVersions?: Maybe<EmailTemplateVersionListRelationFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  lastPublishedAt?: Maybe<DateTimeNullableFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<EnumEmailTemplateTypeFilter>;
  unlayerSetting?: Maybe<UnlayerSettingScalarRelationFilter>;
  unlayerSettingId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailTemplateScalarWhereInput = {
  AND?: Maybe<Array<EmailTemplateScalarWhereInput>>;
  NOT?: Maybe<Array<EmailTemplateScalarWhereInput>>;
  OR?: Maybe<Array<EmailTemplateScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  lastPublishedAt?: Maybe<DateTimeNullableFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<EnumEmailTemplateTypeFilter>;
  unlayerSettingId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailTemplateScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EmailTemplateScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EmailTemplateScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EmailTemplateScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  lastPublishedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumEmailTemplateTypeWithAggregatesFilter>;
  unlayerSettingId?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type EmailTemplateSumAggregateOutputType = {
  __typename?: 'EmailTemplateSumAggregateOutputType';
  unlayerSettingId?: Maybe<Scalars['Int']>;
};

export type EmailTemplateSumOrderByAggregateInput = {
  unlayerSettingId?: Maybe<SortOrder>;
};

export enum EmailTemplateType {
  ServiceReminder = 'ServiceReminder'
}

export type EmailTemplateUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  emailTemplatesVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutEmailTemplateInput>;
  id?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: EmailTemplateType;
  unlayerSettingId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateUncheckedCreateNestedManyWithoutUnlayerSettingInput = {
  connect?: Maybe<Array<EmailTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailTemplateCreateOrConnectWithoutUnlayerSettingInput>>;
  create?: Maybe<Array<EmailTemplateCreateWithoutUnlayerSettingInput>>;
  createMany?: Maybe<EmailTemplateCreateManyUnlayerSettingInputEnvelope>;
};

export type EmailTemplateUncheckedCreateWithoutEmailTemplatesVersionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: EmailTemplateType;
  unlayerSettingId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateUncheckedCreateWithoutUnlayerSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  emailTemplatesVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutEmailTemplateInput>;
  id?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: EmailTemplateType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailTemplatesVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutEmailTemplateNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateType>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateType>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateUncheckedUpdateManyWithoutUnlayerSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateUncheckedUpdateManyWithoutUnlayerSettingNestedInput = {
  connect?: Maybe<Array<EmailTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailTemplateCreateOrConnectWithoutUnlayerSettingInput>>;
  create?: Maybe<Array<EmailTemplateCreateWithoutUnlayerSettingInput>>;
  createMany?: Maybe<EmailTemplateCreateManyUnlayerSettingInputEnvelope>;
  delete?: Maybe<Array<EmailTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailTemplateWhereUniqueInput>>;
  set?: Maybe<Array<EmailTemplateWhereUniqueInput>>;
  update?: Maybe<Array<EmailTemplateUpdateWithWhereUniqueWithoutUnlayerSettingInput>>;
  updateMany?: Maybe<Array<EmailTemplateUpdateManyWithWhereWithoutUnlayerSettingInput>>;
  upsert?: Maybe<Array<EmailTemplateUpsertWithWhereUniqueWithoutUnlayerSettingInput>>;
};

export type EmailTemplateUncheckedUpdateWithoutEmailTemplatesVersionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateType>;
  unlayerSettingId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateUncheckedUpdateWithoutUnlayerSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailTemplatesVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutEmailTemplateNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailTemplatesVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutEmailTemplateNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateType>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneRequiredWithoutEmailTemplatesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateUpdateManyWithWhereWithoutUnlayerSettingInput = {
  data: EmailTemplateUpdateManyMutationInput;
  where: EmailTemplateScalarWhereInput;
};

export type EmailTemplateUpdateManyWithoutUnlayerSettingNestedInput = {
  connect?: Maybe<Array<EmailTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailTemplateCreateOrConnectWithoutUnlayerSettingInput>>;
  create?: Maybe<Array<EmailTemplateCreateWithoutUnlayerSettingInput>>;
  createMany?: Maybe<EmailTemplateCreateManyUnlayerSettingInputEnvelope>;
  delete?: Maybe<Array<EmailTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailTemplateWhereUniqueInput>>;
  set?: Maybe<Array<EmailTemplateWhereUniqueInput>>;
  update?: Maybe<Array<EmailTemplateUpdateWithWhereUniqueWithoutUnlayerSettingInput>>;
  updateMany?: Maybe<Array<EmailTemplateUpdateManyWithWhereWithoutUnlayerSettingInput>>;
  upsert?: Maybe<Array<EmailTemplateUpsertWithWhereUniqueWithoutUnlayerSettingInput>>;
};

export type EmailTemplateUpdateOneRequiredWithoutEmailTemplatesVersionsNestedInput = {
  connect?: Maybe<EmailTemplateWhereUniqueInput>;
  connectOrCreate?: Maybe<EmailTemplateCreateOrConnectWithoutEmailTemplatesVersionsInput>;
  create?: Maybe<EmailTemplateCreateWithoutEmailTemplatesVersionsInput>;
  update?: Maybe<EmailTemplateUpdateToOneWithWhereWithoutEmailTemplatesVersionsInput>;
  upsert?: Maybe<EmailTemplateUpsertWithoutEmailTemplatesVersionsInput>;
};

export type EmailTemplateUpdateToOneWithWhereWithoutEmailTemplatesVersionsInput = {
  data: EmailTemplateUpdateWithoutEmailTemplatesVersionsInput;
  where?: Maybe<EmailTemplateWhereInput>;
};

export type EmailTemplateUpdateWithWhereUniqueWithoutUnlayerSettingInput = {
  data: EmailTemplateUpdateWithoutUnlayerSettingInput;
  where: EmailTemplateWhereUniqueInput;
};

export type EmailTemplateUpdateWithoutEmailTemplatesVersionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateType>;
  unlayerSetting?: Maybe<UnlayerSettingUpdateOneRequiredWithoutEmailTemplatesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateUpdateWithoutUnlayerSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailTemplatesVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutEmailTemplateNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailTemplateUpsertWithWhereUniqueWithoutUnlayerSettingInput = {
  create: EmailTemplateCreateWithoutUnlayerSettingInput;
  update: EmailTemplateUpdateWithoutUnlayerSettingInput;
  where: EmailTemplateWhereUniqueInput;
};

export type EmailTemplateUpsertWithoutEmailTemplatesVersionsInput = {
  create: EmailTemplateCreateWithoutEmailTemplatesVersionsInput;
  update: EmailTemplateUpdateWithoutEmailTemplatesVersionsInput;
  where?: Maybe<EmailTemplateWhereInput>;
};

export type EmailTemplateVersion = {
  __typename?: 'EmailTemplateVersion';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  design: Scalars['Json'];
  emailTemplate: EmailTemplate;
  emailTemplateId: Scalars['String'];
  html: Scalars['String'];
  id: Scalars['String'];
  isCurrent: Scalars['Boolean'];
  lastEditedBy?: Maybe<User>;
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
};


export type EmailTemplateVersionLastEditedByArgs = {
  where?: Maybe<UserWhereInput>;
};

export type EmailTemplateVersionAvgAggregateOutputType = {
  __typename?: 'EmailTemplateVersionAvgAggregateOutputType';
  version?: Maybe<Scalars['Float']>;
};

export type EmailTemplateVersionAvgOrderByAggregateInput = {
  version?: Maybe<SortOrder>;
};

export type EmailTemplateVersionCountAggregateOutputType = {
  __typename?: 'EmailTemplateVersionCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  design: Scalars['Int'];
  emailTemplateId: Scalars['Int'];
  html: Scalars['Int'];
  id: Scalars['Int'];
  isCurrent: Scalars['Int'];
  lastEditedById: Scalars['Int'];
  previewImageUrl: Scalars['Int'];
  publishedAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
  version: Scalars['Int'];
};

export type EmailTemplateVersionCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  design?: Maybe<SortOrder>;
  emailTemplateId?: Maybe<SortOrder>;
  html?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCurrent?: Maybe<SortOrder>;
  lastEditedById?: Maybe<SortOrder>;
  previewImageUrl?: Maybe<SortOrder>;
  publishedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
};

export type EmailTemplateVersionCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design: Scalars['Json'];
  emailTemplate: EmailTemplateCreateNestedOneWithoutEmailTemplatesVersionsInput;
  html: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedBy?: Maybe<UserCreateNestedOneWithoutEmailTemplateVersionsInput>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionCreateManyEmailTemplateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design: Scalars['Json'];
  html: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionCreateManyEmailTemplateInputEnvelope = {
  data: Array<EmailTemplateVersionCreateManyEmailTemplateInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailTemplateVersionCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design: Scalars['Json'];
  emailTemplateId: Scalars['String'];
  html: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionCreateManyLastEditedByInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design: Scalars['Json'];
  emailTemplateId: Scalars['String'];
  html: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionCreateManyLastEditedByInputEnvelope = {
  data: Array<EmailTemplateVersionCreateManyLastEditedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmailTemplateVersionCreateNestedManyWithoutEmailTemplateInput = {
  connect?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailTemplateVersionCreateOrConnectWithoutEmailTemplateInput>>;
  create?: Maybe<Array<EmailTemplateVersionCreateWithoutEmailTemplateInput>>;
  createMany?: Maybe<EmailTemplateVersionCreateManyEmailTemplateInputEnvelope>;
};

export type EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput = {
  connect?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailTemplateVersionCreateOrConnectWithoutLastEditedByInput>>;
  create?: Maybe<Array<EmailTemplateVersionCreateWithoutLastEditedByInput>>;
  createMany?: Maybe<EmailTemplateVersionCreateManyLastEditedByInputEnvelope>;
};

export type EmailTemplateVersionCreateOrConnectWithoutEmailTemplateInput = {
  create: EmailTemplateVersionCreateWithoutEmailTemplateInput;
  where: EmailTemplateVersionWhereUniqueInput;
};

export type EmailTemplateVersionCreateOrConnectWithoutLastEditedByInput = {
  create: EmailTemplateVersionCreateWithoutLastEditedByInput;
  where: EmailTemplateVersionWhereUniqueInput;
};

export type EmailTemplateVersionCreateWithoutEmailTemplateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design: Scalars['Json'];
  html: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedBy?: Maybe<UserCreateNestedOneWithoutEmailTemplateVersionsInput>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionCreateWithoutLastEditedByInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design: Scalars['Json'];
  emailTemplate: EmailTemplateCreateNestedOneWithoutEmailTemplatesVersionsInput;
  html: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionGroupByOutputType = {
  __typename?: 'EmailTemplateVersionGroupByOutputType';
  _avg?: Maybe<EmailTemplateVersionAvgAggregateOutputType>;
  _count?: Maybe<EmailTemplateVersionCountAggregateOutputType>;
  _max?: Maybe<EmailTemplateVersionMaxAggregateOutputType>;
  _min?: Maybe<EmailTemplateVersionMinAggregateOutputType>;
  _sum?: Maybe<EmailTemplateVersionSumAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  design: Scalars['Json'];
  emailTemplateId: Scalars['String'];
  html: Scalars['String'];
  id: Scalars['String'];
  isCurrent: Scalars['Boolean'];
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
};

export type EmailTemplateVersionListRelationFilter = {
  every?: Maybe<EmailTemplateVersionWhereInput>;
  none?: Maybe<EmailTemplateVersionWhereInput>;
  some?: Maybe<EmailTemplateVersionWhereInput>;
};

export type EmailTemplateVersionMaxAggregateOutputType = {
  __typename?: 'EmailTemplateVersionMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailTemplateId?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  emailTemplateId?: Maybe<SortOrder>;
  html?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCurrent?: Maybe<SortOrder>;
  lastEditedById?: Maybe<SortOrder>;
  previewImageUrl?: Maybe<SortOrder>;
  publishedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
};

export type EmailTemplateVersionMinAggregateOutputType = {
  __typename?: 'EmailTemplateVersionMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailTemplateId?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  emailTemplateId?: Maybe<SortOrder>;
  html?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCurrent?: Maybe<SortOrder>;
  lastEditedById?: Maybe<SortOrder>;
  previewImageUrl?: Maybe<SortOrder>;
  publishedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
};

export type EmailTemplateVersionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EmailTemplateVersionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailTemplateVersionOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  design?: Maybe<SortOrder>;
  emailTemplate?: Maybe<EmailTemplateOrderByWithRelationInput>;
  emailTemplateId?: Maybe<SortOrder>;
  html?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCurrent?: Maybe<SortOrder>;
  lastEditedBy?: Maybe<UserOrderByWithRelationInput>;
  lastEditedById?: Maybe<SortOrder>;
  previewImageUrl?: Maybe<SortOrder>;
  publishedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
};

export enum EmailTemplateVersionOrderByRelevanceFieldEnum {
  EmailTemplateId = 'emailTemplateId',
  Html = 'html',
  Id = 'id',
  LastEditedById = 'lastEditedById',
  PreviewImageUrl = 'previewImageUrl'
}

export type EmailTemplateVersionOrderByRelevanceInput = {
  fields: Array<EmailTemplateVersionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EmailTemplateVersionOrderByWithAggregationInput = {
  _avg?: Maybe<EmailTemplateVersionAvgOrderByAggregateInput>;
  _count?: Maybe<EmailTemplateVersionCountOrderByAggregateInput>;
  _max?: Maybe<EmailTemplateVersionMaxOrderByAggregateInput>;
  _min?: Maybe<EmailTemplateVersionMinOrderByAggregateInput>;
  _sum?: Maybe<EmailTemplateVersionSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  design?: Maybe<SortOrder>;
  emailTemplateId?: Maybe<SortOrder>;
  html?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCurrent?: Maybe<SortOrder>;
  lastEditedById?: Maybe<SortOrder>;
  previewImageUrl?: Maybe<SortOrder>;
  publishedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
};

export type EmailTemplateVersionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmailTemplateVersionOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  design?: Maybe<SortOrder>;
  emailTemplate?: Maybe<EmailTemplateOrderByWithRelationInput>;
  emailTemplateId?: Maybe<SortOrder>;
  html?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCurrent?: Maybe<SortOrder>;
  lastEditedBy?: Maybe<UserOrderByWithRelationInput>;
  lastEditedById?: Maybe<SortOrder>;
  previewImageUrl?: Maybe<SortOrder>;
  publishedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
};

export type EmailTemplateVersionOrderByWithRelationInput = {
  _relevance?: Maybe<EmailTemplateVersionOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  design?: Maybe<SortOrder>;
  emailTemplate?: Maybe<EmailTemplateOrderByWithRelationInput>;
  emailTemplateId?: Maybe<SortOrder>;
  html?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCurrent?: Maybe<SortOrder>;
  lastEditedBy?: Maybe<UserOrderByWithRelationInput>;
  lastEditedById?: Maybe<SortOrder>;
  previewImageUrl?: Maybe<SortOrder>;
  publishedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
};

export enum EmailTemplateVersionScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Design = 'design',
  EmailTemplateId = 'emailTemplateId',
  Html = 'html',
  Id = 'id',
  IsCurrent = 'isCurrent',
  LastEditedById = 'lastEditedById',
  PreviewImageUrl = 'previewImageUrl',
  PublishedAt = 'publishedAt',
  UpdatedAt = 'updatedAt',
  Version = 'version'
}

export type EmailTemplateVersionScalarWhereInput = {
  AND?: Maybe<Array<EmailTemplateVersionScalarWhereInput>>;
  NOT?: Maybe<Array<EmailTemplateVersionScalarWhereInput>>;
  OR?: Maybe<Array<EmailTemplateVersionScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  design?: Maybe<JsonFilter>;
  emailTemplateId?: Maybe<StringFilter>;
  html?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  isCurrent?: Maybe<BoolFilter>;
  lastEditedById?: Maybe<StringNullableFilter>;
  previewImageUrl?: Maybe<StringNullableFilter>;
  publishedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  version?: Maybe<IntFilter>;
};

export type EmailTemplateVersionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EmailTemplateVersionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EmailTemplateVersionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EmailTemplateVersionScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  design?: Maybe<JsonWithAggregatesFilter>;
  emailTemplateId?: Maybe<StringWithAggregatesFilter>;
  html?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isCurrent?: Maybe<BoolWithAggregatesFilter>;
  lastEditedById?: Maybe<StringNullableWithAggregatesFilter>;
  previewImageUrl?: Maybe<StringNullableWithAggregatesFilter>;
  publishedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  version?: Maybe<IntWithAggregatesFilter>;
};

export type EmailTemplateVersionSumAggregateOutputType = {
  __typename?: 'EmailTemplateVersionSumAggregateOutputType';
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionSumOrderByAggregateInput = {
  version?: Maybe<SortOrder>;
};

export type EmailTemplateVersionUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design: Scalars['Json'];
  emailTemplateId: Scalars['String'];
  html: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUncheckedCreateNestedManyWithoutEmailTemplateInput = {
  connect?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailTemplateVersionCreateOrConnectWithoutEmailTemplateInput>>;
  create?: Maybe<Array<EmailTemplateVersionCreateWithoutEmailTemplateInput>>;
  createMany?: Maybe<EmailTemplateVersionCreateManyEmailTemplateInputEnvelope>;
};

export type EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput = {
  connect?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailTemplateVersionCreateOrConnectWithoutLastEditedByInput>>;
  create?: Maybe<Array<EmailTemplateVersionCreateWithoutLastEditedByInput>>;
  createMany?: Maybe<EmailTemplateVersionCreateManyLastEditedByInputEnvelope>;
};

export type EmailTemplateVersionUncheckedCreateWithoutEmailTemplateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design: Scalars['Json'];
  html: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUncheckedCreateWithoutLastEditedByInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design: Scalars['Json'];
  emailTemplateId: Scalars['String'];
  html: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design?: Maybe<Scalars['Json']>;
  emailTemplateId?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design?: Maybe<Scalars['Json']>;
  emailTemplateId?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUncheckedUpdateManyWithoutEmailTemplateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design?: Maybe<Scalars['Json']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUncheckedUpdateManyWithoutEmailTemplateNestedInput = {
  connect?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailTemplateVersionCreateOrConnectWithoutEmailTemplateInput>>;
  create?: Maybe<Array<EmailTemplateVersionCreateWithoutEmailTemplateInput>>;
  createMany?: Maybe<EmailTemplateVersionCreateManyEmailTemplateInputEnvelope>;
  delete?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailTemplateVersionScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  set?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  update?: Maybe<Array<EmailTemplateVersionUpdateWithWhereUniqueWithoutEmailTemplateInput>>;
  updateMany?: Maybe<Array<EmailTemplateVersionUpdateManyWithWhereWithoutEmailTemplateInput>>;
  upsert?: Maybe<Array<EmailTemplateVersionUpsertWithWhereUniqueWithoutEmailTemplateInput>>;
};

export type EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design?: Maybe<Scalars['Json']>;
  emailTemplateId?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput = {
  connect?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailTemplateVersionCreateOrConnectWithoutLastEditedByInput>>;
  create?: Maybe<Array<EmailTemplateVersionCreateWithoutLastEditedByInput>>;
  createMany?: Maybe<EmailTemplateVersionCreateManyLastEditedByInputEnvelope>;
  delete?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailTemplateVersionScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  set?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  update?: Maybe<Array<EmailTemplateVersionUpdateWithWhereUniqueWithoutLastEditedByInput>>;
  updateMany?: Maybe<Array<EmailTemplateVersionUpdateManyWithWhereWithoutLastEditedByInput>>;
  upsert?: Maybe<Array<EmailTemplateVersionUpsertWithWhereUniqueWithoutLastEditedByInput>>;
};

export type EmailTemplateVersionUncheckedUpdateWithoutEmailTemplateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design?: Maybe<Scalars['Json']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedById?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUncheckedUpdateWithoutLastEditedByInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design?: Maybe<Scalars['Json']>;
  emailTemplateId?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design?: Maybe<Scalars['Json']>;
  emailTemplate?: Maybe<EmailTemplateUpdateOneRequiredWithoutEmailTemplatesVersionsNestedInput>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedBy?: Maybe<UserUpdateOneWithoutEmailTemplateVersionsNestedInput>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design?: Maybe<Scalars['Json']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUpdateManyWithWhereWithoutEmailTemplateInput = {
  data: EmailTemplateVersionUpdateManyMutationInput;
  where: EmailTemplateVersionScalarWhereInput;
};

export type EmailTemplateVersionUpdateManyWithWhereWithoutLastEditedByInput = {
  data: EmailTemplateVersionUpdateManyMutationInput;
  where: EmailTemplateVersionScalarWhereInput;
};

export type EmailTemplateVersionUpdateManyWithoutEmailTemplateNestedInput = {
  connect?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailTemplateVersionCreateOrConnectWithoutEmailTemplateInput>>;
  create?: Maybe<Array<EmailTemplateVersionCreateWithoutEmailTemplateInput>>;
  createMany?: Maybe<EmailTemplateVersionCreateManyEmailTemplateInputEnvelope>;
  delete?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailTemplateVersionScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  set?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  update?: Maybe<Array<EmailTemplateVersionUpdateWithWhereUniqueWithoutEmailTemplateInput>>;
  updateMany?: Maybe<Array<EmailTemplateVersionUpdateManyWithWhereWithoutEmailTemplateInput>>;
  upsert?: Maybe<Array<EmailTemplateVersionUpsertWithWhereUniqueWithoutEmailTemplateInput>>;
};

export type EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput = {
  connect?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmailTemplateVersionCreateOrConnectWithoutLastEditedByInput>>;
  create?: Maybe<Array<EmailTemplateVersionCreateWithoutLastEditedByInput>>;
  createMany?: Maybe<EmailTemplateVersionCreateManyLastEditedByInputEnvelope>;
  delete?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmailTemplateVersionScalarWhereInput>>;
  disconnect?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  set?: Maybe<Array<EmailTemplateVersionWhereUniqueInput>>;
  update?: Maybe<Array<EmailTemplateVersionUpdateWithWhereUniqueWithoutLastEditedByInput>>;
  updateMany?: Maybe<Array<EmailTemplateVersionUpdateManyWithWhereWithoutLastEditedByInput>>;
  upsert?: Maybe<Array<EmailTemplateVersionUpsertWithWhereUniqueWithoutLastEditedByInput>>;
};

export type EmailTemplateVersionUpdateWithWhereUniqueWithoutEmailTemplateInput = {
  data: EmailTemplateVersionUpdateWithoutEmailTemplateInput;
  where: EmailTemplateVersionWhereUniqueInput;
};

export type EmailTemplateVersionUpdateWithWhereUniqueWithoutLastEditedByInput = {
  data: EmailTemplateVersionUpdateWithoutLastEditedByInput;
  where: EmailTemplateVersionWhereUniqueInput;
};

export type EmailTemplateVersionUpdateWithoutEmailTemplateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design?: Maybe<Scalars['Json']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  lastEditedBy?: Maybe<UserUpdateOneWithoutEmailTemplateVersionsNestedInput>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUpdateWithoutLastEditedByInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  design?: Maybe<Scalars['Json']>;
  emailTemplate?: Maybe<EmailTemplateUpdateOneRequiredWithoutEmailTemplatesVersionsNestedInput>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export type EmailTemplateVersionUpsertWithWhereUniqueWithoutEmailTemplateInput = {
  create: EmailTemplateVersionCreateWithoutEmailTemplateInput;
  update: EmailTemplateVersionUpdateWithoutEmailTemplateInput;
  where: EmailTemplateVersionWhereUniqueInput;
};

export type EmailTemplateVersionUpsertWithWhereUniqueWithoutLastEditedByInput = {
  create: EmailTemplateVersionCreateWithoutLastEditedByInput;
  update: EmailTemplateVersionUpdateWithoutLastEditedByInput;
  where: EmailTemplateVersionWhereUniqueInput;
};

export type EmailTemplateVersionWhereInput = {
  AND?: Maybe<Array<EmailTemplateVersionWhereInput>>;
  NOT?: Maybe<Array<EmailTemplateVersionWhereInput>>;
  OR?: Maybe<Array<EmailTemplateVersionWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  design?: Maybe<JsonFilter>;
  emailTemplate?: Maybe<EmailTemplateScalarRelationFilter>;
  emailTemplateId?: Maybe<StringFilter>;
  html?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  isCurrent?: Maybe<BoolFilter>;
  lastEditedBy?: Maybe<UserNullableScalarRelationFilter>;
  lastEditedById?: Maybe<StringNullableFilter>;
  previewImageUrl?: Maybe<StringNullableFilter>;
  publishedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  version?: Maybe<IntFilter>;
};

export type EmailTemplateVersionWhereUniqueInput = {
  AND?: Maybe<Array<EmailTemplateVersionWhereInput>>;
  NOT?: Maybe<Array<EmailTemplateVersionWhereInput>>;
  OR?: Maybe<Array<EmailTemplateVersionWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  design?: Maybe<JsonFilter>;
  emailTemplate?: Maybe<EmailTemplateScalarRelationFilter>;
  emailTemplateId?: Maybe<StringFilter>;
  html?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<BoolFilter>;
  lastEditedBy?: Maybe<UserNullableScalarRelationFilter>;
  lastEditedById?: Maybe<StringNullableFilter>;
  previewImageUrl?: Maybe<StringNullableFilter>;
  publishedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  version?: Maybe<IntFilter>;
};

export type EmailTemplateWhereInput = {
  AND?: Maybe<Array<EmailTemplateWhereInput>>;
  NOT?: Maybe<Array<EmailTemplateWhereInput>>;
  OR?: Maybe<Array<EmailTemplateWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  emailTemplatesVersions?: Maybe<EmailTemplateVersionListRelationFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  lastPublishedAt?: Maybe<DateTimeNullableFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<EnumEmailTemplateTypeFilter>;
  unlayerSetting?: Maybe<UnlayerSettingScalarRelationFilter>;
  unlayerSettingId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmailTemplateWhereUniqueInput = {
  AND?: Maybe<Array<EmailTemplateWhereInput>>;
  NOT?: Maybe<Array<EmailTemplateWhereInput>>;
  OR?: Maybe<Array<EmailTemplateWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  emailTemplatesVersions?: Maybe<EmailTemplateVersionListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolFilter>;
  lastPublishedAt?: Maybe<DateTimeNullableFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<EnumEmailTemplateTypeFilter>;
  unlayerSetting?: Maybe<UnlayerSettingScalarRelationFilter>;
  unlayerSettingId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmbedUrl = {
  __typename?: 'EmbedURL';
  EmbedUrl?: Maybe<Scalars['String']>;
  RequestId?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['Int']>;
};

export type EmergencyClinicContactInfo = {
  __typename?: 'EmergencyClinicContactInfo';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type EmergencyClinics = {
  __typename?: 'EmergencyClinics';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicSetting: ClinicSetting;
  clinicSettingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayOrder: Scalars['Int'];
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type EmergencyClinicsAvgAggregateOutputType = {
  __typename?: 'EmergencyClinicsAvgAggregateOutputType';
  displayOrder?: Maybe<Scalars['Float']>;
};

export type EmergencyClinicsAvgOrderByAggregateInput = {
  displayOrder?: Maybe<SortOrder>;
};

export type EmergencyClinicsClinicSettingIdDisplayOrderCompoundUniqueInput = {
  clinicSettingId: Scalars['String'];
  displayOrder: Scalars['Int'];
};

export type EmergencyClinicsCountAggregateOutputType = {
  __typename?: 'EmergencyClinicsCountAggregateOutputType';
  _all: Scalars['Int'];
  addressLine1: Scalars['Int'];
  addressLine2: Scalars['Int'];
  city: Scalars['Int'];
  clinicSettingId: Scalars['Int'];
  createdAt: Scalars['Int'];
  displayOrder: Scalars['Int'];
  fullAddress: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  name: Scalars['Int'];
  phone: Scalars['Int'];
  postalCode: Scalars['Int'];
  state: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type EmergencyClinicsCountOrderByAggregateInput = {
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  fullAddress?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmergencyClinicsCreateInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicSetting: ClinicSettingCreateNestedOneWithoutEmergencyClinicsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder: Scalars['Int'];
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsCreateManyClinicSettingInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder: Scalars['Int'];
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsCreateManyClinicSettingInputEnvelope = {
  data: Array<EmergencyClinicsCreateManyClinicSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EmergencyClinicsCreateManyInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicSettingId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder: Scalars['Int'];
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsCreateNestedManyWithoutClinicSettingInput = {
  connect?: Maybe<Array<EmergencyClinicsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmergencyClinicsCreateOrConnectWithoutClinicSettingInput>>;
  create?: Maybe<Array<EmergencyClinicsCreateWithoutClinicSettingInput>>;
  createMany?: Maybe<EmergencyClinicsCreateManyClinicSettingInputEnvelope>;
};

export type EmergencyClinicsCreateOrConnectWithoutClinicSettingInput = {
  create: EmergencyClinicsCreateWithoutClinicSettingInput;
  where: EmergencyClinicsWhereUniqueInput;
};

export type EmergencyClinicsCreateWithoutClinicSettingInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder: Scalars['Int'];
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsGroupByOutputType = {
  __typename?: 'EmergencyClinicsGroupByOutputType';
  _avg?: Maybe<EmergencyClinicsAvgAggregateOutputType>;
  _count?: Maybe<EmergencyClinicsCountAggregateOutputType>;
  _max?: Maybe<EmergencyClinicsMaxAggregateOutputType>;
  _min?: Maybe<EmergencyClinicsMinAggregateOutputType>;
  _sum?: Maybe<EmergencyClinicsSumAggregateOutputType>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicSettingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayOrder: Scalars['Int'];
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type EmergencyClinicsListRelationFilter = {
  every?: Maybe<EmergencyClinicsWhereInput>;
  none?: Maybe<EmergencyClinicsWhereInput>;
  some?: Maybe<EmergencyClinicsWhereInput>;
};

export type EmergencyClinicsMaxAggregateOutputType = {
  __typename?: 'EmergencyClinicsMaxAggregateOutputType';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsMaxOrderByAggregateInput = {
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  fullAddress?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmergencyClinicsMinAggregateOutputType = {
  __typename?: 'EmergencyClinicsMinAggregateOutputType';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsMinOrderByAggregateInput = {
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  fullAddress?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmergencyClinicsOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EmergencyClinicsOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmergencyClinicsOrderByRelevanceInput>;
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  fullAddress?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmergencyClinicsOrderByRelevanceFieldEnum {
  AddressLine1 = 'addressLine1',
  AddressLine2 = 'addressLine2',
  City = 'city',
  ClinicSettingId = 'clinicSettingId',
  FullAddress = 'fullAddress',
  Id = 'id',
  Name = 'name',
  Phone = 'phone',
  PostalCode = 'postalCode',
  State = 'state'
}

export type EmergencyClinicsOrderByRelevanceInput = {
  fields: Array<EmergencyClinicsOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EmergencyClinicsOrderByWithAggregationInput = {
  _avg?: Maybe<EmergencyClinicsAvgOrderByAggregateInput>;
  _count?: Maybe<EmergencyClinicsCountOrderByAggregateInput>;
  _max?: Maybe<EmergencyClinicsMaxOrderByAggregateInput>;
  _min?: Maybe<EmergencyClinicsMinOrderByAggregateInput>;
  _sum?: Maybe<EmergencyClinicsSumOrderByAggregateInput>;
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  fullAddress?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmergencyClinicsOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EmergencyClinicsOrderByRelevanceInput>;
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  fullAddress?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EmergencyClinicsOrderByWithRelationInput = {
  _relevance?: Maybe<EmergencyClinicsOrderByRelevanceInput>;
  addressLine1?: Maybe<SortOrder>;
  addressLine2?: Maybe<SortOrder>;
  city?: Maybe<SortOrder>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  displayOrder?: Maybe<SortOrder>;
  fullAddress?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EmergencyClinicsScalarFieldEnum {
  AddressLine1 = 'addressLine1',
  AddressLine2 = 'addressLine2',
  City = 'city',
  ClinicSettingId = 'clinicSettingId',
  CreatedAt = 'createdAt',
  DisplayOrder = 'displayOrder',
  FullAddress = 'fullAddress',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Name = 'name',
  Phone = 'phone',
  PostalCode = 'postalCode',
  State = 'state',
  UpdatedAt = 'updatedAt'
}

export type EmergencyClinicsScalarWhereInput = {
  AND?: Maybe<Array<EmergencyClinicsScalarWhereInput>>;
  NOT?: Maybe<Array<EmergencyClinicsScalarWhereInput>>;
  OR?: Maybe<Array<EmergencyClinicsScalarWhereInput>>;
  addressLine1?: Maybe<StringNullableFilter>;
  addressLine2?: Maybe<StringNullableFilter>;
  city?: Maybe<StringNullableFilter>;
  clinicSettingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  displayOrder?: Maybe<IntFilter>;
  fullAddress?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  phone?: Maybe<StringFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  state?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmergencyClinicsScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EmergencyClinicsScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EmergencyClinicsScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EmergencyClinicsScalarWhereWithAggregatesInput>>;
  addressLine1?: Maybe<StringNullableWithAggregatesFilter>;
  addressLine2?: Maybe<StringNullableWithAggregatesFilter>;
  city?: Maybe<StringNullableWithAggregatesFilter>;
  clinicSettingId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  displayOrder?: Maybe<IntWithAggregatesFilter>;
  fullAddress?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  phone?: Maybe<StringWithAggregatesFilter>;
  postalCode?: Maybe<StringNullableWithAggregatesFilter>;
  state?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type EmergencyClinicsSumAggregateOutputType = {
  __typename?: 'EmergencyClinicsSumAggregateOutputType';
  displayOrder?: Maybe<Scalars['Int']>;
};

export type EmergencyClinicsSumOrderByAggregateInput = {
  displayOrder?: Maybe<SortOrder>;
};

export type EmergencyClinicsUncheckedCreateInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicSettingId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder: Scalars['Int'];
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsUncheckedCreateNestedManyWithoutClinicSettingInput = {
  connect?: Maybe<Array<EmergencyClinicsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmergencyClinicsCreateOrConnectWithoutClinicSettingInput>>;
  create?: Maybe<Array<EmergencyClinicsCreateWithoutClinicSettingInput>>;
  createMany?: Maybe<EmergencyClinicsCreateManyClinicSettingInputEnvelope>;
};

export type EmergencyClinicsUncheckedCreateWithoutClinicSettingInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder: Scalars['Int'];
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsUncheckedUpdateInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsUncheckedUpdateManyInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsUncheckedUpdateManyWithoutClinicSettingInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsUncheckedUpdateManyWithoutClinicSettingNestedInput = {
  connect?: Maybe<Array<EmergencyClinicsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmergencyClinicsCreateOrConnectWithoutClinicSettingInput>>;
  create?: Maybe<Array<EmergencyClinicsCreateWithoutClinicSettingInput>>;
  createMany?: Maybe<EmergencyClinicsCreateManyClinicSettingInputEnvelope>;
  delete?: Maybe<Array<EmergencyClinicsWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmergencyClinicsScalarWhereInput>>;
  disconnect?: Maybe<Array<EmergencyClinicsWhereUniqueInput>>;
  set?: Maybe<Array<EmergencyClinicsWhereUniqueInput>>;
  update?: Maybe<Array<EmergencyClinicsUpdateWithWhereUniqueWithoutClinicSettingInput>>;
  updateMany?: Maybe<Array<EmergencyClinicsUpdateManyWithWhereWithoutClinicSettingInput>>;
  upsert?: Maybe<Array<EmergencyClinicsUpsertWithWhereUniqueWithoutClinicSettingInput>>;
};

export type EmergencyClinicsUncheckedUpdateWithoutClinicSettingInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsUpdateInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicSetting?: Maybe<ClinicSettingUpdateOneRequiredWithoutEmergencyClinicsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsUpdateManyMutationInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsUpdateManyWithWhereWithoutClinicSettingInput = {
  data: EmergencyClinicsUpdateManyMutationInput;
  where: EmergencyClinicsScalarWhereInput;
};

export type EmergencyClinicsUpdateManyWithoutClinicSettingNestedInput = {
  connect?: Maybe<Array<EmergencyClinicsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EmergencyClinicsCreateOrConnectWithoutClinicSettingInput>>;
  create?: Maybe<Array<EmergencyClinicsCreateWithoutClinicSettingInput>>;
  createMany?: Maybe<EmergencyClinicsCreateManyClinicSettingInputEnvelope>;
  delete?: Maybe<Array<EmergencyClinicsWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EmergencyClinicsScalarWhereInput>>;
  disconnect?: Maybe<Array<EmergencyClinicsWhereUniqueInput>>;
  set?: Maybe<Array<EmergencyClinicsWhereUniqueInput>>;
  update?: Maybe<Array<EmergencyClinicsUpdateWithWhereUniqueWithoutClinicSettingInput>>;
  updateMany?: Maybe<Array<EmergencyClinicsUpdateManyWithWhereWithoutClinicSettingInput>>;
  upsert?: Maybe<Array<EmergencyClinicsUpsertWithWhereUniqueWithoutClinicSettingInput>>;
};

export type EmergencyClinicsUpdateWithWhereUniqueWithoutClinicSettingInput = {
  data: EmergencyClinicsUpdateWithoutClinicSettingInput;
  where: EmergencyClinicsWhereUniqueInput;
};

export type EmergencyClinicsUpdateWithoutClinicSettingInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmergencyClinicsUpsertWithWhereUniqueWithoutClinicSettingInput = {
  create: EmergencyClinicsCreateWithoutClinicSettingInput;
  update: EmergencyClinicsUpdateWithoutClinicSettingInput;
  where: EmergencyClinicsWhereUniqueInput;
};

export type EmergencyClinicsWhereInput = {
  AND?: Maybe<Array<EmergencyClinicsWhereInput>>;
  NOT?: Maybe<Array<EmergencyClinicsWhereInput>>;
  OR?: Maybe<Array<EmergencyClinicsWhereInput>>;
  addressLine1?: Maybe<StringNullableFilter>;
  addressLine2?: Maybe<StringNullableFilter>;
  city?: Maybe<StringNullableFilter>;
  clinicSetting?: Maybe<ClinicSettingScalarRelationFilter>;
  clinicSettingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  displayOrder?: Maybe<IntFilter>;
  fullAddress?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  phone?: Maybe<StringFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  state?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EmergencyClinicsWhereUniqueInput = {
  AND?: Maybe<Array<EmergencyClinicsWhereInput>>;
  NOT?: Maybe<Array<EmergencyClinicsWhereInput>>;
  OR?: Maybe<Array<EmergencyClinicsWhereInput>>;
  addressLine1?: Maybe<StringNullableFilter>;
  addressLine2?: Maybe<StringNullableFilter>;
  city?: Maybe<StringNullableFilter>;
  clinicSetting?: Maybe<ClinicSettingScalarRelationFilter>;
  clinicSettingId?: Maybe<StringFilter>;
  clinicSettingId_displayOrder?: Maybe<EmergencyClinicsClinicSettingIdDisplayOrderCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  displayOrder?: Maybe<IntFilter>;
  fullAddress?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  phone?: Maybe<StringFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  state?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EncryptedClinicUpload = {
  __typename?: 'EncryptedClinicUpload';
  _count: EncryptedClinicUploadCountOutputType;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicListCustomPayoutsConnections: Array<ClinicCustomPayoutsSetup>;
  clinicRepresentativeCustomPayoutsConnections: Array<ClinicCustomPayoutsSetup>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt: Scalars['DateTime'];
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUser?: Maybe<User>;
  uploaderUserId?: Maybe<Scalars['String']>;
};


export type EncryptedClinicUploadClinicListCustomPayoutsConnectionsArgs = {
  cursor?: Maybe<ClinicCustomPayoutsSetupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicCustomPayoutsSetupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicCustomPayoutsSetupOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
};


export type EncryptedClinicUploadClinicRepresentativeCustomPayoutsConnectionsArgs = {
  cursor?: Maybe<ClinicCustomPayoutsSetupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicCustomPayoutsSetupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicCustomPayoutsSetupOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
};


export type EncryptedClinicUploadOrganizationArgs = {
  where?: Maybe<OrganizationWhereInput>;
};


export type EncryptedClinicUploadUploaderUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type EncryptedClinicUploadCountAggregateOutputType = {
  __typename?: 'EncryptedClinicUploadCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  expirationDate: Scalars['Int'];
  id: Scalars['Int'];
  organizationId: Scalars['Int'];
  s3bucket: Scalars['Int'];
  s3key: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  uploaderIP: Scalars['Int'];
  uploaderUserId: Scalars['Int'];
};

export type EncryptedClinicUploadCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  s3bucket?: Maybe<SortOrder>;
  s3key?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploaderIP?: Maybe<SortOrder>;
  uploaderUserId?: Maybe<SortOrder>;
};

export type EncryptedClinicUploadCountOutputType = {
  __typename?: 'EncryptedClinicUploadCountOutputType';
  clinicListCustomPayoutsConnections: Scalars['Int'];
  clinicRepresentativeCustomPayoutsConnections: Scalars['Int'];
};

export type EncryptedClinicUploadCreateInput = {
  clinic: ClinicCreateNestedOneWithoutEncryptedClinicUploadsInput;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupCreateNestedManyWithoutClinicListEncryptedUploadInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupCreateNestedManyWithoutClinicRepresentativeInfoEncryptedUploadInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutAssociatedEncryptedClinicUploadsInput>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUser?: Maybe<UserCreateNestedOneWithoutEncryptedClinicUploadsInput>;
};

export type EncryptedClinicUploadCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadCreateManyClinicInputEnvelope = {
  data: Array<EncryptedClinicUploadCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EncryptedClinicUploadCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadCreateManyOrganizationInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadCreateManyOrganizationInputEnvelope = {
  data: Array<EncryptedClinicUploadCreateManyOrganizationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EncryptedClinicUploadCreateManyUploaderUserInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadCreateManyUploaderUserInputEnvelope = {
  data: Array<EncryptedClinicUploadCreateManyUploaderUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EncryptedClinicUploadCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EncryptedClinicUploadCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EncryptedClinicUploadCreateWithoutClinicInput>>;
  createMany?: Maybe<EncryptedClinicUploadCreateManyClinicInputEnvelope>;
};

export type EncryptedClinicUploadCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EncryptedClinicUploadCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<EncryptedClinicUploadCreateWithoutOrganizationInput>>;
  createMany?: Maybe<EncryptedClinicUploadCreateManyOrganizationInputEnvelope>;
};

export type EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput = {
  connect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EncryptedClinicUploadCreateOrConnectWithoutUploaderUserInput>>;
  create?: Maybe<Array<EncryptedClinicUploadCreateWithoutUploaderUserInput>>;
  createMany?: Maybe<EncryptedClinicUploadCreateManyUploaderUserInputEnvelope>;
};

export type EncryptedClinicUploadCreateNestedOneWithoutClinicListCustomPayoutsConnectionsInput = {
  connect?: Maybe<EncryptedClinicUploadWhereUniqueInput>;
  connectOrCreate?: Maybe<EncryptedClinicUploadCreateOrConnectWithoutClinicListCustomPayoutsConnectionsInput>;
  create?: Maybe<EncryptedClinicUploadCreateWithoutClinicListCustomPayoutsConnectionsInput>;
};

export type EncryptedClinicUploadCreateNestedOneWithoutClinicRepresentativeCustomPayoutsConnectionsInput = {
  connect?: Maybe<EncryptedClinicUploadWhereUniqueInput>;
  connectOrCreate?: Maybe<EncryptedClinicUploadCreateOrConnectWithoutClinicRepresentativeCustomPayoutsConnectionsInput>;
  create?: Maybe<EncryptedClinicUploadCreateWithoutClinicRepresentativeCustomPayoutsConnectionsInput>;
};

export type EncryptedClinicUploadCreateOrConnectWithoutClinicInput = {
  create: EncryptedClinicUploadCreateWithoutClinicInput;
  where: EncryptedClinicUploadWhereUniqueInput;
};

export type EncryptedClinicUploadCreateOrConnectWithoutClinicListCustomPayoutsConnectionsInput = {
  create: EncryptedClinicUploadCreateWithoutClinicListCustomPayoutsConnectionsInput;
  where: EncryptedClinicUploadWhereUniqueInput;
};

export type EncryptedClinicUploadCreateOrConnectWithoutClinicRepresentativeCustomPayoutsConnectionsInput = {
  create: EncryptedClinicUploadCreateWithoutClinicRepresentativeCustomPayoutsConnectionsInput;
  where: EncryptedClinicUploadWhereUniqueInput;
};

export type EncryptedClinicUploadCreateOrConnectWithoutOrganizationInput = {
  create: EncryptedClinicUploadCreateWithoutOrganizationInput;
  where: EncryptedClinicUploadWhereUniqueInput;
};

export type EncryptedClinicUploadCreateOrConnectWithoutUploaderUserInput = {
  create: EncryptedClinicUploadCreateWithoutUploaderUserInput;
  where: EncryptedClinicUploadWhereUniqueInput;
};

export type EncryptedClinicUploadCreateWithoutClinicInput = {
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupCreateNestedManyWithoutClinicListEncryptedUploadInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupCreateNestedManyWithoutClinicRepresentativeInfoEncryptedUploadInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutAssociatedEncryptedClinicUploadsInput>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUser?: Maybe<UserCreateNestedOneWithoutEncryptedClinicUploadsInput>;
};

export type EncryptedClinicUploadCreateWithoutClinicListCustomPayoutsConnectionsInput = {
  clinic: ClinicCreateNestedOneWithoutEncryptedClinicUploadsInput;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupCreateNestedManyWithoutClinicRepresentativeInfoEncryptedUploadInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutAssociatedEncryptedClinicUploadsInput>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUser?: Maybe<UserCreateNestedOneWithoutEncryptedClinicUploadsInput>;
};

export type EncryptedClinicUploadCreateWithoutClinicRepresentativeCustomPayoutsConnectionsInput = {
  clinic: ClinicCreateNestedOneWithoutEncryptedClinicUploadsInput;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupCreateNestedManyWithoutClinicListEncryptedUploadInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutAssociatedEncryptedClinicUploadsInput>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUser?: Maybe<UserCreateNestedOneWithoutEncryptedClinicUploadsInput>;
};

export type EncryptedClinicUploadCreateWithoutOrganizationInput = {
  clinic: ClinicCreateNestedOneWithoutEncryptedClinicUploadsInput;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupCreateNestedManyWithoutClinicListEncryptedUploadInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupCreateNestedManyWithoutClinicRepresentativeInfoEncryptedUploadInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUser?: Maybe<UserCreateNestedOneWithoutEncryptedClinicUploadsInput>;
};

export type EncryptedClinicUploadCreateWithoutUploaderUserInput = {
  clinic: ClinicCreateNestedOneWithoutEncryptedClinicUploadsInput;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupCreateNestedManyWithoutClinicListEncryptedUploadInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupCreateNestedManyWithoutClinicRepresentativeInfoEncryptedUploadInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationCreateNestedOneWithoutAssociatedEncryptedClinicUploadsInput>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadGroupByOutputType = {
  __typename?: 'EncryptedClinicUploadGroupByOutputType';
  _count?: Maybe<EncryptedClinicUploadCountAggregateOutputType>;
  _max?: Maybe<EncryptedClinicUploadMaxAggregateOutputType>;
  _min?: Maybe<EncryptedClinicUploadMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt: Scalars['DateTime'];
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadListRelationFilter = {
  every?: Maybe<EncryptedClinicUploadWhereInput>;
  none?: Maybe<EncryptedClinicUploadWhereInput>;
  some?: Maybe<EncryptedClinicUploadWhereInput>;
};

export type EncryptedClinicUploadMaxAggregateOutputType = {
  __typename?: 'EncryptedClinicUploadMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  s3bucket?: Maybe<SortOrder>;
  s3key?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploaderIP?: Maybe<SortOrder>;
  uploaderUserId?: Maybe<SortOrder>;
};

export type EncryptedClinicUploadMinAggregateOutputType = {
  __typename?: 'EncryptedClinicUploadMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  s3bucket?: Maybe<SortOrder>;
  s3key?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploaderIP?: Maybe<SortOrder>;
  uploaderUserId?: Maybe<SortOrder>;
};

export type EncryptedClinicUploadNullableScalarRelationFilter = {
  AND?: Maybe<Array<EncryptedClinicUploadWhereInput>>;
  NOT?: Maybe<Array<EncryptedClinicUploadWhereInput>>;
  OR?: Maybe<Array<EncryptedClinicUploadWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupListRelationFilter>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  s3bucket?: Maybe<StringFilter>;
  s3key?: Maybe<StringFilter>;
  type?: Maybe<EnumEncryptedClinicUploadTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uploaderIP?: Maybe<StringNullableFilter>;
  uploaderUser?: Maybe<UserNullableScalarRelationFilter>;
  uploaderUserId?: Maybe<StringNullableFilter>;
};

export type EncryptedClinicUploadOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EncryptedClinicUploadOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EncryptedClinicUploadOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupOrderByRelationAggregateInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  s3bucket?: Maybe<SortOrder>;
  s3key?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploaderIP?: Maybe<SortOrder>;
  uploaderUser?: Maybe<UserOrderByWithRelationInput>;
  uploaderUserId?: Maybe<SortOrder>;
};

export enum EncryptedClinicUploadOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Description = 'description',
  Id = 'id',
  OrganizationId = 'organizationId',
  S3bucket = 's3bucket',
  S3key = 's3key',
  UploaderIp = 'uploaderIP',
  UploaderUserId = 'uploaderUserId'
}

export type EncryptedClinicUploadOrderByRelevanceInput = {
  fields: Array<EncryptedClinicUploadOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EncryptedClinicUploadOrderByWithAggregationInput = {
  _count?: Maybe<EncryptedClinicUploadCountOrderByAggregateInput>;
  _max?: Maybe<EncryptedClinicUploadMaxOrderByAggregateInput>;
  _min?: Maybe<EncryptedClinicUploadMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  s3bucket?: Maybe<SortOrder>;
  s3key?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploaderIP?: Maybe<SortOrder>;
  uploaderUserId?: Maybe<SortOrder>;
};

export type EncryptedClinicUploadOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EncryptedClinicUploadOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupOrderByRelationAggregateInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  s3bucket?: Maybe<SortOrder>;
  s3key?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploaderIP?: Maybe<SortOrder>;
  uploaderUser?: Maybe<UserOrderByWithRelationInput>;
  uploaderUserId?: Maybe<SortOrder>;
};

export type EncryptedClinicUploadOrderByWithRelationInput = {
  _relevance?: Maybe<EncryptedClinicUploadOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupOrderByRelationAggregateInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  s3bucket?: Maybe<SortOrder>;
  s3key?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uploaderIP?: Maybe<SortOrder>;
  uploaderUser?: Maybe<UserOrderByWithRelationInput>;
  uploaderUserId?: Maybe<SortOrder>;
};

export enum EncryptedClinicUploadScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Description = 'description',
  ExpirationDate = 'expirationDate',
  Id = 'id',
  OrganizationId = 'organizationId',
  S3bucket = 's3bucket',
  S3key = 's3key',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UploaderIp = 'uploaderIP',
  UploaderUserId = 'uploaderUserId'
}

export type EncryptedClinicUploadScalarWhereInput = {
  AND?: Maybe<Array<EncryptedClinicUploadScalarWhereInput>>;
  NOT?: Maybe<Array<EncryptedClinicUploadScalarWhereInput>>;
  OR?: Maybe<Array<EncryptedClinicUploadScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  s3bucket?: Maybe<StringFilter>;
  s3key?: Maybe<StringFilter>;
  type?: Maybe<EnumEncryptedClinicUploadTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uploaderIP?: Maybe<StringNullableFilter>;
  uploaderUserId?: Maybe<StringNullableFilter>;
};

export type EncryptedClinicUploadScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EncryptedClinicUploadScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EncryptedClinicUploadScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EncryptedClinicUploadScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  expirationDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  organizationId?: Maybe<StringNullableWithAggregatesFilter>;
  s3bucket?: Maybe<StringWithAggregatesFilter>;
  s3key?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumEncryptedClinicUploadTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  uploaderIP?: Maybe<StringNullableWithAggregatesFilter>;
  uploaderUserId?: Maybe<StringNullableWithAggregatesFilter>;
};

export enum EncryptedClinicUploadType {
  PayoutsClinicsList = 'PayoutsClinicsList',
  PayoutsRepresentativeInfo = 'PayoutsRepresentativeInfo'
}

export type EncryptedClinicUploadUncheckedCreateInput = {
  clinicId: Scalars['String'];
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedManyWithoutClinicListEncryptedUploadInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedManyWithoutClinicRepresentativeInfoEncryptedUploadInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EncryptedClinicUploadCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EncryptedClinicUploadCreateWithoutClinicInput>>;
  createMany?: Maybe<EncryptedClinicUploadCreateManyClinicInputEnvelope>;
};

export type EncryptedClinicUploadUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EncryptedClinicUploadCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<EncryptedClinicUploadCreateWithoutOrganizationInput>>;
  createMany?: Maybe<EncryptedClinicUploadCreateManyOrganizationInputEnvelope>;
};

export type EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput = {
  connect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EncryptedClinicUploadCreateOrConnectWithoutUploaderUserInput>>;
  create?: Maybe<Array<EncryptedClinicUploadCreateWithoutUploaderUserInput>>;
  createMany?: Maybe<EncryptedClinicUploadCreateManyUploaderUserInputEnvelope>;
};

export type EncryptedClinicUploadUncheckedCreateWithoutClinicInput = {
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedManyWithoutClinicListEncryptedUploadInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedManyWithoutClinicRepresentativeInfoEncryptedUploadInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedCreateWithoutClinicListCustomPayoutsConnectionsInput = {
  clinicId: Scalars['String'];
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedManyWithoutClinicRepresentativeInfoEncryptedUploadInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedCreateWithoutClinicRepresentativeCustomPayoutsConnectionsInput = {
  clinicId: Scalars['String'];
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedManyWithoutClinicListEncryptedUploadInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedCreateWithoutOrganizationInput = {
  clinicId: Scalars['String'];
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedManyWithoutClinicListEncryptedUploadInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedManyWithoutClinicRepresentativeInfoEncryptedUploadInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedCreateWithoutUploaderUserInput = {
  clinicId: Scalars['String'];
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedManyWithoutClinicListEncryptedUploadInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedCreateNestedManyWithoutClinicRepresentativeInfoEncryptedUploadInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket: Scalars['String'];
  s3key: Scalars['String'];
  type: EncryptedClinicUploadType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicListEncryptedUploadNestedInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EncryptedClinicUploadCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EncryptedClinicUploadCreateWithoutClinicInput>>;
  createMany?: Maybe<EncryptedClinicUploadCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EncryptedClinicUploadScalarWhereInput>>;
  disconnect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  set?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  update?: Maybe<Array<EncryptedClinicUploadUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<EncryptedClinicUploadUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<EncryptedClinicUploadUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type EncryptedClinicUploadUncheckedUpdateManyWithoutOrganizationInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EncryptedClinicUploadCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<EncryptedClinicUploadCreateWithoutOrganizationInput>>;
  createMany?: Maybe<EncryptedClinicUploadCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EncryptedClinicUploadScalarWhereInput>>;
  disconnect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  set?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  update?: Maybe<Array<EncryptedClinicUploadUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<EncryptedClinicUploadUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<EncryptedClinicUploadUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput = {
  connect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EncryptedClinicUploadCreateOrConnectWithoutUploaderUserInput>>;
  create?: Maybe<Array<EncryptedClinicUploadCreateWithoutUploaderUserInput>>;
  createMany?: Maybe<EncryptedClinicUploadCreateManyUploaderUserInputEnvelope>;
  delete?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EncryptedClinicUploadScalarWhereInput>>;
  disconnect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  set?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  update?: Maybe<Array<EncryptedClinicUploadUpdateWithWhereUniqueWithoutUploaderUserInput>>;
  updateMany?: Maybe<Array<EncryptedClinicUploadUpdateManyWithWhereWithoutUploaderUserInput>>;
  upsert?: Maybe<Array<EncryptedClinicUploadUpsertWithWhereUniqueWithoutUploaderUserInput>>;
};

export type EncryptedClinicUploadUncheckedUpdateWithoutClinicInput = {
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicListEncryptedUploadNestedInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedUpdateWithoutClinicListCustomPayoutsConnectionsInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedUpdateWithoutClinicRepresentativeCustomPayoutsConnectionsInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicListEncryptedUploadNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedUpdateWithoutOrganizationInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicListEncryptedUploadNestedInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUserId?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUncheckedUpdateWithoutUploaderUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicListEncryptedUploadNestedInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUncheckedUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEncryptedClinicUploadsNestedInput>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUpdateManyWithoutClinicListEncryptedUploadNestedInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutAssociatedEncryptedClinicUploadsNestedInput>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUser?: Maybe<UserUpdateOneWithoutEncryptedClinicUploadsNestedInput>;
};

export type EncryptedClinicUploadUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUpdateManyWithWhereWithoutClinicInput = {
  data: EncryptedClinicUploadUpdateManyMutationInput;
  where: EncryptedClinicUploadScalarWhereInput;
};

export type EncryptedClinicUploadUpdateManyWithWhereWithoutOrganizationInput = {
  data: EncryptedClinicUploadUpdateManyMutationInput;
  where: EncryptedClinicUploadScalarWhereInput;
};

export type EncryptedClinicUploadUpdateManyWithWhereWithoutUploaderUserInput = {
  data: EncryptedClinicUploadUpdateManyMutationInput;
  where: EncryptedClinicUploadScalarWhereInput;
};

export type EncryptedClinicUploadUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EncryptedClinicUploadCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<EncryptedClinicUploadCreateWithoutClinicInput>>;
  createMany?: Maybe<EncryptedClinicUploadCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EncryptedClinicUploadScalarWhereInput>>;
  disconnect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  set?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  update?: Maybe<Array<EncryptedClinicUploadUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<EncryptedClinicUploadUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<EncryptedClinicUploadUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type EncryptedClinicUploadUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EncryptedClinicUploadCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<EncryptedClinicUploadCreateWithoutOrganizationInput>>;
  createMany?: Maybe<EncryptedClinicUploadCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EncryptedClinicUploadScalarWhereInput>>;
  disconnect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  set?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  update?: Maybe<Array<EncryptedClinicUploadUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<EncryptedClinicUploadUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<EncryptedClinicUploadUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput = {
  connect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EncryptedClinicUploadCreateOrConnectWithoutUploaderUserInput>>;
  create?: Maybe<Array<EncryptedClinicUploadCreateWithoutUploaderUserInput>>;
  createMany?: Maybe<EncryptedClinicUploadCreateManyUploaderUserInputEnvelope>;
  delete?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EncryptedClinicUploadScalarWhereInput>>;
  disconnect?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  set?: Maybe<Array<EncryptedClinicUploadWhereUniqueInput>>;
  update?: Maybe<Array<EncryptedClinicUploadUpdateWithWhereUniqueWithoutUploaderUserInput>>;
  updateMany?: Maybe<Array<EncryptedClinicUploadUpdateManyWithWhereWithoutUploaderUserInput>>;
  upsert?: Maybe<Array<EncryptedClinicUploadUpsertWithWhereUniqueWithoutUploaderUserInput>>;
};

export type EncryptedClinicUploadUpdateOneWithoutClinicListCustomPayoutsConnectionsNestedInput = {
  connect?: Maybe<EncryptedClinicUploadWhereUniqueInput>;
  connectOrCreate?: Maybe<EncryptedClinicUploadCreateOrConnectWithoutClinicListCustomPayoutsConnectionsInput>;
  create?: Maybe<EncryptedClinicUploadCreateWithoutClinicListCustomPayoutsConnectionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<EncryptedClinicUploadUpdateToOneWithWhereWithoutClinicListCustomPayoutsConnectionsInput>;
  upsert?: Maybe<EncryptedClinicUploadUpsertWithoutClinicListCustomPayoutsConnectionsInput>;
};

export type EncryptedClinicUploadUpdateOneWithoutClinicRepresentativeCustomPayoutsConnectionsNestedInput = {
  connect?: Maybe<EncryptedClinicUploadWhereUniqueInput>;
  connectOrCreate?: Maybe<EncryptedClinicUploadCreateOrConnectWithoutClinicRepresentativeCustomPayoutsConnectionsInput>;
  create?: Maybe<EncryptedClinicUploadCreateWithoutClinicRepresentativeCustomPayoutsConnectionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<EncryptedClinicUploadUpdateToOneWithWhereWithoutClinicRepresentativeCustomPayoutsConnectionsInput>;
  upsert?: Maybe<EncryptedClinicUploadUpsertWithoutClinicRepresentativeCustomPayoutsConnectionsInput>;
};

export type EncryptedClinicUploadUpdateToOneWithWhereWithoutClinicListCustomPayoutsConnectionsInput = {
  data: EncryptedClinicUploadUpdateWithoutClinicListCustomPayoutsConnectionsInput;
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};

export type EncryptedClinicUploadUpdateToOneWithWhereWithoutClinicRepresentativeCustomPayoutsConnectionsInput = {
  data: EncryptedClinicUploadUpdateWithoutClinicRepresentativeCustomPayoutsConnectionsInput;
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};

export type EncryptedClinicUploadUpdateWithWhereUniqueWithoutClinicInput = {
  data: EncryptedClinicUploadUpdateWithoutClinicInput;
  where: EncryptedClinicUploadWhereUniqueInput;
};

export type EncryptedClinicUploadUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: EncryptedClinicUploadUpdateWithoutOrganizationInput;
  where: EncryptedClinicUploadWhereUniqueInput;
};

export type EncryptedClinicUploadUpdateWithWhereUniqueWithoutUploaderUserInput = {
  data: EncryptedClinicUploadUpdateWithoutUploaderUserInput;
  where: EncryptedClinicUploadWhereUniqueInput;
};

export type EncryptedClinicUploadUpdateWithoutClinicInput = {
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUpdateManyWithoutClinicListEncryptedUploadNestedInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutAssociatedEncryptedClinicUploadsNestedInput>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUser?: Maybe<UserUpdateOneWithoutEncryptedClinicUploadsNestedInput>;
};

export type EncryptedClinicUploadUpdateWithoutClinicListCustomPayoutsConnectionsInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEncryptedClinicUploadsNestedInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutAssociatedEncryptedClinicUploadsNestedInput>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUser?: Maybe<UserUpdateOneWithoutEncryptedClinicUploadsNestedInput>;
};

export type EncryptedClinicUploadUpdateWithoutClinicRepresentativeCustomPayoutsConnectionsInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEncryptedClinicUploadsNestedInput>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUpdateManyWithoutClinicListEncryptedUploadNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutAssociatedEncryptedClinicUploadsNestedInput>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUser?: Maybe<UserUpdateOneWithoutEncryptedClinicUploadsNestedInput>;
};

export type EncryptedClinicUploadUpdateWithoutOrganizationInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEncryptedClinicUploadsNestedInput>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUpdateManyWithoutClinicListEncryptedUploadNestedInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
  uploaderUser?: Maybe<UserUpdateOneWithoutEncryptedClinicUploadsNestedInput>;
};

export type EncryptedClinicUploadUpdateWithoutUploaderUserInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutEncryptedClinicUploadsNestedInput>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUpdateManyWithoutClinicListEncryptedUploadNestedInput>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupUpdateManyWithoutClinicRepresentativeInfoEncryptedUploadNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneWithoutAssociatedEncryptedClinicUploadsNestedInput>;
  s3bucket?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  type?: Maybe<EncryptedClinicUploadType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploaderIP?: Maybe<Scalars['String']>;
};

export type EncryptedClinicUploadUpsertWithWhereUniqueWithoutClinicInput = {
  create: EncryptedClinicUploadCreateWithoutClinicInput;
  update: EncryptedClinicUploadUpdateWithoutClinicInput;
  where: EncryptedClinicUploadWhereUniqueInput;
};

export type EncryptedClinicUploadUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: EncryptedClinicUploadCreateWithoutOrganizationInput;
  update: EncryptedClinicUploadUpdateWithoutOrganizationInput;
  where: EncryptedClinicUploadWhereUniqueInput;
};

export type EncryptedClinicUploadUpsertWithWhereUniqueWithoutUploaderUserInput = {
  create: EncryptedClinicUploadCreateWithoutUploaderUserInput;
  update: EncryptedClinicUploadUpdateWithoutUploaderUserInput;
  where: EncryptedClinicUploadWhereUniqueInput;
};

export type EncryptedClinicUploadUpsertWithoutClinicListCustomPayoutsConnectionsInput = {
  create: EncryptedClinicUploadCreateWithoutClinicListCustomPayoutsConnectionsInput;
  update: EncryptedClinicUploadUpdateWithoutClinicListCustomPayoutsConnectionsInput;
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};

export type EncryptedClinicUploadUpsertWithoutClinicRepresentativeCustomPayoutsConnectionsInput = {
  create: EncryptedClinicUploadCreateWithoutClinicRepresentativeCustomPayoutsConnectionsInput;
  update: EncryptedClinicUploadUpdateWithoutClinicRepresentativeCustomPayoutsConnectionsInput;
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};

export type EncryptedClinicUploadWhereInput = {
  AND?: Maybe<Array<EncryptedClinicUploadWhereInput>>;
  NOT?: Maybe<Array<EncryptedClinicUploadWhereInput>>;
  OR?: Maybe<Array<EncryptedClinicUploadWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupListRelationFilter>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  s3bucket?: Maybe<StringFilter>;
  s3key?: Maybe<StringFilter>;
  type?: Maybe<EnumEncryptedClinicUploadTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uploaderIP?: Maybe<StringNullableFilter>;
  uploaderUser?: Maybe<UserNullableScalarRelationFilter>;
  uploaderUserId?: Maybe<StringNullableFilter>;
};

export type EncryptedClinicUploadWhereUniqueInput = {
  AND?: Maybe<Array<EncryptedClinicUploadWhereInput>>;
  NOT?: Maybe<Array<EncryptedClinicUploadWhereInput>>;
  OR?: Maybe<Array<EncryptedClinicUploadWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicListCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupListRelationFilter>;
  clinicRepresentativeCustomPayoutsConnections?: Maybe<ClinicCustomPayoutsSetupListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: Maybe<StringNullableFilter>;
  s3bucket?: Maybe<StringFilter>;
  s3key?: Maybe<StringFilter>;
  type?: Maybe<EnumEncryptedClinicUploadTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uploaderIP?: Maybe<StringNullableFilter>;
  uploaderUser?: Maybe<UserNullableScalarRelationFilter>;
  uploaderUserId?: Maybe<StringNullableFilter>;
};

export enum EncryptedSignedUploadPurpose {
  LegalEntityClinic = 'LegalEntity_Clinic',
  LegalEntityRepresentative = 'LegalEntity_Representative'
}

export type EncryptedUploadResponse = {
  __typename?: 'EncryptedUploadResponse';
  success: Scalars['Boolean'];
};

export type EndOneAxionCallInput = {
  callId: Scalars['String'];
  userId: Scalars['String'];
};

export type EnhancedStripeRefundPaymentInput = {
  amount: Scalars['Int'];
  channelId?: Maybe<Scalars['String']>;
  issuerInitials?: Maybe<Scalars['String']>;
  reason: StripeRefundReason;
  reasonOther?: Maybe<Scalars['String']>;
};

export type EnrollmentActivityLogSubscription = {
  __typename?: 'EnrollmentActivityLogSubscription';
  model: Scalars['String'];
  node: GenericActivityLog;
};

export type EnrollmentActivityLogWhereUniqueInput = {
  enrollmentId: Scalars['String'];
};

export type EnrollmentAndSubscriptionInput = {
  carePlanId: Scalars['String'];
  organizationPetId: Scalars['String'];
};

export enum EnrollmentStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Cancelling = 'Cancelling',
  Expired = 'Expired',
  NeverStarted = 'NeverStarted',
  PaymentFailed = 'PaymentFailed',
  Pending = 'Pending'
}

export type EnrollmentSupportEvent = {
  __typename?: 'EnrollmentSupportEvent';
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollment;
  carePlanEnrollmentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currentPlan?: Maybe<CarePlan>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricing?: Maybe<CarePlanPricing>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlan>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricing?: Maybe<CarePlanPricing>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<User>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoice?: Maybe<StripeInvoice>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requester?: Maybe<User>;
  requesterId?: Maybe<Scalars['String']>;
  responder?: Maybe<User>;
  responderId?: Maybe<Scalars['String']>;
  status: SupportEventStatus;
  transferFromPet?: Maybe<OrganizationPet>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPet?: Maybe<OrganizationPet>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};


export type EnrollmentSupportEventCurrentPlanArgs = {
  where?: Maybe<CarePlanWhereInput>;
};


export type EnrollmentSupportEventCurrentPlanPricingArgs = {
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type EnrollmentSupportEventNewPlanArgs = {
  where?: Maybe<CarePlanWhereInput>;
};


export type EnrollmentSupportEventNewPlanPricingArgs = {
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type EnrollmentSupportEventPointOfContactArgs = {
  where?: Maybe<UserWhereInput>;
};


export type EnrollmentSupportEventRelatedInvoiceArgs = {
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type EnrollmentSupportEventRequesterArgs = {
  where?: Maybe<UserWhereInput>;
};


export type EnrollmentSupportEventResponderArgs = {
  where?: Maybe<UserWhereInput>;
};


export type EnrollmentSupportEventTransferFromPetArgs = {
  where?: Maybe<OrganizationPetWhereInput>;
};


export type EnrollmentSupportEventTransferToPetArgs = {
  where?: Maybe<OrganizationPetWhereInput>;
};

export type EnrollmentSupportEventAvgAggregateOutputType = {
  __typename?: 'EnrollmentSupportEventAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
};

export type EnrollmentSupportEventAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type EnrollmentSupportEventCountAggregateOutputType = {
  __typename?: 'EnrollmentSupportEventCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  cancelReason: Scalars['Int'];
  carePlanEnrollmentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  currentPlanId: Scalars['Int'];
  currentPlanPricingId: Scalars['Int'];
  id: Scalars['Int'];
  manageMembershipDescription: Scalars['Int'];
  manageMembershipRequestType: Scalars['Int'];
  newPlanId: Scalars['Int'];
  newPlanPricingId: Scalars['Int'];
  notes: Scalars['Int'];
  paymentSchedule: Scalars['Int'];
  pointOfContactId: Scalars['Int'];
  relatedInvoiceId: Scalars['Int'];
  requesterId: Scalars['Int'];
  responderId: Scalars['Int'];
  status: Scalars['Int'];
  transferFromPetId: Scalars['Int'];
  transferToPetId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  zendeskTicketUrl: Scalars['Int'];
};

export type EnrollmentSupportEventCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  cancelReason?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlanId?: Maybe<SortOrder>;
  currentPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  manageMembershipDescription?: Maybe<SortOrder>;
  manageMembershipRequestType?: Maybe<SortOrder>;
  newPlanId?: Maybe<SortOrder>;
  newPlanPricingId?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  paymentSchedule?: Maybe<SortOrder>;
  pointOfContactId?: Maybe<SortOrder>;
  relatedInvoiceId?: Maybe<SortOrder>;
  requesterId?: Maybe<SortOrder>;
  responderId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transferFromPetId?: Maybe<SortOrder>;
  transferToPetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  zendeskTicketUrl?: Maybe<SortOrder>;
};

export type EnrollmentSupportEventCreateInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutEnrollmentSupportEventsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanCreateNestedOneWithoutCurrentPlanEnrollmentSupportEventsInput>;
  currentPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlanCreateNestedOneWithoutNewPlanEnrollmentSupportEventsInput>;
  newPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserCreateNestedOneWithoutPointOfContactEnrollmentSupportEventsInput>;
  relatedInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutRelatedEnrollmentSupportEventsInput>;
  requester?: Maybe<UserCreateNestedOneWithoutRequestedEnrollmentSupportEventsInput>;
  responder?: Maybe<UserCreateNestedOneWithoutResponderEnrollmentSupportEventsInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferFromPetEnrollmentSupportEventInput>;
  transferToPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferToPetEnrollmentSupportEventInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyCarePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyCarePlanEnrollmentInputEnvelope = {
  data: Array<EnrollmentSupportEventCreateManyCarePlanEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EnrollmentSupportEventCreateManyCurrentPlanInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyCurrentPlanInputEnvelope = {
  data: Array<EnrollmentSupportEventCreateManyCurrentPlanInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EnrollmentSupportEventCreateManyCurrentPlanPricingInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyCurrentPlanPricingInputEnvelope = {
  data: Array<EnrollmentSupportEventCreateManyCurrentPlanPricingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EnrollmentSupportEventCreateManyInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyNewPlanInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyNewPlanInputEnvelope = {
  data: Array<EnrollmentSupportEventCreateManyNewPlanInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EnrollmentSupportEventCreateManyNewPlanPricingInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyNewPlanPricingInputEnvelope = {
  data: Array<EnrollmentSupportEventCreateManyNewPlanPricingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EnrollmentSupportEventCreateManyPointOfContactInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyPointOfContactInputEnvelope = {
  data: Array<EnrollmentSupportEventCreateManyPointOfContactInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EnrollmentSupportEventCreateManyRelatedInvoiceInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyRelatedInvoiceInputEnvelope = {
  data: Array<EnrollmentSupportEventCreateManyRelatedInvoiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EnrollmentSupportEventCreateManyRequesterInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyRequesterInputEnvelope = {
  data: Array<EnrollmentSupportEventCreateManyRequesterInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EnrollmentSupportEventCreateManyResponderInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyResponderInputEnvelope = {
  data: Array<EnrollmentSupportEventCreateManyResponderInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EnrollmentSupportEventCreateManyTransferFromPetInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyTransferFromPetInputEnvelope = {
  data: Array<EnrollmentSupportEventCreateManyTransferFromPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EnrollmentSupportEventCreateManyTransferToPetInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateManyTransferToPetInputEnvelope = {
  data: Array<EnrollmentSupportEventCreateManyTransferToPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EnrollmentSupportEventCreateNestedManyWithoutCarePlanEnrollmentInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyCarePlanEnrollmentInputEnvelope>;
};

export type EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutCurrentPlanInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutCurrentPlanInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyCurrentPlanInputEnvelope>;
};

export type EnrollmentSupportEventCreateNestedManyWithoutCurrentPlanPricingInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutCurrentPlanPricingInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutCurrentPlanPricingInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyCurrentPlanPricingInputEnvelope>;
};

export type EnrollmentSupportEventCreateNestedManyWithoutNewPlanInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutNewPlanInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutNewPlanInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyNewPlanInputEnvelope>;
};

export type EnrollmentSupportEventCreateNestedManyWithoutNewPlanPricingInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutNewPlanPricingInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutNewPlanPricingInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyNewPlanPricingInputEnvelope>;
};

export type EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutPointOfContactInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutPointOfContactInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyPointOfContactInputEnvelope>;
};

export type EnrollmentSupportEventCreateNestedManyWithoutRelatedInvoiceInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutRelatedInvoiceInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutRelatedInvoiceInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyRelatedInvoiceInputEnvelope>;
};

export type EnrollmentSupportEventCreateNestedManyWithoutRequesterInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutRequesterInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutRequesterInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyRequesterInputEnvelope>;
};

export type EnrollmentSupportEventCreateNestedManyWithoutResponderInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutResponderInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutResponderInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyResponderInputEnvelope>;
};

export type EnrollmentSupportEventCreateNestedManyWithoutTransferFromPetInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutTransferFromPetInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutTransferFromPetInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyTransferFromPetInputEnvelope>;
};

export type EnrollmentSupportEventCreateNestedManyWithoutTransferToPetInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutTransferToPetInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutTransferToPetInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyTransferToPetInputEnvelope>;
};

export type EnrollmentSupportEventCreateOrConnectWithoutCarePlanEnrollmentInput = {
  create: EnrollmentSupportEventCreateWithoutCarePlanEnrollmentInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventCreateOrConnectWithoutCurrentPlanInput = {
  create: EnrollmentSupportEventCreateWithoutCurrentPlanInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventCreateOrConnectWithoutCurrentPlanPricingInput = {
  create: EnrollmentSupportEventCreateWithoutCurrentPlanPricingInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventCreateOrConnectWithoutNewPlanInput = {
  create: EnrollmentSupportEventCreateWithoutNewPlanInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventCreateOrConnectWithoutNewPlanPricingInput = {
  create: EnrollmentSupportEventCreateWithoutNewPlanPricingInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventCreateOrConnectWithoutPointOfContactInput = {
  create: EnrollmentSupportEventCreateWithoutPointOfContactInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventCreateOrConnectWithoutRelatedInvoiceInput = {
  create: EnrollmentSupportEventCreateWithoutRelatedInvoiceInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventCreateOrConnectWithoutRequesterInput = {
  create: EnrollmentSupportEventCreateWithoutRequesterInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventCreateOrConnectWithoutResponderInput = {
  create: EnrollmentSupportEventCreateWithoutResponderInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventCreateOrConnectWithoutTransferFromPetInput = {
  create: EnrollmentSupportEventCreateWithoutTransferFromPetInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventCreateOrConnectWithoutTransferToPetInput = {
  create: EnrollmentSupportEventCreateWithoutTransferToPetInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventCreateWithoutCarePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanCreateNestedOneWithoutCurrentPlanEnrollmentSupportEventsInput>;
  currentPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlanCreateNestedOneWithoutNewPlanEnrollmentSupportEventsInput>;
  newPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserCreateNestedOneWithoutPointOfContactEnrollmentSupportEventsInput>;
  relatedInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutRelatedEnrollmentSupportEventsInput>;
  requester?: Maybe<UserCreateNestedOneWithoutRequestedEnrollmentSupportEventsInput>;
  responder?: Maybe<UserCreateNestedOneWithoutResponderEnrollmentSupportEventsInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferFromPetEnrollmentSupportEventInput>;
  transferToPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferToPetEnrollmentSupportEventInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateWithoutCurrentPlanInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutEnrollmentSupportEventsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlanCreateNestedOneWithoutNewPlanEnrollmentSupportEventsInput>;
  newPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserCreateNestedOneWithoutPointOfContactEnrollmentSupportEventsInput>;
  relatedInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutRelatedEnrollmentSupportEventsInput>;
  requester?: Maybe<UserCreateNestedOneWithoutRequestedEnrollmentSupportEventsInput>;
  responder?: Maybe<UserCreateNestedOneWithoutResponderEnrollmentSupportEventsInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferFromPetEnrollmentSupportEventInput>;
  transferToPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferToPetEnrollmentSupportEventInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateWithoutCurrentPlanPricingInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutEnrollmentSupportEventsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanCreateNestedOneWithoutCurrentPlanEnrollmentSupportEventsInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlanCreateNestedOneWithoutNewPlanEnrollmentSupportEventsInput>;
  newPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserCreateNestedOneWithoutPointOfContactEnrollmentSupportEventsInput>;
  relatedInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutRelatedEnrollmentSupportEventsInput>;
  requester?: Maybe<UserCreateNestedOneWithoutRequestedEnrollmentSupportEventsInput>;
  responder?: Maybe<UserCreateNestedOneWithoutResponderEnrollmentSupportEventsInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferFromPetEnrollmentSupportEventInput>;
  transferToPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferToPetEnrollmentSupportEventInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateWithoutNewPlanInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutEnrollmentSupportEventsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanCreateNestedOneWithoutCurrentPlanEnrollmentSupportEventsInput>;
  currentPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserCreateNestedOneWithoutPointOfContactEnrollmentSupportEventsInput>;
  relatedInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutRelatedEnrollmentSupportEventsInput>;
  requester?: Maybe<UserCreateNestedOneWithoutRequestedEnrollmentSupportEventsInput>;
  responder?: Maybe<UserCreateNestedOneWithoutResponderEnrollmentSupportEventsInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferFromPetEnrollmentSupportEventInput>;
  transferToPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferToPetEnrollmentSupportEventInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateWithoutNewPlanPricingInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutEnrollmentSupportEventsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanCreateNestedOneWithoutCurrentPlanEnrollmentSupportEventsInput>;
  currentPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlanCreateNestedOneWithoutNewPlanEnrollmentSupportEventsInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserCreateNestedOneWithoutPointOfContactEnrollmentSupportEventsInput>;
  relatedInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutRelatedEnrollmentSupportEventsInput>;
  requester?: Maybe<UserCreateNestedOneWithoutRequestedEnrollmentSupportEventsInput>;
  responder?: Maybe<UserCreateNestedOneWithoutResponderEnrollmentSupportEventsInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferFromPetEnrollmentSupportEventInput>;
  transferToPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferToPetEnrollmentSupportEventInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateWithoutPointOfContactInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutEnrollmentSupportEventsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanCreateNestedOneWithoutCurrentPlanEnrollmentSupportEventsInput>;
  currentPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlanCreateNestedOneWithoutNewPlanEnrollmentSupportEventsInput>;
  newPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  relatedInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutRelatedEnrollmentSupportEventsInput>;
  requester?: Maybe<UserCreateNestedOneWithoutRequestedEnrollmentSupportEventsInput>;
  responder?: Maybe<UserCreateNestedOneWithoutResponderEnrollmentSupportEventsInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferFromPetEnrollmentSupportEventInput>;
  transferToPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferToPetEnrollmentSupportEventInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateWithoutRelatedInvoiceInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutEnrollmentSupportEventsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanCreateNestedOneWithoutCurrentPlanEnrollmentSupportEventsInput>;
  currentPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlanCreateNestedOneWithoutNewPlanEnrollmentSupportEventsInput>;
  newPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserCreateNestedOneWithoutPointOfContactEnrollmentSupportEventsInput>;
  requester?: Maybe<UserCreateNestedOneWithoutRequestedEnrollmentSupportEventsInput>;
  responder?: Maybe<UserCreateNestedOneWithoutResponderEnrollmentSupportEventsInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferFromPetEnrollmentSupportEventInput>;
  transferToPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferToPetEnrollmentSupportEventInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateWithoutRequesterInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutEnrollmentSupportEventsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanCreateNestedOneWithoutCurrentPlanEnrollmentSupportEventsInput>;
  currentPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlanCreateNestedOneWithoutNewPlanEnrollmentSupportEventsInput>;
  newPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserCreateNestedOneWithoutPointOfContactEnrollmentSupportEventsInput>;
  relatedInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutRelatedEnrollmentSupportEventsInput>;
  responder?: Maybe<UserCreateNestedOneWithoutResponderEnrollmentSupportEventsInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferFromPetEnrollmentSupportEventInput>;
  transferToPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferToPetEnrollmentSupportEventInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateWithoutResponderInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutEnrollmentSupportEventsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanCreateNestedOneWithoutCurrentPlanEnrollmentSupportEventsInput>;
  currentPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlanCreateNestedOneWithoutNewPlanEnrollmentSupportEventsInput>;
  newPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserCreateNestedOneWithoutPointOfContactEnrollmentSupportEventsInput>;
  relatedInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutRelatedEnrollmentSupportEventsInput>;
  requester?: Maybe<UserCreateNestedOneWithoutRequestedEnrollmentSupportEventsInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferFromPetEnrollmentSupportEventInput>;
  transferToPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferToPetEnrollmentSupportEventInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateWithoutTransferFromPetInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutEnrollmentSupportEventsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanCreateNestedOneWithoutCurrentPlanEnrollmentSupportEventsInput>;
  currentPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlanCreateNestedOneWithoutNewPlanEnrollmentSupportEventsInput>;
  newPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserCreateNestedOneWithoutPointOfContactEnrollmentSupportEventsInput>;
  relatedInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutRelatedEnrollmentSupportEventsInput>;
  requester?: Maybe<UserCreateNestedOneWithoutRequestedEnrollmentSupportEventsInput>;
  responder?: Maybe<UserCreateNestedOneWithoutResponderEnrollmentSupportEventsInput>;
  status?: Maybe<SupportEventStatus>;
  transferToPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferToPetEnrollmentSupportEventInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventCreateWithoutTransferToPetInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment: CarePlanEnrollmentCreateNestedOneWithoutEnrollmentSupportEventsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanCreateNestedOneWithoutCurrentPlanEnrollmentSupportEventsInput>;
  currentPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutCurrentPlanPricingEnrollmentSupportEventsInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlan?: Maybe<CarePlanCreateNestedOneWithoutNewPlanEnrollmentSupportEventsInput>;
  newPlanPricing?: Maybe<CarePlanPricingCreateNestedOneWithoutNewPlanPricingEnrollmentSupportEventsInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserCreateNestedOneWithoutPointOfContactEnrollmentSupportEventsInput>;
  relatedInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutRelatedEnrollmentSupportEventsInput>;
  requester?: Maybe<UserCreateNestedOneWithoutRequestedEnrollmentSupportEventsInput>;
  responder?: Maybe<UserCreateNestedOneWithoutResponderEnrollmentSupportEventsInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetCreateNestedOneWithoutTransferFromPetEnrollmentSupportEventInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventGroupByOutputType = {
  __typename?: 'EnrollmentSupportEventGroupByOutputType';
  _avg?: Maybe<EnrollmentSupportEventAvgAggregateOutputType>;
  _count?: Maybe<EnrollmentSupportEventCountAggregateOutputType>;
  _max?: Maybe<EnrollmentSupportEventMaxAggregateOutputType>;
  _min?: Maybe<EnrollmentSupportEventMinAggregateOutputType>;
  _sum?: Maybe<EnrollmentSupportEventSumAggregateOutputType>;
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status: SupportEventStatus;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventListRelationFilter = {
  every?: Maybe<EnrollmentSupportEventWhereInput>;
  none?: Maybe<EnrollmentSupportEventWhereInput>;
  some?: Maybe<EnrollmentSupportEventWhereInput>;
};

export type EnrollmentSupportEventMaxAggregateOutputType = {
  __typename?: 'EnrollmentSupportEventMaxAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  cancelReason?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlanId?: Maybe<SortOrder>;
  currentPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  manageMembershipDescription?: Maybe<SortOrder>;
  manageMembershipRequestType?: Maybe<SortOrder>;
  newPlanId?: Maybe<SortOrder>;
  newPlanPricingId?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  paymentSchedule?: Maybe<SortOrder>;
  pointOfContactId?: Maybe<SortOrder>;
  relatedInvoiceId?: Maybe<SortOrder>;
  requesterId?: Maybe<SortOrder>;
  responderId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transferFromPetId?: Maybe<SortOrder>;
  transferToPetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  zendeskTicketUrl?: Maybe<SortOrder>;
};

export type EnrollmentSupportEventMinAggregateOutputType = {
  __typename?: 'EnrollmentSupportEventMinAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  cancelReason?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlanId?: Maybe<SortOrder>;
  currentPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  manageMembershipDescription?: Maybe<SortOrder>;
  manageMembershipRequestType?: Maybe<SortOrder>;
  newPlanId?: Maybe<SortOrder>;
  newPlanPricingId?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  paymentSchedule?: Maybe<SortOrder>;
  pointOfContactId?: Maybe<SortOrder>;
  relatedInvoiceId?: Maybe<SortOrder>;
  requesterId?: Maybe<SortOrder>;
  responderId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transferFromPetId?: Maybe<SortOrder>;
  transferToPetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  zendeskTicketUrl?: Maybe<SortOrder>;
};

export type EnrollmentSupportEventOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EnrollmentSupportEventOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EnrollmentSupportEventOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  cancelReason?: Maybe<SortOrder>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  currentPlanId?: Maybe<SortOrder>;
  currentPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  currentPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  manageMembershipDescription?: Maybe<SortOrder>;
  manageMembershipRequestType?: Maybe<SortOrder>;
  newPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  newPlanId?: Maybe<SortOrder>;
  newPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  newPlanPricingId?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  paymentSchedule?: Maybe<SortOrder>;
  pointOfContact?: Maybe<UserOrderByWithRelationInput>;
  pointOfContactId?: Maybe<SortOrder>;
  relatedInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  relatedInvoiceId?: Maybe<SortOrder>;
  requester?: Maybe<UserOrderByWithRelationInput>;
  requesterId?: Maybe<SortOrder>;
  responder?: Maybe<UserOrderByWithRelationInput>;
  responderId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transferFromPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  transferFromPetId?: Maybe<SortOrder>;
  transferToPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  transferToPetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  zendeskTicketUrl?: Maybe<SortOrder>;
};

export enum EnrollmentSupportEventOrderByRelevanceFieldEnum {
  CarePlanEnrollmentId = 'carePlanEnrollmentId',
  CurrentPlanId = 'currentPlanId',
  CurrentPlanPricingId = 'currentPlanPricingId',
  Id = 'id',
  ManageMembershipDescription = 'manageMembershipDescription',
  NewPlanId = 'newPlanId',
  NewPlanPricingId = 'newPlanPricingId',
  Notes = 'notes',
  PointOfContactId = 'pointOfContactId',
  RelatedInvoiceId = 'relatedInvoiceId',
  RequesterId = 'requesterId',
  ResponderId = 'responderId',
  TransferFromPetId = 'transferFromPetId',
  TransferToPetId = 'transferToPetId',
  ZendeskTicketUrl = 'zendeskTicketUrl'
}

export type EnrollmentSupportEventOrderByRelevanceInput = {
  fields: Array<EnrollmentSupportEventOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EnrollmentSupportEventOrderByWithAggregationInput = {
  _avg?: Maybe<EnrollmentSupportEventAvgOrderByAggregateInput>;
  _count?: Maybe<EnrollmentSupportEventCountOrderByAggregateInput>;
  _max?: Maybe<EnrollmentSupportEventMaxOrderByAggregateInput>;
  _min?: Maybe<EnrollmentSupportEventMinOrderByAggregateInput>;
  _sum?: Maybe<EnrollmentSupportEventSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  cancelReason?: Maybe<SortOrder>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlanId?: Maybe<SortOrder>;
  currentPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  manageMembershipDescription?: Maybe<SortOrder>;
  manageMembershipRequestType?: Maybe<SortOrder>;
  newPlanId?: Maybe<SortOrder>;
  newPlanPricingId?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  paymentSchedule?: Maybe<SortOrder>;
  pointOfContactId?: Maybe<SortOrder>;
  relatedInvoiceId?: Maybe<SortOrder>;
  requesterId?: Maybe<SortOrder>;
  responderId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transferFromPetId?: Maybe<SortOrder>;
  transferToPetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  zendeskTicketUrl?: Maybe<SortOrder>;
};

export type EnrollmentSupportEventOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EnrollmentSupportEventOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  cancelReason?: Maybe<SortOrder>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  currentPlanId?: Maybe<SortOrder>;
  currentPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  currentPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  manageMembershipDescription?: Maybe<SortOrder>;
  manageMembershipRequestType?: Maybe<SortOrder>;
  newPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  newPlanId?: Maybe<SortOrder>;
  newPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  newPlanPricingId?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  paymentSchedule?: Maybe<SortOrder>;
  pointOfContact?: Maybe<UserOrderByWithRelationInput>;
  pointOfContactId?: Maybe<SortOrder>;
  relatedInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  relatedInvoiceId?: Maybe<SortOrder>;
  requester?: Maybe<UserOrderByWithRelationInput>;
  requesterId?: Maybe<SortOrder>;
  responder?: Maybe<UserOrderByWithRelationInput>;
  responderId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transferFromPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  transferFromPetId?: Maybe<SortOrder>;
  transferToPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  transferToPetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  zendeskTicketUrl?: Maybe<SortOrder>;
};

export type EnrollmentSupportEventOrderByWithRelationInput = {
  _relevance?: Maybe<EnrollmentSupportEventOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  cancelReason?: Maybe<SortOrder>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentOrderByWithRelationInput>;
  carePlanEnrollmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  currentPlanId?: Maybe<SortOrder>;
  currentPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  currentPlanPricingId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  manageMembershipDescription?: Maybe<SortOrder>;
  manageMembershipRequestType?: Maybe<SortOrder>;
  newPlan?: Maybe<CarePlanOrderByWithRelationInput>;
  newPlanId?: Maybe<SortOrder>;
  newPlanPricing?: Maybe<CarePlanPricingOrderByWithRelationInput>;
  newPlanPricingId?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  paymentSchedule?: Maybe<SortOrder>;
  pointOfContact?: Maybe<UserOrderByWithRelationInput>;
  pointOfContactId?: Maybe<SortOrder>;
  relatedInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  relatedInvoiceId?: Maybe<SortOrder>;
  requester?: Maybe<UserOrderByWithRelationInput>;
  requesterId?: Maybe<SortOrder>;
  responder?: Maybe<UserOrderByWithRelationInput>;
  responderId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transferFromPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  transferFromPetId?: Maybe<SortOrder>;
  transferToPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  transferToPetId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  zendeskTicketUrl?: Maybe<SortOrder>;
};

export enum EnrollmentSupportEventScalarFieldEnum {
  Amount = 'amount',
  CancelReason = 'cancelReason',
  CarePlanEnrollmentId = 'carePlanEnrollmentId',
  CreatedAt = 'createdAt',
  CurrentPlanId = 'currentPlanId',
  CurrentPlanPricingId = 'currentPlanPricingId',
  Id = 'id',
  ManageMembershipDescription = 'manageMembershipDescription',
  ManageMembershipRequestType = 'manageMembershipRequestType',
  NewPlanId = 'newPlanId',
  NewPlanPricingId = 'newPlanPricingId',
  Notes = 'notes',
  PaymentSchedule = 'paymentSchedule',
  PointOfContactId = 'pointOfContactId',
  RelatedInvoiceId = 'relatedInvoiceId',
  RequesterId = 'requesterId',
  ResponderId = 'responderId',
  Status = 'status',
  TransferFromPetId = 'transferFromPetId',
  TransferToPetId = 'transferToPetId',
  UpdatedAt = 'updatedAt',
  ZendeskTicketUrl = 'zendeskTicketUrl'
}

export type EnrollmentSupportEventScalarWhereInput = {
  AND?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  NOT?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  OR?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  amount?: Maybe<FloatNullableFilter>;
  cancelReason?: Maybe<EnumCancelReasonTypeNullableFilter>;
  carePlanEnrollmentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentPlanId?: Maybe<StringNullableFilter>;
  currentPlanPricingId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  manageMembershipDescription?: Maybe<StringNullableFilter>;
  manageMembershipRequestType?: Maybe<EnumManageMembershipRequestTypeFilter>;
  newPlanId?: Maybe<StringNullableFilter>;
  newPlanPricingId?: Maybe<StringNullableFilter>;
  notes?: Maybe<StringNullableFilter>;
  paymentSchedule?: Maybe<EnumPaymentScheduleNullableFilter>;
  pointOfContactId?: Maybe<StringNullableFilter>;
  relatedInvoiceId?: Maybe<StringNullableFilter>;
  requesterId?: Maybe<StringNullableFilter>;
  responderId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumSupportEventStatusFilter>;
  transferFromPetId?: Maybe<StringNullableFilter>;
  transferToPetId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  zendeskTicketUrl?: Maybe<StringNullableFilter>;
};

export type EnrollmentSupportEventScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EnrollmentSupportEventScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EnrollmentSupportEventScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EnrollmentSupportEventScalarWhereWithAggregatesInput>>;
  amount?: Maybe<FloatNullableWithAggregatesFilter>;
  cancelReason?: Maybe<EnumCancelReasonTypeNullableWithAggregatesFilter>;
  carePlanEnrollmentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  currentPlanId?: Maybe<StringNullableWithAggregatesFilter>;
  currentPlanPricingId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  manageMembershipDescription?: Maybe<StringNullableWithAggregatesFilter>;
  manageMembershipRequestType?: Maybe<EnumManageMembershipRequestTypeWithAggregatesFilter>;
  newPlanId?: Maybe<StringNullableWithAggregatesFilter>;
  newPlanPricingId?: Maybe<StringNullableWithAggregatesFilter>;
  notes?: Maybe<StringNullableWithAggregatesFilter>;
  paymentSchedule?: Maybe<EnumPaymentScheduleNullableWithAggregatesFilter>;
  pointOfContactId?: Maybe<StringNullableWithAggregatesFilter>;
  relatedInvoiceId?: Maybe<StringNullableWithAggregatesFilter>;
  requesterId?: Maybe<StringNullableWithAggregatesFilter>;
  responderId?: Maybe<StringNullableWithAggregatesFilter>;
  status?: Maybe<EnumSupportEventStatusWithAggregatesFilter>;
  transferFromPetId?: Maybe<StringNullableWithAggregatesFilter>;
  transferToPetId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  zendeskTicketUrl?: Maybe<StringNullableWithAggregatesFilter>;
};

export type EnrollmentSupportEventSumAggregateOutputType = {
  __typename?: 'EnrollmentSupportEventSumAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
};

export type EnrollmentSupportEventSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type EnrollmentSupportEventUncheckedCreateInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedCreateNestedManyWithoutCarePlanEnrollmentInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyCarePlanEnrollmentInputEnvelope>;
};

export type EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutCurrentPlanInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutCurrentPlanInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyCurrentPlanInputEnvelope>;
};

export type EnrollmentSupportEventUncheckedCreateNestedManyWithoutCurrentPlanPricingInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutCurrentPlanPricingInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutCurrentPlanPricingInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyCurrentPlanPricingInputEnvelope>;
};

export type EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutNewPlanInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutNewPlanInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyNewPlanInputEnvelope>;
};

export type EnrollmentSupportEventUncheckedCreateNestedManyWithoutNewPlanPricingInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutNewPlanPricingInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutNewPlanPricingInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyNewPlanPricingInputEnvelope>;
};

export type EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutPointOfContactInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutPointOfContactInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyPointOfContactInputEnvelope>;
};

export type EnrollmentSupportEventUncheckedCreateNestedManyWithoutRelatedInvoiceInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutRelatedInvoiceInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutRelatedInvoiceInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyRelatedInvoiceInputEnvelope>;
};

export type EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutRequesterInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutRequesterInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyRequesterInputEnvelope>;
};

export type EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutResponderInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutResponderInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyResponderInputEnvelope>;
};

export type EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferFromPetInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutTransferFromPetInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutTransferFromPetInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyTransferFromPetInputEnvelope>;
};

export type EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferToPetInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutTransferToPetInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutTransferToPetInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyTransferToPetInputEnvelope>;
};

export type EnrollmentSupportEventUncheckedCreateWithoutCarePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedCreateWithoutCurrentPlanInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedCreateWithoutCurrentPlanPricingInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedCreateWithoutNewPlanInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedCreateWithoutNewPlanPricingInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedCreateWithoutPointOfContactInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedCreateWithoutRelatedInvoiceInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedCreateWithoutRequesterInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedCreateWithoutResponderInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedCreateWithoutTransferFromPetInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedCreateWithoutTransferToPetInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType: ManageMembershipRequestType;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutCarePlanEnrollmentNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyCarePlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutCarePlanEnrollmentInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutCurrentPlanInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutCurrentPlanInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyCurrentPlanInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutCurrentPlanInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutCurrentPlanInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutCurrentPlanInput>>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanPricingInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutCurrentPlanPricingNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutCurrentPlanPricingInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutCurrentPlanPricingInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyCurrentPlanPricingInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutCurrentPlanPricingInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutCurrentPlanPricingInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutCurrentPlanPricingInput>>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutNewPlanInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutNewPlanInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyNewPlanInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutNewPlanInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutNewPlanInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutNewPlanInput>>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanPricingInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutNewPlanPricingNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutNewPlanPricingInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutNewPlanPricingInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyNewPlanPricingInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutNewPlanPricingInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutNewPlanPricingInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutNewPlanPricingInput>>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutPointOfContactInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutPointOfContactInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyPointOfContactInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutPointOfContactInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutPointOfContactInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutPointOfContactInput>>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutRelatedInvoiceInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutRelatedInvoiceNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutRelatedInvoiceInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutRelatedInvoiceInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyRelatedInvoiceInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutRelatedInvoiceInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutRelatedInvoiceInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutRelatedInvoiceInput>>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutRequesterInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutRequesterInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyRequesterInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutRequesterInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutRequesterInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutRequesterInput>>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutResponderInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutResponderInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutResponderInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyResponderInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutResponderInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutResponderInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutResponderInput>>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutTransferFromPetInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutTransferFromPetNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutTransferFromPetInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutTransferFromPetInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyTransferFromPetInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutTransferFromPetInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutTransferFromPetInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutTransferFromPetInput>>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutTransferToPetInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateManyWithoutTransferToPetNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutTransferToPetInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutTransferToPetInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyTransferToPetInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutTransferToPetInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutTransferToPetInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutTransferToPetInput>>;
};

export type EnrollmentSupportEventUncheckedUpdateWithoutCarePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateWithoutCurrentPlanInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateWithoutCurrentPlanPricingInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateWithoutNewPlanInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateWithoutNewPlanPricingInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateWithoutPointOfContactInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateWithoutRelatedInvoiceInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateWithoutRequesterInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateWithoutResponderInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateWithoutTransferFromPetInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferToPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUncheckedUpdateWithoutTransferToPetInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanId?: Maybe<Scalars['String']>;
  currentPlanPricingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanId?: Maybe<Scalars['String']>;
  newPlanPricingId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContactId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
  requesterId?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['String']>;
  status?: Maybe<SupportEventStatus>;
  transferFromPetId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutEnrollmentSupportEventsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanUpdateOneWithoutCurrentPlanEnrollmentSupportEventsNestedInput>;
  currentPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutCurrentPlanPricingEnrollmentSupportEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlan?: Maybe<CarePlanUpdateOneWithoutNewPlanEnrollmentSupportEventsNestedInput>;
  newPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutNewPlanPricingEnrollmentSupportEventsNestedInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserUpdateOneWithoutPointOfContactEnrollmentSupportEventsNestedInput>;
  relatedInvoice?: Maybe<StripeInvoiceUpdateOneWithoutRelatedEnrollmentSupportEventsNestedInput>;
  requester?: Maybe<UserUpdateOneWithoutRequestedEnrollmentSupportEventsNestedInput>;
  responder?: Maybe<UserUpdateOneWithoutResponderEnrollmentSupportEventsNestedInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetUpdateOneWithoutTransferFromPetEnrollmentSupportEventNestedInput>;
  transferToPet?: Maybe<OrganizationPetUpdateOneWithoutTransferToPetEnrollmentSupportEventNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  status?: Maybe<SupportEventStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateManyWithWhereWithoutCarePlanEnrollmentInput = {
  data: EnrollmentSupportEventUpdateManyMutationInput;
  where: EnrollmentSupportEventScalarWhereInput;
};

export type EnrollmentSupportEventUpdateManyWithWhereWithoutCurrentPlanInput = {
  data: EnrollmentSupportEventUpdateManyMutationInput;
  where: EnrollmentSupportEventScalarWhereInput;
};

export type EnrollmentSupportEventUpdateManyWithWhereWithoutCurrentPlanPricingInput = {
  data: EnrollmentSupportEventUpdateManyMutationInput;
  where: EnrollmentSupportEventScalarWhereInput;
};

export type EnrollmentSupportEventUpdateManyWithWhereWithoutNewPlanInput = {
  data: EnrollmentSupportEventUpdateManyMutationInput;
  where: EnrollmentSupportEventScalarWhereInput;
};

export type EnrollmentSupportEventUpdateManyWithWhereWithoutNewPlanPricingInput = {
  data: EnrollmentSupportEventUpdateManyMutationInput;
  where: EnrollmentSupportEventScalarWhereInput;
};

export type EnrollmentSupportEventUpdateManyWithWhereWithoutPointOfContactInput = {
  data: EnrollmentSupportEventUpdateManyMutationInput;
  where: EnrollmentSupportEventScalarWhereInput;
};

export type EnrollmentSupportEventUpdateManyWithWhereWithoutRelatedInvoiceInput = {
  data: EnrollmentSupportEventUpdateManyMutationInput;
  where: EnrollmentSupportEventScalarWhereInput;
};

export type EnrollmentSupportEventUpdateManyWithWhereWithoutRequesterInput = {
  data: EnrollmentSupportEventUpdateManyMutationInput;
  where: EnrollmentSupportEventScalarWhereInput;
};

export type EnrollmentSupportEventUpdateManyWithWhereWithoutResponderInput = {
  data: EnrollmentSupportEventUpdateManyMutationInput;
  where: EnrollmentSupportEventScalarWhereInput;
};

export type EnrollmentSupportEventUpdateManyWithWhereWithoutTransferFromPetInput = {
  data: EnrollmentSupportEventUpdateManyMutationInput;
  where: EnrollmentSupportEventScalarWhereInput;
};

export type EnrollmentSupportEventUpdateManyWithWhereWithoutTransferToPetInput = {
  data: EnrollmentSupportEventUpdateManyMutationInput;
  where: EnrollmentSupportEventScalarWhereInput;
};

export type EnrollmentSupportEventUpdateManyWithoutCarePlanEnrollmentNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutCarePlanEnrollmentInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutCarePlanEnrollmentInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyCarePlanEnrollmentInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutCarePlanEnrollmentInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutCarePlanEnrollmentInput>>;
};

export type EnrollmentSupportEventUpdateManyWithoutCurrentPlanNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutCurrentPlanInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutCurrentPlanInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyCurrentPlanInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutCurrentPlanInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutCurrentPlanInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutCurrentPlanInput>>;
};

export type EnrollmentSupportEventUpdateManyWithoutCurrentPlanPricingNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutCurrentPlanPricingInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutCurrentPlanPricingInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyCurrentPlanPricingInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutCurrentPlanPricingInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutCurrentPlanPricingInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutCurrentPlanPricingInput>>;
};

export type EnrollmentSupportEventUpdateManyWithoutNewPlanNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutNewPlanInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutNewPlanInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyNewPlanInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutNewPlanInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutNewPlanInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutNewPlanInput>>;
};

export type EnrollmentSupportEventUpdateManyWithoutNewPlanPricingNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutNewPlanPricingInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutNewPlanPricingInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyNewPlanPricingInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutNewPlanPricingInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutNewPlanPricingInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutNewPlanPricingInput>>;
};

export type EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutPointOfContactInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutPointOfContactInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyPointOfContactInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutPointOfContactInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutPointOfContactInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutPointOfContactInput>>;
};

export type EnrollmentSupportEventUpdateManyWithoutRelatedInvoiceNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutRelatedInvoiceInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutRelatedInvoiceInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyRelatedInvoiceInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutRelatedInvoiceInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutRelatedInvoiceInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutRelatedInvoiceInput>>;
};

export type EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutRequesterInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutRequesterInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyRequesterInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutRequesterInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutRequesterInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutRequesterInput>>;
};

export type EnrollmentSupportEventUpdateManyWithoutResponderNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutResponderInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutResponderInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyResponderInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutResponderInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutResponderInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutResponderInput>>;
};

export type EnrollmentSupportEventUpdateManyWithoutTransferFromPetNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutTransferFromPetInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutTransferFromPetInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyTransferFromPetInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutTransferFromPetInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutTransferFromPetInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutTransferFromPetInput>>;
};

export type EnrollmentSupportEventUpdateManyWithoutTransferToPetNestedInput = {
  connect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EnrollmentSupportEventCreateOrConnectWithoutTransferToPetInput>>;
  create?: Maybe<Array<EnrollmentSupportEventCreateWithoutTransferToPetInput>>;
  createMany?: Maybe<EnrollmentSupportEventCreateManyTransferToPetInputEnvelope>;
  delete?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EnrollmentSupportEventScalarWhereInput>>;
  disconnect?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  set?: Maybe<Array<EnrollmentSupportEventWhereUniqueInput>>;
  update?: Maybe<Array<EnrollmentSupportEventUpdateWithWhereUniqueWithoutTransferToPetInput>>;
  updateMany?: Maybe<Array<EnrollmentSupportEventUpdateManyWithWhereWithoutTransferToPetInput>>;
  upsert?: Maybe<Array<EnrollmentSupportEventUpsertWithWhereUniqueWithoutTransferToPetInput>>;
};

export type EnrollmentSupportEventUpdateWithWhereUniqueWithoutCarePlanEnrollmentInput = {
  data: EnrollmentSupportEventUpdateWithoutCarePlanEnrollmentInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpdateWithWhereUniqueWithoutCurrentPlanInput = {
  data: EnrollmentSupportEventUpdateWithoutCurrentPlanInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpdateWithWhereUniqueWithoutCurrentPlanPricingInput = {
  data: EnrollmentSupportEventUpdateWithoutCurrentPlanPricingInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpdateWithWhereUniqueWithoutNewPlanInput = {
  data: EnrollmentSupportEventUpdateWithoutNewPlanInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpdateWithWhereUniqueWithoutNewPlanPricingInput = {
  data: EnrollmentSupportEventUpdateWithoutNewPlanPricingInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpdateWithWhereUniqueWithoutPointOfContactInput = {
  data: EnrollmentSupportEventUpdateWithoutPointOfContactInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpdateWithWhereUniqueWithoutRelatedInvoiceInput = {
  data: EnrollmentSupportEventUpdateWithoutRelatedInvoiceInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpdateWithWhereUniqueWithoutRequesterInput = {
  data: EnrollmentSupportEventUpdateWithoutRequesterInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpdateWithWhereUniqueWithoutResponderInput = {
  data: EnrollmentSupportEventUpdateWithoutResponderInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpdateWithWhereUniqueWithoutTransferFromPetInput = {
  data: EnrollmentSupportEventUpdateWithoutTransferFromPetInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpdateWithWhereUniqueWithoutTransferToPetInput = {
  data: EnrollmentSupportEventUpdateWithoutTransferToPetInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpdateWithoutCarePlanEnrollmentInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanUpdateOneWithoutCurrentPlanEnrollmentSupportEventsNestedInput>;
  currentPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutCurrentPlanPricingEnrollmentSupportEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlan?: Maybe<CarePlanUpdateOneWithoutNewPlanEnrollmentSupportEventsNestedInput>;
  newPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutNewPlanPricingEnrollmentSupportEventsNestedInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserUpdateOneWithoutPointOfContactEnrollmentSupportEventsNestedInput>;
  relatedInvoice?: Maybe<StripeInvoiceUpdateOneWithoutRelatedEnrollmentSupportEventsNestedInput>;
  requester?: Maybe<UserUpdateOneWithoutRequestedEnrollmentSupportEventsNestedInput>;
  responder?: Maybe<UserUpdateOneWithoutResponderEnrollmentSupportEventsNestedInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetUpdateOneWithoutTransferFromPetEnrollmentSupportEventNestedInput>;
  transferToPet?: Maybe<OrganizationPetUpdateOneWithoutTransferToPetEnrollmentSupportEventNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateWithoutCurrentPlanInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutEnrollmentSupportEventsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutCurrentPlanPricingEnrollmentSupportEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlan?: Maybe<CarePlanUpdateOneWithoutNewPlanEnrollmentSupportEventsNestedInput>;
  newPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutNewPlanPricingEnrollmentSupportEventsNestedInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserUpdateOneWithoutPointOfContactEnrollmentSupportEventsNestedInput>;
  relatedInvoice?: Maybe<StripeInvoiceUpdateOneWithoutRelatedEnrollmentSupportEventsNestedInput>;
  requester?: Maybe<UserUpdateOneWithoutRequestedEnrollmentSupportEventsNestedInput>;
  responder?: Maybe<UserUpdateOneWithoutResponderEnrollmentSupportEventsNestedInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetUpdateOneWithoutTransferFromPetEnrollmentSupportEventNestedInput>;
  transferToPet?: Maybe<OrganizationPetUpdateOneWithoutTransferToPetEnrollmentSupportEventNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateWithoutCurrentPlanPricingInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutEnrollmentSupportEventsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanUpdateOneWithoutCurrentPlanEnrollmentSupportEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlan?: Maybe<CarePlanUpdateOneWithoutNewPlanEnrollmentSupportEventsNestedInput>;
  newPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutNewPlanPricingEnrollmentSupportEventsNestedInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserUpdateOneWithoutPointOfContactEnrollmentSupportEventsNestedInput>;
  relatedInvoice?: Maybe<StripeInvoiceUpdateOneWithoutRelatedEnrollmentSupportEventsNestedInput>;
  requester?: Maybe<UserUpdateOneWithoutRequestedEnrollmentSupportEventsNestedInput>;
  responder?: Maybe<UserUpdateOneWithoutResponderEnrollmentSupportEventsNestedInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetUpdateOneWithoutTransferFromPetEnrollmentSupportEventNestedInput>;
  transferToPet?: Maybe<OrganizationPetUpdateOneWithoutTransferToPetEnrollmentSupportEventNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateWithoutNewPlanInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutEnrollmentSupportEventsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanUpdateOneWithoutCurrentPlanEnrollmentSupportEventsNestedInput>;
  currentPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutCurrentPlanPricingEnrollmentSupportEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutNewPlanPricingEnrollmentSupportEventsNestedInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserUpdateOneWithoutPointOfContactEnrollmentSupportEventsNestedInput>;
  relatedInvoice?: Maybe<StripeInvoiceUpdateOneWithoutRelatedEnrollmentSupportEventsNestedInput>;
  requester?: Maybe<UserUpdateOneWithoutRequestedEnrollmentSupportEventsNestedInput>;
  responder?: Maybe<UserUpdateOneWithoutResponderEnrollmentSupportEventsNestedInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetUpdateOneWithoutTransferFromPetEnrollmentSupportEventNestedInput>;
  transferToPet?: Maybe<OrganizationPetUpdateOneWithoutTransferToPetEnrollmentSupportEventNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateWithoutNewPlanPricingInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutEnrollmentSupportEventsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanUpdateOneWithoutCurrentPlanEnrollmentSupportEventsNestedInput>;
  currentPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutCurrentPlanPricingEnrollmentSupportEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlan?: Maybe<CarePlanUpdateOneWithoutNewPlanEnrollmentSupportEventsNestedInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserUpdateOneWithoutPointOfContactEnrollmentSupportEventsNestedInput>;
  relatedInvoice?: Maybe<StripeInvoiceUpdateOneWithoutRelatedEnrollmentSupportEventsNestedInput>;
  requester?: Maybe<UserUpdateOneWithoutRequestedEnrollmentSupportEventsNestedInput>;
  responder?: Maybe<UserUpdateOneWithoutResponderEnrollmentSupportEventsNestedInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetUpdateOneWithoutTransferFromPetEnrollmentSupportEventNestedInput>;
  transferToPet?: Maybe<OrganizationPetUpdateOneWithoutTransferToPetEnrollmentSupportEventNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateWithoutPointOfContactInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutEnrollmentSupportEventsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanUpdateOneWithoutCurrentPlanEnrollmentSupportEventsNestedInput>;
  currentPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutCurrentPlanPricingEnrollmentSupportEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlan?: Maybe<CarePlanUpdateOneWithoutNewPlanEnrollmentSupportEventsNestedInput>;
  newPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutNewPlanPricingEnrollmentSupportEventsNestedInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  relatedInvoice?: Maybe<StripeInvoiceUpdateOneWithoutRelatedEnrollmentSupportEventsNestedInput>;
  requester?: Maybe<UserUpdateOneWithoutRequestedEnrollmentSupportEventsNestedInput>;
  responder?: Maybe<UserUpdateOneWithoutResponderEnrollmentSupportEventsNestedInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetUpdateOneWithoutTransferFromPetEnrollmentSupportEventNestedInput>;
  transferToPet?: Maybe<OrganizationPetUpdateOneWithoutTransferToPetEnrollmentSupportEventNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateWithoutRelatedInvoiceInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutEnrollmentSupportEventsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanUpdateOneWithoutCurrentPlanEnrollmentSupportEventsNestedInput>;
  currentPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutCurrentPlanPricingEnrollmentSupportEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlan?: Maybe<CarePlanUpdateOneWithoutNewPlanEnrollmentSupportEventsNestedInput>;
  newPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutNewPlanPricingEnrollmentSupportEventsNestedInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserUpdateOneWithoutPointOfContactEnrollmentSupportEventsNestedInput>;
  requester?: Maybe<UserUpdateOneWithoutRequestedEnrollmentSupportEventsNestedInput>;
  responder?: Maybe<UserUpdateOneWithoutResponderEnrollmentSupportEventsNestedInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetUpdateOneWithoutTransferFromPetEnrollmentSupportEventNestedInput>;
  transferToPet?: Maybe<OrganizationPetUpdateOneWithoutTransferToPetEnrollmentSupportEventNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateWithoutRequesterInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutEnrollmentSupportEventsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanUpdateOneWithoutCurrentPlanEnrollmentSupportEventsNestedInput>;
  currentPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutCurrentPlanPricingEnrollmentSupportEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlan?: Maybe<CarePlanUpdateOneWithoutNewPlanEnrollmentSupportEventsNestedInput>;
  newPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutNewPlanPricingEnrollmentSupportEventsNestedInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserUpdateOneWithoutPointOfContactEnrollmentSupportEventsNestedInput>;
  relatedInvoice?: Maybe<StripeInvoiceUpdateOneWithoutRelatedEnrollmentSupportEventsNestedInput>;
  responder?: Maybe<UserUpdateOneWithoutResponderEnrollmentSupportEventsNestedInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetUpdateOneWithoutTransferFromPetEnrollmentSupportEventNestedInput>;
  transferToPet?: Maybe<OrganizationPetUpdateOneWithoutTransferToPetEnrollmentSupportEventNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateWithoutResponderInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutEnrollmentSupportEventsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanUpdateOneWithoutCurrentPlanEnrollmentSupportEventsNestedInput>;
  currentPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutCurrentPlanPricingEnrollmentSupportEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlan?: Maybe<CarePlanUpdateOneWithoutNewPlanEnrollmentSupportEventsNestedInput>;
  newPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutNewPlanPricingEnrollmentSupportEventsNestedInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserUpdateOneWithoutPointOfContactEnrollmentSupportEventsNestedInput>;
  relatedInvoice?: Maybe<StripeInvoiceUpdateOneWithoutRelatedEnrollmentSupportEventsNestedInput>;
  requester?: Maybe<UserUpdateOneWithoutRequestedEnrollmentSupportEventsNestedInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetUpdateOneWithoutTransferFromPetEnrollmentSupportEventNestedInput>;
  transferToPet?: Maybe<OrganizationPetUpdateOneWithoutTransferToPetEnrollmentSupportEventNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateWithoutTransferFromPetInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutEnrollmentSupportEventsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanUpdateOneWithoutCurrentPlanEnrollmentSupportEventsNestedInput>;
  currentPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutCurrentPlanPricingEnrollmentSupportEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlan?: Maybe<CarePlanUpdateOneWithoutNewPlanEnrollmentSupportEventsNestedInput>;
  newPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutNewPlanPricingEnrollmentSupportEventsNestedInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserUpdateOneWithoutPointOfContactEnrollmentSupportEventsNestedInput>;
  relatedInvoice?: Maybe<StripeInvoiceUpdateOneWithoutRelatedEnrollmentSupportEventsNestedInput>;
  requester?: Maybe<UserUpdateOneWithoutRequestedEnrollmentSupportEventsNestedInput>;
  responder?: Maybe<UserUpdateOneWithoutResponderEnrollmentSupportEventsNestedInput>;
  status?: Maybe<SupportEventStatus>;
  transferToPet?: Maybe<OrganizationPetUpdateOneWithoutTransferToPetEnrollmentSupportEventNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpdateWithoutTransferToPetInput = {
  amount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<CancelReasonType>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentUpdateOneRequiredWithoutEnrollmentSupportEventsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPlan?: Maybe<CarePlanUpdateOneWithoutCurrentPlanEnrollmentSupportEventsNestedInput>;
  currentPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutCurrentPlanPricingEnrollmentSupportEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<Scalars['String']>;
  manageMembershipRequestType?: Maybe<ManageMembershipRequestType>;
  newPlan?: Maybe<CarePlanUpdateOneWithoutNewPlanEnrollmentSupportEventsNestedInput>;
  newPlanPricing?: Maybe<CarePlanPricingUpdateOneWithoutNewPlanPricingEnrollmentSupportEventsNestedInput>;
  notes?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pointOfContact?: Maybe<UserUpdateOneWithoutPointOfContactEnrollmentSupportEventsNestedInput>;
  relatedInvoice?: Maybe<StripeInvoiceUpdateOneWithoutRelatedEnrollmentSupportEventsNestedInput>;
  requester?: Maybe<UserUpdateOneWithoutRequestedEnrollmentSupportEventsNestedInput>;
  responder?: Maybe<UserUpdateOneWithoutResponderEnrollmentSupportEventsNestedInput>;
  status?: Maybe<SupportEventStatus>;
  transferFromPet?: Maybe<OrganizationPetUpdateOneWithoutTransferFromPetEnrollmentSupportEventNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

export type EnrollmentSupportEventUpsertWithWhereUniqueWithoutCarePlanEnrollmentInput = {
  create: EnrollmentSupportEventCreateWithoutCarePlanEnrollmentInput;
  update: EnrollmentSupportEventUpdateWithoutCarePlanEnrollmentInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpsertWithWhereUniqueWithoutCurrentPlanInput = {
  create: EnrollmentSupportEventCreateWithoutCurrentPlanInput;
  update: EnrollmentSupportEventUpdateWithoutCurrentPlanInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpsertWithWhereUniqueWithoutCurrentPlanPricingInput = {
  create: EnrollmentSupportEventCreateWithoutCurrentPlanPricingInput;
  update: EnrollmentSupportEventUpdateWithoutCurrentPlanPricingInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpsertWithWhereUniqueWithoutNewPlanInput = {
  create: EnrollmentSupportEventCreateWithoutNewPlanInput;
  update: EnrollmentSupportEventUpdateWithoutNewPlanInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpsertWithWhereUniqueWithoutNewPlanPricingInput = {
  create: EnrollmentSupportEventCreateWithoutNewPlanPricingInput;
  update: EnrollmentSupportEventUpdateWithoutNewPlanPricingInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpsertWithWhereUniqueWithoutPointOfContactInput = {
  create: EnrollmentSupportEventCreateWithoutPointOfContactInput;
  update: EnrollmentSupportEventUpdateWithoutPointOfContactInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpsertWithWhereUniqueWithoutRelatedInvoiceInput = {
  create: EnrollmentSupportEventCreateWithoutRelatedInvoiceInput;
  update: EnrollmentSupportEventUpdateWithoutRelatedInvoiceInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpsertWithWhereUniqueWithoutRequesterInput = {
  create: EnrollmentSupportEventCreateWithoutRequesterInput;
  update: EnrollmentSupportEventUpdateWithoutRequesterInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpsertWithWhereUniqueWithoutResponderInput = {
  create: EnrollmentSupportEventCreateWithoutResponderInput;
  update: EnrollmentSupportEventUpdateWithoutResponderInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpsertWithWhereUniqueWithoutTransferFromPetInput = {
  create: EnrollmentSupportEventCreateWithoutTransferFromPetInput;
  update: EnrollmentSupportEventUpdateWithoutTransferFromPetInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventUpsertWithWhereUniqueWithoutTransferToPetInput = {
  create: EnrollmentSupportEventCreateWithoutTransferToPetInput;
  update: EnrollmentSupportEventUpdateWithoutTransferToPetInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};

export type EnrollmentSupportEventWhereInput = {
  AND?: Maybe<Array<EnrollmentSupportEventWhereInput>>;
  NOT?: Maybe<Array<EnrollmentSupportEventWhereInput>>;
  OR?: Maybe<Array<EnrollmentSupportEventWhereInput>>;
  amount?: Maybe<FloatNullableFilter>;
  cancelReason?: Maybe<EnumCancelReasonTypeNullableFilter>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentScalarRelationFilter>;
  carePlanEnrollmentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  currentPlanId?: Maybe<StringNullableFilter>;
  currentPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  currentPlanPricingId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  manageMembershipDescription?: Maybe<StringNullableFilter>;
  manageMembershipRequestType?: Maybe<EnumManageMembershipRequestTypeFilter>;
  newPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  newPlanId?: Maybe<StringNullableFilter>;
  newPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  newPlanPricingId?: Maybe<StringNullableFilter>;
  notes?: Maybe<StringNullableFilter>;
  paymentSchedule?: Maybe<EnumPaymentScheduleNullableFilter>;
  pointOfContact?: Maybe<UserNullableScalarRelationFilter>;
  pointOfContactId?: Maybe<StringNullableFilter>;
  relatedInvoice?: Maybe<StripeInvoiceNullableScalarRelationFilter>;
  relatedInvoiceId?: Maybe<StringNullableFilter>;
  requester?: Maybe<UserNullableScalarRelationFilter>;
  requesterId?: Maybe<StringNullableFilter>;
  responder?: Maybe<UserNullableScalarRelationFilter>;
  responderId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumSupportEventStatusFilter>;
  transferFromPet?: Maybe<OrganizationPetNullableScalarRelationFilter>;
  transferFromPetId?: Maybe<StringNullableFilter>;
  transferToPet?: Maybe<OrganizationPetNullableScalarRelationFilter>;
  transferToPetId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  zendeskTicketUrl?: Maybe<StringNullableFilter>;
};

export type EnrollmentSupportEventWhereUniqueInput = {
  AND?: Maybe<Array<EnrollmentSupportEventWhereInput>>;
  NOT?: Maybe<Array<EnrollmentSupportEventWhereInput>>;
  OR?: Maybe<Array<EnrollmentSupportEventWhereInput>>;
  amount?: Maybe<FloatNullableFilter>;
  cancelReason?: Maybe<EnumCancelReasonTypeNullableFilter>;
  carePlanEnrollment?: Maybe<CarePlanEnrollmentScalarRelationFilter>;
  carePlanEnrollmentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  currentPlanId?: Maybe<StringNullableFilter>;
  currentPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  currentPlanPricingId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  manageMembershipDescription?: Maybe<StringNullableFilter>;
  manageMembershipRequestType?: Maybe<EnumManageMembershipRequestTypeFilter>;
  newPlan?: Maybe<CarePlanNullableScalarRelationFilter>;
  newPlanId?: Maybe<StringNullableFilter>;
  newPlanPricing?: Maybe<CarePlanPricingNullableScalarRelationFilter>;
  newPlanPricingId?: Maybe<StringNullableFilter>;
  notes?: Maybe<StringNullableFilter>;
  paymentSchedule?: Maybe<EnumPaymentScheduleNullableFilter>;
  pointOfContact?: Maybe<UserNullableScalarRelationFilter>;
  pointOfContactId?: Maybe<StringNullableFilter>;
  relatedInvoice?: Maybe<StripeInvoiceNullableScalarRelationFilter>;
  relatedInvoiceId?: Maybe<StringNullableFilter>;
  requester?: Maybe<UserNullableScalarRelationFilter>;
  requesterId?: Maybe<StringNullableFilter>;
  responder?: Maybe<UserNullableScalarRelationFilter>;
  responderId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumSupportEventStatusFilter>;
  transferFromPet?: Maybe<OrganizationPetNullableScalarRelationFilter>;
  transferFromPetId?: Maybe<StringNullableFilter>;
  transferToPet?: Maybe<OrganizationPetNullableScalarRelationFilter>;
  transferToPetId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  zendeskTicketUrl?: Maybe<StringNullableFilter>;
};

export type EnsurePetsPromotedInput = {
  clinicPetParentId: Scalars['String'];
};

export type EnsurePetsPromotedResult = {
  __typename?: 'EnsurePetsPromotedResult';
  success: Scalars['Boolean'];
};

export type EnumAmericanKennelClubBreedGroupNullableFilter = {
  equals?: Maybe<AmericanKennelClubBreedGroup>;
  in?: Maybe<Array<AmericanKennelClubBreedGroup>>;
  not?: Maybe<NestedEnumAmericanKennelClubBreedGroupNullableFilter>;
  notIn?: Maybe<Array<AmericanKennelClubBreedGroup>>;
};

export type EnumAmericanKennelClubBreedGroupNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAmericanKennelClubBreedGroupNullableFilter>;
  _min?: Maybe<NestedEnumAmericanKennelClubBreedGroupNullableFilter>;
  equals?: Maybe<AmericanKennelClubBreedGroup>;
  in?: Maybe<Array<AmericanKennelClubBreedGroup>>;
  not?: Maybe<NestedEnumAmericanKennelClubBreedGroupNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AmericanKennelClubBreedGroup>>;
};

export type EnumAmericanKennelClubBreedTemperamentNullableListFilter = {
  equals?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  has?: Maybe<AmericanKennelClubBreedTemperament>;
  hasEvery?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  hasSome?: Maybe<Array<AmericanKennelClubBreedTemperament>>;
  isEmpty?: Maybe<Scalars['Boolean']>;
};

export type EnumAmericanKennelClubDemeanorCategoryNullableFilter = {
  equals?: Maybe<AmericanKennelClubDemeanorCategory>;
  in?: Maybe<Array<AmericanKennelClubDemeanorCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubDemeanorCategoryNullableFilter>;
  notIn?: Maybe<Array<AmericanKennelClubDemeanorCategory>>;
};

export type EnumAmericanKennelClubDemeanorCategoryNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAmericanKennelClubDemeanorCategoryNullableFilter>;
  _min?: Maybe<NestedEnumAmericanKennelClubDemeanorCategoryNullableFilter>;
  equals?: Maybe<AmericanKennelClubDemeanorCategory>;
  in?: Maybe<Array<AmericanKennelClubDemeanorCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubDemeanorCategoryNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AmericanKennelClubDemeanorCategory>>;
};

export type EnumAmericanKennelClubEnergyLevelCategoryNullableFilter = {
  equals?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  in?: Maybe<Array<AmericanKennelClubEnergyLevelCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubEnergyLevelCategoryNullableFilter>;
  notIn?: Maybe<Array<AmericanKennelClubEnergyLevelCategory>>;
};

export type EnumAmericanKennelClubEnergyLevelCategoryNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAmericanKennelClubEnergyLevelCategoryNullableFilter>;
  _min?: Maybe<NestedEnumAmericanKennelClubEnergyLevelCategoryNullableFilter>;
  equals?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  in?: Maybe<Array<AmericanKennelClubEnergyLevelCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubEnergyLevelCategoryNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AmericanKennelClubEnergyLevelCategory>>;
};

export type EnumAmericanKennelClubGroomingFrequencyCategoryNullableFilter = {
  equals?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  in?: Maybe<Array<AmericanKennelClubGroomingFrequencyCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubGroomingFrequencyCategoryNullableFilter>;
  notIn?: Maybe<Array<AmericanKennelClubGroomingFrequencyCategory>>;
};

export type EnumAmericanKennelClubGroomingFrequencyCategoryNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAmericanKennelClubGroomingFrequencyCategoryNullableFilter>;
  _min?: Maybe<NestedEnumAmericanKennelClubGroomingFrequencyCategoryNullableFilter>;
  equals?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  in?: Maybe<Array<AmericanKennelClubGroomingFrequencyCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubGroomingFrequencyCategoryNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AmericanKennelClubGroomingFrequencyCategory>>;
};

export type EnumAmericanKennelClubSheddingCategoryNullableFilter = {
  equals?: Maybe<AmericanKennelClubSheddingCategory>;
  in?: Maybe<Array<AmericanKennelClubSheddingCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubSheddingCategoryNullableFilter>;
  notIn?: Maybe<Array<AmericanKennelClubSheddingCategory>>;
};

export type EnumAmericanKennelClubSheddingCategoryNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAmericanKennelClubSheddingCategoryNullableFilter>;
  _min?: Maybe<NestedEnumAmericanKennelClubSheddingCategoryNullableFilter>;
  equals?: Maybe<AmericanKennelClubSheddingCategory>;
  in?: Maybe<Array<AmericanKennelClubSheddingCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubSheddingCategoryNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AmericanKennelClubSheddingCategory>>;
};

export type EnumAmericanKennelClubTrainabilityCategoryNullableFilter = {
  equals?: Maybe<AmericanKennelClubTrainabilityCategory>;
  in?: Maybe<Array<AmericanKennelClubTrainabilityCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubTrainabilityCategoryNullableFilter>;
  notIn?: Maybe<Array<AmericanKennelClubTrainabilityCategory>>;
};

export type EnumAmericanKennelClubTrainabilityCategoryNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAmericanKennelClubTrainabilityCategoryNullableFilter>;
  _min?: Maybe<NestedEnumAmericanKennelClubTrainabilityCategoryNullableFilter>;
  equals?: Maybe<AmericanKennelClubTrainabilityCategory>;
  in?: Maybe<Array<AmericanKennelClubTrainabilityCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubTrainabilityCategoryNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AmericanKennelClubTrainabilityCategory>>;
};

export type EnumAppointmentDateRangeTypeFieldUpdateOperationsInput = {
  set?: Maybe<AppointmentDateRangeType>;
};

export type EnumAppointmentDateRangeTypeFilter = {
  equals?: Maybe<AppointmentDateRangeType>;
  in?: Maybe<Array<AppointmentDateRangeType>>;
  not?: Maybe<NestedEnumAppointmentDateRangeTypeFilter>;
  notIn?: Maybe<Array<AppointmentDateRangeType>>;
};

export type EnumAppointmentDateRangeTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAppointmentDateRangeTypeFilter>;
  _min?: Maybe<NestedEnumAppointmentDateRangeTypeFilter>;
  equals?: Maybe<AppointmentDateRangeType>;
  in?: Maybe<Array<AppointmentDateRangeType>>;
  not?: Maybe<NestedEnumAppointmentDateRangeTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<AppointmentDateRangeType>>;
};

export type EnumAppointmentStatusFieldUpdateOperationsInput = {
  set?: Maybe<AppointmentStatus>;
};

export type EnumAppointmentStatusFilter = {
  equals?: Maybe<AppointmentStatus>;
  in?: Maybe<Array<AppointmentStatus>>;
  not?: Maybe<NestedEnumAppointmentStatusFilter>;
  notIn?: Maybe<Array<AppointmentStatus>>;
};

export type EnumAppointmentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAppointmentStatusFilter>;
  _min?: Maybe<NestedEnumAppointmentStatusFilter>;
  equals?: Maybe<AppointmentStatus>;
  in?: Maybe<Array<AppointmentStatus>>;
  not?: Maybe<NestedEnumAppointmentStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<AppointmentStatus>>;
};

export type EnumAppointmentTypeVisibilityFieldUpdateOperationsInput = {
  set?: Maybe<AppointmentTypeVisibility>;
};

export type EnumAppointmentTypeVisibilityFilter = {
  equals?: Maybe<AppointmentTypeVisibility>;
  in?: Maybe<Array<AppointmentTypeVisibility>>;
  not?: Maybe<NestedEnumAppointmentTypeVisibilityFilter>;
  notIn?: Maybe<Array<AppointmentTypeVisibility>>;
};

export type EnumAppointmentTypeVisibilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAppointmentTypeVisibilityFilter>;
  _min?: Maybe<NestedEnumAppointmentTypeVisibilityFilter>;
  equals?: Maybe<AppointmentTypeVisibility>;
  in?: Maybe<Array<AppointmentTypeVisibility>>;
  not?: Maybe<NestedEnumAppointmentTypeVisibilityWithAggregatesFilter>;
  notIn?: Maybe<Array<AppointmentTypeVisibility>>;
};

export type EnumAutoResponseSuggestionStatusFieldUpdateOperationsInput = {
  set?: Maybe<AutoResponseSuggestionStatus>;
};

export type EnumAutoResponseSuggestionStatusFilter = {
  equals?: Maybe<AutoResponseSuggestionStatus>;
  in?: Maybe<Array<AutoResponseSuggestionStatus>>;
  not?: Maybe<NestedEnumAutoResponseSuggestionStatusFilter>;
  notIn?: Maybe<Array<AutoResponseSuggestionStatus>>;
};

export type EnumAutoResponseSuggestionStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAutoResponseSuggestionStatusFilter>;
  _min?: Maybe<NestedEnumAutoResponseSuggestionStatusFilter>;
  equals?: Maybe<AutoResponseSuggestionStatus>;
  in?: Maybe<Array<AutoResponseSuggestionStatus>>;
  not?: Maybe<NestedEnumAutoResponseSuggestionStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<AutoResponseSuggestionStatus>>;
};

export type EnumAutomatedTriggerTypeNullableFilter = {
  equals?: Maybe<AutomatedTriggerType>;
  in?: Maybe<Array<AutomatedTriggerType>>;
  not?: Maybe<NestedEnumAutomatedTriggerTypeNullableFilter>;
  notIn?: Maybe<Array<AutomatedTriggerType>>;
};

export type EnumAutomatedTriggerTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAutomatedTriggerTypeNullableFilter>;
  _min?: Maybe<NestedEnumAutomatedTriggerTypeNullableFilter>;
  equals?: Maybe<AutomatedTriggerType>;
  in?: Maybe<Array<AutomatedTriggerType>>;
  not?: Maybe<NestedEnumAutomatedTriggerTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AutomatedTriggerType>>;
};

export type EnumAutomationRunActionPromptTypeFieldUpdateOperationsInput = {
  set?: Maybe<AutomationRunActionPromptType>;
};

export type EnumAutomationRunActionPromptTypeFilter = {
  equals?: Maybe<AutomationRunActionPromptType>;
  in?: Maybe<Array<AutomationRunActionPromptType>>;
  not?: Maybe<NestedEnumAutomationRunActionPromptTypeFilter>;
  notIn?: Maybe<Array<AutomationRunActionPromptType>>;
};

export type EnumAutomationRunActionPromptTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAutomationRunActionPromptTypeFilter>;
  _min?: Maybe<NestedEnumAutomationRunActionPromptTypeFilter>;
  equals?: Maybe<AutomationRunActionPromptType>;
  in?: Maybe<Array<AutomationRunActionPromptType>>;
  not?: Maybe<NestedEnumAutomationRunActionPromptTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<AutomationRunActionPromptType>>;
};

export type EnumAutomationRunActionTypeFieldUpdateOperationsInput = {
  set?: Maybe<AutomationRunActionType>;
};

export type EnumAutomationRunActionTypeFilter = {
  equals?: Maybe<AutomationRunActionType>;
  in?: Maybe<Array<AutomationRunActionType>>;
  not?: Maybe<NestedEnumAutomationRunActionTypeFilter>;
  notIn?: Maybe<Array<AutomationRunActionType>>;
};

export type EnumAutomationRunActionTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAutomationRunActionTypeFilter>;
  _min?: Maybe<NestedEnumAutomationRunActionTypeFilter>;
  equals?: Maybe<AutomationRunActionType>;
  in?: Maybe<Array<AutomationRunActionType>>;
  not?: Maybe<NestedEnumAutomationRunActionTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<AutomationRunActionType>>;
};

export type EnumAutomationRunStatusFieldUpdateOperationsInput = {
  set?: Maybe<AutomationRunStatus>;
};

export type EnumAutomationRunStatusFilter = {
  equals?: Maybe<AutomationRunStatus>;
  in?: Maybe<Array<AutomationRunStatus>>;
  not?: Maybe<NestedEnumAutomationRunStatusFilter>;
  notIn?: Maybe<Array<AutomationRunStatus>>;
};

export type EnumAutomationRunStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAutomationRunStatusFilter>;
  _min?: Maybe<NestedEnumAutomationRunStatusFilter>;
  equals?: Maybe<AutomationRunStatus>;
  in?: Maybe<Array<AutomationRunStatus>>;
  not?: Maybe<NestedEnumAutomationRunStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<AutomationRunStatus>>;
};

export type EnumAutomationRunTypeFieldUpdateOperationsInput = {
  set?: Maybe<AutomationRunType>;
};

export type EnumAutomationRunTypeFilter = {
  equals?: Maybe<AutomationRunType>;
  in?: Maybe<Array<AutomationRunType>>;
  not?: Maybe<NestedEnumAutomationRunTypeFilter>;
  notIn?: Maybe<Array<AutomationRunType>>;
};

export type EnumAutomationRunTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAutomationRunTypeFilter>;
  _min?: Maybe<NestedEnumAutomationRunTypeFilter>;
  equals?: Maybe<AutomationRunType>;
  in?: Maybe<Array<AutomationRunType>>;
  not?: Maybe<NestedEnumAutomationRunTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<AutomationRunType>>;
};

export type EnumAutomationStatusFieldUpdateOperationsInput = {
  set?: Maybe<AutomationStatus>;
};

export type EnumAutomationStatusFilter = {
  equals?: Maybe<AutomationStatus>;
  in?: Maybe<Array<AutomationStatus>>;
  not?: Maybe<NestedEnumAutomationStatusFilter>;
  notIn?: Maybe<Array<AutomationStatus>>;
};

export type EnumAutomationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAutomationStatusFilter>;
  _min?: Maybe<NestedEnumAutomationStatusFilter>;
  equals?: Maybe<AutomationStatus>;
  in?: Maybe<Array<AutomationStatus>>;
  not?: Maybe<NestedEnumAutomationStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<AutomationStatus>>;
};

export type EnumAxionClinicConfigurationStatusFieldUpdateOperationsInput = {
  set?: Maybe<AxionClinicConfigurationStatus>;
};

export type EnumAxionClinicConfigurationStatusFilter = {
  equals?: Maybe<AxionClinicConfigurationStatus>;
  in?: Maybe<Array<AxionClinicConfigurationStatus>>;
  not?: Maybe<NestedEnumAxionClinicConfigurationStatusFilter>;
  notIn?: Maybe<Array<AxionClinicConfigurationStatus>>;
};

export type EnumAxionClinicConfigurationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAxionClinicConfigurationStatusFilter>;
  _min?: Maybe<NestedEnumAxionClinicConfigurationStatusFilter>;
  equals?: Maybe<AxionClinicConfigurationStatus>;
  in?: Maybe<Array<AxionClinicConfigurationStatus>>;
  not?: Maybe<NestedEnumAxionClinicConfigurationStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<AxionClinicConfigurationStatus>>;
};

export type EnumBitwerxHealthcheckRunStatusNullableFilter = {
  equals?: Maybe<BitwerxHealthcheckRunStatus>;
  in?: Maybe<Array<BitwerxHealthcheckRunStatus>>;
  not?: Maybe<NestedEnumBitwerxHealthcheckRunStatusNullableFilter>;
  notIn?: Maybe<Array<BitwerxHealthcheckRunStatus>>;
};

export type EnumBitwerxHealthcheckRunStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumBitwerxHealthcheckRunStatusNullableFilter>;
  _min?: Maybe<NestedEnumBitwerxHealthcheckRunStatusNullableFilter>;
  equals?: Maybe<BitwerxHealthcheckRunStatus>;
  in?: Maybe<Array<BitwerxHealthcheckRunStatus>>;
  not?: Maybe<NestedEnumBitwerxHealthcheckRunStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<BitwerxHealthcheckRunStatus>>;
};

export type EnumBitwerxHealthcheckTypeFieldUpdateOperationsInput = {
  set?: Maybe<BitwerxHealthcheckType>;
};

export type EnumBitwerxHealthcheckTypeFilter = {
  equals?: Maybe<BitwerxHealthcheckType>;
  in?: Maybe<Array<BitwerxHealthcheckType>>;
  not?: Maybe<NestedEnumBitwerxHealthcheckTypeFilter>;
  notIn?: Maybe<Array<BitwerxHealthcheckType>>;
};

export type EnumBitwerxHealthcheckTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumBitwerxHealthcheckTypeFilter>;
  _min?: Maybe<NestedEnumBitwerxHealthcheckTypeFilter>;
  equals?: Maybe<BitwerxHealthcheckType>;
  in?: Maybe<Array<BitwerxHealthcheckType>>;
  not?: Maybe<NestedEnumBitwerxHealthcheckTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<BitwerxHealthcheckType>>;
};

export type EnumBitwerxPaymentEndpointFieldUpdateOperationsInput = {
  set?: Maybe<BitwerxPaymentEndpoint>;
};

export type EnumBitwerxPaymentEndpointFilter = {
  equals?: Maybe<BitwerxPaymentEndpoint>;
  in?: Maybe<Array<BitwerxPaymentEndpoint>>;
  not?: Maybe<NestedEnumBitwerxPaymentEndpointFilter>;
  notIn?: Maybe<Array<BitwerxPaymentEndpoint>>;
};

export type EnumBitwerxPaymentEndpointWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumBitwerxPaymentEndpointFilter>;
  _min?: Maybe<NestedEnumBitwerxPaymentEndpointFilter>;
  equals?: Maybe<BitwerxPaymentEndpoint>;
  in?: Maybe<Array<BitwerxPaymentEndpoint>>;
  not?: Maybe<NestedEnumBitwerxPaymentEndpointWithAggregatesFilter>;
  notIn?: Maybe<Array<BitwerxPaymentEndpoint>>;
};

export type EnumBitwerxSystemFieldUpdateOperationsInput = {
  set?: Maybe<BitwerxSystem>;
};

export type EnumBitwerxSystemFilter = {
  equals?: Maybe<BitwerxSystem>;
  in?: Maybe<Array<BitwerxSystem>>;
  not?: Maybe<NestedEnumBitwerxSystemFilter>;
  notIn?: Maybe<Array<BitwerxSystem>>;
};

export type EnumBitwerxSystemWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumBitwerxSystemFilter>;
  _min?: Maybe<NestedEnumBitwerxSystemFilter>;
  equals?: Maybe<BitwerxSystem>;
  in?: Maybe<Array<BitwerxSystem>>;
  not?: Maybe<NestedEnumBitwerxSystemWithAggregatesFilter>;
  notIn?: Maybe<Array<BitwerxSystem>>;
};

export type EnumBoardFilterColumnTypeFieldUpdateOperationsInput = {
  set?: Maybe<BoardFilterColumnType>;
};

export type EnumBoardFilterColumnTypeFilter = {
  equals?: Maybe<BoardFilterColumnType>;
  in?: Maybe<Array<BoardFilterColumnType>>;
  not?: Maybe<NestedEnumBoardFilterColumnTypeFilter>;
  notIn?: Maybe<Array<BoardFilterColumnType>>;
};

export type EnumBoardFilterColumnTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumBoardFilterColumnTypeFilter>;
  _min?: Maybe<NestedEnumBoardFilterColumnTypeFilter>;
  equals?: Maybe<BoardFilterColumnType>;
  in?: Maybe<Array<BoardFilterColumnType>>;
  not?: Maybe<NestedEnumBoardFilterColumnTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<BoardFilterColumnType>>;
};

export type EnumBoardFilterDateRangeNullableFilter = {
  equals?: Maybe<BoardFilterDateRange>;
  in?: Maybe<Array<BoardFilterDateRange>>;
  not?: Maybe<NestedEnumBoardFilterDateRangeNullableFilter>;
  notIn?: Maybe<Array<BoardFilterDateRange>>;
};

export type EnumBoardFilterDateRangeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumBoardFilterDateRangeNullableFilter>;
  _min?: Maybe<NestedEnumBoardFilterDateRangeNullableFilter>;
  equals?: Maybe<BoardFilterDateRange>;
  in?: Maybe<Array<BoardFilterDateRange>>;
  not?: Maybe<NestedEnumBoardFilterDateRangeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<BoardFilterDateRange>>;
};

export type EnumBoardFilterViewFieldUpdateOperationsInput = {
  set?: Maybe<BoardFilterView>;
};

export type EnumBoardFilterViewFilter = {
  equals?: Maybe<BoardFilterView>;
  in?: Maybe<Array<BoardFilterView>>;
  not?: Maybe<NestedEnumBoardFilterViewFilter>;
  notIn?: Maybe<Array<BoardFilterView>>;
};

export type EnumBoardFilterViewWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumBoardFilterViewFilter>;
  _min?: Maybe<NestedEnumBoardFilterViewFilter>;
  equals?: Maybe<BoardFilterView>;
  in?: Maybe<Array<BoardFilterView>>;
  not?: Maybe<NestedEnumBoardFilterViewWithAggregatesFilter>;
  notIn?: Maybe<Array<BoardFilterView>>;
};

export type EnumBoehringerIngelheimCustomerAlignmentStatusFieldUpdateOperationsInput = {
  set?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
};

export type EnumBoehringerIngelheimCustomerAlignmentStatusFilter = {
  equals?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  in?: Maybe<Array<BoehringerIngelheimCustomerAlignmentStatus>>;
  not?: Maybe<NestedEnumBoehringerIngelheimCustomerAlignmentStatusFilter>;
  notIn?: Maybe<Array<BoehringerIngelheimCustomerAlignmentStatus>>;
};

export type EnumBoehringerIngelheimCustomerAlignmentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumBoehringerIngelheimCustomerAlignmentStatusFilter>;
  _min?: Maybe<NestedEnumBoehringerIngelheimCustomerAlignmentStatusFilter>;
  equals?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  in?: Maybe<Array<BoehringerIngelheimCustomerAlignmentStatus>>;
  not?: Maybe<NestedEnumBoehringerIngelheimCustomerAlignmentStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<BoehringerIngelheimCustomerAlignmentStatus>>;
};

export type EnumCallDirectionFieldUpdateOperationsInput = {
  set?: Maybe<CallDirection>;
};

export type EnumCallDirectionFilter = {
  equals?: Maybe<CallDirection>;
  in?: Maybe<Array<CallDirection>>;
  not?: Maybe<NestedEnumCallDirectionFilter>;
  notIn?: Maybe<Array<CallDirection>>;
};

export type EnumCallDirectionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCallDirectionFilter>;
  _min?: Maybe<NestedEnumCallDirectionFilter>;
  equals?: Maybe<CallDirection>;
  in?: Maybe<Array<CallDirection>>;
  not?: Maybe<NestedEnumCallDirectionWithAggregatesFilter>;
  notIn?: Maybe<Array<CallDirection>>;
};

export type EnumCallHistoryTypeFieldUpdateOperationsInput = {
  set?: Maybe<CallHistoryType>;
};

export type EnumCallHistoryTypeFilter = {
  equals?: Maybe<CallHistoryType>;
  in?: Maybe<Array<CallHistoryType>>;
  not?: Maybe<NestedEnumCallHistoryTypeFilter>;
  notIn?: Maybe<Array<CallHistoryType>>;
};

export type EnumCallHistoryTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCallHistoryTypeFilter>;
  _min?: Maybe<NestedEnumCallHistoryTypeFilter>;
  equals?: Maybe<CallHistoryType>;
  in?: Maybe<Array<CallHistoryType>>;
  not?: Maybe<NestedEnumCallHistoryTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CallHistoryType>>;
};

export type EnumCallParticipantResultNullableFilter = {
  equals?: Maybe<CallParticipantResult>;
  in?: Maybe<Array<CallParticipantResult>>;
  not?: Maybe<NestedEnumCallParticipantResultNullableFilter>;
  notIn?: Maybe<Array<CallParticipantResult>>;
};

export type EnumCallParticipantResultNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCallParticipantResultNullableFilter>;
  _min?: Maybe<NestedEnumCallParticipantResultNullableFilter>;
  equals?: Maybe<CallParticipantResult>;
  in?: Maybe<Array<CallParticipantResult>>;
  not?: Maybe<NestedEnumCallParticipantResultNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CallParticipantResult>>;
};

export type EnumCallProviderFieldUpdateOperationsInput = {
  set?: Maybe<CallProvider>;
};

export type EnumCallProviderFilter = {
  equals?: Maybe<CallProvider>;
  in?: Maybe<Array<CallProvider>>;
  not?: Maybe<NestedEnumCallProviderFilter>;
  notIn?: Maybe<Array<CallProvider>>;
};

export type EnumCallProviderWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCallProviderFilter>;
  _min?: Maybe<NestedEnumCallProviderFilter>;
  equals?: Maybe<CallProvider>;
  in?: Maybe<Array<CallProvider>>;
  not?: Maybe<NestedEnumCallProviderWithAggregatesFilter>;
  notIn?: Maybe<Array<CallProvider>>;
};

export type EnumCallStatusFieldUpdateOperationsInput = {
  set?: Maybe<CallStatus>;
};

export type EnumCallStatusFilter = {
  equals?: Maybe<CallStatus>;
  in?: Maybe<Array<CallStatus>>;
  not?: Maybe<NestedEnumCallStatusFilter>;
  notIn?: Maybe<Array<CallStatus>>;
};

export type EnumCallStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCallStatusFilter>;
  _min?: Maybe<NestedEnumCallStatusFilter>;
  equals?: Maybe<CallStatus>;
  in?: Maybe<Array<CallStatus>>;
  not?: Maybe<NestedEnumCallStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<CallStatus>>;
};

export type EnumCampaignRegistryBrandIdentityStatusNullableFilter = {
  equals?: Maybe<CampaignRegistryBrandIdentityStatus>;
  in?: Maybe<Array<CampaignRegistryBrandIdentityStatus>>;
  not?: Maybe<NestedEnumCampaignRegistryBrandIdentityStatusNullableFilter>;
  notIn?: Maybe<Array<CampaignRegistryBrandIdentityStatus>>;
};

export type EnumCampaignRegistryBrandIdentityStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCampaignRegistryBrandIdentityStatusNullableFilter>;
  _min?: Maybe<NestedEnumCampaignRegistryBrandIdentityStatusNullableFilter>;
  equals?: Maybe<CampaignRegistryBrandIdentityStatus>;
  in?: Maybe<Array<CampaignRegistryBrandIdentityStatus>>;
  not?: Maybe<NestedEnumCampaignRegistryBrandIdentityStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CampaignRegistryBrandIdentityStatus>>;
};

export type EnumCampaignRegistryCampaignSharingStatusNullableFilter = {
  equals?: Maybe<CampaignRegistryCampaignSharingStatus>;
  in?: Maybe<Array<CampaignRegistryCampaignSharingStatus>>;
  not?: Maybe<NestedEnumCampaignRegistryCampaignSharingStatusNullableFilter>;
  notIn?: Maybe<Array<CampaignRegistryCampaignSharingStatus>>;
};

export type EnumCampaignRegistryCampaignSharingStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCampaignRegistryCampaignSharingStatusNullableFilter>;
  _min?: Maybe<NestedEnumCampaignRegistryCampaignSharingStatusNullableFilter>;
  equals?: Maybe<CampaignRegistryCampaignSharingStatus>;
  in?: Maybe<Array<CampaignRegistryCampaignSharingStatus>>;
  not?: Maybe<NestedEnumCampaignRegistryCampaignSharingStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CampaignRegistryCampaignSharingStatus>>;
};

export type EnumCancelReasonTypeNullableFilter = {
  equals?: Maybe<CancelReasonType>;
  in?: Maybe<Array<CancelReasonType>>;
  not?: Maybe<NestedEnumCancelReasonTypeNullableFilter>;
  notIn?: Maybe<Array<CancelReasonType>>;
};

export type EnumCancelReasonTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCancelReasonTypeNullableFilter>;
  _min?: Maybe<NestedEnumCancelReasonTypeNullableFilter>;
  equals?: Maybe<CancelReasonType>;
  in?: Maybe<Array<CancelReasonType>>;
  not?: Maybe<NestedEnumCancelReasonTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CancelReasonType>>;
};

export type EnumCanonicalDataSourceFieldUpdateOperationsInput = {
  set?: Maybe<CanonicalDataSource>;
};

export type EnumCanonicalDataSourceFilter = {
  equals?: Maybe<CanonicalDataSource>;
  in?: Maybe<Array<CanonicalDataSource>>;
  not?: Maybe<NestedEnumCanonicalDataSourceFilter>;
  notIn?: Maybe<Array<CanonicalDataSource>>;
};

export type EnumCanonicalDataSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCanonicalDataSourceFilter>;
  _min?: Maybe<NestedEnumCanonicalDataSourceFilter>;
  equals?: Maybe<CanonicalDataSource>;
  in?: Maybe<Array<CanonicalDataSource>>;
  not?: Maybe<NestedEnumCanonicalDataSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<CanonicalDataSource>>;
};

export type EnumCanonicalServiceStatusFieldUpdateOperationsInput = {
  set?: Maybe<CanonicalServiceStatus>;
};

export type EnumCanonicalServiceStatusFilter = {
  equals?: Maybe<CanonicalServiceStatus>;
  in?: Maybe<Array<CanonicalServiceStatus>>;
  not?: Maybe<NestedEnumCanonicalServiceStatusFilter>;
  notIn?: Maybe<Array<CanonicalServiceStatus>>;
};

export type EnumCanonicalServiceStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCanonicalServiceStatusFilter>;
  _min?: Maybe<NestedEnumCanonicalServiceStatusFilter>;
  equals?: Maybe<CanonicalServiceStatus>;
  in?: Maybe<Array<CanonicalServiceStatus>>;
  not?: Maybe<NestedEnumCanonicalServiceStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<CanonicalServiceStatus>>;
};

export type EnumCanonicalServiceTypeFieldUpdateOperationsInput = {
  set?: Maybe<CanonicalServiceType>;
};

export type EnumCanonicalServiceTypeFilter = {
  equals?: Maybe<CanonicalServiceType>;
  in?: Maybe<Array<CanonicalServiceType>>;
  not?: Maybe<NestedEnumCanonicalServiceTypeFilter>;
  notIn?: Maybe<Array<CanonicalServiceType>>;
};

export type EnumCanonicalServiceTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCanonicalServiceTypeFilter>;
  _min?: Maybe<NestedEnumCanonicalServiceTypeFilter>;
  equals?: Maybe<CanonicalServiceType>;
  in?: Maybe<Array<CanonicalServiceType>>;
  not?: Maybe<NestedEnumCanonicalServiceTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CanonicalServiceType>>;
};

export type EnumCardBrandFieldUpdateOperationsInput = {
  set?: Maybe<CardBrand>;
};

export type EnumCardBrandFilter = {
  equals?: Maybe<CardBrand>;
  in?: Maybe<Array<CardBrand>>;
  not?: Maybe<NestedEnumCardBrandFilter>;
  notIn?: Maybe<Array<CardBrand>>;
};

export type EnumCardBrandNullableFilter = {
  equals?: Maybe<CardBrand>;
  in?: Maybe<Array<CardBrand>>;
  not?: Maybe<NestedEnumCardBrandNullableFilter>;
  notIn?: Maybe<Array<CardBrand>>;
};

export type EnumCardBrandNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCardBrandNullableFilter>;
  _min?: Maybe<NestedEnumCardBrandNullableFilter>;
  equals?: Maybe<CardBrand>;
  in?: Maybe<Array<CardBrand>>;
  not?: Maybe<NestedEnumCardBrandNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CardBrand>>;
};

export type EnumCardBrandWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCardBrandFilter>;
  _min?: Maybe<NestedEnumCardBrandFilter>;
  equals?: Maybe<CardBrand>;
  in?: Maybe<Array<CardBrand>>;
  not?: Maybe<NestedEnumCardBrandWithAggregatesFilter>;
  notIn?: Maybe<Array<CardBrand>>;
};

export type EnumCardFundingNullableFilter = {
  equals?: Maybe<CardFunding>;
  in?: Maybe<Array<CardFunding>>;
  not?: Maybe<NestedEnumCardFundingNullableFilter>;
  notIn?: Maybe<Array<CardFunding>>;
};

export type EnumCardFundingNullableListFilter = {
  equals?: Maybe<Array<CardFunding>>;
  has?: Maybe<CardFunding>;
  hasEvery?: Maybe<Array<CardFunding>>;
  hasSome?: Maybe<Array<CardFunding>>;
  isEmpty?: Maybe<Scalars['Boolean']>;
};

export type EnumCardFundingNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCardFundingNullableFilter>;
  _min?: Maybe<NestedEnumCardFundingNullableFilter>;
  equals?: Maybe<CardFunding>;
  in?: Maybe<Array<CardFunding>>;
  not?: Maybe<NestedEnumCardFundingNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CardFunding>>;
};

export type EnumCareBenefitTypeFieldUpdateOperationsInput = {
  set?: Maybe<CareBenefitType>;
};

export type EnumCareBenefitTypeFilter = {
  equals?: Maybe<CareBenefitType>;
  in?: Maybe<Array<CareBenefitType>>;
  not?: Maybe<NestedEnumCareBenefitTypeFilter>;
  notIn?: Maybe<Array<CareBenefitType>>;
};

export type EnumCareBenefitTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCareBenefitTypeFilter>;
  _min?: Maybe<NestedEnumCareBenefitTypeFilter>;
  equals?: Maybe<CareBenefitType>;
  in?: Maybe<Array<CareBenefitType>>;
  not?: Maybe<NestedEnumCareBenefitTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CareBenefitType>>;
};

export type EnumCareBenefitUnitOfMeasureNullableFilter = {
  equals?: Maybe<CareBenefitUnitOfMeasure>;
  in?: Maybe<Array<CareBenefitUnitOfMeasure>>;
  not?: Maybe<NestedEnumCareBenefitUnitOfMeasureNullableFilter>;
  notIn?: Maybe<Array<CareBenefitUnitOfMeasure>>;
};

export type EnumCareBenefitUnitOfMeasureNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCareBenefitUnitOfMeasureNullableFilter>;
  _min?: Maybe<NestedEnumCareBenefitUnitOfMeasureNullableFilter>;
  equals?: Maybe<CareBenefitUnitOfMeasure>;
  in?: Maybe<Array<CareBenefitUnitOfMeasure>>;
  not?: Maybe<NestedEnumCareBenefitUnitOfMeasureNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CareBenefitUnitOfMeasure>>;
};

export type EnumCareCreditPreapprovalDecisionNullableFilter = {
  equals?: Maybe<CareCreditPreapprovalDecision>;
  in?: Maybe<Array<CareCreditPreapprovalDecision>>;
  not?: Maybe<NestedEnumCareCreditPreapprovalDecisionNullableFilter>;
  notIn?: Maybe<Array<CareCreditPreapprovalDecision>>;
};

export type EnumCareCreditPreapprovalDecisionNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCareCreditPreapprovalDecisionNullableFilter>;
  _min?: Maybe<NestedEnumCareCreditPreapprovalDecisionNullableFilter>;
  equals?: Maybe<CareCreditPreapprovalDecision>;
  in?: Maybe<Array<CareCreditPreapprovalDecision>>;
  not?: Maybe<NestedEnumCareCreditPreapprovalDecisionNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CareCreditPreapprovalDecision>>;
};

export type EnumCareLapsedPaymentStatusFieldUpdateOperationsInput = {
  set?: Maybe<CareLapsedPaymentStatus>;
};

export type EnumCareLapsedPaymentStatusFilter = {
  equals?: Maybe<CareLapsedPaymentStatus>;
  in?: Maybe<Array<CareLapsedPaymentStatus>>;
  not?: Maybe<NestedEnumCareLapsedPaymentStatusFilter>;
  notIn?: Maybe<Array<CareLapsedPaymentStatus>>;
};

export type EnumCareLapsedPaymentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCareLapsedPaymentStatusFilter>;
  _min?: Maybe<NestedEnumCareLapsedPaymentStatusFilter>;
  equals?: Maybe<CareLapsedPaymentStatus>;
  in?: Maybe<Array<CareLapsedPaymentStatus>>;
  not?: Maybe<NestedEnumCareLapsedPaymentStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<CareLapsedPaymentStatus>>;
};

export type EnumCarePlanCycleTypeFieldUpdateOperationsInput = {
  set?: Maybe<CarePlanCycleType>;
};

export type EnumCarePlanCycleTypeFilter = {
  equals?: Maybe<CarePlanCycleType>;
  in?: Maybe<Array<CarePlanCycleType>>;
  not?: Maybe<NestedEnumCarePlanCycleTypeFilter>;
  notIn?: Maybe<Array<CarePlanCycleType>>;
};

export type EnumCarePlanCycleTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCarePlanCycleTypeFilter>;
  _min?: Maybe<NestedEnumCarePlanCycleTypeFilter>;
  equals?: Maybe<CarePlanCycleType>;
  in?: Maybe<Array<CarePlanCycleType>>;
  not?: Maybe<NestedEnumCarePlanCycleTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CarePlanCycleType>>;
};

export type EnumCareProgramLaunchStatusFieldUpdateOperationsInput = {
  set?: Maybe<CareProgramLaunchStatus>;
};

export type EnumCareProgramLaunchStatusFilter = {
  equals?: Maybe<CareProgramLaunchStatus>;
  in?: Maybe<Array<CareProgramLaunchStatus>>;
  not?: Maybe<NestedEnumCareProgramLaunchStatusFilter>;
  notIn?: Maybe<Array<CareProgramLaunchStatus>>;
};

export type EnumCareProgramLaunchStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCareProgramLaunchStatusFilter>;
  _min?: Maybe<NestedEnumCareProgramLaunchStatusFilter>;
  equals?: Maybe<CareProgramLaunchStatus>;
  in?: Maybe<Array<CareProgramLaunchStatus>>;
  not?: Maybe<NestedEnumCareProgramLaunchStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<CareProgramLaunchStatus>>;
};

export type EnumCareSubscriptionPaymentStatusNullableFilter = {
  equals?: Maybe<CareSubscriptionPaymentStatus>;
  in?: Maybe<Array<CareSubscriptionPaymentStatus>>;
  not?: Maybe<NestedEnumCareSubscriptionPaymentStatusNullableFilter>;
  notIn?: Maybe<Array<CareSubscriptionPaymentStatus>>;
};

export type EnumCareSubscriptionPaymentStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCareSubscriptionPaymentStatusNullableFilter>;
  _min?: Maybe<NestedEnumCareSubscriptionPaymentStatusNullableFilter>;
  equals?: Maybe<CareSubscriptionPaymentStatus>;
  in?: Maybe<Array<CareSubscriptionPaymentStatus>>;
  not?: Maybe<NestedEnumCareSubscriptionPaymentStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CareSubscriptionPaymentStatus>>;
};

export type EnumCareSubscriptionTrueUpStatusFieldUpdateOperationsInput = {
  set?: Maybe<CareSubscriptionTrueUpStatus>;
};

export type EnumCareSubscriptionTrueUpStatusFilter = {
  equals?: Maybe<CareSubscriptionTrueUpStatus>;
  in?: Maybe<Array<CareSubscriptionTrueUpStatus>>;
  not?: Maybe<NestedEnumCareSubscriptionTrueUpStatusFilter>;
  notIn?: Maybe<Array<CareSubscriptionTrueUpStatus>>;
};

export type EnumCareSubscriptionTrueUpStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCareSubscriptionTrueUpStatusFilter>;
  _min?: Maybe<NestedEnumCareSubscriptionTrueUpStatusFilter>;
  equals?: Maybe<CareSubscriptionTrueUpStatus>;
  in?: Maybe<Array<CareSubscriptionTrueUpStatus>>;
  not?: Maybe<NestedEnumCareSubscriptionTrueUpStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<CareSubscriptionTrueUpStatus>>;
};

export type EnumCareSubscriptionTrueUpTypeFieldUpdateOperationsInput = {
  set?: Maybe<CareSubscriptionTrueUpType>;
};

export type EnumCareSubscriptionTrueUpTypeFilter = {
  equals?: Maybe<CareSubscriptionTrueUpType>;
  in?: Maybe<Array<CareSubscriptionTrueUpType>>;
  not?: Maybe<NestedEnumCareSubscriptionTrueUpTypeFilter>;
  notIn?: Maybe<Array<CareSubscriptionTrueUpType>>;
};

export type EnumCareSubscriptionTrueUpTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCareSubscriptionTrueUpTypeFilter>;
  _min?: Maybe<NestedEnumCareSubscriptionTrueUpTypeFilter>;
  equals?: Maybe<CareSubscriptionTrueUpType>;
  in?: Maybe<Array<CareSubscriptionTrueUpType>>;
  not?: Maybe<NestedEnumCareSubscriptionTrueUpTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CareSubscriptionTrueUpType>>;
};

export type EnumChannelCreationSourceTypeFieldUpdateOperationsInput = {
  set?: Maybe<ChannelCreationSourceType>;
};

export type EnumChannelCreationSourceTypeFilter = {
  equals?: Maybe<ChannelCreationSourceType>;
  in?: Maybe<Array<ChannelCreationSourceType>>;
  not?: Maybe<NestedEnumChannelCreationSourceTypeFilter>;
  notIn?: Maybe<Array<ChannelCreationSourceType>>;
};

export type EnumChannelCreationSourceTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumChannelCreationSourceTypeFilter>;
  _min?: Maybe<NestedEnumChannelCreationSourceTypeFilter>;
  equals?: Maybe<ChannelCreationSourceType>;
  in?: Maybe<Array<ChannelCreationSourceType>>;
  not?: Maybe<NestedEnumChannelCreationSourceTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelCreationSourceType>>;
};

export type EnumChannelMessageAttachmentEntityTypeNullableFilter = {
  equals?: Maybe<ChannelMessageAttachmentEntityType>;
  in?: Maybe<Array<ChannelMessageAttachmentEntityType>>;
  not?: Maybe<NestedEnumChannelMessageAttachmentEntityTypeNullableFilter>;
  notIn?: Maybe<Array<ChannelMessageAttachmentEntityType>>;
};

export type EnumChannelMessageAttachmentEntityTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumChannelMessageAttachmentEntityTypeNullableFilter>;
  _min?: Maybe<NestedEnumChannelMessageAttachmentEntityTypeNullableFilter>;
  equals?: Maybe<ChannelMessageAttachmentEntityType>;
  in?: Maybe<Array<ChannelMessageAttachmentEntityType>>;
  not?: Maybe<NestedEnumChannelMessageAttachmentEntityTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelMessageAttachmentEntityType>>;
};

export type EnumChannelMessageAttachmentTypeFieldUpdateOperationsInput = {
  set?: Maybe<ChannelMessageAttachmentType>;
};

export type EnumChannelMessageAttachmentTypeFilter = {
  equals?: Maybe<ChannelMessageAttachmentType>;
  in?: Maybe<Array<ChannelMessageAttachmentType>>;
  not?: Maybe<NestedEnumChannelMessageAttachmentTypeFilter>;
  notIn?: Maybe<Array<ChannelMessageAttachmentType>>;
};

export type EnumChannelMessageAttachmentTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumChannelMessageAttachmentTypeFilter>;
  _min?: Maybe<NestedEnumChannelMessageAttachmentTypeFilter>;
  equals?: Maybe<ChannelMessageAttachmentType>;
  in?: Maybe<Array<ChannelMessageAttachmentType>>;
  not?: Maybe<NestedEnumChannelMessageAttachmentTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelMessageAttachmentType>>;
};

export type EnumChannelMessageAttachmentUploadStatusNullableFilter = {
  equals?: Maybe<ChannelMessageAttachmentUploadStatus>;
  in?: Maybe<Array<ChannelMessageAttachmentUploadStatus>>;
  not?: Maybe<NestedEnumChannelMessageAttachmentUploadStatusNullableFilter>;
  notIn?: Maybe<Array<ChannelMessageAttachmentUploadStatus>>;
};

export type EnumChannelMessageAttachmentUploadStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumChannelMessageAttachmentUploadStatusNullableFilter>;
  _min?: Maybe<NestedEnumChannelMessageAttachmentUploadStatusNullableFilter>;
  equals?: Maybe<ChannelMessageAttachmentUploadStatus>;
  in?: Maybe<Array<ChannelMessageAttachmentUploadStatus>>;
  not?: Maybe<NestedEnumChannelMessageAttachmentUploadStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelMessageAttachmentUploadStatus>>;
};

export type EnumChannelStatusActionFieldUpdateOperationsInput = {
  set?: Maybe<ChannelStatusAction>;
};

export type EnumChannelStatusActionFilter = {
  equals?: Maybe<ChannelStatusAction>;
  in?: Maybe<Array<ChannelStatusAction>>;
  not?: Maybe<NestedEnumChannelStatusActionFilter>;
  notIn?: Maybe<Array<ChannelStatusAction>>;
};

export type EnumChannelStatusActionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumChannelStatusActionFilter>;
  _min?: Maybe<NestedEnumChannelStatusActionFilter>;
  equals?: Maybe<ChannelStatusAction>;
  in?: Maybe<Array<ChannelStatusAction>>;
  not?: Maybe<NestedEnumChannelStatusActionWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelStatusAction>>;
};

export type EnumChannelTypeNullableFilter = {
  equals?: Maybe<ChannelType>;
  in?: Maybe<Array<ChannelType>>;
  not?: Maybe<NestedEnumChannelTypeNullableFilter>;
  notIn?: Maybe<Array<ChannelType>>;
};

export type EnumChannelTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumChannelTypeNullableFilter>;
  _min?: Maybe<NestedEnumChannelTypeNullableFilter>;
  equals?: Maybe<ChannelType>;
  in?: Maybe<Array<ChannelType>>;
  not?: Maybe<NestedEnumChannelTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelType>>;
};

export type EnumChannelVisibilityNullableFilter = {
  equals?: Maybe<ChannelVisibility>;
  in?: Maybe<Array<ChannelVisibility>>;
  not?: Maybe<NestedEnumChannelVisibilityNullableFilter>;
  notIn?: Maybe<Array<ChannelVisibility>>;
};

export type EnumChannelVisibilityNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumChannelVisibilityNullableFilter>;
  _min?: Maybe<NestedEnumChannelVisibilityNullableFilter>;
  equals?: Maybe<ChannelVisibility>;
  in?: Maybe<Array<ChannelVisibility>>;
  not?: Maybe<NestedEnumChannelVisibilityNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelVisibility>>;
};

export type EnumChargeCaptureTypeFieldUpdateOperationsInput = {
  set?: Maybe<ChargeCaptureType>;
};

export type EnumChargeCaptureTypeFilter = {
  equals?: Maybe<ChargeCaptureType>;
  in?: Maybe<Array<ChargeCaptureType>>;
  not?: Maybe<NestedEnumChargeCaptureTypeFilter>;
  notIn?: Maybe<Array<ChargeCaptureType>>;
};

export type EnumChargeCaptureTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumChargeCaptureTypeFilter>;
  _min?: Maybe<NestedEnumChargeCaptureTypeFilter>;
  equals?: Maybe<ChargeCaptureType>;
  in?: Maybe<Array<ChargeCaptureType>>;
  not?: Maybe<NestedEnumChargeCaptureTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ChargeCaptureType>>;
};

export type EnumClientConnectClinicSoftwareFieldUpdateOperationsInput = {
  set?: Maybe<ClientConnectClinicSoftware>;
};

export type EnumClientConnectClinicSoftwareFilter = {
  equals?: Maybe<ClientConnectClinicSoftware>;
  in?: Maybe<Array<ClientConnectClinicSoftware>>;
  not?: Maybe<NestedEnumClientConnectClinicSoftwareFilter>;
  notIn?: Maybe<Array<ClientConnectClinicSoftware>>;
};

export type EnumClientConnectClinicSoftwareWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClientConnectClinicSoftwareFilter>;
  _min?: Maybe<NestedEnumClientConnectClinicSoftwareFilter>;
  equals?: Maybe<ClientConnectClinicSoftware>;
  in?: Maybe<Array<ClientConnectClinicSoftware>>;
  not?: Maybe<NestedEnumClientConnectClinicSoftwareWithAggregatesFilter>;
  notIn?: Maybe<Array<ClientConnectClinicSoftware>>;
};

export type EnumClientConnectSystemFieldUpdateOperationsInput = {
  set?: Maybe<ClientConnectSystem>;
};

export type EnumClientConnectSystemFilter = {
  equals?: Maybe<ClientConnectSystem>;
  in?: Maybe<Array<ClientConnectSystem>>;
  not?: Maybe<NestedEnumClientConnectSystemFilter>;
  notIn?: Maybe<Array<ClientConnectSystem>>;
};

export type EnumClientConnectSystemWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClientConnectSystemFilter>;
  _min?: Maybe<NestedEnumClientConnectSystemFilter>;
  equals?: Maybe<ClientConnectSystem>;
  in?: Maybe<Array<ClientConnectSystem>>;
  not?: Maybe<NestedEnumClientConnectSystemWithAggregatesFilter>;
  notIn?: Maybe<Array<ClientConnectSystem>>;
};

export type EnumClinicCustomPayoutsSetupStatusFieldUpdateOperationsInput = {
  set?: Maybe<ClinicCustomPayoutsSetupStatus>;
};

export type EnumClinicCustomPayoutsSetupStatusFilter = {
  equals?: Maybe<ClinicCustomPayoutsSetupStatus>;
  in?: Maybe<Array<ClinicCustomPayoutsSetupStatus>>;
  not?: Maybe<NestedEnumClinicCustomPayoutsSetupStatusFilter>;
  notIn?: Maybe<Array<ClinicCustomPayoutsSetupStatus>>;
};

export type EnumClinicCustomPayoutsSetupStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClinicCustomPayoutsSetupStatusFilter>;
  _min?: Maybe<NestedEnumClinicCustomPayoutsSetupStatusFilter>;
  equals?: Maybe<ClinicCustomPayoutsSetupStatus>;
  in?: Maybe<Array<ClinicCustomPayoutsSetupStatus>>;
  not?: Maybe<NestedEnumClinicCustomPayoutsSetupStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicCustomPayoutsSetupStatus>>;
};

export type EnumClinicEntityCreationSourceNullableFilter = {
  equals?: Maybe<ClinicEntityCreationSource>;
  in?: Maybe<Array<ClinicEntityCreationSource>>;
  not?: Maybe<NestedEnumClinicEntityCreationSourceNullableFilter>;
  notIn?: Maybe<Array<ClinicEntityCreationSource>>;
};

export type EnumClinicEntityCreationSourceNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumClinicEntityCreationSourceNullableFilter>;
  _min?: Maybe<NestedEnumClinicEntityCreationSourceNullableFilter>;
  equals?: Maybe<ClinicEntityCreationSource>;
  in?: Maybe<Array<ClinicEntityCreationSource>>;
  not?: Maybe<NestedEnumClinicEntityCreationSourceNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicEntityCreationSource>>;
};

export type EnumClinicEntityPhoneNumberSmsStatusNullableFilter = {
  equals?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  in?: Maybe<Array<ClinicEntityPhoneNumberSmsStatus>>;
  not?: Maybe<NestedEnumClinicEntityPhoneNumberSmsStatusNullableFilter>;
  notIn?: Maybe<Array<ClinicEntityPhoneNumberSmsStatus>>;
};

export type EnumClinicEntityPhoneNumberSmsStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumClinicEntityPhoneNumberSmsStatusNullableFilter>;
  _min?: Maybe<NestedEnumClinicEntityPhoneNumberSmsStatusNullableFilter>;
  equals?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  in?: Maybe<Array<ClinicEntityPhoneNumberSmsStatus>>;
  not?: Maybe<NestedEnumClinicEntityPhoneNumberSmsStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicEntityPhoneNumberSmsStatus>>;
};

export type EnumClinicModuleSourceFieldUpdateOperationsInput = {
  set?: Maybe<ClinicModuleSource>;
};

export type EnumClinicModuleSourceFilter = {
  equals?: Maybe<ClinicModuleSource>;
  in?: Maybe<Array<ClinicModuleSource>>;
  not?: Maybe<NestedEnumClinicModuleSourceFilter>;
  notIn?: Maybe<Array<ClinicModuleSource>>;
};

export type EnumClinicModuleSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClinicModuleSourceFilter>;
  _min?: Maybe<NestedEnumClinicModuleSourceFilter>;
  equals?: Maybe<ClinicModuleSource>;
  in?: Maybe<Array<ClinicModuleSource>>;
  not?: Maybe<NestedEnumClinicModuleSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicModuleSource>>;
};

export type EnumClinicOfficeHoursTypeFieldUpdateOperationsInput = {
  set?: Maybe<ClinicOfficeHoursType>;
};

export type EnumClinicOfficeHoursTypeFilter = {
  equals?: Maybe<ClinicOfficeHoursType>;
  in?: Maybe<Array<ClinicOfficeHoursType>>;
  not?: Maybe<NestedEnumClinicOfficeHoursTypeFilter>;
  notIn?: Maybe<Array<ClinicOfficeHoursType>>;
};

export type EnumClinicOfficeHoursTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClinicOfficeHoursTypeFilter>;
  _min?: Maybe<NestedEnumClinicOfficeHoursTypeFilter>;
  equals?: Maybe<ClinicOfficeHoursType>;
  in?: Maybe<Array<ClinicOfficeHoursType>>;
  not?: Maybe<NestedEnumClinicOfficeHoursTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicOfficeHoursType>>;
};

export type EnumClinicPetParentAddressTypeNullableFilter = {
  equals?: Maybe<ClinicPetParentAddressType>;
  in?: Maybe<Array<ClinicPetParentAddressType>>;
  not?: Maybe<NestedEnumClinicPetParentAddressTypeNullableFilter>;
  notIn?: Maybe<Array<ClinicPetParentAddressType>>;
};

export type EnumClinicPetParentAddressTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumClinicPetParentAddressTypeNullableFilter>;
  _min?: Maybe<NestedEnumClinicPetParentAddressTypeNullableFilter>;
  equals?: Maybe<ClinicPetParentAddressType>;
  in?: Maybe<Array<ClinicPetParentAddressType>>;
  not?: Maybe<NestedEnumClinicPetParentAddressTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicPetParentAddressType>>;
};

export type EnumClinicPimsIntegrationTypeFieldUpdateOperationsInput = {
  set?: Maybe<ClinicPimsIntegrationType>;
};

export type EnumClinicPimsIntegrationTypeFilter = {
  equals?: Maybe<ClinicPimsIntegrationType>;
  in?: Maybe<Array<ClinicPimsIntegrationType>>;
  not?: Maybe<NestedEnumClinicPimsIntegrationTypeFilter>;
  notIn?: Maybe<Array<ClinicPimsIntegrationType>>;
};

export type EnumClinicPimsIntegrationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClinicPimsIntegrationTypeFilter>;
  _min?: Maybe<NestedEnumClinicPimsIntegrationTypeFilter>;
  equals?: Maybe<ClinicPimsIntegrationType>;
  in?: Maybe<Array<ClinicPimsIntegrationType>>;
  not?: Maybe<NestedEnumClinicPimsIntegrationTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicPimsIntegrationType>>;
};

export type EnumClinicUserFilterTypeFieldUpdateOperationsInput = {
  set?: Maybe<ClinicUserFilterType>;
};

export type EnumClinicUserFilterTypeFilter = {
  equals?: Maybe<ClinicUserFilterType>;
  in?: Maybe<Array<ClinicUserFilterType>>;
  not?: Maybe<NestedEnumClinicUserFilterTypeFilter>;
  notIn?: Maybe<Array<ClinicUserFilterType>>;
};

export type EnumClinicUserFilterTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClinicUserFilterTypeFilter>;
  _min?: Maybe<NestedEnumClinicUserFilterTypeFilter>;
  equals?: Maybe<ClinicUserFilterType>;
  in?: Maybe<Array<ClinicUserFilterType>>;
  not?: Maybe<NestedEnumClinicUserFilterTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicUserFilterType>>;
};

export type EnumConditionAttributeFieldUpdateOperationsInput = {
  set?: Maybe<ConditionAttribute>;
};

export type EnumConditionAttributeFilter = {
  equals?: Maybe<ConditionAttribute>;
  in?: Maybe<Array<ConditionAttribute>>;
  not?: Maybe<NestedEnumConditionAttributeFilter>;
  notIn?: Maybe<Array<ConditionAttribute>>;
};

export type EnumConditionAttributeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumConditionAttributeFilter>;
  _min?: Maybe<NestedEnumConditionAttributeFilter>;
  equals?: Maybe<ConditionAttribute>;
  in?: Maybe<Array<ConditionAttribute>>;
  not?: Maybe<NestedEnumConditionAttributeWithAggregatesFilter>;
  notIn?: Maybe<Array<ConditionAttribute>>;
};

export type EnumConditionEvaluationStatusFieldUpdateOperationsInput = {
  set?: Maybe<ConditionEvaluationStatus>;
};

export type EnumConditionEvaluationStatusFilter = {
  equals?: Maybe<ConditionEvaluationStatus>;
  in?: Maybe<Array<ConditionEvaluationStatus>>;
  not?: Maybe<NestedEnumConditionEvaluationStatusFilter>;
  notIn?: Maybe<Array<ConditionEvaluationStatus>>;
};

export type EnumConditionEvaluationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumConditionEvaluationStatusFilter>;
  _min?: Maybe<NestedEnumConditionEvaluationStatusFilter>;
  equals?: Maybe<ConditionEvaluationStatus>;
  in?: Maybe<Array<ConditionEvaluationStatus>>;
  not?: Maybe<NestedEnumConditionEvaluationStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<ConditionEvaluationStatus>>;
};

export type EnumConditionOperatorFieldUpdateOperationsInput = {
  set?: Maybe<ConditionOperator>;
};

export type EnumConditionOperatorFilter = {
  equals?: Maybe<ConditionOperator>;
  in?: Maybe<Array<ConditionOperator>>;
  not?: Maybe<NestedEnumConditionOperatorFilter>;
  notIn?: Maybe<Array<ConditionOperator>>;
};

export type EnumConditionOperatorWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumConditionOperatorFilter>;
  _min?: Maybe<NestedEnumConditionOperatorFilter>;
  equals?: Maybe<ConditionOperator>;
  in?: Maybe<Array<ConditionOperator>>;
  not?: Maybe<NestedEnumConditionOperatorWithAggregatesFilter>;
  notIn?: Maybe<Array<ConditionOperator>>;
};

export type EnumConditionSetOperatorFieldUpdateOperationsInput = {
  set?: Maybe<ConditionSetOperator>;
};

export type EnumConditionSetOperatorFilter = {
  equals?: Maybe<ConditionSetOperator>;
  in?: Maybe<Array<ConditionSetOperator>>;
  not?: Maybe<NestedEnumConditionSetOperatorFilter>;
  notIn?: Maybe<Array<ConditionSetOperator>>;
};

export type EnumConditionSetOperatorWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumConditionSetOperatorFilter>;
  _min?: Maybe<NestedEnumConditionSetOperatorFilter>;
  equals?: Maybe<ConditionSetOperator>;
  in?: Maybe<Array<ConditionSetOperator>>;
  not?: Maybe<NestedEnumConditionSetOperatorWithAggregatesFilter>;
  notIn?: Maybe<Array<ConditionSetOperator>>;
};

export type EnumConditionalEntityTypeFieldUpdateOperationsInput = {
  set?: Maybe<ConditionalEntityType>;
};

export type EnumConditionalEntityTypeFilter = {
  equals?: Maybe<ConditionalEntityType>;
  in?: Maybe<Array<ConditionalEntityType>>;
  not?: Maybe<NestedEnumConditionalEntityTypeFilter>;
  notIn?: Maybe<Array<ConditionalEntityType>>;
};

export type EnumConditionalEntityTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumConditionalEntityTypeFilter>;
  _min?: Maybe<NestedEnumConditionalEntityTypeFilter>;
  equals?: Maybe<ConditionalEntityType>;
  in?: Maybe<Array<ConditionalEntityType>>;
  not?: Maybe<NestedEnumConditionalEntityTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ConditionalEntityType>>;
};

export type EnumContactEntityTypeFieldUpdateOperationsInput = {
  set?: Maybe<ContactEntityType>;
};

export type EnumContactEntityTypeFilter = {
  equals?: Maybe<ContactEntityType>;
  in?: Maybe<Array<ContactEntityType>>;
  not?: Maybe<NestedEnumContactEntityTypeFilter>;
  notIn?: Maybe<Array<ContactEntityType>>;
};

export type EnumContactEntityTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumContactEntityTypeFilter>;
  _min?: Maybe<NestedEnumContactEntityTypeFilter>;
  equals?: Maybe<ContactEntityType>;
  in?: Maybe<Array<ContactEntityType>>;
  not?: Maybe<NestedEnumContactEntityTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ContactEntityType>>;
};

export type EnumContactVerificationMethodNullableFilter = {
  equals?: Maybe<ContactVerificationMethod>;
  in?: Maybe<Array<ContactVerificationMethod>>;
  not?: Maybe<NestedEnumContactVerificationMethodNullableFilter>;
  notIn?: Maybe<Array<ContactVerificationMethod>>;
};

export type EnumContactVerificationMethodNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumContactVerificationMethodNullableFilter>;
  _min?: Maybe<NestedEnumContactVerificationMethodNullableFilter>;
  equals?: Maybe<ContactVerificationMethod>;
  in?: Maybe<Array<ContactVerificationMethod>>;
  not?: Maybe<NestedEnumContactVerificationMethodNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ContactVerificationMethod>>;
};

export type EnumContextEntityTypeFieldUpdateOperationsInput = {
  set?: Maybe<ContextEntityType>;
};

export type EnumContextEntityTypeFilter = {
  equals?: Maybe<ContextEntityType>;
  in?: Maybe<Array<ContextEntityType>>;
  not?: Maybe<NestedEnumContextEntityTypeFilter>;
  notIn?: Maybe<Array<ContextEntityType>>;
};

export type EnumContextEntityTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumContextEntityTypeFilter>;
  _min?: Maybe<NestedEnumContextEntityTypeFilter>;
  equals?: Maybe<ContextEntityType>;
  in?: Maybe<Array<ContextEntityType>>;
  not?: Maybe<NestedEnumContextEntityTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ContextEntityType>>;
};

export type EnumCurrencyFieldUpdateOperationsInput = {
  set?: Maybe<Currency>;
};

export type EnumCurrencyFilter = {
  equals?: Maybe<Currency>;
  in?: Maybe<Array<Currency>>;
  not?: Maybe<NestedEnumCurrencyFilter>;
  notIn?: Maybe<Array<Currency>>;
};

export type EnumCurrencyWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCurrencyFilter>;
  _min?: Maybe<NestedEnumCurrencyFilter>;
  equals?: Maybe<Currency>;
  in?: Maybe<Array<Currency>>;
  not?: Maybe<NestedEnumCurrencyWithAggregatesFilter>;
  notIn?: Maybe<Array<Currency>>;
};

export type EnumCustomFieldDesignationFieldUpdateOperationsInput = {
  set?: Maybe<CustomFieldDesignation>;
};

export type EnumCustomFieldDesignationFilter = {
  equals?: Maybe<CustomFieldDesignation>;
  in?: Maybe<Array<CustomFieldDesignation>>;
  not?: Maybe<NestedEnumCustomFieldDesignationFilter>;
  notIn?: Maybe<Array<CustomFieldDesignation>>;
};

export type EnumCustomFieldDesignationWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCustomFieldDesignationFilter>;
  _min?: Maybe<NestedEnumCustomFieldDesignationFilter>;
  equals?: Maybe<CustomFieldDesignation>;
  in?: Maybe<Array<CustomFieldDesignation>>;
  not?: Maybe<NestedEnumCustomFieldDesignationWithAggregatesFilter>;
  notIn?: Maybe<Array<CustomFieldDesignation>>;
};

export type EnumCustomFieldNormalizedDataTypeFieldUpdateOperationsInput = {
  set?: Maybe<CustomFieldNormalizedDataType>;
};

export type EnumCustomFieldNormalizedDataTypeFilter = {
  equals?: Maybe<CustomFieldNormalizedDataType>;
  in?: Maybe<Array<CustomFieldNormalizedDataType>>;
  not?: Maybe<NestedEnumCustomFieldNormalizedDataTypeFilter>;
  notIn?: Maybe<Array<CustomFieldNormalizedDataType>>;
};

export type EnumCustomFieldNormalizedDataTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCustomFieldNormalizedDataTypeFilter>;
  _min?: Maybe<NestedEnumCustomFieldNormalizedDataTypeFilter>;
  equals?: Maybe<CustomFieldNormalizedDataType>;
  in?: Maybe<Array<CustomFieldNormalizedDataType>>;
  not?: Maybe<NestedEnumCustomFieldNormalizedDataTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CustomFieldNormalizedDataType>>;
};

export type EnumCustomFieldPimsSyncTypeFieldUpdateOperationsInput = {
  set?: Maybe<CustomFieldPimsSyncType>;
};

export type EnumCustomFieldPimsSyncTypeFilter = {
  equals?: Maybe<CustomFieldPimsSyncType>;
  in?: Maybe<Array<CustomFieldPimsSyncType>>;
  not?: Maybe<NestedEnumCustomFieldPimsSyncTypeFilter>;
  notIn?: Maybe<Array<CustomFieldPimsSyncType>>;
};

export type EnumCustomFieldPimsSyncTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCustomFieldPimsSyncTypeFilter>;
  _min?: Maybe<NestedEnumCustomFieldPimsSyncTypeFilter>;
  equals?: Maybe<CustomFieldPimsSyncType>;
  in?: Maybe<Array<CustomFieldPimsSyncType>>;
  not?: Maybe<NestedEnumCustomFieldPimsSyncTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CustomFieldPimsSyncType>>;
};

export type EnumCustomFieldTargetTypeFieldUpdateOperationsInput = {
  set?: Maybe<CustomFieldTargetType>;
};

export type EnumCustomFieldTargetTypeFilter = {
  equals?: Maybe<CustomFieldTargetType>;
  in?: Maybe<Array<CustomFieldTargetType>>;
  not?: Maybe<NestedEnumCustomFieldTargetTypeFilter>;
  notIn?: Maybe<Array<CustomFieldTargetType>>;
};

export type EnumCustomFieldTargetTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCustomFieldTargetTypeFilter>;
  _min?: Maybe<NestedEnumCustomFieldTargetTypeFilter>;
  equals?: Maybe<CustomFieldTargetType>;
  in?: Maybe<Array<CustomFieldTargetType>>;
  not?: Maybe<NestedEnumCustomFieldTargetTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CustomFieldTargetType>>;
};

export type EnumCustomFieldsDataSourceNullableFilter = {
  equals?: Maybe<CustomFieldsDataSource>;
  in?: Maybe<Array<CustomFieldsDataSource>>;
  not?: Maybe<NestedEnumCustomFieldsDataSourceNullableFilter>;
  notIn?: Maybe<Array<CustomFieldsDataSource>>;
};

export type EnumCustomFieldsDataSourceNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCustomFieldsDataSourceNullableFilter>;
  _min?: Maybe<NestedEnumCustomFieldsDataSourceNullableFilter>;
  equals?: Maybe<CustomFieldsDataSource>;
  in?: Maybe<Array<CustomFieldsDataSource>>;
  not?: Maybe<NestedEnumCustomFieldsDataSourceNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CustomFieldsDataSource>>;
};

export type EnumDeviceOsNullableFilter = {
  equals?: Maybe<DeviceOs>;
  in?: Maybe<Array<DeviceOs>>;
  not?: Maybe<NestedEnumDeviceOsNullableFilter>;
  notIn?: Maybe<Array<DeviceOs>>;
};

export type EnumDeviceOsNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumDeviceOsNullableFilter>;
  _min?: Maybe<NestedEnumDeviceOsNullableFilter>;
  equals?: Maybe<DeviceOs>;
  in?: Maybe<Array<DeviceOs>>;
  not?: Maybe<NestedEnumDeviceOsNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<DeviceOs>>;
};

export type EnumDeviceTypeNullableFilter = {
  equals?: Maybe<DeviceType>;
  in?: Maybe<Array<DeviceType>>;
  not?: Maybe<NestedEnumDeviceTypeNullableFilter>;
  notIn?: Maybe<Array<DeviceType>>;
};

export type EnumDeviceTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumDeviceTypeNullableFilter>;
  _min?: Maybe<NestedEnumDeviceTypeNullableFilter>;
  equals?: Maybe<DeviceType>;
  in?: Maybe<Array<DeviceType>>;
  not?: Maybe<NestedEnumDeviceTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<DeviceType>>;
};

export type EnumDirectBookingAppointmentTypeClientTypeFieldUpdateOperationsInput = {
  set?: Maybe<DirectBookingAppointmentTypeClientType>;
};

export type EnumDirectBookingAppointmentTypeClientTypeFilter = {
  equals?: Maybe<DirectBookingAppointmentTypeClientType>;
  in?: Maybe<Array<DirectBookingAppointmentTypeClientType>>;
  not?: Maybe<NestedEnumDirectBookingAppointmentTypeClientTypeFilter>;
  notIn?: Maybe<Array<DirectBookingAppointmentTypeClientType>>;
};

export type EnumDirectBookingAppointmentTypeClientTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDirectBookingAppointmentTypeClientTypeFilter>;
  _min?: Maybe<NestedEnumDirectBookingAppointmentTypeClientTypeFilter>;
  equals?: Maybe<DirectBookingAppointmentTypeClientType>;
  in?: Maybe<Array<DirectBookingAppointmentTypeClientType>>;
  not?: Maybe<NestedEnumDirectBookingAppointmentTypeClientTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<DirectBookingAppointmentTypeClientType>>;
};

export type EnumDirectBookingSpeciesOptionFieldUpdateOperationsInput = {
  set?: Maybe<DirectBookingSpeciesOption>;
};

export type EnumDirectBookingSpeciesOptionFilter = {
  equals?: Maybe<DirectBookingSpeciesOption>;
  in?: Maybe<Array<DirectBookingSpeciesOption>>;
  not?: Maybe<NestedEnumDirectBookingSpeciesOptionFilter>;
  notIn?: Maybe<Array<DirectBookingSpeciesOption>>;
};

export type EnumDirectBookingSpeciesOptionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDirectBookingSpeciesOptionFilter>;
  _min?: Maybe<NestedEnumDirectBookingSpeciesOptionFilter>;
  equals?: Maybe<DirectBookingSpeciesOption>;
  in?: Maybe<Array<DirectBookingSpeciesOption>>;
  not?: Maybe<NestedEnumDirectBookingSpeciesOptionWithAggregatesFilter>;
  notIn?: Maybe<Array<DirectBookingSpeciesOption>>;
};

export type EnumDocumentationCategoryFieldUpdateOperationsInput = {
  set?: Maybe<DocumentationCategory>;
};

export type EnumDocumentationCategoryFilter = {
  equals?: Maybe<DocumentationCategory>;
  in?: Maybe<Array<DocumentationCategory>>;
  not?: Maybe<NestedEnumDocumentationCategoryFilter>;
  notIn?: Maybe<Array<DocumentationCategory>>;
};

export type EnumDocumentationCategoryWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentationCategoryFilter>;
  _min?: Maybe<NestedEnumDocumentationCategoryFilter>;
  equals?: Maybe<DocumentationCategory>;
  in?: Maybe<Array<DocumentationCategory>>;
  not?: Maybe<NestedEnumDocumentationCategoryWithAggregatesFilter>;
  notIn?: Maybe<Array<DocumentationCategory>>;
};

export type EnumDocumentationProviderFieldUpdateOperationsInput = {
  set?: Maybe<DocumentationProvider>;
};

export type EnumDocumentationProviderFilter = {
  equals?: Maybe<DocumentationProvider>;
  in?: Maybe<Array<DocumentationProvider>>;
  not?: Maybe<NestedEnumDocumentationProviderFilter>;
  notIn?: Maybe<Array<DocumentationProvider>>;
};

export type EnumDocumentationProviderWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentationProviderFilter>;
  _min?: Maybe<NestedEnumDocumentationProviderFilter>;
  equals?: Maybe<DocumentationProvider>;
  in?: Maybe<Array<DocumentationProvider>>;
  not?: Maybe<NestedEnumDocumentationProviderWithAggregatesFilter>;
  notIn?: Maybe<Array<DocumentationProvider>>;
};

export type EnumEmailCampaignCustomListRecipientStatusFieldUpdateOperationsInput = {
  set?: Maybe<EmailCampaignCustomListRecipientStatus>;
};

export type EnumEmailCampaignCustomListRecipientStatusFilter = {
  equals?: Maybe<EmailCampaignCustomListRecipientStatus>;
  in?: Maybe<Array<EmailCampaignCustomListRecipientStatus>>;
  not?: Maybe<NestedEnumEmailCampaignCustomListRecipientStatusFilter>;
  notIn?: Maybe<Array<EmailCampaignCustomListRecipientStatus>>;
};

export type EnumEmailCampaignCustomListRecipientStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailCampaignCustomListRecipientStatusFilter>;
  _min?: Maybe<NestedEnumEmailCampaignCustomListRecipientStatusFilter>;
  equals?: Maybe<EmailCampaignCustomListRecipientStatus>;
  in?: Maybe<Array<EmailCampaignCustomListRecipientStatus>>;
  not?: Maybe<NestedEnumEmailCampaignCustomListRecipientStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignCustomListRecipientStatus>>;
};

export type EnumEmailCampaignLogActionFieldUpdateOperationsInput = {
  set?: Maybe<EmailCampaignLogAction>;
};

export type EnumEmailCampaignLogActionFilter = {
  equals?: Maybe<EmailCampaignLogAction>;
  in?: Maybe<Array<EmailCampaignLogAction>>;
  not?: Maybe<NestedEnumEmailCampaignLogActionFilter>;
  notIn?: Maybe<Array<EmailCampaignLogAction>>;
};

export type EnumEmailCampaignLogActionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailCampaignLogActionFilter>;
  _min?: Maybe<NestedEnumEmailCampaignLogActionFilter>;
  equals?: Maybe<EmailCampaignLogAction>;
  in?: Maybe<Array<EmailCampaignLogAction>>;
  not?: Maybe<NestedEnumEmailCampaignLogActionWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignLogAction>>;
};

export type EnumEmailCampaignLogSkipReasonNullableFilter = {
  equals?: Maybe<EmailCampaignLogSkipReason>;
  in?: Maybe<Array<EmailCampaignLogSkipReason>>;
  not?: Maybe<NestedEnumEmailCampaignLogSkipReasonNullableFilter>;
  notIn?: Maybe<Array<EmailCampaignLogSkipReason>>;
};

export type EnumEmailCampaignLogSkipReasonNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumEmailCampaignLogSkipReasonNullableFilter>;
  _min?: Maybe<NestedEnumEmailCampaignLogSkipReasonNullableFilter>;
  equals?: Maybe<EmailCampaignLogSkipReason>;
  in?: Maybe<Array<EmailCampaignLogSkipReason>>;
  not?: Maybe<NestedEnumEmailCampaignLogSkipReasonNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignLogSkipReason>>;
};

export type EnumEmailCampaignSegmentationTypeFieldUpdateOperationsInput = {
  set?: Maybe<EmailCampaignSegmentationType>;
};

export type EnumEmailCampaignSegmentationTypeFilter = {
  equals?: Maybe<EmailCampaignSegmentationType>;
  in?: Maybe<Array<EmailCampaignSegmentationType>>;
  not?: Maybe<NestedEnumEmailCampaignSegmentationTypeFilter>;
  notIn?: Maybe<Array<EmailCampaignSegmentationType>>;
};

export type EnumEmailCampaignSegmentationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailCampaignSegmentationTypeFilter>;
  _min?: Maybe<NestedEnumEmailCampaignSegmentationTypeFilter>;
  equals?: Maybe<EmailCampaignSegmentationType>;
  in?: Maybe<Array<EmailCampaignSegmentationType>>;
  not?: Maybe<NestedEnumEmailCampaignSegmentationTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignSegmentationType>>;
};

export type EnumEmailCampaignStatusFieldUpdateOperationsInput = {
  set?: Maybe<EmailCampaignStatus>;
};

export type EnumEmailCampaignStatusFilter = {
  equals?: Maybe<EmailCampaignStatus>;
  in?: Maybe<Array<EmailCampaignStatus>>;
  not?: Maybe<NestedEnumEmailCampaignStatusFilter>;
  notIn?: Maybe<Array<EmailCampaignStatus>>;
};

export type EnumEmailCampaignStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailCampaignStatusFilter>;
  _min?: Maybe<NestedEnumEmailCampaignStatusFilter>;
  equals?: Maybe<EmailCampaignStatus>;
  in?: Maybe<Array<EmailCampaignStatus>>;
  not?: Maybe<NestedEnumEmailCampaignStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignStatus>>;
};

export type EnumEmailCampaignTypeFieldUpdateOperationsInput = {
  set?: Maybe<EmailCampaignType>;
};

export type EnumEmailCampaignTypeFilter = {
  equals?: Maybe<EmailCampaignType>;
  in?: Maybe<Array<EmailCampaignType>>;
  not?: Maybe<NestedEnumEmailCampaignTypeFilter>;
  notIn?: Maybe<Array<EmailCampaignType>>;
};

export type EnumEmailCampaignTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailCampaignTypeFilter>;
  _min?: Maybe<NestedEnumEmailCampaignTypeFilter>;
  equals?: Maybe<EmailCampaignType>;
  in?: Maybe<Array<EmailCampaignType>>;
  not?: Maybe<NestedEnumEmailCampaignTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignType>>;
};

export type EnumEmailCampaignUnsubscribeSourceFieldUpdateOperationsInput = {
  set?: Maybe<EmailCampaignUnsubscribeSource>;
};

export type EnumEmailCampaignUnsubscribeSourceFilter = {
  equals?: Maybe<EmailCampaignUnsubscribeSource>;
  in?: Maybe<Array<EmailCampaignUnsubscribeSource>>;
  not?: Maybe<NestedEnumEmailCampaignUnsubscribeSourceFilter>;
  notIn?: Maybe<Array<EmailCampaignUnsubscribeSource>>;
};

export type EnumEmailCampaignUnsubscribeSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailCampaignUnsubscribeSourceFilter>;
  _min?: Maybe<NestedEnumEmailCampaignUnsubscribeSourceFilter>;
  equals?: Maybe<EmailCampaignUnsubscribeSource>;
  in?: Maybe<Array<EmailCampaignUnsubscribeSource>>;
  not?: Maybe<NestedEnumEmailCampaignUnsubscribeSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignUnsubscribeSource>>;
};

export type EnumEmailProviderFieldUpdateOperationsInput = {
  set?: Maybe<EmailProvider>;
};

export type EnumEmailProviderFilter = {
  equals?: Maybe<EmailProvider>;
  in?: Maybe<Array<EmailProvider>>;
  not?: Maybe<NestedEnumEmailProviderFilter>;
  notIn?: Maybe<Array<EmailProvider>>;
};

export type EnumEmailProviderLogEntityTypeFieldUpdateOperationsInput = {
  set?: Maybe<EmailProviderLogEntityType>;
};

export type EnumEmailProviderLogEntityTypeFilter = {
  equals?: Maybe<EmailProviderLogEntityType>;
  in?: Maybe<Array<EmailProviderLogEntityType>>;
  not?: Maybe<NestedEnumEmailProviderLogEntityTypeFilter>;
  notIn?: Maybe<Array<EmailProviderLogEntityType>>;
};

export type EnumEmailProviderLogEntityTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailProviderLogEntityTypeFilter>;
  _min?: Maybe<NestedEnumEmailProviderLogEntityTypeFilter>;
  equals?: Maybe<EmailProviderLogEntityType>;
  in?: Maybe<Array<EmailProviderLogEntityType>>;
  not?: Maybe<NestedEnumEmailProviderLogEntityTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailProviderLogEntityType>>;
};

export type EnumEmailProviderWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailProviderFilter>;
  _min?: Maybe<NestedEnumEmailProviderFilter>;
  equals?: Maybe<EmailProvider>;
  in?: Maybe<Array<EmailProvider>>;
  not?: Maybe<NestedEnumEmailProviderWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailProvider>>;
};

export type EnumEmailTemplateTypeFieldUpdateOperationsInput = {
  set?: Maybe<EmailTemplateType>;
};

export type EnumEmailTemplateTypeFilter = {
  equals?: Maybe<EmailTemplateType>;
  in?: Maybe<Array<EmailTemplateType>>;
  not?: Maybe<NestedEnumEmailTemplateTypeFilter>;
  notIn?: Maybe<Array<EmailTemplateType>>;
};

export type EnumEmailTemplateTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailTemplateTypeFilter>;
  _min?: Maybe<NestedEnumEmailTemplateTypeFilter>;
  equals?: Maybe<EmailTemplateType>;
  in?: Maybe<Array<EmailTemplateType>>;
  not?: Maybe<NestedEnumEmailTemplateTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailTemplateType>>;
};

export type EnumEncryptedClinicUploadTypeFieldUpdateOperationsInput = {
  set?: Maybe<EncryptedClinicUploadType>;
};

export type EnumEncryptedClinicUploadTypeFilter = {
  equals?: Maybe<EncryptedClinicUploadType>;
  in?: Maybe<Array<EncryptedClinicUploadType>>;
  not?: Maybe<NestedEnumEncryptedClinicUploadTypeFilter>;
  notIn?: Maybe<Array<EncryptedClinicUploadType>>;
};

export type EnumEncryptedClinicUploadTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEncryptedClinicUploadTypeFilter>;
  _min?: Maybe<NestedEnumEncryptedClinicUploadTypeFilter>;
  equals?: Maybe<EncryptedClinicUploadType>;
  in?: Maybe<Array<EncryptedClinicUploadType>>;
  not?: Maybe<NestedEnumEncryptedClinicUploadTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<EncryptedClinicUploadType>>;
};

export type EnumEnrollmentStatusFieldUpdateOperationsInput = {
  set?: Maybe<EnrollmentStatus>;
};

export type EnumEnrollmentStatusFilter = {
  equals?: Maybe<EnrollmentStatus>;
  in?: Maybe<Array<EnrollmentStatus>>;
  not?: Maybe<NestedEnumEnrollmentStatusFilter>;
  notIn?: Maybe<Array<EnrollmentStatus>>;
};

export type EnumEnrollmentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEnrollmentStatusFilter>;
  _min?: Maybe<NestedEnumEnrollmentStatusFilter>;
  equals?: Maybe<EnrollmentStatus>;
  in?: Maybe<Array<EnrollmentStatus>>;
  not?: Maybe<NestedEnumEnrollmentStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<EnrollmentStatus>>;
};

export type EnumFeatureFlagStateFieldUpdateOperationsInput = {
  set?: Maybe<FeatureFlagState>;
};

export type EnumFeatureFlagStateFilter = {
  equals?: Maybe<FeatureFlagState>;
  in?: Maybe<Array<FeatureFlagState>>;
  not?: Maybe<NestedEnumFeatureFlagStateFilter>;
  notIn?: Maybe<Array<FeatureFlagState>>;
};

export type EnumFeatureFlagStateWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFeatureFlagStateFilter>;
  _min?: Maybe<NestedEnumFeatureFlagStateFilter>;
  equals?: Maybe<FeatureFlagState>;
  in?: Maybe<Array<FeatureFlagState>>;
  not?: Maybe<NestedEnumFeatureFlagStateWithAggregatesFilter>;
  notIn?: Maybe<Array<FeatureFlagState>>;
};

export type EnumFeatureFlagTypeFieldUpdateOperationsInput = {
  set?: Maybe<FeatureFlagType>;
};

export type EnumFeatureFlagTypeFilter = {
  equals?: Maybe<FeatureFlagType>;
  in?: Maybe<Array<FeatureFlagType>>;
  not?: Maybe<NestedEnumFeatureFlagTypeFilter>;
  notIn?: Maybe<Array<FeatureFlagType>>;
};

export type EnumFeatureFlagTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFeatureFlagTypeFilter>;
  _min?: Maybe<NestedEnumFeatureFlagTypeFilter>;
  equals?: Maybe<FeatureFlagType>;
  in?: Maybe<Array<FeatureFlagType>>;
  not?: Maybe<NestedEnumFeatureFlagTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<FeatureFlagType>>;
};

export type EnumFeeCollectionFieldUpdateOperationsInput = {
  set?: Maybe<FeeCollection>;
};

export type EnumFeeCollectionFilter = {
  equals?: Maybe<FeeCollection>;
  in?: Maybe<Array<FeeCollection>>;
  not?: Maybe<NestedEnumFeeCollectionFilter>;
  notIn?: Maybe<Array<FeeCollection>>;
};

export type EnumFeeCollectionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFeeCollectionFilter>;
  _min?: Maybe<NestedEnumFeeCollectionFilter>;
  equals?: Maybe<FeeCollection>;
  in?: Maybe<Array<FeeCollection>>;
  not?: Maybe<NestedEnumFeeCollectionWithAggregatesFilter>;
  notIn?: Maybe<Array<FeeCollection>>;
};

export type EnumFilterSelectionTypeFieldUpdateOperationsInput = {
  set?: Maybe<FilterSelectionType>;
};

export type EnumFilterSelectionTypeFilter = {
  equals?: Maybe<FilterSelectionType>;
  in?: Maybe<Array<FilterSelectionType>>;
  not?: Maybe<NestedEnumFilterSelectionTypeFilter>;
  notIn?: Maybe<Array<FilterSelectionType>>;
};

export type EnumFilterSelectionTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFilterSelectionTypeFilter>;
  _min?: Maybe<NestedEnumFilterSelectionTypeFilter>;
  equals?: Maybe<FilterSelectionType>;
  in?: Maybe<Array<FilterSelectionType>>;
  not?: Maybe<NestedEnumFilterSelectionTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<FilterSelectionType>>;
};

export type EnumFinancialTransactionTypeFieldUpdateOperationsInput = {
  set?: Maybe<FinancialTransactionType>;
};

export type EnumFinancialTransactionTypeFilter = {
  equals?: Maybe<FinancialTransactionType>;
  in?: Maybe<Array<FinancialTransactionType>>;
  not?: Maybe<NestedEnumFinancialTransactionTypeFilter>;
  notIn?: Maybe<Array<FinancialTransactionType>>;
};

export type EnumFinancialTransactionTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFinancialTransactionTypeFilter>;
  _min?: Maybe<NestedEnumFinancialTransactionTypeFilter>;
  equals?: Maybe<FinancialTransactionType>;
  in?: Maybe<Array<FinancialTransactionType>>;
  not?: Maybe<NestedEnumFinancialTransactionTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<FinancialTransactionType>>;
};

export type EnumFormTemplateTypeFieldUpdateOperationsInput = {
  set?: Maybe<FormTemplateType>;
};

export type EnumFormTemplateTypeFilter = {
  equals?: Maybe<FormTemplateType>;
  in?: Maybe<Array<FormTemplateType>>;
  not?: Maybe<NestedEnumFormTemplateTypeFilter>;
  notIn?: Maybe<Array<FormTemplateType>>;
};

export type EnumFormTemplateTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFormTemplateTypeFilter>;
  _min?: Maybe<NestedEnumFormTemplateTypeFilter>;
  equals?: Maybe<FormTemplateType>;
  in?: Maybe<Array<FormTemplateType>>;
  not?: Maybe<NestedEnumFormTemplateTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<FormTemplateType>>;
};

export type EnumHillsToHomeResultTypeFieldUpdateOperationsInput = {
  set?: Maybe<HillsToHomeResultType>;
};

export type EnumHillsToHomeResultTypeFilter = {
  equals?: Maybe<HillsToHomeResultType>;
  in?: Maybe<Array<HillsToHomeResultType>>;
  not?: Maybe<NestedEnumHillsToHomeResultTypeFilter>;
  notIn?: Maybe<Array<HillsToHomeResultType>>;
};

export type EnumHillsToHomeResultTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumHillsToHomeResultTypeFilter>;
  _min?: Maybe<NestedEnumHillsToHomeResultTypeFilter>;
  equals?: Maybe<HillsToHomeResultType>;
  in?: Maybe<Array<HillsToHomeResultType>>;
  not?: Maybe<NestedEnumHillsToHomeResultTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<HillsToHomeResultType>>;
};

export type EnumHillsToHomeSpeciesNullableFilter = {
  equals?: Maybe<HillsToHomeSpecies>;
  in?: Maybe<Array<HillsToHomeSpecies>>;
  not?: Maybe<NestedEnumHillsToHomeSpeciesNullableFilter>;
  notIn?: Maybe<Array<HillsToHomeSpecies>>;
};

export type EnumHillsToHomeSpeciesNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumHillsToHomeSpeciesNullableFilter>;
  _min?: Maybe<NestedEnumHillsToHomeSpeciesNullableFilter>;
  equals?: Maybe<HillsToHomeSpecies>;
  in?: Maybe<Array<HillsToHomeSpecies>>;
  not?: Maybe<NestedEnumHillsToHomeSpeciesNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<HillsToHomeSpecies>>;
};

export type EnumInformAudienceDefinitionStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformAudienceDefinitionStatus>;
};

export type EnumInformAudienceDefinitionStatusFilter = {
  equals?: Maybe<InformAudienceDefinitionStatus>;
  in?: Maybe<Array<InformAudienceDefinitionStatus>>;
  not?: Maybe<NestedEnumInformAudienceDefinitionStatusFilter>;
  notIn?: Maybe<Array<InformAudienceDefinitionStatus>>;
};

export type EnumInformAudienceDefinitionStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformAudienceDefinitionStatusFilter>;
  _min?: Maybe<NestedEnumInformAudienceDefinitionStatusFilter>;
  equals?: Maybe<InformAudienceDefinitionStatus>;
  in?: Maybe<Array<InformAudienceDefinitionStatus>>;
  not?: Maybe<NestedEnumInformAudienceDefinitionStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformAudienceDefinitionStatus>>;
};

export type EnumInformAudienceDefinitionTypeFieldUpdateOperationsInput = {
  set?: Maybe<InformAudienceDefinitionType>;
};

export type EnumInformAudienceDefinitionTypeFilter = {
  equals?: Maybe<InformAudienceDefinitionType>;
  in?: Maybe<Array<InformAudienceDefinitionType>>;
  not?: Maybe<NestedEnumInformAudienceDefinitionTypeFilter>;
  notIn?: Maybe<Array<InformAudienceDefinitionType>>;
};

export type EnumInformAudienceDefinitionTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformAudienceDefinitionTypeFilter>;
  _min?: Maybe<NestedEnumInformAudienceDefinitionTypeFilter>;
  equals?: Maybe<InformAudienceDefinitionType>;
  in?: Maybe<Array<InformAudienceDefinitionType>>;
  not?: Maybe<NestedEnumInformAudienceDefinitionTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InformAudienceDefinitionType>>;
};

export type EnumInformAudienceMemberMessageCourierFieldUpdateOperationsInput = {
  set?: Maybe<InformAudienceMemberMessageCourier>;
};

export type EnumInformAudienceMemberMessageCourierFilter = {
  equals?: Maybe<InformAudienceMemberMessageCourier>;
  in?: Maybe<Array<InformAudienceMemberMessageCourier>>;
  not?: Maybe<NestedEnumInformAudienceMemberMessageCourierFilter>;
  notIn?: Maybe<Array<InformAudienceMemberMessageCourier>>;
};

export type EnumInformAudienceMemberMessageCourierWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformAudienceMemberMessageCourierFilter>;
  _min?: Maybe<NestedEnumInformAudienceMemberMessageCourierFilter>;
  equals?: Maybe<InformAudienceMemberMessageCourier>;
  in?: Maybe<Array<InformAudienceMemberMessageCourier>>;
  not?: Maybe<NestedEnumInformAudienceMemberMessageCourierWithAggregatesFilter>;
  notIn?: Maybe<Array<InformAudienceMemberMessageCourier>>;
};

export type EnumInformAudienceMemberMessageStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformAudienceMemberMessageStatus>;
};

export type EnumInformAudienceMemberMessageStatusFilter = {
  equals?: Maybe<InformAudienceMemberMessageStatus>;
  in?: Maybe<Array<InformAudienceMemberMessageStatus>>;
  not?: Maybe<NestedEnumInformAudienceMemberMessageStatusFilter>;
  notIn?: Maybe<Array<InformAudienceMemberMessageStatus>>;
};

export type EnumInformAudienceMemberMessageStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformAudienceMemberMessageStatusFilter>;
  _min?: Maybe<NestedEnumInformAudienceMemberMessageStatusFilter>;
  equals?: Maybe<InformAudienceMemberMessageStatus>;
  in?: Maybe<Array<InformAudienceMemberMessageStatus>>;
  not?: Maybe<NestedEnumInformAudienceMemberMessageStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformAudienceMemberMessageStatus>>;
};

export type EnumInformAudienceMemberMessageTypeFieldUpdateOperationsInput = {
  set?: Maybe<InformAudienceMemberMessageType>;
};

export type EnumInformAudienceMemberMessageTypeFilter = {
  equals?: Maybe<InformAudienceMemberMessageType>;
  in?: Maybe<Array<InformAudienceMemberMessageType>>;
  not?: Maybe<NestedEnumInformAudienceMemberMessageTypeFilter>;
  notIn?: Maybe<Array<InformAudienceMemberMessageType>>;
};

export type EnumInformAudienceMemberMessageTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformAudienceMemberMessageTypeFilter>;
  _min?: Maybe<NestedEnumInformAudienceMemberMessageTypeFilter>;
  equals?: Maybe<InformAudienceMemberMessageType>;
  in?: Maybe<Array<InformAudienceMemberMessageType>>;
  not?: Maybe<NestedEnumInformAudienceMemberMessageTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InformAudienceMemberMessageType>>;
};

export type EnumInformCampaignExecutionStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformCampaignExecutionStatus>;
};

export type EnumInformCampaignExecutionStatusFilter = {
  equals?: Maybe<InformCampaignExecutionStatus>;
  in?: Maybe<Array<InformCampaignExecutionStatus>>;
  not?: Maybe<NestedEnumInformCampaignExecutionStatusFilter>;
  notIn?: Maybe<Array<InformCampaignExecutionStatus>>;
};

export type EnumInformCampaignExecutionStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformCampaignExecutionStatusFilter>;
  _min?: Maybe<NestedEnumInformCampaignExecutionStatusFilter>;
  equals?: Maybe<InformCampaignExecutionStatus>;
  in?: Maybe<Array<InformCampaignExecutionStatus>>;
  not?: Maybe<NestedEnumInformCampaignExecutionStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformCampaignExecutionStatus>>;
};

export type EnumInformCampaignStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformCampaignStatus>;
};

export type EnumInformCampaignStatusFilter = {
  equals?: Maybe<InformCampaignStatus>;
  in?: Maybe<Array<InformCampaignStatus>>;
  not?: Maybe<NestedEnumInformCampaignStatusFilter>;
  notIn?: Maybe<Array<InformCampaignStatus>>;
};

export type EnumInformCampaignStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformCampaignStatusFilter>;
  _min?: Maybe<NestedEnumInformCampaignStatusFilter>;
  equals?: Maybe<InformCampaignStatus>;
  in?: Maybe<Array<InformCampaignStatus>>;
  not?: Maybe<NestedEnumInformCampaignStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformCampaignStatus>>;
};

export type EnumInformCampaignTypeFieldUpdateOperationsInput = {
  set?: Maybe<InformCampaignType>;
};

export type EnumInformCampaignTypeFilter = {
  equals?: Maybe<InformCampaignType>;
  in?: Maybe<Array<InformCampaignType>>;
  not?: Maybe<NestedEnumInformCampaignTypeFilter>;
  notIn?: Maybe<Array<InformCampaignType>>;
};

export type EnumInformCampaignTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformCampaignTypeFilter>;
  _min?: Maybe<NestedEnumInformCampaignTypeFilter>;
  equals?: Maybe<InformCampaignType>;
  in?: Maybe<Array<InformCampaignType>>;
  not?: Maybe<NestedEnumInformCampaignTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InformCampaignType>>;
};

export type EnumInformCampaignVisibilityFieldUpdateOperationsInput = {
  set?: Maybe<InformCampaignVisibility>;
};

export type EnumInformCampaignVisibilityFilter = {
  equals?: Maybe<InformCampaignVisibility>;
  in?: Maybe<Array<InformCampaignVisibility>>;
  not?: Maybe<NestedEnumInformCampaignVisibilityFilter>;
  notIn?: Maybe<Array<InformCampaignVisibility>>;
};

export type EnumInformCampaignVisibilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformCampaignVisibilityFilter>;
  _min?: Maybe<NestedEnumInformCampaignVisibilityFilter>;
  equals?: Maybe<InformCampaignVisibility>;
  in?: Maybe<Array<InformCampaignVisibility>>;
  not?: Maybe<NestedEnumInformCampaignVisibilityWithAggregatesFilter>;
  notIn?: Maybe<Array<InformCampaignVisibility>>;
};

export type EnumInformCommunicationOptOutStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformCommunicationOptOutStatus>;
};

export type EnumInformCommunicationOptOutStatusFilter = {
  equals?: Maybe<InformCommunicationOptOutStatus>;
  in?: Maybe<Array<InformCommunicationOptOutStatus>>;
  not?: Maybe<NestedEnumInformCommunicationOptOutStatusFilter>;
  notIn?: Maybe<Array<InformCommunicationOptOutStatus>>;
};

export type EnumInformCommunicationOptOutStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformCommunicationOptOutStatusFilter>;
  _min?: Maybe<NestedEnumInformCommunicationOptOutStatusFilter>;
  equals?: Maybe<InformCommunicationOptOutStatus>;
  in?: Maybe<Array<InformCommunicationOptOutStatus>>;
  not?: Maybe<NestedEnumInformCommunicationOptOutStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformCommunicationOptOutStatus>>;
};

export type EnumInformControlGroupEntityTypeFieldUpdateOperationsInput = {
  set?: Maybe<InformControlGroupEntityType>;
};

export type EnumInformControlGroupEntityTypeFilter = {
  equals?: Maybe<InformControlGroupEntityType>;
  in?: Maybe<Array<InformControlGroupEntityType>>;
  not?: Maybe<NestedEnumInformControlGroupEntityTypeFilter>;
  notIn?: Maybe<Array<InformControlGroupEntityType>>;
};

export type EnumInformControlGroupEntityTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformControlGroupEntityTypeFilter>;
  _min?: Maybe<NestedEnumInformControlGroupEntityTypeFilter>;
  equals?: Maybe<InformControlGroupEntityType>;
  in?: Maybe<Array<InformControlGroupEntityType>>;
  not?: Maybe<NestedEnumInformControlGroupEntityTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InformControlGroupEntityType>>;
};

export type EnumInformEmailTemplateStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformEmailTemplateStatus>;
};

export type EnumInformEmailTemplateStatusFilter = {
  equals?: Maybe<InformEmailTemplateStatus>;
  in?: Maybe<Array<InformEmailTemplateStatus>>;
  not?: Maybe<NestedEnumInformEmailTemplateStatusFilter>;
  notIn?: Maybe<Array<InformEmailTemplateStatus>>;
};

export type EnumInformEmailTemplateStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformEmailTemplateStatusFilter>;
  _min?: Maybe<NestedEnumInformEmailTemplateStatusFilter>;
  equals?: Maybe<InformEmailTemplateStatus>;
  in?: Maybe<Array<InformEmailTemplateStatus>>;
  not?: Maybe<NestedEnumInformEmailTemplateStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformEmailTemplateStatus>>;
};

export type EnumInformEnrollmentStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformEnrollmentStatus>;
};

export type EnumInformEnrollmentStatusFilter = {
  equals?: Maybe<InformEnrollmentStatus>;
  in?: Maybe<Array<InformEnrollmentStatus>>;
  not?: Maybe<NestedEnumInformEnrollmentStatusFilter>;
  notIn?: Maybe<Array<InformEnrollmentStatus>>;
};

export type EnumInformEnrollmentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformEnrollmentStatusFilter>;
  _min?: Maybe<NestedEnumInformEnrollmentStatusFilter>;
  equals?: Maybe<InformEnrollmentStatus>;
  in?: Maybe<Array<InformEnrollmentStatus>>;
  not?: Maybe<NestedEnumInformEnrollmentStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformEnrollmentStatus>>;
};

export type EnumInformEntityUpdatedByTypeNullableFilter = {
  equals?: Maybe<InformEntityUpdatedByType>;
  in?: Maybe<Array<InformEntityUpdatedByType>>;
  not?: Maybe<NestedEnumInformEntityUpdatedByTypeNullableFilter>;
  notIn?: Maybe<Array<InformEntityUpdatedByType>>;
};

export type EnumInformEntityUpdatedByTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumInformEntityUpdatedByTypeNullableFilter>;
  _min?: Maybe<NestedEnumInformEntityUpdatedByTypeNullableFilter>;
  equals?: Maybe<InformEntityUpdatedByType>;
  in?: Maybe<Array<InformEntityUpdatedByType>>;
  not?: Maybe<NestedEnumInformEntityUpdatedByTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<InformEntityUpdatedByType>>;
};

export type EnumInformPartnerCustomerPharmacyProviderNameFieldUpdateOperationsInput = {
  set?: Maybe<InformPartnerCustomerPharmacyProviderName>;
};

export type EnumInformPartnerCustomerPharmacyProviderNameFilter = {
  equals?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  in?: Maybe<Array<InformPartnerCustomerPharmacyProviderName>>;
  not?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderNameFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerPharmacyProviderName>>;
};

export type EnumInformPartnerCustomerPharmacyProviderNameWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderNameFilter>;
  _min?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderNameFilter>;
  equals?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  in?: Maybe<Array<InformPartnerCustomerPharmacyProviderName>>;
  not?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderNameWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerPharmacyProviderName>>;
};

export type EnumInformPartnerCustomerPharmacyProviderStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
};

export type EnumInformPartnerCustomerPharmacyProviderStatusFilter = {
  equals?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  in?: Maybe<Array<InformPartnerCustomerPharmacyProviderStatus>>;
  not?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderStatusFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerPharmacyProviderStatus>>;
};

export type EnumInformPartnerCustomerPharmacyProviderStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderStatusFilter>;
  equals?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  in?: Maybe<Array<InformPartnerCustomerPharmacyProviderStatus>>;
  not?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerPharmacyProviderStatus>>;
};

export type EnumInformPartnerCustomerPharmacyProviderTypeFieldUpdateOperationsInput = {
  set?: Maybe<InformPartnerCustomerPharmacyProviderType>;
};

export type EnumInformPartnerCustomerPharmacyProviderTypeFilter = {
  equals?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  in?: Maybe<Array<InformPartnerCustomerPharmacyProviderType>>;
  not?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderTypeFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerPharmacyProviderType>>;
};

export type EnumInformPartnerCustomerPharmacyProviderTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderTypeFilter>;
  _min?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderTypeFilter>;
  equals?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  in?: Maybe<Array<InformPartnerCustomerPharmacyProviderType>>;
  not?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerPharmacyProviderType>>;
};

export type EnumInformPartnerCustomerVisibilityFieldUpdateOperationsInput = {
  set?: Maybe<InformPartnerCustomerVisibility>;
};

export type EnumInformPartnerCustomerVisibilityFilter = {
  equals?: Maybe<InformPartnerCustomerVisibility>;
  in?: Maybe<Array<InformPartnerCustomerVisibility>>;
  not?: Maybe<NestedEnumInformPartnerCustomerVisibilityFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerVisibility>>;
};

export type EnumInformPartnerCustomerVisibilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerCustomerVisibilityFilter>;
  _min?: Maybe<NestedEnumInformPartnerCustomerVisibilityFilter>;
  equals?: Maybe<InformPartnerCustomerVisibility>;
  in?: Maybe<Array<InformPartnerCustomerVisibility>>;
  not?: Maybe<NestedEnumInformPartnerCustomerVisibilityWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerVisibility>>;
};

export type EnumInformPartnerIntegrationModelNameFieldUpdateOperationsInput = {
  set?: Maybe<InformPartnerIntegrationModelName>;
};

export type EnumInformPartnerIntegrationModelNameFilter = {
  equals?: Maybe<InformPartnerIntegrationModelName>;
  in?: Maybe<Array<InformPartnerIntegrationModelName>>;
  not?: Maybe<NestedEnumInformPartnerIntegrationModelNameFilter>;
  notIn?: Maybe<Array<InformPartnerIntegrationModelName>>;
};

export type EnumInformPartnerIntegrationModelNameWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerIntegrationModelNameFilter>;
  _min?: Maybe<NestedEnumInformPartnerIntegrationModelNameFilter>;
  equals?: Maybe<InformPartnerIntegrationModelName>;
  in?: Maybe<Array<InformPartnerIntegrationModelName>>;
  not?: Maybe<NestedEnumInformPartnerIntegrationModelNameWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerIntegrationModelName>>;
};

export type EnumInformPartnerIntegrationModelStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformPartnerIntegrationModelStatus>;
};

export type EnumInformPartnerIntegrationModelStatusFilter = {
  equals?: Maybe<InformPartnerIntegrationModelStatus>;
  in?: Maybe<Array<InformPartnerIntegrationModelStatus>>;
  not?: Maybe<NestedEnumInformPartnerIntegrationModelStatusFilter>;
  notIn?: Maybe<Array<InformPartnerIntegrationModelStatus>>;
};

export type EnumInformPartnerIntegrationModelStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerIntegrationModelStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerIntegrationModelStatusFilter>;
  equals?: Maybe<InformPartnerIntegrationModelStatus>;
  in?: Maybe<Array<InformPartnerIntegrationModelStatus>>;
  not?: Maybe<NestedEnumInformPartnerIntegrationModelStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerIntegrationModelStatus>>;
};

export type EnumInformPartnerIntegrationStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformPartnerIntegrationStatus>;
};

export type EnumInformPartnerIntegrationStatusFilter = {
  equals?: Maybe<InformPartnerIntegrationStatus>;
  in?: Maybe<Array<InformPartnerIntegrationStatus>>;
  not?: Maybe<NestedEnumInformPartnerIntegrationStatusFilter>;
  notIn?: Maybe<Array<InformPartnerIntegrationStatus>>;
};

export type EnumInformPartnerIntegrationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerIntegrationStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerIntegrationStatusFilter>;
  equals?: Maybe<InformPartnerIntegrationStatus>;
  in?: Maybe<Array<InformPartnerIntegrationStatus>>;
  not?: Maybe<NestedEnumInformPartnerIntegrationStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerIntegrationStatus>>;
};

export type EnumInformPartnerProgramStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformPartnerProgramStatus>;
};

export type EnumInformPartnerProgramStatusFilter = {
  equals?: Maybe<InformPartnerProgramStatus>;
  in?: Maybe<Array<InformPartnerProgramStatus>>;
  not?: Maybe<NestedEnumInformPartnerProgramStatusFilter>;
  notIn?: Maybe<Array<InformPartnerProgramStatus>>;
};

export type EnumInformPartnerProgramStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerProgramStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerProgramStatusFilter>;
  equals?: Maybe<InformPartnerProgramStatus>;
  in?: Maybe<Array<InformPartnerProgramStatus>>;
  not?: Maybe<NestedEnumInformPartnerProgramStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerProgramStatus>>;
};

export type EnumInformPartnerStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformPartnerStatus>;
};

export type EnumInformPartnerStatusFilter = {
  equals?: Maybe<InformPartnerStatus>;
  in?: Maybe<Array<InformPartnerStatus>>;
  not?: Maybe<NestedEnumInformPartnerStatusFilter>;
  notIn?: Maybe<Array<InformPartnerStatus>>;
};

export type EnumInformPartnerStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerStatusFilter>;
  equals?: Maybe<InformPartnerStatus>;
  in?: Maybe<Array<InformPartnerStatus>>;
  not?: Maybe<NestedEnumInformPartnerStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerStatus>>;
};

export type EnumInformPartnerUserRoleNameFieldUpdateOperationsInput = {
  set?: Maybe<InformPartnerUserRoleName>;
};

export type EnumInformPartnerUserRoleNameFilter = {
  equals?: Maybe<InformPartnerUserRoleName>;
  in?: Maybe<Array<InformPartnerUserRoleName>>;
  not?: Maybe<NestedEnumInformPartnerUserRoleNameFilter>;
  notIn?: Maybe<Array<InformPartnerUserRoleName>>;
};

export type EnumInformPartnerUserRoleNameWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerUserRoleNameFilter>;
  _min?: Maybe<NestedEnumInformPartnerUserRoleNameFilter>;
  equals?: Maybe<InformPartnerUserRoleName>;
  in?: Maybe<Array<InformPartnerUserRoleName>>;
  not?: Maybe<NestedEnumInformPartnerUserRoleNameWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerUserRoleName>>;
};

export type EnumInformPartnerUserRoleStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformPartnerUserRoleStatus>;
};

export type EnumInformPartnerUserRoleStatusFilter = {
  equals?: Maybe<InformPartnerUserRoleStatus>;
  in?: Maybe<Array<InformPartnerUserRoleStatus>>;
  not?: Maybe<NestedEnumInformPartnerUserRoleStatusFilter>;
  notIn?: Maybe<Array<InformPartnerUserRoleStatus>>;
};

export type EnumInformPartnerUserRoleStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerUserRoleStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerUserRoleStatusFilter>;
  equals?: Maybe<InformPartnerUserRoleStatus>;
  in?: Maybe<Array<InformPartnerUserRoleStatus>>;
  not?: Maybe<NestedEnumInformPartnerUserRoleStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerUserRoleStatus>>;
};

export type EnumInformPartnerUserStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformPartnerUserStatus>;
};

export type EnumInformPartnerUserStatusFilter = {
  equals?: Maybe<InformPartnerUserStatus>;
  in?: Maybe<Array<InformPartnerUserStatus>>;
  not?: Maybe<NestedEnumInformPartnerUserStatusFilter>;
  notIn?: Maybe<Array<InformPartnerUserStatus>>;
};

export type EnumInformPartnerUserStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerUserStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerUserStatusFilter>;
  equals?: Maybe<InformPartnerUserStatus>;
  in?: Maybe<Array<InformPartnerUserStatus>>;
  not?: Maybe<NestedEnumInformPartnerUserStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerUserStatus>>;
};

export type EnumInformScheduledCampaignCadenceNullableFilter = {
  equals?: Maybe<InformScheduledCampaignCadence>;
  in?: Maybe<Array<InformScheduledCampaignCadence>>;
  not?: Maybe<NestedEnumInformScheduledCampaignCadenceNullableFilter>;
  notIn?: Maybe<Array<InformScheduledCampaignCadence>>;
};

export type EnumInformScheduledCampaignCadenceNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumInformScheduledCampaignCadenceNullableFilter>;
  _min?: Maybe<NestedEnumInformScheduledCampaignCadenceNullableFilter>;
  equals?: Maybe<InformScheduledCampaignCadence>;
  in?: Maybe<Array<InformScheduledCampaignCadence>>;
  not?: Maybe<NestedEnumInformScheduledCampaignCadenceNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<InformScheduledCampaignCadence>>;
};

export type EnumInformScheduledCampaignCommunicationChannelFieldUpdateOperationsInput = {
  set?: Maybe<InformScheduledCampaignCommunicationChannel>;
};

export type EnumInformScheduledCampaignCommunicationChannelFilter = {
  equals?: Maybe<InformScheduledCampaignCommunicationChannel>;
  in?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  not?: Maybe<NestedEnumInformScheduledCampaignCommunicationChannelFilter>;
  notIn?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
};

export type EnumInformScheduledCampaignCommunicationChannelNullableListFilter = {
  equals?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  has?: Maybe<InformScheduledCampaignCommunicationChannel>;
  hasEvery?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  hasSome?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  isEmpty?: Maybe<Scalars['Boolean']>;
};

export type EnumInformScheduledCampaignCommunicationChannelWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformScheduledCampaignCommunicationChannelFilter>;
  _min?: Maybe<NestedEnumInformScheduledCampaignCommunicationChannelFilter>;
  equals?: Maybe<InformScheduledCampaignCommunicationChannel>;
  in?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  not?: Maybe<NestedEnumInformScheduledCampaignCommunicationChannelWithAggregatesFilter>;
  notIn?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
};

export type EnumInformSessionEventAuthorTypeFieldUpdateOperationsInput = {
  set?: Maybe<InformSessionEventAuthorType>;
};

export type EnumInformSessionEventAuthorTypeFilter = {
  equals?: Maybe<InformSessionEventAuthorType>;
  in?: Maybe<Array<InformSessionEventAuthorType>>;
  not?: Maybe<NestedEnumInformSessionEventAuthorTypeFilter>;
  notIn?: Maybe<Array<InformSessionEventAuthorType>>;
};

export type EnumInformSessionEventAuthorTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformSessionEventAuthorTypeFilter>;
  _min?: Maybe<NestedEnumInformSessionEventAuthorTypeFilter>;
  equals?: Maybe<InformSessionEventAuthorType>;
  in?: Maybe<Array<InformSessionEventAuthorType>>;
  not?: Maybe<NestedEnumInformSessionEventAuthorTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InformSessionEventAuthorType>>;
};

export type EnumInformSessionStatusFieldUpdateOperationsInput = {
  set?: Maybe<InformSessionStatus>;
};

export type EnumInformSessionStatusFilter = {
  equals?: Maybe<InformSessionStatus>;
  in?: Maybe<Array<InformSessionStatus>>;
  not?: Maybe<NestedEnumInformSessionStatusFilter>;
  notIn?: Maybe<Array<InformSessionStatus>>;
};

export type EnumInformSessionStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformSessionStatusFilter>;
  _min?: Maybe<NestedEnumInformSessionStatusFilter>;
  equals?: Maybe<InformSessionStatus>;
  in?: Maybe<Array<InformSessionStatus>>;
  not?: Maybe<NestedEnumInformSessionStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformSessionStatus>>;
};

export type EnumInsuranceIntegrationTypeFieldUpdateOperationsInput = {
  set?: Maybe<InsuranceIntegrationType>;
};

export type EnumInsuranceIntegrationTypeFilter = {
  equals?: Maybe<InsuranceIntegrationType>;
  in?: Maybe<Array<InsuranceIntegrationType>>;
  not?: Maybe<NestedEnumInsuranceIntegrationTypeFilter>;
  notIn?: Maybe<Array<InsuranceIntegrationType>>;
};

export type EnumInsuranceIntegrationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInsuranceIntegrationTypeFilter>;
  _min?: Maybe<NestedEnumInsuranceIntegrationTypeFilter>;
  equals?: Maybe<InsuranceIntegrationType>;
  in?: Maybe<Array<InsuranceIntegrationType>>;
  not?: Maybe<NestedEnumInsuranceIntegrationTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InsuranceIntegrationType>>;
};

export type EnumIntegrationStatusNullableFilter = {
  equals?: Maybe<IntegrationStatus>;
  in?: Maybe<Array<IntegrationStatus>>;
  not?: Maybe<NestedEnumIntegrationStatusNullableFilter>;
  notIn?: Maybe<Array<IntegrationStatus>>;
};

export type EnumIntegrationStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumIntegrationStatusNullableFilter>;
  _min?: Maybe<NestedEnumIntegrationStatusNullableFilter>;
  equals?: Maybe<IntegrationStatus>;
  in?: Maybe<Array<IntegrationStatus>>;
  not?: Maybe<NestedEnumIntegrationStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<IntegrationStatus>>;
};

export type EnumIntegrationTypeNullableFilter = {
  equals?: Maybe<IntegrationType>;
  in?: Maybe<Array<IntegrationType>>;
  not?: Maybe<NestedEnumIntegrationTypeNullableFilter>;
  notIn?: Maybe<Array<IntegrationType>>;
};

export type EnumIntegrationTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumIntegrationTypeNullableFilter>;
  _min?: Maybe<NestedEnumIntegrationTypeNullableFilter>;
  equals?: Maybe<IntegrationType>;
  in?: Maybe<Array<IntegrationType>>;
  not?: Maybe<NestedEnumIntegrationTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<IntegrationType>>;
};

export type EnumInvoiceLineItemTypeFieldUpdateOperationsInput = {
  set?: Maybe<InvoiceLineItemType>;
};

export type EnumInvoiceLineItemTypeFilter = {
  equals?: Maybe<InvoiceLineItemType>;
  in?: Maybe<Array<InvoiceLineItemType>>;
  not?: Maybe<NestedEnumInvoiceLineItemTypeFilter>;
  notIn?: Maybe<Array<InvoiceLineItemType>>;
};

export type EnumInvoiceLineItemTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInvoiceLineItemTypeFilter>;
  _min?: Maybe<NestedEnumInvoiceLineItemTypeFilter>;
  equals?: Maybe<InvoiceLineItemType>;
  in?: Maybe<Array<InvoiceLineItemType>>;
  not?: Maybe<NestedEnumInvoiceLineItemTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InvoiceLineItemType>>;
};

export type EnumInvoicePimsWritebackActionFieldUpdateOperationsInput = {
  set?: Maybe<InvoicePimsWritebackAction>;
};

export type EnumInvoicePimsWritebackActionFilter = {
  equals?: Maybe<InvoicePimsWritebackAction>;
  in?: Maybe<Array<InvoicePimsWritebackAction>>;
  not?: Maybe<NestedEnumInvoicePimsWritebackActionFilter>;
  notIn?: Maybe<Array<InvoicePimsWritebackAction>>;
};

export type EnumInvoicePimsWritebackActionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInvoicePimsWritebackActionFilter>;
  _min?: Maybe<NestedEnumInvoicePimsWritebackActionFilter>;
  equals?: Maybe<InvoicePimsWritebackAction>;
  in?: Maybe<Array<InvoicePimsWritebackAction>>;
  not?: Maybe<NestedEnumInvoicePimsWritebackActionWithAggregatesFilter>;
  notIn?: Maybe<Array<InvoicePimsWritebackAction>>;
};

export type EnumInvoiceStatusFieldUpdateOperationsInput = {
  set?: Maybe<InvoiceStatus>;
};

export type EnumInvoiceStatusFilter = {
  equals?: Maybe<InvoiceStatus>;
  in?: Maybe<Array<InvoiceStatus>>;
  not?: Maybe<NestedEnumInvoiceStatusFilter>;
  notIn?: Maybe<Array<InvoiceStatus>>;
};

export type EnumInvoiceStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInvoiceStatusFilter>;
  _min?: Maybe<NestedEnumInvoiceStatusFilter>;
  equals?: Maybe<InvoiceStatus>;
  in?: Maybe<Array<InvoiceStatus>>;
  not?: Maybe<NestedEnumInvoiceStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InvoiceStatus>>;
};

export type EnumLegalEntityTypeFieldUpdateOperationsInput = {
  set?: Maybe<LegalEntityType>;
};

export type EnumLegalEntityTypeFilter = {
  equals?: Maybe<LegalEntityType>;
  in?: Maybe<Array<LegalEntityType>>;
  not?: Maybe<NestedEnumLegalEntityTypeFilter>;
  notIn?: Maybe<Array<LegalEntityType>>;
};

export type EnumLegalEntityTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLegalEntityTypeFilter>;
  _min?: Maybe<NestedEnumLegalEntityTypeFilter>;
  equals?: Maybe<LegalEntityType>;
  in?: Maybe<Array<LegalEntityType>>;
  not?: Maybe<NestedEnumLegalEntityTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<LegalEntityType>>;
};

export type EnumLoyaltyAccountMergerStatusFieldUpdateOperationsInput = {
  set?: Maybe<LoyaltyAccountMergerStatus>;
};

export type EnumLoyaltyAccountMergerStatusFilter = {
  equals?: Maybe<LoyaltyAccountMergerStatus>;
  in?: Maybe<Array<LoyaltyAccountMergerStatus>>;
  not?: Maybe<NestedEnumLoyaltyAccountMergerStatusFilter>;
  notIn?: Maybe<Array<LoyaltyAccountMergerStatus>>;
};

export type EnumLoyaltyAccountMergerStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLoyaltyAccountMergerStatusFilter>;
  _min?: Maybe<NestedEnumLoyaltyAccountMergerStatusFilter>;
  equals?: Maybe<LoyaltyAccountMergerStatus>;
  in?: Maybe<Array<LoyaltyAccountMergerStatus>>;
  not?: Maybe<NestedEnumLoyaltyAccountMergerStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<LoyaltyAccountMergerStatus>>;
};

export type EnumLoyaltyPointDeltaSourceFieldUpdateOperationsInput = {
  set?: Maybe<LoyaltyPointDeltaSource>;
};

export type EnumLoyaltyPointDeltaSourceFilter = {
  equals?: Maybe<LoyaltyPointDeltaSource>;
  in?: Maybe<Array<LoyaltyPointDeltaSource>>;
  not?: Maybe<NestedEnumLoyaltyPointDeltaSourceFilter>;
  notIn?: Maybe<Array<LoyaltyPointDeltaSource>>;
};

export type EnumLoyaltyPointDeltaSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLoyaltyPointDeltaSourceFilter>;
  _min?: Maybe<NestedEnumLoyaltyPointDeltaSourceFilter>;
  equals?: Maybe<LoyaltyPointDeltaSource>;
  in?: Maybe<Array<LoyaltyPointDeltaSource>>;
  not?: Maybe<NestedEnumLoyaltyPointDeltaSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<LoyaltyPointDeltaSource>>;
};

export type EnumLoyaltyProgramStatusFieldUpdateOperationsInput = {
  set?: Maybe<LoyaltyProgramStatus>;
};

export type EnumLoyaltyProgramStatusFilter = {
  equals?: Maybe<LoyaltyProgramStatus>;
  in?: Maybe<Array<LoyaltyProgramStatus>>;
  not?: Maybe<NestedEnumLoyaltyProgramStatusFilter>;
  notIn?: Maybe<Array<LoyaltyProgramStatus>>;
};

export type EnumLoyaltyProgramStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLoyaltyProgramStatusFilter>;
  _min?: Maybe<NestedEnumLoyaltyProgramStatusFilter>;
  equals?: Maybe<LoyaltyProgramStatus>;
  in?: Maybe<Array<LoyaltyProgramStatus>>;
  not?: Maybe<NestedEnumLoyaltyProgramStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<LoyaltyProgramStatus>>;
};

export type EnumLoyaltyRewardAvailabilityFieldUpdateOperationsInput = {
  set?: Maybe<LoyaltyRewardAvailability>;
};

export type EnumLoyaltyRewardAvailabilityFilter = {
  equals?: Maybe<LoyaltyRewardAvailability>;
  in?: Maybe<Array<LoyaltyRewardAvailability>>;
  not?: Maybe<NestedEnumLoyaltyRewardAvailabilityFilter>;
  notIn?: Maybe<Array<LoyaltyRewardAvailability>>;
};

export type EnumLoyaltyRewardAvailabilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLoyaltyRewardAvailabilityFilter>;
  _min?: Maybe<NestedEnumLoyaltyRewardAvailabilityFilter>;
  equals?: Maybe<LoyaltyRewardAvailability>;
  in?: Maybe<Array<LoyaltyRewardAvailability>>;
  not?: Maybe<NestedEnumLoyaltyRewardAvailabilityWithAggregatesFilter>;
  notIn?: Maybe<Array<LoyaltyRewardAvailability>>;
};

export type EnumLoyaltyRewardRedemptionActorTypeFieldUpdateOperationsInput = {
  set?: Maybe<LoyaltyRewardRedemptionActorType>;
};

export type EnumLoyaltyRewardRedemptionActorTypeFilter = {
  equals?: Maybe<LoyaltyRewardRedemptionActorType>;
  in?: Maybe<Array<LoyaltyRewardRedemptionActorType>>;
  not?: Maybe<NestedEnumLoyaltyRewardRedemptionActorTypeFilter>;
  notIn?: Maybe<Array<LoyaltyRewardRedemptionActorType>>;
};

export type EnumLoyaltyRewardRedemptionActorTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLoyaltyRewardRedemptionActorTypeFilter>;
  _min?: Maybe<NestedEnumLoyaltyRewardRedemptionActorTypeFilter>;
  equals?: Maybe<LoyaltyRewardRedemptionActorType>;
  in?: Maybe<Array<LoyaltyRewardRedemptionActorType>>;
  not?: Maybe<NestedEnumLoyaltyRewardRedemptionActorTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<LoyaltyRewardRedemptionActorType>>;
};

export type EnumLoyaltyRewardRedemptionStatusFieldUpdateOperationsInput = {
  set?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type EnumLoyaltyRewardRedemptionStatusFilter = {
  equals?: Maybe<LoyaltyRewardRedemptionStatus>;
  in?: Maybe<Array<LoyaltyRewardRedemptionStatus>>;
  not?: Maybe<NestedEnumLoyaltyRewardRedemptionStatusFilter>;
  notIn?: Maybe<Array<LoyaltyRewardRedemptionStatus>>;
};

export type EnumLoyaltyRewardRedemptionStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLoyaltyRewardRedemptionStatusFilter>;
  _min?: Maybe<NestedEnumLoyaltyRewardRedemptionStatusFilter>;
  equals?: Maybe<LoyaltyRewardRedemptionStatus>;
  in?: Maybe<Array<LoyaltyRewardRedemptionStatus>>;
  not?: Maybe<NestedEnumLoyaltyRewardRedemptionStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<LoyaltyRewardRedemptionStatus>>;
};

export type EnumManageMembershipRequestTypeFieldUpdateOperationsInput = {
  set?: Maybe<ManageMembershipRequestType>;
};

export type EnumManageMembershipRequestTypeFilter = {
  equals?: Maybe<ManageMembershipRequestType>;
  in?: Maybe<Array<ManageMembershipRequestType>>;
  not?: Maybe<NestedEnumManageMembershipRequestTypeFilter>;
  notIn?: Maybe<Array<ManageMembershipRequestType>>;
};

export type EnumManageMembershipRequestTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumManageMembershipRequestTypeFilter>;
  _min?: Maybe<NestedEnumManageMembershipRequestTypeFilter>;
  equals?: Maybe<ManageMembershipRequestType>;
  in?: Maybe<Array<ManageMembershipRequestType>>;
  not?: Maybe<NestedEnumManageMembershipRequestTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ManageMembershipRequestType>>;
};

export type EnumMassTextAlertStatusFieldUpdateOperationsInput = {
  set?: Maybe<MassTextAlertStatus>;
};

export type EnumMassTextAlertStatusFilter = {
  equals?: Maybe<MassTextAlertStatus>;
  in?: Maybe<Array<MassTextAlertStatus>>;
  not?: Maybe<NestedEnumMassTextAlertStatusFilter>;
  notIn?: Maybe<Array<MassTextAlertStatus>>;
};

export type EnumMassTextAlertStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMassTextAlertStatusFilter>;
  _min?: Maybe<NestedEnumMassTextAlertStatusFilter>;
  equals?: Maybe<MassTextAlertStatus>;
  in?: Maybe<Array<MassTextAlertStatus>>;
  not?: Maybe<NestedEnumMassTextAlertStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<MassTextAlertStatus>>;
};

export type EnumMediaTypeFieldUpdateOperationsInput = {
  set?: Maybe<MediaType>;
};

export type EnumMediaTypeFilter = {
  equals?: Maybe<MediaType>;
  in?: Maybe<Array<MediaType>>;
  not?: Maybe<NestedEnumMediaTypeFilter>;
  notIn?: Maybe<Array<MediaType>>;
};

export type EnumMediaTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMediaTypeFilter>;
  _min?: Maybe<NestedEnumMediaTypeFilter>;
  equals?: Maybe<MediaType>;
  in?: Maybe<Array<MediaType>>;
  not?: Maybe<NestedEnumMediaTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<MediaType>>;
};

export type EnumMediaVersionFieldUpdateOperationsInput = {
  set?: Maybe<MediaVersion>;
};

export type EnumMediaVersionFilter = {
  equals?: Maybe<MediaVersion>;
  in?: Maybe<Array<MediaVersion>>;
  not?: Maybe<NestedEnumMediaVersionFilter>;
  notIn?: Maybe<Array<MediaVersion>>;
};

export type EnumMediaVersionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMediaVersionFilter>;
  _min?: Maybe<NestedEnumMediaVersionFilter>;
  equals?: Maybe<MediaVersion>;
  in?: Maybe<Array<MediaVersion>>;
  not?: Maybe<NestedEnumMediaVersionWithAggregatesFilter>;
  notIn?: Maybe<Array<MediaVersion>>;
};

export type EnumMessageSourceFieldUpdateOperationsInput = {
  set?: Maybe<MessageSource>;
};

export type EnumMessageSourceFilter = {
  equals?: Maybe<MessageSource>;
  in?: Maybe<Array<MessageSource>>;
  not?: Maybe<NestedEnumMessageSourceFilter>;
  notIn?: Maybe<Array<MessageSource>>;
};

export type EnumMessageSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMessageSourceFilter>;
  _min?: Maybe<NestedEnumMessageSourceFilter>;
  equals?: Maybe<MessageSource>;
  in?: Maybe<Array<MessageSource>>;
  not?: Maybe<NestedEnumMessageSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<MessageSource>>;
};

export type EnumMessageTemplateTypeFieldUpdateOperationsInput = {
  set?: Maybe<MessageTemplateType>;
};

export type EnumMessageTemplateTypeFilter = {
  equals?: Maybe<MessageTemplateType>;
  in?: Maybe<Array<MessageTemplateType>>;
  not?: Maybe<NestedEnumMessageTemplateTypeFilter>;
  notIn?: Maybe<Array<MessageTemplateType>>;
};

export type EnumMessageTemplateTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMessageTemplateTypeFilter>;
  _min?: Maybe<NestedEnumMessageTemplateTypeFilter>;
  equals?: Maybe<MessageTemplateType>;
  in?: Maybe<Array<MessageTemplateType>>;
  not?: Maybe<NestedEnumMessageTemplateTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<MessageTemplateType>>;
};

export type EnumMessageTypeFieldUpdateOperationsInput = {
  set?: Maybe<MessageType>;
};

export type EnumMessageTypeFilter = {
  equals?: Maybe<MessageType>;
  in?: Maybe<Array<MessageType>>;
  not?: Maybe<NestedEnumMessageTypeFilter>;
  notIn?: Maybe<Array<MessageType>>;
};

export type EnumMessageTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMessageTypeFilter>;
  _min?: Maybe<NestedEnumMessageTypeFilter>;
  equals?: Maybe<MessageType>;
  in?: Maybe<Array<MessageType>>;
  not?: Maybe<NestedEnumMessageTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<MessageType>>;
};

export type EnumMessagingCampaignStatusFieldUpdateOperationsInput = {
  set?: Maybe<MessagingCampaignStatus>;
};

export type EnumMessagingCampaignStatusFilter = {
  equals?: Maybe<MessagingCampaignStatus>;
  in?: Maybe<Array<MessagingCampaignStatus>>;
  not?: Maybe<NestedEnumMessagingCampaignStatusFilter>;
  notIn?: Maybe<Array<MessagingCampaignStatus>>;
};

export type EnumMessagingCampaignStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMessagingCampaignStatusFilter>;
  _min?: Maybe<NestedEnumMessagingCampaignStatusFilter>;
  equals?: Maybe<MessagingCampaignStatus>;
  in?: Maybe<Array<MessagingCampaignStatus>>;
  not?: Maybe<NestedEnumMessagingCampaignStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<MessagingCampaignStatus>>;
};

export type EnumMessagingCampaignTypeFieldUpdateOperationsInput = {
  set?: Maybe<MessagingCampaignType>;
};

export type EnumMessagingCampaignTypeFilter = {
  equals?: Maybe<MessagingCampaignType>;
  in?: Maybe<Array<MessagingCampaignType>>;
  not?: Maybe<NestedEnumMessagingCampaignTypeFilter>;
  notIn?: Maybe<Array<MessagingCampaignType>>;
};

export type EnumMessagingCampaignTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMessagingCampaignTypeFilter>;
  _min?: Maybe<NestedEnumMessagingCampaignTypeFilter>;
  equals?: Maybe<MessagingCampaignType>;
  in?: Maybe<Array<MessagingCampaignType>>;
  not?: Maybe<NestedEnumMessagingCampaignTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<MessagingCampaignType>>;
};

export type EnumMissedCallMessageResponseStatusFieldUpdateOperationsInput = {
  set?: Maybe<MissedCallMessageResponseStatus>;
};

export type EnumMissedCallMessageResponseStatusFilter = {
  equals?: Maybe<MissedCallMessageResponseStatus>;
  in?: Maybe<Array<MissedCallMessageResponseStatus>>;
  not?: Maybe<NestedEnumMissedCallMessageResponseStatusFilter>;
  notIn?: Maybe<Array<MissedCallMessageResponseStatus>>;
};

export type EnumMissedCallMessageResponseStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMissedCallMessageResponseStatusFilter>;
  _min?: Maybe<NestedEnumMissedCallMessageResponseStatusFilter>;
  equals?: Maybe<MissedCallMessageResponseStatus>;
  in?: Maybe<Array<MissedCallMessageResponseStatus>>;
  not?: Maybe<NestedEnumMissedCallMessageResponseStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<MissedCallMessageResponseStatus>>;
};

export type EnumNormalizedWritebackErrorNullableFilter = {
  equals?: Maybe<NormalizedWritebackError>;
  in?: Maybe<Array<NormalizedWritebackError>>;
  not?: Maybe<NestedEnumNormalizedWritebackErrorNullableFilter>;
  notIn?: Maybe<Array<NormalizedWritebackError>>;
};

export type EnumNormalizedWritebackErrorNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumNormalizedWritebackErrorNullableFilter>;
  _min?: Maybe<NestedEnumNormalizedWritebackErrorNullableFilter>;
  equals?: Maybe<NormalizedWritebackError>;
  in?: Maybe<Array<NormalizedWritebackError>>;
  not?: Maybe<NestedEnumNormalizedWritebackErrorNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<NormalizedWritebackError>>;
};

export type EnumNotificationEventFieldUpdateOperationsInput = {
  set?: Maybe<NotificationEvent>;
};

export type EnumNotificationEventFilter = {
  equals?: Maybe<NotificationEvent>;
  in?: Maybe<Array<NotificationEvent>>;
  not?: Maybe<NestedEnumNotificationEventFilter>;
  notIn?: Maybe<Array<NotificationEvent>>;
};

export type EnumNotificationEventWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumNotificationEventFilter>;
  _min?: Maybe<NestedEnumNotificationEventFilter>;
  equals?: Maybe<NotificationEvent>;
  in?: Maybe<Array<NotificationEvent>>;
  not?: Maybe<NestedEnumNotificationEventWithAggregatesFilter>;
  notIn?: Maybe<Array<NotificationEvent>>;
};

export type EnumNotificationSettingTypeFieldUpdateOperationsInput = {
  set?: Maybe<NotificationSettingType>;
};

export type EnumNotificationSettingTypeFilter = {
  equals?: Maybe<NotificationSettingType>;
  in?: Maybe<Array<NotificationSettingType>>;
  not?: Maybe<NestedEnumNotificationSettingTypeFilter>;
  notIn?: Maybe<Array<NotificationSettingType>>;
};

export type EnumNotificationSettingTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumNotificationSettingTypeFilter>;
  _min?: Maybe<NestedEnumNotificationSettingTypeFilter>;
  equals?: Maybe<NotificationSettingType>;
  in?: Maybe<Array<NotificationSettingType>>;
  not?: Maybe<NestedEnumNotificationSettingTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<NotificationSettingType>>;
};

export type EnumPaymentMediumNullableFilter = {
  equals?: Maybe<PaymentMedium>;
  in?: Maybe<Array<PaymentMedium>>;
  not?: Maybe<NestedEnumPaymentMediumNullableFilter>;
  notIn?: Maybe<Array<PaymentMedium>>;
};

export type EnumPaymentMediumNullableListFilter = {
  equals?: Maybe<Array<PaymentMedium>>;
  has?: Maybe<PaymentMedium>;
  hasEvery?: Maybe<Array<PaymentMedium>>;
  hasSome?: Maybe<Array<PaymentMedium>>;
  isEmpty?: Maybe<Scalars['Boolean']>;
};

export type EnumPaymentMediumNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumPaymentMediumNullableFilter>;
  _min?: Maybe<NestedEnumPaymentMediumNullableFilter>;
  equals?: Maybe<PaymentMedium>;
  in?: Maybe<Array<PaymentMedium>>;
  not?: Maybe<NestedEnumPaymentMediumNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<PaymentMedium>>;
};

export type EnumPaymentPimsWritebackActionFieldUpdateOperationsInput = {
  set?: Maybe<PaymentPimsWritebackAction>;
};

export type EnumPaymentPimsWritebackActionFilter = {
  equals?: Maybe<PaymentPimsWritebackAction>;
  in?: Maybe<Array<PaymentPimsWritebackAction>>;
  not?: Maybe<NestedEnumPaymentPimsWritebackActionFilter>;
  notIn?: Maybe<Array<PaymentPimsWritebackAction>>;
};

export type EnumPaymentPimsWritebackActionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPaymentPimsWritebackActionFilter>;
  _min?: Maybe<NestedEnumPaymentPimsWritebackActionFilter>;
  equals?: Maybe<PaymentPimsWritebackAction>;
  in?: Maybe<Array<PaymentPimsWritebackAction>>;
  not?: Maybe<NestedEnumPaymentPimsWritebackActionWithAggregatesFilter>;
  notIn?: Maybe<Array<PaymentPimsWritebackAction>>;
};

export type EnumPaymentRelationshipNullableFilter = {
  equals?: Maybe<PaymentRelationship>;
  in?: Maybe<Array<PaymentRelationship>>;
  not?: Maybe<NestedEnumPaymentRelationshipNullableFilter>;
  notIn?: Maybe<Array<PaymentRelationship>>;
};

export type EnumPaymentRelationshipNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumPaymentRelationshipNullableFilter>;
  _min?: Maybe<NestedEnumPaymentRelationshipNullableFilter>;
  equals?: Maybe<PaymentRelationship>;
  in?: Maybe<Array<PaymentRelationship>>;
  not?: Maybe<NestedEnumPaymentRelationshipNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<PaymentRelationship>>;
};

export type EnumPaymentScheduleNullableFilter = {
  equals?: Maybe<PaymentSchedule>;
  in?: Maybe<Array<PaymentSchedule>>;
  not?: Maybe<NestedEnumPaymentScheduleNullableFilter>;
  notIn?: Maybe<Array<PaymentSchedule>>;
};

export type EnumPaymentScheduleNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumPaymentScheduleNullableFilter>;
  _min?: Maybe<NestedEnumPaymentScheduleNullableFilter>;
  equals?: Maybe<PaymentSchedule>;
  in?: Maybe<Array<PaymentSchedule>>;
  not?: Maybe<NestedEnumPaymentScheduleNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<PaymentSchedule>>;
};

export type EnumPaymentSourceFieldUpdateOperationsInput = {
  set?: Maybe<PaymentSource>;
};

export type EnumPaymentSourceFilter = {
  equals?: Maybe<PaymentSource>;
  in?: Maybe<Array<PaymentSource>>;
  not?: Maybe<NestedEnumPaymentSourceFilter>;
  notIn?: Maybe<Array<PaymentSource>>;
};

export type EnumPaymentSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPaymentSourceFilter>;
  _min?: Maybe<NestedEnumPaymentSourceFilter>;
  equals?: Maybe<PaymentSource>;
  in?: Maybe<Array<PaymentSource>>;
  not?: Maybe<NestedEnumPaymentSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<PaymentSource>>;
};

export type EnumPermissionTypeFieldUpdateOperationsInput = {
  set?: Maybe<PermissionType>;
};

export type EnumPermissionTypeFilter = {
  equals?: Maybe<PermissionType>;
  in?: Maybe<Array<PermissionType>>;
  not?: Maybe<NestedEnumPermissionTypeFilter>;
  notIn?: Maybe<Array<PermissionType>>;
};

export type EnumPermissionTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPermissionTypeFilter>;
  _min?: Maybe<NestedEnumPermissionTypeFilter>;
  equals?: Maybe<PermissionType>;
  in?: Maybe<Array<PermissionType>>;
  not?: Maybe<NestedEnumPermissionTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<PermissionType>>;
};

export type EnumPhoneNumberLookupRequestStatusFieldUpdateOperationsInput = {
  set?: Maybe<PhoneNumberLookupRequestStatus>;
};

export type EnumPhoneNumberLookupRequestStatusFilter = {
  equals?: Maybe<PhoneNumberLookupRequestStatus>;
  in?: Maybe<Array<PhoneNumberLookupRequestStatus>>;
  not?: Maybe<NestedEnumPhoneNumberLookupRequestStatusFilter>;
  notIn?: Maybe<Array<PhoneNumberLookupRequestStatus>>;
};

export type EnumPhoneNumberLookupRequestStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPhoneNumberLookupRequestStatusFilter>;
  _min?: Maybe<NestedEnumPhoneNumberLookupRequestStatusFilter>;
  equals?: Maybe<PhoneNumberLookupRequestStatus>;
  in?: Maybe<Array<PhoneNumberLookupRequestStatus>>;
  not?: Maybe<NestedEnumPhoneNumberLookupRequestStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<PhoneNumberLookupRequestStatus>>;
};

export type EnumPhoneNumberStatusFieldUpdateOperationsInput = {
  set?: Maybe<PhoneNumberStatus>;
};

export type EnumPhoneNumberStatusFilter = {
  equals?: Maybe<PhoneNumberStatus>;
  in?: Maybe<Array<PhoneNumberStatus>>;
  not?: Maybe<NestedEnumPhoneNumberStatusFilter>;
  notIn?: Maybe<Array<PhoneNumberStatus>>;
};

export type EnumPhoneNumberStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPhoneNumberStatusFilter>;
  _min?: Maybe<NestedEnumPhoneNumberStatusFilter>;
  equals?: Maybe<PhoneNumberStatus>;
  in?: Maybe<Array<PhoneNumberStatus>>;
  not?: Maybe<NestedEnumPhoneNumberStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<PhoneNumberStatus>>;
};

export type EnumPimsIntegrationCapabilityFieldUpdateOperationsInput = {
  set?: Maybe<PimsIntegrationCapability>;
};

export type EnumPimsIntegrationCapabilityFilter = {
  equals?: Maybe<PimsIntegrationCapability>;
  in?: Maybe<Array<PimsIntegrationCapability>>;
  not?: Maybe<NestedEnumPimsIntegrationCapabilityFilter>;
  notIn?: Maybe<Array<PimsIntegrationCapability>>;
};

export type EnumPimsIntegrationCapabilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPimsIntegrationCapabilityFilter>;
  _min?: Maybe<NestedEnumPimsIntegrationCapabilityFilter>;
  equals?: Maybe<PimsIntegrationCapability>;
  in?: Maybe<Array<PimsIntegrationCapability>>;
  not?: Maybe<NestedEnumPimsIntegrationCapabilityWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsIntegrationCapability>>;
};

export type EnumPimsInvoiceLineItemTypeFieldUpdateOperationsInput = {
  set?: Maybe<PimsInvoiceLineItemType>;
};

export type EnumPimsInvoiceLineItemTypeFilter = {
  equals?: Maybe<PimsInvoiceLineItemType>;
  in?: Maybe<Array<PimsInvoiceLineItemType>>;
  not?: Maybe<NestedEnumPimsInvoiceLineItemTypeFilter>;
  notIn?: Maybe<Array<PimsInvoiceLineItemType>>;
};

export type EnumPimsInvoiceLineItemTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPimsInvoiceLineItemTypeFilter>;
  _min?: Maybe<NestedEnumPimsInvoiceLineItemTypeFilter>;
  equals?: Maybe<PimsInvoiceLineItemType>;
  in?: Maybe<Array<PimsInvoiceLineItemType>>;
  not?: Maybe<NestedEnumPimsInvoiceLineItemTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsInvoiceLineItemType>>;
};

export type EnumPimsSyncFrequencyFieldUpdateOperationsInput = {
  set?: Maybe<PimsSyncFrequency>;
};

export type EnumPimsSyncFrequencyFilter = {
  equals?: Maybe<PimsSyncFrequency>;
  in?: Maybe<Array<PimsSyncFrequency>>;
  not?: Maybe<NestedEnumPimsSyncFrequencyFilter>;
  notIn?: Maybe<Array<PimsSyncFrequency>>;
};

export type EnumPimsSyncFrequencyWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPimsSyncFrequencyFilter>;
  _min?: Maybe<NestedEnumPimsSyncFrequencyFilter>;
  equals?: Maybe<PimsSyncFrequency>;
  in?: Maybe<Array<PimsSyncFrequency>>;
  not?: Maybe<NestedEnumPimsSyncFrequencyWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsSyncFrequency>>;
};

export type EnumPimsSyncStatusNullableFilter = {
  equals?: Maybe<PimsSyncStatus>;
  in?: Maybe<Array<PimsSyncStatus>>;
  not?: Maybe<NestedEnumPimsSyncStatusNullableFilter>;
  notIn?: Maybe<Array<PimsSyncStatus>>;
};

export type EnumPimsSyncStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumPimsSyncStatusNullableFilter>;
  _min?: Maybe<NestedEnumPimsSyncStatusNullableFilter>;
  equals?: Maybe<PimsSyncStatus>;
  in?: Maybe<Array<PimsSyncStatus>>;
  not?: Maybe<NestedEnumPimsSyncStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsSyncStatus>>;
};

export type EnumPimsWritebackStatusFieldUpdateOperationsInput = {
  set?: Maybe<PimsWritebackStatus>;
};

export type EnumPimsWritebackStatusFilter = {
  equals?: Maybe<PimsWritebackStatus>;
  in?: Maybe<Array<PimsWritebackStatus>>;
  not?: Maybe<NestedEnumPimsWritebackStatusFilter>;
  notIn?: Maybe<Array<PimsWritebackStatus>>;
};

export type EnumPimsWritebackStatusNullableFilter = {
  equals?: Maybe<PimsWritebackStatus>;
  in?: Maybe<Array<PimsWritebackStatus>>;
  not?: Maybe<NestedEnumPimsWritebackStatusNullableFilter>;
  notIn?: Maybe<Array<PimsWritebackStatus>>;
};

export type EnumPimsWritebackStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumPimsWritebackStatusNullableFilter>;
  _min?: Maybe<NestedEnumPimsWritebackStatusNullableFilter>;
  equals?: Maybe<PimsWritebackStatus>;
  in?: Maybe<Array<PimsWritebackStatus>>;
  not?: Maybe<NestedEnumPimsWritebackStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsWritebackStatus>>;
};

export type EnumPimsWritebackStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPimsWritebackStatusFilter>;
  _min?: Maybe<NestedEnumPimsWritebackStatusFilter>;
  equals?: Maybe<PimsWritebackStatus>;
  in?: Maybe<Array<PimsWritebackStatus>>;
  not?: Maybe<NestedEnumPimsWritebackStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsWritebackStatus>>;
};

export type EnumPimsWritebackTypeFieldUpdateOperationsInput = {
  set?: Maybe<PimsWritebackType>;
};

export type EnumPimsWritebackTypeFilter = {
  equals?: Maybe<PimsWritebackType>;
  in?: Maybe<Array<PimsWritebackType>>;
  not?: Maybe<NestedEnumPimsWritebackTypeFilter>;
  notIn?: Maybe<Array<PimsWritebackType>>;
};

export type EnumPimsWritebackTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPimsWritebackTypeFilter>;
  _min?: Maybe<NestedEnumPimsWritebackTypeFilter>;
  equals?: Maybe<PimsWritebackType>;
  in?: Maybe<Array<PimsWritebackType>>;
  not?: Maybe<NestedEnumPimsWritebackTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsWritebackType>>;
};

export type EnumPricingModelFieldUpdateOperationsInput = {
  set?: Maybe<PricingModel>;
};

export type EnumPricingModelFilter = {
  equals?: Maybe<PricingModel>;
  in?: Maybe<Array<PricingModel>>;
  not?: Maybe<NestedEnumPricingModelFilter>;
  notIn?: Maybe<Array<PricingModel>>;
};

export type EnumPricingModelWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPricingModelFilter>;
  _min?: Maybe<NestedEnumPricingModelFilter>;
  equals?: Maybe<PricingModel>;
  in?: Maybe<Array<PricingModel>>;
  not?: Maybe<NestedEnumPricingModelWithAggregatesFilter>;
  notIn?: Maybe<Array<PricingModel>>;
};

export type EnumProductIndicationNullableListFilter = {
  equals?: Maybe<Array<ProductIndication>>;
  has?: Maybe<ProductIndication>;
  hasEvery?: Maybe<Array<ProductIndication>>;
  hasSome?: Maybe<Array<ProductIndication>>;
  isEmpty?: Maybe<Scalars['Boolean']>;
};

export type EnumProductSupplyDurationUnitNullableFilter = {
  equals?: Maybe<ProductSupplyDurationUnit>;
  in?: Maybe<Array<ProductSupplyDurationUnit>>;
  not?: Maybe<NestedEnumProductSupplyDurationUnitNullableFilter>;
  notIn?: Maybe<Array<ProductSupplyDurationUnit>>;
};

export type EnumProductSupplyDurationUnitNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumProductSupplyDurationUnitNullableFilter>;
  _min?: Maybe<NestedEnumProductSupplyDurationUnitNullableFilter>;
  equals?: Maybe<ProductSupplyDurationUnit>;
  in?: Maybe<Array<ProductSupplyDurationUnit>>;
  not?: Maybe<NestedEnumProductSupplyDurationUnitNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ProductSupplyDurationUnit>>;
};

export type EnumProductTypeFieldUpdateOperationsInput = {
  set?: Maybe<ProductType>;
};

export type EnumProductTypeFilter = {
  equals?: Maybe<ProductType>;
  in?: Maybe<Array<ProductType>>;
  not?: Maybe<NestedEnumProductTypeFilter>;
  notIn?: Maybe<Array<ProductType>>;
};

export type EnumProductTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumProductTypeFilter>;
  _min?: Maybe<NestedEnumProductTypeFilter>;
  equals?: Maybe<ProductType>;
  in?: Maybe<Array<ProductType>>;
  not?: Maybe<NestedEnumProductTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ProductType>>;
};

export type EnumProfilePimsSyncStatusFieldUpdateOperationsInput = {
  set?: Maybe<ProfilePimsSyncStatus>;
};

export type EnumProfilePimsSyncStatusFilter = {
  equals?: Maybe<ProfilePimsSyncStatus>;
  in?: Maybe<Array<ProfilePimsSyncStatus>>;
  not?: Maybe<NestedEnumProfilePimsSyncStatusFilter>;
  notIn?: Maybe<Array<ProfilePimsSyncStatus>>;
};

export type EnumProfilePimsSyncStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumProfilePimsSyncStatusFilter>;
  _min?: Maybe<NestedEnumProfilePimsSyncStatusFilter>;
  equals?: Maybe<ProfilePimsSyncStatus>;
  in?: Maybe<Array<ProfilePimsSyncStatus>>;
  not?: Maybe<NestedEnumProfilePimsSyncStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<ProfilePimsSyncStatus>>;
};

export type EnumPushNotificationDeliveryErrorTypeNullableFilter = {
  equals?: Maybe<PushNotificationDeliveryErrorType>;
  in?: Maybe<Array<PushNotificationDeliveryErrorType>>;
  not?: Maybe<NestedEnumPushNotificationDeliveryErrorTypeNullableFilter>;
  notIn?: Maybe<Array<PushNotificationDeliveryErrorType>>;
};

export type EnumPushNotificationDeliveryErrorTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumPushNotificationDeliveryErrorTypeNullableFilter>;
  _min?: Maybe<NestedEnumPushNotificationDeliveryErrorTypeNullableFilter>;
  equals?: Maybe<PushNotificationDeliveryErrorType>;
  in?: Maybe<Array<PushNotificationDeliveryErrorType>>;
  not?: Maybe<NestedEnumPushNotificationDeliveryErrorTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<PushNotificationDeliveryErrorType>>;
};

export type EnumPushNotificationLogStatusTypeFieldUpdateOperationsInput = {
  set?: Maybe<PushNotificationLogStatusType>;
};

export type EnumPushNotificationLogStatusTypeFilter = {
  equals?: Maybe<PushNotificationLogStatusType>;
  in?: Maybe<Array<PushNotificationLogStatusType>>;
  not?: Maybe<NestedEnumPushNotificationLogStatusTypeFilter>;
  notIn?: Maybe<Array<PushNotificationLogStatusType>>;
};

export type EnumPushNotificationLogStatusTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPushNotificationLogStatusTypeFilter>;
  _min?: Maybe<NestedEnumPushNotificationLogStatusTypeFilter>;
  equals?: Maybe<PushNotificationLogStatusType>;
  in?: Maybe<Array<PushNotificationLogStatusType>>;
  not?: Maybe<NestedEnumPushNotificationLogStatusTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<PushNotificationLogStatusType>>;
};

export type EnumPushNotificationStatusFieldUpdateOperationsInput = {
  set?: Maybe<PushNotificationStatus>;
};

export type EnumPushNotificationStatusFilter = {
  equals?: Maybe<PushNotificationStatus>;
  in?: Maybe<Array<PushNotificationStatus>>;
  not?: Maybe<NestedEnumPushNotificationStatusFilter>;
  notIn?: Maybe<Array<PushNotificationStatus>>;
};

export type EnumPushNotificationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPushNotificationStatusFilter>;
  _min?: Maybe<NestedEnumPushNotificationStatusFilter>;
  equals?: Maybe<PushNotificationStatus>;
  in?: Maybe<Array<PushNotificationStatus>>;
  not?: Maybe<NestedEnumPushNotificationStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<PushNotificationStatus>>;
};

export type EnumRecapSourceFieldUpdateOperationsInput = {
  set?: Maybe<RecapSource>;
};

export type EnumRecapSourceFilter = {
  equals?: Maybe<RecapSource>;
  in?: Maybe<Array<RecapSource>>;
  not?: Maybe<NestedEnumRecapSourceFilter>;
  notIn?: Maybe<Array<RecapSource>>;
};

export type EnumRecapSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumRecapSourceFilter>;
  _min?: Maybe<NestedEnumRecapSourceFilter>;
  equals?: Maybe<RecapSource>;
  in?: Maybe<Array<RecapSource>>;
  not?: Maybe<NestedEnumRecapSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<RecapSource>>;
};

export type EnumRecapStatusFieldUpdateOperationsInput = {
  set?: Maybe<RecapStatus>;
};

export type EnumRecapStatusFilter = {
  equals?: Maybe<RecapStatus>;
  in?: Maybe<Array<RecapStatus>>;
  not?: Maybe<NestedEnumRecapStatusFilter>;
  notIn?: Maybe<Array<RecapStatus>>;
};

export type EnumRecapStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumRecapStatusFilter>;
  _min?: Maybe<NestedEnumRecapStatusFilter>;
  equals?: Maybe<RecapStatus>;
  in?: Maybe<Array<RecapStatus>>;
  not?: Maybe<NestedEnumRecapStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<RecapStatus>>;
};

export type EnumRecordingDownloadStatusFieldUpdateOperationsInput = {
  set?: Maybe<RecordingDownloadStatus>;
};

export type EnumRecordingDownloadStatusFilter = {
  equals?: Maybe<RecordingDownloadStatus>;
  in?: Maybe<Array<RecordingDownloadStatus>>;
  not?: Maybe<NestedEnumRecordingDownloadStatusFilter>;
  notIn?: Maybe<Array<RecordingDownloadStatus>>;
};

export type EnumRecordingDownloadStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumRecordingDownloadStatusFilter>;
  _min?: Maybe<NestedEnumRecordingDownloadStatusFilter>;
  equals?: Maybe<RecordingDownloadStatus>;
  in?: Maybe<Array<RecordingDownloadStatus>>;
  not?: Maybe<NestedEnumRecordingDownloadStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<RecordingDownloadStatus>>;
};

export type EnumRefundReasonFieldUpdateOperationsInput = {
  set?: Maybe<RefundReason>;
};

export type EnumRefundReasonFilter = {
  equals?: Maybe<RefundReason>;
  in?: Maybe<Array<RefundReason>>;
  not?: Maybe<NestedEnumRefundReasonFilter>;
  notIn?: Maybe<Array<RefundReason>>;
};

export type EnumRefundReasonWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumRefundReasonFilter>;
  _min?: Maybe<NestedEnumRefundReasonFilter>;
  equals?: Maybe<RefundReason>;
  in?: Maybe<Array<RefundReason>>;
  not?: Maybe<NestedEnumRefundReasonWithAggregatesFilter>;
  notIn?: Maybe<Array<RefundReason>>;
};

export type EnumRenewalRejectionReasonNullableFilter = {
  equals?: Maybe<RenewalRejectionReason>;
  in?: Maybe<Array<RenewalRejectionReason>>;
  not?: Maybe<NestedEnumRenewalRejectionReasonNullableFilter>;
  notIn?: Maybe<Array<RenewalRejectionReason>>;
};

export type EnumRenewalRejectionReasonNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumRenewalRejectionReasonNullableFilter>;
  _min?: Maybe<NestedEnumRenewalRejectionReasonNullableFilter>;
  equals?: Maybe<RenewalRejectionReason>;
  in?: Maybe<Array<RenewalRejectionReason>>;
  not?: Maybe<NestedEnumRenewalRejectionReasonNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<RenewalRejectionReason>>;
};

export type EnumRoleFieldUpdateOperationsInput = {
  set?: Maybe<Role>;
};

export type EnumRoleFilter = {
  equals?: Maybe<Role>;
  in?: Maybe<Array<Role>>;
  not?: Maybe<NestedEnumRoleFilter>;
  notIn?: Maybe<Array<Role>>;
};

export type EnumRoleWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumRoleFilter>;
  _min?: Maybe<NestedEnumRoleFilter>;
  equals?: Maybe<Role>;
  in?: Maybe<Array<Role>>;
  not?: Maybe<NestedEnumRoleWithAggregatesFilter>;
  notIn?: Maybe<Array<Role>>;
};

export type EnumRuleActionsFieldUpdateOperationsInput = {
  set?: Maybe<RuleActions>;
};

export type EnumRuleActionsFilter = {
  equals?: Maybe<RuleActions>;
  in?: Maybe<Array<RuleActions>>;
  not?: Maybe<NestedEnumRuleActionsFilter>;
  notIn?: Maybe<Array<RuleActions>>;
};

export type EnumRuleActionsWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumRuleActionsFilter>;
  _min?: Maybe<NestedEnumRuleActionsFilter>;
  equals?: Maybe<RuleActions>;
  in?: Maybe<Array<RuleActions>>;
  not?: Maybe<NestedEnumRuleActionsWithAggregatesFilter>;
  notIn?: Maybe<Array<RuleActions>>;
};

export type EnumSegmentModelTypeFieldUpdateOperationsInput = {
  set?: Maybe<SegmentModelType>;
};

export type EnumSegmentModelTypeFilter = {
  equals?: Maybe<SegmentModelType>;
  in?: Maybe<Array<SegmentModelType>>;
  not?: Maybe<NestedEnumSegmentModelTypeFilter>;
  notIn?: Maybe<Array<SegmentModelType>>;
};

export type EnumSegmentModelTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSegmentModelTypeFilter>;
  _min?: Maybe<NestedEnumSegmentModelTypeFilter>;
  equals?: Maybe<SegmentModelType>;
  in?: Maybe<Array<SegmentModelType>>;
  not?: Maybe<NestedEnumSegmentModelTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<SegmentModelType>>;
};

export type EnumSegmentTypeFieldUpdateOperationsInput = {
  set?: Maybe<SegmentType>;
};

export type EnumSegmentTypeFilter = {
  equals?: Maybe<SegmentType>;
  in?: Maybe<Array<SegmentType>>;
  not?: Maybe<NestedEnumSegmentTypeFilter>;
  notIn?: Maybe<Array<SegmentType>>;
};

export type EnumSegmentTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSegmentTypeFilter>;
  _min?: Maybe<NestedEnumSegmentTypeFilter>;
  equals?: Maybe<SegmentType>;
  in?: Maybe<Array<SegmentType>>;
  not?: Maybe<NestedEnumSegmentTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<SegmentType>>;
};

export type EnumServiceCapabilityFieldUpdateOperationsInput = {
  set?: Maybe<ServiceCapability>;
};

export type EnumServiceCapabilityFilter = {
  equals?: Maybe<ServiceCapability>;
  in?: Maybe<Array<ServiceCapability>>;
  not?: Maybe<NestedEnumServiceCapabilityFilter>;
  notIn?: Maybe<Array<ServiceCapability>>;
};

export type EnumServiceCapabilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumServiceCapabilityFilter>;
  _min?: Maybe<NestedEnumServiceCapabilityFilter>;
  equals?: Maybe<ServiceCapability>;
  in?: Maybe<Array<ServiceCapability>>;
  not?: Maybe<NestedEnumServiceCapabilityWithAggregatesFilter>;
  notIn?: Maybe<Array<ServiceCapability>>;
};

export type EnumServiceProviderFieldUpdateOperationsInput = {
  set?: Maybe<ServiceProvider>;
};

export type EnumServiceProviderFilter = {
  equals?: Maybe<ServiceProvider>;
  in?: Maybe<Array<ServiceProvider>>;
  not?: Maybe<NestedEnumServiceProviderFilter>;
  notIn?: Maybe<Array<ServiceProvider>>;
};

export type EnumServiceProviderWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumServiceProviderFilter>;
  _min?: Maybe<NestedEnumServiceProviderFilter>;
  equals?: Maybe<ServiceProvider>;
  in?: Maybe<Array<ServiceProvider>>;
  not?: Maybe<NestedEnumServiceProviderWithAggregatesFilter>;
  notIn?: Maybe<Array<ServiceProvider>>;
};

export type EnumServiceReminderNotificationTypeFieldUpdateOperationsInput = {
  set?: Maybe<ServiceReminderNotificationType>;
};

export type EnumServiceReminderNotificationTypeFilter = {
  equals?: Maybe<ServiceReminderNotificationType>;
  in?: Maybe<Array<ServiceReminderNotificationType>>;
  not?: Maybe<NestedEnumServiceReminderNotificationTypeFilter>;
  notIn?: Maybe<Array<ServiceReminderNotificationType>>;
};

export type EnumServiceReminderNotificationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumServiceReminderNotificationTypeFilter>;
  _min?: Maybe<NestedEnumServiceReminderNotificationTypeFilter>;
  equals?: Maybe<ServiceReminderNotificationType>;
  in?: Maybe<Array<ServiceReminderNotificationType>>;
  not?: Maybe<NestedEnumServiceReminderNotificationTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ServiceReminderNotificationType>>;
};

export type EnumServiceReminderTimingOffsetUnitFieldUpdateOperationsInput = {
  set?: Maybe<ServiceReminderTimingOffsetUnit>;
};

export type EnumServiceReminderTimingOffsetUnitFilter = {
  equals?: Maybe<ServiceReminderTimingOffsetUnit>;
  in?: Maybe<Array<ServiceReminderTimingOffsetUnit>>;
  not?: Maybe<NestedEnumServiceReminderTimingOffsetUnitFilter>;
  notIn?: Maybe<Array<ServiceReminderTimingOffsetUnit>>;
};

export type EnumServiceReminderTimingOffsetUnitWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumServiceReminderTimingOffsetUnitFilter>;
  _min?: Maybe<NestedEnumServiceReminderTimingOffsetUnitFilter>;
  equals?: Maybe<ServiceReminderTimingOffsetUnit>;
  in?: Maybe<Array<ServiceReminderTimingOffsetUnit>>;
  not?: Maybe<NestedEnumServiceReminderTimingOffsetUnitWithAggregatesFilter>;
  notIn?: Maybe<Array<ServiceReminderTimingOffsetUnit>>;
};

export type EnumServiceReminderTimingTypeFieldUpdateOperationsInput = {
  set?: Maybe<ServiceReminderTimingType>;
};

export type EnumServiceReminderTimingTypeFilter = {
  equals?: Maybe<ServiceReminderTimingType>;
  in?: Maybe<Array<ServiceReminderTimingType>>;
  not?: Maybe<NestedEnumServiceReminderTimingTypeFilter>;
  notIn?: Maybe<Array<ServiceReminderTimingType>>;
};

export type EnumServiceReminderTimingTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumServiceReminderTimingTypeFilter>;
  _min?: Maybe<NestedEnumServiceReminderTimingTypeFilter>;
  equals?: Maybe<ServiceReminderTimingType>;
  in?: Maybe<Array<ServiceReminderTimingType>>;
  not?: Maybe<NestedEnumServiceReminderTimingTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ServiceReminderTimingType>>;
};

export type EnumSmsEntityTypeNullableFilter = {
  equals?: Maybe<SmsEntityType>;
  in?: Maybe<Array<SmsEntityType>>;
  not?: Maybe<NestedEnumSmsEntityTypeNullableFilter>;
  notIn?: Maybe<Array<SmsEntityType>>;
};

export type EnumSmsEntityTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSmsEntityTypeNullableFilter>;
  _min?: Maybe<NestedEnumSmsEntityTypeNullableFilter>;
  equals?: Maybe<SmsEntityType>;
  in?: Maybe<Array<SmsEntityType>>;
  not?: Maybe<NestedEnumSmsEntityTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SmsEntityType>>;
};

export type EnumSmsNotificationDeliveryErrorTypeNullableFilter = {
  equals?: Maybe<SmsNotificationDeliveryErrorType>;
  in?: Maybe<Array<SmsNotificationDeliveryErrorType>>;
  not?: Maybe<NestedEnumSmsNotificationDeliveryErrorTypeNullableFilter>;
  notIn?: Maybe<Array<SmsNotificationDeliveryErrorType>>;
};

export type EnumSmsNotificationDeliveryErrorTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSmsNotificationDeliveryErrorTypeNullableFilter>;
  _min?: Maybe<NestedEnumSmsNotificationDeliveryErrorTypeNullableFilter>;
  equals?: Maybe<SmsNotificationDeliveryErrorType>;
  in?: Maybe<Array<SmsNotificationDeliveryErrorType>>;
  not?: Maybe<NestedEnumSmsNotificationDeliveryErrorTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SmsNotificationDeliveryErrorType>>;
};

export type EnumSmsNotificationProviderFieldUpdateOperationsInput = {
  set?: Maybe<SmsNotificationProvider>;
};

export type EnumSmsNotificationProviderFilter = {
  equals?: Maybe<SmsNotificationProvider>;
  in?: Maybe<Array<SmsNotificationProvider>>;
  not?: Maybe<NestedEnumSmsNotificationProviderFilter>;
  notIn?: Maybe<Array<SmsNotificationProvider>>;
};

export type EnumSmsNotificationProviderWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSmsNotificationProviderFilter>;
  _min?: Maybe<NestedEnumSmsNotificationProviderFilter>;
  equals?: Maybe<SmsNotificationProvider>;
  in?: Maybe<Array<SmsNotificationProvider>>;
  not?: Maybe<NestedEnumSmsNotificationProviderWithAggregatesFilter>;
  notIn?: Maybe<Array<SmsNotificationProvider>>;
};

export type EnumSmsNotificationStatusTypeFieldUpdateOperationsInput = {
  set?: Maybe<SmsNotificationStatusType>;
};

export type EnumSmsNotificationStatusTypeFilter = {
  equals?: Maybe<SmsNotificationStatusType>;
  in?: Maybe<Array<SmsNotificationStatusType>>;
  not?: Maybe<NestedEnumSmsNotificationStatusTypeFilter>;
  notIn?: Maybe<Array<SmsNotificationStatusType>>;
};

export type EnumSmsNotificationStatusTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSmsNotificationStatusTypeFilter>;
  _min?: Maybe<NestedEnumSmsNotificationStatusTypeFilter>;
  equals?: Maybe<SmsNotificationStatusType>;
  in?: Maybe<Array<SmsNotificationStatusType>>;
  not?: Maybe<NestedEnumSmsNotificationStatusTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<SmsNotificationStatusType>>;
};

export type EnumSpeciesTypeFieldUpdateOperationsInput = {
  set?: Maybe<SpeciesType>;
};

export type EnumSpeciesTypeFilter = {
  equals?: Maybe<SpeciesType>;
  in?: Maybe<Array<SpeciesType>>;
  not?: Maybe<NestedEnumSpeciesTypeFilter>;
  notIn?: Maybe<Array<SpeciesType>>;
};

export type EnumSpeciesTypeNullableFilter = {
  equals?: Maybe<SpeciesType>;
  in?: Maybe<Array<SpeciesType>>;
  not?: Maybe<NestedEnumSpeciesTypeNullableFilter>;
  notIn?: Maybe<Array<SpeciesType>>;
};

export type EnumSpeciesTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSpeciesTypeNullableFilter>;
  _min?: Maybe<NestedEnumSpeciesTypeNullableFilter>;
  equals?: Maybe<SpeciesType>;
  in?: Maybe<Array<SpeciesType>>;
  not?: Maybe<NestedEnumSpeciesTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SpeciesType>>;
};

export type EnumSpeciesTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSpeciesTypeFilter>;
  _min?: Maybe<NestedEnumSpeciesTypeFilter>;
  equals?: Maybe<SpeciesType>;
  in?: Maybe<Array<SpeciesType>>;
  not?: Maybe<NestedEnumSpeciesTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<SpeciesType>>;
};

export type EnumStateFieldUpdateOperationsInput = {
  set?: Maybe<State>;
};

export type EnumStateFilter = {
  equals?: Maybe<State>;
  in?: Maybe<Array<State>>;
  not?: Maybe<NestedEnumStateFilter>;
  notIn?: Maybe<Array<State>>;
};

export type EnumStateWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStateFilter>;
  _min?: Maybe<NestedEnumStateFilter>;
  equals?: Maybe<State>;
  in?: Maybe<Array<State>>;
  not?: Maybe<NestedEnumStateWithAggregatesFilter>;
  notIn?: Maybe<Array<State>>;
};

export type EnumStripeCollectionMethodFieldUpdateOperationsInput = {
  set?: Maybe<StripeCollectionMethod>;
};

export type EnumStripeCollectionMethodFilter = {
  equals?: Maybe<StripeCollectionMethod>;
  in?: Maybe<Array<StripeCollectionMethod>>;
  not?: Maybe<NestedEnumStripeCollectionMethodFilter>;
  notIn?: Maybe<Array<StripeCollectionMethod>>;
};

export type EnumStripeCollectionMethodWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeCollectionMethodFilter>;
  _min?: Maybe<NestedEnumStripeCollectionMethodFilter>;
  equals?: Maybe<StripeCollectionMethod>;
  in?: Maybe<Array<StripeCollectionMethod>>;
  not?: Maybe<NestedEnumStripeCollectionMethodWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeCollectionMethod>>;
};

export type EnumStripeDisputeReasonNullableFilter = {
  equals?: Maybe<StripeDisputeReason>;
  in?: Maybe<Array<StripeDisputeReason>>;
  not?: Maybe<NestedEnumStripeDisputeReasonNullableFilter>;
  notIn?: Maybe<Array<StripeDisputeReason>>;
};

export type EnumStripeDisputeReasonNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumStripeDisputeReasonNullableFilter>;
  _min?: Maybe<NestedEnumStripeDisputeReasonNullableFilter>;
  equals?: Maybe<StripeDisputeReason>;
  in?: Maybe<Array<StripeDisputeReason>>;
  not?: Maybe<NestedEnumStripeDisputeReasonNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeDisputeReason>>;
};

export type EnumStripeDisputeStatusFieldUpdateOperationsInput = {
  set?: Maybe<StripeDisputeStatus>;
};

export type EnumStripeDisputeStatusFilter = {
  equals?: Maybe<StripeDisputeStatus>;
  in?: Maybe<Array<StripeDisputeStatus>>;
  not?: Maybe<NestedEnumStripeDisputeStatusFilter>;
  notIn?: Maybe<Array<StripeDisputeStatus>>;
};

export type EnumStripeDisputeStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeDisputeStatusFilter>;
  _min?: Maybe<NestedEnumStripeDisputeStatusFilter>;
  equals?: Maybe<StripeDisputeStatus>;
  in?: Maybe<Array<StripeDisputeStatus>>;
  not?: Maybe<NestedEnumStripeDisputeStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeDisputeStatus>>;
};

export type EnumStripeInvoiceStatusFieldUpdateOperationsInput = {
  set?: Maybe<StripeInvoiceStatus>;
};

export type EnumStripeInvoiceStatusFilter = {
  equals?: Maybe<StripeInvoiceStatus>;
  in?: Maybe<Array<StripeInvoiceStatus>>;
  not?: Maybe<NestedEnumStripeInvoiceStatusFilter>;
  notIn?: Maybe<Array<StripeInvoiceStatus>>;
};

export type EnumStripeInvoiceStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeInvoiceStatusFilter>;
  _min?: Maybe<NestedEnumStripeInvoiceStatusFilter>;
  equals?: Maybe<StripeInvoiceStatus>;
  in?: Maybe<Array<StripeInvoiceStatus>>;
  not?: Maybe<NestedEnumStripeInvoiceStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeInvoiceStatus>>;
};

export type EnumStripePaymentErrorNullableFilter = {
  equals?: Maybe<StripePaymentError>;
  in?: Maybe<Array<StripePaymentError>>;
  not?: Maybe<NestedEnumStripePaymentErrorNullableFilter>;
  notIn?: Maybe<Array<StripePaymentError>>;
};

export type EnumStripePaymentErrorNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumStripePaymentErrorNullableFilter>;
  _min?: Maybe<NestedEnumStripePaymentErrorNullableFilter>;
  equals?: Maybe<StripePaymentError>;
  in?: Maybe<Array<StripePaymentError>>;
  not?: Maybe<NestedEnumStripePaymentErrorNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<StripePaymentError>>;
};

export type EnumStripePaymentIntentStatusFieldUpdateOperationsInput = {
  set?: Maybe<StripePaymentIntentStatus>;
};

export type EnumStripePaymentIntentStatusFilter = {
  equals?: Maybe<StripePaymentIntentStatus>;
  in?: Maybe<Array<StripePaymentIntentStatus>>;
  not?: Maybe<NestedEnumStripePaymentIntentStatusFilter>;
  notIn?: Maybe<Array<StripePaymentIntentStatus>>;
};

export type EnumStripePaymentIntentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripePaymentIntentStatusFilter>;
  _min?: Maybe<NestedEnumStripePaymentIntentStatusFilter>;
  equals?: Maybe<StripePaymentIntentStatus>;
  in?: Maybe<Array<StripePaymentIntentStatus>>;
  not?: Maybe<NestedEnumStripePaymentIntentStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<StripePaymentIntentStatus>>;
};

export type EnumStripePaymentMethodTypeFieldUpdateOperationsInput = {
  set?: Maybe<StripePaymentMethodType>;
};

export type EnumStripePaymentMethodTypeFilter = {
  equals?: Maybe<StripePaymentMethodType>;
  in?: Maybe<Array<StripePaymentMethodType>>;
  not?: Maybe<NestedEnumStripePaymentMethodTypeFilter>;
  notIn?: Maybe<Array<StripePaymentMethodType>>;
};

export type EnumStripePaymentMethodTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripePaymentMethodTypeFilter>;
  _min?: Maybe<NestedEnumStripePaymentMethodTypeFilter>;
  equals?: Maybe<StripePaymentMethodType>;
  in?: Maybe<Array<StripePaymentMethodType>>;
  not?: Maybe<NestedEnumStripePaymentMethodTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<StripePaymentMethodType>>;
};

export type EnumStripePaymentTransferTypeFieldUpdateOperationsInput = {
  set?: Maybe<StripePaymentTransferType>;
};

export type EnumStripePaymentTransferTypeFilter = {
  equals?: Maybe<StripePaymentTransferType>;
  in?: Maybe<Array<StripePaymentTransferType>>;
  not?: Maybe<NestedEnumStripePaymentTransferTypeFilter>;
  notIn?: Maybe<Array<StripePaymentTransferType>>;
};

export type EnumStripePaymentTransferTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripePaymentTransferTypeFilter>;
  _min?: Maybe<NestedEnumStripePaymentTransferTypeFilter>;
  equals?: Maybe<StripePaymentTransferType>;
  in?: Maybe<Array<StripePaymentTransferType>>;
  not?: Maybe<NestedEnumStripePaymentTransferTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<StripePaymentTransferType>>;
};

export type EnumStripePayoutStatusFieldUpdateOperationsInput = {
  set?: Maybe<StripePayoutStatus>;
};

export type EnumStripePayoutStatusFilter = {
  equals?: Maybe<StripePayoutStatus>;
  in?: Maybe<Array<StripePayoutStatus>>;
  not?: Maybe<NestedEnumStripePayoutStatusFilter>;
  notIn?: Maybe<Array<StripePayoutStatus>>;
};

export type EnumStripePayoutStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripePayoutStatusFilter>;
  _min?: Maybe<NestedEnumStripePayoutStatusFilter>;
  equals?: Maybe<StripePayoutStatus>;
  in?: Maybe<Array<StripePayoutStatus>>;
  not?: Maybe<NestedEnumStripePayoutStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<StripePayoutStatus>>;
};

export type EnumStripeReceiptMediumFieldUpdateOperationsInput = {
  set?: Maybe<StripeReceiptMedium>;
};

export type EnumStripeReceiptMediumFilter = {
  equals?: Maybe<StripeReceiptMedium>;
  in?: Maybe<Array<StripeReceiptMedium>>;
  not?: Maybe<NestedEnumStripeReceiptMediumFilter>;
  notIn?: Maybe<Array<StripeReceiptMedium>>;
};

export type EnumStripeReceiptMediumWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeReceiptMediumFilter>;
  _min?: Maybe<NestedEnumStripeReceiptMediumFilter>;
  equals?: Maybe<StripeReceiptMedium>;
  in?: Maybe<Array<StripeReceiptMedium>>;
  not?: Maybe<NestedEnumStripeReceiptMediumWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeReceiptMedium>>;
};

export type EnumStripeTerminalLocationTypeFieldUpdateOperationsInput = {
  set?: Maybe<StripeTerminalLocationType>;
};

export type EnumStripeTerminalLocationTypeFilter = {
  equals?: Maybe<StripeTerminalLocationType>;
  in?: Maybe<Array<StripeTerminalLocationType>>;
  not?: Maybe<NestedEnumStripeTerminalLocationTypeFilter>;
  notIn?: Maybe<Array<StripeTerminalLocationType>>;
};

export type EnumStripeTerminalLocationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeTerminalLocationTypeFilter>;
  _min?: Maybe<NestedEnumStripeTerminalLocationTypeFilter>;
  equals?: Maybe<StripeTerminalLocationType>;
  in?: Maybe<Array<StripeTerminalLocationType>>;
  not?: Maybe<NestedEnumStripeTerminalLocationTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeTerminalLocationType>>;
};

export type EnumStripeTerminalModelFieldUpdateOperationsInput = {
  set?: Maybe<StripeTerminalModel>;
};

export type EnumStripeTerminalModelFilter = {
  equals?: Maybe<StripeTerminalModel>;
  in?: Maybe<Array<StripeTerminalModel>>;
  not?: Maybe<NestedEnumStripeTerminalModelFilter>;
  notIn?: Maybe<Array<StripeTerminalModel>>;
};

export type EnumStripeTerminalModelWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeTerminalModelFilter>;
  _min?: Maybe<NestedEnumStripeTerminalModelFilter>;
  equals?: Maybe<StripeTerminalModel>;
  in?: Maybe<Array<StripeTerminalModel>>;
  not?: Maybe<NestedEnumStripeTerminalModelWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeTerminalModel>>;
};

export type EnumStripeTerminalStatusFieldUpdateOperationsInput = {
  set?: Maybe<StripeTerminalStatus>;
};

export type EnumStripeTerminalStatusFilter = {
  equals?: Maybe<StripeTerminalStatus>;
  in?: Maybe<Array<StripeTerminalStatus>>;
  not?: Maybe<NestedEnumStripeTerminalStatusFilter>;
  notIn?: Maybe<Array<StripeTerminalStatus>>;
};

export type EnumStripeTerminalStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeTerminalStatusFilter>;
  _min?: Maybe<NestedEnumStripeTerminalStatusFilter>;
  equals?: Maybe<StripeTerminalStatus>;
  in?: Maybe<Array<StripeTerminalStatus>>;
  not?: Maybe<NestedEnumStripeTerminalStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeTerminalStatus>>;
};

export type EnumSupportEventStatusFieldUpdateOperationsInput = {
  set?: Maybe<SupportEventStatus>;
};

export type EnumSupportEventStatusFilter = {
  equals?: Maybe<SupportEventStatus>;
  in?: Maybe<Array<SupportEventStatus>>;
  not?: Maybe<NestedEnumSupportEventStatusFilter>;
  notIn?: Maybe<Array<SupportEventStatus>>;
};

export type EnumSupportEventStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSupportEventStatusFilter>;
  _min?: Maybe<NestedEnumSupportEventStatusFilter>;
  equals?: Maybe<SupportEventStatus>;
  in?: Maybe<Array<SupportEventStatus>>;
  not?: Maybe<NestedEnumSupportEventStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<SupportEventStatus>>;
};

export type EnumSurveyStepNullableFilter = {
  equals?: Maybe<SurveyStep>;
  in?: Maybe<Array<SurveyStep>>;
  not?: Maybe<NestedEnumSurveyStepNullableFilter>;
  notIn?: Maybe<Array<SurveyStep>>;
};

export type EnumSurveyStepNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSurveyStepNullableFilter>;
  _min?: Maybe<NestedEnumSurveyStepNullableFilter>;
  equals?: Maybe<SurveyStep>;
  in?: Maybe<Array<SurveyStep>>;
  not?: Maybe<NestedEnumSurveyStepNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SurveyStep>>;
};

export type EnumSurveyTypeFieldUpdateOperationsInput = {
  set?: Maybe<SurveyType>;
};

export type EnumSurveyTypeFilter = {
  equals?: Maybe<SurveyType>;
  in?: Maybe<Array<SurveyType>>;
  not?: Maybe<NestedEnumSurveyTypeFilter>;
  notIn?: Maybe<Array<SurveyType>>;
};

export type EnumSurveyTypeNullableFilter = {
  equals?: Maybe<SurveyType>;
  in?: Maybe<Array<SurveyType>>;
  not?: Maybe<NestedEnumSurveyTypeNullableFilter>;
  notIn?: Maybe<Array<SurveyType>>;
};

export type EnumSurveyTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSurveyTypeNullableFilter>;
  _min?: Maybe<NestedEnumSurveyTypeNullableFilter>;
  equals?: Maybe<SurveyType>;
  in?: Maybe<Array<SurveyType>>;
  not?: Maybe<NestedEnumSurveyTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SurveyType>>;
};

export type EnumSurveyTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSurveyTypeFilter>;
  _min?: Maybe<NestedEnumSurveyTypeFilter>;
  equals?: Maybe<SurveyType>;
  in?: Maybe<Array<SurveyType>>;
  not?: Maybe<NestedEnumSurveyTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<SurveyType>>;
};

export type EnumSyncVetIntegrationSystemNullableFilter = {
  equals?: Maybe<SyncVetIntegrationSystem>;
  in?: Maybe<Array<SyncVetIntegrationSystem>>;
  not?: Maybe<NestedEnumSyncVetIntegrationSystemNullableFilter>;
  notIn?: Maybe<Array<SyncVetIntegrationSystem>>;
};

export type EnumSyncVetIntegrationSystemNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSyncVetIntegrationSystemNullableFilter>;
  _min?: Maybe<NestedEnumSyncVetIntegrationSystemNullableFilter>;
  equals?: Maybe<SyncVetIntegrationSystem>;
  in?: Maybe<Array<SyncVetIntegrationSystem>>;
  not?: Maybe<NestedEnumSyncVetIntegrationSystemNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SyncVetIntegrationSystem>>;
};

export type EnumSynchronyEventStatusFieldUpdateOperationsInput = {
  set?: Maybe<SynchronyEventStatus>;
};

export type EnumSynchronyEventStatusFilter = {
  equals?: Maybe<SynchronyEventStatus>;
  in?: Maybe<Array<SynchronyEventStatus>>;
  not?: Maybe<NestedEnumSynchronyEventStatusFilter>;
  notIn?: Maybe<Array<SynchronyEventStatus>>;
};

export type EnumSynchronyEventStatusNullableFilter = {
  equals?: Maybe<SynchronyEventStatus>;
  in?: Maybe<Array<SynchronyEventStatus>>;
  not?: Maybe<NestedEnumSynchronyEventStatusNullableFilter>;
  notIn?: Maybe<Array<SynchronyEventStatus>>;
};

export type EnumSynchronyEventStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSynchronyEventStatusNullableFilter>;
  _min?: Maybe<NestedEnumSynchronyEventStatusNullableFilter>;
  equals?: Maybe<SynchronyEventStatus>;
  in?: Maybe<Array<SynchronyEventStatus>>;
  not?: Maybe<NestedEnumSynchronyEventStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SynchronyEventStatus>>;
};

export type EnumSynchronyEventStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSynchronyEventStatusFilter>;
  _min?: Maybe<NestedEnumSynchronyEventStatusFilter>;
  equals?: Maybe<SynchronyEventStatus>;
  in?: Maybe<Array<SynchronyEventStatus>>;
  not?: Maybe<NestedEnumSynchronyEventStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<SynchronyEventStatus>>;
};

export type EnumSynchronyEventTypeFieldUpdateOperationsInput = {
  set?: Maybe<SynchronyEventType>;
};

export type EnumSynchronyEventTypeFilter = {
  equals?: Maybe<SynchronyEventType>;
  in?: Maybe<Array<SynchronyEventType>>;
  not?: Maybe<NestedEnumSynchronyEventTypeFilter>;
  notIn?: Maybe<Array<SynchronyEventType>>;
};

export type EnumSynchronyEventTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSynchronyEventTypeFilter>;
  _min?: Maybe<NestedEnumSynchronyEventTypeFilter>;
  equals?: Maybe<SynchronyEventType>;
  in?: Maybe<Array<SynchronyEventType>>;
  not?: Maybe<NestedEnumSynchronyEventTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<SynchronyEventType>>;
};

export type EnumTaskStatusFieldUpdateOperationsInput = {
  set?: Maybe<TaskStatus>;
};

export type EnumTaskStatusFilter = {
  equals?: Maybe<TaskStatus>;
  in?: Maybe<Array<TaskStatus>>;
  not?: Maybe<NestedEnumTaskStatusFilter>;
  notIn?: Maybe<Array<TaskStatus>>;
};

export type EnumTaskStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumTaskStatusFilter>;
  _min?: Maybe<NestedEnumTaskStatusFilter>;
  equals?: Maybe<TaskStatus>;
  in?: Maybe<Array<TaskStatus>>;
  not?: Maybe<NestedEnumTaskStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<TaskStatus>>;
};

export type EnumTaskTypeFieldUpdateOperationsInput = {
  set?: Maybe<TaskType>;
};

export type EnumTaskTypeFilter = {
  equals?: Maybe<TaskType>;
  in?: Maybe<Array<TaskType>>;
  not?: Maybe<NestedEnumTaskTypeFilter>;
  notIn?: Maybe<Array<TaskType>>;
};

export type EnumTaskTypeNullableFilter = {
  equals?: Maybe<TaskType>;
  in?: Maybe<Array<TaskType>>;
  not?: Maybe<NestedEnumTaskTypeNullableFilter>;
  notIn?: Maybe<Array<TaskType>>;
};

export type EnumTaskTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumTaskTypeNullableFilter>;
  _min?: Maybe<NestedEnumTaskTypeNullableFilter>;
  equals?: Maybe<TaskType>;
  in?: Maybe<Array<TaskType>>;
  not?: Maybe<NestedEnumTaskTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<TaskType>>;
};

export type EnumTaskTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumTaskTypeFilter>;
  _min?: Maybe<NestedEnumTaskTypeFilter>;
  equals?: Maybe<TaskType>;
  in?: Maybe<Array<TaskType>>;
  not?: Maybe<NestedEnumTaskTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<TaskType>>;
};

export type EnumTemplateAvailabilityFieldUpdateOperationsInput = {
  set?: Maybe<TemplateAvailability>;
};

export type EnumTemplateAvailabilityFilter = {
  equals?: Maybe<TemplateAvailability>;
  in?: Maybe<Array<TemplateAvailability>>;
  not?: Maybe<NestedEnumTemplateAvailabilityFilter>;
  notIn?: Maybe<Array<TemplateAvailability>>;
};

export type EnumTemplateAvailabilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumTemplateAvailabilityFilter>;
  _min?: Maybe<NestedEnumTemplateAvailabilityFilter>;
  equals?: Maybe<TemplateAvailability>;
  in?: Maybe<Array<TemplateAvailability>>;
  not?: Maybe<NestedEnumTemplateAvailabilityWithAggregatesFilter>;
  notIn?: Maybe<Array<TemplateAvailability>>;
};

export type EnumTimeUnitNullableFilter = {
  equals?: Maybe<TimeUnit>;
  in?: Maybe<Array<TimeUnit>>;
  not?: Maybe<NestedEnumTimeUnitNullableFilter>;
  notIn?: Maybe<Array<TimeUnit>>;
};

export type EnumTimeUnitNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumTimeUnitNullableFilter>;
  _min?: Maybe<NestedEnumTimeUnitNullableFilter>;
  equals?: Maybe<TimeUnit>;
  in?: Maybe<Array<TimeUnit>>;
  not?: Maybe<NestedEnumTimeUnitNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<TimeUnit>>;
};

export type EnumTranscriptionServicesNullableFilter = {
  equals?: Maybe<TranscriptionServices>;
  in?: Maybe<Array<TranscriptionServices>>;
  not?: Maybe<NestedEnumTranscriptionServicesNullableFilter>;
  notIn?: Maybe<Array<TranscriptionServices>>;
};

export type EnumTranscriptionServicesNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumTranscriptionServicesNullableFilter>;
  _min?: Maybe<NestedEnumTranscriptionServicesNullableFilter>;
  equals?: Maybe<TranscriptionServices>;
  in?: Maybe<Array<TranscriptionServices>>;
  not?: Maybe<NestedEnumTranscriptionServicesNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<TranscriptionServices>>;
};

export type EnumTwilioRecordingStatusFieldUpdateOperationsInput = {
  set?: Maybe<TwilioRecordingStatus>;
};

export type EnumTwilioRecordingStatusFilter = {
  equals?: Maybe<TwilioRecordingStatus>;
  in?: Maybe<Array<TwilioRecordingStatus>>;
  not?: Maybe<NestedEnumTwilioRecordingStatusFilter>;
  notIn?: Maybe<Array<TwilioRecordingStatus>>;
};

export type EnumTwilioRecordingStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumTwilioRecordingStatusFilter>;
  _min?: Maybe<NestedEnumTwilioRecordingStatusFilter>;
  equals?: Maybe<TwilioRecordingStatus>;
  in?: Maybe<Array<TwilioRecordingStatus>>;
  not?: Maybe<NestedEnumTwilioRecordingStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<TwilioRecordingStatus>>;
};

export type EnumTwilioVerificationStatusFieldUpdateOperationsInput = {
  set?: Maybe<TwilioVerificationStatus>;
};

export type EnumTwilioVerificationStatusFilter = {
  equals?: Maybe<TwilioVerificationStatus>;
  in?: Maybe<Array<TwilioVerificationStatus>>;
  not?: Maybe<NestedEnumTwilioVerificationStatusFilter>;
  notIn?: Maybe<Array<TwilioVerificationStatus>>;
};

export type EnumTwilioVerificationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumTwilioVerificationStatusFilter>;
  _min?: Maybe<NestedEnumTwilioVerificationStatusFilter>;
  equals?: Maybe<TwilioVerificationStatus>;
  in?: Maybe<Array<TwilioVerificationStatus>>;
  not?: Maybe<NestedEnumTwilioVerificationStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<TwilioVerificationStatus>>;
};

export type EnumUserTypeFieldUpdateOperationsInput = {
  set?: Maybe<UserType>;
};

export type EnumUserTypeFilter = {
  equals?: Maybe<UserType>;
  in?: Maybe<Array<UserType>>;
  not?: Maybe<NestedEnumUserTypeFilter>;
  notIn?: Maybe<Array<UserType>>;
};

export type EnumUserTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumUserTypeFilter>;
  _min?: Maybe<NestedEnumUserTypeFilter>;
  equals?: Maybe<UserType>;
  in?: Maybe<Array<UserType>>;
  not?: Maybe<NestedEnumUserTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<UserType>>;
};

export type EnumVetDataIntegrationSystemFieldUpdateOperationsInput = {
  set?: Maybe<VetDataIntegrationSystem>;
};

export type EnumVetDataIntegrationSystemFilter = {
  equals?: Maybe<VetDataIntegrationSystem>;
  in?: Maybe<Array<VetDataIntegrationSystem>>;
  not?: Maybe<NestedEnumVetDataIntegrationSystemFilter>;
  notIn?: Maybe<Array<VetDataIntegrationSystem>>;
};

export type EnumVetDataIntegrationSystemWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumVetDataIntegrationSystemFilter>;
  _min?: Maybe<NestedEnumVetDataIntegrationSystemFilter>;
  equals?: Maybe<VetDataIntegrationSystem>;
  in?: Maybe<Array<VetDataIntegrationSystem>>;
  not?: Maybe<NestedEnumVetDataIntegrationSystemWithAggregatesFilter>;
  notIn?: Maybe<Array<VetDataIntegrationSystem>>;
};

export type EnumVetLicenseTypeFieldUpdateOperationsInput = {
  set?: Maybe<VetLicenseType>;
};

export type EnumVetLicenseTypeFilter = {
  equals?: Maybe<VetLicenseType>;
  in?: Maybe<Array<VetLicenseType>>;
  not?: Maybe<NestedEnumVetLicenseTypeFilter>;
  notIn?: Maybe<Array<VetLicenseType>>;
};

export type EnumVetLicenseTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumVetLicenseTypeFilter>;
  _min?: Maybe<NestedEnumVetLicenseTypeFilter>;
  equals?: Maybe<VetLicenseType>;
  in?: Maybe<Array<VetLicenseType>>;
  not?: Maybe<NestedEnumVetLicenseTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<VetLicenseType>>;
};

export type EnumVetsourceCodeTagTypeFieldUpdateOperationsInput = {
  set?: Maybe<VetsourceCodeTagType>;
};

export type EnumVetsourceCodeTagTypeFilter = {
  equals?: Maybe<VetsourceCodeTagType>;
  in?: Maybe<Array<VetsourceCodeTagType>>;
  not?: Maybe<NestedEnumVetsourceCodeTagTypeFilter>;
  notIn?: Maybe<Array<VetsourceCodeTagType>>;
};

export type EnumVetsourceCodeTagTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumVetsourceCodeTagTypeFilter>;
  _min?: Maybe<NestedEnumVetsourceCodeTagTypeFilter>;
  equals?: Maybe<VetsourceCodeTagType>;
  in?: Maybe<Array<VetsourceCodeTagType>>;
  not?: Maybe<NestedEnumVetsourceCodeTagTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<VetsourceCodeTagType>>;
};

export type EnumVetsourceInstallationConnectivityStateFieldUpdateOperationsInput = {
  set?: Maybe<VetsourceInstallationConnectivityState>;
};

export type EnumVetsourceInstallationConnectivityStateFilter = {
  equals?: Maybe<VetsourceInstallationConnectivityState>;
  in?: Maybe<Array<VetsourceInstallationConnectivityState>>;
  not?: Maybe<NestedEnumVetsourceInstallationConnectivityStateFilter>;
  notIn?: Maybe<Array<VetsourceInstallationConnectivityState>>;
};

export type EnumVetsourceInstallationConnectivityStateWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumVetsourceInstallationConnectivityStateFilter>;
  _min?: Maybe<NestedEnumVetsourceInstallationConnectivityStateFilter>;
  equals?: Maybe<VetsourceInstallationConnectivityState>;
  in?: Maybe<Array<VetsourceInstallationConnectivityState>>;
  not?: Maybe<NestedEnumVetsourceInstallationConnectivityStateWithAggregatesFilter>;
  notIn?: Maybe<Array<VetsourceInstallationConnectivityState>>;
};

export type EnumWidgetRequestTypeFieldUpdateOperationsInput = {
  set?: Maybe<WidgetRequestType>;
};

export type EnumWidgetRequestTypeFilter = {
  equals?: Maybe<WidgetRequestType>;
  in?: Maybe<Array<WidgetRequestType>>;
  not?: Maybe<NestedEnumWidgetRequestTypeFilter>;
  notIn?: Maybe<Array<WidgetRequestType>>;
};

export type EnumWidgetRequestTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWidgetRequestTypeFilter>;
  _min?: Maybe<NestedEnumWidgetRequestTypeFilter>;
  equals?: Maybe<WidgetRequestType>;
  in?: Maybe<Array<WidgetRequestType>>;
  not?: Maybe<NestedEnumWidgetRequestTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<WidgetRequestType>>;
};

export type EnumWidgetVisibilityFieldUpdateOperationsInput = {
  set?: Maybe<WidgetVisibility>;
};

export type EnumWidgetVisibilityFilter = {
  equals?: Maybe<WidgetVisibility>;
  in?: Maybe<Array<WidgetVisibility>>;
  not?: Maybe<NestedEnumWidgetVisibilityFilter>;
  notIn?: Maybe<Array<WidgetVisibility>>;
};

export type EnumWidgetVisibilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWidgetVisibilityFilter>;
  _min?: Maybe<NestedEnumWidgetVisibilityFilter>;
  equals?: Maybe<WidgetVisibility>;
  in?: Maybe<Array<WidgetVisibility>>;
  not?: Maybe<NestedEnumWidgetVisibilityWithAggregatesFilter>;
  notIn?: Maybe<Array<WidgetVisibility>>;
};

export type EnumWorkflowActionTypeFieldUpdateOperationsInput = {
  set?: Maybe<WorkflowActionType>;
};

export type EnumWorkflowActionTypeFilter = {
  equals?: Maybe<WorkflowActionType>;
  in?: Maybe<Array<WorkflowActionType>>;
  not?: Maybe<NestedEnumWorkflowActionTypeFilter>;
  notIn?: Maybe<Array<WorkflowActionType>>;
};

export type EnumWorkflowActionTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWorkflowActionTypeFilter>;
  _min?: Maybe<NestedEnumWorkflowActionTypeFilter>;
  equals?: Maybe<WorkflowActionType>;
  in?: Maybe<Array<WorkflowActionType>>;
  not?: Maybe<NestedEnumWorkflowActionTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowActionType>>;
};

export type EnumWorkflowEventFieldUpdateOperationsInput = {
  set?: Maybe<WorkflowEvent>;
};

export type EnumWorkflowEventFilter = {
  equals?: Maybe<WorkflowEvent>;
  in?: Maybe<Array<WorkflowEvent>>;
  not?: Maybe<NestedEnumWorkflowEventFilter>;
  notIn?: Maybe<Array<WorkflowEvent>>;
};

export type EnumWorkflowEventTriggerTypeFieldUpdateOperationsInput = {
  set?: Maybe<WorkflowEventTriggerType>;
};

export type EnumWorkflowEventTriggerTypeFilter = {
  equals?: Maybe<WorkflowEventTriggerType>;
  in?: Maybe<Array<WorkflowEventTriggerType>>;
  not?: Maybe<NestedEnumWorkflowEventTriggerTypeFilter>;
  notIn?: Maybe<Array<WorkflowEventTriggerType>>;
};

export type EnumWorkflowEventTriggerTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWorkflowEventTriggerTypeFilter>;
  _min?: Maybe<NestedEnumWorkflowEventTriggerTypeFilter>;
  equals?: Maybe<WorkflowEventTriggerType>;
  in?: Maybe<Array<WorkflowEventTriggerType>>;
  not?: Maybe<NestedEnumWorkflowEventTriggerTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowEventTriggerType>>;
};

export type EnumWorkflowEventWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWorkflowEventFilter>;
  _min?: Maybe<NestedEnumWorkflowEventFilter>;
  equals?: Maybe<WorkflowEvent>;
  in?: Maybe<Array<WorkflowEvent>>;
  not?: Maybe<NestedEnumWorkflowEventWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowEvent>>;
};

export type EnumWorkflowSendingHoursFieldUpdateOperationsInput = {
  set?: Maybe<WorkflowSendingHours>;
};

export type EnumWorkflowSendingHoursFilter = {
  equals?: Maybe<WorkflowSendingHours>;
  in?: Maybe<Array<WorkflowSendingHours>>;
  not?: Maybe<NestedEnumWorkflowSendingHoursFilter>;
  notIn?: Maybe<Array<WorkflowSendingHours>>;
};

export type EnumWorkflowSendingHoursWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWorkflowSendingHoursFilter>;
  _min?: Maybe<NestedEnumWorkflowSendingHoursFilter>;
  equals?: Maybe<WorkflowSendingHours>;
  in?: Maybe<Array<WorkflowSendingHours>>;
  not?: Maybe<NestedEnumWorkflowSendingHoursWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowSendingHours>>;
};

export type EnumWorkflowTypeFieldUpdateOperationsInput = {
  set?: Maybe<WorkflowType>;
};

export type EnumWorkflowTypeFilter = {
  equals?: Maybe<WorkflowType>;
  in?: Maybe<Array<WorkflowType>>;
  not?: Maybe<NestedEnumWorkflowTypeFilter>;
  notIn?: Maybe<Array<WorkflowType>>;
};

export type EnumWorkflowTypeNullableFilter = {
  equals?: Maybe<WorkflowType>;
  in?: Maybe<Array<WorkflowType>>;
  not?: Maybe<NestedEnumWorkflowTypeNullableFilter>;
  notIn?: Maybe<Array<WorkflowType>>;
};

export type EnumWorkflowTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumWorkflowTypeNullableFilter>;
  _min?: Maybe<NestedEnumWorkflowTypeNullableFilter>;
  equals?: Maybe<WorkflowType>;
  in?: Maybe<Array<WorkflowType>>;
  not?: Maybe<NestedEnumWorkflowTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowType>>;
};

export type EnumWorkflowTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWorkflowTypeFilter>;
  _min?: Maybe<NestedEnumWorkflowTypeFilter>;
  equals?: Maybe<WorkflowType>;
  in?: Maybe<Array<WorkflowType>>;
  not?: Maybe<NestedEnumWorkflowTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowType>>;
};

export type EnumWorkflowVisitTypeFieldUpdateOperationsInput = {
  set?: Maybe<WorkflowVisitType>;
};

export type EnumWorkflowVisitTypeFilter = {
  equals?: Maybe<WorkflowVisitType>;
  in?: Maybe<Array<WorkflowVisitType>>;
  not?: Maybe<NestedEnumWorkflowVisitTypeFilter>;
  notIn?: Maybe<Array<WorkflowVisitType>>;
};

export type EnumWorkflowVisitTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWorkflowVisitTypeFilter>;
  _min?: Maybe<NestedEnumWorkflowVisitTypeFilter>;
  equals?: Maybe<WorkflowVisitType>;
  in?: Maybe<Array<WorkflowVisitType>>;
  not?: Maybe<NestedEnumWorkflowVisitTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowVisitType>>;
};

export type ExportCancellationSummaryAsPdfInput = {
  accountCredit?: Maybe<ItemInfo>;
  applyDiscounts: Scalars['Boolean'];
  balanceDue: Scalars['Float'];
  discount?: Maybe<ItemInfo>;
  exams?: Maybe<ItemInfo>;
  fees?: Maybe<ItemInfo>;
  hasAccountCredit: Scalars['Boolean'];
  hasDiscount: Scalars['Boolean'];
  hasPlanDiscount: Scalars['Boolean'];
  hasTeletriage: Scalars['Boolean'];
  includeFees: Scalars['Boolean'];
  includeManualAdjustment: Scalars['Boolean'];
  manualAdjustment?: Maybe<Scalars['Float']>;
  paymentsMade?: Maybe<PaymentsMade>;
  petName: Scalars['String'];
  plan: Scalars['String'];
  remainingMembershipBalance?: Maybe<PaymentsMade>;
  species: Scalars['String'];
  subtotal?: Maybe<ItemInfo>;
  teletriage?: Maybe<ItemInfo>;
  totalBenefitUsage: Scalars['Float'];
  totalSavings: Scalars['Float'];
};

export type ExportCancellationSummaryAsPdfResponse = {
  __typename?: 'ExportCancellationSummaryAsPdfResponse';
  base64PDF?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ExportItemizedInvoiceToReceiptPdfInput = {
  invoiceId: Scalars['String'];
};

export type ExportItemizedInvoiceToReceiptPdfResponse = {
  __typename?: 'ExportItemizedInvoiceToReceiptPDFResponse';
  base64PDF?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ExportNonItemizedReceiptAsPdfInput = {
  stripePaymentIntentId: Scalars['String'];
};

export type ExportNonItemizedReceiptAsPdfResponse = {
  __typename?: 'ExportNonItemizedReceiptAsPdfResponse';
  base64PDF?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type EzyVetIntegration = {
  __typename?: 'EzyVetIntegration';
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  createdAt: Scalars['DateTime'];
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type EzyVetIntegrationClinicPimsIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type EzyVetIntegrationCountAggregateOutputType = {
  __typename?: 'EzyVetIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  client_id: Scalars['Int'];
  client_secret: Scalars['Int'];
  createdAt: Scalars['Int'];
  defaultAppointmentTypeId: Scalars['Int'];
  id: Scalars['Int'];
  ownership_id: Scalars['Int'];
  scopes: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type EzyVetIntegrationCountOrderByAggregateInput = {
  client_id?: Maybe<SortOrder>;
  client_secret?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ownership_id?: Maybe<SortOrder>;
  scopes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EzyVetIntegrationCreateInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutEzyvetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationCreateManyInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<EzyVetIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<EzyVetIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<EzyVetIntegrationCreateWithoutClinicPimsIntegrationInput>;
};

export type EzyVetIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput = {
  create: EzyVetIntegrationCreateWithoutClinicPimsIntegrationInput;
  where: EzyVetIntegrationWhereUniqueInput;
};

export type EzyVetIntegrationCreateWithoutClinicPimsIntegrationInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationGroupByOutputType = {
  __typename?: 'EzyVetIntegrationGroupByOutputType';
  _count?: Maybe<EzyVetIntegrationCountAggregateOutputType>;
  _max?: Maybe<EzyVetIntegrationMaxAggregateOutputType>;
  _min?: Maybe<EzyVetIntegrationMinAggregateOutputType>;
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type EzyVetIntegrationMaxAggregateOutputType = {
  __typename?: 'EzyVetIntegrationMaxAggregateOutputType';
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationMaxOrderByAggregateInput = {
  client_id?: Maybe<SortOrder>;
  client_secret?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ownership_id?: Maybe<SortOrder>;
  scopes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EzyVetIntegrationMinAggregateOutputType = {
  __typename?: 'EzyVetIntegrationMinAggregateOutputType';
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationMinOrderByAggregateInput = {
  client_id?: Maybe<SortOrder>;
  client_secret?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ownership_id?: Maybe<SortOrder>;
  scopes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EzyVetIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<EzyVetIntegrationWhereInput>>;
  NOT?: Maybe<Array<EzyVetIntegrationWhereInput>>;
  OR?: Maybe<Array<EzyVetIntegrationWhereInput>>;
  client_id?: Maybe<StringNullableFilter>;
  client_secret?: Maybe<StringNullableFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultAppointmentTypeId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  ownership_id?: Maybe<StringNullableFilter>;
  scopes?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EzyVetIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EzyVetIntegrationOrderByRelevanceInput>;
  client_id?: Maybe<SortOrder>;
  client_secret?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ownership_id?: Maybe<SortOrder>;
  scopes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EzyVetIntegrationOrderByRelevanceFieldEnum {
  ClientId = 'client_id',
  ClientSecret = 'client_secret',
  DefaultAppointmentTypeId = 'defaultAppointmentTypeId',
  Id = 'id',
  OwnershipId = 'ownership_id',
  Scopes = 'scopes'
}

export type EzyVetIntegrationOrderByRelevanceInput = {
  fields: Array<EzyVetIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type EzyVetIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<EzyVetIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<EzyVetIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<EzyVetIntegrationMinOrderByAggregateInput>;
  client_id?: Maybe<SortOrder>;
  client_secret?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ownership_id?: Maybe<SortOrder>;
  scopes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EzyVetIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<EzyVetIntegrationOrderByRelevanceInput>;
  client_id?: Maybe<SortOrder>;
  client_secret?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ownership_id?: Maybe<SortOrder>;
  scopes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type EzyVetIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<EzyVetIntegrationOrderByRelevanceInput>;
  client_id?: Maybe<SortOrder>;
  client_secret?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ownership_id?: Maybe<SortOrder>;
  scopes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum EzyVetIntegrationScalarFieldEnum {
  ClientId = 'client_id',
  ClientSecret = 'client_secret',
  CreatedAt = 'createdAt',
  DefaultAppointmentTypeId = 'defaultAppointmentTypeId',
  Id = 'id',
  OwnershipId = 'ownership_id',
  Scopes = 'scopes',
  UpdatedAt = 'updatedAt'
}

export type EzyVetIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EzyVetIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EzyVetIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EzyVetIntegrationScalarWhereWithAggregatesInput>>;
  client_id?: Maybe<StringNullableWithAggregatesFilter>;
  client_secret?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  defaultAppointmentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  ownership_id?: Maybe<StringNullableWithAggregatesFilter>;
  scopes?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type EzyVetIntegrationUncheckedCreateInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedOneWithoutEzyvetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationUncheckedCreateWithoutClinicPimsIntegrationInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationUncheckedUpdateInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedUpdateOneWithoutEzyvetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationUncheckedUpdateManyInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationUncheckedUpdateWithoutClinicPimsIntegrationInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationUpdateInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutEzyvetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationUpdateManyMutationInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<EzyVetIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<EzyVetIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<EzyVetIntegrationCreateWithoutClinicPimsIntegrationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<EzyVetIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput>;
  upsert?: Maybe<EzyVetIntegrationUpsertWithoutClinicPimsIntegrationInput>;
};

export type EzyVetIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput = {
  data: EzyVetIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<EzyVetIntegrationWhereInput>;
};

export type EzyVetIntegrationUpdateWithoutClinicPimsIntegrationInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<Scalars['String']>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzyVetIntegrationUpsertWithoutClinicPimsIntegrationInput = {
  create: EzyVetIntegrationCreateWithoutClinicPimsIntegrationInput;
  update: EzyVetIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<EzyVetIntegrationWhereInput>;
};

export type EzyVetIntegrationWhereInput = {
  AND?: Maybe<Array<EzyVetIntegrationWhereInput>>;
  NOT?: Maybe<Array<EzyVetIntegrationWhereInput>>;
  OR?: Maybe<Array<EzyVetIntegrationWhereInput>>;
  client_id?: Maybe<StringNullableFilter>;
  client_secret?: Maybe<StringNullableFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultAppointmentTypeId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  ownership_id?: Maybe<StringNullableFilter>;
  scopes?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type EzyVetIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<EzyVetIntegrationWhereInput>>;
  NOT?: Maybe<Array<EzyVetIntegrationWhereInput>>;
  OR?: Maybe<Array<EzyVetIntegrationWhereInput>>;
  client_id?: Maybe<StringNullableFilter>;
  client_secret?: Maybe<StringNullableFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultAppointmentTypeId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  ownership_id?: Maybe<StringNullableFilter>;
  scopes?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  _count: FeatureFlagCountOutputType;
  clinics: Array<Clinic>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  emailCampaignTemplates: Array<EmailCampaignTemplate>;
  id: Scalars['String'];
  key: Scalars['String'];
  state: FeatureFlagState;
  type: FeatureFlagType;
  updatedAt: Scalars['DateTime'];
};


export type FeatureFlagClinicsArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type FeatureFlagEmailCampaignTemplatesArgs = {
  cursor?: Maybe<EmailCampaignTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignTemplateWhereInput>;
};

export type FeatureFlagCountAggregateOutputType = {
  __typename?: 'FeatureFlagCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  key: Scalars['Int'];
  state: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type FeatureFlagCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FeatureFlagCountOutputType = {
  __typename?: 'FeatureFlagCountOutputType';
  clinics: Scalars['Int'];
  emailCampaignTemplates: Scalars['Int'];
};

export type FeatureFlagCreateInput = {
  clinics?: Maybe<ClinicCreateNestedManyWithoutFeatureFlagsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutFeatureFlagsInput>;
  id?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  state?: Maybe<FeatureFlagState>;
  type: FeatureFlagType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  state?: Maybe<FeatureFlagState>;
  type: FeatureFlagType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagCreateNestedManyWithoutClinicsInput = {
  connect?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FeatureFlagCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<FeatureFlagCreateWithoutClinicsInput>>;
};

export type FeatureFlagCreateNestedManyWithoutEmailCampaignTemplatesInput = {
  connect?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FeatureFlagCreateOrConnectWithoutEmailCampaignTemplatesInput>>;
  create?: Maybe<Array<FeatureFlagCreateWithoutEmailCampaignTemplatesInput>>;
};

export type FeatureFlagCreateOrConnectWithoutClinicsInput = {
  create: FeatureFlagCreateWithoutClinicsInput;
  where: FeatureFlagWhereUniqueInput;
};

export type FeatureFlagCreateOrConnectWithoutEmailCampaignTemplatesInput = {
  create: FeatureFlagCreateWithoutEmailCampaignTemplatesInput;
  where: FeatureFlagWhereUniqueInput;
};

export type FeatureFlagCreateWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutFeatureFlagsInput>;
  id?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  state?: Maybe<FeatureFlagState>;
  type: FeatureFlagType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagCreateWithoutEmailCampaignTemplatesInput = {
  clinics?: Maybe<ClinicCreateNestedManyWithoutFeatureFlagsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  state?: Maybe<FeatureFlagState>;
  type: FeatureFlagType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagGroupByOutputType = {
  __typename?: 'FeatureFlagGroupByOutputType';
  _count?: Maybe<FeatureFlagCountAggregateOutputType>;
  _max?: Maybe<FeatureFlagMaxAggregateOutputType>;
  _min?: Maybe<FeatureFlagMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  key: Scalars['String'];
  state: FeatureFlagState;
  type: FeatureFlagType;
  updatedAt: Scalars['DateTime'];
};

export type FeatureFlagListRelationFilter = {
  every?: Maybe<FeatureFlagWhereInput>;
  none?: Maybe<FeatureFlagWhereInput>;
  some?: Maybe<FeatureFlagWhereInput>;
};

export type FeatureFlagMaxAggregateOutputType = {
  __typename?: 'FeatureFlagMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<FeatureFlagState>;
  type?: Maybe<FeatureFlagType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FeatureFlagMinAggregateOutputType = {
  __typename?: 'FeatureFlagMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<FeatureFlagState>;
  type?: Maybe<FeatureFlagType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FeatureFlagOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FeatureFlagOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<FeatureFlagOrderByRelevanceInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum FeatureFlagOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  Key = 'key'
}

export type FeatureFlagOrderByRelevanceInput = {
  fields: Array<FeatureFlagOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type FeatureFlagOrderByWithAggregationInput = {
  _count?: Maybe<FeatureFlagCountOrderByAggregateInput>;
  _max?: Maybe<FeatureFlagMaxOrderByAggregateInput>;
  _min?: Maybe<FeatureFlagMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FeatureFlagOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<FeatureFlagOrderByRelevanceInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FeatureFlagOrderByWithRelationInput = {
  _relevance?: Maybe<FeatureFlagOrderByRelevanceInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum FeatureFlagScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Key = 'key',
  State = 'state',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type FeatureFlagScalarWhereInput = {
  AND?: Maybe<Array<FeatureFlagScalarWhereInput>>;
  NOT?: Maybe<Array<FeatureFlagScalarWhereInput>>;
  OR?: Maybe<Array<FeatureFlagScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  key?: Maybe<StringFilter>;
  state?: Maybe<EnumFeatureFlagStateFilter>;
  type?: Maybe<EnumFeatureFlagTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FeatureFlagScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FeatureFlagScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FeatureFlagScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FeatureFlagScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  key?: Maybe<StringWithAggregatesFilter>;
  state?: Maybe<EnumFeatureFlagStateWithAggregatesFilter>;
  type?: Maybe<EnumFeatureFlagTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum FeatureFlagState {
  Off = 'Off',
  On = 'On'
}

export enum FeatureFlagType {
  Clinic = 'Clinic',
  Global = 'Global'
}

export type FeatureFlagUncheckedCreateInput = {
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutFeatureFlagsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutFeatureFlagsInput>;
  id?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  state?: Maybe<FeatureFlagState>;
  type: FeatureFlagType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUncheckedCreateNestedManyWithoutClinicsInput = {
  connect?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FeatureFlagCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<FeatureFlagCreateWithoutClinicsInput>>;
};

export type FeatureFlagUncheckedCreateNestedManyWithoutEmailCampaignTemplatesInput = {
  connect?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FeatureFlagCreateOrConnectWithoutEmailCampaignTemplatesInput>>;
  create?: Maybe<Array<FeatureFlagCreateWithoutEmailCampaignTemplatesInput>>;
};

export type FeatureFlagUncheckedCreateWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutFeatureFlagsInput>;
  id?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  state?: Maybe<FeatureFlagState>;
  type: FeatureFlagType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUncheckedCreateWithoutEmailCampaignTemplatesInput = {
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutFeatureFlagsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  state?: Maybe<FeatureFlagState>;
  type: FeatureFlagType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUncheckedUpdateInput = {
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutFeatureFlagsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutFeatureFlagsNestedInput>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<FeatureFlagState>;
  type?: Maybe<FeatureFlagType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<FeatureFlagState>;
  type?: Maybe<FeatureFlagType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUncheckedUpdateManyWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<FeatureFlagState>;
  type?: Maybe<FeatureFlagType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUncheckedUpdateManyWithoutClinicsNestedInput = {
  connect?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FeatureFlagCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<FeatureFlagCreateWithoutClinicsInput>>;
  delete?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FeatureFlagScalarWhereInput>>;
  disconnect?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  set?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  update?: Maybe<Array<FeatureFlagUpdateWithWhereUniqueWithoutClinicsInput>>;
  updateMany?: Maybe<Array<FeatureFlagUpdateManyWithWhereWithoutClinicsInput>>;
  upsert?: Maybe<Array<FeatureFlagUpsertWithWhereUniqueWithoutClinicsInput>>;
};

export type FeatureFlagUncheckedUpdateManyWithoutEmailCampaignTemplatesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<FeatureFlagState>;
  type?: Maybe<FeatureFlagType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUncheckedUpdateManyWithoutEmailCampaignTemplatesNestedInput = {
  connect?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FeatureFlagCreateOrConnectWithoutEmailCampaignTemplatesInput>>;
  create?: Maybe<Array<FeatureFlagCreateWithoutEmailCampaignTemplatesInput>>;
  delete?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FeatureFlagScalarWhereInput>>;
  disconnect?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  set?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  update?: Maybe<Array<FeatureFlagUpdateWithWhereUniqueWithoutEmailCampaignTemplatesInput>>;
  updateMany?: Maybe<Array<FeatureFlagUpdateManyWithWhereWithoutEmailCampaignTemplatesInput>>;
  upsert?: Maybe<Array<FeatureFlagUpsertWithWhereUniqueWithoutEmailCampaignTemplatesInput>>;
};

export type FeatureFlagUncheckedUpdateWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutFeatureFlagsNestedInput>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<FeatureFlagState>;
  type?: Maybe<FeatureFlagType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUncheckedUpdateWithoutEmailCampaignTemplatesInput = {
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutFeatureFlagsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<FeatureFlagState>;
  type?: Maybe<FeatureFlagType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUpdateInput = {
  clinics?: Maybe<ClinicUpdateManyWithoutFeatureFlagsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateUpdateManyWithoutFeatureFlagsNestedInput>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<FeatureFlagState>;
  type?: Maybe<FeatureFlagType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<FeatureFlagState>;
  type?: Maybe<FeatureFlagType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUpdateManyWithWhereWithoutClinicsInput = {
  data: FeatureFlagUpdateManyMutationInput;
  where: FeatureFlagScalarWhereInput;
};

export type FeatureFlagUpdateManyWithWhereWithoutEmailCampaignTemplatesInput = {
  data: FeatureFlagUpdateManyMutationInput;
  where: FeatureFlagScalarWhereInput;
};

export type FeatureFlagUpdateManyWithoutClinicsNestedInput = {
  connect?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FeatureFlagCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<FeatureFlagCreateWithoutClinicsInput>>;
  delete?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FeatureFlagScalarWhereInput>>;
  disconnect?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  set?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  update?: Maybe<Array<FeatureFlagUpdateWithWhereUniqueWithoutClinicsInput>>;
  updateMany?: Maybe<Array<FeatureFlagUpdateManyWithWhereWithoutClinicsInput>>;
  upsert?: Maybe<Array<FeatureFlagUpsertWithWhereUniqueWithoutClinicsInput>>;
};

export type FeatureFlagUpdateManyWithoutEmailCampaignTemplatesNestedInput = {
  connect?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FeatureFlagCreateOrConnectWithoutEmailCampaignTemplatesInput>>;
  create?: Maybe<Array<FeatureFlagCreateWithoutEmailCampaignTemplatesInput>>;
  delete?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FeatureFlagScalarWhereInput>>;
  disconnect?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  set?: Maybe<Array<FeatureFlagWhereUniqueInput>>;
  update?: Maybe<Array<FeatureFlagUpdateWithWhereUniqueWithoutEmailCampaignTemplatesInput>>;
  updateMany?: Maybe<Array<FeatureFlagUpdateManyWithWhereWithoutEmailCampaignTemplatesInput>>;
  upsert?: Maybe<Array<FeatureFlagUpsertWithWhereUniqueWithoutEmailCampaignTemplatesInput>>;
};

export type FeatureFlagUpdateWithWhereUniqueWithoutClinicsInput = {
  data: FeatureFlagUpdateWithoutClinicsInput;
  where: FeatureFlagWhereUniqueInput;
};

export type FeatureFlagUpdateWithWhereUniqueWithoutEmailCampaignTemplatesInput = {
  data: FeatureFlagUpdateWithoutEmailCampaignTemplatesInput;
  where: FeatureFlagWhereUniqueInput;
};

export type FeatureFlagUpdateWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateUpdateManyWithoutFeatureFlagsNestedInput>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<FeatureFlagState>;
  type?: Maybe<FeatureFlagType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUpdateWithoutEmailCampaignTemplatesInput = {
  clinics?: Maybe<ClinicUpdateManyWithoutFeatureFlagsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<FeatureFlagState>;
  type?: Maybe<FeatureFlagType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureFlagUpsertWithWhereUniqueWithoutClinicsInput = {
  create: FeatureFlagCreateWithoutClinicsInput;
  update: FeatureFlagUpdateWithoutClinicsInput;
  where: FeatureFlagWhereUniqueInput;
};

export type FeatureFlagUpsertWithWhereUniqueWithoutEmailCampaignTemplatesInput = {
  create: FeatureFlagCreateWithoutEmailCampaignTemplatesInput;
  update: FeatureFlagUpdateWithoutEmailCampaignTemplatesInput;
  where: FeatureFlagWhereUniqueInput;
};

export type FeatureFlagWhereInput = {
  AND?: Maybe<Array<FeatureFlagWhereInput>>;
  NOT?: Maybe<Array<FeatureFlagWhereInput>>;
  OR?: Maybe<Array<FeatureFlagWhereInput>>;
  clinics?: Maybe<ClinicListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateListRelationFilter>;
  id?: Maybe<StringFilter>;
  key?: Maybe<StringFilter>;
  state?: Maybe<EnumFeatureFlagStateFilter>;
  type?: Maybe<EnumFeatureFlagTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FeatureFlagWhereUniqueInput = {
  AND?: Maybe<Array<FeatureFlagWhereInput>>;
  NOT?: Maybe<Array<FeatureFlagWhereInput>>;
  OR?: Maybe<Array<FeatureFlagWhereInput>>;
  clinics?: Maybe<ClinicListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  emailCampaignTemplates?: Maybe<EmailCampaignTemplateListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  state?: Maybe<EnumFeatureFlagStateFilter>;
  type?: Maybe<EnumFeatureFlagTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum FeeCollection {
  DuringPayment = 'DuringPayment',
  PostPaid = 'PostPaid'
}

export type FileExportData = {
  __typename?: 'FileExportData';
  base64Encoding: Scalars['String'];
  fileType: Scalars['String'];
};

export enum FilterSelectionType {
  Private = 'Private',
  PublicReadonly = 'PublicReadonly'
}

export type FinancialAdjustment = {
  __typename?: 'FinancialAdjustment';
  amount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  financialTransaction?: Maybe<FinancialTransaction>;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type FinancialAdjustmentFinancialTransactionArgs = {
  where?: Maybe<FinancialTransactionWhereInput>;
};

export type FinancialAdjustmentAvgAggregateOutputType = {
  __typename?: 'FinancialAdjustmentAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
};

export type FinancialAdjustmentAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type FinancialAdjustmentCountAggregateOutputType = {
  __typename?: 'FinancialAdjustmentCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type FinancialAdjustmentCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialAdjustmentCreateInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutAdjustmentInput>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentCreateManyInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentCreateNestedOneWithoutFinancialTransactionInput = {
  connect?: Maybe<FinancialAdjustmentWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialAdjustmentCreateOrConnectWithoutFinancialTransactionInput>;
  create?: Maybe<FinancialAdjustmentCreateWithoutFinancialTransactionInput>;
};

export type FinancialAdjustmentCreateOrConnectWithoutFinancialTransactionInput = {
  create: FinancialAdjustmentCreateWithoutFinancialTransactionInput;
  where: FinancialAdjustmentWhereUniqueInput;
};

export type FinancialAdjustmentCreateWithoutFinancialTransactionInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentGroupByOutputType = {
  __typename?: 'FinancialAdjustmentGroupByOutputType';
  _avg?: Maybe<FinancialAdjustmentAvgAggregateOutputType>;
  _count?: Maybe<FinancialAdjustmentCountAggregateOutputType>;
  _max?: Maybe<FinancialAdjustmentMaxAggregateOutputType>;
  _min?: Maybe<FinancialAdjustmentMinAggregateOutputType>;
  _sum?: Maybe<FinancialAdjustmentSumAggregateOutputType>;
  amount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type FinancialAdjustmentMaxAggregateOutputType = {
  __typename?: 'FinancialAdjustmentMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialAdjustmentMinAggregateOutputType = {
  __typename?: 'FinancialAdjustmentMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialAdjustmentNullableScalarRelationFilter = {
  AND?: Maybe<Array<FinancialAdjustmentWhereInput>>;
  NOT?: Maybe<Array<FinancialAdjustmentWhereInput>>;
  OR?: Maybe<Array<FinancialAdjustmentWhereInput>>;
  amount?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FinancialAdjustmentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<FinancialAdjustmentOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum FinancialAdjustmentOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type FinancialAdjustmentOrderByRelevanceInput = {
  fields: Array<FinancialAdjustmentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type FinancialAdjustmentOrderByWithAggregationInput = {
  _avg?: Maybe<FinancialAdjustmentAvgOrderByAggregateInput>;
  _count?: Maybe<FinancialAdjustmentCountOrderByAggregateInput>;
  _max?: Maybe<FinancialAdjustmentMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialAdjustmentMinOrderByAggregateInput>;
  _sum?: Maybe<FinancialAdjustmentSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialAdjustmentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<FinancialAdjustmentOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialAdjustmentOrderByWithRelationInput = {
  _relevance?: Maybe<FinancialAdjustmentOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum FinancialAdjustmentScalarFieldEnum {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type FinancialAdjustmentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialAdjustmentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialAdjustmentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialAdjustmentScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type FinancialAdjustmentSumAggregateOutputType = {
  __typename?: 'FinancialAdjustmentSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
};

export type FinancialAdjustmentSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type FinancialAdjustmentUncheckedCreateInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutAdjustmentInput>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentUncheckedCreateWithoutFinancialTransactionInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutAdjustmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentUncheckedUpdateWithoutFinancialTransactionInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutAdjustmentNestedInput>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentUpdateOneWithoutFinancialTransactionNestedInput = {
  connect?: Maybe<FinancialAdjustmentWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialAdjustmentCreateOrConnectWithoutFinancialTransactionInput>;
  create?: Maybe<FinancialAdjustmentCreateWithoutFinancialTransactionInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FinancialAdjustmentUpdateToOneWithWhereWithoutFinancialTransactionInput>;
  upsert?: Maybe<FinancialAdjustmentUpsertWithoutFinancialTransactionInput>;
};

export type FinancialAdjustmentUpdateToOneWithWhereWithoutFinancialTransactionInput = {
  data: FinancialAdjustmentUpdateWithoutFinancialTransactionInput;
  where?: Maybe<FinancialAdjustmentWhereInput>;
};

export type FinancialAdjustmentUpdateWithoutFinancialTransactionInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialAdjustmentUpsertWithoutFinancialTransactionInput = {
  create: FinancialAdjustmentCreateWithoutFinancialTransactionInput;
  update: FinancialAdjustmentUpdateWithoutFinancialTransactionInput;
  where?: Maybe<FinancialAdjustmentWhereInput>;
};

export type FinancialAdjustmentWhereInput = {
  AND?: Maybe<Array<FinancialAdjustmentWhereInput>>;
  NOT?: Maybe<Array<FinancialAdjustmentWhereInput>>;
  OR?: Maybe<Array<FinancialAdjustmentWhereInput>>;
  amount?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FinancialAdjustmentWhereUniqueInput = {
  AND?: Maybe<Array<FinancialAdjustmentWhereInput>>;
  NOT?: Maybe<Array<FinancialAdjustmentWhereInput>>;
  OR?: Maybe<Array<FinancialAdjustmentWhereInput>>;
  amount?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FinancialTransaction = {
  __typename?: 'FinancialTransaction';
  adjustment?: Maybe<FinancialAdjustment>;
  adjustmentId?: Maybe<Scalars['String']>;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  stripeDispute?: Maybe<StripeDispute>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoice>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntent>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayout?: Maybe<StripePayout>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefund?: Maybe<StripeRefund>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt: Scalars['DateTime'];
};


export type FinancialTransactionAdjustmentArgs = {
  where?: Maybe<FinancialAdjustmentWhereInput>;
};


export type FinancialTransactionChannelArgs = {
  where?: Maybe<ChannelWhereInput>;
};


export type FinancialTransactionStripeDisputeArgs = {
  where?: Maybe<StripeDisputeWhereInput>;
};


export type FinancialTransactionStripeInvoiceArgs = {
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type FinancialTransactionStripePaymentIntentArgs = {
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type FinancialTransactionStripePayoutArgs = {
  where?: Maybe<StripePayoutWhereInput>;
};


export type FinancialTransactionStripeRefundArgs = {
  where?: Maybe<StripeRefundWhereInput>;
};

export type FinancialTransactionCountAggregateOutputType = {
  __typename?: 'FinancialTransactionCountAggregateOutputType';
  _all: Scalars['Int'];
  adjustmentId: Scalars['Int'];
  channelId: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  stripeDisputeId: Scalars['Int'];
  stripeInvoiceId: Scalars['Int'];
  stripePaymentIntentId: Scalars['Int'];
  stripePayoutId: Scalars['Int'];
  stripeRefundId: Scalars['Int'];
  timestamp: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type FinancialTransactionCountOrderByAggregateInput = {
  adjustmentId?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialTransactionCreateInput = {
  adjustment?: Maybe<FinancialAdjustmentCreateNestedOneWithoutFinancialTransactionInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutFinancialTransactionsInput>;
  clinic: ClinicCreateNestedOneWithoutFinancialTransactionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutFinancialTransactionInput>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutFinancialTransactionInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutFinancialTransactionInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutFinancialTransactionsInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutFinancialTransactionInput>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionCreateManyChannelInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionCreateManyChannelInputEnvelope = {
  data: Array<FinancialTransactionCreateManyChannelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialTransactionCreateManyClinicInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionCreateManyClinicInputEnvelope = {
  data: Array<FinancialTransactionCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialTransactionCreateManyInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionCreateManyStripePayoutInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionCreateManyStripePayoutInputEnvelope = {
  data: Array<FinancialTransactionCreateManyStripePayoutInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialTransactionCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTransactionCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<FinancialTransactionCreateWithoutChannelInput>>;
  createMany?: Maybe<FinancialTransactionCreateManyChannelInputEnvelope>;
};

export type FinancialTransactionCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTransactionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<FinancialTransactionCreateWithoutClinicInput>>;
  createMany?: Maybe<FinancialTransactionCreateManyClinicInputEnvelope>;
};

export type FinancialTransactionCreateNestedManyWithoutStripePayoutInput = {
  connect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTransactionCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<FinancialTransactionCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<FinancialTransactionCreateManyStripePayoutInputEnvelope>;
};

export type FinancialTransactionCreateNestedOneWithoutAdjustmentInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutAdjustmentInput>;
  create?: Maybe<FinancialTransactionCreateWithoutAdjustmentInput>;
};

export type FinancialTransactionCreateNestedOneWithoutStripeDisputeInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripeDisputeInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripeDisputeInput>;
};

export type FinancialTransactionCreateNestedOneWithoutStripeInvoiceInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripeInvoiceInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripeInvoiceInput>;
};

export type FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripePaymentIntentInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripePaymentIntentInput>;
};

export type FinancialTransactionCreateNestedOneWithoutStripeRefundInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripeRefundInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripeRefundInput>;
};

export type FinancialTransactionCreateOrConnectWithoutAdjustmentInput = {
  create: FinancialTransactionCreateWithoutAdjustmentInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionCreateOrConnectWithoutChannelInput = {
  create: FinancialTransactionCreateWithoutChannelInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionCreateOrConnectWithoutClinicInput = {
  create: FinancialTransactionCreateWithoutClinicInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionCreateOrConnectWithoutStripeDisputeInput = {
  create: FinancialTransactionCreateWithoutStripeDisputeInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionCreateOrConnectWithoutStripeInvoiceInput = {
  create: FinancialTransactionCreateWithoutStripeInvoiceInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionCreateOrConnectWithoutStripePaymentIntentInput = {
  create: FinancialTransactionCreateWithoutStripePaymentIntentInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionCreateOrConnectWithoutStripePayoutInput = {
  create: FinancialTransactionCreateWithoutStripePayoutInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionCreateOrConnectWithoutStripeRefundInput = {
  create: FinancialTransactionCreateWithoutStripeRefundInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionCreateWithoutAdjustmentInput = {
  channel?: Maybe<ChannelCreateNestedOneWithoutFinancialTransactionsInput>;
  clinic: ClinicCreateNestedOneWithoutFinancialTransactionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutFinancialTransactionInput>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutFinancialTransactionInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutFinancialTransactionInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutFinancialTransactionsInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutFinancialTransactionInput>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionCreateWithoutChannelInput = {
  adjustment?: Maybe<FinancialAdjustmentCreateNestedOneWithoutFinancialTransactionInput>;
  clinic: ClinicCreateNestedOneWithoutFinancialTransactionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutFinancialTransactionInput>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutFinancialTransactionInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutFinancialTransactionInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutFinancialTransactionsInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutFinancialTransactionInput>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionCreateWithoutClinicInput = {
  adjustment?: Maybe<FinancialAdjustmentCreateNestedOneWithoutFinancialTransactionInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutFinancialTransactionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutFinancialTransactionInput>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutFinancialTransactionInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutFinancialTransactionInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutFinancialTransactionsInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutFinancialTransactionInput>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionCreateWithoutStripeDisputeInput = {
  adjustment?: Maybe<FinancialAdjustmentCreateNestedOneWithoutFinancialTransactionInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutFinancialTransactionsInput>;
  clinic: ClinicCreateNestedOneWithoutFinancialTransactionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutFinancialTransactionInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutFinancialTransactionInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutFinancialTransactionsInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutFinancialTransactionInput>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionCreateWithoutStripeInvoiceInput = {
  adjustment?: Maybe<FinancialAdjustmentCreateNestedOneWithoutFinancialTransactionInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutFinancialTransactionsInput>;
  clinic: ClinicCreateNestedOneWithoutFinancialTransactionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutFinancialTransactionInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutFinancialTransactionInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutFinancialTransactionsInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutFinancialTransactionInput>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionCreateWithoutStripePaymentIntentInput = {
  adjustment?: Maybe<FinancialAdjustmentCreateNestedOneWithoutFinancialTransactionInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutFinancialTransactionsInput>;
  clinic: ClinicCreateNestedOneWithoutFinancialTransactionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutFinancialTransactionInput>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutFinancialTransactionInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutFinancialTransactionsInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutFinancialTransactionInput>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionCreateWithoutStripePayoutInput = {
  adjustment?: Maybe<FinancialAdjustmentCreateNestedOneWithoutFinancialTransactionInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutFinancialTransactionsInput>;
  clinic: ClinicCreateNestedOneWithoutFinancialTransactionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutFinancialTransactionInput>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutFinancialTransactionInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutFinancialTransactionInput>;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutFinancialTransactionInput>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionCreateWithoutStripeRefundInput = {
  adjustment?: Maybe<FinancialAdjustmentCreateNestedOneWithoutFinancialTransactionInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutFinancialTransactionsInput>;
  clinic: ClinicCreateNestedOneWithoutFinancialTransactionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeCreateNestedOneWithoutFinancialTransactionInput>;
  stripeInvoice?: Maybe<StripeInvoiceCreateNestedOneWithoutFinancialTransactionInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutFinancialTransactionInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutFinancialTransactionsInput>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionGroupByOutputType = {
  __typename?: 'FinancialTransactionGroupByOutputType';
  _count?: Maybe<FinancialTransactionCountAggregateOutputType>;
  _max?: Maybe<FinancialTransactionMaxAggregateOutputType>;
  _min?: Maybe<FinancialTransactionMinAggregateOutputType>;
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt: Scalars['DateTime'];
};

export type FinancialTransactionListRelationFilter = {
  every?: Maybe<FinancialTransactionWhereInput>;
  none?: Maybe<FinancialTransactionWhereInput>;
  some?: Maybe<FinancialTransactionWhereInput>;
};

export type FinancialTransactionMaxAggregateOutputType = {
  __typename?: 'FinancialTransactionMaxAggregateOutputType';
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionMaxOrderByAggregateInput = {
  adjustmentId?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialTransactionMinAggregateOutputType = {
  __typename?: 'FinancialTransactionMinAggregateOutputType';
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionMinOrderByAggregateInput = {
  adjustmentId?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialTransactionNullableScalarRelationFilter = {
  AND?: Maybe<Array<FinancialTransactionWhereInput>>;
  NOT?: Maybe<Array<FinancialTransactionWhereInput>>;
  OR?: Maybe<Array<FinancialTransactionWhereInput>>;
  adjustment?: Maybe<FinancialAdjustmentNullableScalarRelationFilter>;
  adjustmentId?: Maybe<StringNullableFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  stripeDispute?: Maybe<StripeDisputeNullableScalarRelationFilter>;
  stripeDisputeId?: Maybe<StringNullableFilter>;
  stripeInvoice?: Maybe<StripeInvoiceNullableScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripePaymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeRefund?: Maybe<StripeRefundNullableScalarRelationFilter>;
  stripeRefundId?: Maybe<StringNullableFilter>;
  timestamp?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumFinancialTransactionTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FinancialTransactionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FinancialTransactionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<FinancialTransactionOrderByRelevanceInput>;
  adjustment?: Maybe<FinancialAdjustmentOrderByWithRelationInput>;
  adjustmentId?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeDispute?: Maybe<StripeDisputeOrderByWithRelationInput>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeRefund?: Maybe<StripeRefundOrderByWithRelationInput>;
  stripeRefundId?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum FinancialTransactionOrderByRelevanceFieldEnum {
  AdjustmentId = 'adjustmentId',
  ChannelId = 'channelId',
  ClinicId = 'clinicId',
  Id = 'id',
  StripeDisputeId = 'stripeDisputeId',
  StripeInvoiceId = 'stripeInvoiceId',
  StripePaymentIntentId = 'stripePaymentIntentId',
  StripePayoutId = 'stripePayoutId',
  StripeRefundId = 'stripeRefundId'
}

export type FinancialTransactionOrderByRelevanceInput = {
  fields: Array<FinancialTransactionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type FinancialTransactionOrderByWithAggregationInput = {
  _count?: Maybe<FinancialTransactionCountOrderByAggregateInput>;
  _max?: Maybe<FinancialTransactionMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialTransactionMinOrderByAggregateInput>;
  adjustmentId?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialTransactionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<FinancialTransactionOrderByRelevanceInput>;
  adjustment?: Maybe<FinancialAdjustmentOrderByWithRelationInput>;
  adjustmentId?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeDispute?: Maybe<StripeDisputeOrderByWithRelationInput>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeRefund?: Maybe<StripeRefundOrderByWithRelationInput>;
  stripeRefundId?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialTransactionOrderByWithRelationInput = {
  _relevance?: Maybe<FinancialTransactionOrderByRelevanceInput>;
  adjustment?: Maybe<FinancialAdjustmentOrderByWithRelationInput>;
  adjustmentId?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeDispute?: Maybe<StripeDisputeOrderByWithRelationInput>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeRefund?: Maybe<StripeRefundOrderByWithRelationInput>;
  stripeRefundId?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum FinancialTransactionScalarFieldEnum {
  AdjustmentId = 'adjustmentId',
  ChannelId = 'channelId',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  StripeDisputeId = 'stripeDisputeId',
  StripeInvoiceId = 'stripeInvoiceId',
  StripePaymentIntentId = 'stripePaymentIntentId',
  StripePayoutId = 'stripePayoutId',
  StripeRefundId = 'stripeRefundId',
  Timestamp = 'timestamp',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type FinancialTransactionScalarWhereInput = {
  AND?: Maybe<Array<FinancialTransactionScalarWhereInput>>;
  NOT?: Maybe<Array<FinancialTransactionScalarWhereInput>>;
  OR?: Maybe<Array<FinancialTransactionScalarWhereInput>>;
  adjustmentId?: Maybe<StringNullableFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  stripeDisputeId?: Maybe<StringNullableFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeRefundId?: Maybe<StringNullableFilter>;
  timestamp?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumFinancialTransactionTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FinancialTransactionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialTransactionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialTransactionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialTransactionScalarWhereWithAggregatesInput>>;
  adjustmentId?: Maybe<StringNullableWithAggregatesFilter>;
  channelId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  stripeDisputeId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeInvoiceId?: Maybe<StringNullableWithAggregatesFilter>;
  stripePaymentIntentId?: Maybe<StringNullableWithAggregatesFilter>;
  stripePayoutId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeRefundId?: Maybe<StringNullableWithAggregatesFilter>;
  timestamp?: Maybe<DateTimeWithAggregatesFilter>;
  type?: Maybe<EnumFinancialTransactionTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum FinancialTransactionType {
  Adjustment = 'Adjustment',
  DirectBookingDeposit = 'DirectBookingDeposit',
  Dispute = 'Dispute',
  Refund = 'Refund',
  Sale = 'Sale',
  Subscription = 'Subscription',
  SubscriptionRefund = 'SubscriptionRefund'
}

export type FinancialTransactionUncheckedCreateInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTransactionCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<FinancialTransactionCreateWithoutChannelInput>>;
  createMany?: Maybe<FinancialTransactionCreateManyChannelInputEnvelope>;
};

export type FinancialTransactionUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTransactionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<FinancialTransactionCreateWithoutClinicInput>>;
  createMany?: Maybe<FinancialTransactionCreateManyClinicInputEnvelope>;
};

export type FinancialTransactionUncheckedCreateNestedManyWithoutStripePayoutInput = {
  connect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTransactionCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<FinancialTransactionCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<FinancialTransactionCreateManyStripePayoutInputEnvelope>;
};

export type FinancialTransactionUncheckedCreateNestedOneWithoutAdjustmentInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutAdjustmentInput>;
  create?: Maybe<FinancialTransactionCreateWithoutAdjustmentInput>;
};

export type FinancialTransactionUncheckedCreateNestedOneWithoutStripeDisputeInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripeDisputeInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripeDisputeInput>;
};

export type FinancialTransactionUncheckedCreateNestedOneWithoutStripeInvoiceInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripeInvoiceInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripeInvoiceInput>;
};

export type FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripePaymentIntentInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripePaymentIntentInput>;
};

export type FinancialTransactionUncheckedCreateNestedOneWithoutStripeRefundInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripeRefundInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripeRefundInput>;
};

export type FinancialTransactionUncheckedCreateWithoutAdjustmentInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedCreateWithoutChannelInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedCreateWithoutClinicInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedCreateWithoutStripeDisputeInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedCreateWithoutStripeInvoiceInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedCreateWithoutStripePaymentIntentInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedCreateWithoutStripePayoutInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedCreateWithoutStripeRefundInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: FinancialTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateManyInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateManyWithoutChannelInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTransactionCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<FinancialTransactionCreateWithoutChannelInput>>;
  createMany?: Maybe<FinancialTransactionCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialTransactionScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  set?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  update?: Maybe<Array<FinancialTransactionUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<FinancialTransactionUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<FinancialTransactionUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type FinancialTransactionUncheckedUpdateManyWithoutClinicInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTransactionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<FinancialTransactionCreateWithoutClinicInput>>;
  createMany?: Maybe<FinancialTransactionCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialTransactionScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  set?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  update?: Maybe<Array<FinancialTransactionUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<FinancialTransactionUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<FinancialTransactionUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type FinancialTransactionUncheckedUpdateManyWithoutStripePayoutInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateManyWithoutStripePayoutNestedInput = {
  connect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTransactionCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<FinancialTransactionCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<FinancialTransactionCreateManyStripePayoutInputEnvelope>;
  delete?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialTransactionScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  set?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  update?: Maybe<Array<FinancialTransactionUpdateWithWhereUniqueWithoutStripePayoutInput>>;
  updateMany?: Maybe<Array<FinancialTransactionUpdateManyWithWhereWithoutStripePayoutInput>>;
  upsert?: Maybe<Array<FinancialTransactionUpsertWithWhereUniqueWithoutStripePayoutInput>>;
};

export type FinancialTransactionUncheckedUpdateOneWithoutAdjustmentNestedInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutAdjustmentInput>;
  create?: Maybe<FinancialTransactionCreateWithoutAdjustmentInput>;
  delete?: Maybe<FinancialTransactionWhereInput>;
  disconnect?: Maybe<FinancialTransactionWhereInput>;
  update?: Maybe<FinancialTransactionUpdateToOneWithWhereWithoutAdjustmentInput>;
  upsert?: Maybe<FinancialTransactionUpsertWithoutAdjustmentInput>;
};

export type FinancialTransactionUncheckedUpdateOneWithoutStripeDisputeNestedInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripeDisputeInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripeDisputeInput>;
  delete?: Maybe<FinancialTransactionWhereInput>;
  disconnect?: Maybe<FinancialTransactionWhereInput>;
  update?: Maybe<FinancialTransactionUpdateToOneWithWhereWithoutStripeDisputeInput>;
  upsert?: Maybe<FinancialTransactionUpsertWithoutStripeDisputeInput>;
};

export type FinancialTransactionUncheckedUpdateOneWithoutStripeInvoiceNestedInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripeInvoiceInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripeInvoiceInput>;
  delete?: Maybe<FinancialTransactionWhereInput>;
  disconnect?: Maybe<FinancialTransactionWhereInput>;
  update?: Maybe<FinancialTransactionUpdateToOneWithWhereWithoutStripeInvoiceInput>;
  upsert?: Maybe<FinancialTransactionUpsertWithoutStripeInvoiceInput>;
};

export type FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripePaymentIntentInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripePaymentIntentInput>;
  delete?: Maybe<FinancialTransactionWhereInput>;
  disconnect?: Maybe<FinancialTransactionWhereInput>;
  update?: Maybe<FinancialTransactionUpdateToOneWithWhereWithoutStripePaymentIntentInput>;
  upsert?: Maybe<FinancialTransactionUpsertWithoutStripePaymentIntentInput>;
};

export type FinancialTransactionUncheckedUpdateOneWithoutStripeRefundNestedInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripeRefundInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripeRefundInput>;
  delete?: Maybe<FinancialTransactionWhereInput>;
  disconnect?: Maybe<FinancialTransactionWhereInput>;
  update?: Maybe<FinancialTransactionUpdateToOneWithWhereWithoutStripeRefundInput>;
  upsert?: Maybe<FinancialTransactionUpsertWithoutStripeRefundInput>;
};

export type FinancialTransactionUncheckedUpdateWithoutAdjustmentInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateWithoutChannelInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateWithoutClinicInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateWithoutStripeDisputeInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateWithoutStripeInvoiceInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateWithoutStripePaymentIntentInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateWithoutStripePayoutInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUncheckedUpdateWithoutStripeRefundInput = {
  adjustmentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUpdateInput = {
  adjustment?: Maybe<FinancialAdjustmentUpdateOneWithoutFinancialTransactionNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutFinancialTransactionsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutFinancialTransactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutFinancialTransactionNestedInput>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutFinancialTransactionsNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutFinancialTransactionNestedInput>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUpdateManyWithWhereWithoutChannelInput = {
  data: FinancialTransactionUpdateManyMutationInput;
  where: FinancialTransactionScalarWhereInput;
};

export type FinancialTransactionUpdateManyWithWhereWithoutClinicInput = {
  data: FinancialTransactionUpdateManyMutationInput;
  where: FinancialTransactionScalarWhereInput;
};

export type FinancialTransactionUpdateManyWithWhereWithoutStripePayoutInput = {
  data: FinancialTransactionUpdateManyMutationInput;
  where: FinancialTransactionScalarWhereInput;
};

export type FinancialTransactionUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTransactionCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<FinancialTransactionCreateWithoutChannelInput>>;
  createMany?: Maybe<FinancialTransactionCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialTransactionScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  set?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  update?: Maybe<Array<FinancialTransactionUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<FinancialTransactionUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<FinancialTransactionUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type FinancialTransactionUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTransactionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<FinancialTransactionCreateWithoutClinicInput>>;
  createMany?: Maybe<FinancialTransactionCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialTransactionScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  set?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  update?: Maybe<Array<FinancialTransactionUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<FinancialTransactionUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<FinancialTransactionUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type FinancialTransactionUpdateManyWithoutStripePayoutNestedInput = {
  connect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTransactionCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<FinancialTransactionCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<FinancialTransactionCreateManyStripePayoutInputEnvelope>;
  delete?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialTransactionScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  set?: Maybe<Array<FinancialTransactionWhereUniqueInput>>;
  update?: Maybe<Array<FinancialTransactionUpdateWithWhereUniqueWithoutStripePayoutInput>>;
  updateMany?: Maybe<Array<FinancialTransactionUpdateManyWithWhereWithoutStripePayoutInput>>;
  upsert?: Maybe<Array<FinancialTransactionUpsertWithWhereUniqueWithoutStripePayoutInput>>;
};

export type FinancialTransactionUpdateOneWithoutAdjustmentNestedInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutAdjustmentInput>;
  create?: Maybe<FinancialTransactionCreateWithoutAdjustmentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FinancialTransactionUpdateToOneWithWhereWithoutAdjustmentInput>;
  upsert?: Maybe<FinancialTransactionUpsertWithoutAdjustmentInput>;
};

export type FinancialTransactionUpdateOneWithoutStripeDisputeNestedInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripeDisputeInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripeDisputeInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FinancialTransactionUpdateToOneWithWhereWithoutStripeDisputeInput>;
  upsert?: Maybe<FinancialTransactionUpsertWithoutStripeDisputeInput>;
};

export type FinancialTransactionUpdateOneWithoutStripeInvoiceNestedInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripeInvoiceInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripeInvoiceInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FinancialTransactionUpdateToOneWithWhereWithoutStripeInvoiceInput>;
  upsert?: Maybe<FinancialTransactionUpsertWithoutStripeInvoiceInput>;
};

export type FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripePaymentIntentInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripePaymentIntentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FinancialTransactionUpdateToOneWithWhereWithoutStripePaymentIntentInput>;
  upsert?: Maybe<FinancialTransactionUpsertWithoutStripePaymentIntentInput>;
};

export type FinancialTransactionUpdateOneWithoutStripeRefundNestedInput = {
  connect?: Maybe<FinancialTransactionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTransactionCreateOrConnectWithoutStripeRefundInput>;
  create?: Maybe<FinancialTransactionCreateWithoutStripeRefundInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FinancialTransactionUpdateToOneWithWhereWithoutStripeRefundInput>;
  upsert?: Maybe<FinancialTransactionUpsertWithoutStripeRefundInput>;
};

export type FinancialTransactionUpdateToOneWithWhereWithoutAdjustmentInput = {
  data: FinancialTransactionUpdateWithoutAdjustmentInput;
  where?: Maybe<FinancialTransactionWhereInput>;
};

export type FinancialTransactionUpdateToOneWithWhereWithoutStripeDisputeInput = {
  data: FinancialTransactionUpdateWithoutStripeDisputeInput;
  where?: Maybe<FinancialTransactionWhereInput>;
};

export type FinancialTransactionUpdateToOneWithWhereWithoutStripeInvoiceInput = {
  data: FinancialTransactionUpdateWithoutStripeInvoiceInput;
  where?: Maybe<FinancialTransactionWhereInput>;
};

export type FinancialTransactionUpdateToOneWithWhereWithoutStripePaymentIntentInput = {
  data: FinancialTransactionUpdateWithoutStripePaymentIntentInput;
  where?: Maybe<FinancialTransactionWhereInput>;
};

export type FinancialTransactionUpdateToOneWithWhereWithoutStripeRefundInput = {
  data: FinancialTransactionUpdateWithoutStripeRefundInput;
  where?: Maybe<FinancialTransactionWhereInput>;
};

export type FinancialTransactionUpdateWithWhereUniqueWithoutChannelInput = {
  data: FinancialTransactionUpdateWithoutChannelInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionUpdateWithWhereUniqueWithoutClinicInput = {
  data: FinancialTransactionUpdateWithoutClinicInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionUpdateWithWhereUniqueWithoutStripePayoutInput = {
  data: FinancialTransactionUpdateWithoutStripePayoutInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionUpdateWithoutAdjustmentInput = {
  channel?: Maybe<ChannelUpdateOneWithoutFinancialTransactionsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutFinancialTransactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutFinancialTransactionNestedInput>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutFinancialTransactionsNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutFinancialTransactionNestedInput>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUpdateWithoutChannelInput = {
  adjustment?: Maybe<FinancialAdjustmentUpdateOneWithoutFinancialTransactionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutFinancialTransactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutFinancialTransactionNestedInput>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutFinancialTransactionsNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutFinancialTransactionNestedInput>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUpdateWithoutClinicInput = {
  adjustment?: Maybe<FinancialAdjustmentUpdateOneWithoutFinancialTransactionNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutFinancialTransactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutFinancialTransactionNestedInput>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutFinancialTransactionsNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutFinancialTransactionNestedInput>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUpdateWithoutStripeDisputeInput = {
  adjustment?: Maybe<FinancialAdjustmentUpdateOneWithoutFinancialTransactionNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutFinancialTransactionsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutFinancialTransactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutFinancialTransactionsNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutFinancialTransactionNestedInput>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUpdateWithoutStripeInvoiceInput = {
  adjustment?: Maybe<FinancialAdjustmentUpdateOneWithoutFinancialTransactionNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutFinancialTransactionsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutFinancialTransactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutFinancialTransactionsNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutFinancialTransactionNestedInput>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUpdateWithoutStripePaymentIntentInput = {
  adjustment?: Maybe<FinancialAdjustmentUpdateOneWithoutFinancialTransactionNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutFinancialTransactionsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutFinancialTransactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutFinancialTransactionNestedInput>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutFinancialTransactionsNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutFinancialTransactionNestedInput>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUpdateWithoutStripePayoutInput = {
  adjustment?: Maybe<FinancialAdjustmentUpdateOneWithoutFinancialTransactionNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutFinancialTransactionsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutFinancialTransactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutFinancialTransactionNestedInput>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutFinancialTransactionNestedInput>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutFinancialTransactionNestedInput>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUpdateWithoutStripeRefundInput = {
  adjustment?: Maybe<FinancialAdjustmentUpdateOneWithoutFinancialTransactionNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutFinancialTransactionsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutFinancialTransactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeUpdateOneWithoutFinancialTransactionNestedInput>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutFinancialTransactionNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutFinancialTransactionsNestedInput>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<FinancialTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTransactionUpsertWithWhereUniqueWithoutChannelInput = {
  create: FinancialTransactionCreateWithoutChannelInput;
  update: FinancialTransactionUpdateWithoutChannelInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionUpsertWithWhereUniqueWithoutClinicInput = {
  create: FinancialTransactionCreateWithoutClinicInput;
  update: FinancialTransactionUpdateWithoutClinicInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionUpsertWithWhereUniqueWithoutStripePayoutInput = {
  create: FinancialTransactionCreateWithoutStripePayoutInput;
  update: FinancialTransactionUpdateWithoutStripePayoutInput;
  where: FinancialTransactionWhereUniqueInput;
};

export type FinancialTransactionUpsertWithoutAdjustmentInput = {
  create: FinancialTransactionCreateWithoutAdjustmentInput;
  update: FinancialTransactionUpdateWithoutAdjustmentInput;
  where?: Maybe<FinancialTransactionWhereInput>;
};

export type FinancialTransactionUpsertWithoutStripeDisputeInput = {
  create: FinancialTransactionCreateWithoutStripeDisputeInput;
  update: FinancialTransactionUpdateWithoutStripeDisputeInput;
  where?: Maybe<FinancialTransactionWhereInput>;
};

export type FinancialTransactionUpsertWithoutStripeInvoiceInput = {
  create: FinancialTransactionCreateWithoutStripeInvoiceInput;
  update: FinancialTransactionUpdateWithoutStripeInvoiceInput;
  where?: Maybe<FinancialTransactionWhereInput>;
};

export type FinancialTransactionUpsertWithoutStripePaymentIntentInput = {
  create: FinancialTransactionCreateWithoutStripePaymentIntentInput;
  update: FinancialTransactionUpdateWithoutStripePaymentIntentInput;
  where?: Maybe<FinancialTransactionWhereInput>;
};

export type FinancialTransactionUpsertWithoutStripeRefundInput = {
  create: FinancialTransactionCreateWithoutStripeRefundInput;
  update: FinancialTransactionUpdateWithoutStripeRefundInput;
  where?: Maybe<FinancialTransactionWhereInput>;
};

export type FinancialTransactionWhereInput = {
  AND?: Maybe<Array<FinancialTransactionWhereInput>>;
  NOT?: Maybe<Array<FinancialTransactionWhereInput>>;
  OR?: Maybe<Array<FinancialTransactionWhereInput>>;
  adjustment?: Maybe<FinancialAdjustmentNullableScalarRelationFilter>;
  adjustmentId?: Maybe<StringNullableFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  stripeDispute?: Maybe<StripeDisputeNullableScalarRelationFilter>;
  stripeDisputeId?: Maybe<StringNullableFilter>;
  stripeInvoice?: Maybe<StripeInvoiceNullableScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripePaymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeRefund?: Maybe<StripeRefundNullableScalarRelationFilter>;
  stripeRefundId?: Maybe<StringNullableFilter>;
  timestamp?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumFinancialTransactionTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FinancialTransactionWhereUniqueInput = {
  AND?: Maybe<Array<FinancialTransactionWhereInput>>;
  NOT?: Maybe<Array<FinancialTransactionWhereInput>>;
  OR?: Maybe<Array<FinancialTransactionWhereInput>>;
  adjustment?: Maybe<FinancialAdjustmentNullableScalarRelationFilter>;
  adjustmentId?: Maybe<Scalars['String']>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  stripeDispute?: Maybe<StripeDisputeNullableScalarRelationFilter>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceNullableScalarRelationFilter>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeRefund?: Maybe<StripeRefundNullableScalarRelationFilter>;
  stripeRefundId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumFinancialTransactionTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FindClinicPetParentByPhoneOrEmailRequest = {
  clinicId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type FindCurrentEmailTemplateVersionInput = {
  type: Scalars['String'];
};

export type FindEmployerIdentificationNumberInput = {
  companyName: Scalars['String'];
};

export type FindEmployerIdentificationNumberResponse = {
  __typename?: 'FindEmployerIdentificationNumberResponse';
  address?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyPhone?: Maybe<Scalars['String']>;
  ein?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type FindMissingBatchingPeriodDatesOutput = {
  __typename?: 'FindMissingBatchingPeriodDatesOutput';
  dates?: Maybe<Array<Scalars['String']>>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type FindSalesforceAccountsWhereInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type FindUniqueSalesforceAccountWhereInput = {
  salesforceAccountId?: Maybe<Scalars['String']>;
};

/** @deprecated - 1.0 */
export type FirebaseStructure = {
  __typename?: 'FirebaseStructure';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  structure?: Maybe<Scalars['String']>;
  table: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type FirebaseStructureCountAggregateOutputType = {
  __typename?: 'FirebaseStructureCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  structure: Scalars['Int'];
  table: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type FirebaseStructureCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  structure?: Maybe<SortOrder>;
  table?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FirebaseStructureCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  structure?: Maybe<Scalars['String']>;
  table: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FirebaseStructureCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  structure?: Maybe<Scalars['String']>;
  table: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FirebaseStructureGroupByOutputType = {
  __typename?: 'FirebaseStructureGroupByOutputType';
  _count?: Maybe<FirebaseStructureCountAggregateOutputType>;
  _max?: Maybe<FirebaseStructureMaxAggregateOutputType>;
  _min?: Maybe<FirebaseStructureMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  structure?: Maybe<Scalars['String']>;
  table: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type FirebaseStructureMaxAggregateOutputType = {
  __typename?: 'FirebaseStructureMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  structure?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FirebaseStructureMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  structure?: Maybe<SortOrder>;
  table?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FirebaseStructureMinAggregateOutputType = {
  __typename?: 'FirebaseStructureMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  structure?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FirebaseStructureMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  structure?: Maybe<SortOrder>;
  table?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FirebaseStructureOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<FirebaseStructureOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  structure?: Maybe<SortOrder>;
  table?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum FirebaseStructureOrderByRelevanceFieldEnum {
  Id = 'id',
  Structure = 'structure',
  Table = 'table'
}

export type FirebaseStructureOrderByRelevanceInput = {
  fields: Array<FirebaseStructureOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type FirebaseStructureOrderByWithAggregationInput = {
  _count?: Maybe<FirebaseStructureCountOrderByAggregateInput>;
  _max?: Maybe<FirebaseStructureMaxOrderByAggregateInput>;
  _min?: Maybe<FirebaseStructureMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  structure?: Maybe<SortOrder>;
  table?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FirebaseStructureOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<FirebaseStructureOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  structure?: Maybe<SortOrder>;
  table?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FirebaseStructureOrderByWithRelationInput = {
  _relevance?: Maybe<FirebaseStructureOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  structure?: Maybe<SortOrder>;
  table?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum FirebaseStructureScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Structure = 'structure',
  Table = 'table',
  UpdatedAt = 'updatedAt'
}

export type FirebaseStructureScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FirebaseStructureScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FirebaseStructureScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FirebaseStructureScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  structure?: Maybe<StringNullableWithAggregatesFilter>;
  table?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type FirebaseStructureUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  structure?: Maybe<Scalars['String']>;
  table: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FirebaseStructureUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  structure?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FirebaseStructureUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  structure?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FirebaseStructureUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  structure?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FirebaseStructureUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  structure?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FirebaseStructureWhereInput = {
  AND?: Maybe<Array<FirebaseStructureWhereInput>>;
  NOT?: Maybe<Array<FirebaseStructureWhereInput>>;
  OR?: Maybe<Array<FirebaseStructureWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  structure?: Maybe<StringNullableFilter>;
  table?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FirebaseStructureWhereUniqueInput = {
  AND?: Maybe<Array<FirebaseStructureWhereInput>>;
  NOT?: Maybe<Array<FirebaseStructureWhereInput>>;
  OR?: Maybe<Array<FirebaseStructureWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  structure?: Maybe<StringNullableFilter>;
  table?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Float']>;
  divide?: Maybe<Scalars['Float']>;
  increment?: Maybe<Scalars['Float']>;
  multiply?: Maybe<Scalars['Float']>;
  set?: Maybe<Scalars['Float']>;
};

export type FloatFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type FloatNullableFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatNullableFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type FloatNullableWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatNullableFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedFloatNullableFilter>;
  _min?: Maybe<NestedFloatNullableFilter>;
  _sum?: Maybe<NestedFloatNullableFilter>;
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type FloatWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedFloatFilter>;
  _min?: Maybe<NestedFloatFilter>;
  _sum?: Maybe<NestedFloatFilter>;
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export enum FormExportErrorType {
  Connection = 'Connection',
  GeneratingForm = 'GeneratingForm',
  InvalidParent = 'InvalidParent',
  InvalidPet = 'InvalidPet',
  PimsConfiguration = 'PimsConfiguration',
  PimsServer = 'PimsServer',
  Throttled = 'Throttled',
  Unauthorized = 'Unauthorized',
  Unknown = 'Unknown'
}

export type FormSubmission = {
  __typename?: 'FormSubmission';
  _count: FormSubmissionCountOutputType;
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunAction>;
  automationRuns: Array<AutomationRun>;
  channelAutomationStatuses: Array<ChannelAutomationStatus>;
  channelCreationSources: Array<ChannelCreationSource>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests: Array<ClinicWidgetRequest>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplate>;
  formTemplateId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications: Array<ServiceReminderNotification>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  users: Array<User>;
};


export type FormSubmissionAppointmentArgs = {
  where?: Maybe<AppointmentWhereInput>;
};


export type FormSubmissionAutomationRunActionArgs = {
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type FormSubmissionAutomationRunsArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type FormSubmissionChannelAutomationStatusesArgs = {
  cursor?: Maybe<ChannelAutomationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelAutomationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelAutomationStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type FormSubmissionChannelCreationSourcesArgs = {
  cursor?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelCreationSourceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelCreationSourceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type FormSubmissionClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type FormSubmissionClinicPetArgs = {
  where?: Maybe<ClinicPetWhereInput>;
};


export type FormSubmissionClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type FormSubmissionClinicWidgetRequestsArgs = {
  cursor?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type FormSubmissionFormTemplateArgs = {
  where?: Maybe<FormTemplateWhereInput>;
};


export type FormSubmissionServiceReminderNotificationsArgs = {
  cursor?: Maybe<ServiceReminderNotificationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderNotificationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderNotificationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};


export type FormSubmissionUsersArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};

export type FormSubmissionCountAggregateOutputType = {
  __typename?: 'FormSubmissionCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentId: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  completedContent: Scalars['Int'];
  createdAt: Scalars['Int'];
  draftContent: Scalars['Int'];
  formTemplateId: Scalars['Int'];
  id: Scalars['Int'];
  isCallDeflectionForm: Scalars['Int'];
  submittedAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type FormSubmissionCountOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  completedContent?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftContent?: Maybe<SortOrder>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCallDeflectionForm?: Maybe<SortOrder>;
  submittedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FormSubmissionCountOutputType = {
  __typename?: 'FormSubmissionCountOutputType';
  automationRuns: Scalars['Int'];
  channelAutomationStatuses: Scalars['Int'];
  channelCreationSources: Scalars['Int'];
  clinicWidgetRequests: Scalars['Int'];
  serviceReminderNotifications: Scalars['Int'];
  users: Scalars['Int'];
};

export type FormSubmissionCreateInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutFormSubmissionsInput>;
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutFormSubmissionsInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionCreateManyAppointmentInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionCreateManyAppointmentInputEnvelope = {
  data: Array<FormSubmissionCreateManyAppointmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FormSubmissionCreateManyClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionCreateManyClinicInputEnvelope = {
  data: Array<FormSubmissionCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FormSubmissionCreateManyClinicPetInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionCreateManyClinicPetInputEnvelope = {
  data: Array<FormSubmissionCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FormSubmissionCreateManyClinicPetParentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionCreateManyClinicPetParentInputEnvelope = {
  data: Array<FormSubmissionCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FormSubmissionCreateManyFormTemplateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionCreateManyFormTemplateInputEnvelope = {
  data: Array<FormSubmissionCreateManyFormTemplateInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FormSubmissionCreateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutAppointmentInput>>;
  createMany?: Maybe<FormSubmissionCreateManyAppointmentInputEnvelope>;
};

export type FormSubmissionCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutClinicInput>>;
  createMany?: Maybe<FormSubmissionCreateManyClinicInputEnvelope>;
};

export type FormSubmissionCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutClinicPetInput>>;
  createMany?: Maybe<FormSubmissionCreateManyClinicPetInputEnvelope>;
};

export type FormSubmissionCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<FormSubmissionCreateManyClinicPetParentInputEnvelope>;
};

export type FormSubmissionCreateNestedManyWithoutFormTemplateInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutFormTemplateInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutFormTemplateInput>>;
  createMany?: Maybe<FormSubmissionCreateManyFormTemplateInputEnvelope>;
};

export type FormSubmissionCreateNestedManyWithoutUsersInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutUsersInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutUsersInput>>;
};

export type FormSubmissionCreateNestedOneWithoutAutomationRunActionInput = {
  connect?: Maybe<FormSubmissionWhereUniqueInput>;
  connectOrCreate?: Maybe<FormSubmissionCreateOrConnectWithoutAutomationRunActionInput>;
  create?: Maybe<FormSubmissionCreateWithoutAutomationRunActionInput>;
};

export type FormSubmissionCreateNestedOneWithoutAutomationRunsInput = {
  connect?: Maybe<FormSubmissionWhereUniqueInput>;
  connectOrCreate?: Maybe<FormSubmissionCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<FormSubmissionCreateWithoutAutomationRunsInput>;
};

export type FormSubmissionCreateNestedOneWithoutChannelAutomationStatusesInput = {
  connect?: Maybe<FormSubmissionWhereUniqueInput>;
  connectOrCreate?: Maybe<FormSubmissionCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<FormSubmissionCreateWithoutChannelAutomationStatusesInput>;
};

export type FormSubmissionCreateNestedOneWithoutChannelCreationSourcesInput = {
  connect?: Maybe<FormSubmissionWhereUniqueInput>;
  connectOrCreate?: Maybe<FormSubmissionCreateOrConnectWithoutChannelCreationSourcesInput>;
  create?: Maybe<FormSubmissionCreateWithoutChannelCreationSourcesInput>;
};

export type FormSubmissionCreateNestedOneWithoutClinicWidgetRequestsInput = {
  connect?: Maybe<FormSubmissionWhereUniqueInput>;
  connectOrCreate?: Maybe<FormSubmissionCreateOrConnectWithoutClinicWidgetRequestsInput>;
  create?: Maybe<FormSubmissionCreateWithoutClinicWidgetRequestsInput>;
};

export type FormSubmissionCreateNestedOneWithoutServiceReminderNotificationsInput = {
  connect?: Maybe<FormSubmissionWhereUniqueInput>;
  connectOrCreate?: Maybe<FormSubmissionCreateOrConnectWithoutServiceReminderNotificationsInput>;
  create?: Maybe<FormSubmissionCreateWithoutServiceReminderNotificationsInput>;
};

export type FormSubmissionCreateOrConnectWithoutAppointmentInput = {
  create: FormSubmissionCreateWithoutAppointmentInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionCreateOrConnectWithoutAutomationRunActionInput = {
  create: FormSubmissionCreateWithoutAutomationRunActionInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionCreateOrConnectWithoutAutomationRunsInput = {
  create: FormSubmissionCreateWithoutAutomationRunsInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionCreateOrConnectWithoutChannelAutomationStatusesInput = {
  create: FormSubmissionCreateWithoutChannelAutomationStatusesInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionCreateOrConnectWithoutChannelCreationSourcesInput = {
  create: FormSubmissionCreateWithoutChannelCreationSourcesInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionCreateOrConnectWithoutClinicInput = {
  create: FormSubmissionCreateWithoutClinicInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionCreateOrConnectWithoutClinicPetInput = {
  create: FormSubmissionCreateWithoutClinicPetInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionCreateOrConnectWithoutClinicPetParentInput = {
  create: FormSubmissionCreateWithoutClinicPetParentInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionCreateOrConnectWithoutClinicWidgetRequestsInput = {
  create: FormSubmissionCreateWithoutClinicWidgetRequestsInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionCreateOrConnectWithoutFormTemplateInput = {
  create: FormSubmissionCreateWithoutFormTemplateInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionCreateOrConnectWithoutServiceReminderNotificationsInput = {
  create: FormSubmissionCreateWithoutServiceReminderNotificationsInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionCreateOrConnectWithoutUsersInput = {
  create: FormSubmissionCreateWithoutUsersInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionCreateWithoutAppointmentInput = {
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutFormSubmissionsInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionCreateWithoutAutomationRunActionInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutFormSubmissionsInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutFormSubmissionsInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionCreateWithoutAutomationRunsInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutFormSubmissionsInput>;
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutFormSubmissionsInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionCreateWithoutChannelAutomationStatusesInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutFormSubmissionsInput>;
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutFormSubmissionsInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionCreateWithoutChannelCreationSourcesInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutFormSubmissionsInput>;
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutFormSubmissionsInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionCreateWithoutClinicInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutFormSubmissionsInput>;
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutFormSubmissionsInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionCreateWithoutClinicPetInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutFormSubmissionsInput>;
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutFormSubmissionsInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionCreateWithoutClinicPetParentInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutFormSubmissionsInput>;
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutFormSubmissionsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutFormSubmissionsInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionCreateWithoutClinicWidgetRequestsInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutFormSubmissionsInput>;
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutFormSubmissionsInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionCreateWithoutFormTemplateInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutFormSubmissionsInput>;
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionCreateWithoutServiceReminderNotificationsInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutFormSubmissionsInput>;
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutFormSubmissionsInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionCreateWithoutUsersInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutFormSubmissionsInput>;
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutFormSubmissionInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutFormSubmissionsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutFormSubmissionsInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutFormSubmissionsInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionExportInput = {
  id: Scalars['String'];
  petIds: Array<Maybe<Scalars['String']>>;
};

export type FormSubmissionExportResponse = {
  __typename?: 'FormSubmissionExportResponse';
  results: Array<Maybe<FormSubmissionExportResult>>;
};

export type FormSubmissionExportResult = {
  __typename?: 'FormSubmissionExportResult';
  errorMessage?: Maybe<Scalars['String']>;
  errorType?: Maybe<FormExportErrorType>;
  formId: Scalars['String'];
  petId: Scalars['String'];
  success: Scalars['Boolean'];
};

export type FormSubmissionGroupByOutputType = {
  __typename?: 'FormSubmissionGroupByOutputType';
  _count?: Maybe<FormSubmissionCountAggregateOutputType>;
  _max?: Maybe<FormSubmissionMaxAggregateOutputType>;
  _min?: Maybe<FormSubmissionMinAggregateOutputType>;
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type FormSubmissionListRelationFilter = {
  every?: Maybe<FormSubmissionWhereInput>;
  none?: Maybe<FormSubmissionWhereInput>;
  some?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionMaxAggregateOutputType = {
  __typename?: 'FormSubmissionMaxAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionMaxOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCallDeflectionForm?: Maybe<SortOrder>;
  submittedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FormSubmissionMinAggregateOutputType = {
  __typename?: 'FormSubmissionMinAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionMinOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCallDeflectionForm?: Maybe<SortOrder>;
  submittedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FormSubmissionNullableScalarRelationFilter = {
  AND?: Maybe<Array<FormSubmissionWhereInput>>;
  NOT?: Maybe<Array<FormSubmissionWhereInput>>;
  OR?: Maybe<Array<FormSubmissionWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  automationRunAction?: Maybe<AutomationRunActionNullableScalarRelationFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  completedContent?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draftContent?: Maybe<JsonNullableFilter>;
  formTemplate?: Maybe<FormTemplateNullableScalarRelationFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isCallDeflectionForm?: Maybe<BoolNullableFilter>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  submittedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  users?: Maybe<UserListRelationFilter>;
};

export type FormSubmissionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FormSubmissionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<FormSubmissionOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  automationRunAction?: Maybe<AutomationRunActionOrderByWithRelationInput>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestOrderByRelationAggregateInput>;
  completedContent?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftContent?: Maybe<SortOrder>;
  formTemplate?: Maybe<FormTemplateOrderByWithRelationInput>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCallDeflectionForm?: Maybe<SortOrder>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationOrderByRelationAggregateInput>;
  submittedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  users?: Maybe<UserOrderByRelationAggregateInput>;
};

export enum FormSubmissionOrderByRelevanceFieldEnum {
  AppointmentId = 'appointmentId',
  ClinicId = 'clinicId',
  ClinicPetId = 'clinicPetId',
  ClinicPetParentId = 'clinicPetParentId',
  FormTemplateId = 'formTemplateId',
  Id = 'id'
}

export type FormSubmissionOrderByRelevanceInput = {
  fields: Array<FormSubmissionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type FormSubmissionOrderByWithAggregationInput = {
  _count?: Maybe<FormSubmissionCountOrderByAggregateInput>;
  _max?: Maybe<FormSubmissionMaxOrderByAggregateInput>;
  _min?: Maybe<FormSubmissionMinOrderByAggregateInput>;
  appointmentId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  completedContent?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftContent?: Maybe<SortOrder>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCallDeflectionForm?: Maybe<SortOrder>;
  submittedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FormSubmissionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<FormSubmissionOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  automationRunAction?: Maybe<AutomationRunActionOrderByWithRelationInput>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestOrderByRelationAggregateInput>;
  completedContent?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftContent?: Maybe<SortOrder>;
  formTemplate?: Maybe<FormTemplateOrderByWithRelationInput>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCallDeflectionForm?: Maybe<SortOrder>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationOrderByRelationAggregateInput>;
  submittedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  users?: Maybe<UserOrderByRelationAggregateInput>;
};

export type FormSubmissionOrderByWithRelationInput = {
  _relevance?: Maybe<FormSubmissionOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  automationRunAction?: Maybe<AutomationRunActionOrderByWithRelationInput>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestOrderByRelationAggregateInput>;
  completedContent?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftContent?: Maybe<SortOrder>;
  formTemplate?: Maybe<FormTemplateOrderByWithRelationInput>;
  formTemplateId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCallDeflectionForm?: Maybe<SortOrder>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationOrderByRelationAggregateInput>;
  submittedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  users?: Maybe<UserOrderByRelationAggregateInput>;
};

export enum FormSubmissionScalarFieldEnum {
  AppointmentId = 'appointmentId',
  ClinicId = 'clinicId',
  ClinicPetId = 'clinicPetId',
  ClinicPetParentId = 'clinicPetParentId',
  CompletedContent = 'completedContent',
  CreatedAt = 'createdAt',
  DraftContent = 'draftContent',
  FormTemplateId = 'formTemplateId',
  Id = 'id',
  IsCallDeflectionForm = 'isCallDeflectionForm',
  SubmittedAt = 'submittedAt',
  UpdatedAt = 'updatedAt'
}

export type FormSubmissionScalarWhereInput = {
  AND?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  NOT?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  OR?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  appointmentId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  completedContent?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draftContent?: Maybe<JsonNullableFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isCallDeflectionForm?: Maybe<BoolNullableFilter>;
  submittedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FormSubmissionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FormSubmissionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FormSubmissionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FormSubmissionScalarWhereWithAggregatesInput>>;
  appointmentId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  completedContent?: Maybe<JsonNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  draftContent?: Maybe<JsonNullableWithAggregatesFilter>;
  formTemplateId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isCallDeflectionForm?: Maybe<BoolNullableWithAggregatesFilter>;
  submittedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type FormSubmissionSubscription = {
  __typename?: 'FormSubmissionSubscription';
  mutation: MutationType;
  node: FormSubmission;
};

export type FormSubmissionUncheckedCreateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionUncheckedCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutAppointmentInput>>;
  createMany?: Maybe<FormSubmissionCreateManyAppointmentInputEnvelope>;
};

export type FormSubmissionUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutClinicInput>>;
  createMany?: Maybe<FormSubmissionCreateManyClinicInputEnvelope>;
};

export type FormSubmissionUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutClinicPetInput>>;
  createMany?: Maybe<FormSubmissionCreateManyClinicPetInputEnvelope>;
};

export type FormSubmissionUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<FormSubmissionCreateManyClinicPetParentInputEnvelope>;
};

export type FormSubmissionUncheckedCreateNestedManyWithoutFormTemplateInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutFormTemplateInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutFormTemplateInput>>;
  createMany?: Maybe<FormSubmissionCreateManyFormTemplateInputEnvelope>;
};

export type FormSubmissionUncheckedCreateNestedManyWithoutUsersInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutUsersInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutUsersInput>>;
};

export type FormSubmissionUncheckedCreateWithoutAppointmentInput = {
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionUncheckedCreateWithoutAutomationRunActionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionUncheckedCreateWithoutAutomationRunsInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionUncheckedCreateWithoutChannelAutomationStatusesInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionUncheckedCreateWithoutChannelCreationSourcesInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionUncheckedCreateWithoutClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionUncheckedCreateWithoutClinicPetInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionUncheckedCreateWithoutClinicPetParentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionUncheckedCreateWithoutClinicWidgetRequestsInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionUncheckedCreateWithoutFormTemplateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionUncheckedCreateWithoutServiceReminderNotificationsInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedCreateNestedManyWithoutFormSubmissionsInput>;
};

export type FormSubmissionUncheckedCreateWithoutUsersInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutFormSubmissionInput>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionUncheckedUpdateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUncheckedUpdateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionUncheckedUpdateManyWithoutAppointmentInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionUncheckedUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutAppointmentInput>>;
  createMany?: Maybe<FormSubmissionCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  disconnect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  update?: Maybe<Array<FormSubmissionUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<FormSubmissionUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<FormSubmissionUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type FormSubmissionUncheckedUpdateManyWithoutClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutClinicInput>>;
  createMany?: Maybe<FormSubmissionCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  disconnect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  update?: Maybe<Array<FormSubmissionUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<FormSubmissionUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<FormSubmissionUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type FormSubmissionUncheckedUpdateManyWithoutClinicPetInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutClinicPetInput>>;
  createMany?: Maybe<FormSubmissionCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  disconnect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  update?: Maybe<Array<FormSubmissionUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<FormSubmissionUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<FormSubmissionUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type FormSubmissionUncheckedUpdateManyWithoutClinicPetParentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<FormSubmissionCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  disconnect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  update?: Maybe<Array<FormSubmissionUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<FormSubmissionUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<FormSubmissionUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type FormSubmissionUncheckedUpdateManyWithoutFormTemplateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionUncheckedUpdateManyWithoutFormTemplateNestedInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutFormTemplateInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutFormTemplateInput>>;
  createMany?: Maybe<FormSubmissionCreateManyFormTemplateInputEnvelope>;
  delete?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  disconnect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  update?: Maybe<Array<FormSubmissionUpdateWithWhereUniqueWithoutFormTemplateInput>>;
  updateMany?: Maybe<Array<FormSubmissionUpdateManyWithWhereWithoutFormTemplateInput>>;
  upsert?: Maybe<Array<FormSubmissionUpsertWithWhereUniqueWithoutFormTemplateInput>>;
};

export type FormSubmissionUncheckedUpdateManyWithoutUsersInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutUsersInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutUsersInput>>;
  delete?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  disconnect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  update?: Maybe<Array<FormSubmissionUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: Maybe<Array<FormSubmissionUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: Maybe<Array<FormSubmissionUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type FormSubmissionUncheckedUpdateWithoutAppointmentInput = {
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUncheckedUpdateWithoutAutomationRunActionInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUncheckedUpdateWithoutAutomationRunsInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUncheckedUpdateWithoutChannelAutomationStatusesInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUncheckedUpdateWithoutChannelCreationSourcesInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUncheckedUpdateWithoutClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUncheckedUpdateWithoutClinicPetInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUncheckedUpdateWithoutClinicPetParentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUncheckedUpdateWithoutClinicWidgetRequestsInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUncheckedUpdateWithoutFormTemplateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUncheckedUpdateWithoutServiceReminderNotificationsInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUncheckedUpdateWithoutUsersInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionUpdateInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutFormSubmissionsNestedInput>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutFormSubmissionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUpdateManyMutationInput = {
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionUpdateManyWithWhereWithoutAppointmentInput = {
  data: FormSubmissionUpdateManyMutationInput;
  where: FormSubmissionScalarWhereInput;
};

export type FormSubmissionUpdateManyWithWhereWithoutClinicInput = {
  data: FormSubmissionUpdateManyMutationInput;
  where: FormSubmissionScalarWhereInput;
};

export type FormSubmissionUpdateManyWithWhereWithoutClinicPetInput = {
  data: FormSubmissionUpdateManyMutationInput;
  where: FormSubmissionScalarWhereInput;
};

export type FormSubmissionUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: FormSubmissionUpdateManyMutationInput;
  where: FormSubmissionScalarWhereInput;
};

export type FormSubmissionUpdateManyWithWhereWithoutFormTemplateInput = {
  data: FormSubmissionUpdateManyMutationInput;
  where: FormSubmissionScalarWhereInput;
};

export type FormSubmissionUpdateManyWithWhereWithoutUsersInput = {
  data: FormSubmissionUpdateManyMutationInput;
  where: FormSubmissionScalarWhereInput;
};

export type FormSubmissionUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutAppointmentInput>>;
  createMany?: Maybe<FormSubmissionCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  disconnect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  update?: Maybe<Array<FormSubmissionUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<FormSubmissionUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<FormSubmissionUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type FormSubmissionUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutClinicInput>>;
  createMany?: Maybe<FormSubmissionCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  disconnect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  update?: Maybe<Array<FormSubmissionUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<FormSubmissionUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<FormSubmissionUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type FormSubmissionUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutClinicPetInput>>;
  createMany?: Maybe<FormSubmissionCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  disconnect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  update?: Maybe<Array<FormSubmissionUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<FormSubmissionUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<FormSubmissionUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type FormSubmissionUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<FormSubmissionCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  disconnect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  update?: Maybe<Array<FormSubmissionUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<FormSubmissionUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<FormSubmissionUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type FormSubmissionUpdateManyWithoutFormTemplateNestedInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutFormTemplateInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutFormTemplateInput>>;
  createMany?: Maybe<FormSubmissionCreateManyFormTemplateInputEnvelope>;
  delete?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  disconnect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  update?: Maybe<Array<FormSubmissionUpdateWithWhereUniqueWithoutFormTemplateInput>>;
  updateMany?: Maybe<Array<FormSubmissionUpdateManyWithWhereWithoutFormTemplateInput>>;
  upsert?: Maybe<Array<FormSubmissionUpsertWithWhereUniqueWithoutFormTemplateInput>>;
};

export type FormSubmissionUpdateManyWithoutUsersNestedInput = {
  connect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormSubmissionCreateOrConnectWithoutUsersInput>>;
  create?: Maybe<Array<FormSubmissionCreateWithoutUsersInput>>;
  delete?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormSubmissionScalarWhereInput>>;
  disconnect?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<FormSubmissionWhereUniqueInput>>;
  update?: Maybe<Array<FormSubmissionUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: Maybe<Array<FormSubmissionUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: Maybe<Array<FormSubmissionUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type FormSubmissionUpdateOneWithoutAutomationRunActionNestedInput = {
  connect?: Maybe<FormSubmissionWhereUniqueInput>;
  connectOrCreate?: Maybe<FormSubmissionCreateOrConnectWithoutAutomationRunActionInput>;
  create?: Maybe<FormSubmissionCreateWithoutAutomationRunActionInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FormSubmissionUpdateToOneWithWhereWithoutAutomationRunActionInput>;
  upsert?: Maybe<FormSubmissionUpsertWithoutAutomationRunActionInput>;
};

export type FormSubmissionUpdateOneWithoutAutomationRunsNestedInput = {
  connect?: Maybe<FormSubmissionWhereUniqueInput>;
  connectOrCreate?: Maybe<FormSubmissionCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<FormSubmissionCreateWithoutAutomationRunsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FormSubmissionUpdateToOneWithWhereWithoutAutomationRunsInput>;
  upsert?: Maybe<FormSubmissionUpsertWithoutAutomationRunsInput>;
};

export type FormSubmissionUpdateOneWithoutChannelAutomationStatusesNestedInput = {
  connect?: Maybe<FormSubmissionWhereUniqueInput>;
  connectOrCreate?: Maybe<FormSubmissionCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<FormSubmissionCreateWithoutChannelAutomationStatusesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FormSubmissionUpdateToOneWithWhereWithoutChannelAutomationStatusesInput>;
  upsert?: Maybe<FormSubmissionUpsertWithoutChannelAutomationStatusesInput>;
};

export type FormSubmissionUpdateOneWithoutChannelCreationSourcesNestedInput = {
  connect?: Maybe<FormSubmissionWhereUniqueInput>;
  connectOrCreate?: Maybe<FormSubmissionCreateOrConnectWithoutChannelCreationSourcesInput>;
  create?: Maybe<FormSubmissionCreateWithoutChannelCreationSourcesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FormSubmissionUpdateToOneWithWhereWithoutChannelCreationSourcesInput>;
  upsert?: Maybe<FormSubmissionUpsertWithoutChannelCreationSourcesInput>;
};

export type FormSubmissionUpdateOneWithoutClinicWidgetRequestsNestedInput = {
  connect?: Maybe<FormSubmissionWhereUniqueInput>;
  connectOrCreate?: Maybe<FormSubmissionCreateOrConnectWithoutClinicWidgetRequestsInput>;
  create?: Maybe<FormSubmissionCreateWithoutClinicWidgetRequestsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FormSubmissionUpdateToOneWithWhereWithoutClinicWidgetRequestsInput>;
  upsert?: Maybe<FormSubmissionUpsertWithoutClinicWidgetRequestsInput>;
};

export type FormSubmissionUpdateOneWithoutServiceReminderNotificationsNestedInput = {
  connect?: Maybe<FormSubmissionWhereUniqueInput>;
  connectOrCreate?: Maybe<FormSubmissionCreateOrConnectWithoutServiceReminderNotificationsInput>;
  create?: Maybe<FormSubmissionCreateWithoutServiceReminderNotificationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FormSubmissionUpdateToOneWithWhereWithoutServiceReminderNotificationsInput>;
  upsert?: Maybe<FormSubmissionUpsertWithoutServiceReminderNotificationsInput>;
};

export type FormSubmissionUpdateToOneWithWhereWithoutAutomationRunActionInput = {
  data: FormSubmissionUpdateWithoutAutomationRunActionInput;
  where?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionUpdateToOneWithWhereWithoutAutomationRunsInput = {
  data: FormSubmissionUpdateWithoutAutomationRunsInput;
  where?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionUpdateToOneWithWhereWithoutChannelAutomationStatusesInput = {
  data: FormSubmissionUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionUpdateToOneWithWhereWithoutChannelCreationSourcesInput = {
  data: FormSubmissionUpdateWithoutChannelCreationSourcesInput;
  where?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionUpdateToOneWithWhereWithoutClinicWidgetRequestsInput = {
  data: FormSubmissionUpdateWithoutClinicWidgetRequestsInput;
  where?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionUpdateToOneWithWhereWithoutServiceReminderNotificationsInput = {
  data: FormSubmissionUpdateWithoutServiceReminderNotificationsInput;
  where?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionUpdateWithWhereUniqueWithoutAppointmentInput = {
  data: FormSubmissionUpdateWithoutAppointmentInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionUpdateWithWhereUniqueWithoutClinicInput = {
  data: FormSubmissionUpdateWithoutClinicInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: FormSubmissionUpdateWithoutClinicPetInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: FormSubmissionUpdateWithoutClinicPetParentInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionUpdateWithWhereUniqueWithoutFormTemplateInput = {
  data: FormSubmissionUpdateWithoutFormTemplateInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionUpdateWithWhereUniqueWithoutUsersInput = {
  data: FormSubmissionUpdateWithoutUsersInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionUpdateWithoutAppointmentInput = {
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutFormSubmissionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUpdateWithoutAutomationRunActionInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutFormSubmissionsNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutFormSubmissionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUpdateWithoutAutomationRunsInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutFormSubmissionsNestedInput>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutFormSubmissionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUpdateWithoutChannelAutomationStatusesInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutFormSubmissionsNestedInput>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutFormSubmissionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUpdateWithoutChannelCreationSourcesInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutFormSubmissionsNestedInput>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutFormSubmissionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUpdateWithoutClinicInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutFormSubmissionsNestedInput>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutFormSubmissionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUpdateWithoutClinicPetInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutFormSubmissionsNestedInput>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutFormSubmissionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUpdateWithoutClinicPetParentInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutFormSubmissionsNestedInput>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutFormSubmissionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUpdateWithoutClinicWidgetRequestsInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutFormSubmissionsNestedInput>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutFormSubmissionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUpdateWithoutFormTemplateInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutFormSubmissionsNestedInput>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUpdateWithoutServiceReminderNotificationsInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutFormSubmissionsNestedInput>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutFormSubmissionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateManyWithoutFormSubmissionsNestedInput>;
};

export type FormSubmissionUpdateWithoutUsersInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutFormSubmissionsNestedInput>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutFormSubmissionNestedInput>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutFormSubmissionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutFormSubmissionNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutFormSubmissionNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutFormSubmissionsNestedInput>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestUpdateManyWithoutFormSubmissionNestedInput>;
  completedContent?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutFormSubmissionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<Scalars['Boolean']>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmissionUpsertWithWhereUniqueWithoutAppointmentInput = {
  create: FormSubmissionCreateWithoutAppointmentInput;
  update: FormSubmissionUpdateWithoutAppointmentInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionUpsertWithWhereUniqueWithoutClinicInput = {
  create: FormSubmissionCreateWithoutClinicInput;
  update: FormSubmissionUpdateWithoutClinicInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: FormSubmissionCreateWithoutClinicPetInput;
  update: FormSubmissionUpdateWithoutClinicPetInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: FormSubmissionCreateWithoutClinicPetParentInput;
  update: FormSubmissionUpdateWithoutClinicPetParentInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionUpsertWithWhereUniqueWithoutFormTemplateInput = {
  create: FormSubmissionCreateWithoutFormTemplateInput;
  update: FormSubmissionUpdateWithoutFormTemplateInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionUpsertWithWhereUniqueWithoutUsersInput = {
  create: FormSubmissionCreateWithoutUsersInput;
  update: FormSubmissionUpdateWithoutUsersInput;
  where: FormSubmissionWhereUniqueInput;
};

export type FormSubmissionUpsertWithoutAutomationRunActionInput = {
  create: FormSubmissionCreateWithoutAutomationRunActionInput;
  update: FormSubmissionUpdateWithoutAutomationRunActionInput;
  where?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionUpsertWithoutAutomationRunsInput = {
  create: FormSubmissionCreateWithoutAutomationRunsInput;
  update: FormSubmissionUpdateWithoutAutomationRunsInput;
  where?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionUpsertWithoutChannelAutomationStatusesInput = {
  create: FormSubmissionCreateWithoutChannelAutomationStatusesInput;
  update: FormSubmissionUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionUpsertWithoutChannelCreationSourcesInput = {
  create: FormSubmissionCreateWithoutChannelCreationSourcesInput;
  update: FormSubmissionUpdateWithoutChannelCreationSourcesInput;
  where?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionUpsertWithoutClinicWidgetRequestsInput = {
  create: FormSubmissionCreateWithoutClinicWidgetRequestsInput;
  update: FormSubmissionUpdateWithoutClinicWidgetRequestsInput;
  where?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionUpsertWithoutServiceReminderNotificationsInput = {
  create: FormSubmissionCreateWithoutServiceReminderNotificationsInput;
  update: FormSubmissionUpdateWithoutServiceReminderNotificationsInput;
  where?: Maybe<FormSubmissionWhereInput>;
};

export type FormSubmissionWhereInput = {
  AND?: Maybe<Array<FormSubmissionWhereInput>>;
  NOT?: Maybe<Array<FormSubmissionWhereInput>>;
  OR?: Maybe<Array<FormSubmissionWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  automationRunAction?: Maybe<AutomationRunActionNullableScalarRelationFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  completedContent?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draftContent?: Maybe<JsonNullableFilter>;
  formTemplate?: Maybe<FormTemplateNullableScalarRelationFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isCallDeflectionForm?: Maybe<BoolNullableFilter>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  submittedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  users?: Maybe<UserListRelationFilter>;
};

export type FormSubmissionWhereUniqueInput = {
  AND?: Maybe<Array<FormSubmissionWhereInput>>;
  NOT?: Maybe<Array<FormSubmissionWhereInput>>;
  OR?: Maybe<Array<FormSubmissionWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  automationRunAction?: Maybe<AutomationRunActionNullableScalarRelationFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicWidgetRequests?: Maybe<ClinicWidgetRequestListRelationFilter>;
  completedContent?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draftContent?: Maybe<JsonNullableFilter>;
  formTemplate?: Maybe<FormTemplateNullableScalarRelationFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isCallDeflectionForm?: Maybe<BoolNullableFilter>;
  serviceReminderNotifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  submittedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  users?: Maybe<UserListRelationFilter>;
};

export type FormTemplate = {
  __typename?: 'FormTemplate';
  _count: FormTemplateCountOutputType;
  autoExportEnabled: Scalars['Boolean'];
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypes: Array<ClinicWidgetRequestType>;
  content?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions: Array<FormSubmission>;
  formTemplateType: FormTemplateType;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services: Array<Service>;
  title: Scalars['String'];
  triggeredWorkflows: Array<WorkflowEventSetting>;
  updatedAt: Scalars['DateTime'];
};


export type FormTemplateClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type FormTemplateClinicWidgetRequestTypesArgs = {
  cursor?: Maybe<ClinicWidgetRequestTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};


export type FormTemplateFormSubmissionsArgs = {
  cursor?: Maybe<FormSubmissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormSubmissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormSubmissionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormSubmissionWhereInput>;
};


export type FormTemplateServicesArgs = {
  cursor?: Maybe<ServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceWhereInput>;
};


export type FormTemplateTriggeredWorkflowsArgs = {
  cursor?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type FormTemplateCountAggregateOutputType = {
  __typename?: 'FormTemplateCountAggregateOutputType';
  _all: Scalars['Int'];
  autoExportEnabled: Scalars['Int'];
  clinicId: Scalars['Int'];
  content: Scalars['Int'];
  createdAt: Scalars['Int'];
  draftContent: Scalars['Int'];
  formTemplateType: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type FormTemplateCountOrderByAggregateInput = {
  autoExportEnabled?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  content?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftContent?: Maybe<SortOrder>;
  formTemplateType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FormTemplateCountOutputType = {
  __typename?: 'FormTemplateCountOutputType';
  clinicWidgetRequestTypes: Scalars['Int'];
  formSubmissions: Scalars['Int'];
  services: Scalars['Int'];
  triggeredWorkflows: Scalars['Int'];
};

export type FormTemplateCreateInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormTemplatesInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutFormTemplateInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutFormTemplateInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceCreateNestedManyWithoutFormTemplateInput>;
  title: Scalars['String'];
  triggeredWorkflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutTriggeringFormTemplatesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateCreateManyClinicInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateCreateManyClinicInputEnvelope = {
  data: Array<FormTemplateCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FormTemplateCreateManyInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<FormTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<FormTemplateCreateManyClinicInputEnvelope>;
};

export type FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput = {
  connect?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormTemplateCreateOrConnectWithoutTriggeredWorkflowsInput>>;
  create?: Maybe<Array<FormTemplateCreateWithoutTriggeredWorkflowsInput>>;
};

export type FormTemplateCreateNestedOneWithoutClinicWidgetRequestTypesInput = {
  connect?: Maybe<FormTemplateWhereUniqueInput>;
  connectOrCreate?: Maybe<FormTemplateCreateOrConnectWithoutClinicWidgetRequestTypesInput>;
  create?: Maybe<FormTemplateCreateWithoutClinicWidgetRequestTypesInput>;
};

export type FormTemplateCreateNestedOneWithoutFormSubmissionsInput = {
  connect?: Maybe<FormTemplateWhereUniqueInput>;
  connectOrCreate?: Maybe<FormTemplateCreateOrConnectWithoutFormSubmissionsInput>;
  create?: Maybe<FormTemplateCreateWithoutFormSubmissionsInput>;
};

export type FormTemplateCreateNestedOneWithoutServicesInput = {
  connect?: Maybe<FormTemplateWhereUniqueInput>;
  connectOrCreate?: Maybe<FormTemplateCreateOrConnectWithoutServicesInput>;
  create?: Maybe<FormTemplateCreateWithoutServicesInput>;
};

export type FormTemplateCreateOrConnectWithoutClinicInput = {
  create: FormTemplateCreateWithoutClinicInput;
  where: FormTemplateWhereUniqueInput;
};

export type FormTemplateCreateOrConnectWithoutClinicWidgetRequestTypesInput = {
  create: FormTemplateCreateWithoutClinicWidgetRequestTypesInput;
  where: FormTemplateWhereUniqueInput;
};

export type FormTemplateCreateOrConnectWithoutFormSubmissionsInput = {
  create: FormTemplateCreateWithoutFormSubmissionsInput;
  where: FormTemplateWhereUniqueInput;
};

export type FormTemplateCreateOrConnectWithoutServicesInput = {
  create: FormTemplateCreateWithoutServicesInput;
  where: FormTemplateWhereUniqueInput;
};

export type FormTemplateCreateOrConnectWithoutTriggeredWorkflowsInput = {
  create: FormTemplateCreateWithoutTriggeredWorkflowsInput;
  where: FormTemplateWhereUniqueInput;
};

export type FormTemplateCreateWithoutClinicInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutFormTemplateInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutFormTemplateInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceCreateNestedManyWithoutFormTemplateInput>;
  title: Scalars['String'];
  triggeredWorkflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutTriggeringFormTemplatesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateCreateWithoutClinicWidgetRequestTypesInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormTemplatesInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutFormTemplateInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceCreateNestedManyWithoutFormTemplateInput>;
  title: Scalars['String'];
  triggeredWorkflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutTriggeringFormTemplatesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateCreateWithoutFormSubmissionsInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormTemplatesInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutFormTemplateInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceCreateNestedManyWithoutFormTemplateInput>;
  title: Scalars['String'];
  triggeredWorkflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutTriggeringFormTemplatesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateCreateWithoutServicesInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormTemplatesInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutFormTemplateInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutFormTemplateInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  triggeredWorkflows?: Maybe<WorkflowEventSettingCreateNestedManyWithoutTriggeringFormTemplatesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateCreateWithoutTriggeredWorkflowsInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutFormTemplatesInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutFormTemplateInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutFormTemplateInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceCreateNestedManyWithoutFormTemplateInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateGroupByOutputType = {
  __typename?: 'FormTemplateGroupByOutputType';
  _count?: Maybe<FormTemplateCountAggregateOutputType>;
  _max?: Maybe<FormTemplateMaxAggregateOutputType>;
  _min?: Maybe<FormTemplateMinAggregateOutputType>;
  autoExportEnabled: Scalars['Boolean'];
  clinicId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateType: FormTemplateType;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type FormTemplateListRelationFilter = {
  every?: Maybe<FormTemplateWhereInput>;
  none?: Maybe<FormTemplateWhereInput>;
  some?: Maybe<FormTemplateWhereInput>;
};

export type FormTemplateMaxAggregateOutputType = {
  __typename?: 'FormTemplateMaxAggregateOutputType';
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateMaxOrderByAggregateInput = {
  autoExportEnabled?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formTemplateType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FormTemplateMinAggregateOutputType = {
  __typename?: 'FormTemplateMinAggregateOutputType';
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateMinOrderByAggregateInput = {
  autoExportEnabled?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formTemplateType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FormTemplateNullableScalarRelationFilter = {
  AND?: Maybe<Array<FormTemplateWhereInput>>;
  NOT?: Maybe<Array<FormTemplateWhereInput>>;
  OR?: Maybe<Array<FormTemplateWhereInput>>;
  autoExportEnabled?: Maybe<BoolFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  content?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draftContent?: Maybe<JsonNullableFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  formTemplateType?: Maybe<EnumFormTemplateTypeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  services?: Maybe<ServiceListRelationFilter>;
  title?: Maybe<StringFilter>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FormTemplateOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FormTemplateOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<FormTemplateOrderByRelevanceInput>;
  autoExportEnabled?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  content?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftContent?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  formTemplateType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  services?: Maybe<ServiceOrderByRelationAggregateInput>;
  title?: Maybe<SortOrder>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum FormTemplateOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  Title = 'title'
}

export type FormTemplateOrderByRelevanceInput = {
  fields: Array<FormTemplateOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type FormTemplateOrderByWithAggregationInput = {
  _count?: Maybe<FormTemplateCountOrderByAggregateInput>;
  _max?: Maybe<FormTemplateMaxOrderByAggregateInput>;
  _min?: Maybe<FormTemplateMinOrderByAggregateInput>;
  autoExportEnabled?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  content?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftContent?: Maybe<SortOrder>;
  formTemplateType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FormTemplateOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<FormTemplateOrderByRelevanceInput>;
  autoExportEnabled?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  content?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftContent?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  formTemplateType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  services?: Maybe<ServiceOrderByRelationAggregateInput>;
  title?: Maybe<SortOrder>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type FormTemplateOrderByWithRelationInput = {
  _relevance?: Maybe<FormTemplateOrderByRelevanceInput>;
  autoExportEnabled?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  content?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftContent?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  formTemplateType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  services?: Maybe<ServiceOrderByRelationAggregateInput>;
  title?: Maybe<SortOrder>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum FormTemplateScalarFieldEnum {
  AutoExportEnabled = 'autoExportEnabled',
  ClinicId = 'clinicId',
  Content = 'content',
  CreatedAt = 'createdAt',
  DraftContent = 'draftContent',
  FormTemplateType = 'formTemplateType',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type FormTemplateScalarWhereInput = {
  AND?: Maybe<Array<FormTemplateScalarWhereInput>>;
  NOT?: Maybe<Array<FormTemplateScalarWhereInput>>;
  OR?: Maybe<Array<FormTemplateScalarWhereInput>>;
  autoExportEnabled?: Maybe<BoolFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  content?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draftContent?: Maybe<JsonNullableFilter>;
  formTemplateType?: Maybe<EnumFormTemplateTypeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FormTemplateScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FormTemplateScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FormTemplateScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FormTemplateScalarWhereWithAggregatesInput>>;
  autoExportEnabled?: Maybe<BoolWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  content?: Maybe<JsonNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  draftContent?: Maybe<JsonNullableWithAggregatesFilter>;
  formTemplateType?: Maybe<EnumFormTemplateTypeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolNullableWithAggregatesFilter>;
  title?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum FormTemplateType {
  FillInTheBlank = 'FillInTheBlank',
  General = 'General',
  ServiceReminder = 'ServiceReminder',
  WidgetRequest = 'WidgetRequest'
}

export type FormTemplateUncheckedCreateInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutFormTemplateInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutFormTemplateInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutFormTemplateInput>;
  title: Scalars['String'];
  triggeredWorkflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutTriggeringFormTemplatesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<FormTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<FormTemplateCreateManyClinicInputEnvelope>;
};

export type FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput = {
  connect?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormTemplateCreateOrConnectWithoutTriggeredWorkflowsInput>>;
  create?: Maybe<Array<FormTemplateCreateWithoutTriggeredWorkflowsInput>>;
};

export type FormTemplateUncheckedCreateWithoutClinicInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutFormTemplateInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutFormTemplateInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutFormTemplateInput>;
  title: Scalars['String'];
  triggeredWorkflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutTriggeringFormTemplatesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedCreateWithoutClinicWidgetRequestTypesInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutFormTemplateInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutFormTemplateInput>;
  title: Scalars['String'];
  triggeredWorkflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutTriggeringFormTemplatesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedCreateWithoutFormSubmissionsInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutFormTemplateInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutFormTemplateInput>;
  title: Scalars['String'];
  triggeredWorkflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutTriggeringFormTemplatesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedCreateWithoutServicesInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutFormTemplateInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutFormTemplateInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  triggeredWorkflows?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutTriggeringFormTemplatesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedCreateWithoutTriggeredWorkflowsInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutFormTemplateInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutFormTemplateInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUncheckedCreateNestedManyWithoutFormTemplateInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedUpdateInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  title?: Maybe<Scalars['String']>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutTriggeringFormTemplatesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedUpdateManyInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedUpdateManyWithoutClinicInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<FormTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<FormTemplateCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  set?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  update?: Maybe<Array<FormTemplateUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<FormTemplateUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<FormTemplateUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput = {
  connect?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormTemplateCreateOrConnectWithoutTriggeredWorkflowsInput>>;
  create?: Maybe<Array<FormTemplateCreateWithoutTriggeredWorkflowsInput>>;
  delete?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  set?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  update?: Maybe<Array<FormTemplateUpdateWithWhereUniqueWithoutTriggeredWorkflowsInput>>;
  updateMany?: Maybe<Array<FormTemplateUpdateManyWithWhereWithoutTriggeredWorkflowsInput>>;
  upsert?: Maybe<Array<FormTemplateUpsertWithWhereUniqueWithoutTriggeredWorkflowsInput>>;
};

export type FormTemplateUncheckedUpdateWithoutClinicInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  title?: Maybe<Scalars['String']>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutTriggeringFormTemplatesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedUpdateWithoutClinicWidgetRequestTypesInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  title?: Maybe<Scalars['String']>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutTriggeringFormTemplatesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedUpdateWithoutFormSubmissionsInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  title?: Maybe<Scalars['String']>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutTriggeringFormTemplatesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedUpdateWithoutServicesInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutTriggeringFormTemplatesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUncheckedUpdateWithoutTriggeredWorkflowsInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUncheckedUpdateManyWithoutFormTemplateNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUpdateInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormTemplatesNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutFormTemplateNestedInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutFormTemplateNestedInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUpdateManyWithoutFormTemplateNestedInput>;
  title?: Maybe<Scalars['String']>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingUpdateManyWithoutTriggeringFormTemplatesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUpdateManyMutationInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUpdateManyWithWhereWithoutClinicInput = {
  data: FormTemplateUpdateManyMutationInput;
  where: FormTemplateScalarWhereInput;
};

export type FormTemplateUpdateManyWithWhereWithoutTriggeredWorkflowsInput = {
  data: FormTemplateUpdateManyMutationInput;
  where: FormTemplateScalarWhereInput;
};

export type FormTemplateUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<FormTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<FormTemplateCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  set?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  update?: Maybe<Array<FormTemplateUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<FormTemplateUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<FormTemplateUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput = {
  connect?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FormTemplateCreateOrConnectWithoutTriggeredWorkflowsInput>>;
  create?: Maybe<Array<FormTemplateCreateWithoutTriggeredWorkflowsInput>>;
  delete?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FormTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  set?: Maybe<Array<FormTemplateWhereUniqueInput>>;
  update?: Maybe<Array<FormTemplateUpdateWithWhereUniqueWithoutTriggeredWorkflowsInput>>;
  updateMany?: Maybe<Array<FormTemplateUpdateManyWithWhereWithoutTriggeredWorkflowsInput>>;
  upsert?: Maybe<Array<FormTemplateUpsertWithWhereUniqueWithoutTriggeredWorkflowsInput>>;
};

export type FormTemplateUpdateOneWithoutClinicWidgetRequestTypesNestedInput = {
  connect?: Maybe<FormTemplateWhereUniqueInput>;
  connectOrCreate?: Maybe<FormTemplateCreateOrConnectWithoutClinicWidgetRequestTypesInput>;
  create?: Maybe<FormTemplateCreateWithoutClinicWidgetRequestTypesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FormTemplateUpdateToOneWithWhereWithoutClinicWidgetRequestTypesInput>;
  upsert?: Maybe<FormTemplateUpsertWithoutClinicWidgetRequestTypesInput>;
};

export type FormTemplateUpdateOneWithoutFormSubmissionsNestedInput = {
  connect?: Maybe<FormTemplateWhereUniqueInput>;
  connectOrCreate?: Maybe<FormTemplateCreateOrConnectWithoutFormSubmissionsInput>;
  create?: Maybe<FormTemplateCreateWithoutFormSubmissionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FormTemplateUpdateToOneWithWhereWithoutFormSubmissionsInput>;
  upsert?: Maybe<FormTemplateUpsertWithoutFormSubmissionsInput>;
};

export type FormTemplateUpdateOneWithoutServicesNestedInput = {
  connect?: Maybe<FormTemplateWhereUniqueInput>;
  connectOrCreate?: Maybe<FormTemplateCreateOrConnectWithoutServicesInput>;
  create?: Maybe<FormTemplateCreateWithoutServicesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FormTemplateUpdateToOneWithWhereWithoutServicesInput>;
  upsert?: Maybe<FormTemplateUpsertWithoutServicesInput>;
};

export type FormTemplateUpdateToOneWithWhereWithoutClinicWidgetRequestTypesInput = {
  data: FormTemplateUpdateWithoutClinicWidgetRequestTypesInput;
  where?: Maybe<FormTemplateWhereInput>;
};

export type FormTemplateUpdateToOneWithWhereWithoutFormSubmissionsInput = {
  data: FormTemplateUpdateWithoutFormSubmissionsInput;
  where?: Maybe<FormTemplateWhereInput>;
};

export type FormTemplateUpdateToOneWithWhereWithoutServicesInput = {
  data: FormTemplateUpdateWithoutServicesInput;
  where?: Maybe<FormTemplateWhereInput>;
};

export type FormTemplateUpdateWithWhereUniqueWithoutClinicInput = {
  data: FormTemplateUpdateWithoutClinicInput;
  where: FormTemplateWhereUniqueInput;
};

export type FormTemplateUpdateWithWhereUniqueWithoutTriggeredWorkflowsInput = {
  data: FormTemplateUpdateWithoutTriggeredWorkflowsInput;
  where: FormTemplateWhereUniqueInput;
};

export type FormTemplateUpdateWithoutClinicInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutFormTemplateNestedInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutFormTemplateNestedInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUpdateManyWithoutFormTemplateNestedInput>;
  title?: Maybe<Scalars['String']>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingUpdateManyWithoutTriggeringFormTemplatesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUpdateWithoutClinicWidgetRequestTypesInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormTemplatesNestedInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutFormTemplateNestedInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUpdateManyWithoutFormTemplateNestedInput>;
  title?: Maybe<Scalars['String']>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingUpdateManyWithoutTriggeringFormTemplatesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUpdateWithoutFormSubmissionsInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormTemplatesNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutFormTemplateNestedInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUpdateManyWithoutFormTemplateNestedInput>;
  title?: Maybe<Scalars['String']>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingUpdateManyWithoutTriggeringFormTemplatesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUpdateWithoutServicesInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormTemplatesNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutFormTemplateNestedInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutFormTemplateNestedInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingUpdateManyWithoutTriggeringFormTemplatesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUpdateWithoutTriggeredWorkflowsInput = {
  autoExportEnabled?: Maybe<Scalars['Boolean']>;
  clinic?: Maybe<ClinicUpdateOneWithoutFormTemplatesNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutFormTemplateNestedInput>;
  content?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftContent?: Maybe<Scalars['Json']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutFormTemplateNestedInput>;
  formTemplateType?: Maybe<FormTemplateType>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  services?: Maybe<ServiceUpdateManyWithoutFormTemplateNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormTemplateUpsertWithWhereUniqueWithoutClinicInput = {
  create: FormTemplateCreateWithoutClinicInput;
  update: FormTemplateUpdateWithoutClinicInput;
  where: FormTemplateWhereUniqueInput;
};

export type FormTemplateUpsertWithWhereUniqueWithoutTriggeredWorkflowsInput = {
  create: FormTemplateCreateWithoutTriggeredWorkflowsInput;
  update: FormTemplateUpdateWithoutTriggeredWorkflowsInput;
  where: FormTemplateWhereUniqueInput;
};

export type FormTemplateUpsertWithoutClinicWidgetRequestTypesInput = {
  create: FormTemplateCreateWithoutClinicWidgetRequestTypesInput;
  update: FormTemplateUpdateWithoutClinicWidgetRequestTypesInput;
  where?: Maybe<FormTemplateWhereInput>;
};

export type FormTemplateUpsertWithoutFormSubmissionsInput = {
  create: FormTemplateCreateWithoutFormSubmissionsInput;
  update: FormTemplateUpdateWithoutFormSubmissionsInput;
  where?: Maybe<FormTemplateWhereInput>;
};

export type FormTemplateUpsertWithoutServicesInput = {
  create: FormTemplateCreateWithoutServicesInput;
  update: FormTemplateUpdateWithoutServicesInput;
  where?: Maybe<FormTemplateWhereInput>;
};

export type FormTemplateWhereInput = {
  AND?: Maybe<Array<FormTemplateWhereInput>>;
  NOT?: Maybe<Array<FormTemplateWhereInput>>;
  OR?: Maybe<Array<FormTemplateWhereInput>>;
  autoExportEnabled?: Maybe<BoolFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  content?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draftContent?: Maybe<JsonNullableFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  formTemplateType?: Maybe<EnumFormTemplateTypeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  services?: Maybe<ServiceListRelationFilter>;
  title?: Maybe<StringFilter>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type FormTemplateWhereUniqueInput = {
  AND?: Maybe<Array<FormTemplateWhereInput>>;
  NOT?: Maybe<Array<FormTemplateWhereInput>>;
  OR?: Maybe<Array<FormTemplateWhereInput>>;
  autoExportEnabled?: Maybe<BoolFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  content?: Maybe<JsonNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draftContent?: Maybe<JsonNullableFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  formTemplateType?: Maybe<EnumFormTemplateTypeFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolNullableFilter>;
  services?: Maybe<ServiceListRelationFilter>;
  title?: Maybe<StringFilter>;
  triggeredWorkflows?: Maybe<WorkflowEventSettingListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type GenerateCustomTokenResponse = {
  __typename?: 'GenerateCustomTokenResponse';
  token?: Maybe<Scalars['String']>;
};

export type GeneratePetIdPdfInput = {
  petId: Scalars['String'];
  petParentId: Scalars['String'];
};

export type GeneratePetIdPdfResponse = {
  __typename?: 'GeneratePetIdPdfResponse';
  base64PDF?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type GenerateTerminalAuthTokenResponse = {
  __typename?: 'GenerateTerminalAuthTokenResponse';
  terminal: StripeTerminal;
  token: Scalars['String'];
};

export type GenerateTerminalSetupPinResponse = {
  __typename?: 'GenerateTerminalSetupPinResponse';
  pin: Scalars['String'];
};

export type GenerateTinyUrlAndTokenInput = {
  clinicPetParentId: Scalars['String'];
};

export type GenerateWidgetAuthenticationRequestResponse = {
  __typename?: 'GenerateWidgetAuthenticationRequestResponse';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type GenericActivityLog = {
  __typename?: 'GenericActivityLog';
  id: Scalars['String'];
};

export type GenericClinicIdInput = {
  clinicId?: Maybe<Scalars['ID']>;
};

export type GenericResponse = {
  __typename?: 'GenericResponse';
  payload?: Maybe<Scalars['Json']>;
  success: Scalars['Boolean'];
};

export type GeocodeSalesforceAccountResponse = {
  __typename?: 'GeocodeSalesforceAccountResponse';
  error?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  salesforceAccountId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type GetAppointmentRecapUrlInput = {
  recapId: Scalars['String'];
};

export type GetBalanceForClientInput = {
  clinicPetParentId: Scalars['String'];
};

export type GetChannelStatusIdsWithEntityCountOfZeroWhere = {
  channelStatusIds: Array<Scalars['String']>;
  clinicId: Scalars['String'];
  end?: Maybe<Scalars['DateTime']>;
  entity: ChannelStatusEntity;
  start?: Maybe<Scalars['DateTime']>;
};

export type GetDirectedAuthLinkResult = {
  __typename?: 'GetDirectedAuthLinkResult';
  link: Scalars['String'];
};

export type GetDisbursementsInput = {
  clinicId: Scalars['String'];
  timestamp: GetFinancialTransactionsTimestamp;
};

export type GetDisbursementsOutput = {
  __typename?: 'GetDisbursementsOutput';
  data: Array<Maybe<StripePayout>>;
  total: Scalars['Int'];
};

export type GetDisputesInput = {
  clinicId: Scalars['String'];
  disputeStatusFiltering?: Maybe<StripeDisputeStatus>;
  includeSubscriptions?: Maybe<Scalars['Boolean']>;
  timestamp?: Maybe<GetFinancialTransactionsTimestamp>;
};

export type GetDisputesOutput = {
  __typename?: 'GetDisputesOutput';
  data: Array<Maybe<StripeDispute>>;
  total: Scalars['Int'];
};

export type GetEntityHistoryInput = {
  id: Scalars['String'];
};

export type GetEntityHistoryOutput = {
  __typename?: 'GetEntityHistoryOutput';
  data: Scalars['String'];
};

export type GetFinancialTransactionTotalsInput = {
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  clientName?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  includeSubscriptions: Scalars['Boolean'];
  reportFilterTab: ReportFilterTab;
  stripePayoutId?: Maybe<Scalars['String']>;
  terminalNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  timestamp?: Maybe<GetFinancialTransactionsTimestamp>;
};

export type GetFinancialTransactionTotalsOutput = {
  __typename?: 'GetFinancialTransactionTotalsOutput';
  amount: Scalars['Int'];
  clientFees: Scalars['Int'];
  invoiced: Scalars['Int'];
  netProceeds: Scalars['Int'];
  refunded: Scalars['Int'];
  transactionFees: Scalars['Int'];
};

export type GetFinancialTransactionsInput = {
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  clientName?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  includeSubscriptions: Scalars['Boolean'];
  reportFilterTab: ReportFilterTab;
  stripePayoutId?: Maybe<Scalars['String']>;
  terminalNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  timestamp?: Maybe<GetFinancialTransactionsTimestamp>;
};

export type GetFinancialTransactionsOutput = {
  __typename?: 'GetFinancialTransactionsOutput';
  data: Array<Maybe<PaymentsReportTransaction>>;
  total: Scalars['Int'];
};

export type GetFinancialTransactionsTimestamp = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type GetLatestActiveSubscriptionInvoiceOutput = {
  __typename?: 'GetLatestActiveSubscriptionInvoiceOutput';
  paymentAmountNeeded: Scalars['Int'];
  paymentAmountReceived: Scalars['Int'];
  paymentIntentSecret: Scalars['String'];
  subscriptionStatus: Scalars['String'];
};

export type GetOrCreateActiveChannelInput = {
  clinicPetParentIds: Array<Scalars['String']>;
};

export type GetOrCreateActiveClientChannelInput = {
  clinicPetParentIds: Array<Scalars['String']>;
};

export type GetPetIdDataInput = {
  petId: Scalars['String'];
  petParentId: Scalars['String'];
};

export type GetPetIdDataResponse = {
  __typename?: 'GetPetIdDataResponse';
  clinic: Clinic;
  history: Array<PetIdHistoryItem>;
  pet: ClinicPet;
  petParent: ClinicPetParent;
};

export type GetSignedUploadInput = {
  contentType: Scalars['String'];
  isPublic?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  overrideClinicIdWith?: Maybe<Scalars['String']>;
};

export type GetSignedUploadUrlOutput = {
  __typename?: 'GetSignedUploadUrlOutput';
  cloudfrontUrl: Scalars['String'];
  finalUrl: Scalars['String'];
  key: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type GlobalPetParent = {
  __typename?: 'GlobalPetParent';
  _count: GlobalPetParentCountOutputType;
  /** all related clinic pet parents */
  clinicPetParents: Array<ClinicPetParent>;
  createdAt: Scalars['DateTime'];
  /** Used for matching */
  email: Scalars['String'];
  id: Scalars['String'];
  /** Used as a secondary characteristic for matching */
  primaryPhoneNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type GlobalPetParentClinicPetParentsArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type GlobalPetParentCountAggregateOutputType = {
  __typename?: 'GlobalPetParentCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  email: Scalars['Int'];
  id: Scalars['Int'];
  primaryPhoneNumber: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type GlobalPetParentCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  primaryPhoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type GlobalPetParentCountOutputType = {
  __typename?: 'GlobalPetParentCountOutputType';
  clinicPetParents: Scalars['Int'];
};

export type GlobalPetParentCreateInput = {
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutGlobalPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentCreateNestedOneWithoutClinicPetParentsInput = {
  connect?: Maybe<GlobalPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<GlobalPetParentCreateOrConnectWithoutClinicPetParentsInput>;
  create?: Maybe<GlobalPetParentCreateWithoutClinicPetParentsInput>;
};

export type GlobalPetParentCreateOrConnectWithoutClinicPetParentsInput = {
  create: GlobalPetParentCreateWithoutClinicPetParentsInput;
  where: GlobalPetParentWhereUniqueInput;
};

export type GlobalPetParentCreateWithoutClinicPetParentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentGroupByOutputType = {
  __typename?: 'GlobalPetParentGroupByOutputType';
  _count?: Maybe<GlobalPetParentCountAggregateOutputType>;
  _max?: Maybe<GlobalPetParentMaxAggregateOutputType>;
  _min?: Maybe<GlobalPetParentMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  primaryPhoneNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type GlobalPetParentMaxAggregateOutputType = {
  __typename?: 'GlobalPetParentMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  primaryPhoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type GlobalPetParentMinAggregateOutputType = {
  __typename?: 'GlobalPetParentMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  primaryPhoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type GlobalPetParentNullableScalarRelationFilter = {
  AND?: Maybe<Array<GlobalPetParentWhereInput>>;
  NOT?: Maybe<Array<GlobalPetParentWhereInput>>;
  OR?: Maybe<Array<GlobalPetParentWhereInput>>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  primaryPhoneNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type GlobalPetParentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<GlobalPetParentOrderByRelevanceInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  primaryPhoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum GlobalPetParentOrderByRelevanceFieldEnum {
  Email = 'email',
  Id = 'id',
  PrimaryPhoneNumber = 'primaryPhoneNumber'
}

export type GlobalPetParentOrderByRelevanceInput = {
  fields: Array<GlobalPetParentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type GlobalPetParentOrderByWithAggregationInput = {
  _count?: Maybe<GlobalPetParentCountOrderByAggregateInput>;
  _max?: Maybe<GlobalPetParentMaxOrderByAggregateInput>;
  _min?: Maybe<GlobalPetParentMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  primaryPhoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type GlobalPetParentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<GlobalPetParentOrderByRelevanceInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  primaryPhoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type GlobalPetParentOrderByWithRelationInput = {
  _relevance?: Maybe<GlobalPetParentOrderByRelevanceInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  primaryPhoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum GlobalPetParentScalarFieldEnum {
  CreatedAt = 'createdAt',
  Email = 'email',
  Id = 'id',
  PrimaryPhoneNumber = 'primaryPhoneNumber',
  UpdatedAt = 'updatedAt'
}

export type GlobalPetParentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<GlobalPetParentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<GlobalPetParentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<GlobalPetParentScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  email?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  primaryPhoneNumber?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type GlobalPetParentUncheckedCreateInput = {
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutGlobalPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentUncheckedCreateWithoutClinicPetParentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentUncheckedUpdateInput = {
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutGlobalPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentUncheckedUpdateWithoutClinicPetParentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentUpdateInput = {
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutGlobalPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentUpdateOneWithoutClinicPetParentsNestedInput = {
  connect?: Maybe<GlobalPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<GlobalPetParentCreateOrConnectWithoutClinicPetParentsInput>;
  create?: Maybe<GlobalPetParentCreateWithoutClinicPetParentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<GlobalPetParentUpdateToOneWithWhereWithoutClinicPetParentsInput>;
  upsert?: Maybe<GlobalPetParentUpsertWithoutClinicPetParentsInput>;
};

export type GlobalPetParentUpdateToOneWithWhereWithoutClinicPetParentsInput = {
  data: GlobalPetParentUpdateWithoutClinicPetParentsInput;
  where?: Maybe<GlobalPetParentWhereInput>;
};

export type GlobalPetParentUpdateWithoutClinicPetParentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalPetParentUpsertWithoutClinicPetParentsInput = {
  create: GlobalPetParentCreateWithoutClinicPetParentsInput;
  update: GlobalPetParentUpdateWithoutClinicPetParentsInput;
  where?: Maybe<GlobalPetParentWhereInput>;
};

export type GlobalPetParentWhereInput = {
  AND?: Maybe<Array<GlobalPetParentWhereInput>>;
  NOT?: Maybe<Array<GlobalPetParentWhereInput>>;
  OR?: Maybe<Array<GlobalPetParentWhereInput>>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  primaryPhoneNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type GlobalPetParentWhereUniqueInput = {
  AND?: Maybe<Array<GlobalPetParentWhereInput>>;
  NOT?: Maybe<Array<GlobalPetParentWhereInput>>;
  OR?: Maybe<Array<GlobalPetParentWhereInput>>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryPhoneNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type GooglePlace = {
  __typename?: 'GooglePlace';
  _count: GooglePlaceCountOutputType;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informPartnerCustomers: Array<InformPartnerCustomer>;
  placeId: Scalars['String'];
  response: Scalars['Json'];
};


export type GooglePlaceClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type GooglePlaceInformPartnerCustomersArgs = {
  cursor?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};

export type GooglePlaceCountAggregateOutputType = {
  __typename?: 'GooglePlaceCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  placeId: Scalars['Int'];
  response: Scalars['Int'];
};

export type GooglePlaceCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  placeId?: Maybe<SortOrder>;
  response?: Maybe<SortOrder>;
};

export type GooglePlaceCountOutputType = {
  __typename?: 'GooglePlaceCountOutputType';
  informPartnerCustomers: Scalars['Int'];
};

export type GooglePlaceCreateInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutGooglePlaceInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutGooglePlaceInput>;
  placeId: Scalars['String'];
  response: Scalars['Json'];
};

export type GooglePlaceCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  placeId: Scalars['String'];
  response: Scalars['Json'];
};

export type GooglePlaceCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<GooglePlaceWhereUniqueInput>;
  connectOrCreate?: Maybe<GooglePlaceCreateOrConnectWithoutClinicInput>;
  create?: Maybe<GooglePlaceCreateWithoutClinicInput>;
};

export type GooglePlaceCreateNestedOneWithoutInformPartnerCustomersInput = {
  connect?: Maybe<GooglePlaceWhereUniqueInput>;
  connectOrCreate?: Maybe<GooglePlaceCreateOrConnectWithoutInformPartnerCustomersInput>;
  create?: Maybe<GooglePlaceCreateWithoutInformPartnerCustomersInput>;
};

export type GooglePlaceCreateOrConnectWithoutClinicInput = {
  create: GooglePlaceCreateWithoutClinicInput;
  where: GooglePlaceWhereUniqueInput;
};

export type GooglePlaceCreateOrConnectWithoutInformPartnerCustomersInput = {
  create: GooglePlaceCreateWithoutInformPartnerCustomersInput;
  where: GooglePlaceWhereUniqueInput;
};

export type GooglePlaceCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutGooglePlaceInput>;
  placeId: Scalars['String'];
  response: Scalars['Json'];
};

export type GooglePlaceCreateWithoutInformPartnerCustomersInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutGooglePlaceInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  placeId: Scalars['String'];
  response: Scalars['Json'];
};

export type GooglePlaceGroupByOutputType = {
  __typename?: 'GooglePlaceGroupByOutputType';
  _count?: Maybe<GooglePlaceCountAggregateOutputType>;
  _max?: Maybe<GooglePlaceMaxAggregateOutputType>;
  _min?: Maybe<GooglePlaceMinAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  placeId: Scalars['String'];
  response: Scalars['Json'];
};

export type GooglePlaceMaxAggregateOutputType = {
  __typename?: 'GooglePlaceMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
};

export type GooglePlaceMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  placeId?: Maybe<SortOrder>;
};

export type GooglePlaceMinAggregateOutputType = {
  __typename?: 'GooglePlaceMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
};

export type GooglePlaceMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  placeId?: Maybe<SortOrder>;
};

export type GooglePlaceNullableScalarRelationFilter = {
  AND?: Maybe<Array<GooglePlaceWhereInput>>;
  NOT?: Maybe<Array<GooglePlaceWhereInput>>;
  OR?: Maybe<Array<GooglePlaceWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  placeId?: Maybe<StringFilter>;
  response?: Maybe<JsonFilter>;
};

export type GooglePlaceOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<GooglePlaceOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  placeId?: Maybe<SortOrder>;
  response?: Maybe<SortOrder>;
};

export enum GooglePlaceOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  PlaceId = 'placeId'
}

export type GooglePlaceOrderByRelevanceInput = {
  fields: Array<GooglePlaceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type GooglePlaceOrderByWithAggregationInput = {
  _count?: Maybe<GooglePlaceCountOrderByAggregateInput>;
  _max?: Maybe<GooglePlaceMaxOrderByAggregateInput>;
  _min?: Maybe<GooglePlaceMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  placeId?: Maybe<SortOrder>;
  response?: Maybe<SortOrder>;
};

export type GooglePlaceOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<GooglePlaceOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  placeId?: Maybe<SortOrder>;
  response?: Maybe<SortOrder>;
};

export type GooglePlaceOrderByWithRelationInput = {
  _relevance?: Maybe<GooglePlaceOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  placeId?: Maybe<SortOrder>;
  response?: Maybe<SortOrder>;
};

export enum GooglePlaceScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  PlaceId = 'placeId',
  Response = 'response'
}

export type GooglePlaceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<GooglePlaceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<GooglePlaceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<GooglePlaceScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  placeId?: Maybe<StringWithAggregatesFilter>;
  response?: Maybe<JsonWithAggregatesFilter>;
};

export type GooglePlaceUncheckedCreateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutGooglePlaceInput>;
  placeId: Scalars['String'];
  response: Scalars['Json'];
};

export type GooglePlaceUncheckedCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<GooglePlaceWhereUniqueInput>;
  connectOrCreate?: Maybe<GooglePlaceCreateOrConnectWithoutClinicInput>;
  create?: Maybe<GooglePlaceCreateWithoutClinicInput>;
};

export type GooglePlaceUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutGooglePlaceInput>;
  placeId: Scalars['String'];
  response: Scalars['Json'];
};

export type GooglePlaceUncheckedCreateWithoutInformPartnerCustomersInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  placeId: Scalars['String'];
  response: Scalars['Json'];
};

export type GooglePlaceUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutGooglePlaceNestedInput>;
  placeId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
};

export type GooglePlaceUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
};

export type GooglePlaceUncheckedUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<GooglePlaceWhereUniqueInput>;
  connectOrCreate?: Maybe<GooglePlaceCreateOrConnectWithoutClinicInput>;
  create?: Maybe<GooglePlaceCreateWithoutClinicInput>;
  delete?: Maybe<GooglePlaceWhereInput>;
  disconnect?: Maybe<GooglePlaceWhereInput>;
  update?: Maybe<GooglePlaceUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<GooglePlaceUpsertWithoutClinicInput>;
};

export type GooglePlaceUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutGooglePlaceNestedInput>;
  placeId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
};

export type GooglePlaceUncheckedUpdateWithoutInformPartnerCustomersInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
};

export type GooglePlaceUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutGooglePlaceNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutGooglePlaceNestedInput>;
  placeId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
};

export type GooglePlaceUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
};

export type GooglePlaceUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<GooglePlaceWhereUniqueInput>;
  connectOrCreate?: Maybe<GooglePlaceCreateOrConnectWithoutClinicInput>;
  create?: Maybe<GooglePlaceCreateWithoutClinicInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<GooglePlaceUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<GooglePlaceUpsertWithoutClinicInput>;
};

export type GooglePlaceUpdateOneWithoutInformPartnerCustomersNestedInput = {
  connect?: Maybe<GooglePlaceWhereUniqueInput>;
  connectOrCreate?: Maybe<GooglePlaceCreateOrConnectWithoutInformPartnerCustomersInput>;
  create?: Maybe<GooglePlaceCreateWithoutInformPartnerCustomersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<GooglePlaceUpdateToOneWithWhereWithoutInformPartnerCustomersInput>;
  upsert?: Maybe<GooglePlaceUpsertWithoutInformPartnerCustomersInput>;
};

export type GooglePlaceUpdateToOneWithWhereWithoutClinicInput = {
  data: GooglePlaceUpdateWithoutClinicInput;
  where?: Maybe<GooglePlaceWhereInput>;
};

export type GooglePlaceUpdateToOneWithWhereWithoutInformPartnerCustomersInput = {
  data: GooglePlaceUpdateWithoutInformPartnerCustomersInput;
  where?: Maybe<GooglePlaceWhereInput>;
};

export type GooglePlaceUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutGooglePlaceNestedInput>;
  placeId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
};

export type GooglePlaceUpdateWithoutInformPartnerCustomersInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutGooglePlaceNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
};

export type GooglePlaceUpsertWithoutClinicInput = {
  create: GooglePlaceCreateWithoutClinicInput;
  update: GooglePlaceUpdateWithoutClinicInput;
  where?: Maybe<GooglePlaceWhereInput>;
};

export type GooglePlaceUpsertWithoutInformPartnerCustomersInput = {
  create: GooglePlaceCreateWithoutInformPartnerCustomersInput;
  update: GooglePlaceUpdateWithoutInformPartnerCustomersInput;
  where?: Maybe<GooglePlaceWhereInput>;
};

export type GooglePlaceWhereInput = {
  AND?: Maybe<Array<GooglePlaceWhereInput>>;
  NOT?: Maybe<Array<GooglePlaceWhereInput>>;
  OR?: Maybe<Array<GooglePlaceWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  placeId?: Maybe<StringFilter>;
  response?: Maybe<JsonFilter>;
};

export type GooglePlaceWhereUniqueInput = {
  AND?: Maybe<Array<GooglePlaceWhereInput>>;
  NOT?: Maybe<Array<GooglePlaceWhereInput>>;
  OR?: Maybe<Array<GooglePlaceWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  placeId?: Maybe<Scalars['String']>;
  response?: Maybe<JsonFilter>;
};

export type HasCarePetWithEnrollmentOutput = {
  __typename?: 'HasCarePetWithEnrollmentOutput';
  hasEnrolledPet: Scalars['Boolean'];
};

export type HasCarePetWithEnrollmentWhereInput = {
  organizationPetParentId: Scalars['String'];
};

export type HasConflictingAppointmentInput = {
  appointmentTypeId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  startAt: Scalars['DateTime'];
};

export type HillsToHomeApiLog = {
  __typename?: 'HillsToHomeAPILog';
  automationRun?: Maybe<AutomationRun>;
  automationRunId?: Maybe<Scalars['String']>;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt: Scalars['DateTime'];
};


export type HillsToHomeApiLogAutomationRunArgs = {
  where?: Maybe<AutomationRunWhereInput>;
};


export type HillsToHomeApiLogChannelArgs = {
  where?: Maybe<ChannelWhereInput>;
};


export type HillsToHomeApiLogClinicPetArgs = {
  where?: Maybe<ClinicPetWhereInput>;
};


export type HillsToHomeApiLogClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type HillsToHomeApiLogCountAggregateOutputType = {
  __typename?: 'HillsToHomeAPILogCountAggregateOutputType';
  _all: Scalars['Int'];
  automationRunId: Scalars['Int'];
  channelId: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  petParentId: Scalars['Int'];
  products: Scalars['Int'];
  response: Scalars['Int'];
  resultType: Scalars['Int'];
  shipTo: Scalars['Int'];
  species: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type HillsToHomeApiLogCountOrderByAggregateInput = {
  automationRunId?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  products?: Maybe<SortOrder>;
  response?: Maybe<SortOrder>;
  resultType?: Maybe<SortOrder>;
  shipTo?: Maybe<SortOrder>;
  species?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type HillsToHomeApiLogCreateInput = {
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutHillsToHomeApiLogInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutHillsToHomeApiLogInput>;
  clinic: ClinicCreateNestedOneWithoutHillsToHomeApiLogInput;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutHillsToHomeApiLogInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutHillsToHomeApiLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogCreateManyAutomationRunInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogCreateManyAutomationRunInputEnvelope = {
  data: Array<HillsToHomeApiLogCreateManyAutomationRunInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type HillsToHomeApiLogCreateManyChannelInput = {
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogCreateManyChannelInputEnvelope = {
  data: Array<HillsToHomeApiLogCreateManyChannelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type HillsToHomeApiLogCreateManyClinicInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogCreateManyClinicInputEnvelope = {
  data: Array<HillsToHomeApiLogCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type HillsToHomeApiLogCreateManyClinicPetInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogCreateManyClinicPetInputEnvelope = {
  data: Array<HillsToHomeApiLogCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type HillsToHomeApiLogCreateManyClinicPetParentInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogCreateManyClinicPetParentInputEnvelope = {
  data: Array<HillsToHomeApiLogCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type HillsToHomeApiLogCreateManyInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogCreateNestedManyWithoutAutomationRunInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyAutomationRunInputEnvelope>;
};

export type HillsToHomeApiLogCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutChannelInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyChannelInputEnvelope>;
};

export type HillsToHomeApiLogCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutClinicInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyClinicInputEnvelope>;
};

export type HillsToHomeApiLogCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutClinicPetInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyClinicPetInputEnvelope>;
};

export type HillsToHomeApiLogCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyClinicPetParentInputEnvelope>;
};

export type HillsToHomeApiLogCreateOrConnectWithoutAutomationRunInput = {
  create: HillsToHomeApiLogCreateWithoutAutomationRunInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogCreateOrConnectWithoutChannelInput = {
  create: HillsToHomeApiLogCreateWithoutChannelInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogCreateOrConnectWithoutClinicInput = {
  create: HillsToHomeApiLogCreateWithoutClinicInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogCreateOrConnectWithoutClinicPetInput = {
  create: HillsToHomeApiLogCreateWithoutClinicPetInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogCreateOrConnectWithoutClinicPetParentInput = {
  create: HillsToHomeApiLogCreateWithoutClinicPetParentInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogCreateWithoutAutomationRunInput = {
  channel?: Maybe<ChannelCreateNestedOneWithoutHillsToHomeApiLogInput>;
  clinic: ClinicCreateNestedOneWithoutHillsToHomeApiLogInput;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutHillsToHomeApiLogInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutHillsToHomeApiLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogCreateWithoutChannelInput = {
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutHillsToHomeApiLogInput>;
  clinic: ClinicCreateNestedOneWithoutHillsToHomeApiLogInput;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutHillsToHomeApiLogInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutHillsToHomeApiLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogCreateWithoutClinicInput = {
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutHillsToHomeApiLogInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutHillsToHomeApiLogInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutHillsToHomeApiLogInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutHillsToHomeApiLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogCreateWithoutClinicPetInput = {
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutHillsToHomeApiLogInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutHillsToHomeApiLogInput>;
  clinic: ClinicCreateNestedOneWithoutHillsToHomeApiLogInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutHillsToHomeApiLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogCreateWithoutClinicPetParentInput = {
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutHillsToHomeApiLogInput>;
  channel?: Maybe<ChannelCreateNestedOneWithoutHillsToHomeApiLogInput>;
  clinic: ClinicCreateNestedOneWithoutHillsToHomeApiLogInput;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutHillsToHomeApiLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogGroupByOutputType = {
  __typename?: 'HillsToHomeAPILogGroupByOutputType';
  _count?: Maybe<HillsToHomeApiLogCountAggregateOutputType>;
  _max?: Maybe<HillsToHomeApiLogMaxAggregateOutputType>;
  _min?: Maybe<HillsToHomeApiLogMinAggregateOutputType>;
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt: Scalars['DateTime'];
};

export type HillsToHomeApiLogListRelationFilter = {
  every?: Maybe<HillsToHomeApiLogWhereInput>;
  none?: Maybe<HillsToHomeApiLogWhereInput>;
  some?: Maybe<HillsToHomeApiLogWhereInput>;
};

export type HillsToHomeApiLogMaxAggregateOutputType = {
  __typename?: 'HillsToHomeAPILogMaxAggregateOutputType';
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogMaxOrderByAggregateInput = {
  automationRunId?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  products?: Maybe<SortOrder>;
  resultType?: Maybe<SortOrder>;
  shipTo?: Maybe<SortOrder>;
  species?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type HillsToHomeApiLogMinAggregateOutputType = {
  __typename?: 'HillsToHomeAPILogMinAggregateOutputType';
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogMinOrderByAggregateInput = {
  automationRunId?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  products?: Maybe<SortOrder>;
  resultType?: Maybe<SortOrder>;
  shipTo?: Maybe<SortOrder>;
  species?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type HillsToHomeApiLogOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type HillsToHomeApiLogOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<HillsToHomeApiLogOrderByRelevanceInput>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  products?: Maybe<SortOrder>;
  response?: Maybe<SortOrder>;
  resultType?: Maybe<SortOrder>;
  shipTo?: Maybe<SortOrder>;
  species?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum HillsToHomeApiLogOrderByRelevanceFieldEnum {
  AutomationRunId = 'automationRunId',
  ChannelId = 'channelId',
  ClinicId = 'clinicId',
  ClinicPetId = 'clinicPetId',
  Id = 'id',
  PetParentId = 'petParentId',
  Products = 'products',
  ShipTo = 'shipTo'
}

export type HillsToHomeApiLogOrderByRelevanceInput = {
  fields: Array<HillsToHomeApiLogOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type HillsToHomeApiLogOrderByWithAggregationInput = {
  _count?: Maybe<HillsToHomeApiLogCountOrderByAggregateInput>;
  _max?: Maybe<HillsToHomeApiLogMaxOrderByAggregateInput>;
  _min?: Maybe<HillsToHomeApiLogMinOrderByAggregateInput>;
  automationRunId?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  products?: Maybe<SortOrder>;
  response?: Maybe<SortOrder>;
  resultType?: Maybe<SortOrder>;
  shipTo?: Maybe<SortOrder>;
  species?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type HillsToHomeApiLogOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<HillsToHomeApiLogOrderByRelevanceInput>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  products?: Maybe<SortOrder>;
  response?: Maybe<SortOrder>;
  resultType?: Maybe<SortOrder>;
  shipTo?: Maybe<SortOrder>;
  species?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type HillsToHomeApiLogOrderByWithRelationInput = {
  _relevance?: Maybe<HillsToHomeApiLogOrderByRelevanceInput>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  channel?: Maybe<ChannelOrderByWithRelationInput>;
  channelId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  products?: Maybe<SortOrder>;
  response?: Maybe<SortOrder>;
  resultType?: Maybe<SortOrder>;
  shipTo?: Maybe<SortOrder>;
  species?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum HillsToHomeApiLogScalarFieldEnum {
  AutomationRunId = 'automationRunId',
  ChannelId = 'channelId',
  ClinicId = 'clinicId',
  ClinicPetId = 'clinicPetId',
  CreatedAt = 'createdAt',
  Id = 'id',
  PetParentId = 'petParentId',
  Products = 'products',
  Response = 'response',
  ResultType = 'resultType',
  ShipTo = 'shipTo',
  Species = 'species',
  UpdatedAt = 'updatedAt'
}

export type HillsToHomeApiLogScalarWhereInput = {
  AND?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  NOT?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  OR?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  automationRunId?: Maybe<StringNullableFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  products?: Maybe<StringNullableFilter>;
  response?: Maybe<JsonFilter>;
  resultType?: Maybe<EnumHillsToHomeResultTypeFilter>;
  shipTo?: Maybe<StringNullableFilter>;
  species?: Maybe<EnumHillsToHomeSpeciesNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type HillsToHomeApiLogScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<HillsToHomeApiLogScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<HillsToHomeApiLogScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<HillsToHomeApiLogScalarWhereWithAggregatesInput>>;
  automationRunId?: Maybe<StringNullableWithAggregatesFilter>;
  channelId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  clinicPetId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  petParentId?: Maybe<StringNullableWithAggregatesFilter>;
  products?: Maybe<StringNullableWithAggregatesFilter>;
  response?: Maybe<JsonWithAggregatesFilter>;
  resultType?: Maybe<EnumHillsToHomeResultTypeWithAggregatesFilter>;
  shipTo?: Maybe<StringNullableWithAggregatesFilter>;
  species?: Maybe<EnumHillsToHomeSpeciesNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type HillsToHomeApiLogUncheckedCreateInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedCreateNestedManyWithoutAutomationRunInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyAutomationRunInputEnvelope>;
};

export type HillsToHomeApiLogUncheckedCreateNestedManyWithoutChannelInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutChannelInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyChannelInputEnvelope>;
};

export type HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutClinicInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyClinicInputEnvelope>;
};

export type HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutClinicPetInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyClinicPetInputEnvelope>;
};

export type HillsToHomeApiLogUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyClinicPetParentInputEnvelope>;
};

export type HillsToHomeApiLogUncheckedCreateWithoutAutomationRunInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedCreateWithoutChannelInput = {
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedCreateWithoutClinicInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedCreateWithoutClinicPetInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedCreateWithoutClinicPetParentInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response: Scalars['Json'];
  resultType: HillsToHomeResultType;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedUpdateInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedUpdateManyInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedUpdateManyWithoutAutomationRunNestedInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyAutomationRunInputEnvelope>;
  delete?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  disconnect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  set?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  update?: Maybe<Array<HillsToHomeApiLogUpdateWithWhereUniqueWithoutAutomationRunInput>>;
  updateMany?: Maybe<Array<HillsToHomeApiLogUpdateManyWithWhereWithoutAutomationRunInput>>;
  upsert?: Maybe<Array<HillsToHomeApiLogUpsertWithWhereUniqueWithoutAutomationRunInput>>;
};

export type HillsToHomeApiLogUncheckedUpdateManyWithoutChannelInput = {
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutChannelInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  disconnect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  set?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  update?: Maybe<Array<HillsToHomeApiLogUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<HillsToHomeApiLogUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<HillsToHomeApiLogUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type HillsToHomeApiLogUncheckedUpdateManyWithoutClinicInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutClinicInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  disconnect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  set?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  update?: Maybe<Array<HillsToHomeApiLogUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<HillsToHomeApiLogUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<HillsToHomeApiLogUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutClinicPetInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  disconnect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  set?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  update?: Maybe<Array<HillsToHomeApiLogUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<HillsToHomeApiLogUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<HillsToHomeApiLogUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  disconnect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  set?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  update?: Maybe<Array<HillsToHomeApiLogUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<HillsToHomeApiLogUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<HillsToHomeApiLogUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type HillsToHomeApiLogUncheckedUpdateWithoutAutomationRunInput = {
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedUpdateWithoutChannelInput = {
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedUpdateWithoutClinicInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedUpdateWithoutClinicPetInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUncheckedUpdateWithoutClinicPetParentInput = {
  automationRunId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUpdateInput = {
  automationRun?: Maybe<AutomationRunUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutHillsToHomeApiLogNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUpdateManyWithWhereWithoutAutomationRunInput = {
  data: HillsToHomeApiLogUpdateManyMutationInput;
  where: HillsToHomeApiLogScalarWhereInput;
};

export type HillsToHomeApiLogUpdateManyWithWhereWithoutChannelInput = {
  data: HillsToHomeApiLogUpdateManyMutationInput;
  where: HillsToHomeApiLogScalarWhereInput;
};

export type HillsToHomeApiLogUpdateManyWithWhereWithoutClinicInput = {
  data: HillsToHomeApiLogUpdateManyMutationInput;
  where: HillsToHomeApiLogScalarWhereInput;
};

export type HillsToHomeApiLogUpdateManyWithWhereWithoutClinicPetInput = {
  data: HillsToHomeApiLogUpdateManyMutationInput;
  where: HillsToHomeApiLogScalarWhereInput;
};

export type HillsToHomeApiLogUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: HillsToHomeApiLogUpdateManyMutationInput;
  where: HillsToHomeApiLogScalarWhereInput;
};

export type HillsToHomeApiLogUpdateManyWithoutAutomationRunNestedInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyAutomationRunInputEnvelope>;
  delete?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  disconnect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  set?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  update?: Maybe<Array<HillsToHomeApiLogUpdateWithWhereUniqueWithoutAutomationRunInput>>;
  updateMany?: Maybe<Array<HillsToHomeApiLogUpdateManyWithWhereWithoutAutomationRunInput>>;
  upsert?: Maybe<Array<HillsToHomeApiLogUpsertWithWhereUniqueWithoutAutomationRunInput>>;
};

export type HillsToHomeApiLogUpdateManyWithoutChannelNestedInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutChannelInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutChannelInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyChannelInputEnvelope>;
  delete?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  disconnect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  set?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  update?: Maybe<Array<HillsToHomeApiLogUpdateWithWhereUniqueWithoutChannelInput>>;
  updateMany?: Maybe<Array<HillsToHomeApiLogUpdateManyWithWhereWithoutChannelInput>>;
  upsert?: Maybe<Array<HillsToHomeApiLogUpsertWithWhereUniqueWithoutChannelInput>>;
};

export type HillsToHomeApiLogUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutClinicInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  disconnect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  set?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  update?: Maybe<Array<HillsToHomeApiLogUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<HillsToHomeApiLogUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<HillsToHomeApiLogUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type HillsToHomeApiLogUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutClinicPetInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  disconnect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  set?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  update?: Maybe<Array<HillsToHomeApiLogUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<HillsToHomeApiLogUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<HillsToHomeApiLogUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type HillsToHomeApiLogUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<HillsToHomeApiLogCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<HillsToHomeApiLogCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<HillsToHomeApiLogCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<HillsToHomeApiLogScalarWhereInput>>;
  disconnect?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  set?: Maybe<Array<HillsToHomeApiLogWhereUniqueInput>>;
  update?: Maybe<Array<HillsToHomeApiLogUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<HillsToHomeApiLogUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<HillsToHomeApiLogUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type HillsToHomeApiLogUpdateWithWhereUniqueWithoutAutomationRunInput = {
  data: HillsToHomeApiLogUpdateWithoutAutomationRunInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogUpdateWithWhereUniqueWithoutChannelInput = {
  data: HillsToHomeApiLogUpdateWithoutChannelInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogUpdateWithWhereUniqueWithoutClinicInput = {
  data: HillsToHomeApiLogUpdateWithoutClinicInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: HillsToHomeApiLogUpdateWithoutClinicPetInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: HillsToHomeApiLogUpdateWithoutClinicPetParentInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogUpdateWithoutAutomationRunInput = {
  channel?: Maybe<ChannelUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutHillsToHomeApiLogNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUpdateWithoutChannelInput = {
  automationRun?: Maybe<AutomationRunUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutHillsToHomeApiLogNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUpdateWithoutClinicInput = {
  automationRun?: Maybe<AutomationRunUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUpdateWithoutClinicPetInput = {
  automationRun?: Maybe<AutomationRunUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutHillsToHomeApiLogNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUpdateWithoutClinicPetParentInput = {
  automationRun?: Maybe<AutomationRunUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  channel?: Maybe<ChannelUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutHillsToHomeApiLogNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutHillsToHomeApiLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Json']>;
  resultType?: Maybe<HillsToHomeResultType>;
  shipTo?: Maybe<Scalars['String']>;
  species?: Maybe<HillsToHomeSpecies>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HillsToHomeApiLogUpsertWithWhereUniqueWithoutAutomationRunInput = {
  create: HillsToHomeApiLogCreateWithoutAutomationRunInput;
  update: HillsToHomeApiLogUpdateWithoutAutomationRunInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogUpsertWithWhereUniqueWithoutChannelInput = {
  create: HillsToHomeApiLogCreateWithoutChannelInput;
  update: HillsToHomeApiLogUpdateWithoutChannelInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogUpsertWithWhereUniqueWithoutClinicInput = {
  create: HillsToHomeApiLogCreateWithoutClinicInput;
  update: HillsToHomeApiLogUpdateWithoutClinicInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: HillsToHomeApiLogCreateWithoutClinicPetInput;
  update: HillsToHomeApiLogUpdateWithoutClinicPetInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: HillsToHomeApiLogCreateWithoutClinicPetParentInput;
  update: HillsToHomeApiLogUpdateWithoutClinicPetParentInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};

export type HillsToHomeApiLogWhereInput = {
  AND?: Maybe<Array<HillsToHomeApiLogWhereInput>>;
  NOT?: Maybe<Array<HillsToHomeApiLogWhereInput>>;
  OR?: Maybe<Array<HillsToHomeApiLogWhereInput>>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  automationRunId?: Maybe<StringNullableFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  products?: Maybe<StringNullableFilter>;
  response?: Maybe<JsonFilter>;
  resultType?: Maybe<EnumHillsToHomeResultTypeFilter>;
  shipTo?: Maybe<StringNullableFilter>;
  species?: Maybe<EnumHillsToHomeSpeciesNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type HillsToHomeApiLogWhereUniqueInput = {
  AND?: Maybe<Array<HillsToHomeApiLogWhereInput>>;
  NOT?: Maybe<Array<HillsToHomeApiLogWhereInput>>;
  OR?: Maybe<Array<HillsToHomeApiLogWhereInput>>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  automationRunId?: Maybe<StringNullableFilter>;
  channel?: Maybe<ChannelNullableScalarRelationFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  petParentId?: Maybe<StringNullableFilter>;
  products?: Maybe<StringNullableFilter>;
  response?: Maybe<JsonFilter>;
  resultType?: Maybe<EnumHillsToHomeResultTypeFilter>;
  shipTo?: Maybe<StringNullableFilter>;
  species?: Maybe<EnumHillsToHomeSpeciesNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum HillsToHomeResultType {
  Error = 'Error',
  Existing = 'Existing',
  New = 'New'
}

export enum HillsToHomeSpecies {
  Cat = 'Cat',
  Dog = 'Dog'
}

export type IdInput = {
  id: Scalars['String'];
};

export enum IgnoreCallAction {
  Ignore = 'Ignore',
  IgnoreAndSendChannelMessage = 'IgnoreAndSendChannelMessage'
}

export type IgnoreOneAxionCallInput = {
  action: IgnoreCallAction;
  callId: Scalars['String'];
  channelMessageText?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

/** @deprecated - 1.0 */
export type Image = {
  __typename?: 'Image';
  _count: ImageCountOutputType;
  consultation: Array<Consultation>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  source: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


/** @deprecated - 1.0 */
export type ImageConsultationArgs = {
  cursor?: Maybe<ConsultationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationWhereInput>;
};

export type ImageCountAggregateOutputType = {
  __typename?: 'ImageCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  source: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ImageCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ImageCountOutputType = {
  __typename?: 'ImageCountOutputType';
  consultation: Scalars['Int'];
};

export type ImageCreateInput = {
  consultation?: Maybe<ConsultationCreateNestedManyWithoutPicsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageCreateNestedManyWithoutConsultationInput = {
  connect?: Maybe<Array<ImageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ImageCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<ImageCreateWithoutConsultationInput>>;
};

export type ImageCreateOrConnectWithoutConsultationInput = {
  create: ImageCreateWithoutConsultationInput;
  where: ImageWhereUniqueInput;
};

export type ImageCreateWithoutConsultationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageGroupByOutputType = {
  __typename?: 'ImageGroupByOutputType';
  _count?: Maybe<ImageCountAggregateOutputType>;
  _max?: Maybe<ImageMaxAggregateOutputType>;
  _min?: Maybe<ImageMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  source: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ImageListRelationFilter = {
  every?: Maybe<ImageWhereInput>;
  none?: Maybe<ImageWhereInput>;
  some?: Maybe<ImageWhereInput>;
};

export type ImageMaxAggregateOutputType = {
  __typename?: 'ImageMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ImageMinAggregateOutputType = {
  __typename?: 'ImageMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ImageOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ImageOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ImageOrderByRelevanceInput>;
  consultation?: Maybe<ConsultationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ImageOrderByRelevanceFieldEnum {
  Id = 'id',
  Source = 'source'
}

export type ImageOrderByRelevanceInput = {
  fields: Array<ImageOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ImageOrderByWithAggregationInput = {
  _count?: Maybe<ImageCountOrderByAggregateInput>;
  _max?: Maybe<ImageMaxOrderByAggregateInput>;
  _min?: Maybe<ImageMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ImageOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ImageOrderByRelevanceInput>;
  consultation?: Maybe<ConsultationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ImageOrderByWithRelationInput = {
  _relevance?: Maybe<ImageOrderByRelevanceInput>;
  consultation?: Maybe<ConsultationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ImageScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Source = 'source',
  UpdatedAt = 'updatedAt'
}

export type ImageScalarWhereInput = {
  AND?: Maybe<Array<ImageScalarWhereInput>>;
  NOT?: Maybe<Array<ImageScalarWhereInput>>;
  OR?: Maybe<Array<ImageScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  source?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ImageScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ImageScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ImageScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ImageScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  source?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ImageUncheckedCreateInput = {
  consultation?: Maybe<ConsultationUncheckedCreateNestedManyWithoutPicsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageUncheckedCreateNestedManyWithoutConsultationInput = {
  connect?: Maybe<Array<ImageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ImageCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<ImageCreateWithoutConsultationInput>>;
};

export type ImageUncheckedCreateWithoutConsultationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageUncheckedUpdateInput = {
  consultation?: Maybe<ConsultationUncheckedUpdateManyWithoutPicsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageUncheckedUpdateManyWithoutConsultationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageUncheckedUpdateManyWithoutConsultationNestedInput = {
  connect?: Maybe<Array<ImageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ImageCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<ImageCreateWithoutConsultationInput>>;
  delete?: Maybe<Array<ImageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ImageScalarWhereInput>>;
  disconnect?: Maybe<Array<ImageWhereUniqueInput>>;
  set?: Maybe<Array<ImageWhereUniqueInput>>;
  update?: Maybe<Array<ImageUpdateWithWhereUniqueWithoutConsultationInput>>;
  updateMany?: Maybe<Array<ImageUpdateManyWithWhereWithoutConsultationInput>>;
  upsert?: Maybe<Array<ImageUpsertWithWhereUniqueWithoutConsultationInput>>;
};

export type ImageUncheckedUpdateWithoutConsultationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageUpdateInput = {
  consultation?: Maybe<ConsultationUpdateManyWithoutPicsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageUpdateManyWithWhereWithoutConsultationInput = {
  data: ImageUpdateManyMutationInput;
  where: ImageScalarWhereInput;
};

export type ImageUpdateManyWithoutConsultationNestedInput = {
  connect?: Maybe<Array<ImageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ImageCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<ImageCreateWithoutConsultationInput>>;
  delete?: Maybe<Array<ImageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ImageScalarWhereInput>>;
  disconnect?: Maybe<Array<ImageWhereUniqueInput>>;
  set?: Maybe<Array<ImageWhereUniqueInput>>;
  update?: Maybe<Array<ImageUpdateWithWhereUniqueWithoutConsultationInput>>;
  updateMany?: Maybe<Array<ImageUpdateManyWithWhereWithoutConsultationInput>>;
  upsert?: Maybe<Array<ImageUpsertWithWhereUniqueWithoutConsultationInput>>;
};

export type ImageUpdateWithWhereUniqueWithoutConsultationInput = {
  data: ImageUpdateWithoutConsultationInput;
  where: ImageWhereUniqueInput;
};

export type ImageUpdateWithoutConsultationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImageUpsertWithWhereUniqueWithoutConsultationInput = {
  create: ImageCreateWithoutConsultationInput;
  update: ImageUpdateWithoutConsultationInput;
  where: ImageWhereUniqueInput;
};

export type ImageWhereInput = {
  AND?: Maybe<Array<ImageWhereInput>>;
  NOT?: Maybe<Array<ImageWhereInput>>;
  OR?: Maybe<Array<ImageWhereInput>>;
  consultation?: Maybe<ConsultationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  source?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ImageWhereUniqueInput = {
  AND?: Maybe<Array<ImageWhereInput>>;
  NOT?: Maybe<Array<ImageWhereInput>>;
  OR?: Maybe<Array<ImageWhereInput>>;
  consultation?: Maybe<ConsultationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAudienceDefinition = {
  __typename?: 'InformAudienceDefinition';
  _count: InformAudienceDefinitionCountOutputType;
  canonicalBreeds: Array<CanonicalBreed>;
  canonicalServices: Array<CanonicalService>;
  canonicalSpecies: Array<CanonicalSpecies>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informCampaigns: Array<InformCampaign>;
  informPartner?: Maybe<InformPartner>;
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition: Array<TaxonomyToInformAudienceDefinition>;
  type: InformAudienceDefinitionType;
  updatedAt: Scalars['DateTime'];
};


export type InformAudienceDefinitionCanonicalBreedsArgs = {
  cursor?: Maybe<CanonicalBreedWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalBreedScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalBreedOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalBreedWhereInput>;
};


export type InformAudienceDefinitionCanonicalServicesArgs = {
  cursor?: Maybe<CanonicalServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalServiceWhereInput>;
};


export type InformAudienceDefinitionCanonicalSpeciesArgs = {
  cursor?: Maybe<CanonicalSpeciesWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalSpeciesScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalSpeciesOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalSpeciesWhereInput>;
};


export type InformAudienceDefinitionInformCampaignsArgs = {
  cursor?: Maybe<InformCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignWhereInput>;
};


export type InformAudienceDefinitionInformPartnerArgs = {
  where?: Maybe<InformPartnerWhereInput>;
};


export type InformAudienceDefinitionTaxonomyToInformAudienceDefinitionArgs = {
  cursor?: Maybe<TaxonomyToInformAudienceDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaxonomyToInformAudienceDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaxonomyToInformAudienceDefinitionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaxonomyToInformAudienceDefinitionWhereInput>;
};

export type InformAudienceDefinitionCountAggregateOutputType = {
  __typename?: 'InformAudienceDefinitionCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerId: Scalars['Int'];
  name: Scalars['Int'];
  settings: Scalars['Int'];
  status: Scalars['Int'];
  statusMessage: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformAudienceDefinitionCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceDefinitionCountOutputType = {
  __typename?: 'InformAudienceDefinitionCountOutputType';
  canonicalBreeds: Scalars['Int'];
  canonicalServices: Scalars['Int'];
  canonicalSpecies: Scalars['Int'];
  informCampaigns: Scalars['Int'];
  taxonomyToInformAudienceDefinition: Scalars['Int'];
};

export type InformAudienceDefinitionCreateInput = {
  canonicalBreeds?: Maybe<CanonicalBreedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignCreateNestedManyWithoutInformAudienceDefinitionInput>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutInformAudienceDefinitionsInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutInformAudienceDefinitionInput>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionCreateManyInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionCreateManyInformPartnerInputEnvelope = {
  data: Array<InformAudienceDefinitionCreateManyInformPartnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformAudienceDefinitionCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionCreateNestedManyWithoutCanonicalBreedsInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutCanonicalBreedsInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutCanonicalBreedsInput>>;
};

export type InformAudienceDefinitionCreateNestedManyWithoutCanonicalServicesInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutCanonicalServicesInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutCanonicalServicesInput>>;
};

export type InformAudienceDefinitionCreateNestedManyWithoutCanonicalSpeciesInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutCanonicalSpeciesInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutCanonicalSpeciesInput>>;
};

export type InformAudienceDefinitionCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformAudienceDefinitionCreateManyInformPartnerInputEnvelope>;
};

export type InformAudienceDefinitionCreateNestedOneWithoutInformCampaignsInput = {
  connect?: Maybe<InformAudienceDefinitionWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAudienceDefinitionCreateOrConnectWithoutInformCampaignsInput>;
  create?: Maybe<InformAudienceDefinitionCreateWithoutInformCampaignsInput>;
};

export type InformAudienceDefinitionCreateNestedOneWithoutTaxonomyToInformAudienceDefinitionInput = {
  connect?: Maybe<InformAudienceDefinitionWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAudienceDefinitionCreateOrConnectWithoutTaxonomyToInformAudienceDefinitionInput>;
  create?: Maybe<InformAudienceDefinitionCreateWithoutTaxonomyToInformAudienceDefinitionInput>;
};

export type InformAudienceDefinitionCreateOrConnectWithoutCanonicalBreedsInput = {
  create: InformAudienceDefinitionCreateWithoutCanonicalBreedsInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionCreateOrConnectWithoutCanonicalServicesInput = {
  create: InformAudienceDefinitionCreateWithoutCanonicalServicesInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionCreateOrConnectWithoutCanonicalSpeciesInput = {
  create: InformAudienceDefinitionCreateWithoutCanonicalSpeciesInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionCreateOrConnectWithoutInformCampaignsInput = {
  create: InformAudienceDefinitionCreateWithoutInformCampaignsInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionCreateOrConnectWithoutInformPartnerInput = {
  create: InformAudienceDefinitionCreateWithoutInformPartnerInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionCreateOrConnectWithoutTaxonomyToInformAudienceDefinitionInput = {
  create: InformAudienceDefinitionCreateWithoutTaxonomyToInformAudienceDefinitionInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionCreateWithoutCanonicalBreedsInput = {
  canonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignCreateNestedManyWithoutInformAudienceDefinitionInput>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutInformAudienceDefinitionsInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutInformAudienceDefinitionInput>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionCreateWithoutCanonicalServicesInput = {
  canonicalBreeds?: Maybe<CanonicalBreedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignCreateNestedManyWithoutInformAudienceDefinitionInput>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutInformAudienceDefinitionsInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutInformAudienceDefinitionInput>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionCreateWithoutCanonicalSpeciesInput = {
  canonicalBreeds?: Maybe<CanonicalBreedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignCreateNestedManyWithoutInformAudienceDefinitionInput>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutInformAudienceDefinitionsInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutInformAudienceDefinitionInput>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionCreateWithoutInformCampaignsInput = {
  canonicalBreeds?: Maybe<CanonicalBreedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutInformAudienceDefinitionsInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutInformAudienceDefinitionInput>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionCreateWithoutInformPartnerInput = {
  canonicalBreeds?: Maybe<CanonicalBreedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignCreateNestedManyWithoutInformAudienceDefinitionInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutInformAudienceDefinitionInput>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionCreateWithoutTaxonomyToInformAudienceDefinitionInput = {
  canonicalBreeds?: Maybe<CanonicalBreedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignCreateNestedManyWithoutInformAudienceDefinitionInput>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutInformAudienceDefinitionsInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionGroupByOutputType = {
  __typename?: 'InformAudienceDefinitionGroupByOutputType';
  _count?: Maybe<InformAudienceDefinitionCountAggregateOutputType>;
  _max?: Maybe<InformAudienceDefinitionMaxAggregateOutputType>;
  _min?: Maybe<InformAudienceDefinitionMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformAudienceDefinitionType;
  updatedAt: Scalars['DateTime'];
};

export type InformAudienceDefinitionListRelationFilter = {
  every?: Maybe<InformAudienceDefinitionWhereInput>;
  none?: Maybe<InformAudienceDefinitionWhereInput>;
  some?: Maybe<InformAudienceDefinitionWhereInput>;
};

export type InformAudienceDefinitionMaxAggregateOutputType = {
  __typename?: 'InformAudienceDefinitionMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceDefinitionMinAggregateOutputType = {
  __typename?: 'InformAudienceDefinitionMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceDefinitionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformAudienceDefinitionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformAudienceDefinitionOrderByRelevanceInput>;
  canonicalBreeds?: Maybe<CanonicalBreedOrderByRelationAggregateInput>;
  canonicalServices?: Maybe<CanonicalServiceOrderByRelationAggregateInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaigns?: Maybe<InformCampaignOrderByRelationAggregateInput>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformAudienceDefinitionOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  Name = 'name'
}

export type InformAudienceDefinitionOrderByRelevanceInput = {
  fields: Array<InformAudienceDefinitionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformAudienceDefinitionOrderByWithAggregationInput = {
  _count?: Maybe<InformAudienceDefinitionCountOrderByAggregateInput>;
  _max?: Maybe<InformAudienceDefinitionMaxOrderByAggregateInput>;
  _min?: Maybe<InformAudienceDefinitionMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceDefinitionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformAudienceDefinitionOrderByRelevanceInput>;
  canonicalBreeds?: Maybe<CanonicalBreedOrderByRelationAggregateInput>;
  canonicalServices?: Maybe<CanonicalServiceOrderByRelationAggregateInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaigns?: Maybe<InformCampaignOrderByRelationAggregateInput>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceDefinitionOrderByWithRelationInput = {
  _relevance?: Maybe<InformAudienceDefinitionOrderByRelevanceInput>;
  canonicalBreeds?: Maybe<CanonicalBreedOrderByRelationAggregateInput>;
  canonicalServices?: Maybe<CanonicalServiceOrderByRelationAggregateInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaigns?: Maybe<InformCampaignOrderByRelationAggregateInput>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformAudienceDefinitionScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  Name = 'name',
  Settings = 'settings',
  Status = 'status',
  StatusMessage = 'statusMessage',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type InformAudienceDefinitionScalarRelationFilter = {
  AND?: Maybe<Array<InformAudienceDefinitionWhereInput>>;
  NOT?: Maybe<Array<InformAudienceDefinitionWhereInput>>;
  OR?: Maybe<Array<InformAudienceDefinitionWhereInput>>;
  canonicalBreeds?: Maybe<CanonicalBreedListRelationFilter>;
  canonicalServices?: Maybe<CanonicalServiceListRelationFilter>;
  canonicalSpecies?: Maybe<CanonicalSpeciesListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informCampaigns?: Maybe<InformCampaignListRelationFilter>;
  informPartner?: Maybe<InformPartnerNullableScalarRelationFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformAudienceDefinitionStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionListRelationFilter>;
  type?: Maybe<EnumInformAudienceDefinitionTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAudienceDefinitionScalarWhereInput = {
  AND?: Maybe<Array<InformAudienceDefinitionScalarWhereInput>>;
  NOT?: Maybe<Array<InformAudienceDefinitionScalarWhereInput>>;
  OR?: Maybe<Array<InformAudienceDefinitionScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformAudienceDefinitionStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumInformAudienceDefinitionTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAudienceDefinitionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformAudienceDefinitionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformAudienceDefinitionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformAudienceDefinitionScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerId?: Maybe<StringNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  status?: Maybe<EnumInformAudienceDefinitionStatusWithAggregatesFilter>;
  statusMessage?: Maybe<JsonNullableWithAggregatesFilter>;
  type?: Maybe<EnumInformAudienceDefinitionTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformAudienceDefinitionStatus {
  Active = 'Active',
  Archived = 'Archived',
  Paused = 'Paused'
}

export enum InformAudienceDefinitionType {
  Conditional = 'Conditional',
  FinalDose = 'FinalDose',
  FirstPurchase = 'FirstPurchase',
  Lapsed = 'Lapsed',
  LapsedOrNonUser = 'LapsedOrNonUser',
  NonUser = 'NonUser',
  RecentAttendee = 'RecentAttendee'
}

export type InformAudienceDefinitionUncheckedCreateInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalBreedsInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutCanonicalBreedsInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutCanonicalBreedsInput>>;
};

export type InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalServicesInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutCanonicalServicesInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutCanonicalServicesInput>>;
};

export type InformAudienceDefinitionUncheckedCreateNestedManyWithoutCanonicalSpeciesInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutCanonicalSpeciesInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutCanonicalSpeciesInput>>;
};

export type InformAudienceDefinitionUncheckedCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformAudienceDefinitionCreateManyInformPartnerInputEnvelope>;
};

export type InformAudienceDefinitionUncheckedCreateWithoutCanonicalBreedsInput = {
  canonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedCreateWithoutCanonicalServicesInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedCreateWithoutCanonicalSpeciesInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedCreateWithoutInformCampaignsInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedCreateWithoutInformPartnerInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedCreateWithoutTaxonomyToInformAudienceDefinitionInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUncheckedCreateNestedManyWithoutInformAudienceDefinitionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceDefinitionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformAudienceDefinitionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedUpdateInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalBreedsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalBreedsNestedInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutCanonicalBreedsInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutCanonicalBreedsInput>>;
  delete?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceDefinitionUpdateWithWhereUniqueWithoutCanonicalBreedsInput>>;
  updateMany?: Maybe<Array<InformAudienceDefinitionUpdateManyWithWhereWithoutCanonicalBreedsInput>>;
  upsert?: Maybe<Array<InformAudienceDefinitionUpsertWithWhereUniqueWithoutCanonicalBreedsInput>>;
};

export type InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalServicesNestedInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutCanonicalServicesInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutCanonicalServicesInput>>;
  delete?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceDefinitionUpdateWithWhereUniqueWithoutCanonicalServicesInput>>;
  updateMany?: Maybe<Array<InformAudienceDefinitionUpdateManyWithWhereWithoutCanonicalServicesInput>>;
  upsert?: Maybe<Array<InformAudienceDefinitionUpsertWithWhereUniqueWithoutCanonicalServicesInput>>;
};

export type InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalSpeciesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedUpdateManyWithoutCanonicalSpeciesNestedInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutCanonicalSpeciesInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutCanonicalSpeciesInput>>;
  delete?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceDefinitionUpdateWithWhereUniqueWithoutCanonicalSpeciesInput>>;
  updateMany?: Maybe<Array<InformAudienceDefinitionUpdateManyWithWhereWithoutCanonicalSpeciesInput>>;
  upsert?: Maybe<Array<InformAudienceDefinitionUpsertWithWhereUniqueWithoutCanonicalSpeciesInput>>;
};

export type InformAudienceDefinitionUncheckedUpdateManyWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformAudienceDefinitionCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceDefinitionUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformAudienceDefinitionUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformAudienceDefinitionUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformAudienceDefinitionUncheckedUpdateWithoutCanonicalBreedsInput = {
  canonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedUpdateWithoutCanonicalServicesInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedUpdateWithoutCanonicalSpeciesInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedUpdateWithoutInformCampaignsInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedUpdateWithoutInformPartnerInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUncheckedUpdateWithoutTaxonomyToInformAudienceDefinitionInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUncheckedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUpdateInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutInformAudienceDefinitionsNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUpdateManyWithWhereWithoutCanonicalBreedsInput = {
  data: InformAudienceDefinitionUpdateManyMutationInput;
  where: InformAudienceDefinitionScalarWhereInput;
};

export type InformAudienceDefinitionUpdateManyWithWhereWithoutCanonicalServicesInput = {
  data: InformAudienceDefinitionUpdateManyMutationInput;
  where: InformAudienceDefinitionScalarWhereInput;
};

export type InformAudienceDefinitionUpdateManyWithWhereWithoutCanonicalSpeciesInput = {
  data: InformAudienceDefinitionUpdateManyMutationInput;
  where: InformAudienceDefinitionScalarWhereInput;
};

export type InformAudienceDefinitionUpdateManyWithWhereWithoutInformPartnerInput = {
  data: InformAudienceDefinitionUpdateManyMutationInput;
  where: InformAudienceDefinitionScalarWhereInput;
};

export type InformAudienceDefinitionUpdateManyWithoutCanonicalBreedsNestedInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutCanonicalBreedsInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutCanonicalBreedsInput>>;
  delete?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceDefinitionUpdateWithWhereUniqueWithoutCanonicalBreedsInput>>;
  updateMany?: Maybe<Array<InformAudienceDefinitionUpdateManyWithWhereWithoutCanonicalBreedsInput>>;
  upsert?: Maybe<Array<InformAudienceDefinitionUpsertWithWhereUniqueWithoutCanonicalBreedsInput>>;
};

export type InformAudienceDefinitionUpdateManyWithoutCanonicalServicesNestedInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutCanonicalServicesInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutCanonicalServicesInput>>;
  delete?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceDefinitionUpdateWithWhereUniqueWithoutCanonicalServicesInput>>;
  updateMany?: Maybe<Array<InformAudienceDefinitionUpdateManyWithWhereWithoutCanonicalServicesInput>>;
  upsert?: Maybe<Array<InformAudienceDefinitionUpsertWithWhereUniqueWithoutCanonicalServicesInput>>;
};

export type InformAudienceDefinitionUpdateManyWithoutCanonicalSpeciesNestedInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutCanonicalSpeciesInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutCanonicalSpeciesInput>>;
  delete?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceDefinitionUpdateWithWhereUniqueWithoutCanonicalSpeciesInput>>;
  updateMany?: Maybe<Array<InformAudienceDefinitionUpdateManyWithWhereWithoutCanonicalSpeciesInput>>;
  upsert?: Maybe<Array<InformAudienceDefinitionUpsertWithWhereUniqueWithoutCanonicalSpeciesInput>>;
};

export type InformAudienceDefinitionUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceDefinitionCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformAudienceDefinitionCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformAudienceDefinitionCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceDefinitionUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformAudienceDefinitionUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformAudienceDefinitionUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformAudienceDefinitionUpdateOneRequiredWithoutInformCampaignsNestedInput = {
  connect?: Maybe<InformAudienceDefinitionWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAudienceDefinitionCreateOrConnectWithoutInformCampaignsInput>;
  create?: Maybe<InformAudienceDefinitionCreateWithoutInformCampaignsInput>;
  update?: Maybe<InformAudienceDefinitionUpdateToOneWithWhereWithoutInformCampaignsInput>;
  upsert?: Maybe<InformAudienceDefinitionUpsertWithoutInformCampaignsInput>;
};

export type InformAudienceDefinitionUpdateOneRequiredWithoutTaxonomyToInformAudienceDefinitionNestedInput = {
  connect?: Maybe<InformAudienceDefinitionWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAudienceDefinitionCreateOrConnectWithoutTaxonomyToInformAudienceDefinitionInput>;
  create?: Maybe<InformAudienceDefinitionCreateWithoutTaxonomyToInformAudienceDefinitionInput>;
  update?: Maybe<InformAudienceDefinitionUpdateToOneWithWhereWithoutTaxonomyToInformAudienceDefinitionInput>;
  upsert?: Maybe<InformAudienceDefinitionUpsertWithoutTaxonomyToInformAudienceDefinitionInput>;
};

export type InformAudienceDefinitionUpdateToOneWithWhereWithoutInformCampaignsInput = {
  data: InformAudienceDefinitionUpdateWithoutInformCampaignsInput;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};

export type InformAudienceDefinitionUpdateToOneWithWhereWithoutTaxonomyToInformAudienceDefinitionInput = {
  data: InformAudienceDefinitionUpdateWithoutTaxonomyToInformAudienceDefinitionInput;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};

export type InformAudienceDefinitionUpdateWithWhereUniqueWithoutCanonicalBreedsInput = {
  data: InformAudienceDefinitionUpdateWithoutCanonicalBreedsInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionUpdateWithWhereUniqueWithoutCanonicalServicesInput = {
  data: InformAudienceDefinitionUpdateWithoutCanonicalServicesInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionUpdateWithWhereUniqueWithoutCanonicalSpeciesInput = {
  data: InformAudienceDefinitionUpdateWithoutCanonicalSpeciesInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionUpdateWithWhereUniqueWithoutInformPartnerInput = {
  data: InformAudienceDefinitionUpdateWithoutInformPartnerInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionUpdateWithoutCanonicalBreedsInput = {
  canonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutInformAudienceDefinitionsNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUpdateWithoutCanonicalServicesInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutInformAudienceDefinitionsNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUpdateWithoutCanonicalSpeciesInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutInformAudienceDefinitionsNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUpdateWithoutInformCampaignsInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutInformAudienceDefinitionsNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUpdateWithoutInformPartnerInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUpdateWithoutTaxonomyToInformAudienceDefinitionInput = {
  canonicalBreeds?: Maybe<CanonicalBreedUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  canonicalSpecies?: Maybe<CanonicalSpeciesUpdateManyWithoutInformAudienceDefinitionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUpdateManyWithoutInformAudienceDefinitionNestedInput>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutInformAudienceDefinitionsNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceDefinitionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformAudienceDefinitionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceDefinitionUpsertWithWhereUniqueWithoutCanonicalBreedsInput = {
  create: InformAudienceDefinitionCreateWithoutCanonicalBreedsInput;
  update: InformAudienceDefinitionUpdateWithoutCanonicalBreedsInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionUpsertWithWhereUniqueWithoutCanonicalServicesInput = {
  create: InformAudienceDefinitionCreateWithoutCanonicalServicesInput;
  update: InformAudienceDefinitionUpdateWithoutCanonicalServicesInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionUpsertWithWhereUniqueWithoutCanonicalSpeciesInput = {
  create: InformAudienceDefinitionCreateWithoutCanonicalSpeciesInput;
  update: InformAudienceDefinitionUpdateWithoutCanonicalSpeciesInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionUpsertWithWhereUniqueWithoutInformPartnerInput = {
  create: InformAudienceDefinitionCreateWithoutInformPartnerInput;
  update: InformAudienceDefinitionUpdateWithoutInformPartnerInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};

export type InformAudienceDefinitionUpsertWithoutInformCampaignsInput = {
  create: InformAudienceDefinitionCreateWithoutInformCampaignsInput;
  update: InformAudienceDefinitionUpdateWithoutInformCampaignsInput;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};

export type InformAudienceDefinitionUpsertWithoutTaxonomyToInformAudienceDefinitionInput = {
  create: InformAudienceDefinitionCreateWithoutTaxonomyToInformAudienceDefinitionInput;
  update: InformAudienceDefinitionUpdateWithoutTaxonomyToInformAudienceDefinitionInput;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};

export type InformAudienceDefinitionWhereInput = {
  AND?: Maybe<Array<InformAudienceDefinitionWhereInput>>;
  NOT?: Maybe<Array<InformAudienceDefinitionWhereInput>>;
  OR?: Maybe<Array<InformAudienceDefinitionWhereInput>>;
  canonicalBreeds?: Maybe<CanonicalBreedListRelationFilter>;
  canonicalServices?: Maybe<CanonicalServiceListRelationFilter>;
  canonicalSpecies?: Maybe<CanonicalSpeciesListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informCampaigns?: Maybe<InformCampaignListRelationFilter>;
  informPartner?: Maybe<InformPartnerNullableScalarRelationFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformAudienceDefinitionStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionListRelationFilter>;
  type?: Maybe<EnumInformAudienceDefinitionTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAudienceDefinitionWhereUniqueInput = {
  AND?: Maybe<Array<InformAudienceDefinitionWhereInput>>;
  NOT?: Maybe<Array<InformAudienceDefinitionWhereInput>>;
  OR?: Maybe<Array<InformAudienceDefinitionWhereInput>>;
  canonicalBreeds?: Maybe<CanonicalBreedListRelationFilter>;
  canonicalServices?: Maybe<CanonicalServiceListRelationFilter>;
  canonicalSpecies?: Maybe<CanonicalSpeciesListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignListRelationFilter>;
  informPartner?: Maybe<InformPartnerNullableScalarRelationFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformAudienceDefinitionStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionListRelationFilter>;
  type?: Maybe<EnumInformAudienceDefinitionTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAudienceMember = {
  __typename?: 'InformAudienceMember';
  _count: InformAudienceMemberCountOutputType;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informAudienceMemberMessages: Array<InformAudienceMemberMessage>;
  informCampaignEnrollment: InformCampaignEnrollment;
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecution: InformCampaignExecution;
  informCampaignExecutionId: Scalars['String'];
  informSession: Array<InformSession>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummary>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type InformAudienceMemberInformAudienceMemberMessagesArgs = {
  cursor?: Maybe<InformAudienceMemberMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceMemberMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberMessageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberMessageWhereInput>;
};


export type InformAudienceMemberInformSessionArgs = {
  cursor?: Maybe<InformSessionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformSessionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformSessionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionWhereInput>;
};


export type InformAudienceMemberServicePurchaseSummaryArgs = {
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};

export type InformAudienceMemberCountAggregateOutputType = {
  __typename?: 'InformAudienceMemberCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  informCampaignEnrollmentId: Scalars['Int'];
  informCampaignExecutionId: Scalars['Int'];
  servicePurchaseSummaryId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformAudienceMemberCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  servicePurchaseSummaryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceMemberCountOutputType = {
  __typename?: 'InformAudienceMemberCountOutputType';
  informAudienceMemberMessages: Scalars['Int'];
  informSession: Scalars['Int'];
};

export type InformAudienceMemberCreateInput = {
  clinic: ClinicCreateNestedOneWithoutInformAudienceMemberInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInformAudienceMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignEnrollment: InformCampaignEnrollmentCreateNestedOneWithoutInformAudienceMemberInput;
  informCampaignExecution: InformCampaignExecutionCreateNestedOneWithoutInformAudienceMemberInput;
  informSession?: Maybe<InformSessionCreateNestedManyWithoutInformAudienceMemberInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryCreateNestedOneWithoutInformAudienceMemberInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateManyClinicInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecutionId: Scalars['String'];
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateManyClinicInputEnvelope = {
  data: Array<InformAudienceMemberCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformAudienceMemberCreateManyClinicPetParentInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecutionId: Scalars['String'];
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateManyClinicPetParentInputEnvelope = {
  data: Array<InformAudienceMemberCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformAudienceMemberCreateManyInformCampaignEnrollmentInput = {
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId: Scalars['String'];
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateManyInformCampaignEnrollmentInputEnvelope = {
  data: Array<InformAudienceMemberCreateManyInformCampaignEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformAudienceMemberCreateManyInformCampaignExecutionInput = {
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId: Scalars['String'];
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateManyInformCampaignExecutionInputEnvelope = {
  data: Array<InformAudienceMemberCreateManyInformCampaignExecutionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformAudienceMemberCreateManyInput = {
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecutionId: Scalars['String'];
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateManyServicePurchaseSummaryInput = {
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecutionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateManyServicePurchaseSummaryInputEnvelope = {
  data: Array<InformAudienceMemberCreateManyServicePurchaseSummaryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformAudienceMemberCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutClinicInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyClinicInputEnvelope>;
};

export type InformAudienceMemberCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyClinicPetParentInputEnvelope>;
};

export type InformAudienceMemberCreateNestedManyWithoutInformCampaignEnrollmentInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutInformCampaignEnrollmentInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutInformCampaignEnrollmentInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyInformCampaignEnrollmentInputEnvelope>;
};

export type InformAudienceMemberCreateNestedManyWithoutInformCampaignExecutionInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutInformCampaignExecutionInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutInformCampaignExecutionInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyInformCampaignExecutionInputEnvelope>;
};

export type InformAudienceMemberCreateNestedManyWithoutServicePurchaseSummaryInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutServicePurchaseSummaryInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutServicePurchaseSummaryInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyServicePurchaseSummaryInputEnvelope>;
};

export type InformAudienceMemberCreateNestedOneWithoutInformAudienceMemberMessagesInput = {
  connect?: Maybe<InformAudienceMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAudienceMemberCreateOrConnectWithoutInformAudienceMemberMessagesInput>;
  create?: Maybe<InformAudienceMemberCreateWithoutInformAudienceMemberMessagesInput>;
};

export type InformAudienceMemberCreateNestedOneWithoutInformSessionInput = {
  connect?: Maybe<InformAudienceMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAudienceMemberCreateOrConnectWithoutInformSessionInput>;
  create?: Maybe<InformAudienceMemberCreateWithoutInformSessionInput>;
};

export type InformAudienceMemberCreateOrConnectWithoutClinicInput = {
  create: InformAudienceMemberCreateWithoutClinicInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberCreateOrConnectWithoutClinicPetParentInput = {
  create: InformAudienceMemberCreateWithoutClinicPetParentInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberCreateOrConnectWithoutInformAudienceMemberMessagesInput = {
  create: InformAudienceMemberCreateWithoutInformAudienceMemberMessagesInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberCreateOrConnectWithoutInformCampaignEnrollmentInput = {
  create: InformAudienceMemberCreateWithoutInformCampaignEnrollmentInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberCreateOrConnectWithoutInformCampaignExecutionInput = {
  create: InformAudienceMemberCreateWithoutInformCampaignExecutionInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberCreateOrConnectWithoutInformSessionInput = {
  create: InformAudienceMemberCreateWithoutInformSessionInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberCreateOrConnectWithoutServicePurchaseSummaryInput = {
  create: InformAudienceMemberCreateWithoutServicePurchaseSummaryInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberCreateWithoutClinicInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInformAudienceMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignEnrollment: InformCampaignEnrollmentCreateNestedOneWithoutInformAudienceMemberInput;
  informCampaignExecution: InformCampaignExecutionCreateNestedOneWithoutInformAudienceMemberInput;
  informSession?: Maybe<InformSessionCreateNestedManyWithoutInformAudienceMemberInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryCreateNestedOneWithoutInformAudienceMemberInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateWithoutClinicPetParentInput = {
  clinic: ClinicCreateNestedOneWithoutInformAudienceMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignEnrollment: InformCampaignEnrollmentCreateNestedOneWithoutInformAudienceMemberInput;
  informCampaignExecution: InformCampaignExecutionCreateNestedOneWithoutInformAudienceMemberInput;
  informSession?: Maybe<InformSessionCreateNestedManyWithoutInformAudienceMemberInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryCreateNestedOneWithoutInformAudienceMemberInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateWithoutInformAudienceMemberMessagesInput = {
  clinic: ClinicCreateNestedOneWithoutInformAudienceMemberInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInformAudienceMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollment: InformCampaignEnrollmentCreateNestedOneWithoutInformAudienceMemberInput;
  informCampaignExecution: InformCampaignExecutionCreateNestedOneWithoutInformAudienceMemberInput;
  informSession?: Maybe<InformSessionCreateNestedManyWithoutInformAudienceMemberInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryCreateNestedOneWithoutInformAudienceMemberInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateWithoutInformCampaignEnrollmentInput = {
  clinic: ClinicCreateNestedOneWithoutInformAudienceMemberInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInformAudienceMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignExecution: InformCampaignExecutionCreateNestedOneWithoutInformAudienceMemberInput;
  informSession?: Maybe<InformSessionCreateNestedManyWithoutInformAudienceMemberInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryCreateNestedOneWithoutInformAudienceMemberInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateWithoutInformCampaignExecutionInput = {
  clinic: ClinicCreateNestedOneWithoutInformAudienceMemberInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInformAudienceMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignEnrollment: InformCampaignEnrollmentCreateNestedOneWithoutInformAudienceMemberInput;
  informSession?: Maybe<InformSessionCreateNestedManyWithoutInformAudienceMemberInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryCreateNestedOneWithoutInformAudienceMemberInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateWithoutInformSessionInput = {
  clinic: ClinicCreateNestedOneWithoutInformAudienceMemberInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInformAudienceMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignEnrollment: InformCampaignEnrollmentCreateNestedOneWithoutInformAudienceMemberInput;
  informCampaignExecution: InformCampaignExecutionCreateNestedOneWithoutInformAudienceMemberInput;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryCreateNestedOneWithoutInformAudienceMemberInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberCreateWithoutServicePurchaseSummaryInput = {
  clinic: ClinicCreateNestedOneWithoutInformAudienceMemberInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInformAudienceMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignEnrollment: InformCampaignEnrollmentCreateNestedOneWithoutInformAudienceMemberInput;
  informCampaignExecution: InformCampaignExecutionCreateNestedOneWithoutInformAudienceMemberInput;
  informSession?: Maybe<InformSessionCreateNestedManyWithoutInformAudienceMemberInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberGroupByOutputType = {
  __typename?: 'InformAudienceMemberGroupByOutputType';
  _count?: Maybe<InformAudienceMemberCountAggregateOutputType>;
  _max?: Maybe<InformAudienceMemberMaxAggregateOutputType>;
  _min?: Maybe<InformAudienceMemberMinAggregateOutputType>;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecutionId: Scalars['String'];
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type InformAudienceMemberInformCampaignExecutionIdInformCampaignEnrollmentIdClinicPetParentIdCompoundUniqueInput = {
  clinicPetParentId: Scalars['String'];
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecutionId: Scalars['String'];
};

export type InformAudienceMemberListRelationFilter = {
  every?: Maybe<InformAudienceMemberWhereInput>;
  none?: Maybe<InformAudienceMemberWhereInput>;
  some?: Maybe<InformAudienceMemberWhereInput>;
};

export type InformAudienceMemberMaxAggregateOutputType = {
  __typename?: 'InformAudienceMemberMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  servicePurchaseSummaryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceMemberMessage = {
  __typename?: 'InformAudienceMemberMessage';
  _count: InformAudienceMemberMessageCountOutputType;
  audienceMember: InformAudienceMember;
  audienceMemberId: Scalars['String'];
  context: Scalars['Json'];
  courier: InformAudienceMemberMessageCourier;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  executeAt: Scalars['DateTime'];
  id: Scalars['String'];
  informSessions: Array<InformSession>;
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceMemberMessageStatus;
  target: Scalars['String'];
  type: InformAudienceMemberMessageType;
  updatedAt: Scalars['DateTime'];
};


export type InformAudienceMemberMessageInformSessionsArgs = {
  cursor?: Maybe<InformSessionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformSessionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformSessionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionWhereInput>;
};

export type InformAudienceMemberMessageCountAggregateOutputType = {
  __typename?: 'InformAudienceMemberMessageCountAggregateOutputType';
  _all: Scalars['Int'];
  audienceMemberId: Scalars['Int'];
  context: Scalars['Int'];
  courier: Scalars['Int'];
  courierMessageId: Scalars['Int'];
  createdAt: Scalars['Int'];
  executeAt: Scalars['Int'];
  id: Scalars['Int'];
  reason: Scalars['Int'];
  sentAt: Scalars['Int'];
  settings: Scalars['Int'];
  status: Scalars['Int'];
  target: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformAudienceMemberMessageCountOrderByAggregateInput = {
  audienceMemberId?: Maybe<SortOrder>;
  context?: Maybe<SortOrder>;
  courier?: Maybe<SortOrder>;
  courierMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  sentAt?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceMemberMessageCountOutputType = {
  __typename?: 'InformAudienceMemberMessageCountOutputType';
  informSessions: Scalars['Int'];
};

export enum InformAudienceMemberMessageCourier {
  Bandwidth = 'Bandwidth',
  SendGrid = 'SendGrid',
  Twilio = 'Twilio'
}

export type InformAudienceMemberMessageCreateInput = {
  audienceMember: InformAudienceMemberCreateNestedOneWithoutInformAudienceMemberMessagesInput;
  context: Scalars['Json'];
  courier: InformAudienceMemberMessageCourier;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutInformAudienceMemberMessageInput>;
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceMemberMessageStatus;
  target: Scalars['String'];
  type: InformAudienceMemberMessageType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageCreateManyAudienceMemberInput = {
  context: Scalars['Json'];
  courier: InformAudienceMemberMessageCourier;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceMemberMessageStatus;
  target: Scalars['String'];
  type: InformAudienceMemberMessageType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageCreateManyAudienceMemberInputEnvelope = {
  data: Array<InformAudienceMemberMessageCreateManyAudienceMemberInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformAudienceMemberMessageCreateManyInput = {
  audienceMemberId: Scalars['String'];
  context: Scalars['Json'];
  courier: InformAudienceMemberMessageCourier;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceMemberMessageStatus;
  target: Scalars['String'];
  type: InformAudienceMemberMessageType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageCreateNestedManyWithoutAudienceMemberInput = {
  connect?: Maybe<Array<InformAudienceMemberMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberMessageCreateOrConnectWithoutAudienceMemberInput>>;
  create?: Maybe<Array<InformAudienceMemberMessageCreateWithoutAudienceMemberInput>>;
  createMany?: Maybe<InformAudienceMemberMessageCreateManyAudienceMemberInputEnvelope>;
};

export type InformAudienceMemberMessageCreateNestedOneWithoutInformSessionsInput = {
  connect?: Maybe<InformAudienceMemberMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAudienceMemberMessageCreateOrConnectWithoutInformSessionsInput>;
  create?: Maybe<InformAudienceMemberMessageCreateWithoutInformSessionsInput>;
};

export type InformAudienceMemberMessageCreateOrConnectWithoutAudienceMemberInput = {
  create: InformAudienceMemberMessageCreateWithoutAudienceMemberInput;
  where: InformAudienceMemberMessageWhereUniqueInput;
};

export type InformAudienceMemberMessageCreateOrConnectWithoutInformSessionsInput = {
  create: InformAudienceMemberMessageCreateWithoutInformSessionsInput;
  where: InformAudienceMemberMessageWhereUniqueInput;
};

export type InformAudienceMemberMessageCreateWithoutAudienceMemberInput = {
  context: Scalars['Json'];
  courier: InformAudienceMemberMessageCourier;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informSessions?: Maybe<InformSessionCreateNestedManyWithoutInformAudienceMemberMessageInput>;
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceMemberMessageStatus;
  target: Scalars['String'];
  type: InformAudienceMemberMessageType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageCreateWithoutInformSessionsInput = {
  audienceMember: InformAudienceMemberCreateNestedOneWithoutInformAudienceMemberMessagesInput;
  context: Scalars['Json'];
  courier: InformAudienceMemberMessageCourier;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceMemberMessageStatus;
  target: Scalars['String'];
  type: InformAudienceMemberMessageType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageGroupByOutputType = {
  __typename?: 'InformAudienceMemberMessageGroupByOutputType';
  _count?: Maybe<InformAudienceMemberMessageCountAggregateOutputType>;
  _max?: Maybe<InformAudienceMemberMessageMaxAggregateOutputType>;
  _min?: Maybe<InformAudienceMemberMessageMinAggregateOutputType>;
  audienceMemberId: Scalars['String'];
  context: Scalars['Json'];
  courier: InformAudienceMemberMessageCourier;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  executeAt: Scalars['DateTime'];
  id: Scalars['String'];
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceMemberMessageStatus;
  target: Scalars['String'];
  type: InformAudienceMemberMessageType;
  updatedAt: Scalars['DateTime'];
};

export type InformAudienceMemberMessageListRelationFilter = {
  every?: Maybe<InformAudienceMemberMessageWhereInput>;
  none?: Maybe<InformAudienceMemberMessageWhereInput>;
  some?: Maybe<InformAudienceMemberMessageWhereInput>;
};

export type InformAudienceMemberMessageMaxAggregateOutputType = {
  __typename?: 'InformAudienceMemberMessageMaxAggregateOutputType';
  audienceMemberId?: Maybe<Scalars['String']>;
  courier?: Maybe<InformAudienceMemberMessageCourier>;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<InformAudienceMemberMessageStatus>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<InformAudienceMemberMessageType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageMaxOrderByAggregateInput = {
  audienceMemberId?: Maybe<SortOrder>;
  courier?: Maybe<SortOrder>;
  courierMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  sentAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceMemberMessageMinAggregateOutputType = {
  __typename?: 'InformAudienceMemberMessageMinAggregateOutputType';
  audienceMemberId?: Maybe<Scalars['String']>;
  courier?: Maybe<InformAudienceMemberMessageCourier>;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<InformAudienceMemberMessageStatus>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<InformAudienceMemberMessageType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageMinOrderByAggregateInput = {
  audienceMemberId?: Maybe<SortOrder>;
  courier?: Maybe<SortOrder>;
  courierMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  sentAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceMemberMessageNullableScalarRelationFilter = {
  AND?: Maybe<Array<InformAudienceMemberMessageWhereInput>>;
  NOT?: Maybe<Array<InformAudienceMemberMessageWhereInput>>;
  OR?: Maybe<Array<InformAudienceMemberMessageWhereInput>>;
  audienceMember?: Maybe<InformAudienceMemberScalarRelationFilter>;
  audienceMemberId?: Maybe<StringFilter>;
  context?: Maybe<JsonFilter>;
  courier?: Maybe<EnumInformAudienceMemberMessageCourierFilter>;
  courierMessageId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  executeAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informSessions?: Maybe<InformSessionListRelationFilter>;
  reason?: Maybe<StringFilter>;
  sentAt?: Maybe<DateTimeNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformAudienceMemberMessageStatusFilter>;
  target?: Maybe<StringFilter>;
  type?: Maybe<EnumInformAudienceMemberMessageTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAudienceMemberMessageOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformAudienceMemberMessageOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformAudienceMemberMessageOrderByRelevanceInput>;
  audienceMember?: Maybe<InformAudienceMemberOrderByWithRelationInput>;
  audienceMemberId?: Maybe<SortOrder>;
  context?: Maybe<SortOrder>;
  courier?: Maybe<SortOrder>;
  courierMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informSessions?: Maybe<InformSessionOrderByRelationAggregateInput>;
  reason?: Maybe<SortOrder>;
  sentAt?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformAudienceMemberMessageOrderByRelevanceFieldEnum {
  AudienceMemberId = 'audienceMemberId',
  CourierMessageId = 'courierMessageId',
  Id = 'id',
  Reason = 'reason',
  Target = 'target'
}

export type InformAudienceMemberMessageOrderByRelevanceInput = {
  fields: Array<InformAudienceMemberMessageOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformAudienceMemberMessageOrderByWithAggregationInput = {
  _count?: Maybe<InformAudienceMemberMessageCountOrderByAggregateInput>;
  _max?: Maybe<InformAudienceMemberMessageMaxOrderByAggregateInput>;
  _min?: Maybe<InformAudienceMemberMessageMinOrderByAggregateInput>;
  audienceMemberId?: Maybe<SortOrder>;
  context?: Maybe<SortOrder>;
  courier?: Maybe<SortOrder>;
  courierMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  sentAt?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceMemberMessageOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformAudienceMemberMessageOrderByRelevanceInput>;
  audienceMember?: Maybe<InformAudienceMemberOrderByWithRelationInput>;
  audienceMemberId?: Maybe<SortOrder>;
  context?: Maybe<SortOrder>;
  courier?: Maybe<SortOrder>;
  courierMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informSessions?: Maybe<InformSessionOrderByRelationAggregateInput>;
  reason?: Maybe<SortOrder>;
  sentAt?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceMemberMessageOrderByWithRelationInput = {
  _relevance?: Maybe<InformAudienceMemberMessageOrderByRelevanceInput>;
  audienceMember?: Maybe<InformAudienceMemberOrderByWithRelationInput>;
  audienceMemberId?: Maybe<SortOrder>;
  context?: Maybe<SortOrder>;
  courier?: Maybe<SortOrder>;
  courierMessageId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informSessions?: Maybe<InformSessionOrderByRelationAggregateInput>;
  reason?: Maybe<SortOrder>;
  sentAt?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformAudienceMemberMessageScalarFieldEnum {
  AudienceMemberId = 'audienceMemberId',
  Context = 'context',
  Courier = 'courier',
  CourierMessageId = 'courierMessageId',
  CreatedAt = 'createdAt',
  ExecuteAt = 'executeAt',
  Id = 'id',
  Reason = 'reason',
  SentAt = 'sentAt',
  Settings = 'settings',
  Status = 'status',
  Target = 'target',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type InformAudienceMemberMessageScalarWhereInput = {
  AND?: Maybe<Array<InformAudienceMemberMessageScalarWhereInput>>;
  NOT?: Maybe<Array<InformAudienceMemberMessageScalarWhereInput>>;
  OR?: Maybe<Array<InformAudienceMemberMessageScalarWhereInput>>;
  audienceMemberId?: Maybe<StringFilter>;
  context?: Maybe<JsonFilter>;
  courier?: Maybe<EnumInformAudienceMemberMessageCourierFilter>;
  courierMessageId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  executeAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  reason?: Maybe<StringFilter>;
  sentAt?: Maybe<DateTimeNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformAudienceMemberMessageStatusFilter>;
  target?: Maybe<StringFilter>;
  type?: Maybe<EnumInformAudienceMemberMessageTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAudienceMemberMessageScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformAudienceMemberMessageScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformAudienceMemberMessageScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformAudienceMemberMessageScalarWhereWithAggregatesInput>>;
  audienceMemberId?: Maybe<StringWithAggregatesFilter>;
  context?: Maybe<JsonWithAggregatesFilter>;
  courier?: Maybe<EnumInformAudienceMemberMessageCourierWithAggregatesFilter>;
  courierMessageId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  executeAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  reason?: Maybe<StringWithAggregatesFilter>;
  sentAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  status?: Maybe<EnumInformAudienceMemberMessageStatusWithAggregatesFilter>;
  target?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumInformAudienceMemberMessageTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformAudienceMemberMessageStatus {
  Created = 'Created',
  Error = 'Error',
  Executed = 'Executed',
  Skipped = 'Skipped'
}

export enum InformAudienceMemberMessageType {
  Email = 'Email',
  Sms = 'Sms'
}

export type InformAudienceMemberMessageUncheckedCreateInput = {
  audienceMemberId: Scalars['String'];
  context: Scalars['Json'];
  courier: InformAudienceMemberMessageCourier;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutInformAudienceMemberMessageInput>;
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceMemberMessageStatus;
  target: Scalars['String'];
  type: InformAudienceMemberMessageType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageUncheckedCreateNestedManyWithoutAudienceMemberInput = {
  connect?: Maybe<Array<InformAudienceMemberMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberMessageCreateOrConnectWithoutAudienceMemberInput>>;
  create?: Maybe<Array<InformAudienceMemberMessageCreateWithoutAudienceMemberInput>>;
  createMany?: Maybe<InformAudienceMemberMessageCreateManyAudienceMemberInputEnvelope>;
};

export type InformAudienceMemberMessageUncheckedCreateWithoutAudienceMemberInput = {
  context: Scalars['Json'];
  courier: InformAudienceMemberMessageCourier;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informSessions?: Maybe<InformSessionUncheckedCreateNestedManyWithoutInformAudienceMemberMessageInput>;
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceMemberMessageStatus;
  target: Scalars['String'];
  type: InformAudienceMemberMessageType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageUncheckedCreateWithoutInformSessionsInput = {
  audienceMemberId: Scalars['String'];
  context: Scalars['Json'];
  courier: InformAudienceMemberMessageCourier;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformAudienceMemberMessageStatus;
  target: Scalars['String'];
  type: InformAudienceMemberMessageType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageUncheckedUpdateInput = {
  audienceMemberId?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['Json']>;
  courier?: Maybe<InformAudienceMemberMessageCourier>;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutInformAudienceMemberMessageNestedInput>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceMemberMessageStatus>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<InformAudienceMemberMessageType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageUncheckedUpdateManyInput = {
  audienceMemberId?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['Json']>;
  courier?: Maybe<InformAudienceMemberMessageCourier>;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceMemberMessageStatus>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<InformAudienceMemberMessageType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageUncheckedUpdateManyWithoutAudienceMemberInput = {
  context?: Maybe<Scalars['Json']>;
  courier?: Maybe<InformAudienceMemberMessageCourier>;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceMemberMessageStatus>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<InformAudienceMemberMessageType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageUncheckedUpdateManyWithoutAudienceMemberNestedInput = {
  connect?: Maybe<Array<InformAudienceMemberMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberMessageCreateOrConnectWithoutAudienceMemberInput>>;
  create?: Maybe<Array<InformAudienceMemberMessageCreateWithoutAudienceMemberInput>>;
  createMany?: Maybe<InformAudienceMemberMessageCreateManyAudienceMemberInputEnvelope>;
  delete?: Maybe<Array<InformAudienceMemberMessageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceMemberMessageScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceMemberMessageWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceMemberMessageWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceMemberMessageUpdateWithWhereUniqueWithoutAudienceMemberInput>>;
  updateMany?: Maybe<Array<InformAudienceMemberMessageUpdateManyWithWhereWithoutAudienceMemberInput>>;
  upsert?: Maybe<Array<InformAudienceMemberMessageUpsertWithWhereUniqueWithoutAudienceMemberInput>>;
};

export type InformAudienceMemberMessageUncheckedUpdateWithoutAudienceMemberInput = {
  context?: Maybe<Scalars['Json']>;
  courier?: Maybe<InformAudienceMemberMessageCourier>;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informSessions?: Maybe<InformSessionUncheckedUpdateManyWithoutInformAudienceMemberMessageNestedInput>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceMemberMessageStatus>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<InformAudienceMemberMessageType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageUncheckedUpdateWithoutInformSessionsInput = {
  audienceMemberId?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['Json']>;
  courier?: Maybe<InformAudienceMemberMessageCourier>;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceMemberMessageStatus>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<InformAudienceMemberMessageType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageUpdateInput = {
  audienceMember?: Maybe<InformAudienceMemberUpdateOneRequiredWithoutInformAudienceMemberMessagesNestedInput>;
  context?: Maybe<Scalars['Json']>;
  courier?: Maybe<InformAudienceMemberMessageCourier>;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutInformAudienceMemberMessageNestedInput>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceMemberMessageStatus>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<InformAudienceMemberMessageType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageUpdateManyMutationInput = {
  context?: Maybe<Scalars['Json']>;
  courier?: Maybe<InformAudienceMemberMessageCourier>;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceMemberMessageStatus>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<InformAudienceMemberMessageType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageUpdateManyWithWhereWithoutAudienceMemberInput = {
  data: InformAudienceMemberMessageUpdateManyMutationInput;
  where: InformAudienceMemberMessageScalarWhereInput;
};

export type InformAudienceMemberMessageUpdateManyWithoutAudienceMemberNestedInput = {
  connect?: Maybe<Array<InformAudienceMemberMessageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberMessageCreateOrConnectWithoutAudienceMemberInput>>;
  create?: Maybe<Array<InformAudienceMemberMessageCreateWithoutAudienceMemberInput>>;
  createMany?: Maybe<InformAudienceMemberMessageCreateManyAudienceMemberInputEnvelope>;
  delete?: Maybe<Array<InformAudienceMemberMessageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceMemberMessageScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceMemberMessageWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceMemberMessageWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceMemberMessageUpdateWithWhereUniqueWithoutAudienceMemberInput>>;
  updateMany?: Maybe<Array<InformAudienceMemberMessageUpdateManyWithWhereWithoutAudienceMemberInput>>;
  upsert?: Maybe<Array<InformAudienceMemberMessageUpsertWithWhereUniqueWithoutAudienceMemberInput>>;
};

export type InformAudienceMemberMessageUpdateOneWithoutInformSessionsNestedInput = {
  connect?: Maybe<InformAudienceMemberMessageWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAudienceMemberMessageCreateOrConnectWithoutInformSessionsInput>;
  create?: Maybe<InformAudienceMemberMessageCreateWithoutInformSessionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformAudienceMemberMessageUpdateToOneWithWhereWithoutInformSessionsInput>;
  upsert?: Maybe<InformAudienceMemberMessageUpsertWithoutInformSessionsInput>;
};

export type InformAudienceMemberMessageUpdateToOneWithWhereWithoutInformSessionsInput = {
  data: InformAudienceMemberMessageUpdateWithoutInformSessionsInput;
  where?: Maybe<InformAudienceMemberMessageWhereInput>;
};

export type InformAudienceMemberMessageUpdateWithWhereUniqueWithoutAudienceMemberInput = {
  data: InformAudienceMemberMessageUpdateWithoutAudienceMemberInput;
  where: InformAudienceMemberMessageWhereUniqueInput;
};

export type InformAudienceMemberMessageUpdateWithoutAudienceMemberInput = {
  context?: Maybe<Scalars['Json']>;
  courier?: Maybe<InformAudienceMemberMessageCourier>;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informSessions?: Maybe<InformSessionUpdateManyWithoutInformAudienceMemberMessageNestedInput>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceMemberMessageStatus>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<InformAudienceMemberMessageType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageUpdateWithoutInformSessionsInput = {
  audienceMember?: Maybe<InformAudienceMemberUpdateOneRequiredWithoutInformAudienceMemberMessagesNestedInput>;
  context?: Maybe<Scalars['Json']>;
  courier?: Maybe<InformAudienceMemberMessageCourier>;
  courierMessageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformAudienceMemberMessageStatus>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<InformAudienceMemberMessageType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMessageUpsertWithWhereUniqueWithoutAudienceMemberInput = {
  create: InformAudienceMemberMessageCreateWithoutAudienceMemberInput;
  update: InformAudienceMemberMessageUpdateWithoutAudienceMemberInput;
  where: InformAudienceMemberMessageWhereUniqueInput;
};

export type InformAudienceMemberMessageUpsertWithoutInformSessionsInput = {
  create: InformAudienceMemberMessageCreateWithoutInformSessionsInput;
  update: InformAudienceMemberMessageUpdateWithoutInformSessionsInput;
  where?: Maybe<InformAudienceMemberMessageWhereInput>;
};

export type InformAudienceMemberMessageWhereInput = {
  AND?: Maybe<Array<InformAudienceMemberMessageWhereInput>>;
  NOT?: Maybe<Array<InformAudienceMemberMessageWhereInput>>;
  OR?: Maybe<Array<InformAudienceMemberMessageWhereInput>>;
  audienceMember?: Maybe<InformAudienceMemberScalarRelationFilter>;
  audienceMemberId?: Maybe<StringFilter>;
  context?: Maybe<JsonFilter>;
  courier?: Maybe<EnumInformAudienceMemberMessageCourierFilter>;
  courierMessageId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  executeAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informSessions?: Maybe<InformSessionListRelationFilter>;
  reason?: Maybe<StringFilter>;
  sentAt?: Maybe<DateTimeNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformAudienceMemberMessageStatusFilter>;
  target?: Maybe<StringFilter>;
  type?: Maybe<EnumInformAudienceMemberMessageTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAudienceMemberMessageWhereUniqueInput = {
  AND?: Maybe<Array<InformAudienceMemberMessageWhereInput>>;
  NOT?: Maybe<Array<InformAudienceMemberMessageWhereInput>>;
  OR?: Maybe<Array<InformAudienceMemberMessageWhereInput>>;
  audienceMember?: Maybe<InformAudienceMemberScalarRelationFilter>;
  audienceMemberId?: Maybe<StringFilter>;
  context?: Maybe<JsonFilter>;
  courier?: Maybe<EnumInformAudienceMemberMessageCourierFilter>;
  courierMessageId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  executeAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  informSessions?: Maybe<InformSessionListRelationFilter>;
  reason?: Maybe<StringFilter>;
  sentAt?: Maybe<DateTimeNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformAudienceMemberMessageStatusFilter>;
  target?: Maybe<StringFilter>;
  type?: Maybe<EnumInformAudienceMemberMessageTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAudienceMemberMinAggregateOutputType = {
  __typename?: 'InformAudienceMemberMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  servicePurchaseSummaryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceMemberOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformAudienceMemberOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformAudienceMemberOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageOrderByRelationAggregateInput>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentOrderByWithRelationInput>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  informCampaignExecution?: Maybe<InformCampaignExecutionOrderByWithRelationInput>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  informSession?: Maybe<InformSessionOrderByRelationAggregateInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryOrderByWithRelationInput>;
  servicePurchaseSummaryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformAudienceMemberOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  Id = 'id',
  InformCampaignEnrollmentId = 'informCampaignEnrollmentId',
  InformCampaignExecutionId = 'informCampaignExecutionId',
  ServicePurchaseSummaryId = 'servicePurchaseSummaryId'
}

export type InformAudienceMemberOrderByRelevanceInput = {
  fields: Array<InformAudienceMemberOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformAudienceMemberOrderByWithAggregationInput = {
  _count?: Maybe<InformAudienceMemberCountOrderByAggregateInput>;
  _max?: Maybe<InformAudienceMemberMaxOrderByAggregateInput>;
  _min?: Maybe<InformAudienceMemberMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  servicePurchaseSummaryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceMemberOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformAudienceMemberOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageOrderByRelationAggregateInput>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentOrderByWithRelationInput>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  informCampaignExecution?: Maybe<InformCampaignExecutionOrderByWithRelationInput>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  informSession?: Maybe<InformSessionOrderByRelationAggregateInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryOrderByWithRelationInput>;
  servicePurchaseSummaryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformAudienceMemberOrderByWithRelationInput = {
  _relevance?: Maybe<InformAudienceMemberOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageOrderByRelationAggregateInput>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentOrderByWithRelationInput>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  informCampaignExecution?: Maybe<InformCampaignExecutionOrderByWithRelationInput>;
  informCampaignExecutionId?: Maybe<SortOrder>;
  informSession?: Maybe<InformSessionOrderByRelationAggregateInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryOrderByWithRelationInput>;
  servicePurchaseSummaryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformAudienceMemberScalarFieldEnum {
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Id = 'id',
  InformCampaignEnrollmentId = 'informCampaignEnrollmentId',
  InformCampaignExecutionId = 'informCampaignExecutionId',
  ServicePurchaseSummaryId = 'servicePurchaseSummaryId',
  UpdatedAt = 'updatedAt'
}

export type InformAudienceMemberScalarRelationFilter = {
  AND?: Maybe<Array<InformAudienceMemberWhereInput>>;
  NOT?: Maybe<Array<InformAudienceMemberWhereInput>>;
  OR?: Maybe<Array<InformAudienceMemberWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageListRelationFilter>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentScalarRelationFilter>;
  informCampaignEnrollmentId?: Maybe<StringFilter>;
  informCampaignExecution?: Maybe<InformCampaignExecutionScalarRelationFilter>;
  informCampaignExecutionId?: Maybe<StringFilter>;
  informSession?: Maybe<InformSessionListRelationFilter>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryNullableScalarRelationFilter>;
  servicePurchaseSummaryId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAudienceMemberScalarWhereInput = {
  AND?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  NOT?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  OR?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informCampaignEnrollmentId?: Maybe<StringFilter>;
  informCampaignExecutionId?: Maybe<StringFilter>;
  servicePurchaseSummaryId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAudienceMemberScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformAudienceMemberScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformAudienceMemberScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformAudienceMemberScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informCampaignEnrollmentId?: Maybe<StringWithAggregatesFilter>;
  informCampaignExecutionId?: Maybe<StringWithAggregatesFilter>;
  servicePurchaseSummaryId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type InformAudienceMemberUncheckedCreateInput = {
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecutionId: Scalars['String'];
  informSession?: Maybe<InformSessionUncheckedCreateNestedManyWithoutInformAudienceMemberInput>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutClinicInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyClinicInputEnvelope>;
};

export type InformAudienceMemberUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyClinicPetParentInputEnvelope>;
};

export type InformAudienceMemberUncheckedCreateNestedManyWithoutInformCampaignEnrollmentInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutInformCampaignEnrollmentInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutInformCampaignEnrollmentInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyInformCampaignEnrollmentInputEnvelope>;
};

export type InformAudienceMemberUncheckedCreateNestedManyWithoutInformCampaignExecutionInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutInformCampaignExecutionInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutInformCampaignExecutionInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyInformCampaignExecutionInputEnvelope>;
};

export type InformAudienceMemberUncheckedCreateNestedManyWithoutServicePurchaseSummaryInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutServicePurchaseSummaryInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutServicePurchaseSummaryInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyServicePurchaseSummaryInputEnvelope>;
};

export type InformAudienceMemberUncheckedCreateWithoutClinicInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecutionId: Scalars['String'];
  informSession?: Maybe<InformSessionUncheckedCreateNestedManyWithoutInformAudienceMemberInput>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedCreateWithoutClinicPetParentInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecutionId: Scalars['String'];
  informSession?: Maybe<InformSessionUncheckedCreateNestedManyWithoutInformAudienceMemberInput>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedCreateWithoutInformAudienceMemberMessagesInput = {
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecutionId: Scalars['String'];
  informSession?: Maybe<InformSessionUncheckedCreateNestedManyWithoutInformAudienceMemberInput>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedCreateWithoutInformCampaignEnrollmentInput = {
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignExecutionId: Scalars['String'];
  informSession?: Maybe<InformSessionUncheckedCreateNestedManyWithoutInformAudienceMemberInput>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedCreateWithoutInformCampaignExecutionInput = {
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignEnrollmentId: Scalars['String'];
  informSession?: Maybe<InformSessionUncheckedCreateNestedManyWithoutInformAudienceMemberInput>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedCreateWithoutInformSessionInput = {
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecutionId: Scalars['String'];
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedCreateWithoutServicePurchaseSummaryInput = {
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedCreateNestedManyWithoutAudienceMemberInput>;
  informCampaignEnrollmentId: Scalars['String'];
  informCampaignExecutionId: Scalars['String'];
  informSession?: Maybe<InformSessionUncheckedCreateNestedManyWithoutInformAudienceMemberInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  informSession?: Maybe<InformSessionUncheckedUpdateManyWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateManyWithoutClinicInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutClinicInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceMemberUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<InformAudienceMemberUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<InformAudienceMemberUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceMemberUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<InformAudienceMemberUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<InformAudienceMemberUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type InformAudienceMemberUncheckedUpdateManyWithoutInformCampaignEnrollmentInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateManyWithoutInformCampaignEnrollmentNestedInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutInformCampaignEnrollmentInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutInformCampaignEnrollmentInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyInformCampaignEnrollmentInputEnvelope>;
  delete?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceMemberUpdateWithWhereUniqueWithoutInformCampaignEnrollmentInput>>;
  updateMany?: Maybe<Array<InformAudienceMemberUpdateManyWithWhereWithoutInformCampaignEnrollmentInput>>;
  upsert?: Maybe<Array<InformAudienceMemberUpsertWithWhereUniqueWithoutInformCampaignEnrollmentInput>>;
};

export type InformAudienceMemberUncheckedUpdateManyWithoutInformCampaignExecutionInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateManyWithoutInformCampaignExecutionNestedInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutInformCampaignExecutionInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutInformCampaignExecutionInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyInformCampaignExecutionInputEnvelope>;
  delete?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceMemberUpdateWithWhereUniqueWithoutInformCampaignExecutionInput>>;
  updateMany?: Maybe<Array<InformAudienceMemberUpdateManyWithWhereWithoutInformCampaignExecutionInput>>;
  upsert?: Maybe<Array<InformAudienceMemberUpsertWithWhereUniqueWithoutInformCampaignExecutionInput>>;
};

export type InformAudienceMemberUncheckedUpdateManyWithoutServicePurchaseSummaryInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateManyWithoutServicePurchaseSummaryNestedInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutServicePurchaseSummaryInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutServicePurchaseSummaryInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyServicePurchaseSummaryInputEnvelope>;
  delete?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceMemberUpdateWithWhereUniqueWithoutServicePurchaseSummaryInput>>;
  updateMany?: Maybe<Array<InformAudienceMemberUpdateManyWithWhereWithoutServicePurchaseSummaryInput>>;
  upsert?: Maybe<Array<InformAudienceMemberUpsertWithWhereUniqueWithoutServicePurchaseSummaryInput>>;
};

export type InformAudienceMemberUncheckedUpdateWithoutClinicInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  informSession?: Maybe<InformSessionUncheckedUpdateManyWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateWithoutClinicPetParentInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  informSession?: Maybe<InformSessionUncheckedUpdateManyWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateWithoutInformAudienceMemberMessagesInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  informSession?: Maybe<InformSessionUncheckedUpdateManyWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateWithoutInformCampaignEnrollmentInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  informSession?: Maybe<InformSessionUncheckedUpdateManyWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateWithoutInformCampaignExecutionInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informSession?: Maybe<InformSessionUncheckedUpdateManyWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateWithoutInformSessionInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  servicePurchaseSummaryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUncheckedUpdateWithoutServicePurchaseSummaryInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUncheckedUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  informCampaignExecutionId?: Maybe<Scalars['String']>;
  informSession?: Maybe<InformSessionUncheckedUpdateManyWithoutInformAudienceMemberNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informSession?: Maybe<InformSessionUpdateManyWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryUpdateOneWithoutInformAudienceMemberNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUpdateManyWithWhereWithoutClinicInput = {
  data: InformAudienceMemberUpdateManyMutationInput;
  where: InformAudienceMemberScalarWhereInput;
};

export type InformAudienceMemberUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: InformAudienceMemberUpdateManyMutationInput;
  where: InformAudienceMemberScalarWhereInput;
};

export type InformAudienceMemberUpdateManyWithWhereWithoutInformCampaignEnrollmentInput = {
  data: InformAudienceMemberUpdateManyMutationInput;
  where: InformAudienceMemberScalarWhereInput;
};

export type InformAudienceMemberUpdateManyWithWhereWithoutInformCampaignExecutionInput = {
  data: InformAudienceMemberUpdateManyMutationInput;
  where: InformAudienceMemberScalarWhereInput;
};

export type InformAudienceMemberUpdateManyWithWhereWithoutServicePurchaseSummaryInput = {
  data: InformAudienceMemberUpdateManyMutationInput;
  where: InformAudienceMemberScalarWhereInput;
};

export type InformAudienceMemberUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutClinicInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceMemberUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<InformAudienceMemberUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<InformAudienceMemberUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type InformAudienceMemberUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceMemberUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<InformAudienceMemberUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<InformAudienceMemberUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type InformAudienceMemberUpdateManyWithoutInformCampaignEnrollmentNestedInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutInformCampaignEnrollmentInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutInformCampaignEnrollmentInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyInformCampaignEnrollmentInputEnvelope>;
  delete?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceMemberUpdateWithWhereUniqueWithoutInformCampaignEnrollmentInput>>;
  updateMany?: Maybe<Array<InformAudienceMemberUpdateManyWithWhereWithoutInformCampaignEnrollmentInput>>;
  upsert?: Maybe<Array<InformAudienceMemberUpsertWithWhereUniqueWithoutInformCampaignEnrollmentInput>>;
};

export type InformAudienceMemberUpdateManyWithoutInformCampaignExecutionNestedInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutInformCampaignExecutionInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutInformCampaignExecutionInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyInformCampaignExecutionInputEnvelope>;
  delete?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceMemberUpdateWithWhereUniqueWithoutInformCampaignExecutionInput>>;
  updateMany?: Maybe<Array<InformAudienceMemberUpdateManyWithWhereWithoutInformCampaignExecutionInput>>;
  upsert?: Maybe<Array<InformAudienceMemberUpsertWithWhereUniqueWithoutInformCampaignExecutionInput>>;
};

export type InformAudienceMemberUpdateManyWithoutServicePurchaseSummaryNestedInput = {
  connect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAudienceMemberCreateOrConnectWithoutServicePurchaseSummaryInput>>;
  create?: Maybe<Array<InformAudienceMemberCreateWithoutServicePurchaseSummaryInput>>;
  createMany?: Maybe<InformAudienceMemberCreateManyServicePurchaseSummaryInputEnvelope>;
  delete?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAudienceMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  set?: Maybe<Array<InformAudienceMemberWhereUniqueInput>>;
  update?: Maybe<Array<InformAudienceMemberUpdateWithWhereUniqueWithoutServicePurchaseSummaryInput>>;
  updateMany?: Maybe<Array<InformAudienceMemberUpdateManyWithWhereWithoutServicePurchaseSummaryInput>>;
  upsert?: Maybe<Array<InformAudienceMemberUpsertWithWhereUniqueWithoutServicePurchaseSummaryInput>>;
};

export type InformAudienceMemberUpdateOneRequiredWithoutInformAudienceMemberMessagesNestedInput = {
  connect?: Maybe<InformAudienceMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAudienceMemberCreateOrConnectWithoutInformAudienceMemberMessagesInput>;
  create?: Maybe<InformAudienceMemberCreateWithoutInformAudienceMemberMessagesInput>;
  update?: Maybe<InformAudienceMemberUpdateToOneWithWhereWithoutInformAudienceMemberMessagesInput>;
  upsert?: Maybe<InformAudienceMemberUpsertWithoutInformAudienceMemberMessagesInput>;
};

export type InformAudienceMemberUpdateOneRequiredWithoutInformSessionNestedInput = {
  connect?: Maybe<InformAudienceMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAudienceMemberCreateOrConnectWithoutInformSessionInput>;
  create?: Maybe<InformAudienceMemberCreateWithoutInformSessionInput>;
  update?: Maybe<InformAudienceMemberUpdateToOneWithWhereWithoutInformSessionInput>;
  upsert?: Maybe<InformAudienceMemberUpsertWithoutInformSessionInput>;
};

export type InformAudienceMemberUpdateToOneWithWhereWithoutInformAudienceMemberMessagesInput = {
  data: InformAudienceMemberUpdateWithoutInformAudienceMemberMessagesInput;
  where?: Maybe<InformAudienceMemberWhereInput>;
};

export type InformAudienceMemberUpdateToOneWithWhereWithoutInformSessionInput = {
  data: InformAudienceMemberUpdateWithoutInformSessionInput;
  where?: Maybe<InformAudienceMemberWhereInput>;
};

export type InformAudienceMemberUpdateWithWhereUniqueWithoutClinicInput = {
  data: InformAudienceMemberUpdateWithoutClinicInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: InformAudienceMemberUpdateWithoutClinicPetParentInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberUpdateWithWhereUniqueWithoutInformCampaignEnrollmentInput = {
  data: InformAudienceMemberUpdateWithoutInformCampaignEnrollmentInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberUpdateWithWhereUniqueWithoutInformCampaignExecutionInput = {
  data: InformAudienceMemberUpdateWithoutInformCampaignExecutionInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberUpdateWithWhereUniqueWithoutServicePurchaseSummaryInput = {
  data: InformAudienceMemberUpdateWithoutServicePurchaseSummaryInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberUpdateWithoutClinicInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informSession?: Maybe<InformSessionUpdateManyWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryUpdateOneWithoutInformAudienceMemberNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUpdateWithoutClinicPetParentInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informSession?: Maybe<InformSessionUpdateManyWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryUpdateOneWithoutInformAudienceMemberNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUpdateWithoutInformAudienceMemberMessagesInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informSession?: Maybe<InformSessionUpdateManyWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryUpdateOneWithoutInformAudienceMemberNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUpdateWithoutInformCampaignEnrollmentInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informSession?: Maybe<InformSessionUpdateManyWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryUpdateOneWithoutInformAudienceMemberNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUpdateWithoutInformCampaignExecutionInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informSession?: Maybe<InformSessionUpdateManyWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryUpdateOneWithoutInformAudienceMemberNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUpdateWithoutInformSessionInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryUpdateOneWithoutInformAudienceMemberNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUpdateWithoutServicePurchaseSummaryInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageUpdateManyWithoutAudienceMemberNestedInput>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informCampaignExecution?: Maybe<InformCampaignExecutionUpdateOneRequiredWithoutInformAudienceMemberNestedInput>;
  informSession?: Maybe<InformSessionUpdateManyWithoutInformAudienceMemberNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformAudienceMemberUpsertWithWhereUniqueWithoutClinicInput = {
  create: InformAudienceMemberCreateWithoutClinicInput;
  update: InformAudienceMemberUpdateWithoutClinicInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: InformAudienceMemberCreateWithoutClinicPetParentInput;
  update: InformAudienceMemberUpdateWithoutClinicPetParentInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberUpsertWithWhereUniqueWithoutInformCampaignEnrollmentInput = {
  create: InformAudienceMemberCreateWithoutInformCampaignEnrollmentInput;
  update: InformAudienceMemberUpdateWithoutInformCampaignEnrollmentInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberUpsertWithWhereUniqueWithoutInformCampaignExecutionInput = {
  create: InformAudienceMemberCreateWithoutInformCampaignExecutionInput;
  update: InformAudienceMemberUpdateWithoutInformCampaignExecutionInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberUpsertWithWhereUniqueWithoutServicePurchaseSummaryInput = {
  create: InformAudienceMemberCreateWithoutServicePurchaseSummaryInput;
  update: InformAudienceMemberUpdateWithoutServicePurchaseSummaryInput;
  where: InformAudienceMemberWhereUniqueInput;
};

export type InformAudienceMemberUpsertWithoutInformAudienceMemberMessagesInput = {
  create: InformAudienceMemberCreateWithoutInformAudienceMemberMessagesInput;
  update: InformAudienceMemberUpdateWithoutInformAudienceMemberMessagesInput;
  where?: Maybe<InformAudienceMemberWhereInput>;
};

export type InformAudienceMemberUpsertWithoutInformSessionInput = {
  create: InformAudienceMemberCreateWithoutInformSessionInput;
  update: InformAudienceMemberUpdateWithoutInformSessionInput;
  where?: Maybe<InformAudienceMemberWhereInput>;
};

export type InformAudienceMemberWhereInput = {
  AND?: Maybe<Array<InformAudienceMemberWhereInput>>;
  NOT?: Maybe<Array<InformAudienceMemberWhereInput>>;
  OR?: Maybe<Array<InformAudienceMemberWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageListRelationFilter>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentScalarRelationFilter>;
  informCampaignEnrollmentId?: Maybe<StringFilter>;
  informCampaignExecution?: Maybe<InformCampaignExecutionScalarRelationFilter>;
  informCampaignExecutionId?: Maybe<StringFilter>;
  informSession?: Maybe<InformSessionListRelationFilter>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryNullableScalarRelationFilter>;
  servicePurchaseSummaryId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAudienceMemberWhereUniqueInput = {
  AND?: Maybe<Array<InformAudienceMemberWhereInput>>;
  NOT?: Maybe<Array<InformAudienceMemberWhereInput>>;
  OR?: Maybe<Array<InformAudienceMemberWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessages?: Maybe<InformAudienceMemberMessageListRelationFilter>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentScalarRelationFilter>;
  informCampaignEnrollmentId?: Maybe<StringFilter>;
  informCampaignExecution?: Maybe<InformCampaignExecutionScalarRelationFilter>;
  informCampaignExecutionId?: Maybe<StringFilter>;
  informCampaignExecutionId_informCampaignEnrollmentId_clinicPetParentId?: Maybe<InformAudienceMemberInformCampaignExecutionIdInformCampaignEnrollmentIdClinicPetParentIdCompoundUniqueInput>;
  informSession?: Maybe<InformSessionListRelationFilter>;
  servicePurchaseSummary?: Maybe<ServicePurchaseSummaryNullableScalarRelationFilter>;
  servicePurchaseSummaryId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformAutomationCampaign = {
  __typename?: 'InformAutomationCampaign';
  id: Scalars['String'];
  informCampaign: InformCampaign;
  workflowEventSetting: WorkflowEventSetting;
  workflowEventSettingId: Scalars['String'];
};

export type InformAutomationCampaignCountAggregateOutputType = {
  __typename?: 'InformAutomationCampaignCountAggregateOutputType';
  _all: Scalars['Int'];
  id: Scalars['Int'];
  workflowEventSettingId: Scalars['Int'];
};

export type InformAutomationCampaignCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type InformAutomationCampaignCreateInput = {
  informCampaign: InformCampaignCreateNestedOneWithoutInformAutomationCampaignInput;
  workflowEventSetting: WorkflowEventSettingCreateNestedOneWithoutInformAutomationCampaignsInput;
};

export type InformAutomationCampaignCreateManyInput = {
  id: Scalars['String'];
  workflowEventSettingId: Scalars['String'];
};

export type InformAutomationCampaignCreateManyWorkflowEventSettingInput = {
  id: Scalars['String'];
};

export type InformAutomationCampaignCreateManyWorkflowEventSettingInputEnvelope = {
  data: Array<InformAutomationCampaignCreateManyWorkflowEventSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput = {
  connect?: Maybe<Array<InformAutomationCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAutomationCampaignCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<InformAutomationCampaignCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<InformAutomationCampaignCreateManyWorkflowEventSettingInputEnvelope>;
};

export type InformAutomationCampaignCreateNestedOneWithoutInformCampaignInput = {
  connect?: Maybe<InformAutomationCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAutomationCampaignCreateOrConnectWithoutInformCampaignInput>;
  create?: Maybe<InformAutomationCampaignCreateWithoutInformCampaignInput>;
};

export type InformAutomationCampaignCreateOrConnectWithoutInformCampaignInput = {
  create: InformAutomationCampaignCreateWithoutInformCampaignInput;
  where: InformAutomationCampaignWhereUniqueInput;
};

export type InformAutomationCampaignCreateOrConnectWithoutWorkflowEventSettingInput = {
  create: InformAutomationCampaignCreateWithoutWorkflowEventSettingInput;
  where: InformAutomationCampaignWhereUniqueInput;
};

export type InformAutomationCampaignCreateWithoutInformCampaignInput = {
  workflowEventSetting: WorkflowEventSettingCreateNestedOneWithoutInformAutomationCampaignsInput;
};

export type InformAutomationCampaignCreateWithoutWorkflowEventSettingInput = {
  informCampaign: InformCampaignCreateNestedOneWithoutInformAutomationCampaignInput;
};

export type InformAutomationCampaignGroupByOutputType = {
  __typename?: 'InformAutomationCampaignGroupByOutputType';
  _count?: Maybe<InformAutomationCampaignCountAggregateOutputType>;
  _max?: Maybe<InformAutomationCampaignMaxAggregateOutputType>;
  _min?: Maybe<InformAutomationCampaignMinAggregateOutputType>;
  id: Scalars['String'];
  workflowEventSettingId: Scalars['String'];
};

export type InformAutomationCampaignListRelationFilter = {
  every?: Maybe<InformAutomationCampaignWhereInput>;
  none?: Maybe<InformAutomationCampaignWhereInput>;
  some?: Maybe<InformAutomationCampaignWhereInput>;
};

export type InformAutomationCampaignMaxAggregateOutputType = {
  __typename?: 'InformAutomationCampaignMaxAggregateOutputType';
  id?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type InformAutomationCampaignMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type InformAutomationCampaignMinAggregateOutputType = {
  __typename?: 'InformAutomationCampaignMinAggregateOutputType';
  id?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type InformAutomationCampaignMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type InformAutomationCampaignNullableScalarRelationFilter = {
  AND?: Maybe<Array<InformAutomationCampaignWhereInput>>;
  NOT?: Maybe<Array<InformAutomationCampaignWhereInput>>;
  OR?: Maybe<Array<InformAutomationCampaignWhereInput>>;
  id?: Maybe<StringFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  workflowEventSetting?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  workflowEventSettingId?: Maybe<StringFilter>;
};

export type InformAutomationCampaignOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformAutomationCampaignOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformAutomationCampaignOrderByRelevanceInput>;
  id?: Maybe<SortOrder>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export enum InformAutomationCampaignOrderByRelevanceFieldEnum {
  Id = 'id',
  WorkflowEventSettingId = 'workflowEventSettingId'
}

export type InformAutomationCampaignOrderByRelevanceInput = {
  fields: Array<InformAutomationCampaignOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformAutomationCampaignOrderByWithAggregationInput = {
  _count?: Maybe<InformAutomationCampaignCountOrderByAggregateInput>;
  _max?: Maybe<InformAutomationCampaignMaxOrderByAggregateInput>;
  _min?: Maybe<InformAutomationCampaignMinOrderByAggregateInput>;
  id?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type InformAutomationCampaignOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformAutomationCampaignOrderByRelevanceInput>;
  id?: Maybe<SortOrder>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export type InformAutomationCampaignOrderByWithRelationInput = {
  _relevance?: Maybe<InformAutomationCampaignOrderByRelevanceInput>;
  id?: Maybe<SortOrder>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowEventSettingId?: Maybe<SortOrder>;
};

export enum InformAutomationCampaignScalarFieldEnum {
  Id = 'id',
  WorkflowEventSettingId = 'workflowEventSettingId'
}

export type InformAutomationCampaignScalarWhereInput = {
  AND?: Maybe<Array<InformAutomationCampaignScalarWhereInput>>;
  NOT?: Maybe<Array<InformAutomationCampaignScalarWhereInput>>;
  OR?: Maybe<Array<InformAutomationCampaignScalarWhereInput>>;
  id?: Maybe<StringFilter>;
  workflowEventSettingId?: Maybe<StringFilter>;
};

export type InformAutomationCampaignScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformAutomationCampaignScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformAutomationCampaignScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformAutomationCampaignScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  workflowEventSettingId?: Maybe<StringWithAggregatesFilter>;
};

export type InformAutomationCampaignUncheckedCreateInput = {
  id: Scalars['String'];
  workflowEventSettingId: Scalars['String'];
};

export type InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput = {
  connect?: Maybe<Array<InformAutomationCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAutomationCampaignCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<InformAutomationCampaignCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<InformAutomationCampaignCreateManyWorkflowEventSettingInputEnvelope>;
};

export type InformAutomationCampaignUncheckedCreateNestedOneWithoutInformCampaignInput = {
  connect?: Maybe<InformAutomationCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAutomationCampaignCreateOrConnectWithoutInformCampaignInput>;
  create?: Maybe<InformAutomationCampaignCreateWithoutInformCampaignInput>;
};

export type InformAutomationCampaignUncheckedCreateWithoutInformCampaignInput = {
  workflowEventSettingId: Scalars['String'];
};

export type InformAutomationCampaignUncheckedCreateWithoutWorkflowEventSettingInput = {
  id: Scalars['String'];
};

export type InformAutomationCampaignUncheckedUpdateInput = {
  id?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type InformAutomationCampaignUncheckedUpdateManyInput = {
  id?: Maybe<Scalars['String']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingInput = {
  id?: Maybe<Scalars['String']>;
};

export type InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput = {
  connect?: Maybe<Array<InformAutomationCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAutomationCampaignCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<InformAutomationCampaignCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<InformAutomationCampaignCreateManyWorkflowEventSettingInputEnvelope>;
  delete?: Maybe<Array<InformAutomationCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAutomationCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAutomationCampaignWhereUniqueInput>>;
  set?: Maybe<Array<InformAutomationCampaignWhereUniqueInput>>;
  update?: Maybe<Array<InformAutomationCampaignUpdateWithWhereUniqueWithoutWorkflowEventSettingInput>>;
  updateMany?: Maybe<Array<InformAutomationCampaignUpdateManyWithWhereWithoutWorkflowEventSettingInput>>;
  upsert?: Maybe<Array<InformAutomationCampaignUpsertWithWhereUniqueWithoutWorkflowEventSettingInput>>;
};

export type InformAutomationCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput = {
  connect?: Maybe<InformAutomationCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAutomationCampaignCreateOrConnectWithoutInformCampaignInput>;
  create?: Maybe<InformAutomationCampaignCreateWithoutInformCampaignInput>;
  delete?: Maybe<InformAutomationCampaignWhereInput>;
  disconnect?: Maybe<InformAutomationCampaignWhereInput>;
  update?: Maybe<InformAutomationCampaignUpdateToOneWithWhereWithoutInformCampaignInput>;
  upsert?: Maybe<InformAutomationCampaignUpsertWithoutInformCampaignInput>;
};

export type InformAutomationCampaignUncheckedUpdateWithoutInformCampaignInput = {
  workflowEventSettingId?: Maybe<Scalars['String']>;
};

export type InformAutomationCampaignUncheckedUpdateWithoutWorkflowEventSettingInput = {
  id?: Maybe<Scalars['String']>;
};

export type InformAutomationCampaignUpdateInput = {
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformAutomationCampaignNestedInput>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutInformAutomationCampaignsNestedInput>;
};

export type InformAutomationCampaignUpdateManyMutationInput = {
  id?: Maybe<StringNullableFilter>;
  workflowEventSettingId?: Maybe<StringNullableFilter>;
};

export type InformAutomationCampaignUpdateManyWithWhereWithoutWorkflowEventSettingInput = {
  data: InformAutomationCampaignUpdateManyMutationInput;
  where: InformAutomationCampaignScalarWhereInput;
};

export type InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput = {
  connect?: Maybe<Array<InformAutomationCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformAutomationCampaignCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<InformAutomationCampaignCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<InformAutomationCampaignCreateManyWorkflowEventSettingInputEnvelope>;
  delete?: Maybe<Array<InformAutomationCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformAutomationCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<InformAutomationCampaignWhereUniqueInput>>;
  set?: Maybe<Array<InformAutomationCampaignWhereUniqueInput>>;
  update?: Maybe<Array<InformAutomationCampaignUpdateWithWhereUniqueWithoutWorkflowEventSettingInput>>;
  updateMany?: Maybe<Array<InformAutomationCampaignUpdateManyWithWhereWithoutWorkflowEventSettingInput>>;
  upsert?: Maybe<Array<InformAutomationCampaignUpsertWithWhereUniqueWithoutWorkflowEventSettingInput>>;
};

export type InformAutomationCampaignUpdateOneWithoutInformCampaignNestedInput = {
  connect?: Maybe<InformAutomationCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformAutomationCampaignCreateOrConnectWithoutInformCampaignInput>;
  create?: Maybe<InformAutomationCampaignCreateWithoutInformCampaignInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformAutomationCampaignUpdateToOneWithWhereWithoutInformCampaignInput>;
  upsert?: Maybe<InformAutomationCampaignUpsertWithoutInformCampaignInput>;
};

export type InformAutomationCampaignUpdateToOneWithWhereWithoutInformCampaignInput = {
  data: InformAutomationCampaignUpdateWithoutInformCampaignInput;
  where?: Maybe<InformAutomationCampaignWhereInput>;
};

export type InformAutomationCampaignUpdateWithWhereUniqueWithoutWorkflowEventSettingInput = {
  data: InformAutomationCampaignUpdateWithoutWorkflowEventSettingInput;
  where: InformAutomationCampaignWhereUniqueInput;
};

export type InformAutomationCampaignUpdateWithoutInformCampaignInput = {
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutInformAutomationCampaignsNestedInput>;
};

export type InformAutomationCampaignUpdateWithoutWorkflowEventSettingInput = {
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformAutomationCampaignNestedInput>;
};

export type InformAutomationCampaignUpsertWithWhereUniqueWithoutWorkflowEventSettingInput = {
  create: InformAutomationCampaignCreateWithoutWorkflowEventSettingInput;
  update: InformAutomationCampaignUpdateWithoutWorkflowEventSettingInput;
  where: InformAutomationCampaignWhereUniqueInput;
};

export type InformAutomationCampaignUpsertWithoutInformCampaignInput = {
  create: InformAutomationCampaignCreateWithoutInformCampaignInput;
  update: InformAutomationCampaignUpdateWithoutInformCampaignInput;
  where?: Maybe<InformAutomationCampaignWhereInput>;
};

export type InformAutomationCampaignWhereInput = {
  AND?: Maybe<Array<InformAutomationCampaignWhereInput>>;
  NOT?: Maybe<Array<InformAutomationCampaignWhereInput>>;
  OR?: Maybe<Array<InformAutomationCampaignWhereInput>>;
  id?: Maybe<StringFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  workflowEventSetting?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  workflowEventSettingId?: Maybe<StringFilter>;
};

export type InformAutomationCampaignWhereUniqueInput = {
  AND?: Maybe<Array<InformAutomationCampaignWhereInput>>;
  NOT?: Maybe<Array<InformAutomationCampaignWhereInput>>;
  OR?: Maybe<Array<InformAutomationCampaignWhereInput>>;
  id?: Maybe<Scalars['String']>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  workflowEventSetting?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  workflowEventSettingId?: Maybe<StringFilter>;
};

export type InformCampaign = {
  __typename?: 'InformCampaign';
  _count: InformCampaignCountOutputType;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informAudienceDefinition: InformAudienceDefinition;
  informAudienceDefinitionId: Scalars['String'];
  informAutomationCampaign?: Maybe<InformAutomationCampaign>;
  informCampaignEnrollments: Array<InformCampaignEnrollment>;
  informCampaignExecutions: Array<InformCampaignExecution>;
  informCampaignGroup?: Maybe<InformCampaignGroup>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaign>;
  informPartnerProgram: InformPartnerProgram;
  informPartnerProgramId: Scalars['String'];
  informScheduledCampaign?: Maybe<InformScheduledCampaign>;
  name: Scalars['String'];
  status: InformCampaignStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt: Scalars['DateTime'];
  visibility: InformCampaignVisibility;
};


export type InformCampaignInformAutomationCampaignArgs = {
  where?: Maybe<InformAutomationCampaignWhereInput>;
};


export type InformCampaignInformCampaignEnrollmentsArgs = {
  cursor?: Maybe<InformCampaignEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignEnrollmentWhereInput>;
};


export type InformCampaignInformCampaignExecutionsArgs = {
  cursor?: Maybe<InformCampaignExecutionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignExecutionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignExecutionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignExecutionWhereInput>;
};


export type InformCampaignInformCampaignGroupArgs = {
  where?: Maybe<InformCampaignGroupWhereInput>;
};


export type InformCampaignInformEventDrivenCampaignArgs = {
  where?: Maybe<InformEventDrivenCampaignWhereInput>;
};


export type InformCampaignInformScheduledCampaignArgs = {
  where?: Maybe<InformScheduledCampaignWhereInput>;
};

export type InformCampaignCountAggregateOutputType = {
  __typename?: 'InformCampaignCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  displayName: Scalars['Int'];
  id: Scalars['Int'];
  informAudienceDefinitionId: Scalars['Int'];
  informCampaignGroupId: Scalars['Int'];
  informPartnerProgramId: Scalars['Int'];
  name: Scalars['Int'];
  status: Scalars['Int'];
  statusMessage: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  visibility: Scalars['Int'];
};

export type InformCampaignCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  informCampaignGroupId?: Maybe<SortOrder>;
  informPartnerProgramId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export type InformCampaignCountOutputType = {
  __typename?: 'InformCampaignCountOutputType';
  informCampaignEnrollments: Scalars['Int'];
  informCampaignExecutions: Scalars['Int'];
};

export type InformCampaignCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition: InformAudienceDefinitionCreateNestedOneWithoutInformCampaignsInput;
  informAutomationCampaign?: Maybe<InformAutomationCampaignCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupCreateNestedOneWithoutInformCampaignsInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformCampaignsInput;
  informScheduledCampaign?: Maybe<InformScheduledCampaignCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignCreateManyInformAudienceDefinitionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informPartnerProgramId: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignCreateManyInformAudienceDefinitionInputEnvelope = {
  data: Array<InformCampaignCreateManyInformAudienceDefinitionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformCampaignCreateManyInformCampaignGroupInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  informPartnerProgramId: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignCreateManyInformCampaignGroupInputEnvelope = {
  data: Array<InformCampaignCreateManyInformCampaignGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformCampaignCreateManyInformPartnerProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  informCampaignGroupId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignCreateManyInformPartnerProgramInputEnvelope = {
  data: Array<InformCampaignCreateManyInformPartnerProgramInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformCampaignCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informPartnerProgramId: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignCreateNestedManyWithoutInformAudienceDefinitionInput = {
  connect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignCreateOrConnectWithoutInformAudienceDefinitionInput>>;
  create?: Maybe<Array<InformCampaignCreateWithoutInformAudienceDefinitionInput>>;
  createMany?: Maybe<InformCampaignCreateManyInformAudienceDefinitionInputEnvelope>;
};

export type InformCampaignCreateNestedManyWithoutInformCampaignGroupInput = {
  connect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignCreateOrConnectWithoutInformCampaignGroupInput>>;
  create?: Maybe<Array<InformCampaignCreateWithoutInformCampaignGroupInput>>;
  createMany?: Maybe<InformCampaignCreateManyInformCampaignGroupInputEnvelope>;
};

export type InformCampaignCreateNestedManyWithoutInformPartnerProgramInput = {
  connect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignCreateOrConnectWithoutInformPartnerProgramInput>>;
  create?: Maybe<Array<InformCampaignCreateWithoutInformPartnerProgramInput>>;
  createMany?: Maybe<InformCampaignCreateManyInformPartnerProgramInputEnvelope>;
};

export type InformCampaignCreateNestedOneWithoutInformAutomationCampaignInput = {
  connect?: Maybe<InformCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignCreateOrConnectWithoutInformAutomationCampaignInput>;
  create?: Maybe<InformCampaignCreateWithoutInformAutomationCampaignInput>;
};

export type InformCampaignCreateNestedOneWithoutInformCampaignEnrollmentsInput = {
  connect?: Maybe<InformCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignCreateOrConnectWithoutInformCampaignEnrollmentsInput>;
  create?: Maybe<InformCampaignCreateWithoutInformCampaignEnrollmentsInput>;
};

export type InformCampaignCreateNestedOneWithoutInformCampaignExecutionsInput = {
  connect?: Maybe<InformCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignCreateOrConnectWithoutInformCampaignExecutionsInput>;
  create?: Maybe<InformCampaignCreateWithoutInformCampaignExecutionsInput>;
};

export type InformCampaignCreateNestedOneWithoutInformEventDrivenCampaignInput = {
  connect?: Maybe<InformCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignCreateOrConnectWithoutInformEventDrivenCampaignInput>;
  create?: Maybe<InformCampaignCreateWithoutInformEventDrivenCampaignInput>;
};

export type InformCampaignCreateNestedOneWithoutInformScheduledCampaignInput = {
  connect?: Maybe<InformCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignCreateOrConnectWithoutInformScheduledCampaignInput>;
  create?: Maybe<InformCampaignCreateWithoutInformScheduledCampaignInput>;
};

export type InformCampaignCreateOrConnectWithoutInformAudienceDefinitionInput = {
  create: InformCampaignCreateWithoutInformAudienceDefinitionInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignCreateOrConnectWithoutInformAutomationCampaignInput = {
  create: InformCampaignCreateWithoutInformAutomationCampaignInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignCreateOrConnectWithoutInformCampaignEnrollmentsInput = {
  create: InformCampaignCreateWithoutInformCampaignEnrollmentsInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignCreateOrConnectWithoutInformCampaignExecutionsInput = {
  create: InformCampaignCreateWithoutInformCampaignExecutionsInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignCreateOrConnectWithoutInformCampaignGroupInput = {
  create: InformCampaignCreateWithoutInformCampaignGroupInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignCreateOrConnectWithoutInformEventDrivenCampaignInput = {
  create: InformCampaignCreateWithoutInformEventDrivenCampaignInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignCreateOrConnectWithoutInformPartnerProgramInput = {
  create: InformCampaignCreateWithoutInformPartnerProgramInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignCreateOrConnectWithoutInformScheduledCampaignInput = {
  create: InformCampaignCreateWithoutInformScheduledCampaignInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignCreateWithoutInformAudienceDefinitionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupCreateNestedOneWithoutInformCampaignsInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformCampaignsInput;
  informScheduledCampaign?: Maybe<InformScheduledCampaignCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignCreateWithoutInformAutomationCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition: InformAudienceDefinitionCreateNestedOneWithoutInformCampaignsInput;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupCreateNestedOneWithoutInformCampaignsInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformCampaignsInput;
  informScheduledCampaign?: Maybe<InformScheduledCampaignCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignCreateWithoutInformCampaignEnrollmentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition: InformAudienceDefinitionCreateNestedOneWithoutInformCampaignsInput;
  informAutomationCampaign?: Maybe<InformAutomationCampaignCreateNestedOneWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupCreateNestedOneWithoutInformCampaignsInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformCampaignsInput;
  informScheduledCampaign?: Maybe<InformScheduledCampaignCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignCreateWithoutInformCampaignExecutionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition: InformAudienceDefinitionCreateNestedOneWithoutInformCampaignsInput;
  informAutomationCampaign?: Maybe<InformAutomationCampaignCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupCreateNestedOneWithoutInformCampaignsInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformCampaignsInput;
  informScheduledCampaign?: Maybe<InformScheduledCampaignCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignCreateWithoutInformCampaignGroupInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition: InformAudienceDefinitionCreateNestedOneWithoutInformCampaignsInput;
  informAutomationCampaign?: Maybe<InformAutomationCampaignCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionCreateNestedManyWithoutInformCampaignInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformCampaignsInput;
  informScheduledCampaign?: Maybe<InformScheduledCampaignCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignCreateWithoutInformEventDrivenCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition: InformAudienceDefinitionCreateNestedOneWithoutInformCampaignsInput;
  informAutomationCampaign?: Maybe<InformAutomationCampaignCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupCreateNestedOneWithoutInformCampaignsInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformCampaignsInput;
  informScheduledCampaign?: Maybe<InformScheduledCampaignCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignCreateWithoutInformPartnerProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition: InformAudienceDefinitionCreateNestedOneWithoutInformCampaignsInput;
  informAutomationCampaign?: Maybe<InformAutomationCampaignCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupCreateNestedOneWithoutInformCampaignsInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignCreateNestedOneWithoutInformCampaignInput>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignCreateWithoutInformScheduledCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition: InformAudienceDefinitionCreateNestedOneWithoutInformCampaignsInput;
  informAutomationCampaign?: Maybe<InformAutomationCampaignCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupCreateNestedOneWithoutInformCampaignsInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformCampaignsInput;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignEnrollment = {
  __typename?: 'InformCampaignEnrollment';
  _count: InformCampaignEnrollmentCountOutputType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informAudienceMember: Array<InformAudienceMember>;
  informCampaign: InformCampaign;
  informCampaignEnrollmentCanonicalServices: Array<InformCampaignEnrollmentCanonicalService>;
  informCampaignId: Scalars['String'];
  informPartnerProgramEnrollment: InformPartnerProgramEnrollment;
  informPartnerProgramEnrollmentId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};


export type InformCampaignEnrollmentInformAudienceMemberArgs = {
  cursor?: Maybe<InformAudienceMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberWhereInput>;
};


export type InformCampaignEnrollmentInformCampaignEnrollmentCanonicalServicesArgs = {
  cursor?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignEnrollmentCanonicalServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignEnrollmentCanonicalServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereInput>;
};

export type InformCampaignEnrollmentCanonicalService = {
  __typename?: 'InformCampaignEnrollmentCanonicalService';
  canonicalService: CanonicalService;
  canonicalServiceId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informCampaignEnrollment: InformCampaignEnrollment;
  informCampaignEnrollmentId: Scalars['String'];
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type InformCampaignEnrollmentCanonicalServiceCountAggregateOutputType = {
  __typename?: 'InformCampaignEnrollmentCanonicalServiceCountAggregateOutputType';
  _all: Scalars['Int'];
  canonicalServiceId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  informCampaignEnrollmentId: Scalars['Int'];
  onlinePharmacyUrl: Scalars['Int'];
  settings: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformCampaignEnrollmentCanonicalServiceCountOrderByAggregateInput = {
  canonicalServiceId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignEnrollmentCanonicalServiceCreateInput = {
  canonicalService: CanonicalServiceCreateNestedOneWithoutInformCampaignEnrollmentCanonicalServicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollment: InformCampaignEnrollmentCreateNestedOneWithoutInformCampaignEnrollmentCanonicalServicesInput;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceCreateManyCanonicalServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId: Scalars['String'];
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceCreateManyCanonicalServiceInputEnvelope = {
  data: Array<InformCampaignEnrollmentCanonicalServiceCreateManyCanonicalServiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformCampaignEnrollmentCanonicalServiceCreateManyInformCampaignEnrollmentInput = {
  canonicalServiceId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceCreateManyInformCampaignEnrollmentInputEnvelope = {
  data: Array<InformCampaignEnrollmentCanonicalServiceCreateManyInformCampaignEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformCampaignEnrollmentCanonicalServiceCreateManyInput = {
  canonicalServiceId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId: Scalars['String'];
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceCreateNestedManyWithoutCanonicalServiceInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateOrConnectWithoutCanonicalServiceInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateWithoutCanonicalServiceInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateManyCanonicalServiceInputEnvelope>;
};

export type InformCampaignEnrollmentCanonicalServiceCreateNestedManyWithoutInformCampaignEnrollmentInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateOrConnectWithoutInformCampaignEnrollmentInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateWithoutInformCampaignEnrollmentInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateManyInformCampaignEnrollmentInputEnvelope>;
};

export type InformCampaignEnrollmentCanonicalServiceCreateOrConnectWithoutCanonicalServiceInput = {
  create: InformCampaignEnrollmentCanonicalServiceCreateWithoutCanonicalServiceInput;
  where: InformCampaignEnrollmentCanonicalServiceWhereUniqueInput;
};

export type InformCampaignEnrollmentCanonicalServiceCreateOrConnectWithoutInformCampaignEnrollmentInput = {
  create: InformCampaignEnrollmentCanonicalServiceCreateWithoutInformCampaignEnrollmentInput;
  where: InformCampaignEnrollmentCanonicalServiceWhereUniqueInput;
};

export type InformCampaignEnrollmentCanonicalServiceCreateWithoutCanonicalServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollment: InformCampaignEnrollmentCreateNestedOneWithoutInformCampaignEnrollmentCanonicalServicesInput;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceCreateWithoutInformCampaignEnrollmentInput = {
  canonicalService: CanonicalServiceCreateNestedOneWithoutInformCampaignEnrollmentCanonicalServicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceGroupByOutputType = {
  __typename?: 'InformCampaignEnrollmentCanonicalServiceGroupByOutputType';
  _count?: Maybe<InformCampaignEnrollmentCanonicalServiceCountAggregateOutputType>;
  _max?: Maybe<InformCampaignEnrollmentCanonicalServiceMaxAggregateOutputType>;
  _min?: Maybe<InformCampaignEnrollmentCanonicalServiceMinAggregateOutputType>;
  canonicalServiceId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informCampaignEnrollmentId: Scalars['String'];
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type InformCampaignEnrollmentCanonicalServiceInformCampaignEnrollmentIdCanonicalServiceIdCompoundUniqueInput = {
  canonicalServiceId: Scalars['String'];
  informCampaignEnrollmentId: Scalars['String'];
};

export type InformCampaignEnrollmentCanonicalServiceListRelationFilter = {
  every?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereInput>;
  none?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereInput>;
  some?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereInput>;
};

export type InformCampaignEnrollmentCanonicalServiceMaxAggregateOutputType = {
  __typename?: 'InformCampaignEnrollmentCanonicalServiceMaxAggregateOutputType';
  canonicalServiceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceMaxOrderByAggregateInput = {
  canonicalServiceId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignEnrollmentCanonicalServiceMinAggregateOutputType = {
  __typename?: 'InformCampaignEnrollmentCanonicalServiceMinAggregateOutputType';
  canonicalServiceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceMinOrderByAggregateInput = {
  canonicalServiceId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignEnrollmentCanonicalServiceOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformCampaignEnrollmentCanonicalServiceOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformCampaignEnrollmentCanonicalServiceOrderByRelevanceInput>;
  canonicalService?: Maybe<CanonicalServiceOrderByWithRelationInput>;
  canonicalServiceId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentOrderByWithRelationInput>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformCampaignEnrollmentCanonicalServiceOrderByRelevanceFieldEnum {
  CanonicalServiceId = 'canonicalServiceId',
  Id = 'id',
  InformCampaignEnrollmentId = 'informCampaignEnrollmentId',
  OnlinePharmacyUrl = 'onlinePharmacyUrl'
}

export type InformCampaignEnrollmentCanonicalServiceOrderByRelevanceInput = {
  fields: Array<InformCampaignEnrollmentCanonicalServiceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformCampaignEnrollmentCanonicalServiceOrderByWithAggregationInput = {
  _count?: Maybe<InformCampaignEnrollmentCanonicalServiceCountOrderByAggregateInput>;
  _max?: Maybe<InformCampaignEnrollmentCanonicalServiceMaxOrderByAggregateInput>;
  _min?: Maybe<InformCampaignEnrollmentCanonicalServiceMinOrderByAggregateInput>;
  canonicalServiceId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignEnrollmentCanonicalServiceOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformCampaignEnrollmentCanonicalServiceOrderByRelevanceInput>;
  canonicalService?: Maybe<CanonicalServiceOrderByWithRelationInput>;
  canonicalServiceId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentOrderByWithRelationInput>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignEnrollmentCanonicalServiceOrderByWithRelationInput = {
  _relevance?: Maybe<InformCampaignEnrollmentCanonicalServiceOrderByRelevanceInput>;
  canonicalService?: Maybe<CanonicalServiceOrderByWithRelationInput>;
  canonicalServiceId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentOrderByWithRelationInput>;
  informCampaignEnrollmentId?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformCampaignEnrollmentCanonicalServiceScalarFieldEnum {
  CanonicalServiceId = 'canonicalServiceId',
  CreatedAt = 'createdAt',
  Id = 'id',
  InformCampaignEnrollmentId = 'informCampaignEnrollmentId',
  OnlinePharmacyUrl = 'onlinePharmacyUrl',
  Settings = 'settings',
  UpdatedAt = 'updatedAt'
}

export type InformCampaignEnrollmentCanonicalServiceScalarWhereInput = {
  AND?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceScalarWhereInput>>;
  NOT?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceScalarWhereInput>>;
  OR?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceScalarWhereInput>>;
  canonicalServiceId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informCampaignEnrollmentId?: Maybe<StringFilter>;
  onlinePharmacyUrl?: Maybe<StringNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignEnrollmentCanonicalServiceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceScalarWhereWithAggregatesInput>>;
  canonicalServiceId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informCampaignEnrollmentId?: Maybe<StringWithAggregatesFilter>;
  onlinePharmacyUrl?: Maybe<StringNullableWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedCreateInput = {
  canonicalServiceId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId: Scalars['String'];
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedCreateNestedManyWithoutCanonicalServiceInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateOrConnectWithoutCanonicalServiceInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateWithoutCanonicalServiceInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateManyCanonicalServiceInputEnvelope>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedCreateNestedManyWithoutInformCampaignEnrollmentInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateOrConnectWithoutInformCampaignEnrollmentInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateWithoutInformCampaignEnrollmentInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateManyInformCampaignEnrollmentInputEnvelope>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedCreateWithoutCanonicalServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId: Scalars['String'];
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedCreateWithoutInformCampaignEnrollmentInput = {
  canonicalServiceId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedUpdateInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutCanonicalServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutCanonicalServiceNestedInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateOrConnectWithoutCanonicalServiceInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateWithoutCanonicalServiceInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateManyCanonicalServiceInputEnvelope>;
  delete?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceUpdateWithWhereUniqueWithoutCanonicalServiceInput>>;
  updateMany?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceUpdateManyWithWhereWithoutCanonicalServiceInput>>;
  upsert?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceUpsertWithWhereUniqueWithoutCanonicalServiceInput>>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutInformCampaignEnrollmentInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutInformCampaignEnrollmentNestedInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateOrConnectWithoutInformCampaignEnrollmentInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateWithoutInformCampaignEnrollmentInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateManyInformCampaignEnrollmentInputEnvelope>;
  delete?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceUpdateWithWhereUniqueWithoutInformCampaignEnrollmentInput>>;
  updateMany?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceUpdateManyWithWhereWithoutInformCampaignEnrollmentInput>>;
  upsert?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceUpsertWithWhereUniqueWithoutInformCampaignEnrollmentInput>>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedUpdateWithoutCanonicalServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentId?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUncheckedUpdateWithoutInformCampaignEnrollmentInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUpdateInput = {
  canonicalService?: Maybe<CanonicalServiceUpdateOneRequiredWithoutInformCampaignEnrollmentCanonicalServicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentUpdateOneRequiredWithoutInformCampaignEnrollmentCanonicalServicesNestedInput>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUpdateManyWithWhereWithoutCanonicalServiceInput = {
  data: InformCampaignEnrollmentCanonicalServiceUpdateManyMutationInput;
  where: InformCampaignEnrollmentCanonicalServiceScalarWhereInput;
};

export type InformCampaignEnrollmentCanonicalServiceUpdateManyWithWhereWithoutInformCampaignEnrollmentInput = {
  data: InformCampaignEnrollmentCanonicalServiceUpdateManyMutationInput;
  where: InformCampaignEnrollmentCanonicalServiceScalarWhereInput;
};

export type InformCampaignEnrollmentCanonicalServiceUpdateManyWithoutCanonicalServiceNestedInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateOrConnectWithoutCanonicalServiceInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateWithoutCanonicalServiceInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateManyCanonicalServiceInputEnvelope>;
  delete?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceUpdateWithWhereUniqueWithoutCanonicalServiceInput>>;
  updateMany?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceUpdateManyWithWhereWithoutCanonicalServiceInput>>;
  upsert?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceUpsertWithWhereUniqueWithoutCanonicalServiceInput>>;
};

export type InformCampaignEnrollmentCanonicalServiceUpdateManyWithoutInformCampaignEnrollmentNestedInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateOrConnectWithoutInformCampaignEnrollmentInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceCreateWithoutInformCampaignEnrollmentInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateManyInformCampaignEnrollmentInputEnvelope>;
  delete?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceUpdateWithWhereUniqueWithoutInformCampaignEnrollmentInput>>;
  updateMany?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceUpdateManyWithWhereWithoutInformCampaignEnrollmentInput>>;
  upsert?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceUpsertWithWhereUniqueWithoutInformCampaignEnrollmentInput>>;
};

export type InformCampaignEnrollmentCanonicalServiceUpdateWithWhereUniqueWithoutCanonicalServiceInput = {
  data: InformCampaignEnrollmentCanonicalServiceUpdateWithoutCanonicalServiceInput;
  where: InformCampaignEnrollmentCanonicalServiceWhereUniqueInput;
};

export type InformCampaignEnrollmentCanonicalServiceUpdateWithWhereUniqueWithoutInformCampaignEnrollmentInput = {
  data: InformCampaignEnrollmentCanonicalServiceUpdateWithoutInformCampaignEnrollmentInput;
  where: InformCampaignEnrollmentCanonicalServiceWhereUniqueInput;
};

export type InformCampaignEnrollmentCanonicalServiceUpdateWithoutCanonicalServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentUpdateOneRequiredWithoutInformCampaignEnrollmentCanonicalServicesNestedInput>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUpdateWithoutInformCampaignEnrollmentInput = {
  canonicalService?: Maybe<CanonicalServiceUpdateOneRequiredWithoutInformCampaignEnrollmentCanonicalServicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCanonicalServiceUpsertWithWhereUniqueWithoutCanonicalServiceInput = {
  create: InformCampaignEnrollmentCanonicalServiceCreateWithoutCanonicalServiceInput;
  update: InformCampaignEnrollmentCanonicalServiceUpdateWithoutCanonicalServiceInput;
  where: InformCampaignEnrollmentCanonicalServiceWhereUniqueInput;
};

export type InformCampaignEnrollmentCanonicalServiceUpsertWithWhereUniqueWithoutInformCampaignEnrollmentInput = {
  create: InformCampaignEnrollmentCanonicalServiceCreateWithoutInformCampaignEnrollmentInput;
  update: InformCampaignEnrollmentCanonicalServiceUpdateWithoutInformCampaignEnrollmentInput;
  where: InformCampaignEnrollmentCanonicalServiceWhereUniqueInput;
};

export type InformCampaignEnrollmentCanonicalServiceWhereInput = {
  AND?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereInput>>;
  NOT?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereInput>>;
  OR?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereInput>>;
  canonicalService?: Maybe<CanonicalServiceScalarRelationFilter>;
  canonicalServiceId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentScalarRelationFilter>;
  informCampaignEnrollmentId?: Maybe<StringFilter>;
  onlinePharmacyUrl?: Maybe<StringNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignEnrollmentCanonicalServiceWhereUniqueInput = {
  AND?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereInput>>;
  NOT?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereInput>>;
  OR?: Maybe<Array<InformCampaignEnrollmentCanonicalServiceWhereInput>>;
  canonicalService?: Maybe<CanonicalServiceScalarRelationFilter>;
  canonicalServiceId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollment?: Maybe<InformCampaignEnrollmentScalarRelationFilter>;
  informCampaignEnrollmentId?: Maybe<StringFilter>;
  informCampaignEnrollmentId_canonicalServiceId?: Maybe<InformCampaignEnrollmentCanonicalServiceInformCampaignEnrollmentIdCanonicalServiceIdCompoundUniqueInput>;
  onlinePharmacyUrl?: Maybe<StringNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignEnrollmentCountAggregateOutputType = {
  __typename?: 'InformCampaignEnrollmentCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  informCampaignId: Scalars['Int'];
  informPartnerProgramEnrollmentId: Scalars['Int'];
  lastUpdatedBy: Scalars['Int'];
  lastUpdatedByType: Scalars['Int'];
  settings: Scalars['Int'];
  status: Scalars['Int'];
  statusMessage: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformCampaignEnrollmentCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignId?: Maybe<SortOrder>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignEnrollmentCountOutputType = {
  __typename?: 'InformCampaignEnrollmentCountOutputType';
  informAudienceMember: Scalars['Int'];
  informCampaignEnrollmentCanonicalServices: Scalars['Int'];
};

export type InformCampaignEnrollmentCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informCampaign: InformCampaignCreateNestedOneWithoutInformCampaignEnrollmentsInput;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informPartnerProgramEnrollment: InformPartnerProgramEnrollmentCreateNestedOneWithoutInformCampaignEnrollmentsInput;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCreateManyInformCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCreateManyInformCampaignInputEnvelope = {
  data: Array<InformCampaignEnrollmentCreateManyInformCampaignInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformCampaignEnrollmentCreateManyInformPartnerProgramEnrollmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCreateManyInformPartnerProgramEnrollmentInputEnvelope = {
  data: Array<InformCampaignEnrollmentCreateManyInformPartnerProgramEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformCampaignEnrollmentCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignId: Scalars['String'];
  informPartnerProgramEnrollmentId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCreateNestedManyWithoutInformCampaignInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCreateOrConnectWithoutInformCampaignInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCreateWithoutInformCampaignInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCreateManyInformCampaignInputEnvelope>;
};

export type InformCampaignEnrollmentCreateNestedManyWithoutInformPartnerProgramEnrollmentInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCreateOrConnectWithoutInformPartnerProgramEnrollmentInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCreateWithoutInformPartnerProgramEnrollmentInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCreateManyInformPartnerProgramEnrollmentInputEnvelope>;
};

export type InformCampaignEnrollmentCreateNestedOneWithoutInformAudienceMemberInput = {
  connect?: Maybe<InformCampaignEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignEnrollmentCreateOrConnectWithoutInformAudienceMemberInput>;
  create?: Maybe<InformCampaignEnrollmentCreateWithoutInformAudienceMemberInput>;
};

export type InformCampaignEnrollmentCreateNestedOneWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  connect?: Maybe<InformCampaignEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignEnrollmentCreateOrConnectWithoutInformCampaignEnrollmentCanonicalServicesInput>;
  create?: Maybe<InformCampaignEnrollmentCreateWithoutInformCampaignEnrollmentCanonicalServicesInput>;
};

export type InformCampaignEnrollmentCreateOrConnectWithoutInformAudienceMemberInput = {
  create: InformCampaignEnrollmentCreateWithoutInformAudienceMemberInput;
  where: InformCampaignEnrollmentWhereUniqueInput;
};

export type InformCampaignEnrollmentCreateOrConnectWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  create: InformCampaignEnrollmentCreateWithoutInformCampaignEnrollmentCanonicalServicesInput;
  where: InformCampaignEnrollmentWhereUniqueInput;
};

export type InformCampaignEnrollmentCreateOrConnectWithoutInformCampaignInput = {
  create: InformCampaignEnrollmentCreateWithoutInformCampaignInput;
  where: InformCampaignEnrollmentWhereUniqueInput;
};

export type InformCampaignEnrollmentCreateOrConnectWithoutInformPartnerProgramEnrollmentInput = {
  create: InformCampaignEnrollmentCreateWithoutInformPartnerProgramEnrollmentInput;
  where: InformCampaignEnrollmentWhereUniqueInput;
};

export type InformCampaignEnrollmentCreateWithoutInformAudienceMemberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaign: InformCampaignCreateNestedOneWithoutInformCampaignEnrollmentsInput;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informPartnerProgramEnrollment: InformPartnerProgramEnrollmentCreateNestedOneWithoutInformCampaignEnrollmentsInput;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCreateWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informCampaign: InformCampaignCreateNestedOneWithoutInformCampaignEnrollmentsInput;
  informPartnerProgramEnrollment: InformPartnerProgramEnrollmentCreateNestedOneWithoutInformCampaignEnrollmentsInput;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCreateWithoutInformCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informPartnerProgramEnrollment: InformPartnerProgramEnrollmentCreateNestedOneWithoutInformCampaignEnrollmentsInput;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentCreateWithoutInformPartnerProgramEnrollmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informCampaign: InformCampaignCreateNestedOneWithoutInformCampaignEnrollmentsInput;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentGroupByOutputType = {
  __typename?: 'InformCampaignEnrollmentGroupByOutputType';
  _count?: Maybe<InformCampaignEnrollmentCountAggregateOutputType>;
  _max?: Maybe<InformCampaignEnrollmentMaxAggregateOutputType>;
  _min?: Maybe<InformCampaignEnrollmentMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informCampaignId: Scalars['String'];
  informPartnerProgramEnrollmentId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type InformCampaignEnrollmentInformPartnerProgramEnrollmentIdInformCampaignIdCompoundUniqueInput = {
  informCampaignId: Scalars['String'];
  informPartnerProgramEnrollmentId: Scalars['String'];
};

export type InformCampaignEnrollmentListRelationFilter = {
  every?: Maybe<InformCampaignEnrollmentWhereInput>;
  none?: Maybe<InformCampaignEnrollmentWhereInput>;
  some?: Maybe<InformCampaignEnrollmentWhereInput>;
};

export type InformCampaignEnrollmentMaxAggregateOutputType = {
  __typename?: 'InformCampaignEnrollmentMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignId?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  status?: Maybe<InformEnrollmentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignId?: Maybe<SortOrder>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignEnrollmentMinAggregateOutputType = {
  __typename?: 'InformCampaignEnrollmentMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignId?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  status?: Maybe<InformEnrollmentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignId?: Maybe<SortOrder>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignEnrollmentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformCampaignEnrollmentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformCampaignEnrollmentOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceOrderByRelationAggregateInput>;
  informCampaignId?: Maybe<SortOrder>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformCampaignEnrollmentOrderByRelevanceFieldEnum {
  Id = 'id',
  InformCampaignId = 'informCampaignId',
  InformPartnerProgramEnrollmentId = 'informPartnerProgramEnrollmentId',
  LastUpdatedBy = 'lastUpdatedBy'
}

export type InformCampaignEnrollmentOrderByRelevanceInput = {
  fields: Array<InformCampaignEnrollmentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformCampaignEnrollmentOrderByWithAggregationInput = {
  _count?: Maybe<InformCampaignEnrollmentCountOrderByAggregateInput>;
  _max?: Maybe<InformCampaignEnrollmentMaxOrderByAggregateInput>;
  _min?: Maybe<InformCampaignEnrollmentMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignId?: Maybe<SortOrder>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignEnrollmentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformCampaignEnrollmentOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceOrderByRelationAggregateInput>;
  informCampaignId?: Maybe<SortOrder>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignEnrollmentOrderByWithRelationInput = {
  _relevance?: Maybe<InformCampaignEnrollmentOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceOrderByRelationAggregateInput>;
  informCampaignId?: Maybe<SortOrder>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformCampaignEnrollmentScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  InformCampaignId = 'informCampaignId',
  InformPartnerProgramEnrollmentId = 'informPartnerProgramEnrollmentId',
  LastUpdatedBy = 'lastUpdatedBy',
  LastUpdatedByType = 'lastUpdatedByType',
  Settings = 'settings',
  Status = 'status',
  StatusMessage = 'statusMessage',
  UpdatedAt = 'updatedAt'
}

export type InformCampaignEnrollmentScalarRelationFilter = {
  AND?: Maybe<Array<InformCampaignEnrollmentWhereInput>>;
  NOT?: Maybe<Array<InformCampaignEnrollmentWhereInput>>;
  OR?: Maybe<Array<InformCampaignEnrollmentWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceListRelationFilter>;
  informCampaignId?: Maybe<StringFilter>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentScalarRelationFilter>;
  informPartnerProgramEnrollmentId?: Maybe<StringFilter>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  lastUpdatedByType?: Maybe<EnumInformEntityUpdatedByTypeNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformEnrollmentStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignEnrollmentScalarWhereInput = {
  AND?: Maybe<Array<InformCampaignEnrollmentScalarWhereInput>>;
  NOT?: Maybe<Array<InformCampaignEnrollmentScalarWhereInput>>;
  OR?: Maybe<Array<InformCampaignEnrollmentScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informCampaignId?: Maybe<StringFilter>;
  informPartnerProgramEnrollmentId?: Maybe<StringFilter>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  lastUpdatedByType?: Maybe<EnumInformEntityUpdatedByTypeNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformEnrollmentStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignEnrollmentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformCampaignEnrollmentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformCampaignEnrollmentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformCampaignEnrollmentScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informCampaignId?: Maybe<StringWithAggregatesFilter>;
  informPartnerProgramEnrollmentId?: Maybe<StringWithAggregatesFilter>;
  lastUpdatedBy?: Maybe<StringNullableWithAggregatesFilter>;
  lastUpdatedByType?: Maybe<EnumInformEntityUpdatedByTypeNullableWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  status?: Maybe<EnumInformEnrollmentStatusWithAggregatesFilter>;
  statusMessage?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type InformCampaignEnrollmentUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informCampaignId: Scalars['String'];
  informPartnerProgramEnrollmentId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformCampaignInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCreateOrConnectWithoutInformCampaignInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCreateWithoutInformCampaignInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCreateManyInformCampaignInputEnvelope>;
};

export type InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformPartnerProgramEnrollmentInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCreateOrConnectWithoutInformPartnerProgramEnrollmentInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCreateWithoutInformPartnerProgramEnrollmentInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCreateManyInformPartnerProgramEnrollmentInputEnvelope>;
};

export type InformCampaignEnrollmentUncheckedCreateWithoutInformAudienceMemberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informCampaignId: Scalars['String'];
  informPartnerProgramEnrollmentId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUncheckedCreateWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informCampaignId: Scalars['String'];
  informPartnerProgramEnrollmentId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUncheckedCreateWithoutInformCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informPartnerProgramEnrollmentId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUncheckedCreateWithoutInformPartnerProgramEnrollmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedCreateNestedManyWithoutInformCampaignEnrollmentInput>;
  informCampaignId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informCampaignId?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignId?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUncheckedUpdateManyWithoutInformCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUncheckedUpdateManyWithoutInformCampaignNestedInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCreateOrConnectWithoutInformCampaignInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCreateWithoutInformCampaignInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCreateManyInformCampaignInputEnvelope>;
  delete?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignEnrollmentUpdateWithWhereUniqueWithoutInformCampaignInput>>;
  updateMany?: Maybe<Array<InformCampaignEnrollmentUpdateManyWithWhereWithoutInformCampaignInput>>;
  upsert?: Maybe<Array<InformCampaignEnrollmentUpsertWithWhereUniqueWithoutInformCampaignInput>>;
};

export type InformCampaignEnrollmentUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCreateOrConnectWithoutInformPartnerProgramEnrollmentInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCreateWithoutInformPartnerProgramEnrollmentInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCreateManyInformPartnerProgramEnrollmentInputEnvelope>;
  delete?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignEnrollmentUpdateWithWhereUniqueWithoutInformPartnerProgramEnrollmentInput>>;
  updateMany?: Maybe<Array<InformCampaignEnrollmentUpdateManyWithWhereWithoutInformPartnerProgramEnrollmentInput>>;
  upsert?: Maybe<Array<InformCampaignEnrollmentUpsertWithWhereUniqueWithoutInformPartnerProgramEnrollmentInput>>;
};

export type InformCampaignEnrollmentUncheckedUpdateWithoutInformAudienceMemberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informCampaignId?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUncheckedUpdateWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informCampaignId?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUncheckedUpdateWithoutInformCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUncheckedUpdateWithoutInformPartnerProgramEnrollmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUncheckedUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informCampaignId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformCampaignEnrollmentsNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentUpdateOneRequiredWithoutInformCampaignEnrollmentsNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUpdateManyWithWhereWithoutInformCampaignInput = {
  data: InformCampaignEnrollmentUpdateManyMutationInput;
  where: InformCampaignEnrollmentScalarWhereInput;
};

export type InformCampaignEnrollmentUpdateManyWithWhereWithoutInformPartnerProgramEnrollmentInput = {
  data: InformCampaignEnrollmentUpdateManyMutationInput;
  where: InformCampaignEnrollmentScalarWhereInput;
};

export type InformCampaignEnrollmentUpdateManyWithoutInformCampaignNestedInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCreateOrConnectWithoutInformCampaignInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCreateWithoutInformCampaignInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCreateManyInformCampaignInputEnvelope>;
  delete?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignEnrollmentUpdateWithWhereUniqueWithoutInformCampaignInput>>;
  updateMany?: Maybe<Array<InformCampaignEnrollmentUpdateManyWithWhereWithoutInformCampaignInput>>;
  upsert?: Maybe<Array<InformCampaignEnrollmentUpsertWithWhereUniqueWithoutInformCampaignInput>>;
};

export type InformCampaignEnrollmentUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput = {
  connect?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignEnrollmentCreateOrConnectWithoutInformPartnerProgramEnrollmentInput>>;
  create?: Maybe<Array<InformCampaignEnrollmentCreateWithoutInformPartnerProgramEnrollmentInput>>;
  createMany?: Maybe<InformCampaignEnrollmentCreateManyInformPartnerProgramEnrollmentInputEnvelope>;
  delete?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignEnrollmentUpdateWithWhereUniqueWithoutInformPartnerProgramEnrollmentInput>>;
  updateMany?: Maybe<Array<InformCampaignEnrollmentUpdateManyWithWhereWithoutInformPartnerProgramEnrollmentInput>>;
  upsert?: Maybe<Array<InformCampaignEnrollmentUpsertWithWhereUniqueWithoutInformPartnerProgramEnrollmentInput>>;
};

export type InformCampaignEnrollmentUpdateOneRequiredWithoutInformAudienceMemberNestedInput = {
  connect?: Maybe<InformCampaignEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignEnrollmentCreateOrConnectWithoutInformAudienceMemberInput>;
  create?: Maybe<InformCampaignEnrollmentCreateWithoutInformAudienceMemberInput>;
  update?: Maybe<InformCampaignEnrollmentUpdateToOneWithWhereWithoutInformAudienceMemberInput>;
  upsert?: Maybe<InformCampaignEnrollmentUpsertWithoutInformAudienceMemberInput>;
};

export type InformCampaignEnrollmentUpdateOneRequiredWithoutInformCampaignEnrollmentCanonicalServicesNestedInput = {
  connect?: Maybe<InformCampaignEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignEnrollmentCreateOrConnectWithoutInformCampaignEnrollmentCanonicalServicesInput>;
  create?: Maybe<InformCampaignEnrollmentCreateWithoutInformCampaignEnrollmentCanonicalServicesInput>;
  update?: Maybe<InformCampaignEnrollmentUpdateToOneWithWhereWithoutInformCampaignEnrollmentCanonicalServicesInput>;
  upsert?: Maybe<InformCampaignEnrollmentUpsertWithoutInformCampaignEnrollmentCanonicalServicesInput>;
};

export type InformCampaignEnrollmentUpdateToOneWithWhereWithoutInformAudienceMemberInput = {
  data: InformCampaignEnrollmentUpdateWithoutInformAudienceMemberInput;
  where?: Maybe<InformCampaignEnrollmentWhereInput>;
};

export type InformCampaignEnrollmentUpdateToOneWithWhereWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  data: InformCampaignEnrollmentUpdateWithoutInformCampaignEnrollmentCanonicalServicesInput;
  where?: Maybe<InformCampaignEnrollmentWhereInput>;
};

export type InformCampaignEnrollmentUpdateWithWhereUniqueWithoutInformCampaignInput = {
  data: InformCampaignEnrollmentUpdateWithoutInformCampaignInput;
  where: InformCampaignEnrollmentWhereUniqueInput;
};

export type InformCampaignEnrollmentUpdateWithWhereUniqueWithoutInformPartnerProgramEnrollmentInput = {
  data: InformCampaignEnrollmentUpdateWithoutInformPartnerProgramEnrollmentInput;
  where: InformCampaignEnrollmentWhereUniqueInput;
};

export type InformCampaignEnrollmentUpdateWithoutInformAudienceMemberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformCampaignEnrollmentsNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentUpdateOneRequiredWithoutInformCampaignEnrollmentsNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUpdateWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformCampaignEnrollmentsNestedInput>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentUpdateOneRequiredWithoutInformCampaignEnrollmentsNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUpdateWithoutInformCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentUpdateOneRequiredWithoutInformCampaignEnrollmentsNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUpdateWithoutInformPartnerProgramEnrollmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformCampaignEnrollmentsNestedInput>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceUpdateManyWithoutInformCampaignEnrollmentNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignEnrollmentUpsertWithWhereUniqueWithoutInformCampaignInput = {
  create: InformCampaignEnrollmentCreateWithoutInformCampaignInput;
  update: InformCampaignEnrollmentUpdateWithoutInformCampaignInput;
  where: InformCampaignEnrollmentWhereUniqueInput;
};

export type InformCampaignEnrollmentUpsertWithWhereUniqueWithoutInformPartnerProgramEnrollmentInput = {
  create: InformCampaignEnrollmentCreateWithoutInformPartnerProgramEnrollmentInput;
  update: InformCampaignEnrollmentUpdateWithoutInformPartnerProgramEnrollmentInput;
  where: InformCampaignEnrollmentWhereUniqueInput;
};

export type InformCampaignEnrollmentUpsertWithoutInformAudienceMemberInput = {
  create: InformCampaignEnrollmentCreateWithoutInformAudienceMemberInput;
  update: InformCampaignEnrollmentUpdateWithoutInformAudienceMemberInput;
  where?: Maybe<InformCampaignEnrollmentWhereInput>;
};

export type InformCampaignEnrollmentUpsertWithoutInformCampaignEnrollmentCanonicalServicesInput = {
  create: InformCampaignEnrollmentCreateWithoutInformCampaignEnrollmentCanonicalServicesInput;
  update: InformCampaignEnrollmentUpdateWithoutInformCampaignEnrollmentCanonicalServicesInput;
  where?: Maybe<InformCampaignEnrollmentWhereInput>;
};

export type InformCampaignEnrollmentWhereInput = {
  AND?: Maybe<Array<InformCampaignEnrollmentWhereInput>>;
  NOT?: Maybe<Array<InformCampaignEnrollmentWhereInput>>;
  OR?: Maybe<Array<InformCampaignEnrollmentWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceListRelationFilter>;
  informCampaignId?: Maybe<StringFilter>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentScalarRelationFilter>;
  informPartnerProgramEnrollmentId?: Maybe<StringFilter>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  lastUpdatedByType?: Maybe<EnumInformEntityUpdatedByTypeNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformEnrollmentStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignEnrollmentWhereUniqueInput = {
  AND?: Maybe<Array<InformCampaignEnrollmentWhereInput>>;
  NOT?: Maybe<Array<InformCampaignEnrollmentWhereInput>>;
  OR?: Maybe<Array<InformCampaignEnrollmentWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  informCampaignEnrollmentCanonicalServices?: Maybe<InformCampaignEnrollmentCanonicalServiceListRelationFilter>;
  informCampaignId?: Maybe<StringFilter>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentScalarRelationFilter>;
  informPartnerProgramEnrollmentId?: Maybe<StringFilter>;
  informPartnerProgramEnrollmentId_informCampaignId?: Maybe<InformCampaignEnrollmentInformPartnerProgramEnrollmentIdInformCampaignIdCompoundUniqueInput>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  lastUpdatedByType?: Maybe<EnumInformEntityUpdatedByTypeNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformEnrollmentStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignExecution = {
  __typename?: 'InformCampaignExecution';
  _count: InformCampaignExecutionCountOutputType;
  createdAt: Scalars['DateTime'];
  emailCampaigns: Array<EmailCampaign>;
  executeAt: Scalars['DateTime'];
  id: Scalars['String'];
  informAudienceMember: Array<InformAudienceMember>;
  informCampaign: InformCampaign;
  informCampaignId: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};


export type InformCampaignExecutionEmailCampaignsArgs = {
  cursor?: Maybe<EmailCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignWhereInput>;
};


export type InformCampaignExecutionInformAudienceMemberArgs = {
  cursor?: Maybe<InformAudienceMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberWhereInput>;
};

export type InformCampaignExecutionCountAggregateOutputType = {
  __typename?: 'InformCampaignExecutionCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  executeAt: Scalars['Int'];
  id: Scalars['Int'];
  informCampaignId: Scalars['Int'];
  settings: Scalars['Int'];
  status: Scalars['Int'];
  statusMessage: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformCampaignExecutionCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignId?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignExecutionCountOutputType = {
  __typename?: 'InformCampaignExecutionCountOutputType';
  emailCampaigns: Scalars['Int'];
  informAudienceMember: Scalars['Int'];
};

export type InformCampaignExecutionCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaigns?: Maybe<EmailCampaignCreateNestedManyWithoutInformCampaignExecutionInput>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutInformCampaignExecutionInput>;
  informCampaign: InformCampaignCreateNestedOneWithoutInformCampaignExecutionsInput;
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionCreateManyInformCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionCreateManyInformCampaignInputEnvelope = {
  data: Array<InformCampaignExecutionCreateManyInformCampaignInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformCampaignExecutionCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informCampaignId: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionCreateNestedManyWithoutInformCampaignInput = {
  connect?: Maybe<Array<InformCampaignExecutionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignExecutionCreateOrConnectWithoutInformCampaignInput>>;
  create?: Maybe<Array<InformCampaignExecutionCreateWithoutInformCampaignInput>>;
  createMany?: Maybe<InformCampaignExecutionCreateManyInformCampaignInputEnvelope>;
};

export type InformCampaignExecutionCreateNestedOneWithoutEmailCampaignsInput = {
  connect?: Maybe<InformCampaignExecutionWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignExecutionCreateOrConnectWithoutEmailCampaignsInput>;
  create?: Maybe<InformCampaignExecutionCreateWithoutEmailCampaignsInput>;
};

export type InformCampaignExecutionCreateNestedOneWithoutInformAudienceMemberInput = {
  connect?: Maybe<InformCampaignExecutionWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignExecutionCreateOrConnectWithoutInformAudienceMemberInput>;
  create?: Maybe<InformCampaignExecutionCreateWithoutInformAudienceMemberInput>;
};

export type InformCampaignExecutionCreateOrConnectWithoutEmailCampaignsInput = {
  create: InformCampaignExecutionCreateWithoutEmailCampaignsInput;
  where: InformCampaignExecutionWhereUniqueInput;
};

export type InformCampaignExecutionCreateOrConnectWithoutInformAudienceMemberInput = {
  create: InformCampaignExecutionCreateWithoutInformAudienceMemberInput;
  where: InformCampaignExecutionWhereUniqueInput;
};

export type InformCampaignExecutionCreateOrConnectWithoutInformCampaignInput = {
  create: InformCampaignExecutionCreateWithoutInformCampaignInput;
  where: InformCampaignExecutionWhereUniqueInput;
};

export type InformCampaignExecutionCreateWithoutEmailCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutInformCampaignExecutionInput>;
  informCampaign: InformCampaignCreateNestedOneWithoutInformCampaignExecutionsInput;
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionCreateWithoutInformAudienceMemberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaigns?: Maybe<EmailCampaignCreateNestedManyWithoutInformCampaignExecutionInput>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informCampaign: InformCampaignCreateNestedOneWithoutInformCampaignExecutionsInput;
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionCreateWithoutInformCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaigns?: Maybe<EmailCampaignCreateNestedManyWithoutInformCampaignExecutionInput>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutInformCampaignExecutionInput>;
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionGroupByOutputType = {
  __typename?: 'InformCampaignExecutionGroupByOutputType';
  _count?: Maybe<InformCampaignExecutionCountAggregateOutputType>;
  _max?: Maybe<InformCampaignExecutionMaxAggregateOutputType>;
  _min?: Maybe<InformCampaignExecutionMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  executeAt: Scalars['DateTime'];
  id: Scalars['String'];
  informCampaignId: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type InformCampaignExecutionListRelationFilter = {
  every?: Maybe<InformCampaignExecutionWhereInput>;
  none?: Maybe<InformCampaignExecutionWhereInput>;
  some?: Maybe<InformCampaignExecutionWhereInput>;
};

export type InformCampaignExecutionMaxAggregateOutputType = {
  __typename?: 'InformCampaignExecutionMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignId?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignExecutionMinAggregateOutputType = {
  __typename?: 'InformCampaignExecutionMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignId?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignExecutionNullableScalarRelationFilter = {
  AND?: Maybe<Array<InformCampaignExecutionWhereInput>>;
  NOT?: Maybe<Array<InformCampaignExecutionWhereInput>>;
  OR?: Maybe<Array<InformCampaignExecutionWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaigns?: Maybe<EmailCampaignListRelationFilter>;
  executeAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  informCampaignId?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformCampaignExecutionStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignExecutionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformCampaignExecutionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformCampaignExecutionOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  emailCampaigns?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  informCampaignId?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformCampaignExecutionOrderByRelevanceFieldEnum {
  Id = 'id',
  InformCampaignId = 'informCampaignId'
}

export type InformCampaignExecutionOrderByRelevanceInput = {
  fields: Array<InformCampaignExecutionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformCampaignExecutionOrderByWithAggregationInput = {
  _count?: Maybe<InformCampaignExecutionCountOrderByAggregateInput>;
  _max?: Maybe<InformCampaignExecutionMaxOrderByAggregateInput>;
  _min?: Maybe<InformCampaignExecutionMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignId?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignExecutionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformCampaignExecutionOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  emailCampaigns?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  informCampaignId?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignExecutionOrderByWithRelationInput = {
  _relevance?: Maybe<InformCampaignExecutionOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  emailCampaigns?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  informCampaignId?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformCampaignExecutionScalarFieldEnum {
  CreatedAt = 'createdAt',
  ExecuteAt = 'executeAt',
  Id = 'id',
  InformCampaignId = 'informCampaignId',
  Settings = 'settings',
  Status = 'status',
  StatusMessage = 'statusMessage',
  UpdatedAt = 'updatedAt'
}

export type InformCampaignExecutionScalarRelationFilter = {
  AND?: Maybe<Array<InformCampaignExecutionWhereInput>>;
  NOT?: Maybe<Array<InformCampaignExecutionWhereInput>>;
  OR?: Maybe<Array<InformCampaignExecutionWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaigns?: Maybe<EmailCampaignListRelationFilter>;
  executeAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  informCampaignId?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformCampaignExecutionStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignExecutionScalarWhereInput = {
  AND?: Maybe<Array<InformCampaignExecutionScalarWhereInput>>;
  NOT?: Maybe<Array<InformCampaignExecutionScalarWhereInput>>;
  OR?: Maybe<Array<InformCampaignExecutionScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  executeAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informCampaignId?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformCampaignExecutionStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignExecutionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformCampaignExecutionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformCampaignExecutionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformCampaignExecutionScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  executeAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informCampaignId?: Maybe<StringWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  status?: Maybe<EnumInformCampaignExecutionStatusWithAggregatesFilter>;
  statusMessage?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformCampaignExecutionStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Running = 'Running',
  Scheduled = 'Scheduled',
  Skipped = 'Skipped'
}

export type InformCampaignExecutionUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaigns?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutInformCampaignExecutionInput>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutInformCampaignExecutionInput>;
  informCampaignId: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUncheckedCreateNestedManyWithoutInformCampaignInput = {
  connect?: Maybe<Array<InformCampaignExecutionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignExecutionCreateOrConnectWithoutInformCampaignInput>>;
  create?: Maybe<Array<InformCampaignExecutionCreateWithoutInformCampaignInput>>;
  createMany?: Maybe<InformCampaignExecutionCreateManyInformCampaignInputEnvelope>;
};

export type InformCampaignExecutionUncheckedCreateWithoutEmailCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutInformCampaignExecutionInput>;
  informCampaignId: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUncheckedCreateWithoutInformAudienceMemberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaigns?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutInformCampaignExecutionInput>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informCampaignId: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUncheckedCreateWithoutInformCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaigns?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutInformCampaignExecutionInput>;
  executeAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutInformCampaignExecutionInput>;
  settings?: Maybe<Scalars['Json']>;
  status: InformCampaignExecutionStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaigns?: Maybe<EmailCampaignUncheckedUpdateManyWithoutInformCampaignExecutionNestedInput>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutInformCampaignExecutionNestedInput>;
  informCampaignId?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignId?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUncheckedUpdateManyWithoutInformCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUncheckedUpdateManyWithoutInformCampaignNestedInput = {
  connect?: Maybe<Array<InformCampaignExecutionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignExecutionCreateOrConnectWithoutInformCampaignInput>>;
  create?: Maybe<Array<InformCampaignExecutionCreateWithoutInformCampaignInput>>;
  createMany?: Maybe<InformCampaignExecutionCreateManyInformCampaignInputEnvelope>;
  delete?: Maybe<Array<InformCampaignExecutionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignExecutionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignExecutionWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignExecutionWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignExecutionUpdateWithWhereUniqueWithoutInformCampaignInput>>;
  updateMany?: Maybe<Array<InformCampaignExecutionUpdateManyWithWhereWithoutInformCampaignInput>>;
  upsert?: Maybe<Array<InformCampaignExecutionUpsertWithWhereUniqueWithoutInformCampaignInput>>;
};

export type InformCampaignExecutionUncheckedUpdateWithoutEmailCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutInformCampaignExecutionNestedInput>;
  informCampaignId?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUncheckedUpdateWithoutInformAudienceMemberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaigns?: Maybe<EmailCampaignUncheckedUpdateManyWithoutInformCampaignExecutionNestedInput>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignId?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUncheckedUpdateWithoutInformCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaigns?: Maybe<EmailCampaignUncheckedUpdateManyWithoutInformCampaignExecutionNestedInput>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutInformCampaignExecutionNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaigns?: Maybe<EmailCampaignUpdateManyWithoutInformCampaignExecutionNestedInput>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutInformCampaignExecutionNestedInput>;
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformCampaignExecutionsNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUpdateManyWithWhereWithoutInformCampaignInput = {
  data: InformCampaignExecutionUpdateManyMutationInput;
  where: InformCampaignExecutionScalarWhereInput;
};

export type InformCampaignExecutionUpdateManyWithoutInformCampaignNestedInput = {
  connect?: Maybe<Array<InformCampaignExecutionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignExecutionCreateOrConnectWithoutInformCampaignInput>>;
  create?: Maybe<Array<InformCampaignExecutionCreateWithoutInformCampaignInput>>;
  createMany?: Maybe<InformCampaignExecutionCreateManyInformCampaignInputEnvelope>;
  delete?: Maybe<Array<InformCampaignExecutionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignExecutionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignExecutionWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignExecutionWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignExecutionUpdateWithWhereUniqueWithoutInformCampaignInput>>;
  updateMany?: Maybe<Array<InformCampaignExecutionUpdateManyWithWhereWithoutInformCampaignInput>>;
  upsert?: Maybe<Array<InformCampaignExecutionUpsertWithWhereUniqueWithoutInformCampaignInput>>;
};

export type InformCampaignExecutionUpdateOneRequiredWithoutInformAudienceMemberNestedInput = {
  connect?: Maybe<InformCampaignExecutionWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignExecutionCreateOrConnectWithoutInformAudienceMemberInput>;
  create?: Maybe<InformCampaignExecutionCreateWithoutInformAudienceMemberInput>;
  update?: Maybe<InformCampaignExecutionUpdateToOneWithWhereWithoutInformAudienceMemberInput>;
  upsert?: Maybe<InformCampaignExecutionUpsertWithoutInformAudienceMemberInput>;
};

export type InformCampaignExecutionUpdateOneWithoutEmailCampaignsNestedInput = {
  connect?: Maybe<InformCampaignExecutionWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignExecutionCreateOrConnectWithoutEmailCampaignsInput>;
  create?: Maybe<InformCampaignExecutionCreateWithoutEmailCampaignsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformCampaignExecutionUpdateToOneWithWhereWithoutEmailCampaignsInput>;
  upsert?: Maybe<InformCampaignExecutionUpsertWithoutEmailCampaignsInput>;
};

export type InformCampaignExecutionUpdateToOneWithWhereWithoutEmailCampaignsInput = {
  data: InformCampaignExecutionUpdateWithoutEmailCampaignsInput;
  where?: Maybe<InformCampaignExecutionWhereInput>;
};

export type InformCampaignExecutionUpdateToOneWithWhereWithoutInformAudienceMemberInput = {
  data: InformCampaignExecutionUpdateWithoutInformAudienceMemberInput;
  where?: Maybe<InformCampaignExecutionWhereInput>;
};

export type InformCampaignExecutionUpdateWithWhereUniqueWithoutInformCampaignInput = {
  data: InformCampaignExecutionUpdateWithoutInformCampaignInput;
  where: InformCampaignExecutionWhereUniqueInput;
};

export type InformCampaignExecutionUpdateWithoutEmailCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutInformCampaignExecutionNestedInput>;
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformCampaignExecutionsNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUpdateWithoutInformAudienceMemberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaigns?: Maybe<EmailCampaignUpdateManyWithoutInformCampaignExecutionNestedInput>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformCampaignExecutionsNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUpdateWithoutInformCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailCampaigns?: Maybe<EmailCampaignUpdateManyWithoutInformCampaignExecutionNestedInput>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutInformCampaignExecutionNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformCampaignExecutionStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignExecutionUpsertWithWhereUniqueWithoutInformCampaignInput = {
  create: InformCampaignExecutionCreateWithoutInformCampaignInput;
  update: InformCampaignExecutionUpdateWithoutInformCampaignInput;
  where: InformCampaignExecutionWhereUniqueInput;
};

export type InformCampaignExecutionUpsertWithoutEmailCampaignsInput = {
  create: InformCampaignExecutionCreateWithoutEmailCampaignsInput;
  update: InformCampaignExecutionUpdateWithoutEmailCampaignsInput;
  where?: Maybe<InformCampaignExecutionWhereInput>;
};

export type InformCampaignExecutionUpsertWithoutInformAudienceMemberInput = {
  create: InformCampaignExecutionCreateWithoutInformAudienceMemberInput;
  update: InformCampaignExecutionUpdateWithoutInformAudienceMemberInput;
  where?: Maybe<InformCampaignExecutionWhereInput>;
};

export type InformCampaignExecutionWhereInput = {
  AND?: Maybe<Array<InformCampaignExecutionWhereInput>>;
  NOT?: Maybe<Array<InformCampaignExecutionWhereInput>>;
  OR?: Maybe<Array<InformCampaignExecutionWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaigns?: Maybe<EmailCampaignListRelationFilter>;
  executeAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  informCampaignId?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformCampaignExecutionStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignExecutionWhereUniqueInput = {
  AND?: Maybe<Array<InformCampaignExecutionWhereInput>>;
  NOT?: Maybe<Array<InformCampaignExecutionWhereInput>>;
  OR?: Maybe<Array<InformCampaignExecutionWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  emailCampaigns?: Maybe<EmailCampaignListRelationFilter>;
  executeAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  informCampaignId?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformCampaignExecutionStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignGroup = {
  __typename?: 'InformCampaignGroup';
  _count: InformCampaignGroupCountOutputType;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informCampaigns: Array<InformCampaign>;
  informPartner: InformPartner;
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type InformCampaignGroupInformCampaignsArgs = {
  cursor?: Maybe<InformCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignWhereInput>;
};

export type InformCampaignGroupByOutputType = {
  __typename?: 'InformCampaignGroupByOutputType';
  _count?: Maybe<InformCampaignCountAggregateOutputType>;
  _max?: Maybe<InformCampaignMaxAggregateOutputType>;
  _min?: Maybe<InformCampaignMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informAudienceDefinitionId: Scalars['String'];
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informPartnerProgramId: Scalars['String'];
  name: Scalars['String'];
  status: InformCampaignStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt: Scalars['DateTime'];
  visibility: InformCampaignVisibility;
};

export type InformCampaignGroupCountAggregateOutputType = {
  __typename?: 'InformCampaignGroupCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  displayName: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerId: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformCampaignGroupCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignGroupCountOutputType = {
  __typename?: 'InformCampaignGroupCountOutputType';
  informCampaigns: Scalars['Int'];
};

export type InformCampaignGroupCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignCreateNestedManyWithoutInformCampaignGroupInput>;
  informPartner: InformPartnerCreateNestedOneWithoutInformCampaignGroupsInput;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupCreateManyInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupCreateManyInformPartnerInputEnvelope = {
  data: Array<InformCampaignGroupCreateManyInformPartnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformCampaignGroupCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformCampaignGroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignGroupCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformCampaignGroupCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformCampaignGroupCreateManyInformPartnerInputEnvelope>;
};

export type InformCampaignGroupCreateNestedOneWithoutInformCampaignsInput = {
  connect?: Maybe<InformCampaignGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignGroupCreateOrConnectWithoutInformCampaignsInput>;
  create?: Maybe<InformCampaignGroupCreateWithoutInformCampaignsInput>;
};

export type InformCampaignGroupCreateOrConnectWithoutInformCampaignsInput = {
  create: InformCampaignGroupCreateWithoutInformCampaignsInput;
  where: InformCampaignGroupWhereUniqueInput;
};

export type InformCampaignGroupCreateOrConnectWithoutInformPartnerInput = {
  create: InformCampaignGroupCreateWithoutInformPartnerInput;
  where: InformCampaignGroupWhereUniqueInput;
};

export type InformCampaignGroupCreateWithoutInformCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformCampaignGroupsInput;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupCreateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignCreateNestedManyWithoutInformCampaignGroupInput>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupGroupByOutputType = {
  __typename?: 'InformCampaignGroupGroupByOutputType';
  _count?: Maybe<InformCampaignGroupCountAggregateOutputType>;
  _max?: Maybe<InformCampaignGroupMaxAggregateOutputType>;
  _min?: Maybe<InformCampaignGroupMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type InformCampaignGroupListRelationFilter = {
  every?: Maybe<InformCampaignGroupWhereInput>;
  none?: Maybe<InformCampaignGroupWhereInput>;
  some?: Maybe<InformCampaignGroupWhereInput>;
};

export type InformCampaignGroupMaxAggregateOutputType = {
  __typename?: 'InformCampaignGroupMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignGroupMinAggregateOutputType = {
  __typename?: 'InformCampaignGroupMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignGroupNameInformPartnerIdCompoundUniqueInput = {
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
};

export type InformCampaignGroupNullableScalarRelationFilter = {
  AND?: Maybe<Array<InformCampaignGroupWhereInput>>;
  NOT?: Maybe<Array<InformCampaignGroupWhereInput>>;
  OR?: Maybe<Array<InformCampaignGroupWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informCampaigns?: Maybe<InformCampaignListRelationFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignGroupOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformCampaignGroupOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformCampaignGroupOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaigns?: Maybe<InformCampaignOrderByRelationAggregateInput>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformCampaignGroupOrderByRelevanceFieldEnum {
  Description = 'description',
  DisplayName = 'displayName',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  Name = 'name'
}

export type InformCampaignGroupOrderByRelevanceInput = {
  fields: Array<InformCampaignGroupOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformCampaignGroupOrderByWithAggregationInput = {
  _count?: Maybe<InformCampaignGroupCountOrderByAggregateInput>;
  _max?: Maybe<InformCampaignGroupMaxOrderByAggregateInput>;
  _min?: Maybe<InformCampaignGroupMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignGroupOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformCampaignGroupOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaigns?: Maybe<InformCampaignOrderByRelationAggregateInput>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCampaignGroupOrderByWithRelationInput = {
  _relevance?: Maybe<InformCampaignGroupOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaigns?: Maybe<InformCampaignOrderByRelationAggregateInput>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformCampaignGroupScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  DisplayName = 'displayName',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type InformCampaignGroupScalarWhereInput = {
  AND?: Maybe<Array<InformCampaignGroupScalarWhereInput>>;
  NOT?: Maybe<Array<InformCampaignGroupScalarWhereInput>>;
  OR?: Maybe<Array<InformCampaignGroupScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignGroupScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformCampaignGroupScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformCampaignGroupScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformCampaignGroupScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  displayName?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type InformCampaignGroupUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedCreateNestedManyWithoutInformCampaignGroupInput>;
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupUncheckedCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformCampaignGroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignGroupCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformCampaignGroupCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformCampaignGroupCreateManyInformPartnerInputEnvelope>;
};

export type InformCampaignGroupUncheckedCreateWithoutInformCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupUncheckedCreateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedCreateNestedManyWithoutInformCampaignGroupInput>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedUpdateManyWithoutInformCampaignGroupNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupUncheckedUpdateManyWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupUncheckedUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformCampaignGroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignGroupCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformCampaignGroupCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformCampaignGroupCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformCampaignGroupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignGroupScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignGroupWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignGroupWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignGroupUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformCampaignGroupUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformCampaignGroupUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformCampaignGroupUncheckedUpdateWithoutInformCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupUncheckedUpdateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedUpdateManyWithoutInformCampaignGroupNestedInput>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUpdateManyWithoutInformCampaignGroupNestedInput>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformCampaignGroupsNestedInput>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupUpdateManyWithWhereWithoutInformPartnerInput = {
  data: InformCampaignGroupUpdateManyMutationInput;
  where: InformCampaignGroupScalarWhereInput;
};

export type InformCampaignGroupUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformCampaignGroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignGroupCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformCampaignGroupCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformCampaignGroupCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformCampaignGroupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignGroupScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignGroupWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignGroupWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignGroupUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformCampaignGroupUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformCampaignGroupUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformCampaignGroupUpdateOneWithoutInformCampaignsNestedInput = {
  connect?: Maybe<InformCampaignGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignGroupCreateOrConnectWithoutInformCampaignsInput>;
  create?: Maybe<InformCampaignGroupCreateWithoutInformCampaignsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformCampaignGroupUpdateToOneWithWhereWithoutInformCampaignsInput>;
  upsert?: Maybe<InformCampaignGroupUpsertWithoutInformCampaignsInput>;
};

export type InformCampaignGroupUpdateToOneWithWhereWithoutInformCampaignsInput = {
  data: InformCampaignGroupUpdateWithoutInformCampaignsInput;
  where?: Maybe<InformCampaignGroupWhereInput>;
};

export type InformCampaignGroupUpdateWithWhereUniqueWithoutInformPartnerInput = {
  data: InformCampaignGroupUpdateWithoutInformPartnerInput;
  where: InformCampaignGroupWhereUniqueInput;
};

export type InformCampaignGroupUpdateWithoutInformCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformCampaignGroupsNestedInput>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupUpdateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUpdateManyWithoutInformCampaignGroupNestedInput>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCampaignGroupUpsertWithWhereUniqueWithoutInformPartnerInput = {
  create: InformCampaignGroupCreateWithoutInformPartnerInput;
  update: InformCampaignGroupUpdateWithoutInformPartnerInput;
  where: InformCampaignGroupWhereUniqueInput;
};

export type InformCampaignGroupUpsertWithoutInformCampaignsInput = {
  create: InformCampaignGroupCreateWithoutInformCampaignsInput;
  update: InformCampaignGroupUpdateWithoutInformCampaignsInput;
  where?: Maybe<InformCampaignGroupWhereInput>;
};

export type InformCampaignGroupWhereInput = {
  AND?: Maybe<Array<InformCampaignGroupWhereInput>>;
  NOT?: Maybe<Array<InformCampaignGroupWhereInput>>;
  OR?: Maybe<Array<InformCampaignGroupWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informCampaigns?: Maybe<InformCampaignListRelationFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignGroupWhereUniqueInput = {
  AND?: Maybe<Array<InformCampaignGroupWhereInput>>;
  NOT?: Maybe<Array<InformCampaignGroupWhereInput>>;
  OR?: Maybe<Array<InformCampaignGroupWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignListRelationFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  name_informPartnerId?: Maybe<InformCampaignGroupNameInformPartnerIdCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCampaignListRelationFilter = {
  every?: Maybe<InformCampaignWhereInput>;
  none?: Maybe<InformCampaignWhereInput>;
  some?: Maybe<InformCampaignWhereInput>;
};

export type InformCampaignMaxAggregateOutputType = {
  __typename?: 'InformCampaignMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  informCampaignGroupId?: Maybe<SortOrder>;
  informPartnerProgramId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export type InformCampaignMinAggregateOutputType = {
  __typename?: 'InformCampaignMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  informCampaignGroupId?: Maybe<SortOrder>;
  informPartnerProgramId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export type InformCampaignOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformCampaignOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformCampaignOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionOrderByWithRelationInput>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignOrderByWithRelationInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentOrderByRelationAggregateInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionOrderByRelationAggregateInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupOrderByWithRelationInput>;
  informCampaignGroupId?: Maybe<SortOrder>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignOrderByWithRelationInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramOrderByWithRelationInput>;
  informPartnerProgramId?: Maybe<SortOrder>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignOrderByWithRelationInput>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export enum InformCampaignOrderByRelevanceFieldEnum {
  Description = 'description',
  DisplayName = 'displayName',
  Id = 'id',
  InformAudienceDefinitionId = 'informAudienceDefinitionId',
  InformCampaignGroupId = 'informCampaignGroupId',
  InformPartnerProgramId = 'informPartnerProgramId',
  Name = 'name'
}

export type InformCampaignOrderByRelevanceInput = {
  fields: Array<InformCampaignOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformCampaignOrderByWithAggregationInput = {
  _count?: Maybe<InformCampaignCountOrderByAggregateInput>;
  _max?: Maybe<InformCampaignMaxOrderByAggregateInput>;
  _min?: Maybe<InformCampaignMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  informCampaignGroupId?: Maybe<SortOrder>;
  informPartnerProgramId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export type InformCampaignOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformCampaignOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionOrderByWithRelationInput>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignOrderByWithRelationInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentOrderByRelationAggregateInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionOrderByRelationAggregateInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupOrderByWithRelationInput>;
  informCampaignGroupId?: Maybe<SortOrder>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignOrderByWithRelationInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramOrderByWithRelationInput>;
  informPartnerProgramId?: Maybe<SortOrder>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignOrderByWithRelationInput>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export type InformCampaignOrderByWithRelationInput = {
  _relevance?: Maybe<InformCampaignOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionOrderByWithRelationInput>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignOrderByWithRelationInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentOrderByRelationAggregateInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionOrderByRelationAggregateInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupOrderByWithRelationInput>;
  informCampaignGroupId?: Maybe<SortOrder>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignOrderByWithRelationInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramOrderByWithRelationInput>;
  informPartnerProgramId?: Maybe<SortOrder>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignOrderByWithRelationInput>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export enum InformCampaignScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  DisplayName = 'displayName',
  Id = 'id',
  InformAudienceDefinitionId = 'informAudienceDefinitionId',
  InformCampaignGroupId = 'informCampaignGroupId',
  InformPartnerProgramId = 'informPartnerProgramId',
  Name = 'name',
  Status = 'status',
  StatusMessage = 'statusMessage',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Visibility = 'visibility'
}

export type InformCampaignScalarRelationFilter = {
  AND?: Maybe<Array<InformCampaignWhereInput>>;
  NOT?: Maybe<Array<InformCampaignWhereInput>>;
  OR?: Maybe<Array<InformCampaignWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionScalarRelationFilter>;
  informAudienceDefinitionId?: Maybe<StringFilter>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignNullableScalarRelationFilter>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentListRelationFilter>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionListRelationFilter>;
  informCampaignGroup?: Maybe<InformCampaignGroupNullableScalarRelationFilter>;
  informCampaignGroupId?: Maybe<StringNullableFilter>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignNullableScalarRelationFilter>;
  informPartnerProgram?: Maybe<InformPartnerProgramScalarRelationFilter>;
  informPartnerProgramId?: Maybe<StringFilter>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignNullableScalarRelationFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<EnumInformCampaignStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumInformCampaignTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visibility?: Maybe<EnumInformCampaignVisibilityFilter>;
};

export type InformCampaignScalarWhereInput = {
  AND?: Maybe<Array<InformCampaignScalarWhereInput>>;
  NOT?: Maybe<Array<InformCampaignScalarWhereInput>>;
  OR?: Maybe<Array<InformCampaignScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitionId?: Maybe<StringFilter>;
  informCampaignGroupId?: Maybe<StringNullableFilter>;
  informPartnerProgramId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<EnumInformCampaignStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumInformCampaignTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visibility?: Maybe<EnumInformCampaignVisibilityFilter>;
};

export type InformCampaignScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformCampaignScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformCampaignScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformCampaignScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  displayName?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informAudienceDefinitionId?: Maybe<StringWithAggregatesFilter>;
  informCampaignGroupId?: Maybe<StringNullableWithAggregatesFilter>;
  informPartnerProgramId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumInformCampaignStatusWithAggregatesFilter>;
  statusMessage?: Maybe<JsonNullableWithAggregatesFilter>;
  type?: Maybe<EnumInformCampaignTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  visibility?: Maybe<EnumInformCampaignVisibilityWithAggregatesFilter>;
};

export enum InformCampaignStatus {
  Active = 'Active',
  Archived = 'Archived',
  Paused = 'Paused'
}

export enum InformCampaignType {
  Automation = 'Automation',
  EventDriven = 'EventDriven',
  Scheduled = 'Scheduled'
}

export type InformCampaignUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgramId: Scalars['String'];
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput = {
  connect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignCreateOrConnectWithoutInformAudienceDefinitionInput>>;
  create?: Maybe<Array<InformCampaignCreateWithoutInformAudienceDefinitionInput>>;
  createMany?: Maybe<InformCampaignCreateManyInformAudienceDefinitionInputEnvelope>;
};

export type InformCampaignUncheckedCreateNestedManyWithoutInformCampaignGroupInput = {
  connect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignCreateOrConnectWithoutInformCampaignGroupInput>>;
  create?: Maybe<Array<InformCampaignCreateWithoutInformCampaignGroupInput>>;
  createMany?: Maybe<InformCampaignCreateManyInformCampaignGroupInputEnvelope>;
};

export type InformCampaignUncheckedCreateNestedManyWithoutInformPartnerProgramInput = {
  connect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignCreateOrConnectWithoutInformPartnerProgramInput>>;
  create?: Maybe<Array<InformCampaignCreateWithoutInformPartnerProgramInput>>;
  createMany?: Maybe<InformCampaignCreateManyInformPartnerProgramInputEnvelope>;
};

export type InformCampaignUncheckedCreateWithoutInformAudienceDefinitionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgramId: Scalars['String'];
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedCreateWithoutInformAutomationCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgramId: Scalars['String'];
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedCreateWithoutInformCampaignEnrollmentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgramId: Scalars['String'];
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedCreateWithoutInformCampaignExecutionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgramId: Scalars['String'];
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedCreateWithoutInformCampaignGroupInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgramId: Scalars['String'];
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedCreateWithoutInformEventDrivenCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informPartnerProgramId: Scalars['String'];
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedCreateWithoutInformPartnerProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedCreateWithoutInformScheduledCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedCreateNestedManyWithoutInformCampaignInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedCreateNestedOneWithoutInformCampaignInput>;
  informPartnerProgramId: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type: InformCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateManyWithoutInformAudienceDefinitionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput = {
  connect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignCreateOrConnectWithoutInformAudienceDefinitionInput>>;
  create?: Maybe<Array<InformCampaignCreateWithoutInformAudienceDefinitionInput>>;
  createMany?: Maybe<InformCampaignCreateManyInformAudienceDefinitionInputEnvelope>;
  delete?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignUpdateWithWhereUniqueWithoutInformAudienceDefinitionInput>>;
  updateMany?: Maybe<Array<InformCampaignUpdateManyWithWhereWithoutInformAudienceDefinitionInput>>;
  upsert?: Maybe<Array<InformCampaignUpsertWithWhereUniqueWithoutInformAudienceDefinitionInput>>;
};

export type InformCampaignUncheckedUpdateManyWithoutInformCampaignGroupInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateManyWithoutInformCampaignGroupNestedInput = {
  connect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignCreateOrConnectWithoutInformCampaignGroupInput>>;
  create?: Maybe<Array<InformCampaignCreateWithoutInformCampaignGroupInput>>;
  createMany?: Maybe<InformCampaignCreateManyInformCampaignGroupInputEnvelope>;
  delete?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignUpdateWithWhereUniqueWithoutInformCampaignGroupInput>>;
  updateMany?: Maybe<Array<InformCampaignUpdateManyWithWhereWithoutInformCampaignGroupInput>>;
  upsert?: Maybe<Array<InformCampaignUpsertWithWhereUniqueWithoutInformCampaignGroupInput>>;
};

export type InformCampaignUncheckedUpdateManyWithoutInformPartnerProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateManyWithoutInformPartnerProgramNestedInput = {
  connect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignCreateOrConnectWithoutInformPartnerProgramInput>>;
  create?: Maybe<Array<InformCampaignCreateWithoutInformPartnerProgramInput>>;
  createMany?: Maybe<InformCampaignCreateManyInformPartnerProgramInputEnvelope>;
  delete?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignUpdateWithWhereUniqueWithoutInformPartnerProgramInput>>;
  updateMany?: Maybe<Array<InformCampaignUpdateManyWithWhereWithoutInformPartnerProgramInput>>;
  upsert?: Maybe<Array<InformCampaignUpsertWithWhereUniqueWithoutInformPartnerProgramInput>>;
};

export type InformCampaignUncheckedUpdateWithoutInformAudienceDefinitionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateWithoutInformAutomationCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateWithoutInformCampaignEnrollmentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateWithoutInformCampaignExecutionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateWithoutInformCampaignGroupInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateWithoutInformEventDrivenCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateWithoutInformPartnerProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUncheckedUpdateWithoutInformScheduledCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUncheckedUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroupId?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupUpdateOneWithoutInformCampaignsNestedInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUpdateManyWithWhereWithoutInformAudienceDefinitionInput = {
  data: InformCampaignUpdateManyMutationInput;
  where: InformCampaignScalarWhereInput;
};

export type InformCampaignUpdateManyWithWhereWithoutInformCampaignGroupInput = {
  data: InformCampaignUpdateManyMutationInput;
  where: InformCampaignScalarWhereInput;
};

export type InformCampaignUpdateManyWithWhereWithoutInformPartnerProgramInput = {
  data: InformCampaignUpdateManyMutationInput;
  where: InformCampaignScalarWhereInput;
};

export type InformCampaignUpdateManyWithoutInformAudienceDefinitionNestedInput = {
  connect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignCreateOrConnectWithoutInformAudienceDefinitionInput>>;
  create?: Maybe<Array<InformCampaignCreateWithoutInformAudienceDefinitionInput>>;
  createMany?: Maybe<InformCampaignCreateManyInformAudienceDefinitionInputEnvelope>;
  delete?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignUpdateWithWhereUniqueWithoutInformAudienceDefinitionInput>>;
  updateMany?: Maybe<Array<InformCampaignUpdateManyWithWhereWithoutInformAudienceDefinitionInput>>;
  upsert?: Maybe<Array<InformCampaignUpsertWithWhereUniqueWithoutInformAudienceDefinitionInput>>;
};

export type InformCampaignUpdateManyWithoutInformCampaignGroupNestedInput = {
  connect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignCreateOrConnectWithoutInformCampaignGroupInput>>;
  create?: Maybe<Array<InformCampaignCreateWithoutInformCampaignGroupInput>>;
  createMany?: Maybe<InformCampaignCreateManyInformCampaignGroupInputEnvelope>;
  delete?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignUpdateWithWhereUniqueWithoutInformCampaignGroupInput>>;
  updateMany?: Maybe<Array<InformCampaignUpdateManyWithWhereWithoutInformCampaignGroupInput>>;
  upsert?: Maybe<Array<InformCampaignUpsertWithWhereUniqueWithoutInformCampaignGroupInput>>;
};

export type InformCampaignUpdateManyWithoutInformPartnerProgramNestedInput = {
  connect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformCampaignCreateOrConnectWithoutInformPartnerProgramInput>>;
  create?: Maybe<Array<InformCampaignCreateWithoutInformPartnerProgramInput>>;
  createMany?: Maybe<InformCampaignCreateManyInformPartnerProgramInputEnvelope>;
  delete?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  set?: Maybe<Array<InformCampaignWhereUniqueInput>>;
  update?: Maybe<Array<InformCampaignUpdateWithWhereUniqueWithoutInformPartnerProgramInput>>;
  updateMany?: Maybe<Array<InformCampaignUpdateManyWithWhereWithoutInformPartnerProgramInput>>;
  upsert?: Maybe<Array<InformCampaignUpsertWithWhereUniqueWithoutInformPartnerProgramInput>>;
};

export type InformCampaignUpdateOneRequiredWithoutInformAutomationCampaignNestedInput = {
  connect?: Maybe<InformCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignCreateOrConnectWithoutInformAutomationCampaignInput>;
  create?: Maybe<InformCampaignCreateWithoutInformAutomationCampaignInput>;
  update?: Maybe<InformCampaignUpdateToOneWithWhereWithoutInformAutomationCampaignInput>;
  upsert?: Maybe<InformCampaignUpsertWithoutInformAutomationCampaignInput>;
};

export type InformCampaignUpdateOneRequiredWithoutInformCampaignEnrollmentsNestedInput = {
  connect?: Maybe<InformCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignCreateOrConnectWithoutInformCampaignEnrollmentsInput>;
  create?: Maybe<InformCampaignCreateWithoutInformCampaignEnrollmentsInput>;
  update?: Maybe<InformCampaignUpdateToOneWithWhereWithoutInformCampaignEnrollmentsInput>;
  upsert?: Maybe<InformCampaignUpsertWithoutInformCampaignEnrollmentsInput>;
};

export type InformCampaignUpdateOneRequiredWithoutInformCampaignExecutionsNestedInput = {
  connect?: Maybe<InformCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignCreateOrConnectWithoutInformCampaignExecutionsInput>;
  create?: Maybe<InformCampaignCreateWithoutInformCampaignExecutionsInput>;
  update?: Maybe<InformCampaignUpdateToOneWithWhereWithoutInformCampaignExecutionsInput>;
  upsert?: Maybe<InformCampaignUpsertWithoutInformCampaignExecutionsInput>;
};

export type InformCampaignUpdateOneRequiredWithoutInformEventDrivenCampaignNestedInput = {
  connect?: Maybe<InformCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignCreateOrConnectWithoutInformEventDrivenCampaignInput>;
  create?: Maybe<InformCampaignCreateWithoutInformEventDrivenCampaignInput>;
  update?: Maybe<InformCampaignUpdateToOneWithWhereWithoutInformEventDrivenCampaignInput>;
  upsert?: Maybe<InformCampaignUpsertWithoutInformEventDrivenCampaignInput>;
};

export type InformCampaignUpdateOneRequiredWithoutInformScheduledCampaignNestedInput = {
  connect?: Maybe<InformCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformCampaignCreateOrConnectWithoutInformScheduledCampaignInput>;
  create?: Maybe<InformCampaignCreateWithoutInformScheduledCampaignInput>;
  update?: Maybe<InformCampaignUpdateToOneWithWhereWithoutInformScheduledCampaignInput>;
  upsert?: Maybe<InformCampaignUpsertWithoutInformScheduledCampaignInput>;
};

export type InformCampaignUpdateToOneWithWhereWithoutInformAutomationCampaignInput = {
  data: InformCampaignUpdateWithoutInformAutomationCampaignInput;
  where?: Maybe<InformCampaignWhereInput>;
};

export type InformCampaignUpdateToOneWithWhereWithoutInformCampaignEnrollmentsInput = {
  data: InformCampaignUpdateWithoutInformCampaignEnrollmentsInput;
  where?: Maybe<InformCampaignWhereInput>;
};

export type InformCampaignUpdateToOneWithWhereWithoutInformCampaignExecutionsInput = {
  data: InformCampaignUpdateWithoutInformCampaignExecutionsInput;
  where?: Maybe<InformCampaignWhereInput>;
};

export type InformCampaignUpdateToOneWithWhereWithoutInformEventDrivenCampaignInput = {
  data: InformCampaignUpdateWithoutInformEventDrivenCampaignInput;
  where?: Maybe<InformCampaignWhereInput>;
};

export type InformCampaignUpdateToOneWithWhereWithoutInformScheduledCampaignInput = {
  data: InformCampaignUpdateWithoutInformScheduledCampaignInput;
  where?: Maybe<InformCampaignWhereInput>;
};

export type InformCampaignUpdateWithWhereUniqueWithoutInformAudienceDefinitionInput = {
  data: InformCampaignUpdateWithoutInformAudienceDefinitionInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignUpdateWithWhereUniqueWithoutInformCampaignGroupInput = {
  data: InformCampaignUpdateWithoutInformCampaignGroupInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignUpdateWithWhereUniqueWithoutInformPartnerProgramInput = {
  data: InformCampaignUpdateWithoutInformPartnerProgramInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignUpdateWithoutInformAudienceDefinitionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupUpdateOneWithoutInformCampaignsNestedInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUpdateWithoutInformAutomationCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupUpdateOneWithoutInformCampaignsNestedInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUpdateWithoutInformCampaignEnrollmentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupUpdateOneWithoutInformCampaignsNestedInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUpdateWithoutInformCampaignExecutionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupUpdateOneWithoutInformCampaignsNestedInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUpdateWithoutInformCampaignGroupInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUpdateManyWithoutInformCampaignNestedInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUpdateWithoutInformEventDrivenCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupUpdateOneWithoutInformCampaignsNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUpdateWithoutInformPartnerProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupUpdateOneWithoutInformCampaignsNestedInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignUpdateOneWithoutInformCampaignNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUpdateWithoutInformScheduledCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionUpdateManyWithoutInformCampaignNestedInput>;
  informCampaignGroup?: Maybe<InformCampaignGroupUpdateOneWithoutInformCampaignsNestedInput>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUpdateOneWithoutInformCampaignNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformCampaignsNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformCampaignStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  type?: Maybe<InformCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformCampaignVisibility>;
};

export type InformCampaignUpsertWithWhereUniqueWithoutInformAudienceDefinitionInput = {
  create: InformCampaignCreateWithoutInformAudienceDefinitionInput;
  update: InformCampaignUpdateWithoutInformAudienceDefinitionInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignUpsertWithWhereUniqueWithoutInformCampaignGroupInput = {
  create: InformCampaignCreateWithoutInformCampaignGroupInput;
  update: InformCampaignUpdateWithoutInformCampaignGroupInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignUpsertWithWhereUniqueWithoutInformPartnerProgramInput = {
  create: InformCampaignCreateWithoutInformPartnerProgramInput;
  update: InformCampaignUpdateWithoutInformPartnerProgramInput;
  where: InformCampaignWhereUniqueInput;
};

export type InformCampaignUpsertWithoutInformAutomationCampaignInput = {
  create: InformCampaignCreateWithoutInformAutomationCampaignInput;
  update: InformCampaignUpdateWithoutInformAutomationCampaignInput;
  where?: Maybe<InformCampaignWhereInput>;
};

export type InformCampaignUpsertWithoutInformCampaignEnrollmentsInput = {
  create: InformCampaignCreateWithoutInformCampaignEnrollmentsInput;
  update: InformCampaignUpdateWithoutInformCampaignEnrollmentsInput;
  where?: Maybe<InformCampaignWhereInput>;
};

export type InformCampaignUpsertWithoutInformCampaignExecutionsInput = {
  create: InformCampaignCreateWithoutInformCampaignExecutionsInput;
  update: InformCampaignUpdateWithoutInformCampaignExecutionsInput;
  where?: Maybe<InformCampaignWhereInput>;
};

export type InformCampaignUpsertWithoutInformEventDrivenCampaignInput = {
  create: InformCampaignCreateWithoutInformEventDrivenCampaignInput;
  update: InformCampaignUpdateWithoutInformEventDrivenCampaignInput;
  where?: Maybe<InformCampaignWhereInput>;
};

export type InformCampaignUpsertWithoutInformScheduledCampaignInput = {
  create: InformCampaignCreateWithoutInformScheduledCampaignInput;
  update: InformCampaignUpdateWithoutInformScheduledCampaignInput;
  where?: Maybe<InformCampaignWhereInput>;
};

export enum InformCampaignVisibility {
  Hidden = 'Hidden',
  Visible = 'Visible'
}

export type InformCampaignWhereInput = {
  AND?: Maybe<Array<InformCampaignWhereInput>>;
  NOT?: Maybe<Array<InformCampaignWhereInput>>;
  OR?: Maybe<Array<InformCampaignWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionScalarRelationFilter>;
  informAudienceDefinitionId?: Maybe<StringFilter>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignNullableScalarRelationFilter>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentListRelationFilter>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionListRelationFilter>;
  informCampaignGroup?: Maybe<InformCampaignGroupNullableScalarRelationFilter>;
  informCampaignGroupId?: Maybe<StringNullableFilter>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignNullableScalarRelationFilter>;
  informPartnerProgram?: Maybe<InformPartnerProgramScalarRelationFilter>;
  informPartnerProgramId?: Maybe<StringFilter>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignNullableScalarRelationFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<EnumInformCampaignStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumInformCampaignTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visibility?: Maybe<EnumInformCampaignVisibilityFilter>;
};

export type InformCampaignWhereUniqueInput = {
  AND?: Maybe<Array<InformCampaignWhereInput>>;
  NOT?: Maybe<Array<InformCampaignWhereInput>>;
  OR?: Maybe<Array<InformCampaignWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionScalarRelationFilter>;
  informAudienceDefinitionId?: Maybe<StringFilter>;
  informAutomationCampaign?: Maybe<InformAutomationCampaignNullableScalarRelationFilter>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentListRelationFilter>;
  informCampaignExecutions?: Maybe<InformCampaignExecutionListRelationFilter>;
  informCampaignGroup?: Maybe<InformCampaignGroupNullableScalarRelationFilter>;
  informCampaignGroupId?: Maybe<StringNullableFilter>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignNullableScalarRelationFilter>;
  informPartnerProgram?: Maybe<InformPartnerProgramScalarRelationFilter>;
  informPartnerProgramId?: Maybe<StringFilter>;
  informScheduledCampaign?: Maybe<InformScheduledCampaignNullableScalarRelationFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<EnumInformCampaignStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumInformCampaignTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visibility?: Maybe<EnumInformCampaignVisibilityFilter>;
};

export type InformCommunicationOptOut = {
  __typename?: 'InformCommunicationOptOut';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  scope: Scalars['String'];
  status: InformCommunicationOptOutStatus;
  target: Scalars['String'];
  targetType: InformScheduledCampaignCommunicationChannel;
  updatedAt: Scalars['DateTime'];
};

export type InformCommunicationOptOutCountAggregateOutputType = {
  __typename?: 'InformCommunicationOptOutCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  scope: Scalars['Int'];
  status: Scalars['Int'];
  target: Scalars['Int'];
  targetType: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformCommunicationOptOutCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scope?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCommunicationOptOutCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope: Scalars['String'];
  status: InformCommunicationOptOutStatus;
  target: Scalars['String'];
  targetType: InformScheduledCampaignCommunicationChannel;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCommunicationOptOutCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope: Scalars['String'];
  status: InformCommunicationOptOutStatus;
  target: Scalars['String'];
  targetType: InformScheduledCampaignCommunicationChannel;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCommunicationOptOutGroupByOutputType = {
  __typename?: 'InformCommunicationOptOutGroupByOutputType';
  _count?: Maybe<InformCommunicationOptOutCountAggregateOutputType>;
  _max?: Maybe<InformCommunicationOptOutMaxAggregateOutputType>;
  _min?: Maybe<InformCommunicationOptOutMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  scope: Scalars['String'];
  status: InformCommunicationOptOutStatus;
  target: Scalars['String'];
  targetType: InformScheduledCampaignCommunicationChannel;
  updatedAt: Scalars['DateTime'];
};

export type InformCommunicationOptOutMaxAggregateOutputType = {
  __typename?: 'InformCommunicationOptOutMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  status?: Maybe<InformCommunicationOptOutStatus>;
  target?: Maybe<Scalars['String']>;
  targetType?: Maybe<InformScheduledCampaignCommunicationChannel>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCommunicationOptOutMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scope?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCommunicationOptOutMinAggregateOutputType = {
  __typename?: 'InformCommunicationOptOutMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  status?: Maybe<InformCommunicationOptOutStatus>;
  target?: Maybe<Scalars['String']>;
  targetType?: Maybe<InformScheduledCampaignCommunicationChannel>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCommunicationOptOutMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scope?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCommunicationOptOutOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformCommunicationOptOutOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scope?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformCommunicationOptOutOrderByRelevanceFieldEnum {
  Id = 'id',
  Scope = 'scope',
  Target = 'target'
}

export type InformCommunicationOptOutOrderByRelevanceInput = {
  fields: Array<InformCommunicationOptOutOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformCommunicationOptOutOrderByWithAggregationInput = {
  _count?: Maybe<InformCommunicationOptOutCountOrderByAggregateInput>;
  _max?: Maybe<InformCommunicationOptOutMaxOrderByAggregateInput>;
  _min?: Maybe<InformCommunicationOptOutMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scope?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCommunicationOptOutOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformCommunicationOptOutOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scope?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformCommunicationOptOutOrderByWithRelationInput = {
  _relevance?: Maybe<InformCommunicationOptOutOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scope?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  target?: Maybe<SortOrder>;
  targetType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformCommunicationOptOutScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Scope = 'scope',
  Status = 'status',
  Target = 'target',
  TargetType = 'targetType',
  UpdatedAt = 'updatedAt'
}

export type InformCommunicationOptOutScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformCommunicationOptOutScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformCommunicationOptOutScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformCommunicationOptOutScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  scope?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumInformCommunicationOptOutStatusWithAggregatesFilter>;
  target?: Maybe<StringWithAggregatesFilter>;
  targetType?: Maybe<EnumInformScheduledCampaignCommunicationChannelWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformCommunicationOptOutStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type InformCommunicationOptOutTargetTypeTargetScopeCompoundUniqueInput = {
  scope: Scalars['String'];
  target: Scalars['String'];
  targetType: InformScheduledCampaignCommunicationChannel;
};

export type InformCommunicationOptOutUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope: Scalars['String'];
  status: InformCommunicationOptOutStatus;
  target: Scalars['String'];
  targetType: InformScheduledCampaignCommunicationChannel;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCommunicationOptOutUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  status?: Maybe<InformCommunicationOptOutStatus>;
  target?: Maybe<Scalars['String']>;
  targetType?: Maybe<InformScheduledCampaignCommunicationChannel>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCommunicationOptOutUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  status?: Maybe<InformCommunicationOptOutStatus>;
  target?: Maybe<Scalars['String']>;
  targetType?: Maybe<InformScheduledCampaignCommunicationChannel>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCommunicationOptOutUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  status?: Maybe<InformCommunicationOptOutStatus>;
  target?: Maybe<Scalars['String']>;
  targetType?: Maybe<InformScheduledCampaignCommunicationChannel>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCommunicationOptOutUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  status?: Maybe<InformCommunicationOptOutStatus>;
  target?: Maybe<Scalars['String']>;
  targetType?: Maybe<InformScheduledCampaignCommunicationChannel>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformCommunicationOptOutWhereInput = {
  AND?: Maybe<Array<InformCommunicationOptOutWhereInput>>;
  NOT?: Maybe<Array<InformCommunicationOptOutWhereInput>>;
  OR?: Maybe<Array<InformCommunicationOptOutWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  scope?: Maybe<StringFilter>;
  status?: Maybe<EnumInformCommunicationOptOutStatusFilter>;
  target?: Maybe<StringFilter>;
  targetType?: Maybe<EnumInformScheduledCampaignCommunicationChannelFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformCommunicationOptOutWhereUniqueInput = {
  AND?: Maybe<Array<InformCommunicationOptOutWhereInput>>;
  NOT?: Maybe<Array<InformCommunicationOptOutWhereInput>>;
  OR?: Maybe<Array<InformCommunicationOptOutWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<StringFilter>;
  status?: Maybe<EnumInformCommunicationOptOutStatusFilter>;
  target?: Maybe<StringFilter>;
  targetType?: Maybe<EnumInformScheduledCampaignCommunicationChannelFilter>;
  targetType_target_scope?: Maybe<InformCommunicationOptOutTargetTypeTargetScopeCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum InformControlGroupEntityType {
  InformCampaign = 'InformCampaign',
  InformCampaignGroup = 'InformCampaignGroup',
  InformPartnerProgram = 'InformPartnerProgram'
}

export type InformControlGroupParticipant = {
  __typename?: 'InformControlGroupParticipant';
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  controlGroupEntityId: Scalars['String'];
  controlGroupEntityType: InformControlGroupEntityType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type InformControlGroupParticipantCountAggregateOutputType = {
  __typename?: 'InformControlGroupParticipantCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  controlGroupEntityId: Scalars['Int'];
  controlGroupEntityType: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformControlGroupParticipantCountOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  controlGroupEntityId?: Maybe<SortOrder>;
  controlGroupEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformControlGroupParticipantCreateInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInformControlGroupParticipantsInput;
  controlGroupEntityId: Scalars['String'];
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantCreateManyClinicPetParentInput = {
  controlGroupEntityId: Scalars['String'];
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantCreateManyClinicPetParentInputEnvelope = {
  data: Array<InformControlGroupParticipantCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformControlGroupParticipantCreateManyInput = {
  clinicPetParentId: Scalars['String'];
  controlGroupEntityId: Scalars['String'];
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<InformControlGroupParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformControlGroupParticipantCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InformControlGroupParticipantCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InformControlGroupParticipantCreateManyClinicPetParentInputEnvelope>;
};

export type InformControlGroupParticipantCreateOrConnectWithoutClinicPetParentInput = {
  create: InformControlGroupParticipantCreateWithoutClinicPetParentInput;
  where: InformControlGroupParticipantWhereUniqueInput;
};

export type InformControlGroupParticipantCreateWithoutClinicPetParentInput = {
  controlGroupEntityId: Scalars['String'];
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantGroupByOutputType = {
  __typename?: 'InformControlGroupParticipantGroupByOutputType';
  _count?: Maybe<InformControlGroupParticipantCountAggregateOutputType>;
  _max?: Maybe<InformControlGroupParticipantMaxAggregateOutputType>;
  _min?: Maybe<InformControlGroupParticipantMinAggregateOutputType>;
  clinicPetParentId: Scalars['String'];
  controlGroupEntityId: Scalars['String'];
  controlGroupEntityType: InformControlGroupEntityType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type InformControlGroupParticipantListRelationFilter = {
  every?: Maybe<InformControlGroupParticipantWhereInput>;
  none?: Maybe<InformControlGroupParticipantWhereInput>;
  some?: Maybe<InformControlGroupParticipantWhereInput>;
};

export type InformControlGroupParticipantMaxAggregateOutputType = {
  __typename?: 'InformControlGroupParticipantMaxAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  controlGroupEntityId?: Maybe<Scalars['String']>;
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantMaxOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  controlGroupEntityId?: Maybe<SortOrder>;
  controlGroupEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformControlGroupParticipantMinAggregateOutputType = {
  __typename?: 'InformControlGroupParticipantMinAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  controlGroupEntityId?: Maybe<Scalars['String']>;
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantMinOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  controlGroupEntityId?: Maybe<SortOrder>;
  controlGroupEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformControlGroupParticipantOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformControlGroupParticipantOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformControlGroupParticipantOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  controlGroupEntityId?: Maybe<SortOrder>;
  controlGroupEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformControlGroupParticipantOrderByRelevanceFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  ControlGroupEntityId = 'controlGroupEntityId',
  Id = 'id'
}

export type InformControlGroupParticipantOrderByRelevanceInput = {
  fields: Array<InformControlGroupParticipantOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformControlGroupParticipantOrderByWithAggregationInput = {
  _count?: Maybe<InformControlGroupParticipantCountOrderByAggregateInput>;
  _max?: Maybe<InformControlGroupParticipantMaxOrderByAggregateInput>;
  _min?: Maybe<InformControlGroupParticipantMinOrderByAggregateInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  controlGroupEntityId?: Maybe<SortOrder>;
  controlGroupEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformControlGroupParticipantOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformControlGroupParticipantOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  controlGroupEntityId?: Maybe<SortOrder>;
  controlGroupEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformControlGroupParticipantOrderByWithRelationInput = {
  _relevance?: Maybe<InformControlGroupParticipantOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  controlGroupEntityId?: Maybe<SortOrder>;
  controlGroupEntityType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformControlGroupParticipantScalarFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  ControlGroupEntityId = 'controlGroupEntityId',
  ControlGroupEntityType = 'controlGroupEntityType',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  UpdatedAt = 'updatedAt'
}

export type InformControlGroupParticipantScalarWhereInput = {
  AND?: Maybe<Array<InformControlGroupParticipantScalarWhereInput>>;
  NOT?: Maybe<Array<InformControlGroupParticipantScalarWhereInput>>;
  OR?: Maybe<Array<InformControlGroupParticipantScalarWhereInput>>;
  clinicPetParentId?: Maybe<StringFilter>;
  controlGroupEntityId?: Maybe<StringFilter>;
  controlGroupEntityType?: Maybe<EnumInformControlGroupEntityTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformControlGroupParticipantScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformControlGroupParticipantScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformControlGroupParticipantScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformControlGroupParticipantScalarWhereWithAggregatesInput>>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  controlGroupEntityId?: Maybe<StringWithAggregatesFilter>;
  controlGroupEntityType?: Maybe<EnumInformControlGroupEntityTypeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type InformControlGroupParticipantUncheckedCreateInput = {
  clinicPetParentId: Scalars['String'];
  controlGroupEntityId: Scalars['String'];
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<InformControlGroupParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformControlGroupParticipantCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InformControlGroupParticipantCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InformControlGroupParticipantCreateManyClinicPetParentInputEnvelope>;
};

export type InformControlGroupParticipantUncheckedCreateWithoutClinicPetParentInput = {
  controlGroupEntityId: Scalars['String'];
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantUncheckedUpdateInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  controlGroupEntityId?: Maybe<Scalars['String']>;
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantUncheckedUpdateManyInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  controlGroupEntityId?: Maybe<Scalars['String']>;
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentInput = {
  controlGroupEntityId?: Maybe<Scalars['String']>;
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<InformControlGroupParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformControlGroupParticipantCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InformControlGroupParticipantCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InformControlGroupParticipantCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<InformControlGroupParticipantWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformControlGroupParticipantScalarWhereInput>>;
  disconnect?: Maybe<Array<InformControlGroupParticipantWhereUniqueInput>>;
  set?: Maybe<Array<InformControlGroupParticipantWhereUniqueInput>>;
  update?: Maybe<Array<InformControlGroupParticipantUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<InformControlGroupParticipantUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<InformControlGroupParticipantUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type InformControlGroupParticipantUncheckedUpdateWithoutClinicPetParentInput = {
  controlGroupEntityId?: Maybe<Scalars['String']>;
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantUpdateInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInformControlGroupParticipantsNestedInput>;
  controlGroupEntityId?: Maybe<Scalars['String']>;
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantUpdateManyMutationInput = {
  controlGroupEntityId?: Maybe<Scalars['String']>;
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: InformControlGroupParticipantUpdateManyMutationInput;
  where: InformControlGroupParticipantScalarWhereInput;
};

export type InformControlGroupParticipantUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<InformControlGroupParticipantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformControlGroupParticipantCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InformControlGroupParticipantCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InformControlGroupParticipantCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<InformControlGroupParticipantWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformControlGroupParticipantScalarWhereInput>>;
  disconnect?: Maybe<Array<InformControlGroupParticipantWhereUniqueInput>>;
  set?: Maybe<Array<InformControlGroupParticipantWhereUniqueInput>>;
  update?: Maybe<Array<InformControlGroupParticipantUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<InformControlGroupParticipantUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<InformControlGroupParticipantUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type InformControlGroupParticipantUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: InformControlGroupParticipantUpdateWithoutClinicPetParentInput;
  where: InformControlGroupParticipantWhereUniqueInput;
};

export type InformControlGroupParticipantUpdateWithoutClinicPetParentInput = {
  controlGroupEntityId?: Maybe<Scalars['String']>;
  controlGroupEntityType?: Maybe<InformControlGroupEntityType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformControlGroupParticipantUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: InformControlGroupParticipantCreateWithoutClinicPetParentInput;
  update: InformControlGroupParticipantUpdateWithoutClinicPetParentInput;
  where: InformControlGroupParticipantWhereUniqueInput;
};

export type InformControlGroupParticipantWhereInput = {
  AND?: Maybe<Array<InformControlGroupParticipantWhereInput>>;
  NOT?: Maybe<Array<InformControlGroupParticipantWhereInput>>;
  OR?: Maybe<Array<InformControlGroupParticipantWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  controlGroupEntityId?: Maybe<StringFilter>;
  controlGroupEntityType?: Maybe<EnumInformControlGroupEntityTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformControlGroupParticipantWhereUniqueInput = {
  AND?: Maybe<Array<InformControlGroupParticipantWhereInput>>;
  NOT?: Maybe<Array<InformControlGroupParticipantWhereInput>>;
  OR?: Maybe<Array<InformControlGroupParticipantWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  controlGroupEntityId?: Maybe<StringFilter>;
  controlGroupEntityType?: Maybe<EnumInformControlGroupEntityTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformEmailTemplate = {
  __typename?: 'InformEmailTemplate';
  _count: InformEmailTemplateCountOutputType;
  createdAt: Scalars['DateTime'];
  history: Array<Scalars['Json']>;
  htmlContent?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartner?: Maybe<InformPartner>;
  informPartnerId?: Maybe<Scalars['String']>;
  informScheduledCampaigns: Array<InformScheduledCampaign>;
  name: Scalars['String'];
  status: InformEmailTemplateStatus;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};


export type InformEmailTemplateInformPartnerArgs = {
  where?: Maybe<InformPartnerWhereInput>;
};


export type InformEmailTemplateInformScheduledCampaignsArgs = {
  cursor?: Maybe<InformScheduledCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformScheduledCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformScheduledCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformScheduledCampaignWhereInput>;
};

export type InformEmailTemplateCountAggregateOutputType = {
  __typename?: 'InformEmailTemplateCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  history: Scalars['Int'];
  htmlContent: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerId: Scalars['Int'];
  name: Scalars['Int'];
  status: Scalars['Int'];
  unlayerJson: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformEmailTemplateCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  history?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformEmailTemplateCountOutputType = {
  __typename?: 'InformEmailTemplateCountOutputType';
  informScheduledCampaigns: Scalars['Int'];
};

export type InformEmailTemplateCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutInformEmailTemplatesInput>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignCreateNestedManyWithoutInformEmailTemplateInput>;
  name: Scalars['String'];
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateCreateManyInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateCreateManyInformPartnerInputEnvelope = {
  data: Array<InformEmailTemplateCreateManyInformPartnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformEmailTemplateCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformEmailTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformEmailTemplateCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformEmailTemplateCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformEmailTemplateCreateManyInformPartnerInputEnvelope>;
};

export type InformEmailTemplateCreateNestedOneWithoutInformScheduledCampaignsInput = {
  connect?: Maybe<InformEmailTemplateWhereUniqueInput>;
  connectOrCreate?: Maybe<InformEmailTemplateCreateOrConnectWithoutInformScheduledCampaignsInput>;
  create?: Maybe<InformEmailTemplateCreateWithoutInformScheduledCampaignsInput>;
};

export type InformEmailTemplateCreateOrConnectWithoutInformPartnerInput = {
  create: InformEmailTemplateCreateWithoutInformPartnerInput;
  where: InformEmailTemplateWhereUniqueInput;
};

export type InformEmailTemplateCreateOrConnectWithoutInformScheduledCampaignsInput = {
  create: InformEmailTemplateCreateWithoutInformScheduledCampaignsInput;
  where: InformEmailTemplateWhereUniqueInput;
};

export type InformEmailTemplateCreateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignCreateNestedManyWithoutInformEmailTemplateInput>;
  name: Scalars['String'];
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateCreateWithoutInformScheduledCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutInformEmailTemplatesInput>;
  name: Scalars['String'];
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateCreatehistoryInput = {
  set: Array<Scalars['Json']>;
};

export type InformEmailTemplateGroupByOutputType = {
  __typename?: 'InformEmailTemplateGroupByOutputType';
  _count?: Maybe<InformEmailTemplateCountAggregateOutputType>;
  _max?: Maybe<InformEmailTemplateMaxAggregateOutputType>;
  _min?: Maybe<InformEmailTemplateMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: InformEmailTemplateStatus;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type InformEmailTemplateListRelationFilter = {
  every?: Maybe<InformEmailTemplateWhereInput>;
  none?: Maybe<InformEmailTemplateWhereInput>;
  some?: Maybe<InformEmailTemplateWhereInput>;
};

export type InformEmailTemplateMaxAggregateOutputType = {
  __typename?: 'InformEmailTemplateMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformEmailTemplateStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformEmailTemplateMinAggregateOutputType = {
  __typename?: 'InformEmailTemplateMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformEmailTemplateStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformEmailTemplateNameInformPartnerIdCompoundUniqueInput = {
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
};

export type InformEmailTemplateNullableScalarRelationFilter = {
  AND?: Maybe<Array<InformEmailTemplateWhereInput>>;
  NOT?: Maybe<Array<InformEmailTemplateWhereInput>>;
  OR?: Maybe<Array<InformEmailTemplateWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  history?: Maybe<JsonNullableListFilter>;
  htmlContent?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartner?: Maybe<InformPartnerNullableScalarRelationFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignListRelationFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<EnumInformEmailTemplateStatusFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformEmailTemplateOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformEmailTemplateOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformEmailTemplateOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  history?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformEmailTemplateOrderByRelevanceFieldEnum {
  HtmlContent = 'htmlContent',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  Name = 'name'
}

export type InformEmailTemplateOrderByRelevanceInput = {
  fields: Array<InformEmailTemplateOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformEmailTemplateOrderByWithAggregationInput = {
  _count?: Maybe<InformEmailTemplateCountOrderByAggregateInput>;
  _max?: Maybe<InformEmailTemplateMaxOrderByAggregateInput>;
  _min?: Maybe<InformEmailTemplateMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  history?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformEmailTemplateOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformEmailTemplateOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  history?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformEmailTemplateOrderByWithRelationInput = {
  _relevance?: Maybe<InformEmailTemplateOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  history?: Maybe<SortOrder>;
  htmlContent?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformEmailTemplateScalarFieldEnum {
  CreatedAt = 'createdAt',
  History = 'history',
  HtmlContent = 'htmlContent',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  Name = 'name',
  Status = 'status',
  UnlayerJson = 'unlayerJson',
  UpdatedAt = 'updatedAt'
}

export type InformEmailTemplateScalarWhereInput = {
  AND?: Maybe<Array<InformEmailTemplateScalarWhereInput>>;
  NOT?: Maybe<Array<InformEmailTemplateScalarWhereInput>>;
  OR?: Maybe<Array<InformEmailTemplateScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  history?: Maybe<JsonNullableListFilter>;
  htmlContent?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<EnumInformEmailTemplateStatusFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformEmailTemplateScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformEmailTemplateScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformEmailTemplateScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformEmailTemplateScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  history?: Maybe<JsonNullableListFilter>;
  htmlContent?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerId?: Maybe<StringNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumInformEmailTemplateStatusWithAggregatesFilter>;
  unlayerJson?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformEmailTemplateStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export type InformEmailTemplateUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignUncheckedCreateNestedManyWithoutInformEmailTemplateInput>;
  name: Scalars['String'];
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateUncheckedCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformEmailTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformEmailTemplateCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformEmailTemplateCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformEmailTemplateCreateManyInformPartnerInputEnvelope>;
};

export type InformEmailTemplateUncheckedCreateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignUncheckedCreateNestedManyWithoutInformEmailTemplateInput>;
  name: Scalars['String'];
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateUncheckedCreateWithoutInformScheduledCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignUncheckedUpdateManyWithoutInformEmailTemplateNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateUncheckedUpdateManyWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateUncheckedUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformEmailTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformEmailTemplateCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformEmailTemplateCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformEmailTemplateCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformEmailTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformEmailTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<InformEmailTemplateWhereUniqueInput>>;
  set?: Maybe<Array<InformEmailTemplateWhereUniqueInput>>;
  update?: Maybe<Array<InformEmailTemplateUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformEmailTemplateUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformEmailTemplateUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformEmailTemplateUncheckedUpdateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignUncheckedUpdateManyWithoutInformEmailTemplateNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateUncheckedUpdateWithoutInformScheduledCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutInformEmailTemplatesNestedInput>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignUpdateManyWithoutInformEmailTemplateNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateUpdateManyWithWhereWithoutInformPartnerInput = {
  data: InformEmailTemplateUpdateManyMutationInput;
  where: InformEmailTemplateScalarWhereInput;
};

export type InformEmailTemplateUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformEmailTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformEmailTemplateCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformEmailTemplateCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformEmailTemplateCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformEmailTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformEmailTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<InformEmailTemplateWhereUniqueInput>>;
  set?: Maybe<Array<InformEmailTemplateWhereUniqueInput>>;
  update?: Maybe<Array<InformEmailTemplateUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformEmailTemplateUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformEmailTemplateUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformEmailTemplateUpdateOneWithoutInformScheduledCampaignsNestedInput = {
  connect?: Maybe<InformEmailTemplateWhereUniqueInput>;
  connectOrCreate?: Maybe<InformEmailTemplateCreateOrConnectWithoutInformScheduledCampaignsInput>;
  create?: Maybe<InformEmailTemplateCreateWithoutInformScheduledCampaignsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformEmailTemplateUpdateToOneWithWhereWithoutInformScheduledCampaignsInput>;
  upsert?: Maybe<InformEmailTemplateUpsertWithoutInformScheduledCampaignsInput>;
};

export type InformEmailTemplateUpdateToOneWithWhereWithoutInformScheduledCampaignsInput = {
  data: InformEmailTemplateUpdateWithoutInformScheduledCampaignsInput;
  where?: Maybe<InformEmailTemplateWhereInput>;
};

export type InformEmailTemplateUpdateWithWhereUniqueWithoutInformPartnerInput = {
  data: InformEmailTemplateUpdateWithoutInformPartnerInput;
  where: InformEmailTemplateWhereUniqueInput;
};

export type InformEmailTemplateUpdateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignUpdateManyWithoutInformEmailTemplateNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateUpdateWithoutInformScheduledCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<Scalars['Json']>>;
  htmlContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutInformEmailTemplatesNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformEmailTemplateStatus>;
  unlayerJson?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEmailTemplateUpdatehistoryInput = {
  push?: Maybe<Array<Scalars['Json']>>;
  set?: Maybe<Array<Scalars['Json']>>;
};

export type InformEmailTemplateUpsertWithWhereUniqueWithoutInformPartnerInput = {
  create: InformEmailTemplateCreateWithoutInformPartnerInput;
  update: InformEmailTemplateUpdateWithoutInformPartnerInput;
  where: InformEmailTemplateWhereUniqueInput;
};

export type InformEmailTemplateUpsertWithoutInformScheduledCampaignsInput = {
  create: InformEmailTemplateCreateWithoutInformScheduledCampaignsInput;
  update: InformEmailTemplateUpdateWithoutInformScheduledCampaignsInput;
  where?: Maybe<InformEmailTemplateWhereInput>;
};

export type InformEmailTemplateWhereInput = {
  AND?: Maybe<Array<InformEmailTemplateWhereInput>>;
  NOT?: Maybe<Array<InformEmailTemplateWhereInput>>;
  OR?: Maybe<Array<InformEmailTemplateWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  history?: Maybe<JsonNullableListFilter>;
  htmlContent?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartner?: Maybe<InformPartnerNullableScalarRelationFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignListRelationFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<EnumInformEmailTemplateStatusFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformEmailTemplateWhereUniqueInput = {
  AND?: Maybe<Array<InformEmailTemplateWhereInput>>;
  NOT?: Maybe<Array<InformEmailTemplateWhereInput>>;
  OR?: Maybe<Array<InformEmailTemplateWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  history?: Maybe<JsonNullableListFilter>;
  htmlContent?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerNullableScalarRelationFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  informScheduledCampaigns?: Maybe<InformScheduledCampaignListRelationFilter>;
  name?: Maybe<StringFilter>;
  name_informPartnerId?: Maybe<InformEmailTemplateNameInformPartnerIdCompoundUniqueInput>;
  status?: Maybe<EnumInformEmailTemplateStatusFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum InformEnrollmentStatus {
  Active = 'Active',
  Archived = 'Archived',
  Canceled = 'Canceled',
  NeedsReview = 'NeedsReview',
  NotEnrolled = 'NotEnrolled',
  NotMigrated = 'NotMigrated',
  Onboarding = 'Onboarding',
  Paused = 'Paused'
}

export type InformEntityHistory = {
  __typename?: 'InformEntityHistory';
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  id: Scalars['String'];
  state: Scalars['Json'];
};

export type InformEntityHistoryCountAggregateOutputType = {
  __typename?: 'InformEntityHistoryCountAggregateOutputType';
  _all: Scalars['Int'];
  authorId: Scalars['Int'];
  authorType: Scalars['Int'];
  createdAt: Scalars['Int'];
  entityId: Scalars['Int'];
  entityType: Scalars['Int'];
  id: Scalars['Int'];
  state: Scalars['Int'];
};

export type InformEntityHistoryCountOrderByAggregateInput = {
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
};

export type InformEntityHistoryCreateInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  state: Scalars['Json'];
};

export type InformEntityHistoryCreateManyInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  state: Scalars['Json'];
};

export type InformEntityHistoryGroupByOutputType = {
  __typename?: 'InformEntityHistoryGroupByOutputType';
  _count?: Maybe<InformEntityHistoryCountAggregateOutputType>;
  _max?: Maybe<InformEntityHistoryMaxAggregateOutputType>;
  _min?: Maybe<InformEntityHistoryMinAggregateOutputType>;
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  id: Scalars['String'];
  state: Scalars['Json'];
};

export type InformEntityHistoryMaxAggregateOutputType = {
  __typename?: 'InformEntityHistoryMaxAggregateOutputType';
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type InformEntityHistoryMaxOrderByAggregateInput = {
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type InformEntityHistoryMinAggregateOutputType = {
  __typename?: 'InformEntityHistoryMinAggregateOutputType';
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type InformEntityHistoryMinOrderByAggregateInput = {
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type InformEntityHistoryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformEntityHistoryOrderByRelevanceInput>;
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
};

export enum InformEntityHistoryOrderByRelevanceFieldEnum {
  AuthorId = 'authorId',
  AuthorType = 'authorType',
  EntityId = 'entityId',
  EntityType = 'entityType',
  Id = 'id'
}

export type InformEntityHistoryOrderByRelevanceInput = {
  fields: Array<InformEntityHistoryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformEntityHistoryOrderByWithAggregationInput = {
  _count?: Maybe<InformEntityHistoryCountOrderByAggregateInput>;
  _max?: Maybe<InformEntityHistoryMaxOrderByAggregateInput>;
  _min?: Maybe<InformEntityHistoryMinOrderByAggregateInput>;
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
};

export type InformEntityHistoryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformEntityHistoryOrderByRelevanceInput>;
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
};

export type InformEntityHistoryOrderByWithRelationInput = {
  _relevance?: Maybe<InformEntityHistoryOrderByRelevanceInput>;
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
};

export enum InformEntityHistoryScalarFieldEnum {
  AuthorId = 'authorId',
  AuthorType = 'authorType',
  CreatedAt = 'createdAt',
  EntityId = 'entityId',
  EntityType = 'entityType',
  Id = 'id',
  State = 'state'
}

export type InformEntityHistoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformEntityHistoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformEntityHistoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformEntityHistoryScalarWhereWithAggregatesInput>>;
  authorId?: Maybe<StringNullableWithAggregatesFilter>;
  authorType?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  entityId?: Maybe<StringWithAggregatesFilter>;
  entityType?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  state?: Maybe<JsonWithAggregatesFilter>;
};

export type InformEntityHistoryUncheckedCreateInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  state: Scalars['Json'];
};

export type InformEntityHistoryUncheckedUpdateInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['Json']>;
};

export type InformEntityHistoryUncheckedUpdateManyInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['Json']>;
};

export type InformEntityHistoryUpdateInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['Json']>;
};

export type InformEntityHistoryUpdateManyMutationInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['Json']>;
};

export type InformEntityHistoryWhereInput = {
  AND?: Maybe<Array<InformEntityHistoryWhereInput>>;
  NOT?: Maybe<Array<InformEntityHistoryWhereInput>>;
  OR?: Maybe<Array<InformEntityHistoryWhereInput>>;
  authorId?: Maybe<StringNullableFilter>;
  authorType?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entityId?: Maybe<StringFilter>;
  entityType?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  state?: Maybe<JsonFilter>;
};

export type InformEntityHistoryWhereUniqueInput = {
  AND?: Maybe<Array<InformEntityHistoryWhereInput>>;
  NOT?: Maybe<Array<InformEntityHistoryWhereInput>>;
  OR?: Maybe<Array<InformEntityHistoryWhereInput>>;
  authorId?: Maybe<StringNullableFilter>;
  authorType?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entityId?: Maybe<StringFilter>;
  entityType?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  state?: Maybe<JsonFilter>;
};

export enum InformEntityUpdatedByType {
  InformPartnerUser = 'InformPartnerUser',
  System = 'System',
  User = 'User'
}

export type InformEventDrivenCampaign = {
  __typename?: 'InformEventDrivenCampaign';
  _count: InformEventDrivenCampaignCountOutputType;
  eventListeners: Array<InformEventListener>;
  id: Scalars['String'];
  informCampaign: InformCampaign;
  settings?: Maybe<Scalars['Json']>;
};


export type InformEventDrivenCampaignEventListenersArgs = {
  cursor?: Maybe<InformEventListenerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEventListenerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEventListenerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEventListenerWhereInput>;
};

export type InformEventDrivenCampaignCountAggregateOutputType = {
  __typename?: 'InformEventDrivenCampaignCountAggregateOutputType';
  _all: Scalars['Int'];
  id: Scalars['Int'];
  settings: Scalars['Int'];
};

export type InformEventDrivenCampaignCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
};

export type InformEventDrivenCampaignCountOutputType = {
  __typename?: 'InformEventDrivenCampaignCountOutputType';
  eventListeners: Scalars['Int'];
};

export type InformEventDrivenCampaignCreateInput = {
  eventListeners?: Maybe<InformEventListenerCreateNestedManyWithoutInformEventDrivenCampaignInput>;
  informCampaign: InformCampaignCreateNestedOneWithoutInformEventDrivenCampaignInput;
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignCreateManyInput = {
  id: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignCreateNestedOneWithoutEventListenersInput = {
  connect?: Maybe<InformEventDrivenCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformEventDrivenCampaignCreateOrConnectWithoutEventListenersInput>;
  create?: Maybe<InformEventDrivenCampaignCreateWithoutEventListenersInput>;
};

export type InformEventDrivenCampaignCreateNestedOneWithoutInformCampaignInput = {
  connect?: Maybe<InformEventDrivenCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformEventDrivenCampaignCreateOrConnectWithoutInformCampaignInput>;
  create?: Maybe<InformEventDrivenCampaignCreateWithoutInformCampaignInput>;
};

export type InformEventDrivenCampaignCreateOrConnectWithoutEventListenersInput = {
  create: InformEventDrivenCampaignCreateWithoutEventListenersInput;
  where: InformEventDrivenCampaignWhereUniqueInput;
};

export type InformEventDrivenCampaignCreateOrConnectWithoutInformCampaignInput = {
  create: InformEventDrivenCampaignCreateWithoutInformCampaignInput;
  where: InformEventDrivenCampaignWhereUniqueInput;
};

export type InformEventDrivenCampaignCreateWithoutEventListenersInput = {
  informCampaign: InformCampaignCreateNestedOneWithoutInformEventDrivenCampaignInput;
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignCreateWithoutInformCampaignInput = {
  eventListeners?: Maybe<InformEventListenerCreateNestedManyWithoutInformEventDrivenCampaignInput>;
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignGroupByOutputType = {
  __typename?: 'InformEventDrivenCampaignGroupByOutputType';
  _count?: Maybe<InformEventDrivenCampaignCountAggregateOutputType>;
  _max?: Maybe<InformEventDrivenCampaignMaxAggregateOutputType>;
  _min?: Maybe<InformEventDrivenCampaignMinAggregateOutputType>;
  id: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignMaxAggregateOutputType = {
  __typename?: 'InformEventDrivenCampaignMaxAggregateOutputType';
  id?: Maybe<Scalars['String']>;
};

export type InformEventDrivenCampaignMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type InformEventDrivenCampaignMinAggregateOutputType = {
  __typename?: 'InformEventDrivenCampaignMinAggregateOutputType';
  id?: Maybe<Scalars['String']>;
};

export type InformEventDrivenCampaignMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type InformEventDrivenCampaignNullableScalarRelationFilter = {
  AND?: Maybe<Array<InformEventDrivenCampaignWhereInput>>;
  NOT?: Maybe<Array<InformEventDrivenCampaignWhereInput>>;
  OR?: Maybe<Array<InformEventDrivenCampaignWhereInput>>;
  eventListeners?: Maybe<InformEventListenerListRelationFilter>;
  id?: Maybe<StringFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  settings?: Maybe<JsonNullableFilter>;
};

export type InformEventDrivenCampaignOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformEventDrivenCampaignOrderByRelevanceInput>;
  eventListeners?: Maybe<InformEventListenerOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  settings?: Maybe<SortOrder>;
};

export enum InformEventDrivenCampaignOrderByRelevanceFieldEnum {
  Id = 'id'
}

export type InformEventDrivenCampaignOrderByRelevanceInput = {
  fields: Array<InformEventDrivenCampaignOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformEventDrivenCampaignOrderByWithAggregationInput = {
  _count?: Maybe<InformEventDrivenCampaignCountOrderByAggregateInput>;
  _max?: Maybe<InformEventDrivenCampaignMaxOrderByAggregateInput>;
  _min?: Maybe<InformEventDrivenCampaignMinOrderByAggregateInput>;
  id?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
};

export type InformEventDrivenCampaignOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformEventDrivenCampaignOrderByRelevanceInput>;
  eventListeners?: Maybe<InformEventListenerOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  settings?: Maybe<SortOrder>;
};

export type InformEventDrivenCampaignOrderByWithRelationInput = {
  _relevance?: Maybe<InformEventDrivenCampaignOrderByRelevanceInput>;
  eventListeners?: Maybe<InformEventListenerOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  settings?: Maybe<SortOrder>;
};

export enum InformEventDrivenCampaignScalarFieldEnum {
  Id = 'id',
  Settings = 'settings'
}

export type InformEventDrivenCampaignScalarRelationFilter = {
  AND?: Maybe<Array<InformEventDrivenCampaignWhereInput>>;
  NOT?: Maybe<Array<InformEventDrivenCampaignWhereInput>>;
  OR?: Maybe<Array<InformEventDrivenCampaignWhereInput>>;
  eventListeners?: Maybe<InformEventListenerListRelationFilter>;
  id?: Maybe<StringFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  settings?: Maybe<JsonNullableFilter>;
};

export type InformEventDrivenCampaignScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformEventDrivenCampaignScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformEventDrivenCampaignScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformEventDrivenCampaignScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
};

export type InformEventDrivenCampaignUncheckedCreateInput = {
  eventListeners?: Maybe<InformEventListenerUncheckedCreateNestedManyWithoutInformEventDrivenCampaignInput>;
  id: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignUncheckedCreateNestedOneWithoutInformCampaignInput = {
  connect?: Maybe<InformEventDrivenCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformEventDrivenCampaignCreateOrConnectWithoutInformCampaignInput>;
  create?: Maybe<InformEventDrivenCampaignCreateWithoutInformCampaignInput>;
};

export type InformEventDrivenCampaignUncheckedCreateWithoutEventListenersInput = {
  id: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignUncheckedCreateWithoutInformCampaignInput = {
  eventListeners?: Maybe<InformEventListenerUncheckedCreateNestedManyWithoutInformEventDrivenCampaignInput>;
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignUncheckedUpdateInput = {
  eventListeners?: Maybe<InformEventListenerUncheckedUpdateManyWithoutInformEventDrivenCampaignNestedInput>;
  id?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignUncheckedUpdateManyInput = {
  id?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput = {
  connect?: Maybe<InformEventDrivenCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformEventDrivenCampaignCreateOrConnectWithoutInformCampaignInput>;
  create?: Maybe<InformEventDrivenCampaignCreateWithoutInformCampaignInput>;
  delete?: Maybe<InformEventDrivenCampaignWhereInput>;
  disconnect?: Maybe<InformEventDrivenCampaignWhereInput>;
  update?: Maybe<InformEventDrivenCampaignUpdateToOneWithWhereWithoutInformCampaignInput>;
  upsert?: Maybe<InformEventDrivenCampaignUpsertWithoutInformCampaignInput>;
};

export type InformEventDrivenCampaignUncheckedUpdateWithoutEventListenersInput = {
  id?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignUncheckedUpdateWithoutInformCampaignInput = {
  eventListeners?: Maybe<InformEventListenerUncheckedUpdateManyWithoutInformEventDrivenCampaignNestedInput>;
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignUpdateInput = {
  eventListeners?: Maybe<InformEventListenerUpdateManyWithoutInformEventDrivenCampaignNestedInput>;
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformEventDrivenCampaignNestedInput>;
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignUpdateManyMutationInput = {
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignUpdateOneRequiredWithoutEventListenersNestedInput = {
  connect?: Maybe<InformEventDrivenCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformEventDrivenCampaignCreateOrConnectWithoutEventListenersInput>;
  create?: Maybe<InformEventDrivenCampaignCreateWithoutEventListenersInput>;
  update?: Maybe<InformEventDrivenCampaignUpdateToOneWithWhereWithoutEventListenersInput>;
  upsert?: Maybe<InformEventDrivenCampaignUpsertWithoutEventListenersInput>;
};

export type InformEventDrivenCampaignUpdateOneWithoutInformCampaignNestedInput = {
  connect?: Maybe<InformEventDrivenCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformEventDrivenCampaignCreateOrConnectWithoutInformCampaignInput>;
  create?: Maybe<InformEventDrivenCampaignCreateWithoutInformCampaignInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformEventDrivenCampaignUpdateToOneWithWhereWithoutInformCampaignInput>;
  upsert?: Maybe<InformEventDrivenCampaignUpsertWithoutInformCampaignInput>;
};

export type InformEventDrivenCampaignUpdateToOneWithWhereWithoutEventListenersInput = {
  data: InformEventDrivenCampaignUpdateWithoutEventListenersInput;
  where?: Maybe<InformEventDrivenCampaignWhereInput>;
};

export type InformEventDrivenCampaignUpdateToOneWithWhereWithoutInformCampaignInput = {
  data: InformEventDrivenCampaignUpdateWithoutInformCampaignInput;
  where?: Maybe<InformEventDrivenCampaignWhereInput>;
};

export type InformEventDrivenCampaignUpdateWithoutEventListenersInput = {
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformEventDrivenCampaignNestedInput>;
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignUpdateWithoutInformCampaignInput = {
  eventListeners?: Maybe<InformEventListenerUpdateManyWithoutInformEventDrivenCampaignNestedInput>;
  settings?: Maybe<Scalars['Json']>;
};

export type InformEventDrivenCampaignUpsertWithoutEventListenersInput = {
  create: InformEventDrivenCampaignCreateWithoutEventListenersInput;
  update: InformEventDrivenCampaignUpdateWithoutEventListenersInput;
  where?: Maybe<InformEventDrivenCampaignWhereInput>;
};

export type InformEventDrivenCampaignUpsertWithoutInformCampaignInput = {
  create: InformEventDrivenCampaignCreateWithoutInformCampaignInput;
  update: InformEventDrivenCampaignUpdateWithoutInformCampaignInput;
  where?: Maybe<InformEventDrivenCampaignWhereInput>;
};

export type InformEventDrivenCampaignWhereInput = {
  AND?: Maybe<Array<InformEventDrivenCampaignWhereInput>>;
  NOT?: Maybe<Array<InformEventDrivenCampaignWhereInput>>;
  OR?: Maybe<Array<InformEventDrivenCampaignWhereInput>>;
  eventListeners?: Maybe<InformEventListenerListRelationFilter>;
  id?: Maybe<StringFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  settings?: Maybe<JsonNullableFilter>;
};

export type InformEventDrivenCampaignWhereUniqueInput = {
  AND?: Maybe<Array<InformEventDrivenCampaignWhereInput>>;
  NOT?: Maybe<Array<InformEventDrivenCampaignWhereInput>>;
  OR?: Maybe<Array<InformEventDrivenCampaignWhereInput>>;
  eventListeners?: Maybe<InformEventListenerListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  settings?: Maybe<JsonNullableFilter>;
};

export type InformEventListener = {
  __typename?: 'InformEventListener';
  _count: InformEventListenerCountOutputType;
  childEventListeners: Array<InformEventListener>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  events: Array<InformSessionEvent>;
  id: Scalars['String'];
  informEventDrivenCampaign: InformEventDrivenCampaign;
  informEventDrivenCampaignId: Scalars['String'];
  name: Scalars['String'];
  parentEventListener?: Maybe<InformEventListener>;
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings: Scalars['Json'];
  updatedAt: Scalars['DateTime'];
};


export type InformEventListenerChildEventListenersArgs = {
  cursor?: Maybe<InformEventListenerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEventListenerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEventListenerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEventListenerWhereInput>;
};


export type InformEventListenerEventsArgs = {
  cursor?: Maybe<InformSessionEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformSessionEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformSessionEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionEventWhereInput>;
};


export type InformEventListenerParentEventListenerArgs = {
  where?: Maybe<InformEventListenerWhereInput>;
};

export type InformEventListenerCountAggregateOutputType = {
  __typename?: 'InformEventListenerCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  informEventDrivenCampaignId: Scalars['Int'];
  name: Scalars['Int'];
  parentInformEventListenerId: Scalars['Int'];
  settings: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformEventListenerCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informEventDrivenCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentInformEventListenerId?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformEventListenerCountOutputType = {
  __typename?: 'InformEventListenerCountOutputType';
  childEventListeners: Scalars['Int'];
  events: Scalars['Int'];
};

export type InformEventListenerCreateInput = {
  childEventListeners?: Maybe<InformEventListenerCreateNestedManyWithoutParentEventListenerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventCreateNestedManyWithoutEventListenerInput>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaign: InformEventDrivenCampaignCreateNestedOneWithoutEventListenersInput;
  name: Scalars['String'];
  parentEventListener?: Maybe<InformEventListenerCreateNestedOneWithoutChildEventListenersInput>;
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerCreateManyInformEventDrivenCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerCreateManyInformEventDrivenCampaignInputEnvelope = {
  data: Array<InformEventListenerCreateManyInformEventDrivenCampaignInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformEventListenerCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId: Scalars['String'];
  name: Scalars['String'];
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerCreateManyParentEventListenerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId: Scalars['String'];
  name: Scalars['String'];
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerCreateManyParentEventListenerInputEnvelope = {
  data: Array<InformEventListenerCreateManyParentEventListenerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformEventListenerCreateNestedManyWithoutInformEventDrivenCampaignInput = {
  connect?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformEventListenerCreateOrConnectWithoutInformEventDrivenCampaignInput>>;
  create?: Maybe<Array<InformEventListenerCreateWithoutInformEventDrivenCampaignInput>>;
  createMany?: Maybe<InformEventListenerCreateManyInformEventDrivenCampaignInputEnvelope>;
};

export type InformEventListenerCreateNestedManyWithoutParentEventListenerInput = {
  connect?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformEventListenerCreateOrConnectWithoutParentEventListenerInput>>;
  create?: Maybe<Array<InformEventListenerCreateWithoutParentEventListenerInput>>;
  createMany?: Maybe<InformEventListenerCreateManyParentEventListenerInputEnvelope>;
};

export type InformEventListenerCreateNestedOneWithoutChildEventListenersInput = {
  connect?: Maybe<InformEventListenerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformEventListenerCreateOrConnectWithoutChildEventListenersInput>;
  create?: Maybe<InformEventListenerCreateWithoutChildEventListenersInput>;
};

export type InformEventListenerCreateNestedOneWithoutEventsInput = {
  connect?: Maybe<InformEventListenerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformEventListenerCreateOrConnectWithoutEventsInput>;
  create?: Maybe<InformEventListenerCreateWithoutEventsInput>;
};

export type InformEventListenerCreateOrConnectWithoutChildEventListenersInput = {
  create: InformEventListenerCreateWithoutChildEventListenersInput;
  where: InformEventListenerWhereUniqueInput;
};

export type InformEventListenerCreateOrConnectWithoutEventsInput = {
  create: InformEventListenerCreateWithoutEventsInput;
  where: InformEventListenerWhereUniqueInput;
};

export type InformEventListenerCreateOrConnectWithoutInformEventDrivenCampaignInput = {
  create: InformEventListenerCreateWithoutInformEventDrivenCampaignInput;
  where: InformEventListenerWhereUniqueInput;
};

export type InformEventListenerCreateOrConnectWithoutParentEventListenerInput = {
  create: InformEventListenerCreateWithoutParentEventListenerInput;
  where: InformEventListenerWhereUniqueInput;
};

export type InformEventListenerCreateWithoutChildEventListenersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventCreateNestedManyWithoutEventListenerInput>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaign: InformEventDrivenCampaignCreateNestedOneWithoutEventListenersInput;
  name: Scalars['String'];
  parentEventListener?: Maybe<InformEventListenerCreateNestedOneWithoutChildEventListenersInput>;
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerCreateWithoutEventsInput = {
  childEventListeners?: Maybe<InformEventListenerCreateNestedManyWithoutParentEventListenerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaign: InformEventDrivenCampaignCreateNestedOneWithoutEventListenersInput;
  name: Scalars['String'];
  parentEventListener?: Maybe<InformEventListenerCreateNestedOneWithoutChildEventListenersInput>;
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerCreateWithoutInformEventDrivenCampaignInput = {
  childEventListeners?: Maybe<InformEventListenerCreateNestedManyWithoutParentEventListenerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventCreateNestedManyWithoutEventListenerInput>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentEventListener?: Maybe<InformEventListenerCreateNestedOneWithoutChildEventListenersInput>;
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerCreateWithoutParentEventListenerInput = {
  childEventListeners?: Maybe<InformEventListenerCreateNestedManyWithoutParentEventListenerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventCreateNestedManyWithoutEventListenerInput>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaign: InformEventDrivenCampaignCreateNestedOneWithoutEventListenersInput;
  name: Scalars['String'];
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerGroupByOutputType = {
  __typename?: 'InformEventListenerGroupByOutputType';
  _count?: Maybe<InformEventListenerCountAggregateOutputType>;
  _max?: Maybe<InformEventListenerMaxAggregateOutputType>;
  _min?: Maybe<InformEventListenerMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  informEventDrivenCampaignId: Scalars['String'];
  name: Scalars['String'];
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings: Scalars['Json'];
  updatedAt: Scalars['DateTime'];
};

export type InformEventListenerListRelationFilter = {
  every?: Maybe<InformEventListenerWhereInput>;
  none?: Maybe<InformEventListenerWhereInput>;
  some?: Maybe<InformEventListenerWhereInput>;
};

export type InformEventListenerMaxAggregateOutputType = {
  __typename?: 'InformEventListenerMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informEventDrivenCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentInformEventListenerId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformEventListenerMinAggregateOutputType = {
  __typename?: 'InformEventListenerMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informEventDrivenCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentInformEventListenerId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformEventListenerNullableScalarRelationFilter = {
  AND?: Maybe<Array<InformEventListenerWhereInput>>;
  NOT?: Maybe<Array<InformEventListenerWhereInput>>;
  OR?: Maybe<Array<InformEventListenerWhereInput>>;
  childEventListeners?: Maybe<InformEventListenerListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  events?: Maybe<InformSessionEventListRelationFilter>;
  id?: Maybe<StringFilter>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignScalarRelationFilter>;
  informEventDrivenCampaignId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  parentEventListener?: Maybe<InformEventListenerNullableScalarRelationFilter>;
  parentInformEventListenerId?: Maybe<StringNullableFilter>;
  settings?: Maybe<JsonFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformEventListenerOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformEventListenerOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformEventListenerOrderByRelevanceInput>;
  childEventListeners?: Maybe<InformEventListenerOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  events?: Maybe<InformSessionEventOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignOrderByWithRelationInput>;
  informEventDrivenCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentEventListener?: Maybe<InformEventListenerOrderByWithRelationInput>;
  parentInformEventListenerId?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformEventListenerOrderByRelevanceFieldEnum {
  Id = 'id',
  InformEventDrivenCampaignId = 'informEventDrivenCampaignId',
  Name = 'name',
  ParentInformEventListenerId = 'parentInformEventListenerId'
}

export type InformEventListenerOrderByRelevanceInput = {
  fields: Array<InformEventListenerOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformEventListenerOrderByWithAggregationInput = {
  _count?: Maybe<InformEventListenerCountOrderByAggregateInput>;
  _max?: Maybe<InformEventListenerMaxOrderByAggregateInput>;
  _min?: Maybe<InformEventListenerMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informEventDrivenCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentInformEventListenerId?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformEventListenerOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformEventListenerOrderByRelevanceInput>;
  childEventListeners?: Maybe<InformEventListenerOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  events?: Maybe<InformSessionEventOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignOrderByWithRelationInput>;
  informEventDrivenCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentEventListener?: Maybe<InformEventListenerOrderByWithRelationInput>;
  parentInformEventListenerId?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformEventListenerOrderByWithRelationInput = {
  _relevance?: Maybe<InformEventListenerOrderByRelevanceInput>;
  childEventListeners?: Maybe<InformEventListenerOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  events?: Maybe<InformSessionEventOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignOrderByWithRelationInput>;
  informEventDrivenCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentEventListener?: Maybe<InformEventListenerOrderByWithRelationInput>;
  parentInformEventListenerId?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformEventListenerScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  InformEventDrivenCampaignId = 'informEventDrivenCampaignId',
  Name = 'name',
  ParentInformEventListenerId = 'parentInformEventListenerId',
  Settings = 'settings',
  UpdatedAt = 'updatedAt'
}

export type InformEventListenerScalarWhereInput = {
  AND?: Maybe<Array<InformEventListenerScalarWhereInput>>;
  NOT?: Maybe<Array<InformEventListenerScalarWhereInput>>;
  OR?: Maybe<Array<InformEventListenerScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  informEventDrivenCampaignId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  parentInformEventListenerId?: Maybe<StringNullableFilter>;
  settings?: Maybe<JsonFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformEventListenerScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformEventListenerScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformEventListenerScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformEventListenerScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informEventDrivenCampaignId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  parentInformEventListenerId?: Maybe<StringNullableWithAggregatesFilter>;
  settings?: Maybe<JsonWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type InformEventListenerUncheckedCreateInput = {
  childEventListeners?: Maybe<InformEventListenerUncheckedCreateNestedManyWithoutParentEventListenerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedCreateNestedManyWithoutEventListenerInput>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId: Scalars['String'];
  name: Scalars['String'];
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUncheckedCreateNestedManyWithoutInformEventDrivenCampaignInput = {
  connect?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformEventListenerCreateOrConnectWithoutInformEventDrivenCampaignInput>>;
  create?: Maybe<Array<InformEventListenerCreateWithoutInformEventDrivenCampaignInput>>;
  createMany?: Maybe<InformEventListenerCreateManyInformEventDrivenCampaignInputEnvelope>;
};

export type InformEventListenerUncheckedCreateNestedManyWithoutParentEventListenerInput = {
  connect?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformEventListenerCreateOrConnectWithoutParentEventListenerInput>>;
  create?: Maybe<Array<InformEventListenerCreateWithoutParentEventListenerInput>>;
  createMany?: Maybe<InformEventListenerCreateManyParentEventListenerInputEnvelope>;
};

export type InformEventListenerUncheckedCreateWithoutChildEventListenersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedCreateNestedManyWithoutEventListenerInput>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId: Scalars['String'];
  name: Scalars['String'];
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUncheckedCreateWithoutEventsInput = {
  childEventListeners?: Maybe<InformEventListenerUncheckedCreateNestedManyWithoutParentEventListenerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId: Scalars['String'];
  name: Scalars['String'];
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUncheckedCreateWithoutInformEventDrivenCampaignInput = {
  childEventListeners?: Maybe<InformEventListenerUncheckedCreateNestedManyWithoutParentEventListenerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedCreateNestedManyWithoutEventListenerInput>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUncheckedCreateWithoutParentEventListenerInput = {
  childEventListeners?: Maybe<InformEventListenerUncheckedCreateNestedManyWithoutParentEventListenerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedCreateNestedManyWithoutEventListenerInput>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId: Scalars['String'];
  name: Scalars['String'];
  settings: Scalars['Json'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUncheckedUpdateInput = {
  childEventListeners?: Maybe<InformEventListenerUncheckedUpdateManyWithoutParentEventListenerNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedUpdateManyWithoutEventListenerNestedInput>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUncheckedUpdateManyWithoutInformEventDrivenCampaignInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUncheckedUpdateManyWithoutInformEventDrivenCampaignNestedInput = {
  connect?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformEventListenerCreateOrConnectWithoutInformEventDrivenCampaignInput>>;
  create?: Maybe<Array<InformEventListenerCreateWithoutInformEventDrivenCampaignInput>>;
  createMany?: Maybe<InformEventListenerCreateManyInformEventDrivenCampaignInputEnvelope>;
  delete?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformEventListenerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  set?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  update?: Maybe<Array<InformEventListenerUpdateWithWhereUniqueWithoutInformEventDrivenCampaignInput>>;
  updateMany?: Maybe<Array<InformEventListenerUpdateManyWithWhereWithoutInformEventDrivenCampaignInput>>;
  upsert?: Maybe<Array<InformEventListenerUpsertWithWhereUniqueWithoutInformEventDrivenCampaignInput>>;
};

export type InformEventListenerUncheckedUpdateManyWithoutParentEventListenerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUncheckedUpdateManyWithoutParentEventListenerNestedInput = {
  connect?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformEventListenerCreateOrConnectWithoutParentEventListenerInput>>;
  create?: Maybe<Array<InformEventListenerCreateWithoutParentEventListenerInput>>;
  createMany?: Maybe<InformEventListenerCreateManyParentEventListenerInputEnvelope>;
  delete?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformEventListenerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  set?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  update?: Maybe<Array<InformEventListenerUpdateWithWhereUniqueWithoutParentEventListenerInput>>;
  updateMany?: Maybe<Array<InformEventListenerUpdateManyWithWhereWithoutParentEventListenerInput>>;
  upsert?: Maybe<Array<InformEventListenerUpsertWithWhereUniqueWithoutParentEventListenerInput>>;
};

export type InformEventListenerUncheckedUpdateWithoutChildEventListenersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedUpdateManyWithoutEventListenerNestedInput>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUncheckedUpdateWithoutEventsInput = {
  childEventListeners?: Maybe<InformEventListenerUncheckedUpdateManyWithoutParentEventListenerNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUncheckedUpdateWithoutInformEventDrivenCampaignInput = {
  childEventListeners?: Maybe<InformEventListenerUncheckedUpdateManyWithoutParentEventListenerNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedUpdateManyWithoutEventListenerNestedInput>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentInformEventListenerId?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUncheckedUpdateWithoutParentEventListenerInput = {
  childEventListeners?: Maybe<InformEventListenerUncheckedUpdateManyWithoutParentEventListenerNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedUpdateManyWithoutEventListenerNestedInput>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUpdateInput = {
  childEventListeners?: Maybe<InformEventListenerUpdateManyWithoutParentEventListenerNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUpdateManyWithoutEventListenerNestedInput>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUpdateOneRequiredWithoutEventListenersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentEventListener?: Maybe<InformEventListenerUpdateOneWithoutChildEventListenersNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUpdateManyWithWhereWithoutInformEventDrivenCampaignInput = {
  data: InformEventListenerUpdateManyMutationInput;
  where: InformEventListenerScalarWhereInput;
};

export type InformEventListenerUpdateManyWithWhereWithoutParentEventListenerInput = {
  data: InformEventListenerUpdateManyMutationInput;
  where: InformEventListenerScalarWhereInput;
};

export type InformEventListenerUpdateManyWithoutInformEventDrivenCampaignNestedInput = {
  connect?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformEventListenerCreateOrConnectWithoutInformEventDrivenCampaignInput>>;
  create?: Maybe<Array<InformEventListenerCreateWithoutInformEventDrivenCampaignInput>>;
  createMany?: Maybe<InformEventListenerCreateManyInformEventDrivenCampaignInputEnvelope>;
  delete?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformEventListenerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  set?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  update?: Maybe<Array<InformEventListenerUpdateWithWhereUniqueWithoutInformEventDrivenCampaignInput>>;
  updateMany?: Maybe<Array<InformEventListenerUpdateManyWithWhereWithoutInformEventDrivenCampaignInput>>;
  upsert?: Maybe<Array<InformEventListenerUpsertWithWhereUniqueWithoutInformEventDrivenCampaignInput>>;
};

export type InformEventListenerUpdateManyWithoutParentEventListenerNestedInput = {
  connect?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformEventListenerCreateOrConnectWithoutParentEventListenerInput>>;
  create?: Maybe<Array<InformEventListenerCreateWithoutParentEventListenerInput>>;
  createMany?: Maybe<InformEventListenerCreateManyParentEventListenerInputEnvelope>;
  delete?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformEventListenerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  set?: Maybe<Array<InformEventListenerWhereUniqueInput>>;
  update?: Maybe<Array<InformEventListenerUpdateWithWhereUniqueWithoutParentEventListenerInput>>;
  updateMany?: Maybe<Array<InformEventListenerUpdateManyWithWhereWithoutParentEventListenerInput>>;
  upsert?: Maybe<Array<InformEventListenerUpsertWithWhereUniqueWithoutParentEventListenerInput>>;
};

export type InformEventListenerUpdateOneWithoutChildEventListenersNestedInput = {
  connect?: Maybe<InformEventListenerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformEventListenerCreateOrConnectWithoutChildEventListenersInput>;
  create?: Maybe<InformEventListenerCreateWithoutChildEventListenersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformEventListenerUpdateToOneWithWhereWithoutChildEventListenersInput>;
  upsert?: Maybe<InformEventListenerUpsertWithoutChildEventListenersInput>;
};

export type InformEventListenerUpdateOneWithoutEventsNestedInput = {
  connect?: Maybe<InformEventListenerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformEventListenerCreateOrConnectWithoutEventsInput>;
  create?: Maybe<InformEventListenerCreateWithoutEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformEventListenerUpdateToOneWithWhereWithoutEventsInput>;
  upsert?: Maybe<InformEventListenerUpsertWithoutEventsInput>;
};

export type InformEventListenerUpdateToOneWithWhereWithoutChildEventListenersInput = {
  data: InformEventListenerUpdateWithoutChildEventListenersInput;
  where?: Maybe<InformEventListenerWhereInput>;
};

export type InformEventListenerUpdateToOneWithWhereWithoutEventsInput = {
  data: InformEventListenerUpdateWithoutEventsInput;
  where?: Maybe<InformEventListenerWhereInput>;
};

export type InformEventListenerUpdateWithWhereUniqueWithoutInformEventDrivenCampaignInput = {
  data: InformEventListenerUpdateWithoutInformEventDrivenCampaignInput;
  where: InformEventListenerWhereUniqueInput;
};

export type InformEventListenerUpdateWithWhereUniqueWithoutParentEventListenerInput = {
  data: InformEventListenerUpdateWithoutParentEventListenerInput;
  where: InformEventListenerWhereUniqueInput;
};

export type InformEventListenerUpdateWithoutChildEventListenersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUpdateManyWithoutEventListenerNestedInput>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUpdateOneRequiredWithoutEventListenersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentEventListener?: Maybe<InformEventListenerUpdateOneWithoutChildEventListenersNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUpdateWithoutEventsInput = {
  childEventListeners?: Maybe<InformEventListenerUpdateManyWithoutParentEventListenerNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUpdateOneRequiredWithoutEventListenersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentEventListener?: Maybe<InformEventListenerUpdateOneWithoutChildEventListenersNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUpdateWithoutInformEventDrivenCampaignInput = {
  childEventListeners?: Maybe<InformEventListenerUpdateManyWithoutParentEventListenerNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUpdateManyWithoutEventListenerNestedInput>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentEventListener?: Maybe<InformEventListenerUpdateOneWithoutChildEventListenersNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUpdateWithoutParentEventListenerInput = {
  childEventListeners?: Maybe<InformEventListenerUpdateManyWithoutParentEventListenerNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUpdateManyWithoutEventListenerNestedInput>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignUpdateOneRequiredWithoutEventListenersNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformEventListenerUpsertWithWhereUniqueWithoutInformEventDrivenCampaignInput = {
  create: InformEventListenerCreateWithoutInformEventDrivenCampaignInput;
  update: InformEventListenerUpdateWithoutInformEventDrivenCampaignInput;
  where: InformEventListenerWhereUniqueInput;
};

export type InformEventListenerUpsertWithWhereUniqueWithoutParentEventListenerInput = {
  create: InformEventListenerCreateWithoutParentEventListenerInput;
  update: InformEventListenerUpdateWithoutParentEventListenerInput;
  where: InformEventListenerWhereUniqueInput;
};

export type InformEventListenerUpsertWithoutChildEventListenersInput = {
  create: InformEventListenerCreateWithoutChildEventListenersInput;
  update: InformEventListenerUpdateWithoutChildEventListenersInput;
  where?: Maybe<InformEventListenerWhereInput>;
};

export type InformEventListenerUpsertWithoutEventsInput = {
  create: InformEventListenerCreateWithoutEventsInput;
  update: InformEventListenerUpdateWithoutEventsInput;
  where?: Maybe<InformEventListenerWhereInput>;
};

export type InformEventListenerWhereInput = {
  AND?: Maybe<Array<InformEventListenerWhereInput>>;
  NOT?: Maybe<Array<InformEventListenerWhereInput>>;
  OR?: Maybe<Array<InformEventListenerWhereInput>>;
  childEventListeners?: Maybe<InformEventListenerListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  events?: Maybe<InformSessionEventListRelationFilter>;
  id?: Maybe<StringFilter>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignScalarRelationFilter>;
  informEventDrivenCampaignId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  parentEventListener?: Maybe<InformEventListenerNullableScalarRelationFilter>;
  parentInformEventListenerId?: Maybe<StringNullableFilter>;
  settings?: Maybe<JsonFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformEventListenerWhereUniqueInput = {
  AND?: Maybe<Array<InformEventListenerWhereInput>>;
  NOT?: Maybe<Array<InformEventListenerWhereInput>>;
  OR?: Maybe<Array<InformEventListenerWhereInput>>;
  childEventListeners?: Maybe<InformEventListenerListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  events?: Maybe<InformSessionEventListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  informEventDrivenCampaign?: Maybe<InformEventDrivenCampaignScalarRelationFilter>;
  informEventDrivenCampaignId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  parentEventListener?: Maybe<InformEventListenerNullableScalarRelationFilter>;
  parentInformEventListenerId?: Maybe<StringNullableFilter>;
  settings?: Maybe<JsonFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformNotificationRecipient = {
  __typename?: 'InformNotificationRecipient';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informPartnerProgramEnrollment: InformPartnerProgramEnrollment;
  informPartnerProgramEnrollmentId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type InformNotificationRecipientCountAggregateOutputType = {
  __typename?: 'InformNotificationRecipientCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerProgramEnrollmentId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type InformNotificationRecipientCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type InformNotificationRecipientCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollment: InformPartnerProgramEnrollmentCreateNestedOneWithoutInformNotificationRecipientsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutInformNotificationRecipientsInput;
};

export type InformNotificationRecipientCreateManyInformPartnerProgramEnrollmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type InformNotificationRecipientCreateManyInformPartnerProgramEnrollmentInputEnvelope = {
  data: Array<InformNotificationRecipientCreateManyInformPartnerProgramEnrollmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformNotificationRecipientCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type InformNotificationRecipientCreateManyUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformNotificationRecipientCreateManyUserInputEnvelope = {
  data: Array<InformNotificationRecipientCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformNotificationRecipientCreateNestedManyWithoutInformPartnerProgramEnrollmentInput = {
  connect?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformNotificationRecipientCreateOrConnectWithoutInformPartnerProgramEnrollmentInput>>;
  create?: Maybe<Array<InformNotificationRecipientCreateWithoutInformPartnerProgramEnrollmentInput>>;
  createMany?: Maybe<InformNotificationRecipientCreateManyInformPartnerProgramEnrollmentInputEnvelope>;
};

export type InformNotificationRecipientCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformNotificationRecipientCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<InformNotificationRecipientCreateWithoutUserInput>>;
  createMany?: Maybe<InformNotificationRecipientCreateManyUserInputEnvelope>;
};

export type InformNotificationRecipientCreateOrConnectWithoutInformPartnerProgramEnrollmentInput = {
  create: InformNotificationRecipientCreateWithoutInformPartnerProgramEnrollmentInput;
  where: InformNotificationRecipientWhereUniqueInput;
};

export type InformNotificationRecipientCreateOrConnectWithoutUserInput = {
  create: InformNotificationRecipientCreateWithoutUserInput;
  where: InformNotificationRecipientWhereUniqueInput;
};

export type InformNotificationRecipientCreateWithoutInformPartnerProgramEnrollmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutInformNotificationRecipientsInput;
};

export type InformNotificationRecipientCreateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollment: InformPartnerProgramEnrollmentCreateNestedOneWithoutInformNotificationRecipientsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformNotificationRecipientGroupByOutputType = {
  __typename?: 'InformNotificationRecipientGroupByOutputType';
  _count?: Maybe<InformNotificationRecipientCountAggregateOutputType>;
  _max?: Maybe<InformNotificationRecipientMaxAggregateOutputType>;
  _min?: Maybe<InformNotificationRecipientMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informPartnerProgramEnrollmentId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type InformNotificationRecipientInformPartnerProgramEnrollmentIdUserIdCompoundUniqueInput = {
  informPartnerProgramEnrollmentId: Scalars['String'];
  userId: Scalars['String'];
};

export type InformNotificationRecipientListRelationFilter = {
  every?: Maybe<InformNotificationRecipientWhereInput>;
  none?: Maybe<InformNotificationRecipientWhereInput>;
  some?: Maybe<InformNotificationRecipientWhereInput>;
};

export type InformNotificationRecipientMaxAggregateOutputType = {
  __typename?: 'InformNotificationRecipientMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type InformNotificationRecipientMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type InformNotificationRecipientMinAggregateOutputType = {
  __typename?: 'InformNotificationRecipientMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type InformNotificationRecipientMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type InformNotificationRecipientOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformNotificationRecipientOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformNotificationRecipientOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum InformNotificationRecipientOrderByRelevanceFieldEnum {
  Id = 'id',
  InformPartnerProgramEnrollmentId = 'informPartnerProgramEnrollmentId',
  UserId = 'userId'
}

export type InformNotificationRecipientOrderByRelevanceInput = {
  fields: Array<InformNotificationRecipientOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformNotificationRecipientOrderByWithAggregationInput = {
  _count?: Maybe<InformNotificationRecipientCountOrderByAggregateInput>;
  _max?: Maybe<InformNotificationRecipientMaxOrderByAggregateInput>;
  _min?: Maybe<InformNotificationRecipientMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type InformNotificationRecipientOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformNotificationRecipientOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type InformNotificationRecipientOrderByWithRelationInput = {
  _relevance?: Maybe<InformNotificationRecipientOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>;
  informPartnerProgramEnrollmentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum InformNotificationRecipientScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  InformPartnerProgramEnrollmentId = 'informPartnerProgramEnrollmentId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type InformNotificationRecipientScalarWhereInput = {
  AND?: Maybe<Array<InformNotificationRecipientScalarWhereInput>>;
  NOT?: Maybe<Array<InformNotificationRecipientScalarWhereInput>>;
  OR?: Maybe<Array<InformNotificationRecipientScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informPartnerProgramEnrollmentId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userId?: Maybe<StringFilter>;
};

export type InformNotificationRecipientScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformNotificationRecipientScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformNotificationRecipientScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformNotificationRecipientScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerProgramEnrollmentId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userId?: Maybe<StringWithAggregatesFilter>;
};

export type InformNotificationRecipientUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type InformNotificationRecipientUncheckedCreateNestedManyWithoutInformPartnerProgramEnrollmentInput = {
  connect?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformNotificationRecipientCreateOrConnectWithoutInformPartnerProgramEnrollmentInput>>;
  create?: Maybe<Array<InformNotificationRecipientCreateWithoutInformPartnerProgramEnrollmentInput>>;
  createMany?: Maybe<InformNotificationRecipientCreateManyInformPartnerProgramEnrollmentInputEnvelope>;
};

export type InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformNotificationRecipientCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<InformNotificationRecipientCreateWithoutUserInput>>;
  createMany?: Maybe<InformNotificationRecipientCreateManyUserInputEnvelope>;
};

export type InformNotificationRecipientUncheckedCreateWithoutInformPartnerProgramEnrollmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type InformNotificationRecipientUncheckedCreateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformNotificationRecipientUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type InformNotificationRecipientUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type InformNotificationRecipientUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type InformNotificationRecipientUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput = {
  connect?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformNotificationRecipientCreateOrConnectWithoutInformPartnerProgramEnrollmentInput>>;
  create?: Maybe<Array<InformNotificationRecipientCreateWithoutInformPartnerProgramEnrollmentInput>>;
  createMany?: Maybe<InformNotificationRecipientCreateManyInformPartnerProgramEnrollmentInputEnvelope>;
  delete?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformNotificationRecipientScalarWhereInput>>;
  disconnect?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  set?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  update?: Maybe<Array<InformNotificationRecipientUpdateWithWhereUniqueWithoutInformPartnerProgramEnrollmentInput>>;
  updateMany?: Maybe<Array<InformNotificationRecipientUpdateManyWithWhereWithoutInformPartnerProgramEnrollmentInput>>;
  upsert?: Maybe<Array<InformNotificationRecipientUpsertWithWhereUniqueWithoutInformPartnerProgramEnrollmentInput>>;
};

export type InformNotificationRecipientUncheckedUpdateManyWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformNotificationRecipientCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<InformNotificationRecipientCreateWithoutUserInput>>;
  createMany?: Maybe<InformNotificationRecipientCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformNotificationRecipientScalarWhereInput>>;
  disconnect?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  set?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  update?: Maybe<Array<InformNotificationRecipientUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<InformNotificationRecipientUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<InformNotificationRecipientUpsertWithWhereUniqueWithoutUserInput>>;
};

export type InformNotificationRecipientUncheckedUpdateWithoutInformPartnerProgramEnrollmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type InformNotificationRecipientUncheckedUpdateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformNotificationRecipientUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentUpdateOneRequiredWithoutInformNotificationRecipientsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneRequiredWithoutInformNotificationRecipientsNestedInput>;
};

export type InformNotificationRecipientUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformNotificationRecipientUpdateManyWithWhereWithoutInformPartnerProgramEnrollmentInput = {
  data: InformNotificationRecipientUpdateManyMutationInput;
  where: InformNotificationRecipientScalarWhereInput;
};

export type InformNotificationRecipientUpdateManyWithWhereWithoutUserInput = {
  data: InformNotificationRecipientUpdateManyMutationInput;
  where: InformNotificationRecipientScalarWhereInput;
};

export type InformNotificationRecipientUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput = {
  connect?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformNotificationRecipientCreateOrConnectWithoutInformPartnerProgramEnrollmentInput>>;
  create?: Maybe<Array<InformNotificationRecipientCreateWithoutInformPartnerProgramEnrollmentInput>>;
  createMany?: Maybe<InformNotificationRecipientCreateManyInformPartnerProgramEnrollmentInputEnvelope>;
  delete?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformNotificationRecipientScalarWhereInput>>;
  disconnect?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  set?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  update?: Maybe<Array<InformNotificationRecipientUpdateWithWhereUniqueWithoutInformPartnerProgramEnrollmentInput>>;
  updateMany?: Maybe<Array<InformNotificationRecipientUpdateManyWithWhereWithoutInformPartnerProgramEnrollmentInput>>;
  upsert?: Maybe<Array<InformNotificationRecipientUpsertWithWhereUniqueWithoutInformPartnerProgramEnrollmentInput>>;
};

export type InformNotificationRecipientUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformNotificationRecipientCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<InformNotificationRecipientCreateWithoutUserInput>>;
  createMany?: Maybe<InformNotificationRecipientCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformNotificationRecipientScalarWhereInput>>;
  disconnect?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  set?: Maybe<Array<InformNotificationRecipientWhereUniqueInput>>;
  update?: Maybe<Array<InformNotificationRecipientUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<InformNotificationRecipientUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<InformNotificationRecipientUpsertWithWhereUniqueWithoutUserInput>>;
};

export type InformNotificationRecipientUpdateWithWhereUniqueWithoutInformPartnerProgramEnrollmentInput = {
  data: InformNotificationRecipientUpdateWithoutInformPartnerProgramEnrollmentInput;
  where: InformNotificationRecipientWhereUniqueInput;
};

export type InformNotificationRecipientUpdateWithWhereUniqueWithoutUserInput = {
  data: InformNotificationRecipientUpdateWithoutUserInput;
  where: InformNotificationRecipientWhereUniqueInput;
};

export type InformNotificationRecipientUpdateWithoutInformPartnerProgramEnrollmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneRequiredWithoutInformNotificationRecipientsNestedInput>;
};

export type InformNotificationRecipientUpdateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentUpdateOneRequiredWithoutInformNotificationRecipientsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformNotificationRecipientUpsertWithWhereUniqueWithoutInformPartnerProgramEnrollmentInput = {
  create: InformNotificationRecipientCreateWithoutInformPartnerProgramEnrollmentInput;
  update: InformNotificationRecipientUpdateWithoutInformPartnerProgramEnrollmentInput;
  where: InformNotificationRecipientWhereUniqueInput;
};

export type InformNotificationRecipientUpsertWithWhereUniqueWithoutUserInput = {
  create: InformNotificationRecipientCreateWithoutUserInput;
  update: InformNotificationRecipientUpdateWithoutUserInput;
  where: InformNotificationRecipientWhereUniqueInput;
};

export type InformNotificationRecipientWhereInput = {
  AND?: Maybe<Array<InformNotificationRecipientWhereInput>>;
  NOT?: Maybe<Array<InformNotificationRecipientWhereInput>>;
  OR?: Maybe<Array<InformNotificationRecipientWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentScalarRelationFilter>;
  informPartnerProgramEnrollmentId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type InformNotificationRecipientWhereUniqueInput = {
  AND?: Maybe<Array<InformNotificationRecipientWhereInput>>;
  NOT?: Maybe<Array<InformNotificationRecipientWhereInput>>;
  OR?: Maybe<Array<InformNotificationRecipientWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollmentScalarRelationFilter>;
  informPartnerProgramEnrollmentId?: Maybe<StringFilter>;
  informPartnerProgramEnrollmentId_userId?: Maybe<InformNotificationRecipientInformPartnerProgramEnrollmentIdUserIdCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type InformPartner = {
  __typename?: 'InformPartner';
  _count: InformPartnerCountOutputType;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informAudienceDefinitions: Array<InformAudienceDefinition>;
  informCampaignGroups: Array<InformCampaignGroup>;
  informEmailTemplates: Array<InformEmailTemplate>;
  informPartnerCustomer: Array<InformPartnerCustomer>;
  informPartnerIntegrations: Array<InformPartnerIntegration>;
  informPartnerPrograms: Array<InformPartnerProgram>;
  informPartnerUsers: Array<InformPartnerUser>;
  name: Scalars['String'];
  products: Array<Product>;
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerStatus;
  updatedAt: Scalars['DateTime'];
};


export type InformPartnerInformAudienceDefinitionsArgs = {
  cursor?: Maybe<InformAudienceDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceDefinitionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};


export type InformPartnerInformCampaignGroupsArgs = {
  cursor?: Maybe<InformCampaignGroupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignGroupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignGroupOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignGroupWhereInput>;
};


export type InformPartnerInformEmailTemplatesArgs = {
  cursor?: Maybe<InformEmailTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEmailTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEmailTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEmailTemplateWhereInput>;
};


export type InformPartnerInformPartnerCustomerArgs = {
  cursor?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};


export type InformPartnerInformPartnerIntegrationsArgs = {
  cursor?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};


export type InformPartnerInformPartnerProgramsArgs = {
  cursor?: Maybe<InformPartnerProgramWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerProgramScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerProgramOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerProgramWhereInput>;
};


export type InformPartnerInformPartnerUsersArgs = {
  cursor?: Maybe<InformPartnerUserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerUserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserWhereInput>;
};


export type InformPartnerProductsArgs = {
  cursor?: Maybe<ProductWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductWhereInput>;
};

export type InformPartnerCountAggregateOutputType = {
  __typename?: 'InformPartnerCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  settings: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformPartnerCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerCountOutputType = {
  __typename?: 'InformPartnerCountOutputType';
  informAudienceDefinitions: Scalars['Int'];
  informCampaignGroups: Scalars['Int'];
  informEmailTemplates: Scalars['Int'];
  informPartnerCustomer: Scalars['Int'];
  informPartnerIntegrations: Scalars['Int'];
  informPartnerPrograms: Scalars['Int'];
  informPartnerUsers: Scalars['Int'];
  products: Scalars['Int'];
};

export type InformPartnerCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCreateNestedOneWithoutInformAudienceDefinitionsInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformAudienceDefinitionsInput>;
  create?: Maybe<InformPartnerCreateWithoutInformAudienceDefinitionsInput>;
};

export type InformPartnerCreateNestedOneWithoutInformCampaignGroupsInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformCampaignGroupsInput>;
  create?: Maybe<InformPartnerCreateWithoutInformCampaignGroupsInput>;
};

export type InformPartnerCreateNestedOneWithoutInformEmailTemplatesInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformEmailTemplatesInput>;
  create?: Maybe<InformPartnerCreateWithoutInformEmailTemplatesInput>;
};

export type InformPartnerCreateNestedOneWithoutInformPartnerCustomerInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformPartnerCustomerInput>;
  create?: Maybe<InformPartnerCreateWithoutInformPartnerCustomerInput>;
};

export type InformPartnerCreateNestedOneWithoutInformPartnerIntegrationsInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformPartnerIntegrationsInput>;
  create?: Maybe<InformPartnerCreateWithoutInformPartnerIntegrationsInput>;
};

export type InformPartnerCreateNestedOneWithoutInformPartnerProgramsInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformPartnerProgramsInput>;
  create?: Maybe<InformPartnerCreateWithoutInformPartnerProgramsInput>;
};

export type InformPartnerCreateNestedOneWithoutInformPartnerUsersInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformPartnerUsersInput>;
  create?: Maybe<InformPartnerCreateWithoutInformPartnerUsersInput>;
};

export type InformPartnerCreateNestedOneWithoutProductsInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutProductsInput>;
  create?: Maybe<InformPartnerCreateWithoutProductsInput>;
};

export type InformPartnerCreateOrConnectWithoutInformAudienceDefinitionsInput = {
  create: InformPartnerCreateWithoutInformAudienceDefinitionsInput;
  where: InformPartnerWhereUniqueInput;
};

export type InformPartnerCreateOrConnectWithoutInformCampaignGroupsInput = {
  create: InformPartnerCreateWithoutInformCampaignGroupsInput;
  where: InformPartnerWhereUniqueInput;
};

export type InformPartnerCreateOrConnectWithoutInformEmailTemplatesInput = {
  create: InformPartnerCreateWithoutInformEmailTemplatesInput;
  where: InformPartnerWhereUniqueInput;
};

export type InformPartnerCreateOrConnectWithoutInformPartnerCustomerInput = {
  create: InformPartnerCreateWithoutInformPartnerCustomerInput;
  where: InformPartnerWhereUniqueInput;
};

export type InformPartnerCreateOrConnectWithoutInformPartnerIntegrationsInput = {
  create: InformPartnerCreateWithoutInformPartnerIntegrationsInput;
  where: InformPartnerWhereUniqueInput;
};

export type InformPartnerCreateOrConnectWithoutInformPartnerProgramsInput = {
  create: InformPartnerCreateWithoutInformPartnerProgramsInput;
  where: InformPartnerWhereUniqueInput;
};

export type InformPartnerCreateOrConnectWithoutInformPartnerUsersInput = {
  create: InformPartnerCreateWithoutInformPartnerUsersInput;
  where: InformPartnerWhereUniqueInput;
};

export type InformPartnerCreateOrConnectWithoutProductsInput = {
  create: InformPartnerCreateWithoutProductsInput;
  where: InformPartnerWhereUniqueInput;
};

export type InformPartnerCreateWithoutInformAudienceDefinitionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignGroups?: Maybe<InformCampaignGroupCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCreateWithoutInformCampaignGroupsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCreateWithoutInformEmailTemplatesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCreateWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCreateWithoutInformPartnerIntegrationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCreateWithoutInformPartnerProgramsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCreateWithoutInformPartnerUsersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCreateWithoutProductsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomer = {
  __typename?: 'InformPartnerCustomer';
  _count: InformPartnerCustomerCountOutputType;
  boehringerIngelheimCustomerAlignments: Array<BoehringerIngelheimCustomerAlignment>;
  checksum: Scalars['String'];
  childInformPartnerCustomers: Array<InformPartnerCustomer>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  externalId: Scalars['String'];
  googlePlace?: Maybe<GooglePlace>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartner: InformPartner;
  informPartnerId: Scalars['String'];
  informPartnerIntegration: InformPartnerIntegration;
  informPartnerIntegrationId: Scalars['String'];
  informPartnerUsers: Array<InformPartnerUser>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomer>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders: Array<InformPartnerCustomerPharmacyProvider>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles: Array<InformPartnerUserRole>;
  updatedAt: Scalars['DateTime'];
  visibility: InformPartnerCustomerVisibility;
};


export type InformPartnerCustomerBoehringerIngelheimCustomerAlignmentsArgs = {
  cursor?: Maybe<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoehringerIngelheimCustomerAlignmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoehringerIngelheimCustomerAlignmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoehringerIngelheimCustomerAlignmentWhereInput>;
};


export type InformPartnerCustomerChildInformPartnerCustomersArgs = {
  cursor?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};


export type InformPartnerCustomerClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type InformPartnerCustomerGooglePlaceArgs = {
  where?: Maybe<GooglePlaceWhereInput>;
};


export type InformPartnerCustomerInformPartnerUsersArgs = {
  cursor?: Maybe<InformPartnerUserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerUserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserWhereInput>;
};


export type InformPartnerCustomerParentInformPartnerCustomerArgs = {
  where?: Maybe<InformPartnerCustomerWhereInput>;
};


export type InformPartnerCustomerPharmacyProvidersArgs = {
  cursor?: Maybe<InformPartnerCustomerPharmacyProviderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerPharmacyProviderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerPharmacyProviderOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerPharmacyProviderWhereInput>;
};


export type InformPartnerCustomerRolesArgs = {
  cursor?: Maybe<InformPartnerUserRoleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerUserRoleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserRoleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserRoleWhereInput>;
};

export type InformPartnerCustomerCountAggregateOutputType = {
  __typename?: 'InformPartnerCustomerCountAggregateOutputType';
  _all: Scalars['Int'];
  checksum: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  externalId: Scalars['Int'];
  googlePlaceId: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerId: Scalars['Int'];
  informPartnerIntegrationId: Scalars['Int'];
  name: Scalars['Int'];
  parentExternalId: Scalars['Int'];
  parentInformPartnerCustomerId: Scalars['Int'];
  phoneNumber: Scalars['Int'];
  postalCode: Scalars['Int'];
  rawData: Scalars['Int'];
  updatedAt: Scalars['Int'];
  visibility: Scalars['Int'];
};

export type InformPartnerCustomerCountOrderByAggregateInput = {
  checksum?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  googlePlaceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentExternalId?: Maybe<SortOrder>;
  parentInformPartnerCustomerId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export type InformPartnerCustomerCountOutputType = {
  __typename?: 'InformPartnerCustomerCountOutputType';
  boehringerIngelheimCustomerAlignments: Scalars['Int'];
  childInformPartnerCustomers: Scalars['Int'];
  informPartnerUsers: Scalars['Int'];
  pharmacyProviders: Scalars['Int'];
  roles: Scalars['Int'];
};

export type InformPartnerCustomerCreateInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutInformPartnerCustomersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutInformPartnerCustomersInput>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerCustomerInput;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomersInput;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedOneWithoutChildInformPartnerCustomersInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateManyClinicInput = {
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateManyClinicInputEnvelope = {
  data: Array<InformPartnerCustomerCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerCustomerCreateManyGooglePlaceInput = {
  checksum: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateManyGooglePlaceInputEnvelope = {
  data: Array<InformPartnerCustomerCreateManyGooglePlaceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerCustomerCreateManyInformPartnerInput = {
  checksum: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId: Scalars['String'];
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateManyInformPartnerInputEnvelope = {
  data: Array<InformPartnerCustomerCreateManyInformPartnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerCustomerCreateManyInformPartnerIntegrationInput = {
  checksum: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateManyInformPartnerIntegrationInputEnvelope = {
  data: Array<InformPartnerCustomerCreateManyInformPartnerIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerCustomerCreateManyInput = {
  checksum: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateManyParentInformPartnerCustomerInput = {
  checksum: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateManyParentInformPartnerCustomerInputEnvelope = {
  data: Array<InformPartnerCustomerCreateManyParentInformPartnerCustomerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerCustomerCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutClinicInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyClinicInputEnvelope>;
};

export type InformPartnerCustomerCreateNestedManyWithoutGooglePlaceInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutGooglePlaceInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutGooglePlaceInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyGooglePlaceInputEnvelope>;
};

export type InformPartnerCustomerCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyInformPartnerInputEnvelope>;
};

export type InformPartnerCustomerCreateNestedManyWithoutInformPartnerIntegrationInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyInformPartnerIntegrationInputEnvelope>;
};

export type InformPartnerCustomerCreateNestedManyWithoutInformPartnerUsersInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutInformPartnerUsersInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutInformPartnerUsersInput>>;
};

export type InformPartnerCustomerCreateNestedManyWithoutParentInformPartnerCustomerInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutParentInformPartnerCustomerInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutParentInformPartnerCustomerInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyParentInformPartnerCustomerInputEnvelope>;
};

export type InformPartnerCustomerCreateNestedOneWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  connect?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCustomerCreateOrConnectWithoutBoehringerIngelheimCustomerAlignmentsInput>;
  create?: Maybe<InformPartnerCustomerCreateWithoutBoehringerIngelheimCustomerAlignmentsInput>;
};

export type InformPartnerCustomerCreateNestedOneWithoutChildInformPartnerCustomersInput = {
  connect?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCustomerCreateOrConnectWithoutChildInformPartnerCustomersInput>;
  create?: Maybe<InformPartnerCustomerCreateWithoutChildInformPartnerCustomersInput>;
};

export type InformPartnerCustomerCreateNestedOneWithoutPharmacyProvidersInput = {
  connect?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCustomerCreateOrConnectWithoutPharmacyProvidersInput>;
  create?: Maybe<InformPartnerCustomerCreateWithoutPharmacyProvidersInput>;
};

export type InformPartnerCustomerCreateNestedOneWithoutRolesInput = {
  connect?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCustomerCreateOrConnectWithoutRolesInput>;
  create?: Maybe<InformPartnerCustomerCreateWithoutRolesInput>;
};

export type InformPartnerCustomerCreateOrConnectWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  create: InformPartnerCustomerCreateWithoutBoehringerIngelheimCustomerAlignmentsInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerCreateOrConnectWithoutChildInformPartnerCustomersInput = {
  create: InformPartnerCustomerCreateWithoutChildInformPartnerCustomersInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerCreateOrConnectWithoutClinicInput = {
  create: InformPartnerCustomerCreateWithoutClinicInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerCreateOrConnectWithoutGooglePlaceInput = {
  create: InformPartnerCustomerCreateWithoutGooglePlaceInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerCreateOrConnectWithoutInformPartnerInput = {
  create: InformPartnerCustomerCreateWithoutInformPartnerInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerCreateOrConnectWithoutInformPartnerIntegrationInput = {
  create: InformPartnerCustomerCreateWithoutInformPartnerIntegrationInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerCreateOrConnectWithoutInformPartnerUsersInput = {
  create: InformPartnerCustomerCreateWithoutInformPartnerUsersInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerCreateOrConnectWithoutParentInformPartnerCustomerInput = {
  create: InformPartnerCustomerCreateWithoutParentInformPartnerCustomerInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerCreateOrConnectWithoutPharmacyProvidersInput = {
  create: InformPartnerCustomerCreateWithoutPharmacyProvidersInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerCreateOrConnectWithoutRolesInput = {
  create: InformPartnerCustomerCreateWithoutRolesInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerCreateWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutInformPartnerCustomersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutInformPartnerCustomersInput>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerCustomerInput;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomersInput;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedOneWithoutChildInformPartnerCustomersInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateWithoutChildInformPartnerCustomersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  clinic?: Maybe<ClinicCreateNestedOneWithoutInformPartnerCustomersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutInformPartnerCustomersInput>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerCustomerInput;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomersInput;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedOneWithoutChildInformPartnerCustomersInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateWithoutClinicInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutInformPartnerCustomersInput>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerCustomerInput;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomersInput;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedOneWithoutChildInformPartnerCustomersInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateWithoutGooglePlaceInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutInformPartnerCustomersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerCustomerInput;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomersInput;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedOneWithoutChildInformPartnerCustomersInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateWithoutInformPartnerInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutInformPartnerCustomersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutInformPartnerCustomersInput>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomersInput;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedOneWithoutChildInformPartnerCustomersInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateWithoutInformPartnerIntegrationInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutInformPartnerCustomersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutInformPartnerCustomersInput>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerCustomerInput;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedOneWithoutChildInformPartnerCustomersInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateWithoutInformPartnerUsersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutInformPartnerCustomersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutInformPartnerCustomersInput>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerCustomerInput;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomersInput;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedOneWithoutChildInformPartnerCustomersInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateWithoutParentInformPartnerCustomerInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutInformPartnerCustomersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutInformPartnerCustomersInput>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerCustomerInput;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomersInput;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateWithoutPharmacyProvidersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutInformPartnerCustomersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutInformPartnerCustomersInput>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerCustomerInput;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomersInput;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedOneWithoutChildInformPartnerCustomersInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerCreateWithoutRolesInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutInformPartnerCustomersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlace?: Maybe<GooglePlaceCreateNestedOneWithoutInformPartnerCustomersInput>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerCustomerInput;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomersInput;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedOneWithoutChildInformPartnerCustomersInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerGroupByOutputType = {
  __typename?: 'InformPartnerCustomerGroupByOutputType';
  _count?: Maybe<InformPartnerCustomerCountAggregateOutputType>;
  _max?: Maybe<InformPartnerCustomerMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerCustomerMinAggregateOutputType>;
  checksum: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  visibility: InformPartnerCustomerVisibility;
};

export type InformPartnerCustomerInformPartnerIdClinicIdCompoundUniqueInput = {
  clinicId: Scalars['String'];
  informPartnerId: Scalars['String'];
};

export type InformPartnerCustomerInformPartnerIdExternalIdCompoundUniqueInput = {
  externalId: Scalars['String'];
  informPartnerId: Scalars['String'];
};

export type InformPartnerCustomerListRelationFilter = {
  every?: Maybe<InformPartnerCustomerWhereInput>;
  none?: Maybe<InformPartnerCustomerWhereInput>;
  some?: Maybe<InformPartnerCustomerWhereInput>;
};

export type InformPartnerCustomerMaxAggregateOutputType = {
  __typename?: 'InformPartnerCustomerMaxAggregateOutputType';
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerMaxOrderByAggregateInput = {
  checksum?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  googlePlaceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentExternalId?: Maybe<SortOrder>;
  parentInformPartnerCustomerId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export type InformPartnerCustomerMinAggregateOutputType = {
  __typename?: 'InformPartnerCustomerMinAggregateOutputType';
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerMinOrderByAggregateInput = {
  checksum?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  googlePlaceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentExternalId?: Maybe<SortOrder>;
  parentInformPartnerCustomerId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export type InformPartnerCustomerNullableScalarRelationFilter = {
  AND?: Maybe<Array<InformPartnerCustomerWhereInput>>;
  NOT?: Maybe<Array<InformPartnerCustomerWhereInput>>;
  OR?: Maybe<Array<InformPartnerCustomerWhereInput>>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentListRelationFilter>;
  checksum?: Maybe<StringFilter>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  externalId?: Maybe<StringFilter>;
  googlePlace?: Maybe<GooglePlaceNullableScalarRelationFilter>;
  googlePlaceId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationScalarRelationFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  name?: Maybe<StringFilter>;
  parentExternalId?: Maybe<StringNullableFilter>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerNullableScalarRelationFilter>;
  parentInformPartnerCustomerId?: Maybe<StringNullableFilter>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderListRelationFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  roles?: Maybe<InformPartnerUserRoleListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visibility?: Maybe<EnumInformPartnerCustomerVisibilityFilter>;
};

export type InformPartnerCustomerOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformPartnerCustomerOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerCustomerOrderByRelevanceInput>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentOrderByRelationAggregateInput>;
  checksum?: Maybe<SortOrder>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  googlePlace?: Maybe<GooglePlaceOrderByWithRelationInput>;
  googlePlaceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationOrderByWithRelationInput>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  informPartnerUsers?: Maybe<InformPartnerUserOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  parentExternalId?: Maybe<SortOrder>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerOrderByWithRelationInput>;
  parentInformPartnerCustomerId?: Maybe<SortOrder>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderOrderByRelationAggregateInput>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  roles?: Maybe<InformPartnerUserRoleOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export enum InformPartnerCustomerOrderByRelevanceFieldEnum {
  Checksum = 'checksum',
  ClinicId = 'clinicId',
  ExternalId = 'externalId',
  GooglePlaceId = 'googlePlaceId',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  InformPartnerIntegrationId = 'informPartnerIntegrationId',
  Name = 'name',
  ParentExternalId = 'parentExternalId',
  ParentInformPartnerCustomerId = 'parentInformPartnerCustomerId',
  PhoneNumber = 'phoneNumber',
  PostalCode = 'postalCode'
}

export type InformPartnerCustomerOrderByRelevanceInput = {
  fields: Array<InformPartnerCustomerOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformPartnerCustomerOrderByWithAggregationInput = {
  _count?: Maybe<InformPartnerCustomerCountOrderByAggregateInput>;
  _max?: Maybe<InformPartnerCustomerMaxOrderByAggregateInput>;
  _min?: Maybe<InformPartnerCustomerMinOrderByAggregateInput>;
  checksum?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  googlePlaceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentExternalId?: Maybe<SortOrder>;
  parentInformPartnerCustomerId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export type InformPartnerCustomerOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerCustomerOrderByRelevanceInput>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentOrderByRelationAggregateInput>;
  checksum?: Maybe<SortOrder>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  googlePlace?: Maybe<GooglePlaceOrderByWithRelationInput>;
  googlePlaceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationOrderByWithRelationInput>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  informPartnerUsers?: Maybe<InformPartnerUserOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  parentExternalId?: Maybe<SortOrder>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerOrderByWithRelationInput>;
  parentInformPartnerCustomerId?: Maybe<SortOrder>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderOrderByRelationAggregateInput>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  roles?: Maybe<InformPartnerUserRoleOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export type InformPartnerCustomerOrderByWithRelationInput = {
  _relevance?: Maybe<InformPartnerCustomerOrderByRelevanceInput>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentOrderByRelationAggregateInput>;
  checksum?: Maybe<SortOrder>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  googlePlace?: Maybe<GooglePlaceOrderByWithRelationInput>;
  googlePlaceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationOrderByWithRelationInput>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  informPartnerUsers?: Maybe<InformPartnerUserOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  parentExternalId?: Maybe<SortOrder>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerOrderByWithRelationInput>;
  parentInformPartnerCustomerId?: Maybe<SortOrder>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderOrderByRelationAggregateInput>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  roles?: Maybe<InformPartnerUserRoleOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  visibility?: Maybe<SortOrder>;
};

export type InformPartnerCustomerPharmacyProvider = {
  __typename?: 'InformPartnerCustomerPharmacyProvider';
  createdAt: Scalars['DateTime'];
  externalId: Scalars['String'];
  id: Scalars['String'];
  informPartnerCustomer?: Maybe<InformPartnerCustomer>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerIntegration: InformPartnerIntegration;
  informPartnerIntegrationId: Scalars['String'];
  name: InformPartnerCustomerPharmacyProviderName;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerCustomerPharmacyProviderStatus;
  type: InformPartnerCustomerPharmacyProviderType;
  updatedAt: Scalars['DateTime'];
};


export type InformPartnerCustomerPharmacyProviderInformPartnerCustomerArgs = {
  where?: Maybe<InformPartnerCustomerWhereInput>;
};

export type InformPartnerCustomerPharmacyProviderCountAggregateOutputType = {
  __typename?: 'InformPartnerCustomerPharmacyProviderCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  externalId: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerCustomerId: Scalars['Int'];
  informPartnerIntegrationId: Scalars['Int'];
  name: Scalars['Int'];
  onlinePharmacyUrl: Scalars['Int'];
  phoneNumber: Scalars['Int'];
  postalCode: Scalars['Int'];
  rawData: Scalars['Int'];
  settings: Scalars['Int'];
  status: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformPartnerCustomerPharmacyProviderCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerCustomerPharmacyProviderCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedOneWithoutPharmacyProvidersInput>;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomerPharmacyProvidersInput;
  name: InformPartnerCustomerPharmacyProviderName;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type: InformPartnerCustomerPharmacyProviderType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderCreateManyInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId: Scalars['String'];
  name: InformPartnerCustomerPharmacyProviderName;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type: InformPartnerCustomerPharmacyProviderType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderCreateManyInformPartnerCustomerInputEnvelope = {
  data: Array<InformPartnerCustomerPharmacyProviderCreateManyInformPartnerCustomerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerCustomerPharmacyProviderCreateManyInformPartnerIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  name: InformPartnerCustomerPharmacyProviderName;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type: InformPartnerCustomerPharmacyProviderType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderCreateManyInformPartnerIntegrationInputEnvelope = {
  data: Array<InformPartnerCustomerPharmacyProviderCreateManyInformPartnerIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerCustomerPharmacyProviderCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId: Scalars['String'];
  name: InformPartnerCustomerPharmacyProviderName;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type: InformPartnerCustomerPharmacyProviderType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerCustomerInput = {
  connect?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateOrConnectWithoutInformPartnerCustomerInput>>;
  create?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerCustomerInput>>;
  createMany?: Maybe<InformPartnerCustomerPharmacyProviderCreateManyInformPartnerCustomerInputEnvelope>;
};

export type InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerIntegrationInput = {
  connect?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerCustomerPharmacyProviderCreateManyInformPartnerIntegrationInputEnvelope>;
};

export type InformPartnerCustomerPharmacyProviderCreateOrConnectWithoutInformPartnerCustomerInput = {
  create: InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerCustomerInput;
  where: InformPartnerCustomerPharmacyProviderWhereUniqueInput;
};

export type InformPartnerCustomerPharmacyProviderCreateOrConnectWithoutInformPartnerIntegrationInput = {
  create: InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerIntegrationInput;
  where: InformPartnerCustomerPharmacyProviderWhereUniqueInput;
};

export type InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomerPharmacyProvidersInput;
  name: InformPartnerCustomerPharmacyProviderName;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type: InformPartnerCustomerPharmacyProviderType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerCreateNestedOneWithoutPharmacyProvidersInput>;
  name: InformPartnerCustomerPharmacyProviderName;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type: InformPartnerCustomerPharmacyProviderType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderExternalIdNameCompoundUniqueInput = {
  externalId: Scalars['String'];
  name: InformPartnerCustomerPharmacyProviderName;
};

export type InformPartnerCustomerPharmacyProviderGroupByOutputType = {
  __typename?: 'InformPartnerCustomerPharmacyProviderGroupByOutputType';
  _count?: Maybe<InformPartnerCustomerPharmacyProviderCountAggregateOutputType>;
  _max?: Maybe<InformPartnerCustomerPharmacyProviderMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerCustomerPharmacyProviderMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  externalId: Scalars['String'];
  id: Scalars['String'];
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId: Scalars['String'];
  name: InformPartnerCustomerPharmacyProviderName;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerCustomerPharmacyProviderStatus;
  type: InformPartnerCustomerPharmacyProviderType;
  updatedAt: Scalars['DateTime'];
};

export type InformPartnerCustomerPharmacyProviderListRelationFilter = {
  every?: Maybe<InformPartnerCustomerPharmacyProviderWhereInput>;
  none?: Maybe<InformPartnerCustomerPharmacyProviderWhereInput>;
  some?: Maybe<InformPartnerCustomerPharmacyProviderWhereInput>;
};

export type InformPartnerCustomerPharmacyProviderMaxAggregateOutputType = {
  __typename?: 'InformPartnerCustomerPharmacyProviderMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerCustomerPharmacyProviderMinAggregateOutputType = {
  __typename?: 'InformPartnerCustomerPharmacyProviderMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerCustomerPharmacyProviderName {
  Vetsource = 'Vetsource'
}

export type InformPartnerCustomerPharmacyProviderOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformPartnerCustomerPharmacyProviderOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerCustomerPharmacyProviderOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerOrderByWithRelationInput>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationOrderByWithRelationInput>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerCustomerPharmacyProviderOrderByRelevanceFieldEnum {
  ExternalId = 'externalId',
  Id = 'id',
  InformPartnerCustomerId = 'informPartnerCustomerId',
  InformPartnerIntegrationId = 'informPartnerIntegrationId',
  OnlinePharmacyUrl = 'onlinePharmacyUrl',
  PhoneNumber = 'phoneNumber',
  PostalCode = 'postalCode'
}

export type InformPartnerCustomerPharmacyProviderOrderByRelevanceInput = {
  fields: Array<InformPartnerCustomerPharmacyProviderOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformPartnerCustomerPharmacyProviderOrderByWithAggregationInput = {
  _count?: Maybe<InformPartnerCustomerPharmacyProviderCountOrderByAggregateInput>;
  _max?: Maybe<InformPartnerCustomerPharmacyProviderMaxOrderByAggregateInput>;
  _min?: Maybe<InformPartnerCustomerPharmacyProviderMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerCustomerPharmacyProviderOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerCustomerPharmacyProviderOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerOrderByWithRelationInput>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationOrderByWithRelationInput>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerCustomerPharmacyProviderOrderByWithRelationInput = {
  _relevance?: Maybe<InformPartnerCustomerPharmacyProviderOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerOrderByWithRelationInput>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationOrderByWithRelationInput>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  onlinePharmacyUrl?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerCustomerPharmacyProviderScalarFieldEnum {
  CreatedAt = 'createdAt',
  ExternalId = 'externalId',
  Id = 'id',
  InformPartnerCustomerId = 'informPartnerCustomerId',
  InformPartnerIntegrationId = 'informPartnerIntegrationId',
  Name = 'name',
  OnlinePharmacyUrl = 'onlinePharmacyUrl',
  PhoneNumber = 'phoneNumber',
  PostalCode = 'postalCode',
  RawData = 'rawData',
  Settings = 'settings',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type InformPartnerCustomerPharmacyProviderScalarWhereInput = {
  AND?: Maybe<Array<InformPartnerCustomerPharmacyProviderScalarWhereInput>>;
  NOT?: Maybe<Array<InformPartnerCustomerPharmacyProviderScalarWhereInput>>;
  OR?: Maybe<Array<InformPartnerCustomerPharmacyProviderScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  externalId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  informPartnerCustomerId?: Maybe<StringNullableFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  name?: Maybe<EnumInformPartnerCustomerPharmacyProviderNameFilter>;
  onlinePharmacyUrl?: Maybe<StringNullableFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerCustomerPharmacyProviderStatusFilter>;
  type?: Maybe<EnumInformPartnerCustomerPharmacyProviderTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerCustomerPharmacyProviderScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformPartnerCustomerPharmacyProviderScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformPartnerCustomerPharmacyProviderScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformPartnerCustomerPharmacyProviderScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  externalId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerCustomerId?: Maybe<StringNullableWithAggregatesFilter>;
  informPartnerIntegrationId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<EnumInformPartnerCustomerPharmacyProviderNameWithAggregatesFilter>;
  onlinePharmacyUrl?: Maybe<StringNullableWithAggregatesFilter>;
  phoneNumber?: Maybe<StringNullableWithAggregatesFilter>;
  postalCode?: Maybe<StringNullableWithAggregatesFilter>;
  rawData?: Maybe<JsonNullableWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  status?: Maybe<EnumInformPartnerCustomerPharmacyProviderStatusWithAggregatesFilter>;
  type?: Maybe<EnumInformPartnerCustomerPharmacyProviderTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformPartnerCustomerPharmacyProviderStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export enum InformPartnerCustomerPharmacyProviderType {
  InStore = 'InStore',
  Online = 'Online',
  OnlineAndInStore = 'OnlineAndInStore'
}

export type InformPartnerCustomerPharmacyProviderUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId: Scalars['String'];
  name: InformPartnerCustomerPharmacyProviderName;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type: InformPartnerCustomerPharmacyProviderType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerCustomerInput = {
  connect?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateOrConnectWithoutInformPartnerCustomerInput>>;
  create?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerCustomerInput>>;
  createMany?: Maybe<InformPartnerCustomerPharmacyProviderCreateManyInformPartnerCustomerInputEnvelope>;
};

export type InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput = {
  connect?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerCustomerPharmacyProviderCreateManyInformPartnerIntegrationInputEnvelope>;
};

export type InformPartnerCustomerPharmacyProviderUncheckedCreateWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId: Scalars['String'];
  name: InformPartnerCustomerPharmacyProviderName;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type: InformPartnerCustomerPharmacyProviderType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUncheckedCreateWithoutInformPartnerIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  name: InformPartnerCustomerPharmacyProviderName;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type: InformPartnerCustomerPharmacyProviderType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateOrConnectWithoutInformPartnerCustomerInput>>;
  create?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerCustomerInput>>;
  createMany?: Maybe<InformPartnerCustomerPharmacyProviderCreateManyInformPartnerCustomerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerPharmacyProviderScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerPharmacyProviderUpdateWithWhereUniqueWithoutInformPartnerCustomerInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerPharmacyProviderUpdateManyWithWhereWithoutInformPartnerCustomerInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerPharmacyProviderUpsertWithWhereUniqueWithoutInformPartnerCustomerInput>>;
};

export type InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerCustomerPharmacyProviderCreateManyInformPartnerIntegrationInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerPharmacyProviderScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerPharmacyProviderUpdateWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerPharmacyProviderUpdateManyWithWhereWithoutInformPartnerIntegrationInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerPharmacyProviderUpsertWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
};

export type InformPartnerCustomerPharmacyProviderUncheckedUpdateWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUncheckedUpdateWithoutInformPartnerIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneWithoutPharmacyProvidersNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomerPharmacyProvidersNestedInput>;
  name?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUpdateManyWithWhereWithoutInformPartnerCustomerInput = {
  data: InformPartnerCustomerPharmacyProviderUpdateManyMutationInput;
  where: InformPartnerCustomerPharmacyProviderScalarWhereInput;
};

export type InformPartnerCustomerPharmacyProviderUpdateManyWithWhereWithoutInformPartnerIntegrationInput = {
  data: InformPartnerCustomerPharmacyProviderUpdateManyMutationInput;
  where: InformPartnerCustomerPharmacyProviderScalarWhereInput;
};

export type InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerCustomerNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateOrConnectWithoutInformPartnerCustomerInput>>;
  create?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerCustomerInput>>;
  createMany?: Maybe<InformPartnerCustomerPharmacyProviderCreateManyInformPartnerCustomerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerPharmacyProviderScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerPharmacyProviderUpdateWithWhereUniqueWithoutInformPartnerCustomerInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerPharmacyProviderUpdateManyWithWhereWithoutInformPartnerCustomerInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerPharmacyProviderUpsertWithWhereUniqueWithoutInformPartnerCustomerInput>>;
};

export type InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerIntegrationNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerCustomerPharmacyProviderCreateManyInformPartnerIntegrationInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerPharmacyProviderScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerPharmacyProviderUpdateWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerPharmacyProviderUpdateManyWithWhereWithoutInformPartnerIntegrationInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerPharmacyProviderUpsertWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
};

export type InformPartnerCustomerPharmacyProviderUpdateWithWhereUniqueWithoutInformPartnerCustomerInput = {
  data: InformPartnerCustomerPharmacyProviderUpdateWithoutInformPartnerCustomerInput;
  where: InformPartnerCustomerPharmacyProviderWhereUniqueInput;
};

export type InformPartnerCustomerPharmacyProviderUpdateWithWhereUniqueWithoutInformPartnerIntegrationInput = {
  data: InformPartnerCustomerPharmacyProviderUpdateWithoutInformPartnerIntegrationInput;
  where: InformPartnerCustomerPharmacyProviderWhereUniqueInput;
};

export type InformPartnerCustomerPharmacyProviderUpdateWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomerPharmacyProvidersNestedInput>;
  name?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUpdateWithoutInformPartnerIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneWithoutPharmacyProvidersNestedInput>;
  name?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  onlinePharmacyUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  type?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerCustomerPharmacyProviderUpsertWithWhereUniqueWithoutInformPartnerCustomerInput = {
  create: InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerCustomerInput;
  update: InformPartnerCustomerPharmacyProviderUpdateWithoutInformPartnerCustomerInput;
  where: InformPartnerCustomerPharmacyProviderWhereUniqueInput;
};

export type InformPartnerCustomerPharmacyProviderUpsertWithWhereUniqueWithoutInformPartnerIntegrationInput = {
  create: InformPartnerCustomerPharmacyProviderCreateWithoutInformPartnerIntegrationInput;
  update: InformPartnerCustomerPharmacyProviderUpdateWithoutInformPartnerIntegrationInput;
  where: InformPartnerCustomerPharmacyProviderWhereUniqueInput;
};

export type InformPartnerCustomerPharmacyProviderWhereInput = {
  AND?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereInput>>;
  NOT?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereInput>>;
  OR?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  externalId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerNullableScalarRelationFilter>;
  informPartnerCustomerId?: Maybe<StringNullableFilter>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationScalarRelationFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  name?: Maybe<EnumInformPartnerCustomerPharmacyProviderNameFilter>;
  onlinePharmacyUrl?: Maybe<StringNullableFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerCustomerPharmacyProviderStatusFilter>;
  type?: Maybe<EnumInformPartnerCustomerPharmacyProviderTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerCustomerPharmacyProviderWhereUniqueInput = {
  AND?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereInput>>;
  NOT?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereInput>>;
  OR?: Maybe<Array<InformPartnerCustomerPharmacyProviderWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  externalId?: Maybe<StringFilter>;
  externalId_name?: Maybe<InformPartnerCustomerPharmacyProviderExternalIdNameCompoundUniqueInput>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerNullableScalarRelationFilter>;
  informPartnerCustomerId?: Maybe<StringNullableFilter>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationScalarRelationFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  name?: Maybe<EnumInformPartnerCustomerPharmacyProviderNameFilter>;
  onlinePharmacyUrl?: Maybe<StringNullableFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerCustomerPharmacyProviderStatusFilter>;
  type?: Maybe<EnumInformPartnerCustomerPharmacyProviderTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum InformPartnerCustomerScalarFieldEnum {
  Checksum = 'checksum',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  ExternalId = 'externalId',
  GooglePlaceId = 'googlePlaceId',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  InformPartnerIntegrationId = 'informPartnerIntegrationId',
  Name = 'name',
  ParentExternalId = 'parentExternalId',
  ParentInformPartnerCustomerId = 'parentInformPartnerCustomerId',
  PhoneNumber = 'phoneNumber',
  PostalCode = 'postalCode',
  RawData = 'rawData',
  UpdatedAt = 'updatedAt',
  Visibility = 'visibility'
}

export type InformPartnerCustomerScalarRelationFilter = {
  AND?: Maybe<Array<InformPartnerCustomerWhereInput>>;
  NOT?: Maybe<Array<InformPartnerCustomerWhereInput>>;
  OR?: Maybe<Array<InformPartnerCustomerWhereInput>>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentListRelationFilter>;
  checksum?: Maybe<StringFilter>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  externalId?: Maybe<StringFilter>;
  googlePlace?: Maybe<GooglePlaceNullableScalarRelationFilter>;
  googlePlaceId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationScalarRelationFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  name?: Maybe<StringFilter>;
  parentExternalId?: Maybe<StringNullableFilter>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerNullableScalarRelationFilter>;
  parentInformPartnerCustomerId?: Maybe<StringNullableFilter>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderListRelationFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  roles?: Maybe<InformPartnerUserRoleListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visibility?: Maybe<EnumInformPartnerCustomerVisibilityFilter>;
};

export type InformPartnerCustomerScalarWhereInput = {
  AND?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  NOT?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  OR?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  checksum?: Maybe<StringFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  externalId?: Maybe<StringFilter>;
  googlePlaceId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  parentExternalId?: Maybe<StringNullableFilter>;
  parentInformPartnerCustomerId?: Maybe<StringNullableFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visibility?: Maybe<EnumInformPartnerCustomerVisibilityFilter>;
};

export type InformPartnerCustomerScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformPartnerCustomerScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformPartnerCustomerScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformPartnerCustomerScalarWhereWithAggregatesInput>>;
  checksum?: Maybe<StringWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  externalId?: Maybe<StringWithAggregatesFilter>;
  googlePlaceId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerId?: Maybe<StringWithAggregatesFilter>;
  informPartnerIntegrationId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  parentExternalId?: Maybe<StringNullableWithAggregatesFilter>;
  parentInformPartnerCustomerId?: Maybe<StringNullableWithAggregatesFilter>;
  phoneNumber?: Maybe<StringNullableWithAggregatesFilter>;
  postalCode?: Maybe<StringNullableWithAggregatesFilter>;
  rawData?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  visibility?: Maybe<EnumInformPartnerCustomerVisibilityWithAggregatesFilter>;
};

export type InformPartnerCustomerUncheckedCreateInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutClinicInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyClinicInputEnvelope>;
};

export type InformPartnerCustomerUncheckedCreateNestedManyWithoutGooglePlaceInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutGooglePlaceInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutGooglePlaceInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyGooglePlaceInputEnvelope>;
};

export type InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyInformPartnerInputEnvelope>;
};

export type InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyInformPartnerIntegrationInputEnvelope>;
};

export type InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerUsersInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutInformPartnerUsersInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutInformPartnerUsersInput>>;
};

export type InformPartnerCustomerUncheckedCreateNestedManyWithoutParentInformPartnerCustomerInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutParentInformPartnerCustomerInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutParentInformPartnerCustomerInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyParentInformPartnerCustomerInputEnvelope>;
};

export type InformPartnerCustomerUncheckedCreateWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedCreateWithoutChildInformPartnerCustomersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedCreateWithoutClinicInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedCreateWithoutGooglePlaceInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedCreateWithoutInformPartnerInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedCreateWithoutInformPartnerIntegrationInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedCreateWithoutInformPartnerUsersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedCreateWithoutParentInformPartnerCustomerInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedCreateWithoutPharmacyProvidersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedCreateWithoutRolesInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  checksum: Scalars['String'];
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutParentInformPartnerCustomerInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerCustomersInput>;
  name: Scalars['String'];
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerCustomerInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateManyInput = {
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateManyWithoutClinicInput = {
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutClinicInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type InformPartnerCustomerUncheckedUpdateManyWithoutGooglePlaceInput = {
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateManyWithoutGooglePlaceNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutGooglePlaceInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutGooglePlaceInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyGooglePlaceInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerUpdateWithWhereUniqueWithoutGooglePlaceInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerUpdateManyWithWhereWithoutGooglePlaceInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerUpsertWithWhereUniqueWithoutGooglePlaceInput>>;
};

export type InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerInput = {
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerIntegrationInput = {
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyInformPartnerIntegrationInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerUpdateWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerUpdateManyWithWhereWithoutInformPartnerIntegrationInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerUpsertWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
};

export type InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerUsersInput = {
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerUsersNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutInformPartnerUsersInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutInformPartnerUsersInput>>;
  delete?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerUpdateWithWhereUniqueWithoutInformPartnerUsersInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerUpdateManyWithWhereWithoutInformPartnerUsersInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerUpsertWithWhereUniqueWithoutInformPartnerUsersInput>>;
};

export type InformPartnerCustomerUncheckedUpdateManyWithoutParentInformPartnerCustomerInput = {
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateManyWithoutParentInformPartnerCustomerNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutParentInformPartnerCustomerInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutParentInformPartnerCustomerInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyParentInformPartnerCustomerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerUpdateWithWhereUniqueWithoutParentInformPartnerCustomerInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerUpdateManyWithWhereWithoutParentInformPartnerCustomerInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerUpsertWithWhereUniqueWithoutParentInformPartnerCustomerInput>>;
};

export type InformPartnerCustomerUncheckedUpdateWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateWithoutChildInformPartnerCustomersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateWithoutClinicInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateWithoutGooglePlaceInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateWithoutInformPartnerInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateWithoutInformPartnerIntegrationInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateWithoutInformPartnerUsersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateWithoutParentInformPartnerCustomerInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateWithoutPharmacyProvidersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUncheckedUpdateWithoutRolesInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomerId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpdateInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutInformPartnerCustomersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutInformPartnerCustomersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerCustomerNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomersNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneWithoutChildInformPartnerCustomersNestedInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpdateManyMutationInput = {
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpdateManyWithWhereWithoutClinicInput = {
  data: InformPartnerCustomerUpdateManyMutationInput;
  where: InformPartnerCustomerScalarWhereInput;
};

export type InformPartnerCustomerUpdateManyWithWhereWithoutGooglePlaceInput = {
  data: InformPartnerCustomerUpdateManyMutationInput;
  where: InformPartnerCustomerScalarWhereInput;
};

export type InformPartnerCustomerUpdateManyWithWhereWithoutInformPartnerInput = {
  data: InformPartnerCustomerUpdateManyMutationInput;
  where: InformPartnerCustomerScalarWhereInput;
};

export type InformPartnerCustomerUpdateManyWithWhereWithoutInformPartnerIntegrationInput = {
  data: InformPartnerCustomerUpdateManyMutationInput;
  where: InformPartnerCustomerScalarWhereInput;
};

export type InformPartnerCustomerUpdateManyWithWhereWithoutInformPartnerUsersInput = {
  data: InformPartnerCustomerUpdateManyMutationInput;
  where: InformPartnerCustomerScalarWhereInput;
};

export type InformPartnerCustomerUpdateManyWithWhereWithoutParentInformPartnerCustomerInput = {
  data: InformPartnerCustomerUpdateManyMutationInput;
  where: InformPartnerCustomerScalarWhereInput;
};

export type InformPartnerCustomerUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutClinicInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type InformPartnerCustomerUpdateManyWithoutGooglePlaceNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutGooglePlaceInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutGooglePlaceInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyGooglePlaceInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerUpdateWithWhereUniqueWithoutGooglePlaceInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerUpdateManyWithWhereWithoutGooglePlaceInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerUpsertWithWhereUniqueWithoutGooglePlaceInput>>;
};

export type InformPartnerCustomerUpdateManyWithoutInformPartnerIntegrationNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyInformPartnerIntegrationInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerUpdateWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerUpdateManyWithWhereWithoutInformPartnerIntegrationInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerUpsertWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
};

export type InformPartnerCustomerUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformPartnerCustomerUpdateManyWithoutInformPartnerUsersNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutInformPartnerUsersInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutInformPartnerUsersInput>>;
  delete?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerUpdateWithWhereUniqueWithoutInformPartnerUsersInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerUpdateManyWithWhereWithoutInformPartnerUsersInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerUpsertWithWhereUniqueWithoutInformPartnerUsersInput>>;
};

export type InformPartnerCustomerUpdateManyWithoutParentInformPartnerCustomerNestedInput = {
  connect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerCustomerCreateOrConnectWithoutParentInformPartnerCustomerInput>>;
  create?: Maybe<Array<InformPartnerCustomerCreateWithoutParentInformPartnerCustomerInput>>;
  createMany?: Maybe<InformPartnerCustomerCreateManyParentInformPartnerCustomerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerCustomerScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerCustomerWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerCustomerUpdateWithWhereUniqueWithoutParentInformPartnerCustomerInput>>;
  updateMany?: Maybe<Array<InformPartnerCustomerUpdateManyWithWhereWithoutParentInformPartnerCustomerInput>>;
  upsert?: Maybe<Array<InformPartnerCustomerUpsertWithWhereUniqueWithoutParentInformPartnerCustomerInput>>;
};

export type InformPartnerCustomerUpdateOneRequiredWithoutBoehringerIngelheimCustomerAlignmentsNestedInput = {
  connect?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCustomerCreateOrConnectWithoutBoehringerIngelheimCustomerAlignmentsInput>;
  create?: Maybe<InformPartnerCustomerCreateWithoutBoehringerIngelheimCustomerAlignmentsInput>;
  update?: Maybe<InformPartnerCustomerUpdateToOneWithWhereWithoutBoehringerIngelheimCustomerAlignmentsInput>;
  upsert?: Maybe<InformPartnerCustomerUpsertWithoutBoehringerIngelheimCustomerAlignmentsInput>;
};

export type InformPartnerCustomerUpdateOneRequiredWithoutRolesNestedInput = {
  connect?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCustomerCreateOrConnectWithoutRolesInput>;
  create?: Maybe<InformPartnerCustomerCreateWithoutRolesInput>;
  update?: Maybe<InformPartnerCustomerUpdateToOneWithWhereWithoutRolesInput>;
  upsert?: Maybe<InformPartnerCustomerUpsertWithoutRolesInput>;
};

export type InformPartnerCustomerUpdateOneWithoutChildInformPartnerCustomersNestedInput = {
  connect?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCustomerCreateOrConnectWithoutChildInformPartnerCustomersInput>;
  create?: Maybe<InformPartnerCustomerCreateWithoutChildInformPartnerCustomersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformPartnerCustomerUpdateToOneWithWhereWithoutChildInformPartnerCustomersInput>;
  upsert?: Maybe<InformPartnerCustomerUpsertWithoutChildInformPartnerCustomersInput>;
};

export type InformPartnerCustomerUpdateOneWithoutPharmacyProvidersNestedInput = {
  connect?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCustomerCreateOrConnectWithoutPharmacyProvidersInput>;
  create?: Maybe<InformPartnerCustomerCreateWithoutPharmacyProvidersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformPartnerCustomerUpdateToOneWithWhereWithoutPharmacyProvidersInput>;
  upsert?: Maybe<InformPartnerCustomerUpsertWithoutPharmacyProvidersInput>;
};

export type InformPartnerCustomerUpdateToOneWithWhereWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  data: InformPartnerCustomerUpdateWithoutBoehringerIngelheimCustomerAlignmentsInput;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};

export type InformPartnerCustomerUpdateToOneWithWhereWithoutChildInformPartnerCustomersInput = {
  data: InformPartnerCustomerUpdateWithoutChildInformPartnerCustomersInput;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};

export type InformPartnerCustomerUpdateToOneWithWhereWithoutPharmacyProvidersInput = {
  data: InformPartnerCustomerUpdateWithoutPharmacyProvidersInput;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};

export type InformPartnerCustomerUpdateToOneWithWhereWithoutRolesInput = {
  data: InformPartnerCustomerUpdateWithoutRolesInput;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};

export type InformPartnerCustomerUpdateWithWhereUniqueWithoutClinicInput = {
  data: InformPartnerCustomerUpdateWithoutClinicInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerUpdateWithWhereUniqueWithoutGooglePlaceInput = {
  data: InformPartnerCustomerUpdateWithoutGooglePlaceInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerUpdateWithWhereUniqueWithoutInformPartnerInput = {
  data: InformPartnerCustomerUpdateWithoutInformPartnerInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerUpdateWithWhereUniqueWithoutInformPartnerIntegrationInput = {
  data: InformPartnerCustomerUpdateWithoutInformPartnerIntegrationInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerUpdateWithWhereUniqueWithoutInformPartnerUsersInput = {
  data: InformPartnerCustomerUpdateWithoutInformPartnerUsersInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerUpdateWithWhereUniqueWithoutParentInformPartnerCustomerInput = {
  data: InformPartnerCustomerUpdateWithoutParentInformPartnerCustomerInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerUpdateWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutInformPartnerCustomersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutInformPartnerCustomersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerCustomerNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomersNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneWithoutChildInformPartnerCustomersNestedInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpdateWithoutChildInformPartnerCustomersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneWithoutInformPartnerCustomersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutInformPartnerCustomersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerCustomerNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomersNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneWithoutChildInformPartnerCustomersNestedInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpdateWithoutClinicInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutInformPartnerCustomersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerCustomerNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomersNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneWithoutChildInformPartnerCustomersNestedInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpdateWithoutGooglePlaceInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutInformPartnerCustomersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerCustomerNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomersNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneWithoutChildInformPartnerCustomersNestedInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpdateWithoutInformPartnerInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutInformPartnerCustomersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutInformPartnerCustomersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomersNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneWithoutChildInformPartnerCustomersNestedInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpdateWithoutInformPartnerIntegrationInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutInformPartnerCustomersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutInformPartnerCustomersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerCustomerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneWithoutChildInformPartnerCustomersNestedInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpdateWithoutInformPartnerUsersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutInformPartnerCustomersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutInformPartnerCustomersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerCustomerNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneWithoutChildInformPartnerCustomersNestedInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpdateWithoutParentInformPartnerCustomerInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutInformPartnerCustomersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutInformPartnerCustomersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerCustomerNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomersNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpdateWithoutPharmacyProvidersInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutInformPartnerCustomersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutInformPartnerCustomersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerCustomerNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomersNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneWithoutChildInformPartnerCustomersNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerCustomerNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpdateWithoutRolesInput = {
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentUpdateManyWithoutInformPartnerCustomerNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutParentInformPartnerCustomerNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutInformPartnerCustomersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GooglePlaceUpdateOneWithoutInformPartnerCustomersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerCustomerNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomersNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerCustomersNestedInput>;
  name?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneWithoutChildInformPartnerCustomersNestedInput>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerCustomerNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<InformPartnerCustomerVisibility>;
};

export type InformPartnerCustomerUpsertWithWhereUniqueWithoutClinicInput = {
  create: InformPartnerCustomerCreateWithoutClinicInput;
  update: InformPartnerCustomerUpdateWithoutClinicInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerUpsertWithWhereUniqueWithoutGooglePlaceInput = {
  create: InformPartnerCustomerCreateWithoutGooglePlaceInput;
  update: InformPartnerCustomerUpdateWithoutGooglePlaceInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerUpsertWithWhereUniqueWithoutInformPartnerInput = {
  create: InformPartnerCustomerCreateWithoutInformPartnerInput;
  update: InformPartnerCustomerUpdateWithoutInformPartnerInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerUpsertWithWhereUniqueWithoutInformPartnerIntegrationInput = {
  create: InformPartnerCustomerCreateWithoutInformPartnerIntegrationInput;
  update: InformPartnerCustomerUpdateWithoutInformPartnerIntegrationInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerUpsertWithWhereUniqueWithoutInformPartnerUsersInput = {
  create: InformPartnerCustomerCreateWithoutInformPartnerUsersInput;
  update: InformPartnerCustomerUpdateWithoutInformPartnerUsersInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerUpsertWithWhereUniqueWithoutParentInformPartnerCustomerInput = {
  create: InformPartnerCustomerCreateWithoutParentInformPartnerCustomerInput;
  update: InformPartnerCustomerUpdateWithoutParentInformPartnerCustomerInput;
  where: InformPartnerCustomerWhereUniqueInput;
};

export type InformPartnerCustomerUpsertWithoutBoehringerIngelheimCustomerAlignmentsInput = {
  create: InformPartnerCustomerCreateWithoutBoehringerIngelheimCustomerAlignmentsInput;
  update: InformPartnerCustomerUpdateWithoutBoehringerIngelheimCustomerAlignmentsInput;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};

export type InformPartnerCustomerUpsertWithoutChildInformPartnerCustomersInput = {
  create: InformPartnerCustomerCreateWithoutChildInformPartnerCustomersInput;
  update: InformPartnerCustomerUpdateWithoutChildInformPartnerCustomersInput;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};

export type InformPartnerCustomerUpsertWithoutPharmacyProvidersInput = {
  create: InformPartnerCustomerCreateWithoutPharmacyProvidersInput;
  update: InformPartnerCustomerUpdateWithoutPharmacyProvidersInput;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};

export type InformPartnerCustomerUpsertWithoutRolesInput = {
  create: InformPartnerCustomerCreateWithoutRolesInput;
  update: InformPartnerCustomerUpdateWithoutRolesInput;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};

export enum InformPartnerCustomerVisibility {
  Hidden = 'Hidden',
  Visible = 'Visible'
}

export type InformPartnerCustomerWhereInput = {
  AND?: Maybe<Array<InformPartnerCustomerWhereInput>>;
  NOT?: Maybe<Array<InformPartnerCustomerWhereInput>>;
  OR?: Maybe<Array<InformPartnerCustomerWhereInput>>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentListRelationFilter>;
  checksum?: Maybe<StringFilter>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  externalId?: Maybe<StringFilter>;
  googlePlace?: Maybe<GooglePlaceNullableScalarRelationFilter>;
  googlePlaceId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationScalarRelationFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  name?: Maybe<StringFilter>;
  parentExternalId?: Maybe<StringNullableFilter>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerNullableScalarRelationFilter>;
  parentInformPartnerCustomerId?: Maybe<StringNullableFilter>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderListRelationFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  roles?: Maybe<InformPartnerUserRoleListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visibility?: Maybe<EnumInformPartnerCustomerVisibilityFilter>;
};

export type InformPartnerCustomerWhereUniqueInput = {
  AND?: Maybe<Array<InformPartnerCustomerWhereInput>>;
  NOT?: Maybe<Array<InformPartnerCustomerWhereInput>>;
  OR?: Maybe<Array<InformPartnerCustomerWhereInput>>;
  boehringerIngelheimCustomerAlignments?: Maybe<BoehringerIngelheimCustomerAlignmentListRelationFilter>;
  checksum?: Maybe<StringFilter>;
  childInformPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  externalId?: Maybe<StringFilter>;
  googlePlace?: Maybe<GooglePlaceNullableScalarRelationFilter>;
  googlePlaceId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerId_clinicId?: Maybe<InformPartnerCustomerInformPartnerIdClinicIdCompoundUniqueInput>;
  informPartnerId_externalId?: Maybe<InformPartnerCustomerInformPartnerIdExternalIdCompoundUniqueInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationScalarRelationFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  name?: Maybe<StringFilter>;
  parentExternalId?: Maybe<StringNullableFilter>;
  parentInformPartnerCustomer?: Maybe<InformPartnerCustomerNullableScalarRelationFilter>;
  parentInformPartnerCustomerId?: Maybe<StringNullableFilter>;
  pharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderListRelationFilter>;
  phoneNumber?: Maybe<StringNullableFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  roles?: Maybe<InformPartnerUserRoleListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visibility?: Maybe<EnumInformPartnerCustomerVisibilityFilter>;
};

export type InformPartnerGroupByOutputType = {
  __typename?: 'InformPartnerGroupByOutputType';
  _count?: Maybe<InformPartnerCountAggregateOutputType>;
  _max?: Maybe<InformPartnerMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerStatus;
  updatedAt: Scalars['DateTime'];
};

export type InformPartnerIntegration = {
  __typename?: 'InformPartnerIntegration';
  _count: InformPartnerIntegrationCountOutputType;
  createdAt: Scalars['DateTime'];
  credentials?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  informPartner: InformPartner;
  informPartnerCustomerPharmacyProviders: Array<InformPartnerCustomerPharmacyProvider>;
  informPartnerCustomers: Array<InformPartnerCustomer>;
  informPartnerId: Scalars['String'];
  informPartnerUsers: Array<InformPartnerUser>;
  models: Array<InformPartnerIntegrationModel>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};


export type InformPartnerIntegrationInformPartnerCustomerPharmacyProvidersArgs = {
  cursor?: Maybe<InformPartnerCustomerPharmacyProviderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerPharmacyProviderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerPharmacyProviderOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerPharmacyProviderWhereInput>;
};


export type InformPartnerIntegrationInformPartnerCustomersArgs = {
  cursor?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};


export type InformPartnerIntegrationInformPartnerUsersArgs = {
  cursor?: Maybe<InformPartnerUserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerUserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserWhereInput>;
};


export type InformPartnerIntegrationModelsArgs = {
  cursor?: Maybe<InformPartnerIntegrationModelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerIntegrationModelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerIntegrationModelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerIntegrationModelWhereInput>;
};

export type InformPartnerIntegrationCountAggregateOutputType = {
  __typename?: 'InformPartnerIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  credentials: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerId: Scalars['Int'];
  status: Scalars['Int'];
  statusMessage: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformPartnerIntegrationCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  credentials?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationCountOutputType = {
  __typename?: 'InformPartnerIntegrationCountOutputType';
  informPartnerCustomerPharmacyProviders: Scalars['Int'];
  informPartnerCustomers: Scalars['Int'];
  informPartnerUsers: Scalars['Int'];
  models: Scalars['Int'];
};

export type InformPartnerIntegrationCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerIntegrationsInput;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerIntegrationInput>;
  models?: Maybe<InformPartnerIntegrationModelCreateNestedManyWithoutInformPartnerIntegrationInput>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationCreateManyInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationCreateManyInformPartnerInputEnvelope = {
  data: Array<InformPartnerIntegrationCreateManyInformPartnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerIntegrationCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformPartnerIntegrationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerIntegrationCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerIntegrationCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerIntegrationCreateManyInformPartnerInputEnvelope>;
};

export type InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomerPharmacyProvidersInput = {
  connect?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerIntegrationCreateOrConnectWithoutInformPartnerCustomerPharmacyProvidersInput>;
  create?: Maybe<InformPartnerIntegrationCreateWithoutInformPartnerCustomerPharmacyProvidersInput>;
};

export type InformPartnerIntegrationCreateNestedOneWithoutInformPartnerCustomersInput = {
  connect?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerIntegrationCreateOrConnectWithoutInformPartnerCustomersInput>;
  create?: Maybe<InformPartnerIntegrationCreateWithoutInformPartnerCustomersInput>;
};

export type InformPartnerIntegrationCreateNestedOneWithoutInformPartnerUsersInput = {
  connect?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerIntegrationCreateOrConnectWithoutInformPartnerUsersInput>;
  create?: Maybe<InformPartnerIntegrationCreateWithoutInformPartnerUsersInput>;
};

export type InformPartnerIntegrationCreateNestedOneWithoutModelsInput = {
  connect?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerIntegrationCreateOrConnectWithoutModelsInput>;
  create?: Maybe<InformPartnerIntegrationCreateWithoutModelsInput>;
};

export type InformPartnerIntegrationCreateOrConnectWithoutInformPartnerCustomerPharmacyProvidersInput = {
  create: InformPartnerIntegrationCreateWithoutInformPartnerCustomerPharmacyProvidersInput;
  where: InformPartnerIntegrationWhereUniqueInput;
};

export type InformPartnerIntegrationCreateOrConnectWithoutInformPartnerCustomersInput = {
  create: InformPartnerIntegrationCreateWithoutInformPartnerCustomersInput;
  where: InformPartnerIntegrationWhereUniqueInput;
};

export type InformPartnerIntegrationCreateOrConnectWithoutInformPartnerInput = {
  create: InformPartnerIntegrationCreateWithoutInformPartnerInput;
  where: InformPartnerIntegrationWhereUniqueInput;
};

export type InformPartnerIntegrationCreateOrConnectWithoutInformPartnerUsersInput = {
  create: InformPartnerIntegrationCreateWithoutInformPartnerUsersInput;
  where: InformPartnerIntegrationWhereUniqueInput;
};

export type InformPartnerIntegrationCreateOrConnectWithoutModelsInput = {
  create: InformPartnerIntegrationCreateWithoutModelsInput;
  where: InformPartnerIntegrationWhereUniqueInput;
};

export type InformPartnerIntegrationCreateWithoutInformPartnerCustomerPharmacyProvidersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerIntegrationsInput;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerIntegrationInput>;
  models?: Maybe<InformPartnerIntegrationModelCreateNestedManyWithoutInformPartnerIntegrationInput>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationCreateWithoutInformPartnerCustomersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerIntegrationsInput;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerIntegrationInput>;
  models?: Maybe<InformPartnerIntegrationModelCreateNestedManyWithoutInformPartnerIntegrationInput>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationCreateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerIntegrationInput>;
  models?: Maybe<InformPartnerIntegrationModelCreateNestedManyWithoutInformPartnerIntegrationInput>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationCreateWithoutInformPartnerUsersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerIntegrationsInput;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerIntegrationInput>;
  models?: Maybe<InformPartnerIntegrationModelCreateNestedManyWithoutInformPartnerIntegrationInput>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationCreateWithoutModelsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerIntegrationsInput;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerUsers?: Maybe<InformPartnerUserCreateNestedManyWithoutInformPartnerIntegrationInput>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationGroupByOutputType = {
  __typename?: 'InformPartnerIntegrationGroupByOutputType';
  _count?: Maybe<InformPartnerIntegrationCountAggregateOutputType>;
  _max?: Maybe<InformPartnerIntegrationMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerIntegrationMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  credentials?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  informPartnerId: Scalars['String'];
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type InformPartnerIntegrationListRelationFilter = {
  every?: Maybe<InformPartnerIntegrationWhereInput>;
  none?: Maybe<InformPartnerIntegrationWhereInput>;
  some?: Maybe<InformPartnerIntegrationWhereInput>;
};

export type InformPartnerIntegrationMaxAggregateOutputType = {
  __typename?: 'InformPartnerIntegrationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationMinAggregateOutputType = {
  __typename?: 'InformPartnerIntegrationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationModel = {
  __typename?: 'InformPartnerIntegrationModel';
  createdAt: Scalars['DateTime'];
  executeAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  informPartnerIntegration: InformPartnerIntegration;
  informPartnerIntegrationId: Scalars['String'];
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name: InformPartnerIntegrationModelName;
  status: InformPartnerIntegrationModelStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type InformPartnerIntegrationModelAvgAggregateOutputType = {
  __typename?: 'InformPartnerIntegrationModelAvgAggregateOutputType';
  syncFrequencyInMinutes?: Maybe<Scalars['Float']>;
};

export type InformPartnerIntegrationModelAvgOrderByAggregateInput = {
  syncFrequencyInMinutes?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationModelCountAggregateOutputType = {
  __typename?: 'InformPartnerIntegrationModelCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  executeAt: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerIntegrationId: Scalars['Int'];
  lastSyncedAt: Scalars['Int'];
  name: Scalars['Int'];
  status: Scalars['Int'];
  statusMessage: Scalars['Int'];
  syncFrequencyInMinutes: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformPartnerIntegrationModelCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationModelCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutModelsInput;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name: InformPartnerIntegrationModelName;
  status: InformPartnerIntegrationModelStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelCreateManyInformPartnerIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name: InformPartnerIntegrationModelName;
  status: InformPartnerIntegrationModelStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelCreateManyInformPartnerIntegrationInputEnvelope = {
  data: Array<InformPartnerIntegrationModelCreateManyInformPartnerIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerIntegrationModelCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId: Scalars['String'];
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name: InformPartnerIntegrationModelName;
  status: InformPartnerIntegrationModelStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelCreateNestedManyWithoutInformPartnerIntegrationInput = {
  connect?: Maybe<Array<InformPartnerIntegrationModelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerIntegrationModelCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerIntegrationModelCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerIntegrationModelCreateManyInformPartnerIntegrationInputEnvelope>;
};

export type InformPartnerIntegrationModelCreateOrConnectWithoutInformPartnerIntegrationInput = {
  create: InformPartnerIntegrationModelCreateWithoutInformPartnerIntegrationInput;
  where: InformPartnerIntegrationModelWhereUniqueInput;
};

export type InformPartnerIntegrationModelCreateWithoutInformPartnerIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name: InformPartnerIntegrationModelName;
  status: InformPartnerIntegrationModelStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelGroupByOutputType = {
  __typename?: 'InformPartnerIntegrationModelGroupByOutputType';
  _avg?: Maybe<InformPartnerIntegrationModelAvgAggregateOutputType>;
  _count?: Maybe<InformPartnerIntegrationModelCountAggregateOutputType>;
  _max?: Maybe<InformPartnerIntegrationModelMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerIntegrationModelMinAggregateOutputType>;
  _sum?: Maybe<InformPartnerIntegrationModelSumAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  executeAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name: InformPartnerIntegrationModelName;
  status: InformPartnerIntegrationModelStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type InformPartnerIntegrationModelInformPartnerIntegrationIdNameCompoundUniqueInput = {
  informPartnerIntegrationId: Scalars['String'];
  name: InformPartnerIntegrationModelName;
};

export type InformPartnerIntegrationModelListRelationFilter = {
  every?: Maybe<InformPartnerIntegrationModelWhereInput>;
  none?: Maybe<InformPartnerIntegrationModelWhereInput>;
  some?: Maybe<InformPartnerIntegrationModelWhereInput>;
};

export type InformPartnerIntegrationModelMaxAggregateOutputType = {
  __typename?: 'InformPartnerIntegrationModelMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<InformPartnerIntegrationModelName>;
  status?: Maybe<InformPartnerIntegrationModelStatus>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationModelMinAggregateOutputType = {
  __typename?: 'InformPartnerIntegrationModelMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<InformPartnerIntegrationModelName>;
  status?: Maybe<InformPartnerIntegrationModelStatus>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerIntegrationModelName {
  BoehringerIngelheimCustomerAlignment = 'BoehringerIngelheimCustomerAlignment',
  BoehringerIngelheimTerritory = 'BoehringerIngelheimTerritory',
  BoehringerIngelheimTerritoryHierarchyForCustomer = 'BoehringerIngelheimTerritoryHierarchyForCustomer',
  InformPartnerCustomer = 'InformPartnerCustomer',
  InformPartnerCustomerPharmacyProvider = 'InformPartnerCustomerPharmacyProvider',
  InformPartnerUser = 'InformPartnerUser'
}

export type InformPartnerIntegrationModelOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationModelOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerIntegrationModelOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationOrderByWithRelationInput>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerIntegrationModelOrderByRelevanceFieldEnum {
  Id = 'id',
  InformPartnerIntegrationId = 'informPartnerIntegrationId'
}

export type InformPartnerIntegrationModelOrderByRelevanceInput = {
  fields: Array<InformPartnerIntegrationModelOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformPartnerIntegrationModelOrderByWithAggregationInput = {
  _avg?: Maybe<InformPartnerIntegrationModelAvgOrderByAggregateInput>;
  _count?: Maybe<InformPartnerIntegrationModelCountOrderByAggregateInput>;
  _max?: Maybe<InformPartnerIntegrationModelMaxOrderByAggregateInput>;
  _min?: Maybe<InformPartnerIntegrationModelMinOrderByAggregateInput>;
  _sum?: Maybe<InformPartnerIntegrationModelSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationModelOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerIntegrationModelOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationOrderByWithRelationInput>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationModelOrderByWithRelationInput = {
  _relevance?: Maybe<InformPartnerIntegrationModelOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  executeAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationOrderByWithRelationInput>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastSyncedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  syncFrequencyInMinutes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerIntegrationModelScalarFieldEnum {
  CreatedAt = 'createdAt',
  ExecuteAt = 'executeAt',
  Id = 'id',
  InformPartnerIntegrationId = 'informPartnerIntegrationId',
  LastSyncedAt = 'lastSyncedAt',
  Name = 'name',
  Status = 'status',
  StatusMessage = 'statusMessage',
  SyncFrequencyInMinutes = 'syncFrequencyInMinutes',
  UpdatedAt = 'updatedAt'
}

export type InformPartnerIntegrationModelScalarWhereInput = {
  AND?: Maybe<Array<InformPartnerIntegrationModelScalarWhereInput>>;
  NOT?: Maybe<Array<InformPartnerIntegrationModelScalarWhereInput>>;
  OR?: Maybe<Array<InformPartnerIntegrationModelScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  executeAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  name?: Maybe<EnumInformPartnerIntegrationModelNameFilter>;
  status?: Maybe<EnumInformPartnerIntegrationModelStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  syncFrequencyInMinutes?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerIntegrationModelScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformPartnerIntegrationModelScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformPartnerIntegrationModelScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformPartnerIntegrationModelScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  executeAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerIntegrationId?: Maybe<StringWithAggregatesFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  name?: Maybe<EnumInformPartnerIntegrationModelNameWithAggregatesFilter>;
  status?: Maybe<EnumInformPartnerIntegrationModelStatusWithAggregatesFilter>;
  statusMessage?: Maybe<JsonNullableWithAggregatesFilter>;
  syncFrequencyInMinutes?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformPartnerIntegrationModelStatus {
  Error = 'Error',
  New = 'New',
  Paused = 'Paused',
  Synced = 'Synced',
  Syncing = 'Syncing'
}

export type InformPartnerIntegrationModelSumAggregateOutputType = {
  __typename?: 'InformPartnerIntegrationModelSumAggregateOutputType';
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
};

export type InformPartnerIntegrationModelSumOrderByAggregateInput = {
  syncFrequencyInMinutes?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationModelUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId: Scalars['String'];
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name: InformPartnerIntegrationModelName;
  status: InformPartnerIntegrationModelStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput = {
  connect?: Maybe<Array<InformPartnerIntegrationModelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerIntegrationModelCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerIntegrationModelCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerIntegrationModelCreateManyInformPartnerIntegrationInputEnvelope>;
};

export type InformPartnerIntegrationModelUncheckedCreateWithoutInformPartnerIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name: InformPartnerIntegrationModelName;
  status: InformPartnerIntegrationModelStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<InformPartnerIntegrationModelName>;
  status?: Maybe<InformPartnerIntegrationModelStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<InformPartnerIntegrationModelName>;
  status?: Maybe<InformPartnerIntegrationModelStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelUncheckedUpdateManyWithoutInformPartnerIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<InformPartnerIntegrationModelName>;
  status?: Maybe<InformPartnerIntegrationModelStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput = {
  connect?: Maybe<Array<InformPartnerIntegrationModelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerIntegrationModelCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerIntegrationModelCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerIntegrationModelCreateManyInformPartnerIntegrationInputEnvelope>;
  delete?: Maybe<Array<InformPartnerIntegrationModelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerIntegrationModelScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerIntegrationModelWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerIntegrationModelWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerIntegrationModelUpdateWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
  updateMany?: Maybe<Array<InformPartnerIntegrationModelUpdateManyWithWhereWithoutInformPartnerIntegrationInput>>;
  upsert?: Maybe<Array<InformPartnerIntegrationModelUpsertWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
};

export type InformPartnerIntegrationModelUncheckedUpdateWithoutInformPartnerIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<InformPartnerIntegrationModelName>;
  status?: Maybe<InformPartnerIntegrationModelStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutModelsNestedInput>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<InformPartnerIntegrationModelName>;
  status?: Maybe<InformPartnerIntegrationModelStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<InformPartnerIntegrationModelName>;
  status?: Maybe<InformPartnerIntegrationModelStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelUpdateManyWithWhereWithoutInformPartnerIntegrationInput = {
  data: InformPartnerIntegrationModelUpdateManyMutationInput;
  where: InformPartnerIntegrationModelScalarWhereInput;
};

export type InformPartnerIntegrationModelUpdateManyWithoutInformPartnerIntegrationNestedInput = {
  connect?: Maybe<Array<InformPartnerIntegrationModelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerIntegrationModelCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerIntegrationModelCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerIntegrationModelCreateManyInformPartnerIntegrationInputEnvelope>;
  delete?: Maybe<Array<InformPartnerIntegrationModelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerIntegrationModelScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerIntegrationModelWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerIntegrationModelWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerIntegrationModelUpdateWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
  updateMany?: Maybe<Array<InformPartnerIntegrationModelUpdateManyWithWhereWithoutInformPartnerIntegrationInput>>;
  upsert?: Maybe<Array<InformPartnerIntegrationModelUpsertWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
};

export type InformPartnerIntegrationModelUpdateWithWhereUniqueWithoutInformPartnerIntegrationInput = {
  data: InformPartnerIntegrationModelUpdateWithoutInformPartnerIntegrationInput;
  where: InformPartnerIntegrationModelWhereUniqueInput;
};

export type InformPartnerIntegrationModelUpdateWithoutInformPartnerIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  executeAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<InformPartnerIntegrationModelName>;
  status?: Maybe<InformPartnerIntegrationModelStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  syncFrequencyInMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationModelUpsertWithWhereUniqueWithoutInformPartnerIntegrationInput = {
  create: InformPartnerIntegrationModelCreateWithoutInformPartnerIntegrationInput;
  update: InformPartnerIntegrationModelUpdateWithoutInformPartnerIntegrationInput;
  where: InformPartnerIntegrationModelWhereUniqueInput;
};

export type InformPartnerIntegrationModelWhereInput = {
  AND?: Maybe<Array<InformPartnerIntegrationModelWhereInput>>;
  NOT?: Maybe<Array<InformPartnerIntegrationModelWhereInput>>;
  OR?: Maybe<Array<InformPartnerIntegrationModelWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  executeAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationScalarRelationFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  name?: Maybe<EnumInformPartnerIntegrationModelNameFilter>;
  status?: Maybe<EnumInformPartnerIntegrationModelStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  syncFrequencyInMinutes?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerIntegrationModelWhereUniqueInput = {
  AND?: Maybe<Array<InformPartnerIntegrationModelWhereInput>>;
  NOT?: Maybe<Array<InformPartnerIntegrationModelWhereInput>>;
  OR?: Maybe<Array<InformPartnerIntegrationModelWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  executeAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationScalarRelationFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  informPartnerIntegrationId_name?: Maybe<InformPartnerIntegrationModelInformPartnerIntegrationIdNameCompoundUniqueInput>;
  lastSyncedAt?: Maybe<DateTimeNullableFilter>;
  name?: Maybe<EnumInformPartnerIntegrationModelNameFilter>;
  status?: Maybe<EnumInformPartnerIntegrationModelStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  syncFrequencyInMinutes?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerIntegrationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerIntegrationOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  credentials?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderOrderByRelationAggregateInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerUsers?: Maybe<InformPartnerUserOrderByRelationAggregateInput>;
  models?: Maybe<InformPartnerIntegrationModelOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerIntegrationOrderByRelevanceFieldEnum {
  Id = 'id',
  InformPartnerId = 'informPartnerId'
}

export type InformPartnerIntegrationOrderByRelevanceInput = {
  fields: Array<InformPartnerIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformPartnerIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<InformPartnerIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<InformPartnerIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<InformPartnerIntegrationMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  credentials?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerIntegrationOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  credentials?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderOrderByRelationAggregateInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerUsers?: Maybe<InformPartnerUserOrderByRelationAggregateInput>;
  models?: Maybe<InformPartnerIntegrationModelOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<InformPartnerIntegrationOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  credentials?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderOrderByRelationAggregateInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerUsers?: Maybe<InformPartnerUserOrderByRelationAggregateInput>;
  models?: Maybe<InformPartnerIntegrationModelOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerIntegrationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Credentials = 'credentials',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  Status = 'status',
  StatusMessage = 'statusMessage',
  UpdatedAt = 'updatedAt'
}

export type InformPartnerIntegrationScalarRelationFilter = {
  AND?: Maybe<Array<InformPartnerIntegrationWhereInput>>;
  NOT?: Maybe<Array<InformPartnerIntegrationWhereInput>>;
  OR?: Maybe<Array<InformPartnerIntegrationWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  credentials?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderListRelationFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  models?: Maybe<InformPartnerIntegrationModelListRelationFilter>;
  status?: Maybe<EnumInformPartnerIntegrationStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerIntegrationScalarWhereInput = {
  AND?: Maybe<Array<InformPartnerIntegrationScalarWhereInput>>;
  NOT?: Maybe<Array<InformPartnerIntegrationScalarWhereInput>>;
  OR?: Maybe<Array<InformPartnerIntegrationScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  credentials?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerId?: Maybe<StringFilter>;
  status?: Maybe<EnumInformPartnerIntegrationStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformPartnerIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformPartnerIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformPartnerIntegrationScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  credentials?: Maybe<JsonNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerId?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumInformPartnerIntegrationStatusWithAggregatesFilter>;
  statusMessage?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformPartnerIntegrationStatus {
  Active = 'Active',
  Archived = 'Archived',
  Paused = 'Paused'
}

export type InformPartnerIntegrationUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  models?: Maybe<InformPartnerIntegrationModelUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformPartnerIntegrationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerIntegrationCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerIntegrationCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerIntegrationCreateManyInformPartnerInputEnvelope>;
};

export type InformPartnerIntegrationUncheckedCreateWithoutInformPartnerCustomerPharmacyProvidersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  models?: Maybe<InformPartnerIntegrationModelUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedCreateWithoutInformPartnerCustomersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  models?: Maybe<InformPartnerIntegrationModelUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedCreateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  models?: Maybe<InformPartnerIntegrationModelUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedCreateWithoutInformPartnerUsersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerId: Scalars['String'];
  models?: Maybe<InformPartnerIntegrationModelUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedCreateWithoutModelsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  informPartnerId: Scalars['String'];
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput>;
  status: InformPartnerIntegrationStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  models?: Maybe<InformPartnerIntegrationModelUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedUpdateManyWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformPartnerIntegrationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerIntegrationCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerIntegrationCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerIntegrationCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerIntegrationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerIntegrationScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerIntegrationWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerIntegrationWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerIntegrationUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformPartnerIntegrationUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformPartnerIntegrationUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformPartnerIntegrationUncheckedUpdateWithoutInformPartnerCustomerPharmacyProvidersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  models?: Maybe<InformPartnerIntegrationModelUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedUpdateWithoutInformPartnerCustomersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  models?: Maybe<InformPartnerIntegrationModelUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedUpdateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  models?: Maybe<InformPartnerIntegrationModelUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedUpdateWithoutInformPartnerUsersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  models?: Maybe<InformPartnerIntegrationModelUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUncheckedUpdateWithoutModelsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerIntegrationsNestedInput>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  models?: Maybe<InformPartnerIntegrationModelUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUpdateManyWithWhereWithoutInformPartnerInput = {
  data: InformPartnerIntegrationUpdateManyMutationInput;
  where: InformPartnerIntegrationScalarWhereInput;
};

export type InformPartnerIntegrationUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformPartnerIntegrationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerIntegrationCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerIntegrationCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerIntegrationCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerIntegrationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerIntegrationScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerIntegrationWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerIntegrationWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerIntegrationUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformPartnerIntegrationUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformPartnerIntegrationUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomerPharmacyProvidersNestedInput = {
  connect?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerIntegrationCreateOrConnectWithoutInformPartnerCustomerPharmacyProvidersInput>;
  create?: Maybe<InformPartnerIntegrationCreateWithoutInformPartnerCustomerPharmacyProvidersInput>;
  update?: Maybe<InformPartnerIntegrationUpdateToOneWithWhereWithoutInformPartnerCustomerPharmacyProvidersInput>;
  upsert?: Maybe<InformPartnerIntegrationUpsertWithoutInformPartnerCustomerPharmacyProvidersInput>;
};

export type InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerCustomersNestedInput = {
  connect?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerIntegrationCreateOrConnectWithoutInformPartnerCustomersInput>;
  create?: Maybe<InformPartnerIntegrationCreateWithoutInformPartnerCustomersInput>;
  update?: Maybe<InformPartnerIntegrationUpdateToOneWithWhereWithoutInformPartnerCustomersInput>;
  upsert?: Maybe<InformPartnerIntegrationUpsertWithoutInformPartnerCustomersInput>;
};

export type InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerUsersNestedInput = {
  connect?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerIntegrationCreateOrConnectWithoutInformPartnerUsersInput>;
  create?: Maybe<InformPartnerIntegrationCreateWithoutInformPartnerUsersInput>;
  update?: Maybe<InformPartnerIntegrationUpdateToOneWithWhereWithoutInformPartnerUsersInput>;
  upsert?: Maybe<InformPartnerIntegrationUpsertWithoutInformPartnerUsersInput>;
};

export type InformPartnerIntegrationUpdateOneRequiredWithoutModelsNestedInput = {
  connect?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerIntegrationCreateOrConnectWithoutModelsInput>;
  create?: Maybe<InformPartnerIntegrationCreateWithoutModelsInput>;
  update?: Maybe<InformPartnerIntegrationUpdateToOneWithWhereWithoutModelsInput>;
  upsert?: Maybe<InformPartnerIntegrationUpsertWithoutModelsInput>;
};

export type InformPartnerIntegrationUpdateToOneWithWhereWithoutInformPartnerCustomerPharmacyProvidersInput = {
  data: InformPartnerIntegrationUpdateWithoutInformPartnerCustomerPharmacyProvidersInput;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};

export type InformPartnerIntegrationUpdateToOneWithWhereWithoutInformPartnerCustomersInput = {
  data: InformPartnerIntegrationUpdateWithoutInformPartnerCustomersInput;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};

export type InformPartnerIntegrationUpdateToOneWithWhereWithoutInformPartnerUsersInput = {
  data: InformPartnerIntegrationUpdateWithoutInformPartnerUsersInput;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};

export type InformPartnerIntegrationUpdateToOneWithWhereWithoutModelsInput = {
  data: InformPartnerIntegrationUpdateWithoutModelsInput;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};

export type InformPartnerIntegrationUpdateWithWhereUniqueWithoutInformPartnerInput = {
  data: InformPartnerIntegrationUpdateWithoutInformPartnerInput;
  where: InformPartnerIntegrationWhereUniqueInput;
};

export type InformPartnerIntegrationUpdateWithoutInformPartnerCustomerPharmacyProvidersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerIntegrationsNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  models?: Maybe<InformPartnerIntegrationModelUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUpdateWithoutInformPartnerCustomersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerIntegrationsNestedInput>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  models?: Maybe<InformPartnerIntegrationModelUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUpdateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  models?: Maybe<InformPartnerIntegrationModelUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUpdateWithoutInformPartnerUsersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerIntegrationsNestedInput>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  models?: Maybe<InformPartnerIntegrationModelUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUpdateWithoutModelsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerIntegrationsNestedInput>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerIntegrationNestedInput>;
  status?: Maybe<InformPartnerIntegrationStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerIntegrationUpsertWithWhereUniqueWithoutInformPartnerInput = {
  create: InformPartnerIntegrationCreateWithoutInformPartnerInput;
  update: InformPartnerIntegrationUpdateWithoutInformPartnerInput;
  where: InformPartnerIntegrationWhereUniqueInput;
};

export type InformPartnerIntegrationUpsertWithoutInformPartnerCustomerPharmacyProvidersInput = {
  create: InformPartnerIntegrationCreateWithoutInformPartnerCustomerPharmacyProvidersInput;
  update: InformPartnerIntegrationUpdateWithoutInformPartnerCustomerPharmacyProvidersInput;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};

export type InformPartnerIntegrationUpsertWithoutInformPartnerCustomersInput = {
  create: InformPartnerIntegrationCreateWithoutInformPartnerCustomersInput;
  update: InformPartnerIntegrationUpdateWithoutInformPartnerCustomersInput;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};

export type InformPartnerIntegrationUpsertWithoutInformPartnerUsersInput = {
  create: InformPartnerIntegrationCreateWithoutInformPartnerUsersInput;
  update: InformPartnerIntegrationUpdateWithoutInformPartnerUsersInput;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};

export type InformPartnerIntegrationUpsertWithoutModelsInput = {
  create: InformPartnerIntegrationCreateWithoutModelsInput;
  update: InformPartnerIntegrationUpdateWithoutModelsInput;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};

export type InformPartnerIntegrationWhereInput = {
  AND?: Maybe<Array<InformPartnerIntegrationWhereInput>>;
  NOT?: Maybe<Array<InformPartnerIntegrationWhereInput>>;
  OR?: Maybe<Array<InformPartnerIntegrationWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  credentials?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderListRelationFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  models?: Maybe<InformPartnerIntegrationModelListRelationFilter>;
  status?: Maybe<EnumInformPartnerIntegrationStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<InformPartnerIntegrationWhereInput>>;
  NOT?: Maybe<Array<InformPartnerIntegrationWhereInput>>;
  OR?: Maybe<Array<InformPartnerIntegrationWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  credentials?: Maybe<JsonNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerCustomerPharmacyProviders?: Maybe<InformPartnerCustomerPharmacyProviderListRelationFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  models?: Maybe<InformPartnerIntegrationModelListRelationFilter>;
  status?: Maybe<EnumInformPartnerIntegrationStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerMaxAggregateOutputType = {
  __typename?: 'InformPartnerMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerMinAggregateOutputType = {
  __typename?: 'InformPartnerMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerNullableScalarRelationFilter = {
  AND?: Maybe<Array<InformPartnerWhereInput>>;
  NOT?: Maybe<Array<InformPartnerWhereInput>>;
  OR?: Maybe<Array<InformPartnerWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  informCampaignGroups?: Maybe<InformCampaignGroupListRelationFilter>;
  informEmailTemplates?: Maybe<InformEmailTemplateListRelationFilter>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationListRelationFilter>;
  informPartnerPrograms?: Maybe<InformPartnerProgramListRelationFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  name?: Maybe<StringFilter>;
  products?: Maybe<ProductListRelationFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionOrderByRelationAggregateInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupOrderByRelationAggregateInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateOrderByRelationAggregateInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationOrderByRelationAggregateInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramOrderByRelationAggregateInput>;
  informPartnerUsers?: Maybe<InformPartnerUserOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  products?: Maybe<ProductOrderByRelationAggregateInput>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type InformPartnerOrderByRelevanceInput = {
  fields: Array<InformPartnerOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformPartnerOrderByWithAggregationInput = {
  _count?: Maybe<InformPartnerCountOrderByAggregateInput>;
  _max?: Maybe<InformPartnerMaxOrderByAggregateInput>;
  _min?: Maybe<InformPartnerMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionOrderByRelationAggregateInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupOrderByRelationAggregateInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateOrderByRelationAggregateInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationOrderByRelationAggregateInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramOrderByRelationAggregateInput>;
  informPartnerUsers?: Maybe<InformPartnerUserOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  products?: Maybe<ProductOrderByRelationAggregateInput>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerOrderByWithRelationInput = {
  _relevance?: Maybe<InformPartnerOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionOrderByRelationAggregateInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupOrderByRelationAggregateInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateOrderByRelationAggregateInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationOrderByRelationAggregateInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramOrderByRelationAggregateInput>;
  informPartnerUsers?: Maybe<InformPartnerUserOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  products?: Maybe<ProductOrderByRelationAggregateInput>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerProgram = {
  __typename?: 'InformPartnerProgram';
  _count: InformPartnerProgramCountOutputType;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informCampaigns: Array<InformCampaign>;
  informPartner: InformPartner;
  informPartnerId: Scalars['String'];
  informPartnerProgramEnrollments: Array<InformPartnerProgramEnrollment>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerProgramStatus;
  updatedAt: Scalars['DateTime'];
};


export type InformPartnerProgramInformCampaignsArgs = {
  cursor?: Maybe<InformCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignWhereInput>;
};


export type InformPartnerProgramInformPartnerProgramEnrollmentsArgs = {
  cursor?: Maybe<InformPartnerProgramEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};

export type InformPartnerProgramCountAggregateOutputType = {
  __typename?: 'InformPartnerProgramCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  displayName: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerId: Scalars['Int'];
  name: Scalars['Int'];
  settings: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformPartnerProgramCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerProgramCountOutputType = {
  __typename?: 'InformPartnerProgramCountOutputType';
  informCampaigns: Scalars['Int'];
  informPartnerProgramEnrollments: Scalars['Int'];
};

export type InformPartnerProgramCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignCreateNestedManyWithoutInformPartnerProgramInput>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerProgramsInput;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutInformPartnerProgramInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramCreateManyInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramCreateManyInformPartnerInputEnvelope = {
  data: Array<InformPartnerProgramCreateManyInformPartnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerProgramCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformPartnerProgramWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerProgramCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerProgramCreateManyInformPartnerInputEnvelope>;
};

export type InformPartnerProgramCreateNestedOneWithoutInformCampaignsInput = {
  connect?: Maybe<InformPartnerProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerProgramCreateOrConnectWithoutInformCampaignsInput>;
  create?: Maybe<InformPartnerProgramCreateWithoutInformCampaignsInput>;
};

export type InformPartnerProgramCreateNestedOneWithoutInformPartnerProgramEnrollmentsInput = {
  connect?: Maybe<InformPartnerProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerProgramCreateOrConnectWithoutInformPartnerProgramEnrollmentsInput>;
  create?: Maybe<InformPartnerProgramCreateWithoutInformPartnerProgramEnrollmentsInput>;
};

export type InformPartnerProgramCreateOrConnectWithoutInformCampaignsInput = {
  create: InformPartnerProgramCreateWithoutInformCampaignsInput;
  where: InformPartnerProgramWhereUniqueInput;
};

export type InformPartnerProgramCreateOrConnectWithoutInformPartnerInput = {
  create: InformPartnerProgramCreateWithoutInformPartnerInput;
  where: InformPartnerProgramWhereUniqueInput;
};

export type InformPartnerProgramCreateOrConnectWithoutInformPartnerProgramEnrollmentsInput = {
  create: InformPartnerProgramCreateWithoutInformPartnerProgramEnrollmentsInput;
  where: InformPartnerProgramWhereUniqueInput;
};

export type InformPartnerProgramCreateWithoutInformCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerProgramsInput;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutInformPartnerProgramInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramCreateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignCreateNestedManyWithoutInformPartnerProgramInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutInformPartnerProgramInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramCreateWithoutInformPartnerProgramEnrollmentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignCreateNestedManyWithoutInformPartnerProgramInput>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerProgramsInput;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollment = {
  __typename?: 'InformPartnerProgramEnrollment';
  _count: InformPartnerProgramEnrollmentCountOutputType;
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUser?: Maybe<User>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  informCampaignEnrollments: Array<InformCampaignEnrollment>;
  informNotificationRecipients: Array<InformNotificationRecipient>;
  informPartnerProgram: InformPartnerProgram;
  informPartnerProgramId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};


export type InformPartnerProgramEnrollmentAcceptedTermsByUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type InformPartnerProgramEnrollmentInformCampaignEnrollmentsArgs = {
  cursor?: Maybe<InformCampaignEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignEnrollmentWhereInput>;
};


export type InformPartnerProgramEnrollmentInformNotificationRecipientsArgs = {
  cursor?: Maybe<InformNotificationRecipientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformNotificationRecipientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformNotificationRecipientOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformNotificationRecipientWhereInput>;
};

export type InformPartnerProgramEnrollmentClinicIdInformPartnerProgramIdCompoundUniqueInput = {
  clinicId: Scalars['String'];
  informPartnerProgramId: Scalars['String'];
};

export type InformPartnerProgramEnrollmentCountAggregateOutputType = {
  __typename?: 'InformPartnerProgramEnrollmentCountAggregateOutputType';
  _all: Scalars['Int'];
  acceptedTermsAt: Scalars['Int'];
  acceptedTermsByUserId: Scalars['Int'];
  churnDate: Scalars['Int'];
  churnReason: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  enrolledAt: Scalars['Int'];
  externalId: Scalars['Int'];
  goLiveAt: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerProgramId: Scalars['Int'];
  lastUpdatedBy: Scalars['Int'];
  lastUpdatedByType: Scalars['Int'];
  settings: Scalars['Int'];
  status: Scalars['Int'];
  statusMessage: Scalars['Int'];
  statusUpdatedAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformPartnerProgramEnrollmentCountOrderByAggregateInput = {
  acceptedTermsAt?: Maybe<SortOrder>;
  acceptedTermsByUserId?: Maybe<SortOrder>;
  churnDate?: Maybe<SortOrder>;
  churnReason?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enrolledAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  goLiveAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerProgramId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  statusUpdatedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerProgramEnrollmentCountOutputType = {
  __typename?: 'InformPartnerProgramEnrollmentCountOutputType';
  informCampaignEnrollments: Scalars['Int'];
  informNotificationRecipients: Scalars['Int'];
};

export type InformPartnerProgramEnrollmentCreateInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUser?: Maybe<UserCreateNestedOneWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinic: ClinicCreateNestedOneWithoutInformPartnerProgramEnrollmentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformPartnerProgramEnrollmentsInput;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentCreateManyAcceptedTermsByUserInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentCreateManyAcceptedTermsByUserInputEnvelope = {
  data: Array<InformPartnerProgramEnrollmentCreateManyAcceptedTermsByUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerProgramEnrollmentCreateManyClinicInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentCreateManyClinicInputEnvelope = {
  data: Array<InformPartnerProgramEnrollmentCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerProgramEnrollmentCreateManyInformPartnerProgramInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentCreateManyInformPartnerProgramInputEnvelope = {
  data: Array<InformPartnerProgramEnrollmentCreateManyInformPartnerProgramInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerProgramEnrollmentCreateManyInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput = {
  connect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramEnrollmentCreateOrConnectWithoutAcceptedTermsByUserInput>>;
  create?: Maybe<Array<InformPartnerProgramEnrollmentCreateWithoutAcceptedTermsByUserInput>>;
  createMany?: Maybe<InformPartnerProgramEnrollmentCreateManyAcceptedTermsByUserInputEnvelope>;
};

export type InformPartnerProgramEnrollmentCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramEnrollmentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InformPartnerProgramEnrollmentCreateWithoutClinicInput>>;
  createMany?: Maybe<InformPartnerProgramEnrollmentCreateManyClinicInputEnvelope>;
};

export type InformPartnerProgramEnrollmentCreateNestedManyWithoutInformPartnerProgramInput = {
  connect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramEnrollmentCreateOrConnectWithoutInformPartnerProgramInput>>;
  create?: Maybe<Array<InformPartnerProgramEnrollmentCreateWithoutInformPartnerProgramInput>>;
  createMany?: Maybe<InformPartnerProgramEnrollmentCreateManyInformPartnerProgramInputEnvelope>;
};

export type InformPartnerProgramEnrollmentCreateNestedOneWithoutInformCampaignEnrollmentsInput = {
  connect?: Maybe<InformPartnerProgramEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerProgramEnrollmentCreateOrConnectWithoutInformCampaignEnrollmentsInput>;
  create?: Maybe<InformPartnerProgramEnrollmentCreateWithoutInformCampaignEnrollmentsInput>;
};

export type InformPartnerProgramEnrollmentCreateNestedOneWithoutInformNotificationRecipientsInput = {
  connect?: Maybe<InformPartnerProgramEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerProgramEnrollmentCreateOrConnectWithoutInformNotificationRecipientsInput>;
  create?: Maybe<InformPartnerProgramEnrollmentCreateWithoutInformNotificationRecipientsInput>;
};

export type InformPartnerProgramEnrollmentCreateOrConnectWithoutAcceptedTermsByUserInput = {
  create: InformPartnerProgramEnrollmentCreateWithoutAcceptedTermsByUserInput;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};

export type InformPartnerProgramEnrollmentCreateOrConnectWithoutClinicInput = {
  create: InformPartnerProgramEnrollmentCreateWithoutClinicInput;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};

export type InformPartnerProgramEnrollmentCreateOrConnectWithoutInformCampaignEnrollmentsInput = {
  create: InformPartnerProgramEnrollmentCreateWithoutInformCampaignEnrollmentsInput;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};

export type InformPartnerProgramEnrollmentCreateOrConnectWithoutInformNotificationRecipientsInput = {
  create: InformPartnerProgramEnrollmentCreateWithoutInformNotificationRecipientsInput;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};

export type InformPartnerProgramEnrollmentCreateOrConnectWithoutInformPartnerProgramInput = {
  create: InformPartnerProgramEnrollmentCreateWithoutInformPartnerProgramInput;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};

export type InformPartnerProgramEnrollmentCreateWithoutAcceptedTermsByUserInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinic: ClinicCreateNestedOneWithoutInformPartnerProgramEnrollmentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformPartnerProgramEnrollmentsInput;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentCreateWithoutClinicInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUser?: Maybe<UserCreateNestedOneWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformPartnerProgramEnrollmentsInput;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentCreateWithoutInformCampaignEnrollmentsInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUser?: Maybe<UserCreateNestedOneWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinic: ClinicCreateNestedOneWithoutInformPartnerProgramEnrollmentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformPartnerProgramEnrollmentsInput;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentCreateWithoutInformNotificationRecipientsInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUser?: Maybe<UserCreateNestedOneWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinic: ClinicCreateNestedOneWithoutInformPartnerProgramEnrollmentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informPartnerProgram: InformPartnerProgramCreateNestedOneWithoutInformPartnerProgramEnrollmentsInput;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentCreateWithoutInformPartnerProgramInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUser?: Maybe<UserCreateNestedOneWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinic: ClinicCreateNestedOneWithoutInformPartnerProgramEnrollmentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentGroupByOutputType = {
  __typename?: 'InformPartnerProgramEnrollmentGroupByOutputType';
  _count?: Maybe<InformPartnerProgramEnrollmentCountAggregateOutputType>;
  _max?: Maybe<InformPartnerProgramEnrollmentMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerProgramEnrollmentMinAggregateOutputType>;
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  informPartnerProgramId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type InformPartnerProgramEnrollmentListRelationFilter = {
  every?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
  none?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
  some?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};

export type InformPartnerProgramEnrollmentMaxAggregateOutputType = {
  __typename?: 'InformPartnerProgramEnrollmentMaxAggregateOutputType';
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  status?: Maybe<InformEnrollmentStatus>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentMaxOrderByAggregateInput = {
  acceptedTermsAt?: Maybe<SortOrder>;
  acceptedTermsByUserId?: Maybe<SortOrder>;
  churnDate?: Maybe<SortOrder>;
  churnReason?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enrolledAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  goLiveAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerProgramId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusUpdatedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerProgramEnrollmentMinAggregateOutputType = {
  __typename?: 'InformPartnerProgramEnrollmentMinAggregateOutputType';
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  status?: Maybe<InformEnrollmentStatus>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentMinOrderByAggregateInput = {
  acceptedTermsAt?: Maybe<SortOrder>;
  acceptedTermsByUserId?: Maybe<SortOrder>;
  churnDate?: Maybe<SortOrder>;
  churnReason?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enrolledAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  goLiveAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerProgramId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusUpdatedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerProgramEnrollmentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformPartnerProgramEnrollmentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerProgramEnrollmentOrderByRelevanceInput>;
  acceptedTermsAt?: Maybe<SortOrder>;
  acceptedTermsByUser?: Maybe<UserOrderByWithRelationInput>;
  acceptedTermsByUserId?: Maybe<SortOrder>;
  churnDate?: Maybe<SortOrder>;
  churnReason?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enrolledAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  goLiveAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentOrderByRelationAggregateInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientOrderByRelationAggregateInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramOrderByWithRelationInput>;
  informPartnerProgramId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  statusUpdatedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerProgramEnrollmentOrderByRelevanceFieldEnum {
  AcceptedTermsByUserId = 'acceptedTermsByUserId',
  ChurnReason = 'churnReason',
  ClinicId = 'clinicId',
  ExternalId = 'externalId',
  Id = 'id',
  InformPartnerProgramId = 'informPartnerProgramId',
  LastUpdatedBy = 'lastUpdatedBy'
}

export type InformPartnerProgramEnrollmentOrderByRelevanceInput = {
  fields: Array<InformPartnerProgramEnrollmentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformPartnerProgramEnrollmentOrderByWithAggregationInput = {
  _count?: Maybe<InformPartnerProgramEnrollmentCountOrderByAggregateInput>;
  _max?: Maybe<InformPartnerProgramEnrollmentMaxOrderByAggregateInput>;
  _min?: Maybe<InformPartnerProgramEnrollmentMinOrderByAggregateInput>;
  acceptedTermsAt?: Maybe<SortOrder>;
  acceptedTermsByUserId?: Maybe<SortOrder>;
  churnDate?: Maybe<SortOrder>;
  churnReason?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enrolledAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  goLiveAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerProgramId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  statusUpdatedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerProgramEnrollmentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerProgramEnrollmentOrderByRelevanceInput>;
  acceptedTermsAt?: Maybe<SortOrder>;
  acceptedTermsByUser?: Maybe<UserOrderByWithRelationInput>;
  acceptedTermsByUserId?: Maybe<SortOrder>;
  churnDate?: Maybe<SortOrder>;
  churnReason?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enrolledAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  goLiveAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentOrderByRelationAggregateInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientOrderByRelationAggregateInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramOrderByWithRelationInput>;
  informPartnerProgramId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  statusUpdatedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerProgramEnrollmentOrderByWithRelationInput = {
  _relevance?: Maybe<InformPartnerProgramEnrollmentOrderByRelevanceInput>;
  acceptedTermsAt?: Maybe<SortOrder>;
  acceptedTermsByUser?: Maybe<UserOrderByWithRelationInput>;
  acceptedTermsByUserId?: Maybe<SortOrder>;
  churnDate?: Maybe<SortOrder>;
  churnReason?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enrolledAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  goLiveAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentOrderByRelationAggregateInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientOrderByRelationAggregateInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramOrderByWithRelationInput>;
  informPartnerProgramId?: Maybe<SortOrder>;
  lastUpdatedBy?: Maybe<SortOrder>;
  lastUpdatedByType?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  statusMessage?: Maybe<SortOrder>;
  statusUpdatedAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerProgramEnrollmentScalarFieldEnum {
  AcceptedTermsAt = 'acceptedTermsAt',
  AcceptedTermsByUserId = 'acceptedTermsByUserId',
  ChurnDate = 'churnDate',
  ChurnReason = 'churnReason',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  EnrolledAt = 'enrolledAt',
  ExternalId = 'externalId',
  GoLiveAt = 'goLiveAt',
  Id = 'id',
  InformPartnerProgramId = 'informPartnerProgramId',
  LastUpdatedBy = 'lastUpdatedBy',
  LastUpdatedByType = 'lastUpdatedByType',
  Settings = 'settings',
  Status = 'status',
  StatusMessage = 'statusMessage',
  StatusUpdatedAt = 'statusUpdatedAt',
  UpdatedAt = 'updatedAt'
}

export type InformPartnerProgramEnrollmentScalarRelationFilter = {
  AND?: Maybe<Array<InformPartnerProgramEnrollmentWhereInput>>;
  NOT?: Maybe<Array<InformPartnerProgramEnrollmentWhereInput>>;
  OR?: Maybe<Array<InformPartnerProgramEnrollmentWhereInput>>;
  acceptedTermsAt?: Maybe<DateTimeNullableFilter>;
  acceptedTermsByUser?: Maybe<UserNullableScalarRelationFilter>;
  acceptedTermsByUserId?: Maybe<StringNullableFilter>;
  churnDate?: Maybe<DateTimeNullableFilter>;
  churnReason?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enrolledAt?: Maybe<DateTimeNullableFilter>;
  externalId?: Maybe<StringNullableFilter>;
  goLiveAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentListRelationFilter>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientListRelationFilter>;
  informPartnerProgram?: Maybe<InformPartnerProgramScalarRelationFilter>;
  informPartnerProgramId?: Maybe<StringFilter>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  lastUpdatedByType?: Maybe<EnumInformEntityUpdatedByTypeNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformEnrollmentStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  statusUpdatedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerProgramEnrollmentScalarWhereInput = {
  AND?: Maybe<Array<InformPartnerProgramEnrollmentScalarWhereInput>>;
  NOT?: Maybe<Array<InformPartnerProgramEnrollmentScalarWhereInput>>;
  OR?: Maybe<Array<InformPartnerProgramEnrollmentScalarWhereInput>>;
  acceptedTermsAt?: Maybe<DateTimeNullableFilter>;
  acceptedTermsByUserId?: Maybe<StringNullableFilter>;
  churnDate?: Maybe<DateTimeNullableFilter>;
  churnReason?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enrolledAt?: Maybe<DateTimeNullableFilter>;
  externalId?: Maybe<StringNullableFilter>;
  goLiveAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerProgramId?: Maybe<StringFilter>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  lastUpdatedByType?: Maybe<EnumInformEntityUpdatedByTypeNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformEnrollmentStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  statusUpdatedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerProgramEnrollmentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformPartnerProgramEnrollmentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformPartnerProgramEnrollmentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformPartnerProgramEnrollmentScalarWhereWithAggregatesInput>>;
  acceptedTermsAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  acceptedTermsByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  churnDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  churnReason?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  enrolledAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  externalId?: Maybe<StringNullableWithAggregatesFilter>;
  goLiveAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerProgramId?: Maybe<StringWithAggregatesFilter>;
  lastUpdatedBy?: Maybe<StringNullableWithAggregatesFilter>;
  lastUpdatedByType?: Maybe<EnumInformEntityUpdatedByTypeNullableWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  status?: Maybe<EnumInformEnrollmentStatusWithAggregatesFilter>;
  statusMessage?: Maybe<JsonNullableWithAggregatesFilter>;
  statusUpdatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type InformPartnerProgramEnrollmentUncheckedCreateInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informPartnerProgramId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput = {
  connect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramEnrollmentCreateOrConnectWithoutAcceptedTermsByUserInput>>;
  create?: Maybe<Array<InformPartnerProgramEnrollmentCreateWithoutAcceptedTermsByUserInput>>;
  createMany?: Maybe<InformPartnerProgramEnrollmentCreateManyAcceptedTermsByUserInputEnvelope>;
};

export type InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramEnrollmentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InformPartnerProgramEnrollmentCreateWithoutClinicInput>>;
  createMany?: Maybe<InformPartnerProgramEnrollmentCreateManyClinicInputEnvelope>;
};

export type InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutInformPartnerProgramInput = {
  connect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramEnrollmentCreateOrConnectWithoutInformPartnerProgramInput>>;
  create?: Maybe<Array<InformPartnerProgramEnrollmentCreateWithoutInformPartnerProgramInput>>;
  createMany?: Maybe<InformPartnerProgramEnrollmentCreateManyInformPartnerProgramInputEnvelope>;
};

export type InformPartnerProgramEnrollmentUncheckedCreateWithoutAcceptedTermsByUserInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informPartnerProgramId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedCreateWithoutClinicInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informPartnerProgramId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedCreateWithoutInformCampaignEnrollmentsInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informPartnerProgramId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedCreateWithoutInformNotificationRecipientsInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informPartnerProgramId: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedCreateWithoutInformPartnerProgramInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutInformPartnerProgramEnrollmentInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status: InformEnrollmentStatus;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateManyInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput = {
  connect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramEnrollmentCreateOrConnectWithoutAcceptedTermsByUserInput>>;
  create?: Maybe<Array<InformPartnerProgramEnrollmentCreateWithoutAcceptedTermsByUserInput>>;
  createMany?: Maybe<InformPartnerProgramEnrollmentCreateManyAcceptedTermsByUserInputEnvelope>;
  delete?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerProgramEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerProgramEnrollmentUpdateWithWhereUniqueWithoutAcceptedTermsByUserInput>>;
  updateMany?: Maybe<Array<InformPartnerProgramEnrollmentUpdateManyWithWhereWithoutAcceptedTermsByUserInput>>;
  upsert?: Maybe<Array<InformPartnerProgramEnrollmentUpsertWithWhereUniqueWithoutAcceptedTermsByUserInput>>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramEnrollmentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InformPartnerProgramEnrollmentCreateWithoutClinicInput>>;
  createMany?: Maybe<InformPartnerProgramEnrollmentCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerProgramEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerProgramEnrollmentUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<InformPartnerProgramEnrollmentUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<InformPartnerProgramEnrollmentUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutInformPartnerProgramInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutInformPartnerProgramNestedInput = {
  connect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramEnrollmentCreateOrConnectWithoutInformPartnerProgramInput>>;
  create?: Maybe<Array<InformPartnerProgramEnrollmentCreateWithoutInformPartnerProgramInput>>;
  createMany?: Maybe<InformPartnerProgramEnrollmentCreateManyInformPartnerProgramInputEnvelope>;
  delete?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerProgramEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerProgramEnrollmentUpdateWithWhereUniqueWithoutInformPartnerProgramInput>>;
  updateMany?: Maybe<Array<InformPartnerProgramEnrollmentUpdateManyWithWhereWithoutInformPartnerProgramInput>>;
  upsert?: Maybe<Array<InformPartnerProgramEnrollmentUpsertWithWhereUniqueWithoutInformPartnerProgramInput>>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateWithoutAcceptedTermsByUserInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateWithoutClinicInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateWithoutInformCampaignEnrollmentsInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateWithoutInformNotificationRecipientsInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informPartnerProgramId?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUncheckedUpdateWithoutInformPartnerProgramInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUserId?: Maybe<Scalars['String']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUpdateInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUser?: Maybe<UserUpdateOneWithoutInformPartnerProgramEnrollmentTermsAcceptancesNestedInput>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInformPartnerProgramEnrollmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformPartnerProgramEnrollmentsNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUpdateManyMutationInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUpdateManyWithWhereWithoutAcceptedTermsByUserInput = {
  data: InformPartnerProgramEnrollmentUpdateManyMutationInput;
  where: InformPartnerProgramEnrollmentScalarWhereInput;
};

export type InformPartnerProgramEnrollmentUpdateManyWithWhereWithoutClinicInput = {
  data: InformPartnerProgramEnrollmentUpdateManyMutationInput;
  where: InformPartnerProgramEnrollmentScalarWhereInput;
};

export type InformPartnerProgramEnrollmentUpdateManyWithWhereWithoutInformPartnerProgramInput = {
  data: InformPartnerProgramEnrollmentUpdateManyMutationInput;
  where: InformPartnerProgramEnrollmentScalarWhereInput;
};

export type InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput = {
  connect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramEnrollmentCreateOrConnectWithoutAcceptedTermsByUserInput>>;
  create?: Maybe<Array<InformPartnerProgramEnrollmentCreateWithoutAcceptedTermsByUserInput>>;
  createMany?: Maybe<InformPartnerProgramEnrollmentCreateManyAcceptedTermsByUserInputEnvelope>;
  delete?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerProgramEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerProgramEnrollmentUpdateWithWhereUniqueWithoutAcceptedTermsByUserInput>>;
  updateMany?: Maybe<Array<InformPartnerProgramEnrollmentUpdateManyWithWhereWithoutAcceptedTermsByUserInput>>;
  upsert?: Maybe<Array<InformPartnerProgramEnrollmentUpsertWithWhereUniqueWithoutAcceptedTermsByUserInput>>;
};

export type InformPartnerProgramEnrollmentUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramEnrollmentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InformPartnerProgramEnrollmentCreateWithoutClinicInput>>;
  createMany?: Maybe<InformPartnerProgramEnrollmentCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerProgramEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerProgramEnrollmentUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<InformPartnerProgramEnrollmentUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<InformPartnerProgramEnrollmentUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type InformPartnerProgramEnrollmentUpdateManyWithoutInformPartnerProgramNestedInput = {
  connect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramEnrollmentCreateOrConnectWithoutInformPartnerProgramInput>>;
  create?: Maybe<Array<InformPartnerProgramEnrollmentCreateWithoutInformPartnerProgramInput>>;
  createMany?: Maybe<InformPartnerProgramEnrollmentCreateManyInformPartnerProgramInputEnvelope>;
  delete?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerProgramEnrollmentScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerProgramEnrollmentWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerProgramEnrollmentUpdateWithWhereUniqueWithoutInformPartnerProgramInput>>;
  updateMany?: Maybe<Array<InformPartnerProgramEnrollmentUpdateManyWithWhereWithoutInformPartnerProgramInput>>;
  upsert?: Maybe<Array<InformPartnerProgramEnrollmentUpsertWithWhereUniqueWithoutInformPartnerProgramInput>>;
};

export type InformPartnerProgramEnrollmentUpdateOneRequiredWithoutInformCampaignEnrollmentsNestedInput = {
  connect?: Maybe<InformPartnerProgramEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerProgramEnrollmentCreateOrConnectWithoutInformCampaignEnrollmentsInput>;
  create?: Maybe<InformPartnerProgramEnrollmentCreateWithoutInformCampaignEnrollmentsInput>;
  update?: Maybe<InformPartnerProgramEnrollmentUpdateToOneWithWhereWithoutInformCampaignEnrollmentsInput>;
  upsert?: Maybe<InformPartnerProgramEnrollmentUpsertWithoutInformCampaignEnrollmentsInput>;
};

export type InformPartnerProgramEnrollmentUpdateOneRequiredWithoutInformNotificationRecipientsNestedInput = {
  connect?: Maybe<InformPartnerProgramEnrollmentWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerProgramEnrollmentCreateOrConnectWithoutInformNotificationRecipientsInput>;
  create?: Maybe<InformPartnerProgramEnrollmentCreateWithoutInformNotificationRecipientsInput>;
  update?: Maybe<InformPartnerProgramEnrollmentUpdateToOneWithWhereWithoutInformNotificationRecipientsInput>;
  upsert?: Maybe<InformPartnerProgramEnrollmentUpsertWithoutInformNotificationRecipientsInput>;
};

export type InformPartnerProgramEnrollmentUpdateToOneWithWhereWithoutInformCampaignEnrollmentsInput = {
  data: InformPartnerProgramEnrollmentUpdateWithoutInformCampaignEnrollmentsInput;
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};

export type InformPartnerProgramEnrollmentUpdateToOneWithWhereWithoutInformNotificationRecipientsInput = {
  data: InformPartnerProgramEnrollmentUpdateWithoutInformNotificationRecipientsInput;
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};

export type InformPartnerProgramEnrollmentUpdateWithWhereUniqueWithoutAcceptedTermsByUserInput = {
  data: InformPartnerProgramEnrollmentUpdateWithoutAcceptedTermsByUserInput;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};

export type InformPartnerProgramEnrollmentUpdateWithWhereUniqueWithoutClinicInput = {
  data: InformPartnerProgramEnrollmentUpdateWithoutClinicInput;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};

export type InformPartnerProgramEnrollmentUpdateWithWhereUniqueWithoutInformPartnerProgramInput = {
  data: InformPartnerProgramEnrollmentUpdateWithoutInformPartnerProgramInput;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};

export type InformPartnerProgramEnrollmentUpdateWithoutAcceptedTermsByUserInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInformPartnerProgramEnrollmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformPartnerProgramEnrollmentsNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUpdateWithoutClinicInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUser?: Maybe<UserUpdateOneWithoutInformPartnerProgramEnrollmentTermsAcceptancesNestedInput>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformPartnerProgramEnrollmentsNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUpdateWithoutInformCampaignEnrollmentsInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUser?: Maybe<UserUpdateOneWithoutInformPartnerProgramEnrollmentTermsAcceptancesNestedInput>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInformPartnerProgramEnrollmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformPartnerProgramEnrollmentsNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUpdateWithoutInformNotificationRecipientsInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUser?: Maybe<UserUpdateOneWithoutInformPartnerProgramEnrollmentTermsAcceptancesNestedInput>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInformPartnerProgramEnrollmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informPartnerProgram?: Maybe<InformPartnerProgramUpdateOneRequiredWithoutInformPartnerProgramEnrollmentsNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUpdateWithoutInformPartnerProgramInput = {
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  acceptedTermsByUser?: Maybe<UserUpdateOneWithoutInformPartnerProgramEnrollmentTermsAcceptancesNestedInput>;
  churnDate?: Maybe<Scalars['DateTime']>;
  churnReason?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInformPartnerProgramEnrollmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutInformPartnerProgramEnrollmentNestedInput>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  lastUpdatedByType?: Maybe<InformEntityUpdatedByType>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformEnrollmentStatus>;
  statusMessage?: Maybe<Scalars['Json']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramEnrollmentUpsertWithWhereUniqueWithoutAcceptedTermsByUserInput = {
  create: InformPartnerProgramEnrollmentCreateWithoutAcceptedTermsByUserInput;
  update: InformPartnerProgramEnrollmentUpdateWithoutAcceptedTermsByUserInput;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};

export type InformPartnerProgramEnrollmentUpsertWithWhereUniqueWithoutClinicInput = {
  create: InformPartnerProgramEnrollmentCreateWithoutClinicInput;
  update: InformPartnerProgramEnrollmentUpdateWithoutClinicInput;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};

export type InformPartnerProgramEnrollmentUpsertWithWhereUniqueWithoutInformPartnerProgramInput = {
  create: InformPartnerProgramEnrollmentCreateWithoutInformPartnerProgramInput;
  update: InformPartnerProgramEnrollmentUpdateWithoutInformPartnerProgramInput;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};

export type InformPartnerProgramEnrollmentUpsertWithoutInformCampaignEnrollmentsInput = {
  create: InformPartnerProgramEnrollmentCreateWithoutInformCampaignEnrollmentsInput;
  update: InformPartnerProgramEnrollmentUpdateWithoutInformCampaignEnrollmentsInput;
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};

export type InformPartnerProgramEnrollmentUpsertWithoutInformNotificationRecipientsInput = {
  create: InformPartnerProgramEnrollmentCreateWithoutInformNotificationRecipientsInput;
  update: InformPartnerProgramEnrollmentUpdateWithoutInformNotificationRecipientsInput;
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};

export type InformPartnerProgramEnrollmentWhereInput = {
  AND?: Maybe<Array<InformPartnerProgramEnrollmentWhereInput>>;
  NOT?: Maybe<Array<InformPartnerProgramEnrollmentWhereInput>>;
  OR?: Maybe<Array<InformPartnerProgramEnrollmentWhereInput>>;
  acceptedTermsAt?: Maybe<DateTimeNullableFilter>;
  acceptedTermsByUser?: Maybe<UserNullableScalarRelationFilter>;
  acceptedTermsByUserId?: Maybe<StringNullableFilter>;
  churnDate?: Maybe<DateTimeNullableFilter>;
  churnReason?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enrolledAt?: Maybe<DateTimeNullableFilter>;
  externalId?: Maybe<StringNullableFilter>;
  goLiveAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentListRelationFilter>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientListRelationFilter>;
  informPartnerProgram?: Maybe<InformPartnerProgramScalarRelationFilter>;
  informPartnerProgramId?: Maybe<StringFilter>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  lastUpdatedByType?: Maybe<EnumInformEntityUpdatedByTypeNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformEnrollmentStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  statusUpdatedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerProgramEnrollmentWhereUniqueInput = {
  AND?: Maybe<Array<InformPartnerProgramEnrollmentWhereInput>>;
  NOT?: Maybe<Array<InformPartnerProgramEnrollmentWhereInput>>;
  OR?: Maybe<Array<InformPartnerProgramEnrollmentWhereInput>>;
  acceptedTermsAt?: Maybe<DateTimeNullableFilter>;
  acceptedTermsByUser?: Maybe<UserNullableScalarRelationFilter>;
  acceptedTermsByUserId?: Maybe<StringNullableFilter>;
  churnDate?: Maybe<DateTimeNullableFilter>;
  churnReason?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicId_informPartnerProgramId?: Maybe<InformPartnerProgramEnrollmentClinicIdInformPartnerProgramIdCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  enrolledAt?: Maybe<DateTimeNullableFilter>;
  externalId?: Maybe<StringNullableFilter>;
  goLiveAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informCampaignEnrollments?: Maybe<InformCampaignEnrollmentListRelationFilter>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientListRelationFilter>;
  informPartnerProgram?: Maybe<InformPartnerProgramScalarRelationFilter>;
  informPartnerProgramId?: Maybe<StringFilter>;
  lastUpdatedBy?: Maybe<StringNullableFilter>;
  lastUpdatedByType?: Maybe<EnumInformEntityUpdatedByTypeNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformEnrollmentStatusFilter>;
  statusMessage?: Maybe<JsonNullableFilter>;
  statusUpdatedAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerProgramGroupByOutputType = {
  __typename?: 'InformPartnerProgramGroupByOutputType';
  _count?: Maybe<InformPartnerProgramCountAggregateOutputType>;
  _max?: Maybe<InformPartnerProgramMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerProgramMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerProgramStatus;
  updatedAt: Scalars['DateTime'];
};

export type InformPartnerProgramInformPartnerIdNameCompoundUniqueInput = {
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
};

export type InformPartnerProgramListRelationFilter = {
  every?: Maybe<InformPartnerProgramWhereInput>;
  none?: Maybe<InformPartnerProgramWhereInput>;
  some?: Maybe<InformPartnerProgramWhereInput>;
};

export type InformPartnerProgramMaxAggregateOutputType = {
  __typename?: 'InformPartnerProgramMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerProgramMinAggregateOutputType = {
  __typename?: 'InformPartnerProgramMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerProgramOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformPartnerProgramOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerProgramOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaigns?: Maybe<InformCampaignOrderByRelationAggregateInput>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerProgramOrderByRelevanceFieldEnum {
  Description = 'description',
  DisplayName = 'displayName',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  Name = 'name'
}

export type InformPartnerProgramOrderByRelevanceInput = {
  fields: Array<InformPartnerProgramOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformPartnerProgramOrderByWithAggregationInput = {
  _count?: Maybe<InformPartnerProgramCountOrderByAggregateInput>;
  _max?: Maybe<InformPartnerProgramMaxOrderByAggregateInput>;
  _min?: Maybe<InformPartnerProgramMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerProgramOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerProgramOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaigns?: Maybe<InformCampaignOrderByRelationAggregateInput>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerProgramOrderByWithRelationInput = {
  _relevance?: Maybe<InformPartnerProgramOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  displayName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaigns?: Maybe<InformCampaignOrderByRelationAggregateInput>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerProgramScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  DisplayName = 'displayName',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  Name = 'name',
  Settings = 'settings',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type InformPartnerProgramScalarRelationFilter = {
  AND?: Maybe<Array<InformPartnerProgramWhereInput>>;
  NOT?: Maybe<Array<InformPartnerProgramWhereInput>>;
  OR?: Maybe<Array<InformPartnerProgramWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informCampaigns?: Maybe<InformCampaignListRelationFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentListRelationFilter>;
  name?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerProgramStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerProgramScalarWhereInput = {
  AND?: Maybe<Array<InformPartnerProgramScalarWhereInput>>;
  NOT?: Maybe<Array<InformPartnerProgramScalarWhereInput>>;
  OR?: Maybe<Array<InformPartnerProgramScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerProgramStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerProgramScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformPartnerProgramScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformPartnerProgramScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformPartnerProgramScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  displayName?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  status?: Maybe<EnumInformPartnerProgramStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformPartnerProgramStatus {
  Active = 'Active',
  Archived = 'Archived',
  Paused = 'Paused'
}

export type InformPartnerProgramUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedCreateNestedManyWithoutInformPartnerProgramInput>;
  informPartnerId: Scalars['String'];
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutInformPartnerProgramInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUncheckedCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformPartnerProgramWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerProgramCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerProgramCreateManyInformPartnerInputEnvelope>;
};

export type InformPartnerProgramUncheckedCreateWithoutInformCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutInformPartnerProgramInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUncheckedCreateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedCreateNestedManyWithoutInformPartnerProgramInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutInformPartnerProgramInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUncheckedCreateWithoutInformPartnerProgramEnrollmentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedCreateNestedManyWithoutInformPartnerProgramInput>;
  informPartnerId: Scalars['String'];
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedUpdateManyWithoutInformPartnerProgramNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutInformPartnerProgramNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUncheckedUpdateManyWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUncheckedUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformPartnerProgramWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerProgramCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerProgramCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerProgramWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerProgramScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerProgramWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerProgramWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerProgramUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformPartnerProgramUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformPartnerProgramUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformPartnerProgramUncheckedUpdateWithoutInformCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutInformPartnerProgramNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUncheckedUpdateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedUpdateManyWithoutInformPartnerProgramNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutInformPartnerProgramNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUncheckedUpdateWithoutInformPartnerProgramEnrollmentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUncheckedUpdateManyWithoutInformPartnerProgramNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUpdateManyWithoutInformPartnerProgramNestedInput>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerProgramsNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutInformPartnerProgramNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUpdateManyWithWhereWithoutInformPartnerInput = {
  data: InformPartnerProgramUpdateManyMutationInput;
  where: InformPartnerProgramScalarWhereInput;
};

export type InformPartnerProgramUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformPartnerProgramWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerProgramCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerProgramCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerProgramCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerProgramWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerProgramScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerProgramWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerProgramWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerProgramUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformPartnerProgramUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformPartnerProgramUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformPartnerProgramUpdateOneRequiredWithoutInformCampaignsNestedInput = {
  connect?: Maybe<InformPartnerProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerProgramCreateOrConnectWithoutInformCampaignsInput>;
  create?: Maybe<InformPartnerProgramCreateWithoutInformCampaignsInput>;
  update?: Maybe<InformPartnerProgramUpdateToOneWithWhereWithoutInformCampaignsInput>;
  upsert?: Maybe<InformPartnerProgramUpsertWithoutInformCampaignsInput>;
};

export type InformPartnerProgramUpdateOneRequiredWithoutInformPartnerProgramEnrollmentsNestedInput = {
  connect?: Maybe<InformPartnerProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerProgramCreateOrConnectWithoutInformPartnerProgramEnrollmentsInput>;
  create?: Maybe<InformPartnerProgramCreateWithoutInformPartnerProgramEnrollmentsInput>;
  update?: Maybe<InformPartnerProgramUpdateToOneWithWhereWithoutInformPartnerProgramEnrollmentsInput>;
  upsert?: Maybe<InformPartnerProgramUpsertWithoutInformPartnerProgramEnrollmentsInput>;
};

export type InformPartnerProgramUpdateToOneWithWhereWithoutInformCampaignsInput = {
  data: InformPartnerProgramUpdateWithoutInformCampaignsInput;
  where?: Maybe<InformPartnerProgramWhereInput>;
};

export type InformPartnerProgramUpdateToOneWithWhereWithoutInformPartnerProgramEnrollmentsInput = {
  data: InformPartnerProgramUpdateWithoutInformPartnerProgramEnrollmentsInput;
  where?: Maybe<InformPartnerProgramWhereInput>;
};

export type InformPartnerProgramUpdateWithWhereUniqueWithoutInformPartnerInput = {
  data: InformPartnerProgramUpdateWithoutInformPartnerInput;
  where: InformPartnerProgramWhereUniqueInput;
};

export type InformPartnerProgramUpdateWithoutInformCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerProgramsNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutInformPartnerProgramNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUpdateWithoutInformPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUpdateManyWithoutInformPartnerProgramNestedInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutInformPartnerProgramNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUpdateWithoutInformPartnerProgramEnrollmentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignUpdateManyWithoutInformPartnerProgramNestedInput>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerProgramsNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerProgramUpsertWithWhereUniqueWithoutInformPartnerInput = {
  create: InformPartnerProgramCreateWithoutInformPartnerInput;
  update: InformPartnerProgramUpdateWithoutInformPartnerInput;
  where: InformPartnerProgramWhereUniqueInput;
};

export type InformPartnerProgramUpsertWithoutInformCampaignsInput = {
  create: InformPartnerProgramCreateWithoutInformCampaignsInput;
  update: InformPartnerProgramUpdateWithoutInformCampaignsInput;
  where?: Maybe<InformPartnerProgramWhereInput>;
};

export type InformPartnerProgramUpsertWithoutInformPartnerProgramEnrollmentsInput = {
  create: InformPartnerProgramCreateWithoutInformPartnerProgramEnrollmentsInput;
  update: InformPartnerProgramUpdateWithoutInformPartnerProgramEnrollmentsInput;
  where?: Maybe<InformPartnerProgramWhereInput>;
};

export type InformPartnerProgramWhereInput = {
  AND?: Maybe<Array<InformPartnerProgramWhereInput>>;
  NOT?: Maybe<Array<InformPartnerProgramWhereInput>>;
  OR?: Maybe<Array<InformPartnerProgramWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informCampaigns?: Maybe<InformCampaignListRelationFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentListRelationFilter>;
  name?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerProgramStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerProgramWhereUniqueInput = {
  AND?: Maybe<Array<InformPartnerProgramWhereInput>>;
  NOT?: Maybe<Array<InformPartnerProgramWhereInput>>;
  OR?: Maybe<Array<InformPartnerProgramWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  displayName?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informCampaigns?: Maybe<InformCampaignListRelationFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerId_name?: Maybe<InformPartnerProgramInformPartnerIdNameCompoundUniqueInput>;
  informPartnerProgramEnrollments?: Maybe<InformPartnerProgramEnrollmentListRelationFilter>;
  name?: Maybe<StringFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerProgramStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum InformPartnerScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  Settings = 'settings',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type InformPartnerScalarRelationFilter = {
  AND?: Maybe<Array<InformPartnerWhereInput>>;
  NOT?: Maybe<Array<InformPartnerWhereInput>>;
  OR?: Maybe<Array<InformPartnerWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  informCampaignGroups?: Maybe<InformCampaignGroupListRelationFilter>;
  informEmailTemplates?: Maybe<InformEmailTemplateListRelationFilter>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationListRelationFilter>;
  informPartnerPrograms?: Maybe<InformPartnerProgramListRelationFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  name?: Maybe<StringFilter>;
  products?: Maybe<ProductListRelationFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformPartnerScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformPartnerScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformPartnerScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  status?: Maybe<EnumInformPartnerStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformPartnerStatus {
  Active = 'Active',
  Archived = 'Archived',
  Paused = 'Paused'
}

export type InformPartnerUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedCreateWithoutInformAudienceDefinitionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedCreateWithoutInformCampaignGroupsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedCreateWithoutInformEmailTemplatesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedCreateWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedCreateWithoutInformPartnerIntegrationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedCreateWithoutInformPartnerProgramsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedCreateWithoutInformPartnerUsersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutInformPartnerInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedCreateWithoutProductsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedCreateNestedManyWithoutInformPartnerInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerInput>;
  name: Scalars['String'];
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedUpdateWithoutInformAudienceDefinitionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedUpdateWithoutInformCampaignGroupsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedUpdateWithoutInformEmailTemplatesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedUpdateWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedUpdateWithoutInformPartnerIntegrationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedUpdateWithoutInformPartnerProgramsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedUpdateWithoutInformPartnerUsersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUncheckedUpdateWithoutProductsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUncheckedUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUpdateOneRequiredWithoutInformCampaignGroupsNestedInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformCampaignGroupsInput>;
  create?: Maybe<InformPartnerCreateWithoutInformCampaignGroupsInput>;
  update?: Maybe<InformPartnerUpdateToOneWithWhereWithoutInformCampaignGroupsInput>;
  upsert?: Maybe<InformPartnerUpsertWithoutInformCampaignGroupsInput>;
};

export type InformPartnerUpdateOneRequiredWithoutInformPartnerCustomerNestedInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformPartnerCustomerInput>;
  create?: Maybe<InformPartnerCreateWithoutInformPartnerCustomerInput>;
  update?: Maybe<InformPartnerUpdateToOneWithWhereWithoutInformPartnerCustomerInput>;
  upsert?: Maybe<InformPartnerUpsertWithoutInformPartnerCustomerInput>;
};

export type InformPartnerUpdateOneRequiredWithoutInformPartnerIntegrationsNestedInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformPartnerIntegrationsInput>;
  create?: Maybe<InformPartnerCreateWithoutInformPartnerIntegrationsInput>;
  update?: Maybe<InformPartnerUpdateToOneWithWhereWithoutInformPartnerIntegrationsInput>;
  upsert?: Maybe<InformPartnerUpsertWithoutInformPartnerIntegrationsInput>;
};

export type InformPartnerUpdateOneRequiredWithoutInformPartnerProgramsNestedInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformPartnerProgramsInput>;
  create?: Maybe<InformPartnerCreateWithoutInformPartnerProgramsInput>;
  update?: Maybe<InformPartnerUpdateToOneWithWhereWithoutInformPartnerProgramsInput>;
  upsert?: Maybe<InformPartnerUpsertWithoutInformPartnerProgramsInput>;
};

export type InformPartnerUpdateOneRequiredWithoutInformPartnerUsersNestedInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformPartnerUsersInput>;
  create?: Maybe<InformPartnerCreateWithoutInformPartnerUsersInput>;
  update?: Maybe<InformPartnerUpdateToOneWithWhereWithoutInformPartnerUsersInput>;
  upsert?: Maybe<InformPartnerUpsertWithoutInformPartnerUsersInput>;
};

export type InformPartnerUpdateOneWithoutInformAudienceDefinitionsNestedInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformAudienceDefinitionsInput>;
  create?: Maybe<InformPartnerCreateWithoutInformAudienceDefinitionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformPartnerUpdateToOneWithWhereWithoutInformAudienceDefinitionsInput>;
  upsert?: Maybe<InformPartnerUpsertWithoutInformAudienceDefinitionsInput>;
};

export type InformPartnerUpdateOneWithoutInformEmailTemplatesNestedInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutInformEmailTemplatesInput>;
  create?: Maybe<InformPartnerCreateWithoutInformEmailTemplatesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformPartnerUpdateToOneWithWhereWithoutInformEmailTemplatesInput>;
  upsert?: Maybe<InformPartnerUpsertWithoutInformEmailTemplatesInput>;
};

export type InformPartnerUpdateOneWithoutProductsNestedInput = {
  connect?: Maybe<InformPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerCreateOrConnectWithoutProductsInput>;
  create?: Maybe<InformPartnerCreateWithoutProductsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformPartnerUpdateToOneWithWhereWithoutProductsInput>;
  upsert?: Maybe<InformPartnerUpsertWithoutProductsInput>;
};

export type InformPartnerUpdateToOneWithWhereWithoutInformAudienceDefinitionsInput = {
  data: InformPartnerUpdateWithoutInformAudienceDefinitionsInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpdateToOneWithWhereWithoutInformCampaignGroupsInput = {
  data: InformPartnerUpdateWithoutInformCampaignGroupsInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpdateToOneWithWhereWithoutInformEmailTemplatesInput = {
  data: InformPartnerUpdateWithoutInformEmailTemplatesInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpdateToOneWithWhereWithoutInformPartnerCustomerInput = {
  data: InformPartnerUpdateWithoutInformPartnerCustomerInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpdateToOneWithWhereWithoutInformPartnerIntegrationsInput = {
  data: InformPartnerUpdateWithoutInformPartnerIntegrationsInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpdateToOneWithWhereWithoutInformPartnerProgramsInput = {
  data: InformPartnerUpdateWithoutInformPartnerProgramsInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpdateToOneWithWhereWithoutInformPartnerUsersInput = {
  data: InformPartnerUpdateWithoutInformPartnerUsersInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpdateToOneWithWhereWithoutProductsInput = {
  data: InformPartnerUpdateWithoutProductsInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpdateWithoutInformAudienceDefinitionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informCampaignGroups?: Maybe<InformCampaignGroupUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUpdateWithoutInformCampaignGroupsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUpdateWithoutInformEmailTemplatesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUpdateWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUpdateWithoutInformPartnerIntegrationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUpdateWithoutInformPartnerProgramsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUpdateWithoutInformPartnerUsersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUpdateManyWithoutInformPartnerNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUpdateWithoutProductsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionUpdateManyWithoutInformPartnerNestedInput>;
  informCampaignGroups?: Maybe<InformCampaignGroupUpdateManyWithoutInformPartnerNestedInput>;
  informEmailTemplates?: Maybe<InformEmailTemplateUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerPrograms?: Maybe<InformPartnerProgramUpdateManyWithoutInformPartnerNestedInput>;
  informPartnerUsers?: Maybe<InformPartnerUserUpdateManyWithoutInformPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUpsertWithoutInformAudienceDefinitionsInput = {
  create: InformPartnerCreateWithoutInformAudienceDefinitionsInput;
  update: InformPartnerUpdateWithoutInformAudienceDefinitionsInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpsertWithoutInformCampaignGroupsInput = {
  create: InformPartnerCreateWithoutInformCampaignGroupsInput;
  update: InformPartnerUpdateWithoutInformCampaignGroupsInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpsertWithoutInformEmailTemplatesInput = {
  create: InformPartnerCreateWithoutInformEmailTemplatesInput;
  update: InformPartnerUpdateWithoutInformEmailTemplatesInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpsertWithoutInformPartnerCustomerInput = {
  create: InformPartnerCreateWithoutInformPartnerCustomerInput;
  update: InformPartnerUpdateWithoutInformPartnerCustomerInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpsertWithoutInformPartnerIntegrationsInput = {
  create: InformPartnerCreateWithoutInformPartnerIntegrationsInput;
  update: InformPartnerUpdateWithoutInformPartnerIntegrationsInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpsertWithoutInformPartnerProgramsInput = {
  create: InformPartnerCreateWithoutInformPartnerProgramsInput;
  update: InformPartnerUpdateWithoutInformPartnerProgramsInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpsertWithoutInformPartnerUsersInput = {
  create: InformPartnerCreateWithoutInformPartnerUsersInput;
  update: InformPartnerUpdateWithoutInformPartnerUsersInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUpsertWithoutProductsInput = {
  create: InformPartnerCreateWithoutProductsInput;
  update: InformPartnerUpdateWithoutProductsInput;
  where?: Maybe<InformPartnerWhereInput>;
};

export type InformPartnerUser = {
  __typename?: 'InformPartnerUser';
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id: Array<UserImpersonation>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id: Array<UserImpersonation>;
  _count: InformPartnerUserCountOutputType;
  boehringerIngelheimTerritories: Array<BoehringerIngelheimTerritory>;
  checksum: Scalars['String'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartner: InformPartner;
  informPartnerCustomers: Array<InformPartnerCustomer>;
  informPartnerId: Scalars['String'];
  informPartnerIntegration: InformPartnerIntegration;
  informPartnerIntegrationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles: Array<InformPartnerUserRole>;
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerUserStatus;
  updatedAt: Scalars['DateTime'];
};


export type InformPartnerUserUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdArgs = {
  cursor?: Maybe<UserImpersonationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserImpersonationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserImpersonationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserImpersonationWhereInput>;
};


export type InformPartnerUserUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdArgs = {
  cursor?: Maybe<UserImpersonationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserImpersonationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserImpersonationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserImpersonationWhereInput>;
};


export type InformPartnerUserBoehringerIngelheimTerritoriesArgs = {
  cursor?: Maybe<BoehringerIngelheimTerritoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoehringerIngelheimTerritoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoehringerIngelheimTerritoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};


export type InformPartnerUserInformPartnerCustomersArgs = {
  cursor?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};


export type InformPartnerUserRolesArgs = {
  cursor?: Maybe<InformPartnerUserRoleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerUserRoleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserRoleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserRoleWhereInput>;
};

export type InformPartnerUserCountAggregateOutputType = {
  __typename?: 'InformPartnerUserCountAggregateOutputType';
  _all: Scalars['Int'];
  checksum: Scalars['Int'];
  createdAt: Scalars['Int'];
  email: Scalars['Int'];
  externalId: Scalars['Int'];
  firebaseId: Scalars['Int'];
  firstName: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerId: Scalars['Int'];
  informPartnerIntegrationId: Scalars['Int'];
  lastName: Scalars['Int'];
  phone: Scalars['Int'];
  rawData: Scalars['Int'];
  settings: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformPartnerUserCountOrderByAggregateInput = {
  checksum?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerUserCountOutputType = {
  __typename?: 'InformPartnerUserCountOutputType';
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id: Scalars['Int'];
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id: Scalars['Int'];
  boehringerIngelheimTerritories: Scalars['Int'];
  informPartnerCustomers: Scalars['Int'];
  roles: Scalars['Int'];
};

export type InformPartnerUserCreateInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerUsersInput;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerUsersInput;
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserCreateManyInformPartnerInput = {
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserCreateManyInformPartnerInputEnvelope = {
  data: Array<InformPartnerUserCreateManyInformPartnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerUserCreateManyInformPartnerIntegrationInput = {
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserCreateManyInformPartnerIntegrationInputEnvelope = {
  data: Array<InformPartnerUserCreateManyInformPartnerIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerUserCreateManyInput = {
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserCreateNestedManyWithoutBoehringerIngelheimTerritoriesInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutBoehringerIngelheimTerritoriesInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutBoehringerIngelheimTerritoriesInput>>;
};

export type InformPartnerUserCreateNestedManyWithoutInformPartnerCustomersInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutInformPartnerCustomersInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutInformPartnerCustomersInput>>;
};

export type InformPartnerUserCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerUserCreateManyInformPartnerInputEnvelope>;
};

export type InformPartnerUserCreateNestedManyWithoutInformPartnerIntegrationInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerUserCreateManyInformPartnerIntegrationInputEnvelope>;
};

export type InformPartnerUserCreateNestedOneWithoutRolesInput = {
  connect?: Maybe<InformPartnerUserWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerUserCreateOrConnectWithoutRolesInput>;
  create?: Maybe<InformPartnerUserCreateWithoutRolesInput>;
};

export type InformPartnerUserCreateNestedOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput = {
  connect?: Maybe<InformPartnerUserWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerUserCreateOrConnectWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput>;
  create?: Maybe<InformPartnerUserCreateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput>;
};

export type InformPartnerUserCreateNestedOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput = {
  connect?: Maybe<InformPartnerUserWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerUserCreateOrConnectWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput>;
  create?: Maybe<InformPartnerUserCreateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput>;
};

export type InformPartnerUserCreateOrConnectWithoutBoehringerIngelheimTerritoriesInput = {
  create: InformPartnerUserCreateWithoutBoehringerIngelheimTerritoriesInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserCreateOrConnectWithoutInformPartnerCustomersInput = {
  create: InformPartnerUserCreateWithoutInformPartnerCustomersInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserCreateOrConnectWithoutInformPartnerInput = {
  create: InformPartnerUserCreateWithoutInformPartnerInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserCreateOrConnectWithoutInformPartnerIntegrationInput = {
  create: InformPartnerUserCreateWithoutInformPartnerIntegrationInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserCreateOrConnectWithoutRolesInput = {
  create: InformPartnerUserCreateWithoutRolesInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserCreateOrConnectWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput = {
  create: InformPartnerUserCreateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserCreateOrConnectWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput = {
  create: InformPartnerUserCreateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserCreateWithoutBoehringerIngelheimTerritoriesInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutInformPartnerUserInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerUsersInput;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerUsersInput;
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserCreateWithoutInformPartnerCustomersInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerUsersInput;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerUsersInput;
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserCreateWithoutInformPartnerInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerUsersInput;
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserCreateWithoutInformPartnerIntegrationInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerUsersInput;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerUsersInput>;
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserCreateWithoutRolesInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerUsersInput;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerUsersInput;
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserCreateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerUsersInput;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerUsersInput;
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserCreateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner: InformPartnerCreateNestedOneWithoutInformPartnerUsersInput;
  informPartnerCustomers?: Maybe<InformPartnerCustomerCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerIntegration: InformPartnerIntegrationCreateNestedOneWithoutInformPartnerUsersInput;
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserGroupByOutputType = {
  __typename?: 'InformPartnerUserGroupByOutputType';
  _count?: Maybe<InformPartnerUserCountAggregateOutputType>;
  _max?: Maybe<InformPartnerUserMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerUserMinAggregateOutputType>;
  checksum: Scalars['String'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerUserStatus;
  updatedAt: Scalars['DateTime'];
};

export type InformPartnerUserInformPartnerIdEmailCompoundUniqueInput = {
  email: Scalars['String'];
  informPartnerId: Scalars['String'];
};

export type InformPartnerUserInformPartnerIdExternalIdCompoundUniqueInput = {
  externalId: Scalars['String'];
  informPartnerId: Scalars['String'];
};

export type InformPartnerUserInformPartnerIdFirebaseIdCompoundUniqueInput = {
  firebaseId: Scalars['String'];
  informPartnerId: Scalars['String'];
};

export type InformPartnerUserListRelationFilter = {
  every?: Maybe<InformPartnerUserWhereInput>;
  none?: Maybe<InformPartnerUserWhereInput>;
  some?: Maybe<InformPartnerUserWhereInput>;
};

export type InformPartnerUserMaxAggregateOutputType = {
  __typename?: 'InformPartnerUserMaxAggregateOutputType';
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserMaxOrderByAggregateInput = {
  checksum?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerUserMinAggregateOutputType = {
  __typename?: 'InformPartnerUserMinAggregateOutputType';
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserMinOrderByAggregateInput = {
  checksum?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerUserNullableScalarRelationFilter = {
  AND?: Maybe<Array<InformPartnerUserWhereInput>>;
  NOT?: Maybe<Array<InformPartnerUserWhereInput>>;
  OR?: Maybe<Array<InformPartnerUserWhereInput>>;
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationListRelationFilter>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationListRelationFilter>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryListRelationFilter>;
  checksum?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  externalId?: Maybe<StringFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firstName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationScalarRelationFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  lastName?: Maybe<StringNullableFilter>;
  phone?: Maybe<StringFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  roles?: Maybe<InformPartnerUserRoleListRelationFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerUserStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerUserOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformPartnerUserOrderByRelationAndSearchRelevanceInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationOrderByRelationAggregateInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationOrderByRelationAggregateInput>;
  _relevance?: Maybe<InformPartnerUserOrderByRelevanceInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryOrderByRelationAggregateInput>;
  checksum?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationOrderByWithRelationInput>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  roles?: Maybe<InformPartnerUserRoleOrderByRelationAggregateInput>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerUserOrderByRelevanceFieldEnum {
  Checksum = 'checksum',
  Email = 'email',
  ExternalId = 'externalId',
  FirebaseId = 'firebaseId',
  FirstName = 'firstName',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  InformPartnerIntegrationId = 'informPartnerIntegrationId',
  LastName = 'lastName',
  Phone = 'phone'
}

export type InformPartnerUserOrderByRelevanceInput = {
  fields: Array<InformPartnerUserOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformPartnerUserOrderByWithAggregationInput = {
  _count?: Maybe<InformPartnerUserCountOrderByAggregateInput>;
  _max?: Maybe<InformPartnerUserMaxOrderByAggregateInput>;
  _min?: Maybe<InformPartnerUserMinOrderByAggregateInput>;
  checksum?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerUserOrderByWithRelationAndSearchRelevanceInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationOrderByRelationAggregateInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationOrderByRelationAggregateInput>;
  _relevance?: Maybe<InformPartnerUserOrderByRelevanceInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryOrderByRelationAggregateInput>;
  checksum?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationOrderByWithRelationInput>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  roles?: Maybe<InformPartnerUserRoleOrderByRelationAggregateInput>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerUserOrderByWithRelationInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationOrderByRelationAggregateInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationOrderByRelationAggregateInput>;
  _relevance?: Maybe<InformPartnerUserOrderByRelevanceInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryOrderByRelationAggregateInput>;
  checksum?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerOrderByRelationAggregateInput>;
  informPartnerId?: Maybe<SortOrder>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationOrderByWithRelationInput>;
  informPartnerIntegrationId?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  rawData?: Maybe<SortOrder>;
  roles?: Maybe<InformPartnerUserRoleOrderByRelationAggregateInput>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerUserRole = {
  __typename?: 'InformPartnerUserRole';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informPartnerCustomer: InformPartnerCustomer;
  informPartnerCustomerId: Scalars['String'];
  informPartnerUser: InformPartnerUser;
  informPartnerUserId: Scalars['String'];
  name: InformPartnerUserRoleName;
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerUserRoleStatus;
  updatedAt: Scalars['DateTime'];
};

export type InformPartnerUserRoleCountAggregateOutputType = {
  __typename?: 'InformPartnerUserRoleCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  informPartnerCustomerId: Scalars['Int'];
  informPartnerUserId: Scalars['Int'];
  name: Scalars['Int'];
  settings: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformPartnerUserRoleCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerUserRoleCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer: InformPartnerCustomerCreateNestedOneWithoutRolesInput;
  informPartnerUser: InformPartnerUserCreateNestedOneWithoutRolesInput;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleCreateManyInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUserId: Scalars['String'];
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleCreateManyInformPartnerCustomerInputEnvelope = {
  data: Array<InformPartnerUserRoleCreateManyInformPartnerCustomerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerUserRoleCreateManyInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId: Scalars['String'];
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleCreateManyInformPartnerUserInputEnvelope = {
  data: Array<InformPartnerUserRoleCreateManyInformPartnerUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformPartnerUserRoleCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId: Scalars['String'];
  informPartnerUserId: Scalars['String'];
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleCreateNestedManyWithoutInformPartnerCustomerInput = {
  connect?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserRoleCreateOrConnectWithoutInformPartnerCustomerInput>>;
  create?: Maybe<Array<InformPartnerUserRoleCreateWithoutInformPartnerCustomerInput>>;
  createMany?: Maybe<InformPartnerUserRoleCreateManyInformPartnerCustomerInputEnvelope>;
};

export type InformPartnerUserRoleCreateNestedManyWithoutInformPartnerUserInput = {
  connect?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserRoleCreateOrConnectWithoutInformPartnerUserInput>>;
  create?: Maybe<Array<InformPartnerUserRoleCreateWithoutInformPartnerUserInput>>;
  createMany?: Maybe<InformPartnerUserRoleCreateManyInformPartnerUserInputEnvelope>;
};

export type InformPartnerUserRoleCreateOrConnectWithoutInformPartnerCustomerInput = {
  create: InformPartnerUserRoleCreateWithoutInformPartnerCustomerInput;
  where: InformPartnerUserRoleWhereUniqueInput;
};

export type InformPartnerUserRoleCreateOrConnectWithoutInformPartnerUserInput = {
  create: InformPartnerUserRoleCreateWithoutInformPartnerUserInput;
  where: InformPartnerUserRoleWhereUniqueInput;
};

export type InformPartnerUserRoleCreateWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUser: InformPartnerUserCreateNestedOneWithoutRolesInput;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleCreateWithoutInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer: InformPartnerCustomerCreateNestedOneWithoutRolesInput;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleGroupByOutputType = {
  __typename?: 'InformPartnerUserRoleGroupByOutputType';
  _count?: Maybe<InformPartnerUserRoleCountAggregateOutputType>;
  _max?: Maybe<InformPartnerUserRoleMaxAggregateOutputType>;
  _min?: Maybe<InformPartnerUserRoleMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informPartnerCustomerId: Scalars['String'];
  informPartnerUserId: Scalars['String'];
  name: InformPartnerUserRoleName;
  settings?: Maybe<Scalars['Json']>;
  status: InformPartnerUserRoleStatus;
  updatedAt: Scalars['DateTime'];
};

export type InformPartnerUserRoleInformPartnerUserIdInformPartnerCustomerIdNameCompoundUniqueInput = {
  informPartnerCustomerId: Scalars['String'];
  informPartnerUserId: Scalars['String'];
  name: InformPartnerUserRoleName;
};

export type InformPartnerUserRoleListRelationFilter = {
  every?: Maybe<InformPartnerUserRoleWhereInput>;
  none?: Maybe<InformPartnerUserRoleWhereInput>;
  some?: Maybe<InformPartnerUserRoleWhereInput>;
};

export type InformPartnerUserRoleMaxAggregateOutputType = {
  __typename?: 'InformPartnerUserRoleMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerUserRoleName>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerUserRoleMinAggregateOutputType = {
  __typename?: 'InformPartnerUserRoleMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerUserRoleName>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerUserRoleName {
  Default = 'Default'
}

export type InformPartnerUserRoleOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformPartnerUserRoleOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerUserRoleOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerOrderByWithRelationInput>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerUser?: Maybe<InformPartnerUserOrderByWithRelationInput>;
  informPartnerUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerUserRoleOrderByRelevanceFieldEnum {
  Id = 'id',
  InformPartnerCustomerId = 'informPartnerCustomerId',
  InformPartnerUserId = 'informPartnerUserId'
}

export type InformPartnerUserRoleOrderByRelevanceInput = {
  fields: Array<InformPartnerUserRoleOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformPartnerUserRoleOrderByWithAggregationInput = {
  _count?: Maybe<InformPartnerUserRoleCountOrderByAggregateInput>;
  _max?: Maybe<InformPartnerUserRoleMaxOrderByAggregateInput>;
  _min?: Maybe<InformPartnerUserRoleMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerUserRoleOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformPartnerUserRoleOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerOrderByWithRelationInput>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerUser?: Maybe<InformPartnerUserOrderByWithRelationInput>;
  informPartnerUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformPartnerUserRoleOrderByWithRelationInput = {
  _relevance?: Maybe<InformPartnerUserRoleOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerOrderByWithRelationInput>;
  informPartnerCustomerId?: Maybe<SortOrder>;
  informPartnerUser?: Maybe<InformPartnerUserOrderByWithRelationInput>;
  informPartnerUserId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformPartnerUserRoleScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  InformPartnerCustomerId = 'informPartnerCustomerId',
  InformPartnerUserId = 'informPartnerUserId',
  Name = 'name',
  Settings = 'settings',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type InformPartnerUserRoleScalarWhereInput = {
  AND?: Maybe<Array<InformPartnerUserRoleScalarWhereInput>>;
  NOT?: Maybe<Array<InformPartnerUserRoleScalarWhereInput>>;
  OR?: Maybe<Array<InformPartnerUserRoleScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informPartnerCustomerId?: Maybe<StringFilter>;
  informPartnerUserId?: Maybe<StringFilter>;
  name?: Maybe<EnumInformPartnerUserRoleNameFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerUserRoleStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerUserRoleScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformPartnerUserRoleScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformPartnerUserRoleScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformPartnerUserRoleScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerCustomerId?: Maybe<StringWithAggregatesFilter>;
  informPartnerUserId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<EnumInformPartnerUserRoleNameWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  status?: Maybe<EnumInformPartnerUserRoleStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformPartnerUserRoleStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type InformPartnerUserRoleUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId: Scalars['String'];
  informPartnerUserId: Scalars['String'];
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerCustomerInput = {
  connect?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserRoleCreateOrConnectWithoutInformPartnerCustomerInput>>;
  create?: Maybe<Array<InformPartnerUserRoleCreateWithoutInformPartnerCustomerInput>>;
  createMany?: Maybe<InformPartnerUserRoleCreateManyInformPartnerCustomerInputEnvelope>;
};

export type InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerUserInput = {
  connect?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserRoleCreateOrConnectWithoutInformPartnerUserInput>>;
  create?: Maybe<Array<InformPartnerUserRoleCreateWithoutInformPartnerUserInput>>;
  createMany?: Maybe<InformPartnerUserRoleCreateManyInformPartnerUserInputEnvelope>;
};

export type InformPartnerUserRoleUncheckedCreateWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUserId: Scalars['String'];
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUncheckedCreateWithoutInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId: Scalars['String'];
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerCustomerNestedInput = {
  connect?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserRoleCreateOrConnectWithoutInformPartnerCustomerInput>>;
  create?: Maybe<Array<InformPartnerUserRoleCreateWithoutInformPartnerCustomerInput>>;
  createMany?: Maybe<InformPartnerUserRoleCreateManyInformPartnerCustomerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerUserRoleScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerUserRoleUpdateWithWhereUniqueWithoutInformPartnerCustomerInput>>;
  updateMany?: Maybe<Array<InformPartnerUserRoleUpdateManyWithWhereWithoutInformPartnerCustomerInput>>;
  upsert?: Maybe<Array<InformPartnerUserRoleUpsertWithWhereUniqueWithoutInformPartnerCustomerInput>>;
};

export type InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerUserNestedInput = {
  connect?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserRoleCreateOrConnectWithoutInformPartnerUserInput>>;
  create?: Maybe<Array<InformPartnerUserRoleCreateWithoutInformPartnerUserInput>>;
  createMany?: Maybe<InformPartnerUserRoleCreateManyInformPartnerUserInputEnvelope>;
  delete?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerUserRoleScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerUserRoleUpdateWithWhereUniqueWithoutInformPartnerUserInput>>;
  updateMany?: Maybe<Array<InformPartnerUserRoleUpdateManyWithWhereWithoutInformPartnerUserInput>>;
  upsert?: Maybe<Array<InformPartnerUserRoleUpsertWithWhereUniqueWithoutInformPartnerUserInput>>;
};

export type InformPartnerUserRoleUncheckedUpdateWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUncheckedUpdateWithoutInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomerId?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneRequiredWithoutRolesNestedInput>;
  informPartnerUser?: Maybe<InformPartnerUserUpdateOneRequiredWithoutRolesNestedInput>;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUpdateManyWithWhereWithoutInformPartnerCustomerInput = {
  data: InformPartnerUserRoleUpdateManyMutationInput;
  where: InformPartnerUserRoleScalarWhereInput;
};

export type InformPartnerUserRoleUpdateManyWithWhereWithoutInformPartnerUserInput = {
  data: InformPartnerUserRoleUpdateManyMutationInput;
  where: InformPartnerUserRoleScalarWhereInput;
};

export type InformPartnerUserRoleUpdateManyWithoutInformPartnerCustomerNestedInput = {
  connect?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserRoleCreateOrConnectWithoutInformPartnerCustomerInput>>;
  create?: Maybe<Array<InformPartnerUserRoleCreateWithoutInformPartnerCustomerInput>>;
  createMany?: Maybe<InformPartnerUserRoleCreateManyInformPartnerCustomerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerUserRoleScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerUserRoleUpdateWithWhereUniqueWithoutInformPartnerCustomerInput>>;
  updateMany?: Maybe<Array<InformPartnerUserRoleUpdateManyWithWhereWithoutInformPartnerCustomerInput>>;
  upsert?: Maybe<Array<InformPartnerUserRoleUpsertWithWhereUniqueWithoutInformPartnerCustomerInput>>;
};

export type InformPartnerUserRoleUpdateManyWithoutInformPartnerUserNestedInput = {
  connect?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserRoleCreateOrConnectWithoutInformPartnerUserInput>>;
  create?: Maybe<Array<InformPartnerUserRoleCreateWithoutInformPartnerUserInput>>;
  createMany?: Maybe<InformPartnerUserRoleCreateManyInformPartnerUserInputEnvelope>;
  delete?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerUserRoleScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerUserRoleWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerUserRoleUpdateWithWhereUniqueWithoutInformPartnerUserInput>>;
  updateMany?: Maybe<Array<InformPartnerUserRoleUpdateManyWithWhereWithoutInformPartnerUserInput>>;
  upsert?: Maybe<Array<InformPartnerUserRoleUpsertWithWhereUniqueWithoutInformPartnerUserInput>>;
};

export type InformPartnerUserRoleUpdateWithWhereUniqueWithoutInformPartnerCustomerInput = {
  data: InformPartnerUserRoleUpdateWithoutInformPartnerCustomerInput;
  where: InformPartnerUserRoleWhereUniqueInput;
};

export type InformPartnerUserRoleUpdateWithWhereUniqueWithoutInformPartnerUserInput = {
  data: InformPartnerUserRoleUpdateWithoutInformPartnerUserInput;
  where: InformPartnerUserRoleWhereUniqueInput;
};

export type InformPartnerUserRoleUpdateWithoutInformPartnerCustomerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerUser?: Maybe<InformPartnerUserUpdateOneRequiredWithoutRolesNestedInput>;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUpdateWithoutInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerUpdateOneRequiredWithoutRolesNestedInput>;
  name?: Maybe<InformPartnerUserRoleName>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserRoleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserRoleUpsertWithWhereUniqueWithoutInformPartnerCustomerInput = {
  create: InformPartnerUserRoleCreateWithoutInformPartnerCustomerInput;
  update: InformPartnerUserRoleUpdateWithoutInformPartnerCustomerInput;
  where: InformPartnerUserRoleWhereUniqueInput;
};

export type InformPartnerUserRoleUpsertWithWhereUniqueWithoutInformPartnerUserInput = {
  create: InformPartnerUserRoleCreateWithoutInformPartnerUserInput;
  update: InformPartnerUserRoleUpdateWithoutInformPartnerUserInput;
  where: InformPartnerUserRoleWhereUniqueInput;
};

export type InformPartnerUserRoleWhereInput = {
  AND?: Maybe<Array<InformPartnerUserRoleWhereInput>>;
  NOT?: Maybe<Array<InformPartnerUserRoleWhereInput>>;
  OR?: Maybe<Array<InformPartnerUserRoleWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerScalarRelationFilter>;
  informPartnerCustomerId?: Maybe<StringFilter>;
  informPartnerUser?: Maybe<InformPartnerUserScalarRelationFilter>;
  informPartnerUserId?: Maybe<StringFilter>;
  name?: Maybe<EnumInformPartnerUserRoleNameFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerUserRoleStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerUserRoleWhereUniqueInput = {
  AND?: Maybe<Array<InformPartnerUserRoleWhereInput>>;
  NOT?: Maybe<Array<InformPartnerUserRoleWhereInput>>;
  OR?: Maybe<Array<InformPartnerUserRoleWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerScalarRelationFilter>;
  informPartnerCustomerId?: Maybe<StringFilter>;
  informPartnerUser?: Maybe<InformPartnerUserScalarRelationFilter>;
  informPartnerUserId?: Maybe<StringFilter>;
  informPartnerUserId_informPartnerCustomerId_name?: Maybe<InformPartnerUserRoleInformPartnerUserIdInformPartnerCustomerIdNameCompoundUniqueInput>;
  name?: Maybe<EnumInformPartnerUserRoleNameFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerUserRoleStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum InformPartnerUserScalarFieldEnum {
  Checksum = 'checksum',
  CreatedAt = 'createdAt',
  Email = 'email',
  ExternalId = 'externalId',
  FirebaseId = 'firebaseId',
  FirstName = 'firstName',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  InformPartnerIntegrationId = 'informPartnerIntegrationId',
  LastName = 'lastName',
  Phone = 'phone',
  RawData = 'rawData',
  Settings = 'settings',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type InformPartnerUserScalarRelationFilter = {
  AND?: Maybe<Array<InformPartnerUserWhereInput>>;
  NOT?: Maybe<Array<InformPartnerUserWhereInput>>;
  OR?: Maybe<Array<InformPartnerUserWhereInput>>;
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationListRelationFilter>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationListRelationFilter>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryListRelationFilter>;
  checksum?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  externalId?: Maybe<StringFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firstName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationScalarRelationFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  lastName?: Maybe<StringNullableFilter>;
  phone?: Maybe<StringFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  roles?: Maybe<InformPartnerUserRoleListRelationFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerUserStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerUserScalarWhereInput = {
  AND?: Maybe<Array<InformPartnerUserScalarWhereInput>>;
  NOT?: Maybe<Array<InformPartnerUserScalarWhereInput>>;
  OR?: Maybe<Array<InformPartnerUserScalarWhereInput>>;
  checksum?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  externalId?: Maybe<StringFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firstName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  lastName?: Maybe<StringNullableFilter>;
  phone?: Maybe<StringFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerUserStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerUserScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformPartnerUserScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformPartnerUserScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformPartnerUserScalarWhereWithAggregatesInput>>;
  checksum?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  email?: Maybe<StringWithAggregatesFilter>;
  externalId?: Maybe<StringWithAggregatesFilter>;
  firebaseId?: Maybe<StringNullableWithAggregatesFilter>;
  firstName?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informPartnerId?: Maybe<StringWithAggregatesFilter>;
  informPartnerIntegrationId?: Maybe<StringWithAggregatesFilter>;
  lastName?: Maybe<StringNullableWithAggregatesFilter>;
  phone?: Maybe<StringWithAggregatesFilter>;
  rawData?: Maybe<JsonNullableWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  status?: Maybe<EnumInformPartnerUserStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformPartnerUserStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type InformPartnerUserUncheckedCreateInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedCreateNestedManyWithoutBoehringerIngelheimTerritoriesInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutBoehringerIngelheimTerritoriesInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutBoehringerIngelheimTerritoriesInput>>;
};

export type InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerCustomersInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutInformPartnerCustomersInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutInformPartnerCustomersInput>>;
};

export type InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerUserCreateManyInformPartnerInputEnvelope>;
};

export type InformPartnerUserUncheckedCreateNestedManyWithoutInformPartnerIntegrationInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerUserCreateManyInformPartnerIntegrationInputEnvelope>;
};

export type InformPartnerUserUncheckedCreateWithoutBoehringerIngelheimTerritoriesInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedCreateWithoutInformPartnerCustomersInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedCreateWithoutInformPartnerInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerIntegrationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedCreateWithoutInformPartnerIntegrationInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedCreateWithoutRolesInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedCreateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedCreateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedInformPartnerUserInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedCreateNestedManyWithoutInformPartnerUsersInput>;
  informPartnerId: Scalars['String'];
  informPartnerIntegrationId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedCreateNestedManyWithoutInformPartnerUserInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateManyInput = {
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateManyWithoutBoehringerIngelheimTerritoriesInput = {
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateManyWithoutBoehringerIngelheimTerritoriesNestedInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutBoehringerIngelheimTerritoriesInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutBoehringerIngelheimTerritoriesInput>>;
  delete?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerUserScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerUserUpdateWithWhereUniqueWithoutBoehringerIngelheimTerritoriesInput>>;
  updateMany?: Maybe<Array<InformPartnerUserUpdateManyWithWhereWithoutBoehringerIngelheimTerritoriesInput>>;
  upsert?: Maybe<Array<InformPartnerUserUpsertWithWhereUniqueWithoutBoehringerIngelheimTerritoriesInput>>;
};

export type InformPartnerUserUncheckedUpdateManyWithoutInformPartnerCustomersInput = {
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateManyWithoutInformPartnerCustomersNestedInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutInformPartnerCustomersInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutInformPartnerCustomersInput>>;
  delete?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerUserScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerUserUpdateWithWhereUniqueWithoutInformPartnerCustomersInput>>;
  updateMany?: Maybe<Array<InformPartnerUserUpdateManyWithWhereWithoutInformPartnerCustomersInput>>;
  upsert?: Maybe<Array<InformPartnerUserUpsertWithWhereUniqueWithoutInformPartnerCustomersInput>>;
};

export type InformPartnerUserUncheckedUpdateManyWithoutInformPartnerInput = {
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateManyWithoutInformPartnerIntegrationInput = {
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateManyWithoutInformPartnerIntegrationNestedInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerUserCreateManyInformPartnerIntegrationInputEnvelope>;
  delete?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerUserScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerUserUpdateWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
  updateMany?: Maybe<Array<InformPartnerUserUpdateManyWithWhereWithoutInformPartnerIntegrationInput>>;
  upsert?: Maybe<Array<InformPartnerUserUpsertWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
};

export type InformPartnerUserUncheckedUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerUserCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerUserScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerUserUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformPartnerUserUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformPartnerUserUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformPartnerUserUncheckedUpdateWithoutBoehringerIngelheimTerritoriesInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateWithoutInformPartnerCustomersInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateWithoutInformPartnerInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateWithoutInformPartnerIntegrationInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateWithoutRolesInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUncheckedUpdateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUncheckedUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerId?: Maybe<Scalars['String']>;
  informPartnerIntegrationId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUncheckedUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUpdateInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUpdateManyMutationInput = {
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUpdateManyWithWhereWithoutBoehringerIngelheimTerritoriesInput = {
  data: InformPartnerUserUpdateManyMutationInput;
  where: InformPartnerUserScalarWhereInput;
};

export type InformPartnerUserUpdateManyWithWhereWithoutInformPartnerCustomersInput = {
  data: InformPartnerUserUpdateManyMutationInput;
  where: InformPartnerUserScalarWhereInput;
};

export type InformPartnerUserUpdateManyWithWhereWithoutInformPartnerInput = {
  data: InformPartnerUserUpdateManyMutationInput;
  where: InformPartnerUserScalarWhereInput;
};

export type InformPartnerUserUpdateManyWithWhereWithoutInformPartnerIntegrationInput = {
  data: InformPartnerUserUpdateManyMutationInput;
  where: InformPartnerUserScalarWhereInput;
};

export type InformPartnerUserUpdateManyWithoutBoehringerIngelheimTerritoriesNestedInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutBoehringerIngelheimTerritoriesInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutBoehringerIngelheimTerritoriesInput>>;
  delete?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerUserScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerUserUpdateWithWhereUniqueWithoutBoehringerIngelheimTerritoriesInput>>;
  updateMany?: Maybe<Array<InformPartnerUserUpdateManyWithWhereWithoutBoehringerIngelheimTerritoriesInput>>;
  upsert?: Maybe<Array<InformPartnerUserUpsertWithWhereUniqueWithoutBoehringerIngelheimTerritoriesInput>>;
};

export type InformPartnerUserUpdateManyWithoutInformPartnerCustomersNestedInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutInformPartnerCustomersInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutInformPartnerCustomersInput>>;
  delete?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerUserScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerUserUpdateWithWhereUniqueWithoutInformPartnerCustomersInput>>;
  updateMany?: Maybe<Array<InformPartnerUserUpdateManyWithWhereWithoutInformPartnerCustomersInput>>;
  upsert?: Maybe<Array<InformPartnerUserUpsertWithWhereUniqueWithoutInformPartnerCustomersInput>>;
};

export type InformPartnerUserUpdateManyWithoutInformPartnerIntegrationNestedInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutInformPartnerIntegrationInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutInformPartnerIntegrationInput>>;
  createMany?: Maybe<InformPartnerUserCreateManyInformPartnerIntegrationInputEnvelope>;
  delete?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerUserScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerUserUpdateWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
  updateMany?: Maybe<Array<InformPartnerUserUpdateManyWithWhereWithoutInformPartnerIntegrationInput>>;
  upsert?: Maybe<Array<InformPartnerUserUpsertWithWhereUniqueWithoutInformPartnerIntegrationInput>>;
};

export type InformPartnerUserUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformPartnerUserCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<InformPartnerUserCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<InformPartnerUserCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformPartnerUserScalarWhereInput>>;
  disconnect?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  set?: Maybe<Array<InformPartnerUserWhereUniqueInput>>;
  update?: Maybe<Array<InformPartnerUserUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<InformPartnerUserUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<InformPartnerUserUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type InformPartnerUserUpdateOneRequiredWithoutRolesNestedInput = {
  connect?: Maybe<InformPartnerUserWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerUserCreateOrConnectWithoutRolesInput>;
  create?: Maybe<InformPartnerUserCreateWithoutRolesInput>;
  update?: Maybe<InformPartnerUserUpdateToOneWithWhereWithoutRolesInput>;
  upsert?: Maybe<InformPartnerUserUpsertWithoutRolesInput>;
};

export type InformPartnerUserUpdateOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdNestedInput = {
  connect?: Maybe<InformPartnerUserWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerUserCreateOrConnectWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput>;
  create?: Maybe<InformPartnerUserCreateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput>;
  delete?: Maybe<InformPartnerUserWhereInput>;
  disconnect?: Maybe<InformPartnerUserWhereInput>;
  update?: Maybe<InformPartnerUserUpdateToOneWithWhereWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput>;
  upsert?: Maybe<InformPartnerUserUpsertWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput>;
};

export type InformPartnerUserUpdateOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdNestedInput = {
  connect?: Maybe<InformPartnerUserWhereUniqueInput>;
  connectOrCreate?: Maybe<InformPartnerUserCreateOrConnectWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput>;
  create?: Maybe<InformPartnerUserCreateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput>;
  delete?: Maybe<InformPartnerUserWhereInput>;
  disconnect?: Maybe<InformPartnerUserWhereInput>;
  update?: Maybe<InformPartnerUserUpdateToOneWithWhereWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput>;
  upsert?: Maybe<InformPartnerUserUpsertWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput>;
};

export type InformPartnerUserUpdateToOneWithWhereWithoutRolesInput = {
  data: InformPartnerUserUpdateWithoutRolesInput;
  where?: Maybe<InformPartnerUserWhereInput>;
};

export type InformPartnerUserUpdateToOneWithWhereWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput = {
  data: InformPartnerUserUpdateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput;
  where?: Maybe<InformPartnerUserWhereInput>;
};

export type InformPartnerUserUpdateToOneWithWhereWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput = {
  data: InformPartnerUserUpdateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput;
  where?: Maybe<InformPartnerUserWhereInput>;
};

export type InformPartnerUserUpdateWithWhereUniqueWithoutBoehringerIngelheimTerritoriesInput = {
  data: InformPartnerUserUpdateWithoutBoehringerIngelheimTerritoriesInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserUpdateWithWhereUniqueWithoutInformPartnerCustomersInput = {
  data: InformPartnerUserUpdateWithoutInformPartnerCustomersInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserUpdateWithWhereUniqueWithoutInformPartnerInput = {
  data: InformPartnerUserUpdateWithoutInformPartnerInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserUpdateWithWhereUniqueWithoutInformPartnerIntegrationInput = {
  data: InformPartnerUserUpdateWithoutInformPartnerIntegrationInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserUpdateWithoutBoehringerIngelheimTerritoriesInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutInformPartnerUserNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUpdateWithoutInformPartnerCustomersInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUpdateWithoutInformPartnerInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUpdateWithoutInformPartnerIntegrationInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerUsersNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUpdateWithoutRolesInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUpdateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUpdateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput = {
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedInformPartnerUserNestedInput>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryUpdateManyWithoutInformPartnerUsersNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerUpdateManyWithoutInformPartnerUsersNestedInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationUpdateOneRequiredWithoutInformPartnerUsersNestedInput>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['Json']>;
  roles?: Maybe<InformPartnerUserRoleUpdateManyWithoutInformPartnerUserNestedInput>;
  settings?: Maybe<Scalars['Json']>;
  status?: Maybe<InformPartnerUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformPartnerUserUpsertWithWhereUniqueWithoutBoehringerIngelheimTerritoriesInput = {
  create: InformPartnerUserCreateWithoutBoehringerIngelheimTerritoriesInput;
  update: InformPartnerUserUpdateWithoutBoehringerIngelheimTerritoriesInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserUpsertWithWhereUniqueWithoutInformPartnerCustomersInput = {
  create: InformPartnerUserCreateWithoutInformPartnerCustomersInput;
  update: InformPartnerUserUpdateWithoutInformPartnerCustomersInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserUpsertWithWhereUniqueWithoutInformPartnerInput = {
  create: InformPartnerUserCreateWithoutInformPartnerInput;
  update: InformPartnerUserUpdateWithoutInformPartnerInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserUpsertWithWhereUniqueWithoutInformPartnerIntegrationInput = {
  create: InformPartnerUserCreateWithoutInformPartnerIntegrationInput;
  update: InformPartnerUserUpdateWithoutInformPartnerIntegrationInput;
  where: InformPartnerUserWhereUniqueInput;
};

export type InformPartnerUserUpsertWithoutRolesInput = {
  create: InformPartnerUserCreateWithoutRolesInput;
  update: InformPartnerUserUpdateWithoutRolesInput;
  where?: Maybe<InformPartnerUserWhereInput>;
};

export type InformPartnerUserUpsertWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput = {
  create: InformPartnerUserCreateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput;
  update: InformPartnerUserUpdateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput;
  where?: Maybe<InformPartnerUserWhereInput>;
};

export type InformPartnerUserUpsertWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput = {
  create: InformPartnerUserCreateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput;
  update: InformPartnerUserUpdateWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput;
  where?: Maybe<InformPartnerUserWhereInput>;
};

export type InformPartnerUserWhereInput = {
  AND?: Maybe<Array<InformPartnerUserWhereInput>>;
  NOT?: Maybe<Array<InformPartnerUserWhereInput>>;
  OR?: Maybe<Array<InformPartnerUserWhereInput>>;
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationListRelationFilter>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationListRelationFilter>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryListRelationFilter>;
  checksum?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  externalId?: Maybe<StringFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firstName?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationScalarRelationFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  lastName?: Maybe<StringNullableFilter>;
  phone?: Maybe<StringFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  roles?: Maybe<InformPartnerUserRoleListRelationFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerUserStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerUserWhereUniqueInput = {
  AND?: Maybe<Array<InformPartnerUserWhereInput>>;
  NOT?: Maybe<Array<InformPartnerUserWhereInput>>;
  OR?: Maybe<Array<InformPartnerUserWhereInput>>;
  UserImpersonation_InformPartnerUserToUserImpersonation_impersonated_inform_partner_user_id?: Maybe<UserImpersonationListRelationFilter>;
  UserImpersonation_InformPartnerUserToUserImpersonation_inform_partner_user_id?: Maybe<UserImpersonationListRelationFilter>;
  boehringerIngelheimTerritories?: Maybe<BoehringerIngelheimTerritoryListRelationFilter>;
  checksum?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  email?: Maybe<StringFilter>;
  externalId?: Maybe<StringFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firstName?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informPartner?: Maybe<InformPartnerScalarRelationFilter>;
  informPartnerCustomers?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerId?: Maybe<StringFilter>;
  informPartnerId_email?: Maybe<InformPartnerUserInformPartnerIdEmailCompoundUniqueInput>;
  informPartnerId_externalId?: Maybe<InformPartnerUserInformPartnerIdExternalIdCompoundUniqueInput>;
  informPartnerId_firebaseId?: Maybe<InformPartnerUserInformPartnerIdFirebaseIdCompoundUniqueInput>;
  informPartnerIntegration?: Maybe<InformPartnerIntegrationScalarRelationFilter>;
  informPartnerIntegrationId?: Maybe<StringFilter>;
  lastName?: Maybe<StringNullableFilter>;
  phone?: Maybe<StringFilter>;
  rawData?: Maybe<JsonNullableFilter>;
  roles?: Maybe<InformPartnerUserRoleListRelationFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerUserStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerWhereInput = {
  AND?: Maybe<Array<InformPartnerWhereInput>>;
  NOT?: Maybe<Array<InformPartnerWhereInput>>;
  OR?: Maybe<Array<InformPartnerWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  informCampaignGroups?: Maybe<InformCampaignGroupListRelationFilter>;
  informEmailTemplates?: Maybe<InformEmailTemplateListRelationFilter>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationListRelationFilter>;
  informPartnerPrograms?: Maybe<InformPartnerProgramListRelationFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  name?: Maybe<StringFilter>;
  products?: Maybe<ProductListRelationFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformPartnerWhereUniqueInput = {
  AND?: Maybe<Array<InformPartnerWhereInput>>;
  NOT?: Maybe<Array<InformPartnerWhereInput>>;
  OR?: Maybe<Array<InformPartnerWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitions?: Maybe<InformAudienceDefinitionListRelationFilter>;
  informCampaignGroups?: Maybe<InformCampaignGroupListRelationFilter>;
  informEmailTemplates?: Maybe<InformEmailTemplateListRelationFilter>;
  informPartnerCustomer?: Maybe<InformPartnerCustomerListRelationFilter>;
  informPartnerIntegrations?: Maybe<InformPartnerIntegrationListRelationFilter>;
  informPartnerPrograms?: Maybe<InformPartnerProgramListRelationFilter>;
  informPartnerUsers?: Maybe<InformPartnerUserListRelationFilter>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<ProductListRelationFilter>;
  settings?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumInformPartnerStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformScheduledCampaign = {
  __typename?: 'InformScheduledCampaign';
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels: Array<InformScheduledCampaignCommunicationChannel>;
  content?: Maybe<Scalars['String']>;
  emailAuditors: Array<Scalars['String']>;
  id: Scalars['String'];
  informCampaign: InformCampaign;
  informEmailTemplate?: Maybe<InformEmailTemplate>;
  informEmailTemplateId?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  unlayerJson?: Maybe<Scalars['Json']>;
};


export type InformScheduledCampaignInformEmailTemplateArgs = {
  where?: Maybe<InformEmailTemplateWhereInput>;
};

export enum InformScheduledCampaignCadence {
  Annually = 'Annually',
  Daily = 'Daily',
  Monthly = 'Monthly',
  None = 'None',
  Quarterly = 'Quarterly',
  Seasonally = 'Seasonally',
  Weekly = 'Weekly'
}

export enum InformScheduledCampaignCommunicationChannel {
  DirectMail = 'DirectMail',
  Email = 'Email',
  Sms = 'SMS'
}

export type InformScheduledCampaignCountAggregateOutputType = {
  __typename?: 'InformScheduledCampaignCountAggregateOutputType';
  _all: Scalars['Int'];
  cadence: Scalars['Int'];
  communicationChannels: Scalars['Int'];
  content: Scalars['Int'];
  emailAuditors: Scalars['Int'];
  id: Scalars['Int'];
  informEmailTemplateId: Scalars['Int'];
  schedule: Scalars['Int'];
  senderPhoneNumber: Scalars['Int'];
  settings: Scalars['Int'];
  smsContent: Scalars['Int'];
  subject: Scalars['Int'];
  unlayerJson: Scalars['Int'];
};

export type InformScheduledCampaignCountOrderByAggregateInput = {
  cadence?: Maybe<SortOrder>;
  communicationChannels?: Maybe<SortOrder>;
  content?: Maybe<SortOrder>;
  emailAuditors?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informEmailTemplateId?: Maybe<SortOrder>;
  schedule?: Maybe<SortOrder>;
  senderPhoneNumber?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  smsContent?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
};

export type InformScheduledCampaignCreateInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  informCampaign: InformCampaignCreateNestedOneWithoutInformScheduledCampaignInput;
  informEmailTemplate?: Maybe<InformEmailTemplateCreateNestedOneWithoutInformScheduledCampaignsInput>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignCreateManyInformEmailTemplateInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignCreateManyInformEmailTemplateInputEnvelope = {
  data: Array<InformScheduledCampaignCreateManyInformEmailTemplateInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformScheduledCampaignCreateManyInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  informEmailTemplateId?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignCreateNestedManyWithoutInformEmailTemplateInput = {
  connect?: Maybe<Array<InformScheduledCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformScheduledCampaignCreateOrConnectWithoutInformEmailTemplateInput>>;
  create?: Maybe<Array<InformScheduledCampaignCreateWithoutInformEmailTemplateInput>>;
  createMany?: Maybe<InformScheduledCampaignCreateManyInformEmailTemplateInputEnvelope>;
};

export type InformScheduledCampaignCreateNestedOneWithoutInformCampaignInput = {
  connect?: Maybe<InformScheduledCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformScheduledCampaignCreateOrConnectWithoutInformCampaignInput>;
  create?: Maybe<InformScheduledCampaignCreateWithoutInformCampaignInput>;
};

export type InformScheduledCampaignCreateOrConnectWithoutInformCampaignInput = {
  create: InformScheduledCampaignCreateWithoutInformCampaignInput;
  where: InformScheduledCampaignWhereUniqueInput;
};

export type InformScheduledCampaignCreateOrConnectWithoutInformEmailTemplateInput = {
  create: InformScheduledCampaignCreateWithoutInformEmailTemplateInput;
  where: InformScheduledCampaignWhereUniqueInput;
};

export type InformScheduledCampaignCreateWithoutInformCampaignInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  informEmailTemplate?: Maybe<InformEmailTemplateCreateNestedOneWithoutInformScheduledCampaignsInput>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignCreateWithoutInformEmailTemplateInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  informCampaign: InformCampaignCreateNestedOneWithoutInformScheduledCampaignInput;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignCreatecommunicationChannelsInput = {
  set: Array<InformScheduledCampaignCommunicationChannel>;
};

export type InformScheduledCampaignCreateemailAuditorsInput = {
  set: Array<Scalars['String']>;
};

export type InformScheduledCampaignGroupByOutputType = {
  __typename?: 'InformScheduledCampaignGroupByOutputType';
  _count?: Maybe<InformScheduledCampaignCountAggregateOutputType>;
  _max?: Maybe<InformScheduledCampaignMaxAggregateOutputType>;
  _min?: Maybe<InformScheduledCampaignMinAggregateOutputType>;
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  informEmailTemplateId?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignListRelationFilter = {
  every?: Maybe<InformScheduledCampaignWhereInput>;
  none?: Maybe<InformScheduledCampaignWhereInput>;
  some?: Maybe<InformScheduledCampaignWhereInput>;
};

export type InformScheduledCampaignMaxAggregateOutputType = {
  __typename?: 'InformScheduledCampaignMaxAggregateOutputType';
  cadence?: Maybe<InformScheduledCampaignCadence>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informEmailTemplateId?: Maybe<Scalars['String']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  smsContent?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type InformScheduledCampaignMaxOrderByAggregateInput = {
  cadence?: Maybe<SortOrder>;
  content?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informEmailTemplateId?: Maybe<SortOrder>;
  senderPhoneNumber?: Maybe<SortOrder>;
  smsContent?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
};

export type InformScheduledCampaignMinAggregateOutputType = {
  __typename?: 'InformScheduledCampaignMinAggregateOutputType';
  cadence?: Maybe<InformScheduledCampaignCadence>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informEmailTemplateId?: Maybe<Scalars['String']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  smsContent?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type InformScheduledCampaignMinOrderByAggregateInput = {
  cadence?: Maybe<SortOrder>;
  content?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informEmailTemplateId?: Maybe<SortOrder>;
  senderPhoneNumber?: Maybe<SortOrder>;
  smsContent?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
};

export type InformScheduledCampaignNullableScalarRelationFilter = {
  AND?: Maybe<Array<InformScheduledCampaignWhereInput>>;
  NOT?: Maybe<Array<InformScheduledCampaignWhereInput>>;
  OR?: Maybe<Array<InformScheduledCampaignWhereInput>>;
  cadence?: Maybe<EnumInformScheduledCampaignCadenceNullableFilter>;
  communicationChannels?: Maybe<EnumInformScheduledCampaignCommunicationChannelNullableListFilter>;
  content?: Maybe<StringNullableFilter>;
  emailAuditors?: Maybe<StringNullableListFilter>;
  id?: Maybe<StringFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  informEmailTemplate?: Maybe<InformEmailTemplateNullableScalarRelationFilter>;
  informEmailTemplateId?: Maybe<StringNullableFilter>;
  schedule?: Maybe<JsonNullableFilter>;
  senderPhoneNumber?: Maybe<StringNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  smsContent?: Maybe<StringNullableFilter>;
  subject?: Maybe<StringFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
};

export type InformScheduledCampaignOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformScheduledCampaignOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformScheduledCampaignOrderByRelevanceInput>;
  cadence?: Maybe<SortOrder>;
  communicationChannels?: Maybe<SortOrder>;
  content?: Maybe<SortOrder>;
  emailAuditors?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  informEmailTemplate?: Maybe<InformEmailTemplateOrderByWithRelationInput>;
  informEmailTemplateId?: Maybe<SortOrder>;
  schedule?: Maybe<SortOrder>;
  senderPhoneNumber?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  smsContent?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
};

export enum InformScheduledCampaignOrderByRelevanceFieldEnum {
  Content = 'content',
  EmailAuditors = 'emailAuditors',
  Id = 'id',
  InformEmailTemplateId = 'informEmailTemplateId',
  SenderPhoneNumber = 'senderPhoneNumber',
  SmsContent = 'smsContent',
  Subject = 'subject'
}

export type InformScheduledCampaignOrderByRelevanceInput = {
  fields: Array<InformScheduledCampaignOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformScheduledCampaignOrderByWithAggregationInput = {
  _count?: Maybe<InformScheduledCampaignCountOrderByAggregateInput>;
  _max?: Maybe<InformScheduledCampaignMaxOrderByAggregateInput>;
  _min?: Maybe<InformScheduledCampaignMinOrderByAggregateInput>;
  cadence?: Maybe<SortOrder>;
  communicationChannels?: Maybe<SortOrder>;
  content?: Maybe<SortOrder>;
  emailAuditors?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informEmailTemplateId?: Maybe<SortOrder>;
  schedule?: Maybe<SortOrder>;
  senderPhoneNumber?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  smsContent?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
};

export type InformScheduledCampaignOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformScheduledCampaignOrderByRelevanceInput>;
  cadence?: Maybe<SortOrder>;
  communicationChannels?: Maybe<SortOrder>;
  content?: Maybe<SortOrder>;
  emailAuditors?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  informEmailTemplate?: Maybe<InformEmailTemplateOrderByWithRelationInput>;
  informEmailTemplateId?: Maybe<SortOrder>;
  schedule?: Maybe<SortOrder>;
  senderPhoneNumber?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  smsContent?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
};

export type InformScheduledCampaignOrderByWithRelationInput = {
  _relevance?: Maybe<InformScheduledCampaignOrderByRelevanceInput>;
  cadence?: Maybe<SortOrder>;
  communicationChannels?: Maybe<SortOrder>;
  content?: Maybe<SortOrder>;
  emailAuditors?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informCampaign?: Maybe<InformCampaignOrderByWithRelationInput>;
  informEmailTemplate?: Maybe<InformEmailTemplateOrderByWithRelationInput>;
  informEmailTemplateId?: Maybe<SortOrder>;
  schedule?: Maybe<SortOrder>;
  senderPhoneNumber?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  smsContent?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  unlayerJson?: Maybe<SortOrder>;
};

export enum InformScheduledCampaignScalarFieldEnum {
  Cadence = 'cadence',
  CommunicationChannels = 'communicationChannels',
  Content = 'content',
  EmailAuditors = 'emailAuditors',
  Id = 'id',
  InformEmailTemplateId = 'informEmailTemplateId',
  Schedule = 'schedule',
  SenderPhoneNumber = 'senderPhoneNumber',
  Settings = 'settings',
  SmsContent = 'smsContent',
  Subject = 'subject',
  UnlayerJson = 'unlayerJson'
}

export type InformScheduledCampaignScalarWhereInput = {
  AND?: Maybe<Array<InformScheduledCampaignScalarWhereInput>>;
  NOT?: Maybe<Array<InformScheduledCampaignScalarWhereInput>>;
  OR?: Maybe<Array<InformScheduledCampaignScalarWhereInput>>;
  cadence?: Maybe<EnumInformScheduledCampaignCadenceNullableFilter>;
  communicationChannels?: Maybe<EnumInformScheduledCampaignCommunicationChannelNullableListFilter>;
  content?: Maybe<StringNullableFilter>;
  emailAuditors?: Maybe<StringNullableListFilter>;
  id?: Maybe<StringFilter>;
  informEmailTemplateId?: Maybe<StringNullableFilter>;
  schedule?: Maybe<JsonNullableFilter>;
  senderPhoneNumber?: Maybe<StringNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  smsContent?: Maybe<StringNullableFilter>;
  subject?: Maybe<StringFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
};

export type InformScheduledCampaignScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformScheduledCampaignScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformScheduledCampaignScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformScheduledCampaignScalarWhereWithAggregatesInput>>;
  cadence?: Maybe<EnumInformScheduledCampaignCadenceNullableWithAggregatesFilter>;
  communicationChannels?: Maybe<EnumInformScheduledCampaignCommunicationChannelNullableListFilter>;
  content?: Maybe<StringNullableWithAggregatesFilter>;
  emailAuditors?: Maybe<StringNullableListFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informEmailTemplateId?: Maybe<StringNullableWithAggregatesFilter>;
  schedule?: Maybe<JsonNullableWithAggregatesFilter>;
  senderPhoneNumber?: Maybe<StringNullableWithAggregatesFilter>;
  settings?: Maybe<JsonNullableWithAggregatesFilter>;
  smsContent?: Maybe<StringNullableWithAggregatesFilter>;
  subject?: Maybe<StringWithAggregatesFilter>;
  unlayerJson?: Maybe<JsonNullableWithAggregatesFilter>;
};

export type InformScheduledCampaignUncheckedCreateInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  informEmailTemplateId?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignUncheckedCreateNestedManyWithoutInformEmailTemplateInput = {
  connect?: Maybe<Array<InformScheduledCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformScheduledCampaignCreateOrConnectWithoutInformEmailTemplateInput>>;
  create?: Maybe<Array<InformScheduledCampaignCreateWithoutInformEmailTemplateInput>>;
  createMany?: Maybe<InformScheduledCampaignCreateManyInformEmailTemplateInputEnvelope>;
};

export type InformScheduledCampaignUncheckedCreateNestedOneWithoutInformCampaignInput = {
  connect?: Maybe<InformScheduledCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformScheduledCampaignCreateOrConnectWithoutInformCampaignInput>;
  create?: Maybe<InformScheduledCampaignCreateWithoutInformCampaignInput>;
};

export type InformScheduledCampaignUncheckedCreateWithoutInformCampaignInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  informEmailTemplateId?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignUncheckedCreateWithoutInformEmailTemplateInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignUncheckedUpdateInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['String']>;
  informEmailTemplateId?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignUncheckedUpdateManyInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['String']>;
  informEmailTemplateId?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignUncheckedUpdateManyWithoutInformEmailTemplateInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignUncheckedUpdateManyWithoutInformEmailTemplateNestedInput = {
  connect?: Maybe<Array<InformScheduledCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformScheduledCampaignCreateOrConnectWithoutInformEmailTemplateInput>>;
  create?: Maybe<Array<InformScheduledCampaignCreateWithoutInformEmailTemplateInput>>;
  createMany?: Maybe<InformScheduledCampaignCreateManyInformEmailTemplateInputEnvelope>;
  delete?: Maybe<Array<InformScheduledCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformScheduledCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<InformScheduledCampaignWhereUniqueInput>>;
  set?: Maybe<Array<InformScheduledCampaignWhereUniqueInput>>;
  update?: Maybe<Array<InformScheduledCampaignUpdateWithWhereUniqueWithoutInformEmailTemplateInput>>;
  updateMany?: Maybe<Array<InformScheduledCampaignUpdateManyWithWhereWithoutInformEmailTemplateInput>>;
  upsert?: Maybe<Array<InformScheduledCampaignUpsertWithWhereUniqueWithoutInformEmailTemplateInput>>;
};

export type InformScheduledCampaignUncheckedUpdateOneWithoutInformCampaignNestedInput = {
  connect?: Maybe<InformScheduledCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformScheduledCampaignCreateOrConnectWithoutInformCampaignInput>;
  create?: Maybe<InformScheduledCampaignCreateWithoutInformCampaignInput>;
  delete?: Maybe<InformScheduledCampaignWhereInput>;
  disconnect?: Maybe<InformScheduledCampaignWhereInput>;
  update?: Maybe<InformScheduledCampaignUpdateToOneWithWhereWithoutInformCampaignInput>;
  upsert?: Maybe<InformScheduledCampaignUpsertWithoutInformCampaignInput>;
};

export type InformScheduledCampaignUncheckedUpdateWithoutInformCampaignInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  informEmailTemplateId?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignUncheckedUpdateWithoutInformEmailTemplateInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignUpdateInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformScheduledCampaignNestedInput>;
  informEmailTemplate?: Maybe<InformEmailTemplateUpdateOneWithoutInformScheduledCampaignsNestedInput>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignUpdateManyMutationInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignUpdateManyWithWhereWithoutInformEmailTemplateInput = {
  data: InformScheduledCampaignUpdateManyMutationInput;
  where: InformScheduledCampaignScalarWhereInput;
};

export type InformScheduledCampaignUpdateManyWithoutInformEmailTemplateNestedInput = {
  connect?: Maybe<Array<InformScheduledCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformScheduledCampaignCreateOrConnectWithoutInformEmailTemplateInput>>;
  create?: Maybe<Array<InformScheduledCampaignCreateWithoutInformEmailTemplateInput>>;
  createMany?: Maybe<InformScheduledCampaignCreateManyInformEmailTemplateInputEnvelope>;
  delete?: Maybe<Array<InformScheduledCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformScheduledCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<InformScheduledCampaignWhereUniqueInput>>;
  set?: Maybe<Array<InformScheduledCampaignWhereUniqueInput>>;
  update?: Maybe<Array<InformScheduledCampaignUpdateWithWhereUniqueWithoutInformEmailTemplateInput>>;
  updateMany?: Maybe<Array<InformScheduledCampaignUpdateManyWithWhereWithoutInformEmailTemplateInput>>;
  upsert?: Maybe<Array<InformScheduledCampaignUpsertWithWhereUniqueWithoutInformEmailTemplateInput>>;
};

export type InformScheduledCampaignUpdateOneWithoutInformCampaignNestedInput = {
  connect?: Maybe<InformScheduledCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<InformScheduledCampaignCreateOrConnectWithoutInformCampaignInput>;
  create?: Maybe<InformScheduledCampaignCreateWithoutInformCampaignInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InformScheduledCampaignUpdateToOneWithWhereWithoutInformCampaignInput>;
  upsert?: Maybe<InformScheduledCampaignUpsertWithoutInformCampaignInput>;
};

export type InformScheduledCampaignUpdateToOneWithWhereWithoutInformCampaignInput = {
  data: InformScheduledCampaignUpdateWithoutInformCampaignInput;
  where?: Maybe<InformScheduledCampaignWhereInput>;
};

export type InformScheduledCampaignUpdateWithWhereUniqueWithoutInformEmailTemplateInput = {
  data: InformScheduledCampaignUpdateWithoutInformEmailTemplateInput;
  where: InformScheduledCampaignWhereUniqueInput;
};

export type InformScheduledCampaignUpdateWithoutInformCampaignInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  informEmailTemplate?: Maybe<InformEmailTemplateUpdateOneWithoutInformScheduledCampaignsNestedInput>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignUpdateWithoutInformEmailTemplateInput = {
  cadence?: Maybe<InformScheduledCampaignCadence>;
  communicationChannels?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  content?: Maybe<Scalars['String']>;
  emailAuditors?: Maybe<Array<Scalars['String']>>;
  informCampaign?: Maybe<InformCampaignUpdateOneRequiredWithoutInformScheduledCampaignNestedInput>;
  schedule?: Maybe<Scalars['Json']>;
  senderPhoneNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Json']>;
  smsContent?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  unlayerJson?: Maybe<Scalars['Json']>;
};

export type InformScheduledCampaignUpdatecommunicationChannelsInput = {
  push?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  set?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
};

export type InformScheduledCampaignUpdateemailAuditorsInput = {
  push?: Maybe<Array<Scalars['String']>>;
  set?: Maybe<Array<Scalars['String']>>;
};

export type InformScheduledCampaignUpsertWithWhereUniqueWithoutInformEmailTemplateInput = {
  create: InformScheduledCampaignCreateWithoutInformEmailTemplateInput;
  update: InformScheduledCampaignUpdateWithoutInformEmailTemplateInput;
  where: InformScheduledCampaignWhereUniqueInput;
};

export type InformScheduledCampaignUpsertWithoutInformCampaignInput = {
  create: InformScheduledCampaignCreateWithoutInformCampaignInput;
  update: InformScheduledCampaignUpdateWithoutInformCampaignInput;
  where?: Maybe<InformScheduledCampaignWhereInput>;
};

export type InformScheduledCampaignWhereInput = {
  AND?: Maybe<Array<InformScheduledCampaignWhereInput>>;
  NOT?: Maybe<Array<InformScheduledCampaignWhereInput>>;
  OR?: Maybe<Array<InformScheduledCampaignWhereInput>>;
  cadence?: Maybe<EnumInformScheduledCampaignCadenceNullableFilter>;
  communicationChannels?: Maybe<EnumInformScheduledCampaignCommunicationChannelNullableListFilter>;
  content?: Maybe<StringNullableFilter>;
  emailAuditors?: Maybe<StringNullableListFilter>;
  id?: Maybe<StringFilter>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  informEmailTemplate?: Maybe<InformEmailTemplateNullableScalarRelationFilter>;
  informEmailTemplateId?: Maybe<StringNullableFilter>;
  schedule?: Maybe<JsonNullableFilter>;
  senderPhoneNumber?: Maybe<StringNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  smsContent?: Maybe<StringNullableFilter>;
  subject?: Maybe<StringFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
};

export type InformScheduledCampaignWhereUniqueInput = {
  AND?: Maybe<Array<InformScheduledCampaignWhereInput>>;
  NOT?: Maybe<Array<InformScheduledCampaignWhereInput>>;
  OR?: Maybe<Array<InformScheduledCampaignWhereInput>>;
  cadence?: Maybe<EnumInformScheduledCampaignCadenceNullableFilter>;
  communicationChannels?: Maybe<EnumInformScheduledCampaignCommunicationChannelNullableListFilter>;
  content?: Maybe<StringNullableFilter>;
  emailAuditors?: Maybe<StringNullableListFilter>;
  id?: Maybe<Scalars['String']>;
  informCampaign?: Maybe<InformCampaignScalarRelationFilter>;
  informEmailTemplate?: Maybe<InformEmailTemplateNullableScalarRelationFilter>;
  informEmailTemplateId?: Maybe<StringNullableFilter>;
  schedule?: Maybe<JsonNullableFilter>;
  senderPhoneNumber?: Maybe<StringNullableFilter>;
  settings?: Maybe<JsonNullableFilter>;
  smsContent?: Maybe<StringNullableFilter>;
  subject?: Maybe<StringFilter>;
  unlayerJson?: Maybe<JsonNullableFilter>;
};

export type InformSession = {
  __typename?: 'InformSession';
  ClinicPetParent?: Maybe<ClinicPetParent>;
  _count: InformSessionCountOutputType;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  events: Array<InformSessionEvent>;
  id: Scalars['String'];
  informAudienceMember: InformAudienceMember;
  informAudienceMemberId: Scalars['String'];
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessage>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status: InformSessionStatus;
  updatedAt: Scalars['DateTime'];
};


export type InformSessionClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type InformSessionEventsArgs = {
  cursor?: Maybe<InformSessionEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformSessionEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformSessionEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionEventWhereInput>;
};


export type InformSessionInformAudienceMemberMessageArgs = {
  where?: Maybe<InformAudienceMemberMessageWhereInput>;
};

export type InformSessionCountAggregateOutputType = {
  __typename?: 'InformSessionCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  informAudienceMemberId: Scalars['Int'];
  informAudienceMemberMessageId: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformSessionCountOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMemberId?: Maybe<SortOrder>;
  informAudienceMemberMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformSessionCountOutputType = {
  __typename?: 'InformSessionCountOutputType';
  events: Scalars['Int'];
};

export type InformSessionCreateInput = {
  ClinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutInformSessionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventCreateNestedManyWithoutSessionInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember: InformAudienceMemberCreateNestedOneWithoutInformSessionInput;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageCreateNestedOneWithoutInformSessionsInput>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionCreateManyClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId: Scalars['String'];
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionCreateManyClinicPetParentInputEnvelope = {
  data: Array<InformSessionCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformSessionCreateManyInformAudienceMemberInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionCreateManyInformAudienceMemberInputEnvelope = {
  data: Array<InformSessionCreateManyInformAudienceMemberInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformSessionCreateManyInformAudienceMemberMessageInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId: Scalars['String'];
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionCreateManyInformAudienceMemberMessageInputEnvelope = {
  data: Array<InformSessionCreateManyInformAudienceMemberMessageInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformSessionCreateManyInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId: Scalars['String'];
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InformSessionCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InformSessionCreateManyClinicPetParentInputEnvelope>;
};

export type InformSessionCreateNestedManyWithoutInformAudienceMemberInput = {
  connect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionCreateOrConnectWithoutInformAudienceMemberInput>>;
  create?: Maybe<Array<InformSessionCreateWithoutInformAudienceMemberInput>>;
  createMany?: Maybe<InformSessionCreateManyInformAudienceMemberInputEnvelope>;
};

export type InformSessionCreateNestedManyWithoutInformAudienceMemberMessageInput = {
  connect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionCreateOrConnectWithoutInformAudienceMemberMessageInput>>;
  create?: Maybe<Array<InformSessionCreateWithoutInformAudienceMemberMessageInput>>;
  createMany?: Maybe<InformSessionCreateManyInformAudienceMemberMessageInputEnvelope>;
};

export type InformSessionCreateNestedOneWithoutEventsInput = {
  connect?: Maybe<InformSessionWhereUniqueInput>;
  connectOrCreate?: Maybe<InformSessionCreateOrConnectWithoutEventsInput>;
  create?: Maybe<InformSessionCreateWithoutEventsInput>;
};

export type InformSessionCreateOrConnectWithoutClinicPetParentInput = {
  create: InformSessionCreateWithoutClinicPetParentInput;
  where: InformSessionWhereUniqueInput;
};

export type InformSessionCreateOrConnectWithoutEventsInput = {
  create: InformSessionCreateWithoutEventsInput;
  where: InformSessionWhereUniqueInput;
};

export type InformSessionCreateOrConnectWithoutInformAudienceMemberInput = {
  create: InformSessionCreateWithoutInformAudienceMemberInput;
  where: InformSessionWhereUniqueInput;
};

export type InformSessionCreateOrConnectWithoutInformAudienceMemberMessageInput = {
  create: InformSessionCreateWithoutInformAudienceMemberMessageInput;
  where: InformSessionWhereUniqueInput;
};

export type InformSessionCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventCreateNestedManyWithoutSessionInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember: InformAudienceMemberCreateNestedOneWithoutInformSessionInput;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageCreateNestedOneWithoutInformSessionsInput>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionCreateWithoutEventsInput = {
  ClinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutInformSessionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember: InformAudienceMemberCreateNestedOneWithoutInformSessionInput;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageCreateNestedOneWithoutInformSessionsInput>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionCreateWithoutInformAudienceMemberInput = {
  ClinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutInformSessionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventCreateNestedManyWithoutSessionInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageCreateNestedOneWithoutInformSessionsInput>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionCreateWithoutInformAudienceMemberMessageInput = {
  ClinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutInformSessionsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventCreateNestedManyWithoutSessionInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember: InformAudienceMemberCreateNestedOneWithoutInformSessionInput;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEvent = {
  __typename?: 'InformSessionEvent';
  authorId?: Maybe<Scalars['String']>;
  authorType: InformSessionEventAuthorType;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['Json']>;
  eventListener?: Maybe<InformEventListener>;
  id: Scalars['String'];
  informEventListenerId?: Maybe<Scalars['String']>;
  informSessionId: Scalars['String'];
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  session: InformSession;
  updatedAt: Scalars['DateTime'];
};


export type InformSessionEventEventListenerArgs = {
  where?: Maybe<InformEventListenerWhereInput>;
};

export enum InformSessionEventAuthorType {
  ClinicPetParent = 'ClinicPetParent',
  System = 'System',
  User = 'User'
}

export type InformSessionEventCountAggregateOutputType = {
  __typename?: 'InformSessionEventCountAggregateOutputType';
  _all: Scalars['Int'];
  authorId: Scalars['Int'];
  authorType: Scalars['Int'];
  createdAt: Scalars['Int'];
  data: Scalars['Int'];
  id: Scalars['Int'];
  informEventListenerId: Scalars['Int'];
  informSessionId: Scalars['Int'];
  name: Scalars['Int'];
  occurredAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InformSessionEventCountOrderByAggregateInput = {
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informEventListenerId?: Maybe<SortOrder>;
  informSessionId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  occurredAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformSessionEventCreateInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType: InformSessionEventAuthorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  eventListener?: Maybe<InformEventListenerCreateNestedOneWithoutEventsInput>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  session: InformSessionCreateNestedOneWithoutEventsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventCreateManyEventListenerInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType: InformSessionEventAuthorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informSessionId: Scalars['String'];
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventCreateManyEventListenerInputEnvelope = {
  data: Array<InformSessionEventCreateManyEventListenerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformSessionEventCreateManyInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType: InformSessionEventAuthorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informEventListenerId?: Maybe<Scalars['String']>;
  informSessionId: Scalars['String'];
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventCreateManySessionInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType: InformSessionEventAuthorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informEventListenerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventCreateManySessionInputEnvelope = {
  data: Array<InformSessionEventCreateManySessionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InformSessionEventCreateNestedManyWithoutEventListenerInput = {
  connect?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionEventCreateOrConnectWithoutEventListenerInput>>;
  create?: Maybe<Array<InformSessionEventCreateWithoutEventListenerInput>>;
  createMany?: Maybe<InformSessionEventCreateManyEventListenerInputEnvelope>;
};

export type InformSessionEventCreateNestedManyWithoutSessionInput = {
  connect?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionEventCreateOrConnectWithoutSessionInput>>;
  create?: Maybe<Array<InformSessionEventCreateWithoutSessionInput>>;
  createMany?: Maybe<InformSessionEventCreateManySessionInputEnvelope>;
};

export type InformSessionEventCreateOrConnectWithoutEventListenerInput = {
  create: InformSessionEventCreateWithoutEventListenerInput;
  where: InformSessionEventWhereUniqueInput;
};

export type InformSessionEventCreateOrConnectWithoutSessionInput = {
  create: InformSessionEventCreateWithoutSessionInput;
  where: InformSessionEventWhereUniqueInput;
};

export type InformSessionEventCreateWithoutEventListenerInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType: InformSessionEventAuthorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  session: InformSessionCreateNestedOneWithoutEventsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventCreateWithoutSessionInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType: InformSessionEventAuthorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  eventListener?: Maybe<InformEventListenerCreateNestedOneWithoutEventsInput>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventGroupByOutputType = {
  __typename?: 'InformSessionEventGroupByOutputType';
  _count?: Maybe<InformSessionEventCountAggregateOutputType>;
  _max?: Maybe<InformSessionEventMaxAggregateOutputType>;
  _min?: Maybe<InformSessionEventMinAggregateOutputType>;
  authorId?: Maybe<Scalars['String']>;
  authorType: InformSessionEventAuthorType;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  informEventListenerId?: Maybe<Scalars['String']>;
  informSessionId: Scalars['String'];
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type InformSessionEventListRelationFilter = {
  every?: Maybe<InformSessionEventWhereInput>;
  none?: Maybe<InformSessionEventWhereInput>;
  some?: Maybe<InformSessionEventWhereInput>;
};

export type InformSessionEventMaxAggregateOutputType = {
  __typename?: 'InformSessionEventMaxAggregateOutputType';
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<InformSessionEventAuthorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informEventListenerId?: Maybe<Scalars['String']>;
  informSessionId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventMaxOrderByAggregateInput = {
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informEventListenerId?: Maybe<SortOrder>;
  informSessionId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  occurredAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformSessionEventMinAggregateOutputType = {
  __typename?: 'InformSessionEventMinAggregateOutputType';
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<InformSessionEventAuthorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informEventListenerId?: Maybe<Scalars['String']>;
  informSessionId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventMinOrderByAggregateInput = {
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informEventListenerId?: Maybe<SortOrder>;
  informSessionId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  occurredAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformSessionEventOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformSessionEventOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformSessionEventOrderByRelevanceInput>;
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  eventListener?: Maybe<InformEventListenerOrderByWithRelationInput>;
  id?: Maybe<SortOrder>;
  informEventListenerId?: Maybe<SortOrder>;
  informSessionId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  occurredAt?: Maybe<SortOrder>;
  session?: Maybe<InformSessionOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformSessionEventOrderByRelevanceFieldEnum {
  AuthorId = 'authorId',
  Id = 'id',
  InformEventListenerId = 'informEventListenerId',
  InformSessionId = 'informSessionId',
  Name = 'name'
}

export type InformSessionEventOrderByRelevanceInput = {
  fields: Array<InformSessionEventOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformSessionEventOrderByWithAggregationInput = {
  _count?: Maybe<InformSessionEventCountOrderByAggregateInput>;
  _max?: Maybe<InformSessionEventMaxOrderByAggregateInput>;
  _min?: Maybe<InformSessionEventMinOrderByAggregateInput>;
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informEventListenerId?: Maybe<SortOrder>;
  informSessionId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  occurredAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformSessionEventOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InformSessionEventOrderByRelevanceInput>;
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  eventListener?: Maybe<InformEventListenerOrderByWithRelationInput>;
  id?: Maybe<SortOrder>;
  informEventListenerId?: Maybe<SortOrder>;
  informSessionId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  occurredAt?: Maybe<SortOrder>;
  session?: Maybe<InformSessionOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformSessionEventOrderByWithRelationInput = {
  _relevance?: Maybe<InformSessionEventOrderByRelevanceInput>;
  authorId?: Maybe<SortOrder>;
  authorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  eventListener?: Maybe<InformEventListenerOrderByWithRelationInput>;
  id?: Maybe<SortOrder>;
  informEventListenerId?: Maybe<SortOrder>;
  informSessionId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  occurredAt?: Maybe<SortOrder>;
  session?: Maybe<InformSessionOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformSessionEventScalarFieldEnum {
  AuthorId = 'authorId',
  AuthorType = 'authorType',
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  InformEventListenerId = 'informEventListenerId',
  InformSessionId = 'informSessionId',
  Name = 'name',
  OccurredAt = 'occurredAt',
  UpdatedAt = 'updatedAt'
}

export type InformSessionEventScalarWhereInput = {
  AND?: Maybe<Array<InformSessionEventScalarWhereInput>>;
  NOT?: Maybe<Array<InformSessionEventScalarWhereInput>>;
  OR?: Maybe<Array<InformSessionEventScalarWhereInput>>;
  authorId?: Maybe<StringNullableFilter>;
  authorType?: Maybe<EnumInformSessionEventAuthorTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  informEventListenerId?: Maybe<StringNullableFilter>;
  informSessionId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  occurredAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformSessionEventScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformSessionEventScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformSessionEventScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformSessionEventScalarWhereWithAggregatesInput>>;
  authorId?: Maybe<StringNullableWithAggregatesFilter>;
  authorType?: Maybe<EnumInformSessionEventAuthorTypeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  data?: Maybe<JsonNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informEventListenerId?: Maybe<StringNullableWithAggregatesFilter>;
  informSessionId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  occurredAt?: Maybe<DateTimeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type InformSessionEventUncheckedCreateInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType: InformSessionEventAuthorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informEventListenerId?: Maybe<Scalars['String']>;
  informSessionId: Scalars['String'];
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUncheckedCreateNestedManyWithoutEventListenerInput = {
  connect?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionEventCreateOrConnectWithoutEventListenerInput>>;
  create?: Maybe<Array<InformSessionEventCreateWithoutEventListenerInput>>;
  createMany?: Maybe<InformSessionEventCreateManyEventListenerInputEnvelope>;
};

export type InformSessionEventUncheckedCreateNestedManyWithoutSessionInput = {
  connect?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionEventCreateOrConnectWithoutSessionInput>>;
  create?: Maybe<Array<InformSessionEventCreateWithoutSessionInput>>;
  createMany?: Maybe<InformSessionEventCreateManySessionInputEnvelope>;
};

export type InformSessionEventUncheckedCreateWithoutEventListenerInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType: InformSessionEventAuthorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informSessionId: Scalars['String'];
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUncheckedCreateWithoutSessionInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType: InformSessionEventAuthorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informEventListenerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUncheckedUpdateInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<InformSessionEventAuthorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informEventListenerId?: Maybe<Scalars['String']>;
  informSessionId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUncheckedUpdateManyInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<InformSessionEventAuthorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informEventListenerId?: Maybe<Scalars['String']>;
  informSessionId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUncheckedUpdateManyWithoutEventListenerInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<InformSessionEventAuthorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informSessionId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUncheckedUpdateManyWithoutEventListenerNestedInput = {
  connect?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionEventCreateOrConnectWithoutEventListenerInput>>;
  create?: Maybe<Array<InformSessionEventCreateWithoutEventListenerInput>>;
  createMany?: Maybe<InformSessionEventCreateManyEventListenerInputEnvelope>;
  delete?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformSessionEventScalarWhereInput>>;
  disconnect?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  set?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  update?: Maybe<Array<InformSessionEventUpdateWithWhereUniqueWithoutEventListenerInput>>;
  updateMany?: Maybe<Array<InformSessionEventUpdateManyWithWhereWithoutEventListenerInput>>;
  upsert?: Maybe<Array<InformSessionEventUpsertWithWhereUniqueWithoutEventListenerInput>>;
};

export type InformSessionEventUncheckedUpdateManyWithoutSessionInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<InformSessionEventAuthorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informEventListenerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUncheckedUpdateManyWithoutSessionNestedInput = {
  connect?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionEventCreateOrConnectWithoutSessionInput>>;
  create?: Maybe<Array<InformSessionEventCreateWithoutSessionInput>>;
  createMany?: Maybe<InformSessionEventCreateManySessionInputEnvelope>;
  delete?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformSessionEventScalarWhereInput>>;
  disconnect?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  set?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  update?: Maybe<Array<InformSessionEventUpdateWithWhereUniqueWithoutSessionInput>>;
  updateMany?: Maybe<Array<InformSessionEventUpdateManyWithWhereWithoutSessionInput>>;
  upsert?: Maybe<Array<InformSessionEventUpsertWithWhereUniqueWithoutSessionInput>>;
};

export type InformSessionEventUncheckedUpdateWithoutEventListenerInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<InformSessionEventAuthorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informSessionId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUncheckedUpdateWithoutSessionInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<InformSessionEventAuthorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  informEventListenerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUpdateInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<InformSessionEventAuthorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  eventListener?: Maybe<InformEventListenerUpdateOneWithoutEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  session?: Maybe<InformSessionUpdateOneRequiredWithoutEventsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUpdateManyMutationInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<InformSessionEventAuthorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUpdateManyWithWhereWithoutEventListenerInput = {
  data: InformSessionEventUpdateManyMutationInput;
  where: InformSessionEventScalarWhereInput;
};

export type InformSessionEventUpdateManyWithWhereWithoutSessionInput = {
  data: InformSessionEventUpdateManyMutationInput;
  where: InformSessionEventScalarWhereInput;
};

export type InformSessionEventUpdateManyWithoutEventListenerNestedInput = {
  connect?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionEventCreateOrConnectWithoutEventListenerInput>>;
  create?: Maybe<Array<InformSessionEventCreateWithoutEventListenerInput>>;
  createMany?: Maybe<InformSessionEventCreateManyEventListenerInputEnvelope>;
  delete?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformSessionEventScalarWhereInput>>;
  disconnect?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  set?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  update?: Maybe<Array<InformSessionEventUpdateWithWhereUniqueWithoutEventListenerInput>>;
  updateMany?: Maybe<Array<InformSessionEventUpdateManyWithWhereWithoutEventListenerInput>>;
  upsert?: Maybe<Array<InformSessionEventUpsertWithWhereUniqueWithoutEventListenerInput>>;
};

export type InformSessionEventUpdateManyWithoutSessionNestedInput = {
  connect?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionEventCreateOrConnectWithoutSessionInput>>;
  create?: Maybe<Array<InformSessionEventCreateWithoutSessionInput>>;
  createMany?: Maybe<InformSessionEventCreateManySessionInputEnvelope>;
  delete?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformSessionEventScalarWhereInput>>;
  disconnect?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  set?: Maybe<Array<InformSessionEventWhereUniqueInput>>;
  update?: Maybe<Array<InformSessionEventUpdateWithWhereUniqueWithoutSessionInput>>;
  updateMany?: Maybe<Array<InformSessionEventUpdateManyWithWhereWithoutSessionInput>>;
  upsert?: Maybe<Array<InformSessionEventUpsertWithWhereUniqueWithoutSessionInput>>;
};

export type InformSessionEventUpdateWithWhereUniqueWithoutEventListenerInput = {
  data: InformSessionEventUpdateWithoutEventListenerInput;
  where: InformSessionEventWhereUniqueInput;
};

export type InformSessionEventUpdateWithWhereUniqueWithoutSessionInput = {
  data: InformSessionEventUpdateWithoutSessionInput;
  where: InformSessionEventWhereUniqueInput;
};

export type InformSessionEventUpdateWithoutEventListenerInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<InformSessionEventAuthorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  session?: Maybe<InformSessionUpdateOneRequiredWithoutEventsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUpdateWithoutSessionInput = {
  authorId?: Maybe<Scalars['String']>;
  authorType?: Maybe<InformSessionEventAuthorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  eventListener?: Maybe<InformEventListenerUpdateOneWithoutEventsNestedInput>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionEventUpsertWithWhereUniqueWithoutEventListenerInput = {
  create: InformSessionEventCreateWithoutEventListenerInput;
  update: InformSessionEventUpdateWithoutEventListenerInput;
  where: InformSessionEventWhereUniqueInput;
};

export type InformSessionEventUpsertWithWhereUniqueWithoutSessionInput = {
  create: InformSessionEventCreateWithoutSessionInput;
  update: InformSessionEventUpdateWithoutSessionInput;
  where: InformSessionEventWhereUniqueInput;
};

export type InformSessionEventWhereInput = {
  AND?: Maybe<Array<InformSessionEventWhereInput>>;
  NOT?: Maybe<Array<InformSessionEventWhereInput>>;
  OR?: Maybe<Array<InformSessionEventWhereInput>>;
  authorId?: Maybe<StringNullableFilter>;
  authorType?: Maybe<EnumInformSessionEventAuthorTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonNullableFilter>;
  eventListener?: Maybe<InformEventListenerNullableScalarRelationFilter>;
  id?: Maybe<StringFilter>;
  informEventListenerId?: Maybe<StringNullableFilter>;
  informSessionId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  occurredAt?: Maybe<DateTimeFilter>;
  session?: Maybe<InformSessionScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformSessionEventWhereUniqueInput = {
  AND?: Maybe<Array<InformSessionEventWhereInput>>;
  NOT?: Maybe<Array<InformSessionEventWhereInput>>;
  OR?: Maybe<Array<InformSessionEventWhereInput>>;
  authorId?: Maybe<StringNullableFilter>;
  authorType?: Maybe<EnumInformSessionEventAuthorTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonNullableFilter>;
  eventListener?: Maybe<InformEventListenerNullableScalarRelationFilter>;
  id?: Maybe<Scalars['String']>;
  informEventListenerId?: Maybe<StringNullableFilter>;
  informSessionId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  occurredAt?: Maybe<DateTimeFilter>;
  session?: Maybe<InformSessionScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformSessionGroupByOutputType = {
  __typename?: 'InformSessionGroupByOutputType';
  _count?: Maybe<InformSessionCountAggregateOutputType>;
  _max?: Maybe<InformSessionMaxAggregateOutputType>;
  _min?: Maybe<InformSessionMinAggregateOutputType>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informAudienceMemberId: Scalars['String'];
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status: InformSessionStatus;
  updatedAt: Scalars['DateTime'];
};

export type InformSessionListRelationFilter = {
  every?: Maybe<InformSessionWhereInput>;
  none?: Maybe<InformSessionWhereInput>;
  some?: Maybe<InformSessionWhereInput>;
};

export type InformSessionMaxAggregateOutputType = {
  __typename?: 'InformSessionMaxAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId?: Maybe<Scalars['String']>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionMaxOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMemberId?: Maybe<SortOrder>;
  informAudienceMemberMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformSessionMinAggregateOutputType = {
  __typename?: 'InformSessionMinAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId?: Maybe<Scalars['String']>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionMinOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMemberId?: Maybe<SortOrder>;
  informAudienceMemberMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformSessionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InformSessionOrderByRelationAndSearchRelevanceInput = {
  ClinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  _relevance?: Maybe<InformSessionOrderByRelevanceInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  events?: Maybe<InformSessionEventOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByWithRelationInput>;
  informAudienceMemberId?: Maybe<SortOrder>;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageOrderByWithRelationInput>;
  informAudienceMemberMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformSessionOrderByRelevanceFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  Id = 'id',
  InformAudienceMemberId = 'informAudienceMemberId',
  InformAudienceMemberMessageId = 'informAudienceMemberMessageId'
}

export type InformSessionOrderByRelevanceInput = {
  fields: Array<InformSessionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InformSessionOrderByWithAggregationInput = {
  _count?: Maybe<InformSessionCountOrderByAggregateInput>;
  _max?: Maybe<InformSessionMaxOrderByAggregateInput>;
  _min?: Maybe<InformSessionMinOrderByAggregateInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMemberId?: Maybe<SortOrder>;
  informAudienceMemberMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformSessionOrderByWithRelationAndSearchRelevanceInput = {
  ClinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  _relevance?: Maybe<InformSessionOrderByRelevanceInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  events?: Maybe<InformSessionEventOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByWithRelationInput>;
  informAudienceMemberId?: Maybe<SortOrder>;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageOrderByWithRelationInput>;
  informAudienceMemberMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InformSessionOrderByWithRelationInput = {
  ClinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  _relevance?: Maybe<InformSessionOrderByRelevanceInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  events?: Maybe<InformSessionEventOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByWithRelationInput>;
  informAudienceMemberId?: Maybe<SortOrder>;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageOrderByWithRelationInput>;
  informAudienceMemberMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InformSessionScalarFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Id = 'id',
  InformAudienceMemberId = 'informAudienceMemberId',
  InformAudienceMemberMessageId = 'informAudienceMemberMessageId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type InformSessionScalarRelationFilter = {
  AND?: Maybe<Array<InformSessionWhereInput>>;
  ClinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  NOT?: Maybe<Array<InformSessionWhereInput>>;
  OR?: Maybe<Array<InformSessionWhereInput>>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  events?: Maybe<InformSessionEventListRelationFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberScalarRelationFilter>;
  informAudienceMemberId?: Maybe<StringFilter>;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageNullableScalarRelationFilter>;
  informAudienceMemberMessageId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumInformSessionStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformSessionScalarWhereInput = {
  AND?: Maybe<Array<InformSessionScalarWhereInput>>;
  NOT?: Maybe<Array<InformSessionScalarWhereInput>>;
  OR?: Maybe<Array<InformSessionScalarWhereInput>>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMemberId?: Maybe<StringFilter>;
  informAudienceMemberMessageId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumInformSessionStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformSessionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InformSessionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InformSessionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InformSessionScalarWhereWithAggregatesInput>>;
  clinicPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informAudienceMemberId?: Maybe<StringWithAggregatesFilter>;
  informAudienceMemberMessageId?: Maybe<StringNullableWithAggregatesFilter>;
  status?: Maybe<EnumInformSessionStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InformSessionStatus {
  Complete = 'Complete',
  Expired = 'Expired',
  InProgress = 'InProgress'
}

export type InformSessionUncheckedCreateInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedCreateNestedManyWithoutSessionInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId: Scalars['String'];
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InformSessionCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InformSessionCreateManyClinicPetParentInputEnvelope>;
};

export type InformSessionUncheckedCreateNestedManyWithoutInformAudienceMemberInput = {
  connect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionCreateOrConnectWithoutInformAudienceMemberInput>>;
  create?: Maybe<Array<InformSessionCreateWithoutInformAudienceMemberInput>>;
  createMany?: Maybe<InformSessionCreateManyInformAudienceMemberInputEnvelope>;
};

export type InformSessionUncheckedCreateNestedManyWithoutInformAudienceMemberMessageInput = {
  connect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionCreateOrConnectWithoutInformAudienceMemberMessageInput>>;
  create?: Maybe<Array<InformSessionCreateWithoutInformAudienceMemberMessageInput>>;
  createMany?: Maybe<InformSessionCreateManyInformAudienceMemberMessageInputEnvelope>;
};

export type InformSessionUncheckedCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedCreateNestedManyWithoutSessionInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId: Scalars['String'];
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedCreateWithoutEventsInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId: Scalars['String'];
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedCreateWithoutInformAudienceMemberInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedCreateNestedManyWithoutSessionInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedCreateWithoutInformAudienceMemberMessageInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedCreateNestedManyWithoutSessionInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId: Scalars['String'];
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedUpdateInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedUpdateManyWithoutSessionNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId?: Maybe<Scalars['String']>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedUpdateManyInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId?: Maybe<Scalars['String']>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedUpdateManyWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId?: Maybe<Scalars['String']>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InformSessionCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InformSessionCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<InformSessionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformSessionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  set?: Maybe<Array<InformSessionWhereUniqueInput>>;
  update?: Maybe<Array<InformSessionUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<InformSessionUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<InformSessionUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type InformSessionUncheckedUpdateManyWithoutInformAudienceMemberInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedUpdateManyWithoutInformAudienceMemberMessageInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedUpdateManyWithoutInformAudienceMemberMessageNestedInput = {
  connect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionCreateOrConnectWithoutInformAudienceMemberMessageInput>>;
  create?: Maybe<Array<InformSessionCreateWithoutInformAudienceMemberMessageInput>>;
  createMany?: Maybe<InformSessionCreateManyInformAudienceMemberMessageInputEnvelope>;
  delete?: Maybe<Array<InformSessionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformSessionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  set?: Maybe<Array<InformSessionWhereUniqueInput>>;
  update?: Maybe<Array<InformSessionUpdateWithWhereUniqueWithoutInformAudienceMemberMessageInput>>;
  updateMany?: Maybe<Array<InformSessionUpdateManyWithWhereWithoutInformAudienceMemberMessageInput>>;
  upsert?: Maybe<Array<InformSessionUpsertWithWhereUniqueWithoutInformAudienceMemberMessageInput>>;
};

export type InformSessionUncheckedUpdateManyWithoutInformAudienceMemberNestedInput = {
  connect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionCreateOrConnectWithoutInformAudienceMemberInput>>;
  create?: Maybe<Array<InformSessionCreateWithoutInformAudienceMemberInput>>;
  createMany?: Maybe<InformSessionCreateManyInformAudienceMemberInputEnvelope>;
  delete?: Maybe<Array<InformSessionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformSessionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  set?: Maybe<Array<InformSessionWhereUniqueInput>>;
  update?: Maybe<Array<InformSessionUpdateWithWhereUniqueWithoutInformAudienceMemberInput>>;
  updateMany?: Maybe<Array<InformSessionUpdateManyWithWhereWithoutInformAudienceMemberInput>>;
  upsert?: Maybe<Array<InformSessionUpsertWithWhereUniqueWithoutInformAudienceMemberInput>>;
};

export type InformSessionUncheckedUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedUpdateManyWithoutSessionNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId?: Maybe<Scalars['String']>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedUpdateWithoutEventsInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId?: Maybe<Scalars['String']>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedUpdateWithoutInformAudienceMemberInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedUpdateManyWithoutSessionNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUncheckedUpdateWithoutInformAudienceMemberMessageInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUncheckedUpdateManyWithoutSessionNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberId?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUpdateInput = {
  ClinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutInformSessionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUpdateManyWithoutSessionNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateOneRequiredWithoutInformSessionNestedInput>;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageUpdateOneWithoutInformSessionsNestedInput>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: InformSessionUpdateManyMutationInput;
  where: InformSessionScalarWhereInput;
};

export type InformSessionUpdateManyWithWhereWithoutInformAudienceMemberInput = {
  data: InformSessionUpdateManyMutationInput;
  where: InformSessionScalarWhereInput;
};

export type InformSessionUpdateManyWithWhereWithoutInformAudienceMemberMessageInput = {
  data: InformSessionUpdateManyMutationInput;
  where: InformSessionScalarWhereInput;
};

export type InformSessionUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InformSessionCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InformSessionCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<InformSessionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformSessionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  set?: Maybe<Array<InformSessionWhereUniqueInput>>;
  update?: Maybe<Array<InformSessionUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<InformSessionUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<InformSessionUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type InformSessionUpdateManyWithoutInformAudienceMemberMessageNestedInput = {
  connect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionCreateOrConnectWithoutInformAudienceMemberMessageInput>>;
  create?: Maybe<Array<InformSessionCreateWithoutInformAudienceMemberMessageInput>>;
  createMany?: Maybe<InformSessionCreateManyInformAudienceMemberMessageInputEnvelope>;
  delete?: Maybe<Array<InformSessionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformSessionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  set?: Maybe<Array<InformSessionWhereUniqueInput>>;
  update?: Maybe<Array<InformSessionUpdateWithWhereUniqueWithoutInformAudienceMemberMessageInput>>;
  updateMany?: Maybe<Array<InformSessionUpdateManyWithWhereWithoutInformAudienceMemberMessageInput>>;
  upsert?: Maybe<Array<InformSessionUpsertWithWhereUniqueWithoutInformAudienceMemberMessageInput>>;
};

export type InformSessionUpdateManyWithoutInformAudienceMemberNestedInput = {
  connect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InformSessionCreateOrConnectWithoutInformAudienceMemberInput>>;
  create?: Maybe<Array<InformSessionCreateWithoutInformAudienceMemberInput>>;
  createMany?: Maybe<InformSessionCreateManyInformAudienceMemberInputEnvelope>;
  delete?: Maybe<Array<InformSessionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InformSessionScalarWhereInput>>;
  disconnect?: Maybe<Array<InformSessionWhereUniqueInput>>;
  set?: Maybe<Array<InformSessionWhereUniqueInput>>;
  update?: Maybe<Array<InformSessionUpdateWithWhereUniqueWithoutInformAudienceMemberInput>>;
  updateMany?: Maybe<Array<InformSessionUpdateManyWithWhereWithoutInformAudienceMemberInput>>;
  upsert?: Maybe<Array<InformSessionUpsertWithWhereUniqueWithoutInformAudienceMemberInput>>;
};

export type InformSessionUpdateOneRequiredWithoutEventsNestedInput = {
  connect?: Maybe<InformSessionWhereUniqueInput>;
  connectOrCreate?: Maybe<InformSessionCreateOrConnectWithoutEventsInput>;
  create?: Maybe<InformSessionCreateWithoutEventsInput>;
  update?: Maybe<InformSessionUpdateToOneWithWhereWithoutEventsInput>;
  upsert?: Maybe<InformSessionUpsertWithoutEventsInput>;
};

export type InformSessionUpdateToOneWithWhereWithoutEventsInput = {
  data: InformSessionUpdateWithoutEventsInput;
  where?: Maybe<InformSessionWhereInput>;
};

export type InformSessionUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: InformSessionUpdateWithoutClinicPetParentInput;
  where: InformSessionWhereUniqueInput;
};

export type InformSessionUpdateWithWhereUniqueWithoutInformAudienceMemberInput = {
  data: InformSessionUpdateWithoutInformAudienceMemberInput;
  where: InformSessionWhereUniqueInput;
};

export type InformSessionUpdateWithWhereUniqueWithoutInformAudienceMemberMessageInput = {
  data: InformSessionUpdateWithoutInformAudienceMemberMessageInput;
  where: InformSessionWhereUniqueInput;
};

export type InformSessionUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUpdateManyWithoutSessionNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateOneRequiredWithoutInformSessionNestedInput>;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageUpdateOneWithoutInformSessionsNestedInput>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUpdateWithoutEventsInput = {
  ClinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutInformSessionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateOneRequiredWithoutInformSessionNestedInput>;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageUpdateOneWithoutInformSessionsNestedInput>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUpdateWithoutInformAudienceMemberInput = {
  ClinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutInformSessionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUpdateManyWithoutSessionNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageUpdateOneWithoutInformSessionsNestedInput>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUpdateWithoutInformAudienceMemberMessageInput = {
  ClinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutInformSessionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<InformSessionEventUpdateManyWithoutSessionNestedInput>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateOneRequiredWithoutInformSessionNestedInput>;
  status?: Maybe<InformSessionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InformSessionUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: InformSessionCreateWithoutClinicPetParentInput;
  update: InformSessionUpdateWithoutClinicPetParentInput;
  where: InformSessionWhereUniqueInput;
};

export type InformSessionUpsertWithWhereUniqueWithoutInformAudienceMemberInput = {
  create: InformSessionCreateWithoutInformAudienceMemberInput;
  update: InformSessionUpdateWithoutInformAudienceMemberInput;
  where: InformSessionWhereUniqueInput;
};

export type InformSessionUpsertWithWhereUniqueWithoutInformAudienceMemberMessageInput = {
  create: InformSessionCreateWithoutInformAudienceMemberMessageInput;
  update: InformSessionUpdateWithoutInformAudienceMemberMessageInput;
  where: InformSessionWhereUniqueInput;
};

export type InformSessionUpsertWithoutEventsInput = {
  create: InformSessionCreateWithoutEventsInput;
  update: InformSessionUpdateWithoutEventsInput;
  where?: Maybe<InformSessionWhereInput>;
};

export type InformSessionWhereInput = {
  AND?: Maybe<Array<InformSessionWhereInput>>;
  ClinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  NOT?: Maybe<Array<InformSessionWhereInput>>;
  OR?: Maybe<Array<InformSessionWhereInput>>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  events?: Maybe<InformSessionEventListRelationFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberScalarRelationFilter>;
  informAudienceMemberId?: Maybe<StringFilter>;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageNullableScalarRelationFilter>;
  informAudienceMemberMessageId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumInformSessionStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InformSessionWhereUniqueInput = {
  AND?: Maybe<Array<InformSessionWhereInput>>;
  ClinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  NOT?: Maybe<Array<InformSessionWhereInput>>;
  OR?: Maybe<Array<InformSessionWhereInput>>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  events?: Maybe<InformSessionEventListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberScalarRelationFilter>;
  informAudienceMemberId?: Maybe<StringFilter>;
  informAudienceMemberMessage?: Maybe<InformAudienceMemberMessageNullableScalarRelationFilter>;
  informAudienceMemberMessageId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumInformSessionStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InstinctIntegration = {
  __typename?: 'InstinctIntegration';
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  createdAt: Scalars['DateTime'];
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** The specific clinic location, if clinic has multiple locations i.e. is part of a Market */
  locationId?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  /** each "Market" (a clinic or collection of clinics) has a subdomain */
  subdomain: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
};


export type InstinctIntegrationClinicPimsIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type InstinctIntegrationCountAggregateOutputType = {
  __typename?: 'InstinctIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  clientId: Scalars['Int'];
  clientSecret: Scalars['Int'];
  createdAt: Scalars['Int'];
  defaultAppointmentTypeId: Scalars['Int'];
  id: Scalars['Int'];
  locationId: Scalars['Int'];
  password: Scalars['Int'];
  subdomain: Scalars['Int'];
  updatedAt: Scalars['Int'];
  username: Scalars['Int'];
};

export type InstinctIntegrationCountOrderByAggregateInput = {
  clientId?: Maybe<SortOrder>;
  clientSecret?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  subdomain?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export type InstinctIntegrationCreateInput = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutInstinctInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  subdomain: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type InstinctIntegrationCreateManyInput = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  subdomain: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type InstinctIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<InstinctIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<InstinctIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<InstinctIntegrationCreateWithoutClinicPimsIntegrationInput>;
};

export type InstinctIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput = {
  create: InstinctIntegrationCreateWithoutClinicPimsIntegrationInput;
  where: InstinctIntegrationWhereUniqueInput;
};

export type InstinctIntegrationCreateWithoutClinicPimsIntegrationInput = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  subdomain: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type InstinctIntegrationGroupByOutputType = {
  __typename?: 'InstinctIntegrationGroupByOutputType';
  _count?: Maybe<InstinctIntegrationCountAggregateOutputType>;
  _max?: Maybe<InstinctIntegrationMaxAggregateOutputType>;
  _min?: Maybe<InstinctIntegrationMinAggregateOutputType>;
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locationId?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  subdomain: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
};

export type InstinctIntegrationMaxAggregateOutputType = {
  __typename?: 'InstinctIntegrationMaxAggregateOutputType';
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type InstinctIntegrationMaxOrderByAggregateInput = {
  clientId?: Maybe<SortOrder>;
  clientSecret?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  subdomain?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export type InstinctIntegrationMinAggregateOutputType = {
  __typename?: 'InstinctIntegrationMinAggregateOutputType';
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type InstinctIntegrationMinOrderByAggregateInput = {
  clientId?: Maybe<SortOrder>;
  clientSecret?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  subdomain?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export type InstinctIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<InstinctIntegrationWhereInput>>;
  NOT?: Maybe<Array<InstinctIntegrationWhereInput>>;
  OR?: Maybe<Array<InstinctIntegrationWhereInput>>;
  clientId?: Maybe<StringNullableFilter>;
  clientSecret?: Maybe<StringNullableFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultAppointmentTypeId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  locationId?: Maybe<StringNullableFilter>;
  password?: Maybe<StringFilter>;
  subdomain?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  username?: Maybe<StringFilter>;
};

export type InstinctIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InstinctIntegrationOrderByRelevanceInput>;
  clientId?: Maybe<SortOrder>;
  clientSecret?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  subdomain?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export enum InstinctIntegrationOrderByRelevanceFieldEnum {
  ClientId = 'clientId',
  ClientSecret = 'clientSecret',
  DefaultAppointmentTypeId = 'defaultAppointmentTypeId',
  Id = 'id',
  LocationId = 'locationId',
  Password = 'password',
  Subdomain = 'subdomain',
  Username = 'username'
}

export type InstinctIntegrationOrderByRelevanceInput = {
  fields: Array<InstinctIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InstinctIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<InstinctIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<InstinctIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<InstinctIntegrationMinOrderByAggregateInput>;
  clientId?: Maybe<SortOrder>;
  clientSecret?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  subdomain?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export type InstinctIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InstinctIntegrationOrderByRelevanceInput>;
  clientId?: Maybe<SortOrder>;
  clientSecret?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  subdomain?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export type InstinctIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<InstinctIntegrationOrderByRelevanceInput>;
  clientId?: Maybe<SortOrder>;
  clientSecret?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  defaultAppointmentTypeId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  subdomain?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export enum InstinctIntegrationScalarFieldEnum {
  ClientId = 'clientId',
  ClientSecret = 'clientSecret',
  CreatedAt = 'createdAt',
  DefaultAppointmentTypeId = 'defaultAppointmentTypeId',
  Id = 'id',
  LocationId = 'locationId',
  Password = 'password',
  Subdomain = 'subdomain',
  UpdatedAt = 'updatedAt',
  Username = 'username'
}

export type InstinctIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InstinctIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InstinctIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InstinctIntegrationScalarWhereWithAggregatesInput>>;
  clientId?: Maybe<StringNullableWithAggregatesFilter>;
  clientSecret?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  defaultAppointmentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  locationId?: Maybe<StringNullableWithAggregatesFilter>;
  password?: Maybe<StringWithAggregatesFilter>;
  subdomain?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  username?: Maybe<StringWithAggregatesFilter>;
};

export type InstinctIntegrationUncheckedCreateInput = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedOneWithoutInstinctInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  subdomain: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type InstinctIntegrationUncheckedCreateWithoutClinicPimsIntegrationInput = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  subdomain: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type InstinctIntegrationUncheckedUpdateInput = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedUpdateOneWithoutInstinctNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type InstinctIntegrationUncheckedUpdateManyInput = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type InstinctIntegrationUncheckedUpdateWithoutClinicPimsIntegrationInput = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type InstinctIntegrationUpdateInput = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutInstinctNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type InstinctIntegrationUpdateManyMutationInput = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type InstinctIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<InstinctIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<InstinctIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<InstinctIntegrationCreateWithoutClinicPimsIntegrationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InstinctIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput>;
  upsert?: Maybe<InstinctIntegrationUpsertWithoutClinicPimsIntegrationInput>;
};

export type InstinctIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput = {
  data: InstinctIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<InstinctIntegrationWhereInput>;
};

export type InstinctIntegrationUpdateWithoutClinicPimsIntegrationInput = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultAppointmentTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type InstinctIntegrationUpsertWithoutClinicPimsIntegrationInput = {
  create: InstinctIntegrationCreateWithoutClinicPimsIntegrationInput;
  update: InstinctIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<InstinctIntegrationWhereInput>;
};

export type InstinctIntegrationWhereInput = {
  AND?: Maybe<Array<InstinctIntegrationWhereInput>>;
  NOT?: Maybe<Array<InstinctIntegrationWhereInput>>;
  OR?: Maybe<Array<InstinctIntegrationWhereInput>>;
  clientId?: Maybe<StringNullableFilter>;
  clientSecret?: Maybe<StringNullableFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultAppointmentTypeId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  locationId?: Maybe<StringNullableFilter>;
  password?: Maybe<StringFilter>;
  subdomain?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  username?: Maybe<StringFilter>;
};

export type InstinctIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<InstinctIntegrationWhereInput>>;
  NOT?: Maybe<Array<InstinctIntegrationWhereInput>>;
  OR?: Maybe<Array<InstinctIntegrationWhereInput>>;
  clientId?: Maybe<StringNullableFilter>;
  clientSecret?: Maybe<StringNullableFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultAppointmentTypeId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<StringNullableFilter>;
  password?: Maybe<StringFilter>;
  subdomain?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  username?: Maybe<StringFilter>;
};

export type InsuranceIntegration = {
  __typename?: 'InsuranceIntegration';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  trupanionIntegration?: Maybe<TrupanionIntegration>;
  type: InsuranceIntegrationType;
  updatedAt: Scalars['DateTime'];
};


export type InsuranceIntegrationTrupanionIntegrationArgs = {
  where?: Maybe<TrupanionIntegrationWhereInput>;
};

export type InsuranceIntegrationCountAggregateOutputType = {
  __typename?: 'InsuranceIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InsuranceIntegrationCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InsuranceIntegrationCreateInput = {
  clinic: ClinicCreateNestedOneWithoutInsuranceIntegrationsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationCreateNestedOneWithoutInsuranceIntegrationInput>;
  type: InsuranceIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  type: InsuranceIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationCreateManyClinicInputEnvelope = {
  data: Array<InsuranceIntegrationCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InsuranceIntegrationCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  type: InsuranceIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<InsuranceIntegrationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InsuranceIntegrationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InsuranceIntegrationCreateWithoutClinicInput>>;
  createMany?: Maybe<InsuranceIntegrationCreateManyClinicInputEnvelope>;
};

export type InsuranceIntegrationCreateNestedOneWithoutTrupanionIntegrationInput = {
  connect?: Maybe<InsuranceIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<InsuranceIntegrationCreateOrConnectWithoutTrupanionIntegrationInput>;
  create?: Maybe<InsuranceIntegrationCreateWithoutTrupanionIntegrationInput>;
};

export type InsuranceIntegrationCreateOrConnectWithoutClinicInput = {
  create: InsuranceIntegrationCreateWithoutClinicInput;
  where: InsuranceIntegrationWhereUniqueInput;
};

export type InsuranceIntegrationCreateOrConnectWithoutTrupanionIntegrationInput = {
  create: InsuranceIntegrationCreateWithoutTrupanionIntegrationInput;
  where: InsuranceIntegrationWhereUniqueInput;
};

export type InsuranceIntegrationCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationCreateNestedOneWithoutInsuranceIntegrationInput>;
  type: InsuranceIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationCreateWithoutTrupanionIntegrationInput = {
  clinic: ClinicCreateNestedOneWithoutInsuranceIntegrationsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  type: InsuranceIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationGroupByOutputType = {
  __typename?: 'InsuranceIntegrationGroupByOutputType';
  _count?: Maybe<InsuranceIntegrationCountAggregateOutputType>;
  _max?: Maybe<InsuranceIntegrationMaxAggregateOutputType>;
  _min?: Maybe<InsuranceIntegrationMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  type: InsuranceIntegrationType;
  updatedAt: Scalars['DateTime'];
};

export type InsuranceIntegrationListRelationFilter = {
  every?: Maybe<InsuranceIntegrationWhereInput>;
  none?: Maybe<InsuranceIntegrationWhereInput>;
  some?: Maybe<InsuranceIntegrationWhereInput>;
};

export type InsuranceIntegrationMaxAggregateOutputType = {
  __typename?: 'InsuranceIntegrationMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  type?: Maybe<InsuranceIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InsuranceIntegrationMinAggregateOutputType = {
  __typename?: 'InsuranceIntegrationMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  type?: Maybe<InsuranceIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InsuranceIntegrationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InsuranceIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InsuranceIntegrationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  trupanionIntegration?: Maybe<TrupanionIntegrationOrderByWithRelationInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InsuranceIntegrationOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id'
}

export type InsuranceIntegrationOrderByRelevanceInput = {
  fields: Array<InsuranceIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InsuranceIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<InsuranceIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<InsuranceIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<InsuranceIntegrationMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InsuranceIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InsuranceIntegrationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  trupanionIntegration?: Maybe<TrupanionIntegrationOrderByWithRelationInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InsuranceIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<InsuranceIntegrationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  trupanionIntegration?: Maybe<TrupanionIntegrationOrderByWithRelationInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InsuranceIntegrationScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type InsuranceIntegrationScalarRelationFilter = {
  AND?: Maybe<Array<InsuranceIntegrationWhereInput>>;
  NOT?: Maybe<Array<InsuranceIntegrationWhereInput>>;
  OR?: Maybe<Array<InsuranceIntegrationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  trupanionIntegration?: Maybe<TrupanionIntegrationNullableScalarRelationFilter>;
  type?: Maybe<EnumInsuranceIntegrationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InsuranceIntegrationScalarWhereInput = {
  AND?: Maybe<Array<InsuranceIntegrationScalarWhereInput>>;
  NOT?: Maybe<Array<InsuranceIntegrationScalarWhereInput>>;
  OR?: Maybe<Array<InsuranceIntegrationScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  type?: Maybe<EnumInsuranceIntegrationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InsuranceIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InsuranceIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InsuranceIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InsuranceIntegrationScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  type?: Maybe<EnumInsuranceIntegrationTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InsuranceIntegrationType {
  Trupanion = 'Trupanion'
}

export type InsuranceIntegrationUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUncheckedCreateNestedOneWithoutInsuranceIntegrationInput>;
  type: InsuranceIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<InsuranceIntegrationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InsuranceIntegrationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InsuranceIntegrationCreateWithoutClinicInput>>;
  createMany?: Maybe<InsuranceIntegrationCreateManyClinicInputEnvelope>;
};

export type InsuranceIntegrationUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUncheckedCreateNestedOneWithoutInsuranceIntegrationInput>;
  type: InsuranceIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationUncheckedCreateWithoutTrupanionIntegrationInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  type: InsuranceIntegrationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUncheckedUpdateOneWithoutInsuranceIntegrationNestedInput>;
  type?: Maybe<InsuranceIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  type?: Maybe<InsuranceIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  type?: Maybe<InsuranceIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<InsuranceIntegrationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InsuranceIntegrationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InsuranceIntegrationCreateWithoutClinicInput>>;
  createMany?: Maybe<InsuranceIntegrationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<InsuranceIntegrationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InsuranceIntegrationScalarWhereInput>>;
  disconnect?: Maybe<Array<InsuranceIntegrationWhereUniqueInput>>;
  set?: Maybe<Array<InsuranceIntegrationWhereUniqueInput>>;
  update?: Maybe<Array<InsuranceIntegrationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<InsuranceIntegrationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<InsuranceIntegrationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type InsuranceIntegrationUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUncheckedUpdateOneWithoutInsuranceIntegrationNestedInput>;
  type?: Maybe<InsuranceIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationUncheckedUpdateWithoutTrupanionIntegrationInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  type?: Maybe<InsuranceIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInsuranceIntegrationsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUpdateOneWithoutInsuranceIntegrationNestedInput>;
  type?: Maybe<InsuranceIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  type?: Maybe<InsuranceIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationUpdateManyWithWhereWithoutClinicInput = {
  data: InsuranceIntegrationUpdateManyMutationInput;
  where: InsuranceIntegrationScalarWhereInput;
};

export type InsuranceIntegrationUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<InsuranceIntegrationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InsuranceIntegrationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<InsuranceIntegrationCreateWithoutClinicInput>>;
  createMany?: Maybe<InsuranceIntegrationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<InsuranceIntegrationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InsuranceIntegrationScalarWhereInput>>;
  disconnect?: Maybe<Array<InsuranceIntegrationWhereUniqueInput>>;
  set?: Maybe<Array<InsuranceIntegrationWhereUniqueInput>>;
  update?: Maybe<Array<InsuranceIntegrationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<InsuranceIntegrationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<InsuranceIntegrationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type InsuranceIntegrationUpdateOneRequiredWithoutTrupanionIntegrationNestedInput = {
  connect?: Maybe<InsuranceIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<InsuranceIntegrationCreateOrConnectWithoutTrupanionIntegrationInput>;
  create?: Maybe<InsuranceIntegrationCreateWithoutTrupanionIntegrationInput>;
  update?: Maybe<InsuranceIntegrationUpdateToOneWithWhereWithoutTrupanionIntegrationInput>;
  upsert?: Maybe<InsuranceIntegrationUpsertWithoutTrupanionIntegrationInput>;
};

export type InsuranceIntegrationUpdateToOneWithWhereWithoutTrupanionIntegrationInput = {
  data: InsuranceIntegrationUpdateWithoutTrupanionIntegrationInput;
  where?: Maybe<InsuranceIntegrationWhereInput>;
};

export type InsuranceIntegrationUpdateWithWhereUniqueWithoutClinicInput = {
  data: InsuranceIntegrationUpdateWithoutClinicInput;
  where: InsuranceIntegrationWhereUniqueInput;
};

export type InsuranceIntegrationUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUpdateOneWithoutInsuranceIntegrationNestedInput>;
  type?: Maybe<InsuranceIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationUpdateWithoutTrupanionIntegrationInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutInsuranceIntegrationsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  type?: Maybe<InsuranceIntegrationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsuranceIntegrationUpsertWithWhereUniqueWithoutClinicInput = {
  create: InsuranceIntegrationCreateWithoutClinicInput;
  update: InsuranceIntegrationUpdateWithoutClinicInput;
  where: InsuranceIntegrationWhereUniqueInput;
};

export type InsuranceIntegrationUpsertWithoutTrupanionIntegrationInput = {
  create: InsuranceIntegrationCreateWithoutTrupanionIntegrationInput;
  update: InsuranceIntegrationUpdateWithoutTrupanionIntegrationInput;
  where?: Maybe<InsuranceIntegrationWhereInput>;
};

export type InsuranceIntegrationWhereInput = {
  AND?: Maybe<Array<InsuranceIntegrationWhereInput>>;
  NOT?: Maybe<Array<InsuranceIntegrationWhereInput>>;
  OR?: Maybe<Array<InsuranceIntegrationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  trupanionIntegration?: Maybe<TrupanionIntegrationNullableScalarRelationFilter>;
  type?: Maybe<EnumInsuranceIntegrationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InsuranceIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<InsuranceIntegrationWhereInput>>;
  NOT?: Maybe<Array<InsuranceIntegrationWhereInput>>;
  OR?: Maybe<Array<InsuranceIntegrationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolFilter>;
  trupanionIntegration?: Maybe<TrupanionIntegrationNullableScalarRelationFilter>;
  type?: Maybe<EnumInsuranceIntegrationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Int']>;
  divide?: Maybe<Scalars['Int']>;
  increment?: Maybe<Scalars['Int']>;
  multiply?: Maybe<Scalars['Int']>;
  set?: Maybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatNullableFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedIntNullableFilter>;
  _sum?: Maybe<NestedIntNullableFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedIntFilter>;
  _sum?: Maybe<NestedIntFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntegrationOutageHistoryEntry = {
  __typename?: 'IntegrationOutageHistoryEntry';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  status: Scalars['String'];
};

export type IntegrationOutageHistoryEntryCountAggregateOutputType = {
  __typename?: 'IntegrationOutageHistoryEntryCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  status: Scalars['Int'];
};

export type IntegrationOutageHistoryEntryCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type IntegrationOutageHistoryEntryCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutIntegrationOutageHistoryEntryInput;
  isActive?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
};

export type IntegrationOutageHistoryEntryCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
};

export type IntegrationOutageHistoryEntryCreateManyIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
};

export type IntegrationOutageHistoryEntryCreateManyIntegrationInputEnvelope = {
  data: Array<IntegrationOutageHistoryEntryCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type IntegrationOutageHistoryEntryCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<IntegrationOutageHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<IntegrationOutageHistoryEntryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<IntegrationOutageHistoryEntryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<IntegrationOutageHistoryEntryCreateManyIntegrationInputEnvelope>;
};

export type IntegrationOutageHistoryEntryCreateOrConnectWithoutIntegrationInput = {
  create: IntegrationOutageHistoryEntryCreateWithoutIntegrationInput;
  where: IntegrationOutageHistoryEntryWhereUniqueInput;
};

export type IntegrationOutageHistoryEntryCreateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
};

export type IntegrationOutageHistoryEntryGroupByOutputType = {
  __typename?: 'IntegrationOutageHistoryEntryGroupByOutputType';
  _count?: Maybe<IntegrationOutageHistoryEntryCountAggregateOutputType>;
  _max?: Maybe<IntegrationOutageHistoryEntryMaxAggregateOutputType>;
  _min?: Maybe<IntegrationOutageHistoryEntryMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  status: Scalars['String'];
};

export type IntegrationOutageHistoryEntryListRelationFilter = {
  every?: Maybe<IntegrationOutageHistoryEntryWhereInput>;
  none?: Maybe<IntegrationOutageHistoryEntryWhereInput>;
  some?: Maybe<IntegrationOutageHistoryEntryWhereInput>;
};

export type IntegrationOutageHistoryEntryMaxAggregateOutputType = {
  __typename?: 'IntegrationOutageHistoryEntryMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type IntegrationOutageHistoryEntryMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type IntegrationOutageHistoryEntryMinAggregateOutputType = {
  __typename?: 'IntegrationOutageHistoryEntryMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type IntegrationOutageHistoryEntryMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type IntegrationOutageHistoryEntryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type IntegrationOutageHistoryEntryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<IntegrationOutageHistoryEntryOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export enum IntegrationOutageHistoryEntryOrderByRelevanceFieldEnum {
  Id = 'id',
  IntegrationId = 'integrationId',
  Status = 'status'
}

export type IntegrationOutageHistoryEntryOrderByRelevanceInput = {
  fields: Array<IntegrationOutageHistoryEntryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type IntegrationOutageHistoryEntryOrderByWithAggregationInput = {
  _count?: Maybe<IntegrationOutageHistoryEntryCountOrderByAggregateInput>;
  _max?: Maybe<IntegrationOutageHistoryEntryMaxOrderByAggregateInput>;
  _min?: Maybe<IntegrationOutageHistoryEntryMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type IntegrationOutageHistoryEntryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<IntegrationOutageHistoryEntryOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type IntegrationOutageHistoryEntryOrderByWithRelationInput = {
  _relevance?: Maybe<IntegrationOutageHistoryEntryOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export enum IntegrationOutageHistoryEntryScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  Status = 'status'
}

export type IntegrationOutageHistoryEntryScalarWhereInput = {
  AND?: Maybe<Array<IntegrationOutageHistoryEntryScalarWhereInput>>;
  NOT?: Maybe<Array<IntegrationOutageHistoryEntryScalarWhereInput>>;
  OR?: Maybe<Array<IntegrationOutageHistoryEntryScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  status?: Maybe<StringFilter>;
};

export type IntegrationOutageHistoryEntryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<IntegrationOutageHistoryEntryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<IntegrationOutageHistoryEntryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<IntegrationOutageHistoryEntryScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  status?: Maybe<StringWithAggregatesFilter>;
};

export type IntegrationOutageHistoryEntrySubscription = {
  __typename?: 'IntegrationOutageHistoryEntrySubscription';
  mutation: MutationType;
  node: IntegrationOutageHistoryEntry;
};

export type IntegrationOutageHistoryEntryUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
};

export type IntegrationOutageHistoryEntryUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<IntegrationOutageHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<IntegrationOutageHistoryEntryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<IntegrationOutageHistoryEntryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<IntegrationOutageHistoryEntryCreateManyIntegrationInputEnvelope>;
};

export type IntegrationOutageHistoryEntryUncheckedCreateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
};

export type IntegrationOutageHistoryEntryUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type IntegrationOutageHistoryEntryUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type IntegrationOutageHistoryEntryUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<IntegrationOutageHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<IntegrationOutageHistoryEntryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<IntegrationOutageHistoryEntryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<IntegrationOutageHistoryEntryCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<IntegrationOutageHistoryEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<IntegrationOutageHistoryEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<IntegrationOutageHistoryEntryWhereUniqueInput>>;
  set?: Maybe<Array<IntegrationOutageHistoryEntryWhereUniqueInput>>;
  update?: Maybe<Array<IntegrationOutageHistoryEntryUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<IntegrationOutageHistoryEntryUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<IntegrationOutageHistoryEntryUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type IntegrationOutageHistoryEntryUncheckedUpdateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type IntegrationOutageHistoryEntryUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutIntegrationOutageHistoryEntryNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type IntegrationOutageHistoryEntryUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type IntegrationOutageHistoryEntryUpdateManyWithWhereWithoutIntegrationInput = {
  data: IntegrationOutageHistoryEntryUpdateManyMutationInput;
  where: IntegrationOutageHistoryEntryScalarWhereInput;
};

export type IntegrationOutageHistoryEntryUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<IntegrationOutageHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<IntegrationOutageHistoryEntryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<IntegrationOutageHistoryEntryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<IntegrationOutageHistoryEntryCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<IntegrationOutageHistoryEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<IntegrationOutageHistoryEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<IntegrationOutageHistoryEntryWhereUniqueInput>>;
  set?: Maybe<Array<IntegrationOutageHistoryEntryWhereUniqueInput>>;
  update?: Maybe<Array<IntegrationOutageHistoryEntryUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<IntegrationOutageHistoryEntryUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<IntegrationOutageHistoryEntryUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type IntegrationOutageHistoryEntryUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: IntegrationOutageHistoryEntryUpdateWithoutIntegrationInput;
  where: IntegrationOutageHistoryEntryWhereUniqueInput;
};

export type IntegrationOutageHistoryEntryUpdateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type IntegrationOutageHistoryEntryUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: IntegrationOutageHistoryEntryCreateWithoutIntegrationInput;
  update: IntegrationOutageHistoryEntryUpdateWithoutIntegrationInput;
  where: IntegrationOutageHistoryEntryWhereUniqueInput;
};

export type IntegrationOutageHistoryEntryWhereInput = {
  AND?: Maybe<Array<IntegrationOutageHistoryEntryWhereInput>>;
  NOT?: Maybe<Array<IntegrationOutageHistoryEntryWhereInput>>;
  OR?: Maybe<Array<IntegrationOutageHistoryEntryWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  status?: Maybe<StringFilter>;
};

export type IntegrationOutageHistoryEntryWhereUniqueInput = {
  AND?: Maybe<Array<IntegrationOutageHistoryEntryWhereInput>>;
  NOT?: Maybe<Array<IntegrationOutageHistoryEntryWhereInput>>;
  OR?: Maybe<Array<IntegrationOutageHistoryEntryWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  status?: Maybe<StringFilter>;
};

export enum IntegrationStatus {
  Abandoned = 'Abandoned',
  Connected = 'Connected',
  Created = 'Created',
  NotIntegrated = 'NotIntegrated',
  NotValid = 'NotValid',
  Paused = 'Paused',
  Scheduled = 'Scheduled',
  Valid = 'Valid'
}

export enum IntegrationType {
  ClinicWebApp = 'CLINIC_WEB_APP',
  DocupostWebhook = 'DOCUPOST_WEBHOOK',
  Ezyvet = 'EZYVET',
  Instinct = 'INSTINCT',
  Internal = 'INTERNAL',
  Neo = 'NEO',
  PetWidget = 'PET_WIDGET',
  SalesforceWebhook = 'SALESFORCE_WEBHOOK',
  StripePciReview = 'STRIPE_PCI_REVIEW',
  SynchronyWebhook = 'SYNCHRONY_WEBHOOK',
  TerminalApp = 'TERMINAL_APP',
  Vetdata = 'VETDATA',
  Vetter = 'VETTER',
  VideoPluginWebApp = 'VIDEO_PLUGIN_WEB_APP'
}

export type InterchangeRate = {
  __typename?: 'InterchangeRate';
  basisPoints: Scalars['Int'];
  centsPerTransaction: Scalars['Int'];
  clinicPaymentFeeConfiguration: ClinicPaymentFeeConfiguration;
  clinicPaymentFeeConfigurationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  fundingSources: Array<CardFunding>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  paymentMedia: Array<PaymentMedium>;
  startsAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type InterchangeRateAvgAggregateOutputType = {
  __typename?: 'InterchangeRateAvgAggregateOutputType';
  basisPoints?: Maybe<Scalars['Float']>;
  centsPerTransaction?: Maybe<Scalars['Float']>;
};

export type InterchangeRateAvgOrderByAggregateInput = {
  basisPoints?: Maybe<SortOrder>;
  centsPerTransaction?: Maybe<SortOrder>;
};

export type InterchangeRateCountAggregateOutputType = {
  __typename?: 'InterchangeRateCountAggregateOutputType';
  _all: Scalars['Int'];
  basisPoints: Scalars['Int'];
  centsPerTransaction: Scalars['Int'];
  clinicPaymentFeeConfigurationId: Scalars['Int'];
  createdAt: Scalars['Int'];
  endsAt: Scalars['Int'];
  fundingSources: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  paymentMedia: Scalars['Int'];
  startsAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InterchangeRateCountOrderByAggregateInput = {
  basisPoints?: Maybe<SortOrder>;
  centsPerTransaction?: Maybe<SortOrder>;
  clinicPaymentFeeConfigurationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  fundingSources?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  paymentMedia?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InterchangeRateCreateInput = {
  basisPoints: Scalars['Int'];
  centsPerTransaction: Scalars['Int'];
  clinicPaymentFeeConfiguration: ClinicPaymentFeeConfigurationCreateNestedOneWithoutInterchangeRatesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateCreateManyClinicPaymentFeeConfigurationInput = {
  basisPoints: Scalars['Int'];
  centsPerTransaction: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateCreateManyClinicPaymentFeeConfigurationInputEnvelope = {
  data: Array<InterchangeRateCreateManyClinicPaymentFeeConfigurationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InterchangeRateCreateManyInput = {
  basisPoints: Scalars['Int'];
  centsPerTransaction: Scalars['Int'];
  clinicPaymentFeeConfigurationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateCreateNestedManyWithoutClinicPaymentFeeConfigurationInput = {
  connect?: Maybe<Array<InterchangeRateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InterchangeRateCreateOrConnectWithoutClinicPaymentFeeConfigurationInput>>;
  create?: Maybe<Array<InterchangeRateCreateWithoutClinicPaymentFeeConfigurationInput>>;
  createMany?: Maybe<InterchangeRateCreateManyClinicPaymentFeeConfigurationInputEnvelope>;
};

export type InterchangeRateCreateOrConnectWithoutClinicPaymentFeeConfigurationInput = {
  create: InterchangeRateCreateWithoutClinicPaymentFeeConfigurationInput;
  where: InterchangeRateWhereUniqueInput;
};

export type InterchangeRateCreateWithoutClinicPaymentFeeConfigurationInput = {
  basisPoints: Scalars['Int'];
  centsPerTransaction: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateCreatefundingSourcesInput = {
  set: Array<CardFunding>;
};

export type InterchangeRateCreatepaymentMediaInput = {
  set: Array<PaymentMedium>;
};

export type InterchangeRateGroupByOutputType = {
  __typename?: 'InterchangeRateGroupByOutputType';
  _avg?: Maybe<InterchangeRateAvgAggregateOutputType>;
  _count?: Maybe<InterchangeRateCountAggregateOutputType>;
  _max?: Maybe<InterchangeRateMaxAggregateOutputType>;
  _min?: Maybe<InterchangeRateMinAggregateOutputType>;
  _sum?: Maybe<InterchangeRateSumAggregateOutputType>;
  basisPoints: Scalars['Int'];
  centsPerTransaction: Scalars['Int'];
  clinicPaymentFeeConfigurationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  fundingSources?: Maybe<Array<CardFunding>>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type InterchangeRateListRelationFilter = {
  every?: Maybe<InterchangeRateWhereInput>;
  none?: Maybe<InterchangeRateWhereInput>;
  some?: Maybe<InterchangeRateWhereInput>;
};

export type InterchangeRateMaxAggregateOutputType = {
  __typename?: 'InterchangeRateMaxAggregateOutputType';
  basisPoints?: Maybe<Scalars['Int']>;
  centsPerTransaction?: Maybe<Scalars['Int']>;
  clinicPaymentFeeConfigurationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateMaxOrderByAggregateInput = {
  basisPoints?: Maybe<SortOrder>;
  centsPerTransaction?: Maybe<SortOrder>;
  clinicPaymentFeeConfigurationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InterchangeRateMinAggregateOutputType = {
  __typename?: 'InterchangeRateMinAggregateOutputType';
  basisPoints?: Maybe<Scalars['Int']>;
  centsPerTransaction?: Maybe<Scalars['Int']>;
  clinicPaymentFeeConfigurationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateMinOrderByAggregateInput = {
  basisPoints?: Maybe<SortOrder>;
  centsPerTransaction?: Maybe<SortOrder>;
  clinicPaymentFeeConfigurationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InterchangeRateOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InterchangeRateOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InterchangeRateOrderByRelevanceInput>;
  basisPoints?: Maybe<SortOrder>;
  centsPerTransaction?: Maybe<SortOrder>;
  clinicPaymentFeeConfiguration?: Maybe<ClinicPaymentFeeConfigurationOrderByWithRelationInput>;
  clinicPaymentFeeConfigurationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  fundingSources?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  paymentMedia?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InterchangeRateOrderByRelevanceFieldEnum {
  ClinicPaymentFeeConfigurationId = 'clinicPaymentFeeConfigurationId',
  Id = 'id'
}

export type InterchangeRateOrderByRelevanceInput = {
  fields: Array<InterchangeRateOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InterchangeRateOrderByWithAggregationInput = {
  _avg?: Maybe<InterchangeRateAvgOrderByAggregateInput>;
  _count?: Maybe<InterchangeRateCountOrderByAggregateInput>;
  _max?: Maybe<InterchangeRateMaxOrderByAggregateInput>;
  _min?: Maybe<InterchangeRateMinOrderByAggregateInput>;
  _sum?: Maybe<InterchangeRateSumOrderByAggregateInput>;
  basisPoints?: Maybe<SortOrder>;
  centsPerTransaction?: Maybe<SortOrder>;
  clinicPaymentFeeConfigurationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  fundingSources?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  paymentMedia?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InterchangeRateOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InterchangeRateOrderByRelevanceInput>;
  basisPoints?: Maybe<SortOrder>;
  centsPerTransaction?: Maybe<SortOrder>;
  clinicPaymentFeeConfiguration?: Maybe<ClinicPaymentFeeConfigurationOrderByWithRelationInput>;
  clinicPaymentFeeConfigurationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  fundingSources?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  paymentMedia?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InterchangeRateOrderByWithRelationInput = {
  _relevance?: Maybe<InterchangeRateOrderByRelevanceInput>;
  basisPoints?: Maybe<SortOrder>;
  centsPerTransaction?: Maybe<SortOrder>;
  clinicPaymentFeeConfiguration?: Maybe<ClinicPaymentFeeConfigurationOrderByWithRelationInput>;
  clinicPaymentFeeConfigurationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  fundingSources?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  paymentMedia?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InterchangeRateScalarFieldEnum {
  BasisPoints = 'basisPoints',
  CentsPerTransaction = 'centsPerTransaction',
  ClinicPaymentFeeConfigurationId = 'clinicPaymentFeeConfigurationId',
  CreatedAt = 'createdAt',
  EndsAt = 'endsAt',
  FundingSources = 'fundingSources',
  Id = 'id',
  IsActive = 'isActive',
  PaymentMedia = 'paymentMedia',
  StartsAt = 'startsAt',
  UpdatedAt = 'updatedAt'
}

export type InterchangeRateScalarWhereInput = {
  AND?: Maybe<Array<InterchangeRateScalarWhereInput>>;
  NOT?: Maybe<Array<InterchangeRateScalarWhereInput>>;
  OR?: Maybe<Array<InterchangeRateScalarWhereInput>>;
  basisPoints?: Maybe<IntFilter>;
  centsPerTransaction?: Maybe<IntFilter>;
  clinicPaymentFeeConfigurationId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endsAt?: Maybe<DateTimeFilter>;
  fundingSources?: Maybe<EnumCardFundingNullableListFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  paymentMedia?: Maybe<EnumPaymentMediumNullableListFilter>;
  startsAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InterchangeRateScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InterchangeRateScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InterchangeRateScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InterchangeRateScalarWhereWithAggregatesInput>>;
  basisPoints?: Maybe<IntWithAggregatesFilter>;
  centsPerTransaction?: Maybe<IntWithAggregatesFilter>;
  clinicPaymentFeeConfigurationId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  endsAt?: Maybe<DateTimeWithAggregatesFilter>;
  fundingSources?: Maybe<EnumCardFundingNullableListFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  paymentMedia?: Maybe<EnumPaymentMediumNullableListFilter>;
  startsAt?: Maybe<DateTimeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type InterchangeRateSumAggregateOutputType = {
  __typename?: 'InterchangeRateSumAggregateOutputType';
  basisPoints?: Maybe<Scalars['Int']>;
  centsPerTransaction?: Maybe<Scalars['Int']>;
};

export type InterchangeRateSumOrderByAggregateInput = {
  basisPoints?: Maybe<SortOrder>;
  centsPerTransaction?: Maybe<SortOrder>;
};

export type InterchangeRateUncheckedCreateInput = {
  basisPoints: Scalars['Int'];
  centsPerTransaction: Scalars['Int'];
  clinicPaymentFeeConfigurationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateUncheckedCreateNestedManyWithoutClinicPaymentFeeConfigurationInput = {
  connect?: Maybe<Array<InterchangeRateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InterchangeRateCreateOrConnectWithoutClinicPaymentFeeConfigurationInput>>;
  create?: Maybe<Array<InterchangeRateCreateWithoutClinicPaymentFeeConfigurationInput>>;
  createMany?: Maybe<InterchangeRateCreateManyClinicPaymentFeeConfigurationInputEnvelope>;
};

export type InterchangeRateUncheckedCreateWithoutClinicPaymentFeeConfigurationInput = {
  basisPoints: Scalars['Int'];
  centsPerTransaction: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateUncheckedUpdateInput = {
  basisPoints?: Maybe<Scalars['Int']>;
  centsPerTransaction?: Maybe<Scalars['Int']>;
  clinicPaymentFeeConfigurationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateUncheckedUpdateManyInput = {
  basisPoints?: Maybe<Scalars['Int']>;
  centsPerTransaction?: Maybe<Scalars['Int']>;
  clinicPaymentFeeConfigurationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateUncheckedUpdateManyWithoutClinicPaymentFeeConfigurationInput = {
  basisPoints?: Maybe<Scalars['Int']>;
  centsPerTransaction?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateUncheckedUpdateManyWithoutClinicPaymentFeeConfigurationNestedInput = {
  connect?: Maybe<Array<InterchangeRateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InterchangeRateCreateOrConnectWithoutClinicPaymentFeeConfigurationInput>>;
  create?: Maybe<Array<InterchangeRateCreateWithoutClinicPaymentFeeConfigurationInput>>;
  createMany?: Maybe<InterchangeRateCreateManyClinicPaymentFeeConfigurationInputEnvelope>;
  delete?: Maybe<Array<InterchangeRateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InterchangeRateScalarWhereInput>>;
  disconnect?: Maybe<Array<InterchangeRateWhereUniqueInput>>;
  set?: Maybe<Array<InterchangeRateWhereUniqueInput>>;
  update?: Maybe<Array<InterchangeRateUpdateWithWhereUniqueWithoutClinicPaymentFeeConfigurationInput>>;
  updateMany?: Maybe<Array<InterchangeRateUpdateManyWithWhereWithoutClinicPaymentFeeConfigurationInput>>;
  upsert?: Maybe<Array<InterchangeRateUpsertWithWhereUniqueWithoutClinicPaymentFeeConfigurationInput>>;
};

export type InterchangeRateUncheckedUpdateWithoutClinicPaymentFeeConfigurationInput = {
  basisPoints?: Maybe<Scalars['Int']>;
  centsPerTransaction?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateUpdateInput = {
  basisPoints?: Maybe<Scalars['Int']>;
  centsPerTransaction?: Maybe<Scalars['Int']>;
  clinicPaymentFeeConfiguration?: Maybe<ClinicPaymentFeeConfigurationUpdateOneRequiredWithoutInterchangeRatesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateUpdateManyMutationInput = {
  basisPoints?: Maybe<Scalars['Int']>;
  centsPerTransaction?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateUpdateManyWithWhereWithoutClinicPaymentFeeConfigurationInput = {
  data: InterchangeRateUpdateManyMutationInput;
  where: InterchangeRateScalarWhereInput;
};

export type InterchangeRateUpdateManyWithoutClinicPaymentFeeConfigurationNestedInput = {
  connect?: Maybe<Array<InterchangeRateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InterchangeRateCreateOrConnectWithoutClinicPaymentFeeConfigurationInput>>;
  create?: Maybe<Array<InterchangeRateCreateWithoutClinicPaymentFeeConfigurationInput>>;
  createMany?: Maybe<InterchangeRateCreateManyClinicPaymentFeeConfigurationInputEnvelope>;
  delete?: Maybe<Array<InterchangeRateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InterchangeRateScalarWhereInput>>;
  disconnect?: Maybe<Array<InterchangeRateWhereUniqueInput>>;
  set?: Maybe<Array<InterchangeRateWhereUniqueInput>>;
  update?: Maybe<Array<InterchangeRateUpdateWithWhereUniqueWithoutClinicPaymentFeeConfigurationInput>>;
  updateMany?: Maybe<Array<InterchangeRateUpdateManyWithWhereWithoutClinicPaymentFeeConfigurationInput>>;
  upsert?: Maybe<Array<InterchangeRateUpsertWithWhereUniqueWithoutClinicPaymentFeeConfigurationInput>>;
};

export type InterchangeRateUpdateWithWhereUniqueWithoutClinicPaymentFeeConfigurationInput = {
  data: InterchangeRateUpdateWithoutClinicPaymentFeeConfigurationInput;
  where: InterchangeRateWhereUniqueInput;
};

export type InterchangeRateUpdateWithoutClinicPaymentFeeConfigurationInput = {
  basisPoints?: Maybe<Scalars['Int']>;
  centsPerTransaction?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  fundingSources?: Maybe<Array<CardFunding>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMedia?: Maybe<Array<PaymentMedium>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterchangeRateUpdatefundingSourcesInput = {
  push?: Maybe<Array<CardFunding>>;
  set?: Maybe<Array<CardFunding>>;
};

export type InterchangeRateUpdatepaymentMediaInput = {
  push?: Maybe<Array<PaymentMedium>>;
  set?: Maybe<Array<PaymentMedium>>;
};

export type InterchangeRateUpsertWithWhereUniqueWithoutClinicPaymentFeeConfigurationInput = {
  create: InterchangeRateCreateWithoutClinicPaymentFeeConfigurationInput;
  update: InterchangeRateUpdateWithoutClinicPaymentFeeConfigurationInput;
  where: InterchangeRateWhereUniqueInput;
};

export type InterchangeRateWhereInput = {
  AND?: Maybe<Array<InterchangeRateWhereInput>>;
  NOT?: Maybe<Array<InterchangeRateWhereInput>>;
  OR?: Maybe<Array<InterchangeRateWhereInput>>;
  basisPoints?: Maybe<IntFilter>;
  centsPerTransaction?: Maybe<IntFilter>;
  clinicPaymentFeeConfiguration?: Maybe<ClinicPaymentFeeConfigurationScalarRelationFilter>;
  clinicPaymentFeeConfigurationId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endsAt?: Maybe<DateTimeFilter>;
  fundingSources?: Maybe<EnumCardFundingNullableListFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  paymentMedia?: Maybe<EnumPaymentMediumNullableListFilter>;
  startsAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InterchangeRateWhereUniqueInput = {
  AND?: Maybe<Array<InterchangeRateWhereInput>>;
  NOT?: Maybe<Array<InterchangeRateWhereInput>>;
  OR?: Maybe<Array<InterchangeRateWhereInput>>;
  basisPoints?: Maybe<IntFilter>;
  centsPerTransaction?: Maybe<IntFilter>;
  clinicPaymentFeeConfiguration?: Maybe<ClinicPaymentFeeConfigurationScalarRelationFilter>;
  clinicPaymentFeeConfigurationId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endsAt?: Maybe<DateTimeFilter>;
  fundingSources?: Maybe<EnumCardFundingNullableListFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolFilter>;
  paymentMedia?: Maybe<EnumPaymentMediumNullableListFilter>;
  startsAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Invoice = {
  __typename?: 'Invoice';
  _count: InvoiceCountOutputType;
  associatedCareBenefitCredits: Array<CareBenefitUsageToInvoiceLineItem>;
  careAccountCreditIntents: Array<CareAccountCreditIntent>;
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: Currency;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** The clinic readable identifier for this invoice, e.g. number */
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems: Array<InvoiceLineItem>;
  loyaltyPointDeltas: Array<LoyaltyPointDelta>;
  outstandingBalance: Scalars['Int'];
  pimsInvoice?: Maybe<PimsInvoice>;
  relatedInvoiceWritebacks: Array<InvoicePimsWritebackLogEntry>;
  sentBy?: Maybe<User>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries: Array<ServicePurchaseSummary>;
  status: InvoiceStatus;
  stripePaymentIntents: Array<StripePaymentIntent>;
  subtotal: Scalars['Int'];
  taxes: Scalars['Int'];
  total: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type InvoiceAssociatedCareBenefitCreditsArgs = {
  cursor?: Maybe<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
};


export type InvoiceCareAccountCreditIntentsArgs = {
  cursor?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAccountCreditIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAccountCreditIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};


export type InvoiceIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type InvoiceLineItemsArgs = {
  cursor?: Maybe<InvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceLineItemWhereInput>;
};


export type InvoiceLoyaltyPointDeltasArgs = {
  cursor?: Maybe<LoyaltyPointDeltaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointDeltaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointDeltaOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
};


export type InvoicePimsInvoiceArgs = {
  where?: Maybe<PimsInvoiceWhereInput>;
};


export type InvoiceRelatedInvoiceWritebacksArgs = {
  cursor?: Maybe<InvoicePimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoicePimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoicePimsWritebackLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
};


export type InvoiceSentByArgs = {
  where?: Maybe<UserWhereInput>;
};


export type InvoiceServicePurchaseSummariesArgs = {
  cursor?: Maybe<ServicePurchaseSummaryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServicePurchaseSummaryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServicePurchaseSummaryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};


export type InvoiceStripePaymentIntentsArgs = {
  cursor?: Maybe<StripePaymentIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type InvoiceAvgAggregateOutputType = {
  __typename?: 'InvoiceAvgAggregateOutputType';
  outstandingBalance?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  taxes?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type InvoiceAvgOrderByAggregateInput = {
  outstandingBalance?: Maybe<SortOrder>;
  subtotal?: Maybe<SortOrder>;
  taxes?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
};

export type InvoiceCountAggregateOutputType = {
  __typename?: 'InvoiceCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  currency: Scalars['Int'];
  date: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  identifier: Scalars['Int'];
  integrationId: Scalars['Int'];
  outstandingBalance: Scalars['Int'];
  sentByUserId: Scalars['Int'];
  status: Scalars['Int'];
  subtotal: Scalars['Int'];
  taxes: Scalars['Int'];
  total: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InvoiceCountOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  identifier?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  outstandingBalance?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subtotal?: Maybe<SortOrder>;
  taxes?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InvoiceCountOutputType = {
  __typename?: 'InvoiceCountOutputType';
  associatedCareBenefitCredits: Scalars['Int'];
  careAccountCreditIntents: Scalars['Int'];
  lineItems: Scalars['Int'];
  loyaltyPointDeltas: Scalars['Int'];
  relatedInvoiceWritebacks: Scalars['Int'];
  servicePurchaseSummaries: Scalars['Int'];
  stripePaymentIntents: Scalars['Int'];
};

export type InvoiceCreateInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutInvoiceInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInvoicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutInvoicesInput>;
  lineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryCreateNestedManyWithoutInvoiceInput>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentInvoicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateManyClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  sentByUserId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateManyClinicPetParentInputEnvelope = {
  data: Array<InvoiceCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InvoiceCreateManyInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  sentByUserId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateManyIntegrationInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  sentByUserId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateManyIntegrationInputEnvelope = {
  data: Array<InvoiceCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InvoiceCreateManySentByInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  status?: Maybe<InvoiceStatus>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateManySentByInputEnvelope = {
  data: Array<InvoiceCreateManySentByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InvoiceCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InvoiceCreateManyClinicPetParentInputEnvelope>;
};

export type InvoiceCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<InvoiceCreateManyIntegrationInputEnvelope>;
};

export type InvoiceCreateNestedManyWithoutSentByInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutSentByInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutSentByInput>>;
  createMany?: Maybe<InvoiceCreateManySentByInputEnvelope>;
};

export type InvoiceCreateNestedManyWithoutStripePaymentIntentsInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutStripePaymentIntentsInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutStripePaymentIntentsInput>>;
};

export type InvoiceCreateNestedOneWithoutAssociatedCareBenefitCreditsInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutAssociatedCareBenefitCreditsInput>;
  create?: Maybe<InvoiceCreateWithoutAssociatedCareBenefitCreditsInput>;
};

export type InvoiceCreateNestedOneWithoutCareAccountCreditIntentsInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutCareAccountCreditIntentsInput>;
  create?: Maybe<InvoiceCreateWithoutCareAccountCreditIntentsInput>;
};

export type InvoiceCreateNestedOneWithoutLineItemsInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutLineItemsInput>;
  create?: Maybe<InvoiceCreateWithoutLineItemsInput>;
};

export type InvoiceCreateNestedOneWithoutLoyaltyPointDeltasInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutLoyaltyPointDeltasInput>;
  create?: Maybe<InvoiceCreateWithoutLoyaltyPointDeltasInput>;
};

export type InvoiceCreateNestedOneWithoutPimsInvoiceInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutPimsInvoiceInput>;
  create?: Maybe<InvoiceCreateWithoutPimsInvoiceInput>;
};

export type InvoiceCreateNestedOneWithoutRelatedInvoiceWritebacksInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutRelatedInvoiceWritebacksInput>;
  create?: Maybe<InvoiceCreateWithoutRelatedInvoiceWritebacksInput>;
};

export type InvoiceCreateNestedOneWithoutServicePurchaseSummariesInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutServicePurchaseSummariesInput>;
  create?: Maybe<InvoiceCreateWithoutServicePurchaseSummariesInput>;
};

export type InvoiceCreateOrConnectWithoutAssociatedCareBenefitCreditsInput = {
  create: InvoiceCreateWithoutAssociatedCareBenefitCreditsInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceCreateOrConnectWithoutCareAccountCreditIntentsInput = {
  create: InvoiceCreateWithoutCareAccountCreditIntentsInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceCreateOrConnectWithoutClinicPetParentInput = {
  create: InvoiceCreateWithoutClinicPetParentInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceCreateOrConnectWithoutIntegrationInput = {
  create: InvoiceCreateWithoutIntegrationInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceCreateOrConnectWithoutLineItemsInput = {
  create: InvoiceCreateWithoutLineItemsInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceCreateOrConnectWithoutLoyaltyPointDeltasInput = {
  create: InvoiceCreateWithoutLoyaltyPointDeltasInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceCreateOrConnectWithoutPimsInvoiceInput = {
  create: InvoiceCreateWithoutPimsInvoiceInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceCreateOrConnectWithoutRelatedInvoiceWritebacksInput = {
  create: InvoiceCreateWithoutRelatedInvoiceWritebacksInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceCreateOrConnectWithoutSentByInput = {
  create: InvoiceCreateWithoutSentByInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceCreateOrConnectWithoutServicePurchaseSummariesInput = {
  create: InvoiceCreateWithoutServicePurchaseSummariesInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceCreateOrConnectWithoutStripePaymentIntentsInput = {
  create: InvoiceCreateWithoutStripePaymentIntentsInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceCreateWithoutAssociatedCareBenefitCreditsInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutInvoiceInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInvoicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutInvoicesInput>;
  lineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryCreateNestedManyWithoutInvoiceInput>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentInvoicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateWithoutCareAccountCreditIntentsInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutAssociatedInvoiceInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInvoicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutInvoicesInput>;
  lineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryCreateNestedManyWithoutInvoiceInput>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentInvoicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateWithoutClinicPetParentInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutInvoiceInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutInvoicesInput>;
  lineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryCreateNestedManyWithoutInvoiceInput>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentInvoicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateWithoutIntegrationInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutInvoiceInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInvoicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryCreateNestedManyWithoutInvoiceInput>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentInvoicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateWithoutLineItemsInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutInvoiceInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInvoicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutInvoicesInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryCreateNestedManyWithoutInvoiceInput>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentInvoicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateWithoutLoyaltyPointDeltasInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutInvoiceInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInvoicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutInvoicesInput>;
  lineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryCreateNestedManyWithoutInvoiceInput>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentInvoicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateWithoutPimsInvoiceInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutInvoiceInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInvoicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutInvoicesInput>;
  lineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryCreateNestedManyWithoutInvoiceInput>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentInvoicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateWithoutRelatedInvoiceWritebacksInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutInvoiceInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInvoicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutInvoicesInput>;
  lineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceCreateNestedOneWithoutInvoiceInput>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentInvoicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateWithoutSentByInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutInvoiceInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInvoicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutInvoicesInput>;
  lineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryCreateNestedManyWithoutInvoiceInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateWithoutServicePurchaseSummariesInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutInvoiceInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInvoicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutInvoicesInput>;
  lineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryCreateNestedManyWithoutInvoiceInput>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentInvoicesInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceCreateWithoutStripePaymentIntentsInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentCreateNestedManyWithoutInvoiceInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutInvoicesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutInvoicesInput>;
  lineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryCreateNestedManyWithoutInvoiceInput>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentInvoicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceGroupByOutputType = {
  __typename?: 'InvoiceGroupByOutputType';
  _avg?: Maybe<InvoiceAvgAggregateOutputType>;
  _count?: Maybe<InvoiceCountAggregateOutputType>;
  _max?: Maybe<InvoiceMaxAggregateOutputType>;
  _min?: Maybe<InvoiceMinAggregateOutputType>;
  _sum?: Maybe<InvoiceSumAggregateOutputType>;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: Currency;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  outstandingBalance: Scalars['Int'];
  sentByUserId?: Maybe<Scalars['String']>;
  status: InvoiceStatus;
  subtotal: Scalars['Int'];
  taxes: Scalars['Int'];
  total: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  AutomationRun: Array<AutomationRun>;
  _count: InvoiceLineItemCountOutputType;
  amount: Scalars['Int'];
  clinicPets: Array<ClinicPet>;
  connectedCareBenefits: Array<CareBenefitUsageToInvoiceLineItem>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredBy?: Maybe<ClinicEmployee>;
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id: Scalars['String'];
  invoice: Invoice;
  invoiceId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isTaxable: Scalars['Boolean'];
  isVoided: Scalars['Boolean'];
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItem>;
  provider?: Maybe<ClinicEmployee>;
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  service?: Maybe<Service>;
  serviceId?: Maybe<Scalars['String']>;
  /** The time field is the time the item was added (or service was rendered for PIMS-managed invoices) */
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt: Scalars['DateTime'];
};


export type InvoiceLineItemAutomationRunArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type InvoiceLineItemClinicPetsArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type InvoiceLineItemConnectedCareBenefitsArgs = {
  cursor?: Maybe<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
};


export type InvoiceLineItemEnteredByArgs = {
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type InvoiceLineItemPimsInvoiceLineItemArgs = {
  where?: Maybe<PimsInvoiceLineItemWhereInput>;
};


export type InvoiceLineItemProviderArgs = {
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type InvoiceLineItemServiceArgs = {
  where?: Maybe<ServiceWhereInput>;
};

export type InvoiceLineItemAvgAggregateOutputType = {
  __typename?: 'InvoiceLineItemAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  lineNumber?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

export type InvoiceLineItemAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  fee?: Maybe<SortOrder>;
  lineNumber?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
};

export type InvoiceLineItemCountAggregateOutputType = {
  __typename?: 'InvoiceLineItemCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  discount: Scalars['Int'];
  enteredById: Scalars['Int'];
  fee: Scalars['Int'];
  id: Scalars['Int'];
  invoiceId: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isHidden: Scalars['Int'];
  isTaxable: Scalars['Int'];
  isVoided: Scalars['Int'];
  lineNumber: Scalars['Int'];
  providerId: Scalars['Int'];
  quantity: Scalars['Int'];
  serviceId: Scalars['Int'];
  time: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InvoiceLineItemCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  enteredById?: Maybe<SortOrder>;
  fee?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isHidden?: Maybe<SortOrder>;
  isTaxable?: Maybe<SortOrder>;
  isVoided?: Maybe<SortOrder>;
  lineNumber?: Maybe<SortOrder>;
  providerId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InvoiceLineItemCountOutputType = {
  __typename?: 'InvoiceLineItemCountOutputType';
  AutomationRun: Scalars['Int'];
  clinicPets: Scalars['Int'];
  connectedCareBenefits: Scalars['Int'];
};

export type InvoiceLineItemCreateInput = {
  AutomationRun?: Maybe<AutomationRunCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutEnteredByInvoiceLineItemsInput>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoice: InvoiceCreateNestedOneWithoutLineItemsInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemCreateNestedOneWithoutInvoiceLineItemInput>;
  provider?: Maybe<ClinicEmployeeCreateNestedOneWithoutProviderInvoiceLineItemsInput>;
  quantity: Scalars['Float'];
  service?: Maybe<ServiceCreateNestedOneWithoutInvoiceLineItemsInput>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateManyEnteredByInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateManyEnteredByInputEnvelope = {
  data: Array<InvoiceLineItemCreateManyEnteredByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InvoiceLineItemCreateManyInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateManyInvoiceInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateManyInvoiceInputEnvelope = {
  data: Array<InvoiceLineItemCreateManyInvoiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InvoiceLineItemCreateManyProviderInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateManyProviderInputEnvelope = {
  data: Array<InvoiceLineItemCreateManyProviderInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InvoiceLineItemCreateManyServiceInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateManyServiceInputEnvelope = {
  data: Array<InvoiceLineItemCreateManyServiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InvoiceLineItemCreateNestedManyWithoutClinicPetsInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutClinicPetsInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutClinicPetsInput>>;
};

export type InvoiceLineItemCreateNestedManyWithoutEnteredByInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutEnteredByInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutEnteredByInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyEnteredByInputEnvelope>;
};

export type InvoiceLineItemCreateNestedManyWithoutInvoiceInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutInvoiceInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyInvoiceInputEnvelope>;
};

export type InvoiceLineItemCreateNestedManyWithoutProviderInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutProviderInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutProviderInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyProviderInputEnvelope>;
};

export type InvoiceLineItemCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutServiceInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyServiceInputEnvelope>;
};

export type InvoiceLineItemCreateNestedOneWithoutAutomationRunInput = {
  connect?: Maybe<InvoiceLineItemWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceLineItemCreateOrConnectWithoutAutomationRunInput>;
  create?: Maybe<InvoiceLineItemCreateWithoutAutomationRunInput>;
};

export type InvoiceLineItemCreateNestedOneWithoutConnectedCareBenefitsInput = {
  connect?: Maybe<InvoiceLineItemWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceLineItemCreateOrConnectWithoutConnectedCareBenefitsInput>;
  create?: Maybe<InvoiceLineItemCreateWithoutConnectedCareBenefitsInput>;
};

export type InvoiceLineItemCreateNestedOneWithoutPimsInvoiceLineItemInput = {
  connect?: Maybe<InvoiceLineItemWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceLineItemCreateOrConnectWithoutPimsInvoiceLineItemInput>;
  create?: Maybe<InvoiceLineItemCreateWithoutPimsInvoiceLineItemInput>;
};

export type InvoiceLineItemCreateOrConnectWithoutAutomationRunInput = {
  create: InvoiceLineItemCreateWithoutAutomationRunInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemCreateOrConnectWithoutClinicPetsInput = {
  create: InvoiceLineItemCreateWithoutClinicPetsInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemCreateOrConnectWithoutConnectedCareBenefitsInput = {
  create: InvoiceLineItemCreateWithoutConnectedCareBenefitsInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemCreateOrConnectWithoutEnteredByInput = {
  create: InvoiceLineItemCreateWithoutEnteredByInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemCreateOrConnectWithoutInvoiceInput = {
  create: InvoiceLineItemCreateWithoutInvoiceInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemCreateOrConnectWithoutPimsInvoiceLineItemInput = {
  create: InvoiceLineItemCreateWithoutPimsInvoiceLineItemInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemCreateOrConnectWithoutProviderInput = {
  create: InvoiceLineItemCreateWithoutProviderInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemCreateOrConnectWithoutServiceInput = {
  create: InvoiceLineItemCreateWithoutServiceInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemCreateWithoutAutomationRunInput = {
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutEnteredByInvoiceLineItemsInput>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoice: InvoiceCreateNestedOneWithoutLineItemsInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemCreateNestedOneWithoutInvoiceLineItemInput>;
  provider?: Maybe<ClinicEmployeeCreateNestedOneWithoutProviderInvoiceLineItemsInput>;
  quantity: Scalars['Float'];
  service?: Maybe<ServiceCreateNestedOneWithoutInvoiceLineItemsInput>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateWithoutClinicPetsInput = {
  AutomationRun?: Maybe<AutomationRunCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutEnteredByInvoiceLineItemsInput>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoice: InvoiceCreateNestedOneWithoutLineItemsInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemCreateNestedOneWithoutInvoiceLineItemInput>;
  provider?: Maybe<ClinicEmployeeCreateNestedOneWithoutProviderInvoiceLineItemsInput>;
  quantity: Scalars['Float'];
  service?: Maybe<ServiceCreateNestedOneWithoutInvoiceLineItemsInput>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateWithoutConnectedCareBenefitsInput = {
  AutomationRun?: Maybe<AutomationRunCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutInvoiceLineItemsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutEnteredByInvoiceLineItemsInput>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoice: InvoiceCreateNestedOneWithoutLineItemsInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemCreateNestedOneWithoutInvoiceLineItemInput>;
  provider?: Maybe<ClinicEmployeeCreateNestedOneWithoutProviderInvoiceLineItemsInput>;
  quantity: Scalars['Float'];
  service?: Maybe<ServiceCreateNestedOneWithoutInvoiceLineItemsInput>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateWithoutEnteredByInput = {
  AutomationRun?: Maybe<AutomationRunCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoice: InvoiceCreateNestedOneWithoutLineItemsInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemCreateNestedOneWithoutInvoiceLineItemInput>;
  provider?: Maybe<ClinicEmployeeCreateNestedOneWithoutProviderInvoiceLineItemsInput>;
  quantity: Scalars['Float'];
  service?: Maybe<ServiceCreateNestedOneWithoutInvoiceLineItemsInput>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateWithoutInvoiceInput = {
  AutomationRun?: Maybe<AutomationRunCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutEnteredByInvoiceLineItemsInput>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemCreateNestedOneWithoutInvoiceLineItemInput>;
  provider?: Maybe<ClinicEmployeeCreateNestedOneWithoutProviderInvoiceLineItemsInput>;
  quantity: Scalars['Float'];
  service?: Maybe<ServiceCreateNestedOneWithoutInvoiceLineItemsInput>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateWithoutPimsInvoiceLineItemInput = {
  AutomationRun?: Maybe<AutomationRunCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutEnteredByInvoiceLineItemsInput>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoice: InvoiceCreateNestedOneWithoutLineItemsInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  provider?: Maybe<ClinicEmployeeCreateNestedOneWithoutProviderInvoiceLineItemsInput>;
  quantity: Scalars['Float'];
  service?: Maybe<ServiceCreateNestedOneWithoutInvoiceLineItemsInput>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateWithoutProviderInput = {
  AutomationRun?: Maybe<AutomationRunCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutEnteredByInvoiceLineItemsInput>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoice: InvoiceCreateNestedOneWithoutLineItemsInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemCreateNestedOneWithoutInvoiceLineItemInput>;
  quantity: Scalars['Float'];
  service?: Maybe<ServiceCreateNestedOneWithoutInvoiceLineItemsInput>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemCreateWithoutServiceInput = {
  AutomationRun?: Maybe<AutomationRunCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredBy?: Maybe<ClinicEmployeeCreateNestedOneWithoutEnteredByInvoiceLineItemsInput>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoice: InvoiceCreateNestedOneWithoutLineItemsInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemCreateNestedOneWithoutInvoiceLineItemInput>;
  provider?: Maybe<ClinicEmployeeCreateNestedOneWithoutProviderInvoiceLineItemsInput>;
  quantity: Scalars['Float'];
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemGroupByOutputType = {
  __typename?: 'InvoiceLineItemGroupByOutputType';
  _avg?: Maybe<InvoiceLineItemAvgAggregateOutputType>;
  _count?: Maybe<InvoiceLineItemCountAggregateOutputType>;
  _max?: Maybe<InvoiceLineItemMaxAggregateOutputType>;
  _min?: Maybe<InvoiceLineItemMinAggregateOutputType>;
  _sum?: Maybe<InvoiceLineItemSumAggregateOutputType>;
  amount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id: Scalars['String'];
  invoiceId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isTaxable: Scalars['Boolean'];
  isVoided: Scalars['Boolean'];
  lineNumber: Scalars['Int'];
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt: Scalars['DateTime'];
};

export type InvoiceLineItemListRelationFilter = {
  every?: Maybe<InvoiceLineItemWhereInput>;
  none?: Maybe<InvoiceLineItemWhereInput>;
  some?: Maybe<InvoiceLineItemWhereInput>;
};

export type InvoiceLineItemMaxAggregateOutputType = {
  __typename?: 'InvoiceLineItemMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  enteredById?: Maybe<SortOrder>;
  fee?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isHidden?: Maybe<SortOrder>;
  isTaxable?: Maybe<SortOrder>;
  isVoided?: Maybe<SortOrder>;
  lineNumber?: Maybe<SortOrder>;
  providerId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InvoiceLineItemMinAggregateOutputType = {
  __typename?: 'InvoiceLineItemMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  enteredById?: Maybe<SortOrder>;
  fee?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isHidden?: Maybe<SortOrder>;
  isTaxable?: Maybe<SortOrder>;
  isVoided?: Maybe<SortOrder>;
  lineNumber?: Maybe<SortOrder>;
  providerId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InvoiceLineItemNullableScalarRelationFilter = {
  AND?: Maybe<Array<InvoiceLineItemWhereInput>>;
  AutomationRun?: Maybe<AutomationRunListRelationFilter>;
  NOT?: Maybe<Array<InvoiceLineItemWhereInput>>;
  OR?: Maybe<Array<InvoiceLineItemWhereInput>>;
  amount?: Maybe<IntFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  discount?: Maybe<IntFilter>;
  enteredBy?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  enteredById?: Maybe<StringNullableFilter>;
  fee?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isHidden?: Maybe<BoolFilter>;
  isTaxable?: Maybe<BoolFilter>;
  isVoided?: Maybe<BoolFilter>;
  lineNumber?: Maybe<IntFilter>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemNullableScalarRelationFilter>;
  provider?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  providerId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<FloatFilter>;
  service?: Maybe<ServiceNullableScalarRelationFilter>;
  serviceId?: Maybe<StringNullableFilter>;
  time?: Maybe<DateTimeNullableFilter>;
  type?: Maybe<EnumInvoiceLineItemTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InvoiceLineItemOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InvoiceLineItemOrderByRelationAndSearchRelevanceInput = {
  AutomationRun?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  _relevance?: Maybe<InvoiceLineItemOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  clinicPets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  enteredBy?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  enteredById?: Maybe<SortOrder>;
  fee?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isHidden?: Maybe<SortOrder>;
  isTaxable?: Maybe<SortOrder>;
  isVoided?: Maybe<SortOrder>;
  lineNumber?: Maybe<SortOrder>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemOrderByWithRelationInput>;
  provider?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  providerId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InvoiceLineItemOrderByRelevanceFieldEnum {
  Description = 'description',
  EnteredById = 'enteredById',
  Id = 'id',
  InvoiceId = 'invoiceId',
  ProviderId = 'providerId',
  ServiceId = 'serviceId'
}

export type InvoiceLineItemOrderByRelevanceInput = {
  fields: Array<InvoiceLineItemOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InvoiceLineItemOrderByWithAggregationInput = {
  _avg?: Maybe<InvoiceLineItemAvgOrderByAggregateInput>;
  _count?: Maybe<InvoiceLineItemCountOrderByAggregateInput>;
  _max?: Maybe<InvoiceLineItemMaxOrderByAggregateInput>;
  _min?: Maybe<InvoiceLineItemMinOrderByAggregateInput>;
  _sum?: Maybe<InvoiceLineItemSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  enteredById?: Maybe<SortOrder>;
  fee?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isHidden?: Maybe<SortOrder>;
  isTaxable?: Maybe<SortOrder>;
  isVoided?: Maybe<SortOrder>;
  lineNumber?: Maybe<SortOrder>;
  providerId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InvoiceLineItemOrderByWithRelationAndSearchRelevanceInput = {
  AutomationRun?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  _relevance?: Maybe<InvoiceLineItemOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  clinicPets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  enteredBy?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  enteredById?: Maybe<SortOrder>;
  fee?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isHidden?: Maybe<SortOrder>;
  isTaxable?: Maybe<SortOrder>;
  isVoided?: Maybe<SortOrder>;
  lineNumber?: Maybe<SortOrder>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemOrderByWithRelationInput>;
  provider?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  providerId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InvoiceLineItemOrderByWithRelationInput = {
  AutomationRun?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  _relevance?: Maybe<InvoiceLineItemOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  clinicPets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  enteredBy?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  enteredById?: Maybe<SortOrder>;
  fee?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isHidden?: Maybe<SortOrder>;
  isTaxable?: Maybe<SortOrder>;
  isVoided?: Maybe<SortOrder>;
  lineNumber?: Maybe<SortOrder>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemOrderByWithRelationInput>;
  provider?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  providerId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InvoiceLineItemScalarFieldEnum {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Description = 'description',
  Discount = 'discount',
  EnteredById = 'enteredById',
  Fee = 'fee',
  Id = 'id',
  InvoiceId = 'invoiceId',
  IsDeleted = 'isDeleted',
  IsHidden = 'isHidden',
  IsTaxable = 'isTaxable',
  IsVoided = 'isVoided',
  LineNumber = 'lineNumber',
  ProviderId = 'providerId',
  Quantity = 'quantity',
  ServiceId = 'serviceId',
  Time = 'time',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type InvoiceLineItemScalarRelationFilter = {
  AND?: Maybe<Array<InvoiceLineItemWhereInput>>;
  AutomationRun?: Maybe<AutomationRunListRelationFilter>;
  NOT?: Maybe<Array<InvoiceLineItemWhereInput>>;
  OR?: Maybe<Array<InvoiceLineItemWhereInput>>;
  amount?: Maybe<IntFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  discount?: Maybe<IntFilter>;
  enteredBy?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  enteredById?: Maybe<StringNullableFilter>;
  fee?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isHidden?: Maybe<BoolFilter>;
  isTaxable?: Maybe<BoolFilter>;
  isVoided?: Maybe<BoolFilter>;
  lineNumber?: Maybe<IntFilter>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemNullableScalarRelationFilter>;
  provider?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  providerId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<FloatFilter>;
  service?: Maybe<ServiceNullableScalarRelationFilter>;
  serviceId?: Maybe<StringNullableFilter>;
  time?: Maybe<DateTimeNullableFilter>;
  type?: Maybe<EnumInvoiceLineItemTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InvoiceLineItemScalarWhereInput = {
  AND?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  NOT?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  OR?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  amount?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  discount?: Maybe<IntFilter>;
  enteredById?: Maybe<StringNullableFilter>;
  fee?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  invoiceId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isHidden?: Maybe<BoolFilter>;
  isTaxable?: Maybe<BoolFilter>;
  isVoided?: Maybe<BoolFilter>;
  lineNumber?: Maybe<IntFilter>;
  providerId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<FloatFilter>;
  serviceId?: Maybe<StringNullableFilter>;
  time?: Maybe<DateTimeNullableFilter>;
  type?: Maybe<EnumInvoiceLineItemTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InvoiceLineItemScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InvoiceLineItemScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InvoiceLineItemScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InvoiceLineItemScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  discount?: Maybe<IntWithAggregatesFilter>;
  enteredById?: Maybe<StringNullableWithAggregatesFilter>;
  fee?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  invoiceId?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  isHidden?: Maybe<BoolWithAggregatesFilter>;
  isTaxable?: Maybe<BoolWithAggregatesFilter>;
  isVoided?: Maybe<BoolWithAggregatesFilter>;
  lineNumber?: Maybe<IntWithAggregatesFilter>;
  providerId?: Maybe<StringNullableWithAggregatesFilter>;
  quantity?: Maybe<FloatWithAggregatesFilter>;
  serviceId?: Maybe<StringNullableWithAggregatesFilter>;
  time?: Maybe<DateTimeNullableWithAggregatesFilter>;
  type?: Maybe<EnumInvoiceLineItemTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type InvoiceLineItemSumAggregateOutputType = {
  __typename?: 'InvoiceLineItemSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Int']>;
  fee?: Maybe<Scalars['Int']>;
  lineNumber?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Float']>;
};

export type InvoiceLineItemSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  fee?: Maybe<SortOrder>;
  lineNumber?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
};

export enum InvoiceLineItemType {
  Adjustment = 'adjustment',
  Code = 'code',
  Discount = 'discount',
  Estimate = 'estimate',
  Fee = 'fee',
  Note = 'note',
  Payment = 'payment',
  Return = 'return',
  Tax = 'tax',
  Unknown = 'unknown',
  Writeoff = 'writeoff'
}

export type InvoiceLineItemUncheckedCreateInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedOneWithoutInvoiceLineItemInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedCreateNestedManyWithoutClinicPetsInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutClinicPetsInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutClinicPetsInput>>;
};

export type InvoiceLineItemUncheckedCreateNestedManyWithoutEnteredByInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutEnteredByInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutEnteredByInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyEnteredByInputEnvelope>;
};

export type InvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutInvoiceInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyInvoiceInputEnvelope>;
};

export type InvoiceLineItemUncheckedCreateNestedManyWithoutProviderInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutProviderInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutProviderInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyProviderInputEnvelope>;
};

export type InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutServiceInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyServiceInputEnvelope>;
};

export type InvoiceLineItemUncheckedCreateWithoutAutomationRunInput = {
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedOneWithoutInvoiceLineItemInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedCreateWithoutClinicPetsInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedOneWithoutInvoiceLineItemInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedCreateWithoutConnectedCareBenefitsInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutInvoiceLineItemsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedOneWithoutInvoiceLineItemInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedCreateWithoutEnteredByInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedOneWithoutInvoiceLineItemInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedCreateWithoutInvoiceInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedOneWithoutInvoiceLineItemInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedCreateWithoutPimsInvoiceLineItemInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedCreateWithoutProviderInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedOneWithoutInvoiceLineItemInput>;
  quantity: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedCreateWithoutServiceInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutInvioceLineItemInput>;
  amount: Scalars['Int'];
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutInvoiceLineItemsInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceLineItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  discount: Scalars['Int'];
  enteredById?: Maybe<Scalars['String']>;
  fee: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedCreateNestedOneWithoutInvoiceLineItemInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  time?: Maybe<Scalars['DateTime']>;
  type: InvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedUpdateOneWithoutInvoiceLineItemNestedInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateManyWithoutClinicPetsNestedInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutClinicPetsInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutClinicPetsInput>>;
  delete?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceLineItemUpdateWithWhereUniqueWithoutClinicPetsInput>>;
  updateMany?: Maybe<Array<InvoiceLineItemUpdateManyWithWhereWithoutClinicPetsInput>>;
  upsert?: Maybe<Array<InvoiceLineItemUpsertWithWhereUniqueWithoutClinicPetsInput>>;
};

export type InvoiceLineItemUncheckedUpdateManyWithoutEnteredByInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateManyWithoutEnteredByNestedInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutEnteredByInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutEnteredByInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyEnteredByInputEnvelope>;
  delete?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceLineItemUpdateWithWhereUniqueWithoutEnteredByInput>>;
  updateMany?: Maybe<Array<InvoiceLineItemUpdateManyWithWhereWithoutEnteredByInput>>;
  upsert?: Maybe<Array<InvoiceLineItemUpsertWithWhereUniqueWithoutEnteredByInput>>;
};

export type InvoiceLineItemUncheckedUpdateManyWithoutInvoiceInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateManyWithoutInvoiceNestedInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutInvoiceInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyInvoiceInputEnvelope>;
  delete?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceLineItemUpdateWithWhereUniqueWithoutInvoiceInput>>;
  updateMany?: Maybe<Array<InvoiceLineItemUpdateManyWithWhereWithoutInvoiceInput>>;
  upsert?: Maybe<Array<InvoiceLineItemUpsertWithWhereUniqueWithoutInvoiceInput>>;
};

export type InvoiceLineItemUncheckedUpdateManyWithoutProviderInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateManyWithoutProviderNestedInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutProviderInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutProviderInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyProviderInputEnvelope>;
  delete?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceLineItemUpdateWithWhereUniqueWithoutProviderInput>>;
  updateMany?: Maybe<Array<InvoiceLineItemUpdateManyWithWhereWithoutProviderInput>>;
  upsert?: Maybe<Array<InvoiceLineItemUpsertWithWhereUniqueWithoutProviderInput>>;
};

export type InvoiceLineItemUncheckedUpdateManyWithoutServiceInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutServiceInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceLineItemUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<InvoiceLineItemUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<InvoiceLineItemUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type InvoiceLineItemUncheckedUpdateWithoutAutomationRunInput = {
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedUpdateOneWithoutInvoiceLineItemNestedInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateWithoutClinicPetsInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedUpdateOneWithoutInvoiceLineItemNestedInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateWithoutConnectedCareBenefitsInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutInvoiceLineItemsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedUpdateOneWithoutInvoiceLineItemNestedInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateWithoutEnteredByInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedUpdateOneWithoutInvoiceLineItemNestedInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateWithoutInvoiceInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedUpdateOneWithoutInvoiceLineItemNestedInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateWithoutPimsInvoiceLineItemInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateWithoutProviderInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedUpdateOneWithoutInvoiceLineItemNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUncheckedUpdateWithoutServiceInput = {
  AutomationRun?: Maybe<AutomationRunUncheckedUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredById?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUncheckedUpdateOneWithoutInvoiceLineItemNestedInput>;
  providerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUpdateInput = {
  AutomationRun?: Maybe<AutomationRunUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutEnteredByInvoiceLineItemsNestedInput>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutLineItemsNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUpdateOneWithoutInvoiceLineItemNestedInput>;
  provider?: Maybe<ClinicEmployeeUpdateOneWithoutProviderInvoiceLineItemsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneWithoutInvoiceLineItemsNestedInput>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Float']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUpdateManyWithWhereWithoutClinicPetsInput = {
  data: InvoiceLineItemUpdateManyMutationInput;
  where: InvoiceLineItemScalarWhereInput;
};

export type InvoiceLineItemUpdateManyWithWhereWithoutEnteredByInput = {
  data: InvoiceLineItemUpdateManyMutationInput;
  where: InvoiceLineItemScalarWhereInput;
};

export type InvoiceLineItemUpdateManyWithWhereWithoutInvoiceInput = {
  data: InvoiceLineItemUpdateManyMutationInput;
  where: InvoiceLineItemScalarWhereInput;
};

export type InvoiceLineItemUpdateManyWithWhereWithoutProviderInput = {
  data: InvoiceLineItemUpdateManyMutationInput;
  where: InvoiceLineItemScalarWhereInput;
};

export type InvoiceLineItemUpdateManyWithWhereWithoutServiceInput = {
  data: InvoiceLineItemUpdateManyMutationInput;
  where: InvoiceLineItemScalarWhereInput;
};

export type InvoiceLineItemUpdateManyWithoutClinicPetsNestedInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutClinicPetsInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutClinicPetsInput>>;
  delete?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceLineItemUpdateWithWhereUniqueWithoutClinicPetsInput>>;
  updateMany?: Maybe<Array<InvoiceLineItemUpdateManyWithWhereWithoutClinicPetsInput>>;
  upsert?: Maybe<Array<InvoiceLineItemUpsertWithWhereUniqueWithoutClinicPetsInput>>;
};

export type InvoiceLineItemUpdateManyWithoutEnteredByNestedInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutEnteredByInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutEnteredByInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyEnteredByInputEnvelope>;
  delete?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceLineItemUpdateWithWhereUniqueWithoutEnteredByInput>>;
  updateMany?: Maybe<Array<InvoiceLineItemUpdateManyWithWhereWithoutEnteredByInput>>;
  upsert?: Maybe<Array<InvoiceLineItemUpsertWithWhereUniqueWithoutEnteredByInput>>;
};

export type InvoiceLineItemUpdateManyWithoutInvoiceNestedInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutInvoiceInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyInvoiceInputEnvelope>;
  delete?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceLineItemUpdateWithWhereUniqueWithoutInvoiceInput>>;
  updateMany?: Maybe<Array<InvoiceLineItemUpdateManyWithWhereWithoutInvoiceInput>>;
  upsert?: Maybe<Array<InvoiceLineItemUpsertWithWhereUniqueWithoutInvoiceInput>>;
};

export type InvoiceLineItemUpdateManyWithoutProviderNestedInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutProviderInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutProviderInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyProviderInputEnvelope>;
  delete?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceLineItemUpdateWithWhereUniqueWithoutProviderInput>>;
  updateMany?: Maybe<Array<InvoiceLineItemUpdateManyWithWhereWithoutProviderInput>>;
  upsert?: Maybe<Array<InvoiceLineItemUpsertWithWhereUniqueWithoutProviderInput>>;
};

export type InvoiceLineItemUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceLineItemCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<InvoiceLineItemCreateWithoutServiceInput>>;
  createMany?: Maybe<InvoiceLineItemCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceLineItemUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<InvoiceLineItemUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<InvoiceLineItemUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type InvoiceLineItemUpdateOneRequiredWithoutPimsInvoiceLineItemNestedInput = {
  connect?: Maybe<InvoiceLineItemWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceLineItemCreateOrConnectWithoutPimsInvoiceLineItemInput>;
  create?: Maybe<InvoiceLineItemCreateWithoutPimsInvoiceLineItemInput>;
  update?: Maybe<InvoiceLineItemUpdateToOneWithWhereWithoutPimsInvoiceLineItemInput>;
  upsert?: Maybe<InvoiceLineItemUpsertWithoutPimsInvoiceLineItemInput>;
};

export type InvoiceLineItemUpdateOneWithoutAutomationRunNestedInput = {
  connect?: Maybe<InvoiceLineItemWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceLineItemCreateOrConnectWithoutAutomationRunInput>;
  create?: Maybe<InvoiceLineItemCreateWithoutAutomationRunInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InvoiceLineItemUpdateToOneWithWhereWithoutAutomationRunInput>;
  upsert?: Maybe<InvoiceLineItemUpsertWithoutAutomationRunInput>;
};

export type InvoiceLineItemUpdateOneWithoutConnectedCareBenefitsNestedInput = {
  connect?: Maybe<InvoiceLineItemWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceLineItemCreateOrConnectWithoutConnectedCareBenefitsInput>;
  create?: Maybe<InvoiceLineItemCreateWithoutConnectedCareBenefitsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InvoiceLineItemUpdateToOneWithWhereWithoutConnectedCareBenefitsInput>;
  upsert?: Maybe<InvoiceLineItemUpsertWithoutConnectedCareBenefitsInput>;
};

export type InvoiceLineItemUpdateToOneWithWhereWithoutAutomationRunInput = {
  data: InvoiceLineItemUpdateWithoutAutomationRunInput;
  where?: Maybe<InvoiceLineItemWhereInput>;
};

export type InvoiceLineItemUpdateToOneWithWhereWithoutConnectedCareBenefitsInput = {
  data: InvoiceLineItemUpdateWithoutConnectedCareBenefitsInput;
  where?: Maybe<InvoiceLineItemWhereInput>;
};

export type InvoiceLineItemUpdateToOneWithWhereWithoutPimsInvoiceLineItemInput = {
  data: InvoiceLineItemUpdateWithoutPimsInvoiceLineItemInput;
  where?: Maybe<InvoiceLineItemWhereInput>;
};

export type InvoiceLineItemUpdateWithWhereUniqueWithoutClinicPetsInput = {
  data: InvoiceLineItemUpdateWithoutClinicPetsInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemUpdateWithWhereUniqueWithoutEnteredByInput = {
  data: InvoiceLineItemUpdateWithoutEnteredByInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemUpdateWithWhereUniqueWithoutInvoiceInput = {
  data: InvoiceLineItemUpdateWithoutInvoiceInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemUpdateWithWhereUniqueWithoutProviderInput = {
  data: InvoiceLineItemUpdateWithoutProviderInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemUpdateWithWhereUniqueWithoutServiceInput = {
  data: InvoiceLineItemUpdateWithoutServiceInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemUpdateWithoutAutomationRunInput = {
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutEnteredByInvoiceLineItemsNestedInput>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutLineItemsNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUpdateOneWithoutInvoiceLineItemNestedInput>;
  provider?: Maybe<ClinicEmployeeUpdateOneWithoutProviderInvoiceLineItemsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneWithoutInvoiceLineItemsNestedInput>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUpdateWithoutClinicPetsInput = {
  AutomationRun?: Maybe<AutomationRunUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutEnteredByInvoiceLineItemsNestedInput>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutLineItemsNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUpdateOneWithoutInvoiceLineItemNestedInput>;
  provider?: Maybe<ClinicEmployeeUpdateOneWithoutProviderInvoiceLineItemsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneWithoutInvoiceLineItemsNestedInput>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUpdateWithoutConnectedCareBenefitsInput = {
  AutomationRun?: Maybe<AutomationRunUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutInvoiceLineItemsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutEnteredByInvoiceLineItemsNestedInput>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutLineItemsNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUpdateOneWithoutInvoiceLineItemNestedInput>;
  provider?: Maybe<ClinicEmployeeUpdateOneWithoutProviderInvoiceLineItemsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneWithoutInvoiceLineItemsNestedInput>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUpdateWithoutEnteredByInput = {
  AutomationRun?: Maybe<AutomationRunUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutLineItemsNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUpdateOneWithoutInvoiceLineItemNestedInput>;
  provider?: Maybe<ClinicEmployeeUpdateOneWithoutProviderInvoiceLineItemsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneWithoutInvoiceLineItemsNestedInput>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUpdateWithoutInvoiceInput = {
  AutomationRun?: Maybe<AutomationRunUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutEnteredByInvoiceLineItemsNestedInput>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUpdateOneWithoutInvoiceLineItemNestedInput>;
  provider?: Maybe<ClinicEmployeeUpdateOneWithoutProviderInvoiceLineItemsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneWithoutInvoiceLineItemsNestedInput>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUpdateWithoutPimsInvoiceLineItemInput = {
  AutomationRun?: Maybe<AutomationRunUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutEnteredByInvoiceLineItemsNestedInput>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutLineItemsNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  provider?: Maybe<ClinicEmployeeUpdateOneWithoutProviderInvoiceLineItemsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneWithoutInvoiceLineItemsNestedInput>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUpdateWithoutProviderInput = {
  AutomationRun?: Maybe<AutomationRunUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutEnteredByInvoiceLineItemsNestedInput>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutLineItemsNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUpdateOneWithoutInvoiceLineItemNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneWithoutInvoiceLineItemsNestedInput>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUpdateWithoutServiceInput = {
  AutomationRun?: Maybe<AutomationRunUpdateManyWithoutInvioceLineItemNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutInvoiceLineItemsNestedInput>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutInvoiceLineItemNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  enteredBy?: Maybe<ClinicEmployeeUpdateOneWithoutEnteredByInvoiceLineItemsNestedInput>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutLineItemsNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  isVoided?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['Int']>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemUpdateOneWithoutInvoiceLineItemNestedInput>;
  provider?: Maybe<ClinicEmployeeUpdateOneWithoutProviderInvoiceLineItemsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<InvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceLineItemUpsertWithWhereUniqueWithoutClinicPetsInput = {
  create: InvoiceLineItemCreateWithoutClinicPetsInput;
  update: InvoiceLineItemUpdateWithoutClinicPetsInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemUpsertWithWhereUniqueWithoutEnteredByInput = {
  create: InvoiceLineItemCreateWithoutEnteredByInput;
  update: InvoiceLineItemUpdateWithoutEnteredByInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemUpsertWithWhereUniqueWithoutInvoiceInput = {
  create: InvoiceLineItemCreateWithoutInvoiceInput;
  update: InvoiceLineItemUpdateWithoutInvoiceInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemUpsertWithWhereUniqueWithoutProviderInput = {
  create: InvoiceLineItemCreateWithoutProviderInput;
  update: InvoiceLineItemUpdateWithoutProviderInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemUpsertWithWhereUniqueWithoutServiceInput = {
  create: InvoiceLineItemCreateWithoutServiceInput;
  update: InvoiceLineItemUpdateWithoutServiceInput;
  where: InvoiceLineItemWhereUniqueInput;
};

export type InvoiceLineItemUpsertWithoutAutomationRunInput = {
  create: InvoiceLineItemCreateWithoutAutomationRunInput;
  update: InvoiceLineItemUpdateWithoutAutomationRunInput;
  where?: Maybe<InvoiceLineItemWhereInput>;
};

export type InvoiceLineItemUpsertWithoutConnectedCareBenefitsInput = {
  create: InvoiceLineItemCreateWithoutConnectedCareBenefitsInput;
  update: InvoiceLineItemUpdateWithoutConnectedCareBenefitsInput;
  where?: Maybe<InvoiceLineItemWhereInput>;
};

export type InvoiceLineItemUpsertWithoutPimsInvoiceLineItemInput = {
  create: InvoiceLineItemCreateWithoutPimsInvoiceLineItemInput;
  update: InvoiceLineItemUpdateWithoutPimsInvoiceLineItemInput;
  where?: Maybe<InvoiceLineItemWhereInput>;
};

export type InvoiceLineItemWhereInput = {
  AND?: Maybe<Array<InvoiceLineItemWhereInput>>;
  AutomationRun?: Maybe<AutomationRunListRelationFilter>;
  NOT?: Maybe<Array<InvoiceLineItemWhereInput>>;
  OR?: Maybe<Array<InvoiceLineItemWhereInput>>;
  amount?: Maybe<IntFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  discount?: Maybe<IntFilter>;
  enteredBy?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  enteredById?: Maybe<StringNullableFilter>;
  fee?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isHidden?: Maybe<BoolFilter>;
  isTaxable?: Maybe<BoolFilter>;
  isVoided?: Maybe<BoolFilter>;
  lineNumber?: Maybe<IntFilter>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemNullableScalarRelationFilter>;
  provider?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  providerId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<FloatFilter>;
  service?: Maybe<ServiceNullableScalarRelationFilter>;
  serviceId?: Maybe<StringNullableFilter>;
  time?: Maybe<DateTimeNullableFilter>;
  type?: Maybe<EnumInvoiceLineItemTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InvoiceLineItemWhereUniqueInput = {
  AND?: Maybe<Array<InvoiceLineItemWhereInput>>;
  AutomationRun?: Maybe<AutomationRunListRelationFilter>;
  NOT?: Maybe<Array<InvoiceLineItemWhereInput>>;
  OR?: Maybe<Array<InvoiceLineItemWhereInput>>;
  amount?: Maybe<IntFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  connectedCareBenefits?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  discount?: Maybe<IntFilter>;
  enteredBy?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  enteredById?: Maybe<StringNullableFilter>;
  fee?: Maybe<IntFilter>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isHidden?: Maybe<BoolFilter>;
  isTaxable?: Maybe<BoolFilter>;
  isVoided?: Maybe<BoolFilter>;
  lineNumber?: Maybe<IntFilter>;
  pimsInvoiceLineItem?: Maybe<PimsInvoiceLineItemNullableScalarRelationFilter>;
  provider?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  providerId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<FloatFilter>;
  service?: Maybe<ServiceNullableScalarRelationFilter>;
  serviceId?: Maybe<StringNullableFilter>;
  time?: Maybe<DateTimeNullableFilter>;
  type?: Maybe<EnumInvoiceLineItemTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InvoiceListRelationFilter = {
  every?: Maybe<InvoiceWhereInput>;
  none?: Maybe<InvoiceWhereInput>;
  some?: Maybe<InvoiceWhereInput>;
};

export type InvoiceMaxAggregateOutputType = {
  __typename?: 'InvoiceMaxAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  sentByUserId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceMaxOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  identifier?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  outstandingBalance?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subtotal?: Maybe<SortOrder>;
  taxes?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InvoiceMinAggregateOutputType = {
  __typename?: 'InvoiceMinAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  sentByUserId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceMinOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  identifier?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  outstandingBalance?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subtotal?: Maybe<SortOrder>;
  taxes?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InvoiceNullableScalarRelationFilter = {
  AND?: Maybe<Array<InvoiceWhereInput>>;
  NOT?: Maybe<Array<InvoiceWhereInput>>;
  OR?: Maybe<Array<InvoiceWhereInput>>;
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  date?: Maybe<DateTimeNullableFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  identifier?: Maybe<StringNullableFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  lineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  outstandingBalance?: Maybe<IntFilter>;
  pimsInvoice?: Maybe<PimsInvoiceNullableScalarRelationFilter>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryListRelationFilter>;
  sentBy?: Maybe<UserNullableScalarRelationFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  status?: Maybe<EnumInvoiceStatusFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  subtotal?: Maybe<IntFilter>;
  taxes?: Maybe<IntFilter>;
  total?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InvoiceOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InvoiceOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InvoiceOrderByRelevanceInput>;
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentOrderByRelationAggregateInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  identifier?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  lineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  outstandingBalance?: Maybe<SortOrder>;
  pimsInvoice?: Maybe<PimsInvoiceOrderByWithRelationInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryOrderByRelationAggregateInput>;
  sentBy?: Maybe<UserOrderByWithRelationInput>;
  sentByUserId?: Maybe<SortOrder>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  subtotal?: Maybe<SortOrder>;
  taxes?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InvoiceOrderByRelevanceFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  Description = 'description',
  Id = 'id',
  Identifier = 'identifier',
  IntegrationId = 'integrationId',
  SentByUserId = 'sentByUserId'
}

export type InvoiceOrderByRelevanceInput = {
  fields: Array<InvoiceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InvoiceOrderByWithAggregationInput = {
  _avg?: Maybe<InvoiceAvgOrderByAggregateInput>;
  _count?: Maybe<InvoiceCountOrderByAggregateInput>;
  _max?: Maybe<InvoiceMaxOrderByAggregateInput>;
  _min?: Maybe<InvoiceMinOrderByAggregateInput>;
  _sum?: Maybe<InvoiceSumOrderByAggregateInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  identifier?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  outstandingBalance?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subtotal?: Maybe<SortOrder>;
  taxes?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InvoiceOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InvoiceOrderByRelevanceInput>;
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentOrderByRelationAggregateInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  identifier?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  lineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  outstandingBalance?: Maybe<SortOrder>;
  pimsInvoice?: Maybe<PimsInvoiceOrderByWithRelationInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryOrderByRelationAggregateInput>;
  sentBy?: Maybe<UserOrderByWithRelationInput>;
  sentByUserId?: Maybe<SortOrder>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  subtotal?: Maybe<SortOrder>;
  taxes?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type InvoiceOrderByWithRelationInput = {
  _relevance?: Maybe<InvoiceOrderByRelevanceInput>;
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentOrderByRelationAggregateInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  identifier?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  lineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  outstandingBalance?: Maybe<SortOrder>;
  pimsInvoice?: Maybe<PimsInvoiceOrderByWithRelationInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryOrderByRelationAggregateInput>;
  sentBy?: Maybe<UserOrderByWithRelationInput>;
  sentByUserId?: Maybe<SortOrder>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  subtotal?: Maybe<SortOrder>;
  taxes?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum InvoicePimsWritebackAction {
  CareDiscountApplied = 'Care_Discount_Applied',
  PaymentCollected = 'Payment_Collected'
}

export type InvoicePimsWritebackLogEntry = {
  __typename?: 'InvoicePimsWritebackLogEntry';
  action: InvoicePimsWritebackAction;
  invoice: Invoice;
  invoiceId: Scalars['String'];
  writebackLog: PimsWritebackLogEntry;
  writebackLogId: Scalars['String'];
};

export type InvoicePimsWritebackLogEntryCountAggregateOutputType = {
  __typename?: 'InvoicePimsWritebackLogEntryCountAggregateOutputType';
  _all: Scalars['Int'];
  action: Scalars['Int'];
  invoiceId: Scalars['Int'];
  writebackLogId: Scalars['Int'];
};

export type InvoicePimsWritebackLogEntryCountOrderByAggregateInput = {
  action?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type InvoicePimsWritebackLogEntryCreateInput = {
  action: InvoicePimsWritebackAction;
  invoice: InvoiceCreateNestedOneWithoutRelatedInvoiceWritebacksInput;
  writebackLog: PimsWritebackLogEntryCreateNestedOneWithoutInvoiceLogInput;
};

export type InvoicePimsWritebackLogEntryCreateManyInput = {
  action: InvoicePimsWritebackAction;
  invoiceId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type InvoicePimsWritebackLogEntryCreateManyInvoiceInput = {
  action: InvoicePimsWritebackAction;
  writebackLogId: Scalars['String'];
};

export type InvoicePimsWritebackLogEntryCreateManyInvoiceInputEnvelope = {
  data: Array<InvoicePimsWritebackLogEntryCreateManyInvoiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type InvoicePimsWritebackLogEntryCreateNestedManyWithoutInvoiceInput = {
  connect?: Maybe<Array<InvoicePimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoicePimsWritebackLogEntryCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<InvoicePimsWritebackLogEntryCreateWithoutInvoiceInput>>;
  createMany?: Maybe<InvoicePimsWritebackLogEntryCreateManyInvoiceInputEnvelope>;
};

export type InvoicePimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput = {
  connect?: Maybe<InvoicePimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoicePimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<InvoicePimsWritebackLogEntryCreateWithoutWritebackLogInput>;
};

export type InvoicePimsWritebackLogEntryCreateOrConnectWithoutInvoiceInput = {
  create: InvoicePimsWritebackLogEntryCreateWithoutInvoiceInput;
  where: InvoicePimsWritebackLogEntryWhereUniqueInput;
};

export type InvoicePimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput = {
  create: InvoicePimsWritebackLogEntryCreateWithoutWritebackLogInput;
  where: InvoicePimsWritebackLogEntryWhereUniqueInput;
};

export type InvoicePimsWritebackLogEntryCreateWithoutInvoiceInput = {
  action: InvoicePimsWritebackAction;
  writebackLog: PimsWritebackLogEntryCreateNestedOneWithoutInvoiceLogInput;
};

export type InvoicePimsWritebackLogEntryCreateWithoutWritebackLogInput = {
  action: InvoicePimsWritebackAction;
  invoice: InvoiceCreateNestedOneWithoutRelatedInvoiceWritebacksInput;
};

export type InvoicePimsWritebackLogEntryGroupByOutputType = {
  __typename?: 'InvoicePimsWritebackLogEntryGroupByOutputType';
  _count?: Maybe<InvoicePimsWritebackLogEntryCountAggregateOutputType>;
  _max?: Maybe<InvoicePimsWritebackLogEntryMaxAggregateOutputType>;
  _min?: Maybe<InvoicePimsWritebackLogEntryMinAggregateOutputType>;
  action: InvoicePimsWritebackAction;
  invoiceId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type InvoicePimsWritebackLogEntryListRelationFilter = {
  every?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
  none?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
  some?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
};

export type InvoicePimsWritebackLogEntryMaxAggregateOutputType = {
  __typename?: 'InvoicePimsWritebackLogEntryMaxAggregateOutputType';
  action?: Maybe<InvoicePimsWritebackAction>;
  invoiceId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type InvoicePimsWritebackLogEntryMaxOrderByAggregateInput = {
  action?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type InvoicePimsWritebackLogEntryMinAggregateOutputType = {
  __typename?: 'InvoicePimsWritebackLogEntryMinAggregateOutputType';
  action?: Maybe<InvoicePimsWritebackAction>;
  invoiceId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type InvoicePimsWritebackLogEntryMinOrderByAggregateInput = {
  action?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type InvoicePimsWritebackLogEntryNullableScalarRelationFilter = {
  AND?: Maybe<Array<InvoicePimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<InvoicePimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<InvoicePimsWritebackLogEntryWhereInput>>;
  action?: Maybe<EnumInvoicePimsWritebackActionFilter>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceId?: Maybe<StringFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type InvoicePimsWritebackLogEntryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type InvoicePimsWritebackLogEntryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InvoicePimsWritebackLogEntryOrderByRelevanceInput>;
  action?: Maybe<SortOrder>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceId?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export enum InvoicePimsWritebackLogEntryOrderByRelevanceFieldEnum {
  InvoiceId = 'invoiceId',
  WritebackLogId = 'writebackLogId'
}

export type InvoicePimsWritebackLogEntryOrderByRelevanceInput = {
  fields: Array<InvoicePimsWritebackLogEntryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InvoicePimsWritebackLogEntryOrderByWithAggregationInput = {
  _count?: Maybe<InvoicePimsWritebackLogEntryCountOrderByAggregateInput>;
  _max?: Maybe<InvoicePimsWritebackLogEntryMaxOrderByAggregateInput>;
  _min?: Maybe<InvoicePimsWritebackLogEntryMinOrderByAggregateInput>;
  action?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type InvoicePimsWritebackLogEntryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<InvoicePimsWritebackLogEntryOrderByRelevanceInput>;
  action?: Maybe<SortOrder>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceId?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export type InvoicePimsWritebackLogEntryOrderByWithRelationInput = {
  _relevance?: Maybe<InvoicePimsWritebackLogEntryOrderByRelevanceInput>;
  action?: Maybe<SortOrder>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceId?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export enum InvoicePimsWritebackLogEntryScalarFieldEnum {
  Action = 'action',
  InvoiceId = 'invoiceId',
  WritebackLogId = 'writebackLogId'
}

export type InvoicePimsWritebackLogEntryScalarWhereInput = {
  AND?: Maybe<Array<InvoicePimsWritebackLogEntryScalarWhereInput>>;
  NOT?: Maybe<Array<InvoicePimsWritebackLogEntryScalarWhereInput>>;
  OR?: Maybe<Array<InvoicePimsWritebackLogEntryScalarWhereInput>>;
  action?: Maybe<EnumInvoicePimsWritebackActionFilter>;
  invoiceId?: Maybe<StringFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type InvoicePimsWritebackLogEntryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InvoicePimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InvoicePimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InvoicePimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  action?: Maybe<EnumInvoicePimsWritebackActionWithAggregatesFilter>;
  invoiceId?: Maybe<StringWithAggregatesFilter>;
  writebackLogId?: Maybe<StringWithAggregatesFilter>;
};

export type InvoicePimsWritebackLogEntryUncheckedCreateInput = {
  action: InvoicePimsWritebackAction;
  invoiceId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type InvoicePimsWritebackLogEntryUncheckedCreateNestedManyWithoutInvoiceInput = {
  connect?: Maybe<Array<InvoicePimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoicePimsWritebackLogEntryCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<InvoicePimsWritebackLogEntryCreateWithoutInvoiceInput>>;
  createMany?: Maybe<InvoicePimsWritebackLogEntryCreateManyInvoiceInputEnvelope>;
};

export type InvoicePimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput = {
  connect?: Maybe<InvoicePimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoicePimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<InvoicePimsWritebackLogEntryCreateWithoutWritebackLogInput>;
};

export type InvoicePimsWritebackLogEntryUncheckedCreateWithoutInvoiceInput = {
  action: InvoicePimsWritebackAction;
  writebackLogId: Scalars['String'];
};

export type InvoicePimsWritebackLogEntryUncheckedCreateWithoutWritebackLogInput = {
  action: InvoicePimsWritebackAction;
  invoiceId: Scalars['String'];
};

export type InvoicePimsWritebackLogEntryUncheckedUpdateInput = {
  action?: Maybe<InvoicePimsWritebackAction>;
  invoiceId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type InvoicePimsWritebackLogEntryUncheckedUpdateManyInput = {
  action?: Maybe<InvoicePimsWritebackAction>;
  invoiceId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceInput = {
  action?: Maybe<InvoicePimsWritebackAction>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceNestedInput = {
  connect?: Maybe<Array<InvoicePimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoicePimsWritebackLogEntryCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<InvoicePimsWritebackLogEntryCreateWithoutInvoiceInput>>;
  createMany?: Maybe<InvoicePimsWritebackLogEntryCreateManyInvoiceInputEnvelope>;
  delete?: Maybe<Array<InvoicePimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoicePimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoicePimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<InvoicePimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<InvoicePimsWritebackLogEntryUpdateWithWhereUniqueWithoutInvoiceInput>>;
  updateMany?: Maybe<Array<InvoicePimsWritebackLogEntryUpdateManyWithWhereWithoutInvoiceInput>>;
  upsert?: Maybe<Array<InvoicePimsWritebackLogEntryUpsertWithWhereUniqueWithoutInvoiceInput>>;
};

export type InvoicePimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput = {
  connect?: Maybe<InvoicePimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoicePimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<InvoicePimsWritebackLogEntryCreateWithoutWritebackLogInput>;
  delete?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
  disconnect?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
  update?: Maybe<InvoicePimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput>;
  upsert?: Maybe<InvoicePimsWritebackLogEntryUpsertWithoutWritebackLogInput>;
};

export type InvoicePimsWritebackLogEntryUncheckedUpdateWithoutInvoiceInput = {
  action?: Maybe<InvoicePimsWritebackAction>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type InvoicePimsWritebackLogEntryUncheckedUpdateWithoutWritebackLogInput = {
  action?: Maybe<InvoicePimsWritebackAction>;
  invoiceId?: Maybe<Scalars['String']>;
};

export type InvoicePimsWritebackLogEntryUpdateInput = {
  action?: Maybe<InvoicePimsWritebackAction>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutRelatedInvoiceWritebacksNestedInput>;
  writebackLog?: Maybe<PimsWritebackLogEntryUpdateOneRequiredWithoutInvoiceLogNestedInput>;
};

export type InvoicePimsWritebackLogEntryUpdateManyMutationInput = {
  action?: Maybe<InvoicePimsWritebackAction>;
};

export type InvoicePimsWritebackLogEntryUpdateManyWithWhereWithoutInvoiceInput = {
  data: InvoicePimsWritebackLogEntryUpdateManyMutationInput;
  where: InvoicePimsWritebackLogEntryScalarWhereInput;
};

export type InvoicePimsWritebackLogEntryUpdateManyWithoutInvoiceNestedInput = {
  connect?: Maybe<Array<InvoicePimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoicePimsWritebackLogEntryCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<InvoicePimsWritebackLogEntryCreateWithoutInvoiceInput>>;
  createMany?: Maybe<InvoicePimsWritebackLogEntryCreateManyInvoiceInputEnvelope>;
  delete?: Maybe<Array<InvoicePimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoicePimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoicePimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<InvoicePimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<InvoicePimsWritebackLogEntryUpdateWithWhereUniqueWithoutInvoiceInput>>;
  updateMany?: Maybe<Array<InvoicePimsWritebackLogEntryUpdateManyWithWhereWithoutInvoiceInput>>;
  upsert?: Maybe<Array<InvoicePimsWritebackLogEntryUpsertWithWhereUniqueWithoutInvoiceInput>>;
};

export type InvoicePimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput = {
  connect?: Maybe<InvoicePimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoicePimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<InvoicePimsWritebackLogEntryCreateWithoutWritebackLogInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InvoicePimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput>;
  upsert?: Maybe<InvoicePimsWritebackLogEntryUpsertWithoutWritebackLogInput>;
};

export type InvoicePimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput = {
  data: InvoicePimsWritebackLogEntryUpdateWithoutWritebackLogInput;
  where?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
};

export type InvoicePimsWritebackLogEntryUpdateWithWhereUniqueWithoutInvoiceInput = {
  data: InvoicePimsWritebackLogEntryUpdateWithoutInvoiceInput;
  where: InvoicePimsWritebackLogEntryWhereUniqueInput;
};

export type InvoicePimsWritebackLogEntryUpdateWithoutInvoiceInput = {
  action?: Maybe<InvoicePimsWritebackAction>;
  writebackLog?: Maybe<PimsWritebackLogEntryUpdateOneRequiredWithoutInvoiceLogNestedInput>;
};

export type InvoicePimsWritebackLogEntryUpdateWithoutWritebackLogInput = {
  action?: Maybe<InvoicePimsWritebackAction>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutRelatedInvoiceWritebacksNestedInput>;
};

export type InvoicePimsWritebackLogEntryUpsertWithWhereUniqueWithoutInvoiceInput = {
  create: InvoicePimsWritebackLogEntryCreateWithoutInvoiceInput;
  update: InvoicePimsWritebackLogEntryUpdateWithoutInvoiceInput;
  where: InvoicePimsWritebackLogEntryWhereUniqueInput;
};

export type InvoicePimsWritebackLogEntryUpsertWithoutWritebackLogInput = {
  create: InvoicePimsWritebackLogEntryCreateWithoutWritebackLogInput;
  update: InvoicePimsWritebackLogEntryUpdateWithoutWritebackLogInput;
  where?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
};

export type InvoicePimsWritebackLogEntryWhereInput = {
  AND?: Maybe<Array<InvoicePimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<InvoicePimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<InvoicePimsWritebackLogEntryWhereInput>>;
  action?: Maybe<EnumInvoicePimsWritebackActionFilter>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceId?: Maybe<StringFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type InvoicePimsWritebackLogEntryWhereUniqueInput = {
  AND?: Maybe<Array<InvoicePimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<InvoicePimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<InvoicePimsWritebackLogEntryWhereInput>>;
  action?: Maybe<EnumInvoicePimsWritebackActionFilter>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceId?: Maybe<StringFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<Scalars['String']>;
  writebackLogId_invoiceId?: Maybe<InvoicePimsWritebackLogEntryWritebackLogIdInvoiceIdCompoundUniqueInput>;
};

export type InvoicePimsWritebackLogEntryWritebackLogIdInvoiceIdCompoundUniqueInput = {
  invoiceId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export enum InvoiceScalarFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  Date = 'date',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  Identifier = 'identifier',
  IntegrationId = 'integrationId',
  OutstandingBalance = 'outstandingBalance',
  SentByUserId = 'sentByUserId',
  Status = 'status',
  Subtotal = 'subtotal',
  Taxes = 'taxes',
  Total = 'total',
  UpdatedAt = 'updatedAt'
}

export type InvoiceScalarRelationFilter = {
  AND?: Maybe<Array<InvoiceWhereInput>>;
  NOT?: Maybe<Array<InvoiceWhereInput>>;
  OR?: Maybe<Array<InvoiceWhereInput>>;
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  date?: Maybe<DateTimeNullableFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  identifier?: Maybe<StringNullableFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  lineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  outstandingBalance?: Maybe<IntFilter>;
  pimsInvoice?: Maybe<PimsInvoiceNullableScalarRelationFilter>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryListRelationFilter>;
  sentBy?: Maybe<UserNullableScalarRelationFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  status?: Maybe<EnumInvoiceStatusFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  subtotal?: Maybe<IntFilter>;
  taxes?: Maybe<IntFilter>;
  total?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InvoiceScalarWhereInput = {
  AND?: Maybe<Array<InvoiceScalarWhereInput>>;
  NOT?: Maybe<Array<InvoiceScalarWhereInput>>;
  OR?: Maybe<Array<InvoiceScalarWhereInput>>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  date?: Maybe<DateTimeNullableFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  identifier?: Maybe<StringNullableFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  outstandingBalance?: Maybe<IntFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumInvoiceStatusFilter>;
  subtotal?: Maybe<IntFilter>;
  taxes?: Maybe<IntFilter>;
  total?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InvoiceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<InvoiceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<InvoiceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<InvoiceScalarWhereWithAggregatesInput>>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  currency?: Maybe<EnumCurrencyWithAggregatesFilter>;
  date?: Maybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  identifier?: Maybe<StringNullableWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  outstandingBalance?: Maybe<IntWithAggregatesFilter>;
  sentByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  status?: Maybe<EnumInvoiceStatusWithAggregatesFilter>;
  subtotal?: Maybe<IntWithAggregatesFilter>;
  taxes?: Maybe<IntWithAggregatesFilter>;
  total?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum InvoiceStatus {
  Closed = 'Closed',
  Open = 'Open'
}

export type InvoiceSumAggregateOutputType = {
  __typename?: 'InvoiceSumAggregateOutputType';
  outstandingBalance?: Maybe<Scalars['Int']>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type InvoiceSumOrderByAggregateInput = {
  outstandingBalance?: Maybe<SortOrder>;
  subtotal?: Maybe<SortOrder>;
  taxes?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
};

export type InvoiceUncheckedCreateInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutInvoiceInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedManyWithoutInvoiceInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InvoiceCreateManyClinicPetParentInputEnvelope>;
};

export type InvoiceUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<InvoiceCreateManyIntegrationInputEnvelope>;
};

export type InvoiceUncheckedCreateNestedManyWithoutSentByInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutSentByInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutSentByInput>>;
  createMany?: Maybe<InvoiceCreateManySentByInputEnvelope>;
};

export type InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutStripePaymentIntentsInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutStripePaymentIntentsInput>>;
};

export type InvoiceUncheckedCreateWithoutAssociatedCareBenefitCreditsInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutInvoiceInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedManyWithoutInvoiceInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedCreateWithoutCareAccountCreditIntentsInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutAssociatedInvoiceInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedManyWithoutInvoiceInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedCreateWithoutClinicPetParentInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutInvoiceInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedManyWithoutInvoiceInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedCreateWithoutIntegrationInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutInvoiceInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedManyWithoutInvoiceInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedCreateWithoutLineItemsInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutInvoiceInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedManyWithoutInvoiceInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedCreateWithoutLoyaltyPointDeltasInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutInvoiceInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedManyWithoutInvoiceInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedCreateWithoutPimsInvoiceInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutInvoiceInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedManyWithoutInvoiceInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedCreateWithoutRelatedInvoiceWritebacksInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutInvoiceInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedCreateNestedOneWithoutInvoiceInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedCreateWithoutSentByInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutInvoiceInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedManyWithoutInvoiceInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedCreateWithoutServicePurchaseSummariesInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutInvoiceInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedManyWithoutInvoiceInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutInvoicesInput>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedCreateWithoutStripePaymentIntentsInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutAssociatedInvoiceInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedCreateNestedManyWithoutInvoiceInput>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutInvoiceInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutGrantingInvoiceInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedCreateNestedOneWithoutInvoiceInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedManyWithoutInvoiceInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutInvoiceInput>;
  status?: Maybe<InvoiceStatus>;
  subtotal: Scalars['Int'];
  taxes?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateManyInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  sentByUserId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateManyWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  sentByUserId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InvoiceCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<InvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<InvoiceUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<InvoiceUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type InvoiceUncheckedUpdateManyWithoutIntegrationInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  sentByUserId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<InvoiceCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<InvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<InvoiceUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<InvoiceUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type InvoiceUncheckedUpdateManyWithoutSentByInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateManyWithoutSentByNestedInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutSentByInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutSentByInput>>;
  createMany?: Maybe<InvoiceCreateManySentByInputEnvelope>;
  delete?: Maybe<Array<InvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceUpdateWithWhereUniqueWithoutSentByInput>>;
  updateMany?: Maybe<Array<InvoiceUpdateManyWithWhereWithoutSentByInput>>;
  upsert?: Maybe<Array<InvoiceUpsertWithWhereUniqueWithoutSentByInput>>;
};

export type InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  sentByUserId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutStripePaymentIntentsInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutStripePaymentIntentsInput>>;
  delete?: Maybe<Array<InvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceUpdateWithWhereUniqueWithoutStripePaymentIntentsInput>>;
  updateMany?: Maybe<Array<InvoiceUpdateManyWithWhereWithoutStripePaymentIntentsInput>>;
  upsert?: Maybe<Array<InvoiceUpsertWithWhereUniqueWithoutStripePaymentIntentsInput>>;
};

export type InvoiceUncheckedUpdateWithoutAssociatedCareBenefitCreditsInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateWithoutCareAccountCreditIntentsInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateWithoutClinicPetParentInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateWithoutIntegrationInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateWithoutLineItemsInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateWithoutLoyaltyPointDeltasInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateWithoutPimsInvoiceInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateWithoutRelatedInvoiceWritebacksInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedUpdateOneWithoutInvoiceNestedInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateWithoutSentByInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateWithoutServicePurchaseSummariesInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUncheckedUpdateWithoutStripePaymentIntentsInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUncheckedUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUncheckedUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  sentByUserId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInvoicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutInvoicesNestedInput>;
  lineItems?: Maybe<InvoiceLineItemUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUpdateManyWithoutInvoiceNestedInput>;
  sentBy?: Maybe<UserUpdateOneWithoutSentInvoicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: InvoiceUpdateManyMutationInput;
  where: InvoiceScalarWhereInput;
};

export type InvoiceUpdateManyWithWhereWithoutIntegrationInput = {
  data: InvoiceUpdateManyMutationInput;
  where: InvoiceScalarWhereInput;
};

export type InvoiceUpdateManyWithWhereWithoutSentByInput = {
  data: InvoiceUpdateManyMutationInput;
  where: InvoiceScalarWhereInput;
};

export type InvoiceUpdateManyWithWhereWithoutStripePaymentIntentsInput = {
  data: InvoiceUpdateManyMutationInput;
  where: InvoiceScalarWhereInput;
};

export type InvoiceUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<InvoiceCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<InvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<InvoiceUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<InvoiceUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type InvoiceUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<InvoiceCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<InvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<InvoiceUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<InvoiceUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type InvoiceUpdateManyWithoutSentByNestedInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutSentByInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutSentByInput>>;
  createMany?: Maybe<InvoiceCreateManySentByInputEnvelope>;
  delete?: Maybe<Array<InvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceUpdateWithWhereUniqueWithoutSentByInput>>;
  updateMany?: Maybe<Array<InvoiceUpdateManyWithWhereWithoutSentByInput>>;
  upsert?: Maybe<Array<InvoiceUpsertWithWhereUniqueWithoutSentByInput>>;
};

export type InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput = {
  connect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<InvoiceCreateOrConnectWithoutStripePaymentIntentsInput>>;
  create?: Maybe<Array<InvoiceCreateWithoutStripePaymentIntentsInput>>;
  delete?: Maybe<Array<InvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<InvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<InvoiceWhereUniqueInput>>;
  set?: Maybe<Array<InvoiceWhereUniqueInput>>;
  update?: Maybe<Array<InvoiceUpdateWithWhereUniqueWithoutStripePaymentIntentsInput>>;
  updateMany?: Maybe<Array<InvoiceUpdateManyWithWhereWithoutStripePaymentIntentsInput>>;
  upsert?: Maybe<Array<InvoiceUpsertWithWhereUniqueWithoutStripePaymentIntentsInput>>;
};

export type InvoiceUpdateOneRequiredWithoutLineItemsNestedInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutLineItemsInput>;
  create?: Maybe<InvoiceCreateWithoutLineItemsInput>;
  update?: Maybe<InvoiceUpdateToOneWithWhereWithoutLineItemsInput>;
  upsert?: Maybe<InvoiceUpsertWithoutLineItemsInput>;
};

export type InvoiceUpdateOneRequiredWithoutPimsInvoiceNestedInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutPimsInvoiceInput>;
  create?: Maybe<InvoiceCreateWithoutPimsInvoiceInput>;
  update?: Maybe<InvoiceUpdateToOneWithWhereWithoutPimsInvoiceInput>;
  upsert?: Maybe<InvoiceUpsertWithoutPimsInvoiceInput>;
};

export type InvoiceUpdateOneRequiredWithoutRelatedInvoiceWritebacksNestedInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutRelatedInvoiceWritebacksInput>;
  create?: Maybe<InvoiceCreateWithoutRelatedInvoiceWritebacksInput>;
  update?: Maybe<InvoiceUpdateToOneWithWhereWithoutRelatedInvoiceWritebacksInput>;
  upsert?: Maybe<InvoiceUpsertWithoutRelatedInvoiceWritebacksInput>;
};

export type InvoiceUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutServicePurchaseSummariesInput>;
  create?: Maybe<InvoiceCreateWithoutServicePurchaseSummariesInput>;
  update?: Maybe<InvoiceUpdateToOneWithWhereWithoutServicePurchaseSummariesInput>;
  upsert?: Maybe<InvoiceUpsertWithoutServicePurchaseSummariesInput>;
};

export type InvoiceUpdateOneWithoutAssociatedCareBenefitCreditsNestedInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutAssociatedCareBenefitCreditsInput>;
  create?: Maybe<InvoiceCreateWithoutAssociatedCareBenefitCreditsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InvoiceUpdateToOneWithWhereWithoutAssociatedCareBenefitCreditsInput>;
  upsert?: Maybe<InvoiceUpsertWithoutAssociatedCareBenefitCreditsInput>;
};

export type InvoiceUpdateOneWithoutCareAccountCreditIntentsNestedInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutCareAccountCreditIntentsInput>;
  create?: Maybe<InvoiceCreateWithoutCareAccountCreditIntentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InvoiceUpdateToOneWithWhereWithoutCareAccountCreditIntentsInput>;
  upsert?: Maybe<InvoiceUpsertWithoutCareAccountCreditIntentsInput>;
};

export type InvoiceUpdateOneWithoutLoyaltyPointDeltasNestedInput = {
  connect?: Maybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<InvoiceCreateOrConnectWithoutLoyaltyPointDeltasInput>;
  create?: Maybe<InvoiceCreateWithoutLoyaltyPointDeltasInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InvoiceUpdateToOneWithWhereWithoutLoyaltyPointDeltasInput>;
  upsert?: Maybe<InvoiceUpsertWithoutLoyaltyPointDeltasInput>;
};

export type InvoiceUpdateToOneWithWhereWithoutAssociatedCareBenefitCreditsInput = {
  data: InvoiceUpdateWithoutAssociatedCareBenefitCreditsInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpdateToOneWithWhereWithoutCareAccountCreditIntentsInput = {
  data: InvoiceUpdateWithoutCareAccountCreditIntentsInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpdateToOneWithWhereWithoutLineItemsInput = {
  data: InvoiceUpdateWithoutLineItemsInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpdateToOneWithWhereWithoutLoyaltyPointDeltasInput = {
  data: InvoiceUpdateWithoutLoyaltyPointDeltasInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpdateToOneWithWhereWithoutPimsInvoiceInput = {
  data: InvoiceUpdateWithoutPimsInvoiceInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpdateToOneWithWhereWithoutRelatedInvoiceWritebacksInput = {
  data: InvoiceUpdateWithoutRelatedInvoiceWritebacksInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpdateToOneWithWhereWithoutServicePurchaseSummariesInput = {
  data: InvoiceUpdateWithoutServicePurchaseSummariesInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: InvoiceUpdateWithoutClinicPetParentInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: InvoiceUpdateWithoutIntegrationInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceUpdateWithWhereUniqueWithoutSentByInput = {
  data: InvoiceUpdateWithoutSentByInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceUpdateWithWhereUniqueWithoutStripePaymentIntentsInput = {
  data: InvoiceUpdateWithoutStripePaymentIntentsInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceUpdateWithoutAssociatedCareBenefitCreditsInput = {
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInvoicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutInvoicesNestedInput>;
  lineItems?: Maybe<InvoiceLineItemUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUpdateManyWithoutInvoiceNestedInput>;
  sentBy?: Maybe<UserUpdateOneWithoutSentInvoicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateWithoutCareAccountCreditIntentsInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutAssociatedInvoiceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInvoicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutInvoicesNestedInput>;
  lineItems?: Maybe<InvoiceLineItemUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUpdateManyWithoutInvoiceNestedInput>;
  sentBy?: Maybe<UserUpdateOneWithoutSentInvoicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateWithoutClinicPetParentInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutInvoiceNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutInvoicesNestedInput>;
  lineItems?: Maybe<InvoiceLineItemUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUpdateManyWithoutInvoiceNestedInput>;
  sentBy?: Maybe<UserUpdateOneWithoutSentInvoicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateWithoutIntegrationInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInvoicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  lineItems?: Maybe<InvoiceLineItemUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUpdateManyWithoutInvoiceNestedInput>;
  sentBy?: Maybe<UserUpdateOneWithoutSentInvoicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateWithoutLineItemsInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInvoicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutInvoicesNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUpdateManyWithoutInvoiceNestedInput>;
  sentBy?: Maybe<UserUpdateOneWithoutSentInvoicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateWithoutLoyaltyPointDeltasInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInvoicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutInvoicesNestedInput>;
  lineItems?: Maybe<InvoiceLineItemUpdateManyWithoutInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUpdateManyWithoutInvoiceNestedInput>;
  sentBy?: Maybe<UserUpdateOneWithoutSentInvoicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateWithoutPimsInvoiceInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInvoicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutInvoicesNestedInput>;
  lineItems?: Maybe<InvoiceLineItemUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUpdateManyWithoutInvoiceNestedInput>;
  sentBy?: Maybe<UserUpdateOneWithoutSentInvoicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateWithoutRelatedInvoiceWritebacksInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInvoicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutInvoicesNestedInput>;
  lineItems?: Maybe<InvoiceLineItemUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUpdateOneWithoutInvoiceNestedInput>;
  sentBy?: Maybe<UserUpdateOneWithoutSentInvoicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateWithoutSentByInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInvoicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutInvoicesNestedInput>;
  lineItems?: Maybe<InvoiceLineItemUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUpdateManyWithoutInvoiceNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateWithoutServicePurchaseSummariesInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInvoicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutInvoicesNestedInput>;
  lineItems?: Maybe<InvoiceLineItemUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUpdateManyWithoutInvoiceNestedInput>;
  sentBy?: Maybe<UserUpdateOneWithoutSentInvoicesNestedInput>;
  status?: Maybe<InvoiceStatus>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutInvoicesNestedInput>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpdateWithoutStripePaymentIntentsInput = {
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutAssociatedInvoiceNestedInput>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentUpdateManyWithoutInvoiceNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutInvoicesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutInvoicesNestedInput>;
  lineItems?: Maybe<InvoiceLineItemUpdateManyWithoutInvoiceNestedInput>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutGrantingInvoiceNestedInput>;
  outstandingBalance?: Maybe<Scalars['Int']>;
  pimsInvoice?: Maybe<PimsInvoiceUpdateOneWithoutInvoiceNestedInput>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryUpdateManyWithoutInvoiceNestedInput>;
  sentBy?: Maybe<UserUpdateOneWithoutSentInvoicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutInvoiceNestedInput>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InvoiceUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: InvoiceCreateWithoutClinicPetParentInput;
  update: InvoiceUpdateWithoutClinicPetParentInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: InvoiceCreateWithoutIntegrationInput;
  update: InvoiceUpdateWithoutIntegrationInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceUpsertWithWhereUniqueWithoutSentByInput = {
  create: InvoiceCreateWithoutSentByInput;
  update: InvoiceUpdateWithoutSentByInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceUpsertWithWhereUniqueWithoutStripePaymentIntentsInput = {
  create: InvoiceCreateWithoutStripePaymentIntentsInput;
  update: InvoiceUpdateWithoutStripePaymentIntentsInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceUpsertWithoutAssociatedCareBenefitCreditsInput = {
  create: InvoiceCreateWithoutAssociatedCareBenefitCreditsInput;
  update: InvoiceUpdateWithoutAssociatedCareBenefitCreditsInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpsertWithoutCareAccountCreditIntentsInput = {
  create: InvoiceCreateWithoutCareAccountCreditIntentsInput;
  update: InvoiceUpdateWithoutCareAccountCreditIntentsInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpsertWithoutLineItemsInput = {
  create: InvoiceCreateWithoutLineItemsInput;
  update: InvoiceUpdateWithoutLineItemsInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpsertWithoutLoyaltyPointDeltasInput = {
  create: InvoiceCreateWithoutLoyaltyPointDeltasInput;
  update: InvoiceUpdateWithoutLoyaltyPointDeltasInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpsertWithoutPimsInvoiceInput = {
  create: InvoiceCreateWithoutPimsInvoiceInput;
  update: InvoiceUpdateWithoutPimsInvoiceInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpsertWithoutRelatedInvoiceWritebacksInput = {
  create: InvoiceCreateWithoutRelatedInvoiceWritebacksInput;
  update: InvoiceUpdateWithoutRelatedInvoiceWritebacksInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceUpsertWithoutServicePurchaseSummariesInput = {
  create: InvoiceCreateWithoutServicePurchaseSummariesInput;
  update: InvoiceUpdateWithoutServicePurchaseSummariesInput;
  where?: Maybe<InvoiceWhereInput>;
};

export type InvoiceWhereInput = {
  AND?: Maybe<Array<InvoiceWhereInput>>;
  NOT?: Maybe<Array<InvoiceWhereInput>>;
  OR?: Maybe<Array<InvoiceWhereInput>>;
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  date?: Maybe<DateTimeNullableFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  identifier?: Maybe<StringNullableFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  lineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  outstandingBalance?: Maybe<IntFilter>;
  pimsInvoice?: Maybe<PimsInvoiceNullableScalarRelationFilter>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryListRelationFilter>;
  sentBy?: Maybe<UserNullableScalarRelationFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  status?: Maybe<EnumInvoiceStatusFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  subtotal?: Maybe<IntFilter>;
  taxes?: Maybe<IntFilter>;
  total?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InvoiceWhereUniqueInput = {
  AND?: Maybe<Array<InvoiceWhereInput>>;
  NOT?: Maybe<Array<InvoiceWhereInput>>;
  OR?: Maybe<Array<InvoiceWhereInput>>;
  associatedCareBenefitCredits?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  careAccountCreditIntents?: Maybe<CareAccountCreditIntentListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  date?: Maybe<DateTimeNullableFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<StringNullableFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  lineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  outstandingBalance?: Maybe<IntFilter>;
  pimsInvoice?: Maybe<PimsInvoiceNullableScalarRelationFilter>;
  relatedInvoiceWritebacks?: Maybe<InvoicePimsWritebackLogEntryListRelationFilter>;
  sentBy?: Maybe<UserNullableScalarRelationFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  status?: Maybe<EnumInvoiceStatusFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  subtotal?: Maybe<IntFilter>;
  taxes?: Maybe<IntFilter>;
  total?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type InvokeAiConverseContent = {
  text: Scalars['String'];
};

export type InvokeAiConverseInput = {
  messages: Array<InvokeAiConverseMessage>;
  modelId?: Maybe<Scalars['String']>;
  systemPrompt?: Maybe<Scalars['String']>;
};

export type InvokeAiConverseMessage = {
  content: Array<InvokeAiConverseContent>;
  role: AiConverseRole;
};

export type InvokeAiConverseOutput = {
  __typename?: 'InvokeAiConverseOutput';
  message: Scalars['String'];
  role: AiConverseRole;
};

export type ItemInfo = {
  discountedValue?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  savings?: Maybe<Scalars['Float']>;
  usedValue: Scalars['Float'];
};

export type JobChain = {
  __typename?: 'JobChain';
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type JobChainStatus = {
  __typename?: 'JobChainStatus';
  completedAt?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['Json']>;
  erroredAt?: Maybe<Scalars['DateTime']>;
  jobChainId?: Maybe<Scalars['String']>;
  payload?: Maybe<Array<Maybe<Scalars['Json']>>>;
  queuedAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
};

export type JobChainStatusInput = {
  jobChainId: Scalars['String'];
};

export type JobChainSubscritptionPayload = {
  __typename?: 'JobChainSubscritptionPayload';
  error?: Maybe<Scalars['Json']>;
  jobChainId?: Maybe<Scalars['String']>;
  payload?: Maybe<Array<Maybe<Scalars['Json']>>>;
  success: Scalars['Boolean'];
};

export type JobChainSubscritptionWhereInput = {
  id: StringFilter;
};


export type JsonFilter = {
  array_contains?: Maybe<Scalars['Json']>;
  array_ends_with?: Maybe<Scalars['Json']>;
  array_starts_with?: Maybe<Scalars['Json']>;
  equals?: Maybe<Scalars['Json']>;
  gt?: Maybe<Scalars['Json']>;
  gte?: Maybe<Scalars['Json']>;
  lt?: Maybe<Scalars['Json']>;
  lte?: Maybe<Scalars['Json']>;
  not?: Maybe<Scalars['Json']>;
  path?: Maybe<Array<Scalars['String']>>;
  string_contains?: Maybe<Scalars['String']>;
  string_ends_with?: Maybe<Scalars['String']>;
  string_starts_with?: Maybe<Scalars['String']>;
};

export enum JsonNullValueFilter {
  AnyNull = 'AnyNull',
  DbNull = 'DbNull',
  JsonNull = 'JsonNull'
}

export enum JsonNullValueInput {
  JsonNull = 'JsonNull'
}

export type JsonNullableFilter = {
  array_contains?: Maybe<Scalars['Json']>;
  array_ends_with?: Maybe<Scalars['Json']>;
  array_starts_with?: Maybe<Scalars['Json']>;
  equals?: Maybe<Scalars['Json']>;
  gt?: Maybe<Scalars['Json']>;
  gte?: Maybe<Scalars['Json']>;
  lt?: Maybe<Scalars['Json']>;
  lte?: Maybe<Scalars['Json']>;
  not?: Maybe<Scalars['Json']>;
  path?: Maybe<Array<Scalars['String']>>;
  string_contains?: Maybe<Scalars['String']>;
  string_ends_with?: Maybe<Scalars['String']>;
  string_starts_with?: Maybe<Scalars['String']>;
};

export type JsonNullableListFilter = {
  equals?: Maybe<Array<Scalars['Json']>>;
  has?: Maybe<Scalars['Json']>;
  hasEvery?: Maybe<Array<Scalars['Json']>>;
  hasSome?: Maybe<Array<Scalars['Json']>>;
  isEmpty?: Maybe<Scalars['Boolean']>;
};

export type JsonNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedJsonNullableFilter>;
  _min?: Maybe<NestedJsonNullableFilter>;
  array_contains?: Maybe<Scalars['Json']>;
  array_ends_with?: Maybe<Scalars['Json']>;
  array_starts_with?: Maybe<Scalars['Json']>;
  equals?: Maybe<Scalars['Json']>;
  gt?: Maybe<Scalars['Json']>;
  gte?: Maybe<Scalars['Json']>;
  lt?: Maybe<Scalars['Json']>;
  lte?: Maybe<Scalars['Json']>;
  not?: Maybe<Scalars['Json']>;
  path?: Maybe<Array<Scalars['String']>>;
  string_contains?: Maybe<Scalars['String']>;
  string_ends_with?: Maybe<Scalars['String']>;
  string_starts_with?: Maybe<Scalars['String']>;
};

export type JsonWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedJsonFilter>;
  _min?: Maybe<NestedJsonFilter>;
  array_contains?: Maybe<Scalars['Json']>;
  array_ends_with?: Maybe<Scalars['Json']>;
  array_starts_with?: Maybe<Scalars['Json']>;
  equals?: Maybe<Scalars['Json']>;
  gt?: Maybe<Scalars['Json']>;
  gte?: Maybe<Scalars['Json']>;
  lt?: Maybe<Scalars['Json']>;
  lte?: Maybe<Scalars['Json']>;
  not?: Maybe<Scalars['Json']>;
  path?: Maybe<Array<Scalars['String']>>;
  string_contains?: Maybe<Scalars['String']>;
  string_ends_with?: Maybe<Scalars['String']>;
  string_starts_with?: Maybe<Scalars['String']>;
};

export enum LoaStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Opened = 'OPENED',
  Signed = 'SIGNED',
  Signing = 'SIGNING'
}

export type LabPanel = {
  __typename?: 'LabPanel';
  LabResult: Array<LabResult>;
  _count: LabPanelCountOutputType;
  clinicEmployee?: Maybe<ClinicEmployee>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type LabPanelLabResultArgs = {
  cursor?: Maybe<LabResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LabResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LabResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabResultWhereInput>;
};


export type LabPanelClinicEmployeeArgs = {
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type LabPanelClinicPetArgs = {
  where?: Maybe<ClinicPetWhereInput>;
};


export type LabPanelIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type LabPanelCountAggregateOutputType = {
  __typename?: 'LabPanelCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicEmployeeId: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  createdAt: Scalars['Int'];
  date: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isDeleted: Scalars['Int'];
  name: Scalars['Int'];
  notes: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  siteId: Scalars['Int'];
  sourceName: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LabPanelCountOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  sourceName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LabPanelCountOutputType = {
  __typename?: 'LabPanelCountOutputType';
  LabResult: Scalars['Int'];
};

export type LabPanelCreateInput = {
  LabResult?: Maybe<LabResultCreateNestedManyWithoutLabPanelInput>;
  clinicEmployee?: Maybe<ClinicEmployeeCreateNestedOneWithoutLabPanelInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutLabPanelInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutLabPanelInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelCreateManyClinicEmployeeInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelCreateManyClinicEmployeeInputEnvelope = {
  data: Array<LabPanelCreateManyClinicEmployeeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LabPanelCreateManyClinicPetInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelCreateManyClinicPetInputEnvelope = {
  data: Array<LabPanelCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LabPanelCreateManyInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelCreateManyIntegrationInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelCreateManyIntegrationInputEnvelope = {
  data: Array<LabPanelCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LabPanelCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabPanelCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<LabPanelCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<LabPanelCreateManyClinicEmployeeInputEnvelope>;
};

export type LabPanelCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabPanelCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<LabPanelCreateWithoutClinicPetInput>>;
  createMany?: Maybe<LabPanelCreateManyClinicPetInputEnvelope>;
};

export type LabPanelCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabPanelCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<LabPanelCreateWithoutIntegrationInput>>;
  createMany?: Maybe<LabPanelCreateManyIntegrationInputEnvelope>;
};

export type LabPanelCreateNestedOneWithoutLabResultInput = {
  connect?: Maybe<LabPanelWhereUniqueInput>;
  connectOrCreate?: Maybe<LabPanelCreateOrConnectWithoutLabResultInput>;
  create?: Maybe<LabPanelCreateWithoutLabResultInput>;
};

export type LabPanelCreateOrConnectWithoutClinicEmployeeInput = {
  create: LabPanelCreateWithoutClinicEmployeeInput;
  where: LabPanelWhereUniqueInput;
};

export type LabPanelCreateOrConnectWithoutClinicPetInput = {
  create: LabPanelCreateWithoutClinicPetInput;
  where: LabPanelWhereUniqueInput;
};

export type LabPanelCreateOrConnectWithoutIntegrationInput = {
  create: LabPanelCreateWithoutIntegrationInput;
  where: LabPanelWhereUniqueInput;
};

export type LabPanelCreateOrConnectWithoutLabResultInput = {
  create: LabPanelCreateWithoutLabResultInput;
  where: LabPanelWhereUniqueInput;
};

export type LabPanelCreateWithoutClinicEmployeeInput = {
  LabResult?: Maybe<LabResultCreateNestedManyWithoutLabPanelInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutLabPanelInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutLabPanelInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelCreateWithoutClinicPetInput = {
  LabResult?: Maybe<LabResultCreateNestedManyWithoutLabPanelInput>;
  clinicEmployee?: Maybe<ClinicEmployeeCreateNestedOneWithoutLabPanelInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutLabPanelInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelCreateWithoutIntegrationInput = {
  LabResult?: Maybe<LabResultCreateNestedManyWithoutLabPanelInput>;
  clinicEmployee?: Maybe<ClinicEmployeeCreateNestedOneWithoutLabPanelInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutLabPanelInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelCreateWithoutLabResultInput = {
  clinicEmployee?: Maybe<ClinicEmployeeCreateNestedOneWithoutLabPanelInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutLabPanelInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutLabPanelInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelGroupByOutputType = {
  __typename?: 'LabPanelGroupByOutputType';
  _count?: Maybe<LabPanelCountAggregateOutputType>;
  _max?: Maybe<LabPanelMaxAggregateOutputType>;
  _min?: Maybe<LabPanelMinAggregateOutputType>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  integrationId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type LabPanelLabPanelPimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type LabPanelListRelationFilter = {
  every?: Maybe<LabPanelWhereInput>;
  none?: Maybe<LabPanelWhereInput>;
  some?: Maybe<LabPanelWhereInput>;
};

export type LabPanelMaxAggregateOutputType = {
  __typename?: 'LabPanelMaxAggregateOutputType';
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelMaxOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  sourceName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LabPanelMinAggregateOutputType = {
  __typename?: 'LabPanelMinAggregateOutputType';
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelMinOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  sourceName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LabPanelNullableScalarRelationFilter = {
  AND?: Maybe<Array<LabPanelWhereInput>>;
  LabResult?: Maybe<LabResultListRelationFilter>;
  NOT?: Maybe<Array<LabPanelWhereInput>>;
  OR?: Maybe<Array<LabPanelWhereInput>>;
  clinicEmployee?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringNullableFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  date?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringNullableFilter>;
  notes?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  sourceName?: Maybe<StringNullableFilter>;
  status?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LabPanelOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LabPanelOrderByRelationAndSearchRelevanceInput = {
  LabResult?: Maybe<LabResultOrderByRelationAggregateInput>;
  _relevance?: Maybe<LabPanelOrderByRelevanceInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  sourceName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LabPanelOrderByRelevanceFieldEnum {
  ClinicEmployeeId = 'clinicEmployeeId',
  ClinicPetId = 'clinicPetId',
  Id = 'id',
  IntegrationId = 'integrationId',
  Name = 'name',
  Notes = 'notes',
  PimsId = 'pimsId',
  SiteId = 'siteId',
  SourceName = 'sourceName',
  Status = 'status'
}

export type LabPanelOrderByRelevanceInput = {
  fields: Array<LabPanelOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LabPanelOrderByWithAggregationInput = {
  _count?: Maybe<LabPanelCountOrderByAggregateInput>;
  _max?: Maybe<LabPanelMaxOrderByAggregateInput>;
  _min?: Maybe<LabPanelMinOrderByAggregateInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  sourceName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LabPanelOrderByWithRelationAndSearchRelevanceInput = {
  LabResult?: Maybe<LabResultOrderByRelationAggregateInput>;
  _relevance?: Maybe<LabPanelOrderByRelevanceInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  sourceName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LabPanelOrderByWithRelationInput = {
  LabResult?: Maybe<LabResultOrderByRelationAggregateInput>;
  _relevance?: Maybe<LabPanelOrderByRelevanceInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  sourceName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LabPanelScalarFieldEnum {
  ClinicEmployeeId = 'clinicEmployeeId',
  ClinicPetId = 'clinicPetId',
  CreatedAt = 'createdAt',
  Date = 'date',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsDeleted = 'isDeleted',
  Name = 'name',
  Notes = 'notes',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  SiteId = 'siteId',
  SourceName = 'sourceName',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type LabPanelScalarWhereInput = {
  AND?: Maybe<Array<LabPanelScalarWhereInput>>;
  NOT?: Maybe<Array<LabPanelScalarWhereInput>>;
  OR?: Maybe<Array<LabPanelScalarWhereInput>>;
  clinicEmployeeId?: Maybe<StringNullableFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  date?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringNullableFilter>;
  notes?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  sourceName?: Maybe<StringNullableFilter>;
  status?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LabPanelScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LabPanelScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LabPanelScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LabPanelScalarWhereWithAggregatesInput>>;
  clinicEmployeeId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  date?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringNullableWithAggregatesFilter>;
  notes?: Maybe<StringNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  siteId?: Maybe<StringNullableWithAggregatesFilter>;
  sourceName?: Maybe<StringNullableWithAggregatesFilter>;
  status?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type LabPanelUncheckedCreateInput = {
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutLabPanelInput>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabPanelCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<LabPanelCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<LabPanelCreateManyClinicEmployeeInputEnvelope>;
};

export type LabPanelUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabPanelCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<LabPanelCreateWithoutClinicPetInput>>;
  createMany?: Maybe<LabPanelCreateManyClinicPetInputEnvelope>;
};

export type LabPanelUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabPanelCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<LabPanelCreateWithoutIntegrationInput>>;
  createMany?: Maybe<LabPanelCreateManyIntegrationInputEnvelope>;
};

export type LabPanelUncheckedCreateWithoutClinicEmployeeInput = {
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutLabPanelInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedCreateWithoutClinicPetInput = {
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutLabPanelInput>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedCreateWithoutIntegrationInput = {
  LabResult?: Maybe<LabResultUncheckedCreateNestedManyWithoutLabPanelInput>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedCreateWithoutLabResultInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedUpdateInput = {
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutLabPanelNestedInput>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedUpdateManyInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedUpdateManyWithoutClinicEmployeeInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabPanelCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<LabPanelCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<LabPanelCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<LabPanelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LabPanelScalarWhereInput>>;
  disconnect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  set?: Maybe<Array<LabPanelWhereUniqueInput>>;
  update?: Maybe<Array<LabPanelUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<LabPanelUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<LabPanelUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type LabPanelUncheckedUpdateManyWithoutClinicPetInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabPanelCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<LabPanelCreateWithoutClinicPetInput>>;
  createMany?: Maybe<LabPanelCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<LabPanelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LabPanelScalarWhereInput>>;
  disconnect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  set?: Maybe<Array<LabPanelWhereUniqueInput>>;
  update?: Maybe<Array<LabPanelUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<LabPanelUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<LabPanelUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type LabPanelUncheckedUpdateManyWithoutIntegrationInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabPanelCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<LabPanelCreateWithoutIntegrationInput>>;
  createMany?: Maybe<LabPanelCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<LabPanelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LabPanelScalarWhereInput>>;
  disconnect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  set?: Maybe<Array<LabPanelWhereUniqueInput>>;
  update?: Maybe<Array<LabPanelUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<LabPanelUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<LabPanelUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type LabPanelUncheckedUpdateWithoutClinicEmployeeInput = {
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutLabPanelNestedInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedUpdateWithoutClinicPetInput = {
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutLabPanelNestedInput>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedUpdateWithoutIntegrationInput = {
  LabResult?: Maybe<LabResultUncheckedUpdateManyWithoutLabPanelNestedInput>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUncheckedUpdateWithoutLabResultInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUpdateInput = {
  LabResult?: Maybe<LabResultUpdateManyWithoutLabPanelNestedInput>;
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneWithoutLabPanelNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutLabPanelNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutLabPanelNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUpdateManyWithWhereWithoutClinicEmployeeInput = {
  data: LabPanelUpdateManyMutationInput;
  where: LabPanelScalarWhereInput;
};

export type LabPanelUpdateManyWithWhereWithoutClinicPetInput = {
  data: LabPanelUpdateManyMutationInput;
  where: LabPanelScalarWhereInput;
};

export type LabPanelUpdateManyWithWhereWithoutIntegrationInput = {
  data: LabPanelUpdateManyMutationInput;
  where: LabPanelScalarWhereInput;
};

export type LabPanelUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabPanelCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<LabPanelCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<LabPanelCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<LabPanelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LabPanelScalarWhereInput>>;
  disconnect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  set?: Maybe<Array<LabPanelWhereUniqueInput>>;
  update?: Maybe<Array<LabPanelUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<LabPanelUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<LabPanelUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type LabPanelUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabPanelCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<LabPanelCreateWithoutClinicPetInput>>;
  createMany?: Maybe<LabPanelCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<LabPanelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LabPanelScalarWhereInput>>;
  disconnect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  set?: Maybe<Array<LabPanelWhereUniqueInput>>;
  update?: Maybe<Array<LabPanelUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<LabPanelUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<LabPanelUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type LabPanelUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabPanelCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<LabPanelCreateWithoutIntegrationInput>>;
  createMany?: Maybe<LabPanelCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<LabPanelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LabPanelScalarWhereInput>>;
  disconnect?: Maybe<Array<LabPanelWhereUniqueInput>>;
  set?: Maybe<Array<LabPanelWhereUniqueInput>>;
  update?: Maybe<Array<LabPanelUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<LabPanelUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<LabPanelUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type LabPanelUpdateOneWithoutLabResultNestedInput = {
  connect?: Maybe<LabPanelWhereUniqueInput>;
  connectOrCreate?: Maybe<LabPanelCreateOrConnectWithoutLabResultInput>;
  create?: Maybe<LabPanelCreateWithoutLabResultInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LabPanelUpdateToOneWithWhereWithoutLabResultInput>;
  upsert?: Maybe<LabPanelUpsertWithoutLabResultInput>;
};

export type LabPanelUpdateToOneWithWhereWithoutLabResultInput = {
  data: LabPanelUpdateWithoutLabResultInput;
  where?: Maybe<LabPanelWhereInput>;
};

export type LabPanelUpdateWithWhereUniqueWithoutClinicEmployeeInput = {
  data: LabPanelUpdateWithoutClinicEmployeeInput;
  where: LabPanelWhereUniqueInput;
};

export type LabPanelUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: LabPanelUpdateWithoutClinicPetInput;
  where: LabPanelWhereUniqueInput;
};

export type LabPanelUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: LabPanelUpdateWithoutIntegrationInput;
  where: LabPanelWhereUniqueInput;
};

export type LabPanelUpdateWithoutClinicEmployeeInput = {
  LabResult?: Maybe<LabResultUpdateManyWithoutLabPanelNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutLabPanelNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutLabPanelNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUpdateWithoutClinicPetInput = {
  LabResult?: Maybe<LabResultUpdateManyWithoutLabPanelNestedInput>;
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneWithoutLabPanelNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutLabPanelNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUpdateWithoutIntegrationInput = {
  LabResult?: Maybe<LabResultUpdateManyWithoutLabPanelNestedInput>;
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneWithoutLabPanelNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutLabPanelNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUpdateWithoutLabResultInput = {
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneWithoutLabPanelNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutLabPanelNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutLabPanelNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  siteId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabPanelUpsertWithWhereUniqueWithoutClinicEmployeeInput = {
  create: LabPanelCreateWithoutClinicEmployeeInput;
  update: LabPanelUpdateWithoutClinicEmployeeInput;
  where: LabPanelWhereUniqueInput;
};

export type LabPanelUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: LabPanelCreateWithoutClinicPetInput;
  update: LabPanelUpdateWithoutClinicPetInput;
  where: LabPanelWhereUniqueInput;
};

export type LabPanelUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: LabPanelCreateWithoutIntegrationInput;
  update: LabPanelUpdateWithoutIntegrationInput;
  where: LabPanelWhereUniqueInput;
};

export type LabPanelUpsertWithoutLabResultInput = {
  create: LabPanelCreateWithoutLabResultInput;
  update: LabPanelUpdateWithoutLabResultInput;
  where?: Maybe<LabPanelWhereInput>;
};

export type LabPanelWhereInput = {
  AND?: Maybe<Array<LabPanelWhereInput>>;
  LabResult?: Maybe<LabResultListRelationFilter>;
  NOT?: Maybe<Array<LabPanelWhereInput>>;
  OR?: Maybe<Array<LabPanelWhereInput>>;
  clinicEmployee?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringNullableFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  date?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringNullableFilter>;
  notes?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  sourceName?: Maybe<StringNullableFilter>;
  status?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LabPanelWhereUniqueInput = {
  AND?: Maybe<Array<LabPanelWhereInput>>;
  LabResult?: Maybe<LabResultListRelationFilter>;
  NOT?: Maybe<Array<LabPanelWhereInput>>;
  OR?: Maybe<Array<LabPanelWhereInput>>;
  clinicEmployee?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringNullableFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  date?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  labPanelPimsIdAndIntegrationId?: Maybe<LabPanelLabPanelPimsIdAndIntegrationIdCompoundUniqueInput>;
  name?: Maybe<StringNullableFilter>;
  notes?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  sourceName?: Maybe<StringNullableFilter>;
  status?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LabResult = {
  __typename?: 'LabResult';
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  indicator?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  labPanel?: Maybe<LabPanel>;
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type LabResultIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type LabResultLabPanelArgs = {
  where?: Maybe<LabPanelWhereInput>;
};

export type LabResultCountAggregateOutputType = {
  __typename?: 'LabResultCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  date: Scalars['Int'];
  id: Scalars['Int'];
  indicator: Scalars['Int'];
  integrationId: Scalars['Int'];
  isDeleted: Scalars['Int'];
  labPanelId: Scalars['Int'];
  name: Scalars['Int'];
  notes: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  referenceCriticalHigh: Scalars['Int'];
  referenceCriticalLow: Scalars['Int'];
  referenceHigh: Scalars['Int'];
  referenceLow: Scalars['Int'];
  referenceRange: Scalars['Int'];
  result: Scalars['Int'];
  unitOfMeasure: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LabResultCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  indicator?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  labPanelId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  referenceCriticalHigh?: Maybe<SortOrder>;
  referenceCriticalLow?: Maybe<SortOrder>;
  referenceHigh?: Maybe<SortOrder>;
  referenceLow?: Maybe<SortOrder>;
  referenceRange?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  unitOfMeasure?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LabResultCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutLabResultInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanel?: Maybe<LabPanelCreateNestedOneWithoutLabResultInput>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultCreateManyIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultCreateManyIntegrationInputEnvelope = {
  data: Array<LabResultCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LabResultCreateManyLabPanelInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultCreateManyLabPanelInputEnvelope = {
  data: Array<LabResultCreateManyLabPanelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LabResultCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<LabResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabResultCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<LabResultCreateWithoutIntegrationInput>>;
  createMany?: Maybe<LabResultCreateManyIntegrationInputEnvelope>;
};

export type LabResultCreateNestedManyWithoutLabPanelInput = {
  connect?: Maybe<Array<LabResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabResultCreateOrConnectWithoutLabPanelInput>>;
  create?: Maybe<Array<LabResultCreateWithoutLabPanelInput>>;
  createMany?: Maybe<LabResultCreateManyLabPanelInputEnvelope>;
};

export type LabResultCreateOrConnectWithoutIntegrationInput = {
  create: LabResultCreateWithoutIntegrationInput;
  where: LabResultWhereUniqueInput;
};

export type LabResultCreateOrConnectWithoutLabPanelInput = {
  create: LabResultCreateWithoutLabPanelInput;
  where: LabResultWhereUniqueInput;
};

export type LabResultCreateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanel?: Maybe<LabPanelCreateNestedOneWithoutLabResultInput>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultCreateWithoutLabPanelInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutLabResultInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultGroupByOutputType = {
  __typename?: 'LabResultGroupByOutputType';
  _count?: Maybe<LabResultCountAggregateOutputType>;
  _max?: Maybe<LabResultMaxAggregateOutputType>;
  _min?: Maybe<LabResultMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  indicator?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type LabResultLabResultPimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type LabResultListRelationFilter = {
  every?: Maybe<LabResultWhereInput>;
  none?: Maybe<LabResultWhereInput>;
  some?: Maybe<LabResultWhereInput>;
};

export type LabResultMaxAggregateOutputType = {
  __typename?: 'LabResultMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  indicator?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  labPanelId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  referenceCriticalHigh?: Maybe<SortOrder>;
  referenceCriticalLow?: Maybe<SortOrder>;
  referenceHigh?: Maybe<SortOrder>;
  referenceLow?: Maybe<SortOrder>;
  referenceRange?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  unitOfMeasure?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LabResultMinAggregateOutputType = {
  __typename?: 'LabResultMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  indicator?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  labPanelId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  referenceCriticalHigh?: Maybe<SortOrder>;
  referenceCriticalLow?: Maybe<SortOrder>;
  referenceHigh?: Maybe<SortOrder>;
  referenceLow?: Maybe<SortOrder>;
  referenceRange?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  unitOfMeasure?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LabResultOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LabResultOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LabResultOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  indicator?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  labPanel?: Maybe<LabPanelOrderByWithRelationInput>;
  labPanelId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  referenceCriticalHigh?: Maybe<SortOrder>;
  referenceCriticalLow?: Maybe<SortOrder>;
  referenceHigh?: Maybe<SortOrder>;
  referenceLow?: Maybe<SortOrder>;
  referenceRange?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  unitOfMeasure?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LabResultOrderByRelevanceFieldEnum {
  Id = 'id',
  Indicator = 'indicator',
  IntegrationId = 'integrationId',
  LabPanelId = 'labPanelId',
  Name = 'name',
  Notes = 'notes',
  PimsId = 'pimsId',
  ReferenceCriticalHigh = 'referenceCriticalHigh',
  ReferenceCriticalLow = 'referenceCriticalLow',
  ReferenceHigh = 'referenceHigh',
  ReferenceLow = 'referenceLow',
  ReferenceRange = 'referenceRange',
  Result = 'result',
  UnitOfMeasure = 'unitOfMeasure'
}

export type LabResultOrderByRelevanceInput = {
  fields: Array<LabResultOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LabResultOrderByWithAggregationInput = {
  _count?: Maybe<LabResultCountOrderByAggregateInput>;
  _max?: Maybe<LabResultMaxOrderByAggregateInput>;
  _min?: Maybe<LabResultMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  indicator?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  labPanelId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  referenceCriticalHigh?: Maybe<SortOrder>;
  referenceCriticalLow?: Maybe<SortOrder>;
  referenceHigh?: Maybe<SortOrder>;
  referenceLow?: Maybe<SortOrder>;
  referenceRange?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  unitOfMeasure?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LabResultOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LabResultOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  indicator?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  labPanel?: Maybe<LabPanelOrderByWithRelationInput>;
  labPanelId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  referenceCriticalHigh?: Maybe<SortOrder>;
  referenceCriticalLow?: Maybe<SortOrder>;
  referenceHigh?: Maybe<SortOrder>;
  referenceLow?: Maybe<SortOrder>;
  referenceRange?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  unitOfMeasure?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LabResultOrderByWithRelationInput = {
  _relevance?: Maybe<LabResultOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  indicator?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  labPanel?: Maybe<LabPanelOrderByWithRelationInput>;
  labPanelId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notes?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  referenceCriticalHigh?: Maybe<SortOrder>;
  referenceCriticalLow?: Maybe<SortOrder>;
  referenceHigh?: Maybe<SortOrder>;
  referenceLow?: Maybe<SortOrder>;
  referenceRange?: Maybe<SortOrder>;
  result?: Maybe<SortOrder>;
  unitOfMeasure?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LabResultScalarFieldEnum {
  CreatedAt = 'createdAt',
  Date = 'date',
  Id = 'id',
  Indicator = 'indicator',
  IntegrationId = 'integrationId',
  IsDeleted = 'isDeleted',
  LabPanelId = 'labPanelId',
  Name = 'name',
  Notes = 'notes',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  ReferenceCriticalHigh = 'referenceCriticalHigh',
  ReferenceCriticalLow = 'referenceCriticalLow',
  ReferenceHigh = 'referenceHigh',
  ReferenceLow = 'referenceLow',
  ReferenceRange = 'referenceRange',
  Result = 'result',
  UnitOfMeasure = 'unitOfMeasure',
  UpdatedAt = 'updatedAt'
}

export type LabResultScalarWhereInput = {
  AND?: Maybe<Array<LabResultScalarWhereInput>>;
  NOT?: Maybe<Array<LabResultScalarWhereInput>>;
  OR?: Maybe<Array<LabResultScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  date?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  indicator?: Maybe<StringNullableFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  labPanelId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringNullableFilter>;
  notes?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  referenceCriticalHigh?: Maybe<StringNullableFilter>;
  referenceCriticalLow?: Maybe<StringNullableFilter>;
  referenceHigh?: Maybe<StringNullableFilter>;
  referenceLow?: Maybe<StringNullableFilter>;
  referenceRange?: Maybe<StringNullableFilter>;
  result?: Maybe<StringNullableFilter>;
  unitOfMeasure?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LabResultScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LabResultScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LabResultScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LabResultScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  date?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  indicator?: Maybe<StringNullableWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  labPanelId?: Maybe<StringNullableWithAggregatesFilter>;
  name?: Maybe<StringNullableWithAggregatesFilter>;
  notes?: Maybe<StringNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  referenceCriticalHigh?: Maybe<StringNullableWithAggregatesFilter>;
  referenceCriticalLow?: Maybe<StringNullableWithAggregatesFilter>;
  referenceHigh?: Maybe<StringNullableWithAggregatesFilter>;
  referenceLow?: Maybe<StringNullableWithAggregatesFilter>;
  referenceRange?: Maybe<StringNullableWithAggregatesFilter>;
  result?: Maybe<StringNullableWithAggregatesFilter>;
  unitOfMeasure?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type LabResultUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<LabResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabResultCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<LabResultCreateWithoutIntegrationInput>>;
  createMany?: Maybe<LabResultCreateManyIntegrationInputEnvelope>;
};

export type LabResultUncheckedCreateNestedManyWithoutLabPanelInput = {
  connect?: Maybe<Array<LabResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabResultCreateOrConnectWithoutLabPanelInput>>;
  create?: Maybe<Array<LabResultCreateWithoutLabPanelInput>>;
  createMany?: Maybe<LabResultCreateManyLabPanelInputEnvelope>;
};

export type LabResultUncheckedCreateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUncheckedCreateWithoutLabPanelInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUncheckedUpdateManyWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<LabResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabResultCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<LabResultCreateWithoutIntegrationInput>>;
  createMany?: Maybe<LabResultCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<LabResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LabResultScalarWhereInput>>;
  disconnect?: Maybe<Array<LabResultWhereUniqueInput>>;
  set?: Maybe<Array<LabResultWhereUniqueInput>>;
  update?: Maybe<Array<LabResultUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<LabResultUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<LabResultUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type LabResultUncheckedUpdateManyWithoutLabPanelInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUncheckedUpdateManyWithoutLabPanelNestedInput = {
  connect?: Maybe<Array<LabResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabResultCreateOrConnectWithoutLabPanelInput>>;
  create?: Maybe<Array<LabResultCreateWithoutLabPanelInput>>;
  createMany?: Maybe<LabResultCreateManyLabPanelInputEnvelope>;
  delete?: Maybe<Array<LabResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LabResultScalarWhereInput>>;
  disconnect?: Maybe<Array<LabResultWhereUniqueInput>>;
  set?: Maybe<Array<LabResultWhereUniqueInput>>;
  update?: Maybe<Array<LabResultUpdateWithWhereUniqueWithoutLabPanelInput>>;
  updateMany?: Maybe<Array<LabResultUpdateManyWithWhereWithoutLabPanelInput>>;
  upsert?: Maybe<Array<LabResultUpsertWithWhereUniqueWithoutLabPanelInput>>;
};

export type LabResultUncheckedUpdateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanelId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUncheckedUpdateWithoutLabPanelInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutLabResultNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanel?: Maybe<LabPanelUpdateOneWithoutLabResultNestedInput>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUpdateManyWithWhereWithoutIntegrationInput = {
  data: LabResultUpdateManyMutationInput;
  where: LabResultScalarWhereInput;
};

export type LabResultUpdateManyWithWhereWithoutLabPanelInput = {
  data: LabResultUpdateManyMutationInput;
  where: LabResultScalarWhereInput;
};

export type LabResultUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<LabResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabResultCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<LabResultCreateWithoutIntegrationInput>>;
  createMany?: Maybe<LabResultCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<LabResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LabResultScalarWhereInput>>;
  disconnect?: Maybe<Array<LabResultWhereUniqueInput>>;
  set?: Maybe<Array<LabResultWhereUniqueInput>>;
  update?: Maybe<Array<LabResultUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<LabResultUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<LabResultUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type LabResultUpdateManyWithoutLabPanelNestedInput = {
  connect?: Maybe<Array<LabResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LabResultCreateOrConnectWithoutLabPanelInput>>;
  create?: Maybe<Array<LabResultCreateWithoutLabPanelInput>>;
  createMany?: Maybe<LabResultCreateManyLabPanelInputEnvelope>;
  delete?: Maybe<Array<LabResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LabResultScalarWhereInput>>;
  disconnect?: Maybe<Array<LabResultWhereUniqueInput>>;
  set?: Maybe<Array<LabResultWhereUniqueInput>>;
  update?: Maybe<Array<LabResultUpdateWithWhereUniqueWithoutLabPanelInput>>;
  updateMany?: Maybe<Array<LabResultUpdateManyWithWhereWithoutLabPanelInput>>;
  upsert?: Maybe<Array<LabResultUpsertWithWhereUniqueWithoutLabPanelInput>>;
};

export type LabResultUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: LabResultUpdateWithoutIntegrationInput;
  where: LabResultWhereUniqueInput;
};

export type LabResultUpdateWithWhereUniqueWithoutLabPanelInput = {
  data: LabResultUpdateWithoutLabPanelInput;
  where: LabResultWhereUniqueInput;
};

export type LabResultUpdateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  labPanel?: Maybe<LabPanelUpdateOneWithoutLabResultNestedInput>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUpdateWithoutLabPanelInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutLabResultNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  referenceCriticalHigh?: Maybe<Scalars['String']>;
  referenceCriticalLow?: Maybe<Scalars['String']>;
  referenceHigh?: Maybe<Scalars['String']>;
  referenceLow?: Maybe<Scalars['String']>;
  referenceRange?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabResultUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: LabResultCreateWithoutIntegrationInput;
  update: LabResultUpdateWithoutIntegrationInput;
  where: LabResultWhereUniqueInput;
};

export type LabResultUpsertWithWhereUniqueWithoutLabPanelInput = {
  create: LabResultCreateWithoutLabPanelInput;
  update: LabResultUpdateWithoutLabPanelInput;
  where: LabResultWhereUniqueInput;
};

export type LabResultWhereInput = {
  AND?: Maybe<Array<LabResultWhereInput>>;
  NOT?: Maybe<Array<LabResultWhereInput>>;
  OR?: Maybe<Array<LabResultWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  date?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  indicator?: Maybe<StringNullableFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  labPanel?: Maybe<LabPanelNullableScalarRelationFilter>;
  labPanelId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringNullableFilter>;
  notes?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  referenceCriticalHigh?: Maybe<StringNullableFilter>;
  referenceCriticalLow?: Maybe<StringNullableFilter>;
  referenceHigh?: Maybe<StringNullableFilter>;
  referenceLow?: Maybe<StringNullableFilter>;
  referenceRange?: Maybe<StringNullableFilter>;
  result?: Maybe<StringNullableFilter>;
  unitOfMeasure?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LabResultWhereUniqueInput = {
  AND?: Maybe<Array<LabResultWhereInput>>;
  NOT?: Maybe<Array<LabResultWhereInput>>;
  OR?: Maybe<Array<LabResultWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  date?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  indicator?: Maybe<StringNullableFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  labPanel?: Maybe<LabPanelNullableScalarRelationFilter>;
  labPanelId?: Maybe<StringNullableFilter>;
  labResultPimsIdAndIntegrationId?: Maybe<LabResultLabResultPimsIdAndIntegrationIdCompoundUniqueInput>;
  name?: Maybe<StringNullableFilter>;
  notes?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  referenceCriticalHigh?: Maybe<StringNullableFilter>;
  referenceCriticalLow?: Maybe<StringNullableFilter>;
  referenceHigh?: Maybe<StringNullableFilter>;
  referenceLow?: Maybe<StringNullableFilter>;
  referenceRange?: Maybe<StringNullableFilter>;
  result?: Maybe<StringNullableFilter>;
  unitOfMeasure?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LapsedPetParentTriggers = {
  __typename?: 'LapsedPetParentTriggers';
  automation: WorkflowEventSetting;
  automationId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isQueued: Scalars['Boolean'];
  triggerAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type LapsedPetParentTriggersAutomationIdClinicPetParentIdCompoundUniqueInput = {
  automationId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
};

export type LapsedPetParentTriggersCountAggregateOutputType = {
  __typename?: 'LapsedPetParentTriggersCountAggregateOutputType';
  _all: Scalars['Int'];
  automationId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isQueued: Scalars['Int'];
  triggerAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LapsedPetParentTriggersCountOrderByAggregateInput = {
  automationId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isQueued?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LapsedPetParentTriggersCreateInput = {
  automation: WorkflowEventSettingCreateNestedOneWithoutLapsedPetParentTriggersInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutLapsedPetParentTriggersInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersCreateManyAutomationInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersCreateManyAutomationInputEnvelope = {
  data: Array<LapsedPetParentTriggersCreateManyAutomationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LapsedPetParentTriggersCreateManyClinicPetParentInput = {
  automationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersCreateManyClinicPetParentInputEnvelope = {
  data: Array<LapsedPetParentTriggersCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LapsedPetParentTriggersCreateManyInput = {
  automationId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput = {
  connect?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LapsedPetParentTriggersCreateOrConnectWithoutAutomationInput>>;
  create?: Maybe<Array<LapsedPetParentTriggersCreateWithoutAutomationInput>>;
  createMany?: Maybe<LapsedPetParentTriggersCreateManyAutomationInputEnvelope>;
};

export type LapsedPetParentTriggersCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LapsedPetParentTriggersCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<LapsedPetParentTriggersCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<LapsedPetParentTriggersCreateManyClinicPetParentInputEnvelope>;
};

export type LapsedPetParentTriggersCreateOrConnectWithoutAutomationInput = {
  create: LapsedPetParentTriggersCreateWithoutAutomationInput;
  where: LapsedPetParentTriggersWhereUniqueInput;
};

export type LapsedPetParentTriggersCreateOrConnectWithoutClinicPetParentInput = {
  create: LapsedPetParentTriggersCreateWithoutClinicPetParentInput;
  where: LapsedPetParentTriggersWhereUniqueInput;
};

export type LapsedPetParentTriggersCreateWithoutAutomationInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutLapsedPetParentTriggersInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersCreateWithoutClinicPetParentInput = {
  automation: WorkflowEventSettingCreateNestedOneWithoutLapsedPetParentTriggersInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersGroupByOutputType = {
  __typename?: 'LapsedPetParentTriggersGroupByOutputType';
  _count?: Maybe<LapsedPetParentTriggersCountAggregateOutputType>;
  _max?: Maybe<LapsedPetParentTriggersMaxAggregateOutputType>;
  _min?: Maybe<LapsedPetParentTriggersMinAggregateOutputType>;
  automationId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isQueued: Scalars['Boolean'];
  triggerAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type LapsedPetParentTriggersListRelationFilter = {
  every?: Maybe<LapsedPetParentTriggersWhereInput>;
  none?: Maybe<LapsedPetParentTriggersWhereInput>;
  some?: Maybe<LapsedPetParentTriggersWhereInput>;
};

export type LapsedPetParentTriggersMaxAggregateOutputType = {
  __typename?: 'LapsedPetParentTriggersMaxAggregateOutputType';
  automationId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersMaxOrderByAggregateInput = {
  automationId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isQueued?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LapsedPetParentTriggersMinAggregateOutputType = {
  __typename?: 'LapsedPetParentTriggersMinAggregateOutputType';
  automationId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersMinOrderByAggregateInput = {
  automationId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isQueued?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LapsedPetParentTriggersOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LapsedPetParentTriggersOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LapsedPetParentTriggersOrderByRelevanceInput>;
  automation?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  automationId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isQueued?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LapsedPetParentTriggersOrderByRelevanceFieldEnum {
  AutomationId = 'automationId',
  ClinicPetParentId = 'clinicPetParentId',
  Id = 'id'
}

export type LapsedPetParentTriggersOrderByRelevanceInput = {
  fields: Array<LapsedPetParentTriggersOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LapsedPetParentTriggersOrderByWithAggregationInput = {
  _count?: Maybe<LapsedPetParentTriggersCountOrderByAggregateInput>;
  _max?: Maybe<LapsedPetParentTriggersMaxOrderByAggregateInput>;
  _min?: Maybe<LapsedPetParentTriggersMinOrderByAggregateInput>;
  automationId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isQueued?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LapsedPetParentTriggersOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LapsedPetParentTriggersOrderByRelevanceInput>;
  automation?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  automationId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isQueued?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LapsedPetParentTriggersOrderByWithRelationInput = {
  _relevance?: Maybe<LapsedPetParentTriggersOrderByRelevanceInput>;
  automation?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  automationId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isQueued?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LapsedPetParentTriggersScalarFieldEnum {
  AutomationId = 'automationId',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  IsQueued = 'isQueued',
  TriggerAt = 'triggerAt',
  UpdatedAt = 'updatedAt'
}

export type LapsedPetParentTriggersScalarWhereInput = {
  AND?: Maybe<Array<LapsedPetParentTriggersScalarWhereInput>>;
  NOT?: Maybe<Array<LapsedPetParentTriggersScalarWhereInput>>;
  OR?: Maybe<Array<LapsedPetParentTriggersScalarWhereInput>>;
  automationId?: Maybe<StringFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isQueued?: Maybe<BoolFilter>;
  triggerAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LapsedPetParentTriggersScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LapsedPetParentTriggersScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LapsedPetParentTriggersScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LapsedPetParentTriggersScalarWhereWithAggregatesInput>>;
  automationId?: Maybe<StringWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  isQueued?: Maybe<BoolWithAggregatesFilter>;
  triggerAt?: Maybe<DateTimeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type LapsedPetParentTriggersUncheckedCreateInput = {
  automationId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput = {
  connect?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LapsedPetParentTriggersCreateOrConnectWithoutAutomationInput>>;
  create?: Maybe<Array<LapsedPetParentTriggersCreateWithoutAutomationInput>>;
  createMany?: Maybe<LapsedPetParentTriggersCreateManyAutomationInputEnvelope>;
};

export type LapsedPetParentTriggersUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LapsedPetParentTriggersCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<LapsedPetParentTriggersCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<LapsedPetParentTriggersCreateManyClinicPetParentInputEnvelope>;
};

export type LapsedPetParentTriggersUncheckedCreateWithoutAutomationInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUncheckedCreateWithoutClinicPetParentInput = {
  automationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUncheckedUpdateInput = {
  automationId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUncheckedUpdateManyInput = {
  automationId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput = {
  connect?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LapsedPetParentTriggersCreateOrConnectWithoutAutomationInput>>;
  create?: Maybe<Array<LapsedPetParentTriggersCreateWithoutAutomationInput>>;
  createMany?: Maybe<LapsedPetParentTriggersCreateManyAutomationInputEnvelope>;
  delete?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LapsedPetParentTriggersScalarWhereInput>>;
  disconnect?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  set?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  update?: Maybe<Array<LapsedPetParentTriggersUpdateWithWhereUniqueWithoutAutomationInput>>;
  updateMany?: Maybe<Array<LapsedPetParentTriggersUpdateManyWithWhereWithoutAutomationInput>>;
  upsert?: Maybe<Array<LapsedPetParentTriggersUpsertWithWhereUniqueWithoutAutomationInput>>;
};

export type LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentInput = {
  automationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LapsedPetParentTriggersCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<LapsedPetParentTriggersCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<LapsedPetParentTriggersCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LapsedPetParentTriggersScalarWhereInput>>;
  disconnect?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  set?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  update?: Maybe<Array<LapsedPetParentTriggersUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<LapsedPetParentTriggersUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<LapsedPetParentTriggersUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type LapsedPetParentTriggersUncheckedUpdateWithoutAutomationInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUncheckedUpdateWithoutClinicPetParentInput = {
  automationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUpdateInput = {
  automation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutLapsedPetParentTriggersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutLapsedPetParentTriggersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUpdateManyWithWhereWithoutAutomationInput = {
  data: LapsedPetParentTriggersUpdateManyMutationInput;
  where: LapsedPetParentTriggersScalarWhereInput;
};

export type LapsedPetParentTriggersUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: LapsedPetParentTriggersUpdateManyMutationInput;
  where: LapsedPetParentTriggersScalarWhereInput;
};

export type LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput = {
  connect?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LapsedPetParentTriggersCreateOrConnectWithoutAutomationInput>>;
  create?: Maybe<Array<LapsedPetParentTriggersCreateWithoutAutomationInput>>;
  createMany?: Maybe<LapsedPetParentTriggersCreateManyAutomationInputEnvelope>;
  delete?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LapsedPetParentTriggersScalarWhereInput>>;
  disconnect?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  set?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  update?: Maybe<Array<LapsedPetParentTriggersUpdateWithWhereUniqueWithoutAutomationInput>>;
  updateMany?: Maybe<Array<LapsedPetParentTriggersUpdateManyWithWhereWithoutAutomationInput>>;
  upsert?: Maybe<Array<LapsedPetParentTriggersUpsertWithWhereUniqueWithoutAutomationInput>>;
};

export type LapsedPetParentTriggersUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LapsedPetParentTriggersCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<LapsedPetParentTriggersCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<LapsedPetParentTriggersCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LapsedPetParentTriggersScalarWhereInput>>;
  disconnect?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  set?: Maybe<Array<LapsedPetParentTriggersWhereUniqueInput>>;
  update?: Maybe<Array<LapsedPetParentTriggersUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<LapsedPetParentTriggersUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<LapsedPetParentTriggersUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type LapsedPetParentTriggersUpdateWithWhereUniqueWithoutAutomationInput = {
  data: LapsedPetParentTriggersUpdateWithoutAutomationInput;
  where: LapsedPetParentTriggersWhereUniqueInput;
};

export type LapsedPetParentTriggersUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: LapsedPetParentTriggersUpdateWithoutClinicPetParentInput;
  where: LapsedPetParentTriggersWhereUniqueInput;
};

export type LapsedPetParentTriggersUpdateWithoutAutomationInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutLapsedPetParentTriggersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUpdateWithoutClinicPetParentInput = {
  automation?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutLapsedPetParentTriggersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isQueued?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LapsedPetParentTriggersUpsertWithWhereUniqueWithoutAutomationInput = {
  create: LapsedPetParentTriggersCreateWithoutAutomationInput;
  update: LapsedPetParentTriggersUpdateWithoutAutomationInput;
  where: LapsedPetParentTriggersWhereUniqueInput;
};

export type LapsedPetParentTriggersUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: LapsedPetParentTriggersCreateWithoutClinicPetParentInput;
  update: LapsedPetParentTriggersUpdateWithoutClinicPetParentInput;
  where: LapsedPetParentTriggersWhereUniqueInput;
};

export type LapsedPetParentTriggersWhereInput = {
  AND?: Maybe<Array<LapsedPetParentTriggersWhereInput>>;
  NOT?: Maybe<Array<LapsedPetParentTriggersWhereInput>>;
  OR?: Maybe<Array<LapsedPetParentTriggersWhereInput>>;
  automation?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  automationId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isQueued?: Maybe<BoolFilter>;
  triggerAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LapsedPetParentTriggersWhereUniqueInput = {
  AND?: Maybe<Array<LapsedPetParentTriggersWhereInput>>;
  NOT?: Maybe<Array<LapsedPetParentTriggersWhereInput>>;
  OR?: Maybe<Array<LapsedPetParentTriggersWhereInput>>;
  automation?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  automationId?: Maybe<StringFilter>;
  automationId_clinicPetParentId?: Maybe<LapsedPetParentTriggersAutomationIdClinicPetParentIdCompoundUniqueInput>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<BoolFilter>;
  isQueued?: Maybe<BoolFilter>;
  triggerAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LegalEntity = {
  __typename?: 'LegalEntity';
  _count: LegalEntityCountOutputType;
  clinics: Array<Clinic>;
  createdAt: Scalars['DateTime'];
  ein: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: LegalEntityType;
  updatedAt: Scalars['DateTime'];
};


export type LegalEntityClinicsArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};

export type LegalEntityCountAggregateOutputType = {
  __typename?: 'LegalEntityCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  ein: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LegalEntityCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  ein?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LegalEntityCountOutputType = {
  __typename?: 'LegalEntityCountOutputType';
  clinics: Scalars['Int'];
};

export type LegalEntityCreateInput = {
  clinics?: Maybe<ClinicCreateNestedManyWithoutLegalEntityInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ein: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: LegalEntityType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  ein: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: LegalEntityType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityCreateNestedOneWithoutClinicsInput = {
  connect?: Maybe<LegalEntityWhereUniqueInput>;
  connectOrCreate?: Maybe<LegalEntityCreateOrConnectWithoutClinicsInput>;
  create?: Maybe<LegalEntityCreateWithoutClinicsInput>;
};

export type LegalEntityCreateOrConnectWithoutClinicsInput = {
  create: LegalEntityCreateWithoutClinicsInput;
  where: LegalEntityWhereUniqueInput;
};

export type LegalEntityCreateWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  ein: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: LegalEntityType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityGroupByOutputType = {
  __typename?: 'LegalEntityGroupByOutputType';
  _count?: Maybe<LegalEntityCountAggregateOutputType>;
  _max?: Maybe<LegalEntityMaxAggregateOutputType>;
  _min?: Maybe<LegalEntityMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  ein: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: LegalEntityType;
  updatedAt: Scalars['DateTime'];
};

export type LegalEntityMaxAggregateOutputType = {
  __typename?: 'LegalEntityMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  ein?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<LegalEntityType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  ein?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LegalEntityMinAggregateOutputType = {
  __typename?: 'LegalEntityMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  ein?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<LegalEntityType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  ein?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LegalEntityNullableScalarRelationFilter = {
  AND?: Maybe<Array<LegalEntityWhereInput>>;
  NOT?: Maybe<Array<LegalEntityWhereInput>>;
  OR?: Maybe<Array<LegalEntityWhereInput>>;
  clinics?: Maybe<ClinicListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  ein?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<EnumLegalEntityTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LegalEntityOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LegalEntityOrderByRelevanceInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  ein?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LegalEntityOrderByRelevanceFieldEnum {
  Ein = 'ein',
  Id = 'id',
  Name = 'name'
}

export type LegalEntityOrderByRelevanceInput = {
  fields: Array<LegalEntityOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LegalEntityOrderByWithAggregationInput = {
  _count?: Maybe<LegalEntityCountOrderByAggregateInput>;
  _max?: Maybe<LegalEntityMaxOrderByAggregateInput>;
  _min?: Maybe<LegalEntityMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  ein?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LegalEntityOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LegalEntityOrderByRelevanceInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  ein?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LegalEntityOrderByWithRelationInput = {
  _relevance?: Maybe<LegalEntityOrderByRelevanceInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  ein?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LegalEntityScalarFieldEnum {
  CreatedAt = 'createdAt',
  Ein = 'ein',
  Id = 'id',
  Name = 'name',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type LegalEntityScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LegalEntityScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LegalEntityScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LegalEntityScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  ein?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumLegalEntityTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum LegalEntityType {
  GovernmentalUnit = 'GOVERNMENTAL_UNIT',
  GovernmentInstrumentality = 'GOVERNMENT_INSTRUMENTALITY',
  IncorporatedNonProfit = 'INCORPORATED_NON_PROFIT',
  MultiMemberLlc = 'MULTI_MEMBER_LLC',
  PrivateCorporation = 'PRIVATE_CORPORATION',
  PrivatePartnership = 'PRIVATE_PARTNERSHIP',
  PublicCorporation = 'PUBLIC_CORPORATION',
  PublicPartnership = 'PUBLIC_PARTNERSHIP',
  SingleMemberLlc = 'SINGLE_MEMBER_LLC',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP',
  TaxExemptGovernmentInstrumentality = 'TAX_EXEMPT_GOVERNMENT_INSTRUMENTALITY',
  UnincorporatedAssociation = 'UNINCORPORATED_ASSOCIATION',
  UnincorporatedNonProfit = 'UNINCORPORATED_NON_PROFIT'
}

export type LegalEntityUncheckedCreateInput = {
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutLegalEntityInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ein: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: LegalEntityType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityUncheckedCreateWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  ein: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: LegalEntityType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityUncheckedUpdateInput = {
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutLegalEntityNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ein?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<LegalEntityType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  ein?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<LegalEntityType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityUncheckedUpdateWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  ein?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<LegalEntityType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityUpdateInput = {
  clinics?: Maybe<ClinicUpdateManyWithoutLegalEntityNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ein?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<LegalEntityType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  ein?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<LegalEntityType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityUpdateOneWithoutClinicsNestedInput = {
  connect?: Maybe<LegalEntityWhereUniqueInput>;
  connectOrCreate?: Maybe<LegalEntityCreateOrConnectWithoutClinicsInput>;
  create?: Maybe<LegalEntityCreateWithoutClinicsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LegalEntityUpdateToOneWithWhereWithoutClinicsInput>;
  upsert?: Maybe<LegalEntityUpsertWithoutClinicsInput>;
};

export type LegalEntityUpdateToOneWithWhereWithoutClinicsInput = {
  data: LegalEntityUpdateWithoutClinicsInput;
  where?: Maybe<LegalEntityWhereInput>;
};

export type LegalEntityUpdateWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  ein?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<LegalEntityType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegalEntityUpsertWithoutClinicsInput = {
  create: LegalEntityCreateWithoutClinicsInput;
  update: LegalEntityUpdateWithoutClinicsInput;
  where?: Maybe<LegalEntityWhereInput>;
};

export type LegalEntityWhereInput = {
  AND?: Maybe<Array<LegalEntityWhereInput>>;
  NOT?: Maybe<Array<LegalEntityWhereInput>>;
  OR?: Maybe<Array<LegalEntityWhereInput>>;
  clinics?: Maybe<ClinicListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  ein?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<EnumLegalEntityTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LegalEntityWhereUniqueInput = {
  AND?: Maybe<Array<LegalEntityWhereInput>>;
  NOT?: Maybe<Array<LegalEntityWhereInput>>;
  OR?: Maybe<Array<LegalEntityWhereInput>>;
  clinics?: Maybe<ClinicListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  ein?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<StringFilter>;
  type?: Maybe<EnumLegalEntityTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoginLinkOutput = {
  __typename?: 'LoginLinkOutput';
  url: Scalars['String'];
};

export type LoyaltyAccount = {
  __typename?: 'LoyaltyAccount';
  _count: LoyaltyAccountCountOutputType;
  accountHolders: Array<LoyaltyAccountHolder>;
  createdAt: Scalars['DateTime'];
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  /** leftover balance from running total point systems */
  leftOverSpend: Scalars['Int'];
  mergeSent?: Maybe<LoyaltyAccountMerger>;
  mergesTaken: Array<LoyaltyAccountMerger>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  /** how many points an account has */
  pointBalance: Scalars['Int'];
  pointDeltas: Array<LoyaltyPointDelta>;
  program: LoyaltyProgram;
  programId: Scalars['String'];
  rewardRedemptions: Array<LoyaltyRewardRedemption>;
  updatedAt: Scalars['DateTime'];
};


export type LoyaltyAccountAccountHoldersArgs = {
  cursor?: Maybe<LoyaltyAccountHolderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountHolderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountHolderOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};


export type LoyaltyAccountMergeSentArgs = {
  where?: Maybe<LoyaltyAccountMergerWhereInput>;
};


export type LoyaltyAccountMergesTakenArgs = {
  cursor?: Maybe<LoyaltyAccountMergerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountMergerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountMergerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountMergerWhereInput>;
};


export type LoyaltyAccountPointDeltasArgs = {
  cursor?: Maybe<LoyaltyPointDeltaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointDeltaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointDeltaOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
};


export type LoyaltyAccountRewardRedemptionsArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardRedemptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionWhereInput>;
};

export type LoyaltyAccountAvgAggregateOutputType = {
  __typename?: 'LoyaltyAccountAvgAggregateOutputType';
  leftOverSpend?: Maybe<Scalars['Float']>;
  pointBalance?: Maybe<Scalars['Float']>;
};

export type LoyaltyAccountAvgOrderByAggregateInput = {
  leftOverSpend?: Maybe<SortOrder>;
  pointBalance?: Maybe<SortOrder>;
};

export type LoyaltyAccountCountAggregateOutputType = {
  __typename?: 'LoyaltyAccountCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deactivationDate: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  leftOverSpend: Scalars['Int'];
  migratedAt: Scalars['Int'];
  pointBalance: Scalars['Int'];
  programId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LoyaltyAccountCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  deactivationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  leftOverSpend?: Maybe<SortOrder>;
  migratedAt?: Maybe<SortOrder>;
  pointBalance?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyAccountCountOutputType = {
  __typename?: 'LoyaltyAccountCountOutputType';
  accountHolders: Scalars['Int'];
  mergesTaken: Scalars['Int'];
  pointDeltas: Scalars['Int'];
  rewardRedemptions: Scalars['Int'];
};

export type LoyaltyAccountCreateInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderCreateNestedManyWithoutAccountInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerCreateNestedOneWithoutMergeDataFromAccountInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutMergeDataIntoAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutAccountInput>;
  program: LoyaltyProgramCreateNestedOneWithoutAccountsInput;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionCreateNestedManyWithoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountCreateManyProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountCreateManyProgramInputEnvelope = {
  data: Array<LoyaltyAccountCreateManyProgramInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyAccountCreateNestedManyWithoutProgramInput = {
  connect?: Maybe<Array<LoyaltyAccountWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyAccountCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyAccountCreateManyProgramInputEnvelope>;
};

export type LoyaltyAccountCreateNestedOneWithoutAccountHoldersInput = {
  connect?: Maybe<LoyaltyAccountWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountCreateOrConnectWithoutAccountHoldersInput>;
  create?: Maybe<LoyaltyAccountCreateWithoutAccountHoldersInput>;
};

export type LoyaltyAccountCreateNestedOneWithoutMergeSentInput = {
  connect?: Maybe<LoyaltyAccountWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountCreateOrConnectWithoutMergeSentInput>;
  create?: Maybe<LoyaltyAccountCreateWithoutMergeSentInput>;
};

export type LoyaltyAccountCreateNestedOneWithoutMergesTakenInput = {
  connect?: Maybe<LoyaltyAccountWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountCreateOrConnectWithoutMergesTakenInput>;
  create?: Maybe<LoyaltyAccountCreateWithoutMergesTakenInput>;
};

export type LoyaltyAccountCreateNestedOneWithoutPointDeltasInput = {
  connect?: Maybe<LoyaltyAccountWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountCreateOrConnectWithoutPointDeltasInput>;
  create?: Maybe<LoyaltyAccountCreateWithoutPointDeltasInput>;
};

export type LoyaltyAccountCreateNestedOneWithoutRewardRedemptionsInput = {
  connect?: Maybe<LoyaltyAccountWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountCreateOrConnectWithoutRewardRedemptionsInput>;
  create?: Maybe<LoyaltyAccountCreateWithoutRewardRedemptionsInput>;
};

export type LoyaltyAccountCreateOrConnectWithoutAccountHoldersInput = {
  create: LoyaltyAccountCreateWithoutAccountHoldersInput;
  where: LoyaltyAccountWhereUniqueInput;
};

export type LoyaltyAccountCreateOrConnectWithoutMergeSentInput = {
  create: LoyaltyAccountCreateWithoutMergeSentInput;
  where: LoyaltyAccountWhereUniqueInput;
};

export type LoyaltyAccountCreateOrConnectWithoutMergesTakenInput = {
  create: LoyaltyAccountCreateWithoutMergesTakenInput;
  where: LoyaltyAccountWhereUniqueInput;
};

export type LoyaltyAccountCreateOrConnectWithoutPointDeltasInput = {
  create: LoyaltyAccountCreateWithoutPointDeltasInput;
  where: LoyaltyAccountWhereUniqueInput;
};

export type LoyaltyAccountCreateOrConnectWithoutProgramInput = {
  create: LoyaltyAccountCreateWithoutProgramInput;
  where: LoyaltyAccountWhereUniqueInput;
};

export type LoyaltyAccountCreateOrConnectWithoutRewardRedemptionsInput = {
  create: LoyaltyAccountCreateWithoutRewardRedemptionsInput;
  where: LoyaltyAccountWhereUniqueInput;
};

export type LoyaltyAccountCreateWithoutAccountHoldersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerCreateNestedOneWithoutMergeDataFromAccountInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutMergeDataIntoAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutAccountInput>;
  program: LoyaltyProgramCreateNestedOneWithoutAccountsInput;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionCreateNestedManyWithoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountCreateWithoutMergeSentInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderCreateNestedManyWithoutAccountInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergesTaken?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutMergeDataIntoAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutAccountInput>;
  program: LoyaltyProgramCreateNestedOneWithoutAccountsInput;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionCreateNestedManyWithoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountCreateWithoutMergesTakenInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderCreateNestedManyWithoutAccountInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerCreateNestedOneWithoutMergeDataFromAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutAccountInput>;
  program: LoyaltyProgramCreateNestedOneWithoutAccountsInput;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionCreateNestedManyWithoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountCreateWithoutPointDeltasInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderCreateNestedManyWithoutAccountInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerCreateNestedOneWithoutMergeDataFromAccountInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutMergeDataIntoAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  program: LoyaltyProgramCreateNestedOneWithoutAccountsInput;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionCreateNestedManyWithoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountCreateWithoutProgramInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderCreateNestedManyWithoutAccountInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerCreateNestedOneWithoutMergeDataFromAccountInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutMergeDataIntoAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutAccountInput>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionCreateNestedManyWithoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountCreateWithoutRewardRedemptionsInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderCreateNestedManyWithoutAccountInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerCreateNestedOneWithoutMergeDataFromAccountInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutMergeDataIntoAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutAccountInput>;
  program: LoyaltyProgramCreateNestedOneWithoutAccountsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountGroupByOutputType = {
  __typename?: 'LoyaltyAccountGroupByOutputType';
  _avg?: Maybe<LoyaltyAccountAvgAggregateOutputType>;
  _count?: Maybe<LoyaltyAccountCountAggregateOutputType>;
  _max?: Maybe<LoyaltyAccountMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyAccountMinAggregateOutputType>;
  _sum?: Maybe<LoyaltyAccountSumAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  leftOverSpend: Scalars['Int'];
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance: Scalars['Int'];
  programId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LoyaltyAccountHolder = {
  __typename?: 'LoyaltyAccountHolder';
  _count: LoyaltyAccountHolderCountOutputType;
  account: LoyaltyAccount;
  accountId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  program: LoyaltyProgram;
  programId: Scalars['String'];
  rewardRedemptionActions: Array<LoyaltyRewardRedemptionHistoryEntry>;
  updatedAt: Scalars['DateTime'];
};


export type LoyaltyAccountHolderRewardRedemptionActionsArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
};

export type LoyaltyAccountHolderClinicPetParentIdAccountIdCompoundUniqueInput = {
  accountId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
};

export type LoyaltyAccountHolderCountAggregateOutputType = {
  __typename?: 'LoyaltyAccountHolderCountAggregateOutputType';
  _all: Scalars['Int'];
  accountId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  programId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LoyaltyAccountHolderCountOrderByAggregateInput = {
  accountId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyAccountHolderCountOutputType = {
  __typename?: 'LoyaltyAccountHolderCountOutputType';
  rewardRedemptionActions: Scalars['Int'];
};

export type LoyaltyAccountHolderCreateInput = {
  account: LoyaltyAccountCreateNestedOneWithoutAccountHoldersInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutLoyaltyAccountHolderInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  program: LoyaltyProgramCreateNestedOneWithoutLoyaltyAccountHoldersInput;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingAccountHolderInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderCreateManyAccountInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderCreateManyAccountInputEnvelope = {
  data: Array<LoyaltyAccountHolderCreateManyAccountInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyAccountHolderCreateManyInput = {
  accountId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderCreateManyProgramInput = {
  accountId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderCreateManyProgramInputEnvelope = {
  data: Array<LoyaltyAccountHolderCreateManyProgramInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyAccountHolderCreateNestedManyWithoutAccountInput = {
  connect?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountHolderCreateOrConnectWithoutAccountInput>>;
  create?: Maybe<Array<LoyaltyAccountHolderCreateWithoutAccountInput>>;
  createMany?: Maybe<LoyaltyAccountHolderCreateManyAccountInputEnvelope>;
};

export type LoyaltyAccountHolderCreateNestedManyWithoutProgramInput = {
  connect?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountHolderCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyAccountHolderCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyAccountHolderCreateManyProgramInputEnvelope>;
};

export type LoyaltyAccountHolderCreateNestedOneWithoutClinicPetParentInput = {
  connect?: Maybe<LoyaltyAccountHolderWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountHolderCreateOrConnectWithoutClinicPetParentInput>;
  create?: Maybe<LoyaltyAccountHolderCreateWithoutClinicPetParentInput>;
};

export type LoyaltyAccountHolderCreateNestedOneWithoutRewardRedemptionActionsInput = {
  connect?: Maybe<LoyaltyAccountHolderWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountHolderCreateOrConnectWithoutRewardRedemptionActionsInput>;
  create?: Maybe<LoyaltyAccountHolderCreateWithoutRewardRedemptionActionsInput>;
};

export type LoyaltyAccountHolderCreateOrConnectWithoutAccountInput = {
  create: LoyaltyAccountHolderCreateWithoutAccountInput;
  where: LoyaltyAccountHolderWhereUniqueInput;
};

export type LoyaltyAccountHolderCreateOrConnectWithoutClinicPetParentInput = {
  create: LoyaltyAccountHolderCreateWithoutClinicPetParentInput;
  where: LoyaltyAccountHolderWhereUniqueInput;
};

export type LoyaltyAccountHolderCreateOrConnectWithoutProgramInput = {
  create: LoyaltyAccountHolderCreateWithoutProgramInput;
  where: LoyaltyAccountHolderWhereUniqueInput;
};

export type LoyaltyAccountHolderCreateOrConnectWithoutRewardRedemptionActionsInput = {
  create: LoyaltyAccountHolderCreateWithoutRewardRedemptionActionsInput;
  where: LoyaltyAccountHolderWhereUniqueInput;
};

export type LoyaltyAccountHolderCreateWithoutAccountInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutLoyaltyAccountHolderInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  program: LoyaltyProgramCreateNestedOneWithoutLoyaltyAccountHoldersInput;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingAccountHolderInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderCreateWithoutClinicPetParentInput = {
  account: LoyaltyAccountCreateNestedOneWithoutAccountHoldersInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  program: LoyaltyProgramCreateNestedOneWithoutLoyaltyAccountHoldersInput;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingAccountHolderInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderCreateWithoutProgramInput = {
  account: LoyaltyAccountCreateNestedOneWithoutAccountHoldersInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutLoyaltyAccountHolderInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingAccountHolderInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderCreateWithoutRewardRedemptionActionsInput = {
  account: LoyaltyAccountCreateNestedOneWithoutAccountHoldersInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutLoyaltyAccountHolderInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  program: LoyaltyProgramCreateNestedOneWithoutLoyaltyAccountHoldersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderGroupByOutputType = {
  __typename?: 'LoyaltyAccountHolderGroupByOutputType';
  _count?: Maybe<LoyaltyAccountHolderCountAggregateOutputType>;
  _max?: Maybe<LoyaltyAccountHolderMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyAccountHolderMinAggregateOutputType>;
  accountId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  programId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LoyaltyAccountHolderListRelationFilter = {
  every?: Maybe<LoyaltyAccountHolderWhereInput>;
  none?: Maybe<LoyaltyAccountHolderWhereInput>;
  some?: Maybe<LoyaltyAccountHolderWhereInput>;
};

export type LoyaltyAccountHolderMaxAggregateOutputType = {
  __typename?: 'LoyaltyAccountHolderMaxAggregateOutputType';
  accountId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderMaxOrderByAggregateInput = {
  accountId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyAccountHolderMinAggregateOutputType = {
  __typename?: 'LoyaltyAccountHolderMinAggregateOutputType';
  accountId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderMinOrderByAggregateInput = {
  accountId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyAccountHolderNullableScalarRelationFilter = {
  AND?: Maybe<Array<LoyaltyAccountHolderWhereInput>>;
  NOT?: Maybe<Array<LoyaltyAccountHolderWhereInput>>;
  OR?: Maybe<Array<LoyaltyAccountHolderWhereInput>>;
  account?: Maybe<LoyaltyAccountScalarRelationFilter>;
  accountId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyAccountHolderOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LoyaltyAccountHolderOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyAccountHolderOrderByRelevanceInput>;
  account?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  accountId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyAccountHolderOrderByRelevanceFieldEnum {
  AccountId = 'accountId',
  ClinicPetParentId = 'clinicPetParentId',
  Id = 'id',
  ProgramId = 'programId'
}

export type LoyaltyAccountHolderOrderByRelevanceInput = {
  fields: Array<LoyaltyAccountHolderOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyAccountHolderOrderByWithAggregationInput = {
  _count?: Maybe<LoyaltyAccountHolderCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyAccountHolderMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyAccountHolderMinOrderByAggregateInput>;
  accountId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyAccountHolderOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyAccountHolderOrderByRelevanceInput>;
  account?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  accountId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyAccountHolderOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyAccountHolderOrderByRelevanceInput>;
  account?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  accountId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyAccountHolderScalarFieldEnum {
  AccountId = 'accountId',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Id = 'id',
  ProgramId = 'programId',
  UpdatedAt = 'updatedAt'
}

export type LoyaltyAccountHolderScalarWhereInput = {
  AND?: Maybe<Array<LoyaltyAccountHolderScalarWhereInput>>;
  NOT?: Maybe<Array<LoyaltyAccountHolderScalarWhereInput>>;
  OR?: Maybe<Array<LoyaltyAccountHolderScalarWhereInput>>;
  accountId?: Maybe<StringFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  programId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyAccountHolderScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyAccountHolderScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyAccountHolderScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyAccountHolderScalarWhereWithAggregatesInput>>;
  accountId?: Maybe<StringWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  programId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type LoyaltyAccountHolderUncheckedCreateInput = {
  accountId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingAccountHolderInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountHolderCreateOrConnectWithoutAccountInput>>;
  create?: Maybe<Array<LoyaltyAccountHolderCreateWithoutAccountInput>>;
  createMany?: Maybe<LoyaltyAccountHolderCreateManyAccountInputEnvelope>;
};

export type LoyaltyAccountHolderUncheckedCreateNestedManyWithoutProgramInput = {
  connect?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountHolderCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyAccountHolderCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyAccountHolderCreateManyProgramInputEnvelope>;
};

export type LoyaltyAccountHolderUncheckedCreateNestedOneWithoutClinicPetParentInput = {
  connect?: Maybe<LoyaltyAccountHolderWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountHolderCreateOrConnectWithoutClinicPetParentInput>;
  create?: Maybe<LoyaltyAccountHolderCreateWithoutClinicPetParentInput>;
};

export type LoyaltyAccountHolderUncheckedCreateWithoutAccountInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingAccountHolderInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUncheckedCreateWithoutClinicPetParentInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingAccountHolderInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUncheckedCreateWithoutProgramInput = {
  accountId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingAccountHolderInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUncheckedCreateWithoutRewardRedemptionActionsInput = {
  accountId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUncheckedUpdateInput = {
  accountId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingAccountHolderNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUncheckedUpdateManyInput = {
  accountId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUncheckedUpdateManyWithoutAccountInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountHolderCreateOrConnectWithoutAccountInput>>;
  create?: Maybe<Array<LoyaltyAccountHolderCreateWithoutAccountInput>>;
  createMany?: Maybe<LoyaltyAccountHolderCreateManyAccountInputEnvelope>;
  delete?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyAccountHolderScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyAccountHolderUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: Maybe<Array<LoyaltyAccountHolderUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: Maybe<Array<LoyaltyAccountHolderUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type LoyaltyAccountHolderUncheckedUpdateManyWithoutProgramInput = {
  accountId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUncheckedUpdateManyWithoutProgramNestedInput = {
  connect?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountHolderCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyAccountHolderCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyAccountHolderCreateManyProgramInputEnvelope>;
  delete?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyAccountHolderScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyAccountHolderUpdateWithWhereUniqueWithoutProgramInput>>;
  updateMany?: Maybe<Array<LoyaltyAccountHolderUpdateManyWithWhereWithoutProgramInput>>;
  upsert?: Maybe<Array<LoyaltyAccountHolderUpsertWithWhereUniqueWithoutProgramInput>>;
};

export type LoyaltyAccountHolderUncheckedUpdateOneWithoutClinicPetParentNestedInput = {
  connect?: Maybe<LoyaltyAccountHolderWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountHolderCreateOrConnectWithoutClinicPetParentInput>;
  create?: Maybe<LoyaltyAccountHolderCreateWithoutClinicPetParentInput>;
  delete?: Maybe<LoyaltyAccountHolderWhereInput>;
  disconnect?: Maybe<LoyaltyAccountHolderWhereInput>;
  update?: Maybe<LoyaltyAccountHolderUpdateToOneWithWhereWithoutClinicPetParentInput>;
  upsert?: Maybe<LoyaltyAccountHolderUpsertWithoutClinicPetParentInput>;
};

export type LoyaltyAccountHolderUncheckedUpdateWithoutAccountInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingAccountHolderNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUncheckedUpdateWithoutClinicPetParentInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingAccountHolderNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUncheckedUpdateWithoutProgramInput = {
  accountId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingAccountHolderNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUncheckedUpdateWithoutRewardRedemptionActionsInput = {
  accountId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUpdateInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutAccountHoldersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutLoyaltyAccountHolderNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutLoyaltyAccountHoldersNestedInput>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingAccountHolderNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUpdateManyWithWhereWithoutAccountInput = {
  data: LoyaltyAccountHolderUpdateManyMutationInput;
  where: LoyaltyAccountHolderScalarWhereInput;
};

export type LoyaltyAccountHolderUpdateManyWithWhereWithoutProgramInput = {
  data: LoyaltyAccountHolderUpdateManyMutationInput;
  where: LoyaltyAccountHolderScalarWhereInput;
};

export type LoyaltyAccountHolderUpdateManyWithoutAccountNestedInput = {
  connect?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountHolderCreateOrConnectWithoutAccountInput>>;
  create?: Maybe<Array<LoyaltyAccountHolderCreateWithoutAccountInput>>;
  createMany?: Maybe<LoyaltyAccountHolderCreateManyAccountInputEnvelope>;
  delete?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyAccountHolderScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyAccountHolderUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: Maybe<Array<LoyaltyAccountHolderUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: Maybe<Array<LoyaltyAccountHolderUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type LoyaltyAccountHolderUpdateManyWithoutProgramNestedInput = {
  connect?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountHolderCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyAccountHolderCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyAccountHolderCreateManyProgramInputEnvelope>;
  delete?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyAccountHolderScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyAccountHolderWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyAccountHolderUpdateWithWhereUniqueWithoutProgramInput>>;
  updateMany?: Maybe<Array<LoyaltyAccountHolderUpdateManyWithWhereWithoutProgramInput>>;
  upsert?: Maybe<Array<LoyaltyAccountHolderUpsertWithWhereUniqueWithoutProgramInput>>;
};

export type LoyaltyAccountHolderUpdateOneWithoutClinicPetParentNestedInput = {
  connect?: Maybe<LoyaltyAccountHolderWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountHolderCreateOrConnectWithoutClinicPetParentInput>;
  create?: Maybe<LoyaltyAccountHolderCreateWithoutClinicPetParentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LoyaltyAccountHolderUpdateToOneWithWhereWithoutClinicPetParentInput>;
  upsert?: Maybe<LoyaltyAccountHolderUpsertWithoutClinicPetParentInput>;
};

export type LoyaltyAccountHolderUpdateOneWithoutRewardRedemptionActionsNestedInput = {
  connect?: Maybe<LoyaltyAccountHolderWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountHolderCreateOrConnectWithoutRewardRedemptionActionsInput>;
  create?: Maybe<LoyaltyAccountHolderCreateWithoutRewardRedemptionActionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LoyaltyAccountHolderUpdateToOneWithWhereWithoutRewardRedemptionActionsInput>;
  upsert?: Maybe<LoyaltyAccountHolderUpsertWithoutRewardRedemptionActionsInput>;
};

export type LoyaltyAccountHolderUpdateToOneWithWhereWithoutClinicPetParentInput = {
  data: LoyaltyAccountHolderUpdateWithoutClinicPetParentInput;
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};

export type LoyaltyAccountHolderUpdateToOneWithWhereWithoutRewardRedemptionActionsInput = {
  data: LoyaltyAccountHolderUpdateWithoutRewardRedemptionActionsInput;
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};

export type LoyaltyAccountHolderUpdateWithWhereUniqueWithoutAccountInput = {
  data: LoyaltyAccountHolderUpdateWithoutAccountInput;
  where: LoyaltyAccountHolderWhereUniqueInput;
};

export type LoyaltyAccountHolderUpdateWithWhereUniqueWithoutProgramInput = {
  data: LoyaltyAccountHolderUpdateWithoutProgramInput;
  where: LoyaltyAccountHolderWhereUniqueInput;
};

export type LoyaltyAccountHolderUpdateWithoutAccountInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutLoyaltyAccountHolderNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutLoyaltyAccountHoldersNestedInput>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingAccountHolderNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUpdateWithoutClinicPetParentInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutAccountHoldersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutLoyaltyAccountHoldersNestedInput>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingAccountHolderNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUpdateWithoutProgramInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutAccountHoldersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutLoyaltyAccountHolderNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingAccountHolderNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUpdateWithoutRewardRedemptionActionsInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutAccountHoldersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutLoyaltyAccountHolderNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutLoyaltyAccountHoldersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountHolderUpsertWithWhereUniqueWithoutAccountInput = {
  create: LoyaltyAccountHolderCreateWithoutAccountInput;
  update: LoyaltyAccountHolderUpdateWithoutAccountInput;
  where: LoyaltyAccountHolderWhereUniqueInput;
};

export type LoyaltyAccountHolderUpsertWithWhereUniqueWithoutProgramInput = {
  create: LoyaltyAccountHolderCreateWithoutProgramInput;
  update: LoyaltyAccountHolderUpdateWithoutProgramInput;
  where: LoyaltyAccountHolderWhereUniqueInput;
};

export type LoyaltyAccountHolderUpsertWithoutClinicPetParentInput = {
  create: LoyaltyAccountHolderCreateWithoutClinicPetParentInput;
  update: LoyaltyAccountHolderUpdateWithoutClinicPetParentInput;
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};

export type LoyaltyAccountHolderUpsertWithoutRewardRedemptionActionsInput = {
  create: LoyaltyAccountHolderCreateWithoutRewardRedemptionActionsInput;
  update: LoyaltyAccountHolderUpdateWithoutRewardRedemptionActionsInput;
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};

export type LoyaltyAccountHolderWhereInput = {
  AND?: Maybe<Array<LoyaltyAccountHolderWhereInput>>;
  NOT?: Maybe<Array<LoyaltyAccountHolderWhereInput>>;
  OR?: Maybe<Array<LoyaltyAccountHolderWhereInput>>;
  account?: Maybe<LoyaltyAccountScalarRelationFilter>;
  accountId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyAccountHolderWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyAccountHolderWhereInput>>;
  NOT?: Maybe<Array<LoyaltyAccountHolderWhereInput>>;
  OR?: Maybe<Array<LoyaltyAccountHolderWhereInput>>;
  account?: Maybe<LoyaltyAccountScalarRelationFilter>;
  accountId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicPetParentId_accountId?: Maybe<LoyaltyAccountHolderClinicPetParentIdAccountIdCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  rewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyAccountListRelationFilter = {
  every?: Maybe<LoyaltyAccountWhereInput>;
  none?: Maybe<LoyaltyAccountWhereInput>;
  some?: Maybe<LoyaltyAccountWhereInput>;
};

export type LoyaltyAccountMaxAggregateOutputType = {
  __typename?: 'LoyaltyAccountMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  deactivationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  leftOverSpend?: Maybe<SortOrder>;
  migratedAt?: Maybe<SortOrder>;
  pointBalance?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyAccountMerger = {
  __typename?: 'LoyaltyAccountMerger';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  initiatedBy: User;
  mergeDataFromAccount: LoyaltyAccount;
  mergeDataFromAccountId: Scalars['String'];
  mergeDataIntoAccount: LoyaltyAccount;
  mergeDataIntoAccountId: Scalars['String'];
  mergerInitiatorId: Scalars['String'];
  status: LoyaltyAccountMergerStatus;
};

export type LoyaltyAccountMergerCountAggregateOutputType = {
  __typename?: 'LoyaltyAccountMergerCountAggregateOutputType';
  _all: Scalars['Int'];
  completedAt: Scalars['Int'];
  createdAt: Scalars['Int'];
  errorMessage: Scalars['Int'];
  id: Scalars['Int'];
  mergeDataFromAccountId: Scalars['Int'];
  mergeDataIntoAccountId: Scalars['Int'];
  mergerInitiatorId: Scalars['Int'];
  status: Scalars['Int'];
};

export type LoyaltyAccountMergerCountOrderByAggregateInput = {
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mergeDataFromAccountId?: Maybe<SortOrder>;
  mergeDataIntoAccountId?: Maybe<SortOrder>;
  mergerInitiatorId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyAccountMergerCreateInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  initiatedBy: UserCreateNestedOneWithoutIntitiatedLoyaltyAccountMergesInput;
  mergeDataFromAccount: LoyaltyAccountCreateNestedOneWithoutMergeSentInput;
  mergeDataIntoAccount: LoyaltyAccountCreateNestedOneWithoutMergesTakenInput;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerCreateManyInitiatedByInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId: Scalars['String'];
  mergeDataIntoAccountId: Scalars['String'];
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerCreateManyInitiatedByInputEnvelope = {
  data: Array<LoyaltyAccountMergerCreateManyInitiatedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyAccountMergerCreateManyInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId: Scalars['String'];
  mergeDataIntoAccountId: Scalars['String'];
  mergerInitiatorId: Scalars['String'];
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerCreateManyMergeDataIntoAccountInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId: Scalars['String'];
  mergerInitiatorId: Scalars['String'];
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerCreateManyMergeDataIntoAccountInputEnvelope = {
  data: Array<LoyaltyAccountMergerCreateManyMergeDataIntoAccountInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput = {
  connect?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountMergerCreateOrConnectWithoutInitiatedByInput>>;
  create?: Maybe<Array<LoyaltyAccountMergerCreateWithoutInitiatedByInput>>;
  createMany?: Maybe<LoyaltyAccountMergerCreateManyInitiatedByInputEnvelope>;
};

export type LoyaltyAccountMergerCreateNestedManyWithoutMergeDataIntoAccountInput = {
  connect?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountMergerCreateOrConnectWithoutMergeDataIntoAccountInput>>;
  create?: Maybe<Array<LoyaltyAccountMergerCreateWithoutMergeDataIntoAccountInput>>;
  createMany?: Maybe<LoyaltyAccountMergerCreateManyMergeDataIntoAccountInputEnvelope>;
};

export type LoyaltyAccountMergerCreateNestedOneWithoutMergeDataFromAccountInput = {
  connect?: Maybe<LoyaltyAccountMergerWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountMergerCreateOrConnectWithoutMergeDataFromAccountInput>;
  create?: Maybe<LoyaltyAccountMergerCreateWithoutMergeDataFromAccountInput>;
};

export type LoyaltyAccountMergerCreateOrConnectWithoutInitiatedByInput = {
  create: LoyaltyAccountMergerCreateWithoutInitiatedByInput;
  where: LoyaltyAccountMergerWhereUniqueInput;
};

export type LoyaltyAccountMergerCreateOrConnectWithoutMergeDataFromAccountInput = {
  create: LoyaltyAccountMergerCreateWithoutMergeDataFromAccountInput;
  where: LoyaltyAccountMergerWhereUniqueInput;
};

export type LoyaltyAccountMergerCreateOrConnectWithoutMergeDataIntoAccountInput = {
  create: LoyaltyAccountMergerCreateWithoutMergeDataIntoAccountInput;
  where: LoyaltyAccountMergerWhereUniqueInput;
};

export type LoyaltyAccountMergerCreateWithoutInitiatedByInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccount: LoyaltyAccountCreateNestedOneWithoutMergeSentInput;
  mergeDataIntoAccount: LoyaltyAccountCreateNestedOneWithoutMergesTakenInput;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerCreateWithoutMergeDataFromAccountInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  initiatedBy: UserCreateNestedOneWithoutIntitiatedLoyaltyAccountMergesInput;
  mergeDataIntoAccount: LoyaltyAccountCreateNestedOneWithoutMergesTakenInput;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerCreateWithoutMergeDataIntoAccountInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  initiatedBy: UserCreateNestedOneWithoutIntitiatedLoyaltyAccountMergesInput;
  mergeDataFromAccount: LoyaltyAccountCreateNestedOneWithoutMergeSentInput;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerGroupByOutputType = {
  __typename?: 'LoyaltyAccountMergerGroupByOutputType';
  _count?: Maybe<LoyaltyAccountMergerCountAggregateOutputType>;
  _max?: Maybe<LoyaltyAccountMergerMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyAccountMergerMinAggregateOutputType>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mergeDataFromAccountId: Scalars['String'];
  mergeDataIntoAccountId: Scalars['String'];
  mergerInitiatorId: Scalars['String'];
  status: LoyaltyAccountMergerStatus;
};

export type LoyaltyAccountMergerListRelationFilter = {
  every?: Maybe<LoyaltyAccountMergerWhereInput>;
  none?: Maybe<LoyaltyAccountMergerWhereInput>;
  some?: Maybe<LoyaltyAccountMergerWhereInput>;
};

export type LoyaltyAccountMergerMaxAggregateOutputType = {
  __typename?: 'LoyaltyAccountMergerMaxAggregateOutputType';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId?: Maybe<Scalars['String']>;
  mergeDataIntoAccountId?: Maybe<Scalars['String']>;
  mergerInitiatorId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerMaxOrderByAggregateInput = {
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mergeDataFromAccountId?: Maybe<SortOrder>;
  mergeDataIntoAccountId?: Maybe<SortOrder>;
  mergerInitiatorId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyAccountMergerMinAggregateOutputType = {
  __typename?: 'LoyaltyAccountMergerMinAggregateOutputType';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId?: Maybe<Scalars['String']>;
  mergeDataIntoAccountId?: Maybe<Scalars['String']>;
  mergerInitiatorId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerMinOrderByAggregateInput = {
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mergeDataFromAccountId?: Maybe<SortOrder>;
  mergeDataIntoAccountId?: Maybe<SortOrder>;
  mergerInitiatorId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyAccountMergerNullableScalarRelationFilter = {
  AND?: Maybe<Array<LoyaltyAccountMergerWhereInput>>;
  NOT?: Maybe<Array<LoyaltyAccountMergerWhereInput>>;
  OR?: Maybe<Array<LoyaltyAccountMergerWhereInput>>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  errorMessage?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  initiatedBy?: Maybe<UserScalarRelationFilter>;
  mergeDataFromAccount?: Maybe<LoyaltyAccountScalarRelationFilter>;
  mergeDataFromAccountId?: Maybe<StringFilter>;
  mergeDataIntoAccount?: Maybe<LoyaltyAccountScalarRelationFilter>;
  mergeDataIntoAccountId?: Maybe<StringFilter>;
  mergerInitiatorId?: Maybe<StringFilter>;
  status?: Maybe<EnumLoyaltyAccountMergerStatusFilter>;
};

export type LoyaltyAccountMergerOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LoyaltyAccountMergerOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyAccountMergerOrderByRelevanceInput>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initiatedBy?: Maybe<UserOrderByWithRelationInput>;
  mergeDataFromAccount?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  mergeDataFromAccountId?: Maybe<SortOrder>;
  mergeDataIntoAccount?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  mergeDataIntoAccountId?: Maybe<SortOrder>;
  mergerInitiatorId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export enum LoyaltyAccountMergerOrderByRelevanceFieldEnum {
  ErrorMessage = 'errorMessage',
  Id = 'id',
  MergeDataFromAccountId = 'mergeDataFromAccountId',
  MergeDataIntoAccountId = 'mergeDataIntoAccountId',
  MergerInitiatorId = 'mergerInitiatorId'
}

export type LoyaltyAccountMergerOrderByRelevanceInput = {
  fields: Array<LoyaltyAccountMergerOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyAccountMergerOrderByWithAggregationInput = {
  _count?: Maybe<LoyaltyAccountMergerCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyAccountMergerMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyAccountMergerMinOrderByAggregateInput>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mergeDataFromAccountId?: Maybe<SortOrder>;
  mergeDataIntoAccountId?: Maybe<SortOrder>;
  mergerInitiatorId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyAccountMergerOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyAccountMergerOrderByRelevanceInput>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initiatedBy?: Maybe<UserOrderByWithRelationInput>;
  mergeDataFromAccount?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  mergeDataFromAccountId?: Maybe<SortOrder>;
  mergeDataIntoAccount?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  mergeDataIntoAccountId?: Maybe<SortOrder>;
  mergerInitiatorId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyAccountMergerOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyAccountMergerOrderByRelevanceInput>;
  completedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initiatedBy?: Maybe<UserOrderByWithRelationInput>;
  mergeDataFromAccount?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  mergeDataFromAccountId?: Maybe<SortOrder>;
  mergeDataIntoAccount?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  mergeDataIntoAccountId?: Maybe<SortOrder>;
  mergerInitiatorId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export enum LoyaltyAccountMergerScalarFieldEnum {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  ErrorMessage = 'errorMessage',
  Id = 'id',
  MergeDataFromAccountId = 'mergeDataFromAccountId',
  MergeDataIntoAccountId = 'mergeDataIntoAccountId',
  MergerInitiatorId = 'mergerInitiatorId',
  Status = 'status'
}

export type LoyaltyAccountMergerScalarWhereInput = {
  AND?: Maybe<Array<LoyaltyAccountMergerScalarWhereInput>>;
  NOT?: Maybe<Array<LoyaltyAccountMergerScalarWhereInput>>;
  OR?: Maybe<Array<LoyaltyAccountMergerScalarWhereInput>>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  errorMessage?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  mergeDataFromAccountId?: Maybe<StringFilter>;
  mergeDataIntoAccountId?: Maybe<StringFilter>;
  mergerInitiatorId?: Maybe<StringFilter>;
  status?: Maybe<EnumLoyaltyAccountMergerStatusFilter>;
};

export type LoyaltyAccountMergerScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyAccountMergerScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyAccountMergerScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyAccountMergerScalarWhereWithAggregatesInput>>;
  completedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  errorMessage?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  mergeDataFromAccountId?: Maybe<StringWithAggregatesFilter>;
  mergeDataIntoAccountId?: Maybe<StringWithAggregatesFilter>;
  mergerInitiatorId?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumLoyaltyAccountMergerStatusWithAggregatesFilter>;
};

export enum LoyaltyAccountMergerStatus {
  Completed = 'Completed',
  Errored = 'Errored',
  Started = 'Started'
}

export type LoyaltyAccountMergerUncheckedCreateInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId: Scalars['String'];
  mergeDataIntoAccountId: Scalars['String'];
  mergerInitiatorId: Scalars['String'];
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput = {
  connect?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountMergerCreateOrConnectWithoutInitiatedByInput>>;
  create?: Maybe<Array<LoyaltyAccountMergerCreateWithoutInitiatedByInput>>;
  createMany?: Maybe<LoyaltyAccountMergerCreateManyInitiatedByInputEnvelope>;
};

export type LoyaltyAccountMergerUncheckedCreateNestedManyWithoutMergeDataIntoAccountInput = {
  connect?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountMergerCreateOrConnectWithoutMergeDataIntoAccountInput>>;
  create?: Maybe<Array<LoyaltyAccountMergerCreateWithoutMergeDataIntoAccountInput>>;
  createMany?: Maybe<LoyaltyAccountMergerCreateManyMergeDataIntoAccountInputEnvelope>;
};

export type LoyaltyAccountMergerUncheckedCreateNestedOneWithoutMergeDataFromAccountInput = {
  connect?: Maybe<LoyaltyAccountMergerWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountMergerCreateOrConnectWithoutMergeDataFromAccountInput>;
  create?: Maybe<LoyaltyAccountMergerCreateWithoutMergeDataFromAccountInput>;
};

export type LoyaltyAccountMergerUncheckedCreateWithoutInitiatedByInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId: Scalars['String'];
  mergeDataIntoAccountId: Scalars['String'];
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUncheckedCreateWithoutMergeDataFromAccountInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataIntoAccountId: Scalars['String'];
  mergerInitiatorId: Scalars['String'];
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUncheckedCreateWithoutMergeDataIntoAccountInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId: Scalars['String'];
  mergerInitiatorId: Scalars['String'];
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUncheckedUpdateInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId?: Maybe<Scalars['String']>;
  mergeDataIntoAccountId?: Maybe<Scalars['String']>;
  mergerInitiatorId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUncheckedUpdateManyInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId?: Maybe<Scalars['String']>;
  mergeDataIntoAccountId?: Maybe<Scalars['String']>;
  mergerInitiatorId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId?: Maybe<Scalars['String']>;
  mergeDataIntoAccountId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput = {
  connect?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountMergerCreateOrConnectWithoutInitiatedByInput>>;
  create?: Maybe<Array<LoyaltyAccountMergerCreateWithoutInitiatedByInput>>;
  createMany?: Maybe<LoyaltyAccountMergerCreateManyInitiatedByInputEnvelope>;
  delete?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyAccountMergerScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyAccountMergerUpdateWithWhereUniqueWithoutInitiatedByInput>>;
  updateMany?: Maybe<Array<LoyaltyAccountMergerUpdateManyWithWhereWithoutInitiatedByInput>>;
  upsert?: Maybe<Array<LoyaltyAccountMergerUpsertWithWhereUniqueWithoutInitiatedByInput>>;
};

export type LoyaltyAccountMergerUncheckedUpdateManyWithoutMergeDataIntoAccountInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId?: Maybe<Scalars['String']>;
  mergerInitiatorId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUncheckedUpdateManyWithoutMergeDataIntoAccountNestedInput = {
  connect?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountMergerCreateOrConnectWithoutMergeDataIntoAccountInput>>;
  create?: Maybe<Array<LoyaltyAccountMergerCreateWithoutMergeDataIntoAccountInput>>;
  createMany?: Maybe<LoyaltyAccountMergerCreateManyMergeDataIntoAccountInputEnvelope>;
  delete?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyAccountMergerScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyAccountMergerUpdateWithWhereUniqueWithoutMergeDataIntoAccountInput>>;
  updateMany?: Maybe<Array<LoyaltyAccountMergerUpdateManyWithWhereWithoutMergeDataIntoAccountInput>>;
  upsert?: Maybe<Array<LoyaltyAccountMergerUpsertWithWhereUniqueWithoutMergeDataIntoAccountInput>>;
};

export type LoyaltyAccountMergerUncheckedUpdateOneWithoutMergeDataFromAccountNestedInput = {
  connect?: Maybe<LoyaltyAccountMergerWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountMergerCreateOrConnectWithoutMergeDataFromAccountInput>;
  create?: Maybe<LoyaltyAccountMergerCreateWithoutMergeDataFromAccountInput>;
  delete?: Maybe<LoyaltyAccountMergerWhereInput>;
  disconnect?: Maybe<LoyaltyAccountMergerWhereInput>;
  update?: Maybe<LoyaltyAccountMergerUpdateToOneWithWhereWithoutMergeDataFromAccountInput>;
  upsert?: Maybe<LoyaltyAccountMergerUpsertWithoutMergeDataFromAccountInput>;
};

export type LoyaltyAccountMergerUncheckedUpdateWithoutInitiatedByInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId?: Maybe<Scalars['String']>;
  mergeDataIntoAccountId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUncheckedUpdateWithoutMergeDataFromAccountInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataIntoAccountId?: Maybe<Scalars['String']>;
  mergerInitiatorId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUncheckedUpdateWithoutMergeDataIntoAccountInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccountId?: Maybe<Scalars['String']>;
  mergerInitiatorId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUpdateInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  initiatedBy?: Maybe<UserUpdateOneRequiredWithoutIntitiatedLoyaltyAccountMergesNestedInput>;
  mergeDataFromAccount?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutMergeSentNestedInput>;
  mergeDataIntoAccount?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutMergesTakenNestedInput>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUpdateManyMutationInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUpdateManyWithWhereWithoutInitiatedByInput = {
  data: LoyaltyAccountMergerUpdateManyMutationInput;
  where: LoyaltyAccountMergerScalarWhereInput;
};

export type LoyaltyAccountMergerUpdateManyWithWhereWithoutMergeDataIntoAccountInput = {
  data: LoyaltyAccountMergerUpdateManyMutationInput;
  where: LoyaltyAccountMergerScalarWhereInput;
};

export type LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput = {
  connect?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountMergerCreateOrConnectWithoutInitiatedByInput>>;
  create?: Maybe<Array<LoyaltyAccountMergerCreateWithoutInitiatedByInput>>;
  createMany?: Maybe<LoyaltyAccountMergerCreateManyInitiatedByInputEnvelope>;
  delete?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyAccountMergerScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyAccountMergerUpdateWithWhereUniqueWithoutInitiatedByInput>>;
  updateMany?: Maybe<Array<LoyaltyAccountMergerUpdateManyWithWhereWithoutInitiatedByInput>>;
  upsert?: Maybe<Array<LoyaltyAccountMergerUpsertWithWhereUniqueWithoutInitiatedByInput>>;
};

export type LoyaltyAccountMergerUpdateManyWithoutMergeDataIntoAccountNestedInput = {
  connect?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountMergerCreateOrConnectWithoutMergeDataIntoAccountInput>>;
  create?: Maybe<Array<LoyaltyAccountMergerCreateWithoutMergeDataIntoAccountInput>>;
  createMany?: Maybe<LoyaltyAccountMergerCreateManyMergeDataIntoAccountInputEnvelope>;
  delete?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyAccountMergerScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyAccountMergerWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyAccountMergerUpdateWithWhereUniqueWithoutMergeDataIntoAccountInput>>;
  updateMany?: Maybe<Array<LoyaltyAccountMergerUpdateManyWithWhereWithoutMergeDataIntoAccountInput>>;
  upsert?: Maybe<Array<LoyaltyAccountMergerUpsertWithWhereUniqueWithoutMergeDataIntoAccountInput>>;
};

export type LoyaltyAccountMergerUpdateOneWithoutMergeDataFromAccountNestedInput = {
  connect?: Maybe<LoyaltyAccountMergerWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountMergerCreateOrConnectWithoutMergeDataFromAccountInput>;
  create?: Maybe<LoyaltyAccountMergerCreateWithoutMergeDataFromAccountInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LoyaltyAccountMergerUpdateToOneWithWhereWithoutMergeDataFromAccountInput>;
  upsert?: Maybe<LoyaltyAccountMergerUpsertWithoutMergeDataFromAccountInput>;
};

export type LoyaltyAccountMergerUpdateToOneWithWhereWithoutMergeDataFromAccountInput = {
  data: LoyaltyAccountMergerUpdateWithoutMergeDataFromAccountInput;
  where?: Maybe<LoyaltyAccountMergerWhereInput>;
};

export type LoyaltyAccountMergerUpdateWithWhereUniqueWithoutInitiatedByInput = {
  data: LoyaltyAccountMergerUpdateWithoutInitiatedByInput;
  where: LoyaltyAccountMergerWhereUniqueInput;
};

export type LoyaltyAccountMergerUpdateWithWhereUniqueWithoutMergeDataIntoAccountInput = {
  data: LoyaltyAccountMergerUpdateWithoutMergeDataIntoAccountInput;
  where: LoyaltyAccountMergerWhereUniqueInput;
};

export type LoyaltyAccountMergerUpdateWithoutInitiatedByInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mergeDataFromAccount?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutMergeSentNestedInput>;
  mergeDataIntoAccount?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutMergesTakenNestedInput>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUpdateWithoutMergeDataFromAccountInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  initiatedBy?: Maybe<UserUpdateOneRequiredWithoutIntitiatedLoyaltyAccountMergesNestedInput>;
  mergeDataIntoAccount?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutMergesTakenNestedInput>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUpdateWithoutMergeDataIntoAccountInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  initiatedBy?: Maybe<UserUpdateOneRequiredWithoutIntitiatedLoyaltyAccountMergesNestedInput>;
  mergeDataFromAccount?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutMergeSentNestedInput>;
  status?: Maybe<LoyaltyAccountMergerStatus>;
};

export type LoyaltyAccountMergerUpsertWithWhereUniqueWithoutInitiatedByInput = {
  create: LoyaltyAccountMergerCreateWithoutInitiatedByInput;
  update: LoyaltyAccountMergerUpdateWithoutInitiatedByInput;
  where: LoyaltyAccountMergerWhereUniqueInput;
};

export type LoyaltyAccountMergerUpsertWithWhereUniqueWithoutMergeDataIntoAccountInput = {
  create: LoyaltyAccountMergerCreateWithoutMergeDataIntoAccountInput;
  update: LoyaltyAccountMergerUpdateWithoutMergeDataIntoAccountInput;
  where: LoyaltyAccountMergerWhereUniqueInput;
};

export type LoyaltyAccountMergerUpsertWithoutMergeDataFromAccountInput = {
  create: LoyaltyAccountMergerCreateWithoutMergeDataFromAccountInput;
  update: LoyaltyAccountMergerUpdateWithoutMergeDataFromAccountInput;
  where?: Maybe<LoyaltyAccountMergerWhereInput>;
};

export type LoyaltyAccountMergerWhereInput = {
  AND?: Maybe<Array<LoyaltyAccountMergerWhereInput>>;
  NOT?: Maybe<Array<LoyaltyAccountMergerWhereInput>>;
  OR?: Maybe<Array<LoyaltyAccountMergerWhereInput>>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  errorMessage?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  initiatedBy?: Maybe<UserScalarRelationFilter>;
  mergeDataFromAccount?: Maybe<LoyaltyAccountScalarRelationFilter>;
  mergeDataFromAccountId?: Maybe<StringFilter>;
  mergeDataIntoAccount?: Maybe<LoyaltyAccountScalarRelationFilter>;
  mergeDataIntoAccountId?: Maybe<StringFilter>;
  mergerInitiatorId?: Maybe<StringFilter>;
  status?: Maybe<EnumLoyaltyAccountMergerStatusFilter>;
};

export type LoyaltyAccountMergerWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyAccountMergerWhereInput>>;
  NOT?: Maybe<Array<LoyaltyAccountMergerWhereInput>>;
  OR?: Maybe<Array<LoyaltyAccountMergerWhereInput>>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  errorMessage?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  initiatedBy?: Maybe<UserScalarRelationFilter>;
  mergeDataFromAccount?: Maybe<LoyaltyAccountScalarRelationFilter>;
  mergeDataFromAccountId?: Maybe<Scalars['String']>;
  mergeDataIntoAccount?: Maybe<LoyaltyAccountScalarRelationFilter>;
  mergeDataIntoAccountId?: Maybe<StringFilter>;
  mergerInitiatorId?: Maybe<StringFilter>;
  status?: Maybe<EnumLoyaltyAccountMergerStatusFilter>;
};

export type LoyaltyAccountMinAggregateOutputType = {
  __typename?: 'LoyaltyAccountMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  deactivationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  leftOverSpend?: Maybe<SortOrder>;
  migratedAt?: Maybe<SortOrder>;
  pointBalance?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyAccountOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LoyaltyAccountOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyAccountOrderByRelevanceInput>;
  accountHolders?: Maybe<LoyaltyAccountHolderOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deactivationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  leftOverSpend?: Maybe<SortOrder>;
  mergeSent?: Maybe<LoyaltyAccountMergerOrderByWithRelationInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerOrderByRelationAggregateInput>;
  migratedAt?: Maybe<SortOrder>;
  pointBalance?: Maybe<SortOrder>;
  pointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyAccountOrderByRelevanceFieldEnum {
  Id = 'id',
  ProgramId = 'programId'
}

export type LoyaltyAccountOrderByRelevanceInput = {
  fields: Array<LoyaltyAccountOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyAccountOrderByWithAggregationInput = {
  _avg?: Maybe<LoyaltyAccountAvgOrderByAggregateInput>;
  _count?: Maybe<LoyaltyAccountCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyAccountMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyAccountMinOrderByAggregateInput>;
  _sum?: Maybe<LoyaltyAccountSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deactivationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  leftOverSpend?: Maybe<SortOrder>;
  migratedAt?: Maybe<SortOrder>;
  pointBalance?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyAccountOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyAccountOrderByRelevanceInput>;
  accountHolders?: Maybe<LoyaltyAccountHolderOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deactivationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  leftOverSpend?: Maybe<SortOrder>;
  mergeSent?: Maybe<LoyaltyAccountMergerOrderByWithRelationInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerOrderByRelationAggregateInput>;
  migratedAt?: Maybe<SortOrder>;
  pointBalance?: Maybe<SortOrder>;
  pointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyAccountOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyAccountOrderByRelevanceInput>;
  accountHolders?: Maybe<LoyaltyAccountHolderOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deactivationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  leftOverSpend?: Maybe<SortOrder>;
  mergeSent?: Maybe<LoyaltyAccountMergerOrderByWithRelationInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerOrderByRelationAggregateInput>;
  migratedAt?: Maybe<SortOrder>;
  pointBalance?: Maybe<SortOrder>;
  pointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyAccountScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeactivationDate = 'deactivationDate',
  Id = 'id',
  IsActive = 'isActive',
  LeftOverSpend = 'leftOverSpend',
  MigratedAt = 'migratedAt',
  PointBalance = 'pointBalance',
  ProgramId = 'programId',
  UpdatedAt = 'updatedAt'
}

export type LoyaltyAccountScalarRelationFilter = {
  AND?: Maybe<Array<LoyaltyAccountWhereInput>>;
  NOT?: Maybe<Array<LoyaltyAccountWhereInput>>;
  OR?: Maybe<Array<LoyaltyAccountWhereInput>>;
  accountHolders?: Maybe<LoyaltyAccountHolderListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deactivationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  leftOverSpend?: Maybe<IntFilter>;
  mergeSent?: Maybe<LoyaltyAccountMergerNullableScalarRelationFilter>;
  mergesTaken?: Maybe<LoyaltyAccountMergerListRelationFilter>;
  migratedAt?: Maybe<DateTimeNullableFilter>;
  pointBalance?: Maybe<IntFilter>;
  pointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyAccountScalarWhereInput = {
  AND?: Maybe<Array<LoyaltyAccountScalarWhereInput>>;
  NOT?: Maybe<Array<LoyaltyAccountScalarWhereInput>>;
  OR?: Maybe<Array<LoyaltyAccountScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  deactivationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  leftOverSpend?: Maybe<IntFilter>;
  migratedAt?: Maybe<DateTimeNullableFilter>;
  pointBalance?: Maybe<IntFilter>;
  programId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyAccountScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyAccountScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyAccountScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyAccountScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deactivationDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  leftOverSpend?: Maybe<IntWithAggregatesFilter>;
  migratedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  pointBalance?: Maybe<IntWithAggregatesFilter>;
  programId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type LoyaltyAccountSubscription = {
  __typename?: 'LoyaltyAccountSubscription';
  mutation: MutationType;
  node: LoyaltyAccount;
};

export type LoyaltyAccountSumAggregateOutputType = {
  __typename?: 'LoyaltyAccountSumAggregateOutputType';
  leftOverSpend?: Maybe<Scalars['Int']>;
  pointBalance?: Maybe<Scalars['Int']>;
};

export type LoyaltyAccountSumOrderByAggregateInput = {
  leftOverSpend?: Maybe<SortOrder>;
  pointBalance?: Maybe<SortOrder>;
};

export type LoyaltyAccountUncheckedCreateInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedManyWithoutAccountInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedOneWithoutMergeDataFromAccountInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutMergeDataIntoAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutAccountInput>;
  programId: Scalars['String'];
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUncheckedCreateNestedManyWithoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedCreateNestedManyWithoutProgramInput = {
  connect?: Maybe<Array<LoyaltyAccountWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyAccountCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyAccountCreateManyProgramInputEnvelope>;
};

export type LoyaltyAccountUncheckedCreateWithoutAccountHoldersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedOneWithoutMergeDataFromAccountInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutMergeDataIntoAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutAccountInput>;
  programId: Scalars['String'];
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUncheckedCreateNestedManyWithoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedCreateWithoutMergeSentInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedManyWithoutAccountInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutMergeDataIntoAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutAccountInput>;
  programId: Scalars['String'];
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUncheckedCreateNestedManyWithoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedCreateWithoutMergesTakenInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedManyWithoutAccountInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedOneWithoutMergeDataFromAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutAccountInput>;
  programId: Scalars['String'];
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUncheckedCreateNestedManyWithoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedCreateWithoutPointDeltasInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedManyWithoutAccountInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedOneWithoutMergeDataFromAccountInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutMergeDataIntoAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUncheckedCreateNestedManyWithoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedCreateWithoutProgramInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedManyWithoutAccountInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedOneWithoutMergeDataFromAccountInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutMergeDataIntoAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutAccountInput>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUncheckedCreateNestedManyWithoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedCreateWithoutRewardRedemptionsInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedManyWithoutAccountInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedOneWithoutMergeDataFromAccountInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutMergeDataIntoAccountInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutAccountInput>;
  programId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedUpdateInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUncheckedUpdateManyWithoutAccountNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUncheckedUpdateOneWithoutMergeDataFromAccountNestedInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutMergeDataIntoAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutAccountNestedInput>;
  programId?: Maybe<Scalars['String']>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUncheckedUpdateManyWithoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedUpdateManyWithoutProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedUpdateManyWithoutProgramNestedInput = {
  connect?: Maybe<Array<LoyaltyAccountWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyAccountCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyAccountCreateManyProgramInputEnvelope>;
  delete?: Maybe<Array<LoyaltyAccountWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyAccountScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyAccountWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyAccountWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyAccountUpdateWithWhereUniqueWithoutProgramInput>>;
  updateMany?: Maybe<Array<LoyaltyAccountUpdateManyWithWhereWithoutProgramInput>>;
  upsert?: Maybe<Array<LoyaltyAccountUpsertWithWhereUniqueWithoutProgramInput>>;
};

export type LoyaltyAccountUncheckedUpdateWithoutAccountHoldersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUncheckedUpdateOneWithoutMergeDataFromAccountNestedInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutMergeDataIntoAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutAccountNestedInput>;
  programId?: Maybe<Scalars['String']>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUncheckedUpdateManyWithoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedUpdateWithoutMergeSentInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUncheckedUpdateManyWithoutAccountNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutMergeDataIntoAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutAccountNestedInput>;
  programId?: Maybe<Scalars['String']>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUncheckedUpdateManyWithoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedUpdateWithoutMergesTakenInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUncheckedUpdateManyWithoutAccountNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUncheckedUpdateOneWithoutMergeDataFromAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutAccountNestedInput>;
  programId?: Maybe<Scalars['String']>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUncheckedUpdateManyWithoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedUpdateWithoutPointDeltasInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUncheckedUpdateManyWithoutAccountNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUncheckedUpdateOneWithoutMergeDataFromAccountNestedInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutMergeDataIntoAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUncheckedUpdateManyWithoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedUpdateWithoutProgramInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUncheckedUpdateManyWithoutAccountNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUncheckedUpdateOneWithoutMergeDataFromAccountNestedInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutMergeDataIntoAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutAccountNestedInput>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUncheckedUpdateManyWithoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUncheckedUpdateWithoutRewardRedemptionsInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUncheckedUpdateManyWithoutAccountNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUncheckedUpdateOneWithoutMergeDataFromAccountNestedInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutMergeDataIntoAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutAccountNestedInput>;
  programId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUpdateInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUpdateManyWithoutAccountNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUpdateOneWithoutMergeDataFromAccountNestedInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUpdateManyWithoutMergeDataIntoAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutAccountNestedInput>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutAccountsNestedInput>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUpdateManyWithoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUpdateManyWithWhereWithoutProgramInput = {
  data: LoyaltyAccountUpdateManyMutationInput;
  where: LoyaltyAccountScalarWhereInput;
};

export type LoyaltyAccountUpdateManyWithoutProgramNestedInput = {
  connect?: Maybe<Array<LoyaltyAccountWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyAccountCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyAccountCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyAccountCreateManyProgramInputEnvelope>;
  delete?: Maybe<Array<LoyaltyAccountWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyAccountScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyAccountWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyAccountWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyAccountUpdateWithWhereUniqueWithoutProgramInput>>;
  updateMany?: Maybe<Array<LoyaltyAccountUpdateManyWithWhereWithoutProgramInput>>;
  upsert?: Maybe<Array<LoyaltyAccountUpsertWithWhereUniqueWithoutProgramInput>>;
};

export type LoyaltyAccountUpdateOneRequiredWithoutAccountHoldersNestedInput = {
  connect?: Maybe<LoyaltyAccountWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountCreateOrConnectWithoutAccountHoldersInput>;
  create?: Maybe<LoyaltyAccountCreateWithoutAccountHoldersInput>;
  update?: Maybe<LoyaltyAccountUpdateToOneWithWhereWithoutAccountHoldersInput>;
  upsert?: Maybe<LoyaltyAccountUpsertWithoutAccountHoldersInput>;
};

export type LoyaltyAccountUpdateOneRequiredWithoutMergeSentNestedInput = {
  connect?: Maybe<LoyaltyAccountWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountCreateOrConnectWithoutMergeSentInput>;
  create?: Maybe<LoyaltyAccountCreateWithoutMergeSentInput>;
  update?: Maybe<LoyaltyAccountUpdateToOneWithWhereWithoutMergeSentInput>;
  upsert?: Maybe<LoyaltyAccountUpsertWithoutMergeSentInput>;
};

export type LoyaltyAccountUpdateOneRequiredWithoutMergesTakenNestedInput = {
  connect?: Maybe<LoyaltyAccountWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountCreateOrConnectWithoutMergesTakenInput>;
  create?: Maybe<LoyaltyAccountCreateWithoutMergesTakenInput>;
  update?: Maybe<LoyaltyAccountUpdateToOneWithWhereWithoutMergesTakenInput>;
  upsert?: Maybe<LoyaltyAccountUpsertWithoutMergesTakenInput>;
};

export type LoyaltyAccountUpdateOneRequiredWithoutPointDeltasNestedInput = {
  connect?: Maybe<LoyaltyAccountWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountCreateOrConnectWithoutPointDeltasInput>;
  create?: Maybe<LoyaltyAccountCreateWithoutPointDeltasInput>;
  update?: Maybe<LoyaltyAccountUpdateToOneWithWhereWithoutPointDeltasInput>;
  upsert?: Maybe<LoyaltyAccountUpsertWithoutPointDeltasInput>;
};

export type LoyaltyAccountUpdateOneRequiredWithoutRewardRedemptionsNestedInput = {
  connect?: Maybe<LoyaltyAccountWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyAccountCreateOrConnectWithoutRewardRedemptionsInput>;
  create?: Maybe<LoyaltyAccountCreateWithoutRewardRedemptionsInput>;
  update?: Maybe<LoyaltyAccountUpdateToOneWithWhereWithoutRewardRedemptionsInput>;
  upsert?: Maybe<LoyaltyAccountUpsertWithoutRewardRedemptionsInput>;
};

export type LoyaltyAccountUpdateToOneWithWhereWithoutAccountHoldersInput = {
  data: LoyaltyAccountUpdateWithoutAccountHoldersInput;
  where?: Maybe<LoyaltyAccountWhereInput>;
};

export type LoyaltyAccountUpdateToOneWithWhereWithoutMergeSentInput = {
  data: LoyaltyAccountUpdateWithoutMergeSentInput;
  where?: Maybe<LoyaltyAccountWhereInput>;
};

export type LoyaltyAccountUpdateToOneWithWhereWithoutMergesTakenInput = {
  data: LoyaltyAccountUpdateWithoutMergesTakenInput;
  where?: Maybe<LoyaltyAccountWhereInput>;
};

export type LoyaltyAccountUpdateToOneWithWhereWithoutPointDeltasInput = {
  data: LoyaltyAccountUpdateWithoutPointDeltasInput;
  where?: Maybe<LoyaltyAccountWhereInput>;
};

export type LoyaltyAccountUpdateToOneWithWhereWithoutRewardRedemptionsInput = {
  data: LoyaltyAccountUpdateWithoutRewardRedemptionsInput;
  where?: Maybe<LoyaltyAccountWhereInput>;
};

export type LoyaltyAccountUpdateWithWhereUniqueWithoutProgramInput = {
  data: LoyaltyAccountUpdateWithoutProgramInput;
  where: LoyaltyAccountWhereUniqueInput;
};

export type LoyaltyAccountUpdateWithoutAccountHoldersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUpdateOneWithoutMergeDataFromAccountNestedInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUpdateManyWithoutMergeDataIntoAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutAccountNestedInput>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutAccountsNestedInput>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUpdateManyWithoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUpdateWithoutMergeSentInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUpdateManyWithoutAccountNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUpdateManyWithoutMergeDataIntoAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutAccountNestedInput>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutAccountsNestedInput>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUpdateManyWithoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUpdateWithoutMergesTakenInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUpdateManyWithoutAccountNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUpdateOneWithoutMergeDataFromAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutAccountNestedInput>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutAccountsNestedInput>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUpdateManyWithoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUpdateWithoutPointDeltasInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUpdateManyWithoutAccountNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUpdateOneWithoutMergeDataFromAccountNestedInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUpdateManyWithoutMergeDataIntoAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutAccountsNestedInput>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUpdateManyWithoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUpdateWithoutProgramInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUpdateManyWithoutAccountNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUpdateOneWithoutMergeDataFromAccountNestedInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUpdateManyWithoutMergeDataIntoAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutAccountNestedInput>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionUpdateManyWithoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUpdateWithoutRewardRedemptionsInput = {
  accountHolders?: Maybe<LoyaltyAccountHolderUpdateManyWithoutAccountNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leftOverSpend?: Maybe<Scalars['Int']>;
  mergeSent?: Maybe<LoyaltyAccountMergerUpdateOneWithoutMergeDataFromAccountNestedInput>;
  mergesTaken?: Maybe<LoyaltyAccountMergerUpdateManyWithoutMergeDataIntoAccountNestedInput>;
  migratedAt?: Maybe<Scalars['DateTime']>;
  pointBalance?: Maybe<Scalars['Int']>;
  pointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutAccountNestedInput>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutAccountsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyAccountUpsertWithWhereUniqueWithoutProgramInput = {
  create: LoyaltyAccountCreateWithoutProgramInput;
  update: LoyaltyAccountUpdateWithoutProgramInput;
  where: LoyaltyAccountWhereUniqueInput;
};

export type LoyaltyAccountUpsertWithoutAccountHoldersInput = {
  create: LoyaltyAccountCreateWithoutAccountHoldersInput;
  update: LoyaltyAccountUpdateWithoutAccountHoldersInput;
  where?: Maybe<LoyaltyAccountWhereInput>;
};

export type LoyaltyAccountUpsertWithoutMergeSentInput = {
  create: LoyaltyAccountCreateWithoutMergeSentInput;
  update: LoyaltyAccountUpdateWithoutMergeSentInput;
  where?: Maybe<LoyaltyAccountWhereInput>;
};

export type LoyaltyAccountUpsertWithoutMergesTakenInput = {
  create: LoyaltyAccountCreateWithoutMergesTakenInput;
  update: LoyaltyAccountUpdateWithoutMergesTakenInput;
  where?: Maybe<LoyaltyAccountWhereInput>;
};

export type LoyaltyAccountUpsertWithoutPointDeltasInput = {
  create: LoyaltyAccountCreateWithoutPointDeltasInput;
  update: LoyaltyAccountUpdateWithoutPointDeltasInput;
  where?: Maybe<LoyaltyAccountWhereInput>;
};

export type LoyaltyAccountUpsertWithoutRewardRedemptionsInput = {
  create: LoyaltyAccountCreateWithoutRewardRedemptionsInput;
  update: LoyaltyAccountUpdateWithoutRewardRedemptionsInput;
  where?: Maybe<LoyaltyAccountWhereInput>;
};

export type LoyaltyAccountWhereInput = {
  AND?: Maybe<Array<LoyaltyAccountWhereInput>>;
  NOT?: Maybe<Array<LoyaltyAccountWhereInput>>;
  OR?: Maybe<Array<LoyaltyAccountWhereInput>>;
  accountHolders?: Maybe<LoyaltyAccountHolderListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deactivationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  leftOverSpend?: Maybe<IntFilter>;
  mergeSent?: Maybe<LoyaltyAccountMergerNullableScalarRelationFilter>;
  mergesTaken?: Maybe<LoyaltyAccountMergerListRelationFilter>;
  migratedAt?: Maybe<DateTimeNullableFilter>;
  pointBalance?: Maybe<IntFilter>;
  pointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyAccountWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyAccountWhereInput>>;
  NOT?: Maybe<Array<LoyaltyAccountWhereInput>>;
  OR?: Maybe<Array<LoyaltyAccountWhereInput>>;
  accountHolders?: Maybe<LoyaltyAccountHolderListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deactivationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolFilter>;
  leftOverSpend?: Maybe<IntFilter>;
  mergeSent?: Maybe<LoyaltyAccountMergerNullableScalarRelationFilter>;
  mergesTaken?: Maybe<LoyaltyAccountMergerListRelationFilter>;
  migratedAt?: Maybe<DateTimeNullableFilter>;
  pointBalance?: Maybe<IntFilter>;
  pointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  rewardRedemptions?: Maybe<LoyaltyRewardRedemptionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyInvoicePointGranter = {
  __typename?: 'LoyaltyInvoicePointGranter';
  _count: LoyaltyInvoicePointGranterCountOutputType;
  allowAllServices: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  grantingServiceCategories: Array<LoyaltyPointGrantingServiceCategory>;
  grantingServices: Array<LoyaltyPointGrantingService>;
  id: Scalars['String'];
  label: Scalars['String'];
  program: LoyaltyProgram;
  programId: Scalars['String'];
  reduceFromDiscounts: Scalars['Boolean'];
  relatedInvoiceLoyaltyPointDeltas: Array<LoyaltyPointDelta>;
  updatedAt: Scalars['DateTime'];
};


export type LoyaltyInvoicePointGranterGrantingServiceCategoriesArgs = {
  cursor?: Maybe<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceCategoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointGrantingServiceCategoryWhereInput>;
};


export type LoyaltyInvoicePointGranterGrantingServicesArgs = {
  cursor?: Maybe<LoyaltyPointGrantingServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointGrantingServiceWhereInput>;
};


export type LoyaltyInvoicePointGranterRelatedInvoiceLoyaltyPointDeltasArgs = {
  cursor?: Maybe<LoyaltyPointDeltaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointDeltaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointDeltaOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
};

export type LoyaltyInvoicePointGranterCountAggregateOutputType = {
  __typename?: 'LoyaltyInvoicePointGranterCountAggregateOutputType';
  _all: Scalars['Int'];
  allowAllServices: Scalars['Int'];
  createdAt: Scalars['Int'];
  enabled: Scalars['Int'];
  id: Scalars['Int'];
  label: Scalars['Int'];
  programId: Scalars['Int'];
  reduceFromDiscounts: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LoyaltyInvoicePointGranterCountOrderByAggregateInput = {
  allowAllServices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  reduceFromDiscounts?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyInvoicePointGranterCountOutputType = {
  __typename?: 'LoyaltyInvoicePointGranterCountOutputType';
  grantingServiceCategories: Scalars['Int'];
  grantingServices: Scalars['Int'];
  relatedInvoiceLoyaltyPointDeltas: Scalars['Int'];
};

export type LoyaltyInvoicePointGranterCreateInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryCreateNestedManyWithoutGranterInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutGranterInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  program: LoyaltyProgramCreateNestedOneWithoutPointGrantersInput;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutInvoicePointGranterInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterCreateManyInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterCreateManyProgramInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterCreateManyProgramInputEnvelope = {
  data: Array<LoyaltyInvoicePointGranterCreateManyProgramInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyInvoicePointGranterCreateNestedManyWithoutProgramInput = {
  connect?: Maybe<Array<LoyaltyInvoicePointGranterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyInvoicePointGranterCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyInvoicePointGranterCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyInvoicePointGranterCreateManyProgramInputEnvelope>;
};

export type LoyaltyInvoicePointGranterCreateNestedOneWithoutGrantingServiceCategoriesInput = {
  connect?: Maybe<LoyaltyInvoicePointGranterWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyInvoicePointGranterCreateOrConnectWithoutGrantingServiceCategoriesInput>;
  create?: Maybe<LoyaltyInvoicePointGranterCreateWithoutGrantingServiceCategoriesInput>;
};

export type LoyaltyInvoicePointGranterCreateNestedOneWithoutGrantingServicesInput = {
  connect?: Maybe<LoyaltyInvoicePointGranterWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyInvoicePointGranterCreateOrConnectWithoutGrantingServicesInput>;
  create?: Maybe<LoyaltyInvoicePointGranterCreateWithoutGrantingServicesInput>;
};

export type LoyaltyInvoicePointGranterCreateNestedOneWithoutRelatedInvoiceLoyaltyPointDeltasInput = {
  connect?: Maybe<LoyaltyInvoicePointGranterWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyInvoicePointGranterCreateOrConnectWithoutRelatedInvoiceLoyaltyPointDeltasInput>;
  create?: Maybe<LoyaltyInvoicePointGranterCreateWithoutRelatedInvoiceLoyaltyPointDeltasInput>;
};

export type LoyaltyInvoicePointGranterCreateOrConnectWithoutGrantingServiceCategoriesInput = {
  create: LoyaltyInvoicePointGranterCreateWithoutGrantingServiceCategoriesInput;
  where: LoyaltyInvoicePointGranterWhereUniqueInput;
};

export type LoyaltyInvoicePointGranterCreateOrConnectWithoutGrantingServicesInput = {
  create: LoyaltyInvoicePointGranterCreateWithoutGrantingServicesInput;
  where: LoyaltyInvoicePointGranterWhereUniqueInput;
};

export type LoyaltyInvoicePointGranterCreateOrConnectWithoutProgramInput = {
  create: LoyaltyInvoicePointGranterCreateWithoutProgramInput;
  where: LoyaltyInvoicePointGranterWhereUniqueInput;
};

export type LoyaltyInvoicePointGranterCreateOrConnectWithoutRelatedInvoiceLoyaltyPointDeltasInput = {
  create: LoyaltyInvoicePointGranterCreateWithoutRelatedInvoiceLoyaltyPointDeltasInput;
  where: LoyaltyInvoicePointGranterWhereUniqueInput;
};

export type LoyaltyInvoicePointGranterCreateWithoutGrantingServiceCategoriesInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutGranterInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  program: LoyaltyProgramCreateNestedOneWithoutPointGrantersInput;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutInvoicePointGranterInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterCreateWithoutGrantingServicesInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryCreateNestedManyWithoutGranterInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  program: LoyaltyProgramCreateNestedOneWithoutPointGrantersInput;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutInvoicePointGranterInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterCreateWithoutProgramInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryCreateNestedManyWithoutGranterInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutGranterInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutInvoicePointGranterInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterCreateWithoutRelatedInvoiceLoyaltyPointDeltasInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryCreateNestedManyWithoutGranterInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutGranterInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  program: LoyaltyProgramCreateNestedOneWithoutPointGrantersInput;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterGroupByOutputType = {
  __typename?: 'LoyaltyInvoicePointGranterGroupByOutputType';
  _count?: Maybe<LoyaltyInvoicePointGranterCountAggregateOutputType>;
  _max?: Maybe<LoyaltyInvoicePointGranterMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyInvoicePointGranterMinAggregateOutputType>;
  allowAllServices: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  label: Scalars['String'];
  programId: Scalars['String'];
  reduceFromDiscounts: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type LoyaltyInvoicePointGranterListRelationFilter = {
  every?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
  none?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
  some?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};

export type LoyaltyInvoicePointGranterMaxAggregateOutputType = {
  __typename?: 'LoyaltyInvoicePointGranterMaxAggregateOutputType';
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterMaxOrderByAggregateInput = {
  allowAllServices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  reduceFromDiscounts?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyInvoicePointGranterMinAggregateOutputType = {
  __typename?: 'LoyaltyInvoicePointGranterMinAggregateOutputType';
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterMinOrderByAggregateInput = {
  allowAllServices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  reduceFromDiscounts?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyInvoicePointGranterNullableScalarRelationFilter = {
  AND?: Maybe<Array<LoyaltyInvoicePointGranterWhereInput>>;
  NOT?: Maybe<Array<LoyaltyInvoicePointGranterWhereInput>>;
  OR?: Maybe<Array<LoyaltyInvoicePointGranterWhereInput>>;
  allowAllServices?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enabled?: Maybe<BoolFilter>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryListRelationFilter>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceListRelationFilter>;
  id?: Maybe<StringFilter>;
  label?: Maybe<StringFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  reduceFromDiscounts?: Maybe<BoolFilter>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyInvoicePointGranterOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LoyaltyInvoicePointGranterOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyInvoicePointGranterOrderByRelevanceInput>;
  allowAllServices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enabled?: Maybe<SortOrder>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryOrderByRelationAggregateInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  reduceFromDiscounts?: Maybe<SortOrder>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyInvoicePointGranterOrderByRelevanceFieldEnum {
  Id = 'id',
  Label = 'label',
  ProgramId = 'programId'
}

export type LoyaltyInvoicePointGranterOrderByRelevanceInput = {
  fields: Array<LoyaltyInvoicePointGranterOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyInvoicePointGranterOrderByWithAggregationInput = {
  _count?: Maybe<LoyaltyInvoicePointGranterCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyInvoicePointGranterMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyInvoicePointGranterMinOrderByAggregateInput>;
  allowAllServices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  reduceFromDiscounts?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyInvoicePointGranterOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyInvoicePointGranterOrderByRelevanceInput>;
  allowAllServices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enabled?: Maybe<SortOrder>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryOrderByRelationAggregateInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  reduceFromDiscounts?: Maybe<SortOrder>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyInvoicePointGranterOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyInvoicePointGranterOrderByRelevanceInput>;
  allowAllServices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  enabled?: Maybe<SortOrder>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryOrderByRelationAggregateInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  reduceFromDiscounts?: Maybe<SortOrder>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyInvoicePointGranterScalarFieldEnum {
  AllowAllServices = 'allowAllServices',
  CreatedAt = 'createdAt',
  Enabled = 'enabled',
  Id = 'id',
  Label = 'label',
  ProgramId = 'programId',
  ReduceFromDiscounts = 'reduceFromDiscounts',
  UpdatedAt = 'updatedAt'
}

export type LoyaltyInvoicePointGranterScalarRelationFilter = {
  AND?: Maybe<Array<LoyaltyInvoicePointGranterWhereInput>>;
  NOT?: Maybe<Array<LoyaltyInvoicePointGranterWhereInput>>;
  OR?: Maybe<Array<LoyaltyInvoicePointGranterWhereInput>>;
  allowAllServices?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enabled?: Maybe<BoolFilter>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryListRelationFilter>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceListRelationFilter>;
  id?: Maybe<StringFilter>;
  label?: Maybe<StringFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  reduceFromDiscounts?: Maybe<BoolFilter>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyInvoicePointGranterScalarWhereInput = {
  AND?: Maybe<Array<LoyaltyInvoicePointGranterScalarWhereInput>>;
  NOT?: Maybe<Array<LoyaltyInvoicePointGranterScalarWhereInput>>;
  OR?: Maybe<Array<LoyaltyInvoicePointGranterScalarWhereInput>>;
  allowAllServices?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enabled?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  label?: Maybe<StringFilter>;
  programId?: Maybe<StringFilter>;
  reduceFromDiscounts?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyInvoicePointGranterScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyInvoicePointGranterScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyInvoicePointGranterScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyInvoicePointGranterScalarWhereWithAggregatesInput>>;
  allowAllServices?: Maybe<BoolWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  enabled?: Maybe<BoolWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  label?: Maybe<StringWithAggregatesFilter>;
  programId?: Maybe<StringWithAggregatesFilter>;
  reduceFromDiscounts?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type LoyaltyInvoicePointGranterUncheckedCreateInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedCreateNestedManyWithoutGranterInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutGranterInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutInvoicePointGranterInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUncheckedCreateNestedManyWithoutProgramInput = {
  connect?: Maybe<Array<LoyaltyInvoicePointGranterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyInvoicePointGranterCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyInvoicePointGranterCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyInvoicePointGranterCreateManyProgramInputEnvelope>;
};

export type LoyaltyInvoicePointGranterUncheckedCreateWithoutGrantingServiceCategoriesInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutGranterInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutInvoicePointGranterInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUncheckedCreateWithoutGrantingServicesInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedCreateNestedManyWithoutGranterInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutInvoicePointGranterInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUncheckedCreateWithoutProgramInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedCreateNestedManyWithoutGranterInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutGranterInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutInvoicePointGranterInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUncheckedCreateWithoutRelatedInvoiceLoyaltyPointDeltasInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedCreateNestedManyWithoutGranterInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutGranterInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUncheckedUpdateInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutGranterNestedInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutGranterNestedInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutInvoicePointGranterNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUncheckedUpdateManyInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUncheckedUpdateManyWithoutProgramInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUncheckedUpdateManyWithoutProgramNestedInput = {
  connect?: Maybe<Array<LoyaltyInvoicePointGranterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyInvoicePointGranterCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyInvoicePointGranterCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyInvoicePointGranterCreateManyProgramInputEnvelope>;
  delete?: Maybe<Array<LoyaltyInvoicePointGranterWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyInvoicePointGranterScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyInvoicePointGranterWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyInvoicePointGranterWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyInvoicePointGranterUpdateWithWhereUniqueWithoutProgramInput>>;
  updateMany?: Maybe<Array<LoyaltyInvoicePointGranterUpdateManyWithWhereWithoutProgramInput>>;
  upsert?: Maybe<Array<LoyaltyInvoicePointGranterUpsertWithWhereUniqueWithoutProgramInput>>;
};

export type LoyaltyInvoicePointGranterUncheckedUpdateWithoutGrantingServiceCategoriesInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutGranterNestedInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutInvoicePointGranterNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUncheckedUpdateWithoutGrantingServicesInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutGranterNestedInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutInvoicePointGranterNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUncheckedUpdateWithoutProgramInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutGranterNestedInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutGranterNestedInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutInvoicePointGranterNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUncheckedUpdateWithoutRelatedInvoiceLoyaltyPointDeltasInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutGranterNestedInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutGranterNestedInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUpdateInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUpdateManyWithoutGranterNestedInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutGranterNestedInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutPointGrantersNestedInput>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutInvoicePointGranterNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUpdateManyMutationInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUpdateManyWithWhereWithoutProgramInput = {
  data: LoyaltyInvoicePointGranterUpdateManyMutationInput;
  where: LoyaltyInvoicePointGranterScalarWhereInput;
};

export type LoyaltyInvoicePointGranterUpdateManyWithoutProgramNestedInput = {
  connect?: Maybe<Array<LoyaltyInvoicePointGranterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyInvoicePointGranterCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyInvoicePointGranterCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyInvoicePointGranterCreateManyProgramInputEnvelope>;
  delete?: Maybe<Array<LoyaltyInvoicePointGranterWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyInvoicePointGranterScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyInvoicePointGranterWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyInvoicePointGranterWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyInvoicePointGranterUpdateWithWhereUniqueWithoutProgramInput>>;
  updateMany?: Maybe<Array<LoyaltyInvoicePointGranterUpdateManyWithWhereWithoutProgramInput>>;
  upsert?: Maybe<Array<LoyaltyInvoicePointGranterUpsertWithWhereUniqueWithoutProgramInput>>;
};

export type LoyaltyInvoicePointGranterUpdateOneRequiredWithoutGrantingServiceCategoriesNestedInput = {
  connect?: Maybe<LoyaltyInvoicePointGranterWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyInvoicePointGranterCreateOrConnectWithoutGrantingServiceCategoriesInput>;
  create?: Maybe<LoyaltyInvoicePointGranterCreateWithoutGrantingServiceCategoriesInput>;
  update?: Maybe<LoyaltyInvoicePointGranterUpdateToOneWithWhereWithoutGrantingServiceCategoriesInput>;
  upsert?: Maybe<LoyaltyInvoicePointGranterUpsertWithoutGrantingServiceCategoriesInput>;
};

export type LoyaltyInvoicePointGranterUpdateOneRequiredWithoutGrantingServicesNestedInput = {
  connect?: Maybe<LoyaltyInvoicePointGranterWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyInvoicePointGranterCreateOrConnectWithoutGrantingServicesInput>;
  create?: Maybe<LoyaltyInvoicePointGranterCreateWithoutGrantingServicesInput>;
  update?: Maybe<LoyaltyInvoicePointGranterUpdateToOneWithWhereWithoutGrantingServicesInput>;
  upsert?: Maybe<LoyaltyInvoicePointGranterUpsertWithoutGrantingServicesInput>;
};

export type LoyaltyInvoicePointGranterUpdateOneWithoutRelatedInvoiceLoyaltyPointDeltasNestedInput = {
  connect?: Maybe<LoyaltyInvoicePointGranterWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyInvoicePointGranterCreateOrConnectWithoutRelatedInvoiceLoyaltyPointDeltasInput>;
  create?: Maybe<LoyaltyInvoicePointGranterCreateWithoutRelatedInvoiceLoyaltyPointDeltasInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LoyaltyInvoicePointGranterUpdateToOneWithWhereWithoutRelatedInvoiceLoyaltyPointDeltasInput>;
  upsert?: Maybe<LoyaltyInvoicePointGranterUpsertWithoutRelatedInvoiceLoyaltyPointDeltasInput>;
};

export type LoyaltyInvoicePointGranterUpdateToOneWithWhereWithoutGrantingServiceCategoriesInput = {
  data: LoyaltyInvoicePointGranterUpdateWithoutGrantingServiceCategoriesInput;
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};

export type LoyaltyInvoicePointGranterUpdateToOneWithWhereWithoutGrantingServicesInput = {
  data: LoyaltyInvoicePointGranterUpdateWithoutGrantingServicesInput;
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};

export type LoyaltyInvoicePointGranterUpdateToOneWithWhereWithoutRelatedInvoiceLoyaltyPointDeltasInput = {
  data: LoyaltyInvoicePointGranterUpdateWithoutRelatedInvoiceLoyaltyPointDeltasInput;
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};

export type LoyaltyInvoicePointGranterUpdateWithWhereUniqueWithoutProgramInput = {
  data: LoyaltyInvoicePointGranterUpdateWithoutProgramInput;
  where: LoyaltyInvoicePointGranterWhereUniqueInput;
};

export type LoyaltyInvoicePointGranterUpdateWithoutGrantingServiceCategoriesInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutGranterNestedInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutPointGrantersNestedInput>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutInvoicePointGranterNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUpdateWithoutGrantingServicesInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUpdateManyWithoutGranterNestedInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutPointGrantersNestedInput>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutInvoicePointGranterNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUpdateWithoutProgramInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUpdateManyWithoutGranterNestedInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutGranterNestedInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutInvoicePointGranterNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUpdateWithoutRelatedInvoiceLoyaltyPointDeltasInput = {
  allowAllServices?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUpdateManyWithoutGranterNestedInput>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutGranterNestedInput>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutPointGrantersNestedInput>;
  reduceFromDiscounts?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyInvoicePointGranterUpsertWithWhereUniqueWithoutProgramInput = {
  create: LoyaltyInvoicePointGranterCreateWithoutProgramInput;
  update: LoyaltyInvoicePointGranterUpdateWithoutProgramInput;
  where: LoyaltyInvoicePointGranterWhereUniqueInput;
};

export type LoyaltyInvoicePointGranterUpsertWithoutGrantingServiceCategoriesInput = {
  create: LoyaltyInvoicePointGranterCreateWithoutGrantingServiceCategoriesInput;
  update: LoyaltyInvoicePointGranterUpdateWithoutGrantingServiceCategoriesInput;
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};

export type LoyaltyInvoicePointGranterUpsertWithoutGrantingServicesInput = {
  create: LoyaltyInvoicePointGranterCreateWithoutGrantingServicesInput;
  update: LoyaltyInvoicePointGranterUpdateWithoutGrantingServicesInput;
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};

export type LoyaltyInvoicePointGranterUpsertWithoutRelatedInvoiceLoyaltyPointDeltasInput = {
  create: LoyaltyInvoicePointGranterCreateWithoutRelatedInvoiceLoyaltyPointDeltasInput;
  update: LoyaltyInvoicePointGranterUpdateWithoutRelatedInvoiceLoyaltyPointDeltasInput;
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};

export type LoyaltyInvoicePointGranterWhereInput = {
  AND?: Maybe<Array<LoyaltyInvoicePointGranterWhereInput>>;
  NOT?: Maybe<Array<LoyaltyInvoicePointGranterWhereInput>>;
  OR?: Maybe<Array<LoyaltyInvoicePointGranterWhereInput>>;
  allowAllServices?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enabled?: Maybe<BoolFilter>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryListRelationFilter>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceListRelationFilter>;
  id?: Maybe<StringFilter>;
  label?: Maybe<StringFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  reduceFromDiscounts?: Maybe<BoolFilter>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyInvoicePointGranterWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyInvoicePointGranterWhereInput>>;
  NOT?: Maybe<Array<LoyaltyInvoicePointGranterWhereInput>>;
  OR?: Maybe<Array<LoyaltyInvoicePointGranterWhereInput>>;
  allowAllServices?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  enabled?: Maybe<BoolFilter>;
  grantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryListRelationFilter>;
  grantingServices?: Maybe<LoyaltyPointGrantingServiceListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<StringFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  reduceFromDiscounts?: Maybe<BoolFilter>;
  relatedInvoiceLoyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyInvoiceTriggerInput = {
  invoiceId: Scalars['String'];
};

export type LoyaltyInvoiceTriggerOutput = {
  __typename?: 'LoyaltyInvoiceTriggerOutput';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type LoyaltyPointDelta = {
  __typename?: 'LoyaltyPointDelta';
  account: LoyaltyAccount;
  accountId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  grantingInvoice?: Maybe<Invoice>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranter>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount: Scalars['Boolean'];
  relatedClinic: Clinic;
  relatedClinicId: Scalars['String'];
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntry>;
  source: LoyaltyPointDeltaSource;
  updatedAt: Scalars['DateTime'];
  userGrant?: Maybe<LoyaltyPointUserGrant>;
  userGrantId?: Maybe<Scalars['String']>;
};


export type LoyaltyPointDeltaGrantingInvoiceArgs = {
  where?: Maybe<InvoiceWhereInput>;
};


export type LoyaltyPointDeltaInvoicePointGranterArgs = {
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};


export type LoyaltyPointDeltaRelatedRedemptionHistoryEntryArgs = {
  where?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
};


export type LoyaltyPointDeltaUserGrantArgs = {
  where?: Maybe<LoyaltyPointUserGrantWhereInput>;
};

export type LoyaltyPointDeltaAvgAggregateOutputType = {
  __typename?: 'LoyaltyPointDeltaAvgAggregateOutputType';
  leftOverSpendDelta?: Maybe<Scalars['Float']>;
  points?: Maybe<Scalars['Float']>;
};

export type LoyaltyPointDeltaAvgOrderByAggregateInput = {
  leftOverSpendDelta?: Maybe<SortOrder>;
  points?: Maybe<SortOrder>;
};

export type LoyaltyPointDeltaCountAggregateOutputType = {
  __typename?: 'LoyaltyPointDeltaCountAggregateOutputType';
  _all: Scalars['Int'];
  accountId: Scalars['Int'];
  createdAt: Scalars['Int'];
  grantingInvoiceId: Scalars['Int'];
  id: Scalars['Int'];
  invoicePointGranterId: Scalars['Int'];
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount: Scalars['Int'];
  relatedClinicId: Scalars['Int'];
  source: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userGrantId: Scalars['Int'];
};

export type LoyaltyPointDeltaCountOrderByAggregateInput = {
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingInvoiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoicePointGranterId?: Maybe<SortOrder>;
  leftOverSpendDelta?: Maybe<SortOrder>;
  points?: Maybe<SortOrder>;
  postedToAccount?: Maybe<SortOrder>;
  relatedClinicId?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGrantId?: Maybe<SortOrder>;
};

export type LoyaltyPointDeltaCreateInput = {
  account: LoyaltyAccountCreateNestedOneWithoutPointDeltasInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoice?: Maybe<InvoiceCreateNestedOneWithoutLoyaltyPointDeltasInput>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterCreateNestedOneWithoutRelatedInvoiceLoyaltyPointDeltasInput>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinic: ClinicCreateNestedOneWithoutLoyaltyPointDeltasInput;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedOneWithoutPointDeltaInput>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrant?: Maybe<LoyaltyPointUserGrantCreateNestedOneWithoutLoyaltyPointDeltasInput>;
};

export type LoyaltyPointDeltaCreateManyAccountInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId: Scalars['String'];
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaCreateManyAccountInputEnvelope = {
  data: Array<LoyaltyPointDeltaCreateManyAccountInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyPointDeltaCreateManyGrantingInvoiceInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId: Scalars['String'];
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaCreateManyGrantingInvoiceInputEnvelope = {
  data: Array<LoyaltyPointDeltaCreateManyGrantingInvoiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyPointDeltaCreateManyInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId: Scalars['String'];
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaCreateManyInvoicePointGranterInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId: Scalars['String'];
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaCreateManyInvoicePointGranterInputEnvelope = {
  data: Array<LoyaltyPointDeltaCreateManyInvoicePointGranterInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyPointDeltaCreateManyRelatedClinicInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaCreateManyRelatedClinicInputEnvelope = {
  data: Array<LoyaltyPointDeltaCreateManyRelatedClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyPointDeltaCreateManyUserGrantInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId: Scalars['String'];
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointDeltaCreateManyUserGrantInputEnvelope = {
  data: Array<LoyaltyPointDeltaCreateManyUserGrantInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyPointDeltaCreateNestedManyWithoutAccountInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutAccountInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutAccountInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyAccountInputEnvelope>;
};

export type LoyaltyPointDeltaCreateNestedManyWithoutGrantingInvoiceInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutGrantingInvoiceInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutGrantingInvoiceInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyGrantingInvoiceInputEnvelope>;
};

export type LoyaltyPointDeltaCreateNestedManyWithoutInvoicePointGranterInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutInvoicePointGranterInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutInvoicePointGranterInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyInvoicePointGranterInputEnvelope>;
};

export type LoyaltyPointDeltaCreateNestedManyWithoutRelatedClinicInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutRelatedClinicInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutRelatedClinicInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyRelatedClinicInputEnvelope>;
};

export type LoyaltyPointDeltaCreateNestedManyWithoutUserGrantInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutUserGrantInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutUserGrantInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyUserGrantInputEnvelope>;
};

export type LoyaltyPointDeltaCreateNestedOneWithoutRelatedRedemptionHistoryEntryInput = {
  connect?: Maybe<LoyaltyPointDeltaWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyPointDeltaCreateOrConnectWithoutRelatedRedemptionHistoryEntryInput>;
  create?: Maybe<LoyaltyPointDeltaCreateWithoutRelatedRedemptionHistoryEntryInput>;
};

export type LoyaltyPointDeltaCreateOrConnectWithoutAccountInput = {
  create: LoyaltyPointDeltaCreateWithoutAccountInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaCreateOrConnectWithoutGrantingInvoiceInput = {
  create: LoyaltyPointDeltaCreateWithoutGrantingInvoiceInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaCreateOrConnectWithoutInvoicePointGranterInput = {
  create: LoyaltyPointDeltaCreateWithoutInvoicePointGranterInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaCreateOrConnectWithoutRelatedClinicInput = {
  create: LoyaltyPointDeltaCreateWithoutRelatedClinicInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaCreateOrConnectWithoutRelatedRedemptionHistoryEntryInput = {
  create: LoyaltyPointDeltaCreateWithoutRelatedRedemptionHistoryEntryInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaCreateOrConnectWithoutUserGrantInput = {
  create: LoyaltyPointDeltaCreateWithoutUserGrantInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaCreateWithoutAccountInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoice?: Maybe<InvoiceCreateNestedOneWithoutLoyaltyPointDeltasInput>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterCreateNestedOneWithoutRelatedInvoiceLoyaltyPointDeltasInput>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinic: ClinicCreateNestedOneWithoutLoyaltyPointDeltasInput;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedOneWithoutPointDeltaInput>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrant?: Maybe<LoyaltyPointUserGrantCreateNestedOneWithoutLoyaltyPointDeltasInput>;
};

export type LoyaltyPointDeltaCreateWithoutGrantingInvoiceInput = {
  account: LoyaltyAccountCreateNestedOneWithoutPointDeltasInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterCreateNestedOneWithoutRelatedInvoiceLoyaltyPointDeltasInput>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinic: ClinicCreateNestedOneWithoutLoyaltyPointDeltasInput;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedOneWithoutPointDeltaInput>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrant?: Maybe<LoyaltyPointUserGrantCreateNestedOneWithoutLoyaltyPointDeltasInput>;
};

export type LoyaltyPointDeltaCreateWithoutInvoicePointGranterInput = {
  account: LoyaltyAccountCreateNestedOneWithoutPointDeltasInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoice?: Maybe<InvoiceCreateNestedOneWithoutLoyaltyPointDeltasInput>;
  id?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinic: ClinicCreateNestedOneWithoutLoyaltyPointDeltasInput;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedOneWithoutPointDeltaInput>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrant?: Maybe<LoyaltyPointUserGrantCreateNestedOneWithoutLoyaltyPointDeltasInput>;
};

export type LoyaltyPointDeltaCreateWithoutRelatedClinicInput = {
  account: LoyaltyAccountCreateNestedOneWithoutPointDeltasInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoice?: Maybe<InvoiceCreateNestedOneWithoutLoyaltyPointDeltasInput>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterCreateNestedOneWithoutRelatedInvoiceLoyaltyPointDeltasInput>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedOneWithoutPointDeltaInput>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrant?: Maybe<LoyaltyPointUserGrantCreateNestedOneWithoutLoyaltyPointDeltasInput>;
};

export type LoyaltyPointDeltaCreateWithoutRelatedRedemptionHistoryEntryInput = {
  account: LoyaltyAccountCreateNestedOneWithoutPointDeltasInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoice?: Maybe<InvoiceCreateNestedOneWithoutLoyaltyPointDeltasInput>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterCreateNestedOneWithoutRelatedInvoiceLoyaltyPointDeltasInput>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinic: ClinicCreateNestedOneWithoutLoyaltyPointDeltasInput;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrant?: Maybe<LoyaltyPointUserGrantCreateNestedOneWithoutLoyaltyPointDeltasInput>;
};

export type LoyaltyPointDeltaCreateWithoutUserGrantInput = {
  account: LoyaltyAccountCreateNestedOneWithoutPointDeltasInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoice?: Maybe<InvoiceCreateNestedOneWithoutLoyaltyPointDeltasInput>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterCreateNestedOneWithoutRelatedInvoiceLoyaltyPointDeltasInput>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinic: ClinicCreateNestedOneWithoutLoyaltyPointDeltasInput;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedOneWithoutPointDeltaInput>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointDeltaGrantingInvoiceIdInvoicePointGranterIdCompoundUniqueInput = {
  grantingInvoiceId: Scalars['String'];
  invoicePointGranterId: Scalars['String'];
};

export type LoyaltyPointDeltaGroupByOutputType = {
  __typename?: 'LoyaltyPointDeltaGroupByOutputType';
  _avg?: Maybe<LoyaltyPointDeltaAvgAggregateOutputType>;
  _count?: Maybe<LoyaltyPointDeltaCountAggregateOutputType>;
  _max?: Maybe<LoyaltyPointDeltaMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyPointDeltaMinAggregateOutputType>;
  _sum?: Maybe<LoyaltyPointDeltaSumAggregateOutputType>;
  accountId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount: Scalars['Boolean'];
  relatedClinicId: Scalars['String'];
  source: LoyaltyPointDeltaSource;
  updatedAt: Scalars['DateTime'];
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaListRelationFilter = {
  every?: Maybe<LoyaltyPointDeltaWhereInput>;
  none?: Maybe<LoyaltyPointDeltaWhereInput>;
  some?: Maybe<LoyaltyPointDeltaWhereInput>;
};

export type LoyaltyPointDeltaMaxAggregateOutputType = {
  __typename?: 'LoyaltyPointDeltaMaxAggregateOutputType';
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaMaxOrderByAggregateInput = {
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingInvoiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoicePointGranterId?: Maybe<SortOrder>;
  leftOverSpendDelta?: Maybe<SortOrder>;
  points?: Maybe<SortOrder>;
  postedToAccount?: Maybe<SortOrder>;
  relatedClinicId?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGrantId?: Maybe<SortOrder>;
};

export type LoyaltyPointDeltaMinAggregateOutputType = {
  __typename?: 'LoyaltyPointDeltaMinAggregateOutputType';
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaMinOrderByAggregateInput = {
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingInvoiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoicePointGranterId?: Maybe<SortOrder>;
  leftOverSpendDelta?: Maybe<SortOrder>;
  points?: Maybe<SortOrder>;
  postedToAccount?: Maybe<SortOrder>;
  relatedClinicId?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGrantId?: Maybe<SortOrder>;
};

export type LoyaltyPointDeltaNullableScalarRelationFilter = {
  AND?: Maybe<Array<LoyaltyPointDeltaWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointDeltaWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointDeltaWhereInput>>;
  account?: Maybe<LoyaltyAccountScalarRelationFilter>;
  accountId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  grantingInvoice?: Maybe<InvoiceNullableScalarRelationFilter>;
  grantingInvoiceId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterNullableScalarRelationFilter>;
  invoicePointGranterId?: Maybe<StringNullableFilter>;
  leftOverSpendDelta?: Maybe<IntFilter>;
  points?: Maybe<IntFilter>;
  postedToAccount?: Maybe<BoolFilter>;
  relatedClinic?: Maybe<ClinicScalarRelationFilter>;
  relatedClinicId?: Maybe<StringFilter>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryNullableScalarRelationFilter>;
  source?: Maybe<EnumLoyaltyPointDeltaSourceFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userGrant?: Maybe<LoyaltyPointUserGrantNullableScalarRelationFilter>;
  userGrantId?: Maybe<StringNullableFilter>;
};

export type LoyaltyPointDeltaOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LoyaltyPointDeltaOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyPointDeltaOrderByRelevanceInput>;
  account?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingInvoice?: Maybe<InvoiceOrderByWithRelationInput>;
  grantingInvoiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>;
  invoicePointGranterId?: Maybe<SortOrder>;
  leftOverSpendDelta?: Maybe<SortOrder>;
  points?: Maybe<SortOrder>;
  postedToAccount?: Maybe<SortOrder>;
  relatedClinic?: Maybe<ClinicOrderByWithRelationInput>;
  relatedClinicId?: Maybe<SortOrder>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationInput>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGrant?: Maybe<LoyaltyPointUserGrantOrderByWithRelationInput>;
  userGrantId?: Maybe<SortOrder>;
};

export enum LoyaltyPointDeltaOrderByRelevanceFieldEnum {
  AccountId = 'accountId',
  GrantingInvoiceId = 'grantingInvoiceId',
  Id = 'id',
  InvoicePointGranterId = 'invoicePointGranterId',
  RelatedClinicId = 'relatedClinicId',
  UserGrantId = 'userGrantId'
}

export type LoyaltyPointDeltaOrderByRelevanceInput = {
  fields: Array<LoyaltyPointDeltaOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyPointDeltaOrderByWithAggregationInput = {
  _avg?: Maybe<LoyaltyPointDeltaAvgOrderByAggregateInput>;
  _count?: Maybe<LoyaltyPointDeltaCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyPointDeltaMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyPointDeltaMinOrderByAggregateInput>;
  _sum?: Maybe<LoyaltyPointDeltaSumOrderByAggregateInput>;
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingInvoiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoicePointGranterId?: Maybe<SortOrder>;
  leftOverSpendDelta?: Maybe<SortOrder>;
  points?: Maybe<SortOrder>;
  postedToAccount?: Maybe<SortOrder>;
  relatedClinicId?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGrantId?: Maybe<SortOrder>;
};

export type LoyaltyPointDeltaOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyPointDeltaOrderByRelevanceInput>;
  account?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingInvoice?: Maybe<InvoiceOrderByWithRelationInput>;
  grantingInvoiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>;
  invoicePointGranterId?: Maybe<SortOrder>;
  leftOverSpendDelta?: Maybe<SortOrder>;
  points?: Maybe<SortOrder>;
  postedToAccount?: Maybe<SortOrder>;
  relatedClinic?: Maybe<ClinicOrderByWithRelationInput>;
  relatedClinicId?: Maybe<SortOrder>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationInput>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGrant?: Maybe<LoyaltyPointUserGrantOrderByWithRelationInput>;
  userGrantId?: Maybe<SortOrder>;
};

export type LoyaltyPointDeltaOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyPointDeltaOrderByRelevanceInput>;
  account?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingInvoice?: Maybe<InvoiceOrderByWithRelationInput>;
  grantingInvoiceId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>;
  invoicePointGranterId?: Maybe<SortOrder>;
  leftOverSpendDelta?: Maybe<SortOrder>;
  points?: Maybe<SortOrder>;
  postedToAccount?: Maybe<SortOrder>;
  relatedClinic?: Maybe<ClinicOrderByWithRelationInput>;
  relatedClinicId?: Maybe<SortOrder>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationInput>;
  source?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userGrant?: Maybe<LoyaltyPointUserGrantOrderByWithRelationInput>;
  userGrantId?: Maybe<SortOrder>;
};

export enum LoyaltyPointDeltaScalarFieldEnum {
  AccountId = 'accountId',
  CreatedAt = 'createdAt',
  GrantingInvoiceId = 'grantingInvoiceId',
  Id = 'id',
  InvoicePointGranterId = 'invoicePointGranterId',
  LeftOverSpendDelta = 'leftOverSpendDelta',
  Points = 'points',
  PostedToAccount = 'postedToAccount',
  RelatedClinicId = 'relatedClinicId',
  Source = 'source',
  UpdatedAt = 'updatedAt',
  UserGrantId = 'userGrantId'
}

export type LoyaltyPointDeltaScalarWhereInput = {
  AND?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  accountId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  grantingInvoiceId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invoicePointGranterId?: Maybe<StringNullableFilter>;
  leftOverSpendDelta?: Maybe<IntFilter>;
  points?: Maybe<IntFilter>;
  postedToAccount?: Maybe<BoolFilter>;
  relatedClinicId?: Maybe<StringFilter>;
  source?: Maybe<EnumLoyaltyPointDeltaSourceFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userGrantId?: Maybe<StringNullableFilter>;
};

export type LoyaltyPointDeltaScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyPointDeltaScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyPointDeltaScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyPointDeltaScalarWhereWithAggregatesInput>>;
  accountId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  grantingInvoiceId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  invoicePointGranterId?: Maybe<StringNullableWithAggregatesFilter>;
  leftOverSpendDelta?: Maybe<IntWithAggregatesFilter>;
  points?: Maybe<IntWithAggregatesFilter>;
  postedToAccount?: Maybe<BoolWithAggregatesFilter>;
  relatedClinicId?: Maybe<StringWithAggregatesFilter>;
  source?: Maybe<EnumLoyaltyPointDeltaSourceWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userGrantId?: Maybe<StringNullableWithAggregatesFilter>;
};

export enum LoyaltyPointDeltaSource {
  Correction = 'Correction',
  InvoiceSpend = 'InvoiceSpend',
  Merge = 'Merge',
  Migration = 'Migration',
  RewardRedemption = 'RewardRedemption',
  UserGrant = 'UserGrant'
}

export type LoyaltyPointDeltaSumAggregateOutputType = {
  __typename?: 'LoyaltyPointDeltaSumAggregateOutputType';
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
};

export type LoyaltyPointDeltaSumOrderByAggregateInput = {
  leftOverSpendDelta?: Maybe<SortOrder>;
  points?: Maybe<SortOrder>;
};

export type LoyaltyPointDeltaUncheckedCreateInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId: Scalars['String'];
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedOneWithoutPointDeltaInput>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutAccountInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutAccountInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyAccountInputEnvelope>;
};

export type LoyaltyPointDeltaUncheckedCreateNestedManyWithoutGrantingInvoiceInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutGrantingInvoiceInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutGrantingInvoiceInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyGrantingInvoiceInputEnvelope>;
};

export type LoyaltyPointDeltaUncheckedCreateNestedManyWithoutInvoicePointGranterInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutInvoicePointGranterInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutInvoicePointGranterInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyInvoicePointGranterInputEnvelope>;
};

export type LoyaltyPointDeltaUncheckedCreateNestedManyWithoutRelatedClinicInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutRelatedClinicInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutRelatedClinicInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyRelatedClinicInputEnvelope>;
};

export type LoyaltyPointDeltaUncheckedCreateNestedManyWithoutUserGrantInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutUserGrantInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutUserGrantInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyUserGrantInputEnvelope>;
};

export type LoyaltyPointDeltaUncheckedCreateWithoutAccountInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId: Scalars['String'];
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedOneWithoutPointDeltaInput>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedCreateWithoutGrantingInvoiceInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId: Scalars['String'];
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedOneWithoutPointDeltaInput>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedCreateWithoutInvoicePointGranterInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId: Scalars['String'];
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedOneWithoutPointDeltaInput>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedCreateWithoutRelatedClinicInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedOneWithoutPointDeltaInput>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedCreateWithoutRelatedRedemptionHistoryEntryInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId: Scalars['String'];
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedCreateWithoutUserGrantInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta: Scalars['Int'];
  points: Scalars['Int'];
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId: Scalars['String'];
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedOneWithoutPointDeltaInput>;
  source: LoyaltyPointDeltaSource;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointDeltaUncheckedUpdateInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateOneWithoutPointDeltaNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedUpdateManyInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedUpdateManyWithoutAccountInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutAccountInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutAccountInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyAccountInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointDeltaUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: Maybe<Array<LoyaltyPointDeltaUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: Maybe<Array<LoyaltyPointDeltaUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedUpdateManyWithoutGrantingInvoiceNestedInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutGrantingInvoiceInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutGrantingInvoiceInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyGrantingInvoiceInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointDeltaUpdateWithWhereUniqueWithoutGrantingInvoiceInput>>;
  updateMany?: Maybe<Array<LoyaltyPointDeltaUpdateManyWithWhereWithoutGrantingInvoiceInput>>;
  upsert?: Maybe<Array<LoyaltyPointDeltaUpsertWithWhereUniqueWithoutGrantingInvoiceInput>>;
};

export type LoyaltyPointDeltaUncheckedUpdateManyWithoutInvoicePointGranterInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedUpdateManyWithoutInvoicePointGranterNestedInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutInvoicePointGranterInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutInvoicePointGranterInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyInvoicePointGranterInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointDeltaUpdateWithWhereUniqueWithoutInvoicePointGranterInput>>;
  updateMany?: Maybe<Array<LoyaltyPointDeltaUpdateManyWithWhereWithoutInvoicePointGranterInput>>;
  upsert?: Maybe<Array<LoyaltyPointDeltaUpsertWithWhereUniqueWithoutInvoicePointGranterInput>>;
};

export type LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedUpdateManyWithoutRelatedClinicNestedInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutRelatedClinicInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutRelatedClinicInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyRelatedClinicInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointDeltaUpdateWithWhereUniqueWithoutRelatedClinicInput>>;
  updateMany?: Maybe<Array<LoyaltyPointDeltaUpdateManyWithWhereWithoutRelatedClinicInput>>;
  upsert?: Maybe<Array<LoyaltyPointDeltaUpsertWithWhereUniqueWithoutRelatedClinicInput>>;
};

export type LoyaltyPointDeltaUncheckedUpdateManyWithoutUserGrantInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointDeltaUncheckedUpdateManyWithoutUserGrantNestedInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutUserGrantInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutUserGrantInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyUserGrantInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointDeltaUpdateWithWhereUniqueWithoutUserGrantInput>>;
  updateMany?: Maybe<Array<LoyaltyPointDeltaUpdateManyWithWhereWithoutUserGrantInput>>;
  upsert?: Maybe<Array<LoyaltyPointDeltaUpsertWithWhereUniqueWithoutUserGrantInput>>;
};

export type LoyaltyPointDeltaUncheckedUpdateWithoutAccountInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateOneWithoutPointDeltaNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedUpdateWithoutGrantingInvoiceInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateOneWithoutPointDeltaNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedUpdateWithoutInvoicePointGranterInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateOneWithoutPointDeltaNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedUpdateWithoutRelatedClinicInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateOneWithoutPointDeltaNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedUpdateWithoutRelatedRedemptionHistoryEntryInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrantId?: Maybe<Scalars['String']>;
};

export type LoyaltyPointDeltaUncheckedUpdateWithoutUserGrantInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranterId?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateOneWithoutPointDeltaNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointDeltaUpdateInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutPointDeltasNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoice?: Maybe<InvoiceUpdateOneWithoutLoyaltyPointDeltasNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterUpdateOneWithoutRelatedInvoiceLoyaltyPointDeltasNestedInput>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinic?: Maybe<ClinicUpdateOneRequiredWithoutLoyaltyPointDeltasNestedInput>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateOneWithoutPointDeltaNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrant?: Maybe<LoyaltyPointUserGrantUpdateOneWithoutLoyaltyPointDeltasNestedInput>;
};

export type LoyaltyPointDeltaUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointDeltaUpdateManyWithWhereWithoutAccountInput = {
  data: LoyaltyPointDeltaUpdateManyMutationInput;
  where: LoyaltyPointDeltaScalarWhereInput;
};

export type LoyaltyPointDeltaUpdateManyWithWhereWithoutGrantingInvoiceInput = {
  data: LoyaltyPointDeltaUpdateManyMutationInput;
  where: LoyaltyPointDeltaScalarWhereInput;
};

export type LoyaltyPointDeltaUpdateManyWithWhereWithoutInvoicePointGranterInput = {
  data: LoyaltyPointDeltaUpdateManyMutationInput;
  where: LoyaltyPointDeltaScalarWhereInput;
};

export type LoyaltyPointDeltaUpdateManyWithWhereWithoutRelatedClinicInput = {
  data: LoyaltyPointDeltaUpdateManyMutationInput;
  where: LoyaltyPointDeltaScalarWhereInput;
};

export type LoyaltyPointDeltaUpdateManyWithWhereWithoutUserGrantInput = {
  data: LoyaltyPointDeltaUpdateManyMutationInput;
  where: LoyaltyPointDeltaScalarWhereInput;
};

export type LoyaltyPointDeltaUpdateManyWithoutAccountNestedInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutAccountInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutAccountInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyAccountInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointDeltaUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: Maybe<Array<LoyaltyPointDeltaUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: Maybe<Array<LoyaltyPointDeltaUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type LoyaltyPointDeltaUpdateManyWithoutGrantingInvoiceNestedInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutGrantingInvoiceInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutGrantingInvoiceInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyGrantingInvoiceInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointDeltaUpdateWithWhereUniqueWithoutGrantingInvoiceInput>>;
  updateMany?: Maybe<Array<LoyaltyPointDeltaUpdateManyWithWhereWithoutGrantingInvoiceInput>>;
  upsert?: Maybe<Array<LoyaltyPointDeltaUpsertWithWhereUniqueWithoutGrantingInvoiceInput>>;
};

export type LoyaltyPointDeltaUpdateManyWithoutInvoicePointGranterNestedInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutInvoicePointGranterInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutInvoicePointGranterInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyInvoicePointGranterInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointDeltaUpdateWithWhereUniqueWithoutInvoicePointGranterInput>>;
  updateMany?: Maybe<Array<LoyaltyPointDeltaUpdateManyWithWhereWithoutInvoicePointGranterInput>>;
  upsert?: Maybe<Array<LoyaltyPointDeltaUpsertWithWhereUniqueWithoutInvoicePointGranterInput>>;
};

export type LoyaltyPointDeltaUpdateManyWithoutRelatedClinicNestedInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutRelatedClinicInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutRelatedClinicInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyRelatedClinicInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointDeltaUpdateWithWhereUniqueWithoutRelatedClinicInput>>;
  updateMany?: Maybe<Array<LoyaltyPointDeltaUpdateManyWithWhereWithoutRelatedClinicInput>>;
  upsert?: Maybe<Array<LoyaltyPointDeltaUpsertWithWhereUniqueWithoutRelatedClinicInput>>;
};

export type LoyaltyPointDeltaUpdateManyWithoutUserGrantNestedInput = {
  connect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointDeltaCreateOrConnectWithoutUserGrantInput>>;
  create?: Maybe<Array<LoyaltyPointDeltaCreateWithoutUserGrantInput>>;
  createMany?: Maybe<LoyaltyPointDeltaCreateManyUserGrantInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointDeltaScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointDeltaWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointDeltaUpdateWithWhereUniqueWithoutUserGrantInput>>;
  updateMany?: Maybe<Array<LoyaltyPointDeltaUpdateManyWithWhereWithoutUserGrantInput>>;
  upsert?: Maybe<Array<LoyaltyPointDeltaUpsertWithWhereUniqueWithoutUserGrantInput>>;
};

export type LoyaltyPointDeltaUpdateOneWithoutRelatedRedemptionHistoryEntryNestedInput = {
  connect?: Maybe<LoyaltyPointDeltaWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyPointDeltaCreateOrConnectWithoutRelatedRedemptionHistoryEntryInput>;
  create?: Maybe<LoyaltyPointDeltaCreateWithoutRelatedRedemptionHistoryEntryInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LoyaltyPointDeltaUpdateToOneWithWhereWithoutRelatedRedemptionHistoryEntryInput>;
  upsert?: Maybe<LoyaltyPointDeltaUpsertWithoutRelatedRedemptionHistoryEntryInput>;
};

export type LoyaltyPointDeltaUpdateToOneWithWhereWithoutRelatedRedemptionHistoryEntryInput = {
  data: LoyaltyPointDeltaUpdateWithoutRelatedRedemptionHistoryEntryInput;
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
};

export type LoyaltyPointDeltaUpdateWithWhereUniqueWithoutAccountInput = {
  data: LoyaltyPointDeltaUpdateWithoutAccountInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaUpdateWithWhereUniqueWithoutGrantingInvoiceInput = {
  data: LoyaltyPointDeltaUpdateWithoutGrantingInvoiceInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaUpdateWithWhereUniqueWithoutInvoicePointGranterInput = {
  data: LoyaltyPointDeltaUpdateWithoutInvoicePointGranterInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaUpdateWithWhereUniqueWithoutRelatedClinicInput = {
  data: LoyaltyPointDeltaUpdateWithoutRelatedClinicInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaUpdateWithWhereUniqueWithoutUserGrantInput = {
  data: LoyaltyPointDeltaUpdateWithoutUserGrantInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaUpdateWithoutAccountInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoice?: Maybe<InvoiceUpdateOneWithoutLoyaltyPointDeltasNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterUpdateOneWithoutRelatedInvoiceLoyaltyPointDeltasNestedInput>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinic?: Maybe<ClinicUpdateOneRequiredWithoutLoyaltyPointDeltasNestedInput>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateOneWithoutPointDeltaNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrant?: Maybe<LoyaltyPointUserGrantUpdateOneWithoutLoyaltyPointDeltasNestedInput>;
};

export type LoyaltyPointDeltaUpdateWithoutGrantingInvoiceInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutPointDeltasNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterUpdateOneWithoutRelatedInvoiceLoyaltyPointDeltasNestedInput>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinic?: Maybe<ClinicUpdateOneRequiredWithoutLoyaltyPointDeltasNestedInput>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateOneWithoutPointDeltaNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrant?: Maybe<LoyaltyPointUserGrantUpdateOneWithoutLoyaltyPointDeltasNestedInput>;
};

export type LoyaltyPointDeltaUpdateWithoutInvoicePointGranterInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutPointDeltasNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoice?: Maybe<InvoiceUpdateOneWithoutLoyaltyPointDeltasNestedInput>;
  id?: Maybe<Scalars['String']>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinic?: Maybe<ClinicUpdateOneRequiredWithoutLoyaltyPointDeltasNestedInput>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateOneWithoutPointDeltaNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrant?: Maybe<LoyaltyPointUserGrantUpdateOneWithoutLoyaltyPointDeltasNestedInput>;
};

export type LoyaltyPointDeltaUpdateWithoutRelatedClinicInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutPointDeltasNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoice?: Maybe<InvoiceUpdateOneWithoutLoyaltyPointDeltasNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterUpdateOneWithoutRelatedInvoiceLoyaltyPointDeltasNestedInput>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateOneWithoutPointDeltaNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrant?: Maybe<LoyaltyPointUserGrantUpdateOneWithoutLoyaltyPointDeltasNestedInput>;
};

export type LoyaltyPointDeltaUpdateWithoutRelatedRedemptionHistoryEntryInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutPointDeltasNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoice?: Maybe<InvoiceUpdateOneWithoutLoyaltyPointDeltasNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterUpdateOneWithoutRelatedInvoiceLoyaltyPointDeltasNestedInput>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinic?: Maybe<ClinicUpdateOneRequiredWithoutLoyaltyPointDeltasNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGrant?: Maybe<LoyaltyPointUserGrantUpdateOneWithoutLoyaltyPointDeltasNestedInput>;
};

export type LoyaltyPointDeltaUpdateWithoutUserGrantInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutPointDeltasNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingInvoice?: Maybe<InvoiceUpdateOneWithoutLoyaltyPointDeltasNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterUpdateOneWithoutRelatedInvoiceLoyaltyPointDeltasNestedInput>;
  leftOverSpendDelta?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  postedToAccount?: Maybe<Scalars['Boolean']>;
  relatedClinic?: Maybe<ClinicUpdateOneRequiredWithoutLoyaltyPointDeltasNestedInput>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateOneWithoutPointDeltaNestedInput>;
  source?: Maybe<LoyaltyPointDeltaSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointDeltaUpsertWithWhereUniqueWithoutAccountInput = {
  create: LoyaltyPointDeltaCreateWithoutAccountInput;
  update: LoyaltyPointDeltaUpdateWithoutAccountInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaUpsertWithWhereUniqueWithoutGrantingInvoiceInput = {
  create: LoyaltyPointDeltaCreateWithoutGrantingInvoiceInput;
  update: LoyaltyPointDeltaUpdateWithoutGrantingInvoiceInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaUpsertWithWhereUniqueWithoutInvoicePointGranterInput = {
  create: LoyaltyPointDeltaCreateWithoutInvoicePointGranterInput;
  update: LoyaltyPointDeltaUpdateWithoutInvoicePointGranterInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaUpsertWithWhereUniqueWithoutRelatedClinicInput = {
  create: LoyaltyPointDeltaCreateWithoutRelatedClinicInput;
  update: LoyaltyPointDeltaUpdateWithoutRelatedClinicInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaUpsertWithWhereUniqueWithoutUserGrantInput = {
  create: LoyaltyPointDeltaCreateWithoutUserGrantInput;
  update: LoyaltyPointDeltaUpdateWithoutUserGrantInput;
  where: LoyaltyPointDeltaWhereUniqueInput;
};

export type LoyaltyPointDeltaUpsertWithoutRelatedRedemptionHistoryEntryInput = {
  create: LoyaltyPointDeltaCreateWithoutRelatedRedemptionHistoryEntryInput;
  update: LoyaltyPointDeltaUpdateWithoutRelatedRedemptionHistoryEntryInput;
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
};

export type LoyaltyPointDeltaWhereInput = {
  AND?: Maybe<Array<LoyaltyPointDeltaWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointDeltaWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointDeltaWhereInput>>;
  account?: Maybe<LoyaltyAccountScalarRelationFilter>;
  accountId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  grantingInvoice?: Maybe<InvoiceNullableScalarRelationFilter>;
  grantingInvoiceId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterNullableScalarRelationFilter>;
  invoicePointGranterId?: Maybe<StringNullableFilter>;
  leftOverSpendDelta?: Maybe<IntFilter>;
  points?: Maybe<IntFilter>;
  postedToAccount?: Maybe<BoolFilter>;
  relatedClinic?: Maybe<ClinicScalarRelationFilter>;
  relatedClinicId?: Maybe<StringFilter>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryNullableScalarRelationFilter>;
  source?: Maybe<EnumLoyaltyPointDeltaSourceFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userGrant?: Maybe<LoyaltyPointUserGrantNullableScalarRelationFilter>;
  userGrantId?: Maybe<StringNullableFilter>;
};

export type LoyaltyPointDeltaWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyPointDeltaWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointDeltaWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointDeltaWhereInput>>;
  account?: Maybe<LoyaltyAccountScalarRelationFilter>;
  accountId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  grantingInvoice?: Maybe<InvoiceNullableScalarRelationFilter>;
  grantingInvoiceId?: Maybe<StringNullableFilter>;
  grantingInvoiceId_invoicePointGranterId?: Maybe<LoyaltyPointDeltaGrantingInvoiceIdInvoicePointGranterIdCompoundUniqueInput>;
  id?: Maybe<Scalars['String']>;
  invoicePointGranter?: Maybe<LoyaltyInvoicePointGranterNullableScalarRelationFilter>;
  invoicePointGranterId?: Maybe<StringNullableFilter>;
  leftOverSpendDelta?: Maybe<IntFilter>;
  points?: Maybe<IntFilter>;
  postedToAccount?: Maybe<BoolFilter>;
  relatedClinic?: Maybe<ClinicScalarRelationFilter>;
  relatedClinicId?: Maybe<StringFilter>;
  relatedRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntryNullableScalarRelationFilter>;
  source?: Maybe<EnumLoyaltyPointDeltaSourceFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userGrant?: Maybe<LoyaltyPointUserGrantNullableScalarRelationFilter>;
  userGrantId?: Maybe<StringNullableFilter>;
};

export type LoyaltyPointGrantByUser = {
  internalNotes?: Maybe<Scalars['String']>;
  loyaltyAccountId: Scalars['String'];
  points: Scalars['Int'];
  publicNotes?: Maybe<Scalars['String']>;
};

export type LoyaltyPointGrantingService = {
  __typename?: 'LoyaltyPointGrantingService';
  createdAt: Scalars['DateTime'];
  granter: LoyaltyInvoicePointGranter;
  granterId: Scalars['String'];
  service: Service;
  serviceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LoyaltyPointGrantingServiceCategory = {
  __typename?: 'LoyaltyPointGrantingServiceCategory';
  createdAt: Scalars['DateTime'];
  granter: LoyaltyInvoicePointGranter;
  granterId: Scalars['String'];
  serviceCategory: ServiceCategory;
  serviceCategoryId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LoyaltyPointGrantingServiceCategoryCountAggregateOutputType = {
  __typename?: 'LoyaltyPointGrantingServiceCategoryCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  granterId: Scalars['Int'];
  serviceCategoryId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LoyaltyPointGrantingServiceCategoryCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  granterId?: Maybe<SortOrder>;
  serviceCategoryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointGrantingServiceCategoryCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granter: LoyaltyInvoicePointGranterCreateNestedOneWithoutGrantingServiceCategoriesInput;
  serviceCategory: ServiceCategoryCreateNestedOneWithoutLoyaltyPointGrantingServiceCategoriesInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryCreateManyGranterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryCreateManyGranterInputEnvelope = {
  data: Array<LoyaltyPointGrantingServiceCategoryCreateManyGranterInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyPointGrantingServiceCategoryCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId: Scalars['String'];
  serviceCategoryId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryCreateManyServiceCategoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryCreateManyServiceCategoryInputEnvelope = {
  data: Array<LoyaltyPointGrantingServiceCategoryCreateManyServiceCategoryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyPointGrantingServiceCategoryCreateNestedManyWithoutGranterInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateOrConnectWithoutGranterInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateWithoutGranterInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCategoryCreateManyGranterInputEnvelope>;
};

export type LoyaltyPointGrantingServiceCategoryCreateNestedManyWithoutServiceCategoryInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateOrConnectWithoutServiceCategoryInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateWithoutServiceCategoryInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCategoryCreateManyServiceCategoryInputEnvelope>;
};

export type LoyaltyPointGrantingServiceCategoryCreateOrConnectWithoutGranterInput = {
  create: LoyaltyPointGrantingServiceCategoryCreateWithoutGranterInput;
  where: LoyaltyPointGrantingServiceCategoryWhereUniqueInput;
};

export type LoyaltyPointGrantingServiceCategoryCreateOrConnectWithoutServiceCategoryInput = {
  create: LoyaltyPointGrantingServiceCategoryCreateWithoutServiceCategoryInput;
  where: LoyaltyPointGrantingServiceCategoryWhereUniqueInput;
};

export type LoyaltyPointGrantingServiceCategoryCreateWithoutGranterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategory: ServiceCategoryCreateNestedOneWithoutLoyaltyPointGrantingServiceCategoriesInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryCreateWithoutServiceCategoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granter: LoyaltyInvoicePointGranterCreateNestedOneWithoutGrantingServiceCategoriesInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryGroupByOutputType = {
  __typename?: 'LoyaltyPointGrantingServiceCategoryGroupByOutputType';
  _count?: Maybe<LoyaltyPointGrantingServiceCategoryCountAggregateOutputType>;
  _max?: Maybe<LoyaltyPointGrantingServiceCategoryMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyPointGrantingServiceCategoryMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  granterId: Scalars['String'];
  serviceCategoryId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LoyaltyPointGrantingServiceCategoryListRelationFilter = {
  every?: Maybe<LoyaltyPointGrantingServiceCategoryWhereInput>;
  none?: Maybe<LoyaltyPointGrantingServiceCategoryWhereInput>;
  some?: Maybe<LoyaltyPointGrantingServiceCategoryWhereInput>;
};

export type LoyaltyPointGrantingServiceCategoryMaxAggregateOutputType = {
  __typename?: 'LoyaltyPointGrantingServiceCategoryMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId?: Maybe<Scalars['String']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  granterId?: Maybe<SortOrder>;
  serviceCategoryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointGrantingServiceCategoryMinAggregateOutputType = {
  __typename?: 'LoyaltyPointGrantingServiceCategoryMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId?: Maybe<Scalars['String']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  granterId?: Maybe<SortOrder>;
  serviceCategoryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointGrantingServiceCategoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LoyaltyPointGrantingServiceCategoryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyPointGrantingServiceCategoryOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  granter?: Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>;
  granterId?: Maybe<SortOrder>;
  serviceCategory?: Maybe<ServiceCategoryOrderByWithRelationInput>;
  serviceCategoryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyPointGrantingServiceCategoryOrderByRelevanceFieldEnum {
  GranterId = 'granterId',
  ServiceCategoryId = 'serviceCategoryId'
}

export type LoyaltyPointGrantingServiceCategoryOrderByRelevanceInput = {
  fields: Array<LoyaltyPointGrantingServiceCategoryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyPointGrantingServiceCategoryOrderByWithAggregationInput = {
  _count?: Maybe<LoyaltyPointGrantingServiceCategoryCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyPointGrantingServiceCategoryMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyPointGrantingServiceCategoryMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  granterId?: Maybe<SortOrder>;
  serviceCategoryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointGrantingServiceCategoryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyPointGrantingServiceCategoryOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  granter?: Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>;
  granterId?: Maybe<SortOrder>;
  serviceCategory?: Maybe<ServiceCategoryOrderByWithRelationInput>;
  serviceCategoryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointGrantingServiceCategoryOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyPointGrantingServiceCategoryOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  granter?: Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>;
  granterId?: Maybe<SortOrder>;
  serviceCategory?: Maybe<ServiceCategoryOrderByWithRelationInput>;
  serviceCategoryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyPointGrantingServiceCategoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  GranterId = 'granterId',
  ServiceCategoryId = 'serviceCategoryId',
  UpdatedAt = 'updatedAt'
}

export type LoyaltyPointGrantingServiceCategoryScalarWhereInput = {
  AND?: Maybe<Array<LoyaltyPointGrantingServiceCategoryScalarWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointGrantingServiceCategoryScalarWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointGrantingServiceCategoryScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  granterId?: Maybe<StringFilter>;
  serviceCategoryId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyPointGrantingServiceCategoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyPointGrantingServiceCategoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyPointGrantingServiceCategoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyPointGrantingServiceCategoryScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  granterId?: Maybe<StringWithAggregatesFilter>;
  serviceCategoryId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type LoyaltyPointGrantingServiceCategoryServiceCategoryIdGranterIdCompoundUniqueInput = {
  granterId: Scalars['String'];
  serviceCategoryId: Scalars['String'];
};

export type LoyaltyPointGrantingServiceCategoryUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId: Scalars['String'];
  serviceCategoryId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUncheckedCreateNestedManyWithoutGranterInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateOrConnectWithoutGranterInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateWithoutGranterInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCategoryCreateManyGranterInputEnvelope>;
};

export type LoyaltyPointGrantingServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateOrConnectWithoutServiceCategoryInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateWithoutServiceCategoryInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCategoryCreateManyServiceCategoryInputEnvelope>;
};

export type LoyaltyPointGrantingServiceCategoryUncheckedCreateWithoutGranterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUncheckedCreateWithoutServiceCategoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId?: Maybe<Scalars['String']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId?: Maybe<Scalars['String']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutGranterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutGranterNestedInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateOrConnectWithoutGranterInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateWithoutGranterInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCategoryCreateManyGranterInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointGrantingServiceCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointGrantingServiceCategoryUpdateWithWhereUniqueWithoutGranterInput>>;
  updateMany?: Maybe<Array<LoyaltyPointGrantingServiceCategoryUpdateManyWithWhereWithoutGranterInput>>;
  upsert?: Maybe<Array<LoyaltyPointGrantingServiceCategoryUpsertWithWhereUniqueWithoutGranterInput>>;
};

export type LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutServiceCategoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateOrConnectWithoutServiceCategoryInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateWithoutServiceCategoryInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCategoryCreateManyServiceCategoryInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointGrantingServiceCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointGrantingServiceCategoryUpdateWithWhereUniqueWithoutServiceCategoryInput>>;
  updateMany?: Maybe<Array<LoyaltyPointGrantingServiceCategoryUpdateManyWithWhereWithoutServiceCategoryInput>>;
  upsert?: Maybe<Array<LoyaltyPointGrantingServiceCategoryUpsertWithWhereUniqueWithoutServiceCategoryInput>>;
};

export type LoyaltyPointGrantingServiceCategoryUncheckedUpdateWithoutGranterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUncheckedUpdateWithoutServiceCategoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granter?: Maybe<LoyaltyInvoicePointGranterUpdateOneRequiredWithoutGrantingServiceCategoriesNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneRequiredWithoutLoyaltyPointGrantingServiceCategoriesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUpdateManyWithWhereWithoutGranterInput = {
  data: LoyaltyPointGrantingServiceCategoryUpdateManyMutationInput;
  where: LoyaltyPointGrantingServiceCategoryScalarWhereInput;
};

export type LoyaltyPointGrantingServiceCategoryUpdateManyWithWhereWithoutServiceCategoryInput = {
  data: LoyaltyPointGrantingServiceCategoryUpdateManyMutationInput;
  where: LoyaltyPointGrantingServiceCategoryScalarWhereInput;
};

export type LoyaltyPointGrantingServiceCategoryUpdateManyWithoutGranterNestedInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateOrConnectWithoutGranterInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateWithoutGranterInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCategoryCreateManyGranterInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointGrantingServiceCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointGrantingServiceCategoryUpdateWithWhereUniqueWithoutGranterInput>>;
  updateMany?: Maybe<Array<LoyaltyPointGrantingServiceCategoryUpdateManyWithWhereWithoutGranterInput>>;
  upsert?: Maybe<Array<LoyaltyPointGrantingServiceCategoryUpsertWithWhereUniqueWithoutGranterInput>>;
};

export type LoyaltyPointGrantingServiceCategoryUpdateManyWithoutServiceCategoryNestedInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateOrConnectWithoutServiceCategoryInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCategoryCreateWithoutServiceCategoryInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCategoryCreateManyServiceCategoryInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointGrantingServiceCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointGrantingServiceCategoryUpdateWithWhereUniqueWithoutServiceCategoryInput>>;
  updateMany?: Maybe<Array<LoyaltyPointGrantingServiceCategoryUpdateManyWithWhereWithoutServiceCategoryInput>>;
  upsert?: Maybe<Array<LoyaltyPointGrantingServiceCategoryUpsertWithWhereUniqueWithoutServiceCategoryInput>>;
};

export type LoyaltyPointGrantingServiceCategoryUpdateWithWhereUniqueWithoutGranterInput = {
  data: LoyaltyPointGrantingServiceCategoryUpdateWithoutGranterInput;
  where: LoyaltyPointGrantingServiceCategoryWhereUniqueInput;
};

export type LoyaltyPointGrantingServiceCategoryUpdateWithWhereUniqueWithoutServiceCategoryInput = {
  data: LoyaltyPointGrantingServiceCategoryUpdateWithoutServiceCategoryInput;
  where: LoyaltyPointGrantingServiceCategoryWhereUniqueInput;
};

export type LoyaltyPointGrantingServiceCategoryUpdateWithoutGranterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneRequiredWithoutLoyaltyPointGrantingServiceCategoriesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUpdateWithoutServiceCategoryInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granter?: Maybe<LoyaltyInvoicePointGranterUpdateOneRequiredWithoutGrantingServiceCategoriesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCategoryUpsertWithWhereUniqueWithoutGranterInput = {
  create: LoyaltyPointGrantingServiceCategoryCreateWithoutGranterInput;
  update: LoyaltyPointGrantingServiceCategoryUpdateWithoutGranterInput;
  where: LoyaltyPointGrantingServiceCategoryWhereUniqueInput;
};

export type LoyaltyPointGrantingServiceCategoryUpsertWithWhereUniqueWithoutServiceCategoryInput = {
  create: LoyaltyPointGrantingServiceCategoryCreateWithoutServiceCategoryInput;
  update: LoyaltyPointGrantingServiceCategoryUpdateWithoutServiceCategoryInput;
  where: LoyaltyPointGrantingServiceCategoryWhereUniqueInput;
};

export type LoyaltyPointGrantingServiceCategoryWhereInput = {
  AND?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  granter?: Maybe<LoyaltyInvoicePointGranterScalarRelationFilter>;
  granterId?: Maybe<StringFilter>;
  serviceCategory?: Maybe<ServiceCategoryScalarRelationFilter>;
  serviceCategoryId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyPointGrantingServiceCategoryWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointGrantingServiceCategoryWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  granter?: Maybe<LoyaltyInvoicePointGranterScalarRelationFilter>;
  granterId?: Maybe<StringFilter>;
  serviceCategory?: Maybe<ServiceCategoryScalarRelationFilter>;
  serviceCategoryId?: Maybe<StringFilter>;
  serviceCategoryId_granterId?: Maybe<LoyaltyPointGrantingServiceCategoryServiceCategoryIdGranterIdCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyPointGrantingServiceCountAggregateOutputType = {
  __typename?: 'LoyaltyPointGrantingServiceCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  granterId: Scalars['Int'];
  serviceId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LoyaltyPointGrantingServiceCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  granterId?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointGrantingServiceCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granter: LoyaltyInvoicePointGranterCreateNestedOneWithoutGrantingServicesInput;
  service: ServiceCreateNestedOneWithoutLoyaltyPointGrantingServicesInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCreateManyGranterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCreateManyGranterInputEnvelope = {
  data: Array<LoyaltyPointGrantingServiceCreateManyGranterInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyPointGrantingServiceCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId: Scalars['String'];
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCreateManyServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCreateManyServiceInputEnvelope = {
  data: Array<LoyaltyPointGrantingServiceCreateManyServiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyPointGrantingServiceCreateNestedManyWithoutGranterInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCreateOrConnectWithoutGranterInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCreateWithoutGranterInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCreateManyGranterInputEnvelope>;
};

export type LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCreateWithoutServiceInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCreateManyServiceInputEnvelope>;
};

export type LoyaltyPointGrantingServiceCreateOrConnectWithoutGranterInput = {
  create: LoyaltyPointGrantingServiceCreateWithoutGranterInput;
  where: LoyaltyPointGrantingServiceWhereUniqueInput;
};

export type LoyaltyPointGrantingServiceCreateOrConnectWithoutServiceInput = {
  create: LoyaltyPointGrantingServiceCreateWithoutServiceInput;
  where: LoyaltyPointGrantingServiceWhereUniqueInput;
};

export type LoyaltyPointGrantingServiceCreateWithoutGranterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  service: ServiceCreateNestedOneWithoutLoyaltyPointGrantingServicesInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceCreateWithoutServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granter: LoyaltyInvoicePointGranterCreateNestedOneWithoutGrantingServicesInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceGroupByOutputType = {
  __typename?: 'LoyaltyPointGrantingServiceGroupByOutputType';
  _count?: Maybe<LoyaltyPointGrantingServiceCountAggregateOutputType>;
  _max?: Maybe<LoyaltyPointGrantingServiceMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyPointGrantingServiceMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  granterId: Scalars['String'];
  serviceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LoyaltyPointGrantingServiceListRelationFilter = {
  every?: Maybe<LoyaltyPointGrantingServiceWhereInput>;
  none?: Maybe<LoyaltyPointGrantingServiceWhereInput>;
  some?: Maybe<LoyaltyPointGrantingServiceWhereInput>;
};

export type LoyaltyPointGrantingServiceMaxAggregateOutputType = {
  __typename?: 'LoyaltyPointGrantingServiceMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  granterId?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointGrantingServiceMinAggregateOutputType = {
  __typename?: 'LoyaltyPointGrantingServiceMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  granterId?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointGrantingServiceOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LoyaltyPointGrantingServiceOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyPointGrantingServiceOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  granter?: Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>;
  granterId?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyPointGrantingServiceOrderByRelevanceFieldEnum {
  GranterId = 'granterId',
  ServiceId = 'serviceId'
}

export type LoyaltyPointGrantingServiceOrderByRelevanceInput = {
  fields: Array<LoyaltyPointGrantingServiceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyPointGrantingServiceOrderByWithAggregationInput = {
  _count?: Maybe<LoyaltyPointGrantingServiceCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyPointGrantingServiceMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyPointGrantingServiceMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  granterId?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointGrantingServiceOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyPointGrantingServiceOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  granter?: Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>;
  granterId?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointGrantingServiceOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyPointGrantingServiceOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  granter?: Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>;
  granterId?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyPointGrantingServiceScalarFieldEnum {
  CreatedAt = 'createdAt',
  GranterId = 'granterId',
  ServiceId = 'serviceId',
  UpdatedAt = 'updatedAt'
}

export type LoyaltyPointGrantingServiceScalarWhereInput = {
  AND?: Maybe<Array<LoyaltyPointGrantingServiceScalarWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointGrantingServiceScalarWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointGrantingServiceScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  granterId?: Maybe<StringFilter>;
  serviceId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyPointGrantingServiceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyPointGrantingServiceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyPointGrantingServiceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyPointGrantingServiceScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  granterId?: Maybe<StringWithAggregatesFilter>;
  serviceId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type LoyaltyPointGrantingServiceServiceIdGranterIdCompoundUniqueInput = {
  granterId: Scalars['String'];
  serviceId: Scalars['String'];
};

export type LoyaltyPointGrantingServiceUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId: Scalars['String'];
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutGranterInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCreateOrConnectWithoutGranterInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCreateWithoutGranterInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCreateManyGranterInputEnvelope>;
};

export type LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCreateWithoutServiceInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCreateManyServiceInputEnvelope>;
};

export type LoyaltyPointGrantingServiceUncheckedCreateWithoutGranterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUncheckedCreateWithoutServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutGranterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutGranterNestedInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCreateOrConnectWithoutGranterInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCreateWithoutGranterInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCreateManyGranterInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointGrantingServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointGrantingServiceUpdateWithWhereUniqueWithoutGranterInput>>;
  updateMany?: Maybe<Array<LoyaltyPointGrantingServiceUpdateManyWithWhereWithoutGranterInput>>;
  upsert?: Maybe<Array<LoyaltyPointGrantingServiceUpsertWithWhereUniqueWithoutGranterInput>>;
};

export type LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCreateWithoutServiceInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointGrantingServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointGrantingServiceUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<LoyaltyPointGrantingServiceUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<LoyaltyPointGrantingServiceUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type LoyaltyPointGrantingServiceUncheckedUpdateWithoutGranterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUncheckedUpdateWithoutServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granterId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granter?: Maybe<LoyaltyInvoicePointGranterUpdateOneRequiredWithoutGrantingServicesNestedInput>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutLoyaltyPointGrantingServicesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUpdateManyWithWhereWithoutGranterInput = {
  data: LoyaltyPointGrantingServiceUpdateManyMutationInput;
  where: LoyaltyPointGrantingServiceScalarWhereInput;
};

export type LoyaltyPointGrantingServiceUpdateManyWithWhereWithoutServiceInput = {
  data: LoyaltyPointGrantingServiceUpdateManyMutationInput;
  where: LoyaltyPointGrantingServiceScalarWhereInput;
};

export type LoyaltyPointGrantingServiceUpdateManyWithoutGranterNestedInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCreateOrConnectWithoutGranterInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCreateWithoutGranterInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCreateManyGranterInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointGrantingServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointGrantingServiceUpdateWithWhereUniqueWithoutGranterInput>>;
  updateMany?: Maybe<Array<LoyaltyPointGrantingServiceUpdateManyWithWhereWithoutGranterInput>>;
  upsert?: Maybe<Array<LoyaltyPointGrantingServiceUpsertWithWhereUniqueWithoutGranterInput>>;
};

export type LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointGrantingServiceCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<LoyaltyPointGrantingServiceCreateWithoutServiceInput>>;
  createMany?: Maybe<LoyaltyPointGrantingServiceCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointGrantingServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointGrantingServiceWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointGrantingServiceUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<LoyaltyPointGrantingServiceUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<LoyaltyPointGrantingServiceUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type LoyaltyPointGrantingServiceUpdateWithWhereUniqueWithoutGranterInput = {
  data: LoyaltyPointGrantingServiceUpdateWithoutGranterInput;
  where: LoyaltyPointGrantingServiceWhereUniqueInput;
};

export type LoyaltyPointGrantingServiceUpdateWithWhereUniqueWithoutServiceInput = {
  data: LoyaltyPointGrantingServiceUpdateWithoutServiceInput;
  where: LoyaltyPointGrantingServiceWhereUniqueInput;
};

export type LoyaltyPointGrantingServiceUpdateWithoutGranterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutLoyaltyPointGrantingServicesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUpdateWithoutServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  granter?: Maybe<LoyaltyInvoicePointGranterUpdateOneRequiredWithoutGrantingServicesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointGrantingServiceUpsertWithWhereUniqueWithoutGranterInput = {
  create: LoyaltyPointGrantingServiceCreateWithoutGranterInput;
  update: LoyaltyPointGrantingServiceUpdateWithoutGranterInput;
  where: LoyaltyPointGrantingServiceWhereUniqueInput;
};

export type LoyaltyPointGrantingServiceUpsertWithWhereUniqueWithoutServiceInput = {
  create: LoyaltyPointGrantingServiceCreateWithoutServiceInput;
  update: LoyaltyPointGrantingServiceUpdateWithoutServiceInput;
  where: LoyaltyPointGrantingServiceWhereUniqueInput;
};

export type LoyaltyPointGrantingServiceWhereInput = {
  AND?: Maybe<Array<LoyaltyPointGrantingServiceWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointGrantingServiceWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointGrantingServiceWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  granter?: Maybe<LoyaltyInvoicePointGranterScalarRelationFilter>;
  granterId?: Maybe<StringFilter>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyPointGrantingServiceWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyPointGrantingServiceWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointGrantingServiceWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointGrantingServiceWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  granter?: Maybe<LoyaltyInvoicePointGranterScalarRelationFilter>;
  granterId?: Maybe<StringFilter>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
  serviceId_granterId?: Maybe<LoyaltyPointGrantingServiceServiceIdGranterIdCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyPointUserGrant = {
  __typename?: 'LoyaltyPointUserGrant';
  _count: LoyaltyPointUserGrantCountOutputType;
  amount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  grantingUser: User;
  grantingUserId: Scalars['String'];
  id: Scalars['String'];
  internalNotes?: Maybe<Scalars['String']>;
  loyaltyPointDeltas: Array<LoyaltyPointDelta>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type LoyaltyPointUserGrantLoyaltyPointDeltasArgs = {
  cursor?: Maybe<LoyaltyPointDeltaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointDeltaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointDeltaOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
};

export type LoyaltyPointUserGrantAvgAggregateOutputType = {
  __typename?: 'LoyaltyPointUserGrantAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
};

export type LoyaltyPointUserGrantAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type LoyaltyPointUserGrantCountAggregateOutputType = {
  __typename?: 'LoyaltyPointUserGrantCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  createdAt: Scalars['Int'];
  grantingUserId: Scalars['Int'];
  id: Scalars['Int'];
  internalNotes: Scalars['Int'];
  publicNotes: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LoyaltyPointUserGrantCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  publicNotes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointUserGrantCountOutputType = {
  __typename?: 'LoyaltyPointUserGrantCountOutputType';
  loyaltyPointDeltas: Scalars['Int'];
};

export type LoyaltyPointUserGrantCreateInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingUser: UserCreateNestedOneWithoutLoyaltyPointUserGrantsInput;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutUserGrantInput>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantCreateManyGrantingUserInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantCreateManyGrantingUserInputEnvelope = {
  data: Array<LoyaltyPointUserGrantCreateManyGrantingUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyPointUserGrantCreateManyInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingUserId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput = {
  connect?: Maybe<Array<LoyaltyPointUserGrantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointUserGrantCreateOrConnectWithoutGrantingUserInput>>;
  create?: Maybe<Array<LoyaltyPointUserGrantCreateWithoutGrantingUserInput>>;
  createMany?: Maybe<LoyaltyPointUserGrantCreateManyGrantingUserInputEnvelope>;
};

export type LoyaltyPointUserGrantCreateNestedOneWithoutLoyaltyPointDeltasInput = {
  connect?: Maybe<LoyaltyPointUserGrantWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyPointUserGrantCreateOrConnectWithoutLoyaltyPointDeltasInput>;
  create?: Maybe<LoyaltyPointUserGrantCreateWithoutLoyaltyPointDeltasInput>;
};

export type LoyaltyPointUserGrantCreateOrConnectWithoutGrantingUserInput = {
  create: LoyaltyPointUserGrantCreateWithoutGrantingUserInput;
  where: LoyaltyPointUserGrantWhereUniqueInput;
};

export type LoyaltyPointUserGrantCreateOrConnectWithoutLoyaltyPointDeltasInput = {
  create: LoyaltyPointUserGrantCreateWithoutLoyaltyPointDeltasInput;
  where: LoyaltyPointUserGrantWhereUniqueInput;
};

export type LoyaltyPointUserGrantCreateWithoutGrantingUserInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaCreateNestedManyWithoutUserGrantInput>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantCreateWithoutLoyaltyPointDeltasInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingUser: UserCreateNestedOneWithoutLoyaltyPointUserGrantsInput;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantGroupByOutputType = {
  __typename?: 'LoyaltyPointUserGrantGroupByOutputType';
  _avg?: Maybe<LoyaltyPointUserGrantAvgAggregateOutputType>;
  _count?: Maybe<LoyaltyPointUserGrantCountAggregateOutputType>;
  _max?: Maybe<LoyaltyPointUserGrantMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyPointUserGrantMinAggregateOutputType>;
  _sum?: Maybe<LoyaltyPointUserGrantSumAggregateOutputType>;
  amount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  grantingUserId: Scalars['String'];
  id: Scalars['String'];
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type LoyaltyPointUserGrantListRelationFilter = {
  every?: Maybe<LoyaltyPointUserGrantWhereInput>;
  none?: Maybe<LoyaltyPointUserGrantWhereInput>;
  some?: Maybe<LoyaltyPointUserGrantWhereInput>;
};

export type LoyaltyPointUserGrantMaxAggregateOutputType = {
  __typename?: 'LoyaltyPointUserGrantMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  publicNotes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointUserGrantMinAggregateOutputType = {
  __typename?: 'LoyaltyPointUserGrantMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  publicNotes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointUserGrantNullableScalarRelationFilter = {
  AND?: Maybe<Array<LoyaltyPointUserGrantWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointUserGrantWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointUserGrantWhereInput>>;
  amount?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  grantingUser?: Maybe<UserScalarRelationFilter>;
  grantingUserId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  internalNotes?: Maybe<StringNullableFilter>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  publicNotes?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyPointUserGrantOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LoyaltyPointUserGrantOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyPointUserGrantOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingUser?: Maybe<UserOrderByWithRelationInput>;
  grantingUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  publicNotes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyPointUserGrantOrderByRelevanceFieldEnum {
  GrantingUserId = 'grantingUserId',
  Id = 'id',
  InternalNotes = 'internalNotes',
  PublicNotes = 'publicNotes'
}

export type LoyaltyPointUserGrantOrderByRelevanceInput = {
  fields: Array<LoyaltyPointUserGrantOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyPointUserGrantOrderByWithAggregationInput = {
  _avg?: Maybe<LoyaltyPointUserGrantAvgOrderByAggregateInput>;
  _count?: Maybe<LoyaltyPointUserGrantCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyPointUserGrantMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyPointUserGrantMinOrderByAggregateInput>;
  _sum?: Maybe<LoyaltyPointUserGrantSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  publicNotes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointUserGrantOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyPointUserGrantOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingUser?: Maybe<UserOrderByWithRelationInput>;
  grantingUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  publicNotes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyPointUserGrantOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyPointUserGrantOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  grantingUser?: Maybe<UserOrderByWithRelationInput>;
  grantingUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaOrderByRelationAggregateInput>;
  publicNotes?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyPointUserGrantScalarFieldEnum {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  GrantingUserId = 'grantingUserId',
  Id = 'id',
  InternalNotes = 'internalNotes',
  PublicNotes = 'publicNotes',
  UpdatedAt = 'updatedAt'
}

export type LoyaltyPointUserGrantScalarWhereInput = {
  AND?: Maybe<Array<LoyaltyPointUserGrantScalarWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointUserGrantScalarWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointUserGrantScalarWhereInput>>;
  amount?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  grantingUserId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  internalNotes?: Maybe<StringNullableFilter>;
  publicNotes?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyPointUserGrantScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyPointUserGrantScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyPointUserGrantScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyPointUserGrantScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  grantingUserId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  internalNotes?: Maybe<StringNullableWithAggregatesFilter>;
  publicNotes?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type LoyaltyPointUserGrantSumAggregateOutputType = {
  __typename?: 'LoyaltyPointUserGrantSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
};

export type LoyaltyPointUserGrantSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type LoyaltyPointUserGrantUncheckedCreateInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingUserId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutUserGrantInput>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput = {
  connect?: Maybe<Array<LoyaltyPointUserGrantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointUserGrantCreateOrConnectWithoutGrantingUserInput>>;
  create?: Maybe<Array<LoyaltyPointUserGrantCreateWithoutGrantingUserInput>>;
  createMany?: Maybe<LoyaltyPointUserGrantCreateManyGrantingUserInputEnvelope>;
};

export type LoyaltyPointUserGrantUncheckedCreateWithoutGrantingUserInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedCreateNestedManyWithoutUserGrantInput>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantUncheckedCreateWithoutLoyaltyPointDeltasInput = {
  amount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingUserId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutUserGrantNestedInput>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput = {
  connect?: Maybe<Array<LoyaltyPointUserGrantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointUserGrantCreateOrConnectWithoutGrantingUserInput>>;
  create?: Maybe<Array<LoyaltyPointUserGrantCreateWithoutGrantingUserInput>>;
  createMany?: Maybe<LoyaltyPointUserGrantCreateManyGrantingUserInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointUserGrantWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointUserGrantScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointUserGrantWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointUserGrantWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointUserGrantUpdateWithWhereUniqueWithoutGrantingUserInput>>;
  updateMany?: Maybe<Array<LoyaltyPointUserGrantUpdateManyWithWhereWithoutGrantingUserInput>>;
  upsert?: Maybe<Array<LoyaltyPointUserGrantUpsertWithWhereUniqueWithoutGrantingUserInput>>;
};

export type LoyaltyPointUserGrantUncheckedUpdateWithoutGrantingUserInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUncheckedUpdateManyWithoutUserGrantNestedInput>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantUncheckedUpdateWithoutLoyaltyPointDeltasInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingUser?: Maybe<UserUpdateOneRequiredWithoutLoyaltyPointUserGrantsNestedInput>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutUserGrantNestedInput>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantUpdateManyWithWhereWithoutGrantingUserInput = {
  data: LoyaltyPointUserGrantUpdateManyMutationInput;
  where: LoyaltyPointUserGrantScalarWhereInput;
};

export type LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput = {
  connect?: Maybe<Array<LoyaltyPointUserGrantWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyPointUserGrantCreateOrConnectWithoutGrantingUserInput>>;
  create?: Maybe<Array<LoyaltyPointUserGrantCreateWithoutGrantingUserInput>>;
  createMany?: Maybe<LoyaltyPointUserGrantCreateManyGrantingUserInputEnvelope>;
  delete?: Maybe<Array<LoyaltyPointUserGrantWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyPointUserGrantScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyPointUserGrantWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyPointUserGrantWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyPointUserGrantUpdateWithWhereUniqueWithoutGrantingUserInput>>;
  updateMany?: Maybe<Array<LoyaltyPointUserGrantUpdateManyWithWhereWithoutGrantingUserInput>>;
  upsert?: Maybe<Array<LoyaltyPointUserGrantUpsertWithWhereUniqueWithoutGrantingUserInput>>;
};

export type LoyaltyPointUserGrantUpdateOneWithoutLoyaltyPointDeltasNestedInput = {
  connect?: Maybe<LoyaltyPointUserGrantWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyPointUserGrantCreateOrConnectWithoutLoyaltyPointDeltasInput>;
  create?: Maybe<LoyaltyPointUserGrantCreateWithoutLoyaltyPointDeltasInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LoyaltyPointUserGrantUpdateToOneWithWhereWithoutLoyaltyPointDeltasInput>;
  upsert?: Maybe<LoyaltyPointUserGrantUpsertWithoutLoyaltyPointDeltasInput>;
};

export type LoyaltyPointUserGrantUpdateToOneWithWhereWithoutLoyaltyPointDeltasInput = {
  data: LoyaltyPointUserGrantUpdateWithoutLoyaltyPointDeltasInput;
  where?: Maybe<LoyaltyPointUserGrantWhereInput>;
};

export type LoyaltyPointUserGrantUpdateWithWhereUniqueWithoutGrantingUserInput = {
  data: LoyaltyPointUserGrantUpdateWithoutGrantingUserInput;
  where: LoyaltyPointUserGrantWhereUniqueInput;
};

export type LoyaltyPointUserGrantUpdateWithoutGrantingUserInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaUpdateManyWithoutUserGrantNestedInput>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantUpdateWithoutLoyaltyPointDeltasInput = {
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  grantingUser?: Maybe<UserUpdateOneRequiredWithoutLoyaltyPointUserGrantsNestedInput>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyPointUserGrantUpsertWithWhereUniqueWithoutGrantingUserInput = {
  create: LoyaltyPointUserGrantCreateWithoutGrantingUserInput;
  update: LoyaltyPointUserGrantUpdateWithoutGrantingUserInput;
  where: LoyaltyPointUserGrantWhereUniqueInput;
};

export type LoyaltyPointUserGrantUpsertWithoutLoyaltyPointDeltasInput = {
  create: LoyaltyPointUserGrantCreateWithoutLoyaltyPointDeltasInput;
  update: LoyaltyPointUserGrantUpdateWithoutLoyaltyPointDeltasInput;
  where?: Maybe<LoyaltyPointUserGrantWhereInput>;
};

export type LoyaltyPointUserGrantWhereInput = {
  AND?: Maybe<Array<LoyaltyPointUserGrantWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointUserGrantWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointUserGrantWhereInput>>;
  amount?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  grantingUser?: Maybe<UserScalarRelationFilter>;
  grantingUserId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  internalNotes?: Maybe<StringNullableFilter>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  publicNotes?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyPointUserGrantWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyPointUserGrantWhereInput>>;
  NOT?: Maybe<Array<LoyaltyPointUserGrantWhereInput>>;
  OR?: Maybe<Array<LoyaltyPointUserGrantWhereInput>>;
  amount?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  grantingUser?: Maybe<UserScalarRelationFilter>;
  grantingUserId?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<StringNullableFilter>;
  loyaltyPointDeltas?: Maybe<LoyaltyPointDeltaListRelationFilter>;
  publicNotes?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyProgram = {
  __typename?: 'LoyaltyProgram';
  _count: LoyaltyProgramCountOutputType;
  accounts: Array<LoyaltyAccount>;
  allowOpenInvoices: Scalars['Boolean'];
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  loyaltyAccountHolders: Array<LoyaltyAccountHolder>;
  minimumTransactionCents: Scalars['Int'];
  participatingClinics: Array<Clinic>;
  pointGranters: Array<LoyaltyInvoicePointGranter>;
  rewards: Array<LoyaltyReward>;
  status: LoyaltyProgramStatus;
  statusHistories: Array<LoyaltyProgramStatusHistory>;
  updatedAt: Scalars['DateTime'];
};


export type LoyaltyProgramAccountsArgs = {
  cursor?: Maybe<LoyaltyAccountWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountWhereInput>;
};


export type LoyaltyProgramLoyaltyAccountHoldersArgs = {
  cursor?: Maybe<LoyaltyAccountHolderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountHolderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountHolderOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};


export type LoyaltyProgramParticipatingClinicsArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type LoyaltyProgramPointGrantersArgs = {
  cursor?: Maybe<LoyaltyInvoicePointGranterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyInvoicePointGranterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};


export type LoyaltyProgramRewardsArgs = {
  cursor?: Maybe<LoyaltyRewardWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardWhereInput>;
};


export type LoyaltyProgramStatusHistoriesArgs = {
  cursor?: Maybe<LoyaltyProgramStatusHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyProgramStatusHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyProgramStatusHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyProgramStatusHistoryWhereInput>;
};

export type LoyaltyProgramAvgAggregateOutputType = {
  __typename?: 'LoyaltyProgramAvgAggregateOutputType';
  centsPerPoint?: Maybe<Scalars['Float']>;
  minimumTransactionCents?: Maybe<Scalars['Float']>;
};

export type LoyaltyProgramAvgOrderByAggregateInput = {
  centsPerPoint?: Maybe<SortOrder>;
  minimumTransactionCents?: Maybe<SortOrder>;
};

export type LoyaltyProgramCountAggregateOutputType = {
  __typename?: 'LoyaltyProgramCountAggregateOutputType';
  _all: Scalars['Int'];
  allowOpenInvoices: Scalars['Int'];
  allowSpendCarryOver: Scalars['Int'];
  centsPerPoint: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  minimumTransactionCents: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LoyaltyProgramCountOrderByAggregateInput = {
  allowOpenInvoices?: Maybe<SortOrder>;
  allowSpendCarryOver?: Maybe<SortOrder>;
  centsPerPoint?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  minimumTransactionCents?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyProgramCountOutputType = {
  __typename?: 'LoyaltyProgramCountOutputType';
  accounts: Scalars['Int'];
  loyaltyAccountHolders: Scalars['Int'];
  participatingClinics: Scalars['Int'];
  pointGranters: Scalars['Int'];
  rewards: Scalars['Int'];
  statusHistories: Scalars['Int'];
};

export type LoyaltyProgramCreateInput = {
  accounts?: Maybe<LoyaltyAccountCreateNestedManyWithoutProgramInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderCreateNestedManyWithoutProgramInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutLoyaltyProgramInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterCreateNestedManyWithoutProgramInput>;
  rewards?: Maybe<LoyaltyRewardCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryCreateNestedManyWithoutProgramInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramCreateManyInput = {
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  status: LoyaltyProgramStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramCreateNestedOneWithoutAccountsInput = {
  connect?: Maybe<LoyaltyProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyProgramCreateOrConnectWithoutAccountsInput>;
  create?: Maybe<LoyaltyProgramCreateWithoutAccountsInput>;
};

export type LoyaltyProgramCreateNestedOneWithoutLoyaltyAccountHoldersInput = {
  connect?: Maybe<LoyaltyProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyProgramCreateOrConnectWithoutLoyaltyAccountHoldersInput>;
  create?: Maybe<LoyaltyProgramCreateWithoutLoyaltyAccountHoldersInput>;
};

export type LoyaltyProgramCreateNestedOneWithoutParticipatingClinicsInput = {
  connect?: Maybe<LoyaltyProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyProgramCreateOrConnectWithoutParticipatingClinicsInput>;
  create?: Maybe<LoyaltyProgramCreateWithoutParticipatingClinicsInput>;
};

export type LoyaltyProgramCreateNestedOneWithoutPointGrantersInput = {
  connect?: Maybe<LoyaltyProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyProgramCreateOrConnectWithoutPointGrantersInput>;
  create?: Maybe<LoyaltyProgramCreateWithoutPointGrantersInput>;
};

export type LoyaltyProgramCreateNestedOneWithoutRewardsInput = {
  connect?: Maybe<LoyaltyProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyProgramCreateOrConnectWithoutRewardsInput>;
  create?: Maybe<LoyaltyProgramCreateWithoutRewardsInput>;
};

export type LoyaltyProgramCreateNestedOneWithoutStatusHistoriesInput = {
  connect?: Maybe<LoyaltyProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyProgramCreateOrConnectWithoutStatusHistoriesInput>;
  create?: Maybe<LoyaltyProgramCreateWithoutStatusHistoriesInput>;
};

export type LoyaltyProgramCreateOrConnectWithoutAccountsInput = {
  create: LoyaltyProgramCreateWithoutAccountsInput;
  where: LoyaltyProgramWhereUniqueInput;
};

export type LoyaltyProgramCreateOrConnectWithoutLoyaltyAccountHoldersInput = {
  create: LoyaltyProgramCreateWithoutLoyaltyAccountHoldersInput;
  where: LoyaltyProgramWhereUniqueInput;
};

export type LoyaltyProgramCreateOrConnectWithoutParticipatingClinicsInput = {
  create: LoyaltyProgramCreateWithoutParticipatingClinicsInput;
  where: LoyaltyProgramWhereUniqueInput;
};

export type LoyaltyProgramCreateOrConnectWithoutPointGrantersInput = {
  create: LoyaltyProgramCreateWithoutPointGrantersInput;
  where: LoyaltyProgramWhereUniqueInput;
};

export type LoyaltyProgramCreateOrConnectWithoutRewardsInput = {
  create: LoyaltyProgramCreateWithoutRewardsInput;
  where: LoyaltyProgramWhereUniqueInput;
};

export type LoyaltyProgramCreateOrConnectWithoutStatusHistoriesInput = {
  create: LoyaltyProgramCreateWithoutStatusHistoriesInput;
  where: LoyaltyProgramWhereUniqueInput;
};

export type LoyaltyProgramCreateWithoutAccountsInput = {
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderCreateNestedManyWithoutProgramInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutLoyaltyProgramInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterCreateNestedManyWithoutProgramInput>;
  rewards?: Maybe<LoyaltyRewardCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryCreateNestedManyWithoutProgramInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramCreateWithoutLoyaltyAccountHoldersInput = {
  accounts?: Maybe<LoyaltyAccountCreateNestedManyWithoutProgramInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutLoyaltyProgramInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterCreateNestedManyWithoutProgramInput>;
  rewards?: Maybe<LoyaltyRewardCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryCreateNestedManyWithoutProgramInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramCreateWithoutParticipatingClinicsInput = {
  accounts?: Maybe<LoyaltyAccountCreateNestedManyWithoutProgramInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderCreateNestedManyWithoutProgramInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterCreateNestedManyWithoutProgramInput>;
  rewards?: Maybe<LoyaltyRewardCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryCreateNestedManyWithoutProgramInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramCreateWithoutPointGrantersInput = {
  accounts?: Maybe<LoyaltyAccountCreateNestedManyWithoutProgramInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderCreateNestedManyWithoutProgramInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutLoyaltyProgramInput>;
  rewards?: Maybe<LoyaltyRewardCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryCreateNestedManyWithoutProgramInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramCreateWithoutRewardsInput = {
  accounts?: Maybe<LoyaltyAccountCreateNestedManyWithoutProgramInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderCreateNestedManyWithoutProgramInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutLoyaltyProgramInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryCreateNestedManyWithoutProgramInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramCreateWithoutStatusHistoriesInput = {
  accounts?: Maybe<LoyaltyAccountCreateNestedManyWithoutProgramInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderCreateNestedManyWithoutProgramInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicCreateNestedManyWithoutLoyaltyProgramInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterCreateNestedManyWithoutProgramInput>;
  rewards?: Maybe<LoyaltyRewardCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramGroupByOutputType = {
  __typename?: 'LoyaltyProgramGroupByOutputType';
  _avg?: Maybe<LoyaltyProgramAvgAggregateOutputType>;
  _count?: Maybe<LoyaltyProgramCountAggregateOutputType>;
  _max?: Maybe<LoyaltyProgramMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyProgramMinAggregateOutputType>;
  _sum?: Maybe<LoyaltyProgramSumAggregateOutputType>;
  allowOpenInvoices: Scalars['Boolean'];
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  minimumTransactionCents: Scalars['Int'];
  status: LoyaltyProgramStatus;
  updatedAt: Scalars['DateTime'];
};

export type LoyaltyProgramMaxAggregateOutputType = {
  __typename?: 'LoyaltyProgramMaxAggregateOutputType';
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  status?: Maybe<LoyaltyProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramMaxOrderByAggregateInput = {
  allowOpenInvoices?: Maybe<SortOrder>;
  allowSpendCarryOver?: Maybe<SortOrder>;
  centsPerPoint?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  minimumTransactionCents?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyProgramMinAggregateOutputType = {
  __typename?: 'LoyaltyProgramMinAggregateOutputType';
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  status?: Maybe<LoyaltyProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramMinOrderByAggregateInput = {
  allowOpenInvoices?: Maybe<SortOrder>;
  allowSpendCarryOver?: Maybe<SortOrder>;
  centsPerPoint?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  minimumTransactionCents?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyProgramNullableScalarRelationFilter = {
  AND?: Maybe<Array<LoyaltyProgramWhereInput>>;
  NOT?: Maybe<Array<LoyaltyProgramWhereInput>>;
  OR?: Maybe<Array<LoyaltyProgramWhereInput>>;
  accounts?: Maybe<LoyaltyAccountListRelationFilter>;
  allowOpenInvoices?: Maybe<BoolFilter>;
  allowSpendCarryOver?: Maybe<BoolFilter>;
  centsPerPoint?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderListRelationFilter>;
  minimumTransactionCents?: Maybe<IntFilter>;
  participatingClinics?: Maybe<ClinicListRelationFilter>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterListRelationFilter>;
  rewards?: Maybe<LoyaltyRewardListRelationFilter>;
  status?: Maybe<EnumLoyaltyProgramStatusFilter>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyProgramOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyProgramOrderByRelevanceInput>;
  accounts?: Maybe<LoyaltyAccountOrderByRelationAggregateInput>;
  allowOpenInvoices?: Maybe<SortOrder>;
  allowSpendCarryOver?: Maybe<SortOrder>;
  centsPerPoint?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderOrderByRelationAggregateInput>;
  minimumTransactionCents?: Maybe<SortOrder>;
  participatingClinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterOrderByRelationAggregateInput>;
  rewards?: Maybe<LoyaltyRewardOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyProgramOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type LoyaltyProgramOrderByRelevanceInput = {
  fields: Array<LoyaltyProgramOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyProgramOrderByWithAggregationInput = {
  _avg?: Maybe<LoyaltyProgramAvgOrderByAggregateInput>;
  _count?: Maybe<LoyaltyProgramCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyProgramMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyProgramMinOrderByAggregateInput>;
  _sum?: Maybe<LoyaltyProgramSumOrderByAggregateInput>;
  allowOpenInvoices?: Maybe<SortOrder>;
  allowSpendCarryOver?: Maybe<SortOrder>;
  centsPerPoint?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  minimumTransactionCents?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyProgramOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyProgramOrderByRelevanceInput>;
  accounts?: Maybe<LoyaltyAccountOrderByRelationAggregateInput>;
  allowOpenInvoices?: Maybe<SortOrder>;
  allowSpendCarryOver?: Maybe<SortOrder>;
  centsPerPoint?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderOrderByRelationAggregateInput>;
  minimumTransactionCents?: Maybe<SortOrder>;
  participatingClinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterOrderByRelationAggregateInput>;
  rewards?: Maybe<LoyaltyRewardOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyProgramOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyProgramOrderByRelevanceInput>;
  accounts?: Maybe<LoyaltyAccountOrderByRelationAggregateInput>;
  allowOpenInvoices?: Maybe<SortOrder>;
  allowSpendCarryOver?: Maybe<SortOrder>;
  centsPerPoint?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderOrderByRelationAggregateInput>;
  minimumTransactionCents?: Maybe<SortOrder>;
  participatingClinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterOrderByRelationAggregateInput>;
  rewards?: Maybe<LoyaltyRewardOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyProgramScalarFieldEnum {
  AllowOpenInvoices = 'allowOpenInvoices',
  AllowSpendCarryOver = 'allowSpendCarryOver',
  CentsPerPoint = 'centsPerPoint',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  MinimumTransactionCents = 'minimumTransactionCents',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type LoyaltyProgramScalarRelationFilter = {
  AND?: Maybe<Array<LoyaltyProgramWhereInput>>;
  NOT?: Maybe<Array<LoyaltyProgramWhereInput>>;
  OR?: Maybe<Array<LoyaltyProgramWhereInput>>;
  accounts?: Maybe<LoyaltyAccountListRelationFilter>;
  allowOpenInvoices?: Maybe<BoolFilter>;
  allowSpendCarryOver?: Maybe<BoolFilter>;
  centsPerPoint?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderListRelationFilter>;
  minimumTransactionCents?: Maybe<IntFilter>;
  participatingClinics?: Maybe<ClinicListRelationFilter>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterListRelationFilter>;
  rewards?: Maybe<LoyaltyRewardListRelationFilter>;
  status?: Maybe<EnumLoyaltyProgramStatusFilter>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyProgramScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyProgramScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyProgramScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyProgramScalarWhereWithAggregatesInput>>;
  allowOpenInvoices?: Maybe<BoolWithAggregatesFilter>;
  allowSpendCarryOver?: Maybe<BoolWithAggregatesFilter>;
  centsPerPoint?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  minimumTransactionCents?: Maybe<IntWithAggregatesFilter>;
  status?: Maybe<EnumLoyaltyProgramStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum LoyaltyProgramStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Live = 'Live',
  Test = 'Test'
}

export type LoyaltyProgramStatusHistory = {
  __typename?: 'LoyaltyProgramStatusHistory';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  program: LoyaltyProgram;
  programId: Scalars['String'];
  status: LoyaltyProgramStatus;
};

export type LoyaltyProgramStatusHistoryCountAggregateOutputType = {
  __typename?: 'LoyaltyProgramStatusHistoryCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  programId: Scalars['Int'];
  status: Scalars['Int'];
};

export type LoyaltyProgramStatusHistoryCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyProgramStatusHistoryCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  program: LoyaltyProgramCreateNestedOneWithoutStatusHistoriesInput;
  status: LoyaltyProgramStatus;
};

export type LoyaltyProgramStatusHistoryCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  status: LoyaltyProgramStatus;
};

export type LoyaltyProgramStatusHistoryCreateManyProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status: LoyaltyProgramStatus;
};

export type LoyaltyProgramStatusHistoryCreateManyProgramInputEnvelope = {
  data: Array<LoyaltyProgramStatusHistoryCreateManyProgramInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyProgramStatusHistoryCreateNestedManyWithoutProgramInput = {
  connect?: Maybe<Array<LoyaltyProgramStatusHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyProgramStatusHistoryCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyProgramStatusHistoryCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyProgramStatusHistoryCreateManyProgramInputEnvelope>;
};

export type LoyaltyProgramStatusHistoryCreateOrConnectWithoutProgramInput = {
  create: LoyaltyProgramStatusHistoryCreateWithoutProgramInput;
  where: LoyaltyProgramStatusHistoryWhereUniqueInput;
};

export type LoyaltyProgramStatusHistoryCreateWithoutProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status: LoyaltyProgramStatus;
};

export type LoyaltyProgramStatusHistoryGroupByOutputType = {
  __typename?: 'LoyaltyProgramStatusHistoryGroupByOutputType';
  _count?: Maybe<LoyaltyProgramStatusHistoryCountAggregateOutputType>;
  _max?: Maybe<LoyaltyProgramStatusHistoryMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyProgramStatusHistoryMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  programId: Scalars['String'];
  status: LoyaltyProgramStatus;
};

export type LoyaltyProgramStatusHistoryListRelationFilter = {
  every?: Maybe<LoyaltyProgramStatusHistoryWhereInput>;
  none?: Maybe<LoyaltyProgramStatusHistoryWhereInput>;
  some?: Maybe<LoyaltyProgramStatusHistoryWhereInput>;
};

export type LoyaltyProgramStatusHistoryMaxAggregateOutputType = {
  __typename?: 'LoyaltyProgramStatusHistoryMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyProgramStatus>;
};

export type LoyaltyProgramStatusHistoryMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyProgramStatusHistoryMinAggregateOutputType = {
  __typename?: 'LoyaltyProgramStatusHistoryMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyProgramStatus>;
};

export type LoyaltyProgramStatusHistoryMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyProgramStatusHistoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LoyaltyProgramStatusHistoryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyProgramStatusHistoryOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export enum LoyaltyProgramStatusHistoryOrderByRelevanceFieldEnum {
  Id = 'id',
  ProgramId = 'programId'
}

export type LoyaltyProgramStatusHistoryOrderByRelevanceInput = {
  fields: Array<LoyaltyProgramStatusHistoryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyProgramStatusHistoryOrderByWithAggregationInput = {
  _count?: Maybe<LoyaltyProgramStatusHistoryCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyProgramStatusHistoryMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyProgramStatusHistoryMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyProgramStatusHistoryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyProgramStatusHistoryOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyProgramStatusHistoryOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyProgramStatusHistoryOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export enum LoyaltyProgramStatusHistoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ProgramId = 'programId',
  Status = 'status'
}

export type LoyaltyProgramStatusHistoryScalarWhereInput = {
  AND?: Maybe<Array<LoyaltyProgramStatusHistoryScalarWhereInput>>;
  NOT?: Maybe<Array<LoyaltyProgramStatusHistoryScalarWhereInput>>;
  OR?: Maybe<Array<LoyaltyProgramStatusHistoryScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  programId?: Maybe<StringFilter>;
  status?: Maybe<EnumLoyaltyProgramStatusFilter>;
};

export type LoyaltyProgramStatusHistoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyProgramStatusHistoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyProgramStatusHistoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyProgramStatusHistoryScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  programId?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumLoyaltyProgramStatusWithAggregatesFilter>;
};

export type LoyaltyProgramStatusHistoryUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId: Scalars['String'];
  status: LoyaltyProgramStatus;
};

export type LoyaltyProgramStatusHistoryUncheckedCreateNestedManyWithoutProgramInput = {
  connect?: Maybe<Array<LoyaltyProgramStatusHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyProgramStatusHistoryCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyProgramStatusHistoryCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyProgramStatusHistoryCreateManyProgramInputEnvelope>;
};

export type LoyaltyProgramStatusHistoryUncheckedCreateWithoutProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status: LoyaltyProgramStatus;
};

export type LoyaltyProgramStatusHistoryUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyProgramStatus>;
};

export type LoyaltyProgramStatusHistoryUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyProgramStatus>;
};

export type LoyaltyProgramStatusHistoryUncheckedUpdateManyWithoutProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyProgramStatus>;
};

export type LoyaltyProgramStatusHistoryUncheckedUpdateManyWithoutProgramNestedInput = {
  connect?: Maybe<Array<LoyaltyProgramStatusHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyProgramStatusHistoryCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyProgramStatusHistoryCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyProgramStatusHistoryCreateManyProgramInputEnvelope>;
  delete?: Maybe<Array<LoyaltyProgramStatusHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyProgramStatusHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyProgramStatusHistoryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyProgramStatusHistoryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyProgramStatusHistoryUpdateWithWhereUniqueWithoutProgramInput>>;
  updateMany?: Maybe<Array<LoyaltyProgramStatusHistoryUpdateManyWithWhereWithoutProgramInput>>;
  upsert?: Maybe<Array<LoyaltyProgramStatusHistoryUpsertWithWhereUniqueWithoutProgramInput>>;
};

export type LoyaltyProgramStatusHistoryUncheckedUpdateWithoutProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyProgramStatus>;
};

export type LoyaltyProgramStatusHistoryUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutStatusHistoriesNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
};

export type LoyaltyProgramStatusHistoryUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyProgramStatus>;
};

export type LoyaltyProgramStatusHistoryUpdateManyWithWhereWithoutProgramInput = {
  data: LoyaltyProgramStatusHistoryUpdateManyMutationInput;
  where: LoyaltyProgramStatusHistoryScalarWhereInput;
};

export type LoyaltyProgramStatusHistoryUpdateManyWithoutProgramNestedInput = {
  connect?: Maybe<Array<LoyaltyProgramStatusHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyProgramStatusHistoryCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyProgramStatusHistoryCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyProgramStatusHistoryCreateManyProgramInputEnvelope>;
  delete?: Maybe<Array<LoyaltyProgramStatusHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyProgramStatusHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyProgramStatusHistoryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyProgramStatusHistoryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyProgramStatusHistoryUpdateWithWhereUniqueWithoutProgramInput>>;
  updateMany?: Maybe<Array<LoyaltyProgramStatusHistoryUpdateManyWithWhereWithoutProgramInput>>;
  upsert?: Maybe<Array<LoyaltyProgramStatusHistoryUpsertWithWhereUniqueWithoutProgramInput>>;
};

export type LoyaltyProgramStatusHistoryUpdateWithWhereUniqueWithoutProgramInput = {
  data: LoyaltyProgramStatusHistoryUpdateWithoutProgramInput;
  where: LoyaltyProgramStatusHistoryWhereUniqueInput;
};

export type LoyaltyProgramStatusHistoryUpdateWithoutProgramInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyProgramStatus>;
};

export type LoyaltyProgramStatusHistoryUpsertWithWhereUniqueWithoutProgramInput = {
  create: LoyaltyProgramStatusHistoryCreateWithoutProgramInput;
  update: LoyaltyProgramStatusHistoryUpdateWithoutProgramInput;
  where: LoyaltyProgramStatusHistoryWhereUniqueInput;
};

export type LoyaltyProgramStatusHistoryWhereInput = {
  AND?: Maybe<Array<LoyaltyProgramStatusHistoryWhereInput>>;
  NOT?: Maybe<Array<LoyaltyProgramStatusHistoryWhereInput>>;
  OR?: Maybe<Array<LoyaltyProgramStatusHistoryWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  status?: Maybe<EnumLoyaltyProgramStatusFilter>;
};

export type LoyaltyProgramStatusHistoryWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyProgramStatusHistoryWhereInput>>;
  NOT?: Maybe<Array<LoyaltyProgramStatusHistoryWhereInput>>;
  OR?: Maybe<Array<LoyaltyProgramStatusHistoryWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  status?: Maybe<EnumLoyaltyProgramStatusFilter>;
};

export type LoyaltyProgramSubscription = {
  __typename?: 'LoyaltyProgramSubscription';
  mutation: MutationType;
  node: LoyaltyProgram;
};

export type LoyaltyProgramSumAggregateOutputType = {
  __typename?: 'LoyaltyProgramSumAggregateOutputType';
  centsPerPoint?: Maybe<Scalars['Int']>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
};

export type LoyaltyProgramSumOrderByAggregateInput = {
  centsPerPoint?: Maybe<SortOrder>;
  minimumTransactionCents?: Maybe<SortOrder>;
};

export type LoyaltyProgramUncheckedCreateInput = {
  accounts?: Maybe<LoyaltyAccountUncheckedCreateNestedManyWithoutProgramInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedManyWithoutProgramInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutLoyaltyProgramInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUncheckedCreateNestedManyWithoutProgramInput>;
  rewards?: Maybe<LoyaltyRewardUncheckedCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUncheckedCreateNestedManyWithoutProgramInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedCreateWithoutAccountsInput = {
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedManyWithoutProgramInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutLoyaltyProgramInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUncheckedCreateNestedManyWithoutProgramInput>;
  rewards?: Maybe<LoyaltyRewardUncheckedCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUncheckedCreateNestedManyWithoutProgramInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedCreateWithoutLoyaltyAccountHoldersInput = {
  accounts?: Maybe<LoyaltyAccountUncheckedCreateNestedManyWithoutProgramInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutLoyaltyProgramInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUncheckedCreateNestedManyWithoutProgramInput>;
  rewards?: Maybe<LoyaltyRewardUncheckedCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUncheckedCreateNestedManyWithoutProgramInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedCreateWithoutParticipatingClinicsInput = {
  accounts?: Maybe<LoyaltyAccountUncheckedCreateNestedManyWithoutProgramInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedManyWithoutProgramInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUncheckedCreateNestedManyWithoutProgramInput>;
  rewards?: Maybe<LoyaltyRewardUncheckedCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUncheckedCreateNestedManyWithoutProgramInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedCreateWithoutPointGrantersInput = {
  accounts?: Maybe<LoyaltyAccountUncheckedCreateNestedManyWithoutProgramInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedManyWithoutProgramInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutLoyaltyProgramInput>;
  rewards?: Maybe<LoyaltyRewardUncheckedCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUncheckedCreateNestedManyWithoutProgramInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedCreateWithoutRewardsInput = {
  accounts?: Maybe<LoyaltyAccountUncheckedCreateNestedManyWithoutProgramInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedManyWithoutProgramInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutLoyaltyProgramInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUncheckedCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUncheckedCreateNestedManyWithoutProgramInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedCreateWithoutStatusHistoriesInput = {
  accounts?: Maybe<LoyaltyAccountUncheckedCreateNestedManyWithoutProgramInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver: Scalars['Boolean'];
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUncheckedCreateNestedManyWithoutProgramInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutLoyaltyProgramInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUncheckedCreateNestedManyWithoutProgramInput>;
  rewards?: Maybe<LoyaltyRewardUncheckedCreateNestedManyWithoutProgramInput>;
  status: LoyaltyProgramStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedUpdateInput = {
  accounts?: Maybe<LoyaltyAccountUncheckedUpdateManyWithoutProgramNestedInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUncheckedUpdateManyWithoutProgramNestedInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutLoyaltyProgramNestedInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUncheckedUpdateManyWithoutProgramNestedInput>;
  rewards?: Maybe<LoyaltyRewardUncheckedUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUncheckedUpdateManyWithoutProgramNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedUpdateManyInput = {
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  status?: Maybe<LoyaltyProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedUpdateWithoutAccountsInput = {
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUncheckedUpdateManyWithoutProgramNestedInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutLoyaltyProgramNestedInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUncheckedUpdateManyWithoutProgramNestedInput>;
  rewards?: Maybe<LoyaltyRewardUncheckedUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUncheckedUpdateManyWithoutProgramNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedUpdateWithoutLoyaltyAccountHoldersInput = {
  accounts?: Maybe<LoyaltyAccountUncheckedUpdateManyWithoutProgramNestedInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutLoyaltyProgramNestedInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUncheckedUpdateManyWithoutProgramNestedInput>;
  rewards?: Maybe<LoyaltyRewardUncheckedUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUncheckedUpdateManyWithoutProgramNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedUpdateWithoutParticipatingClinicsInput = {
  accounts?: Maybe<LoyaltyAccountUncheckedUpdateManyWithoutProgramNestedInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUncheckedUpdateManyWithoutProgramNestedInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUncheckedUpdateManyWithoutProgramNestedInput>;
  rewards?: Maybe<LoyaltyRewardUncheckedUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUncheckedUpdateManyWithoutProgramNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedUpdateWithoutPointGrantersInput = {
  accounts?: Maybe<LoyaltyAccountUncheckedUpdateManyWithoutProgramNestedInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUncheckedUpdateManyWithoutProgramNestedInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutLoyaltyProgramNestedInput>;
  rewards?: Maybe<LoyaltyRewardUncheckedUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUncheckedUpdateManyWithoutProgramNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedUpdateWithoutRewardsInput = {
  accounts?: Maybe<LoyaltyAccountUncheckedUpdateManyWithoutProgramNestedInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUncheckedUpdateManyWithoutProgramNestedInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutLoyaltyProgramNestedInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUncheckedUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUncheckedUpdateManyWithoutProgramNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUncheckedUpdateWithoutStatusHistoriesInput = {
  accounts?: Maybe<LoyaltyAccountUncheckedUpdateManyWithoutProgramNestedInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUncheckedUpdateManyWithoutProgramNestedInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUncheckedUpdateManyWithoutLoyaltyProgramNestedInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUncheckedUpdateManyWithoutProgramNestedInput>;
  rewards?: Maybe<LoyaltyRewardUncheckedUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUpdateInput = {
  accounts?: Maybe<LoyaltyAccountUpdateManyWithoutProgramNestedInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUpdateManyWithoutProgramNestedInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutLoyaltyProgramNestedInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUpdateManyWithoutProgramNestedInput>;
  rewards?: Maybe<LoyaltyRewardUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUpdateManyWithoutProgramNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUpdateManyMutationInput = {
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  status?: Maybe<LoyaltyProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUpdateOneRequiredWithoutAccountsNestedInput = {
  connect?: Maybe<LoyaltyProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyProgramCreateOrConnectWithoutAccountsInput>;
  create?: Maybe<LoyaltyProgramCreateWithoutAccountsInput>;
  update?: Maybe<LoyaltyProgramUpdateToOneWithWhereWithoutAccountsInput>;
  upsert?: Maybe<LoyaltyProgramUpsertWithoutAccountsInput>;
};

export type LoyaltyProgramUpdateOneRequiredWithoutLoyaltyAccountHoldersNestedInput = {
  connect?: Maybe<LoyaltyProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyProgramCreateOrConnectWithoutLoyaltyAccountHoldersInput>;
  create?: Maybe<LoyaltyProgramCreateWithoutLoyaltyAccountHoldersInput>;
  update?: Maybe<LoyaltyProgramUpdateToOneWithWhereWithoutLoyaltyAccountHoldersInput>;
  upsert?: Maybe<LoyaltyProgramUpsertWithoutLoyaltyAccountHoldersInput>;
};

export type LoyaltyProgramUpdateOneRequiredWithoutPointGrantersNestedInput = {
  connect?: Maybe<LoyaltyProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyProgramCreateOrConnectWithoutPointGrantersInput>;
  create?: Maybe<LoyaltyProgramCreateWithoutPointGrantersInput>;
  update?: Maybe<LoyaltyProgramUpdateToOneWithWhereWithoutPointGrantersInput>;
  upsert?: Maybe<LoyaltyProgramUpsertWithoutPointGrantersInput>;
};

export type LoyaltyProgramUpdateOneRequiredWithoutRewardsNestedInput = {
  connect?: Maybe<LoyaltyProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyProgramCreateOrConnectWithoutRewardsInput>;
  create?: Maybe<LoyaltyProgramCreateWithoutRewardsInput>;
  update?: Maybe<LoyaltyProgramUpdateToOneWithWhereWithoutRewardsInput>;
  upsert?: Maybe<LoyaltyProgramUpsertWithoutRewardsInput>;
};

export type LoyaltyProgramUpdateOneRequiredWithoutStatusHistoriesNestedInput = {
  connect?: Maybe<LoyaltyProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyProgramCreateOrConnectWithoutStatusHistoriesInput>;
  create?: Maybe<LoyaltyProgramCreateWithoutStatusHistoriesInput>;
  update?: Maybe<LoyaltyProgramUpdateToOneWithWhereWithoutStatusHistoriesInput>;
  upsert?: Maybe<LoyaltyProgramUpsertWithoutStatusHistoriesInput>;
};

export type LoyaltyProgramUpdateOneWithoutParticipatingClinicsNestedInput = {
  connect?: Maybe<LoyaltyProgramWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyProgramCreateOrConnectWithoutParticipatingClinicsInput>;
  create?: Maybe<LoyaltyProgramCreateWithoutParticipatingClinicsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LoyaltyProgramUpdateToOneWithWhereWithoutParticipatingClinicsInput>;
  upsert?: Maybe<LoyaltyProgramUpsertWithoutParticipatingClinicsInput>;
};

export type LoyaltyProgramUpdateToOneWithWhereWithoutAccountsInput = {
  data: LoyaltyProgramUpdateWithoutAccountsInput;
  where?: Maybe<LoyaltyProgramWhereInput>;
};

export type LoyaltyProgramUpdateToOneWithWhereWithoutLoyaltyAccountHoldersInput = {
  data: LoyaltyProgramUpdateWithoutLoyaltyAccountHoldersInput;
  where?: Maybe<LoyaltyProgramWhereInput>;
};

export type LoyaltyProgramUpdateToOneWithWhereWithoutParticipatingClinicsInput = {
  data: LoyaltyProgramUpdateWithoutParticipatingClinicsInput;
  where?: Maybe<LoyaltyProgramWhereInput>;
};

export type LoyaltyProgramUpdateToOneWithWhereWithoutPointGrantersInput = {
  data: LoyaltyProgramUpdateWithoutPointGrantersInput;
  where?: Maybe<LoyaltyProgramWhereInput>;
};

export type LoyaltyProgramUpdateToOneWithWhereWithoutRewardsInput = {
  data: LoyaltyProgramUpdateWithoutRewardsInput;
  where?: Maybe<LoyaltyProgramWhereInput>;
};

export type LoyaltyProgramUpdateToOneWithWhereWithoutStatusHistoriesInput = {
  data: LoyaltyProgramUpdateWithoutStatusHistoriesInput;
  where?: Maybe<LoyaltyProgramWhereInput>;
};

export type LoyaltyProgramUpdateWithoutAccountsInput = {
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUpdateManyWithoutProgramNestedInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutLoyaltyProgramNestedInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUpdateManyWithoutProgramNestedInput>;
  rewards?: Maybe<LoyaltyRewardUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUpdateManyWithoutProgramNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUpdateWithoutLoyaltyAccountHoldersInput = {
  accounts?: Maybe<LoyaltyAccountUpdateManyWithoutProgramNestedInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutLoyaltyProgramNestedInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUpdateManyWithoutProgramNestedInput>;
  rewards?: Maybe<LoyaltyRewardUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUpdateManyWithoutProgramNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUpdateWithoutParticipatingClinicsInput = {
  accounts?: Maybe<LoyaltyAccountUpdateManyWithoutProgramNestedInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUpdateManyWithoutProgramNestedInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUpdateManyWithoutProgramNestedInput>;
  rewards?: Maybe<LoyaltyRewardUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUpdateManyWithoutProgramNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUpdateWithoutPointGrantersInput = {
  accounts?: Maybe<LoyaltyAccountUpdateManyWithoutProgramNestedInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUpdateManyWithoutProgramNestedInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutLoyaltyProgramNestedInput>;
  rewards?: Maybe<LoyaltyRewardUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUpdateManyWithoutProgramNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUpdateWithoutRewardsInput = {
  accounts?: Maybe<LoyaltyAccountUpdateManyWithoutProgramNestedInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUpdateManyWithoutProgramNestedInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutLoyaltyProgramNestedInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryUpdateManyWithoutProgramNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUpdateWithoutStatusHistoriesInput = {
  accounts?: Maybe<LoyaltyAccountUpdateManyWithoutProgramNestedInput>;
  allowOpenInvoices?: Maybe<Scalars['Boolean']>;
  allowSpendCarryOver?: Maybe<Scalars['Boolean']>;
  centsPerPoint?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderUpdateManyWithoutProgramNestedInput>;
  minimumTransactionCents?: Maybe<Scalars['Int']>;
  participatingClinics?: Maybe<ClinicUpdateManyWithoutLoyaltyProgramNestedInput>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterUpdateManyWithoutProgramNestedInput>;
  rewards?: Maybe<LoyaltyRewardUpdateManyWithoutProgramNestedInput>;
  status?: Maybe<LoyaltyProgramStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyProgramUpsertWithoutAccountsInput = {
  create: LoyaltyProgramCreateWithoutAccountsInput;
  update: LoyaltyProgramUpdateWithoutAccountsInput;
  where?: Maybe<LoyaltyProgramWhereInput>;
};

export type LoyaltyProgramUpsertWithoutLoyaltyAccountHoldersInput = {
  create: LoyaltyProgramCreateWithoutLoyaltyAccountHoldersInput;
  update: LoyaltyProgramUpdateWithoutLoyaltyAccountHoldersInput;
  where?: Maybe<LoyaltyProgramWhereInput>;
};

export type LoyaltyProgramUpsertWithoutParticipatingClinicsInput = {
  create: LoyaltyProgramCreateWithoutParticipatingClinicsInput;
  update: LoyaltyProgramUpdateWithoutParticipatingClinicsInput;
  where?: Maybe<LoyaltyProgramWhereInput>;
};

export type LoyaltyProgramUpsertWithoutPointGrantersInput = {
  create: LoyaltyProgramCreateWithoutPointGrantersInput;
  update: LoyaltyProgramUpdateWithoutPointGrantersInput;
  where?: Maybe<LoyaltyProgramWhereInput>;
};

export type LoyaltyProgramUpsertWithoutRewardsInput = {
  create: LoyaltyProgramCreateWithoutRewardsInput;
  update: LoyaltyProgramUpdateWithoutRewardsInput;
  where?: Maybe<LoyaltyProgramWhereInput>;
};

export type LoyaltyProgramUpsertWithoutStatusHistoriesInput = {
  create: LoyaltyProgramCreateWithoutStatusHistoriesInput;
  update: LoyaltyProgramUpdateWithoutStatusHistoriesInput;
  where?: Maybe<LoyaltyProgramWhereInput>;
};

export type LoyaltyProgramWhereInput = {
  AND?: Maybe<Array<LoyaltyProgramWhereInput>>;
  NOT?: Maybe<Array<LoyaltyProgramWhereInput>>;
  OR?: Maybe<Array<LoyaltyProgramWhereInput>>;
  accounts?: Maybe<LoyaltyAccountListRelationFilter>;
  allowOpenInvoices?: Maybe<BoolFilter>;
  allowSpendCarryOver?: Maybe<BoolFilter>;
  centsPerPoint?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderListRelationFilter>;
  minimumTransactionCents?: Maybe<IntFilter>;
  participatingClinics?: Maybe<ClinicListRelationFilter>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterListRelationFilter>;
  rewards?: Maybe<LoyaltyRewardListRelationFilter>;
  status?: Maybe<EnumLoyaltyProgramStatusFilter>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyProgramWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyProgramWhereInput>>;
  NOT?: Maybe<Array<LoyaltyProgramWhereInput>>;
  OR?: Maybe<Array<LoyaltyProgramWhereInput>>;
  accounts?: Maybe<LoyaltyAccountListRelationFilter>;
  allowOpenInvoices?: Maybe<BoolFilter>;
  allowSpendCarryOver?: Maybe<BoolFilter>;
  centsPerPoint?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  loyaltyAccountHolders?: Maybe<LoyaltyAccountHolderListRelationFilter>;
  minimumTransactionCents?: Maybe<IntFilter>;
  participatingClinics?: Maybe<ClinicListRelationFilter>;
  pointGranters?: Maybe<LoyaltyInvoicePointGranterListRelationFilter>;
  rewards?: Maybe<LoyaltyRewardListRelationFilter>;
  status?: Maybe<EnumLoyaltyProgramStatusFilter>;
  statusHistories?: Maybe<LoyaltyProgramStatusHistoryListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyReward = {
  __typename?: 'LoyaltyReward';
  _count: LoyaltyRewardCountOutputType;
  availability: LoyaltyRewardAvailability;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  /** Notes that are available only to the clinic */
  internalNotes?: Maybe<Scalars['String']>;
  pointCost: Scalars['Int'];
  program: LoyaltyProgram;
  programId: Scalars['String'];
  redemptions: Array<LoyaltyRewardRedemption>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type LoyaltyRewardRedemptionsArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardRedemptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionWhereInput>;
};

export enum LoyaltyRewardAvailability {
  Archived = 'Archived',
  Published = 'Published',
  Unpublished = 'Unpublished'
}

export type LoyaltyRewardAvgAggregateOutputType = {
  __typename?: 'LoyaltyRewardAvgAggregateOutputType';
  pointCost?: Maybe<Scalars['Float']>;
};

export type LoyaltyRewardAvgOrderByAggregateInput = {
  pointCost?: Maybe<SortOrder>;
};

export type LoyaltyRewardCountAggregateOutputType = {
  __typename?: 'LoyaltyRewardCountAggregateOutputType';
  _all: Scalars['Int'];
  availability: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  internalNotes: Scalars['Int'];
  pointCost: Scalars['Int'];
  programId: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LoyaltyRewardCountOrderByAggregateInput = {
  availability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  pointCost?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyRewardCountOutputType = {
  __typename?: 'LoyaltyRewardCountOutputType';
  redemptions: Scalars['Int'];
};

export type LoyaltyRewardCreateInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost: Scalars['Int'];
  program: LoyaltyProgramCreateNestedOneWithoutRewardsInput;
  redemptions?: Maybe<LoyaltyRewardRedemptionCreateNestedManyWithoutRewardInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardCreateManyInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost: Scalars['Int'];
  programId: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardCreateManyProgramInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost: Scalars['Int'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardCreateManyProgramInputEnvelope = {
  data: Array<LoyaltyRewardCreateManyProgramInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyRewardCreateNestedManyWithoutProgramInput = {
  connect?: Maybe<Array<LoyaltyRewardWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyRewardCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyRewardCreateManyProgramInputEnvelope>;
};

export type LoyaltyRewardCreateNestedOneWithoutRedemptionsInput = {
  connect?: Maybe<LoyaltyRewardWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyRewardCreateOrConnectWithoutRedemptionsInput>;
  create?: Maybe<LoyaltyRewardCreateWithoutRedemptionsInput>;
};

export type LoyaltyRewardCreateOrConnectWithoutProgramInput = {
  create: LoyaltyRewardCreateWithoutProgramInput;
  where: LoyaltyRewardWhereUniqueInput;
};

export type LoyaltyRewardCreateOrConnectWithoutRedemptionsInput = {
  create: LoyaltyRewardCreateWithoutRedemptionsInput;
  where: LoyaltyRewardWhereUniqueInput;
};

export type LoyaltyRewardCreateWithoutProgramInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost: Scalars['Int'];
  redemptions?: Maybe<LoyaltyRewardRedemptionCreateNestedManyWithoutRewardInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardCreateWithoutRedemptionsInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost: Scalars['Int'];
  program: LoyaltyProgramCreateNestedOneWithoutRewardsInput;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardGroupByOutputType = {
  __typename?: 'LoyaltyRewardGroupByOutputType';
  _avg?: Maybe<LoyaltyRewardAvgAggregateOutputType>;
  _count?: Maybe<LoyaltyRewardCountAggregateOutputType>;
  _max?: Maybe<LoyaltyRewardMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyRewardMinAggregateOutputType>;
  _sum?: Maybe<LoyaltyRewardSumAggregateOutputType>;
  availability: LoyaltyRewardAvailability;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  internalNotes?: Maybe<Scalars['String']>;
  pointCost: Scalars['Int'];
  programId: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LoyaltyRewardListRelationFilter = {
  every?: Maybe<LoyaltyRewardWhereInput>;
  none?: Maybe<LoyaltyRewardWhereInput>;
  some?: Maybe<LoyaltyRewardWhereInput>;
};

export type LoyaltyRewardMaxAggregateOutputType = {
  __typename?: 'LoyaltyRewardMaxAggregateOutputType';
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardMaxOrderByAggregateInput = {
  availability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  pointCost?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyRewardMinAggregateOutputType = {
  __typename?: 'LoyaltyRewardMinAggregateOutputType';
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardMinOrderByAggregateInput = {
  availability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  pointCost?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyRewardOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LoyaltyRewardOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyRewardOrderByRelevanceInput>;
  availability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  pointCost?: Maybe<SortOrder>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  redemptions?: Maybe<LoyaltyRewardRedemptionOrderByRelationAggregateInput>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyRewardOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  InternalNotes = 'internalNotes',
  ProgramId = 'programId',
  Title = 'title'
}

export type LoyaltyRewardOrderByRelevanceInput = {
  fields: Array<LoyaltyRewardOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyRewardOrderByWithAggregationInput = {
  _avg?: Maybe<LoyaltyRewardAvgOrderByAggregateInput>;
  _count?: Maybe<LoyaltyRewardCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyRewardMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyRewardMinOrderByAggregateInput>;
  _sum?: Maybe<LoyaltyRewardSumOrderByAggregateInput>;
  availability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  pointCost?: Maybe<SortOrder>;
  programId?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyRewardOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyRewardOrderByRelevanceInput>;
  availability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  pointCost?: Maybe<SortOrder>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  redemptions?: Maybe<LoyaltyRewardRedemptionOrderByRelationAggregateInput>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyRewardOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyRewardOrderByRelevanceInput>;
  availability?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNotes?: Maybe<SortOrder>;
  pointCost?: Maybe<SortOrder>;
  program?: Maybe<LoyaltyProgramOrderByWithRelationInput>;
  programId?: Maybe<SortOrder>;
  redemptions?: Maybe<LoyaltyRewardRedemptionOrderByRelationAggregateInput>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemption = {
  __typename?: 'LoyaltyRewardRedemption';
  _count: LoyaltyRewardRedemptionCountOutputType;
  account: LoyaltyAccount;
  accountId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  internalNote: Scalars['String'];
  redemptionHistories: Array<LoyaltyRewardRedemptionHistoryEntry>;
  reward: LoyaltyReward;
  rewardId: Scalars['String'];
  status: LoyaltyRewardRedemptionStatus;
  updatedAt: Scalars['DateTime'];
};


export type LoyaltyRewardRedemptionRedemptionHistoriesArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
};

export enum LoyaltyRewardRedemptionActorType {
  ClinicUser = 'ClinicUser',
  PetParent = 'PetParent',
  System = 'System'
}

export type LoyaltyRewardRedemptionCountAggregateOutputType = {
  __typename?: 'LoyaltyRewardRedemptionCountAggregateOutputType';
  _all: Scalars['Int'];
  accountId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  internalNote: Scalars['Int'];
  rewardId: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LoyaltyRewardRedemptionCountOrderByAggregateInput = {
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNote?: Maybe<SortOrder>;
  rewardId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionCountOutputType = {
  __typename?: 'LoyaltyRewardRedemptionCountOutputType';
  redemptionHistories: Scalars['Int'];
};

export type LoyaltyRewardRedemptionCreateInput = {
  account: LoyaltyAccountCreateNestedOneWithoutRewardRedemptionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote: Scalars['String'];
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRedemptionInput>;
  reward: LoyaltyRewardCreateNestedOneWithoutRedemptionsInput;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionCreateManyAccountInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote: Scalars['String'];
  rewardId: Scalars['String'];
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionCreateManyAccountInputEnvelope = {
  data: Array<LoyaltyRewardRedemptionCreateManyAccountInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyRewardRedemptionCreateManyInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote: Scalars['String'];
  rewardId: Scalars['String'];
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionCreateManyRewardInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote: Scalars['String'];
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionCreateManyRewardInputEnvelope = {
  data: Array<LoyaltyRewardRedemptionCreateManyRewardInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyRewardRedemptionCreateNestedManyWithoutAccountInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionCreateOrConnectWithoutAccountInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionCreateWithoutAccountInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionCreateManyAccountInputEnvelope>;
};

export type LoyaltyRewardRedemptionCreateNestedManyWithoutRewardInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionCreateOrConnectWithoutRewardInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionCreateWithoutRewardInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionCreateManyRewardInputEnvelope>;
};

export type LoyaltyRewardRedemptionCreateNestedOneWithoutRedemptionHistoriesInput = {
  connect?: Maybe<LoyaltyRewardRedemptionWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyRewardRedemptionCreateOrConnectWithoutRedemptionHistoriesInput>;
  create?: Maybe<LoyaltyRewardRedemptionCreateWithoutRedemptionHistoriesInput>;
};

export type LoyaltyRewardRedemptionCreateOrConnectWithoutAccountInput = {
  create: LoyaltyRewardRedemptionCreateWithoutAccountInput;
  where: LoyaltyRewardRedemptionWhereUniqueInput;
};

export type LoyaltyRewardRedemptionCreateOrConnectWithoutRedemptionHistoriesInput = {
  create: LoyaltyRewardRedemptionCreateWithoutRedemptionHistoriesInput;
  where: LoyaltyRewardRedemptionWhereUniqueInput;
};

export type LoyaltyRewardRedemptionCreateOrConnectWithoutRewardInput = {
  create: LoyaltyRewardRedemptionCreateWithoutRewardInput;
  where: LoyaltyRewardRedemptionWhereUniqueInput;
};

export type LoyaltyRewardRedemptionCreateWithoutAccountInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote: Scalars['String'];
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRedemptionInput>;
  reward: LoyaltyRewardCreateNestedOneWithoutRedemptionsInput;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionCreateWithoutRedemptionHistoriesInput = {
  account: LoyaltyAccountCreateNestedOneWithoutRewardRedemptionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote: Scalars['String'];
  reward: LoyaltyRewardCreateNestedOneWithoutRedemptionsInput;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionCreateWithoutRewardInput = {
  account: LoyaltyAccountCreateNestedOneWithoutRewardRedemptionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote: Scalars['String'];
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRedemptionInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionGroupByOutputType = {
  __typename?: 'LoyaltyRewardRedemptionGroupByOutputType';
  _count?: Maybe<LoyaltyRewardRedemptionCountAggregateOutputType>;
  _max?: Maybe<LoyaltyRewardRedemptionMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyRewardRedemptionMinAggregateOutputType>;
  accountId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  internalNote: Scalars['String'];
  rewardId: Scalars['String'];
  status: LoyaltyRewardRedemptionStatus;
  updatedAt: Scalars['DateTime'];
};

/** Used for when a Loyalty Account holder requests a Loyalty Reward */
export type LoyaltyRewardRedemptionHistoryEntry = {
  __typename?: 'LoyaltyRewardRedemptionHistoryEntry';
  actingAccountHolder?: Maybe<LoyaltyAccountHolder>;
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUser?: Maybe<User>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  pointDelta?: Maybe<LoyaltyPointDelta>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemption: LoyaltyRewardRedemption;
  redemptionId: Scalars['String'];
  relatedClinic?: Maybe<Clinic>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status: LoyaltyRewardRedemptionStatus;
};


/** Used for when a Loyalty Account holder requests a Loyalty Reward */
export type LoyaltyRewardRedemptionHistoryEntryActingAccountHolderArgs = {
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};


/** Used for when a Loyalty Account holder requests a Loyalty Reward */
export type LoyaltyRewardRedemptionHistoryEntryActingUserArgs = {
  where?: Maybe<UserWhereInput>;
};


/** Used for when a Loyalty Account holder requests a Loyalty Reward */
export type LoyaltyRewardRedemptionHistoryEntryPointDeltaArgs = {
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
};


/** Used for when a Loyalty Account holder requests a Loyalty Reward */
export type LoyaltyRewardRedemptionHistoryEntryRelatedClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};

export type LoyaltyRewardRedemptionHistoryEntryCountAggregateOutputType = {
  __typename?: 'LoyaltyRewardRedemptionHistoryEntryCountAggregateOutputType';
  _all: Scalars['Int'];
  actingAccountHolderId: Scalars['Int'];
  actingUserId: Scalars['Int'];
  actorType: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pointDeltaId: Scalars['Int'];
  redemptionId: Scalars['Int'];
  relatedClinicId: Scalars['Int'];
  status: Scalars['Int'];
};

export type LoyaltyRewardRedemptionHistoryEntryCountOrderByAggregateInput = {
  actingAccountHolderId?: Maybe<SortOrder>;
  actingUserId?: Maybe<SortOrder>;
  actorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pointDeltaId?: Maybe<SortOrder>;
  redemptionId?: Maybe<SortOrder>;
  relatedClinicId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateInput = {
  actingAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutRewardRedemptionActionsInput>;
  actingUser?: Maybe<UserCreateNestedOneWithoutLoyaltyRewardRedemptionActionsInput>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDelta?: Maybe<LoyaltyPointDeltaCreateNestedOneWithoutRelatedRedemptionHistoryEntryInput>;
  redemption: LoyaltyRewardRedemptionCreateNestedOneWithoutRedemptionHistoriesInput;
  relatedClinic?: Maybe<ClinicCreateNestedOneWithoutLoyaltyRewardRedemptionActionsInput>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateManyActingAccountHolderInput = {
  actingUserId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId: Scalars['String'];
  relatedClinicId?: Maybe<Scalars['String']>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateManyActingAccountHolderInputEnvelope = {
  data: Array<LoyaltyRewardRedemptionHistoryEntryCreateManyActingAccountHolderInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateManyActingUserInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId: Scalars['String'];
  relatedClinicId?: Maybe<Scalars['String']>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateManyActingUserInputEnvelope = {
  data: Array<LoyaltyRewardRedemptionHistoryEntryCreateManyActingUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateManyInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId: Scalars['String'];
  relatedClinicId?: Maybe<Scalars['String']>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateManyRedemptionInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateManyRedemptionInputEnvelope = {
  data: Array<LoyaltyRewardRedemptionHistoryEntryCreateManyRedemptionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateManyRelatedClinicInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId: Scalars['String'];
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateManyRelatedClinicInputEnvelope = {
  data: Array<LoyaltyRewardRedemptionHistoryEntryCreateManyRelatedClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingAccountHolderInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutActingAccountHolderInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingAccountHolderInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyActingAccountHolderInputEnvelope>;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutActingUserInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingUserInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyActingUserInputEnvelope>;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRedemptionInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutRedemptionInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutRedemptionInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyRedemptionInputEnvelope>;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutRelatedClinicInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutRelatedClinicInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutRelatedClinicInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyRelatedClinicInputEnvelope>;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateNestedOneWithoutPointDeltaInput = {
  connect?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutPointDeltaInput>;
  create?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateWithoutPointDeltaInput>;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutActingAccountHolderInput = {
  create: LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingAccountHolderInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutActingUserInput = {
  create: LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingUserInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutPointDeltaInput = {
  create: LoyaltyRewardRedemptionHistoryEntryCreateWithoutPointDeltaInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutRedemptionInput = {
  create: LoyaltyRewardRedemptionHistoryEntryCreateWithoutRedemptionInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutRelatedClinicInput = {
  create: LoyaltyRewardRedemptionHistoryEntryCreateWithoutRelatedClinicInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingAccountHolderInput = {
  actingUser?: Maybe<UserCreateNestedOneWithoutLoyaltyRewardRedemptionActionsInput>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDelta?: Maybe<LoyaltyPointDeltaCreateNestedOneWithoutRelatedRedemptionHistoryEntryInput>;
  redemption: LoyaltyRewardRedemptionCreateNestedOneWithoutRedemptionHistoriesInput;
  relatedClinic?: Maybe<ClinicCreateNestedOneWithoutLoyaltyRewardRedemptionActionsInput>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingUserInput = {
  actingAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutRewardRedemptionActionsInput>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDelta?: Maybe<LoyaltyPointDeltaCreateNestedOneWithoutRelatedRedemptionHistoryEntryInput>;
  redemption: LoyaltyRewardRedemptionCreateNestedOneWithoutRedemptionHistoriesInput;
  relatedClinic?: Maybe<ClinicCreateNestedOneWithoutLoyaltyRewardRedemptionActionsInput>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateWithoutPointDeltaInput = {
  actingAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutRewardRedemptionActionsInput>;
  actingUser?: Maybe<UserCreateNestedOneWithoutLoyaltyRewardRedemptionActionsInput>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  redemption: LoyaltyRewardRedemptionCreateNestedOneWithoutRedemptionHistoriesInput;
  relatedClinic?: Maybe<ClinicCreateNestedOneWithoutLoyaltyRewardRedemptionActionsInput>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateWithoutRedemptionInput = {
  actingAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutRewardRedemptionActionsInput>;
  actingUser?: Maybe<UserCreateNestedOneWithoutLoyaltyRewardRedemptionActionsInput>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDelta?: Maybe<LoyaltyPointDeltaCreateNestedOneWithoutRelatedRedemptionHistoryEntryInput>;
  relatedClinic?: Maybe<ClinicCreateNestedOneWithoutLoyaltyRewardRedemptionActionsInput>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryCreateWithoutRelatedClinicInput = {
  actingAccountHolder?: Maybe<LoyaltyAccountHolderCreateNestedOneWithoutRewardRedemptionActionsInput>;
  actingUser?: Maybe<UserCreateNestedOneWithoutLoyaltyRewardRedemptionActionsInput>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDelta?: Maybe<LoyaltyPointDeltaCreateNestedOneWithoutRelatedRedemptionHistoryEntryInput>;
  redemption: LoyaltyRewardRedemptionCreateNestedOneWithoutRedemptionHistoriesInput;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryGroupByOutputType = {
  __typename?: 'LoyaltyRewardRedemptionHistoryEntryGroupByOutputType';
  _count?: Maybe<LoyaltyRewardRedemptionHistoryEntryCountAggregateOutputType>;
  _max?: Maybe<LoyaltyRewardRedemptionHistoryEntryMaxAggregateOutputType>;
  _min?: Maybe<LoyaltyRewardRedemptionHistoryEntryMinAggregateOutputType>;
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId: Scalars['String'];
  relatedClinicId?: Maybe<Scalars['String']>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryListRelationFilter = {
  every?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
  none?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
  some?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
};

export type LoyaltyRewardRedemptionHistoryEntryMaxAggregateOutputType = {
  __typename?: 'LoyaltyRewardRedemptionHistoryEntryMaxAggregateOutputType';
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryMaxOrderByAggregateInput = {
  actingAccountHolderId?: Maybe<SortOrder>;
  actingUserId?: Maybe<SortOrder>;
  actorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pointDeltaId?: Maybe<SortOrder>;
  redemptionId?: Maybe<SortOrder>;
  relatedClinicId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionHistoryEntryMinAggregateOutputType = {
  __typename?: 'LoyaltyRewardRedemptionHistoryEntryMinAggregateOutputType';
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryMinOrderByAggregateInput = {
  actingAccountHolderId?: Maybe<SortOrder>;
  actingUserId?: Maybe<SortOrder>;
  actorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pointDeltaId?: Maybe<SortOrder>;
  redemptionId?: Maybe<SortOrder>;
  relatedClinicId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionHistoryEntryNullableScalarRelationFilter = {
  AND?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereInput>>;
  NOT?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereInput>>;
  OR?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereInput>>;
  actingAccountHolder?: Maybe<LoyaltyAccountHolderNullableScalarRelationFilter>;
  actingAccountHolderId?: Maybe<StringNullableFilter>;
  actingUser?: Maybe<UserNullableScalarRelationFilter>;
  actingUserId?: Maybe<StringNullableFilter>;
  actorType?: Maybe<EnumLoyaltyRewardRedemptionActorTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  pointDelta?: Maybe<LoyaltyPointDeltaNullableScalarRelationFilter>;
  pointDeltaId?: Maybe<StringNullableFilter>;
  redemption?: Maybe<LoyaltyRewardRedemptionScalarRelationFilter>;
  redemptionId?: Maybe<StringFilter>;
  relatedClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  relatedClinicId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumLoyaltyRewardRedemptionStatusFilter>;
};

export type LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionHistoryEntryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelevanceInput>;
  actingAccountHolder?: Maybe<LoyaltyAccountHolderOrderByWithRelationInput>;
  actingAccountHolderId?: Maybe<SortOrder>;
  actingUser?: Maybe<UserOrderByWithRelationInput>;
  actingUserId?: Maybe<SortOrder>;
  actorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pointDelta?: Maybe<LoyaltyPointDeltaOrderByWithRelationInput>;
  pointDeltaId?: Maybe<SortOrder>;
  redemption?: Maybe<LoyaltyRewardRedemptionOrderByWithRelationInput>;
  redemptionId?: Maybe<SortOrder>;
  relatedClinic?: Maybe<ClinicOrderByWithRelationInput>;
  relatedClinicId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export enum LoyaltyRewardRedemptionHistoryEntryOrderByRelevanceFieldEnum {
  ActingAccountHolderId = 'actingAccountHolderId',
  ActingUserId = 'actingUserId',
  Id = 'id',
  PointDeltaId = 'pointDeltaId',
  RedemptionId = 'redemptionId',
  RelatedClinicId = 'relatedClinicId'
}

export type LoyaltyRewardRedemptionHistoryEntryOrderByRelevanceInput = {
  fields: Array<LoyaltyRewardRedemptionHistoryEntryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyRewardRedemptionHistoryEntryOrderByWithAggregationInput = {
  _count?: Maybe<LoyaltyRewardRedemptionHistoryEntryCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyRewardRedemptionHistoryEntryMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyRewardRedemptionHistoryEntryMinOrderByAggregateInput>;
  actingAccountHolderId?: Maybe<SortOrder>;
  actingUserId?: Maybe<SortOrder>;
  actorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pointDeltaId?: Maybe<SortOrder>;
  redemptionId?: Maybe<SortOrder>;
  relatedClinicId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelevanceInput>;
  actingAccountHolder?: Maybe<LoyaltyAccountHolderOrderByWithRelationInput>;
  actingAccountHolderId?: Maybe<SortOrder>;
  actingUser?: Maybe<UserOrderByWithRelationInput>;
  actingUserId?: Maybe<SortOrder>;
  actorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pointDelta?: Maybe<LoyaltyPointDeltaOrderByWithRelationInput>;
  pointDeltaId?: Maybe<SortOrder>;
  redemption?: Maybe<LoyaltyRewardRedemptionOrderByWithRelationInput>;
  redemptionId?: Maybe<SortOrder>;
  relatedClinic?: Maybe<ClinicOrderByWithRelationInput>;
  relatedClinicId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelevanceInput>;
  actingAccountHolder?: Maybe<LoyaltyAccountHolderOrderByWithRelationInput>;
  actingAccountHolderId?: Maybe<SortOrder>;
  actingUser?: Maybe<UserOrderByWithRelationInput>;
  actingUserId?: Maybe<SortOrder>;
  actorType?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pointDelta?: Maybe<LoyaltyPointDeltaOrderByWithRelationInput>;
  pointDeltaId?: Maybe<SortOrder>;
  redemption?: Maybe<LoyaltyRewardRedemptionOrderByWithRelationInput>;
  redemptionId?: Maybe<SortOrder>;
  relatedClinic?: Maybe<ClinicOrderByWithRelationInput>;
  relatedClinicId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionHistoryEntryRedemptionIdStatusCompoundUniqueInput = {
  redemptionId: Scalars['String'];
  status: LoyaltyRewardRedemptionStatus;
};

export enum LoyaltyRewardRedemptionHistoryEntryScalarFieldEnum {
  ActingAccountHolderId = 'actingAccountHolderId',
  ActingUserId = 'actingUserId',
  ActorType = 'actorType',
  CreatedAt = 'createdAt',
  Id = 'id',
  PointDeltaId = 'pointDeltaId',
  RedemptionId = 'redemptionId',
  RelatedClinicId = 'relatedClinicId',
  Status = 'status'
}

export type LoyaltyRewardRedemptionHistoryEntryScalarWhereInput = {
  AND?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereInput>>;
  NOT?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereInput>>;
  OR?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereInput>>;
  actingAccountHolderId?: Maybe<StringNullableFilter>;
  actingUserId?: Maybe<StringNullableFilter>;
  actorType?: Maybe<EnumLoyaltyRewardRedemptionActorTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  pointDeltaId?: Maybe<StringNullableFilter>;
  redemptionId?: Maybe<StringFilter>;
  relatedClinicId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumLoyaltyRewardRedemptionStatusFilter>;
};

export type LoyaltyRewardRedemptionHistoryEntryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereWithAggregatesInput>>;
  actingAccountHolderId?: Maybe<StringNullableWithAggregatesFilter>;
  actingUserId?: Maybe<StringNullableWithAggregatesFilter>;
  actorType?: Maybe<EnumLoyaltyRewardRedemptionActorTypeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  pointDeltaId?: Maybe<StringNullableWithAggregatesFilter>;
  redemptionId?: Maybe<StringWithAggregatesFilter>;
  relatedClinicId?: Maybe<StringNullableWithAggregatesFilter>;
  status?: Maybe<EnumLoyaltyRewardRedemptionStatusWithAggregatesFilter>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedCreateInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId: Scalars['String'];
  relatedClinicId?: Maybe<Scalars['String']>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingAccountHolderInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutActingAccountHolderInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingAccountHolderInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyActingAccountHolderInputEnvelope>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutActingUserInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingUserInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyActingUserInputEnvelope>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRedemptionInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutRedemptionInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutRedemptionInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyRedemptionInputEnvelope>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRelatedClinicInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutRelatedClinicInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutRelatedClinicInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyRelatedClinicInputEnvelope>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedOneWithoutPointDeltaInput = {
  connect?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutPointDeltaInput>;
  create?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateWithoutPointDeltaInput>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedCreateWithoutActingAccountHolderInput = {
  actingUserId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId: Scalars['String'];
  relatedClinicId?: Maybe<Scalars['String']>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedCreateWithoutActingUserInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId: Scalars['String'];
  relatedClinicId?: Maybe<Scalars['String']>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedCreateWithoutPointDeltaInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  redemptionId: Scalars['String'];
  relatedClinicId?: Maybe<Scalars['String']>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedCreateWithoutRedemptionInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedCreateWithoutRelatedClinicInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType: LoyaltyRewardRedemptionActorType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId: Scalars['String'];
  status: LoyaltyRewardRedemptionStatus;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingAccountHolderInput = {
  actingUserId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingAccountHolderNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutActingAccountHolderInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingAccountHolderInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyActingAccountHolderInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateWithWhereUniqueWithoutActingAccountHolderInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithWhereWithoutActingAccountHolderInput>>;
  upsert?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpsertWithWhereUniqueWithoutActingAccountHolderInput>>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutActingUserInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingUserInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyActingUserInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateWithWhereUniqueWithoutActingUserInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithWhereWithoutActingUserInput>>;
  upsert?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpsertWithWhereUniqueWithoutActingUserInput>>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRedemptionInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRedemptionNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutRedemptionInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutRedemptionInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyRedemptionInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateWithWhereUniqueWithoutRedemptionInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithWhereWithoutRedemptionInput>>;
  upsert?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpsertWithWhereUniqueWithoutRedemptionInput>>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRelatedClinicNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutRelatedClinicInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutRelatedClinicInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyRelatedClinicInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateWithWhereUniqueWithoutRelatedClinicInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithWhereWithoutRelatedClinicInput>>;
  upsert?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpsertWithWhereUniqueWithoutRelatedClinicInput>>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateOneWithoutPointDeltaNestedInput = {
  connect?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutPointDeltaInput>;
  create?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateWithoutPointDeltaInput>;
  delete?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
  disconnect?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
  update?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateToOneWithWhereWithoutPointDeltaInput>;
  upsert?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpsertWithoutPointDeltaInput>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateWithoutActingAccountHolderInput = {
  actingUserId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateWithoutActingUserInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateWithoutPointDeltaInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  redemptionId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateWithoutRedemptionInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  relatedClinicId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateWithoutRelatedClinicInput = {
  actingAccountHolderId?: Maybe<Scalars['String']>;
  actingUserId?: Maybe<Scalars['String']>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemptionId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateInput = {
  actingAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutRewardRedemptionActionsNestedInput>;
  actingUser?: Maybe<UserUpdateOneWithoutLoyaltyRewardRedemptionActionsNestedInput>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDelta?: Maybe<LoyaltyPointDeltaUpdateOneWithoutRelatedRedemptionHistoryEntryNestedInput>;
  redemption?: Maybe<LoyaltyRewardRedemptionUpdateOneRequiredWithoutRedemptionHistoriesNestedInput>;
  relatedClinic?: Maybe<ClinicUpdateOneWithoutLoyaltyRewardRedemptionActionsNestedInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateManyMutationInput = {
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateManyWithWhereWithoutActingAccountHolderInput = {
  data: LoyaltyRewardRedemptionHistoryEntryUpdateManyMutationInput;
  where: LoyaltyRewardRedemptionHistoryEntryScalarWhereInput;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateManyWithWhereWithoutActingUserInput = {
  data: LoyaltyRewardRedemptionHistoryEntryUpdateManyMutationInput;
  where: LoyaltyRewardRedemptionHistoryEntryScalarWhereInput;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateManyWithWhereWithoutRedemptionInput = {
  data: LoyaltyRewardRedemptionHistoryEntryUpdateManyMutationInput;
  where: LoyaltyRewardRedemptionHistoryEntryScalarWhereInput;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateManyWithWhereWithoutRelatedClinicInput = {
  data: LoyaltyRewardRedemptionHistoryEntryUpdateManyMutationInput;
  where: LoyaltyRewardRedemptionHistoryEntryScalarWhereInput;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingAccountHolderNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutActingAccountHolderInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingAccountHolderInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyActingAccountHolderInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateWithWhereUniqueWithoutActingAccountHolderInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithWhereWithoutActingAccountHolderInput>>;
  upsert?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpsertWithWhereUniqueWithoutActingAccountHolderInput>>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutActingUserInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingUserInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyActingUserInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateWithWhereUniqueWithoutActingUserInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithWhereWithoutActingUserInput>>;
  upsert?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpsertWithWhereUniqueWithoutActingUserInput>>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRedemptionNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutRedemptionInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutRedemptionInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyRedemptionInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateWithWhereUniqueWithoutRedemptionInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithWhereWithoutRedemptionInput>>;
  upsert?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpsertWithWhereUniqueWithoutRedemptionInput>>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRelatedClinicNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutRelatedClinicInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryCreateWithoutRelatedClinicInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateManyRelatedClinicInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateWithWhereUniqueWithoutRelatedClinicInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithWhereWithoutRelatedClinicInput>>;
  upsert?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryUpsertWithWhereUniqueWithoutRelatedClinicInput>>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateOneWithoutPointDeltaNestedInput = {
  connect?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateOrConnectWithoutPointDeltaInput>;
  create?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateWithoutPointDeltaInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateToOneWithWhereWithoutPointDeltaInput>;
  upsert?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpsertWithoutPointDeltaInput>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateToOneWithWhereWithoutPointDeltaInput = {
  data: LoyaltyRewardRedemptionHistoryEntryUpdateWithoutPointDeltaInput;
  where?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateWithWhereUniqueWithoutActingAccountHolderInput = {
  data: LoyaltyRewardRedemptionHistoryEntryUpdateWithoutActingAccountHolderInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateWithWhereUniqueWithoutActingUserInput = {
  data: LoyaltyRewardRedemptionHistoryEntryUpdateWithoutActingUserInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateWithWhereUniqueWithoutRedemptionInput = {
  data: LoyaltyRewardRedemptionHistoryEntryUpdateWithoutRedemptionInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateWithWhereUniqueWithoutRelatedClinicInput = {
  data: LoyaltyRewardRedemptionHistoryEntryUpdateWithoutRelatedClinicInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateWithoutActingAccountHolderInput = {
  actingUser?: Maybe<UserUpdateOneWithoutLoyaltyRewardRedemptionActionsNestedInput>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDelta?: Maybe<LoyaltyPointDeltaUpdateOneWithoutRelatedRedemptionHistoryEntryNestedInput>;
  redemption?: Maybe<LoyaltyRewardRedemptionUpdateOneRequiredWithoutRedemptionHistoriesNestedInput>;
  relatedClinic?: Maybe<ClinicUpdateOneWithoutLoyaltyRewardRedemptionActionsNestedInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateWithoutActingUserInput = {
  actingAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutRewardRedemptionActionsNestedInput>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDelta?: Maybe<LoyaltyPointDeltaUpdateOneWithoutRelatedRedemptionHistoryEntryNestedInput>;
  redemption?: Maybe<LoyaltyRewardRedemptionUpdateOneRequiredWithoutRedemptionHistoriesNestedInput>;
  relatedClinic?: Maybe<ClinicUpdateOneWithoutLoyaltyRewardRedemptionActionsNestedInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateWithoutPointDeltaInput = {
  actingAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutRewardRedemptionActionsNestedInput>;
  actingUser?: Maybe<UserUpdateOneWithoutLoyaltyRewardRedemptionActionsNestedInput>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  redemption?: Maybe<LoyaltyRewardRedemptionUpdateOneRequiredWithoutRedemptionHistoriesNestedInput>;
  relatedClinic?: Maybe<ClinicUpdateOneWithoutLoyaltyRewardRedemptionActionsNestedInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateWithoutRedemptionInput = {
  actingAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutRewardRedemptionActionsNestedInput>;
  actingUser?: Maybe<UserUpdateOneWithoutLoyaltyRewardRedemptionActionsNestedInput>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDelta?: Maybe<LoyaltyPointDeltaUpdateOneWithoutRelatedRedemptionHistoryEntryNestedInput>;
  relatedClinic?: Maybe<ClinicUpdateOneWithoutLoyaltyRewardRedemptionActionsNestedInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpdateWithoutRelatedClinicInput = {
  actingAccountHolder?: Maybe<LoyaltyAccountHolderUpdateOneWithoutRewardRedemptionActionsNestedInput>;
  actingUser?: Maybe<UserUpdateOneWithoutLoyaltyRewardRedemptionActionsNestedInput>;
  actorType?: Maybe<LoyaltyRewardRedemptionActorType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pointDelta?: Maybe<LoyaltyPointDeltaUpdateOneWithoutRelatedRedemptionHistoryEntryNestedInput>;
  redemption?: Maybe<LoyaltyRewardRedemptionUpdateOneRequiredWithoutRedemptionHistoriesNestedInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
};

export type LoyaltyRewardRedemptionHistoryEntryUpsertWithWhereUniqueWithoutActingAccountHolderInput = {
  create: LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingAccountHolderInput;
  update: LoyaltyRewardRedemptionHistoryEntryUpdateWithoutActingAccountHolderInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryUpsertWithWhereUniqueWithoutActingUserInput = {
  create: LoyaltyRewardRedemptionHistoryEntryCreateWithoutActingUserInput;
  update: LoyaltyRewardRedemptionHistoryEntryUpdateWithoutActingUserInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryUpsertWithWhereUniqueWithoutRedemptionInput = {
  create: LoyaltyRewardRedemptionHistoryEntryCreateWithoutRedemptionInput;
  update: LoyaltyRewardRedemptionHistoryEntryUpdateWithoutRedemptionInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryUpsertWithWhereUniqueWithoutRelatedClinicInput = {
  create: LoyaltyRewardRedemptionHistoryEntryCreateWithoutRelatedClinicInput;
  update: LoyaltyRewardRedemptionHistoryEntryUpdateWithoutRelatedClinicInput;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};

export type LoyaltyRewardRedemptionHistoryEntryUpsertWithoutPointDeltaInput = {
  create: LoyaltyRewardRedemptionHistoryEntryCreateWithoutPointDeltaInput;
  update: LoyaltyRewardRedemptionHistoryEntryUpdateWithoutPointDeltaInput;
  where?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
};

export type LoyaltyRewardRedemptionHistoryEntryWhereInput = {
  AND?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereInput>>;
  NOT?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereInput>>;
  OR?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereInput>>;
  actingAccountHolder?: Maybe<LoyaltyAccountHolderNullableScalarRelationFilter>;
  actingAccountHolderId?: Maybe<StringNullableFilter>;
  actingUser?: Maybe<UserNullableScalarRelationFilter>;
  actingUserId?: Maybe<StringNullableFilter>;
  actorType?: Maybe<EnumLoyaltyRewardRedemptionActorTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  pointDelta?: Maybe<LoyaltyPointDeltaNullableScalarRelationFilter>;
  pointDeltaId?: Maybe<StringNullableFilter>;
  redemption?: Maybe<LoyaltyRewardRedemptionScalarRelationFilter>;
  redemptionId?: Maybe<StringFilter>;
  relatedClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  relatedClinicId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumLoyaltyRewardRedemptionStatusFilter>;
};

export type LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereInput>>;
  NOT?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereInput>>;
  OR?: Maybe<Array<LoyaltyRewardRedemptionHistoryEntryWhereInput>>;
  actingAccountHolder?: Maybe<LoyaltyAccountHolderNullableScalarRelationFilter>;
  actingAccountHolderId?: Maybe<StringNullableFilter>;
  actingUser?: Maybe<UserNullableScalarRelationFilter>;
  actingUserId?: Maybe<StringNullableFilter>;
  actorType?: Maybe<EnumLoyaltyRewardRedemptionActorTypeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  pointDelta?: Maybe<LoyaltyPointDeltaNullableScalarRelationFilter>;
  pointDeltaId?: Maybe<Scalars['String']>;
  redemption?: Maybe<LoyaltyRewardRedemptionScalarRelationFilter>;
  redemptionId?: Maybe<StringFilter>;
  redemptionId_status?: Maybe<LoyaltyRewardRedemptionHistoryEntryRedemptionIdStatusCompoundUniqueInput>;
  relatedClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  relatedClinicId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumLoyaltyRewardRedemptionStatusFilter>;
};

export type LoyaltyRewardRedemptionInput = {
  loyaltyRewardRedemptionId?: Maybe<Scalars['String']>;
};

export type LoyaltyRewardRedemptionListRelationFilter = {
  every?: Maybe<LoyaltyRewardRedemptionWhereInput>;
  none?: Maybe<LoyaltyRewardRedemptionWhereInput>;
  some?: Maybe<LoyaltyRewardRedemptionWhereInput>;
};

export type LoyaltyRewardRedemptionMaxAggregateOutputType = {
  __typename?: 'LoyaltyRewardRedemptionMaxAggregateOutputType';
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  rewardId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionMaxOrderByAggregateInput = {
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNote?: Maybe<SortOrder>;
  rewardId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionMinAggregateOutputType = {
  __typename?: 'LoyaltyRewardRedemptionMinAggregateOutputType';
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  rewardId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionMinOrderByAggregateInput = {
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNote?: Maybe<SortOrder>;
  rewardId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyRewardRedemptionOrderByRelevanceInput>;
  account?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNote?: Maybe<SortOrder>;
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput>;
  reward?: Maybe<LoyaltyRewardOrderByWithRelationInput>;
  rewardId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyRewardRedemptionOrderByRelevanceFieldEnum {
  AccountId = 'accountId',
  Id = 'id',
  InternalNote = 'internalNote',
  RewardId = 'rewardId'
}

export type LoyaltyRewardRedemptionOrderByRelevanceInput = {
  fields: Array<LoyaltyRewardRedemptionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type LoyaltyRewardRedemptionOrderByWithAggregationInput = {
  _count?: Maybe<LoyaltyRewardRedemptionCountOrderByAggregateInput>;
  _max?: Maybe<LoyaltyRewardRedemptionMaxOrderByAggregateInput>;
  _min?: Maybe<LoyaltyRewardRedemptionMinOrderByAggregateInput>;
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNote?: Maybe<SortOrder>;
  rewardId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<LoyaltyRewardRedemptionOrderByRelevanceInput>;
  account?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNote?: Maybe<SortOrder>;
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput>;
  reward?: Maybe<LoyaltyRewardOrderByWithRelationInput>;
  rewardId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type LoyaltyRewardRedemptionOrderByWithRelationInput = {
  _relevance?: Maybe<LoyaltyRewardRedemptionOrderByRelevanceInput>;
  account?: Maybe<LoyaltyAccountOrderByWithRelationInput>;
  accountId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  internalNote?: Maybe<SortOrder>;
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput>;
  reward?: Maybe<LoyaltyRewardOrderByWithRelationInput>;
  rewardId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum LoyaltyRewardRedemptionScalarFieldEnum {
  AccountId = 'accountId',
  CreatedAt = 'createdAt',
  Id = 'id',
  InternalNote = 'internalNote',
  RewardId = 'rewardId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type LoyaltyRewardRedemptionScalarRelationFilter = {
  AND?: Maybe<Array<LoyaltyRewardRedemptionWhereInput>>;
  NOT?: Maybe<Array<LoyaltyRewardRedemptionWhereInput>>;
  OR?: Maybe<Array<LoyaltyRewardRedemptionWhereInput>>;
  account?: Maybe<LoyaltyAccountScalarRelationFilter>;
  accountId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  internalNote?: Maybe<StringFilter>;
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  reward?: Maybe<LoyaltyRewardScalarRelationFilter>;
  rewardId?: Maybe<StringFilter>;
  status?: Maybe<EnumLoyaltyRewardRedemptionStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyRewardRedemptionScalarWhereInput = {
  AND?: Maybe<Array<LoyaltyRewardRedemptionScalarWhereInput>>;
  NOT?: Maybe<Array<LoyaltyRewardRedemptionScalarWhereInput>>;
  OR?: Maybe<Array<LoyaltyRewardRedemptionScalarWhereInput>>;
  accountId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  internalNote?: Maybe<StringFilter>;
  rewardId?: Maybe<StringFilter>;
  status?: Maybe<EnumLoyaltyRewardRedemptionStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyRewardRedemptionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyRewardRedemptionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyRewardRedemptionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyRewardRedemptionScalarWhereWithAggregatesInput>>;
  accountId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  internalNote?: Maybe<StringWithAggregatesFilter>;
  rewardId?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumLoyaltyRewardRedemptionStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum LoyaltyRewardRedemptionStatus {
  Canceled = 'Canceled',
  Canceling = 'Canceling',
  Fulfilled = 'Fulfilled',
  PendingFulfillment = 'PendingFulfillment',
  Rejected = 'Rejected',
  Requested = 'Requested'
}

export type LoyaltyRewardRedemptionSubscription = {
  __typename?: 'LoyaltyRewardRedemptionSubscription';
  mutation: MutationType;
  node: LoyaltyRewardRedemption;
};

export type LoyaltyRewardRedemptionUncheckedCreateInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote: Scalars['String'];
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRedemptionInput>;
  rewardId: Scalars['String'];
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionCreateOrConnectWithoutAccountInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionCreateWithoutAccountInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionCreateManyAccountInputEnvelope>;
};

export type LoyaltyRewardRedemptionUncheckedCreateNestedManyWithoutRewardInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionCreateOrConnectWithoutRewardInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionCreateWithoutRewardInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionCreateManyRewardInputEnvelope>;
};

export type LoyaltyRewardRedemptionUncheckedCreateWithoutAccountInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote: Scalars['String'];
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRedemptionInput>;
  rewardId: Scalars['String'];
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUncheckedCreateWithoutRedemptionHistoriesInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote: Scalars['String'];
  rewardId: Scalars['String'];
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUncheckedCreateWithoutRewardInput = {
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote: Scalars['String'];
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutRedemptionInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUncheckedUpdateInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRedemptionNestedInput>;
  rewardId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUncheckedUpdateManyInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  rewardId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUncheckedUpdateManyWithoutAccountInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  rewardId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionCreateOrConnectWithoutAccountInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionCreateWithoutAccountInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionCreateManyAccountInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardRedemptionScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardRedemptionUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardRedemptionUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: Maybe<Array<LoyaltyRewardRedemptionUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type LoyaltyRewardRedemptionUncheckedUpdateManyWithoutRewardInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUncheckedUpdateManyWithoutRewardNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionCreateOrConnectWithoutRewardInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionCreateWithoutRewardInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionCreateManyRewardInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardRedemptionScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardRedemptionUpdateWithWhereUniqueWithoutRewardInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardRedemptionUpdateManyWithWhereWithoutRewardInput>>;
  upsert?: Maybe<Array<LoyaltyRewardRedemptionUpsertWithWhereUniqueWithoutRewardInput>>;
};

export type LoyaltyRewardRedemptionUncheckedUpdateWithoutAccountInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRedemptionNestedInput>;
  rewardId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUncheckedUpdateWithoutRedemptionHistoriesInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  rewardId?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUncheckedUpdateWithoutRewardInput = {
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutRedemptionNestedInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUpdateInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutRewardRedemptionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRedemptionNestedInput>;
  reward?: Maybe<LoyaltyRewardUpdateOneRequiredWithoutRedemptionsNestedInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUpdateManyWithWhereWithoutAccountInput = {
  data: LoyaltyRewardRedemptionUpdateManyMutationInput;
  where: LoyaltyRewardRedemptionScalarWhereInput;
};

export type LoyaltyRewardRedemptionUpdateManyWithWhereWithoutRewardInput = {
  data: LoyaltyRewardRedemptionUpdateManyMutationInput;
  where: LoyaltyRewardRedemptionScalarWhereInput;
};

export type LoyaltyRewardRedemptionUpdateManyWithoutAccountNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionCreateOrConnectWithoutAccountInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionCreateWithoutAccountInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionCreateManyAccountInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardRedemptionScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardRedemptionUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardRedemptionUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: Maybe<Array<LoyaltyRewardRedemptionUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type LoyaltyRewardRedemptionUpdateManyWithoutRewardNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardRedemptionCreateOrConnectWithoutRewardInput>>;
  create?: Maybe<Array<LoyaltyRewardRedemptionCreateWithoutRewardInput>>;
  createMany?: Maybe<LoyaltyRewardRedemptionCreateManyRewardInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardRedemptionScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardRedemptionWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardRedemptionUpdateWithWhereUniqueWithoutRewardInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardRedemptionUpdateManyWithWhereWithoutRewardInput>>;
  upsert?: Maybe<Array<LoyaltyRewardRedemptionUpsertWithWhereUniqueWithoutRewardInput>>;
};

export type LoyaltyRewardRedemptionUpdateOneRequiredWithoutRedemptionHistoriesNestedInput = {
  connect?: Maybe<LoyaltyRewardRedemptionWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyRewardRedemptionCreateOrConnectWithoutRedemptionHistoriesInput>;
  create?: Maybe<LoyaltyRewardRedemptionCreateWithoutRedemptionHistoriesInput>;
  update?: Maybe<LoyaltyRewardRedemptionUpdateToOneWithWhereWithoutRedemptionHistoriesInput>;
  upsert?: Maybe<LoyaltyRewardRedemptionUpsertWithoutRedemptionHistoriesInput>;
};

export type LoyaltyRewardRedemptionUpdateToOneWithWhereWithoutRedemptionHistoriesInput = {
  data: LoyaltyRewardRedemptionUpdateWithoutRedemptionHistoriesInput;
  where?: Maybe<LoyaltyRewardRedemptionWhereInput>;
};

export type LoyaltyRewardRedemptionUpdateWithWhereUniqueWithoutAccountInput = {
  data: LoyaltyRewardRedemptionUpdateWithoutAccountInput;
  where: LoyaltyRewardRedemptionWhereUniqueInput;
};

export type LoyaltyRewardRedemptionUpdateWithWhereUniqueWithoutRewardInput = {
  data: LoyaltyRewardRedemptionUpdateWithoutRewardInput;
  where: LoyaltyRewardRedemptionWhereUniqueInput;
};

export type LoyaltyRewardRedemptionUpdateWithoutAccountInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRedemptionNestedInput>;
  reward?: Maybe<LoyaltyRewardUpdateOneRequiredWithoutRedemptionsNestedInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUpdateWithoutRedemptionHistoriesInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutRewardRedemptionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  reward?: Maybe<LoyaltyRewardUpdateOneRequiredWithoutRedemptionsNestedInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUpdateWithoutRewardInput = {
  account?: Maybe<LoyaltyAccountUpdateOneRequiredWithoutRewardRedemptionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutRedemptionNestedInput>;
  status?: Maybe<LoyaltyRewardRedemptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardRedemptionUpsertWithWhereUniqueWithoutAccountInput = {
  create: LoyaltyRewardRedemptionCreateWithoutAccountInput;
  update: LoyaltyRewardRedemptionUpdateWithoutAccountInput;
  where: LoyaltyRewardRedemptionWhereUniqueInput;
};

export type LoyaltyRewardRedemptionUpsertWithWhereUniqueWithoutRewardInput = {
  create: LoyaltyRewardRedemptionCreateWithoutRewardInput;
  update: LoyaltyRewardRedemptionUpdateWithoutRewardInput;
  where: LoyaltyRewardRedemptionWhereUniqueInput;
};

export type LoyaltyRewardRedemptionUpsertWithoutRedemptionHistoriesInput = {
  create: LoyaltyRewardRedemptionCreateWithoutRedemptionHistoriesInput;
  update: LoyaltyRewardRedemptionUpdateWithoutRedemptionHistoriesInput;
  where?: Maybe<LoyaltyRewardRedemptionWhereInput>;
};

export type LoyaltyRewardRedemptionWhereInput = {
  AND?: Maybe<Array<LoyaltyRewardRedemptionWhereInput>>;
  NOT?: Maybe<Array<LoyaltyRewardRedemptionWhereInput>>;
  OR?: Maybe<Array<LoyaltyRewardRedemptionWhereInput>>;
  account?: Maybe<LoyaltyAccountScalarRelationFilter>;
  accountId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  internalNote?: Maybe<StringFilter>;
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  reward?: Maybe<LoyaltyRewardScalarRelationFilter>;
  rewardId?: Maybe<StringFilter>;
  status?: Maybe<EnumLoyaltyRewardRedemptionStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyRewardRedemptionWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyRewardRedemptionWhereInput>>;
  NOT?: Maybe<Array<LoyaltyRewardRedemptionWhereInput>>;
  OR?: Maybe<Array<LoyaltyRewardRedemptionWhereInput>>;
  account?: Maybe<LoyaltyAccountScalarRelationFilter>;
  accountId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  internalNote?: Maybe<StringFilter>;
  redemptionHistories?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  reward?: Maybe<LoyaltyRewardScalarRelationFilter>;
  rewardId?: Maybe<StringFilter>;
  status?: Maybe<EnumLoyaltyRewardRedemptionStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum LoyaltyRewardScalarFieldEnum {
  Availability = 'availability',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  InternalNotes = 'internalNotes',
  PointCost = 'pointCost',
  ProgramId = 'programId',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type LoyaltyRewardScalarRelationFilter = {
  AND?: Maybe<Array<LoyaltyRewardWhereInput>>;
  NOT?: Maybe<Array<LoyaltyRewardWhereInput>>;
  OR?: Maybe<Array<LoyaltyRewardWhereInput>>;
  availability?: Maybe<EnumLoyaltyRewardAvailabilityFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  internalNotes?: Maybe<StringNullableFilter>;
  pointCost?: Maybe<IntFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  redemptions?: Maybe<LoyaltyRewardRedemptionListRelationFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyRewardScalarWhereInput = {
  AND?: Maybe<Array<LoyaltyRewardScalarWhereInput>>;
  NOT?: Maybe<Array<LoyaltyRewardScalarWhereInput>>;
  OR?: Maybe<Array<LoyaltyRewardScalarWhereInput>>;
  availability?: Maybe<EnumLoyaltyRewardAvailabilityFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  internalNotes?: Maybe<StringNullableFilter>;
  pointCost?: Maybe<IntFilter>;
  programId?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyRewardScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoyaltyRewardScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoyaltyRewardScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoyaltyRewardScalarWhereWithAggregatesInput>>;
  availability?: Maybe<EnumLoyaltyRewardAvailabilityWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  internalNotes?: Maybe<StringNullableWithAggregatesFilter>;
  pointCost?: Maybe<IntWithAggregatesFilter>;
  programId?: Maybe<StringWithAggregatesFilter>;
  title?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type LoyaltyRewardSumAggregateOutputType = {
  __typename?: 'LoyaltyRewardSumAggregateOutputType';
  pointCost?: Maybe<Scalars['Int']>;
};

export type LoyaltyRewardSumOrderByAggregateInput = {
  pointCost?: Maybe<SortOrder>;
};

export type LoyaltyRewardUncheckedCreateInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost: Scalars['Int'];
  programId: Scalars['String'];
  redemptions?: Maybe<LoyaltyRewardRedemptionUncheckedCreateNestedManyWithoutRewardInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardUncheckedCreateNestedManyWithoutProgramInput = {
  connect?: Maybe<Array<LoyaltyRewardWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyRewardCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyRewardCreateManyProgramInputEnvelope>;
};

export type LoyaltyRewardUncheckedCreateWithoutProgramInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost: Scalars['Int'];
  redemptions?: Maybe<LoyaltyRewardRedemptionUncheckedCreateNestedManyWithoutRewardInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardUncheckedCreateWithoutRedemptionsInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost: Scalars['Int'];
  programId: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardUncheckedUpdateInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  redemptions?: Maybe<LoyaltyRewardRedemptionUncheckedUpdateManyWithoutRewardNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardUncheckedUpdateManyInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardUncheckedUpdateManyWithoutProgramInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardUncheckedUpdateManyWithoutProgramNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyRewardCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyRewardCreateManyProgramInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardUpdateWithWhereUniqueWithoutProgramInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardUpdateManyWithWhereWithoutProgramInput>>;
  upsert?: Maybe<Array<LoyaltyRewardUpsertWithWhereUniqueWithoutProgramInput>>;
};

export type LoyaltyRewardUncheckedUpdateWithoutProgramInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost?: Maybe<Scalars['Int']>;
  redemptions?: Maybe<LoyaltyRewardRedemptionUncheckedUpdateManyWithoutRewardNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardUncheckedUpdateWithoutRedemptionsInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardUpdateInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost?: Maybe<Scalars['Int']>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutRewardsNestedInput>;
  redemptions?: Maybe<LoyaltyRewardRedemptionUpdateManyWithoutRewardNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardUpdateManyMutationInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardUpdateManyWithWhereWithoutProgramInput = {
  data: LoyaltyRewardUpdateManyMutationInput;
  where: LoyaltyRewardScalarWhereInput;
};

export type LoyaltyRewardUpdateManyWithoutProgramNestedInput = {
  connect?: Maybe<Array<LoyaltyRewardWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<LoyaltyRewardCreateOrConnectWithoutProgramInput>>;
  create?: Maybe<Array<LoyaltyRewardCreateWithoutProgramInput>>;
  createMany?: Maybe<LoyaltyRewardCreateManyProgramInputEnvelope>;
  delete?: Maybe<Array<LoyaltyRewardWhereUniqueInput>>;
  deleteMany?: Maybe<Array<LoyaltyRewardScalarWhereInput>>;
  disconnect?: Maybe<Array<LoyaltyRewardWhereUniqueInput>>;
  set?: Maybe<Array<LoyaltyRewardWhereUniqueInput>>;
  update?: Maybe<Array<LoyaltyRewardUpdateWithWhereUniqueWithoutProgramInput>>;
  updateMany?: Maybe<Array<LoyaltyRewardUpdateManyWithWhereWithoutProgramInput>>;
  upsert?: Maybe<Array<LoyaltyRewardUpsertWithWhereUniqueWithoutProgramInput>>;
};

export type LoyaltyRewardUpdateOneRequiredWithoutRedemptionsNestedInput = {
  connect?: Maybe<LoyaltyRewardWhereUniqueInput>;
  connectOrCreate?: Maybe<LoyaltyRewardCreateOrConnectWithoutRedemptionsInput>;
  create?: Maybe<LoyaltyRewardCreateWithoutRedemptionsInput>;
  update?: Maybe<LoyaltyRewardUpdateToOneWithWhereWithoutRedemptionsInput>;
  upsert?: Maybe<LoyaltyRewardUpsertWithoutRedemptionsInput>;
};

export type LoyaltyRewardUpdateToOneWithWhereWithoutRedemptionsInput = {
  data: LoyaltyRewardUpdateWithoutRedemptionsInput;
  where?: Maybe<LoyaltyRewardWhereInput>;
};

export type LoyaltyRewardUpdateWithWhereUniqueWithoutProgramInput = {
  data: LoyaltyRewardUpdateWithoutProgramInput;
  where: LoyaltyRewardWhereUniqueInput;
};

export type LoyaltyRewardUpdateWithoutProgramInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost?: Maybe<Scalars['Int']>;
  redemptions?: Maybe<LoyaltyRewardRedemptionUpdateManyWithoutRewardNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardUpdateWithoutRedemptionsInput = {
  availability?: Maybe<LoyaltyRewardAvailability>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  pointCost?: Maybe<Scalars['Int']>;
  program?: Maybe<LoyaltyProgramUpdateOneRequiredWithoutRewardsNestedInput>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoyaltyRewardUpsertWithWhereUniqueWithoutProgramInput = {
  create: LoyaltyRewardCreateWithoutProgramInput;
  update: LoyaltyRewardUpdateWithoutProgramInput;
  where: LoyaltyRewardWhereUniqueInput;
};

export type LoyaltyRewardUpsertWithoutRedemptionsInput = {
  create: LoyaltyRewardCreateWithoutRedemptionsInput;
  update: LoyaltyRewardUpdateWithoutRedemptionsInput;
  where?: Maybe<LoyaltyRewardWhereInput>;
};

export type LoyaltyRewardWhereInput = {
  AND?: Maybe<Array<LoyaltyRewardWhereInput>>;
  NOT?: Maybe<Array<LoyaltyRewardWhereInput>>;
  OR?: Maybe<Array<LoyaltyRewardWhereInput>>;
  availability?: Maybe<EnumLoyaltyRewardAvailabilityFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  internalNotes?: Maybe<StringNullableFilter>;
  pointCost?: Maybe<IntFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  redemptions?: Maybe<LoyaltyRewardRedemptionListRelationFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type LoyaltyRewardWhereUniqueInput = {
  AND?: Maybe<Array<LoyaltyRewardWhereInput>>;
  NOT?: Maybe<Array<LoyaltyRewardWhereInput>>;
  OR?: Maybe<Array<LoyaltyRewardWhereInput>>;
  availability?: Maybe<EnumLoyaltyRewardAvailabilityFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<StringNullableFilter>;
  pointCost?: Maybe<IntFilter>;
  program?: Maybe<LoyaltyProgramScalarRelationFilter>;
  programId?: Maybe<StringFilter>;
  redemptions?: Maybe<LoyaltyRewardRedemptionListRelationFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum ManageMembershipRequestType {
  Cancel = 'Cancel',
  EditBenefit = 'EditBenefit',
  ManualAdjusment = 'ManualAdjusment',
  Note = 'Note',
  OptOut = 'OptOut',
  Other = 'Other',
  RemoveBenefit = 'RemoveBenefit',
  Transfer = 'Transfer',
  Upgrade = 'Upgrade'
}

export type MassTextAlert = {
  __typename?: 'MassTextAlert';
  _count: MassTextAlertCountOutputType;
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByUser: User;
  createdByUserId: Scalars['String'];
  id: Scalars['String'];
  massTextAlertEntries: Array<MassTextAlertEntry>;
  status: MassTextAlertStatus;
  updatedAt: Scalars['DateTime'];
};


export type MassTextAlertMassTextAlertEntriesArgs = {
  cursor?: Maybe<MassTextAlertEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertEntryWhereInput>;
};

export type MassTextAlertCountAggregateOutputType = {
  __typename?: 'MassTextAlertCountAggregateOutputType';
  _all: Scalars['Int'];
  alertBody: Scalars['Int'];
  appointmentDateRangeType: Scalars['Int'];
  appointmentDateTimeFrom: Scalars['Int'];
  appointmentDateTimeTo: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdByUserId: Scalars['Int'];
  id: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MassTextAlertCountOrderByAggregateInput = {
  alertBody?: Maybe<SortOrder>;
  appointmentDateRangeType?: Maybe<SortOrder>;
  appointmentDateTimeFrom?: Maybe<SortOrder>;
  appointmentDateTimeTo?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertCountOutputType = {
  __typename?: 'MassTextAlertCountOutputType';
  massTextAlertEntries: Scalars['Int'];
};

export type MassTextAlertCreateInput = {
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  clinic: ClinicCreateNestedOneWithoutMassTextAlertsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser: UserCreateNestedOneWithoutMassTextAlertsInput;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutMassTextAlertInput>;
  status: MassTextAlertStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertCreateManyClinicInput = {
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  status: MassTextAlertStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertCreateManyClinicInputEnvelope = {
  data: Array<MassTextAlertCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MassTextAlertCreateManyCreatedByUserInput = {
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status: MassTextAlertStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertCreateManyCreatedByUserInputEnvelope = {
  data: Array<MassTextAlertCreateManyCreatedByUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MassTextAlertCreateManyInput = {
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  status: MassTextAlertStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<MassTextAlertCreateWithoutClinicInput>>;
  createMany?: Maybe<MassTextAlertCreateManyClinicInputEnvelope>;
};

export type MassTextAlertCreateNestedManyWithoutCreatedByUserInput = {
  connect?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertCreateOrConnectWithoutCreatedByUserInput>>;
  create?: Maybe<Array<MassTextAlertCreateWithoutCreatedByUserInput>>;
  createMany?: Maybe<MassTextAlertCreateManyCreatedByUserInputEnvelope>;
};

export type MassTextAlertCreateNestedOneWithoutMassTextAlertEntriesInput = {
  connect?: Maybe<MassTextAlertWhereUniqueInput>;
  connectOrCreate?: Maybe<MassTextAlertCreateOrConnectWithoutMassTextAlertEntriesInput>;
  create?: Maybe<MassTextAlertCreateWithoutMassTextAlertEntriesInput>;
};

export type MassTextAlertCreateOrConnectWithoutClinicInput = {
  create: MassTextAlertCreateWithoutClinicInput;
  where: MassTextAlertWhereUniqueInput;
};

export type MassTextAlertCreateOrConnectWithoutCreatedByUserInput = {
  create: MassTextAlertCreateWithoutCreatedByUserInput;
  where: MassTextAlertWhereUniqueInput;
};

export type MassTextAlertCreateOrConnectWithoutMassTextAlertEntriesInput = {
  create: MassTextAlertCreateWithoutMassTextAlertEntriesInput;
  where: MassTextAlertWhereUniqueInput;
};

export type MassTextAlertCreateWithoutClinicInput = {
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser: UserCreateNestedOneWithoutMassTextAlertsInput;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutMassTextAlertInput>;
  status: MassTextAlertStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertCreateWithoutCreatedByUserInput = {
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  clinic: ClinicCreateNestedOneWithoutMassTextAlertsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryCreateNestedManyWithoutMassTextAlertInput>;
  status: MassTextAlertStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertCreateWithoutMassTextAlertEntriesInput = {
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  clinic: ClinicCreateNestedOneWithoutMassTextAlertsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser: UserCreateNestedOneWithoutMassTextAlertsInput;
  id?: Maybe<Scalars['String']>;
  status: MassTextAlertStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntry = {
  __typename?: 'MassTextAlertEntry';
  _count: MassTextAlertEntryCountOutputType;
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  massAlertEntryAppointments: Array<MassTextAlertEntryAppointment>;
  massTextAlert: MassTextAlert;
  massTextAlertId: Scalars['String'];
  phoneNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type MassTextAlertEntryMassAlertEntryAppointmentsArgs = {
  cursor?: Maybe<MassTextAlertEntryAppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertEntryAppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertEntryAppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertEntryAppointmentWhereInput>;
};

export type MassTextAlertEntryAppointment = {
  __typename?: 'MassTextAlertEntryAppointment';
  appointment: Appointment;
  appointmentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  massTextAlertEntry: MassTextAlertEntry;
  massTextAlertEntryId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type MassTextAlertEntryAppointmentCountAggregateOutputType = {
  __typename?: 'MassTextAlertEntryAppointmentCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  massTextAlertEntryId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MassTextAlertEntryAppointmentCountOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertEntryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertEntryAppointmentCreateInput = {
  appointment: AppointmentCreateNestedOneWithoutMassTextAlertEntryAppointmentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntry: MassTextAlertEntryCreateNestedOneWithoutMassAlertEntryAppointmentsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentCreateManyAppointmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntryId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentCreateManyAppointmentInputEnvelope = {
  data: Array<MassTextAlertEntryAppointmentCreateManyAppointmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MassTextAlertEntryAppointmentCreateManyInput = {
  appointmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntryId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentCreateManyMassTextAlertEntryInput = {
  appointmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentCreateManyMassTextAlertEntryInputEnvelope = {
  data: Array<MassTextAlertEntryAppointmentCreateManyMassTextAlertEntryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MassTextAlertEntryAppointmentCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryAppointmentCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<MassTextAlertEntryAppointmentCreateWithoutAppointmentInput>>;
  createMany?: Maybe<MassTextAlertEntryAppointmentCreateManyAppointmentInputEnvelope>;
};

export type MassTextAlertEntryAppointmentCreateNestedManyWithoutMassTextAlertEntryInput = {
  connect?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryAppointmentCreateOrConnectWithoutMassTextAlertEntryInput>>;
  create?: Maybe<Array<MassTextAlertEntryAppointmentCreateWithoutMassTextAlertEntryInput>>;
  createMany?: Maybe<MassTextAlertEntryAppointmentCreateManyMassTextAlertEntryInputEnvelope>;
};

export type MassTextAlertEntryAppointmentCreateOrConnectWithoutAppointmentInput = {
  create: MassTextAlertEntryAppointmentCreateWithoutAppointmentInput;
  where: MassTextAlertEntryAppointmentWhereUniqueInput;
};

export type MassTextAlertEntryAppointmentCreateOrConnectWithoutMassTextAlertEntryInput = {
  create: MassTextAlertEntryAppointmentCreateWithoutMassTextAlertEntryInput;
  where: MassTextAlertEntryAppointmentWhereUniqueInput;
};

export type MassTextAlertEntryAppointmentCreateWithoutAppointmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntry: MassTextAlertEntryCreateNestedOneWithoutMassAlertEntryAppointmentsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentCreateWithoutMassTextAlertEntryInput = {
  appointment: AppointmentCreateNestedOneWithoutMassTextAlertEntryAppointmentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentGroupByOutputType = {
  __typename?: 'MassTextAlertEntryAppointmentGroupByOutputType';
  _count?: Maybe<MassTextAlertEntryAppointmentCountAggregateOutputType>;
  _max?: Maybe<MassTextAlertEntryAppointmentMaxAggregateOutputType>;
  _min?: Maybe<MassTextAlertEntryAppointmentMinAggregateOutputType>;
  appointmentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  massTextAlertEntryId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type MassTextAlertEntryAppointmentListRelationFilter = {
  every?: Maybe<MassTextAlertEntryAppointmentWhereInput>;
  none?: Maybe<MassTextAlertEntryAppointmentWhereInput>;
  some?: Maybe<MassTextAlertEntryAppointmentWhereInput>;
};

export type MassTextAlertEntryAppointmentMassTextAlertEntryIdAppointmentIdCompoundUniqueInput = {
  appointmentId: Scalars['String'];
  massTextAlertEntryId: Scalars['String'];
};

export type MassTextAlertEntryAppointmentMaxAggregateOutputType = {
  __typename?: 'MassTextAlertEntryAppointmentMaxAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentMaxOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertEntryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertEntryAppointmentMinAggregateOutputType = {
  __typename?: 'MassTextAlertEntryAppointmentMinAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentMinOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertEntryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertEntryAppointmentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type MassTextAlertEntryAppointmentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MassTextAlertEntryAppointmentOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertEntry?: Maybe<MassTextAlertEntryOrderByWithRelationInput>;
  massTextAlertEntryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum MassTextAlertEntryAppointmentOrderByRelevanceFieldEnum {
  AppointmentId = 'appointmentId',
  Id = 'id',
  MassTextAlertEntryId = 'massTextAlertEntryId'
}

export type MassTextAlertEntryAppointmentOrderByRelevanceInput = {
  fields: Array<MassTextAlertEntryAppointmentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type MassTextAlertEntryAppointmentOrderByWithAggregationInput = {
  _count?: Maybe<MassTextAlertEntryAppointmentCountOrderByAggregateInput>;
  _max?: Maybe<MassTextAlertEntryAppointmentMaxOrderByAggregateInput>;
  _min?: Maybe<MassTextAlertEntryAppointmentMinOrderByAggregateInput>;
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertEntryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertEntryAppointmentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MassTextAlertEntryAppointmentOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertEntry?: Maybe<MassTextAlertEntryOrderByWithRelationInput>;
  massTextAlertEntryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertEntryAppointmentOrderByWithRelationInput = {
  _relevance?: Maybe<MassTextAlertEntryAppointmentOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertEntry?: Maybe<MassTextAlertEntryOrderByWithRelationInput>;
  massTextAlertEntryId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum MassTextAlertEntryAppointmentScalarFieldEnum {
  AppointmentId = 'appointmentId',
  CreatedAt = 'createdAt',
  Id = 'id',
  MassTextAlertEntryId = 'massTextAlertEntryId',
  UpdatedAt = 'updatedAt'
}

export type MassTextAlertEntryAppointmentScalarWhereInput = {
  AND?: Maybe<Array<MassTextAlertEntryAppointmentScalarWhereInput>>;
  NOT?: Maybe<Array<MassTextAlertEntryAppointmentScalarWhereInput>>;
  OR?: Maybe<Array<MassTextAlertEntryAppointmentScalarWhereInput>>;
  appointmentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  massTextAlertEntryId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MassTextAlertEntryAppointmentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<MassTextAlertEntryAppointmentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<MassTextAlertEntryAppointmentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<MassTextAlertEntryAppointmentScalarWhereWithAggregatesInput>>;
  appointmentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  massTextAlertEntryId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type MassTextAlertEntryAppointmentUncheckedCreateInput = {
  appointmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntryId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryAppointmentCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<MassTextAlertEntryAppointmentCreateWithoutAppointmentInput>>;
  createMany?: Maybe<MassTextAlertEntryAppointmentCreateManyAppointmentInputEnvelope>;
};

export type MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutMassTextAlertEntryInput = {
  connect?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryAppointmentCreateOrConnectWithoutMassTextAlertEntryInput>>;
  create?: Maybe<Array<MassTextAlertEntryAppointmentCreateWithoutMassTextAlertEntryInput>>;
  createMany?: Maybe<MassTextAlertEntryAppointmentCreateManyMassTextAlertEntryInputEnvelope>;
};

export type MassTextAlertEntryAppointmentUncheckedCreateWithoutAppointmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntryId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUncheckedCreateWithoutMassTextAlertEntryInput = {
  appointmentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUncheckedUpdateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUncheckedUpdateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryAppointmentCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<MassTextAlertEntryAppointmentCreateWithoutAppointmentInput>>;
  createMany?: Maybe<MassTextAlertEntryAppointmentCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MassTextAlertEntryAppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  set?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  update?: Maybe<Array<MassTextAlertEntryAppointmentUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<MassTextAlertEntryAppointmentUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<MassTextAlertEntryAppointmentUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutMassTextAlertEntryInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutMassTextAlertEntryNestedInput = {
  connect?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryAppointmentCreateOrConnectWithoutMassTextAlertEntryInput>>;
  create?: Maybe<Array<MassTextAlertEntryAppointmentCreateWithoutMassTextAlertEntryInput>>;
  createMany?: Maybe<MassTextAlertEntryAppointmentCreateManyMassTextAlertEntryInputEnvelope>;
  delete?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MassTextAlertEntryAppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  set?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  update?: Maybe<Array<MassTextAlertEntryAppointmentUpdateWithWhereUniqueWithoutMassTextAlertEntryInput>>;
  updateMany?: Maybe<Array<MassTextAlertEntryAppointmentUpdateManyWithWhereWithoutMassTextAlertEntryInput>>;
  upsert?: Maybe<Array<MassTextAlertEntryAppointmentUpsertWithWhereUniqueWithoutMassTextAlertEntryInput>>;
};

export type MassTextAlertEntryAppointmentUncheckedUpdateWithoutAppointmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUncheckedUpdateWithoutMassTextAlertEntryInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUpdateInput = {
  appointment?: Maybe<AppointmentUpdateOneRequiredWithoutMassTextAlertEntryAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntry?: Maybe<MassTextAlertEntryUpdateOneRequiredWithoutMassAlertEntryAppointmentsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUpdateManyWithWhereWithoutAppointmentInput = {
  data: MassTextAlertEntryAppointmentUpdateManyMutationInput;
  where: MassTextAlertEntryAppointmentScalarWhereInput;
};

export type MassTextAlertEntryAppointmentUpdateManyWithWhereWithoutMassTextAlertEntryInput = {
  data: MassTextAlertEntryAppointmentUpdateManyMutationInput;
  where: MassTextAlertEntryAppointmentScalarWhereInput;
};

export type MassTextAlertEntryAppointmentUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryAppointmentCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<MassTextAlertEntryAppointmentCreateWithoutAppointmentInput>>;
  createMany?: Maybe<MassTextAlertEntryAppointmentCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MassTextAlertEntryAppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  set?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  update?: Maybe<Array<MassTextAlertEntryAppointmentUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<MassTextAlertEntryAppointmentUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<MassTextAlertEntryAppointmentUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type MassTextAlertEntryAppointmentUpdateManyWithoutMassTextAlertEntryNestedInput = {
  connect?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryAppointmentCreateOrConnectWithoutMassTextAlertEntryInput>>;
  create?: Maybe<Array<MassTextAlertEntryAppointmentCreateWithoutMassTextAlertEntryInput>>;
  createMany?: Maybe<MassTextAlertEntryAppointmentCreateManyMassTextAlertEntryInputEnvelope>;
  delete?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MassTextAlertEntryAppointmentScalarWhereInput>>;
  disconnect?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  set?: Maybe<Array<MassTextAlertEntryAppointmentWhereUniqueInput>>;
  update?: Maybe<Array<MassTextAlertEntryAppointmentUpdateWithWhereUniqueWithoutMassTextAlertEntryInput>>;
  updateMany?: Maybe<Array<MassTextAlertEntryAppointmentUpdateManyWithWhereWithoutMassTextAlertEntryInput>>;
  upsert?: Maybe<Array<MassTextAlertEntryAppointmentUpsertWithWhereUniqueWithoutMassTextAlertEntryInput>>;
};

export type MassTextAlertEntryAppointmentUpdateWithWhereUniqueWithoutAppointmentInput = {
  data: MassTextAlertEntryAppointmentUpdateWithoutAppointmentInput;
  where: MassTextAlertEntryAppointmentWhereUniqueInput;
};

export type MassTextAlertEntryAppointmentUpdateWithWhereUniqueWithoutMassTextAlertEntryInput = {
  data: MassTextAlertEntryAppointmentUpdateWithoutMassTextAlertEntryInput;
  where: MassTextAlertEntryAppointmentWhereUniqueInput;
};

export type MassTextAlertEntryAppointmentUpdateWithoutAppointmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntry?: Maybe<MassTextAlertEntryUpdateOneRequiredWithoutMassAlertEntryAppointmentsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUpdateWithoutMassTextAlertEntryInput = {
  appointment?: Maybe<AppointmentUpdateOneRequiredWithoutMassTextAlertEntryAppointmentsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryAppointmentUpsertWithWhereUniqueWithoutAppointmentInput = {
  create: MassTextAlertEntryAppointmentCreateWithoutAppointmentInput;
  update: MassTextAlertEntryAppointmentUpdateWithoutAppointmentInput;
  where: MassTextAlertEntryAppointmentWhereUniqueInput;
};

export type MassTextAlertEntryAppointmentUpsertWithWhereUniqueWithoutMassTextAlertEntryInput = {
  create: MassTextAlertEntryAppointmentCreateWithoutMassTextAlertEntryInput;
  update: MassTextAlertEntryAppointmentUpdateWithoutMassTextAlertEntryInput;
  where: MassTextAlertEntryAppointmentWhereUniqueInput;
};

export type MassTextAlertEntryAppointmentWhereInput = {
  AND?: Maybe<Array<MassTextAlertEntryAppointmentWhereInput>>;
  NOT?: Maybe<Array<MassTextAlertEntryAppointmentWhereInput>>;
  OR?: Maybe<Array<MassTextAlertEntryAppointmentWhereInput>>;
  appointment?: Maybe<AppointmentScalarRelationFilter>;
  appointmentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  massTextAlertEntry?: Maybe<MassTextAlertEntryScalarRelationFilter>;
  massTextAlertEntryId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MassTextAlertEntryAppointmentWhereUniqueInput = {
  AND?: Maybe<Array<MassTextAlertEntryAppointmentWhereInput>>;
  NOT?: Maybe<Array<MassTextAlertEntryAppointmentWhereInput>>;
  OR?: Maybe<Array<MassTextAlertEntryAppointmentWhereInput>>;
  appointment?: Maybe<AppointmentScalarRelationFilter>;
  appointmentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntry?: Maybe<MassTextAlertEntryScalarRelationFilter>;
  massTextAlertEntryId?: Maybe<StringFilter>;
  massTextAlertEntryId_appointmentId?: Maybe<MassTextAlertEntryAppointmentMassTextAlertEntryIdAppointmentIdCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MassTextAlertEntryCountAggregateOutputType = {
  __typename?: 'MassTextAlertEntryCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  massTextAlertId: Scalars['Int'];
  phoneNumber: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MassTextAlertEntryCountOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertEntryCountOutputType = {
  __typename?: 'MassTextAlertEntryCountOutputType';
  massAlertEntryAppointments: Scalars['Int'];
};

export type MassTextAlertEntryCreateInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutMassTextAlertEntriesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutMassTextAlertEntryInput>;
  massTextAlert: MassTextAlertCreateNestedOneWithoutMassTextAlertEntriesInput;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryCreateManyClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertId: Scalars['String'];
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryCreateManyClinicPetParentInputEnvelope = {
  data: Array<MassTextAlertEntryCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MassTextAlertEntryCreateManyInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertId: Scalars['String'];
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryCreateManyMassTextAlertInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryCreateManyMassTextAlertInputEnvelope = {
  data: Array<MassTextAlertEntryCreateManyMassTextAlertInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MassTextAlertEntryCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<MassTextAlertEntryCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<MassTextAlertEntryCreateManyClinicPetParentInputEnvelope>;
};

export type MassTextAlertEntryCreateNestedManyWithoutMassTextAlertInput = {
  connect?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryCreateOrConnectWithoutMassTextAlertInput>>;
  create?: Maybe<Array<MassTextAlertEntryCreateWithoutMassTextAlertInput>>;
  createMany?: Maybe<MassTextAlertEntryCreateManyMassTextAlertInputEnvelope>;
};

export type MassTextAlertEntryCreateNestedOneWithoutMassAlertEntryAppointmentsInput = {
  connect?: Maybe<MassTextAlertEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<MassTextAlertEntryCreateOrConnectWithoutMassAlertEntryAppointmentsInput>;
  create?: Maybe<MassTextAlertEntryCreateWithoutMassAlertEntryAppointmentsInput>;
};

export type MassTextAlertEntryCreateOrConnectWithoutClinicPetParentInput = {
  create: MassTextAlertEntryCreateWithoutClinicPetParentInput;
  where: MassTextAlertEntryWhereUniqueInput;
};

export type MassTextAlertEntryCreateOrConnectWithoutMassAlertEntryAppointmentsInput = {
  create: MassTextAlertEntryCreateWithoutMassAlertEntryAppointmentsInput;
  where: MassTextAlertEntryWhereUniqueInput;
};

export type MassTextAlertEntryCreateOrConnectWithoutMassTextAlertInput = {
  create: MassTextAlertEntryCreateWithoutMassTextAlertInput;
  where: MassTextAlertEntryWhereUniqueInput;
};

export type MassTextAlertEntryCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutMassTextAlertEntryInput>;
  massTextAlert: MassTextAlertCreateNestedOneWithoutMassTextAlertEntriesInput;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryCreateWithoutMassAlertEntryAppointmentsInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutMassTextAlertEntriesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlert: MassTextAlertCreateNestedOneWithoutMassTextAlertEntriesInput;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryCreateWithoutMassTextAlertInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutMassTextAlertEntriesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentCreateNestedManyWithoutMassTextAlertEntryInput>;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryGroupByOutputType = {
  __typename?: 'MassTextAlertEntryGroupByOutputType';
  _count?: Maybe<MassTextAlertEntryCountAggregateOutputType>;
  _max?: Maybe<MassTextAlertEntryMaxAggregateOutputType>;
  _min?: Maybe<MassTextAlertEntryMinAggregateOutputType>;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  massTextAlertId: Scalars['String'];
  phoneNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type MassTextAlertEntryListRelationFilter = {
  every?: Maybe<MassTextAlertEntryWhereInput>;
  none?: Maybe<MassTextAlertEntryWhereInput>;
  some?: Maybe<MassTextAlertEntryWhereInput>;
};

export type MassTextAlertEntryMaxAggregateOutputType = {
  __typename?: 'MassTextAlertEntryMaxAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryMaxOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertEntryMinAggregateOutputType = {
  __typename?: 'MassTextAlertEntryMinAggregateOutputType';
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryMinOrderByAggregateInput = {
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertEntryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type MassTextAlertEntryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MassTextAlertEntryOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentOrderByRelationAggregateInput>;
  massTextAlert?: Maybe<MassTextAlertOrderByWithRelationInput>;
  massTextAlertId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum MassTextAlertEntryOrderByRelevanceFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  Id = 'id',
  MassTextAlertId = 'massTextAlertId',
  PhoneNumber = 'phoneNumber'
}

export type MassTextAlertEntryOrderByRelevanceInput = {
  fields: Array<MassTextAlertEntryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type MassTextAlertEntryOrderByWithAggregationInput = {
  _count?: Maybe<MassTextAlertEntryCountOrderByAggregateInput>;
  _max?: Maybe<MassTextAlertEntryMaxOrderByAggregateInput>;
  _min?: Maybe<MassTextAlertEntryMinOrderByAggregateInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertEntryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MassTextAlertEntryOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentOrderByRelationAggregateInput>;
  massTextAlert?: Maybe<MassTextAlertOrderByWithRelationInput>;
  massTextAlertId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertEntryOrderByWithRelationInput = {
  _relevance?: Maybe<MassTextAlertEntryOrderByRelevanceInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentOrderByRelationAggregateInput>;
  massTextAlert?: Maybe<MassTextAlertOrderByWithRelationInput>;
  massTextAlertId?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum MassTextAlertEntryScalarFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Id = 'id',
  MassTextAlertId = 'massTextAlertId',
  PhoneNumber = 'phoneNumber',
  UpdatedAt = 'updatedAt'
}

export type MassTextAlertEntryScalarRelationFilter = {
  AND?: Maybe<Array<MassTextAlertEntryWhereInput>>;
  NOT?: Maybe<Array<MassTextAlertEntryWhereInput>>;
  OR?: Maybe<Array<MassTextAlertEntryWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentListRelationFilter>;
  massTextAlert?: Maybe<MassTextAlertScalarRelationFilter>;
  massTextAlertId?: Maybe<StringFilter>;
  phoneNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MassTextAlertEntryScalarWhereInput = {
  AND?: Maybe<Array<MassTextAlertEntryScalarWhereInput>>;
  NOT?: Maybe<Array<MassTextAlertEntryScalarWhereInput>>;
  OR?: Maybe<Array<MassTextAlertEntryScalarWhereInput>>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  massTextAlertId?: Maybe<StringFilter>;
  phoneNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MassTextAlertEntryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<MassTextAlertEntryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<MassTextAlertEntryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<MassTextAlertEntryScalarWhereWithAggregatesInput>>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  massTextAlertId?: Maybe<StringWithAggregatesFilter>;
  phoneNumber?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type MassTextAlertEntryUncheckedCreateInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutMassTextAlertEntryInput>;
  massTextAlertId: Scalars['String'];
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<MassTextAlertEntryCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<MassTextAlertEntryCreateManyClinicPetParentInputEnvelope>;
};

export type MassTextAlertEntryUncheckedCreateNestedManyWithoutMassTextAlertInput = {
  connect?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryCreateOrConnectWithoutMassTextAlertInput>>;
  create?: Maybe<Array<MassTextAlertEntryCreateWithoutMassTextAlertInput>>;
  createMany?: Maybe<MassTextAlertEntryCreateManyMassTextAlertInputEnvelope>;
};

export type MassTextAlertEntryUncheckedCreateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutMassTextAlertEntryInput>;
  massTextAlertId: Scalars['String'];
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUncheckedCreateWithoutMassAlertEntryAppointmentsInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertId: Scalars['String'];
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUncheckedCreateWithoutMassTextAlertInput = {
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedCreateNestedManyWithoutMassTextAlertEntryInput>;
  phoneNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUncheckedUpdateInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutMassTextAlertEntryNestedInput>;
  massTextAlertId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUncheckedUpdateManyInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<MassTextAlertEntryCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<MassTextAlertEntryCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MassTextAlertEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  set?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  update?: Maybe<Array<MassTextAlertEntryUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<MassTextAlertEntryUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<MassTextAlertEntryUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type MassTextAlertEntryUncheckedUpdateManyWithoutMassTextAlertInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUncheckedUpdateManyWithoutMassTextAlertNestedInput = {
  connect?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryCreateOrConnectWithoutMassTextAlertInput>>;
  create?: Maybe<Array<MassTextAlertEntryCreateWithoutMassTextAlertInput>>;
  createMany?: Maybe<MassTextAlertEntryCreateManyMassTextAlertInputEnvelope>;
  delete?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MassTextAlertEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  set?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  update?: Maybe<Array<MassTextAlertEntryUpdateWithWhereUniqueWithoutMassTextAlertInput>>;
  updateMany?: Maybe<Array<MassTextAlertEntryUpdateManyWithWhereWithoutMassTextAlertInput>>;
  upsert?: Maybe<Array<MassTextAlertEntryUpsertWithWhereUniqueWithoutMassTextAlertInput>>;
};

export type MassTextAlertEntryUncheckedUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutMassTextAlertEntryNestedInput>;
  massTextAlertId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUncheckedUpdateWithoutMassAlertEntryAppointmentsInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUncheckedUpdateWithoutMassTextAlertInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUncheckedUpdateManyWithoutMassTextAlertEntryNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUpdateInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutMassTextAlertEntriesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutMassTextAlertEntryNestedInput>;
  massTextAlert?: Maybe<MassTextAlertUpdateOneRequiredWithoutMassTextAlertEntriesNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: MassTextAlertEntryUpdateManyMutationInput;
  where: MassTextAlertEntryScalarWhereInput;
};

export type MassTextAlertEntryUpdateManyWithWhereWithoutMassTextAlertInput = {
  data: MassTextAlertEntryUpdateManyMutationInput;
  where: MassTextAlertEntryScalarWhereInput;
};

export type MassTextAlertEntryUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<MassTextAlertEntryCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<MassTextAlertEntryCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MassTextAlertEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  set?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  update?: Maybe<Array<MassTextAlertEntryUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<MassTextAlertEntryUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<MassTextAlertEntryUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type MassTextAlertEntryUpdateManyWithoutMassTextAlertNestedInput = {
  connect?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertEntryCreateOrConnectWithoutMassTextAlertInput>>;
  create?: Maybe<Array<MassTextAlertEntryCreateWithoutMassTextAlertInput>>;
  createMany?: Maybe<MassTextAlertEntryCreateManyMassTextAlertInputEnvelope>;
  delete?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MassTextAlertEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  set?: Maybe<Array<MassTextAlertEntryWhereUniqueInput>>;
  update?: Maybe<Array<MassTextAlertEntryUpdateWithWhereUniqueWithoutMassTextAlertInput>>;
  updateMany?: Maybe<Array<MassTextAlertEntryUpdateManyWithWhereWithoutMassTextAlertInput>>;
  upsert?: Maybe<Array<MassTextAlertEntryUpsertWithWhereUniqueWithoutMassTextAlertInput>>;
};

export type MassTextAlertEntryUpdateOneRequiredWithoutMassAlertEntryAppointmentsNestedInput = {
  connect?: Maybe<MassTextAlertEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<MassTextAlertEntryCreateOrConnectWithoutMassAlertEntryAppointmentsInput>;
  create?: Maybe<MassTextAlertEntryCreateWithoutMassAlertEntryAppointmentsInput>;
  update?: Maybe<MassTextAlertEntryUpdateToOneWithWhereWithoutMassAlertEntryAppointmentsInput>;
  upsert?: Maybe<MassTextAlertEntryUpsertWithoutMassAlertEntryAppointmentsInput>;
};

export type MassTextAlertEntryUpdateToOneWithWhereWithoutMassAlertEntryAppointmentsInput = {
  data: MassTextAlertEntryUpdateWithoutMassAlertEntryAppointmentsInput;
  where?: Maybe<MassTextAlertEntryWhereInput>;
};

export type MassTextAlertEntryUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: MassTextAlertEntryUpdateWithoutClinicPetParentInput;
  where: MassTextAlertEntryWhereUniqueInput;
};

export type MassTextAlertEntryUpdateWithWhereUniqueWithoutMassTextAlertInput = {
  data: MassTextAlertEntryUpdateWithoutMassTextAlertInput;
  where: MassTextAlertEntryWhereUniqueInput;
};

export type MassTextAlertEntryUpdateWithoutClinicPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutMassTextAlertEntryNestedInput>;
  massTextAlert?: Maybe<MassTextAlertUpdateOneRequiredWithoutMassTextAlertEntriesNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUpdateWithoutMassAlertEntryAppointmentsInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutMassTextAlertEntriesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlert?: Maybe<MassTextAlertUpdateOneRequiredWithoutMassTextAlertEntriesNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUpdateWithoutMassTextAlertInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutMassTextAlertEntriesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentUpdateManyWithoutMassTextAlertEntryNestedInput>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertEntryUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: MassTextAlertEntryCreateWithoutClinicPetParentInput;
  update: MassTextAlertEntryUpdateWithoutClinicPetParentInput;
  where: MassTextAlertEntryWhereUniqueInput;
};

export type MassTextAlertEntryUpsertWithWhereUniqueWithoutMassTextAlertInput = {
  create: MassTextAlertEntryCreateWithoutMassTextAlertInput;
  update: MassTextAlertEntryUpdateWithoutMassTextAlertInput;
  where: MassTextAlertEntryWhereUniqueInput;
};

export type MassTextAlertEntryUpsertWithoutMassAlertEntryAppointmentsInput = {
  create: MassTextAlertEntryCreateWithoutMassAlertEntryAppointmentsInput;
  update: MassTextAlertEntryUpdateWithoutMassAlertEntryAppointmentsInput;
  where?: Maybe<MassTextAlertEntryWhereInput>;
};

export type MassTextAlertEntryWhereInput = {
  AND?: Maybe<Array<MassTextAlertEntryWhereInput>>;
  NOT?: Maybe<Array<MassTextAlertEntryWhereInput>>;
  OR?: Maybe<Array<MassTextAlertEntryWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentListRelationFilter>;
  massTextAlert?: Maybe<MassTextAlertScalarRelationFilter>;
  massTextAlertId?: Maybe<StringFilter>;
  phoneNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MassTextAlertEntryWhereUniqueInput = {
  AND?: Maybe<Array<MassTextAlertEntryWhereInput>>;
  NOT?: Maybe<Array<MassTextAlertEntryWhereInput>>;
  OR?: Maybe<Array<MassTextAlertEntryWhereInput>>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  massAlertEntryAppointments?: Maybe<MassTextAlertEntryAppointmentListRelationFilter>;
  massTextAlert?: Maybe<MassTextAlertScalarRelationFilter>;
  massTextAlertId?: Maybe<StringFilter>;
  phoneNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MassTextAlertGroupByOutputType = {
  __typename?: 'MassTextAlertGroupByOutputType';
  _count?: Maybe<MassTextAlertCountAggregateOutputType>;
  _max?: Maybe<MassTextAlertMaxAggregateOutputType>;
  _min?: Maybe<MassTextAlertMinAggregateOutputType>;
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['String'];
  id: Scalars['String'];
  status: MassTextAlertStatus;
  updatedAt: Scalars['DateTime'];
};

export type MassTextAlertListRelationFilter = {
  every?: Maybe<MassTextAlertWhereInput>;
  none?: Maybe<MassTextAlertWhereInput>;
  some?: Maybe<MassTextAlertWhereInput>;
};

export type MassTextAlertMaxAggregateOutputType = {
  __typename?: 'MassTextAlertMaxAggregateOutputType';
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertMaxOrderByAggregateInput = {
  alertBody?: Maybe<SortOrder>;
  appointmentDateRangeType?: Maybe<SortOrder>;
  appointmentDateTimeFrom?: Maybe<SortOrder>;
  appointmentDateTimeTo?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertMinAggregateOutputType = {
  __typename?: 'MassTextAlertMinAggregateOutputType';
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertMinOrderByAggregateInput = {
  alertBody?: Maybe<SortOrder>;
  appointmentDateRangeType?: Maybe<SortOrder>;
  appointmentDateTimeFrom?: Maybe<SortOrder>;
  appointmentDateTimeTo?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type MassTextAlertOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MassTextAlertOrderByRelevanceInput>;
  alertBody?: Maybe<SortOrder>;
  appointmentDateRangeType?: Maybe<SortOrder>;
  appointmentDateTimeFrom?: Maybe<SortOrder>;
  appointmentDateTimeTo?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUser?: Maybe<UserOrderByWithRelationInput>;
  createdByUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum MassTextAlertOrderByRelevanceFieldEnum {
  AlertBody = 'alertBody',
  ClinicId = 'clinicId',
  CreatedByUserId = 'createdByUserId',
  Id = 'id'
}

export type MassTextAlertOrderByRelevanceInput = {
  fields: Array<MassTextAlertOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type MassTextAlertOrderByWithAggregationInput = {
  _count?: Maybe<MassTextAlertCountOrderByAggregateInput>;
  _max?: Maybe<MassTextAlertMaxOrderByAggregateInput>;
  _min?: Maybe<MassTextAlertMinOrderByAggregateInput>;
  alertBody?: Maybe<SortOrder>;
  appointmentDateRangeType?: Maybe<SortOrder>;
  appointmentDateTimeFrom?: Maybe<SortOrder>;
  appointmentDateTimeTo?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MassTextAlertOrderByRelevanceInput>;
  alertBody?: Maybe<SortOrder>;
  appointmentDateRangeType?: Maybe<SortOrder>;
  appointmentDateTimeFrom?: Maybe<SortOrder>;
  appointmentDateTimeTo?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUser?: Maybe<UserOrderByWithRelationInput>;
  createdByUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertOrderByWithRelationInput = {
  _relevance?: Maybe<MassTextAlertOrderByRelevanceInput>;
  alertBody?: Maybe<SortOrder>;
  appointmentDateRangeType?: Maybe<SortOrder>;
  appointmentDateTimeFrom?: Maybe<SortOrder>;
  appointmentDateTimeTo?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUser?: Maybe<UserOrderByWithRelationInput>;
  createdByUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MassTextAlertReportEntry = {
  __typename?: 'MassTextAlertReportEntry';
  errorDetails?: Maybe<Scalars['String']>;
  petParentFullName: Scalars['String'];
  phoneNumber: Scalars['String'];
  smsStatus?: Maybe<SmsNotificationStatusType>;
};

export enum MassTextAlertScalarFieldEnum {
  AlertBody = 'alertBody',
  AppointmentDateRangeType = 'appointmentDateRangeType',
  AppointmentDateTimeFrom = 'appointmentDateTimeFrom',
  AppointmentDateTimeTo = 'appointmentDateTimeTo',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  Id = 'id',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type MassTextAlertScalarRelationFilter = {
  AND?: Maybe<Array<MassTextAlertWhereInput>>;
  NOT?: Maybe<Array<MassTextAlertWhereInput>>;
  OR?: Maybe<Array<MassTextAlertWhereInput>>;
  alertBody?: Maybe<StringFilter>;
  appointmentDateRangeType?: Maybe<EnumAppointmentDateRangeTypeFilter>;
  appointmentDateTimeFrom?: Maybe<DateTimeFilter>;
  appointmentDateTimeTo?: Maybe<DateTimeFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUser?: Maybe<UserScalarRelationFilter>;
  createdByUserId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryListRelationFilter>;
  status?: Maybe<EnumMassTextAlertStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MassTextAlertScalarWhereInput = {
  AND?: Maybe<Array<MassTextAlertScalarWhereInput>>;
  NOT?: Maybe<Array<MassTextAlertScalarWhereInput>>;
  OR?: Maybe<Array<MassTextAlertScalarWhereInput>>;
  alertBody?: Maybe<StringFilter>;
  appointmentDateRangeType?: Maybe<EnumAppointmentDateRangeTypeFilter>;
  appointmentDateTimeFrom?: Maybe<DateTimeFilter>;
  appointmentDateTimeTo?: Maybe<DateTimeFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUserId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumMassTextAlertStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MassTextAlertScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<MassTextAlertScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<MassTextAlertScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<MassTextAlertScalarWhereWithAggregatesInput>>;
  alertBody?: Maybe<StringWithAggregatesFilter>;
  appointmentDateRangeType?: Maybe<EnumAppointmentDateRangeTypeWithAggregatesFilter>;
  appointmentDateTimeFrom?: Maybe<DateTimeWithAggregatesFilter>;
  appointmentDateTimeTo?: Maybe<DateTimeWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  createdByUserId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumMassTextAlertStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum MassTextAlertStatus {
  Processing = 'Processing',
  Sent = 'Sent'
}

export type MassTextAlertSubscription = {
  __typename?: 'MassTextAlertSubscription';
  mutation: MutationType;
  node: MassTextAlert;
};

export type MassTextAlertUncheckedCreateInput = {
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutMassTextAlertInput>;
  status: MassTextAlertStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<MassTextAlertCreateWithoutClinicInput>>;
  createMany?: Maybe<MassTextAlertCreateManyClinicInputEnvelope>;
};

export type MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput = {
  connect?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertCreateOrConnectWithoutCreatedByUserInput>>;
  create?: Maybe<Array<MassTextAlertCreateWithoutCreatedByUserInput>>;
  createMany?: Maybe<MassTextAlertCreateManyCreatedByUserInputEnvelope>;
};

export type MassTextAlertUncheckedCreateWithoutClinicInput = {
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutMassTextAlertInput>;
  status: MassTextAlertStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUncheckedCreateWithoutCreatedByUserInput = {
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedCreateNestedManyWithoutMassTextAlertInput>;
  status: MassTextAlertStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUncheckedCreateWithoutMassTextAlertEntriesInput = {
  alertBody: Scalars['String'];
  appointmentDateRangeType: AppointmentDateRangeType;
  appointmentDateTimeFrom: Scalars['DateTime'];
  appointmentDateTimeTo: Scalars['DateTime'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  status: MassTextAlertStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUncheckedUpdateInput = {
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutMassTextAlertNestedInput>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUncheckedUpdateManyInput = {
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUncheckedUpdateManyWithoutClinicInput = {
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<MassTextAlertCreateWithoutClinicInput>>;
  createMany?: Maybe<MassTextAlertCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MassTextAlertScalarWhereInput>>;
  disconnect?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  set?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  update?: Maybe<Array<MassTextAlertUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<MassTextAlertUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<MassTextAlertUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type MassTextAlertUncheckedUpdateManyWithoutCreatedByUserInput = {
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertCreateOrConnectWithoutCreatedByUserInput>>;
  create?: Maybe<Array<MassTextAlertCreateWithoutCreatedByUserInput>>;
  createMany?: Maybe<MassTextAlertCreateManyCreatedByUserInputEnvelope>;
  delete?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MassTextAlertScalarWhereInput>>;
  disconnect?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  set?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  update?: Maybe<Array<MassTextAlertUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: Maybe<Array<MassTextAlertUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: Maybe<Array<MassTextAlertUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type MassTextAlertUncheckedUpdateWithoutClinicInput = {
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutMassTextAlertNestedInput>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUncheckedUpdateWithoutCreatedByUserInput = {
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUncheckedUpdateManyWithoutMassTextAlertNestedInput>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUncheckedUpdateWithoutMassTextAlertEntriesInput = {
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUpdateInput = {
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutMassTextAlertsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneRequiredWithoutMassTextAlertsNestedInput>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutMassTextAlertNestedInput>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUpdateManyMutationInput = {
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUpdateManyWithWhereWithoutClinicInput = {
  data: MassTextAlertUpdateManyMutationInput;
  where: MassTextAlertScalarWhereInput;
};

export type MassTextAlertUpdateManyWithWhereWithoutCreatedByUserInput = {
  data: MassTextAlertUpdateManyMutationInput;
  where: MassTextAlertScalarWhereInput;
};

export type MassTextAlertUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<MassTextAlertCreateWithoutClinicInput>>;
  createMany?: Maybe<MassTextAlertCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MassTextAlertScalarWhereInput>>;
  disconnect?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  set?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  update?: Maybe<Array<MassTextAlertUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<MassTextAlertUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<MassTextAlertUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type MassTextAlertUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MassTextAlertCreateOrConnectWithoutCreatedByUserInput>>;
  create?: Maybe<Array<MassTextAlertCreateWithoutCreatedByUserInput>>;
  createMany?: Maybe<MassTextAlertCreateManyCreatedByUserInputEnvelope>;
  delete?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MassTextAlertScalarWhereInput>>;
  disconnect?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  set?: Maybe<Array<MassTextAlertWhereUniqueInput>>;
  update?: Maybe<Array<MassTextAlertUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: Maybe<Array<MassTextAlertUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: Maybe<Array<MassTextAlertUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type MassTextAlertUpdateOneRequiredWithoutMassTextAlertEntriesNestedInput = {
  connect?: Maybe<MassTextAlertWhereUniqueInput>;
  connectOrCreate?: Maybe<MassTextAlertCreateOrConnectWithoutMassTextAlertEntriesInput>;
  create?: Maybe<MassTextAlertCreateWithoutMassTextAlertEntriesInput>;
  update?: Maybe<MassTextAlertUpdateToOneWithWhereWithoutMassTextAlertEntriesInput>;
  upsert?: Maybe<MassTextAlertUpsertWithoutMassTextAlertEntriesInput>;
};

export type MassTextAlertUpdateToOneWithWhereWithoutMassTextAlertEntriesInput = {
  data: MassTextAlertUpdateWithoutMassTextAlertEntriesInput;
  where?: Maybe<MassTextAlertWhereInput>;
};

export type MassTextAlertUpdateWithWhereUniqueWithoutClinicInput = {
  data: MassTextAlertUpdateWithoutClinicInput;
  where: MassTextAlertWhereUniqueInput;
};

export type MassTextAlertUpdateWithWhereUniqueWithoutCreatedByUserInput = {
  data: MassTextAlertUpdateWithoutCreatedByUserInput;
  where: MassTextAlertWhereUniqueInput;
};

export type MassTextAlertUpdateWithoutClinicInput = {
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneRequiredWithoutMassTextAlertsNestedInput>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutMassTextAlertNestedInput>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUpdateWithoutCreatedByUserInput = {
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutMassTextAlertsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryUpdateManyWithoutMassTextAlertNestedInput>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUpdateWithoutMassTextAlertEntriesInput = {
  alertBody?: Maybe<Scalars['String']>;
  appointmentDateRangeType?: Maybe<AppointmentDateRangeType>;
  appointmentDateTimeFrom?: Maybe<Scalars['DateTime']>;
  appointmentDateTimeTo?: Maybe<Scalars['DateTime']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutMassTextAlertsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneRequiredWithoutMassTextAlertsNestedInput>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<MassTextAlertStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MassTextAlertUpsertWithWhereUniqueWithoutClinicInput = {
  create: MassTextAlertCreateWithoutClinicInput;
  update: MassTextAlertUpdateWithoutClinicInput;
  where: MassTextAlertWhereUniqueInput;
};

export type MassTextAlertUpsertWithWhereUniqueWithoutCreatedByUserInput = {
  create: MassTextAlertCreateWithoutCreatedByUserInput;
  update: MassTextAlertUpdateWithoutCreatedByUserInput;
  where: MassTextAlertWhereUniqueInput;
};

export type MassTextAlertUpsertWithoutMassTextAlertEntriesInput = {
  create: MassTextAlertCreateWithoutMassTextAlertEntriesInput;
  update: MassTextAlertUpdateWithoutMassTextAlertEntriesInput;
  where?: Maybe<MassTextAlertWhereInput>;
};

export type MassTextAlertWhereInput = {
  AND?: Maybe<Array<MassTextAlertWhereInput>>;
  NOT?: Maybe<Array<MassTextAlertWhereInput>>;
  OR?: Maybe<Array<MassTextAlertWhereInput>>;
  alertBody?: Maybe<StringFilter>;
  appointmentDateRangeType?: Maybe<EnumAppointmentDateRangeTypeFilter>;
  appointmentDateTimeFrom?: Maybe<DateTimeFilter>;
  appointmentDateTimeTo?: Maybe<DateTimeFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUser?: Maybe<UserScalarRelationFilter>;
  createdByUserId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryListRelationFilter>;
  status?: Maybe<EnumMassTextAlertStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MassTextAlertWhereUniqueInput = {
  AND?: Maybe<Array<MassTextAlertWhereInput>>;
  NOT?: Maybe<Array<MassTextAlertWhereInput>>;
  OR?: Maybe<Array<MassTextAlertWhereInput>>;
  alertBody?: Maybe<StringFilter>;
  appointmentDateRangeType?: Maybe<EnumAppointmentDateRangeTypeFilter>;
  appointmentDateTimeFrom?: Maybe<DateTimeFilter>;
  appointmentDateTimeTo?: Maybe<DateTimeFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUser?: Maybe<UserScalarRelationFilter>;
  createdByUserId?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  massTextAlertEntries?: Maybe<MassTextAlertEntryListRelationFilter>;
  status?: Maybe<EnumMassTextAlertStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Media = {
  __typename?: 'Media';
  _count: MediaCountOutputType;
  channelMessageAttachments: Array<ChannelMessageAttachment>;
  checksum: Scalars['String'];
  children: Array<Media>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPets: Array<ClinicPet>;
  createdAt: Scalars['DateTime'];
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  parent?: Maybe<Media>;
  parentMediaId?: Maybe<Scalars['String']>;
  products: Array<Product>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  users: Array<User>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};


export type MediaChannelMessageAttachmentsArgs = {
  cursor?: Maybe<ChannelMessageAttachmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageAttachmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageAttachmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageAttachmentWhereInput>;
};


export type MediaChildrenArgs = {
  cursor?: Maybe<MediaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MediaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MediaOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MediaWhereInput>;
};


export type MediaClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type MediaClinicPetsArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type MediaParentArgs = {
  where?: Maybe<MediaWhereInput>;
};


export type MediaProductsArgs = {
  cursor?: Maybe<ProductWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductWhereInput>;
};


export type MediaUsersArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};

export type MediaAvgAggregateOutputType = {
  __typename?: 'MediaAvgAggregateOutputType';
  durationInSeconds?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type MediaAvgOrderByAggregateInput = {
  durationInSeconds?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  sizeInMegabytes?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
};

export type MediaCountAggregateOutputType = {
  __typename?: 'MediaCountAggregateOutputType';
  _all: Scalars['Int'];
  checksum: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  durationInSeconds: Scalars['Int'];
  format: Scalars['Int'];
  height: Scalars['Int'];
  id: Scalars['Int'];
  parentMediaId: Scalars['Int'];
  properties: Scalars['Int'];
  s3Bucket: Scalars['Int'];
  s3Key: Scalars['Int'];
  sizeInMegabytes: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  url: Scalars['Int'];
  version: Scalars['Int'];
  width: Scalars['Int'];
};

export type MediaCountOrderByAggregateInput = {
  checksum?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  durationInSeconds?: Maybe<SortOrder>;
  format?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  parentMediaId?: Maybe<SortOrder>;
  properties?: Maybe<SortOrder>;
  s3Bucket?: Maybe<SortOrder>;
  s3Key?: Maybe<SortOrder>;
  sizeInMegabytes?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
};

export type MediaCountOutputType = {
  __typename?: 'MediaCountOutputType';
  channelMessageAttachments: Scalars['Int'];
  children: Scalars['Int'];
  clinicPets: Scalars['Int'];
  products: Scalars['Int'];
  users: Scalars['Int'];
};

export type MediaCreateInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  children?: Maybe<MediaCreateNestedManyWithoutParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutMediaInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaCreateNestedOneWithoutChildrenInput>;
  products?: Maybe<ProductCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaCreateManyClinicInput = {
  checksum: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaCreateManyClinicInputEnvelope = {
  data: Array<MediaCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MediaCreateManyInput = {
  checksum: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaCreateManyParentInput = {
  checksum: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaCreateManyParentInputEnvelope = {
  data: Array<MediaCreateManyParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MediaCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<MediaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MediaCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<MediaCreateWithoutClinicInput>>;
  createMany?: Maybe<MediaCreateManyClinicInputEnvelope>;
};

export type MediaCreateNestedManyWithoutParentInput = {
  connect?: Maybe<Array<MediaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MediaCreateOrConnectWithoutParentInput>>;
  create?: Maybe<Array<MediaCreateWithoutParentInput>>;
  createMany?: Maybe<MediaCreateManyParentInputEnvelope>;
};

export type MediaCreateNestedManyWithoutProductsInput = {
  connect?: Maybe<Array<MediaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MediaCreateOrConnectWithoutProductsInput>>;
  create?: Maybe<Array<MediaCreateWithoutProductsInput>>;
};

export type MediaCreateNestedOneWithoutChannelMessageAttachmentsInput = {
  connect?: Maybe<MediaWhereUniqueInput>;
  connectOrCreate?: Maybe<MediaCreateOrConnectWithoutChannelMessageAttachmentsInput>;
  create?: Maybe<MediaCreateWithoutChannelMessageAttachmentsInput>;
};

export type MediaCreateNestedOneWithoutChildrenInput = {
  connect?: Maybe<MediaWhereUniqueInput>;
  connectOrCreate?: Maybe<MediaCreateOrConnectWithoutChildrenInput>;
  create?: Maybe<MediaCreateWithoutChildrenInput>;
};

export type MediaCreateNestedOneWithoutClinicPetsInput = {
  connect?: Maybe<MediaWhereUniqueInput>;
  connectOrCreate?: Maybe<MediaCreateOrConnectWithoutClinicPetsInput>;
  create?: Maybe<MediaCreateWithoutClinicPetsInput>;
};

export type MediaCreateNestedOneWithoutUsersInput = {
  connect?: Maybe<MediaWhereUniqueInput>;
  connectOrCreate?: Maybe<MediaCreateOrConnectWithoutUsersInput>;
  create?: Maybe<MediaCreateWithoutUsersInput>;
};

export type MediaCreateOrConnectWithoutChannelMessageAttachmentsInput = {
  create: MediaCreateWithoutChannelMessageAttachmentsInput;
  where: MediaWhereUniqueInput;
};

export type MediaCreateOrConnectWithoutChildrenInput = {
  create: MediaCreateWithoutChildrenInput;
  where: MediaWhereUniqueInput;
};

export type MediaCreateOrConnectWithoutClinicInput = {
  create: MediaCreateWithoutClinicInput;
  where: MediaWhereUniqueInput;
};

export type MediaCreateOrConnectWithoutClinicPetsInput = {
  create: MediaCreateWithoutClinicPetsInput;
  where: MediaWhereUniqueInput;
};

export type MediaCreateOrConnectWithoutParentInput = {
  create: MediaCreateWithoutParentInput;
  where: MediaWhereUniqueInput;
};

export type MediaCreateOrConnectWithoutProductsInput = {
  create: MediaCreateWithoutProductsInput;
  where: MediaWhereUniqueInput;
};

export type MediaCreateOrConnectWithoutUsersInput = {
  create: MediaCreateWithoutUsersInput;
  where: MediaWhereUniqueInput;
};

export type MediaCreateWithoutChannelMessageAttachmentsInput = {
  checksum: Scalars['String'];
  children?: Maybe<MediaCreateNestedManyWithoutParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutMediaInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaCreateNestedOneWithoutChildrenInput>;
  products?: Maybe<ProductCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaCreateWithoutChildrenInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  clinic?: Maybe<ClinicCreateNestedOneWithoutMediaInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaCreateNestedOneWithoutChildrenInput>;
  products?: Maybe<ProductCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaCreateWithoutClinicInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  children?: Maybe<MediaCreateNestedManyWithoutParentInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaCreateNestedOneWithoutChildrenInput>;
  products?: Maybe<ProductCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaCreateWithoutClinicPetsInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  children?: Maybe<MediaCreateNestedManyWithoutParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaCreateNestedOneWithoutChildrenInput>;
  products?: Maybe<ProductCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaCreateWithoutParentInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  children?: Maybe<MediaCreateNestedManyWithoutParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutMediaInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<ProductCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaCreateWithoutProductsInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  children?: Maybe<MediaCreateNestedManyWithoutParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutMediaInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaCreateNestedOneWithoutChildrenInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaCreateWithoutUsersInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  children?: Maybe<MediaCreateNestedManyWithoutParentInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutMediaInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaCreateNestedOneWithoutChildrenInput>;
  products?: Maybe<ProductCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaGroupByOutputType = {
  __typename?: 'MediaGroupByOutputType';
  _avg?: Maybe<MediaAvgAggregateOutputType>;
  _count?: Maybe<MediaCountAggregateOutputType>;
  _max?: Maybe<MediaMaxAggregateOutputType>;
  _min?: Maybe<MediaMinAggregateOutputType>;
  _sum?: Maybe<MediaSumAggregateOutputType>;
  checksum: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  parentMediaId?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaListRelationFilter = {
  every?: Maybe<MediaWhereInput>;
  none?: Maybe<MediaWhereInput>;
  some?: Maybe<MediaWhereInput>;
};

export type MediaMaxAggregateOutputType = {
  __typename?: 'MediaMaxAggregateOutputType';
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaMaxOrderByAggregateInput = {
  checksum?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  durationInSeconds?: Maybe<SortOrder>;
  format?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  parentMediaId?: Maybe<SortOrder>;
  s3Bucket?: Maybe<SortOrder>;
  s3Key?: Maybe<SortOrder>;
  sizeInMegabytes?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
};

export type MediaMinAggregateOutputType = {
  __typename?: 'MediaMinAggregateOutputType';
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaMinOrderByAggregateInput = {
  checksum?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  durationInSeconds?: Maybe<SortOrder>;
  format?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  parentMediaId?: Maybe<SortOrder>;
  s3Bucket?: Maybe<SortOrder>;
  s3Key?: Maybe<SortOrder>;
  sizeInMegabytes?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
};

export type MediaNullableScalarRelationFilter = {
  AND?: Maybe<Array<MediaWhereInput>>;
  NOT?: Maybe<Array<MediaWhereInput>>;
  OR?: Maybe<Array<MediaWhereInput>>;
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentListRelationFilter>;
  checksum?: Maybe<StringFilter>;
  children?: Maybe<MediaListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  durationInSeconds?: Maybe<FloatNullableFilter>;
  format?: Maybe<StringFilter>;
  height?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  parent?: Maybe<MediaNullableScalarRelationFilter>;
  parentMediaId?: Maybe<StringNullableFilter>;
  products?: Maybe<ProductListRelationFilter>;
  properties?: Maybe<JsonNullableFilter>;
  s3Bucket?: Maybe<StringNullableFilter>;
  s3Key?: Maybe<StringNullableFilter>;
  sizeInMegabytes?: Maybe<FloatFilter>;
  type?: Maybe<EnumMediaTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
  users?: Maybe<UserListRelationFilter>;
  version?: Maybe<EnumMediaVersionFilter>;
  width?: Maybe<IntNullableFilter>;
};

export type MediaOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type MediaOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MediaOrderByRelevanceInput>;
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentOrderByRelationAggregateInput>;
  checksum?: Maybe<SortOrder>;
  children?: Maybe<MediaOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  durationInSeconds?: Maybe<SortOrder>;
  format?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  parent?: Maybe<MediaOrderByWithRelationInput>;
  parentMediaId?: Maybe<SortOrder>;
  products?: Maybe<ProductOrderByRelationAggregateInput>;
  properties?: Maybe<SortOrder>;
  s3Bucket?: Maybe<SortOrder>;
  s3Key?: Maybe<SortOrder>;
  sizeInMegabytes?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  users?: Maybe<UserOrderByRelationAggregateInput>;
  version?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
};

export enum MediaOrderByRelevanceFieldEnum {
  Checksum = 'checksum',
  ClinicId = 'clinicId',
  Format = 'format',
  Id = 'id',
  ParentMediaId = 'parentMediaId',
  S3Bucket = 's3Bucket',
  S3Key = 's3Key',
  Url = 'url'
}

export type MediaOrderByRelevanceInput = {
  fields: Array<MediaOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type MediaOrderByWithAggregationInput = {
  _avg?: Maybe<MediaAvgOrderByAggregateInput>;
  _count?: Maybe<MediaCountOrderByAggregateInput>;
  _max?: Maybe<MediaMaxOrderByAggregateInput>;
  _min?: Maybe<MediaMinOrderByAggregateInput>;
  _sum?: Maybe<MediaSumOrderByAggregateInput>;
  checksum?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  durationInSeconds?: Maybe<SortOrder>;
  format?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  parentMediaId?: Maybe<SortOrder>;
  properties?: Maybe<SortOrder>;
  s3Bucket?: Maybe<SortOrder>;
  s3Key?: Maybe<SortOrder>;
  sizeInMegabytes?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
};

export type MediaOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MediaOrderByRelevanceInput>;
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentOrderByRelationAggregateInput>;
  checksum?: Maybe<SortOrder>;
  children?: Maybe<MediaOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  durationInSeconds?: Maybe<SortOrder>;
  format?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  parent?: Maybe<MediaOrderByWithRelationInput>;
  parentMediaId?: Maybe<SortOrder>;
  products?: Maybe<ProductOrderByRelationAggregateInput>;
  properties?: Maybe<SortOrder>;
  s3Bucket?: Maybe<SortOrder>;
  s3Key?: Maybe<SortOrder>;
  sizeInMegabytes?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  users?: Maybe<UserOrderByRelationAggregateInput>;
  version?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
};

export type MediaOrderByWithRelationInput = {
  _relevance?: Maybe<MediaOrderByRelevanceInput>;
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentOrderByRelationAggregateInput>;
  checksum?: Maybe<SortOrder>;
  children?: Maybe<MediaOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  durationInSeconds?: Maybe<SortOrder>;
  format?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  parent?: Maybe<MediaOrderByWithRelationInput>;
  parentMediaId?: Maybe<SortOrder>;
  products?: Maybe<ProductOrderByRelationAggregateInput>;
  properties?: Maybe<SortOrder>;
  s3Bucket?: Maybe<SortOrder>;
  s3Key?: Maybe<SortOrder>;
  sizeInMegabytes?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
  users?: Maybe<UserOrderByRelationAggregateInput>;
  version?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
};

export enum MediaScalarFieldEnum {
  Checksum = 'checksum',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  DurationInSeconds = 'durationInSeconds',
  Format = 'format',
  Height = 'height',
  Id = 'id',
  ParentMediaId = 'parentMediaId',
  Properties = 'properties',
  S3Bucket = 's3Bucket',
  S3Key = 's3Key',
  SizeInMegabytes = 'sizeInMegabytes',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Url = 'url',
  Version = 'version',
  Width = 'width'
}

export type MediaScalarWhereInput = {
  AND?: Maybe<Array<MediaScalarWhereInput>>;
  NOT?: Maybe<Array<MediaScalarWhereInput>>;
  OR?: Maybe<Array<MediaScalarWhereInput>>;
  checksum?: Maybe<StringFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  durationInSeconds?: Maybe<FloatNullableFilter>;
  format?: Maybe<StringFilter>;
  height?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  parentMediaId?: Maybe<StringNullableFilter>;
  properties?: Maybe<JsonNullableFilter>;
  s3Bucket?: Maybe<StringNullableFilter>;
  s3Key?: Maybe<StringNullableFilter>;
  sizeInMegabytes?: Maybe<FloatFilter>;
  type?: Maybe<EnumMediaTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
  version?: Maybe<EnumMediaVersionFilter>;
  width?: Maybe<IntNullableFilter>;
};

export type MediaScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<MediaScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<MediaScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<MediaScalarWhereWithAggregatesInput>>;
  checksum?: Maybe<StringWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  durationInSeconds?: Maybe<FloatNullableWithAggregatesFilter>;
  format?: Maybe<StringWithAggregatesFilter>;
  height?: Maybe<IntNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  parentMediaId?: Maybe<StringNullableWithAggregatesFilter>;
  properties?: Maybe<JsonNullableWithAggregatesFilter>;
  s3Bucket?: Maybe<StringNullableWithAggregatesFilter>;
  s3Key?: Maybe<StringNullableWithAggregatesFilter>;
  sizeInMegabytes?: Maybe<FloatWithAggregatesFilter>;
  type?: Maybe<EnumMediaTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  url?: Maybe<StringWithAggregatesFilter>;
  version?: Maybe<EnumMediaVersionWithAggregatesFilter>;
  width?: Maybe<IntNullableWithAggregatesFilter>;
};

export type MediaSumAggregateOutputType = {
  __typename?: 'MediaSumAggregateOutputType';
  durationInSeconds?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Int']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaSumOrderByAggregateInput = {
  durationInSeconds?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  sizeInMegabytes?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
};

export enum MediaType {
  Audio = 'Audio',
  Image = 'Image',
  Video = 'Video'
}

export type MediaUncheckedCreateInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  children?: Maybe<MediaUncheckedCreateNestedManyWithoutParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserUncheckedCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<MediaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MediaCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<MediaCreateWithoutClinicInput>>;
  createMany?: Maybe<MediaCreateManyClinicInputEnvelope>;
};

export type MediaUncheckedCreateNestedManyWithoutParentInput = {
  connect?: Maybe<Array<MediaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MediaCreateOrConnectWithoutParentInput>>;
  create?: Maybe<Array<MediaCreateWithoutParentInput>>;
  createMany?: Maybe<MediaCreateManyParentInputEnvelope>;
};

export type MediaUncheckedCreateNestedManyWithoutProductsInput = {
  connect?: Maybe<Array<MediaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MediaCreateOrConnectWithoutProductsInput>>;
  create?: Maybe<Array<MediaCreateWithoutProductsInput>>;
};

export type MediaUncheckedCreateWithoutChannelMessageAttachmentsInput = {
  checksum: Scalars['String'];
  children?: Maybe<MediaUncheckedCreateNestedManyWithoutParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserUncheckedCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedCreateWithoutChildrenInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserUncheckedCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedCreateWithoutClinicInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  children?: Maybe<MediaUncheckedCreateNestedManyWithoutParentInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserUncheckedCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedCreateWithoutClinicPetsInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  children?: Maybe<MediaUncheckedCreateNestedManyWithoutParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserUncheckedCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedCreateWithoutParentInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  children?: Maybe<MediaUncheckedCreateNestedManyWithoutParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserUncheckedCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedCreateWithoutProductsInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  children?: Maybe<MediaUncheckedCreateNestedManyWithoutParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  users?: Maybe<UserUncheckedCreateNestedManyWithoutMediaInput>;
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedCreateWithoutUsersInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedCreateNestedManyWithoutMediaInput>;
  checksum: Scalars['String'];
  children?: Maybe<MediaUncheckedCreateNestedManyWithoutParentInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutMediaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedCreateNestedManyWithoutMediaInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes: Scalars['Float'];
  type: MediaType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  version: MediaVersion;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedUpdateInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUncheckedUpdateManyWithoutParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedUpdateManyInput = {
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedUpdateManyWithoutClinicInput = {
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<MediaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MediaCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<MediaCreateWithoutClinicInput>>;
  createMany?: Maybe<MediaCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<MediaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MediaScalarWhereInput>>;
  disconnect?: Maybe<Array<MediaWhereUniqueInput>>;
  set?: Maybe<Array<MediaWhereUniqueInput>>;
  update?: Maybe<Array<MediaUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<MediaUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<MediaUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type MediaUncheckedUpdateManyWithoutParentInput = {
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedUpdateManyWithoutParentNestedInput = {
  connect?: Maybe<Array<MediaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MediaCreateOrConnectWithoutParentInput>>;
  create?: Maybe<Array<MediaCreateWithoutParentInput>>;
  createMany?: Maybe<MediaCreateManyParentInputEnvelope>;
  delete?: Maybe<Array<MediaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MediaScalarWhereInput>>;
  disconnect?: Maybe<Array<MediaWhereUniqueInput>>;
  set?: Maybe<Array<MediaWhereUniqueInput>>;
  update?: Maybe<Array<MediaUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: Maybe<Array<MediaUpdateManyWithWhereWithoutParentInput>>;
  upsert?: Maybe<Array<MediaUpsertWithWhereUniqueWithoutParentInput>>;
};

export type MediaUncheckedUpdateManyWithoutProductsInput = {
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedUpdateManyWithoutProductsNestedInput = {
  connect?: Maybe<Array<MediaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MediaCreateOrConnectWithoutProductsInput>>;
  create?: Maybe<Array<MediaCreateWithoutProductsInput>>;
  delete?: Maybe<Array<MediaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MediaScalarWhereInput>>;
  disconnect?: Maybe<Array<MediaWhereUniqueInput>>;
  set?: Maybe<Array<MediaWhereUniqueInput>>;
  update?: Maybe<Array<MediaUpdateWithWhereUniqueWithoutProductsInput>>;
  updateMany?: Maybe<Array<MediaUpdateManyWithWhereWithoutProductsInput>>;
  upsert?: Maybe<Array<MediaUpsertWithWhereUniqueWithoutProductsInput>>;
};

export type MediaUncheckedUpdateWithoutChannelMessageAttachmentsInput = {
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUncheckedUpdateManyWithoutParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedUpdateWithoutChildrenInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedUpdateWithoutClinicInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUncheckedUpdateManyWithoutParentNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedUpdateWithoutClinicPetsInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUncheckedUpdateManyWithoutParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedUpdateWithoutParentInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUncheckedUpdateManyWithoutParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedUpdateWithoutProductsInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUncheckedUpdateManyWithoutParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUncheckedUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUncheckedUpdateWithoutUsersInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUncheckedUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUncheckedUpdateManyWithoutParentNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parentMediaId?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUncheckedUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUpdateInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUpdateManyWithoutParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutMediaNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaUpdateOneWithoutChildrenNestedInput>;
  products?: Maybe<ProductUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUpdateManyMutationInput = {
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUpdateManyWithWhereWithoutClinicInput = {
  data: MediaUpdateManyMutationInput;
  where: MediaScalarWhereInput;
};

export type MediaUpdateManyWithWhereWithoutParentInput = {
  data: MediaUpdateManyMutationInput;
  where: MediaScalarWhereInput;
};

export type MediaUpdateManyWithWhereWithoutProductsInput = {
  data: MediaUpdateManyMutationInput;
  where: MediaScalarWhereInput;
};

export type MediaUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<MediaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MediaCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<MediaCreateWithoutClinicInput>>;
  createMany?: Maybe<MediaCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<MediaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MediaScalarWhereInput>>;
  disconnect?: Maybe<Array<MediaWhereUniqueInput>>;
  set?: Maybe<Array<MediaWhereUniqueInput>>;
  update?: Maybe<Array<MediaUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<MediaUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<MediaUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type MediaUpdateManyWithoutParentNestedInput = {
  connect?: Maybe<Array<MediaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MediaCreateOrConnectWithoutParentInput>>;
  create?: Maybe<Array<MediaCreateWithoutParentInput>>;
  createMany?: Maybe<MediaCreateManyParentInputEnvelope>;
  delete?: Maybe<Array<MediaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MediaScalarWhereInput>>;
  disconnect?: Maybe<Array<MediaWhereUniqueInput>>;
  set?: Maybe<Array<MediaWhereUniqueInput>>;
  update?: Maybe<Array<MediaUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: Maybe<Array<MediaUpdateManyWithWhereWithoutParentInput>>;
  upsert?: Maybe<Array<MediaUpsertWithWhereUniqueWithoutParentInput>>;
};

export type MediaUpdateManyWithoutProductsNestedInput = {
  connect?: Maybe<Array<MediaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MediaCreateOrConnectWithoutProductsInput>>;
  create?: Maybe<Array<MediaCreateWithoutProductsInput>>;
  delete?: Maybe<Array<MediaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MediaScalarWhereInput>>;
  disconnect?: Maybe<Array<MediaWhereUniqueInput>>;
  set?: Maybe<Array<MediaWhereUniqueInput>>;
  update?: Maybe<Array<MediaUpdateWithWhereUniqueWithoutProductsInput>>;
  updateMany?: Maybe<Array<MediaUpdateManyWithWhereWithoutProductsInput>>;
  upsert?: Maybe<Array<MediaUpsertWithWhereUniqueWithoutProductsInput>>;
};

export type MediaUpdateOneWithoutChannelMessageAttachmentsNestedInput = {
  connect?: Maybe<MediaWhereUniqueInput>;
  connectOrCreate?: Maybe<MediaCreateOrConnectWithoutChannelMessageAttachmentsInput>;
  create?: Maybe<MediaCreateWithoutChannelMessageAttachmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<MediaUpdateToOneWithWhereWithoutChannelMessageAttachmentsInput>;
  upsert?: Maybe<MediaUpsertWithoutChannelMessageAttachmentsInput>;
};

export type MediaUpdateOneWithoutChildrenNestedInput = {
  connect?: Maybe<MediaWhereUniqueInput>;
  connectOrCreate?: Maybe<MediaCreateOrConnectWithoutChildrenInput>;
  create?: Maybe<MediaCreateWithoutChildrenInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<MediaUpdateToOneWithWhereWithoutChildrenInput>;
  upsert?: Maybe<MediaUpsertWithoutChildrenInput>;
};

export type MediaUpdateOneWithoutClinicPetsNestedInput = {
  connect?: Maybe<MediaWhereUniqueInput>;
  connectOrCreate?: Maybe<MediaCreateOrConnectWithoutClinicPetsInput>;
  create?: Maybe<MediaCreateWithoutClinicPetsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<MediaUpdateToOneWithWhereWithoutClinicPetsInput>;
  upsert?: Maybe<MediaUpsertWithoutClinicPetsInput>;
};

export type MediaUpdateOneWithoutUsersNestedInput = {
  connect?: Maybe<MediaWhereUniqueInput>;
  connectOrCreate?: Maybe<MediaCreateOrConnectWithoutUsersInput>;
  create?: Maybe<MediaCreateWithoutUsersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<MediaUpdateToOneWithWhereWithoutUsersInput>;
  upsert?: Maybe<MediaUpsertWithoutUsersInput>;
};

export type MediaUpdateToOneWithWhereWithoutChannelMessageAttachmentsInput = {
  data: MediaUpdateWithoutChannelMessageAttachmentsInput;
  where?: Maybe<MediaWhereInput>;
};

export type MediaUpdateToOneWithWhereWithoutChildrenInput = {
  data: MediaUpdateWithoutChildrenInput;
  where?: Maybe<MediaWhereInput>;
};

export type MediaUpdateToOneWithWhereWithoutClinicPetsInput = {
  data: MediaUpdateWithoutClinicPetsInput;
  where?: Maybe<MediaWhereInput>;
};

export type MediaUpdateToOneWithWhereWithoutUsersInput = {
  data: MediaUpdateWithoutUsersInput;
  where?: Maybe<MediaWhereInput>;
};

export type MediaUpdateWithWhereUniqueWithoutClinicInput = {
  data: MediaUpdateWithoutClinicInput;
  where: MediaWhereUniqueInput;
};

export type MediaUpdateWithWhereUniqueWithoutParentInput = {
  data: MediaUpdateWithoutParentInput;
  where: MediaWhereUniqueInput;
};

export type MediaUpdateWithWhereUniqueWithoutProductsInput = {
  data: MediaUpdateWithoutProductsInput;
  where: MediaWhereUniqueInput;
};

export type MediaUpdateWithoutChannelMessageAttachmentsInput = {
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUpdateManyWithoutParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutMediaNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaUpdateOneWithoutChildrenNestedInput>;
  products?: Maybe<ProductUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUpdateWithoutChildrenInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneWithoutMediaNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaUpdateOneWithoutChildrenNestedInput>;
  products?: Maybe<ProductUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUpdateWithoutClinicInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUpdateManyWithoutParentNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaUpdateOneWithoutChildrenNestedInput>;
  products?: Maybe<ProductUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUpdateWithoutClinicPetsInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUpdateManyWithoutParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaUpdateOneWithoutChildrenNestedInput>;
  products?: Maybe<ProductUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUpdateWithoutParentInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUpdateManyWithoutParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutMediaNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  products?: Maybe<ProductUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUpdateWithoutProductsInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUpdateManyWithoutParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutMediaNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaUpdateOneWithoutChildrenNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<UserUpdateManyWithoutMediaNestedInput>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUpdateWithoutUsersInput = {
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentUpdateManyWithoutMediaNestedInput>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaUpdateManyWithoutParentNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutMediaNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutMediaNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaUpdateOneWithoutChildrenNestedInput>;
  products?: Maybe<ProductUpdateManyWithoutMediaNestedInput>;
  properties?: Maybe<Scalars['Json']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sizeInMegabytes?: Maybe<Scalars['Float']>;
  type?: Maybe<MediaType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<MediaVersion>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaUpsertWithWhereUniqueWithoutClinicInput = {
  create: MediaCreateWithoutClinicInput;
  update: MediaUpdateWithoutClinicInput;
  where: MediaWhereUniqueInput;
};

export type MediaUpsertWithWhereUniqueWithoutParentInput = {
  create: MediaCreateWithoutParentInput;
  update: MediaUpdateWithoutParentInput;
  where: MediaWhereUniqueInput;
};

export type MediaUpsertWithWhereUniqueWithoutProductsInput = {
  create: MediaCreateWithoutProductsInput;
  update: MediaUpdateWithoutProductsInput;
  where: MediaWhereUniqueInput;
};

export type MediaUpsertWithoutChannelMessageAttachmentsInput = {
  create: MediaCreateWithoutChannelMessageAttachmentsInput;
  update: MediaUpdateWithoutChannelMessageAttachmentsInput;
  where?: Maybe<MediaWhereInput>;
};

export type MediaUpsertWithoutChildrenInput = {
  create: MediaCreateWithoutChildrenInput;
  update: MediaUpdateWithoutChildrenInput;
  where?: Maybe<MediaWhereInput>;
};

export type MediaUpsertWithoutClinicPetsInput = {
  create: MediaCreateWithoutClinicPetsInput;
  update: MediaUpdateWithoutClinicPetsInput;
  where?: Maybe<MediaWhereInput>;
};

export type MediaUpsertWithoutUsersInput = {
  create: MediaCreateWithoutUsersInput;
  update: MediaUpdateWithoutUsersInput;
  where?: Maybe<MediaWhereInput>;
};

export enum MediaVersion {
  Derived = 'Derived',
  Large = 'Large',
  Medium = 'Medium',
  Original = 'Original',
  Small = 'Small',
  Thumbnail = 'Thumbnail'
}

export type MediaWhereInput = {
  AND?: Maybe<Array<MediaWhereInput>>;
  NOT?: Maybe<Array<MediaWhereInput>>;
  OR?: Maybe<Array<MediaWhereInput>>;
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentListRelationFilter>;
  checksum?: Maybe<StringFilter>;
  children?: Maybe<MediaListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  durationInSeconds?: Maybe<FloatNullableFilter>;
  format?: Maybe<StringFilter>;
  height?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  parent?: Maybe<MediaNullableScalarRelationFilter>;
  parentMediaId?: Maybe<StringNullableFilter>;
  products?: Maybe<ProductListRelationFilter>;
  properties?: Maybe<JsonNullableFilter>;
  s3Bucket?: Maybe<StringNullableFilter>;
  s3Key?: Maybe<StringNullableFilter>;
  sizeInMegabytes?: Maybe<FloatFilter>;
  type?: Maybe<EnumMediaTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
  users?: Maybe<UserListRelationFilter>;
  version?: Maybe<EnumMediaVersionFilter>;
  width?: Maybe<IntNullableFilter>;
};

export type MediaWhereUniqueInput = {
  AND?: Maybe<Array<MediaWhereInput>>;
  NOT?: Maybe<Array<MediaWhereInput>>;
  OR?: Maybe<Array<MediaWhereInput>>;
  channelMessageAttachments?: Maybe<ChannelMessageAttachmentListRelationFilter>;
  checksum?: Maybe<Scalars['String']>;
  children?: Maybe<MediaListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  durationInSeconds?: Maybe<FloatNullableFilter>;
  format?: Maybe<StringFilter>;
  height?: Maybe<IntNullableFilter>;
  id?: Maybe<Scalars['String']>;
  parent?: Maybe<MediaNullableScalarRelationFilter>;
  parentMediaId?: Maybe<StringNullableFilter>;
  products?: Maybe<ProductListRelationFilter>;
  properties?: Maybe<JsonNullableFilter>;
  s3Bucket?: Maybe<StringNullableFilter>;
  s3Key?: Maybe<StringNullableFilter>;
  sizeInMegabytes?: Maybe<FloatFilter>;
  type?: Maybe<EnumMediaTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
  users?: Maybe<UserListRelationFilter>;
  version?: Maybe<EnumMediaVersionFilter>;
  width?: Maybe<IntNullableFilter>;
};

export type MedicalHistory = {
  __typename?: 'MedicalHistory';
  clinicEmployee?: Maybe<ClinicEmployee>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<Service>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type MedicalHistoryClinicEmployeeArgs = {
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type MedicalHistoryClinicPetArgs = {
  where?: Maybe<ClinicPetWhereInput>;
};


export type MedicalHistoryIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type MedicalHistoryServiceArgs = {
  where?: Maybe<ServiceWhereInput>;
};

export type MedicalHistoryCountAggregateOutputType = {
  __typename?: 'MedicalHistoryCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicEmployeeId: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  comments: Scalars['Int'];
  createdAt: Scalars['Int'];
  details: Scalars['Int'];
  historyDate: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isDeclined: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isPending: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  serviceId: Scalars['Int'];
  shortDescription: Scalars['Int'];
  siteId: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MedicalHistoryCountOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  historyDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeclined?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPending?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MedicalHistoryCreateInput = {
  clinicEmployee?: Maybe<ClinicEmployeeCreateNestedOneWithoutMedicalHistoryInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutMedicalHistoryInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutMedicalHistoryInput>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceCreateNestedOneWithoutMedicalHistoryInput>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryCreateManyClinicEmployeeInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryCreateManyClinicEmployeeInputEnvelope = {
  data: Array<MedicalHistoryCreateManyClinicEmployeeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MedicalHistoryCreateManyClinicPetInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryCreateManyClinicPetInputEnvelope = {
  data: Array<MedicalHistoryCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MedicalHistoryCreateManyInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryCreateManyIntegrationInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryCreateManyIntegrationInputEnvelope = {
  data: Array<MedicalHistoryCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MedicalHistoryCreateManyServiceInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryCreateManyServiceInputEnvelope = {
  data: Array<MedicalHistoryCreateManyServiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MedicalHistoryCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyClinicEmployeeInputEnvelope>;
};

export type MedicalHistoryCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutClinicPetInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyClinicPetInputEnvelope>;
};

export type MedicalHistoryCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyIntegrationInputEnvelope>;
};

export type MedicalHistoryCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutServiceInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyServiceInputEnvelope>;
};

export type MedicalHistoryCreateOrConnectWithoutClinicEmployeeInput = {
  create: MedicalHistoryCreateWithoutClinicEmployeeInput;
  where: MedicalHistoryWhereUniqueInput;
};

export type MedicalHistoryCreateOrConnectWithoutClinicPetInput = {
  create: MedicalHistoryCreateWithoutClinicPetInput;
  where: MedicalHistoryWhereUniqueInput;
};

export type MedicalHistoryCreateOrConnectWithoutIntegrationInput = {
  create: MedicalHistoryCreateWithoutIntegrationInput;
  where: MedicalHistoryWhereUniqueInput;
};

export type MedicalHistoryCreateOrConnectWithoutServiceInput = {
  create: MedicalHistoryCreateWithoutServiceInput;
  where: MedicalHistoryWhereUniqueInput;
};

export type MedicalHistoryCreateWithoutClinicEmployeeInput = {
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutMedicalHistoryInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutMedicalHistoryInput>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceCreateNestedOneWithoutMedicalHistoryInput>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryCreateWithoutClinicPetInput = {
  clinicEmployee?: Maybe<ClinicEmployeeCreateNestedOneWithoutMedicalHistoryInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutMedicalHistoryInput>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceCreateNestedOneWithoutMedicalHistoryInput>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryCreateWithoutIntegrationInput = {
  clinicEmployee?: Maybe<ClinicEmployeeCreateNestedOneWithoutMedicalHistoryInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutMedicalHistoryInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceCreateNestedOneWithoutMedicalHistoryInput>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryCreateWithoutServiceInput = {
  clinicEmployee?: Maybe<ClinicEmployeeCreateNestedOneWithoutMedicalHistoryInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutMedicalHistoryInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutMedicalHistoryInput>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryGroupByOutputType = {
  __typename?: 'MedicalHistoryGroupByOutputType';
  _count?: Maybe<MedicalHistoryCountAggregateOutputType>;
  _max?: Maybe<MedicalHistoryMaxAggregateOutputType>;
  _min?: Maybe<MedicalHistoryMinAggregateOutputType>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type MedicalHistoryListRelationFilter = {
  every?: Maybe<MedicalHistoryWhereInput>;
  none?: Maybe<MedicalHistoryWhereInput>;
  some?: Maybe<MedicalHistoryWhereInput>;
};

export type MedicalHistoryMaxAggregateOutputType = {
  __typename?: 'MedicalHistoryMaxAggregateOutputType';
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryMaxOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  historyDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeclined?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPending?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MedicalHistoryMedicalHistoryPimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type MedicalHistoryMinAggregateOutputType = {
  __typename?: 'MedicalHistoryMinAggregateOutputType';
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryMinOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  historyDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeclined?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPending?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MedicalHistoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type MedicalHistoryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MedicalHistoryOrderByRelevanceInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  historyDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeclined?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPending?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum MedicalHistoryOrderByRelevanceFieldEnum {
  ClinicEmployeeId = 'clinicEmployeeId',
  ClinicPetId = 'clinicPetId',
  Comments = 'comments',
  Details = 'details',
  Id = 'id',
  IntegrationId = 'integrationId',
  PimsId = 'pimsId',
  ServiceId = 'serviceId',
  ShortDescription = 'shortDescription',
  SiteId = 'siteId',
  Type = 'type'
}

export type MedicalHistoryOrderByRelevanceInput = {
  fields: Array<MedicalHistoryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type MedicalHistoryOrderByWithAggregationInput = {
  _count?: Maybe<MedicalHistoryCountOrderByAggregateInput>;
  _max?: Maybe<MedicalHistoryMaxOrderByAggregateInput>;
  _min?: Maybe<MedicalHistoryMinOrderByAggregateInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  historyDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeclined?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPending?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MedicalHistoryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MedicalHistoryOrderByRelevanceInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  historyDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeclined?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPending?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MedicalHistoryOrderByWithRelationInput = {
  _relevance?: Maybe<MedicalHistoryOrderByRelevanceInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  historyDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeclined?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPending?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum MedicalHistoryScalarFieldEnum {
  ClinicEmployeeId = 'clinicEmployeeId',
  ClinicPetId = 'clinicPetId',
  Comments = 'comments',
  CreatedAt = 'createdAt',
  Details = 'details',
  HistoryDate = 'historyDate',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsDeclined = 'isDeclined',
  IsDeleted = 'isDeleted',
  IsPending = 'isPending',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  ServiceId = 'serviceId',
  ShortDescription = 'shortDescription',
  SiteId = 'siteId',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type MedicalHistoryScalarWhereInput = {
  AND?: Maybe<Array<MedicalHistoryScalarWhereInput>>;
  NOT?: Maybe<Array<MedicalHistoryScalarWhereInput>>;
  OR?: Maybe<Array<MedicalHistoryScalarWhereInput>>;
  clinicEmployeeId?: Maybe<StringNullableFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  comments?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  details?: Maybe<StringNullableFilter>;
  historyDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeclined?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isPending?: Maybe<BoolNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  serviceId?: Maybe<StringNullableFilter>;
  shortDescription?: Maybe<StringNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MedicalHistoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<MedicalHistoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<MedicalHistoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<MedicalHistoryScalarWhereWithAggregatesInput>>;
  clinicEmployeeId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetId?: Maybe<StringNullableWithAggregatesFilter>;
  comments?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  details?: Maybe<StringNullableWithAggregatesFilter>;
  historyDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  isDeclined?: Maybe<BoolNullableWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  isPending?: Maybe<BoolNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  serviceId?: Maybe<StringNullableWithAggregatesFilter>;
  shortDescription?: Maybe<StringNullableWithAggregatesFilter>;
  siteId?: Maybe<StringNullableWithAggregatesFilter>;
  type?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type MedicalHistoryUncheckedCreateInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyClinicEmployeeInputEnvelope>;
};

export type MedicalHistoryUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutClinicPetInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyClinicPetInputEnvelope>;
};

export type MedicalHistoryUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyIntegrationInputEnvelope>;
};

export type MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutServiceInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyServiceInputEnvelope>;
};

export type MedicalHistoryUncheckedCreateWithoutClinicEmployeeInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedCreateWithoutClinicPetInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedCreateWithoutIntegrationInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedCreateWithoutServiceInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedUpdateInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedUpdateManyInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MedicalHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  set?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  update?: Maybe<Array<MedicalHistoryUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<MedicalHistoryUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<MedicalHistoryUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type MedicalHistoryUncheckedUpdateManyWithoutClinicPetInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutClinicPetInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MedicalHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  set?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  update?: Maybe<Array<MedicalHistoryUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<MedicalHistoryUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<MedicalHistoryUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type MedicalHistoryUncheckedUpdateManyWithoutIntegrationInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MedicalHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  set?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  update?: Maybe<Array<MedicalHistoryUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<MedicalHistoryUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<MedicalHistoryUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type MedicalHistoryUncheckedUpdateManyWithoutServiceInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutServiceInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MedicalHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  set?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  update?: Maybe<Array<MedicalHistoryUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<MedicalHistoryUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<MedicalHistoryUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type MedicalHistoryUncheckedUpdateWithoutClinicEmployeeInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedUpdateWithoutClinicPetInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedUpdateWithoutIntegrationInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUncheckedUpdateWithoutServiceInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUpdateInput = {
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneWithoutMedicalHistoryNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutMedicalHistoryNestedInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutMedicalHistoryNestedInput>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceUpdateOneWithoutMedicalHistoryNestedInput>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUpdateManyMutationInput = {
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUpdateManyWithWhereWithoutClinicEmployeeInput = {
  data: MedicalHistoryUpdateManyMutationInput;
  where: MedicalHistoryScalarWhereInput;
};

export type MedicalHistoryUpdateManyWithWhereWithoutClinicPetInput = {
  data: MedicalHistoryUpdateManyMutationInput;
  where: MedicalHistoryScalarWhereInput;
};

export type MedicalHistoryUpdateManyWithWhereWithoutIntegrationInput = {
  data: MedicalHistoryUpdateManyMutationInput;
  where: MedicalHistoryScalarWhereInput;
};

export type MedicalHistoryUpdateManyWithWhereWithoutServiceInput = {
  data: MedicalHistoryUpdateManyMutationInput;
  where: MedicalHistoryScalarWhereInput;
};

export type MedicalHistoryUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MedicalHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  set?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  update?: Maybe<Array<MedicalHistoryUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<MedicalHistoryUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<MedicalHistoryUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type MedicalHistoryUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutClinicPetInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MedicalHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  set?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  update?: Maybe<Array<MedicalHistoryUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<MedicalHistoryUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<MedicalHistoryUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type MedicalHistoryUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MedicalHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  set?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  update?: Maybe<Array<MedicalHistoryUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<MedicalHistoryUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<MedicalHistoryUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type MedicalHistoryUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MedicalHistoryCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<MedicalHistoryCreateWithoutServiceInput>>;
  createMany?: Maybe<MedicalHistoryCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MedicalHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  set?: Maybe<Array<MedicalHistoryWhereUniqueInput>>;
  update?: Maybe<Array<MedicalHistoryUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<MedicalHistoryUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<MedicalHistoryUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type MedicalHistoryUpdateWithWhereUniqueWithoutClinicEmployeeInput = {
  data: MedicalHistoryUpdateWithoutClinicEmployeeInput;
  where: MedicalHistoryWhereUniqueInput;
};

export type MedicalHistoryUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: MedicalHistoryUpdateWithoutClinicPetInput;
  where: MedicalHistoryWhereUniqueInput;
};

export type MedicalHistoryUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: MedicalHistoryUpdateWithoutIntegrationInput;
  where: MedicalHistoryWhereUniqueInput;
};

export type MedicalHistoryUpdateWithWhereUniqueWithoutServiceInput = {
  data: MedicalHistoryUpdateWithoutServiceInput;
  where: MedicalHistoryWhereUniqueInput;
};

export type MedicalHistoryUpdateWithoutClinicEmployeeInput = {
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutMedicalHistoryNestedInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutMedicalHistoryNestedInput>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceUpdateOneWithoutMedicalHistoryNestedInput>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUpdateWithoutClinicPetInput = {
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneWithoutMedicalHistoryNestedInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutMedicalHistoryNestedInput>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceUpdateOneWithoutMedicalHistoryNestedInput>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUpdateWithoutIntegrationInput = {
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneWithoutMedicalHistoryNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutMedicalHistoryNestedInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceUpdateOneWithoutMedicalHistoryNestedInput>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUpdateWithoutServiceInput = {
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneWithoutMedicalHistoryNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutMedicalHistoryNestedInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  historyDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutMedicalHistoryNestedInput>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalHistoryUpsertWithWhereUniqueWithoutClinicEmployeeInput = {
  create: MedicalHistoryCreateWithoutClinicEmployeeInput;
  update: MedicalHistoryUpdateWithoutClinicEmployeeInput;
  where: MedicalHistoryWhereUniqueInput;
};

export type MedicalHistoryUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: MedicalHistoryCreateWithoutClinicPetInput;
  update: MedicalHistoryUpdateWithoutClinicPetInput;
  where: MedicalHistoryWhereUniqueInput;
};

export type MedicalHistoryUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: MedicalHistoryCreateWithoutIntegrationInput;
  update: MedicalHistoryUpdateWithoutIntegrationInput;
  where: MedicalHistoryWhereUniqueInput;
};

export type MedicalHistoryUpsertWithWhereUniqueWithoutServiceInput = {
  create: MedicalHistoryCreateWithoutServiceInput;
  update: MedicalHistoryUpdateWithoutServiceInput;
  where: MedicalHistoryWhereUniqueInput;
};

export type MedicalHistoryWhereInput = {
  AND?: Maybe<Array<MedicalHistoryWhereInput>>;
  NOT?: Maybe<Array<MedicalHistoryWhereInput>>;
  OR?: Maybe<Array<MedicalHistoryWhereInput>>;
  clinicEmployee?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringNullableFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  comments?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  details?: Maybe<StringNullableFilter>;
  historyDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeclined?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isPending?: Maybe<BoolNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  service?: Maybe<ServiceNullableScalarRelationFilter>;
  serviceId?: Maybe<StringNullableFilter>;
  shortDescription?: Maybe<StringNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MedicalHistoryWhereUniqueInput = {
  AND?: Maybe<Array<MedicalHistoryWhereInput>>;
  NOT?: Maybe<Array<MedicalHistoryWhereInput>>;
  OR?: Maybe<Array<MedicalHistoryWhereInput>>;
  clinicEmployee?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringNullableFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  comments?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  details?: Maybe<StringNullableFilter>;
  historyDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isDeclined?: Maybe<BoolNullableFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isPending?: Maybe<BoolNullableFilter>;
  medicalHistoryPimsIdAndIntegrationId?: Maybe<MedicalHistoryMedicalHistoryPimsIdAndIntegrationIdCompoundUniqueInput>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  service?: Maybe<ServiceNullableScalarRelationFilter>;
  serviceId?: Maybe<StringNullableFilter>;
  shortDescription?: Maybe<StringNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  type?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MergePetParentInput = {
  clinicId: Scalars['String'];
  deleteId: Scalars['String'];
  keepId: Scalars['String'];
  update?: Maybe<ClinicPetParentUpdateInput>;
};

export type MergePetParentResult = {
  __typename?: 'MergePetParentResult';
  messages?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type MessageEventResponse = {
  __typename?: 'MessageEventResponse';
  callRecordingId?: Maybe<Scalars['String']>;
  jobChainId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum MessageSource {
  Sms = 'Sms',
  Web = 'Web'
}

export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  attachments: Scalars['Json'];
  body: Scalars['String'];
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  type: MessageTemplateType;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
};


export type MessageTemplateUpdatedByArgs = {
  where?: Maybe<UserWhereInput>;
};

export type MessageTemplateCountAggregateOutputType = {
  __typename?: 'MessageTemplateCountAggregateOutputType';
  _all: Scalars['Int'];
  attachments: Scalars['Int'];
  body: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isArchived: Scalars['Int'];
  name: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  updatedById: Scalars['Int'];
};

export type MessageTemplateCountOrderByAggregateInput = {
  attachments?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isArchived?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedById?: Maybe<SortOrder>;
};

export type MessageTemplateCreateInput = {
  attachments?: Maybe<Scalars['Json']>;
  body: Scalars['String'];
  clinic: ClinicCreateNestedOneWithoutMessageTemplatesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserCreateNestedOneWithoutMessageTemplatesInput>;
};

export type MessageTemplateCreateManyClinicInput = {
  attachments?: Maybe<Scalars['Json']>;
  body: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type MessageTemplateCreateManyClinicInputEnvelope = {
  data: Array<MessageTemplateCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MessageTemplateCreateManyInput = {
  attachments?: Maybe<Scalars['Json']>;
  body: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type MessageTemplateCreateManyUpdatedByInput = {
  attachments?: Maybe<Scalars['Json']>;
  body: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageTemplateCreateManyUpdatedByInputEnvelope = {
  data: Array<MessageTemplateCreateManyUpdatedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MessageTemplateCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MessageTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<MessageTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<MessageTemplateCreateManyClinicInputEnvelope>;
};

export type MessageTemplateCreateNestedManyWithoutUpdatedByInput = {
  connect?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MessageTemplateCreateOrConnectWithoutUpdatedByInput>>;
  create?: Maybe<Array<MessageTemplateCreateWithoutUpdatedByInput>>;
  createMany?: Maybe<MessageTemplateCreateManyUpdatedByInputEnvelope>;
};

export type MessageTemplateCreateOrConnectWithoutClinicInput = {
  create: MessageTemplateCreateWithoutClinicInput;
  where: MessageTemplateWhereUniqueInput;
};

export type MessageTemplateCreateOrConnectWithoutUpdatedByInput = {
  create: MessageTemplateCreateWithoutUpdatedByInput;
  where: MessageTemplateWhereUniqueInput;
};

export type MessageTemplateCreateWithoutClinicInput = {
  attachments?: Maybe<Scalars['Json']>;
  body: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserCreateNestedOneWithoutMessageTemplatesInput>;
};

export type MessageTemplateCreateWithoutUpdatedByInput = {
  attachments?: Maybe<Scalars['Json']>;
  body: Scalars['String'];
  clinic: ClinicCreateNestedOneWithoutMessageTemplatesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageTemplateGroupByOutputType = {
  __typename?: 'MessageTemplateGroupByOutputType';
  _count?: Maybe<MessageTemplateCountAggregateOutputType>;
  _max?: Maybe<MessageTemplateMaxAggregateOutputType>;
  _min?: Maybe<MessageTemplateMinAggregateOutputType>;
  attachments: Scalars['Json'];
  body: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  type: MessageTemplateType;
  updatedAt: Scalars['DateTime'];
  updatedById?: Maybe<Scalars['String']>;
};

export type MessageTemplateListRelationFilter = {
  every?: Maybe<MessageTemplateWhereInput>;
  none?: Maybe<MessageTemplateWhereInput>;
  some?: Maybe<MessageTemplateWhereInput>;
};

export type MessageTemplateMaxAggregateOutputType = {
  __typename?: 'MessageTemplateMaxAggregateOutputType';
  body?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type MessageTemplateMaxOrderByAggregateInput = {
  body?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isArchived?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedById?: Maybe<SortOrder>;
};

export type MessageTemplateMinAggregateOutputType = {
  __typename?: 'MessageTemplateMinAggregateOutputType';
  body?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type MessageTemplateMinOrderByAggregateInput = {
  body?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isArchived?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedById?: Maybe<SortOrder>;
};

export type MessageTemplateOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type MessageTemplateOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MessageTemplateOrderByRelevanceInput>;
  attachments?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isArchived?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedBy?: Maybe<UserOrderByWithRelationInput>;
  updatedById?: Maybe<SortOrder>;
};

export enum MessageTemplateOrderByRelevanceFieldEnum {
  Body = 'body',
  ClinicId = 'clinicId',
  Id = 'id',
  Name = 'name',
  UpdatedById = 'updatedById'
}

export type MessageTemplateOrderByRelevanceInput = {
  fields: Array<MessageTemplateOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type MessageTemplateOrderByWithAggregationInput = {
  _count?: Maybe<MessageTemplateCountOrderByAggregateInput>;
  _max?: Maybe<MessageTemplateMaxOrderByAggregateInput>;
  _min?: Maybe<MessageTemplateMinOrderByAggregateInput>;
  attachments?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isArchived?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedById?: Maybe<SortOrder>;
};

export type MessageTemplateOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MessageTemplateOrderByRelevanceInput>;
  attachments?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isArchived?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedBy?: Maybe<UserOrderByWithRelationInput>;
  updatedById?: Maybe<SortOrder>;
};

export type MessageTemplateOrderByWithRelationInput = {
  _relevance?: Maybe<MessageTemplateOrderByRelevanceInput>;
  attachments?: Maybe<SortOrder>;
  body?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isArchived?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedBy?: Maybe<UserOrderByWithRelationInput>;
  updatedById?: Maybe<SortOrder>;
};

export enum MessageTemplateScalarFieldEnum {
  Attachments = 'attachments',
  Body = 'body',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsArchived = 'isArchived',
  Name = 'name',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UpdatedById = 'updatedById'
}

export type MessageTemplateScalarWhereInput = {
  AND?: Maybe<Array<MessageTemplateScalarWhereInput>>;
  NOT?: Maybe<Array<MessageTemplateScalarWhereInput>>;
  OR?: Maybe<Array<MessageTemplateScalarWhereInput>>;
  attachments?: Maybe<JsonFilter>;
  body?: Maybe<StringFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isArchived?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<EnumMessageTemplateTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  updatedById?: Maybe<StringNullableFilter>;
};

export type MessageTemplateScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<MessageTemplateScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<MessageTemplateScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<MessageTemplateScalarWhereWithAggregatesInput>>;
  attachments?: Maybe<JsonWithAggregatesFilter>;
  body?: Maybe<StringWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isArchived?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumMessageTemplateTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  updatedById?: Maybe<StringNullableWithAggregatesFilter>;
};

export enum MessageTemplateType {
  CareCreditPreapproval = 'CareCreditPreapproval',
  Default = 'Default'
}

export type MessageTemplateUncheckedCreateInput = {
  attachments?: Maybe<Scalars['Json']>;
  body: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type MessageTemplateUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MessageTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<MessageTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<MessageTemplateCreateManyClinicInputEnvelope>;
};

export type MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput = {
  connect?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MessageTemplateCreateOrConnectWithoutUpdatedByInput>>;
  create?: Maybe<Array<MessageTemplateCreateWithoutUpdatedByInput>>;
  createMany?: Maybe<MessageTemplateCreateManyUpdatedByInputEnvelope>;
};

export type MessageTemplateUncheckedCreateWithoutClinicInput = {
  attachments?: Maybe<Scalars['Json']>;
  body: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type MessageTemplateUncheckedCreateWithoutUpdatedByInput = {
  attachments?: Maybe<Scalars['Json']>;
  body: Scalars['String'];
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageTemplateUncheckedUpdateInput = {
  attachments?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type MessageTemplateUncheckedUpdateManyInput = {
  attachments?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type MessageTemplateUncheckedUpdateManyWithoutClinicInput = {
  attachments?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type MessageTemplateUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MessageTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<MessageTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<MessageTemplateCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MessageTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  set?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  update?: Maybe<Array<MessageTemplateUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<MessageTemplateUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<MessageTemplateUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type MessageTemplateUncheckedUpdateManyWithoutUpdatedByInput = {
  attachments?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput = {
  connect?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MessageTemplateCreateOrConnectWithoutUpdatedByInput>>;
  create?: Maybe<Array<MessageTemplateCreateWithoutUpdatedByInput>>;
  createMany?: Maybe<MessageTemplateCreateManyUpdatedByInputEnvelope>;
  delete?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MessageTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  set?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  update?: Maybe<Array<MessageTemplateUpdateWithWhereUniqueWithoutUpdatedByInput>>;
  updateMany?: Maybe<Array<MessageTemplateUpdateManyWithWhereWithoutUpdatedByInput>>;
  upsert?: Maybe<Array<MessageTemplateUpsertWithWhereUniqueWithoutUpdatedByInput>>;
};

export type MessageTemplateUncheckedUpdateWithoutClinicInput = {
  attachments?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['String']>;
};

export type MessageTemplateUncheckedUpdateWithoutUpdatedByInput = {
  attachments?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageTemplateUpdateInput = {
  attachments?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutMessageTemplatesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserUpdateOneWithoutMessageTemplatesNestedInput>;
};

export type MessageTemplateUpdateManyMutationInput = {
  attachments?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageTemplateUpdateManyWithWhereWithoutClinicInput = {
  data: MessageTemplateUpdateManyMutationInput;
  where: MessageTemplateScalarWhereInput;
};

export type MessageTemplateUpdateManyWithWhereWithoutUpdatedByInput = {
  data: MessageTemplateUpdateManyMutationInput;
  where: MessageTemplateScalarWhereInput;
};

export type MessageTemplateUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MessageTemplateCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<MessageTemplateCreateWithoutClinicInput>>;
  createMany?: Maybe<MessageTemplateCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MessageTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  set?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  update?: Maybe<Array<MessageTemplateUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<MessageTemplateUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<MessageTemplateUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type MessageTemplateUpdateManyWithoutUpdatedByNestedInput = {
  connect?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MessageTemplateCreateOrConnectWithoutUpdatedByInput>>;
  create?: Maybe<Array<MessageTemplateCreateWithoutUpdatedByInput>>;
  createMany?: Maybe<MessageTemplateCreateManyUpdatedByInputEnvelope>;
  delete?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MessageTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  set?: Maybe<Array<MessageTemplateWhereUniqueInput>>;
  update?: Maybe<Array<MessageTemplateUpdateWithWhereUniqueWithoutUpdatedByInput>>;
  updateMany?: Maybe<Array<MessageTemplateUpdateManyWithWhereWithoutUpdatedByInput>>;
  upsert?: Maybe<Array<MessageTemplateUpsertWithWhereUniqueWithoutUpdatedByInput>>;
};

export type MessageTemplateUpdateWithWhereUniqueWithoutClinicInput = {
  data: MessageTemplateUpdateWithoutClinicInput;
  where: MessageTemplateWhereUniqueInput;
};

export type MessageTemplateUpdateWithWhereUniqueWithoutUpdatedByInput = {
  data: MessageTemplateUpdateWithoutUpdatedByInput;
  where: MessageTemplateWhereUniqueInput;
};

export type MessageTemplateUpdateWithoutClinicInput = {
  attachments?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserUpdateOneWithoutMessageTemplatesNestedInput>;
};

export type MessageTemplateUpdateWithoutUpdatedByInput = {
  attachments?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutMessageTemplatesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MessageTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageTemplateUpsertWithWhereUniqueWithoutClinicInput = {
  create: MessageTemplateCreateWithoutClinicInput;
  update: MessageTemplateUpdateWithoutClinicInput;
  where: MessageTemplateWhereUniqueInput;
};

export type MessageTemplateUpsertWithWhereUniqueWithoutUpdatedByInput = {
  create: MessageTemplateCreateWithoutUpdatedByInput;
  update: MessageTemplateUpdateWithoutUpdatedByInput;
  where: MessageTemplateWhereUniqueInput;
};

export type MessageTemplateWhereInput = {
  AND?: Maybe<Array<MessageTemplateWhereInput>>;
  NOT?: Maybe<Array<MessageTemplateWhereInput>>;
  OR?: Maybe<Array<MessageTemplateWhereInput>>;
  attachments?: Maybe<JsonFilter>;
  body?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isArchived?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<EnumMessageTemplateTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  updatedBy?: Maybe<UserNullableScalarRelationFilter>;
  updatedById?: Maybe<StringNullableFilter>;
};

export type MessageTemplateWhereUniqueInput = {
  AND?: Maybe<Array<MessageTemplateWhereInput>>;
  NOT?: Maybe<Array<MessageTemplateWhereInput>>;
  OR?: Maybe<Array<MessageTemplateWhereInput>>;
  attachments?: Maybe<JsonFilter>;
  body?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<EnumMessageTemplateTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  updatedBy?: Maybe<UserNullableScalarRelationFilter>;
  updatedById?: Maybe<StringNullableFilter>;
};

export enum MessageType {
  Message = 'Message',
  Note = 'Note'
}

export type MessagingCampaign = {
  __typename?: 'MessagingCampaign';
  _count: MessagingCampaignCountOutputType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  messagingPartner: MessagingPartner;
  messagingPartnerId: Scalars['String'];
  name: Scalars['String'];
  status: MessagingCampaignStatus;
  type: MessagingCampaignType;
  updatedAt: Scalars['DateTime'];
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
  workflowEventSettings: Array<WorkflowEventSetting>;
};


export type MessagingCampaignWorkflowEventSettingsArgs = {
  cursor?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type MessagingCampaignCountAggregateOutputType = {
  __typename?: 'MessagingCampaignCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  messagingPartnerId: Scalars['Int'];
  name: Scalars['Int'];
  status: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  workflowEventSettingTemplate: Scalars['Int'];
};

export type MessagingCampaignCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingTemplate?: Maybe<SortOrder>;
};

export type MessagingCampaignCountOutputType = {
  __typename?: 'MessagingCampaignCountOutputType';
  workflowEventSettings: Scalars['Int'];
};

export type MessagingCampaignCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingPartner: MessagingPartnerCreateNestedOneWithoutMessagingCampaignsInput;
  name: Scalars['String'];
  status: MessagingCampaignStatus;
  type: MessagingCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutMessagingCampaignInput>;
};

export type MessagingCampaignCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingPartnerId: Scalars['String'];
  name: Scalars['String'];
  status: MessagingCampaignStatus;
  type: MessagingCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
};

export type MessagingCampaignCreateManyMessagingPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: MessagingCampaignStatus;
  type: MessagingCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
};

export type MessagingCampaignCreateManyMessagingPartnerInputEnvelope = {
  data: Array<MessagingCampaignCreateManyMessagingPartnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MessagingCampaignCreateNestedManyWithoutMessagingPartnerInput = {
  connect?: Maybe<Array<MessagingCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MessagingCampaignCreateOrConnectWithoutMessagingPartnerInput>>;
  create?: Maybe<Array<MessagingCampaignCreateWithoutMessagingPartnerInput>>;
  createMany?: Maybe<MessagingCampaignCreateManyMessagingPartnerInputEnvelope>;
};

export type MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput = {
  connect?: Maybe<MessagingCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<MessagingCampaignCreateOrConnectWithoutWorkflowEventSettingsInput>;
  create?: Maybe<MessagingCampaignCreateWithoutWorkflowEventSettingsInput>;
};

export type MessagingCampaignCreateOrConnectWithoutMessagingPartnerInput = {
  create: MessagingCampaignCreateWithoutMessagingPartnerInput;
  where: MessagingCampaignWhereUniqueInput;
};

export type MessagingCampaignCreateOrConnectWithoutWorkflowEventSettingsInput = {
  create: MessagingCampaignCreateWithoutWorkflowEventSettingsInput;
  where: MessagingCampaignWhereUniqueInput;
};

export type MessagingCampaignCreateWithoutMessagingPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: MessagingCampaignStatus;
  type: MessagingCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutMessagingCampaignInput>;
};

export type MessagingCampaignCreateWithoutWorkflowEventSettingsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingPartner: MessagingPartnerCreateNestedOneWithoutMessagingCampaignsInput;
  name: Scalars['String'];
  status: MessagingCampaignStatus;
  type: MessagingCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
};

export type MessagingCampaignGroupByOutputType = {
  __typename?: 'MessagingCampaignGroupByOutputType';
  _count?: Maybe<MessagingCampaignCountAggregateOutputType>;
  _max?: Maybe<MessagingCampaignMaxAggregateOutputType>;
  _min?: Maybe<MessagingCampaignMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  messagingPartnerId: Scalars['String'];
  name: Scalars['String'];
  status: MessagingCampaignStatus;
  type: MessagingCampaignType;
  updatedAt: Scalars['DateTime'];
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
};

export type MessagingCampaignListRelationFilter = {
  every?: Maybe<MessagingCampaignWhereInput>;
  none?: Maybe<MessagingCampaignWhereInput>;
  some?: Maybe<MessagingCampaignWhereInput>;
};

export type MessagingCampaignMaxAggregateOutputType = {
  __typename?: 'MessagingCampaignMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<MessagingCampaignStatus>;
  type?: Maybe<MessagingCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingCampaignMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MessagingCampaignMinAggregateOutputType = {
  __typename?: 'MessagingCampaignMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<MessagingCampaignStatus>;
  type?: Maybe<MessagingCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingCampaignMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MessagingCampaignNullableScalarRelationFilter = {
  AND?: Maybe<Array<MessagingCampaignWhereInput>>;
  NOT?: Maybe<Array<MessagingCampaignWhereInput>>;
  OR?: Maybe<Array<MessagingCampaignWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  messagingPartner?: Maybe<MessagingPartnerScalarRelationFilter>;
  messagingPartnerId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<EnumMessagingCampaignStatusFilter>;
  type?: Maybe<EnumMessagingCampaignTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSettingTemplate?: Maybe<JsonNullableFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type MessagingCampaignOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type MessagingCampaignOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MessagingCampaignOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingPartner?: Maybe<MessagingPartnerOrderByWithRelationInput>;
  messagingPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingTemplate?: Maybe<SortOrder>;
  workflowEventSettings?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum MessagingCampaignOrderByRelevanceFieldEnum {
  Id = 'id',
  MessagingPartnerId = 'messagingPartnerId',
  Name = 'name'
}

export type MessagingCampaignOrderByRelevanceInput = {
  fields: Array<MessagingCampaignOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type MessagingCampaignOrderByWithAggregationInput = {
  _count?: Maybe<MessagingCampaignCountOrderByAggregateInput>;
  _max?: Maybe<MessagingCampaignMaxOrderByAggregateInput>;
  _min?: Maybe<MessagingCampaignMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingTemplate?: Maybe<SortOrder>;
};

export type MessagingCampaignOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MessagingCampaignOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingPartner?: Maybe<MessagingPartnerOrderByWithRelationInput>;
  messagingPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingTemplate?: Maybe<SortOrder>;
  workflowEventSettings?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export type MessagingCampaignOrderByWithRelationInput = {
  _relevance?: Maybe<MessagingCampaignOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingPartner?: Maybe<MessagingPartnerOrderByWithRelationInput>;
  messagingPartnerId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingTemplate?: Maybe<SortOrder>;
  workflowEventSettings?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum MessagingCampaignScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  MessagingPartnerId = 'messagingPartnerId',
  Name = 'name',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  WorkflowEventSettingTemplate = 'workflowEventSettingTemplate'
}

export type MessagingCampaignScalarWhereInput = {
  AND?: Maybe<Array<MessagingCampaignScalarWhereInput>>;
  NOT?: Maybe<Array<MessagingCampaignScalarWhereInput>>;
  OR?: Maybe<Array<MessagingCampaignScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  messagingPartnerId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<EnumMessagingCampaignStatusFilter>;
  type?: Maybe<EnumMessagingCampaignTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSettingTemplate?: Maybe<JsonNullableFilter>;
};

export type MessagingCampaignScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<MessagingCampaignScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<MessagingCampaignScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<MessagingCampaignScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  messagingPartnerId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumMessagingCampaignStatusWithAggregatesFilter>;
  type?: Maybe<EnumMessagingCampaignTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  workflowEventSettingTemplate?: Maybe<JsonNullableWithAggregatesFilter>;
};

export enum MessagingCampaignStatus {
  Active = 'Active',
  Paused = 'Paused'
}

export enum MessagingCampaignType {
  Automation = 'Automation'
}

export type MessagingCampaignUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingPartnerId: Scalars['String'];
  name: Scalars['String'];
  status: MessagingCampaignStatus;
  type: MessagingCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutMessagingCampaignInput>;
};

export type MessagingCampaignUncheckedCreateNestedManyWithoutMessagingPartnerInput = {
  connect?: Maybe<Array<MessagingCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MessagingCampaignCreateOrConnectWithoutMessagingPartnerInput>>;
  create?: Maybe<Array<MessagingCampaignCreateWithoutMessagingPartnerInput>>;
  createMany?: Maybe<MessagingCampaignCreateManyMessagingPartnerInputEnvelope>;
};

export type MessagingCampaignUncheckedCreateWithoutMessagingPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: MessagingCampaignStatus;
  type: MessagingCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutMessagingCampaignInput>;
};

export type MessagingCampaignUncheckedCreateWithoutWorkflowEventSettingsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingPartnerId: Scalars['String'];
  name: Scalars['String'];
  status: MessagingCampaignStatus;
  type: MessagingCampaignType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
};

export type MessagingCampaignUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<MessagingCampaignStatus>;
  type?: Maybe<MessagingCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutMessagingCampaignNestedInput>;
};

export type MessagingCampaignUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<MessagingCampaignStatus>;
  type?: Maybe<MessagingCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
};

export type MessagingCampaignUncheckedUpdateManyWithoutMessagingPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<MessagingCampaignStatus>;
  type?: Maybe<MessagingCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
};

export type MessagingCampaignUncheckedUpdateManyWithoutMessagingPartnerNestedInput = {
  connect?: Maybe<Array<MessagingCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MessagingCampaignCreateOrConnectWithoutMessagingPartnerInput>>;
  create?: Maybe<Array<MessagingCampaignCreateWithoutMessagingPartnerInput>>;
  createMany?: Maybe<MessagingCampaignCreateManyMessagingPartnerInputEnvelope>;
  delete?: Maybe<Array<MessagingCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MessagingCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<MessagingCampaignWhereUniqueInput>>;
  set?: Maybe<Array<MessagingCampaignWhereUniqueInput>>;
  update?: Maybe<Array<MessagingCampaignUpdateWithWhereUniqueWithoutMessagingPartnerInput>>;
  updateMany?: Maybe<Array<MessagingCampaignUpdateManyWithWhereWithoutMessagingPartnerInput>>;
  upsert?: Maybe<Array<MessagingCampaignUpsertWithWhereUniqueWithoutMessagingPartnerInput>>;
};

export type MessagingCampaignUncheckedUpdateWithoutMessagingPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<MessagingCampaignStatus>;
  type?: Maybe<MessagingCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutMessagingCampaignNestedInput>;
};

export type MessagingCampaignUncheckedUpdateWithoutWorkflowEventSettingsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingPartnerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<MessagingCampaignStatus>;
  type?: Maybe<MessagingCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
};

export type MessagingCampaignUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingPartner?: Maybe<MessagingPartnerUpdateOneRequiredWithoutMessagingCampaignsNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<MessagingCampaignStatus>;
  type?: Maybe<MessagingCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutMessagingCampaignNestedInput>;
};

export type MessagingCampaignUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<MessagingCampaignStatus>;
  type?: Maybe<MessagingCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
};

export type MessagingCampaignUpdateManyWithWhereWithoutMessagingPartnerInput = {
  data: MessagingCampaignUpdateManyMutationInput;
  where: MessagingCampaignScalarWhereInput;
};

export type MessagingCampaignUpdateManyWithoutMessagingPartnerNestedInput = {
  connect?: Maybe<Array<MessagingCampaignWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MessagingCampaignCreateOrConnectWithoutMessagingPartnerInput>>;
  create?: Maybe<Array<MessagingCampaignCreateWithoutMessagingPartnerInput>>;
  createMany?: Maybe<MessagingCampaignCreateManyMessagingPartnerInputEnvelope>;
  delete?: Maybe<Array<MessagingCampaignWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MessagingCampaignScalarWhereInput>>;
  disconnect?: Maybe<Array<MessagingCampaignWhereUniqueInput>>;
  set?: Maybe<Array<MessagingCampaignWhereUniqueInput>>;
  update?: Maybe<Array<MessagingCampaignUpdateWithWhereUniqueWithoutMessagingPartnerInput>>;
  updateMany?: Maybe<Array<MessagingCampaignUpdateManyWithWhereWithoutMessagingPartnerInput>>;
  upsert?: Maybe<Array<MessagingCampaignUpsertWithWhereUniqueWithoutMessagingPartnerInput>>;
};

export type MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput = {
  connect?: Maybe<MessagingCampaignWhereUniqueInput>;
  connectOrCreate?: Maybe<MessagingCampaignCreateOrConnectWithoutWorkflowEventSettingsInput>;
  create?: Maybe<MessagingCampaignCreateWithoutWorkflowEventSettingsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<MessagingCampaignUpdateToOneWithWhereWithoutWorkflowEventSettingsInput>;
  upsert?: Maybe<MessagingCampaignUpsertWithoutWorkflowEventSettingsInput>;
};

export type MessagingCampaignUpdateToOneWithWhereWithoutWorkflowEventSettingsInput = {
  data: MessagingCampaignUpdateWithoutWorkflowEventSettingsInput;
  where?: Maybe<MessagingCampaignWhereInput>;
};

export type MessagingCampaignUpdateWithWhereUniqueWithoutMessagingPartnerInput = {
  data: MessagingCampaignUpdateWithoutMessagingPartnerInput;
  where: MessagingCampaignWhereUniqueInput;
};

export type MessagingCampaignUpdateWithoutMessagingPartnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<MessagingCampaignStatus>;
  type?: Maybe<MessagingCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutMessagingCampaignNestedInput>;
};

export type MessagingCampaignUpdateWithoutWorkflowEventSettingsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingPartner?: Maybe<MessagingPartnerUpdateOneRequiredWithoutMessagingCampaignsNestedInput>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<MessagingCampaignStatus>;
  type?: Maybe<MessagingCampaignType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingTemplate?: Maybe<Scalars['Json']>;
};

export type MessagingCampaignUpsertWithWhereUniqueWithoutMessagingPartnerInput = {
  create: MessagingCampaignCreateWithoutMessagingPartnerInput;
  update: MessagingCampaignUpdateWithoutMessagingPartnerInput;
  where: MessagingCampaignWhereUniqueInput;
};

export type MessagingCampaignUpsertWithoutWorkflowEventSettingsInput = {
  create: MessagingCampaignCreateWithoutWorkflowEventSettingsInput;
  update: MessagingCampaignUpdateWithoutWorkflowEventSettingsInput;
  where?: Maybe<MessagingCampaignWhereInput>;
};

export type MessagingCampaignWhereInput = {
  AND?: Maybe<Array<MessagingCampaignWhereInput>>;
  NOT?: Maybe<Array<MessagingCampaignWhereInput>>;
  OR?: Maybe<Array<MessagingCampaignWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  messagingPartner?: Maybe<MessagingPartnerScalarRelationFilter>;
  messagingPartnerId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<EnumMessagingCampaignStatusFilter>;
  type?: Maybe<EnumMessagingCampaignTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSettingTemplate?: Maybe<JsonNullableFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type MessagingCampaignWhereUniqueInput = {
  AND?: Maybe<Array<MessagingCampaignWhereInput>>;
  NOT?: Maybe<Array<MessagingCampaignWhereInput>>;
  OR?: Maybe<Array<MessagingCampaignWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  messagingPartner?: Maybe<MessagingPartnerScalarRelationFilter>;
  messagingPartnerId?: Maybe<StringFilter>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<EnumMessagingCampaignStatusFilter>;
  type?: Maybe<EnumMessagingCampaignTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSettingTemplate?: Maybe<JsonNullableFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type MessagingPartner = {
  __typename?: 'MessagingPartner';
  _count: MessagingPartnerCountOutputType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  messagingCampaigns: Array<MessagingCampaign>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type MessagingPartnerMessagingCampaignsArgs = {
  cursor?: Maybe<MessagingCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MessagingCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MessagingCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessagingCampaignWhereInput>;
};

export type MessagingPartnerCountAggregateOutputType = {
  __typename?: 'MessagingPartnerCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MessagingPartnerCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MessagingPartnerCountOutputType = {
  __typename?: 'MessagingPartnerCountOutputType';
  messagingCampaigns: Scalars['Int'];
};

export type MessagingPartnerCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingCampaigns?: Maybe<MessagingCampaignCreateNestedManyWithoutMessagingPartnerInput>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerCreateNestedOneWithoutMessagingCampaignsInput = {
  connect?: Maybe<MessagingPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<MessagingPartnerCreateOrConnectWithoutMessagingCampaignsInput>;
  create?: Maybe<MessagingPartnerCreateWithoutMessagingCampaignsInput>;
};

export type MessagingPartnerCreateOrConnectWithoutMessagingCampaignsInput = {
  create: MessagingPartnerCreateWithoutMessagingCampaignsInput;
  where: MessagingPartnerWhereUniqueInput;
};

export type MessagingPartnerCreateWithoutMessagingCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerGroupByOutputType = {
  __typename?: 'MessagingPartnerGroupByOutputType';
  _count?: Maybe<MessagingPartnerCountAggregateOutputType>;
  _max?: Maybe<MessagingPartnerMaxAggregateOutputType>;
  _min?: Maybe<MessagingPartnerMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type MessagingPartnerMaxAggregateOutputType = {
  __typename?: 'MessagingPartnerMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MessagingPartnerMinAggregateOutputType = {
  __typename?: 'MessagingPartnerMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MessagingPartnerOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MessagingPartnerOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingCampaigns?: Maybe<MessagingCampaignOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum MessagingPartnerOrderByRelevanceFieldEnum {
  Id = 'id',
  Name = 'name'
}

export type MessagingPartnerOrderByRelevanceInput = {
  fields: Array<MessagingPartnerOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type MessagingPartnerOrderByWithAggregationInput = {
  _count?: Maybe<MessagingPartnerCountOrderByAggregateInput>;
  _max?: Maybe<MessagingPartnerMaxOrderByAggregateInput>;
  _min?: Maybe<MessagingPartnerMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MessagingPartnerOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<MessagingPartnerOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingCampaigns?: Maybe<MessagingCampaignOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MessagingPartnerOrderByWithRelationInput = {
  _relevance?: Maybe<MessagingPartnerOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingCampaigns?: Maybe<MessagingCampaignOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum MessagingPartnerScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type MessagingPartnerScalarRelationFilter = {
  AND?: Maybe<Array<MessagingPartnerWhereInput>>;
  NOT?: Maybe<Array<MessagingPartnerWhereInput>>;
  OR?: Maybe<Array<MessagingPartnerWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  messagingCampaigns?: Maybe<MessagingCampaignListRelationFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MessagingPartnerScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<MessagingPartnerScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<MessagingPartnerScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<MessagingPartnerScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type MessagingPartnerUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingCampaigns?: Maybe<MessagingCampaignUncheckedCreateNestedManyWithoutMessagingPartnerInput>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerUncheckedCreateWithoutMessagingCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingCampaigns?: Maybe<MessagingCampaignUncheckedUpdateManyWithoutMessagingPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerUncheckedUpdateWithoutMessagingCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingCampaigns?: Maybe<MessagingCampaignUpdateManyWithoutMessagingPartnerNestedInput>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerUpdateOneRequiredWithoutMessagingCampaignsNestedInput = {
  connect?: Maybe<MessagingPartnerWhereUniqueInput>;
  connectOrCreate?: Maybe<MessagingPartnerCreateOrConnectWithoutMessagingCampaignsInput>;
  create?: Maybe<MessagingPartnerCreateWithoutMessagingCampaignsInput>;
  update?: Maybe<MessagingPartnerUpdateToOneWithWhereWithoutMessagingCampaignsInput>;
  upsert?: Maybe<MessagingPartnerUpsertWithoutMessagingCampaignsInput>;
};

export type MessagingPartnerUpdateToOneWithWhereWithoutMessagingCampaignsInput = {
  data: MessagingPartnerUpdateWithoutMessagingCampaignsInput;
  where?: Maybe<MessagingPartnerWhereInput>;
};

export type MessagingPartnerUpdateWithoutMessagingCampaignsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessagingPartnerUpsertWithoutMessagingCampaignsInput = {
  create: MessagingPartnerCreateWithoutMessagingCampaignsInput;
  update: MessagingPartnerUpdateWithoutMessagingCampaignsInput;
  where?: Maybe<MessagingPartnerWhereInput>;
};

export type MessagingPartnerWhereInput = {
  AND?: Maybe<Array<MessagingPartnerWhereInput>>;
  NOT?: Maybe<Array<MessagingPartnerWhereInput>>;
  OR?: Maybe<Array<MessagingPartnerWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  messagingCampaigns?: Maybe<MessagingCampaignListRelationFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type MessagingPartnerWhereUniqueInput = {
  AND?: Maybe<Array<MessagingPartnerWhereInput>>;
  NOT?: Maybe<Array<MessagingPartnerWhereInput>>;
  OR?: Maybe<Array<MessagingPartnerWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  messagingCampaigns?: Maybe<MessagingCampaignListRelationFilter>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum MissedCallMessageResponseStatus {
  All = 'All',
  Disabled = 'Disabled',
  PetParentsOnly = 'PetParentsOnly'
}

export type Module = {
  __typename?: 'Module';
  _count: ModuleCountOutputType;
  clinicModules: Array<ClinicModule>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  productPackages: Array<ProductPackage>;
  updatedAt: Scalars['DateTime'];
};


export type ModuleClinicModulesArgs = {
  cursor?: Maybe<ClinicModuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicModuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicModuleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicModuleWhereInput>;
};


export type ModuleProductPackagesArgs = {
  cursor?: Maybe<ProductPackageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductPackageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductPackageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductPackageWhereInput>;
};

export type ModuleCountAggregateOutputType = {
  __typename?: 'ModuleCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ModuleCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ModuleCountOutputType = {
  __typename?: 'ModuleCountOutputType';
  clinicModules: Scalars['Int'];
  productPackages: Scalars['Int'];
};

export type ModuleCreateInput = {
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutModuleInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  productPackages?: Maybe<ProductPackageCreateNestedManyWithoutModulesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleCreateNestedManyWithoutProductPackagesInput = {
  connect?: Maybe<Array<ModuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ModuleCreateOrConnectWithoutProductPackagesInput>>;
  create?: Maybe<Array<ModuleCreateWithoutProductPackagesInput>>;
};

export type ModuleCreateNestedOneWithoutClinicModulesInput = {
  connect?: Maybe<ModuleWhereUniqueInput>;
  connectOrCreate?: Maybe<ModuleCreateOrConnectWithoutClinicModulesInput>;
  create?: Maybe<ModuleCreateWithoutClinicModulesInput>;
};

export type ModuleCreateOrConnectWithoutClinicModulesInput = {
  create: ModuleCreateWithoutClinicModulesInput;
  where: ModuleWhereUniqueInput;
};

export type ModuleCreateOrConnectWithoutProductPackagesInput = {
  create: ModuleCreateWithoutProductPackagesInput;
  where: ModuleWhereUniqueInput;
};

export type ModuleCreateWithoutClinicModulesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  productPackages?: Maybe<ProductPackageCreateNestedManyWithoutModulesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleCreateWithoutProductPackagesInput = {
  clinicModules?: Maybe<ClinicModuleCreateNestedManyWithoutModuleInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleGroupByOutputType = {
  __typename?: 'ModuleGroupByOutputType';
  _count?: Maybe<ModuleCountAggregateOutputType>;
  _max?: Maybe<ModuleMaxAggregateOutputType>;
  _min?: Maybe<ModuleMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ModuleListRelationFilter = {
  every?: Maybe<ModuleWhereInput>;
  none?: Maybe<ModuleWhereInput>;
  some?: Maybe<ModuleWhereInput>;
};

export type ModuleMaxAggregateOutputType = {
  __typename?: 'ModuleMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ModuleMinAggregateOutputType = {
  __typename?: 'ModuleMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ModuleOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ModuleOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ModuleOrderByRelevanceInput>;
  clinicModules?: Maybe<ClinicModuleOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  productPackages?: Maybe<ProductPackageOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ModuleOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type ModuleOrderByRelevanceInput = {
  fields: Array<ModuleOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ModuleOrderByWithAggregationInput = {
  _count?: Maybe<ModuleCountOrderByAggregateInput>;
  _max?: Maybe<ModuleMaxOrderByAggregateInput>;
  _min?: Maybe<ModuleMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ModuleOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ModuleOrderByRelevanceInput>;
  clinicModules?: Maybe<ClinicModuleOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  productPackages?: Maybe<ProductPackageOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type ModuleOrderByWithRelationInput = {
  _relevance?: Maybe<ModuleOrderByRelevanceInput>;
  clinicModules?: Maybe<ClinicModuleOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  productPackages?: Maybe<ProductPackageOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ModuleScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type ModuleScalarRelationFilter = {
  AND?: Maybe<Array<ModuleWhereInput>>;
  NOT?: Maybe<Array<ModuleWhereInput>>;
  OR?: Maybe<Array<ModuleWhereInput>>;
  clinicModules?: Maybe<ClinicModuleListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  productPackages?: Maybe<ProductPackageListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ModuleScalarWhereInput = {
  AND?: Maybe<Array<ModuleScalarWhereInput>>;
  NOT?: Maybe<Array<ModuleScalarWhereInput>>;
  OR?: Maybe<Array<ModuleScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ModuleScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ModuleScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ModuleScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ModuleScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ModuleUncheckedCreateInput = {
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutModuleInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  productPackages?: Maybe<ProductPackageUncheckedCreateNestedManyWithoutModulesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleUncheckedCreateNestedManyWithoutProductPackagesInput = {
  connect?: Maybe<Array<ModuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ModuleCreateOrConnectWithoutProductPackagesInput>>;
  create?: Maybe<Array<ModuleCreateWithoutProductPackagesInput>>;
};

export type ModuleUncheckedCreateWithoutClinicModulesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  productPackages?: Maybe<ProductPackageUncheckedCreateNestedManyWithoutModulesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleUncheckedCreateWithoutProductPackagesInput = {
  clinicModules?: Maybe<ClinicModuleUncheckedCreateNestedManyWithoutModuleInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleUncheckedUpdateInput = {
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutModuleNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productPackages?: Maybe<ProductPackageUncheckedUpdateManyWithoutModulesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleUncheckedUpdateManyWithoutProductPackagesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleUncheckedUpdateManyWithoutProductPackagesNestedInput = {
  connect?: Maybe<Array<ModuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ModuleCreateOrConnectWithoutProductPackagesInput>>;
  create?: Maybe<Array<ModuleCreateWithoutProductPackagesInput>>;
  delete?: Maybe<Array<ModuleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ModuleScalarWhereInput>>;
  disconnect?: Maybe<Array<ModuleWhereUniqueInput>>;
  set?: Maybe<Array<ModuleWhereUniqueInput>>;
  update?: Maybe<Array<ModuleUpdateWithWhereUniqueWithoutProductPackagesInput>>;
  updateMany?: Maybe<Array<ModuleUpdateManyWithWhereWithoutProductPackagesInput>>;
  upsert?: Maybe<Array<ModuleUpsertWithWhereUniqueWithoutProductPackagesInput>>;
};

export type ModuleUncheckedUpdateWithoutClinicModulesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productPackages?: Maybe<ProductPackageUncheckedUpdateManyWithoutModulesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleUncheckedUpdateWithoutProductPackagesInput = {
  clinicModules?: Maybe<ClinicModuleUncheckedUpdateManyWithoutModuleNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleUpdateInput = {
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutModuleNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productPackages?: Maybe<ProductPackageUpdateManyWithoutModulesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleUpdateManyWithWhereWithoutProductPackagesInput = {
  data: ModuleUpdateManyMutationInput;
  where: ModuleScalarWhereInput;
};

export type ModuleUpdateManyWithoutProductPackagesNestedInput = {
  connect?: Maybe<Array<ModuleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ModuleCreateOrConnectWithoutProductPackagesInput>>;
  create?: Maybe<Array<ModuleCreateWithoutProductPackagesInput>>;
  delete?: Maybe<Array<ModuleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ModuleScalarWhereInput>>;
  disconnect?: Maybe<Array<ModuleWhereUniqueInput>>;
  set?: Maybe<Array<ModuleWhereUniqueInput>>;
  update?: Maybe<Array<ModuleUpdateWithWhereUniqueWithoutProductPackagesInput>>;
  updateMany?: Maybe<Array<ModuleUpdateManyWithWhereWithoutProductPackagesInput>>;
  upsert?: Maybe<Array<ModuleUpsertWithWhereUniqueWithoutProductPackagesInput>>;
};

export type ModuleUpdateOneRequiredWithoutClinicModulesNestedInput = {
  connect?: Maybe<ModuleWhereUniqueInput>;
  connectOrCreate?: Maybe<ModuleCreateOrConnectWithoutClinicModulesInput>;
  create?: Maybe<ModuleCreateWithoutClinicModulesInput>;
  update?: Maybe<ModuleUpdateToOneWithWhereWithoutClinicModulesInput>;
  upsert?: Maybe<ModuleUpsertWithoutClinicModulesInput>;
};

export type ModuleUpdateToOneWithWhereWithoutClinicModulesInput = {
  data: ModuleUpdateWithoutClinicModulesInput;
  where?: Maybe<ModuleWhereInput>;
};

export type ModuleUpdateWithWhereUniqueWithoutProductPackagesInput = {
  data: ModuleUpdateWithoutProductPackagesInput;
  where: ModuleWhereUniqueInput;
};

export type ModuleUpdateWithoutClinicModulesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productPackages?: Maybe<ProductPackageUpdateManyWithoutModulesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleUpdateWithoutProductPackagesInput = {
  clinicModules?: Maybe<ClinicModuleUpdateManyWithoutModuleNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModuleUpsertWithWhereUniqueWithoutProductPackagesInput = {
  create: ModuleCreateWithoutProductPackagesInput;
  update: ModuleUpdateWithoutProductPackagesInput;
  where: ModuleWhereUniqueInput;
};

export type ModuleUpsertWithoutClinicModulesInput = {
  create: ModuleCreateWithoutClinicModulesInput;
  update: ModuleUpdateWithoutClinicModulesInput;
  where?: Maybe<ModuleWhereInput>;
};

export type ModuleWhereInput = {
  AND?: Maybe<Array<ModuleWhereInput>>;
  NOT?: Maybe<Array<ModuleWhereInput>>;
  OR?: Maybe<Array<ModuleWhereInput>>;
  clinicModules?: Maybe<ClinicModuleListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  productPackages?: Maybe<ProductPackageListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ModuleWhereUniqueInput = {
  AND?: Maybe<Array<ModuleWhereInput>>;
  NOT?: Maybe<Array<ModuleWhereInput>>;
  OR?: Maybe<Array<ModuleWhereInput>>;
  clinicModules?: Maybe<ClinicModuleListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productPackages?: Maybe<ProductPackageListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptUserInvitation2?: Maybe<AcceptUserInvitationResponse>;
  addChannelMember2?: Maybe<ChannelMember>;
  addChannelTag?: Maybe<Channel>;
  addClinicToLoyaltyProgram: OperationResult;
  /** @deprecated Use upsertUserToClinic instead */
  addUserToClinic: User;
  aiRecapExportToPims: GenericResponse;
  archiveLoyaltyProgram: OperationResult;
  buildSignedLookerUrl: Scalars['String'];
  bulkPublishWorkflowEventSettings: BulkPublishWorkflowEventSettingsResponse;
  cancelCareSubscription?: Maybe<CancelCareSubscriptionResult>;
  cancelClinicSubscription?: Maybe<GenericResponse>;
  cancelLoyaltyRewardRedemption: LoyaltyRewardRedemption;
  cancelStripePaymentIntent2?: Maybe<StripePaymentIntent>;
  changeCareSubscriptionPaymentMethod?: Maybe<ChangeCareSubscriptionPaymentMethodOutput>;
  channelBulkExportToPims?: Maybe<GenericResponse>;
  channelExportToPims?: Maybe<GenericResponse>;
  claimClinicPetParentAuthCode?: Maybe<ClaimClinicPetParentAuthCodeResponse>;
  clearTerminalDisplay?: Maybe<ClearTerminalDisplayResponse>;
  clearUnreadMessages2: GenericResponse;
  confirmAppointment2: Appointment;
  connectStripeTerminal?: Maybe<StripeTerminal>;
  copyOneWorkflowEventSetting: WorkflowEventSetting;
  createCallHistory?: Maybe<CallHistory>;
  createCareEnrollmentsAndSubscriptions: CreateCareEnrollmentAndSubscriptionResult;
  createCarePaymentMethodSetup: CreatePaymentMethodSetupInputResult;
  createChannelFilterSelection: ChannelFilterSelection;
  createChannelMessage2: ChannelMessage;
  createClinicWidgetRequest?: Maybe<CreateClinicWidgetRequestResponse>;
  createDirectBookingAppointment?: Maybe<DirectBookingAppointmentResponse>;
  createEmailTemplateVersion: EmailTemplateVersion;
  createImpersonation: TokenOutput;
  createLoyaltyProgram: LoyaltyProgram;
  createOneActiveIngredient: ActiveIngredient;
  createOneAppointment: Appointment;
  createOneAppointmentAvailability: AppointmentAvailability;
  createOneAppointmentNoteTemplate: AppointmentNoteTemplate;
  createOneAppointmentType: AppointmentType;
  createOneAutomationRun: AutomationRun;
  createOneAutomationRunAction: AutomationRunAction;
  createOneAxionCall?: Maybe<AxionCallOutput>;
  createOneAxionClinicConfiguration: AxionClinicConfiguration;
  createOneAxionClinicUserConfiguration: AxionClinicUserConfiguration;
  createOneBedrockInference: BedrockInference;
  createOneBitwerxHealthcheck: BitwerxHealthcheck;
  createOneBitwerxIntegration: BitwerxIntegration;
  createOneBitwerxPaymentHealthcheckResult: BitwerxPaymentHealthcheckResult;
  createOneBitwerxPaymentHealthcheckRun: BitwerxPaymentHealthcheckRun;
  createOneBoardFilterColumn: BoardFilterColumn;
  createOneBoardFilterSpecificDateRange: BoardFilterSpecificDateRange;
  createOneBoehringerIngelheimCustomerAlignment: BoehringerIngelheimCustomerAlignment;
  createOneBoehringerIngelheimTerritory: BoehringerIngelheimTerritory;
  createOneBreed: Breed;
  createOneCallHistory: CallHistory;
  createOneCallParticipant: CallParticipant;
  createOneCallRecording?: Maybe<CallRecording>;
  createOneCampaignRegistryCampaign: CampaignRegistryCampaign;
  createOneCanonicalBreed: CanonicalBreed;
  createOneCanonicalCanineBreedProfile: CanonicalCanineBreedProfile;
  createOneCanonicalService: CanonicalService;
  createOneCanonicalSpecies: CanonicalSpecies;
  createOneCareAddonEnrollment: CareAddonEnrollment;
  createOneCareAddonPackage: CareAddonPackage;
  createOneCareAddonPackageBenefit: CareAddonPackageBenefit;
  createOneCareAuthorizationRequest: CareAuthorizationRequest;
  createOneCareBenefit: CareBenefit;
  createOneCareBenefitUsage: CareBenefitUsage;
  createOneCareBenefitUsageFollowup: CareBenefitUsageFollowup;
  createOneCareBenefitUsageFollowupStep: CareBenefitUsageFollowupStep;
  createOneCareBenefitUsageToInvoiceLineItem: CareBenefitUsageToInvoiceLineItem;
  createOneCareCreditPreapprovalCheck: CareCreditPreapprovalCheck;
  createOneCareEnrollmentPayment: CareEnrollmentPayment;
  createOneCareEnrollmentToStripeInvoiceItem: CareEnrollmentToStripeInvoiceItem;
  createOneCareLapsedPayment: CareLapsedPayment;
  createOneCarePlan: CarePlan;
  createOneCarePlanBenefit: CarePlanBenefit;
  createOneCarePlanBenefitEnrollmentCarryover: CarePlanBenefitEnrollmentCarryover;
  createOneCarePlanEnrollment: CarePlanEnrollment;
  createOneCarePlanPricing: CarePlanPricing;
  createOneCarePlanProviderGroup: CarePlanProviderGroup;
  createOneCareStripeSubscription: CareStripeSubscription;
  createOneCareSubscriptionTrueUp: CareSubscriptionTrueUp;
  createOneCareSubscriptionTrueUpLogEntry: CareSubscriptionTrueUpLogEntry;
  createOneChannel: Channel;
  createOneChannelAutomationStatus: ChannelAutomationStatus;
  createOneChannelCreationSource: ChannelCreationSource;
  createOneChannelFilterSelection: ChannelFilterSelection;
  createOneChannelMember: ChannelMember;
  createOneChannelMessage: ChannelMessage;
  createOneChannelMessageAttachment: ChannelMessageAttachment;
  createOneChannelMessageAutoResponse: ChannelMessageAutoResponse;
  createOneChannelMessageReaction: ChannelMessageReaction;
  createOneChannelPin: ChannelPin;
  createOneChannelSelection: ChannelSelection;
  createOneChannelStatus: ChannelStatus;
  createOneChannelStatusChannelAssignee: ChannelStatusChannelAssignee;
  createOneChemicalCompound: ChemicalCompound;
  createOneClientConnectIntegration: ClientConnectIntegration;
  createOneClinic: Clinic;
  createOneClinicBlockedPhoneNumber: ClinicBlockedPhoneNumber;
  createOneClinicCustomPayoutsSetup: ClinicCustomPayoutsSetup;
  createOneClinicDirectBookingSetting: ClinicDirectBookingSetting;
  createOneClinicEmailCampaignSetting: ClinicEmailCampaignSetting;
  createOneClinicEmployee: ClinicEmployee;
  createOneClinicEmployeeAppointmentTypeSetting: ClinicEmployeeAppointmentTypeSetting;
  createOneClinicEntityPhoneNumber: ClinicEntityPhoneNumber;
  createOneClinicModule: ClinicModule;
  createOneClinicOfficeHour: ClinicOfficeHour;
  createOneClinicOnboarding: ClinicOnboarding;
  createOneClinicPaymentFeeConfiguration: ClinicPaymentFeeConfiguration;
  createOneClinicPet: ClinicPet;
  createOneClinicPetAlert: ClinicPetAlert;
  createOneClinicPetCustomFieldValue: ClinicPetCustomFieldValue;
  createOneClinicPetParent: ClinicPetParent;
  createOneClinicPetParentAddress: ClinicPetParentAddress;
  createOneClinicPetParentCustomFieldValue: ClinicPetParentCustomFieldValue;
  createOneClinicPetParentDevice: ClinicPetParentDevice;
  createOneClinicPetParentPimsSyncStatus: ClinicPetParentPimsSyncStatus;
  createOneClinicPetPimsSyncStatus: ClinicPetPimsSyncStatus;
  createOneClinicPhoneNumber: ClinicPhoneNumber;
  createOneClinicPimsIntegration: ClinicPimsIntegration;
  createOneClinicPimsIntegrationCapability: ClinicPimsIntegrationCapability;
  createOneClinicPimsIntegrationCapabilityHistoryEntry: ClinicPimsIntegrationCapabilityHistoryEntry;
  createOneClinicPostcardSetting: ClinicPostcardSetting;
  createOneClinicRoom: ClinicRoom;
  createOneClinicSetting: ClinicSetting;
  createOneClinicUserFilter: ClinicUserFilter;
  createOneClinicWidgetRequest: ClinicWidgetRequest;
  createOneClinicWidgetRequestType: ClinicWidgetRequestType;
  createOneClinicWidgetSetting: ClinicWidgetSetting;
  createOneColor: Color;
  createOneCondition: Condition;
  createOneConditionSet: ConditionSet;
  createOneConditionalEntityEvaluation: ConditionalEntityEvaluation;
  createOneConsultationRequest: ConsultationRequest;
  createOneCustomFieldDefinition: CustomFieldDefinition;
  createOneCustomFieldPimsWritebackLogEntry: CustomFieldPimsWritebackLogEntry;
  createOneDirectBookingAppointmentTypeSetting: DirectBookingAppointmentTypeSetting;
  createOneDirectBookingExclusionRule: DirectBookingExclusionRule;
  createOneDirectBookingExclusionTimeSlot: DirectBookingExclusionTimeSlot;
  createOneDisbursement: Disbursement;
  createOneDocumentation: Documentation;
  createOneEmailCampaign: EmailCampaign;
  createOneEmailCampaignCustomList: EmailCampaignCustomList;
  createOneEmailCampaignCustomListRecipient: EmailCampaignCustomListRecipient;
  createOneEmailCampaignCustomListUploadHistory: EmailCampaignCustomListUploadHistory;
  createOneEmailCampaignLog: EmailCampaignLog;
  createOneEmailCampaignTemplate: EmailCampaignTemplate;
  createOneEmailCampaignUnsubscribe: EmailCampaignUnsubscribe;
  createOneEmailProviderLog: EmailProviderLog;
  createOneEmergencyClinics: EmergencyClinics;
  createOneEncryptedClinicUpload: EncryptedClinicUpload;
  createOneEnrollmentSupportEvent: EnrollmentSupportEvent;
  createOneEzyVetIntegration: EzyVetIntegration;
  createOneFeatureFlag: FeatureFlag;
  createOneFinancialAdjustment: FinancialAdjustment;
  createOneFinancialTransaction: FinancialTransaction;
  createOneFormSubmission: FormSubmission;
  createOneFormTemplate: FormTemplate;
  createOneGlobalPetParent: GlobalPetParent;
  createOneGooglePlace: GooglePlace;
  createOneHillsToHomeAPILog: HillsToHomeApiLog;
  createOneInformAudienceDefinition: InformAudienceDefinition;
  createOneInformAudienceMember: InformAudienceMember;
  createOneInformAudienceMemberMessage: InformAudienceMemberMessage;
  createOneInformAutomationCampaign: InformAutomationCampaign;
  createOneInformCampaign: InformCampaign;
  createOneInformCampaignEnrollment: InformCampaignEnrollment;
  createOneInformCampaignEnrollmentCanonicalService: InformCampaignEnrollmentCanonicalService;
  createOneInformCampaignExecution: InformCampaignExecution;
  createOneInformCampaignGroup: InformCampaignGroup;
  createOneInformCommunicationOptOut: InformCommunicationOptOut;
  createOneInformControlGroupParticipant: InformControlGroupParticipant;
  createOneInformEmailTemplate: InformEmailTemplate;
  createOneInformEntityHistory: InformEntityHistory;
  createOneInformEventDrivenCampaign: InformEventDrivenCampaign;
  createOneInformEventListener: InformEventListener;
  createOneInformNotificationRecipient: InformNotificationRecipient;
  createOneInformPartner: InformPartner;
  createOneInformPartnerCustomer: InformPartnerCustomer;
  createOneInformPartnerCustomerPharmacyProvider: InformPartnerCustomerPharmacyProvider;
  createOneInformPartnerIntegration: InformPartnerIntegration;
  createOneInformPartnerIntegrationModel: InformPartnerIntegrationModel;
  createOneInformPartnerProgram: InformPartnerProgram;
  createOneInformPartnerProgramEnrollment: InformPartnerProgramEnrollment;
  createOneInformPartnerUser: InformPartnerUser;
  createOneInformPartnerUserRole: InformPartnerUserRole;
  createOneInformScheduledCampaign: InformScheduledCampaign;
  createOneInformSession: InformSession;
  createOneInformSessionEvent: InformSessionEvent;
  createOneInstinctIntegration: InstinctIntegration;
  createOneInsuranceIntegration: InsuranceIntegration;
  createOneIntegrationOutageHistoryEntry: IntegrationOutageHistoryEntry;
  createOneInterchangeRate: InterchangeRate;
  createOneInvoice: Invoice;
  createOneInvoiceLineItem: InvoiceLineItem;
  createOneInvoicePimsWritebackLogEntry: InvoicePimsWritebackLogEntry;
  createOneLabPanel: LabPanel;
  createOneLabResult: LabResult;
  createOneLapsedPetParentTriggers: LapsedPetParentTriggers;
  createOneLegalEntity: LegalEntity;
  createOneLoyaltyAccount: LoyaltyAccount;
  createOneLoyaltyAccountHolder: LoyaltyAccountHolder;
  createOneLoyaltyAccountMerger: LoyaltyAccountMerger;
  createOneLoyaltyInvoicePointGranter: LoyaltyInvoicePointGranter;
  createOneLoyaltyPointGrantingService: LoyaltyPointGrantingService;
  createOneLoyaltyPointGrantingServiceCategory: LoyaltyPointGrantingServiceCategory;
  createOneLoyaltyPointUserGrant: LoyaltyPointUserGrant;
  createOneLoyaltyReward: LoyaltyReward;
  createOneLoyaltyRewardRedemption: LoyaltyRewardRedemption;
  createOneMassTextAlert: MassTextAlert;
  createOneMassTextAlertEntry: MassTextAlertEntry;
  createOneMassTextAlertEntryAppointment: MassTextAlertEntryAppointment;
  createOneMedia: Media;
  createOneMedicalHistory: MedicalHistory;
  createOneMessageTemplate: MessageTemplate;
  createOneMessagingCampaign: MessagingCampaign;
  createOneMessagingPartner: MessagingPartner;
  createOneModule: Module;
  createOneNonPrismaSchemaScriptRan: NonPrismaSchemaScriptRan;
  createOneNotificationEventToMessage: NotificationEventToMessage;
  createOneOrganization: Organization;
  createOneOrganizationCareBenefitToClinicService: OrganizationCareBenefitToClinicService;
  createOneOrganizationCareBenefitToClinicServiceCategory: OrganizationCareBenefitToClinicServiceCategory;
  createOneOrganizationPet: OrganizationPet;
  createOneOrganizationPetParent: OrganizationPetParent;
  createOneOrganizationPetToOrganizationPetParent: OrganizationPetToOrganizationPetParent;
  createOnePPCIntegration: PpcIntegration;
  createOnePaymentsReportTransaction: PaymentsReportTransaction;
  createOnePayoutBatchingPeriod: PayoutBatchingPeriod;
  createOnePayoutBatchingSchedule: PayoutBatchingSchedule;
  createOnePayoutBatchingSetting: PayoutBatchingSetting;
  createOnePermission: Permission;
  createOnePetParentSetting: PetParentSetting;
  createOnePetPortalSetting: PetPortalSetting;
  createOnePhoneNumberLookupRequest: PhoneNumberLookupRequest;
  createOnePhoneNumberLookupResult: PhoneNumberLookupResult;
  createOnePimsInvoice: PimsInvoice;
  createOnePimsInvoiceLineItem: PimsInvoiceLineItem;
  createOnePimsWritebackLogEntry: PimsWritebackLogEntry;
  createOnePrescription: Prescription;
  createOneProduct: Product;
  createOneProductPackage: ProductPackage;
  createOneProductPackageSubscription: ProductPackageSubscription;
  createOneProviderAppointmentTypeRoomMap: ProviderAppointmentTypeRoomMap;
  createOneProviderAppointmentTypeRoomMapByName: DirectBookingCreateOneProviderAppointmentTypeRoomMapByNameResponse;
  createOnePushNotificationLog: PushNotificationLog;
  createOneRecap: Recap;
  createOneRules: Rules;
  createOneSegment: Segment;
  createOneSentTrupanionExamDayOffer: SentTrupanionExamDayOffer;
  createOneService: Service;
  createOneServiceCategory: ServiceCategory;
  createOneServicePurchaseSummary: ServicePurchaseSummary;
  createOneServiceReminder: ServiceReminder;
  createOneServiceReminderNotification: ServiceReminderNotification;
  createOneServiceReminderTiming: ServiceReminderTiming;
  createOneSex: Sex;
  createOneSmsNotificationStatus: SmsNotificationStatus;
  createOneSpecies: Species;
  createOneStaffRole: StaffRole;
  createOneStripeCustomer: StripeCustomer;
  createOneStripeDispute: StripeDispute;
  createOneStripeInvoice: StripeInvoice;
  createOneStripeInvoiceItem: StripeInvoiceItem;
  createOneStripePaymentIntent: StripePaymentIntent;
  createOneStripePaymentMethod: StripePaymentMethod;
  createOneStripePayout: StripePayout;
  createOneStripePayoutAccount: StripePayoutAccount;
  createOneStripeReceipt: StripeReceipt;
  createOneStripeReceiptHistory: StripeReceiptHistory;
  createOneStripeRefund: StripeRefund;
  createOneStripeTerminal: StripeTerminal;
  createOneStripeTerminalLocation: StripeTerminalLocation;
  createOneSurveyAppointmentTypeSetting: SurveyAppointmentTypeSetting;
  createOneSurveyResult: SurveyResult;
  createOneSurveySetting: SurveySetting;
  createOneSyncVetIntegration: SyncVetIntegration;
  createOneSyncVetService: SyncVetService;
  createOneSynchronyClinicConfiguration: SynchronyClinicConfiguration;
  createOneSynchronyEvent: SynchronyEvent;
  createOneTask: Task;
  createOneTaxonomy: Taxonomy;
  createOneTaxonomyToInformAudienceDefinition: TaxonomyToInformAudienceDefinition;
  createOneTransaction: Transaction;
  createOneTrupanionCertificateAvailability: TrupanionCertificateAvailability;
  createOneTrupanionIntegratedAppointmentType: TrupanionIntegratedAppointmentType;
  createOneTrupanionIntegration: TrupanionIntegration;
  createOneUser: User;
  createOneUserAppointmentGrouping: UserAppointmentGrouping;
  createOneUserBoardFilter: UserBoardFilter;
  createOneUserChannelFilterSelection: UserChannelFilterSelection;
  createOneUserNotificationSetting: UserNotificationSetting;
  createOneUserSetting: UserSetting;
  createOneUserTaskList: UserTaskList;
  createOneUserTaskListFilter: UserTaskListFilter;
  createOneVaccination: Vaccination;
  createOneVetAvailability: VetAvailability;
  createOneVetAvailabilityClinicRoomMap: VetAvailabilityClinicRoomMap;
  createOneVetAvailabilityMap: VetAvailabilityMap;
  createOneVetInfo: VetInfo;
  createOneVetsourceCodeTag: VetsourceCodeTag;
  createOneVetsourceInstallation: VetsourceInstallation;
  createOneVetsourcePharmacyIntegration: VetsourcePharmacyIntegration;
  createOneVetsourceRevenueCategory: VetsourceRevenueCategory;
  createOneWorkflowEventSetting: WorkflowEventSetting;
  /** @deprecated use createCarePaymentMethodSetup */
  createPaymentMethodSetup: CreatePaymentMethodSetupInputResult;
  createSalesforceAccount?: Maybe<CreateSalesforceAccountResponse>;
  createStripePaymentIntent2?: Maybe<StripePaymentIntent>;
  createStripeTerminalLocation?: Maybe<StripeTerminalLocation>;
  createSystemChannelMessage2?: Maybe<ChannelMessage>;
  createTeamChannel2?: Maybe<Channel>;
  createTerminalAppPaymentIntent?: Maybe<TerminalAppPaymentResponse>;
  createTwilioToken: CreateTwilioTokenResponse;
  createWorkflowEventSettingAndConditions: WorkflowEventSetting;
  customUpsertOneUserBoardFilter?: Maybe<CustomUpsertOneUserBoardFilterResponse>;
  deactivateLoyaltyAccount: LoyaltyAccount;
  deleteChannelFilterSelection?: Maybe<ChannelFilterSelection>;
  deleteEmailCampaignCustomList?: Maybe<EmailCampaignCustomList>;
  deleteManyActiveIngredient?: Maybe<BatchPayload>;
  deleteManyAppointment?: Maybe<BatchPayload>;
  deleteManyAppointmentAvailability?: Maybe<BatchPayload>;
  deleteManyAppointmentNoteTemplate?: Maybe<BatchPayload>;
  deleteManyAppointmentType?: Maybe<BatchPayload>;
  deleteManyAutomationRun?: Maybe<BatchPayload>;
  deleteManyAutomationRunAction?: Maybe<BatchPayload>;
  deleteManyAxionClinicConfiguration?: Maybe<BatchPayload>;
  deleteManyAxionClinicUserConfiguration?: Maybe<BatchPayload>;
  deleteManyBedrockInference?: Maybe<BatchPayload>;
  deleteManyBitwerxHealthcheck?: Maybe<BatchPayload>;
  deleteManyBitwerxIntegration?: Maybe<BatchPayload>;
  deleteManyBitwerxPaymentHealthcheckResult?: Maybe<BatchPayload>;
  deleteManyBitwerxPaymentHealthcheckRun?: Maybe<BatchPayload>;
  deleteManyBoardFilterColumn?: Maybe<BatchPayload>;
  deleteManyBoardFilterSpecificDateRange?: Maybe<BatchPayload>;
  deleteManyBoehringerIngelheimCustomerAlignment?: Maybe<BatchPayload>;
  deleteManyBoehringerIngelheimTerritory?: Maybe<BatchPayload>;
  deleteManyBreed?: Maybe<BatchPayload>;
  deleteManyCallHistory?: Maybe<BatchPayload>;
  deleteManyCallParticipant?: Maybe<BatchPayload>;
  deleteManyCampaignRegistryCampaign?: Maybe<BatchPayload>;
  deleteManyCanonicalBreed?: Maybe<BatchPayload>;
  deleteManyCanonicalCanineBreedProfile?: Maybe<BatchPayload>;
  deleteManyCanonicalService?: Maybe<BatchPayload>;
  deleteManyCanonicalSpecies?: Maybe<BatchPayload>;
  deleteManyCareAddonEnrollment?: Maybe<BatchPayload>;
  deleteManyCareAddonPackage?: Maybe<BatchPayload>;
  deleteManyCareAddonPackageBenefit?: Maybe<BatchPayload>;
  deleteManyCareAuthorizationRequest?: Maybe<BatchPayload>;
  deleteManyCareBenefit?: Maybe<BatchPayload>;
  deleteManyCareBenefitUsage?: Maybe<BatchPayload>;
  deleteManyCareBenefitUsageFollowup?: Maybe<BatchPayload>;
  deleteManyCareBenefitUsageFollowupStep?: Maybe<BatchPayload>;
  deleteManyCareBenefitUsageToInvoiceLineItem?: Maybe<BatchPayload>;
  deleteManyCareCreditPreapprovalCheck?: Maybe<BatchPayload>;
  deleteManyCareEnrollmentPayment?: Maybe<BatchPayload>;
  deleteManyCareEnrollmentToStripeInvoiceItem?: Maybe<BatchPayload>;
  deleteManyCareLapsedPayment?: Maybe<BatchPayload>;
  deleteManyCarePlan?: Maybe<BatchPayload>;
  deleteManyCarePlanBenefit?: Maybe<BatchPayload>;
  deleteManyCarePlanBenefitEnrollmentCarryover?: Maybe<BatchPayload>;
  deleteManyCarePlanEnrollment?: Maybe<BatchPayload>;
  deleteManyCarePlanPricing?: Maybe<BatchPayload>;
  deleteManyCarePlanProviderGroup?: Maybe<BatchPayload>;
  deleteManyCareStripeSubscription?: Maybe<BatchPayload>;
  deleteManyCareSubscriptionTrueUp?: Maybe<BatchPayload>;
  deleteManyCareSubscriptionTrueUpLogEntry?: Maybe<BatchPayload>;
  deleteManyChannel?: Maybe<BatchPayload>;
  deleteManyChannelAutomationStatus?: Maybe<BatchPayload>;
  deleteManyChannelCreationSource?: Maybe<BatchPayload>;
  deleteManyChannelFilterSelection?: Maybe<BatchPayload>;
  deleteManyChannelMember?: Maybe<BatchPayload>;
  deleteManyChannelMessage?: Maybe<BatchPayload>;
  deleteManyChannelMessageAttachment?: Maybe<BatchPayload>;
  deleteManyChannelMessageAutoResponse?: Maybe<BatchPayload>;
  deleteManyChannelMessageReaction?: Maybe<BatchPayload>;
  deleteManyChannelPin?: Maybe<BatchPayload>;
  deleteManyChannelSelection?: Maybe<BatchPayload>;
  deleteManyChannelStatus?: Maybe<BatchPayload>;
  deleteManyChannelStatusChannelAssignee?: Maybe<BatchPayload>;
  deleteManyChemicalCompound?: Maybe<BatchPayload>;
  deleteManyClientConnectIntegration?: Maybe<BatchPayload>;
  deleteManyClinic?: Maybe<BatchPayload>;
  deleteManyClinicBlockedPhoneNumber?: Maybe<BatchPayload>;
  deleteManyClinicCustomPayoutsSetup?: Maybe<BatchPayload>;
  deleteManyClinicDirectBookingSetting?: Maybe<BatchPayload>;
  deleteManyClinicEmailCampaignSetting?: Maybe<BatchPayload>;
  deleteManyClinicEmployee?: Maybe<BatchPayload>;
  deleteManyClinicEmployeeAppointmentTypeSetting?: Maybe<BatchPayload>;
  deleteManyClinicEntityPhoneNumber?: Maybe<BatchPayload>;
  deleteManyClinicModule?: Maybe<BatchPayload>;
  deleteManyClinicOfficeHour?: Maybe<BatchPayload>;
  deleteManyClinicOnboarding?: Maybe<BatchPayload>;
  deleteManyClinicPaymentFeeConfiguration?: Maybe<BatchPayload>;
  deleteManyClinicPet?: Maybe<BatchPayload>;
  deleteManyClinicPetAlert?: Maybe<BatchPayload>;
  deleteManyClinicPetCustomFieldValue?: Maybe<BatchPayload>;
  deleteManyClinicPetParent?: Maybe<BatchPayload>;
  deleteManyClinicPetParentAddress?: Maybe<BatchPayload>;
  deleteManyClinicPetParentCustomFieldValue?: Maybe<BatchPayload>;
  deleteManyClinicPetParentDevice?: Maybe<BatchPayload>;
  deleteManyClinicPetParentPimsSyncStatus?: Maybe<BatchPayload>;
  deleteManyClinicPetPimsSyncStatus?: Maybe<BatchPayload>;
  deleteManyClinicPhoneNumber?: Maybe<BatchPayload>;
  deleteManyClinicPimsIntegration?: Maybe<BatchPayload>;
  deleteManyClinicPimsIntegrationCapability?: Maybe<BatchPayload>;
  deleteManyClinicPimsIntegrationCapabilityHistoryEntry?: Maybe<BatchPayload>;
  deleteManyClinicPostcardSetting?: Maybe<BatchPayload>;
  deleteManyClinicRoom?: Maybe<BatchPayload>;
  deleteManyClinicSetting?: Maybe<BatchPayload>;
  deleteManyClinicUserFilter?: Maybe<BatchPayload>;
  deleteManyClinicWidgetRequest?: Maybe<BatchPayload>;
  deleteManyClinicWidgetRequestType?: Maybe<BatchPayload>;
  deleteManyClinicWidgetSetting?: Maybe<BatchPayload>;
  deleteManyColor?: Maybe<BatchPayload>;
  deleteManyCondition?: Maybe<BatchPayload>;
  deleteManyConditionSet?: Maybe<BatchPayload>;
  deleteManyConditionalEntityEvaluation?: Maybe<BatchPayload>;
  deleteManyConsultationRequest?: Maybe<BatchPayload>;
  deleteManyCustomFieldDefinition?: Maybe<BatchPayload>;
  deleteManyCustomFieldPimsWritebackLogEntry?: Maybe<BatchPayload>;
  deleteManyDirectBookingAppointmentTypeSetting?: Maybe<BatchPayload>;
  deleteManyDirectBookingExclusionTimeSlot?: Maybe<BatchPayload>;
  deleteManyDisbursement?: Maybe<BatchPayload>;
  deleteManyDocumentation?: Maybe<BatchPayload>;
  deleteManyEmailCampaign?: Maybe<BatchPayload>;
  deleteManyEmailCampaignCustomList?: Maybe<BatchPayload>;
  deleteManyEmailCampaignCustomListRecipient?: Maybe<BatchPayload>;
  deleteManyEmailCampaignCustomListUploadHistory?: Maybe<BatchPayload>;
  deleteManyEmailCampaignLog?: Maybe<BatchPayload>;
  deleteManyEmailCampaignTemplate?: Maybe<BatchPayload>;
  deleteManyEmailCampaignUnsubscribe?: Maybe<BatchPayload>;
  deleteManyEmailProviderLog?: Maybe<BatchPayload>;
  deleteManyEmergencyClinics?: Maybe<BatchPayload>;
  deleteManyEncryptedClinicUpload?: Maybe<BatchPayload>;
  deleteManyEnrollmentSupportEvent?: Maybe<BatchPayload>;
  deleteManyEzyVetIntegration?: Maybe<BatchPayload>;
  deleteManyFeatureFlag?: Maybe<BatchPayload>;
  deleteManyFinancialAdjustment?: Maybe<BatchPayload>;
  deleteManyFinancialTransaction?: Maybe<BatchPayload>;
  deleteManyFormSubmission?: Maybe<BatchPayload>;
  deleteManyFormTemplate?: Maybe<BatchPayload>;
  deleteManyGlobalPetParent?: Maybe<BatchPayload>;
  deleteManyGooglePlace?: Maybe<BatchPayload>;
  deleteManyHillsToHomeAPILog?: Maybe<BatchPayload>;
  deleteManyInformAudienceDefinition?: Maybe<BatchPayload>;
  deleteManyInformAudienceMember?: Maybe<BatchPayload>;
  deleteManyInformAudienceMemberMessage?: Maybe<BatchPayload>;
  deleteManyInformAutomationCampaign?: Maybe<BatchPayload>;
  deleteManyInformCampaign?: Maybe<BatchPayload>;
  deleteManyInformCampaignEnrollment?: Maybe<BatchPayload>;
  deleteManyInformCampaignEnrollmentCanonicalService?: Maybe<BatchPayload>;
  deleteManyInformCampaignExecution?: Maybe<BatchPayload>;
  deleteManyInformCampaignGroup?: Maybe<BatchPayload>;
  deleteManyInformCommunicationOptOut?: Maybe<BatchPayload>;
  deleteManyInformControlGroupParticipant?: Maybe<BatchPayload>;
  deleteManyInformEmailTemplate?: Maybe<BatchPayload>;
  deleteManyInformEntityHistory?: Maybe<BatchPayload>;
  deleteManyInformEventDrivenCampaign?: Maybe<BatchPayload>;
  deleteManyInformEventListener?: Maybe<BatchPayload>;
  deleteManyInformNotificationRecipient?: Maybe<BatchPayload>;
  deleteManyInformPartner?: Maybe<BatchPayload>;
  deleteManyInformPartnerCustomer?: Maybe<BatchPayload>;
  deleteManyInformPartnerCustomerPharmacyProvider?: Maybe<BatchPayload>;
  deleteManyInformPartnerIntegration?: Maybe<BatchPayload>;
  deleteManyInformPartnerIntegrationModel?: Maybe<BatchPayload>;
  deleteManyInformPartnerProgram?: Maybe<BatchPayload>;
  deleteManyInformPartnerProgramEnrollment?: Maybe<BatchPayload>;
  deleteManyInformPartnerUser?: Maybe<BatchPayload>;
  deleteManyInformPartnerUserRole?: Maybe<BatchPayload>;
  deleteManyInformScheduledCampaign?: Maybe<BatchPayload>;
  deleteManyInformSession?: Maybe<BatchPayload>;
  deleteManyInformSessionEvent?: Maybe<BatchPayload>;
  deleteManyInstinctIntegration?: Maybe<BatchPayload>;
  deleteManyInsuranceIntegration?: Maybe<BatchPayload>;
  deleteManyIntegrationOutageHistoryEntry?: Maybe<BatchPayload>;
  deleteManyInterchangeRate?: Maybe<BatchPayload>;
  deleteManyInvoice?: Maybe<BatchPayload>;
  deleteManyInvoiceLineItem?: Maybe<BatchPayload>;
  deleteManyInvoicePimsWritebackLogEntry?: Maybe<BatchPayload>;
  deleteManyLabPanel?: Maybe<BatchPayload>;
  deleteManyLabResult?: Maybe<BatchPayload>;
  deleteManyLapsedPetParentTriggers?: Maybe<BatchPayload>;
  deleteManyLoyaltyAccount?: Maybe<BatchPayload>;
  deleteManyLoyaltyAccountHolder?: Maybe<BatchPayload>;
  deleteManyLoyaltyAccountMerger?: Maybe<BatchPayload>;
  deleteManyLoyaltyInvoicePointGranter?: Maybe<BatchPayload>;
  deleteManyLoyaltyPointGrantingService?: Maybe<BatchPayload>;
  deleteManyLoyaltyPointGrantingServiceCategory?: Maybe<BatchPayload>;
  deleteManyLoyaltyPointUserGrant?: Maybe<BatchPayload>;
  deleteManyLoyaltyRewardRedemption?: Maybe<BatchPayload>;
  deleteManyMassTextAlert?: Maybe<BatchPayload>;
  deleteManyMassTextAlertEntry?: Maybe<BatchPayload>;
  deleteManyMassTextAlertEntryAppointment?: Maybe<BatchPayload>;
  deleteManyMedia?: Maybe<BatchPayload>;
  deleteManyMedicalHistory?: Maybe<BatchPayload>;
  deleteManyMessageTemplate?: Maybe<BatchPayload>;
  deleteManyMessagingCampaign?: Maybe<BatchPayload>;
  deleteManyMessagingPartner?: Maybe<BatchPayload>;
  deleteManyModule?: Maybe<BatchPayload>;
  deleteManyNonPrismaSchemaScriptRan?: Maybe<BatchPayload>;
  deleteManyNotificationEventToMessage?: Maybe<BatchPayload>;
  deleteManyOrganization?: Maybe<BatchPayload>;
  deleteManyOrganizationCareBenefitToClinicService?: Maybe<BatchPayload>;
  deleteManyOrganizationCareBenefitToClinicServiceCategory?: Maybe<BatchPayload>;
  deleteManyOrganizationPet?: Maybe<BatchPayload>;
  deleteManyOrganizationPetParent?: Maybe<BatchPayload>;
  deleteManyOrganizationPetToOrganizationPetParent?: Maybe<BatchPayload>;
  deleteManyPPCIntegration?: Maybe<BatchPayload>;
  deleteManyPaymentsReportTransaction?: Maybe<BatchPayload>;
  deleteManyPayoutBatchingSchedule?: Maybe<BatchPayload>;
  deleteManyPayoutBatchingSetting?: Maybe<BatchPayload>;
  deleteManyPermission?: Maybe<BatchPayload>;
  deleteManyPetParentSetting?: Maybe<BatchPayload>;
  deleteManyPetPortalSetting?: Maybe<BatchPayload>;
  deleteManyPhoneNumberLookupRequest?: Maybe<BatchPayload>;
  deleteManyPhoneNumberLookupResult?: Maybe<BatchPayload>;
  deleteManyPimsInvoice?: Maybe<BatchPayload>;
  deleteManyPimsInvoiceLineItem?: Maybe<BatchPayload>;
  deleteManyPimsWritebackLogEntry?: Maybe<BatchPayload>;
  deleteManyPrescription?: Maybe<BatchPayload>;
  deleteManyProduct?: Maybe<BatchPayload>;
  deleteManyProductPackage?: Maybe<BatchPayload>;
  deleteManyProductPackageSubscription?: Maybe<BatchPayload>;
  deleteManyProviderAppointmentTypeRoomMap?: Maybe<BatchPayload>;
  deleteManyPushNotificationLog?: Maybe<BatchPayload>;
  deleteManyRecap?: Maybe<BatchPayload>;
  deleteManyRules?: Maybe<BatchPayload>;
  deleteManySegment?: Maybe<BatchPayload>;
  deleteManySentTrupanionExamDayOffer?: Maybe<BatchPayload>;
  deleteManyService?: Maybe<BatchPayload>;
  deleteManyServiceCategory?: Maybe<BatchPayload>;
  deleteManyServicePurchaseSummary?: Maybe<BatchPayload>;
  deleteManyServiceReminder?: Maybe<BatchPayload>;
  deleteManyServiceReminderNotification?: Maybe<BatchPayload>;
  deleteManyServiceReminderTiming?: Maybe<BatchPayload>;
  deleteManySex?: Maybe<BatchPayload>;
  deleteManySmsNotificationStatus?: Maybe<BatchPayload>;
  deleteManySpecies?: Maybe<BatchPayload>;
  deleteManyStaffRole?: Maybe<BatchPayload>;
  deleteManyStripeCustomer?: Maybe<BatchPayload>;
  deleteManyStripeDispute?: Maybe<BatchPayload>;
  deleteManyStripeInvoice?: Maybe<BatchPayload>;
  deleteManyStripeInvoiceItem?: Maybe<BatchPayload>;
  deleteManyStripePaymentMethod?: Maybe<BatchPayload>;
  deleteManyStripePayout?: Maybe<BatchPayload>;
  deleteManyStripePayoutAccount?: Maybe<BatchPayload>;
  deleteManyStripeReceipt?: Maybe<BatchPayload>;
  deleteManyStripeReceiptHistory?: Maybe<BatchPayload>;
  deleteManyStripeRefund?: Maybe<BatchPayload>;
  deleteManyStripeTerminal?: Maybe<BatchPayload>;
  deleteManyStripeTerminalLocation?: Maybe<BatchPayload>;
  deleteManySurveyAppointmentTypeSetting?: Maybe<BatchPayload>;
  deleteManySurveyResult?: Maybe<BatchPayload>;
  deleteManySurveySetting?: Maybe<BatchPayload>;
  deleteManySyncVetIntegration?: Maybe<BatchPayload>;
  deleteManySyncVetService?: Maybe<BatchPayload>;
  deleteManySynchronyClinicConfiguration?: Maybe<BatchPayload>;
  deleteManySynchronyEvent?: Maybe<BatchPayload>;
  deleteManyTask?: Maybe<BatchPayload>;
  deleteManyTaxonomy?: Maybe<BatchPayload>;
  deleteManyTaxonomyToInformAudienceDefinition?: Maybe<BatchPayload>;
  deleteManyTransaction?: Maybe<BatchPayload>;
  deleteManyTrupanionCertificateAvailability?: Maybe<BatchPayload>;
  deleteManyTrupanionIntegratedAppointmentType?: Maybe<BatchPayload>;
  deleteManyTrupanionIntegration?: Maybe<BatchPayload>;
  deleteManyUser?: Maybe<BatchPayload>;
  deleteManyUserAppointmentGrouping?: Maybe<BatchPayload>;
  deleteManyUserBoardFilter?: Maybe<BatchPayload>;
  deleteManyUserChannelFilterSelection?: Maybe<BatchPayload>;
  deleteManyUserNotificationSetting?: Maybe<BatchPayload>;
  deleteManyUserSetting?: Maybe<BatchPayload>;
  deleteManyUserTaskList?: Maybe<BatchPayload>;
  deleteManyUserTaskListFilter?: Maybe<BatchPayload>;
  deleteManyVaccination?: Maybe<BatchPayload>;
  deleteManyVetAvailability?: Maybe<BatchPayload>;
  deleteManyVetAvailabilityClinicRoomMap?: Maybe<BatchPayload>;
  deleteManyVetAvailabilityMap?: Maybe<BatchPayload>;
  deleteManyVetInfo?: Maybe<BatchPayload>;
  deleteManyVetsourceCodeTag?: Maybe<BatchPayload>;
  deleteManyVetsourceInstallation?: Maybe<BatchPayload>;
  deleteManyVetsourcePharmacyIntegration?: Maybe<BatchPayload>;
  deleteManyVetsourceRevenueCategory?: Maybe<BatchPayload>;
  deleteManyWorkflowEventSetting?: Maybe<BatchPayload>;
  deleteOneActiveIngredient?: Maybe<ActiveIngredient>;
  deleteOneAppointment?: Maybe<Appointment>;
  deleteOneAppointmentAvailability?: Maybe<AppointmentAvailability>;
  deleteOneAppointmentNoteTemplate?: Maybe<AppointmentNoteTemplate>;
  deleteOneAppointmentType?: Maybe<AppointmentType>;
  deleteOneAutomationRun?: Maybe<AutomationRun>;
  deleteOneAutomationRunAction?: Maybe<AutomationRunAction>;
  deleteOneAxionClinicConfiguration?: Maybe<AxionClinicConfiguration>;
  deleteOneAxionClinicUserConfiguration?: Maybe<AxionClinicUserConfiguration>;
  deleteOneBedrockInference?: Maybe<BedrockInference>;
  deleteOneBitwerxHealthcheck?: Maybe<BitwerxHealthcheck>;
  deleteOneBitwerxIntegration?: Maybe<BitwerxIntegration>;
  deleteOneBitwerxPaymentHealthcheckResult?: Maybe<BitwerxPaymentHealthcheckResult>;
  deleteOneBitwerxPaymentHealthcheckRun?: Maybe<BitwerxPaymentHealthcheckRun>;
  deleteOneBoardFilterColumn?: Maybe<BoardFilterColumn>;
  deleteOneBoardFilterSpecificDateRange?: Maybe<BoardFilterSpecificDateRange>;
  deleteOneBoehringerIngelheimCustomerAlignment?: Maybe<BoehringerIngelheimCustomerAlignment>;
  deleteOneBoehringerIngelheimTerritory?: Maybe<BoehringerIngelheimTerritory>;
  deleteOneBreed?: Maybe<Breed>;
  deleteOneCallHistory?: Maybe<CallHistory>;
  deleteOneCallParticipant?: Maybe<CallParticipant>;
  /** Deletes a CallRecording and its associated TwilioCallRecording */
  deleteOneCallRecording?: Maybe<CallRecording>;
  deleteOneCampaignRegistryCampaign?: Maybe<CampaignRegistryCampaign>;
  deleteOneCanonicalBreed?: Maybe<CanonicalBreed>;
  deleteOneCanonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfile>;
  deleteOneCanonicalService?: Maybe<CanonicalService>;
  deleteOneCanonicalSpecies?: Maybe<CanonicalSpecies>;
  deleteOneCareAddonEnrollment?: Maybe<CareAddonEnrollment>;
  deleteOneCareAddonPackage?: Maybe<CareAddonPackage>;
  deleteOneCareAddonPackageBenefit?: Maybe<CareAddonPackageBenefit>;
  deleteOneCareAuthorizationRequest?: Maybe<CareAuthorizationRequest>;
  deleteOneCareBenefit?: Maybe<CareBenefit>;
  deleteOneCareBenefitUsage?: Maybe<CareBenefitUsage>;
  deleteOneCareBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowup>;
  deleteOneCareBenefitUsageFollowupStep?: Maybe<CareBenefitUsageFollowupStep>;
  deleteOneCareBenefitUsageToInvoiceLineItem?: Maybe<CareBenefitUsageToInvoiceLineItem>;
  deleteOneCareCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheck>;
  deleteOneCareEnrollmentPayment?: Maybe<CareEnrollmentPayment>;
  deleteOneCareEnrollmentToStripeInvoiceItem?: Maybe<CareEnrollmentToStripeInvoiceItem>;
  deleteOneCareLapsedPayment?: Maybe<CareLapsedPayment>;
  deleteOneCarePlan?: Maybe<CarePlan>;
  deleteOneCarePlanBenefit?: Maybe<CarePlanBenefit>;
  deleteOneCarePlanBenefitEnrollmentCarryover?: Maybe<CarePlanBenefitEnrollmentCarryover>;
  deleteOneCarePlanEnrollment?: Maybe<CarePlanEnrollment>;
  deleteOneCarePlanPricing?: Maybe<CarePlanPricing>;
  deleteOneCarePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  deleteOneCareStripeSubscription?: Maybe<CareStripeSubscription>;
  deleteOneCareSubscriptionTrueUp?: Maybe<CareSubscriptionTrueUp>;
  deleteOneCareSubscriptionTrueUpLogEntry?: Maybe<CareSubscriptionTrueUpLogEntry>;
  deleteOneChannel?: Maybe<Channel>;
  deleteOneChannelAutomationStatus?: Maybe<ChannelAutomationStatus>;
  deleteOneChannelCreationSource?: Maybe<ChannelCreationSource>;
  deleteOneChannelFilterSelection?: Maybe<ChannelFilterSelection>;
  deleteOneChannelMember?: Maybe<ChannelMember>;
  deleteOneChannelMessage?: Maybe<ChannelMessage>;
  deleteOneChannelMessageAttachment?: Maybe<ChannelMessageAttachment>;
  deleteOneChannelMessageAutoResponse?: Maybe<ChannelMessageAutoResponse>;
  deleteOneChannelMessageReaction?: Maybe<ChannelMessageReaction>;
  deleteOneChannelPin?: Maybe<ChannelPin>;
  deleteOneChannelSelection?: Maybe<ChannelSelection>;
  deleteOneChannelStatus?: Maybe<ChannelStatus>;
  deleteOneChannelStatusChannelAssignee?: Maybe<ChannelStatusChannelAssignee>;
  deleteOneChemicalCompound?: Maybe<ChemicalCompound>;
  deleteOneClientConnectIntegration?: Maybe<ClientConnectIntegration>;
  deleteOneClinic?: Maybe<Clinic>;
  deleteOneClinicBlockedPhoneNumber?: Maybe<ClinicBlockedPhoneNumber>;
  deleteOneClinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetup>;
  deleteOneClinicDirectBookingSetting?: Maybe<ClinicDirectBookingSetting>;
  deleteOneClinicEmailCampaignSetting?: Maybe<ClinicEmailCampaignSetting>;
  deleteOneClinicEmployee?: Maybe<ClinicEmployee>;
  deleteOneClinicEmployeeAppointmentTypeSetting?: Maybe<ClinicEmployeeAppointmentTypeSetting>;
  deleteOneClinicEntityPhoneNumber?: Maybe<ClinicEntityPhoneNumber>;
  deleteOneClinicModule?: Maybe<ClinicModule>;
  deleteOneClinicOfficeHour?: Maybe<ClinicOfficeHour>;
  deleteOneClinicOnboarding?: Maybe<ClinicOnboarding>;
  deleteOneClinicPaymentFeeConfiguration?: Maybe<ClinicPaymentFeeConfiguration>;
  deleteOneClinicPet?: Maybe<ClinicPet>;
  deleteOneClinicPetAlert?: Maybe<ClinicPetAlert>;
  deleteOneClinicPetCustomFieldValue?: Maybe<ClinicPetCustomFieldValue>;
  deleteOneClinicPetParent?: Maybe<ClinicPetParent>;
  deleteOneClinicPetParentAddress?: Maybe<ClinicPetParentAddress>;
  deleteOneClinicPetParentCustomFieldValue?: Maybe<ClinicPetParentCustomFieldValue>;
  deleteOneClinicPetParentDevice?: Maybe<ClinicPetParentDevice>;
  deleteOneClinicPetParentPimsSyncStatus?: Maybe<ClinicPetParentPimsSyncStatus>;
  deleteOneClinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatus>;
  deleteOneClinicPhoneNumber?: Maybe<ClinicPhoneNumber>;
  deleteOneClinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  deleteOneClinicPimsIntegrationCapability?: Maybe<ClinicPimsIntegrationCapability>;
  deleteOneClinicPimsIntegrationCapabilityHistoryEntry?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntry>;
  deleteOneClinicPostcardSetting?: Maybe<ClinicPostcardSetting>;
  deleteOneClinicRoom?: Maybe<ClinicRoom>;
  deleteOneClinicSetting?: Maybe<ClinicSetting>;
  deleteOneClinicUserFilter?: Maybe<ClinicUserFilter>;
  deleteOneClinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  deleteOneClinicWidgetRequestType?: Maybe<ClinicWidgetRequestType>;
  deleteOneClinicWidgetSetting?: Maybe<ClinicWidgetSetting>;
  deleteOneColor?: Maybe<Color>;
  deleteOneCondition?: Maybe<Condition>;
  deleteOneConditionSet?: Maybe<ConditionSet>;
  deleteOneConditionalEntityEvaluation?: Maybe<ConditionalEntityEvaluation>;
  deleteOneConsultationRequest?: Maybe<ConsultationRequest>;
  deleteOneCustomFieldDefinition?: Maybe<CustomFieldDefinition>;
  deleteOneCustomFieldPimsWritebackLogEntry?: Maybe<CustomFieldPimsWritebackLogEntry>;
  deleteOneDirectBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSetting>;
  deleteOneDirectBookingExclusionRule?: Maybe<DirectBookingExclusionRule>;
  deleteOneDirectBookingExclusionTimeSlot?: Maybe<DirectBookingExclusionTimeSlot>;
  deleteOneDisbursement?: Maybe<Disbursement>;
  deleteOneDocumentation?: Maybe<Documentation>;
  deleteOneEmailCampaign?: Maybe<EmailCampaign>;
  deleteOneEmailCampaignCustomList?: Maybe<EmailCampaignCustomList>;
  deleteOneEmailCampaignCustomListRecipient?: Maybe<EmailCampaignCustomListRecipient>;
  deleteOneEmailCampaignCustomListUploadHistory?: Maybe<EmailCampaignCustomListUploadHistory>;
  deleteOneEmailCampaignLog?: Maybe<EmailCampaignLog>;
  deleteOneEmailCampaignTemplate?: Maybe<EmailCampaignTemplate>;
  deleteOneEmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribe>;
  deleteOneEmailProviderLog?: Maybe<EmailProviderLog>;
  deleteOneEmergencyClinics?: Maybe<EmergencyClinics>;
  deleteOneEncryptedClinicUpload?: Maybe<EncryptedClinicUpload>;
  deleteOneEnrollmentSupportEvent?: Maybe<EnrollmentSupportEvent>;
  deleteOneEzyVetIntegration?: Maybe<EzyVetIntegration>;
  deleteOneFeatureFlag?: Maybe<FeatureFlag>;
  deleteOneFinancialAdjustment?: Maybe<FinancialAdjustment>;
  deleteOneFinancialTransaction?: Maybe<FinancialTransaction>;
  deleteOneFormSubmission?: Maybe<FormSubmission>;
  deleteOneFormTemplate?: Maybe<FormTemplate>;
  deleteOneGlobalPetParent?: Maybe<GlobalPetParent>;
  deleteOneGooglePlace?: Maybe<GooglePlace>;
  deleteOneHillsToHomeAPILog?: Maybe<HillsToHomeApiLog>;
  deleteOneInformAudienceDefinition?: Maybe<InformAudienceDefinition>;
  deleteOneInformAudienceMember?: Maybe<InformAudienceMember>;
  deleteOneInformAudienceMemberMessage?: Maybe<InformAudienceMemberMessage>;
  deleteOneInformAutomationCampaign?: Maybe<InformAutomationCampaign>;
  deleteOneInformCampaign?: Maybe<InformCampaign>;
  deleteOneInformCampaignEnrollment?: Maybe<InformCampaignEnrollment>;
  deleteOneInformCampaignEnrollmentCanonicalService?: Maybe<InformCampaignEnrollmentCanonicalService>;
  deleteOneInformCampaignExecution?: Maybe<InformCampaignExecution>;
  deleteOneInformCampaignGroup?: Maybe<InformCampaignGroup>;
  deleteOneInformCommunicationOptOut?: Maybe<InformCommunicationOptOut>;
  deleteOneInformControlGroupParticipant?: Maybe<InformControlGroupParticipant>;
  deleteOneInformEmailTemplate?: Maybe<InformEmailTemplate>;
  deleteOneInformEntityHistory?: Maybe<InformEntityHistory>;
  deleteOneInformEventDrivenCampaign?: Maybe<InformEventDrivenCampaign>;
  deleteOneInformEventListener?: Maybe<InformEventListener>;
  deleteOneInformNotificationRecipient?: Maybe<InformNotificationRecipient>;
  deleteOneInformPartner?: Maybe<InformPartner>;
  deleteOneInformPartnerCustomer?: Maybe<InformPartnerCustomer>;
  deleteOneInformPartnerCustomerPharmacyProvider?: Maybe<InformPartnerCustomerPharmacyProvider>;
  deleteOneInformPartnerIntegration?: Maybe<InformPartnerIntegration>;
  deleteOneInformPartnerIntegrationModel?: Maybe<InformPartnerIntegrationModel>;
  deleteOneInformPartnerProgram?: Maybe<InformPartnerProgram>;
  deleteOneInformPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollment>;
  deleteOneInformPartnerUser?: Maybe<InformPartnerUser>;
  deleteOneInformPartnerUserRole?: Maybe<InformPartnerUserRole>;
  deleteOneInformScheduledCampaign?: Maybe<InformScheduledCampaign>;
  deleteOneInformSession?: Maybe<InformSession>;
  deleteOneInformSessionEvent?: Maybe<InformSessionEvent>;
  deleteOneInstinctIntegration?: Maybe<InstinctIntegration>;
  deleteOneInsuranceIntegration?: Maybe<InsuranceIntegration>;
  deleteOneIntegrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntry>;
  deleteOneInterchangeRate?: Maybe<InterchangeRate>;
  deleteOneInvoice?: Maybe<Invoice>;
  deleteOneInvoiceLineItem?: Maybe<InvoiceLineItem>;
  deleteOneInvoicePimsWritebackLogEntry?: Maybe<InvoicePimsWritebackLogEntry>;
  deleteOneLabPanel?: Maybe<LabPanel>;
  deleteOneLabResult?: Maybe<LabResult>;
  deleteOneLapsedPetParentTriggers?: Maybe<LapsedPetParentTriggers>;
  deleteOneLoyaltyAccount?: Maybe<LoyaltyAccount>;
  deleteOneLoyaltyAccountHolder?: Maybe<LoyaltyAccountHolder>;
  deleteOneLoyaltyAccountMerger?: Maybe<LoyaltyAccountMerger>;
  deleteOneLoyaltyInvoicePointGranter?: Maybe<LoyaltyInvoicePointGranter>;
  deleteOneLoyaltyPointGrantingService?: Maybe<LoyaltyPointGrantingService>;
  deleteOneLoyaltyPointGrantingServiceCategory?: Maybe<LoyaltyPointGrantingServiceCategory>;
  deleteOneLoyaltyPointUserGrant?: Maybe<LoyaltyPointUserGrant>;
  deleteOneLoyaltyRewardRedemption?: Maybe<LoyaltyRewardRedemption>;
  deleteOneMassTextAlert?: Maybe<MassTextAlert>;
  deleteOneMassTextAlertEntry?: Maybe<MassTextAlertEntry>;
  deleteOneMassTextAlertEntryAppointment?: Maybe<MassTextAlertEntryAppointment>;
  deleteOneMedia?: Maybe<Media>;
  deleteOneMedicalHistory?: Maybe<MedicalHistory>;
  deleteOneMessageTemplate?: Maybe<MessageTemplate>;
  deleteOneMessagingCampaign?: Maybe<MessagingCampaign>;
  deleteOneMessagingPartner?: Maybe<MessagingPartner>;
  deleteOneModule?: Maybe<Module>;
  deleteOneNonPrismaSchemaScriptRan?: Maybe<NonPrismaSchemaScriptRan>;
  deleteOneNotificationEventToMessage?: Maybe<NotificationEventToMessage>;
  deleteOneOrganization?: Maybe<Organization>;
  deleteOneOrganizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicService>;
  deleteOneOrganizationCareBenefitToClinicServiceCategory?: Maybe<OrganizationCareBenefitToClinicServiceCategory>;
  deleteOneOrganizationPet?: Maybe<OrganizationPet>;
  deleteOneOrganizationPetParent?: Maybe<OrganizationPetParent>;
  deleteOneOrganizationPetToOrganizationPetParent?: Maybe<OrganizationPetToOrganizationPetParent>;
  deleteOnePPCIntegration?: Maybe<PpcIntegration>;
  deleteOnePaymentsReportTransaction?: Maybe<PaymentsReportTransaction>;
  deleteOnePayoutBatchingSchedule?: Maybe<PayoutBatchingSchedule>;
  deleteOnePayoutBatchingSetting?: Maybe<PayoutBatchingSetting>;
  deleteOnePermission?: Maybe<Permission>;
  deleteOnePetParentSetting?: Maybe<PetParentSetting>;
  deleteOnePetPortalSetting?: Maybe<PetPortalSetting>;
  deleteOnePhoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequest>;
  deleteOnePhoneNumberLookupResult?: Maybe<PhoneNumberLookupResult>;
  deleteOnePimsInvoice?: Maybe<PimsInvoice>;
  deleteOnePimsInvoiceLineItem?: Maybe<PimsInvoiceLineItem>;
  deleteOnePimsWritebackLogEntry?: Maybe<PimsWritebackLogEntry>;
  deleteOnePrescription?: Maybe<Prescription>;
  deleteOneProduct?: Maybe<Product>;
  deleteOneProductPackage?: Maybe<ProductPackage>;
  deleteOneProductPackageSubscription?: Maybe<ProductPackageSubscription>;
  deleteOneProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMap>;
  deleteOnePushNotificationLog?: Maybe<PushNotificationLog>;
  deleteOneRecap?: Maybe<Recap>;
  deleteOneRules?: Maybe<Rules>;
  deleteOneSegment?: Maybe<Segment>;
  deleteOneSentTrupanionExamDayOffer?: Maybe<SentTrupanionExamDayOffer>;
  deleteOneService?: Maybe<Service>;
  deleteOneServiceCategory?: Maybe<ServiceCategory>;
  deleteOneServicePurchaseSummary?: Maybe<ServicePurchaseSummary>;
  deleteOneServiceReminder?: Maybe<ServiceReminder>;
  deleteOneServiceReminderNotification?: Maybe<ServiceReminderNotification>;
  deleteOneServiceReminderTiming?: Maybe<ServiceReminderTiming>;
  deleteOneSex?: Maybe<Sex>;
  deleteOneSmsNotificationStatus?: Maybe<SmsNotificationStatus>;
  deleteOneSpecies?: Maybe<Species>;
  deleteOneStaffRole?: Maybe<StaffRole>;
  deleteOneStripeCustomer?: Maybe<StripeCustomer>;
  deleteOneStripeDispute?: Maybe<StripeDispute>;
  deleteOneStripeInvoice?: Maybe<StripeInvoice>;
  deleteOneStripeInvoiceItem?: Maybe<StripeInvoiceItem>;
  deleteOneStripePaymentMethod?: Maybe<StripePaymentMethod>;
  deleteOneStripePayout?: Maybe<StripePayout>;
  deleteOneStripePayoutAccount?: Maybe<StripePayoutAccount>;
  deleteOneStripeReceipt?: Maybe<StripeReceipt>;
  deleteOneStripeReceiptHistory?: Maybe<StripeReceiptHistory>;
  deleteOneStripeRefund?: Maybe<StripeRefund>;
  deleteOneStripeTerminal?: Maybe<StripeTerminal>;
  deleteOneStripeTerminalLocation?: Maybe<StripeTerminalLocation>;
  deleteOneSurveyAppointmentTypeSetting?: Maybe<SurveyAppointmentTypeSetting>;
  deleteOneSurveyResult?: Maybe<SurveyResult>;
  deleteOneSurveySetting?: Maybe<SurveySetting>;
  deleteOneSyncVetIntegration?: Maybe<SyncVetIntegration>;
  deleteOneSyncVetService?: Maybe<SyncVetService>;
  deleteOneSynchronyClinicConfiguration?: Maybe<SynchronyClinicConfiguration>;
  deleteOneSynchronyEvent?: Maybe<SynchronyEvent>;
  deleteOneTask?: Maybe<Task>;
  deleteOneTaxonomy?: Maybe<Taxonomy>;
  deleteOneTaxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinition>;
  deleteOneTransaction?: Maybe<Transaction>;
  deleteOneTrupanionCertificateAvailability?: Maybe<TrupanionCertificateAvailability>;
  deleteOneTrupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentType>;
  deleteOneTrupanionIntegration?: Maybe<TrupanionIntegration>;
  deleteOneUser?: Maybe<User>;
  deleteOneUserAppointmentGrouping?: Maybe<UserAppointmentGrouping>;
  deleteOneUserBoardFilter?: Maybe<UserBoardFilter>;
  deleteOneUserChannelFilterSelection?: Maybe<UserChannelFilterSelection>;
  deleteOneUserNotificationSetting?: Maybe<UserNotificationSetting>;
  deleteOneUserSetting?: Maybe<UserSetting>;
  deleteOneUserTaskList?: Maybe<UserTaskList>;
  deleteOneUserTaskListFilter?: Maybe<UserTaskListFilter>;
  deleteOneVaccination?: Maybe<Vaccination>;
  deleteOneVetAvailability?: Maybe<VetAvailability>;
  deleteOneVetAvailabilityClinicRoomMap?: Maybe<VetAvailabilityClinicRoomMap>;
  deleteOneVetAvailabilityMap?: Maybe<VetAvailabilityMap>;
  deleteOneVetInfo?: Maybe<VetInfo>;
  deleteOneVetsourceCodeTag?: Maybe<VetsourceCodeTag>;
  deleteOneVetsourceInstallation?: Maybe<VetsourceInstallation>;
  deleteOneVetsourcePharmacyIntegration?: Maybe<VetsourcePharmacyIntegration>;
  deleteOneVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategory>;
  deleteOneWorkflowEventSetting?: Maybe<WorkflowEventSetting>;
  downloadManyCallRecordings?: Maybe<Array<Maybe<MessageEventResponse>>>;
  duplicateEmailCampaign?: Maybe<EmailCampaign>;
  encryptAndUploadData: EncryptedUploadResponse;
  endOneAxionCall?: Maybe<AxionCallOutput>;
  ensurePetsPromoted?: Maybe<EnsurePetsPromotedResult>;
  findOrCreateLoyaltyAccountForClinicPetParent: LoyaltyAccount;
  findOrCreateLoyaltyProgram: LoyaltyProgram;
  formSubmissionExportToPims?: Maybe<FormSubmissionExportResponse>;
  fulfillLoyaltyRewardRedemption: LoyaltyRewardRedemption;
  generateCustomToken?: Maybe<GenerateCustomTokenResponse>;
  generateIntercomJwt: Scalars['String'];
  generateTerminalAuthToken?: Maybe<GenerateTerminalAuthTokenResponse>;
  generateTerminalSetupPin?: Maybe<GenerateTerminalSetupPinResponse>;
  generateTinyUrlAndToken?: Maybe<Scalars['Json']>;
  generateWidgetAuthenticationRequest?: Maybe<GenerateWidgetAuthenticationRequestResponse>;
  geocodeSalesforceAccount?: Maybe<GeocodeSalesforceAccountResponse>;
  getDirectedCareLoginLink: GetDirectedAuthLinkResult;
  getOrCreateActiveChannel?: Maybe<Channel>;
  getOrCreateActiveClientChannel?: Maybe<Channel>;
  getSignedDownloadUrl?: Maybe<Scalars['String']>;
  getSignedUploadUrl: GetSignedUploadUrlOutput;
  ignoreOneAxionCall?: Maybe<AxionCallOutput>;
  initSurveySetting: SurveySetting;
  /** Merge the information from the deleteId petparent into the keepId pet parent and soft delete deleteId */
  mergePetParent: MergePetParentResult;
  orderPhoneNumber?: Maybe<ClinicPhoneNumber>;
  performCarePlanEnrollmentUpgrade?: Maybe<PerformCarePlanEnrollmentUpgradeOutput>;
  postCareInvoiceAccountCreditToPims: WritebackCareInvoiceAccountCreditToPimsResponse;
  processAppointmentRecap: ProcessAppointmentRecapOutput;
  processAppointmentRecapChunks: ProcessAppointmentRecapChunksOutput;
  processTerminalPayment?: Maybe<ProcessTerminalPaymentResponse>;
  redeemClinicPetParentAuthCode?: Maybe<Scalars['Json']>;
  redeemOneTimeCode: RedeemOneTimeCodeResult;
  refundStripePaymentIntent2?: Maybe<StripePaymentIntent>;
  regeneratePetParentClinicListWithTokens?: Maybe<Scalars['Json']>;
  registerTwilioSubaccount?: Maybe<GenericResponse>;
  removeChannelMember2?: Maybe<ChannelMember>;
  removeChannelTag?: Maybe<Channel>;
  removeClinicFromLoyaltyProgram: OperationResult;
  removeUserFromClinic: User;
  requestBitwerxIntegration?: Maybe<ClinicPimsIntegration>;
  requestCareLoginLink: AuthLinkRequestResult;
  requestLoyaltyReward: LoyaltyRewardRedemption;
  requestOneTimeCode: RequestOneTimeCodeResult;
  resendReceiptEmail: ResendReceiptEmailOutput;
  resendUserInvitation: User;
  resetAutomationRun?: Maybe<AutomationRun>;
  retryPaymentWriteback?: Maybe<RetryPaymentWritebackOutput>;
  retryProcessAppointmentRecap: RetryProcessAppointmentRecapOutput;
  retryTwilioCampaignRegistration?: Maybe<GenericResponse>;
  saveEmailTemplateVersion: EmailTemplateVersion;
  sendCareSignUpEmail?: Maybe<SendCareSignUpEmailOutput>;
  sendClinicPetParentAuthCode?: Maybe<SendClinicPetParentAuthCodeResponse>;
  /** @deprecated Use sendClinicPetParentAuthCode instead */
  sendClinicPetParentAuthLink?: Maybe<ClinicPetParentAuthLinkResponse>;
  sendConsultationReceipt?: Maybe<Scalars['Json']>;
  sendDirectedCareLoginLink: DirectedAuthLinkResult;
  sendEmailCampaignNow?: Maybe<SentEmailCampaign>;
  sendEnrollmentEmail?: Maybe<SendEnrollmentEmailOutput>;
  sendPaymentToTerminal?: Maybe<SendPaymentToTerminalResponse>;
  sendUiRefreshEvent?: Maybe<UiRefresh>;
  sendWidgetCodeToDeveloper?: Maybe<GenericResponse>;
  setClinicPetParentPrivacy?: Maybe<PrivacyResponse>;
  setPaymentIntentClinicPetParent2?: Maybe<StripePaymentIntent>;
  startChecksOnRecapChunksContinuity: StartChecksOnRecapChunksContinuityOutput;
  stripeConnectConnectedAccount?: Maybe<StripeAccountOutput>;
  stripeCreateConnectedAccount?: Maybe<StripeCreateAccountOutput>;
  submitForm2?: Maybe<SubmitFormResponse>;
  submitLoyaltyPointGrantToAccountByUser: OperationResult;
  submitPetParentRequest?: Maybe<SubmitFormResponse>;
  submitPrescriptionRefillRequest: SubmitPrescriptionRefillRequestResponse;
  syncClinic?: Maybe<Scalars['Json']>;
  syncManyPimsIntegrationModel?: Maybe<Array<ClinicPimsIntegrationCapability>>;
  syncPimsIntegrationModel: ClinicPimsIntegrationCapability;
  toggleTwilioVideoCallRecordingStatus?: Maybe<CallRecording>;
  transferCareSubscription?: Maybe<TransferSubscriptionOutput>;
  transferTwilioNumber?: Maybe<GenericResponse>;
  triggerLoyaltyInvoiceProcessing: LoyaltyInvoiceTriggerOutput;
  triggerMessageEvent?: Maybe<MessageEventResponse>;
  triggerWorkflowEvent?: Maybe<GenericResponse>;
  trupanionIssueCertificate?: Maybe<TrupanionIssueCertificateResponse>;
  twilioGetOrCreateHostedNumberOrder?: Maybe<TwilioGetOrCreateHostedNumberOrderOutput>;
  twilioGetOrGenerateLOA?: Maybe<TwilioGetOrGenerateLoaResponse>;
  twilioPurchaseNumber?: Maybe<GenericResponse>;
  twilioVerifyCallerId?: Maybe<TwilioCallerIdVerification>;
  twilioVerifySubAccountCallerId?: Maybe<TwilioCallerIdVerification>;
  updateAppointmentTypeProviderRoomMaps: UpdateAppointmentTypeProviderRoomMapsResponse;
  updateCareSubscription?: Maybe<UpdateCareSubscriptionResult>;
  updateChannelFilterSelection: ChannelFilterSelection;
  updateClinicAppointmentTypeSettings?: Maybe<AppointmentType>;
  updateClinicPetParentContactInfoFromPims: ClinicPetParent;
  updateClinicPetWithoutPims?: Maybe<ClinicPet>;
  updateClinicPostcardSetting: ClinicPostcardSetting;
  updateClinicSettingTransactionColumn: ClinicSetting;
  updateManyActiveIngredient?: Maybe<BatchPayload>;
  updateManyAppointment?: Maybe<BatchPayload>;
  updateManyAppointmentAvailability?: Maybe<BatchPayload>;
  updateManyAppointmentNoteTemplate?: Maybe<BatchPayload>;
  updateManyAppointmentType?: Maybe<BatchPayload>;
  updateManyAppointmentTypeSortOrder: AppointmentTypeWithOrderResponse;
  updateManyAutomationRun?: Maybe<BatchPayload>;
  updateManyAutomationRunAction?: Maybe<BatchPayload>;
  updateManyAxionClinicConfiguration?: Maybe<BatchPayload>;
  updateManyAxionClinicUserConfiguration?: Maybe<BatchPayload>;
  updateManyBedrockInference?: Maybe<BatchPayload>;
  updateManyBitwerxHealthcheck?: Maybe<BatchPayload>;
  updateManyBitwerxIntegration?: Maybe<BatchPayload>;
  updateManyBitwerxPaymentHealthcheckResult?: Maybe<BatchPayload>;
  updateManyBitwerxPaymentHealthcheckRun?: Maybe<BatchPayload>;
  updateManyBoardFilterColumn?: Maybe<BatchPayload>;
  updateManyBoardFilterSpecificDateRange?: Maybe<BatchPayload>;
  updateManyBoehringerIngelheimCustomerAlignment?: Maybe<BatchPayload>;
  updateManyBoehringerIngelheimTerritory?: Maybe<BatchPayload>;
  updateManyBreed?: Maybe<BatchPayload>;
  updateManyCallHistory?: Maybe<BatchPayload>;
  updateManyCallParticipant?: Maybe<BatchPayload>;
  updateManyCampaignRegistryCampaign?: Maybe<BatchPayload>;
  updateManyCanonicalBreed?: Maybe<BatchPayload>;
  updateManyCanonicalCanineBreedProfile?: Maybe<BatchPayload>;
  updateManyCanonicalService?: Maybe<BatchPayload>;
  updateManyCanonicalSpecies?: Maybe<BatchPayload>;
  updateManyCareAddonEnrollment?: Maybe<BatchPayload>;
  updateManyCareAddonPackage?: Maybe<BatchPayload>;
  updateManyCareAddonPackageBenefit?: Maybe<BatchPayload>;
  updateManyCareAuthorizationRequest?: Maybe<BatchPayload>;
  updateManyCareBenefit?: Maybe<BatchPayload>;
  updateManyCareBenefitUsage?: Maybe<BatchPayload>;
  updateManyCareBenefitUsageFollowup?: Maybe<BatchPayload>;
  updateManyCareBenefitUsageFollowupStep?: Maybe<BatchPayload>;
  updateManyCareBenefitUsageToInvoiceLineItem?: Maybe<BatchPayload>;
  updateManyCareCreditPreapprovalCheck?: Maybe<BatchPayload>;
  updateManyCareEnrollmentPayment?: Maybe<BatchPayload>;
  updateManyCareEnrollmentToStripeInvoiceItem?: Maybe<BatchPayload>;
  updateManyCareLapsedPayment?: Maybe<BatchPayload>;
  updateManyCarePlan?: Maybe<BatchPayload>;
  updateManyCarePlanBenefit?: Maybe<BatchPayload>;
  updateManyCarePlanBenefitEnrollmentCarryover?: Maybe<BatchPayload>;
  updateManyCarePlanEnrollment?: Maybe<BatchPayload>;
  updateManyCarePlanPricing?: Maybe<BatchPayload>;
  updateManyCarePlanProviderGroup?: Maybe<BatchPayload>;
  updateManyCareStripeSubscription?: Maybe<BatchPayload>;
  updateManyCareSubscriptionTrueUp?: Maybe<BatchPayload>;
  updateManyCareSubscriptionTrueUpLogEntry?: Maybe<BatchPayload>;
  updateManyChannel?: Maybe<BatchPayload>;
  updateManyChannelAutomationStatus?: Maybe<BatchPayload>;
  updateManyChannelCreationSource?: Maybe<BatchPayload>;
  updateManyChannelFilterSelection?: Maybe<BatchPayload>;
  updateManyChannelMember?: Maybe<BatchPayload>;
  updateManyChannelMessage?: Maybe<BatchPayload>;
  updateManyChannelMessageAttachment?: Maybe<BatchPayload>;
  updateManyChannelMessageAutoResponse?: Maybe<BatchPayload>;
  updateManyChannelMessageReaction?: Maybe<BatchPayload>;
  updateManyChannelPin?: Maybe<BatchPayload>;
  updateManyChannelSelection?: Maybe<BatchPayload>;
  updateManyChannelStatus?: Maybe<BatchPayload>;
  updateManyChannelStatusChannelAssignee?: Maybe<BatchPayload>;
  updateManyChannelStatusSortOrder: ChannelStatusWithOrderResponse;
  updateManyChemicalCompound?: Maybe<BatchPayload>;
  updateManyClientConnectIntegration?: Maybe<BatchPayload>;
  updateManyClinic?: Maybe<BatchPayload>;
  updateManyClinicBlockedPhoneNumber?: Maybe<BatchPayload>;
  updateManyClinicCustomPayoutsSetup?: Maybe<BatchPayload>;
  updateManyClinicDirectBookingSetting?: Maybe<BatchPayload>;
  updateManyClinicEmailCampaignSetting?: Maybe<BatchPayload>;
  updateManyClinicEmployee?: Maybe<BatchPayload>;
  updateManyClinicEmployeeAppointmentTypeSetting?: Maybe<BatchPayload>;
  updateManyClinicEntityPhoneNumber?: Maybe<BatchPayload>;
  updateManyClinicModule?: Maybe<BatchPayload>;
  updateManyClinicOfficeHour?: Maybe<BatchPayload>;
  updateManyClinicOnboarding?: Maybe<BatchPayload>;
  updateManyClinicPaymentFeeConfiguration?: Maybe<BatchPayload>;
  updateManyClinicPet?: Maybe<BatchPayload>;
  updateManyClinicPetAlert?: Maybe<BatchPayload>;
  updateManyClinicPetCustomFieldValue?: Maybe<BatchPayload>;
  updateManyClinicPetParent?: Maybe<BatchPayload>;
  updateManyClinicPetParentAddress?: Maybe<BatchPayload>;
  updateManyClinicPetParentCustomFieldValue?: Maybe<BatchPayload>;
  updateManyClinicPetParentDevice?: Maybe<BatchPayload>;
  updateManyClinicPetParentPimsSyncStatus?: Maybe<BatchPayload>;
  updateManyClinicPetPimsSyncStatus?: Maybe<BatchPayload>;
  updateManyClinicPhoneNumber?: Maybe<BatchPayload>;
  updateManyClinicPimsIntegration?: Maybe<BatchPayload>;
  updateManyClinicPimsIntegrationCapability?: Maybe<BatchPayload>;
  updateManyClinicPimsIntegrationCapabilityHistoryEntry?: Maybe<BatchPayload>;
  updateManyClinicPostcardSetting?: Maybe<BatchPayload>;
  updateManyClinicRoom?: Maybe<BatchPayload>;
  updateManyClinicSetting?: Maybe<BatchPayload>;
  updateManyClinicUserFilter?: Maybe<BatchPayload>;
  updateManyClinicWidgetRequest?: Maybe<BatchPayload>;
  updateManyClinicWidgetRequestType?: Maybe<BatchPayload>;
  updateManyClinicWidgetSetting?: Maybe<BatchPayload>;
  updateManyColor?: Maybe<BatchPayload>;
  updateManyCondition?: Maybe<BatchPayload>;
  updateManyConditionSet?: Maybe<BatchPayload>;
  updateManyConditionalEntityEvaluation?: Maybe<BatchPayload>;
  updateManyConsultationRequest?: Maybe<BatchPayload>;
  updateManyCustomFieldDefinition?: Maybe<BatchPayload>;
  updateManyCustomFieldPimsWritebackLogEntry?: Maybe<BatchPayload>;
  updateManyDirectBookingAppointmentTypeSetting?: Maybe<BatchPayload>;
  updateManyDirectBookingExclusionTimeSlot?: Maybe<BatchPayload>;
  updateManyDisbursement?: Maybe<BatchPayload>;
  updateManyDocumentation?: Maybe<BatchPayload>;
  updateManyEmailCampaign?: Maybe<BatchPayload>;
  updateManyEmailCampaignCustomList?: Maybe<BatchPayload>;
  updateManyEmailCampaignCustomListRecipient?: Maybe<BatchPayload>;
  updateManyEmailCampaignCustomListUploadHistory?: Maybe<BatchPayload>;
  updateManyEmailCampaignLog?: Maybe<BatchPayload>;
  updateManyEmailCampaignTemplate?: Maybe<BatchPayload>;
  updateManyEmailCampaignUnsubscribe?: Maybe<BatchPayload>;
  updateManyEmailProviderLog?: Maybe<BatchPayload>;
  updateManyEmailTemplateVersion?: Maybe<BatchPayload>;
  updateManyEmergencyClinics?: Maybe<BatchPayload>;
  updateManyEncryptedClinicUpload?: Maybe<BatchPayload>;
  updateManyEnrollmentSupportEvent?: Maybe<BatchPayload>;
  updateManyEzyVetIntegration?: Maybe<BatchPayload>;
  updateManyFeatureFlag?: Maybe<BatchPayload>;
  updateManyFinancialAdjustment?: Maybe<BatchPayload>;
  updateManyFinancialTransaction?: Maybe<BatchPayload>;
  updateManyFormSubmission?: Maybe<BatchPayload>;
  updateManyFormTemplate?: Maybe<BatchPayload>;
  updateManyGlobalPetParent?: Maybe<BatchPayload>;
  updateManyGooglePlace?: Maybe<BatchPayload>;
  updateManyHillsToHomeAPILog?: Maybe<BatchPayload>;
  updateManyInformAudienceDefinition?: Maybe<BatchPayload>;
  updateManyInformAudienceMember?: Maybe<BatchPayload>;
  updateManyInformAudienceMemberMessage?: Maybe<BatchPayload>;
  updateManyInformCampaign?: Maybe<BatchPayload>;
  updateManyInformCampaignEnrollment?: Maybe<BatchPayload>;
  updateManyInformCampaignEnrollmentCanonicalService?: Maybe<BatchPayload>;
  updateManyInformCampaignExecution?: Maybe<BatchPayload>;
  updateManyInformCampaignGroup?: Maybe<BatchPayload>;
  updateManyInformCommunicationOptOut?: Maybe<BatchPayload>;
  updateManyInformControlGroupParticipant?: Maybe<BatchPayload>;
  updateManyInformEmailTemplate?: Maybe<BatchPayload>;
  updateManyInformEntityHistory?: Maybe<BatchPayload>;
  updateManyInformEventDrivenCampaign?: Maybe<BatchPayload>;
  updateManyInformEventListener?: Maybe<BatchPayload>;
  updateManyInformNotificationRecipient?: Maybe<BatchPayload>;
  updateManyInformPartner?: Maybe<BatchPayload>;
  updateManyInformPartnerCustomer?: Maybe<BatchPayload>;
  updateManyInformPartnerCustomerPharmacyProvider?: Maybe<BatchPayload>;
  updateManyInformPartnerIntegration?: Maybe<BatchPayload>;
  updateManyInformPartnerIntegrationModel?: Maybe<BatchPayload>;
  updateManyInformPartnerProgram?: Maybe<BatchPayload>;
  updateManyInformPartnerProgramEnrollment?: Maybe<BatchPayload>;
  updateManyInformPartnerUser?: Maybe<BatchPayload>;
  updateManyInformPartnerUserRole?: Maybe<BatchPayload>;
  updateManyInformScheduledCampaign?: Maybe<BatchPayload>;
  updateManyInformSession?: Maybe<BatchPayload>;
  updateManyInformSessionEvent?: Maybe<BatchPayload>;
  updateManyInstinctIntegration?: Maybe<BatchPayload>;
  updateManyInsuranceIntegration?: Maybe<BatchPayload>;
  updateManyIntegrationOutageHistoryEntry?: Maybe<BatchPayload>;
  updateManyInterchangeRate?: Maybe<BatchPayload>;
  updateManyInvoice?: Maybe<BatchPayload>;
  updateManyInvoiceLineItem?: Maybe<BatchPayload>;
  updateManyInvoicePimsWritebackLogEntry?: Maybe<BatchPayload>;
  updateManyLabPanel?: Maybe<BatchPayload>;
  updateManyLabResult?: Maybe<BatchPayload>;
  updateManyLapsedPetParentTriggers?: Maybe<BatchPayload>;
  updateManyLegalEntity?: Maybe<BatchPayload>;
  updateManyLoyaltyAccount?: Maybe<BatchPayload>;
  updateManyLoyaltyAccountHolder?: Maybe<BatchPayload>;
  updateManyLoyaltyAccountMerger?: Maybe<BatchPayload>;
  updateManyLoyaltyInvoicePointGranter?: Maybe<BatchPayload>;
  updateManyLoyaltyPointGrantingService?: Maybe<BatchPayload>;
  updateManyLoyaltyPointGrantingServiceCategory?: Maybe<BatchPayload>;
  updateManyLoyaltyPointUserGrant?: Maybe<BatchPayload>;
  updateManyLoyaltyReward?: Maybe<BatchPayload>;
  updateManyLoyaltyRewardRedemption?: Maybe<BatchPayload>;
  updateManyMassTextAlert?: Maybe<BatchPayload>;
  updateManyMassTextAlertEntry?: Maybe<BatchPayload>;
  updateManyMassTextAlertEntryAppointment?: Maybe<BatchPayload>;
  updateManyMedia?: Maybe<BatchPayload>;
  updateManyMedicalHistory?: Maybe<BatchPayload>;
  updateManyMessageTemplate?: Maybe<BatchPayload>;
  updateManyMessagingCampaign?: Maybe<BatchPayload>;
  updateManyMessagingPartner?: Maybe<BatchPayload>;
  updateManyModule?: Maybe<BatchPayload>;
  updateManyNonPrismaSchemaScriptRan?: Maybe<BatchPayload>;
  updateManyNotificationEventToMessage?: Maybe<BatchPayload>;
  updateManyOrganization?: Maybe<BatchPayload>;
  updateManyOrganizationCareBenefitToClinicServiceCategory?: Maybe<BatchPayload>;
  updateManyOrganizationPet?: Maybe<BatchPayload>;
  updateManyOrganizationPetParent?: Maybe<BatchPayload>;
  updateManyPPCIntegration?: Maybe<BatchPayload>;
  updateManyPaymentsReportTransaction?: Maybe<BatchPayload>;
  updateManyPayoutBatchingPeriod?: Maybe<BatchPayload>;
  updateManyPayoutBatchingSchedule?: Maybe<BatchPayload>;
  updateManyPayoutBatchingSetting?: Maybe<BatchPayload>;
  updateManyPermission?: Maybe<BatchPayload>;
  updateManyPetParentSetting?: Maybe<BatchPayload>;
  updateManyPetPortalSetting?: Maybe<BatchPayload>;
  updateManyPhoneNumberLookupRequest?: Maybe<BatchPayload>;
  updateManyPhoneNumberLookupResult?: Maybe<BatchPayload>;
  updateManyPimsInvoice?: Maybe<BatchPayload>;
  updateManyPimsInvoiceLineItem?: Maybe<BatchPayload>;
  updateManyPimsWritebackLogEntry?: Maybe<BatchPayload>;
  updateManyPrescription?: Maybe<BatchPayload>;
  updateManyProduct?: Maybe<BatchPayload>;
  updateManyProductPackage?: Maybe<BatchPayload>;
  updateManyProductPackageSubscription?: Maybe<BatchPayload>;
  updateManyProviderAppointmentTypeRoomMap?: Maybe<BatchPayload>;
  updateManyPushNotificationLog?: Maybe<BatchPayload>;
  updateManyRecap?: Maybe<BatchPayload>;
  updateManyRules?: Maybe<BatchPayload>;
  updateManySegment?: Maybe<BatchPayload>;
  updateManySentTrupanionExamDayOffer?: Maybe<BatchPayload>;
  updateManyService?: Maybe<BatchPayload>;
  updateManyServiceCategory?: Maybe<BatchPayload>;
  updateManyServicePurchaseSummary?: Maybe<BatchPayload>;
  updateManyServiceReminder?: Maybe<BatchPayload>;
  updateManyServiceReminderNotification?: Maybe<BatchPayload>;
  updateManyServiceReminderTiming?: Maybe<BatchPayload>;
  updateManyServicesAndTimings: Array<Service>;
  updateManySex?: Maybe<BatchPayload>;
  updateManySmsNotificationStatus?: Maybe<BatchPayload>;
  updateManySpecies?: Maybe<BatchPayload>;
  updateManyStaffRole?: Maybe<BatchPayload>;
  updateManyStripeCustomer?: Maybe<BatchPayload>;
  updateManyStripeDispute?: Maybe<BatchPayload>;
  updateManyStripeInvoice?: Maybe<BatchPayload>;
  updateManyStripeInvoiceItem?: Maybe<BatchPayload>;
  updateManyStripePaymentIntent?: Maybe<BatchPayload>;
  updateManyStripePaymentMethod?: Maybe<BatchPayload>;
  updateManyStripePayout?: Maybe<BatchPayload>;
  updateManyStripePayoutAccount?: Maybe<BatchPayload>;
  updateManyStripeReceipt?: Maybe<BatchPayload>;
  updateManyStripeReceiptHistory?: Maybe<BatchPayload>;
  updateManyStripeRefund?: Maybe<BatchPayload>;
  updateManyStripeTerminal?: Maybe<BatchPayload>;
  updateManyStripeTerminalLocation?: Maybe<BatchPayload>;
  updateManySurveyAppointmentTypeSetting?: Maybe<BatchPayload>;
  updateManySurveyResult?: Maybe<BatchPayload>;
  updateManySurveySetting?: Maybe<BatchPayload>;
  updateManySyncVetIntegration?: Maybe<BatchPayload>;
  updateManySyncVetService?: Maybe<BatchPayload>;
  updateManySynchronyClinicConfiguration?: Maybe<BatchPayload>;
  updateManySynchronyEvent?: Maybe<BatchPayload>;
  updateManyTask?: Maybe<BatchPayload>;
  updateManyTaxonomy?: Maybe<BatchPayload>;
  updateManyTaxonomyToInformAudienceDefinition?: Maybe<BatchPayload>;
  updateManyTimingsDeliveryOptions: Array<Service>;
  updateManyTransaction?: Maybe<BatchPayload>;
  updateManyTrupanionCertificateAvailability?: Maybe<BatchPayload>;
  updateManyTrupanionIntegratedAppointmentType?: Maybe<BatchPayload>;
  updateManyTrupanionIntegration?: Maybe<BatchPayload>;
  updateManyUser?: Maybe<BatchPayload>;
  updateManyUserAppointmentGrouping?: Maybe<BatchPayload>;
  updateManyUserBoardFilter?: Maybe<BatchPayload>;
  updateManyUserChannelFilterSelection?: Maybe<BatchPayload>;
  updateManyUserNotificationSetting?: Maybe<BatchPayload>;
  updateManyUserSetting?: Maybe<BatchPayload>;
  updateManyUserTaskList?: Maybe<BatchPayload>;
  updateManyUserTaskListFilter?: Maybe<BatchPayload>;
  updateManyVaccination?: Maybe<BatchPayload>;
  updateManyVetAvailability?: Maybe<BatchPayload>;
  updateManyVetAvailabilityClinicRoomMap?: Maybe<BatchPayload>;
  updateManyVetAvailabilityMap?: Maybe<BatchPayload>;
  updateManyVetInfo?: Maybe<BatchPayload>;
  updateManyVetsourceCodeTag?: Maybe<BatchPayload>;
  updateManyVetsourceInstallation?: Maybe<BatchPayload>;
  updateManyVetsourcePharmacyIntegration?: Maybe<BatchPayload>;
  updateManyVetsourceRevenueCategory?: Maybe<BatchPayload>;
  updateManyWorkflowEventSetting?: Maybe<BatchPayload>;
  updateOneActiveIngredient: ActiveIngredient;
  updateOneAppointment: Appointment;
  updateOneAppointmentAvailability: AppointmentAvailability;
  updateOneAppointmentNoteTemplate: AppointmentNoteTemplate;
  updateOneAppointmentType: AppointmentType;
  updateOneAutomationRun: AutomationRun;
  updateOneAutomationRunAction: AutomationRunAction;
  updateOneAxionCall?: Maybe<AxionCallOutput>;
  updateOneAxionClinicConfiguration: AxionClinicConfiguration;
  updateOneAxionClinicUserConfiguration: AxionClinicUserConfiguration;
  updateOneBedrockInference: BedrockInference;
  updateOneBitwerxHealthcheck: BitwerxHealthcheck;
  updateOneBitwerxIntegration: BitwerxIntegration;
  updateOneBitwerxPaymentHealthcheckResult: BitwerxPaymentHealthcheckResult;
  updateOneBitwerxPaymentHealthcheckRun: BitwerxPaymentHealthcheckRun;
  updateOneBitwerxPaymentWritebackConfiguration: BitwerxPaymentWritebackConfiguration;
  updateOneBoardFilterColumn: BoardFilterColumn;
  updateOneBoardFilterSpecificDateRange: BoardFilterSpecificDateRange;
  updateOneBoehringerIngelheimCustomerAlignment: BoehringerIngelheimCustomerAlignment;
  updateOneBoehringerIngelheimTerritory: BoehringerIngelheimTerritory;
  updateOneBreed: Breed;
  updateOneCallHistory: CallHistory;
  updateOneCallParticipant: CallParticipant;
  updateOneCallRecording?: Maybe<CallRecording>;
  updateOneCampaignRegistryCampaign: CampaignRegistryCampaign;
  updateOneCanonicalBreed: CanonicalBreed;
  updateOneCanonicalCanineBreedProfile: CanonicalCanineBreedProfile;
  updateOneCanonicalService: CanonicalService;
  updateOneCanonicalSpecies: CanonicalSpecies;
  updateOneCareAddonEnrollment: CareAddonEnrollment;
  updateOneCareAddonPackage: CareAddonPackage;
  updateOneCareAddonPackageBenefit: CareAddonPackageBenefit;
  updateOneCareAuthorizationRequest: CareAuthorizationRequest;
  updateOneCareBenefit: CareBenefit;
  updateOneCareBenefitUsage: CareBenefitUsage;
  updateOneCareBenefitUsageFollowup: CareBenefitUsageFollowup;
  updateOneCareBenefitUsageFollowupStep: CareBenefitUsageFollowupStep;
  updateOneCareBenefitUsageToInvoiceLineItem: CareBenefitUsageToInvoiceLineItem;
  updateOneCareCreditPreapprovalCheck: CareCreditPreapprovalCheck;
  updateOneCareEnrollmentPayment: CareEnrollmentPayment;
  updateOneCareEnrollmentToStripeInvoiceItem: CareEnrollmentToStripeInvoiceItem;
  updateOneCareLapsedPayment: CareLapsedPayment;
  updateOneCarePlan: CarePlan;
  updateOneCarePlanBenefit: CarePlanBenefit;
  updateOneCarePlanBenefitEnrollmentCarryover: CarePlanBenefitEnrollmentCarryover;
  updateOneCarePlanEnrollment: CarePlanEnrollment;
  updateOneCarePlanPricing: CarePlanPricing;
  updateOneCarePlanProviderGroup: CarePlanProviderGroup;
  updateOneCareStripeSubscription: CareStripeSubscription;
  updateOneCareSubscriptionTrueUp: CareSubscriptionTrueUp;
  updateOneCareSubscriptionTrueUpLogEntry: CareSubscriptionTrueUpLogEntry;
  updateOneChannel: Channel;
  updateOneChannelAutomationStatus: ChannelAutomationStatus;
  updateOneChannelCreationSource: ChannelCreationSource;
  updateOneChannelFilterSelection: ChannelFilterSelection;
  updateOneChannelMember: ChannelMember;
  updateOneChannelMessage: ChannelMessage;
  updateOneChannelMessageAttachment: ChannelMessageAttachment;
  updateOneChannelMessageAutoResponse: ChannelMessageAutoResponse;
  updateOneChannelMessageReaction: ChannelMessageReaction;
  updateOneChannelPin: ChannelPin;
  updateOneChannelSelection: ChannelSelection;
  updateOneChannelStatus: ChannelStatus;
  updateOneChannelStatusChannelAssignee: ChannelStatusChannelAssignee;
  updateOneChemicalCompound: ChemicalCompound;
  updateOneClientConnectIntegration: ClientConnectIntegration;
  updateOneClinic: Clinic;
  updateOneClinicBlockedPhoneNumber: ClinicBlockedPhoneNumber;
  updateOneClinicCustomPayoutsSetup: ClinicCustomPayoutsSetup;
  updateOneClinicDirectBookingSetting: ClinicDirectBookingSetting;
  updateOneClinicEmailCampaignSetting: ClinicEmailCampaignSetting;
  updateOneClinicEmployee: ClinicEmployee;
  updateOneClinicEmployeeAppointmentTypeSetting: ClinicEmployeeAppointmentTypeSetting;
  updateOneClinicEntityPhoneNumber: ClinicEntityPhoneNumber;
  updateOneClinicModule: ClinicModule;
  updateOneClinicOfficeHour: ClinicOfficeHour;
  updateOneClinicOnboarding: ClinicOnboarding;
  updateOneClinicPaymentFeeConfiguration: ClinicPaymentFeeConfiguration;
  updateOneClinicPet: ClinicPet;
  updateOneClinicPetAlert: ClinicPetAlert;
  updateOneClinicPetCustomFieldValue: ClinicPetCustomFieldValue;
  updateOneClinicPetParent: ClinicPetParent;
  updateOneClinicPetParentAddress: ClinicPetParentAddress;
  updateOneClinicPetParentAndEnqueuePhoneNumberLookup: ClinicPetParentWithJobChainsResponse;
  updateOneClinicPetParentCustomFieldValue: ClinicPetParentCustomFieldValue;
  updateOneClinicPetParentDevice: ClinicPetParentDevice;
  updateOneClinicPetParentPimsSyncStatus: ClinicPetParentPimsSyncStatus;
  updateOneClinicPetPimsSyncStatus: ClinicPetPimsSyncStatus;
  updateOneClinicPhoneNumber: ClinicPhoneNumber;
  updateOneClinicPimsIntegration: ClinicPimsIntegration;
  updateOneClinicPimsIntegrationCapability: ClinicPimsIntegrationCapability;
  updateOneClinicPimsIntegrationCapabilityHistoryEntry: ClinicPimsIntegrationCapabilityHistoryEntry;
  updateOneClinicPostcardSetting: ClinicPostcardSetting;
  updateOneClinicRoom: ClinicRoom;
  updateOneClinicSetting: ClinicSetting;
  updateOneClinicUserFilter: ClinicUserFilter;
  updateOneClinicWidgetRequest: ClinicWidgetRequest;
  updateOneClinicWidgetRequestType: ClinicWidgetRequestType;
  updateOneClinicWidgetSetting: ClinicWidgetSetting;
  updateOneColor: Color;
  updateOneCondition: Condition;
  updateOneConditionSet: ConditionSet;
  updateOneConditionalEntityEvaluation: ConditionalEntityEvaluation;
  updateOneConsultationRequest: ConsultationRequest;
  updateOneCustomFieldDefinition: CustomFieldDefinition;
  updateOneCustomFieldPimsWritebackLogEntry: CustomFieldPimsWritebackLogEntry;
  updateOneDirectBookingAppointmentTypeSetting: DirectBookingAppointmentTypeSetting;
  updateOneDirectBookingExclusionRule: DirectBookingExclusionRule;
  updateOneDirectBookingExclusionTimeSlot: DirectBookingExclusionTimeSlot;
  updateOneDisbursement: Disbursement;
  updateOneDocumentation: Documentation;
  updateOneEmailCampaign: EmailCampaign;
  updateOneEmailCampaignCustomList: EmailCampaignCustomList;
  updateOneEmailCampaignCustomListRecipient: EmailCampaignCustomListRecipient;
  updateOneEmailCampaignCustomListUploadHistory: EmailCampaignCustomListUploadHistory;
  updateOneEmailCampaignLog: EmailCampaignLog;
  updateOneEmailCampaignTemplate: EmailCampaignTemplate;
  updateOneEmailCampaignUnsubscribe: EmailCampaignUnsubscribe;
  updateOneEmailProviderLog: EmailProviderLog;
  updateOneEmailTemplateVersion: EmailTemplateVersion;
  updateOneEmergencyClinics: EmergencyClinics;
  updateOneEncryptedClinicUpload: EncryptedClinicUpload;
  updateOneEnrollmentSupportEvent: EnrollmentSupportEvent;
  updateOneEzyVetIntegration: EzyVetIntegration;
  updateOneFeatureFlag: FeatureFlag;
  updateOneFinancialAdjustment: FinancialAdjustment;
  updateOneFinancialTransaction: FinancialTransaction;
  updateOneFormSubmission: FormSubmission;
  updateOneFormTemplate: FormTemplate;
  updateOneGlobalPetParent: GlobalPetParent;
  updateOneGooglePlace: GooglePlace;
  updateOneHillsToHomeAPILog: HillsToHomeApiLog;
  updateOneInformAudienceDefinition: InformAudienceDefinition;
  updateOneInformAudienceMember: InformAudienceMember;
  updateOneInformAudienceMemberMessage: InformAudienceMemberMessage;
  updateOneInformAutomationCampaign: InformAutomationCampaign;
  updateOneInformCampaign: InformCampaign;
  updateOneInformCampaignEnrollment: InformCampaignEnrollment;
  updateOneInformCampaignEnrollmentCanonicalService: InformCampaignEnrollmentCanonicalService;
  updateOneInformCampaignExecution: InformCampaignExecution;
  updateOneInformCampaignGroup: InformCampaignGroup;
  updateOneInformCommunicationOptOut: InformCommunicationOptOut;
  updateOneInformControlGroupParticipant: InformControlGroupParticipant;
  updateOneInformEmailTemplate: InformEmailTemplate;
  updateOneInformEntityHistory: InformEntityHistory;
  updateOneInformEventDrivenCampaign: InformEventDrivenCampaign;
  updateOneInformEventListener: InformEventListener;
  updateOneInformNotificationRecipient: InformNotificationRecipient;
  updateOneInformPartner: InformPartner;
  updateOneInformPartnerCustomer: InformPartnerCustomer;
  updateOneInformPartnerCustomerPharmacyProvider: InformPartnerCustomerPharmacyProvider;
  updateOneInformPartnerIntegration: InformPartnerIntegration;
  updateOneInformPartnerIntegrationModel: InformPartnerIntegrationModel;
  updateOneInformPartnerProgram: InformPartnerProgram;
  updateOneInformPartnerProgramEnrollment: InformPartnerProgramEnrollment;
  updateOneInformPartnerUser: InformPartnerUser;
  updateOneInformPartnerUserRole: InformPartnerUserRole;
  updateOneInformScheduledCampaign: InformScheduledCampaign;
  updateOneInformSession: InformSession;
  updateOneInformSessionEvent: InformSessionEvent;
  updateOneInstinctIntegration: InstinctIntegration;
  updateOneInsuranceIntegration: InsuranceIntegration;
  updateOneIntegrationOutageHistoryEntry: IntegrationOutageHistoryEntry;
  updateOneInterchangeRate: InterchangeRate;
  updateOneInvoice: Invoice;
  updateOneInvoiceLineItem: InvoiceLineItem;
  updateOneInvoicePimsWritebackLogEntry: InvoicePimsWritebackLogEntry;
  updateOneLabPanel: LabPanel;
  updateOneLabResult: LabResult;
  updateOneLapsedPetParentTriggers: LapsedPetParentTriggers;
  updateOneLegalEntity: LegalEntity;
  updateOneLoyaltyAccount: LoyaltyAccount;
  updateOneLoyaltyAccountHolder: LoyaltyAccountHolder;
  updateOneLoyaltyAccountMerger: LoyaltyAccountMerger;
  updateOneLoyaltyInvoicePointGranter: LoyaltyInvoicePointGranter;
  updateOneLoyaltyPointGrantingService: LoyaltyPointGrantingService;
  updateOneLoyaltyPointGrantingServiceCategory: LoyaltyPointGrantingServiceCategory;
  updateOneLoyaltyPointUserGrant: LoyaltyPointUserGrant;
  updateOneLoyaltyProgram: LoyaltyProgram;
  updateOneLoyaltyReward: LoyaltyReward;
  updateOneLoyaltyRewardRedemption: LoyaltyRewardRedemption;
  updateOneMassTextAlert: MassTextAlert;
  updateOneMassTextAlertEntry: MassTextAlertEntry;
  updateOneMassTextAlertEntryAppointment: MassTextAlertEntryAppointment;
  updateOneMedia: Media;
  updateOneMedicalHistory: MedicalHistory;
  updateOneMessageTemplate: MessageTemplate;
  updateOneMessagingCampaign: MessagingCampaign;
  updateOneMessagingPartner: MessagingPartner;
  updateOneModule: Module;
  updateOneNonPrismaSchemaScriptRan: NonPrismaSchemaScriptRan;
  updateOneNotificationEventToMessage: NotificationEventToMessage;
  updateOneOrganization: Organization;
  updateOneOrganizationCareBenefitToClinicService: OrganizationCareBenefitToClinicService;
  updateOneOrganizationCareBenefitToClinicServiceCategory: OrganizationCareBenefitToClinicServiceCategory;
  updateOneOrganizationPet: OrganizationPet;
  updateOneOrganizationPetParent: OrganizationPetParent;
  updateOneOrganizationPetToOrganizationPetParent: OrganizationPetToOrganizationPetParent;
  updateOnePPCIntegration: PpcIntegration;
  updateOnePaymentsReportTransaction: PaymentsReportTransaction;
  updateOnePayoutBatchingPeriod: PayoutBatchingPeriod;
  updateOnePayoutBatchingSchedule: PayoutBatchingSchedule;
  updateOnePayoutBatchingSetting: PayoutBatchingSetting;
  updateOnePermission: Permission;
  updateOnePetParentSetting: PetParentSetting;
  updateOnePetPortalSetting: PetPortalSetting;
  updateOnePhoneNumberLookupRequest: PhoneNumberLookupRequest;
  updateOnePhoneNumberLookupResult: PhoneNumberLookupResult;
  updateOnePimsInvoice: PimsInvoice;
  updateOnePimsInvoiceLineItem: PimsInvoiceLineItem;
  updateOnePimsWritebackLogEntry: PimsWritebackLogEntry;
  updateOnePrescription: Prescription;
  updateOneProduct: Product;
  updateOneProductPackage: ProductPackage;
  updateOneProductPackageSubscription: ProductPackageSubscription;
  updateOneProviderAppointmentTypeRoomMap: ProviderAppointmentTypeRoomMap;
  updateOnePushNotificationLog: PushNotificationLog;
  updateOneRecap: Recap;
  updateOneRules: Rules;
  updateOneSegment: Segment;
  updateOneSentTrupanionExamDayOffer: SentTrupanionExamDayOffer;
  updateOneService: Service;
  updateOneServiceCategory: ServiceCategory;
  updateOneServicePurchaseSummary: ServicePurchaseSummary;
  updateOneServiceReminder: ServiceReminder;
  updateOneServiceReminderNotification: ServiceReminderNotification;
  updateOneServiceReminderTiming: ServiceReminderTiming;
  updateOneSex: Sex;
  updateOneSmsNotificationStatus: SmsNotificationStatus;
  updateOneSpecies: Species;
  updateOneStaffRole: StaffRole;
  updateOneStripeCustomer: StripeCustomer;
  updateOneStripeDispute: StripeDispute;
  updateOneStripeInvoice: StripeInvoice;
  updateOneStripeInvoiceItem: StripeInvoiceItem;
  updateOneStripePaymentIntent: StripePaymentIntent;
  updateOneStripePaymentMethod: StripePaymentMethod;
  updateOneStripePayout: StripePayout;
  updateOneStripePayoutAccount: StripePayoutAccount;
  updateOneStripeReceipt: StripeReceipt;
  updateOneStripeReceiptHistory: StripeReceiptHistory;
  updateOneStripeRefund: StripeRefund;
  updateOneStripeTerminal: StripeTerminal;
  updateOneStripeTerminalLocation: StripeTerminalLocation;
  updateOneSurveyAppointmentTypeSetting: SurveyAppointmentTypeSetting;
  updateOneSurveyResult: SurveyResult;
  updateOneSurveySetting: SurveySetting;
  updateOneSyncVetIntegration: SyncVetIntegration;
  updateOneSyncVetService: SyncVetService;
  updateOneSynchronyClinicConfiguration: SynchronyClinicConfiguration;
  updateOneSynchronyEvent: SynchronyEvent;
  updateOneTask: Task;
  updateOneTaxonomy: Taxonomy;
  updateOneTaxonomyToInformAudienceDefinition: TaxonomyToInformAudienceDefinition;
  updateOneTransaction: Transaction;
  updateOneTrupanionCertificateAvailability: TrupanionCertificateAvailability;
  updateOneTrupanionIntegratedAppointmentType: TrupanionIntegratedAppointmentType;
  updateOneTrupanionIntegration: TrupanionIntegration;
  updateOneUser: User;
  updateOneUserAppointmentGrouping: UserAppointmentGrouping;
  updateOneUserBoardFilter: UserBoardFilter;
  updateOneUserChannelFilterSelection: UserChannelFilterSelection;
  updateOneUserNotificationSetting: UserNotificationSetting;
  updateOneUserSetting: UserSetting;
  updateOneUserTaskList: UserTaskList;
  updateOneUserTaskListFilter: UserTaskListFilter;
  updateOneVaccination: Vaccination;
  updateOneVetAvailability: VetAvailability;
  updateOneVetAvailabilityClinicRoomMap: VetAvailabilityClinicRoomMap;
  updateOneVetAvailabilityMap: VetAvailabilityMap;
  updateOneVetInfo: VetInfo;
  updateOneVetsourceCodeTag: VetsourceCodeTag;
  updateOneVetsourceInstallation: VetsourceInstallation;
  updateOneVetsourcePharmacyIntegration: VetsourcePharmacyIntegration;
  updateOneVetsourceRevenueCategory: VetsourceRevenueCategory;
  updateOneWorkflowEventSetting: WorkflowEventSetting;
  updatePayoutBatchingSetting: UpdatePayoutBatchingSettingResponse;
  updatePetParentPaymentIntent?: Maybe<StripePaymentIntent>;
  updateStripePayment?: Maybe<StripePaymentOutput>;
  updateTeamChannel2?: Maybe<Channel>;
  updateTerminalAppPaymentIntent?: Maybe<StripePaymentIntent>;
  uploadEmailCampaignCustomList?: Maybe<EmailCampaignCustomListResponse>;
  upsertOneActiveIngredient?: Maybe<ActiveIngredient>;
  upsertOneAppointment?: Maybe<Appointment>;
  upsertOneAppointmentAvailability?: Maybe<AppointmentAvailability>;
  upsertOneAppointmentNoteTemplate?: Maybe<AppointmentNoteTemplate>;
  upsertOneAppointmentType?: Maybe<AppointmentType>;
  upsertOneAutomationRun?: Maybe<AutomationRun>;
  upsertOneAutomationRunAction?: Maybe<AutomationRunAction>;
  upsertOneAxionClinicConfiguration?: Maybe<AxionClinicConfiguration>;
  upsertOneAxionClinicUserConfiguration?: Maybe<AxionClinicUserConfiguration>;
  upsertOneBedrockInference?: Maybe<BedrockInference>;
  upsertOneBitwerxHealthcheck?: Maybe<BitwerxHealthcheck>;
  upsertOneBitwerxIntegration?: Maybe<BitwerxIntegration>;
  upsertOneBitwerxPaymentHealthcheckResult?: Maybe<BitwerxPaymentHealthcheckResult>;
  upsertOneBitwerxPaymentHealthcheckRun?: Maybe<BitwerxPaymentHealthcheckRun>;
  upsertOneBitwerxPaymentWritebackConfiguration?: Maybe<BitwerxPaymentWritebackConfiguration>;
  upsertOneBoardFilterColumn?: Maybe<BoardFilterColumn>;
  upsertOneBoardFilterSpecificDateRange?: Maybe<BoardFilterSpecificDateRange>;
  upsertOneBoehringerIngelheimCustomerAlignment?: Maybe<BoehringerIngelheimCustomerAlignment>;
  upsertOneBoehringerIngelheimTerritory?: Maybe<BoehringerIngelheimTerritory>;
  upsertOneBreed?: Maybe<Breed>;
  upsertOneCallHistory?: Maybe<CallHistory>;
  upsertOneCallParticipant?: Maybe<CallParticipant>;
  upsertOneCampaignRegistryCampaign?: Maybe<CampaignRegistryCampaign>;
  upsertOneCanonicalBreed?: Maybe<CanonicalBreed>;
  upsertOneCanonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfile>;
  upsertOneCanonicalService?: Maybe<CanonicalService>;
  upsertOneCanonicalSpecies?: Maybe<CanonicalSpecies>;
  upsertOneCareAddonEnrollment?: Maybe<CareAddonEnrollment>;
  upsertOneCareAddonPackage?: Maybe<CareAddonPackage>;
  upsertOneCareAddonPackageBenefit?: Maybe<CareAddonPackageBenefit>;
  upsertOneCareAuthorizationRequest?: Maybe<CareAuthorizationRequest>;
  upsertOneCareBenefit?: Maybe<CareBenefit>;
  upsertOneCareBenefitUsage?: Maybe<CareBenefitUsage>;
  upsertOneCareBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowup>;
  upsertOneCareBenefitUsageFollowupStep?: Maybe<CareBenefitUsageFollowupStep>;
  upsertOneCareBenefitUsageToInvoiceLineItem?: Maybe<CareBenefitUsageToInvoiceLineItem>;
  upsertOneCareCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheck>;
  upsertOneCareEnrollmentPayment?: Maybe<CareEnrollmentPayment>;
  upsertOneCareEnrollmentToStripeInvoiceItem?: Maybe<CareEnrollmentToStripeInvoiceItem>;
  upsertOneCareLapsedPayment?: Maybe<CareLapsedPayment>;
  upsertOneCarePlan?: Maybe<CarePlan>;
  upsertOneCarePlanBenefit?: Maybe<CarePlanBenefit>;
  upsertOneCarePlanBenefitEnrollmentCarryover?: Maybe<CarePlanBenefitEnrollmentCarryover>;
  upsertOneCarePlanEnrollment?: Maybe<CarePlanEnrollment>;
  upsertOneCarePlanPricing?: Maybe<CarePlanPricing>;
  upsertOneCarePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  upsertOneCareStripeSubscription?: Maybe<CareStripeSubscription>;
  upsertOneCareSubscriptionTrueUp?: Maybe<CareSubscriptionTrueUp>;
  upsertOneCareSubscriptionTrueUpLogEntry?: Maybe<CareSubscriptionTrueUpLogEntry>;
  upsertOneChannel?: Maybe<Channel>;
  upsertOneChannelAutomationStatus?: Maybe<ChannelAutomationStatus>;
  upsertOneChannelCreationSource?: Maybe<ChannelCreationSource>;
  upsertOneChannelFilterSelection?: Maybe<ChannelFilterSelection>;
  upsertOneChannelMember?: Maybe<ChannelMember>;
  upsertOneChannelMessage?: Maybe<ChannelMessage>;
  upsertOneChannelMessageAttachment?: Maybe<ChannelMessageAttachment>;
  upsertOneChannelMessageAutoResponse?: Maybe<ChannelMessageAutoResponse>;
  upsertOneChannelMessageReaction?: Maybe<ChannelMessageReaction>;
  upsertOneChannelPin?: Maybe<ChannelPin>;
  upsertOneChannelSelection?: Maybe<ChannelSelection>;
  upsertOneChannelStatus?: Maybe<ChannelStatus>;
  upsertOneChannelStatusChannelAssignee?: Maybe<ChannelStatusChannelAssignee>;
  upsertOneChemicalCompound?: Maybe<ChemicalCompound>;
  upsertOneClientConnectIntegration?: Maybe<ClientConnectIntegration>;
  upsertOneClinic?: Maybe<Clinic>;
  upsertOneClinicBlockedPhoneNumber?: Maybe<ClinicBlockedPhoneNumber>;
  upsertOneClinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetup>;
  upsertOneClinicDirectBookingSetting?: Maybe<ClinicDirectBookingSetting>;
  upsertOneClinicEmailCampaignSetting?: Maybe<ClinicEmailCampaignSetting>;
  upsertOneClinicEmployee?: Maybe<ClinicEmployee>;
  upsertOneClinicEmployeeAppointmentTypeSetting?: Maybe<ClinicEmployeeAppointmentTypeSetting>;
  upsertOneClinicEntityPhoneNumber?: Maybe<ClinicEntityPhoneNumber>;
  upsertOneClinicModule?: Maybe<ClinicModule>;
  upsertOneClinicOfficeHour?: Maybe<ClinicOfficeHour>;
  upsertOneClinicOnboarding?: Maybe<ClinicOnboarding>;
  upsertOneClinicPaymentFeeConfiguration?: Maybe<ClinicPaymentFeeConfiguration>;
  upsertOneClinicPet?: Maybe<ClinicPet>;
  upsertOneClinicPetAlert?: Maybe<ClinicPetAlert>;
  upsertOneClinicPetCustomFieldValue?: Maybe<ClinicPetCustomFieldValue>;
  upsertOneClinicPetParent?: Maybe<ClinicPetParent>;
  upsertOneClinicPetParentAddress?: Maybe<ClinicPetParentAddress>;
  upsertOneClinicPetParentCustomFieldValue?: Maybe<ClinicPetParentCustomFieldValue>;
  upsertOneClinicPetParentDevice?: Maybe<ClinicPetParentDevice>;
  upsertOneClinicPetParentPimsSyncStatus?: Maybe<ClinicPetParentPimsSyncStatus>;
  upsertOneClinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatus>;
  upsertOneClinicPhoneNumber?: Maybe<ClinicPhoneNumber>;
  upsertOneClinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  upsertOneClinicPimsIntegrationCapability?: Maybe<ClinicPimsIntegrationCapability>;
  upsertOneClinicPimsIntegrationCapabilityHistoryEntry?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntry>;
  upsertOneClinicPostcardSetting?: Maybe<ClinicPostcardSetting>;
  upsertOneClinicRoom?: Maybe<ClinicRoom>;
  upsertOneClinicSetting?: Maybe<ClinicSetting>;
  upsertOneClinicUserFilter?: Maybe<ClinicUserFilter>;
  upsertOneClinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  upsertOneClinicWidgetRequestType?: Maybe<ClinicWidgetRequestType>;
  upsertOneClinicWidgetSetting?: Maybe<ClinicWidgetSetting>;
  upsertOneColor?: Maybe<Color>;
  upsertOneCondition?: Maybe<Condition>;
  upsertOneConditionSet?: Maybe<ConditionSet>;
  upsertOneConditionalEntityEvaluation?: Maybe<ConditionalEntityEvaluation>;
  upsertOneConsultationRequest?: Maybe<ConsultationRequest>;
  upsertOneCustomFieldDefinition?: Maybe<CustomFieldDefinition>;
  upsertOneCustomFieldPimsWritebackLogEntry?: Maybe<CustomFieldPimsWritebackLogEntry>;
  upsertOneDirectBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSetting>;
  upsertOneDirectBookingExclusionRule?: Maybe<DirectBookingExclusionRule>;
  upsertOneDirectBookingExclusionTimeSlot?: Maybe<DirectBookingExclusionTimeSlot>;
  upsertOneDisbursement?: Maybe<Disbursement>;
  upsertOneDocumentation?: Maybe<Documentation>;
  upsertOneEmailCampaign?: Maybe<EmailCampaign>;
  upsertOneEmailCampaignCustomList?: Maybe<EmailCampaignCustomList>;
  upsertOneEmailCampaignCustomListRecipient?: Maybe<EmailCampaignCustomListRecipient>;
  upsertOneEmailCampaignCustomListUploadHistory?: Maybe<EmailCampaignCustomListUploadHistory>;
  upsertOneEmailCampaignLog?: Maybe<EmailCampaignLog>;
  upsertOneEmailCampaignTemplate?: Maybe<EmailCampaignTemplate>;
  upsertOneEmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribe>;
  upsertOneEmailProviderLog?: Maybe<EmailProviderLog>;
  upsertOneEmergencyClinics?: Maybe<EmergencyClinics>;
  upsertOneEncryptedClinicUpload?: Maybe<EncryptedClinicUpload>;
  upsertOneEnrollmentSupportEvent?: Maybe<EnrollmentSupportEvent>;
  upsertOneEzyVetIntegration?: Maybe<EzyVetIntegration>;
  upsertOneFeatureFlag?: Maybe<FeatureFlag>;
  upsertOneFinancialAdjustment?: Maybe<FinancialAdjustment>;
  upsertOneFinancialTransaction?: Maybe<FinancialTransaction>;
  upsertOneFormSubmission?: Maybe<FormSubmission>;
  upsertOneFormTemplate?: Maybe<FormTemplate>;
  upsertOneGlobalPetParent?: Maybe<GlobalPetParent>;
  upsertOneGooglePlace?: Maybe<GooglePlace>;
  upsertOneHillsToHomeAPILog?: Maybe<HillsToHomeApiLog>;
  upsertOneInformAudienceDefinition?: Maybe<InformAudienceDefinition>;
  upsertOneInformAudienceMember?: Maybe<InformAudienceMember>;
  upsertOneInformAudienceMemberMessage?: Maybe<InformAudienceMemberMessage>;
  upsertOneInformAutomationCampaign?: Maybe<InformAutomationCampaign>;
  upsertOneInformCampaign?: Maybe<InformCampaign>;
  upsertOneInformCampaignEnrollment?: Maybe<InformCampaignEnrollment>;
  upsertOneInformCampaignEnrollmentCanonicalService?: Maybe<InformCampaignEnrollmentCanonicalService>;
  upsertOneInformCampaignExecution?: Maybe<InformCampaignExecution>;
  upsertOneInformCampaignGroup?: Maybe<InformCampaignGroup>;
  upsertOneInformCommunicationOptOut?: Maybe<InformCommunicationOptOut>;
  upsertOneInformControlGroupParticipant?: Maybe<InformControlGroupParticipant>;
  upsertOneInformEmailTemplate?: Maybe<InformEmailTemplate>;
  upsertOneInformEntityHistory?: Maybe<InformEntityHistory>;
  upsertOneInformEventDrivenCampaign?: Maybe<InformEventDrivenCampaign>;
  upsertOneInformEventListener?: Maybe<InformEventListener>;
  upsertOneInformNotificationRecipient?: Maybe<InformNotificationRecipient>;
  upsertOneInformPartner?: Maybe<InformPartner>;
  upsertOneInformPartnerCustomer?: Maybe<InformPartnerCustomer>;
  upsertOneInformPartnerCustomerPharmacyProvider?: Maybe<InformPartnerCustomerPharmacyProvider>;
  upsertOneInformPartnerIntegration?: Maybe<InformPartnerIntegration>;
  upsertOneInformPartnerIntegrationModel?: Maybe<InformPartnerIntegrationModel>;
  upsertOneInformPartnerProgram?: Maybe<InformPartnerProgram>;
  upsertOneInformPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollment>;
  upsertOneInformPartnerUser?: Maybe<InformPartnerUser>;
  upsertOneInformPartnerUserRole?: Maybe<InformPartnerUserRole>;
  upsertOneInformScheduledCampaign?: Maybe<InformScheduledCampaign>;
  upsertOneInformSession?: Maybe<InformSession>;
  upsertOneInformSessionEvent?: Maybe<InformSessionEvent>;
  upsertOneInstinctIntegration?: Maybe<InstinctIntegration>;
  upsertOneInsuranceIntegration?: Maybe<InsuranceIntegration>;
  upsertOneIntegrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntry>;
  upsertOneInterchangeRate?: Maybe<InterchangeRate>;
  upsertOneInvoice?: Maybe<Invoice>;
  upsertOneInvoiceLineItem?: Maybe<InvoiceLineItem>;
  upsertOneInvoicePimsWritebackLogEntry?: Maybe<InvoicePimsWritebackLogEntry>;
  upsertOneLabPanel?: Maybe<LabPanel>;
  upsertOneLabResult?: Maybe<LabResult>;
  upsertOneLapsedPetParentTriggers?: Maybe<LapsedPetParentTriggers>;
  upsertOneLegalEntity?: Maybe<LegalEntity>;
  upsertOneLoyaltyAccount?: Maybe<LoyaltyAccount>;
  upsertOneLoyaltyAccountHolder?: Maybe<LoyaltyAccountHolder>;
  upsertOneLoyaltyAccountMerger?: Maybe<LoyaltyAccountMerger>;
  upsertOneLoyaltyInvoicePointGranter?: Maybe<LoyaltyInvoicePointGranter>;
  upsertOneLoyaltyPointGrantingService?: Maybe<LoyaltyPointGrantingService>;
  upsertOneLoyaltyPointGrantingServiceCategory?: Maybe<LoyaltyPointGrantingServiceCategory>;
  upsertOneLoyaltyPointUserGrant?: Maybe<LoyaltyPointUserGrant>;
  upsertOneLoyaltyReward?: Maybe<LoyaltyReward>;
  upsertOneLoyaltyRewardRedemption?: Maybe<LoyaltyRewardRedemption>;
  upsertOneMassTextAlert?: Maybe<MassTextAlert>;
  upsertOneMassTextAlertEntry?: Maybe<MassTextAlertEntry>;
  upsertOneMassTextAlertEntryAppointment?: Maybe<MassTextAlertEntryAppointment>;
  upsertOneMedia?: Maybe<Media>;
  upsertOneMedicalHistory?: Maybe<MedicalHistory>;
  upsertOneMessageTemplate?: Maybe<MessageTemplate>;
  upsertOneMessagingCampaign?: Maybe<MessagingCampaign>;
  upsertOneMessagingPartner?: Maybe<MessagingPartner>;
  upsertOneModule?: Maybe<Module>;
  upsertOneNonPrismaSchemaScriptRan?: Maybe<NonPrismaSchemaScriptRan>;
  upsertOneNotificationEventToMessage?: Maybe<NotificationEventToMessage>;
  upsertOneOrganization?: Maybe<Organization>;
  upsertOneOrganizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicService>;
  upsertOneOrganizationCareBenefitToClinicServiceCategory?: Maybe<OrganizationCareBenefitToClinicServiceCategory>;
  upsertOneOrganizationPet?: Maybe<OrganizationPet>;
  upsertOneOrganizationPetParent?: Maybe<OrganizationPetParent>;
  upsertOneOrganizationPetToOrganizationPetParent?: Maybe<OrganizationPetToOrganizationPetParent>;
  upsertOnePPCIntegration?: Maybe<PpcIntegration>;
  upsertOnePaymentsReportTransaction?: Maybe<PaymentsReportTransaction>;
  upsertOnePayoutBatchingPeriod?: Maybe<PayoutBatchingPeriod>;
  upsertOnePayoutBatchingSchedule?: Maybe<PayoutBatchingSchedule>;
  upsertOnePayoutBatchingSetting?: Maybe<PayoutBatchingSetting>;
  upsertOnePermission?: Maybe<Permission>;
  upsertOnePetParentSetting?: Maybe<PetParentSetting>;
  upsertOnePetPortalSetting?: Maybe<PetPortalSetting>;
  upsertOnePhoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequest>;
  upsertOnePhoneNumberLookupResult?: Maybe<PhoneNumberLookupResult>;
  upsertOnePimsInvoice?: Maybe<PimsInvoice>;
  upsertOnePimsInvoiceLineItem?: Maybe<PimsInvoiceLineItem>;
  upsertOnePimsWritebackLogEntry?: Maybe<PimsWritebackLogEntry>;
  upsertOnePrescription?: Maybe<Prescription>;
  upsertOneProduct?: Maybe<Product>;
  upsertOneProductPackage?: Maybe<ProductPackage>;
  upsertOneProductPackageSubscription?: Maybe<ProductPackageSubscription>;
  upsertOneProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMap>;
  upsertOnePushNotificationLog?: Maybe<PushNotificationLog>;
  upsertOneRecap?: Maybe<Recap>;
  upsertOneRules?: Maybe<Rules>;
  upsertOneSegment?: Maybe<Segment>;
  upsertOneSentTrupanionExamDayOffer?: Maybe<SentTrupanionExamDayOffer>;
  upsertOneService?: Maybe<Service>;
  upsertOneServiceCategory?: Maybe<ServiceCategory>;
  upsertOneServicePurchaseSummary?: Maybe<ServicePurchaseSummary>;
  upsertOneServiceReminder?: Maybe<ServiceReminder>;
  upsertOneServiceReminderNotification?: Maybe<ServiceReminderNotification>;
  upsertOneServiceReminderTiming?: Maybe<ServiceReminderTiming>;
  upsertOneSex?: Maybe<Sex>;
  upsertOneSmsNotificationStatus?: Maybe<SmsNotificationStatus>;
  upsertOneSpecies?: Maybe<Species>;
  upsertOneStaffRole?: Maybe<StaffRole>;
  upsertOneStripeCustomer?: Maybe<StripeCustomer>;
  upsertOneStripeDispute?: Maybe<StripeDispute>;
  upsertOneStripeInvoice?: Maybe<StripeInvoice>;
  upsertOneStripeInvoiceItem?: Maybe<StripeInvoiceItem>;
  upsertOneStripePaymentIntent?: Maybe<StripePaymentIntent>;
  upsertOneStripePaymentMethod?: Maybe<StripePaymentMethod>;
  upsertOneStripePayout?: Maybe<StripePayout>;
  upsertOneStripePayoutAccount?: Maybe<StripePayoutAccount>;
  upsertOneStripeReceipt?: Maybe<StripeReceipt>;
  upsertOneStripeReceiptHistory?: Maybe<StripeReceiptHistory>;
  upsertOneStripeRefund?: Maybe<StripeRefund>;
  upsertOneStripeTerminal?: Maybe<StripeTerminal>;
  upsertOneStripeTerminalLocation?: Maybe<StripeTerminalLocation>;
  upsertOneSurveyAppointmentTypeSetting?: Maybe<SurveyAppointmentTypeSetting>;
  upsertOneSurveyResult?: Maybe<SurveyResult>;
  upsertOneSurveySetting?: Maybe<SurveySetting>;
  upsertOneSyncVetIntegration?: Maybe<SyncVetIntegration>;
  upsertOneSyncVetService?: Maybe<SyncVetService>;
  upsertOneSynchronyClinicConfiguration?: Maybe<SynchronyClinicConfiguration>;
  upsertOneSynchronyEvent?: Maybe<SynchronyEvent>;
  upsertOneTask?: Maybe<Task>;
  upsertOneTaxonomy?: Maybe<Taxonomy>;
  upsertOneTaxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinition>;
  upsertOneTransaction?: Maybe<Transaction>;
  upsertOneTrupanionCertificateAvailability?: Maybe<TrupanionCertificateAvailability>;
  upsertOneTrupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentType>;
  upsertOneTrupanionIntegration?: Maybe<TrupanionIntegration>;
  upsertOneUser?: Maybe<User>;
  upsertOneUserAppointmentGrouping?: Maybe<UserAppointmentGrouping>;
  upsertOneUserBoardFilter?: Maybe<UserBoardFilter>;
  upsertOneUserChannelFilterSelection?: Maybe<UserChannelFilterSelection>;
  upsertOneUserNotificationSetting?: Maybe<UserNotificationSetting>;
  upsertOneUserSetting?: Maybe<UserSetting>;
  upsertOneUserTaskList?: Maybe<UserTaskList>;
  upsertOneUserTaskListFilter?: Maybe<UserTaskListFilter>;
  upsertOneVaccination?: Maybe<Vaccination>;
  upsertOneVetAvailability?: Maybe<VetAvailability>;
  upsertOneVetAvailabilityClinicRoomMap?: Maybe<VetAvailabilityClinicRoomMap>;
  upsertOneVetAvailabilityMap?: Maybe<VetAvailabilityMap>;
  upsertOneVetInfo?: Maybe<VetInfo>;
  upsertOneVetsourceCodeTag?: Maybe<VetsourceCodeTag>;
  upsertOneVetsourceInstallation?: Maybe<VetsourceInstallation>;
  upsertOneVetsourcePharmacyIntegration?: Maybe<VetsourcePharmacyIntegration>;
  upsertOneVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategory>;
  upsertOneWorkflowEventSetting?: Maybe<WorkflowEventSetting>;
  upsertUserToClinic: User;
  verifyClinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  verifyClinicWidgetRequest2?: Maybe<ClinicWidgetRequest>;
  verifyWidgetAuthenticationRequest?: Maybe<VerifyWidgetAuthenticationRequestResponse>;
};


export type MutationAcceptUserInvitation2Args = {
  data: AcceptUserInvitationInput;
};


export type MutationAddChannelMember2Args = {
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type MutationAddChannelTagArgs = {
  channelId: Scalars['String'];
  tag?: Maybe<TagInput>;
};


export type MutationAddClinicToLoyaltyProgramArgs = {
  clinicId: Scalars['String'];
  programId: Scalars['String'];
};


export type MutationAddUserToClinicArgs = {
  data: UserCreateInput;
};


export type MutationAiRecapExportToPimsArgs = {
  where?: Maybe<AppointmentWhereUniqueInput>;
};


export type MutationArchiveLoyaltyProgramArgs = {
  disconnectMemberClinics?: Maybe<Scalars['Boolean']>;
  programId: Scalars['String'];
};


export type MutationBuildSignedLookerUrlArgs = {
  reportId: Scalars['String'];
};


export type MutationBulkPublishWorkflowEventSettingsArgs = {
  data: BulkPublishWorkflowEventSettingsInput;
};


export type MutationCancelCareSubscriptionArgs = {
  data?: Maybe<CancelCareSubscriptionInput>;
};


export type MutationCancelClinicSubscriptionArgs = {
  data: ClinicCancellationInput;
  where: ClinicWhereUniqueInput;
};


export type MutationCancelLoyaltyRewardRedemptionArgs = {
  data: LoyaltyRewardRedemptionInput;
};


export type MutationCancelStripePaymentIntent2Args = {
  where: StripePaymentIntentWhereUniqueInput;
};


export type MutationChangeCareSubscriptionPaymentMethodArgs = {
  data?: Maybe<ChangeCareSubscriptionPaymentMethodInput>;
};


export type MutationChannelBulkExportToPimsArgs = {
  where: Array<Maybe<ChannelExportWhereInput>>;
};


export type MutationChannelExportToPimsArgs = {
  where: ChannelExportWhereInput;
};


export type MutationClaimClinicPetParentAuthCodeArgs = {
  data: ClaimClinicPetParentAuthCodeRequest;
};


export type MutationClearTerminalDisplayArgs = {
  stripeTerminalId: Scalars['String'];
};


export type MutationClearUnreadMessages2Args = {
  data: ClearUnreadMessagesInput;
};


export type MutationConfirmAppointment2Args = {
  where?: Maybe<AppointmentWhereUniqueInput>;
};


export type MutationConnectStripeTerminalArgs = {
  displayName: Scalars['String'];
  pairingCode: Scalars['String'];
};


export type MutationCopyOneWorkflowEventSettingArgs = {
  where: WorkflowEventSettingWhereUniqueInput;
};


export type MutationCreateCallHistoryArgs = {
  data: CreateCallHistoryInput;
};


export type MutationCreateCareEnrollmentsAndSubscriptionsArgs = {
  data: CreateCareEnrollmentAndSubscriptionInput;
};


export type MutationCreateCarePaymentMethodSetupArgs = {
  data?: Maybe<CreateCarePaymentMethodSetupInput>;
};


export type MutationCreateChannelFilterSelectionArgs = {
  data?: Maybe<CreateChannelFilterSelectionInput>;
};


export type MutationCreateChannelMessage2Args = {
  data: ChannelMessageCreateInput;
};


export type MutationCreateClinicWidgetRequestArgs = {
  data: ClinicWidgetRequestCreateInput;
};


export type MutationCreateDirectBookingAppointmentArgs = {
  data?: Maybe<AppointmentCreateInput>;
};


export type MutationCreateEmailTemplateVersionArgs = {
  data: CreateEmailTemplateVersionInput;
};


export type MutationCreateImpersonationArgs = {
  data: IdInput;
};


export type MutationCreateOneActiveIngredientArgs = {
  data: ActiveIngredientCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneAppointmentArgs = {
  data: AppointmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneAppointmentAvailabilityArgs = {
  data: AppointmentAvailabilityCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneAppointmentNoteTemplateArgs = {
  data: AppointmentNoteTemplateCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneAppointmentTypeArgs = {
  data: AppointmentTypeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneAutomationRunArgs = {
  data: AutomationRunCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneAutomationRunActionArgs = {
  data: AutomationRunActionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneAxionCallArgs = {
  data: CreateOneAxionCallInput;
};


export type MutationCreateOneAxionClinicConfigurationArgs = {
  data: AxionClinicConfigurationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneAxionClinicUserConfigurationArgs = {
  data: AxionClinicUserConfigurationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneBedrockInferenceArgs = {
  data: BedrockInferenceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneBitwerxHealthcheckArgs = {
  data: BitwerxHealthcheckCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneBitwerxIntegrationArgs = {
  data: BitwerxIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneBitwerxPaymentHealthcheckResultArgs = {
  data: BitwerxPaymentHealthcheckResultCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneBitwerxPaymentHealthcheckRunArgs = {
  data: BitwerxPaymentHealthcheckRunCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneBoardFilterColumnArgs = {
  data: BoardFilterColumnCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneBoardFilterSpecificDateRangeArgs = {
  data: BoardFilterSpecificDateRangeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneBoehringerIngelheimCustomerAlignmentArgs = {
  data: BoehringerIngelheimCustomerAlignmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneBoehringerIngelheimTerritoryArgs = {
  data: BoehringerIngelheimTerritoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneBreedArgs = {
  data: BreedCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCallHistoryArgs = {
  data: CallHistoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCallParticipantArgs = {
  data: CallParticipantCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCallRecordingArgs = {
  callSid: Scalars['String'];
};


export type MutationCreateOneCampaignRegistryCampaignArgs = {
  data: CampaignRegistryCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCanonicalBreedArgs = {
  data: CanonicalBreedCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCanonicalCanineBreedProfileArgs = {
  data: CanonicalCanineBreedProfileCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCanonicalServiceArgs = {
  data: CanonicalServiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCanonicalSpeciesArgs = {
  data: CanonicalSpeciesCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareAddonEnrollmentArgs = {
  data: CareAddonEnrollmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareAddonPackageArgs = {
  data: CareAddonPackageCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareAddonPackageBenefitArgs = {
  data: CareAddonPackageBenefitCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareAuthorizationRequestArgs = {
  data: CareAuthorizationRequestCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareBenefitArgs = {
  data: CareBenefitCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareBenefitUsageArgs = {
  data: CareBenefitUsageCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareBenefitUsageFollowupArgs = {
  data: CareBenefitUsageFollowupCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareBenefitUsageFollowupStepArgs = {
  data: CareBenefitUsageFollowupStepCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareBenefitUsageToInvoiceLineItemArgs = {
  data: CareBenefitUsageToInvoiceLineItemCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareCreditPreapprovalCheckArgs = {
  data: CareCreditPreapprovalCheckCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareEnrollmentPaymentArgs = {
  data: CareEnrollmentPaymentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareEnrollmentToStripeInvoiceItemArgs = {
  data: CareEnrollmentToStripeInvoiceItemCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareLapsedPaymentArgs = {
  data: CareLapsedPaymentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCarePlanArgs = {
  data: CarePlanCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCarePlanBenefitArgs = {
  data: CarePlanBenefitCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCarePlanBenefitEnrollmentCarryoverArgs = {
  data: CarePlanBenefitEnrollmentCarryoverCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCarePlanEnrollmentArgs = {
  data: CarePlanEnrollmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCarePlanPricingArgs = {
  data: CarePlanPricingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCarePlanProviderGroupArgs = {
  data: CarePlanProviderGroupCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareStripeSubscriptionArgs = {
  data: CareStripeSubscriptionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareSubscriptionTrueUpArgs = {
  data: CareSubscriptionTrueUpCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCareSubscriptionTrueUpLogEntryArgs = {
  data: CareSubscriptionTrueUpLogEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelArgs = {
  data: ChannelCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelAutomationStatusArgs = {
  data: ChannelAutomationStatusCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelCreationSourceArgs = {
  data: ChannelCreationSourceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelFilterSelectionArgs = {
  data: ChannelFilterSelectionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelMemberArgs = {
  data: ChannelMemberCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelMessageArgs = {
  data: ChannelMessageCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelMessageAttachmentArgs = {
  data: ChannelMessageAttachmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelMessageAutoResponseArgs = {
  data: ChannelMessageAutoResponseCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelMessageReactionArgs = {
  data: ChannelMessageReactionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelPinArgs = {
  data: ChannelPinCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelSelectionArgs = {
  data: ChannelSelectionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelStatusArgs = {
  data: ChannelStatusCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChannelStatusChannelAssigneeArgs = {
  data: ChannelStatusChannelAssigneeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneChemicalCompoundArgs = {
  data: ChemicalCompoundCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClientConnectIntegrationArgs = {
  data: ClientConnectIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicArgs = {
  data: ClinicCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicBlockedPhoneNumberArgs = {
  data: ClinicBlockedPhoneNumberCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicCustomPayoutsSetupArgs = {
  data: ClinicCustomPayoutsSetupCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicDirectBookingSettingArgs = {
  data: ClinicDirectBookingSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicEmailCampaignSettingArgs = {
  data: ClinicEmailCampaignSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicEmployeeArgs = {
  data: ClinicEmployeeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicEmployeeAppointmentTypeSettingArgs = {
  data: ClinicEmployeeAppointmentTypeSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicEntityPhoneNumberArgs = {
  data: ClinicEntityPhoneNumberCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicModuleArgs = {
  data: ClinicModuleCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicOfficeHourArgs = {
  data: ClinicOfficeHourCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicOnboardingArgs = {
  data: ClinicOnboardingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPaymentFeeConfigurationArgs = {
  data: ClinicPaymentFeeConfigurationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPetArgs = {
  data: ClinicPetCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPetAlertArgs = {
  data: ClinicPetAlertCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPetCustomFieldValueArgs = {
  data: ClinicPetCustomFieldValueCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPetParentArgs = {
  data: ClinicPetParentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPetParentAddressArgs = {
  data: ClinicPetParentAddressCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPetParentCustomFieldValueArgs = {
  data: ClinicPetParentCustomFieldValueCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPetParentDeviceArgs = {
  data: ClinicPetParentDeviceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPetParentPimsSyncStatusArgs = {
  data: ClinicPetParentPimsSyncStatusCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPetPimsSyncStatusArgs = {
  data: ClinicPetPimsSyncStatusCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPhoneNumberArgs = {
  data: ClinicPhoneNumberCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPimsIntegrationArgs = {
  data: ClinicPimsIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPimsIntegrationCapabilityArgs = {
  data: ClinicPimsIntegrationCapabilityCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPimsIntegrationCapabilityHistoryEntryArgs = {
  data: ClinicPimsIntegrationCapabilityHistoryEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicPostcardSettingArgs = {
  data: ClinicPostcardSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicRoomArgs = {
  data: ClinicRoomCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicSettingArgs = {
  data: ClinicSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicUserFilterArgs = {
  data: ClinicUserFilterCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicWidgetRequestArgs = {
  data: ClinicWidgetRequestCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicWidgetRequestTypeArgs = {
  data: ClinicWidgetRequestTypeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneClinicWidgetSettingArgs = {
  data: ClinicWidgetSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneColorArgs = {
  data: ColorCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneConditionArgs = {
  data: ConditionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneConditionSetArgs = {
  data: ConditionSetCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneConditionalEntityEvaluationArgs = {
  data: ConditionalEntityEvaluationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneConsultationRequestArgs = {
  data: ConsultationRequestCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCustomFieldDefinitionArgs = {
  data: CustomFieldDefinitionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneCustomFieldPimsWritebackLogEntryArgs = {
  data: CustomFieldPimsWritebackLogEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneDirectBookingAppointmentTypeSettingArgs = {
  data: DirectBookingAppointmentTypeSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneDirectBookingExclusionRuleArgs = {
  data: DirectBookingExclusionRuleCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneDirectBookingExclusionTimeSlotArgs = {
  data: DirectBookingExclusionTimeSlotCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneDisbursementArgs = {
  data: DisbursementCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneDocumentationArgs = {
  data: DocumentationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneEmailCampaignArgs = {
  data: EmailCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneEmailCampaignCustomListArgs = {
  data: EmailCampaignCustomListCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneEmailCampaignCustomListRecipientArgs = {
  data: EmailCampaignCustomListRecipientCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneEmailCampaignCustomListUploadHistoryArgs = {
  data: EmailCampaignCustomListUploadHistoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneEmailCampaignLogArgs = {
  data: EmailCampaignLogCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneEmailCampaignTemplateArgs = {
  data: EmailCampaignTemplateCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneEmailCampaignUnsubscribeArgs = {
  data: EmailCampaignUnsubscribeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneEmailProviderLogArgs = {
  data: EmailProviderLogCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneEmergencyClinicsArgs = {
  data: EmergencyClinicsCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneEncryptedClinicUploadArgs = {
  data: EncryptedClinicUploadCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneEnrollmentSupportEventArgs = {
  data: EnrollmentSupportEventCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneEzyVetIntegrationArgs = {
  data: EzyVetIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneFeatureFlagArgs = {
  data: FeatureFlagCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneFinancialAdjustmentArgs = {
  data: FinancialAdjustmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneFinancialTransactionArgs = {
  data: FinancialTransactionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneFormSubmissionArgs = {
  data: FormSubmissionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneFormTemplateArgs = {
  data: FormTemplateCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneGlobalPetParentArgs = {
  data: GlobalPetParentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneGooglePlaceArgs = {
  data: GooglePlaceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneHillsToHomeApiLogArgs = {
  data: HillsToHomeApiLogCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformAudienceDefinitionArgs = {
  data: InformAudienceDefinitionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformAudienceMemberArgs = {
  data: InformAudienceMemberCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformAudienceMemberMessageArgs = {
  data: InformAudienceMemberMessageCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformAutomationCampaignArgs = {
  data: InformAutomationCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformCampaignArgs = {
  data: InformCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformCampaignEnrollmentArgs = {
  data: InformCampaignEnrollmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformCampaignEnrollmentCanonicalServiceArgs = {
  data: InformCampaignEnrollmentCanonicalServiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformCampaignExecutionArgs = {
  data: InformCampaignExecutionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformCampaignGroupArgs = {
  data: InformCampaignGroupCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformCommunicationOptOutArgs = {
  data: InformCommunicationOptOutCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformControlGroupParticipantArgs = {
  data: InformControlGroupParticipantCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformEmailTemplateArgs = {
  data: InformEmailTemplateCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformEntityHistoryArgs = {
  data: InformEntityHistoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformEventDrivenCampaignArgs = {
  data: InformEventDrivenCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformEventListenerArgs = {
  data: InformEventListenerCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformNotificationRecipientArgs = {
  data: InformNotificationRecipientCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformPartnerArgs = {
  data: InformPartnerCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformPartnerCustomerArgs = {
  data: InformPartnerCustomerCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformPartnerCustomerPharmacyProviderArgs = {
  data: InformPartnerCustomerPharmacyProviderCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformPartnerIntegrationArgs = {
  data: InformPartnerIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformPartnerIntegrationModelArgs = {
  data: InformPartnerIntegrationModelCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformPartnerProgramArgs = {
  data: InformPartnerProgramCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformPartnerProgramEnrollmentArgs = {
  data: InformPartnerProgramEnrollmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformPartnerUserArgs = {
  data: InformPartnerUserCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformPartnerUserRoleArgs = {
  data: InformPartnerUserRoleCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformScheduledCampaignArgs = {
  data: InformScheduledCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformSessionArgs = {
  data: InformSessionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInformSessionEventArgs = {
  data: InformSessionEventCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInstinctIntegrationArgs = {
  data: InstinctIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInsuranceIntegrationArgs = {
  data: InsuranceIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneIntegrationOutageHistoryEntryArgs = {
  data: IntegrationOutageHistoryEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInterchangeRateArgs = {
  data: InterchangeRateCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInvoiceArgs = {
  data: InvoiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInvoiceLineItemArgs = {
  data: InvoiceLineItemCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneInvoicePimsWritebackLogEntryArgs = {
  data: InvoicePimsWritebackLogEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLabPanelArgs = {
  data: LabPanelCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLabResultArgs = {
  data: LabResultCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLapsedPetParentTriggersArgs = {
  data: LapsedPetParentTriggersCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLegalEntityArgs = {
  data: LegalEntityCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLoyaltyAccountArgs = {
  data: LoyaltyAccountCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLoyaltyAccountHolderArgs = {
  data: LoyaltyAccountHolderCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLoyaltyAccountMergerArgs = {
  data: LoyaltyAccountMergerCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLoyaltyInvoicePointGranterArgs = {
  data: LoyaltyInvoicePointGranterCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLoyaltyPointGrantingServiceArgs = {
  data: LoyaltyPointGrantingServiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLoyaltyPointGrantingServiceCategoryArgs = {
  data: LoyaltyPointGrantingServiceCategoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLoyaltyPointUserGrantArgs = {
  data: LoyaltyPointUserGrantCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLoyaltyRewardArgs = {
  data: LoyaltyRewardCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneLoyaltyRewardRedemptionArgs = {
  data: LoyaltyRewardRedemptionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneMassTextAlertArgs = {
  data: MassTextAlertCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneMassTextAlertEntryArgs = {
  data: MassTextAlertEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneMassTextAlertEntryAppointmentArgs = {
  data: MassTextAlertEntryAppointmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneMediaArgs = {
  data: MediaCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneMedicalHistoryArgs = {
  data: MedicalHistoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneMessageTemplateArgs = {
  data: MessageTemplateCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneMessagingCampaignArgs = {
  data: MessagingCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneMessagingPartnerArgs = {
  data: MessagingPartnerCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneModuleArgs = {
  data: ModuleCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneNonPrismaSchemaScriptRanArgs = {
  data: NonPrismaSchemaScriptRanCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneNotificationEventToMessageArgs = {
  data: NotificationEventToMessageCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneOrganizationArgs = {
  data: OrganizationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneOrganizationCareBenefitToClinicServiceArgs = {
  data: OrganizationCareBenefitToClinicServiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneOrganizationCareBenefitToClinicServiceCategoryArgs = {
  data: OrganizationCareBenefitToClinicServiceCategoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneOrganizationPetArgs = {
  data: OrganizationPetCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneOrganizationPetParentArgs = {
  data: OrganizationPetParentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneOrganizationPetToOrganizationPetParentArgs = {
  data: OrganizationPetToOrganizationPetParentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePpcIntegrationArgs = {
  data: PpcIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePaymentsReportTransactionArgs = {
  data: PaymentsReportTransactionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePayoutBatchingPeriodArgs = {
  data: PayoutBatchingPeriodCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePayoutBatchingScheduleArgs = {
  data: PayoutBatchingScheduleCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePayoutBatchingSettingArgs = {
  data: PayoutBatchingSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePermissionArgs = {
  data: PermissionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePetParentSettingArgs = {
  data: PetParentSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePetPortalSettingArgs = {
  data: PetPortalSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePhoneNumberLookupRequestArgs = {
  data: PhoneNumberLookupRequestCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePhoneNumberLookupResultArgs = {
  data: PhoneNumberLookupResultCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePimsInvoiceArgs = {
  data: PimsInvoiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePimsInvoiceLineItemArgs = {
  data: PimsInvoiceLineItemCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePimsWritebackLogEntryArgs = {
  data: PimsWritebackLogEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOnePrescriptionArgs = {
  data: PrescriptionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneProductArgs = {
  data: ProductCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneProductPackageArgs = {
  data: ProductPackageCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneProductPackageSubscriptionArgs = {
  data: ProductPackageSubscriptionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneProviderAppointmentTypeRoomMapArgs = {
  data: ProviderAppointmentTypeRoomMapCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneProviderAppointmentTypeRoomMapByNameArgs = {
  data: DirectBookingCreateOneProviderAppointmentTypeRoomMapByNameInput;
};


export type MutationCreateOnePushNotificationLogArgs = {
  data: PushNotificationLogCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneRecapArgs = {
  data: RecapCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneRulesArgs = {
  data: RulesCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneSegmentArgs = {
  data: SegmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneSentTrupanionExamDayOfferArgs = {
  data: SentTrupanionExamDayOfferCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneServiceArgs = {
  data: ServiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneServiceCategoryArgs = {
  data: ServiceCategoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneServicePurchaseSummaryArgs = {
  data: ServicePurchaseSummaryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneServiceReminderArgs = {
  data: ServiceReminderCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneServiceReminderNotificationArgs = {
  data: ServiceReminderNotificationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneServiceReminderTimingArgs = {
  data: ServiceReminderTimingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneSexArgs = {
  data: SexCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneSmsNotificationStatusArgs = {
  data: SmsNotificationStatusCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneSpeciesArgs = {
  data: SpeciesCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStaffRoleArgs = {
  data: StaffRoleCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripeCustomerArgs = {
  data: StripeCustomerCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripeDisputeArgs = {
  data: StripeDisputeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripeInvoiceArgs = {
  data: StripeInvoiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripeInvoiceItemArgs = {
  data: StripeInvoiceItemCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripePaymentIntentArgs = {
  data: StripePaymentIntentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripePaymentMethodArgs = {
  data: StripePaymentMethodCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripePayoutArgs = {
  data: StripePayoutCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripePayoutAccountArgs = {
  data: StripePayoutAccountCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripeReceiptArgs = {
  data?: Maybe<StripeReceiptCreateInput>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripeReceiptHistoryArgs = {
  data: StripeReceiptHistoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripeRefundArgs = {
  data: StripeRefundCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripeTerminalArgs = {
  data: StripeTerminalCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneStripeTerminalLocationArgs = {
  data: StripeTerminalLocationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneSurveyAppointmentTypeSettingArgs = {
  data: SurveyAppointmentTypeSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneSurveyResultArgs = {
  data: SurveyResultCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneSurveySettingArgs = {
  data: SurveySettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneSyncVetIntegrationArgs = {
  data: SyncVetIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneSyncVetServiceArgs = {
  data: SyncVetServiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneSynchronyClinicConfigurationArgs = {
  data: SynchronyClinicConfigurationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneSynchronyEventArgs = {
  data: SynchronyEventCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneTaskArgs = {
  data: TaskCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneTaxonomyArgs = {
  data: TaxonomyCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneTaxonomyToInformAudienceDefinitionArgs = {
  data: TaxonomyToInformAudienceDefinitionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneTransactionArgs = {
  data: TransactionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneTrupanionCertificateAvailabilityArgs = {
  data: TrupanionCertificateAvailabilityCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneTrupanionIntegratedAppointmentTypeArgs = {
  data: TrupanionIntegratedAppointmentTypeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneTrupanionIntegrationArgs = {
  data: TrupanionIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneUserArgs = {
  data: UserCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneUserAppointmentGroupingArgs = {
  data: UserAppointmentGroupingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneUserBoardFilterArgs = {
  data: UserBoardFilterCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneUserChannelFilterSelectionArgs = {
  data: UserChannelFilterSelectionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneUserNotificationSettingArgs = {
  data: UserNotificationSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneUserSettingArgs = {
  data: UserSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneUserTaskListArgs = {
  data: UserTaskListCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneUserTaskListFilterArgs = {
  data: UserTaskListFilterCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneVaccinationArgs = {
  data: VaccinationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneVetAvailabilityArgs = {
  data: VetAvailabilityCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneVetAvailabilityClinicRoomMapArgs = {
  data: VetAvailabilityClinicRoomMapCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneVetAvailabilityMapArgs = {
  data: VetAvailabilityMapCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneVetInfoArgs = {
  data: VetInfoCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneVetsourceCodeTagArgs = {
  data: VetsourceCodeTagCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneVetsourceInstallationArgs = {
  data: VetsourceInstallationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneVetsourcePharmacyIntegrationArgs = {
  data: VetsourcePharmacyIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneVetsourceRevenueCategoryArgs = {
  data: VetsourceRevenueCategoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateOneWorkflowEventSettingArgs = {
  data: WorkflowEventSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
};


export type MutationCreateSalesforceAccountArgs = {
  accountType?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
};


export type MutationCreateStripePaymentIntent2Args = {
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  data: StripeCreatePaymentInput;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransactionType?: Maybe<FinancialTransactionType>;
  invoiceIds?: Maybe<Array<Scalars['String']>>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  stripeTerminalStripeId?: Maybe<Scalars['String']>;
};


export type MutationCreateStripeTerminalLocationArgs = {
  displayName: Scalars['String'];
  type?: Maybe<StripeTerminalLocationType>;
};


export type MutationCreateSystemChannelMessage2Args = {
  data: SystemMessageCreateInput;
};


export type MutationCreateTeamChannel2Args = {
  data: CreateTeamChannelInput;
};


export type MutationCreateTerminalAppPaymentIntentArgs = {
  cardType?: Maybe<CardFunding>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  data: StripeCreatePaymentInput;
  emailOverride?: Maybe<Scalars['String']>;
  invoiceIds?: Maybe<Array<Scalars['String']>>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
};


export type MutationCreateTwilioTokenArgs = {
  data: CreateTwilioTokenInput;
};


export type MutationCreateWorkflowEventSettingAndConditionsArgs = {
  data: CreateWorkflowEventSettingAndConditionsInput;
};


export type MutationCustomUpsertOneUserBoardFilterArgs = {
  data: CustomUpsertOneUserBoardFilterDataInput;
  where: CustomUpsertOneUserBoardFilterWhereInput;
};


export type MutationDeactivateLoyaltyAccountArgs = {
  loyaltyAccountId: Scalars['String'];
};


export type MutationDeleteChannelFilterSelectionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEmailCampaignCustomListArgs = {
  data: DeleteEmailCampaignCustomListInput;
};


export type MutationDeleteManyActiveIngredientArgs = {
  where?: Maybe<ActiveIngredientWhereInput>;
};


export type MutationDeleteManyAppointmentArgs = {
  where?: Maybe<AppointmentWhereInput>;
};


export type MutationDeleteManyAppointmentAvailabilityArgs = {
  where?: Maybe<AppointmentAvailabilityWhereInput>;
};


export type MutationDeleteManyAppointmentNoteTemplateArgs = {
  where?: Maybe<AppointmentNoteTemplateWhereInput>;
};


export type MutationDeleteManyAppointmentTypeArgs = {
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type MutationDeleteManyAutomationRunArgs = {
  where?: Maybe<AutomationRunWhereInput>;
};


export type MutationDeleteManyAutomationRunActionArgs = {
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type MutationDeleteManyAxionClinicConfigurationArgs = {
  where?: Maybe<AxionClinicConfigurationWhereInput>;
};


export type MutationDeleteManyAxionClinicUserConfigurationArgs = {
  where?: Maybe<AxionClinicUserConfigurationWhereInput>;
};


export type MutationDeleteManyBedrockInferenceArgs = {
  where?: Maybe<BedrockInferenceWhereInput>;
};


export type MutationDeleteManyBitwerxHealthcheckArgs = {
  where?: Maybe<BitwerxHealthcheckWhereInput>;
};


export type MutationDeleteManyBitwerxIntegrationArgs = {
  where?: Maybe<BitwerxIntegrationWhereInput>;
};


export type MutationDeleteManyBitwerxPaymentHealthcheckResultArgs = {
  where?: Maybe<BitwerxPaymentHealthcheckResultWhereInput>;
};


export type MutationDeleteManyBitwerxPaymentHealthcheckRunArgs = {
  where?: Maybe<BitwerxPaymentHealthcheckRunWhereInput>;
};


export type MutationDeleteManyBoardFilterColumnArgs = {
  where?: Maybe<BoardFilterColumnWhereInput>;
};


export type MutationDeleteManyBoardFilterSpecificDateRangeArgs = {
  where?: Maybe<BoardFilterSpecificDateRangeWhereInput>;
};


export type MutationDeleteManyBoehringerIngelheimCustomerAlignmentArgs = {
  where?: Maybe<BoehringerIngelheimCustomerAlignmentWhereInput>;
};


export type MutationDeleteManyBoehringerIngelheimTerritoryArgs = {
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};


export type MutationDeleteManyBreedArgs = {
  where?: Maybe<BreedWhereInput>;
};


export type MutationDeleteManyCallHistoryArgs = {
  where?: Maybe<CallHistoryWhereInput>;
};


export type MutationDeleteManyCallParticipantArgs = {
  where?: Maybe<CallParticipantWhereInput>;
};


export type MutationDeleteManyCampaignRegistryCampaignArgs = {
  where?: Maybe<CampaignRegistryCampaignWhereInput>;
};


export type MutationDeleteManyCanonicalBreedArgs = {
  where?: Maybe<CanonicalBreedWhereInput>;
};


export type MutationDeleteManyCanonicalCanineBreedProfileArgs = {
  where?: Maybe<CanonicalCanineBreedProfileWhereInput>;
};


export type MutationDeleteManyCanonicalServiceArgs = {
  where?: Maybe<CanonicalServiceWhereInput>;
};


export type MutationDeleteManyCanonicalSpeciesArgs = {
  where?: Maybe<CanonicalSpeciesWhereInput>;
};


export type MutationDeleteManyCareAddonEnrollmentArgs = {
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};


export type MutationDeleteManyCareAddonPackageArgs = {
  where?: Maybe<CareAddonPackageWhereInput>;
};


export type MutationDeleteManyCareAddonPackageBenefitArgs = {
  where?: Maybe<CareAddonPackageBenefitWhereInput>;
};


export type MutationDeleteManyCareAuthorizationRequestArgs = {
  where?: Maybe<CareAuthorizationRequestWhereInput>;
};


export type MutationDeleteManyCareBenefitArgs = {
  where?: Maybe<CareBenefitWhereInput>;
};


export type MutationDeleteManyCareBenefitUsageArgs = {
  where?: Maybe<CareBenefitUsageWhereInput>;
};


export type MutationDeleteManyCareBenefitUsageFollowupArgs = {
  where?: Maybe<CareBenefitUsageFollowupWhereInput>;
};


export type MutationDeleteManyCareBenefitUsageFollowupStepArgs = {
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};


export type MutationDeleteManyCareBenefitUsageToInvoiceLineItemArgs = {
  where?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
};


export type MutationDeleteManyCareCreditPreapprovalCheckArgs = {
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};


export type MutationDeleteManyCareEnrollmentPaymentArgs = {
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};


export type MutationDeleteManyCareEnrollmentToStripeInvoiceItemArgs = {
  where?: Maybe<CareEnrollmentToStripeInvoiceItemWhereInput>;
};


export type MutationDeleteManyCareLapsedPaymentArgs = {
  where?: Maybe<CareLapsedPaymentWhereInput>;
};


export type MutationDeleteManyCarePlanArgs = {
  where?: Maybe<CarePlanWhereInput>;
};


export type MutationDeleteManyCarePlanBenefitArgs = {
  where?: Maybe<CarePlanBenefitWhereInput>;
};


export type MutationDeleteManyCarePlanBenefitEnrollmentCarryoverArgs = {
  where?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereInput>;
};


export type MutationDeleteManyCarePlanEnrollmentArgs = {
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type MutationDeleteManyCarePlanPricingArgs = {
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type MutationDeleteManyCarePlanProviderGroupArgs = {
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type MutationDeleteManyCareStripeSubscriptionArgs = {
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type MutationDeleteManyCareSubscriptionTrueUpArgs = {
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
};


export type MutationDeleteManyCareSubscriptionTrueUpLogEntryArgs = {
  where?: Maybe<CareSubscriptionTrueUpLogEntryWhereInput>;
};


export type MutationDeleteManyChannelArgs = {
  where?: Maybe<ChannelWhereInput>;
};


export type MutationDeleteManyChannelAutomationStatusArgs = {
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type MutationDeleteManyChannelCreationSourceArgs = {
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type MutationDeleteManyChannelFilterSelectionArgs = {
  where?: Maybe<ChannelFilterSelectionWhereInput>;
};


export type MutationDeleteManyChannelMemberArgs = {
  where?: Maybe<ChannelMemberWhereInput>;
};


export type MutationDeleteManyChannelMessageArgs = {
  where?: Maybe<ChannelMessageWhereInput>;
};


export type MutationDeleteManyChannelMessageAttachmentArgs = {
  where?: Maybe<ChannelMessageAttachmentWhereInput>;
};


export type MutationDeleteManyChannelMessageAutoResponseArgs = {
  where?: Maybe<ChannelMessageAutoResponseWhereInput>;
};


export type MutationDeleteManyChannelMessageReactionArgs = {
  where?: Maybe<ChannelMessageReactionWhereInput>;
};


export type MutationDeleteManyChannelPinArgs = {
  where?: Maybe<ChannelPinWhereInput>;
};


export type MutationDeleteManyChannelSelectionArgs = {
  where?: Maybe<ChannelSelectionWhereInput>;
};


export type MutationDeleteManyChannelStatusArgs = {
  where?: Maybe<ChannelStatusWhereInput>;
};


export type MutationDeleteManyChannelStatusChannelAssigneeArgs = {
  where?: Maybe<ChannelStatusChannelAssigneeWhereInput>;
};


export type MutationDeleteManyChemicalCompoundArgs = {
  where?: Maybe<ChemicalCompoundWhereInput>;
};


export type MutationDeleteManyClientConnectIntegrationArgs = {
  where?: Maybe<ClientConnectIntegrationWhereInput>;
};


export type MutationDeleteManyClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type MutationDeleteManyClinicBlockedPhoneNumberArgs = {
  where?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
};


export type MutationDeleteManyClinicCustomPayoutsSetupArgs = {
  where?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
};


export type MutationDeleteManyClinicDirectBookingSettingArgs = {
  where?: Maybe<ClinicDirectBookingSettingWhereInput>;
};


export type MutationDeleteManyClinicEmailCampaignSettingArgs = {
  where?: Maybe<ClinicEmailCampaignSettingWhereInput>;
};


export type MutationDeleteManyClinicEmployeeArgs = {
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type MutationDeleteManyClinicEmployeeAppointmentTypeSettingArgs = {
  where?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereInput>;
};


export type MutationDeleteManyClinicEntityPhoneNumberArgs = {
  where?: Maybe<ClinicEntityPhoneNumberWhereInput>;
};


export type MutationDeleteManyClinicModuleArgs = {
  where?: Maybe<ClinicModuleWhereInput>;
};


export type MutationDeleteManyClinicOfficeHourArgs = {
  where?: Maybe<ClinicOfficeHourWhereInput>;
};


export type MutationDeleteManyClinicOnboardingArgs = {
  where?: Maybe<ClinicOnboardingWhereInput>;
};


export type MutationDeleteManyClinicPaymentFeeConfigurationArgs = {
  where?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
};


export type MutationDeleteManyClinicPetArgs = {
  where?: Maybe<ClinicPetWhereInput>;
};


export type MutationDeleteManyClinicPetAlertArgs = {
  where?: Maybe<ClinicPetAlertWhereInput>;
};


export type MutationDeleteManyClinicPetCustomFieldValueArgs = {
  where?: Maybe<ClinicPetCustomFieldValueWhereInput>;
};


export type MutationDeleteManyClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type MutationDeleteManyClinicPetParentAddressArgs = {
  where?: Maybe<ClinicPetParentAddressWhereInput>;
};


export type MutationDeleteManyClinicPetParentCustomFieldValueArgs = {
  where?: Maybe<ClinicPetParentCustomFieldValueWhereInput>;
};


export type MutationDeleteManyClinicPetParentDeviceArgs = {
  where?: Maybe<ClinicPetParentDeviceWhereInput>;
};


export type MutationDeleteManyClinicPetParentPimsSyncStatusArgs = {
  where?: Maybe<ClinicPetParentPimsSyncStatusWhereInput>;
};


export type MutationDeleteManyClinicPetPimsSyncStatusArgs = {
  where?: Maybe<ClinicPetPimsSyncStatusWhereInput>;
};


export type MutationDeleteManyClinicPhoneNumberArgs = {
  where?: Maybe<ClinicPhoneNumberWhereInput>;
};


export type MutationDeleteManyClinicPimsIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type MutationDeleteManyClinicPimsIntegrationCapabilityArgs = {
  where?: Maybe<ClinicPimsIntegrationCapabilityWhereInput>;
};


export type MutationDeleteManyClinicPimsIntegrationCapabilityHistoryEntryArgs = {
  where?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>;
};


export type MutationDeleteManyClinicPostcardSettingArgs = {
  where?: Maybe<ClinicPostcardSettingWhereInput>;
};


export type MutationDeleteManyClinicRoomArgs = {
  where?: Maybe<ClinicRoomWhereInput>;
};


export type MutationDeleteManyClinicSettingArgs = {
  where?: Maybe<ClinicSettingWhereInput>;
};


export type MutationDeleteManyClinicUserFilterArgs = {
  where?: Maybe<ClinicUserFilterWhereInput>;
};


export type MutationDeleteManyClinicWidgetRequestArgs = {
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type MutationDeleteManyClinicWidgetRequestTypeArgs = {
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};


export type MutationDeleteManyClinicWidgetSettingArgs = {
  where?: Maybe<ClinicWidgetSettingWhereInput>;
};


export type MutationDeleteManyColorArgs = {
  where?: Maybe<ColorWhereInput>;
};


export type MutationDeleteManyConditionArgs = {
  where?: Maybe<ConditionWhereInput>;
};


export type MutationDeleteManyConditionSetArgs = {
  where?: Maybe<ConditionSetWhereInput>;
};


export type MutationDeleteManyConditionalEntityEvaluationArgs = {
  where?: Maybe<ConditionalEntityEvaluationWhereInput>;
};


export type MutationDeleteManyConsultationRequestArgs = {
  where?: Maybe<ConsultationRequestWhereInput>;
};


export type MutationDeleteManyCustomFieldDefinitionArgs = {
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};


export type MutationDeleteManyCustomFieldPimsWritebackLogEntryArgs = {
  where?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
};


export type MutationDeleteManyDirectBookingAppointmentTypeSettingArgs = {
  where?: Maybe<DirectBookingAppointmentTypeSettingWhereInput>;
};


export type MutationDeleteManyDirectBookingExclusionTimeSlotArgs = {
  where?: Maybe<DirectBookingExclusionTimeSlotWhereInput>;
};


export type MutationDeleteManyDisbursementArgs = {
  where?: Maybe<DisbursementWhereInput>;
};


export type MutationDeleteManyDocumentationArgs = {
  where?: Maybe<DocumentationWhereInput>;
};


export type MutationDeleteManyEmailCampaignArgs = {
  where?: Maybe<EmailCampaignWhereInput>;
};


export type MutationDeleteManyEmailCampaignCustomListArgs = {
  where?: Maybe<EmailCampaignCustomListWhereInput>;
};


export type MutationDeleteManyEmailCampaignCustomListRecipientArgs = {
  where?: Maybe<EmailCampaignCustomListRecipientWhereInput>;
};


export type MutationDeleteManyEmailCampaignCustomListUploadHistoryArgs = {
  where?: Maybe<EmailCampaignCustomListUploadHistoryWhereInput>;
};


export type MutationDeleteManyEmailCampaignLogArgs = {
  where?: Maybe<EmailCampaignLogWhereInput>;
};


export type MutationDeleteManyEmailCampaignTemplateArgs = {
  where?: Maybe<EmailCampaignTemplateWhereInput>;
};


export type MutationDeleteManyEmailCampaignUnsubscribeArgs = {
  where?: Maybe<EmailCampaignUnsubscribeWhereInput>;
};


export type MutationDeleteManyEmailProviderLogArgs = {
  where?: Maybe<EmailProviderLogWhereInput>;
};


export type MutationDeleteManyEmergencyClinicsArgs = {
  where?: Maybe<EmergencyClinicsWhereInput>;
};


export type MutationDeleteManyEncryptedClinicUploadArgs = {
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};


export type MutationDeleteManyEnrollmentSupportEventArgs = {
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type MutationDeleteManyEzyVetIntegrationArgs = {
  where?: Maybe<EzyVetIntegrationWhereInput>;
};


export type MutationDeleteManyFeatureFlagArgs = {
  where?: Maybe<FeatureFlagWhereInput>;
};


export type MutationDeleteManyFinancialAdjustmentArgs = {
  where?: Maybe<FinancialAdjustmentWhereInput>;
};


export type MutationDeleteManyFinancialTransactionArgs = {
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type MutationDeleteManyFormSubmissionArgs = {
  where?: Maybe<FormSubmissionWhereInput>;
};


export type MutationDeleteManyFormTemplateArgs = {
  where?: Maybe<FormTemplateWhereInput>;
};


export type MutationDeleteManyGlobalPetParentArgs = {
  where?: Maybe<GlobalPetParentWhereInput>;
};


export type MutationDeleteManyGooglePlaceArgs = {
  where?: Maybe<GooglePlaceWhereInput>;
};


export type MutationDeleteManyHillsToHomeApiLogArgs = {
  where?: Maybe<HillsToHomeApiLogWhereInput>;
};


export type MutationDeleteManyInformAudienceDefinitionArgs = {
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};


export type MutationDeleteManyInformAudienceMemberArgs = {
  where?: Maybe<InformAudienceMemberWhereInput>;
};


export type MutationDeleteManyInformAudienceMemberMessageArgs = {
  where?: Maybe<InformAudienceMemberMessageWhereInput>;
};


export type MutationDeleteManyInformAutomationCampaignArgs = {
  where?: Maybe<InformAutomationCampaignWhereInput>;
};


export type MutationDeleteManyInformCampaignArgs = {
  where?: Maybe<InformCampaignWhereInput>;
};


export type MutationDeleteManyInformCampaignEnrollmentArgs = {
  where?: Maybe<InformCampaignEnrollmentWhereInput>;
};


export type MutationDeleteManyInformCampaignEnrollmentCanonicalServiceArgs = {
  where?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereInput>;
};


export type MutationDeleteManyInformCampaignExecutionArgs = {
  where?: Maybe<InformCampaignExecutionWhereInput>;
};


export type MutationDeleteManyInformCampaignGroupArgs = {
  where?: Maybe<InformCampaignGroupWhereInput>;
};


export type MutationDeleteManyInformCommunicationOptOutArgs = {
  where?: Maybe<InformCommunicationOptOutWhereInput>;
};


export type MutationDeleteManyInformControlGroupParticipantArgs = {
  where?: Maybe<InformControlGroupParticipantWhereInput>;
};


export type MutationDeleteManyInformEmailTemplateArgs = {
  where?: Maybe<InformEmailTemplateWhereInput>;
};


export type MutationDeleteManyInformEntityHistoryArgs = {
  where?: Maybe<InformEntityHistoryWhereInput>;
};


export type MutationDeleteManyInformEventDrivenCampaignArgs = {
  where?: Maybe<InformEventDrivenCampaignWhereInput>;
};


export type MutationDeleteManyInformEventListenerArgs = {
  where?: Maybe<InformEventListenerWhereInput>;
};


export type MutationDeleteManyInformNotificationRecipientArgs = {
  where?: Maybe<InformNotificationRecipientWhereInput>;
};


export type MutationDeleteManyInformPartnerArgs = {
  where?: Maybe<InformPartnerWhereInput>;
};


export type MutationDeleteManyInformPartnerCustomerArgs = {
  where?: Maybe<InformPartnerCustomerWhereInput>;
};


export type MutationDeleteManyInformPartnerCustomerPharmacyProviderArgs = {
  where?: Maybe<InformPartnerCustomerPharmacyProviderWhereInput>;
};


export type MutationDeleteManyInformPartnerIntegrationArgs = {
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};


export type MutationDeleteManyInformPartnerIntegrationModelArgs = {
  where?: Maybe<InformPartnerIntegrationModelWhereInput>;
};


export type MutationDeleteManyInformPartnerProgramArgs = {
  where?: Maybe<InformPartnerProgramWhereInput>;
};


export type MutationDeleteManyInformPartnerProgramEnrollmentArgs = {
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};


export type MutationDeleteManyInformPartnerUserArgs = {
  where?: Maybe<InformPartnerUserWhereInput>;
};


export type MutationDeleteManyInformPartnerUserRoleArgs = {
  where?: Maybe<InformPartnerUserRoleWhereInput>;
};


export type MutationDeleteManyInformScheduledCampaignArgs = {
  where?: Maybe<InformScheduledCampaignWhereInput>;
};


export type MutationDeleteManyInformSessionArgs = {
  where?: Maybe<InformSessionWhereInput>;
};


export type MutationDeleteManyInformSessionEventArgs = {
  where?: Maybe<InformSessionEventWhereInput>;
};


export type MutationDeleteManyInstinctIntegrationArgs = {
  where?: Maybe<InstinctIntegrationWhereInput>;
};


export type MutationDeleteManyInsuranceIntegrationArgs = {
  where?: Maybe<InsuranceIntegrationWhereInput>;
};


export type MutationDeleteManyIntegrationOutageHistoryEntryArgs = {
  where?: Maybe<IntegrationOutageHistoryEntryWhereInput>;
};


export type MutationDeleteManyInterchangeRateArgs = {
  where?: Maybe<InterchangeRateWhereInput>;
};


export type MutationDeleteManyInvoiceArgs = {
  where?: Maybe<InvoiceWhereInput>;
};


export type MutationDeleteManyInvoiceLineItemArgs = {
  where?: Maybe<InvoiceLineItemWhereInput>;
};


export type MutationDeleteManyInvoicePimsWritebackLogEntryArgs = {
  where?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
};


export type MutationDeleteManyLabPanelArgs = {
  where?: Maybe<LabPanelWhereInput>;
};


export type MutationDeleteManyLabResultArgs = {
  where?: Maybe<LabResultWhereInput>;
};


export type MutationDeleteManyLapsedPetParentTriggersArgs = {
  where?: Maybe<LapsedPetParentTriggersWhereInput>;
};


export type MutationDeleteManyLoyaltyAccountArgs = {
  where?: Maybe<LoyaltyAccountWhereInput>;
};


export type MutationDeleteManyLoyaltyAccountHolderArgs = {
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};


export type MutationDeleteManyLoyaltyAccountMergerArgs = {
  where?: Maybe<LoyaltyAccountMergerWhereInput>;
};


export type MutationDeleteManyLoyaltyInvoicePointGranterArgs = {
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};


export type MutationDeleteManyLoyaltyPointGrantingServiceArgs = {
  where?: Maybe<LoyaltyPointGrantingServiceWhereInput>;
};


export type MutationDeleteManyLoyaltyPointGrantingServiceCategoryArgs = {
  where?: Maybe<LoyaltyPointGrantingServiceCategoryWhereInput>;
};


export type MutationDeleteManyLoyaltyPointUserGrantArgs = {
  where?: Maybe<LoyaltyPointUserGrantWhereInput>;
};


export type MutationDeleteManyLoyaltyRewardRedemptionArgs = {
  where?: Maybe<LoyaltyRewardRedemptionWhereInput>;
};


export type MutationDeleteManyMassTextAlertArgs = {
  where?: Maybe<MassTextAlertWhereInput>;
};


export type MutationDeleteManyMassTextAlertEntryArgs = {
  where?: Maybe<MassTextAlertEntryWhereInput>;
};


export type MutationDeleteManyMassTextAlertEntryAppointmentArgs = {
  where?: Maybe<MassTextAlertEntryAppointmentWhereInput>;
};


export type MutationDeleteManyMediaArgs = {
  where?: Maybe<MediaWhereInput>;
};


export type MutationDeleteManyMedicalHistoryArgs = {
  where?: Maybe<MedicalHistoryWhereInput>;
};


export type MutationDeleteManyMessageTemplateArgs = {
  where?: Maybe<MessageTemplateWhereInput>;
};


export type MutationDeleteManyMessagingCampaignArgs = {
  where?: Maybe<MessagingCampaignWhereInput>;
};


export type MutationDeleteManyMessagingPartnerArgs = {
  where?: Maybe<MessagingPartnerWhereInput>;
};


export type MutationDeleteManyModuleArgs = {
  where?: Maybe<ModuleWhereInput>;
};


export type MutationDeleteManyNonPrismaSchemaScriptRanArgs = {
  where?: Maybe<NonPrismaSchemaScriptRanWhereInput>;
};


export type MutationDeleteManyNotificationEventToMessageArgs = {
  where?: Maybe<NotificationEventToMessageWhereInput>;
};


export type MutationDeleteManyOrganizationArgs = {
  where?: Maybe<OrganizationWhereInput>;
};


export type MutationDeleteManyOrganizationCareBenefitToClinicServiceArgs = {
  where?: Maybe<OrganizationCareBenefitToClinicServiceWhereInput>;
};


export type MutationDeleteManyOrganizationCareBenefitToClinicServiceCategoryArgs = {
  where?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereInput>;
};


export type MutationDeleteManyOrganizationPetArgs = {
  where?: Maybe<OrganizationPetWhereInput>;
};


export type MutationDeleteManyOrganizationPetParentArgs = {
  where?: Maybe<OrganizationPetParentWhereInput>;
};


export type MutationDeleteManyOrganizationPetToOrganizationPetParentArgs = {
  where?: Maybe<OrganizationPetToOrganizationPetParentWhereInput>;
};


export type MutationDeleteManyPpcIntegrationArgs = {
  where?: Maybe<PpcIntegrationWhereInput>;
};


export type MutationDeleteManyPaymentsReportTransactionArgs = {
  where?: Maybe<PaymentsReportTransactionWhereInput>;
};


export type MutationDeleteManyPayoutBatchingScheduleArgs = {
  where?: Maybe<PayoutBatchingScheduleWhereInput>;
};


export type MutationDeleteManyPayoutBatchingSettingArgs = {
  where?: Maybe<PayoutBatchingSettingWhereInput>;
};


export type MutationDeleteManyPermissionArgs = {
  where?: Maybe<PermissionWhereInput>;
};


export type MutationDeleteManyPetParentSettingArgs = {
  where?: Maybe<PetParentSettingWhereInput>;
};


export type MutationDeleteManyPetPortalSettingArgs = {
  where?: Maybe<PetPortalSettingWhereInput>;
};


export type MutationDeleteManyPhoneNumberLookupRequestArgs = {
  where?: Maybe<PhoneNumberLookupRequestWhereInput>;
};


export type MutationDeleteManyPhoneNumberLookupResultArgs = {
  where?: Maybe<PhoneNumberLookupResultWhereInput>;
};


export type MutationDeleteManyPimsInvoiceArgs = {
  where?: Maybe<PimsInvoiceWhereInput>;
};


export type MutationDeleteManyPimsInvoiceLineItemArgs = {
  where?: Maybe<PimsInvoiceLineItemWhereInput>;
};


export type MutationDeleteManyPimsWritebackLogEntryArgs = {
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};


export type MutationDeleteManyPrescriptionArgs = {
  where?: Maybe<PrescriptionWhereInput>;
};


export type MutationDeleteManyProductArgs = {
  where?: Maybe<ProductWhereInput>;
};


export type MutationDeleteManyProductPackageArgs = {
  where?: Maybe<ProductPackageWhereInput>;
};


export type MutationDeleteManyProductPackageSubscriptionArgs = {
  where?: Maybe<ProductPackageSubscriptionWhereInput>;
};


export type MutationDeleteManyProviderAppointmentTypeRoomMapArgs = {
  where?: Maybe<ProviderAppointmentTypeRoomMapWhereInput>;
};


export type MutationDeleteManyPushNotificationLogArgs = {
  where?: Maybe<PushNotificationLogWhereInput>;
};


export type MutationDeleteManyRecapArgs = {
  where?: Maybe<RecapWhereInput>;
};


export type MutationDeleteManyRulesArgs = {
  where?: Maybe<RulesWhereInput>;
};


export type MutationDeleteManySegmentArgs = {
  where?: Maybe<SegmentWhereInput>;
};


export type MutationDeleteManySentTrupanionExamDayOfferArgs = {
  where?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};


export type MutationDeleteManyServiceArgs = {
  where?: Maybe<ServiceWhereInput>;
};


export type MutationDeleteManyServiceCategoryArgs = {
  where?: Maybe<ServiceCategoryWhereInput>;
};


export type MutationDeleteManyServicePurchaseSummaryArgs = {
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};


export type MutationDeleteManyServiceReminderArgs = {
  where?: Maybe<ServiceReminderWhereInput>;
};


export type MutationDeleteManyServiceReminderNotificationArgs = {
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};


export type MutationDeleteManyServiceReminderTimingArgs = {
  where?: Maybe<ServiceReminderTimingWhereInput>;
};


export type MutationDeleteManySexArgs = {
  where?: Maybe<SexWhereInput>;
};


export type MutationDeleteManySmsNotificationStatusArgs = {
  where?: Maybe<SmsNotificationStatusWhereInput>;
};


export type MutationDeleteManySpeciesArgs = {
  where?: Maybe<SpeciesWhereInput>;
};


export type MutationDeleteManyStaffRoleArgs = {
  where?: Maybe<StaffRoleWhereInput>;
};


export type MutationDeleteManyStripeCustomerArgs = {
  where?: Maybe<StripeCustomerWhereInput>;
};


export type MutationDeleteManyStripeDisputeArgs = {
  where?: Maybe<StripeDisputeWhereInput>;
};


export type MutationDeleteManyStripeInvoiceArgs = {
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type MutationDeleteManyStripeInvoiceItemArgs = {
  where?: Maybe<StripeInvoiceItemWhereInput>;
};


export type MutationDeleteManyStripePaymentMethodArgs = {
  where?: Maybe<StripePaymentMethodWhereInput>;
};


export type MutationDeleteManyStripePayoutArgs = {
  where?: Maybe<StripePayoutWhereInput>;
};


export type MutationDeleteManyStripePayoutAccountArgs = {
  where?: Maybe<StripePayoutAccountWhereInput>;
};


export type MutationDeleteManyStripeReceiptArgs = {
  where?: Maybe<StripeReceiptWhereInput>;
};


export type MutationDeleteManyStripeReceiptHistoryArgs = {
  where?: Maybe<StripeReceiptHistoryWhereInput>;
};


export type MutationDeleteManyStripeRefundArgs = {
  where?: Maybe<StripeRefundWhereInput>;
};


export type MutationDeleteManyStripeTerminalArgs = {
  where?: Maybe<StripeTerminalWhereInput>;
};


export type MutationDeleteManyStripeTerminalLocationArgs = {
  where?: Maybe<StripeTerminalLocationWhereInput>;
};


export type MutationDeleteManySurveyAppointmentTypeSettingArgs = {
  where?: Maybe<SurveyAppointmentTypeSettingWhereInput>;
};


export type MutationDeleteManySurveyResultArgs = {
  where?: Maybe<SurveyResultWhereInput>;
};


export type MutationDeleteManySurveySettingArgs = {
  where?: Maybe<SurveySettingWhereInput>;
};


export type MutationDeleteManySyncVetIntegrationArgs = {
  where?: Maybe<SyncVetIntegrationWhereInput>;
};


export type MutationDeleteManySyncVetServiceArgs = {
  where?: Maybe<SyncVetServiceWhereInput>;
};


export type MutationDeleteManySynchronyClinicConfigurationArgs = {
  where?: Maybe<SynchronyClinicConfigurationWhereInput>;
};


export type MutationDeleteManySynchronyEventArgs = {
  where?: Maybe<SynchronyEventWhereInput>;
};


export type MutationDeleteManyTaskArgs = {
  where?: Maybe<TaskWhereInput>;
};


export type MutationDeleteManyTaxonomyArgs = {
  where?: Maybe<TaxonomyWhereInput>;
};


export type MutationDeleteManyTaxonomyToInformAudienceDefinitionArgs = {
  where?: Maybe<TaxonomyToInformAudienceDefinitionWhereInput>;
};


export type MutationDeleteManyTransactionArgs = {
  where?: Maybe<TransactionWhereInput>;
};


export type MutationDeleteManyTrupanionCertificateAvailabilityArgs = {
  where?: Maybe<TrupanionCertificateAvailabilityWhereInput>;
};


export type MutationDeleteManyTrupanionIntegratedAppointmentTypeArgs = {
  where?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
};


export type MutationDeleteManyTrupanionIntegrationArgs = {
  where?: Maybe<TrupanionIntegrationWhereInput>;
};


export type MutationDeleteManyUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type MutationDeleteManyUserAppointmentGroupingArgs = {
  where?: Maybe<UserAppointmentGroupingWhereInput>;
};


export type MutationDeleteManyUserBoardFilterArgs = {
  where?: Maybe<UserBoardFilterWhereInput>;
};


export type MutationDeleteManyUserChannelFilterSelectionArgs = {
  where?: Maybe<UserChannelFilterSelectionWhereInput>;
};


export type MutationDeleteManyUserNotificationSettingArgs = {
  where?: Maybe<UserNotificationSettingWhereInput>;
};


export type MutationDeleteManyUserSettingArgs = {
  where?: Maybe<UserSettingWhereInput>;
};


export type MutationDeleteManyUserTaskListArgs = {
  where?: Maybe<UserTaskListWhereInput>;
};


export type MutationDeleteManyUserTaskListFilterArgs = {
  where?: Maybe<UserTaskListFilterWhereInput>;
};


export type MutationDeleteManyVaccinationArgs = {
  where?: Maybe<VaccinationWhereInput>;
};


export type MutationDeleteManyVetAvailabilityArgs = {
  where?: Maybe<VetAvailabilityWhereInput>;
};


export type MutationDeleteManyVetAvailabilityClinicRoomMapArgs = {
  where?: Maybe<VetAvailabilityClinicRoomMapWhereInput>;
};


export type MutationDeleteManyVetAvailabilityMapArgs = {
  where?: Maybe<VetAvailabilityMapWhereInput>;
};


export type MutationDeleteManyVetInfoArgs = {
  where?: Maybe<VetInfoWhereInput>;
};


export type MutationDeleteManyVetsourceCodeTagArgs = {
  where?: Maybe<VetsourceCodeTagWhereInput>;
};


export type MutationDeleteManyVetsourceInstallationArgs = {
  where?: Maybe<VetsourceInstallationWhereInput>;
};


export type MutationDeleteManyVetsourcePharmacyIntegrationArgs = {
  where?: Maybe<VetsourcePharmacyIntegrationWhereInput>;
};


export type MutationDeleteManyVetsourceRevenueCategoryArgs = {
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};


export type MutationDeleteManyWorkflowEventSettingArgs = {
  where?: Maybe<WorkflowEventSettingWhereInput>;
};


export type MutationDeleteOneActiveIngredientArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ActiveIngredientWhereUniqueInput;
};


export type MutationDeleteOneAppointmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AppointmentWhereUniqueInput;
};


export type MutationDeleteOneAppointmentAvailabilityArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AppointmentAvailabilityWhereUniqueInput;
};


export type MutationDeleteOneAppointmentNoteTemplateArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AppointmentNoteTemplateWhereUniqueInput;
};


export type MutationDeleteOneAppointmentTypeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AppointmentTypeWhereUniqueInput;
};


export type MutationDeleteOneAutomationRunArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AutomationRunWhereUniqueInput;
};


export type MutationDeleteOneAutomationRunActionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AutomationRunActionWhereUniqueInput;
};


export type MutationDeleteOneAxionClinicConfigurationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AxionClinicConfigurationWhereUniqueInput;
};


export type MutationDeleteOneAxionClinicUserConfigurationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AxionClinicUserConfigurationWhereUniqueInput;
};


export type MutationDeleteOneBedrockInferenceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BedrockInferenceWhereUniqueInput;
};


export type MutationDeleteOneBitwerxHealthcheckArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxHealthcheckWhereUniqueInput;
};


export type MutationDeleteOneBitwerxIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxIntegrationWhereUniqueInput;
};


export type MutationDeleteOneBitwerxPaymentHealthcheckResultArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxPaymentHealthcheckResultWhereUniqueInput;
};


export type MutationDeleteOneBitwerxPaymentHealthcheckRunArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxPaymentHealthcheckRunWhereUniqueInput;
};


export type MutationDeleteOneBoardFilterColumnArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BoardFilterColumnWhereUniqueInput;
};


export type MutationDeleteOneBoardFilterSpecificDateRangeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BoardFilterSpecificDateRangeWhereUniqueInput;
};


export type MutationDeleteOneBoehringerIngelheimCustomerAlignmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BoehringerIngelheimCustomerAlignmentWhereUniqueInput;
};


export type MutationDeleteOneBoehringerIngelheimTerritoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BoehringerIngelheimTerritoryWhereUniqueInput;
};


export type MutationDeleteOneBreedArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BreedWhereUniqueInput;
};


export type MutationDeleteOneCallHistoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CallHistoryWhereUniqueInput;
};


export type MutationDeleteOneCallParticipantArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CallParticipantWhereUniqueInput;
};


export type MutationDeleteOneCallRecordingArgs = {
  where: CallRecordingWhereUniqueInput;
};


export type MutationDeleteOneCampaignRegistryCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CampaignRegistryCampaignWhereUniqueInput;
};


export type MutationDeleteOneCanonicalBreedArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CanonicalBreedWhereUniqueInput;
};


export type MutationDeleteOneCanonicalCanineBreedProfileArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CanonicalCanineBreedProfileWhereUniqueInput;
};


export type MutationDeleteOneCanonicalServiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CanonicalServiceWhereUniqueInput;
};


export type MutationDeleteOneCanonicalSpeciesArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CanonicalSpeciesWhereUniqueInput;
};


export type MutationDeleteOneCareAddonEnrollmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAddonEnrollmentWhereUniqueInput;
};


export type MutationDeleteOneCareAddonPackageArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAddonPackageWhereUniqueInput;
};


export type MutationDeleteOneCareAddonPackageBenefitArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAddonPackageBenefitWhereUniqueInput;
};


export type MutationDeleteOneCareAuthorizationRequestArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAuthorizationRequestWhereUniqueInput;
};


export type MutationDeleteOneCareBenefitArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitWhereUniqueInput;
};


export type MutationDeleteOneCareBenefitUsageArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitUsageWhereUniqueInput;
};


export type MutationDeleteOneCareBenefitUsageFollowupArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitUsageFollowupWhereUniqueInput;
};


export type MutationDeleteOneCareBenefitUsageFollowupStepArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitUsageFollowupStepWhereUniqueInput;
};


export type MutationDeleteOneCareBenefitUsageToInvoiceLineItemArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};


export type MutationDeleteOneCareCreditPreapprovalCheckArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareCreditPreapprovalCheckWhereUniqueInput;
};


export type MutationDeleteOneCareEnrollmentPaymentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareEnrollmentPaymentWhereUniqueInput;
};


export type MutationDeleteOneCareEnrollmentToStripeInvoiceItemArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};


export type MutationDeleteOneCareLapsedPaymentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareLapsedPaymentWhereUniqueInput;
};


export type MutationDeleteOneCarePlanArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanWhereUniqueInput;
};


export type MutationDeleteOneCarePlanBenefitArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanBenefitWhereUniqueInput;
};


export type MutationDeleteOneCarePlanBenefitEnrollmentCarryoverArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};


export type MutationDeleteOneCarePlanEnrollmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanEnrollmentWhereUniqueInput;
};


export type MutationDeleteOneCarePlanPricingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanPricingWhereUniqueInput;
};


export type MutationDeleteOneCarePlanProviderGroupArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanProviderGroupWhereUniqueInput;
};


export type MutationDeleteOneCareStripeSubscriptionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareStripeSubscriptionWhereUniqueInput;
};


export type MutationDeleteOneCareSubscriptionTrueUpArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};


export type MutationDeleteOneCareSubscriptionTrueUpLogEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareSubscriptionTrueUpLogEntryWhereUniqueInput;
};


export type MutationDeleteOneChannelArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelWhereUniqueInput;
};


export type MutationDeleteOneChannelAutomationStatusArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelAutomationStatusWhereUniqueInput;
};


export type MutationDeleteOneChannelCreationSourceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelCreationSourceWhereUniqueInput;
};


export type MutationDeleteOneChannelFilterSelectionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelFilterSelectionWhereUniqueInput;
};


export type MutationDeleteOneChannelMemberArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMemberWhereUniqueInput;
};


export type MutationDeleteOneChannelMessageArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMessageWhereUniqueInput;
};


export type MutationDeleteOneChannelMessageAttachmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMessageAttachmentWhereUniqueInput;
};


export type MutationDeleteOneChannelMessageAutoResponseArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMessageAutoResponseWhereUniqueInput;
};


export type MutationDeleteOneChannelMessageReactionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMessageReactionWhereUniqueInput;
};


export type MutationDeleteOneChannelPinArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelPinWhereUniqueInput;
};


export type MutationDeleteOneChannelSelectionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelSelectionWhereUniqueInput;
};


export type MutationDeleteOneChannelStatusArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelStatusWhereUniqueInput;
};


export type MutationDeleteOneChannelStatusChannelAssigneeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};


export type MutationDeleteOneChemicalCompoundArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChemicalCompoundWhereUniqueInput;
};


export type MutationDeleteOneClientConnectIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClientConnectIntegrationWhereUniqueInput;
};


export type MutationDeleteOneClinicArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicWhereUniqueInput;
};


export type MutationDeleteOneClinicBlockedPhoneNumberArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};


export type MutationDeleteOneClinicCustomPayoutsSetupArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicCustomPayoutsSetupWhereUniqueInput;
};


export type MutationDeleteOneClinicDirectBookingSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicDirectBookingSettingWhereUniqueInput;
};


export type MutationDeleteOneClinicEmailCampaignSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicEmailCampaignSettingWhereUniqueInput;
};


export type MutationDeleteOneClinicEmployeeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicEmployeeWhereUniqueInput;
};


export type MutationDeleteOneClinicEmployeeAppointmentTypeSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicEmployeeAppointmentTypeSettingWhereUniqueInput;
};


export type MutationDeleteOneClinicEntityPhoneNumberArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};


export type MutationDeleteOneClinicModuleArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicModuleWhereUniqueInput;
};


export type MutationDeleteOneClinicOfficeHourArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicOfficeHourWhereUniqueInput;
};


export type MutationDeleteOneClinicOnboardingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicOnboardingWhereUniqueInput;
};


export type MutationDeleteOneClinicPaymentFeeConfigurationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPaymentFeeConfigurationWhereUniqueInput;
};


export type MutationDeleteOneClinicPetArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetWhereUniqueInput;
};


export type MutationDeleteOneClinicPetAlertArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetAlertWhereUniqueInput;
};


export type MutationDeleteOneClinicPetCustomFieldValueArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetCustomFieldValueWhereUniqueInput;
};


export type MutationDeleteOneClinicPetParentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentWhereUniqueInput;
};


export type MutationDeleteOneClinicPetParentAddressArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentAddressWhereUniqueInput;
};


export type MutationDeleteOneClinicPetParentCustomFieldValueArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentCustomFieldValueWhereUniqueInput;
};


export type MutationDeleteOneClinicPetParentDeviceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentDeviceWhereUniqueInput;
};


export type MutationDeleteOneClinicPetParentPimsSyncStatusArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentPimsSyncStatusWhereUniqueInput;
};


export type MutationDeleteOneClinicPetPimsSyncStatusArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetPimsSyncStatusWhereUniqueInput;
};


export type MutationDeleteOneClinicPhoneNumberArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPhoneNumberWhereUniqueInput;
};


export type MutationDeleteOneClinicPimsIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPimsIntegrationWhereUniqueInput;
};


export type MutationDeleteOneClinicPimsIntegrationCapabilityArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPimsIntegrationCapabilityWhereUniqueInput;
};


export type MutationDeleteOneClinicPimsIntegrationCapabilityHistoryEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput;
};


export type MutationDeleteOneClinicPostcardSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPostcardSettingWhereUniqueInput;
};


export type MutationDeleteOneClinicRoomArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicRoomWhereUniqueInput;
};


export type MutationDeleteOneClinicSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicSettingWhereUniqueInput;
};


export type MutationDeleteOneClinicUserFilterArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicUserFilterWhereUniqueInput;
};


export type MutationDeleteOneClinicWidgetRequestArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicWidgetRequestWhereUniqueInput;
};


export type MutationDeleteOneClinicWidgetRequestTypeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};


export type MutationDeleteOneClinicWidgetSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicWidgetSettingWhereUniqueInput;
};


export type MutationDeleteOneColorArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ColorWhereUniqueInput;
};


export type MutationDeleteOneConditionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConditionWhereUniqueInput;
};


export type MutationDeleteOneConditionSetArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConditionSetWhereUniqueInput;
};


export type MutationDeleteOneConditionalEntityEvaluationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConditionalEntityEvaluationWhereUniqueInput;
};


export type MutationDeleteOneConsultationRequestArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConsultationRequestWhereUniqueInput;
};


export type MutationDeleteOneCustomFieldDefinitionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CustomFieldDefinitionWhereUniqueInput;
};


export type MutationDeleteOneCustomFieldPimsWritebackLogEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CustomFieldPimsWritebackLogEntryWhereUniqueInput;
};


export type MutationDeleteOneDirectBookingAppointmentTypeSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DirectBookingAppointmentTypeSettingWhereUniqueInput;
};


export type MutationDeleteOneDirectBookingExclusionRuleArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};


export type MutationDeleteOneDirectBookingExclusionTimeSlotArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DirectBookingExclusionTimeSlotWhereUniqueInput;
};


export type MutationDeleteOneDisbursementArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DisbursementWhereUniqueInput;
};


export type MutationDeleteOneDocumentationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DocumentationWhereUniqueInput;
};


export type MutationDeleteOneEmailCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignWhereUniqueInput;
};


export type MutationDeleteOneEmailCampaignCustomListArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignCustomListWhereUniqueInput;
};


export type MutationDeleteOneEmailCampaignCustomListRecipientArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignCustomListRecipientWhereUniqueInput;
};


export type MutationDeleteOneEmailCampaignCustomListUploadHistoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignCustomListUploadHistoryWhereUniqueInput;
};


export type MutationDeleteOneEmailCampaignLogArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignLogWhereUniqueInput;
};


export type MutationDeleteOneEmailCampaignTemplateArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignTemplateWhereUniqueInput;
};


export type MutationDeleteOneEmailCampaignUnsubscribeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};


export type MutationDeleteOneEmailProviderLogArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailProviderLogWhereUniqueInput;
};


export type MutationDeleteOneEmergencyClinicsArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmergencyClinicsWhereUniqueInput;
};


export type MutationDeleteOneEncryptedClinicUploadArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EncryptedClinicUploadWhereUniqueInput;
};


export type MutationDeleteOneEnrollmentSupportEventArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EnrollmentSupportEventWhereUniqueInput;
};


export type MutationDeleteOneEzyVetIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EzyVetIntegrationWhereUniqueInput;
};


export type MutationDeleteOneFeatureFlagArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FeatureFlagWhereUniqueInput;
};


export type MutationDeleteOneFinancialAdjustmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FinancialAdjustmentWhereUniqueInput;
};


export type MutationDeleteOneFinancialTransactionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FinancialTransactionWhereUniqueInput;
};


export type MutationDeleteOneFormSubmissionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FormSubmissionWhereUniqueInput;
};


export type MutationDeleteOneFormTemplateArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FormTemplateWhereUniqueInput;
};


export type MutationDeleteOneGlobalPetParentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: GlobalPetParentWhereUniqueInput;
};


export type MutationDeleteOneGooglePlaceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: GooglePlaceWhereUniqueInput;
};


export type MutationDeleteOneHillsToHomeApiLogArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: HillsToHomeApiLogWhereUniqueInput;
};


export type MutationDeleteOneInformAudienceDefinitionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformAudienceDefinitionWhereUniqueInput;
};


export type MutationDeleteOneInformAudienceMemberArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformAudienceMemberWhereUniqueInput;
};


export type MutationDeleteOneInformAudienceMemberMessageArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformAudienceMemberMessageWhereUniqueInput;
};


export type MutationDeleteOneInformAutomationCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformAutomationCampaignWhereUniqueInput;
};


export type MutationDeleteOneInformCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignWhereUniqueInput;
};


export type MutationDeleteOneInformCampaignEnrollmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignEnrollmentWhereUniqueInput;
};


export type MutationDeleteOneInformCampaignEnrollmentCanonicalServiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignEnrollmentCanonicalServiceWhereUniqueInput;
};


export type MutationDeleteOneInformCampaignExecutionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignExecutionWhereUniqueInput;
};


export type MutationDeleteOneInformCampaignGroupArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignGroupWhereUniqueInput;
};


export type MutationDeleteOneInformCommunicationOptOutArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCommunicationOptOutWhereUniqueInput;
};


export type MutationDeleteOneInformControlGroupParticipantArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformControlGroupParticipantWhereUniqueInput;
};


export type MutationDeleteOneInformEmailTemplateArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformEmailTemplateWhereUniqueInput;
};


export type MutationDeleteOneInformEntityHistoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformEntityHistoryWhereUniqueInput;
};


export type MutationDeleteOneInformEventDrivenCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformEventDrivenCampaignWhereUniqueInput;
};


export type MutationDeleteOneInformEventListenerArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformEventListenerWhereUniqueInput;
};


export type MutationDeleteOneInformNotificationRecipientArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformNotificationRecipientWhereUniqueInput;
};


export type MutationDeleteOneInformPartnerArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerWhereUniqueInput;
};


export type MutationDeleteOneInformPartnerCustomerArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerCustomerWhereUniqueInput;
};


export type MutationDeleteOneInformPartnerCustomerPharmacyProviderArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerCustomerPharmacyProviderWhereUniqueInput;
};


export type MutationDeleteOneInformPartnerIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerIntegrationWhereUniqueInput;
};


export type MutationDeleteOneInformPartnerIntegrationModelArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerIntegrationModelWhereUniqueInput;
};


export type MutationDeleteOneInformPartnerProgramArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerProgramWhereUniqueInput;
};


export type MutationDeleteOneInformPartnerProgramEnrollmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};


export type MutationDeleteOneInformPartnerUserArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerUserWhereUniqueInput;
};


export type MutationDeleteOneInformPartnerUserRoleArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerUserRoleWhereUniqueInput;
};


export type MutationDeleteOneInformScheduledCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformScheduledCampaignWhereUniqueInput;
};


export type MutationDeleteOneInformSessionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformSessionWhereUniqueInput;
};


export type MutationDeleteOneInformSessionEventArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformSessionEventWhereUniqueInput;
};


export type MutationDeleteOneInstinctIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InstinctIntegrationWhereUniqueInput;
};


export type MutationDeleteOneInsuranceIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InsuranceIntegrationWhereUniqueInput;
};


export type MutationDeleteOneIntegrationOutageHistoryEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: IntegrationOutageHistoryEntryWhereUniqueInput;
};


export type MutationDeleteOneInterchangeRateArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InterchangeRateWhereUniqueInput;
};


export type MutationDeleteOneInvoiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InvoiceWhereUniqueInput;
};


export type MutationDeleteOneInvoiceLineItemArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InvoiceLineItemWhereUniqueInput;
};


export type MutationDeleteOneInvoicePimsWritebackLogEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InvoicePimsWritebackLogEntryWhereUniqueInput;
};


export type MutationDeleteOneLabPanelArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LabPanelWhereUniqueInput;
};


export type MutationDeleteOneLabResultArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LabResultWhereUniqueInput;
};


export type MutationDeleteOneLapsedPetParentTriggersArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LapsedPetParentTriggersWhereUniqueInput;
};


export type MutationDeleteOneLoyaltyAccountArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyAccountWhereUniqueInput;
};


export type MutationDeleteOneLoyaltyAccountHolderArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyAccountHolderWhereUniqueInput;
};


export type MutationDeleteOneLoyaltyAccountMergerArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyAccountMergerWhereUniqueInput;
};


export type MutationDeleteOneLoyaltyInvoicePointGranterArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyInvoicePointGranterWhereUniqueInput;
};


export type MutationDeleteOneLoyaltyPointGrantingServiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyPointGrantingServiceWhereUniqueInput;
};


export type MutationDeleteOneLoyaltyPointGrantingServiceCategoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyPointGrantingServiceCategoryWhereUniqueInput;
};


export type MutationDeleteOneLoyaltyPointUserGrantArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyPointUserGrantWhereUniqueInput;
};


export type MutationDeleteOneLoyaltyRewardRedemptionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyRewardRedemptionWhereUniqueInput;
};


export type MutationDeleteOneMassTextAlertArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MassTextAlertWhereUniqueInput;
};


export type MutationDeleteOneMassTextAlertEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MassTextAlertEntryWhereUniqueInput;
};


export type MutationDeleteOneMassTextAlertEntryAppointmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MassTextAlertEntryAppointmentWhereUniqueInput;
};


export type MutationDeleteOneMediaArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MediaWhereUniqueInput;
};


export type MutationDeleteOneMedicalHistoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MedicalHistoryWhereUniqueInput;
};


export type MutationDeleteOneMessageTemplateArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MessageTemplateWhereUniqueInput;
};


export type MutationDeleteOneMessagingCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MessagingCampaignWhereUniqueInput;
};


export type MutationDeleteOneMessagingPartnerArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MessagingPartnerWhereUniqueInput;
};


export type MutationDeleteOneModuleArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ModuleWhereUniqueInput;
};


export type MutationDeleteOneNonPrismaSchemaScriptRanArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: NonPrismaSchemaScriptRanWhereUniqueInput;
};


export type MutationDeleteOneNotificationEventToMessageArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: NotificationEventToMessageWhereUniqueInput;
};


export type MutationDeleteOneOrganizationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationWhereUniqueInput;
};


export type MutationDeleteOneOrganizationCareBenefitToClinicServiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationCareBenefitToClinicServiceWhereUniqueInput;
};


export type MutationDeleteOneOrganizationCareBenefitToClinicServiceCategoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput;
};


export type MutationDeleteOneOrganizationPetArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationPetWhereUniqueInput;
};


export type MutationDeleteOneOrganizationPetParentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationPetParentWhereUniqueInput;
};


export type MutationDeleteOneOrganizationPetToOrganizationPetParentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationPetToOrganizationPetParentWhereUniqueInput;
};


export type MutationDeleteOnePpcIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PpcIntegrationWhereUniqueInput;
};


export type MutationDeleteOnePaymentsReportTransactionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PaymentsReportTransactionWhereUniqueInput;
};


export type MutationDeleteOnePayoutBatchingScheduleArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PayoutBatchingScheduleWhereUniqueInput;
};


export type MutationDeleteOnePayoutBatchingSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PayoutBatchingSettingWhereUniqueInput;
};


export type MutationDeleteOnePermissionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PermissionWhereUniqueInput;
};


export type MutationDeleteOnePetParentSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PetParentSettingWhereUniqueInput;
};


export type MutationDeleteOnePetPortalSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PetPortalSettingWhereUniqueInput;
};


export type MutationDeleteOnePhoneNumberLookupRequestArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PhoneNumberLookupRequestWhereUniqueInput;
};


export type MutationDeleteOnePhoneNumberLookupResultArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PhoneNumberLookupResultWhereUniqueInput;
};


export type MutationDeleteOnePimsInvoiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PimsInvoiceWhereUniqueInput;
};


export type MutationDeleteOnePimsInvoiceLineItemArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PimsInvoiceLineItemWhereUniqueInput;
};


export type MutationDeleteOnePimsWritebackLogEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PimsWritebackLogEntryWhereUniqueInput;
};


export type MutationDeleteOnePrescriptionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PrescriptionWhereUniqueInput;
};


export type MutationDeleteOneProductArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ProductWhereUniqueInput;
};


export type MutationDeleteOneProductPackageArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ProductPackageWhereUniqueInput;
};


export type MutationDeleteOneProductPackageSubscriptionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ProductPackageSubscriptionWhereUniqueInput;
};


export type MutationDeleteOneProviderAppointmentTypeRoomMapArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};


export type MutationDeleteOnePushNotificationLogArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PushNotificationLogWhereUniqueInput;
};


export type MutationDeleteOneRecapArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: RecapWhereUniqueInput;
};


export type MutationDeleteOneRulesArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: RulesWhereUniqueInput;
};


export type MutationDeleteOneSegmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SegmentWhereUniqueInput;
};


export type MutationDeleteOneSentTrupanionExamDayOfferArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};


export type MutationDeleteOneServiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceWhereUniqueInput;
};


export type MutationDeleteOneServiceCategoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceCategoryWhereUniqueInput;
};


export type MutationDeleteOneServicePurchaseSummaryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServicePurchaseSummaryWhereUniqueInput;
};


export type MutationDeleteOneServiceReminderArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceReminderWhereUniqueInput;
};


export type MutationDeleteOneServiceReminderNotificationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceReminderNotificationWhereUniqueInput;
};


export type MutationDeleteOneServiceReminderTimingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceReminderTimingWhereUniqueInput;
};


export type MutationDeleteOneSexArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SexWhereUniqueInput;
};


export type MutationDeleteOneSmsNotificationStatusArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SmsNotificationStatusWhereUniqueInput;
};


export type MutationDeleteOneSpeciesArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SpeciesWhereUniqueInput;
};


export type MutationDeleteOneStaffRoleArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StaffRoleWhereUniqueInput;
};


export type MutationDeleteOneStripeCustomerArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeCustomerWhereUniqueInput;
};


export type MutationDeleteOneStripeDisputeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeDisputeWhereUniqueInput;
};


export type MutationDeleteOneStripeInvoiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeInvoiceWhereUniqueInput;
};


export type MutationDeleteOneStripeInvoiceItemArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeInvoiceItemWhereUniqueInput;
};


export type MutationDeleteOneStripePaymentMethodArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripePaymentMethodWhereUniqueInput;
};


export type MutationDeleteOneStripePayoutArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripePayoutWhereUniqueInput;
};


export type MutationDeleteOneStripePayoutAccountArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripePayoutAccountWhereUniqueInput;
};


export type MutationDeleteOneStripeReceiptArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeReceiptWhereUniqueInput;
};


export type MutationDeleteOneStripeReceiptHistoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeReceiptHistoryWhereUniqueInput;
};


export type MutationDeleteOneStripeRefundArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeRefundWhereUniqueInput;
};


export type MutationDeleteOneStripeTerminalArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeTerminalWhereUniqueInput;
};


export type MutationDeleteOneStripeTerminalLocationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeTerminalLocationWhereUniqueInput;
};


export type MutationDeleteOneSurveyAppointmentTypeSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SurveyAppointmentTypeSettingWhereUniqueInput;
};


export type MutationDeleteOneSurveyResultArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SurveyResultWhereUniqueInput;
};


export type MutationDeleteOneSurveySettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SurveySettingWhereUniqueInput;
};


export type MutationDeleteOneSyncVetIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SyncVetIntegrationWhereUniqueInput;
};


export type MutationDeleteOneSyncVetServiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SyncVetServiceWhereUniqueInput;
};


export type MutationDeleteOneSynchronyClinicConfigurationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SynchronyClinicConfigurationWhereUniqueInput;
};


export type MutationDeleteOneSynchronyEventArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SynchronyEventWhereUniqueInput;
};


export type MutationDeleteOneTaskArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TaskWhereUniqueInput;
};


export type MutationDeleteOneTaxonomyArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TaxonomyWhereUniqueInput;
};


export type MutationDeleteOneTaxonomyToInformAudienceDefinitionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TaxonomyToInformAudienceDefinitionWhereUniqueInput;
};


export type MutationDeleteOneTransactionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TransactionWhereUniqueInput;
};


export type MutationDeleteOneTrupanionCertificateAvailabilityArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TrupanionCertificateAvailabilityWhereUniqueInput;
};


export type MutationDeleteOneTrupanionIntegratedAppointmentTypeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TrupanionIntegratedAppointmentTypeWhereUniqueInput;
};


export type MutationDeleteOneTrupanionIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TrupanionIntegrationWhereUniqueInput;
};


export type MutationDeleteOneUserArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserWhereUniqueInput;
};


export type MutationDeleteOneUserAppointmentGroupingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserAppointmentGroupingWhereUniqueInput;
};


export type MutationDeleteOneUserBoardFilterArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserBoardFilterWhereUniqueInput;
};


export type MutationDeleteOneUserChannelFilterSelectionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserChannelFilterSelectionWhereUniqueInput;
};


export type MutationDeleteOneUserNotificationSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserNotificationSettingWhereUniqueInput;
};


export type MutationDeleteOneUserSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserSettingWhereUniqueInput;
};


export type MutationDeleteOneUserTaskListArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserTaskListWhereUniqueInput;
};


export type MutationDeleteOneUserTaskListFilterArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserTaskListFilterWhereUniqueInput;
};


export type MutationDeleteOneVaccinationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VaccinationWhereUniqueInput;
};


export type MutationDeleteOneVetAvailabilityArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetAvailabilityWhereUniqueInput;
};


export type MutationDeleteOneVetAvailabilityClinicRoomMapArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetAvailabilityClinicRoomMapWhereUniqueInput;
};


export type MutationDeleteOneVetAvailabilityMapArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetAvailabilityMapWhereUniqueInput;
};


export type MutationDeleteOneVetInfoArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetInfoWhereUniqueInput;
};


export type MutationDeleteOneVetsourceCodeTagArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetsourceCodeTagWhereUniqueInput;
};


export type MutationDeleteOneVetsourceInstallationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetsourceInstallationWhereUniqueInput;
};


export type MutationDeleteOneVetsourcePharmacyIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetsourcePharmacyIntegrationWhereUniqueInput;
};


export type MutationDeleteOneVetsourceRevenueCategoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetsourceRevenueCategoryWhereUniqueInput;
};


export type MutationDeleteOneWorkflowEventSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: WorkflowEventSettingWhereUniqueInput;
};


export type MutationDownloadManyCallRecordingsArgs = {
  where: CallRecordingWhereInput;
};


export type MutationDuplicateEmailCampaignArgs = {
  data: DuplicateEmailCampaignInput;
};


export type MutationEncryptAndUploadDataArgs = {
  body: Scalars['String'];
  extension: Scalars['String'];
  purpose: EncryptedSignedUploadPurpose;
};


export type MutationEndOneAxionCallArgs = {
  data: EndOneAxionCallInput;
};


export type MutationEnsurePetsPromotedArgs = {
  data?: Maybe<EnsurePetsPromotedInput>;
};


export type MutationFindOrCreateLoyaltyAccountForClinicPetParentArgs = {
  clinicPetParentId: Scalars['String'];
};


export type MutationFormSubmissionExportToPimsArgs = {
  data?: Maybe<FormSubmissionExportInput>;
};


export type MutationFulfillLoyaltyRewardRedemptionArgs = {
  data: LoyaltyRewardRedemptionInput;
};


export type MutationGenerateTerminalAuthTokenArgs = {
  stripeTerminalId: Scalars['String'];
};


export type MutationGenerateTerminalSetupPinArgs = {
  clinicId: Scalars['String'];
};


export type MutationGenerateTinyUrlAndTokenArgs = {
  data: GenerateTinyUrlAndTokenInput;
};


export type MutationGenerateWidgetAuthenticationRequestArgs = {
  where: WidgetClinicPetParentLookupInput;
};


export type MutationGeocodeSalesforceAccountArgs = {
  override?: Maybe<Scalars['Boolean']>;
  remainingAttempts?: Maybe<Scalars['Int']>;
  salesforceAccountId: Scalars['String'];
  useCache?: Maybe<Scalars['Boolean']>;
};


export type MutationGetDirectedCareLoginLinkArgs = {
  data: DirectedAuthLinkInput;
};


export type MutationGetOrCreateActiveChannelArgs = {
  data: GetOrCreateActiveChannelInput;
};


export type MutationGetOrCreateActiveClientChannelArgs = {
  creationSource?: Maybe<ChannelCreationSourceInput>;
  data: GetOrCreateActiveClientChannelInput;
};


export type MutationGetSignedDownloadUrlArgs = {
  assetUrl: Scalars['String'];
};


export type MutationGetSignedUploadUrlArgs = {
  data: GetSignedUploadInput;
};


export type MutationIgnoreOneAxionCallArgs = {
  data: IgnoreOneAxionCallInput;
};


export type MutationInitSurveySettingArgs = {
  clinicId: Scalars['String'];
};


export type MutationMergePetParentArgs = {
  data?: Maybe<MergePetParentInput>;
};


export type MutationOrderPhoneNumberArgs = {
  data: OrderPhoneNumberInput;
};


export type MutationPerformCarePlanEnrollmentUpgradeArgs = {
  data: PerformCarePlanEnrollmentUpgradeInput;
};


export type MutationPostCareInvoiceAccountCreditToPimsArgs = {
  data: WritebackCareInvoiceAccountCreditToPimsInput;
};


export type MutationProcessAppointmentRecapArgs = {
  data: ProcessAppointmentRecapInput;
};


export type MutationProcessAppointmentRecapChunksArgs = {
  data: ProcessAppointmentRecapChunksInput;
};


export type MutationProcessTerminalPaymentArgs = {
  isSurchargeClinic?: Maybe<Scalars['Boolean']>;
  paymentIntent: PaymentIntentInput;
  stripeTerminalId: Scalars['String'];
};


export type MutationRedeemClinicPetParentAuthCodeArgs = {
  authCode: Scalars['String'];
};


export type MutationRedeemOneTimeCodeArgs = {
  data: RedeemOneTimeCodeInput;
};


export type MutationRefundStripePaymentIntent2Args = {
  data: EnhancedStripeRefundPaymentInput;
  where: StripePaymentIntentWhereUniqueInput;
};


export type MutationRegeneratePetParentClinicListWithTokensArgs = {
  data?: Maybe<RegeneratePetParentClinicListWithTokensInput>;
};


export type MutationRegisterTwilioSubaccountArgs = {
  accountOwnerEmail: Scalars['String'];
  accountOwnerFirstName: Scalars['String'];
  accountOwnerLastName: Scalars['String'];
  accountOwnerPhone: Scalars['String'];
  clinicId: Scalars['String'];
};


export type MutationRemoveChannelMember2Args = {
  channelMemberId: Scalars['String'];
};


export type MutationRemoveChannelTagArgs = {
  channelId: Scalars['String'];
  tagName?: Maybe<Scalars['String']>;
  tagType?: Maybe<TagType>;
};


export type MutationRemoveClinicFromLoyaltyProgramArgs = {
  clinicId: Scalars['String'];
  programId: Scalars['String'];
};


export type MutationRemoveUserFromClinicArgs = {
  data: RemoveUserFromClinicInput;
};


export type MutationRequestBitwerxIntegrationArgs = {
  data: RequestBitwerxIntegrationInput;
};


export type MutationRequestCareLoginLinkArgs = {
  data: AuthLinkRequestInput;
};


export type MutationRequestLoyaltyRewardArgs = {
  data: RequestLoyaltyRewardInput;
};


export type MutationRequestOneTimeCodeArgs = {
  data?: Maybe<RequestOneTimeCodeInput>;
};


export type MutationResendReceiptEmailArgs = {
  emailOverride?: Maybe<Scalars['String']>;
  stripePaymentIntentId: Scalars['String'];
};


export type MutationResendUserInvitationArgs = {
  data: ResendUserInvitationInput;
};


export type MutationResetAutomationRunArgs = {
  where?: Maybe<AutomationRunWhereUniqueInput>;
};


export type MutationRetryPaymentWritebackArgs = {
  stripePaymentIntentId: Scalars['String'];
};


export type MutationRetryProcessAppointmentRecapArgs = {
  data: RetryProcessAppointmentRecapInput;
};


export type MutationRetryTwilioCampaignRegistrationArgs = {
  clinicId: Scalars['String'];
};


export type MutationSaveEmailTemplateVersionArgs = {
  data: SaveEmailTemplateVersionInput;
};


export type MutationSendCareSignUpEmailArgs = {
  data?: Maybe<SendCareSignUpEmailInput>;
};


export type MutationSendClinicPetParentAuthCodeArgs = {
  data: SendClinicPetParentAuthCodeRequest;
};


export type MutationSendClinicPetParentAuthLinkArgs = {
  data: SendClinicPetParentAuthLinkRequest;
};


export type MutationSendConsultationReceiptArgs = {
  data: SendConsultationReceiptInput;
};


export type MutationSendDirectedCareLoginLinkArgs = {
  data: DirectedAuthLinkInput;
};


export type MutationSendEmailCampaignNowArgs = {
  data: SendEmailCampaignNowInput;
};


export type MutationSendEnrollmentEmailArgs = {
  data?: Maybe<SendEnrollmentEmailInput>;
};


export type MutationSendPaymentToTerminalArgs = {
  stripePaymentIntentId: Scalars['String'];
  stripeTerminalId: Scalars['String'];
};


export type MutationSendUiRefreshEventArgs = {
  data: UiRefreshInput;
};


export type MutationSendWidgetCodeToDeveloperArgs = {
  data: SendWidgetCodeToDeveloperInput;
};


export type MutationSetClinicPetParentPrivacyArgs = {
  clinicPetParentId: Scalars['String'];
};


export type MutationSetPaymentIntentClinicPetParent2Args = {
  where: StripePaymentIntentWhereUniqueInput;
};


export type MutationStartChecksOnRecapChunksContinuityArgs = {
  data: StartChecksOnRecapChunksContinuityInput;
};


export type MutationStripeConnectConnectedAccountArgs = {
  data: StripeConnectOauthInput;
};


export type MutationStripeCreateConnectedAccountArgs = {
  data: StripeCreateAccountInput;
};


export type MutationSubmitForm2Args = {
  data: FormSubmissionUpdateInput;
  where: FormSubmissionWhereUniqueInput;
};


export type MutationSubmitLoyaltyPointGrantToAccountByUserArgs = {
  data: LoyaltyPointGrantByUser;
};


export type MutationSubmitPetParentRequestArgs = {
  data: SubmitPetParentRequestInput;
};


export type MutationSubmitPrescriptionRefillRequestArgs = {
  data: SubmitPrescriptionRefillRequestInput;
};


export type MutationSyncClinicArgs = {
  clinicId: Scalars['String'];
};


export type MutationSyncManyPimsIntegrationModelArgs = {
  data: SyncManyPimsIntegrationModelInput;
};


export type MutationSyncPimsIntegrationModelArgs = {
  data: SyncPimsIntegrationModelInput;
};


export type MutationToggleTwilioVideoCallRecordingStatusArgs = {
  data: VideoCallRecordingToggleInput;
};


export type MutationTransferCareSubscriptionArgs = {
  data?: Maybe<TransferSubscriptionInput>;
};


export type MutationTransferTwilioNumberArgs = {
  data: TransferTwilioNumberInput;
};


export type MutationTriggerLoyaltyInvoiceProcessingArgs = {
  data: LoyaltyInvoiceTriggerInput;
};


export type MutationTriggerMessageEventArgs = {
  data: TriggerMessageEventInput;
};


export type MutationTriggerWorkflowEventArgs = {
  data: TriggerWorkflowEventInput;
};


export type MutationTrupanionIssueCertificateArgs = {
  data: TrupanionIssueCertificateDataInput;
  where: TrupanionIssueCertificateWhereInput;
};


export type MutationTwilioGetOrCreateHostedNumberOrderArgs = {
  data: TwilioGetOrCreateHostedNumberOrderInput;
};


export type MutationTwilioGetOrGenerateLoaArgs = {
  data: TwilioGetOrGenerateLoaInput;
};


export type MutationTwilioPurchaseNumberArgs = {
  data?: Maybe<GenericClinicIdInput>;
};


export type MutationTwilioVerifyCallerIdArgs = {
  data: TwilioVerifyCallerIdInput;
};


export type MutationTwilioVerifySubAccountCallerIdArgs = {
  data: TwilioVerifySubAccountCallerIdInput;
};


export type MutationUpdateAppointmentTypeProviderRoomMapsArgs = {
  data: UpdateAppointmentTypeProviderRoomMapsInput;
};


export type MutationUpdateCareSubscriptionArgs = {
  data?: Maybe<UpdateCareSubscriptionInput>;
};


export type MutationUpdateChannelFilterSelectionArgs = {
  data?: Maybe<UpdateChannelFilterSelectionInput>;
};


export type MutationUpdateClinicAppointmentTypeSettingsArgs = {
  appointmentTypeId: Scalars['String'];
  displayName: Scalars['String'];
  showInPetPortal: Scalars['Boolean'];
};


export type MutationUpdateClinicPetParentContactInfoFromPimsArgs = {
  where?: Maybe<ClinicPetParentWhereUniqueInput>;
};


export type MutationUpdateClinicPetWithoutPimsArgs = {
  data: ClinicPetUpdateInput;
  where: ClinicPetWhereUniqueInput;
};


export type MutationUpdateClinicPostcardSettingArgs = {
  data: UpdateClinicPostcardSettingDataInput;
  where?: Maybe<UpdateClinicPostcardSettingWhereInput>;
};


export type MutationUpdateClinicSettingTransactionColumnArgs = {
  data: ClinicSettingUpdateInput;
  where: ClinicSettingWhereUniqueInput;
};


export type MutationUpdateManyActiveIngredientArgs = {
  data: ActiveIngredientUpdateManyMutationInput;
  where?: Maybe<ActiveIngredientWhereInput>;
};


export type MutationUpdateManyAppointmentArgs = {
  data: AppointmentUpdateManyMutationInput;
  where?: Maybe<AppointmentWhereInput>;
};


export type MutationUpdateManyAppointmentAvailabilityArgs = {
  data: AppointmentAvailabilityUpdateManyMutationInput;
  where?: Maybe<AppointmentAvailabilityWhereInput>;
};


export type MutationUpdateManyAppointmentNoteTemplateArgs = {
  data: AppointmentNoteTemplateUpdateManyMutationInput;
  where?: Maybe<AppointmentNoteTemplateWhereInput>;
};


export type MutationUpdateManyAppointmentTypeArgs = {
  data: AppointmentTypeUpdateManyMutationInput;
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type MutationUpdateManyAppointmentTypeSortOrderArgs = {
  data?: Maybe<Array<AppointmentTypeWithOrder>>;
};


export type MutationUpdateManyAutomationRunArgs = {
  data: AutomationRunUpdateManyMutationInput;
  where?: Maybe<AutomationRunWhereInput>;
};


export type MutationUpdateManyAutomationRunActionArgs = {
  data: AutomationRunActionUpdateManyMutationInput;
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type MutationUpdateManyAxionClinicConfigurationArgs = {
  data: AxionClinicConfigurationUpdateManyMutationInput;
  where?: Maybe<AxionClinicConfigurationWhereInput>;
};


export type MutationUpdateManyAxionClinicUserConfigurationArgs = {
  data: AxionClinicUserConfigurationUpdateManyMutationInput;
  where?: Maybe<AxionClinicUserConfigurationWhereInput>;
};


export type MutationUpdateManyBedrockInferenceArgs = {
  data: BedrockInferenceUpdateManyMutationInput;
  where?: Maybe<BedrockInferenceWhereInput>;
};


export type MutationUpdateManyBitwerxHealthcheckArgs = {
  data: BitwerxHealthcheckUpdateManyMutationInput;
  where?: Maybe<BitwerxHealthcheckWhereInput>;
};


export type MutationUpdateManyBitwerxIntegrationArgs = {
  data: BitwerxIntegrationUpdateManyMutationInput;
  where?: Maybe<BitwerxIntegrationWhereInput>;
};


export type MutationUpdateManyBitwerxPaymentHealthcheckResultArgs = {
  data: BitwerxPaymentHealthcheckResultUpdateManyMutationInput;
  where?: Maybe<BitwerxPaymentHealthcheckResultWhereInput>;
};


export type MutationUpdateManyBitwerxPaymentHealthcheckRunArgs = {
  data: BitwerxPaymentHealthcheckRunUpdateManyMutationInput;
  where?: Maybe<BitwerxPaymentHealthcheckRunWhereInput>;
};


export type MutationUpdateManyBoardFilterColumnArgs = {
  data: BoardFilterColumnUpdateManyMutationInput;
  where?: Maybe<BoardFilterColumnWhereInput>;
};


export type MutationUpdateManyBoardFilterSpecificDateRangeArgs = {
  data: BoardFilterSpecificDateRangeUpdateManyMutationInput;
  where?: Maybe<BoardFilterSpecificDateRangeWhereInput>;
};


export type MutationUpdateManyBoehringerIngelheimCustomerAlignmentArgs = {
  data: BoehringerIngelheimCustomerAlignmentUpdateManyMutationInput;
  where?: Maybe<BoehringerIngelheimCustomerAlignmentWhereInput>;
};


export type MutationUpdateManyBoehringerIngelheimTerritoryArgs = {
  data: BoehringerIngelheimTerritoryUpdateManyMutationInput;
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};


export type MutationUpdateManyBreedArgs = {
  data: BreedUpdateManyMutationInput;
  where?: Maybe<BreedWhereInput>;
};


export type MutationUpdateManyCallHistoryArgs = {
  data: CallHistoryUpdateManyMutationInput;
  where?: Maybe<CallHistoryWhereInput>;
};


export type MutationUpdateManyCallParticipantArgs = {
  data: CallParticipantUpdateManyMutationInput;
  where?: Maybe<CallParticipantWhereInput>;
};


export type MutationUpdateManyCampaignRegistryCampaignArgs = {
  data: CampaignRegistryCampaignUpdateManyMutationInput;
  where?: Maybe<CampaignRegistryCampaignWhereInput>;
};


export type MutationUpdateManyCanonicalBreedArgs = {
  data: CanonicalBreedUpdateManyMutationInput;
  where?: Maybe<CanonicalBreedWhereInput>;
};


export type MutationUpdateManyCanonicalCanineBreedProfileArgs = {
  data: CanonicalCanineBreedProfileUpdateManyMutationInput;
  where?: Maybe<CanonicalCanineBreedProfileWhereInput>;
};


export type MutationUpdateManyCanonicalServiceArgs = {
  data: CanonicalServiceUpdateManyMutationInput;
  where?: Maybe<CanonicalServiceWhereInput>;
};


export type MutationUpdateManyCanonicalSpeciesArgs = {
  data: CanonicalSpeciesUpdateManyMutationInput;
  where?: Maybe<CanonicalSpeciesWhereInput>;
};


export type MutationUpdateManyCareAddonEnrollmentArgs = {
  data: CareAddonEnrollmentUpdateManyMutationInput;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};


export type MutationUpdateManyCareAddonPackageArgs = {
  data: CareAddonPackageUpdateManyMutationInput;
  where?: Maybe<CareAddonPackageWhereInput>;
};


export type MutationUpdateManyCareAddonPackageBenefitArgs = {
  data: CareAddonPackageBenefitUpdateManyMutationInput;
  where?: Maybe<CareAddonPackageBenefitWhereInput>;
};


export type MutationUpdateManyCareAuthorizationRequestArgs = {
  data: CareAuthorizationRequestUpdateManyMutationInput;
  where?: Maybe<CareAuthorizationRequestWhereInput>;
};


export type MutationUpdateManyCareBenefitArgs = {
  data: CareBenefitUpdateManyMutationInput;
  where?: Maybe<CareBenefitWhereInput>;
};


export type MutationUpdateManyCareBenefitUsageArgs = {
  data: CareBenefitUsageUpdateManyMutationInput;
  where?: Maybe<CareBenefitUsageWhereInput>;
};


export type MutationUpdateManyCareBenefitUsageFollowupArgs = {
  data: CareBenefitUsageFollowupUpdateManyMutationInput;
  where?: Maybe<CareBenefitUsageFollowupWhereInput>;
};


export type MutationUpdateManyCareBenefitUsageFollowupStepArgs = {
  data: CareBenefitUsageFollowupStepUpdateManyMutationInput;
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};


export type MutationUpdateManyCareBenefitUsageToInvoiceLineItemArgs = {
  data: CareBenefitUsageToInvoiceLineItemUpdateManyMutationInput;
  where?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
};


export type MutationUpdateManyCareCreditPreapprovalCheckArgs = {
  data: CareCreditPreapprovalCheckUpdateManyMutationInput;
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};


export type MutationUpdateManyCareEnrollmentPaymentArgs = {
  data: CareEnrollmentPaymentUpdateManyMutationInput;
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};


export type MutationUpdateManyCareEnrollmentToStripeInvoiceItemArgs = {
  data: CareEnrollmentToStripeInvoiceItemUpdateManyMutationInput;
  where?: Maybe<CareEnrollmentToStripeInvoiceItemWhereInput>;
};


export type MutationUpdateManyCareLapsedPaymentArgs = {
  data: CareLapsedPaymentUpdateManyMutationInput;
  where?: Maybe<CareLapsedPaymentWhereInput>;
};


export type MutationUpdateManyCarePlanArgs = {
  data: CarePlanUpdateManyMutationInput;
  where?: Maybe<CarePlanWhereInput>;
};


export type MutationUpdateManyCarePlanBenefitArgs = {
  data: CarePlanBenefitUpdateManyMutationInput;
  where?: Maybe<CarePlanBenefitWhereInput>;
};


export type MutationUpdateManyCarePlanBenefitEnrollmentCarryoverArgs = {
  data: CarePlanBenefitEnrollmentCarryoverUpdateManyMutationInput;
  where?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereInput>;
};


export type MutationUpdateManyCarePlanEnrollmentArgs = {
  data: CarePlanEnrollmentUpdateManyMutationInput;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type MutationUpdateManyCarePlanPricingArgs = {
  data: CarePlanPricingUpdateManyMutationInput;
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type MutationUpdateManyCarePlanProviderGroupArgs = {
  data: CarePlanProviderGroupUpdateManyMutationInput;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type MutationUpdateManyCareStripeSubscriptionArgs = {
  data: CareStripeSubscriptionUpdateManyMutationInput;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type MutationUpdateManyCareSubscriptionTrueUpArgs = {
  data: CareSubscriptionTrueUpUpdateManyMutationInput;
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
};


export type MutationUpdateManyCareSubscriptionTrueUpLogEntryArgs = {
  data: CareSubscriptionTrueUpLogEntryUpdateManyMutationInput;
  where?: Maybe<CareSubscriptionTrueUpLogEntryWhereInput>;
};


export type MutationUpdateManyChannelArgs = {
  data: ChannelUpdateManyMutationInput;
  where?: Maybe<ChannelWhereInput>;
};


export type MutationUpdateManyChannelAutomationStatusArgs = {
  data: ChannelAutomationStatusUpdateManyMutationInput;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type MutationUpdateManyChannelCreationSourceArgs = {
  data: ChannelCreationSourceUpdateManyMutationInput;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type MutationUpdateManyChannelFilterSelectionArgs = {
  data: ChannelFilterSelectionUpdateManyMutationInput;
  where?: Maybe<ChannelFilterSelectionWhereInput>;
};


export type MutationUpdateManyChannelMemberArgs = {
  data: ChannelMemberUpdateManyMutationInput;
  where?: Maybe<ChannelMemberWhereInput>;
};


export type MutationUpdateManyChannelMessageArgs = {
  data: ChannelMessageUpdateManyMutationInput;
  where?: Maybe<ChannelMessageWhereInput>;
};


export type MutationUpdateManyChannelMessageAttachmentArgs = {
  data: ChannelMessageAttachmentUpdateManyMutationInput;
  where?: Maybe<ChannelMessageAttachmentWhereInput>;
};


export type MutationUpdateManyChannelMessageAutoResponseArgs = {
  data: ChannelMessageAutoResponseUpdateManyMutationInput;
  where?: Maybe<ChannelMessageAutoResponseWhereInput>;
};


export type MutationUpdateManyChannelMessageReactionArgs = {
  data: ChannelMessageReactionUpdateManyMutationInput;
  where?: Maybe<ChannelMessageReactionWhereInput>;
};


export type MutationUpdateManyChannelPinArgs = {
  data: ChannelPinUpdateManyMutationInput;
  where?: Maybe<ChannelPinWhereInput>;
};


export type MutationUpdateManyChannelSelectionArgs = {
  data: ChannelSelectionUpdateManyMutationInput;
  where?: Maybe<ChannelSelectionWhereInput>;
};


export type MutationUpdateManyChannelStatusArgs = {
  data: ChannelStatusUpdateManyMutationInput;
  where?: Maybe<ChannelStatusWhereInput>;
};


export type MutationUpdateManyChannelStatusChannelAssigneeArgs = {
  data: ChannelStatusChannelAssigneeUpdateManyMutationInput;
  where?: Maybe<ChannelStatusChannelAssigneeWhereInput>;
};


export type MutationUpdateManyChannelStatusSortOrderArgs = {
  data?: Maybe<Array<ChannelStatusWithOrder>>;
};


export type MutationUpdateManyChemicalCompoundArgs = {
  data: ChemicalCompoundUpdateManyMutationInput;
  where?: Maybe<ChemicalCompoundWhereInput>;
};


export type MutationUpdateManyClientConnectIntegrationArgs = {
  data: ClientConnectIntegrationUpdateManyMutationInput;
  where?: Maybe<ClientConnectIntegrationWhereInput>;
};


export type MutationUpdateManyClinicArgs = {
  data: ClinicUpdateManyMutationInput;
  where?: Maybe<ClinicWhereInput>;
};


export type MutationUpdateManyClinicBlockedPhoneNumberArgs = {
  data: ClinicBlockedPhoneNumberUpdateManyMutationInput;
  where?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
};


export type MutationUpdateManyClinicCustomPayoutsSetupArgs = {
  data: ClinicCustomPayoutsSetupUpdateManyMutationInput;
  where?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
};


export type MutationUpdateManyClinicDirectBookingSettingArgs = {
  data: ClinicDirectBookingSettingUpdateManyMutationInput;
  where?: Maybe<ClinicDirectBookingSettingWhereInput>;
};


export type MutationUpdateManyClinicEmailCampaignSettingArgs = {
  data: ClinicEmailCampaignSettingUpdateManyMutationInput;
  where?: Maybe<ClinicEmailCampaignSettingWhereInput>;
};


export type MutationUpdateManyClinicEmployeeArgs = {
  data: ClinicEmployeeUpdateManyMutationInput;
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type MutationUpdateManyClinicEmployeeAppointmentTypeSettingArgs = {
  data: ClinicEmployeeAppointmentTypeSettingUpdateManyMutationInput;
  where?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereInput>;
};


export type MutationUpdateManyClinicEntityPhoneNumberArgs = {
  data: ClinicEntityPhoneNumberUpdateManyMutationInput;
  where?: Maybe<ClinicEntityPhoneNumberWhereInput>;
};


export type MutationUpdateManyClinicModuleArgs = {
  data: ClinicModuleUpdateManyMutationInput;
  where?: Maybe<ClinicModuleWhereInput>;
};


export type MutationUpdateManyClinicOfficeHourArgs = {
  data: ClinicOfficeHourUpdateManyMutationInput;
  where?: Maybe<ClinicOfficeHourWhereInput>;
};


export type MutationUpdateManyClinicOnboardingArgs = {
  data: ClinicOnboardingUpdateManyMutationInput;
  where?: Maybe<ClinicOnboardingWhereInput>;
};


export type MutationUpdateManyClinicPaymentFeeConfigurationArgs = {
  data: ClinicPaymentFeeConfigurationUpdateManyMutationInput;
  where?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
};


export type MutationUpdateManyClinicPetArgs = {
  data: ClinicPetUpdateManyMutationInput;
  where?: Maybe<ClinicPetWhereInput>;
};


export type MutationUpdateManyClinicPetAlertArgs = {
  data: ClinicPetAlertUpdateManyMutationInput;
  where?: Maybe<ClinicPetAlertWhereInput>;
};


export type MutationUpdateManyClinicPetCustomFieldValueArgs = {
  data: ClinicPetCustomFieldValueUpdateManyMutationInput;
  where?: Maybe<ClinicPetCustomFieldValueWhereInput>;
};


export type MutationUpdateManyClinicPetParentArgs = {
  data: ClinicPetParentUpdateManyMutationInput;
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type MutationUpdateManyClinicPetParentAddressArgs = {
  data: ClinicPetParentAddressUpdateManyMutationInput;
  where?: Maybe<ClinicPetParentAddressWhereInput>;
};


export type MutationUpdateManyClinicPetParentCustomFieldValueArgs = {
  data: ClinicPetParentCustomFieldValueUpdateManyMutationInput;
  where?: Maybe<ClinicPetParentCustomFieldValueWhereInput>;
};


export type MutationUpdateManyClinicPetParentDeviceArgs = {
  data: ClinicPetParentDeviceUpdateManyMutationInput;
  where?: Maybe<ClinicPetParentDeviceWhereInput>;
};


export type MutationUpdateManyClinicPetParentPimsSyncStatusArgs = {
  data: ClinicPetParentPimsSyncStatusUpdateManyMutationInput;
  where?: Maybe<ClinicPetParentPimsSyncStatusWhereInput>;
};


export type MutationUpdateManyClinicPetPimsSyncStatusArgs = {
  data: ClinicPetPimsSyncStatusUpdateManyMutationInput;
  where?: Maybe<ClinicPetPimsSyncStatusWhereInput>;
};


export type MutationUpdateManyClinicPhoneNumberArgs = {
  data: ClinicPhoneNumberUpdateManyMutationInput;
  where?: Maybe<ClinicPhoneNumberWhereInput>;
};


export type MutationUpdateManyClinicPimsIntegrationArgs = {
  data: ClinicPimsIntegrationUpdateManyMutationInput;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type MutationUpdateManyClinicPimsIntegrationCapabilityArgs = {
  data: ClinicPimsIntegrationCapabilityUpdateManyMutationInput;
  where?: Maybe<ClinicPimsIntegrationCapabilityWhereInput>;
};


export type MutationUpdateManyClinicPimsIntegrationCapabilityHistoryEntryArgs = {
  data: ClinicPimsIntegrationCapabilityHistoryEntryUpdateManyMutationInput;
  where?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>;
};


export type MutationUpdateManyClinicPostcardSettingArgs = {
  data: ClinicPostcardSettingUpdateManyMutationInput;
  where?: Maybe<ClinicPostcardSettingWhereInput>;
};


export type MutationUpdateManyClinicRoomArgs = {
  data: ClinicRoomUpdateManyMutationInput;
  where?: Maybe<ClinicRoomWhereInput>;
};


export type MutationUpdateManyClinicSettingArgs = {
  data: ClinicSettingUpdateManyMutationInput;
  where?: Maybe<ClinicSettingWhereInput>;
};


export type MutationUpdateManyClinicUserFilterArgs = {
  data: ClinicUserFilterUpdateManyMutationInput;
  where?: Maybe<ClinicUserFilterWhereInput>;
};


export type MutationUpdateManyClinicWidgetRequestArgs = {
  data: ClinicWidgetRequestUpdateManyMutationInput;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type MutationUpdateManyClinicWidgetRequestTypeArgs = {
  data: ClinicWidgetRequestTypeUpdateManyMutationInput;
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};


export type MutationUpdateManyClinicWidgetSettingArgs = {
  data: ClinicWidgetSettingUpdateManyMutationInput;
  where?: Maybe<ClinicWidgetSettingWhereInput>;
};


export type MutationUpdateManyColorArgs = {
  data: ColorUpdateManyMutationInput;
  where?: Maybe<ColorWhereInput>;
};


export type MutationUpdateManyConditionArgs = {
  data: ConditionUpdateManyMutationInput;
  where?: Maybe<ConditionWhereInput>;
};


export type MutationUpdateManyConditionSetArgs = {
  data: ConditionSetUpdateManyMutationInput;
  where?: Maybe<ConditionSetWhereInput>;
};


export type MutationUpdateManyConditionalEntityEvaluationArgs = {
  data: ConditionalEntityEvaluationUpdateManyMutationInput;
  where?: Maybe<ConditionalEntityEvaluationWhereInput>;
};


export type MutationUpdateManyConsultationRequestArgs = {
  data: ConsultationRequestUpdateManyMutationInput;
  where?: Maybe<ConsultationRequestWhereInput>;
};


export type MutationUpdateManyCustomFieldDefinitionArgs = {
  data: CustomFieldDefinitionUpdateManyMutationInput;
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};


export type MutationUpdateManyCustomFieldPimsWritebackLogEntryArgs = {
  data: CustomFieldPimsWritebackLogEntryUpdateManyMutationInput;
  where?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
};


export type MutationUpdateManyDirectBookingAppointmentTypeSettingArgs = {
  data: DirectBookingAppointmentTypeSettingUpdateManyMutationInput;
  where?: Maybe<DirectBookingAppointmentTypeSettingWhereInput>;
};


export type MutationUpdateManyDirectBookingExclusionTimeSlotArgs = {
  data: DirectBookingExclusionTimeSlotUpdateManyMutationInput;
  where?: Maybe<DirectBookingExclusionTimeSlotWhereInput>;
};


export type MutationUpdateManyDisbursementArgs = {
  data: DisbursementUpdateManyMutationInput;
  where?: Maybe<DisbursementWhereInput>;
};


export type MutationUpdateManyDocumentationArgs = {
  data: DocumentationUpdateManyMutationInput;
  where?: Maybe<DocumentationWhereInput>;
};


export type MutationUpdateManyEmailCampaignArgs = {
  data: EmailCampaignUpdateManyMutationInput;
  where?: Maybe<EmailCampaignWhereInput>;
};


export type MutationUpdateManyEmailCampaignCustomListArgs = {
  data: EmailCampaignCustomListUpdateManyMutationInput;
  where?: Maybe<EmailCampaignCustomListWhereInput>;
};


export type MutationUpdateManyEmailCampaignCustomListRecipientArgs = {
  data: EmailCampaignCustomListRecipientUpdateManyMutationInput;
  where?: Maybe<EmailCampaignCustomListRecipientWhereInput>;
};


export type MutationUpdateManyEmailCampaignCustomListUploadHistoryArgs = {
  data: EmailCampaignCustomListUploadHistoryUpdateManyMutationInput;
  where?: Maybe<EmailCampaignCustomListUploadHistoryWhereInput>;
};


export type MutationUpdateManyEmailCampaignLogArgs = {
  data: EmailCampaignLogUpdateManyMutationInput;
  where?: Maybe<EmailCampaignLogWhereInput>;
};


export type MutationUpdateManyEmailCampaignTemplateArgs = {
  data: EmailCampaignTemplateUpdateManyMutationInput;
  where?: Maybe<EmailCampaignTemplateWhereInput>;
};


export type MutationUpdateManyEmailCampaignUnsubscribeArgs = {
  data: EmailCampaignUnsubscribeUpdateManyMutationInput;
  where?: Maybe<EmailCampaignUnsubscribeWhereInput>;
};


export type MutationUpdateManyEmailProviderLogArgs = {
  data: EmailProviderLogUpdateManyMutationInput;
  where?: Maybe<EmailProviderLogWhereInput>;
};


export type MutationUpdateManyEmailTemplateVersionArgs = {
  data: EmailTemplateVersionUpdateManyMutationInput;
  where?: Maybe<EmailTemplateVersionWhereInput>;
};


export type MutationUpdateManyEmergencyClinicsArgs = {
  data: EmergencyClinicsUpdateManyMutationInput;
  where?: Maybe<EmergencyClinicsWhereInput>;
};


export type MutationUpdateManyEncryptedClinicUploadArgs = {
  data: EncryptedClinicUploadUpdateManyMutationInput;
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};


export type MutationUpdateManyEnrollmentSupportEventArgs = {
  data: EnrollmentSupportEventUpdateManyMutationInput;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type MutationUpdateManyEzyVetIntegrationArgs = {
  data: EzyVetIntegrationUpdateManyMutationInput;
  where?: Maybe<EzyVetIntegrationWhereInput>;
};


export type MutationUpdateManyFeatureFlagArgs = {
  data: FeatureFlagUpdateManyMutationInput;
  where?: Maybe<FeatureFlagWhereInput>;
};


export type MutationUpdateManyFinancialAdjustmentArgs = {
  data: FinancialAdjustmentUpdateManyMutationInput;
  where?: Maybe<FinancialAdjustmentWhereInput>;
};


export type MutationUpdateManyFinancialTransactionArgs = {
  data: FinancialTransactionUpdateManyMutationInput;
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type MutationUpdateManyFormSubmissionArgs = {
  data: FormSubmissionUpdateManyMutationInput;
  where?: Maybe<FormSubmissionWhereInput>;
};


export type MutationUpdateManyFormTemplateArgs = {
  data: FormTemplateUpdateManyMutationInput;
  where?: Maybe<FormTemplateWhereInput>;
};


export type MutationUpdateManyGlobalPetParentArgs = {
  data: GlobalPetParentUpdateManyMutationInput;
  where?: Maybe<GlobalPetParentWhereInput>;
};


export type MutationUpdateManyGooglePlaceArgs = {
  data: GooglePlaceUpdateManyMutationInput;
  where?: Maybe<GooglePlaceWhereInput>;
};


export type MutationUpdateManyHillsToHomeApiLogArgs = {
  data: HillsToHomeApiLogUpdateManyMutationInput;
  where?: Maybe<HillsToHomeApiLogWhereInput>;
};


export type MutationUpdateManyInformAudienceDefinitionArgs = {
  data: InformAudienceDefinitionUpdateManyMutationInput;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};


export type MutationUpdateManyInformAudienceMemberArgs = {
  data: InformAudienceMemberUpdateManyMutationInput;
  where?: Maybe<InformAudienceMemberWhereInput>;
};


export type MutationUpdateManyInformAudienceMemberMessageArgs = {
  data: InformAudienceMemberMessageUpdateManyMutationInput;
  where?: Maybe<InformAudienceMemberMessageWhereInput>;
};


export type MutationUpdateManyInformCampaignArgs = {
  data: InformCampaignUpdateManyMutationInput;
  where?: Maybe<InformCampaignWhereInput>;
};


export type MutationUpdateManyInformCampaignEnrollmentArgs = {
  data: InformCampaignEnrollmentUpdateManyMutationInput;
  where?: Maybe<InformCampaignEnrollmentWhereInput>;
};


export type MutationUpdateManyInformCampaignEnrollmentCanonicalServiceArgs = {
  data: InformCampaignEnrollmentCanonicalServiceUpdateManyMutationInput;
  where?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereInput>;
};


export type MutationUpdateManyInformCampaignExecutionArgs = {
  data: InformCampaignExecutionUpdateManyMutationInput;
  where?: Maybe<InformCampaignExecutionWhereInput>;
};


export type MutationUpdateManyInformCampaignGroupArgs = {
  data: InformCampaignGroupUpdateManyMutationInput;
  where?: Maybe<InformCampaignGroupWhereInput>;
};


export type MutationUpdateManyInformCommunicationOptOutArgs = {
  data: InformCommunicationOptOutUpdateManyMutationInput;
  where?: Maybe<InformCommunicationOptOutWhereInput>;
};


export type MutationUpdateManyInformControlGroupParticipantArgs = {
  data: InformControlGroupParticipantUpdateManyMutationInput;
  where?: Maybe<InformControlGroupParticipantWhereInput>;
};


export type MutationUpdateManyInformEmailTemplateArgs = {
  data: InformEmailTemplateUpdateManyMutationInput;
  where?: Maybe<InformEmailTemplateWhereInput>;
};


export type MutationUpdateManyInformEntityHistoryArgs = {
  data: InformEntityHistoryUpdateManyMutationInput;
  where?: Maybe<InformEntityHistoryWhereInput>;
};


export type MutationUpdateManyInformEventDrivenCampaignArgs = {
  data: InformEventDrivenCampaignUpdateManyMutationInput;
  where?: Maybe<InformEventDrivenCampaignWhereInput>;
};


export type MutationUpdateManyInformEventListenerArgs = {
  data: InformEventListenerUpdateManyMutationInput;
  where?: Maybe<InformEventListenerWhereInput>;
};


export type MutationUpdateManyInformNotificationRecipientArgs = {
  data: InformNotificationRecipientUpdateManyMutationInput;
  where?: Maybe<InformNotificationRecipientWhereInput>;
};


export type MutationUpdateManyInformPartnerArgs = {
  data: InformPartnerUpdateManyMutationInput;
  where?: Maybe<InformPartnerWhereInput>;
};


export type MutationUpdateManyInformPartnerCustomerArgs = {
  data: InformPartnerCustomerUpdateManyMutationInput;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};


export type MutationUpdateManyInformPartnerCustomerPharmacyProviderArgs = {
  data: InformPartnerCustomerPharmacyProviderUpdateManyMutationInput;
  where?: Maybe<InformPartnerCustomerPharmacyProviderWhereInput>;
};


export type MutationUpdateManyInformPartnerIntegrationArgs = {
  data: InformPartnerIntegrationUpdateManyMutationInput;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};


export type MutationUpdateManyInformPartnerIntegrationModelArgs = {
  data: InformPartnerIntegrationModelUpdateManyMutationInput;
  where?: Maybe<InformPartnerIntegrationModelWhereInput>;
};


export type MutationUpdateManyInformPartnerProgramArgs = {
  data: InformPartnerProgramUpdateManyMutationInput;
  where?: Maybe<InformPartnerProgramWhereInput>;
};


export type MutationUpdateManyInformPartnerProgramEnrollmentArgs = {
  data: InformPartnerProgramEnrollmentUpdateManyMutationInput;
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};


export type MutationUpdateManyInformPartnerUserArgs = {
  data: InformPartnerUserUpdateManyMutationInput;
  where?: Maybe<InformPartnerUserWhereInput>;
};


export type MutationUpdateManyInformPartnerUserRoleArgs = {
  data: InformPartnerUserRoleUpdateManyMutationInput;
  where?: Maybe<InformPartnerUserRoleWhereInput>;
};


export type MutationUpdateManyInformScheduledCampaignArgs = {
  data: InformScheduledCampaignUpdateManyMutationInput;
  where?: Maybe<InformScheduledCampaignWhereInput>;
};


export type MutationUpdateManyInformSessionArgs = {
  data: InformSessionUpdateManyMutationInput;
  where?: Maybe<InformSessionWhereInput>;
};


export type MutationUpdateManyInformSessionEventArgs = {
  data: InformSessionEventUpdateManyMutationInput;
  where?: Maybe<InformSessionEventWhereInput>;
};


export type MutationUpdateManyInstinctIntegrationArgs = {
  data: InstinctIntegrationUpdateManyMutationInput;
  where?: Maybe<InstinctIntegrationWhereInput>;
};


export type MutationUpdateManyInsuranceIntegrationArgs = {
  data: InsuranceIntegrationUpdateManyMutationInput;
  where?: Maybe<InsuranceIntegrationWhereInput>;
};


export type MutationUpdateManyIntegrationOutageHistoryEntryArgs = {
  data: IntegrationOutageHistoryEntryUpdateManyMutationInput;
  where?: Maybe<IntegrationOutageHistoryEntryWhereInput>;
};


export type MutationUpdateManyInterchangeRateArgs = {
  data: InterchangeRateUpdateManyMutationInput;
  where?: Maybe<InterchangeRateWhereInput>;
};


export type MutationUpdateManyInvoiceArgs = {
  data: InvoiceUpdateManyMutationInput;
  where?: Maybe<InvoiceWhereInput>;
};


export type MutationUpdateManyInvoiceLineItemArgs = {
  data: InvoiceLineItemUpdateManyMutationInput;
  where?: Maybe<InvoiceLineItemWhereInput>;
};


export type MutationUpdateManyInvoicePimsWritebackLogEntryArgs = {
  data: InvoicePimsWritebackLogEntryUpdateManyMutationInput;
  where?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
};


export type MutationUpdateManyLabPanelArgs = {
  data: LabPanelUpdateManyMutationInput;
  where?: Maybe<LabPanelWhereInput>;
};


export type MutationUpdateManyLabResultArgs = {
  data: LabResultUpdateManyMutationInput;
  where?: Maybe<LabResultWhereInput>;
};


export type MutationUpdateManyLapsedPetParentTriggersArgs = {
  data: LapsedPetParentTriggersUpdateManyMutationInput;
  where?: Maybe<LapsedPetParentTriggersWhereInput>;
};


export type MutationUpdateManyLegalEntityArgs = {
  data: LegalEntityUpdateManyMutationInput;
  where?: Maybe<LegalEntityWhereInput>;
};


export type MutationUpdateManyLoyaltyAccountArgs = {
  data: LoyaltyAccountUpdateManyMutationInput;
  where?: Maybe<LoyaltyAccountWhereInput>;
};


export type MutationUpdateManyLoyaltyAccountHolderArgs = {
  data: LoyaltyAccountHolderUpdateManyMutationInput;
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};


export type MutationUpdateManyLoyaltyAccountMergerArgs = {
  data: LoyaltyAccountMergerUpdateManyMutationInput;
  where?: Maybe<LoyaltyAccountMergerWhereInput>;
};


export type MutationUpdateManyLoyaltyInvoicePointGranterArgs = {
  data: LoyaltyInvoicePointGranterUpdateManyMutationInput;
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};


export type MutationUpdateManyLoyaltyPointGrantingServiceArgs = {
  data: LoyaltyPointGrantingServiceUpdateManyMutationInput;
  where?: Maybe<LoyaltyPointGrantingServiceWhereInput>;
};


export type MutationUpdateManyLoyaltyPointGrantingServiceCategoryArgs = {
  data: LoyaltyPointGrantingServiceCategoryUpdateManyMutationInput;
  where?: Maybe<LoyaltyPointGrantingServiceCategoryWhereInput>;
};


export type MutationUpdateManyLoyaltyPointUserGrantArgs = {
  data: LoyaltyPointUserGrantUpdateManyMutationInput;
  where?: Maybe<LoyaltyPointUserGrantWhereInput>;
};


export type MutationUpdateManyLoyaltyRewardArgs = {
  data: LoyaltyRewardUpdateManyMutationInput;
  where?: Maybe<LoyaltyRewardWhereInput>;
};


export type MutationUpdateManyLoyaltyRewardRedemptionArgs = {
  data: LoyaltyRewardRedemptionUpdateManyMutationInput;
  where?: Maybe<LoyaltyRewardRedemptionWhereInput>;
};


export type MutationUpdateManyMassTextAlertArgs = {
  data: MassTextAlertUpdateManyMutationInput;
  where?: Maybe<MassTextAlertWhereInput>;
};


export type MutationUpdateManyMassTextAlertEntryArgs = {
  data: MassTextAlertEntryUpdateManyMutationInput;
  where?: Maybe<MassTextAlertEntryWhereInput>;
};


export type MutationUpdateManyMassTextAlertEntryAppointmentArgs = {
  data: MassTextAlertEntryAppointmentUpdateManyMutationInput;
  where?: Maybe<MassTextAlertEntryAppointmentWhereInput>;
};


export type MutationUpdateManyMediaArgs = {
  data: MediaUpdateManyMutationInput;
  where?: Maybe<MediaWhereInput>;
};


export type MutationUpdateManyMedicalHistoryArgs = {
  data: MedicalHistoryUpdateManyMutationInput;
  where?: Maybe<MedicalHistoryWhereInput>;
};


export type MutationUpdateManyMessageTemplateArgs = {
  data: MessageTemplateUpdateManyMutationInput;
  where?: Maybe<MessageTemplateWhereInput>;
};


export type MutationUpdateManyMessagingCampaignArgs = {
  data: MessagingCampaignUpdateManyMutationInput;
  where?: Maybe<MessagingCampaignWhereInput>;
};


export type MutationUpdateManyMessagingPartnerArgs = {
  data: MessagingPartnerUpdateManyMutationInput;
  where?: Maybe<MessagingPartnerWhereInput>;
};


export type MutationUpdateManyModuleArgs = {
  data: ModuleUpdateManyMutationInput;
  where?: Maybe<ModuleWhereInput>;
};


export type MutationUpdateManyNonPrismaSchemaScriptRanArgs = {
  data: NonPrismaSchemaScriptRanUpdateManyMutationInput;
  where?: Maybe<NonPrismaSchemaScriptRanWhereInput>;
};


export type MutationUpdateManyNotificationEventToMessageArgs = {
  data: NotificationEventToMessageUpdateManyMutationInput;
  where?: Maybe<NotificationEventToMessageWhereInput>;
};


export type MutationUpdateManyOrganizationArgs = {
  data: OrganizationUpdateManyMutationInput;
  where?: Maybe<OrganizationWhereInput>;
};


export type MutationUpdateManyOrganizationCareBenefitToClinicServiceCategoryArgs = {
  data: OrganizationCareBenefitToClinicServiceCategoryUpdateManyMutationInput;
  where?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereInput>;
};


export type MutationUpdateManyOrganizationPetArgs = {
  data: OrganizationPetUpdateManyMutationInput;
  where?: Maybe<OrganizationPetWhereInput>;
};


export type MutationUpdateManyOrganizationPetParentArgs = {
  data: OrganizationPetParentUpdateManyMutationInput;
  where?: Maybe<OrganizationPetParentWhereInput>;
};


export type MutationUpdateManyPpcIntegrationArgs = {
  data: PpcIntegrationUpdateManyMutationInput;
  where?: Maybe<PpcIntegrationWhereInput>;
};


export type MutationUpdateManyPaymentsReportTransactionArgs = {
  data: PaymentsReportTransactionUpdateManyMutationInput;
  where?: Maybe<PaymentsReportTransactionWhereInput>;
};


export type MutationUpdateManyPayoutBatchingPeriodArgs = {
  data: PayoutBatchingPeriodUpdateManyMutationInput;
  where?: Maybe<PayoutBatchingPeriodWhereInput>;
};


export type MutationUpdateManyPayoutBatchingScheduleArgs = {
  data: PayoutBatchingScheduleUpdateManyMutationInput;
  where?: Maybe<PayoutBatchingScheduleWhereInput>;
};


export type MutationUpdateManyPayoutBatchingSettingArgs = {
  data: PayoutBatchingSettingUpdateManyMutationInput;
  where?: Maybe<PayoutBatchingSettingWhereInput>;
};


export type MutationUpdateManyPermissionArgs = {
  data: PermissionUpdateManyMutationInput;
  where?: Maybe<PermissionWhereInput>;
};


export type MutationUpdateManyPetParentSettingArgs = {
  data: PetParentSettingUpdateManyMutationInput;
  where?: Maybe<PetParentSettingWhereInput>;
};


export type MutationUpdateManyPetPortalSettingArgs = {
  data: PetPortalSettingUpdateManyMutationInput;
  where?: Maybe<PetPortalSettingWhereInput>;
};


export type MutationUpdateManyPhoneNumberLookupRequestArgs = {
  data: PhoneNumberLookupRequestUpdateManyMutationInput;
  where?: Maybe<PhoneNumberLookupRequestWhereInput>;
};


export type MutationUpdateManyPhoneNumberLookupResultArgs = {
  data: PhoneNumberLookupResultUpdateManyMutationInput;
  where?: Maybe<PhoneNumberLookupResultWhereInput>;
};


export type MutationUpdateManyPimsInvoiceArgs = {
  data: PimsInvoiceUpdateManyMutationInput;
  where?: Maybe<PimsInvoiceWhereInput>;
};


export type MutationUpdateManyPimsInvoiceLineItemArgs = {
  data: PimsInvoiceLineItemUpdateManyMutationInput;
  where?: Maybe<PimsInvoiceLineItemWhereInput>;
};


export type MutationUpdateManyPimsWritebackLogEntryArgs = {
  data: PimsWritebackLogEntryUpdateManyMutationInput;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};


export type MutationUpdateManyPrescriptionArgs = {
  data: PrescriptionUpdateManyMutationInput;
  where?: Maybe<PrescriptionWhereInput>;
};


export type MutationUpdateManyProductArgs = {
  data: ProductUpdateManyMutationInput;
  where?: Maybe<ProductWhereInput>;
};


export type MutationUpdateManyProductPackageArgs = {
  data: ProductPackageUpdateManyMutationInput;
  where?: Maybe<ProductPackageWhereInput>;
};


export type MutationUpdateManyProductPackageSubscriptionArgs = {
  data: ProductPackageSubscriptionUpdateManyMutationInput;
  where?: Maybe<ProductPackageSubscriptionWhereInput>;
};


export type MutationUpdateManyProviderAppointmentTypeRoomMapArgs = {
  data: ProviderAppointmentTypeRoomMapUpdateManyMutationInput;
  where?: Maybe<ProviderAppointmentTypeRoomMapWhereInput>;
};


export type MutationUpdateManyPushNotificationLogArgs = {
  data: PushNotificationLogUpdateManyMutationInput;
  where?: Maybe<PushNotificationLogWhereInput>;
};


export type MutationUpdateManyRecapArgs = {
  data: RecapUpdateManyMutationInput;
  where?: Maybe<RecapWhereInput>;
};


export type MutationUpdateManyRulesArgs = {
  data: RulesUpdateManyMutationInput;
  where?: Maybe<RulesWhereInput>;
};


export type MutationUpdateManySegmentArgs = {
  data: SegmentUpdateManyMutationInput;
  where?: Maybe<SegmentWhereInput>;
};


export type MutationUpdateManySentTrupanionExamDayOfferArgs = {
  data: SentTrupanionExamDayOfferUpdateManyMutationInput;
  where?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};


export type MutationUpdateManyServiceArgs = {
  data: ServiceUpdateManyMutationInput;
  where?: Maybe<ServiceWhereInput>;
};


export type MutationUpdateManyServiceCategoryArgs = {
  data: ServiceCategoryUpdateManyMutationInput;
  where?: Maybe<ServiceCategoryWhereInput>;
};


export type MutationUpdateManyServicePurchaseSummaryArgs = {
  data: ServicePurchaseSummaryUpdateManyMutationInput;
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};


export type MutationUpdateManyServiceReminderArgs = {
  data: ServiceReminderUpdateManyMutationInput;
  where?: Maybe<ServiceReminderWhereInput>;
};


export type MutationUpdateManyServiceReminderNotificationArgs = {
  data: ServiceReminderNotificationUpdateManyMutationInput;
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};


export type MutationUpdateManyServiceReminderTimingArgs = {
  data: ServiceReminderTimingUpdateManyMutationInput;
  where?: Maybe<ServiceReminderTimingWhereInput>;
};


export type MutationUpdateManyServicesAndTimingsArgs = {
  data: Array<ServiceReminderTimingInput>;
  where: ServiceWhereInput;
};


export type MutationUpdateManySexArgs = {
  data: SexUpdateManyMutationInput;
  where?: Maybe<SexWhereInput>;
};


export type MutationUpdateManySmsNotificationStatusArgs = {
  data: SmsNotificationStatusUpdateManyMutationInput;
  where?: Maybe<SmsNotificationStatusWhereInput>;
};


export type MutationUpdateManySpeciesArgs = {
  data: SpeciesUpdateManyMutationInput;
  where?: Maybe<SpeciesWhereInput>;
};


export type MutationUpdateManyStaffRoleArgs = {
  data: StaffRoleUpdateManyMutationInput;
  where?: Maybe<StaffRoleWhereInput>;
};


export type MutationUpdateManyStripeCustomerArgs = {
  data: StripeCustomerUpdateManyMutationInput;
  where?: Maybe<StripeCustomerWhereInput>;
};


export type MutationUpdateManyStripeDisputeArgs = {
  data: StripeDisputeUpdateManyMutationInput;
  where?: Maybe<StripeDisputeWhereInput>;
};


export type MutationUpdateManyStripeInvoiceArgs = {
  data: StripeInvoiceUpdateManyMutationInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type MutationUpdateManyStripeInvoiceItemArgs = {
  data: StripeInvoiceItemUpdateManyMutationInput;
  where?: Maybe<StripeInvoiceItemWhereInput>;
};


export type MutationUpdateManyStripePaymentIntentArgs = {
  data: StripePaymentIntentUpdateManyMutationInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type MutationUpdateManyStripePaymentMethodArgs = {
  data: StripePaymentMethodUpdateManyMutationInput;
  where?: Maybe<StripePaymentMethodWhereInput>;
};


export type MutationUpdateManyStripePayoutArgs = {
  data: StripePayoutUpdateManyMutationInput;
  where?: Maybe<StripePayoutWhereInput>;
};


export type MutationUpdateManyStripePayoutAccountArgs = {
  data: StripePayoutAccountUpdateManyMutationInput;
  where?: Maybe<StripePayoutAccountWhereInput>;
};


export type MutationUpdateManyStripeReceiptArgs = {
  data: StripeReceiptUpdateManyMutationInput;
  where?: Maybe<StripeReceiptWhereInput>;
};


export type MutationUpdateManyStripeReceiptHistoryArgs = {
  data: StripeReceiptHistoryUpdateManyMutationInput;
  where?: Maybe<StripeReceiptHistoryWhereInput>;
};


export type MutationUpdateManyStripeRefundArgs = {
  data: StripeRefundUpdateManyMutationInput;
  where?: Maybe<StripeRefundWhereInput>;
};


export type MutationUpdateManyStripeTerminalArgs = {
  data: StripeTerminalUpdateManyMutationInput;
  where?: Maybe<StripeTerminalWhereInput>;
};


export type MutationUpdateManyStripeTerminalLocationArgs = {
  data: StripeTerminalLocationUpdateManyMutationInput;
  where?: Maybe<StripeTerminalLocationWhereInput>;
};


export type MutationUpdateManySurveyAppointmentTypeSettingArgs = {
  data: SurveyAppointmentTypeSettingUpdateManyMutationInput;
  where?: Maybe<SurveyAppointmentTypeSettingWhereInput>;
};


export type MutationUpdateManySurveyResultArgs = {
  data: SurveyResultUpdateManyMutationInput;
  where?: Maybe<SurveyResultWhereInput>;
};


export type MutationUpdateManySurveySettingArgs = {
  data: SurveySettingUpdateManyMutationInput;
  where?: Maybe<SurveySettingWhereInput>;
};


export type MutationUpdateManySyncVetIntegrationArgs = {
  data: SyncVetIntegrationUpdateManyMutationInput;
  where?: Maybe<SyncVetIntegrationWhereInput>;
};


export type MutationUpdateManySyncVetServiceArgs = {
  data: SyncVetServiceUpdateManyMutationInput;
  where?: Maybe<SyncVetServiceWhereInput>;
};


export type MutationUpdateManySynchronyClinicConfigurationArgs = {
  data: SynchronyClinicConfigurationUpdateManyMutationInput;
  where?: Maybe<SynchronyClinicConfigurationWhereInput>;
};


export type MutationUpdateManySynchronyEventArgs = {
  data: SynchronyEventUpdateManyMutationInput;
  where?: Maybe<SynchronyEventWhereInput>;
};


export type MutationUpdateManyTaskArgs = {
  data: TaskUpdateManyMutationInput;
  where?: Maybe<TaskWhereInput>;
};


export type MutationUpdateManyTaxonomyArgs = {
  data: TaxonomyUpdateManyMutationInput;
  where?: Maybe<TaxonomyWhereInput>;
};


export type MutationUpdateManyTaxonomyToInformAudienceDefinitionArgs = {
  data: TaxonomyToInformAudienceDefinitionUpdateManyMutationInput;
  where?: Maybe<TaxonomyToInformAudienceDefinitionWhereInput>;
};


export type MutationUpdateManyTimingsDeliveryOptionsArgs = {
  data: ServiceReminderTimingDeliveryOptionInput;
  where: ServiceWhereInput;
};


export type MutationUpdateManyTransactionArgs = {
  data: TransactionUpdateManyMutationInput;
  where?: Maybe<TransactionWhereInput>;
};


export type MutationUpdateManyTrupanionCertificateAvailabilityArgs = {
  data: TrupanionCertificateAvailabilityUpdateManyMutationInput;
  where?: Maybe<TrupanionCertificateAvailabilityWhereInput>;
};


export type MutationUpdateManyTrupanionIntegratedAppointmentTypeArgs = {
  data: TrupanionIntegratedAppointmentTypeUpdateManyMutationInput;
  where?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
};


export type MutationUpdateManyTrupanionIntegrationArgs = {
  data: TrupanionIntegrationUpdateManyMutationInput;
  where?: Maybe<TrupanionIntegrationWhereInput>;
};


export type MutationUpdateManyUserArgs = {
  data: UserUpdateManyMutationInput;
  where?: Maybe<UserWhereInput>;
};


export type MutationUpdateManyUserAppointmentGroupingArgs = {
  data: UserAppointmentGroupingUpdateManyMutationInput;
  where?: Maybe<UserAppointmentGroupingWhereInput>;
};


export type MutationUpdateManyUserBoardFilterArgs = {
  data: UserBoardFilterUpdateManyMutationInput;
  where?: Maybe<UserBoardFilterWhereInput>;
};


export type MutationUpdateManyUserChannelFilterSelectionArgs = {
  data: UserChannelFilterSelectionUpdateManyMutationInput;
  where?: Maybe<UserChannelFilterSelectionWhereInput>;
};


export type MutationUpdateManyUserNotificationSettingArgs = {
  data: UserNotificationSettingUpdateManyMutationInput;
  where?: Maybe<UserNotificationSettingWhereInput>;
};


export type MutationUpdateManyUserSettingArgs = {
  data: UserSettingUpdateManyMutationInput;
  where?: Maybe<UserSettingWhereInput>;
};


export type MutationUpdateManyUserTaskListArgs = {
  data: UserTaskListUpdateManyMutationInput;
  where?: Maybe<UserTaskListWhereInput>;
};


export type MutationUpdateManyUserTaskListFilterArgs = {
  data: UserTaskListFilterUpdateManyMutationInput;
  where?: Maybe<UserTaskListFilterWhereInput>;
};


export type MutationUpdateManyVaccinationArgs = {
  data: VaccinationUpdateManyMutationInput;
  where?: Maybe<VaccinationWhereInput>;
};


export type MutationUpdateManyVetAvailabilityArgs = {
  data: VetAvailabilityUpdateManyMutationInput;
  where?: Maybe<VetAvailabilityWhereInput>;
};


export type MutationUpdateManyVetAvailabilityClinicRoomMapArgs = {
  data: VetAvailabilityClinicRoomMapUpdateManyMutationInput;
  where?: Maybe<VetAvailabilityClinicRoomMapWhereInput>;
};


export type MutationUpdateManyVetAvailabilityMapArgs = {
  data: VetAvailabilityMapUpdateManyMutationInput;
  where?: Maybe<VetAvailabilityMapWhereInput>;
};


export type MutationUpdateManyVetInfoArgs = {
  data: VetInfoUpdateManyMutationInput;
  where?: Maybe<VetInfoWhereInput>;
};


export type MutationUpdateManyVetsourceCodeTagArgs = {
  data: VetsourceCodeTagUpdateManyMutationInput;
  where?: Maybe<VetsourceCodeTagWhereInput>;
};


export type MutationUpdateManyVetsourceInstallationArgs = {
  data: VetsourceInstallationUpdateManyMutationInput;
  where?: Maybe<VetsourceInstallationWhereInput>;
};


export type MutationUpdateManyVetsourcePharmacyIntegrationArgs = {
  data: VetsourcePharmacyIntegrationUpdateManyMutationInput;
  where?: Maybe<VetsourcePharmacyIntegrationWhereInput>;
};


export type MutationUpdateManyVetsourceRevenueCategoryArgs = {
  data: VetsourceRevenueCategoryUpdateManyMutationInput;
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};


export type MutationUpdateManyWorkflowEventSettingArgs = {
  data: WorkflowEventSettingUpdateManyMutationInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};


export type MutationUpdateOneActiveIngredientArgs = {
  data: ActiveIngredientUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ActiveIngredientWhereUniqueInput;
};


export type MutationUpdateOneAppointmentArgs = {
  data: AppointmentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AppointmentWhereUniqueInput;
};


export type MutationUpdateOneAppointmentAvailabilityArgs = {
  data: AppointmentAvailabilityUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AppointmentAvailabilityWhereUniqueInput;
};


export type MutationUpdateOneAppointmentNoteTemplateArgs = {
  data: AppointmentNoteTemplateUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AppointmentNoteTemplateWhereUniqueInput;
};


export type MutationUpdateOneAppointmentTypeArgs = {
  data: AppointmentTypeUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AppointmentTypeWhereUniqueInput;
};


export type MutationUpdateOneAutomationRunArgs = {
  data: AutomationRunUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AutomationRunWhereUniqueInput;
};


export type MutationUpdateOneAutomationRunActionArgs = {
  data: AutomationRunActionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AutomationRunActionWhereUniqueInput;
};


export type MutationUpdateOneAxionCallArgs = {
  data: UpdateOneAxionCallInput;
};


export type MutationUpdateOneAxionClinicConfigurationArgs = {
  data: AxionClinicConfigurationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AxionClinicConfigurationWhereUniqueInput;
};


export type MutationUpdateOneAxionClinicUserConfigurationArgs = {
  data: AxionClinicUserConfigurationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AxionClinicUserConfigurationWhereUniqueInput;
};


export type MutationUpdateOneBedrockInferenceArgs = {
  data: BedrockInferenceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BedrockInferenceWhereUniqueInput;
};


export type MutationUpdateOneBitwerxHealthcheckArgs = {
  data: BitwerxHealthcheckUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxHealthcheckWhereUniqueInput;
};


export type MutationUpdateOneBitwerxIntegrationArgs = {
  data: BitwerxIntegrationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxIntegrationWhereUniqueInput;
};


export type MutationUpdateOneBitwerxPaymentHealthcheckResultArgs = {
  data: BitwerxPaymentHealthcheckResultUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxPaymentHealthcheckResultWhereUniqueInput;
};


export type MutationUpdateOneBitwerxPaymentHealthcheckRunArgs = {
  data: BitwerxPaymentHealthcheckRunUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxPaymentHealthcheckRunWhereUniqueInput;
};


export type MutationUpdateOneBitwerxPaymentWritebackConfigurationArgs = {
  data: BitwerxPaymentWritebackConfigurationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};


export type MutationUpdateOneBoardFilterColumnArgs = {
  data: BoardFilterColumnUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BoardFilterColumnWhereUniqueInput;
};


export type MutationUpdateOneBoardFilterSpecificDateRangeArgs = {
  data: BoardFilterSpecificDateRangeUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BoardFilterSpecificDateRangeWhereUniqueInput;
};


export type MutationUpdateOneBoehringerIngelheimCustomerAlignmentArgs = {
  data: BoehringerIngelheimCustomerAlignmentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BoehringerIngelheimCustomerAlignmentWhereUniqueInput;
};


export type MutationUpdateOneBoehringerIngelheimTerritoryArgs = {
  data: BoehringerIngelheimTerritoryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BoehringerIngelheimTerritoryWhereUniqueInput;
};


export type MutationUpdateOneBreedArgs = {
  data: BreedUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BreedWhereUniqueInput;
};


export type MutationUpdateOneCallHistoryArgs = {
  data: CallHistoryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CallHistoryWhereUniqueInput;
};


export type MutationUpdateOneCallParticipantArgs = {
  data: CallParticipantUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CallParticipantWhereUniqueInput;
};


export type MutationUpdateOneCallRecordingArgs = {
  data: CallRecordingUpdateInput;
  where: CallRecordingWhereUniqueInput;
};


export type MutationUpdateOneCampaignRegistryCampaignArgs = {
  data: CampaignRegistryCampaignUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CampaignRegistryCampaignWhereUniqueInput;
};


export type MutationUpdateOneCanonicalBreedArgs = {
  data: CanonicalBreedUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CanonicalBreedWhereUniqueInput;
};


export type MutationUpdateOneCanonicalCanineBreedProfileArgs = {
  data: CanonicalCanineBreedProfileUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CanonicalCanineBreedProfileWhereUniqueInput;
};


export type MutationUpdateOneCanonicalServiceArgs = {
  data: CanonicalServiceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CanonicalServiceWhereUniqueInput;
};


export type MutationUpdateOneCanonicalSpeciesArgs = {
  data: CanonicalSpeciesUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CanonicalSpeciesWhereUniqueInput;
};


export type MutationUpdateOneCareAddonEnrollmentArgs = {
  data: CareAddonEnrollmentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAddonEnrollmentWhereUniqueInput;
};


export type MutationUpdateOneCareAddonPackageArgs = {
  data: CareAddonPackageUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAddonPackageWhereUniqueInput;
};


export type MutationUpdateOneCareAddonPackageBenefitArgs = {
  data: CareAddonPackageBenefitUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAddonPackageBenefitWhereUniqueInput;
};


export type MutationUpdateOneCareAuthorizationRequestArgs = {
  data: CareAuthorizationRequestUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAuthorizationRequestWhereUniqueInput;
};


export type MutationUpdateOneCareBenefitArgs = {
  data: CareBenefitUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitWhereUniqueInput;
};


export type MutationUpdateOneCareBenefitUsageArgs = {
  data: CareBenefitUsageUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitUsageWhereUniqueInput;
};


export type MutationUpdateOneCareBenefitUsageFollowupArgs = {
  data: CareBenefitUsageFollowupUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitUsageFollowupWhereUniqueInput;
};


export type MutationUpdateOneCareBenefitUsageFollowupStepArgs = {
  data: CareBenefitUsageFollowupStepUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitUsageFollowupStepWhereUniqueInput;
};


export type MutationUpdateOneCareBenefitUsageToInvoiceLineItemArgs = {
  data: CareBenefitUsageToInvoiceLineItemUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};


export type MutationUpdateOneCareCreditPreapprovalCheckArgs = {
  data: CareCreditPreapprovalCheckUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareCreditPreapprovalCheckWhereUniqueInput;
};


export type MutationUpdateOneCareEnrollmentPaymentArgs = {
  data: CareEnrollmentPaymentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareEnrollmentPaymentWhereUniqueInput;
};


export type MutationUpdateOneCareEnrollmentToStripeInvoiceItemArgs = {
  data: CareEnrollmentToStripeInvoiceItemUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};


export type MutationUpdateOneCareLapsedPaymentArgs = {
  data: CareLapsedPaymentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareLapsedPaymentWhereUniqueInput;
};


export type MutationUpdateOneCarePlanArgs = {
  data: CarePlanUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanWhereUniqueInput;
};


export type MutationUpdateOneCarePlanBenefitArgs = {
  data: CarePlanBenefitUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanBenefitWhereUniqueInput;
};


export type MutationUpdateOneCarePlanBenefitEnrollmentCarryoverArgs = {
  data: CarePlanBenefitEnrollmentCarryoverUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};


export type MutationUpdateOneCarePlanEnrollmentArgs = {
  data: CarePlanEnrollmentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanEnrollmentWhereUniqueInput;
};


export type MutationUpdateOneCarePlanPricingArgs = {
  data: CarePlanPricingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanPricingWhereUniqueInput;
};


export type MutationUpdateOneCarePlanProviderGroupArgs = {
  data: CarePlanProviderGroupUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanProviderGroupWhereUniqueInput;
};


export type MutationUpdateOneCareStripeSubscriptionArgs = {
  data: CareStripeSubscriptionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareStripeSubscriptionWhereUniqueInput;
};


export type MutationUpdateOneCareSubscriptionTrueUpArgs = {
  data: CareSubscriptionTrueUpUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};


export type MutationUpdateOneCareSubscriptionTrueUpLogEntryArgs = {
  data: CareSubscriptionTrueUpLogEntryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareSubscriptionTrueUpLogEntryWhereUniqueInput;
};


export type MutationUpdateOneChannelArgs = {
  data: ChannelUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelWhereUniqueInput;
};


export type MutationUpdateOneChannelAutomationStatusArgs = {
  data: ChannelAutomationStatusUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelAutomationStatusWhereUniqueInput;
};


export type MutationUpdateOneChannelCreationSourceArgs = {
  data: ChannelCreationSourceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelCreationSourceWhereUniqueInput;
};


export type MutationUpdateOneChannelFilterSelectionArgs = {
  data: ChannelFilterSelectionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelFilterSelectionWhereUniqueInput;
};


export type MutationUpdateOneChannelMemberArgs = {
  data: ChannelMemberUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMemberWhereUniqueInput;
};


export type MutationUpdateOneChannelMessageArgs = {
  data: ChannelMessageUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMessageWhereUniqueInput;
};


export type MutationUpdateOneChannelMessageAttachmentArgs = {
  data: ChannelMessageAttachmentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMessageAttachmentWhereUniqueInput;
};


export type MutationUpdateOneChannelMessageAutoResponseArgs = {
  data: ChannelMessageAutoResponseUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMessageAutoResponseWhereUniqueInput;
};


export type MutationUpdateOneChannelMessageReactionArgs = {
  data: ChannelMessageReactionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMessageReactionWhereUniqueInput;
};


export type MutationUpdateOneChannelPinArgs = {
  data: ChannelPinUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelPinWhereUniqueInput;
};


export type MutationUpdateOneChannelSelectionArgs = {
  data: ChannelSelectionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelSelectionWhereUniqueInput;
};


export type MutationUpdateOneChannelStatusArgs = {
  data: ChannelStatusUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelStatusWhereUniqueInput;
};


export type MutationUpdateOneChannelStatusChannelAssigneeArgs = {
  data: ChannelStatusChannelAssigneeUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};


export type MutationUpdateOneChemicalCompoundArgs = {
  data: ChemicalCompoundUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChemicalCompoundWhereUniqueInput;
};


export type MutationUpdateOneClientConnectIntegrationArgs = {
  data: ClientConnectIntegrationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClientConnectIntegrationWhereUniqueInput;
};


export type MutationUpdateOneClinicArgs = {
  data: ClinicUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicWhereUniqueInput;
};


export type MutationUpdateOneClinicBlockedPhoneNumberArgs = {
  data: ClinicBlockedPhoneNumberUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};


export type MutationUpdateOneClinicCustomPayoutsSetupArgs = {
  data: ClinicCustomPayoutsSetupUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicCustomPayoutsSetupWhereUniqueInput;
};


export type MutationUpdateOneClinicDirectBookingSettingArgs = {
  data: ClinicDirectBookingSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicDirectBookingSettingWhereUniqueInput;
};


export type MutationUpdateOneClinicEmailCampaignSettingArgs = {
  data: ClinicEmailCampaignSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicEmailCampaignSettingWhereUniqueInput;
};


export type MutationUpdateOneClinicEmployeeArgs = {
  data: ClinicEmployeeUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicEmployeeWhereUniqueInput;
};


export type MutationUpdateOneClinicEmployeeAppointmentTypeSettingArgs = {
  data: ClinicEmployeeAppointmentTypeSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicEmployeeAppointmentTypeSettingWhereUniqueInput;
};


export type MutationUpdateOneClinicEntityPhoneNumberArgs = {
  data: ClinicEntityPhoneNumberUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};


export type MutationUpdateOneClinicModuleArgs = {
  data: ClinicModuleUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicModuleWhereUniqueInput;
};


export type MutationUpdateOneClinicOfficeHourArgs = {
  data: ClinicOfficeHourUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicOfficeHourWhereUniqueInput;
};


export type MutationUpdateOneClinicOnboardingArgs = {
  data: ClinicOnboardingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicOnboardingWhereUniqueInput;
};


export type MutationUpdateOneClinicPaymentFeeConfigurationArgs = {
  data: ClinicPaymentFeeConfigurationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPaymentFeeConfigurationWhereUniqueInput;
};


export type MutationUpdateOneClinicPetArgs = {
  data: ClinicPetUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetWhereUniqueInput;
};


export type MutationUpdateOneClinicPetAlertArgs = {
  data: ClinicPetAlertUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetAlertWhereUniqueInput;
};


export type MutationUpdateOneClinicPetCustomFieldValueArgs = {
  data: ClinicPetCustomFieldValueUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetCustomFieldValueWhereUniqueInput;
};


export type MutationUpdateOneClinicPetParentArgs = {
  data: ClinicPetParentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentWhereUniqueInput;
};


export type MutationUpdateOneClinicPetParentAddressArgs = {
  data: ClinicPetParentAddressUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentAddressWhereUniqueInput;
};


export type MutationUpdateOneClinicPetParentAndEnqueuePhoneNumberLookupArgs = {
  data: ClinicPetParentUpdateInput;
  where: ClinicPetParentWhereUniqueInput;
};


export type MutationUpdateOneClinicPetParentCustomFieldValueArgs = {
  data: ClinicPetParentCustomFieldValueUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentCustomFieldValueWhereUniqueInput;
};


export type MutationUpdateOneClinicPetParentDeviceArgs = {
  data: ClinicPetParentDeviceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentDeviceWhereUniqueInput;
};


export type MutationUpdateOneClinicPetParentPimsSyncStatusArgs = {
  data: ClinicPetParentPimsSyncStatusUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentPimsSyncStatusWhereUniqueInput;
};


export type MutationUpdateOneClinicPetPimsSyncStatusArgs = {
  data: ClinicPetPimsSyncStatusUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetPimsSyncStatusWhereUniqueInput;
};


export type MutationUpdateOneClinicPhoneNumberArgs = {
  data: ClinicPhoneNumberUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPhoneNumberWhereUniqueInput;
};


export type MutationUpdateOneClinicPimsIntegrationArgs = {
  data: ClinicPimsIntegrationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPimsIntegrationWhereUniqueInput;
};


export type MutationUpdateOneClinicPimsIntegrationCapabilityArgs = {
  data: ClinicPimsIntegrationCapabilityUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPimsIntegrationCapabilityWhereUniqueInput;
};


export type MutationUpdateOneClinicPimsIntegrationCapabilityHistoryEntryArgs = {
  data: ClinicPimsIntegrationCapabilityHistoryEntryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput;
};


export type MutationUpdateOneClinicPostcardSettingArgs = {
  data: ClinicPostcardSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPostcardSettingWhereUniqueInput;
};


export type MutationUpdateOneClinicRoomArgs = {
  data: ClinicRoomUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicRoomWhereUniqueInput;
};


export type MutationUpdateOneClinicSettingArgs = {
  data: ClinicSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicSettingWhereUniqueInput;
};


export type MutationUpdateOneClinicUserFilterArgs = {
  data: ClinicUserFilterUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicUserFilterWhereUniqueInput;
};


export type MutationUpdateOneClinicWidgetRequestArgs = {
  data: ClinicWidgetRequestUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicWidgetRequestWhereUniqueInput;
};


export type MutationUpdateOneClinicWidgetRequestTypeArgs = {
  data: ClinicWidgetRequestTypeUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};


export type MutationUpdateOneClinicWidgetSettingArgs = {
  data: ClinicWidgetSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicWidgetSettingWhereUniqueInput;
};


export type MutationUpdateOneColorArgs = {
  data: ColorUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ColorWhereUniqueInput;
};


export type MutationUpdateOneConditionArgs = {
  data: ConditionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConditionWhereUniqueInput;
};


export type MutationUpdateOneConditionSetArgs = {
  data: ConditionSetUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConditionSetWhereUniqueInput;
};


export type MutationUpdateOneConditionalEntityEvaluationArgs = {
  data: ConditionalEntityEvaluationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConditionalEntityEvaluationWhereUniqueInput;
};


export type MutationUpdateOneConsultationRequestArgs = {
  data: ConsultationRequestUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConsultationRequestWhereUniqueInput;
};


export type MutationUpdateOneCustomFieldDefinitionArgs = {
  data: CustomFieldDefinitionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CustomFieldDefinitionWhereUniqueInput;
};


export type MutationUpdateOneCustomFieldPimsWritebackLogEntryArgs = {
  data: CustomFieldPimsWritebackLogEntryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CustomFieldPimsWritebackLogEntryWhereUniqueInput;
};


export type MutationUpdateOneDirectBookingAppointmentTypeSettingArgs = {
  data: DirectBookingAppointmentTypeSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DirectBookingAppointmentTypeSettingWhereUniqueInput;
};


export type MutationUpdateOneDirectBookingExclusionRuleArgs = {
  data: DirectBookingExclusionRuleUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};


export type MutationUpdateOneDirectBookingExclusionTimeSlotArgs = {
  data: DirectBookingExclusionTimeSlotUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DirectBookingExclusionTimeSlotWhereUniqueInput;
};


export type MutationUpdateOneDisbursementArgs = {
  data: DisbursementUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DisbursementWhereUniqueInput;
};


export type MutationUpdateOneDocumentationArgs = {
  data: DocumentationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DocumentationWhereUniqueInput;
};


export type MutationUpdateOneEmailCampaignArgs = {
  data: EmailCampaignUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignWhereUniqueInput;
};


export type MutationUpdateOneEmailCampaignCustomListArgs = {
  data: EmailCampaignCustomListUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignCustomListWhereUniqueInput;
};


export type MutationUpdateOneEmailCampaignCustomListRecipientArgs = {
  data: EmailCampaignCustomListRecipientUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignCustomListRecipientWhereUniqueInput;
};


export type MutationUpdateOneEmailCampaignCustomListUploadHistoryArgs = {
  data: EmailCampaignCustomListUploadHistoryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignCustomListUploadHistoryWhereUniqueInput;
};


export type MutationUpdateOneEmailCampaignLogArgs = {
  data: EmailCampaignLogUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignLogWhereUniqueInput;
};


export type MutationUpdateOneEmailCampaignTemplateArgs = {
  data: EmailCampaignTemplateUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignTemplateWhereUniqueInput;
};


export type MutationUpdateOneEmailCampaignUnsubscribeArgs = {
  data: EmailCampaignUnsubscribeUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};


export type MutationUpdateOneEmailProviderLogArgs = {
  data: EmailProviderLogUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailProviderLogWhereUniqueInput;
};


export type MutationUpdateOneEmailTemplateVersionArgs = {
  data: EmailTemplateVersionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailTemplateVersionWhereUniqueInput;
};


export type MutationUpdateOneEmergencyClinicsArgs = {
  data: EmergencyClinicsUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmergencyClinicsWhereUniqueInput;
};


export type MutationUpdateOneEncryptedClinicUploadArgs = {
  data: EncryptedClinicUploadUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EncryptedClinicUploadWhereUniqueInput;
};


export type MutationUpdateOneEnrollmentSupportEventArgs = {
  data: EnrollmentSupportEventUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EnrollmentSupportEventWhereUniqueInput;
};


export type MutationUpdateOneEzyVetIntegrationArgs = {
  data: EzyVetIntegrationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EzyVetIntegrationWhereUniqueInput;
};


export type MutationUpdateOneFeatureFlagArgs = {
  data: FeatureFlagUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FeatureFlagWhereUniqueInput;
};


export type MutationUpdateOneFinancialAdjustmentArgs = {
  data: FinancialAdjustmentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FinancialAdjustmentWhereUniqueInput;
};


export type MutationUpdateOneFinancialTransactionArgs = {
  data: FinancialTransactionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FinancialTransactionWhereUniqueInput;
};


export type MutationUpdateOneFormSubmissionArgs = {
  data: FormSubmissionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FormSubmissionWhereUniqueInput;
};


export type MutationUpdateOneFormTemplateArgs = {
  data: FormTemplateUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FormTemplateWhereUniqueInput;
};


export type MutationUpdateOneGlobalPetParentArgs = {
  data: GlobalPetParentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: GlobalPetParentWhereUniqueInput;
};


export type MutationUpdateOneGooglePlaceArgs = {
  data: GooglePlaceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: GooglePlaceWhereUniqueInput;
};


export type MutationUpdateOneHillsToHomeApiLogArgs = {
  data: HillsToHomeApiLogUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: HillsToHomeApiLogWhereUniqueInput;
};


export type MutationUpdateOneInformAudienceDefinitionArgs = {
  data: InformAudienceDefinitionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformAudienceDefinitionWhereUniqueInput;
};


export type MutationUpdateOneInformAudienceMemberArgs = {
  data: InformAudienceMemberUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformAudienceMemberWhereUniqueInput;
};


export type MutationUpdateOneInformAudienceMemberMessageArgs = {
  data: InformAudienceMemberMessageUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformAudienceMemberMessageWhereUniqueInput;
};


export type MutationUpdateOneInformAutomationCampaignArgs = {
  data: InformAutomationCampaignUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformAutomationCampaignWhereUniqueInput;
};


export type MutationUpdateOneInformCampaignArgs = {
  data: InformCampaignUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignWhereUniqueInput;
};


export type MutationUpdateOneInformCampaignEnrollmentArgs = {
  data: InformCampaignEnrollmentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignEnrollmentWhereUniqueInput;
};


export type MutationUpdateOneInformCampaignEnrollmentCanonicalServiceArgs = {
  data: InformCampaignEnrollmentCanonicalServiceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignEnrollmentCanonicalServiceWhereUniqueInput;
};


export type MutationUpdateOneInformCampaignExecutionArgs = {
  data: InformCampaignExecutionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignExecutionWhereUniqueInput;
};


export type MutationUpdateOneInformCampaignGroupArgs = {
  data: InformCampaignGroupUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignGroupWhereUniqueInput;
};


export type MutationUpdateOneInformCommunicationOptOutArgs = {
  data: InformCommunicationOptOutUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCommunicationOptOutWhereUniqueInput;
};


export type MutationUpdateOneInformControlGroupParticipantArgs = {
  data: InformControlGroupParticipantUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformControlGroupParticipantWhereUniqueInput;
};


export type MutationUpdateOneInformEmailTemplateArgs = {
  data: InformEmailTemplateUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformEmailTemplateWhereUniqueInput;
};


export type MutationUpdateOneInformEntityHistoryArgs = {
  data: InformEntityHistoryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformEntityHistoryWhereUniqueInput;
};


export type MutationUpdateOneInformEventDrivenCampaignArgs = {
  data: InformEventDrivenCampaignUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformEventDrivenCampaignWhereUniqueInput;
};


export type MutationUpdateOneInformEventListenerArgs = {
  data: InformEventListenerUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformEventListenerWhereUniqueInput;
};


export type MutationUpdateOneInformNotificationRecipientArgs = {
  data: InformNotificationRecipientUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformNotificationRecipientWhereUniqueInput;
};


export type MutationUpdateOneInformPartnerArgs = {
  data: InformPartnerUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerWhereUniqueInput;
};


export type MutationUpdateOneInformPartnerCustomerArgs = {
  data: InformPartnerCustomerUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerCustomerWhereUniqueInput;
};


export type MutationUpdateOneInformPartnerCustomerPharmacyProviderArgs = {
  data: InformPartnerCustomerPharmacyProviderUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerCustomerPharmacyProviderWhereUniqueInput;
};


export type MutationUpdateOneInformPartnerIntegrationArgs = {
  data: InformPartnerIntegrationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerIntegrationWhereUniqueInput;
};


export type MutationUpdateOneInformPartnerIntegrationModelArgs = {
  data: InformPartnerIntegrationModelUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerIntegrationModelWhereUniqueInput;
};


export type MutationUpdateOneInformPartnerProgramArgs = {
  data: InformPartnerProgramUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerProgramWhereUniqueInput;
};


export type MutationUpdateOneInformPartnerProgramEnrollmentArgs = {
  data: InformPartnerProgramEnrollmentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};


export type MutationUpdateOneInformPartnerUserArgs = {
  data: InformPartnerUserUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerUserWhereUniqueInput;
};


export type MutationUpdateOneInformPartnerUserRoleArgs = {
  data: InformPartnerUserRoleUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerUserRoleWhereUniqueInput;
};


export type MutationUpdateOneInformScheduledCampaignArgs = {
  data: InformScheduledCampaignUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformScheduledCampaignWhereUniqueInput;
};


export type MutationUpdateOneInformSessionArgs = {
  data: InformSessionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformSessionWhereUniqueInput;
};


export type MutationUpdateOneInformSessionEventArgs = {
  data: InformSessionEventUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformSessionEventWhereUniqueInput;
};


export type MutationUpdateOneInstinctIntegrationArgs = {
  data: InstinctIntegrationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InstinctIntegrationWhereUniqueInput;
};


export type MutationUpdateOneInsuranceIntegrationArgs = {
  data: InsuranceIntegrationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InsuranceIntegrationWhereUniqueInput;
};


export type MutationUpdateOneIntegrationOutageHistoryEntryArgs = {
  data: IntegrationOutageHistoryEntryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: IntegrationOutageHistoryEntryWhereUniqueInput;
};


export type MutationUpdateOneInterchangeRateArgs = {
  data: InterchangeRateUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InterchangeRateWhereUniqueInput;
};


export type MutationUpdateOneInvoiceArgs = {
  data: InvoiceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InvoiceWhereUniqueInput;
};


export type MutationUpdateOneInvoiceLineItemArgs = {
  data: InvoiceLineItemUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InvoiceLineItemWhereUniqueInput;
};


export type MutationUpdateOneInvoicePimsWritebackLogEntryArgs = {
  data: InvoicePimsWritebackLogEntryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InvoicePimsWritebackLogEntryWhereUniqueInput;
};


export type MutationUpdateOneLabPanelArgs = {
  data: LabPanelUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LabPanelWhereUniqueInput;
};


export type MutationUpdateOneLabResultArgs = {
  data: LabResultUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LabResultWhereUniqueInput;
};


export type MutationUpdateOneLapsedPetParentTriggersArgs = {
  data: LapsedPetParentTriggersUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LapsedPetParentTriggersWhereUniqueInput;
};


export type MutationUpdateOneLegalEntityArgs = {
  data: LegalEntityUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LegalEntityWhereUniqueInput;
};


export type MutationUpdateOneLoyaltyAccountArgs = {
  data: LoyaltyAccountUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyAccountWhereUniqueInput;
};


export type MutationUpdateOneLoyaltyAccountHolderArgs = {
  data: LoyaltyAccountHolderUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyAccountHolderWhereUniqueInput;
};


export type MutationUpdateOneLoyaltyAccountMergerArgs = {
  data: LoyaltyAccountMergerUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyAccountMergerWhereUniqueInput;
};


export type MutationUpdateOneLoyaltyInvoicePointGranterArgs = {
  data: LoyaltyInvoicePointGranterUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyInvoicePointGranterWhereUniqueInput;
};


export type MutationUpdateOneLoyaltyPointGrantingServiceArgs = {
  data: LoyaltyPointGrantingServiceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyPointGrantingServiceWhereUniqueInput;
};


export type MutationUpdateOneLoyaltyPointGrantingServiceCategoryArgs = {
  data: LoyaltyPointGrantingServiceCategoryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyPointGrantingServiceCategoryWhereUniqueInput;
};


export type MutationUpdateOneLoyaltyPointUserGrantArgs = {
  data: LoyaltyPointUserGrantUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyPointUserGrantWhereUniqueInput;
};


export type MutationUpdateOneLoyaltyProgramArgs = {
  data: LoyaltyProgramUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyProgramWhereUniqueInput;
};


export type MutationUpdateOneLoyaltyRewardArgs = {
  data: LoyaltyRewardUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyRewardWhereUniqueInput;
};


export type MutationUpdateOneLoyaltyRewardRedemptionArgs = {
  data: LoyaltyRewardRedemptionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyRewardRedemptionWhereUniqueInput;
};


export type MutationUpdateOneMassTextAlertArgs = {
  data: MassTextAlertUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MassTextAlertWhereUniqueInput;
};


export type MutationUpdateOneMassTextAlertEntryArgs = {
  data: MassTextAlertEntryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MassTextAlertEntryWhereUniqueInput;
};


export type MutationUpdateOneMassTextAlertEntryAppointmentArgs = {
  data: MassTextAlertEntryAppointmentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MassTextAlertEntryAppointmentWhereUniqueInput;
};


export type MutationUpdateOneMediaArgs = {
  data: MediaUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MediaWhereUniqueInput;
};


export type MutationUpdateOneMedicalHistoryArgs = {
  data: MedicalHistoryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MedicalHistoryWhereUniqueInput;
};


export type MutationUpdateOneMessageTemplateArgs = {
  data: MessageTemplateUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MessageTemplateWhereUniqueInput;
};


export type MutationUpdateOneMessagingCampaignArgs = {
  data: MessagingCampaignUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MessagingCampaignWhereUniqueInput;
};


export type MutationUpdateOneMessagingPartnerArgs = {
  data: MessagingPartnerUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MessagingPartnerWhereUniqueInput;
};


export type MutationUpdateOneModuleArgs = {
  data: ModuleUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ModuleWhereUniqueInput;
};


export type MutationUpdateOneNonPrismaSchemaScriptRanArgs = {
  data: NonPrismaSchemaScriptRanUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: NonPrismaSchemaScriptRanWhereUniqueInput;
};


export type MutationUpdateOneNotificationEventToMessageArgs = {
  data: NotificationEventToMessageUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: NotificationEventToMessageWhereUniqueInput;
};


export type MutationUpdateOneOrganizationArgs = {
  data: OrganizationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationWhereUniqueInput;
};


export type MutationUpdateOneOrganizationCareBenefitToClinicServiceArgs = {
  data: OrganizationCareBenefitToClinicServiceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationCareBenefitToClinicServiceWhereUniqueInput;
};


export type MutationUpdateOneOrganizationCareBenefitToClinicServiceCategoryArgs = {
  data: OrganizationCareBenefitToClinicServiceCategoryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput;
};


export type MutationUpdateOneOrganizationPetArgs = {
  data: OrganizationPetUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationPetWhereUniqueInput;
};


export type MutationUpdateOneOrganizationPetParentArgs = {
  data: OrganizationPetParentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationPetParentWhereUniqueInput;
};


export type MutationUpdateOneOrganizationPetToOrganizationPetParentArgs = {
  data: OrganizationPetToOrganizationPetParentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationPetToOrganizationPetParentWhereUniqueInput;
};


export type MutationUpdateOnePpcIntegrationArgs = {
  data: PpcIntegrationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PpcIntegrationWhereUniqueInput;
};


export type MutationUpdateOnePaymentsReportTransactionArgs = {
  data: PaymentsReportTransactionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PaymentsReportTransactionWhereUniqueInput;
};


export type MutationUpdateOnePayoutBatchingPeriodArgs = {
  data: PayoutBatchingPeriodUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PayoutBatchingPeriodWhereUniqueInput;
};


export type MutationUpdateOnePayoutBatchingScheduleArgs = {
  data: PayoutBatchingScheduleUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PayoutBatchingScheduleWhereUniqueInput;
};


export type MutationUpdateOnePayoutBatchingSettingArgs = {
  data: PayoutBatchingSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PayoutBatchingSettingWhereUniqueInput;
};


export type MutationUpdateOnePermissionArgs = {
  data: PermissionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PermissionWhereUniqueInput;
};


export type MutationUpdateOnePetParentSettingArgs = {
  data: PetParentSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PetParentSettingWhereUniqueInput;
};


export type MutationUpdateOnePetPortalSettingArgs = {
  data: PetPortalSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PetPortalSettingWhereUniqueInput;
};


export type MutationUpdateOnePhoneNumberLookupRequestArgs = {
  data: PhoneNumberLookupRequestUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PhoneNumberLookupRequestWhereUniqueInput;
};


export type MutationUpdateOnePhoneNumberLookupResultArgs = {
  data: PhoneNumberLookupResultUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PhoneNumberLookupResultWhereUniqueInput;
};


export type MutationUpdateOnePimsInvoiceArgs = {
  data: PimsInvoiceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PimsInvoiceWhereUniqueInput;
};


export type MutationUpdateOnePimsInvoiceLineItemArgs = {
  data: PimsInvoiceLineItemUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PimsInvoiceLineItemWhereUniqueInput;
};


export type MutationUpdateOnePimsWritebackLogEntryArgs = {
  data: PimsWritebackLogEntryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PimsWritebackLogEntryWhereUniqueInput;
};


export type MutationUpdateOnePrescriptionArgs = {
  data: PrescriptionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PrescriptionWhereUniqueInput;
};


export type MutationUpdateOneProductArgs = {
  data: ProductUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ProductWhereUniqueInput;
};


export type MutationUpdateOneProductPackageArgs = {
  data: ProductPackageUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ProductPackageWhereUniqueInput;
};


export type MutationUpdateOneProductPackageSubscriptionArgs = {
  data: ProductPackageSubscriptionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ProductPackageSubscriptionWhereUniqueInput;
};


export type MutationUpdateOneProviderAppointmentTypeRoomMapArgs = {
  data: ProviderAppointmentTypeRoomMapUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};


export type MutationUpdateOnePushNotificationLogArgs = {
  data: PushNotificationLogUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PushNotificationLogWhereUniqueInput;
};


export type MutationUpdateOneRecapArgs = {
  data: RecapUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: RecapWhereUniqueInput;
};


export type MutationUpdateOneRulesArgs = {
  data: RulesUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: RulesWhereUniqueInput;
};


export type MutationUpdateOneSegmentArgs = {
  data: SegmentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SegmentWhereUniqueInput;
};


export type MutationUpdateOneSentTrupanionExamDayOfferArgs = {
  data: SentTrupanionExamDayOfferUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};


export type MutationUpdateOneServiceArgs = {
  data: ServiceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceWhereUniqueInput;
};


export type MutationUpdateOneServiceCategoryArgs = {
  data: ServiceCategoryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceCategoryWhereUniqueInput;
};


export type MutationUpdateOneServicePurchaseSummaryArgs = {
  data: ServicePurchaseSummaryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServicePurchaseSummaryWhereUniqueInput;
};


export type MutationUpdateOneServiceReminderArgs = {
  data: ServiceReminderUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceReminderWhereUniqueInput;
};


export type MutationUpdateOneServiceReminderNotificationArgs = {
  data: ServiceReminderNotificationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceReminderNotificationWhereUniqueInput;
};


export type MutationUpdateOneServiceReminderTimingArgs = {
  data: ServiceReminderTimingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceReminderTimingWhereUniqueInput;
};


export type MutationUpdateOneSexArgs = {
  data: SexUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SexWhereUniqueInput;
};


export type MutationUpdateOneSmsNotificationStatusArgs = {
  data: SmsNotificationStatusUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SmsNotificationStatusWhereUniqueInput;
};


export type MutationUpdateOneSpeciesArgs = {
  data: SpeciesUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SpeciesWhereUniqueInput;
};


export type MutationUpdateOneStaffRoleArgs = {
  data: StaffRoleUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StaffRoleWhereUniqueInput;
};


export type MutationUpdateOneStripeCustomerArgs = {
  data: StripeCustomerUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeCustomerWhereUniqueInput;
};


export type MutationUpdateOneStripeDisputeArgs = {
  data: StripeDisputeUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeDisputeWhereUniqueInput;
};


export type MutationUpdateOneStripeInvoiceArgs = {
  data: StripeInvoiceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeInvoiceWhereUniqueInput;
};


export type MutationUpdateOneStripeInvoiceItemArgs = {
  data: StripeInvoiceItemUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeInvoiceItemWhereUniqueInput;
};


export type MutationUpdateOneStripePaymentIntentArgs = {
  data: StripePaymentIntentUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripePaymentIntentWhereUniqueInput;
};


export type MutationUpdateOneStripePaymentMethodArgs = {
  data: StripePaymentMethodUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripePaymentMethodWhereUniqueInput;
};


export type MutationUpdateOneStripePayoutArgs = {
  data: StripePayoutUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripePayoutWhereUniqueInput;
};


export type MutationUpdateOneStripePayoutAccountArgs = {
  data: StripePayoutAccountUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripePayoutAccountWhereUniqueInput;
};


export type MutationUpdateOneStripeReceiptArgs = {
  data: StripeReceiptUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeReceiptWhereUniqueInput;
};


export type MutationUpdateOneStripeReceiptHistoryArgs = {
  data: StripeReceiptHistoryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeReceiptHistoryWhereUniqueInput;
};


export type MutationUpdateOneStripeRefundArgs = {
  data: StripeRefundUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeRefundWhereUniqueInput;
};


export type MutationUpdateOneStripeTerminalArgs = {
  data: StripeTerminalUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeTerminalWhereUniqueInput;
};


export type MutationUpdateOneStripeTerminalLocationArgs = {
  data: StripeTerminalLocationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeTerminalLocationWhereUniqueInput;
};


export type MutationUpdateOneSurveyAppointmentTypeSettingArgs = {
  data: SurveyAppointmentTypeSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SurveyAppointmentTypeSettingWhereUniqueInput;
};


export type MutationUpdateOneSurveyResultArgs = {
  data: SurveyResultUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SurveyResultWhereUniqueInput;
};


export type MutationUpdateOneSurveySettingArgs = {
  data: SurveySettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SurveySettingWhereUniqueInput;
};


export type MutationUpdateOneSyncVetIntegrationArgs = {
  data: SyncVetIntegrationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SyncVetIntegrationWhereUniqueInput;
};


export type MutationUpdateOneSyncVetServiceArgs = {
  data: SyncVetServiceUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SyncVetServiceWhereUniqueInput;
};


export type MutationUpdateOneSynchronyClinicConfigurationArgs = {
  data: SynchronyClinicConfigurationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SynchronyClinicConfigurationWhereUniqueInput;
};


export type MutationUpdateOneSynchronyEventArgs = {
  data: SynchronyEventUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SynchronyEventWhereUniqueInput;
};


export type MutationUpdateOneTaskArgs = {
  data: TaskUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TaskWhereUniqueInput;
};


export type MutationUpdateOneTaxonomyArgs = {
  data: TaxonomyUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TaxonomyWhereUniqueInput;
};


export type MutationUpdateOneTaxonomyToInformAudienceDefinitionArgs = {
  data: TaxonomyToInformAudienceDefinitionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TaxonomyToInformAudienceDefinitionWhereUniqueInput;
};


export type MutationUpdateOneTransactionArgs = {
  data: TransactionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TransactionWhereUniqueInput;
};


export type MutationUpdateOneTrupanionCertificateAvailabilityArgs = {
  data: TrupanionCertificateAvailabilityUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TrupanionCertificateAvailabilityWhereUniqueInput;
};


export type MutationUpdateOneTrupanionIntegratedAppointmentTypeArgs = {
  data: TrupanionIntegratedAppointmentTypeUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TrupanionIntegratedAppointmentTypeWhereUniqueInput;
};


export type MutationUpdateOneTrupanionIntegrationArgs = {
  data: TrupanionIntegrationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TrupanionIntegrationWhereUniqueInput;
};


export type MutationUpdateOneUserArgs = {
  data: UserUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserWhereUniqueInput;
};


export type MutationUpdateOneUserAppointmentGroupingArgs = {
  data: UserAppointmentGroupingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserAppointmentGroupingWhereUniqueInput;
};


export type MutationUpdateOneUserBoardFilterArgs = {
  data: UserBoardFilterUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserBoardFilterWhereUniqueInput;
};


export type MutationUpdateOneUserChannelFilterSelectionArgs = {
  data: UserChannelFilterSelectionUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserChannelFilterSelectionWhereUniqueInput;
};


export type MutationUpdateOneUserNotificationSettingArgs = {
  data: UserNotificationSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserNotificationSettingWhereUniqueInput;
};


export type MutationUpdateOneUserSettingArgs = {
  data: UserSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserSettingWhereUniqueInput;
};


export type MutationUpdateOneUserTaskListArgs = {
  data: UserTaskListUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserTaskListWhereUniqueInput;
};


export type MutationUpdateOneUserTaskListFilterArgs = {
  data: UserTaskListFilterUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserTaskListFilterWhereUniqueInput;
};


export type MutationUpdateOneVaccinationArgs = {
  data: VaccinationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VaccinationWhereUniqueInput;
};


export type MutationUpdateOneVetAvailabilityArgs = {
  data: VetAvailabilityUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetAvailabilityWhereUniqueInput;
};


export type MutationUpdateOneVetAvailabilityClinicRoomMapArgs = {
  data: VetAvailabilityClinicRoomMapUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetAvailabilityClinicRoomMapWhereUniqueInput;
};


export type MutationUpdateOneVetAvailabilityMapArgs = {
  data: VetAvailabilityMapUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetAvailabilityMapWhereUniqueInput;
};


export type MutationUpdateOneVetInfoArgs = {
  data: VetInfoUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetInfoWhereUniqueInput;
};


export type MutationUpdateOneVetsourceCodeTagArgs = {
  data: VetsourceCodeTagUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetsourceCodeTagWhereUniqueInput;
};


export type MutationUpdateOneVetsourceInstallationArgs = {
  data: VetsourceInstallationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetsourceInstallationWhereUniqueInput;
};


export type MutationUpdateOneVetsourcePharmacyIntegrationArgs = {
  data: VetsourcePharmacyIntegrationUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetsourcePharmacyIntegrationWhereUniqueInput;
};


export type MutationUpdateOneVetsourceRevenueCategoryArgs = {
  data: VetsourceRevenueCategoryUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetsourceRevenueCategoryWhereUniqueInput;
};


export type MutationUpdateOneWorkflowEventSettingArgs = {
  data: WorkflowEventSettingUpdateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: WorkflowEventSettingWhereUniqueInput;
};


export type MutationUpdatePayoutBatchingSettingArgs = {
  data: UpdatePayoutBatchingSettingInput;
};


export type MutationUpdatePetParentPaymentIntentArgs = {
  data: StripeUpdatePaymentInput;
};


export type MutationUpdateStripePaymentArgs = {
  data: StripeUpdatePaymentInput;
};


export type MutationUpdateTeamChannel2Args = {
  data: ChannelUpdateInput;
  where: ChannelWhereUniqueInput;
};


export type MutationUpdateTerminalAppPaymentIntentArgs = {
  data: StripeUpdatePaymentInput;
};


export type MutationUploadEmailCampaignCustomListArgs = {
  data: UploadEmailCampaignCustomListInput;
};


export type MutationUpsertOneActiveIngredientArgs = {
  create: ActiveIngredientCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ActiveIngredientUpdateInput;
  where: ActiveIngredientWhereUniqueInput;
};


export type MutationUpsertOneAppointmentArgs = {
  create: AppointmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: AppointmentUpdateInput;
  where: AppointmentWhereUniqueInput;
};


export type MutationUpsertOneAppointmentAvailabilityArgs = {
  create: AppointmentAvailabilityCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: AppointmentAvailabilityUpdateInput;
  where: AppointmentAvailabilityWhereUniqueInput;
};


export type MutationUpsertOneAppointmentNoteTemplateArgs = {
  create: AppointmentNoteTemplateCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: AppointmentNoteTemplateUpdateInput;
  where: AppointmentNoteTemplateWhereUniqueInput;
};


export type MutationUpsertOneAppointmentTypeArgs = {
  create: AppointmentTypeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: AppointmentTypeUpdateInput;
  where: AppointmentTypeWhereUniqueInput;
};


export type MutationUpsertOneAutomationRunArgs = {
  create: AutomationRunCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: AutomationRunUpdateInput;
  where: AutomationRunWhereUniqueInput;
};


export type MutationUpsertOneAutomationRunActionArgs = {
  create: AutomationRunActionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: AutomationRunActionUpdateInput;
  where: AutomationRunActionWhereUniqueInput;
};


export type MutationUpsertOneAxionClinicConfigurationArgs = {
  create: AxionClinicConfigurationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: AxionClinicConfigurationUpdateInput;
  where: AxionClinicConfigurationWhereUniqueInput;
};


export type MutationUpsertOneAxionClinicUserConfigurationArgs = {
  create: AxionClinicUserConfigurationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: AxionClinicUserConfigurationUpdateInput;
  where: AxionClinicUserConfigurationWhereUniqueInput;
};


export type MutationUpsertOneBedrockInferenceArgs = {
  create: BedrockInferenceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: BedrockInferenceUpdateInput;
  where: BedrockInferenceWhereUniqueInput;
};


export type MutationUpsertOneBitwerxHealthcheckArgs = {
  create: BitwerxHealthcheckCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: BitwerxHealthcheckUpdateInput;
  where: BitwerxHealthcheckWhereUniqueInput;
};


export type MutationUpsertOneBitwerxIntegrationArgs = {
  create: BitwerxIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: BitwerxIntegrationUpdateInput;
  where: BitwerxIntegrationWhereUniqueInput;
};


export type MutationUpsertOneBitwerxPaymentHealthcheckResultArgs = {
  create: BitwerxPaymentHealthcheckResultCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: BitwerxPaymentHealthcheckResultUpdateInput;
  where: BitwerxPaymentHealthcheckResultWhereUniqueInput;
};


export type MutationUpsertOneBitwerxPaymentHealthcheckRunArgs = {
  create: BitwerxPaymentHealthcheckRunCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: BitwerxPaymentHealthcheckRunUpdateInput;
  where: BitwerxPaymentHealthcheckRunWhereUniqueInput;
};


export type MutationUpsertOneBitwerxPaymentWritebackConfigurationArgs = {
  create: BitwerxPaymentWritebackConfigurationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: BitwerxPaymentWritebackConfigurationUpdateInput;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};


export type MutationUpsertOneBoardFilterColumnArgs = {
  create: BoardFilterColumnCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: BoardFilterColumnUpdateInput;
  where: BoardFilterColumnWhereUniqueInput;
};


export type MutationUpsertOneBoardFilterSpecificDateRangeArgs = {
  create: BoardFilterSpecificDateRangeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: BoardFilterSpecificDateRangeUpdateInput;
  where: BoardFilterSpecificDateRangeWhereUniqueInput;
};


export type MutationUpsertOneBoehringerIngelheimCustomerAlignmentArgs = {
  create: BoehringerIngelheimCustomerAlignmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: BoehringerIngelheimCustomerAlignmentUpdateInput;
  where: BoehringerIngelheimCustomerAlignmentWhereUniqueInput;
};


export type MutationUpsertOneBoehringerIngelheimTerritoryArgs = {
  create: BoehringerIngelheimTerritoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: BoehringerIngelheimTerritoryUpdateInput;
  where: BoehringerIngelheimTerritoryWhereUniqueInput;
};


export type MutationUpsertOneBreedArgs = {
  create: BreedCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: BreedUpdateInput;
  where: BreedWhereUniqueInput;
};


export type MutationUpsertOneCallHistoryArgs = {
  create: CallHistoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CallHistoryUpdateInput;
  where: CallHistoryWhereUniqueInput;
};


export type MutationUpsertOneCallParticipantArgs = {
  create: CallParticipantCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CallParticipantUpdateInput;
  where: CallParticipantWhereUniqueInput;
};


export type MutationUpsertOneCampaignRegistryCampaignArgs = {
  create: CampaignRegistryCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CampaignRegistryCampaignUpdateInput;
  where: CampaignRegistryCampaignWhereUniqueInput;
};


export type MutationUpsertOneCanonicalBreedArgs = {
  create: CanonicalBreedCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CanonicalBreedUpdateInput;
  where: CanonicalBreedWhereUniqueInput;
};


export type MutationUpsertOneCanonicalCanineBreedProfileArgs = {
  create: CanonicalCanineBreedProfileCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CanonicalCanineBreedProfileUpdateInput;
  where: CanonicalCanineBreedProfileWhereUniqueInput;
};


export type MutationUpsertOneCanonicalServiceArgs = {
  create: CanonicalServiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CanonicalServiceUpdateInput;
  where: CanonicalServiceWhereUniqueInput;
};


export type MutationUpsertOneCanonicalSpeciesArgs = {
  create: CanonicalSpeciesCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CanonicalSpeciesUpdateInput;
  where: CanonicalSpeciesWhereUniqueInput;
};


export type MutationUpsertOneCareAddonEnrollmentArgs = {
  create: CareAddonEnrollmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareAddonEnrollmentUpdateInput;
  where: CareAddonEnrollmentWhereUniqueInput;
};


export type MutationUpsertOneCareAddonPackageArgs = {
  create: CareAddonPackageCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareAddonPackageUpdateInput;
  where: CareAddonPackageWhereUniqueInput;
};


export type MutationUpsertOneCareAddonPackageBenefitArgs = {
  create: CareAddonPackageBenefitCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareAddonPackageBenefitUpdateInput;
  where: CareAddonPackageBenefitWhereUniqueInput;
};


export type MutationUpsertOneCareAuthorizationRequestArgs = {
  create: CareAuthorizationRequestCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareAuthorizationRequestUpdateInput;
  where: CareAuthorizationRequestWhereUniqueInput;
};


export type MutationUpsertOneCareBenefitArgs = {
  create: CareBenefitCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareBenefitUpdateInput;
  where: CareBenefitWhereUniqueInput;
};


export type MutationUpsertOneCareBenefitUsageArgs = {
  create: CareBenefitUsageCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareBenefitUsageUpdateInput;
  where: CareBenefitUsageWhereUniqueInput;
};


export type MutationUpsertOneCareBenefitUsageFollowupArgs = {
  create: CareBenefitUsageFollowupCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareBenefitUsageFollowupUpdateInput;
  where: CareBenefitUsageFollowupWhereUniqueInput;
};


export type MutationUpsertOneCareBenefitUsageFollowupStepArgs = {
  create: CareBenefitUsageFollowupStepCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareBenefitUsageFollowupStepUpdateInput;
  where: CareBenefitUsageFollowupStepWhereUniqueInput;
};


export type MutationUpsertOneCareBenefitUsageToInvoiceLineItemArgs = {
  create: CareBenefitUsageToInvoiceLineItemCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareBenefitUsageToInvoiceLineItemUpdateInput;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};


export type MutationUpsertOneCareCreditPreapprovalCheckArgs = {
  create: CareCreditPreapprovalCheckCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareCreditPreapprovalCheckUpdateInput;
  where: CareCreditPreapprovalCheckWhereUniqueInput;
};


export type MutationUpsertOneCareEnrollmentPaymentArgs = {
  create: CareEnrollmentPaymentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareEnrollmentPaymentUpdateInput;
  where: CareEnrollmentPaymentWhereUniqueInput;
};


export type MutationUpsertOneCareEnrollmentToStripeInvoiceItemArgs = {
  create: CareEnrollmentToStripeInvoiceItemCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareEnrollmentToStripeInvoiceItemUpdateInput;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};


export type MutationUpsertOneCareLapsedPaymentArgs = {
  create: CareLapsedPaymentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareLapsedPaymentUpdateInput;
  where: CareLapsedPaymentWhereUniqueInput;
};


export type MutationUpsertOneCarePlanArgs = {
  create: CarePlanCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CarePlanUpdateInput;
  where: CarePlanWhereUniqueInput;
};


export type MutationUpsertOneCarePlanBenefitArgs = {
  create: CarePlanBenefitCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CarePlanBenefitUpdateInput;
  where: CarePlanBenefitWhereUniqueInput;
};


export type MutationUpsertOneCarePlanBenefitEnrollmentCarryoverArgs = {
  create: CarePlanBenefitEnrollmentCarryoverCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CarePlanBenefitEnrollmentCarryoverUpdateInput;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};


export type MutationUpsertOneCarePlanEnrollmentArgs = {
  create: CarePlanEnrollmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CarePlanEnrollmentUpdateInput;
  where: CarePlanEnrollmentWhereUniqueInput;
};


export type MutationUpsertOneCarePlanPricingArgs = {
  create: CarePlanPricingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CarePlanPricingUpdateInput;
  where: CarePlanPricingWhereUniqueInput;
};


export type MutationUpsertOneCarePlanProviderGroupArgs = {
  create: CarePlanProviderGroupCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CarePlanProviderGroupUpdateInput;
  where: CarePlanProviderGroupWhereUniqueInput;
};


export type MutationUpsertOneCareStripeSubscriptionArgs = {
  create: CareStripeSubscriptionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareStripeSubscriptionUpdateInput;
  where: CareStripeSubscriptionWhereUniqueInput;
};


export type MutationUpsertOneCareSubscriptionTrueUpArgs = {
  create: CareSubscriptionTrueUpCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareSubscriptionTrueUpUpdateInput;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};


export type MutationUpsertOneCareSubscriptionTrueUpLogEntryArgs = {
  create: CareSubscriptionTrueUpLogEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CareSubscriptionTrueUpLogEntryUpdateInput;
  where: CareSubscriptionTrueUpLogEntryWhereUniqueInput;
};


export type MutationUpsertOneChannelArgs = {
  create: ChannelCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelUpdateInput;
  where: ChannelWhereUniqueInput;
};


export type MutationUpsertOneChannelAutomationStatusArgs = {
  create: ChannelAutomationStatusCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelAutomationStatusUpdateInput;
  where: ChannelAutomationStatusWhereUniqueInput;
};


export type MutationUpsertOneChannelCreationSourceArgs = {
  create: ChannelCreationSourceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelCreationSourceUpdateInput;
  where: ChannelCreationSourceWhereUniqueInput;
};


export type MutationUpsertOneChannelFilterSelectionArgs = {
  create: ChannelFilterSelectionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelFilterSelectionUpdateInput;
  where: ChannelFilterSelectionWhereUniqueInput;
};


export type MutationUpsertOneChannelMemberArgs = {
  create: ChannelMemberCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelMemberUpdateInput;
  where: ChannelMemberWhereUniqueInput;
};


export type MutationUpsertOneChannelMessageArgs = {
  create: ChannelMessageCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelMessageUpdateInput;
  where: ChannelMessageWhereUniqueInput;
};


export type MutationUpsertOneChannelMessageAttachmentArgs = {
  create: ChannelMessageAttachmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelMessageAttachmentUpdateInput;
  where: ChannelMessageAttachmentWhereUniqueInput;
};


export type MutationUpsertOneChannelMessageAutoResponseArgs = {
  create: ChannelMessageAutoResponseCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelMessageAutoResponseUpdateInput;
  where: ChannelMessageAutoResponseWhereUniqueInput;
};


export type MutationUpsertOneChannelMessageReactionArgs = {
  create: ChannelMessageReactionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelMessageReactionUpdateInput;
  where: ChannelMessageReactionWhereUniqueInput;
};


export type MutationUpsertOneChannelPinArgs = {
  create: ChannelPinCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelPinUpdateInput;
  where: ChannelPinWhereUniqueInput;
};


export type MutationUpsertOneChannelSelectionArgs = {
  create: ChannelSelectionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelSelectionUpdateInput;
  where: ChannelSelectionWhereUniqueInput;
};


export type MutationUpsertOneChannelStatusArgs = {
  create: ChannelStatusCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelStatusUpdateInput;
  where: ChannelStatusWhereUniqueInput;
};


export type MutationUpsertOneChannelStatusChannelAssigneeArgs = {
  create: ChannelStatusChannelAssigneeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChannelStatusChannelAssigneeUpdateInput;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};


export type MutationUpsertOneChemicalCompoundArgs = {
  create: ChemicalCompoundCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ChemicalCompoundUpdateInput;
  where: ChemicalCompoundWhereUniqueInput;
};


export type MutationUpsertOneClientConnectIntegrationArgs = {
  create: ClientConnectIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClientConnectIntegrationUpdateInput;
  where: ClientConnectIntegrationWhereUniqueInput;
};


export type MutationUpsertOneClinicArgs = {
  create: ClinicCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicUpdateInput;
  where: ClinicWhereUniqueInput;
};


export type MutationUpsertOneClinicBlockedPhoneNumberArgs = {
  create: ClinicBlockedPhoneNumberCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicBlockedPhoneNumberUpdateInput;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};


export type MutationUpsertOneClinicCustomPayoutsSetupArgs = {
  create: ClinicCustomPayoutsSetupCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicCustomPayoutsSetupUpdateInput;
  where: ClinicCustomPayoutsSetupWhereUniqueInput;
};


export type MutationUpsertOneClinicDirectBookingSettingArgs = {
  create: ClinicDirectBookingSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicDirectBookingSettingUpdateInput;
  where: ClinicDirectBookingSettingWhereUniqueInput;
};


export type MutationUpsertOneClinicEmailCampaignSettingArgs = {
  create: ClinicEmailCampaignSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicEmailCampaignSettingUpdateInput;
  where: ClinicEmailCampaignSettingWhereUniqueInput;
};


export type MutationUpsertOneClinicEmployeeArgs = {
  create: ClinicEmployeeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicEmployeeUpdateInput;
  where: ClinicEmployeeWhereUniqueInput;
};


export type MutationUpsertOneClinicEmployeeAppointmentTypeSettingArgs = {
  create: ClinicEmployeeAppointmentTypeSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicEmployeeAppointmentTypeSettingUpdateInput;
  where: ClinicEmployeeAppointmentTypeSettingWhereUniqueInput;
};


export type MutationUpsertOneClinicEntityPhoneNumberArgs = {
  create: ClinicEntityPhoneNumberCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicEntityPhoneNumberUpdateInput;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};


export type MutationUpsertOneClinicModuleArgs = {
  create: ClinicModuleCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicModuleUpdateInput;
  where: ClinicModuleWhereUniqueInput;
};


export type MutationUpsertOneClinicOfficeHourArgs = {
  create: ClinicOfficeHourCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicOfficeHourUpdateInput;
  where: ClinicOfficeHourWhereUniqueInput;
};


export type MutationUpsertOneClinicOnboardingArgs = {
  create: ClinicOnboardingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicOnboardingUpdateInput;
  where: ClinicOnboardingWhereUniqueInput;
};


export type MutationUpsertOneClinicPaymentFeeConfigurationArgs = {
  create: ClinicPaymentFeeConfigurationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPaymentFeeConfigurationUpdateInput;
  where: ClinicPaymentFeeConfigurationWhereUniqueInput;
};


export type MutationUpsertOneClinicPetArgs = {
  create: ClinicPetCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPetUpdateInput;
  where: ClinicPetWhereUniqueInput;
};


export type MutationUpsertOneClinicPetAlertArgs = {
  create: ClinicPetAlertCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPetAlertUpdateInput;
  where: ClinicPetAlertWhereUniqueInput;
};


export type MutationUpsertOneClinicPetCustomFieldValueArgs = {
  create: ClinicPetCustomFieldValueCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPetCustomFieldValueUpdateInput;
  where: ClinicPetCustomFieldValueWhereUniqueInput;
};


export type MutationUpsertOneClinicPetParentArgs = {
  create: ClinicPetParentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPetParentUpdateInput;
  where: ClinicPetParentWhereUniqueInput;
};


export type MutationUpsertOneClinicPetParentAddressArgs = {
  create: ClinicPetParentAddressCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPetParentAddressUpdateInput;
  where: ClinicPetParentAddressWhereUniqueInput;
};


export type MutationUpsertOneClinicPetParentCustomFieldValueArgs = {
  create: ClinicPetParentCustomFieldValueCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPetParentCustomFieldValueUpdateInput;
  where: ClinicPetParentCustomFieldValueWhereUniqueInput;
};


export type MutationUpsertOneClinicPetParentDeviceArgs = {
  create: ClinicPetParentDeviceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPetParentDeviceUpdateInput;
  where: ClinicPetParentDeviceWhereUniqueInput;
};


export type MutationUpsertOneClinicPetParentPimsSyncStatusArgs = {
  create: ClinicPetParentPimsSyncStatusCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPetParentPimsSyncStatusUpdateInput;
  where: ClinicPetParentPimsSyncStatusWhereUniqueInput;
};


export type MutationUpsertOneClinicPetPimsSyncStatusArgs = {
  create: ClinicPetPimsSyncStatusCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPetPimsSyncStatusUpdateInput;
  where: ClinicPetPimsSyncStatusWhereUniqueInput;
};


export type MutationUpsertOneClinicPhoneNumberArgs = {
  create: ClinicPhoneNumberCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPhoneNumberUpdateInput;
  where: ClinicPhoneNumberWhereUniqueInput;
};


export type MutationUpsertOneClinicPimsIntegrationArgs = {
  create: ClinicPimsIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPimsIntegrationUpdateInput;
  where: ClinicPimsIntegrationWhereUniqueInput;
};


export type MutationUpsertOneClinicPimsIntegrationCapabilityArgs = {
  create: ClinicPimsIntegrationCapabilityCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPimsIntegrationCapabilityUpdateInput;
  where: ClinicPimsIntegrationCapabilityWhereUniqueInput;
};


export type MutationUpsertOneClinicPimsIntegrationCapabilityHistoryEntryArgs = {
  create: ClinicPimsIntegrationCapabilityHistoryEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPimsIntegrationCapabilityHistoryEntryUpdateInput;
  where: ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput;
};


export type MutationUpsertOneClinicPostcardSettingArgs = {
  create: ClinicPostcardSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicPostcardSettingUpdateInput;
  where: ClinicPostcardSettingWhereUniqueInput;
};


export type MutationUpsertOneClinicRoomArgs = {
  create: ClinicRoomCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicRoomUpdateInput;
  where: ClinicRoomWhereUniqueInput;
};


export type MutationUpsertOneClinicSettingArgs = {
  create: ClinicSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicSettingUpdateInput;
  where: ClinicSettingWhereUniqueInput;
};


export type MutationUpsertOneClinicUserFilterArgs = {
  create: ClinicUserFilterCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicUserFilterUpdateInput;
  where: ClinicUserFilterWhereUniqueInput;
};


export type MutationUpsertOneClinicWidgetRequestArgs = {
  create: ClinicWidgetRequestCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicWidgetRequestUpdateInput;
  where: ClinicWidgetRequestWhereUniqueInput;
};


export type MutationUpsertOneClinicWidgetRequestTypeArgs = {
  create: ClinicWidgetRequestTypeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicWidgetRequestTypeUpdateInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};


export type MutationUpsertOneClinicWidgetSettingArgs = {
  create: ClinicWidgetSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ClinicWidgetSettingUpdateInput;
  where: ClinicWidgetSettingWhereUniqueInput;
};


export type MutationUpsertOneColorArgs = {
  create: ColorCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ColorUpdateInput;
  where: ColorWhereUniqueInput;
};


export type MutationUpsertOneConditionArgs = {
  create: ConditionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ConditionUpdateInput;
  where: ConditionWhereUniqueInput;
};


export type MutationUpsertOneConditionSetArgs = {
  create: ConditionSetCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ConditionSetUpdateInput;
  where: ConditionSetWhereUniqueInput;
};


export type MutationUpsertOneConditionalEntityEvaluationArgs = {
  create: ConditionalEntityEvaluationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ConditionalEntityEvaluationUpdateInput;
  where: ConditionalEntityEvaluationWhereUniqueInput;
};


export type MutationUpsertOneConsultationRequestArgs = {
  create: ConsultationRequestCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ConsultationRequestUpdateInput;
  where: ConsultationRequestWhereUniqueInput;
};


export type MutationUpsertOneCustomFieldDefinitionArgs = {
  create: CustomFieldDefinitionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CustomFieldDefinitionUpdateInput;
  where: CustomFieldDefinitionWhereUniqueInput;
};


export type MutationUpsertOneCustomFieldPimsWritebackLogEntryArgs = {
  create: CustomFieldPimsWritebackLogEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: CustomFieldPimsWritebackLogEntryUpdateInput;
  where: CustomFieldPimsWritebackLogEntryWhereUniqueInput;
};


export type MutationUpsertOneDirectBookingAppointmentTypeSettingArgs = {
  create: DirectBookingAppointmentTypeSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: DirectBookingAppointmentTypeSettingUpdateInput;
  where: DirectBookingAppointmentTypeSettingWhereUniqueInput;
};


export type MutationUpsertOneDirectBookingExclusionRuleArgs = {
  create: DirectBookingExclusionRuleCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: DirectBookingExclusionRuleUpdateInput;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};


export type MutationUpsertOneDirectBookingExclusionTimeSlotArgs = {
  create: DirectBookingExclusionTimeSlotCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: DirectBookingExclusionTimeSlotUpdateInput;
  where: DirectBookingExclusionTimeSlotWhereUniqueInput;
};


export type MutationUpsertOneDisbursementArgs = {
  create: DisbursementCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: DisbursementUpdateInput;
  where: DisbursementWhereUniqueInput;
};


export type MutationUpsertOneDocumentationArgs = {
  create: DocumentationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: DocumentationUpdateInput;
  where: DocumentationWhereUniqueInput;
};


export type MutationUpsertOneEmailCampaignArgs = {
  create: EmailCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: EmailCampaignUpdateInput;
  where: EmailCampaignWhereUniqueInput;
};


export type MutationUpsertOneEmailCampaignCustomListArgs = {
  create: EmailCampaignCustomListCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: EmailCampaignCustomListUpdateInput;
  where: EmailCampaignCustomListWhereUniqueInput;
};


export type MutationUpsertOneEmailCampaignCustomListRecipientArgs = {
  create: EmailCampaignCustomListRecipientCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: EmailCampaignCustomListRecipientUpdateInput;
  where: EmailCampaignCustomListRecipientWhereUniqueInput;
};


export type MutationUpsertOneEmailCampaignCustomListUploadHistoryArgs = {
  create: EmailCampaignCustomListUploadHistoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: EmailCampaignCustomListUploadHistoryUpdateInput;
  where: EmailCampaignCustomListUploadHistoryWhereUniqueInput;
};


export type MutationUpsertOneEmailCampaignLogArgs = {
  create: EmailCampaignLogCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: EmailCampaignLogUpdateInput;
  where: EmailCampaignLogWhereUniqueInput;
};


export type MutationUpsertOneEmailCampaignTemplateArgs = {
  create: EmailCampaignTemplateCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: EmailCampaignTemplateUpdateInput;
  where: EmailCampaignTemplateWhereUniqueInput;
};


export type MutationUpsertOneEmailCampaignUnsubscribeArgs = {
  create: EmailCampaignUnsubscribeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: EmailCampaignUnsubscribeUpdateInput;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};


export type MutationUpsertOneEmailProviderLogArgs = {
  create: EmailProviderLogCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: EmailProviderLogUpdateInput;
  where: EmailProviderLogWhereUniqueInput;
};


export type MutationUpsertOneEmergencyClinicsArgs = {
  create: EmergencyClinicsCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: EmergencyClinicsUpdateInput;
  where: EmergencyClinicsWhereUniqueInput;
};


export type MutationUpsertOneEncryptedClinicUploadArgs = {
  create: EncryptedClinicUploadCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: EncryptedClinicUploadUpdateInput;
  where: EncryptedClinicUploadWhereUniqueInput;
};


export type MutationUpsertOneEnrollmentSupportEventArgs = {
  create: EnrollmentSupportEventCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: EnrollmentSupportEventUpdateInput;
  where: EnrollmentSupportEventWhereUniqueInput;
};


export type MutationUpsertOneEzyVetIntegrationArgs = {
  create: EzyVetIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: EzyVetIntegrationUpdateInput;
  where: EzyVetIntegrationWhereUniqueInput;
};


export type MutationUpsertOneFeatureFlagArgs = {
  create: FeatureFlagCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: FeatureFlagUpdateInput;
  where: FeatureFlagWhereUniqueInput;
};


export type MutationUpsertOneFinancialAdjustmentArgs = {
  create: FinancialAdjustmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: FinancialAdjustmentUpdateInput;
  where: FinancialAdjustmentWhereUniqueInput;
};


export type MutationUpsertOneFinancialTransactionArgs = {
  create: FinancialTransactionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: FinancialTransactionUpdateInput;
  where: FinancialTransactionWhereUniqueInput;
};


export type MutationUpsertOneFormSubmissionArgs = {
  create: FormSubmissionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: FormSubmissionUpdateInput;
  where: FormSubmissionWhereUniqueInput;
};


export type MutationUpsertOneFormTemplateArgs = {
  create: FormTemplateCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: FormTemplateUpdateInput;
  where: FormTemplateWhereUniqueInput;
};


export type MutationUpsertOneGlobalPetParentArgs = {
  create: GlobalPetParentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: GlobalPetParentUpdateInput;
  where: GlobalPetParentWhereUniqueInput;
};


export type MutationUpsertOneGooglePlaceArgs = {
  create: GooglePlaceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: GooglePlaceUpdateInput;
  where: GooglePlaceWhereUniqueInput;
};


export type MutationUpsertOneHillsToHomeApiLogArgs = {
  create: HillsToHomeApiLogCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: HillsToHomeApiLogUpdateInput;
  where: HillsToHomeApiLogWhereUniqueInput;
};


export type MutationUpsertOneInformAudienceDefinitionArgs = {
  create: InformAudienceDefinitionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformAudienceDefinitionUpdateInput;
  where: InformAudienceDefinitionWhereUniqueInput;
};


export type MutationUpsertOneInformAudienceMemberArgs = {
  create: InformAudienceMemberCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformAudienceMemberUpdateInput;
  where: InformAudienceMemberWhereUniqueInput;
};


export type MutationUpsertOneInformAudienceMemberMessageArgs = {
  create: InformAudienceMemberMessageCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformAudienceMemberMessageUpdateInput;
  where: InformAudienceMemberMessageWhereUniqueInput;
};


export type MutationUpsertOneInformAutomationCampaignArgs = {
  create: InformAutomationCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformAutomationCampaignUpdateInput;
  where: InformAutomationCampaignWhereUniqueInput;
};


export type MutationUpsertOneInformCampaignArgs = {
  create: InformCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformCampaignUpdateInput;
  where: InformCampaignWhereUniqueInput;
};


export type MutationUpsertOneInformCampaignEnrollmentArgs = {
  create: InformCampaignEnrollmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformCampaignEnrollmentUpdateInput;
  where: InformCampaignEnrollmentWhereUniqueInput;
};


export type MutationUpsertOneInformCampaignEnrollmentCanonicalServiceArgs = {
  create: InformCampaignEnrollmentCanonicalServiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformCampaignEnrollmentCanonicalServiceUpdateInput;
  where: InformCampaignEnrollmentCanonicalServiceWhereUniqueInput;
};


export type MutationUpsertOneInformCampaignExecutionArgs = {
  create: InformCampaignExecutionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformCampaignExecutionUpdateInput;
  where: InformCampaignExecutionWhereUniqueInput;
};


export type MutationUpsertOneInformCampaignGroupArgs = {
  create: InformCampaignGroupCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformCampaignGroupUpdateInput;
  where: InformCampaignGroupWhereUniqueInput;
};


export type MutationUpsertOneInformCommunicationOptOutArgs = {
  create: InformCommunicationOptOutCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformCommunicationOptOutUpdateInput;
  where: InformCommunicationOptOutWhereUniqueInput;
};


export type MutationUpsertOneInformControlGroupParticipantArgs = {
  create: InformControlGroupParticipantCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformControlGroupParticipantUpdateInput;
  where: InformControlGroupParticipantWhereUniqueInput;
};


export type MutationUpsertOneInformEmailTemplateArgs = {
  create: InformEmailTemplateCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformEmailTemplateUpdateInput;
  where: InformEmailTemplateWhereUniqueInput;
};


export type MutationUpsertOneInformEntityHistoryArgs = {
  create: InformEntityHistoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformEntityHistoryUpdateInput;
  where: InformEntityHistoryWhereUniqueInput;
};


export type MutationUpsertOneInformEventDrivenCampaignArgs = {
  create: InformEventDrivenCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformEventDrivenCampaignUpdateInput;
  where: InformEventDrivenCampaignWhereUniqueInput;
};


export type MutationUpsertOneInformEventListenerArgs = {
  create: InformEventListenerCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformEventListenerUpdateInput;
  where: InformEventListenerWhereUniqueInput;
};


export type MutationUpsertOneInformNotificationRecipientArgs = {
  create: InformNotificationRecipientCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformNotificationRecipientUpdateInput;
  where: InformNotificationRecipientWhereUniqueInput;
};


export type MutationUpsertOneInformPartnerArgs = {
  create: InformPartnerCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformPartnerUpdateInput;
  where: InformPartnerWhereUniqueInput;
};


export type MutationUpsertOneInformPartnerCustomerArgs = {
  create: InformPartnerCustomerCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformPartnerCustomerUpdateInput;
  where: InformPartnerCustomerWhereUniqueInput;
};


export type MutationUpsertOneInformPartnerCustomerPharmacyProviderArgs = {
  create: InformPartnerCustomerPharmacyProviderCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformPartnerCustomerPharmacyProviderUpdateInput;
  where: InformPartnerCustomerPharmacyProviderWhereUniqueInput;
};


export type MutationUpsertOneInformPartnerIntegrationArgs = {
  create: InformPartnerIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformPartnerIntegrationUpdateInput;
  where: InformPartnerIntegrationWhereUniqueInput;
};


export type MutationUpsertOneInformPartnerIntegrationModelArgs = {
  create: InformPartnerIntegrationModelCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformPartnerIntegrationModelUpdateInput;
  where: InformPartnerIntegrationModelWhereUniqueInput;
};


export type MutationUpsertOneInformPartnerProgramArgs = {
  create: InformPartnerProgramCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformPartnerProgramUpdateInput;
  where: InformPartnerProgramWhereUniqueInput;
};


export type MutationUpsertOneInformPartnerProgramEnrollmentArgs = {
  create: InformPartnerProgramEnrollmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformPartnerProgramEnrollmentUpdateInput;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};


export type MutationUpsertOneInformPartnerUserArgs = {
  create: InformPartnerUserCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformPartnerUserUpdateInput;
  where: InformPartnerUserWhereUniqueInput;
};


export type MutationUpsertOneInformPartnerUserRoleArgs = {
  create: InformPartnerUserRoleCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformPartnerUserRoleUpdateInput;
  where: InformPartnerUserRoleWhereUniqueInput;
};


export type MutationUpsertOneInformScheduledCampaignArgs = {
  create: InformScheduledCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformScheduledCampaignUpdateInput;
  where: InformScheduledCampaignWhereUniqueInput;
};


export type MutationUpsertOneInformSessionArgs = {
  create: InformSessionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformSessionUpdateInput;
  where: InformSessionWhereUniqueInput;
};


export type MutationUpsertOneInformSessionEventArgs = {
  create: InformSessionEventCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InformSessionEventUpdateInput;
  where: InformSessionEventWhereUniqueInput;
};


export type MutationUpsertOneInstinctIntegrationArgs = {
  create: InstinctIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InstinctIntegrationUpdateInput;
  where: InstinctIntegrationWhereUniqueInput;
};


export type MutationUpsertOneInsuranceIntegrationArgs = {
  create: InsuranceIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InsuranceIntegrationUpdateInput;
  where: InsuranceIntegrationWhereUniqueInput;
};


export type MutationUpsertOneIntegrationOutageHistoryEntryArgs = {
  create: IntegrationOutageHistoryEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: IntegrationOutageHistoryEntryUpdateInput;
  where: IntegrationOutageHistoryEntryWhereUniqueInput;
};


export type MutationUpsertOneInterchangeRateArgs = {
  create: InterchangeRateCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InterchangeRateUpdateInput;
  where: InterchangeRateWhereUniqueInput;
};


export type MutationUpsertOneInvoiceArgs = {
  create: InvoiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InvoiceUpdateInput;
  where: InvoiceWhereUniqueInput;
};


export type MutationUpsertOneInvoiceLineItemArgs = {
  create: InvoiceLineItemCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InvoiceLineItemUpdateInput;
  where: InvoiceLineItemWhereUniqueInput;
};


export type MutationUpsertOneInvoicePimsWritebackLogEntryArgs = {
  create: InvoicePimsWritebackLogEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: InvoicePimsWritebackLogEntryUpdateInput;
  where: InvoicePimsWritebackLogEntryWhereUniqueInput;
};


export type MutationUpsertOneLabPanelArgs = {
  create: LabPanelCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LabPanelUpdateInput;
  where: LabPanelWhereUniqueInput;
};


export type MutationUpsertOneLabResultArgs = {
  create: LabResultCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LabResultUpdateInput;
  where: LabResultWhereUniqueInput;
};


export type MutationUpsertOneLapsedPetParentTriggersArgs = {
  create: LapsedPetParentTriggersCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LapsedPetParentTriggersUpdateInput;
  where: LapsedPetParentTriggersWhereUniqueInput;
};


export type MutationUpsertOneLegalEntityArgs = {
  create: LegalEntityCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LegalEntityUpdateInput;
  where: LegalEntityWhereUniqueInput;
};


export type MutationUpsertOneLoyaltyAccountArgs = {
  create: LoyaltyAccountCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LoyaltyAccountUpdateInput;
  where: LoyaltyAccountWhereUniqueInput;
};


export type MutationUpsertOneLoyaltyAccountHolderArgs = {
  create: LoyaltyAccountHolderCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LoyaltyAccountHolderUpdateInput;
  where: LoyaltyAccountHolderWhereUniqueInput;
};


export type MutationUpsertOneLoyaltyAccountMergerArgs = {
  create: LoyaltyAccountMergerCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LoyaltyAccountMergerUpdateInput;
  where: LoyaltyAccountMergerWhereUniqueInput;
};


export type MutationUpsertOneLoyaltyInvoicePointGranterArgs = {
  create: LoyaltyInvoicePointGranterCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LoyaltyInvoicePointGranterUpdateInput;
  where: LoyaltyInvoicePointGranterWhereUniqueInput;
};


export type MutationUpsertOneLoyaltyPointGrantingServiceArgs = {
  create: LoyaltyPointGrantingServiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LoyaltyPointGrantingServiceUpdateInput;
  where: LoyaltyPointGrantingServiceWhereUniqueInput;
};


export type MutationUpsertOneLoyaltyPointGrantingServiceCategoryArgs = {
  create: LoyaltyPointGrantingServiceCategoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LoyaltyPointGrantingServiceCategoryUpdateInput;
  where: LoyaltyPointGrantingServiceCategoryWhereUniqueInput;
};


export type MutationUpsertOneLoyaltyPointUserGrantArgs = {
  create: LoyaltyPointUserGrantCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LoyaltyPointUserGrantUpdateInput;
  where: LoyaltyPointUserGrantWhereUniqueInput;
};


export type MutationUpsertOneLoyaltyRewardArgs = {
  create: LoyaltyRewardCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LoyaltyRewardUpdateInput;
  where: LoyaltyRewardWhereUniqueInput;
};


export type MutationUpsertOneLoyaltyRewardRedemptionArgs = {
  create: LoyaltyRewardRedemptionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: LoyaltyRewardRedemptionUpdateInput;
  where: LoyaltyRewardRedemptionWhereUniqueInput;
};


export type MutationUpsertOneMassTextAlertArgs = {
  create: MassTextAlertCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: MassTextAlertUpdateInput;
  where: MassTextAlertWhereUniqueInput;
};


export type MutationUpsertOneMassTextAlertEntryArgs = {
  create: MassTextAlertEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: MassTextAlertEntryUpdateInput;
  where: MassTextAlertEntryWhereUniqueInput;
};


export type MutationUpsertOneMassTextAlertEntryAppointmentArgs = {
  create: MassTextAlertEntryAppointmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: MassTextAlertEntryAppointmentUpdateInput;
  where: MassTextAlertEntryAppointmentWhereUniqueInput;
};


export type MutationUpsertOneMediaArgs = {
  create: MediaCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: MediaUpdateInput;
  where: MediaWhereUniqueInput;
};


export type MutationUpsertOneMedicalHistoryArgs = {
  create: MedicalHistoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: MedicalHistoryUpdateInput;
  where: MedicalHistoryWhereUniqueInput;
};


export type MutationUpsertOneMessageTemplateArgs = {
  create: MessageTemplateCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: MessageTemplateUpdateInput;
  where: MessageTemplateWhereUniqueInput;
};


export type MutationUpsertOneMessagingCampaignArgs = {
  create: MessagingCampaignCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: MessagingCampaignUpdateInput;
  where: MessagingCampaignWhereUniqueInput;
};


export type MutationUpsertOneMessagingPartnerArgs = {
  create: MessagingPartnerCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: MessagingPartnerUpdateInput;
  where: MessagingPartnerWhereUniqueInput;
};


export type MutationUpsertOneModuleArgs = {
  create: ModuleCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ModuleUpdateInput;
  where: ModuleWhereUniqueInput;
};


export type MutationUpsertOneNonPrismaSchemaScriptRanArgs = {
  create: NonPrismaSchemaScriptRanCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: NonPrismaSchemaScriptRanUpdateInput;
  where: NonPrismaSchemaScriptRanWhereUniqueInput;
};


export type MutationUpsertOneNotificationEventToMessageArgs = {
  create: NotificationEventToMessageCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: NotificationEventToMessageUpdateInput;
  where: NotificationEventToMessageWhereUniqueInput;
};


export type MutationUpsertOneOrganizationArgs = {
  create: OrganizationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: OrganizationUpdateInput;
  where: OrganizationWhereUniqueInput;
};


export type MutationUpsertOneOrganizationCareBenefitToClinicServiceArgs = {
  create: OrganizationCareBenefitToClinicServiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: OrganizationCareBenefitToClinicServiceUpdateInput;
  where: OrganizationCareBenefitToClinicServiceWhereUniqueInput;
};


export type MutationUpsertOneOrganizationCareBenefitToClinicServiceCategoryArgs = {
  create: OrganizationCareBenefitToClinicServiceCategoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: OrganizationCareBenefitToClinicServiceCategoryUpdateInput;
  where: OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput;
};


export type MutationUpsertOneOrganizationPetArgs = {
  create: OrganizationPetCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: OrganizationPetUpdateInput;
  where: OrganizationPetWhereUniqueInput;
};


export type MutationUpsertOneOrganizationPetParentArgs = {
  create: OrganizationPetParentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: OrganizationPetParentUpdateInput;
  where: OrganizationPetParentWhereUniqueInput;
};


export type MutationUpsertOneOrganizationPetToOrganizationPetParentArgs = {
  create: OrganizationPetToOrganizationPetParentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: OrganizationPetToOrganizationPetParentUpdateInput;
  where: OrganizationPetToOrganizationPetParentWhereUniqueInput;
};


export type MutationUpsertOnePpcIntegrationArgs = {
  create: PpcIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PpcIntegrationUpdateInput;
  where: PpcIntegrationWhereUniqueInput;
};


export type MutationUpsertOnePaymentsReportTransactionArgs = {
  create: PaymentsReportTransactionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PaymentsReportTransactionUpdateInput;
  where: PaymentsReportTransactionWhereUniqueInput;
};


export type MutationUpsertOnePayoutBatchingPeriodArgs = {
  create: PayoutBatchingPeriodCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PayoutBatchingPeriodUpdateInput;
  where: PayoutBatchingPeriodWhereUniqueInput;
};


export type MutationUpsertOnePayoutBatchingScheduleArgs = {
  create: PayoutBatchingScheduleCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PayoutBatchingScheduleUpdateInput;
  where: PayoutBatchingScheduleWhereUniqueInput;
};


export type MutationUpsertOnePayoutBatchingSettingArgs = {
  create: PayoutBatchingSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PayoutBatchingSettingUpdateInput;
  where: PayoutBatchingSettingWhereUniqueInput;
};


export type MutationUpsertOnePermissionArgs = {
  create: PermissionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PermissionUpdateInput;
  where: PermissionWhereUniqueInput;
};


export type MutationUpsertOnePetParentSettingArgs = {
  create: PetParentSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PetParentSettingUpdateInput;
  where: PetParentSettingWhereUniqueInput;
};


export type MutationUpsertOnePetPortalSettingArgs = {
  create: PetPortalSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PetPortalSettingUpdateInput;
  where: PetPortalSettingWhereUniqueInput;
};


export type MutationUpsertOnePhoneNumberLookupRequestArgs = {
  create: PhoneNumberLookupRequestCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PhoneNumberLookupRequestUpdateInput;
  where: PhoneNumberLookupRequestWhereUniqueInput;
};


export type MutationUpsertOnePhoneNumberLookupResultArgs = {
  create: PhoneNumberLookupResultCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PhoneNumberLookupResultUpdateInput;
  where: PhoneNumberLookupResultWhereUniqueInput;
};


export type MutationUpsertOnePimsInvoiceArgs = {
  create: PimsInvoiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PimsInvoiceUpdateInput;
  where: PimsInvoiceWhereUniqueInput;
};


export type MutationUpsertOnePimsInvoiceLineItemArgs = {
  create: PimsInvoiceLineItemCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PimsInvoiceLineItemUpdateInput;
  where: PimsInvoiceLineItemWhereUniqueInput;
};


export type MutationUpsertOnePimsWritebackLogEntryArgs = {
  create: PimsWritebackLogEntryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PimsWritebackLogEntryUpdateInput;
  where: PimsWritebackLogEntryWhereUniqueInput;
};


export type MutationUpsertOnePrescriptionArgs = {
  create: PrescriptionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PrescriptionUpdateInput;
  where: PrescriptionWhereUniqueInput;
};


export type MutationUpsertOneProductArgs = {
  create: ProductCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ProductUpdateInput;
  where: ProductWhereUniqueInput;
};


export type MutationUpsertOneProductPackageArgs = {
  create: ProductPackageCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ProductPackageUpdateInput;
  where: ProductPackageWhereUniqueInput;
};


export type MutationUpsertOneProductPackageSubscriptionArgs = {
  create: ProductPackageSubscriptionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ProductPackageSubscriptionUpdateInput;
  where: ProductPackageSubscriptionWhereUniqueInput;
};


export type MutationUpsertOneProviderAppointmentTypeRoomMapArgs = {
  create: ProviderAppointmentTypeRoomMapCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ProviderAppointmentTypeRoomMapUpdateInput;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};


export type MutationUpsertOnePushNotificationLogArgs = {
  create: PushNotificationLogCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: PushNotificationLogUpdateInput;
  where: PushNotificationLogWhereUniqueInput;
};


export type MutationUpsertOneRecapArgs = {
  create: RecapCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: RecapUpdateInput;
  where: RecapWhereUniqueInput;
};


export type MutationUpsertOneRulesArgs = {
  create: RulesCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: RulesUpdateInput;
  where: RulesWhereUniqueInput;
};


export type MutationUpsertOneSegmentArgs = {
  create: SegmentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: SegmentUpdateInput;
  where: SegmentWhereUniqueInput;
};


export type MutationUpsertOneSentTrupanionExamDayOfferArgs = {
  create: SentTrupanionExamDayOfferCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: SentTrupanionExamDayOfferUpdateInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};


export type MutationUpsertOneServiceArgs = {
  create: ServiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ServiceUpdateInput;
  where: ServiceWhereUniqueInput;
};


export type MutationUpsertOneServiceCategoryArgs = {
  create: ServiceCategoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ServiceCategoryUpdateInput;
  where: ServiceCategoryWhereUniqueInput;
};


export type MutationUpsertOneServicePurchaseSummaryArgs = {
  create: ServicePurchaseSummaryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ServicePurchaseSummaryUpdateInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};


export type MutationUpsertOneServiceReminderArgs = {
  create: ServiceReminderCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ServiceReminderUpdateInput;
  where: ServiceReminderWhereUniqueInput;
};


export type MutationUpsertOneServiceReminderNotificationArgs = {
  create: ServiceReminderNotificationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ServiceReminderNotificationUpdateInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};


export type MutationUpsertOneServiceReminderTimingArgs = {
  create: ServiceReminderTimingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: ServiceReminderTimingUpdateInput;
  where: ServiceReminderTimingWhereUniqueInput;
};


export type MutationUpsertOneSexArgs = {
  create: SexCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: SexUpdateInput;
  where: SexWhereUniqueInput;
};


export type MutationUpsertOneSmsNotificationStatusArgs = {
  create: SmsNotificationStatusCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: SmsNotificationStatusUpdateInput;
  where: SmsNotificationStatusWhereUniqueInput;
};


export type MutationUpsertOneSpeciesArgs = {
  create: SpeciesCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: SpeciesUpdateInput;
  where: SpeciesWhereUniqueInput;
};


export type MutationUpsertOneStaffRoleArgs = {
  create: StaffRoleCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StaffRoleUpdateInput;
  where: StaffRoleWhereUniqueInput;
};


export type MutationUpsertOneStripeCustomerArgs = {
  create: StripeCustomerCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripeCustomerUpdateInput;
  where: StripeCustomerWhereUniqueInput;
};


export type MutationUpsertOneStripeDisputeArgs = {
  create: StripeDisputeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripeDisputeUpdateInput;
  where: StripeDisputeWhereUniqueInput;
};


export type MutationUpsertOneStripeInvoiceArgs = {
  create: StripeInvoiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripeInvoiceUpdateInput;
  where: StripeInvoiceWhereUniqueInput;
};


export type MutationUpsertOneStripeInvoiceItemArgs = {
  create: StripeInvoiceItemCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripeInvoiceItemUpdateInput;
  where: StripeInvoiceItemWhereUniqueInput;
};


export type MutationUpsertOneStripePaymentIntentArgs = {
  create: StripePaymentIntentCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripePaymentIntentUpdateInput;
  where: StripePaymentIntentWhereUniqueInput;
};


export type MutationUpsertOneStripePaymentMethodArgs = {
  create: StripePaymentMethodCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripePaymentMethodUpdateInput;
  where: StripePaymentMethodWhereUniqueInput;
};


export type MutationUpsertOneStripePayoutArgs = {
  create: StripePayoutCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripePayoutUpdateInput;
  where: StripePayoutWhereUniqueInput;
};


export type MutationUpsertOneStripePayoutAccountArgs = {
  create: StripePayoutAccountCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripePayoutAccountUpdateInput;
  where: StripePayoutAccountWhereUniqueInput;
};


export type MutationUpsertOneStripeReceiptArgs = {
  create: StripeReceiptCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripeReceiptUpdateInput;
  where: StripeReceiptWhereUniqueInput;
};


export type MutationUpsertOneStripeReceiptHistoryArgs = {
  create: StripeReceiptHistoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripeReceiptHistoryUpdateInput;
  where: StripeReceiptHistoryWhereUniqueInput;
};


export type MutationUpsertOneStripeRefundArgs = {
  create: StripeRefundCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripeRefundUpdateInput;
  where: StripeRefundWhereUniqueInput;
};


export type MutationUpsertOneStripeTerminalArgs = {
  create: StripeTerminalCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripeTerminalUpdateInput;
  where: StripeTerminalWhereUniqueInput;
};


export type MutationUpsertOneStripeTerminalLocationArgs = {
  create: StripeTerminalLocationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: StripeTerminalLocationUpdateInput;
  where: StripeTerminalLocationWhereUniqueInput;
};


export type MutationUpsertOneSurveyAppointmentTypeSettingArgs = {
  create: SurveyAppointmentTypeSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: SurveyAppointmentTypeSettingUpdateInput;
  where: SurveyAppointmentTypeSettingWhereUniqueInput;
};


export type MutationUpsertOneSurveyResultArgs = {
  create: SurveyResultCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: SurveyResultUpdateInput;
  where: SurveyResultWhereUniqueInput;
};


export type MutationUpsertOneSurveySettingArgs = {
  create: SurveySettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: SurveySettingUpdateInput;
  where: SurveySettingWhereUniqueInput;
};


export type MutationUpsertOneSyncVetIntegrationArgs = {
  create: SyncVetIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: SyncVetIntegrationUpdateInput;
  where: SyncVetIntegrationWhereUniqueInput;
};


export type MutationUpsertOneSyncVetServiceArgs = {
  create: SyncVetServiceCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: SyncVetServiceUpdateInput;
  where: SyncVetServiceWhereUniqueInput;
};


export type MutationUpsertOneSynchronyClinicConfigurationArgs = {
  create: SynchronyClinicConfigurationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: SynchronyClinicConfigurationUpdateInput;
  where: SynchronyClinicConfigurationWhereUniqueInput;
};


export type MutationUpsertOneSynchronyEventArgs = {
  create: SynchronyEventCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: SynchronyEventUpdateInput;
  where: SynchronyEventWhereUniqueInput;
};


export type MutationUpsertOneTaskArgs = {
  create: TaskCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: TaskUpdateInput;
  where: TaskWhereUniqueInput;
};


export type MutationUpsertOneTaxonomyArgs = {
  create: TaxonomyCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: TaxonomyUpdateInput;
  where: TaxonomyWhereUniqueInput;
};


export type MutationUpsertOneTaxonomyToInformAudienceDefinitionArgs = {
  create: TaxonomyToInformAudienceDefinitionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: TaxonomyToInformAudienceDefinitionUpdateInput;
  where: TaxonomyToInformAudienceDefinitionWhereUniqueInput;
};


export type MutationUpsertOneTransactionArgs = {
  create: TransactionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: TransactionUpdateInput;
  where: TransactionWhereUniqueInput;
};


export type MutationUpsertOneTrupanionCertificateAvailabilityArgs = {
  create: TrupanionCertificateAvailabilityCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: TrupanionCertificateAvailabilityUpdateInput;
  where: TrupanionCertificateAvailabilityWhereUniqueInput;
};


export type MutationUpsertOneTrupanionIntegratedAppointmentTypeArgs = {
  create: TrupanionIntegratedAppointmentTypeCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: TrupanionIntegratedAppointmentTypeUpdateInput;
  where: TrupanionIntegratedAppointmentTypeWhereUniqueInput;
};


export type MutationUpsertOneTrupanionIntegrationArgs = {
  create: TrupanionIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: TrupanionIntegrationUpdateInput;
  where: TrupanionIntegrationWhereUniqueInput;
};


export type MutationUpsertOneUserArgs = {
  create: UserCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpsertOneUserAppointmentGroupingArgs = {
  create: UserAppointmentGroupingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: UserAppointmentGroupingUpdateInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};


export type MutationUpsertOneUserBoardFilterArgs = {
  create: UserBoardFilterCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: UserBoardFilterUpdateInput;
  where: UserBoardFilterWhereUniqueInput;
};


export type MutationUpsertOneUserChannelFilterSelectionArgs = {
  create: UserChannelFilterSelectionCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: UserChannelFilterSelectionUpdateInput;
  where: UserChannelFilterSelectionWhereUniqueInput;
};


export type MutationUpsertOneUserNotificationSettingArgs = {
  create: UserNotificationSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: UserNotificationSettingUpdateInput;
  where: UserNotificationSettingWhereUniqueInput;
};


export type MutationUpsertOneUserSettingArgs = {
  create: UserSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: UserSettingUpdateInput;
  where: UserSettingWhereUniqueInput;
};


export type MutationUpsertOneUserTaskListArgs = {
  create: UserTaskListCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: UserTaskListUpdateInput;
  where: UserTaskListWhereUniqueInput;
};


export type MutationUpsertOneUserTaskListFilterArgs = {
  create: UserTaskListFilterCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: UserTaskListFilterUpdateInput;
  where: UserTaskListFilterWhereUniqueInput;
};


export type MutationUpsertOneVaccinationArgs = {
  create: VaccinationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: VaccinationUpdateInput;
  where: VaccinationWhereUniqueInput;
};


export type MutationUpsertOneVetAvailabilityArgs = {
  create: VetAvailabilityCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: VetAvailabilityUpdateInput;
  where: VetAvailabilityWhereUniqueInput;
};


export type MutationUpsertOneVetAvailabilityClinicRoomMapArgs = {
  create: VetAvailabilityClinicRoomMapCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: VetAvailabilityClinicRoomMapUpdateInput;
  where: VetAvailabilityClinicRoomMapWhereUniqueInput;
};


export type MutationUpsertOneVetAvailabilityMapArgs = {
  create: VetAvailabilityMapCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: VetAvailabilityMapUpdateInput;
  where: VetAvailabilityMapWhereUniqueInput;
};


export type MutationUpsertOneVetInfoArgs = {
  create: VetInfoCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: VetInfoUpdateInput;
  where: VetInfoWhereUniqueInput;
};


export type MutationUpsertOneVetsourceCodeTagArgs = {
  create: VetsourceCodeTagCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: VetsourceCodeTagUpdateInput;
  where: VetsourceCodeTagWhereUniqueInput;
};


export type MutationUpsertOneVetsourceInstallationArgs = {
  create: VetsourceInstallationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: VetsourceInstallationUpdateInput;
  where: VetsourceInstallationWhereUniqueInput;
};


export type MutationUpsertOneVetsourcePharmacyIntegrationArgs = {
  create: VetsourcePharmacyIntegrationCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: VetsourcePharmacyIntegrationUpdateInput;
  where: VetsourcePharmacyIntegrationWhereUniqueInput;
};


export type MutationUpsertOneVetsourceRevenueCategoryArgs = {
  create: VetsourceRevenueCategoryCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: VetsourceRevenueCategoryUpdateInput;
  where: VetsourceRevenueCategoryWhereUniqueInput;
};


export type MutationUpsertOneWorkflowEventSettingArgs = {
  create: WorkflowEventSettingCreateInput;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  update: WorkflowEventSettingUpdateInput;
  where: WorkflowEventSettingWhereUniqueInput;
};


export type MutationUpsertUserToClinicArgs = {
  data: UpsertUserToClinicInput;
};


export type MutationVerifyClinicWidgetRequestArgs = {
  where: VerifyClinicWidgetRequestInput;
};


export type MutationVerifyClinicWidgetRequest2Args = {
  where: VerifyClinicWidgetRequestInput;
};


export type MutationVerifyWidgetAuthenticationRequestArgs = {
  data: VerifyWidgetAuthenticationRequestInput;
};

export enum MutationType {
  Create = 'create',
  Delete = 'delete',
  Update = 'update',
  Upsert = 'upsert'
}

export type NeoIntegration = {
  __typename?: 'NeoIntegration';
  authToken: Scalars['String'];
  branchId?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type NeoIntegrationClinicPimsIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type NeoIntegrationCountAggregateOutputType = {
  __typename?: 'NeoIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  authToken: Scalars['Int'];
  branchId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type NeoIntegrationCountOrderByAggregateInput = {
  authToken?: Maybe<SortOrder>;
  branchId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NeoIntegrationCreateInput = {
  authToken: Scalars['String'];
  branchId?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutNeoInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationCreateManyInput = {
  authToken: Scalars['String'];
  branchId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<NeoIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<NeoIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<NeoIntegrationCreateWithoutClinicPimsIntegrationInput>;
};

export type NeoIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput = {
  create: NeoIntegrationCreateWithoutClinicPimsIntegrationInput;
  where: NeoIntegrationWhereUniqueInput;
};

export type NeoIntegrationCreateWithoutClinicPimsIntegrationInput = {
  authToken: Scalars['String'];
  branchId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationGroupByOutputType = {
  __typename?: 'NeoIntegrationGroupByOutputType';
  _count?: Maybe<NeoIntegrationCountAggregateOutputType>;
  _max?: Maybe<NeoIntegrationMaxAggregateOutputType>;
  _min?: Maybe<NeoIntegrationMinAggregateOutputType>;
  authToken: Scalars['String'];
  branchId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type NeoIntegrationMaxAggregateOutputType = {
  __typename?: 'NeoIntegrationMaxAggregateOutputType';
  authToken?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationMaxOrderByAggregateInput = {
  authToken?: Maybe<SortOrder>;
  branchId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NeoIntegrationMinAggregateOutputType = {
  __typename?: 'NeoIntegrationMinAggregateOutputType';
  authToken?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationMinOrderByAggregateInput = {
  authToken?: Maybe<SortOrder>;
  branchId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NeoIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<NeoIntegrationWhereInput>>;
  NOT?: Maybe<Array<NeoIntegrationWhereInput>>;
  OR?: Maybe<Array<NeoIntegrationWhereInput>>;
  authToken?: Maybe<StringFilter>;
  branchId?: Maybe<StringNullableFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type NeoIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<NeoIntegrationOrderByRelevanceInput>;
  authToken?: Maybe<SortOrder>;
  branchId?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum NeoIntegrationOrderByRelevanceFieldEnum {
  AuthToken = 'authToken',
  BranchId = 'branchId',
  Id = 'id'
}

export type NeoIntegrationOrderByRelevanceInput = {
  fields: Array<NeoIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type NeoIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<NeoIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<NeoIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<NeoIntegrationMinOrderByAggregateInput>;
  authToken?: Maybe<SortOrder>;
  branchId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NeoIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<NeoIntegrationOrderByRelevanceInput>;
  authToken?: Maybe<SortOrder>;
  branchId?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NeoIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<NeoIntegrationOrderByRelevanceInput>;
  authToken?: Maybe<SortOrder>;
  branchId?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum NeoIntegrationScalarFieldEnum {
  AuthToken = 'authToken',
  BranchId = 'branchId',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type NeoIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<NeoIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<NeoIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<NeoIntegrationScalarWhereWithAggregatesInput>>;
  authToken?: Maybe<StringWithAggregatesFilter>;
  branchId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type NeoIntegrationUncheckedCreateInput = {
  authToken: Scalars['String'];
  branchId?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedOneWithoutNeoInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationUncheckedCreateWithoutClinicPimsIntegrationInput = {
  authToken: Scalars['String'];
  branchId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationUncheckedUpdateInput = {
  authToken?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedUpdateOneWithoutNeoNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationUncheckedUpdateManyInput = {
  authToken?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationUncheckedUpdateWithoutClinicPimsIntegrationInput = {
  authToken?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationUpdateInput = {
  authToken?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutNeoNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationUpdateManyMutationInput = {
  authToken?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<NeoIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<NeoIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<NeoIntegrationCreateWithoutClinicPimsIntegrationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<NeoIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput>;
  upsert?: Maybe<NeoIntegrationUpsertWithoutClinicPimsIntegrationInput>;
};

export type NeoIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput = {
  data: NeoIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<NeoIntegrationWhereInput>;
};

export type NeoIntegrationUpdateWithoutClinicPimsIntegrationInput = {
  authToken?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NeoIntegrationUpsertWithoutClinicPimsIntegrationInput = {
  create: NeoIntegrationCreateWithoutClinicPimsIntegrationInput;
  update: NeoIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<NeoIntegrationWhereInput>;
};

export type NeoIntegrationWhereInput = {
  AND?: Maybe<Array<NeoIntegrationWhereInput>>;
  NOT?: Maybe<Array<NeoIntegrationWhereInput>>;
  OR?: Maybe<Array<NeoIntegrationWhereInput>>;
  authToken?: Maybe<StringFilter>;
  branchId?: Maybe<StringNullableFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type NeoIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<NeoIntegrationWhereInput>>;
  NOT?: Maybe<Array<NeoIntegrationWhereInput>>;
  OR?: Maybe<Array<NeoIntegrationWhereInput>>;
  authToken?: Maybe<StringFilter>;
  branchId?: Maybe<StringNullableFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type NestedBoolFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedBoolNullableFilter>;
  _min?: Maybe<NestedBoolNullableFilter>;
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolNullableWithAggregatesFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedBoolFilter>;
  _min?: Maybe<NestedBoolFilter>;
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedDateTimeNullableFilter>;
  _min?: Maybe<NestedDateTimeNullableFilter>;
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedDateTimeFilter>;
  _min?: Maybe<NestedDateTimeFilter>;
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedEnumAmericanKennelClubBreedGroupNullableFilter = {
  equals?: Maybe<AmericanKennelClubBreedGroup>;
  in?: Maybe<Array<AmericanKennelClubBreedGroup>>;
  not?: Maybe<NestedEnumAmericanKennelClubBreedGroupNullableFilter>;
  notIn?: Maybe<Array<AmericanKennelClubBreedGroup>>;
};

export type NestedEnumAmericanKennelClubBreedGroupNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAmericanKennelClubBreedGroupNullableFilter>;
  _min?: Maybe<NestedEnumAmericanKennelClubBreedGroupNullableFilter>;
  equals?: Maybe<AmericanKennelClubBreedGroup>;
  in?: Maybe<Array<AmericanKennelClubBreedGroup>>;
  not?: Maybe<NestedEnumAmericanKennelClubBreedGroupNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AmericanKennelClubBreedGroup>>;
};

export type NestedEnumAmericanKennelClubDemeanorCategoryNullableFilter = {
  equals?: Maybe<AmericanKennelClubDemeanorCategory>;
  in?: Maybe<Array<AmericanKennelClubDemeanorCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubDemeanorCategoryNullableFilter>;
  notIn?: Maybe<Array<AmericanKennelClubDemeanorCategory>>;
};

export type NestedEnumAmericanKennelClubDemeanorCategoryNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAmericanKennelClubDemeanorCategoryNullableFilter>;
  _min?: Maybe<NestedEnumAmericanKennelClubDemeanorCategoryNullableFilter>;
  equals?: Maybe<AmericanKennelClubDemeanorCategory>;
  in?: Maybe<Array<AmericanKennelClubDemeanorCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubDemeanorCategoryNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AmericanKennelClubDemeanorCategory>>;
};

export type NestedEnumAmericanKennelClubEnergyLevelCategoryNullableFilter = {
  equals?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  in?: Maybe<Array<AmericanKennelClubEnergyLevelCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubEnergyLevelCategoryNullableFilter>;
  notIn?: Maybe<Array<AmericanKennelClubEnergyLevelCategory>>;
};

export type NestedEnumAmericanKennelClubEnergyLevelCategoryNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAmericanKennelClubEnergyLevelCategoryNullableFilter>;
  _min?: Maybe<NestedEnumAmericanKennelClubEnergyLevelCategoryNullableFilter>;
  equals?: Maybe<AmericanKennelClubEnergyLevelCategory>;
  in?: Maybe<Array<AmericanKennelClubEnergyLevelCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubEnergyLevelCategoryNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AmericanKennelClubEnergyLevelCategory>>;
};

export type NestedEnumAmericanKennelClubGroomingFrequencyCategoryNullableFilter = {
  equals?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  in?: Maybe<Array<AmericanKennelClubGroomingFrequencyCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubGroomingFrequencyCategoryNullableFilter>;
  notIn?: Maybe<Array<AmericanKennelClubGroomingFrequencyCategory>>;
};

export type NestedEnumAmericanKennelClubGroomingFrequencyCategoryNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAmericanKennelClubGroomingFrequencyCategoryNullableFilter>;
  _min?: Maybe<NestedEnumAmericanKennelClubGroomingFrequencyCategoryNullableFilter>;
  equals?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
  in?: Maybe<Array<AmericanKennelClubGroomingFrequencyCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubGroomingFrequencyCategoryNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AmericanKennelClubGroomingFrequencyCategory>>;
};

export type NestedEnumAmericanKennelClubSheddingCategoryNullableFilter = {
  equals?: Maybe<AmericanKennelClubSheddingCategory>;
  in?: Maybe<Array<AmericanKennelClubSheddingCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubSheddingCategoryNullableFilter>;
  notIn?: Maybe<Array<AmericanKennelClubSheddingCategory>>;
};

export type NestedEnumAmericanKennelClubSheddingCategoryNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAmericanKennelClubSheddingCategoryNullableFilter>;
  _min?: Maybe<NestedEnumAmericanKennelClubSheddingCategoryNullableFilter>;
  equals?: Maybe<AmericanKennelClubSheddingCategory>;
  in?: Maybe<Array<AmericanKennelClubSheddingCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubSheddingCategoryNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AmericanKennelClubSheddingCategory>>;
};

export type NestedEnumAmericanKennelClubTrainabilityCategoryNullableFilter = {
  equals?: Maybe<AmericanKennelClubTrainabilityCategory>;
  in?: Maybe<Array<AmericanKennelClubTrainabilityCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubTrainabilityCategoryNullableFilter>;
  notIn?: Maybe<Array<AmericanKennelClubTrainabilityCategory>>;
};

export type NestedEnumAmericanKennelClubTrainabilityCategoryNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAmericanKennelClubTrainabilityCategoryNullableFilter>;
  _min?: Maybe<NestedEnumAmericanKennelClubTrainabilityCategoryNullableFilter>;
  equals?: Maybe<AmericanKennelClubTrainabilityCategory>;
  in?: Maybe<Array<AmericanKennelClubTrainabilityCategory>>;
  not?: Maybe<NestedEnumAmericanKennelClubTrainabilityCategoryNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AmericanKennelClubTrainabilityCategory>>;
};

export type NestedEnumAppointmentDateRangeTypeFilter = {
  equals?: Maybe<AppointmentDateRangeType>;
  in?: Maybe<Array<AppointmentDateRangeType>>;
  not?: Maybe<NestedEnumAppointmentDateRangeTypeFilter>;
  notIn?: Maybe<Array<AppointmentDateRangeType>>;
};

export type NestedEnumAppointmentDateRangeTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAppointmentDateRangeTypeFilter>;
  _min?: Maybe<NestedEnumAppointmentDateRangeTypeFilter>;
  equals?: Maybe<AppointmentDateRangeType>;
  in?: Maybe<Array<AppointmentDateRangeType>>;
  not?: Maybe<NestedEnumAppointmentDateRangeTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<AppointmentDateRangeType>>;
};

export type NestedEnumAppointmentStatusFilter = {
  equals?: Maybe<AppointmentStatus>;
  in?: Maybe<Array<AppointmentStatus>>;
  not?: Maybe<NestedEnumAppointmentStatusFilter>;
  notIn?: Maybe<Array<AppointmentStatus>>;
};

export type NestedEnumAppointmentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAppointmentStatusFilter>;
  _min?: Maybe<NestedEnumAppointmentStatusFilter>;
  equals?: Maybe<AppointmentStatus>;
  in?: Maybe<Array<AppointmentStatus>>;
  not?: Maybe<NestedEnumAppointmentStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<AppointmentStatus>>;
};

export type NestedEnumAppointmentTypeVisibilityFilter = {
  equals?: Maybe<AppointmentTypeVisibility>;
  in?: Maybe<Array<AppointmentTypeVisibility>>;
  not?: Maybe<NestedEnumAppointmentTypeVisibilityFilter>;
  notIn?: Maybe<Array<AppointmentTypeVisibility>>;
};

export type NestedEnumAppointmentTypeVisibilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAppointmentTypeVisibilityFilter>;
  _min?: Maybe<NestedEnumAppointmentTypeVisibilityFilter>;
  equals?: Maybe<AppointmentTypeVisibility>;
  in?: Maybe<Array<AppointmentTypeVisibility>>;
  not?: Maybe<NestedEnumAppointmentTypeVisibilityWithAggregatesFilter>;
  notIn?: Maybe<Array<AppointmentTypeVisibility>>;
};

export type NestedEnumAutoResponseSuggestionStatusFilter = {
  equals?: Maybe<AutoResponseSuggestionStatus>;
  in?: Maybe<Array<AutoResponseSuggestionStatus>>;
  not?: Maybe<NestedEnumAutoResponseSuggestionStatusFilter>;
  notIn?: Maybe<Array<AutoResponseSuggestionStatus>>;
};

export type NestedEnumAutoResponseSuggestionStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAutoResponseSuggestionStatusFilter>;
  _min?: Maybe<NestedEnumAutoResponseSuggestionStatusFilter>;
  equals?: Maybe<AutoResponseSuggestionStatus>;
  in?: Maybe<Array<AutoResponseSuggestionStatus>>;
  not?: Maybe<NestedEnumAutoResponseSuggestionStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<AutoResponseSuggestionStatus>>;
};

export type NestedEnumAutomatedTriggerTypeNullableFilter = {
  equals?: Maybe<AutomatedTriggerType>;
  in?: Maybe<Array<AutomatedTriggerType>>;
  not?: Maybe<NestedEnumAutomatedTriggerTypeNullableFilter>;
  notIn?: Maybe<Array<AutomatedTriggerType>>;
};

export type NestedEnumAutomatedTriggerTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumAutomatedTriggerTypeNullableFilter>;
  _min?: Maybe<NestedEnumAutomatedTriggerTypeNullableFilter>;
  equals?: Maybe<AutomatedTriggerType>;
  in?: Maybe<Array<AutomatedTriggerType>>;
  not?: Maybe<NestedEnumAutomatedTriggerTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<AutomatedTriggerType>>;
};

export type NestedEnumAutomationRunActionPromptTypeFilter = {
  equals?: Maybe<AutomationRunActionPromptType>;
  in?: Maybe<Array<AutomationRunActionPromptType>>;
  not?: Maybe<NestedEnumAutomationRunActionPromptTypeFilter>;
  notIn?: Maybe<Array<AutomationRunActionPromptType>>;
};

export type NestedEnumAutomationRunActionPromptTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAutomationRunActionPromptTypeFilter>;
  _min?: Maybe<NestedEnumAutomationRunActionPromptTypeFilter>;
  equals?: Maybe<AutomationRunActionPromptType>;
  in?: Maybe<Array<AutomationRunActionPromptType>>;
  not?: Maybe<NestedEnumAutomationRunActionPromptTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<AutomationRunActionPromptType>>;
};

export type NestedEnumAutomationRunActionTypeFilter = {
  equals?: Maybe<AutomationRunActionType>;
  in?: Maybe<Array<AutomationRunActionType>>;
  not?: Maybe<NestedEnumAutomationRunActionTypeFilter>;
  notIn?: Maybe<Array<AutomationRunActionType>>;
};

export type NestedEnumAutomationRunActionTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAutomationRunActionTypeFilter>;
  _min?: Maybe<NestedEnumAutomationRunActionTypeFilter>;
  equals?: Maybe<AutomationRunActionType>;
  in?: Maybe<Array<AutomationRunActionType>>;
  not?: Maybe<NestedEnumAutomationRunActionTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<AutomationRunActionType>>;
};

export type NestedEnumAutomationRunStatusFilter = {
  equals?: Maybe<AutomationRunStatus>;
  in?: Maybe<Array<AutomationRunStatus>>;
  not?: Maybe<NestedEnumAutomationRunStatusFilter>;
  notIn?: Maybe<Array<AutomationRunStatus>>;
};

export type NestedEnumAutomationRunStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAutomationRunStatusFilter>;
  _min?: Maybe<NestedEnumAutomationRunStatusFilter>;
  equals?: Maybe<AutomationRunStatus>;
  in?: Maybe<Array<AutomationRunStatus>>;
  not?: Maybe<NestedEnumAutomationRunStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<AutomationRunStatus>>;
};

export type NestedEnumAutomationRunTypeFilter = {
  equals?: Maybe<AutomationRunType>;
  in?: Maybe<Array<AutomationRunType>>;
  not?: Maybe<NestedEnumAutomationRunTypeFilter>;
  notIn?: Maybe<Array<AutomationRunType>>;
};

export type NestedEnumAutomationRunTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAutomationRunTypeFilter>;
  _min?: Maybe<NestedEnumAutomationRunTypeFilter>;
  equals?: Maybe<AutomationRunType>;
  in?: Maybe<Array<AutomationRunType>>;
  not?: Maybe<NestedEnumAutomationRunTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<AutomationRunType>>;
};

export type NestedEnumAutomationStatusFilter = {
  equals?: Maybe<AutomationStatus>;
  in?: Maybe<Array<AutomationStatus>>;
  not?: Maybe<NestedEnumAutomationStatusFilter>;
  notIn?: Maybe<Array<AutomationStatus>>;
};

export type NestedEnumAutomationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAutomationStatusFilter>;
  _min?: Maybe<NestedEnumAutomationStatusFilter>;
  equals?: Maybe<AutomationStatus>;
  in?: Maybe<Array<AutomationStatus>>;
  not?: Maybe<NestedEnumAutomationStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<AutomationStatus>>;
};

export type NestedEnumAxionClinicConfigurationStatusFilter = {
  equals?: Maybe<AxionClinicConfigurationStatus>;
  in?: Maybe<Array<AxionClinicConfigurationStatus>>;
  not?: Maybe<NestedEnumAxionClinicConfigurationStatusFilter>;
  notIn?: Maybe<Array<AxionClinicConfigurationStatus>>;
};

export type NestedEnumAxionClinicConfigurationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumAxionClinicConfigurationStatusFilter>;
  _min?: Maybe<NestedEnumAxionClinicConfigurationStatusFilter>;
  equals?: Maybe<AxionClinicConfigurationStatus>;
  in?: Maybe<Array<AxionClinicConfigurationStatus>>;
  not?: Maybe<NestedEnumAxionClinicConfigurationStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<AxionClinicConfigurationStatus>>;
};

export type NestedEnumBitwerxHealthcheckRunStatusNullableFilter = {
  equals?: Maybe<BitwerxHealthcheckRunStatus>;
  in?: Maybe<Array<BitwerxHealthcheckRunStatus>>;
  not?: Maybe<NestedEnumBitwerxHealthcheckRunStatusNullableFilter>;
  notIn?: Maybe<Array<BitwerxHealthcheckRunStatus>>;
};

export type NestedEnumBitwerxHealthcheckRunStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumBitwerxHealthcheckRunStatusNullableFilter>;
  _min?: Maybe<NestedEnumBitwerxHealthcheckRunStatusNullableFilter>;
  equals?: Maybe<BitwerxHealthcheckRunStatus>;
  in?: Maybe<Array<BitwerxHealthcheckRunStatus>>;
  not?: Maybe<NestedEnumBitwerxHealthcheckRunStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<BitwerxHealthcheckRunStatus>>;
};

export type NestedEnumBitwerxHealthcheckTypeFilter = {
  equals?: Maybe<BitwerxHealthcheckType>;
  in?: Maybe<Array<BitwerxHealthcheckType>>;
  not?: Maybe<NestedEnumBitwerxHealthcheckTypeFilter>;
  notIn?: Maybe<Array<BitwerxHealthcheckType>>;
};

export type NestedEnumBitwerxHealthcheckTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumBitwerxHealthcheckTypeFilter>;
  _min?: Maybe<NestedEnumBitwerxHealthcheckTypeFilter>;
  equals?: Maybe<BitwerxHealthcheckType>;
  in?: Maybe<Array<BitwerxHealthcheckType>>;
  not?: Maybe<NestedEnumBitwerxHealthcheckTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<BitwerxHealthcheckType>>;
};

export type NestedEnumBitwerxPaymentEndpointFilter = {
  equals?: Maybe<BitwerxPaymentEndpoint>;
  in?: Maybe<Array<BitwerxPaymentEndpoint>>;
  not?: Maybe<NestedEnumBitwerxPaymentEndpointFilter>;
  notIn?: Maybe<Array<BitwerxPaymentEndpoint>>;
};

export type NestedEnumBitwerxPaymentEndpointWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumBitwerxPaymentEndpointFilter>;
  _min?: Maybe<NestedEnumBitwerxPaymentEndpointFilter>;
  equals?: Maybe<BitwerxPaymentEndpoint>;
  in?: Maybe<Array<BitwerxPaymentEndpoint>>;
  not?: Maybe<NestedEnumBitwerxPaymentEndpointWithAggregatesFilter>;
  notIn?: Maybe<Array<BitwerxPaymentEndpoint>>;
};

export type NestedEnumBitwerxSystemFilter = {
  equals?: Maybe<BitwerxSystem>;
  in?: Maybe<Array<BitwerxSystem>>;
  not?: Maybe<NestedEnumBitwerxSystemFilter>;
  notIn?: Maybe<Array<BitwerxSystem>>;
};

export type NestedEnumBitwerxSystemWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumBitwerxSystemFilter>;
  _min?: Maybe<NestedEnumBitwerxSystemFilter>;
  equals?: Maybe<BitwerxSystem>;
  in?: Maybe<Array<BitwerxSystem>>;
  not?: Maybe<NestedEnumBitwerxSystemWithAggregatesFilter>;
  notIn?: Maybe<Array<BitwerxSystem>>;
};

export type NestedEnumBoardFilterColumnTypeFilter = {
  equals?: Maybe<BoardFilterColumnType>;
  in?: Maybe<Array<BoardFilterColumnType>>;
  not?: Maybe<NestedEnumBoardFilterColumnTypeFilter>;
  notIn?: Maybe<Array<BoardFilterColumnType>>;
};

export type NestedEnumBoardFilterColumnTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumBoardFilterColumnTypeFilter>;
  _min?: Maybe<NestedEnumBoardFilterColumnTypeFilter>;
  equals?: Maybe<BoardFilterColumnType>;
  in?: Maybe<Array<BoardFilterColumnType>>;
  not?: Maybe<NestedEnumBoardFilterColumnTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<BoardFilterColumnType>>;
};

export type NestedEnumBoardFilterDateRangeNullableFilter = {
  equals?: Maybe<BoardFilterDateRange>;
  in?: Maybe<Array<BoardFilterDateRange>>;
  not?: Maybe<NestedEnumBoardFilterDateRangeNullableFilter>;
  notIn?: Maybe<Array<BoardFilterDateRange>>;
};

export type NestedEnumBoardFilterDateRangeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumBoardFilterDateRangeNullableFilter>;
  _min?: Maybe<NestedEnumBoardFilterDateRangeNullableFilter>;
  equals?: Maybe<BoardFilterDateRange>;
  in?: Maybe<Array<BoardFilterDateRange>>;
  not?: Maybe<NestedEnumBoardFilterDateRangeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<BoardFilterDateRange>>;
};

export type NestedEnumBoardFilterViewFilter = {
  equals?: Maybe<BoardFilterView>;
  in?: Maybe<Array<BoardFilterView>>;
  not?: Maybe<NestedEnumBoardFilterViewFilter>;
  notIn?: Maybe<Array<BoardFilterView>>;
};

export type NestedEnumBoardFilterViewWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumBoardFilterViewFilter>;
  _min?: Maybe<NestedEnumBoardFilterViewFilter>;
  equals?: Maybe<BoardFilterView>;
  in?: Maybe<Array<BoardFilterView>>;
  not?: Maybe<NestedEnumBoardFilterViewWithAggregatesFilter>;
  notIn?: Maybe<Array<BoardFilterView>>;
};

export type NestedEnumBoehringerIngelheimCustomerAlignmentStatusFilter = {
  equals?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  in?: Maybe<Array<BoehringerIngelheimCustomerAlignmentStatus>>;
  not?: Maybe<NestedEnumBoehringerIngelheimCustomerAlignmentStatusFilter>;
  notIn?: Maybe<Array<BoehringerIngelheimCustomerAlignmentStatus>>;
};

export type NestedEnumBoehringerIngelheimCustomerAlignmentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumBoehringerIngelheimCustomerAlignmentStatusFilter>;
  _min?: Maybe<NestedEnumBoehringerIngelheimCustomerAlignmentStatusFilter>;
  equals?: Maybe<BoehringerIngelheimCustomerAlignmentStatus>;
  in?: Maybe<Array<BoehringerIngelheimCustomerAlignmentStatus>>;
  not?: Maybe<NestedEnumBoehringerIngelheimCustomerAlignmentStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<BoehringerIngelheimCustomerAlignmentStatus>>;
};

export type NestedEnumCallDirectionFilter = {
  equals?: Maybe<CallDirection>;
  in?: Maybe<Array<CallDirection>>;
  not?: Maybe<NestedEnumCallDirectionFilter>;
  notIn?: Maybe<Array<CallDirection>>;
};

export type NestedEnumCallDirectionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCallDirectionFilter>;
  _min?: Maybe<NestedEnumCallDirectionFilter>;
  equals?: Maybe<CallDirection>;
  in?: Maybe<Array<CallDirection>>;
  not?: Maybe<NestedEnumCallDirectionWithAggregatesFilter>;
  notIn?: Maybe<Array<CallDirection>>;
};

export type NestedEnumCallHistoryTypeFilter = {
  equals?: Maybe<CallHistoryType>;
  in?: Maybe<Array<CallHistoryType>>;
  not?: Maybe<NestedEnumCallHistoryTypeFilter>;
  notIn?: Maybe<Array<CallHistoryType>>;
};

export type NestedEnumCallHistoryTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCallHistoryTypeFilter>;
  _min?: Maybe<NestedEnumCallHistoryTypeFilter>;
  equals?: Maybe<CallHistoryType>;
  in?: Maybe<Array<CallHistoryType>>;
  not?: Maybe<NestedEnumCallHistoryTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CallHistoryType>>;
};

export type NestedEnumCallParticipantResultNullableFilter = {
  equals?: Maybe<CallParticipantResult>;
  in?: Maybe<Array<CallParticipantResult>>;
  not?: Maybe<NestedEnumCallParticipantResultNullableFilter>;
  notIn?: Maybe<Array<CallParticipantResult>>;
};

export type NestedEnumCallParticipantResultNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCallParticipantResultNullableFilter>;
  _min?: Maybe<NestedEnumCallParticipantResultNullableFilter>;
  equals?: Maybe<CallParticipantResult>;
  in?: Maybe<Array<CallParticipantResult>>;
  not?: Maybe<NestedEnumCallParticipantResultNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CallParticipantResult>>;
};

export type NestedEnumCallProviderFilter = {
  equals?: Maybe<CallProvider>;
  in?: Maybe<Array<CallProvider>>;
  not?: Maybe<NestedEnumCallProviderFilter>;
  notIn?: Maybe<Array<CallProvider>>;
};

export type NestedEnumCallProviderWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCallProviderFilter>;
  _min?: Maybe<NestedEnumCallProviderFilter>;
  equals?: Maybe<CallProvider>;
  in?: Maybe<Array<CallProvider>>;
  not?: Maybe<NestedEnumCallProviderWithAggregatesFilter>;
  notIn?: Maybe<Array<CallProvider>>;
};

export type NestedEnumCallStatusFilter = {
  equals?: Maybe<CallStatus>;
  in?: Maybe<Array<CallStatus>>;
  not?: Maybe<NestedEnumCallStatusFilter>;
  notIn?: Maybe<Array<CallStatus>>;
};

export type NestedEnumCallStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCallStatusFilter>;
  _min?: Maybe<NestedEnumCallStatusFilter>;
  equals?: Maybe<CallStatus>;
  in?: Maybe<Array<CallStatus>>;
  not?: Maybe<NestedEnumCallStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<CallStatus>>;
};

export type NestedEnumCampaignRegistryBrandIdentityStatusNullableFilter = {
  equals?: Maybe<CampaignRegistryBrandIdentityStatus>;
  in?: Maybe<Array<CampaignRegistryBrandIdentityStatus>>;
  not?: Maybe<NestedEnumCampaignRegistryBrandIdentityStatusNullableFilter>;
  notIn?: Maybe<Array<CampaignRegistryBrandIdentityStatus>>;
};

export type NestedEnumCampaignRegistryBrandIdentityStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCampaignRegistryBrandIdentityStatusNullableFilter>;
  _min?: Maybe<NestedEnumCampaignRegistryBrandIdentityStatusNullableFilter>;
  equals?: Maybe<CampaignRegistryBrandIdentityStatus>;
  in?: Maybe<Array<CampaignRegistryBrandIdentityStatus>>;
  not?: Maybe<NestedEnumCampaignRegistryBrandIdentityStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CampaignRegistryBrandIdentityStatus>>;
};

export type NestedEnumCampaignRegistryCampaignSharingStatusNullableFilter = {
  equals?: Maybe<CampaignRegistryCampaignSharingStatus>;
  in?: Maybe<Array<CampaignRegistryCampaignSharingStatus>>;
  not?: Maybe<NestedEnumCampaignRegistryCampaignSharingStatusNullableFilter>;
  notIn?: Maybe<Array<CampaignRegistryCampaignSharingStatus>>;
};

export type NestedEnumCampaignRegistryCampaignSharingStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCampaignRegistryCampaignSharingStatusNullableFilter>;
  _min?: Maybe<NestedEnumCampaignRegistryCampaignSharingStatusNullableFilter>;
  equals?: Maybe<CampaignRegistryCampaignSharingStatus>;
  in?: Maybe<Array<CampaignRegistryCampaignSharingStatus>>;
  not?: Maybe<NestedEnumCampaignRegistryCampaignSharingStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CampaignRegistryCampaignSharingStatus>>;
};

export type NestedEnumCancelReasonTypeNullableFilter = {
  equals?: Maybe<CancelReasonType>;
  in?: Maybe<Array<CancelReasonType>>;
  not?: Maybe<NestedEnumCancelReasonTypeNullableFilter>;
  notIn?: Maybe<Array<CancelReasonType>>;
};

export type NestedEnumCancelReasonTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCancelReasonTypeNullableFilter>;
  _min?: Maybe<NestedEnumCancelReasonTypeNullableFilter>;
  equals?: Maybe<CancelReasonType>;
  in?: Maybe<Array<CancelReasonType>>;
  not?: Maybe<NestedEnumCancelReasonTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CancelReasonType>>;
};

export type NestedEnumCanonicalDataSourceFilter = {
  equals?: Maybe<CanonicalDataSource>;
  in?: Maybe<Array<CanonicalDataSource>>;
  not?: Maybe<NestedEnumCanonicalDataSourceFilter>;
  notIn?: Maybe<Array<CanonicalDataSource>>;
};

export type NestedEnumCanonicalDataSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCanonicalDataSourceFilter>;
  _min?: Maybe<NestedEnumCanonicalDataSourceFilter>;
  equals?: Maybe<CanonicalDataSource>;
  in?: Maybe<Array<CanonicalDataSource>>;
  not?: Maybe<NestedEnumCanonicalDataSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<CanonicalDataSource>>;
};

export type NestedEnumCanonicalServiceStatusFilter = {
  equals?: Maybe<CanonicalServiceStatus>;
  in?: Maybe<Array<CanonicalServiceStatus>>;
  not?: Maybe<NestedEnumCanonicalServiceStatusFilter>;
  notIn?: Maybe<Array<CanonicalServiceStatus>>;
};

export type NestedEnumCanonicalServiceStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCanonicalServiceStatusFilter>;
  _min?: Maybe<NestedEnumCanonicalServiceStatusFilter>;
  equals?: Maybe<CanonicalServiceStatus>;
  in?: Maybe<Array<CanonicalServiceStatus>>;
  not?: Maybe<NestedEnumCanonicalServiceStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<CanonicalServiceStatus>>;
};

export type NestedEnumCanonicalServiceTypeFilter = {
  equals?: Maybe<CanonicalServiceType>;
  in?: Maybe<Array<CanonicalServiceType>>;
  not?: Maybe<NestedEnumCanonicalServiceTypeFilter>;
  notIn?: Maybe<Array<CanonicalServiceType>>;
};

export type NestedEnumCanonicalServiceTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCanonicalServiceTypeFilter>;
  _min?: Maybe<NestedEnumCanonicalServiceTypeFilter>;
  equals?: Maybe<CanonicalServiceType>;
  in?: Maybe<Array<CanonicalServiceType>>;
  not?: Maybe<NestedEnumCanonicalServiceTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CanonicalServiceType>>;
};

export type NestedEnumCardBrandFilter = {
  equals?: Maybe<CardBrand>;
  in?: Maybe<Array<CardBrand>>;
  not?: Maybe<NestedEnumCardBrandFilter>;
  notIn?: Maybe<Array<CardBrand>>;
};

export type NestedEnumCardBrandNullableFilter = {
  equals?: Maybe<CardBrand>;
  in?: Maybe<Array<CardBrand>>;
  not?: Maybe<NestedEnumCardBrandNullableFilter>;
  notIn?: Maybe<Array<CardBrand>>;
};

export type NestedEnumCardBrandNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCardBrandNullableFilter>;
  _min?: Maybe<NestedEnumCardBrandNullableFilter>;
  equals?: Maybe<CardBrand>;
  in?: Maybe<Array<CardBrand>>;
  not?: Maybe<NestedEnumCardBrandNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CardBrand>>;
};

export type NestedEnumCardBrandWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCardBrandFilter>;
  _min?: Maybe<NestedEnumCardBrandFilter>;
  equals?: Maybe<CardBrand>;
  in?: Maybe<Array<CardBrand>>;
  not?: Maybe<NestedEnumCardBrandWithAggregatesFilter>;
  notIn?: Maybe<Array<CardBrand>>;
};

export type NestedEnumCardFundingNullableFilter = {
  equals?: Maybe<CardFunding>;
  in?: Maybe<Array<CardFunding>>;
  not?: Maybe<NestedEnumCardFundingNullableFilter>;
  notIn?: Maybe<Array<CardFunding>>;
};

export type NestedEnumCardFundingNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCardFundingNullableFilter>;
  _min?: Maybe<NestedEnumCardFundingNullableFilter>;
  equals?: Maybe<CardFunding>;
  in?: Maybe<Array<CardFunding>>;
  not?: Maybe<NestedEnumCardFundingNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CardFunding>>;
};

export type NestedEnumCareBenefitTypeFilter = {
  equals?: Maybe<CareBenefitType>;
  in?: Maybe<Array<CareBenefitType>>;
  not?: Maybe<NestedEnumCareBenefitTypeFilter>;
  notIn?: Maybe<Array<CareBenefitType>>;
};

export type NestedEnumCareBenefitTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCareBenefitTypeFilter>;
  _min?: Maybe<NestedEnumCareBenefitTypeFilter>;
  equals?: Maybe<CareBenefitType>;
  in?: Maybe<Array<CareBenefitType>>;
  not?: Maybe<NestedEnumCareBenefitTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CareBenefitType>>;
};

export type NestedEnumCareBenefitUnitOfMeasureNullableFilter = {
  equals?: Maybe<CareBenefitUnitOfMeasure>;
  in?: Maybe<Array<CareBenefitUnitOfMeasure>>;
  not?: Maybe<NestedEnumCareBenefitUnitOfMeasureNullableFilter>;
  notIn?: Maybe<Array<CareBenefitUnitOfMeasure>>;
};

export type NestedEnumCareBenefitUnitOfMeasureNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCareBenefitUnitOfMeasureNullableFilter>;
  _min?: Maybe<NestedEnumCareBenefitUnitOfMeasureNullableFilter>;
  equals?: Maybe<CareBenefitUnitOfMeasure>;
  in?: Maybe<Array<CareBenefitUnitOfMeasure>>;
  not?: Maybe<NestedEnumCareBenefitUnitOfMeasureNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CareBenefitUnitOfMeasure>>;
};

export type NestedEnumCareCreditPreapprovalDecisionNullableFilter = {
  equals?: Maybe<CareCreditPreapprovalDecision>;
  in?: Maybe<Array<CareCreditPreapprovalDecision>>;
  not?: Maybe<NestedEnumCareCreditPreapprovalDecisionNullableFilter>;
  notIn?: Maybe<Array<CareCreditPreapprovalDecision>>;
};

export type NestedEnumCareCreditPreapprovalDecisionNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCareCreditPreapprovalDecisionNullableFilter>;
  _min?: Maybe<NestedEnumCareCreditPreapprovalDecisionNullableFilter>;
  equals?: Maybe<CareCreditPreapprovalDecision>;
  in?: Maybe<Array<CareCreditPreapprovalDecision>>;
  not?: Maybe<NestedEnumCareCreditPreapprovalDecisionNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CareCreditPreapprovalDecision>>;
};

export type NestedEnumCareLapsedPaymentStatusFilter = {
  equals?: Maybe<CareLapsedPaymentStatus>;
  in?: Maybe<Array<CareLapsedPaymentStatus>>;
  not?: Maybe<NestedEnumCareLapsedPaymentStatusFilter>;
  notIn?: Maybe<Array<CareLapsedPaymentStatus>>;
};

export type NestedEnumCareLapsedPaymentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCareLapsedPaymentStatusFilter>;
  _min?: Maybe<NestedEnumCareLapsedPaymentStatusFilter>;
  equals?: Maybe<CareLapsedPaymentStatus>;
  in?: Maybe<Array<CareLapsedPaymentStatus>>;
  not?: Maybe<NestedEnumCareLapsedPaymentStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<CareLapsedPaymentStatus>>;
};

export type NestedEnumCarePlanCycleTypeFilter = {
  equals?: Maybe<CarePlanCycleType>;
  in?: Maybe<Array<CarePlanCycleType>>;
  not?: Maybe<NestedEnumCarePlanCycleTypeFilter>;
  notIn?: Maybe<Array<CarePlanCycleType>>;
};

export type NestedEnumCarePlanCycleTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCarePlanCycleTypeFilter>;
  _min?: Maybe<NestedEnumCarePlanCycleTypeFilter>;
  equals?: Maybe<CarePlanCycleType>;
  in?: Maybe<Array<CarePlanCycleType>>;
  not?: Maybe<NestedEnumCarePlanCycleTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CarePlanCycleType>>;
};

export type NestedEnumCareProgramLaunchStatusFilter = {
  equals?: Maybe<CareProgramLaunchStatus>;
  in?: Maybe<Array<CareProgramLaunchStatus>>;
  not?: Maybe<NestedEnumCareProgramLaunchStatusFilter>;
  notIn?: Maybe<Array<CareProgramLaunchStatus>>;
};

export type NestedEnumCareProgramLaunchStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCareProgramLaunchStatusFilter>;
  _min?: Maybe<NestedEnumCareProgramLaunchStatusFilter>;
  equals?: Maybe<CareProgramLaunchStatus>;
  in?: Maybe<Array<CareProgramLaunchStatus>>;
  not?: Maybe<NestedEnumCareProgramLaunchStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<CareProgramLaunchStatus>>;
};

export type NestedEnumCareSubscriptionPaymentStatusNullableFilter = {
  equals?: Maybe<CareSubscriptionPaymentStatus>;
  in?: Maybe<Array<CareSubscriptionPaymentStatus>>;
  not?: Maybe<NestedEnumCareSubscriptionPaymentStatusNullableFilter>;
  notIn?: Maybe<Array<CareSubscriptionPaymentStatus>>;
};

export type NestedEnumCareSubscriptionPaymentStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCareSubscriptionPaymentStatusNullableFilter>;
  _min?: Maybe<NestedEnumCareSubscriptionPaymentStatusNullableFilter>;
  equals?: Maybe<CareSubscriptionPaymentStatus>;
  in?: Maybe<Array<CareSubscriptionPaymentStatus>>;
  not?: Maybe<NestedEnumCareSubscriptionPaymentStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CareSubscriptionPaymentStatus>>;
};

export type NestedEnumCareSubscriptionTrueUpStatusFilter = {
  equals?: Maybe<CareSubscriptionTrueUpStatus>;
  in?: Maybe<Array<CareSubscriptionTrueUpStatus>>;
  not?: Maybe<NestedEnumCareSubscriptionTrueUpStatusFilter>;
  notIn?: Maybe<Array<CareSubscriptionTrueUpStatus>>;
};

export type NestedEnumCareSubscriptionTrueUpStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCareSubscriptionTrueUpStatusFilter>;
  _min?: Maybe<NestedEnumCareSubscriptionTrueUpStatusFilter>;
  equals?: Maybe<CareSubscriptionTrueUpStatus>;
  in?: Maybe<Array<CareSubscriptionTrueUpStatus>>;
  not?: Maybe<NestedEnumCareSubscriptionTrueUpStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<CareSubscriptionTrueUpStatus>>;
};

export type NestedEnumCareSubscriptionTrueUpTypeFilter = {
  equals?: Maybe<CareSubscriptionTrueUpType>;
  in?: Maybe<Array<CareSubscriptionTrueUpType>>;
  not?: Maybe<NestedEnumCareSubscriptionTrueUpTypeFilter>;
  notIn?: Maybe<Array<CareSubscriptionTrueUpType>>;
};

export type NestedEnumCareSubscriptionTrueUpTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCareSubscriptionTrueUpTypeFilter>;
  _min?: Maybe<NestedEnumCareSubscriptionTrueUpTypeFilter>;
  equals?: Maybe<CareSubscriptionTrueUpType>;
  in?: Maybe<Array<CareSubscriptionTrueUpType>>;
  not?: Maybe<NestedEnumCareSubscriptionTrueUpTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CareSubscriptionTrueUpType>>;
};

export type NestedEnumChannelCreationSourceTypeFilter = {
  equals?: Maybe<ChannelCreationSourceType>;
  in?: Maybe<Array<ChannelCreationSourceType>>;
  not?: Maybe<NestedEnumChannelCreationSourceTypeFilter>;
  notIn?: Maybe<Array<ChannelCreationSourceType>>;
};

export type NestedEnumChannelCreationSourceTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumChannelCreationSourceTypeFilter>;
  _min?: Maybe<NestedEnumChannelCreationSourceTypeFilter>;
  equals?: Maybe<ChannelCreationSourceType>;
  in?: Maybe<Array<ChannelCreationSourceType>>;
  not?: Maybe<NestedEnumChannelCreationSourceTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelCreationSourceType>>;
};

export type NestedEnumChannelMessageAttachmentEntityTypeNullableFilter = {
  equals?: Maybe<ChannelMessageAttachmentEntityType>;
  in?: Maybe<Array<ChannelMessageAttachmentEntityType>>;
  not?: Maybe<NestedEnumChannelMessageAttachmentEntityTypeNullableFilter>;
  notIn?: Maybe<Array<ChannelMessageAttachmentEntityType>>;
};

export type NestedEnumChannelMessageAttachmentEntityTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumChannelMessageAttachmentEntityTypeNullableFilter>;
  _min?: Maybe<NestedEnumChannelMessageAttachmentEntityTypeNullableFilter>;
  equals?: Maybe<ChannelMessageAttachmentEntityType>;
  in?: Maybe<Array<ChannelMessageAttachmentEntityType>>;
  not?: Maybe<NestedEnumChannelMessageAttachmentEntityTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelMessageAttachmentEntityType>>;
};

export type NestedEnumChannelMessageAttachmentTypeFilter = {
  equals?: Maybe<ChannelMessageAttachmentType>;
  in?: Maybe<Array<ChannelMessageAttachmentType>>;
  not?: Maybe<NestedEnumChannelMessageAttachmentTypeFilter>;
  notIn?: Maybe<Array<ChannelMessageAttachmentType>>;
};

export type NestedEnumChannelMessageAttachmentTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumChannelMessageAttachmentTypeFilter>;
  _min?: Maybe<NestedEnumChannelMessageAttachmentTypeFilter>;
  equals?: Maybe<ChannelMessageAttachmentType>;
  in?: Maybe<Array<ChannelMessageAttachmentType>>;
  not?: Maybe<NestedEnumChannelMessageAttachmentTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelMessageAttachmentType>>;
};

export type NestedEnumChannelMessageAttachmentUploadStatusNullableFilter = {
  equals?: Maybe<ChannelMessageAttachmentUploadStatus>;
  in?: Maybe<Array<ChannelMessageAttachmentUploadStatus>>;
  not?: Maybe<NestedEnumChannelMessageAttachmentUploadStatusNullableFilter>;
  notIn?: Maybe<Array<ChannelMessageAttachmentUploadStatus>>;
};

export type NestedEnumChannelMessageAttachmentUploadStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumChannelMessageAttachmentUploadStatusNullableFilter>;
  _min?: Maybe<NestedEnumChannelMessageAttachmentUploadStatusNullableFilter>;
  equals?: Maybe<ChannelMessageAttachmentUploadStatus>;
  in?: Maybe<Array<ChannelMessageAttachmentUploadStatus>>;
  not?: Maybe<NestedEnumChannelMessageAttachmentUploadStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelMessageAttachmentUploadStatus>>;
};

export type NestedEnumChannelStatusActionFilter = {
  equals?: Maybe<ChannelStatusAction>;
  in?: Maybe<Array<ChannelStatusAction>>;
  not?: Maybe<NestedEnumChannelStatusActionFilter>;
  notIn?: Maybe<Array<ChannelStatusAction>>;
};

export type NestedEnumChannelStatusActionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumChannelStatusActionFilter>;
  _min?: Maybe<NestedEnumChannelStatusActionFilter>;
  equals?: Maybe<ChannelStatusAction>;
  in?: Maybe<Array<ChannelStatusAction>>;
  not?: Maybe<NestedEnumChannelStatusActionWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelStatusAction>>;
};

export type NestedEnumChannelTypeNullableFilter = {
  equals?: Maybe<ChannelType>;
  in?: Maybe<Array<ChannelType>>;
  not?: Maybe<NestedEnumChannelTypeNullableFilter>;
  notIn?: Maybe<Array<ChannelType>>;
};

export type NestedEnumChannelTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumChannelTypeNullableFilter>;
  _min?: Maybe<NestedEnumChannelTypeNullableFilter>;
  equals?: Maybe<ChannelType>;
  in?: Maybe<Array<ChannelType>>;
  not?: Maybe<NestedEnumChannelTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelType>>;
};

export type NestedEnumChannelVisibilityNullableFilter = {
  equals?: Maybe<ChannelVisibility>;
  in?: Maybe<Array<ChannelVisibility>>;
  not?: Maybe<NestedEnumChannelVisibilityNullableFilter>;
  notIn?: Maybe<Array<ChannelVisibility>>;
};

export type NestedEnumChannelVisibilityNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumChannelVisibilityNullableFilter>;
  _min?: Maybe<NestedEnumChannelVisibilityNullableFilter>;
  equals?: Maybe<ChannelVisibility>;
  in?: Maybe<Array<ChannelVisibility>>;
  not?: Maybe<NestedEnumChannelVisibilityNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ChannelVisibility>>;
};

export type NestedEnumChargeCaptureTypeFilter = {
  equals?: Maybe<ChargeCaptureType>;
  in?: Maybe<Array<ChargeCaptureType>>;
  not?: Maybe<NestedEnumChargeCaptureTypeFilter>;
  notIn?: Maybe<Array<ChargeCaptureType>>;
};

export type NestedEnumChargeCaptureTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumChargeCaptureTypeFilter>;
  _min?: Maybe<NestedEnumChargeCaptureTypeFilter>;
  equals?: Maybe<ChargeCaptureType>;
  in?: Maybe<Array<ChargeCaptureType>>;
  not?: Maybe<NestedEnumChargeCaptureTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ChargeCaptureType>>;
};

export type NestedEnumClientConnectClinicSoftwareFilter = {
  equals?: Maybe<ClientConnectClinicSoftware>;
  in?: Maybe<Array<ClientConnectClinicSoftware>>;
  not?: Maybe<NestedEnumClientConnectClinicSoftwareFilter>;
  notIn?: Maybe<Array<ClientConnectClinicSoftware>>;
};

export type NestedEnumClientConnectClinicSoftwareWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClientConnectClinicSoftwareFilter>;
  _min?: Maybe<NestedEnumClientConnectClinicSoftwareFilter>;
  equals?: Maybe<ClientConnectClinicSoftware>;
  in?: Maybe<Array<ClientConnectClinicSoftware>>;
  not?: Maybe<NestedEnumClientConnectClinicSoftwareWithAggregatesFilter>;
  notIn?: Maybe<Array<ClientConnectClinicSoftware>>;
};

export type NestedEnumClientConnectSystemFilter = {
  equals?: Maybe<ClientConnectSystem>;
  in?: Maybe<Array<ClientConnectSystem>>;
  not?: Maybe<NestedEnumClientConnectSystemFilter>;
  notIn?: Maybe<Array<ClientConnectSystem>>;
};

export type NestedEnumClientConnectSystemWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClientConnectSystemFilter>;
  _min?: Maybe<NestedEnumClientConnectSystemFilter>;
  equals?: Maybe<ClientConnectSystem>;
  in?: Maybe<Array<ClientConnectSystem>>;
  not?: Maybe<NestedEnumClientConnectSystemWithAggregatesFilter>;
  notIn?: Maybe<Array<ClientConnectSystem>>;
};

export type NestedEnumClinicCustomPayoutsSetupStatusFilter = {
  equals?: Maybe<ClinicCustomPayoutsSetupStatus>;
  in?: Maybe<Array<ClinicCustomPayoutsSetupStatus>>;
  not?: Maybe<NestedEnumClinicCustomPayoutsSetupStatusFilter>;
  notIn?: Maybe<Array<ClinicCustomPayoutsSetupStatus>>;
};

export type NestedEnumClinicCustomPayoutsSetupStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClinicCustomPayoutsSetupStatusFilter>;
  _min?: Maybe<NestedEnumClinicCustomPayoutsSetupStatusFilter>;
  equals?: Maybe<ClinicCustomPayoutsSetupStatus>;
  in?: Maybe<Array<ClinicCustomPayoutsSetupStatus>>;
  not?: Maybe<NestedEnumClinicCustomPayoutsSetupStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicCustomPayoutsSetupStatus>>;
};

export type NestedEnumClinicEntityCreationSourceNullableFilter = {
  equals?: Maybe<ClinicEntityCreationSource>;
  in?: Maybe<Array<ClinicEntityCreationSource>>;
  not?: Maybe<NestedEnumClinicEntityCreationSourceNullableFilter>;
  notIn?: Maybe<Array<ClinicEntityCreationSource>>;
};

export type NestedEnumClinicEntityCreationSourceNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumClinicEntityCreationSourceNullableFilter>;
  _min?: Maybe<NestedEnumClinicEntityCreationSourceNullableFilter>;
  equals?: Maybe<ClinicEntityCreationSource>;
  in?: Maybe<Array<ClinicEntityCreationSource>>;
  not?: Maybe<NestedEnumClinicEntityCreationSourceNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicEntityCreationSource>>;
};

export type NestedEnumClinicEntityPhoneNumberSmsStatusNullableFilter = {
  equals?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  in?: Maybe<Array<ClinicEntityPhoneNumberSmsStatus>>;
  not?: Maybe<NestedEnumClinicEntityPhoneNumberSmsStatusNullableFilter>;
  notIn?: Maybe<Array<ClinicEntityPhoneNumberSmsStatus>>;
};

export type NestedEnumClinicEntityPhoneNumberSmsStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumClinicEntityPhoneNumberSmsStatusNullableFilter>;
  _min?: Maybe<NestedEnumClinicEntityPhoneNumberSmsStatusNullableFilter>;
  equals?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
  in?: Maybe<Array<ClinicEntityPhoneNumberSmsStatus>>;
  not?: Maybe<NestedEnumClinicEntityPhoneNumberSmsStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicEntityPhoneNumberSmsStatus>>;
};

export type NestedEnumClinicModuleSourceFilter = {
  equals?: Maybe<ClinicModuleSource>;
  in?: Maybe<Array<ClinicModuleSource>>;
  not?: Maybe<NestedEnumClinicModuleSourceFilter>;
  notIn?: Maybe<Array<ClinicModuleSource>>;
};

export type NestedEnumClinicModuleSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClinicModuleSourceFilter>;
  _min?: Maybe<NestedEnumClinicModuleSourceFilter>;
  equals?: Maybe<ClinicModuleSource>;
  in?: Maybe<Array<ClinicModuleSource>>;
  not?: Maybe<NestedEnumClinicModuleSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicModuleSource>>;
};

export type NestedEnumClinicOfficeHoursTypeFilter = {
  equals?: Maybe<ClinicOfficeHoursType>;
  in?: Maybe<Array<ClinicOfficeHoursType>>;
  not?: Maybe<NestedEnumClinicOfficeHoursTypeFilter>;
  notIn?: Maybe<Array<ClinicOfficeHoursType>>;
};

export type NestedEnumClinicOfficeHoursTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClinicOfficeHoursTypeFilter>;
  _min?: Maybe<NestedEnumClinicOfficeHoursTypeFilter>;
  equals?: Maybe<ClinicOfficeHoursType>;
  in?: Maybe<Array<ClinicOfficeHoursType>>;
  not?: Maybe<NestedEnumClinicOfficeHoursTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicOfficeHoursType>>;
};

export type NestedEnumClinicPetParentAddressTypeNullableFilter = {
  equals?: Maybe<ClinicPetParentAddressType>;
  in?: Maybe<Array<ClinicPetParentAddressType>>;
  not?: Maybe<NestedEnumClinicPetParentAddressTypeNullableFilter>;
  notIn?: Maybe<Array<ClinicPetParentAddressType>>;
};

export type NestedEnumClinicPetParentAddressTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumClinicPetParentAddressTypeNullableFilter>;
  _min?: Maybe<NestedEnumClinicPetParentAddressTypeNullableFilter>;
  equals?: Maybe<ClinicPetParentAddressType>;
  in?: Maybe<Array<ClinicPetParentAddressType>>;
  not?: Maybe<NestedEnumClinicPetParentAddressTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicPetParentAddressType>>;
};

export type NestedEnumClinicPimsIntegrationTypeFilter = {
  equals?: Maybe<ClinicPimsIntegrationType>;
  in?: Maybe<Array<ClinicPimsIntegrationType>>;
  not?: Maybe<NestedEnumClinicPimsIntegrationTypeFilter>;
  notIn?: Maybe<Array<ClinicPimsIntegrationType>>;
};

export type NestedEnumClinicPimsIntegrationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClinicPimsIntegrationTypeFilter>;
  _min?: Maybe<NestedEnumClinicPimsIntegrationTypeFilter>;
  equals?: Maybe<ClinicPimsIntegrationType>;
  in?: Maybe<Array<ClinicPimsIntegrationType>>;
  not?: Maybe<NestedEnumClinicPimsIntegrationTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicPimsIntegrationType>>;
};

export type NestedEnumClinicUserFilterTypeFilter = {
  equals?: Maybe<ClinicUserFilterType>;
  in?: Maybe<Array<ClinicUserFilterType>>;
  not?: Maybe<NestedEnumClinicUserFilterTypeFilter>;
  notIn?: Maybe<Array<ClinicUserFilterType>>;
};

export type NestedEnumClinicUserFilterTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumClinicUserFilterTypeFilter>;
  _min?: Maybe<NestedEnumClinicUserFilterTypeFilter>;
  equals?: Maybe<ClinicUserFilterType>;
  in?: Maybe<Array<ClinicUserFilterType>>;
  not?: Maybe<NestedEnumClinicUserFilterTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ClinicUserFilterType>>;
};

export type NestedEnumConditionAttributeFilter = {
  equals?: Maybe<ConditionAttribute>;
  in?: Maybe<Array<ConditionAttribute>>;
  not?: Maybe<NestedEnumConditionAttributeFilter>;
  notIn?: Maybe<Array<ConditionAttribute>>;
};

export type NestedEnumConditionAttributeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumConditionAttributeFilter>;
  _min?: Maybe<NestedEnumConditionAttributeFilter>;
  equals?: Maybe<ConditionAttribute>;
  in?: Maybe<Array<ConditionAttribute>>;
  not?: Maybe<NestedEnumConditionAttributeWithAggregatesFilter>;
  notIn?: Maybe<Array<ConditionAttribute>>;
};

export type NestedEnumConditionEvaluationStatusFilter = {
  equals?: Maybe<ConditionEvaluationStatus>;
  in?: Maybe<Array<ConditionEvaluationStatus>>;
  not?: Maybe<NestedEnumConditionEvaluationStatusFilter>;
  notIn?: Maybe<Array<ConditionEvaluationStatus>>;
};

export type NestedEnumConditionEvaluationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumConditionEvaluationStatusFilter>;
  _min?: Maybe<NestedEnumConditionEvaluationStatusFilter>;
  equals?: Maybe<ConditionEvaluationStatus>;
  in?: Maybe<Array<ConditionEvaluationStatus>>;
  not?: Maybe<NestedEnumConditionEvaluationStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<ConditionEvaluationStatus>>;
};

export type NestedEnumConditionOperatorFilter = {
  equals?: Maybe<ConditionOperator>;
  in?: Maybe<Array<ConditionOperator>>;
  not?: Maybe<NestedEnumConditionOperatorFilter>;
  notIn?: Maybe<Array<ConditionOperator>>;
};

export type NestedEnumConditionOperatorWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumConditionOperatorFilter>;
  _min?: Maybe<NestedEnumConditionOperatorFilter>;
  equals?: Maybe<ConditionOperator>;
  in?: Maybe<Array<ConditionOperator>>;
  not?: Maybe<NestedEnumConditionOperatorWithAggregatesFilter>;
  notIn?: Maybe<Array<ConditionOperator>>;
};

export type NestedEnumConditionSetOperatorFilter = {
  equals?: Maybe<ConditionSetOperator>;
  in?: Maybe<Array<ConditionSetOperator>>;
  not?: Maybe<NestedEnumConditionSetOperatorFilter>;
  notIn?: Maybe<Array<ConditionSetOperator>>;
};

export type NestedEnumConditionSetOperatorWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumConditionSetOperatorFilter>;
  _min?: Maybe<NestedEnumConditionSetOperatorFilter>;
  equals?: Maybe<ConditionSetOperator>;
  in?: Maybe<Array<ConditionSetOperator>>;
  not?: Maybe<NestedEnumConditionSetOperatorWithAggregatesFilter>;
  notIn?: Maybe<Array<ConditionSetOperator>>;
};

export type NestedEnumConditionalEntityTypeFilter = {
  equals?: Maybe<ConditionalEntityType>;
  in?: Maybe<Array<ConditionalEntityType>>;
  not?: Maybe<NestedEnumConditionalEntityTypeFilter>;
  notIn?: Maybe<Array<ConditionalEntityType>>;
};

export type NestedEnumConditionalEntityTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumConditionalEntityTypeFilter>;
  _min?: Maybe<NestedEnumConditionalEntityTypeFilter>;
  equals?: Maybe<ConditionalEntityType>;
  in?: Maybe<Array<ConditionalEntityType>>;
  not?: Maybe<NestedEnumConditionalEntityTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ConditionalEntityType>>;
};

export type NestedEnumContactEntityTypeFilter = {
  equals?: Maybe<ContactEntityType>;
  in?: Maybe<Array<ContactEntityType>>;
  not?: Maybe<NestedEnumContactEntityTypeFilter>;
  notIn?: Maybe<Array<ContactEntityType>>;
};

export type NestedEnumContactEntityTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumContactEntityTypeFilter>;
  _min?: Maybe<NestedEnumContactEntityTypeFilter>;
  equals?: Maybe<ContactEntityType>;
  in?: Maybe<Array<ContactEntityType>>;
  not?: Maybe<NestedEnumContactEntityTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ContactEntityType>>;
};

export type NestedEnumContactVerificationMethodNullableFilter = {
  equals?: Maybe<ContactVerificationMethod>;
  in?: Maybe<Array<ContactVerificationMethod>>;
  not?: Maybe<NestedEnumContactVerificationMethodNullableFilter>;
  notIn?: Maybe<Array<ContactVerificationMethod>>;
};

export type NestedEnumContactVerificationMethodNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumContactVerificationMethodNullableFilter>;
  _min?: Maybe<NestedEnumContactVerificationMethodNullableFilter>;
  equals?: Maybe<ContactVerificationMethod>;
  in?: Maybe<Array<ContactVerificationMethod>>;
  not?: Maybe<NestedEnumContactVerificationMethodNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ContactVerificationMethod>>;
};

export type NestedEnumContextEntityTypeFilter = {
  equals?: Maybe<ContextEntityType>;
  in?: Maybe<Array<ContextEntityType>>;
  not?: Maybe<NestedEnumContextEntityTypeFilter>;
  notIn?: Maybe<Array<ContextEntityType>>;
};

export type NestedEnumContextEntityTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumContextEntityTypeFilter>;
  _min?: Maybe<NestedEnumContextEntityTypeFilter>;
  equals?: Maybe<ContextEntityType>;
  in?: Maybe<Array<ContextEntityType>>;
  not?: Maybe<NestedEnumContextEntityTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ContextEntityType>>;
};

export type NestedEnumCurrencyFilter = {
  equals?: Maybe<Currency>;
  in?: Maybe<Array<Currency>>;
  not?: Maybe<NestedEnumCurrencyFilter>;
  notIn?: Maybe<Array<Currency>>;
};

export type NestedEnumCurrencyWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCurrencyFilter>;
  _min?: Maybe<NestedEnumCurrencyFilter>;
  equals?: Maybe<Currency>;
  in?: Maybe<Array<Currency>>;
  not?: Maybe<NestedEnumCurrencyWithAggregatesFilter>;
  notIn?: Maybe<Array<Currency>>;
};

export type NestedEnumCustomFieldDesignationFilter = {
  equals?: Maybe<CustomFieldDesignation>;
  in?: Maybe<Array<CustomFieldDesignation>>;
  not?: Maybe<NestedEnumCustomFieldDesignationFilter>;
  notIn?: Maybe<Array<CustomFieldDesignation>>;
};

export type NestedEnumCustomFieldDesignationWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCustomFieldDesignationFilter>;
  _min?: Maybe<NestedEnumCustomFieldDesignationFilter>;
  equals?: Maybe<CustomFieldDesignation>;
  in?: Maybe<Array<CustomFieldDesignation>>;
  not?: Maybe<NestedEnumCustomFieldDesignationWithAggregatesFilter>;
  notIn?: Maybe<Array<CustomFieldDesignation>>;
};

export type NestedEnumCustomFieldNormalizedDataTypeFilter = {
  equals?: Maybe<CustomFieldNormalizedDataType>;
  in?: Maybe<Array<CustomFieldNormalizedDataType>>;
  not?: Maybe<NestedEnumCustomFieldNormalizedDataTypeFilter>;
  notIn?: Maybe<Array<CustomFieldNormalizedDataType>>;
};

export type NestedEnumCustomFieldNormalizedDataTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCustomFieldNormalizedDataTypeFilter>;
  _min?: Maybe<NestedEnumCustomFieldNormalizedDataTypeFilter>;
  equals?: Maybe<CustomFieldNormalizedDataType>;
  in?: Maybe<Array<CustomFieldNormalizedDataType>>;
  not?: Maybe<NestedEnumCustomFieldNormalizedDataTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CustomFieldNormalizedDataType>>;
};

export type NestedEnumCustomFieldPimsSyncTypeFilter = {
  equals?: Maybe<CustomFieldPimsSyncType>;
  in?: Maybe<Array<CustomFieldPimsSyncType>>;
  not?: Maybe<NestedEnumCustomFieldPimsSyncTypeFilter>;
  notIn?: Maybe<Array<CustomFieldPimsSyncType>>;
};

export type NestedEnumCustomFieldPimsSyncTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCustomFieldPimsSyncTypeFilter>;
  _min?: Maybe<NestedEnumCustomFieldPimsSyncTypeFilter>;
  equals?: Maybe<CustomFieldPimsSyncType>;
  in?: Maybe<Array<CustomFieldPimsSyncType>>;
  not?: Maybe<NestedEnumCustomFieldPimsSyncTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CustomFieldPimsSyncType>>;
};

export type NestedEnumCustomFieldTargetTypeFilter = {
  equals?: Maybe<CustomFieldTargetType>;
  in?: Maybe<Array<CustomFieldTargetType>>;
  not?: Maybe<NestedEnumCustomFieldTargetTypeFilter>;
  notIn?: Maybe<Array<CustomFieldTargetType>>;
};

export type NestedEnumCustomFieldTargetTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCustomFieldTargetTypeFilter>;
  _min?: Maybe<NestedEnumCustomFieldTargetTypeFilter>;
  equals?: Maybe<CustomFieldTargetType>;
  in?: Maybe<Array<CustomFieldTargetType>>;
  not?: Maybe<NestedEnumCustomFieldTargetTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<CustomFieldTargetType>>;
};

export type NestedEnumCustomFieldsDataSourceNullableFilter = {
  equals?: Maybe<CustomFieldsDataSource>;
  in?: Maybe<Array<CustomFieldsDataSource>>;
  not?: Maybe<NestedEnumCustomFieldsDataSourceNullableFilter>;
  notIn?: Maybe<Array<CustomFieldsDataSource>>;
};

export type NestedEnumCustomFieldsDataSourceNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumCustomFieldsDataSourceNullableFilter>;
  _min?: Maybe<NestedEnumCustomFieldsDataSourceNullableFilter>;
  equals?: Maybe<CustomFieldsDataSource>;
  in?: Maybe<Array<CustomFieldsDataSource>>;
  not?: Maybe<NestedEnumCustomFieldsDataSourceNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<CustomFieldsDataSource>>;
};

export type NestedEnumDeviceOsNullableFilter = {
  equals?: Maybe<DeviceOs>;
  in?: Maybe<Array<DeviceOs>>;
  not?: Maybe<NestedEnumDeviceOsNullableFilter>;
  notIn?: Maybe<Array<DeviceOs>>;
};

export type NestedEnumDeviceOsNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumDeviceOsNullableFilter>;
  _min?: Maybe<NestedEnumDeviceOsNullableFilter>;
  equals?: Maybe<DeviceOs>;
  in?: Maybe<Array<DeviceOs>>;
  not?: Maybe<NestedEnumDeviceOsNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<DeviceOs>>;
};

export type NestedEnumDeviceTypeNullableFilter = {
  equals?: Maybe<DeviceType>;
  in?: Maybe<Array<DeviceType>>;
  not?: Maybe<NestedEnumDeviceTypeNullableFilter>;
  notIn?: Maybe<Array<DeviceType>>;
};

export type NestedEnumDeviceTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumDeviceTypeNullableFilter>;
  _min?: Maybe<NestedEnumDeviceTypeNullableFilter>;
  equals?: Maybe<DeviceType>;
  in?: Maybe<Array<DeviceType>>;
  not?: Maybe<NestedEnumDeviceTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<DeviceType>>;
};

export type NestedEnumDirectBookingAppointmentTypeClientTypeFilter = {
  equals?: Maybe<DirectBookingAppointmentTypeClientType>;
  in?: Maybe<Array<DirectBookingAppointmentTypeClientType>>;
  not?: Maybe<NestedEnumDirectBookingAppointmentTypeClientTypeFilter>;
  notIn?: Maybe<Array<DirectBookingAppointmentTypeClientType>>;
};

export type NestedEnumDirectBookingAppointmentTypeClientTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDirectBookingAppointmentTypeClientTypeFilter>;
  _min?: Maybe<NestedEnumDirectBookingAppointmentTypeClientTypeFilter>;
  equals?: Maybe<DirectBookingAppointmentTypeClientType>;
  in?: Maybe<Array<DirectBookingAppointmentTypeClientType>>;
  not?: Maybe<NestedEnumDirectBookingAppointmentTypeClientTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<DirectBookingAppointmentTypeClientType>>;
};

export type NestedEnumDirectBookingSpeciesOptionFilter = {
  equals?: Maybe<DirectBookingSpeciesOption>;
  in?: Maybe<Array<DirectBookingSpeciesOption>>;
  not?: Maybe<NestedEnumDirectBookingSpeciesOptionFilter>;
  notIn?: Maybe<Array<DirectBookingSpeciesOption>>;
};

export type NestedEnumDirectBookingSpeciesOptionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDirectBookingSpeciesOptionFilter>;
  _min?: Maybe<NestedEnumDirectBookingSpeciesOptionFilter>;
  equals?: Maybe<DirectBookingSpeciesOption>;
  in?: Maybe<Array<DirectBookingSpeciesOption>>;
  not?: Maybe<NestedEnumDirectBookingSpeciesOptionWithAggregatesFilter>;
  notIn?: Maybe<Array<DirectBookingSpeciesOption>>;
};

export type NestedEnumDocumentationCategoryFilter = {
  equals?: Maybe<DocumentationCategory>;
  in?: Maybe<Array<DocumentationCategory>>;
  not?: Maybe<NestedEnumDocumentationCategoryFilter>;
  notIn?: Maybe<Array<DocumentationCategory>>;
};

export type NestedEnumDocumentationCategoryWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentationCategoryFilter>;
  _min?: Maybe<NestedEnumDocumentationCategoryFilter>;
  equals?: Maybe<DocumentationCategory>;
  in?: Maybe<Array<DocumentationCategory>>;
  not?: Maybe<NestedEnumDocumentationCategoryWithAggregatesFilter>;
  notIn?: Maybe<Array<DocumentationCategory>>;
};

export type NestedEnumDocumentationProviderFilter = {
  equals?: Maybe<DocumentationProvider>;
  in?: Maybe<Array<DocumentationProvider>>;
  not?: Maybe<NestedEnumDocumentationProviderFilter>;
  notIn?: Maybe<Array<DocumentationProvider>>;
};

export type NestedEnumDocumentationProviderWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentationProviderFilter>;
  _min?: Maybe<NestedEnumDocumentationProviderFilter>;
  equals?: Maybe<DocumentationProvider>;
  in?: Maybe<Array<DocumentationProvider>>;
  not?: Maybe<NestedEnumDocumentationProviderWithAggregatesFilter>;
  notIn?: Maybe<Array<DocumentationProvider>>;
};

export type NestedEnumEmailCampaignCustomListRecipientStatusFilter = {
  equals?: Maybe<EmailCampaignCustomListRecipientStatus>;
  in?: Maybe<Array<EmailCampaignCustomListRecipientStatus>>;
  not?: Maybe<NestedEnumEmailCampaignCustomListRecipientStatusFilter>;
  notIn?: Maybe<Array<EmailCampaignCustomListRecipientStatus>>;
};

export type NestedEnumEmailCampaignCustomListRecipientStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailCampaignCustomListRecipientStatusFilter>;
  _min?: Maybe<NestedEnumEmailCampaignCustomListRecipientStatusFilter>;
  equals?: Maybe<EmailCampaignCustomListRecipientStatus>;
  in?: Maybe<Array<EmailCampaignCustomListRecipientStatus>>;
  not?: Maybe<NestedEnumEmailCampaignCustomListRecipientStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignCustomListRecipientStatus>>;
};

export type NestedEnumEmailCampaignLogActionFilter = {
  equals?: Maybe<EmailCampaignLogAction>;
  in?: Maybe<Array<EmailCampaignLogAction>>;
  not?: Maybe<NestedEnumEmailCampaignLogActionFilter>;
  notIn?: Maybe<Array<EmailCampaignLogAction>>;
};

export type NestedEnumEmailCampaignLogActionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailCampaignLogActionFilter>;
  _min?: Maybe<NestedEnumEmailCampaignLogActionFilter>;
  equals?: Maybe<EmailCampaignLogAction>;
  in?: Maybe<Array<EmailCampaignLogAction>>;
  not?: Maybe<NestedEnumEmailCampaignLogActionWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignLogAction>>;
};

export type NestedEnumEmailCampaignLogSkipReasonNullableFilter = {
  equals?: Maybe<EmailCampaignLogSkipReason>;
  in?: Maybe<Array<EmailCampaignLogSkipReason>>;
  not?: Maybe<NestedEnumEmailCampaignLogSkipReasonNullableFilter>;
  notIn?: Maybe<Array<EmailCampaignLogSkipReason>>;
};

export type NestedEnumEmailCampaignLogSkipReasonNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumEmailCampaignLogSkipReasonNullableFilter>;
  _min?: Maybe<NestedEnumEmailCampaignLogSkipReasonNullableFilter>;
  equals?: Maybe<EmailCampaignLogSkipReason>;
  in?: Maybe<Array<EmailCampaignLogSkipReason>>;
  not?: Maybe<NestedEnumEmailCampaignLogSkipReasonNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignLogSkipReason>>;
};

export type NestedEnumEmailCampaignSegmentationTypeFilter = {
  equals?: Maybe<EmailCampaignSegmentationType>;
  in?: Maybe<Array<EmailCampaignSegmentationType>>;
  not?: Maybe<NestedEnumEmailCampaignSegmentationTypeFilter>;
  notIn?: Maybe<Array<EmailCampaignSegmentationType>>;
};

export type NestedEnumEmailCampaignSegmentationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailCampaignSegmentationTypeFilter>;
  _min?: Maybe<NestedEnumEmailCampaignSegmentationTypeFilter>;
  equals?: Maybe<EmailCampaignSegmentationType>;
  in?: Maybe<Array<EmailCampaignSegmentationType>>;
  not?: Maybe<NestedEnumEmailCampaignSegmentationTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignSegmentationType>>;
};

export type NestedEnumEmailCampaignStatusFilter = {
  equals?: Maybe<EmailCampaignStatus>;
  in?: Maybe<Array<EmailCampaignStatus>>;
  not?: Maybe<NestedEnumEmailCampaignStatusFilter>;
  notIn?: Maybe<Array<EmailCampaignStatus>>;
};

export type NestedEnumEmailCampaignStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailCampaignStatusFilter>;
  _min?: Maybe<NestedEnumEmailCampaignStatusFilter>;
  equals?: Maybe<EmailCampaignStatus>;
  in?: Maybe<Array<EmailCampaignStatus>>;
  not?: Maybe<NestedEnumEmailCampaignStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignStatus>>;
};

export type NestedEnumEmailCampaignTypeFilter = {
  equals?: Maybe<EmailCampaignType>;
  in?: Maybe<Array<EmailCampaignType>>;
  not?: Maybe<NestedEnumEmailCampaignTypeFilter>;
  notIn?: Maybe<Array<EmailCampaignType>>;
};

export type NestedEnumEmailCampaignTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailCampaignTypeFilter>;
  _min?: Maybe<NestedEnumEmailCampaignTypeFilter>;
  equals?: Maybe<EmailCampaignType>;
  in?: Maybe<Array<EmailCampaignType>>;
  not?: Maybe<NestedEnumEmailCampaignTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignType>>;
};

export type NestedEnumEmailCampaignUnsubscribeSourceFilter = {
  equals?: Maybe<EmailCampaignUnsubscribeSource>;
  in?: Maybe<Array<EmailCampaignUnsubscribeSource>>;
  not?: Maybe<NestedEnumEmailCampaignUnsubscribeSourceFilter>;
  notIn?: Maybe<Array<EmailCampaignUnsubscribeSource>>;
};

export type NestedEnumEmailCampaignUnsubscribeSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailCampaignUnsubscribeSourceFilter>;
  _min?: Maybe<NestedEnumEmailCampaignUnsubscribeSourceFilter>;
  equals?: Maybe<EmailCampaignUnsubscribeSource>;
  in?: Maybe<Array<EmailCampaignUnsubscribeSource>>;
  not?: Maybe<NestedEnumEmailCampaignUnsubscribeSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailCampaignUnsubscribeSource>>;
};

export type NestedEnumEmailProviderFilter = {
  equals?: Maybe<EmailProvider>;
  in?: Maybe<Array<EmailProvider>>;
  not?: Maybe<NestedEnumEmailProviderFilter>;
  notIn?: Maybe<Array<EmailProvider>>;
};

export type NestedEnumEmailProviderLogEntityTypeFilter = {
  equals?: Maybe<EmailProviderLogEntityType>;
  in?: Maybe<Array<EmailProviderLogEntityType>>;
  not?: Maybe<NestedEnumEmailProviderLogEntityTypeFilter>;
  notIn?: Maybe<Array<EmailProviderLogEntityType>>;
};

export type NestedEnumEmailProviderLogEntityTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailProviderLogEntityTypeFilter>;
  _min?: Maybe<NestedEnumEmailProviderLogEntityTypeFilter>;
  equals?: Maybe<EmailProviderLogEntityType>;
  in?: Maybe<Array<EmailProviderLogEntityType>>;
  not?: Maybe<NestedEnumEmailProviderLogEntityTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailProviderLogEntityType>>;
};

export type NestedEnumEmailProviderWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailProviderFilter>;
  _min?: Maybe<NestedEnumEmailProviderFilter>;
  equals?: Maybe<EmailProvider>;
  in?: Maybe<Array<EmailProvider>>;
  not?: Maybe<NestedEnumEmailProviderWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailProvider>>;
};

export type NestedEnumEmailTemplateTypeFilter = {
  equals?: Maybe<EmailTemplateType>;
  in?: Maybe<Array<EmailTemplateType>>;
  not?: Maybe<NestedEnumEmailTemplateTypeFilter>;
  notIn?: Maybe<Array<EmailTemplateType>>;
};

export type NestedEnumEmailTemplateTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEmailTemplateTypeFilter>;
  _min?: Maybe<NestedEnumEmailTemplateTypeFilter>;
  equals?: Maybe<EmailTemplateType>;
  in?: Maybe<Array<EmailTemplateType>>;
  not?: Maybe<NestedEnumEmailTemplateTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<EmailTemplateType>>;
};

export type NestedEnumEncryptedClinicUploadTypeFilter = {
  equals?: Maybe<EncryptedClinicUploadType>;
  in?: Maybe<Array<EncryptedClinicUploadType>>;
  not?: Maybe<NestedEnumEncryptedClinicUploadTypeFilter>;
  notIn?: Maybe<Array<EncryptedClinicUploadType>>;
};

export type NestedEnumEncryptedClinicUploadTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEncryptedClinicUploadTypeFilter>;
  _min?: Maybe<NestedEnumEncryptedClinicUploadTypeFilter>;
  equals?: Maybe<EncryptedClinicUploadType>;
  in?: Maybe<Array<EncryptedClinicUploadType>>;
  not?: Maybe<NestedEnumEncryptedClinicUploadTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<EncryptedClinicUploadType>>;
};

export type NestedEnumEnrollmentStatusFilter = {
  equals?: Maybe<EnrollmentStatus>;
  in?: Maybe<Array<EnrollmentStatus>>;
  not?: Maybe<NestedEnumEnrollmentStatusFilter>;
  notIn?: Maybe<Array<EnrollmentStatus>>;
};

export type NestedEnumEnrollmentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEnrollmentStatusFilter>;
  _min?: Maybe<NestedEnumEnrollmentStatusFilter>;
  equals?: Maybe<EnrollmentStatus>;
  in?: Maybe<Array<EnrollmentStatus>>;
  not?: Maybe<NestedEnumEnrollmentStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<EnrollmentStatus>>;
};

export type NestedEnumFeatureFlagStateFilter = {
  equals?: Maybe<FeatureFlagState>;
  in?: Maybe<Array<FeatureFlagState>>;
  not?: Maybe<NestedEnumFeatureFlagStateFilter>;
  notIn?: Maybe<Array<FeatureFlagState>>;
};

export type NestedEnumFeatureFlagStateWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFeatureFlagStateFilter>;
  _min?: Maybe<NestedEnumFeatureFlagStateFilter>;
  equals?: Maybe<FeatureFlagState>;
  in?: Maybe<Array<FeatureFlagState>>;
  not?: Maybe<NestedEnumFeatureFlagStateWithAggregatesFilter>;
  notIn?: Maybe<Array<FeatureFlagState>>;
};

export type NestedEnumFeatureFlagTypeFilter = {
  equals?: Maybe<FeatureFlagType>;
  in?: Maybe<Array<FeatureFlagType>>;
  not?: Maybe<NestedEnumFeatureFlagTypeFilter>;
  notIn?: Maybe<Array<FeatureFlagType>>;
};

export type NestedEnumFeatureFlagTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFeatureFlagTypeFilter>;
  _min?: Maybe<NestedEnumFeatureFlagTypeFilter>;
  equals?: Maybe<FeatureFlagType>;
  in?: Maybe<Array<FeatureFlagType>>;
  not?: Maybe<NestedEnumFeatureFlagTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<FeatureFlagType>>;
};

export type NestedEnumFeeCollectionFilter = {
  equals?: Maybe<FeeCollection>;
  in?: Maybe<Array<FeeCollection>>;
  not?: Maybe<NestedEnumFeeCollectionFilter>;
  notIn?: Maybe<Array<FeeCollection>>;
};

export type NestedEnumFeeCollectionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFeeCollectionFilter>;
  _min?: Maybe<NestedEnumFeeCollectionFilter>;
  equals?: Maybe<FeeCollection>;
  in?: Maybe<Array<FeeCollection>>;
  not?: Maybe<NestedEnumFeeCollectionWithAggregatesFilter>;
  notIn?: Maybe<Array<FeeCollection>>;
};

export type NestedEnumFilterSelectionTypeFilter = {
  equals?: Maybe<FilterSelectionType>;
  in?: Maybe<Array<FilterSelectionType>>;
  not?: Maybe<NestedEnumFilterSelectionTypeFilter>;
  notIn?: Maybe<Array<FilterSelectionType>>;
};

export type NestedEnumFilterSelectionTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFilterSelectionTypeFilter>;
  _min?: Maybe<NestedEnumFilterSelectionTypeFilter>;
  equals?: Maybe<FilterSelectionType>;
  in?: Maybe<Array<FilterSelectionType>>;
  not?: Maybe<NestedEnumFilterSelectionTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<FilterSelectionType>>;
};

export type NestedEnumFinancialTransactionTypeFilter = {
  equals?: Maybe<FinancialTransactionType>;
  in?: Maybe<Array<FinancialTransactionType>>;
  not?: Maybe<NestedEnumFinancialTransactionTypeFilter>;
  notIn?: Maybe<Array<FinancialTransactionType>>;
};

export type NestedEnumFinancialTransactionTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFinancialTransactionTypeFilter>;
  _min?: Maybe<NestedEnumFinancialTransactionTypeFilter>;
  equals?: Maybe<FinancialTransactionType>;
  in?: Maybe<Array<FinancialTransactionType>>;
  not?: Maybe<NestedEnumFinancialTransactionTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<FinancialTransactionType>>;
};

export type NestedEnumFormTemplateTypeFilter = {
  equals?: Maybe<FormTemplateType>;
  in?: Maybe<Array<FormTemplateType>>;
  not?: Maybe<NestedEnumFormTemplateTypeFilter>;
  notIn?: Maybe<Array<FormTemplateType>>;
};

export type NestedEnumFormTemplateTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFormTemplateTypeFilter>;
  _min?: Maybe<NestedEnumFormTemplateTypeFilter>;
  equals?: Maybe<FormTemplateType>;
  in?: Maybe<Array<FormTemplateType>>;
  not?: Maybe<NestedEnumFormTemplateTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<FormTemplateType>>;
};

export type NestedEnumHillsToHomeResultTypeFilter = {
  equals?: Maybe<HillsToHomeResultType>;
  in?: Maybe<Array<HillsToHomeResultType>>;
  not?: Maybe<NestedEnumHillsToHomeResultTypeFilter>;
  notIn?: Maybe<Array<HillsToHomeResultType>>;
};

export type NestedEnumHillsToHomeResultTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumHillsToHomeResultTypeFilter>;
  _min?: Maybe<NestedEnumHillsToHomeResultTypeFilter>;
  equals?: Maybe<HillsToHomeResultType>;
  in?: Maybe<Array<HillsToHomeResultType>>;
  not?: Maybe<NestedEnumHillsToHomeResultTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<HillsToHomeResultType>>;
};

export type NestedEnumHillsToHomeSpeciesNullableFilter = {
  equals?: Maybe<HillsToHomeSpecies>;
  in?: Maybe<Array<HillsToHomeSpecies>>;
  not?: Maybe<NestedEnumHillsToHomeSpeciesNullableFilter>;
  notIn?: Maybe<Array<HillsToHomeSpecies>>;
};

export type NestedEnumHillsToHomeSpeciesNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumHillsToHomeSpeciesNullableFilter>;
  _min?: Maybe<NestedEnumHillsToHomeSpeciesNullableFilter>;
  equals?: Maybe<HillsToHomeSpecies>;
  in?: Maybe<Array<HillsToHomeSpecies>>;
  not?: Maybe<NestedEnumHillsToHomeSpeciesNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<HillsToHomeSpecies>>;
};

export type NestedEnumInformAudienceDefinitionStatusFilter = {
  equals?: Maybe<InformAudienceDefinitionStatus>;
  in?: Maybe<Array<InformAudienceDefinitionStatus>>;
  not?: Maybe<NestedEnumInformAudienceDefinitionStatusFilter>;
  notIn?: Maybe<Array<InformAudienceDefinitionStatus>>;
};

export type NestedEnumInformAudienceDefinitionStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformAudienceDefinitionStatusFilter>;
  _min?: Maybe<NestedEnumInformAudienceDefinitionStatusFilter>;
  equals?: Maybe<InformAudienceDefinitionStatus>;
  in?: Maybe<Array<InformAudienceDefinitionStatus>>;
  not?: Maybe<NestedEnumInformAudienceDefinitionStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformAudienceDefinitionStatus>>;
};

export type NestedEnumInformAudienceDefinitionTypeFilter = {
  equals?: Maybe<InformAudienceDefinitionType>;
  in?: Maybe<Array<InformAudienceDefinitionType>>;
  not?: Maybe<NestedEnumInformAudienceDefinitionTypeFilter>;
  notIn?: Maybe<Array<InformAudienceDefinitionType>>;
};

export type NestedEnumInformAudienceDefinitionTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformAudienceDefinitionTypeFilter>;
  _min?: Maybe<NestedEnumInformAudienceDefinitionTypeFilter>;
  equals?: Maybe<InformAudienceDefinitionType>;
  in?: Maybe<Array<InformAudienceDefinitionType>>;
  not?: Maybe<NestedEnumInformAudienceDefinitionTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InformAudienceDefinitionType>>;
};

export type NestedEnumInformAudienceMemberMessageCourierFilter = {
  equals?: Maybe<InformAudienceMemberMessageCourier>;
  in?: Maybe<Array<InformAudienceMemberMessageCourier>>;
  not?: Maybe<NestedEnumInformAudienceMemberMessageCourierFilter>;
  notIn?: Maybe<Array<InformAudienceMemberMessageCourier>>;
};

export type NestedEnumInformAudienceMemberMessageCourierWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformAudienceMemberMessageCourierFilter>;
  _min?: Maybe<NestedEnumInformAudienceMemberMessageCourierFilter>;
  equals?: Maybe<InformAudienceMemberMessageCourier>;
  in?: Maybe<Array<InformAudienceMemberMessageCourier>>;
  not?: Maybe<NestedEnumInformAudienceMemberMessageCourierWithAggregatesFilter>;
  notIn?: Maybe<Array<InformAudienceMemberMessageCourier>>;
};

export type NestedEnumInformAudienceMemberMessageStatusFilter = {
  equals?: Maybe<InformAudienceMemberMessageStatus>;
  in?: Maybe<Array<InformAudienceMemberMessageStatus>>;
  not?: Maybe<NestedEnumInformAudienceMemberMessageStatusFilter>;
  notIn?: Maybe<Array<InformAudienceMemberMessageStatus>>;
};

export type NestedEnumInformAudienceMemberMessageStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformAudienceMemberMessageStatusFilter>;
  _min?: Maybe<NestedEnumInformAudienceMemberMessageStatusFilter>;
  equals?: Maybe<InformAudienceMemberMessageStatus>;
  in?: Maybe<Array<InformAudienceMemberMessageStatus>>;
  not?: Maybe<NestedEnumInformAudienceMemberMessageStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformAudienceMemberMessageStatus>>;
};

export type NestedEnumInformAudienceMemberMessageTypeFilter = {
  equals?: Maybe<InformAudienceMemberMessageType>;
  in?: Maybe<Array<InformAudienceMemberMessageType>>;
  not?: Maybe<NestedEnumInformAudienceMemberMessageTypeFilter>;
  notIn?: Maybe<Array<InformAudienceMemberMessageType>>;
};

export type NestedEnumInformAudienceMemberMessageTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformAudienceMemberMessageTypeFilter>;
  _min?: Maybe<NestedEnumInformAudienceMemberMessageTypeFilter>;
  equals?: Maybe<InformAudienceMemberMessageType>;
  in?: Maybe<Array<InformAudienceMemberMessageType>>;
  not?: Maybe<NestedEnumInformAudienceMemberMessageTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InformAudienceMemberMessageType>>;
};

export type NestedEnumInformCampaignExecutionStatusFilter = {
  equals?: Maybe<InformCampaignExecutionStatus>;
  in?: Maybe<Array<InformCampaignExecutionStatus>>;
  not?: Maybe<NestedEnumInformCampaignExecutionStatusFilter>;
  notIn?: Maybe<Array<InformCampaignExecutionStatus>>;
};

export type NestedEnumInformCampaignExecutionStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformCampaignExecutionStatusFilter>;
  _min?: Maybe<NestedEnumInformCampaignExecutionStatusFilter>;
  equals?: Maybe<InformCampaignExecutionStatus>;
  in?: Maybe<Array<InformCampaignExecutionStatus>>;
  not?: Maybe<NestedEnumInformCampaignExecutionStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformCampaignExecutionStatus>>;
};

export type NestedEnumInformCampaignStatusFilter = {
  equals?: Maybe<InformCampaignStatus>;
  in?: Maybe<Array<InformCampaignStatus>>;
  not?: Maybe<NestedEnumInformCampaignStatusFilter>;
  notIn?: Maybe<Array<InformCampaignStatus>>;
};

export type NestedEnumInformCampaignStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformCampaignStatusFilter>;
  _min?: Maybe<NestedEnumInformCampaignStatusFilter>;
  equals?: Maybe<InformCampaignStatus>;
  in?: Maybe<Array<InformCampaignStatus>>;
  not?: Maybe<NestedEnumInformCampaignStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformCampaignStatus>>;
};

export type NestedEnumInformCampaignTypeFilter = {
  equals?: Maybe<InformCampaignType>;
  in?: Maybe<Array<InformCampaignType>>;
  not?: Maybe<NestedEnumInformCampaignTypeFilter>;
  notIn?: Maybe<Array<InformCampaignType>>;
};

export type NestedEnumInformCampaignTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformCampaignTypeFilter>;
  _min?: Maybe<NestedEnumInformCampaignTypeFilter>;
  equals?: Maybe<InformCampaignType>;
  in?: Maybe<Array<InformCampaignType>>;
  not?: Maybe<NestedEnumInformCampaignTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InformCampaignType>>;
};

export type NestedEnumInformCampaignVisibilityFilter = {
  equals?: Maybe<InformCampaignVisibility>;
  in?: Maybe<Array<InformCampaignVisibility>>;
  not?: Maybe<NestedEnumInformCampaignVisibilityFilter>;
  notIn?: Maybe<Array<InformCampaignVisibility>>;
};

export type NestedEnumInformCampaignVisibilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformCampaignVisibilityFilter>;
  _min?: Maybe<NestedEnumInformCampaignVisibilityFilter>;
  equals?: Maybe<InformCampaignVisibility>;
  in?: Maybe<Array<InformCampaignVisibility>>;
  not?: Maybe<NestedEnumInformCampaignVisibilityWithAggregatesFilter>;
  notIn?: Maybe<Array<InformCampaignVisibility>>;
};

export type NestedEnumInformCommunicationOptOutStatusFilter = {
  equals?: Maybe<InformCommunicationOptOutStatus>;
  in?: Maybe<Array<InformCommunicationOptOutStatus>>;
  not?: Maybe<NestedEnumInformCommunicationOptOutStatusFilter>;
  notIn?: Maybe<Array<InformCommunicationOptOutStatus>>;
};

export type NestedEnumInformCommunicationOptOutStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformCommunicationOptOutStatusFilter>;
  _min?: Maybe<NestedEnumInformCommunicationOptOutStatusFilter>;
  equals?: Maybe<InformCommunicationOptOutStatus>;
  in?: Maybe<Array<InformCommunicationOptOutStatus>>;
  not?: Maybe<NestedEnumInformCommunicationOptOutStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformCommunicationOptOutStatus>>;
};

export type NestedEnumInformControlGroupEntityTypeFilter = {
  equals?: Maybe<InformControlGroupEntityType>;
  in?: Maybe<Array<InformControlGroupEntityType>>;
  not?: Maybe<NestedEnumInformControlGroupEntityTypeFilter>;
  notIn?: Maybe<Array<InformControlGroupEntityType>>;
};

export type NestedEnumInformControlGroupEntityTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformControlGroupEntityTypeFilter>;
  _min?: Maybe<NestedEnumInformControlGroupEntityTypeFilter>;
  equals?: Maybe<InformControlGroupEntityType>;
  in?: Maybe<Array<InformControlGroupEntityType>>;
  not?: Maybe<NestedEnumInformControlGroupEntityTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InformControlGroupEntityType>>;
};

export type NestedEnumInformEmailTemplateStatusFilter = {
  equals?: Maybe<InformEmailTemplateStatus>;
  in?: Maybe<Array<InformEmailTemplateStatus>>;
  not?: Maybe<NestedEnumInformEmailTemplateStatusFilter>;
  notIn?: Maybe<Array<InformEmailTemplateStatus>>;
};

export type NestedEnumInformEmailTemplateStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformEmailTemplateStatusFilter>;
  _min?: Maybe<NestedEnumInformEmailTemplateStatusFilter>;
  equals?: Maybe<InformEmailTemplateStatus>;
  in?: Maybe<Array<InformEmailTemplateStatus>>;
  not?: Maybe<NestedEnumInformEmailTemplateStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformEmailTemplateStatus>>;
};

export type NestedEnumInformEnrollmentStatusFilter = {
  equals?: Maybe<InformEnrollmentStatus>;
  in?: Maybe<Array<InformEnrollmentStatus>>;
  not?: Maybe<NestedEnumInformEnrollmentStatusFilter>;
  notIn?: Maybe<Array<InformEnrollmentStatus>>;
};

export type NestedEnumInformEnrollmentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformEnrollmentStatusFilter>;
  _min?: Maybe<NestedEnumInformEnrollmentStatusFilter>;
  equals?: Maybe<InformEnrollmentStatus>;
  in?: Maybe<Array<InformEnrollmentStatus>>;
  not?: Maybe<NestedEnumInformEnrollmentStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformEnrollmentStatus>>;
};

export type NestedEnumInformEntityUpdatedByTypeNullableFilter = {
  equals?: Maybe<InformEntityUpdatedByType>;
  in?: Maybe<Array<InformEntityUpdatedByType>>;
  not?: Maybe<NestedEnumInformEntityUpdatedByTypeNullableFilter>;
  notIn?: Maybe<Array<InformEntityUpdatedByType>>;
};

export type NestedEnumInformEntityUpdatedByTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumInformEntityUpdatedByTypeNullableFilter>;
  _min?: Maybe<NestedEnumInformEntityUpdatedByTypeNullableFilter>;
  equals?: Maybe<InformEntityUpdatedByType>;
  in?: Maybe<Array<InformEntityUpdatedByType>>;
  not?: Maybe<NestedEnumInformEntityUpdatedByTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<InformEntityUpdatedByType>>;
};

export type NestedEnumInformPartnerCustomerPharmacyProviderNameFilter = {
  equals?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  in?: Maybe<Array<InformPartnerCustomerPharmacyProviderName>>;
  not?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderNameFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerPharmacyProviderName>>;
};

export type NestedEnumInformPartnerCustomerPharmacyProviderNameWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderNameFilter>;
  _min?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderNameFilter>;
  equals?: Maybe<InformPartnerCustomerPharmacyProviderName>;
  in?: Maybe<Array<InformPartnerCustomerPharmacyProviderName>>;
  not?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderNameWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerPharmacyProviderName>>;
};

export type NestedEnumInformPartnerCustomerPharmacyProviderStatusFilter = {
  equals?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  in?: Maybe<Array<InformPartnerCustomerPharmacyProviderStatus>>;
  not?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderStatusFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerPharmacyProviderStatus>>;
};

export type NestedEnumInformPartnerCustomerPharmacyProviderStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderStatusFilter>;
  equals?: Maybe<InformPartnerCustomerPharmacyProviderStatus>;
  in?: Maybe<Array<InformPartnerCustomerPharmacyProviderStatus>>;
  not?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerPharmacyProviderStatus>>;
};

export type NestedEnumInformPartnerCustomerPharmacyProviderTypeFilter = {
  equals?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  in?: Maybe<Array<InformPartnerCustomerPharmacyProviderType>>;
  not?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderTypeFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerPharmacyProviderType>>;
};

export type NestedEnumInformPartnerCustomerPharmacyProviderTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderTypeFilter>;
  _min?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderTypeFilter>;
  equals?: Maybe<InformPartnerCustomerPharmacyProviderType>;
  in?: Maybe<Array<InformPartnerCustomerPharmacyProviderType>>;
  not?: Maybe<NestedEnumInformPartnerCustomerPharmacyProviderTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerPharmacyProviderType>>;
};

export type NestedEnumInformPartnerCustomerVisibilityFilter = {
  equals?: Maybe<InformPartnerCustomerVisibility>;
  in?: Maybe<Array<InformPartnerCustomerVisibility>>;
  not?: Maybe<NestedEnumInformPartnerCustomerVisibilityFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerVisibility>>;
};

export type NestedEnumInformPartnerCustomerVisibilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerCustomerVisibilityFilter>;
  _min?: Maybe<NestedEnumInformPartnerCustomerVisibilityFilter>;
  equals?: Maybe<InformPartnerCustomerVisibility>;
  in?: Maybe<Array<InformPartnerCustomerVisibility>>;
  not?: Maybe<NestedEnumInformPartnerCustomerVisibilityWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerCustomerVisibility>>;
};

export type NestedEnumInformPartnerIntegrationModelNameFilter = {
  equals?: Maybe<InformPartnerIntegrationModelName>;
  in?: Maybe<Array<InformPartnerIntegrationModelName>>;
  not?: Maybe<NestedEnumInformPartnerIntegrationModelNameFilter>;
  notIn?: Maybe<Array<InformPartnerIntegrationModelName>>;
};

export type NestedEnumInformPartnerIntegrationModelNameWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerIntegrationModelNameFilter>;
  _min?: Maybe<NestedEnumInformPartnerIntegrationModelNameFilter>;
  equals?: Maybe<InformPartnerIntegrationModelName>;
  in?: Maybe<Array<InformPartnerIntegrationModelName>>;
  not?: Maybe<NestedEnumInformPartnerIntegrationModelNameWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerIntegrationModelName>>;
};

export type NestedEnumInformPartnerIntegrationModelStatusFilter = {
  equals?: Maybe<InformPartnerIntegrationModelStatus>;
  in?: Maybe<Array<InformPartnerIntegrationModelStatus>>;
  not?: Maybe<NestedEnumInformPartnerIntegrationModelStatusFilter>;
  notIn?: Maybe<Array<InformPartnerIntegrationModelStatus>>;
};

export type NestedEnumInformPartnerIntegrationModelStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerIntegrationModelStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerIntegrationModelStatusFilter>;
  equals?: Maybe<InformPartnerIntegrationModelStatus>;
  in?: Maybe<Array<InformPartnerIntegrationModelStatus>>;
  not?: Maybe<NestedEnumInformPartnerIntegrationModelStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerIntegrationModelStatus>>;
};

export type NestedEnumInformPartnerIntegrationStatusFilter = {
  equals?: Maybe<InformPartnerIntegrationStatus>;
  in?: Maybe<Array<InformPartnerIntegrationStatus>>;
  not?: Maybe<NestedEnumInformPartnerIntegrationStatusFilter>;
  notIn?: Maybe<Array<InformPartnerIntegrationStatus>>;
};

export type NestedEnumInformPartnerIntegrationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerIntegrationStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerIntegrationStatusFilter>;
  equals?: Maybe<InformPartnerIntegrationStatus>;
  in?: Maybe<Array<InformPartnerIntegrationStatus>>;
  not?: Maybe<NestedEnumInformPartnerIntegrationStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerIntegrationStatus>>;
};

export type NestedEnumInformPartnerProgramStatusFilter = {
  equals?: Maybe<InformPartnerProgramStatus>;
  in?: Maybe<Array<InformPartnerProgramStatus>>;
  not?: Maybe<NestedEnumInformPartnerProgramStatusFilter>;
  notIn?: Maybe<Array<InformPartnerProgramStatus>>;
};

export type NestedEnumInformPartnerProgramStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerProgramStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerProgramStatusFilter>;
  equals?: Maybe<InformPartnerProgramStatus>;
  in?: Maybe<Array<InformPartnerProgramStatus>>;
  not?: Maybe<NestedEnumInformPartnerProgramStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerProgramStatus>>;
};

export type NestedEnumInformPartnerStatusFilter = {
  equals?: Maybe<InformPartnerStatus>;
  in?: Maybe<Array<InformPartnerStatus>>;
  not?: Maybe<NestedEnumInformPartnerStatusFilter>;
  notIn?: Maybe<Array<InformPartnerStatus>>;
};

export type NestedEnumInformPartnerStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerStatusFilter>;
  equals?: Maybe<InformPartnerStatus>;
  in?: Maybe<Array<InformPartnerStatus>>;
  not?: Maybe<NestedEnumInformPartnerStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerStatus>>;
};

export type NestedEnumInformPartnerUserRoleNameFilter = {
  equals?: Maybe<InformPartnerUserRoleName>;
  in?: Maybe<Array<InformPartnerUserRoleName>>;
  not?: Maybe<NestedEnumInformPartnerUserRoleNameFilter>;
  notIn?: Maybe<Array<InformPartnerUserRoleName>>;
};

export type NestedEnumInformPartnerUserRoleNameWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerUserRoleNameFilter>;
  _min?: Maybe<NestedEnumInformPartnerUserRoleNameFilter>;
  equals?: Maybe<InformPartnerUserRoleName>;
  in?: Maybe<Array<InformPartnerUserRoleName>>;
  not?: Maybe<NestedEnumInformPartnerUserRoleNameWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerUserRoleName>>;
};

export type NestedEnumInformPartnerUserRoleStatusFilter = {
  equals?: Maybe<InformPartnerUserRoleStatus>;
  in?: Maybe<Array<InformPartnerUserRoleStatus>>;
  not?: Maybe<NestedEnumInformPartnerUserRoleStatusFilter>;
  notIn?: Maybe<Array<InformPartnerUserRoleStatus>>;
};

export type NestedEnumInformPartnerUserRoleStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerUserRoleStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerUserRoleStatusFilter>;
  equals?: Maybe<InformPartnerUserRoleStatus>;
  in?: Maybe<Array<InformPartnerUserRoleStatus>>;
  not?: Maybe<NestedEnumInformPartnerUserRoleStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerUserRoleStatus>>;
};

export type NestedEnumInformPartnerUserStatusFilter = {
  equals?: Maybe<InformPartnerUserStatus>;
  in?: Maybe<Array<InformPartnerUserStatus>>;
  not?: Maybe<NestedEnumInformPartnerUserStatusFilter>;
  notIn?: Maybe<Array<InformPartnerUserStatus>>;
};

export type NestedEnumInformPartnerUserStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformPartnerUserStatusFilter>;
  _min?: Maybe<NestedEnumInformPartnerUserStatusFilter>;
  equals?: Maybe<InformPartnerUserStatus>;
  in?: Maybe<Array<InformPartnerUserStatus>>;
  not?: Maybe<NestedEnumInformPartnerUserStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformPartnerUserStatus>>;
};

export type NestedEnumInformScheduledCampaignCadenceNullableFilter = {
  equals?: Maybe<InformScheduledCampaignCadence>;
  in?: Maybe<Array<InformScheduledCampaignCadence>>;
  not?: Maybe<NestedEnumInformScheduledCampaignCadenceNullableFilter>;
  notIn?: Maybe<Array<InformScheduledCampaignCadence>>;
};

export type NestedEnumInformScheduledCampaignCadenceNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumInformScheduledCampaignCadenceNullableFilter>;
  _min?: Maybe<NestedEnumInformScheduledCampaignCadenceNullableFilter>;
  equals?: Maybe<InformScheduledCampaignCadence>;
  in?: Maybe<Array<InformScheduledCampaignCadence>>;
  not?: Maybe<NestedEnumInformScheduledCampaignCadenceNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<InformScheduledCampaignCadence>>;
};

export type NestedEnumInformScheduledCampaignCommunicationChannelFilter = {
  equals?: Maybe<InformScheduledCampaignCommunicationChannel>;
  in?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  not?: Maybe<NestedEnumInformScheduledCampaignCommunicationChannelFilter>;
  notIn?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
};

export type NestedEnumInformScheduledCampaignCommunicationChannelWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformScheduledCampaignCommunicationChannelFilter>;
  _min?: Maybe<NestedEnumInformScheduledCampaignCommunicationChannelFilter>;
  equals?: Maybe<InformScheduledCampaignCommunicationChannel>;
  in?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
  not?: Maybe<NestedEnumInformScheduledCampaignCommunicationChannelWithAggregatesFilter>;
  notIn?: Maybe<Array<InformScheduledCampaignCommunicationChannel>>;
};

export type NestedEnumInformSessionEventAuthorTypeFilter = {
  equals?: Maybe<InformSessionEventAuthorType>;
  in?: Maybe<Array<InformSessionEventAuthorType>>;
  not?: Maybe<NestedEnumInformSessionEventAuthorTypeFilter>;
  notIn?: Maybe<Array<InformSessionEventAuthorType>>;
};

export type NestedEnumInformSessionEventAuthorTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformSessionEventAuthorTypeFilter>;
  _min?: Maybe<NestedEnumInformSessionEventAuthorTypeFilter>;
  equals?: Maybe<InformSessionEventAuthorType>;
  in?: Maybe<Array<InformSessionEventAuthorType>>;
  not?: Maybe<NestedEnumInformSessionEventAuthorTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InformSessionEventAuthorType>>;
};

export type NestedEnumInformSessionStatusFilter = {
  equals?: Maybe<InformSessionStatus>;
  in?: Maybe<Array<InformSessionStatus>>;
  not?: Maybe<NestedEnumInformSessionStatusFilter>;
  notIn?: Maybe<Array<InformSessionStatus>>;
};

export type NestedEnumInformSessionStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInformSessionStatusFilter>;
  _min?: Maybe<NestedEnumInformSessionStatusFilter>;
  equals?: Maybe<InformSessionStatus>;
  in?: Maybe<Array<InformSessionStatus>>;
  not?: Maybe<NestedEnumInformSessionStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InformSessionStatus>>;
};

export type NestedEnumInsuranceIntegrationTypeFilter = {
  equals?: Maybe<InsuranceIntegrationType>;
  in?: Maybe<Array<InsuranceIntegrationType>>;
  not?: Maybe<NestedEnumInsuranceIntegrationTypeFilter>;
  notIn?: Maybe<Array<InsuranceIntegrationType>>;
};

export type NestedEnumInsuranceIntegrationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInsuranceIntegrationTypeFilter>;
  _min?: Maybe<NestedEnumInsuranceIntegrationTypeFilter>;
  equals?: Maybe<InsuranceIntegrationType>;
  in?: Maybe<Array<InsuranceIntegrationType>>;
  not?: Maybe<NestedEnumInsuranceIntegrationTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InsuranceIntegrationType>>;
};

export type NestedEnumIntegrationStatusNullableFilter = {
  equals?: Maybe<IntegrationStatus>;
  in?: Maybe<Array<IntegrationStatus>>;
  not?: Maybe<NestedEnumIntegrationStatusNullableFilter>;
  notIn?: Maybe<Array<IntegrationStatus>>;
};

export type NestedEnumIntegrationStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumIntegrationStatusNullableFilter>;
  _min?: Maybe<NestedEnumIntegrationStatusNullableFilter>;
  equals?: Maybe<IntegrationStatus>;
  in?: Maybe<Array<IntegrationStatus>>;
  not?: Maybe<NestedEnumIntegrationStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<IntegrationStatus>>;
};

export type NestedEnumIntegrationTypeNullableFilter = {
  equals?: Maybe<IntegrationType>;
  in?: Maybe<Array<IntegrationType>>;
  not?: Maybe<NestedEnumIntegrationTypeNullableFilter>;
  notIn?: Maybe<Array<IntegrationType>>;
};

export type NestedEnumIntegrationTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumIntegrationTypeNullableFilter>;
  _min?: Maybe<NestedEnumIntegrationTypeNullableFilter>;
  equals?: Maybe<IntegrationType>;
  in?: Maybe<Array<IntegrationType>>;
  not?: Maybe<NestedEnumIntegrationTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<IntegrationType>>;
};

export type NestedEnumInvoiceLineItemTypeFilter = {
  equals?: Maybe<InvoiceLineItemType>;
  in?: Maybe<Array<InvoiceLineItemType>>;
  not?: Maybe<NestedEnumInvoiceLineItemTypeFilter>;
  notIn?: Maybe<Array<InvoiceLineItemType>>;
};

export type NestedEnumInvoiceLineItemTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInvoiceLineItemTypeFilter>;
  _min?: Maybe<NestedEnumInvoiceLineItemTypeFilter>;
  equals?: Maybe<InvoiceLineItemType>;
  in?: Maybe<Array<InvoiceLineItemType>>;
  not?: Maybe<NestedEnumInvoiceLineItemTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<InvoiceLineItemType>>;
};

export type NestedEnumInvoicePimsWritebackActionFilter = {
  equals?: Maybe<InvoicePimsWritebackAction>;
  in?: Maybe<Array<InvoicePimsWritebackAction>>;
  not?: Maybe<NestedEnumInvoicePimsWritebackActionFilter>;
  notIn?: Maybe<Array<InvoicePimsWritebackAction>>;
};

export type NestedEnumInvoicePimsWritebackActionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInvoicePimsWritebackActionFilter>;
  _min?: Maybe<NestedEnumInvoicePimsWritebackActionFilter>;
  equals?: Maybe<InvoicePimsWritebackAction>;
  in?: Maybe<Array<InvoicePimsWritebackAction>>;
  not?: Maybe<NestedEnumInvoicePimsWritebackActionWithAggregatesFilter>;
  notIn?: Maybe<Array<InvoicePimsWritebackAction>>;
};

export type NestedEnumInvoiceStatusFilter = {
  equals?: Maybe<InvoiceStatus>;
  in?: Maybe<Array<InvoiceStatus>>;
  not?: Maybe<NestedEnumInvoiceStatusFilter>;
  notIn?: Maybe<Array<InvoiceStatus>>;
};

export type NestedEnumInvoiceStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumInvoiceStatusFilter>;
  _min?: Maybe<NestedEnumInvoiceStatusFilter>;
  equals?: Maybe<InvoiceStatus>;
  in?: Maybe<Array<InvoiceStatus>>;
  not?: Maybe<NestedEnumInvoiceStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<InvoiceStatus>>;
};

export type NestedEnumLegalEntityTypeFilter = {
  equals?: Maybe<LegalEntityType>;
  in?: Maybe<Array<LegalEntityType>>;
  not?: Maybe<NestedEnumLegalEntityTypeFilter>;
  notIn?: Maybe<Array<LegalEntityType>>;
};

export type NestedEnumLegalEntityTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLegalEntityTypeFilter>;
  _min?: Maybe<NestedEnumLegalEntityTypeFilter>;
  equals?: Maybe<LegalEntityType>;
  in?: Maybe<Array<LegalEntityType>>;
  not?: Maybe<NestedEnumLegalEntityTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<LegalEntityType>>;
};

export type NestedEnumLoyaltyAccountMergerStatusFilter = {
  equals?: Maybe<LoyaltyAccountMergerStatus>;
  in?: Maybe<Array<LoyaltyAccountMergerStatus>>;
  not?: Maybe<NestedEnumLoyaltyAccountMergerStatusFilter>;
  notIn?: Maybe<Array<LoyaltyAccountMergerStatus>>;
};

export type NestedEnumLoyaltyAccountMergerStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLoyaltyAccountMergerStatusFilter>;
  _min?: Maybe<NestedEnumLoyaltyAccountMergerStatusFilter>;
  equals?: Maybe<LoyaltyAccountMergerStatus>;
  in?: Maybe<Array<LoyaltyAccountMergerStatus>>;
  not?: Maybe<NestedEnumLoyaltyAccountMergerStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<LoyaltyAccountMergerStatus>>;
};

export type NestedEnumLoyaltyPointDeltaSourceFilter = {
  equals?: Maybe<LoyaltyPointDeltaSource>;
  in?: Maybe<Array<LoyaltyPointDeltaSource>>;
  not?: Maybe<NestedEnumLoyaltyPointDeltaSourceFilter>;
  notIn?: Maybe<Array<LoyaltyPointDeltaSource>>;
};

export type NestedEnumLoyaltyPointDeltaSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLoyaltyPointDeltaSourceFilter>;
  _min?: Maybe<NestedEnumLoyaltyPointDeltaSourceFilter>;
  equals?: Maybe<LoyaltyPointDeltaSource>;
  in?: Maybe<Array<LoyaltyPointDeltaSource>>;
  not?: Maybe<NestedEnumLoyaltyPointDeltaSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<LoyaltyPointDeltaSource>>;
};

export type NestedEnumLoyaltyProgramStatusFilter = {
  equals?: Maybe<LoyaltyProgramStatus>;
  in?: Maybe<Array<LoyaltyProgramStatus>>;
  not?: Maybe<NestedEnumLoyaltyProgramStatusFilter>;
  notIn?: Maybe<Array<LoyaltyProgramStatus>>;
};

export type NestedEnumLoyaltyProgramStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLoyaltyProgramStatusFilter>;
  _min?: Maybe<NestedEnumLoyaltyProgramStatusFilter>;
  equals?: Maybe<LoyaltyProgramStatus>;
  in?: Maybe<Array<LoyaltyProgramStatus>>;
  not?: Maybe<NestedEnumLoyaltyProgramStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<LoyaltyProgramStatus>>;
};

export type NestedEnumLoyaltyRewardAvailabilityFilter = {
  equals?: Maybe<LoyaltyRewardAvailability>;
  in?: Maybe<Array<LoyaltyRewardAvailability>>;
  not?: Maybe<NestedEnumLoyaltyRewardAvailabilityFilter>;
  notIn?: Maybe<Array<LoyaltyRewardAvailability>>;
};

export type NestedEnumLoyaltyRewardAvailabilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLoyaltyRewardAvailabilityFilter>;
  _min?: Maybe<NestedEnumLoyaltyRewardAvailabilityFilter>;
  equals?: Maybe<LoyaltyRewardAvailability>;
  in?: Maybe<Array<LoyaltyRewardAvailability>>;
  not?: Maybe<NestedEnumLoyaltyRewardAvailabilityWithAggregatesFilter>;
  notIn?: Maybe<Array<LoyaltyRewardAvailability>>;
};

export type NestedEnumLoyaltyRewardRedemptionActorTypeFilter = {
  equals?: Maybe<LoyaltyRewardRedemptionActorType>;
  in?: Maybe<Array<LoyaltyRewardRedemptionActorType>>;
  not?: Maybe<NestedEnumLoyaltyRewardRedemptionActorTypeFilter>;
  notIn?: Maybe<Array<LoyaltyRewardRedemptionActorType>>;
};

export type NestedEnumLoyaltyRewardRedemptionActorTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLoyaltyRewardRedemptionActorTypeFilter>;
  _min?: Maybe<NestedEnumLoyaltyRewardRedemptionActorTypeFilter>;
  equals?: Maybe<LoyaltyRewardRedemptionActorType>;
  in?: Maybe<Array<LoyaltyRewardRedemptionActorType>>;
  not?: Maybe<NestedEnumLoyaltyRewardRedemptionActorTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<LoyaltyRewardRedemptionActorType>>;
};

export type NestedEnumLoyaltyRewardRedemptionStatusFilter = {
  equals?: Maybe<LoyaltyRewardRedemptionStatus>;
  in?: Maybe<Array<LoyaltyRewardRedemptionStatus>>;
  not?: Maybe<NestedEnumLoyaltyRewardRedemptionStatusFilter>;
  notIn?: Maybe<Array<LoyaltyRewardRedemptionStatus>>;
};

export type NestedEnumLoyaltyRewardRedemptionStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumLoyaltyRewardRedemptionStatusFilter>;
  _min?: Maybe<NestedEnumLoyaltyRewardRedemptionStatusFilter>;
  equals?: Maybe<LoyaltyRewardRedemptionStatus>;
  in?: Maybe<Array<LoyaltyRewardRedemptionStatus>>;
  not?: Maybe<NestedEnumLoyaltyRewardRedemptionStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<LoyaltyRewardRedemptionStatus>>;
};

export type NestedEnumManageMembershipRequestTypeFilter = {
  equals?: Maybe<ManageMembershipRequestType>;
  in?: Maybe<Array<ManageMembershipRequestType>>;
  not?: Maybe<NestedEnumManageMembershipRequestTypeFilter>;
  notIn?: Maybe<Array<ManageMembershipRequestType>>;
};

export type NestedEnumManageMembershipRequestTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumManageMembershipRequestTypeFilter>;
  _min?: Maybe<NestedEnumManageMembershipRequestTypeFilter>;
  equals?: Maybe<ManageMembershipRequestType>;
  in?: Maybe<Array<ManageMembershipRequestType>>;
  not?: Maybe<NestedEnumManageMembershipRequestTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ManageMembershipRequestType>>;
};

export type NestedEnumMassTextAlertStatusFilter = {
  equals?: Maybe<MassTextAlertStatus>;
  in?: Maybe<Array<MassTextAlertStatus>>;
  not?: Maybe<NestedEnumMassTextAlertStatusFilter>;
  notIn?: Maybe<Array<MassTextAlertStatus>>;
};

export type NestedEnumMassTextAlertStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMassTextAlertStatusFilter>;
  _min?: Maybe<NestedEnumMassTextAlertStatusFilter>;
  equals?: Maybe<MassTextAlertStatus>;
  in?: Maybe<Array<MassTextAlertStatus>>;
  not?: Maybe<NestedEnumMassTextAlertStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<MassTextAlertStatus>>;
};

export type NestedEnumMediaTypeFilter = {
  equals?: Maybe<MediaType>;
  in?: Maybe<Array<MediaType>>;
  not?: Maybe<NestedEnumMediaTypeFilter>;
  notIn?: Maybe<Array<MediaType>>;
};

export type NestedEnumMediaTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMediaTypeFilter>;
  _min?: Maybe<NestedEnumMediaTypeFilter>;
  equals?: Maybe<MediaType>;
  in?: Maybe<Array<MediaType>>;
  not?: Maybe<NestedEnumMediaTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<MediaType>>;
};

export type NestedEnumMediaVersionFilter = {
  equals?: Maybe<MediaVersion>;
  in?: Maybe<Array<MediaVersion>>;
  not?: Maybe<NestedEnumMediaVersionFilter>;
  notIn?: Maybe<Array<MediaVersion>>;
};

export type NestedEnumMediaVersionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMediaVersionFilter>;
  _min?: Maybe<NestedEnumMediaVersionFilter>;
  equals?: Maybe<MediaVersion>;
  in?: Maybe<Array<MediaVersion>>;
  not?: Maybe<NestedEnumMediaVersionWithAggregatesFilter>;
  notIn?: Maybe<Array<MediaVersion>>;
};

export type NestedEnumMessageSourceFilter = {
  equals?: Maybe<MessageSource>;
  in?: Maybe<Array<MessageSource>>;
  not?: Maybe<NestedEnumMessageSourceFilter>;
  notIn?: Maybe<Array<MessageSource>>;
};

export type NestedEnumMessageSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMessageSourceFilter>;
  _min?: Maybe<NestedEnumMessageSourceFilter>;
  equals?: Maybe<MessageSource>;
  in?: Maybe<Array<MessageSource>>;
  not?: Maybe<NestedEnumMessageSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<MessageSource>>;
};

export type NestedEnumMessageTemplateTypeFilter = {
  equals?: Maybe<MessageTemplateType>;
  in?: Maybe<Array<MessageTemplateType>>;
  not?: Maybe<NestedEnumMessageTemplateTypeFilter>;
  notIn?: Maybe<Array<MessageTemplateType>>;
};

export type NestedEnumMessageTemplateTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMessageTemplateTypeFilter>;
  _min?: Maybe<NestedEnumMessageTemplateTypeFilter>;
  equals?: Maybe<MessageTemplateType>;
  in?: Maybe<Array<MessageTemplateType>>;
  not?: Maybe<NestedEnumMessageTemplateTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<MessageTemplateType>>;
};

export type NestedEnumMessageTypeFilter = {
  equals?: Maybe<MessageType>;
  in?: Maybe<Array<MessageType>>;
  not?: Maybe<NestedEnumMessageTypeFilter>;
  notIn?: Maybe<Array<MessageType>>;
};

export type NestedEnumMessageTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMessageTypeFilter>;
  _min?: Maybe<NestedEnumMessageTypeFilter>;
  equals?: Maybe<MessageType>;
  in?: Maybe<Array<MessageType>>;
  not?: Maybe<NestedEnumMessageTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<MessageType>>;
};

export type NestedEnumMessagingCampaignStatusFilter = {
  equals?: Maybe<MessagingCampaignStatus>;
  in?: Maybe<Array<MessagingCampaignStatus>>;
  not?: Maybe<NestedEnumMessagingCampaignStatusFilter>;
  notIn?: Maybe<Array<MessagingCampaignStatus>>;
};

export type NestedEnumMessagingCampaignStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMessagingCampaignStatusFilter>;
  _min?: Maybe<NestedEnumMessagingCampaignStatusFilter>;
  equals?: Maybe<MessagingCampaignStatus>;
  in?: Maybe<Array<MessagingCampaignStatus>>;
  not?: Maybe<NestedEnumMessagingCampaignStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<MessagingCampaignStatus>>;
};

export type NestedEnumMessagingCampaignTypeFilter = {
  equals?: Maybe<MessagingCampaignType>;
  in?: Maybe<Array<MessagingCampaignType>>;
  not?: Maybe<NestedEnumMessagingCampaignTypeFilter>;
  notIn?: Maybe<Array<MessagingCampaignType>>;
};

export type NestedEnumMessagingCampaignTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMessagingCampaignTypeFilter>;
  _min?: Maybe<NestedEnumMessagingCampaignTypeFilter>;
  equals?: Maybe<MessagingCampaignType>;
  in?: Maybe<Array<MessagingCampaignType>>;
  not?: Maybe<NestedEnumMessagingCampaignTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<MessagingCampaignType>>;
};

export type NestedEnumMissedCallMessageResponseStatusFilter = {
  equals?: Maybe<MissedCallMessageResponseStatus>;
  in?: Maybe<Array<MissedCallMessageResponseStatus>>;
  not?: Maybe<NestedEnumMissedCallMessageResponseStatusFilter>;
  notIn?: Maybe<Array<MissedCallMessageResponseStatus>>;
};

export type NestedEnumMissedCallMessageResponseStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumMissedCallMessageResponseStatusFilter>;
  _min?: Maybe<NestedEnumMissedCallMessageResponseStatusFilter>;
  equals?: Maybe<MissedCallMessageResponseStatus>;
  in?: Maybe<Array<MissedCallMessageResponseStatus>>;
  not?: Maybe<NestedEnumMissedCallMessageResponseStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<MissedCallMessageResponseStatus>>;
};

export type NestedEnumNormalizedWritebackErrorNullableFilter = {
  equals?: Maybe<NormalizedWritebackError>;
  in?: Maybe<Array<NormalizedWritebackError>>;
  not?: Maybe<NestedEnumNormalizedWritebackErrorNullableFilter>;
  notIn?: Maybe<Array<NormalizedWritebackError>>;
};

export type NestedEnumNormalizedWritebackErrorNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumNormalizedWritebackErrorNullableFilter>;
  _min?: Maybe<NestedEnumNormalizedWritebackErrorNullableFilter>;
  equals?: Maybe<NormalizedWritebackError>;
  in?: Maybe<Array<NormalizedWritebackError>>;
  not?: Maybe<NestedEnumNormalizedWritebackErrorNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<NormalizedWritebackError>>;
};

export type NestedEnumNotificationEventFilter = {
  equals?: Maybe<NotificationEvent>;
  in?: Maybe<Array<NotificationEvent>>;
  not?: Maybe<NestedEnumNotificationEventFilter>;
  notIn?: Maybe<Array<NotificationEvent>>;
};

export type NestedEnumNotificationEventWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumNotificationEventFilter>;
  _min?: Maybe<NestedEnumNotificationEventFilter>;
  equals?: Maybe<NotificationEvent>;
  in?: Maybe<Array<NotificationEvent>>;
  not?: Maybe<NestedEnumNotificationEventWithAggregatesFilter>;
  notIn?: Maybe<Array<NotificationEvent>>;
};

export type NestedEnumNotificationSettingTypeFilter = {
  equals?: Maybe<NotificationSettingType>;
  in?: Maybe<Array<NotificationSettingType>>;
  not?: Maybe<NestedEnumNotificationSettingTypeFilter>;
  notIn?: Maybe<Array<NotificationSettingType>>;
};

export type NestedEnumNotificationSettingTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumNotificationSettingTypeFilter>;
  _min?: Maybe<NestedEnumNotificationSettingTypeFilter>;
  equals?: Maybe<NotificationSettingType>;
  in?: Maybe<Array<NotificationSettingType>>;
  not?: Maybe<NestedEnumNotificationSettingTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<NotificationSettingType>>;
};

export type NestedEnumPaymentMediumNullableFilter = {
  equals?: Maybe<PaymentMedium>;
  in?: Maybe<Array<PaymentMedium>>;
  not?: Maybe<NestedEnumPaymentMediumNullableFilter>;
  notIn?: Maybe<Array<PaymentMedium>>;
};

export type NestedEnumPaymentMediumNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumPaymentMediumNullableFilter>;
  _min?: Maybe<NestedEnumPaymentMediumNullableFilter>;
  equals?: Maybe<PaymentMedium>;
  in?: Maybe<Array<PaymentMedium>>;
  not?: Maybe<NestedEnumPaymentMediumNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<PaymentMedium>>;
};

export type NestedEnumPaymentPimsWritebackActionFilter = {
  equals?: Maybe<PaymentPimsWritebackAction>;
  in?: Maybe<Array<PaymentPimsWritebackAction>>;
  not?: Maybe<NestedEnumPaymentPimsWritebackActionFilter>;
  notIn?: Maybe<Array<PaymentPimsWritebackAction>>;
};

export type NestedEnumPaymentPimsWritebackActionWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPaymentPimsWritebackActionFilter>;
  _min?: Maybe<NestedEnumPaymentPimsWritebackActionFilter>;
  equals?: Maybe<PaymentPimsWritebackAction>;
  in?: Maybe<Array<PaymentPimsWritebackAction>>;
  not?: Maybe<NestedEnumPaymentPimsWritebackActionWithAggregatesFilter>;
  notIn?: Maybe<Array<PaymentPimsWritebackAction>>;
};

export type NestedEnumPaymentRelationshipNullableFilter = {
  equals?: Maybe<PaymentRelationship>;
  in?: Maybe<Array<PaymentRelationship>>;
  not?: Maybe<NestedEnumPaymentRelationshipNullableFilter>;
  notIn?: Maybe<Array<PaymentRelationship>>;
};

export type NestedEnumPaymentRelationshipNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumPaymentRelationshipNullableFilter>;
  _min?: Maybe<NestedEnumPaymentRelationshipNullableFilter>;
  equals?: Maybe<PaymentRelationship>;
  in?: Maybe<Array<PaymentRelationship>>;
  not?: Maybe<NestedEnumPaymentRelationshipNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<PaymentRelationship>>;
};

export type NestedEnumPaymentScheduleNullableFilter = {
  equals?: Maybe<PaymentSchedule>;
  in?: Maybe<Array<PaymentSchedule>>;
  not?: Maybe<NestedEnumPaymentScheduleNullableFilter>;
  notIn?: Maybe<Array<PaymentSchedule>>;
};

export type NestedEnumPaymentScheduleNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumPaymentScheduleNullableFilter>;
  _min?: Maybe<NestedEnumPaymentScheduleNullableFilter>;
  equals?: Maybe<PaymentSchedule>;
  in?: Maybe<Array<PaymentSchedule>>;
  not?: Maybe<NestedEnumPaymentScheduleNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<PaymentSchedule>>;
};

export type NestedEnumPaymentSourceFilter = {
  equals?: Maybe<PaymentSource>;
  in?: Maybe<Array<PaymentSource>>;
  not?: Maybe<NestedEnumPaymentSourceFilter>;
  notIn?: Maybe<Array<PaymentSource>>;
};

export type NestedEnumPaymentSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPaymentSourceFilter>;
  _min?: Maybe<NestedEnumPaymentSourceFilter>;
  equals?: Maybe<PaymentSource>;
  in?: Maybe<Array<PaymentSource>>;
  not?: Maybe<NestedEnumPaymentSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<PaymentSource>>;
};

export type NestedEnumPermissionTypeFilter = {
  equals?: Maybe<PermissionType>;
  in?: Maybe<Array<PermissionType>>;
  not?: Maybe<NestedEnumPermissionTypeFilter>;
  notIn?: Maybe<Array<PermissionType>>;
};

export type NestedEnumPermissionTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPermissionTypeFilter>;
  _min?: Maybe<NestedEnumPermissionTypeFilter>;
  equals?: Maybe<PermissionType>;
  in?: Maybe<Array<PermissionType>>;
  not?: Maybe<NestedEnumPermissionTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<PermissionType>>;
};

export type NestedEnumPhoneNumberLookupRequestStatusFilter = {
  equals?: Maybe<PhoneNumberLookupRequestStatus>;
  in?: Maybe<Array<PhoneNumberLookupRequestStatus>>;
  not?: Maybe<NestedEnumPhoneNumberLookupRequestStatusFilter>;
  notIn?: Maybe<Array<PhoneNumberLookupRequestStatus>>;
};

export type NestedEnumPhoneNumberLookupRequestStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPhoneNumberLookupRequestStatusFilter>;
  _min?: Maybe<NestedEnumPhoneNumberLookupRequestStatusFilter>;
  equals?: Maybe<PhoneNumberLookupRequestStatus>;
  in?: Maybe<Array<PhoneNumberLookupRequestStatus>>;
  not?: Maybe<NestedEnumPhoneNumberLookupRequestStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<PhoneNumberLookupRequestStatus>>;
};

export type NestedEnumPhoneNumberStatusFilter = {
  equals?: Maybe<PhoneNumberStatus>;
  in?: Maybe<Array<PhoneNumberStatus>>;
  not?: Maybe<NestedEnumPhoneNumberStatusFilter>;
  notIn?: Maybe<Array<PhoneNumberStatus>>;
};

export type NestedEnumPhoneNumberStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPhoneNumberStatusFilter>;
  _min?: Maybe<NestedEnumPhoneNumberStatusFilter>;
  equals?: Maybe<PhoneNumberStatus>;
  in?: Maybe<Array<PhoneNumberStatus>>;
  not?: Maybe<NestedEnumPhoneNumberStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<PhoneNumberStatus>>;
};

export type NestedEnumPimsIntegrationCapabilityFilter = {
  equals?: Maybe<PimsIntegrationCapability>;
  in?: Maybe<Array<PimsIntegrationCapability>>;
  not?: Maybe<NestedEnumPimsIntegrationCapabilityFilter>;
  notIn?: Maybe<Array<PimsIntegrationCapability>>;
};

export type NestedEnumPimsIntegrationCapabilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPimsIntegrationCapabilityFilter>;
  _min?: Maybe<NestedEnumPimsIntegrationCapabilityFilter>;
  equals?: Maybe<PimsIntegrationCapability>;
  in?: Maybe<Array<PimsIntegrationCapability>>;
  not?: Maybe<NestedEnumPimsIntegrationCapabilityWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsIntegrationCapability>>;
};

export type NestedEnumPimsInvoiceLineItemTypeFilter = {
  equals?: Maybe<PimsInvoiceLineItemType>;
  in?: Maybe<Array<PimsInvoiceLineItemType>>;
  not?: Maybe<NestedEnumPimsInvoiceLineItemTypeFilter>;
  notIn?: Maybe<Array<PimsInvoiceLineItemType>>;
};

export type NestedEnumPimsInvoiceLineItemTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPimsInvoiceLineItemTypeFilter>;
  _min?: Maybe<NestedEnumPimsInvoiceLineItemTypeFilter>;
  equals?: Maybe<PimsInvoiceLineItemType>;
  in?: Maybe<Array<PimsInvoiceLineItemType>>;
  not?: Maybe<NestedEnumPimsInvoiceLineItemTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsInvoiceLineItemType>>;
};

export type NestedEnumPimsSyncFrequencyFilter = {
  equals?: Maybe<PimsSyncFrequency>;
  in?: Maybe<Array<PimsSyncFrequency>>;
  not?: Maybe<NestedEnumPimsSyncFrequencyFilter>;
  notIn?: Maybe<Array<PimsSyncFrequency>>;
};

export type NestedEnumPimsSyncFrequencyWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPimsSyncFrequencyFilter>;
  _min?: Maybe<NestedEnumPimsSyncFrequencyFilter>;
  equals?: Maybe<PimsSyncFrequency>;
  in?: Maybe<Array<PimsSyncFrequency>>;
  not?: Maybe<NestedEnumPimsSyncFrequencyWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsSyncFrequency>>;
};

export type NestedEnumPimsSyncStatusNullableFilter = {
  equals?: Maybe<PimsSyncStatus>;
  in?: Maybe<Array<PimsSyncStatus>>;
  not?: Maybe<NestedEnumPimsSyncStatusNullableFilter>;
  notIn?: Maybe<Array<PimsSyncStatus>>;
};

export type NestedEnumPimsSyncStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumPimsSyncStatusNullableFilter>;
  _min?: Maybe<NestedEnumPimsSyncStatusNullableFilter>;
  equals?: Maybe<PimsSyncStatus>;
  in?: Maybe<Array<PimsSyncStatus>>;
  not?: Maybe<NestedEnumPimsSyncStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsSyncStatus>>;
};

export type NestedEnumPimsWritebackStatusFilter = {
  equals?: Maybe<PimsWritebackStatus>;
  in?: Maybe<Array<PimsWritebackStatus>>;
  not?: Maybe<NestedEnumPimsWritebackStatusFilter>;
  notIn?: Maybe<Array<PimsWritebackStatus>>;
};

export type NestedEnumPimsWritebackStatusNullableFilter = {
  equals?: Maybe<PimsWritebackStatus>;
  in?: Maybe<Array<PimsWritebackStatus>>;
  not?: Maybe<NestedEnumPimsWritebackStatusNullableFilter>;
  notIn?: Maybe<Array<PimsWritebackStatus>>;
};

export type NestedEnumPimsWritebackStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumPimsWritebackStatusNullableFilter>;
  _min?: Maybe<NestedEnumPimsWritebackStatusNullableFilter>;
  equals?: Maybe<PimsWritebackStatus>;
  in?: Maybe<Array<PimsWritebackStatus>>;
  not?: Maybe<NestedEnumPimsWritebackStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsWritebackStatus>>;
};

export type NestedEnumPimsWritebackStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPimsWritebackStatusFilter>;
  _min?: Maybe<NestedEnumPimsWritebackStatusFilter>;
  equals?: Maybe<PimsWritebackStatus>;
  in?: Maybe<Array<PimsWritebackStatus>>;
  not?: Maybe<NestedEnumPimsWritebackStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsWritebackStatus>>;
};

export type NestedEnumPimsWritebackTypeFilter = {
  equals?: Maybe<PimsWritebackType>;
  in?: Maybe<Array<PimsWritebackType>>;
  not?: Maybe<NestedEnumPimsWritebackTypeFilter>;
  notIn?: Maybe<Array<PimsWritebackType>>;
};

export type NestedEnumPimsWritebackTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPimsWritebackTypeFilter>;
  _min?: Maybe<NestedEnumPimsWritebackTypeFilter>;
  equals?: Maybe<PimsWritebackType>;
  in?: Maybe<Array<PimsWritebackType>>;
  not?: Maybe<NestedEnumPimsWritebackTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<PimsWritebackType>>;
};

export type NestedEnumPricingModelFilter = {
  equals?: Maybe<PricingModel>;
  in?: Maybe<Array<PricingModel>>;
  not?: Maybe<NestedEnumPricingModelFilter>;
  notIn?: Maybe<Array<PricingModel>>;
};

export type NestedEnumPricingModelWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPricingModelFilter>;
  _min?: Maybe<NestedEnumPricingModelFilter>;
  equals?: Maybe<PricingModel>;
  in?: Maybe<Array<PricingModel>>;
  not?: Maybe<NestedEnumPricingModelWithAggregatesFilter>;
  notIn?: Maybe<Array<PricingModel>>;
};

export type NestedEnumProductSupplyDurationUnitNullableFilter = {
  equals?: Maybe<ProductSupplyDurationUnit>;
  in?: Maybe<Array<ProductSupplyDurationUnit>>;
  not?: Maybe<NestedEnumProductSupplyDurationUnitNullableFilter>;
  notIn?: Maybe<Array<ProductSupplyDurationUnit>>;
};

export type NestedEnumProductSupplyDurationUnitNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumProductSupplyDurationUnitNullableFilter>;
  _min?: Maybe<NestedEnumProductSupplyDurationUnitNullableFilter>;
  equals?: Maybe<ProductSupplyDurationUnit>;
  in?: Maybe<Array<ProductSupplyDurationUnit>>;
  not?: Maybe<NestedEnumProductSupplyDurationUnitNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<ProductSupplyDurationUnit>>;
};

export type NestedEnumProductTypeFilter = {
  equals?: Maybe<ProductType>;
  in?: Maybe<Array<ProductType>>;
  not?: Maybe<NestedEnumProductTypeFilter>;
  notIn?: Maybe<Array<ProductType>>;
};

export type NestedEnumProductTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumProductTypeFilter>;
  _min?: Maybe<NestedEnumProductTypeFilter>;
  equals?: Maybe<ProductType>;
  in?: Maybe<Array<ProductType>>;
  not?: Maybe<NestedEnumProductTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ProductType>>;
};

export type NestedEnumProfilePimsSyncStatusFilter = {
  equals?: Maybe<ProfilePimsSyncStatus>;
  in?: Maybe<Array<ProfilePimsSyncStatus>>;
  not?: Maybe<NestedEnumProfilePimsSyncStatusFilter>;
  notIn?: Maybe<Array<ProfilePimsSyncStatus>>;
};

export type NestedEnumProfilePimsSyncStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumProfilePimsSyncStatusFilter>;
  _min?: Maybe<NestedEnumProfilePimsSyncStatusFilter>;
  equals?: Maybe<ProfilePimsSyncStatus>;
  in?: Maybe<Array<ProfilePimsSyncStatus>>;
  not?: Maybe<NestedEnumProfilePimsSyncStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<ProfilePimsSyncStatus>>;
};

export type NestedEnumPushNotificationDeliveryErrorTypeNullableFilter = {
  equals?: Maybe<PushNotificationDeliveryErrorType>;
  in?: Maybe<Array<PushNotificationDeliveryErrorType>>;
  not?: Maybe<NestedEnumPushNotificationDeliveryErrorTypeNullableFilter>;
  notIn?: Maybe<Array<PushNotificationDeliveryErrorType>>;
};

export type NestedEnumPushNotificationDeliveryErrorTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumPushNotificationDeliveryErrorTypeNullableFilter>;
  _min?: Maybe<NestedEnumPushNotificationDeliveryErrorTypeNullableFilter>;
  equals?: Maybe<PushNotificationDeliveryErrorType>;
  in?: Maybe<Array<PushNotificationDeliveryErrorType>>;
  not?: Maybe<NestedEnumPushNotificationDeliveryErrorTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<PushNotificationDeliveryErrorType>>;
};

export type NestedEnumPushNotificationLogStatusTypeFilter = {
  equals?: Maybe<PushNotificationLogStatusType>;
  in?: Maybe<Array<PushNotificationLogStatusType>>;
  not?: Maybe<NestedEnumPushNotificationLogStatusTypeFilter>;
  notIn?: Maybe<Array<PushNotificationLogStatusType>>;
};

export type NestedEnumPushNotificationLogStatusTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPushNotificationLogStatusTypeFilter>;
  _min?: Maybe<NestedEnumPushNotificationLogStatusTypeFilter>;
  equals?: Maybe<PushNotificationLogStatusType>;
  in?: Maybe<Array<PushNotificationLogStatusType>>;
  not?: Maybe<NestedEnumPushNotificationLogStatusTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<PushNotificationLogStatusType>>;
};

export type NestedEnumPushNotificationStatusFilter = {
  equals?: Maybe<PushNotificationStatus>;
  in?: Maybe<Array<PushNotificationStatus>>;
  not?: Maybe<NestedEnumPushNotificationStatusFilter>;
  notIn?: Maybe<Array<PushNotificationStatus>>;
};

export type NestedEnumPushNotificationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPushNotificationStatusFilter>;
  _min?: Maybe<NestedEnumPushNotificationStatusFilter>;
  equals?: Maybe<PushNotificationStatus>;
  in?: Maybe<Array<PushNotificationStatus>>;
  not?: Maybe<NestedEnumPushNotificationStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<PushNotificationStatus>>;
};

export type NestedEnumRecapSourceFilter = {
  equals?: Maybe<RecapSource>;
  in?: Maybe<Array<RecapSource>>;
  not?: Maybe<NestedEnumRecapSourceFilter>;
  notIn?: Maybe<Array<RecapSource>>;
};

export type NestedEnumRecapSourceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumRecapSourceFilter>;
  _min?: Maybe<NestedEnumRecapSourceFilter>;
  equals?: Maybe<RecapSource>;
  in?: Maybe<Array<RecapSource>>;
  not?: Maybe<NestedEnumRecapSourceWithAggregatesFilter>;
  notIn?: Maybe<Array<RecapSource>>;
};

export type NestedEnumRecapStatusFilter = {
  equals?: Maybe<RecapStatus>;
  in?: Maybe<Array<RecapStatus>>;
  not?: Maybe<NestedEnumRecapStatusFilter>;
  notIn?: Maybe<Array<RecapStatus>>;
};

export type NestedEnumRecapStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumRecapStatusFilter>;
  _min?: Maybe<NestedEnumRecapStatusFilter>;
  equals?: Maybe<RecapStatus>;
  in?: Maybe<Array<RecapStatus>>;
  not?: Maybe<NestedEnumRecapStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<RecapStatus>>;
};

export type NestedEnumRecordingDownloadStatusFilter = {
  equals?: Maybe<RecordingDownloadStatus>;
  in?: Maybe<Array<RecordingDownloadStatus>>;
  not?: Maybe<NestedEnumRecordingDownloadStatusFilter>;
  notIn?: Maybe<Array<RecordingDownloadStatus>>;
};

export type NestedEnumRecordingDownloadStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumRecordingDownloadStatusFilter>;
  _min?: Maybe<NestedEnumRecordingDownloadStatusFilter>;
  equals?: Maybe<RecordingDownloadStatus>;
  in?: Maybe<Array<RecordingDownloadStatus>>;
  not?: Maybe<NestedEnumRecordingDownloadStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<RecordingDownloadStatus>>;
};

export type NestedEnumRefundReasonFilter = {
  equals?: Maybe<RefundReason>;
  in?: Maybe<Array<RefundReason>>;
  not?: Maybe<NestedEnumRefundReasonFilter>;
  notIn?: Maybe<Array<RefundReason>>;
};

export type NestedEnumRefundReasonWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumRefundReasonFilter>;
  _min?: Maybe<NestedEnumRefundReasonFilter>;
  equals?: Maybe<RefundReason>;
  in?: Maybe<Array<RefundReason>>;
  not?: Maybe<NestedEnumRefundReasonWithAggregatesFilter>;
  notIn?: Maybe<Array<RefundReason>>;
};

export type NestedEnumRenewalRejectionReasonNullableFilter = {
  equals?: Maybe<RenewalRejectionReason>;
  in?: Maybe<Array<RenewalRejectionReason>>;
  not?: Maybe<NestedEnumRenewalRejectionReasonNullableFilter>;
  notIn?: Maybe<Array<RenewalRejectionReason>>;
};

export type NestedEnumRenewalRejectionReasonNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumRenewalRejectionReasonNullableFilter>;
  _min?: Maybe<NestedEnumRenewalRejectionReasonNullableFilter>;
  equals?: Maybe<RenewalRejectionReason>;
  in?: Maybe<Array<RenewalRejectionReason>>;
  not?: Maybe<NestedEnumRenewalRejectionReasonNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<RenewalRejectionReason>>;
};

export type NestedEnumRoleFilter = {
  equals?: Maybe<Role>;
  in?: Maybe<Array<Role>>;
  not?: Maybe<NestedEnumRoleFilter>;
  notIn?: Maybe<Array<Role>>;
};

export type NestedEnumRoleWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumRoleFilter>;
  _min?: Maybe<NestedEnumRoleFilter>;
  equals?: Maybe<Role>;
  in?: Maybe<Array<Role>>;
  not?: Maybe<NestedEnumRoleWithAggregatesFilter>;
  notIn?: Maybe<Array<Role>>;
};

export type NestedEnumRuleActionsFilter = {
  equals?: Maybe<RuleActions>;
  in?: Maybe<Array<RuleActions>>;
  not?: Maybe<NestedEnumRuleActionsFilter>;
  notIn?: Maybe<Array<RuleActions>>;
};

export type NestedEnumRuleActionsWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumRuleActionsFilter>;
  _min?: Maybe<NestedEnumRuleActionsFilter>;
  equals?: Maybe<RuleActions>;
  in?: Maybe<Array<RuleActions>>;
  not?: Maybe<NestedEnumRuleActionsWithAggregatesFilter>;
  notIn?: Maybe<Array<RuleActions>>;
};

export type NestedEnumSegmentModelTypeFilter = {
  equals?: Maybe<SegmentModelType>;
  in?: Maybe<Array<SegmentModelType>>;
  not?: Maybe<NestedEnumSegmentModelTypeFilter>;
  notIn?: Maybe<Array<SegmentModelType>>;
};

export type NestedEnumSegmentModelTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSegmentModelTypeFilter>;
  _min?: Maybe<NestedEnumSegmentModelTypeFilter>;
  equals?: Maybe<SegmentModelType>;
  in?: Maybe<Array<SegmentModelType>>;
  not?: Maybe<NestedEnumSegmentModelTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<SegmentModelType>>;
};

export type NestedEnumSegmentTypeFilter = {
  equals?: Maybe<SegmentType>;
  in?: Maybe<Array<SegmentType>>;
  not?: Maybe<NestedEnumSegmentTypeFilter>;
  notIn?: Maybe<Array<SegmentType>>;
};

export type NestedEnumSegmentTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSegmentTypeFilter>;
  _min?: Maybe<NestedEnumSegmentTypeFilter>;
  equals?: Maybe<SegmentType>;
  in?: Maybe<Array<SegmentType>>;
  not?: Maybe<NestedEnumSegmentTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<SegmentType>>;
};

export type NestedEnumServiceCapabilityFilter = {
  equals?: Maybe<ServiceCapability>;
  in?: Maybe<Array<ServiceCapability>>;
  not?: Maybe<NestedEnumServiceCapabilityFilter>;
  notIn?: Maybe<Array<ServiceCapability>>;
};

export type NestedEnumServiceCapabilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumServiceCapabilityFilter>;
  _min?: Maybe<NestedEnumServiceCapabilityFilter>;
  equals?: Maybe<ServiceCapability>;
  in?: Maybe<Array<ServiceCapability>>;
  not?: Maybe<NestedEnumServiceCapabilityWithAggregatesFilter>;
  notIn?: Maybe<Array<ServiceCapability>>;
};

export type NestedEnumServiceProviderFilter = {
  equals?: Maybe<ServiceProvider>;
  in?: Maybe<Array<ServiceProvider>>;
  not?: Maybe<NestedEnumServiceProviderFilter>;
  notIn?: Maybe<Array<ServiceProvider>>;
};

export type NestedEnumServiceProviderWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumServiceProviderFilter>;
  _min?: Maybe<NestedEnumServiceProviderFilter>;
  equals?: Maybe<ServiceProvider>;
  in?: Maybe<Array<ServiceProvider>>;
  not?: Maybe<NestedEnumServiceProviderWithAggregatesFilter>;
  notIn?: Maybe<Array<ServiceProvider>>;
};

export type NestedEnumServiceReminderNotificationTypeFilter = {
  equals?: Maybe<ServiceReminderNotificationType>;
  in?: Maybe<Array<ServiceReminderNotificationType>>;
  not?: Maybe<NestedEnumServiceReminderNotificationTypeFilter>;
  notIn?: Maybe<Array<ServiceReminderNotificationType>>;
};

export type NestedEnumServiceReminderNotificationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumServiceReminderNotificationTypeFilter>;
  _min?: Maybe<NestedEnumServiceReminderNotificationTypeFilter>;
  equals?: Maybe<ServiceReminderNotificationType>;
  in?: Maybe<Array<ServiceReminderNotificationType>>;
  not?: Maybe<NestedEnumServiceReminderNotificationTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ServiceReminderNotificationType>>;
};

export type NestedEnumServiceReminderTimingOffsetUnitFilter = {
  equals?: Maybe<ServiceReminderTimingOffsetUnit>;
  in?: Maybe<Array<ServiceReminderTimingOffsetUnit>>;
  not?: Maybe<NestedEnumServiceReminderTimingOffsetUnitFilter>;
  notIn?: Maybe<Array<ServiceReminderTimingOffsetUnit>>;
};

export type NestedEnumServiceReminderTimingOffsetUnitWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumServiceReminderTimingOffsetUnitFilter>;
  _min?: Maybe<NestedEnumServiceReminderTimingOffsetUnitFilter>;
  equals?: Maybe<ServiceReminderTimingOffsetUnit>;
  in?: Maybe<Array<ServiceReminderTimingOffsetUnit>>;
  not?: Maybe<NestedEnumServiceReminderTimingOffsetUnitWithAggregatesFilter>;
  notIn?: Maybe<Array<ServiceReminderTimingOffsetUnit>>;
};

export type NestedEnumServiceReminderTimingTypeFilter = {
  equals?: Maybe<ServiceReminderTimingType>;
  in?: Maybe<Array<ServiceReminderTimingType>>;
  not?: Maybe<NestedEnumServiceReminderTimingTypeFilter>;
  notIn?: Maybe<Array<ServiceReminderTimingType>>;
};

export type NestedEnumServiceReminderTimingTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumServiceReminderTimingTypeFilter>;
  _min?: Maybe<NestedEnumServiceReminderTimingTypeFilter>;
  equals?: Maybe<ServiceReminderTimingType>;
  in?: Maybe<Array<ServiceReminderTimingType>>;
  not?: Maybe<NestedEnumServiceReminderTimingTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<ServiceReminderTimingType>>;
};

export type NestedEnumSmsEntityTypeNullableFilter = {
  equals?: Maybe<SmsEntityType>;
  in?: Maybe<Array<SmsEntityType>>;
  not?: Maybe<NestedEnumSmsEntityTypeNullableFilter>;
  notIn?: Maybe<Array<SmsEntityType>>;
};

export type NestedEnumSmsEntityTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSmsEntityTypeNullableFilter>;
  _min?: Maybe<NestedEnumSmsEntityTypeNullableFilter>;
  equals?: Maybe<SmsEntityType>;
  in?: Maybe<Array<SmsEntityType>>;
  not?: Maybe<NestedEnumSmsEntityTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SmsEntityType>>;
};

export type NestedEnumSmsNotificationDeliveryErrorTypeNullableFilter = {
  equals?: Maybe<SmsNotificationDeliveryErrorType>;
  in?: Maybe<Array<SmsNotificationDeliveryErrorType>>;
  not?: Maybe<NestedEnumSmsNotificationDeliveryErrorTypeNullableFilter>;
  notIn?: Maybe<Array<SmsNotificationDeliveryErrorType>>;
};

export type NestedEnumSmsNotificationDeliveryErrorTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSmsNotificationDeliveryErrorTypeNullableFilter>;
  _min?: Maybe<NestedEnumSmsNotificationDeliveryErrorTypeNullableFilter>;
  equals?: Maybe<SmsNotificationDeliveryErrorType>;
  in?: Maybe<Array<SmsNotificationDeliveryErrorType>>;
  not?: Maybe<NestedEnumSmsNotificationDeliveryErrorTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SmsNotificationDeliveryErrorType>>;
};

export type NestedEnumSmsNotificationProviderFilter = {
  equals?: Maybe<SmsNotificationProvider>;
  in?: Maybe<Array<SmsNotificationProvider>>;
  not?: Maybe<NestedEnumSmsNotificationProviderFilter>;
  notIn?: Maybe<Array<SmsNotificationProvider>>;
};

export type NestedEnumSmsNotificationProviderWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSmsNotificationProviderFilter>;
  _min?: Maybe<NestedEnumSmsNotificationProviderFilter>;
  equals?: Maybe<SmsNotificationProvider>;
  in?: Maybe<Array<SmsNotificationProvider>>;
  not?: Maybe<NestedEnumSmsNotificationProviderWithAggregatesFilter>;
  notIn?: Maybe<Array<SmsNotificationProvider>>;
};

export type NestedEnumSmsNotificationStatusTypeFilter = {
  equals?: Maybe<SmsNotificationStatusType>;
  in?: Maybe<Array<SmsNotificationStatusType>>;
  not?: Maybe<NestedEnumSmsNotificationStatusTypeFilter>;
  notIn?: Maybe<Array<SmsNotificationStatusType>>;
};

export type NestedEnumSmsNotificationStatusTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSmsNotificationStatusTypeFilter>;
  _min?: Maybe<NestedEnumSmsNotificationStatusTypeFilter>;
  equals?: Maybe<SmsNotificationStatusType>;
  in?: Maybe<Array<SmsNotificationStatusType>>;
  not?: Maybe<NestedEnumSmsNotificationStatusTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<SmsNotificationStatusType>>;
};

export type NestedEnumSpeciesTypeFilter = {
  equals?: Maybe<SpeciesType>;
  in?: Maybe<Array<SpeciesType>>;
  not?: Maybe<NestedEnumSpeciesTypeFilter>;
  notIn?: Maybe<Array<SpeciesType>>;
};

export type NestedEnumSpeciesTypeNullableFilter = {
  equals?: Maybe<SpeciesType>;
  in?: Maybe<Array<SpeciesType>>;
  not?: Maybe<NestedEnumSpeciesTypeNullableFilter>;
  notIn?: Maybe<Array<SpeciesType>>;
};

export type NestedEnumSpeciesTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSpeciesTypeNullableFilter>;
  _min?: Maybe<NestedEnumSpeciesTypeNullableFilter>;
  equals?: Maybe<SpeciesType>;
  in?: Maybe<Array<SpeciesType>>;
  not?: Maybe<NestedEnumSpeciesTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SpeciesType>>;
};

export type NestedEnumSpeciesTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSpeciesTypeFilter>;
  _min?: Maybe<NestedEnumSpeciesTypeFilter>;
  equals?: Maybe<SpeciesType>;
  in?: Maybe<Array<SpeciesType>>;
  not?: Maybe<NestedEnumSpeciesTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<SpeciesType>>;
};

export type NestedEnumStateFilter = {
  equals?: Maybe<State>;
  in?: Maybe<Array<State>>;
  not?: Maybe<NestedEnumStateFilter>;
  notIn?: Maybe<Array<State>>;
};

export type NestedEnumStateWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStateFilter>;
  _min?: Maybe<NestedEnumStateFilter>;
  equals?: Maybe<State>;
  in?: Maybe<Array<State>>;
  not?: Maybe<NestedEnumStateWithAggregatesFilter>;
  notIn?: Maybe<Array<State>>;
};

export type NestedEnumStripeCollectionMethodFilter = {
  equals?: Maybe<StripeCollectionMethod>;
  in?: Maybe<Array<StripeCollectionMethod>>;
  not?: Maybe<NestedEnumStripeCollectionMethodFilter>;
  notIn?: Maybe<Array<StripeCollectionMethod>>;
};

export type NestedEnumStripeCollectionMethodWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeCollectionMethodFilter>;
  _min?: Maybe<NestedEnumStripeCollectionMethodFilter>;
  equals?: Maybe<StripeCollectionMethod>;
  in?: Maybe<Array<StripeCollectionMethod>>;
  not?: Maybe<NestedEnumStripeCollectionMethodWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeCollectionMethod>>;
};

export type NestedEnumStripeDisputeReasonNullableFilter = {
  equals?: Maybe<StripeDisputeReason>;
  in?: Maybe<Array<StripeDisputeReason>>;
  not?: Maybe<NestedEnumStripeDisputeReasonNullableFilter>;
  notIn?: Maybe<Array<StripeDisputeReason>>;
};

export type NestedEnumStripeDisputeReasonNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumStripeDisputeReasonNullableFilter>;
  _min?: Maybe<NestedEnumStripeDisputeReasonNullableFilter>;
  equals?: Maybe<StripeDisputeReason>;
  in?: Maybe<Array<StripeDisputeReason>>;
  not?: Maybe<NestedEnumStripeDisputeReasonNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeDisputeReason>>;
};

export type NestedEnumStripeDisputeStatusFilter = {
  equals?: Maybe<StripeDisputeStatus>;
  in?: Maybe<Array<StripeDisputeStatus>>;
  not?: Maybe<NestedEnumStripeDisputeStatusFilter>;
  notIn?: Maybe<Array<StripeDisputeStatus>>;
};

export type NestedEnumStripeDisputeStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeDisputeStatusFilter>;
  _min?: Maybe<NestedEnumStripeDisputeStatusFilter>;
  equals?: Maybe<StripeDisputeStatus>;
  in?: Maybe<Array<StripeDisputeStatus>>;
  not?: Maybe<NestedEnumStripeDisputeStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeDisputeStatus>>;
};

export type NestedEnumStripeInvoiceStatusFilter = {
  equals?: Maybe<StripeInvoiceStatus>;
  in?: Maybe<Array<StripeInvoiceStatus>>;
  not?: Maybe<NestedEnumStripeInvoiceStatusFilter>;
  notIn?: Maybe<Array<StripeInvoiceStatus>>;
};

export type NestedEnumStripeInvoiceStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeInvoiceStatusFilter>;
  _min?: Maybe<NestedEnumStripeInvoiceStatusFilter>;
  equals?: Maybe<StripeInvoiceStatus>;
  in?: Maybe<Array<StripeInvoiceStatus>>;
  not?: Maybe<NestedEnumStripeInvoiceStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeInvoiceStatus>>;
};

export type NestedEnumStripePaymentErrorNullableFilter = {
  equals?: Maybe<StripePaymentError>;
  in?: Maybe<Array<StripePaymentError>>;
  not?: Maybe<NestedEnumStripePaymentErrorNullableFilter>;
  notIn?: Maybe<Array<StripePaymentError>>;
};

export type NestedEnumStripePaymentErrorNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumStripePaymentErrorNullableFilter>;
  _min?: Maybe<NestedEnumStripePaymentErrorNullableFilter>;
  equals?: Maybe<StripePaymentError>;
  in?: Maybe<Array<StripePaymentError>>;
  not?: Maybe<NestedEnumStripePaymentErrorNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<StripePaymentError>>;
};

export type NestedEnumStripePaymentIntentStatusFilter = {
  equals?: Maybe<StripePaymentIntentStatus>;
  in?: Maybe<Array<StripePaymentIntentStatus>>;
  not?: Maybe<NestedEnumStripePaymentIntentStatusFilter>;
  notIn?: Maybe<Array<StripePaymentIntentStatus>>;
};

export type NestedEnumStripePaymentIntentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripePaymentIntentStatusFilter>;
  _min?: Maybe<NestedEnumStripePaymentIntentStatusFilter>;
  equals?: Maybe<StripePaymentIntentStatus>;
  in?: Maybe<Array<StripePaymentIntentStatus>>;
  not?: Maybe<NestedEnumStripePaymentIntentStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<StripePaymentIntentStatus>>;
};

export type NestedEnumStripePaymentMethodTypeFilter = {
  equals?: Maybe<StripePaymentMethodType>;
  in?: Maybe<Array<StripePaymentMethodType>>;
  not?: Maybe<NestedEnumStripePaymentMethodTypeFilter>;
  notIn?: Maybe<Array<StripePaymentMethodType>>;
};

export type NestedEnumStripePaymentMethodTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripePaymentMethodTypeFilter>;
  _min?: Maybe<NestedEnumStripePaymentMethodTypeFilter>;
  equals?: Maybe<StripePaymentMethodType>;
  in?: Maybe<Array<StripePaymentMethodType>>;
  not?: Maybe<NestedEnumStripePaymentMethodTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<StripePaymentMethodType>>;
};

export type NestedEnumStripePaymentTransferTypeFilter = {
  equals?: Maybe<StripePaymentTransferType>;
  in?: Maybe<Array<StripePaymentTransferType>>;
  not?: Maybe<NestedEnumStripePaymentTransferTypeFilter>;
  notIn?: Maybe<Array<StripePaymentTransferType>>;
};

export type NestedEnumStripePaymentTransferTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripePaymentTransferTypeFilter>;
  _min?: Maybe<NestedEnumStripePaymentTransferTypeFilter>;
  equals?: Maybe<StripePaymentTransferType>;
  in?: Maybe<Array<StripePaymentTransferType>>;
  not?: Maybe<NestedEnumStripePaymentTransferTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<StripePaymentTransferType>>;
};

export type NestedEnumStripePayoutStatusFilter = {
  equals?: Maybe<StripePayoutStatus>;
  in?: Maybe<Array<StripePayoutStatus>>;
  not?: Maybe<NestedEnumStripePayoutStatusFilter>;
  notIn?: Maybe<Array<StripePayoutStatus>>;
};

export type NestedEnumStripePayoutStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripePayoutStatusFilter>;
  _min?: Maybe<NestedEnumStripePayoutStatusFilter>;
  equals?: Maybe<StripePayoutStatus>;
  in?: Maybe<Array<StripePayoutStatus>>;
  not?: Maybe<NestedEnumStripePayoutStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<StripePayoutStatus>>;
};

export type NestedEnumStripeReceiptMediumFilter = {
  equals?: Maybe<StripeReceiptMedium>;
  in?: Maybe<Array<StripeReceiptMedium>>;
  not?: Maybe<NestedEnumStripeReceiptMediumFilter>;
  notIn?: Maybe<Array<StripeReceiptMedium>>;
};

export type NestedEnumStripeReceiptMediumWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeReceiptMediumFilter>;
  _min?: Maybe<NestedEnumStripeReceiptMediumFilter>;
  equals?: Maybe<StripeReceiptMedium>;
  in?: Maybe<Array<StripeReceiptMedium>>;
  not?: Maybe<NestedEnumStripeReceiptMediumWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeReceiptMedium>>;
};

export type NestedEnumStripeTerminalLocationTypeFilter = {
  equals?: Maybe<StripeTerminalLocationType>;
  in?: Maybe<Array<StripeTerminalLocationType>>;
  not?: Maybe<NestedEnumStripeTerminalLocationTypeFilter>;
  notIn?: Maybe<Array<StripeTerminalLocationType>>;
};

export type NestedEnumStripeTerminalLocationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeTerminalLocationTypeFilter>;
  _min?: Maybe<NestedEnumStripeTerminalLocationTypeFilter>;
  equals?: Maybe<StripeTerminalLocationType>;
  in?: Maybe<Array<StripeTerminalLocationType>>;
  not?: Maybe<NestedEnumStripeTerminalLocationTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeTerminalLocationType>>;
};

export type NestedEnumStripeTerminalModelFilter = {
  equals?: Maybe<StripeTerminalModel>;
  in?: Maybe<Array<StripeTerminalModel>>;
  not?: Maybe<NestedEnumStripeTerminalModelFilter>;
  notIn?: Maybe<Array<StripeTerminalModel>>;
};

export type NestedEnumStripeTerminalModelWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeTerminalModelFilter>;
  _min?: Maybe<NestedEnumStripeTerminalModelFilter>;
  equals?: Maybe<StripeTerminalModel>;
  in?: Maybe<Array<StripeTerminalModel>>;
  not?: Maybe<NestedEnumStripeTerminalModelWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeTerminalModel>>;
};

export type NestedEnumStripeTerminalStatusFilter = {
  equals?: Maybe<StripeTerminalStatus>;
  in?: Maybe<Array<StripeTerminalStatus>>;
  not?: Maybe<NestedEnumStripeTerminalStatusFilter>;
  notIn?: Maybe<Array<StripeTerminalStatus>>;
};

export type NestedEnumStripeTerminalStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumStripeTerminalStatusFilter>;
  _min?: Maybe<NestedEnumStripeTerminalStatusFilter>;
  equals?: Maybe<StripeTerminalStatus>;
  in?: Maybe<Array<StripeTerminalStatus>>;
  not?: Maybe<NestedEnumStripeTerminalStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<StripeTerminalStatus>>;
};

export type NestedEnumSupportEventStatusFilter = {
  equals?: Maybe<SupportEventStatus>;
  in?: Maybe<Array<SupportEventStatus>>;
  not?: Maybe<NestedEnumSupportEventStatusFilter>;
  notIn?: Maybe<Array<SupportEventStatus>>;
};

export type NestedEnumSupportEventStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSupportEventStatusFilter>;
  _min?: Maybe<NestedEnumSupportEventStatusFilter>;
  equals?: Maybe<SupportEventStatus>;
  in?: Maybe<Array<SupportEventStatus>>;
  not?: Maybe<NestedEnumSupportEventStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<SupportEventStatus>>;
};

export type NestedEnumSurveyStepNullableFilter = {
  equals?: Maybe<SurveyStep>;
  in?: Maybe<Array<SurveyStep>>;
  not?: Maybe<NestedEnumSurveyStepNullableFilter>;
  notIn?: Maybe<Array<SurveyStep>>;
};

export type NestedEnumSurveyStepNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSurveyStepNullableFilter>;
  _min?: Maybe<NestedEnumSurveyStepNullableFilter>;
  equals?: Maybe<SurveyStep>;
  in?: Maybe<Array<SurveyStep>>;
  not?: Maybe<NestedEnumSurveyStepNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SurveyStep>>;
};

export type NestedEnumSurveyTypeFilter = {
  equals?: Maybe<SurveyType>;
  in?: Maybe<Array<SurveyType>>;
  not?: Maybe<NestedEnumSurveyTypeFilter>;
  notIn?: Maybe<Array<SurveyType>>;
};

export type NestedEnumSurveyTypeNullableFilter = {
  equals?: Maybe<SurveyType>;
  in?: Maybe<Array<SurveyType>>;
  not?: Maybe<NestedEnumSurveyTypeNullableFilter>;
  notIn?: Maybe<Array<SurveyType>>;
};

export type NestedEnumSurveyTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSurveyTypeNullableFilter>;
  _min?: Maybe<NestedEnumSurveyTypeNullableFilter>;
  equals?: Maybe<SurveyType>;
  in?: Maybe<Array<SurveyType>>;
  not?: Maybe<NestedEnumSurveyTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SurveyType>>;
};

export type NestedEnumSurveyTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSurveyTypeFilter>;
  _min?: Maybe<NestedEnumSurveyTypeFilter>;
  equals?: Maybe<SurveyType>;
  in?: Maybe<Array<SurveyType>>;
  not?: Maybe<NestedEnumSurveyTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<SurveyType>>;
};

export type NestedEnumSyncVetIntegrationSystemNullableFilter = {
  equals?: Maybe<SyncVetIntegrationSystem>;
  in?: Maybe<Array<SyncVetIntegrationSystem>>;
  not?: Maybe<NestedEnumSyncVetIntegrationSystemNullableFilter>;
  notIn?: Maybe<Array<SyncVetIntegrationSystem>>;
};

export type NestedEnumSyncVetIntegrationSystemNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSyncVetIntegrationSystemNullableFilter>;
  _min?: Maybe<NestedEnumSyncVetIntegrationSystemNullableFilter>;
  equals?: Maybe<SyncVetIntegrationSystem>;
  in?: Maybe<Array<SyncVetIntegrationSystem>>;
  not?: Maybe<NestedEnumSyncVetIntegrationSystemNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SyncVetIntegrationSystem>>;
};

export type NestedEnumSynchronyEventStatusFilter = {
  equals?: Maybe<SynchronyEventStatus>;
  in?: Maybe<Array<SynchronyEventStatus>>;
  not?: Maybe<NestedEnumSynchronyEventStatusFilter>;
  notIn?: Maybe<Array<SynchronyEventStatus>>;
};

export type NestedEnumSynchronyEventStatusNullableFilter = {
  equals?: Maybe<SynchronyEventStatus>;
  in?: Maybe<Array<SynchronyEventStatus>>;
  not?: Maybe<NestedEnumSynchronyEventStatusNullableFilter>;
  notIn?: Maybe<Array<SynchronyEventStatus>>;
};

export type NestedEnumSynchronyEventStatusNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumSynchronyEventStatusNullableFilter>;
  _min?: Maybe<NestedEnumSynchronyEventStatusNullableFilter>;
  equals?: Maybe<SynchronyEventStatus>;
  in?: Maybe<Array<SynchronyEventStatus>>;
  not?: Maybe<NestedEnumSynchronyEventStatusNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<SynchronyEventStatus>>;
};

export type NestedEnumSynchronyEventStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSynchronyEventStatusFilter>;
  _min?: Maybe<NestedEnumSynchronyEventStatusFilter>;
  equals?: Maybe<SynchronyEventStatus>;
  in?: Maybe<Array<SynchronyEventStatus>>;
  not?: Maybe<NestedEnumSynchronyEventStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<SynchronyEventStatus>>;
};

export type NestedEnumSynchronyEventTypeFilter = {
  equals?: Maybe<SynchronyEventType>;
  in?: Maybe<Array<SynchronyEventType>>;
  not?: Maybe<NestedEnumSynchronyEventTypeFilter>;
  notIn?: Maybe<Array<SynchronyEventType>>;
};

export type NestedEnumSynchronyEventTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSynchronyEventTypeFilter>;
  _min?: Maybe<NestedEnumSynchronyEventTypeFilter>;
  equals?: Maybe<SynchronyEventType>;
  in?: Maybe<Array<SynchronyEventType>>;
  not?: Maybe<NestedEnumSynchronyEventTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<SynchronyEventType>>;
};

export type NestedEnumTaskStatusFilter = {
  equals?: Maybe<TaskStatus>;
  in?: Maybe<Array<TaskStatus>>;
  not?: Maybe<NestedEnumTaskStatusFilter>;
  notIn?: Maybe<Array<TaskStatus>>;
};

export type NestedEnumTaskStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumTaskStatusFilter>;
  _min?: Maybe<NestedEnumTaskStatusFilter>;
  equals?: Maybe<TaskStatus>;
  in?: Maybe<Array<TaskStatus>>;
  not?: Maybe<NestedEnumTaskStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<TaskStatus>>;
};

export type NestedEnumTaskTypeFilter = {
  equals?: Maybe<TaskType>;
  in?: Maybe<Array<TaskType>>;
  not?: Maybe<NestedEnumTaskTypeFilter>;
  notIn?: Maybe<Array<TaskType>>;
};

export type NestedEnumTaskTypeNullableFilter = {
  equals?: Maybe<TaskType>;
  in?: Maybe<Array<TaskType>>;
  not?: Maybe<NestedEnumTaskTypeNullableFilter>;
  notIn?: Maybe<Array<TaskType>>;
};

export type NestedEnumTaskTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumTaskTypeNullableFilter>;
  _min?: Maybe<NestedEnumTaskTypeNullableFilter>;
  equals?: Maybe<TaskType>;
  in?: Maybe<Array<TaskType>>;
  not?: Maybe<NestedEnumTaskTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<TaskType>>;
};

export type NestedEnumTaskTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumTaskTypeFilter>;
  _min?: Maybe<NestedEnumTaskTypeFilter>;
  equals?: Maybe<TaskType>;
  in?: Maybe<Array<TaskType>>;
  not?: Maybe<NestedEnumTaskTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<TaskType>>;
};

export type NestedEnumTemplateAvailabilityFilter = {
  equals?: Maybe<TemplateAvailability>;
  in?: Maybe<Array<TemplateAvailability>>;
  not?: Maybe<NestedEnumTemplateAvailabilityFilter>;
  notIn?: Maybe<Array<TemplateAvailability>>;
};

export type NestedEnumTemplateAvailabilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumTemplateAvailabilityFilter>;
  _min?: Maybe<NestedEnumTemplateAvailabilityFilter>;
  equals?: Maybe<TemplateAvailability>;
  in?: Maybe<Array<TemplateAvailability>>;
  not?: Maybe<NestedEnumTemplateAvailabilityWithAggregatesFilter>;
  notIn?: Maybe<Array<TemplateAvailability>>;
};

export type NestedEnumTimeUnitNullableFilter = {
  equals?: Maybe<TimeUnit>;
  in?: Maybe<Array<TimeUnit>>;
  not?: Maybe<NestedEnumTimeUnitNullableFilter>;
  notIn?: Maybe<Array<TimeUnit>>;
};

export type NestedEnumTimeUnitNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumTimeUnitNullableFilter>;
  _min?: Maybe<NestedEnumTimeUnitNullableFilter>;
  equals?: Maybe<TimeUnit>;
  in?: Maybe<Array<TimeUnit>>;
  not?: Maybe<NestedEnumTimeUnitNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<TimeUnit>>;
};

export type NestedEnumTranscriptionServicesNullableFilter = {
  equals?: Maybe<TranscriptionServices>;
  in?: Maybe<Array<TranscriptionServices>>;
  not?: Maybe<NestedEnumTranscriptionServicesNullableFilter>;
  notIn?: Maybe<Array<TranscriptionServices>>;
};

export type NestedEnumTranscriptionServicesNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumTranscriptionServicesNullableFilter>;
  _min?: Maybe<NestedEnumTranscriptionServicesNullableFilter>;
  equals?: Maybe<TranscriptionServices>;
  in?: Maybe<Array<TranscriptionServices>>;
  not?: Maybe<NestedEnumTranscriptionServicesNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<TranscriptionServices>>;
};

export type NestedEnumTwilioRecordingStatusFilter = {
  equals?: Maybe<TwilioRecordingStatus>;
  in?: Maybe<Array<TwilioRecordingStatus>>;
  not?: Maybe<NestedEnumTwilioRecordingStatusFilter>;
  notIn?: Maybe<Array<TwilioRecordingStatus>>;
};

export type NestedEnumTwilioRecordingStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumTwilioRecordingStatusFilter>;
  _min?: Maybe<NestedEnumTwilioRecordingStatusFilter>;
  equals?: Maybe<TwilioRecordingStatus>;
  in?: Maybe<Array<TwilioRecordingStatus>>;
  not?: Maybe<NestedEnumTwilioRecordingStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<TwilioRecordingStatus>>;
};

export type NestedEnumTwilioVerificationStatusFilter = {
  equals?: Maybe<TwilioVerificationStatus>;
  in?: Maybe<Array<TwilioVerificationStatus>>;
  not?: Maybe<NestedEnumTwilioVerificationStatusFilter>;
  notIn?: Maybe<Array<TwilioVerificationStatus>>;
};

export type NestedEnumTwilioVerificationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumTwilioVerificationStatusFilter>;
  _min?: Maybe<NestedEnumTwilioVerificationStatusFilter>;
  equals?: Maybe<TwilioVerificationStatus>;
  in?: Maybe<Array<TwilioVerificationStatus>>;
  not?: Maybe<NestedEnumTwilioVerificationStatusWithAggregatesFilter>;
  notIn?: Maybe<Array<TwilioVerificationStatus>>;
};

export type NestedEnumUserTypeFilter = {
  equals?: Maybe<UserType>;
  in?: Maybe<Array<UserType>>;
  not?: Maybe<NestedEnumUserTypeFilter>;
  notIn?: Maybe<Array<UserType>>;
};

export type NestedEnumUserTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumUserTypeFilter>;
  _min?: Maybe<NestedEnumUserTypeFilter>;
  equals?: Maybe<UserType>;
  in?: Maybe<Array<UserType>>;
  not?: Maybe<NestedEnumUserTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<UserType>>;
};

export type NestedEnumVetDataIntegrationSystemFilter = {
  equals?: Maybe<VetDataIntegrationSystem>;
  in?: Maybe<Array<VetDataIntegrationSystem>>;
  not?: Maybe<NestedEnumVetDataIntegrationSystemFilter>;
  notIn?: Maybe<Array<VetDataIntegrationSystem>>;
};

export type NestedEnumVetDataIntegrationSystemWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumVetDataIntegrationSystemFilter>;
  _min?: Maybe<NestedEnumVetDataIntegrationSystemFilter>;
  equals?: Maybe<VetDataIntegrationSystem>;
  in?: Maybe<Array<VetDataIntegrationSystem>>;
  not?: Maybe<NestedEnumVetDataIntegrationSystemWithAggregatesFilter>;
  notIn?: Maybe<Array<VetDataIntegrationSystem>>;
};

export type NestedEnumVetLicenseTypeFilter = {
  equals?: Maybe<VetLicenseType>;
  in?: Maybe<Array<VetLicenseType>>;
  not?: Maybe<NestedEnumVetLicenseTypeFilter>;
  notIn?: Maybe<Array<VetLicenseType>>;
};

export type NestedEnumVetLicenseTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumVetLicenseTypeFilter>;
  _min?: Maybe<NestedEnumVetLicenseTypeFilter>;
  equals?: Maybe<VetLicenseType>;
  in?: Maybe<Array<VetLicenseType>>;
  not?: Maybe<NestedEnumVetLicenseTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<VetLicenseType>>;
};

export type NestedEnumVetsourceCodeTagTypeFilter = {
  equals?: Maybe<VetsourceCodeTagType>;
  in?: Maybe<Array<VetsourceCodeTagType>>;
  not?: Maybe<NestedEnumVetsourceCodeTagTypeFilter>;
  notIn?: Maybe<Array<VetsourceCodeTagType>>;
};

export type NestedEnumVetsourceCodeTagTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumVetsourceCodeTagTypeFilter>;
  _min?: Maybe<NestedEnumVetsourceCodeTagTypeFilter>;
  equals?: Maybe<VetsourceCodeTagType>;
  in?: Maybe<Array<VetsourceCodeTagType>>;
  not?: Maybe<NestedEnumVetsourceCodeTagTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<VetsourceCodeTagType>>;
};

export type NestedEnumVetsourceInstallationConnectivityStateFilter = {
  equals?: Maybe<VetsourceInstallationConnectivityState>;
  in?: Maybe<Array<VetsourceInstallationConnectivityState>>;
  not?: Maybe<NestedEnumVetsourceInstallationConnectivityStateFilter>;
  notIn?: Maybe<Array<VetsourceInstallationConnectivityState>>;
};

export type NestedEnumVetsourceInstallationConnectivityStateWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumVetsourceInstallationConnectivityStateFilter>;
  _min?: Maybe<NestedEnumVetsourceInstallationConnectivityStateFilter>;
  equals?: Maybe<VetsourceInstallationConnectivityState>;
  in?: Maybe<Array<VetsourceInstallationConnectivityState>>;
  not?: Maybe<NestedEnumVetsourceInstallationConnectivityStateWithAggregatesFilter>;
  notIn?: Maybe<Array<VetsourceInstallationConnectivityState>>;
};

export type NestedEnumWidgetRequestTypeFilter = {
  equals?: Maybe<WidgetRequestType>;
  in?: Maybe<Array<WidgetRequestType>>;
  not?: Maybe<NestedEnumWidgetRequestTypeFilter>;
  notIn?: Maybe<Array<WidgetRequestType>>;
};

export type NestedEnumWidgetRequestTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWidgetRequestTypeFilter>;
  _min?: Maybe<NestedEnumWidgetRequestTypeFilter>;
  equals?: Maybe<WidgetRequestType>;
  in?: Maybe<Array<WidgetRequestType>>;
  not?: Maybe<NestedEnumWidgetRequestTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<WidgetRequestType>>;
};

export type NestedEnumWidgetVisibilityFilter = {
  equals?: Maybe<WidgetVisibility>;
  in?: Maybe<Array<WidgetVisibility>>;
  not?: Maybe<NestedEnumWidgetVisibilityFilter>;
  notIn?: Maybe<Array<WidgetVisibility>>;
};

export type NestedEnumWidgetVisibilityWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWidgetVisibilityFilter>;
  _min?: Maybe<NestedEnumWidgetVisibilityFilter>;
  equals?: Maybe<WidgetVisibility>;
  in?: Maybe<Array<WidgetVisibility>>;
  not?: Maybe<NestedEnumWidgetVisibilityWithAggregatesFilter>;
  notIn?: Maybe<Array<WidgetVisibility>>;
};

export type NestedEnumWorkflowActionTypeFilter = {
  equals?: Maybe<WorkflowActionType>;
  in?: Maybe<Array<WorkflowActionType>>;
  not?: Maybe<NestedEnumWorkflowActionTypeFilter>;
  notIn?: Maybe<Array<WorkflowActionType>>;
};

export type NestedEnumWorkflowActionTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWorkflowActionTypeFilter>;
  _min?: Maybe<NestedEnumWorkflowActionTypeFilter>;
  equals?: Maybe<WorkflowActionType>;
  in?: Maybe<Array<WorkflowActionType>>;
  not?: Maybe<NestedEnumWorkflowActionTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowActionType>>;
};

export type NestedEnumWorkflowEventFilter = {
  equals?: Maybe<WorkflowEvent>;
  in?: Maybe<Array<WorkflowEvent>>;
  not?: Maybe<NestedEnumWorkflowEventFilter>;
  notIn?: Maybe<Array<WorkflowEvent>>;
};

export type NestedEnumWorkflowEventTriggerTypeFilter = {
  equals?: Maybe<WorkflowEventTriggerType>;
  in?: Maybe<Array<WorkflowEventTriggerType>>;
  not?: Maybe<NestedEnumWorkflowEventTriggerTypeFilter>;
  notIn?: Maybe<Array<WorkflowEventTriggerType>>;
};

export type NestedEnumWorkflowEventTriggerTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWorkflowEventTriggerTypeFilter>;
  _min?: Maybe<NestedEnumWorkflowEventTriggerTypeFilter>;
  equals?: Maybe<WorkflowEventTriggerType>;
  in?: Maybe<Array<WorkflowEventTriggerType>>;
  not?: Maybe<NestedEnumWorkflowEventTriggerTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowEventTriggerType>>;
};

export type NestedEnumWorkflowEventWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWorkflowEventFilter>;
  _min?: Maybe<NestedEnumWorkflowEventFilter>;
  equals?: Maybe<WorkflowEvent>;
  in?: Maybe<Array<WorkflowEvent>>;
  not?: Maybe<NestedEnumWorkflowEventWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowEvent>>;
};

export type NestedEnumWorkflowSendingHoursFilter = {
  equals?: Maybe<WorkflowSendingHours>;
  in?: Maybe<Array<WorkflowSendingHours>>;
  not?: Maybe<NestedEnumWorkflowSendingHoursFilter>;
  notIn?: Maybe<Array<WorkflowSendingHours>>;
};

export type NestedEnumWorkflowSendingHoursWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWorkflowSendingHoursFilter>;
  _min?: Maybe<NestedEnumWorkflowSendingHoursFilter>;
  equals?: Maybe<WorkflowSendingHours>;
  in?: Maybe<Array<WorkflowSendingHours>>;
  not?: Maybe<NestedEnumWorkflowSendingHoursWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowSendingHours>>;
};

export type NestedEnumWorkflowTypeFilter = {
  equals?: Maybe<WorkflowType>;
  in?: Maybe<Array<WorkflowType>>;
  not?: Maybe<NestedEnumWorkflowTypeFilter>;
  notIn?: Maybe<Array<WorkflowType>>;
};

export type NestedEnumWorkflowTypeNullableFilter = {
  equals?: Maybe<WorkflowType>;
  in?: Maybe<Array<WorkflowType>>;
  not?: Maybe<NestedEnumWorkflowTypeNullableFilter>;
  notIn?: Maybe<Array<WorkflowType>>;
};

export type NestedEnumWorkflowTypeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumWorkflowTypeNullableFilter>;
  _min?: Maybe<NestedEnumWorkflowTypeNullableFilter>;
  equals?: Maybe<WorkflowType>;
  in?: Maybe<Array<WorkflowType>>;
  not?: Maybe<NestedEnumWorkflowTypeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowType>>;
};

export type NestedEnumWorkflowTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWorkflowTypeFilter>;
  _min?: Maybe<NestedEnumWorkflowTypeFilter>;
  equals?: Maybe<WorkflowType>;
  in?: Maybe<Array<WorkflowType>>;
  not?: Maybe<NestedEnumWorkflowTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowType>>;
};

export type NestedEnumWorkflowVisitTypeFilter = {
  equals?: Maybe<WorkflowVisitType>;
  in?: Maybe<Array<WorkflowVisitType>>;
  not?: Maybe<NestedEnumWorkflowVisitTypeFilter>;
  notIn?: Maybe<Array<WorkflowVisitType>>;
};

export type NestedEnumWorkflowVisitTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumWorkflowVisitTypeFilter>;
  _min?: Maybe<NestedEnumWorkflowVisitTypeFilter>;
  equals?: Maybe<WorkflowVisitType>;
  in?: Maybe<Array<WorkflowVisitType>>;
  not?: Maybe<NestedEnumWorkflowVisitTypeWithAggregatesFilter>;
  notIn?: Maybe<Array<WorkflowVisitType>>;
};

export type NestedFloatFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatNullableFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatNullableFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedFloatNullableFilter>;
  _min?: Maybe<NestedFloatNullableFilter>;
  _sum?: Maybe<NestedFloatNullableFilter>;
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedFloatWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedFloatFilter>;
  _min?: Maybe<NestedFloatFilter>;
  _sum?: Maybe<NestedFloatFilter>;
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatNullableFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedIntNullableFilter>;
  _sum?: Maybe<NestedIntNullableFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedIntFilter>;
  _sum?: Maybe<NestedIntFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedJsonFilter = {
  array_contains?: Maybe<Scalars['Json']>;
  array_ends_with?: Maybe<Scalars['Json']>;
  array_starts_with?: Maybe<Scalars['Json']>;
  equals?: Maybe<Scalars['Json']>;
  gt?: Maybe<Scalars['Json']>;
  gte?: Maybe<Scalars['Json']>;
  lt?: Maybe<Scalars['Json']>;
  lte?: Maybe<Scalars['Json']>;
  not?: Maybe<Scalars['Json']>;
  path?: Maybe<Array<Scalars['String']>>;
  string_contains?: Maybe<Scalars['String']>;
  string_ends_with?: Maybe<Scalars['String']>;
  string_starts_with?: Maybe<Scalars['String']>;
};

export type NestedJsonNullableFilter = {
  array_contains?: Maybe<Scalars['Json']>;
  array_ends_with?: Maybe<Scalars['Json']>;
  array_starts_with?: Maybe<Scalars['Json']>;
  equals?: Maybe<Scalars['Json']>;
  gt?: Maybe<Scalars['Json']>;
  gte?: Maybe<Scalars['Json']>;
  lt?: Maybe<Scalars['Json']>;
  lte?: Maybe<Scalars['Json']>;
  not?: Maybe<Scalars['Json']>;
  path?: Maybe<Array<Scalars['String']>>;
  string_contains?: Maybe<Scalars['String']>;
  string_ends_with?: Maybe<Scalars['String']>;
  string_starts_with?: Maybe<Scalars['String']>;
};

export type NestedStringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringNullableFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedStringNullableFilter>;
  _min?: Maybe<NestedStringNullableFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedStringFilter>;
  _min?: Maybe<NestedStringFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NonPrismaSchemaScriptRan = {
  __typename?: 'NonPrismaSchemaScriptRan';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  scriptName: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type NonPrismaSchemaScriptRanCountAggregateOutputType = {
  __typename?: 'NonPrismaSchemaScriptRanCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  scriptName: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type NonPrismaSchemaScriptRanCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scriptName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NonPrismaSchemaScriptRanCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scriptName: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NonPrismaSchemaScriptRanCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scriptName: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NonPrismaSchemaScriptRanGroupByOutputType = {
  __typename?: 'NonPrismaSchemaScriptRanGroupByOutputType';
  _count?: Maybe<NonPrismaSchemaScriptRanCountAggregateOutputType>;
  _max?: Maybe<NonPrismaSchemaScriptRanMaxAggregateOutputType>;
  _min?: Maybe<NonPrismaSchemaScriptRanMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  scriptName: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type NonPrismaSchemaScriptRanMaxAggregateOutputType = {
  __typename?: 'NonPrismaSchemaScriptRanMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scriptName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NonPrismaSchemaScriptRanMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scriptName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NonPrismaSchemaScriptRanMinAggregateOutputType = {
  __typename?: 'NonPrismaSchemaScriptRanMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scriptName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NonPrismaSchemaScriptRanMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scriptName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NonPrismaSchemaScriptRanOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<NonPrismaSchemaScriptRanOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scriptName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum NonPrismaSchemaScriptRanOrderByRelevanceFieldEnum {
  Id = 'id',
  ScriptName = 'scriptName',
  Status = 'status'
}

export type NonPrismaSchemaScriptRanOrderByRelevanceInput = {
  fields: Array<NonPrismaSchemaScriptRanOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type NonPrismaSchemaScriptRanOrderByWithAggregationInput = {
  _count?: Maybe<NonPrismaSchemaScriptRanCountOrderByAggregateInput>;
  _max?: Maybe<NonPrismaSchemaScriptRanMaxOrderByAggregateInput>;
  _min?: Maybe<NonPrismaSchemaScriptRanMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scriptName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NonPrismaSchemaScriptRanOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<NonPrismaSchemaScriptRanOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scriptName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NonPrismaSchemaScriptRanOrderByWithRelationInput = {
  _relevance?: Maybe<NonPrismaSchemaScriptRanOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  scriptName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum NonPrismaSchemaScriptRanScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ScriptName = 'scriptName',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type NonPrismaSchemaScriptRanScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<NonPrismaSchemaScriptRanScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<NonPrismaSchemaScriptRanScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<NonPrismaSchemaScriptRanScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  scriptName?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type NonPrismaSchemaScriptRanUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scriptName: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NonPrismaSchemaScriptRanUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scriptName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NonPrismaSchemaScriptRanUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scriptName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NonPrismaSchemaScriptRanUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scriptName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NonPrismaSchemaScriptRanUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scriptName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NonPrismaSchemaScriptRanWhereInput = {
  AND?: Maybe<Array<NonPrismaSchemaScriptRanWhereInput>>;
  NOT?: Maybe<Array<NonPrismaSchemaScriptRanWhereInput>>;
  OR?: Maybe<Array<NonPrismaSchemaScriptRanWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  scriptName?: Maybe<StringFilter>;
  status?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type NonPrismaSchemaScriptRanWhereUniqueInput = {
  AND?: Maybe<Array<NonPrismaSchemaScriptRanWhereInput>>;
  NOT?: Maybe<Array<NonPrismaSchemaScriptRanWhereInput>>;
  OR?: Maybe<Array<NonPrismaSchemaScriptRanWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  scriptName?: Maybe<Scalars['String']>;
  status?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum NormalizedWritebackError {
  BitwerxDown = 'Bitwerx_Down',
  BitwerxGenericError = 'Bitwerx_GenericError',
  BitwerxHeartbeatTooOld = 'Bitwerx_HeartbeatTooOld',
  BitwerxInvalidConfiguration = 'Bitwerx_InvalidConfiguration',
  BitwerxInvalidQuery = 'Bitwerx_InvalidQuery',
  BitwerxInvoiceClosed = 'Bitwerx_InvoiceClosed',
  BitwerxPimsConnectivityIssue = 'Bitwerx_PimsConnectivityIssue',
  BitwerxTimedOut = 'Bitwerx_TimedOut',
  BitwerxUnknown = 'Bitwerx_Unknown'
}

export enum NotificationEvent {
  AppointmentArrivalConfirmation = 'AppointmentArrivalConfirmation',
  AppointmentCancelation = 'AppointmentCancelation',
  AppointmentConfirmation = 'AppointmentConfirmation',
  AppointmentConfirmed = 'AppointmentConfirmed',
  AppointmentFollowup = 'AppointmentFollowup',
  AppointmentPimsSync = 'AppointmentPimsSync',
  AppointmentReminder = 'AppointmentReminder',
  AppointmentRescheduleRequested = 'AppointmentRescheduleRequested',
  AppointmentScheduled = 'AppointmentScheduled',
  CallDeflectionFormSubmitted = 'CallDeflectionFormSubmitted',
  ServiceReminderFormSubmitted = 'ServiceReminderFormSubmitted',
  WidgetRequestFormSubmitted = 'WidgetRequestFormSubmitted'
}

export type NotificationEventToMessage = {
  __typename?: 'NotificationEventToMessage';
  createdAt: Scalars['DateTime'];
  emailBody: Scalars['String'];
  emailCallToAction: Scalars['String'];
  emailSalutation: Scalars['String'];
  emailSubject: Scalars['String'];
  emailTitle: Scalars['String'];
  event: NotificationEvent;
  id: Scalars['String'];
  smsMessage: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type NotificationEventToMessageCountAggregateOutputType = {
  __typename?: 'NotificationEventToMessageCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  emailBody: Scalars['Int'];
  emailCallToAction: Scalars['Int'];
  emailSalutation: Scalars['Int'];
  emailSubject: Scalars['Int'];
  emailTitle: Scalars['Int'];
  event: Scalars['Int'];
  id: Scalars['Int'];
  smsMessage: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type NotificationEventToMessageCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  emailBody?: Maybe<SortOrder>;
  emailCallToAction?: Maybe<SortOrder>;
  emailSalutation?: Maybe<SortOrder>;
  emailSubject?: Maybe<SortOrder>;
  emailTitle?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  smsMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NotificationEventToMessageCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailBody: Scalars['String'];
  emailCallToAction: Scalars['String'];
  emailSalutation: Scalars['String'];
  emailSubject: Scalars['String'];
  emailTitle: Scalars['String'];
  event: NotificationEvent;
  id?: Maybe<Scalars['String']>;
  smsMessage: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationEventToMessageCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailBody: Scalars['String'];
  emailCallToAction: Scalars['String'];
  emailSalutation: Scalars['String'];
  emailSubject: Scalars['String'];
  emailTitle: Scalars['String'];
  event: NotificationEvent;
  id?: Maybe<Scalars['String']>;
  smsMessage: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationEventToMessageGroupByOutputType = {
  __typename?: 'NotificationEventToMessageGroupByOutputType';
  _count?: Maybe<NotificationEventToMessageCountAggregateOutputType>;
  _max?: Maybe<NotificationEventToMessageMaxAggregateOutputType>;
  _min?: Maybe<NotificationEventToMessageMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  emailBody: Scalars['String'];
  emailCallToAction: Scalars['String'];
  emailSalutation: Scalars['String'];
  emailSubject: Scalars['String'];
  emailTitle: Scalars['String'];
  event: NotificationEvent;
  id: Scalars['String'];
  smsMessage: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type NotificationEventToMessageMaxAggregateOutputType = {
  __typename?: 'NotificationEventToMessageMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  emailBody?: Maybe<Scalars['String']>;
  emailCallToAction?: Maybe<Scalars['String']>;
  emailSalutation?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  emailTitle?: Maybe<Scalars['String']>;
  event?: Maybe<NotificationEvent>;
  id?: Maybe<Scalars['String']>;
  smsMessage?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationEventToMessageMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  emailBody?: Maybe<SortOrder>;
  emailCallToAction?: Maybe<SortOrder>;
  emailSalutation?: Maybe<SortOrder>;
  emailSubject?: Maybe<SortOrder>;
  emailTitle?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  smsMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NotificationEventToMessageMinAggregateOutputType = {
  __typename?: 'NotificationEventToMessageMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  emailBody?: Maybe<Scalars['String']>;
  emailCallToAction?: Maybe<Scalars['String']>;
  emailSalutation?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  emailTitle?: Maybe<Scalars['String']>;
  event?: Maybe<NotificationEvent>;
  id?: Maybe<Scalars['String']>;
  smsMessage?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationEventToMessageMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  emailBody?: Maybe<SortOrder>;
  emailCallToAction?: Maybe<SortOrder>;
  emailSalutation?: Maybe<SortOrder>;
  emailSubject?: Maybe<SortOrder>;
  emailTitle?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  smsMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NotificationEventToMessageOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<NotificationEventToMessageOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  emailBody?: Maybe<SortOrder>;
  emailCallToAction?: Maybe<SortOrder>;
  emailSalutation?: Maybe<SortOrder>;
  emailSubject?: Maybe<SortOrder>;
  emailTitle?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  smsMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum NotificationEventToMessageOrderByRelevanceFieldEnum {
  EmailBody = 'emailBody',
  EmailCallToAction = 'emailCallToAction',
  EmailSalutation = 'emailSalutation',
  EmailSubject = 'emailSubject',
  EmailTitle = 'emailTitle',
  Id = 'id',
  SmsMessage = 'smsMessage'
}

export type NotificationEventToMessageOrderByRelevanceInput = {
  fields: Array<NotificationEventToMessageOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type NotificationEventToMessageOrderByWithAggregationInput = {
  _count?: Maybe<NotificationEventToMessageCountOrderByAggregateInput>;
  _max?: Maybe<NotificationEventToMessageMaxOrderByAggregateInput>;
  _min?: Maybe<NotificationEventToMessageMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  emailBody?: Maybe<SortOrder>;
  emailCallToAction?: Maybe<SortOrder>;
  emailSalutation?: Maybe<SortOrder>;
  emailSubject?: Maybe<SortOrder>;
  emailTitle?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  smsMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NotificationEventToMessageOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<NotificationEventToMessageOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  emailBody?: Maybe<SortOrder>;
  emailCallToAction?: Maybe<SortOrder>;
  emailSalutation?: Maybe<SortOrder>;
  emailSubject?: Maybe<SortOrder>;
  emailTitle?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  smsMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type NotificationEventToMessageOrderByWithRelationInput = {
  _relevance?: Maybe<NotificationEventToMessageOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  emailBody?: Maybe<SortOrder>;
  emailCallToAction?: Maybe<SortOrder>;
  emailSalutation?: Maybe<SortOrder>;
  emailSubject?: Maybe<SortOrder>;
  emailTitle?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  smsMessage?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum NotificationEventToMessageScalarFieldEnum {
  CreatedAt = 'createdAt',
  EmailBody = 'emailBody',
  EmailCallToAction = 'emailCallToAction',
  EmailSalutation = 'emailSalutation',
  EmailSubject = 'emailSubject',
  EmailTitle = 'emailTitle',
  Event = 'event',
  Id = 'id',
  SmsMessage = 'smsMessage',
  UpdatedAt = 'updatedAt'
}

export type NotificationEventToMessageScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<NotificationEventToMessageScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<NotificationEventToMessageScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<NotificationEventToMessageScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  emailBody?: Maybe<StringWithAggregatesFilter>;
  emailCallToAction?: Maybe<StringWithAggregatesFilter>;
  emailSalutation?: Maybe<StringWithAggregatesFilter>;
  emailSubject?: Maybe<StringWithAggregatesFilter>;
  emailTitle?: Maybe<StringWithAggregatesFilter>;
  event?: Maybe<EnumNotificationEventWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  smsMessage?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type NotificationEventToMessageUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailBody: Scalars['String'];
  emailCallToAction: Scalars['String'];
  emailSalutation: Scalars['String'];
  emailSubject: Scalars['String'];
  emailTitle: Scalars['String'];
  event: NotificationEvent;
  id?: Maybe<Scalars['String']>;
  smsMessage: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationEventToMessageUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailBody?: Maybe<Scalars['String']>;
  emailCallToAction?: Maybe<Scalars['String']>;
  emailSalutation?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  emailTitle?: Maybe<Scalars['String']>;
  event?: Maybe<NotificationEvent>;
  id?: Maybe<Scalars['String']>;
  smsMessage?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationEventToMessageUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailBody?: Maybe<Scalars['String']>;
  emailCallToAction?: Maybe<Scalars['String']>;
  emailSalutation?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  emailTitle?: Maybe<Scalars['String']>;
  event?: Maybe<NotificationEvent>;
  id?: Maybe<Scalars['String']>;
  smsMessage?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationEventToMessageUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailBody?: Maybe<Scalars['String']>;
  emailCallToAction?: Maybe<Scalars['String']>;
  emailSalutation?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  emailTitle?: Maybe<Scalars['String']>;
  event?: Maybe<NotificationEvent>;
  id?: Maybe<Scalars['String']>;
  smsMessage?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationEventToMessageUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailBody?: Maybe<Scalars['String']>;
  emailCallToAction?: Maybe<Scalars['String']>;
  emailSalutation?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  emailTitle?: Maybe<Scalars['String']>;
  event?: Maybe<NotificationEvent>;
  id?: Maybe<Scalars['String']>;
  smsMessage?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationEventToMessageWhereInput = {
  AND?: Maybe<Array<NotificationEventToMessageWhereInput>>;
  NOT?: Maybe<Array<NotificationEventToMessageWhereInput>>;
  OR?: Maybe<Array<NotificationEventToMessageWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  emailBody?: Maybe<StringFilter>;
  emailCallToAction?: Maybe<StringFilter>;
  emailSalutation?: Maybe<StringFilter>;
  emailSubject?: Maybe<StringFilter>;
  emailTitle?: Maybe<StringFilter>;
  event?: Maybe<EnumNotificationEventFilter>;
  id?: Maybe<StringFilter>;
  smsMessage?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type NotificationEventToMessageWhereUniqueInput = {
  AND?: Maybe<Array<NotificationEventToMessageWhereInput>>;
  NOT?: Maybe<Array<NotificationEventToMessageWhereInput>>;
  OR?: Maybe<Array<NotificationEventToMessageWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  emailBody?: Maybe<StringFilter>;
  emailCallToAction?: Maybe<StringFilter>;
  emailSalutation?: Maybe<StringFilter>;
  emailSubject?: Maybe<StringFilter>;
  emailTitle?: Maybe<StringFilter>;
  event?: Maybe<NotificationEvent>;
  id?: Maybe<Scalars['String']>;
  smsMessage?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum NotificationSettingType {
  AppointmentConfirmed = 'Appointment_Confirmed',
  AppointmentRescheduleRequested = 'Appointment_RescheduleRequested',
  ConnectWidgetRequestSubmitted = 'ConnectWidget_RequestSubmitted',
  ConversationAssigned = 'Conversation_Assigned',
  ConversationNewMessage = 'Conversation_NewMessage',
  ConversationStatusChange = 'Conversation_StatusChange',
  FormSubmitted = 'Form_Submitted',
  PaymentDispute = 'Payment_Dispute',
  PaymentReceived = 'Payment_Received'
}

export type NullableBoolFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['Boolean']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['DateTime']>;
};

export type NullableEnumAmericanKennelClubBreedGroupFieldUpdateOperationsInput = {
  set?: Maybe<AmericanKennelClubBreedGroup>;
};

export type NullableEnumAmericanKennelClubDemeanorCategoryFieldUpdateOperationsInput = {
  set?: Maybe<AmericanKennelClubDemeanorCategory>;
};

export type NullableEnumAmericanKennelClubEnergyLevelCategoryFieldUpdateOperationsInput = {
  set?: Maybe<AmericanKennelClubEnergyLevelCategory>;
};

export type NullableEnumAmericanKennelClubGroomingFrequencyCategoryFieldUpdateOperationsInput = {
  set?: Maybe<AmericanKennelClubGroomingFrequencyCategory>;
};

export type NullableEnumAmericanKennelClubSheddingCategoryFieldUpdateOperationsInput = {
  set?: Maybe<AmericanKennelClubSheddingCategory>;
};

export type NullableEnumAmericanKennelClubTrainabilityCategoryFieldUpdateOperationsInput = {
  set?: Maybe<AmericanKennelClubTrainabilityCategory>;
};

export type NullableEnumAutomatedTriggerTypeFieldUpdateOperationsInput = {
  set?: Maybe<AutomatedTriggerType>;
};

export type NullableEnumBitwerxHealthcheckRunStatusFieldUpdateOperationsInput = {
  set?: Maybe<BitwerxHealthcheckRunStatus>;
};

export type NullableEnumBoardFilterDateRangeFieldUpdateOperationsInput = {
  set?: Maybe<BoardFilterDateRange>;
};

export type NullableEnumCallParticipantResultFieldUpdateOperationsInput = {
  set?: Maybe<CallParticipantResult>;
};

export type NullableEnumCampaignRegistryBrandIdentityStatusFieldUpdateOperationsInput = {
  set?: Maybe<CampaignRegistryBrandIdentityStatus>;
};

export type NullableEnumCampaignRegistryCampaignSharingStatusFieldUpdateOperationsInput = {
  set?: Maybe<CampaignRegistryCampaignSharingStatus>;
};

export type NullableEnumCancelReasonTypeFieldUpdateOperationsInput = {
  set?: Maybe<CancelReasonType>;
};

export type NullableEnumCardBrandFieldUpdateOperationsInput = {
  set?: Maybe<CardBrand>;
};

export type NullableEnumCardFundingFieldUpdateOperationsInput = {
  set?: Maybe<CardFunding>;
};

export type NullableEnumCareBenefitUnitOfMeasureFieldUpdateOperationsInput = {
  set?: Maybe<CareBenefitUnitOfMeasure>;
};

export type NullableEnumCareCreditPreapprovalDecisionFieldUpdateOperationsInput = {
  set?: Maybe<CareCreditPreapprovalDecision>;
};

export type NullableEnumCareSubscriptionPaymentStatusFieldUpdateOperationsInput = {
  set?: Maybe<CareSubscriptionPaymentStatus>;
};

export type NullableEnumChannelMessageAttachmentEntityTypeFieldUpdateOperationsInput = {
  set?: Maybe<ChannelMessageAttachmentEntityType>;
};

export type NullableEnumChannelMessageAttachmentUploadStatusFieldUpdateOperationsInput = {
  set?: Maybe<ChannelMessageAttachmentUploadStatus>;
};

export type NullableEnumChannelTypeFieldUpdateOperationsInput = {
  set?: Maybe<ChannelType>;
};

export type NullableEnumChannelVisibilityFieldUpdateOperationsInput = {
  set?: Maybe<ChannelVisibility>;
};

export type NullableEnumClinicEntityCreationSourceFieldUpdateOperationsInput = {
  set?: Maybe<ClinicEntityCreationSource>;
};

export type NullableEnumClinicEntityPhoneNumberSmsStatusFieldUpdateOperationsInput = {
  set?: Maybe<ClinicEntityPhoneNumberSmsStatus>;
};

export type NullableEnumClinicPetParentAddressTypeFieldUpdateOperationsInput = {
  set?: Maybe<ClinicPetParentAddressType>;
};

export type NullableEnumContactVerificationMethodFieldUpdateOperationsInput = {
  set?: Maybe<ContactVerificationMethod>;
};

export type NullableEnumCustomFieldsDataSourceFieldUpdateOperationsInput = {
  set?: Maybe<CustomFieldsDataSource>;
};

export type NullableEnumDeviceOsFieldUpdateOperationsInput = {
  set?: Maybe<DeviceOs>;
};

export type NullableEnumDeviceTypeFieldUpdateOperationsInput = {
  set?: Maybe<DeviceType>;
};

export type NullableEnumEmailCampaignLogSkipReasonFieldUpdateOperationsInput = {
  set?: Maybe<EmailCampaignLogSkipReason>;
};

export type NullableEnumHillsToHomeSpeciesFieldUpdateOperationsInput = {
  set?: Maybe<HillsToHomeSpecies>;
};

export type NullableEnumInformEntityUpdatedByTypeFieldUpdateOperationsInput = {
  set?: Maybe<InformEntityUpdatedByType>;
};

export type NullableEnumInformScheduledCampaignCadenceFieldUpdateOperationsInput = {
  set?: Maybe<InformScheduledCampaignCadence>;
};

export type NullableEnumIntegrationStatusFieldUpdateOperationsInput = {
  set?: Maybe<IntegrationStatus>;
};

export type NullableEnumIntegrationTypeFieldUpdateOperationsInput = {
  set?: Maybe<IntegrationType>;
};

export type NullableEnumNormalizedWritebackErrorFieldUpdateOperationsInput = {
  set?: Maybe<NormalizedWritebackError>;
};

export type NullableEnumPaymentMediumFieldUpdateOperationsInput = {
  set?: Maybe<PaymentMedium>;
};

export type NullableEnumPaymentRelationshipFieldUpdateOperationsInput = {
  set?: Maybe<PaymentRelationship>;
};

export type NullableEnumPaymentScheduleFieldUpdateOperationsInput = {
  set?: Maybe<PaymentSchedule>;
};

export type NullableEnumPimsSyncStatusFieldUpdateOperationsInput = {
  set?: Maybe<PimsSyncStatus>;
};

export type NullableEnumPimsWritebackStatusFieldUpdateOperationsInput = {
  set?: Maybe<PimsWritebackStatus>;
};

export type NullableEnumProductSupplyDurationUnitFieldUpdateOperationsInput = {
  set?: Maybe<ProductSupplyDurationUnit>;
};

export type NullableEnumPushNotificationDeliveryErrorTypeFieldUpdateOperationsInput = {
  set?: Maybe<PushNotificationDeliveryErrorType>;
};

export type NullableEnumRenewalRejectionReasonFieldUpdateOperationsInput = {
  set?: Maybe<RenewalRejectionReason>;
};

export type NullableEnumSmsEntityTypeFieldUpdateOperationsInput = {
  set?: Maybe<SmsEntityType>;
};

export type NullableEnumSmsNotificationDeliveryErrorTypeFieldUpdateOperationsInput = {
  set?: Maybe<SmsNotificationDeliveryErrorType>;
};

export type NullableEnumSpeciesTypeFieldUpdateOperationsInput = {
  set?: Maybe<SpeciesType>;
};

export type NullableEnumStripeDisputeReasonFieldUpdateOperationsInput = {
  set?: Maybe<StripeDisputeReason>;
};

export type NullableEnumStripePaymentErrorFieldUpdateOperationsInput = {
  set?: Maybe<StripePaymentError>;
};

export type NullableEnumSurveyStepFieldUpdateOperationsInput = {
  set?: Maybe<SurveyStep>;
};

export type NullableEnumSurveyTypeFieldUpdateOperationsInput = {
  set?: Maybe<SurveyType>;
};

export type NullableEnumSyncVetIntegrationSystemFieldUpdateOperationsInput = {
  set?: Maybe<SyncVetIntegrationSystem>;
};

export type NullableEnumSynchronyEventStatusFieldUpdateOperationsInput = {
  set?: Maybe<SynchronyEventStatus>;
};

export type NullableEnumTaskTypeFieldUpdateOperationsInput = {
  set?: Maybe<TaskType>;
};

export type NullableEnumTimeUnitFieldUpdateOperationsInput = {
  set?: Maybe<TimeUnit>;
};

export type NullableEnumTranscriptionServicesFieldUpdateOperationsInput = {
  set?: Maybe<TranscriptionServices>;
};

export type NullableEnumWorkflowTypeFieldUpdateOperationsInput = {
  set?: Maybe<WorkflowType>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Float']>;
  divide?: Maybe<Scalars['Float']>;
  increment?: Maybe<Scalars['Float']>;
  multiply?: Maybe<Scalars['Float']>;
  set?: Maybe<Scalars['Float']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Int']>;
  divide?: Maybe<Scalars['Int']>;
  increment?: Maybe<Scalars['Int']>;
  multiply?: Maybe<Scalars['Int']>;
  set?: Maybe<Scalars['Int']>;
};

export enum NullableJsonNullValueInput {
  DbNull = 'DbNull',
  JsonNull = 'JsonNull'
}

export type NullableStringFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['String']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type NumberOfPetParentsReached = {
  __typename?: 'NumberOfPetParentsReached';
  numberOfPetPerents?: Maybe<Scalars['Int']>;
  timeEstimateInSeconds?: Maybe<Scalars['Int']>;
};

export type OperationResult = {
  __typename?: 'OperationResult';
  messages: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type OrderPhoneNumberInput = {
  phoneNumber: Scalars['String'];
};

export type OrderPhoneNumberResponse = {
  __typename?: 'OrderPhoneNumberResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Organization = {
  __typename?: 'Organization';
  EmailCampaignTemplate: Array<EmailCampaignTemplate>;
  _count: OrganizationCountOutputType;
  associatedEncryptedClinicUploads: Array<EncryptedClinicUpload>;
  careAddonPackage: Array<CareAddonPackage>;
  careBenefits: Array<CareBenefit>;
  carePlanProviderGroups: Array<CarePlanProviderGroup>;
  carePlans: Array<CarePlan>;
  clinics: Array<Clinic>;
  configuration: Scalars['Json'];
  createdAt: Scalars['DateTime'];
  crmId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  organizationPetParents: Array<OrganizationPetParent>;
  organizationPets: Array<OrganizationPet>;
  paymentProcessorClinic?: Maybe<Clinic>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type OrganizationEmailCampaignTemplateArgs = {
  cursor?: Maybe<EmailCampaignTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignTemplateWhereInput>;
};


export type OrganizationAssociatedEncryptedClinicUploadsArgs = {
  cursor?: Maybe<EncryptedClinicUploadWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EncryptedClinicUploadScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EncryptedClinicUploadOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};


export type OrganizationCareAddonPackageArgs = {
  cursor?: Maybe<CareAddonPackageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonPackageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonPackageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonPackageWhereInput>;
};


export type OrganizationCareBenefitsArgs = {
  cursor?: Maybe<CareBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitWhereInput>;
};


export type OrganizationCarePlanProviderGroupsArgs = {
  cursor?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanProviderGroupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanProviderGroupOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type OrganizationCarePlansArgs = {
  cursor?: Maybe<CarePlanWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanWhereInput>;
};


export type OrganizationClinicsArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type OrganizationOrganizationPetParentsArgs = {
  cursor?: Maybe<OrganizationPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetParentWhereInput>;
};


export type OrganizationOrganizationPetsArgs = {
  cursor?: Maybe<OrganizationPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetWhereInput>;
};


export type OrganizationPaymentProcessorClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};

export type OrganizationCareBenefitToClinicService = {
  __typename?: 'OrganizationCareBenefitToClinicService';
  benefit: CareBenefit;
  benefitId: Scalars['String'];
  service: Service;
  serviceId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceBenefitIdServiceIdCompoundUniqueInput = {
  benefitId: Scalars['String'];
  serviceId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceCategory = {
  __typename?: 'OrganizationCareBenefitToClinicServiceCategory';
  benefit: CareBenefit;
  benefitId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  serviceCategory: ServiceCategory;
  serviceCategoryId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceCategoryBenefitIdServiceCategoryIdCompoundUniqueInput = {
  benefitId: Scalars['String'];
  serviceCategoryId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceCategoryCountAggregateOutputType = {
  __typename?: 'OrganizationCareBenefitToClinicServiceCategoryCountAggregateOutputType';
  _all: Scalars['Int'];
  benefitId: Scalars['Int'];
  createdAt: Scalars['Int'];
  serviceCategoryId: Scalars['Int'];
};

export type OrganizationCareBenefitToClinicServiceCategoryCountOrderByAggregateInput = {
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  serviceCategoryId?: Maybe<SortOrder>;
};

export type OrganizationCareBenefitToClinicServiceCategoryCreateInput = {
  benefit: CareBenefitCreateNestedOneWithoutConnectedServiceCategoriesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategory: ServiceCategoryCreateNestedOneWithoutConnectedCareBenefitsInput;
};

export type OrganizationCareBenefitToClinicServiceCategoryCreateManyBenefitInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceCategoryCreateManyBenefitInputEnvelope = {
  data: Array<OrganizationCareBenefitToClinicServiceCategoryCreateManyBenefitInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryCreateManyInput = {
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceCategoryCreateManyServiceCategoryInput = {
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryCreateManyServiceCategoryInputEnvelope = {
  data: Array<OrganizationCareBenefitToClinicServiceCategoryCreateManyServiceCategoryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutBenefitInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateWithoutBenefitInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateManyBenefitInputEnvelope>;
};

export type OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutServiceCategoryInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateOrConnectWithoutServiceCategoryInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateWithoutServiceCategoryInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateManyServiceCategoryInputEnvelope>;
};

export type OrganizationCareBenefitToClinicServiceCategoryCreateOrConnectWithoutBenefitInput = {
  create: OrganizationCareBenefitToClinicServiceCategoryCreateWithoutBenefitInput;
  where: OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput;
};

export type OrganizationCareBenefitToClinicServiceCategoryCreateOrConnectWithoutServiceCategoryInput = {
  create: OrganizationCareBenefitToClinicServiceCategoryCreateWithoutServiceCategoryInput;
  where: OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput;
};

export type OrganizationCareBenefitToClinicServiceCategoryCreateWithoutBenefitInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategory: ServiceCategoryCreateNestedOneWithoutConnectedCareBenefitsInput;
};

export type OrganizationCareBenefitToClinicServiceCategoryCreateWithoutServiceCategoryInput = {
  benefit: CareBenefitCreateNestedOneWithoutConnectedServiceCategoriesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryGroupByOutputType = {
  __typename?: 'OrganizationCareBenefitToClinicServiceCategoryGroupByOutputType';
  _count?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCountAggregateOutputType>;
  _max?: Maybe<OrganizationCareBenefitToClinicServiceCategoryMaxAggregateOutputType>;
  _min?: Maybe<OrganizationCareBenefitToClinicServiceCategoryMinAggregateOutputType>;
  benefitId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  serviceCategoryId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceCategoryListRelationFilter = {
  every?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereInput>;
  none?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereInput>;
  some?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereInput>;
};

export type OrganizationCareBenefitToClinicServiceCategoryMaxAggregateOutputType = {
  __typename?: 'OrganizationCareBenefitToClinicServiceCategoryMaxAggregateOutputType';
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryMaxOrderByAggregateInput = {
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  serviceCategoryId?: Maybe<SortOrder>;
};

export type OrganizationCareBenefitToClinicServiceCategoryMinAggregateOutputType = {
  __typename?: 'OrganizationCareBenefitToClinicServiceCategoryMinAggregateOutputType';
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryMinOrderByAggregateInput = {
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  serviceCategoryId?: Maybe<SortOrder>;
};

export type OrganizationCareBenefitToClinicServiceCategoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type OrganizationCareBenefitToClinicServiceCategoryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByRelevanceInput>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  serviceCategory?: Maybe<ServiceCategoryOrderByWithRelationInput>;
  serviceCategoryId?: Maybe<SortOrder>;
};

export enum OrganizationCareBenefitToClinicServiceCategoryOrderByRelevanceFieldEnum {
  BenefitId = 'benefitId',
  ServiceCategoryId = 'serviceCategoryId'
}

export type OrganizationCareBenefitToClinicServiceCategoryOrderByRelevanceInput = {
  fields: Array<OrganizationCareBenefitToClinicServiceCategoryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type OrganizationCareBenefitToClinicServiceCategoryOrderByWithAggregationInput = {
  _count?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCountOrderByAggregateInput>;
  _max?: Maybe<OrganizationCareBenefitToClinicServiceCategoryMaxOrderByAggregateInput>;
  _min?: Maybe<OrganizationCareBenefitToClinicServiceCategoryMinOrderByAggregateInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  serviceCategoryId?: Maybe<SortOrder>;
};

export type OrganizationCareBenefitToClinicServiceCategoryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByRelevanceInput>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  serviceCategory?: Maybe<ServiceCategoryOrderByWithRelationInput>;
  serviceCategoryId?: Maybe<SortOrder>;
};

export type OrganizationCareBenefitToClinicServiceCategoryOrderByWithRelationInput = {
  _relevance?: Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByRelevanceInput>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  serviceCategory?: Maybe<ServiceCategoryOrderByWithRelationInput>;
  serviceCategoryId?: Maybe<SortOrder>;
};

export enum OrganizationCareBenefitToClinicServiceCategoryScalarFieldEnum {
  BenefitId = 'benefitId',
  CreatedAt = 'createdAt',
  ServiceCategoryId = 'serviceCategoryId'
}

export type OrganizationCareBenefitToClinicServiceCategoryScalarWhereInput = {
  AND?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryScalarWhereInput>>;
  NOT?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryScalarWhereInput>>;
  OR?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryScalarWhereInput>>;
  benefitId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  serviceCategoryId?: Maybe<StringFilter>;
};

export type OrganizationCareBenefitToClinicServiceCategoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryScalarWhereWithAggregatesInput>>;
  benefitId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  serviceCategoryId?: Maybe<StringWithAggregatesFilter>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateInput = {
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutBenefitInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateWithoutBenefitInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateManyBenefitInputEnvelope>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateOrConnectWithoutServiceCategoryInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateWithoutServiceCategoryInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateManyServiceCategoryInputEnvelope>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateWithoutBenefitInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateWithoutServiceCategoryInput = {
  benefitId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateInput = {
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyInput = {
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutBenefitInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutBenefitNestedInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateWithoutBenefitInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateManyBenefitInputEnvelope>;
  delete?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryUpdateWithWhereUniqueWithoutBenefitInput>>;
  updateMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithWhereWithoutBenefitInput>>;
  upsert?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryUpsertWithWhereUniqueWithoutBenefitInput>>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutServiceCategoryInput = {
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateOrConnectWithoutServiceCategoryInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateWithoutServiceCategoryInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateManyServiceCategoryInputEnvelope>;
  delete?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryUpdateWithWhereUniqueWithoutServiceCategoryInput>>;
  updateMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithWhereWithoutServiceCategoryInput>>;
  upsert?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryUpsertWithWhereUniqueWithoutServiceCategoryInput>>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateWithoutBenefitInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateWithoutServiceCategoryInput = {
  benefitId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUpdateInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutConnectedServiceCategoriesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneRequiredWithoutConnectedCareBenefitsNestedInput>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithWhereWithoutBenefitInput = {
  data: OrganizationCareBenefitToClinicServiceCategoryUpdateManyMutationInput;
  where: OrganizationCareBenefitToClinicServiceCategoryScalarWhereInput;
};

export type OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithWhereWithoutServiceCategoryInput = {
  data: OrganizationCareBenefitToClinicServiceCategoryUpdateManyMutationInput;
  where: OrganizationCareBenefitToClinicServiceCategoryScalarWhereInput;
};

export type OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutBenefitNestedInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateWithoutBenefitInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateManyBenefitInputEnvelope>;
  delete?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryUpdateWithWhereUniqueWithoutBenefitInput>>;
  updateMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithWhereWithoutBenefitInput>>;
  upsert?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryUpsertWithWhereUniqueWithoutBenefitInput>>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutServiceCategoryNestedInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateOrConnectWithoutServiceCategoryInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryCreateWithoutServiceCategoryInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateManyServiceCategoryInputEnvelope>;
  delete?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryUpdateWithWhereUniqueWithoutServiceCategoryInput>>;
  updateMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithWhereWithoutServiceCategoryInput>>;
  upsert?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryUpsertWithWhereUniqueWithoutServiceCategoryInput>>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUpdateWithWhereUniqueWithoutBenefitInput = {
  data: OrganizationCareBenefitToClinicServiceCategoryUpdateWithoutBenefitInput;
  where: OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput;
};

export type OrganizationCareBenefitToClinicServiceCategoryUpdateWithWhereUniqueWithoutServiceCategoryInput = {
  data: OrganizationCareBenefitToClinicServiceCategoryUpdateWithoutServiceCategoryInput;
  where: OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput;
};

export type OrganizationCareBenefitToClinicServiceCategoryUpdateWithoutBenefitInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneRequiredWithoutConnectedCareBenefitsNestedInput>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUpdateWithoutServiceCategoryInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutConnectedServiceCategoriesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCareBenefitToClinicServiceCategoryUpsertWithWhereUniqueWithoutBenefitInput = {
  create: OrganizationCareBenefitToClinicServiceCategoryCreateWithoutBenefitInput;
  update: OrganizationCareBenefitToClinicServiceCategoryUpdateWithoutBenefitInput;
  where: OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput;
};

export type OrganizationCareBenefitToClinicServiceCategoryUpsertWithWhereUniqueWithoutServiceCategoryInput = {
  create: OrganizationCareBenefitToClinicServiceCategoryCreateWithoutServiceCategoryInput;
  update: OrganizationCareBenefitToClinicServiceCategoryUpdateWithoutServiceCategoryInput;
  where: OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput;
};

export type OrganizationCareBenefitToClinicServiceCategoryWhereInput = {
  AND?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereInput>>;
  NOT?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereInput>>;
  OR?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereInput>>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  serviceCategory?: Maybe<ServiceCategoryScalarRelationFilter>;
  serviceCategoryId?: Maybe<StringFilter>;
};

export type OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput = {
  AND?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereInput>>;
  NOT?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereInput>>;
  OR?: Maybe<Array<OrganizationCareBenefitToClinicServiceCategoryWhereInput>>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  benefitId_serviceCategoryId?: Maybe<OrganizationCareBenefitToClinicServiceCategoryBenefitIdServiceCategoryIdCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  serviceCategory?: Maybe<ServiceCategoryScalarRelationFilter>;
  serviceCategoryId?: Maybe<StringFilter>;
};

export type OrganizationCareBenefitToClinicServiceCountAggregateOutputType = {
  __typename?: 'OrganizationCareBenefitToClinicServiceCountAggregateOutputType';
  _all: Scalars['Int'];
  benefitId: Scalars['Int'];
  serviceId: Scalars['Int'];
};

export type OrganizationCareBenefitToClinicServiceCountOrderByAggregateInput = {
  benefitId?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
};

export type OrganizationCareBenefitToClinicServiceCreateInput = {
  benefit: CareBenefitCreateNestedOneWithoutOrganizationCareBenefitToClinicServiceInput;
  service: ServiceCreateNestedOneWithoutOrganizationCareBenefitToClinicServiceInput;
};

export type OrganizationCareBenefitToClinicServiceCreateManyBenefitInput = {
  serviceId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceCreateManyBenefitInputEnvelope = {
  data: Array<OrganizationCareBenefitToClinicServiceCreateManyBenefitInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type OrganizationCareBenefitToClinicServiceCreateManyInput = {
  benefitId: Scalars['String'];
  serviceId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceCreateManyServiceInput = {
  benefitId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceCreateManyServiceInputEnvelope = {
  data: Array<OrganizationCareBenefitToClinicServiceCreateManyServiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutBenefitInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateWithoutBenefitInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCreateManyBenefitInputEnvelope>;
};

export type OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateWithoutServiceInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCreateManyServiceInputEnvelope>;
};

export type OrganizationCareBenefitToClinicServiceCreateOrConnectWithoutBenefitInput = {
  create: OrganizationCareBenefitToClinicServiceCreateWithoutBenefitInput;
  where: OrganizationCareBenefitToClinicServiceWhereUniqueInput;
};

export type OrganizationCareBenefitToClinicServiceCreateOrConnectWithoutServiceInput = {
  create: OrganizationCareBenefitToClinicServiceCreateWithoutServiceInput;
  where: OrganizationCareBenefitToClinicServiceWhereUniqueInput;
};

export type OrganizationCareBenefitToClinicServiceCreateWithoutBenefitInput = {
  service: ServiceCreateNestedOneWithoutOrganizationCareBenefitToClinicServiceInput;
};

export type OrganizationCareBenefitToClinicServiceCreateWithoutServiceInput = {
  benefit: CareBenefitCreateNestedOneWithoutOrganizationCareBenefitToClinicServiceInput;
};

export type OrganizationCareBenefitToClinicServiceGroupByOutputType = {
  __typename?: 'OrganizationCareBenefitToClinicServiceGroupByOutputType';
  _count?: Maybe<OrganizationCareBenefitToClinicServiceCountAggregateOutputType>;
  _max?: Maybe<OrganizationCareBenefitToClinicServiceMaxAggregateOutputType>;
  _min?: Maybe<OrganizationCareBenefitToClinicServiceMinAggregateOutputType>;
  benefitId: Scalars['String'];
  serviceId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceListRelationFilter = {
  every?: Maybe<OrganizationCareBenefitToClinicServiceWhereInput>;
  none?: Maybe<OrganizationCareBenefitToClinicServiceWhereInput>;
  some?: Maybe<OrganizationCareBenefitToClinicServiceWhereInput>;
};

export type OrganizationCareBenefitToClinicServiceMaxAggregateOutputType = {
  __typename?: 'OrganizationCareBenefitToClinicServiceMaxAggregateOutputType';
  benefitId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceMaxOrderByAggregateInput = {
  benefitId?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
};

export type OrganizationCareBenefitToClinicServiceMinAggregateOutputType = {
  __typename?: 'OrganizationCareBenefitToClinicServiceMinAggregateOutputType';
  benefitId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceMinOrderByAggregateInput = {
  benefitId?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
};

export type OrganizationCareBenefitToClinicServiceOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type OrganizationCareBenefitToClinicServiceOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<OrganizationCareBenefitToClinicServiceOrderByRelevanceInput>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
};

export enum OrganizationCareBenefitToClinicServiceOrderByRelevanceFieldEnum {
  BenefitId = 'benefitId',
  ServiceId = 'serviceId'
}

export type OrganizationCareBenefitToClinicServiceOrderByRelevanceInput = {
  fields: Array<OrganizationCareBenefitToClinicServiceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type OrganizationCareBenefitToClinicServiceOrderByWithAggregationInput = {
  _count?: Maybe<OrganizationCareBenefitToClinicServiceCountOrderByAggregateInput>;
  _max?: Maybe<OrganizationCareBenefitToClinicServiceMaxOrderByAggregateInput>;
  _min?: Maybe<OrganizationCareBenefitToClinicServiceMinOrderByAggregateInput>;
  benefitId?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
};

export type OrganizationCareBenefitToClinicServiceOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<OrganizationCareBenefitToClinicServiceOrderByRelevanceInput>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
};

export type OrganizationCareBenefitToClinicServiceOrderByWithRelationInput = {
  _relevance?: Maybe<OrganizationCareBenefitToClinicServiceOrderByRelevanceInput>;
  benefit?: Maybe<CareBenefitOrderByWithRelationInput>;
  benefitId?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
};

export enum OrganizationCareBenefitToClinicServiceScalarFieldEnum {
  BenefitId = 'benefitId',
  ServiceId = 'serviceId'
}

export type OrganizationCareBenefitToClinicServiceScalarWhereInput = {
  AND?: Maybe<Array<OrganizationCareBenefitToClinicServiceScalarWhereInput>>;
  NOT?: Maybe<Array<OrganizationCareBenefitToClinicServiceScalarWhereInput>>;
  OR?: Maybe<Array<OrganizationCareBenefitToClinicServiceScalarWhereInput>>;
  benefitId?: Maybe<StringFilter>;
  serviceId?: Maybe<StringFilter>;
};

export type OrganizationCareBenefitToClinicServiceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<OrganizationCareBenefitToClinicServiceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<OrganizationCareBenefitToClinicServiceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<OrganizationCareBenefitToClinicServiceScalarWhereWithAggregatesInput>>;
  benefitId?: Maybe<StringWithAggregatesFilter>;
  serviceId?: Maybe<StringWithAggregatesFilter>;
};

export type OrganizationCareBenefitToClinicServiceUncheckedCreateInput = {
  benefitId: Scalars['String'];
  serviceId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutBenefitInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateWithoutBenefitInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCreateManyBenefitInputEnvelope>;
};

export type OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateWithoutServiceInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCreateManyServiceInputEnvelope>;
};

export type OrganizationCareBenefitToClinicServiceUncheckedCreateWithoutBenefitInput = {
  serviceId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceUncheckedCreateWithoutServiceInput = {
  benefitId: Scalars['String'];
};

export type OrganizationCareBenefitToClinicServiceUncheckedUpdateInput = {
  benefitId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceUncheckedUpdateManyInput = {
  benefitId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutBenefitInput = {
  serviceId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutBenefitNestedInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateWithoutBenefitInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCreateManyBenefitInputEnvelope>;
  delete?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationCareBenefitToClinicServiceUpdateWithWhereUniqueWithoutBenefitInput>>;
  updateMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceUpdateManyWithWhereWithoutBenefitInput>>;
  upsert?: Maybe<Array<OrganizationCareBenefitToClinicServiceUpsertWithWhereUniqueWithoutBenefitInput>>;
};

export type OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceInput = {
  benefitId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateWithoutServiceInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationCareBenefitToClinicServiceUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<OrganizationCareBenefitToClinicServiceUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type OrganizationCareBenefitToClinicServiceUncheckedUpdateWithoutBenefitInput = {
  serviceId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceUncheckedUpdateWithoutServiceInput = {
  benefitId?: Maybe<Scalars['String']>;
};

export type OrganizationCareBenefitToClinicServiceUpdateInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutOrganizationCareBenefitToClinicServiceNestedInput>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutOrganizationCareBenefitToClinicServiceNestedInput>;
};

export type OrganizationCareBenefitToClinicServiceUpdateManyMutationInput = {
  benefitId?: Maybe<StringNullableFilter>;
  serviceId?: Maybe<StringNullableFilter>;
};

export type OrganizationCareBenefitToClinicServiceUpdateManyWithWhereWithoutBenefitInput = {
  data: OrganizationCareBenefitToClinicServiceUpdateManyMutationInput;
  where: OrganizationCareBenefitToClinicServiceScalarWhereInput;
};

export type OrganizationCareBenefitToClinicServiceUpdateManyWithWhereWithoutServiceInput = {
  data: OrganizationCareBenefitToClinicServiceUpdateManyMutationInput;
  where: OrganizationCareBenefitToClinicServiceScalarWhereInput;
};

export type OrganizationCareBenefitToClinicServiceUpdateManyWithoutBenefitNestedInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateOrConnectWithoutBenefitInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateWithoutBenefitInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCreateManyBenefitInputEnvelope>;
  delete?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationCareBenefitToClinicServiceUpdateWithWhereUniqueWithoutBenefitInput>>;
  updateMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceUpdateManyWithWhereWithoutBenefitInput>>;
  upsert?: Maybe<Array<OrganizationCareBenefitToClinicServiceUpsertWithWhereUniqueWithoutBenefitInput>>;
};

export type OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<OrganizationCareBenefitToClinicServiceCreateWithoutServiceInput>>;
  createMany?: Maybe<OrganizationCareBenefitToClinicServiceCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationCareBenefitToClinicServiceUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<OrganizationCareBenefitToClinicServiceUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<OrganizationCareBenefitToClinicServiceUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type OrganizationCareBenefitToClinicServiceUpdateWithWhereUniqueWithoutBenefitInput = {
  data: OrganizationCareBenefitToClinicServiceUpdateWithoutBenefitInput;
  where: OrganizationCareBenefitToClinicServiceWhereUniqueInput;
};

export type OrganizationCareBenefitToClinicServiceUpdateWithWhereUniqueWithoutServiceInput = {
  data: OrganizationCareBenefitToClinicServiceUpdateWithoutServiceInput;
  where: OrganizationCareBenefitToClinicServiceWhereUniqueInput;
};

export type OrganizationCareBenefitToClinicServiceUpdateWithoutBenefitInput = {
  service?: Maybe<ServiceUpdateOneRequiredWithoutOrganizationCareBenefitToClinicServiceNestedInput>;
};

export type OrganizationCareBenefitToClinicServiceUpdateWithoutServiceInput = {
  benefit?: Maybe<CareBenefitUpdateOneRequiredWithoutOrganizationCareBenefitToClinicServiceNestedInput>;
};

export type OrganizationCareBenefitToClinicServiceUpsertWithWhereUniqueWithoutBenefitInput = {
  create: OrganizationCareBenefitToClinicServiceCreateWithoutBenefitInput;
  update: OrganizationCareBenefitToClinicServiceUpdateWithoutBenefitInput;
  where: OrganizationCareBenefitToClinicServiceWhereUniqueInput;
};

export type OrganizationCareBenefitToClinicServiceUpsertWithWhereUniqueWithoutServiceInput = {
  create: OrganizationCareBenefitToClinicServiceCreateWithoutServiceInput;
  update: OrganizationCareBenefitToClinicServiceUpdateWithoutServiceInput;
  where: OrganizationCareBenefitToClinicServiceWhereUniqueInput;
};

export type OrganizationCareBenefitToClinicServiceWhereInput = {
  AND?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereInput>>;
  NOT?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereInput>>;
  OR?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereInput>>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
};

export type OrganizationCareBenefitToClinicServiceWhereUniqueInput = {
  AND?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereInput>>;
  NOT?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereInput>>;
  OR?: Maybe<Array<OrganizationCareBenefitToClinicServiceWhereInput>>;
  benefit?: Maybe<CareBenefitScalarRelationFilter>;
  benefitId?: Maybe<StringFilter>;
  benefitId_serviceId?: Maybe<OrganizationCareBenefitToClinicServiceBenefitIdServiceIdCompoundUniqueInput>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
};

export type OrganizationCountAggregateOutputType = {
  __typename?: 'OrganizationCountAggregateOutputType';
  _all: Scalars['Int'];
  configuration: Scalars['Int'];
  createdAt: Scalars['Int'];
  crmId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  paymentProcessorClinicId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type OrganizationCountOrderByAggregateInput = {
  configuration?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationCountOutputType = {
  __typename?: 'OrganizationCountOutputType';
  EmailCampaignTemplate: Scalars['Int'];
  associatedEncryptedClinicUploads: Scalars['Int'];
  careAddonPackage: Scalars['Int'];
  careBenefits: Scalars['Int'];
  carePlanProviderGroups: Scalars['Int'];
  carePlans: Scalars['Int'];
  clinics: Scalars['Int'];
  organizationPetParents: Scalars['Int'];
  organizationPets: Scalars['Int'];
};

export type OrganizationCreateInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutCarePayoutOrganizationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCreateManyInput = {
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCreateNestedOneWithoutAssociatedEncryptedClinicUploadsInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutAssociatedEncryptedClinicUploadsInput>;
  create?: Maybe<OrganizationCreateWithoutAssociatedEncryptedClinicUploadsInput>;
};

export type OrganizationCreateNestedOneWithoutCareAddonPackageInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutCareAddonPackageInput>;
  create?: Maybe<OrganizationCreateWithoutCareAddonPackageInput>;
};

export type OrganizationCreateNestedOneWithoutCareBenefitsInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutCareBenefitsInput>;
  create?: Maybe<OrganizationCreateWithoutCareBenefitsInput>;
};

export type OrganizationCreateNestedOneWithoutCarePlanProviderGroupsInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutCarePlanProviderGroupsInput>;
  create?: Maybe<OrganizationCreateWithoutCarePlanProviderGroupsInput>;
};

export type OrganizationCreateNestedOneWithoutCarePlansInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutCarePlansInput>;
  create?: Maybe<OrganizationCreateWithoutCarePlansInput>;
};

export type OrganizationCreateNestedOneWithoutClinicsInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutClinicsInput>;
  create?: Maybe<OrganizationCreateWithoutClinicsInput>;
};

export type OrganizationCreateNestedOneWithoutEmailCampaignTemplateInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutEmailCampaignTemplateInput>;
  create?: Maybe<OrganizationCreateWithoutEmailCampaignTemplateInput>;
};

export type OrganizationCreateNestedOneWithoutOrganizationPetParentsInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutOrganizationPetParentsInput>;
  create?: Maybe<OrganizationCreateWithoutOrganizationPetParentsInput>;
};

export type OrganizationCreateNestedOneWithoutOrganizationPetsInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutOrganizationPetsInput>;
  create?: Maybe<OrganizationCreateWithoutOrganizationPetsInput>;
};

export type OrganizationCreateNestedOneWithoutPaymentProcessorClinicInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutPaymentProcessorClinicInput>;
  create?: Maybe<OrganizationCreateWithoutPaymentProcessorClinicInput>;
};

export type OrganizationCreateOrConnectWithoutAssociatedEncryptedClinicUploadsInput = {
  create: OrganizationCreateWithoutAssociatedEncryptedClinicUploadsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCareAddonPackageInput = {
  create: OrganizationCreateWithoutCareAddonPackageInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCareBenefitsInput = {
  create: OrganizationCreateWithoutCareBenefitsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCarePlanProviderGroupsInput = {
  create: OrganizationCreateWithoutCarePlanProviderGroupsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCarePlansInput = {
  create: OrganizationCreateWithoutCarePlansInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutClinicsInput = {
  create: OrganizationCreateWithoutClinicsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutEmailCampaignTemplateInput = {
  create: OrganizationCreateWithoutEmailCampaignTemplateInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutOrganizationPetParentsInput = {
  create: OrganizationCreateWithoutOrganizationPetParentsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutOrganizationPetsInput = {
  create: OrganizationCreateWithoutOrganizationPetsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutPaymentProcessorClinicInput = {
  create: OrganizationCreateWithoutPaymentProcessorClinicInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateWithoutAssociatedEncryptedClinicUploadsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutCarePayoutOrganizationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCreateWithoutCareAddonPackageInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutCarePayoutOrganizationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCreateWithoutCareBenefitsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutCarePayoutOrganizationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCreateWithoutCarePlanProviderGroupsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutCarePayoutOrganizationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCreateWithoutCarePlansInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutCarePayoutOrganizationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCreateWithoutClinicsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutCarePayoutOrganizationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCreateWithoutEmailCampaignTemplateInput = {
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutCarePayoutOrganizationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCreateWithoutOrganizationPetParentsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPets?: Maybe<OrganizationPetCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutCarePayoutOrganizationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCreateWithoutOrganizationPetsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinic?: Maybe<ClinicCreateNestedOneWithoutCarePayoutOrganizationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCreateWithoutPaymentProcessorClinicInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationGroupByOutputType = {
  __typename?: 'OrganizationGroupByOutputType';
  _count?: Maybe<OrganizationCountAggregateOutputType>;
  _max?: Maybe<OrganizationMaxAggregateOutputType>;
  _min?: Maybe<OrganizationMinAggregateOutputType>;
  configuration: Scalars['Json'];
  createdAt: Scalars['DateTime'];
  crmId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type OrganizationMaxAggregateOutputType = {
  __typename?: 'OrganizationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationMinAggregateOutputType = {
  __typename?: 'OrganizationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationNullableScalarRelationFilter = {
  AND?: Maybe<Array<OrganizationWhereInput>>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateListRelationFilter>;
  NOT?: Maybe<Array<OrganizationWhereInput>>;
  OR?: Maybe<Array<OrganizationWhereInput>>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadListRelationFilter>;
  careAddonPackage?: Maybe<CareAddonPackageListRelationFilter>;
  careBenefits?: Maybe<CareBenefitListRelationFilter>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupListRelationFilter>;
  carePlans?: Maybe<CarePlanListRelationFilter>;
  clinics?: Maybe<ClinicListRelationFilter>;
  configuration?: Maybe<JsonFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  crmId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  organizationPetParents?: Maybe<OrganizationPetParentListRelationFilter>;
  organizationPets?: Maybe<OrganizationPetListRelationFilter>;
  paymentProcessorClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  paymentProcessorClinicId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type OrganizationOrderByRelationAndSearchRelevanceInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateOrderByRelationAggregateInput>;
  _relevance?: Maybe<OrganizationOrderByRelevanceInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadOrderByRelationAggregateInput>;
  careAddonPackage?: Maybe<CareAddonPackageOrderByRelationAggregateInput>;
  careBenefits?: Maybe<CareBenefitOrderByRelationAggregateInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupOrderByRelationAggregateInput>;
  carePlans?: Maybe<CarePlanOrderByRelationAggregateInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  configuration?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationPetParents?: Maybe<OrganizationPetParentOrderByRelationAggregateInput>;
  organizationPets?: Maybe<OrganizationPetOrderByRelationAggregateInput>;
  paymentProcessorClinic?: Maybe<ClinicOrderByWithRelationInput>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum OrganizationOrderByRelevanceFieldEnum {
  CrmId = 'crmId',
  Id = 'id',
  Name = 'name',
  PaymentProcessorClinicId = 'paymentProcessorClinicId'
}

export type OrganizationOrderByRelevanceInput = {
  fields: Array<OrganizationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type OrganizationOrderByWithAggregationInput = {
  _count?: Maybe<OrganizationCountOrderByAggregateInput>;
  _max?: Maybe<OrganizationMaxOrderByAggregateInput>;
  _min?: Maybe<OrganizationMinOrderByAggregateInput>;
  configuration?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationOrderByWithRelationAndSearchRelevanceInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateOrderByRelationAggregateInput>;
  _relevance?: Maybe<OrganizationOrderByRelevanceInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadOrderByRelationAggregateInput>;
  careAddonPackage?: Maybe<CareAddonPackageOrderByRelationAggregateInput>;
  careBenefits?: Maybe<CareBenefitOrderByRelationAggregateInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupOrderByRelationAggregateInput>;
  carePlans?: Maybe<CarePlanOrderByRelationAggregateInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  configuration?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationPetParents?: Maybe<OrganizationPetParentOrderByRelationAggregateInput>;
  organizationPets?: Maybe<OrganizationPetOrderByRelationAggregateInput>;
  paymentProcessorClinic?: Maybe<ClinicOrderByWithRelationInput>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationOrderByWithRelationInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateOrderByRelationAggregateInput>;
  _relevance?: Maybe<OrganizationOrderByRelevanceInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadOrderByRelationAggregateInput>;
  careAddonPackage?: Maybe<CareAddonPackageOrderByRelationAggregateInput>;
  careBenefits?: Maybe<CareBenefitOrderByRelationAggregateInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupOrderByRelationAggregateInput>;
  carePlans?: Maybe<CarePlanOrderByRelationAggregateInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  configuration?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  organizationPetParents?: Maybe<OrganizationPetParentOrderByRelationAggregateInput>;
  organizationPets?: Maybe<OrganizationPetOrderByRelationAggregateInput>;
  paymentProcessorClinic?: Maybe<ClinicOrderByWithRelationInput>;
  paymentProcessorClinicId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationPet = {
  __typename?: 'OrganizationPet';
  TransferFromPetEnrollmentSupportEvent: Array<EnrollmentSupportEvent>;
  TransferToPetEnrollmentSupportEvent: Array<EnrollmentSupportEvent>;
  _count: OrganizationPetCountOutputType;
  associatedBenefitUsageFollowup: Array<CareBenefitUsageFollowup>;
  associatedSubscriptions: Array<CareStripeSubscription>;
  careAddonEnrollments: Array<CareAddonEnrollment>;
  carePlanEnrollments: Array<CarePlanEnrollment>;
  clinicPets: Array<ClinicPet>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  organization: Organization;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents: Array<OrganizationPetToOrganizationPetParent>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type OrganizationPetTransferFromPetEnrollmentSupportEventArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type OrganizationPetTransferToPetEnrollmentSupportEventArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type OrganizationPetAssociatedBenefitUsageFollowupArgs = {
  cursor?: Maybe<CareBenefitUsageFollowupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageFollowupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageFollowupOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageFollowupWhereInput>;
};


export type OrganizationPetAssociatedSubscriptionsArgs = {
  cursor?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareStripeSubscriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareStripeSubscriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type OrganizationPetCareAddonEnrollmentsArgs = {
  cursor?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};


export type OrganizationPetCarePlanEnrollmentsArgs = {
  cursor?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type OrganizationPetClinicPetsArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type OrganizationPetOrganizationPetToOrganizationPetParentsArgs = {
  cursor?: Maybe<OrganizationPetToOrganizationPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetToOrganizationPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetToOrganizationPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetToOrganizationPetParentWhereInput>;
};

export type OrganizationPetCountAggregateOutputType = {
  __typename?: 'OrganizationPetCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  organizationId: Scalars['Int'];
  preferredName: Scalars['Int'];
  profilePictureUrl: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type OrganizationPetCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  preferredName?: Maybe<SortOrder>;
  profilePictureUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationPetCountOutputType = {
  __typename?: 'OrganizationPetCountOutputType';
  TransferFromPetEnrollmentSupportEvent: Scalars['Int'];
  TransferToPetEnrollmentSupportEvent: Scalars['Int'];
  associatedBenefitUsageFollowup: Scalars['Int'];
  associatedSubscriptions: Scalars['Int'];
  careAddonEnrollments: Scalars['Int'];
  carePlanEnrollments: Scalars['Int'];
  clinicPets: Scalars['Int'];
  organizationPetToOrganizationPetParents: Scalars['Int'];
};

export type OrganizationPetCreateInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetCreateManyOrganizationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetCreateManyOrganizationInputEnvelope = {
  data: Array<OrganizationPetCreateManyOrganizationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type OrganizationPetCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<OrganizationPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<OrganizationPetCreateWithoutOrganizationInput>>;
  createMany?: Maybe<OrganizationPetCreateManyOrganizationInputEnvelope>;
};

export type OrganizationPetCreateNestedOneWithoutAssociatedBenefitUsageFollowupInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutAssociatedBenefitUsageFollowupInput>;
  create?: Maybe<OrganizationPetCreateWithoutAssociatedBenefitUsageFollowupInput>;
};

export type OrganizationPetCreateNestedOneWithoutAssociatedSubscriptionsInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutAssociatedSubscriptionsInput>;
  create?: Maybe<OrganizationPetCreateWithoutAssociatedSubscriptionsInput>;
};

export type OrganizationPetCreateNestedOneWithoutCareAddonEnrollmentsInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutCareAddonEnrollmentsInput>;
  create?: Maybe<OrganizationPetCreateWithoutCareAddonEnrollmentsInput>;
};

export type OrganizationPetCreateNestedOneWithoutCarePlanEnrollmentsInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutCarePlanEnrollmentsInput>;
  create?: Maybe<OrganizationPetCreateWithoutCarePlanEnrollmentsInput>;
};

export type OrganizationPetCreateNestedOneWithoutClinicPetsInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutClinicPetsInput>;
  create?: Maybe<OrganizationPetCreateWithoutClinicPetsInput>;
};

export type OrganizationPetCreateNestedOneWithoutOrganizationPetToOrganizationPetParentsInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutOrganizationPetToOrganizationPetParentsInput>;
  create?: Maybe<OrganizationPetCreateWithoutOrganizationPetToOrganizationPetParentsInput>;
};

export type OrganizationPetCreateNestedOneWithoutTransferFromPetEnrollmentSupportEventInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutTransferFromPetEnrollmentSupportEventInput>;
  create?: Maybe<OrganizationPetCreateWithoutTransferFromPetEnrollmentSupportEventInput>;
};

export type OrganizationPetCreateNestedOneWithoutTransferToPetEnrollmentSupportEventInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutTransferToPetEnrollmentSupportEventInput>;
  create?: Maybe<OrganizationPetCreateWithoutTransferToPetEnrollmentSupportEventInput>;
};

export type OrganizationPetCreateOrConnectWithoutAssociatedBenefitUsageFollowupInput = {
  create: OrganizationPetCreateWithoutAssociatedBenefitUsageFollowupInput;
  where: OrganizationPetWhereUniqueInput;
};

export type OrganizationPetCreateOrConnectWithoutAssociatedSubscriptionsInput = {
  create: OrganizationPetCreateWithoutAssociatedSubscriptionsInput;
  where: OrganizationPetWhereUniqueInput;
};

export type OrganizationPetCreateOrConnectWithoutCareAddonEnrollmentsInput = {
  create: OrganizationPetCreateWithoutCareAddonEnrollmentsInput;
  where: OrganizationPetWhereUniqueInput;
};

export type OrganizationPetCreateOrConnectWithoutCarePlanEnrollmentsInput = {
  create: OrganizationPetCreateWithoutCarePlanEnrollmentsInput;
  where: OrganizationPetWhereUniqueInput;
};

export type OrganizationPetCreateOrConnectWithoutClinicPetsInput = {
  create: OrganizationPetCreateWithoutClinicPetsInput;
  where: OrganizationPetWhereUniqueInput;
};

export type OrganizationPetCreateOrConnectWithoutOrganizationInput = {
  create: OrganizationPetCreateWithoutOrganizationInput;
  where: OrganizationPetWhereUniqueInput;
};

export type OrganizationPetCreateOrConnectWithoutOrganizationPetToOrganizationPetParentsInput = {
  create: OrganizationPetCreateWithoutOrganizationPetToOrganizationPetParentsInput;
  where: OrganizationPetWhereUniqueInput;
};

export type OrganizationPetCreateOrConnectWithoutTransferFromPetEnrollmentSupportEventInput = {
  create: OrganizationPetCreateWithoutTransferFromPetEnrollmentSupportEventInput;
  where: OrganizationPetWhereUniqueInput;
};

export type OrganizationPetCreateOrConnectWithoutTransferToPetEnrollmentSupportEventInput = {
  create: OrganizationPetCreateWithoutTransferToPetEnrollmentSupportEventInput;
  where: OrganizationPetWhereUniqueInput;
};

export type OrganizationPetCreateWithoutAssociatedBenefitUsageFollowupInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferToPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetCreateWithoutAssociatedSubscriptionsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutRelatedOrganizationPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetCreateWithoutCareAddonEnrollmentsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetCreateWithoutCarePlanEnrollmentsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetCreateWithoutClinicPetsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetCreateWithoutOrganizationInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetCreateWithoutOrganizationPetToOrganizationPetParentsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetsInput;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetCreateWithoutTransferFromPetEnrollmentSupportEventInput = {
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetCreateWithoutTransferToPetEnrollmentSupportEventInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutTransferFromPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetEnrollmentInput = {
  careAddonIds: Array<Scalars['String']>;
  carePlanIds: Array<Scalars['String']>;
  organizationPetId: Scalars['String'];
};

export type OrganizationPetGroupByOutputType = {
  __typename?: 'OrganizationPetGroupByOutputType';
  _count?: Maybe<OrganizationPetCountAggregateOutputType>;
  _max?: Maybe<OrganizationPetMaxAggregateOutputType>;
  _min?: Maybe<OrganizationPetMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  organizationId: Scalars['String'];
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type OrganizationPetListRelationFilter = {
  every?: Maybe<OrganizationPetWhereInput>;
  none?: Maybe<OrganizationPetWhereInput>;
  some?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetMaxAggregateOutputType = {
  __typename?: 'OrganizationPetMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  preferredName?: Maybe<SortOrder>;
  profilePictureUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationPetMinAggregateOutputType = {
  __typename?: 'OrganizationPetMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  preferredName?: Maybe<SortOrder>;
  profilePictureUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationPetNullableScalarRelationFilter = {
  AND?: Maybe<Array<OrganizationPetWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetWhereInput>>;
  OR?: Maybe<Array<OrganizationPetWhereInput>>;
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventListRelationFilter>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventListRelationFilter>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupListRelationFilter>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentListRelationFilter>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentListRelationFilter>;
  preferredName?: Maybe<StringFilter>;
  profilePictureUrl?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type OrganizationPetOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type OrganizationPetOrderByRelationAndSearchRelevanceInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  _relevance?: Maybe<OrganizationPetOrderByRelevanceInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupOrderByRelationAggregateInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionOrderByRelationAggregateInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentOrderByRelationAggregateInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  clinicPets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentOrderByRelationAggregateInput>;
  preferredName?: Maybe<SortOrder>;
  profilePictureUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum OrganizationPetOrderByRelevanceFieldEnum {
  Id = 'id',
  OrganizationId = 'organizationId',
  PreferredName = 'preferredName',
  ProfilePictureUrl = 'profilePictureUrl'
}

export type OrganizationPetOrderByRelevanceInput = {
  fields: Array<OrganizationPetOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type OrganizationPetOrderByWithAggregationInput = {
  _count?: Maybe<OrganizationPetCountOrderByAggregateInput>;
  _max?: Maybe<OrganizationPetMaxOrderByAggregateInput>;
  _min?: Maybe<OrganizationPetMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  preferredName?: Maybe<SortOrder>;
  profilePictureUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationPetOrderByWithRelationAndSearchRelevanceInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  _relevance?: Maybe<OrganizationPetOrderByRelevanceInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupOrderByRelationAggregateInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionOrderByRelationAggregateInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentOrderByRelationAggregateInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  clinicPets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentOrderByRelationAggregateInput>;
  preferredName?: Maybe<SortOrder>;
  profilePictureUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationPetOrderByWithRelationInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  _relevance?: Maybe<OrganizationPetOrderByRelevanceInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupOrderByRelationAggregateInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionOrderByRelationAggregateInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentOrderByRelationAggregateInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentOrderByRelationAggregateInput>;
  clinicPets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentOrderByRelationAggregateInput>;
  preferredName?: Maybe<SortOrder>;
  profilePictureUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationPetParent = {
  __typename?: 'OrganizationPetParent';
  _count: OrganizationPetParentCountOutputType;
  /** @deprecated - as parents might have multiple pet subscriptions */
  activeCareStripeSubscription?: Maybe<CareStripeSubscription>;
  /** @deprecated - as parents might have multiple pet subscriptions */
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  allCareStripeSubscriptions: Array<CareStripeSubscription>;
  clinicPetParents: Array<ClinicPetParent>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  organization: Organization;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents: Array<OrganizationPetToOrganizationPetParent>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomer?: Maybe<StripeCustomer>;
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type OrganizationPetParentActiveCareStripeSubscriptionArgs = {
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type OrganizationPetParentAllCareStripeSubscriptionsArgs = {
  cursor?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareStripeSubscriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareStripeSubscriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type OrganizationPetParentClinicPetParentsArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type OrganizationPetParentOrganizationPetToOrganizationPetParentsArgs = {
  cursor?: Maybe<OrganizationPetToOrganizationPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetToOrganizationPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetToOrganizationPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetToOrganizationPetParentWhereInput>;
};


export type OrganizationPetParentStripeCustomerArgs = {
  where?: Maybe<StripeCustomerWhereInput>;
};

export type OrganizationPetParentCountAggregateOutputType = {
  __typename?: 'OrganizationPetParentCountAggregateOutputType';
  _all: Scalars['Int'];
  activeCareStripeSubscriptionId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  organizationId: Scalars['Int'];
  preferredFirstName: Scalars['Int'];
  preferredLastName: Scalars['Int'];
  stripeCustomerTableId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type OrganizationPetParentCountOrderByAggregateInput = {
  activeCareStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  preferredFirstName?: Maybe<SortOrder>;
  preferredLastName?: Maybe<SortOrder>;
  stripeCustomerTableId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationPetParentCountOutputType = {
  __typename?: 'OrganizationPetParentCountOutputType';
  allCareStripeSubscriptions: Scalars['Int'];
  clinicPetParents: Scalars['Int'];
  organizationPetToOrganizationPetParents: Scalars['Int'];
};

export type OrganizationPetParentCreateInput = {
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutActiveSubscriberInput>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutSubscriptionOwnerInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutOrganizationPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetParentsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetParentInput>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutOrganizationPetParentsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentCreateManyInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentCreateManyOrganizationInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentCreateManyOrganizationInputEnvelope = {
  data: Array<OrganizationPetParentCreateManyOrganizationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type OrganizationPetParentCreateManyStripeCustomerInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentCreateManyStripeCustomerInputEnvelope = {
  data: Array<OrganizationPetParentCreateManyStripeCustomerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type OrganizationPetParentCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetParentCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<OrganizationPetParentCreateWithoutOrganizationInput>>;
  createMany?: Maybe<OrganizationPetParentCreateManyOrganizationInputEnvelope>;
};

export type OrganizationPetParentCreateNestedManyWithoutStripeCustomerInput = {
  connect?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetParentCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<OrganizationPetParentCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<OrganizationPetParentCreateManyStripeCustomerInputEnvelope>;
};

export type OrganizationPetParentCreateNestedOneWithoutActiveCareStripeSubscriptionInput = {
  connect?: Maybe<OrganizationPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetParentCreateOrConnectWithoutActiveCareStripeSubscriptionInput>;
  create?: Maybe<OrganizationPetParentCreateWithoutActiveCareStripeSubscriptionInput>;
};

export type OrganizationPetParentCreateNestedOneWithoutAllCareStripeSubscriptionsInput = {
  connect?: Maybe<OrganizationPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetParentCreateOrConnectWithoutAllCareStripeSubscriptionsInput>;
  create?: Maybe<OrganizationPetParentCreateWithoutAllCareStripeSubscriptionsInput>;
};

export type OrganizationPetParentCreateNestedOneWithoutClinicPetParentsInput = {
  connect?: Maybe<OrganizationPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetParentCreateOrConnectWithoutClinicPetParentsInput>;
  create?: Maybe<OrganizationPetParentCreateWithoutClinicPetParentsInput>;
};

export type OrganizationPetParentCreateNestedOneWithoutOrganizationPetToOrganizationPetParentsInput = {
  connect?: Maybe<OrganizationPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetParentCreateOrConnectWithoutOrganizationPetToOrganizationPetParentsInput>;
  create?: Maybe<OrganizationPetParentCreateWithoutOrganizationPetToOrganizationPetParentsInput>;
};

export type OrganizationPetParentCreateOrConnectWithoutActiveCareStripeSubscriptionInput = {
  create: OrganizationPetParentCreateWithoutActiveCareStripeSubscriptionInput;
  where: OrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetParentCreateOrConnectWithoutAllCareStripeSubscriptionsInput = {
  create: OrganizationPetParentCreateWithoutAllCareStripeSubscriptionsInput;
  where: OrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetParentCreateOrConnectWithoutClinicPetParentsInput = {
  create: OrganizationPetParentCreateWithoutClinicPetParentsInput;
  where: OrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetParentCreateOrConnectWithoutOrganizationInput = {
  create: OrganizationPetParentCreateWithoutOrganizationInput;
  where: OrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetParentCreateOrConnectWithoutOrganizationPetToOrganizationPetParentsInput = {
  create: OrganizationPetParentCreateWithoutOrganizationPetToOrganizationPetParentsInput;
  where: OrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetParentCreateOrConnectWithoutStripeCustomerInput = {
  create: OrganizationPetParentCreateWithoutStripeCustomerInput;
  where: OrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetParentCreateWithoutActiveCareStripeSubscriptionInput = {
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutSubscriptionOwnerInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutOrganizationPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetParentsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetParentInput>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutOrganizationPetParentsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentCreateWithoutAllCareStripeSubscriptionsInput = {
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutActiveSubscriberInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutOrganizationPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetParentsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetParentInput>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutOrganizationPetParentsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentCreateWithoutClinicPetParentsInput = {
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutActiveSubscriberInput>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutSubscriptionOwnerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetParentsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetParentInput>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutOrganizationPetParentsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentCreateWithoutOrganizationInput = {
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutActiveSubscriberInput>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutSubscriptionOwnerInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutOrganizationPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetParentInput>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutOrganizationPetParentsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentCreateWithoutOrganizationPetToOrganizationPetParentsInput = {
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutActiveSubscriberInput>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutSubscriptionOwnerInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutOrganizationPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetParentsInput;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutOrganizationPetParentsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentCreateWithoutStripeCustomerInput = {
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionCreateNestedOneWithoutActiveSubscriberInput>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutSubscriptionOwnerInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutOrganizationPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutOrganizationPetParentsInput;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetParentInput>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentGroupByOutputType = {
  __typename?: 'OrganizationPetParentGroupByOutputType';
  _count?: Maybe<OrganizationPetParentCountAggregateOutputType>;
  _max?: Maybe<OrganizationPetParentMaxAggregateOutputType>;
  _min?: Maybe<OrganizationPetParentMinAggregateOutputType>;
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  organizationId: Scalars['String'];
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type OrganizationPetParentListRelationFilter = {
  every?: Maybe<OrganizationPetParentWhereInput>;
  none?: Maybe<OrganizationPetParentWhereInput>;
  some?: Maybe<OrganizationPetParentWhereInput>;
};

export type OrganizationPetParentMaxAggregateOutputType = {
  __typename?: 'OrganizationPetParentMaxAggregateOutputType';
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentMaxOrderByAggregateInput = {
  activeCareStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  preferredFirstName?: Maybe<SortOrder>;
  preferredLastName?: Maybe<SortOrder>;
  stripeCustomerTableId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationPetParentMinAggregateOutputType = {
  __typename?: 'OrganizationPetParentMinAggregateOutputType';
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentMinOrderByAggregateInput = {
  activeCareStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  preferredFirstName?: Maybe<SortOrder>;
  preferredLastName?: Maybe<SortOrder>;
  stripeCustomerTableId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationPetParentNullableScalarRelationFilter = {
  AND?: Maybe<Array<OrganizationPetParentWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetParentWhereInput>>;
  OR?: Maybe<Array<OrganizationPetParentWhereInput>>;
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionNullableScalarRelationFilter>;
  activeCareStripeSubscriptionId?: Maybe<StringNullableFilter>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentListRelationFilter>;
  preferredFirstName?: Maybe<StringFilter>;
  preferredLastName?: Maybe<StringFilter>;
  stripeCustomer?: Maybe<StripeCustomerNullableScalarRelationFilter>;
  stripeCustomerTableId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type OrganizationPetParentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type OrganizationPetParentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<OrganizationPetParentOrderByRelevanceInput>;
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  activeCareStripeSubscriptionId?: Maybe<SortOrder>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionOrderByRelationAggregateInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentOrderByRelationAggregateInput>;
  preferredFirstName?: Maybe<SortOrder>;
  preferredLastName?: Maybe<SortOrder>;
  stripeCustomer?: Maybe<StripeCustomerOrderByWithRelationInput>;
  stripeCustomerTableId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum OrganizationPetParentOrderByRelevanceFieldEnum {
  ActiveCareStripeSubscriptionId = 'activeCareStripeSubscriptionId',
  Id = 'id',
  OrganizationId = 'organizationId',
  PreferredFirstName = 'preferredFirstName',
  PreferredLastName = 'preferredLastName',
  StripeCustomerTableId = 'stripeCustomerTableId'
}

export type OrganizationPetParentOrderByRelevanceInput = {
  fields: Array<OrganizationPetParentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type OrganizationPetParentOrderByWithAggregationInput = {
  _count?: Maybe<OrganizationPetParentCountOrderByAggregateInput>;
  _max?: Maybe<OrganizationPetParentMaxOrderByAggregateInput>;
  _min?: Maybe<OrganizationPetParentMinOrderByAggregateInput>;
  activeCareStripeSubscriptionId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organizationId?: Maybe<SortOrder>;
  preferredFirstName?: Maybe<SortOrder>;
  preferredLastName?: Maybe<SortOrder>;
  stripeCustomerTableId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationPetParentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<OrganizationPetParentOrderByRelevanceInput>;
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  activeCareStripeSubscriptionId?: Maybe<SortOrder>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionOrderByRelationAggregateInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentOrderByRelationAggregateInput>;
  preferredFirstName?: Maybe<SortOrder>;
  preferredLastName?: Maybe<SortOrder>;
  stripeCustomer?: Maybe<StripeCustomerOrderByWithRelationInput>;
  stripeCustomerTableId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrganizationPetParentOrderByWithRelationInput = {
  _relevance?: Maybe<OrganizationPetParentOrderByRelevanceInput>;
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  activeCareStripeSubscriptionId?: Maybe<SortOrder>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionOrderByRelationAggregateInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  organization?: Maybe<OrganizationOrderByWithRelationInput>;
  organizationId?: Maybe<SortOrder>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentOrderByRelationAggregateInput>;
  preferredFirstName?: Maybe<SortOrder>;
  preferredLastName?: Maybe<SortOrder>;
  stripeCustomer?: Maybe<StripeCustomerOrderByWithRelationInput>;
  stripeCustomerTableId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum OrganizationPetParentScalarFieldEnum {
  ActiveCareStripeSubscriptionId = 'activeCareStripeSubscriptionId',
  CreatedAt = 'createdAt',
  Id = 'id',
  OrganizationId = 'organizationId',
  PreferredFirstName = 'preferredFirstName',
  PreferredLastName = 'preferredLastName',
  StripeCustomerTableId = 'stripeCustomerTableId',
  UpdatedAt = 'updatedAt'
}

export type OrganizationPetParentScalarRelationFilter = {
  AND?: Maybe<Array<OrganizationPetParentWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetParentWhereInput>>;
  OR?: Maybe<Array<OrganizationPetParentWhereInput>>;
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionNullableScalarRelationFilter>;
  activeCareStripeSubscriptionId?: Maybe<StringNullableFilter>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentListRelationFilter>;
  preferredFirstName?: Maybe<StringFilter>;
  preferredLastName?: Maybe<StringFilter>;
  stripeCustomer?: Maybe<StripeCustomerNullableScalarRelationFilter>;
  stripeCustomerTableId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type OrganizationPetParentScalarWhereInput = {
  AND?: Maybe<Array<OrganizationPetParentScalarWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetParentScalarWhereInput>>;
  OR?: Maybe<Array<OrganizationPetParentScalarWhereInput>>;
  activeCareStripeSubscriptionId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  organizationId?: Maybe<StringFilter>;
  preferredFirstName?: Maybe<StringFilter>;
  preferredLastName?: Maybe<StringFilter>;
  stripeCustomerTableId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type OrganizationPetParentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<OrganizationPetParentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<OrganizationPetParentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<OrganizationPetParentScalarWhereWithAggregatesInput>>;
  activeCareStripeSubscriptionId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  organizationId?: Maybe<StringWithAggregatesFilter>;
  preferredFirstName?: Maybe<StringWithAggregatesFilter>;
  preferredLastName?: Maybe<StringWithAggregatesFilter>;
  stripeCustomerTableId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type OrganizationPetParentUncheckedCreateInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutSubscriptionOwnerInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetParentCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<OrganizationPetParentCreateWithoutOrganizationInput>>;
  createMany?: Maybe<OrganizationPetParentCreateManyOrganizationInputEnvelope>;
};

export type OrganizationPetParentUncheckedCreateNestedManyWithoutStripeCustomerInput = {
  connect?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetParentCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<OrganizationPetParentCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<OrganizationPetParentCreateManyStripeCustomerInputEnvelope>;
};

export type OrganizationPetParentUncheckedCreateNestedOneWithoutActiveCareStripeSubscriptionInput = {
  connect?: Maybe<OrganizationPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetParentCreateOrConnectWithoutActiveCareStripeSubscriptionInput>;
  create?: Maybe<OrganizationPetParentCreateWithoutActiveCareStripeSubscriptionInput>;
};

export type OrganizationPetParentUncheckedCreateWithoutActiveCareStripeSubscriptionInput = {
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutSubscriptionOwnerInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedCreateWithoutAllCareStripeSubscriptionsInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedCreateWithoutClinicPetParentsInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutSubscriptionOwnerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedCreateWithoutOrganizationInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutSubscriptionOwnerInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedCreateWithoutOrganizationPetToOrganizationPetParentsInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutSubscriptionOwnerInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedCreateWithoutStripeCustomerInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutSubscriptionOwnerInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput>;
  preferredFirstName: Scalars['String'];
  preferredLastName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedUpdateInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutSubscriptionOwnerNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedUpdateManyInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedUpdateManyWithoutOrganizationInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetParentCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<OrganizationPetParentCreateWithoutOrganizationInput>>;
  createMany?: Maybe<OrganizationPetParentCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationPetParentUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<OrganizationPetParentUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<OrganizationPetParentUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type OrganizationPetParentUncheckedUpdateManyWithoutStripeCustomerInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedUpdateManyWithoutStripeCustomerNestedInput = {
  connect?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetParentCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<OrganizationPetParentCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<OrganizationPetParentCreateManyStripeCustomerInputEnvelope>;
  delete?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationPetParentUpdateWithWhereUniqueWithoutStripeCustomerInput>>;
  updateMany?: Maybe<Array<OrganizationPetParentUpdateManyWithWhereWithoutStripeCustomerInput>>;
  upsert?: Maybe<Array<OrganizationPetParentUpsertWithWhereUniqueWithoutStripeCustomerInput>>;
};

export type OrganizationPetParentUncheckedUpdateOneWithoutActiveCareStripeSubscriptionNestedInput = {
  connect?: Maybe<OrganizationPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetParentCreateOrConnectWithoutActiveCareStripeSubscriptionInput>;
  create?: Maybe<OrganizationPetParentCreateWithoutActiveCareStripeSubscriptionInput>;
  delete?: Maybe<OrganizationPetParentWhereInput>;
  disconnect?: Maybe<OrganizationPetParentWhereInput>;
  update?: Maybe<OrganizationPetParentUpdateToOneWithWhereWithoutActiveCareStripeSubscriptionInput>;
  upsert?: Maybe<OrganizationPetParentUpsertWithoutActiveCareStripeSubscriptionInput>;
};

export type OrganizationPetParentUncheckedUpdateWithoutActiveCareStripeSubscriptionInput = {
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutSubscriptionOwnerNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedUpdateWithoutAllCareStripeSubscriptionsInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedUpdateWithoutClinicPetParentsInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutSubscriptionOwnerNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedUpdateWithoutOrganizationInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutSubscriptionOwnerNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedUpdateWithoutOrganizationPetToOrganizationPetParentsInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutSubscriptionOwnerNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomerTableId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUncheckedUpdateWithoutStripeCustomerInput = {
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutSubscriptionOwnerNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUpdateInput = {
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutActiveSubscriberNestedInput>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutSubscriptionOwnerNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutOrganizationPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetParentsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetParentNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutOrganizationPetParentsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUpdateManyWithWhereWithoutOrganizationInput = {
  data: OrganizationPetParentUpdateManyMutationInput;
  where: OrganizationPetParentScalarWhereInput;
};

export type OrganizationPetParentUpdateManyWithWhereWithoutStripeCustomerInput = {
  data: OrganizationPetParentUpdateManyMutationInput;
  where: OrganizationPetParentScalarWhereInput;
};

export type OrganizationPetParentUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetParentCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<OrganizationPetParentCreateWithoutOrganizationInput>>;
  createMany?: Maybe<OrganizationPetParentCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationPetParentUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<OrganizationPetParentUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<OrganizationPetParentUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type OrganizationPetParentUpdateManyWithoutStripeCustomerNestedInput = {
  connect?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetParentCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<OrganizationPetParentCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<OrganizationPetParentCreateManyStripeCustomerInputEnvelope>;
  delete?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationPetParentWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationPetParentUpdateWithWhereUniqueWithoutStripeCustomerInput>>;
  updateMany?: Maybe<Array<OrganizationPetParentUpdateManyWithWhereWithoutStripeCustomerInput>>;
  upsert?: Maybe<Array<OrganizationPetParentUpsertWithWhereUniqueWithoutStripeCustomerInput>>;
};

export type OrganizationPetParentUpdateOneRequiredWithoutAllCareStripeSubscriptionsNestedInput = {
  connect?: Maybe<OrganizationPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetParentCreateOrConnectWithoutAllCareStripeSubscriptionsInput>;
  create?: Maybe<OrganizationPetParentCreateWithoutAllCareStripeSubscriptionsInput>;
  update?: Maybe<OrganizationPetParentUpdateToOneWithWhereWithoutAllCareStripeSubscriptionsInput>;
  upsert?: Maybe<OrganizationPetParentUpsertWithoutAllCareStripeSubscriptionsInput>;
};

export type OrganizationPetParentUpdateOneRequiredWithoutOrganizationPetToOrganizationPetParentsNestedInput = {
  connect?: Maybe<OrganizationPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetParentCreateOrConnectWithoutOrganizationPetToOrganizationPetParentsInput>;
  create?: Maybe<OrganizationPetParentCreateWithoutOrganizationPetToOrganizationPetParentsInput>;
  update?: Maybe<OrganizationPetParentUpdateToOneWithWhereWithoutOrganizationPetToOrganizationPetParentsInput>;
  upsert?: Maybe<OrganizationPetParentUpsertWithoutOrganizationPetToOrganizationPetParentsInput>;
};

export type OrganizationPetParentUpdateOneWithoutActiveCareStripeSubscriptionNestedInput = {
  connect?: Maybe<OrganizationPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetParentCreateOrConnectWithoutActiveCareStripeSubscriptionInput>;
  create?: Maybe<OrganizationPetParentCreateWithoutActiveCareStripeSubscriptionInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OrganizationPetParentUpdateToOneWithWhereWithoutActiveCareStripeSubscriptionInput>;
  upsert?: Maybe<OrganizationPetParentUpsertWithoutActiveCareStripeSubscriptionInput>;
};

export type OrganizationPetParentUpdateOneWithoutClinicPetParentsNestedInput = {
  connect?: Maybe<OrganizationPetParentWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetParentCreateOrConnectWithoutClinicPetParentsInput>;
  create?: Maybe<OrganizationPetParentCreateWithoutClinicPetParentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OrganizationPetParentUpdateToOneWithWhereWithoutClinicPetParentsInput>;
  upsert?: Maybe<OrganizationPetParentUpsertWithoutClinicPetParentsInput>;
};

export type OrganizationPetParentUpdateToOneWithWhereWithoutActiveCareStripeSubscriptionInput = {
  data: OrganizationPetParentUpdateWithoutActiveCareStripeSubscriptionInput;
  where?: Maybe<OrganizationPetParentWhereInput>;
};

export type OrganizationPetParentUpdateToOneWithWhereWithoutAllCareStripeSubscriptionsInput = {
  data: OrganizationPetParentUpdateWithoutAllCareStripeSubscriptionsInput;
  where?: Maybe<OrganizationPetParentWhereInput>;
};

export type OrganizationPetParentUpdateToOneWithWhereWithoutClinicPetParentsInput = {
  data: OrganizationPetParentUpdateWithoutClinicPetParentsInput;
  where?: Maybe<OrganizationPetParentWhereInput>;
};

export type OrganizationPetParentUpdateToOneWithWhereWithoutOrganizationPetToOrganizationPetParentsInput = {
  data: OrganizationPetParentUpdateWithoutOrganizationPetToOrganizationPetParentsInput;
  where?: Maybe<OrganizationPetParentWhereInput>;
};

export type OrganizationPetParentUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: OrganizationPetParentUpdateWithoutOrganizationInput;
  where: OrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetParentUpdateWithWhereUniqueWithoutStripeCustomerInput = {
  data: OrganizationPetParentUpdateWithoutStripeCustomerInput;
  where: OrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetParentUpdateWithoutActiveCareStripeSubscriptionInput = {
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutSubscriptionOwnerNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutOrganizationPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetParentsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetParentNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutOrganizationPetParentsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUpdateWithoutAllCareStripeSubscriptionsInput = {
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutActiveSubscriberNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutOrganizationPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetParentsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetParentNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutOrganizationPetParentsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUpdateWithoutClinicPetParentsInput = {
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutActiveSubscriberNestedInput>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutSubscriptionOwnerNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetParentsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetParentNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutOrganizationPetParentsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUpdateWithoutOrganizationInput = {
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutActiveSubscriberNestedInput>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutSubscriptionOwnerNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutOrganizationPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetParentNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutOrganizationPetParentsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUpdateWithoutOrganizationPetToOrganizationPetParentsInput = {
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutActiveSubscriberNestedInput>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutSubscriptionOwnerNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutOrganizationPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetParentsNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutOrganizationPetParentsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUpdateWithoutStripeCustomerInput = {
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneWithoutActiveSubscriberNestedInput>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutSubscriptionOwnerNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutOrganizationPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetParentsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetParentNestedInput>;
  preferredFirstName?: Maybe<Scalars['String']>;
  preferredLastName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetParentUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: OrganizationPetParentCreateWithoutOrganizationInput;
  update: OrganizationPetParentUpdateWithoutOrganizationInput;
  where: OrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetParentUpsertWithWhereUniqueWithoutStripeCustomerInput = {
  create: OrganizationPetParentCreateWithoutStripeCustomerInput;
  update: OrganizationPetParentUpdateWithoutStripeCustomerInput;
  where: OrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetParentUpsertWithoutActiveCareStripeSubscriptionInput = {
  create: OrganizationPetParentCreateWithoutActiveCareStripeSubscriptionInput;
  update: OrganizationPetParentUpdateWithoutActiveCareStripeSubscriptionInput;
  where?: Maybe<OrganizationPetParentWhereInput>;
};

export type OrganizationPetParentUpsertWithoutAllCareStripeSubscriptionsInput = {
  create: OrganizationPetParentCreateWithoutAllCareStripeSubscriptionsInput;
  update: OrganizationPetParentUpdateWithoutAllCareStripeSubscriptionsInput;
  where?: Maybe<OrganizationPetParentWhereInput>;
};

export type OrganizationPetParentUpsertWithoutClinicPetParentsInput = {
  create: OrganizationPetParentCreateWithoutClinicPetParentsInput;
  update: OrganizationPetParentUpdateWithoutClinicPetParentsInput;
  where?: Maybe<OrganizationPetParentWhereInput>;
};

export type OrganizationPetParentUpsertWithoutOrganizationPetToOrganizationPetParentsInput = {
  create: OrganizationPetParentCreateWithoutOrganizationPetToOrganizationPetParentsInput;
  update: OrganizationPetParentUpdateWithoutOrganizationPetToOrganizationPetParentsInput;
  where?: Maybe<OrganizationPetParentWhereInput>;
};

export type OrganizationPetParentWhereInput = {
  AND?: Maybe<Array<OrganizationPetParentWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetParentWhereInput>>;
  OR?: Maybe<Array<OrganizationPetParentWhereInput>>;
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionNullableScalarRelationFilter>;
  activeCareStripeSubscriptionId?: Maybe<StringNullableFilter>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentListRelationFilter>;
  preferredFirstName?: Maybe<StringFilter>;
  preferredLastName?: Maybe<StringFilter>;
  stripeCustomer?: Maybe<StripeCustomerNullableScalarRelationFilter>;
  stripeCustomerTableId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type OrganizationPetParentWhereUniqueInput = {
  AND?: Maybe<Array<OrganizationPetParentWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetParentWhereInput>>;
  OR?: Maybe<Array<OrganizationPetParentWhereInput>>;
  activeCareStripeSubscription?: Maybe<CareStripeSubscriptionNullableScalarRelationFilter>;
  activeCareStripeSubscriptionId?: Maybe<Scalars['String']>;
  allCareStripeSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentListRelationFilter>;
  preferredFirstName?: Maybe<StringFilter>;
  preferredLastName?: Maybe<StringFilter>;
  stripeCustomer?: Maybe<StripeCustomerNullableScalarRelationFilter>;
  stripeCustomerTableId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum OrganizationPetScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  OrganizationId = 'organizationId',
  PreferredName = 'preferredName',
  ProfilePictureUrl = 'profilePictureUrl',
  UpdatedAt = 'updatedAt'
}

export type OrganizationPetScalarRelationFilter = {
  AND?: Maybe<Array<OrganizationPetWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetWhereInput>>;
  OR?: Maybe<Array<OrganizationPetWhereInput>>;
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventListRelationFilter>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventListRelationFilter>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupListRelationFilter>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentListRelationFilter>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentListRelationFilter>;
  preferredName?: Maybe<StringFilter>;
  profilePictureUrl?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type OrganizationPetScalarWhereInput = {
  AND?: Maybe<Array<OrganizationPetScalarWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetScalarWhereInput>>;
  OR?: Maybe<Array<OrganizationPetScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  organizationId?: Maybe<StringFilter>;
  preferredName?: Maybe<StringFilter>;
  profilePictureUrl?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type OrganizationPetScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<OrganizationPetScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<OrganizationPetScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<OrganizationPetScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  organizationId?: Maybe<StringWithAggregatesFilter>;
  preferredName?: Maybe<StringWithAggregatesFilter>;
  profilePictureUrl?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type OrganizationPetToOrganizationPetParent = {
  __typename?: 'OrganizationPetToOrganizationPetParent';
  organizationPet: OrganizationPet;
  organizationPetId: Scalars['String'];
  organizationPetParent: OrganizationPetParent;
  organizationPetParentId: Scalars['String'];
};

export type OrganizationPetToOrganizationPetParentCountAggregateOutputType = {
  __typename?: 'OrganizationPetToOrganizationPetParentCountAggregateOutputType';
  _all: Scalars['Int'];
  organizationPetId: Scalars['Int'];
  organizationPetParentId: Scalars['Int'];
};

export type OrganizationPetToOrganizationPetParentCountOrderByAggregateInput = {
  organizationPetId?: Maybe<SortOrder>;
  organizationPetParentId?: Maybe<SortOrder>;
};

export type OrganizationPetToOrganizationPetParentCreateInput = {
  organizationPet: OrganizationPetCreateNestedOneWithoutOrganizationPetToOrganizationPetParentsInput;
  organizationPetParent: OrganizationPetParentCreateNestedOneWithoutOrganizationPetToOrganizationPetParentsInput;
};

export type OrganizationPetToOrganizationPetParentCreateManyInput = {
  organizationPetId: Scalars['String'];
  organizationPetParentId: Scalars['String'];
};

export type OrganizationPetToOrganizationPetParentCreateManyOrganizationPetInput = {
  organizationPetParentId: Scalars['String'];
};

export type OrganizationPetToOrganizationPetParentCreateManyOrganizationPetInputEnvelope = {
  data: Array<OrganizationPetToOrganizationPetParentCreateManyOrganizationPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type OrganizationPetToOrganizationPetParentCreateManyOrganizationPetParentInput = {
  organizationPetId: Scalars['String'];
};

export type OrganizationPetToOrganizationPetParentCreateManyOrganizationPetParentInputEnvelope = {
  data: Array<OrganizationPetToOrganizationPetParentCreateManyOrganizationPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetInput = {
  connect?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<OrganizationPetToOrganizationPetParentCreateManyOrganizationPetInputEnvelope>;
};

export type OrganizationPetToOrganizationPetParentCreateNestedManyWithoutOrganizationPetParentInput = {
  connect?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateOrConnectWithoutOrganizationPetParentInput>>;
  create?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetParentInput>>;
  createMany?: Maybe<OrganizationPetToOrganizationPetParentCreateManyOrganizationPetParentInputEnvelope>;
};

export type OrganizationPetToOrganizationPetParentCreateOrConnectWithoutOrganizationPetInput = {
  create: OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetInput;
  where: OrganizationPetToOrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetToOrganizationPetParentCreateOrConnectWithoutOrganizationPetParentInput = {
  create: OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetParentInput;
  where: OrganizationPetToOrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetInput = {
  organizationPetParent: OrganizationPetParentCreateNestedOneWithoutOrganizationPetToOrganizationPetParentsInput;
};

export type OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetParentInput = {
  organizationPet: OrganizationPetCreateNestedOneWithoutOrganizationPetToOrganizationPetParentsInput;
};

export type OrganizationPetToOrganizationPetParentGroupByOutputType = {
  __typename?: 'OrganizationPetToOrganizationPetParentGroupByOutputType';
  _count?: Maybe<OrganizationPetToOrganizationPetParentCountAggregateOutputType>;
  _max?: Maybe<OrganizationPetToOrganizationPetParentMaxAggregateOutputType>;
  _min?: Maybe<OrganizationPetToOrganizationPetParentMinAggregateOutputType>;
  organizationPetId: Scalars['String'];
  organizationPetParentId: Scalars['String'];
};

export type OrganizationPetToOrganizationPetParentListRelationFilter = {
  every?: Maybe<OrganizationPetToOrganizationPetParentWhereInput>;
  none?: Maybe<OrganizationPetToOrganizationPetParentWhereInput>;
  some?: Maybe<OrganizationPetToOrganizationPetParentWhereInput>;
};

export type OrganizationPetToOrganizationPetParentMaxAggregateOutputType = {
  __typename?: 'OrganizationPetToOrganizationPetParentMaxAggregateOutputType';
  organizationPetId?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
};

export type OrganizationPetToOrganizationPetParentMaxOrderByAggregateInput = {
  organizationPetId?: Maybe<SortOrder>;
  organizationPetParentId?: Maybe<SortOrder>;
};

export type OrganizationPetToOrganizationPetParentMinAggregateOutputType = {
  __typename?: 'OrganizationPetToOrganizationPetParentMinAggregateOutputType';
  organizationPetId?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
};

export type OrganizationPetToOrganizationPetParentMinOrderByAggregateInput = {
  organizationPetId?: Maybe<SortOrder>;
  organizationPetParentId?: Maybe<SortOrder>;
};

export type OrganizationPetToOrganizationPetParentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type OrganizationPetToOrganizationPetParentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<OrganizationPetToOrganizationPetParentOrderByRelevanceInput>;
  organizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  organizationPetId?: Maybe<SortOrder>;
  organizationPetParent?: Maybe<OrganizationPetParentOrderByWithRelationInput>;
  organizationPetParentId?: Maybe<SortOrder>;
};

export enum OrganizationPetToOrganizationPetParentOrderByRelevanceFieldEnum {
  OrganizationPetId = 'organizationPetId',
  OrganizationPetParentId = 'organizationPetParentId'
}

export type OrganizationPetToOrganizationPetParentOrderByRelevanceInput = {
  fields: Array<OrganizationPetToOrganizationPetParentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type OrganizationPetToOrganizationPetParentOrderByWithAggregationInput = {
  _count?: Maybe<OrganizationPetToOrganizationPetParentCountOrderByAggregateInput>;
  _max?: Maybe<OrganizationPetToOrganizationPetParentMaxOrderByAggregateInput>;
  _min?: Maybe<OrganizationPetToOrganizationPetParentMinOrderByAggregateInput>;
  organizationPetId?: Maybe<SortOrder>;
  organizationPetParentId?: Maybe<SortOrder>;
};

export type OrganizationPetToOrganizationPetParentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<OrganizationPetToOrganizationPetParentOrderByRelevanceInput>;
  organizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  organizationPetId?: Maybe<SortOrder>;
  organizationPetParent?: Maybe<OrganizationPetParentOrderByWithRelationInput>;
  organizationPetParentId?: Maybe<SortOrder>;
};

export type OrganizationPetToOrganizationPetParentOrderByWithRelationInput = {
  _relevance?: Maybe<OrganizationPetToOrganizationPetParentOrderByRelevanceInput>;
  organizationPet?: Maybe<OrganizationPetOrderByWithRelationInput>;
  organizationPetId?: Maybe<SortOrder>;
  organizationPetParent?: Maybe<OrganizationPetParentOrderByWithRelationInput>;
  organizationPetParentId?: Maybe<SortOrder>;
};

export type OrganizationPetToOrganizationPetParentOrganizationPetIdOrganizationPetParentIdCompoundUniqueInput = {
  organizationPetId: Scalars['String'];
  organizationPetParentId: Scalars['String'];
};

export enum OrganizationPetToOrganizationPetParentScalarFieldEnum {
  OrganizationPetId = 'organizationPetId',
  OrganizationPetParentId = 'organizationPetParentId'
}

export type OrganizationPetToOrganizationPetParentScalarWhereInput = {
  AND?: Maybe<Array<OrganizationPetToOrganizationPetParentScalarWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetToOrganizationPetParentScalarWhereInput>>;
  OR?: Maybe<Array<OrganizationPetToOrganizationPetParentScalarWhereInput>>;
  organizationPetId?: Maybe<StringFilter>;
  organizationPetParentId?: Maybe<StringFilter>;
};

export type OrganizationPetToOrganizationPetParentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<OrganizationPetToOrganizationPetParentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<OrganizationPetToOrganizationPetParentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<OrganizationPetToOrganizationPetParentScalarWhereWithAggregatesInput>>;
  organizationPetId?: Maybe<StringWithAggregatesFilter>;
  organizationPetParentId?: Maybe<StringWithAggregatesFilter>;
};

export type OrganizationPetToOrganizationPetParentUncheckedCreateInput = {
  organizationPetId: Scalars['String'];
  organizationPetParentId: Scalars['String'];
};

export type OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetInput = {
  connect?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<OrganizationPetToOrganizationPetParentCreateManyOrganizationPetInputEnvelope>;
};

export type OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetParentInput = {
  connect?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateOrConnectWithoutOrganizationPetParentInput>>;
  create?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetParentInput>>;
  createMany?: Maybe<OrganizationPetToOrganizationPetParentCreateManyOrganizationPetParentInputEnvelope>;
};

export type OrganizationPetToOrganizationPetParentUncheckedCreateWithoutOrganizationPetInput = {
  organizationPetParentId: Scalars['String'];
};

export type OrganizationPetToOrganizationPetParentUncheckedCreateWithoutOrganizationPetParentInput = {
  organizationPetId: Scalars['String'];
};

export type OrganizationPetToOrganizationPetParentUncheckedUpdateInput = {
  organizationPetId?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
};

export type OrganizationPetToOrganizationPetParentUncheckedUpdateManyInput = {
  organizationPetId?: Maybe<Scalars['String']>;
  organizationPetParentId?: Maybe<Scalars['String']>;
};

export type OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetInput = {
  organizationPetParentId?: Maybe<Scalars['String']>;
};

export type OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetNestedInput = {
  connect?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<OrganizationPetToOrganizationPetParentCreateManyOrganizationPetInputEnvelope>;
  delete?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationPetToOrganizationPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationPetToOrganizationPetParentUpdateWithWhereUniqueWithoutOrganizationPetInput>>;
  updateMany?: Maybe<Array<OrganizationPetToOrganizationPetParentUpdateManyWithWhereWithoutOrganizationPetInput>>;
  upsert?: Maybe<Array<OrganizationPetToOrganizationPetParentUpsertWithWhereUniqueWithoutOrganizationPetInput>>;
};

export type OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetParentInput = {
  organizationPetId?: Maybe<Scalars['String']>;
};

export type OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetParentNestedInput = {
  connect?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateOrConnectWithoutOrganizationPetParentInput>>;
  create?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetParentInput>>;
  createMany?: Maybe<OrganizationPetToOrganizationPetParentCreateManyOrganizationPetParentInputEnvelope>;
  delete?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationPetToOrganizationPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationPetToOrganizationPetParentUpdateWithWhereUniqueWithoutOrganizationPetParentInput>>;
  updateMany?: Maybe<Array<OrganizationPetToOrganizationPetParentUpdateManyWithWhereWithoutOrganizationPetParentInput>>;
  upsert?: Maybe<Array<OrganizationPetToOrganizationPetParentUpsertWithWhereUniqueWithoutOrganizationPetParentInput>>;
};

export type OrganizationPetToOrganizationPetParentUncheckedUpdateWithoutOrganizationPetInput = {
  organizationPetParentId?: Maybe<Scalars['String']>;
};

export type OrganizationPetToOrganizationPetParentUncheckedUpdateWithoutOrganizationPetParentInput = {
  organizationPetId?: Maybe<Scalars['String']>;
};

export type OrganizationPetToOrganizationPetParentUpdateInput = {
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutOrganizationPetToOrganizationPetParentsNestedInput>;
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneRequiredWithoutOrganizationPetToOrganizationPetParentsNestedInput>;
};

export type OrganizationPetToOrganizationPetParentUpdateManyMutationInput = {
  organizationPetId?: Maybe<StringNullableFilter>;
  organizationPetParentId?: Maybe<StringNullableFilter>;
};

export type OrganizationPetToOrganizationPetParentUpdateManyWithWhereWithoutOrganizationPetInput = {
  data: OrganizationPetToOrganizationPetParentUpdateManyMutationInput;
  where: OrganizationPetToOrganizationPetParentScalarWhereInput;
};

export type OrganizationPetToOrganizationPetParentUpdateManyWithWhereWithoutOrganizationPetParentInput = {
  data: OrganizationPetToOrganizationPetParentUpdateManyMutationInput;
  where: OrganizationPetToOrganizationPetParentScalarWhereInput;
};

export type OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetNestedInput = {
  connect?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateOrConnectWithoutOrganizationPetInput>>;
  create?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetInput>>;
  createMany?: Maybe<OrganizationPetToOrganizationPetParentCreateManyOrganizationPetInputEnvelope>;
  delete?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationPetToOrganizationPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationPetToOrganizationPetParentUpdateWithWhereUniqueWithoutOrganizationPetInput>>;
  updateMany?: Maybe<Array<OrganizationPetToOrganizationPetParentUpdateManyWithWhereWithoutOrganizationPetInput>>;
  upsert?: Maybe<Array<OrganizationPetToOrganizationPetParentUpsertWithWhereUniqueWithoutOrganizationPetInput>>;
};

export type OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetParentNestedInput = {
  connect?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateOrConnectWithoutOrganizationPetParentInput>>;
  create?: Maybe<Array<OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetParentInput>>;
  createMany?: Maybe<OrganizationPetToOrganizationPetParentCreateManyOrganizationPetParentInputEnvelope>;
  delete?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationPetToOrganizationPetParentScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationPetToOrganizationPetParentUpdateWithWhereUniqueWithoutOrganizationPetParentInput>>;
  updateMany?: Maybe<Array<OrganizationPetToOrganizationPetParentUpdateManyWithWhereWithoutOrganizationPetParentInput>>;
  upsert?: Maybe<Array<OrganizationPetToOrganizationPetParentUpsertWithWhereUniqueWithoutOrganizationPetParentInput>>;
};

export type OrganizationPetToOrganizationPetParentUpdateWithWhereUniqueWithoutOrganizationPetInput = {
  data: OrganizationPetToOrganizationPetParentUpdateWithoutOrganizationPetInput;
  where: OrganizationPetToOrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetToOrganizationPetParentUpdateWithWhereUniqueWithoutOrganizationPetParentInput = {
  data: OrganizationPetToOrganizationPetParentUpdateWithoutOrganizationPetParentInput;
  where: OrganizationPetToOrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetToOrganizationPetParentUpdateWithoutOrganizationPetInput = {
  organizationPetParent?: Maybe<OrganizationPetParentUpdateOneRequiredWithoutOrganizationPetToOrganizationPetParentsNestedInput>;
};

export type OrganizationPetToOrganizationPetParentUpdateWithoutOrganizationPetParentInput = {
  organizationPet?: Maybe<OrganizationPetUpdateOneRequiredWithoutOrganizationPetToOrganizationPetParentsNestedInput>;
};

export type OrganizationPetToOrganizationPetParentUpsertWithWhereUniqueWithoutOrganizationPetInput = {
  create: OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetInput;
  update: OrganizationPetToOrganizationPetParentUpdateWithoutOrganizationPetInput;
  where: OrganizationPetToOrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetToOrganizationPetParentUpsertWithWhereUniqueWithoutOrganizationPetParentInput = {
  create: OrganizationPetToOrganizationPetParentCreateWithoutOrganizationPetParentInput;
  update: OrganizationPetToOrganizationPetParentUpdateWithoutOrganizationPetParentInput;
  where: OrganizationPetToOrganizationPetParentWhereUniqueInput;
};

export type OrganizationPetToOrganizationPetParentWhereInput = {
  AND?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereInput>>;
  OR?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereInput>>;
  organizationPet?: Maybe<OrganizationPetScalarRelationFilter>;
  organizationPetId?: Maybe<StringFilter>;
  organizationPetParent?: Maybe<OrganizationPetParentScalarRelationFilter>;
  organizationPetParentId?: Maybe<StringFilter>;
};

export type OrganizationPetToOrganizationPetParentWhereUniqueInput = {
  AND?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereInput>>;
  OR?: Maybe<Array<OrganizationPetToOrganizationPetParentWhereInput>>;
  organizationPet?: Maybe<OrganizationPetScalarRelationFilter>;
  organizationPetId?: Maybe<StringFilter>;
  organizationPetId_organizationPetParentId?: Maybe<OrganizationPetToOrganizationPetParentOrganizationPetIdOrganizationPetParentIdCompoundUniqueInput>;
  organizationPetParent?: Maybe<OrganizationPetParentScalarRelationFilter>;
  organizationPetParentId?: Maybe<StringFilter>;
};

export type OrganizationPetUncheckedCreateInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: Maybe<Array<OrganizationPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<OrganizationPetCreateWithoutOrganizationInput>>;
  createMany?: Maybe<OrganizationPetCreateManyOrganizationInputEnvelope>;
};

export type OrganizationPetUncheckedCreateWithoutAssociatedBenefitUsageFollowupInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferToPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedCreateWithoutAssociatedSubscriptionsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutRelatedOrganizationPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedCreateWithoutCareAddonEnrollmentsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedCreateWithoutCarePlanEnrollmentsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedCreateWithoutClinicPetsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedCreateWithoutOrganizationInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedCreateWithoutOrganizationPetToOrganizationPetParentsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferFromPetInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedCreateWithoutTransferFromPetEnrollmentSupportEventInput = {
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferToPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedCreateWithoutTransferToPetEnrollmentSupportEventInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutTransferFromPetInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedCreateNestedManyWithoutRelatedOrganizationPetInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutAssociatedPetInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  clinicPets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationPetInput>;
  preferredName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedUpdateInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedUpdateManyWithoutOrganizationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<OrganizationPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<OrganizationPetCreateWithoutOrganizationInput>>;
  createMany?: Maybe<OrganizationPetCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<OrganizationPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationPetScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationPetWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationPetWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationPetUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<OrganizationPetUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<OrganizationPetUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type OrganizationPetUncheckedUpdateWithoutAssociatedBenefitUsageFollowupInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferToPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedUpdateWithoutAssociatedSubscriptionsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedUpdateWithoutCareAddonEnrollmentsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedUpdateWithoutCarePlanEnrollmentsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedUpdateWithoutClinicPetsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedUpdateWithoutOrganizationInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedUpdateWithoutOrganizationPetToOrganizationPetParentsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedUpdateWithoutTransferFromPetEnrollmentSupportEventInput = {
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUncheckedUpdateWithoutTransferToPetEnrollmentSupportEventInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutTransferFromPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUncheckedUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUncheckedUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUpdateInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUpdateManyWithWhereWithoutOrganizationInput = {
  data: OrganizationPetUpdateManyMutationInput;
  where: OrganizationPetScalarWhereInput;
};

export type OrganizationPetUpdateManyWithoutOrganizationNestedInput = {
  connect?: Maybe<Array<OrganizationPetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<OrganizationPetCreateOrConnectWithoutOrganizationInput>>;
  create?: Maybe<Array<OrganizationPetCreateWithoutOrganizationInput>>;
  createMany?: Maybe<OrganizationPetCreateManyOrganizationInputEnvelope>;
  delete?: Maybe<Array<OrganizationPetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<OrganizationPetScalarWhereInput>>;
  disconnect?: Maybe<Array<OrganizationPetWhereUniqueInput>>;
  set?: Maybe<Array<OrganizationPetWhereUniqueInput>>;
  update?: Maybe<Array<OrganizationPetUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: Maybe<Array<OrganizationPetUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: Maybe<Array<OrganizationPetUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type OrganizationPetUpdateOneRequiredWithoutAssociatedBenefitUsageFollowupNestedInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutAssociatedBenefitUsageFollowupInput>;
  create?: Maybe<OrganizationPetCreateWithoutAssociatedBenefitUsageFollowupInput>;
  update?: Maybe<OrganizationPetUpdateToOneWithWhereWithoutAssociatedBenefitUsageFollowupInput>;
  upsert?: Maybe<OrganizationPetUpsertWithoutAssociatedBenefitUsageFollowupInput>;
};

export type OrganizationPetUpdateOneRequiredWithoutCareAddonEnrollmentsNestedInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutCareAddonEnrollmentsInput>;
  create?: Maybe<OrganizationPetCreateWithoutCareAddonEnrollmentsInput>;
  update?: Maybe<OrganizationPetUpdateToOneWithWhereWithoutCareAddonEnrollmentsInput>;
  upsert?: Maybe<OrganizationPetUpsertWithoutCareAddonEnrollmentsInput>;
};

export type OrganizationPetUpdateOneRequiredWithoutCarePlanEnrollmentsNestedInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutCarePlanEnrollmentsInput>;
  create?: Maybe<OrganizationPetCreateWithoutCarePlanEnrollmentsInput>;
  update?: Maybe<OrganizationPetUpdateToOneWithWhereWithoutCarePlanEnrollmentsInput>;
  upsert?: Maybe<OrganizationPetUpsertWithoutCarePlanEnrollmentsInput>;
};

export type OrganizationPetUpdateOneRequiredWithoutOrganizationPetToOrganizationPetParentsNestedInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutOrganizationPetToOrganizationPetParentsInput>;
  create?: Maybe<OrganizationPetCreateWithoutOrganizationPetToOrganizationPetParentsInput>;
  update?: Maybe<OrganizationPetUpdateToOneWithWhereWithoutOrganizationPetToOrganizationPetParentsInput>;
  upsert?: Maybe<OrganizationPetUpsertWithoutOrganizationPetToOrganizationPetParentsInput>;
};

export type OrganizationPetUpdateOneWithoutAssociatedSubscriptionsNestedInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutAssociatedSubscriptionsInput>;
  create?: Maybe<OrganizationPetCreateWithoutAssociatedSubscriptionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OrganizationPetUpdateToOneWithWhereWithoutAssociatedSubscriptionsInput>;
  upsert?: Maybe<OrganizationPetUpsertWithoutAssociatedSubscriptionsInput>;
};

export type OrganizationPetUpdateOneWithoutClinicPetsNestedInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutClinicPetsInput>;
  create?: Maybe<OrganizationPetCreateWithoutClinicPetsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OrganizationPetUpdateToOneWithWhereWithoutClinicPetsInput>;
  upsert?: Maybe<OrganizationPetUpsertWithoutClinicPetsInput>;
};

export type OrganizationPetUpdateOneWithoutTransferFromPetEnrollmentSupportEventNestedInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutTransferFromPetEnrollmentSupportEventInput>;
  create?: Maybe<OrganizationPetCreateWithoutTransferFromPetEnrollmentSupportEventInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OrganizationPetUpdateToOneWithWhereWithoutTransferFromPetEnrollmentSupportEventInput>;
  upsert?: Maybe<OrganizationPetUpsertWithoutTransferFromPetEnrollmentSupportEventInput>;
};

export type OrganizationPetUpdateOneWithoutTransferToPetEnrollmentSupportEventNestedInput = {
  connect?: Maybe<OrganizationPetWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationPetCreateOrConnectWithoutTransferToPetEnrollmentSupportEventInput>;
  create?: Maybe<OrganizationPetCreateWithoutTransferToPetEnrollmentSupportEventInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OrganizationPetUpdateToOneWithWhereWithoutTransferToPetEnrollmentSupportEventInput>;
  upsert?: Maybe<OrganizationPetUpsertWithoutTransferToPetEnrollmentSupportEventInput>;
};

export type OrganizationPetUpdateToOneWithWhereWithoutAssociatedBenefitUsageFollowupInput = {
  data: OrganizationPetUpdateWithoutAssociatedBenefitUsageFollowupInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpdateToOneWithWhereWithoutAssociatedSubscriptionsInput = {
  data: OrganizationPetUpdateWithoutAssociatedSubscriptionsInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpdateToOneWithWhereWithoutCareAddonEnrollmentsInput = {
  data: OrganizationPetUpdateWithoutCareAddonEnrollmentsInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpdateToOneWithWhereWithoutCarePlanEnrollmentsInput = {
  data: OrganizationPetUpdateWithoutCarePlanEnrollmentsInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpdateToOneWithWhereWithoutClinicPetsInput = {
  data: OrganizationPetUpdateWithoutClinicPetsInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpdateToOneWithWhereWithoutOrganizationPetToOrganizationPetParentsInput = {
  data: OrganizationPetUpdateWithoutOrganizationPetToOrganizationPetParentsInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpdateToOneWithWhereWithoutTransferFromPetEnrollmentSupportEventInput = {
  data: OrganizationPetUpdateWithoutTransferFromPetEnrollmentSupportEventInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpdateToOneWithWhereWithoutTransferToPetEnrollmentSupportEventInput = {
  data: OrganizationPetUpdateWithoutTransferToPetEnrollmentSupportEventInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: OrganizationPetUpdateWithoutOrganizationInput;
  where: OrganizationPetWhereUniqueInput;
};

export type OrganizationPetUpdateWithoutAssociatedBenefitUsageFollowupInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferToPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUpdateWithoutAssociatedSubscriptionsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUpdateWithoutCareAddonEnrollmentsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUpdateWithoutCarePlanEnrollmentsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUpdateWithoutClinicPetsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUpdateWithoutOrganizationInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUpdateWithoutOrganizationPetToOrganizationPetParentsInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferFromPetNestedInput>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetsNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUpdateWithoutTransferFromPetEnrollmentSupportEventInput = {
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferToPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUpdateWithoutTransferToPetEnrollmentSupportEventInput = {
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventUpdateManyWithoutTransferFromPetNestedInput>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupUpdateManyWithoutRelatedOrganizationPetNestedInput>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutAssociatedPetNestedInput>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentUpdateManyWithoutOrganizationPetNestedInput>;
  clinicPets?: Maybe<ClinicPetUpdateManyWithoutOrganizationPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationUpdateOneRequiredWithoutOrganizationPetsNestedInput>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentUpdateManyWithoutOrganizationPetNestedInput>;
  preferredName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationPetUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: OrganizationPetCreateWithoutOrganizationInput;
  update: OrganizationPetUpdateWithoutOrganizationInput;
  where: OrganizationPetWhereUniqueInput;
};

export type OrganizationPetUpsertWithoutAssociatedBenefitUsageFollowupInput = {
  create: OrganizationPetCreateWithoutAssociatedBenefitUsageFollowupInput;
  update: OrganizationPetUpdateWithoutAssociatedBenefitUsageFollowupInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpsertWithoutAssociatedSubscriptionsInput = {
  create: OrganizationPetCreateWithoutAssociatedSubscriptionsInput;
  update: OrganizationPetUpdateWithoutAssociatedSubscriptionsInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpsertWithoutCareAddonEnrollmentsInput = {
  create: OrganizationPetCreateWithoutCareAddonEnrollmentsInput;
  update: OrganizationPetUpdateWithoutCareAddonEnrollmentsInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpsertWithoutCarePlanEnrollmentsInput = {
  create: OrganizationPetCreateWithoutCarePlanEnrollmentsInput;
  update: OrganizationPetUpdateWithoutCarePlanEnrollmentsInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpsertWithoutClinicPetsInput = {
  create: OrganizationPetCreateWithoutClinicPetsInput;
  update: OrganizationPetUpdateWithoutClinicPetsInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpsertWithoutOrganizationPetToOrganizationPetParentsInput = {
  create: OrganizationPetCreateWithoutOrganizationPetToOrganizationPetParentsInput;
  update: OrganizationPetUpdateWithoutOrganizationPetToOrganizationPetParentsInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpsertWithoutTransferFromPetEnrollmentSupportEventInput = {
  create: OrganizationPetCreateWithoutTransferFromPetEnrollmentSupportEventInput;
  update: OrganizationPetUpdateWithoutTransferFromPetEnrollmentSupportEventInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetUpsertWithoutTransferToPetEnrollmentSupportEventInput = {
  create: OrganizationPetCreateWithoutTransferToPetEnrollmentSupportEventInput;
  update: OrganizationPetUpdateWithoutTransferToPetEnrollmentSupportEventInput;
  where?: Maybe<OrganizationPetWhereInput>;
};

export type OrganizationPetWhereInput = {
  AND?: Maybe<Array<OrganizationPetWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetWhereInput>>;
  OR?: Maybe<Array<OrganizationPetWhereInput>>;
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventListRelationFilter>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventListRelationFilter>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupListRelationFilter>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentListRelationFilter>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentListRelationFilter>;
  preferredName?: Maybe<StringFilter>;
  profilePictureUrl?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type OrganizationPetWhereUniqueInput = {
  AND?: Maybe<Array<OrganizationPetWhereInput>>;
  NOT?: Maybe<Array<OrganizationPetWhereInput>>;
  OR?: Maybe<Array<OrganizationPetWhereInput>>;
  TransferFromPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventListRelationFilter>;
  TransferToPetEnrollmentSupportEvent?: Maybe<EnrollmentSupportEventListRelationFilter>;
  associatedBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowupListRelationFilter>;
  associatedSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  careAddonEnrollments?: Maybe<CareAddonEnrollmentListRelationFilter>;
  carePlanEnrollments?: Maybe<CarePlanEnrollmentListRelationFilter>;
  clinicPets?: Maybe<ClinicPetListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationScalarRelationFilter>;
  organizationId?: Maybe<StringFilter>;
  organizationPetToOrganizationPetParents?: Maybe<OrganizationPetToOrganizationPetParentListRelationFilter>;
  preferredName?: Maybe<StringFilter>;
  profilePictureUrl?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum OrganizationScalarFieldEnum {
  Configuration = 'configuration',
  CreatedAt = 'createdAt',
  CrmId = 'crmId',
  Id = 'id',
  Name = 'name',
  PaymentProcessorClinicId = 'paymentProcessorClinicId',
  UpdatedAt = 'updatedAt'
}

export type OrganizationScalarRelationFilter = {
  AND?: Maybe<Array<OrganizationWhereInput>>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateListRelationFilter>;
  NOT?: Maybe<Array<OrganizationWhereInput>>;
  OR?: Maybe<Array<OrganizationWhereInput>>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadListRelationFilter>;
  careAddonPackage?: Maybe<CareAddonPackageListRelationFilter>;
  careBenefits?: Maybe<CareBenefitListRelationFilter>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupListRelationFilter>;
  carePlans?: Maybe<CarePlanListRelationFilter>;
  clinics?: Maybe<ClinicListRelationFilter>;
  configuration?: Maybe<JsonFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  crmId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  organizationPetParents?: Maybe<OrganizationPetParentListRelationFilter>;
  organizationPets?: Maybe<OrganizationPetListRelationFilter>;
  paymentProcessorClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  paymentProcessorClinicId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type OrganizationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<OrganizationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<OrganizationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<OrganizationScalarWhereWithAggregatesInput>>;
  configuration?: Maybe<JsonWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  crmId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  paymentProcessorClinicId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type OrganizationUncheckedCreateInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedCreateNestedOneWithoutPaymentProcessorClinicInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutPaymentProcessorClinicInput>;
  create?: Maybe<OrganizationCreateWithoutPaymentProcessorClinicInput>;
};

export type OrganizationUncheckedCreateWithoutAssociatedEncryptedClinicUploadsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedCreateWithoutCareAddonPackageInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedCreateWithoutCareBenefitsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedCreateWithoutCarePlanProviderGroupsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedCreateWithoutCarePlansInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedCreateWithoutClinicsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedCreateWithoutEmailCampaignTemplateInput = {
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedCreateWithoutOrganizationPetParentsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPets?: Maybe<OrganizationPetUncheckedCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedCreateWithoutOrganizationPetsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedCreateWithoutPaymentProcessorClinicInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutOrganizationInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedCreateNestedManyWithoutOrganizationInput>;
  careBenefits?: Maybe<CareBenefitUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedCreateNestedManyWithoutOrganizationInput>;
  carePlans?: Maybe<CarePlanUncheckedCreateNestedManyWithoutOrganizationInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutOrganizationInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutOrganizationInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedUpdateInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUncheckedUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedUpdateManyInput = {
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedUpdateOneWithoutPaymentProcessorClinicNestedInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutPaymentProcessorClinicInput>;
  create?: Maybe<OrganizationCreateWithoutPaymentProcessorClinicInput>;
  delete?: Maybe<OrganizationWhereInput>;
  disconnect?: Maybe<OrganizationWhereInput>;
  update?: Maybe<OrganizationUpdateToOneWithWhereWithoutPaymentProcessorClinicInput>;
  upsert?: Maybe<OrganizationUpsertWithoutPaymentProcessorClinicInput>;
};

export type OrganizationUncheckedUpdateWithoutAssociatedEncryptedClinicUploadsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUncheckedUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedUpdateWithoutCareAddonPackageInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUncheckedUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedUpdateWithoutCareBenefitsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUncheckedUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedUpdateWithoutCarePlanProviderGroupsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUncheckedUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedUpdateWithoutCarePlansInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedUpdateWithoutClinicsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUncheckedUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedUpdateWithoutEmailCampaignTemplateInput = {
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUncheckedUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedUpdateWithoutOrganizationPetParentsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUncheckedUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPets?: Maybe<OrganizationPetUncheckedUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedUpdateWithoutOrganizationPetsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUncheckedUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUncheckedUpdateWithoutPaymentProcessorClinicInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUncheckedUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUncheckedUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUncheckedUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUncheckedUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpdateInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutCarePayoutOrganizationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpdateManyMutationInput = {
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpdateOneRequiredWithoutCareBenefitsNestedInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutCareBenefitsInput>;
  create?: Maybe<OrganizationCreateWithoutCareBenefitsInput>;
  update?: Maybe<OrganizationUpdateToOneWithWhereWithoutCareBenefitsInput>;
  upsert?: Maybe<OrganizationUpsertWithoutCareBenefitsInput>;
};

export type OrganizationUpdateOneRequiredWithoutCarePlansNestedInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutCarePlansInput>;
  create?: Maybe<OrganizationCreateWithoutCarePlansInput>;
  update?: Maybe<OrganizationUpdateToOneWithWhereWithoutCarePlansInput>;
  upsert?: Maybe<OrganizationUpsertWithoutCarePlansInput>;
};

export type OrganizationUpdateOneRequiredWithoutOrganizationPetParentsNestedInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutOrganizationPetParentsInput>;
  create?: Maybe<OrganizationCreateWithoutOrganizationPetParentsInput>;
  update?: Maybe<OrganizationUpdateToOneWithWhereWithoutOrganizationPetParentsInput>;
  upsert?: Maybe<OrganizationUpsertWithoutOrganizationPetParentsInput>;
};

export type OrganizationUpdateOneRequiredWithoutOrganizationPetsNestedInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutOrganizationPetsInput>;
  create?: Maybe<OrganizationCreateWithoutOrganizationPetsInput>;
  update?: Maybe<OrganizationUpdateToOneWithWhereWithoutOrganizationPetsInput>;
  upsert?: Maybe<OrganizationUpsertWithoutOrganizationPetsInput>;
};

export type OrganizationUpdateOneWithoutAssociatedEncryptedClinicUploadsNestedInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutAssociatedEncryptedClinicUploadsInput>;
  create?: Maybe<OrganizationCreateWithoutAssociatedEncryptedClinicUploadsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OrganizationUpdateToOneWithWhereWithoutAssociatedEncryptedClinicUploadsInput>;
  upsert?: Maybe<OrganizationUpsertWithoutAssociatedEncryptedClinicUploadsInput>;
};

export type OrganizationUpdateOneWithoutCareAddonPackageNestedInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutCareAddonPackageInput>;
  create?: Maybe<OrganizationCreateWithoutCareAddonPackageInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OrganizationUpdateToOneWithWhereWithoutCareAddonPackageInput>;
  upsert?: Maybe<OrganizationUpsertWithoutCareAddonPackageInput>;
};

export type OrganizationUpdateOneWithoutCarePlanProviderGroupsNestedInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutCarePlanProviderGroupsInput>;
  create?: Maybe<OrganizationCreateWithoutCarePlanProviderGroupsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OrganizationUpdateToOneWithWhereWithoutCarePlanProviderGroupsInput>;
  upsert?: Maybe<OrganizationUpsertWithoutCarePlanProviderGroupsInput>;
};

export type OrganizationUpdateOneWithoutClinicsNestedInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutClinicsInput>;
  create?: Maybe<OrganizationCreateWithoutClinicsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OrganizationUpdateToOneWithWhereWithoutClinicsInput>;
  upsert?: Maybe<OrganizationUpsertWithoutClinicsInput>;
};

export type OrganizationUpdateOneWithoutEmailCampaignTemplateNestedInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutEmailCampaignTemplateInput>;
  create?: Maybe<OrganizationCreateWithoutEmailCampaignTemplateInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OrganizationUpdateToOneWithWhereWithoutEmailCampaignTemplateInput>;
  upsert?: Maybe<OrganizationUpsertWithoutEmailCampaignTemplateInput>;
};

export type OrganizationUpdateOneWithoutPaymentProcessorClinicNestedInput = {
  connect?: Maybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: Maybe<OrganizationCreateOrConnectWithoutPaymentProcessorClinicInput>;
  create?: Maybe<OrganizationCreateWithoutPaymentProcessorClinicInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OrganizationUpdateToOneWithWhereWithoutPaymentProcessorClinicInput>;
  upsert?: Maybe<OrganizationUpsertWithoutPaymentProcessorClinicInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutAssociatedEncryptedClinicUploadsInput = {
  data: OrganizationUpdateWithoutAssociatedEncryptedClinicUploadsInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCareAddonPackageInput = {
  data: OrganizationUpdateWithoutCareAddonPackageInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCareBenefitsInput = {
  data: OrganizationUpdateWithoutCareBenefitsInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCarePlanProviderGroupsInput = {
  data: OrganizationUpdateWithoutCarePlanProviderGroupsInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCarePlansInput = {
  data: OrganizationUpdateWithoutCarePlansInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutClinicsInput = {
  data: OrganizationUpdateWithoutClinicsInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutEmailCampaignTemplateInput = {
  data: OrganizationUpdateWithoutEmailCampaignTemplateInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutOrganizationPetParentsInput = {
  data: OrganizationUpdateWithoutOrganizationPetParentsInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutOrganizationPetsInput = {
  data: OrganizationUpdateWithoutOrganizationPetsInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutPaymentProcessorClinicInput = {
  data: OrganizationUpdateWithoutPaymentProcessorClinicInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpdateWithoutAssociatedEncryptedClinicUploadsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutCarePayoutOrganizationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpdateWithoutCareAddonPackageInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutCarePayoutOrganizationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpdateWithoutCareBenefitsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutCarePayoutOrganizationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpdateWithoutCarePlanProviderGroupsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutCarePayoutOrganizationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpdateWithoutCarePlansInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutCarePayoutOrganizationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpdateWithoutClinicsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutCarePayoutOrganizationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpdateWithoutEmailCampaignTemplateInput = {
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutCarePayoutOrganizationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpdateWithoutOrganizationPetParentsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPets?: Maybe<OrganizationPetUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutCarePayoutOrganizationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpdateWithoutOrganizationPetsInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutOrganizationNestedInput>;
  paymentProcessorClinic?: Maybe<ClinicUpdateOneWithoutCarePayoutOrganizationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpdateWithoutPaymentProcessorClinicInput = {
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutOrganizationNestedInput>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutOrganizationNestedInput>;
  careAddonPackage?: Maybe<CareAddonPackageUpdateManyWithoutOrganizationNestedInput>;
  careBenefits?: Maybe<CareBenefitUpdateManyWithoutOrganizationNestedInput>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupUpdateManyWithoutOrganizationNestedInput>;
  carePlans?: Maybe<CarePlanUpdateManyWithoutOrganizationNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutOrganizationNestedInput>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutOrganizationNestedInput>;
  organizationPets?: Maybe<OrganizationPetUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationUpsertWithoutAssociatedEncryptedClinicUploadsInput = {
  create: OrganizationCreateWithoutAssociatedEncryptedClinicUploadsInput;
  update: OrganizationUpdateWithoutAssociatedEncryptedClinicUploadsInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCareAddonPackageInput = {
  create: OrganizationCreateWithoutCareAddonPackageInput;
  update: OrganizationUpdateWithoutCareAddonPackageInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCareBenefitsInput = {
  create: OrganizationCreateWithoutCareBenefitsInput;
  update: OrganizationUpdateWithoutCareBenefitsInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCarePlanProviderGroupsInput = {
  create: OrganizationCreateWithoutCarePlanProviderGroupsInput;
  update: OrganizationUpdateWithoutCarePlanProviderGroupsInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCarePlansInput = {
  create: OrganizationCreateWithoutCarePlansInput;
  update: OrganizationUpdateWithoutCarePlansInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutClinicsInput = {
  create: OrganizationCreateWithoutClinicsInput;
  update: OrganizationUpdateWithoutClinicsInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutEmailCampaignTemplateInput = {
  create: OrganizationCreateWithoutEmailCampaignTemplateInput;
  update: OrganizationUpdateWithoutEmailCampaignTemplateInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutOrganizationPetParentsInput = {
  create: OrganizationCreateWithoutOrganizationPetParentsInput;
  update: OrganizationUpdateWithoutOrganizationPetParentsInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutOrganizationPetsInput = {
  create: OrganizationCreateWithoutOrganizationPetsInput;
  update: OrganizationUpdateWithoutOrganizationPetsInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutPaymentProcessorClinicInput = {
  create: OrganizationCreateWithoutPaymentProcessorClinicInput;
  update: OrganizationUpdateWithoutPaymentProcessorClinicInput;
  where?: Maybe<OrganizationWhereInput>;
};

export type OrganizationWhereInput = {
  AND?: Maybe<Array<OrganizationWhereInput>>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateListRelationFilter>;
  NOT?: Maybe<Array<OrganizationWhereInput>>;
  OR?: Maybe<Array<OrganizationWhereInput>>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadListRelationFilter>;
  careAddonPackage?: Maybe<CareAddonPackageListRelationFilter>;
  careBenefits?: Maybe<CareBenefitListRelationFilter>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupListRelationFilter>;
  carePlans?: Maybe<CarePlanListRelationFilter>;
  clinics?: Maybe<ClinicListRelationFilter>;
  configuration?: Maybe<JsonFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  crmId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  organizationPetParents?: Maybe<OrganizationPetParentListRelationFilter>;
  organizationPets?: Maybe<OrganizationPetListRelationFilter>;
  paymentProcessorClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  paymentProcessorClinicId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type OrganizationWhereUniqueInput = {
  AND?: Maybe<Array<OrganizationWhereInput>>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateListRelationFilter>;
  NOT?: Maybe<Array<OrganizationWhereInput>>;
  OR?: Maybe<Array<OrganizationWhereInput>>;
  associatedEncryptedClinicUploads?: Maybe<EncryptedClinicUploadListRelationFilter>;
  careAddonPackage?: Maybe<CareAddonPackageListRelationFilter>;
  careBenefits?: Maybe<CareBenefitListRelationFilter>;
  carePlanProviderGroups?: Maybe<CarePlanProviderGroupListRelationFilter>;
  carePlans?: Maybe<CarePlanListRelationFilter>;
  clinics?: Maybe<ClinicListRelationFilter>;
  configuration?: Maybe<JsonFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  crmId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentListRelationFilter>;
  organizationPets?: Maybe<OrganizationPetListRelationFilter>;
  paymentProcessorClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  paymentProcessorClinicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

/** @deprecated - 1.0 */
export type OwnerInfo = {
  __typename?: 'OwnerInfo';
  _count: OwnerInfoCountOutputType;
  consultations: Array<Consultation>;
  createdAt: Scalars['DateTime'];
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  pets: Array<Pet>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
};


/** @deprecated - 1.0 */
export type OwnerInfoConsultationsArgs = {
  cursor?: Maybe<ConsultationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationWhereInput>;
};


/** @deprecated - 1.0 */
export type OwnerInfoPetsArgs = {
  cursor?: Maybe<PetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PetWhereInput>;
};


/** @deprecated - 1.0 */
export type OwnerInfoUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type OwnerInfoCountAggregateOutputType = {
  __typename?: 'OwnerInfoCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  customerId: Scalars['Int'];
  firebaseId: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type OwnerInfoCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OwnerInfoCountOutputType = {
  __typename?: 'OwnerInfoCountOutputType';
  consultations: Scalars['Int'];
  pets: Scalars['Int'];
};

export type OwnerInfoCreateInput = {
  consultations?: Maybe<ConsultationCreateNestedManyWithoutPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetCreateNestedManyWithoutPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutOwnerInfoInput>;
};

export type OwnerInfoCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OwnerInfoCreateNestedOneWithoutConsultationsInput = {
  connect?: Maybe<OwnerInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<OwnerInfoCreateOrConnectWithoutConsultationsInput>;
  create?: Maybe<OwnerInfoCreateWithoutConsultationsInput>;
};

export type OwnerInfoCreateNestedOneWithoutPetsInput = {
  connect?: Maybe<OwnerInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<OwnerInfoCreateOrConnectWithoutPetsInput>;
  create?: Maybe<OwnerInfoCreateWithoutPetsInput>;
};

export type OwnerInfoCreateNestedOneWithoutUserInput = {
  connect?: Maybe<OwnerInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<OwnerInfoCreateOrConnectWithoutUserInput>;
  create?: Maybe<OwnerInfoCreateWithoutUserInput>;
};

export type OwnerInfoCreateOrConnectWithoutConsultationsInput = {
  create: OwnerInfoCreateWithoutConsultationsInput;
  where: OwnerInfoWhereUniqueInput;
};

export type OwnerInfoCreateOrConnectWithoutPetsInput = {
  create: OwnerInfoCreateWithoutPetsInput;
  where: OwnerInfoWhereUniqueInput;
};

export type OwnerInfoCreateOrConnectWithoutUserInput = {
  create: OwnerInfoCreateWithoutUserInput;
  where: OwnerInfoWhereUniqueInput;
};

export type OwnerInfoCreateWithoutConsultationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetCreateNestedManyWithoutPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutOwnerInfoInput>;
};

export type OwnerInfoCreateWithoutPetsInput = {
  consultations?: Maybe<ConsultationCreateNestedManyWithoutPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutOwnerInfoInput>;
};

export type OwnerInfoCreateWithoutUserInput = {
  consultations?: Maybe<ConsultationCreateNestedManyWithoutPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetCreateNestedManyWithoutPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OwnerInfoGroupByOutputType = {
  __typename?: 'OwnerInfoGroupByOutputType';
  _count?: Maybe<OwnerInfoCountAggregateOutputType>;
  _max?: Maybe<OwnerInfoMaxAggregateOutputType>;
  _min?: Maybe<OwnerInfoMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type OwnerInfoMaxAggregateOutputType = {
  __typename?: 'OwnerInfoMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OwnerInfoMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OwnerInfoMinAggregateOutputType = {
  __typename?: 'OwnerInfoMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OwnerInfoMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OwnerInfoNullableScalarRelationFilter = {
  AND?: Maybe<Array<OwnerInfoWhereInput>>;
  NOT?: Maybe<Array<OwnerInfoWhereInput>>;
  OR?: Maybe<Array<OwnerInfoWhereInput>>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customerId?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  pets?: Maybe<PetListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
};

export type OwnerInfoOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<OwnerInfoOrderByRelevanceInput>;
  consultations?: Maybe<ConsultationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pets?: Maybe<PetOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
};

export enum OwnerInfoOrderByRelevanceFieldEnum {
  CustomerId = 'customerId',
  FirebaseId = 'firebaseId',
  Id = 'id'
}

export type OwnerInfoOrderByRelevanceInput = {
  fields: Array<OwnerInfoOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type OwnerInfoOrderByWithAggregationInput = {
  _count?: Maybe<OwnerInfoCountOrderByAggregateInput>;
  _max?: Maybe<OwnerInfoMaxOrderByAggregateInput>;
  _min?: Maybe<OwnerInfoMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OwnerInfoOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<OwnerInfoOrderByRelevanceInput>;
  consultations?: Maybe<ConsultationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pets?: Maybe<PetOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
};

export type OwnerInfoOrderByWithRelationInput = {
  _relevance?: Maybe<OwnerInfoOrderByRelevanceInput>;
  consultations?: Maybe<ConsultationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  customerId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pets?: Maybe<PetOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
};

export enum OwnerInfoScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  FirebaseId = 'firebaseId',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type OwnerInfoScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<OwnerInfoScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<OwnerInfoScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<OwnerInfoScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  customerId?: Maybe<StringNullableWithAggregatesFilter>;
  firebaseId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type OwnerInfoUncheckedCreateInput = {
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedOneWithoutOwnerInfoInput>;
};

export type OwnerInfoUncheckedCreateWithoutConsultationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedOneWithoutOwnerInfoInput>;
};

export type OwnerInfoUncheckedCreateWithoutPetsInput = {
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedOneWithoutOwnerInfoInput>;
};

export type OwnerInfoUncheckedCreateWithoutUserInput = {
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutPetParentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetUncheckedCreateNestedManyWithoutPetParentInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OwnerInfoUncheckedUpdateInput = {
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateOneWithoutOwnerInfoNestedInput>;
};

export type OwnerInfoUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OwnerInfoUncheckedUpdateWithoutConsultationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateOneWithoutOwnerInfoNestedInput>;
};

export type OwnerInfoUncheckedUpdateWithoutPetsInput = {
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateOneWithoutOwnerInfoNestedInput>;
};

export type OwnerInfoUncheckedUpdateWithoutUserInput = {
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetUncheckedUpdateManyWithoutPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OwnerInfoUpdateInput = {
  consultations?: Maybe<ConsultationUpdateManyWithoutPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetUpdateManyWithoutPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutOwnerInfoNestedInput>;
};

export type OwnerInfoUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OwnerInfoUpdateOneWithoutConsultationsNestedInput = {
  connect?: Maybe<OwnerInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<OwnerInfoCreateOrConnectWithoutConsultationsInput>;
  create?: Maybe<OwnerInfoCreateWithoutConsultationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OwnerInfoUpdateToOneWithWhereWithoutConsultationsInput>;
  upsert?: Maybe<OwnerInfoUpsertWithoutConsultationsInput>;
};

export type OwnerInfoUpdateOneWithoutPetsNestedInput = {
  connect?: Maybe<OwnerInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<OwnerInfoCreateOrConnectWithoutPetsInput>;
  create?: Maybe<OwnerInfoCreateWithoutPetsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OwnerInfoUpdateToOneWithWhereWithoutPetsInput>;
  upsert?: Maybe<OwnerInfoUpsertWithoutPetsInput>;
};

export type OwnerInfoUpdateOneWithoutUserNestedInput = {
  connect?: Maybe<OwnerInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<OwnerInfoCreateOrConnectWithoutUserInput>;
  create?: Maybe<OwnerInfoCreateWithoutUserInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<OwnerInfoUpdateToOneWithWhereWithoutUserInput>;
  upsert?: Maybe<OwnerInfoUpsertWithoutUserInput>;
};

export type OwnerInfoUpdateToOneWithWhereWithoutConsultationsInput = {
  data: OwnerInfoUpdateWithoutConsultationsInput;
  where?: Maybe<OwnerInfoWhereInput>;
};

export type OwnerInfoUpdateToOneWithWhereWithoutPetsInput = {
  data: OwnerInfoUpdateWithoutPetsInput;
  where?: Maybe<OwnerInfoWhereInput>;
};

export type OwnerInfoUpdateToOneWithWhereWithoutUserInput = {
  data: OwnerInfoUpdateWithoutUserInput;
  where?: Maybe<OwnerInfoWhereInput>;
};

export type OwnerInfoUpdateWithoutConsultationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetUpdateManyWithoutPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutOwnerInfoNestedInput>;
};

export type OwnerInfoUpdateWithoutPetsInput = {
  consultations?: Maybe<ConsultationUpdateManyWithoutPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutOwnerInfoNestedInput>;
};

export type OwnerInfoUpdateWithoutUserInput = {
  consultations?: Maybe<ConsultationUpdateManyWithoutPetParentNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetUpdateManyWithoutPetParentNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OwnerInfoUpsertWithoutConsultationsInput = {
  create: OwnerInfoCreateWithoutConsultationsInput;
  update: OwnerInfoUpdateWithoutConsultationsInput;
  where?: Maybe<OwnerInfoWhereInput>;
};

export type OwnerInfoUpsertWithoutPetsInput = {
  create: OwnerInfoCreateWithoutPetsInput;
  update: OwnerInfoUpdateWithoutPetsInput;
  where?: Maybe<OwnerInfoWhereInput>;
};

export type OwnerInfoUpsertWithoutUserInput = {
  create: OwnerInfoCreateWithoutUserInput;
  update: OwnerInfoUpdateWithoutUserInput;
  where?: Maybe<OwnerInfoWhereInput>;
};

export type OwnerInfoWhereInput = {
  AND?: Maybe<Array<OwnerInfoWhereInput>>;
  NOT?: Maybe<Array<OwnerInfoWhereInput>>;
  OR?: Maybe<Array<OwnerInfoWhereInput>>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customerId?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  pets?: Maybe<PetListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
};

export type OwnerInfoWhereUniqueInput = {
  AND?: Maybe<Array<OwnerInfoWhereInput>>;
  NOT?: Maybe<Array<OwnerInfoWhereInput>>;
  OR?: Maybe<Array<OwnerInfoWhereInput>>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customerId?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pets?: Maybe<PetListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
};

export type PpcIntegration = {
  __typename?: 'PPCIntegration';
  clinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type PpcIntegrationClinicPimsIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type PpcIntegrationCountAggregateOutputType = {
  __typename?: 'PPCIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  ppcClinicId: Scalars['Int'];
  ppcLocationId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PpcIntegrationCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ppcClinicId?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PpcIntegrationCreateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutPpcInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<PpcIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<PpcIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<PpcIntegrationCreateWithoutClinicPimsIntegrationInput>;
};

export type PpcIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput = {
  create: PpcIntegrationCreateWithoutClinicPimsIntegrationInput;
  where: PpcIntegrationWhereUniqueInput;
};

export type PpcIntegrationCreateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationGroupByOutputType = {
  __typename?: 'PPCIntegrationGroupByOutputType';
  _count?: Maybe<PpcIntegrationCountAggregateOutputType>;
  _max?: Maybe<PpcIntegrationMaxAggregateOutputType>;
  _min?: Maybe<PpcIntegrationMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PpcIntegrationMaxAggregateOutputType = {
  __typename?: 'PPCIntegrationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ppcClinicId?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PpcIntegrationMinAggregateOutputType = {
  __typename?: 'PPCIntegrationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ppcClinicId?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PpcIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<PpcIntegrationWhereInput>>;
  NOT?: Maybe<Array<PpcIntegrationWhereInput>>;
  OR?: Maybe<Array<PpcIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  ppcClinicId?: Maybe<StringNullableFilter>;
  ppcLocationId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PpcIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PpcIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ppcClinicId?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PpcIntegrationOrderByRelevanceFieldEnum {
  Id = 'id',
  PpcClinicId = 'ppcClinicId',
  PpcLocationId = 'ppcLocationId'
}

export type PpcIntegrationOrderByRelevanceInput = {
  fields: Array<PpcIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PpcIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<PpcIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<PpcIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<PpcIntegrationMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ppcClinicId?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PpcIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PpcIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ppcClinicId?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PpcIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<PpcIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ppcClinicId?: Maybe<SortOrder>;
  ppcLocationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PpcIntegrationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  PpcClinicId = 'ppcClinicId',
  PpcLocationId = 'ppcLocationId',
  UpdatedAt = 'updatedAt'
}

export type PpcIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PpcIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PpcIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PpcIntegrationScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  ppcClinicId?: Maybe<StringNullableWithAggregatesFilter>;
  ppcLocationId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type PpcIntegrationUncheckedCreateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedOneWithoutPpcInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationUncheckedCreateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationUncheckedUpdateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedUpdateOneWithoutPpcNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationUncheckedUpdateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationUpdateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutPpcNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<PpcIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<PpcIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<PpcIntegrationCreateWithoutClinicPimsIntegrationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PpcIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput>;
  upsert?: Maybe<PpcIntegrationUpsertWithoutClinicPimsIntegrationInput>;
};

export type PpcIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput = {
  data: PpcIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<PpcIntegrationWhereInput>;
};

export type PpcIntegrationUpdateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<Scalars['String']>;
  ppcLocationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PpcIntegrationUpsertWithoutClinicPimsIntegrationInput = {
  create: PpcIntegrationCreateWithoutClinicPimsIntegrationInput;
  update: PpcIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<PpcIntegrationWhereInput>;
};

export type PpcIntegrationWhereInput = {
  AND?: Maybe<Array<PpcIntegrationWhereInput>>;
  NOT?: Maybe<Array<PpcIntegrationWhereInput>>;
  OR?: Maybe<Array<PpcIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  ppcClinicId?: Maybe<StringNullableFilter>;
  ppcLocationId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PpcIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<PpcIntegrationWhereInput>>;
  NOT?: Maybe<Array<PpcIntegrationWhereInput>>;
  OR?: Maybe<Array<PpcIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  ppcClinicId?: Maybe<StringNullableFilter>;
  ppcLocationId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PaymentIntentInput = {
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  create: StripeCreatePaymentInput;
  emailOverride?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceIds?: Maybe<Array<Scalars['String']>>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
};

export enum PaymentMedium {
  StripeOnline = 'StripeOnline',
  StripeTerminal = 'StripeTerminal',
  StripeTerminalApp = 'StripeTerminalApp',
  StripeVirtualTerminal = 'StripeVirtualTerminal'
}

export enum PaymentPimsWritebackAction {
  CareDiscountApplied = 'Care_Discount_Applied',
  PaymentCollected = 'Payment_Collected'
}

export type PaymentPimsWritebackLogEntry = {
  __typename?: 'PaymentPimsWritebackLogEntry';
  action: PaymentPimsWritebackAction;
  payment: StripePaymentIntent;
  paymentId: Scalars['String'];
  writebackLog: PimsWritebackLogEntry;
  writebackLogId: Scalars['String'];
};

export type PaymentPimsWritebackLogEntryCountAggregateOutputType = {
  __typename?: 'PaymentPimsWritebackLogEntryCountAggregateOutputType';
  _all: Scalars['Int'];
  action: Scalars['Int'];
  paymentId: Scalars['Int'];
  writebackLogId: Scalars['Int'];
};

export type PaymentPimsWritebackLogEntryCountOrderByAggregateInput = {
  action?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type PaymentPimsWritebackLogEntryCreateInput = {
  action: PaymentPimsWritebackAction;
  payment: StripePaymentIntentCreateNestedOneWithoutWritebackLogEntriesInput;
  writebackLog: PimsWritebackLogEntryCreateNestedOneWithoutPaymentLogInput;
};

export type PaymentPimsWritebackLogEntryCreateManyInput = {
  action: PaymentPimsWritebackAction;
  paymentId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type PaymentPimsWritebackLogEntryCreateManyPaymentInput = {
  action: PaymentPimsWritebackAction;
  writebackLogId: Scalars['String'];
};

export type PaymentPimsWritebackLogEntryCreateManyPaymentInputEnvelope = {
  data: Array<PaymentPimsWritebackLogEntryCreateManyPaymentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput = {
  connect?: Maybe<Array<PaymentPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PaymentPimsWritebackLogEntryCreateOrConnectWithoutPaymentInput>>;
  create?: Maybe<Array<PaymentPimsWritebackLogEntryCreateWithoutPaymentInput>>;
  createMany?: Maybe<PaymentPimsWritebackLogEntryCreateManyPaymentInputEnvelope>;
};

export type PaymentPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput = {
  connect?: Maybe<PaymentPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PaymentPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<PaymentPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
};

export type PaymentPimsWritebackLogEntryCreateOrConnectWithoutPaymentInput = {
  create: PaymentPimsWritebackLogEntryCreateWithoutPaymentInput;
  where: PaymentPimsWritebackLogEntryWhereUniqueInput;
};

export type PaymentPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput = {
  create: PaymentPimsWritebackLogEntryCreateWithoutWritebackLogInput;
  where: PaymentPimsWritebackLogEntryWhereUniqueInput;
};

export type PaymentPimsWritebackLogEntryCreateWithoutPaymentInput = {
  action: PaymentPimsWritebackAction;
  writebackLog: PimsWritebackLogEntryCreateNestedOneWithoutPaymentLogInput;
};

export type PaymentPimsWritebackLogEntryCreateWithoutWritebackLogInput = {
  action: PaymentPimsWritebackAction;
  payment: StripePaymentIntentCreateNestedOneWithoutWritebackLogEntriesInput;
};

export type PaymentPimsWritebackLogEntryGroupByOutputType = {
  __typename?: 'PaymentPimsWritebackLogEntryGroupByOutputType';
  _count?: Maybe<PaymentPimsWritebackLogEntryCountAggregateOutputType>;
  _max?: Maybe<PaymentPimsWritebackLogEntryMaxAggregateOutputType>;
  _min?: Maybe<PaymentPimsWritebackLogEntryMinAggregateOutputType>;
  action: PaymentPimsWritebackAction;
  paymentId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type PaymentPimsWritebackLogEntryListRelationFilter = {
  every?: Maybe<PaymentPimsWritebackLogEntryWhereInput>;
  none?: Maybe<PaymentPimsWritebackLogEntryWhereInput>;
  some?: Maybe<PaymentPimsWritebackLogEntryWhereInput>;
};

export type PaymentPimsWritebackLogEntryMaxAggregateOutputType = {
  __typename?: 'PaymentPimsWritebackLogEntryMaxAggregateOutputType';
  action?: Maybe<PaymentPimsWritebackAction>;
  paymentId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type PaymentPimsWritebackLogEntryMaxOrderByAggregateInput = {
  action?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type PaymentPimsWritebackLogEntryMinAggregateOutputType = {
  __typename?: 'PaymentPimsWritebackLogEntryMinAggregateOutputType';
  action?: Maybe<PaymentPimsWritebackAction>;
  paymentId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type PaymentPimsWritebackLogEntryMinOrderByAggregateInput = {
  action?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type PaymentPimsWritebackLogEntryNullableScalarRelationFilter = {
  AND?: Maybe<Array<PaymentPimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<PaymentPimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<PaymentPimsWritebackLogEntryWhereInput>>;
  action?: Maybe<EnumPaymentPimsWritebackActionFilter>;
  payment?: Maybe<StripePaymentIntentScalarRelationFilter>;
  paymentId?: Maybe<StringFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type PaymentPimsWritebackLogEntryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PaymentPimsWritebackLogEntryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PaymentPimsWritebackLogEntryOrderByRelevanceInput>;
  action?: Maybe<SortOrder>;
  payment?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  paymentId?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export enum PaymentPimsWritebackLogEntryOrderByRelevanceFieldEnum {
  PaymentId = 'paymentId',
  WritebackLogId = 'writebackLogId'
}

export type PaymentPimsWritebackLogEntryOrderByRelevanceInput = {
  fields: Array<PaymentPimsWritebackLogEntryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PaymentPimsWritebackLogEntryOrderByWithAggregationInput = {
  _count?: Maybe<PaymentPimsWritebackLogEntryCountOrderByAggregateInput>;
  _max?: Maybe<PaymentPimsWritebackLogEntryMaxOrderByAggregateInput>;
  _min?: Maybe<PaymentPimsWritebackLogEntryMinOrderByAggregateInput>;
  action?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  writebackLogId?: Maybe<SortOrder>;
};

export type PaymentPimsWritebackLogEntryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PaymentPimsWritebackLogEntryOrderByRelevanceInput>;
  action?: Maybe<SortOrder>;
  payment?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  paymentId?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export type PaymentPimsWritebackLogEntryOrderByWithRelationInput = {
  _relevance?: Maybe<PaymentPimsWritebackLogEntryOrderByRelevanceInput>;
  action?: Maybe<SortOrder>;
  payment?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  paymentId?: Maybe<SortOrder>;
  writebackLog?: Maybe<PimsWritebackLogEntryOrderByWithRelationInput>;
  writebackLogId?: Maybe<SortOrder>;
};

export enum PaymentPimsWritebackLogEntryScalarFieldEnum {
  Action = 'action',
  PaymentId = 'paymentId',
  WritebackLogId = 'writebackLogId'
}

export type PaymentPimsWritebackLogEntryScalarWhereInput = {
  AND?: Maybe<Array<PaymentPimsWritebackLogEntryScalarWhereInput>>;
  NOT?: Maybe<Array<PaymentPimsWritebackLogEntryScalarWhereInput>>;
  OR?: Maybe<Array<PaymentPimsWritebackLogEntryScalarWhereInput>>;
  action?: Maybe<EnumPaymentPimsWritebackActionFilter>;
  paymentId?: Maybe<StringFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type PaymentPimsWritebackLogEntryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PaymentPimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PaymentPimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PaymentPimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  action?: Maybe<EnumPaymentPimsWritebackActionWithAggregatesFilter>;
  paymentId?: Maybe<StringWithAggregatesFilter>;
  writebackLogId?: Maybe<StringWithAggregatesFilter>;
};

export type PaymentPimsWritebackLogEntryUncheckedCreateInput = {
  action: PaymentPimsWritebackAction;
  paymentId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export type PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput = {
  connect?: Maybe<Array<PaymentPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PaymentPimsWritebackLogEntryCreateOrConnectWithoutPaymentInput>>;
  create?: Maybe<Array<PaymentPimsWritebackLogEntryCreateWithoutPaymentInput>>;
  createMany?: Maybe<PaymentPimsWritebackLogEntryCreateManyPaymentInputEnvelope>;
};

export type PaymentPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput = {
  connect?: Maybe<PaymentPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PaymentPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<PaymentPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
};

export type PaymentPimsWritebackLogEntryUncheckedCreateWithoutPaymentInput = {
  action: PaymentPimsWritebackAction;
  writebackLogId: Scalars['String'];
};

export type PaymentPimsWritebackLogEntryUncheckedCreateWithoutWritebackLogInput = {
  action: PaymentPimsWritebackAction;
  paymentId: Scalars['String'];
};

export type PaymentPimsWritebackLogEntryUncheckedUpdateInput = {
  action?: Maybe<PaymentPimsWritebackAction>;
  paymentId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type PaymentPimsWritebackLogEntryUncheckedUpdateManyInput = {
  action?: Maybe<PaymentPimsWritebackAction>;
  paymentId?: Maybe<Scalars['String']>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentInput = {
  action?: Maybe<PaymentPimsWritebackAction>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput = {
  connect?: Maybe<Array<PaymentPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PaymentPimsWritebackLogEntryCreateOrConnectWithoutPaymentInput>>;
  create?: Maybe<Array<PaymentPimsWritebackLogEntryCreateWithoutPaymentInput>>;
  createMany?: Maybe<PaymentPimsWritebackLogEntryCreateManyPaymentInputEnvelope>;
  delete?: Maybe<Array<PaymentPimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PaymentPimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<PaymentPimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<PaymentPimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<PaymentPimsWritebackLogEntryUpdateWithWhereUniqueWithoutPaymentInput>>;
  updateMany?: Maybe<Array<PaymentPimsWritebackLogEntryUpdateManyWithWhereWithoutPaymentInput>>;
  upsert?: Maybe<Array<PaymentPimsWritebackLogEntryUpsertWithWhereUniqueWithoutPaymentInput>>;
};

export type PaymentPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput = {
  connect?: Maybe<PaymentPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PaymentPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<PaymentPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
  delete?: Maybe<PaymentPimsWritebackLogEntryWhereInput>;
  disconnect?: Maybe<PaymentPimsWritebackLogEntryWhereInput>;
  update?: Maybe<PaymentPimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput>;
  upsert?: Maybe<PaymentPimsWritebackLogEntryUpsertWithoutWritebackLogInput>;
};

export type PaymentPimsWritebackLogEntryUncheckedUpdateWithoutPaymentInput = {
  action?: Maybe<PaymentPimsWritebackAction>;
  writebackLogId?: Maybe<Scalars['String']>;
};

export type PaymentPimsWritebackLogEntryUncheckedUpdateWithoutWritebackLogInput = {
  action?: Maybe<PaymentPimsWritebackAction>;
  paymentId?: Maybe<Scalars['String']>;
};

export type PaymentPimsWritebackLogEntryUpdateInput = {
  action?: Maybe<PaymentPimsWritebackAction>;
  payment?: Maybe<StripePaymentIntentUpdateOneRequiredWithoutWritebackLogEntriesNestedInput>;
  writebackLog?: Maybe<PimsWritebackLogEntryUpdateOneRequiredWithoutPaymentLogNestedInput>;
};

export type PaymentPimsWritebackLogEntryUpdateManyMutationInput = {
  action?: Maybe<PaymentPimsWritebackAction>;
};

export type PaymentPimsWritebackLogEntryUpdateManyWithWhereWithoutPaymentInput = {
  data: PaymentPimsWritebackLogEntryUpdateManyMutationInput;
  where: PaymentPimsWritebackLogEntryScalarWhereInput;
};

export type PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput = {
  connect?: Maybe<Array<PaymentPimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PaymentPimsWritebackLogEntryCreateOrConnectWithoutPaymentInput>>;
  create?: Maybe<Array<PaymentPimsWritebackLogEntryCreateWithoutPaymentInput>>;
  createMany?: Maybe<PaymentPimsWritebackLogEntryCreateManyPaymentInputEnvelope>;
  delete?: Maybe<Array<PaymentPimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PaymentPimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<PaymentPimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<PaymentPimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<PaymentPimsWritebackLogEntryUpdateWithWhereUniqueWithoutPaymentInput>>;
  updateMany?: Maybe<Array<PaymentPimsWritebackLogEntryUpdateManyWithWhereWithoutPaymentInput>>;
  upsert?: Maybe<Array<PaymentPimsWritebackLogEntryUpsertWithWhereUniqueWithoutPaymentInput>>;
};

export type PaymentPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput = {
  connect?: Maybe<PaymentPimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PaymentPimsWritebackLogEntryCreateOrConnectWithoutWritebackLogInput>;
  create?: Maybe<PaymentPimsWritebackLogEntryCreateWithoutWritebackLogInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PaymentPimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput>;
  upsert?: Maybe<PaymentPimsWritebackLogEntryUpsertWithoutWritebackLogInput>;
};

export type PaymentPimsWritebackLogEntryUpdateToOneWithWhereWithoutWritebackLogInput = {
  data: PaymentPimsWritebackLogEntryUpdateWithoutWritebackLogInput;
  where?: Maybe<PaymentPimsWritebackLogEntryWhereInput>;
};

export type PaymentPimsWritebackLogEntryUpdateWithWhereUniqueWithoutPaymentInput = {
  data: PaymentPimsWritebackLogEntryUpdateWithoutPaymentInput;
  where: PaymentPimsWritebackLogEntryWhereUniqueInput;
};

export type PaymentPimsWritebackLogEntryUpdateWithoutPaymentInput = {
  action?: Maybe<PaymentPimsWritebackAction>;
  writebackLog?: Maybe<PimsWritebackLogEntryUpdateOneRequiredWithoutPaymentLogNestedInput>;
};

export type PaymentPimsWritebackLogEntryUpdateWithoutWritebackLogInput = {
  action?: Maybe<PaymentPimsWritebackAction>;
  payment?: Maybe<StripePaymentIntentUpdateOneRequiredWithoutWritebackLogEntriesNestedInput>;
};

export type PaymentPimsWritebackLogEntryUpsertWithWhereUniqueWithoutPaymentInput = {
  create: PaymentPimsWritebackLogEntryCreateWithoutPaymentInput;
  update: PaymentPimsWritebackLogEntryUpdateWithoutPaymentInput;
  where: PaymentPimsWritebackLogEntryWhereUniqueInput;
};

export type PaymentPimsWritebackLogEntryUpsertWithoutWritebackLogInput = {
  create: PaymentPimsWritebackLogEntryCreateWithoutWritebackLogInput;
  update: PaymentPimsWritebackLogEntryUpdateWithoutWritebackLogInput;
  where?: Maybe<PaymentPimsWritebackLogEntryWhereInput>;
};

export type PaymentPimsWritebackLogEntryWhereInput = {
  AND?: Maybe<Array<PaymentPimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<PaymentPimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<PaymentPimsWritebackLogEntryWhereInput>>;
  action?: Maybe<EnumPaymentPimsWritebackActionFilter>;
  payment?: Maybe<StripePaymentIntentScalarRelationFilter>;
  paymentId?: Maybe<StringFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<StringFilter>;
};

export type PaymentPimsWritebackLogEntryWhereUniqueInput = {
  AND?: Maybe<Array<PaymentPimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<PaymentPimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<PaymentPimsWritebackLogEntryWhereInput>>;
  action?: Maybe<EnumPaymentPimsWritebackActionFilter>;
  payment?: Maybe<StripePaymentIntentScalarRelationFilter>;
  paymentId?: Maybe<StringFilter>;
  writebackLog?: Maybe<PimsWritebackLogEntryScalarRelationFilter>;
  writebackLogId?: Maybe<Scalars['String']>;
  writebackLogId_paymentId?: Maybe<PaymentPimsWritebackLogEntryWritebackLogIdPaymentIdCompoundUniqueInput>;
};

export type PaymentPimsWritebackLogEntryWritebackLogIdPaymentIdCompoundUniqueInput = {
  paymentId: Scalars['String'];
  writebackLogId: Scalars['String'];
};

export enum PaymentRelationship {
  AccountBalance = 'AccountBalance',
  CustomAmount = 'CustomAmount'
}

export enum PaymentSchedule {
  Full = 'Full',
  OverTime = 'OverTime'
}

export enum PaymentSource {
  Braintree = 'Braintree',
  Stripe = 'Stripe'
}

export type PaymentsMade = {
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  total: Scalars['Float'];
};

export type PaymentsReportTransaction = {
  __typename?: 'PaymentsReportTransaction';
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  channelId?: Maybe<Scalars['String']>;
  clientFee?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  clientPetParentEmail?: Maybe<Scalars['String']>;
  clientPetParentId?: Maybe<Scalars['String']>;
  clientPimsId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  financialAdjustmentDescription?: Maybe<Scalars['String']>;
  financialAdjustmentId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceIdentifiers?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  netProceeds?: Maybe<Scalars['Int']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  paymentStatus?: Maybe<Scalars['String']>;
  refundReason?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentIntentPaidAt?: Maybe<Scalars['DateTime']>;
  stripePaymentIntentStripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  terminalId?: Maybe<Scalars['String']>;
  terminalName?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
  transactionId: Scalars['String'];
  type: FinancialTransactionType;
  writebackError?: Maybe<NormalizedWritebackError>;
  writebackStatus?: Maybe<PimsWritebackStatus>;
};

export type PaymentsReportTransactionAvgAggregateOutputType = {
  __typename?: 'PaymentsReportTransactionAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  clientFee?: Maybe<Scalars['Float']>;
  netProceeds?: Maybe<Scalars['Float']>;
  refunded?: Maybe<Scalars['Float']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Float']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Float']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Float']>;
  totalInvoiced?: Maybe<Scalars['Float']>;
  transactionFees?: Maybe<Scalars['Float']>;
};

export type PaymentsReportTransactionAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  clientFee?: Maybe<SortOrder>;
  netProceeds?: Maybe<SortOrder>;
  refunded?: Maybe<SortOrder>;
  stripePaymentIntentAmountCaptured?: Maybe<SortOrder>;
  stripePaymentIntentTotalRefunded?: Maybe<SortOrder>;
  stripeRefundPaymentIntentAmount?: Maybe<SortOrder>;
  totalInvoiced?: Maybe<SortOrder>;
  transactionFees?: Maybe<SortOrder>;
};

export type PaymentsReportTransactionCountAggregateOutputType = {
  __typename?: 'PaymentsReportTransactionCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  arrivalDate: Scalars['Int'];
  cardBrand: Scalars['Int'];
  cardType: Scalars['Int'];
  channelId: Scalars['Int'];
  clientFee: Scalars['Int'];
  clientName: Scalars['Int'];
  clientPetParentEmail: Scalars['Int'];
  clientPetParentId: Scalars['Int'];
  clientPimsId: Scalars['Int'];
  clinicId: Scalars['Int'];
  financialAdjustmentDescription: Scalars['Int'];
  financialAdjustmentId: Scalars['Int'];
  invoiceId: Scalars['Int'];
  invoiceIdentifiers: Scalars['Int'];
  last4: Scalars['Int'];
  netProceeds: Scalars['Int'];
  paymentIdentifier: Scalars['Int'];
  paymentMedium: Scalars['Int'];
  paymentRelationship: Scalars['Int'];
  paymentStatus: Scalars['Int'];
  refundReason: Scalars['Int'];
  refunded: Scalars['Int'];
  sentBy: Scalars['Int'];
  stripeDisputeId: Scalars['Int'];
  stripeInvoiceId: Scalars['Int'];
  stripePaymentIntentAmountCaptured: Scalars['Int'];
  stripePaymentIntentId: Scalars['Int'];
  stripePaymentIntentPaidAt: Scalars['Int'];
  stripePaymentIntentStripeId: Scalars['Int'];
  stripePaymentIntentTotalRefunded: Scalars['Int'];
  stripePayoutId: Scalars['Int'];
  stripeReceiptId: Scalars['Int'];
  stripeRefundId: Scalars['Int'];
  stripeRefundPaymentIntentAmount: Scalars['Int'];
  terminalId: Scalars['Int'];
  terminalName: Scalars['Int'];
  timestamp: Scalars['Int'];
  totalInvoiced: Scalars['Int'];
  transactionFees: Scalars['Int'];
  transactionId: Scalars['Int'];
  type: Scalars['Int'];
  writebackError: Scalars['Int'];
  writebackStatus: Scalars['Int'];
};

export type PaymentsReportTransactionCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  cardBrand?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clientFee?: Maybe<SortOrder>;
  clientName?: Maybe<SortOrder>;
  clientPetParentEmail?: Maybe<SortOrder>;
  clientPetParentId?: Maybe<SortOrder>;
  clientPimsId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  financialAdjustmentDescription?: Maybe<SortOrder>;
  financialAdjustmentId?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  invoiceIdentifiers?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  netProceeds?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  refundReason?: Maybe<SortOrder>;
  refunded?: Maybe<SortOrder>;
  sentBy?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntentAmountCaptured?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePaymentIntentPaidAt?: Maybe<SortOrder>;
  stripePaymentIntentStripeId?: Maybe<SortOrder>;
  stripePaymentIntentTotalRefunded?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  stripeRefundPaymentIntentAmount?: Maybe<SortOrder>;
  terminalId?: Maybe<SortOrder>;
  terminalName?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  totalInvoiced?: Maybe<SortOrder>;
  transactionFees?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  writebackError?: Maybe<SortOrder>;
  writebackStatus?: Maybe<SortOrder>;
};

export type PaymentsReportTransactionCreateInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  channelId?: Maybe<Scalars['String']>;
  clientFee?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  clientPetParentEmail?: Maybe<Scalars['String']>;
  clientPetParentId?: Maybe<Scalars['String']>;
  clientPimsId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  financialAdjustmentDescription?: Maybe<Scalars['String']>;
  financialAdjustmentId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceIdentifiers?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  netProceeds?: Maybe<Scalars['Int']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  paymentStatus?: Maybe<Scalars['String']>;
  refundReason?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentIntentPaidAt?: Maybe<Scalars['DateTime']>;
  stripePaymentIntentStripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  terminalId?: Maybe<Scalars['String']>;
  terminalName?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
  transactionId: Scalars['String'];
  type: FinancialTransactionType;
  writebackError?: Maybe<NormalizedWritebackError>;
  writebackStatus?: Maybe<PimsWritebackStatus>;
};

export type PaymentsReportTransactionCreateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  channelId?: Maybe<Scalars['String']>;
  clientFee?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  clientPetParentEmail?: Maybe<Scalars['String']>;
  clientPetParentId?: Maybe<Scalars['String']>;
  clientPimsId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  financialAdjustmentDescription?: Maybe<Scalars['String']>;
  financialAdjustmentId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceIdentifiers?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  netProceeds?: Maybe<Scalars['Int']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  paymentStatus?: Maybe<Scalars['String']>;
  refundReason?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentIntentPaidAt?: Maybe<Scalars['DateTime']>;
  stripePaymentIntentStripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  terminalId?: Maybe<Scalars['String']>;
  terminalName?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
  transactionId: Scalars['String'];
  type: FinancialTransactionType;
  writebackError?: Maybe<NormalizedWritebackError>;
  writebackStatus?: Maybe<PimsWritebackStatus>;
};

export type PaymentsReportTransactionGroupByOutputType = {
  __typename?: 'PaymentsReportTransactionGroupByOutputType';
  _avg?: Maybe<PaymentsReportTransactionAvgAggregateOutputType>;
  _count?: Maybe<PaymentsReportTransactionCountAggregateOutputType>;
  _max?: Maybe<PaymentsReportTransactionMaxAggregateOutputType>;
  _min?: Maybe<PaymentsReportTransactionMinAggregateOutputType>;
  _sum?: Maybe<PaymentsReportTransactionSumAggregateOutputType>;
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  channelId?: Maybe<Scalars['String']>;
  clientFee?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  clientPetParentEmail?: Maybe<Scalars['String']>;
  clientPetParentId?: Maybe<Scalars['String']>;
  clientPimsId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  financialAdjustmentDescription?: Maybe<Scalars['String']>;
  financialAdjustmentId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceIdentifiers?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  netProceeds?: Maybe<Scalars['Int']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  paymentStatus?: Maybe<Scalars['String']>;
  refundReason?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentIntentPaidAt?: Maybe<Scalars['DateTime']>;
  stripePaymentIntentStripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  terminalId?: Maybe<Scalars['String']>;
  terminalName?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
  transactionId: Scalars['String'];
  type: FinancialTransactionType;
  writebackError?: Maybe<NormalizedWritebackError>;
  writebackStatus?: Maybe<PimsWritebackStatus>;
};

export type PaymentsReportTransactionMaxAggregateOutputType = {
  __typename?: 'PaymentsReportTransactionMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  channelId?: Maybe<Scalars['String']>;
  clientFee?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  clientPetParentEmail?: Maybe<Scalars['String']>;
  clientPetParentId?: Maybe<Scalars['String']>;
  clientPimsId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  financialAdjustmentDescription?: Maybe<Scalars['String']>;
  financialAdjustmentId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceIdentifiers?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  netProceeds?: Maybe<Scalars['Int']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  paymentStatus?: Maybe<Scalars['String']>;
  refundReason?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentIntentPaidAt?: Maybe<Scalars['DateTime']>;
  stripePaymentIntentStripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  terminalId?: Maybe<Scalars['String']>;
  terminalName?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
  transactionId?: Maybe<Scalars['String']>;
  type?: Maybe<FinancialTransactionType>;
  writebackError?: Maybe<NormalizedWritebackError>;
  writebackStatus?: Maybe<PimsWritebackStatus>;
};

export type PaymentsReportTransactionMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  cardBrand?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clientFee?: Maybe<SortOrder>;
  clientName?: Maybe<SortOrder>;
  clientPetParentEmail?: Maybe<SortOrder>;
  clientPetParentId?: Maybe<SortOrder>;
  clientPimsId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  financialAdjustmentDescription?: Maybe<SortOrder>;
  financialAdjustmentId?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  invoiceIdentifiers?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  netProceeds?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  refundReason?: Maybe<SortOrder>;
  refunded?: Maybe<SortOrder>;
  sentBy?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntentAmountCaptured?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePaymentIntentPaidAt?: Maybe<SortOrder>;
  stripePaymentIntentStripeId?: Maybe<SortOrder>;
  stripePaymentIntentTotalRefunded?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  stripeRefundPaymentIntentAmount?: Maybe<SortOrder>;
  terminalId?: Maybe<SortOrder>;
  terminalName?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  totalInvoiced?: Maybe<SortOrder>;
  transactionFees?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  writebackError?: Maybe<SortOrder>;
  writebackStatus?: Maybe<SortOrder>;
};

export type PaymentsReportTransactionMinAggregateOutputType = {
  __typename?: 'PaymentsReportTransactionMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  channelId?: Maybe<Scalars['String']>;
  clientFee?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  clientPetParentEmail?: Maybe<Scalars['String']>;
  clientPetParentId?: Maybe<Scalars['String']>;
  clientPimsId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  financialAdjustmentDescription?: Maybe<Scalars['String']>;
  financialAdjustmentId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceIdentifiers?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  netProceeds?: Maybe<Scalars['Int']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  paymentStatus?: Maybe<Scalars['String']>;
  refundReason?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentIntentPaidAt?: Maybe<Scalars['DateTime']>;
  stripePaymentIntentStripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  terminalId?: Maybe<Scalars['String']>;
  terminalName?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
  transactionId?: Maybe<Scalars['String']>;
  type?: Maybe<FinancialTransactionType>;
  writebackError?: Maybe<NormalizedWritebackError>;
  writebackStatus?: Maybe<PimsWritebackStatus>;
};

export type PaymentsReportTransactionMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  cardBrand?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clientFee?: Maybe<SortOrder>;
  clientName?: Maybe<SortOrder>;
  clientPetParentEmail?: Maybe<SortOrder>;
  clientPetParentId?: Maybe<SortOrder>;
  clientPimsId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  financialAdjustmentDescription?: Maybe<SortOrder>;
  financialAdjustmentId?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  invoiceIdentifiers?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  netProceeds?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  refundReason?: Maybe<SortOrder>;
  refunded?: Maybe<SortOrder>;
  sentBy?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntentAmountCaptured?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePaymentIntentPaidAt?: Maybe<SortOrder>;
  stripePaymentIntentStripeId?: Maybe<SortOrder>;
  stripePaymentIntentTotalRefunded?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  stripeRefundPaymentIntentAmount?: Maybe<SortOrder>;
  terminalId?: Maybe<SortOrder>;
  terminalName?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  totalInvoiced?: Maybe<SortOrder>;
  transactionFees?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  writebackError?: Maybe<SortOrder>;
  writebackStatus?: Maybe<SortOrder>;
};

export type PaymentsReportTransactionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PaymentsReportTransactionOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  cardBrand?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clientFee?: Maybe<SortOrder>;
  clientName?: Maybe<SortOrder>;
  clientPetParentEmail?: Maybe<SortOrder>;
  clientPetParentId?: Maybe<SortOrder>;
  clientPimsId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  financialAdjustmentDescription?: Maybe<SortOrder>;
  financialAdjustmentId?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  invoiceIdentifiers?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  netProceeds?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  refundReason?: Maybe<SortOrder>;
  refunded?: Maybe<SortOrder>;
  sentBy?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntentAmountCaptured?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePaymentIntentPaidAt?: Maybe<SortOrder>;
  stripePaymentIntentStripeId?: Maybe<SortOrder>;
  stripePaymentIntentTotalRefunded?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  stripeRefundPaymentIntentAmount?: Maybe<SortOrder>;
  terminalId?: Maybe<SortOrder>;
  terminalName?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  totalInvoiced?: Maybe<SortOrder>;
  transactionFees?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  writebackError?: Maybe<SortOrder>;
  writebackStatus?: Maybe<SortOrder>;
};

export enum PaymentsReportTransactionOrderByRelevanceFieldEnum {
  ChannelId = 'channelId',
  ClientName = 'clientName',
  ClientPetParentEmail = 'clientPetParentEmail',
  ClientPetParentId = 'clientPetParentId',
  ClientPimsId = 'clientPimsId',
  ClinicId = 'clinicId',
  FinancialAdjustmentDescription = 'financialAdjustmentDescription',
  FinancialAdjustmentId = 'financialAdjustmentId',
  InvoiceId = 'invoiceId',
  InvoiceIdentifiers = 'invoiceIdentifiers',
  Last4 = 'last4',
  PaymentIdentifier = 'paymentIdentifier',
  PaymentMedium = 'paymentMedium',
  PaymentStatus = 'paymentStatus',
  RefundReason = 'refundReason',
  SentBy = 'sentBy',
  StripeDisputeId = 'stripeDisputeId',
  StripeInvoiceId = 'stripeInvoiceId',
  StripePaymentIntentId = 'stripePaymentIntentId',
  StripePaymentIntentStripeId = 'stripePaymentIntentStripeId',
  StripePayoutId = 'stripePayoutId',
  StripeReceiptId = 'stripeReceiptId',
  StripeRefundId = 'stripeRefundId',
  TerminalId = 'terminalId',
  TerminalName = 'terminalName',
  TransactionId = 'transactionId'
}

export type PaymentsReportTransactionOrderByRelevanceInput = {
  fields: Array<PaymentsReportTransactionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PaymentsReportTransactionOrderByWithAggregationInput = {
  _avg?: Maybe<PaymentsReportTransactionAvgOrderByAggregateInput>;
  _count?: Maybe<PaymentsReportTransactionCountOrderByAggregateInput>;
  _max?: Maybe<PaymentsReportTransactionMaxOrderByAggregateInput>;
  _min?: Maybe<PaymentsReportTransactionMinOrderByAggregateInput>;
  _sum?: Maybe<PaymentsReportTransactionSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  cardBrand?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clientFee?: Maybe<SortOrder>;
  clientName?: Maybe<SortOrder>;
  clientPetParentEmail?: Maybe<SortOrder>;
  clientPetParentId?: Maybe<SortOrder>;
  clientPimsId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  financialAdjustmentDescription?: Maybe<SortOrder>;
  financialAdjustmentId?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  invoiceIdentifiers?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  netProceeds?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  refundReason?: Maybe<SortOrder>;
  refunded?: Maybe<SortOrder>;
  sentBy?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntentAmountCaptured?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePaymentIntentPaidAt?: Maybe<SortOrder>;
  stripePaymentIntentStripeId?: Maybe<SortOrder>;
  stripePaymentIntentTotalRefunded?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  stripeRefundPaymentIntentAmount?: Maybe<SortOrder>;
  terminalId?: Maybe<SortOrder>;
  terminalName?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  totalInvoiced?: Maybe<SortOrder>;
  transactionFees?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  writebackError?: Maybe<SortOrder>;
  writebackStatus?: Maybe<SortOrder>;
};

export type PaymentsReportTransactionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PaymentsReportTransactionOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  cardBrand?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clientFee?: Maybe<SortOrder>;
  clientName?: Maybe<SortOrder>;
  clientPetParentEmail?: Maybe<SortOrder>;
  clientPetParentId?: Maybe<SortOrder>;
  clientPimsId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  financialAdjustmentDescription?: Maybe<SortOrder>;
  financialAdjustmentId?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  invoiceIdentifiers?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  netProceeds?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  refundReason?: Maybe<SortOrder>;
  refunded?: Maybe<SortOrder>;
  sentBy?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntentAmountCaptured?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePaymentIntentPaidAt?: Maybe<SortOrder>;
  stripePaymentIntentStripeId?: Maybe<SortOrder>;
  stripePaymentIntentTotalRefunded?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  stripeRefundPaymentIntentAmount?: Maybe<SortOrder>;
  terminalId?: Maybe<SortOrder>;
  terminalName?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  totalInvoiced?: Maybe<SortOrder>;
  transactionFees?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  writebackError?: Maybe<SortOrder>;
  writebackStatus?: Maybe<SortOrder>;
};

export type PaymentsReportTransactionOrderByWithRelationInput = {
  _relevance?: Maybe<PaymentsReportTransactionOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  cardBrand?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  channelId?: Maybe<SortOrder>;
  clientFee?: Maybe<SortOrder>;
  clientName?: Maybe<SortOrder>;
  clientPetParentEmail?: Maybe<SortOrder>;
  clientPetParentId?: Maybe<SortOrder>;
  clientPimsId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  financialAdjustmentDescription?: Maybe<SortOrder>;
  financialAdjustmentId?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  invoiceIdentifiers?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  netProceeds?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  paymentStatus?: Maybe<SortOrder>;
  refundReason?: Maybe<SortOrder>;
  refunded?: Maybe<SortOrder>;
  sentBy?: Maybe<SortOrder>;
  stripeDisputeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripePaymentIntentAmountCaptured?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePaymentIntentPaidAt?: Maybe<SortOrder>;
  stripePaymentIntentStripeId?: Maybe<SortOrder>;
  stripePaymentIntentTotalRefunded?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  stripeRefundPaymentIntentAmount?: Maybe<SortOrder>;
  terminalId?: Maybe<SortOrder>;
  terminalName?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  totalInvoiced?: Maybe<SortOrder>;
  transactionFees?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  writebackError?: Maybe<SortOrder>;
  writebackStatus?: Maybe<SortOrder>;
};

export enum PaymentsReportTransactionScalarFieldEnum {
  Amount = 'amount',
  ArrivalDate = 'arrivalDate',
  CardBrand = 'cardBrand',
  CardType = 'cardType',
  ChannelId = 'channelId',
  ClientFee = 'clientFee',
  ClientName = 'clientName',
  ClientPetParentEmail = 'clientPetParentEmail',
  ClientPetParentId = 'clientPetParentId',
  ClientPimsId = 'clientPimsId',
  ClinicId = 'clinicId',
  FinancialAdjustmentDescription = 'financialAdjustmentDescription',
  FinancialAdjustmentId = 'financialAdjustmentId',
  InvoiceId = 'invoiceId',
  InvoiceIdentifiers = 'invoiceIdentifiers',
  Last4 = 'last4',
  NetProceeds = 'netProceeds',
  PaymentIdentifier = 'paymentIdentifier',
  PaymentMedium = 'paymentMedium',
  PaymentRelationship = 'paymentRelationship',
  PaymentStatus = 'paymentStatus',
  RefundReason = 'refundReason',
  Refunded = 'refunded',
  SentBy = 'sentBy',
  StripeDisputeId = 'stripeDisputeId',
  StripeInvoiceId = 'stripeInvoiceId',
  StripePaymentIntentAmountCaptured = 'stripePaymentIntentAmountCaptured',
  StripePaymentIntentId = 'stripePaymentIntentId',
  StripePaymentIntentPaidAt = 'stripePaymentIntentPaidAt',
  StripePaymentIntentStripeId = 'stripePaymentIntentStripeId',
  StripePaymentIntentTotalRefunded = 'stripePaymentIntentTotalRefunded',
  StripePayoutId = 'stripePayoutId',
  StripeReceiptId = 'stripeReceiptId',
  StripeRefundId = 'stripeRefundId',
  StripeRefundPaymentIntentAmount = 'stripeRefundPaymentIntentAmount',
  TerminalId = 'terminalId',
  TerminalName = 'terminalName',
  Timestamp = 'timestamp',
  TotalInvoiced = 'totalInvoiced',
  TransactionFees = 'transactionFees',
  TransactionId = 'transactionId',
  Type = 'type',
  WritebackError = 'writebackError',
  WritebackStatus = 'writebackStatus'
}

export type PaymentsReportTransactionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PaymentsReportTransactionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PaymentsReportTransactionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PaymentsReportTransactionScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntNullableWithAggregatesFilter>;
  arrivalDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  cardBrand?: Maybe<EnumCardBrandNullableWithAggregatesFilter>;
  cardType?: Maybe<EnumCardFundingNullableWithAggregatesFilter>;
  channelId?: Maybe<StringNullableWithAggregatesFilter>;
  clientFee?: Maybe<IntNullableWithAggregatesFilter>;
  clientName?: Maybe<StringNullableWithAggregatesFilter>;
  clientPetParentEmail?: Maybe<StringNullableWithAggregatesFilter>;
  clientPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  clientPimsId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  financialAdjustmentDescription?: Maybe<StringNullableWithAggregatesFilter>;
  financialAdjustmentId?: Maybe<StringNullableWithAggregatesFilter>;
  invoiceId?: Maybe<StringNullableWithAggregatesFilter>;
  invoiceIdentifiers?: Maybe<StringNullableWithAggregatesFilter>;
  last4?: Maybe<StringNullableWithAggregatesFilter>;
  netProceeds?: Maybe<IntNullableWithAggregatesFilter>;
  paymentIdentifier?: Maybe<StringNullableWithAggregatesFilter>;
  paymentMedium?: Maybe<StringNullableWithAggregatesFilter>;
  paymentRelationship?: Maybe<EnumPaymentRelationshipNullableWithAggregatesFilter>;
  paymentStatus?: Maybe<StringNullableWithAggregatesFilter>;
  refundReason?: Maybe<StringNullableWithAggregatesFilter>;
  refunded?: Maybe<IntNullableWithAggregatesFilter>;
  sentBy?: Maybe<StringNullableWithAggregatesFilter>;
  stripeDisputeId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeInvoiceId?: Maybe<StringNullableWithAggregatesFilter>;
  stripePaymentIntentAmountCaptured?: Maybe<IntNullableWithAggregatesFilter>;
  stripePaymentIntentId?: Maybe<StringNullableWithAggregatesFilter>;
  stripePaymentIntentPaidAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  stripePaymentIntentStripeId?: Maybe<StringNullableWithAggregatesFilter>;
  stripePaymentIntentTotalRefunded?: Maybe<IntNullableWithAggregatesFilter>;
  stripePayoutId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeReceiptId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeRefundId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeRefundPaymentIntentAmount?: Maybe<IntNullableWithAggregatesFilter>;
  terminalId?: Maybe<StringNullableWithAggregatesFilter>;
  terminalName?: Maybe<StringNullableWithAggregatesFilter>;
  timestamp?: Maybe<DateTimeWithAggregatesFilter>;
  totalInvoiced?: Maybe<IntNullableWithAggregatesFilter>;
  transactionFees?: Maybe<IntNullableWithAggregatesFilter>;
  transactionId?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumFinancialTransactionTypeWithAggregatesFilter>;
  writebackError?: Maybe<EnumNormalizedWritebackErrorNullableWithAggregatesFilter>;
  writebackStatus?: Maybe<EnumPimsWritebackStatusNullableWithAggregatesFilter>;
};

export type PaymentsReportTransactionSumAggregateOutputType = {
  __typename?: 'PaymentsReportTransactionSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  clientFee?: Maybe<Scalars['Int']>;
  netProceeds?: Maybe<Scalars['Int']>;
  refunded?: Maybe<Scalars['Int']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
};

export type PaymentsReportTransactionSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  clientFee?: Maybe<SortOrder>;
  netProceeds?: Maybe<SortOrder>;
  refunded?: Maybe<SortOrder>;
  stripePaymentIntentAmountCaptured?: Maybe<SortOrder>;
  stripePaymentIntentTotalRefunded?: Maybe<SortOrder>;
  stripeRefundPaymentIntentAmount?: Maybe<SortOrder>;
  totalInvoiced?: Maybe<SortOrder>;
  transactionFees?: Maybe<SortOrder>;
};

export type PaymentsReportTransactionUncheckedCreateInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  channelId?: Maybe<Scalars['String']>;
  clientFee?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  clientPetParentEmail?: Maybe<Scalars['String']>;
  clientPetParentId?: Maybe<Scalars['String']>;
  clientPimsId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  financialAdjustmentDescription?: Maybe<Scalars['String']>;
  financialAdjustmentId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceIdentifiers?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  netProceeds?: Maybe<Scalars['Int']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  paymentStatus?: Maybe<Scalars['String']>;
  refundReason?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentIntentPaidAt?: Maybe<Scalars['DateTime']>;
  stripePaymentIntentStripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  terminalId?: Maybe<Scalars['String']>;
  terminalName?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
  transactionId: Scalars['String'];
  type: FinancialTransactionType;
  writebackError?: Maybe<NormalizedWritebackError>;
  writebackStatus?: Maybe<PimsWritebackStatus>;
};

export type PaymentsReportTransactionUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  channelId?: Maybe<Scalars['String']>;
  clientFee?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  clientPetParentEmail?: Maybe<Scalars['String']>;
  clientPetParentId?: Maybe<Scalars['String']>;
  clientPimsId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  financialAdjustmentDescription?: Maybe<Scalars['String']>;
  financialAdjustmentId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceIdentifiers?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  netProceeds?: Maybe<Scalars['Int']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  paymentStatus?: Maybe<Scalars['String']>;
  refundReason?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentIntentPaidAt?: Maybe<Scalars['DateTime']>;
  stripePaymentIntentStripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  terminalId?: Maybe<Scalars['String']>;
  terminalName?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
  transactionId?: Maybe<Scalars['String']>;
  type?: Maybe<FinancialTransactionType>;
  writebackError?: Maybe<NormalizedWritebackError>;
  writebackStatus?: Maybe<PimsWritebackStatus>;
};

export type PaymentsReportTransactionUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  channelId?: Maybe<Scalars['String']>;
  clientFee?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  clientPetParentEmail?: Maybe<Scalars['String']>;
  clientPetParentId?: Maybe<Scalars['String']>;
  clientPimsId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  financialAdjustmentDescription?: Maybe<Scalars['String']>;
  financialAdjustmentId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceIdentifiers?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  netProceeds?: Maybe<Scalars['Int']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  paymentStatus?: Maybe<Scalars['String']>;
  refundReason?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentIntentPaidAt?: Maybe<Scalars['DateTime']>;
  stripePaymentIntentStripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  terminalId?: Maybe<Scalars['String']>;
  terminalName?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
  transactionId?: Maybe<Scalars['String']>;
  type?: Maybe<FinancialTransactionType>;
  writebackError?: Maybe<NormalizedWritebackError>;
  writebackStatus?: Maybe<PimsWritebackStatus>;
};

export type PaymentsReportTransactionUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  channelId?: Maybe<Scalars['String']>;
  clientFee?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  clientPetParentEmail?: Maybe<Scalars['String']>;
  clientPetParentId?: Maybe<Scalars['String']>;
  clientPimsId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  financialAdjustmentDescription?: Maybe<Scalars['String']>;
  financialAdjustmentId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceIdentifiers?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  netProceeds?: Maybe<Scalars['Int']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  paymentStatus?: Maybe<Scalars['String']>;
  refundReason?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentIntentPaidAt?: Maybe<Scalars['DateTime']>;
  stripePaymentIntentStripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  terminalId?: Maybe<Scalars['String']>;
  terminalName?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
  transactionId?: Maybe<Scalars['String']>;
  type?: Maybe<FinancialTransactionType>;
  writebackError?: Maybe<NormalizedWritebackError>;
  writebackStatus?: Maybe<PimsWritebackStatus>;
};

export type PaymentsReportTransactionUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  cardBrand?: Maybe<CardBrand>;
  cardType?: Maybe<CardFunding>;
  channelId?: Maybe<Scalars['String']>;
  clientFee?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  clientPetParentEmail?: Maybe<Scalars['String']>;
  clientPetParentId?: Maybe<Scalars['String']>;
  clientPimsId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  financialAdjustmentDescription?: Maybe<Scalars['String']>;
  financialAdjustmentId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceIdentifiers?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  netProceeds?: Maybe<Scalars['Int']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  paymentStatus?: Maybe<Scalars['String']>;
  refundReason?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<Scalars['String']>;
  stripeDisputeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentAmountCaptured?: Maybe<Scalars['Int']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentIntentPaidAt?: Maybe<Scalars['DateTime']>;
  stripePaymentIntentStripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentTotalRefunded?: Maybe<Scalars['Int']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundPaymentIntentAmount?: Maybe<Scalars['Int']>;
  terminalId?: Maybe<Scalars['String']>;
  terminalName?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  totalInvoiced?: Maybe<Scalars['Int']>;
  transactionFees?: Maybe<Scalars['Int']>;
  transactionId?: Maybe<Scalars['String']>;
  type?: Maybe<FinancialTransactionType>;
  writebackError?: Maybe<NormalizedWritebackError>;
  writebackStatus?: Maybe<PimsWritebackStatus>;
};

export type PaymentsReportTransactionWhereInput = {
  AND?: Maybe<Array<PaymentsReportTransactionWhereInput>>;
  NOT?: Maybe<Array<PaymentsReportTransactionWhereInput>>;
  OR?: Maybe<Array<PaymentsReportTransactionWhereInput>>;
  amount?: Maybe<IntNullableFilter>;
  arrivalDate?: Maybe<DateTimeNullableFilter>;
  cardBrand?: Maybe<EnumCardBrandNullableFilter>;
  cardType?: Maybe<EnumCardFundingNullableFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clientFee?: Maybe<IntNullableFilter>;
  clientName?: Maybe<StringNullableFilter>;
  clientPetParentEmail?: Maybe<StringNullableFilter>;
  clientPetParentId?: Maybe<StringNullableFilter>;
  clientPimsId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  financialAdjustmentDescription?: Maybe<StringNullableFilter>;
  financialAdjustmentId?: Maybe<StringNullableFilter>;
  invoiceId?: Maybe<StringNullableFilter>;
  invoiceIdentifiers?: Maybe<StringNullableFilter>;
  last4?: Maybe<StringNullableFilter>;
  netProceeds?: Maybe<IntNullableFilter>;
  paymentIdentifier?: Maybe<StringNullableFilter>;
  paymentMedium?: Maybe<StringNullableFilter>;
  paymentRelationship?: Maybe<EnumPaymentRelationshipNullableFilter>;
  paymentStatus?: Maybe<StringNullableFilter>;
  refundReason?: Maybe<StringNullableFilter>;
  refunded?: Maybe<IntNullableFilter>;
  sentBy?: Maybe<StringNullableFilter>;
  stripeDisputeId?: Maybe<StringNullableFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripePaymentIntentAmountCaptured?: Maybe<IntNullableFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePaymentIntentPaidAt?: Maybe<DateTimeNullableFilter>;
  stripePaymentIntentStripeId?: Maybe<StringNullableFilter>;
  stripePaymentIntentTotalRefunded?: Maybe<IntNullableFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeReceiptId?: Maybe<StringNullableFilter>;
  stripeRefundId?: Maybe<StringNullableFilter>;
  stripeRefundPaymentIntentAmount?: Maybe<IntNullableFilter>;
  terminalId?: Maybe<StringNullableFilter>;
  terminalName?: Maybe<StringNullableFilter>;
  timestamp?: Maybe<DateTimeFilter>;
  totalInvoiced?: Maybe<IntNullableFilter>;
  transactionFees?: Maybe<IntNullableFilter>;
  transactionId?: Maybe<StringFilter>;
  type?: Maybe<EnumFinancialTransactionTypeFilter>;
  writebackError?: Maybe<EnumNormalizedWritebackErrorNullableFilter>;
  writebackStatus?: Maybe<EnumPimsWritebackStatusNullableFilter>;
};

export type PaymentsReportTransactionWhereUniqueInput = {
  AND?: Maybe<Array<PaymentsReportTransactionWhereInput>>;
  NOT?: Maybe<Array<PaymentsReportTransactionWhereInput>>;
  OR?: Maybe<Array<PaymentsReportTransactionWhereInput>>;
  amount?: Maybe<IntNullableFilter>;
  arrivalDate?: Maybe<DateTimeNullableFilter>;
  cardBrand?: Maybe<EnumCardBrandNullableFilter>;
  cardType?: Maybe<EnumCardFundingNullableFilter>;
  channelId?: Maybe<StringNullableFilter>;
  clientFee?: Maybe<IntNullableFilter>;
  clientName?: Maybe<StringNullableFilter>;
  clientPetParentEmail?: Maybe<StringNullableFilter>;
  clientPetParentId?: Maybe<StringNullableFilter>;
  clientPimsId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  financialAdjustmentDescription?: Maybe<StringNullableFilter>;
  financialAdjustmentId?: Maybe<StringNullableFilter>;
  invoiceId?: Maybe<StringNullableFilter>;
  invoiceIdentifiers?: Maybe<StringNullableFilter>;
  last4?: Maybe<StringNullableFilter>;
  netProceeds?: Maybe<IntNullableFilter>;
  paymentIdentifier?: Maybe<StringNullableFilter>;
  paymentMedium?: Maybe<StringNullableFilter>;
  paymentRelationship?: Maybe<EnumPaymentRelationshipNullableFilter>;
  paymentStatus?: Maybe<StringNullableFilter>;
  refundReason?: Maybe<StringNullableFilter>;
  refunded?: Maybe<IntNullableFilter>;
  sentBy?: Maybe<StringNullableFilter>;
  stripeDisputeId?: Maybe<StringNullableFilter>;
  stripeInvoiceId?: Maybe<StringNullableFilter>;
  stripePaymentIntentAmountCaptured?: Maybe<IntNullableFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePaymentIntentPaidAt?: Maybe<DateTimeNullableFilter>;
  stripePaymentIntentStripeId?: Maybe<StringNullableFilter>;
  stripePaymentIntentTotalRefunded?: Maybe<IntNullableFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeReceiptId?: Maybe<StringNullableFilter>;
  stripeRefundId?: Maybe<StringNullableFilter>;
  stripeRefundPaymentIntentAmount?: Maybe<IntNullableFilter>;
  terminalId?: Maybe<StringNullableFilter>;
  terminalName?: Maybe<StringNullableFilter>;
  timestamp?: Maybe<DateTimeFilter>;
  totalInvoiced?: Maybe<IntNullableFilter>;
  transactionFees?: Maybe<IntNullableFilter>;
  transactionId?: Maybe<Scalars['String']>;
  type?: Maybe<EnumFinancialTransactionTypeFilter>;
  writebackError?: Maybe<EnumNormalizedWritebackErrorNullableFilter>;
  writebackStatus?: Maybe<EnumPimsWritebackStatusNullableFilter>;
};

export type PayoutBatchingPeriod = {
  __typename?: 'PayoutBatchingPeriod';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  id: Scalars['String'];
  startsAt: Scalars['DateTime'];
  stripePayout?: Maybe<StripePayout>;
  updatedAt: Scalars['DateTime'];
};


export type PayoutBatchingPeriodCreatedByUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type PayoutBatchingPeriodStripePayoutArgs = {
  where?: Maybe<StripePayoutWhereInput>;
};

export type PayoutBatchingPeriodClinicIdStartsAtEndsAtCompoundUniqueInput = {
  clinicId: Scalars['String'];
  endsAt: Scalars['DateTime'];
  startsAt: Scalars['DateTime'];
};

export type PayoutBatchingPeriodCountAggregateOutputType = {
  __typename?: 'PayoutBatchingPeriodCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdByUserId: Scalars['Int'];
  endsAt: Scalars['Int'];
  id: Scalars['Int'];
  startsAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PayoutBatchingPeriodCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PayoutBatchingPeriodCreateInput = {
  clinic: ClinicCreateNestedOneWithoutPayoutBatchingPeriodsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutCreatedPayoutBatchingPeriodsInput>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutPayoutBatchingPeriodInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodCreateManyClinicInputEnvelope = {
  data: Array<PayoutBatchingPeriodCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PayoutBatchingPeriodCreateManyCreatedByUserInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodCreateManyCreatedByUserInputEnvelope = {
  data: Array<PayoutBatchingPeriodCreateManyCreatedByUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PayoutBatchingPeriodCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingPeriodCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<PayoutBatchingPeriodCreateWithoutClinicInput>>;
  createMany?: Maybe<PayoutBatchingPeriodCreateManyClinicInputEnvelope>;
};

export type PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput = {
  connect?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingPeriodCreateOrConnectWithoutCreatedByUserInput>>;
  create?: Maybe<Array<PayoutBatchingPeriodCreateWithoutCreatedByUserInput>>;
  createMany?: Maybe<PayoutBatchingPeriodCreateManyCreatedByUserInputEnvelope>;
};

export type PayoutBatchingPeriodCreateNestedOneWithoutStripePayoutInput = {
  connect?: Maybe<PayoutBatchingPeriodWhereUniqueInput>;
  connectOrCreate?: Maybe<PayoutBatchingPeriodCreateOrConnectWithoutStripePayoutInput>;
  create?: Maybe<PayoutBatchingPeriodCreateWithoutStripePayoutInput>;
};

export type PayoutBatchingPeriodCreateOrConnectWithoutClinicInput = {
  create: PayoutBatchingPeriodCreateWithoutClinicInput;
  where: PayoutBatchingPeriodWhereUniqueInput;
};

export type PayoutBatchingPeriodCreateOrConnectWithoutCreatedByUserInput = {
  create: PayoutBatchingPeriodCreateWithoutCreatedByUserInput;
  where: PayoutBatchingPeriodWhereUniqueInput;
};

export type PayoutBatchingPeriodCreateOrConnectWithoutStripePayoutInput = {
  create: PayoutBatchingPeriodCreateWithoutStripePayoutInput;
  where: PayoutBatchingPeriodWhereUniqueInput;
};

export type PayoutBatchingPeriodCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutCreatedPayoutBatchingPeriodsInput>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutPayoutBatchingPeriodInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodCreateWithoutCreatedByUserInput = {
  clinic: ClinicCreateNestedOneWithoutPayoutBatchingPeriodsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutPayoutBatchingPeriodInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodCreateWithoutStripePayoutInput = {
  clinic: ClinicCreateNestedOneWithoutPayoutBatchingPeriodsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserCreateNestedOneWithoutCreatedPayoutBatchingPeriodsInput>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodGroupByOutputType = {
  __typename?: 'PayoutBatchingPeriodGroupByOutputType';
  _count?: Maybe<PayoutBatchingPeriodCountAggregateOutputType>;
  _max?: Maybe<PayoutBatchingPeriodMaxAggregateOutputType>;
  _min?: Maybe<PayoutBatchingPeriodMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  id: Scalars['String'];
  startsAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type PayoutBatchingPeriodListRelationFilter = {
  every?: Maybe<PayoutBatchingPeriodWhereInput>;
  none?: Maybe<PayoutBatchingPeriodWhereInput>;
  some?: Maybe<PayoutBatchingPeriodWhereInput>;
};

export type PayoutBatchingPeriodMaxAggregateOutputType = {
  __typename?: 'PayoutBatchingPeriodMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PayoutBatchingPeriodMinAggregateOutputType = {
  __typename?: 'PayoutBatchingPeriodMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PayoutBatchingPeriodNullableScalarRelationFilter = {
  AND?: Maybe<Array<PayoutBatchingPeriodWhereInput>>;
  NOT?: Maybe<Array<PayoutBatchingPeriodWhereInput>>;
  OR?: Maybe<Array<PayoutBatchingPeriodWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUser?: Maybe<UserNullableScalarRelationFilter>;
  createdByUserId?: Maybe<StringNullableFilter>;
  endsAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  startsAt?: Maybe<DateTimeFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PayoutBatchingPeriodOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PayoutBatchingPeriodOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PayoutBatchingPeriodOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUser?: Maybe<UserOrderByWithRelationInput>;
  createdByUserId?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PayoutBatchingPeriodOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  CreatedByUserId = 'createdByUserId',
  Id = 'id'
}

export type PayoutBatchingPeriodOrderByRelevanceInput = {
  fields: Array<PayoutBatchingPeriodOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PayoutBatchingPeriodOrderByWithAggregationInput = {
  _count?: Maybe<PayoutBatchingPeriodCountOrderByAggregateInput>;
  _max?: Maybe<PayoutBatchingPeriodMaxOrderByAggregateInput>;
  _min?: Maybe<PayoutBatchingPeriodMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PayoutBatchingPeriodOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PayoutBatchingPeriodOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUser?: Maybe<UserOrderByWithRelationInput>;
  createdByUserId?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type PayoutBatchingPeriodOrderByWithRelationInput = {
  _relevance?: Maybe<PayoutBatchingPeriodOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUser?: Maybe<UserOrderByWithRelationInput>;
  createdByUserId?: Maybe<SortOrder>;
  endsAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  startsAt?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PayoutBatchingPeriodScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  EndsAt = 'endsAt',
  Id = 'id',
  StartsAt = 'startsAt',
  UpdatedAt = 'updatedAt'
}

export type PayoutBatchingPeriodScalarWhereInput = {
  AND?: Maybe<Array<PayoutBatchingPeriodScalarWhereInput>>;
  NOT?: Maybe<Array<PayoutBatchingPeriodScalarWhereInput>>;
  OR?: Maybe<Array<PayoutBatchingPeriodScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUserId?: Maybe<StringNullableFilter>;
  endsAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  startsAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PayoutBatchingPeriodScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PayoutBatchingPeriodScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PayoutBatchingPeriodScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PayoutBatchingPeriodScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  createdByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  endsAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  startsAt?: Maybe<DateTimeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type PayoutBatchingPeriodUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  stripePayout?: Maybe<StripePayoutUncheckedCreateNestedOneWithoutPayoutBatchingPeriodInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingPeriodCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<PayoutBatchingPeriodCreateWithoutClinicInput>>;
  createMany?: Maybe<PayoutBatchingPeriodCreateManyClinicInputEnvelope>;
};

export type PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput = {
  connect?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingPeriodCreateOrConnectWithoutCreatedByUserInput>>;
  create?: Maybe<Array<PayoutBatchingPeriodCreateWithoutCreatedByUserInput>>;
  createMany?: Maybe<PayoutBatchingPeriodCreateManyCreatedByUserInputEnvelope>;
};

export type PayoutBatchingPeriodUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  stripePayout?: Maybe<StripePayoutUncheckedCreateNestedOneWithoutPayoutBatchingPeriodInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUncheckedCreateWithoutCreatedByUserInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  stripePayout?: Maybe<StripePayoutUncheckedCreateNestedOneWithoutPayoutBatchingPeriodInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUncheckedCreateWithoutStripePayoutInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  stripePayout?: Maybe<StripePayoutUncheckedUpdateOneWithoutPayoutBatchingPeriodNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingPeriodCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<PayoutBatchingPeriodCreateWithoutClinicInput>>;
  createMany?: Maybe<PayoutBatchingPeriodCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PayoutBatchingPeriodScalarWhereInput>>;
  disconnect?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  set?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  update?: Maybe<Array<PayoutBatchingPeriodUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<PayoutBatchingPeriodUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<PayoutBatchingPeriodUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingPeriodCreateOrConnectWithoutCreatedByUserInput>>;
  create?: Maybe<Array<PayoutBatchingPeriodCreateWithoutCreatedByUserInput>>;
  createMany?: Maybe<PayoutBatchingPeriodCreateManyCreatedByUserInputEnvelope>;
  delete?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PayoutBatchingPeriodScalarWhereInput>>;
  disconnect?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  set?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  update?: Maybe<Array<PayoutBatchingPeriodUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: Maybe<Array<PayoutBatchingPeriodUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: Maybe<Array<PayoutBatchingPeriodUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type PayoutBatchingPeriodUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  stripePayout?: Maybe<StripePayoutUncheckedUpdateOneWithoutPayoutBatchingPeriodNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUncheckedUpdateWithoutCreatedByUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  stripePayout?: Maybe<StripePayoutUncheckedUpdateOneWithoutPayoutBatchingPeriodNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUncheckedUpdateWithoutStripePayoutInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutPayoutBatchingPeriodsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutCreatedPayoutBatchingPeriodsNestedInput>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutPayoutBatchingPeriodNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUpdateManyWithWhereWithoutClinicInput = {
  data: PayoutBatchingPeriodUpdateManyMutationInput;
  where: PayoutBatchingPeriodScalarWhereInput;
};

export type PayoutBatchingPeriodUpdateManyWithWhereWithoutCreatedByUserInput = {
  data: PayoutBatchingPeriodUpdateManyMutationInput;
  where: PayoutBatchingPeriodScalarWhereInput;
};

export type PayoutBatchingPeriodUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingPeriodCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<PayoutBatchingPeriodCreateWithoutClinicInput>>;
  createMany?: Maybe<PayoutBatchingPeriodCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PayoutBatchingPeriodScalarWhereInput>>;
  disconnect?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  set?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  update?: Maybe<Array<PayoutBatchingPeriodUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<PayoutBatchingPeriodUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<PayoutBatchingPeriodUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingPeriodCreateOrConnectWithoutCreatedByUserInput>>;
  create?: Maybe<Array<PayoutBatchingPeriodCreateWithoutCreatedByUserInput>>;
  createMany?: Maybe<PayoutBatchingPeriodCreateManyCreatedByUserInputEnvelope>;
  delete?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PayoutBatchingPeriodScalarWhereInput>>;
  disconnect?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  set?: Maybe<Array<PayoutBatchingPeriodWhereUniqueInput>>;
  update?: Maybe<Array<PayoutBatchingPeriodUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: Maybe<Array<PayoutBatchingPeriodUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: Maybe<Array<PayoutBatchingPeriodUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type PayoutBatchingPeriodUpdateOneWithoutStripePayoutNestedInput = {
  connect?: Maybe<PayoutBatchingPeriodWhereUniqueInput>;
  connectOrCreate?: Maybe<PayoutBatchingPeriodCreateOrConnectWithoutStripePayoutInput>;
  create?: Maybe<PayoutBatchingPeriodCreateWithoutStripePayoutInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PayoutBatchingPeriodUpdateToOneWithWhereWithoutStripePayoutInput>;
  upsert?: Maybe<PayoutBatchingPeriodUpsertWithoutStripePayoutInput>;
};

export type PayoutBatchingPeriodUpdateToOneWithWhereWithoutStripePayoutInput = {
  data: PayoutBatchingPeriodUpdateWithoutStripePayoutInput;
  where?: Maybe<PayoutBatchingPeriodWhereInput>;
};

export type PayoutBatchingPeriodUpdateWithWhereUniqueWithoutClinicInput = {
  data: PayoutBatchingPeriodUpdateWithoutClinicInput;
  where: PayoutBatchingPeriodWhereUniqueInput;
};

export type PayoutBatchingPeriodUpdateWithWhereUniqueWithoutCreatedByUserInput = {
  data: PayoutBatchingPeriodUpdateWithoutCreatedByUserInput;
  where: PayoutBatchingPeriodWhereUniqueInput;
};

export type PayoutBatchingPeriodUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutCreatedPayoutBatchingPeriodsNestedInput>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutPayoutBatchingPeriodNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUpdateWithoutCreatedByUserInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutPayoutBatchingPeriodsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutPayoutBatchingPeriodNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUpdateWithoutStripePayoutInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutPayoutBatchingPeriodsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<UserUpdateOneWithoutCreatedPayoutBatchingPeriodsNestedInput>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingPeriodUpsertWithWhereUniqueWithoutClinicInput = {
  create: PayoutBatchingPeriodCreateWithoutClinicInput;
  update: PayoutBatchingPeriodUpdateWithoutClinicInput;
  where: PayoutBatchingPeriodWhereUniqueInput;
};

export type PayoutBatchingPeriodUpsertWithWhereUniqueWithoutCreatedByUserInput = {
  create: PayoutBatchingPeriodCreateWithoutCreatedByUserInput;
  update: PayoutBatchingPeriodUpdateWithoutCreatedByUserInput;
  where: PayoutBatchingPeriodWhereUniqueInput;
};

export type PayoutBatchingPeriodUpsertWithoutStripePayoutInput = {
  create: PayoutBatchingPeriodCreateWithoutStripePayoutInput;
  update: PayoutBatchingPeriodUpdateWithoutStripePayoutInput;
  where?: Maybe<PayoutBatchingPeriodWhereInput>;
};

export type PayoutBatchingPeriodWhereInput = {
  AND?: Maybe<Array<PayoutBatchingPeriodWhereInput>>;
  NOT?: Maybe<Array<PayoutBatchingPeriodWhereInput>>;
  OR?: Maybe<Array<PayoutBatchingPeriodWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUser?: Maybe<UserNullableScalarRelationFilter>;
  createdByUserId?: Maybe<StringNullableFilter>;
  endsAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  startsAt?: Maybe<DateTimeFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PayoutBatchingPeriodWhereUniqueInput = {
  AND?: Maybe<Array<PayoutBatchingPeriodWhereInput>>;
  NOT?: Maybe<Array<PayoutBatchingPeriodWhereInput>>;
  OR?: Maybe<Array<PayoutBatchingPeriodWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicId_startsAt_endsAt?: Maybe<PayoutBatchingPeriodClinicIdStartsAtEndsAtCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUser?: Maybe<UserNullableScalarRelationFilter>;
  createdByUserId?: Maybe<StringNullableFilter>;
  endsAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  startsAt?: Maybe<DateTimeFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PayoutBatchingSchedule = {
  __typename?: 'PayoutBatchingSchedule';
  createdAt: Scalars['DateTime'];
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['DateTime'];
  id: Scalars['String'];
  setting: PayoutBatchingSetting;
  settingId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PayoutBatchingScheduleAvgAggregateOutputType = {
  __typename?: 'PayoutBatchingScheduleAvgAggregateOutputType';
  dayOfWeek?: Maybe<Scalars['Float']>;
};

export type PayoutBatchingScheduleAvgOrderByAggregateInput = {
  dayOfWeek?: Maybe<SortOrder>;
};

export type PayoutBatchingScheduleCountAggregateOutputType = {
  __typename?: 'PayoutBatchingScheduleCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['Int'];
  id: Scalars['Int'];
  settingId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PayoutBatchingScheduleCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  settingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PayoutBatchingScheduleCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  setting: PayoutBatchingSettingCreateNestedOneWithoutSchedulesInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  settingId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleCreateManySettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleCreateManySettingInputEnvelope = {
  data: Array<PayoutBatchingScheduleCreateManySettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PayoutBatchingScheduleCreateNestedManyWithoutSettingInput = {
  connect?: Maybe<Array<PayoutBatchingScheduleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingScheduleCreateOrConnectWithoutSettingInput>>;
  create?: Maybe<Array<PayoutBatchingScheduleCreateWithoutSettingInput>>;
  createMany?: Maybe<PayoutBatchingScheduleCreateManySettingInputEnvelope>;
};

export type PayoutBatchingScheduleCreateOrConnectWithoutSettingInput = {
  create: PayoutBatchingScheduleCreateWithoutSettingInput;
  where: PayoutBatchingScheduleWhereUniqueInput;
};

export type PayoutBatchingScheduleCreateWithoutSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleDayOfWeekSettingIdCompoundUniqueInput = {
  dayOfWeek: Scalars['Int'];
  settingId: Scalars['String'];
};

export type PayoutBatchingScheduleGroupByOutputType = {
  __typename?: 'PayoutBatchingScheduleGroupByOutputType';
  _avg?: Maybe<PayoutBatchingScheduleAvgAggregateOutputType>;
  _count?: Maybe<PayoutBatchingScheduleCountAggregateOutputType>;
  _max?: Maybe<PayoutBatchingScheduleMaxAggregateOutputType>;
  _min?: Maybe<PayoutBatchingScheduleMinAggregateOutputType>;
  _sum?: Maybe<PayoutBatchingScheduleSumAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['DateTime'];
  id: Scalars['String'];
  settingId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PayoutBatchingScheduleListRelationFilter = {
  every?: Maybe<PayoutBatchingScheduleWhereInput>;
  none?: Maybe<PayoutBatchingScheduleWhereInput>;
  some?: Maybe<PayoutBatchingScheduleWhereInput>;
};

export type PayoutBatchingScheduleMaxAggregateOutputType = {
  __typename?: 'PayoutBatchingScheduleMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  settingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  settingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PayoutBatchingScheduleMinAggregateOutputType = {
  __typename?: 'PayoutBatchingScheduleMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  settingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  settingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PayoutBatchingScheduleOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PayoutBatchingScheduleOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PayoutBatchingScheduleOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  setting?: Maybe<PayoutBatchingSettingOrderByWithRelationInput>;
  settingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PayoutBatchingScheduleOrderByRelevanceFieldEnum {
  Id = 'id',
  SettingId = 'settingId'
}

export type PayoutBatchingScheduleOrderByRelevanceInput = {
  fields: Array<PayoutBatchingScheduleOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PayoutBatchingScheduleOrderByWithAggregationInput = {
  _avg?: Maybe<PayoutBatchingScheduleAvgOrderByAggregateInput>;
  _count?: Maybe<PayoutBatchingScheduleCountOrderByAggregateInput>;
  _max?: Maybe<PayoutBatchingScheduleMaxOrderByAggregateInput>;
  _min?: Maybe<PayoutBatchingScheduleMinOrderByAggregateInput>;
  _sum?: Maybe<PayoutBatchingScheduleSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  settingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PayoutBatchingScheduleOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PayoutBatchingScheduleOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  setting?: Maybe<PayoutBatchingSettingOrderByWithRelationInput>;
  settingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PayoutBatchingScheduleOrderByWithRelationInput = {
  _relevance?: Maybe<PayoutBatchingScheduleOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  dayOfWeek?: Maybe<SortOrder>;
  endTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  setting?: Maybe<PayoutBatchingSettingOrderByWithRelationInput>;
  settingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PayoutBatchingScheduleScalarFieldEnum {
  CreatedAt = 'createdAt',
  DayOfWeek = 'dayOfWeek',
  EndTime = 'endTime',
  Id = 'id',
  SettingId = 'settingId',
  UpdatedAt = 'updatedAt'
}

export type PayoutBatchingScheduleScalarWhereInput = {
  AND?: Maybe<Array<PayoutBatchingScheduleScalarWhereInput>>;
  NOT?: Maybe<Array<PayoutBatchingScheduleScalarWhereInput>>;
  OR?: Maybe<Array<PayoutBatchingScheduleScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  dayOfWeek?: Maybe<IntFilter>;
  endTime?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  settingId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PayoutBatchingScheduleScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PayoutBatchingScheduleScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PayoutBatchingScheduleScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PayoutBatchingScheduleScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  dayOfWeek?: Maybe<IntWithAggregatesFilter>;
  endTime?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  settingId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type PayoutBatchingScheduleSumAggregateOutputType = {
  __typename?: 'PayoutBatchingScheduleSumAggregateOutputType';
  dayOfWeek?: Maybe<Scalars['Int']>;
};

export type PayoutBatchingScheduleSumOrderByAggregateInput = {
  dayOfWeek?: Maybe<SortOrder>;
};

export type PayoutBatchingScheduleUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  settingId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleUncheckedCreateNestedManyWithoutSettingInput = {
  connect?: Maybe<Array<PayoutBatchingScheduleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingScheduleCreateOrConnectWithoutSettingInput>>;
  create?: Maybe<Array<PayoutBatchingScheduleCreateWithoutSettingInput>>;
  createMany?: Maybe<PayoutBatchingScheduleCreateManySettingInputEnvelope>;
};

export type PayoutBatchingScheduleUncheckedCreateWithoutSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  settingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  settingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleUncheckedUpdateManyWithoutSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleUncheckedUpdateManyWithoutSettingNestedInput = {
  connect?: Maybe<Array<PayoutBatchingScheduleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingScheduleCreateOrConnectWithoutSettingInput>>;
  create?: Maybe<Array<PayoutBatchingScheduleCreateWithoutSettingInput>>;
  createMany?: Maybe<PayoutBatchingScheduleCreateManySettingInputEnvelope>;
  delete?: Maybe<Array<PayoutBatchingScheduleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PayoutBatchingScheduleScalarWhereInput>>;
  disconnect?: Maybe<Array<PayoutBatchingScheduleWhereUniqueInput>>;
  set?: Maybe<Array<PayoutBatchingScheduleWhereUniqueInput>>;
  update?: Maybe<Array<PayoutBatchingScheduleUpdateWithWhereUniqueWithoutSettingInput>>;
  updateMany?: Maybe<Array<PayoutBatchingScheduleUpdateManyWithWhereWithoutSettingInput>>;
  upsert?: Maybe<Array<PayoutBatchingScheduleUpsertWithWhereUniqueWithoutSettingInput>>;
};

export type PayoutBatchingScheduleUncheckedUpdateWithoutSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  setting?: Maybe<PayoutBatchingSettingUpdateOneRequiredWithoutSchedulesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleUpdateManyWithWhereWithoutSettingInput = {
  data: PayoutBatchingScheduleUpdateManyMutationInput;
  where: PayoutBatchingScheduleScalarWhereInput;
};

export type PayoutBatchingScheduleUpdateManyWithoutSettingNestedInput = {
  connect?: Maybe<Array<PayoutBatchingScheduleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingScheduleCreateOrConnectWithoutSettingInput>>;
  create?: Maybe<Array<PayoutBatchingScheduleCreateWithoutSettingInput>>;
  createMany?: Maybe<PayoutBatchingScheduleCreateManySettingInputEnvelope>;
  delete?: Maybe<Array<PayoutBatchingScheduleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PayoutBatchingScheduleScalarWhereInput>>;
  disconnect?: Maybe<Array<PayoutBatchingScheduleWhereUniqueInput>>;
  set?: Maybe<Array<PayoutBatchingScheduleWhereUniqueInput>>;
  update?: Maybe<Array<PayoutBatchingScheduleUpdateWithWhereUniqueWithoutSettingInput>>;
  updateMany?: Maybe<Array<PayoutBatchingScheduleUpdateManyWithWhereWithoutSettingInput>>;
  upsert?: Maybe<Array<PayoutBatchingScheduleUpsertWithWhereUniqueWithoutSettingInput>>;
};

export type PayoutBatchingScheduleUpdateWithWhereUniqueWithoutSettingInput = {
  data: PayoutBatchingScheduleUpdateWithoutSettingInput;
  where: PayoutBatchingScheduleWhereUniqueInput;
};

export type PayoutBatchingScheduleUpdateWithoutSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingScheduleUpsertWithWhereUniqueWithoutSettingInput = {
  create: PayoutBatchingScheduleCreateWithoutSettingInput;
  update: PayoutBatchingScheduleUpdateWithoutSettingInput;
  where: PayoutBatchingScheduleWhereUniqueInput;
};

export type PayoutBatchingScheduleWhereInput = {
  AND?: Maybe<Array<PayoutBatchingScheduleWhereInput>>;
  NOT?: Maybe<Array<PayoutBatchingScheduleWhereInput>>;
  OR?: Maybe<Array<PayoutBatchingScheduleWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  dayOfWeek?: Maybe<IntFilter>;
  endTime?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  setting?: Maybe<PayoutBatchingSettingScalarRelationFilter>;
  settingId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PayoutBatchingScheduleWhereUniqueInput = {
  AND?: Maybe<Array<PayoutBatchingScheduleWhereInput>>;
  NOT?: Maybe<Array<PayoutBatchingScheduleWhereInput>>;
  OR?: Maybe<Array<PayoutBatchingScheduleWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  dayOfWeek?: Maybe<IntFilter>;
  dayOfWeek_settingId?: Maybe<PayoutBatchingScheduleDayOfWeekSettingIdCompoundUniqueInput>;
  endTime?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  setting?: Maybe<PayoutBatchingSettingScalarRelationFilter>;
  settingId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PayoutBatchingSetting = {
  __typename?: 'PayoutBatchingSetting';
  _count: PayoutBatchingSettingCountOutputType;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isAutomated: Scalars['Boolean'];
  schedules: Array<PayoutBatchingSchedule>;
  updatedAt: Scalars['DateTime'];
  updatedByUser?: Maybe<User>;
  updatedByUserId?: Maybe<Scalars['String']>;
};


export type PayoutBatchingSettingSchedulesArgs = {
  cursor?: Maybe<PayoutBatchingScheduleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingScheduleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingScheduleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingScheduleWhereInput>;
};


export type PayoutBatchingSettingUpdatedByUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type PayoutBatchingSettingCountAggregateOutputType = {
  __typename?: 'PayoutBatchingSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isAutomated: Scalars['Int'];
  updatedAt: Scalars['Int'];
  updatedByUserId: Scalars['Int'];
};

export type PayoutBatchingSettingCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomated?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedByUserId?: Maybe<SortOrder>;
};

export type PayoutBatchingSettingCountOutputType = {
  __typename?: 'PayoutBatchingSettingCountOutputType';
  schedules: Scalars['Int'];
};

export type PayoutBatchingSettingCreateInput = {
  clinic: ClinicCreateNestedOneWithoutPayoutBatchingSettingInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<PayoutBatchingScheduleCreateNestedManyWithoutSettingInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUser?: Maybe<UserCreateNestedOneWithoutPayoutBatchingSettingInput>;
};

export type PayoutBatchingSettingCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type PayoutBatchingSettingCreateManyUpdatedByUserInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingSettingCreateManyUpdatedByUserInputEnvelope = {
  data: Array<PayoutBatchingSettingCreateManyUpdatedByUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput = {
  connect?: Maybe<Array<PayoutBatchingSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingSettingCreateOrConnectWithoutUpdatedByUserInput>>;
  create?: Maybe<Array<PayoutBatchingSettingCreateWithoutUpdatedByUserInput>>;
  createMany?: Maybe<PayoutBatchingSettingCreateManyUpdatedByUserInputEnvelope>;
};

export type PayoutBatchingSettingCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<PayoutBatchingSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<PayoutBatchingSettingCreateOrConnectWithoutClinicInput>;
  create?: Maybe<PayoutBatchingSettingCreateWithoutClinicInput>;
};

export type PayoutBatchingSettingCreateNestedOneWithoutSchedulesInput = {
  connect?: Maybe<PayoutBatchingSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<PayoutBatchingSettingCreateOrConnectWithoutSchedulesInput>;
  create?: Maybe<PayoutBatchingSettingCreateWithoutSchedulesInput>;
};

export type PayoutBatchingSettingCreateOrConnectWithoutClinicInput = {
  create: PayoutBatchingSettingCreateWithoutClinicInput;
  where: PayoutBatchingSettingWhereUniqueInput;
};

export type PayoutBatchingSettingCreateOrConnectWithoutSchedulesInput = {
  create: PayoutBatchingSettingCreateWithoutSchedulesInput;
  where: PayoutBatchingSettingWhereUniqueInput;
};

export type PayoutBatchingSettingCreateOrConnectWithoutUpdatedByUserInput = {
  create: PayoutBatchingSettingCreateWithoutUpdatedByUserInput;
  where: PayoutBatchingSettingWhereUniqueInput;
};

export type PayoutBatchingSettingCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<PayoutBatchingScheduleCreateNestedManyWithoutSettingInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUser?: Maybe<UserCreateNestedOneWithoutPayoutBatchingSettingInput>;
};

export type PayoutBatchingSettingCreateWithoutSchedulesInput = {
  clinic: ClinicCreateNestedOneWithoutPayoutBatchingSettingInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUser?: Maybe<UserCreateNestedOneWithoutPayoutBatchingSettingInput>;
};

export type PayoutBatchingSettingCreateWithoutUpdatedByUserInput = {
  clinic: ClinicCreateNestedOneWithoutPayoutBatchingSettingInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<PayoutBatchingScheduleCreateNestedManyWithoutSettingInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingSettingGroupByOutputType = {
  __typename?: 'PayoutBatchingSettingGroupByOutputType';
  _count?: Maybe<PayoutBatchingSettingCountAggregateOutputType>;
  _max?: Maybe<PayoutBatchingSettingMaxAggregateOutputType>;
  _min?: Maybe<PayoutBatchingSettingMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isAutomated: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type PayoutBatchingSettingListRelationFilter = {
  every?: Maybe<PayoutBatchingSettingWhereInput>;
  none?: Maybe<PayoutBatchingSettingWhereInput>;
  some?: Maybe<PayoutBatchingSettingWhereInput>;
};

export type PayoutBatchingSettingMaxAggregateOutputType = {
  __typename?: 'PayoutBatchingSettingMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type PayoutBatchingSettingMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomated?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedByUserId?: Maybe<SortOrder>;
};

export type PayoutBatchingSettingMinAggregateOutputType = {
  __typename?: 'PayoutBatchingSettingMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type PayoutBatchingSettingMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomated?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedByUserId?: Maybe<SortOrder>;
};

export type PayoutBatchingSettingNullableScalarRelationFilter = {
  AND?: Maybe<Array<PayoutBatchingSettingWhereInput>>;
  NOT?: Maybe<Array<PayoutBatchingSettingWhereInput>>;
  OR?: Maybe<Array<PayoutBatchingSettingWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isAutomated?: Maybe<BoolFilter>;
  schedules?: Maybe<PayoutBatchingScheduleListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  updatedByUser?: Maybe<UserNullableScalarRelationFilter>;
  updatedByUserId?: Maybe<StringNullableFilter>;
};

export type PayoutBatchingSettingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PayoutBatchingSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PayoutBatchingSettingOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomated?: Maybe<SortOrder>;
  schedules?: Maybe<PayoutBatchingScheduleOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  updatedByUser?: Maybe<UserOrderByWithRelationInput>;
  updatedByUserId?: Maybe<SortOrder>;
};

export enum PayoutBatchingSettingOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  UpdatedByUserId = 'updatedByUserId'
}

export type PayoutBatchingSettingOrderByRelevanceInput = {
  fields: Array<PayoutBatchingSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PayoutBatchingSettingOrderByWithAggregationInput = {
  _count?: Maybe<PayoutBatchingSettingCountOrderByAggregateInput>;
  _max?: Maybe<PayoutBatchingSettingMaxOrderByAggregateInput>;
  _min?: Maybe<PayoutBatchingSettingMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomated?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  updatedByUserId?: Maybe<SortOrder>;
};

export type PayoutBatchingSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PayoutBatchingSettingOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomated?: Maybe<SortOrder>;
  schedules?: Maybe<PayoutBatchingScheduleOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  updatedByUser?: Maybe<UserOrderByWithRelationInput>;
  updatedByUserId?: Maybe<SortOrder>;
};

export type PayoutBatchingSettingOrderByWithRelationInput = {
  _relevance?: Maybe<PayoutBatchingSettingOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomated?: Maybe<SortOrder>;
  schedules?: Maybe<PayoutBatchingScheduleOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  updatedByUser?: Maybe<UserOrderByWithRelationInput>;
  updatedByUserId?: Maybe<SortOrder>;
};

export enum PayoutBatchingSettingScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsAutomated = 'isAutomated',
  UpdatedAt = 'updatedAt',
  UpdatedByUserId = 'updatedByUserId'
}

export type PayoutBatchingSettingScalarRelationFilter = {
  AND?: Maybe<Array<PayoutBatchingSettingWhereInput>>;
  NOT?: Maybe<Array<PayoutBatchingSettingWhereInput>>;
  OR?: Maybe<Array<PayoutBatchingSettingWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isAutomated?: Maybe<BoolFilter>;
  schedules?: Maybe<PayoutBatchingScheduleListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  updatedByUser?: Maybe<UserNullableScalarRelationFilter>;
  updatedByUserId?: Maybe<StringNullableFilter>;
};

export type PayoutBatchingSettingScalarWhereInput = {
  AND?: Maybe<Array<PayoutBatchingSettingScalarWhereInput>>;
  NOT?: Maybe<Array<PayoutBatchingSettingScalarWhereInput>>;
  OR?: Maybe<Array<PayoutBatchingSettingScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isAutomated?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  updatedByUserId?: Maybe<StringNullableFilter>;
};

export type PayoutBatchingSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PayoutBatchingSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PayoutBatchingSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PayoutBatchingSettingScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isAutomated?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  updatedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type PayoutBatchingSettingUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<PayoutBatchingScheduleUncheckedCreateNestedManyWithoutSettingInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput = {
  connect?: Maybe<Array<PayoutBatchingSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingSettingCreateOrConnectWithoutUpdatedByUserInput>>;
  create?: Maybe<Array<PayoutBatchingSettingCreateWithoutUpdatedByUserInput>>;
  createMany?: Maybe<PayoutBatchingSettingCreateManyUpdatedByUserInputEnvelope>;
};

export type PayoutBatchingSettingUncheckedCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<PayoutBatchingSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<PayoutBatchingSettingCreateOrConnectWithoutClinicInput>;
  create?: Maybe<PayoutBatchingSettingCreateWithoutClinicInput>;
};

export type PayoutBatchingSettingUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<PayoutBatchingScheduleUncheckedCreateNestedManyWithoutSettingInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type PayoutBatchingSettingUncheckedCreateWithoutSchedulesInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type PayoutBatchingSettingUncheckedCreateWithoutUpdatedByUserInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<PayoutBatchingScheduleUncheckedCreateNestedManyWithoutSettingInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingSettingUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<PayoutBatchingScheduleUncheckedUpdateManyWithoutSettingNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type PayoutBatchingSettingUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput = {
  connect?: Maybe<Array<PayoutBatchingSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingSettingCreateOrConnectWithoutUpdatedByUserInput>>;
  create?: Maybe<Array<PayoutBatchingSettingCreateWithoutUpdatedByUserInput>>;
  createMany?: Maybe<PayoutBatchingSettingCreateManyUpdatedByUserInputEnvelope>;
  delete?: Maybe<Array<PayoutBatchingSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PayoutBatchingSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<PayoutBatchingSettingWhereUniqueInput>>;
  set?: Maybe<Array<PayoutBatchingSettingWhereUniqueInput>>;
  update?: Maybe<Array<PayoutBatchingSettingUpdateWithWhereUniqueWithoutUpdatedByUserInput>>;
  updateMany?: Maybe<Array<PayoutBatchingSettingUpdateManyWithWhereWithoutUpdatedByUserInput>>;
  upsert?: Maybe<Array<PayoutBatchingSettingUpsertWithWhereUniqueWithoutUpdatedByUserInput>>;
};

export type PayoutBatchingSettingUncheckedUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<PayoutBatchingSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<PayoutBatchingSettingCreateOrConnectWithoutClinicInput>;
  create?: Maybe<PayoutBatchingSettingCreateWithoutClinicInput>;
  delete?: Maybe<PayoutBatchingSettingWhereInput>;
  disconnect?: Maybe<PayoutBatchingSettingWhereInput>;
  update?: Maybe<PayoutBatchingSettingUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<PayoutBatchingSettingUpsertWithoutClinicInput>;
};

export type PayoutBatchingSettingUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<PayoutBatchingScheduleUncheckedUpdateManyWithoutSettingNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type PayoutBatchingSettingUncheckedUpdateWithoutSchedulesInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type PayoutBatchingSettingUncheckedUpdateWithoutUpdatedByUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<PayoutBatchingScheduleUncheckedUpdateManyWithoutSettingNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingSettingUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutPayoutBatchingSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<PayoutBatchingScheduleUpdateManyWithoutSettingNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUser?: Maybe<UserUpdateOneWithoutPayoutBatchingSettingNestedInput>;
};

export type PayoutBatchingSettingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingSettingUpdateManyWithWhereWithoutUpdatedByUserInput = {
  data: PayoutBatchingSettingUpdateManyMutationInput;
  where: PayoutBatchingSettingScalarWhereInput;
};

export type PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput = {
  connect?: Maybe<Array<PayoutBatchingSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PayoutBatchingSettingCreateOrConnectWithoutUpdatedByUserInput>>;
  create?: Maybe<Array<PayoutBatchingSettingCreateWithoutUpdatedByUserInput>>;
  createMany?: Maybe<PayoutBatchingSettingCreateManyUpdatedByUserInputEnvelope>;
  delete?: Maybe<Array<PayoutBatchingSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PayoutBatchingSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<PayoutBatchingSettingWhereUniqueInput>>;
  set?: Maybe<Array<PayoutBatchingSettingWhereUniqueInput>>;
  update?: Maybe<Array<PayoutBatchingSettingUpdateWithWhereUniqueWithoutUpdatedByUserInput>>;
  updateMany?: Maybe<Array<PayoutBatchingSettingUpdateManyWithWhereWithoutUpdatedByUserInput>>;
  upsert?: Maybe<Array<PayoutBatchingSettingUpsertWithWhereUniqueWithoutUpdatedByUserInput>>;
};

export type PayoutBatchingSettingUpdateOneRequiredWithoutSchedulesNestedInput = {
  connect?: Maybe<PayoutBatchingSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<PayoutBatchingSettingCreateOrConnectWithoutSchedulesInput>;
  create?: Maybe<PayoutBatchingSettingCreateWithoutSchedulesInput>;
  update?: Maybe<PayoutBatchingSettingUpdateToOneWithWhereWithoutSchedulesInput>;
  upsert?: Maybe<PayoutBatchingSettingUpsertWithoutSchedulesInput>;
};

export type PayoutBatchingSettingUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<PayoutBatchingSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<PayoutBatchingSettingCreateOrConnectWithoutClinicInput>;
  create?: Maybe<PayoutBatchingSettingCreateWithoutClinicInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PayoutBatchingSettingUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<PayoutBatchingSettingUpsertWithoutClinicInput>;
};

export type PayoutBatchingSettingUpdateToOneWithWhereWithoutClinicInput = {
  data: PayoutBatchingSettingUpdateWithoutClinicInput;
  where?: Maybe<PayoutBatchingSettingWhereInput>;
};

export type PayoutBatchingSettingUpdateToOneWithWhereWithoutSchedulesInput = {
  data: PayoutBatchingSettingUpdateWithoutSchedulesInput;
  where?: Maybe<PayoutBatchingSettingWhereInput>;
};

export type PayoutBatchingSettingUpdateWithWhereUniqueWithoutUpdatedByUserInput = {
  data: PayoutBatchingSettingUpdateWithoutUpdatedByUserInput;
  where: PayoutBatchingSettingWhereUniqueInput;
};

export type PayoutBatchingSettingUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<PayoutBatchingScheduleUpdateManyWithoutSettingNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUser?: Maybe<UserUpdateOneWithoutPayoutBatchingSettingNestedInput>;
};

export type PayoutBatchingSettingUpdateWithoutSchedulesInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutPayoutBatchingSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUser?: Maybe<UserUpdateOneWithoutPayoutBatchingSettingNestedInput>;
};

export type PayoutBatchingSettingUpdateWithoutUpdatedByUserInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutPayoutBatchingSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<PayoutBatchingScheduleUpdateManyWithoutSettingNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBatchingSettingUpsertWithWhereUniqueWithoutUpdatedByUserInput = {
  create: PayoutBatchingSettingCreateWithoutUpdatedByUserInput;
  update: PayoutBatchingSettingUpdateWithoutUpdatedByUserInput;
  where: PayoutBatchingSettingWhereUniqueInput;
};

export type PayoutBatchingSettingUpsertWithoutClinicInput = {
  create: PayoutBatchingSettingCreateWithoutClinicInput;
  update: PayoutBatchingSettingUpdateWithoutClinicInput;
  where?: Maybe<PayoutBatchingSettingWhereInput>;
};

export type PayoutBatchingSettingUpsertWithoutSchedulesInput = {
  create: PayoutBatchingSettingCreateWithoutSchedulesInput;
  update: PayoutBatchingSettingUpdateWithoutSchedulesInput;
  where?: Maybe<PayoutBatchingSettingWhereInput>;
};

export type PayoutBatchingSettingWhereInput = {
  AND?: Maybe<Array<PayoutBatchingSettingWhereInput>>;
  NOT?: Maybe<Array<PayoutBatchingSettingWhereInput>>;
  OR?: Maybe<Array<PayoutBatchingSettingWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isAutomated?: Maybe<BoolFilter>;
  schedules?: Maybe<PayoutBatchingScheduleListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  updatedByUser?: Maybe<UserNullableScalarRelationFilter>;
  updatedByUserId?: Maybe<StringNullableFilter>;
};

export type PayoutBatchingSettingWhereUniqueInput = {
  AND?: Maybe<Array<PayoutBatchingSettingWhereInput>>;
  NOT?: Maybe<Array<PayoutBatchingSettingWhereInput>>;
  OR?: Maybe<Array<PayoutBatchingSettingWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isAutomated?: Maybe<BoolFilter>;
  schedules?: Maybe<PayoutBatchingScheduleListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  updatedByUser?: Maybe<UserNullableScalarRelationFilter>;
  updatedByUserId?: Maybe<StringNullableFilter>;
};

export type PerformCarePlanEnrollmentUpgradeInput = {
  carePlanEnrollmentId: Scalars['String'];
  feeAmount: Scalars['Float'];
  newPlanId: Scalars['String'];
  newPlanPricingId?: Maybe<Scalars['String']>;
  relatedInvoiceId?: Maybe<Scalars['String']>;
};

export type PerformCarePlanEnrollmentUpgradeOutput = {
  __typename?: 'PerformCarePlanEnrollmentUpgradeOutput';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  upgradeInvoiceId?: Maybe<Scalars['String']>;
};

export type Permission = {
  __typename?: 'Permission';
  _count: PermissionCountOutputType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  roles: Array<StaffRole>;
  type: PermissionType;
  updatedAt: Scalars['DateTime'];
};


export type PermissionRolesArgs = {
  cursor?: Maybe<StaffRoleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StaffRoleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StaffRoleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StaffRoleWhereInput>;
};

export type PermissionCountAggregateOutputType = {
  __typename?: 'PermissionCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PermissionCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PermissionCountOutputType = {
  __typename?: 'PermissionCountOutputType';
  roles: Scalars['Int'];
};

export type PermissionCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutPermissionsInput>;
  type: PermissionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type: PermissionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionCreateNestedManyWithoutRolesInput = {
  connect?: Maybe<Array<PermissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PermissionCreateOrConnectWithoutRolesInput>>;
  create?: Maybe<Array<PermissionCreateWithoutRolesInput>>;
};

export type PermissionCreateOrConnectWithoutRolesInput = {
  create: PermissionCreateWithoutRolesInput;
  where: PermissionWhereUniqueInput;
};

export type PermissionCreateWithoutRolesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type: PermissionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionGroupByOutputType = {
  __typename?: 'PermissionGroupByOutputType';
  _count?: Maybe<PermissionCountAggregateOutputType>;
  _max?: Maybe<PermissionMaxAggregateOutputType>;
  _min?: Maybe<PermissionMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  type: PermissionType;
  updatedAt: Scalars['DateTime'];
};

export type PermissionListRelationFilter = {
  every?: Maybe<PermissionWhereInput>;
  none?: Maybe<PermissionWhereInput>;
  some?: Maybe<PermissionWhereInput>;
};

export type PermissionMaxAggregateOutputType = {
  __typename?: 'PermissionMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<PermissionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PermissionMinAggregateOutputType = {
  __typename?: 'PermissionMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<PermissionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PermissionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PermissionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PermissionOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  roles?: Maybe<StaffRoleOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PermissionOrderByRelevanceFieldEnum {
  Id = 'id'
}

export type PermissionOrderByRelevanceInput = {
  fields: Array<PermissionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PermissionOrderByWithAggregationInput = {
  _count?: Maybe<PermissionCountOrderByAggregateInput>;
  _max?: Maybe<PermissionMaxOrderByAggregateInput>;
  _min?: Maybe<PermissionMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PermissionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PermissionOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  roles?: Maybe<StaffRoleOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PermissionOrderByWithRelationInput = {
  _relevance?: Maybe<PermissionOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  roles?: Maybe<StaffRoleOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PermissionScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type PermissionScalarWhereInput = {
  AND?: Maybe<Array<PermissionScalarWhereInput>>;
  NOT?: Maybe<Array<PermissionScalarWhereInput>>;
  OR?: Maybe<Array<PermissionScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  type?: Maybe<EnumPermissionTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PermissionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PermissionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PermissionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PermissionScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumPermissionTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum PermissionType {
  ChangeClinicPricing = 'ChangeClinicPricing',
  ManageChannelMessage = 'ManageChannelMessage',
  ManageTeletriage = 'ManageTeletriage',
  ReadAppointment = 'ReadAppointment',
  ReadChannel = 'ReadChannel',
  ReadClinicPetParent = 'ReadClinicPetParent',
  ReadConsultation = 'ReadConsultation',
  ReadOrganization = 'ReadOrganization',
  ReadPet = 'ReadPet',
  ReadUser = 'ReadUser',
  WriteAppointment = 'WriteAppointment',
  WriteChannel = 'WriteChannel',
  WriteClinic = 'WriteClinic',
  WriteClinicPetParent = 'WriteClinicPetParent',
  WriteConsultation = 'WriteConsultation',
  WriteOrganization = 'WriteOrganization',
  WritePet = 'WritePet',
  WriteUser = 'WriteUser'
}

export type PermissionUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutPermissionsInput>;
  type: PermissionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionUncheckedCreateNestedManyWithoutRolesInput = {
  connect?: Maybe<Array<PermissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PermissionCreateOrConnectWithoutRolesInput>>;
  create?: Maybe<Array<PermissionCreateWithoutRolesInput>>;
};

export type PermissionUncheckedCreateWithoutRolesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type: PermissionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutPermissionsNestedInput>;
  type?: Maybe<PermissionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<PermissionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionUncheckedUpdateManyWithoutRolesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<PermissionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionUncheckedUpdateManyWithoutRolesNestedInput = {
  connect?: Maybe<Array<PermissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PermissionCreateOrConnectWithoutRolesInput>>;
  create?: Maybe<Array<PermissionCreateWithoutRolesInput>>;
  delete?: Maybe<Array<PermissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PermissionScalarWhereInput>>;
  disconnect?: Maybe<Array<PermissionWhereUniqueInput>>;
  set?: Maybe<Array<PermissionWhereUniqueInput>>;
  update?: Maybe<Array<PermissionUpdateWithWhereUniqueWithoutRolesInput>>;
  updateMany?: Maybe<Array<PermissionUpdateManyWithWhereWithoutRolesInput>>;
  upsert?: Maybe<Array<PermissionUpsertWithWhereUniqueWithoutRolesInput>>;
};

export type PermissionUncheckedUpdateWithoutRolesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<PermissionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutPermissionsNestedInput>;
  type?: Maybe<PermissionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<PermissionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionUpdateManyWithWhereWithoutRolesInput = {
  data: PermissionUpdateManyMutationInput;
  where: PermissionScalarWhereInput;
};

export type PermissionUpdateManyWithoutRolesNestedInput = {
  connect?: Maybe<Array<PermissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PermissionCreateOrConnectWithoutRolesInput>>;
  create?: Maybe<Array<PermissionCreateWithoutRolesInput>>;
  delete?: Maybe<Array<PermissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PermissionScalarWhereInput>>;
  disconnect?: Maybe<Array<PermissionWhereUniqueInput>>;
  set?: Maybe<Array<PermissionWhereUniqueInput>>;
  update?: Maybe<Array<PermissionUpdateWithWhereUniqueWithoutRolesInput>>;
  updateMany?: Maybe<Array<PermissionUpdateManyWithWhereWithoutRolesInput>>;
  upsert?: Maybe<Array<PermissionUpsertWithWhereUniqueWithoutRolesInput>>;
};

export type PermissionUpdateWithWhereUniqueWithoutRolesInput = {
  data: PermissionUpdateWithoutRolesInput;
  where: PermissionWhereUniqueInput;
};

export type PermissionUpdateWithoutRolesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<PermissionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionUpsertWithWhereUniqueWithoutRolesInput = {
  create: PermissionCreateWithoutRolesInput;
  update: PermissionUpdateWithoutRolesInput;
  where: PermissionWhereUniqueInput;
};

export type PermissionWhereInput = {
  AND?: Maybe<Array<PermissionWhereInput>>;
  NOT?: Maybe<Array<PermissionWhereInput>>;
  OR?: Maybe<Array<PermissionWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  roles?: Maybe<StaffRoleListRelationFilter>;
  type?: Maybe<EnumPermissionTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PermissionWhereUniqueInput = {
  AND?: Maybe<Array<PermissionWhereInput>>;
  NOT?: Maybe<Array<PermissionWhereInput>>;
  OR?: Maybe<Array<PermissionWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleListRelationFilter>;
  type?: Maybe<PermissionType>;
  updatedAt?: Maybe<DateTimeFilter>;
};

/** @deprecated - 1.0 */
export type Pet = {
  __typename?: 'Pet';
  _count: PetCountOutputType;
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  consultations: Array<Consultation>;
  createdAt: Scalars['DateTime'];
  currentClinic?: Maybe<Clinic>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  petParent?: Maybe<OwnerInfo>;
  petParentId?: Maybe<Scalars['String']>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics: Array<Clinic>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  weight: Scalars['Float'];
};


/** @deprecated - 1.0 */
export type PetConsultationsArgs = {
  cursor?: Maybe<ConsultationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationWhereInput>;
};


/** @deprecated - 1.0 */
export type PetCurrentClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


/** @deprecated - 1.0 */
export type PetPetParentArgs = {
  where?: Maybe<OwnerInfoWhereInput>;
};


/** @deprecated - 1.0 */
export type PetPreviousClinicsArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};

export type PetAvgAggregateOutputType = {
  __typename?: 'PetAvgAggregateOutputType';
  bornOnDay?: Maybe<Scalars['Float']>;
  bornOnMonth?: Maybe<Scalars['Float']>;
  bornOnYear?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetAvgOrderByAggregateInput = {
  bornOnDay?: Maybe<SortOrder>;
  bornOnMonth?: Maybe<SortOrder>;
  bornOnYear?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
};

export type PetBenefitUsage = {
  __typename?: 'PetBenefitUsage';
  organizationPetId: Scalars['String'];
  usages: Array<UsageByBenefit>;
};

export type PetCountAggregateOutputType = {
  __typename?: 'PetCountAggregateOutputType';
  _all: Scalars['Int'];
  bornOn: Scalars['Int'];
  bornOnDay: Scalars['Int'];
  bornOnMonth: Scalars['Int'];
  bornOnYear: Scalars['Int'];
  breed: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  environment: Scalars['Int'];
  firebaseId: Scalars['Int'];
  gender: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  petParentId: Scalars['Int'];
  petType: Scalars['Int'];
  photo: Scalars['Int'];
  pimsId: Scalars['Int'];
  repoStatus: Scalars['Int'];
  updatedAt: Scalars['Int'];
  weight: Scalars['Int'];
};

export type PetCountOrderByAggregateInput = {
  bornOn?: Maybe<SortOrder>;
  bornOnDay?: Maybe<SortOrder>;
  bornOnMonth?: Maybe<SortOrder>;
  bornOnYear?: Maybe<SortOrder>;
  breed?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  environment?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  petType?: Maybe<SortOrder>;
  photo?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  repoStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
};

export type PetCountOutputType = {
  __typename?: 'PetCountOutputType';
  consultations: Scalars['Int'];
  previousClinics: Scalars['Int'];
};

export type PetCreateInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicCreateNestedOneWithoutPetsIdInput>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutPetsInput>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicCreateNestedManyWithoutPetsInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetCreateManyCurrentClinicInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petParentId?: Maybe<Scalars['String']>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetCreateManyCurrentClinicInputEnvelope = {
  data: Array<PetCreateManyCurrentClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PetCreateManyInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petParentId?: Maybe<Scalars['String']>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetCreateManyPetParentInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetCreateManyPetParentInputEnvelope = {
  data: Array<PetCreateManyPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PetCreateNestedManyWithoutCurrentClinicInput = {
  connect?: Maybe<Array<PetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PetCreateOrConnectWithoutCurrentClinicInput>>;
  create?: Maybe<Array<PetCreateWithoutCurrentClinicInput>>;
  createMany?: Maybe<PetCreateManyCurrentClinicInputEnvelope>;
};

export type PetCreateNestedManyWithoutPetParentInput = {
  connect?: Maybe<Array<PetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PetCreateOrConnectWithoutPetParentInput>>;
  create?: Maybe<Array<PetCreateWithoutPetParentInput>>;
  createMany?: Maybe<PetCreateManyPetParentInputEnvelope>;
};

export type PetCreateNestedManyWithoutPreviousClinicsInput = {
  connect?: Maybe<Array<PetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PetCreateOrConnectWithoutPreviousClinicsInput>>;
  create?: Maybe<Array<PetCreateWithoutPreviousClinicsInput>>;
};

export type PetCreateNestedOneWithoutConsultationsInput = {
  connect?: Maybe<PetWhereUniqueInput>;
  connectOrCreate?: Maybe<PetCreateOrConnectWithoutConsultationsInput>;
  create?: Maybe<PetCreateWithoutConsultationsInput>;
};

export type PetCreateOrConnectWithoutConsultationsInput = {
  create: PetCreateWithoutConsultationsInput;
  where: PetWhereUniqueInput;
};

export type PetCreateOrConnectWithoutCurrentClinicInput = {
  create: PetCreateWithoutCurrentClinicInput;
  where: PetWhereUniqueInput;
};

export type PetCreateOrConnectWithoutPetParentInput = {
  create: PetCreateWithoutPetParentInput;
  where: PetWhereUniqueInput;
};

export type PetCreateOrConnectWithoutPreviousClinicsInput = {
  create: PetCreateWithoutPreviousClinicsInput;
  where: PetWhereUniqueInput;
};

export type PetCreateWithoutConsultationsInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicCreateNestedOneWithoutPetsIdInput>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutPetsInput>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicCreateNestedManyWithoutPetsInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetCreateWithoutCurrentClinicInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutPetsInput>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicCreateNestedManyWithoutPetsInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetCreateWithoutPetParentInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicCreateNestedOneWithoutPetsIdInput>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicCreateNestedManyWithoutPetsInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetCreateWithoutPreviousClinicsInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicCreateNestedOneWithoutPetsIdInput>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petParent?: Maybe<OwnerInfoCreateNestedOneWithoutPetsInput>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetGroupByOutputType = {
  __typename?: 'PetGroupByOutputType';
  _avg?: Maybe<PetAvgAggregateOutputType>;
  _count?: Maybe<PetCountAggregateOutputType>;
  _max?: Maybe<PetMaxAggregateOutputType>;
  _min?: Maybe<PetMinAggregateOutputType>;
  _sum?: Maybe<PetSumAggregateOutputType>;
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  petParentId?: Maybe<Scalars['String']>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  weight: Scalars['Float'];
};

export type PetIdHistoryItem = {
  __typename?: 'PetIdHistoryItem';
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  dueDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
};

export type PetListRelationFilter = {
  every?: Maybe<PetWhereInput>;
  none?: Maybe<PetWhereInput>;
  some?: Maybe<PetWhereInput>;
};

export type PetMaxAggregateOutputType = {
  __typename?: 'PetMaxAggregateOutputType';
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetMaxOrderByAggregateInput = {
  bornOn?: Maybe<SortOrder>;
  bornOnDay?: Maybe<SortOrder>;
  bornOnMonth?: Maybe<SortOrder>;
  bornOnYear?: Maybe<SortOrder>;
  breed?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  environment?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  petType?: Maybe<SortOrder>;
  photo?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  repoStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
};

export type PetMinAggregateOutputType = {
  __typename?: 'PetMinAggregateOutputType';
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetMinOrderByAggregateInput = {
  bornOn?: Maybe<SortOrder>;
  bornOnDay?: Maybe<SortOrder>;
  bornOnMonth?: Maybe<SortOrder>;
  bornOnYear?: Maybe<SortOrder>;
  breed?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  environment?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  petType?: Maybe<SortOrder>;
  photo?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  repoStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
};

export type PetNullableScalarRelationFilter = {
  AND?: Maybe<Array<PetWhereInput>>;
  NOT?: Maybe<Array<PetWhereInput>>;
  OR?: Maybe<Array<PetWhereInput>>;
  bornOn?: Maybe<DateTimeNullableFilter>;
  bornOnDay?: Maybe<IntNullableFilter>;
  bornOnMonth?: Maybe<IntNullableFilter>;
  bornOnYear?: Maybe<IntNullableFilter>;
  breed?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  environment?: Maybe<StringFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  gender?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  petParent?: Maybe<OwnerInfoNullableScalarRelationFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  petType?: Maybe<StringFilter>;
  photo?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  previousClinics?: Maybe<ClinicListRelationFilter>;
  repoStatus?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  weight?: Maybe<FloatFilter>;
};

export type PetOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PetOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PetOrderByRelevanceInput>;
  bornOn?: Maybe<SortOrder>;
  bornOnDay?: Maybe<SortOrder>;
  bornOnMonth?: Maybe<SortOrder>;
  bornOnYear?: Maybe<SortOrder>;
  breed?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  consultations?: Maybe<ConsultationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  currentClinic?: Maybe<ClinicOrderByWithRelationInput>;
  environment?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  petParent?: Maybe<OwnerInfoOrderByWithRelationInput>;
  petParentId?: Maybe<SortOrder>;
  petType?: Maybe<SortOrder>;
  photo?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  previousClinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  repoStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
};

export enum PetOrderByRelevanceFieldEnum {
  Breed = 'breed',
  ClinicId = 'clinicId',
  Environment = 'environment',
  FirebaseId = 'firebaseId',
  Gender = 'gender',
  Id = 'id',
  Name = 'name',
  PetParentId = 'petParentId',
  PetType = 'petType',
  Photo = 'photo',
  PimsId = 'pimsId',
  RepoStatus = 'repoStatus'
}

export type PetOrderByRelevanceInput = {
  fields: Array<PetOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PetOrderByWithAggregationInput = {
  _avg?: Maybe<PetAvgOrderByAggregateInput>;
  _count?: Maybe<PetCountOrderByAggregateInput>;
  _max?: Maybe<PetMaxOrderByAggregateInput>;
  _min?: Maybe<PetMinOrderByAggregateInput>;
  _sum?: Maybe<PetSumOrderByAggregateInput>;
  bornOn?: Maybe<SortOrder>;
  bornOnDay?: Maybe<SortOrder>;
  bornOnMonth?: Maybe<SortOrder>;
  bornOnYear?: Maybe<SortOrder>;
  breed?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  environment?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  petParentId?: Maybe<SortOrder>;
  petType?: Maybe<SortOrder>;
  photo?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  repoStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
};

export type PetOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PetOrderByRelevanceInput>;
  bornOn?: Maybe<SortOrder>;
  bornOnDay?: Maybe<SortOrder>;
  bornOnMonth?: Maybe<SortOrder>;
  bornOnYear?: Maybe<SortOrder>;
  breed?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  consultations?: Maybe<ConsultationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  currentClinic?: Maybe<ClinicOrderByWithRelationInput>;
  environment?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  petParent?: Maybe<OwnerInfoOrderByWithRelationInput>;
  petParentId?: Maybe<SortOrder>;
  petType?: Maybe<SortOrder>;
  photo?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  previousClinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  repoStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
};

export type PetOrderByWithRelationInput = {
  _relevance?: Maybe<PetOrderByRelevanceInput>;
  bornOn?: Maybe<SortOrder>;
  bornOnDay?: Maybe<SortOrder>;
  bornOnMonth?: Maybe<SortOrder>;
  bornOnYear?: Maybe<SortOrder>;
  breed?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  consultations?: Maybe<ConsultationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  currentClinic?: Maybe<ClinicOrderByWithRelationInput>;
  environment?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  gender?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  petParent?: Maybe<OwnerInfoOrderByWithRelationInput>;
  petParentId?: Maybe<SortOrder>;
  petType?: Maybe<SortOrder>;
  photo?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  previousClinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  repoStatus?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
};

export type PetParentSetting = {
  __typename?: 'PetParentSetting';
  _count: PetParentSettingCountOutputType;
  createdAt: Scalars['DateTime'];
  emailNotifications: Scalars['Boolean'];
  emailOptedOutByPetParent: Scalars['Boolean'];
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isSubscribedToReminders: Scalars['Boolean'];
  petParent: Array<ClinicPetParent>;
  pushNotifications: Scalars['Boolean'];
  pushOptedOutByPetParent: Scalars['Boolean'];
  sendSurvey: Scalars['Boolean'];
  smsNotifications: Scalars['Boolean'];
  smsOptedOutByPetParent: Scalars['Boolean'];
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};


export type PetParentSettingPetParentArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};

export type PetParentSettingCountAggregateOutputType = {
  __typename?: 'PetParentSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  emailNotifications: Scalars['Int'];
  emailOptedOutByPetParent: Scalars['Int'];
  emailOptedOutByPetParentAt: Scalars['Int'];
  id: Scalars['Int'];
  isSubscribedToReminders: Scalars['Int'];
  pushNotifications: Scalars['Int'];
  pushOptedOutByPetParent: Scalars['Int'];
  sendSurvey: Scalars['Int'];
  smsNotifications: Scalars['Int'];
  smsOptedOutByPetParent: Scalars['Int'];
  smsOptedOutByPetParentAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PetParentSettingCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  emailOptedOutByPetParent?: Maybe<SortOrder>;
  emailOptedOutByPetParentAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  pushNotifications?: Maybe<SortOrder>;
  pushOptedOutByPetParent?: Maybe<SortOrder>;
  sendSurvey?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  smsOptedOutByPetParent?: Maybe<SortOrder>;
  smsOptedOutByPetParentAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PetParentSettingCountOutputType = {
  __typename?: 'PetParentSettingCountOutputType';
  petParent: Scalars['Int'];
};

export type PetParentSettingCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  petParent?: Maybe<ClinicPetParentCreateNestedManyWithoutPetParentSettingInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingCreateNestedOneWithoutPetParentInput = {
  connect?: Maybe<PetParentSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<PetParentSettingCreateOrConnectWithoutPetParentInput>;
  create?: Maybe<PetParentSettingCreateWithoutPetParentInput>;
};

export type PetParentSettingCreateOrConnectWithoutPetParentInput = {
  create: PetParentSettingCreateWithoutPetParentInput;
  where: PetParentSettingWhereUniqueInput;
};

export type PetParentSettingCreateWithoutPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingGroupByOutputType = {
  __typename?: 'PetParentSettingGroupByOutputType';
  _count?: Maybe<PetParentSettingCountAggregateOutputType>;
  _max?: Maybe<PetParentSettingMaxAggregateOutputType>;
  _min?: Maybe<PetParentSettingMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  emailNotifications: Scalars['Boolean'];
  emailOptedOutByPetParent: Scalars['Boolean'];
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isSubscribedToReminders: Scalars['Boolean'];
  pushNotifications: Scalars['Boolean'];
  pushOptedOutByPetParent: Scalars['Boolean'];
  sendSurvey: Scalars['Boolean'];
  smsNotifications: Scalars['Boolean'];
  smsOptedOutByPetParent: Scalars['Boolean'];
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type PetParentSettingMaxAggregateOutputType = {
  __typename?: 'PetParentSettingMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  emailOptedOutByPetParent?: Maybe<SortOrder>;
  emailOptedOutByPetParentAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  pushNotifications?: Maybe<SortOrder>;
  pushOptedOutByPetParent?: Maybe<SortOrder>;
  sendSurvey?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  smsOptedOutByPetParent?: Maybe<SortOrder>;
  smsOptedOutByPetParentAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PetParentSettingMinAggregateOutputType = {
  __typename?: 'PetParentSettingMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  emailOptedOutByPetParent?: Maybe<SortOrder>;
  emailOptedOutByPetParentAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  pushNotifications?: Maybe<SortOrder>;
  pushOptedOutByPetParent?: Maybe<SortOrder>;
  sendSurvey?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  smsOptedOutByPetParent?: Maybe<SortOrder>;
  smsOptedOutByPetParentAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PetParentSettingNullableScalarRelationFilter = {
  AND?: Maybe<Array<PetParentSettingWhereInput>>;
  NOT?: Maybe<Array<PetParentSettingWhereInput>>;
  OR?: Maybe<Array<PetParentSettingWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  emailNotifications?: Maybe<BoolFilter>;
  emailOptedOutByPetParent?: Maybe<BoolFilter>;
  emailOptedOutByPetParentAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  isSubscribedToReminders?: Maybe<BoolFilter>;
  petParent?: Maybe<ClinicPetParentListRelationFilter>;
  pushNotifications?: Maybe<BoolFilter>;
  pushOptedOutByPetParent?: Maybe<BoolFilter>;
  sendSurvey?: Maybe<BoolFilter>;
  smsNotifications?: Maybe<BoolFilter>;
  smsOptedOutByPetParent?: Maybe<BoolFilter>;
  smsOptedOutByPetParentAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PetParentSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PetParentSettingOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  emailOptedOutByPetParent?: Maybe<SortOrder>;
  emailOptedOutByPetParentAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  petParent?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  pushNotifications?: Maybe<SortOrder>;
  pushOptedOutByPetParent?: Maybe<SortOrder>;
  sendSurvey?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  smsOptedOutByPetParent?: Maybe<SortOrder>;
  smsOptedOutByPetParentAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PetParentSettingOrderByRelevanceFieldEnum {
  Id = 'id'
}

export type PetParentSettingOrderByRelevanceInput = {
  fields: Array<PetParentSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PetParentSettingOrderByWithAggregationInput = {
  _count?: Maybe<PetParentSettingCountOrderByAggregateInput>;
  _max?: Maybe<PetParentSettingMaxOrderByAggregateInput>;
  _min?: Maybe<PetParentSettingMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  emailOptedOutByPetParent?: Maybe<SortOrder>;
  emailOptedOutByPetParentAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  pushNotifications?: Maybe<SortOrder>;
  pushOptedOutByPetParent?: Maybe<SortOrder>;
  sendSurvey?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  smsOptedOutByPetParent?: Maybe<SortOrder>;
  smsOptedOutByPetParentAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PetParentSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PetParentSettingOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  emailOptedOutByPetParent?: Maybe<SortOrder>;
  emailOptedOutByPetParentAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  petParent?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  pushNotifications?: Maybe<SortOrder>;
  pushOptedOutByPetParent?: Maybe<SortOrder>;
  sendSurvey?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  smsOptedOutByPetParent?: Maybe<SortOrder>;
  smsOptedOutByPetParentAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PetParentSettingOrderByWithRelationInput = {
  _relevance?: Maybe<PetParentSettingOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  emailOptedOutByPetParent?: Maybe<SortOrder>;
  emailOptedOutByPetParentAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSubscribedToReminders?: Maybe<SortOrder>;
  petParent?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  pushNotifications?: Maybe<SortOrder>;
  pushOptedOutByPetParent?: Maybe<SortOrder>;
  sendSurvey?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  smsOptedOutByPetParent?: Maybe<SortOrder>;
  smsOptedOutByPetParentAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PetParentSettingScalarFieldEnum {
  CreatedAt = 'createdAt',
  EmailNotifications = 'emailNotifications',
  EmailOptedOutByPetParent = 'emailOptedOutByPetParent',
  EmailOptedOutByPetParentAt = 'emailOptedOutByPetParentAt',
  Id = 'id',
  IsSubscribedToReminders = 'isSubscribedToReminders',
  PushNotifications = 'pushNotifications',
  PushOptedOutByPetParent = 'pushOptedOutByPetParent',
  SendSurvey = 'sendSurvey',
  SmsNotifications = 'smsNotifications',
  SmsOptedOutByPetParent = 'smsOptedOutByPetParent',
  SmsOptedOutByPetParentAt = 'smsOptedOutByPetParentAt',
  UpdatedAt = 'updatedAt'
}

export type PetParentSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PetParentSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PetParentSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PetParentSettingScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  emailNotifications?: Maybe<BoolWithAggregatesFilter>;
  emailOptedOutByPetParent?: Maybe<BoolWithAggregatesFilter>;
  emailOptedOutByPetParentAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isSubscribedToReminders?: Maybe<BoolWithAggregatesFilter>;
  pushNotifications?: Maybe<BoolWithAggregatesFilter>;
  pushOptedOutByPetParent?: Maybe<BoolWithAggregatesFilter>;
  sendSurvey?: Maybe<BoolWithAggregatesFilter>;
  smsNotifications?: Maybe<BoolWithAggregatesFilter>;
  smsOptedOutByPetParent?: Maybe<BoolWithAggregatesFilter>;
  smsOptedOutByPetParentAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type PetParentSettingUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  petParent?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutPetParentSettingInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingUncheckedCreateWithoutPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  petParent?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutPetParentSettingNestedInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingUncheckedUpdateWithoutPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  petParent?: Maybe<ClinicPetParentUpdateManyWithoutPetParentSettingNestedInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingUpdateOneWithoutPetParentNestedInput = {
  connect?: Maybe<PetParentSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<PetParentSettingCreateOrConnectWithoutPetParentInput>;
  create?: Maybe<PetParentSettingCreateWithoutPetParentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PetParentSettingUpdateToOneWithWhereWithoutPetParentInput>;
  upsert?: Maybe<PetParentSettingUpsertWithoutPetParentInput>;
};

export type PetParentSettingUpdateToOneWithWhereWithoutPetParentInput = {
  data: PetParentSettingUpdateWithoutPetParentInput;
  where?: Maybe<PetParentSettingWhereInput>;
};

export type PetParentSettingUpdateWithoutPetParentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  emailOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  pushOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  sendSurvey?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParent?: Maybe<Scalars['Boolean']>;
  smsOptedOutByPetParentAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetParentSettingUpsertWithoutPetParentInput = {
  create: PetParentSettingCreateWithoutPetParentInput;
  update: PetParentSettingUpdateWithoutPetParentInput;
  where?: Maybe<PetParentSettingWhereInput>;
};

export type PetParentSettingWhereInput = {
  AND?: Maybe<Array<PetParentSettingWhereInput>>;
  NOT?: Maybe<Array<PetParentSettingWhereInput>>;
  OR?: Maybe<Array<PetParentSettingWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  emailNotifications?: Maybe<BoolFilter>;
  emailOptedOutByPetParent?: Maybe<BoolFilter>;
  emailOptedOutByPetParentAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  isSubscribedToReminders?: Maybe<BoolFilter>;
  petParent?: Maybe<ClinicPetParentListRelationFilter>;
  pushNotifications?: Maybe<BoolFilter>;
  pushOptedOutByPetParent?: Maybe<BoolFilter>;
  sendSurvey?: Maybe<BoolFilter>;
  smsNotifications?: Maybe<BoolFilter>;
  smsOptedOutByPetParent?: Maybe<BoolFilter>;
  smsOptedOutByPetParentAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PetParentSettingWhereUniqueInput = {
  AND?: Maybe<Array<PetParentSettingWhereInput>>;
  NOT?: Maybe<Array<PetParentSettingWhereInput>>;
  OR?: Maybe<Array<PetParentSettingWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  emailNotifications?: Maybe<BoolFilter>;
  emailOptedOutByPetParent?: Maybe<BoolFilter>;
  emailOptedOutByPetParentAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isSubscribedToReminders?: Maybe<BoolFilter>;
  petParent?: Maybe<ClinicPetParentListRelationFilter>;
  pushNotifications?: Maybe<BoolFilter>;
  pushOptedOutByPetParent?: Maybe<BoolFilter>;
  sendSurvey?: Maybe<BoolFilter>;
  smsNotifications?: Maybe<BoolFilter>;
  smsOptedOutByPetParent?: Maybe<BoolFilter>;
  smsOptedOutByPetParentAt?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PetPortalSetting = {
  __typename?: 'PetPortalSetting';
  clinicSetting: ClinicSetting;
  clinicSettingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  showAppointments: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type PetPortalSettingCountAggregateOutputType = {
  __typename?: 'PetPortalSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicSettingId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  showAppointments: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PetPortalSettingCountOrderByAggregateInput = {
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  showAppointments?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PetPortalSettingCreateInput = {
  clinicSetting: ClinicSettingCreateNestedOneWithoutPetPortalSettingInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingCreateManyInput = {
  clinicSettingId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingCreateNestedOneWithoutClinicSettingInput = {
  connect?: Maybe<PetPortalSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<PetPortalSettingCreateOrConnectWithoutClinicSettingInput>;
  create?: Maybe<PetPortalSettingCreateWithoutClinicSettingInput>;
};

export type PetPortalSettingCreateOrConnectWithoutClinicSettingInput = {
  create: PetPortalSettingCreateWithoutClinicSettingInput;
  where: PetPortalSettingWhereUniqueInput;
};

export type PetPortalSettingCreateWithoutClinicSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingGroupByOutputType = {
  __typename?: 'PetPortalSettingGroupByOutputType';
  _count?: Maybe<PetPortalSettingCountAggregateOutputType>;
  _max?: Maybe<PetPortalSettingMaxAggregateOutputType>;
  _min?: Maybe<PetPortalSettingMinAggregateOutputType>;
  clinicSettingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  showAppointments: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type PetPortalSettingMaxAggregateOutputType = {
  __typename?: 'PetPortalSettingMaxAggregateOutputType';
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingMaxOrderByAggregateInput = {
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  showAppointments?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PetPortalSettingMinAggregateOutputType = {
  __typename?: 'PetPortalSettingMinAggregateOutputType';
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingMinOrderByAggregateInput = {
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  showAppointments?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PetPortalSettingNullableScalarRelationFilter = {
  AND?: Maybe<Array<PetPortalSettingWhereInput>>;
  NOT?: Maybe<Array<PetPortalSettingWhereInput>>;
  OR?: Maybe<Array<PetPortalSettingWhereInput>>;
  clinicSetting?: Maybe<ClinicSettingScalarRelationFilter>;
  clinicSettingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  showAppointments?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PetPortalSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PetPortalSettingOrderByRelevanceInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  showAppointments?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PetPortalSettingOrderByRelevanceFieldEnum {
  ClinicSettingId = 'clinicSettingId',
  Id = 'id'
}

export type PetPortalSettingOrderByRelevanceInput = {
  fields: Array<PetPortalSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PetPortalSettingOrderByWithAggregationInput = {
  _count?: Maybe<PetPortalSettingCountOrderByAggregateInput>;
  _max?: Maybe<PetPortalSettingMaxOrderByAggregateInput>;
  _min?: Maybe<PetPortalSettingMinOrderByAggregateInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  showAppointments?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PetPortalSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PetPortalSettingOrderByRelevanceInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  showAppointments?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PetPortalSettingOrderByWithRelationInput = {
  _relevance?: Maybe<PetPortalSettingOrderByRelevanceInput>;
  clinicSetting?: Maybe<ClinicSettingOrderByWithRelationInput>;
  clinicSettingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  showAppointments?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PetPortalSettingScalarFieldEnum {
  ClinicSettingId = 'clinicSettingId',
  CreatedAt = 'createdAt',
  Id = 'id',
  ShowAppointments = 'showAppointments',
  UpdatedAt = 'updatedAt'
}

export type PetPortalSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PetPortalSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PetPortalSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PetPortalSettingScalarWhereWithAggregatesInput>>;
  clinicSettingId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  showAppointments?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type PetPortalSettingUncheckedCreateInput = {
  clinicSettingId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingUncheckedCreateNestedOneWithoutClinicSettingInput = {
  connect?: Maybe<PetPortalSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<PetPortalSettingCreateOrConnectWithoutClinicSettingInput>;
  create?: Maybe<PetPortalSettingCreateWithoutClinicSettingInput>;
};

export type PetPortalSettingUncheckedCreateWithoutClinicSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingUncheckedUpdateInput = {
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingUncheckedUpdateManyInput = {
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingUncheckedUpdateOneWithoutClinicSettingNestedInput = {
  connect?: Maybe<PetPortalSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<PetPortalSettingCreateOrConnectWithoutClinicSettingInput>;
  create?: Maybe<PetPortalSettingCreateWithoutClinicSettingInput>;
  delete?: Maybe<PetPortalSettingWhereInput>;
  disconnect?: Maybe<PetPortalSettingWhereInput>;
  update?: Maybe<PetPortalSettingUpdateToOneWithWhereWithoutClinicSettingInput>;
  upsert?: Maybe<PetPortalSettingUpsertWithoutClinicSettingInput>;
};

export type PetPortalSettingUncheckedUpdateWithoutClinicSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingUpdateInput = {
  clinicSetting?: Maybe<ClinicSettingUpdateOneRequiredWithoutPetPortalSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingUpdateOneWithoutClinicSettingNestedInput = {
  connect?: Maybe<PetPortalSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<PetPortalSettingCreateOrConnectWithoutClinicSettingInput>;
  create?: Maybe<PetPortalSettingCreateWithoutClinicSettingInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PetPortalSettingUpdateToOneWithWhereWithoutClinicSettingInput>;
  upsert?: Maybe<PetPortalSettingUpsertWithoutClinicSettingInput>;
};

export type PetPortalSettingUpdateToOneWithWhereWithoutClinicSettingInput = {
  data: PetPortalSettingUpdateWithoutClinicSettingInput;
  where?: Maybe<PetPortalSettingWhereInput>;
};

export type PetPortalSettingUpdateWithoutClinicSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PetPortalSettingUpsertWithoutClinicSettingInput = {
  create: PetPortalSettingCreateWithoutClinicSettingInput;
  update: PetPortalSettingUpdateWithoutClinicSettingInput;
  where?: Maybe<PetPortalSettingWhereInput>;
};

export type PetPortalSettingWhereInput = {
  AND?: Maybe<Array<PetPortalSettingWhereInput>>;
  NOT?: Maybe<Array<PetPortalSettingWhereInput>>;
  OR?: Maybe<Array<PetPortalSettingWhereInput>>;
  clinicSetting?: Maybe<ClinicSettingScalarRelationFilter>;
  clinicSettingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  showAppointments?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PetPortalSettingWhereUniqueInput = {
  AND?: Maybe<Array<PetPortalSettingWhereInput>>;
  NOT?: Maybe<Array<PetPortalSettingWhereInput>>;
  OR?: Maybe<Array<PetPortalSettingWhereInput>>;
  clinicSetting?: Maybe<ClinicSettingScalarRelationFilter>;
  clinicSettingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  showAppointments?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum PetScalarFieldEnum {
  BornOn = 'bornOn',
  BornOnDay = 'bornOnDay',
  BornOnMonth = 'bornOnMonth',
  BornOnYear = 'bornOnYear',
  Breed = 'breed',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Environment = 'environment',
  FirebaseId = 'firebaseId',
  Gender = 'gender',
  Id = 'id',
  Name = 'name',
  PetParentId = 'petParentId',
  PetType = 'petType',
  Photo = 'photo',
  PimsId = 'pimsId',
  RepoStatus = 'repoStatus',
  UpdatedAt = 'updatedAt',
  Weight = 'weight'
}

export type PetScalarWhereInput = {
  AND?: Maybe<Array<PetScalarWhereInput>>;
  NOT?: Maybe<Array<PetScalarWhereInput>>;
  OR?: Maybe<Array<PetScalarWhereInput>>;
  bornOn?: Maybe<DateTimeNullableFilter>;
  bornOnDay?: Maybe<IntNullableFilter>;
  bornOnMonth?: Maybe<IntNullableFilter>;
  bornOnYear?: Maybe<IntNullableFilter>;
  breed?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  environment?: Maybe<StringFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  gender?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  petType?: Maybe<StringFilter>;
  photo?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  repoStatus?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  weight?: Maybe<FloatFilter>;
};

export type PetScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PetScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PetScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PetScalarWhereWithAggregatesInput>>;
  bornOn?: Maybe<DateTimeNullableWithAggregatesFilter>;
  bornOnDay?: Maybe<IntNullableWithAggregatesFilter>;
  bornOnMonth?: Maybe<IntNullableWithAggregatesFilter>;
  bornOnYear?: Maybe<IntNullableWithAggregatesFilter>;
  breed?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  environment?: Maybe<StringWithAggregatesFilter>;
  firebaseId?: Maybe<StringNullableWithAggregatesFilter>;
  gender?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  petParentId?: Maybe<StringNullableWithAggregatesFilter>;
  petType?: Maybe<StringWithAggregatesFilter>;
  photo?: Maybe<StringNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  repoStatus?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  weight?: Maybe<FloatWithAggregatesFilter>;
};

export type PetSumAggregateOutputType = {
  __typename?: 'PetSumAggregateOutputType';
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetSumOrderByAggregateInput = {
  bornOnDay?: Maybe<SortOrder>;
  bornOnMonth?: Maybe<SortOrder>;
  bornOnYear?: Maybe<SortOrder>;
  weight?: Maybe<SortOrder>;
};

export type PetUncheckedCreateInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petParentId?: Maybe<Scalars['String']>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutPetsInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedCreateNestedManyWithoutCurrentClinicInput = {
  connect?: Maybe<Array<PetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PetCreateOrConnectWithoutCurrentClinicInput>>;
  create?: Maybe<Array<PetCreateWithoutCurrentClinicInput>>;
  createMany?: Maybe<PetCreateManyCurrentClinicInputEnvelope>;
};

export type PetUncheckedCreateNestedManyWithoutPetParentInput = {
  connect?: Maybe<Array<PetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PetCreateOrConnectWithoutPetParentInput>>;
  create?: Maybe<Array<PetCreateWithoutPetParentInput>>;
  createMany?: Maybe<PetCreateManyPetParentInputEnvelope>;
};

export type PetUncheckedCreateNestedManyWithoutPreviousClinicsInput = {
  connect?: Maybe<Array<PetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PetCreateOrConnectWithoutPreviousClinicsInput>>;
  create?: Maybe<Array<PetCreateWithoutPreviousClinicsInput>>;
};

export type PetUncheckedCreateWithoutConsultationsInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petParentId?: Maybe<Scalars['String']>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutPetsInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedCreateWithoutCurrentClinicInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petParentId?: Maybe<Scalars['String']>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutPetsInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedCreateWithoutPetParentInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutPetsInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedCreateWithoutPreviousClinicsInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutPetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petParentId?: Maybe<Scalars['String']>;
  petType: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedUpdateInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicUncheckedUpdateManyWithoutPetsNestedInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedUpdateManyInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedUpdateManyWithoutCurrentClinicInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedUpdateManyWithoutCurrentClinicNestedInput = {
  connect?: Maybe<Array<PetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PetCreateOrConnectWithoutCurrentClinicInput>>;
  create?: Maybe<Array<PetCreateWithoutCurrentClinicInput>>;
  createMany?: Maybe<PetCreateManyCurrentClinicInputEnvelope>;
  delete?: Maybe<Array<PetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PetScalarWhereInput>>;
  disconnect?: Maybe<Array<PetWhereUniqueInput>>;
  set?: Maybe<Array<PetWhereUniqueInput>>;
  update?: Maybe<Array<PetUpdateWithWhereUniqueWithoutCurrentClinicInput>>;
  updateMany?: Maybe<Array<PetUpdateManyWithWhereWithoutCurrentClinicInput>>;
  upsert?: Maybe<Array<PetUpsertWithWhereUniqueWithoutCurrentClinicInput>>;
};

export type PetUncheckedUpdateManyWithoutPetParentInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedUpdateManyWithoutPetParentNestedInput = {
  connect?: Maybe<Array<PetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PetCreateOrConnectWithoutPetParentInput>>;
  create?: Maybe<Array<PetCreateWithoutPetParentInput>>;
  createMany?: Maybe<PetCreateManyPetParentInputEnvelope>;
  delete?: Maybe<Array<PetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PetScalarWhereInput>>;
  disconnect?: Maybe<Array<PetWhereUniqueInput>>;
  set?: Maybe<Array<PetWhereUniqueInput>>;
  update?: Maybe<Array<PetUpdateWithWhereUniqueWithoutPetParentInput>>;
  updateMany?: Maybe<Array<PetUpdateManyWithWhereWithoutPetParentInput>>;
  upsert?: Maybe<Array<PetUpsertWithWhereUniqueWithoutPetParentInput>>;
};

export type PetUncheckedUpdateManyWithoutPreviousClinicsInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedUpdateManyWithoutPreviousClinicsNestedInput = {
  connect?: Maybe<Array<PetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PetCreateOrConnectWithoutPreviousClinicsInput>>;
  create?: Maybe<Array<PetCreateWithoutPreviousClinicsInput>>;
  delete?: Maybe<Array<PetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PetScalarWhereInput>>;
  disconnect?: Maybe<Array<PetWhereUniqueInput>>;
  set?: Maybe<Array<PetWhereUniqueInput>>;
  update?: Maybe<Array<PetUpdateWithWhereUniqueWithoutPreviousClinicsInput>>;
  updateMany?: Maybe<Array<PetUpdateManyWithWhereWithoutPreviousClinicsInput>>;
  upsert?: Maybe<Array<PetUpsertWithWhereUniqueWithoutPreviousClinicsInput>>;
};

export type PetUncheckedUpdateWithoutConsultationsInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicUncheckedUpdateManyWithoutPetsNestedInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedUpdateWithoutCurrentClinicInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicUncheckedUpdateManyWithoutPetsNestedInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedUpdateWithoutPetParentInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicUncheckedUpdateManyWithoutPetsNestedInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUncheckedUpdateWithoutPreviousClinicsInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUpdateInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationUpdateManyWithoutPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicUpdateOneWithoutPetsIdNestedInput>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutPetsNestedInput>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicUpdateManyWithoutPetsNestedInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUpdateManyMutationInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUpdateManyWithWhereWithoutCurrentClinicInput = {
  data: PetUpdateManyMutationInput;
  where: PetScalarWhereInput;
};

export type PetUpdateManyWithWhereWithoutPetParentInput = {
  data: PetUpdateManyMutationInput;
  where: PetScalarWhereInput;
};

export type PetUpdateManyWithWhereWithoutPreviousClinicsInput = {
  data: PetUpdateManyMutationInput;
  where: PetScalarWhereInput;
};

export type PetUpdateManyWithoutCurrentClinicNestedInput = {
  connect?: Maybe<Array<PetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PetCreateOrConnectWithoutCurrentClinicInput>>;
  create?: Maybe<Array<PetCreateWithoutCurrentClinicInput>>;
  createMany?: Maybe<PetCreateManyCurrentClinicInputEnvelope>;
  delete?: Maybe<Array<PetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PetScalarWhereInput>>;
  disconnect?: Maybe<Array<PetWhereUniqueInput>>;
  set?: Maybe<Array<PetWhereUniqueInput>>;
  update?: Maybe<Array<PetUpdateWithWhereUniqueWithoutCurrentClinicInput>>;
  updateMany?: Maybe<Array<PetUpdateManyWithWhereWithoutCurrentClinicInput>>;
  upsert?: Maybe<Array<PetUpsertWithWhereUniqueWithoutCurrentClinicInput>>;
};

export type PetUpdateManyWithoutPetParentNestedInput = {
  connect?: Maybe<Array<PetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PetCreateOrConnectWithoutPetParentInput>>;
  create?: Maybe<Array<PetCreateWithoutPetParentInput>>;
  createMany?: Maybe<PetCreateManyPetParentInputEnvelope>;
  delete?: Maybe<Array<PetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PetScalarWhereInput>>;
  disconnect?: Maybe<Array<PetWhereUniqueInput>>;
  set?: Maybe<Array<PetWhereUniqueInput>>;
  update?: Maybe<Array<PetUpdateWithWhereUniqueWithoutPetParentInput>>;
  updateMany?: Maybe<Array<PetUpdateManyWithWhereWithoutPetParentInput>>;
  upsert?: Maybe<Array<PetUpsertWithWhereUniqueWithoutPetParentInput>>;
};

export type PetUpdateManyWithoutPreviousClinicsNestedInput = {
  connect?: Maybe<Array<PetWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PetCreateOrConnectWithoutPreviousClinicsInput>>;
  create?: Maybe<Array<PetCreateWithoutPreviousClinicsInput>>;
  delete?: Maybe<Array<PetWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PetScalarWhereInput>>;
  disconnect?: Maybe<Array<PetWhereUniqueInput>>;
  set?: Maybe<Array<PetWhereUniqueInput>>;
  update?: Maybe<Array<PetUpdateWithWhereUniqueWithoutPreviousClinicsInput>>;
  updateMany?: Maybe<Array<PetUpdateManyWithWhereWithoutPreviousClinicsInput>>;
  upsert?: Maybe<Array<PetUpsertWithWhereUniqueWithoutPreviousClinicsInput>>;
};

export type PetUpdateOneWithoutConsultationsNestedInput = {
  connect?: Maybe<PetWhereUniqueInput>;
  connectOrCreate?: Maybe<PetCreateOrConnectWithoutConsultationsInput>;
  create?: Maybe<PetCreateWithoutConsultationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PetUpdateToOneWithWhereWithoutConsultationsInput>;
  upsert?: Maybe<PetUpsertWithoutConsultationsInput>;
};

export type PetUpdateToOneWithWhereWithoutConsultationsInput = {
  data: PetUpdateWithoutConsultationsInput;
  where?: Maybe<PetWhereInput>;
};

export type PetUpdateWithWhereUniqueWithoutCurrentClinicInput = {
  data: PetUpdateWithoutCurrentClinicInput;
  where: PetWhereUniqueInput;
};

export type PetUpdateWithWhereUniqueWithoutPetParentInput = {
  data: PetUpdateWithoutPetParentInput;
  where: PetWhereUniqueInput;
};

export type PetUpdateWithWhereUniqueWithoutPreviousClinicsInput = {
  data: PetUpdateWithoutPreviousClinicsInput;
  where: PetWhereUniqueInput;
};

export type PetUpdateWithoutConsultationsInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicUpdateOneWithoutPetsIdNestedInput>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutPetsNestedInput>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicUpdateManyWithoutPetsNestedInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUpdateWithoutCurrentClinicInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationUpdateManyWithoutPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutPetsNestedInput>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicUpdateManyWithoutPetsNestedInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUpdateWithoutPetParentInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationUpdateManyWithoutPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicUpdateOneWithoutPetsIdNestedInput>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  previousClinics?: Maybe<ClinicUpdateManyWithoutPetsNestedInput>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUpdateWithoutPreviousClinicsInput = {
  bornOn?: Maybe<Scalars['DateTime']>;
  bornOnDay?: Maybe<Scalars['Int']>;
  bornOnMonth?: Maybe<Scalars['Int']>;
  bornOnYear?: Maybe<Scalars['Int']>;
  breed?: Maybe<Scalars['String']>;
  consultations?: Maybe<ConsultationUpdateManyWithoutPetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicUpdateOneWithoutPetsIdNestedInput>;
  environment?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  petParent?: Maybe<OwnerInfoUpdateOneWithoutPetsNestedInput>;
  petType?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  repoStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PetUpsertWithWhereUniqueWithoutCurrentClinicInput = {
  create: PetCreateWithoutCurrentClinicInput;
  update: PetUpdateWithoutCurrentClinicInput;
  where: PetWhereUniqueInput;
};

export type PetUpsertWithWhereUniqueWithoutPetParentInput = {
  create: PetCreateWithoutPetParentInput;
  update: PetUpdateWithoutPetParentInput;
  where: PetWhereUniqueInput;
};

export type PetUpsertWithWhereUniqueWithoutPreviousClinicsInput = {
  create: PetCreateWithoutPreviousClinicsInput;
  update: PetUpdateWithoutPreviousClinicsInput;
  where: PetWhereUniqueInput;
};

export type PetUpsertWithoutConsultationsInput = {
  create: PetCreateWithoutConsultationsInput;
  update: PetUpdateWithoutConsultationsInput;
  where?: Maybe<PetWhereInput>;
};

export type PetWhereInput = {
  AND?: Maybe<Array<PetWhereInput>>;
  NOT?: Maybe<Array<PetWhereInput>>;
  OR?: Maybe<Array<PetWhereInput>>;
  bornOn?: Maybe<DateTimeNullableFilter>;
  bornOnDay?: Maybe<IntNullableFilter>;
  bornOnMonth?: Maybe<IntNullableFilter>;
  bornOnYear?: Maybe<IntNullableFilter>;
  breed?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  environment?: Maybe<StringFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  gender?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  petParent?: Maybe<OwnerInfoNullableScalarRelationFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  petType?: Maybe<StringFilter>;
  photo?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  previousClinics?: Maybe<ClinicListRelationFilter>;
  repoStatus?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  weight?: Maybe<FloatFilter>;
};

export type PetWhereUniqueInput = {
  AND?: Maybe<Array<PetWhereInput>>;
  NOT?: Maybe<Array<PetWhereInput>>;
  OR?: Maybe<Array<PetWhereInput>>;
  bornOn?: Maybe<DateTimeNullableFilter>;
  bornOnDay?: Maybe<IntNullableFilter>;
  bornOnMonth?: Maybe<IntNullableFilter>;
  bornOnYear?: Maybe<IntNullableFilter>;
  breed?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  environment?: Maybe<StringFilter>;
  firebaseId?: Maybe<Scalars['String']>;
  gender?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<StringFilter>;
  petParent?: Maybe<OwnerInfoNullableScalarRelationFilter>;
  petParentId?: Maybe<StringNullableFilter>;
  petType?: Maybe<StringFilter>;
  photo?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  previousClinics?: Maybe<ClinicListRelationFilter>;
  repoStatus?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  weight?: Maybe<FloatFilter>;
};

export type PhoneNumberLookupRequest = {
  __typename?: 'PhoneNumberLookupRequest';
  _count: PhoneNumberLookupRequestCountOutputType;
  clinicEntityPhoneNumbers: Array<ClinicEntityPhoneNumber>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  providerRequestId: Scalars['String'];
  results: Array<PhoneNumberLookupResult>;
  status: PhoneNumberLookupRequestStatus;
  updatedAt: Scalars['DateTime'];
};


export type PhoneNumberLookupRequestClinicEntityPhoneNumbersArgs = {
  cursor?: Maybe<ClinicEntityPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEntityPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEntityPhoneNumberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEntityPhoneNumberWhereInput>;
};


export type PhoneNumberLookupRequestResultsArgs = {
  cursor?: Maybe<PhoneNumberLookupResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PhoneNumberLookupResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PhoneNumberLookupResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PhoneNumberLookupResultWhereInput>;
};

export type PhoneNumberLookupRequestCountAggregateOutputType = {
  __typename?: 'PhoneNumberLookupRequestCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  providerRequestId: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PhoneNumberLookupRequestCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerRequestId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PhoneNumberLookupRequestCountOutputType = {
  __typename?: 'PhoneNumberLookupRequestCountOutputType';
  clinicEntityPhoneNumbers: Scalars['Int'];
  results: Scalars['Int'];
};

export type PhoneNumberLookupRequestCreateInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutPhoneNumberLookupRequestInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId: Scalars['String'];
  results?: Maybe<PhoneNumberLookupResultCreateNestedManyWithoutRequestInput>;
  status: PhoneNumberLookupRequestStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId: Scalars['String'];
  status: PhoneNumberLookupRequestStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestCreateNestedOneWithoutClinicEntityPhoneNumbersInput = {
  connect?: Maybe<PhoneNumberLookupRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<PhoneNumberLookupRequestCreateOrConnectWithoutClinicEntityPhoneNumbersInput>;
  create?: Maybe<PhoneNumberLookupRequestCreateWithoutClinicEntityPhoneNumbersInput>;
};

export type PhoneNumberLookupRequestCreateNestedOneWithoutResultsInput = {
  connect?: Maybe<PhoneNumberLookupRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<PhoneNumberLookupRequestCreateOrConnectWithoutResultsInput>;
  create?: Maybe<PhoneNumberLookupRequestCreateWithoutResultsInput>;
};

export type PhoneNumberLookupRequestCreateOrConnectWithoutClinicEntityPhoneNumbersInput = {
  create: PhoneNumberLookupRequestCreateWithoutClinicEntityPhoneNumbersInput;
  where: PhoneNumberLookupRequestWhereUniqueInput;
};

export type PhoneNumberLookupRequestCreateOrConnectWithoutResultsInput = {
  create: PhoneNumberLookupRequestCreateWithoutResultsInput;
  where: PhoneNumberLookupRequestWhereUniqueInput;
};

export type PhoneNumberLookupRequestCreateWithoutClinicEntityPhoneNumbersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId: Scalars['String'];
  results?: Maybe<PhoneNumberLookupResultCreateNestedManyWithoutRequestInput>;
  status: PhoneNumberLookupRequestStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestCreateWithoutResultsInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutPhoneNumberLookupRequestInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId: Scalars['String'];
  status: PhoneNumberLookupRequestStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestGroupByOutputType = {
  __typename?: 'PhoneNumberLookupRequestGroupByOutputType';
  _count?: Maybe<PhoneNumberLookupRequestCountAggregateOutputType>;
  _max?: Maybe<PhoneNumberLookupRequestMaxAggregateOutputType>;
  _min?: Maybe<PhoneNumberLookupRequestMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  providerRequestId: Scalars['String'];
  status: PhoneNumberLookupRequestStatus;
  updatedAt: Scalars['DateTime'];
};

export type PhoneNumberLookupRequestMaxAggregateOutputType = {
  __typename?: 'PhoneNumberLookupRequestMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId?: Maybe<Scalars['String']>;
  status?: Maybe<PhoneNumberLookupRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerRequestId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PhoneNumberLookupRequestMinAggregateOutputType = {
  __typename?: 'PhoneNumberLookupRequestMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId?: Maybe<Scalars['String']>;
  status?: Maybe<PhoneNumberLookupRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerRequestId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PhoneNumberLookupRequestNullableScalarRelationFilter = {
  AND?: Maybe<Array<PhoneNumberLookupRequestWhereInput>>;
  NOT?: Maybe<Array<PhoneNumberLookupRequestWhereInput>>;
  OR?: Maybe<Array<PhoneNumberLookupRequestWhereInput>>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  providerRequestId?: Maybe<StringFilter>;
  results?: Maybe<PhoneNumberLookupResultListRelationFilter>;
  status?: Maybe<EnumPhoneNumberLookupRequestStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PhoneNumberLookupRequestOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PhoneNumberLookupRequestOrderByRelevanceInput>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerRequestId?: Maybe<SortOrder>;
  results?: Maybe<PhoneNumberLookupResultOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PhoneNumberLookupRequestOrderByRelevanceFieldEnum {
  Id = 'id',
  ProviderRequestId = 'providerRequestId'
}

export type PhoneNumberLookupRequestOrderByRelevanceInput = {
  fields: Array<PhoneNumberLookupRequestOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PhoneNumberLookupRequestOrderByWithAggregationInput = {
  _count?: Maybe<PhoneNumberLookupRequestCountOrderByAggregateInput>;
  _max?: Maybe<PhoneNumberLookupRequestMaxOrderByAggregateInput>;
  _min?: Maybe<PhoneNumberLookupRequestMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerRequestId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PhoneNumberLookupRequestOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PhoneNumberLookupRequestOrderByRelevanceInput>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerRequestId?: Maybe<SortOrder>;
  results?: Maybe<PhoneNumberLookupResultOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PhoneNumberLookupRequestOrderByWithRelationInput = {
  _relevance?: Maybe<PhoneNumberLookupRequestOrderByRelevanceInput>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerRequestId?: Maybe<SortOrder>;
  results?: Maybe<PhoneNumberLookupResultOrderByRelationAggregateInput>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PhoneNumberLookupRequestScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ProviderRequestId = 'providerRequestId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type PhoneNumberLookupRequestScalarRelationFilter = {
  AND?: Maybe<Array<PhoneNumberLookupRequestWhereInput>>;
  NOT?: Maybe<Array<PhoneNumberLookupRequestWhereInput>>;
  OR?: Maybe<Array<PhoneNumberLookupRequestWhereInput>>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  providerRequestId?: Maybe<StringFilter>;
  results?: Maybe<PhoneNumberLookupResultListRelationFilter>;
  status?: Maybe<EnumPhoneNumberLookupRequestStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PhoneNumberLookupRequestScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PhoneNumberLookupRequestScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PhoneNumberLookupRequestScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PhoneNumberLookupRequestScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  providerRequestId?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumPhoneNumberLookupRequestStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum PhoneNumberLookupRequestStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  PartialComplete = 'PARTIAL_COMPLETE'
}

export type PhoneNumberLookupRequestUncheckedCreateInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutPhoneNumberLookupRequestInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId: Scalars['String'];
  results?: Maybe<PhoneNumberLookupResultUncheckedCreateNestedManyWithoutRequestInput>;
  status: PhoneNumberLookupRequestStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestUncheckedCreateWithoutClinicEntityPhoneNumbersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId: Scalars['String'];
  results?: Maybe<PhoneNumberLookupResultUncheckedCreateNestedManyWithoutRequestInput>;
  status: PhoneNumberLookupRequestStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestUncheckedCreateWithoutResultsInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutPhoneNumberLookupRequestInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId: Scalars['String'];
  status: PhoneNumberLookupRequestStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestUncheckedUpdateInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutPhoneNumberLookupRequestNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId?: Maybe<Scalars['String']>;
  results?: Maybe<PhoneNumberLookupResultUncheckedUpdateManyWithoutRequestNestedInput>;
  status?: Maybe<PhoneNumberLookupRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId?: Maybe<Scalars['String']>;
  status?: Maybe<PhoneNumberLookupRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestUncheckedUpdateWithoutClinicEntityPhoneNumbersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId?: Maybe<Scalars['String']>;
  results?: Maybe<PhoneNumberLookupResultUncheckedUpdateManyWithoutRequestNestedInput>;
  status?: Maybe<PhoneNumberLookupRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestUncheckedUpdateWithoutResultsInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutPhoneNumberLookupRequestNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId?: Maybe<Scalars['String']>;
  status?: Maybe<PhoneNumberLookupRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestUpdateInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutPhoneNumberLookupRequestNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId?: Maybe<Scalars['String']>;
  results?: Maybe<PhoneNumberLookupResultUpdateManyWithoutRequestNestedInput>;
  status?: Maybe<PhoneNumberLookupRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId?: Maybe<Scalars['String']>;
  status?: Maybe<PhoneNumberLookupRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestUpdateOneRequiredWithoutResultsNestedInput = {
  connect?: Maybe<PhoneNumberLookupRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<PhoneNumberLookupRequestCreateOrConnectWithoutResultsInput>;
  create?: Maybe<PhoneNumberLookupRequestCreateWithoutResultsInput>;
  update?: Maybe<PhoneNumberLookupRequestUpdateToOneWithWhereWithoutResultsInput>;
  upsert?: Maybe<PhoneNumberLookupRequestUpsertWithoutResultsInput>;
};

export type PhoneNumberLookupRequestUpdateOneWithoutClinicEntityPhoneNumbersNestedInput = {
  connect?: Maybe<PhoneNumberLookupRequestWhereUniqueInput>;
  connectOrCreate?: Maybe<PhoneNumberLookupRequestCreateOrConnectWithoutClinicEntityPhoneNumbersInput>;
  create?: Maybe<PhoneNumberLookupRequestCreateWithoutClinicEntityPhoneNumbersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PhoneNumberLookupRequestUpdateToOneWithWhereWithoutClinicEntityPhoneNumbersInput>;
  upsert?: Maybe<PhoneNumberLookupRequestUpsertWithoutClinicEntityPhoneNumbersInput>;
};

export type PhoneNumberLookupRequestUpdateToOneWithWhereWithoutClinicEntityPhoneNumbersInput = {
  data: PhoneNumberLookupRequestUpdateWithoutClinicEntityPhoneNumbersInput;
  where?: Maybe<PhoneNumberLookupRequestWhereInput>;
};

export type PhoneNumberLookupRequestUpdateToOneWithWhereWithoutResultsInput = {
  data: PhoneNumberLookupRequestUpdateWithoutResultsInput;
  where?: Maybe<PhoneNumberLookupRequestWhereInput>;
};

export type PhoneNumberLookupRequestUpdateWithoutClinicEntityPhoneNumbersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId?: Maybe<Scalars['String']>;
  results?: Maybe<PhoneNumberLookupResultUpdateManyWithoutRequestNestedInput>;
  status?: Maybe<PhoneNumberLookupRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestUpdateWithoutResultsInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutPhoneNumberLookupRequestNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  providerRequestId?: Maybe<Scalars['String']>;
  status?: Maybe<PhoneNumberLookupRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumberLookupRequestUpsertWithoutClinicEntityPhoneNumbersInput = {
  create: PhoneNumberLookupRequestCreateWithoutClinicEntityPhoneNumbersInput;
  update: PhoneNumberLookupRequestUpdateWithoutClinicEntityPhoneNumbersInput;
  where?: Maybe<PhoneNumberLookupRequestWhereInput>;
};

export type PhoneNumberLookupRequestUpsertWithoutResultsInput = {
  create: PhoneNumberLookupRequestCreateWithoutResultsInput;
  update: PhoneNumberLookupRequestUpdateWithoutResultsInput;
  where?: Maybe<PhoneNumberLookupRequestWhereInput>;
};

export type PhoneNumberLookupRequestWhereInput = {
  AND?: Maybe<Array<PhoneNumberLookupRequestWhereInput>>;
  NOT?: Maybe<Array<PhoneNumberLookupRequestWhereInput>>;
  OR?: Maybe<Array<PhoneNumberLookupRequestWhereInput>>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  providerRequestId?: Maybe<StringFilter>;
  results?: Maybe<PhoneNumberLookupResultListRelationFilter>;
  status?: Maybe<EnumPhoneNumberLookupRequestStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PhoneNumberLookupRequestWhereUniqueInput = {
  AND?: Maybe<Array<PhoneNumberLookupRequestWhereInput>>;
  NOT?: Maybe<Array<PhoneNumberLookupRequestWhereInput>>;
  OR?: Maybe<Array<PhoneNumberLookupRequestWhereInput>>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  providerRequestId?: Maybe<StringFilter>;
  results?: Maybe<PhoneNumberLookupResultListRelationFilter>;
  status?: Maybe<EnumPhoneNumberLookupRequestStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PhoneNumberLookupResult = {
  __typename?: 'PhoneNumberLookupResult';
  _count: PhoneNumberLookupResultCountOutputType;
  clinicEntityPhoneNumbers: Array<ClinicEntityPhoneNumber>;
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  e164Format: Scalars['String'];
  formatted: Scalars['String'];
  id: Scalars['String'];
  lineProvider: Scalars['String'];
  lineType: Scalars['String'];
  lookupRequestId: Scalars['String'];
  message: Scalars['String'];
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  request: PhoneNumberLookupRequest;
  responseCode: Scalars['Int'];
};


export type PhoneNumberLookupResultClinicEntityPhoneNumbersArgs = {
  cursor?: Maybe<ClinicEntityPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEntityPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEntityPhoneNumberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEntityPhoneNumberWhereInput>;
};

export type PhoneNumberLookupResultAvgAggregateOutputType = {
  __typename?: 'PhoneNumberLookupResultAvgAggregateOutputType';
  responseCode?: Maybe<Scalars['Float']>;
};

export type PhoneNumberLookupResultAvgOrderByAggregateInput = {
  responseCode?: Maybe<SortOrder>;
};

export type PhoneNumberLookupResultCountAggregateOutputType = {
  __typename?: 'PhoneNumberLookupResultCountAggregateOutputType';
  _all: Scalars['Int'];
  country: Scalars['Int'];
  createdAt: Scalars['Int'];
  e164Format: Scalars['Int'];
  formatted: Scalars['Int'];
  id: Scalars['Int'];
  lineProvider: Scalars['Int'];
  lineType: Scalars['Int'];
  lookupRequestId: Scalars['Int'];
  message: Scalars['Int'];
  mobileCountryCode: Scalars['Int'];
  mobileNetworkCode: Scalars['Int'];
  responseCode: Scalars['Int'];
};

export type PhoneNumberLookupResultCountOrderByAggregateInput = {
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  e164Format?: Maybe<SortOrder>;
  formatted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lineProvider?: Maybe<SortOrder>;
  lineType?: Maybe<SortOrder>;
  lookupRequestId?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  mobileCountryCode?: Maybe<SortOrder>;
  mobileNetworkCode?: Maybe<SortOrder>;
  responseCode?: Maybe<SortOrder>;
};

export type PhoneNumberLookupResultCountOutputType = {
  __typename?: 'PhoneNumberLookupResultCountOutputType';
  clinicEntityPhoneNumbers: Scalars['Int'];
};

export type PhoneNumberLookupResultCreateInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutPhoneNumberLookupResultInput>;
  country: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format: Scalars['String'];
  formatted: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lineProvider: Scalars['String'];
  lineType: Scalars['String'];
  message: Scalars['String'];
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  request: PhoneNumberLookupRequestCreateNestedOneWithoutResultsInput;
  responseCode: Scalars['Int'];
};

export type PhoneNumberLookupResultCreateManyInput = {
  country: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format: Scalars['String'];
  formatted: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lineProvider: Scalars['String'];
  lineType: Scalars['String'];
  lookupRequestId: Scalars['String'];
  message: Scalars['String'];
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode: Scalars['Int'];
};

export type PhoneNumberLookupResultCreateManyRequestInput = {
  country: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format: Scalars['String'];
  formatted: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lineProvider: Scalars['String'];
  lineType: Scalars['String'];
  message: Scalars['String'];
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode: Scalars['Int'];
};

export type PhoneNumberLookupResultCreateManyRequestInputEnvelope = {
  data: Array<PhoneNumberLookupResultCreateManyRequestInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PhoneNumberLookupResultCreateNestedManyWithoutRequestInput = {
  connect?: Maybe<Array<PhoneNumberLookupResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PhoneNumberLookupResultCreateOrConnectWithoutRequestInput>>;
  create?: Maybe<Array<PhoneNumberLookupResultCreateWithoutRequestInput>>;
  createMany?: Maybe<PhoneNumberLookupResultCreateManyRequestInputEnvelope>;
};

export type PhoneNumberLookupResultCreateNestedOneWithoutClinicEntityPhoneNumbersInput = {
  connect?: Maybe<PhoneNumberLookupResultWhereUniqueInput>;
  connectOrCreate?: Maybe<PhoneNumberLookupResultCreateOrConnectWithoutClinicEntityPhoneNumbersInput>;
  create?: Maybe<PhoneNumberLookupResultCreateWithoutClinicEntityPhoneNumbersInput>;
};

export type PhoneNumberLookupResultCreateOrConnectWithoutClinicEntityPhoneNumbersInput = {
  create: PhoneNumberLookupResultCreateWithoutClinicEntityPhoneNumbersInput;
  where: PhoneNumberLookupResultWhereUniqueInput;
};

export type PhoneNumberLookupResultCreateOrConnectWithoutRequestInput = {
  create: PhoneNumberLookupResultCreateWithoutRequestInput;
  where: PhoneNumberLookupResultWhereUniqueInput;
};

export type PhoneNumberLookupResultCreateWithoutClinicEntityPhoneNumbersInput = {
  country: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format: Scalars['String'];
  formatted: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lineProvider: Scalars['String'];
  lineType: Scalars['String'];
  message: Scalars['String'];
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  request: PhoneNumberLookupRequestCreateNestedOneWithoutResultsInput;
  responseCode: Scalars['Int'];
};

export type PhoneNumberLookupResultCreateWithoutRequestInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberCreateNestedManyWithoutPhoneNumberLookupResultInput>;
  country: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format: Scalars['String'];
  formatted: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lineProvider: Scalars['String'];
  lineType: Scalars['String'];
  message: Scalars['String'];
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode: Scalars['Int'];
};

export type PhoneNumberLookupResultGroupByOutputType = {
  __typename?: 'PhoneNumberLookupResultGroupByOutputType';
  _avg?: Maybe<PhoneNumberLookupResultAvgAggregateOutputType>;
  _count?: Maybe<PhoneNumberLookupResultCountAggregateOutputType>;
  _max?: Maybe<PhoneNumberLookupResultMaxAggregateOutputType>;
  _min?: Maybe<PhoneNumberLookupResultMinAggregateOutputType>;
  _sum?: Maybe<PhoneNumberLookupResultSumAggregateOutputType>;
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  e164Format: Scalars['String'];
  formatted: Scalars['String'];
  id: Scalars['String'];
  lineProvider: Scalars['String'];
  lineType: Scalars['String'];
  lookupRequestId: Scalars['String'];
  message: Scalars['String'];
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode: Scalars['Int'];
};

export type PhoneNumberLookupResultListRelationFilter = {
  every?: Maybe<PhoneNumberLookupResultWhereInput>;
  none?: Maybe<PhoneNumberLookupResultWhereInput>;
  some?: Maybe<PhoneNumberLookupResultWhereInput>;
};

export type PhoneNumberLookupResultMaxAggregateOutputType = {
  __typename?: 'PhoneNumberLookupResultMaxAggregateOutputType';
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lineProvider?: Maybe<Scalars['String']>;
  lineType?: Maybe<Scalars['String']>;
  lookupRequestId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLookupResultMaxOrderByAggregateInput = {
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  e164Format?: Maybe<SortOrder>;
  formatted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lineProvider?: Maybe<SortOrder>;
  lineType?: Maybe<SortOrder>;
  lookupRequestId?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  mobileCountryCode?: Maybe<SortOrder>;
  mobileNetworkCode?: Maybe<SortOrder>;
  responseCode?: Maybe<SortOrder>;
};

export type PhoneNumberLookupResultMinAggregateOutputType = {
  __typename?: 'PhoneNumberLookupResultMinAggregateOutputType';
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lineProvider?: Maybe<Scalars['String']>;
  lineType?: Maybe<Scalars['String']>;
  lookupRequestId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLookupResultMinOrderByAggregateInput = {
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  e164Format?: Maybe<SortOrder>;
  formatted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lineProvider?: Maybe<SortOrder>;
  lineType?: Maybe<SortOrder>;
  lookupRequestId?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  mobileCountryCode?: Maybe<SortOrder>;
  mobileNetworkCode?: Maybe<SortOrder>;
  responseCode?: Maybe<SortOrder>;
};

export type PhoneNumberLookupResultNullableScalarRelationFilter = {
  AND?: Maybe<Array<PhoneNumberLookupResultWhereInput>>;
  NOT?: Maybe<Array<PhoneNumberLookupResultWhereInput>>;
  OR?: Maybe<Array<PhoneNumberLookupResultWhereInput>>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberListRelationFilter>;
  country?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  e164Format?: Maybe<StringFilter>;
  formatted?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  lineProvider?: Maybe<StringFilter>;
  lineType?: Maybe<StringFilter>;
  lookupRequestId?: Maybe<StringFilter>;
  message?: Maybe<StringFilter>;
  mobileCountryCode?: Maybe<StringNullableFilter>;
  mobileNetworkCode?: Maybe<StringNullableFilter>;
  request?: Maybe<PhoneNumberLookupRequestScalarRelationFilter>;
  responseCode?: Maybe<IntFilter>;
};

export type PhoneNumberLookupResultOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PhoneNumberLookupResultOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PhoneNumberLookupResultOrderByRelevanceInput>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberOrderByRelationAggregateInput>;
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  e164Format?: Maybe<SortOrder>;
  formatted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lineProvider?: Maybe<SortOrder>;
  lineType?: Maybe<SortOrder>;
  lookupRequestId?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  mobileCountryCode?: Maybe<SortOrder>;
  mobileNetworkCode?: Maybe<SortOrder>;
  request?: Maybe<PhoneNumberLookupRequestOrderByWithRelationInput>;
  responseCode?: Maybe<SortOrder>;
};

export enum PhoneNumberLookupResultOrderByRelevanceFieldEnum {
  Country = 'country',
  E164Format = 'e164Format',
  Formatted = 'formatted',
  Id = 'id',
  LineProvider = 'lineProvider',
  LineType = 'lineType',
  LookupRequestId = 'lookupRequestId',
  Message = 'message',
  MobileCountryCode = 'mobileCountryCode',
  MobileNetworkCode = 'mobileNetworkCode'
}

export type PhoneNumberLookupResultOrderByRelevanceInput = {
  fields: Array<PhoneNumberLookupResultOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PhoneNumberLookupResultOrderByWithAggregationInput = {
  _avg?: Maybe<PhoneNumberLookupResultAvgOrderByAggregateInput>;
  _count?: Maybe<PhoneNumberLookupResultCountOrderByAggregateInput>;
  _max?: Maybe<PhoneNumberLookupResultMaxOrderByAggregateInput>;
  _min?: Maybe<PhoneNumberLookupResultMinOrderByAggregateInput>;
  _sum?: Maybe<PhoneNumberLookupResultSumOrderByAggregateInput>;
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  e164Format?: Maybe<SortOrder>;
  formatted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lineProvider?: Maybe<SortOrder>;
  lineType?: Maybe<SortOrder>;
  lookupRequestId?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  mobileCountryCode?: Maybe<SortOrder>;
  mobileNetworkCode?: Maybe<SortOrder>;
  responseCode?: Maybe<SortOrder>;
};

export type PhoneNumberLookupResultOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PhoneNumberLookupResultOrderByRelevanceInput>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberOrderByRelationAggregateInput>;
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  e164Format?: Maybe<SortOrder>;
  formatted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lineProvider?: Maybe<SortOrder>;
  lineType?: Maybe<SortOrder>;
  lookupRequestId?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  mobileCountryCode?: Maybe<SortOrder>;
  mobileNetworkCode?: Maybe<SortOrder>;
  request?: Maybe<PhoneNumberLookupRequestOrderByWithRelationInput>;
  responseCode?: Maybe<SortOrder>;
};

export type PhoneNumberLookupResultOrderByWithRelationInput = {
  _relevance?: Maybe<PhoneNumberLookupResultOrderByRelevanceInput>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberOrderByRelationAggregateInput>;
  country?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  e164Format?: Maybe<SortOrder>;
  formatted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lineProvider?: Maybe<SortOrder>;
  lineType?: Maybe<SortOrder>;
  lookupRequestId?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  mobileCountryCode?: Maybe<SortOrder>;
  mobileNetworkCode?: Maybe<SortOrder>;
  request?: Maybe<PhoneNumberLookupRequestOrderByWithRelationInput>;
  responseCode?: Maybe<SortOrder>;
};

export enum PhoneNumberLookupResultScalarFieldEnum {
  Country = 'country',
  CreatedAt = 'createdAt',
  E164Format = 'e164Format',
  Formatted = 'formatted',
  Id = 'id',
  LineProvider = 'lineProvider',
  LineType = 'lineType',
  LookupRequestId = 'lookupRequestId',
  Message = 'message',
  MobileCountryCode = 'mobileCountryCode',
  MobileNetworkCode = 'mobileNetworkCode',
  ResponseCode = 'responseCode'
}

export type PhoneNumberLookupResultScalarWhereInput = {
  AND?: Maybe<Array<PhoneNumberLookupResultScalarWhereInput>>;
  NOT?: Maybe<Array<PhoneNumberLookupResultScalarWhereInput>>;
  OR?: Maybe<Array<PhoneNumberLookupResultScalarWhereInput>>;
  country?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  e164Format?: Maybe<StringFilter>;
  formatted?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  lineProvider?: Maybe<StringFilter>;
  lineType?: Maybe<StringFilter>;
  lookupRequestId?: Maybe<StringFilter>;
  message?: Maybe<StringFilter>;
  mobileCountryCode?: Maybe<StringNullableFilter>;
  mobileNetworkCode?: Maybe<StringNullableFilter>;
  responseCode?: Maybe<IntFilter>;
};

export type PhoneNumberLookupResultScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PhoneNumberLookupResultScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PhoneNumberLookupResultScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PhoneNumberLookupResultScalarWhereWithAggregatesInput>>;
  country?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  e164Format?: Maybe<StringWithAggregatesFilter>;
  formatted?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  lineProvider?: Maybe<StringWithAggregatesFilter>;
  lineType?: Maybe<StringWithAggregatesFilter>;
  lookupRequestId?: Maybe<StringWithAggregatesFilter>;
  message?: Maybe<StringWithAggregatesFilter>;
  mobileCountryCode?: Maybe<StringNullableWithAggregatesFilter>;
  mobileNetworkCode?: Maybe<StringNullableWithAggregatesFilter>;
  responseCode?: Maybe<IntWithAggregatesFilter>;
};

export type PhoneNumberLookupResultSumAggregateOutputType = {
  __typename?: 'PhoneNumberLookupResultSumAggregateOutputType';
  responseCode?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLookupResultSumOrderByAggregateInput = {
  responseCode?: Maybe<SortOrder>;
};

export type PhoneNumberLookupResultUncheckedCreateInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutPhoneNumberLookupResultInput>;
  country: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format: Scalars['String'];
  formatted: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lineProvider: Scalars['String'];
  lineType: Scalars['String'];
  lookupRequestId: Scalars['String'];
  message: Scalars['String'];
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode: Scalars['Int'];
};

export type PhoneNumberLookupResultUncheckedCreateNestedManyWithoutRequestInput = {
  connect?: Maybe<Array<PhoneNumberLookupResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PhoneNumberLookupResultCreateOrConnectWithoutRequestInput>>;
  create?: Maybe<Array<PhoneNumberLookupResultCreateWithoutRequestInput>>;
  createMany?: Maybe<PhoneNumberLookupResultCreateManyRequestInputEnvelope>;
};

export type PhoneNumberLookupResultUncheckedCreateWithoutClinicEntityPhoneNumbersInput = {
  country: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format: Scalars['String'];
  formatted: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lineProvider: Scalars['String'];
  lineType: Scalars['String'];
  lookupRequestId: Scalars['String'];
  message: Scalars['String'];
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode: Scalars['Int'];
};

export type PhoneNumberLookupResultUncheckedCreateWithoutRequestInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedCreateNestedManyWithoutPhoneNumberLookupResultInput>;
  country: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format: Scalars['String'];
  formatted: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lineProvider: Scalars['String'];
  lineType: Scalars['String'];
  message: Scalars['String'];
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode: Scalars['Int'];
};

export type PhoneNumberLookupResultUncheckedUpdateInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutPhoneNumberLookupResultNestedInput>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lineProvider?: Maybe<Scalars['String']>;
  lineType?: Maybe<Scalars['String']>;
  lookupRequestId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLookupResultUncheckedUpdateManyInput = {
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lineProvider?: Maybe<Scalars['String']>;
  lineType?: Maybe<Scalars['String']>;
  lookupRequestId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLookupResultUncheckedUpdateManyWithoutRequestInput = {
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lineProvider?: Maybe<Scalars['String']>;
  lineType?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLookupResultUncheckedUpdateManyWithoutRequestNestedInput = {
  connect?: Maybe<Array<PhoneNumberLookupResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PhoneNumberLookupResultCreateOrConnectWithoutRequestInput>>;
  create?: Maybe<Array<PhoneNumberLookupResultCreateWithoutRequestInput>>;
  createMany?: Maybe<PhoneNumberLookupResultCreateManyRequestInputEnvelope>;
  delete?: Maybe<Array<PhoneNumberLookupResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PhoneNumberLookupResultScalarWhereInput>>;
  disconnect?: Maybe<Array<PhoneNumberLookupResultWhereUniqueInput>>;
  set?: Maybe<Array<PhoneNumberLookupResultWhereUniqueInput>>;
  update?: Maybe<Array<PhoneNumberLookupResultUpdateWithWhereUniqueWithoutRequestInput>>;
  updateMany?: Maybe<Array<PhoneNumberLookupResultUpdateManyWithWhereWithoutRequestInput>>;
  upsert?: Maybe<Array<PhoneNumberLookupResultUpsertWithWhereUniqueWithoutRequestInput>>;
};

export type PhoneNumberLookupResultUncheckedUpdateWithoutClinicEntityPhoneNumbersInput = {
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lineProvider?: Maybe<Scalars['String']>;
  lineType?: Maybe<Scalars['String']>;
  lookupRequestId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLookupResultUncheckedUpdateWithoutRequestInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberUncheckedUpdateManyWithoutPhoneNumberLookupResultNestedInput>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lineProvider?: Maybe<Scalars['String']>;
  lineType?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLookupResultUpdateInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutPhoneNumberLookupResultNestedInput>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lineProvider?: Maybe<Scalars['String']>;
  lineType?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  request?: Maybe<PhoneNumberLookupRequestUpdateOneRequiredWithoutResultsNestedInput>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLookupResultUpdateManyMutationInput = {
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lineProvider?: Maybe<Scalars['String']>;
  lineType?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLookupResultUpdateManyWithWhereWithoutRequestInput = {
  data: PhoneNumberLookupResultUpdateManyMutationInput;
  where: PhoneNumberLookupResultScalarWhereInput;
};

export type PhoneNumberLookupResultUpdateManyWithoutRequestNestedInput = {
  connect?: Maybe<Array<PhoneNumberLookupResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PhoneNumberLookupResultCreateOrConnectWithoutRequestInput>>;
  create?: Maybe<Array<PhoneNumberLookupResultCreateWithoutRequestInput>>;
  createMany?: Maybe<PhoneNumberLookupResultCreateManyRequestInputEnvelope>;
  delete?: Maybe<Array<PhoneNumberLookupResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PhoneNumberLookupResultScalarWhereInput>>;
  disconnect?: Maybe<Array<PhoneNumberLookupResultWhereUniqueInput>>;
  set?: Maybe<Array<PhoneNumberLookupResultWhereUniqueInput>>;
  update?: Maybe<Array<PhoneNumberLookupResultUpdateWithWhereUniqueWithoutRequestInput>>;
  updateMany?: Maybe<Array<PhoneNumberLookupResultUpdateManyWithWhereWithoutRequestInput>>;
  upsert?: Maybe<Array<PhoneNumberLookupResultUpsertWithWhereUniqueWithoutRequestInput>>;
};

export type PhoneNumberLookupResultUpdateOneWithoutClinicEntityPhoneNumbersNestedInput = {
  connect?: Maybe<PhoneNumberLookupResultWhereUniqueInput>;
  connectOrCreate?: Maybe<PhoneNumberLookupResultCreateOrConnectWithoutClinicEntityPhoneNumbersInput>;
  create?: Maybe<PhoneNumberLookupResultCreateWithoutClinicEntityPhoneNumbersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PhoneNumberLookupResultUpdateToOneWithWhereWithoutClinicEntityPhoneNumbersInput>;
  upsert?: Maybe<PhoneNumberLookupResultUpsertWithoutClinicEntityPhoneNumbersInput>;
};

export type PhoneNumberLookupResultUpdateToOneWithWhereWithoutClinicEntityPhoneNumbersInput = {
  data: PhoneNumberLookupResultUpdateWithoutClinicEntityPhoneNumbersInput;
  where?: Maybe<PhoneNumberLookupResultWhereInput>;
};

export type PhoneNumberLookupResultUpdateWithWhereUniqueWithoutRequestInput = {
  data: PhoneNumberLookupResultUpdateWithoutRequestInput;
  where: PhoneNumberLookupResultWhereUniqueInput;
};

export type PhoneNumberLookupResultUpdateWithoutClinicEntityPhoneNumbersInput = {
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lineProvider?: Maybe<Scalars['String']>;
  lineType?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  request?: Maybe<PhoneNumberLookupRequestUpdateOneRequiredWithoutResultsNestedInput>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLookupResultUpdateWithoutRequestInput = {
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberUpdateManyWithoutPhoneNumberLookupResultNestedInput>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  e164Format?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lineProvider?: Maybe<Scalars['String']>;
  lineType?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type PhoneNumberLookupResultUpsertWithWhereUniqueWithoutRequestInput = {
  create: PhoneNumberLookupResultCreateWithoutRequestInput;
  update: PhoneNumberLookupResultUpdateWithoutRequestInput;
  where: PhoneNumberLookupResultWhereUniqueInput;
};

export type PhoneNumberLookupResultUpsertWithoutClinicEntityPhoneNumbersInput = {
  create: PhoneNumberLookupResultCreateWithoutClinicEntityPhoneNumbersInput;
  update: PhoneNumberLookupResultUpdateWithoutClinicEntityPhoneNumbersInput;
  where?: Maybe<PhoneNumberLookupResultWhereInput>;
};

export type PhoneNumberLookupResultWhereInput = {
  AND?: Maybe<Array<PhoneNumberLookupResultWhereInput>>;
  NOT?: Maybe<Array<PhoneNumberLookupResultWhereInput>>;
  OR?: Maybe<Array<PhoneNumberLookupResultWhereInput>>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberListRelationFilter>;
  country?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  e164Format?: Maybe<StringFilter>;
  formatted?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  lineProvider?: Maybe<StringFilter>;
  lineType?: Maybe<StringFilter>;
  lookupRequestId?: Maybe<StringFilter>;
  message?: Maybe<StringFilter>;
  mobileCountryCode?: Maybe<StringNullableFilter>;
  mobileNetworkCode?: Maybe<StringNullableFilter>;
  request?: Maybe<PhoneNumberLookupRequestScalarRelationFilter>;
  responseCode?: Maybe<IntFilter>;
};

export type PhoneNumberLookupResultWhereUniqueInput = {
  AND?: Maybe<Array<PhoneNumberLookupResultWhereInput>>;
  NOT?: Maybe<Array<PhoneNumberLookupResultWhereInput>>;
  OR?: Maybe<Array<PhoneNumberLookupResultWhereInput>>;
  clinicEntityPhoneNumbers?: Maybe<ClinicEntityPhoneNumberListRelationFilter>;
  country?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  e164Format?: Maybe<StringFilter>;
  formatted?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  lineProvider?: Maybe<StringFilter>;
  lineType?: Maybe<StringFilter>;
  lookupRequestId?: Maybe<StringFilter>;
  message?: Maybe<StringFilter>;
  mobileCountryCode?: Maybe<StringNullableFilter>;
  mobileNetworkCode?: Maybe<StringNullableFilter>;
  request?: Maybe<PhoneNumberLookupRequestScalarRelationFilter>;
  responseCode?: Maybe<IntFilter>;
};

export enum PhoneNumberStatus {
  Hosted = 'Hosted',
  HostingNotAvailable = 'HostingNotAvailable',
  New = 'New',
  PortingInProgress = 'PortingInProgress',
  ProblemHosting = 'ProblemHosting',
  PurchasedFromBandwidth = 'PurchasedFromBandwidth',
  PurchasedFromTwilio = 'PurchasedFromTwilio',
  ReadyToHost = 'ReadyToHost'
}

export enum PimsIntegrationCapability {
  Appointment = 'Appointment',
  AppointmentAvailability = 'AppointmentAvailability',
  AppointmentLiveDelete = 'AppointmentLiveDelete',
  AppointmentResource = 'AppointmentResource',
  AppointmentType = 'AppointmentType',
  Availability = 'Availability',
  AvailabilityResources = 'AvailabilityResources',
  Breed = 'Breed',
  ClinicEmployee = 'ClinicEmployee',
  ClinicEntityPhoneNumber = 'ClinicEntityPhoneNumber',
  ClinicPet = 'ClinicPet',
  ClinicPetAlert = 'ClinicPetAlert',
  ClinicPetCustomFields = 'ClinicPetCustomFields',
  ClinicPetParent = 'ClinicPetParent',
  ClinicPetParentAddress = 'ClinicPetParentAddress',
  ClinicPetParentContactInfo = 'ClinicPetParentContactInfo',
  ClinicPetParentCustomFields = 'ClinicPetParentCustomFields',
  ClinicPetToClinicPetParent = 'ClinicPetToClinicPetParent',
  ClinicRoom = 'ClinicRoom',
  Color = 'Color',
  Email = 'Email',
  Invoice = 'Invoice',
  InvoiceLineItem = 'InvoiceLineItem',
  LabPanel = 'LabPanel',
  LabResult = 'LabResult',
  MedicalHistory = 'MedicalHistory',
  NormalizedService = 'NormalizedService',
  PimsPaymentType = 'PimsPaymentType',
  Prescription = 'Prescription',
  Service = 'Service',
  ServiceCategory = 'ServiceCategory',
  ServiceReminder = 'ServiceReminder',
  Sex = 'Sex',
  Species = 'Species',
  SyncVetService = 'SyncVetService',
  Vaccination = 'Vaccination',
  Vital = 'Vital'
}

export type PimsInvoice = {
  __typename?: 'PimsInvoice';
  createdAt: Scalars['DateTime'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  invoice: Invoice;
  invoiceId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  /** The status from PIMS for this invoice, since these are specific to a PIMS or a clinic config */
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PimsInvoiceCountAggregateOutputType = {
  __typename?: 'PimsInvoiceCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  integrationId: Scalars['Int'];
  invoiceId: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PimsInvoiceCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsInvoiceCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPimsInvoicesInput;
  invoice: InvoiceCreateNestedOneWithoutPimsInvoiceInput;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId: Scalars['String'];
  invoiceId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceCreateManyIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  invoiceId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceCreateManyIntegrationInputEnvelope = {
  data: Array<PimsInvoiceCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PimsInvoiceCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<PimsInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsInvoiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsInvoiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsInvoiceCreateManyIntegrationInputEnvelope>;
};

export type PimsInvoiceCreateNestedOneWithoutInvoiceInput = {
  connect?: Maybe<PimsInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsInvoiceCreateOrConnectWithoutInvoiceInput>;
  create?: Maybe<PimsInvoiceCreateWithoutInvoiceInput>;
};

export type PimsInvoiceCreateOrConnectWithoutIntegrationInput = {
  create: PimsInvoiceCreateWithoutIntegrationInput;
  where: PimsInvoiceWhereUniqueInput;
};

export type PimsInvoiceCreateOrConnectWithoutInvoiceInput = {
  create: PimsInvoiceCreateWithoutInvoiceInput;
  where: PimsInvoiceWhereUniqueInput;
};

export type PimsInvoiceCreateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  invoice: InvoiceCreateNestedOneWithoutPimsInvoiceInput;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceCreateWithoutInvoiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPimsInvoicesInput;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceGroupByOutputType = {
  __typename?: 'PimsInvoiceGroupByOutputType';
  _count?: Maybe<PimsInvoiceCountAggregateOutputType>;
  _max?: Maybe<PimsInvoiceMaxAggregateOutputType>;
  _min?: Maybe<PimsInvoiceMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  integrationId: Scalars['String'];
  invoiceId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PimsInvoiceInvoiceIdIntegrationIdPimsIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  invoiceId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type PimsInvoiceLineItem = {
  __typename?: 'PimsInvoiceLineItem';
  createdAt: Scalars['DateTime'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  invoiceLineItem: InvoiceLineItem;
  invoiceLineItemId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  type: PimsInvoiceLineItemType;
  updatedAt: Scalars['DateTime'];
};

export type PimsInvoiceLineItemCountAggregateOutputType = {
  __typename?: 'PimsInvoiceLineItemCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  integrationId: Scalars['Int'];
  invoiceLineItemId: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PimsInvoiceLineItemCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItemId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsInvoiceLineItemCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPimsInvoiceLineItemsInput;
  invoiceLineItem: InvoiceLineItemCreateNestedOneWithoutPimsInvoiceLineItemInput;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  type: PimsInvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId: Scalars['String'];
  invoiceLineItemId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  type: PimsInvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemCreateManyIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  invoiceLineItemId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  type: PimsInvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemCreateManyIntegrationInputEnvelope = {
  data: Array<PimsInvoiceLineItemCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PimsInvoiceLineItemCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<PimsInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsInvoiceLineItemCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsInvoiceLineItemCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsInvoiceLineItemCreateManyIntegrationInputEnvelope>;
};

export type PimsInvoiceLineItemCreateNestedOneWithoutInvoiceLineItemInput = {
  connect?: Maybe<PimsInvoiceLineItemWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsInvoiceLineItemCreateOrConnectWithoutInvoiceLineItemInput>;
  create?: Maybe<PimsInvoiceLineItemCreateWithoutInvoiceLineItemInput>;
};

export type PimsInvoiceLineItemCreateOrConnectWithoutIntegrationInput = {
  create: PimsInvoiceLineItemCreateWithoutIntegrationInput;
  where: PimsInvoiceLineItemWhereUniqueInput;
};

export type PimsInvoiceLineItemCreateOrConnectWithoutInvoiceLineItemInput = {
  create: PimsInvoiceLineItemCreateWithoutInvoiceLineItemInput;
  where: PimsInvoiceLineItemWhereUniqueInput;
};

export type PimsInvoiceLineItemCreateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  invoiceLineItem: InvoiceLineItemCreateNestedOneWithoutPimsInvoiceLineItemInput;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  type: PimsInvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemCreateWithoutInvoiceLineItemInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPimsInvoiceLineItemsInput;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  type: PimsInvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemGroupByOutputType = {
  __typename?: 'PimsInvoiceLineItemGroupByOutputType';
  _count?: Maybe<PimsInvoiceLineItemCountAggregateOutputType>;
  _max?: Maybe<PimsInvoiceLineItemMaxAggregateOutputType>;
  _min?: Maybe<PimsInvoiceLineItemMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  integrationId: Scalars['String'];
  invoiceLineItemId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  type: PimsInvoiceLineItemType;
  updatedAt: Scalars['DateTime'];
};

export type PimsInvoiceLineItemInvoiceLineItemIdIntegrationIdPimsIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  invoiceLineItemId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type PimsInvoiceLineItemListRelationFilter = {
  every?: Maybe<PimsInvoiceLineItemWhereInput>;
  none?: Maybe<PimsInvoiceLineItemWhereInput>;
  some?: Maybe<PimsInvoiceLineItemWhereInput>;
};

export type PimsInvoiceLineItemMaxAggregateOutputType = {
  __typename?: 'PimsInvoiceLineItemMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsInvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItemId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsInvoiceLineItemMinAggregateOutputType = {
  __typename?: 'PimsInvoiceLineItemMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsInvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItemId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsInvoiceLineItemNullableScalarRelationFilter = {
  AND?: Maybe<Array<PimsInvoiceLineItemWhereInput>>;
  NOT?: Maybe<Array<PimsInvoiceLineItemWhereInput>>;
  OR?: Maybe<Array<PimsInvoiceLineItemWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoiceLineItem?: Maybe<InvoiceLineItemScalarRelationFilter>;
  invoiceLineItemId?: Maybe<StringFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumPimsInvoiceLineItemTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PimsInvoiceLineItemOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PimsInvoiceLineItemOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PimsInvoiceLineItemOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItem?: Maybe<InvoiceLineItemOrderByWithRelationInput>;
  invoiceLineItemId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PimsInvoiceLineItemOrderByRelevanceFieldEnum {
  IntegrationId = 'integrationId',
  InvoiceLineItemId = 'invoiceLineItemId',
  PimsId = 'pimsId'
}

export type PimsInvoiceLineItemOrderByRelevanceInput = {
  fields: Array<PimsInvoiceLineItemOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PimsInvoiceLineItemOrderByWithAggregationInput = {
  _count?: Maybe<PimsInvoiceLineItemCountOrderByAggregateInput>;
  _max?: Maybe<PimsInvoiceLineItemMaxOrderByAggregateInput>;
  _min?: Maybe<PimsInvoiceLineItemMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItemId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsInvoiceLineItemOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PimsInvoiceLineItemOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItem?: Maybe<InvoiceLineItemOrderByWithRelationInput>;
  invoiceLineItemId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsInvoiceLineItemOrderByWithRelationInput = {
  _relevance?: Maybe<PimsInvoiceLineItemOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItem?: Maybe<InvoiceLineItemOrderByWithRelationInput>;
  invoiceLineItemId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsInvoiceLineItemPimsInvoiceLineItemUniqueIntegrationIdPimsIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export enum PimsInvoiceLineItemScalarFieldEnum {
  CreatedAt = 'createdAt',
  IntegrationId = 'integrationId',
  InvoiceLineItemId = 'invoiceLineItemId',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type PimsInvoiceLineItemScalarWhereInput = {
  AND?: Maybe<Array<PimsInvoiceLineItemScalarWhereInput>>;
  NOT?: Maybe<Array<PimsInvoiceLineItemScalarWhereInput>>;
  OR?: Maybe<Array<PimsInvoiceLineItemScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  integrationId?: Maybe<StringFilter>;
  invoiceLineItemId?: Maybe<StringFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumPimsInvoiceLineItemTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PimsInvoiceLineItemScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PimsInvoiceLineItemScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PimsInvoiceLineItemScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PimsInvoiceLineItemScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  invoiceLineItemId?: Maybe<StringWithAggregatesFilter>;
  pimsId?: Maybe<StringWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  type?: Maybe<EnumPimsInvoiceLineItemTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum PimsInvoiceLineItemType {
  BitwerxAdjustment = 'Bitwerx_Adjustment',
  BitwerxCode = 'Bitwerx_Code',
  BitwerxDiscount = 'Bitwerx_Discount',
  BitwerxEstimate = 'Bitwerx_Estimate',
  BitwerxFee = 'Bitwerx_Fee',
  BitwerxNote = 'Bitwerx_Note',
  BitwerxPayment = 'Bitwerx_Payment',
  BitwerxReturn = 'Bitwerx_Return',
  BitwerxTax = 'Bitwerx_Tax',
  BitwerxWriteOff = 'Bitwerx_WriteOff',
  VetdataAdjustment = 'Vetdata_Adjustment',
  VetdataCode = 'Vetdata_Code',
  VetdataDiscount = 'Vetdata_Discount',
  VetdataEstimate = 'Vetdata_Estimate',
  VetdataFee = 'Vetdata_Fee',
  VetdataNote = 'Vetdata_Note',
  VetdataPayment = 'Vetdata_Payment',
  VetdataReturn = 'Vetdata_Return',
  VetdataTax = 'Vetdata_Tax',
  VetdataUnknown = 'Vetdata_Unknown',
  VetdataWriteOff = 'Vetdata_WriteOff'
}

export type PimsInvoiceLineItemUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId: Scalars['String'];
  invoiceLineItemId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  type: PimsInvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<PimsInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsInvoiceLineItemCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsInvoiceLineItemCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsInvoiceLineItemCreateManyIntegrationInputEnvelope>;
};

export type PimsInvoiceLineItemUncheckedCreateNestedOneWithoutInvoiceLineItemInput = {
  connect?: Maybe<PimsInvoiceLineItemWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsInvoiceLineItemCreateOrConnectWithoutInvoiceLineItemInput>;
  create?: Maybe<PimsInvoiceLineItemCreateWithoutInvoiceLineItemInput>;
};

export type PimsInvoiceLineItemUncheckedCreateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  invoiceLineItemId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  type: PimsInvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemUncheckedCreateWithoutInvoiceLineItemInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  type: PimsInvoiceLineItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<PimsInvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<PimsInvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<PimsInvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<PimsInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsInvoiceLineItemCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsInvoiceLineItemCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsInvoiceLineItemCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<PimsInvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PimsInvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<PimsInvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<PimsInvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<PimsInvoiceLineItemUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<PimsInvoiceLineItemUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<PimsInvoiceLineItemUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type PimsInvoiceLineItemUncheckedUpdateOneWithoutInvoiceLineItemNestedInput = {
  connect?: Maybe<PimsInvoiceLineItemWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsInvoiceLineItemCreateOrConnectWithoutInvoiceLineItemInput>;
  create?: Maybe<PimsInvoiceLineItemCreateWithoutInvoiceLineItemInput>;
  delete?: Maybe<PimsInvoiceLineItemWhereInput>;
  disconnect?: Maybe<PimsInvoiceLineItemWhereInput>;
  update?: Maybe<PimsInvoiceLineItemUpdateToOneWithWhereWithoutInvoiceLineItemInput>;
  upsert?: Maybe<PimsInvoiceLineItemUpsertWithoutInvoiceLineItemInput>;
};

export type PimsInvoiceLineItemUncheckedUpdateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<PimsInvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemUncheckedUpdateWithoutInvoiceLineItemInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<PimsInvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPimsInvoiceLineItemsNestedInput>;
  invoiceLineItem?: Maybe<InvoiceLineItemUpdateOneRequiredWithoutPimsInvoiceLineItemNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<PimsInvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<PimsInvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemUpdateManyWithWhereWithoutIntegrationInput = {
  data: PimsInvoiceLineItemUpdateManyMutationInput;
  where: PimsInvoiceLineItemScalarWhereInput;
};

export type PimsInvoiceLineItemUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<PimsInvoiceLineItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsInvoiceLineItemCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsInvoiceLineItemCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsInvoiceLineItemCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<PimsInvoiceLineItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PimsInvoiceLineItemScalarWhereInput>>;
  disconnect?: Maybe<Array<PimsInvoiceLineItemWhereUniqueInput>>;
  set?: Maybe<Array<PimsInvoiceLineItemWhereUniqueInput>>;
  update?: Maybe<Array<PimsInvoiceLineItemUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<PimsInvoiceLineItemUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<PimsInvoiceLineItemUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type PimsInvoiceLineItemUpdateOneWithoutInvoiceLineItemNestedInput = {
  connect?: Maybe<PimsInvoiceLineItemWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsInvoiceLineItemCreateOrConnectWithoutInvoiceLineItemInput>;
  create?: Maybe<PimsInvoiceLineItemCreateWithoutInvoiceLineItemInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PimsInvoiceLineItemUpdateToOneWithWhereWithoutInvoiceLineItemInput>;
  upsert?: Maybe<PimsInvoiceLineItemUpsertWithoutInvoiceLineItemInput>;
};

export type PimsInvoiceLineItemUpdateToOneWithWhereWithoutInvoiceLineItemInput = {
  data: PimsInvoiceLineItemUpdateWithoutInvoiceLineItemInput;
  where?: Maybe<PimsInvoiceLineItemWhereInput>;
};

export type PimsInvoiceLineItemUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: PimsInvoiceLineItemUpdateWithoutIntegrationInput;
  where: PimsInvoiceLineItemWhereUniqueInput;
};

export type PimsInvoiceLineItemUpdateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  invoiceLineItem?: Maybe<InvoiceLineItemUpdateOneRequiredWithoutPimsInvoiceLineItemNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<PimsInvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemUpdateWithoutInvoiceLineItemInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPimsInvoiceLineItemsNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  type?: Maybe<PimsInvoiceLineItemType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceLineItemUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: PimsInvoiceLineItemCreateWithoutIntegrationInput;
  update: PimsInvoiceLineItemUpdateWithoutIntegrationInput;
  where: PimsInvoiceLineItemWhereUniqueInput;
};

export type PimsInvoiceLineItemUpsertWithoutInvoiceLineItemInput = {
  create: PimsInvoiceLineItemCreateWithoutInvoiceLineItemInput;
  update: PimsInvoiceLineItemUpdateWithoutInvoiceLineItemInput;
  where?: Maybe<PimsInvoiceLineItemWhereInput>;
};

export type PimsInvoiceLineItemWhereInput = {
  AND?: Maybe<Array<PimsInvoiceLineItemWhereInput>>;
  NOT?: Maybe<Array<PimsInvoiceLineItemWhereInput>>;
  OR?: Maybe<Array<PimsInvoiceLineItemWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoiceLineItem?: Maybe<InvoiceLineItemScalarRelationFilter>;
  invoiceLineItemId?: Maybe<StringFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumPimsInvoiceLineItemTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PimsInvoiceLineItemWhereUniqueInput = {
  AND?: Maybe<Array<PimsInvoiceLineItemWhereInput>>;
  NOT?: Maybe<Array<PimsInvoiceLineItemWhereInput>>;
  OR?: Maybe<Array<PimsInvoiceLineItemWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoiceLineItem?: Maybe<InvoiceLineItemScalarRelationFilter>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  invoiceLineItemId_integrationId_pimsId?: Maybe<PimsInvoiceLineItemInvoiceLineItemIdIntegrationIdPimsIdCompoundUniqueInput>;
  pimsId?: Maybe<StringFilter>;
  pimsInvoiceLineItemUniqueIntegrationIdPimsId?: Maybe<PimsInvoiceLineItemPimsInvoiceLineItemUniqueIntegrationIdPimsIdCompoundUniqueInput>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumPimsInvoiceLineItemTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PimsInvoiceListRelationFilter = {
  every?: Maybe<PimsInvoiceWhereInput>;
  none?: Maybe<PimsInvoiceWhereInput>;
  some?: Maybe<PimsInvoiceWhereInput>;
};

export type PimsInvoiceMaxAggregateOutputType = {
  __typename?: 'PimsInvoiceMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsInvoiceMinAggregateOutputType = {
  __typename?: 'PimsInvoiceMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsInvoiceNullableScalarRelationFilter = {
  AND?: Maybe<Array<PimsInvoiceWhereInput>>;
  NOT?: Maybe<Array<PimsInvoiceWhereInput>>;
  OR?: Maybe<Array<PimsInvoiceWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceId?: Maybe<StringFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  status?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PimsInvoiceOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PimsInvoiceOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PimsInvoiceOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PimsInvoiceOrderByRelevanceFieldEnum {
  IntegrationId = 'integrationId',
  InvoiceId = 'invoiceId',
  PimsId = 'pimsId',
  Status = 'status'
}

export type PimsInvoiceOrderByRelevanceInput = {
  fields: Array<PimsInvoiceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PimsInvoiceOrderByWithAggregationInput = {
  _count?: Maybe<PimsInvoiceCountOrderByAggregateInput>;
  _max?: Maybe<PimsInvoiceMaxOrderByAggregateInput>;
  _min?: Maybe<PimsInvoiceMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsInvoiceOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PimsInvoiceOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsInvoiceOrderByWithRelationInput = {
  _relevance?: Maybe<PimsInvoiceOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsInvoicePimsInvoiceUniqueIntegrationIdPimsIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export enum PimsInvoiceScalarFieldEnum {
  CreatedAt = 'createdAt',
  IntegrationId = 'integrationId',
  InvoiceId = 'invoiceId',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type PimsInvoiceScalarWhereInput = {
  AND?: Maybe<Array<PimsInvoiceScalarWhereInput>>;
  NOT?: Maybe<Array<PimsInvoiceScalarWhereInput>>;
  OR?: Maybe<Array<PimsInvoiceScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  integrationId?: Maybe<StringFilter>;
  invoiceId?: Maybe<StringFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  status?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PimsInvoiceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PimsInvoiceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PimsInvoiceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PimsInvoiceScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  invoiceId?: Maybe<StringWithAggregatesFilter>;
  pimsId?: Maybe<StringWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  status?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type PimsInvoiceUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId: Scalars['String'];
  invoiceId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<PimsInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsInvoiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsInvoiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsInvoiceCreateManyIntegrationInputEnvelope>;
};

export type PimsInvoiceUncheckedCreateNestedOneWithoutInvoiceInput = {
  connect?: Maybe<PimsInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsInvoiceCreateOrConnectWithoutInvoiceInput>;
  create?: Maybe<PimsInvoiceCreateWithoutInvoiceInput>;
};

export type PimsInvoiceUncheckedCreateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  invoiceId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceUncheckedCreateWithoutInvoiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceUncheckedUpdateManyWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<PimsInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsInvoiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsInvoiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsInvoiceCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<PimsInvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PimsInvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<PimsInvoiceWhereUniqueInput>>;
  set?: Maybe<Array<PimsInvoiceWhereUniqueInput>>;
  update?: Maybe<Array<PimsInvoiceUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<PimsInvoiceUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<PimsInvoiceUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type PimsInvoiceUncheckedUpdateOneWithoutInvoiceNestedInput = {
  connect?: Maybe<PimsInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsInvoiceCreateOrConnectWithoutInvoiceInput>;
  create?: Maybe<PimsInvoiceCreateWithoutInvoiceInput>;
  delete?: Maybe<PimsInvoiceWhereInput>;
  disconnect?: Maybe<PimsInvoiceWhereInput>;
  update?: Maybe<PimsInvoiceUpdateToOneWithWhereWithoutInvoiceInput>;
  upsert?: Maybe<PimsInvoiceUpsertWithoutInvoiceInput>;
};

export type PimsInvoiceUncheckedUpdateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceUncheckedUpdateWithoutInvoiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integrationId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPimsInvoicesNestedInput>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutPimsInvoiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceUpdateManyWithWhereWithoutIntegrationInput = {
  data: PimsInvoiceUpdateManyMutationInput;
  where: PimsInvoiceScalarWhereInput;
};

export type PimsInvoiceUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<PimsInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsInvoiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsInvoiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsInvoiceCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<PimsInvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PimsInvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<PimsInvoiceWhereUniqueInput>>;
  set?: Maybe<Array<PimsInvoiceWhereUniqueInput>>;
  update?: Maybe<Array<PimsInvoiceUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<PimsInvoiceUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<PimsInvoiceUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type PimsInvoiceUpdateOneWithoutInvoiceNestedInput = {
  connect?: Maybe<PimsInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsInvoiceCreateOrConnectWithoutInvoiceInput>;
  create?: Maybe<PimsInvoiceCreateWithoutInvoiceInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PimsInvoiceUpdateToOneWithWhereWithoutInvoiceInput>;
  upsert?: Maybe<PimsInvoiceUpsertWithoutInvoiceInput>;
};

export type PimsInvoiceUpdateToOneWithWhereWithoutInvoiceInput = {
  data: PimsInvoiceUpdateWithoutInvoiceInput;
  where?: Maybe<PimsInvoiceWhereInput>;
};

export type PimsInvoiceUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: PimsInvoiceUpdateWithoutIntegrationInput;
  where: PimsInvoiceWhereUniqueInput;
};

export type PimsInvoiceUpdateWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutPimsInvoiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceUpdateWithoutInvoiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPimsInvoicesNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsInvoiceUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: PimsInvoiceCreateWithoutIntegrationInput;
  update: PimsInvoiceUpdateWithoutIntegrationInput;
  where: PimsInvoiceWhereUniqueInput;
};

export type PimsInvoiceUpsertWithoutInvoiceInput = {
  create: PimsInvoiceCreateWithoutInvoiceInput;
  update: PimsInvoiceUpdateWithoutInvoiceInput;
  where?: Maybe<PimsInvoiceWhereInput>;
};

export type PimsInvoiceWhereInput = {
  AND?: Maybe<Array<PimsInvoiceWhereInput>>;
  NOT?: Maybe<Array<PimsInvoiceWhereInput>>;
  OR?: Maybe<Array<PimsInvoiceWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceId?: Maybe<StringFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  status?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PimsInvoiceWhereUniqueInput = {
  AND?: Maybe<Array<PimsInvoiceWhereInput>>;
  NOT?: Maybe<Array<PimsInvoiceWhereInput>>;
  OR?: Maybe<Array<PimsInvoiceWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceId_integrationId_pimsId?: Maybe<PimsInvoiceInvoiceIdIntegrationIdPimsIdCompoundUniqueInput>;
  pimsId?: Maybe<StringFilter>;
  pimsInvoiceUniqueIntegrationIdPimsId?: Maybe<PimsInvoicePimsInvoiceUniqueIntegrationIdPimsIdCompoundUniqueInput>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  status?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PimsPaymentType = {
  __typename?: 'PimsPaymentType';
  _count: PimsPaymentTypeCountOutputType;
  amexBitwerxPaymentWritebackConfigurations: Array<BitwerxPaymentWritebackConfiguration>;
  careDiscountBitwerxPaymentWritebackConfigurations: Array<BitwerxPaymentWritebackConfiguration>;
  defaultBitwerxPaymentWritebackConfigurations: Array<BitwerxPaymentWritebackConfiguration>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations: Array<BitwerxPaymentWritebackConfiguration>;
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isCreditCard: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations: Array<BitwerxPaymentWritebackConfiguration>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations: Array<BitwerxPaymentWritebackConfiguration>;
};


export type PimsPaymentTypeAmexBitwerxPaymentWritebackConfigurationsArgs = {
  cursor?: Maybe<BitwerxPaymentWritebackConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
};


export type PimsPaymentTypeCareDiscountBitwerxPaymentWritebackConfigurationsArgs = {
  cursor?: Maybe<BitwerxPaymentWritebackConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
};


export type PimsPaymentTypeDefaultBitwerxPaymentWritebackConfigurationsArgs = {
  cursor?: Maybe<BitwerxPaymentWritebackConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
};


export type PimsPaymentTypeDiscoverBitwerxPaymentWritebackConfigurationsArgs = {
  cursor?: Maybe<BitwerxPaymentWritebackConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
};


export type PimsPaymentTypeMastercardBitwerxPaymentWritebackConfigurationsArgs = {
  cursor?: Maybe<BitwerxPaymentWritebackConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
};


export type PimsPaymentTypeVisaBitwerxPaymentWritebackConfigurationsArgs = {
  cursor?: Maybe<BitwerxPaymentWritebackConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
};

export type PimsPaymentTypeCountAggregateOutputType = {
  __typename?: 'PimsPaymentTypeCountAggregateOutputType';
  _all: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isCreditCard: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isInactive: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
};

export type PimsPaymentTypeCountOrderByAggregateInput = {
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isCreditCard?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isInactive?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
};

export type PimsPaymentTypeCountOutputType = {
  __typename?: 'PimsPaymentTypeCountOutputType';
  amexBitwerxPaymentWritebackConfigurations: Scalars['Int'];
  careDiscountBitwerxPaymentWritebackConfigurations: Scalars['Int'];
  defaultBitwerxPaymentWritebackConfigurations: Scalars['Int'];
  discoverBitwerxPaymentWritebackConfigurations: Scalars['Int'];
  mastercardBitwerxPaymentWritebackConfigurations: Scalars['Int'];
  visaBitwerxPaymentWritebackConfigurations: Scalars['Int'];
};

export type PimsPaymentTypeCreateInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPimsPaymentTypesInput;
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeCreateManyInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
};

export type PimsPaymentTypeCreateManyIntegrationInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
};

export type PimsPaymentTypeCreateManyIntegrationInputEnvelope = {
  data: Array<PimsPaymentTypeCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PimsPaymentTypeCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<PimsPaymentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsPaymentTypeCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsPaymentTypeCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsPaymentTypeCreateManyIntegrationInputEnvelope>;
};

export type PimsPaymentTypeCreateNestedOneWithoutAmexBitwerxPaymentWritebackConfigurationsInput = {
  connect?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsPaymentTypeCreateOrConnectWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<PimsPaymentTypeCreateWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
};

export type PimsPaymentTypeCreateNestedOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput = {
  connect?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsPaymentTypeCreateOrConnectWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<PimsPaymentTypeCreateWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
};

export type PimsPaymentTypeCreateNestedOneWithoutDefaultBitwerxPaymentWritebackConfigurationsInput = {
  connect?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsPaymentTypeCreateOrConnectWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<PimsPaymentTypeCreateWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
};

export type PimsPaymentTypeCreateNestedOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput = {
  connect?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsPaymentTypeCreateOrConnectWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<PimsPaymentTypeCreateWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
};

export type PimsPaymentTypeCreateNestedOneWithoutMastercardBitwerxPaymentWritebackConfigurationsInput = {
  connect?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsPaymentTypeCreateOrConnectWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<PimsPaymentTypeCreateWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
};

export type PimsPaymentTypeCreateNestedOneWithoutVisaBitwerxPaymentWritebackConfigurationsInput = {
  connect?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsPaymentTypeCreateOrConnectWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<PimsPaymentTypeCreateWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
};

export type PimsPaymentTypeCreateOrConnectWithoutAmexBitwerxPaymentWritebackConfigurationsInput = {
  create: PimsPaymentTypeCreateWithoutAmexBitwerxPaymentWritebackConfigurationsInput;
  where: PimsPaymentTypeWhereUniqueInput;
};

export type PimsPaymentTypeCreateOrConnectWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput = {
  create: PimsPaymentTypeCreateWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput;
  where: PimsPaymentTypeWhereUniqueInput;
};

export type PimsPaymentTypeCreateOrConnectWithoutDefaultBitwerxPaymentWritebackConfigurationsInput = {
  create: PimsPaymentTypeCreateWithoutDefaultBitwerxPaymentWritebackConfigurationsInput;
  where: PimsPaymentTypeWhereUniqueInput;
};

export type PimsPaymentTypeCreateOrConnectWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput = {
  create: PimsPaymentTypeCreateWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput;
  where: PimsPaymentTypeWhereUniqueInput;
};

export type PimsPaymentTypeCreateOrConnectWithoutIntegrationInput = {
  create: PimsPaymentTypeCreateWithoutIntegrationInput;
  where: PimsPaymentTypeWhereUniqueInput;
};

export type PimsPaymentTypeCreateOrConnectWithoutMastercardBitwerxPaymentWritebackConfigurationsInput = {
  create: PimsPaymentTypeCreateWithoutMastercardBitwerxPaymentWritebackConfigurationsInput;
  where: PimsPaymentTypeWhereUniqueInput;
};

export type PimsPaymentTypeCreateOrConnectWithoutVisaBitwerxPaymentWritebackConfigurationsInput = {
  create: PimsPaymentTypeCreateWithoutVisaBitwerxPaymentWritebackConfigurationsInput;
  where: PimsPaymentTypeWhereUniqueInput;
};

export type PimsPaymentTypeCreateWithoutAmexBitwerxPaymentWritebackConfigurationsInput = {
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPimsPaymentTypesInput;
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeCreateWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPimsPaymentTypesInput;
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeCreateWithoutDefaultBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPimsPaymentTypesInput;
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeCreateWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPimsPaymentTypesInput;
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeCreateWithoutIntegrationInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeCreateWithoutMastercardBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPimsPaymentTypesInput;
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeCreateWithoutVisaBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPimsPaymentTypesInput;
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
};

export type PimsPaymentTypeGroupByOutputType = {
  __typename?: 'PimsPaymentTypeGroupByOutputType';
  _count?: Maybe<PimsPaymentTypeCountAggregateOutputType>;
  _max?: Maybe<PimsPaymentTypeMaxAggregateOutputType>;
  _min?: Maybe<PimsPaymentTypeMinAggregateOutputType>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integrationId: Scalars['String'];
  isCreditCard: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isInactive: Scalars['Boolean'];
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
};

export type PimsPaymentTypeListRelationFilter = {
  every?: Maybe<PimsPaymentTypeWhereInput>;
  none?: Maybe<PimsPaymentTypeWhereInput>;
  some?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeMaxAggregateOutputType = {
  __typename?: 'PimsPaymentTypeMaxAggregateOutputType';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
};

export type PimsPaymentTypeMaxOrderByAggregateInput = {
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isCreditCard?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isInactive?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
};

export type PimsPaymentTypeMinAggregateOutputType = {
  __typename?: 'PimsPaymentTypeMinAggregateOutputType';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
};

export type PimsPaymentTypeMinOrderByAggregateInput = {
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isCreditCard?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isInactive?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
};

export type PimsPaymentTypeNullableScalarRelationFilter = {
  AND?: Maybe<Array<PimsPaymentTypeWhereInput>>;
  NOT?: Maybe<Array<PimsPaymentTypeWhereInput>>;
  OR?: Maybe<Array<PimsPaymentTypeWhereInput>>;
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  description?: Maybe<StringNullableFilter>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isCreditCard?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isInactive?: Maybe<BoolFilter>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonFilter>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
};

export type PimsPaymentTypeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PimsPaymentTypeOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PimsPaymentTypeOrderByRelevanceInput>;
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  description?: Maybe<SortOrder>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isCreditCard?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isInactive?: Maybe<SortOrder>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
};

export enum PimsPaymentTypeOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  IntegrationId = 'integrationId',
  PimsId = 'pimsId'
}

export type PimsPaymentTypeOrderByRelevanceInput = {
  fields: Array<PimsPaymentTypeOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PimsPaymentTypeOrderByWithAggregationInput = {
  _count?: Maybe<PimsPaymentTypeCountOrderByAggregateInput>;
  _max?: Maybe<PimsPaymentTypeMaxOrderByAggregateInput>;
  _min?: Maybe<PimsPaymentTypeMinOrderByAggregateInput>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isCreditCard?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isInactive?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
};

export type PimsPaymentTypeOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PimsPaymentTypeOrderByRelevanceInput>;
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  description?: Maybe<SortOrder>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isCreditCard?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isInactive?: Maybe<SortOrder>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
};

export type PimsPaymentTypeOrderByWithRelationInput = {
  _relevance?: Maybe<PimsPaymentTypeOrderByRelevanceInput>;
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  description?: Maybe<SortOrder>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isCreditCard?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isInactive?: Maybe<SortOrder>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationOrderByRelationAggregateInput>;
};

export type PimsPaymentTypePimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export enum PimsPaymentTypeScalarFieldEnum {
  Description = 'description',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsCreditCard = 'isCreditCard',
  IsDeleted = 'isDeleted',
  IsInactive = 'isInactive',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue'
}

export type PimsPaymentTypeScalarWhereInput = {
  AND?: Maybe<Array<PimsPaymentTypeScalarWhereInput>>;
  NOT?: Maybe<Array<PimsPaymentTypeScalarWhereInput>>;
  OR?: Maybe<Array<PimsPaymentTypeScalarWhereInput>>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  isCreditCard?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isInactive?: Maybe<BoolFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonFilter>;
};

export type PimsPaymentTypeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PimsPaymentTypeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PimsPaymentTypeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PimsPaymentTypeScalarWhereWithAggregatesInput>>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isCreditCard?: Maybe<BoolWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  isInactive?: Maybe<BoolWithAggregatesFilter>;
  pimsId?: Maybe<StringWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonWithAggregatesFilter>;
};

export type PimsPaymentTypeUncheckedCreateInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<PimsPaymentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsPaymentTypeCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsPaymentTypeCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsPaymentTypeCreateManyIntegrationInputEnvelope>;
};

export type PimsPaymentTypeUncheckedCreateWithoutAmexBitwerxPaymentWritebackConfigurationsInput = {
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeUncheckedCreateWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeUncheckedCreateWithoutDefaultBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeUncheckedCreateWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeUncheckedCreateWithoutIntegrationInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeUncheckedCreateWithoutMastercardBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutVisaPimsPaymentTypeInput>;
};

export type PimsPaymentTypeUncheckedCreateWithoutVisaBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutAmexPimsPaymentTypeInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutCareDiscountPimsPaymentTypeInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDefaultPimsPaymentTypeInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutDiscoverPimsPaymentTypeInput>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCreditCard: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive: Scalars['Boolean'];
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedCreateNestedManyWithoutMastercardPimsPaymentTypeInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
};

export type PimsPaymentTypeUncheckedUpdateInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUncheckedUpdateManyInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
};

export type PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
};

export type PimsPaymentTypeUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<PimsPaymentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsPaymentTypeCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsPaymentTypeCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsPaymentTypeCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<PimsPaymentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PimsPaymentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<PimsPaymentTypeWhereUniqueInput>>;
  set?: Maybe<Array<PimsPaymentTypeWhereUniqueInput>>;
  update?: Maybe<Array<PimsPaymentTypeUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<PimsPaymentTypeUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<PimsPaymentTypeUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type PimsPaymentTypeUncheckedUpdateWithoutAmexBitwerxPaymentWritebackConfigurationsInput = {
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUncheckedUpdateWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUncheckedUpdateWithoutDefaultBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUncheckedUpdateWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUncheckedUpdateWithoutIntegrationInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUncheckedUpdateWithoutMastercardBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUncheckedUpdateWithoutVisaBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUncheckedUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
};

export type PimsPaymentTypeUpdateInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPimsPaymentTypesNestedInput>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUpdateManyMutationInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
};

export type PimsPaymentTypeUpdateManyWithWhereWithoutIntegrationInput = {
  data: PimsPaymentTypeUpdateManyMutationInput;
  where: PimsPaymentTypeScalarWhereInput;
};

export type PimsPaymentTypeUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<PimsPaymentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsPaymentTypeCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsPaymentTypeCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsPaymentTypeCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<PimsPaymentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PimsPaymentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<PimsPaymentTypeWhereUniqueInput>>;
  set?: Maybe<Array<PimsPaymentTypeWhereUniqueInput>>;
  update?: Maybe<Array<PimsPaymentTypeUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<PimsPaymentTypeUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<PimsPaymentTypeUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type PimsPaymentTypeUpdateOneWithoutAmexBitwerxPaymentWritebackConfigurationsNestedInput = {
  connect?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsPaymentTypeCreateOrConnectWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<PimsPaymentTypeCreateWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PimsPaymentTypeUpdateToOneWithWhereWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
  upsert?: Maybe<PimsPaymentTypeUpsertWithoutAmexBitwerxPaymentWritebackConfigurationsInput>;
};

export type PimsPaymentTypeUpdateOneWithoutCareDiscountBitwerxPaymentWritebackConfigurationsNestedInput = {
  connect?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsPaymentTypeCreateOrConnectWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<PimsPaymentTypeCreateWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PimsPaymentTypeUpdateToOneWithWhereWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
  upsert?: Maybe<PimsPaymentTypeUpsertWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput>;
};

export type PimsPaymentTypeUpdateOneWithoutDefaultBitwerxPaymentWritebackConfigurationsNestedInput = {
  connect?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsPaymentTypeCreateOrConnectWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<PimsPaymentTypeCreateWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PimsPaymentTypeUpdateToOneWithWhereWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
  upsert?: Maybe<PimsPaymentTypeUpsertWithoutDefaultBitwerxPaymentWritebackConfigurationsInput>;
};

export type PimsPaymentTypeUpdateOneWithoutDiscoverBitwerxPaymentWritebackConfigurationsNestedInput = {
  connect?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsPaymentTypeCreateOrConnectWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<PimsPaymentTypeCreateWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PimsPaymentTypeUpdateToOneWithWhereWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
  upsert?: Maybe<PimsPaymentTypeUpsertWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput>;
};

export type PimsPaymentTypeUpdateOneWithoutMastercardBitwerxPaymentWritebackConfigurationsNestedInput = {
  connect?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsPaymentTypeCreateOrConnectWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<PimsPaymentTypeCreateWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PimsPaymentTypeUpdateToOneWithWhereWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
  upsert?: Maybe<PimsPaymentTypeUpsertWithoutMastercardBitwerxPaymentWritebackConfigurationsInput>;
};

export type PimsPaymentTypeUpdateOneWithoutVisaBitwerxPaymentWritebackConfigurationsNestedInput = {
  connect?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsPaymentTypeCreateOrConnectWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
  create?: Maybe<PimsPaymentTypeCreateWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PimsPaymentTypeUpdateToOneWithWhereWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
  upsert?: Maybe<PimsPaymentTypeUpsertWithoutVisaBitwerxPaymentWritebackConfigurationsInput>;
};

export type PimsPaymentTypeUpdateToOneWithWhereWithoutAmexBitwerxPaymentWritebackConfigurationsInput = {
  data: PimsPaymentTypeUpdateWithoutAmexBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeUpdateToOneWithWhereWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput = {
  data: PimsPaymentTypeUpdateWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeUpdateToOneWithWhereWithoutDefaultBitwerxPaymentWritebackConfigurationsInput = {
  data: PimsPaymentTypeUpdateWithoutDefaultBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeUpdateToOneWithWhereWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput = {
  data: PimsPaymentTypeUpdateWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeUpdateToOneWithWhereWithoutMastercardBitwerxPaymentWritebackConfigurationsInput = {
  data: PimsPaymentTypeUpdateWithoutMastercardBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeUpdateToOneWithWhereWithoutVisaBitwerxPaymentWritebackConfigurationsInput = {
  data: PimsPaymentTypeUpdateWithoutVisaBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: PimsPaymentTypeUpdateWithoutIntegrationInput;
  where: PimsPaymentTypeWhereUniqueInput;
};

export type PimsPaymentTypeUpdateWithoutAmexBitwerxPaymentWritebackConfigurationsInput = {
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPimsPaymentTypesNestedInput>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUpdateWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPimsPaymentTypesNestedInput>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUpdateWithoutDefaultBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPimsPaymentTypesNestedInput>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUpdateWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPimsPaymentTypesNestedInput>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUpdateWithoutIntegrationInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUpdateWithoutMastercardBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPimsPaymentTypesNestedInput>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutVisaPimsPaymentTypeNestedInput>;
};

export type PimsPaymentTypeUpdateWithoutVisaBitwerxPaymentWritebackConfigurationsInput = {
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutAmexPimsPaymentTypeNestedInput>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutCareDiscountPimsPaymentTypeNestedInput>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDefaultPimsPaymentTypeNestedInput>;
  description?: Maybe<Scalars['String']>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutDiscoverPimsPaymentTypeNestedInput>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPimsPaymentTypesNestedInput>;
  isCreditCard?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationUpdateManyWithoutMastercardPimsPaymentTypeNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
};

export type PimsPaymentTypeUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: PimsPaymentTypeCreateWithoutIntegrationInput;
  update: PimsPaymentTypeUpdateWithoutIntegrationInput;
  where: PimsPaymentTypeWhereUniqueInput;
};

export type PimsPaymentTypeUpsertWithoutAmexBitwerxPaymentWritebackConfigurationsInput = {
  create: PimsPaymentTypeCreateWithoutAmexBitwerxPaymentWritebackConfigurationsInput;
  update: PimsPaymentTypeUpdateWithoutAmexBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeUpsertWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput = {
  create: PimsPaymentTypeCreateWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput;
  update: PimsPaymentTypeUpdateWithoutCareDiscountBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeUpsertWithoutDefaultBitwerxPaymentWritebackConfigurationsInput = {
  create: PimsPaymentTypeCreateWithoutDefaultBitwerxPaymentWritebackConfigurationsInput;
  update: PimsPaymentTypeUpdateWithoutDefaultBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeUpsertWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput = {
  create: PimsPaymentTypeCreateWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput;
  update: PimsPaymentTypeUpdateWithoutDiscoverBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeUpsertWithoutMastercardBitwerxPaymentWritebackConfigurationsInput = {
  create: PimsPaymentTypeCreateWithoutMastercardBitwerxPaymentWritebackConfigurationsInput;
  update: PimsPaymentTypeUpdateWithoutMastercardBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeUpsertWithoutVisaBitwerxPaymentWritebackConfigurationsInput = {
  create: PimsPaymentTypeCreateWithoutVisaBitwerxPaymentWritebackConfigurationsInput;
  update: PimsPaymentTypeUpdateWithoutVisaBitwerxPaymentWritebackConfigurationsInput;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};

export type PimsPaymentTypeWhereInput = {
  AND?: Maybe<Array<PimsPaymentTypeWhereInput>>;
  NOT?: Maybe<Array<PimsPaymentTypeWhereInput>>;
  OR?: Maybe<Array<PimsPaymentTypeWhereInput>>;
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  description?: Maybe<StringNullableFilter>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isCreditCard?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isInactive?: Maybe<BoolFilter>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonFilter>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
};

export type PimsPaymentTypeWhereUniqueInput = {
  AND?: Maybe<Array<PimsPaymentTypeWhereInput>>;
  NOT?: Maybe<Array<PimsPaymentTypeWhereInput>>;
  OR?: Maybe<Array<PimsPaymentTypeWhereInput>>;
  amexBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  careDiscountBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  defaultBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  description?: Maybe<StringNullableFilter>;
  discoverBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isCreditCard?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isInactive?: Maybe<BoolFilter>;
  mastercardBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
  pimsId?: Maybe<StringFilter>;
  pimsIdAndIntegrationId?: Maybe<PimsPaymentTypePimsIdAndIntegrationIdCompoundUniqueInput>;
  rawPimsValue?: Maybe<JsonFilter>;
  visaBitwerxPaymentWritebackConfigurations?: Maybe<BitwerxPaymentWritebackConfigurationListRelationFilter>;
};

export enum PimsSyncFrequency {
  Sync_5Min = 'Sync_5_Min',
  Sync_24Hour = 'Sync_24_Hour',
  Sync_30Sec = 'Sync_30_Sec'
}

export enum PimsSyncStatus {
  Completed = 'Completed',
  Created = 'Created',
  Error = 'Error',
  Started = 'Started'
}

export type PimsWritebackLogEntry = {
  __typename?: 'PimsWritebackLogEntry';
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntry>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntry>;
  createdAt: Scalars['DateTime'];
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntry>;
  httpCode?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntry>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntry>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  /** Only set this when there were errors */
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredBy?: Maybe<User>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type: PimsWritebackType;
  updatedAt: Scalars['DateTime'];
};


export type PimsWritebackLogEntryAiRecapPimsWritebackLogEntryArgs = {
  where?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
};


export type PimsWritebackLogEntryCareAccountCreditLogArgs = {
  where?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
};


export type PimsWritebackLogEntryCustomFieldsLogArgs = {
  where?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
};


export type PimsWritebackLogEntryInvoiceLogArgs = {
  where?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
};


export type PimsWritebackLogEntryPaymentLogArgs = {
  where?: Maybe<PaymentPimsWritebackLogEntryWhereInput>;
};


export type PimsWritebackLogEntryTriggeredByArgs = {
  where?: Maybe<UserWhereInput>;
};

export type PimsWritebackLogEntryAvgAggregateOutputType = {
  __typename?: 'PimsWritebackLogEntryAvgAggregateOutputType';
  httpCode?: Maybe<Scalars['Float']>;
};

export type PimsWritebackLogEntryAvgOrderByAggregateInput = {
  httpCode?: Maybe<SortOrder>;
};

export type PimsWritebackLogEntryCountAggregateOutputType = {
  __typename?: 'PimsWritebackLogEntryCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  httpCode: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  normalizedError: Scalars['Int'];
  pimsError: Scalars['Int'];
  pimsId: Scalars['Int'];
  requestBody: Scalars['Int'];
  requestId: Scalars['Int'];
  status: Scalars['Int'];
  triggeredByUserId: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PimsWritebackLogEntryCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  normalizedError?: Maybe<SortOrder>;
  pimsError?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  requestId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredByUserId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsWritebackLogEntryCreateInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutWritebackLogEntriesInput;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredBy?: Maybe<UserCreateNestedOneWithoutTriggeredWritebacksInput>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryCreateManyIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryCreateManyIntegrationInputEnvelope = {
  data: Array<PimsWritebackLogEntryCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PimsWritebackLogEntryCreateManyTriggeredByInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryCreateManyTriggeredByInputEnvelope = {
  data: Array<PimsWritebackLogEntryCreateManyTriggeredByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PimsWritebackLogEntryCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsWritebackLogEntryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsWritebackLogEntryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsWritebackLogEntryCreateManyIntegrationInputEnvelope>;
};

export type PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput = {
  connect?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsWritebackLogEntryCreateOrConnectWithoutTriggeredByInput>>;
  create?: Maybe<Array<PimsWritebackLogEntryCreateWithoutTriggeredByInput>>;
  createMany?: Maybe<PimsWritebackLogEntryCreateManyTriggeredByInputEnvelope>;
};

export type PimsWritebackLogEntryCreateNestedOneWithoutAiRecapPimsWritebackLogEntryInput = {
  connect?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsWritebackLogEntryCreateOrConnectWithoutAiRecapPimsWritebackLogEntryInput>;
  create?: Maybe<PimsWritebackLogEntryCreateWithoutAiRecapPimsWritebackLogEntryInput>;
};

export type PimsWritebackLogEntryCreateNestedOneWithoutCareAccountCreditLogInput = {
  connect?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsWritebackLogEntryCreateOrConnectWithoutCareAccountCreditLogInput>;
  create?: Maybe<PimsWritebackLogEntryCreateWithoutCareAccountCreditLogInput>;
};

export type PimsWritebackLogEntryCreateNestedOneWithoutCustomFieldsLogInput = {
  connect?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsWritebackLogEntryCreateOrConnectWithoutCustomFieldsLogInput>;
  create?: Maybe<PimsWritebackLogEntryCreateWithoutCustomFieldsLogInput>;
};

export type PimsWritebackLogEntryCreateNestedOneWithoutInvoiceLogInput = {
  connect?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsWritebackLogEntryCreateOrConnectWithoutInvoiceLogInput>;
  create?: Maybe<PimsWritebackLogEntryCreateWithoutInvoiceLogInput>;
};

export type PimsWritebackLogEntryCreateNestedOneWithoutPaymentLogInput = {
  connect?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsWritebackLogEntryCreateOrConnectWithoutPaymentLogInput>;
  create?: Maybe<PimsWritebackLogEntryCreateWithoutPaymentLogInput>;
};

export type PimsWritebackLogEntryCreateOrConnectWithoutAiRecapPimsWritebackLogEntryInput = {
  create: PimsWritebackLogEntryCreateWithoutAiRecapPimsWritebackLogEntryInput;
  where: PimsWritebackLogEntryWhereUniqueInput;
};

export type PimsWritebackLogEntryCreateOrConnectWithoutCareAccountCreditLogInput = {
  create: PimsWritebackLogEntryCreateWithoutCareAccountCreditLogInput;
  where: PimsWritebackLogEntryWhereUniqueInput;
};

export type PimsWritebackLogEntryCreateOrConnectWithoutCustomFieldsLogInput = {
  create: PimsWritebackLogEntryCreateWithoutCustomFieldsLogInput;
  where: PimsWritebackLogEntryWhereUniqueInput;
};

export type PimsWritebackLogEntryCreateOrConnectWithoutIntegrationInput = {
  create: PimsWritebackLogEntryCreateWithoutIntegrationInput;
  where: PimsWritebackLogEntryWhereUniqueInput;
};

export type PimsWritebackLogEntryCreateOrConnectWithoutInvoiceLogInput = {
  create: PimsWritebackLogEntryCreateWithoutInvoiceLogInput;
  where: PimsWritebackLogEntryWhereUniqueInput;
};

export type PimsWritebackLogEntryCreateOrConnectWithoutPaymentLogInput = {
  create: PimsWritebackLogEntryCreateWithoutPaymentLogInput;
  where: PimsWritebackLogEntryWhereUniqueInput;
};

export type PimsWritebackLogEntryCreateOrConnectWithoutTriggeredByInput = {
  create: PimsWritebackLogEntryCreateWithoutTriggeredByInput;
  where: PimsWritebackLogEntryWhereUniqueInput;
};

export type PimsWritebackLogEntryCreateWithoutAiRecapPimsWritebackLogEntryInput = {
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutWritebackLogEntriesInput;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredBy?: Maybe<UserCreateNestedOneWithoutTriggeredWritebacksInput>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryCreateWithoutCareAccountCreditLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutWritebackLogEntriesInput;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredBy?: Maybe<UserCreateNestedOneWithoutTriggeredWritebacksInput>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryCreateWithoutCustomFieldsLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutWritebackLogEntriesInput;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredBy?: Maybe<UserCreateNestedOneWithoutTriggeredWritebacksInput>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryCreateWithoutIntegrationInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredBy?: Maybe<UserCreateNestedOneWithoutTriggeredWritebacksInput>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryCreateWithoutInvoiceLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutWritebackLogEntriesInput;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredBy?: Maybe<UserCreateNestedOneWithoutTriggeredWritebacksInput>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryCreateWithoutPaymentLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutWritebackLogEntriesInput;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredBy?: Maybe<UserCreateNestedOneWithoutTriggeredWritebacksInput>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryCreateWithoutTriggeredByInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutWritebackLogEntriesInput;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryGroupByOutputType = {
  __typename?: 'PimsWritebackLogEntryGroupByOutputType';
  _avg?: Maybe<PimsWritebackLogEntryAvgAggregateOutputType>;
  _count?: Maybe<PimsWritebackLogEntryCountAggregateOutputType>;
  _max?: Maybe<PimsWritebackLogEntryMaxAggregateOutputType>;
  _min?: Maybe<PimsWritebackLogEntryMinAggregateOutputType>;
  _sum?: Maybe<PimsWritebackLogEntrySumAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  httpCode?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  integrationId: Scalars['String'];
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type: PimsWritebackType;
  updatedAt: Scalars['DateTime'];
};

export type PimsWritebackLogEntryListRelationFilter = {
  every?: Maybe<PimsWritebackLogEntryWhereInput>;
  none?: Maybe<PimsWritebackLogEntryWhereInput>;
  some?: Maybe<PimsWritebackLogEntryWhereInput>;
};

export type PimsWritebackLogEntryMaxAggregateOutputType = {
  __typename?: 'PimsWritebackLogEntryMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  normalizedError?: Maybe<SortOrder>;
  pimsError?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  requestId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredByUserId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsWritebackLogEntryMinAggregateOutputType = {
  __typename?: 'PimsWritebackLogEntryMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  normalizedError?: Maybe<SortOrder>;
  pimsError?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  requestId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredByUserId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsWritebackLogEntryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PimsWritebackLogEntryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PimsWritebackLogEntryOrderByRelevanceInput>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryOrderByWithRelationInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryOrderByWithRelationInput>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryOrderByWithRelationInput>;
  normalizedError?: Maybe<SortOrder>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryOrderByWithRelationInput>;
  pimsError?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  requestId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredBy?: Maybe<UserOrderByWithRelationInput>;
  triggeredByUserId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PimsWritebackLogEntryOrderByRelevanceFieldEnum {
  Id = 'id',
  IntegrationId = 'integrationId',
  PimsError = 'pimsError',
  PimsId = 'pimsId',
  RequestId = 'requestId',
  TriggeredByUserId = 'triggeredByUserId'
}

export type PimsWritebackLogEntryOrderByRelevanceInput = {
  fields: Array<PimsWritebackLogEntryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PimsWritebackLogEntryOrderByWithAggregationInput = {
  _avg?: Maybe<PimsWritebackLogEntryAvgOrderByAggregateInput>;
  _count?: Maybe<PimsWritebackLogEntryCountOrderByAggregateInput>;
  _max?: Maybe<PimsWritebackLogEntryMaxOrderByAggregateInput>;
  _min?: Maybe<PimsWritebackLogEntryMinOrderByAggregateInput>;
  _sum?: Maybe<PimsWritebackLogEntrySumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  normalizedError?: Maybe<SortOrder>;
  pimsError?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  requestId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredByUserId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsWritebackLogEntryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PimsWritebackLogEntryOrderByRelevanceInput>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryOrderByWithRelationInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryOrderByWithRelationInput>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryOrderByWithRelationInput>;
  normalizedError?: Maybe<SortOrder>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryOrderByWithRelationInput>;
  pimsError?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  requestId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredBy?: Maybe<UserOrderByWithRelationInput>;
  triggeredByUserId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PimsWritebackLogEntryOrderByWithRelationInput = {
  _relevance?: Maybe<PimsWritebackLogEntryOrderByRelevanceInput>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryOrderByWithRelationInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryOrderByWithRelationInput>;
  httpCode?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryOrderByWithRelationInput>;
  normalizedError?: Maybe<SortOrder>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryOrderByWithRelationInput>;
  pimsError?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  requestId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  triggeredBy?: Maybe<UserOrderByWithRelationInput>;
  triggeredByUserId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PimsWritebackLogEntryScalarFieldEnum {
  CreatedAt = 'createdAt',
  HttpCode = 'httpCode',
  Id = 'id',
  IntegrationId = 'integrationId',
  NormalizedError = 'normalizedError',
  PimsError = 'pimsError',
  PimsId = 'pimsId',
  RequestBody = 'requestBody',
  RequestId = 'requestId',
  Status = 'status',
  TriggeredByUserId = 'triggeredByUserId',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type PimsWritebackLogEntryScalarRelationFilter = {
  AND?: Maybe<Array<PimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<PimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<PimsWritebackLogEntryWhereInput>>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryNullableScalarRelationFilter>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryNullableScalarRelationFilter>;
  httpCode?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryNullableScalarRelationFilter>;
  normalizedError?: Maybe<EnumNormalizedWritebackErrorNullableFilter>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryNullableScalarRelationFilter>;
  pimsError?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  requestBody?: Maybe<JsonNullableFilter>;
  requestId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumPimsWritebackStatusFilter>;
  triggeredBy?: Maybe<UserNullableScalarRelationFilter>;
  triggeredByUserId?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumPimsWritebackTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PimsWritebackLogEntryScalarWhereInput = {
  AND?: Maybe<Array<PimsWritebackLogEntryScalarWhereInput>>;
  NOT?: Maybe<Array<PimsWritebackLogEntryScalarWhereInput>>;
  OR?: Maybe<Array<PimsWritebackLogEntryScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  httpCode?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  normalizedError?: Maybe<EnumNormalizedWritebackErrorNullableFilter>;
  pimsError?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  requestBody?: Maybe<JsonNullableFilter>;
  requestId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumPimsWritebackStatusFilter>;
  triggeredByUserId?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumPimsWritebackTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PimsWritebackLogEntryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PimsWritebackLogEntryScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  httpCode?: Maybe<IntNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  normalizedError?: Maybe<EnumNormalizedWritebackErrorNullableWithAggregatesFilter>;
  pimsError?: Maybe<StringNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  requestBody?: Maybe<JsonNullableWithAggregatesFilter>;
  requestId?: Maybe<StringNullableWithAggregatesFilter>;
  status?: Maybe<EnumPimsWritebackStatusWithAggregatesFilter>;
  triggeredByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  type?: Maybe<EnumPimsWritebackTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type PimsWritebackLogEntrySumAggregateOutputType = {
  __typename?: 'PimsWritebackLogEntrySumAggregateOutputType';
  httpCode?: Maybe<Scalars['Int']>;
};

export type PimsWritebackLogEntrySumOrderByAggregateInput = {
  httpCode?: Maybe<SortOrder>;
};

export type PimsWritebackLogEntryUncheckedCreateInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsWritebackLogEntryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsWritebackLogEntryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsWritebackLogEntryCreateManyIntegrationInputEnvelope>;
};

export type PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput = {
  connect?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsWritebackLogEntryCreateOrConnectWithoutTriggeredByInput>>;
  create?: Maybe<Array<PimsWritebackLogEntryCreateWithoutTriggeredByInput>>;
  createMany?: Maybe<PimsWritebackLogEntryCreateManyTriggeredByInputEnvelope>;
};

export type PimsWritebackLogEntryUncheckedCreateWithoutAiRecapPimsWritebackLogEntryInput = {
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedCreateWithoutCareAccountCreditLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedCreateWithoutCustomFieldsLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedCreateWithoutIntegrationInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedCreateWithoutInvoiceLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedCreateWithoutPaymentLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedCreateWithoutTriggeredByInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedOneWithoutWritebackLogInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status: PimsWritebackStatus;
  type: PimsWritebackType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedUpdateInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsWritebackLogEntryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsWritebackLogEntryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsWritebackLogEntryCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<PimsWritebackLogEntryUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<PimsWritebackLogEntryUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<PimsWritebackLogEntryUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput = {
  connect?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsWritebackLogEntryCreateOrConnectWithoutTriggeredByInput>>;
  create?: Maybe<Array<PimsWritebackLogEntryCreateWithoutTriggeredByInput>>;
  createMany?: Maybe<PimsWritebackLogEntryCreateManyTriggeredByInputEnvelope>;
  delete?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<PimsWritebackLogEntryUpdateWithWhereUniqueWithoutTriggeredByInput>>;
  updateMany?: Maybe<Array<PimsWritebackLogEntryUpdateManyWithWhereWithoutTriggeredByInput>>;
  upsert?: Maybe<Array<PimsWritebackLogEntryUpsertWithWhereUniqueWithoutTriggeredByInput>>;
};

export type PimsWritebackLogEntryUncheckedUpdateWithoutAiRecapPimsWritebackLogEntryInput = {
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedUpdateWithoutCareAccountCreditLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedUpdateWithoutCustomFieldsLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedUpdateWithoutIntegrationInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedUpdateWithoutInvoiceLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedUpdateWithoutPaymentLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredByUserId?: Maybe<Scalars['String']>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUncheckedUpdateWithoutTriggeredByInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUpdateInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutWritebackLogEntriesNestedInput>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredBy?: Maybe<UserUpdateOneWithoutTriggeredWritebacksNestedInput>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUpdateManyWithWhereWithoutIntegrationInput = {
  data: PimsWritebackLogEntryUpdateManyMutationInput;
  where: PimsWritebackLogEntryScalarWhereInput;
};

export type PimsWritebackLogEntryUpdateManyWithWhereWithoutTriggeredByInput = {
  data: PimsWritebackLogEntryUpdateManyMutationInput;
  where: PimsWritebackLogEntryScalarWhereInput;
};

export type PimsWritebackLogEntryUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsWritebackLogEntryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PimsWritebackLogEntryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PimsWritebackLogEntryCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<PimsWritebackLogEntryUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<PimsWritebackLogEntryUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<PimsWritebackLogEntryUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput = {
  connect?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PimsWritebackLogEntryCreateOrConnectWithoutTriggeredByInput>>;
  create?: Maybe<Array<PimsWritebackLogEntryCreateWithoutTriggeredByInput>>;
  createMany?: Maybe<PimsWritebackLogEntryCreateManyTriggeredByInputEnvelope>;
  delete?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PimsWritebackLogEntryScalarWhereInput>>;
  disconnect?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  set?: Maybe<Array<PimsWritebackLogEntryWhereUniqueInput>>;
  update?: Maybe<Array<PimsWritebackLogEntryUpdateWithWhereUniqueWithoutTriggeredByInput>>;
  updateMany?: Maybe<Array<PimsWritebackLogEntryUpdateManyWithWhereWithoutTriggeredByInput>>;
  upsert?: Maybe<Array<PimsWritebackLogEntryUpsertWithWhereUniqueWithoutTriggeredByInput>>;
};

export type PimsWritebackLogEntryUpdateOneRequiredWithoutAiRecapPimsWritebackLogEntryNestedInput = {
  connect?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsWritebackLogEntryCreateOrConnectWithoutAiRecapPimsWritebackLogEntryInput>;
  create?: Maybe<PimsWritebackLogEntryCreateWithoutAiRecapPimsWritebackLogEntryInput>;
  update?: Maybe<PimsWritebackLogEntryUpdateToOneWithWhereWithoutAiRecapPimsWritebackLogEntryInput>;
  upsert?: Maybe<PimsWritebackLogEntryUpsertWithoutAiRecapPimsWritebackLogEntryInput>;
};

export type PimsWritebackLogEntryUpdateOneRequiredWithoutCareAccountCreditLogNestedInput = {
  connect?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsWritebackLogEntryCreateOrConnectWithoutCareAccountCreditLogInput>;
  create?: Maybe<PimsWritebackLogEntryCreateWithoutCareAccountCreditLogInput>;
  update?: Maybe<PimsWritebackLogEntryUpdateToOneWithWhereWithoutCareAccountCreditLogInput>;
  upsert?: Maybe<PimsWritebackLogEntryUpsertWithoutCareAccountCreditLogInput>;
};

export type PimsWritebackLogEntryUpdateOneRequiredWithoutCustomFieldsLogNestedInput = {
  connect?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsWritebackLogEntryCreateOrConnectWithoutCustomFieldsLogInput>;
  create?: Maybe<PimsWritebackLogEntryCreateWithoutCustomFieldsLogInput>;
  update?: Maybe<PimsWritebackLogEntryUpdateToOneWithWhereWithoutCustomFieldsLogInput>;
  upsert?: Maybe<PimsWritebackLogEntryUpsertWithoutCustomFieldsLogInput>;
};

export type PimsWritebackLogEntryUpdateOneRequiredWithoutInvoiceLogNestedInput = {
  connect?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsWritebackLogEntryCreateOrConnectWithoutInvoiceLogInput>;
  create?: Maybe<PimsWritebackLogEntryCreateWithoutInvoiceLogInput>;
  update?: Maybe<PimsWritebackLogEntryUpdateToOneWithWhereWithoutInvoiceLogInput>;
  upsert?: Maybe<PimsWritebackLogEntryUpsertWithoutInvoiceLogInput>;
};

export type PimsWritebackLogEntryUpdateOneRequiredWithoutPaymentLogNestedInput = {
  connect?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  connectOrCreate?: Maybe<PimsWritebackLogEntryCreateOrConnectWithoutPaymentLogInput>;
  create?: Maybe<PimsWritebackLogEntryCreateWithoutPaymentLogInput>;
  update?: Maybe<PimsWritebackLogEntryUpdateToOneWithWhereWithoutPaymentLogInput>;
  upsert?: Maybe<PimsWritebackLogEntryUpsertWithoutPaymentLogInput>;
};

export type PimsWritebackLogEntryUpdateToOneWithWhereWithoutAiRecapPimsWritebackLogEntryInput = {
  data: PimsWritebackLogEntryUpdateWithoutAiRecapPimsWritebackLogEntryInput;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};

export type PimsWritebackLogEntryUpdateToOneWithWhereWithoutCareAccountCreditLogInput = {
  data: PimsWritebackLogEntryUpdateWithoutCareAccountCreditLogInput;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};

export type PimsWritebackLogEntryUpdateToOneWithWhereWithoutCustomFieldsLogInput = {
  data: PimsWritebackLogEntryUpdateWithoutCustomFieldsLogInput;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};

export type PimsWritebackLogEntryUpdateToOneWithWhereWithoutInvoiceLogInput = {
  data: PimsWritebackLogEntryUpdateWithoutInvoiceLogInput;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};

export type PimsWritebackLogEntryUpdateToOneWithWhereWithoutPaymentLogInput = {
  data: PimsWritebackLogEntryUpdateWithoutPaymentLogInput;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};

export type PimsWritebackLogEntryUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: PimsWritebackLogEntryUpdateWithoutIntegrationInput;
  where: PimsWritebackLogEntryWhereUniqueInput;
};

export type PimsWritebackLogEntryUpdateWithWhereUniqueWithoutTriggeredByInput = {
  data: PimsWritebackLogEntryUpdateWithoutTriggeredByInput;
  where: PimsWritebackLogEntryWhereUniqueInput;
};

export type PimsWritebackLogEntryUpdateWithoutAiRecapPimsWritebackLogEntryInput = {
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutWritebackLogEntriesNestedInput>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredBy?: Maybe<UserUpdateOneWithoutTriggeredWritebacksNestedInput>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUpdateWithoutCareAccountCreditLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutWritebackLogEntriesNestedInput>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredBy?: Maybe<UserUpdateOneWithoutTriggeredWritebacksNestedInput>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUpdateWithoutCustomFieldsLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutWritebackLogEntriesNestedInput>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredBy?: Maybe<UserUpdateOneWithoutTriggeredWritebacksNestedInput>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUpdateWithoutIntegrationInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredBy?: Maybe<UserUpdateOneWithoutTriggeredWritebacksNestedInput>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUpdateWithoutInvoiceLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutWritebackLogEntriesNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredBy?: Maybe<UserUpdateOneWithoutTriggeredWritebacksNestedInput>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUpdateWithoutPaymentLogInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutWritebackLogEntriesNestedInput>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  triggeredBy?: Maybe<UserUpdateOneWithoutTriggeredWritebacksNestedInput>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUpdateWithoutTriggeredByInput = {
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  httpCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutWritebackLogEntriesNestedInput>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  normalizedError?: Maybe<NormalizedWritebackError>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryUpdateOneWithoutWritebackLogNestedInput>;
  pimsError?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  requestBody?: Maybe<Scalars['Json']>;
  requestId?: Maybe<Scalars['String']>;
  status?: Maybe<PimsWritebackStatus>;
  type?: Maybe<PimsWritebackType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PimsWritebackLogEntryUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: PimsWritebackLogEntryCreateWithoutIntegrationInput;
  update: PimsWritebackLogEntryUpdateWithoutIntegrationInput;
  where: PimsWritebackLogEntryWhereUniqueInput;
};

export type PimsWritebackLogEntryUpsertWithWhereUniqueWithoutTriggeredByInput = {
  create: PimsWritebackLogEntryCreateWithoutTriggeredByInput;
  update: PimsWritebackLogEntryUpdateWithoutTriggeredByInput;
  where: PimsWritebackLogEntryWhereUniqueInput;
};

export type PimsWritebackLogEntryUpsertWithoutAiRecapPimsWritebackLogEntryInput = {
  create: PimsWritebackLogEntryCreateWithoutAiRecapPimsWritebackLogEntryInput;
  update: PimsWritebackLogEntryUpdateWithoutAiRecapPimsWritebackLogEntryInput;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};

export type PimsWritebackLogEntryUpsertWithoutCareAccountCreditLogInput = {
  create: PimsWritebackLogEntryCreateWithoutCareAccountCreditLogInput;
  update: PimsWritebackLogEntryUpdateWithoutCareAccountCreditLogInput;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};

export type PimsWritebackLogEntryUpsertWithoutCustomFieldsLogInput = {
  create: PimsWritebackLogEntryCreateWithoutCustomFieldsLogInput;
  update: PimsWritebackLogEntryUpdateWithoutCustomFieldsLogInput;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};

export type PimsWritebackLogEntryUpsertWithoutInvoiceLogInput = {
  create: PimsWritebackLogEntryCreateWithoutInvoiceLogInput;
  update: PimsWritebackLogEntryUpdateWithoutInvoiceLogInput;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};

export type PimsWritebackLogEntryUpsertWithoutPaymentLogInput = {
  create: PimsWritebackLogEntryCreateWithoutPaymentLogInput;
  update: PimsWritebackLogEntryUpdateWithoutPaymentLogInput;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};

export type PimsWritebackLogEntryWhereInput = {
  AND?: Maybe<Array<PimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<PimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<PimsWritebackLogEntryWhereInput>>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryNullableScalarRelationFilter>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryNullableScalarRelationFilter>;
  httpCode?: Maybe<IntNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryNullableScalarRelationFilter>;
  normalizedError?: Maybe<EnumNormalizedWritebackErrorNullableFilter>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryNullableScalarRelationFilter>;
  pimsError?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  requestBody?: Maybe<JsonNullableFilter>;
  requestId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumPimsWritebackStatusFilter>;
  triggeredBy?: Maybe<UserNullableScalarRelationFilter>;
  triggeredByUserId?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumPimsWritebackTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PimsWritebackLogEntryWhereUniqueInput = {
  AND?: Maybe<Array<PimsWritebackLogEntryWhereInput>>;
  NOT?: Maybe<Array<PimsWritebackLogEntryWhereInput>>;
  OR?: Maybe<Array<PimsWritebackLogEntryWhereInput>>;
  aiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntryNullableScalarRelationFilter>;
  careAccountCreditLog?: Maybe<CareAccountCreditPimsWritebackLogEntryNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  customFieldsLog?: Maybe<CustomFieldPimsWritebackLogEntryNullableScalarRelationFilter>;
  httpCode?: Maybe<IntNullableFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoiceLog?: Maybe<InvoicePimsWritebackLogEntryNullableScalarRelationFilter>;
  normalizedError?: Maybe<EnumNormalizedWritebackErrorNullableFilter>;
  paymentLog?: Maybe<PaymentPimsWritebackLogEntryNullableScalarRelationFilter>;
  pimsError?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  requestBody?: Maybe<JsonNullableFilter>;
  requestId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumPimsWritebackStatusFilter>;
  triggeredBy?: Maybe<UserNullableScalarRelationFilter>;
  triggeredByUserId?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumPimsWritebackTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum PimsWritebackStatus {
  Failure = 'Failure',
  Pending = 'Pending',
  PendingRetryAutomatic = 'Pending_RetryAutomatic',
  PendingRetryManual = 'Pending_RetryManual',
  Success = 'Success'
}

export enum PimsWritebackType {
  CustomField = 'CustomField',
  Payment = 'Payment'
}


export type Prescription = {
  __typename?: 'Prescription';
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  instructions?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctor?: Maybe<ClinicEmployee>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<Service>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};


export type PrescriptionPrescribingDoctorArgs = {
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type PrescriptionServiceArgs = {
  where?: Maybe<ServiceWhereInput>;
};

export type PrescriptionAvgAggregateOutputType = {
  __typename?: 'PrescriptionAvgAggregateOutputType';
  currentRefillNumber?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalRefills?: Maybe<Scalars['Float']>;
};

export type PrescriptionAvgOrderByAggregateInput = {
  currentRefillNumber?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  totalRefills?: Maybe<SortOrder>;
};

export type PrescriptionCountAggregateOutputType = {
  __typename?: 'PrescriptionCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  comments: Scalars['Int'];
  createdAt: Scalars['Int'];
  currentRefillNumber: Scalars['Int'];
  description: Scalars['Int'];
  expiredAt: Scalars['Int'];
  id: Scalars['Int'];
  instructions: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  issuedAt: Scalars['Int'];
  lastRequestedAt: Scalars['Int'];
  pimsId: Scalars['Int'];
  prescribingDoctorId: Scalars['Int'];
  quantity: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  serviceId: Scalars['Int'];
  totalRefills: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PrescriptionCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentRefillNumber?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instructions?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  issuedAt?: Maybe<SortOrder>;
  lastRequestedAt?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescribingDoctorId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  totalRefills?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PrescriptionCreateInput = {
  clinic: ClinicCreateNestedOneWithoutPrescriptionsInput;
  clinicPet: ClinicPetCreateNestedOneWithoutPrescriptionsInput;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPrescriptionsInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctor?: Maybe<ClinicEmployeeCreateNestedOneWithoutPrescriptionsInput>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceCreateNestedOneWithoutPrescriptionsInput>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionCreateManyClinicInput = {
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionCreateManyClinicInputEnvelope = {
  data: Array<PrescriptionCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PrescriptionCreateManyClinicPetInput = {
  clinicId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionCreateManyClinicPetInputEnvelope = {
  data: Array<PrescriptionCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PrescriptionCreateManyInput = {
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionCreateManyIntegrationInput = {
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionCreateManyIntegrationInputEnvelope = {
  data: Array<PrescriptionCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PrescriptionCreateManyPrescribingDoctorInput = {
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionCreateManyPrescribingDoctorInputEnvelope = {
  data: Array<PrescriptionCreateManyPrescribingDoctorInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PrescriptionCreateManyServiceInput = {
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionCreateManyServiceInputEnvelope = {
  data: Array<PrescriptionCreateManyServiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PrescriptionCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutClinicInput>>;
  createMany?: Maybe<PrescriptionCreateManyClinicInputEnvelope>;
};

export type PrescriptionCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutClinicPetInput>>;
  createMany?: Maybe<PrescriptionCreateManyClinicPetInputEnvelope>;
};

export type PrescriptionCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PrescriptionCreateManyIntegrationInputEnvelope>;
};

export type PrescriptionCreateNestedManyWithoutPrescribingDoctorInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutPrescribingDoctorInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutPrescribingDoctorInput>>;
  createMany?: Maybe<PrescriptionCreateManyPrescribingDoctorInputEnvelope>;
};

export type PrescriptionCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutServiceInput>>;
  createMany?: Maybe<PrescriptionCreateManyServiceInputEnvelope>;
};

export type PrescriptionCreateOrConnectWithoutClinicInput = {
  create: PrescriptionCreateWithoutClinicInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionCreateOrConnectWithoutClinicPetInput = {
  create: PrescriptionCreateWithoutClinicPetInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionCreateOrConnectWithoutIntegrationInput = {
  create: PrescriptionCreateWithoutIntegrationInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionCreateOrConnectWithoutPrescribingDoctorInput = {
  create: PrescriptionCreateWithoutPrescribingDoctorInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionCreateOrConnectWithoutServiceInput = {
  create: PrescriptionCreateWithoutServiceInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionCreateWithoutClinicInput = {
  clinicPet: ClinicPetCreateNestedOneWithoutPrescriptionsInput;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPrescriptionsInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctor?: Maybe<ClinicEmployeeCreateNestedOneWithoutPrescriptionsInput>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceCreateNestedOneWithoutPrescriptionsInput>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionCreateWithoutClinicPetInput = {
  clinic: ClinicCreateNestedOneWithoutPrescriptionsInput;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPrescriptionsInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctor?: Maybe<ClinicEmployeeCreateNestedOneWithoutPrescriptionsInput>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceCreateNestedOneWithoutPrescriptionsInput>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionCreateWithoutIntegrationInput = {
  clinic: ClinicCreateNestedOneWithoutPrescriptionsInput;
  clinicPet: ClinicPetCreateNestedOneWithoutPrescriptionsInput;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctor?: Maybe<ClinicEmployeeCreateNestedOneWithoutPrescriptionsInput>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceCreateNestedOneWithoutPrescriptionsInput>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionCreateWithoutPrescribingDoctorInput = {
  clinic: ClinicCreateNestedOneWithoutPrescriptionsInput;
  clinicPet: ClinicPetCreateNestedOneWithoutPrescriptionsInput;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPrescriptionsInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceCreateNestedOneWithoutPrescriptionsInput>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionCreateWithoutServiceInput = {
  clinic: ClinicCreateNestedOneWithoutPrescriptionsInput;
  clinicPet: ClinicPetCreateNestedOneWithoutPrescriptionsInput;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutPrescriptionsInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctor?: Maybe<ClinicEmployeeCreateNestedOneWithoutPrescriptionsInput>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionGroupByOutputType = {
  __typename?: 'PrescriptionGroupByOutputType';
  _avg?: Maybe<PrescriptionAvgAggregateOutputType>;
  _count?: Maybe<PrescriptionCountAggregateOutputType>;
  _max?: Maybe<PrescriptionMaxAggregateOutputType>;
  _min?: Maybe<PrescriptionMinAggregateOutputType>;
  _sum?: Maybe<PrescriptionSumAggregateOutputType>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  instructions?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type PrescriptionListRelationFilter = {
  every?: Maybe<PrescriptionWhereInput>;
  none?: Maybe<PrescriptionWhereInput>;
  some?: Maybe<PrescriptionWhereInput>;
};

export type PrescriptionMaxAggregateOutputType = {
  __typename?: 'PrescriptionMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentRefillNumber?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instructions?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  issuedAt?: Maybe<SortOrder>;
  lastRequestedAt?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescribingDoctorId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  totalRefills?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PrescriptionMinAggregateOutputType = {
  __typename?: 'PrescriptionMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentRefillNumber?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instructions?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  issuedAt?: Maybe<SortOrder>;
  lastRequestedAt?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescribingDoctorId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  totalRefills?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PrescriptionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PrescriptionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PrescriptionOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentRefillNumber?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instructions?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  issuedAt?: Maybe<SortOrder>;
  lastRequestedAt?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescribingDoctor?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  prescribingDoctorId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  totalRefills?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PrescriptionOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  ClinicPetId = 'clinicPetId',
  Comments = 'comments',
  Description = 'description',
  Id = 'id',
  Instructions = 'instructions',
  IntegrationId = 'integrationId',
  PimsId = 'pimsId',
  PrescribingDoctorId = 'prescribingDoctorId',
  ServiceId = 'serviceId'
}

export type PrescriptionOrderByRelevanceInput = {
  fields: Array<PrescriptionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PrescriptionOrderByWithAggregationInput = {
  _avg?: Maybe<PrescriptionAvgOrderByAggregateInput>;
  _count?: Maybe<PrescriptionCountOrderByAggregateInput>;
  _max?: Maybe<PrescriptionMaxOrderByAggregateInput>;
  _min?: Maybe<PrescriptionMinOrderByAggregateInput>;
  _sum?: Maybe<PrescriptionSumOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentRefillNumber?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instructions?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  issuedAt?: Maybe<SortOrder>;
  lastRequestedAt?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescribingDoctorId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  totalRefills?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PrescriptionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PrescriptionOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentRefillNumber?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instructions?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  issuedAt?: Maybe<SortOrder>;
  lastRequestedAt?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescribingDoctor?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  prescribingDoctorId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  totalRefills?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PrescriptionOrderByWithRelationInput = {
  _relevance?: Maybe<PrescriptionOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currentRefillNumber?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  instructions?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  issuedAt?: Maybe<SortOrder>;
  lastRequestedAt?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  prescribingDoctor?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  prescribingDoctorId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  totalRefills?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PrescriptionPimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export enum PrescriptionScalarFieldEnum {
  ClinicId = 'clinicId',
  ClinicPetId = 'clinicPetId',
  Comments = 'comments',
  CreatedAt = 'createdAt',
  CurrentRefillNumber = 'currentRefillNumber',
  Description = 'description',
  ExpiredAt = 'expiredAt',
  Id = 'id',
  Instructions = 'instructions',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  IssuedAt = 'issuedAt',
  LastRequestedAt = 'lastRequestedAt',
  PimsId = 'pimsId',
  PrescribingDoctorId = 'prescribingDoctorId',
  Quantity = 'quantity',
  RawPimsValue = 'rawPimsValue',
  ServiceId = 'serviceId',
  TotalRefills = 'totalRefills',
  UpdatedAt = 'updatedAt'
}

export type PrescriptionScalarWhereInput = {
  AND?: Maybe<Array<PrescriptionScalarWhereInput>>;
  NOT?: Maybe<Array<PrescriptionScalarWhereInput>>;
  OR?: Maybe<Array<PrescriptionScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  clinicPetId?: Maybe<StringFilter>;
  comments?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentRefillNumber?: Maybe<IntNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  expiredAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  instructions?: Maybe<StringNullableFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  issuedAt?: Maybe<DateTimeNullableFilter>;
  lastRequestedAt?: Maybe<DateTimeNullableFilter>;
  pimsId?: Maybe<StringFilter>;
  prescribingDoctorId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<FloatNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  serviceId?: Maybe<StringNullableFilter>;
  totalRefills?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PrescriptionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PrescriptionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PrescriptionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PrescriptionScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  clinicPetId?: Maybe<StringWithAggregatesFilter>;
  comments?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  currentRefillNumber?: Maybe<IntNullableWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  expiredAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  instructions?: Maybe<StringNullableWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  issuedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  lastRequestedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringWithAggregatesFilter>;
  prescribingDoctorId?: Maybe<StringNullableWithAggregatesFilter>;
  quantity?: Maybe<FloatNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  serviceId?: Maybe<StringNullableWithAggregatesFilter>;
  totalRefills?: Maybe<IntNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type PrescriptionSumAggregateOutputType = {
  __typename?: 'PrescriptionSumAggregateOutputType';
  currentRefillNumber?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Float']>;
  totalRefills?: Maybe<Scalars['Int']>;
};

export type PrescriptionSumOrderByAggregateInput = {
  currentRefillNumber?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  totalRefills?: Maybe<SortOrder>;
};

export type PrescriptionUncheckedCreateInput = {
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutClinicInput>>;
  createMany?: Maybe<PrescriptionCreateManyClinicInputEnvelope>;
};

export type PrescriptionUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutClinicPetInput>>;
  createMany?: Maybe<PrescriptionCreateManyClinicPetInputEnvelope>;
};

export type PrescriptionUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PrescriptionCreateManyIntegrationInputEnvelope>;
};

export type PrescriptionUncheckedCreateNestedManyWithoutPrescribingDoctorInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutPrescribingDoctorInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutPrescribingDoctorInput>>;
  createMany?: Maybe<PrescriptionCreateManyPrescribingDoctorInputEnvelope>;
};

export type PrescriptionUncheckedCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutServiceInput>>;
  createMany?: Maybe<PrescriptionCreateManyServiceInputEnvelope>;
};

export type PrescriptionUncheckedCreateWithoutClinicInput = {
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedCreateWithoutClinicPetInput = {
  clinicId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedCreateWithoutIntegrationInput = {
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedCreateWithoutPrescribingDoctorInput = {
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedCreateWithoutServiceInput = {
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId: Scalars['String'];
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedUpdateManyWithoutClinicInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutClinicInput>>;
  createMany?: Maybe<PrescriptionCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PrescriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  set?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  update?: Maybe<Array<PrescriptionUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<PrescriptionUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<PrescriptionUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type PrescriptionUncheckedUpdateManyWithoutClinicPetInput = {
  clinicId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutClinicPetInput>>;
  createMany?: Maybe<PrescriptionCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PrescriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  set?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  update?: Maybe<Array<PrescriptionUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<PrescriptionUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<PrescriptionUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type PrescriptionUncheckedUpdateManyWithoutIntegrationInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PrescriptionCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PrescriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  set?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  update?: Maybe<Array<PrescriptionUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<PrescriptionUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<PrescriptionUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedUpdateManyWithoutPrescribingDoctorNestedInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutPrescribingDoctorInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutPrescribingDoctorInput>>;
  createMany?: Maybe<PrescriptionCreateManyPrescribingDoctorInputEnvelope>;
  delete?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PrescriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  set?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  update?: Maybe<Array<PrescriptionUpdateWithWhereUniqueWithoutPrescribingDoctorInput>>;
  updateMany?: Maybe<Array<PrescriptionUpdateManyWithWhereWithoutPrescribingDoctorInput>>;
  upsert?: Maybe<Array<PrescriptionUpsertWithWhereUniqueWithoutPrescribingDoctorInput>>;
};

export type PrescriptionUncheckedUpdateManyWithoutServiceInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutServiceInput>>;
  createMany?: Maybe<PrescriptionCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PrescriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  set?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  update?: Maybe<Array<PrescriptionUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<PrescriptionUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<PrescriptionUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type PrescriptionUncheckedUpdateWithoutClinicInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedUpdateWithoutClinicPetInput = {
  clinicId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedUpdateWithoutIntegrationInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedUpdateWithoutPrescribingDoctorInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serviceId?: Maybe<Scalars['String']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUncheckedUpdateWithoutServiceInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctorId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctor?: Maybe<ClinicEmployeeUpdateOneWithoutPrescriptionsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceUpdateOneWithoutPrescriptionsNestedInput>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUpdateManyMutationInput = {
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUpdateManyWithWhereWithoutClinicInput = {
  data: PrescriptionUpdateManyMutationInput;
  where: PrescriptionScalarWhereInput;
};

export type PrescriptionUpdateManyWithWhereWithoutClinicPetInput = {
  data: PrescriptionUpdateManyMutationInput;
  where: PrescriptionScalarWhereInput;
};

export type PrescriptionUpdateManyWithWhereWithoutIntegrationInput = {
  data: PrescriptionUpdateManyMutationInput;
  where: PrescriptionScalarWhereInput;
};

export type PrescriptionUpdateManyWithWhereWithoutPrescribingDoctorInput = {
  data: PrescriptionUpdateManyMutationInput;
  where: PrescriptionScalarWhereInput;
};

export type PrescriptionUpdateManyWithWhereWithoutServiceInput = {
  data: PrescriptionUpdateManyMutationInput;
  where: PrescriptionScalarWhereInput;
};

export type PrescriptionUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutClinicInput>>;
  createMany?: Maybe<PrescriptionCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PrescriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  set?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  update?: Maybe<Array<PrescriptionUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<PrescriptionUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<PrescriptionUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type PrescriptionUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutClinicPetInput>>;
  createMany?: Maybe<PrescriptionCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PrescriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  set?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  update?: Maybe<Array<PrescriptionUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<PrescriptionUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<PrescriptionUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type PrescriptionUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutIntegrationInput>>;
  createMany?: Maybe<PrescriptionCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PrescriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  set?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  update?: Maybe<Array<PrescriptionUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<PrescriptionUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<PrescriptionUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type PrescriptionUpdateManyWithoutPrescribingDoctorNestedInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutPrescribingDoctorInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutPrescribingDoctorInput>>;
  createMany?: Maybe<PrescriptionCreateManyPrescribingDoctorInputEnvelope>;
  delete?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PrescriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  set?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  update?: Maybe<Array<PrescriptionUpdateWithWhereUniqueWithoutPrescribingDoctorInput>>;
  updateMany?: Maybe<Array<PrescriptionUpdateManyWithWhereWithoutPrescribingDoctorInput>>;
  upsert?: Maybe<Array<PrescriptionUpsertWithWhereUniqueWithoutPrescribingDoctorInput>>;
};

export type PrescriptionUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PrescriptionCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<PrescriptionCreateWithoutServiceInput>>;
  createMany?: Maybe<PrescriptionCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PrescriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  set?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  update?: Maybe<Array<PrescriptionUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<PrescriptionUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<PrescriptionUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type PrescriptionUpdateWithWhereUniqueWithoutClinicInput = {
  data: PrescriptionUpdateWithoutClinicInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: PrescriptionUpdateWithoutClinicPetInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: PrescriptionUpdateWithoutIntegrationInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionUpdateWithWhereUniqueWithoutPrescribingDoctorInput = {
  data: PrescriptionUpdateWithoutPrescribingDoctorInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionUpdateWithWhereUniqueWithoutServiceInput = {
  data: PrescriptionUpdateWithoutServiceInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionUpdateWithoutClinicInput = {
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctor?: Maybe<ClinicEmployeeUpdateOneWithoutPrescriptionsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceUpdateOneWithoutPrescriptionsNestedInput>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUpdateWithoutClinicPetInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctor?: Maybe<ClinicEmployeeUpdateOneWithoutPrescriptionsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceUpdateOneWithoutPrescriptionsNestedInput>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUpdateWithoutIntegrationInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctor?: Maybe<ClinicEmployeeUpdateOneWithoutPrescriptionsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceUpdateOneWithoutPrescriptionsNestedInput>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUpdateWithoutPrescribingDoctorInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  service?: Maybe<ServiceUpdateOneWithoutPrescriptionsNestedInput>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUpdateWithoutServiceInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentRefillNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutPrescriptionsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']>;
  pimsId?: Maybe<Scalars['String']>;
  prescribingDoctor?: Maybe<ClinicEmployeeUpdateOneWithoutPrescriptionsNestedInput>;
  quantity?: Maybe<Scalars['Float']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  totalRefills?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionUpsertWithWhereUniqueWithoutClinicInput = {
  create: PrescriptionCreateWithoutClinicInput;
  update: PrescriptionUpdateWithoutClinicInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: PrescriptionCreateWithoutClinicPetInput;
  update: PrescriptionUpdateWithoutClinicPetInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: PrescriptionCreateWithoutIntegrationInput;
  update: PrescriptionUpdateWithoutIntegrationInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionUpsertWithWhereUniqueWithoutPrescribingDoctorInput = {
  create: PrescriptionCreateWithoutPrescribingDoctorInput;
  update: PrescriptionUpdateWithoutPrescribingDoctorInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionUpsertWithWhereUniqueWithoutServiceInput = {
  create: PrescriptionCreateWithoutServiceInput;
  update: PrescriptionUpdateWithoutServiceInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionWhereInput = {
  AND?: Maybe<Array<PrescriptionWhereInput>>;
  NOT?: Maybe<Array<PrescriptionWhereInput>>;
  OR?: Maybe<Array<PrescriptionWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  comments?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentRefillNumber?: Maybe<IntNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  expiredAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  instructions?: Maybe<StringNullableFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  issuedAt?: Maybe<DateTimeNullableFilter>;
  lastRequestedAt?: Maybe<DateTimeNullableFilter>;
  pimsId?: Maybe<StringFilter>;
  prescribingDoctor?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  prescribingDoctorId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<FloatNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  service?: Maybe<ServiceNullableScalarRelationFilter>;
  serviceId?: Maybe<StringNullableFilter>;
  totalRefills?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PrescriptionWhereUniqueInput = {
  AND?: Maybe<Array<PrescriptionWhereInput>>;
  NOT?: Maybe<Array<PrescriptionWhereInput>>;
  OR?: Maybe<Array<PrescriptionWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  comments?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentRefillNumber?: Maybe<IntNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  expiredAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  instructions?: Maybe<StringNullableFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  issuedAt?: Maybe<DateTimeNullableFilter>;
  lastRequestedAt?: Maybe<DateTimeNullableFilter>;
  pimsId?: Maybe<StringFilter>;
  pimsIdAndIntegrationId?: Maybe<PrescriptionPimsIdAndIntegrationIdCompoundUniqueInput>;
  prescribingDoctor?: Maybe<ClinicEmployeeNullableScalarRelationFilter>;
  prescribingDoctorId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<FloatNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  service?: Maybe<ServiceNullableScalarRelationFilter>;
  serviceId?: Maybe<StringNullableFilter>;
  totalRefills?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum PricingModel {
  BlendedRate = 'BlendedRate',
  InterchangePlus = 'InterchangePlus'
}

export type PrivacyResponse = {
  __typename?: 'PrivacyResponse';
  confirmation: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ProcessAppointmentRecapChunksInput = {
  recapId: Scalars['String'];
};

export type ProcessAppointmentRecapChunksOutput = {
  __typename?: 'ProcessAppointmentRecapChunksOutput';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ProcessAppointmentRecapInput = {
  appointmentId: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Int']>;
  recapAudioUrl: Scalars['String'];
  templateId?: Maybe<Scalars['String']>;
};

export type ProcessAppointmentRecapOutput = {
  __typename?: 'ProcessAppointmentRecapOutput';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ProcessTerminalPaymentResponse = {
  __typename?: 'ProcessTerminalPaymentResponse';
  error?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  terminal: StripeTerminal;
};

export type Product = {
  __typename?: 'Product';
  _count: ProductCountOutputType;
  activeIngredients: Array<ActiveIngredient>;
  brand: Scalars['String'];
  canonicalService: CanonicalService;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  indications: Array<ProductIndication>;
  informPartner?: Maybe<InformPartner>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media: Array<Media>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parent?: Maybe<Product>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  variants: Array<Product>;
};


export type ProductActiveIngredientsArgs = {
  cursor?: Maybe<ActiveIngredientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ActiveIngredientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ActiveIngredientOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ActiveIngredientWhereInput>;
};


export type ProductInformPartnerArgs = {
  where?: Maybe<InformPartnerWhereInput>;
};


export type ProductMediaArgs = {
  cursor?: Maybe<MediaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MediaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MediaOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MediaWhereInput>;
};


export type ProductParentArgs = {
  where?: Maybe<ProductWhereInput>;
};


export type ProductVariantsArgs = {
  cursor?: Maybe<ProductWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductWhereInput>;
};

export type ProductAvgAggregateOutputType = {
  __typename?: 'ProductAvgAggregateOutputType';
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  supplyDuration?: Maybe<Scalars['Float']>;
};

export type ProductAvgOrderByAggregateInput = {
  maxWeightInKg?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  supplyDuration?: Maybe<SortOrder>;
};

export type ProductCountAggregateOutputType = {
  __typename?: 'ProductCountAggregateOutputType';
  _all: Scalars['Int'];
  brand: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  details: Scalars['Int'];
  id: Scalars['Int'];
  indications: Scalars['Int'];
  informPartnerId: Scalars['Int'];
  manufacturer: Scalars['Int'];
  maxWeightInKg: Scalars['Int'];
  minWeightInKg: Scalars['Int'];
  name: Scalars['Int'];
  parentProductId: Scalars['Int'];
  quantity: Scalars['Int'];
  supplyDuration: Scalars['Int'];
  supplyDurationUnit: Scalars['Int'];
  type: Scalars['Int'];
  universalProductCode: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ProductCountOrderByAggregateInput = {
  brand?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  indications?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentProductId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  supplyDuration?: Maybe<SortOrder>;
  supplyDurationUnit?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  universalProductCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductCountOutputType = {
  __typename?: 'ProductCountOutputType';
  activeIngredients: Scalars['Int'];
  media: Scalars['Int'];
  variants: Scalars['Int'];
};

export type ProductCreateInput = {
  activeIngredients?: Maybe<ActiveIngredientCreateNestedManyWithoutProductInput>;
  brand: Scalars['String'];
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutProductInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutProductsInput>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaCreateNestedManyWithoutProductsInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parent?: Maybe<ProductCreateNestedOneWithoutVariantsInput>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductCreateNestedManyWithoutParentInput>;
};

export type ProductCreateManyInformPartnerInput = {
  brand: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductCreateManyInformPartnerInputEnvelope = {
  data: Array<ProductCreateManyInformPartnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ProductCreateManyInput = {
  brand: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductCreateManyParentInput = {
  brand: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductCreateManyParentInputEnvelope = {
  data: Array<ProductCreateManyParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ProductCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<ProductCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<ProductCreateManyInformPartnerInputEnvelope>;
};

export type ProductCreateNestedManyWithoutMediaInput = {
  connect?: Maybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<ProductCreateWithoutMediaInput>>;
};

export type ProductCreateNestedManyWithoutParentInput = {
  connect?: Maybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductCreateOrConnectWithoutParentInput>>;
  create?: Maybe<Array<ProductCreateWithoutParentInput>>;
  createMany?: Maybe<ProductCreateManyParentInputEnvelope>;
};

export type ProductCreateNestedOneWithoutActiveIngredientsInput = {
  connect?: Maybe<ProductWhereUniqueInput>;
  connectOrCreate?: Maybe<ProductCreateOrConnectWithoutActiveIngredientsInput>;
  create?: Maybe<ProductCreateWithoutActiveIngredientsInput>;
};

export type ProductCreateNestedOneWithoutCanonicalServiceInput = {
  connect?: Maybe<ProductWhereUniqueInput>;
  connectOrCreate?: Maybe<ProductCreateOrConnectWithoutCanonicalServiceInput>;
  create?: Maybe<ProductCreateWithoutCanonicalServiceInput>;
};

export type ProductCreateNestedOneWithoutVariantsInput = {
  connect?: Maybe<ProductWhereUniqueInput>;
  connectOrCreate?: Maybe<ProductCreateOrConnectWithoutVariantsInput>;
  create?: Maybe<ProductCreateWithoutVariantsInput>;
};

export type ProductCreateOrConnectWithoutActiveIngredientsInput = {
  create: ProductCreateWithoutActiveIngredientsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutCanonicalServiceInput = {
  create: ProductCreateWithoutCanonicalServiceInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutInformPartnerInput = {
  create: ProductCreateWithoutInformPartnerInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutMediaInput = {
  create: ProductCreateWithoutMediaInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutParentInput = {
  create: ProductCreateWithoutParentInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutVariantsInput = {
  create: ProductCreateWithoutVariantsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateWithoutActiveIngredientsInput = {
  brand: Scalars['String'];
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutProductInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutProductsInput>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaCreateNestedManyWithoutProductsInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parent?: Maybe<ProductCreateNestedOneWithoutVariantsInput>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductCreateNestedManyWithoutParentInput>;
};

export type ProductCreateWithoutCanonicalServiceInput = {
  activeIngredients?: Maybe<ActiveIngredientCreateNestedManyWithoutProductInput>;
  brand: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutProductsInput>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaCreateNestedManyWithoutProductsInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parent?: Maybe<ProductCreateNestedOneWithoutVariantsInput>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductCreateNestedManyWithoutParentInput>;
};

export type ProductCreateWithoutInformPartnerInput = {
  activeIngredients?: Maybe<ActiveIngredientCreateNestedManyWithoutProductInput>;
  brand: Scalars['String'];
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutProductInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaCreateNestedManyWithoutProductsInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parent?: Maybe<ProductCreateNestedOneWithoutVariantsInput>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductCreateNestedManyWithoutParentInput>;
};

export type ProductCreateWithoutMediaInput = {
  activeIngredients?: Maybe<ActiveIngredientCreateNestedManyWithoutProductInput>;
  brand: Scalars['String'];
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutProductInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutProductsInput>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parent?: Maybe<ProductCreateNestedOneWithoutVariantsInput>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductCreateNestedManyWithoutParentInput>;
};

export type ProductCreateWithoutParentInput = {
  activeIngredients?: Maybe<ActiveIngredientCreateNestedManyWithoutProductInput>;
  brand: Scalars['String'];
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutProductInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutProductsInput>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaCreateNestedManyWithoutProductsInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductCreateNestedManyWithoutParentInput>;
};

export type ProductCreateWithoutVariantsInput = {
  activeIngredients?: Maybe<ActiveIngredientCreateNestedManyWithoutProductInput>;
  brand: Scalars['String'];
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutProductInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartnerCreateNestedOneWithoutProductsInput>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaCreateNestedManyWithoutProductsInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parent?: Maybe<ProductCreateNestedOneWithoutVariantsInput>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductCreateindicationsInput = {
  set: Array<ProductIndication>;
};

export type ProductGroupByOutputType = {
  __typename?: 'ProductGroupByOutputType';
  _avg?: Maybe<ProductAvgAggregateOutputType>;
  _count?: Maybe<ProductCountAggregateOutputType>;
  _max?: Maybe<ProductMaxAggregateOutputType>;
  _min?: Maybe<ProductMinAggregateOutputType>;
  _sum?: Maybe<ProductSumAggregateOutputType>;
  brand: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export enum ProductIndication {
  Combo = 'COMBO',
  CongestiveHeartFailure = 'CongestiveHeartFailure',
  Dental = 'Dental',
  DigestiveCare = 'DigestiveCare',
  Fleatick = 'FLEATICK',
  Flea = 'Flea',
  HeartDisease = 'HEART_DISEASE',
  Heartworm = 'Heartworm',
  JointSuppThera = 'JOINT_SUPP_THERA',
  Kidney = 'Kidney',
  Nsaid = 'NSAID',
  Other = 'OTHER',
  PituitaryParsIntermediaDysfunction = 'PituitaryParsIntermediaDysfunction',
  SkinCare = 'SkinCare',
  Tick = 'Tick',
  Urinary = 'Urinary',
  Vaccine = 'VACCINE',
  WeightManagement = 'WeightManagement'
}

export type ProductListRelationFilter = {
  every?: Maybe<ProductWhereInput>;
  none?: Maybe<ProductWhereInput>;
  some?: Maybe<ProductWhereInput>;
};

export type ProductMaxAggregateOutputType = {
  __typename?: 'ProductMaxAggregateOutputType';
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductMaxOrderByAggregateInput = {
  brand?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentProductId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  supplyDuration?: Maybe<SortOrder>;
  supplyDurationUnit?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  universalProductCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductMinAggregateOutputType = {
  __typename?: 'ProductMinAggregateOutputType';
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductMinOrderByAggregateInput = {
  brand?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentProductId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  supplyDuration?: Maybe<SortOrder>;
  supplyDurationUnit?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  universalProductCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductNullableScalarRelationFilter = {
  AND?: Maybe<Array<ProductWhereInput>>;
  NOT?: Maybe<Array<ProductWhereInput>>;
  OR?: Maybe<Array<ProductWhereInput>>;
  activeIngredients?: Maybe<ActiveIngredientListRelationFilter>;
  brand?: Maybe<StringFilter>;
  canonicalService?: Maybe<CanonicalServiceScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  details?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  indications?: Maybe<EnumProductIndicationNullableListFilter>;
  informPartner?: Maybe<InformPartnerNullableScalarRelationFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  manufacturer?: Maybe<StringFilter>;
  maxWeightInKg?: Maybe<FloatNullableFilter>;
  media?: Maybe<MediaListRelationFilter>;
  minWeightInKg?: Maybe<FloatNullableFilter>;
  name?: Maybe<StringFilter>;
  parent?: Maybe<ProductNullableScalarRelationFilter>;
  parentProductId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<IntNullableFilter>;
  supplyDuration?: Maybe<FloatNullableFilter>;
  supplyDurationUnit?: Maybe<EnumProductSupplyDurationUnitNullableFilter>;
  type?: Maybe<EnumProductTypeFilter>;
  universalProductCode?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  variants?: Maybe<ProductListRelationFilter>;
};

export type ProductOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ProductOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ProductOrderByRelevanceInput>;
  activeIngredients?: Maybe<ActiveIngredientOrderByRelationAggregateInput>;
  brand?: Maybe<SortOrder>;
  canonicalService?: Maybe<CanonicalServiceOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  indications?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  media?: Maybe<MediaOrderByRelationAggregateInput>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parent?: Maybe<ProductOrderByWithRelationInput>;
  parentProductId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  supplyDuration?: Maybe<SortOrder>;
  supplyDurationUnit?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  universalProductCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  variants?: Maybe<ProductOrderByRelationAggregateInput>;
};

export enum ProductOrderByRelevanceFieldEnum {
  Brand = 'brand',
  Description = 'description',
  Id = 'id',
  InformPartnerId = 'informPartnerId',
  Manufacturer = 'manufacturer',
  Name = 'name',
  ParentProductId = 'parentProductId',
  UniversalProductCode = 'universalProductCode'
}

export type ProductOrderByRelevanceInput = {
  fields: Array<ProductOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ProductOrderByWithAggregationInput = {
  _avg?: Maybe<ProductAvgOrderByAggregateInput>;
  _count?: Maybe<ProductCountOrderByAggregateInput>;
  _max?: Maybe<ProductMaxOrderByAggregateInput>;
  _min?: Maybe<ProductMinOrderByAggregateInput>;
  _sum?: Maybe<ProductSumOrderByAggregateInput>;
  brand?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  indications?: Maybe<SortOrder>;
  informPartnerId?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentProductId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  supplyDuration?: Maybe<SortOrder>;
  supplyDurationUnit?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  universalProductCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ProductOrderByRelevanceInput>;
  activeIngredients?: Maybe<ActiveIngredientOrderByRelationAggregateInput>;
  brand?: Maybe<SortOrder>;
  canonicalService?: Maybe<CanonicalServiceOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  indications?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  media?: Maybe<MediaOrderByRelationAggregateInput>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parent?: Maybe<ProductOrderByWithRelationInput>;
  parentProductId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  supplyDuration?: Maybe<SortOrder>;
  supplyDurationUnit?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  universalProductCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  variants?: Maybe<ProductOrderByRelationAggregateInput>;
};

export type ProductOrderByWithRelationInput = {
  _relevance?: Maybe<ProductOrderByRelevanceInput>;
  activeIngredients?: Maybe<ActiveIngredientOrderByRelationAggregateInput>;
  brand?: Maybe<SortOrder>;
  canonicalService?: Maybe<CanonicalServiceOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  details?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  indications?: Maybe<SortOrder>;
  informPartner?: Maybe<InformPartnerOrderByWithRelationInput>;
  informPartnerId?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  maxWeightInKg?: Maybe<SortOrder>;
  media?: Maybe<MediaOrderByRelationAggregateInput>;
  minWeightInKg?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parent?: Maybe<ProductOrderByWithRelationInput>;
  parentProductId?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  supplyDuration?: Maybe<SortOrder>;
  supplyDurationUnit?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  universalProductCode?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  variants?: Maybe<ProductOrderByRelationAggregateInput>;
};

export type ProductPackage = {
  __typename?: 'ProductPackage';
  _count: ProductPackageCountOutputType;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modules: Array<Module>;
  name: Scalars['String'];
  subscriptions: Array<ProductPackageSubscription>;
  updatedAt: Scalars['DateTime'];
};


export type ProductPackageModulesArgs = {
  cursor?: Maybe<ModuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ModuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ModuleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ModuleWhereInput>;
};


export type ProductPackageSubscriptionsArgs = {
  cursor?: Maybe<ProductPackageSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductPackageSubscriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductPackageSubscriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductPackageSubscriptionWhereInput>;
};

export type ProductPackageCountAggregateOutputType = {
  __typename?: 'ProductPackageCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ProductPackageCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductPackageCountOutputType = {
  __typename?: 'ProductPackageCountOutputType';
  modules: Scalars['Int'];
  subscriptions: Scalars['Int'];
};

export type ProductPackageCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modules?: Maybe<ModuleCreateNestedManyWithoutProductPackagesInput>;
  name: Scalars['String'];
  subscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutProductPackageInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageCreateNestedManyWithoutModulesInput = {
  connect?: Maybe<Array<ProductPackageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductPackageCreateOrConnectWithoutModulesInput>>;
  create?: Maybe<Array<ProductPackageCreateWithoutModulesInput>>;
};

export type ProductPackageCreateNestedOneWithoutSubscriptionsInput = {
  connect?: Maybe<ProductPackageWhereUniqueInput>;
  connectOrCreate?: Maybe<ProductPackageCreateOrConnectWithoutSubscriptionsInput>;
  create?: Maybe<ProductPackageCreateWithoutSubscriptionsInput>;
};

export type ProductPackageCreateOrConnectWithoutModulesInput = {
  create: ProductPackageCreateWithoutModulesInput;
  where: ProductPackageWhereUniqueInput;
};

export type ProductPackageCreateOrConnectWithoutSubscriptionsInput = {
  create: ProductPackageCreateWithoutSubscriptionsInput;
  where: ProductPackageWhereUniqueInput;
};

export type ProductPackageCreateWithoutModulesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subscriptions?: Maybe<ProductPackageSubscriptionCreateNestedManyWithoutProductPackageInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageCreateWithoutSubscriptionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modules?: Maybe<ModuleCreateNestedManyWithoutProductPackagesInput>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageGroupByOutputType = {
  __typename?: 'ProductPackageGroupByOutputType';
  _count?: Maybe<ProductPackageCountAggregateOutputType>;
  _max?: Maybe<ProductPackageMaxAggregateOutputType>;
  _min?: Maybe<ProductPackageMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ProductPackageListRelationFilter = {
  every?: Maybe<ProductPackageWhereInput>;
  none?: Maybe<ProductPackageWhereInput>;
  some?: Maybe<ProductPackageWhereInput>;
};

export type ProductPackageMaxAggregateOutputType = {
  __typename?: 'ProductPackageMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductPackageMinAggregateOutputType = {
  __typename?: 'ProductPackageMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductPackageOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ProductPackageOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ProductPackageOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  modules?: Maybe<ModuleOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  subscriptions?: Maybe<ProductPackageSubscriptionOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ProductPackageOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type ProductPackageOrderByRelevanceInput = {
  fields: Array<ProductPackageOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ProductPackageOrderByWithAggregationInput = {
  _count?: Maybe<ProductPackageCountOrderByAggregateInput>;
  _max?: Maybe<ProductPackageMaxOrderByAggregateInput>;
  _min?: Maybe<ProductPackageMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductPackageOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ProductPackageOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  modules?: Maybe<ModuleOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  subscriptions?: Maybe<ProductPackageSubscriptionOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductPackageOrderByWithRelationInput = {
  _relevance?: Maybe<ProductPackageOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  modules?: Maybe<ModuleOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  subscriptions?: Maybe<ProductPackageSubscriptionOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ProductPackageScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type ProductPackageScalarRelationFilter = {
  AND?: Maybe<Array<ProductPackageWhereInput>>;
  NOT?: Maybe<Array<ProductPackageWhereInput>>;
  OR?: Maybe<Array<ProductPackageWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  modules?: Maybe<ModuleListRelationFilter>;
  name?: Maybe<StringFilter>;
  subscriptions?: Maybe<ProductPackageSubscriptionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ProductPackageScalarWhereInput = {
  AND?: Maybe<Array<ProductPackageScalarWhereInput>>;
  NOT?: Maybe<Array<ProductPackageScalarWhereInput>>;
  OR?: Maybe<Array<ProductPackageScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ProductPackageScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ProductPackageScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ProductPackageScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ProductPackageScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ProductPackageSubscription = {
  __typename?: 'ProductPackageSubscription';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  packageId: Scalars['String'];
  productPackage: ProductPackage;
  startAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type ProductPackageSubscriptionCountAggregateOutputType = {
  __typename?: 'ProductPackageSubscriptionCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  endAt: Scalars['Int'];
  id: Scalars['Int'];
  packageId: Scalars['Int'];
  startAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ProductPackageSubscriptionCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  packageId?: Maybe<SortOrder>;
  startAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductPackageSubscriptionCreateInput = {
  clinic: ClinicCreateNestedOneWithoutProductPackageSubscriptionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  productPackage: ProductPackageCreateNestedOneWithoutSubscriptionsInput;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  packageId: Scalars['String'];
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionCreateManyClinicInputEnvelope = {
  data: Array<ProductPackageSubscriptionCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ProductPackageSubscriptionCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  packageId: Scalars['String'];
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionCreateManyProductPackageInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionCreateManyProductPackageInputEnvelope = {
  data: Array<ProductPackageSubscriptionCreateManyProductPackageInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ProductPackageSubscriptionCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductPackageSubscriptionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ProductPackageSubscriptionCreateWithoutClinicInput>>;
  createMany?: Maybe<ProductPackageSubscriptionCreateManyClinicInputEnvelope>;
};

export type ProductPackageSubscriptionCreateNestedManyWithoutProductPackageInput = {
  connect?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductPackageSubscriptionCreateOrConnectWithoutProductPackageInput>>;
  create?: Maybe<Array<ProductPackageSubscriptionCreateWithoutProductPackageInput>>;
  createMany?: Maybe<ProductPackageSubscriptionCreateManyProductPackageInputEnvelope>;
};

export type ProductPackageSubscriptionCreateOrConnectWithoutClinicInput = {
  create: ProductPackageSubscriptionCreateWithoutClinicInput;
  where: ProductPackageSubscriptionWhereUniqueInput;
};

export type ProductPackageSubscriptionCreateOrConnectWithoutProductPackageInput = {
  create: ProductPackageSubscriptionCreateWithoutProductPackageInput;
  where: ProductPackageSubscriptionWhereUniqueInput;
};

export type ProductPackageSubscriptionCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  productPackage: ProductPackageCreateNestedOneWithoutSubscriptionsInput;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionCreateWithoutProductPackageInput = {
  clinic: ClinicCreateNestedOneWithoutProductPackageSubscriptionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionGroupByOutputType = {
  __typename?: 'ProductPackageSubscriptionGroupByOutputType';
  _count?: Maybe<ProductPackageSubscriptionCountAggregateOutputType>;
  _max?: Maybe<ProductPackageSubscriptionMaxAggregateOutputType>;
  _min?: Maybe<ProductPackageSubscriptionMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  packageId: Scalars['String'];
  startAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type ProductPackageSubscriptionListRelationFilter = {
  every?: Maybe<ProductPackageSubscriptionWhereInput>;
  none?: Maybe<ProductPackageSubscriptionWhereInput>;
  some?: Maybe<ProductPackageSubscriptionWhereInput>;
};

export type ProductPackageSubscriptionMaxAggregateOutputType = {
  __typename?: 'ProductPackageSubscriptionMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  packageId?: Maybe<SortOrder>;
  startAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductPackageSubscriptionMinAggregateOutputType = {
  __typename?: 'ProductPackageSubscriptionMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  packageId?: Maybe<SortOrder>;
  startAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductPackageSubscriptionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ProductPackageSubscriptionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ProductPackageSubscriptionOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  packageId?: Maybe<SortOrder>;
  productPackage?: Maybe<ProductPackageOrderByWithRelationInput>;
  startAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ProductPackageSubscriptionOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  PackageId = 'packageId'
}

export type ProductPackageSubscriptionOrderByRelevanceInput = {
  fields: Array<ProductPackageSubscriptionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ProductPackageSubscriptionOrderByWithAggregationInput = {
  _count?: Maybe<ProductPackageSubscriptionCountOrderByAggregateInput>;
  _max?: Maybe<ProductPackageSubscriptionMaxOrderByAggregateInput>;
  _min?: Maybe<ProductPackageSubscriptionMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  packageId?: Maybe<SortOrder>;
  startAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductPackageSubscriptionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ProductPackageSubscriptionOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  packageId?: Maybe<SortOrder>;
  productPackage?: Maybe<ProductPackageOrderByWithRelationInput>;
  startAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProductPackageSubscriptionOrderByWithRelationInput = {
  _relevance?: Maybe<ProductPackageSubscriptionOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  packageId?: Maybe<SortOrder>;
  productPackage?: Maybe<ProductPackageOrderByWithRelationInput>;
  startAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ProductPackageSubscriptionScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  EndAt = 'endAt',
  Id = 'id',
  PackageId = 'packageId',
  StartAt = 'startAt',
  UpdatedAt = 'updatedAt'
}

export type ProductPackageSubscriptionScalarWhereInput = {
  AND?: Maybe<Array<ProductPackageSubscriptionScalarWhereInput>>;
  NOT?: Maybe<Array<ProductPackageSubscriptionScalarWhereInput>>;
  OR?: Maybe<Array<ProductPackageSubscriptionScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  packageId?: Maybe<StringFilter>;
  startAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ProductPackageSubscriptionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ProductPackageSubscriptionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ProductPackageSubscriptionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ProductPackageSubscriptionScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  endAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  packageId?: Maybe<StringWithAggregatesFilter>;
  startAt?: Maybe<DateTimeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ProductPackageSubscriptionUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  packageId: Scalars['String'];
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductPackageSubscriptionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ProductPackageSubscriptionCreateWithoutClinicInput>>;
  createMany?: Maybe<ProductPackageSubscriptionCreateManyClinicInputEnvelope>;
};

export type ProductPackageSubscriptionUncheckedCreateNestedManyWithoutProductPackageInput = {
  connect?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductPackageSubscriptionCreateOrConnectWithoutProductPackageInput>>;
  create?: Maybe<Array<ProductPackageSubscriptionCreateWithoutProductPackageInput>>;
  createMany?: Maybe<ProductPackageSubscriptionCreateManyProductPackageInputEnvelope>;
};

export type ProductPackageSubscriptionUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  packageId: Scalars['String'];
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUncheckedCreateWithoutProductPackageInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductPackageSubscriptionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ProductPackageSubscriptionCreateWithoutClinicInput>>;
  createMany?: Maybe<ProductPackageSubscriptionCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProductPackageSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<ProductPackageSubscriptionUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ProductPackageSubscriptionUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ProductPackageSubscriptionUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ProductPackageSubscriptionUncheckedUpdateManyWithoutProductPackageInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUncheckedUpdateManyWithoutProductPackageNestedInput = {
  connect?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductPackageSubscriptionCreateOrConnectWithoutProductPackageInput>>;
  create?: Maybe<Array<ProductPackageSubscriptionCreateWithoutProductPackageInput>>;
  createMany?: Maybe<ProductPackageSubscriptionCreateManyProductPackageInputEnvelope>;
  delete?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProductPackageSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<ProductPackageSubscriptionUpdateWithWhereUniqueWithoutProductPackageInput>>;
  updateMany?: Maybe<Array<ProductPackageSubscriptionUpdateManyWithWhereWithoutProductPackageInput>>;
  upsert?: Maybe<Array<ProductPackageSubscriptionUpsertWithWhereUniqueWithoutProductPackageInput>>;
};

export type ProductPackageSubscriptionUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUncheckedUpdateWithoutProductPackageInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutProductPackageSubscriptionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  productPackage?: Maybe<ProductPackageUpdateOneRequiredWithoutSubscriptionsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUpdateManyWithWhereWithoutClinicInput = {
  data: ProductPackageSubscriptionUpdateManyMutationInput;
  where: ProductPackageSubscriptionScalarWhereInput;
};

export type ProductPackageSubscriptionUpdateManyWithWhereWithoutProductPackageInput = {
  data: ProductPackageSubscriptionUpdateManyMutationInput;
  where: ProductPackageSubscriptionScalarWhereInput;
};

export type ProductPackageSubscriptionUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductPackageSubscriptionCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<ProductPackageSubscriptionCreateWithoutClinicInput>>;
  createMany?: Maybe<ProductPackageSubscriptionCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProductPackageSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<ProductPackageSubscriptionUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<ProductPackageSubscriptionUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<ProductPackageSubscriptionUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ProductPackageSubscriptionUpdateManyWithoutProductPackageNestedInput = {
  connect?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductPackageSubscriptionCreateOrConnectWithoutProductPackageInput>>;
  create?: Maybe<Array<ProductPackageSubscriptionCreateWithoutProductPackageInput>>;
  createMany?: Maybe<ProductPackageSubscriptionCreateManyProductPackageInputEnvelope>;
  delete?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProductPackageSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<ProductPackageSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<ProductPackageSubscriptionUpdateWithWhereUniqueWithoutProductPackageInput>>;
  updateMany?: Maybe<Array<ProductPackageSubscriptionUpdateManyWithWhereWithoutProductPackageInput>>;
  upsert?: Maybe<Array<ProductPackageSubscriptionUpsertWithWhereUniqueWithoutProductPackageInput>>;
};

export type ProductPackageSubscriptionUpdateWithWhereUniqueWithoutClinicInput = {
  data: ProductPackageSubscriptionUpdateWithoutClinicInput;
  where: ProductPackageSubscriptionWhereUniqueInput;
};

export type ProductPackageSubscriptionUpdateWithWhereUniqueWithoutProductPackageInput = {
  data: ProductPackageSubscriptionUpdateWithoutProductPackageInput;
  where: ProductPackageSubscriptionWhereUniqueInput;
};

export type ProductPackageSubscriptionUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  productPackage?: Maybe<ProductPackageUpdateOneRequiredWithoutSubscriptionsNestedInput>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUpdateWithoutProductPackageInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutProductPackageSubscriptionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageSubscriptionUpsertWithWhereUniqueWithoutClinicInput = {
  create: ProductPackageSubscriptionCreateWithoutClinicInput;
  update: ProductPackageSubscriptionUpdateWithoutClinicInput;
  where: ProductPackageSubscriptionWhereUniqueInput;
};

export type ProductPackageSubscriptionUpsertWithWhereUniqueWithoutProductPackageInput = {
  create: ProductPackageSubscriptionCreateWithoutProductPackageInput;
  update: ProductPackageSubscriptionUpdateWithoutProductPackageInput;
  where: ProductPackageSubscriptionWhereUniqueInput;
};

export type ProductPackageSubscriptionWhereInput = {
  AND?: Maybe<Array<ProductPackageSubscriptionWhereInput>>;
  NOT?: Maybe<Array<ProductPackageSubscriptionWhereInput>>;
  OR?: Maybe<Array<ProductPackageSubscriptionWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  packageId?: Maybe<StringFilter>;
  productPackage?: Maybe<ProductPackageScalarRelationFilter>;
  startAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ProductPackageSubscriptionWhereUniqueInput = {
  AND?: Maybe<Array<ProductPackageSubscriptionWhereInput>>;
  NOT?: Maybe<Array<ProductPackageSubscriptionWhereInput>>;
  OR?: Maybe<Array<ProductPackageSubscriptionWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  packageId?: Maybe<StringFilter>;
  productPackage?: Maybe<ProductPackageScalarRelationFilter>;
  startAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ProductPackageUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modules?: Maybe<ModuleUncheckedCreateNestedManyWithoutProductPackagesInput>;
  name: Scalars['String'];
  subscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutProductPackageInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageUncheckedCreateNestedManyWithoutModulesInput = {
  connect?: Maybe<Array<ProductPackageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductPackageCreateOrConnectWithoutModulesInput>>;
  create?: Maybe<Array<ProductPackageCreateWithoutModulesInput>>;
};

export type ProductPackageUncheckedCreateWithoutModulesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subscriptions?: Maybe<ProductPackageSubscriptionUncheckedCreateNestedManyWithoutProductPackageInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageUncheckedCreateWithoutSubscriptionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modules?: Maybe<ModuleUncheckedCreateNestedManyWithoutProductPackagesInput>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modules?: Maybe<ModuleUncheckedUpdateManyWithoutProductPackagesNestedInput>;
  name?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutProductPackageNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageUncheckedUpdateManyWithoutModulesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageUncheckedUpdateManyWithoutModulesNestedInput = {
  connect?: Maybe<Array<ProductPackageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductPackageCreateOrConnectWithoutModulesInput>>;
  create?: Maybe<Array<ProductPackageCreateWithoutModulesInput>>;
  delete?: Maybe<Array<ProductPackageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProductPackageScalarWhereInput>>;
  disconnect?: Maybe<Array<ProductPackageWhereUniqueInput>>;
  set?: Maybe<Array<ProductPackageWhereUniqueInput>>;
  update?: Maybe<Array<ProductPackageUpdateWithWhereUniqueWithoutModulesInput>>;
  updateMany?: Maybe<Array<ProductPackageUpdateManyWithWhereWithoutModulesInput>>;
  upsert?: Maybe<Array<ProductPackageUpsertWithWhereUniqueWithoutModulesInput>>;
};

export type ProductPackageUncheckedUpdateWithoutModulesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<ProductPackageSubscriptionUncheckedUpdateManyWithoutProductPackageNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageUncheckedUpdateWithoutSubscriptionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modules?: Maybe<ModuleUncheckedUpdateManyWithoutProductPackagesNestedInput>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modules?: Maybe<ModuleUpdateManyWithoutProductPackagesNestedInput>;
  name?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutProductPackageNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageUpdateManyWithWhereWithoutModulesInput = {
  data: ProductPackageUpdateManyMutationInput;
  where: ProductPackageScalarWhereInput;
};

export type ProductPackageUpdateManyWithoutModulesNestedInput = {
  connect?: Maybe<Array<ProductPackageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductPackageCreateOrConnectWithoutModulesInput>>;
  create?: Maybe<Array<ProductPackageCreateWithoutModulesInput>>;
  delete?: Maybe<Array<ProductPackageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProductPackageScalarWhereInput>>;
  disconnect?: Maybe<Array<ProductPackageWhereUniqueInput>>;
  set?: Maybe<Array<ProductPackageWhereUniqueInput>>;
  update?: Maybe<Array<ProductPackageUpdateWithWhereUniqueWithoutModulesInput>>;
  updateMany?: Maybe<Array<ProductPackageUpdateManyWithWhereWithoutModulesInput>>;
  upsert?: Maybe<Array<ProductPackageUpsertWithWhereUniqueWithoutModulesInput>>;
};

export type ProductPackageUpdateOneRequiredWithoutSubscriptionsNestedInput = {
  connect?: Maybe<ProductPackageWhereUniqueInput>;
  connectOrCreate?: Maybe<ProductPackageCreateOrConnectWithoutSubscriptionsInput>;
  create?: Maybe<ProductPackageCreateWithoutSubscriptionsInput>;
  update?: Maybe<ProductPackageUpdateToOneWithWhereWithoutSubscriptionsInput>;
  upsert?: Maybe<ProductPackageUpsertWithoutSubscriptionsInput>;
};

export type ProductPackageUpdateToOneWithWhereWithoutSubscriptionsInput = {
  data: ProductPackageUpdateWithoutSubscriptionsInput;
  where?: Maybe<ProductPackageWhereInput>;
};

export type ProductPackageUpdateWithWhereUniqueWithoutModulesInput = {
  data: ProductPackageUpdateWithoutModulesInput;
  where: ProductPackageWhereUniqueInput;
};

export type ProductPackageUpdateWithoutModulesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<ProductPackageSubscriptionUpdateManyWithoutProductPackageNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageUpdateWithoutSubscriptionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modules?: Maybe<ModuleUpdateManyWithoutProductPackagesNestedInput>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductPackageUpsertWithWhereUniqueWithoutModulesInput = {
  create: ProductPackageCreateWithoutModulesInput;
  update: ProductPackageUpdateWithoutModulesInput;
  where: ProductPackageWhereUniqueInput;
};

export type ProductPackageUpsertWithoutSubscriptionsInput = {
  create: ProductPackageCreateWithoutSubscriptionsInput;
  update: ProductPackageUpdateWithoutSubscriptionsInput;
  where?: Maybe<ProductPackageWhereInput>;
};

export type ProductPackageWhereInput = {
  AND?: Maybe<Array<ProductPackageWhereInput>>;
  NOT?: Maybe<Array<ProductPackageWhereInput>>;
  OR?: Maybe<Array<ProductPackageWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  modules?: Maybe<ModuleListRelationFilter>;
  name?: Maybe<StringFilter>;
  subscriptions?: Maybe<ProductPackageSubscriptionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ProductPackageWhereUniqueInput = {
  AND?: Maybe<Array<ProductPackageWhereInput>>;
  NOT?: Maybe<Array<ProductPackageWhereInput>>;
  OR?: Maybe<Array<ProductPackageWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  modules?: Maybe<ModuleListRelationFilter>;
  name?: Maybe<StringFilter>;
  subscriptions?: Maybe<ProductPackageSubscriptionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum ProductScalarFieldEnum {
  Brand = 'brand',
  CreatedAt = 'createdAt',
  Description = 'description',
  Details = 'details',
  Id = 'id',
  Indications = 'indications',
  InformPartnerId = 'informPartnerId',
  Manufacturer = 'manufacturer',
  MaxWeightInKg = 'maxWeightInKg',
  MinWeightInKg = 'minWeightInKg',
  Name = 'name',
  ParentProductId = 'parentProductId',
  Quantity = 'quantity',
  SupplyDuration = 'supplyDuration',
  SupplyDurationUnit = 'supplyDurationUnit',
  Type = 'type',
  UniversalProductCode = 'universalProductCode',
  UpdatedAt = 'updatedAt'
}

export type ProductScalarRelationFilter = {
  AND?: Maybe<Array<ProductWhereInput>>;
  NOT?: Maybe<Array<ProductWhereInput>>;
  OR?: Maybe<Array<ProductWhereInput>>;
  activeIngredients?: Maybe<ActiveIngredientListRelationFilter>;
  brand?: Maybe<StringFilter>;
  canonicalService?: Maybe<CanonicalServiceScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  details?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  indications?: Maybe<EnumProductIndicationNullableListFilter>;
  informPartner?: Maybe<InformPartnerNullableScalarRelationFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  manufacturer?: Maybe<StringFilter>;
  maxWeightInKg?: Maybe<FloatNullableFilter>;
  media?: Maybe<MediaListRelationFilter>;
  minWeightInKg?: Maybe<FloatNullableFilter>;
  name?: Maybe<StringFilter>;
  parent?: Maybe<ProductNullableScalarRelationFilter>;
  parentProductId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<IntNullableFilter>;
  supplyDuration?: Maybe<FloatNullableFilter>;
  supplyDurationUnit?: Maybe<EnumProductSupplyDurationUnitNullableFilter>;
  type?: Maybe<EnumProductTypeFilter>;
  universalProductCode?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  variants?: Maybe<ProductListRelationFilter>;
};

export type ProductScalarWhereInput = {
  AND?: Maybe<Array<ProductScalarWhereInput>>;
  NOT?: Maybe<Array<ProductScalarWhereInput>>;
  OR?: Maybe<Array<ProductScalarWhereInput>>;
  brand?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  details?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  indications?: Maybe<EnumProductIndicationNullableListFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  manufacturer?: Maybe<StringFilter>;
  maxWeightInKg?: Maybe<FloatNullableFilter>;
  minWeightInKg?: Maybe<FloatNullableFilter>;
  name?: Maybe<StringFilter>;
  parentProductId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<IntNullableFilter>;
  supplyDuration?: Maybe<FloatNullableFilter>;
  supplyDurationUnit?: Maybe<EnumProductSupplyDurationUnitNullableFilter>;
  type?: Maybe<EnumProductTypeFilter>;
  universalProductCode?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ProductScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ProductScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ProductScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ProductScalarWhereWithAggregatesInput>>;
  brand?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  details?: Maybe<JsonNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  indications?: Maybe<EnumProductIndicationNullableListFilter>;
  informPartnerId?: Maybe<StringNullableWithAggregatesFilter>;
  manufacturer?: Maybe<StringWithAggregatesFilter>;
  maxWeightInKg?: Maybe<FloatNullableWithAggregatesFilter>;
  minWeightInKg?: Maybe<FloatNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  parentProductId?: Maybe<StringNullableWithAggregatesFilter>;
  quantity?: Maybe<IntNullableWithAggregatesFilter>;
  supplyDuration?: Maybe<FloatNullableWithAggregatesFilter>;
  supplyDurationUnit?: Maybe<EnumProductSupplyDurationUnitNullableWithAggregatesFilter>;
  type?: Maybe<EnumProductTypeWithAggregatesFilter>;
  universalProductCode?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ProductSumAggregateOutputType = {
  __typename?: 'ProductSumAggregateOutputType';
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
};

export type ProductSumOrderByAggregateInput = {
  maxWeightInKg?: Maybe<SortOrder>;
  minWeightInKg?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  supplyDuration?: Maybe<SortOrder>;
};

export enum ProductSupplyDurationUnit {
  Days = 'Days',
  Months = 'Months',
  Weeks = 'Weeks',
  Years = 'Years'
}

export enum ProductType {
  Food = 'Food',
  Medication = 'Medication'
}

export type ProductTypeNameBrandManufacturerCompoundUniqueInput = {
  brand: Scalars['String'];
  manufacturer: Scalars['String'];
  name: Scalars['String'];
  type: ProductType;
};

export type ProductUncheckedCreateInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedCreateNestedManyWithoutProductInput>;
  brand: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutProductsInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUncheckedCreateNestedManyWithoutParentInput>;
};

export type ProductUncheckedCreateNestedManyWithoutInformPartnerInput = {
  connect?: Maybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<ProductCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<ProductCreateManyInformPartnerInputEnvelope>;
};

export type ProductUncheckedCreateNestedManyWithoutMediaInput = {
  connect?: Maybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<ProductCreateWithoutMediaInput>>;
};

export type ProductUncheckedCreateNestedManyWithoutParentInput = {
  connect?: Maybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductCreateOrConnectWithoutParentInput>>;
  create?: Maybe<Array<ProductCreateWithoutParentInput>>;
  createMany?: Maybe<ProductCreateManyParentInputEnvelope>;
};

export type ProductUncheckedCreateNestedOneWithoutCanonicalServiceInput = {
  connect?: Maybe<ProductWhereUniqueInput>;
  connectOrCreate?: Maybe<ProductCreateOrConnectWithoutCanonicalServiceInput>;
  create?: Maybe<ProductCreateWithoutCanonicalServiceInput>;
};

export type ProductUncheckedCreateWithoutActiveIngredientsInput = {
  brand: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutProductsInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUncheckedCreateNestedManyWithoutParentInput>;
};

export type ProductUncheckedCreateWithoutCanonicalServiceInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedCreateNestedManyWithoutProductInput>;
  brand: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutProductsInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUncheckedCreateNestedManyWithoutParentInput>;
};

export type ProductUncheckedCreateWithoutInformPartnerInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedCreateNestedManyWithoutProductInput>;
  brand: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutProductsInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUncheckedCreateNestedManyWithoutParentInput>;
};

export type ProductUncheckedCreateWithoutMediaInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedCreateNestedManyWithoutProductInput>;
  brand: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUncheckedCreateNestedManyWithoutParentInput>;
};

export type ProductUncheckedCreateWithoutParentInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedCreateNestedManyWithoutProductInput>;
  brand: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutProductsInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUncheckedCreateNestedManyWithoutParentInput>;
};

export type ProductUncheckedCreateWithoutVariantsInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedCreateNestedManyWithoutProductInput>;
  brand: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer: Scalars['String'];
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUncheckedCreateNestedManyWithoutProductsInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type: ProductType;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductUncheckedUpdateInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedUpdateManyWithoutProductNestedInput>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutProductsNestedInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUncheckedUpdateManyWithoutParentNestedInput>;
};

export type ProductUncheckedUpdateManyInput = {
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductUncheckedUpdateManyWithoutInformPartnerInput = {
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductUncheckedUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<ProductCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<ProductCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProductScalarWhereInput>>;
  disconnect?: Maybe<Array<ProductWhereUniqueInput>>;
  set?: Maybe<Array<ProductWhereUniqueInput>>;
  update?: Maybe<Array<ProductUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<ProductUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<ProductUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type ProductUncheckedUpdateManyWithoutMediaInput = {
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductUncheckedUpdateManyWithoutMediaNestedInput = {
  connect?: Maybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<ProductCreateWithoutMediaInput>>;
  delete?: Maybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProductScalarWhereInput>>;
  disconnect?: Maybe<Array<ProductWhereUniqueInput>>;
  set?: Maybe<Array<ProductWhereUniqueInput>>;
  update?: Maybe<Array<ProductUpdateWithWhereUniqueWithoutMediaInput>>;
  updateMany?: Maybe<Array<ProductUpdateManyWithWhereWithoutMediaInput>>;
  upsert?: Maybe<Array<ProductUpsertWithWhereUniqueWithoutMediaInput>>;
};

export type ProductUncheckedUpdateManyWithoutParentInput = {
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductUncheckedUpdateManyWithoutParentNestedInput = {
  connect?: Maybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductCreateOrConnectWithoutParentInput>>;
  create?: Maybe<Array<ProductCreateWithoutParentInput>>;
  createMany?: Maybe<ProductCreateManyParentInputEnvelope>;
  delete?: Maybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProductScalarWhereInput>>;
  disconnect?: Maybe<Array<ProductWhereUniqueInput>>;
  set?: Maybe<Array<ProductWhereUniqueInput>>;
  update?: Maybe<Array<ProductUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: Maybe<Array<ProductUpdateManyWithWhereWithoutParentInput>>;
  upsert?: Maybe<Array<ProductUpsertWithWhereUniqueWithoutParentInput>>;
};

export type ProductUncheckedUpdateOneWithoutCanonicalServiceNestedInput = {
  connect?: Maybe<ProductWhereUniqueInput>;
  connectOrCreate?: Maybe<ProductCreateOrConnectWithoutCanonicalServiceInput>;
  create?: Maybe<ProductCreateWithoutCanonicalServiceInput>;
  delete?: Maybe<ProductWhereInput>;
  disconnect?: Maybe<ProductWhereInput>;
  update?: Maybe<ProductUpdateToOneWithWhereWithoutCanonicalServiceInput>;
  upsert?: Maybe<ProductUpsertWithoutCanonicalServiceInput>;
};

export type ProductUncheckedUpdateWithoutActiveIngredientsInput = {
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutProductsNestedInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUncheckedUpdateManyWithoutParentNestedInput>;
};

export type ProductUncheckedUpdateWithoutCanonicalServiceInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedUpdateManyWithoutProductNestedInput>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutProductsNestedInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUncheckedUpdateManyWithoutParentNestedInput>;
};

export type ProductUncheckedUpdateWithoutInformPartnerInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedUpdateManyWithoutProductNestedInput>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutProductsNestedInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUncheckedUpdateManyWithoutParentNestedInput>;
};

export type ProductUncheckedUpdateWithoutMediaInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedUpdateManyWithoutProductNestedInput>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUncheckedUpdateManyWithoutParentNestedInput>;
};

export type ProductUncheckedUpdateWithoutParentInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedUpdateManyWithoutProductNestedInput>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutProductsNestedInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUncheckedUpdateManyWithoutParentNestedInput>;
};

export type ProductUncheckedUpdateWithoutVariantsInput = {
  activeIngredients?: Maybe<ActiveIngredientUncheckedUpdateManyWithoutProductNestedInput>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartnerId?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUncheckedUpdateManyWithoutProductsNestedInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parentProductId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductUpdateInput = {
  activeIngredients?: Maybe<ActiveIngredientUpdateManyWithoutProductNestedInput>;
  brand?: Maybe<Scalars['String']>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneRequiredWithoutProductNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutProductsNestedInput>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUpdateManyWithoutProductsNestedInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<ProductUpdateOneWithoutVariantsNestedInput>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUpdateManyWithoutParentNestedInput>;
};

export type ProductUpdateManyMutationInput = {
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductUpdateManyWithWhereWithoutInformPartnerInput = {
  data: ProductUpdateManyMutationInput;
  where: ProductScalarWhereInput;
};

export type ProductUpdateManyWithWhereWithoutMediaInput = {
  data: ProductUpdateManyMutationInput;
  where: ProductScalarWhereInput;
};

export type ProductUpdateManyWithWhereWithoutParentInput = {
  data: ProductUpdateManyMutationInput;
  where: ProductScalarWhereInput;
};

export type ProductUpdateManyWithoutInformPartnerNestedInput = {
  connect?: Maybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductCreateOrConnectWithoutInformPartnerInput>>;
  create?: Maybe<Array<ProductCreateWithoutInformPartnerInput>>;
  createMany?: Maybe<ProductCreateManyInformPartnerInputEnvelope>;
  delete?: Maybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProductScalarWhereInput>>;
  disconnect?: Maybe<Array<ProductWhereUniqueInput>>;
  set?: Maybe<Array<ProductWhereUniqueInput>>;
  update?: Maybe<Array<ProductUpdateWithWhereUniqueWithoutInformPartnerInput>>;
  updateMany?: Maybe<Array<ProductUpdateManyWithWhereWithoutInformPartnerInput>>;
  upsert?: Maybe<Array<ProductUpsertWithWhereUniqueWithoutInformPartnerInput>>;
};

export type ProductUpdateManyWithoutMediaNestedInput = {
  connect?: Maybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<ProductCreateWithoutMediaInput>>;
  delete?: Maybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProductScalarWhereInput>>;
  disconnect?: Maybe<Array<ProductWhereUniqueInput>>;
  set?: Maybe<Array<ProductWhereUniqueInput>>;
  update?: Maybe<Array<ProductUpdateWithWhereUniqueWithoutMediaInput>>;
  updateMany?: Maybe<Array<ProductUpdateManyWithWhereWithoutMediaInput>>;
  upsert?: Maybe<Array<ProductUpsertWithWhereUniqueWithoutMediaInput>>;
};

export type ProductUpdateManyWithoutParentNestedInput = {
  connect?: Maybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProductCreateOrConnectWithoutParentInput>>;
  create?: Maybe<Array<ProductCreateWithoutParentInput>>;
  createMany?: Maybe<ProductCreateManyParentInputEnvelope>;
  delete?: Maybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProductScalarWhereInput>>;
  disconnect?: Maybe<Array<ProductWhereUniqueInput>>;
  set?: Maybe<Array<ProductWhereUniqueInput>>;
  update?: Maybe<Array<ProductUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: Maybe<Array<ProductUpdateManyWithWhereWithoutParentInput>>;
  upsert?: Maybe<Array<ProductUpsertWithWhereUniqueWithoutParentInput>>;
};

export type ProductUpdateOneRequiredWithoutActiveIngredientsNestedInput = {
  connect?: Maybe<ProductWhereUniqueInput>;
  connectOrCreate?: Maybe<ProductCreateOrConnectWithoutActiveIngredientsInput>;
  create?: Maybe<ProductCreateWithoutActiveIngredientsInput>;
  update?: Maybe<ProductUpdateToOneWithWhereWithoutActiveIngredientsInput>;
  upsert?: Maybe<ProductUpsertWithoutActiveIngredientsInput>;
};

export type ProductUpdateOneWithoutCanonicalServiceNestedInput = {
  connect?: Maybe<ProductWhereUniqueInput>;
  connectOrCreate?: Maybe<ProductCreateOrConnectWithoutCanonicalServiceInput>;
  create?: Maybe<ProductCreateWithoutCanonicalServiceInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ProductUpdateToOneWithWhereWithoutCanonicalServiceInput>;
  upsert?: Maybe<ProductUpsertWithoutCanonicalServiceInput>;
};

export type ProductUpdateOneWithoutVariantsNestedInput = {
  connect?: Maybe<ProductWhereUniqueInput>;
  connectOrCreate?: Maybe<ProductCreateOrConnectWithoutVariantsInput>;
  create?: Maybe<ProductCreateWithoutVariantsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ProductUpdateToOneWithWhereWithoutVariantsInput>;
  upsert?: Maybe<ProductUpsertWithoutVariantsInput>;
};

export type ProductUpdateToOneWithWhereWithoutActiveIngredientsInput = {
  data: ProductUpdateWithoutActiveIngredientsInput;
  where?: Maybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutCanonicalServiceInput = {
  data: ProductUpdateWithoutCanonicalServiceInput;
  where?: Maybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutVariantsInput = {
  data: ProductUpdateWithoutVariantsInput;
  where?: Maybe<ProductWhereInput>;
};

export type ProductUpdateWithWhereUniqueWithoutInformPartnerInput = {
  data: ProductUpdateWithoutInformPartnerInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpdateWithWhereUniqueWithoutMediaInput = {
  data: ProductUpdateWithoutMediaInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpdateWithWhereUniqueWithoutParentInput = {
  data: ProductUpdateWithoutParentInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpdateWithoutActiveIngredientsInput = {
  brand?: Maybe<Scalars['String']>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneRequiredWithoutProductNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutProductsNestedInput>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUpdateManyWithoutProductsNestedInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<ProductUpdateOneWithoutVariantsNestedInput>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUpdateManyWithoutParentNestedInput>;
};

export type ProductUpdateWithoutCanonicalServiceInput = {
  activeIngredients?: Maybe<ActiveIngredientUpdateManyWithoutProductNestedInput>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutProductsNestedInput>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUpdateManyWithoutProductsNestedInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<ProductUpdateOneWithoutVariantsNestedInput>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUpdateManyWithoutParentNestedInput>;
};

export type ProductUpdateWithoutInformPartnerInput = {
  activeIngredients?: Maybe<ActiveIngredientUpdateManyWithoutProductNestedInput>;
  brand?: Maybe<Scalars['String']>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneRequiredWithoutProductNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUpdateManyWithoutProductsNestedInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<ProductUpdateOneWithoutVariantsNestedInput>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUpdateManyWithoutParentNestedInput>;
};

export type ProductUpdateWithoutMediaInput = {
  activeIngredients?: Maybe<ActiveIngredientUpdateManyWithoutProductNestedInput>;
  brand?: Maybe<Scalars['String']>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneRequiredWithoutProductNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutProductsNestedInput>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<ProductUpdateOneWithoutVariantsNestedInput>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUpdateManyWithoutParentNestedInput>;
};

export type ProductUpdateWithoutParentInput = {
  activeIngredients?: Maybe<ActiveIngredientUpdateManyWithoutProductNestedInput>;
  brand?: Maybe<Scalars['String']>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneRequiredWithoutProductNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutProductsNestedInput>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUpdateManyWithoutProductsNestedInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<ProductUpdateManyWithoutParentNestedInput>;
};

export type ProductUpdateWithoutVariantsInput = {
  activeIngredients?: Maybe<ActiveIngredientUpdateManyWithoutProductNestedInput>;
  brand?: Maybe<Scalars['String']>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneRequiredWithoutProductNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['Json']>;
  indications?: Maybe<Array<ProductIndication>>;
  informPartner?: Maybe<InformPartnerUpdateOneWithoutProductsNestedInput>;
  manufacturer?: Maybe<Scalars['String']>;
  maxWeightInKg?: Maybe<Scalars['Float']>;
  media?: Maybe<MediaUpdateManyWithoutProductsNestedInput>;
  minWeightInKg?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<ProductUpdateOneWithoutVariantsNestedInput>;
  quantity?: Maybe<Scalars['Int']>;
  supplyDuration?: Maybe<Scalars['Float']>;
  supplyDurationUnit?: Maybe<ProductSupplyDurationUnit>;
  type?: Maybe<ProductType>;
  universalProductCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductUpdateindicationsInput = {
  push?: Maybe<Array<ProductIndication>>;
  set?: Maybe<Array<ProductIndication>>;
};

export type ProductUpsertWithWhereUniqueWithoutInformPartnerInput = {
  create: ProductCreateWithoutInformPartnerInput;
  update: ProductUpdateWithoutInformPartnerInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpsertWithWhereUniqueWithoutMediaInput = {
  create: ProductCreateWithoutMediaInput;
  update: ProductUpdateWithoutMediaInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpsertWithWhereUniqueWithoutParentInput = {
  create: ProductCreateWithoutParentInput;
  update: ProductUpdateWithoutParentInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpsertWithoutActiveIngredientsInput = {
  create: ProductCreateWithoutActiveIngredientsInput;
  update: ProductUpdateWithoutActiveIngredientsInput;
  where?: Maybe<ProductWhereInput>;
};

export type ProductUpsertWithoutCanonicalServiceInput = {
  create: ProductCreateWithoutCanonicalServiceInput;
  update: ProductUpdateWithoutCanonicalServiceInput;
  where?: Maybe<ProductWhereInput>;
};

export type ProductUpsertWithoutVariantsInput = {
  create: ProductCreateWithoutVariantsInput;
  update: ProductUpdateWithoutVariantsInput;
  where?: Maybe<ProductWhereInput>;
};

export type ProductWhereInput = {
  AND?: Maybe<Array<ProductWhereInput>>;
  NOT?: Maybe<Array<ProductWhereInput>>;
  OR?: Maybe<Array<ProductWhereInput>>;
  activeIngredients?: Maybe<ActiveIngredientListRelationFilter>;
  brand?: Maybe<StringFilter>;
  canonicalService?: Maybe<CanonicalServiceScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  details?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  indications?: Maybe<EnumProductIndicationNullableListFilter>;
  informPartner?: Maybe<InformPartnerNullableScalarRelationFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  manufacturer?: Maybe<StringFilter>;
  maxWeightInKg?: Maybe<FloatNullableFilter>;
  media?: Maybe<MediaListRelationFilter>;
  minWeightInKg?: Maybe<FloatNullableFilter>;
  name?: Maybe<StringFilter>;
  parent?: Maybe<ProductNullableScalarRelationFilter>;
  parentProductId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<IntNullableFilter>;
  supplyDuration?: Maybe<FloatNullableFilter>;
  supplyDurationUnit?: Maybe<EnumProductSupplyDurationUnitNullableFilter>;
  type?: Maybe<EnumProductTypeFilter>;
  universalProductCode?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  variants?: Maybe<ProductListRelationFilter>;
};

export type ProductWhereUniqueInput = {
  AND?: Maybe<Array<ProductWhereInput>>;
  NOT?: Maybe<Array<ProductWhereInput>>;
  OR?: Maybe<Array<ProductWhereInput>>;
  activeIngredients?: Maybe<ActiveIngredientListRelationFilter>;
  brand?: Maybe<StringFilter>;
  canonicalService?: Maybe<CanonicalServiceScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  details?: Maybe<JsonNullableFilter>;
  id?: Maybe<Scalars['String']>;
  indications?: Maybe<EnumProductIndicationNullableListFilter>;
  informPartner?: Maybe<InformPartnerNullableScalarRelationFilter>;
  informPartnerId?: Maybe<StringNullableFilter>;
  manufacturer?: Maybe<StringFilter>;
  maxWeightInKg?: Maybe<FloatNullableFilter>;
  media?: Maybe<MediaListRelationFilter>;
  minWeightInKg?: Maybe<FloatNullableFilter>;
  name?: Maybe<StringFilter>;
  parent?: Maybe<ProductNullableScalarRelationFilter>;
  parentProductId?: Maybe<StringNullableFilter>;
  quantity?: Maybe<IntNullableFilter>;
  supplyDuration?: Maybe<FloatNullableFilter>;
  supplyDurationUnit?: Maybe<EnumProductSupplyDurationUnitNullableFilter>;
  type?: Maybe<EnumProductTypeFilter>;
  type_name_brand_manufacturer?: Maybe<ProductTypeNameBrandManufacturerCompoundUniqueInput>;
  universalProductCode?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  variants?: Maybe<ProductListRelationFilter>;
};

export enum ProfilePimsSyncStatus {
  Error = 'Error',
  InProgress = 'InProgress',
  Queued = 'Queued',
  Success = 'Success'
}

/** @deprecated - 1.0 */
export type PromoCode = {
  __typename?: 'PromoCode';
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  created: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  discount: Scalars['Float'];
  expiresAt: Scalars['DateTime'];
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


/** @deprecated - 1.0 */
export type PromoCodeClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};

export type PromoCodeAvgAggregateOutputType = {
  __typename?: 'PromoCodeAvgAggregateOutputType';
  amountAvailable?: Maybe<Scalars['Float']>;
  amountUsed?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type PromoCodeAvgOrderByAggregateInput = {
  amountAvailable?: Maybe<SortOrder>;
  amountUsed?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
};

export type PromoCodeCountAggregateOutputType = {
  __typename?: 'PromoCodeCountAggregateOutputType';
  _all: Scalars['Int'];
  amountAvailable: Scalars['Int'];
  amountUsed: Scalars['Int'];
  clinicId: Scalars['Int'];
  code: Scalars['Int'];
  created: Scalars['Int'];
  createdAt: Scalars['Int'];
  discount: Scalars['Int'];
  expiresAt: Scalars['Int'];
  firebaseId: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PromoCodeCountOrderByAggregateInput = {
  amountAvailable?: Maybe<SortOrder>;
  amountUsed?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  created?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PromoCodeCreateInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutPromoCodesInput>;
  code: Scalars['String'];
  created: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  discount: Scalars['Float'];
  expiresAt: Scalars['DateTime'];
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeCreateManyClinicInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  created: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  discount: Scalars['Float'];
  expiresAt: Scalars['DateTime'];
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeCreateManyClinicInputEnvelope = {
  data: Array<PromoCodeCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PromoCodeCreateManyInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  clinicId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  created: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  discount: Scalars['Float'];
  expiresAt: Scalars['DateTime'];
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<PromoCodeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PromoCodeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<PromoCodeCreateWithoutClinicInput>>;
  createMany?: Maybe<PromoCodeCreateManyClinicInputEnvelope>;
};

export type PromoCodeCreateOrConnectWithoutClinicInput = {
  create: PromoCodeCreateWithoutClinicInput;
  where: PromoCodeWhereUniqueInput;
};

export type PromoCodeCreateWithoutClinicInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  created: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  discount: Scalars['Float'];
  expiresAt: Scalars['DateTime'];
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeGroupByOutputType = {
  __typename?: 'PromoCodeGroupByOutputType';
  _avg?: Maybe<PromoCodeAvgAggregateOutputType>;
  _count?: Maybe<PromoCodeCountAggregateOutputType>;
  _max?: Maybe<PromoCodeMaxAggregateOutputType>;
  _min?: Maybe<PromoCodeMinAggregateOutputType>;
  _sum?: Maybe<PromoCodeSumAggregateOutputType>;
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  clinicId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  created: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  discount: Scalars['Float'];
  expiresAt: Scalars['DateTime'];
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PromoCodeListRelationFilter = {
  every?: Maybe<PromoCodeWhereInput>;
  none?: Maybe<PromoCodeWhereInput>;
  some?: Maybe<PromoCodeWhereInput>;
};

export type PromoCodeMaxAggregateOutputType = {
  __typename?: 'PromoCodeMaxAggregateOutputType';
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  clinicId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeMaxOrderByAggregateInput = {
  amountAvailable?: Maybe<SortOrder>;
  amountUsed?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  created?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PromoCodeMinAggregateOutputType = {
  __typename?: 'PromoCodeMinAggregateOutputType';
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  clinicId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeMinOrderByAggregateInput = {
  amountAvailable?: Maybe<SortOrder>;
  amountUsed?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  created?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PromoCodeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PromoCodeOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PromoCodeOrderByRelevanceInput>;
  amountAvailable?: Maybe<SortOrder>;
  amountUsed?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  created?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PromoCodeOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Code = 'code',
  FirebaseId = 'firebaseId',
  Id = 'id'
}

export type PromoCodeOrderByRelevanceInput = {
  fields: Array<PromoCodeOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PromoCodeOrderByWithAggregationInput = {
  _avg?: Maybe<PromoCodeAvgOrderByAggregateInput>;
  _count?: Maybe<PromoCodeCountOrderByAggregateInput>;
  _max?: Maybe<PromoCodeMaxOrderByAggregateInput>;
  _min?: Maybe<PromoCodeMinOrderByAggregateInput>;
  _sum?: Maybe<PromoCodeSumOrderByAggregateInput>;
  amountAvailable?: Maybe<SortOrder>;
  amountUsed?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  created?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PromoCodeOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PromoCodeOrderByRelevanceInput>;
  amountAvailable?: Maybe<SortOrder>;
  amountUsed?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  created?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PromoCodeOrderByWithRelationInput = {
  _relevance?: Maybe<PromoCodeOrderByRelevanceInput>;
  amountAvailable?: Maybe<SortOrder>;
  amountUsed?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  created?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PromoCodeScalarFieldEnum {
  AmountAvailable = 'amountAvailable',
  AmountUsed = 'amountUsed',
  ClinicId = 'clinicId',
  Code = 'code',
  Created = 'created',
  CreatedAt = 'createdAt',
  Discount = 'discount',
  ExpiresAt = 'expiresAt',
  FirebaseId = 'firebaseId',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type PromoCodeScalarWhereInput = {
  AND?: Maybe<Array<PromoCodeScalarWhereInput>>;
  NOT?: Maybe<Array<PromoCodeScalarWhereInput>>;
  OR?: Maybe<Array<PromoCodeScalarWhereInput>>;
  amountAvailable?: Maybe<IntNullableFilter>;
  amountUsed?: Maybe<IntNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  code?: Maybe<StringFilter>;
  created?: Maybe<DateTimeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  discount?: Maybe<FloatFilter>;
  expiresAt?: Maybe<DateTimeFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PromoCodeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PromoCodeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PromoCodeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PromoCodeScalarWhereWithAggregatesInput>>;
  amountAvailable?: Maybe<IntNullableWithAggregatesFilter>;
  amountUsed?: Maybe<IntNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  code?: Maybe<StringWithAggregatesFilter>;
  created?: Maybe<DateTimeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  discount?: Maybe<FloatWithAggregatesFilter>;
  expiresAt?: Maybe<DateTimeWithAggregatesFilter>;
  firebaseId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type PromoCodeSumAggregateOutputType = {
  __typename?: 'PromoCodeSumAggregateOutputType';
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Float']>;
};

export type PromoCodeSumOrderByAggregateInput = {
  amountAvailable?: Maybe<SortOrder>;
  amountUsed?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
};

export type PromoCodeUncheckedCreateInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  clinicId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  created: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  discount: Scalars['Float'];
  expiresAt: Scalars['DateTime'];
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<PromoCodeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PromoCodeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<PromoCodeCreateWithoutClinicInput>>;
  createMany?: Maybe<PromoCodeCreateManyClinicInputEnvelope>;
};

export type PromoCodeUncheckedCreateWithoutClinicInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  created: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  discount: Scalars['Float'];
  expiresAt: Scalars['DateTime'];
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeUncheckedUpdateInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  clinicId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeUncheckedUpdateManyInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  clinicId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeUncheckedUpdateManyWithoutClinicInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<PromoCodeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PromoCodeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<PromoCodeCreateWithoutClinicInput>>;
  createMany?: Maybe<PromoCodeCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<PromoCodeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PromoCodeScalarWhereInput>>;
  disconnect?: Maybe<Array<PromoCodeWhereUniqueInput>>;
  set?: Maybe<Array<PromoCodeWhereUniqueInput>>;
  update?: Maybe<Array<PromoCodeUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<PromoCodeUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<PromoCodeUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type PromoCodeUncheckedUpdateWithoutClinicInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeUpdateInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  clinic?: Maybe<ClinicUpdateOneWithoutPromoCodesNestedInput>;
  code?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeUpdateManyMutationInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeUpdateManyWithWhereWithoutClinicInput = {
  data: PromoCodeUpdateManyMutationInput;
  where: PromoCodeScalarWhereInput;
};

export type PromoCodeUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<PromoCodeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PromoCodeCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<PromoCodeCreateWithoutClinicInput>>;
  createMany?: Maybe<PromoCodeCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<PromoCodeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PromoCodeScalarWhereInput>>;
  disconnect?: Maybe<Array<PromoCodeWhereUniqueInput>>;
  set?: Maybe<Array<PromoCodeWhereUniqueInput>>;
  update?: Maybe<Array<PromoCodeUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<PromoCodeUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<PromoCodeUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type PromoCodeUpdateWithWhereUniqueWithoutClinicInput = {
  data: PromoCodeUpdateWithoutClinicInput;
  where: PromoCodeWhereUniqueInput;
};

export type PromoCodeUpdateWithoutClinicInput = {
  amountAvailable?: Maybe<Scalars['Int']>;
  amountUsed?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromoCodeUpsertWithWhereUniqueWithoutClinicInput = {
  create: PromoCodeCreateWithoutClinicInput;
  update: PromoCodeUpdateWithoutClinicInput;
  where: PromoCodeWhereUniqueInput;
};

export type PromoCodeWhereInput = {
  AND?: Maybe<Array<PromoCodeWhereInput>>;
  NOT?: Maybe<Array<PromoCodeWhereInput>>;
  OR?: Maybe<Array<PromoCodeWhereInput>>;
  amountAvailable?: Maybe<IntNullableFilter>;
  amountUsed?: Maybe<IntNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  code?: Maybe<StringFilter>;
  created?: Maybe<DateTimeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  discount?: Maybe<FloatFilter>;
  expiresAt?: Maybe<DateTimeFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PromoCodeWhereUniqueInput = {
  AND?: Maybe<Array<PromoCodeWhereInput>>;
  NOT?: Maybe<Array<PromoCodeWhereInput>>;
  OR?: Maybe<Array<PromoCodeWhereInput>>;
  amountAvailable?: Maybe<IntNullableFilter>;
  amountUsed?: Maybe<IntNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  code?: Maybe<StringFilter>;
  created?: Maybe<DateTimeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  discount?: Maybe<FloatFilter>;
  expiresAt?: Maybe<DateTimeFilter>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ProviderAppointmentTypeRoomMap = {
  __typename?: 'ProviderAppointmentTypeRoomMap';
  appoinmentTypeId?: Maybe<Scalars['String']>;
  appointmentType?: Maybe<AppointmentType>;
  clinicEmployee: ClinicEmployee;
  clinicEmployeeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  room: ClinicRoom;
  roomId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type ProviderAppointmentTypeRoomMapAppointmentTypeArgs = {
  where?: Maybe<AppointmentTypeWhereInput>;
};

export type ProviderAppointmentTypeRoomMapClinicEmployeeIdAppoinmentTypeIdRoomIdCompoundUniqueInput = {
  appoinmentTypeId: Scalars['String'];
  clinicEmployeeId: Scalars['String'];
  roomId: Scalars['String'];
};

export type ProviderAppointmentTypeRoomMapCountAggregateOutputType = {
  __typename?: 'ProviderAppointmentTypeRoomMapCountAggregateOutputType';
  _all: Scalars['Int'];
  appoinmentTypeId: Scalars['Int'];
  clinicEmployeeId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  roomId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ProviderAppointmentTypeRoomMapCountOrderByAggregateInput = {
  appoinmentTypeId?: Maybe<SortOrder>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProviderAppointmentTypeRoomMapCreateInput = {
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutProviderAppointmentTypeRoomMapInput>;
  clinicEmployee: ClinicEmployeeCreateNestedOneWithoutProviderAppointmentTypeRoomMapInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  room: ClinicRoomCreateNestedOneWithoutProviderAppointmentTypeRoomMapInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapCreateManyAppointmentTypeInput = {
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapCreateManyAppointmentTypeInputEnvelope = {
  data: Array<ProviderAppointmentTypeRoomMapCreateManyAppointmentTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ProviderAppointmentTypeRoomMapCreateManyClinicEmployeeInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapCreateManyClinicEmployeeInputEnvelope = {
  data: Array<ProviderAppointmentTypeRoomMapCreateManyClinicEmployeeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ProviderAppointmentTypeRoomMapCreateManyInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapCreateManyRoomInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapCreateManyRoomInputEnvelope = {
  data: Array<ProviderAppointmentTypeRoomMapCreateManyRoomInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ProviderAppointmentTypeRoomMapCreateNestedManyWithoutAppointmentTypeInput = {
  connect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<ProviderAppointmentTypeRoomMapCreateManyAppointmentTypeInputEnvelope>;
};

export type ProviderAppointmentTypeRoomMapCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<ProviderAppointmentTypeRoomMapCreateManyClinicEmployeeInputEnvelope>;
};

export type ProviderAppointmentTypeRoomMapCreateNestedManyWithoutRoomInput = {
  connect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateOrConnectWithoutRoomInput>>;
  create?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateWithoutRoomInput>>;
  createMany?: Maybe<ProviderAppointmentTypeRoomMapCreateManyRoomInputEnvelope>;
};

export type ProviderAppointmentTypeRoomMapCreateOrConnectWithoutAppointmentTypeInput = {
  create: ProviderAppointmentTypeRoomMapCreateWithoutAppointmentTypeInput;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};

export type ProviderAppointmentTypeRoomMapCreateOrConnectWithoutClinicEmployeeInput = {
  create: ProviderAppointmentTypeRoomMapCreateWithoutClinicEmployeeInput;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};

export type ProviderAppointmentTypeRoomMapCreateOrConnectWithoutRoomInput = {
  create: ProviderAppointmentTypeRoomMapCreateWithoutRoomInput;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};

export type ProviderAppointmentTypeRoomMapCreateWithoutAppointmentTypeInput = {
  clinicEmployee: ClinicEmployeeCreateNestedOneWithoutProviderAppointmentTypeRoomMapInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  room: ClinicRoomCreateNestedOneWithoutProviderAppointmentTypeRoomMapInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapCreateWithoutClinicEmployeeInput = {
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutProviderAppointmentTypeRoomMapInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  room: ClinicRoomCreateNestedOneWithoutProviderAppointmentTypeRoomMapInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapCreateWithoutRoomInput = {
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutProviderAppointmentTypeRoomMapInput>;
  clinicEmployee: ClinicEmployeeCreateNestedOneWithoutProviderAppointmentTypeRoomMapInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapGroupByOutputType = {
  __typename?: 'ProviderAppointmentTypeRoomMapGroupByOutputType';
  _count?: Maybe<ProviderAppointmentTypeRoomMapCountAggregateOutputType>;
  _max?: Maybe<ProviderAppointmentTypeRoomMapMaxAggregateOutputType>;
  _min?: Maybe<ProviderAppointmentTypeRoomMapMinAggregateOutputType>;
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  roomId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ProviderAppointmentTypeRoomMapListRelationFilter = {
  every?: Maybe<ProviderAppointmentTypeRoomMapWhereInput>;
  none?: Maybe<ProviderAppointmentTypeRoomMapWhereInput>;
  some?: Maybe<ProviderAppointmentTypeRoomMapWhereInput>;
};

export type ProviderAppointmentTypeRoomMapMaxAggregateOutputType = {
  __typename?: 'ProviderAppointmentTypeRoomMapMaxAggregateOutputType';
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapMaxOrderByAggregateInput = {
  appoinmentTypeId?: Maybe<SortOrder>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProviderAppointmentTypeRoomMapMinAggregateOutputType = {
  __typename?: 'ProviderAppointmentTypeRoomMapMinAggregateOutputType';
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapMinOrderByAggregateInput = {
  appoinmentTypeId?: Maybe<SortOrder>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProviderAppointmentTypeRoomMapOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ProviderAppointmentTypeRoomMapOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ProviderAppointmentTypeRoomMapOrderByRelevanceInput>;
  appoinmentTypeId?: Maybe<SortOrder>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  room?: Maybe<ClinicRoomOrderByWithRelationInput>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ProviderAppointmentTypeRoomMapOrderByRelevanceFieldEnum {
  AppoinmentTypeId = 'appoinmentTypeId',
  ClinicEmployeeId = 'clinicEmployeeId',
  Id = 'id',
  RoomId = 'roomId'
}

export type ProviderAppointmentTypeRoomMapOrderByRelevanceInput = {
  fields: Array<ProviderAppointmentTypeRoomMapOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ProviderAppointmentTypeRoomMapOrderByWithAggregationInput = {
  _count?: Maybe<ProviderAppointmentTypeRoomMapCountOrderByAggregateInput>;
  _max?: Maybe<ProviderAppointmentTypeRoomMapMaxOrderByAggregateInput>;
  _min?: Maybe<ProviderAppointmentTypeRoomMapMinOrderByAggregateInput>;
  appoinmentTypeId?: Maybe<SortOrder>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProviderAppointmentTypeRoomMapOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ProviderAppointmentTypeRoomMapOrderByRelevanceInput>;
  appoinmentTypeId?: Maybe<SortOrder>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  room?: Maybe<ClinicRoomOrderByWithRelationInput>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ProviderAppointmentTypeRoomMapOrderByWithRelationInput = {
  _relevance?: Maybe<ProviderAppointmentTypeRoomMapOrderByRelevanceInput>;
  appoinmentTypeId?: Maybe<SortOrder>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  room?: Maybe<ClinicRoomOrderByWithRelationInput>;
  roomId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ProviderAppointmentTypeRoomMapScalarFieldEnum {
  AppoinmentTypeId = 'appoinmentTypeId',
  ClinicEmployeeId = 'clinicEmployeeId',
  CreatedAt = 'createdAt',
  Id = 'id',
  RoomId = 'roomId',
  UpdatedAt = 'updatedAt'
}

export type ProviderAppointmentTypeRoomMapScalarWhereInput = {
  AND?: Maybe<Array<ProviderAppointmentTypeRoomMapScalarWhereInput>>;
  NOT?: Maybe<Array<ProviderAppointmentTypeRoomMapScalarWhereInput>>;
  OR?: Maybe<Array<ProviderAppointmentTypeRoomMapScalarWhereInput>>;
  appoinmentTypeId?: Maybe<StringNullableFilter>;
  clinicEmployeeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  roomId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ProviderAppointmentTypeRoomMapScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ProviderAppointmentTypeRoomMapScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ProviderAppointmentTypeRoomMapScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ProviderAppointmentTypeRoomMapScalarWhereWithAggregatesInput>>;
  appoinmentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicEmployeeId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  roomId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ProviderAppointmentTypeRoomMapUncheckedCreateInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutAppointmentTypeInput = {
  connect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<ProviderAppointmentTypeRoomMapCreateManyAppointmentTypeInputEnvelope>;
};

export type ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<ProviderAppointmentTypeRoomMapCreateManyClinicEmployeeInputEnvelope>;
};

export type ProviderAppointmentTypeRoomMapUncheckedCreateNestedManyWithoutRoomInput = {
  connect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateOrConnectWithoutRoomInput>>;
  create?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateWithoutRoomInput>>;
  createMany?: Maybe<ProviderAppointmentTypeRoomMapCreateManyRoomInputEnvelope>;
};

export type ProviderAppointmentTypeRoomMapUncheckedCreateWithoutAppointmentTypeInput = {
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUncheckedCreateWithoutClinicEmployeeInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUncheckedCreateWithoutRoomInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUncheckedUpdateInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUncheckedUpdateManyInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<ProviderAppointmentTypeRoomMapCreateManyAppointmentTypeInputEnvelope>;
  delete?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProviderAppointmentTypeRoomMapScalarWhereInput>>;
  disconnect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  set?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  update?: Maybe<Array<ProviderAppointmentTypeRoomMapUpdateWithWhereUniqueWithoutAppointmentTypeInput>>;
  updateMany?: Maybe<Array<ProviderAppointmentTypeRoomMapUpdateManyWithWhereWithoutAppointmentTypeInput>>;
  upsert?: Maybe<Array<ProviderAppointmentTypeRoomMapUpsertWithWhereUniqueWithoutAppointmentTypeInput>>;
};

export type ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<ProviderAppointmentTypeRoomMapCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProviderAppointmentTypeRoomMapScalarWhereInput>>;
  disconnect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  set?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  update?: Maybe<Array<ProviderAppointmentTypeRoomMapUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<ProviderAppointmentTypeRoomMapUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<ProviderAppointmentTypeRoomMapUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutRoomInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUncheckedUpdateManyWithoutRoomNestedInput = {
  connect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateOrConnectWithoutRoomInput>>;
  create?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateWithoutRoomInput>>;
  createMany?: Maybe<ProviderAppointmentTypeRoomMapCreateManyRoomInputEnvelope>;
  delete?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProviderAppointmentTypeRoomMapScalarWhereInput>>;
  disconnect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  set?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  update?: Maybe<Array<ProviderAppointmentTypeRoomMapUpdateWithWhereUniqueWithoutRoomInput>>;
  updateMany?: Maybe<Array<ProviderAppointmentTypeRoomMapUpdateManyWithWhereWithoutRoomInput>>;
  upsert?: Maybe<Array<ProviderAppointmentTypeRoomMapUpsertWithWhereUniqueWithoutRoomInput>>;
};

export type ProviderAppointmentTypeRoomMapUncheckedUpdateWithoutAppointmentTypeInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUncheckedUpdateWithoutClinicEmployeeInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUncheckedUpdateWithoutRoomInput = {
  appoinmentTypeId?: Maybe<Scalars['String']>;
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUpdateInput = {
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutProviderAppointmentTypeRoomMapNestedInput>;
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneRequiredWithoutProviderAppointmentTypeRoomMapNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  room?: Maybe<ClinicRoomUpdateOneRequiredWithoutProviderAppointmentTypeRoomMapNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUpdateManyWithWhereWithoutAppointmentTypeInput = {
  data: ProviderAppointmentTypeRoomMapUpdateManyMutationInput;
  where: ProviderAppointmentTypeRoomMapScalarWhereInput;
};

export type ProviderAppointmentTypeRoomMapUpdateManyWithWhereWithoutClinicEmployeeInput = {
  data: ProviderAppointmentTypeRoomMapUpdateManyMutationInput;
  where: ProviderAppointmentTypeRoomMapScalarWhereInput;
};

export type ProviderAppointmentTypeRoomMapUpdateManyWithWhereWithoutRoomInput = {
  data: ProviderAppointmentTypeRoomMapUpdateManyMutationInput;
  where: ProviderAppointmentTypeRoomMapScalarWhereInput;
};

export type ProviderAppointmentTypeRoomMapUpdateManyWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<ProviderAppointmentTypeRoomMapCreateManyAppointmentTypeInputEnvelope>;
  delete?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProviderAppointmentTypeRoomMapScalarWhereInput>>;
  disconnect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  set?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  update?: Maybe<Array<ProviderAppointmentTypeRoomMapUpdateWithWhereUniqueWithoutAppointmentTypeInput>>;
  updateMany?: Maybe<Array<ProviderAppointmentTypeRoomMapUpdateManyWithWhereWithoutAppointmentTypeInput>>;
  upsert?: Maybe<Array<ProviderAppointmentTypeRoomMapUpsertWithWhereUniqueWithoutAppointmentTypeInput>>;
};

export type ProviderAppointmentTypeRoomMapUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<ProviderAppointmentTypeRoomMapCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProviderAppointmentTypeRoomMapScalarWhereInput>>;
  disconnect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  set?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  update?: Maybe<Array<ProviderAppointmentTypeRoomMapUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<ProviderAppointmentTypeRoomMapUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<ProviderAppointmentTypeRoomMapUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type ProviderAppointmentTypeRoomMapUpdateManyWithoutRoomNestedInput = {
  connect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateOrConnectWithoutRoomInput>>;
  create?: Maybe<Array<ProviderAppointmentTypeRoomMapCreateWithoutRoomInput>>;
  createMany?: Maybe<ProviderAppointmentTypeRoomMapCreateManyRoomInputEnvelope>;
  delete?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ProviderAppointmentTypeRoomMapScalarWhereInput>>;
  disconnect?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  set?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereUniqueInput>>;
  update?: Maybe<Array<ProviderAppointmentTypeRoomMapUpdateWithWhereUniqueWithoutRoomInput>>;
  updateMany?: Maybe<Array<ProviderAppointmentTypeRoomMapUpdateManyWithWhereWithoutRoomInput>>;
  upsert?: Maybe<Array<ProviderAppointmentTypeRoomMapUpsertWithWhereUniqueWithoutRoomInput>>;
};

export type ProviderAppointmentTypeRoomMapUpdateWithWhereUniqueWithoutAppointmentTypeInput = {
  data: ProviderAppointmentTypeRoomMapUpdateWithoutAppointmentTypeInput;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};

export type ProviderAppointmentTypeRoomMapUpdateWithWhereUniqueWithoutClinicEmployeeInput = {
  data: ProviderAppointmentTypeRoomMapUpdateWithoutClinicEmployeeInput;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};

export type ProviderAppointmentTypeRoomMapUpdateWithWhereUniqueWithoutRoomInput = {
  data: ProviderAppointmentTypeRoomMapUpdateWithoutRoomInput;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};

export type ProviderAppointmentTypeRoomMapUpdateWithoutAppointmentTypeInput = {
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneRequiredWithoutProviderAppointmentTypeRoomMapNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  room?: Maybe<ClinicRoomUpdateOneRequiredWithoutProviderAppointmentTypeRoomMapNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUpdateWithoutClinicEmployeeInput = {
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutProviderAppointmentTypeRoomMapNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  room?: Maybe<ClinicRoomUpdateOneRequiredWithoutProviderAppointmentTypeRoomMapNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUpdateWithoutRoomInput = {
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutProviderAppointmentTypeRoomMapNestedInput>;
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneRequiredWithoutProviderAppointmentTypeRoomMapNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderAppointmentTypeRoomMapUpsertWithWhereUniqueWithoutAppointmentTypeInput = {
  create: ProviderAppointmentTypeRoomMapCreateWithoutAppointmentTypeInput;
  update: ProviderAppointmentTypeRoomMapUpdateWithoutAppointmentTypeInput;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};

export type ProviderAppointmentTypeRoomMapUpsertWithWhereUniqueWithoutClinicEmployeeInput = {
  create: ProviderAppointmentTypeRoomMapCreateWithoutClinicEmployeeInput;
  update: ProviderAppointmentTypeRoomMapUpdateWithoutClinicEmployeeInput;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};

export type ProviderAppointmentTypeRoomMapUpsertWithWhereUniqueWithoutRoomInput = {
  create: ProviderAppointmentTypeRoomMapCreateWithoutRoomInput;
  update: ProviderAppointmentTypeRoomMapUpdateWithoutRoomInput;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};

export type ProviderAppointmentTypeRoomMapWhereInput = {
  AND?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereInput>>;
  NOT?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereInput>>;
  OR?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereInput>>;
  appoinmentTypeId?: Maybe<StringNullableFilter>;
  appointmentType?: Maybe<AppointmentTypeNullableScalarRelationFilter>;
  clinicEmployee?: Maybe<ClinicEmployeeScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  room?: Maybe<ClinicRoomScalarRelationFilter>;
  roomId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ProviderAppointmentTypeRoomMapWhereUniqueInput = {
  AND?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereInput>>;
  NOT?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereInput>>;
  OR?: Maybe<Array<ProviderAppointmentTypeRoomMapWhereInput>>;
  appoinmentTypeId?: Maybe<StringNullableFilter>;
  appointmentType?: Maybe<AppointmentTypeNullableScalarRelationFilter>;
  clinicEmployee?: Maybe<ClinicEmployeeScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringFilter>;
  clinicEmployeeId_appoinmentTypeId_roomId?: Maybe<ProviderAppointmentTypeRoomMapClinicEmployeeIdAppoinmentTypeIdRoomIdCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  room?: Maybe<ClinicRoomScalarRelationFilter>;
  roomId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum PushNotificationDeliveryErrorType {
  AuthorizationError = 'AuthorizationError',
  EndpointDisabled = 'EndpointDisabled',
  InternalError = 'InternalError',
  InvalidParameter = 'InvalidParameter',
  Unknown = 'Unknown'
}

export type PushNotificationLog = {
  __typename?: 'PushNotificationLog';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDevice: ClinicPetParentDevice;
  clinicPetParentDeviceId: Scalars['String'];
  clinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** Our categorization of the error */
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id: Scalars['String'];
  /** the error message given by the provider */
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessage>;
  /** optionally included: the channel associated with this notification */
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefund?: Maybe<StripeRefund>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type PushNotificationLogAppointmentArgs = {
  where?: Maybe<AppointmentWhereInput>;
};


export type PushNotificationLogClinicWidgetRequestArgs = {
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type PushNotificationLogSentChannelMessageArgs = {
  where?: Maybe<ChannelMessageWhereInput>;
};


export type PushNotificationLogStripeRefundArgs = {
  where?: Maybe<StripeRefundWhereInput>;
};

export type PushNotificationLogCountAggregateOutputType = {
  __typename?: 'PushNotificationLogCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentId: Scalars['Int'];
  clinicPetParentDeviceId: Scalars['Int'];
  clinicWidgetRequestId: Scalars['Int'];
  createdAt: Scalars['Int'];
  errorType: Scalars['Int'];
  id: Scalars['Int'];
  providerErrorData: Scalars['Int'];
  sentChannelMessageId: Scalars['Int'];
  status: Scalars['Int'];
  stripeRefundId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PushNotificationLogCountOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  clinicPetParentDeviceId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  sentChannelMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PushNotificationLogCreateInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutPushNotificationLogsInput>;
  clinicPetParentDevice: ClinicPetParentDeviceCreateNestedOneWithoutPushNotificationLogsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutPushNotificationLogsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessageCreateNestedOneWithoutPushNotificationLogsInput>;
  status: PushNotificationLogStatusType;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutPushNotificationLogsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogCreateManyAppointmentInput = {
  clinicPetParentDeviceId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogCreateManyAppointmentInputEnvelope = {
  data: Array<PushNotificationLogCreateManyAppointmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PushNotificationLogCreateManyClinicPetParentDeviceInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogCreateManyClinicPetParentDeviceInputEnvelope = {
  data: Array<PushNotificationLogCreateManyClinicPetParentDeviceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PushNotificationLogCreateManyClinicWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogCreateManyClinicWidgetRequestInputEnvelope = {
  data: Array<PushNotificationLogCreateManyClinicWidgetRequestInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PushNotificationLogCreateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogCreateManySentChannelMessageInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogCreateManySentChannelMessageInputEnvelope = {
  data: Array<PushNotificationLogCreateManySentChannelMessageInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PushNotificationLogCreateManyStripeRefundInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogCreateManyStripeRefundInputEnvelope = {
  data: Array<PushNotificationLogCreateManyStripeRefundInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PushNotificationLogCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutAppointmentInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyAppointmentInputEnvelope>;
};

export type PushNotificationLogCreateNestedManyWithoutClinicPetParentDeviceInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutClinicPetParentDeviceInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutClinicPetParentDeviceInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyClinicPetParentDeviceInputEnvelope>;
};

export type PushNotificationLogCreateNestedManyWithoutClinicWidgetRequestInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyClinicWidgetRequestInputEnvelope>;
};

export type PushNotificationLogCreateNestedManyWithoutSentChannelMessageInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutSentChannelMessageInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutSentChannelMessageInput>>;
  createMany?: Maybe<PushNotificationLogCreateManySentChannelMessageInputEnvelope>;
};

export type PushNotificationLogCreateNestedManyWithoutStripeRefundInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutStripeRefundInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutStripeRefundInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyStripeRefundInputEnvelope>;
};

export type PushNotificationLogCreateOrConnectWithoutAppointmentInput = {
  create: PushNotificationLogCreateWithoutAppointmentInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogCreateOrConnectWithoutClinicPetParentDeviceInput = {
  create: PushNotificationLogCreateWithoutClinicPetParentDeviceInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogCreateOrConnectWithoutClinicWidgetRequestInput = {
  create: PushNotificationLogCreateWithoutClinicWidgetRequestInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogCreateOrConnectWithoutSentChannelMessageInput = {
  create: PushNotificationLogCreateWithoutSentChannelMessageInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogCreateOrConnectWithoutStripeRefundInput = {
  create: PushNotificationLogCreateWithoutStripeRefundInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogCreateWithoutAppointmentInput = {
  clinicPetParentDevice: ClinicPetParentDeviceCreateNestedOneWithoutPushNotificationLogsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutPushNotificationLogsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessageCreateNestedOneWithoutPushNotificationLogsInput>;
  status: PushNotificationLogStatusType;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutPushNotificationLogsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogCreateWithoutClinicPetParentDeviceInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutPushNotificationLogsInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutPushNotificationLogsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessageCreateNestedOneWithoutPushNotificationLogsInput>;
  status: PushNotificationLogStatusType;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutPushNotificationLogsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogCreateWithoutClinicWidgetRequestInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutPushNotificationLogsInput>;
  clinicPetParentDevice: ClinicPetParentDeviceCreateNestedOneWithoutPushNotificationLogsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessageCreateNestedOneWithoutPushNotificationLogsInput>;
  status: PushNotificationLogStatusType;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutPushNotificationLogsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogCreateWithoutSentChannelMessageInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutPushNotificationLogsInput>;
  clinicPetParentDevice: ClinicPetParentDeviceCreateNestedOneWithoutPushNotificationLogsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutPushNotificationLogsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefund?: Maybe<StripeRefundCreateNestedOneWithoutPushNotificationLogsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogCreateWithoutStripeRefundInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutPushNotificationLogsInput>;
  clinicPetParentDevice: ClinicPetParentDeviceCreateNestedOneWithoutPushNotificationLogsInput;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutPushNotificationLogsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessageCreateNestedOneWithoutPushNotificationLogsInput>;
  status: PushNotificationLogStatusType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogGroupByOutputType = {
  __typename?: 'PushNotificationLogGroupByOutputType';
  _count?: Maybe<PushNotificationLogCountAggregateOutputType>;
  _max?: Maybe<PushNotificationLogMaxAggregateOutputType>;
  _min?: Maybe<PushNotificationLogMinAggregateOutputType>;
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id: Scalars['String'];
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PushNotificationLogListRelationFilter = {
  every?: Maybe<PushNotificationLogWhereInput>;
  none?: Maybe<PushNotificationLogWhereInput>;
  some?: Maybe<PushNotificationLogWhereInput>;
};

export type PushNotificationLogMaxAggregateOutputType = {
  __typename?: 'PushNotificationLogMaxAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogMaxOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  clinicPetParentDeviceId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  sentChannelMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PushNotificationLogMinAggregateOutputType = {
  __typename?: 'PushNotificationLogMinAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogMinOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  clinicPetParentDeviceId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  sentChannelMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PushNotificationLogOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PushNotificationLogOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PushNotificationLogOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  clinicPetParentDevice?: Maybe<ClinicPetParentDeviceOrderByWithRelationInput>;
  clinicPetParentDeviceId?: Maybe<SortOrder>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  sentChannelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  sentChannelMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeRefund?: Maybe<StripeRefundOrderByWithRelationInput>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PushNotificationLogOrderByRelevanceFieldEnum {
  AppointmentId = 'appointmentId',
  ClinicPetParentDeviceId = 'clinicPetParentDeviceId',
  ClinicWidgetRequestId = 'clinicWidgetRequestId',
  Id = 'id',
  ProviderErrorData = 'providerErrorData',
  SentChannelMessageId = 'sentChannelMessageId',
  StripeRefundId = 'stripeRefundId'
}

export type PushNotificationLogOrderByRelevanceInput = {
  fields: Array<PushNotificationLogOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type PushNotificationLogOrderByWithAggregationInput = {
  _count?: Maybe<PushNotificationLogCountOrderByAggregateInput>;
  _max?: Maybe<PushNotificationLogMaxOrderByAggregateInput>;
  _min?: Maybe<PushNotificationLogMinOrderByAggregateInput>;
  appointmentId?: Maybe<SortOrder>;
  clinicPetParentDeviceId?: Maybe<SortOrder>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  sentChannelMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PushNotificationLogOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<PushNotificationLogOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  clinicPetParentDevice?: Maybe<ClinicPetParentDeviceOrderByWithRelationInput>;
  clinicPetParentDeviceId?: Maybe<SortOrder>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  sentChannelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  sentChannelMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeRefund?: Maybe<StripeRefundOrderByWithRelationInput>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PushNotificationLogOrderByWithRelationInput = {
  _relevance?: Maybe<PushNotificationLogOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  clinicPetParentDevice?: Maybe<ClinicPetParentDeviceOrderByWithRelationInput>;
  clinicPetParentDeviceId?: Maybe<SortOrder>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  clinicWidgetRequestId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  sentChannelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  sentChannelMessageId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeRefund?: Maybe<StripeRefundOrderByWithRelationInput>;
  stripeRefundId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum PushNotificationLogScalarFieldEnum {
  AppointmentId = 'appointmentId',
  ClinicPetParentDeviceId = 'clinicPetParentDeviceId',
  ClinicWidgetRequestId = 'clinicWidgetRequestId',
  CreatedAt = 'createdAt',
  ErrorType = 'errorType',
  Id = 'id',
  ProviderErrorData = 'providerErrorData',
  SentChannelMessageId = 'sentChannelMessageId',
  Status = 'status',
  StripeRefundId = 'stripeRefundId',
  UpdatedAt = 'updatedAt'
}

export type PushNotificationLogScalarWhereInput = {
  AND?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  NOT?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  OR?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  appointmentId?: Maybe<StringNullableFilter>;
  clinicPetParentDeviceId?: Maybe<StringFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  errorType?: Maybe<EnumPushNotificationDeliveryErrorTypeNullableFilter>;
  id?: Maybe<StringFilter>;
  providerErrorData?: Maybe<StringNullableFilter>;
  sentChannelMessageId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumPushNotificationLogStatusTypeFilter>;
  stripeRefundId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PushNotificationLogScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PushNotificationLogScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PushNotificationLogScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PushNotificationLogScalarWhereWithAggregatesInput>>;
  appointmentId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetParentDeviceId?: Maybe<StringWithAggregatesFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  errorType?: Maybe<EnumPushNotificationDeliveryErrorTypeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  providerErrorData?: Maybe<StringNullableWithAggregatesFilter>;
  sentChannelMessageId?: Maybe<StringNullableWithAggregatesFilter>;
  status?: Maybe<EnumPushNotificationLogStatusTypeWithAggregatesFilter>;
  stripeRefundId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum PushNotificationLogStatusType {
  Error = 'Error',
  Sent = 'Sent'
}

export type PushNotificationLogUncheckedCreateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutAppointmentInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyAppointmentInputEnvelope>;
};

export type PushNotificationLogUncheckedCreateNestedManyWithoutClinicPetParentDeviceInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutClinicPetParentDeviceInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutClinicPetParentDeviceInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyClinicPetParentDeviceInputEnvelope>;
};

export type PushNotificationLogUncheckedCreateNestedManyWithoutClinicWidgetRequestInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyClinicWidgetRequestInputEnvelope>;
};

export type PushNotificationLogUncheckedCreateNestedManyWithoutSentChannelMessageInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutSentChannelMessageInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutSentChannelMessageInput>>;
  createMany?: Maybe<PushNotificationLogCreateManySentChannelMessageInputEnvelope>;
};

export type PushNotificationLogUncheckedCreateNestedManyWithoutStripeRefundInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutStripeRefundInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutStripeRefundInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyStripeRefundInputEnvelope>;
};

export type PushNotificationLogUncheckedCreateWithoutAppointmentInput = {
  clinicPetParentDeviceId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedCreateWithoutClinicPetParentDeviceInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedCreateWithoutClinicWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedCreateWithoutSentChannelMessageInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedCreateWithoutStripeRefundInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId: Scalars['String'];
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status: PushNotificationLogStatusType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedUpdateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedUpdateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedUpdateManyWithoutAppointmentInput = {
  clinicPetParentDeviceId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutAppointmentInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  disconnect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  set?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  update?: Maybe<Array<PushNotificationLogUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<PushNotificationLogUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<PushNotificationLogUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type PushNotificationLogUncheckedUpdateManyWithoutClinicPetParentDeviceInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedUpdateManyWithoutClinicPetParentDeviceNestedInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutClinicPetParentDeviceInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutClinicPetParentDeviceInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyClinicPetParentDeviceInputEnvelope>;
  delete?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  disconnect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  set?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  update?: Maybe<Array<PushNotificationLogUpdateWithWhereUniqueWithoutClinicPetParentDeviceInput>>;
  updateMany?: Maybe<Array<PushNotificationLogUpdateManyWithWhereWithoutClinicPetParentDeviceInput>>;
  upsert?: Maybe<Array<PushNotificationLogUpsertWithWhereUniqueWithoutClinicPetParentDeviceInput>>;
};

export type PushNotificationLogUncheckedUpdateManyWithoutClinicWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedUpdateManyWithoutClinicWidgetRequestNestedInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyClinicWidgetRequestInputEnvelope>;
  delete?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  disconnect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  set?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  update?: Maybe<Array<PushNotificationLogUpdateWithWhereUniqueWithoutClinicWidgetRequestInput>>;
  updateMany?: Maybe<Array<PushNotificationLogUpdateManyWithWhereWithoutClinicWidgetRequestInput>>;
  upsert?: Maybe<Array<PushNotificationLogUpsertWithWhereUniqueWithoutClinicWidgetRequestInput>>;
};

export type PushNotificationLogUncheckedUpdateManyWithoutSentChannelMessageInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedUpdateManyWithoutSentChannelMessageNestedInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutSentChannelMessageInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutSentChannelMessageInput>>;
  createMany?: Maybe<PushNotificationLogCreateManySentChannelMessageInputEnvelope>;
  delete?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  disconnect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  set?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  update?: Maybe<Array<PushNotificationLogUpdateWithWhereUniqueWithoutSentChannelMessageInput>>;
  updateMany?: Maybe<Array<PushNotificationLogUpdateManyWithWhereWithoutSentChannelMessageInput>>;
  upsert?: Maybe<Array<PushNotificationLogUpsertWithWhereUniqueWithoutSentChannelMessageInput>>;
};

export type PushNotificationLogUncheckedUpdateManyWithoutStripeRefundInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedUpdateManyWithoutStripeRefundNestedInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutStripeRefundInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutStripeRefundInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyStripeRefundInputEnvelope>;
  delete?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  disconnect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  set?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  update?: Maybe<Array<PushNotificationLogUpdateWithWhereUniqueWithoutStripeRefundInput>>;
  updateMany?: Maybe<Array<PushNotificationLogUpdateManyWithWhereWithoutStripeRefundInput>>;
  upsert?: Maybe<Array<PushNotificationLogUpsertWithWhereUniqueWithoutStripeRefundInput>>;
};

export type PushNotificationLogUncheckedUpdateWithoutAppointmentInput = {
  clinicPetParentDeviceId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedUpdateWithoutClinicPetParentDeviceInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedUpdateWithoutClinicWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedUpdateWithoutSentChannelMessageInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUncheckedUpdateWithoutStripeRefundInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicPetParentDeviceId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUpdateInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutPushNotificationLogsNestedInput>;
  clinicPetParentDevice?: Maybe<ClinicPetParentDeviceUpdateOneRequiredWithoutPushNotificationLogsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutPushNotificationLogsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessageUpdateOneWithoutPushNotificationLogsNestedInput>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutPushNotificationLogsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUpdateManyWithWhereWithoutAppointmentInput = {
  data: PushNotificationLogUpdateManyMutationInput;
  where: PushNotificationLogScalarWhereInput;
};

export type PushNotificationLogUpdateManyWithWhereWithoutClinicPetParentDeviceInput = {
  data: PushNotificationLogUpdateManyMutationInput;
  where: PushNotificationLogScalarWhereInput;
};

export type PushNotificationLogUpdateManyWithWhereWithoutClinicWidgetRequestInput = {
  data: PushNotificationLogUpdateManyMutationInput;
  where: PushNotificationLogScalarWhereInput;
};

export type PushNotificationLogUpdateManyWithWhereWithoutSentChannelMessageInput = {
  data: PushNotificationLogUpdateManyMutationInput;
  where: PushNotificationLogScalarWhereInput;
};

export type PushNotificationLogUpdateManyWithWhereWithoutStripeRefundInput = {
  data: PushNotificationLogUpdateManyMutationInput;
  where: PushNotificationLogScalarWhereInput;
};

export type PushNotificationLogUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutAppointmentInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  disconnect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  set?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  update?: Maybe<Array<PushNotificationLogUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<PushNotificationLogUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<PushNotificationLogUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type PushNotificationLogUpdateManyWithoutClinicPetParentDeviceNestedInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutClinicPetParentDeviceInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutClinicPetParentDeviceInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyClinicPetParentDeviceInputEnvelope>;
  delete?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  disconnect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  set?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  update?: Maybe<Array<PushNotificationLogUpdateWithWhereUniqueWithoutClinicPetParentDeviceInput>>;
  updateMany?: Maybe<Array<PushNotificationLogUpdateManyWithWhereWithoutClinicPetParentDeviceInput>>;
  upsert?: Maybe<Array<PushNotificationLogUpsertWithWhereUniqueWithoutClinicPetParentDeviceInput>>;
};

export type PushNotificationLogUpdateManyWithoutClinicWidgetRequestNestedInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutClinicWidgetRequestInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutClinicWidgetRequestInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyClinicWidgetRequestInputEnvelope>;
  delete?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  disconnect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  set?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  update?: Maybe<Array<PushNotificationLogUpdateWithWhereUniqueWithoutClinicWidgetRequestInput>>;
  updateMany?: Maybe<Array<PushNotificationLogUpdateManyWithWhereWithoutClinicWidgetRequestInput>>;
  upsert?: Maybe<Array<PushNotificationLogUpsertWithWhereUniqueWithoutClinicWidgetRequestInput>>;
};

export type PushNotificationLogUpdateManyWithoutSentChannelMessageNestedInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutSentChannelMessageInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutSentChannelMessageInput>>;
  createMany?: Maybe<PushNotificationLogCreateManySentChannelMessageInputEnvelope>;
  delete?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  disconnect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  set?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  update?: Maybe<Array<PushNotificationLogUpdateWithWhereUniqueWithoutSentChannelMessageInput>>;
  updateMany?: Maybe<Array<PushNotificationLogUpdateManyWithWhereWithoutSentChannelMessageInput>>;
  upsert?: Maybe<Array<PushNotificationLogUpsertWithWhereUniqueWithoutSentChannelMessageInput>>;
};

export type PushNotificationLogUpdateManyWithoutStripeRefundNestedInput = {
  connect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PushNotificationLogCreateOrConnectWithoutStripeRefundInput>>;
  create?: Maybe<Array<PushNotificationLogCreateWithoutStripeRefundInput>>;
  createMany?: Maybe<PushNotificationLogCreateManyStripeRefundInputEnvelope>;
  delete?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PushNotificationLogScalarWhereInput>>;
  disconnect?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  set?: Maybe<Array<PushNotificationLogWhereUniqueInput>>;
  update?: Maybe<Array<PushNotificationLogUpdateWithWhereUniqueWithoutStripeRefundInput>>;
  updateMany?: Maybe<Array<PushNotificationLogUpdateManyWithWhereWithoutStripeRefundInput>>;
  upsert?: Maybe<Array<PushNotificationLogUpsertWithWhereUniqueWithoutStripeRefundInput>>;
};

export type PushNotificationLogUpdateWithWhereUniqueWithoutAppointmentInput = {
  data: PushNotificationLogUpdateWithoutAppointmentInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogUpdateWithWhereUniqueWithoutClinicPetParentDeviceInput = {
  data: PushNotificationLogUpdateWithoutClinicPetParentDeviceInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogUpdateWithWhereUniqueWithoutClinicWidgetRequestInput = {
  data: PushNotificationLogUpdateWithoutClinicWidgetRequestInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogUpdateWithWhereUniqueWithoutSentChannelMessageInput = {
  data: PushNotificationLogUpdateWithoutSentChannelMessageInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogUpdateWithWhereUniqueWithoutStripeRefundInput = {
  data: PushNotificationLogUpdateWithoutStripeRefundInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogUpdateWithoutAppointmentInput = {
  clinicPetParentDevice?: Maybe<ClinicPetParentDeviceUpdateOneRequiredWithoutPushNotificationLogsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutPushNotificationLogsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessageUpdateOneWithoutPushNotificationLogsNestedInput>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutPushNotificationLogsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUpdateWithoutClinicPetParentDeviceInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutPushNotificationLogsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutPushNotificationLogsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessageUpdateOneWithoutPushNotificationLogsNestedInput>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutPushNotificationLogsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUpdateWithoutClinicWidgetRequestInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutPushNotificationLogsNestedInput>;
  clinicPetParentDevice?: Maybe<ClinicPetParentDeviceUpdateOneRequiredWithoutPushNotificationLogsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessageUpdateOneWithoutPushNotificationLogsNestedInput>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutPushNotificationLogsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUpdateWithoutSentChannelMessageInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutPushNotificationLogsNestedInput>;
  clinicPetParentDevice?: Maybe<ClinicPetParentDeviceUpdateOneRequiredWithoutPushNotificationLogsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutPushNotificationLogsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  status?: Maybe<PushNotificationLogStatusType>;
  stripeRefund?: Maybe<StripeRefundUpdateOneWithoutPushNotificationLogsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUpdateWithoutStripeRefundInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutPushNotificationLogsNestedInput>;
  clinicPetParentDevice?: Maybe<ClinicPetParentDeviceUpdateOneRequiredWithoutPushNotificationLogsNestedInput>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutPushNotificationLogsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorType?: Maybe<PushNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessageUpdateOneWithoutPushNotificationLogsNestedInput>;
  status?: Maybe<PushNotificationLogStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PushNotificationLogUpsertWithWhereUniqueWithoutAppointmentInput = {
  create: PushNotificationLogCreateWithoutAppointmentInput;
  update: PushNotificationLogUpdateWithoutAppointmentInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogUpsertWithWhereUniqueWithoutClinicPetParentDeviceInput = {
  create: PushNotificationLogCreateWithoutClinicPetParentDeviceInput;
  update: PushNotificationLogUpdateWithoutClinicPetParentDeviceInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogUpsertWithWhereUniqueWithoutClinicWidgetRequestInput = {
  create: PushNotificationLogCreateWithoutClinicWidgetRequestInput;
  update: PushNotificationLogUpdateWithoutClinicWidgetRequestInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogUpsertWithWhereUniqueWithoutSentChannelMessageInput = {
  create: PushNotificationLogCreateWithoutSentChannelMessageInput;
  update: PushNotificationLogUpdateWithoutSentChannelMessageInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogUpsertWithWhereUniqueWithoutStripeRefundInput = {
  create: PushNotificationLogCreateWithoutStripeRefundInput;
  update: PushNotificationLogUpdateWithoutStripeRefundInput;
  where: PushNotificationLogWhereUniqueInput;
};

export type PushNotificationLogWhereInput = {
  AND?: Maybe<Array<PushNotificationLogWhereInput>>;
  NOT?: Maybe<Array<PushNotificationLogWhereInput>>;
  OR?: Maybe<Array<PushNotificationLogWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  clinicPetParentDevice?: Maybe<ClinicPetParentDeviceScalarRelationFilter>;
  clinicPetParentDeviceId?: Maybe<StringFilter>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  errorType?: Maybe<EnumPushNotificationDeliveryErrorTypeNullableFilter>;
  id?: Maybe<StringFilter>;
  providerErrorData?: Maybe<StringNullableFilter>;
  sentChannelMessage?: Maybe<ChannelMessageNullableScalarRelationFilter>;
  sentChannelMessageId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumPushNotificationLogStatusTypeFilter>;
  stripeRefund?: Maybe<StripeRefundNullableScalarRelationFilter>;
  stripeRefundId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PushNotificationLogWhereUniqueInput = {
  AND?: Maybe<Array<PushNotificationLogWhereInput>>;
  NOT?: Maybe<Array<PushNotificationLogWhereInput>>;
  OR?: Maybe<Array<PushNotificationLogWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  clinicPetParentDevice?: Maybe<ClinicPetParentDeviceScalarRelationFilter>;
  clinicPetParentDeviceId?: Maybe<StringFilter>;
  clinicWidgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  clinicWidgetRequestId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  errorType?: Maybe<EnumPushNotificationDeliveryErrorTypeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  providerErrorData?: Maybe<StringNullableFilter>;
  sentChannelMessage?: Maybe<ChannelMessageNullableScalarRelationFilter>;
  sentChannelMessageId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumPushNotificationLogStatusTypeFilter>;
  stripeRefund?: Maybe<StripeRefundNullableScalarRelationFilter>;
  stripeRefundId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum PushNotificationStatus {
  Blocked = 'BLOCKED',
  Denied = 'DENIED',
  Granted = 'GRANTED',
  Limited = 'LIMITED',
  Unavailable = 'UNAVAILABLE',
  Undetermined = 'UNDETERMINED'
}

export type Query = {
  __typename?: 'Query';
  aggregateActiveIngredient?: Maybe<AggregateActiveIngredient>;
  aggregateAiRecapPimsWritebackLogEntry?: Maybe<AggregateAiRecapPimsWritebackLogEntry>;
  aggregateAppointment?: Maybe<AggregateAppointment>;
  aggregateAppointmentAvailability?: Maybe<AggregateAppointmentAvailability>;
  aggregateAppointmentNoteTemplate?: Maybe<AggregateAppointmentNoteTemplate>;
  aggregateAppointmentType?: Maybe<AggregateAppointmentType>;
  aggregateAutomationRun?: Maybe<AggregateAutomationRun>;
  aggregateAutomationRunAction?: Maybe<AggregateAutomationRunAction>;
  aggregateAxionClinicConfiguration?: Maybe<AggregateAxionClinicConfiguration>;
  aggregateAxionClinicUserConfiguration?: Maybe<AggregateAxionClinicUserConfiguration>;
  aggregateBedrockInference?: Maybe<AggregateBedrockInference>;
  aggregateBitwerxHealthcheck?: Maybe<AggregateBitwerxHealthcheck>;
  aggregateBitwerxIntegration?: Maybe<AggregateBitwerxIntegration>;
  aggregateBitwerxPaymentHealthcheckResult?: Maybe<AggregateBitwerxPaymentHealthcheckResult>;
  aggregateBitwerxPaymentHealthcheckRun?: Maybe<AggregateBitwerxPaymentHealthcheckRun>;
  aggregateBoardFilterColumn?: Maybe<AggregateBoardFilterColumn>;
  aggregateBoardFilterSpecificDateRange?: Maybe<AggregateBoardFilterSpecificDateRange>;
  aggregateBoehringerIngelheimCustomerAlignment?: Maybe<AggregateBoehringerIngelheimCustomerAlignment>;
  aggregateBoehringerIngelheimTerritory?: Maybe<AggregateBoehringerIngelheimTerritory>;
  aggregateBreed?: Maybe<AggregateBreed>;
  aggregateCallHistory?: Maybe<AggregateCallHistory>;
  aggregateCallParticipant?: Maybe<AggregateCallParticipant>;
  aggregateCallRecording?: Maybe<AggregateCallRecording>;
  aggregateCampaignRegistryCampaign?: Maybe<AggregateCampaignRegistryCampaign>;
  aggregateCanonicalBreed?: Maybe<AggregateCanonicalBreed>;
  aggregateCanonicalCanineBreedProfile?: Maybe<AggregateCanonicalCanineBreedProfile>;
  aggregateCanonicalService?: Maybe<AggregateCanonicalService>;
  aggregateCanonicalSpecies?: Maybe<AggregateCanonicalSpecies>;
  aggregateCareAccountCreditIntent?: Maybe<AggregateCareAccountCreditIntent>;
  aggregateCareAccountCreditPimsWritebackLogEntry?: Maybe<AggregateCareAccountCreditPimsWritebackLogEntry>;
  aggregateCareAddonEnrollment?: Maybe<AggregateCareAddonEnrollment>;
  aggregateCareAddonPackage?: Maybe<AggregateCareAddonPackage>;
  aggregateCareAddonPackageBenefit?: Maybe<AggregateCareAddonPackageBenefit>;
  aggregateCareAuthorizationRequest?: Maybe<AggregateCareAuthorizationRequest>;
  aggregateCareBenefit?: Maybe<AggregateCareBenefit>;
  aggregateCareBenefitUsage?: Maybe<AggregateCareBenefitUsage>;
  aggregateCareBenefitUsageFollowup?: Maybe<AggregateCareBenefitUsageFollowup>;
  aggregateCareBenefitUsageFollowupStep?: Maybe<AggregateCareBenefitUsageFollowupStep>;
  aggregateCareBenefitUsageToInvoiceLineItem?: Maybe<AggregateCareBenefitUsageToInvoiceLineItem>;
  aggregateCareCreditPreapprovalCheck?: Maybe<AggregateCareCreditPreapprovalCheck>;
  aggregateCareEnrollmentPayment?: Maybe<AggregateCareEnrollmentPayment>;
  aggregateCareEnrollmentToStripeInvoiceItem?: Maybe<AggregateCareEnrollmentToStripeInvoiceItem>;
  aggregateCareLapsedPayment?: Maybe<AggregateCareLapsedPayment>;
  aggregateCarePlan?: Maybe<AggregateCarePlan>;
  aggregateCarePlanBenefit?: Maybe<AggregateCarePlanBenefit>;
  aggregateCarePlanBenefitEnrollmentCarryover?: Maybe<AggregateCarePlanBenefitEnrollmentCarryover>;
  aggregateCarePlanEnrollment?: Maybe<AggregateCarePlanEnrollment>;
  aggregateCarePlanPricing?: Maybe<AggregateCarePlanPricing>;
  aggregateCarePlanProviderGroup?: Maybe<AggregateCarePlanProviderGroup>;
  aggregateCareStripeSubscription?: Maybe<AggregateCareStripeSubscription>;
  aggregateCareSubscriptionTrueUp?: Maybe<AggregateCareSubscriptionTrueUp>;
  aggregateCareSubscriptionTrueUpLogEntry?: Maybe<AggregateCareSubscriptionTrueUpLogEntry>;
  aggregateChannel?: Maybe<AggregateChannel>;
  aggregateChannelAutomationStatus?: Maybe<AggregateChannelAutomationStatus>;
  aggregateChannelCreationSource?: Maybe<AggregateChannelCreationSource>;
  aggregateChannelFilterSelection?: Maybe<AggregateChannelFilterSelection>;
  aggregateChannelMember?: Maybe<AggregateChannelMember>;
  aggregateChannelMessage?: Maybe<AggregateChannelMessage>;
  aggregateChannelMessageAttachment?: Maybe<AggregateChannelMessageAttachment>;
  aggregateChannelMessageAutoResponse?: Maybe<AggregateChannelMessageAutoResponse>;
  aggregateChannelMessageReaction?: Maybe<AggregateChannelMessageReaction>;
  aggregateChannelPin?: Maybe<AggregateChannelPin>;
  aggregateChannelSelection?: Maybe<AggregateChannelSelection>;
  aggregateChannelStatus?: Maybe<AggregateChannelStatus>;
  aggregateChannelStatusChannelAssignee?: Maybe<AggregateChannelStatusChannelAssignee>;
  aggregateChemicalCompound?: Maybe<AggregateChemicalCompound>;
  aggregateClientConnectIntegration?: Maybe<AggregateClientConnectIntegration>;
  aggregateClinic?: Maybe<AggregateClinic>;
  aggregateClinicBlockedPhoneNumber?: Maybe<AggregateClinicBlockedPhoneNumber>;
  aggregateClinicCustomPayoutsSetup?: Maybe<AggregateClinicCustomPayoutsSetup>;
  aggregateClinicDirectBookingSetting?: Maybe<AggregateClinicDirectBookingSetting>;
  aggregateClinicEmailCampaignSetting?: Maybe<AggregateClinicEmailCampaignSetting>;
  aggregateClinicEmployee?: Maybe<AggregateClinicEmployee>;
  aggregateClinicEmployeeAppointmentTypeSetting?: Maybe<AggregateClinicEmployeeAppointmentTypeSetting>;
  aggregateClinicEntityPhoneNumber?: Maybe<AggregateClinicEntityPhoneNumber>;
  aggregateClinicModule?: Maybe<AggregateClinicModule>;
  aggregateClinicOfficeHour?: Maybe<AggregateClinicOfficeHour>;
  aggregateClinicOnboarding?: Maybe<AggregateClinicOnboarding>;
  aggregateClinicPaymentFeeConfiguration?: Maybe<AggregateClinicPaymentFeeConfiguration>;
  aggregateClinicPet?: Maybe<AggregateClinicPet>;
  aggregateClinicPetAlert?: Maybe<AggregateClinicPetAlert>;
  aggregateClinicPetCustomFieldValue?: Maybe<AggregateClinicPetCustomFieldValue>;
  aggregateClinicPetParent?: Maybe<AggregateClinicPetParent>;
  aggregateClinicPetParentAddress?: Maybe<AggregateClinicPetParentAddress>;
  aggregateClinicPetParentCustomFieldValue?: Maybe<AggregateClinicPetParentCustomFieldValue>;
  aggregateClinicPetParentDevice?: Maybe<AggregateClinicPetParentDevice>;
  aggregateClinicPetParentPimsSyncStatus?: Maybe<AggregateClinicPetParentPimsSyncStatus>;
  aggregateClinicPetPimsSyncStatus?: Maybe<AggregateClinicPetPimsSyncStatus>;
  aggregateClinicPhoneNumber?: Maybe<AggregateClinicPhoneNumber>;
  aggregateClinicPimsIntegration?: Maybe<AggregateClinicPimsIntegration>;
  aggregateClinicPimsIntegrationCapability?: Maybe<AggregateClinicPimsIntegrationCapability>;
  aggregateClinicPimsIntegrationCapabilityHistoryEntry?: Maybe<AggregateClinicPimsIntegrationCapabilityHistoryEntry>;
  aggregateClinicPostcardSetting?: Maybe<AggregateClinicPostcardSetting>;
  aggregateClinicRoom?: Maybe<AggregateClinicRoom>;
  aggregateClinicSetting?: Maybe<AggregateClinicSetting>;
  aggregateClinicUserFilter?: Maybe<AggregateClinicUserFilter>;
  aggregateClinicWidgetRequest?: Maybe<AggregateClinicWidgetRequest>;
  aggregateClinicWidgetRequestType?: Maybe<AggregateClinicWidgetRequestType>;
  aggregateClinicWidgetSetting?: Maybe<AggregateClinicWidgetSetting>;
  aggregateColor?: Maybe<AggregateColor>;
  aggregateCondition?: Maybe<AggregateCondition>;
  aggregateConditionSet?: Maybe<AggregateConditionSet>;
  aggregateConditionalEntityEvaluation?: Maybe<AggregateConditionalEntityEvaluation>;
  aggregateConsultation?: Maybe<AggregateConsultation>;
  aggregateConsultationRequest?: Maybe<AggregateConsultationRequest>;
  aggregateCustomFieldDefinition?: Maybe<AggregateCustomFieldDefinition>;
  aggregateCustomFieldPimsWritebackLogEntry?: Maybe<AggregateCustomFieldPimsWritebackLogEntry>;
  aggregateDirectBookingAppointmentTypeSetting?: Maybe<AggregateDirectBookingAppointmentTypeSetting>;
  aggregateDisbursement?: Maybe<AggregateDisbursement>;
  aggregateDocumentation?: Maybe<AggregateDocumentation>;
  aggregateEmailCampaign?: Maybe<AggregateEmailCampaign>;
  aggregateEmailCampaignCustomList?: Maybe<AggregateEmailCampaignCustomList>;
  aggregateEmailCampaignCustomListRecipient?: Maybe<AggregateEmailCampaignCustomListRecipient>;
  aggregateEmailCampaignCustomListUploadHistory?: Maybe<AggregateEmailCampaignCustomListUploadHistory>;
  aggregateEmailCampaignLog?: Maybe<AggregateEmailCampaignLog>;
  aggregateEmailCampaignTemplate?: Maybe<AggregateEmailCampaignTemplate>;
  aggregateEmailCampaignUnsubscribe?: Maybe<AggregateEmailCampaignUnsubscribe>;
  aggregateEmailProviderLog?: Maybe<AggregateEmailProviderLog>;
  aggregateEmergencyClinics?: Maybe<AggregateEmergencyClinics>;
  aggregateEncryptedClinicUpload?: Maybe<AggregateEncryptedClinicUpload>;
  aggregateEnrollmentSupportEvent?: Maybe<AggregateEnrollmentSupportEvent>;
  aggregateEzyVetIntegration?: Maybe<AggregateEzyVetIntegration>;
  aggregateFeatureFlag?: Maybe<AggregateFeatureFlag>;
  aggregateFinancialAdjustment?: Maybe<AggregateFinancialAdjustment>;
  aggregateFinancialTransaction?: Maybe<AggregateFinancialTransaction>;
  aggregateFormSubmission?: Maybe<AggregateFormSubmission>;
  aggregateFormTemplate?: Maybe<AggregateFormTemplate>;
  aggregateGlobalPetParent?: Maybe<AggregateGlobalPetParent>;
  aggregateGooglePlace?: Maybe<AggregateGooglePlace>;
  aggregateHillsToHomeAPILog?: Maybe<AggregateHillsToHomeApiLog>;
  aggregateInformAudienceDefinition?: Maybe<AggregateInformAudienceDefinition>;
  aggregateInformAudienceMember?: Maybe<AggregateInformAudienceMember>;
  aggregateInformAudienceMemberMessage?: Maybe<AggregateInformAudienceMemberMessage>;
  aggregateInformAutomationCampaign?: Maybe<AggregateInformAutomationCampaign>;
  aggregateInformCampaign?: Maybe<AggregateInformCampaign>;
  aggregateInformCampaignEnrollment?: Maybe<AggregateInformCampaignEnrollment>;
  aggregateInformCampaignEnrollmentCanonicalService?: Maybe<AggregateInformCampaignEnrollmentCanonicalService>;
  aggregateInformCampaignExecution?: Maybe<AggregateInformCampaignExecution>;
  aggregateInformCampaignGroup?: Maybe<AggregateInformCampaignGroup>;
  aggregateInformCommunicationOptOut?: Maybe<AggregateInformCommunicationOptOut>;
  aggregateInformControlGroupParticipant?: Maybe<AggregateInformControlGroupParticipant>;
  aggregateInformEmailTemplate?: Maybe<AggregateInformEmailTemplate>;
  aggregateInformEntityHistory?: Maybe<AggregateInformEntityHistory>;
  aggregateInformEventDrivenCampaign?: Maybe<AggregateInformEventDrivenCampaign>;
  aggregateInformEventListener?: Maybe<AggregateInformEventListener>;
  aggregateInformNotificationRecipient?: Maybe<AggregateInformNotificationRecipient>;
  aggregateInformPartner?: Maybe<AggregateInformPartner>;
  aggregateInformPartnerCustomer?: Maybe<AggregateInformPartnerCustomer>;
  aggregateInformPartnerCustomerPharmacyProvider?: Maybe<AggregateInformPartnerCustomerPharmacyProvider>;
  aggregateInformPartnerIntegration?: Maybe<AggregateInformPartnerIntegration>;
  aggregateInformPartnerIntegrationModel?: Maybe<AggregateInformPartnerIntegrationModel>;
  aggregateInformPartnerProgram?: Maybe<AggregateInformPartnerProgram>;
  aggregateInformPartnerProgramEnrollment?: Maybe<AggregateInformPartnerProgramEnrollment>;
  aggregateInformPartnerUser?: Maybe<AggregateInformPartnerUser>;
  aggregateInformPartnerUserRole?: Maybe<AggregateInformPartnerUserRole>;
  aggregateInformScheduledCampaign?: Maybe<AggregateInformScheduledCampaign>;
  aggregateInformSession?: Maybe<AggregateInformSession>;
  aggregateInformSessionEvent?: Maybe<AggregateInformSessionEvent>;
  aggregateInstinctIntegration?: Maybe<AggregateInstinctIntegration>;
  aggregateInsuranceIntegration?: Maybe<AggregateInsuranceIntegration>;
  aggregateIntegrationOutageHistoryEntry?: Maybe<AggregateIntegrationOutageHistoryEntry>;
  aggregateInterchangeRate?: Maybe<AggregateInterchangeRate>;
  aggregateInvoice?: Maybe<AggregateInvoice>;
  aggregateInvoiceLineItem?: Maybe<AggregateInvoiceLineItem>;
  aggregateInvoicePimsWritebackLogEntry?: Maybe<AggregateInvoicePimsWritebackLogEntry>;
  aggregateLabPanel?: Maybe<AggregateLabPanel>;
  aggregateLabResult?: Maybe<AggregateLabResult>;
  aggregateLapsedPetParentTriggers?: Maybe<AggregateLapsedPetParentTriggers>;
  aggregateLegalEntity?: Maybe<AggregateLegalEntity>;
  aggregateLoyaltyAccount?: Maybe<AggregateLoyaltyAccount>;
  aggregateLoyaltyAccountHolder?: Maybe<AggregateLoyaltyAccountHolder>;
  aggregateLoyaltyAccountMerger?: Maybe<AggregateLoyaltyAccountMerger>;
  aggregateLoyaltyInvoicePointGranter?: Maybe<AggregateLoyaltyInvoicePointGranter>;
  aggregateLoyaltyPointDelta?: Maybe<AggregateLoyaltyPointDelta>;
  aggregateLoyaltyPointGrantingService?: Maybe<AggregateLoyaltyPointGrantingService>;
  aggregateLoyaltyPointGrantingServiceCategory?: Maybe<AggregateLoyaltyPointGrantingServiceCategory>;
  aggregateLoyaltyPointUserGrant?: Maybe<AggregateLoyaltyPointUserGrant>;
  aggregateLoyaltyProgram?: Maybe<AggregateLoyaltyProgram>;
  aggregateLoyaltyProgramStatusHistory?: Maybe<AggregateLoyaltyProgramStatusHistory>;
  aggregateLoyaltyReward?: Maybe<AggregateLoyaltyReward>;
  aggregateLoyaltyRewardRedemption?: Maybe<AggregateLoyaltyRewardRedemption>;
  aggregateLoyaltyRewardRedemptionHistoryEntry?: Maybe<AggregateLoyaltyRewardRedemptionHistoryEntry>;
  aggregateMassTextAlert?: Maybe<AggregateMassTextAlert>;
  aggregateMassTextAlertEntry?: Maybe<AggregateMassTextAlertEntry>;
  aggregateMassTextAlertEntryAppointment?: Maybe<AggregateMassTextAlertEntryAppointment>;
  aggregateMedia?: Maybe<AggregateMedia>;
  aggregateMedicalHistory?: Maybe<AggregateMedicalHistory>;
  aggregateMessageTemplate?: Maybe<AggregateMessageTemplate>;
  aggregateMessagingCampaign?: Maybe<AggregateMessagingCampaign>;
  aggregateMessagingPartner?: Maybe<AggregateMessagingPartner>;
  aggregateModule?: Maybe<AggregateModule>;
  aggregateNonPrismaSchemaScriptRan?: Maybe<AggregateNonPrismaSchemaScriptRan>;
  aggregateNotificationEventToMessage?: Maybe<AggregateNotificationEventToMessage>;
  aggregateOrganization?: Maybe<AggregateOrganization>;
  aggregateOrganizationCareBenefitToClinicService?: Maybe<AggregateOrganizationCareBenefitToClinicService>;
  aggregateOrganizationCareBenefitToClinicServiceCategory?: Maybe<AggregateOrganizationCareBenefitToClinicServiceCategory>;
  aggregateOrganizationPet?: Maybe<AggregateOrganizationPet>;
  aggregateOrganizationPetParent?: Maybe<AggregateOrganizationPetParent>;
  aggregateOrganizationPetToOrganizationPetParent?: Maybe<AggregateOrganizationPetToOrganizationPetParent>;
  aggregatePPCIntegration?: Maybe<AggregatePpcIntegration>;
  aggregatePaymentsReportTransaction?: Maybe<AggregatePaymentsReportTransaction>;
  aggregatePayoutBatchingSchedule?: Maybe<AggregatePayoutBatchingSchedule>;
  aggregatePayoutBatchingSetting?: Maybe<AggregatePayoutBatchingSetting>;
  aggregatePermission?: Maybe<AggregatePermission>;
  aggregatePetParentSetting?: Maybe<AggregatePetParentSetting>;
  aggregatePetPortalSetting?: Maybe<AggregatePetPortalSetting>;
  aggregatePhoneNumberLookupRequest?: Maybe<AggregatePhoneNumberLookupRequest>;
  aggregatePhoneNumberLookupResult?: Maybe<AggregatePhoneNumberLookupResult>;
  aggregatePimsInvoice?: Maybe<AggregatePimsInvoice>;
  aggregatePimsInvoiceLineItem?: Maybe<AggregatePimsInvoiceLineItem>;
  aggregatePimsPaymentType?: Maybe<AggregatePimsPaymentType>;
  aggregatePimsWritebackLogEntry?: Maybe<AggregatePimsWritebackLogEntry>;
  aggregatePrescription?: Maybe<AggregatePrescription>;
  aggregateProduct?: Maybe<AggregateProduct>;
  aggregateProductPackage?: Maybe<AggregateProductPackage>;
  aggregateProductPackageSubscription?: Maybe<AggregateProductPackageSubscription>;
  aggregateProviderAppointmentTypeRoomMap?: Maybe<AggregateProviderAppointmentTypeRoomMap>;
  aggregatePushNotificationLog?: Maybe<AggregatePushNotificationLog>;
  aggregateRecap?: Maybe<AggregateRecap>;
  aggregateRules?: Maybe<AggregateRules>;
  aggregateSegment?: Maybe<AggregateSegment>;
  aggregateSentTrupanionExamDayOffer?: Maybe<AggregateSentTrupanionExamDayOffer>;
  aggregateService?: Maybe<AggregateService>;
  aggregateServiceCategory?: Maybe<AggregateServiceCategory>;
  aggregateServicePurchaseSummary?: Maybe<AggregateServicePurchaseSummary>;
  aggregateServiceReminder?: Maybe<AggregateServiceReminder>;
  aggregateServiceReminderNotification?: Maybe<AggregateServiceReminderNotification>;
  aggregateServiceReminderTiming?: Maybe<AggregateServiceReminderTiming>;
  aggregateSex?: Maybe<AggregateSex>;
  aggregateSmsNotificationStatus?: Maybe<AggregateSmsNotificationStatus>;
  aggregateSpecies?: Maybe<AggregateSpecies>;
  aggregateStaffRole?: Maybe<AggregateStaffRole>;
  aggregateStripeCustomer?: Maybe<AggregateStripeCustomer>;
  aggregateStripeDispute?: Maybe<AggregateStripeDispute>;
  aggregateStripeInvoice?: Maybe<AggregateStripeInvoice>;
  aggregateStripeInvoiceItem?: Maybe<AggregateStripeInvoiceItem>;
  aggregateStripePaymentIntent?: Maybe<AggregateStripePaymentIntent>;
  aggregateStripePaymentMethod?: Maybe<AggregateStripePaymentMethod>;
  aggregateStripePayout?: Maybe<AggregateStripePayout>;
  aggregateStripePayoutAccount?: Maybe<AggregateStripePayoutAccount>;
  aggregateStripeReceipt?: Maybe<AggregateStripeReceipt>;
  aggregateStripeReceiptHistory?: Maybe<AggregateStripeReceiptHistory>;
  aggregateStripeRefund?: Maybe<AggregateStripeRefund>;
  aggregateStripeTerminal?: Maybe<AggregateStripeTerminal>;
  aggregateStripeTerminalLocation?: Maybe<AggregateStripeTerminalLocation>;
  aggregateSurveyAppointmentTypeSetting?: Maybe<AggregateSurveyAppointmentTypeSetting>;
  aggregateSurveyResult?: Maybe<AggregateSurveyResult>;
  aggregateSurveySetting?: Maybe<AggregateSurveySetting>;
  aggregateSyncVetIntegration?: Maybe<AggregateSyncVetIntegration>;
  aggregateSyncVetService?: Maybe<AggregateSyncVetService>;
  aggregateSynchronyClinicConfiguration?: Maybe<AggregateSynchronyClinicConfiguration>;
  aggregateSynchronyEvent?: Maybe<AggregateSynchronyEvent>;
  aggregateTask?: Maybe<AggregateTask>;
  aggregateTaxonomy?: Maybe<AggregateTaxonomy>;
  aggregateTaxonomyToInformAudienceDefinition?: Maybe<AggregateTaxonomyToInformAudienceDefinition>;
  aggregateTransaction?: Maybe<AggregateTransaction>;
  aggregateTrupanionCertificateAvailability?: Maybe<AggregateTrupanionCertificateAvailability>;
  aggregateTrupanionIntegratedAppointmentType?: Maybe<AggregateTrupanionIntegratedAppointmentType>;
  aggregateTrupanionIntegration?: Maybe<AggregateTrupanionIntegration>;
  aggregateTwilioCallRecording?: Maybe<AggregateTwilioCallRecording>;
  aggregateUser?: Maybe<AggregateUser>;
  aggregateUserAppointmentGrouping?: Maybe<AggregateUserAppointmentGrouping>;
  aggregateUserBoardFilter?: Maybe<AggregateUserBoardFilter>;
  aggregateUserChannelFilterSelection?: Maybe<AggregateUserChannelFilterSelection>;
  aggregateUserNotificationSetting?: Maybe<AggregateUserNotificationSetting>;
  aggregateUserSetting?: Maybe<AggregateUserSetting>;
  aggregateUserTaskList?: Maybe<AggregateUserTaskList>;
  aggregateUserTaskListFilter?: Maybe<AggregateUserTaskListFilter>;
  aggregateVaccination?: Maybe<AggregateVaccination>;
  aggregateVetAvailability?: Maybe<AggregateVetAvailability>;
  aggregateVetAvailabilityClinicRoomMap?: Maybe<AggregateVetAvailabilityClinicRoomMap>;
  aggregateVetAvailabilityMap?: Maybe<AggregateVetAvailabilityMap>;
  aggregateVetInfo?: Maybe<AggregateVetInfo>;
  aggregateVetsourceCodeTag?: Maybe<AggregateVetsourceCodeTag>;
  aggregateVetsourceInstallation?: Maybe<AggregateVetsourceInstallation>;
  aggregateVetsourcePharmacyIntegration?: Maybe<AggregateVetsourcePharmacyIntegration>;
  aggregateVetsourceRevenueCategory?: Maybe<AggregateVetsourceRevenueCategory>;
  aggregateWorkflowEventSetting?: Maybe<AggregateWorkflowEventSetting>;
  aiChannelSuggestedMessage?: Maybe<ChannelSuggestedMessageResponse>;
  aiChannelSummary?: Maybe<ChannelSummaryResponse>;
  appointmentFilters?: Maybe<AppointmentFilter>;
  axionGetCalls?: Maybe<AxionGetCallsOutput>;
  axionGetDomains?: Maybe<AxionGetDomainsOutput>;
  calculateMultiplePetsBenefitUsage?: Maybe<CalculateMultiplePetsBenefitUsageOutput>;
  calculatePetBenefitUsage?: Maybe<CalculatePetBenefitUsageOutput>;
  canManuallyRetryPaymentWriteback: CanManuallyRetryPaymentWritebackOutput;
  canSendEmailCampaign?: Maybe<Scalars['Boolean']>;
  channelExport?: Maybe<FileExportData>;
  channelMessageUnreadCount: ChannelMessageUnreadCountResult;
  channelSearch: ChannelSearchOutput;
  channelUnreadMessageCount?: Maybe<ChannelUnreadMessageCountResult>;
  checkClinicCareStatus: CheckClinicCareStatusResult;
  checkPhoneVerification?: Maybe<Scalars['Json']>;
  clientReadTest?: Maybe<Scalars['Boolean']>;
  clientWriteTest?: Maybe<Scalars['Boolean']>;
  clinicHasAutomationsThatCreateTasks: Scalars['Boolean'];
  clinicPaymentActivity?: Maybe<ClinicPaymentActivityOutput>;
  clinicPetParentSearch: Array<ClinicPetParent>;
  clinicPetSearch: Array<ClinicPet>;
  customFindUniqueUserBoardFilter?: Maybe<CustomFindUniqueUserBoardFilterResponse>;
  estimateNumberOfPetParentsReached?: Maybe<NumberOfPetParentsReached>;
  exportCancellationSummaryAsPdf: ExportCancellationSummaryAsPdfResponse;
  exportItemizedInvoiceAsReceiptPDF: ExportItemizedInvoiceToReceiptPdfResponse;
  exportNonItemizedReceiptAsPdf: ExportNonItemizedReceiptAsPdfResponse;
  findClinicContactInfo?: Maybe<ClinicContactInfo>;
  findClinicPetParentByPhoneOrEmail: Array<ClinicPetParent>;
  findClinicPetParentByToken?: Maybe<ClinicPetParent>;
  findCurrentEmailTemplateVersions: CurrentEmailTemplateVersionsFindResponse;
  findEmployerIdentificationNumber?: Maybe<Array<Maybe<FindEmployerIdentificationNumberResponse>>>;
  findFirstActiveIngredient?: Maybe<ActiveIngredient>;
  findFirstAiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntry>;
  findFirstAppointment?: Maybe<Appointment>;
  findFirstAppointmentAvailability?: Maybe<AppointmentAvailability>;
  findFirstAppointmentNoteTemplate?: Maybe<AppointmentNoteTemplate>;
  findFirstAppointmentType?: Maybe<AppointmentType>;
  findFirstAutomationRun?: Maybe<AutomationRun>;
  findFirstAutomationRunAction?: Maybe<AutomationRunAction>;
  findFirstAxionClinicConfiguration?: Maybe<AxionClinicConfiguration>;
  findFirstAxionClinicUserConfiguration?: Maybe<AxionClinicUserConfiguration>;
  findFirstBedrockInference?: Maybe<BedrockInference>;
  findFirstBitwerxHealthcheck?: Maybe<BitwerxHealthcheck>;
  findFirstBitwerxIntegration?: Maybe<BitwerxIntegration>;
  findFirstBitwerxPaymentHealthcheckResult?: Maybe<BitwerxPaymentHealthcheckResult>;
  findFirstBitwerxPaymentHealthcheckRun?: Maybe<BitwerxPaymentHealthcheckRun>;
  findFirstBitwerxPaymentWritebackConfiguration?: Maybe<BitwerxPaymentWritebackConfiguration>;
  findFirstBoardFilterColumn?: Maybe<BoardFilterColumn>;
  findFirstBoardFilterSpecificDateRange?: Maybe<BoardFilterSpecificDateRange>;
  findFirstBoehringerIngelheimCustomerAlignment?: Maybe<BoehringerIngelheimCustomerAlignment>;
  findFirstBoehringerIngelheimTerritory?: Maybe<BoehringerIngelheimTerritory>;
  findFirstBreed?: Maybe<Breed>;
  findFirstCallHistory?: Maybe<CallHistory>;
  findFirstCallParticipant?: Maybe<CallParticipant>;
  findFirstCallRecording?: Maybe<CallRecording>;
  findFirstCampaignRegistryCampaign?: Maybe<CampaignRegistryCampaign>;
  findFirstCanonicalBreed?: Maybe<CanonicalBreed>;
  findFirstCanonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfile>;
  findFirstCanonicalService?: Maybe<CanonicalService>;
  findFirstCanonicalSpecies?: Maybe<CanonicalSpecies>;
  findFirstCareAccountCreditIntent?: Maybe<CareAccountCreditIntent>;
  findFirstCareAccountCreditPimsWritebackLogEntry?: Maybe<CareAccountCreditPimsWritebackLogEntry>;
  findFirstCareAddonEnrollment?: Maybe<CareAddonEnrollment>;
  findFirstCareAddonPackage?: Maybe<CareAddonPackage>;
  findFirstCareAddonPackageBenefit?: Maybe<CareAddonPackageBenefit>;
  findFirstCareAuthorizationRequest?: Maybe<CareAuthorizationRequest>;
  findFirstCareBenefit?: Maybe<CareBenefit>;
  findFirstCareBenefitUsage?: Maybe<CareBenefitUsage>;
  findFirstCareBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowup>;
  findFirstCareBenefitUsageFollowupStep?: Maybe<CareBenefitUsageFollowupStep>;
  findFirstCareBenefitUsageToInvoiceLineItem?: Maybe<CareBenefitUsageToInvoiceLineItem>;
  findFirstCareCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheck>;
  findFirstCareEnrollmentPayment?: Maybe<CareEnrollmentPayment>;
  findFirstCareEnrollmentToStripeInvoiceItem?: Maybe<CareEnrollmentToStripeInvoiceItem>;
  findFirstCareLapsedPayment?: Maybe<CareLapsedPayment>;
  findFirstCarePlan?: Maybe<CarePlan>;
  findFirstCarePlanBenefit?: Maybe<CarePlanBenefit>;
  findFirstCarePlanBenefitEnrollmentCarryover?: Maybe<CarePlanBenefitEnrollmentCarryover>;
  findFirstCarePlanEnrollment?: Maybe<CarePlanEnrollment>;
  findFirstCarePlanPricing?: Maybe<CarePlanPricing>;
  findFirstCarePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  findFirstCareStripeSubscription?: Maybe<CareStripeSubscription>;
  findFirstCareSubscriptionTrueUp?: Maybe<CareSubscriptionTrueUp>;
  findFirstCareSubscriptionTrueUpLogEntry?: Maybe<CareSubscriptionTrueUpLogEntry>;
  findFirstChannel?: Maybe<Channel>;
  findFirstChannelAutomationStatus?: Maybe<ChannelAutomationStatus>;
  findFirstChannelCreationSource?: Maybe<ChannelCreationSource>;
  findFirstChannelFilterSelection?: Maybe<ChannelFilterSelection>;
  findFirstChannelMember?: Maybe<ChannelMember>;
  findFirstChannelMessage?: Maybe<ChannelMessage>;
  findFirstChannelMessageAttachment?: Maybe<ChannelMessageAttachment>;
  findFirstChannelMessageAutoResponse?: Maybe<ChannelMessageAutoResponse>;
  findFirstChannelMessageReaction?: Maybe<ChannelMessageReaction>;
  findFirstChannelPin?: Maybe<ChannelPin>;
  findFirstChannelSelection?: Maybe<ChannelSelection>;
  findFirstChannelStatus?: Maybe<ChannelStatus>;
  findFirstChannelStatusChannelAssignee?: Maybe<ChannelStatusChannelAssignee>;
  findFirstChemicalCompound?: Maybe<ChemicalCompound>;
  findFirstClientConnectIntegration?: Maybe<ClientConnectIntegration>;
  findFirstClinic?: Maybe<Clinic>;
  findFirstClinicBlockedPhoneNumber?: Maybe<ClinicBlockedPhoneNumber>;
  findFirstClinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetup>;
  findFirstClinicDirectBookingSetting?: Maybe<ClinicDirectBookingSetting>;
  findFirstClinicEmailCampaignSetting?: Maybe<ClinicEmailCampaignSetting>;
  findFirstClinicEmployee?: Maybe<ClinicEmployee>;
  findFirstClinicEmployeeAppointmentTypeSetting?: Maybe<ClinicEmployeeAppointmentTypeSetting>;
  findFirstClinicEntityPhoneNumber?: Maybe<ClinicEntityPhoneNumber>;
  findFirstClinicModule?: Maybe<ClinicModule>;
  findFirstClinicOfficeHour?: Maybe<ClinicOfficeHour>;
  findFirstClinicOnboarding?: Maybe<ClinicOnboarding>;
  findFirstClinicPaymentFeeConfiguration?: Maybe<ClinicPaymentFeeConfiguration>;
  findFirstClinicPet?: Maybe<ClinicPet>;
  findFirstClinicPetAlert?: Maybe<ClinicPetAlert>;
  findFirstClinicPetCustomFieldValue?: Maybe<ClinicPetCustomFieldValue>;
  findFirstClinicPetParent?: Maybe<ClinicPetParent>;
  findFirstClinicPetParentAddress?: Maybe<ClinicPetParentAddress>;
  findFirstClinicPetParentCustomFieldValue?: Maybe<ClinicPetParentCustomFieldValue>;
  findFirstClinicPetParentDevice?: Maybe<ClinicPetParentDevice>;
  findFirstClinicPetParentPimsSyncStatus?: Maybe<ClinicPetParentPimsSyncStatus>;
  findFirstClinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatus>;
  findFirstClinicPhoneNumber?: Maybe<ClinicPhoneNumber>;
  findFirstClinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  findFirstClinicPimsIntegrationCapability?: Maybe<ClinicPimsIntegrationCapability>;
  findFirstClinicPimsIntegrationCapabilityHistoryEntry?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntry>;
  findFirstClinicPostcardSetting?: Maybe<ClinicPostcardSetting>;
  findFirstClinicRoom?: Maybe<ClinicRoom>;
  findFirstClinicSetting?: Maybe<ClinicSetting>;
  findFirstClinicUserFilter?: Maybe<ClinicUserFilter>;
  findFirstClinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  findFirstClinicWidgetRequestType?: Maybe<ClinicWidgetRequestType>;
  findFirstClinicWidgetSetting?: Maybe<ClinicWidgetSetting>;
  findFirstColor?: Maybe<Color>;
  findFirstCondition?: Maybe<Condition>;
  findFirstConditionSet?: Maybe<ConditionSet>;
  findFirstConditionalEntityEvaluation?: Maybe<ConditionalEntityEvaluation>;
  findFirstConsultation?: Maybe<Consultation>;
  findFirstConsultationRequest?: Maybe<ConsultationRequest>;
  findFirstCustomFieldDefinition?: Maybe<CustomFieldDefinition>;
  findFirstCustomFieldPimsWritebackLogEntry?: Maybe<CustomFieldPimsWritebackLogEntry>;
  findFirstDirectBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSetting>;
  findFirstDirectBookingExclusionRule?: Maybe<DirectBookingExclusionRule>;
  findFirstDirectBookingExclusionTimeSlot?: Maybe<DirectBookingExclusionTimeSlot>;
  findFirstDisbursement?: Maybe<Disbursement>;
  findFirstDocumentation?: Maybe<Documentation>;
  findFirstEmailCampaign?: Maybe<EmailCampaign>;
  findFirstEmailCampaignCustomList?: Maybe<EmailCampaignCustomList>;
  findFirstEmailCampaignCustomListRecipient?: Maybe<EmailCampaignCustomListRecipient>;
  findFirstEmailCampaignCustomListUploadHistory?: Maybe<EmailCampaignCustomListUploadHistory>;
  findFirstEmailCampaignLog?: Maybe<EmailCampaignLog>;
  findFirstEmailCampaignTemplate?: Maybe<EmailCampaignTemplate>;
  findFirstEmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribe>;
  findFirstEmailProviderLog?: Maybe<EmailProviderLog>;
  findFirstEmergencyClinics?: Maybe<EmergencyClinics>;
  findFirstEncryptedClinicUpload?: Maybe<EncryptedClinicUpload>;
  findFirstEnrollmentSupportEvent?: Maybe<EnrollmentSupportEvent>;
  findFirstEzyVetIntegration?: Maybe<EzyVetIntegration>;
  findFirstFeatureFlag?: Maybe<FeatureFlag>;
  findFirstFinancialAdjustment?: Maybe<FinancialAdjustment>;
  findFirstFinancialTransaction?: Maybe<FinancialTransaction>;
  findFirstFormSubmission?: Maybe<FormSubmission>;
  findFirstFormTemplate?: Maybe<FormTemplate>;
  findFirstGlobalPetParent?: Maybe<GlobalPetParent>;
  findFirstGooglePlace?: Maybe<GooglePlace>;
  findFirstHillsToHomeAPILog?: Maybe<HillsToHomeApiLog>;
  findFirstInformAudienceDefinition?: Maybe<InformAudienceDefinition>;
  findFirstInformAudienceMember?: Maybe<InformAudienceMember>;
  findFirstInformAudienceMemberMessage?: Maybe<InformAudienceMemberMessage>;
  findFirstInformAutomationCampaign?: Maybe<InformAutomationCampaign>;
  findFirstInformCampaign?: Maybe<InformCampaign>;
  findFirstInformCampaignEnrollment?: Maybe<InformCampaignEnrollment>;
  findFirstInformCampaignEnrollmentCanonicalService?: Maybe<InformCampaignEnrollmentCanonicalService>;
  findFirstInformCampaignExecution?: Maybe<InformCampaignExecution>;
  findFirstInformCampaignGroup?: Maybe<InformCampaignGroup>;
  findFirstInformCommunicationOptOut?: Maybe<InformCommunicationOptOut>;
  findFirstInformControlGroupParticipant?: Maybe<InformControlGroupParticipant>;
  findFirstInformEmailTemplate?: Maybe<InformEmailTemplate>;
  findFirstInformEntityHistory?: Maybe<InformEntityHistory>;
  findFirstInformEventDrivenCampaign?: Maybe<InformEventDrivenCampaign>;
  findFirstInformEventListener?: Maybe<InformEventListener>;
  findFirstInformNotificationRecipient?: Maybe<InformNotificationRecipient>;
  findFirstInformPartner?: Maybe<InformPartner>;
  findFirstInformPartnerCustomer?: Maybe<InformPartnerCustomer>;
  findFirstInformPartnerCustomerPharmacyProvider?: Maybe<InformPartnerCustomerPharmacyProvider>;
  findFirstInformPartnerIntegration?: Maybe<InformPartnerIntegration>;
  findFirstInformPartnerIntegrationModel?: Maybe<InformPartnerIntegrationModel>;
  findFirstInformPartnerProgram?: Maybe<InformPartnerProgram>;
  findFirstInformPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollment>;
  findFirstInformPartnerUser?: Maybe<InformPartnerUser>;
  findFirstInformPartnerUserRole?: Maybe<InformPartnerUserRole>;
  findFirstInformScheduledCampaign?: Maybe<InformScheduledCampaign>;
  findFirstInformSession?: Maybe<InformSession>;
  findFirstInformSessionEvent?: Maybe<InformSessionEvent>;
  findFirstInstinctIntegration?: Maybe<InstinctIntegration>;
  findFirstInsuranceIntegration?: Maybe<InsuranceIntegration>;
  findFirstIntegrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntry>;
  findFirstInterchangeRate?: Maybe<InterchangeRate>;
  findFirstInvoice?: Maybe<Invoice>;
  findFirstInvoiceLineItem?: Maybe<InvoiceLineItem>;
  findFirstInvoicePimsWritebackLogEntry?: Maybe<InvoicePimsWritebackLogEntry>;
  findFirstLabPanel?: Maybe<LabPanel>;
  findFirstLabResult?: Maybe<LabResult>;
  findFirstLapsedPetParentTriggers?: Maybe<LapsedPetParentTriggers>;
  findFirstLegalEntity?: Maybe<LegalEntity>;
  findFirstLoyaltyAccount?: Maybe<LoyaltyAccount>;
  findFirstLoyaltyAccountHolder?: Maybe<LoyaltyAccountHolder>;
  findFirstLoyaltyAccountMerger?: Maybe<LoyaltyAccountMerger>;
  findFirstLoyaltyInvoicePointGranter?: Maybe<LoyaltyInvoicePointGranter>;
  findFirstLoyaltyPointDelta?: Maybe<LoyaltyPointDelta>;
  findFirstLoyaltyPointGrantingService?: Maybe<LoyaltyPointGrantingService>;
  findFirstLoyaltyPointGrantingServiceCategory?: Maybe<LoyaltyPointGrantingServiceCategory>;
  findFirstLoyaltyPointUserGrant?: Maybe<LoyaltyPointUserGrant>;
  findFirstLoyaltyProgram?: Maybe<LoyaltyProgram>;
  findFirstLoyaltyProgramStatusHistory?: Maybe<LoyaltyProgramStatusHistory>;
  findFirstLoyaltyReward?: Maybe<LoyaltyReward>;
  findFirstLoyaltyRewardRedemption?: Maybe<LoyaltyRewardRedemption>;
  findFirstLoyaltyRewardRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntry>;
  findFirstMassTextAlert?: Maybe<MassTextAlert>;
  findFirstMassTextAlertEntry?: Maybe<MassTextAlertEntry>;
  findFirstMassTextAlertEntryAppointment?: Maybe<MassTextAlertEntryAppointment>;
  findFirstMedia?: Maybe<Media>;
  findFirstMedicalHistory?: Maybe<MedicalHistory>;
  findFirstMessageTemplate?: Maybe<MessageTemplate>;
  findFirstMessagingCampaign?: Maybe<MessagingCampaign>;
  findFirstMessagingPartner?: Maybe<MessagingPartner>;
  findFirstModule?: Maybe<Module>;
  findFirstNonPrismaSchemaScriptRan?: Maybe<NonPrismaSchemaScriptRan>;
  findFirstNotificationEventToMessage?: Maybe<NotificationEventToMessage>;
  findFirstOrganization?: Maybe<Organization>;
  findFirstOrganizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicService>;
  findFirstOrganizationCareBenefitToClinicServiceCategory?: Maybe<OrganizationCareBenefitToClinicServiceCategory>;
  findFirstOrganizationPet?: Maybe<OrganizationPet>;
  findFirstOrganizationPetParent?: Maybe<OrganizationPetParent>;
  findFirstOrganizationPetToOrganizationPetParent?: Maybe<OrganizationPetToOrganizationPetParent>;
  findFirstPPCIntegration?: Maybe<PpcIntegration>;
  findFirstPaymentsReportTransaction?: Maybe<PaymentsReportTransaction>;
  findFirstPayoutBatchingPeriod?: Maybe<PayoutBatchingPeriod>;
  findFirstPayoutBatchingSchedule?: Maybe<PayoutBatchingSchedule>;
  findFirstPayoutBatchingSetting?: Maybe<PayoutBatchingSetting>;
  findFirstPermission?: Maybe<Permission>;
  findFirstPetParentSetting?: Maybe<PetParentSetting>;
  findFirstPetPortalSetting?: Maybe<PetPortalSetting>;
  findFirstPhoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequest>;
  findFirstPhoneNumberLookupResult?: Maybe<PhoneNumberLookupResult>;
  findFirstPimsInvoice?: Maybe<PimsInvoice>;
  findFirstPimsInvoiceLineItem?: Maybe<PimsInvoiceLineItem>;
  findFirstPimsPaymentType?: Maybe<PimsPaymentType>;
  findFirstPimsWritebackLogEntry?: Maybe<PimsWritebackLogEntry>;
  findFirstPrescription?: Maybe<Prescription>;
  findFirstProduct?: Maybe<Product>;
  findFirstProductPackage?: Maybe<ProductPackage>;
  findFirstProductPackageSubscription?: Maybe<ProductPackageSubscription>;
  findFirstProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMap>;
  findFirstPushNotificationLog?: Maybe<PushNotificationLog>;
  findFirstRecap?: Maybe<Recap>;
  findFirstRules?: Maybe<Rules>;
  findFirstSegment?: Maybe<Segment>;
  findFirstSentTrupanionExamDayOffer?: Maybe<SentTrupanionExamDayOffer>;
  findFirstService?: Maybe<Service>;
  findFirstServiceCategory?: Maybe<ServiceCategory>;
  findFirstServicePurchaseSummary?: Maybe<ServicePurchaseSummary>;
  findFirstServiceReminder?: Maybe<ServiceReminder>;
  findFirstServiceReminderNotification?: Maybe<ServiceReminderNotification>;
  findFirstServiceReminderTiming?: Maybe<ServiceReminderTiming>;
  findFirstSex?: Maybe<Sex>;
  findFirstSmsNotificationStatus?: Maybe<SmsNotificationStatus>;
  findFirstSpecies?: Maybe<Species>;
  findFirstStaffRole?: Maybe<StaffRole>;
  findFirstStripeCustomer?: Maybe<StripeCustomer>;
  findFirstStripeDispute?: Maybe<StripeDispute>;
  findFirstStripeInvoice?: Maybe<StripeInvoice>;
  findFirstStripeInvoiceItem?: Maybe<StripeInvoiceItem>;
  findFirstStripePaymentIntent?: Maybe<StripePaymentIntent>;
  findFirstStripePaymentMethod?: Maybe<StripePaymentMethod>;
  findFirstStripePayout?: Maybe<StripePayout>;
  findFirstStripePayoutAccount?: Maybe<StripePayoutAccount>;
  findFirstStripeReceipt?: Maybe<StripeReceipt>;
  findFirstStripeReceiptHistory?: Maybe<StripeReceiptHistory>;
  findFirstStripeRefund?: Maybe<StripeRefund>;
  findFirstStripeTerminal?: Maybe<StripeTerminal>;
  findFirstStripeTerminalLocation?: Maybe<StripeTerminalLocation>;
  findFirstSurveyAppointmentTypeSetting?: Maybe<SurveyAppointmentTypeSetting>;
  findFirstSurveyResult?: Maybe<SurveyResult>;
  findFirstSurveySetting?: Maybe<SurveySetting>;
  findFirstSyncVetIntegration?: Maybe<SyncVetIntegration>;
  findFirstSyncVetService?: Maybe<SyncVetService>;
  findFirstSynchronyClinicConfiguration?: Maybe<SynchronyClinicConfiguration>;
  findFirstSynchronyEvent?: Maybe<SynchronyEvent>;
  findFirstTask?: Maybe<Task>;
  findFirstTaxonomy?: Maybe<Taxonomy>;
  findFirstTaxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinition>;
  findFirstTransaction?: Maybe<Transaction>;
  findFirstTrupanionCertificateAvailability?: Maybe<TrupanionCertificateAvailability>;
  findFirstTrupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentType>;
  findFirstTrupanionIntegration?: Maybe<TrupanionIntegration>;
  findFirstTwilioCallRecording?: Maybe<TwilioCallRecording>;
  findFirstUser?: Maybe<User>;
  findFirstUserAppointmentGrouping?: Maybe<UserAppointmentGrouping>;
  findFirstUserBoardFilter?: Maybe<UserBoardFilter>;
  findFirstUserChannelFilterSelection?: Maybe<UserChannelFilterSelection>;
  findFirstUserNotificationSetting?: Maybe<UserNotificationSetting>;
  findFirstUserSetting?: Maybe<UserSetting>;
  findFirstUserTaskList?: Maybe<UserTaskList>;
  findFirstUserTaskListFilter?: Maybe<UserTaskListFilter>;
  findFirstVaccination?: Maybe<Vaccination>;
  findFirstVetAvailability?: Maybe<VetAvailability>;
  findFirstVetAvailabilityClinicRoomMap?: Maybe<VetAvailabilityClinicRoomMap>;
  findFirstVetAvailabilityMap?: Maybe<VetAvailabilityMap>;
  findFirstVetInfo?: Maybe<VetInfo>;
  findFirstVetsourceCodeTag?: Maybe<VetsourceCodeTag>;
  findFirstVetsourceInstallation?: Maybe<VetsourceInstallation>;
  findFirstVetsourcePharmacyIntegration?: Maybe<VetsourcePharmacyIntegration>;
  findFirstVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategory>;
  findFirstWorkflowEventSetting?: Maybe<WorkflowEventSetting>;
  findManyActiveIngredient: Array<ActiveIngredient>;
  findManyActiveIngredientCount: Scalars['Int'];
  findManyAiRecapPimsWritebackLogEntry: Array<AiRecapPimsWritebackLogEntry>;
  findManyAiRecapPimsWritebackLogEntryCount: Scalars['Int'];
  findManyAppointment: Array<Appointment>;
  findManyAppointmentAvailability: Array<AppointmentAvailability>;
  findManyAppointmentAvailabilityCount: Scalars['Int'];
  findManyAppointmentCount: Scalars['Int'];
  findManyAppointmentNoteTemplate: Array<AppointmentNoteTemplate>;
  findManyAppointmentNoteTemplateCount: Scalars['Int'];
  findManyAppointmentType: Array<AppointmentType>;
  findManyAppointmentTypeCount: Scalars['Int'];
  findManyAutomationRun: Array<AutomationRun>;
  findManyAutomationRunAction: Array<AutomationRunAction>;
  findManyAutomationRunActionCount: Scalars['Int'];
  findManyAutomationRunCount: Scalars['Int'];
  findManyAxionClinicConfiguration: Array<AxionClinicConfiguration>;
  findManyAxionClinicConfigurationCount: Scalars['Int'];
  findManyAxionClinicUserConfiguration: Array<AxionClinicUserConfiguration>;
  findManyAxionClinicUserConfigurationCount: Scalars['Int'];
  findManyBedrockInference: Array<BedrockInference>;
  findManyBedrockInferenceCount: Scalars['Int'];
  findManyBitwerxHealthcheck: Array<BitwerxHealthcheck>;
  findManyBitwerxHealthcheckCount: Scalars['Int'];
  findManyBitwerxIntegration: Array<BitwerxIntegration>;
  findManyBitwerxIntegrationCount: Scalars['Int'];
  findManyBitwerxPaymentHealthcheckResult: Array<BitwerxPaymentHealthcheckResult>;
  findManyBitwerxPaymentHealthcheckResultCount: Scalars['Int'];
  findManyBitwerxPaymentHealthcheckRun: Array<BitwerxPaymentHealthcheckRun>;
  findManyBitwerxPaymentHealthcheckRunCount: Scalars['Int'];
  findManyBitwerxPaymentWritebackConfigurationCount: Scalars['Int'];
  findManyBoardFilterColumn: Array<BoardFilterColumn>;
  findManyBoardFilterColumnCount: Scalars['Int'];
  findManyBoardFilterSpecificDateRange: Array<BoardFilterSpecificDateRange>;
  findManyBoardFilterSpecificDateRangeCount: Scalars['Int'];
  findManyBoehringerIngelheimCustomerAlignment: Array<BoehringerIngelheimCustomerAlignment>;
  findManyBoehringerIngelheimCustomerAlignmentCount: Scalars['Int'];
  findManyBoehringerIngelheimTerritory: Array<BoehringerIngelheimTerritory>;
  findManyBoehringerIngelheimTerritoryCount: Scalars['Int'];
  findManyBreed: Array<Breed>;
  findManyBreedCount: Scalars['Int'];
  findManyCallHistory: Array<CallHistory>;
  findManyCallHistoryCount: Scalars['Int'];
  findManyCallParticipant: Array<CallParticipant>;
  findManyCallParticipantCount: Scalars['Int'];
  findManyCallRecording: Array<CallRecording>;
  findManyCallRecordingCount: Scalars['Int'];
  findManyCampaignRegistryCampaign: Array<CampaignRegistryCampaign>;
  findManyCampaignRegistryCampaignCount: Scalars['Int'];
  findManyCanonicalBreed: Array<CanonicalBreed>;
  findManyCanonicalBreedCount: Scalars['Int'];
  findManyCanonicalCanineBreedProfile: Array<CanonicalCanineBreedProfile>;
  findManyCanonicalCanineBreedProfileCount: Scalars['Int'];
  findManyCanonicalService: Array<CanonicalService>;
  findManyCanonicalServiceCount: Scalars['Int'];
  findManyCanonicalSpecies: Array<CanonicalSpecies>;
  findManyCanonicalSpeciesCount: Scalars['Int'];
  findManyCareAccountCreditIntent: Array<CareAccountCreditIntent>;
  findManyCareAccountCreditIntentCount: Scalars['Int'];
  findManyCareAccountCreditPimsWritebackLogEntry: Array<CareAccountCreditPimsWritebackLogEntry>;
  findManyCareAccountCreditPimsWritebackLogEntryCount: Scalars['Int'];
  findManyCareAddonEnrollment: Array<CareAddonEnrollment>;
  findManyCareAddonEnrollmentCount: Scalars['Int'];
  findManyCareAddonPackage: Array<CareAddonPackage>;
  findManyCareAddonPackageBenefit: Array<CareAddonPackageBenefit>;
  findManyCareAddonPackageBenefitCount: Scalars['Int'];
  findManyCareAddonPackageCount: Scalars['Int'];
  findManyCareAuthorizationRequest: Array<CareAuthorizationRequest>;
  findManyCareAuthorizationRequestCount: Scalars['Int'];
  findManyCareBenefit: Array<CareBenefit>;
  findManyCareBenefitCount: Scalars['Int'];
  findManyCareBenefitUsage: Array<CareBenefitUsage>;
  findManyCareBenefitUsageCount: Scalars['Int'];
  findManyCareBenefitUsageFollowup: Array<CareBenefitUsageFollowup>;
  findManyCareBenefitUsageFollowupCount: Scalars['Int'];
  findManyCareBenefitUsageFollowupStep: Array<CareBenefitUsageFollowupStep>;
  findManyCareBenefitUsageFollowupStepCount: Scalars['Int'];
  findManyCareBenefitUsageToInvoiceLineItem: Array<CareBenefitUsageToInvoiceLineItem>;
  findManyCareBenefitUsageToInvoiceLineItemCount: Scalars['Int'];
  findManyCareCreditPreapprovalCheck: Array<CareCreditPreapprovalCheck>;
  findManyCareCreditPreapprovalCheckCount: Scalars['Int'];
  findManyCareEnrollmentPayment: Array<CareEnrollmentPayment>;
  findManyCareEnrollmentPaymentCount: Scalars['Int'];
  findManyCareEnrollmentToStripeInvoiceItem: Array<CareEnrollmentToStripeInvoiceItem>;
  findManyCareEnrollmentToStripeInvoiceItemCount: Scalars['Int'];
  findManyCareLapsedPayment: Array<CareLapsedPayment>;
  findManyCareLapsedPaymentCount: Scalars['Int'];
  findManyCarePlan: Array<CarePlan>;
  findManyCarePlanBenefit: Array<CarePlanBenefit>;
  findManyCarePlanBenefitCount: Scalars['Int'];
  findManyCarePlanBenefitEnrollmentCarryover: Array<CarePlanBenefitEnrollmentCarryover>;
  findManyCarePlanBenefitEnrollmentCarryoverCount: Scalars['Int'];
  findManyCarePlanCount: Scalars['Int'];
  findManyCarePlanEnrollment: Array<CarePlanEnrollment>;
  findManyCarePlanEnrollmentCount: Scalars['Int'];
  findManyCarePlanPricing: Array<CarePlanPricing>;
  findManyCarePlanPricingCount: Scalars['Int'];
  findManyCarePlanProviderGroup: Array<CarePlanProviderGroup>;
  findManyCarePlanProviderGroupCount: Scalars['Int'];
  findManyCareStripeSubscription: Array<CareStripeSubscription>;
  findManyCareStripeSubscriptionCount: Scalars['Int'];
  findManyCareSubscriptionTrueUp: Array<CareSubscriptionTrueUp>;
  findManyCareSubscriptionTrueUpCount: Scalars['Int'];
  findManyCareSubscriptionTrueUpLogEntry: Array<CareSubscriptionTrueUpLogEntry>;
  findManyCareSubscriptionTrueUpLogEntryCount: Scalars['Int'];
  findManyChannel: Array<Channel>;
  findManyChannelAutomationStatus: Array<ChannelAutomationStatus>;
  findManyChannelAutomationStatusCount: Scalars['Int'];
  findManyChannelCount: Scalars['Int'];
  findManyChannelCreationSource: Array<ChannelCreationSource>;
  findManyChannelCreationSourceCount: Scalars['Int'];
  findManyChannelFilterSelection: Array<ChannelFilterSelection>;
  findManyChannelFilterSelectionCount: Scalars['Int'];
  findManyChannelMember: Array<ChannelMember>;
  findManyChannelMemberCount: Scalars['Int'];
  findManyChannelMessage: Array<ChannelMessage>;
  findManyChannelMessageAttachment: Array<ChannelMessageAttachment>;
  findManyChannelMessageAttachmentCount: Scalars['Int'];
  findManyChannelMessageAutoResponse: Array<ChannelMessageAutoResponse>;
  findManyChannelMessageAutoResponseCount: Scalars['Int'];
  findManyChannelMessageCount: Scalars['Int'];
  findManyChannelMessageReaction: Array<ChannelMessageReaction>;
  findManyChannelMessageReactionCount: Scalars['Int'];
  findManyChannelPin: Array<ChannelPin>;
  findManyChannelPinCount: Scalars['Int'];
  findManyChannelSelection: Array<ChannelSelection>;
  findManyChannelSelectionCount: Scalars['Int'];
  findManyChannelStatus: Array<ChannelStatus>;
  findManyChannelStatusChannelAssignee: Array<ChannelStatusChannelAssignee>;
  findManyChannelStatusChannelAssigneeCount: Scalars['Int'];
  findManyChannelStatusCount: Scalars['Int'];
  findManyChemicalCompound: Array<ChemicalCompound>;
  findManyChemicalCompoundCount: Scalars['Int'];
  findManyClientConnectIntegration: Array<ClientConnectIntegration>;
  findManyClientConnectIntegrationCount: Scalars['Int'];
  findManyClinic: Array<Clinic>;
  findManyClinicBlockedPhoneNumber: Array<ClinicBlockedPhoneNumber>;
  findManyClinicBlockedPhoneNumberCount: Scalars['Int'];
  findManyClinicCount: Scalars['Int'];
  findManyClinicCustomPayoutsSetup: Array<ClinicCustomPayoutsSetup>;
  findManyClinicCustomPayoutsSetupCount: Scalars['Int'];
  findManyClinicDirectBookingSetting: Array<ClinicDirectBookingSetting>;
  findManyClinicDirectBookingSettingCount: Scalars['Int'];
  findManyClinicEmailCampaignSetting: Array<ClinicEmailCampaignSetting>;
  findManyClinicEmailCampaignSettingCount: Scalars['Int'];
  findManyClinicEmployee: Array<ClinicEmployee>;
  findManyClinicEmployeeAppointmentTypeSetting: Array<ClinicEmployeeAppointmentTypeSetting>;
  findManyClinicEmployeeAppointmentTypeSettingCount: Scalars['Int'];
  findManyClinicEmployeeCount: Scalars['Int'];
  findManyClinicEntityPhoneNumber: Array<ClinicEntityPhoneNumber>;
  findManyClinicEntityPhoneNumberCount: Scalars['Int'];
  findManyClinicModule: Array<ClinicModule>;
  findManyClinicModuleCount: Scalars['Int'];
  findManyClinicOfficeHour: Array<ClinicOfficeHour>;
  findManyClinicOfficeHourCount: Scalars['Int'];
  findManyClinicOnboarding: Array<ClinicOnboarding>;
  findManyClinicOnboardingCount: Scalars['Int'];
  findManyClinicPaymentFeeConfiguration: Array<ClinicPaymentFeeConfiguration>;
  findManyClinicPaymentFeeConfigurationCount: Scalars['Int'];
  findManyClinicPet: Array<ClinicPet>;
  findManyClinicPetAlert: Array<ClinicPetAlert>;
  findManyClinicPetAlertCount: Scalars['Int'];
  findManyClinicPetCount: Scalars['Int'];
  findManyClinicPetCustomFieldValue: Array<ClinicPetCustomFieldValue>;
  findManyClinicPetCustomFieldValueCount: Scalars['Int'];
  findManyClinicPetParent: Array<ClinicPetParent>;
  findManyClinicPetParentAddress: Array<ClinicPetParentAddress>;
  findManyClinicPetParentAddressCount: Scalars['Int'];
  findManyClinicPetParentCount: Scalars['Int'];
  findManyClinicPetParentCustomFieldValue: Array<ClinicPetParentCustomFieldValue>;
  findManyClinicPetParentCustomFieldValueCount: Scalars['Int'];
  findManyClinicPetParentDevice: Array<ClinicPetParentDevice>;
  findManyClinicPetParentDeviceCount: Scalars['Int'];
  findManyClinicPetParentPimsSyncStatus: Array<ClinicPetParentPimsSyncStatus>;
  findManyClinicPetParentPimsSyncStatusCount: Scalars['Int'];
  findManyClinicPetPimsSyncStatus: Array<ClinicPetPimsSyncStatus>;
  findManyClinicPetPimsSyncStatusCount: Scalars['Int'];
  findManyClinicPhoneNumber: Array<ClinicPhoneNumber>;
  findManyClinicPhoneNumberCount: Scalars['Int'];
  findManyClinicPimsIntegration: Array<ClinicPimsIntegration>;
  findManyClinicPimsIntegrationCapability: Array<ClinicPimsIntegrationCapability>;
  findManyClinicPimsIntegrationCapabilityCount: Scalars['Int'];
  findManyClinicPimsIntegrationCapabilityHistoryEntry: Array<ClinicPimsIntegrationCapabilityHistoryEntry>;
  findManyClinicPimsIntegrationCapabilityHistoryEntryCount: Scalars['Int'];
  findManyClinicPimsIntegrationCount: Scalars['Int'];
  findManyClinicPostcardSetting: Array<ClinicPostcardSetting>;
  findManyClinicPostcardSettingCount: Scalars['Int'];
  findManyClinicRoom: Array<ClinicRoom>;
  findManyClinicRoomCount: Scalars['Int'];
  findManyClinicSetting: Array<ClinicSetting>;
  findManyClinicSettingCount: Scalars['Int'];
  findManyClinicUserFilter: Array<ClinicUserFilter>;
  findManyClinicUserFilterCount: Scalars['Int'];
  findManyClinicWidgetRequest: Array<ClinicWidgetRequest>;
  findManyClinicWidgetRequestCount: Scalars['Int'];
  findManyClinicWidgetRequestType: Array<ClinicWidgetRequestType>;
  findManyClinicWidgetRequestTypeCount: Scalars['Int'];
  findManyClinicWidgetSetting: Array<ClinicWidgetSetting>;
  findManyClinicWidgetSettingCount: Scalars['Int'];
  findManyColor: Array<Color>;
  findManyColorCount: Scalars['Int'];
  findManyCondition: Array<Condition>;
  findManyConditionCount: Scalars['Int'];
  findManyConditionSet: Array<ConditionSet>;
  findManyConditionSetCount: Scalars['Int'];
  findManyConditionalEntityEvaluation: Array<ConditionalEntityEvaluation>;
  findManyConditionalEntityEvaluationCount: Scalars['Int'];
  findManyConsultation: Array<Consultation>;
  findManyConsultationCount: Scalars['Int'];
  findManyConsultationRequest: Array<ConsultationRequest>;
  findManyConsultationRequestCount: Scalars['Int'];
  findManyCustomFieldDefinition: Array<CustomFieldDefinition>;
  findManyCustomFieldDefinitionCount: Scalars['Int'];
  findManyCustomFieldPimsWritebackLogEntry: Array<CustomFieldPimsWritebackLogEntry>;
  findManyCustomFieldPimsWritebackLogEntryCount: Scalars['Int'];
  findManyDirectBookingAppointmentTypeSetting: Array<DirectBookingAppointmentTypeSetting>;
  findManyDirectBookingAppointmentTypeSettingCount: Scalars['Int'];
  findManyDirectBookingExclusionRule: Array<DirectBookingExclusionRule>;
  findManyDirectBookingExclusionRuleCount: Scalars['Int'];
  findManyDirectBookingExclusionTimeSlot: Array<DirectBookingExclusionTimeSlot>;
  findManyDirectBookingExclusionTimeSlotCount: Scalars['Int'];
  findManyDisbursement: Array<Disbursement>;
  findManyDisbursementCount: Scalars['Int'];
  findManyDocumentation: Array<Documentation>;
  findManyDocumentationCount: Scalars['Int'];
  findManyEmailCampaign: Array<EmailCampaign>;
  findManyEmailCampaignCount: Scalars['Int'];
  findManyEmailCampaignCustomList: Array<EmailCampaignCustomList>;
  findManyEmailCampaignCustomListCount: Scalars['Int'];
  findManyEmailCampaignCustomListRecipient: Array<EmailCampaignCustomListRecipient>;
  findManyEmailCampaignCustomListRecipientCount: Scalars['Int'];
  findManyEmailCampaignCustomListUploadHistory: Array<EmailCampaignCustomListUploadHistory>;
  findManyEmailCampaignCustomListUploadHistoryCount: Scalars['Int'];
  findManyEmailCampaignLog: Array<EmailCampaignLog>;
  findManyEmailCampaignLogCount: Scalars['Int'];
  findManyEmailCampaignTemplate: Array<EmailCampaignTemplate>;
  findManyEmailCampaignTemplateCount: Scalars['Int'];
  findManyEmailCampaignUnsubscribe: Array<EmailCampaignUnsubscribe>;
  findManyEmailCampaignUnsubscribeCount: Scalars['Int'];
  findManyEmailProviderLog: Array<EmailProviderLog>;
  findManyEmailProviderLogCount: Scalars['Int'];
  findManyEmergencyClinics: Array<EmergencyClinics>;
  findManyEmergencyClinicsCount: Scalars['Int'];
  findManyEncryptedClinicUpload: Array<EncryptedClinicUpload>;
  findManyEncryptedClinicUploadCount: Scalars['Int'];
  findManyEnrollmentSupportEvent: Array<EnrollmentSupportEvent>;
  findManyEnrollmentSupportEventCount: Scalars['Int'];
  findManyEzyVetIntegration: Array<EzyVetIntegration>;
  findManyEzyVetIntegrationCount: Scalars['Int'];
  findManyFeatureFlag: Array<FeatureFlag>;
  findManyFeatureFlagCount: Scalars['Int'];
  findManyFinancialAdjustment: Array<FinancialAdjustment>;
  findManyFinancialAdjustmentCount: Scalars['Int'];
  findManyFinancialTransaction: Array<FinancialTransaction>;
  findManyFinancialTransactionCount: Scalars['Int'];
  findManyFormSubmission: Array<FormSubmission>;
  findManyFormSubmissionCount: Scalars['Int'];
  findManyFormTemplate: Array<FormTemplate>;
  findManyFormTemplateCount: Scalars['Int'];
  findManyGlobalPetParent: Array<GlobalPetParent>;
  findManyGlobalPetParentCount: Scalars['Int'];
  findManyGooglePlace: Array<GooglePlace>;
  findManyGooglePlaceCount: Scalars['Int'];
  findManyHillsToHomeAPILog: Array<HillsToHomeApiLog>;
  findManyHillsToHomeAPILogCount: Scalars['Int'];
  findManyInformAudienceDefinition: Array<InformAudienceDefinition>;
  findManyInformAudienceDefinitionCount: Scalars['Int'];
  findManyInformAudienceMember: Array<InformAudienceMember>;
  findManyInformAudienceMemberCount: Scalars['Int'];
  findManyInformAudienceMemberMessage: Array<InformAudienceMemberMessage>;
  findManyInformAudienceMemberMessageCount: Scalars['Int'];
  findManyInformAutomationCampaign: Array<InformAutomationCampaign>;
  findManyInformAutomationCampaignCount: Scalars['Int'];
  findManyInformCampaign: Array<InformCampaign>;
  findManyInformCampaignCount: Scalars['Int'];
  findManyInformCampaignEnrollment: Array<InformCampaignEnrollment>;
  findManyInformCampaignEnrollmentCanonicalService: Array<InformCampaignEnrollmentCanonicalService>;
  findManyInformCampaignEnrollmentCanonicalServiceCount: Scalars['Int'];
  findManyInformCampaignEnrollmentCount: Scalars['Int'];
  findManyInformCampaignExecution: Array<InformCampaignExecution>;
  findManyInformCampaignExecutionCount: Scalars['Int'];
  findManyInformCampaignGroup: Array<InformCampaignGroup>;
  findManyInformCampaignGroupCount: Scalars['Int'];
  findManyInformCommunicationOptOut: Array<InformCommunicationOptOut>;
  findManyInformCommunicationOptOutCount: Scalars['Int'];
  findManyInformControlGroupParticipant: Array<InformControlGroupParticipant>;
  findManyInformControlGroupParticipantCount: Scalars['Int'];
  findManyInformEmailTemplate: Array<InformEmailTemplate>;
  findManyInformEmailTemplateCount: Scalars['Int'];
  findManyInformEntityHistory: Array<InformEntityHistory>;
  findManyInformEntityHistoryCount: Scalars['Int'];
  findManyInformEventDrivenCampaign: Array<InformEventDrivenCampaign>;
  findManyInformEventDrivenCampaignCount: Scalars['Int'];
  findManyInformEventListener: Array<InformEventListener>;
  findManyInformEventListenerCount: Scalars['Int'];
  findManyInformNotificationRecipient: Array<InformNotificationRecipient>;
  findManyInformNotificationRecipientCount: Scalars['Int'];
  findManyInformPartner: Array<InformPartner>;
  findManyInformPartnerCount: Scalars['Int'];
  findManyInformPartnerCustomer: Array<InformPartnerCustomer>;
  findManyInformPartnerCustomerCount: Scalars['Int'];
  findManyInformPartnerCustomerPharmacyProvider: Array<InformPartnerCustomerPharmacyProvider>;
  findManyInformPartnerCustomerPharmacyProviderCount: Scalars['Int'];
  findManyInformPartnerIntegration: Array<InformPartnerIntegration>;
  findManyInformPartnerIntegrationCount: Scalars['Int'];
  findManyInformPartnerIntegrationModel: Array<InformPartnerIntegrationModel>;
  findManyInformPartnerIntegrationModelCount: Scalars['Int'];
  findManyInformPartnerProgram: Array<InformPartnerProgram>;
  findManyInformPartnerProgramCount: Scalars['Int'];
  findManyInformPartnerProgramEnrollment: Array<InformPartnerProgramEnrollment>;
  findManyInformPartnerProgramEnrollmentCount: Scalars['Int'];
  findManyInformPartnerUser: Array<InformPartnerUser>;
  findManyInformPartnerUserCount: Scalars['Int'];
  findManyInformPartnerUserRole: Array<InformPartnerUserRole>;
  findManyInformPartnerUserRoleCount: Scalars['Int'];
  findManyInformScheduledCampaign: Array<InformScheduledCampaign>;
  findManyInformScheduledCampaignCount: Scalars['Int'];
  findManyInformSession: Array<InformSession>;
  findManyInformSessionCount: Scalars['Int'];
  findManyInformSessionEvent: Array<InformSessionEvent>;
  findManyInformSessionEventCount: Scalars['Int'];
  findManyInstinctIntegration: Array<InstinctIntegration>;
  findManyInstinctIntegrationCount: Scalars['Int'];
  findManyInsuranceIntegration: Array<InsuranceIntegration>;
  findManyInsuranceIntegrationCount: Scalars['Int'];
  findManyIntegrationOutageHistoryEntry: Array<IntegrationOutageHistoryEntry>;
  findManyIntegrationOutageHistoryEntryCount: Scalars['Int'];
  findManyInterchangeRate: Array<InterchangeRate>;
  findManyInterchangeRateCount: Scalars['Int'];
  findManyInvoice: Array<Invoice>;
  findManyInvoiceCount: Scalars['Int'];
  findManyInvoiceLineItem: Array<InvoiceLineItem>;
  findManyInvoiceLineItemCount: Scalars['Int'];
  findManyInvoicePimsWritebackLogEntry: Array<InvoicePimsWritebackLogEntry>;
  findManyInvoicePimsWritebackLogEntryCount: Scalars['Int'];
  findManyLabPanel: Array<LabPanel>;
  findManyLabPanelCount: Scalars['Int'];
  findManyLabResult: Array<LabResult>;
  findManyLabResultCount: Scalars['Int'];
  findManyLapsedPetParentTriggers: Array<LapsedPetParentTriggers>;
  findManyLapsedPetParentTriggersCount: Scalars['Int'];
  findManyLegalEntity: Array<LegalEntity>;
  findManyLegalEntityCount: Scalars['Int'];
  findManyLoyaltyAccount: Array<LoyaltyAccount>;
  findManyLoyaltyAccountCount: Scalars['Int'];
  findManyLoyaltyAccountHolder: Array<LoyaltyAccountHolder>;
  findManyLoyaltyAccountHolderCount: Scalars['Int'];
  findManyLoyaltyAccountMerger: Array<LoyaltyAccountMerger>;
  findManyLoyaltyAccountMergerCount: Scalars['Int'];
  findManyLoyaltyInvoicePointGranter: Array<LoyaltyInvoicePointGranter>;
  findManyLoyaltyInvoicePointGranterCount: Scalars['Int'];
  findManyLoyaltyPointDelta: Array<LoyaltyPointDelta>;
  findManyLoyaltyPointDeltaCount: Scalars['Int'];
  findManyLoyaltyPointGrantingService: Array<LoyaltyPointGrantingService>;
  findManyLoyaltyPointGrantingServiceCategory: Array<LoyaltyPointGrantingServiceCategory>;
  findManyLoyaltyPointGrantingServiceCategoryCount: Scalars['Int'];
  findManyLoyaltyPointGrantingServiceCount: Scalars['Int'];
  findManyLoyaltyPointUserGrant: Array<LoyaltyPointUserGrant>;
  findManyLoyaltyPointUserGrantCount: Scalars['Int'];
  findManyLoyaltyProgram: Array<LoyaltyProgram>;
  findManyLoyaltyProgramCount: Scalars['Int'];
  findManyLoyaltyProgramStatusHistory: Array<LoyaltyProgramStatusHistory>;
  findManyLoyaltyProgramStatusHistoryCount: Scalars['Int'];
  findManyLoyaltyReward: Array<LoyaltyReward>;
  findManyLoyaltyRewardCount: Scalars['Int'];
  findManyLoyaltyRewardRedemption: Array<LoyaltyRewardRedemption>;
  findManyLoyaltyRewardRedemptionCount: Scalars['Int'];
  findManyLoyaltyRewardRedemptionHistoryEntry: Array<LoyaltyRewardRedemptionHistoryEntry>;
  findManyLoyaltyRewardRedemptionHistoryEntryCount: Scalars['Int'];
  findManyMassTextAlert: Array<MassTextAlert>;
  findManyMassTextAlertCount: Scalars['Int'];
  findManyMassTextAlertEntry: Array<MassTextAlertEntry>;
  findManyMassTextAlertEntryAppointment: Array<MassTextAlertEntryAppointment>;
  findManyMassTextAlertEntryAppointmentCount: Scalars['Int'];
  findManyMassTextAlertEntryCount: Scalars['Int'];
  findManyMedia: Array<Media>;
  findManyMediaCount: Scalars['Int'];
  findManyMedicalHistory: Array<MedicalHistory>;
  findManyMedicalHistoryCount: Scalars['Int'];
  findManyMessageTemplate: Array<MessageTemplate>;
  findManyMessageTemplateCount: Scalars['Int'];
  findManyMessagingCampaign: Array<MessagingCampaign>;
  findManyMessagingCampaignCount: Scalars['Int'];
  findManyMessagingPartner: Array<MessagingPartner>;
  findManyMessagingPartnerCount: Scalars['Int'];
  findManyModule: Array<Module>;
  findManyModuleCount: Scalars['Int'];
  findManyNonPrismaSchemaScriptRan: Array<NonPrismaSchemaScriptRan>;
  findManyNonPrismaSchemaScriptRanCount: Scalars['Int'];
  findManyNotificationEventToMessage: Array<NotificationEventToMessage>;
  findManyNotificationEventToMessageCount: Scalars['Int'];
  findManyOrganization: Array<Organization>;
  findManyOrganizationCareBenefitToClinicService: Array<OrganizationCareBenefitToClinicService>;
  findManyOrganizationCareBenefitToClinicServiceCategory: Array<OrganizationCareBenefitToClinicServiceCategory>;
  findManyOrganizationCareBenefitToClinicServiceCategoryCount: Scalars['Int'];
  findManyOrganizationCareBenefitToClinicServiceCount: Scalars['Int'];
  findManyOrganizationCount: Scalars['Int'];
  findManyOrganizationPet: Array<OrganizationPet>;
  findManyOrganizationPetCount: Scalars['Int'];
  findManyOrganizationPetParent: Array<OrganizationPetParent>;
  findManyOrganizationPetParentCount: Scalars['Int'];
  findManyOrganizationPetToOrganizationPetParent: Array<OrganizationPetToOrganizationPetParent>;
  findManyOrganizationPetToOrganizationPetParentCount: Scalars['Int'];
  findManyPPCIntegration: Array<PpcIntegration>;
  findManyPPCIntegrationCount: Scalars['Int'];
  findManyParentWorkflowEventSetting: Array<Maybe<WorkflowEventSetting>>;
  findManyPaymentsReportTransaction: Array<PaymentsReportTransaction>;
  findManyPaymentsReportTransactionCount: Scalars['Int'];
  findManyPayoutBatchingPeriod: Array<PayoutBatchingPeriod>;
  findManyPayoutBatchingPeriodCount: Scalars['Int'];
  findManyPayoutBatchingSchedule: Array<PayoutBatchingSchedule>;
  findManyPayoutBatchingScheduleCount: Scalars['Int'];
  findManyPayoutBatchingSetting: Array<PayoutBatchingSetting>;
  findManyPayoutBatchingSettingCount: Scalars['Int'];
  findManyPermission: Array<Permission>;
  findManyPermissionCount: Scalars['Int'];
  findManyPetParentSetting: Array<PetParentSetting>;
  findManyPetParentSettingCount: Scalars['Int'];
  findManyPetPortalSetting: Array<PetPortalSetting>;
  findManyPetPortalSettingCount: Scalars['Int'];
  findManyPhoneNumberLookupRequest: Array<PhoneNumberLookupRequest>;
  findManyPhoneNumberLookupRequestCount: Scalars['Int'];
  findManyPhoneNumberLookupResult: Array<PhoneNumberLookupResult>;
  findManyPhoneNumberLookupResultCount: Scalars['Int'];
  findManyPimsInvoice: Array<PimsInvoice>;
  findManyPimsInvoiceCount: Scalars['Int'];
  findManyPimsInvoiceLineItem: Array<PimsInvoiceLineItem>;
  findManyPimsInvoiceLineItemCount: Scalars['Int'];
  findManyPimsPaymentType: Array<PimsPaymentType>;
  findManyPimsPaymentTypeCount: Scalars['Int'];
  findManyPimsWritebackLogEntry: Array<PimsWritebackLogEntry>;
  findManyPimsWritebackLogEntryCount: Scalars['Int'];
  findManyPrescription: Array<Prescription>;
  findManyPrescriptionCount: Scalars['Int'];
  findManyProduct: Array<Product>;
  findManyProductCount: Scalars['Int'];
  findManyProductPackage: Array<ProductPackage>;
  findManyProductPackageCount: Scalars['Int'];
  findManyProductPackageSubscription: Array<ProductPackageSubscription>;
  findManyProductPackageSubscriptionCount: Scalars['Int'];
  findManyProviderAppointmentTypeRoomMap: Array<ProviderAppointmentTypeRoomMap>;
  findManyProviderAppointmentTypeRoomMapCount: Scalars['Int'];
  findManyPushNotificationLog: Array<PushNotificationLog>;
  findManyPushNotificationLogCount: Scalars['Int'];
  findManyRecap: Array<Recap>;
  findManyRecapCount: Scalars['Int'];
  findManyRules: Array<Rules>;
  findManyRulesCount: Scalars['Int'];
  findManySalesforceAccounts?: Maybe<Array<Maybe<SalesforceAccount>>>;
  findManySegment: Array<Segment>;
  findManySegmentCount: Scalars['Int'];
  findManySentTrupanionExamDayOffer: Array<SentTrupanionExamDayOffer>;
  findManySentTrupanionExamDayOfferCount: Scalars['Int'];
  findManyService: Array<Service>;
  findManyServiceCategory: Array<ServiceCategory>;
  findManyServiceCategoryCount: Scalars['Int'];
  findManyServiceCount: Scalars['Int'];
  findManyServicePurchaseSummary: Array<ServicePurchaseSummary>;
  findManyServicePurchaseSummaryCount: Scalars['Int'];
  findManyServiceReminder: Array<ServiceReminder>;
  findManyServiceReminderCount: Scalars['Int'];
  findManyServiceReminderNotification: Array<ServiceReminderNotification>;
  findManyServiceReminderNotificationCount: Scalars['Int'];
  findManyServiceReminderTiming: Array<ServiceReminderTiming>;
  findManyServiceReminderTimingCount: Scalars['Int'];
  findManySex: Array<Sex>;
  findManySexCount: Scalars['Int'];
  findManySmsNotificationStatus: Array<SmsNotificationStatus>;
  findManySmsNotificationStatusCount: Scalars['Int'];
  findManySpecies: Array<Species>;
  findManySpeciesCount: Scalars['Int'];
  findManyStaffRole: Array<StaffRole>;
  findManyStaffRoleCount: Scalars['Int'];
  findManyStripeCustomer: Array<StripeCustomer>;
  findManyStripeCustomerCount: Scalars['Int'];
  findManyStripeDispute: Array<StripeDispute>;
  findManyStripeDisputeCount: Scalars['Int'];
  findManyStripeInvoice: Array<StripeInvoice>;
  findManyStripeInvoiceCount: Scalars['Int'];
  findManyStripeInvoiceItem: Array<StripeInvoiceItem>;
  findManyStripeInvoiceItemCount: Scalars['Int'];
  findManyStripePaymentIntent: Array<StripePaymentIntent>;
  findManyStripePaymentIntentCount: Scalars['Int'];
  findManyStripePaymentMethod: Array<StripePaymentMethod>;
  findManyStripePaymentMethodCount: Scalars['Int'];
  findManyStripePayout: Array<StripePayout>;
  findManyStripePayoutAccount: Array<StripePayoutAccount>;
  findManyStripePayoutAccountCount: Scalars['Int'];
  findManyStripePayoutCount: Scalars['Int'];
  findManyStripeReceipt: Array<StripeReceipt>;
  findManyStripeReceiptCount: Scalars['Int'];
  findManyStripeReceiptHistory: Array<StripeReceiptHistory>;
  findManyStripeReceiptHistoryCount: Scalars['Int'];
  findManyStripeRefund: Array<StripeRefund>;
  findManyStripeRefundCount: Scalars['Int'];
  findManyStripeTerminal: Array<StripeTerminal>;
  findManyStripeTerminalCount: Scalars['Int'];
  findManyStripeTerminalLocation: Array<StripeTerminalLocation>;
  findManyStripeTerminalLocationCount: Scalars['Int'];
  findManySurveyAppointmentTypeSetting: Array<SurveyAppointmentTypeSetting>;
  findManySurveyAppointmentTypeSettingCount: Scalars['Int'];
  findManySurveyResult: Array<SurveyResult>;
  findManySurveyResultCount: Scalars['Int'];
  findManySurveySetting: Array<SurveySetting>;
  findManySurveySettingCount: Scalars['Int'];
  findManySyncVetIntegration: Array<SyncVetIntegration>;
  findManySyncVetIntegrationCount: Scalars['Int'];
  findManySyncVetService: Array<SyncVetService>;
  findManySyncVetServiceCount: Scalars['Int'];
  findManySynchronyClinicConfiguration: Array<SynchronyClinicConfiguration>;
  findManySynchronyClinicConfigurationCount: Scalars['Int'];
  findManySynchronyEvent: Array<SynchronyEvent>;
  findManySynchronyEventCount: Scalars['Int'];
  findManyTask: Array<Task>;
  findManyTaskCount: Scalars['Int'];
  findManyTaxonomy: Array<Taxonomy>;
  findManyTaxonomyCount: Scalars['Int'];
  findManyTaxonomyToInformAudienceDefinition: Array<TaxonomyToInformAudienceDefinition>;
  findManyTaxonomyToInformAudienceDefinitionCount: Scalars['Int'];
  findManyTransaction: Array<Transaction>;
  findManyTransactionCount: Scalars['Int'];
  findManyTrupanionCertificateAvailability: Array<TrupanionCertificateAvailability>;
  findManyTrupanionCertificateAvailabilityCount: Scalars['Int'];
  findManyTrupanionIntegratedAppointmentType: Array<TrupanionIntegratedAppointmentType>;
  findManyTrupanionIntegratedAppointmentTypeCount: Scalars['Int'];
  findManyTrupanionIntegration: Array<TrupanionIntegration>;
  findManyTrupanionIntegrationCount: Scalars['Int'];
  findManyTwilioCallRecording: Array<TwilioCallRecording>;
  findManyTwilioCallRecordingCount: Scalars['Int'];
  findManyUser: Array<User>;
  findManyUserAppointmentGrouping: Array<UserAppointmentGrouping>;
  findManyUserAppointmentGroupingCount: Scalars['Int'];
  findManyUserBoardFilter: Array<UserBoardFilter>;
  findManyUserBoardFilterCount: Scalars['Int'];
  findManyUserChannelFilterSelection: Array<UserChannelFilterSelection>;
  findManyUserChannelFilterSelectionCount: Scalars['Int'];
  findManyUserCount: Scalars['Int'];
  findManyUserNotificationSetting: Array<UserNotificationSetting>;
  findManyUserNotificationSettingCount: Scalars['Int'];
  findManyUserSetting: Array<UserSetting>;
  findManyUserSettingCount: Scalars['Int'];
  findManyUserTaskList: Array<UserTaskList>;
  findManyUserTaskListCount: Scalars['Int'];
  findManyUserTaskListFilter: Array<UserTaskListFilter>;
  findManyUserTaskListFilterCount: Scalars['Int'];
  findManyVaccination: Array<Vaccination>;
  findManyVaccinationCount: Scalars['Int'];
  findManyVetAvailability: Array<VetAvailability>;
  findManyVetAvailabilityClinicRoomMap: Array<VetAvailabilityClinicRoomMap>;
  findManyVetAvailabilityClinicRoomMapCount: Scalars['Int'];
  findManyVetAvailabilityCount: Scalars['Int'];
  findManyVetAvailabilityMap: Array<VetAvailabilityMap>;
  findManyVetAvailabilityMapCount: Scalars['Int'];
  findManyVetInfo: Array<VetInfo>;
  findManyVetInfoCount: Scalars['Int'];
  findManyVetsourceCodeTag: Array<VetsourceCodeTag>;
  findManyVetsourceCodeTagCount: Scalars['Int'];
  findManyVetsourceInstallation: Array<VetsourceInstallation>;
  findManyVetsourceInstallationCount: Scalars['Int'];
  findManyVetsourcePharmacyIntegration: Array<VetsourcePharmacyIntegration>;
  findManyVetsourcePharmacyIntegrationCount: Scalars['Int'];
  findManyVetsourceRevenueCategory: Array<VetsourceRevenueCategory>;
  findManyVetsourceRevenueCategoryCount: Scalars['Int'];
  findManyWorkflowEventSetting: Array<WorkflowEventSetting>;
  findManyWorkflowEventSettingCount: Scalars['Int'];
  findMissingPayoutBatchingPeriodDates: FindMissingBatchingPeriodDatesOutput;
  findOrganizationPetParentByToken?: Maybe<OrganizationPetParent>;
  findUniqueActiveIngredient?: Maybe<ActiveIngredient>;
  findUniqueAiRecapPimsWritebackLogEntry?: Maybe<AiRecapPimsWritebackLogEntry>;
  findUniqueAppointment?: Maybe<Appointment>;
  findUniqueAppointmentAvailability?: Maybe<AppointmentAvailability>;
  findUniqueAppointmentNoteTemplate?: Maybe<AppointmentNoteTemplate>;
  findUniqueAppointmentType?: Maybe<AppointmentType>;
  findUniqueAutomationRun?: Maybe<AutomationRun>;
  findUniqueAutomationRunAction?: Maybe<AutomationRunAction>;
  findUniqueAxionClinicConfiguration?: Maybe<AxionClinicConfiguration>;
  findUniqueAxionClinicUserConfiguration?: Maybe<AxionClinicUserConfiguration>;
  findUniqueBedrockInference?: Maybe<BedrockInference>;
  findUniqueBitwerxHealthcheck?: Maybe<BitwerxHealthcheck>;
  findUniqueBitwerxIntegration?: Maybe<BitwerxIntegration>;
  findUniqueBitwerxPaymentHealthcheckResult?: Maybe<BitwerxPaymentHealthcheckResult>;
  findUniqueBitwerxPaymentHealthcheckRun?: Maybe<BitwerxPaymentHealthcheckRun>;
  findUniqueBitwerxPaymentWritebackConfiguration?: Maybe<BitwerxPaymentWritebackConfiguration>;
  findUniqueBoardFilterColumn?: Maybe<BoardFilterColumn>;
  findUniqueBoardFilterSpecificDateRange?: Maybe<BoardFilterSpecificDateRange>;
  findUniqueBoehringerIngelheimCustomerAlignment?: Maybe<BoehringerIngelheimCustomerAlignment>;
  findUniqueBoehringerIngelheimTerritory?: Maybe<BoehringerIngelheimTerritory>;
  findUniqueBreed?: Maybe<Breed>;
  findUniqueCallHistory?: Maybe<CallHistory>;
  findUniqueCallParticipant?: Maybe<CallParticipant>;
  findUniqueCallRecording?: Maybe<CallRecording>;
  findUniqueCampaignRegistryCampaign?: Maybe<CampaignRegistryCampaign>;
  findUniqueCanonicalBreed?: Maybe<CanonicalBreed>;
  findUniqueCanonicalCanineBreedProfile?: Maybe<CanonicalCanineBreedProfile>;
  findUniqueCanonicalService?: Maybe<CanonicalService>;
  findUniqueCanonicalSpecies?: Maybe<CanonicalSpecies>;
  findUniqueCareAccountCreditIntent?: Maybe<CareAccountCreditIntent>;
  findUniqueCareAccountCreditPimsWritebackLogEntry?: Maybe<CareAccountCreditPimsWritebackLogEntry>;
  findUniqueCareAddonEnrollment?: Maybe<CareAddonEnrollment>;
  findUniqueCareAddonPackage?: Maybe<CareAddonPackage>;
  findUniqueCareAddonPackageBenefit?: Maybe<CareAddonPackageBenefit>;
  findUniqueCareAuthorizationRequest?: Maybe<CareAuthorizationRequest>;
  findUniqueCareBenefit?: Maybe<CareBenefit>;
  findUniqueCareBenefitUsage?: Maybe<CareBenefitUsage>;
  findUniqueCareBenefitUsageFollowup?: Maybe<CareBenefitUsageFollowup>;
  findUniqueCareBenefitUsageFollowupStep?: Maybe<CareBenefitUsageFollowupStep>;
  findUniqueCareBenefitUsageToInvoiceLineItem?: Maybe<CareBenefitUsageToInvoiceLineItem>;
  findUniqueCareCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheck>;
  findUniqueCareEnrollmentPayment?: Maybe<CareEnrollmentPayment>;
  findUniqueCareEnrollmentToStripeInvoiceItem?: Maybe<CareEnrollmentToStripeInvoiceItem>;
  findUniqueCareLapsedPayment?: Maybe<CareLapsedPayment>;
  findUniqueCarePlan?: Maybe<CarePlan>;
  findUniqueCarePlanBenefit?: Maybe<CarePlanBenefit>;
  findUniqueCarePlanBenefitEnrollmentCarryover?: Maybe<CarePlanBenefitEnrollmentCarryover>;
  findUniqueCarePlanEnrollment?: Maybe<CarePlanEnrollment>;
  findUniqueCarePlanPricing?: Maybe<CarePlanPricing>;
  findUniqueCarePlanProviderGroup?: Maybe<CarePlanProviderGroup>;
  findUniqueCareStripeSubscription?: Maybe<CareStripeSubscription>;
  findUniqueCareSubscriptionTrueUp?: Maybe<CareSubscriptionTrueUp>;
  findUniqueCareSubscriptionTrueUpLogEntry?: Maybe<CareSubscriptionTrueUpLogEntry>;
  findUniqueChannel?: Maybe<Channel>;
  findUniqueChannelAutomationStatus?: Maybe<ChannelAutomationStatus>;
  findUniqueChannelCreationSource?: Maybe<ChannelCreationSource>;
  findUniqueChannelFilterSelection?: Maybe<ChannelFilterSelection>;
  findUniqueChannelMember?: Maybe<ChannelMember>;
  findUniqueChannelMessage?: Maybe<ChannelMessage>;
  findUniqueChannelMessageAttachment?: Maybe<ChannelMessageAttachment>;
  findUniqueChannelMessageAutoResponse?: Maybe<ChannelMessageAutoResponse>;
  findUniqueChannelMessageReaction?: Maybe<ChannelMessageReaction>;
  findUniqueChannelPin?: Maybe<ChannelPin>;
  findUniqueChannelSelection?: Maybe<ChannelSelection>;
  findUniqueChannelStatus?: Maybe<ChannelStatus>;
  findUniqueChannelStatusChannelAssignee?: Maybe<ChannelStatusChannelAssignee>;
  findUniqueChemicalCompound?: Maybe<ChemicalCompound>;
  findUniqueClientConnectIntegration?: Maybe<ClientConnectIntegration>;
  findUniqueClinic?: Maybe<Clinic>;
  findUniqueClinicBlockedPhoneNumber?: Maybe<ClinicBlockedPhoneNumber>;
  findUniqueClinicCustomPayoutsSetup?: Maybe<ClinicCustomPayoutsSetup>;
  findUniqueClinicDirectBookingSetting?: Maybe<ClinicDirectBookingSetting>;
  findUniqueClinicEmailCampaignSetting?: Maybe<ClinicEmailCampaignSetting>;
  findUniqueClinicEmployee?: Maybe<ClinicEmployee>;
  findUniqueClinicEmployeeAppointmentTypeSetting?: Maybe<ClinicEmployeeAppointmentTypeSetting>;
  findUniqueClinicEntityPhoneNumber?: Maybe<ClinicEntityPhoneNumber>;
  findUniqueClinicModule?: Maybe<ClinicModule>;
  findUniqueClinicOfficeHour?: Maybe<ClinicOfficeHour>;
  findUniqueClinicOnboarding?: Maybe<ClinicOnboarding>;
  findUniqueClinicPaymentFeeConfiguration?: Maybe<ClinicPaymentFeeConfiguration>;
  findUniqueClinicPet?: Maybe<ClinicPet>;
  findUniqueClinicPetAlert?: Maybe<ClinicPetAlert>;
  findUniqueClinicPetCustomFieldValue?: Maybe<ClinicPetCustomFieldValue>;
  findUniqueClinicPetParent?: Maybe<ClinicPetParent>;
  findUniqueClinicPetParentAddress?: Maybe<ClinicPetParentAddress>;
  findUniqueClinicPetParentCustomFieldValue?: Maybe<ClinicPetParentCustomFieldValue>;
  findUniqueClinicPetParentDevice?: Maybe<ClinicPetParentDevice>;
  findUniqueClinicPetParentPimsSyncStatus?: Maybe<ClinicPetParentPimsSyncStatus>;
  findUniqueClinicPetPimsSyncStatus?: Maybe<ClinicPetPimsSyncStatus>;
  findUniqueClinicPhoneNumber?: Maybe<ClinicPhoneNumber>;
  findUniqueClinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  findUniqueClinicPimsIntegrationCapability?: Maybe<ClinicPimsIntegrationCapability>;
  findUniqueClinicPimsIntegrationCapabilityHistoryEntry?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntry>;
  findUniqueClinicPostcardSetting?: Maybe<ClinicPostcardSetting>;
  findUniqueClinicRoom?: Maybe<ClinicRoom>;
  findUniqueClinicSetting?: Maybe<ClinicSetting>;
  findUniqueClinicUserFilter?: Maybe<ClinicUserFilter>;
  findUniqueClinicWidgetRequest?: Maybe<ClinicWidgetRequest>;
  findUniqueClinicWidgetRequestType?: Maybe<ClinicWidgetRequestType>;
  findUniqueClinicWidgetSetting?: Maybe<ClinicWidgetSetting>;
  findUniqueColor?: Maybe<Color>;
  findUniqueCondition?: Maybe<Condition>;
  findUniqueConditionSet?: Maybe<ConditionSet>;
  findUniqueConditionalEntityEvaluation?: Maybe<ConditionalEntityEvaluation>;
  findUniqueConsultation?: Maybe<Consultation>;
  findUniqueConsultationRequest?: Maybe<ConsultationRequest>;
  findUniqueCustomFieldDefinition?: Maybe<CustomFieldDefinition>;
  findUniqueCustomFieldPimsWritebackLogEntry?: Maybe<CustomFieldPimsWritebackLogEntry>;
  findUniqueDirectBookingAppointmentTypeSetting?: Maybe<DirectBookingAppointmentTypeSetting>;
  findUniqueDirectBookingExclusionRule?: Maybe<DirectBookingExclusionRule>;
  findUniqueDirectBookingExclusionTimeSlot?: Maybe<DirectBookingExclusionTimeSlot>;
  findUniqueDisbursement?: Maybe<Disbursement>;
  findUniqueDocumentation?: Maybe<Documentation>;
  findUniqueEmailCampaign?: Maybe<EmailCampaign>;
  findUniqueEmailCampaignCustomList?: Maybe<EmailCampaignCustomList>;
  findUniqueEmailCampaignCustomListRecipient?: Maybe<EmailCampaignCustomListRecipient>;
  findUniqueEmailCampaignCustomListUploadHistory?: Maybe<EmailCampaignCustomListUploadHistory>;
  findUniqueEmailCampaignLog?: Maybe<EmailCampaignLog>;
  findUniqueEmailCampaignTemplate?: Maybe<EmailCampaignTemplate>;
  findUniqueEmailCampaignUnsubscribe?: Maybe<EmailCampaignUnsubscribe>;
  findUniqueEmailProviderLog?: Maybe<EmailProviderLog>;
  findUniqueEmergencyClinics?: Maybe<EmergencyClinics>;
  findUniqueEncryptedClinicUpload?: Maybe<EncryptedClinicUpload>;
  findUniqueEnrollmentSupportEvent?: Maybe<EnrollmentSupportEvent>;
  findUniqueEzyVetIntegration?: Maybe<EzyVetIntegration>;
  findUniqueFeatureFlag?: Maybe<FeatureFlag>;
  findUniqueFinancialAdjustment?: Maybe<FinancialAdjustment>;
  findUniqueFinancialTransaction?: Maybe<FinancialTransaction>;
  findUniqueFormSubmission?: Maybe<FormSubmission>;
  findUniqueFormTemplate?: Maybe<FormTemplate>;
  findUniqueGlobalPetParent?: Maybe<GlobalPetParent>;
  findUniqueGooglePlace?: Maybe<GooglePlace>;
  findUniqueHillsToHomeAPILog?: Maybe<HillsToHomeApiLog>;
  findUniqueInformAudienceDefinition?: Maybe<InformAudienceDefinition>;
  findUniqueInformAudienceMember?: Maybe<InformAudienceMember>;
  findUniqueInformAudienceMemberMessage?: Maybe<InformAudienceMemberMessage>;
  findUniqueInformAutomationCampaign?: Maybe<InformAutomationCampaign>;
  findUniqueInformCampaign?: Maybe<InformCampaign>;
  findUniqueInformCampaignEnrollment?: Maybe<InformCampaignEnrollment>;
  findUniqueInformCampaignEnrollmentCanonicalService?: Maybe<InformCampaignEnrollmentCanonicalService>;
  findUniqueInformCampaignExecution?: Maybe<InformCampaignExecution>;
  findUniqueInformCampaignGroup?: Maybe<InformCampaignGroup>;
  findUniqueInformCommunicationOptOut?: Maybe<InformCommunicationOptOut>;
  findUniqueInformControlGroupParticipant?: Maybe<InformControlGroupParticipant>;
  findUniqueInformEmailTemplate?: Maybe<InformEmailTemplate>;
  findUniqueInformEntityHistory?: Maybe<InformEntityHistory>;
  findUniqueInformEventDrivenCampaign?: Maybe<InformEventDrivenCampaign>;
  findUniqueInformEventListener?: Maybe<InformEventListener>;
  findUniqueInformNotificationRecipient?: Maybe<InformNotificationRecipient>;
  findUniqueInformPartner?: Maybe<InformPartner>;
  findUniqueInformPartnerCustomer?: Maybe<InformPartnerCustomer>;
  findUniqueInformPartnerCustomerPharmacyProvider?: Maybe<InformPartnerCustomerPharmacyProvider>;
  findUniqueInformPartnerIntegration?: Maybe<InformPartnerIntegration>;
  findUniqueInformPartnerIntegrationModel?: Maybe<InformPartnerIntegrationModel>;
  findUniqueInformPartnerProgram?: Maybe<InformPartnerProgram>;
  findUniqueInformPartnerProgramEnrollment?: Maybe<InformPartnerProgramEnrollment>;
  findUniqueInformPartnerUser?: Maybe<InformPartnerUser>;
  findUniqueInformPartnerUserRole?: Maybe<InformPartnerUserRole>;
  findUniqueInformScheduledCampaign?: Maybe<InformScheduledCampaign>;
  findUniqueInformSession?: Maybe<InformSession>;
  findUniqueInformSessionEvent?: Maybe<InformSessionEvent>;
  findUniqueInstinctIntegration?: Maybe<InstinctIntegration>;
  findUniqueInsuranceIntegration?: Maybe<InsuranceIntegration>;
  findUniqueIntegrationOutageHistoryEntry?: Maybe<IntegrationOutageHistoryEntry>;
  findUniqueInterchangeRate?: Maybe<InterchangeRate>;
  findUniqueInvoice?: Maybe<Invoice>;
  findUniqueInvoiceLineItem?: Maybe<InvoiceLineItem>;
  findUniqueInvoicePimsWritebackLogEntry?: Maybe<InvoicePimsWritebackLogEntry>;
  findUniqueLabPanel?: Maybe<LabPanel>;
  findUniqueLabResult?: Maybe<LabResult>;
  findUniqueLapsedPetParentTriggers?: Maybe<LapsedPetParentTriggers>;
  findUniqueLegalEntity?: Maybe<LegalEntity>;
  findUniqueLoyaltyAccount?: Maybe<LoyaltyAccount>;
  findUniqueLoyaltyAccountHolder?: Maybe<LoyaltyAccountHolder>;
  findUniqueLoyaltyAccountMerger?: Maybe<LoyaltyAccountMerger>;
  findUniqueLoyaltyInvoicePointGranter?: Maybe<LoyaltyInvoicePointGranter>;
  findUniqueLoyaltyPointDelta?: Maybe<LoyaltyPointDelta>;
  findUniqueLoyaltyPointGrantingService?: Maybe<LoyaltyPointGrantingService>;
  findUniqueLoyaltyPointGrantingServiceCategory?: Maybe<LoyaltyPointGrantingServiceCategory>;
  findUniqueLoyaltyPointUserGrant?: Maybe<LoyaltyPointUserGrant>;
  findUniqueLoyaltyProgram?: Maybe<LoyaltyProgram>;
  findUniqueLoyaltyProgramStatusHistory?: Maybe<LoyaltyProgramStatusHistory>;
  findUniqueLoyaltyReward?: Maybe<LoyaltyReward>;
  findUniqueLoyaltyRewardRedemption?: Maybe<LoyaltyRewardRedemption>;
  findUniqueLoyaltyRewardRedemptionHistoryEntry?: Maybe<LoyaltyRewardRedemptionHistoryEntry>;
  findUniqueMassTextAlert?: Maybe<MassTextAlert>;
  findUniqueMassTextAlertEntry?: Maybe<MassTextAlertEntry>;
  findUniqueMassTextAlertEntryAppointment?: Maybe<MassTextAlertEntryAppointment>;
  findUniqueMedia?: Maybe<Media>;
  findUniqueMedicalHistory?: Maybe<MedicalHistory>;
  findUniqueMessageTemplate?: Maybe<MessageTemplate>;
  findUniqueMessagingCampaign?: Maybe<MessagingCampaign>;
  findUniqueMessagingPartner?: Maybe<MessagingPartner>;
  findUniqueModule?: Maybe<Module>;
  findUniqueNonPrismaSchemaScriptRan?: Maybe<NonPrismaSchemaScriptRan>;
  findUniqueNotificationEventToMessage?: Maybe<NotificationEventToMessage>;
  findUniqueOrganization?: Maybe<Organization>;
  findUniqueOrganizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicService>;
  findUniqueOrganizationCareBenefitToClinicServiceCategory?: Maybe<OrganizationCareBenefitToClinicServiceCategory>;
  findUniqueOrganizationPet?: Maybe<OrganizationPet>;
  findUniqueOrganizationPetParent?: Maybe<OrganizationPetParent>;
  findUniqueOrganizationPetToOrganizationPetParent?: Maybe<OrganizationPetToOrganizationPetParent>;
  findUniquePPCIntegration?: Maybe<PpcIntegration>;
  findUniquePaymentsReportTransaction?: Maybe<PaymentsReportTransaction>;
  findUniquePayoutBatchingPeriod?: Maybe<PayoutBatchingPeriod>;
  findUniquePayoutBatchingSchedule?: Maybe<PayoutBatchingSchedule>;
  findUniquePayoutBatchingSetting?: Maybe<PayoutBatchingSetting>;
  findUniquePermission?: Maybe<Permission>;
  findUniquePetParentSetting?: Maybe<PetParentSetting>;
  findUniquePetPortalSetting?: Maybe<PetPortalSetting>;
  findUniquePhoneNumberLookupRequest?: Maybe<PhoneNumberLookupRequest>;
  findUniquePhoneNumberLookupResult?: Maybe<PhoneNumberLookupResult>;
  findUniquePimsInvoice?: Maybe<PimsInvoice>;
  findUniquePimsInvoiceLineItem?: Maybe<PimsInvoiceLineItem>;
  findUniquePimsPaymentType?: Maybe<PimsPaymentType>;
  findUniquePimsWritebackLogEntry?: Maybe<PimsWritebackLogEntry>;
  findUniquePrescription?: Maybe<Prescription>;
  findUniqueProduct?: Maybe<Product>;
  findUniqueProductPackage?: Maybe<ProductPackage>;
  findUniqueProductPackageSubscription?: Maybe<ProductPackageSubscription>;
  findUniqueProviderAppointmentTypeRoomMap?: Maybe<ProviderAppointmentTypeRoomMap>;
  findUniquePushNotificationLog?: Maybe<PushNotificationLog>;
  findUniqueRecap?: Maybe<Recap>;
  findUniqueRules?: Maybe<Rules>;
  findUniqueSalesforceAccount?: Maybe<UniqueSalesforceAccount>;
  findUniqueSegment?: Maybe<Segment>;
  findUniqueSentTrupanionExamDayOffer?: Maybe<SentTrupanionExamDayOffer>;
  findUniqueService?: Maybe<Service>;
  findUniqueServiceCategory?: Maybe<ServiceCategory>;
  findUniqueServicePurchaseSummary?: Maybe<ServicePurchaseSummary>;
  findUniqueServiceReminder?: Maybe<ServiceReminder>;
  findUniqueServiceReminderNotification?: Maybe<ServiceReminderNotification>;
  findUniqueServiceReminderTiming?: Maybe<ServiceReminderTiming>;
  findUniqueSex?: Maybe<Sex>;
  findUniqueSmsNotificationStatus?: Maybe<SmsNotificationStatus>;
  findUniqueSpecies?: Maybe<Species>;
  findUniqueStaffRole?: Maybe<StaffRole>;
  findUniqueStripeCustomer?: Maybe<StripeCustomer>;
  findUniqueStripeDispute?: Maybe<StripeDispute>;
  findUniqueStripeInvoice?: Maybe<StripeInvoice>;
  findUniqueStripeInvoiceItem?: Maybe<StripeInvoiceItem>;
  findUniqueStripePaymentIntent?: Maybe<StripePaymentIntent>;
  findUniqueStripePaymentMethod?: Maybe<StripePaymentMethod>;
  findUniqueStripePayout?: Maybe<StripePayout>;
  findUniqueStripePayoutAccount?: Maybe<StripePayoutAccount>;
  findUniqueStripeReceipt?: Maybe<StripeReceipt>;
  findUniqueStripeReceiptHistory?: Maybe<StripeReceiptHistory>;
  findUniqueStripeRefund?: Maybe<StripeRefund>;
  findUniqueStripeTerminal?: Maybe<StripeTerminal>;
  findUniqueStripeTerminalLocation?: Maybe<StripeTerminalLocation>;
  findUniqueSurveyAppointmentTypeSetting?: Maybe<SurveyAppointmentTypeSetting>;
  findUniqueSurveyResult?: Maybe<SurveyResult>;
  findUniqueSurveySetting?: Maybe<SurveySetting>;
  findUniqueSyncVetIntegration?: Maybe<SyncVetIntegration>;
  findUniqueSyncVetService?: Maybe<SyncVetService>;
  findUniqueSynchronyClinicConfiguration?: Maybe<SynchronyClinicConfiguration>;
  findUniqueSynchronyEvent?: Maybe<SynchronyEvent>;
  findUniqueTask?: Maybe<Task>;
  findUniqueTaxonomy?: Maybe<Taxonomy>;
  findUniqueTaxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinition>;
  findUniqueTransaction?: Maybe<Transaction>;
  findUniqueTrupanionCertificateAvailability?: Maybe<TrupanionCertificateAvailability>;
  findUniqueTrupanionIntegratedAppointmentType?: Maybe<TrupanionIntegratedAppointmentType>;
  findUniqueTrupanionIntegration?: Maybe<TrupanionIntegration>;
  findUniqueTwilioCallRecording?: Maybe<TwilioCallRecording>;
  findUniqueUser?: Maybe<User>;
  findUniqueUserAppointmentGrouping?: Maybe<UserAppointmentGrouping>;
  findUniqueUserBoardFilter?: Maybe<UserBoardFilter>;
  findUniqueUserChannelFilterSelection?: Maybe<UserChannelFilterSelection>;
  findUniqueUserNotificationSetting?: Maybe<UserNotificationSetting>;
  findUniqueUserSetting?: Maybe<UserSetting>;
  findUniqueUserTaskList?: Maybe<UserTaskList>;
  findUniqueUserTaskListFilter?: Maybe<UserTaskListFilter>;
  findUniqueVaccination?: Maybe<Vaccination>;
  findUniqueVetAvailability?: Maybe<VetAvailability>;
  findUniqueVetAvailabilityClinicRoomMap?: Maybe<VetAvailabilityClinicRoomMap>;
  findUniqueVetAvailabilityMap?: Maybe<VetAvailabilityMap>;
  findUniqueVetInfo?: Maybe<VetInfo>;
  findUniqueVetsourceCodeTag?: Maybe<VetsourceCodeTag>;
  findUniqueVetsourceInstallation?: Maybe<VetsourceInstallation>;
  findUniqueVetsourcePharmacyIntegration?: Maybe<VetsourcePharmacyIntegration>;
  findUniqueVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategory>;
  findUniqueWorkflowEventSetting?: Maybe<WorkflowEventSetting>;
  formSubmissionExport?: Maybe<FileExportData>;
  generatePetIdPdf: GeneratePetIdPdfResponse;
  getAppointmentHistory: GetEntityHistoryOutput;
  getAppointmentRecapUrl?: Maybe<Scalars['String']>;
  getAvailableFormTemplatesForWorkflows: Array<Maybe<FormTemplate>>;
  getBalanceForClient?: Maybe<BitwerxClientBalance>;
  getChannelStatusIdsWithEntityCountOfZero: Array<Scalars['String']>;
  getClinicDirectBookingSettings?: Maybe<ClinicDirectBookingSettingsResponse>;
  getClinicEmailCampaignTemplates: Array<EmailCampaignTemplate>;
  getClinicPetHistory: GetEntityHistoryOutput;
  getClinicPetParentHistory: GetEntityHistoryOutput;
  getCurrentInformPartnerUser?: Maybe<InformPartnerUser>;
  getCurrentUser?: Maybe<User>;
  getDirectBookingAppointmentTypes: Array<Maybe<DirectBookingAppointmentTypes>>;
  getDirectBookingOpenTimeSlots2: DirectBookingOpenTimeSlot2Response;
  getDisbursements: GetDisbursementsOutput;
  getDisputes: GetDisputesOutput;
  getEmailCampaignCustomListUrl?: Maybe<Scalars['String']>;
  getEmailCampaignSegmentCount?: Maybe<Scalars['Int']>;
  getFinancialTransactionTotals: GetFinancialTransactionTotalsOutput;
  getFinancialTransactions: GetFinancialTransactionsOutput;
  getHasConflictingAppointment?: Maybe<Scalars['Boolean']>;
  getInvoiceById?: Maybe<Invoice>;
  getInvoicesForClient: Array<Invoice>;
  getInvoicesForClients: Array<Invoice>;
  getLatestActiveSubscriptionInvoice?: Maybe<GetLatestActiveSubscriptionInvoiceOutput>;
  getOrCreateActiveChannel?: Maybe<Channel>;
  getPetIdData: GetPetIdDataResponse;
  getPossiblyDeflectedFormSubmission?: Maybe<FormSubmission>;
  getQuickSightAdminDashboards?: Maybe<Array<Maybe<DashboardSummary>>>;
  getQuickSightDashboards?: Maybe<Array<Maybe<DashboardSummary>>>;
  getQuickSightEmbedURL?: Maybe<EmbedUrl>;
  getStripePaymentIntentData?: Maybe<StripePaymentOutput>;
  getTeletriageStatuses: Array<TeletriageChannelStatus>;
  getTeletriageUserClinics: Array<Maybe<Clinic>>;
  getTerminalToken?: Maybe<StripeTerminalTokenOutput>;
  getTwilioNumbers?: Maybe<GenericResponse>;
  getWorkflowEventActionHistory: GetEntityHistoryOutput;
  getWorkflowEventSettingHistory: GetEntityHistoryOutput;
  healthCheck?: Maybe<GenericResponse>;
  invokeConverseAiRequest: InvokeAiConverseOutput;
  jobChainStatus?: Maybe<JobChainStatus>;
  massTextAlertReport?: Maybe<Array<Maybe<MassTextAlertReportEntry>>>;
  renderWorkflowNotificationBody?: Maybe<Scalars['String']>;
  retrieveAuthTokenForContact?: Maybe<ChurnZeroResponse>;
  root?: Maybe<Scalars['String']>;
  savedChannelFilterSelections: Array<ChannelFilterSelection>;
  searchPhoneNumber?: Maybe<SearchPhoneNumberResponse>;
  searchTwilioNumbers?: Maybe<GenericResponse>;
  sendConsultationReceipt?: Maybe<Scalars['Json']>;
  sendDailyCronJobs?: Maybe<Scalars['Json']>;
  sendDailyFinancialReport?: Maybe<Scalars['Json']>;
  sendPetParentReceipt?: Maybe<Scalars['Json']>;
  sendVetSubscriptionReceipt?: Maybe<Scalars['Json']>;
  stripeCreateAccountSession?: Maybe<StripeCreateAccountSessionOutput>;
  stripeCreateCustomerPortal?: Maybe<StripeCustomerPortalOutput>;
  stripeCreateLoginLink?: Maybe<LoginLinkOutput>;
  stripeRetrieveConnectedAccount?: Maybe<StripeAccountOutput>;
  stripeRetrievePetParentPortalUrl?: Maybe<StripeCustomerPortalOutput>;
  teletriageChannelSearch: TeletriageChannelSearchOutput;
  teletriageChannelUnreadMessageCount: TeletriageChannelUnreadMessageCountResult;
  tokenValidation?: Maybe<Scalars['Json']>;
  trupanionCertificateAvailability?: Maybe<Array<Maybe<TrupanionAvailability>>>;
  trupanionHospitalSearch?: Maybe<Array<Maybe<TrupanionHospital>>>;
  twilioA2PRegistrationStatus?: Maybe<GenericResponse>;
  twilioCapabilityToken?: Maybe<TwilioCapabilityToken>;
  twilioEligibilityCheck?: Maybe<GenericResponse>;
  userAppointmentGroupingsFilters: Scalars['Json'];
  verificationCheck?: Maybe<GenericResponse>;
  verificationRequest?: Maybe<GenericResponse>;
  verifyTerminalSetupPin: VerifyTerminalSetupPinResponse;
  widgetClinicPetParentLookup: Array<WidgetClinicPetParentLookupResponse>;
};


export type QueryAggregateActiveIngredientArgs = {
  cursor?: Maybe<ActiveIngredientWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ActiveIngredientOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ActiveIngredientWhereInput>;
};


export type QueryAggregateAiRecapPimsWritebackLogEntryArgs = {
  cursor?: Maybe<AiRecapPimsWritebackLogEntryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<AiRecapPimsWritebackLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
};


export type QueryAggregateAppointmentArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type QueryAggregateAppointmentAvailabilityArgs = {
  cursor?: Maybe<AppointmentAvailabilityWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<AppointmentAvailabilityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentAvailabilityWhereInput>;
};


export type QueryAggregateAppointmentNoteTemplateArgs = {
  cursor?: Maybe<AppointmentNoteTemplateWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<AppointmentNoteTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentNoteTemplateWhereInput>;
};


export type QueryAggregateAppointmentTypeArgs = {
  cursor?: Maybe<AppointmentTypeWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<AppointmentTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type QueryAggregateAutomationRunArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type QueryAggregateAutomationRunActionArgs = {
  cursor?: Maybe<AutomationRunActionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<AutomationRunActionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type QueryAggregateAxionClinicConfigurationArgs = {
  cursor?: Maybe<AxionClinicConfigurationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<AxionClinicConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AxionClinicConfigurationWhereInput>;
};


export type QueryAggregateAxionClinicUserConfigurationArgs = {
  cursor?: Maybe<AxionClinicUserConfigurationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<AxionClinicUserConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AxionClinicUserConfigurationWhereInput>;
};


export type QueryAggregateBedrockInferenceArgs = {
  cursor?: Maybe<BedrockInferenceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<BedrockInferenceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BedrockInferenceWhereInput>;
};


export type QueryAggregateBitwerxHealthcheckArgs = {
  cursor?: Maybe<BitwerxHealthcheckWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<BitwerxHealthcheckOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxHealthcheckWhereInput>;
};


export type QueryAggregateBitwerxIntegrationArgs = {
  cursor?: Maybe<BitwerxIntegrationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<BitwerxIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxIntegrationWhereInput>;
};


export type QueryAggregateBitwerxPaymentHealthcheckResultArgs = {
  cursor?: Maybe<BitwerxPaymentHealthcheckResultWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentHealthcheckResultWhereInput>;
};


export type QueryAggregateBitwerxPaymentHealthcheckRunArgs = {
  cursor?: Maybe<BitwerxPaymentHealthcheckRunWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentHealthcheckRunWhereInput>;
};


export type QueryAggregateBoardFilterColumnArgs = {
  cursor?: Maybe<BoardFilterColumnWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<BoardFilterColumnOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoardFilterColumnWhereInput>;
};


export type QueryAggregateBoardFilterSpecificDateRangeArgs = {
  cursor?: Maybe<BoardFilterSpecificDateRangeWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<BoardFilterSpecificDateRangeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoardFilterSpecificDateRangeWhereInput>;
};


export type QueryAggregateBoehringerIngelheimCustomerAlignmentArgs = {
  cursor?: Maybe<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<BoehringerIngelheimCustomerAlignmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoehringerIngelheimCustomerAlignmentWhereInput>;
};


export type QueryAggregateBoehringerIngelheimTerritoryArgs = {
  cursor?: Maybe<BoehringerIngelheimTerritoryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<BoehringerIngelheimTerritoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};


export type QueryAggregateBreedArgs = {
  cursor?: Maybe<BreedWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<BreedOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BreedWhereInput>;
};


export type QueryAggregateCallHistoryArgs = {
  cursor?: Maybe<CallHistoryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CallHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallHistoryWhereInput>;
};


export type QueryAggregateCallParticipantArgs = {
  cursor?: Maybe<CallParticipantWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CallParticipantOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallParticipantWhereInput>;
};


export type QueryAggregateCallRecordingArgs = {
  cursor?: Maybe<CallRecordingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CallRecordingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallRecordingWhereInput>;
};


export type QueryAggregateCampaignRegistryCampaignArgs = {
  cursor?: Maybe<CampaignRegistryCampaignWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CampaignRegistryCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CampaignRegistryCampaignWhereInput>;
};


export type QueryAggregateCanonicalBreedArgs = {
  cursor?: Maybe<CanonicalBreedWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CanonicalBreedOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalBreedWhereInput>;
};


export type QueryAggregateCanonicalCanineBreedProfileArgs = {
  cursor?: Maybe<CanonicalCanineBreedProfileWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CanonicalCanineBreedProfileOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalCanineBreedProfileWhereInput>;
};


export type QueryAggregateCanonicalServiceArgs = {
  cursor?: Maybe<CanonicalServiceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CanonicalServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalServiceWhereInput>;
};


export type QueryAggregateCanonicalSpeciesArgs = {
  cursor?: Maybe<CanonicalSpeciesWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CanonicalSpeciesOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalSpeciesWhereInput>;
};


export type QueryAggregateCareAccountCreditIntentArgs = {
  cursor?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareAccountCreditIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};


export type QueryAggregateCareAccountCreditPimsWritebackLogEntryArgs = {
  cursor?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareAccountCreditPimsWritebackLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
};


export type QueryAggregateCareAddonEnrollmentArgs = {
  cursor?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareAddonEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};


export type QueryAggregateCareAddonPackageArgs = {
  cursor?: Maybe<CareAddonPackageWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareAddonPackageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonPackageWhereInput>;
};


export type QueryAggregateCareAddonPackageBenefitArgs = {
  cursor?: Maybe<CareAddonPackageBenefitWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareAddonPackageBenefitOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonPackageBenefitWhereInput>;
};


export type QueryAggregateCareAuthorizationRequestArgs = {
  cursor?: Maybe<CareAuthorizationRequestWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareAuthorizationRequestOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAuthorizationRequestWhereInput>;
};


export type QueryAggregateCareBenefitArgs = {
  cursor?: Maybe<CareBenefitWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareBenefitOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitWhereInput>;
};


export type QueryAggregateCareBenefitUsageArgs = {
  cursor?: Maybe<CareBenefitUsageWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageWhereInput>;
};


export type QueryAggregateCareBenefitUsageFollowupArgs = {
  cursor?: Maybe<CareBenefitUsageFollowupWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageFollowupOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageFollowupWhereInput>;
};


export type QueryAggregateCareBenefitUsageFollowupStepArgs = {
  cursor?: Maybe<CareBenefitUsageFollowupStepWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageFollowupStepOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};


export type QueryAggregateCareBenefitUsageToInvoiceLineItemArgs = {
  cursor?: Maybe<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
};


export type QueryAggregateCareCreditPreapprovalCheckArgs = {
  cursor?: Maybe<CareCreditPreapprovalCheckWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareCreditPreapprovalCheckOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};


export type QueryAggregateCareEnrollmentPaymentArgs = {
  cursor?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentPaymentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};


export type QueryAggregateCareEnrollmentToStripeInvoiceItemArgs = {
  cursor?: Maybe<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentToStripeInvoiceItemWhereInput>;
};


export type QueryAggregateCareLapsedPaymentArgs = {
  cursor?: Maybe<CareLapsedPaymentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareLapsedPaymentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareLapsedPaymentWhereInput>;
};


export type QueryAggregateCarePlanArgs = {
  cursor?: Maybe<CarePlanWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CarePlanOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanWhereInput>;
};


export type QueryAggregateCarePlanBenefitArgs = {
  cursor?: Maybe<CarePlanBenefitWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitWhereInput>;
};


export type QueryAggregateCarePlanBenefitEnrollmentCarryoverArgs = {
  cursor?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereInput>;
};


export type QueryAggregateCarePlanEnrollmentArgs = {
  cursor?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CarePlanEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type QueryAggregateCarePlanPricingArgs = {
  cursor?: Maybe<CarePlanPricingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CarePlanPricingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type QueryAggregateCarePlanProviderGroupArgs = {
  cursor?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CarePlanProviderGroupOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type QueryAggregateCareStripeSubscriptionArgs = {
  cursor?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareStripeSubscriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type QueryAggregateCareSubscriptionTrueUpArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
};


export type QueryAggregateCareSubscriptionTrueUpLogEntryArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpLogEntryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpLogEntryWhereInput>;
};


export type QueryAggregateChannelArgs = {
  cursor?: Maybe<ChannelWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelWhereInput>;
};


export type QueryAggregateChannelAutomationStatusArgs = {
  cursor?: Maybe<ChannelAutomationStatusWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelAutomationStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type QueryAggregateChannelCreationSourceArgs = {
  cursor?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelCreationSourceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type QueryAggregateChannelFilterSelectionArgs = {
  cursor?: Maybe<ChannelFilterSelectionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelFilterSelectionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelFilterSelectionWhereInput>;
};


export type QueryAggregateChannelMemberArgs = {
  cursor?: Maybe<ChannelMemberWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelMemberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMemberWhereInput>;
};


export type QueryAggregateChannelMessageArgs = {
  cursor?: Maybe<ChannelMessageWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageWhereInput>;
};


export type QueryAggregateChannelMessageAttachmentArgs = {
  cursor?: Maybe<ChannelMessageAttachmentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageAttachmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageAttachmentWhereInput>;
};


export type QueryAggregateChannelMessageAutoResponseArgs = {
  cursor?: Maybe<ChannelMessageAutoResponseWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageAutoResponseOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageAutoResponseWhereInput>;
};


export type QueryAggregateChannelMessageReactionArgs = {
  cursor?: Maybe<ChannelMessageReactionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageReactionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageReactionWhereInput>;
};


export type QueryAggregateChannelPinArgs = {
  cursor?: Maybe<ChannelPinWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelPinOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelPinWhereInput>;
};


export type QueryAggregateChannelSelectionArgs = {
  cursor?: Maybe<ChannelSelectionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelSelectionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelSelectionWhereInput>;
};


export type QueryAggregateChannelStatusArgs = {
  cursor?: Maybe<ChannelStatusWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusWhereInput>;
};


export type QueryAggregateChannelStatusChannelAssigneeArgs = {
  cursor?: Maybe<ChannelStatusChannelAssigneeWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusChannelAssigneeWhereInput>;
};


export type QueryAggregateChemicalCompoundArgs = {
  cursor?: Maybe<ChemicalCompoundWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ChemicalCompoundOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChemicalCompoundWhereInput>;
};


export type QueryAggregateClientConnectIntegrationArgs = {
  cursor?: Maybe<ClientConnectIntegrationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClientConnectIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClientConnectIntegrationWhereInput>;
};


export type QueryAggregateClinicArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type QueryAggregateClinicBlockedPhoneNumberArgs = {
  cursor?: Maybe<ClinicBlockedPhoneNumberWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
};


export type QueryAggregateClinicCustomPayoutsSetupArgs = {
  cursor?: Maybe<ClinicCustomPayoutsSetupWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicCustomPayoutsSetupOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
};


export type QueryAggregateClinicDirectBookingSettingArgs = {
  cursor?: Maybe<ClinicDirectBookingSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicDirectBookingSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicDirectBookingSettingWhereInput>;
};


export type QueryAggregateClinicEmailCampaignSettingArgs = {
  cursor?: Maybe<ClinicEmailCampaignSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicEmailCampaignSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmailCampaignSettingWhereInput>;
};


export type QueryAggregateClinicEmployeeArgs = {
  cursor?: Maybe<ClinicEmployeeWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type QueryAggregateClinicEmployeeAppointmentTypeSettingArgs = {
  cursor?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeAppointmentTypeSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereInput>;
};


export type QueryAggregateClinicEntityPhoneNumberArgs = {
  cursor?: Maybe<ClinicEntityPhoneNumberWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicEntityPhoneNumberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEntityPhoneNumberWhereInput>;
};


export type QueryAggregateClinicModuleArgs = {
  cursor?: Maybe<ClinicModuleWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicModuleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicModuleWhereInput>;
};


export type QueryAggregateClinicOfficeHourArgs = {
  cursor?: Maybe<ClinicOfficeHourWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicOfficeHourOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicOfficeHourWhereInput>;
};


export type QueryAggregateClinicOnboardingArgs = {
  cursor?: Maybe<ClinicOnboardingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicOnboardingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicOnboardingWhereInput>;
};


export type QueryAggregateClinicPaymentFeeConfigurationArgs = {
  cursor?: Maybe<ClinicPaymentFeeConfigurationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPaymentFeeConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
};


export type QueryAggregateClinicPetArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type QueryAggregateClinicPetAlertArgs = {
  cursor?: Maybe<ClinicPetAlertWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPetAlertOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetAlertWhereInput>;
};


export type QueryAggregateClinicPetCustomFieldValueArgs = {
  cursor?: Maybe<ClinicPetCustomFieldValueWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPetCustomFieldValueOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetCustomFieldValueWhereInput>;
};


export type QueryAggregateClinicPetParentArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type QueryAggregateClinicPetParentAddressArgs = {
  cursor?: Maybe<ClinicPetParentAddressWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentAddressOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentAddressWhereInput>;
};


export type QueryAggregateClinicPetParentCustomFieldValueArgs = {
  cursor?: Maybe<ClinicPetParentCustomFieldValueWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentCustomFieldValueOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentCustomFieldValueWhereInput>;
};


export type QueryAggregateClinicPetParentDeviceArgs = {
  cursor?: Maybe<ClinicPetParentDeviceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentDeviceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentDeviceWhereInput>;
};


export type QueryAggregateClinicPetParentPimsSyncStatusArgs = {
  cursor?: Maybe<ClinicPetParentPimsSyncStatusWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentPimsSyncStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentPimsSyncStatusWhereInput>;
};


export type QueryAggregateClinicPetPimsSyncStatusArgs = {
  cursor?: Maybe<ClinicPetPimsSyncStatusWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPetPimsSyncStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetPimsSyncStatusWhereInput>;
};


export type QueryAggregateClinicPhoneNumberArgs = {
  cursor?: Maybe<ClinicPhoneNumberWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPhoneNumberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPhoneNumberWhereInput>;
};


export type QueryAggregateClinicPimsIntegrationArgs = {
  cursor?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type QueryAggregateClinicPimsIntegrationCapabilityArgs = {
  cursor?: Maybe<ClinicPimsIntegrationCapabilityWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationCapabilityWhereInput>;
};


export type QueryAggregateClinicPimsIntegrationCapabilityHistoryEntryArgs = {
  cursor?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityHistoryEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>;
};


export type QueryAggregateClinicPostcardSettingArgs = {
  cursor?: Maybe<ClinicPostcardSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicPostcardSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPostcardSettingWhereInput>;
};


export type QueryAggregateClinicRoomArgs = {
  cursor?: Maybe<ClinicRoomWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicRoomOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicRoomWhereInput>;
};


export type QueryAggregateClinicSettingArgs = {
  cursor?: Maybe<ClinicSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicSettingWhereInput>;
};


export type QueryAggregateClinicUserFilterArgs = {
  cursor?: Maybe<ClinicUserFilterWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicUserFilterOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicUserFilterWhereInput>;
};


export type QueryAggregateClinicWidgetRequestArgs = {
  cursor?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type QueryAggregateClinicWidgetRequestTypeArgs = {
  cursor?: Maybe<ClinicWidgetRequestTypeWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};


export type QueryAggregateClinicWidgetSettingArgs = {
  cursor?: Maybe<ClinicWidgetSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetSettingWhereInput>;
};


export type QueryAggregateColorArgs = {
  cursor?: Maybe<ColorWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ColorOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ColorWhereInput>;
};


export type QueryAggregateConditionArgs = {
  cursor?: Maybe<ConditionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ConditionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionWhereInput>;
};


export type QueryAggregateConditionSetArgs = {
  cursor?: Maybe<ConditionSetWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ConditionSetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionSetWhereInput>;
};


export type QueryAggregateConditionalEntityEvaluationArgs = {
  cursor?: Maybe<ConditionalEntityEvaluationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ConditionalEntityEvaluationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionalEntityEvaluationWhereInput>;
};


export type QueryAggregateConsultationArgs = {
  cursor?: Maybe<ConsultationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ConsultationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationWhereInput>;
};


export type QueryAggregateConsultationRequestArgs = {
  cursor?: Maybe<ConsultationRequestWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ConsultationRequestOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationRequestWhereInput>;
};


export type QueryAggregateCustomFieldDefinitionArgs = {
  cursor?: Maybe<CustomFieldDefinitionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CustomFieldDefinitionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};


export type QueryAggregateCustomFieldPimsWritebackLogEntryArgs = {
  cursor?: Maybe<CustomFieldPimsWritebackLogEntryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<CustomFieldPimsWritebackLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
};


export type QueryAggregateDirectBookingAppointmentTypeSettingArgs = {
  cursor?: Maybe<DirectBookingAppointmentTypeSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<DirectBookingAppointmentTypeSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingAppointmentTypeSettingWhereInput>;
};


export type QueryAggregateDisbursementArgs = {
  cursor?: Maybe<DisbursementWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<DisbursementOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DisbursementWhereInput>;
};


export type QueryAggregateDocumentationArgs = {
  cursor?: Maybe<DocumentationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<DocumentationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentationWhereInput>;
};


export type QueryAggregateEmailCampaignArgs = {
  cursor?: Maybe<EmailCampaignWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignWhereInput>;
};


export type QueryAggregateEmailCampaignCustomListArgs = {
  cursor?: Maybe<EmailCampaignCustomListWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListWhereInput>;
};


export type QueryAggregateEmailCampaignCustomListRecipientArgs = {
  cursor?: Maybe<EmailCampaignCustomListRecipientWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListRecipientOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListRecipientWhereInput>;
};


export type QueryAggregateEmailCampaignCustomListUploadHistoryArgs = {
  cursor?: Maybe<EmailCampaignCustomListUploadHistoryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListUploadHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListUploadHistoryWhereInput>;
};


export type QueryAggregateEmailCampaignLogArgs = {
  cursor?: Maybe<EmailCampaignLogWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignLogWhereInput>;
};


export type QueryAggregateEmailCampaignTemplateArgs = {
  cursor?: Maybe<EmailCampaignTemplateWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignTemplateWhereInput>;
};


export type QueryAggregateEmailCampaignUnsubscribeArgs = {
  cursor?: Maybe<EmailCampaignUnsubscribeWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignUnsubscribeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignUnsubscribeWhereInput>;
};


export type QueryAggregateEmailProviderLogArgs = {
  cursor?: Maybe<EmailProviderLogWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<EmailProviderLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailProviderLogWhereInput>;
};


export type QueryAggregateEmergencyClinicsArgs = {
  cursor?: Maybe<EmergencyClinicsWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<EmergencyClinicsOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmergencyClinicsWhereInput>;
};


export type QueryAggregateEncryptedClinicUploadArgs = {
  cursor?: Maybe<EncryptedClinicUploadWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<EncryptedClinicUploadOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};


export type QueryAggregateEnrollmentSupportEventArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type QueryAggregateEzyVetIntegrationArgs = {
  cursor?: Maybe<EzyVetIntegrationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<EzyVetIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EzyVetIntegrationWhereInput>;
};


export type QueryAggregateFeatureFlagArgs = {
  cursor?: Maybe<FeatureFlagWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<FeatureFlagOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FeatureFlagWhereInput>;
};


export type QueryAggregateFinancialAdjustmentArgs = {
  cursor?: Maybe<FinancialAdjustmentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<FinancialAdjustmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialAdjustmentWhereInput>;
};


export type QueryAggregateFinancialTransactionArgs = {
  cursor?: Maybe<FinancialTransactionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<FinancialTransactionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type QueryAggregateFormSubmissionArgs = {
  cursor?: Maybe<FormSubmissionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<FormSubmissionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormSubmissionWhereInput>;
};


export type QueryAggregateFormTemplateArgs = {
  cursor?: Maybe<FormTemplateWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<FormTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormTemplateWhereInput>;
};


export type QueryAggregateGlobalPetParentArgs = {
  cursor?: Maybe<GlobalPetParentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<GlobalPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GlobalPetParentWhereInput>;
};


export type QueryAggregateGooglePlaceArgs = {
  cursor?: Maybe<GooglePlaceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<GooglePlaceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GooglePlaceWhereInput>;
};


export type QueryAggregateHillsToHomeApiLogArgs = {
  cursor?: Maybe<HillsToHomeApiLogWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<HillsToHomeApiLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<HillsToHomeApiLogWhereInput>;
};


export type QueryAggregateInformAudienceDefinitionArgs = {
  cursor?: Maybe<InformAudienceDefinitionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformAudienceDefinitionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};


export type QueryAggregateInformAudienceMemberArgs = {
  cursor?: Maybe<InformAudienceMemberWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberWhereInput>;
};


export type QueryAggregateInformAudienceMemberMessageArgs = {
  cursor?: Maybe<InformAudienceMemberMessageWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberMessageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberMessageWhereInput>;
};


export type QueryAggregateInformAutomationCampaignArgs = {
  cursor?: Maybe<InformAutomationCampaignWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformAutomationCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAutomationCampaignWhereInput>;
};


export type QueryAggregateInformCampaignArgs = {
  cursor?: Maybe<InformCampaignWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignWhereInput>;
};


export type QueryAggregateInformCampaignEnrollmentArgs = {
  cursor?: Maybe<InformCampaignEnrollmentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformCampaignEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignEnrollmentWhereInput>;
};


export type QueryAggregateInformCampaignEnrollmentCanonicalServiceArgs = {
  cursor?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformCampaignEnrollmentCanonicalServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereInput>;
};


export type QueryAggregateInformCampaignExecutionArgs = {
  cursor?: Maybe<InformCampaignExecutionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformCampaignExecutionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignExecutionWhereInput>;
};


export type QueryAggregateInformCampaignGroupArgs = {
  cursor?: Maybe<InformCampaignGroupWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformCampaignGroupOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignGroupWhereInput>;
};


export type QueryAggregateInformCommunicationOptOutArgs = {
  cursor?: Maybe<InformCommunicationOptOutWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformCommunicationOptOutOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCommunicationOptOutWhereInput>;
};


export type QueryAggregateInformControlGroupParticipantArgs = {
  cursor?: Maybe<InformControlGroupParticipantWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformControlGroupParticipantOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformControlGroupParticipantWhereInput>;
};


export type QueryAggregateInformEmailTemplateArgs = {
  cursor?: Maybe<InformEmailTemplateWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformEmailTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEmailTemplateWhereInput>;
};


export type QueryAggregateInformEntityHistoryArgs = {
  cursor?: Maybe<InformEntityHistoryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformEntityHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEntityHistoryWhereInput>;
};


export type QueryAggregateInformEventDrivenCampaignArgs = {
  cursor?: Maybe<InformEventDrivenCampaignWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformEventDrivenCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEventDrivenCampaignWhereInput>;
};


export type QueryAggregateInformEventListenerArgs = {
  cursor?: Maybe<InformEventListenerWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformEventListenerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEventListenerWhereInput>;
};


export type QueryAggregateInformNotificationRecipientArgs = {
  cursor?: Maybe<InformNotificationRecipientWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformNotificationRecipientOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformNotificationRecipientWhereInput>;
};


export type QueryAggregateInformPartnerArgs = {
  cursor?: Maybe<InformPartnerWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformPartnerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerWhereInput>;
};


export type QueryAggregateInformPartnerCustomerArgs = {
  cursor?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};


export type QueryAggregateInformPartnerCustomerPharmacyProviderArgs = {
  cursor?: Maybe<InformPartnerCustomerPharmacyProviderWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerPharmacyProviderOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerPharmacyProviderWhereInput>;
};


export type QueryAggregateInformPartnerIntegrationArgs = {
  cursor?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformPartnerIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};


export type QueryAggregateInformPartnerIntegrationModelArgs = {
  cursor?: Maybe<InformPartnerIntegrationModelWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformPartnerIntegrationModelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerIntegrationModelWhereInput>;
};


export type QueryAggregateInformPartnerProgramArgs = {
  cursor?: Maybe<InformPartnerProgramWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformPartnerProgramOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerProgramWhereInput>;
};


export type QueryAggregateInformPartnerProgramEnrollmentArgs = {
  cursor?: Maybe<InformPartnerProgramEnrollmentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};


export type QueryAggregateInformPartnerUserArgs = {
  cursor?: Maybe<InformPartnerUserWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserWhereInput>;
};


export type QueryAggregateInformPartnerUserRoleArgs = {
  cursor?: Maybe<InformPartnerUserRoleWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserRoleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserRoleWhereInput>;
};


export type QueryAggregateInformScheduledCampaignArgs = {
  cursor?: Maybe<InformScheduledCampaignWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformScheduledCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformScheduledCampaignWhereInput>;
};


export type QueryAggregateInformSessionArgs = {
  cursor?: Maybe<InformSessionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformSessionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionWhereInput>;
};


export type QueryAggregateInformSessionEventArgs = {
  cursor?: Maybe<InformSessionEventWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InformSessionEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionEventWhereInput>;
};


export type QueryAggregateInstinctIntegrationArgs = {
  cursor?: Maybe<InstinctIntegrationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InstinctIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InstinctIntegrationWhereInput>;
};


export type QueryAggregateInsuranceIntegrationArgs = {
  cursor?: Maybe<InsuranceIntegrationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InsuranceIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InsuranceIntegrationWhereInput>;
};


export type QueryAggregateIntegrationOutageHistoryEntryArgs = {
  cursor?: Maybe<IntegrationOutageHistoryEntryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<IntegrationOutageHistoryEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<IntegrationOutageHistoryEntryWhereInput>;
};


export type QueryAggregateInterchangeRateArgs = {
  cursor?: Maybe<InterchangeRateWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InterchangeRateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InterchangeRateWhereInput>;
};


export type QueryAggregateInvoiceArgs = {
  cursor?: Maybe<InvoiceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InvoiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceWhereInput>;
};


export type QueryAggregateInvoiceLineItemArgs = {
  cursor?: Maybe<InvoiceLineItemWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceLineItemWhereInput>;
};


export type QueryAggregateInvoicePimsWritebackLogEntryArgs = {
  cursor?: Maybe<InvoicePimsWritebackLogEntryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<InvoicePimsWritebackLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
};


export type QueryAggregateLabPanelArgs = {
  cursor?: Maybe<LabPanelWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LabPanelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabPanelWhereInput>;
};


export type QueryAggregateLabResultArgs = {
  cursor?: Maybe<LabResultWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LabResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabResultWhereInput>;
};


export type QueryAggregateLapsedPetParentTriggersArgs = {
  cursor?: Maybe<LapsedPetParentTriggersWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LapsedPetParentTriggersOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LapsedPetParentTriggersWhereInput>;
};


export type QueryAggregateLegalEntityArgs = {
  cursor?: Maybe<LegalEntityWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LegalEntityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LegalEntityWhereInput>;
};


export type QueryAggregateLoyaltyAccountArgs = {
  cursor?: Maybe<LoyaltyAccountWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountWhereInput>;
};


export type QueryAggregateLoyaltyAccountHolderArgs = {
  cursor?: Maybe<LoyaltyAccountHolderWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountHolderOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};


export type QueryAggregateLoyaltyAccountMergerArgs = {
  cursor?: Maybe<LoyaltyAccountMergerWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountMergerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountMergerWhereInput>;
};


export type QueryAggregateLoyaltyInvoicePointGranterArgs = {
  cursor?: Maybe<LoyaltyInvoicePointGranterWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};


export type QueryAggregateLoyaltyPointDeltaArgs = {
  cursor?: Maybe<LoyaltyPointDeltaWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointDeltaOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
};


export type QueryAggregateLoyaltyPointGrantingServiceArgs = {
  cursor?: Maybe<LoyaltyPointGrantingServiceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointGrantingServiceWhereInput>;
};


export type QueryAggregateLoyaltyPointGrantingServiceCategoryArgs = {
  cursor?: Maybe<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceCategoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointGrantingServiceCategoryWhereInput>;
};


export type QueryAggregateLoyaltyPointUserGrantArgs = {
  cursor?: Maybe<LoyaltyPointUserGrantWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointUserGrantOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointUserGrantWhereInput>;
};


export type QueryAggregateLoyaltyProgramArgs = {
  cursor?: Maybe<LoyaltyProgramWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyProgramOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyProgramWhereInput>;
};


export type QueryAggregateLoyaltyProgramStatusHistoryArgs = {
  cursor?: Maybe<LoyaltyProgramStatusHistoryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyProgramStatusHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyProgramStatusHistoryWhereInput>;
};


export type QueryAggregateLoyaltyRewardArgs = {
  cursor?: Maybe<LoyaltyRewardWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardWhereInput>;
};


export type QueryAggregateLoyaltyRewardRedemptionArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionWhereInput>;
};


export type QueryAggregateLoyaltyRewardRedemptionHistoryEntryArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
};


export type QueryAggregateMassTextAlertArgs = {
  cursor?: Maybe<MassTextAlertWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertWhereInput>;
};


export type QueryAggregateMassTextAlertEntryArgs = {
  cursor?: Maybe<MassTextAlertEntryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertEntryWhereInput>;
};


export type QueryAggregateMassTextAlertEntryAppointmentArgs = {
  cursor?: Maybe<MassTextAlertEntryAppointmentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertEntryAppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertEntryAppointmentWhereInput>;
};


export type QueryAggregateMediaArgs = {
  cursor?: Maybe<MediaWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<MediaOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MediaWhereInput>;
};


export type QueryAggregateMedicalHistoryArgs = {
  cursor?: Maybe<MedicalHistoryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<MedicalHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MedicalHistoryWhereInput>;
};


export type QueryAggregateMessageTemplateArgs = {
  cursor?: Maybe<MessageTemplateWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<MessageTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessageTemplateWhereInput>;
};


export type QueryAggregateMessagingCampaignArgs = {
  cursor?: Maybe<MessagingCampaignWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<MessagingCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessagingCampaignWhereInput>;
};


export type QueryAggregateMessagingPartnerArgs = {
  cursor?: Maybe<MessagingPartnerWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<MessagingPartnerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessagingPartnerWhereInput>;
};


export type QueryAggregateModuleArgs = {
  cursor?: Maybe<ModuleWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ModuleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ModuleWhereInput>;
};


export type QueryAggregateNonPrismaSchemaScriptRanArgs = {
  cursor?: Maybe<NonPrismaSchemaScriptRanWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<NonPrismaSchemaScriptRanOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<NonPrismaSchemaScriptRanWhereInput>;
};


export type QueryAggregateNotificationEventToMessageArgs = {
  cursor?: Maybe<NotificationEventToMessageWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<NotificationEventToMessageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<NotificationEventToMessageWhereInput>;
};


export type QueryAggregateOrganizationArgs = {
  cursor?: Maybe<OrganizationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<OrganizationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationWhereInput>;
};


export type QueryAggregateOrganizationCareBenefitToClinicServiceArgs = {
  cursor?: Maybe<OrganizationCareBenefitToClinicServiceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationCareBenefitToClinicServiceWhereInput>;
};


export type QueryAggregateOrganizationCareBenefitToClinicServiceCategoryArgs = {
  cursor?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereInput>;
};


export type QueryAggregateOrganizationPetArgs = {
  cursor?: Maybe<OrganizationPetWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetWhereInput>;
};


export type QueryAggregateOrganizationPetParentArgs = {
  cursor?: Maybe<OrganizationPetParentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetParentWhereInput>;
};


export type QueryAggregateOrganizationPetToOrganizationPetParentArgs = {
  cursor?: Maybe<OrganizationPetToOrganizationPetParentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetToOrganizationPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetToOrganizationPetParentWhereInput>;
};


export type QueryAggregatePpcIntegrationArgs = {
  cursor?: Maybe<PpcIntegrationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PpcIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PpcIntegrationWhereInput>;
};


export type QueryAggregatePaymentsReportTransactionArgs = {
  cursor?: Maybe<PaymentsReportTransactionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PaymentsReportTransactionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PaymentsReportTransactionWhereInput>;
};


export type QueryAggregatePayoutBatchingScheduleArgs = {
  cursor?: Maybe<PayoutBatchingScheduleWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingScheduleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingScheduleWhereInput>;
};


export type QueryAggregatePayoutBatchingSettingArgs = {
  cursor?: Maybe<PayoutBatchingSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingSettingWhereInput>;
};


export type QueryAggregatePermissionArgs = {
  cursor?: Maybe<PermissionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PermissionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PermissionWhereInput>;
};


export type QueryAggregatePetParentSettingArgs = {
  cursor?: Maybe<PetParentSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PetParentSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PetParentSettingWhereInput>;
};


export type QueryAggregatePetPortalSettingArgs = {
  cursor?: Maybe<PetPortalSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PetPortalSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PetPortalSettingWhereInput>;
};


export type QueryAggregatePhoneNumberLookupRequestArgs = {
  cursor?: Maybe<PhoneNumberLookupRequestWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PhoneNumberLookupRequestOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PhoneNumberLookupRequestWhereInput>;
};


export type QueryAggregatePhoneNumberLookupResultArgs = {
  cursor?: Maybe<PhoneNumberLookupResultWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PhoneNumberLookupResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PhoneNumberLookupResultWhereInput>;
};


export type QueryAggregatePimsInvoiceArgs = {
  cursor?: Maybe<PimsInvoiceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PimsInvoiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsInvoiceWhereInput>;
};


export type QueryAggregatePimsInvoiceLineItemArgs = {
  cursor?: Maybe<PimsInvoiceLineItemWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PimsInvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsInvoiceLineItemWhereInput>;
};


export type QueryAggregatePimsPaymentTypeArgs = {
  cursor?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PimsPaymentTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};


export type QueryAggregatePimsWritebackLogEntryArgs = {
  cursor?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PimsWritebackLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};


export type QueryAggregatePrescriptionArgs = {
  cursor?: Maybe<PrescriptionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PrescriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PrescriptionWhereInput>;
};


export type QueryAggregateProductArgs = {
  cursor?: Maybe<ProductWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ProductOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductWhereInput>;
};


export type QueryAggregateProductPackageArgs = {
  cursor?: Maybe<ProductPackageWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ProductPackageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductPackageWhereInput>;
};


export type QueryAggregateProductPackageSubscriptionArgs = {
  cursor?: Maybe<ProductPackageSubscriptionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ProductPackageSubscriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductPackageSubscriptionWhereInput>;
};


export type QueryAggregateProviderAppointmentTypeRoomMapArgs = {
  cursor?: Maybe<ProviderAppointmentTypeRoomMapWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProviderAppointmentTypeRoomMapWhereInput>;
};


export type QueryAggregatePushNotificationLogArgs = {
  cursor?: Maybe<PushNotificationLogWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<PushNotificationLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PushNotificationLogWhereInput>;
};


export type QueryAggregateRecapArgs = {
  cursor?: Maybe<RecapWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<RecapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RecapWhereInput>;
};


export type QueryAggregateRulesArgs = {
  cursor?: Maybe<RulesWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<RulesOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RulesWhereInput>;
};


export type QueryAggregateSegmentArgs = {
  cursor?: Maybe<SegmentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<SegmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SegmentWhereInput>;
};


export type QueryAggregateSentTrupanionExamDayOfferArgs = {
  cursor?: Maybe<SentTrupanionExamDayOfferWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<SentTrupanionExamDayOfferOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};


export type QueryAggregateServiceArgs = {
  cursor?: Maybe<ServiceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceWhereInput>;
};


export type QueryAggregateServiceCategoryArgs = {
  cursor?: Maybe<ServiceCategoryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ServiceCategoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceCategoryWhereInput>;
};


export type QueryAggregateServicePurchaseSummaryArgs = {
  cursor?: Maybe<ServicePurchaseSummaryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ServicePurchaseSummaryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};


export type QueryAggregateServiceReminderArgs = {
  cursor?: Maybe<ServiceReminderWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderWhereInput>;
};


export type QueryAggregateServiceReminderNotificationArgs = {
  cursor?: Maybe<ServiceReminderNotificationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderNotificationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};


export type QueryAggregateServiceReminderTimingArgs = {
  cursor?: Maybe<ServiceReminderTimingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderTimingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderTimingWhereInput>;
};


export type QueryAggregateSexArgs = {
  cursor?: Maybe<SexWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<SexOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SexWhereInput>;
};


export type QueryAggregateSmsNotificationStatusArgs = {
  cursor?: Maybe<SmsNotificationStatusWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<SmsNotificationStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SmsNotificationStatusWhereInput>;
};


export type QueryAggregateSpeciesArgs = {
  cursor?: Maybe<SpeciesWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<SpeciesOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SpeciesWhereInput>;
};


export type QueryAggregateStaffRoleArgs = {
  cursor?: Maybe<StaffRoleWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StaffRoleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StaffRoleWhereInput>;
};


export type QueryAggregateStripeCustomerArgs = {
  cursor?: Maybe<StripeCustomerWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripeCustomerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeCustomerWhereInput>;
};


export type QueryAggregateStripeDisputeArgs = {
  cursor?: Maybe<StripeDisputeWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripeDisputeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeDisputeWhereInput>;
};


export type QueryAggregateStripeInvoiceArgs = {
  cursor?: Maybe<StripeInvoiceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripeInvoiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type QueryAggregateStripeInvoiceItemArgs = {
  cursor?: Maybe<StripeInvoiceItemWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripeInvoiceItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeInvoiceItemWhereInput>;
};


export type QueryAggregateStripePaymentIntentArgs = {
  cursor?: Maybe<StripePaymentIntentWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripePaymentIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type QueryAggregateStripePaymentMethodArgs = {
  cursor?: Maybe<StripePaymentMethodWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripePaymentMethodOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentMethodWhereInput>;
};


export type QueryAggregateStripePayoutArgs = {
  cursor?: Maybe<StripePayoutWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripePayoutOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePayoutWhereInput>;
};


export type QueryAggregateStripePayoutAccountArgs = {
  cursor?: Maybe<StripePayoutAccountWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripePayoutAccountOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePayoutAccountWhereInput>;
};


export type QueryAggregateStripeReceiptArgs = {
  cursor?: Maybe<StripeReceiptWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripeReceiptOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeReceiptWhereInput>;
};


export type QueryAggregateStripeReceiptHistoryArgs = {
  cursor?: Maybe<StripeReceiptHistoryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripeReceiptHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeReceiptHistoryWhereInput>;
};


export type QueryAggregateStripeRefundArgs = {
  cursor?: Maybe<StripeRefundWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripeRefundOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeRefundWhereInput>;
};


export type QueryAggregateStripeTerminalArgs = {
  cursor?: Maybe<StripeTerminalWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripeTerminalOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeTerminalWhereInput>;
};


export type QueryAggregateStripeTerminalLocationArgs = {
  cursor?: Maybe<StripeTerminalLocationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<StripeTerminalLocationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeTerminalLocationWhereInput>;
};


export type QueryAggregateSurveyAppointmentTypeSettingArgs = {
  cursor?: Maybe<SurveyAppointmentTypeSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<SurveyAppointmentTypeSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyAppointmentTypeSettingWhereInput>;
};


export type QueryAggregateSurveyResultArgs = {
  cursor?: Maybe<SurveyResultWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<SurveyResultOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyResultWhereInput>;
};


export type QueryAggregateSurveySettingArgs = {
  cursor?: Maybe<SurveySettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<SurveySettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveySettingWhereInput>;
};


export type QueryAggregateSyncVetIntegrationArgs = {
  cursor?: Maybe<SyncVetIntegrationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<SyncVetIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SyncVetIntegrationWhereInput>;
};


export type QueryAggregateSyncVetServiceArgs = {
  cursor?: Maybe<SyncVetServiceWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<SyncVetServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SyncVetServiceWhereInput>;
};


export type QueryAggregateSynchronyClinicConfigurationArgs = {
  cursor?: Maybe<SynchronyClinicConfigurationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<SynchronyClinicConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SynchronyClinicConfigurationWhereInput>;
};


export type QueryAggregateSynchronyEventArgs = {
  cursor?: Maybe<SynchronyEventWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<SynchronyEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SynchronyEventWhereInput>;
};


export type QueryAggregateTaskArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<TaskOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaskWhereInput>;
};


export type QueryAggregateTaxonomyArgs = {
  cursor?: Maybe<TaxonomyWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<TaxonomyOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaxonomyWhereInput>;
};


export type QueryAggregateTaxonomyToInformAudienceDefinitionArgs = {
  cursor?: Maybe<TaxonomyToInformAudienceDefinitionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<TaxonomyToInformAudienceDefinitionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaxonomyToInformAudienceDefinitionWhereInput>;
};


export type QueryAggregateTransactionArgs = {
  cursor?: Maybe<TransactionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<TransactionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TransactionWhereInput>;
};


export type QueryAggregateTrupanionCertificateAvailabilityArgs = {
  cursor?: Maybe<TrupanionCertificateAvailabilityWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<TrupanionCertificateAvailabilityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionCertificateAvailabilityWhereInput>;
};


export type QueryAggregateTrupanionIntegratedAppointmentTypeArgs = {
  cursor?: Maybe<TrupanionIntegratedAppointmentTypeWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<TrupanionIntegratedAppointmentTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
};


export type QueryAggregateTrupanionIntegrationArgs = {
  cursor?: Maybe<TrupanionIntegrationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<TrupanionIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionIntegrationWhereInput>;
};


export type QueryAggregateTwilioCallRecordingArgs = {
  cursor?: Maybe<TwilioCallRecordingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<TwilioCallRecordingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TwilioCallRecordingWhereInput>;
};


export type QueryAggregateUserArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type QueryAggregateUserAppointmentGroupingArgs = {
  cursor?: Maybe<UserAppointmentGroupingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<UserAppointmentGroupingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAppointmentGroupingWhereInput>;
};


export type QueryAggregateUserBoardFilterArgs = {
  cursor?: Maybe<UserBoardFilterWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<UserBoardFilterOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserBoardFilterWhereInput>;
};


export type QueryAggregateUserChannelFilterSelectionArgs = {
  cursor?: Maybe<UserChannelFilterSelectionWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<UserChannelFilterSelectionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserChannelFilterSelectionWhereInput>;
};


export type QueryAggregateUserNotificationSettingArgs = {
  cursor?: Maybe<UserNotificationSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<UserNotificationSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserNotificationSettingWhereInput>;
};


export type QueryAggregateUserSettingArgs = {
  cursor?: Maybe<UserSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<UserSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserSettingWhereInput>;
};


export type QueryAggregateUserTaskListArgs = {
  cursor?: Maybe<UserTaskListWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<UserTaskListOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserTaskListWhereInput>;
};


export type QueryAggregateUserTaskListFilterArgs = {
  cursor?: Maybe<UserTaskListFilterWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<UserTaskListFilterOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserTaskListFilterWhereInput>;
};


export type QueryAggregateVaccinationArgs = {
  cursor?: Maybe<VaccinationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<VaccinationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VaccinationWhereInput>;
};


export type QueryAggregateVetAvailabilityArgs = {
  cursor?: Maybe<VetAvailabilityWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityWhereInput>;
};


export type QueryAggregateVetAvailabilityClinicRoomMapArgs = {
  cursor?: Maybe<VetAvailabilityClinicRoomMapWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityClinicRoomMapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityClinicRoomMapWhereInput>;
};


export type QueryAggregateVetAvailabilityMapArgs = {
  cursor?: Maybe<VetAvailabilityMapWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityMapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityMapWhereInput>;
};


export type QueryAggregateVetInfoArgs = {
  cursor?: Maybe<VetInfoWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<VetInfoOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetInfoWhereInput>;
};


export type QueryAggregateVetsourceCodeTagArgs = {
  cursor?: Maybe<VetsourceCodeTagWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<VetsourceCodeTagOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceCodeTagWhereInput>;
};


export type QueryAggregateVetsourceInstallationArgs = {
  cursor?: Maybe<VetsourceInstallationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<VetsourceInstallationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceInstallationWhereInput>;
};


export type QueryAggregateVetsourcePharmacyIntegrationArgs = {
  cursor?: Maybe<VetsourcePharmacyIntegrationWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<VetsourcePharmacyIntegrationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourcePharmacyIntegrationWhereInput>;
};


export type QueryAggregateVetsourceRevenueCategoryArgs = {
  cursor?: Maybe<VetsourceRevenueCategoryWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<VetsourceRevenueCategoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};


export type QueryAggregateWorkflowEventSettingArgs = {
  cursor?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};


export type QueryAiChannelSuggestedMessageArgs = {
  alternatePrompt?: Maybe<Scalars['String']>;
  maxTokensToSample?: Maybe<Scalars['Int']>;
  where: ChannelSuggestedMessageWhereInput;
};


export type QueryAiChannelSummaryArgs = {
  alternatePrompt?: Maybe<Scalars['String']>;
  maxTokensToSample?: Maybe<Scalars['Int']>;
  where: ChannelSummaryWhereInput;
};


export type QueryCalculateMultiplePetsBenefitUsageArgs = {
  where?: Maybe<CalculateMultiplePetsBenefitUsageInput>;
};


export type QueryCalculatePetBenefitUsageArgs = {
  where?: Maybe<CalculatePetBenefitUsageInput>;
};


export type QueryCanManuallyRetryPaymentWritebackArgs = {
  stripePaymentIntentId: Scalars['String'];
};


export type QueryCanSendEmailCampaignArgs = {
  clinicId: Scalars['String'];
};


export type QueryChannelExportArgs = {
  where: ChannelExportWhereInput;
};


export type QueryChannelSearchArgs = {
  orderBy?: Maybe<ChannelOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SearchChannelInput>;
};


export type QueryCheckClinicCareStatusArgs = {
  data: CheckClinicCareInput;
};


export type QueryCheckPhoneVerificationArgs = {
  data: CheckPhoneVerificationInput;
};


export type QueryClinicHasAutomationsThatCreateTasksArgs = {
  clinicId: Scalars['String'];
};


export type QueryClinicPetParentSearchArgs = {
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SearchClinicPetParentInput>;
};


export type QueryClinicPetSearchArgs = {
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SearchClinicPetInput>;
};


export type QueryCustomFindUniqueUserBoardFilterArgs = {
  where: CustomFindUniqueUserBoardFilterWhereInput;
};


export type QueryEstimateNumberOfPetParentsReachedArgs = {
  alertBody: Scalars['String'];
  appointmentDateTimeFrom: Scalars['String'];
  appointmentDateTimeTo: Scalars['String'];
  clinicId: Scalars['String'];
};


export type QueryExportCancellationSummaryAsPdfArgs = {
  data: ExportCancellationSummaryAsPdfInput;
};


export type QueryExportItemizedInvoiceAsReceiptPdfArgs = {
  data: ExportItemizedInvoiceToReceiptPdfInput;
};


export type QueryExportNonItemizedReceiptAsPdfArgs = {
  data: ExportNonItemizedReceiptAsPdfInput;
};


export type QueryFindClinicContactInfoArgs = {
  clinicId: Scalars['String'];
};


export type QueryFindClinicPetParentByPhoneOrEmailArgs = {
  where: FindClinicPetParentByPhoneOrEmailRequest;
};


export type QueryFindCurrentEmailTemplateVersionsArgs = {
  data: FindCurrentEmailTemplateVersionInput;
};


export type QueryFindEmployerIdentificationNumberArgs = {
  data: FindEmployerIdentificationNumberInput;
};


export type QueryFindFirstActiveIngredientArgs = {
  cursor?: Maybe<ActiveIngredientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ActiveIngredientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ActiveIngredientOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ActiveIngredientWhereInput>;
};


export type QueryFindFirstAiRecapPimsWritebackLogEntryArgs = {
  cursor?: Maybe<AiRecapPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AiRecapPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AiRecapPimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
};


export type QueryFindFirstAppointmentArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type QueryFindFirstAppointmentAvailabilityArgs = {
  cursor?: Maybe<AppointmentAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentAvailabilityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentAvailabilityWhereInput>;
};


export type QueryFindFirstAppointmentNoteTemplateArgs = {
  cursor?: Maybe<AppointmentNoteTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentNoteTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentNoteTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentNoteTemplateWhereInput>;
};


export type QueryFindFirstAppointmentTypeArgs = {
  cursor?: Maybe<AppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentTypeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type QueryFindFirstAutomationRunArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type QueryFindFirstAutomationRunActionArgs = {
  cursor?: Maybe<AutomationRunActionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunActionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunActionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type QueryFindFirstAxionClinicConfigurationArgs = {
  cursor?: Maybe<AxionClinicConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AxionClinicConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AxionClinicConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AxionClinicConfigurationWhereInput>;
};


export type QueryFindFirstAxionClinicUserConfigurationArgs = {
  cursor?: Maybe<AxionClinicUserConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AxionClinicUserConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AxionClinicUserConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AxionClinicUserConfigurationWhereInput>;
};


export type QueryFindFirstBedrockInferenceArgs = {
  cursor?: Maybe<BedrockInferenceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BedrockInferenceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BedrockInferenceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BedrockInferenceWhereInput>;
};


export type QueryFindFirstBitwerxHealthcheckArgs = {
  cursor?: Maybe<BitwerxHealthcheckWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxHealthcheckScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxHealthcheckOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxHealthcheckWhereInput>;
};


export type QueryFindFirstBitwerxIntegrationArgs = {
  cursor?: Maybe<BitwerxIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxIntegrationWhereInput>;
};


export type QueryFindFirstBitwerxPaymentHealthcheckResultArgs = {
  cursor?: Maybe<BitwerxPaymentHealthcheckResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckResultOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentHealthcheckResultWhereInput>;
};


export type QueryFindFirstBitwerxPaymentHealthcheckRunArgs = {
  cursor?: Maybe<BitwerxPaymentHealthcheckRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckRunOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentHealthcheckRunWhereInput>;
};


export type QueryFindFirstBitwerxPaymentWritebackConfigurationArgs = {
  cursor?: Maybe<BitwerxPaymentWritebackConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
};


export type QueryFindFirstBoardFilterColumnArgs = {
  cursor?: Maybe<BoardFilterColumnWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoardFilterColumnScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoardFilterColumnOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoardFilterColumnWhereInput>;
};


export type QueryFindFirstBoardFilterSpecificDateRangeArgs = {
  cursor?: Maybe<BoardFilterSpecificDateRangeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoardFilterSpecificDateRangeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoardFilterSpecificDateRangeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoardFilterSpecificDateRangeWhereInput>;
};


export type QueryFindFirstBoehringerIngelheimCustomerAlignmentArgs = {
  cursor?: Maybe<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoehringerIngelheimCustomerAlignmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoehringerIngelheimCustomerAlignmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoehringerIngelheimCustomerAlignmentWhereInput>;
};


export type QueryFindFirstBoehringerIngelheimTerritoryArgs = {
  cursor?: Maybe<BoehringerIngelheimTerritoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoehringerIngelheimTerritoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoehringerIngelheimTerritoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};


export type QueryFindFirstBreedArgs = {
  cursor?: Maybe<BreedWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BreedScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BreedOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BreedWhereInput>;
};


export type QueryFindFirstCallHistoryArgs = {
  cursor?: Maybe<CallHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallHistoryWhereInput>;
};


export type QueryFindFirstCallParticipantArgs = {
  cursor?: Maybe<CallParticipantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallParticipantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallParticipantOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallParticipantWhereInput>;
};


export type QueryFindFirstCallRecordingArgs = {
  cursor?: Maybe<CallRecordingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallRecordingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallRecordingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallRecordingWhereInput>;
};


export type QueryFindFirstCampaignRegistryCampaignArgs = {
  cursor?: Maybe<CampaignRegistryCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CampaignRegistryCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CampaignRegistryCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CampaignRegistryCampaignWhereInput>;
};


export type QueryFindFirstCanonicalBreedArgs = {
  cursor?: Maybe<CanonicalBreedWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalBreedScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalBreedOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalBreedWhereInput>;
};


export type QueryFindFirstCanonicalCanineBreedProfileArgs = {
  cursor?: Maybe<CanonicalCanineBreedProfileWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalCanineBreedProfileScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalCanineBreedProfileOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalCanineBreedProfileWhereInput>;
};


export type QueryFindFirstCanonicalServiceArgs = {
  cursor?: Maybe<CanonicalServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalServiceWhereInput>;
};


export type QueryFindFirstCanonicalSpeciesArgs = {
  cursor?: Maybe<CanonicalSpeciesWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalSpeciesScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalSpeciesOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalSpeciesWhereInput>;
};


export type QueryFindFirstCareAccountCreditIntentArgs = {
  cursor?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAccountCreditIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAccountCreditIntentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};


export type QueryFindFirstCareAccountCreditPimsWritebackLogEntryArgs = {
  cursor?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAccountCreditPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAccountCreditPimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
};


export type QueryFindFirstCareAddonEnrollmentArgs = {
  cursor?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonEnrollmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};


export type QueryFindFirstCareAddonPackageArgs = {
  cursor?: Maybe<CareAddonPackageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonPackageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonPackageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonPackageWhereInput>;
};


export type QueryFindFirstCareAddonPackageBenefitArgs = {
  cursor?: Maybe<CareAddonPackageBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonPackageBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonPackageBenefitOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonPackageBenefitWhereInput>;
};


export type QueryFindFirstCareAuthorizationRequestArgs = {
  cursor?: Maybe<CareAuthorizationRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAuthorizationRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAuthorizationRequestOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAuthorizationRequestWhereInput>;
};


export type QueryFindFirstCareBenefitArgs = {
  cursor?: Maybe<CareBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitWhereInput>;
};


export type QueryFindFirstCareBenefitUsageArgs = {
  cursor?: Maybe<CareBenefitUsageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageWhereInput>;
};


export type QueryFindFirstCareBenefitUsageFollowupArgs = {
  cursor?: Maybe<CareBenefitUsageFollowupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageFollowupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageFollowupOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageFollowupWhereInput>;
};


export type QueryFindFirstCareBenefitUsageFollowupStepArgs = {
  cursor?: Maybe<CareBenefitUsageFollowupStepWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageFollowupStepScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageFollowupStepOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};


export type QueryFindFirstCareBenefitUsageToInvoiceLineItemArgs = {
  cursor?: Maybe<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
};


export type QueryFindFirstCareCreditPreapprovalCheckArgs = {
  cursor?: Maybe<CareCreditPreapprovalCheckWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareCreditPreapprovalCheckScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareCreditPreapprovalCheckOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};


export type QueryFindFirstCareEnrollmentPaymentArgs = {
  cursor?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareEnrollmentPaymentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentPaymentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};


export type QueryFindFirstCareEnrollmentToStripeInvoiceItemArgs = {
  cursor?: Maybe<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentToStripeInvoiceItemWhereInput>;
};


export type QueryFindFirstCareLapsedPaymentArgs = {
  cursor?: Maybe<CareLapsedPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareLapsedPaymentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareLapsedPaymentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareLapsedPaymentWhereInput>;
};


export type QueryFindFirstCarePlanArgs = {
  cursor?: Maybe<CarePlanWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanWhereInput>;
};


export type QueryFindFirstCarePlanBenefitArgs = {
  cursor?: Maybe<CarePlanBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitWhereInput>;
};


export type QueryFindFirstCarePlanBenefitEnrollmentCarryoverArgs = {
  cursor?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereInput>;
};


export type QueryFindFirstCarePlanEnrollmentArgs = {
  cursor?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanEnrollmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type QueryFindFirstCarePlanPricingArgs = {
  cursor?: Maybe<CarePlanPricingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanPricingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanPricingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type QueryFindFirstCarePlanProviderGroupArgs = {
  cursor?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanProviderGroupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanProviderGroupOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type QueryFindFirstCareStripeSubscriptionArgs = {
  cursor?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareStripeSubscriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareStripeSubscriptionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type QueryFindFirstCareSubscriptionTrueUpArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareSubscriptionTrueUpScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
};


export type QueryFindFirstCareSubscriptionTrueUpLogEntryArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareSubscriptionTrueUpLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpLogEntryWhereInput>;
};


export type QueryFindFirstChannelArgs = {
  cursor?: Maybe<ChannelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelWhereInput>;
};


export type QueryFindFirstChannelAutomationStatusArgs = {
  cursor?: Maybe<ChannelAutomationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelAutomationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelAutomationStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type QueryFindFirstChannelCreationSourceArgs = {
  cursor?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelCreationSourceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelCreationSourceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type QueryFindFirstChannelFilterSelectionArgs = {
  cursor?: Maybe<ChannelFilterSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelFilterSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelFilterSelectionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelFilterSelectionWhereInput>;
};


export type QueryFindFirstChannelMemberArgs = {
  cursor?: Maybe<ChannelMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMemberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMemberWhereInput>;
};


export type QueryFindFirstChannelMessageArgs = {
  cursor?: Maybe<ChannelMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageWhereInput>;
};


export type QueryFindFirstChannelMessageAttachmentArgs = {
  cursor?: Maybe<ChannelMessageAttachmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageAttachmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageAttachmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageAttachmentWhereInput>;
};


export type QueryFindFirstChannelMessageAutoResponseArgs = {
  cursor?: Maybe<ChannelMessageAutoResponseWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageAutoResponseScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageAutoResponseOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageAutoResponseWhereInput>;
};


export type QueryFindFirstChannelMessageReactionArgs = {
  cursor?: Maybe<ChannelMessageReactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageReactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageReactionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageReactionWhereInput>;
};


export type QueryFindFirstChannelPinArgs = {
  cursor?: Maybe<ChannelPinWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelPinScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelPinOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelPinWhereInput>;
};


export type QueryFindFirstChannelSelectionArgs = {
  cursor?: Maybe<ChannelSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelSelectionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelSelectionWhereInput>;
};


export type QueryFindFirstChannelStatusArgs = {
  cursor?: Maybe<ChannelStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusWhereInput>;
};


export type QueryFindFirstChannelStatusChannelAssigneeArgs = {
  cursor?: Maybe<ChannelStatusChannelAssigneeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusChannelAssigneeWhereInput>;
};


export type QueryFindFirstChemicalCompoundArgs = {
  cursor?: Maybe<ChemicalCompoundWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChemicalCompoundScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChemicalCompoundOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChemicalCompoundWhereInput>;
};


export type QueryFindFirstClientConnectIntegrationArgs = {
  cursor?: Maybe<ClientConnectIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClientConnectIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClientConnectIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClientConnectIntegrationWhereInput>;
};


export type QueryFindFirstClinicArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type QueryFindFirstClinicBlockedPhoneNumberArgs = {
  cursor?: Maybe<ClinicBlockedPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
};


export type QueryFindFirstClinicCustomPayoutsSetupArgs = {
  cursor?: Maybe<ClinicCustomPayoutsSetupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicCustomPayoutsSetupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicCustomPayoutsSetupOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
};


export type QueryFindFirstClinicDirectBookingSettingArgs = {
  cursor?: Maybe<ClinicDirectBookingSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicDirectBookingSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicDirectBookingSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicDirectBookingSettingWhereInput>;
};


export type QueryFindFirstClinicEmailCampaignSettingArgs = {
  cursor?: Maybe<ClinicEmailCampaignSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmailCampaignSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmailCampaignSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmailCampaignSettingWhereInput>;
};


export type QueryFindFirstClinicEmployeeArgs = {
  cursor?: Maybe<ClinicEmployeeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type QueryFindFirstClinicEmployeeAppointmentTypeSettingArgs = {
  cursor?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeAppointmentTypeSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereInput>;
};


export type QueryFindFirstClinicEntityPhoneNumberArgs = {
  cursor?: Maybe<ClinicEntityPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEntityPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEntityPhoneNumberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEntityPhoneNumberWhereInput>;
};


export type QueryFindFirstClinicModuleArgs = {
  cursor?: Maybe<ClinicModuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicModuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicModuleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicModuleWhereInput>;
};


export type QueryFindFirstClinicOfficeHourArgs = {
  cursor?: Maybe<ClinicOfficeHourWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicOfficeHourScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOfficeHourOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicOfficeHourWhereInput>;
};


export type QueryFindFirstClinicOnboardingArgs = {
  cursor?: Maybe<ClinicOnboardingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicOnboardingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOnboardingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicOnboardingWhereInput>;
};


export type QueryFindFirstClinicPaymentFeeConfigurationArgs = {
  cursor?: Maybe<ClinicPaymentFeeConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPaymentFeeConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPaymentFeeConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
};


export type QueryFindFirstClinicPetArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type QueryFindFirstClinicPetAlertArgs = {
  cursor?: Maybe<ClinicPetAlertWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetAlertScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetAlertOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetAlertWhereInput>;
};


export type QueryFindFirstClinicPetCustomFieldValueArgs = {
  cursor?: Maybe<ClinicPetCustomFieldValueWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetCustomFieldValueScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetCustomFieldValueOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetCustomFieldValueWhereInput>;
};


export type QueryFindFirstClinicPetParentArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type QueryFindFirstClinicPetParentAddressArgs = {
  cursor?: Maybe<ClinicPetParentAddressWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentAddressScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentAddressOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentAddressWhereInput>;
};


export type QueryFindFirstClinicPetParentCustomFieldValueArgs = {
  cursor?: Maybe<ClinicPetParentCustomFieldValueWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentCustomFieldValueScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentCustomFieldValueOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentCustomFieldValueWhereInput>;
};


export type QueryFindFirstClinicPetParentDeviceArgs = {
  cursor?: Maybe<ClinicPetParentDeviceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentDeviceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentDeviceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentDeviceWhereInput>;
};


export type QueryFindFirstClinicPetParentPimsSyncStatusArgs = {
  cursor?: Maybe<ClinicPetParentPimsSyncStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentPimsSyncStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentPimsSyncStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentPimsSyncStatusWhereInput>;
};


export type QueryFindFirstClinicPetPimsSyncStatusArgs = {
  cursor?: Maybe<ClinicPetPimsSyncStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetPimsSyncStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetPimsSyncStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetPimsSyncStatusWhereInput>;
};


export type QueryFindFirstClinicPhoneNumberArgs = {
  cursor?: Maybe<ClinicPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPhoneNumberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPhoneNumberWhereInput>;
};


export type QueryFindFirstClinicPimsIntegrationArgs = {
  cursor?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPimsIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type QueryFindFirstClinicPimsIntegrationCapabilityArgs = {
  cursor?: Maybe<ClinicPimsIntegrationCapabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationCapabilityWhereInput>;
};


export type QueryFindFirstClinicPimsIntegrationCapabilityHistoryEntryArgs = {
  cursor?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityHistoryEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>;
};


export type QueryFindFirstClinicPostcardSettingArgs = {
  cursor?: Maybe<ClinicPostcardSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPostcardSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPostcardSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPostcardSettingWhereInput>;
};


export type QueryFindFirstClinicRoomArgs = {
  cursor?: Maybe<ClinicRoomWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicRoomScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicRoomOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicRoomWhereInput>;
};


export type QueryFindFirstClinicSettingArgs = {
  cursor?: Maybe<ClinicSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicSettingWhereInput>;
};


export type QueryFindFirstClinicUserFilterArgs = {
  cursor?: Maybe<ClinicUserFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicUserFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicUserFilterOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicUserFilterWhereInput>;
};


export type QueryFindFirstClinicWidgetRequestArgs = {
  cursor?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type QueryFindFirstClinicWidgetRequestTypeArgs = {
  cursor?: Maybe<ClinicWidgetRequestTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};


export type QueryFindFirstClinicWidgetSettingArgs = {
  cursor?: Maybe<ClinicWidgetSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetSettingWhereInput>;
};


export type QueryFindFirstColorArgs = {
  cursor?: Maybe<ColorWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ColorScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ColorOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ColorWhereInput>;
};


export type QueryFindFirstConditionArgs = {
  cursor?: Maybe<ConditionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConditionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConditionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionWhereInput>;
};


export type QueryFindFirstConditionSetArgs = {
  cursor?: Maybe<ConditionSetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConditionSetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConditionSetOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionSetWhereInput>;
};


export type QueryFindFirstConditionalEntityEvaluationArgs = {
  cursor?: Maybe<ConditionalEntityEvaluationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConditionalEntityEvaluationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConditionalEntityEvaluationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionalEntityEvaluationWhereInput>;
};


export type QueryFindFirstConsultationArgs = {
  cursor?: Maybe<ConsultationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationWhereInput>;
};


export type QueryFindFirstConsultationRequestArgs = {
  cursor?: Maybe<ConsultationRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationRequestOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationRequestWhereInput>;
};


export type QueryFindFirstCustomFieldDefinitionArgs = {
  cursor?: Maybe<CustomFieldDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CustomFieldDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CustomFieldDefinitionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};


export type QueryFindFirstCustomFieldPimsWritebackLogEntryArgs = {
  cursor?: Maybe<CustomFieldPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CustomFieldPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CustomFieldPimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
};


export type QueryFindFirstDirectBookingAppointmentTypeSettingArgs = {
  cursor?: Maybe<DirectBookingAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingAppointmentTypeSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingAppointmentTypeSettingWhereInput>;
};


export type QueryFindFirstDirectBookingExclusionRuleArgs = {
  cursor?: Maybe<DirectBookingExclusionRuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingExclusionRuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingExclusionRuleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingExclusionRuleWhereInput>;
};


export type QueryFindFirstDirectBookingExclusionTimeSlotArgs = {
  cursor?: Maybe<DirectBookingExclusionTimeSlotWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingExclusionTimeSlotScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingExclusionTimeSlotOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingExclusionTimeSlotWhereInput>;
};


export type QueryFindFirstDisbursementArgs = {
  cursor?: Maybe<DisbursementWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DisbursementScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DisbursementOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DisbursementWhereInput>;
};


export type QueryFindFirstDocumentationArgs = {
  cursor?: Maybe<DocumentationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DocumentationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DocumentationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentationWhereInput>;
};


export type QueryFindFirstEmailCampaignArgs = {
  cursor?: Maybe<EmailCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignWhereInput>;
};


export type QueryFindFirstEmailCampaignCustomListArgs = {
  cursor?: Maybe<EmailCampaignCustomListWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignCustomListScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListWhereInput>;
};


export type QueryFindFirstEmailCampaignCustomListRecipientArgs = {
  cursor?: Maybe<EmailCampaignCustomListRecipientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignCustomListRecipientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListRecipientOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListRecipientWhereInput>;
};


export type QueryFindFirstEmailCampaignCustomListUploadHistoryArgs = {
  cursor?: Maybe<EmailCampaignCustomListUploadHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignCustomListUploadHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListUploadHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListUploadHistoryWhereInput>;
};


export type QueryFindFirstEmailCampaignLogArgs = {
  cursor?: Maybe<EmailCampaignLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignLogOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignLogWhereInput>;
};


export type QueryFindFirstEmailCampaignTemplateArgs = {
  cursor?: Maybe<EmailCampaignTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignTemplateWhereInput>;
};


export type QueryFindFirstEmailCampaignUnsubscribeArgs = {
  cursor?: Maybe<EmailCampaignUnsubscribeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignUnsubscribeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignUnsubscribeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignUnsubscribeWhereInput>;
};


export type QueryFindFirstEmailProviderLogArgs = {
  cursor?: Maybe<EmailProviderLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailProviderLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailProviderLogOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailProviderLogWhereInput>;
};


export type QueryFindFirstEmergencyClinicsArgs = {
  cursor?: Maybe<EmergencyClinicsWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmergencyClinicsScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmergencyClinicsOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmergencyClinicsWhereInput>;
};


export type QueryFindFirstEncryptedClinicUploadArgs = {
  cursor?: Maybe<EncryptedClinicUploadWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EncryptedClinicUploadScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EncryptedClinicUploadOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};


export type QueryFindFirstEnrollmentSupportEventArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type QueryFindFirstEzyVetIntegrationArgs = {
  cursor?: Maybe<EzyVetIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EzyVetIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EzyVetIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EzyVetIntegrationWhereInput>;
};


export type QueryFindFirstFeatureFlagArgs = {
  cursor?: Maybe<FeatureFlagWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FeatureFlagScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FeatureFlagOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FeatureFlagWhereInput>;
};


export type QueryFindFirstFinancialAdjustmentArgs = {
  cursor?: Maybe<FinancialAdjustmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FinancialAdjustmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FinancialAdjustmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialAdjustmentWhereInput>;
};


export type QueryFindFirstFinancialTransactionArgs = {
  cursor?: Maybe<FinancialTransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FinancialTransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FinancialTransactionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type QueryFindFirstFormSubmissionArgs = {
  cursor?: Maybe<FormSubmissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormSubmissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormSubmissionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormSubmissionWhereInput>;
};


export type QueryFindFirstFormTemplateArgs = {
  cursor?: Maybe<FormTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormTemplateWhereInput>;
};


export type QueryFindFirstGlobalPetParentArgs = {
  cursor?: Maybe<GlobalPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<GlobalPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<GlobalPetParentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GlobalPetParentWhereInput>;
};


export type QueryFindFirstGooglePlaceArgs = {
  cursor?: Maybe<GooglePlaceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<GooglePlaceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<GooglePlaceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GooglePlaceWhereInput>;
};


export type QueryFindFirstHillsToHomeApiLogArgs = {
  cursor?: Maybe<HillsToHomeApiLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<HillsToHomeApiLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<HillsToHomeApiLogOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<HillsToHomeApiLogWhereInput>;
};


export type QueryFindFirstInformAudienceDefinitionArgs = {
  cursor?: Maybe<InformAudienceDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceDefinitionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};


export type QueryFindFirstInformAudienceMemberArgs = {
  cursor?: Maybe<InformAudienceMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberWhereInput>;
};


export type QueryFindFirstInformAudienceMemberMessageArgs = {
  cursor?: Maybe<InformAudienceMemberMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceMemberMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberMessageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberMessageWhereInput>;
};


export type QueryFindFirstInformAutomationCampaignArgs = {
  cursor?: Maybe<InformAutomationCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAutomationCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAutomationCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAutomationCampaignWhereInput>;
};


export type QueryFindFirstInformCampaignArgs = {
  cursor?: Maybe<InformCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignWhereInput>;
};


export type QueryFindFirstInformCampaignEnrollmentArgs = {
  cursor?: Maybe<InformCampaignEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignEnrollmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignEnrollmentWhereInput>;
};


export type QueryFindFirstInformCampaignEnrollmentCanonicalServiceArgs = {
  cursor?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignEnrollmentCanonicalServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignEnrollmentCanonicalServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereInput>;
};


export type QueryFindFirstInformCampaignExecutionArgs = {
  cursor?: Maybe<InformCampaignExecutionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignExecutionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignExecutionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignExecutionWhereInput>;
};


export type QueryFindFirstInformCampaignGroupArgs = {
  cursor?: Maybe<InformCampaignGroupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignGroupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignGroupOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignGroupWhereInput>;
};


export type QueryFindFirstInformCommunicationOptOutArgs = {
  cursor?: Maybe<InformCommunicationOptOutWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCommunicationOptOutScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCommunicationOptOutOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCommunicationOptOutWhereInput>;
};


export type QueryFindFirstInformControlGroupParticipantArgs = {
  cursor?: Maybe<InformControlGroupParticipantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformControlGroupParticipantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformControlGroupParticipantOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformControlGroupParticipantWhereInput>;
};


export type QueryFindFirstInformEmailTemplateArgs = {
  cursor?: Maybe<InformEmailTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEmailTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEmailTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEmailTemplateWhereInput>;
};


export type QueryFindFirstInformEntityHistoryArgs = {
  cursor?: Maybe<InformEntityHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEntityHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEntityHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEntityHistoryWhereInput>;
};


export type QueryFindFirstInformEventDrivenCampaignArgs = {
  cursor?: Maybe<InformEventDrivenCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEventDrivenCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEventDrivenCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEventDrivenCampaignWhereInput>;
};


export type QueryFindFirstInformEventListenerArgs = {
  cursor?: Maybe<InformEventListenerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEventListenerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEventListenerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEventListenerWhereInput>;
};


export type QueryFindFirstInformNotificationRecipientArgs = {
  cursor?: Maybe<InformNotificationRecipientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformNotificationRecipientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformNotificationRecipientOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformNotificationRecipientWhereInput>;
};


export type QueryFindFirstInformPartnerArgs = {
  cursor?: Maybe<InformPartnerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerWhereInput>;
};


export type QueryFindFirstInformPartnerCustomerArgs = {
  cursor?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};


export type QueryFindFirstInformPartnerCustomerPharmacyProviderArgs = {
  cursor?: Maybe<InformPartnerCustomerPharmacyProviderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerPharmacyProviderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerPharmacyProviderOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerPharmacyProviderWhereInput>;
};


export type QueryFindFirstInformPartnerIntegrationArgs = {
  cursor?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};


export type QueryFindFirstInformPartnerIntegrationModelArgs = {
  cursor?: Maybe<InformPartnerIntegrationModelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerIntegrationModelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerIntegrationModelOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerIntegrationModelWhereInput>;
};


export type QueryFindFirstInformPartnerProgramArgs = {
  cursor?: Maybe<InformPartnerProgramWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerProgramScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerProgramOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerProgramWhereInput>;
};


export type QueryFindFirstInformPartnerProgramEnrollmentArgs = {
  cursor?: Maybe<InformPartnerProgramEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};


export type QueryFindFirstInformPartnerUserArgs = {
  cursor?: Maybe<InformPartnerUserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerUserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserWhereInput>;
};


export type QueryFindFirstInformPartnerUserRoleArgs = {
  cursor?: Maybe<InformPartnerUserRoleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerUserRoleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserRoleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserRoleWhereInput>;
};


export type QueryFindFirstInformScheduledCampaignArgs = {
  cursor?: Maybe<InformScheduledCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformScheduledCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformScheduledCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformScheduledCampaignWhereInput>;
};


export type QueryFindFirstInformSessionArgs = {
  cursor?: Maybe<InformSessionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformSessionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformSessionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionWhereInput>;
};


export type QueryFindFirstInformSessionEventArgs = {
  cursor?: Maybe<InformSessionEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformSessionEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformSessionEventOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionEventWhereInput>;
};


export type QueryFindFirstInstinctIntegrationArgs = {
  cursor?: Maybe<InstinctIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InstinctIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InstinctIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InstinctIntegrationWhereInput>;
};


export type QueryFindFirstInsuranceIntegrationArgs = {
  cursor?: Maybe<InsuranceIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InsuranceIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InsuranceIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InsuranceIntegrationWhereInput>;
};


export type QueryFindFirstIntegrationOutageHistoryEntryArgs = {
  cursor?: Maybe<IntegrationOutageHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<IntegrationOutageHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<IntegrationOutageHistoryEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<IntegrationOutageHistoryEntryWhereInput>;
};


export type QueryFindFirstInterchangeRateArgs = {
  cursor?: Maybe<InterchangeRateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InterchangeRateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InterchangeRateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InterchangeRateWhereInput>;
};


export type QueryFindFirstInvoiceArgs = {
  cursor?: Maybe<InvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceWhereInput>;
};


export type QueryFindFirstInvoiceLineItemArgs = {
  cursor?: Maybe<InvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceLineItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceLineItemWhereInput>;
};


export type QueryFindFirstInvoicePimsWritebackLogEntryArgs = {
  cursor?: Maybe<InvoicePimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoicePimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoicePimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
};


export type QueryFindFirstLabPanelArgs = {
  cursor?: Maybe<LabPanelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LabPanelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LabPanelOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabPanelWhereInput>;
};


export type QueryFindFirstLabResultArgs = {
  cursor?: Maybe<LabResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LabResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LabResultOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabResultWhereInput>;
};


export type QueryFindFirstLapsedPetParentTriggersArgs = {
  cursor?: Maybe<LapsedPetParentTriggersWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LapsedPetParentTriggersScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LapsedPetParentTriggersOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LapsedPetParentTriggersWhereInput>;
};


export type QueryFindFirstLegalEntityArgs = {
  cursor?: Maybe<LegalEntityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LegalEntityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LegalEntityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LegalEntityWhereInput>;
};


export type QueryFindFirstLoyaltyAccountArgs = {
  cursor?: Maybe<LoyaltyAccountWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountWhereInput>;
};


export type QueryFindFirstLoyaltyAccountHolderArgs = {
  cursor?: Maybe<LoyaltyAccountHolderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountHolderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountHolderOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};


export type QueryFindFirstLoyaltyAccountMergerArgs = {
  cursor?: Maybe<LoyaltyAccountMergerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountMergerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountMergerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountMergerWhereInput>;
};


export type QueryFindFirstLoyaltyInvoicePointGranterArgs = {
  cursor?: Maybe<LoyaltyInvoicePointGranterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyInvoicePointGranterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};


export type QueryFindFirstLoyaltyPointDeltaArgs = {
  cursor?: Maybe<LoyaltyPointDeltaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointDeltaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointDeltaOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
};


export type QueryFindFirstLoyaltyPointGrantingServiceArgs = {
  cursor?: Maybe<LoyaltyPointGrantingServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointGrantingServiceWhereInput>;
};


export type QueryFindFirstLoyaltyPointGrantingServiceCategoryArgs = {
  cursor?: Maybe<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceCategoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointGrantingServiceCategoryWhereInput>;
};


export type QueryFindFirstLoyaltyPointUserGrantArgs = {
  cursor?: Maybe<LoyaltyPointUserGrantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointUserGrantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointUserGrantOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointUserGrantWhereInput>;
};


export type QueryFindFirstLoyaltyProgramArgs = {
  cursor?: Maybe<LoyaltyProgramWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyProgramScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyProgramOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyProgramWhereInput>;
};


export type QueryFindFirstLoyaltyProgramStatusHistoryArgs = {
  cursor?: Maybe<LoyaltyProgramStatusHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyProgramStatusHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyProgramStatusHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyProgramStatusHistoryWhereInput>;
};


export type QueryFindFirstLoyaltyRewardArgs = {
  cursor?: Maybe<LoyaltyRewardWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardWhereInput>;
};


export type QueryFindFirstLoyaltyRewardRedemptionArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardRedemptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionWhereInput>;
};


export type QueryFindFirstLoyaltyRewardRedemptionHistoryEntryArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
};


export type QueryFindFirstMassTextAlertArgs = {
  cursor?: Maybe<MassTextAlertWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertWhereInput>;
};


export type QueryFindFirstMassTextAlertEntryArgs = {
  cursor?: Maybe<MassTextAlertEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertEntryWhereInput>;
};


export type QueryFindFirstMassTextAlertEntryAppointmentArgs = {
  cursor?: Maybe<MassTextAlertEntryAppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertEntryAppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertEntryAppointmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertEntryAppointmentWhereInput>;
};


export type QueryFindFirstMediaArgs = {
  cursor?: Maybe<MediaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MediaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MediaOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MediaWhereInput>;
};


export type QueryFindFirstMedicalHistoryArgs = {
  cursor?: Maybe<MedicalHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MedicalHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MedicalHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MedicalHistoryWhereInput>;
};


export type QueryFindFirstMessageTemplateArgs = {
  cursor?: Maybe<MessageTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MessageTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MessageTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessageTemplateWhereInput>;
};


export type QueryFindFirstMessagingCampaignArgs = {
  cursor?: Maybe<MessagingCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MessagingCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MessagingCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessagingCampaignWhereInput>;
};


export type QueryFindFirstMessagingPartnerArgs = {
  cursor?: Maybe<MessagingPartnerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MessagingPartnerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MessagingPartnerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessagingPartnerWhereInput>;
};


export type QueryFindFirstModuleArgs = {
  cursor?: Maybe<ModuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ModuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ModuleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ModuleWhereInput>;
};


export type QueryFindFirstNonPrismaSchemaScriptRanArgs = {
  cursor?: Maybe<NonPrismaSchemaScriptRanWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<NonPrismaSchemaScriptRanScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<NonPrismaSchemaScriptRanOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<NonPrismaSchemaScriptRanWhereInput>;
};


export type QueryFindFirstNotificationEventToMessageArgs = {
  cursor?: Maybe<NotificationEventToMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<NotificationEventToMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<NotificationEventToMessageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<NotificationEventToMessageWhereInput>;
};


export type QueryFindFirstOrganizationArgs = {
  cursor?: Maybe<OrganizationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationWhereInput>;
};


export type QueryFindFirstOrganizationCareBenefitToClinicServiceArgs = {
  cursor?: Maybe<OrganizationCareBenefitToClinicServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationCareBenefitToClinicServiceWhereInput>;
};


export type QueryFindFirstOrganizationCareBenefitToClinicServiceCategoryArgs = {
  cursor?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereInput>;
};


export type QueryFindFirstOrganizationPetArgs = {
  cursor?: Maybe<OrganizationPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetWhereInput>;
};


export type QueryFindFirstOrganizationPetParentArgs = {
  cursor?: Maybe<OrganizationPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetParentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetParentWhereInput>;
};


export type QueryFindFirstOrganizationPetToOrganizationPetParentArgs = {
  cursor?: Maybe<OrganizationPetToOrganizationPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetToOrganizationPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetToOrganizationPetParentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetToOrganizationPetParentWhereInput>;
};


export type QueryFindFirstPpcIntegrationArgs = {
  cursor?: Maybe<PpcIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PpcIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PpcIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PpcIntegrationWhereInput>;
};


export type QueryFindFirstPaymentsReportTransactionArgs = {
  cursor?: Maybe<PaymentsReportTransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PaymentsReportTransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PaymentsReportTransactionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PaymentsReportTransactionWhereInput>;
};


export type QueryFindFirstPayoutBatchingPeriodArgs = {
  cursor?: Maybe<PayoutBatchingPeriodWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingPeriodScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingPeriodOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingPeriodWhereInput>;
};


export type QueryFindFirstPayoutBatchingScheduleArgs = {
  cursor?: Maybe<PayoutBatchingScheduleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingScheduleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingScheduleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingScheduleWhereInput>;
};


export type QueryFindFirstPayoutBatchingSettingArgs = {
  cursor?: Maybe<PayoutBatchingSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingSettingWhereInput>;
};


export type QueryFindFirstPermissionArgs = {
  cursor?: Maybe<PermissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PermissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PermissionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PermissionWhereInput>;
};


export type QueryFindFirstPetParentSettingArgs = {
  cursor?: Maybe<PetParentSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PetParentSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PetParentSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PetParentSettingWhereInput>;
};


export type QueryFindFirstPetPortalSettingArgs = {
  cursor?: Maybe<PetPortalSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PetPortalSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PetPortalSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PetPortalSettingWhereInput>;
};


export type QueryFindFirstPhoneNumberLookupRequestArgs = {
  cursor?: Maybe<PhoneNumberLookupRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PhoneNumberLookupRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PhoneNumberLookupRequestOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PhoneNumberLookupRequestWhereInput>;
};


export type QueryFindFirstPhoneNumberLookupResultArgs = {
  cursor?: Maybe<PhoneNumberLookupResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PhoneNumberLookupResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PhoneNumberLookupResultOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PhoneNumberLookupResultWhereInput>;
};


export type QueryFindFirstPimsInvoiceArgs = {
  cursor?: Maybe<PimsInvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsInvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsInvoiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsInvoiceWhereInput>;
};


export type QueryFindFirstPimsInvoiceLineItemArgs = {
  cursor?: Maybe<PimsInvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsInvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsInvoiceLineItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsInvoiceLineItemWhereInput>;
};


export type QueryFindFirstPimsPaymentTypeArgs = {
  cursor?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsPaymentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsPaymentTypeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};


export type QueryFindFirstPimsWritebackLogEntryArgs = {
  cursor?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};


export type QueryFindFirstPrescriptionArgs = {
  cursor?: Maybe<PrescriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PrescriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PrescriptionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PrescriptionWhereInput>;
};


export type QueryFindFirstProductArgs = {
  cursor?: Maybe<ProductWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductWhereInput>;
};


export type QueryFindFirstProductPackageArgs = {
  cursor?: Maybe<ProductPackageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductPackageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductPackageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductPackageWhereInput>;
};


export type QueryFindFirstProductPackageSubscriptionArgs = {
  cursor?: Maybe<ProductPackageSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductPackageSubscriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductPackageSubscriptionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductPackageSubscriptionWhereInput>;
};


export type QueryFindFirstProviderAppointmentTypeRoomMapArgs = {
  cursor?: Maybe<ProviderAppointmentTypeRoomMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProviderAppointmentTypeRoomMapWhereInput>;
};


export type QueryFindFirstPushNotificationLogArgs = {
  cursor?: Maybe<PushNotificationLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PushNotificationLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PushNotificationLogOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PushNotificationLogWhereInput>;
};


export type QueryFindFirstRecapArgs = {
  cursor?: Maybe<RecapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<RecapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<RecapOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RecapWhereInput>;
};


export type QueryFindFirstRulesArgs = {
  cursor?: Maybe<RulesWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<RulesScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<RulesOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RulesWhereInput>;
};


export type QueryFindFirstSegmentArgs = {
  cursor?: Maybe<SegmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SegmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SegmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SegmentWhereInput>;
};


export type QueryFindFirstSentTrupanionExamDayOfferArgs = {
  cursor?: Maybe<SentTrupanionExamDayOfferWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SentTrupanionExamDayOfferScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SentTrupanionExamDayOfferOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};


export type QueryFindFirstServiceArgs = {
  cursor?: Maybe<ServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceWhereInput>;
};


export type QueryFindFirstServiceCategoryArgs = {
  cursor?: Maybe<ServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceCategoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceCategoryWhereInput>;
};


export type QueryFindFirstServicePurchaseSummaryArgs = {
  cursor?: Maybe<ServicePurchaseSummaryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServicePurchaseSummaryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServicePurchaseSummaryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};


export type QueryFindFirstServiceReminderArgs = {
  cursor?: Maybe<ServiceReminderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderWhereInput>;
};


export type QueryFindFirstServiceReminderNotificationArgs = {
  cursor?: Maybe<ServiceReminderNotificationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderNotificationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderNotificationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};


export type QueryFindFirstServiceReminderTimingArgs = {
  cursor?: Maybe<ServiceReminderTimingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderTimingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderTimingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderTimingWhereInput>;
};


export type QueryFindFirstSexArgs = {
  cursor?: Maybe<SexWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SexScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SexOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SexWhereInput>;
};


export type QueryFindFirstSmsNotificationStatusArgs = {
  cursor?: Maybe<SmsNotificationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SmsNotificationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SmsNotificationStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SmsNotificationStatusWhereInput>;
};


export type QueryFindFirstSpeciesArgs = {
  cursor?: Maybe<SpeciesWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SpeciesScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SpeciesOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SpeciesWhereInput>;
};


export type QueryFindFirstStaffRoleArgs = {
  cursor?: Maybe<StaffRoleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StaffRoleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StaffRoleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StaffRoleWhereInput>;
};


export type QueryFindFirstStripeCustomerArgs = {
  cursor?: Maybe<StripeCustomerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeCustomerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeCustomerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeCustomerWhereInput>;
};


export type QueryFindFirstStripeDisputeArgs = {
  cursor?: Maybe<StripeDisputeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeDisputeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeDisputeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeDisputeWhereInput>;
};


export type QueryFindFirstStripeInvoiceArgs = {
  cursor?: Maybe<StripeInvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeInvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeInvoiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type QueryFindFirstStripeInvoiceItemArgs = {
  cursor?: Maybe<StripeInvoiceItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeInvoiceItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeInvoiceItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeInvoiceItemWhereInput>;
};


export type QueryFindFirstStripePaymentIntentArgs = {
  cursor?: Maybe<StripePaymentIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentIntentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type QueryFindFirstStripePaymentMethodArgs = {
  cursor?: Maybe<StripePaymentMethodWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentMethodScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentMethodOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentMethodWhereInput>;
};


export type QueryFindFirstStripePayoutArgs = {
  cursor?: Maybe<StripePayoutWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePayoutScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePayoutOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePayoutWhereInput>;
};


export type QueryFindFirstStripePayoutAccountArgs = {
  cursor?: Maybe<StripePayoutAccountWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePayoutAccountScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePayoutAccountOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePayoutAccountWhereInput>;
};


export type QueryFindFirstStripeReceiptArgs = {
  cursor?: Maybe<StripeReceiptWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeReceiptScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeReceiptOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeReceiptWhereInput>;
};


export type QueryFindFirstStripeReceiptHistoryArgs = {
  cursor?: Maybe<StripeReceiptHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeReceiptHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeReceiptHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeReceiptHistoryWhereInput>;
};


export type QueryFindFirstStripeRefundArgs = {
  cursor?: Maybe<StripeRefundWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeRefundScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeRefundOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeRefundWhereInput>;
};


export type QueryFindFirstStripeTerminalArgs = {
  cursor?: Maybe<StripeTerminalWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeTerminalScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeTerminalOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeTerminalWhereInput>;
};


export type QueryFindFirstStripeTerminalLocationArgs = {
  cursor?: Maybe<StripeTerminalLocationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeTerminalLocationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeTerminalLocationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeTerminalLocationWhereInput>;
};


export type QueryFindFirstSurveyAppointmentTypeSettingArgs = {
  cursor?: Maybe<SurveyAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveyAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveyAppointmentTypeSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyAppointmentTypeSettingWhereInput>;
};


export type QueryFindFirstSurveyResultArgs = {
  cursor?: Maybe<SurveyResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveyResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveyResultOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyResultWhereInput>;
};


export type QueryFindFirstSurveySettingArgs = {
  cursor?: Maybe<SurveySettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveySettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveySettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveySettingWhereInput>;
};


export type QueryFindFirstSyncVetIntegrationArgs = {
  cursor?: Maybe<SyncVetIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SyncVetIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SyncVetIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SyncVetIntegrationWhereInput>;
};


export type QueryFindFirstSyncVetServiceArgs = {
  cursor?: Maybe<SyncVetServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SyncVetServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SyncVetServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SyncVetServiceWhereInput>;
};


export type QueryFindFirstSynchronyClinicConfigurationArgs = {
  cursor?: Maybe<SynchronyClinicConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SynchronyClinicConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SynchronyClinicConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SynchronyClinicConfigurationWhereInput>;
};


export type QueryFindFirstSynchronyEventArgs = {
  cursor?: Maybe<SynchronyEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SynchronyEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SynchronyEventOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SynchronyEventWhereInput>;
};


export type QueryFindFirstTaskArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaskScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaskOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaskWhereInput>;
};


export type QueryFindFirstTaxonomyArgs = {
  cursor?: Maybe<TaxonomyWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaxonomyScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaxonomyOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaxonomyWhereInput>;
};


export type QueryFindFirstTaxonomyToInformAudienceDefinitionArgs = {
  cursor?: Maybe<TaxonomyToInformAudienceDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaxonomyToInformAudienceDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaxonomyToInformAudienceDefinitionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaxonomyToInformAudienceDefinitionWhereInput>;
};


export type QueryFindFirstTransactionArgs = {
  cursor?: Maybe<TransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TransactionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TransactionWhereInput>;
};


export type QueryFindFirstTrupanionCertificateAvailabilityArgs = {
  cursor?: Maybe<TrupanionCertificateAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TrupanionCertificateAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TrupanionCertificateAvailabilityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionCertificateAvailabilityWhereInput>;
};


export type QueryFindFirstTrupanionIntegratedAppointmentTypeArgs = {
  cursor?: Maybe<TrupanionIntegratedAppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TrupanionIntegratedAppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TrupanionIntegratedAppointmentTypeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
};


export type QueryFindFirstTrupanionIntegrationArgs = {
  cursor?: Maybe<TrupanionIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TrupanionIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TrupanionIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionIntegrationWhereInput>;
};


export type QueryFindFirstTwilioCallRecordingArgs = {
  cursor?: Maybe<TwilioCallRecordingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TwilioCallRecordingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TwilioCallRecordingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TwilioCallRecordingWhereInput>;
};


export type QueryFindFirstUserArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type QueryFindFirstUserAppointmentGroupingArgs = {
  cursor?: Maybe<UserAppointmentGroupingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserAppointmentGroupingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserAppointmentGroupingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAppointmentGroupingWhereInput>;
};


export type QueryFindFirstUserBoardFilterArgs = {
  cursor?: Maybe<UserBoardFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserBoardFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserBoardFilterOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserBoardFilterWhereInput>;
};


export type QueryFindFirstUserChannelFilterSelectionArgs = {
  cursor?: Maybe<UserChannelFilterSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserChannelFilterSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserChannelFilterSelectionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserChannelFilterSelectionWhereInput>;
};


export type QueryFindFirstUserNotificationSettingArgs = {
  cursor?: Maybe<UserNotificationSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserNotificationSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserNotificationSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserNotificationSettingWhereInput>;
};


export type QueryFindFirstUserSettingArgs = {
  cursor?: Maybe<UserSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserSettingWhereInput>;
};


export type QueryFindFirstUserTaskListArgs = {
  cursor?: Maybe<UserTaskListWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserTaskListScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserTaskListOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserTaskListWhereInput>;
};


export type QueryFindFirstUserTaskListFilterArgs = {
  cursor?: Maybe<UserTaskListFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserTaskListFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserTaskListFilterOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserTaskListFilterWhereInput>;
};


export type QueryFindFirstVaccinationArgs = {
  cursor?: Maybe<VaccinationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VaccinationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VaccinationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VaccinationWhereInput>;
};


export type QueryFindFirstVetAvailabilityArgs = {
  cursor?: Maybe<VetAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityWhereInput>;
};


export type QueryFindFirstVetAvailabilityClinicRoomMapArgs = {
  cursor?: Maybe<VetAvailabilityClinicRoomMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityClinicRoomMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityClinicRoomMapOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityClinicRoomMapWhereInput>;
};


export type QueryFindFirstVetAvailabilityMapArgs = {
  cursor?: Maybe<VetAvailabilityMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityMapOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityMapWhereInput>;
};


export type QueryFindFirstVetInfoArgs = {
  cursor?: Maybe<VetInfoWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetInfoScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetInfoOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetInfoWhereInput>;
};


export type QueryFindFirstVetsourceCodeTagArgs = {
  cursor?: Maybe<VetsourceCodeTagWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourceCodeTagScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourceCodeTagOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceCodeTagWhereInput>;
};


export type QueryFindFirstVetsourceInstallationArgs = {
  cursor?: Maybe<VetsourceInstallationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourceInstallationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourceInstallationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceInstallationWhereInput>;
};


export type QueryFindFirstVetsourcePharmacyIntegrationArgs = {
  cursor?: Maybe<VetsourcePharmacyIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourcePharmacyIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourcePharmacyIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourcePharmacyIntegrationWhereInput>;
};


export type QueryFindFirstVetsourceRevenueCategoryArgs = {
  cursor?: Maybe<VetsourceRevenueCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourceRevenueCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourceRevenueCategoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};


export type QueryFindFirstWorkflowEventSettingArgs = {
  cursor?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};


export type QueryFindManyActiveIngredientArgs = {
  cursor?: Maybe<ActiveIngredientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ActiveIngredientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ActiveIngredientOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ActiveIngredientWhereInput>;
};


export type QueryFindManyActiveIngredientCountArgs = {
  cursor?: Maybe<ActiveIngredientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ActiveIngredientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ActiveIngredientOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ActiveIngredientWhereInput>;
};


export type QueryFindManyAiRecapPimsWritebackLogEntryArgs = {
  cursor?: Maybe<AiRecapPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AiRecapPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AiRecapPimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
};


export type QueryFindManyAiRecapPimsWritebackLogEntryCountArgs = {
  cursor?: Maybe<AiRecapPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AiRecapPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AiRecapPimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AiRecapPimsWritebackLogEntryWhereInput>;
};


export type QueryFindManyAppointmentArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type QueryFindManyAppointmentAvailabilityArgs = {
  cursor?: Maybe<AppointmentAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentAvailabilityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentAvailabilityWhereInput>;
};


export type QueryFindManyAppointmentAvailabilityCountArgs = {
  cursor?: Maybe<AppointmentAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentAvailabilityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentAvailabilityWhereInput>;
};


export type QueryFindManyAppointmentCountArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type QueryFindManyAppointmentNoteTemplateArgs = {
  cursor?: Maybe<AppointmentNoteTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentNoteTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentNoteTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentNoteTemplateWhereInput>;
};


export type QueryFindManyAppointmentNoteTemplateCountArgs = {
  cursor?: Maybe<AppointmentNoteTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentNoteTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentNoteTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentNoteTemplateWhereInput>;
};


export type QueryFindManyAppointmentTypeArgs = {
  cursor?: Maybe<AppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentTypeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type QueryFindManyAppointmentTypeCountArgs = {
  cursor?: Maybe<AppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentTypeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type QueryFindManyAutomationRunArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type QueryFindManyAutomationRunActionArgs = {
  cursor?: Maybe<AutomationRunActionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunActionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunActionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type QueryFindManyAutomationRunActionCountArgs = {
  cursor?: Maybe<AutomationRunActionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunActionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunActionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type QueryFindManyAutomationRunCountArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type QueryFindManyAxionClinicConfigurationArgs = {
  cursor?: Maybe<AxionClinicConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AxionClinicConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AxionClinicConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AxionClinicConfigurationWhereInput>;
};


export type QueryFindManyAxionClinicConfigurationCountArgs = {
  cursor?: Maybe<AxionClinicConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AxionClinicConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AxionClinicConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AxionClinicConfigurationWhereInput>;
};


export type QueryFindManyAxionClinicUserConfigurationArgs = {
  cursor?: Maybe<AxionClinicUserConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AxionClinicUserConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AxionClinicUserConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AxionClinicUserConfigurationWhereInput>;
};


export type QueryFindManyAxionClinicUserConfigurationCountArgs = {
  cursor?: Maybe<AxionClinicUserConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AxionClinicUserConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AxionClinicUserConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AxionClinicUserConfigurationWhereInput>;
};


export type QueryFindManyBedrockInferenceArgs = {
  cursor?: Maybe<BedrockInferenceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BedrockInferenceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BedrockInferenceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BedrockInferenceWhereInput>;
};


export type QueryFindManyBedrockInferenceCountArgs = {
  cursor?: Maybe<BedrockInferenceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BedrockInferenceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BedrockInferenceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BedrockInferenceWhereInput>;
};


export type QueryFindManyBitwerxHealthcheckArgs = {
  cursor?: Maybe<BitwerxHealthcheckWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxHealthcheckScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxHealthcheckOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxHealthcheckWhereInput>;
};


export type QueryFindManyBitwerxHealthcheckCountArgs = {
  cursor?: Maybe<BitwerxHealthcheckWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxHealthcheckScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxHealthcheckOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxHealthcheckWhereInput>;
};


export type QueryFindManyBitwerxIntegrationArgs = {
  cursor?: Maybe<BitwerxIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxIntegrationWhereInput>;
};


export type QueryFindManyBitwerxIntegrationCountArgs = {
  cursor?: Maybe<BitwerxIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxIntegrationWhereInput>;
};


export type QueryFindManyBitwerxPaymentHealthcheckResultArgs = {
  cursor?: Maybe<BitwerxPaymentHealthcheckResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckResultOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentHealthcheckResultWhereInput>;
};


export type QueryFindManyBitwerxPaymentHealthcheckResultCountArgs = {
  cursor?: Maybe<BitwerxPaymentHealthcheckResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckResultOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentHealthcheckResultWhereInput>;
};


export type QueryFindManyBitwerxPaymentHealthcheckRunArgs = {
  cursor?: Maybe<BitwerxPaymentHealthcheckRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckRunOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentHealthcheckRunWhereInput>;
};


export type QueryFindManyBitwerxPaymentHealthcheckRunCountArgs = {
  cursor?: Maybe<BitwerxPaymentHealthcheckRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentHealthcheckRunOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentHealthcheckRunWhereInput>;
};


export type QueryFindManyBitwerxPaymentWritebackConfigurationCountArgs = {
  cursor?: Maybe<BitwerxPaymentWritebackConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BitwerxPaymentWritebackConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BitwerxPaymentWritebackConfigurationWhereInput>;
};


export type QueryFindManyBoardFilterColumnArgs = {
  cursor?: Maybe<BoardFilterColumnWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoardFilterColumnScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoardFilterColumnOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoardFilterColumnWhereInput>;
};


export type QueryFindManyBoardFilterColumnCountArgs = {
  cursor?: Maybe<BoardFilterColumnWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoardFilterColumnScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoardFilterColumnOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoardFilterColumnWhereInput>;
};


export type QueryFindManyBoardFilterSpecificDateRangeArgs = {
  cursor?: Maybe<BoardFilterSpecificDateRangeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoardFilterSpecificDateRangeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoardFilterSpecificDateRangeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoardFilterSpecificDateRangeWhereInput>;
};


export type QueryFindManyBoardFilterSpecificDateRangeCountArgs = {
  cursor?: Maybe<BoardFilterSpecificDateRangeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoardFilterSpecificDateRangeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoardFilterSpecificDateRangeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoardFilterSpecificDateRangeWhereInput>;
};


export type QueryFindManyBoehringerIngelheimCustomerAlignmentArgs = {
  cursor?: Maybe<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoehringerIngelheimCustomerAlignmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoehringerIngelheimCustomerAlignmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoehringerIngelheimCustomerAlignmentWhereInput>;
};


export type QueryFindManyBoehringerIngelheimCustomerAlignmentCountArgs = {
  cursor?: Maybe<BoehringerIngelheimCustomerAlignmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoehringerIngelheimCustomerAlignmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoehringerIngelheimCustomerAlignmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoehringerIngelheimCustomerAlignmentWhereInput>;
};


export type QueryFindManyBoehringerIngelheimTerritoryArgs = {
  cursor?: Maybe<BoehringerIngelheimTerritoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoehringerIngelheimTerritoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoehringerIngelheimTerritoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};


export type QueryFindManyBoehringerIngelheimTerritoryCountArgs = {
  cursor?: Maybe<BoehringerIngelheimTerritoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoehringerIngelheimTerritoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoehringerIngelheimTerritoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoehringerIngelheimTerritoryWhereInput>;
};


export type QueryFindManyBreedArgs = {
  cursor?: Maybe<BreedWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BreedScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BreedOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BreedWhereInput>;
};


export type QueryFindManyBreedCountArgs = {
  cursor?: Maybe<BreedWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BreedScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BreedOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BreedWhereInput>;
};


export type QueryFindManyCallHistoryArgs = {
  cursor?: Maybe<CallHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallHistoryWhereInput>;
};


export type QueryFindManyCallHistoryCountArgs = {
  cursor?: Maybe<CallHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallHistoryWhereInput>;
};


export type QueryFindManyCallParticipantArgs = {
  cursor?: Maybe<CallParticipantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallParticipantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallParticipantOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallParticipantWhereInput>;
};


export type QueryFindManyCallParticipantCountArgs = {
  cursor?: Maybe<CallParticipantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallParticipantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallParticipantOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallParticipantWhereInput>;
};


export type QueryFindManyCallRecordingArgs = {
  cursor?: Maybe<CallRecordingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallRecordingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallRecordingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallRecordingWhereInput>;
};


export type QueryFindManyCallRecordingCountArgs = {
  cursor?: Maybe<CallRecordingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallRecordingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallRecordingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallRecordingWhereInput>;
};


export type QueryFindManyCampaignRegistryCampaignArgs = {
  cursor?: Maybe<CampaignRegistryCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CampaignRegistryCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CampaignRegistryCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CampaignRegistryCampaignWhereInput>;
};


export type QueryFindManyCampaignRegistryCampaignCountArgs = {
  cursor?: Maybe<CampaignRegistryCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CampaignRegistryCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CampaignRegistryCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CampaignRegistryCampaignWhereInput>;
};


export type QueryFindManyCanonicalBreedArgs = {
  cursor?: Maybe<CanonicalBreedWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalBreedScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalBreedOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalBreedWhereInput>;
};


export type QueryFindManyCanonicalBreedCountArgs = {
  cursor?: Maybe<CanonicalBreedWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalBreedScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalBreedOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalBreedWhereInput>;
};


export type QueryFindManyCanonicalCanineBreedProfileArgs = {
  cursor?: Maybe<CanonicalCanineBreedProfileWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalCanineBreedProfileScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalCanineBreedProfileOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalCanineBreedProfileWhereInput>;
};


export type QueryFindManyCanonicalCanineBreedProfileCountArgs = {
  cursor?: Maybe<CanonicalCanineBreedProfileWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalCanineBreedProfileScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalCanineBreedProfileOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalCanineBreedProfileWhereInput>;
};


export type QueryFindManyCanonicalServiceArgs = {
  cursor?: Maybe<CanonicalServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalServiceWhereInput>;
};


export type QueryFindManyCanonicalServiceCountArgs = {
  cursor?: Maybe<CanonicalServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalServiceWhereInput>;
};


export type QueryFindManyCanonicalSpeciesArgs = {
  cursor?: Maybe<CanonicalSpeciesWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalSpeciesScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalSpeciesOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalSpeciesWhereInput>;
};


export type QueryFindManyCanonicalSpeciesCountArgs = {
  cursor?: Maybe<CanonicalSpeciesWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalSpeciesScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalSpeciesOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalSpeciesWhereInput>;
};


export type QueryFindManyCareAccountCreditIntentArgs = {
  cursor?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAccountCreditIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAccountCreditIntentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};


export type QueryFindManyCareAccountCreditIntentCountArgs = {
  cursor?: Maybe<CareAccountCreditIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAccountCreditIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAccountCreditIntentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};


export type QueryFindManyCareAccountCreditPimsWritebackLogEntryArgs = {
  cursor?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAccountCreditPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAccountCreditPimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
};


export type QueryFindManyCareAccountCreditPimsWritebackLogEntryCountArgs = {
  cursor?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAccountCreditPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAccountCreditPimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAccountCreditPimsWritebackLogEntryWhereInput>;
};


export type QueryFindManyCareAddonEnrollmentArgs = {
  cursor?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonEnrollmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};


export type QueryFindManyCareAddonEnrollmentCountArgs = {
  cursor?: Maybe<CareAddonEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonEnrollmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonEnrollmentWhereInput>;
};


export type QueryFindManyCareAddonPackageArgs = {
  cursor?: Maybe<CareAddonPackageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonPackageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonPackageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonPackageWhereInput>;
};


export type QueryFindManyCareAddonPackageBenefitArgs = {
  cursor?: Maybe<CareAddonPackageBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonPackageBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonPackageBenefitOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonPackageBenefitWhereInput>;
};


export type QueryFindManyCareAddonPackageBenefitCountArgs = {
  cursor?: Maybe<CareAddonPackageBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonPackageBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonPackageBenefitOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonPackageBenefitWhereInput>;
};


export type QueryFindManyCareAddonPackageCountArgs = {
  cursor?: Maybe<CareAddonPackageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAddonPackageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAddonPackageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAddonPackageWhereInput>;
};


export type QueryFindManyCareAuthorizationRequestArgs = {
  cursor?: Maybe<CareAuthorizationRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAuthorizationRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAuthorizationRequestOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAuthorizationRequestWhereInput>;
};


export type QueryFindManyCareAuthorizationRequestCountArgs = {
  cursor?: Maybe<CareAuthorizationRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareAuthorizationRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareAuthorizationRequestOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareAuthorizationRequestWhereInput>;
};


export type QueryFindManyCareBenefitArgs = {
  cursor?: Maybe<CareBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitWhereInput>;
};


export type QueryFindManyCareBenefitCountArgs = {
  cursor?: Maybe<CareBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitWhereInput>;
};


export type QueryFindManyCareBenefitUsageArgs = {
  cursor?: Maybe<CareBenefitUsageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageWhereInput>;
};


export type QueryFindManyCareBenefitUsageCountArgs = {
  cursor?: Maybe<CareBenefitUsageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageWhereInput>;
};


export type QueryFindManyCareBenefitUsageFollowupArgs = {
  cursor?: Maybe<CareBenefitUsageFollowupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageFollowupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageFollowupOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageFollowupWhereInput>;
};


export type QueryFindManyCareBenefitUsageFollowupCountArgs = {
  cursor?: Maybe<CareBenefitUsageFollowupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageFollowupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageFollowupOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageFollowupWhereInput>;
};


export type QueryFindManyCareBenefitUsageFollowupStepArgs = {
  cursor?: Maybe<CareBenefitUsageFollowupStepWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageFollowupStepScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageFollowupStepOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};


export type QueryFindManyCareBenefitUsageFollowupStepCountArgs = {
  cursor?: Maybe<CareBenefitUsageFollowupStepWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageFollowupStepScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageFollowupStepOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};


export type QueryFindManyCareBenefitUsageToInvoiceLineItemArgs = {
  cursor?: Maybe<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
};


export type QueryFindManyCareBenefitUsageToInvoiceLineItemCountArgs = {
  cursor?: Maybe<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
};


export type QueryFindManyCareCreditPreapprovalCheckArgs = {
  cursor?: Maybe<CareCreditPreapprovalCheckWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareCreditPreapprovalCheckScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareCreditPreapprovalCheckOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};


export type QueryFindManyCareCreditPreapprovalCheckCountArgs = {
  cursor?: Maybe<CareCreditPreapprovalCheckWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareCreditPreapprovalCheckScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareCreditPreapprovalCheckOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};


export type QueryFindManyCareEnrollmentPaymentArgs = {
  cursor?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareEnrollmentPaymentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentPaymentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};


export type QueryFindManyCareEnrollmentPaymentCountArgs = {
  cursor?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareEnrollmentPaymentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentPaymentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};


export type QueryFindManyCareEnrollmentToStripeInvoiceItemArgs = {
  cursor?: Maybe<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentToStripeInvoiceItemWhereInput>;
};


export type QueryFindManyCareEnrollmentToStripeInvoiceItemCountArgs = {
  cursor?: Maybe<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentToStripeInvoiceItemWhereInput>;
};


export type QueryFindManyCareLapsedPaymentArgs = {
  cursor?: Maybe<CareLapsedPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareLapsedPaymentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareLapsedPaymentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareLapsedPaymentWhereInput>;
};


export type QueryFindManyCareLapsedPaymentCountArgs = {
  cursor?: Maybe<CareLapsedPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareLapsedPaymentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareLapsedPaymentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareLapsedPaymentWhereInput>;
};


export type QueryFindManyCarePlanArgs = {
  cursor?: Maybe<CarePlanWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanWhereInput>;
};


export type QueryFindManyCarePlanBenefitArgs = {
  cursor?: Maybe<CarePlanBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitWhereInput>;
};


export type QueryFindManyCarePlanBenefitCountArgs = {
  cursor?: Maybe<CarePlanBenefitWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanBenefitScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitWhereInput>;
};


export type QueryFindManyCarePlanBenefitEnrollmentCarryoverArgs = {
  cursor?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereInput>;
};


export type QueryFindManyCarePlanBenefitEnrollmentCarryoverCountArgs = {
  cursor?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanBenefitEnrollmentCarryoverOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanBenefitEnrollmentCarryoverWhereInput>;
};


export type QueryFindManyCarePlanCountArgs = {
  cursor?: Maybe<CarePlanWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanWhereInput>;
};


export type QueryFindManyCarePlanEnrollmentArgs = {
  cursor?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanEnrollmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type QueryFindManyCarePlanEnrollmentCountArgs = {
  cursor?: Maybe<CarePlanEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanEnrollmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanEnrollmentWhereInput>;
};


export type QueryFindManyCarePlanPricingArgs = {
  cursor?: Maybe<CarePlanPricingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanPricingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanPricingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type QueryFindManyCarePlanPricingCountArgs = {
  cursor?: Maybe<CarePlanPricingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanPricingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanPricingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanPricingWhereInput>;
};


export type QueryFindManyCarePlanProviderGroupArgs = {
  cursor?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanProviderGroupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanProviderGroupOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type QueryFindManyCarePlanProviderGroupCountArgs = {
  cursor?: Maybe<CarePlanProviderGroupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CarePlanProviderGroupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CarePlanProviderGroupOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CarePlanProviderGroupWhereInput>;
};


export type QueryFindManyCareStripeSubscriptionArgs = {
  cursor?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareStripeSubscriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareStripeSubscriptionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type QueryFindManyCareStripeSubscriptionCountArgs = {
  cursor?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareStripeSubscriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareStripeSubscriptionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type QueryFindManyCareSubscriptionTrueUpArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareSubscriptionTrueUpScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
};


export type QueryFindManyCareSubscriptionTrueUpCountArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareSubscriptionTrueUpScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
};


export type QueryFindManyCareSubscriptionTrueUpLogEntryArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareSubscriptionTrueUpLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpLogEntryWhereInput>;
};


export type QueryFindManyCareSubscriptionTrueUpLogEntryCountArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareSubscriptionTrueUpLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpLogEntryWhereInput>;
};


export type QueryFindManyChannelArgs = {
  cursor?: Maybe<ChannelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelWhereInput>;
};


export type QueryFindManyChannelAutomationStatusArgs = {
  cursor?: Maybe<ChannelAutomationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelAutomationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelAutomationStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type QueryFindManyChannelAutomationStatusCountArgs = {
  cursor?: Maybe<ChannelAutomationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelAutomationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelAutomationStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type QueryFindManyChannelCountArgs = {
  cursor?: Maybe<ChannelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelWhereInput>;
};


export type QueryFindManyChannelCreationSourceArgs = {
  cursor?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelCreationSourceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelCreationSourceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type QueryFindManyChannelCreationSourceCountArgs = {
  cursor?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelCreationSourceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelCreationSourceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type QueryFindManyChannelFilterSelectionArgs = {
  cursor?: Maybe<ChannelFilterSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelFilterSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelFilterSelectionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelFilterSelectionWhereInput>;
};


export type QueryFindManyChannelFilterSelectionCountArgs = {
  cursor?: Maybe<ChannelFilterSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelFilterSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelFilterSelectionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelFilterSelectionWhereInput>;
};


export type QueryFindManyChannelMemberArgs = {
  cursor?: Maybe<ChannelMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMemberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMemberWhereInput>;
};


export type QueryFindManyChannelMemberCountArgs = {
  cursor?: Maybe<ChannelMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMemberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMemberWhereInput>;
};


export type QueryFindManyChannelMessageArgs = {
  cursor?: Maybe<ChannelMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageWhereInput>;
};


export type QueryFindManyChannelMessageAttachmentArgs = {
  cursor?: Maybe<ChannelMessageAttachmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageAttachmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageAttachmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageAttachmentWhereInput>;
};


export type QueryFindManyChannelMessageAttachmentCountArgs = {
  cursor?: Maybe<ChannelMessageAttachmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageAttachmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageAttachmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageAttachmentWhereInput>;
};


export type QueryFindManyChannelMessageAutoResponseArgs = {
  cursor?: Maybe<ChannelMessageAutoResponseWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageAutoResponseScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageAutoResponseOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageAutoResponseWhereInput>;
};


export type QueryFindManyChannelMessageAutoResponseCountArgs = {
  cursor?: Maybe<ChannelMessageAutoResponseWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageAutoResponseScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageAutoResponseOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageAutoResponseWhereInput>;
};


export type QueryFindManyChannelMessageCountArgs = {
  cursor?: Maybe<ChannelMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageWhereInput>;
};


export type QueryFindManyChannelMessageReactionArgs = {
  cursor?: Maybe<ChannelMessageReactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageReactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageReactionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageReactionWhereInput>;
};


export type QueryFindManyChannelMessageReactionCountArgs = {
  cursor?: Maybe<ChannelMessageReactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageReactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageReactionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageReactionWhereInput>;
};


export type QueryFindManyChannelPinArgs = {
  cursor?: Maybe<ChannelPinWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelPinScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelPinOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelPinWhereInput>;
};


export type QueryFindManyChannelPinCountArgs = {
  cursor?: Maybe<ChannelPinWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelPinScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelPinOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelPinWhereInput>;
};


export type QueryFindManyChannelSelectionArgs = {
  cursor?: Maybe<ChannelSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelSelectionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelSelectionWhereInput>;
};


export type QueryFindManyChannelSelectionCountArgs = {
  cursor?: Maybe<ChannelSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelSelectionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelSelectionWhereInput>;
};


export type QueryFindManyChannelStatusArgs = {
  cursor?: Maybe<ChannelStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusWhereInput>;
};


export type QueryFindManyChannelStatusChannelAssigneeArgs = {
  cursor?: Maybe<ChannelStatusChannelAssigneeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusChannelAssigneeWhereInput>;
};


export type QueryFindManyChannelStatusChannelAssigneeCountArgs = {
  cursor?: Maybe<ChannelStatusChannelAssigneeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusChannelAssigneeWhereInput>;
};


export type QueryFindManyChannelStatusCountArgs = {
  cursor?: Maybe<ChannelStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusWhereInput>;
};


export type QueryFindManyChemicalCompoundArgs = {
  cursor?: Maybe<ChemicalCompoundWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChemicalCompoundScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChemicalCompoundOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChemicalCompoundWhereInput>;
};


export type QueryFindManyChemicalCompoundCountArgs = {
  cursor?: Maybe<ChemicalCompoundWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChemicalCompoundScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChemicalCompoundOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChemicalCompoundWhereInput>;
};


export type QueryFindManyClientConnectIntegrationArgs = {
  cursor?: Maybe<ClientConnectIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClientConnectIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClientConnectIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClientConnectIntegrationWhereInput>;
};


export type QueryFindManyClientConnectIntegrationCountArgs = {
  cursor?: Maybe<ClientConnectIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClientConnectIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClientConnectIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClientConnectIntegrationWhereInput>;
};


export type QueryFindManyClinicArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type QueryFindManyClinicBlockedPhoneNumberArgs = {
  cursor?: Maybe<ClinicBlockedPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
};


export type QueryFindManyClinicBlockedPhoneNumberCountArgs = {
  cursor?: Maybe<ClinicBlockedPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
};


export type QueryFindManyClinicCountArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type QueryFindManyClinicCustomPayoutsSetupArgs = {
  cursor?: Maybe<ClinicCustomPayoutsSetupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicCustomPayoutsSetupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicCustomPayoutsSetupOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
};


export type QueryFindManyClinicCustomPayoutsSetupCountArgs = {
  cursor?: Maybe<ClinicCustomPayoutsSetupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicCustomPayoutsSetupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicCustomPayoutsSetupOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicCustomPayoutsSetupWhereInput>;
};


export type QueryFindManyClinicDirectBookingSettingArgs = {
  cursor?: Maybe<ClinicDirectBookingSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicDirectBookingSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicDirectBookingSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicDirectBookingSettingWhereInput>;
};


export type QueryFindManyClinicDirectBookingSettingCountArgs = {
  cursor?: Maybe<ClinicDirectBookingSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicDirectBookingSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicDirectBookingSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicDirectBookingSettingWhereInput>;
};


export type QueryFindManyClinicEmailCampaignSettingArgs = {
  cursor?: Maybe<ClinicEmailCampaignSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmailCampaignSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmailCampaignSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmailCampaignSettingWhereInput>;
};


export type QueryFindManyClinicEmailCampaignSettingCountArgs = {
  cursor?: Maybe<ClinicEmailCampaignSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmailCampaignSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmailCampaignSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmailCampaignSettingWhereInput>;
};


export type QueryFindManyClinicEmployeeArgs = {
  cursor?: Maybe<ClinicEmployeeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type QueryFindManyClinicEmployeeAppointmentTypeSettingArgs = {
  cursor?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeAppointmentTypeSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereInput>;
};


export type QueryFindManyClinicEmployeeAppointmentTypeSettingCountArgs = {
  cursor?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeAppointmentTypeSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeAppointmentTypeSettingWhereInput>;
};


export type QueryFindManyClinicEmployeeCountArgs = {
  cursor?: Maybe<ClinicEmployeeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type QueryFindManyClinicEntityPhoneNumberArgs = {
  cursor?: Maybe<ClinicEntityPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEntityPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEntityPhoneNumberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEntityPhoneNumberWhereInput>;
};


export type QueryFindManyClinicEntityPhoneNumberCountArgs = {
  cursor?: Maybe<ClinicEntityPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEntityPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEntityPhoneNumberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEntityPhoneNumberWhereInput>;
};


export type QueryFindManyClinicModuleArgs = {
  cursor?: Maybe<ClinicModuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicModuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicModuleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicModuleWhereInput>;
};


export type QueryFindManyClinicModuleCountArgs = {
  cursor?: Maybe<ClinicModuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicModuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicModuleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicModuleWhereInput>;
};


export type QueryFindManyClinicOfficeHourArgs = {
  cursor?: Maybe<ClinicOfficeHourWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicOfficeHourScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOfficeHourOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicOfficeHourWhereInput>;
};


export type QueryFindManyClinicOfficeHourCountArgs = {
  cursor?: Maybe<ClinicOfficeHourWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicOfficeHourScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOfficeHourOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicOfficeHourWhereInput>;
};


export type QueryFindManyClinicOnboardingArgs = {
  cursor?: Maybe<ClinicOnboardingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicOnboardingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOnboardingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicOnboardingWhereInput>;
};


export type QueryFindManyClinicOnboardingCountArgs = {
  cursor?: Maybe<ClinicOnboardingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicOnboardingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOnboardingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicOnboardingWhereInput>;
};


export type QueryFindManyClinicPaymentFeeConfigurationArgs = {
  cursor?: Maybe<ClinicPaymentFeeConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPaymentFeeConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPaymentFeeConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
};


export type QueryFindManyClinicPaymentFeeConfigurationCountArgs = {
  cursor?: Maybe<ClinicPaymentFeeConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPaymentFeeConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPaymentFeeConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPaymentFeeConfigurationWhereInput>;
};


export type QueryFindManyClinicPetArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type QueryFindManyClinicPetAlertArgs = {
  cursor?: Maybe<ClinicPetAlertWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetAlertScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetAlertOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetAlertWhereInput>;
};


export type QueryFindManyClinicPetAlertCountArgs = {
  cursor?: Maybe<ClinicPetAlertWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetAlertScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetAlertOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetAlertWhereInput>;
};


export type QueryFindManyClinicPetCountArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type QueryFindManyClinicPetCustomFieldValueArgs = {
  cursor?: Maybe<ClinicPetCustomFieldValueWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetCustomFieldValueScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetCustomFieldValueOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetCustomFieldValueWhereInput>;
};


export type QueryFindManyClinicPetCustomFieldValueCountArgs = {
  cursor?: Maybe<ClinicPetCustomFieldValueWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetCustomFieldValueScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetCustomFieldValueOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetCustomFieldValueWhereInput>;
};


export type QueryFindManyClinicPetParentArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type QueryFindManyClinicPetParentAddressArgs = {
  cursor?: Maybe<ClinicPetParentAddressWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentAddressScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentAddressOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentAddressWhereInput>;
};


export type QueryFindManyClinicPetParentAddressCountArgs = {
  cursor?: Maybe<ClinicPetParentAddressWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentAddressScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentAddressOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentAddressWhereInput>;
};


export type QueryFindManyClinicPetParentCountArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type QueryFindManyClinicPetParentCustomFieldValueArgs = {
  cursor?: Maybe<ClinicPetParentCustomFieldValueWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentCustomFieldValueScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentCustomFieldValueOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentCustomFieldValueWhereInput>;
};


export type QueryFindManyClinicPetParentCustomFieldValueCountArgs = {
  cursor?: Maybe<ClinicPetParentCustomFieldValueWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentCustomFieldValueScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentCustomFieldValueOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentCustomFieldValueWhereInput>;
};


export type QueryFindManyClinicPetParentDeviceArgs = {
  cursor?: Maybe<ClinicPetParentDeviceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentDeviceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentDeviceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentDeviceWhereInput>;
};


export type QueryFindManyClinicPetParentDeviceCountArgs = {
  cursor?: Maybe<ClinicPetParentDeviceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentDeviceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentDeviceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentDeviceWhereInput>;
};


export type QueryFindManyClinicPetParentPimsSyncStatusArgs = {
  cursor?: Maybe<ClinicPetParentPimsSyncStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentPimsSyncStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentPimsSyncStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentPimsSyncStatusWhereInput>;
};


export type QueryFindManyClinicPetParentPimsSyncStatusCountArgs = {
  cursor?: Maybe<ClinicPetParentPimsSyncStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentPimsSyncStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentPimsSyncStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentPimsSyncStatusWhereInput>;
};


export type QueryFindManyClinicPetPimsSyncStatusArgs = {
  cursor?: Maybe<ClinicPetPimsSyncStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetPimsSyncStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetPimsSyncStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetPimsSyncStatusWhereInput>;
};


export type QueryFindManyClinicPetPimsSyncStatusCountArgs = {
  cursor?: Maybe<ClinicPetPimsSyncStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetPimsSyncStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetPimsSyncStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetPimsSyncStatusWhereInput>;
};


export type QueryFindManyClinicPhoneNumberArgs = {
  cursor?: Maybe<ClinicPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPhoneNumberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPhoneNumberWhereInput>;
};


export type QueryFindManyClinicPhoneNumberCountArgs = {
  cursor?: Maybe<ClinicPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPhoneNumberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPhoneNumberWhereInput>;
};


export type QueryFindManyClinicPimsIntegrationArgs = {
  cursor?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPimsIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type QueryFindManyClinicPimsIntegrationCapabilityArgs = {
  cursor?: Maybe<ClinicPimsIntegrationCapabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationCapabilityWhereInput>;
};


export type QueryFindManyClinicPimsIntegrationCapabilityCountArgs = {
  cursor?: Maybe<ClinicPimsIntegrationCapabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationCapabilityWhereInput>;
};


export type QueryFindManyClinicPimsIntegrationCapabilityHistoryEntryArgs = {
  cursor?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityHistoryEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>;
};


export type QueryFindManyClinicPimsIntegrationCapabilityHistoryEntryCountArgs = {
  cursor?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationCapabilityHistoryEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationCapabilityHistoryEntryWhereInput>;
};


export type QueryFindManyClinicPimsIntegrationCountArgs = {
  cursor?: Maybe<ClinicPimsIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPimsIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPimsIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type QueryFindManyClinicPostcardSettingArgs = {
  cursor?: Maybe<ClinicPostcardSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPostcardSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPostcardSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPostcardSettingWhereInput>;
};


export type QueryFindManyClinicPostcardSettingCountArgs = {
  cursor?: Maybe<ClinicPostcardSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPostcardSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPostcardSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPostcardSettingWhereInput>;
};


export type QueryFindManyClinicRoomArgs = {
  cursor?: Maybe<ClinicRoomWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicRoomScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicRoomOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicRoomWhereInput>;
};


export type QueryFindManyClinicRoomCountArgs = {
  cursor?: Maybe<ClinicRoomWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicRoomScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicRoomOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicRoomWhereInput>;
};


export type QueryFindManyClinicSettingArgs = {
  cursor?: Maybe<ClinicSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicSettingWhereInput>;
};


export type QueryFindManyClinicSettingCountArgs = {
  cursor?: Maybe<ClinicSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicSettingWhereInput>;
};


export type QueryFindManyClinicUserFilterArgs = {
  cursor?: Maybe<ClinicUserFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicUserFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicUserFilterOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicUserFilterWhereInput>;
};


export type QueryFindManyClinicUserFilterCountArgs = {
  cursor?: Maybe<ClinicUserFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicUserFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicUserFilterOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicUserFilterWhereInput>;
};


export type QueryFindManyClinicWidgetRequestArgs = {
  cursor?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type QueryFindManyClinicWidgetRequestCountArgs = {
  cursor?: Maybe<ClinicWidgetRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};


export type QueryFindManyClinicWidgetRequestTypeArgs = {
  cursor?: Maybe<ClinicWidgetRequestTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};


export type QueryFindManyClinicWidgetRequestTypeCountArgs = {
  cursor?: Maybe<ClinicWidgetRequestTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};


export type QueryFindManyClinicWidgetSettingArgs = {
  cursor?: Maybe<ClinicWidgetSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetSettingWhereInput>;
};


export type QueryFindManyClinicWidgetSettingCountArgs = {
  cursor?: Maybe<ClinicWidgetSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetSettingWhereInput>;
};


export type QueryFindManyColorArgs = {
  cursor?: Maybe<ColorWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ColorScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ColorOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ColorWhereInput>;
};


export type QueryFindManyColorCountArgs = {
  cursor?: Maybe<ColorWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ColorScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ColorOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ColorWhereInput>;
};


export type QueryFindManyConditionArgs = {
  cursor?: Maybe<ConditionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConditionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConditionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionWhereInput>;
};


export type QueryFindManyConditionCountArgs = {
  cursor?: Maybe<ConditionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConditionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConditionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionWhereInput>;
};


export type QueryFindManyConditionSetArgs = {
  cursor?: Maybe<ConditionSetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConditionSetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConditionSetOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionSetWhereInput>;
};


export type QueryFindManyConditionSetCountArgs = {
  cursor?: Maybe<ConditionSetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConditionSetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConditionSetOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionSetWhereInput>;
};


export type QueryFindManyConditionalEntityEvaluationArgs = {
  cursor?: Maybe<ConditionalEntityEvaluationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConditionalEntityEvaluationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConditionalEntityEvaluationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionalEntityEvaluationWhereInput>;
};


export type QueryFindManyConditionalEntityEvaluationCountArgs = {
  cursor?: Maybe<ConditionalEntityEvaluationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConditionalEntityEvaluationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConditionalEntityEvaluationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConditionalEntityEvaluationWhereInput>;
};


export type QueryFindManyConsultationArgs = {
  cursor?: Maybe<ConsultationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationWhereInput>;
};


export type QueryFindManyConsultationCountArgs = {
  cursor?: Maybe<ConsultationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationWhereInput>;
};


export type QueryFindManyConsultationRequestArgs = {
  cursor?: Maybe<ConsultationRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationRequestOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationRequestWhereInput>;
};


export type QueryFindManyConsultationRequestCountArgs = {
  cursor?: Maybe<ConsultationRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationRequestOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationRequestWhereInput>;
};


export type QueryFindManyCustomFieldDefinitionArgs = {
  cursor?: Maybe<CustomFieldDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CustomFieldDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CustomFieldDefinitionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};


export type QueryFindManyCustomFieldDefinitionCountArgs = {
  cursor?: Maybe<CustomFieldDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CustomFieldDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CustomFieldDefinitionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CustomFieldDefinitionWhereInput>;
};


export type QueryFindManyCustomFieldPimsWritebackLogEntryArgs = {
  cursor?: Maybe<CustomFieldPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CustomFieldPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CustomFieldPimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
};


export type QueryFindManyCustomFieldPimsWritebackLogEntryCountArgs = {
  cursor?: Maybe<CustomFieldPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CustomFieldPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CustomFieldPimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CustomFieldPimsWritebackLogEntryWhereInput>;
};


export type QueryFindManyDirectBookingAppointmentTypeSettingArgs = {
  cursor?: Maybe<DirectBookingAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingAppointmentTypeSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingAppointmentTypeSettingWhereInput>;
};


export type QueryFindManyDirectBookingAppointmentTypeSettingCountArgs = {
  cursor?: Maybe<DirectBookingAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingAppointmentTypeSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingAppointmentTypeSettingWhereInput>;
};


export type QueryFindManyDirectBookingExclusionRuleArgs = {
  cursor?: Maybe<DirectBookingExclusionRuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingExclusionRuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingExclusionRuleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingExclusionRuleWhereInput>;
};


export type QueryFindManyDirectBookingExclusionRuleCountArgs = {
  cursor?: Maybe<DirectBookingExclusionRuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingExclusionRuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingExclusionRuleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingExclusionRuleWhereInput>;
};


export type QueryFindManyDirectBookingExclusionTimeSlotArgs = {
  cursor?: Maybe<DirectBookingExclusionTimeSlotWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingExclusionTimeSlotScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingExclusionTimeSlotOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingExclusionTimeSlotWhereInput>;
};


export type QueryFindManyDirectBookingExclusionTimeSlotCountArgs = {
  cursor?: Maybe<DirectBookingExclusionTimeSlotWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DirectBookingExclusionTimeSlotScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DirectBookingExclusionTimeSlotOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DirectBookingExclusionTimeSlotWhereInput>;
};


export type QueryFindManyDisbursementArgs = {
  cursor?: Maybe<DisbursementWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DisbursementScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DisbursementOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DisbursementWhereInput>;
};


export type QueryFindManyDisbursementCountArgs = {
  cursor?: Maybe<DisbursementWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DisbursementScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DisbursementOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DisbursementWhereInput>;
};


export type QueryFindManyDocumentationArgs = {
  cursor?: Maybe<DocumentationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DocumentationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DocumentationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentationWhereInput>;
};


export type QueryFindManyDocumentationCountArgs = {
  cursor?: Maybe<DocumentationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<DocumentationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<DocumentationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentationWhereInput>;
};


export type QueryFindManyEmailCampaignArgs = {
  cursor?: Maybe<EmailCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignWhereInput>;
};


export type QueryFindManyEmailCampaignCountArgs = {
  cursor?: Maybe<EmailCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignWhereInput>;
};


export type QueryFindManyEmailCampaignCustomListArgs = {
  cursor?: Maybe<EmailCampaignCustomListWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignCustomListScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListWhereInput>;
};


export type QueryFindManyEmailCampaignCustomListCountArgs = {
  cursor?: Maybe<EmailCampaignCustomListWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignCustomListScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListWhereInput>;
};


export type QueryFindManyEmailCampaignCustomListRecipientArgs = {
  cursor?: Maybe<EmailCampaignCustomListRecipientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignCustomListRecipientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListRecipientOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListRecipientWhereInput>;
};


export type QueryFindManyEmailCampaignCustomListRecipientCountArgs = {
  cursor?: Maybe<EmailCampaignCustomListRecipientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignCustomListRecipientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListRecipientOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListRecipientWhereInput>;
};


export type QueryFindManyEmailCampaignCustomListUploadHistoryArgs = {
  cursor?: Maybe<EmailCampaignCustomListUploadHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignCustomListUploadHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListUploadHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListUploadHistoryWhereInput>;
};


export type QueryFindManyEmailCampaignCustomListUploadHistoryCountArgs = {
  cursor?: Maybe<EmailCampaignCustomListUploadHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignCustomListUploadHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignCustomListUploadHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignCustomListUploadHistoryWhereInput>;
};


export type QueryFindManyEmailCampaignLogArgs = {
  cursor?: Maybe<EmailCampaignLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignLogOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignLogWhereInput>;
};


export type QueryFindManyEmailCampaignLogCountArgs = {
  cursor?: Maybe<EmailCampaignLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignLogOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignLogWhereInput>;
};


export type QueryFindManyEmailCampaignTemplateArgs = {
  cursor?: Maybe<EmailCampaignTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignTemplateWhereInput>;
};


export type QueryFindManyEmailCampaignTemplateCountArgs = {
  cursor?: Maybe<EmailCampaignTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignTemplateWhereInput>;
};


export type QueryFindManyEmailCampaignUnsubscribeArgs = {
  cursor?: Maybe<EmailCampaignUnsubscribeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignUnsubscribeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignUnsubscribeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignUnsubscribeWhereInput>;
};


export type QueryFindManyEmailCampaignUnsubscribeCountArgs = {
  cursor?: Maybe<EmailCampaignUnsubscribeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignUnsubscribeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignUnsubscribeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignUnsubscribeWhereInput>;
};


export type QueryFindManyEmailProviderLogArgs = {
  cursor?: Maybe<EmailProviderLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailProviderLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailProviderLogOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailProviderLogWhereInput>;
};


export type QueryFindManyEmailProviderLogCountArgs = {
  cursor?: Maybe<EmailProviderLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailProviderLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailProviderLogOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailProviderLogWhereInput>;
};


export type QueryFindManyEmergencyClinicsArgs = {
  cursor?: Maybe<EmergencyClinicsWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmergencyClinicsScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmergencyClinicsOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmergencyClinicsWhereInput>;
};


export type QueryFindManyEmergencyClinicsCountArgs = {
  cursor?: Maybe<EmergencyClinicsWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmergencyClinicsScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmergencyClinicsOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmergencyClinicsWhereInput>;
};


export type QueryFindManyEncryptedClinicUploadArgs = {
  cursor?: Maybe<EncryptedClinicUploadWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EncryptedClinicUploadScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EncryptedClinicUploadOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};


export type QueryFindManyEncryptedClinicUploadCountArgs = {
  cursor?: Maybe<EncryptedClinicUploadWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EncryptedClinicUploadScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EncryptedClinicUploadOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};


export type QueryFindManyEnrollmentSupportEventArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type QueryFindManyEnrollmentSupportEventCountArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type QueryFindManyEzyVetIntegrationArgs = {
  cursor?: Maybe<EzyVetIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EzyVetIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EzyVetIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EzyVetIntegrationWhereInput>;
};


export type QueryFindManyEzyVetIntegrationCountArgs = {
  cursor?: Maybe<EzyVetIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EzyVetIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EzyVetIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EzyVetIntegrationWhereInput>;
};


export type QueryFindManyFeatureFlagArgs = {
  cursor?: Maybe<FeatureFlagWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FeatureFlagScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FeatureFlagOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FeatureFlagWhereInput>;
};


export type QueryFindManyFeatureFlagCountArgs = {
  cursor?: Maybe<FeatureFlagWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FeatureFlagScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FeatureFlagOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FeatureFlagWhereInput>;
};


export type QueryFindManyFinancialAdjustmentArgs = {
  cursor?: Maybe<FinancialAdjustmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FinancialAdjustmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FinancialAdjustmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialAdjustmentWhereInput>;
};


export type QueryFindManyFinancialAdjustmentCountArgs = {
  cursor?: Maybe<FinancialAdjustmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FinancialAdjustmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FinancialAdjustmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialAdjustmentWhereInput>;
};


export type QueryFindManyFinancialTransactionArgs = {
  cursor?: Maybe<FinancialTransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FinancialTransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FinancialTransactionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type QueryFindManyFinancialTransactionCountArgs = {
  cursor?: Maybe<FinancialTransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FinancialTransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FinancialTransactionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type QueryFindManyFormSubmissionArgs = {
  cursor?: Maybe<FormSubmissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormSubmissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormSubmissionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormSubmissionWhereInput>;
};


export type QueryFindManyFormSubmissionCountArgs = {
  cursor?: Maybe<FormSubmissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormSubmissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormSubmissionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormSubmissionWhereInput>;
};


export type QueryFindManyFormTemplateArgs = {
  cursor?: Maybe<FormTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormTemplateWhereInput>;
};


export type QueryFindManyFormTemplateCountArgs = {
  cursor?: Maybe<FormTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormTemplateWhereInput>;
};


export type QueryFindManyGlobalPetParentArgs = {
  cursor?: Maybe<GlobalPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<GlobalPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<GlobalPetParentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GlobalPetParentWhereInput>;
};


export type QueryFindManyGlobalPetParentCountArgs = {
  cursor?: Maybe<GlobalPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<GlobalPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<GlobalPetParentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GlobalPetParentWhereInput>;
};


export type QueryFindManyGooglePlaceArgs = {
  cursor?: Maybe<GooglePlaceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<GooglePlaceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<GooglePlaceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GooglePlaceWhereInput>;
};


export type QueryFindManyGooglePlaceCountArgs = {
  cursor?: Maybe<GooglePlaceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<GooglePlaceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<GooglePlaceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GooglePlaceWhereInput>;
};


export type QueryFindManyHillsToHomeApiLogArgs = {
  cursor?: Maybe<HillsToHomeApiLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<HillsToHomeApiLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<HillsToHomeApiLogOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<HillsToHomeApiLogWhereInput>;
};


export type QueryFindManyHillsToHomeApiLogCountArgs = {
  cursor?: Maybe<HillsToHomeApiLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<HillsToHomeApiLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<HillsToHomeApiLogOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<HillsToHomeApiLogWhereInput>;
};


export type QueryFindManyInformAudienceDefinitionArgs = {
  cursor?: Maybe<InformAudienceDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceDefinitionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};


export type QueryFindManyInformAudienceDefinitionCountArgs = {
  cursor?: Maybe<InformAudienceDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceDefinitionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceDefinitionWhereInput>;
};


export type QueryFindManyInformAudienceMemberArgs = {
  cursor?: Maybe<InformAudienceMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberWhereInput>;
};


export type QueryFindManyInformAudienceMemberCountArgs = {
  cursor?: Maybe<InformAudienceMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberWhereInput>;
};


export type QueryFindManyInformAudienceMemberMessageArgs = {
  cursor?: Maybe<InformAudienceMemberMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceMemberMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberMessageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberMessageWhereInput>;
};


export type QueryFindManyInformAudienceMemberMessageCountArgs = {
  cursor?: Maybe<InformAudienceMemberMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceMemberMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberMessageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberMessageWhereInput>;
};


export type QueryFindManyInformAutomationCampaignArgs = {
  cursor?: Maybe<InformAutomationCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAutomationCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAutomationCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAutomationCampaignWhereInput>;
};


export type QueryFindManyInformAutomationCampaignCountArgs = {
  cursor?: Maybe<InformAutomationCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAutomationCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAutomationCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAutomationCampaignWhereInput>;
};


export type QueryFindManyInformCampaignArgs = {
  cursor?: Maybe<InformCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignWhereInput>;
};


export type QueryFindManyInformCampaignCountArgs = {
  cursor?: Maybe<InformCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignWhereInput>;
};


export type QueryFindManyInformCampaignEnrollmentArgs = {
  cursor?: Maybe<InformCampaignEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignEnrollmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignEnrollmentWhereInput>;
};


export type QueryFindManyInformCampaignEnrollmentCanonicalServiceArgs = {
  cursor?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignEnrollmentCanonicalServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignEnrollmentCanonicalServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereInput>;
};


export type QueryFindManyInformCampaignEnrollmentCanonicalServiceCountArgs = {
  cursor?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignEnrollmentCanonicalServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignEnrollmentCanonicalServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignEnrollmentCanonicalServiceWhereInput>;
};


export type QueryFindManyInformCampaignEnrollmentCountArgs = {
  cursor?: Maybe<InformCampaignEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignEnrollmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignEnrollmentWhereInput>;
};


export type QueryFindManyInformCampaignExecutionArgs = {
  cursor?: Maybe<InformCampaignExecutionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignExecutionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignExecutionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignExecutionWhereInput>;
};


export type QueryFindManyInformCampaignExecutionCountArgs = {
  cursor?: Maybe<InformCampaignExecutionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignExecutionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignExecutionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignExecutionWhereInput>;
};


export type QueryFindManyInformCampaignGroupArgs = {
  cursor?: Maybe<InformCampaignGroupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignGroupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignGroupOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignGroupWhereInput>;
};


export type QueryFindManyInformCampaignGroupCountArgs = {
  cursor?: Maybe<InformCampaignGroupWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCampaignGroupScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCampaignGroupOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCampaignGroupWhereInput>;
};


export type QueryFindManyInformCommunicationOptOutArgs = {
  cursor?: Maybe<InformCommunicationOptOutWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCommunicationOptOutScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCommunicationOptOutOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCommunicationOptOutWhereInput>;
};


export type QueryFindManyInformCommunicationOptOutCountArgs = {
  cursor?: Maybe<InformCommunicationOptOutWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformCommunicationOptOutScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformCommunicationOptOutOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformCommunicationOptOutWhereInput>;
};


export type QueryFindManyInformControlGroupParticipantArgs = {
  cursor?: Maybe<InformControlGroupParticipantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformControlGroupParticipantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformControlGroupParticipantOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformControlGroupParticipantWhereInput>;
};


export type QueryFindManyInformControlGroupParticipantCountArgs = {
  cursor?: Maybe<InformControlGroupParticipantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformControlGroupParticipantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformControlGroupParticipantOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformControlGroupParticipantWhereInput>;
};


export type QueryFindManyInformEmailTemplateArgs = {
  cursor?: Maybe<InformEmailTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEmailTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEmailTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEmailTemplateWhereInput>;
};


export type QueryFindManyInformEmailTemplateCountArgs = {
  cursor?: Maybe<InformEmailTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEmailTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEmailTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEmailTemplateWhereInput>;
};


export type QueryFindManyInformEntityHistoryArgs = {
  cursor?: Maybe<InformEntityHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEntityHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEntityHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEntityHistoryWhereInput>;
};


export type QueryFindManyInformEntityHistoryCountArgs = {
  cursor?: Maybe<InformEntityHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEntityHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEntityHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEntityHistoryWhereInput>;
};


export type QueryFindManyInformEventDrivenCampaignArgs = {
  cursor?: Maybe<InformEventDrivenCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEventDrivenCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEventDrivenCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEventDrivenCampaignWhereInput>;
};


export type QueryFindManyInformEventDrivenCampaignCountArgs = {
  cursor?: Maybe<InformEventDrivenCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEventDrivenCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEventDrivenCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEventDrivenCampaignWhereInput>;
};


export type QueryFindManyInformEventListenerArgs = {
  cursor?: Maybe<InformEventListenerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEventListenerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEventListenerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEventListenerWhereInput>;
};


export type QueryFindManyInformEventListenerCountArgs = {
  cursor?: Maybe<InformEventListenerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformEventListenerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformEventListenerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformEventListenerWhereInput>;
};


export type QueryFindManyInformNotificationRecipientArgs = {
  cursor?: Maybe<InformNotificationRecipientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformNotificationRecipientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformNotificationRecipientOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformNotificationRecipientWhereInput>;
};


export type QueryFindManyInformNotificationRecipientCountArgs = {
  cursor?: Maybe<InformNotificationRecipientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformNotificationRecipientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformNotificationRecipientOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformNotificationRecipientWhereInput>;
};


export type QueryFindManyInformPartnerArgs = {
  cursor?: Maybe<InformPartnerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerWhereInput>;
};


export type QueryFindManyInformPartnerCountArgs = {
  cursor?: Maybe<InformPartnerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerWhereInput>;
};


export type QueryFindManyInformPartnerCustomerArgs = {
  cursor?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};


export type QueryFindManyInformPartnerCustomerCountArgs = {
  cursor?: Maybe<InformPartnerCustomerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerWhereInput>;
};


export type QueryFindManyInformPartnerCustomerPharmacyProviderArgs = {
  cursor?: Maybe<InformPartnerCustomerPharmacyProviderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerPharmacyProviderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerPharmacyProviderOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerPharmacyProviderWhereInput>;
};


export type QueryFindManyInformPartnerCustomerPharmacyProviderCountArgs = {
  cursor?: Maybe<InformPartnerCustomerPharmacyProviderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerCustomerPharmacyProviderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerCustomerPharmacyProviderOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerCustomerPharmacyProviderWhereInput>;
};


export type QueryFindManyInformPartnerIntegrationArgs = {
  cursor?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};


export type QueryFindManyInformPartnerIntegrationCountArgs = {
  cursor?: Maybe<InformPartnerIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerIntegrationWhereInput>;
};


export type QueryFindManyInformPartnerIntegrationModelArgs = {
  cursor?: Maybe<InformPartnerIntegrationModelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerIntegrationModelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerIntegrationModelOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerIntegrationModelWhereInput>;
};


export type QueryFindManyInformPartnerIntegrationModelCountArgs = {
  cursor?: Maybe<InformPartnerIntegrationModelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerIntegrationModelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerIntegrationModelOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerIntegrationModelWhereInput>;
};


export type QueryFindManyInformPartnerProgramArgs = {
  cursor?: Maybe<InformPartnerProgramWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerProgramScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerProgramOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerProgramWhereInput>;
};


export type QueryFindManyInformPartnerProgramCountArgs = {
  cursor?: Maybe<InformPartnerProgramWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerProgramScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerProgramOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerProgramWhereInput>;
};


export type QueryFindManyInformPartnerProgramEnrollmentArgs = {
  cursor?: Maybe<InformPartnerProgramEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};


export type QueryFindManyInformPartnerProgramEnrollmentCountArgs = {
  cursor?: Maybe<InformPartnerProgramEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};


export type QueryFindManyInformPartnerUserArgs = {
  cursor?: Maybe<InformPartnerUserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerUserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserWhereInput>;
};


export type QueryFindManyInformPartnerUserCountArgs = {
  cursor?: Maybe<InformPartnerUserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerUserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserWhereInput>;
};


export type QueryFindManyInformPartnerUserRoleArgs = {
  cursor?: Maybe<InformPartnerUserRoleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerUserRoleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserRoleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserRoleWhereInput>;
};


export type QueryFindManyInformPartnerUserRoleCountArgs = {
  cursor?: Maybe<InformPartnerUserRoleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerUserRoleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerUserRoleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerUserRoleWhereInput>;
};


export type QueryFindManyInformScheduledCampaignArgs = {
  cursor?: Maybe<InformScheduledCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformScheduledCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformScheduledCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformScheduledCampaignWhereInput>;
};


export type QueryFindManyInformScheduledCampaignCountArgs = {
  cursor?: Maybe<InformScheduledCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformScheduledCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformScheduledCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformScheduledCampaignWhereInput>;
};


export type QueryFindManyInformSessionArgs = {
  cursor?: Maybe<InformSessionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformSessionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformSessionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionWhereInput>;
};


export type QueryFindManyInformSessionCountArgs = {
  cursor?: Maybe<InformSessionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformSessionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformSessionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionWhereInput>;
};


export type QueryFindManyInformSessionEventArgs = {
  cursor?: Maybe<InformSessionEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformSessionEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformSessionEventOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionEventWhereInput>;
};


export type QueryFindManyInformSessionEventCountArgs = {
  cursor?: Maybe<InformSessionEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformSessionEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformSessionEventOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformSessionEventWhereInput>;
};


export type QueryFindManyInstinctIntegrationArgs = {
  cursor?: Maybe<InstinctIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InstinctIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InstinctIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InstinctIntegrationWhereInput>;
};


export type QueryFindManyInstinctIntegrationCountArgs = {
  cursor?: Maybe<InstinctIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InstinctIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InstinctIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InstinctIntegrationWhereInput>;
};


export type QueryFindManyInsuranceIntegrationArgs = {
  cursor?: Maybe<InsuranceIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InsuranceIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InsuranceIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InsuranceIntegrationWhereInput>;
};


export type QueryFindManyInsuranceIntegrationCountArgs = {
  cursor?: Maybe<InsuranceIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InsuranceIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InsuranceIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InsuranceIntegrationWhereInput>;
};


export type QueryFindManyIntegrationOutageHistoryEntryArgs = {
  cursor?: Maybe<IntegrationOutageHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<IntegrationOutageHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<IntegrationOutageHistoryEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<IntegrationOutageHistoryEntryWhereInput>;
};


export type QueryFindManyIntegrationOutageHistoryEntryCountArgs = {
  cursor?: Maybe<IntegrationOutageHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<IntegrationOutageHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<IntegrationOutageHistoryEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<IntegrationOutageHistoryEntryWhereInput>;
};


export type QueryFindManyInterchangeRateArgs = {
  cursor?: Maybe<InterchangeRateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InterchangeRateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InterchangeRateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InterchangeRateWhereInput>;
};


export type QueryFindManyInterchangeRateCountArgs = {
  cursor?: Maybe<InterchangeRateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InterchangeRateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InterchangeRateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InterchangeRateWhereInput>;
};


export type QueryFindManyInvoiceArgs = {
  cursor?: Maybe<InvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceWhereInput>;
};


export type QueryFindManyInvoiceCountArgs = {
  cursor?: Maybe<InvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceWhereInput>;
};


export type QueryFindManyInvoiceLineItemArgs = {
  cursor?: Maybe<InvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceLineItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceLineItemWhereInput>;
};


export type QueryFindManyInvoiceLineItemCountArgs = {
  cursor?: Maybe<InvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceLineItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceLineItemWhereInput>;
};


export type QueryFindManyInvoicePimsWritebackLogEntryArgs = {
  cursor?: Maybe<InvoicePimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoicePimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoicePimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
};


export type QueryFindManyInvoicePimsWritebackLogEntryCountArgs = {
  cursor?: Maybe<InvoicePimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoicePimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoicePimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoicePimsWritebackLogEntryWhereInput>;
};


export type QueryFindManyLabPanelArgs = {
  cursor?: Maybe<LabPanelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LabPanelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LabPanelOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabPanelWhereInput>;
};


export type QueryFindManyLabPanelCountArgs = {
  cursor?: Maybe<LabPanelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LabPanelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LabPanelOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabPanelWhereInput>;
};


export type QueryFindManyLabResultArgs = {
  cursor?: Maybe<LabResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LabResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LabResultOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabResultWhereInput>;
};


export type QueryFindManyLabResultCountArgs = {
  cursor?: Maybe<LabResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LabResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LabResultOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LabResultWhereInput>;
};


export type QueryFindManyLapsedPetParentTriggersArgs = {
  cursor?: Maybe<LapsedPetParentTriggersWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LapsedPetParentTriggersScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LapsedPetParentTriggersOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LapsedPetParentTriggersWhereInput>;
};


export type QueryFindManyLapsedPetParentTriggersCountArgs = {
  cursor?: Maybe<LapsedPetParentTriggersWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LapsedPetParentTriggersScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LapsedPetParentTriggersOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LapsedPetParentTriggersWhereInput>;
};


export type QueryFindManyLegalEntityArgs = {
  cursor?: Maybe<LegalEntityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LegalEntityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LegalEntityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LegalEntityWhereInput>;
};


export type QueryFindManyLegalEntityCountArgs = {
  cursor?: Maybe<LegalEntityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LegalEntityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LegalEntityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LegalEntityWhereInput>;
};


export type QueryFindManyLoyaltyAccountArgs = {
  cursor?: Maybe<LoyaltyAccountWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountWhereInput>;
};


export type QueryFindManyLoyaltyAccountCountArgs = {
  cursor?: Maybe<LoyaltyAccountWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountWhereInput>;
};


export type QueryFindManyLoyaltyAccountHolderArgs = {
  cursor?: Maybe<LoyaltyAccountHolderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountHolderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountHolderOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};


export type QueryFindManyLoyaltyAccountHolderCountArgs = {
  cursor?: Maybe<LoyaltyAccountHolderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountHolderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountHolderOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
};


export type QueryFindManyLoyaltyAccountMergerArgs = {
  cursor?: Maybe<LoyaltyAccountMergerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountMergerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountMergerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountMergerWhereInput>;
};


export type QueryFindManyLoyaltyAccountMergerCountArgs = {
  cursor?: Maybe<LoyaltyAccountMergerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountMergerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountMergerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountMergerWhereInput>;
};


export type QueryFindManyLoyaltyInvoicePointGranterArgs = {
  cursor?: Maybe<LoyaltyInvoicePointGranterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyInvoicePointGranterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};


export type QueryFindManyLoyaltyInvoicePointGranterCountArgs = {
  cursor?: Maybe<LoyaltyInvoicePointGranterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyInvoicePointGranterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyInvoicePointGranterOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyInvoicePointGranterWhereInput>;
};


export type QueryFindManyLoyaltyPointDeltaArgs = {
  cursor?: Maybe<LoyaltyPointDeltaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointDeltaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointDeltaOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
};


export type QueryFindManyLoyaltyPointDeltaCountArgs = {
  cursor?: Maybe<LoyaltyPointDeltaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointDeltaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointDeltaOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
};


export type QueryFindManyLoyaltyPointGrantingServiceArgs = {
  cursor?: Maybe<LoyaltyPointGrantingServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointGrantingServiceWhereInput>;
};


export type QueryFindManyLoyaltyPointGrantingServiceCategoryArgs = {
  cursor?: Maybe<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceCategoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointGrantingServiceCategoryWhereInput>;
};


export type QueryFindManyLoyaltyPointGrantingServiceCategoryCountArgs = {
  cursor?: Maybe<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceCategoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointGrantingServiceCategoryWhereInput>;
};


export type QueryFindManyLoyaltyPointGrantingServiceCountArgs = {
  cursor?: Maybe<LoyaltyPointGrantingServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointGrantingServiceWhereInput>;
};


export type QueryFindManyLoyaltyPointUserGrantArgs = {
  cursor?: Maybe<LoyaltyPointUserGrantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointUserGrantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointUserGrantOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointUserGrantWhereInput>;
};


export type QueryFindManyLoyaltyPointUserGrantCountArgs = {
  cursor?: Maybe<LoyaltyPointUserGrantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointUserGrantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointUserGrantOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointUserGrantWhereInput>;
};


export type QueryFindManyLoyaltyProgramArgs = {
  cursor?: Maybe<LoyaltyProgramWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyProgramScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyProgramOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyProgramWhereInput>;
};


export type QueryFindManyLoyaltyProgramCountArgs = {
  cursor?: Maybe<LoyaltyProgramWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyProgramScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyProgramOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyProgramWhereInput>;
};


export type QueryFindManyLoyaltyProgramStatusHistoryArgs = {
  cursor?: Maybe<LoyaltyProgramStatusHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyProgramStatusHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyProgramStatusHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyProgramStatusHistoryWhereInput>;
};


export type QueryFindManyLoyaltyProgramStatusHistoryCountArgs = {
  cursor?: Maybe<LoyaltyProgramStatusHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyProgramStatusHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyProgramStatusHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyProgramStatusHistoryWhereInput>;
};


export type QueryFindManyLoyaltyRewardArgs = {
  cursor?: Maybe<LoyaltyRewardWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardWhereInput>;
};


export type QueryFindManyLoyaltyRewardCountArgs = {
  cursor?: Maybe<LoyaltyRewardWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardWhereInput>;
};


export type QueryFindManyLoyaltyRewardRedemptionArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardRedemptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionWhereInput>;
};


export type QueryFindManyLoyaltyRewardRedemptionCountArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardRedemptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionWhereInput>;
};


export type QueryFindManyLoyaltyRewardRedemptionHistoryEntryArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
};


export type QueryFindManyLoyaltyRewardRedemptionHistoryEntryCountArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
};


export type QueryFindManyMassTextAlertArgs = {
  cursor?: Maybe<MassTextAlertWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertWhereInput>;
};


export type QueryFindManyMassTextAlertCountArgs = {
  cursor?: Maybe<MassTextAlertWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertWhereInput>;
};


export type QueryFindManyMassTextAlertEntryArgs = {
  cursor?: Maybe<MassTextAlertEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertEntryWhereInput>;
};


export type QueryFindManyMassTextAlertEntryAppointmentArgs = {
  cursor?: Maybe<MassTextAlertEntryAppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertEntryAppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertEntryAppointmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertEntryAppointmentWhereInput>;
};


export type QueryFindManyMassTextAlertEntryAppointmentCountArgs = {
  cursor?: Maybe<MassTextAlertEntryAppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertEntryAppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertEntryAppointmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertEntryAppointmentWhereInput>;
};


export type QueryFindManyMassTextAlertEntryCountArgs = {
  cursor?: Maybe<MassTextAlertEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertEntryWhereInput>;
};


export type QueryFindManyMediaArgs = {
  cursor?: Maybe<MediaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MediaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MediaOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MediaWhereInput>;
};


export type QueryFindManyMediaCountArgs = {
  cursor?: Maybe<MediaWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MediaScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MediaOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MediaWhereInput>;
};


export type QueryFindManyMedicalHistoryArgs = {
  cursor?: Maybe<MedicalHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MedicalHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MedicalHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MedicalHistoryWhereInput>;
};


export type QueryFindManyMedicalHistoryCountArgs = {
  cursor?: Maybe<MedicalHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MedicalHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MedicalHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MedicalHistoryWhereInput>;
};


export type QueryFindManyMessageTemplateArgs = {
  cursor?: Maybe<MessageTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MessageTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MessageTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessageTemplateWhereInput>;
};


export type QueryFindManyMessageTemplateCountArgs = {
  cursor?: Maybe<MessageTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MessageTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MessageTemplateOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessageTemplateWhereInput>;
};


export type QueryFindManyMessagingCampaignArgs = {
  cursor?: Maybe<MessagingCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MessagingCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MessagingCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessagingCampaignWhereInput>;
};


export type QueryFindManyMessagingCampaignCountArgs = {
  cursor?: Maybe<MessagingCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MessagingCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MessagingCampaignOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessagingCampaignWhereInput>;
};


export type QueryFindManyMessagingPartnerArgs = {
  cursor?: Maybe<MessagingPartnerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MessagingPartnerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MessagingPartnerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessagingPartnerWhereInput>;
};


export type QueryFindManyMessagingPartnerCountArgs = {
  cursor?: Maybe<MessagingPartnerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MessagingPartnerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MessagingPartnerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessagingPartnerWhereInput>;
};


export type QueryFindManyModuleArgs = {
  cursor?: Maybe<ModuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ModuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ModuleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ModuleWhereInput>;
};


export type QueryFindManyModuleCountArgs = {
  cursor?: Maybe<ModuleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ModuleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ModuleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ModuleWhereInput>;
};


export type QueryFindManyNonPrismaSchemaScriptRanArgs = {
  cursor?: Maybe<NonPrismaSchemaScriptRanWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<NonPrismaSchemaScriptRanScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<NonPrismaSchemaScriptRanOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<NonPrismaSchemaScriptRanWhereInput>;
};


export type QueryFindManyNonPrismaSchemaScriptRanCountArgs = {
  cursor?: Maybe<NonPrismaSchemaScriptRanWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<NonPrismaSchemaScriptRanScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<NonPrismaSchemaScriptRanOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<NonPrismaSchemaScriptRanWhereInput>;
};


export type QueryFindManyNotificationEventToMessageArgs = {
  cursor?: Maybe<NotificationEventToMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<NotificationEventToMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<NotificationEventToMessageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<NotificationEventToMessageWhereInput>;
};


export type QueryFindManyNotificationEventToMessageCountArgs = {
  cursor?: Maybe<NotificationEventToMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<NotificationEventToMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<NotificationEventToMessageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<NotificationEventToMessageWhereInput>;
};


export type QueryFindManyOrganizationArgs = {
  cursor?: Maybe<OrganizationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationWhereInput>;
};


export type QueryFindManyOrganizationCareBenefitToClinicServiceArgs = {
  cursor?: Maybe<OrganizationCareBenefitToClinicServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationCareBenefitToClinicServiceWhereInput>;
};


export type QueryFindManyOrganizationCareBenefitToClinicServiceCategoryArgs = {
  cursor?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereInput>;
};


export type QueryFindManyOrganizationCareBenefitToClinicServiceCategoryCountArgs = {
  cursor?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereInput>;
};


export type QueryFindManyOrganizationCareBenefitToClinicServiceCountArgs = {
  cursor?: Maybe<OrganizationCareBenefitToClinicServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationCareBenefitToClinicServiceWhereInput>;
};


export type QueryFindManyOrganizationCountArgs = {
  cursor?: Maybe<OrganizationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationWhereInput>;
};


export type QueryFindManyOrganizationPetArgs = {
  cursor?: Maybe<OrganizationPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetWhereInput>;
};


export type QueryFindManyOrganizationPetCountArgs = {
  cursor?: Maybe<OrganizationPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetWhereInput>;
};


export type QueryFindManyOrganizationPetParentArgs = {
  cursor?: Maybe<OrganizationPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetParentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetParentWhereInput>;
};


export type QueryFindManyOrganizationPetParentCountArgs = {
  cursor?: Maybe<OrganizationPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetParentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetParentWhereInput>;
};


export type QueryFindManyOrganizationPetToOrganizationPetParentArgs = {
  cursor?: Maybe<OrganizationPetToOrganizationPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetToOrganizationPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetToOrganizationPetParentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetToOrganizationPetParentWhereInput>;
};


export type QueryFindManyOrganizationPetToOrganizationPetParentCountArgs = {
  cursor?: Maybe<OrganizationPetToOrganizationPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetToOrganizationPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetToOrganizationPetParentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetToOrganizationPetParentWhereInput>;
};


export type QueryFindManyPpcIntegrationArgs = {
  cursor?: Maybe<PpcIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PpcIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PpcIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PpcIntegrationWhereInput>;
};


export type QueryFindManyPpcIntegrationCountArgs = {
  cursor?: Maybe<PpcIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PpcIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PpcIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PpcIntegrationWhereInput>;
};


export type QueryFindManyParentWorkflowEventSettingArgs = {
  workflowId: Scalars['String'];
};


export type QueryFindManyPaymentsReportTransactionArgs = {
  cursor?: Maybe<PaymentsReportTransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PaymentsReportTransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PaymentsReportTransactionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PaymentsReportTransactionWhereInput>;
};


export type QueryFindManyPaymentsReportTransactionCountArgs = {
  cursor?: Maybe<PaymentsReportTransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PaymentsReportTransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PaymentsReportTransactionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PaymentsReportTransactionWhereInput>;
};


export type QueryFindManyPayoutBatchingPeriodArgs = {
  cursor?: Maybe<PayoutBatchingPeriodWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingPeriodScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingPeriodOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingPeriodWhereInput>;
};


export type QueryFindManyPayoutBatchingPeriodCountArgs = {
  cursor?: Maybe<PayoutBatchingPeriodWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingPeriodScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingPeriodOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingPeriodWhereInput>;
};


export type QueryFindManyPayoutBatchingScheduleArgs = {
  cursor?: Maybe<PayoutBatchingScheduleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingScheduleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingScheduleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingScheduleWhereInput>;
};


export type QueryFindManyPayoutBatchingScheduleCountArgs = {
  cursor?: Maybe<PayoutBatchingScheduleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingScheduleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingScheduleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingScheduleWhereInput>;
};


export type QueryFindManyPayoutBatchingSettingArgs = {
  cursor?: Maybe<PayoutBatchingSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingSettingWhereInput>;
};


export type QueryFindManyPayoutBatchingSettingCountArgs = {
  cursor?: Maybe<PayoutBatchingSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingSettingWhereInput>;
};


export type QueryFindManyPermissionArgs = {
  cursor?: Maybe<PermissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PermissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PermissionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PermissionWhereInput>;
};


export type QueryFindManyPermissionCountArgs = {
  cursor?: Maybe<PermissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PermissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PermissionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PermissionWhereInput>;
};


export type QueryFindManyPetParentSettingArgs = {
  cursor?: Maybe<PetParentSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PetParentSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PetParentSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PetParentSettingWhereInput>;
};


export type QueryFindManyPetParentSettingCountArgs = {
  cursor?: Maybe<PetParentSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PetParentSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PetParentSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PetParentSettingWhereInput>;
};


export type QueryFindManyPetPortalSettingArgs = {
  cursor?: Maybe<PetPortalSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PetPortalSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PetPortalSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PetPortalSettingWhereInput>;
};


export type QueryFindManyPetPortalSettingCountArgs = {
  cursor?: Maybe<PetPortalSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PetPortalSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PetPortalSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PetPortalSettingWhereInput>;
};


export type QueryFindManyPhoneNumberLookupRequestArgs = {
  cursor?: Maybe<PhoneNumberLookupRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PhoneNumberLookupRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PhoneNumberLookupRequestOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PhoneNumberLookupRequestWhereInput>;
};


export type QueryFindManyPhoneNumberLookupRequestCountArgs = {
  cursor?: Maybe<PhoneNumberLookupRequestWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PhoneNumberLookupRequestScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PhoneNumberLookupRequestOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PhoneNumberLookupRequestWhereInput>;
};


export type QueryFindManyPhoneNumberLookupResultArgs = {
  cursor?: Maybe<PhoneNumberLookupResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PhoneNumberLookupResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PhoneNumberLookupResultOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PhoneNumberLookupResultWhereInput>;
};


export type QueryFindManyPhoneNumberLookupResultCountArgs = {
  cursor?: Maybe<PhoneNumberLookupResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PhoneNumberLookupResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PhoneNumberLookupResultOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PhoneNumberLookupResultWhereInput>;
};


export type QueryFindManyPimsInvoiceArgs = {
  cursor?: Maybe<PimsInvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsInvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsInvoiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsInvoiceWhereInput>;
};


export type QueryFindManyPimsInvoiceCountArgs = {
  cursor?: Maybe<PimsInvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsInvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsInvoiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsInvoiceWhereInput>;
};


export type QueryFindManyPimsInvoiceLineItemArgs = {
  cursor?: Maybe<PimsInvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsInvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsInvoiceLineItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsInvoiceLineItemWhereInput>;
};


export type QueryFindManyPimsInvoiceLineItemCountArgs = {
  cursor?: Maybe<PimsInvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsInvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsInvoiceLineItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsInvoiceLineItemWhereInput>;
};


export type QueryFindManyPimsPaymentTypeArgs = {
  cursor?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsPaymentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsPaymentTypeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};


export type QueryFindManyPimsPaymentTypeCountArgs = {
  cursor?: Maybe<PimsPaymentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsPaymentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsPaymentTypeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsPaymentTypeWhereInput>;
};


export type QueryFindManyPimsWritebackLogEntryArgs = {
  cursor?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};


export type QueryFindManyPimsWritebackLogEntryCountArgs = {
  cursor?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsWritebackLogEntryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};


export type QueryFindManyPrescriptionArgs = {
  cursor?: Maybe<PrescriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PrescriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PrescriptionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PrescriptionWhereInput>;
};


export type QueryFindManyPrescriptionCountArgs = {
  cursor?: Maybe<PrescriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PrescriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PrescriptionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PrescriptionWhereInput>;
};


export type QueryFindManyProductArgs = {
  cursor?: Maybe<ProductWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductWhereInput>;
};


export type QueryFindManyProductCountArgs = {
  cursor?: Maybe<ProductWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductWhereInput>;
};


export type QueryFindManyProductPackageArgs = {
  cursor?: Maybe<ProductPackageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductPackageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductPackageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductPackageWhereInput>;
};


export type QueryFindManyProductPackageCountArgs = {
  cursor?: Maybe<ProductPackageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductPackageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductPackageOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductPackageWhereInput>;
};


export type QueryFindManyProductPackageSubscriptionArgs = {
  cursor?: Maybe<ProductPackageSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductPackageSubscriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductPackageSubscriptionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductPackageSubscriptionWhereInput>;
};


export type QueryFindManyProductPackageSubscriptionCountArgs = {
  cursor?: Maybe<ProductPackageSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProductPackageSubscriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProductPackageSubscriptionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProductPackageSubscriptionWhereInput>;
};


export type QueryFindManyProviderAppointmentTypeRoomMapArgs = {
  cursor?: Maybe<ProviderAppointmentTypeRoomMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProviderAppointmentTypeRoomMapWhereInput>;
};


export type QueryFindManyProviderAppointmentTypeRoomMapCountArgs = {
  cursor?: Maybe<ProviderAppointmentTypeRoomMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ProviderAppointmentTypeRoomMapOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ProviderAppointmentTypeRoomMapWhereInput>;
};


export type QueryFindManyPushNotificationLogArgs = {
  cursor?: Maybe<PushNotificationLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PushNotificationLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PushNotificationLogOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PushNotificationLogWhereInput>;
};


export type QueryFindManyPushNotificationLogCountArgs = {
  cursor?: Maybe<PushNotificationLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PushNotificationLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PushNotificationLogOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PushNotificationLogWhereInput>;
};


export type QueryFindManyRecapArgs = {
  cursor?: Maybe<RecapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<RecapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<RecapOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RecapWhereInput>;
};


export type QueryFindManyRecapCountArgs = {
  cursor?: Maybe<RecapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<RecapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<RecapOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RecapWhereInput>;
};


export type QueryFindManyRulesArgs = {
  cursor?: Maybe<RulesWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<RulesScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<RulesOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RulesWhereInput>;
};


export type QueryFindManyRulesCountArgs = {
  cursor?: Maybe<RulesWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<RulesScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<RulesOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RulesWhereInput>;
};


export type QueryFindManySalesforceAccountsArgs = {
  sources: Array<SalesforceSource>;
  where: FindSalesforceAccountsWhereInput;
};


export type QueryFindManySegmentArgs = {
  cursor?: Maybe<SegmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SegmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SegmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SegmentWhereInput>;
};


export type QueryFindManySegmentCountArgs = {
  cursor?: Maybe<SegmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SegmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SegmentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SegmentWhereInput>;
};


export type QueryFindManySentTrupanionExamDayOfferArgs = {
  cursor?: Maybe<SentTrupanionExamDayOfferWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SentTrupanionExamDayOfferScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SentTrupanionExamDayOfferOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};


export type QueryFindManySentTrupanionExamDayOfferCountArgs = {
  cursor?: Maybe<SentTrupanionExamDayOfferWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SentTrupanionExamDayOfferScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SentTrupanionExamDayOfferOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};


export type QueryFindManyServiceArgs = {
  cursor?: Maybe<ServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceWhereInput>;
};


export type QueryFindManyServiceCategoryArgs = {
  cursor?: Maybe<ServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceCategoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceCategoryWhereInput>;
};


export type QueryFindManyServiceCategoryCountArgs = {
  cursor?: Maybe<ServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceCategoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceCategoryWhereInput>;
};


export type QueryFindManyServiceCountArgs = {
  cursor?: Maybe<ServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceWhereInput>;
};


export type QueryFindManyServicePurchaseSummaryArgs = {
  cursor?: Maybe<ServicePurchaseSummaryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServicePurchaseSummaryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServicePurchaseSummaryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};


export type QueryFindManyServicePurchaseSummaryCountArgs = {
  cursor?: Maybe<ServicePurchaseSummaryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServicePurchaseSummaryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServicePurchaseSummaryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};


export type QueryFindManyServiceReminderArgs = {
  cursor?: Maybe<ServiceReminderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderWhereInput>;
};


export type QueryFindManyServiceReminderCountArgs = {
  cursor?: Maybe<ServiceReminderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderWhereInput>;
};


export type QueryFindManyServiceReminderNotificationArgs = {
  cursor?: Maybe<ServiceReminderNotificationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderNotificationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderNotificationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};


export type QueryFindManyServiceReminderNotificationCountArgs = {
  cursor?: Maybe<ServiceReminderNotificationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderNotificationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderNotificationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};


export type QueryFindManyServiceReminderTimingArgs = {
  cursor?: Maybe<ServiceReminderTimingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderTimingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderTimingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderTimingWhereInput>;
};


export type QueryFindManyServiceReminderTimingCountArgs = {
  cursor?: Maybe<ServiceReminderTimingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderTimingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderTimingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderTimingWhereInput>;
};


export type QueryFindManySexArgs = {
  cursor?: Maybe<SexWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SexScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SexOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SexWhereInput>;
};


export type QueryFindManySexCountArgs = {
  cursor?: Maybe<SexWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SexScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SexOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SexWhereInput>;
};


export type QueryFindManySmsNotificationStatusArgs = {
  cursor?: Maybe<SmsNotificationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SmsNotificationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SmsNotificationStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SmsNotificationStatusWhereInput>;
};


export type QueryFindManySmsNotificationStatusCountArgs = {
  cursor?: Maybe<SmsNotificationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SmsNotificationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SmsNotificationStatusOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SmsNotificationStatusWhereInput>;
};


export type QueryFindManySpeciesArgs = {
  cursor?: Maybe<SpeciesWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SpeciesScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SpeciesOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SpeciesWhereInput>;
};


export type QueryFindManySpeciesCountArgs = {
  cursor?: Maybe<SpeciesWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SpeciesScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SpeciesOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SpeciesWhereInput>;
};


export type QueryFindManyStaffRoleArgs = {
  cursor?: Maybe<StaffRoleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StaffRoleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StaffRoleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StaffRoleWhereInput>;
};


export type QueryFindManyStaffRoleCountArgs = {
  cursor?: Maybe<StaffRoleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StaffRoleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StaffRoleOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StaffRoleWhereInput>;
};


export type QueryFindManyStripeCustomerArgs = {
  cursor?: Maybe<StripeCustomerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeCustomerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeCustomerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeCustomerWhereInput>;
};


export type QueryFindManyStripeCustomerCountArgs = {
  cursor?: Maybe<StripeCustomerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeCustomerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeCustomerOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeCustomerWhereInput>;
};


export type QueryFindManyStripeDisputeArgs = {
  cursor?: Maybe<StripeDisputeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeDisputeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeDisputeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeDisputeWhereInput>;
};


export type QueryFindManyStripeDisputeCountArgs = {
  cursor?: Maybe<StripeDisputeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeDisputeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeDisputeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeDisputeWhereInput>;
};


export type QueryFindManyStripeInvoiceArgs = {
  cursor?: Maybe<StripeInvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeInvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeInvoiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type QueryFindManyStripeInvoiceCountArgs = {
  cursor?: Maybe<StripeInvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeInvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeInvoiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type QueryFindManyStripeInvoiceItemArgs = {
  cursor?: Maybe<StripeInvoiceItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeInvoiceItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeInvoiceItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeInvoiceItemWhereInput>;
};


export type QueryFindManyStripeInvoiceItemCountArgs = {
  cursor?: Maybe<StripeInvoiceItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeInvoiceItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeInvoiceItemOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeInvoiceItemWhereInput>;
};


export type QueryFindManyStripePaymentIntentArgs = {
  cursor?: Maybe<StripePaymentIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentIntentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type QueryFindManyStripePaymentIntentCountArgs = {
  cursor?: Maybe<StripePaymentIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentIntentOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type QueryFindManyStripePaymentMethodArgs = {
  cursor?: Maybe<StripePaymentMethodWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentMethodScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentMethodOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentMethodWhereInput>;
};


export type QueryFindManyStripePaymentMethodCountArgs = {
  cursor?: Maybe<StripePaymentMethodWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentMethodScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentMethodOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentMethodWhereInput>;
};


export type QueryFindManyStripePayoutArgs = {
  cursor?: Maybe<StripePayoutWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePayoutScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePayoutOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePayoutWhereInput>;
};


export type QueryFindManyStripePayoutAccountArgs = {
  cursor?: Maybe<StripePayoutAccountWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePayoutAccountScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePayoutAccountOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePayoutAccountWhereInput>;
};


export type QueryFindManyStripePayoutAccountCountArgs = {
  cursor?: Maybe<StripePayoutAccountWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePayoutAccountScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePayoutAccountOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePayoutAccountWhereInput>;
};


export type QueryFindManyStripePayoutCountArgs = {
  cursor?: Maybe<StripePayoutWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePayoutScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePayoutOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePayoutWhereInput>;
};


export type QueryFindManyStripeReceiptArgs = {
  cursor?: Maybe<StripeReceiptWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeReceiptScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeReceiptOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeReceiptWhereInput>;
};


export type QueryFindManyStripeReceiptCountArgs = {
  cursor?: Maybe<StripeReceiptWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeReceiptScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeReceiptOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeReceiptWhereInput>;
};


export type QueryFindManyStripeReceiptHistoryArgs = {
  cursor?: Maybe<StripeReceiptHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeReceiptHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeReceiptHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeReceiptHistoryWhereInput>;
};


export type QueryFindManyStripeReceiptHistoryCountArgs = {
  cursor?: Maybe<StripeReceiptHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeReceiptHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeReceiptHistoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeReceiptHistoryWhereInput>;
};


export type QueryFindManyStripeRefundArgs = {
  cursor?: Maybe<StripeRefundWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeRefundScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeRefundOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeRefundWhereInput>;
};


export type QueryFindManyStripeRefundCountArgs = {
  cursor?: Maybe<StripeRefundWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeRefundScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeRefundOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeRefundWhereInput>;
};


export type QueryFindManyStripeTerminalArgs = {
  cursor?: Maybe<StripeTerminalWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeTerminalScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeTerminalOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeTerminalWhereInput>;
};


export type QueryFindManyStripeTerminalCountArgs = {
  cursor?: Maybe<StripeTerminalWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeTerminalScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeTerminalOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeTerminalWhereInput>;
};


export type QueryFindManyStripeTerminalLocationArgs = {
  cursor?: Maybe<StripeTerminalLocationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeTerminalLocationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeTerminalLocationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeTerminalLocationWhereInput>;
};


export type QueryFindManyStripeTerminalLocationCountArgs = {
  cursor?: Maybe<StripeTerminalLocationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeTerminalLocationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeTerminalLocationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeTerminalLocationWhereInput>;
};


export type QueryFindManySurveyAppointmentTypeSettingArgs = {
  cursor?: Maybe<SurveyAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveyAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveyAppointmentTypeSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyAppointmentTypeSettingWhereInput>;
};


export type QueryFindManySurveyAppointmentTypeSettingCountArgs = {
  cursor?: Maybe<SurveyAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveyAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveyAppointmentTypeSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyAppointmentTypeSettingWhereInput>;
};


export type QueryFindManySurveyResultArgs = {
  cursor?: Maybe<SurveyResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveyResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveyResultOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyResultWhereInput>;
};


export type QueryFindManySurveyResultCountArgs = {
  cursor?: Maybe<SurveyResultWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveyResultScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveyResultOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyResultWhereInput>;
};


export type QueryFindManySurveySettingArgs = {
  cursor?: Maybe<SurveySettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveySettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveySettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveySettingWhereInput>;
};


export type QueryFindManySurveySettingCountArgs = {
  cursor?: Maybe<SurveySettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveySettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveySettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveySettingWhereInput>;
};


export type QueryFindManySyncVetIntegrationArgs = {
  cursor?: Maybe<SyncVetIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SyncVetIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SyncVetIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SyncVetIntegrationWhereInput>;
};


export type QueryFindManySyncVetIntegrationCountArgs = {
  cursor?: Maybe<SyncVetIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SyncVetIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SyncVetIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SyncVetIntegrationWhereInput>;
};


export type QueryFindManySyncVetServiceArgs = {
  cursor?: Maybe<SyncVetServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SyncVetServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SyncVetServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SyncVetServiceWhereInput>;
};


export type QueryFindManySyncVetServiceCountArgs = {
  cursor?: Maybe<SyncVetServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SyncVetServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SyncVetServiceOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SyncVetServiceWhereInput>;
};


export type QueryFindManySynchronyClinicConfigurationArgs = {
  cursor?: Maybe<SynchronyClinicConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SynchronyClinicConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SynchronyClinicConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SynchronyClinicConfigurationWhereInput>;
};


export type QueryFindManySynchronyClinicConfigurationCountArgs = {
  cursor?: Maybe<SynchronyClinicConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SynchronyClinicConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SynchronyClinicConfigurationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SynchronyClinicConfigurationWhereInput>;
};


export type QueryFindManySynchronyEventArgs = {
  cursor?: Maybe<SynchronyEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SynchronyEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SynchronyEventOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SynchronyEventWhereInput>;
};


export type QueryFindManySynchronyEventCountArgs = {
  cursor?: Maybe<SynchronyEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SynchronyEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SynchronyEventOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SynchronyEventWhereInput>;
};


export type QueryFindManyTaskArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaskScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaskOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaskWhereInput>;
};


export type QueryFindManyTaskCountArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaskScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaskOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaskWhereInput>;
};


export type QueryFindManyTaxonomyArgs = {
  cursor?: Maybe<TaxonomyWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaxonomyScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaxonomyOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaxonomyWhereInput>;
};


export type QueryFindManyTaxonomyCountArgs = {
  cursor?: Maybe<TaxonomyWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaxonomyScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaxonomyOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaxonomyWhereInput>;
};


export type QueryFindManyTaxonomyToInformAudienceDefinitionArgs = {
  cursor?: Maybe<TaxonomyToInformAudienceDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaxonomyToInformAudienceDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaxonomyToInformAudienceDefinitionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaxonomyToInformAudienceDefinitionWhereInput>;
};


export type QueryFindManyTaxonomyToInformAudienceDefinitionCountArgs = {
  cursor?: Maybe<TaxonomyToInformAudienceDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaxonomyToInformAudienceDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaxonomyToInformAudienceDefinitionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaxonomyToInformAudienceDefinitionWhereInput>;
};


export type QueryFindManyTransactionArgs = {
  cursor?: Maybe<TransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TransactionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TransactionWhereInput>;
};


export type QueryFindManyTransactionCountArgs = {
  cursor?: Maybe<TransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TransactionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TransactionWhereInput>;
};


export type QueryFindManyTrupanionCertificateAvailabilityArgs = {
  cursor?: Maybe<TrupanionCertificateAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TrupanionCertificateAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TrupanionCertificateAvailabilityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionCertificateAvailabilityWhereInput>;
};


export type QueryFindManyTrupanionCertificateAvailabilityCountArgs = {
  cursor?: Maybe<TrupanionCertificateAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TrupanionCertificateAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TrupanionCertificateAvailabilityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionCertificateAvailabilityWhereInput>;
};


export type QueryFindManyTrupanionIntegratedAppointmentTypeArgs = {
  cursor?: Maybe<TrupanionIntegratedAppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TrupanionIntegratedAppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TrupanionIntegratedAppointmentTypeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
};


export type QueryFindManyTrupanionIntegratedAppointmentTypeCountArgs = {
  cursor?: Maybe<TrupanionIntegratedAppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TrupanionIntegratedAppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TrupanionIntegratedAppointmentTypeOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
};


export type QueryFindManyTrupanionIntegrationArgs = {
  cursor?: Maybe<TrupanionIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TrupanionIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TrupanionIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionIntegrationWhereInput>;
};


export type QueryFindManyTrupanionIntegrationCountArgs = {
  cursor?: Maybe<TrupanionIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TrupanionIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TrupanionIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionIntegrationWhereInput>;
};


export type QueryFindManyTwilioCallRecordingArgs = {
  cursor?: Maybe<TwilioCallRecordingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TwilioCallRecordingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TwilioCallRecordingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TwilioCallRecordingWhereInput>;
};


export type QueryFindManyTwilioCallRecordingCountArgs = {
  cursor?: Maybe<TwilioCallRecordingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TwilioCallRecordingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TwilioCallRecordingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TwilioCallRecordingWhereInput>;
};


export type QueryFindManyUserArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type QueryFindManyUserAppointmentGroupingArgs = {
  cursor?: Maybe<UserAppointmentGroupingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserAppointmentGroupingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserAppointmentGroupingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAppointmentGroupingWhereInput>;
};


export type QueryFindManyUserAppointmentGroupingCountArgs = {
  cursor?: Maybe<UserAppointmentGroupingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserAppointmentGroupingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserAppointmentGroupingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAppointmentGroupingWhereInput>;
};


export type QueryFindManyUserBoardFilterArgs = {
  cursor?: Maybe<UserBoardFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserBoardFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserBoardFilterOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserBoardFilterWhereInput>;
};


export type QueryFindManyUserBoardFilterCountArgs = {
  cursor?: Maybe<UserBoardFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserBoardFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserBoardFilterOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserBoardFilterWhereInput>;
};


export type QueryFindManyUserChannelFilterSelectionArgs = {
  cursor?: Maybe<UserChannelFilterSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserChannelFilterSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserChannelFilterSelectionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserChannelFilterSelectionWhereInput>;
};


export type QueryFindManyUserChannelFilterSelectionCountArgs = {
  cursor?: Maybe<UserChannelFilterSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserChannelFilterSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserChannelFilterSelectionOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserChannelFilterSelectionWhereInput>;
};


export type QueryFindManyUserCountArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type QueryFindManyUserNotificationSettingArgs = {
  cursor?: Maybe<UserNotificationSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserNotificationSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserNotificationSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserNotificationSettingWhereInput>;
};


export type QueryFindManyUserNotificationSettingCountArgs = {
  cursor?: Maybe<UserNotificationSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserNotificationSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserNotificationSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserNotificationSettingWhereInput>;
};


export type QueryFindManyUserSettingArgs = {
  cursor?: Maybe<UserSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserSettingWhereInput>;
};


export type QueryFindManyUserSettingCountArgs = {
  cursor?: Maybe<UserSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserSettingWhereInput>;
};


export type QueryFindManyUserTaskListArgs = {
  cursor?: Maybe<UserTaskListWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserTaskListScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserTaskListOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserTaskListWhereInput>;
};


export type QueryFindManyUserTaskListCountArgs = {
  cursor?: Maybe<UserTaskListWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserTaskListScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserTaskListOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserTaskListWhereInput>;
};


export type QueryFindManyUserTaskListFilterArgs = {
  cursor?: Maybe<UserTaskListFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserTaskListFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserTaskListFilterOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserTaskListFilterWhereInput>;
};


export type QueryFindManyUserTaskListFilterCountArgs = {
  cursor?: Maybe<UserTaskListFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserTaskListFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserTaskListFilterOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserTaskListFilterWhereInput>;
};


export type QueryFindManyVaccinationArgs = {
  cursor?: Maybe<VaccinationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VaccinationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VaccinationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VaccinationWhereInput>;
};


export type QueryFindManyVaccinationCountArgs = {
  cursor?: Maybe<VaccinationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VaccinationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VaccinationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VaccinationWhereInput>;
};


export type QueryFindManyVetAvailabilityArgs = {
  cursor?: Maybe<VetAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityWhereInput>;
};


export type QueryFindManyVetAvailabilityClinicRoomMapArgs = {
  cursor?: Maybe<VetAvailabilityClinicRoomMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityClinicRoomMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityClinicRoomMapOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityClinicRoomMapWhereInput>;
};


export type QueryFindManyVetAvailabilityClinicRoomMapCountArgs = {
  cursor?: Maybe<VetAvailabilityClinicRoomMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityClinicRoomMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityClinicRoomMapOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityClinicRoomMapWhereInput>;
};


export type QueryFindManyVetAvailabilityCountArgs = {
  cursor?: Maybe<VetAvailabilityWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityWhereInput>;
};


export type QueryFindManyVetAvailabilityMapArgs = {
  cursor?: Maybe<VetAvailabilityMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityMapOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityMapWhereInput>;
};


export type QueryFindManyVetAvailabilityMapCountArgs = {
  cursor?: Maybe<VetAvailabilityMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityMapOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityMapWhereInput>;
};


export type QueryFindManyVetInfoArgs = {
  cursor?: Maybe<VetInfoWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetInfoScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetInfoOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetInfoWhereInput>;
};


export type QueryFindManyVetInfoCountArgs = {
  cursor?: Maybe<VetInfoWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetInfoScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetInfoOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetInfoWhereInput>;
};


export type QueryFindManyVetsourceCodeTagArgs = {
  cursor?: Maybe<VetsourceCodeTagWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourceCodeTagScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourceCodeTagOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceCodeTagWhereInput>;
};


export type QueryFindManyVetsourceCodeTagCountArgs = {
  cursor?: Maybe<VetsourceCodeTagWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourceCodeTagScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourceCodeTagOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceCodeTagWhereInput>;
};


export type QueryFindManyVetsourceInstallationArgs = {
  cursor?: Maybe<VetsourceInstallationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourceInstallationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourceInstallationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceInstallationWhereInput>;
};


export type QueryFindManyVetsourceInstallationCountArgs = {
  cursor?: Maybe<VetsourceInstallationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourceInstallationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourceInstallationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceInstallationWhereInput>;
};


export type QueryFindManyVetsourcePharmacyIntegrationArgs = {
  cursor?: Maybe<VetsourcePharmacyIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourcePharmacyIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourcePharmacyIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourcePharmacyIntegrationWhereInput>;
};


export type QueryFindManyVetsourcePharmacyIntegrationCountArgs = {
  cursor?: Maybe<VetsourcePharmacyIntegrationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourcePharmacyIntegrationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourcePharmacyIntegrationOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourcePharmacyIntegrationWhereInput>;
};


export type QueryFindManyVetsourceRevenueCategoryArgs = {
  cursor?: Maybe<VetsourceRevenueCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourceRevenueCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourceRevenueCategoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};


export type QueryFindManyVetsourceRevenueCategoryCountArgs = {
  cursor?: Maybe<VetsourceRevenueCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourceRevenueCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourceRevenueCategoryOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};


export type QueryFindManyWorkflowEventSettingArgs = {
  cursor?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};


export type QueryFindManyWorkflowEventSettingCountArgs = {
  cursor?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventSettingOrderByWithRelationInput>>>;
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};


export type QueryFindUniqueActiveIngredientArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ActiveIngredientWhereUniqueInput;
};


export type QueryFindUniqueAiRecapPimsWritebackLogEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AiRecapPimsWritebackLogEntryWhereUniqueInput;
};


export type QueryFindUniqueAppointmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AppointmentWhereUniqueInput;
};


export type QueryFindUniqueAppointmentAvailabilityArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AppointmentAvailabilityWhereUniqueInput;
};


export type QueryFindUniqueAppointmentNoteTemplateArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AppointmentNoteTemplateWhereUniqueInput;
};


export type QueryFindUniqueAppointmentTypeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AppointmentTypeWhereUniqueInput;
};


export type QueryFindUniqueAutomationRunArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AutomationRunWhereUniqueInput;
};


export type QueryFindUniqueAutomationRunActionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AutomationRunActionWhereUniqueInput;
};


export type QueryFindUniqueAxionClinicConfigurationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AxionClinicConfigurationWhereUniqueInput;
};


export type QueryFindUniqueAxionClinicUserConfigurationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: AxionClinicUserConfigurationWhereUniqueInput;
};


export type QueryFindUniqueBedrockInferenceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BedrockInferenceWhereUniqueInput;
};


export type QueryFindUniqueBitwerxHealthcheckArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxHealthcheckWhereUniqueInput;
};


export type QueryFindUniqueBitwerxIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxIntegrationWhereUniqueInput;
};


export type QueryFindUniqueBitwerxPaymentHealthcheckResultArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxPaymentHealthcheckResultWhereUniqueInput;
};


export type QueryFindUniqueBitwerxPaymentHealthcheckRunArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxPaymentHealthcheckRunWhereUniqueInput;
};


export type QueryFindUniqueBitwerxPaymentWritebackConfigurationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
};


export type QueryFindUniqueBoardFilterColumnArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BoardFilterColumnWhereUniqueInput;
};


export type QueryFindUniqueBoardFilterSpecificDateRangeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BoardFilterSpecificDateRangeWhereUniqueInput;
};


export type QueryFindUniqueBoehringerIngelheimCustomerAlignmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BoehringerIngelheimCustomerAlignmentWhereUniqueInput;
};


export type QueryFindUniqueBoehringerIngelheimTerritoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BoehringerIngelheimTerritoryWhereUniqueInput;
};


export type QueryFindUniqueBreedArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: BreedWhereUniqueInput;
};


export type QueryFindUniqueCallHistoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CallHistoryWhereUniqueInput;
};


export type QueryFindUniqueCallParticipantArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CallParticipantWhereUniqueInput;
};


export type QueryFindUniqueCallRecordingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CallRecordingWhereUniqueInput;
};


export type QueryFindUniqueCampaignRegistryCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CampaignRegistryCampaignWhereUniqueInput;
};


export type QueryFindUniqueCanonicalBreedArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CanonicalBreedWhereUniqueInput;
};


export type QueryFindUniqueCanonicalCanineBreedProfileArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CanonicalCanineBreedProfileWhereUniqueInput;
};


export type QueryFindUniqueCanonicalServiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CanonicalServiceWhereUniqueInput;
};


export type QueryFindUniqueCanonicalSpeciesArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CanonicalSpeciesWhereUniqueInput;
};


export type QueryFindUniqueCareAccountCreditIntentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAccountCreditIntentWhereUniqueInput;
};


export type QueryFindUniqueCareAccountCreditPimsWritebackLogEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAccountCreditPimsWritebackLogEntryWhereUniqueInput;
};


export type QueryFindUniqueCareAddonEnrollmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAddonEnrollmentWhereUniqueInput;
};


export type QueryFindUniqueCareAddonPackageArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAddonPackageWhereUniqueInput;
};


export type QueryFindUniqueCareAddonPackageBenefitArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAddonPackageBenefitWhereUniqueInput;
};


export type QueryFindUniqueCareAuthorizationRequestArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareAuthorizationRequestWhereUniqueInput;
};


export type QueryFindUniqueCareBenefitArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitWhereUniqueInput;
};


export type QueryFindUniqueCareBenefitUsageArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitUsageWhereUniqueInput;
};


export type QueryFindUniqueCareBenefitUsageFollowupArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitUsageFollowupWhereUniqueInput;
};


export type QueryFindUniqueCareBenefitUsageFollowupStepArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitUsageFollowupStepWhereUniqueInput;
};


export type QueryFindUniqueCareBenefitUsageToInvoiceLineItemArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
};


export type QueryFindUniqueCareCreditPreapprovalCheckArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareCreditPreapprovalCheckWhereUniqueInput;
};


export type QueryFindUniqueCareEnrollmentPaymentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareEnrollmentPaymentWhereUniqueInput;
};


export type QueryFindUniqueCareEnrollmentToStripeInvoiceItemArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareEnrollmentToStripeInvoiceItemWhereUniqueInput;
};


export type QueryFindUniqueCareLapsedPaymentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareLapsedPaymentWhereUniqueInput;
};


export type QueryFindUniqueCarePlanArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanWhereUniqueInput;
};


export type QueryFindUniqueCarePlanBenefitArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanBenefitWhereUniqueInput;
};


export type QueryFindUniqueCarePlanBenefitEnrollmentCarryoverArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanBenefitEnrollmentCarryoverWhereUniqueInput;
};


export type QueryFindUniqueCarePlanEnrollmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanEnrollmentWhereUniqueInput;
};


export type QueryFindUniqueCarePlanPricingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanPricingWhereUniqueInput;
};


export type QueryFindUniqueCarePlanProviderGroupArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CarePlanProviderGroupWhereUniqueInput;
};


export type QueryFindUniqueCareStripeSubscriptionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareStripeSubscriptionWhereUniqueInput;
};


export type QueryFindUniqueCareSubscriptionTrueUpArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareSubscriptionTrueUpWhereUniqueInput;
};


export type QueryFindUniqueCareSubscriptionTrueUpLogEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CareSubscriptionTrueUpLogEntryWhereUniqueInput;
};


export type QueryFindUniqueChannelArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelWhereUniqueInput;
};


export type QueryFindUniqueChannelAutomationStatusArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelAutomationStatusWhereUniqueInput;
};


export type QueryFindUniqueChannelCreationSourceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelCreationSourceWhereUniqueInput;
};


export type QueryFindUniqueChannelFilterSelectionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelFilterSelectionWhereUniqueInput;
};


export type QueryFindUniqueChannelMemberArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMemberWhereUniqueInput;
};


export type QueryFindUniqueChannelMessageArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMessageWhereUniqueInput;
};


export type QueryFindUniqueChannelMessageAttachmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMessageAttachmentWhereUniqueInput;
};


export type QueryFindUniqueChannelMessageAutoResponseArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMessageAutoResponseWhereUniqueInput;
};


export type QueryFindUniqueChannelMessageReactionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelMessageReactionWhereUniqueInput;
};


export type QueryFindUniqueChannelPinArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelPinWhereUniqueInput;
};


export type QueryFindUniqueChannelSelectionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelSelectionWhereUniqueInput;
};


export type QueryFindUniqueChannelStatusArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelStatusWhereUniqueInput;
};


export type QueryFindUniqueChannelStatusChannelAssigneeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChannelStatusChannelAssigneeWhereUniqueInput;
};


export type QueryFindUniqueChemicalCompoundArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ChemicalCompoundWhereUniqueInput;
};


export type QueryFindUniqueClientConnectIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClientConnectIntegrationWhereUniqueInput;
};


export type QueryFindUniqueClinicArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicWhereUniqueInput;
};


export type QueryFindUniqueClinicBlockedPhoneNumberArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
};


export type QueryFindUniqueClinicCustomPayoutsSetupArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicCustomPayoutsSetupWhereUniqueInput;
};


export type QueryFindUniqueClinicDirectBookingSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicDirectBookingSettingWhereUniqueInput;
};


export type QueryFindUniqueClinicEmailCampaignSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicEmailCampaignSettingWhereUniqueInput;
};


export type QueryFindUniqueClinicEmployeeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicEmployeeWhereUniqueInput;
};


export type QueryFindUniqueClinicEmployeeAppointmentTypeSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicEmployeeAppointmentTypeSettingWhereUniqueInput;
};


export type QueryFindUniqueClinicEntityPhoneNumberArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicEntityPhoneNumberWhereUniqueInput;
};


export type QueryFindUniqueClinicModuleArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicModuleWhereUniqueInput;
};


export type QueryFindUniqueClinicOfficeHourArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicOfficeHourWhereUniqueInput;
};


export type QueryFindUniqueClinicOnboardingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicOnboardingWhereUniqueInput;
};


export type QueryFindUniqueClinicPaymentFeeConfigurationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPaymentFeeConfigurationWhereUniqueInput;
};


export type QueryFindUniqueClinicPetArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetWhereUniqueInput;
};


export type QueryFindUniqueClinicPetAlertArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetAlertWhereUniqueInput;
};


export type QueryFindUniqueClinicPetCustomFieldValueArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetCustomFieldValueWhereUniqueInput;
};


export type QueryFindUniqueClinicPetParentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentWhereUniqueInput;
};


export type QueryFindUniqueClinicPetParentAddressArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentAddressWhereUniqueInput;
};


export type QueryFindUniqueClinicPetParentCustomFieldValueArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentCustomFieldValueWhereUniqueInput;
};


export type QueryFindUniqueClinicPetParentDeviceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentDeviceWhereUniqueInput;
};


export type QueryFindUniqueClinicPetParentPimsSyncStatusArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetParentPimsSyncStatusWhereUniqueInput;
};


export type QueryFindUniqueClinicPetPimsSyncStatusArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPetPimsSyncStatusWhereUniqueInput;
};


export type QueryFindUniqueClinicPhoneNumberArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPhoneNumberWhereUniqueInput;
};


export type QueryFindUniqueClinicPimsIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPimsIntegrationWhereUniqueInput;
};


export type QueryFindUniqueClinicPimsIntegrationCapabilityArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPimsIntegrationCapabilityWhereUniqueInput;
};


export type QueryFindUniqueClinicPimsIntegrationCapabilityHistoryEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPimsIntegrationCapabilityHistoryEntryWhereUniqueInput;
};


export type QueryFindUniqueClinicPostcardSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicPostcardSettingWhereUniqueInput;
};


export type QueryFindUniqueClinicRoomArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicRoomWhereUniqueInput;
};


export type QueryFindUniqueClinicSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicSettingWhereUniqueInput;
};


export type QueryFindUniqueClinicUserFilterArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicUserFilterWhereUniqueInput;
};


export type QueryFindUniqueClinicWidgetRequestArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicWidgetRequestWhereUniqueInput;
};


export type QueryFindUniqueClinicWidgetRequestTypeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
};


export type QueryFindUniqueClinicWidgetSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ClinicWidgetSettingWhereUniqueInput;
};


export type QueryFindUniqueColorArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ColorWhereUniqueInput;
};


export type QueryFindUniqueConditionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConditionWhereUniqueInput;
};


export type QueryFindUniqueConditionSetArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConditionSetWhereUniqueInput;
};


export type QueryFindUniqueConditionalEntityEvaluationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConditionalEntityEvaluationWhereUniqueInput;
};


export type QueryFindUniqueConsultationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConsultationWhereUniqueInput;
};


export type QueryFindUniqueConsultationRequestArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ConsultationRequestWhereUniqueInput;
};


export type QueryFindUniqueCustomFieldDefinitionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CustomFieldDefinitionWhereUniqueInput;
};


export type QueryFindUniqueCustomFieldPimsWritebackLogEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: CustomFieldPimsWritebackLogEntryWhereUniqueInput;
};


export type QueryFindUniqueDirectBookingAppointmentTypeSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DirectBookingAppointmentTypeSettingWhereUniqueInput;
};


export type QueryFindUniqueDirectBookingExclusionRuleArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DirectBookingExclusionRuleWhereUniqueInput;
};


export type QueryFindUniqueDirectBookingExclusionTimeSlotArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DirectBookingExclusionTimeSlotWhereUniqueInput;
};


export type QueryFindUniqueDisbursementArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DisbursementWhereUniqueInput;
};


export type QueryFindUniqueDocumentationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: DocumentationWhereUniqueInput;
};


export type QueryFindUniqueEmailCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignWhereUniqueInput;
};


export type QueryFindUniqueEmailCampaignCustomListArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignCustomListWhereUniqueInput;
};


export type QueryFindUniqueEmailCampaignCustomListRecipientArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignCustomListRecipientWhereUniqueInput;
};


export type QueryFindUniqueEmailCampaignCustomListUploadHistoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignCustomListUploadHistoryWhereUniqueInput;
};


export type QueryFindUniqueEmailCampaignLogArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignLogWhereUniqueInput;
};


export type QueryFindUniqueEmailCampaignTemplateArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignTemplateWhereUniqueInput;
};


export type QueryFindUniqueEmailCampaignUnsubscribeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailCampaignUnsubscribeWhereUniqueInput;
};


export type QueryFindUniqueEmailProviderLogArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmailProviderLogWhereUniqueInput;
};


export type QueryFindUniqueEmergencyClinicsArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EmergencyClinicsWhereUniqueInput;
};


export type QueryFindUniqueEncryptedClinicUploadArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EncryptedClinicUploadWhereUniqueInput;
};


export type QueryFindUniqueEnrollmentSupportEventArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EnrollmentSupportEventWhereUniqueInput;
};


export type QueryFindUniqueEzyVetIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: EzyVetIntegrationWhereUniqueInput;
};


export type QueryFindUniqueFeatureFlagArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FeatureFlagWhereUniqueInput;
};


export type QueryFindUniqueFinancialAdjustmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FinancialAdjustmentWhereUniqueInput;
};


export type QueryFindUniqueFinancialTransactionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FinancialTransactionWhereUniqueInput;
};


export type QueryFindUniqueFormSubmissionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FormSubmissionWhereUniqueInput;
};


export type QueryFindUniqueFormTemplateArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: FormTemplateWhereUniqueInput;
};


export type QueryFindUniqueGlobalPetParentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: GlobalPetParentWhereUniqueInput;
};


export type QueryFindUniqueGooglePlaceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: GooglePlaceWhereUniqueInput;
};


export type QueryFindUniqueHillsToHomeApiLogArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: HillsToHomeApiLogWhereUniqueInput;
};


export type QueryFindUniqueInformAudienceDefinitionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformAudienceDefinitionWhereUniqueInput;
};


export type QueryFindUniqueInformAudienceMemberArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformAudienceMemberWhereUniqueInput;
};


export type QueryFindUniqueInformAudienceMemberMessageArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformAudienceMemberMessageWhereUniqueInput;
};


export type QueryFindUniqueInformAutomationCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformAutomationCampaignWhereUniqueInput;
};


export type QueryFindUniqueInformCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignWhereUniqueInput;
};


export type QueryFindUniqueInformCampaignEnrollmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignEnrollmentWhereUniqueInput;
};


export type QueryFindUniqueInformCampaignEnrollmentCanonicalServiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignEnrollmentCanonicalServiceWhereUniqueInput;
};


export type QueryFindUniqueInformCampaignExecutionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignExecutionWhereUniqueInput;
};


export type QueryFindUniqueInformCampaignGroupArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCampaignGroupWhereUniqueInput;
};


export type QueryFindUniqueInformCommunicationOptOutArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformCommunicationOptOutWhereUniqueInput;
};


export type QueryFindUniqueInformControlGroupParticipantArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformControlGroupParticipantWhereUniqueInput;
};


export type QueryFindUniqueInformEmailTemplateArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformEmailTemplateWhereUniqueInput;
};


export type QueryFindUniqueInformEntityHistoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformEntityHistoryWhereUniqueInput;
};


export type QueryFindUniqueInformEventDrivenCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformEventDrivenCampaignWhereUniqueInput;
};


export type QueryFindUniqueInformEventListenerArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformEventListenerWhereUniqueInput;
};


export type QueryFindUniqueInformNotificationRecipientArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformNotificationRecipientWhereUniqueInput;
};


export type QueryFindUniqueInformPartnerArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerWhereUniqueInput;
};


export type QueryFindUniqueInformPartnerCustomerArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerCustomerWhereUniqueInput;
};


export type QueryFindUniqueInformPartnerCustomerPharmacyProviderArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerCustomerPharmacyProviderWhereUniqueInput;
};


export type QueryFindUniqueInformPartnerIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerIntegrationWhereUniqueInput;
};


export type QueryFindUniqueInformPartnerIntegrationModelArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerIntegrationModelWhereUniqueInput;
};


export type QueryFindUniqueInformPartnerProgramArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerProgramWhereUniqueInput;
};


export type QueryFindUniqueInformPartnerProgramEnrollmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerProgramEnrollmentWhereUniqueInput;
};


export type QueryFindUniqueInformPartnerUserArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerUserWhereUniqueInput;
};


export type QueryFindUniqueInformPartnerUserRoleArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformPartnerUserRoleWhereUniqueInput;
};


export type QueryFindUniqueInformScheduledCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformScheduledCampaignWhereUniqueInput;
};


export type QueryFindUniqueInformSessionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformSessionWhereUniqueInput;
};


export type QueryFindUniqueInformSessionEventArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InformSessionEventWhereUniqueInput;
};


export type QueryFindUniqueInstinctIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InstinctIntegrationWhereUniqueInput;
};


export type QueryFindUniqueInsuranceIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InsuranceIntegrationWhereUniqueInput;
};


export type QueryFindUniqueIntegrationOutageHistoryEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: IntegrationOutageHistoryEntryWhereUniqueInput;
};


export type QueryFindUniqueInterchangeRateArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InterchangeRateWhereUniqueInput;
};


export type QueryFindUniqueInvoiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InvoiceWhereUniqueInput;
};


export type QueryFindUniqueInvoiceLineItemArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InvoiceLineItemWhereUniqueInput;
};


export type QueryFindUniqueInvoicePimsWritebackLogEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: InvoicePimsWritebackLogEntryWhereUniqueInput;
};


export type QueryFindUniqueLabPanelArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LabPanelWhereUniqueInput;
};


export type QueryFindUniqueLabResultArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LabResultWhereUniqueInput;
};


export type QueryFindUniqueLapsedPetParentTriggersArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LapsedPetParentTriggersWhereUniqueInput;
};


export type QueryFindUniqueLegalEntityArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LegalEntityWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyAccountArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyAccountWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyAccountHolderArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyAccountHolderWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyAccountMergerArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyAccountMergerWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyInvoicePointGranterArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyInvoicePointGranterWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyPointDeltaArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyPointDeltaWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyPointGrantingServiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyPointGrantingServiceWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyPointGrantingServiceCategoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyPointGrantingServiceCategoryWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyPointUserGrantArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyPointUserGrantWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyProgramArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyProgramWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyProgramStatusHistoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyProgramStatusHistoryWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyRewardArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyRewardWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyRewardRedemptionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyRewardRedemptionWhereUniqueInput;
};


export type QueryFindUniqueLoyaltyRewardRedemptionHistoryEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput;
};


export type QueryFindUniqueMassTextAlertArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MassTextAlertWhereUniqueInput;
};


export type QueryFindUniqueMassTextAlertEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MassTextAlertEntryWhereUniqueInput;
};


export type QueryFindUniqueMassTextAlertEntryAppointmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MassTextAlertEntryAppointmentWhereUniqueInput;
};


export type QueryFindUniqueMediaArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MediaWhereUniqueInput;
};


export type QueryFindUniqueMedicalHistoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MedicalHistoryWhereUniqueInput;
};


export type QueryFindUniqueMessageTemplateArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MessageTemplateWhereUniqueInput;
};


export type QueryFindUniqueMessagingCampaignArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MessagingCampaignWhereUniqueInput;
};


export type QueryFindUniqueMessagingPartnerArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: MessagingPartnerWhereUniqueInput;
};


export type QueryFindUniqueModuleArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ModuleWhereUniqueInput;
};


export type QueryFindUniqueNonPrismaSchemaScriptRanArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: NonPrismaSchemaScriptRanWhereUniqueInput;
};


export type QueryFindUniqueNotificationEventToMessageArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: NotificationEventToMessageWhereUniqueInput;
};


export type QueryFindUniqueOrganizationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationWhereUniqueInput;
};


export type QueryFindUniqueOrganizationCareBenefitToClinicServiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationCareBenefitToClinicServiceWhereUniqueInput;
};


export type QueryFindUniqueOrganizationCareBenefitToClinicServiceCategoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput;
};


export type QueryFindUniqueOrganizationPetArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationPetWhereUniqueInput;
};


export type QueryFindUniqueOrganizationPetParentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationPetParentWhereUniqueInput;
};


export type QueryFindUniqueOrganizationPetToOrganizationPetParentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: OrganizationPetToOrganizationPetParentWhereUniqueInput;
};


export type QueryFindUniquePpcIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PpcIntegrationWhereUniqueInput;
};


export type QueryFindUniquePaymentsReportTransactionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PaymentsReportTransactionWhereUniqueInput;
};


export type QueryFindUniquePayoutBatchingPeriodArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PayoutBatchingPeriodWhereUniqueInput;
};


export type QueryFindUniquePayoutBatchingScheduleArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PayoutBatchingScheduleWhereUniqueInput;
};


export type QueryFindUniquePayoutBatchingSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PayoutBatchingSettingWhereUniqueInput;
};


export type QueryFindUniquePermissionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PermissionWhereUniqueInput;
};


export type QueryFindUniquePetParentSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PetParentSettingWhereUniqueInput;
};


export type QueryFindUniquePetPortalSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PetPortalSettingWhereUniqueInput;
};


export type QueryFindUniquePhoneNumberLookupRequestArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PhoneNumberLookupRequestWhereUniqueInput;
};


export type QueryFindUniquePhoneNumberLookupResultArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PhoneNumberLookupResultWhereUniqueInput;
};


export type QueryFindUniquePimsInvoiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PimsInvoiceWhereUniqueInput;
};


export type QueryFindUniquePimsInvoiceLineItemArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PimsInvoiceLineItemWhereUniqueInput;
};


export type QueryFindUniquePimsPaymentTypeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PimsPaymentTypeWhereUniqueInput;
};


export type QueryFindUniquePimsWritebackLogEntryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PimsWritebackLogEntryWhereUniqueInput;
};


export type QueryFindUniquePrescriptionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PrescriptionWhereUniqueInput;
};


export type QueryFindUniqueProductArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ProductWhereUniqueInput;
};


export type QueryFindUniqueProductPackageArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ProductPackageWhereUniqueInput;
};


export type QueryFindUniqueProductPackageSubscriptionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ProductPackageSubscriptionWhereUniqueInput;
};


export type QueryFindUniqueProviderAppointmentTypeRoomMapArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ProviderAppointmentTypeRoomMapWhereUniqueInput;
};


export type QueryFindUniquePushNotificationLogArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: PushNotificationLogWhereUniqueInput;
};


export type QueryFindUniqueRecapArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: RecapWhereUniqueInput;
};


export type QueryFindUniqueRulesArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: RulesWhereUniqueInput;
};


export type QueryFindUniqueSalesforceAccountArgs = {
  where: FindUniqueSalesforceAccountWhereInput;
};


export type QueryFindUniqueSegmentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SegmentWhereUniqueInput;
};


export type QueryFindUniqueSentTrupanionExamDayOfferArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};


export type QueryFindUniqueServiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceWhereUniqueInput;
};


export type QueryFindUniqueServiceCategoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceCategoryWhereUniqueInput;
};


export type QueryFindUniqueServicePurchaseSummaryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServicePurchaseSummaryWhereUniqueInput;
};


export type QueryFindUniqueServiceReminderArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceReminderWhereUniqueInput;
};


export type QueryFindUniqueServiceReminderNotificationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceReminderNotificationWhereUniqueInput;
};


export type QueryFindUniqueServiceReminderTimingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: ServiceReminderTimingWhereUniqueInput;
};


export type QueryFindUniqueSexArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SexWhereUniqueInput;
};


export type QueryFindUniqueSmsNotificationStatusArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SmsNotificationStatusWhereUniqueInput;
};


export type QueryFindUniqueSpeciesArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SpeciesWhereUniqueInput;
};


export type QueryFindUniqueStaffRoleArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StaffRoleWhereUniqueInput;
};


export type QueryFindUniqueStripeCustomerArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeCustomerWhereUniqueInput;
};


export type QueryFindUniqueStripeDisputeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeDisputeWhereUniqueInput;
};


export type QueryFindUniqueStripeInvoiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeInvoiceWhereUniqueInput;
};


export type QueryFindUniqueStripeInvoiceItemArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeInvoiceItemWhereUniqueInput;
};


export type QueryFindUniqueStripePaymentIntentArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripePaymentIntentWhereUniqueInput;
};


export type QueryFindUniqueStripePaymentMethodArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripePaymentMethodWhereUniqueInput;
};


export type QueryFindUniqueStripePayoutArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripePayoutWhereUniqueInput;
};


export type QueryFindUniqueStripePayoutAccountArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripePayoutAccountWhereUniqueInput;
};


export type QueryFindUniqueStripeReceiptArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeReceiptWhereUniqueInput;
};


export type QueryFindUniqueStripeReceiptHistoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeReceiptHistoryWhereUniqueInput;
};


export type QueryFindUniqueStripeRefundArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeRefundWhereUniqueInput;
};


export type QueryFindUniqueStripeTerminalArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeTerminalWhereUniqueInput;
};


export type QueryFindUniqueStripeTerminalLocationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: StripeTerminalLocationWhereUniqueInput;
};


export type QueryFindUniqueSurveyAppointmentTypeSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SurveyAppointmentTypeSettingWhereUniqueInput;
};


export type QueryFindUniqueSurveyResultArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SurveyResultWhereUniqueInput;
};


export type QueryFindUniqueSurveySettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SurveySettingWhereUniqueInput;
};


export type QueryFindUniqueSyncVetIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SyncVetIntegrationWhereUniqueInput;
};


export type QueryFindUniqueSyncVetServiceArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SyncVetServiceWhereUniqueInput;
};


export type QueryFindUniqueSynchronyClinicConfigurationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SynchronyClinicConfigurationWhereUniqueInput;
};


export type QueryFindUniqueSynchronyEventArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: SynchronyEventWhereUniqueInput;
};


export type QueryFindUniqueTaskArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TaskWhereUniqueInput;
};


export type QueryFindUniqueTaxonomyArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TaxonomyWhereUniqueInput;
};


export type QueryFindUniqueTaxonomyToInformAudienceDefinitionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TaxonomyToInformAudienceDefinitionWhereUniqueInput;
};


export type QueryFindUniqueTransactionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TransactionWhereUniqueInput;
};


export type QueryFindUniqueTrupanionCertificateAvailabilityArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TrupanionCertificateAvailabilityWhereUniqueInput;
};


export type QueryFindUniqueTrupanionIntegratedAppointmentTypeArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TrupanionIntegratedAppointmentTypeWhereUniqueInput;
};


export type QueryFindUniqueTrupanionIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TrupanionIntegrationWhereUniqueInput;
};


export type QueryFindUniqueTwilioCallRecordingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: TwilioCallRecordingWhereUniqueInput;
};


export type QueryFindUniqueUserArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserWhereUniqueInput;
};


export type QueryFindUniqueUserAppointmentGroupingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserAppointmentGroupingWhereUniqueInput;
};


export type QueryFindUniqueUserBoardFilterArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserBoardFilterWhereUniqueInput;
};


export type QueryFindUniqueUserChannelFilterSelectionArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserChannelFilterSelectionWhereUniqueInput;
};


export type QueryFindUniqueUserNotificationSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserNotificationSettingWhereUniqueInput;
};


export type QueryFindUniqueUserSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserSettingWhereUniqueInput;
};


export type QueryFindUniqueUserTaskListArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserTaskListWhereUniqueInput;
};


export type QueryFindUniqueUserTaskListFilterArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: UserTaskListFilterWhereUniqueInput;
};


export type QueryFindUniqueVaccinationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VaccinationWhereUniqueInput;
};


export type QueryFindUniqueVetAvailabilityArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetAvailabilityWhereUniqueInput;
};


export type QueryFindUniqueVetAvailabilityClinicRoomMapArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetAvailabilityClinicRoomMapWhereUniqueInput;
};


export type QueryFindUniqueVetAvailabilityMapArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetAvailabilityMapWhereUniqueInput;
};


export type QueryFindUniqueVetInfoArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetInfoWhereUniqueInput;
};


export type QueryFindUniqueVetsourceCodeTagArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetsourceCodeTagWhereUniqueInput;
};


export type QueryFindUniqueVetsourceInstallationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetsourceInstallationWhereUniqueInput;
};


export type QueryFindUniqueVetsourcePharmacyIntegrationArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetsourcePharmacyIntegrationWhereUniqueInput;
};


export type QueryFindUniqueVetsourceRevenueCategoryArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: VetsourceRevenueCategoryWhereUniqueInput;
};


export type QueryFindUniqueWorkflowEventSettingArgs = {
  relationLoadStrategy?: Maybe<RelationLoadStrategy>;
  where: WorkflowEventSettingWhereUniqueInput;
};


export type QueryFormSubmissionExportArgs = {
  where: FormSubmissionWhereUniqueInput;
};


export type QueryGeneratePetIdPdfArgs = {
  data: GeneratePetIdPdfInput;
};


export type QueryGetAppointmentHistoryArgs = {
  where: GetEntityHistoryInput;
};


export type QueryGetAppointmentRecapUrlArgs = {
  data: GetAppointmentRecapUrlInput;
};


export type QueryGetAvailableFormTemplatesForWorkflowsArgs = {
  where?: Maybe<FormTemplateWhereInput>;
};


export type QueryGetBalanceForClientArgs = {
  where: GetBalanceForClientInput;
};


export type QueryGetChannelStatusIdsWithEntityCountOfZeroArgs = {
  where: GetChannelStatusIdsWithEntityCountOfZeroWhere;
};


export type QueryGetClinicDirectBookingSettingsArgs = {
  data?: Maybe<ClinicDirectBookingSettingsInput>;
};


export type QueryGetClinicEmailCampaignTemplatesArgs = {
  clinicId: Scalars['String'];
};


export type QueryGetClinicPetHistoryArgs = {
  where: GetEntityHistoryInput;
};


export type QueryGetClinicPetParentHistoryArgs = {
  where: GetEntityHistoryInput;
};


export type QueryGetCurrentInformPartnerUserArgs = {
  email?: Maybe<Scalars['String']>;
};


export type QueryGetDirectBookingAppointmentTypesArgs = {
  data: DirectBookingAppointmentTypeInput;
};


export type QueryGetDirectBookingOpenTimeSlots2Args = {
  data: DirectBookingOpenTimeSlot2Input;
};


export type QueryGetDisbursementsArgs = {
  data: GetDisbursementsInput;
  skip?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<SortBy>;
  take?: Maybe<Scalars['Int']>;
};


export type QueryGetDisputesArgs = {
  data: GetDisputesInput;
  skip?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<SortBy>;
  take?: Maybe<Scalars['Int']>;
};


export type QueryGetEmailCampaignCustomListUrlArgs = {
  data: EmailCampaignCustomListUrlInput;
};


export type QueryGetEmailCampaignSegmentCountArgs = {
  clinicId: Scalars['String'];
  emailCampaignId?: Maybe<Scalars['String']>;
};


export type QueryGetFinancialTransactionTotalsArgs = {
  data: GetFinancialTransactionTotalsInput;
};


export type QueryGetFinancialTransactionsArgs = {
  data: GetFinancialTransactionsInput;
  skip?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<SortBy>;
  take?: Maybe<Scalars['Int']>;
};


export type QueryGetHasConflictingAppointmentArgs = {
  data: HasConflictingAppointmentInput;
};


export type QueryGetInvoiceByIdArgs = {
  where: InvoiceWhereUniqueInput;
};


export type QueryGetInvoicesForClientArgs = {
  cursor?: Maybe<InvoiceWhereUniqueInput>;
  distinct?: Maybe<InvoiceScalarFieldEnum>;
  orderBy?: Maybe<Array<InvoiceOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where: InvoiceWhereInput;
};


export type QueryGetInvoicesForClientsArgs = {
  cursor?: Maybe<InvoiceWhereUniqueInput>;
  distinct?: Maybe<InvoiceScalarFieldEnum>;
  orderBy?: Maybe<Array<InvoiceOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where: InvoiceWhereInput;
};


export type QueryGetOrCreateActiveChannelArgs = {
  data: GetOrCreateActiveChannelInput;
};


export type QueryGetPetIdDataArgs = {
  data: GetPetIdDataInput;
};


export type QueryGetPossiblyDeflectedFormSubmissionArgs = {
  data?: Maybe<FormSubmissionWhereInput>;
};


export type QueryGetQuickSightEmbedUrlArgs = {
  where: GetQuickSightEmbedUrlInput;
};


export type QueryGetStripePaymentIntentDataArgs = {
  where: StripePaymentIntentWhereUniqueInput;
};


export type QueryGetTerminalTokenArgs = {
  where: StripeTerminalLocationUniqueInput;
};


export type QueryGetTwilioNumbersArgs = {
  data?: Maybe<GenericClinicIdInput>;
};


export type QueryGetWorkflowEventActionHistoryArgs = {
  where: GetEntityHistoryInput;
};


export type QueryGetWorkflowEventSettingHistoryArgs = {
  where: GetEntityHistoryInput;
};


export type QueryInvokeConverseAiRequestArgs = {
  data: InvokeAiConverseInput;
};


export type QueryJobChainStatusArgs = {
  where: JobChainStatusInput;
};


export type QueryMassTextAlertReportArgs = {
  massTextAlertId: Scalars['String'];
};


export type QueryRenderWorkflowNotificationBodyArgs = {
  automationRunId: Scalars['String'];
};


export type QuerySavedChannelFilterSelectionsArgs = {
  cursor?: Maybe<UserChannelFilterSelectionWhereUniqueInput>;
  orderBy?: Maybe<ChannelFilterSelectionOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserChannelFilterSelectionWhereInput>;
};


export type QuerySearchPhoneNumberArgs = {
  data?: Maybe<SearchPhoneNumberInput>;
};


export type QuerySearchTwilioNumbersArgs = {
  data: SearchTwilioNumbersInput;
};


export type QuerySendConsultationReceiptArgs = {
  data: SendConsultationReceiptInput;
};


export type QuerySendPetParentReceiptArgs = {
  data: SendPetParentReceiptInput;
};


export type QuerySendVetSubscriptionReceiptArgs = {
  data: SendVetSubscriptionReceiptInput;
};


export type QueryStripeCreateAccountSessionArgs = {
  data: StripeCreateAccountSessionInput;
};


export type QueryStripeCreateCustomerPortalArgs = {
  data?: Maybe<StripeCustomerPortalInput>;
};


export type QueryStripeRetrievePetParentPortalUrlArgs = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  data?: Maybe<StripeCustomerPortalInput>;
};


export type QueryTeletriageChannelSearchArgs = {
  orderBy?: Maybe<ChannelOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeletriageSearchChannelInput>;
};


export type QueryTeletriageChannelUnreadMessageCountArgs = {
  clinicIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryTokenValidationArgs = {
  data: TokenValidationInput;
};


export type QueryTrupanionCertificateAvailabilityArgs = {
  where: TrupanionCertificateAvailabilityInput;
};


export type QueryTrupanionHospitalSearchArgs = {
  where: TrupanionHospitalSearchInput;
};


export type QueryTwilioA2PRegistrationStatusArgs = {
  clinicId: Scalars['String'];
};


export type QueryTwilioCapabilityTokenArgs = {
  type?: Maybe<TwilioCapabilityType>;
};


export type QueryTwilioEligibilityCheckArgs = {
  data: TwilioEligibilityCheckInput;
};


export type QueryVerificationCheckArgs = {
  data?: Maybe<VerificationCheckInput>;
};


export type QueryVerificationRequestArgs = {
  data?: Maybe<VerificationRequestInput>;
};


export type QueryVerifyTerminalSetupPinArgs = {
  pin: Scalars['String'];
};


export type QueryWidgetClinicPetParentLookupArgs = {
  where: WidgetClinicPetParentLookupInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Recap = {
  __typename?: 'Recap';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: User;
  createdByUserId: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  recordingS3Uri?: Maybe<Scalars['String']>;
  source: RecapSource;
  status: RecapStatus;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type RecapAppointmentArgs = {
  where?: Maybe<AppointmentWhereInput>;
};

export type RecapAvgAggregateOutputType = {
  __typename?: 'RecapAvgAggregateOutputType';
  durationSeconds?: Maybe<Scalars['Float']>;
};

export type RecapAvgOrderByAggregateInput = {
  durationSeconds?: Maybe<SortOrder>;
};

export type RecapCountAggregateOutputType = {
  __typename?: 'RecapCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentId: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdByUserId: Scalars['Int'];
  durationSeconds: Scalars['Int'];
  generatedText: Scalars['Int'];
  id: Scalars['Int'];
  recordingS3Uri: Scalars['Int'];
  source: Scalars['Int'];
  status: Scalars['Int'];
  templateId: Scalars['Int'];
  transcriptionRequestId: Scalars['Int'];
  transcriptionS3Uri: Scalars['Int'];
  transcriptionService: Scalars['Int'];
  transcriptionText: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type RecapCountOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  durationSeconds?: Maybe<SortOrder>;
  generatedText?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  recordingS3Uri?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  templateId?: Maybe<SortOrder>;
  transcriptionRequestId?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  transcriptionService?: Maybe<SortOrder>;
  transcriptionText?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RecapCreateInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutRecapsInput>;
  clinic: ClinicCreateNestedOneWithoutRecapsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: UserCreateNestedOneWithoutRecapsInput;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapCreateManyAppointmentInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapCreateManyAppointmentInputEnvelope = {
  data: Array<RecapCreateManyAppointmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type RecapCreateManyClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapCreateManyClinicInputEnvelope = {
  data: Array<RecapCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type RecapCreateManyCreatedByInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapCreateManyCreatedByInputEnvelope = {
  data: Array<RecapCreateManyCreatedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type RecapCreateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<RecapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RecapCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<RecapCreateWithoutAppointmentInput>>;
  createMany?: Maybe<RecapCreateManyAppointmentInputEnvelope>;
};

export type RecapCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<RecapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RecapCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<RecapCreateWithoutClinicInput>>;
  createMany?: Maybe<RecapCreateManyClinicInputEnvelope>;
};

export type RecapCreateNestedManyWithoutCreatedByInput = {
  connect?: Maybe<Array<RecapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RecapCreateOrConnectWithoutCreatedByInput>>;
  create?: Maybe<Array<RecapCreateWithoutCreatedByInput>>;
  createMany?: Maybe<RecapCreateManyCreatedByInputEnvelope>;
};

export type RecapCreateOrConnectWithoutAppointmentInput = {
  create: RecapCreateWithoutAppointmentInput;
  where: RecapWhereUniqueInput;
};

export type RecapCreateOrConnectWithoutClinicInput = {
  create: RecapCreateWithoutClinicInput;
  where: RecapWhereUniqueInput;
};

export type RecapCreateOrConnectWithoutCreatedByInput = {
  create: RecapCreateWithoutCreatedByInput;
  where: RecapWhereUniqueInput;
};

export type RecapCreateWithoutAppointmentInput = {
  clinic: ClinicCreateNestedOneWithoutRecapsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: UserCreateNestedOneWithoutRecapsInput;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapCreateWithoutClinicInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutRecapsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: UserCreateNestedOneWithoutRecapsInput;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapCreateWithoutCreatedByInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutRecapsInput>;
  clinic: ClinicCreateNestedOneWithoutRecapsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapGroupByOutputType = {
  __typename?: 'RecapGroupByOutputType';
  _avg?: Maybe<RecapAvgAggregateOutputType>;
  _count?: Maybe<RecapCountAggregateOutputType>;
  _max?: Maybe<RecapMaxAggregateOutputType>;
  _min?: Maybe<RecapMinAggregateOutputType>;
  _sum?: Maybe<RecapSumAggregateOutputType>;
  appointmentId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  recordingS3Uri?: Maybe<Scalars['String']>;
  source: RecapSource;
  status: RecapStatus;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type RecapListRelationFilter = {
  every?: Maybe<RecapWhereInput>;
  none?: Maybe<RecapWhereInput>;
  some?: Maybe<RecapWhereInput>;
};

export type RecapMaxAggregateOutputType = {
  __typename?: 'RecapMaxAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapMaxOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  durationSeconds?: Maybe<SortOrder>;
  generatedText?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  recordingS3Uri?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  templateId?: Maybe<SortOrder>;
  transcriptionRequestId?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  transcriptionService?: Maybe<SortOrder>;
  transcriptionText?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RecapMinAggregateOutputType = {
  __typename?: 'RecapMinAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapMinOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  durationSeconds?: Maybe<SortOrder>;
  generatedText?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  recordingS3Uri?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  templateId?: Maybe<SortOrder>;
  transcriptionRequestId?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  transcriptionService?: Maybe<SortOrder>;
  transcriptionText?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RecapOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type RecapOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<RecapOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdBy?: Maybe<UserOrderByWithRelationInput>;
  createdByUserId?: Maybe<SortOrder>;
  durationSeconds?: Maybe<SortOrder>;
  generatedText?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  recordingS3Uri?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  templateId?: Maybe<SortOrder>;
  transcriptionRequestId?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  transcriptionService?: Maybe<SortOrder>;
  transcriptionText?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum RecapOrderByRelevanceFieldEnum {
  AppointmentId = 'appointmentId',
  ClinicId = 'clinicId',
  CreatedByUserId = 'createdByUserId',
  GeneratedText = 'generatedText',
  Id = 'id',
  RecordingS3Uri = 'recordingS3Uri',
  TemplateId = 'templateId',
  TranscriptionRequestId = 'transcriptionRequestId',
  TranscriptionS3Uri = 'transcriptionS3Uri',
  TranscriptionText = 'transcriptionText'
}

export type RecapOrderByRelevanceInput = {
  fields: Array<RecapOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type RecapOrderByWithAggregationInput = {
  _avg?: Maybe<RecapAvgOrderByAggregateInput>;
  _count?: Maybe<RecapCountOrderByAggregateInput>;
  _max?: Maybe<RecapMaxOrderByAggregateInput>;
  _min?: Maybe<RecapMinOrderByAggregateInput>;
  _sum?: Maybe<RecapSumOrderByAggregateInput>;
  appointmentId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdByUserId?: Maybe<SortOrder>;
  durationSeconds?: Maybe<SortOrder>;
  generatedText?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  recordingS3Uri?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  templateId?: Maybe<SortOrder>;
  transcriptionRequestId?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  transcriptionService?: Maybe<SortOrder>;
  transcriptionText?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RecapOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<RecapOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdBy?: Maybe<UserOrderByWithRelationInput>;
  createdByUserId?: Maybe<SortOrder>;
  durationSeconds?: Maybe<SortOrder>;
  generatedText?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  recordingS3Uri?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  templateId?: Maybe<SortOrder>;
  transcriptionRequestId?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  transcriptionService?: Maybe<SortOrder>;
  transcriptionText?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RecapOrderByWithRelationInput = {
  _relevance?: Maybe<RecapOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdBy?: Maybe<UserOrderByWithRelationInput>;
  createdByUserId?: Maybe<SortOrder>;
  durationSeconds?: Maybe<SortOrder>;
  generatedText?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  recordingS3Uri?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  templateId?: Maybe<SortOrder>;
  transcriptionRequestId?: Maybe<SortOrder>;
  transcriptionS3Uri?: Maybe<SortOrder>;
  transcriptionService?: Maybe<SortOrder>;
  transcriptionText?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum RecapScalarFieldEnum {
  AppointmentId = 'appointmentId',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  DurationSeconds = 'durationSeconds',
  GeneratedText = 'generatedText',
  Id = 'id',
  RecordingS3Uri = 'recordingS3Uri',
  Source = 'source',
  Status = 'status',
  TemplateId = 'templateId',
  TranscriptionRequestId = 'transcriptionRequestId',
  TranscriptionS3Uri = 'transcriptionS3Uri',
  TranscriptionService = 'transcriptionService',
  TranscriptionText = 'transcriptionText',
  UpdatedAt = 'updatedAt'
}

export type RecapScalarWhereInput = {
  AND?: Maybe<Array<RecapScalarWhereInput>>;
  NOT?: Maybe<Array<RecapScalarWhereInput>>;
  OR?: Maybe<Array<RecapScalarWhereInput>>;
  appointmentId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdByUserId?: Maybe<StringFilter>;
  durationSeconds?: Maybe<IntNullableFilter>;
  generatedText?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  recordingS3Uri?: Maybe<StringNullableFilter>;
  source?: Maybe<EnumRecapSourceFilter>;
  status?: Maybe<EnumRecapStatusFilter>;
  templateId?: Maybe<StringNullableFilter>;
  transcriptionRequestId?: Maybe<StringNullableFilter>;
  transcriptionS3Uri?: Maybe<StringNullableFilter>;
  transcriptionService?: Maybe<EnumTranscriptionServicesNullableFilter>;
  transcriptionText?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type RecapScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<RecapScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<RecapScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<RecapScalarWhereWithAggregatesInput>>;
  appointmentId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  createdByUserId?: Maybe<StringWithAggregatesFilter>;
  durationSeconds?: Maybe<IntNullableWithAggregatesFilter>;
  generatedText?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  recordingS3Uri?: Maybe<StringNullableWithAggregatesFilter>;
  source?: Maybe<EnumRecapSourceWithAggregatesFilter>;
  status?: Maybe<EnumRecapStatusWithAggregatesFilter>;
  templateId?: Maybe<StringNullableWithAggregatesFilter>;
  transcriptionRequestId?: Maybe<StringNullableWithAggregatesFilter>;
  transcriptionS3Uri?: Maybe<StringNullableWithAggregatesFilter>;
  transcriptionService?: Maybe<EnumTranscriptionServicesNullableWithAggregatesFilter>;
  transcriptionText?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum RecapSource {
  Browser = 'BROWSER',
  NativeApp = 'NATIVE_APP'
}

export enum RecapStatus {
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Error = 'ERROR',
  GeneratingSummary = 'GENERATING_SUMMARY',
  Transcribing = 'TRANSCRIBING',
  Uploading = 'UPLOADING'
}

export type RecapSubscription = {
  __typename?: 'RecapSubscription';
  mutation: MutationType;
  node: Recap;
};

export type RecapSumAggregateOutputType = {
  __typename?: 'RecapSumAggregateOutputType';
  durationSeconds?: Maybe<Scalars['Int']>;
};

export type RecapSumOrderByAggregateInput = {
  durationSeconds?: Maybe<SortOrder>;
};

export type RecapSummaryGeneratedSubscription = {
  __typename?: 'RecapSummaryGeneratedSubscription';
  mutation: MutationType;
  node: Appointment;
};

export type RecapUncheckedCreateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUncheckedCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<RecapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RecapCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<RecapCreateWithoutAppointmentInput>>;
  createMany?: Maybe<RecapCreateManyAppointmentInputEnvelope>;
};

export type RecapUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<RecapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RecapCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<RecapCreateWithoutClinicInput>>;
  createMany?: Maybe<RecapCreateManyClinicInputEnvelope>;
};

export type RecapUncheckedCreateNestedManyWithoutCreatedByInput = {
  connect?: Maybe<Array<RecapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RecapCreateOrConnectWithoutCreatedByInput>>;
  create?: Maybe<Array<RecapCreateWithoutCreatedByInput>>;
  createMany?: Maybe<RecapCreateManyCreatedByInputEnvelope>;
};

export type RecapUncheckedCreateWithoutAppointmentInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUncheckedCreateWithoutClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUncheckedCreateWithoutCreatedByInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUncheckedUpdateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUncheckedUpdateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUncheckedUpdateManyWithoutAppointmentInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUncheckedUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<RecapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RecapCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<RecapCreateWithoutAppointmentInput>>;
  createMany?: Maybe<RecapCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<RecapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RecapScalarWhereInput>>;
  disconnect?: Maybe<Array<RecapWhereUniqueInput>>;
  set?: Maybe<Array<RecapWhereUniqueInput>>;
  update?: Maybe<Array<RecapUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<RecapUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<RecapUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type RecapUncheckedUpdateManyWithoutClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<RecapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RecapCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<RecapCreateWithoutClinicInput>>;
  createMany?: Maybe<RecapCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<RecapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RecapScalarWhereInput>>;
  disconnect?: Maybe<Array<RecapWhereUniqueInput>>;
  set?: Maybe<Array<RecapWhereUniqueInput>>;
  update?: Maybe<Array<RecapUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<RecapUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<RecapUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type RecapUncheckedUpdateManyWithoutCreatedByInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUncheckedUpdateManyWithoutCreatedByNestedInput = {
  connect?: Maybe<Array<RecapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RecapCreateOrConnectWithoutCreatedByInput>>;
  create?: Maybe<Array<RecapCreateWithoutCreatedByInput>>;
  createMany?: Maybe<RecapCreateManyCreatedByInputEnvelope>;
  delete?: Maybe<Array<RecapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RecapScalarWhereInput>>;
  disconnect?: Maybe<Array<RecapWhereUniqueInput>>;
  set?: Maybe<Array<RecapWhereUniqueInput>>;
  update?: Maybe<Array<RecapUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: Maybe<Array<RecapUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: Maybe<Array<RecapUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type RecapUncheckedUpdateWithoutAppointmentInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUncheckedUpdateWithoutClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUncheckedUpdateWithoutCreatedByInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUpdateInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutRecapsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutRecapsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserUpdateOneRequiredWithoutRecapsNestedInput>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUpdateManyWithWhereWithoutAppointmentInput = {
  data: RecapUpdateManyMutationInput;
  where: RecapScalarWhereInput;
};

export type RecapUpdateManyWithWhereWithoutClinicInput = {
  data: RecapUpdateManyMutationInput;
  where: RecapScalarWhereInput;
};

export type RecapUpdateManyWithWhereWithoutCreatedByInput = {
  data: RecapUpdateManyMutationInput;
  where: RecapScalarWhereInput;
};

export type RecapUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<RecapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RecapCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<RecapCreateWithoutAppointmentInput>>;
  createMany?: Maybe<RecapCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<RecapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RecapScalarWhereInput>>;
  disconnect?: Maybe<Array<RecapWhereUniqueInput>>;
  set?: Maybe<Array<RecapWhereUniqueInput>>;
  update?: Maybe<Array<RecapUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<RecapUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<RecapUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type RecapUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<RecapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RecapCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<RecapCreateWithoutClinicInput>>;
  createMany?: Maybe<RecapCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<RecapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RecapScalarWhereInput>>;
  disconnect?: Maybe<Array<RecapWhereUniqueInput>>;
  set?: Maybe<Array<RecapWhereUniqueInput>>;
  update?: Maybe<Array<RecapUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<RecapUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<RecapUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type RecapUpdateManyWithoutCreatedByNestedInput = {
  connect?: Maybe<Array<RecapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RecapCreateOrConnectWithoutCreatedByInput>>;
  create?: Maybe<Array<RecapCreateWithoutCreatedByInput>>;
  createMany?: Maybe<RecapCreateManyCreatedByInputEnvelope>;
  delete?: Maybe<Array<RecapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RecapScalarWhereInput>>;
  disconnect?: Maybe<Array<RecapWhereUniqueInput>>;
  set?: Maybe<Array<RecapWhereUniqueInput>>;
  update?: Maybe<Array<RecapUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: Maybe<Array<RecapUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: Maybe<Array<RecapUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type RecapUpdateWithWhereUniqueWithoutAppointmentInput = {
  data: RecapUpdateWithoutAppointmentInput;
  where: RecapWhereUniqueInput;
};

export type RecapUpdateWithWhereUniqueWithoutClinicInput = {
  data: RecapUpdateWithoutClinicInput;
  where: RecapWhereUniqueInput;
};

export type RecapUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: RecapUpdateWithoutCreatedByInput;
  where: RecapWhereUniqueInput;
};

export type RecapUpdateWithoutAppointmentInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutRecapsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserUpdateOneRequiredWithoutRecapsNestedInput>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUpdateWithoutClinicInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutRecapsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserUpdateOneRequiredWithoutRecapsNestedInput>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUpdateWithoutCreatedByInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutRecapsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutRecapsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  generatedText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<Scalars['String']>;
  source?: Maybe<RecapSource>;
  status?: Maybe<RecapStatus>;
  templateId?: Maybe<Scalars['String']>;
  transcriptionRequestId?: Maybe<Scalars['String']>;
  transcriptionS3Uri?: Maybe<Scalars['String']>;
  transcriptionService?: Maybe<TranscriptionServices>;
  transcriptionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecapUpsertWithWhereUniqueWithoutAppointmentInput = {
  create: RecapCreateWithoutAppointmentInput;
  update: RecapUpdateWithoutAppointmentInput;
  where: RecapWhereUniqueInput;
};

export type RecapUpsertWithWhereUniqueWithoutClinicInput = {
  create: RecapCreateWithoutClinicInput;
  update: RecapUpdateWithoutClinicInput;
  where: RecapWhereUniqueInput;
};

export type RecapUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: RecapCreateWithoutCreatedByInput;
  update: RecapUpdateWithoutCreatedByInput;
  where: RecapWhereUniqueInput;
};

export type RecapWhereInput = {
  AND?: Maybe<Array<RecapWhereInput>>;
  NOT?: Maybe<Array<RecapWhereInput>>;
  OR?: Maybe<Array<RecapWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdBy?: Maybe<UserScalarRelationFilter>;
  createdByUserId?: Maybe<StringFilter>;
  durationSeconds?: Maybe<IntNullableFilter>;
  generatedText?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  recordingS3Uri?: Maybe<StringNullableFilter>;
  source?: Maybe<EnumRecapSourceFilter>;
  status?: Maybe<EnumRecapStatusFilter>;
  templateId?: Maybe<StringNullableFilter>;
  transcriptionRequestId?: Maybe<StringNullableFilter>;
  transcriptionS3Uri?: Maybe<StringNullableFilter>;
  transcriptionService?: Maybe<EnumTranscriptionServicesNullableFilter>;
  transcriptionText?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type RecapWhereUniqueInput = {
  AND?: Maybe<Array<RecapWhereInput>>;
  NOT?: Maybe<Array<RecapWhereInput>>;
  OR?: Maybe<Array<RecapWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdBy?: Maybe<UserScalarRelationFilter>;
  createdByUserId?: Maybe<StringFilter>;
  durationSeconds?: Maybe<IntNullableFilter>;
  generatedText?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  recordingS3Uri?: Maybe<StringNullableFilter>;
  source?: Maybe<EnumRecapSourceFilter>;
  status?: Maybe<EnumRecapStatusFilter>;
  templateId?: Maybe<StringNullableFilter>;
  transcriptionRequestId?: Maybe<StringNullableFilter>;
  transcriptionS3Uri?: Maybe<StringNullableFilter>;
  transcriptionService?: Maybe<EnumTranscriptionServicesNullableFilter>;
  transcriptionText?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum RecordingControlStatus {
  InProgress = 'InProgress',
  Paused = 'Paused',
  Stopped = 'Stopped'
}

export enum RecordingDownloadStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Pending = 'Pending',
  Processing = 'Processing'
}

export type RedeemOneTimeCodeInput = {
  code: Scalars['String'];
  trusted: Scalars['Boolean'];
};

export type RedeemOneTimeCodeResult = {
  __typename?: 'RedeemOneTimeCodeResult';
  success: Scalars['Boolean'];
  token: Scalars['String'];
};

export enum RefundReason {
  Duplicate = 'Duplicate',
  Fraudulent = 'Fraudulent',
  Other = 'Other',
  PartialRefund = 'Partial_Refund',
  RequestedByCustomer = 'Requested_By_Customer'
}

export type RegeneratePetParentClinicListWithTokensInput = {
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export enum RelationLoadStrategy {
  Join = 'join',
  Query = 'query'
}

export type RemoveUserFromClinicInput = {
  clinicId: Scalars['String'];
  userId: Scalars['String'];
};

export enum RenewalRejectionReason {
  DeceasedPet = 'DeceasedPet',
  OptOut = 'OptOut',
  PaymentsMissing = 'PaymentsMissing'
}

export enum ReportFilterTab {
  All = 'All',
  Complete = 'Complete',
  Disbursements = 'Disbursements',
  Disputes = 'Disputes',
  Incomplete = 'Incomplete'
}

export type RequestBitwerxIntegrationInput = {
  clinicContactEmail: Scalars['String'];
  forPayments?: Maybe<Scalars['Boolean']>;
};

export type RequestLoyaltyRewardInput = {
  loyaltyAccountId: Scalars['String'];
  loyaltyRewardId: Scalars['String'];
};

export type RequestOneTimeCodeInput = {
  emailAddress?: Maybe<Scalars['String']>;
  method: RequestOneTimeCodeMethod;
  phoneNumber?: Maybe<Scalars['String']>;
};

export enum RequestOneTimeCodeMethod {
  Email = 'EMAIL',
  Text = 'TEXT'
}

export type RequestOneTimeCodeResult = {
  __typename?: 'RequestOneTimeCodeResult';
  success: Scalars['Boolean'];
};

export type ResendReceiptEmailOutput = {
  __typename?: 'ResendReceiptEmailOutput';
  error?: Maybe<Scalars['String']>;
  jobChainId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ResendUserInvitationInput = {
  email: Scalars['String'];
};

export type RetryPaymentWritebackOutput = {
  __typename?: 'RetryPaymentWritebackOutput';
  error?: Maybe<Scalars['String']>;
  jobChainId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type RetryProcessAppointmentRecapInput = {
  recapId: Scalars['String'];
};

export type RetryProcessAppointmentRecapOutput = {
  __typename?: 'RetryProcessAppointmentRecapOutput';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** @deprecated - 1.0 */
export type Review = {
  __typename?: 'Review';
  _count: ReviewCountOutputType;
  createdAt: Scalars['DateTime'];
  feedbackMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  rating: Scalars['Int'];
  ratingDisplay: Scalars['String'];
  ratingScale: Scalars['Int'];
  relationshipId?: Maybe<Scalars['String']>;
  reviewTags: Array<ReviewTag>;
  reviewType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};


/** @deprecated - 1.0 */
export type ReviewReviewTagsArgs = {
  cursor?: Maybe<ReviewTagWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ReviewTagScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ReviewTagOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReviewTagWhereInput>;
};


/** @deprecated - 1.0 */
export type ReviewUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type ReviewAvgAggregateOutputType = {
  __typename?: 'ReviewAvgAggregateOutputType';
  rating?: Maybe<Scalars['Float']>;
  ratingScale?: Maybe<Scalars['Float']>;
};

export type ReviewAvgOrderByAggregateInput = {
  rating?: Maybe<SortOrder>;
  ratingScale?: Maybe<SortOrder>;
};

export type ReviewCountAggregateOutputType = {
  __typename?: 'ReviewCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  feedbackMessage: Scalars['Int'];
  id: Scalars['Int'];
  rating: Scalars['Int'];
  ratingDisplay: Scalars['Int'];
  ratingScale: Scalars['Int'];
  relationshipId: Scalars['Int'];
  reviewType: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ReviewCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  feedbackMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rating?: Maybe<SortOrder>;
  ratingDisplay?: Maybe<SortOrder>;
  ratingScale?: Maybe<SortOrder>;
  relationshipId?: Maybe<SortOrder>;
  reviewType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ReviewCountOutputType = {
  __typename?: 'ReviewCountOutputType';
  reviewTags: Scalars['Int'];
};

export type ReviewCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  ratingDisplay: Scalars['String'];
  ratingScale: Scalars['Int'];
  relationshipId?: Maybe<Scalars['String']>;
  reviewTags?: Maybe<ReviewTagCreateNestedManyWithoutReviewsInput>;
  reviewType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutReviewsInput>;
};

export type ReviewCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  ratingDisplay: Scalars['String'];
  ratingScale: Scalars['Int'];
  relationshipId?: Maybe<Scalars['String']>;
  reviewType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ReviewCreateManyUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  ratingDisplay: Scalars['String'];
  ratingScale: Scalars['Int'];
  relationshipId?: Maybe<Scalars['String']>;
  reviewType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewCreateManyUserInputEnvelope = {
  data: Array<ReviewCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ReviewCreateNestedManyWithoutReviewTagsInput = {
  connect?: Maybe<Array<ReviewWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReviewCreateOrConnectWithoutReviewTagsInput>>;
  create?: Maybe<Array<ReviewCreateWithoutReviewTagsInput>>;
};

export type ReviewCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ReviewWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReviewCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ReviewCreateWithoutUserInput>>;
  createMany?: Maybe<ReviewCreateManyUserInputEnvelope>;
};

export type ReviewCreateOrConnectWithoutReviewTagsInput = {
  create: ReviewCreateWithoutReviewTagsInput;
  where: ReviewWhereUniqueInput;
};

export type ReviewCreateOrConnectWithoutUserInput = {
  create: ReviewCreateWithoutUserInput;
  where: ReviewWhereUniqueInput;
};

export type ReviewCreateWithoutReviewTagsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  ratingDisplay: Scalars['String'];
  ratingScale: Scalars['Int'];
  relationshipId?: Maybe<Scalars['String']>;
  reviewType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutReviewsInput>;
};

export type ReviewCreateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  ratingDisplay: Scalars['String'];
  ratingScale: Scalars['Int'];
  relationshipId?: Maybe<Scalars['String']>;
  reviewTags?: Maybe<ReviewTagCreateNestedManyWithoutReviewsInput>;
  reviewType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewGroupByOutputType = {
  __typename?: 'ReviewGroupByOutputType';
  _avg?: Maybe<ReviewAvgAggregateOutputType>;
  _count?: Maybe<ReviewCountAggregateOutputType>;
  _max?: Maybe<ReviewMaxAggregateOutputType>;
  _min?: Maybe<ReviewMinAggregateOutputType>;
  _sum?: Maybe<ReviewSumAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  feedbackMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  rating: Scalars['Int'];
  ratingDisplay: Scalars['String'];
  ratingScale: Scalars['Int'];
  relationshipId?: Maybe<Scalars['String']>;
  reviewType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type ReviewListRelationFilter = {
  every?: Maybe<ReviewWhereInput>;
  none?: Maybe<ReviewWhereInput>;
  some?: Maybe<ReviewWhereInput>;
};

export type ReviewMaxAggregateOutputType = {
  __typename?: 'ReviewMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  ratingDisplay?: Maybe<Scalars['String']>;
  ratingScale?: Maybe<Scalars['Int']>;
  relationshipId?: Maybe<Scalars['String']>;
  reviewType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ReviewMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  feedbackMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rating?: Maybe<SortOrder>;
  ratingDisplay?: Maybe<SortOrder>;
  ratingScale?: Maybe<SortOrder>;
  relationshipId?: Maybe<SortOrder>;
  reviewType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ReviewMinAggregateOutputType = {
  __typename?: 'ReviewMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  ratingDisplay?: Maybe<Scalars['String']>;
  ratingScale?: Maybe<Scalars['Int']>;
  relationshipId?: Maybe<Scalars['String']>;
  reviewType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ReviewMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  feedbackMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rating?: Maybe<SortOrder>;
  ratingDisplay?: Maybe<SortOrder>;
  ratingScale?: Maybe<SortOrder>;
  relationshipId?: Maybe<SortOrder>;
  reviewType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ReviewOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ReviewOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ReviewOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  feedbackMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rating?: Maybe<SortOrder>;
  ratingDisplay?: Maybe<SortOrder>;
  ratingScale?: Maybe<SortOrder>;
  relationshipId?: Maybe<SortOrder>;
  reviewTags?: Maybe<ReviewTagOrderByRelationAggregateInput>;
  reviewType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ReviewOrderByRelevanceFieldEnum {
  FeedbackMessage = 'feedbackMessage',
  Id = 'id',
  RatingDisplay = 'ratingDisplay',
  RelationshipId = 'relationshipId',
  ReviewType = 'reviewType',
  UserId = 'userId'
}

export type ReviewOrderByRelevanceInput = {
  fields: Array<ReviewOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ReviewOrderByWithAggregationInput = {
  _avg?: Maybe<ReviewAvgOrderByAggregateInput>;
  _count?: Maybe<ReviewCountOrderByAggregateInput>;
  _max?: Maybe<ReviewMaxOrderByAggregateInput>;
  _min?: Maybe<ReviewMinOrderByAggregateInput>;
  _sum?: Maybe<ReviewSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  feedbackMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rating?: Maybe<SortOrder>;
  ratingDisplay?: Maybe<SortOrder>;
  ratingScale?: Maybe<SortOrder>;
  relationshipId?: Maybe<SortOrder>;
  reviewType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type ReviewOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ReviewOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  feedbackMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rating?: Maybe<SortOrder>;
  ratingDisplay?: Maybe<SortOrder>;
  ratingScale?: Maybe<SortOrder>;
  relationshipId?: Maybe<SortOrder>;
  reviewTags?: Maybe<ReviewTagOrderByRelationAggregateInput>;
  reviewType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type ReviewOrderByWithRelationInput = {
  _relevance?: Maybe<ReviewOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  feedbackMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  rating?: Maybe<SortOrder>;
  ratingDisplay?: Maybe<SortOrder>;
  ratingScale?: Maybe<SortOrder>;
  relationshipId?: Maybe<SortOrder>;
  reviewTags?: Maybe<ReviewTagOrderByRelationAggregateInput>;
  reviewType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum ReviewScalarFieldEnum {
  CreatedAt = 'createdAt',
  FeedbackMessage = 'feedbackMessage',
  Id = 'id',
  Rating = 'rating',
  RatingDisplay = 'ratingDisplay',
  RatingScale = 'ratingScale',
  RelationshipId = 'relationshipId',
  ReviewType = 'reviewType',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ReviewScalarWhereInput = {
  AND?: Maybe<Array<ReviewScalarWhereInput>>;
  NOT?: Maybe<Array<ReviewScalarWhereInput>>;
  OR?: Maybe<Array<ReviewScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  feedbackMessage?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  rating?: Maybe<IntFilter>;
  ratingDisplay?: Maybe<StringFilter>;
  ratingScale?: Maybe<IntFilter>;
  relationshipId?: Maybe<StringNullableFilter>;
  reviewType?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type ReviewScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ReviewScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ReviewScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ReviewScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  feedbackMessage?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  rating?: Maybe<IntWithAggregatesFilter>;
  ratingDisplay?: Maybe<StringWithAggregatesFilter>;
  ratingScale?: Maybe<IntWithAggregatesFilter>;
  relationshipId?: Maybe<StringNullableWithAggregatesFilter>;
  reviewType?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type ReviewSumAggregateOutputType = {
  __typename?: 'ReviewSumAggregateOutputType';
  rating?: Maybe<Scalars['Int']>;
  ratingScale?: Maybe<Scalars['Int']>;
};

export type ReviewSumOrderByAggregateInput = {
  rating?: Maybe<SortOrder>;
  ratingScale?: Maybe<SortOrder>;
};

/** @deprecated - 1.0 */
export type ReviewTag = {
  __typename?: 'ReviewTag';
  _count: ReviewTagCountOutputType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  reviews: Array<Review>;
  updatedAt: Scalars['DateTime'];
};


/** @deprecated - 1.0 */
export type ReviewTagReviewsArgs = {
  cursor?: Maybe<ReviewWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ReviewScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ReviewOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReviewWhereInput>;
};

export type ReviewTagCountAggregateOutputType = {
  __typename?: 'ReviewTagCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ReviewTagCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ReviewTagCountOutputType = {
  __typename?: 'ReviewTagCountOutputType';
  reviews: Scalars['Int'];
};

export type ReviewTagCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  reviews?: Maybe<ReviewCreateNestedManyWithoutReviewTagsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagCreateNestedManyWithoutReviewsInput = {
  connect?: Maybe<Array<ReviewTagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReviewTagCreateOrConnectWithoutReviewsInput>>;
  create?: Maybe<Array<ReviewTagCreateWithoutReviewsInput>>;
};

export type ReviewTagCreateOrConnectWithoutReviewsInput = {
  create: ReviewTagCreateWithoutReviewsInput;
  where: ReviewTagWhereUniqueInput;
};

export type ReviewTagCreateWithoutReviewsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagGroupByOutputType = {
  __typename?: 'ReviewTagGroupByOutputType';
  _count?: Maybe<ReviewTagCountAggregateOutputType>;
  _max?: Maybe<ReviewTagMaxAggregateOutputType>;
  _min?: Maybe<ReviewTagMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ReviewTagListRelationFilter = {
  every?: Maybe<ReviewTagWhereInput>;
  none?: Maybe<ReviewTagWhereInput>;
  some?: Maybe<ReviewTagWhereInput>;
};

export type ReviewTagMaxAggregateOutputType = {
  __typename?: 'ReviewTagMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ReviewTagMinAggregateOutputType = {
  __typename?: 'ReviewTagMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ReviewTagOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ReviewTagOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ReviewTagOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  reviews?: Maybe<ReviewOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ReviewTagOrderByRelevanceFieldEnum {
  Id = 'id',
  Name = 'name'
}

export type ReviewTagOrderByRelevanceInput = {
  fields: Array<ReviewTagOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ReviewTagOrderByWithAggregationInput = {
  _count?: Maybe<ReviewTagCountOrderByAggregateInput>;
  _max?: Maybe<ReviewTagMaxOrderByAggregateInput>;
  _min?: Maybe<ReviewTagMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ReviewTagOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ReviewTagOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  reviews?: Maybe<ReviewOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type ReviewTagOrderByWithRelationInput = {
  _relevance?: Maybe<ReviewTagOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  reviews?: Maybe<ReviewOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ReviewTagScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type ReviewTagScalarWhereInput = {
  AND?: Maybe<Array<ReviewTagScalarWhereInput>>;
  NOT?: Maybe<Array<ReviewTagScalarWhereInput>>;
  OR?: Maybe<Array<ReviewTagScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ReviewTagScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ReviewTagScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ReviewTagScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ReviewTagScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ReviewTagUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutReviewTagsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagUncheckedCreateNestedManyWithoutReviewsInput = {
  connect?: Maybe<Array<ReviewTagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReviewTagCreateOrConnectWithoutReviewsInput>>;
  create?: Maybe<Array<ReviewTagCreateWithoutReviewsInput>>;
};

export type ReviewTagUncheckedCreateWithoutReviewsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutReviewTagsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagUncheckedUpdateManyWithoutReviewsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagUncheckedUpdateManyWithoutReviewsNestedInput = {
  connect?: Maybe<Array<ReviewTagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReviewTagCreateOrConnectWithoutReviewsInput>>;
  create?: Maybe<Array<ReviewTagCreateWithoutReviewsInput>>;
  delete?: Maybe<Array<ReviewTagWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReviewTagScalarWhereInput>>;
  disconnect?: Maybe<Array<ReviewTagWhereUniqueInput>>;
  set?: Maybe<Array<ReviewTagWhereUniqueInput>>;
  update?: Maybe<Array<ReviewTagUpdateWithWhereUniqueWithoutReviewsInput>>;
  updateMany?: Maybe<Array<ReviewTagUpdateManyWithWhereWithoutReviewsInput>>;
  upsert?: Maybe<Array<ReviewTagUpsertWithWhereUniqueWithoutReviewsInput>>;
};

export type ReviewTagUncheckedUpdateWithoutReviewsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  reviews?: Maybe<ReviewUpdateManyWithoutReviewTagsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagUpdateManyWithWhereWithoutReviewsInput = {
  data: ReviewTagUpdateManyMutationInput;
  where: ReviewTagScalarWhereInput;
};

export type ReviewTagUpdateManyWithoutReviewsNestedInput = {
  connect?: Maybe<Array<ReviewTagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReviewTagCreateOrConnectWithoutReviewsInput>>;
  create?: Maybe<Array<ReviewTagCreateWithoutReviewsInput>>;
  delete?: Maybe<Array<ReviewTagWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReviewTagScalarWhereInput>>;
  disconnect?: Maybe<Array<ReviewTagWhereUniqueInput>>;
  set?: Maybe<Array<ReviewTagWhereUniqueInput>>;
  update?: Maybe<Array<ReviewTagUpdateWithWhereUniqueWithoutReviewsInput>>;
  updateMany?: Maybe<Array<ReviewTagUpdateManyWithWhereWithoutReviewsInput>>;
  upsert?: Maybe<Array<ReviewTagUpsertWithWhereUniqueWithoutReviewsInput>>;
};

export type ReviewTagUpdateWithWhereUniqueWithoutReviewsInput = {
  data: ReviewTagUpdateWithoutReviewsInput;
  where: ReviewTagWhereUniqueInput;
};

export type ReviewTagUpdateWithoutReviewsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewTagUpsertWithWhereUniqueWithoutReviewsInput = {
  create: ReviewTagCreateWithoutReviewsInput;
  update: ReviewTagUpdateWithoutReviewsInput;
  where: ReviewTagWhereUniqueInput;
};

export type ReviewTagWhereInput = {
  AND?: Maybe<Array<ReviewTagWhereInput>>;
  NOT?: Maybe<Array<ReviewTagWhereInput>>;
  OR?: Maybe<Array<ReviewTagWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  name?: Maybe<StringFilter>;
  reviews?: Maybe<ReviewListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ReviewTagWhereUniqueInput = {
  AND?: Maybe<Array<ReviewTagWhereInput>>;
  NOT?: Maybe<Array<ReviewTagWhereInput>>;
  OR?: Maybe<Array<ReviewTagWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolNullableFilter>;
  name?: Maybe<Scalars['String']>;
  reviews?: Maybe<ReviewListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ReviewUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  ratingDisplay: Scalars['String'];
  ratingScale: Scalars['Int'];
  relationshipId?: Maybe<Scalars['String']>;
  reviewTags?: Maybe<ReviewTagUncheckedCreateNestedManyWithoutReviewsInput>;
  reviewType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ReviewUncheckedCreateNestedManyWithoutReviewTagsInput = {
  connect?: Maybe<Array<ReviewWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReviewCreateOrConnectWithoutReviewTagsInput>>;
  create?: Maybe<Array<ReviewCreateWithoutReviewTagsInput>>;
};

export type ReviewUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ReviewWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReviewCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ReviewCreateWithoutUserInput>>;
  createMany?: Maybe<ReviewCreateManyUserInputEnvelope>;
};

export type ReviewUncheckedCreateWithoutReviewTagsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  ratingDisplay: Scalars['String'];
  ratingScale: Scalars['Int'];
  relationshipId?: Maybe<Scalars['String']>;
  reviewType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ReviewUncheckedCreateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  ratingDisplay: Scalars['String'];
  ratingScale: Scalars['Int'];
  relationshipId?: Maybe<Scalars['String']>;
  reviewTags?: Maybe<ReviewTagUncheckedCreateNestedManyWithoutReviewsInput>;
  reviewType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  ratingDisplay?: Maybe<Scalars['String']>;
  ratingScale?: Maybe<Scalars['Int']>;
  relationshipId?: Maybe<Scalars['String']>;
  reviewTags?: Maybe<ReviewTagUncheckedUpdateManyWithoutReviewsNestedInput>;
  reviewType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ReviewUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  ratingDisplay?: Maybe<Scalars['String']>;
  ratingScale?: Maybe<Scalars['Int']>;
  relationshipId?: Maybe<Scalars['String']>;
  reviewType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ReviewUncheckedUpdateManyWithoutReviewTagsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  ratingDisplay?: Maybe<Scalars['String']>;
  ratingScale?: Maybe<Scalars['Int']>;
  relationshipId?: Maybe<Scalars['String']>;
  reviewType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ReviewUncheckedUpdateManyWithoutReviewTagsNestedInput = {
  connect?: Maybe<Array<ReviewWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReviewCreateOrConnectWithoutReviewTagsInput>>;
  create?: Maybe<Array<ReviewCreateWithoutReviewTagsInput>>;
  delete?: Maybe<Array<ReviewWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReviewScalarWhereInput>>;
  disconnect?: Maybe<Array<ReviewWhereUniqueInput>>;
  set?: Maybe<Array<ReviewWhereUniqueInput>>;
  update?: Maybe<Array<ReviewUpdateWithWhereUniqueWithoutReviewTagsInput>>;
  updateMany?: Maybe<Array<ReviewUpdateManyWithWhereWithoutReviewTagsInput>>;
  upsert?: Maybe<Array<ReviewUpsertWithWhereUniqueWithoutReviewTagsInput>>;
};

export type ReviewUncheckedUpdateManyWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  ratingDisplay?: Maybe<Scalars['String']>;
  ratingScale?: Maybe<Scalars['Int']>;
  relationshipId?: Maybe<Scalars['String']>;
  reviewType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ReviewWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReviewCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ReviewCreateWithoutUserInput>>;
  createMany?: Maybe<ReviewCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ReviewWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReviewScalarWhereInput>>;
  disconnect?: Maybe<Array<ReviewWhereUniqueInput>>;
  set?: Maybe<Array<ReviewWhereUniqueInput>>;
  update?: Maybe<Array<ReviewUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ReviewUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ReviewUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ReviewUncheckedUpdateWithoutReviewTagsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  ratingDisplay?: Maybe<Scalars['String']>;
  ratingScale?: Maybe<Scalars['Int']>;
  relationshipId?: Maybe<Scalars['String']>;
  reviewType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ReviewUncheckedUpdateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  ratingDisplay?: Maybe<Scalars['String']>;
  ratingScale?: Maybe<Scalars['Int']>;
  relationshipId?: Maybe<Scalars['String']>;
  reviewTags?: Maybe<ReviewTagUncheckedUpdateManyWithoutReviewsNestedInput>;
  reviewType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  ratingDisplay?: Maybe<Scalars['String']>;
  ratingScale?: Maybe<Scalars['Int']>;
  relationshipId?: Maybe<Scalars['String']>;
  reviewTags?: Maybe<ReviewTagUpdateManyWithoutReviewsNestedInput>;
  reviewType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutReviewsNestedInput>;
};

export type ReviewUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  ratingDisplay?: Maybe<Scalars['String']>;
  ratingScale?: Maybe<Scalars['Int']>;
  relationshipId?: Maybe<Scalars['String']>;
  reviewType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewUpdateManyWithWhereWithoutReviewTagsInput = {
  data: ReviewUpdateManyMutationInput;
  where: ReviewScalarWhereInput;
};

export type ReviewUpdateManyWithWhereWithoutUserInput = {
  data: ReviewUpdateManyMutationInput;
  where: ReviewScalarWhereInput;
};

export type ReviewUpdateManyWithoutReviewTagsNestedInput = {
  connect?: Maybe<Array<ReviewWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReviewCreateOrConnectWithoutReviewTagsInput>>;
  create?: Maybe<Array<ReviewCreateWithoutReviewTagsInput>>;
  delete?: Maybe<Array<ReviewWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReviewScalarWhereInput>>;
  disconnect?: Maybe<Array<ReviewWhereUniqueInput>>;
  set?: Maybe<Array<ReviewWhereUniqueInput>>;
  update?: Maybe<Array<ReviewUpdateWithWhereUniqueWithoutReviewTagsInput>>;
  updateMany?: Maybe<Array<ReviewUpdateManyWithWhereWithoutReviewTagsInput>>;
  upsert?: Maybe<Array<ReviewUpsertWithWhereUniqueWithoutReviewTagsInput>>;
};

export type ReviewUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ReviewWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReviewCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ReviewCreateWithoutUserInput>>;
  createMany?: Maybe<ReviewCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ReviewWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReviewScalarWhereInput>>;
  disconnect?: Maybe<Array<ReviewWhereUniqueInput>>;
  set?: Maybe<Array<ReviewWhereUniqueInput>>;
  update?: Maybe<Array<ReviewUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ReviewUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ReviewUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ReviewUpdateWithWhereUniqueWithoutReviewTagsInput = {
  data: ReviewUpdateWithoutReviewTagsInput;
  where: ReviewWhereUniqueInput;
};

export type ReviewUpdateWithWhereUniqueWithoutUserInput = {
  data: ReviewUpdateWithoutUserInput;
  where: ReviewWhereUniqueInput;
};

export type ReviewUpdateWithoutReviewTagsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  ratingDisplay?: Maybe<Scalars['String']>;
  ratingScale?: Maybe<Scalars['Int']>;
  relationshipId?: Maybe<Scalars['String']>;
  reviewType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutReviewsNestedInput>;
};

export type ReviewUpdateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedbackMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  ratingDisplay?: Maybe<Scalars['String']>;
  ratingScale?: Maybe<Scalars['Int']>;
  relationshipId?: Maybe<Scalars['String']>;
  reviewTags?: Maybe<ReviewTagUpdateManyWithoutReviewsNestedInput>;
  reviewType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewUpsertWithWhereUniqueWithoutReviewTagsInput = {
  create: ReviewCreateWithoutReviewTagsInput;
  update: ReviewUpdateWithoutReviewTagsInput;
  where: ReviewWhereUniqueInput;
};

export type ReviewUpsertWithWhereUniqueWithoutUserInput = {
  create: ReviewCreateWithoutUserInput;
  update: ReviewUpdateWithoutUserInput;
  where: ReviewWhereUniqueInput;
};

export type ReviewWhereInput = {
  AND?: Maybe<Array<ReviewWhereInput>>;
  NOT?: Maybe<Array<ReviewWhereInput>>;
  OR?: Maybe<Array<ReviewWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  feedbackMessage?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  rating?: Maybe<IntFilter>;
  ratingDisplay?: Maybe<StringFilter>;
  ratingScale?: Maybe<IntFilter>;
  relationshipId?: Maybe<StringNullableFilter>;
  reviewTags?: Maybe<ReviewTagListRelationFilter>;
  reviewType?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type ReviewWhereUniqueInput = {
  AND?: Maybe<Array<ReviewWhereInput>>;
  NOT?: Maybe<Array<ReviewWhereInput>>;
  OR?: Maybe<Array<ReviewWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  feedbackMessage?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<IntFilter>;
  ratingDisplay?: Maybe<StringFilter>;
  ratingScale?: Maybe<IntFilter>;
  relationshipId?: Maybe<StringNullableFilter>;
  reviewTags?: Maybe<ReviewTagListRelationFilter>;
  reviewType?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export enum Role {
  Admin = 'ADMIN',
  Head = 'HEAD',
  Member = 'MEMBER',
  Nurse = 'NURSE',
  Pm = 'PM',
  Rec = 'REC',
  Technician = 'TECHNICIAN',
  TeletriageAgent = 'TELETRIAGE_AGENT',
  Vet = 'VET'
}

export enum RuleActions {
  UpdateInactiveChannelStatus = 'UpdateInactiveChannelStatus'
}

export type Rules = {
  __typename?: 'Rules';
  action: RuleActions;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  options: Scalars['Json'];
  updatedAt: Scalars['DateTime'];
};

export type RulesCountAggregateOutputType = {
  __typename?: 'RulesCountAggregateOutputType';
  _all: Scalars['Int'];
  action: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  options: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type RulesCountOrderByAggregateInput = {
  action?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  options?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RulesCreateInput = {
  action?: Maybe<RuleActions>;
  clinic: ClinicCreateNestedOneWithoutRulesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesCreateManyClinicInput = {
  action?: Maybe<RuleActions>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesCreateManyClinicInputEnvelope = {
  data: Array<RulesCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type RulesCreateManyInput = {
  action?: Maybe<RuleActions>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<RulesWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RulesCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<RulesCreateWithoutClinicInput>>;
  createMany?: Maybe<RulesCreateManyClinicInputEnvelope>;
};

export type RulesCreateOrConnectWithoutClinicInput = {
  create: RulesCreateWithoutClinicInput;
  where: RulesWhereUniqueInput;
};

export type RulesCreateWithoutClinicInput = {
  action?: Maybe<RuleActions>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesGroupByOutputType = {
  __typename?: 'RulesGroupByOutputType';
  _count?: Maybe<RulesCountAggregateOutputType>;
  _max?: Maybe<RulesMaxAggregateOutputType>;
  _min?: Maybe<RulesMinAggregateOutputType>;
  action: RuleActions;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  options: Scalars['Json'];
  updatedAt: Scalars['DateTime'];
};

export type RulesListRelationFilter = {
  every?: Maybe<RulesWhereInput>;
  none?: Maybe<RulesWhereInput>;
  some?: Maybe<RulesWhereInput>;
};

export type RulesMaxAggregateOutputType = {
  __typename?: 'RulesMaxAggregateOutputType';
  action?: Maybe<RuleActions>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesMaxOrderByAggregateInput = {
  action?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RulesMinAggregateOutputType = {
  __typename?: 'RulesMinAggregateOutputType';
  action?: Maybe<RuleActions>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesMinOrderByAggregateInput = {
  action?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RulesOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type RulesOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<RulesOrderByRelevanceInput>;
  action?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  options?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum RulesOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id'
}

export type RulesOrderByRelevanceInput = {
  fields: Array<RulesOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type RulesOrderByWithAggregationInput = {
  _count?: Maybe<RulesCountOrderByAggregateInput>;
  _max?: Maybe<RulesMaxOrderByAggregateInput>;
  _min?: Maybe<RulesMinOrderByAggregateInput>;
  action?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  options?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RulesOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<RulesOrderByRelevanceInput>;
  action?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  options?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RulesOrderByWithRelationInput = {
  _relevance?: Maybe<RulesOrderByRelevanceInput>;
  action?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  options?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum RulesScalarFieldEnum {
  Action = 'action',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Options = 'options',
  UpdatedAt = 'updatedAt'
}

export type RulesScalarWhereInput = {
  AND?: Maybe<Array<RulesScalarWhereInput>>;
  NOT?: Maybe<Array<RulesScalarWhereInput>>;
  OR?: Maybe<Array<RulesScalarWhereInput>>;
  action?: Maybe<EnumRuleActionsFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  options?: Maybe<JsonFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type RulesScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<RulesScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<RulesScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<RulesScalarWhereWithAggregatesInput>>;
  action?: Maybe<EnumRuleActionsWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  options?: Maybe<JsonWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type RulesUncheckedCreateInput = {
  action?: Maybe<RuleActions>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<RulesWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RulesCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<RulesCreateWithoutClinicInput>>;
  createMany?: Maybe<RulesCreateManyClinicInputEnvelope>;
};

export type RulesUncheckedCreateWithoutClinicInput = {
  action?: Maybe<RuleActions>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesUncheckedUpdateInput = {
  action?: Maybe<RuleActions>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesUncheckedUpdateManyInput = {
  action?: Maybe<RuleActions>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesUncheckedUpdateManyWithoutClinicInput = {
  action?: Maybe<RuleActions>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<RulesWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RulesCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<RulesCreateWithoutClinicInput>>;
  createMany?: Maybe<RulesCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<RulesWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RulesScalarWhereInput>>;
  disconnect?: Maybe<Array<RulesWhereUniqueInput>>;
  set?: Maybe<Array<RulesWhereUniqueInput>>;
  update?: Maybe<Array<RulesUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<RulesUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<RulesUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type RulesUncheckedUpdateWithoutClinicInput = {
  action?: Maybe<RuleActions>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesUpdateInput = {
  action?: Maybe<RuleActions>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutRulesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesUpdateManyMutationInput = {
  action?: Maybe<RuleActions>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesUpdateManyWithWhereWithoutClinicInput = {
  data: RulesUpdateManyMutationInput;
  where: RulesScalarWhereInput;
};

export type RulesUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<RulesWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RulesCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<RulesCreateWithoutClinicInput>>;
  createMany?: Maybe<RulesCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<RulesWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RulesScalarWhereInput>>;
  disconnect?: Maybe<Array<RulesWhereUniqueInput>>;
  set?: Maybe<Array<RulesWhereUniqueInput>>;
  update?: Maybe<Array<RulesUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<RulesUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<RulesUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type RulesUpdateWithWhereUniqueWithoutClinicInput = {
  data: RulesUpdateWithoutClinicInput;
  where: RulesWhereUniqueInput;
};

export type RulesUpdateWithoutClinicInput = {
  action?: Maybe<RuleActions>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RulesUpsertWithWhereUniqueWithoutClinicInput = {
  create: RulesCreateWithoutClinicInput;
  update: RulesUpdateWithoutClinicInput;
  where: RulesWhereUniqueInput;
};

export type RulesWhereInput = {
  AND?: Maybe<Array<RulesWhereInput>>;
  NOT?: Maybe<Array<RulesWhereInput>>;
  OR?: Maybe<Array<RulesWhereInput>>;
  action?: Maybe<EnumRuleActionsFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  options?: Maybe<JsonFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type RulesWhereUniqueInput = {
  AND?: Maybe<Array<RulesWhereInput>>;
  NOT?: Maybe<Array<RulesWhereInput>>;
  OR?: Maybe<Array<RulesWhereInput>>;
  action?: Maybe<EnumRuleActionsFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<JsonFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SalesforceAccount = {
  __typename?: 'SalesforceAccount';
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  levenshteinDistance?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  salesforceAccountId?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  source: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export enum SalesforceSource {
  CurrentEnvironment = 'CURRENT_ENVIRONMENT',
  Redshift = 'REDSHIFT'
}

export type SaveEmailTemplateVersionInput = {
  design: Scalars['Json'];
  emailTemplateVersionId: Scalars['String'];
  html: Scalars['String'];
  shouldPublish?: Maybe<Scalars['Boolean']>;
};

export type Schedule = {
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['DateTime'];
};

export type SearchChannelInput = {
  and?: Maybe<Array<Maybe<SearchChannelInput>>>;
  appointmentClinicEmployeeIds?: Maybe<Array<Scalars['String']>>;
  appointmentRoomIds?: Maybe<Array<Scalars['String']>>;
  appointmentTypeIds?: Maybe<Array<Scalars['String']>>;
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  assigneeNames?: Maybe<Scalars['String']>;
  channelPinUserIds?: Maybe<Array<Scalars['String']>>;
  channelStatusAction?: Maybe<Scalars['String']>;
  channelStatusIds?: Maybe<Array<Scalars['String']>>;
  channelStatusName?: Maybe<Scalars['String']>;
  channelType?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  excludedChannelPinUserIds?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['String']>;
  idIn?: Maybe<Array<Scalars['String']>>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isUnassigned?: Maybe<Scalars['Boolean']>;
  messageBodies?: Maybe<Scalars['String']>;
  or?: Maybe<Array<Maybe<SearchChannelInput>>>;
  petNames?: Maybe<Scalars['String']>;
  petParentNames?: Maybe<Scalars['String']>;
  tagNames?: Maybe<Array<Scalars['String']>>;
  uniqueName?: Maybe<Scalars['String']>;
  userNames?: Maybe<Scalars['String']>;
};

export type SearchClinicPetInput = {
  name?: Maybe<Scalars['String']>;
  petParentNames?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
};

export type SearchClinicPetParentInput = {
  and?: Maybe<Array<Maybe<SearchClinicPetParentInput>>>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  or?: Maybe<Array<Maybe<SearchClinicPetParentInput>>>;
  petNames?: Maybe<Scalars['String']>;
  petPimsIds?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
};

export type SearchPhoneNumberInput = {
  code: Scalars['String'];
  quantity: Scalars['String'];
};

export type SearchPhoneNumberResponse = {
  __typename?: 'SearchPhoneNumberResponse';
  phoneNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  total?: Maybe<Scalars['Int']>;
};

export type SearchTwilioNumbersInput = {
  areaCode?: Maybe<Scalars['String']>;
};

export type Segment = {
  __typename?: 'Segment';
  definitionVariables?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  model: SegmentModelType;
  name: Scalars['String'];
  prismaDefinition?: Maybe<Scalars['Json']>;
  rawSqlDefinition?: Maybe<Scalars['String']>;
  sortingOrder: Scalars['Int'];
  type: SegmentType;
};

export type SegmentAvgAggregateOutputType = {
  __typename?: 'SegmentAvgAggregateOutputType';
  sortingOrder?: Maybe<Scalars['Float']>;
};

export type SegmentAvgOrderByAggregateInput = {
  sortingOrder?: Maybe<SortOrder>;
};

export type SegmentBuilderDefinitionVariablesInput = {
  staticVariables: Scalars['Json'];
};

export type SegmentCountAggregateOutputType = {
  __typename?: 'SegmentCountAggregateOutputType';
  _all: Scalars['Int'];
  definitionVariables: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  model: Scalars['Int'];
  name: Scalars['Int'];
  prismaDefinition: Scalars['Int'];
  rawSqlDefinition: Scalars['Int'];
  sortingOrder: Scalars['Int'];
  type: Scalars['Int'];
};

export type SegmentCountOrderByAggregateInput = {
  definitionVariables?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  prismaDefinition?: Maybe<SortOrder>;
  rawSqlDefinition?: Maybe<SortOrder>;
  sortingOrder?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type SegmentCreateInput = {
  definitionVariables?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  model: SegmentModelType;
  name: Scalars['String'];
  prismaDefinition?: Maybe<Scalars['Json']>;
  rawSqlDefinition?: Maybe<Scalars['String']>;
  sortingOrder: Scalars['Int'];
  type: SegmentType;
};

export type SegmentCreateManyInput = {
  definitionVariables?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  model: SegmentModelType;
  name: Scalars['String'];
  prismaDefinition?: Maybe<Scalars['Json']>;
  rawSqlDefinition?: Maybe<Scalars['String']>;
  sortingOrder: Scalars['Int'];
  type: SegmentType;
};

export type SegmentGroupByOutputType = {
  __typename?: 'SegmentGroupByOutputType';
  _avg?: Maybe<SegmentAvgAggregateOutputType>;
  _count?: Maybe<SegmentCountAggregateOutputType>;
  _max?: Maybe<SegmentMaxAggregateOutputType>;
  _min?: Maybe<SegmentMinAggregateOutputType>;
  _sum?: Maybe<SegmentSumAggregateOutputType>;
  definitionVariables?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  model: SegmentModelType;
  name: Scalars['String'];
  prismaDefinition?: Maybe<Scalars['Json']>;
  rawSqlDefinition?: Maybe<Scalars['String']>;
  sortingOrder: Scalars['Int'];
  type: SegmentType;
};

export type SegmentMaxAggregateOutputType = {
  __typename?: 'SegmentMaxAggregateOutputType';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  model?: Maybe<SegmentModelType>;
  name?: Maybe<Scalars['String']>;
  rawSqlDefinition?: Maybe<Scalars['String']>;
  sortingOrder?: Maybe<Scalars['Int']>;
  type?: Maybe<SegmentType>;
};

export type SegmentMaxOrderByAggregateInput = {
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  rawSqlDefinition?: Maybe<SortOrder>;
  sortingOrder?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type SegmentMinAggregateOutputType = {
  __typename?: 'SegmentMinAggregateOutputType';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  model?: Maybe<SegmentModelType>;
  name?: Maybe<Scalars['String']>;
  rawSqlDefinition?: Maybe<Scalars['String']>;
  sortingOrder?: Maybe<Scalars['Int']>;
  type?: Maybe<SegmentType>;
};

export type SegmentMinOrderByAggregateInput = {
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  rawSqlDefinition?: Maybe<SortOrder>;
  sortingOrder?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export enum SegmentModelType {
  ClinicPetParent = 'ClinicPetParent'
}

export type SegmentOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SegmentOrderByRelevanceInput>;
  definitionVariables?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  prismaDefinition?: Maybe<SortOrder>;
  rawSqlDefinition?: Maybe<SortOrder>;
  sortingOrder?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export enum SegmentOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  Name = 'name',
  RawSqlDefinition = 'rawSqlDefinition'
}

export type SegmentOrderByRelevanceInput = {
  fields: Array<SegmentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type SegmentOrderByWithAggregationInput = {
  _avg?: Maybe<SegmentAvgOrderByAggregateInput>;
  _count?: Maybe<SegmentCountOrderByAggregateInput>;
  _max?: Maybe<SegmentMaxOrderByAggregateInput>;
  _min?: Maybe<SegmentMinOrderByAggregateInput>;
  _sum?: Maybe<SegmentSumOrderByAggregateInput>;
  definitionVariables?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  prismaDefinition?: Maybe<SortOrder>;
  rawSqlDefinition?: Maybe<SortOrder>;
  sortingOrder?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type SegmentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SegmentOrderByRelevanceInput>;
  definitionVariables?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  prismaDefinition?: Maybe<SortOrder>;
  rawSqlDefinition?: Maybe<SortOrder>;
  sortingOrder?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type SegmentOrderByWithRelationInput = {
  _relevance?: Maybe<SegmentOrderByRelevanceInput>;
  definitionVariables?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  prismaDefinition?: Maybe<SortOrder>;
  rawSqlDefinition?: Maybe<SortOrder>;
  sortingOrder?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export enum SegmentScalarFieldEnum {
  DefinitionVariables = 'definitionVariables',
  Description = 'description',
  Id = 'id',
  Model = 'model',
  Name = 'name',
  PrismaDefinition = 'prismaDefinition',
  RawSqlDefinition = 'rawSqlDefinition',
  SortingOrder = 'sortingOrder',
  Type = 'type'
}

export type SegmentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SegmentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SegmentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SegmentScalarWhereWithAggregatesInput>>;
  definitionVariables?: Maybe<JsonNullableWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  model?: Maybe<EnumSegmentModelTypeWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  prismaDefinition?: Maybe<JsonNullableWithAggregatesFilter>;
  rawSqlDefinition?: Maybe<StringNullableWithAggregatesFilter>;
  sortingOrder?: Maybe<IntWithAggregatesFilter>;
  type?: Maybe<EnumSegmentTypeWithAggregatesFilter>;
};

export type SegmentSumAggregateOutputType = {
  __typename?: 'SegmentSumAggregateOutputType';
  sortingOrder?: Maybe<Scalars['Int']>;
};

export type SegmentSumOrderByAggregateInput = {
  sortingOrder?: Maybe<SortOrder>;
};

export enum SegmentType {
  Clinic = 'Clinic',
  ClinicRawSql = 'ClinicRawSql',
  System = 'System',
  SystemRawSql = 'SystemRawSql'
}

export type SegmentUncheckedCreateInput = {
  definitionVariables?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  model: SegmentModelType;
  name: Scalars['String'];
  prismaDefinition?: Maybe<Scalars['Json']>;
  rawSqlDefinition?: Maybe<Scalars['String']>;
  sortingOrder: Scalars['Int'];
  type: SegmentType;
};

export type SegmentUncheckedUpdateInput = {
  definitionVariables?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  model?: Maybe<SegmentModelType>;
  name?: Maybe<Scalars['String']>;
  prismaDefinition?: Maybe<Scalars['Json']>;
  rawSqlDefinition?: Maybe<Scalars['String']>;
  sortingOrder?: Maybe<Scalars['Int']>;
  type?: Maybe<SegmentType>;
};

export type SegmentUncheckedUpdateManyInput = {
  definitionVariables?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  model?: Maybe<SegmentModelType>;
  name?: Maybe<Scalars['String']>;
  prismaDefinition?: Maybe<Scalars['Json']>;
  rawSqlDefinition?: Maybe<Scalars['String']>;
  sortingOrder?: Maybe<Scalars['Int']>;
  type?: Maybe<SegmentType>;
};

export type SegmentUpdateInput = {
  definitionVariables?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  model?: Maybe<SegmentModelType>;
  name?: Maybe<Scalars['String']>;
  prismaDefinition?: Maybe<Scalars['Json']>;
  rawSqlDefinition?: Maybe<Scalars['String']>;
  sortingOrder?: Maybe<Scalars['Int']>;
  type?: Maybe<SegmentType>;
};

export type SegmentUpdateManyMutationInput = {
  definitionVariables?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  model?: Maybe<SegmentModelType>;
  name?: Maybe<Scalars['String']>;
  prismaDefinition?: Maybe<Scalars['Json']>;
  rawSqlDefinition?: Maybe<Scalars['String']>;
  sortingOrder?: Maybe<Scalars['Int']>;
  type?: Maybe<SegmentType>;
};

export type SegmentWhereInput = {
  AND?: Maybe<Array<SegmentWhereInput>>;
  NOT?: Maybe<Array<SegmentWhereInput>>;
  OR?: Maybe<Array<SegmentWhereInput>>;
  definitionVariables?: Maybe<JsonNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  model?: Maybe<EnumSegmentModelTypeFilter>;
  name?: Maybe<StringFilter>;
  prismaDefinition?: Maybe<JsonNullableFilter>;
  rawSqlDefinition?: Maybe<StringNullableFilter>;
  sortingOrder?: Maybe<IntFilter>;
  type?: Maybe<EnumSegmentTypeFilter>;
};

export type SegmentWhereUniqueInput = {
  AND?: Maybe<Array<SegmentWhereInput>>;
  NOT?: Maybe<Array<SegmentWhereInput>>;
  OR?: Maybe<Array<SegmentWhereInput>>;
  definitionVariables?: Maybe<JsonNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  model?: Maybe<EnumSegmentModelTypeFilter>;
  name?: Maybe<StringFilter>;
  prismaDefinition?: Maybe<JsonNullableFilter>;
  rawSqlDefinition?: Maybe<StringNullableFilter>;
  sortingOrder?: Maybe<IntFilter>;
  type?: Maybe<EnumSegmentTypeFilter>;
};

export type SegmentsArgsInput = {
  conditionalSegments?: Maybe<Array<Maybe<ConditionalSegmentsInput>>>;
};

export type SendCareSignUpEmailInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type SendCareSignUpEmailOutput = {
  __typename?: 'SendCareSignUpEmailOutput';
  success: Scalars['Boolean'];
};

export type SendCareSignUpEmailResult = {
  __typename?: 'SendCareSignUpEmailResult';
  success: Scalars['Boolean'];
};

export type SendClinicPetParentAuthCodeRequest = {
  clinicId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  queryParams?: Maybe<Scalars['Json']>;
};

export type SendClinicPetParentAuthCodeResponse = {
  __typename?: 'SendClinicPetParentAuthCodeResponse';
  message: Scalars['String'];
  requestId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SendClinicPetParentAuthLinkRequest = {
  clinicId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  isDeepLink?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  queryParams?: Maybe<Scalars['Json']>;
};

export type SendConsultationReceiptInput = {
  consultationFirebaseId: Scalars['String'];
  consultationId: Scalars['String'];
  emails: Array<Scalars['String']>;
  firebaseId: Scalars['String'];
};

export type SendEnrollmentEmailInput = {
  careStripeSubscriptionId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
};

export type SendEnrollmentEmailOutput = {
  __typename?: 'SendEnrollmentEmailOutput';
  success: Scalars['Boolean'];
};

export type SendPaymentToTerminalResponse = {
  __typename?: 'SendPaymentToTerminalResponse';
  success: Scalars['Boolean'];
  terminal: StripeTerminal;
};

export type SendPetParentReceiptInput = {
  consultationId: Scalars['String'];
  firebaseId: Scalars['String'];
};

export type SendWidgetCodeToDeveloperInput = {
  ccEmailAddresses?: Maybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type SentTrupanionExamDayOffer = {
  __typename?: 'SentTrupanionExamDayOffer';
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentType>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  clinicUser?: Maybe<User>;
  createdAt: Scalars['DateTime'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegration: TrupanionIntegration;
  trupanionIntegrationId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type SentTrupanionExamDayOfferAppointmentTypeArgs = {
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type SentTrupanionExamDayOfferClinicUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type SentTrupanionExamDayOfferCountAggregateOutputType = {
  __typename?: 'SentTrupanionExamDayOfferCountAggregateOutputType';
  _all: Scalars['Int'];
  activationDate: Scalars['Int'];
  appointmentTypeId: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  expirationDate: Scalars['Int'];
  id: Scalars['Int'];
  referenceNumber: Scalars['Int'];
  sentByClinicUserId: Scalars['Int'];
  trupanionIntegrationId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SentTrupanionExamDayOfferCountOrderByAggregateInput = {
  activationDate?: Maybe<SortOrder>;
  appointmentTypeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  referenceNumber?: Maybe<SortOrder>;
  sentByClinicUserId?: Maybe<SortOrder>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SentTrupanionExamDayOfferCreateInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutRelatedTrupanionExamDayOffersInput>;
  clinic: ClinicCreateNestedOneWithoutSentTrupanionExamDayOffersInput;
  clinicPet: ClinicPetCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput;
  clinicUser?: Maybe<UserCreateNestedOneWithoutSentTrupanionExamDayOffersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  trupanionIntegration: TrupanionIntegrationCreateNestedOneWithoutSentTrupanionExamDayOffersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateManyAppointmentTypeInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateManyAppointmentTypeInputEnvelope = {
  data: Array<SentTrupanionExamDayOfferCreateManyAppointmentTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SentTrupanionExamDayOfferCreateManyClinicInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateManyClinicInputEnvelope = {
  data: Array<SentTrupanionExamDayOfferCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SentTrupanionExamDayOfferCreateManyClinicPetInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateManyClinicPetInputEnvelope = {
  data: Array<SentTrupanionExamDayOfferCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SentTrupanionExamDayOfferCreateManyClinicPetParentInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateManyClinicPetParentInputEnvelope = {
  data: Array<SentTrupanionExamDayOfferCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SentTrupanionExamDayOfferCreateManyClinicUserInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateManyClinicUserInputEnvelope = {
  data: Array<SentTrupanionExamDayOfferCreateManyClinicUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SentTrupanionExamDayOfferCreateManyInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateManyTrupanionIntegrationInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateManyTrupanionIntegrationInputEnvelope = {
  data: Array<SentTrupanionExamDayOfferCreateManyTrupanionIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SentTrupanionExamDayOfferCreateNestedManyWithoutAppointmentTypeInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyAppointmentTypeInputEnvelope>;
};

export type SentTrupanionExamDayOfferCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicInputEnvelope>;
};

export type SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicPetInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicPetInputEnvelope>;
};

export type SentTrupanionExamDayOfferCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicPetParentInputEnvelope>;
};

export type SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicUserInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicUserInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicUserInputEnvelope>;
};

export type SentTrupanionExamDayOfferCreateNestedManyWithoutTrupanionIntegrationInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutTrupanionIntegrationInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutTrupanionIntegrationInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyTrupanionIntegrationInputEnvelope>;
};

export type SentTrupanionExamDayOfferCreateOrConnectWithoutAppointmentTypeInput = {
  create: SentTrupanionExamDayOfferCreateWithoutAppointmentTypeInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferCreateOrConnectWithoutClinicInput = {
  create: SentTrupanionExamDayOfferCreateWithoutClinicInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferCreateOrConnectWithoutClinicPetInput = {
  create: SentTrupanionExamDayOfferCreateWithoutClinicPetInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferCreateOrConnectWithoutClinicPetParentInput = {
  create: SentTrupanionExamDayOfferCreateWithoutClinicPetParentInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferCreateOrConnectWithoutClinicUserInput = {
  create: SentTrupanionExamDayOfferCreateWithoutClinicUserInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferCreateOrConnectWithoutTrupanionIntegrationInput = {
  create: SentTrupanionExamDayOfferCreateWithoutTrupanionIntegrationInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferCreateWithoutAppointmentTypeInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  clinic: ClinicCreateNestedOneWithoutSentTrupanionExamDayOffersInput;
  clinicPet: ClinicPetCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput;
  clinicUser?: Maybe<UserCreateNestedOneWithoutSentTrupanionExamDayOffersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  trupanionIntegration: TrupanionIntegrationCreateNestedOneWithoutSentTrupanionExamDayOffersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateWithoutClinicInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutRelatedTrupanionExamDayOffersInput>;
  clinicPet: ClinicPetCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput;
  clinicUser?: Maybe<UserCreateNestedOneWithoutSentTrupanionExamDayOffersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  trupanionIntegration: TrupanionIntegrationCreateNestedOneWithoutSentTrupanionExamDayOffersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateWithoutClinicPetInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutRelatedTrupanionExamDayOffersInput>;
  clinic: ClinicCreateNestedOneWithoutSentTrupanionExamDayOffersInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput;
  clinicUser?: Maybe<UserCreateNestedOneWithoutSentTrupanionExamDayOffersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  trupanionIntegration: TrupanionIntegrationCreateNestedOneWithoutSentTrupanionExamDayOffersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateWithoutClinicPetParentInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutRelatedTrupanionExamDayOffersInput>;
  clinic: ClinicCreateNestedOneWithoutSentTrupanionExamDayOffersInput;
  clinicPet: ClinicPetCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput;
  clinicUser?: Maybe<UserCreateNestedOneWithoutSentTrupanionExamDayOffersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  trupanionIntegration: TrupanionIntegrationCreateNestedOneWithoutSentTrupanionExamDayOffersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateWithoutClinicUserInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutRelatedTrupanionExamDayOffersInput>;
  clinic: ClinicCreateNestedOneWithoutSentTrupanionExamDayOffersInput;
  clinicPet: ClinicPetCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  trupanionIntegration: TrupanionIntegrationCreateNestedOneWithoutSentTrupanionExamDayOffersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferCreateWithoutTrupanionIntegrationInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentTypeCreateNestedOneWithoutRelatedTrupanionExamDayOffersInput>;
  clinic: ClinicCreateNestedOneWithoutSentTrupanionExamDayOffersInput;
  clinicPet: ClinicPetCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutReceivedTrupanionExamDayOffersInput;
  clinicUser?: Maybe<UserCreateNestedOneWithoutSentTrupanionExamDayOffersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferGroupByOutputType = {
  __typename?: 'SentTrupanionExamDayOfferGroupByOutputType';
  _count?: Maybe<SentTrupanionExamDayOfferCountAggregateOutputType>;
  _max?: Maybe<SentTrupanionExamDayOfferMaxAggregateOutputType>;
  _min?: Maybe<SentTrupanionExamDayOfferMinAggregateOutputType>;
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SentTrupanionExamDayOfferListRelationFilter = {
  every?: Maybe<SentTrupanionExamDayOfferWhereInput>;
  none?: Maybe<SentTrupanionExamDayOfferWhereInput>;
  some?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};

export type SentTrupanionExamDayOfferMaxAggregateOutputType = {
  __typename?: 'SentTrupanionExamDayOfferMaxAggregateOutputType';
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferMaxOrderByAggregateInput = {
  activationDate?: Maybe<SortOrder>;
  appointmentTypeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  referenceNumber?: Maybe<SortOrder>;
  sentByClinicUserId?: Maybe<SortOrder>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SentTrupanionExamDayOfferMinAggregateOutputType = {
  __typename?: 'SentTrupanionExamDayOfferMinAggregateOutputType';
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferMinOrderByAggregateInput = {
  activationDate?: Maybe<SortOrder>;
  appointmentTypeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  referenceNumber?: Maybe<SortOrder>;
  sentByClinicUserId?: Maybe<SortOrder>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SentTrupanionExamDayOfferOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SentTrupanionExamDayOfferOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SentTrupanionExamDayOfferOrderByRelevanceInput>;
  activationDate?: Maybe<SortOrder>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicUser?: Maybe<UserOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  referenceNumber?: Maybe<SortOrder>;
  sentByClinicUserId?: Maybe<SortOrder>;
  trupanionIntegration?: Maybe<TrupanionIntegrationOrderByWithRelationInput>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SentTrupanionExamDayOfferOrderByRelevanceFieldEnum {
  AppointmentTypeId = 'appointmentTypeId',
  ClinicId = 'clinicId',
  ClinicPetId = 'clinicPetId',
  ClinicPetParentId = 'clinicPetParentId',
  Id = 'id',
  ReferenceNumber = 'referenceNumber',
  SentByClinicUserId = 'sentByClinicUserId',
  TrupanionIntegrationId = 'trupanionIntegrationId'
}

export type SentTrupanionExamDayOfferOrderByRelevanceInput = {
  fields: Array<SentTrupanionExamDayOfferOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type SentTrupanionExamDayOfferOrderByWithAggregationInput = {
  _count?: Maybe<SentTrupanionExamDayOfferCountOrderByAggregateInput>;
  _max?: Maybe<SentTrupanionExamDayOfferMaxOrderByAggregateInput>;
  _min?: Maybe<SentTrupanionExamDayOfferMinOrderByAggregateInput>;
  activationDate?: Maybe<SortOrder>;
  appointmentTypeId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  referenceNumber?: Maybe<SortOrder>;
  sentByClinicUserId?: Maybe<SortOrder>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SentTrupanionExamDayOfferOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SentTrupanionExamDayOfferOrderByRelevanceInput>;
  activationDate?: Maybe<SortOrder>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicUser?: Maybe<UserOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  referenceNumber?: Maybe<SortOrder>;
  sentByClinicUserId?: Maybe<SortOrder>;
  trupanionIntegration?: Maybe<TrupanionIntegrationOrderByWithRelationInput>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SentTrupanionExamDayOfferOrderByWithRelationInput = {
  _relevance?: Maybe<SentTrupanionExamDayOfferOrderByRelevanceInput>;
  activationDate?: Maybe<SortOrder>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicUser?: Maybe<UserOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  referenceNumber?: Maybe<SortOrder>;
  sentByClinicUserId?: Maybe<SortOrder>;
  trupanionIntegration?: Maybe<TrupanionIntegrationOrderByWithRelationInput>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SentTrupanionExamDayOfferScalarFieldEnum {
  ActivationDate = 'activationDate',
  AppointmentTypeId = 'appointmentTypeId',
  ClinicId = 'clinicId',
  ClinicPetId = 'clinicPetId',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  ExpirationDate = 'expirationDate',
  Id = 'id',
  ReferenceNumber = 'referenceNumber',
  SentByClinicUserId = 'sentByClinicUserId',
  TrupanionIntegrationId = 'trupanionIntegrationId',
  UpdatedAt = 'updatedAt'
}

export type SentTrupanionExamDayOfferScalarWhereInput = {
  AND?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  NOT?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  OR?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  activationDate?: Maybe<DateTimeNullableFilter>;
  appointmentTypeId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetId?: Maybe<StringFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  referenceNumber?: Maybe<StringFilter>;
  sentByClinicUserId?: Maybe<StringNullableFilter>;
  trupanionIntegrationId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SentTrupanionExamDayOfferScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereWithAggregatesInput>>;
  activationDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  appointmentTypeId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  clinicPetId?: Maybe<StringWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  expirationDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  referenceNumber?: Maybe<StringWithAggregatesFilter>;
  sentByClinicUserId?: Maybe<StringNullableWithAggregatesFilter>;
  trupanionIntegrationId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type SentTrupanionExamDayOfferUncheckedCreateInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutAppointmentTypeInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyAppointmentTypeInputEnvelope>;
};

export type SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicInputEnvelope>;
};

export type SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicPetInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicPetInputEnvelope>;
};

export type SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicPetParentInputEnvelope>;
};

export type SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicUserInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicUserInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicUserInputEnvelope>;
};

export type SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutTrupanionIntegrationInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutTrupanionIntegrationInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutTrupanionIntegrationInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyTrupanionIntegrationInputEnvelope>;
};

export type SentTrupanionExamDayOfferUncheckedCreateWithoutAppointmentTypeInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedCreateWithoutClinicInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedCreateWithoutClinicPetInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedCreateWithoutClinicPetParentInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedCreateWithoutClinicUserInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedCreateWithoutTrupanionIntegrationInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  sentByClinicUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyAppointmentTypeInputEnvelope>;
  delete?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  disconnect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  set?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  update?: Maybe<Array<SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutAppointmentTypeInput>>;
  updateMany?: Maybe<Array<SentTrupanionExamDayOfferUpdateManyWithWhereWithoutAppointmentTypeInput>>;
  upsert?: Maybe<Array<SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutAppointmentTypeInput>>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  disconnect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  set?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  update?: Maybe<Array<SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<SentTrupanionExamDayOfferUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicPetInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  disconnect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  set?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  update?: Maybe<Array<SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<SentTrupanionExamDayOfferUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  disconnect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  set?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  update?: Maybe<Array<SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<SentTrupanionExamDayOfferUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicUserInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicUserInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicUserInputEnvelope>;
  delete?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  disconnect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  set?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  update?: Maybe<Array<SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutClinicUserInput>>;
  updateMany?: Maybe<Array<SentTrupanionExamDayOfferUpdateManyWithWhereWithoutClinicUserInput>>;
  upsert?: Maybe<Array<SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutClinicUserInput>>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyWithoutTrupanionIntegrationInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateManyWithoutTrupanionIntegrationNestedInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutTrupanionIntegrationInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutTrupanionIntegrationInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyTrupanionIntegrationInputEnvelope>;
  delete?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  disconnect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  set?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  update?: Maybe<Array<SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutTrupanionIntegrationInput>>;
  updateMany?: Maybe<Array<SentTrupanionExamDayOfferUpdateManyWithWhereWithoutTrupanionIntegrationInput>>;
  upsert?: Maybe<Array<SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutTrupanionIntegrationInput>>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateWithoutAppointmentTypeInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateWithoutClinicInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateWithoutClinicPetInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateWithoutClinicPetParentInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateWithoutClinicUserInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUncheckedUpdateWithoutTrupanionIntegrationInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  sentByClinicUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUpdateInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutRelatedTrupanionExamDayOffersNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput>;
  clinicUser?: Maybe<UserUpdateOneWithoutSentTrupanionExamDayOffersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUpdateManyMutationInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUpdateManyWithWhereWithoutAppointmentTypeInput = {
  data: SentTrupanionExamDayOfferUpdateManyMutationInput;
  where: SentTrupanionExamDayOfferScalarWhereInput;
};

export type SentTrupanionExamDayOfferUpdateManyWithWhereWithoutClinicInput = {
  data: SentTrupanionExamDayOfferUpdateManyMutationInput;
  where: SentTrupanionExamDayOfferScalarWhereInput;
};

export type SentTrupanionExamDayOfferUpdateManyWithWhereWithoutClinicPetInput = {
  data: SentTrupanionExamDayOfferUpdateManyMutationInput;
  where: SentTrupanionExamDayOfferScalarWhereInput;
};

export type SentTrupanionExamDayOfferUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: SentTrupanionExamDayOfferUpdateManyMutationInput;
  where: SentTrupanionExamDayOfferScalarWhereInput;
};

export type SentTrupanionExamDayOfferUpdateManyWithWhereWithoutClinicUserInput = {
  data: SentTrupanionExamDayOfferUpdateManyMutationInput;
  where: SentTrupanionExamDayOfferScalarWhereInput;
};

export type SentTrupanionExamDayOfferUpdateManyWithWhereWithoutTrupanionIntegrationInput = {
  data: SentTrupanionExamDayOfferUpdateManyMutationInput;
  where: SentTrupanionExamDayOfferScalarWhereInput;
};

export type SentTrupanionExamDayOfferUpdateManyWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyAppointmentTypeInputEnvelope>;
  delete?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  disconnect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  set?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  update?: Maybe<Array<SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutAppointmentTypeInput>>;
  updateMany?: Maybe<Array<SentTrupanionExamDayOfferUpdateManyWithWhereWithoutAppointmentTypeInput>>;
  upsert?: Maybe<Array<SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutAppointmentTypeInput>>;
};

export type SentTrupanionExamDayOfferUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  disconnect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  set?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  update?: Maybe<Array<SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<SentTrupanionExamDayOfferUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type SentTrupanionExamDayOfferUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicPetInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  disconnect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  set?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  update?: Maybe<Array<SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<SentTrupanionExamDayOfferUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type SentTrupanionExamDayOfferUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  disconnect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  set?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  update?: Maybe<Array<SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<SentTrupanionExamDayOfferUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutClinicUserInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutClinicUserInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyClinicUserInputEnvelope>;
  delete?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  disconnect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  set?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  update?: Maybe<Array<SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutClinicUserInput>>;
  updateMany?: Maybe<Array<SentTrupanionExamDayOfferUpdateManyWithWhereWithoutClinicUserInput>>;
  upsert?: Maybe<Array<SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutClinicUserInput>>;
};

export type SentTrupanionExamDayOfferUpdateManyWithoutTrupanionIntegrationNestedInput = {
  connect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SentTrupanionExamDayOfferCreateOrConnectWithoutTrupanionIntegrationInput>>;
  create?: Maybe<Array<SentTrupanionExamDayOfferCreateWithoutTrupanionIntegrationInput>>;
  createMany?: Maybe<SentTrupanionExamDayOfferCreateManyTrupanionIntegrationInputEnvelope>;
  delete?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SentTrupanionExamDayOfferScalarWhereInput>>;
  disconnect?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  set?: Maybe<Array<SentTrupanionExamDayOfferWhereUniqueInput>>;
  update?: Maybe<Array<SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutTrupanionIntegrationInput>>;
  updateMany?: Maybe<Array<SentTrupanionExamDayOfferUpdateManyWithWhereWithoutTrupanionIntegrationInput>>;
  upsert?: Maybe<Array<SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutTrupanionIntegrationInput>>;
};

export type SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutAppointmentTypeInput = {
  data: SentTrupanionExamDayOfferUpdateWithoutAppointmentTypeInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutClinicInput = {
  data: SentTrupanionExamDayOfferUpdateWithoutClinicInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: SentTrupanionExamDayOfferUpdateWithoutClinicPetInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: SentTrupanionExamDayOfferUpdateWithoutClinicPetParentInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutClinicUserInput = {
  data: SentTrupanionExamDayOfferUpdateWithoutClinicUserInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferUpdateWithWhereUniqueWithoutTrupanionIntegrationInput = {
  data: SentTrupanionExamDayOfferUpdateWithoutTrupanionIntegrationInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferUpdateWithoutAppointmentTypeInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput>;
  clinicUser?: Maybe<UserUpdateOneWithoutSentTrupanionExamDayOffersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUpdateWithoutClinicInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutRelatedTrupanionExamDayOffersNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput>;
  clinicUser?: Maybe<UserUpdateOneWithoutSentTrupanionExamDayOffersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUpdateWithoutClinicPetInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutRelatedTrupanionExamDayOffersNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput>;
  clinicUser?: Maybe<UserUpdateOneWithoutSentTrupanionExamDayOffersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUpdateWithoutClinicPetParentInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutRelatedTrupanionExamDayOffersNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput>;
  clinicUser?: Maybe<UserUpdateOneWithoutSentTrupanionExamDayOffersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUpdateWithoutClinicUserInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutRelatedTrupanionExamDayOffersNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUpdateWithoutTrupanionIntegrationInput = {
  activationDate?: Maybe<Scalars['DateTime']>;
  appointmentType?: Maybe<AppointmentTypeUpdateOneWithoutRelatedTrupanionExamDayOffersNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutReceivedTrupanionExamDayOffersNestedInput>;
  clinicUser?: Maybe<UserUpdateOneWithoutSentTrupanionExamDayOffersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutAppointmentTypeInput = {
  create: SentTrupanionExamDayOfferCreateWithoutAppointmentTypeInput;
  update: SentTrupanionExamDayOfferUpdateWithoutAppointmentTypeInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutClinicInput = {
  create: SentTrupanionExamDayOfferCreateWithoutClinicInput;
  update: SentTrupanionExamDayOfferUpdateWithoutClinicInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: SentTrupanionExamDayOfferCreateWithoutClinicPetInput;
  update: SentTrupanionExamDayOfferUpdateWithoutClinicPetInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: SentTrupanionExamDayOfferCreateWithoutClinicPetParentInput;
  update: SentTrupanionExamDayOfferUpdateWithoutClinicPetParentInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutClinicUserInput = {
  create: SentTrupanionExamDayOfferCreateWithoutClinicUserInput;
  update: SentTrupanionExamDayOfferUpdateWithoutClinicUserInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferUpsertWithWhereUniqueWithoutTrupanionIntegrationInput = {
  create: SentTrupanionExamDayOfferCreateWithoutTrupanionIntegrationInput;
  update: SentTrupanionExamDayOfferUpdateWithoutTrupanionIntegrationInput;
  where: SentTrupanionExamDayOfferWhereUniqueInput;
};

export type SentTrupanionExamDayOfferWhereInput = {
  AND?: Maybe<Array<SentTrupanionExamDayOfferWhereInput>>;
  NOT?: Maybe<Array<SentTrupanionExamDayOfferWhereInput>>;
  OR?: Maybe<Array<SentTrupanionExamDayOfferWhereInput>>;
  activationDate?: Maybe<DateTimeNullableFilter>;
  appointmentType?: Maybe<AppointmentTypeNullableScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  clinicUser?: Maybe<UserNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  referenceNumber?: Maybe<StringFilter>;
  sentByClinicUserId?: Maybe<StringNullableFilter>;
  trupanionIntegration?: Maybe<TrupanionIntegrationScalarRelationFilter>;
  trupanionIntegrationId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SentTrupanionExamDayOfferWhereUniqueInput = {
  AND?: Maybe<Array<SentTrupanionExamDayOfferWhereInput>>;
  NOT?: Maybe<Array<SentTrupanionExamDayOfferWhereInput>>;
  OR?: Maybe<Array<SentTrupanionExamDayOfferWhereInput>>;
  activationDate?: Maybe<DateTimeNullableFilter>;
  appointmentType?: Maybe<AppointmentTypeNullableScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  clinicUser?: Maybe<UserNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<StringFilter>;
  sentByClinicUserId?: Maybe<StringNullableFilter>;
  trupanionIntegration?: Maybe<TrupanionIntegrationScalarRelationFilter>;
  trupanionIntegrationId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Service = {
  __typename?: 'Service';
  MedicalHistory: Array<MedicalHistory>;
  _count: ServiceCountOutputType;
  canonicalService?: Maybe<CanonicalService>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  draftCareBenefitUsageToInvoiceLineItems: Array<CareBenefitUsageToInvoiceLineItem>;
  formTemplate?: Maybe<FormTemplate>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders: Scalars['Boolean'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  invoiceLineItems: Array<InvoiceLineItem>;
  isDeleted: Scalars['Boolean'];
  isPetPortal: Scalars['Boolean'];
  isPostcard: Scalars['Boolean'];
  isReminderActive: Scalars['Boolean'];
  loyaltyPointGrantingServices: Array<LoyaltyPointGrantingService>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService: Array<OrganizationCareBenefitToClinicService>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions: Array<Prescription>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings: Array<ServiceReminderTiming>;
  reminders: Array<ServiceReminder>;
  serviceCategory?: Maybe<ServiceCategory>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries: Array<ServicePurchaseSummary>;
  taxonomy?: Maybe<Taxonomy>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vetsourceCodeTags: Array<VetsourceCodeTag>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategory>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};


export type ServiceMedicalHistoryArgs = {
  cursor?: Maybe<MedicalHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MedicalHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MedicalHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MedicalHistoryWhereInput>;
};


export type ServiceCanonicalServiceArgs = {
  where?: Maybe<CanonicalServiceWhereInput>;
};


export type ServiceDraftCareBenefitUsageToInvoiceLineItemsArgs = {
  cursor?: Maybe<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
};


export type ServiceFormTemplateArgs = {
  where?: Maybe<FormTemplateWhereInput>;
};


export type ServiceInvoiceLineItemsArgs = {
  cursor?: Maybe<InvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceLineItemWhereInput>;
};


export type ServiceLoyaltyPointGrantingServicesArgs = {
  cursor?: Maybe<LoyaltyPointGrantingServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointGrantingServiceWhereInput>;
};


export type ServiceOrganizationCareBenefitToClinicServiceArgs = {
  cursor?: Maybe<OrganizationCareBenefitToClinicServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationCareBenefitToClinicServiceWhereInput>;
};


export type ServicePrescriptionsArgs = {
  cursor?: Maybe<PrescriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PrescriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PrescriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PrescriptionWhereInput>;
};


export type ServiceReminderTimingsArgs = {
  cursor?: Maybe<ServiceReminderTimingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderTimingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderTimingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderTimingWhereInput>;
};


export type ServiceRemindersArgs = {
  cursor?: Maybe<ServiceReminderWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderWhereInput>;
};


export type ServiceServiceCategoryArgs = {
  where?: Maybe<ServiceCategoryWhereInput>;
};


export type ServiceServicePurchaseSummariesArgs = {
  cursor?: Maybe<ServicePurchaseSummaryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServicePurchaseSummaryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServicePurchaseSummaryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};


export type ServiceTaxonomyArgs = {
  where?: Maybe<TaxonomyWhereInput>;
};


export type ServiceVetsourceCodeTagsArgs = {
  cursor?: Maybe<VetsourceCodeTagWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourceCodeTagScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourceCodeTagOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceCodeTagWhereInput>;
};


export type ServiceVetsourceRevenueCategoryArgs = {
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};

export type ServiceAvgAggregateOutputType = {
  __typename?: 'ServiceAvgAggregateOutputType';
  vetsourceFreeDoses?: Maybe<Scalars['Float']>;
  vetsourcePaidDoses?: Maybe<Scalars['Float']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
};

export type ServiceAvgOrderByAggregateInput = {
  vetsourceFreeDoses?: Maybe<SortOrder>;
  vetsourcePaidDoses?: Maybe<SortOrder>;
  vetsourceQuantityOverride?: Maybe<SortOrder>;
};

export enum ServiceCapability {
  Mms = 'MMS',
  Sms = 'SMS',
  Voice = 'Voice'
}

export type ServiceCategory = {
  __typename?: 'ServiceCategory';
  _count: ServiceCategoryCountOutputType;
  childServiceCategoires: Array<ServiceCategory>;
  childServices: Array<Service>;
  connectedCareBenefits: Array<OrganizationCareBenefitToClinicServiceCategory>;
  description: Scalars['String'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  loyaltyPointGrantingServiceCategories: Array<LoyaltyPointGrantingServiceCategory>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategory>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};


export type ServiceCategoryChildServiceCategoiresArgs = {
  cursor?: Maybe<ServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceCategoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceCategoryWhereInput>;
};


export type ServiceCategoryChildServicesArgs = {
  cursor?: Maybe<ServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceWhereInput>;
};


export type ServiceCategoryConnectedCareBenefitsArgs = {
  cursor?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationCareBenefitToClinicServiceCategoryWhereInput>;
};


export type ServiceCategoryLoyaltyPointGrantingServiceCategoriesArgs = {
  cursor?: Maybe<LoyaltyPointGrantingServiceCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointGrantingServiceCategoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointGrantingServiceCategoryWhereInput>;
};


export type ServiceCategoryParentServiceCategoryArgs = {
  where?: Maybe<ServiceCategoryWhereInput>;
};

export type ServiceCategoryCountAggregateOutputType = {
  __typename?: 'ServiceCategoryCountAggregateOutputType';
  _all: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isDeleted: Scalars['Int'];
  parentCategoryPimsId: Scalars['Int'];
  parentServiceCategoryId: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  shortDescription: Scalars['Int'];
};

export type ServiceCategoryCountOrderByAggregateInput = {
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  parentCategoryPimsId?: Maybe<SortOrder>;
  parentServiceCategoryId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
};

export type ServiceCategoryCountOutputType = {
  __typename?: 'ServiceCategoryCountOutputType';
  childServiceCategoires: Scalars['Int'];
  childServices: Scalars['Int'];
  connectedCareBenefits: Scalars['Int'];
  loyaltyPointGrantingServiceCategories: Scalars['Int'];
};

export type ServiceCategoryCreateInput = {
  childServiceCategoires?: Maybe<ServiceCategoryCreateNestedManyWithoutParentServiceCategoryInput>;
  childServices?: Maybe<ServiceCreateNestedManyWithoutServiceCategoryInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceCategoriesInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryCreateNestedManyWithoutServiceCategoryInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServiceCategoiresInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryCreateManyInput = {
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryCreateManyIntegrationInput = {
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryCreateManyIntegrationInputEnvelope = {
  data: Array<ServiceCategoryCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceCategoryCreateManyParentServiceCategoryInput = {
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryCreateManyParentServiceCategoryInputEnvelope = {
  data: Array<ServiceCategoryCreateManyParentServiceCategoryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceCategoryCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCategoryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ServiceCategoryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ServiceCategoryCreateManyIntegrationInputEnvelope>;
};

export type ServiceCategoryCreateNestedManyWithoutParentServiceCategoryInput = {
  connect?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCategoryCreateOrConnectWithoutParentServiceCategoryInput>>;
  create?: Maybe<Array<ServiceCategoryCreateWithoutParentServiceCategoryInput>>;
  createMany?: Maybe<ServiceCategoryCreateManyParentServiceCategoryInputEnvelope>;
};

export type ServiceCategoryCreateNestedOneWithoutChildServiceCategoiresInput = {
  connect?: Maybe<ServiceCategoryWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCategoryCreateOrConnectWithoutChildServiceCategoiresInput>;
  create?: Maybe<ServiceCategoryCreateWithoutChildServiceCategoiresInput>;
};

export type ServiceCategoryCreateNestedOneWithoutChildServicesInput = {
  connect?: Maybe<ServiceCategoryWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCategoryCreateOrConnectWithoutChildServicesInput>;
  create?: Maybe<ServiceCategoryCreateWithoutChildServicesInput>;
};

export type ServiceCategoryCreateNestedOneWithoutConnectedCareBenefitsInput = {
  connect?: Maybe<ServiceCategoryWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCategoryCreateOrConnectWithoutConnectedCareBenefitsInput>;
  create?: Maybe<ServiceCategoryCreateWithoutConnectedCareBenefitsInput>;
};

export type ServiceCategoryCreateNestedOneWithoutLoyaltyPointGrantingServiceCategoriesInput = {
  connect?: Maybe<ServiceCategoryWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCategoryCreateOrConnectWithoutLoyaltyPointGrantingServiceCategoriesInput>;
  create?: Maybe<ServiceCategoryCreateWithoutLoyaltyPointGrantingServiceCategoriesInput>;
};

export type ServiceCategoryCreateOrConnectWithoutChildServiceCategoiresInput = {
  create: ServiceCategoryCreateWithoutChildServiceCategoiresInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryCreateOrConnectWithoutChildServicesInput = {
  create: ServiceCategoryCreateWithoutChildServicesInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryCreateOrConnectWithoutConnectedCareBenefitsInput = {
  create: ServiceCategoryCreateWithoutConnectedCareBenefitsInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryCreateOrConnectWithoutIntegrationInput = {
  create: ServiceCategoryCreateWithoutIntegrationInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryCreateOrConnectWithoutLoyaltyPointGrantingServiceCategoriesInput = {
  create: ServiceCategoryCreateWithoutLoyaltyPointGrantingServiceCategoriesInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryCreateOrConnectWithoutParentServiceCategoryInput = {
  create: ServiceCategoryCreateWithoutParentServiceCategoryInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryCreateWithoutChildServiceCategoiresInput = {
  childServices?: Maybe<ServiceCreateNestedManyWithoutServiceCategoryInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceCategoriesInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryCreateNestedManyWithoutServiceCategoryInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServiceCategoiresInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryCreateWithoutChildServicesInput = {
  childServiceCategoires?: Maybe<ServiceCategoryCreateNestedManyWithoutParentServiceCategoryInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceCategoriesInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryCreateNestedManyWithoutServiceCategoryInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServiceCategoiresInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryCreateWithoutConnectedCareBenefitsInput = {
  childServiceCategoires?: Maybe<ServiceCategoryCreateNestedManyWithoutParentServiceCategoryInput>;
  childServices?: Maybe<ServiceCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceCategoriesInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryCreateNestedManyWithoutServiceCategoryInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServiceCategoiresInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryCreateWithoutIntegrationInput = {
  childServiceCategoires?: Maybe<ServiceCategoryCreateNestedManyWithoutParentServiceCategoryInput>;
  childServices?: Maybe<ServiceCreateNestedManyWithoutServiceCategoryInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryCreateNestedManyWithoutServiceCategoryInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServiceCategoiresInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryCreateWithoutLoyaltyPointGrantingServiceCategoriesInput = {
  childServiceCategoires?: Maybe<ServiceCategoryCreateNestedManyWithoutParentServiceCategoryInput>;
  childServices?: Maybe<ServiceCreateNestedManyWithoutServiceCategoryInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceCategoriesInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServiceCategoiresInput>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryCreateWithoutParentServiceCategoryInput = {
  childServiceCategoires?: Maybe<ServiceCategoryCreateNestedManyWithoutParentServiceCategoryInput>;
  childServices?: Maybe<ServiceCreateNestedManyWithoutServiceCategoryInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceCategoriesInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryCreateNestedManyWithoutServiceCategoryInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryGroupByOutputType = {
  __typename?: 'ServiceCategoryGroupByOutputType';
  _count?: Maybe<ServiceCategoryCountAggregateOutputType>;
  _max?: Maybe<ServiceCategoryMaxAggregateOutputType>;
  _min?: Maybe<ServiceCategoryMinAggregateOutputType>;
  description: Scalars['String'];
  id: Scalars['String'];
  integrationId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryListRelationFilter = {
  every?: Maybe<ServiceCategoryWhereInput>;
  none?: Maybe<ServiceCategoryWhereInput>;
  some?: Maybe<ServiceCategoryWhereInput>;
};

export type ServiceCategoryMaxAggregateOutputType = {
  __typename?: 'ServiceCategoryMaxAggregateOutputType';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryMaxOrderByAggregateInput = {
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  parentCategoryPimsId?: Maybe<SortOrder>;
  parentServiceCategoryId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
};

export type ServiceCategoryMinAggregateOutputType = {
  __typename?: 'ServiceCategoryMinAggregateOutputType';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryMinOrderByAggregateInput = {
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  parentCategoryPimsId?: Maybe<SortOrder>;
  parentServiceCategoryId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
};

export type ServiceCategoryNullableScalarRelationFilter = {
  AND?: Maybe<Array<ServiceCategoryWhereInput>>;
  NOT?: Maybe<Array<ServiceCategoryWhereInput>>;
  OR?: Maybe<Array<ServiceCategoryWhereInput>>;
  childServiceCategoires?: Maybe<ServiceCategoryListRelationFilter>;
  childServices?: Maybe<ServiceListRelationFilter>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryListRelationFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryListRelationFilter>;
  parentCategoryPimsId?: Maybe<StringNullableFilter>;
  parentServiceCategory?: Maybe<ServiceCategoryNullableScalarRelationFilter>;
  parentServiceCategoryId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonFilter>;
  shortDescription?: Maybe<StringFilter>;
};

export type ServiceCategoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ServiceCategoryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ServiceCategoryOrderByRelevanceInput>;
  childServiceCategoires?: Maybe<ServiceCategoryOrderByRelationAggregateInput>;
  childServices?: Maybe<ServiceOrderByRelationAggregateInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByRelationAggregateInput>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryOrderByRelationAggregateInput>;
  parentCategoryPimsId?: Maybe<SortOrder>;
  parentServiceCategory?: Maybe<ServiceCategoryOrderByWithRelationInput>;
  parentServiceCategoryId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
};

export enum ServiceCategoryOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  IntegrationId = 'integrationId',
  ParentCategoryPimsId = 'parentCategoryPimsId',
  ParentServiceCategoryId = 'parentServiceCategoryId',
  PimsId = 'pimsId',
  ShortDescription = 'shortDescription'
}

export type ServiceCategoryOrderByRelevanceInput = {
  fields: Array<ServiceCategoryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ServiceCategoryOrderByWithAggregationInput = {
  _count?: Maybe<ServiceCategoryCountOrderByAggregateInput>;
  _max?: Maybe<ServiceCategoryMaxOrderByAggregateInput>;
  _min?: Maybe<ServiceCategoryMinOrderByAggregateInput>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  parentCategoryPimsId?: Maybe<SortOrder>;
  parentServiceCategoryId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
};

export type ServiceCategoryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ServiceCategoryOrderByRelevanceInput>;
  childServiceCategoires?: Maybe<ServiceCategoryOrderByRelationAggregateInput>;
  childServices?: Maybe<ServiceOrderByRelationAggregateInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByRelationAggregateInput>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryOrderByRelationAggregateInput>;
  parentCategoryPimsId?: Maybe<SortOrder>;
  parentServiceCategory?: Maybe<ServiceCategoryOrderByWithRelationInput>;
  parentServiceCategoryId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
};

export type ServiceCategoryOrderByWithRelationInput = {
  _relevance?: Maybe<ServiceCategoryOrderByRelevanceInput>;
  childServiceCategoires?: Maybe<ServiceCategoryOrderByRelationAggregateInput>;
  childServices?: Maybe<ServiceOrderByRelationAggregateInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryOrderByRelationAggregateInput>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryOrderByRelationAggregateInput>;
  parentCategoryPimsId?: Maybe<SortOrder>;
  parentServiceCategory?: Maybe<ServiceCategoryOrderByWithRelationInput>;
  parentServiceCategoryId?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  shortDescription?: Maybe<SortOrder>;
};

export type ServiceCategoryPimsIdIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export enum ServiceCategoryScalarFieldEnum {
  Description = 'description',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsDeleted = 'isDeleted',
  ParentCategoryPimsId = 'parentCategoryPimsId',
  ParentServiceCategoryId = 'parentServiceCategoryId',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  ShortDescription = 'shortDescription'
}

export type ServiceCategoryScalarRelationFilter = {
  AND?: Maybe<Array<ServiceCategoryWhereInput>>;
  NOT?: Maybe<Array<ServiceCategoryWhereInput>>;
  OR?: Maybe<Array<ServiceCategoryWhereInput>>;
  childServiceCategoires?: Maybe<ServiceCategoryListRelationFilter>;
  childServices?: Maybe<ServiceListRelationFilter>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryListRelationFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryListRelationFilter>;
  parentCategoryPimsId?: Maybe<StringNullableFilter>;
  parentServiceCategory?: Maybe<ServiceCategoryNullableScalarRelationFilter>;
  parentServiceCategoryId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonFilter>;
  shortDescription?: Maybe<StringFilter>;
};

export type ServiceCategoryScalarWhereInput = {
  AND?: Maybe<Array<ServiceCategoryScalarWhereInput>>;
  NOT?: Maybe<Array<ServiceCategoryScalarWhereInput>>;
  OR?: Maybe<Array<ServiceCategoryScalarWhereInput>>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  parentCategoryPimsId?: Maybe<StringNullableFilter>;
  parentServiceCategoryId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonFilter>;
  shortDescription?: Maybe<StringFilter>;
};

export type ServiceCategoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ServiceCategoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ServiceCategoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ServiceCategoryScalarWhereWithAggregatesInput>>;
  description?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  parentCategoryPimsId?: Maybe<StringNullableWithAggregatesFilter>;
  parentServiceCategoryId?: Maybe<StringNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonWithAggregatesFilter>;
  shortDescription?: Maybe<StringWithAggregatesFilter>;
};

export type ServiceCategoryUncheckedCreateInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutParentServiceCategoryInput>;
  childServices?: Maybe<ServiceUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCategoryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ServiceCategoryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ServiceCategoryCreateManyIntegrationInputEnvelope>;
};

export type ServiceCategoryUncheckedCreateNestedManyWithoutParentServiceCategoryInput = {
  connect?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCategoryCreateOrConnectWithoutParentServiceCategoryInput>>;
  create?: Maybe<Array<ServiceCategoryCreateWithoutParentServiceCategoryInput>>;
  createMany?: Maybe<ServiceCategoryCreateManyParentServiceCategoryInputEnvelope>;
};

export type ServiceCategoryUncheckedCreateWithoutChildServiceCategoiresInput = {
  childServices?: Maybe<ServiceUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryUncheckedCreateWithoutChildServicesInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutParentServiceCategoryInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryUncheckedCreateWithoutConnectedCareBenefitsInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutParentServiceCategoryInput>;
  childServices?: Maybe<ServiceUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryUncheckedCreateWithoutIntegrationInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutParentServiceCategoryInput>;
  childServices?: Maybe<ServiceUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryUncheckedCreateWithoutLoyaltyPointGrantingServiceCategoriesInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutParentServiceCategoryInput>;
  childServices?: Maybe<ServiceUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryUncheckedCreateWithoutParentServiceCategoryInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUncheckedCreateNestedManyWithoutParentServiceCategoryInput>;
  childServices?: Maybe<ServiceUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedCreateNestedManyWithoutServiceCategoryInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  pimsId: Scalars['String'];
  rawPimsValue: Scalars['Json'];
  shortDescription: Scalars['String'];
};

export type ServiceCategoryUncheckedUpdateInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutParentServiceCategoryNestedInput>;
  childServices?: Maybe<ServiceUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUncheckedUpdateManyInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUncheckedUpdateManyWithoutIntegrationInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCategoryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ServiceCategoryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ServiceCategoryCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  set?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  update?: Maybe<Array<ServiceCategoryUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ServiceCategoryUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ServiceCategoryUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ServiceCategoryUncheckedUpdateManyWithoutParentServiceCategoryInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUncheckedUpdateManyWithoutParentServiceCategoryNestedInput = {
  connect?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCategoryCreateOrConnectWithoutParentServiceCategoryInput>>;
  create?: Maybe<Array<ServiceCategoryCreateWithoutParentServiceCategoryInput>>;
  createMany?: Maybe<ServiceCategoryCreateManyParentServiceCategoryInputEnvelope>;
  delete?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  set?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  update?: Maybe<Array<ServiceCategoryUpdateWithWhereUniqueWithoutParentServiceCategoryInput>>;
  updateMany?: Maybe<Array<ServiceCategoryUpdateManyWithWhereWithoutParentServiceCategoryInput>>;
  upsert?: Maybe<Array<ServiceCategoryUpsertWithWhereUniqueWithoutParentServiceCategoryInput>>;
};

export type ServiceCategoryUncheckedUpdateWithoutChildServiceCategoiresInput = {
  childServices?: Maybe<ServiceUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUncheckedUpdateWithoutChildServicesInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutParentServiceCategoryNestedInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUncheckedUpdateWithoutConnectedCareBenefitsInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutParentServiceCategoryNestedInput>;
  childServices?: Maybe<ServiceUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUncheckedUpdateWithoutIntegrationInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutParentServiceCategoryNestedInput>;
  childServices?: Maybe<ServiceUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUncheckedUpdateWithoutLoyaltyPointGrantingServiceCategoriesInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutParentServiceCategoryNestedInput>;
  childServices?: Maybe<ServiceUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategoryId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUncheckedUpdateWithoutParentServiceCategoryInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUncheckedUpdateManyWithoutParentServiceCategoryNestedInput>;
  childServices?: Maybe<ServiceUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUncheckedUpdateManyWithoutServiceCategoryNestedInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUpdateInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUpdateManyWithoutParentServiceCategoryNestedInput>;
  childServices?: Maybe<ServiceUpdateManyWithoutServiceCategoryNestedInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceCategoriesNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUpdateManyWithoutServiceCategoryNestedInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServiceCategoiresNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUpdateManyMutationInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUpdateManyWithWhereWithoutIntegrationInput = {
  data: ServiceCategoryUpdateManyMutationInput;
  where: ServiceCategoryScalarWhereInput;
};

export type ServiceCategoryUpdateManyWithWhereWithoutParentServiceCategoryInput = {
  data: ServiceCategoryUpdateManyMutationInput;
  where: ServiceCategoryScalarWhereInput;
};

export type ServiceCategoryUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCategoryCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ServiceCategoryCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ServiceCategoryCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  set?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  update?: Maybe<Array<ServiceCategoryUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ServiceCategoryUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ServiceCategoryUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ServiceCategoryUpdateManyWithoutParentServiceCategoryNestedInput = {
  connect?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCategoryCreateOrConnectWithoutParentServiceCategoryInput>>;
  create?: Maybe<Array<ServiceCategoryCreateWithoutParentServiceCategoryInput>>;
  createMany?: Maybe<ServiceCategoryCreateManyParentServiceCategoryInputEnvelope>;
  delete?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  set?: Maybe<Array<ServiceCategoryWhereUniqueInput>>;
  update?: Maybe<Array<ServiceCategoryUpdateWithWhereUniqueWithoutParentServiceCategoryInput>>;
  updateMany?: Maybe<Array<ServiceCategoryUpdateManyWithWhereWithoutParentServiceCategoryInput>>;
  upsert?: Maybe<Array<ServiceCategoryUpsertWithWhereUniqueWithoutParentServiceCategoryInput>>;
};

export type ServiceCategoryUpdateOneRequiredWithoutConnectedCareBenefitsNestedInput = {
  connect?: Maybe<ServiceCategoryWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCategoryCreateOrConnectWithoutConnectedCareBenefitsInput>;
  create?: Maybe<ServiceCategoryCreateWithoutConnectedCareBenefitsInput>;
  update?: Maybe<ServiceCategoryUpdateToOneWithWhereWithoutConnectedCareBenefitsInput>;
  upsert?: Maybe<ServiceCategoryUpsertWithoutConnectedCareBenefitsInput>;
};

export type ServiceCategoryUpdateOneRequiredWithoutLoyaltyPointGrantingServiceCategoriesNestedInput = {
  connect?: Maybe<ServiceCategoryWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCategoryCreateOrConnectWithoutLoyaltyPointGrantingServiceCategoriesInput>;
  create?: Maybe<ServiceCategoryCreateWithoutLoyaltyPointGrantingServiceCategoriesInput>;
  update?: Maybe<ServiceCategoryUpdateToOneWithWhereWithoutLoyaltyPointGrantingServiceCategoriesInput>;
  upsert?: Maybe<ServiceCategoryUpsertWithoutLoyaltyPointGrantingServiceCategoriesInput>;
};

export type ServiceCategoryUpdateOneWithoutChildServiceCategoiresNestedInput = {
  connect?: Maybe<ServiceCategoryWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCategoryCreateOrConnectWithoutChildServiceCategoiresInput>;
  create?: Maybe<ServiceCategoryCreateWithoutChildServiceCategoiresInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServiceCategoryUpdateToOneWithWhereWithoutChildServiceCategoiresInput>;
  upsert?: Maybe<ServiceCategoryUpsertWithoutChildServiceCategoiresInput>;
};

export type ServiceCategoryUpdateOneWithoutChildServicesNestedInput = {
  connect?: Maybe<ServiceCategoryWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCategoryCreateOrConnectWithoutChildServicesInput>;
  create?: Maybe<ServiceCategoryCreateWithoutChildServicesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServiceCategoryUpdateToOneWithWhereWithoutChildServicesInput>;
  upsert?: Maybe<ServiceCategoryUpsertWithoutChildServicesInput>;
};

export type ServiceCategoryUpdateToOneWithWhereWithoutChildServiceCategoiresInput = {
  data: ServiceCategoryUpdateWithoutChildServiceCategoiresInput;
  where?: Maybe<ServiceCategoryWhereInput>;
};

export type ServiceCategoryUpdateToOneWithWhereWithoutChildServicesInput = {
  data: ServiceCategoryUpdateWithoutChildServicesInput;
  where?: Maybe<ServiceCategoryWhereInput>;
};

export type ServiceCategoryUpdateToOneWithWhereWithoutConnectedCareBenefitsInput = {
  data: ServiceCategoryUpdateWithoutConnectedCareBenefitsInput;
  where?: Maybe<ServiceCategoryWhereInput>;
};

export type ServiceCategoryUpdateToOneWithWhereWithoutLoyaltyPointGrantingServiceCategoriesInput = {
  data: ServiceCategoryUpdateWithoutLoyaltyPointGrantingServiceCategoriesInput;
  where?: Maybe<ServiceCategoryWhereInput>;
};

export type ServiceCategoryUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: ServiceCategoryUpdateWithoutIntegrationInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryUpdateWithWhereUniqueWithoutParentServiceCategoryInput = {
  data: ServiceCategoryUpdateWithoutParentServiceCategoryInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryUpdateWithoutChildServiceCategoiresInput = {
  childServices?: Maybe<ServiceUpdateManyWithoutServiceCategoryNestedInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceCategoriesNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUpdateManyWithoutServiceCategoryNestedInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServiceCategoiresNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUpdateWithoutChildServicesInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUpdateManyWithoutParentServiceCategoryNestedInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceCategoriesNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUpdateManyWithoutServiceCategoryNestedInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServiceCategoiresNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUpdateWithoutConnectedCareBenefitsInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUpdateManyWithoutParentServiceCategoryNestedInput>;
  childServices?: Maybe<ServiceUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceCategoriesNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUpdateManyWithoutServiceCategoryNestedInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServiceCategoiresNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUpdateWithoutIntegrationInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUpdateManyWithoutParentServiceCategoryNestedInput>;
  childServices?: Maybe<ServiceUpdateManyWithoutServiceCategoryNestedInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUpdateManyWithoutServiceCategoryNestedInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServiceCategoiresNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUpdateWithoutLoyaltyPointGrantingServiceCategoriesInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUpdateManyWithoutParentServiceCategoryNestedInput>;
  childServices?: Maybe<ServiceUpdateManyWithoutServiceCategoryNestedInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceCategoriesNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  parentServiceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServiceCategoiresNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUpdateWithoutParentServiceCategoryInput = {
  childServiceCategoires?: Maybe<ServiceCategoryUpdateManyWithoutParentServiceCategoryNestedInput>;
  childServices?: Maybe<ServiceUpdateManyWithoutServiceCategoryNestedInput>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryUpdateManyWithoutServiceCategoryNestedInput>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceCategoriesNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryUpdateManyWithoutServiceCategoryNestedInput>;
  parentCategoryPimsId?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ServiceCategoryUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: ServiceCategoryCreateWithoutIntegrationInput;
  update: ServiceCategoryUpdateWithoutIntegrationInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryUpsertWithWhereUniqueWithoutParentServiceCategoryInput = {
  create: ServiceCategoryCreateWithoutParentServiceCategoryInput;
  update: ServiceCategoryUpdateWithoutParentServiceCategoryInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryUpsertWithoutChildServiceCategoiresInput = {
  create: ServiceCategoryCreateWithoutChildServiceCategoiresInput;
  update: ServiceCategoryUpdateWithoutChildServiceCategoiresInput;
  where?: Maybe<ServiceCategoryWhereInput>;
};

export type ServiceCategoryUpsertWithoutChildServicesInput = {
  create: ServiceCategoryCreateWithoutChildServicesInput;
  update: ServiceCategoryUpdateWithoutChildServicesInput;
  where?: Maybe<ServiceCategoryWhereInput>;
};

export type ServiceCategoryUpsertWithoutConnectedCareBenefitsInput = {
  create: ServiceCategoryCreateWithoutConnectedCareBenefitsInput;
  update: ServiceCategoryUpdateWithoutConnectedCareBenefitsInput;
  where?: Maybe<ServiceCategoryWhereInput>;
};

export type ServiceCategoryUpsertWithoutLoyaltyPointGrantingServiceCategoriesInput = {
  create: ServiceCategoryCreateWithoutLoyaltyPointGrantingServiceCategoriesInput;
  update: ServiceCategoryUpdateWithoutLoyaltyPointGrantingServiceCategoriesInput;
  where?: Maybe<ServiceCategoryWhereInput>;
};

export type ServiceCategoryWhereInput = {
  AND?: Maybe<Array<ServiceCategoryWhereInput>>;
  NOT?: Maybe<Array<ServiceCategoryWhereInput>>;
  OR?: Maybe<Array<ServiceCategoryWhereInput>>;
  childServiceCategoires?: Maybe<ServiceCategoryListRelationFilter>;
  childServices?: Maybe<ServiceListRelationFilter>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryListRelationFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryListRelationFilter>;
  parentCategoryPimsId?: Maybe<StringNullableFilter>;
  parentServiceCategory?: Maybe<ServiceCategoryNullableScalarRelationFilter>;
  parentServiceCategoryId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonFilter>;
  shortDescription?: Maybe<StringFilter>;
};

export type ServiceCategoryWhereUniqueInput = {
  AND?: Maybe<Array<ServiceCategoryWhereInput>>;
  NOT?: Maybe<Array<ServiceCategoryWhereInput>>;
  OR?: Maybe<Array<ServiceCategoryWhereInput>>;
  childServiceCategoires?: Maybe<ServiceCategoryListRelationFilter>;
  childServices?: Maybe<ServiceListRelationFilter>;
  connectedCareBenefits?: Maybe<OrganizationCareBenefitToClinicServiceCategoryListRelationFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  loyaltyPointGrantingServiceCategories?: Maybe<LoyaltyPointGrantingServiceCategoryListRelationFilter>;
  parentCategoryPimsId?: Maybe<StringNullableFilter>;
  parentServiceCategory?: Maybe<ServiceCategoryNullableScalarRelationFilter>;
  parentServiceCategoryId?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringFilter>;
  pimsId_integrationId?: Maybe<ServiceCategoryPimsIdIntegrationIdCompoundUniqueInput>;
  rawPimsValue?: Maybe<JsonFilter>;
  shortDescription?: Maybe<StringFilter>;
};

export type ServiceCountAggregateOutputType = {
  __typename?: 'ServiceCountAggregateOutputType';
  _all: Scalars['Int'];
  canonicalServiceId: Scalars['Int'];
  code: Scalars['Int'];
  createdAt: Scalars['Int'];
  formTemplateId: Scalars['Int'];
  hasConfiguredReminders: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isPetPortal: Scalars['Int'];
  isPostcard: Scalars['Int'];
  isReminderActive: Scalars['Int'];
  name: Scalars['Int'];
  pimsId: Scalars['Int'];
  pimsName: Scalars['Int'];
  pimsType: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  reminderActivationDate: Scalars['Int'];
  serviceCategoryId: Scalars['Int'];
  taxonomyId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  vetsourceFreeDoses: Scalars['Int'];
  vetsourcePaidDoses: Scalars['Int'];
  vetsourceQuantityOverride: Scalars['Int'];
  vetsourceRevenueCategoryName: Scalars['Int'];
};

export type ServiceCountOrderByAggregateInput = {
  canonicalServiceId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formTemplateId?: Maybe<SortOrder>;
  hasConfiguredReminders?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPetPortal?: Maybe<SortOrder>;
  isPostcard?: Maybe<SortOrder>;
  isReminderActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsType?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  reminderActivationDate?: Maybe<SortOrder>;
  serviceCategoryId?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourceFreeDoses?: Maybe<SortOrder>;
  vetsourcePaidDoses?: Maybe<SortOrder>;
  vetsourceQuantityOverride?: Maybe<SortOrder>;
  vetsourceRevenueCategoryName?: Maybe<SortOrder>;
};

export type ServiceCountOutputType = {
  __typename?: 'ServiceCountOutputType';
  MedicalHistory: Scalars['Int'];
  draftCareBenefitUsageToInvoiceLineItems: Scalars['Int'];
  invoiceLineItems: Scalars['Int'];
  loyaltyPointGrantingServices: Scalars['Int'];
  organizationCareBenefitToClinicService: Scalars['Int'];
  prescriptions: Scalars['Int'];
  reminderTimings: Scalars['Int'];
  reminders: Scalars['Int'];
  servicePurchaseSummaries: Scalars['Int'];
  vetsourceCodeTags: Scalars['Int'];
};

export type ServiceCreateInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateManyCanonicalServiceInput = {
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceCreateManyCanonicalServiceInputEnvelope = {
  data: Array<ServiceCreateManyCanonicalServiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceCreateManyFormTemplateInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceCreateManyFormTemplateInputEnvelope = {
  data: Array<ServiceCreateManyFormTemplateInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceCreateManyInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceCreateManyIntegrationInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceCreateManyIntegrationInputEnvelope = {
  data: Array<ServiceCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceCreateManyServiceCategoryInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceCreateManyServiceCategoryInputEnvelope = {
  data: Array<ServiceCreateManyServiceCategoryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceCreateManyTaxonomyInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceCreateManyTaxonomyInputEnvelope = {
  data: Array<ServiceCreateManyTaxonomyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceCreateManyVetsourceRevenueCategoryInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
};

export type ServiceCreateManyVetsourceRevenueCategoryInputEnvelope = {
  data: Array<ServiceCreateManyVetsourceRevenueCategoryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceCreateNestedManyWithoutCanonicalServiceInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutCanonicalServiceInput>>;
  create?: Maybe<Array<ServiceCreateWithoutCanonicalServiceInput>>;
  createMany?: Maybe<ServiceCreateManyCanonicalServiceInputEnvelope>;
};

export type ServiceCreateNestedManyWithoutFormTemplateInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutFormTemplateInput>>;
  create?: Maybe<Array<ServiceCreateWithoutFormTemplateInput>>;
  createMany?: Maybe<ServiceCreateManyFormTemplateInputEnvelope>;
};

export type ServiceCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ServiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ServiceCreateManyIntegrationInputEnvelope>;
};

export type ServiceCreateNestedManyWithoutServiceCategoryInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutServiceCategoryInput>>;
  create?: Maybe<Array<ServiceCreateWithoutServiceCategoryInput>>;
  createMany?: Maybe<ServiceCreateManyServiceCategoryInputEnvelope>;
};

export type ServiceCreateNestedManyWithoutTaxonomyInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<ServiceCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<ServiceCreateManyTaxonomyInputEnvelope>;
};

export type ServiceCreateNestedManyWithoutVetsourceCodeTagsInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutVetsourceCodeTagsInput>>;
  create?: Maybe<Array<ServiceCreateWithoutVetsourceCodeTagsInput>>;
};

export type ServiceCreateNestedManyWithoutVetsourceRevenueCategoryInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutVetsourceRevenueCategoryInput>>;
  create?: Maybe<Array<ServiceCreateWithoutVetsourceRevenueCategoryInput>>;
  createMany?: Maybe<ServiceCreateManyVetsourceRevenueCategoryInputEnvelope>;
};

export type ServiceCreateNestedOneWithoutDraftCareBenefitUsageToInvoiceLineItemsInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutDraftCareBenefitUsageToInvoiceLineItemsInput>;
  create?: Maybe<ServiceCreateWithoutDraftCareBenefitUsageToInvoiceLineItemsInput>;
};

export type ServiceCreateNestedOneWithoutInvoiceLineItemsInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutInvoiceLineItemsInput>;
  create?: Maybe<ServiceCreateWithoutInvoiceLineItemsInput>;
};

export type ServiceCreateNestedOneWithoutLoyaltyPointGrantingServicesInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutLoyaltyPointGrantingServicesInput>;
  create?: Maybe<ServiceCreateWithoutLoyaltyPointGrantingServicesInput>;
};

export type ServiceCreateNestedOneWithoutMedicalHistoryInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutMedicalHistoryInput>;
  create?: Maybe<ServiceCreateWithoutMedicalHistoryInput>;
};

export type ServiceCreateNestedOneWithoutOrganizationCareBenefitToClinicServiceInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutOrganizationCareBenefitToClinicServiceInput>;
  create?: Maybe<ServiceCreateWithoutOrganizationCareBenefitToClinicServiceInput>;
};

export type ServiceCreateNestedOneWithoutPrescriptionsInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutPrescriptionsInput>;
  create?: Maybe<ServiceCreateWithoutPrescriptionsInput>;
};

export type ServiceCreateNestedOneWithoutReminderTimingsInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutReminderTimingsInput>;
  create?: Maybe<ServiceCreateWithoutReminderTimingsInput>;
};

export type ServiceCreateNestedOneWithoutRemindersInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutRemindersInput>;
  create?: Maybe<ServiceCreateWithoutRemindersInput>;
};

export type ServiceCreateNestedOneWithoutServicePurchaseSummariesInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutServicePurchaseSummariesInput>;
  create?: Maybe<ServiceCreateWithoutServicePurchaseSummariesInput>;
};

export type ServiceCreateOrConnectWithoutCanonicalServiceInput = {
  create: ServiceCreateWithoutCanonicalServiceInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutDraftCareBenefitUsageToInvoiceLineItemsInput = {
  create: ServiceCreateWithoutDraftCareBenefitUsageToInvoiceLineItemsInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutFormTemplateInput = {
  create: ServiceCreateWithoutFormTemplateInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutIntegrationInput = {
  create: ServiceCreateWithoutIntegrationInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutInvoiceLineItemsInput = {
  create: ServiceCreateWithoutInvoiceLineItemsInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutLoyaltyPointGrantingServicesInput = {
  create: ServiceCreateWithoutLoyaltyPointGrantingServicesInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutMedicalHistoryInput = {
  create: ServiceCreateWithoutMedicalHistoryInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutOrganizationCareBenefitToClinicServiceInput = {
  create: ServiceCreateWithoutOrganizationCareBenefitToClinicServiceInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutPrescriptionsInput = {
  create: ServiceCreateWithoutPrescriptionsInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutReminderTimingsInput = {
  create: ServiceCreateWithoutReminderTimingsInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutRemindersInput = {
  create: ServiceCreateWithoutRemindersInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutServiceCategoryInput = {
  create: ServiceCreateWithoutServiceCategoryInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutServicePurchaseSummariesInput = {
  create: ServiceCreateWithoutServicePurchaseSummariesInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutTaxonomyInput = {
  create: ServiceCreateWithoutTaxonomyInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutVetsourceCodeTagsInput = {
  create: ServiceCreateWithoutVetsourceCodeTagsInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutVetsourceRevenueCategoryInput = {
  create: ServiceCreateWithoutVetsourceRevenueCategoryInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateWithoutCanonicalServiceInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutDraftCareBenefitUsageToInvoiceLineItemsInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutFormTemplateInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutIntegrationInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutInvoiceLineItemsInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutLoyaltyPointGrantingServicesInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutMedicalHistoryInput = {
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutOrganizationCareBenefitToClinicServiceInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutPrescriptionsInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutReminderTimingsInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutRemindersInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutServiceCategoryInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutServicePurchaseSummariesInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutTaxonomyInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutVetsourceCodeTagsInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput>;
};

export type ServiceCreateWithoutVetsourceRevenueCategoryInput = {
  MedicalHistory?: Maybe<MedicalHistoryCreateNestedManyWithoutServiceInput>;
  canonicalService?: Maybe<CanonicalServiceCreateNestedOneWithoutServicesInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutDraftServiceInput>;
  formTemplate?: Maybe<FormTemplateCreateNestedOneWithoutServicesInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServicesInput;
  invoiceLineItems?: Maybe<InvoiceLineItemCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderCreateNestedManyWithoutServiceInput>;
  serviceCategory?: Maybe<ServiceCategoryCreateNestedOneWithoutChildServicesInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryCreateNestedManyWithoutServiceInput>;
  taxonomy?: Maybe<TaxonomyCreateNestedOneWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
};

export type ServiceGroupByOutputType = {
  __typename?: 'ServiceGroupByOutputType';
  _avg?: Maybe<ServiceAvgAggregateOutputType>;
  _count?: Maybe<ServiceCountAggregateOutputType>;
  _max?: Maybe<ServiceMaxAggregateOutputType>;
  _min?: Maybe<ServiceMinAggregateOutputType>;
  _sum?: Maybe<ServiceSumAggregateOutputType>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders: Scalars['Boolean'];
  id: Scalars['String'];
  integrationId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isPetPortal: Scalars['Boolean'];
  isPostcard: Scalars['Boolean'];
  isReminderActive: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceListRelationFilter = {
  every?: Maybe<ServiceWhereInput>;
  none?: Maybe<ServiceWhereInput>;
  some?: Maybe<ServiceWhereInput>;
};

export type ServiceMaxAggregateOutputType = {
  __typename?: 'ServiceMaxAggregateOutputType';
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceMaxOrderByAggregateInput = {
  canonicalServiceId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formTemplateId?: Maybe<SortOrder>;
  hasConfiguredReminders?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPetPortal?: Maybe<SortOrder>;
  isPostcard?: Maybe<SortOrder>;
  isReminderActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsType?: Maybe<SortOrder>;
  reminderActivationDate?: Maybe<SortOrder>;
  serviceCategoryId?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourceFreeDoses?: Maybe<SortOrder>;
  vetsourcePaidDoses?: Maybe<SortOrder>;
  vetsourceQuantityOverride?: Maybe<SortOrder>;
  vetsourceRevenueCategoryName?: Maybe<SortOrder>;
};

export type ServiceMinAggregateOutputType = {
  __typename?: 'ServiceMinAggregateOutputType';
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceMinOrderByAggregateInput = {
  canonicalServiceId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formTemplateId?: Maybe<SortOrder>;
  hasConfiguredReminders?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPetPortal?: Maybe<SortOrder>;
  isPostcard?: Maybe<SortOrder>;
  isReminderActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsType?: Maybe<SortOrder>;
  reminderActivationDate?: Maybe<SortOrder>;
  serviceCategoryId?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourceFreeDoses?: Maybe<SortOrder>;
  vetsourcePaidDoses?: Maybe<SortOrder>;
  vetsourceQuantityOverride?: Maybe<SortOrder>;
  vetsourceRevenueCategoryName?: Maybe<SortOrder>;
};

export type ServiceNullableScalarRelationFilter = {
  AND?: Maybe<Array<ServiceWhereInput>>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ServiceWhereInput>>;
  OR?: Maybe<Array<ServiceWhereInput>>;
  canonicalService?: Maybe<CanonicalServiceNullableScalarRelationFilter>;
  canonicalServiceId?: Maybe<StringNullableFilter>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  formTemplate?: Maybe<FormTemplateNullableScalarRelationFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  hasConfiguredReminders?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isPetPortal?: Maybe<BoolFilter>;
  isPostcard?: Maybe<BoolFilter>;
  isReminderActive?: Maybe<BoolFilter>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceListRelationFilter>;
  name?: Maybe<StringFilter>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceListRelationFilter>;
  pimsId?: Maybe<StringFilter>;
  pimsName?: Maybe<StringFilter>;
  pimsType?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  reminderActivationDate?: Maybe<DateTimeNullableFilter>;
  reminderTimings?: Maybe<ServiceReminderTimingListRelationFilter>;
  reminders?: Maybe<ServiceReminderListRelationFilter>;
  serviceCategory?: Maybe<ServiceCategoryNullableScalarRelationFilter>;
  serviceCategoryId?: Maybe<StringNullableFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagListRelationFilter>;
  vetsourceFreeDoses?: Maybe<IntNullableFilter>;
  vetsourcePaidDoses?: Maybe<IntNullableFilter>;
  vetsourceQuantityOverride?: Maybe<FloatNullableFilter>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryNullableScalarRelationFilter>;
  vetsourceRevenueCategoryName?: Maybe<StringNullableFilter>;
};

export type ServiceOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ServiceOrderByRelationAndSearchRelevanceInput = {
  MedicalHistory?: Maybe<MedicalHistoryOrderByRelationAggregateInput>;
  _relevance?: Maybe<ServiceOrderByRelevanceInput>;
  canonicalService?: Maybe<CanonicalServiceOrderByWithRelationInput>;
  canonicalServiceId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  formTemplate?: Maybe<FormTemplateOrderByWithRelationInput>;
  formTemplateId?: Maybe<SortOrder>;
  hasConfiguredReminders?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  isDeleted?: Maybe<SortOrder>;
  isPetPortal?: Maybe<SortOrder>;
  isPostcard?: Maybe<SortOrder>;
  isReminderActive?: Maybe<SortOrder>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsType?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  rawPimsValue?: Maybe<SortOrder>;
  reminderActivationDate?: Maybe<SortOrder>;
  reminderTimings?: Maybe<ServiceReminderTimingOrderByRelationAggregateInput>;
  reminders?: Maybe<ServiceReminderOrderByRelationAggregateInput>;
  serviceCategory?: Maybe<ServiceCategoryOrderByWithRelationInput>;
  serviceCategoryId?: Maybe<SortOrder>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryOrderByRelationAggregateInput>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagOrderByRelationAggregateInput>;
  vetsourceFreeDoses?: Maybe<SortOrder>;
  vetsourcePaidDoses?: Maybe<SortOrder>;
  vetsourceQuantityOverride?: Maybe<SortOrder>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryOrderByWithRelationInput>;
  vetsourceRevenueCategoryName?: Maybe<SortOrder>;
};

export enum ServiceOrderByRelevanceFieldEnum {
  CanonicalServiceId = 'canonicalServiceId',
  Code = 'code',
  FormTemplateId = 'formTemplateId',
  Id = 'id',
  IntegrationId = 'integrationId',
  Name = 'name',
  PimsId = 'pimsId',
  PimsName = 'pimsName',
  PimsType = 'pimsType',
  ServiceCategoryId = 'serviceCategoryId',
  TaxonomyId = 'taxonomyId',
  VetsourceRevenueCategoryName = 'vetsourceRevenueCategoryName'
}

export type ServiceOrderByRelevanceInput = {
  fields: Array<ServiceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ServiceOrderByWithAggregationInput = {
  _avg?: Maybe<ServiceAvgOrderByAggregateInput>;
  _count?: Maybe<ServiceCountOrderByAggregateInput>;
  _max?: Maybe<ServiceMaxOrderByAggregateInput>;
  _min?: Maybe<ServiceMinOrderByAggregateInput>;
  _sum?: Maybe<ServiceSumOrderByAggregateInput>;
  canonicalServiceId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  formTemplateId?: Maybe<SortOrder>;
  hasConfiguredReminders?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isPetPortal?: Maybe<SortOrder>;
  isPostcard?: Maybe<SortOrder>;
  isReminderActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsType?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  reminderActivationDate?: Maybe<SortOrder>;
  serviceCategoryId?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourceFreeDoses?: Maybe<SortOrder>;
  vetsourcePaidDoses?: Maybe<SortOrder>;
  vetsourceQuantityOverride?: Maybe<SortOrder>;
  vetsourceRevenueCategoryName?: Maybe<SortOrder>;
};

export type ServiceOrderByWithRelationAndSearchRelevanceInput = {
  MedicalHistory?: Maybe<MedicalHistoryOrderByRelationAggregateInput>;
  _relevance?: Maybe<ServiceOrderByRelevanceInput>;
  canonicalService?: Maybe<CanonicalServiceOrderByWithRelationInput>;
  canonicalServiceId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  formTemplate?: Maybe<FormTemplateOrderByWithRelationInput>;
  formTemplateId?: Maybe<SortOrder>;
  hasConfiguredReminders?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  isDeleted?: Maybe<SortOrder>;
  isPetPortal?: Maybe<SortOrder>;
  isPostcard?: Maybe<SortOrder>;
  isReminderActive?: Maybe<SortOrder>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsType?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  rawPimsValue?: Maybe<SortOrder>;
  reminderActivationDate?: Maybe<SortOrder>;
  reminderTimings?: Maybe<ServiceReminderTimingOrderByRelationAggregateInput>;
  reminders?: Maybe<ServiceReminderOrderByRelationAggregateInput>;
  serviceCategory?: Maybe<ServiceCategoryOrderByWithRelationInput>;
  serviceCategoryId?: Maybe<SortOrder>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryOrderByRelationAggregateInput>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagOrderByRelationAggregateInput>;
  vetsourceFreeDoses?: Maybe<SortOrder>;
  vetsourcePaidDoses?: Maybe<SortOrder>;
  vetsourceQuantityOverride?: Maybe<SortOrder>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryOrderByWithRelationInput>;
  vetsourceRevenueCategoryName?: Maybe<SortOrder>;
};

export type ServiceOrderByWithRelationInput = {
  MedicalHistory?: Maybe<MedicalHistoryOrderByRelationAggregateInput>;
  _relevance?: Maybe<ServiceOrderByRelevanceInput>;
  canonicalService?: Maybe<CanonicalServiceOrderByWithRelationInput>;
  canonicalServiceId?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  formTemplate?: Maybe<FormTemplateOrderByWithRelationInput>;
  formTemplateId?: Maybe<SortOrder>;
  hasConfiguredReminders?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  invoiceLineItems?: Maybe<InvoiceLineItemOrderByRelationAggregateInput>;
  isDeleted?: Maybe<SortOrder>;
  isPetPortal?: Maybe<SortOrder>;
  isPostcard?: Maybe<SortOrder>;
  isReminderActive?: Maybe<SortOrder>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceOrderByRelationAggregateInput>;
  name?: Maybe<SortOrder>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  pimsType?: Maybe<SortOrder>;
  prescriptions?: Maybe<PrescriptionOrderByRelationAggregateInput>;
  rawPimsValue?: Maybe<SortOrder>;
  reminderActivationDate?: Maybe<SortOrder>;
  reminderTimings?: Maybe<ServiceReminderTimingOrderByRelationAggregateInput>;
  reminders?: Maybe<ServiceReminderOrderByRelationAggregateInput>;
  serviceCategory?: Maybe<ServiceCategoryOrderByWithRelationInput>;
  serviceCategoryId?: Maybe<SortOrder>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryOrderByRelationAggregateInput>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagOrderByRelationAggregateInput>;
  vetsourceFreeDoses?: Maybe<SortOrder>;
  vetsourcePaidDoses?: Maybe<SortOrder>;
  vetsourceQuantityOverride?: Maybe<SortOrder>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryOrderByWithRelationInput>;
  vetsourceRevenueCategoryName?: Maybe<SortOrder>;
};

export enum ServiceProvider {
  Bandwidth = 'Bandwidth',
  Twilio = 'Twilio'
}

export type ServicePurchaseSummary = {
  __typename?: 'ServicePurchaseSummary';
  _count: ServicePurchaseSummaryCountOutputType;
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  countInvoices: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  informAudienceMember: Array<InformAudienceMember>;
  invoice: Invoice;
  invoiceDate: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  lastAmount: Scalars['Float'];
  lastQuantity: Scalars['Float'];
  service: Service;
  serviceId: Scalars['String'];
  sumAmount: Scalars['Float'];
  sumQuantity: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};


export type ServicePurchaseSummaryInformAudienceMemberArgs = {
  cursor?: Maybe<InformAudienceMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAudienceMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAudienceMemberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAudienceMemberWhereInput>;
};

export type ServicePurchaseSummaryAvgAggregateOutputType = {
  __typename?: 'ServicePurchaseSummaryAvgAggregateOutputType';
  countInvoices?: Maybe<Scalars['Float']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
};

export type ServicePurchaseSummaryAvgOrderByAggregateInput = {
  countInvoices?: Maybe<SortOrder>;
  lastAmount?: Maybe<SortOrder>;
  lastQuantity?: Maybe<SortOrder>;
  sumAmount?: Maybe<SortOrder>;
  sumQuantity?: Maybe<SortOrder>;
};

export type ServicePurchaseSummaryClinicPetIdServiceIdCompoundUniqueInput = {
  clinicPetId: Scalars['String'];
  serviceId: Scalars['String'];
};

export type ServicePurchaseSummaryCountAggregateOutputType = {
  __typename?: 'ServicePurchaseSummaryCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  countInvoices: Scalars['Int'];
  createdAt: Scalars['Int'];
  expectedRefillDate: Scalars['Int'];
  id: Scalars['Int'];
  invoiceDate: Scalars['Int'];
  invoiceId: Scalars['Int'];
  lastAmount: Scalars['Int'];
  lastQuantity: Scalars['Int'];
  serviceId: Scalars['Int'];
  sumAmount: Scalars['Int'];
  sumQuantity: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ServicePurchaseSummaryCountOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  countInvoices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expectedRefillDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceDate?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  lastAmount?: Maybe<SortOrder>;
  lastQuantity?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  sumAmount?: Maybe<SortOrder>;
  sumQuantity?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServicePurchaseSummaryCountOutputType = {
  __typename?: 'ServicePurchaseSummaryCountOutputType';
  informAudienceMember: Scalars['Int'];
};

export type ServicePurchaseSummaryCreateInput = {
  clinicPet: ClinicPetCreateNestedOneWithoutServicePurchaseSummariesInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutServicePurchaseSummariesInput;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutServicePurchaseSummaryInput>;
  invoice: InvoiceCreateNestedOneWithoutServicePurchaseSummariesInput;
  invoiceDate: Scalars['DateTime'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  service: ServiceCreateNestedOneWithoutServicePurchaseSummariesInput;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryCreateManyClinicPetInput = {
  clinicPetParentId: Scalars['String'];
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId: Scalars['String'];
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryCreateManyClinicPetInputEnvelope = {
  data: Array<ServicePurchaseSummaryCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServicePurchaseSummaryCreateManyClinicPetParentInput = {
  clinicPetId: Scalars['String'];
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId: Scalars['String'];
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryCreateManyClinicPetParentInputEnvelope = {
  data: Array<ServicePurchaseSummaryCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServicePurchaseSummaryCreateManyInput = {
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId: Scalars['String'];
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryCreateManyInvoiceInput = {
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate: Scalars['DateTime'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId: Scalars['String'];
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryCreateManyInvoiceInputEnvelope = {
  data: Array<ServicePurchaseSummaryCreateManyInvoiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServicePurchaseSummaryCreateManyServiceInput = {
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryCreateManyServiceInputEnvelope = {
  data: Array<ServicePurchaseSummaryCreateManyServiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServicePurchaseSummaryCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyClinicPetInputEnvelope>;
};

export type ServicePurchaseSummaryCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyClinicPetParentInputEnvelope>;
};

export type ServicePurchaseSummaryCreateNestedManyWithoutInvoiceInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutInvoiceInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyInvoiceInputEnvelope>;
};

export type ServicePurchaseSummaryCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutServiceInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyServiceInputEnvelope>;
};

export type ServicePurchaseSummaryCreateNestedOneWithoutInformAudienceMemberInput = {
  connect?: Maybe<ServicePurchaseSummaryWhereUniqueInput>;
  connectOrCreate?: Maybe<ServicePurchaseSummaryCreateOrConnectWithoutInformAudienceMemberInput>;
  create?: Maybe<ServicePurchaseSummaryCreateWithoutInformAudienceMemberInput>;
};

export type ServicePurchaseSummaryCreateOrConnectWithoutClinicPetInput = {
  create: ServicePurchaseSummaryCreateWithoutClinicPetInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryCreateOrConnectWithoutClinicPetParentInput = {
  create: ServicePurchaseSummaryCreateWithoutClinicPetParentInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryCreateOrConnectWithoutInformAudienceMemberInput = {
  create: ServicePurchaseSummaryCreateWithoutInformAudienceMemberInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryCreateOrConnectWithoutInvoiceInput = {
  create: ServicePurchaseSummaryCreateWithoutInvoiceInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryCreateOrConnectWithoutServiceInput = {
  create: ServicePurchaseSummaryCreateWithoutServiceInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryCreateWithoutClinicPetInput = {
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutServicePurchaseSummariesInput;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutServicePurchaseSummaryInput>;
  invoice: InvoiceCreateNestedOneWithoutServicePurchaseSummariesInput;
  invoiceDate: Scalars['DateTime'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  service: ServiceCreateNestedOneWithoutServicePurchaseSummariesInput;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryCreateWithoutClinicPetParentInput = {
  clinicPet: ClinicPetCreateNestedOneWithoutServicePurchaseSummariesInput;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutServicePurchaseSummaryInput>;
  invoice: InvoiceCreateNestedOneWithoutServicePurchaseSummariesInput;
  invoiceDate: Scalars['DateTime'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  service: ServiceCreateNestedOneWithoutServicePurchaseSummariesInput;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryCreateWithoutInformAudienceMemberInput = {
  clinicPet: ClinicPetCreateNestedOneWithoutServicePurchaseSummariesInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutServicePurchaseSummariesInput;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoice: InvoiceCreateNestedOneWithoutServicePurchaseSummariesInput;
  invoiceDate: Scalars['DateTime'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  service: ServiceCreateNestedOneWithoutServicePurchaseSummariesInput;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryCreateWithoutInvoiceInput = {
  clinicPet: ClinicPetCreateNestedOneWithoutServicePurchaseSummariesInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutServicePurchaseSummariesInput;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutServicePurchaseSummaryInput>;
  invoiceDate: Scalars['DateTime'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  service: ServiceCreateNestedOneWithoutServicePurchaseSummariesInput;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryCreateWithoutServiceInput = {
  clinicPet: ClinicPetCreateNestedOneWithoutServicePurchaseSummariesInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutServicePurchaseSummariesInput;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberCreateNestedManyWithoutServicePurchaseSummaryInput>;
  invoice: InvoiceCreateNestedOneWithoutServicePurchaseSummariesInput;
  invoiceDate: Scalars['DateTime'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryGroupByOutputType = {
  __typename?: 'ServicePurchaseSummaryGroupByOutputType';
  _avg?: Maybe<ServicePurchaseSummaryAvgAggregateOutputType>;
  _count?: Maybe<ServicePurchaseSummaryCountAggregateOutputType>;
  _max?: Maybe<ServicePurchaseSummaryMaxAggregateOutputType>;
  _min?: Maybe<ServicePurchaseSummaryMinAggregateOutputType>;
  _sum?: Maybe<ServicePurchaseSummarySumAggregateOutputType>;
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  countInvoices: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  invoiceDate: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  lastAmount: Scalars['Float'];
  lastQuantity: Scalars['Float'];
  serviceId: Scalars['String'];
  sumAmount: Scalars['Float'];
  sumQuantity: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type ServicePurchaseSummaryListRelationFilter = {
  every?: Maybe<ServicePurchaseSummaryWhereInput>;
  none?: Maybe<ServicePurchaseSummaryWhereInput>;
  some?: Maybe<ServicePurchaseSummaryWhereInput>;
};

export type ServicePurchaseSummaryMaxAggregateOutputType = {
  __typename?: 'ServicePurchaseSummaryMaxAggregateOutputType';
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryMaxOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  countInvoices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expectedRefillDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceDate?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  lastAmount?: Maybe<SortOrder>;
  lastQuantity?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  sumAmount?: Maybe<SortOrder>;
  sumQuantity?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServicePurchaseSummaryMinAggregateOutputType = {
  __typename?: 'ServicePurchaseSummaryMinAggregateOutputType';
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryMinOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  countInvoices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expectedRefillDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceDate?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  lastAmount?: Maybe<SortOrder>;
  lastQuantity?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  sumAmount?: Maybe<SortOrder>;
  sumQuantity?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServicePurchaseSummaryNullableScalarRelationFilter = {
  AND?: Maybe<Array<ServicePurchaseSummaryWhereInput>>;
  NOT?: Maybe<Array<ServicePurchaseSummaryWhereInput>>;
  OR?: Maybe<Array<ServicePurchaseSummaryWhereInput>>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  countInvoices?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expectedRefillDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceDate?: Maybe<DateTimeFilter>;
  invoiceId?: Maybe<StringFilter>;
  lastAmount?: Maybe<FloatFilter>;
  lastQuantity?: Maybe<FloatFilter>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
  sumAmount?: Maybe<FloatFilter>;
  sumQuantity?: Maybe<FloatFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServicePurchaseSummaryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ServicePurchaseSummaryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ServicePurchaseSummaryOrderByRelevanceInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  countInvoices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expectedRefillDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceDate?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  lastAmount?: Maybe<SortOrder>;
  lastQuantity?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  sumAmount?: Maybe<SortOrder>;
  sumQuantity?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ServicePurchaseSummaryOrderByRelevanceFieldEnum {
  ClinicPetId = 'clinicPetId',
  ClinicPetParentId = 'clinicPetParentId',
  Id = 'id',
  InvoiceId = 'invoiceId',
  ServiceId = 'serviceId'
}

export type ServicePurchaseSummaryOrderByRelevanceInput = {
  fields: Array<ServicePurchaseSummaryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ServicePurchaseSummaryOrderByWithAggregationInput = {
  _avg?: Maybe<ServicePurchaseSummaryAvgOrderByAggregateInput>;
  _count?: Maybe<ServicePurchaseSummaryCountOrderByAggregateInput>;
  _max?: Maybe<ServicePurchaseSummaryMaxOrderByAggregateInput>;
  _min?: Maybe<ServicePurchaseSummaryMinOrderByAggregateInput>;
  _sum?: Maybe<ServicePurchaseSummarySumOrderByAggregateInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  countInvoices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expectedRefillDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoiceDate?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  lastAmount?: Maybe<SortOrder>;
  lastQuantity?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  sumAmount?: Maybe<SortOrder>;
  sumQuantity?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServicePurchaseSummaryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ServicePurchaseSummaryOrderByRelevanceInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  countInvoices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expectedRefillDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceDate?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  lastAmount?: Maybe<SortOrder>;
  lastQuantity?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  sumAmount?: Maybe<SortOrder>;
  sumQuantity?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServicePurchaseSummaryOrderByWithRelationInput = {
  _relevance?: Maybe<ServicePurchaseSummaryOrderByRelevanceInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  countInvoices?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expectedRefillDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceMember?: Maybe<InformAudienceMemberOrderByRelationAggregateInput>;
  invoice?: Maybe<InvoiceOrderByWithRelationInput>;
  invoiceDate?: Maybe<SortOrder>;
  invoiceId?: Maybe<SortOrder>;
  lastAmount?: Maybe<SortOrder>;
  lastQuantity?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  sumAmount?: Maybe<SortOrder>;
  sumQuantity?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ServicePurchaseSummaryScalarFieldEnum {
  ClinicPetId = 'clinicPetId',
  ClinicPetParentId = 'clinicPetParentId',
  CountInvoices = 'countInvoices',
  CreatedAt = 'createdAt',
  ExpectedRefillDate = 'expectedRefillDate',
  Id = 'id',
  InvoiceDate = 'invoiceDate',
  InvoiceId = 'invoiceId',
  LastAmount = 'lastAmount',
  LastQuantity = 'lastQuantity',
  ServiceId = 'serviceId',
  SumAmount = 'sumAmount',
  SumQuantity = 'sumQuantity',
  UpdatedAt = 'updatedAt'
}

export type ServicePurchaseSummaryScalarWhereInput = {
  AND?: Maybe<Array<ServicePurchaseSummaryScalarWhereInput>>;
  NOT?: Maybe<Array<ServicePurchaseSummaryScalarWhereInput>>;
  OR?: Maybe<Array<ServicePurchaseSummaryScalarWhereInput>>;
  clinicPetId?: Maybe<StringFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  countInvoices?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expectedRefillDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  invoiceDate?: Maybe<DateTimeFilter>;
  invoiceId?: Maybe<StringFilter>;
  lastAmount?: Maybe<FloatFilter>;
  lastQuantity?: Maybe<FloatFilter>;
  serviceId?: Maybe<StringFilter>;
  sumAmount?: Maybe<FloatFilter>;
  sumQuantity?: Maybe<FloatFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServicePurchaseSummaryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ServicePurchaseSummaryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ServicePurchaseSummaryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ServicePurchaseSummaryScalarWhereWithAggregatesInput>>;
  clinicPetId?: Maybe<StringWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  countInvoices?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  expectedRefillDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  invoiceDate?: Maybe<DateTimeWithAggregatesFilter>;
  invoiceId?: Maybe<StringWithAggregatesFilter>;
  lastAmount?: Maybe<FloatWithAggregatesFilter>;
  lastQuantity?: Maybe<FloatWithAggregatesFilter>;
  serviceId?: Maybe<StringWithAggregatesFilter>;
  sumAmount?: Maybe<FloatWithAggregatesFilter>;
  sumQuantity?: Maybe<FloatWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ServicePurchaseSummarySumAggregateOutputType = {
  __typename?: 'ServicePurchaseSummarySumAggregateOutputType';
  countInvoices?: Maybe<Scalars['Int']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
};

export type ServicePurchaseSummarySumOrderByAggregateInput = {
  countInvoices?: Maybe<SortOrder>;
  lastAmount?: Maybe<SortOrder>;
  lastQuantity?: Maybe<SortOrder>;
  sumAmount?: Maybe<SortOrder>;
  sumQuantity?: Maybe<SortOrder>;
};

export type ServicePurchaseSummaryUncheckedCreateInput = {
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutServicePurchaseSummaryInput>;
  invoiceDate: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId: Scalars['String'];
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyClinicPetInputEnvelope>;
};

export type ServicePurchaseSummaryUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyClinicPetParentInputEnvelope>;
};

export type ServicePurchaseSummaryUncheckedCreateNestedManyWithoutInvoiceInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutInvoiceInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyInvoiceInputEnvelope>;
};

export type ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutServiceInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyServiceInputEnvelope>;
};

export type ServicePurchaseSummaryUncheckedCreateWithoutClinicPetInput = {
  clinicPetParentId: Scalars['String'];
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutServicePurchaseSummaryInput>;
  invoiceDate: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId: Scalars['String'];
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedCreateWithoutClinicPetParentInput = {
  clinicPetId: Scalars['String'];
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutServicePurchaseSummaryInput>;
  invoiceDate: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId: Scalars['String'];
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedCreateWithoutInformAudienceMemberInput = {
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId: Scalars['String'];
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedCreateWithoutInvoiceInput = {
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutServicePurchaseSummaryInput>;
  invoiceDate: Scalars['DateTime'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId: Scalars['String'];
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedCreateWithoutServiceInput = {
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedCreateNestedManyWithoutServicePurchaseSummaryInput>;
  invoiceDate: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedUpdateInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutServicePurchaseSummaryNestedInput>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedUpdateManyInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServicePurchaseSummaryScalarWhereInput>>;
  disconnect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  set?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  update?: Maybe<Array<ServicePurchaseSummaryUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<ServicePurchaseSummaryUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<ServicePurchaseSummaryUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServicePurchaseSummaryScalarWhereInput>>;
  disconnect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  set?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  update?: Maybe<Array<ServicePurchaseSummaryUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ServicePurchaseSummaryUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ServicePurchaseSummaryUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedUpdateManyWithoutInvoiceNestedInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutInvoiceInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyInvoiceInputEnvelope>;
  delete?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServicePurchaseSummaryScalarWhereInput>>;
  disconnect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  set?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  update?: Maybe<Array<ServicePurchaseSummaryUpdateWithWhereUniqueWithoutInvoiceInput>>;
  updateMany?: Maybe<Array<ServicePurchaseSummaryUpdateManyWithWhereWithoutInvoiceInput>>;
  upsert?: Maybe<Array<ServicePurchaseSummaryUpsertWithWhereUniqueWithoutInvoiceInput>>;
};

export type ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutServiceInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServicePurchaseSummaryScalarWhereInput>>;
  disconnect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  set?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  update?: Maybe<Array<ServicePurchaseSummaryUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<ServicePurchaseSummaryUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<ServicePurchaseSummaryUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type ServicePurchaseSummaryUncheckedUpdateWithoutClinicPetInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutServicePurchaseSummaryNestedInput>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedUpdateWithoutClinicPetParentInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutServicePurchaseSummaryNestedInput>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedUpdateWithoutInformAudienceMemberInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedUpdateWithoutInvoiceInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutServicePurchaseSummaryNestedInput>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUncheckedUpdateWithoutServiceInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUncheckedUpdateManyWithoutServicePurchaseSummaryNestedInput>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['String']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUpdateInput = {
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutServicePurchaseSummaryNestedInput>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUpdateManyMutationInput = {
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUpdateManyWithWhereWithoutClinicPetInput = {
  data: ServicePurchaseSummaryUpdateManyMutationInput;
  where: ServicePurchaseSummaryScalarWhereInput;
};

export type ServicePurchaseSummaryUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: ServicePurchaseSummaryUpdateManyMutationInput;
  where: ServicePurchaseSummaryScalarWhereInput;
};

export type ServicePurchaseSummaryUpdateManyWithWhereWithoutInvoiceInput = {
  data: ServicePurchaseSummaryUpdateManyMutationInput;
  where: ServicePurchaseSummaryScalarWhereInput;
};

export type ServicePurchaseSummaryUpdateManyWithWhereWithoutServiceInput = {
  data: ServicePurchaseSummaryUpdateManyMutationInput;
  where: ServicePurchaseSummaryScalarWhereInput;
};

export type ServicePurchaseSummaryUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServicePurchaseSummaryScalarWhereInput>>;
  disconnect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  set?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  update?: Maybe<Array<ServicePurchaseSummaryUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<ServicePurchaseSummaryUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<ServicePurchaseSummaryUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type ServicePurchaseSummaryUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServicePurchaseSummaryScalarWhereInput>>;
  disconnect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  set?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  update?: Maybe<Array<ServicePurchaseSummaryUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ServicePurchaseSummaryUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ServicePurchaseSummaryUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ServicePurchaseSummaryUpdateManyWithoutInvoiceNestedInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutInvoiceInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutInvoiceInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyInvoiceInputEnvelope>;
  delete?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServicePurchaseSummaryScalarWhereInput>>;
  disconnect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  set?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  update?: Maybe<Array<ServicePurchaseSummaryUpdateWithWhereUniqueWithoutInvoiceInput>>;
  updateMany?: Maybe<Array<ServicePurchaseSummaryUpdateManyWithWhereWithoutInvoiceInput>>;
  upsert?: Maybe<Array<ServicePurchaseSummaryUpsertWithWhereUniqueWithoutInvoiceInput>>;
};

export type ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServicePurchaseSummaryCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<ServicePurchaseSummaryCreateWithoutServiceInput>>;
  createMany?: Maybe<ServicePurchaseSummaryCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServicePurchaseSummaryScalarWhereInput>>;
  disconnect?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  set?: Maybe<Array<ServicePurchaseSummaryWhereUniqueInput>>;
  update?: Maybe<Array<ServicePurchaseSummaryUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<ServicePurchaseSummaryUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<ServicePurchaseSummaryUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type ServicePurchaseSummaryUpdateOneWithoutInformAudienceMemberNestedInput = {
  connect?: Maybe<ServicePurchaseSummaryWhereUniqueInput>;
  connectOrCreate?: Maybe<ServicePurchaseSummaryCreateOrConnectWithoutInformAudienceMemberInput>;
  create?: Maybe<ServicePurchaseSummaryCreateWithoutInformAudienceMemberInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServicePurchaseSummaryUpdateToOneWithWhereWithoutInformAudienceMemberInput>;
  upsert?: Maybe<ServicePurchaseSummaryUpsertWithoutInformAudienceMemberInput>;
};

export type ServicePurchaseSummaryUpdateToOneWithWhereWithoutInformAudienceMemberInput = {
  data: ServicePurchaseSummaryUpdateWithoutInformAudienceMemberInput;
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};

export type ServicePurchaseSummaryUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: ServicePurchaseSummaryUpdateWithoutClinicPetInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: ServicePurchaseSummaryUpdateWithoutClinicPetParentInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryUpdateWithWhereUniqueWithoutInvoiceInput = {
  data: ServicePurchaseSummaryUpdateWithoutInvoiceInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryUpdateWithWhereUniqueWithoutServiceInput = {
  data: ServicePurchaseSummaryUpdateWithoutServiceInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryUpdateWithoutClinicPetInput = {
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutServicePurchaseSummaryNestedInput>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUpdateWithoutClinicPetParentInput = {
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutServicePurchaseSummaryNestedInput>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUpdateWithoutInformAudienceMemberInput = {
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUpdateWithoutInvoiceInput = {
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutServicePurchaseSummaryNestedInput>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUpdateWithoutServiceInput = {
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  countInvoices?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expectedRefillDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberUpdateManyWithoutServicePurchaseSummaryNestedInput>;
  invoice?: Maybe<InvoiceUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  lastAmount?: Maybe<Scalars['Float']>;
  lastQuantity?: Maybe<Scalars['Float']>;
  sumAmount?: Maybe<Scalars['Float']>;
  sumQuantity?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServicePurchaseSummaryUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: ServicePurchaseSummaryCreateWithoutClinicPetInput;
  update: ServicePurchaseSummaryUpdateWithoutClinicPetInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: ServicePurchaseSummaryCreateWithoutClinicPetParentInput;
  update: ServicePurchaseSummaryUpdateWithoutClinicPetParentInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryUpsertWithWhereUniqueWithoutInvoiceInput = {
  create: ServicePurchaseSummaryCreateWithoutInvoiceInput;
  update: ServicePurchaseSummaryUpdateWithoutInvoiceInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryUpsertWithWhereUniqueWithoutServiceInput = {
  create: ServicePurchaseSummaryCreateWithoutServiceInput;
  update: ServicePurchaseSummaryUpdateWithoutServiceInput;
  where: ServicePurchaseSummaryWhereUniqueInput;
};

export type ServicePurchaseSummaryUpsertWithoutInformAudienceMemberInput = {
  create: ServicePurchaseSummaryCreateWithoutInformAudienceMemberInput;
  update: ServicePurchaseSummaryUpdateWithoutInformAudienceMemberInput;
  where?: Maybe<ServicePurchaseSummaryWhereInput>;
};

export type ServicePurchaseSummaryWhereInput = {
  AND?: Maybe<Array<ServicePurchaseSummaryWhereInput>>;
  NOT?: Maybe<Array<ServicePurchaseSummaryWhereInput>>;
  OR?: Maybe<Array<ServicePurchaseSummaryWhereInput>>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  countInvoices?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expectedRefillDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceDate?: Maybe<DateTimeFilter>;
  invoiceId?: Maybe<StringFilter>;
  lastAmount?: Maybe<FloatFilter>;
  lastQuantity?: Maybe<FloatFilter>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
  sumAmount?: Maybe<FloatFilter>;
  sumQuantity?: Maybe<FloatFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServicePurchaseSummaryWhereUniqueInput = {
  AND?: Maybe<Array<ServicePurchaseSummaryWhereInput>>;
  NOT?: Maybe<Array<ServicePurchaseSummaryWhereInput>>;
  OR?: Maybe<Array<ServicePurchaseSummaryWhereInput>>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  clinicPetId_serviceId?: Maybe<ServicePurchaseSummaryClinicPetIdServiceIdCompoundUniqueInput>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  countInvoices?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expectedRefillDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  informAudienceMember?: Maybe<InformAudienceMemberListRelationFilter>;
  invoice?: Maybe<InvoiceScalarRelationFilter>;
  invoiceDate?: Maybe<DateTimeFilter>;
  invoiceId?: Maybe<StringFilter>;
  lastAmount?: Maybe<FloatFilter>;
  lastQuantity?: Maybe<FloatFilter>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
  sumAmount?: Maybe<FloatFilter>;
  sumQuantity?: Maybe<FloatFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServiceReminder = {
  __typename?: 'ServiceReminder';
  _count: ServiceReminderCountOutputType;
  automationRuns: Array<AutomationRun>;
  channelAutomationStatuses: Array<ChannelAutomationStatus>;
  channelCreationSources: Array<ChannelCreationSource>;
  clinicPet?: Maybe<ClinicPet>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded: Scalars['Boolean'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isCompleted: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  notifications: Array<ServiceReminderNotification>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service: Service;
  serviceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type ServiceReminderAutomationRunsArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type ServiceReminderChannelAutomationStatusesArgs = {
  cursor?: Maybe<ChannelAutomationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelAutomationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelAutomationStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type ServiceReminderChannelCreationSourcesArgs = {
  cursor?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelCreationSourceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelCreationSourceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type ServiceReminderClinicPetArgs = {
  where?: Maybe<ClinicPetWhereInput>;
};


export type ServiceReminderClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type ServiceReminderNotificationsArgs = {
  cursor?: Maybe<ServiceReminderNotificationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderNotificationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderNotificationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};

export type ServiceReminderCountAggregateOutputType = {
  __typename?: 'ServiceReminderCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  dateLastGiven: Scalars['Int'];
  dueDate: Scalars['Int'];
  hasResponded: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isCompleted: Scalars['Int'];
  isDeleted: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  resourceUid: Scalars['Int'];
  serviceId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ServiceReminderCountOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dateLastGiven?: Maybe<SortOrder>;
  dueDate?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isCompleted?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderCountOutputType = {
  __typename?: 'ServiceReminderCountOutputType';
  automationRuns: Scalars['Int'];
  channelAutomationStatuses: Scalars['Int'];
  channelCreationSources: Scalars['Int'];
  notifications: Scalars['Int'];
};

export type ServiceReminderCreateInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutServiceReminderInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutServiceRemindersInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutServiceRemindersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceRemindersInput;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service: ServiceCreateNestedOneWithoutRemindersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateManyClinicPetInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateManyClinicPetInputEnvelope = {
  data: Array<ServiceReminderCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceReminderCreateManyClinicPetParentInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateManyClinicPetParentInputEnvelope = {
  data: Array<ServiceReminderCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceReminderCreateManyInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateManyIntegrationInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateManyIntegrationInputEnvelope = {
  data: Array<ServiceReminderCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceReminderCreateManyServiceInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateManyServiceInputEnvelope = {
  data: Array<ServiceReminderCreateManyServiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceReminderCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ServiceReminderCreateManyClinicPetInputEnvelope>;
};

export type ServiceReminderCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ServiceReminderCreateManyClinicPetParentInputEnvelope>;
};

export type ServiceReminderCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ServiceReminderCreateManyIntegrationInputEnvelope>;
};

export type ServiceReminderCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutServiceInput>>;
  createMany?: Maybe<ServiceReminderCreateManyServiceInputEnvelope>;
};

export type ServiceReminderCreateNestedOneWithoutAutomationRunsInput = {
  connect?: Maybe<ServiceReminderWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceReminderCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<ServiceReminderCreateWithoutAutomationRunsInput>;
};

export type ServiceReminderCreateNestedOneWithoutChannelAutomationStatusesInput = {
  connect?: Maybe<ServiceReminderWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceReminderCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<ServiceReminderCreateWithoutChannelAutomationStatusesInput>;
};

export type ServiceReminderCreateNestedOneWithoutChannelCreationSourcesInput = {
  connect?: Maybe<ServiceReminderWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceReminderCreateOrConnectWithoutChannelCreationSourcesInput>;
  create?: Maybe<ServiceReminderCreateWithoutChannelCreationSourcesInput>;
};

export type ServiceReminderCreateNestedOneWithoutNotificationsInput = {
  connect?: Maybe<ServiceReminderWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceReminderCreateOrConnectWithoutNotificationsInput>;
  create?: Maybe<ServiceReminderCreateWithoutNotificationsInput>;
};

export type ServiceReminderCreateOrConnectWithoutAutomationRunsInput = {
  create: ServiceReminderCreateWithoutAutomationRunsInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderCreateOrConnectWithoutChannelAutomationStatusesInput = {
  create: ServiceReminderCreateWithoutChannelAutomationStatusesInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderCreateOrConnectWithoutChannelCreationSourcesInput = {
  create: ServiceReminderCreateWithoutChannelCreationSourcesInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderCreateOrConnectWithoutClinicPetInput = {
  create: ServiceReminderCreateWithoutClinicPetInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderCreateOrConnectWithoutClinicPetParentInput = {
  create: ServiceReminderCreateWithoutClinicPetParentInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderCreateOrConnectWithoutIntegrationInput = {
  create: ServiceReminderCreateWithoutIntegrationInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderCreateOrConnectWithoutNotificationsInput = {
  create: ServiceReminderCreateWithoutNotificationsInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderCreateOrConnectWithoutServiceInput = {
  create: ServiceReminderCreateWithoutServiceInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderCreateWithoutAutomationRunsInput = {
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutServiceReminderInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutServiceRemindersInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutServiceRemindersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceRemindersInput;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service: ServiceCreateNestedOneWithoutRemindersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateWithoutChannelAutomationStatusesInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutServiceReminderInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutServiceRemindersInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutServiceRemindersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceRemindersInput;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service: ServiceCreateNestedOneWithoutRemindersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateWithoutChannelCreationSourcesInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutServiceReminderInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutServiceRemindersInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutServiceRemindersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceRemindersInput;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service: ServiceCreateNestedOneWithoutRemindersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateWithoutClinicPetInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutServiceReminderInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutServiceRemindersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceRemindersInput;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service: ServiceCreateNestedOneWithoutRemindersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateWithoutClinicPetParentInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutServiceReminderInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutServiceRemindersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceRemindersInput;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service: ServiceCreateNestedOneWithoutRemindersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateWithoutIntegrationInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutServiceReminderInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutServiceRemindersInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutServiceRemindersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service: ServiceCreateNestedOneWithoutRemindersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateWithoutNotificationsInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutServiceReminderInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutServiceRemindersInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutServiceRemindersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceRemindersInput;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service: ServiceCreateNestedOneWithoutRemindersInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderCreateWithoutServiceInput = {
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutServiceReminderInput>;
  clinicPet?: Maybe<ClinicPetCreateNestedOneWithoutServiceRemindersInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutServiceRemindersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutServiceRemindersInput;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderGroupByOutputType = {
  __typename?: 'ServiceReminderGroupByOutputType';
  _count?: Maybe<ServiceReminderCountAggregateOutputType>;
  _max?: Maybe<ServiceReminderMaxAggregateOutputType>;
  _min?: Maybe<ServiceReminderMinAggregateOutputType>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded: Scalars['Boolean'];
  id: Scalars['String'];
  integrationId: Scalars['String'];
  isCompleted: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ServiceReminderListRelationFilter = {
  every?: Maybe<ServiceReminderWhereInput>;
  none?: Maybe<ServiceReminderWhereInput>;
  some?: Maybe<ServiceReminderWhereInput>;
};

export type ServiceReminderMaxAggregateOutputType = {
  __typename?: 'ServiceReminderMaxAggregateOutputType';
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderMaxOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dateLastGiven?: Maybe<SortOrder>;
  dueDate?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isCompleted?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderMinAggregateOutputType = {
  __typename?: 'ServiceReminderMinAggregateOutputType';
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderMinOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dateLastGiven?: Maybe<SortOrder>;
  dueDate?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isCompleted?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderNotification = {
  __typename?: 'ServiceReminderNotification';
  _count: ServiceReminderNotificationCountOutputType;
  bundledNotifications: Array<ServiceReminderNotification>;
  createdAt: Scalars['DateTime'];
  formSubmission?: Maybe<FormSubmission>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded: Scalars['Boolean'];
  id: Scalars['String'];
  notificationType: ServiceReminderNotificationType;
  parentNotification?: Maybe<ServiceReminderNotification>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt: Scalars['DateTime'];
  queued: Scalars['Boolean'];
  serviceReminder: ServiceReminder;
  serviceReminderId: Scalars['String'];
  timing?: Maybe<ServiceReminderTiming>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type ServiceReminderNotificationBundledNotificationsArgs = {
  cursor?: Maybe<ServiceReminderNotificationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderNotificationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderNotificationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};


export type ServiceReminderNotificationFormSubmissionArgs = {
  where?: Maybe<FormSubmissionWhereInput>;
};


export type ServiceReminderNotificationParentNotificationArgs = {
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};


export type ServiceReminderNotificationTimingArgs = {
  where?: Maybe<ServiceReminderTimingWhereInput>;
};

export type ServiceReminderNotificationCountAggregateOutputType = {
  __typename?: 'ServiceReminderNotificationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  formSubmissionId: Scalars['Int'];
  hasResponded: Scalars['Int'];
  id: Scalars['Int'];
  notificationType: Scalars['Int'];
  parentNotificationId: Scalars['Int'];
  queueAt: Scalars['Int'];
  queued: Scalars['Int'];
  serviceReminderId: Scalars['Int'];
  timingId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ServiceReminderNotificationCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notificationType?: Maybe<SortOrder>;
  parentNotificationId?: Maybe<SortOrder>;
  queueAt?: Maybe<SortOrder>;
  queued?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  timingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderNotificationCountOutputType = {
  __typename?: 'ServiceReminderNotificationCountOutputType';
  bundledNotifications: Scalars['Int'];
};

export type ServiceReminderNotificationCreateInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutParentNotificationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutServiceReminderNotificationsInput>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotification?: Maybe<ServiceReminderNotificationCreateNestedOneWithoutBundledNotificationsInput>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminder: ServiceReminderCreateNestedOneWithoutNotificationsInput;
  timing?: Maybe<ServiceReminderTimingCreateNestedOneWithoutNotificationsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationCreateManyFormSubmissionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId: Scalars['String'];
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationCreateManyFormSubmissionInputEnvelope = {
  data: Array<ServiceReminderNotificationCreateManyFormSubmissionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceReminderNotificationCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId: Scalars['String'];
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationCreateManyParentNotificationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId: Scalars['String'];
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationCreateManyParentNotificationInputEnvelope = {
  data: Array<ServiceReminderNotificationCreateManyParentNotificationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceReminderNotificationCreateManyServiceReminderInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationCreateManyServiceReminderInputEnvelope = {
  data: Array<ServiceReminderNotificationCreateManyServiceReminderInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceReminderNotificationCreateManyTimingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationCreateManyTimingInputEnvelope = {
  data: Array<ServiceReminderNotificationCreateManyTimingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceReminderNotificationCreateNestedManyWithoutFormSubmissionInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyFormSubmissionInputEnvelope>;
};

export type ServiceReminderNotificationCreateNestedManyWithoutParentNotificationInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutParentNotificationInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutParentNotificationInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyParentNotificationInputEnvelope>;
};

export type ServiceReminderNotificationCreateNestedManyWithoutServiceReminderInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyServiceReminderInputEnvelope>;
};

export type ServiceReminderNotificationCreateNestedManyWithoutTimingInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutTimingInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutTimingInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyTimingInputEnvelope>;
};

export type ServiceReminderNotificationCreateNestedOneWithoutBundledNotificationsInput = {
  connect?: Maybe<ServiceReminderNotificationWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceReminderNotificationCreateOrConnectWithoutBundledNotificationsInput>;
  create?: Maybe<ServiceReminderNotificationCreateWithoutBundledNotificationsInput>;
};

export type ServiceReminderNotificationCreateOrConnectWithoutBundledNotificationsInput = {
  create: ServiceReminderNotificationCreateWithoutBundledNotificationsInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationCreateOrConnectWithoutFormSubmissionInput = {
  create: ServiceReminderNotificationCreateWithoutFormSubmissionInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationCreateOrConnectWithoutParentNotificationInput = {
  create: ServiceReminderNotificationCreateWithoutParentNotificationInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationCreateOrConnectWithoutServiceReminderInput = {
  create: ServiceReminderNotificationCreateWithoutServiceReminderInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationCreateOrConnectWithoutTimingInput = {
  create: ServiceReminderNotificationCreateWithoutTimingInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationCreateWithoutBundledNotificationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutServiceReminderNotificationsInput>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotification?: Maybe<ServiceReminderNotificationCreateNestedOneWithoutBundledNotificationsInput>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminder: ServiceReminderCreateNestedOneWithoutNotificationsInput;
  timing?: Maybe<ServiceReminderTimingCreateNestedOneWithoutNotificationsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationCreateWithoutFormSubmissionInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutParentNotificationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotification?: Maybe<ServiceReminderNotificationCreateNestedOneWithoutBundledNotificationsInput>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminder: ServiceReminderCreateNestedOneWithoutNotificationsInput;
  timing?: Maybe<ServiceReminderTimingCreateNestedOneWithoutNotificationsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationCreateWithoutParentNotificationInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutParentNotificationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutServiceReminderNotificationsInput>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminder: ServiceReminderCreateNestedOneWithoutNotificationsInput;
  timing?: Maybe<ServiceReminderTimingCreateNestedOneWithoutNotificationsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationCreateWithoutServiceReminderInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutParentNotificationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutServiceReminderNotificationsInput>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotification?: Maybe<ServiceReminderNotificationCreateNestedOneWithoutBundledNotificationsInput>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  timing?: Maybe<ServiceReminderTimingCreateNestedOneWithoutNotificationsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationCreateWithoutTimingInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutParentNotificationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionCreateNestedOneWithoutServiceReminderNotificationsInput>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotification?: Maybe<ServiceReminderNotificationCreateNestedOneWithoutBundledNotificationsInput>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminder: ServiceReminderCreateNestedOneWithoutNotificationsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationGroupByOutputType = {
  __typename?: 'ServiceReminderNotificationGroupByOutputType';
  _count?: Maybe<ServiceReminderNotificationCountAggregateOutputType>;
  _max?: Maybe<ServiceReminderNotificationMaxAggregateOutputType>;
  _min?: Maybe<ServiceReminderNotificationMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded: Scalars['Boolean'];
  id: Scalars['String'];
  notificationType: ServiceReminderNotificationType;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt: Scalars['DateTime'];
  queued: Scalars['Boolean'];
  serviceReminderId: Scalars['String'];
  timingId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ServiceReminderNotificationListRelationFilter = {
  every?: Maybe<ServiceReminderNotificationWhereInput>;
  none?: Maybe<ServiceReminderNotificationWhereInput>;
  some?: Maybe<ServiceReminderNotificationWhereInput>;
};

export type ServiceReminderNotificationMaxAggregateOutputType = {
  __typename?: 'ServiceReminderNotificationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notificationType?: Maybe<SortOrder>;
  parentNotificationId?: Maybe<SortOrder>;
  queueAt?: Maybe<SortOrder>;
  queued?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  timingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderNotificationMinAggregateOutputType = {
  __typename?: 'ServiceReminderNotificationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notificationType?: Maybe<SortOrder>;
  parentNotificationId?: Maybe<SortOrder>;
  queueAt?: Maybe<SortOrder>;
  queued?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  timingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderNotificationNullableScalarRelationFilter = {
  AND?: Maybe<Array<ServiceReminderNotificationWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderNotificationWhereInput>>;
  OR?: Maybe<Array<ServiceReminderNotificationWhereInput>>;
  bundledNotifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  hasResponded?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  notificationType?: Maybe<EnumServiceReminderNotificationTypeFilter>;
  parentNotification?: Maybe<ServiceReminderNotificationNullableScalarRelationFilter>;
  parentNotificationId?: Maybe<StringNullableFilter>;
  queueAt?: Maybe<DateTimeFilter>;
  queued?: Maybe<BoolFilter>;
  serviceReminder?: Maybe<ServiceReminderScalarRelationFilter>;
  serviceReminderId?: Maybe<StringFilter>;
  timing?: Maybe<ServiceReminderTimingNullableScalarRelationFilter>;
  timingId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServiceReminderNotificationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ServiceReminderNotificationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ServiceReminderNotificationOrderByRelevanceInput>;
  bundledNotifications?: Maybe<ServiceReminderNotificationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notificationType?: Maybe<SortOrder>;
  parentNotification?: Maybe<ServiceReminderNotificationOrderByWithRelationInput>;
  parentNotificationId?: Maybe<SortOrder>;
  queueAt?: Maybe<SortOrder>;
  queued?: Maybe<SortOrder>;
  serviceReminder?: Maybe<ServiceReminderOrderByWithRelationInput>;
  serviceReminderId?: Maybe<SortOrder>;
  timing?: Maybe<ServiceReminderTimingOrderByWithRelationInput>;
  timingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ServiceReminderNotificationOrderByRelevanceFieldEnum {
  FormSubmissionId = 'formSubmissionId',
  Id = 'id',
  ParentNotificationId = 'parentNotificationId',
  ServiceReminderId = 'serviceReminderId',
  TimingId = 'timingId'
}

export type ServiceReminderNotificationOrderByRelevanceInput = {
  fields: Array<ServiceReminderNotificationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ServiceReminderNotificationOrderByWithAggregationInput = {
  _count?: Maybe<ServiceReminderNotificationCountOrderByAggregateInput>;
  _max?: Maybe<ServiceReminderNotificationMaxOrderByAggregateInput>;
  _min?: Maybe<ServiceReminderNotificationMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  formSubmissionId?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notificationType?: Maybe<SortOrder>;
  parentNotificationId?: Maybe<SortOrder>;
  queueAt?: Maybe<SortOrder>;
  queued?: Maybe<SortOrder>;
  serviceReminderId?: Maybe<SortOrder>;
  timingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderNotificationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ServiceReminderNotificationOrderByRelevanceInput>;
  bundledNotifications?: Maybe<ServiceReminderNotificationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notificationType?: Maybe<SortOrder>;
  parentNotification?: Maybe<ServiceReminderNotificationOrderByWithRelationInput>;
  parentNotificationId?: Maybe<SortOrder>;
  queueAt?: Maybe<SortOrder>;
  queued?: Maybe<SortOrder>;
  serviceReminder?: Maybe<ServiceReminderOrderByWithRelationInput>;
  serviceReminderId?: Maybe<SortOrder>;
  timing?: Maybe<ServiceReminderTimingOrderByWithRelationInput>;
  timingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderNotificationOrderByWithRelationInput = {
  _relevance?: Maybe<ServiceReminderNotificationOrderByRelevanceInput>;
  bundledNotifications?: Maybe<ServiceReminderNotificationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  formSubmission?: Maybe<FormSubmissionOrderByWithRelationInput>;
  formSubmissionId?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  notificationType?: Maybe<SortOrder>;
  parentNotification?: Maybe<ServiceReminderNotificationOrderByWithRelationInput>;
  parentNotificationId?: Maybe<SortOrder>;
  queueAt?: Maybe<SortOrder>;
  queued?: Maybe<SortOrder>;
  serviceReminder?: Maybe<ServiceReminderOrderByWithRelationInput>;
  serviceReminderId?: Maybe<SortOrder>;
  timing?: Maybe<ServiceReminderTimingOrderByWithRelationInput>;
  timingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ServiceReminderNotificationScalarFieldEnum {
  CreatedAt = 'createdAt',
  FormSubmissionId = 'formSubmissionId',
  HasResponded = 'hasResponded',
  Id = 'id',
  NotificationType = 'notificationType',
  ParentNotificationId = 'parentNotificationId',
  QueueAt = 'queueAt',
  Queued = 'queued',
  ServiceReminderId = 'serviceReminderId',
  TimingId = 'timingId',
  UpdatedAt = 'updatedAt'
}

export type ServiceReminderNotificationScalarWhereInput = {
  AND?: Maybe<Array<ServiceReminderNotificationScalarWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderNotificationScalarWhereInput>>;
  OR?: Maybe<Array<ServiceReminderNotificationScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  hasResponded?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  notificationType?: Maybe<EnumServiceReminderNotificationTypeFilter>;
  parentNotificationId?: Maybe<StringNullableFilter>;
  queueAt?: Maybe<DateTimeFilter>;
  queued?: Maybe<BoolFilter>;
  serviceReminderId?: Maybe<StringFilter>;
  timingId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServiceReminderNotificationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ServiceReminderNotificationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ServiceReminderNotificationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ServiceReminderNotificationScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  formSubmissionId?: Maybe<StringNullableWithAggregatesFilter>;
  hasResponded?: Maybe<BoolWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  notificationType?: Maybe<EnumServiceReminderNotificationTypeWithAggregatesFilter>;
  parentNotificationId?: Maybe<StringNullableWithAggregatesFilter>;
  queueAt?: Maybe<DateTimeWithAggregatesFilter>;
  queued?: Maybe<BoolWithAggregatesFilter>;
  serviceReminderId?: Maybe<StringWithAggregatesFilter>;
  timingId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum ServiceReminderNotificationType {
  Digital = 'Digital',
  Postcard = 'Postcard'
}

export type ServiceReminderNotificationUncheckedCreateInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutParentNotificationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId: Scalars['String'];
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedCreateNestedManyWithoutFormSubmissionInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyFormSubmissionInputEnvelope>;
};

export type ServiceReminderNotificationUncheckedCreateNestedManyWithoutParentNotificationInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutParentNotificationInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutParentNotificationInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyParentNotificationInputEnvelope>;
};

export type ServiceReminderNotificationUncheckedCreateNestedManyWithoutServiceReminderInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyServiceReminderInputEnvelope>;
};

export type ServiceReminderNotificationUncheckedCreateNestedManyWithoutTimingInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutTimingInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutTimingInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyTimingInputEnvelope>;
};

export type ServiceReminderNotificationUncheckedCreateWithoutBundledNotificationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId: Scalars['String'];
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedCreateWithoutFormSubmissionInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutParentNotificationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId: Scalars['String'];
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedCreateWithoutParentNotificationInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutParentNotificationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId: Scalars['String'];
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedCreateWithoutServiceReminderInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutParentNotificationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedCreateWithoutTimingInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutParentNotificationInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt: Scalars['DateTime'];
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedUpdateInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutParentNotificationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedUpdateManyWithoutFormSubmissionNestedInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyFormSubmissionInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderNotificationScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderNotificationUpdateWithWhereUniqueWithoutFormSubmissionInput>>;
  updateMany?: Maybe<Array<ServiceReminderNotificationUpdateManyWithWhereWithoutFormSubmissionInput>>;
  upsert?: Maybe<Array<ServiceReminderNotificationUpsertWithWhereUniqueWithoutFormSubmissionInput>>;
};

export type ServiceReminderNotificationUncheckedUpdateManyWithoutParentNotificationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedUpdateManyWithoutParentNotificationNestedInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutParentNotificationInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutParentNotificationInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyParentNotificationInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderNotificationScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderNotificationUpdateWithWhereUniqueWithoutParentNotificationInput>>;
  updateMany?: Maybe<Array<ServiceReminderNotificationUpdateManyWithWhereWithoutParentNotificationInput>>;
  upsert?: Maybe<Array<ServiceReminderNotificationUpsertWithWhereUniqueWithoutParentNotificationInput>>;
};

export type ServiceReminderNotificationUncheckedUpdateManyWithoutServiceReminderInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedUpdateManyWithoutServiceReminderNestedInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyServiceReminderInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderNotificationScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderNotificationUpdateWithWhereUniqueWithoutServiceReminderInput>>;
  updateMany?: Maybe<Array<ServiceReminderNotificationUpdateManyWithWhereWithoutServiceReminderInput>>;
  upsert?: Maybe<Array<ServiceReminderNotificationUpsertWithWhereUniqueWithoutServiceReminderInput>>;
};

export type ServiceReminderNotificationUncheckedUpdateManyWithoutTimingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedUpdateManyWithoutTimingNestedInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutTimingInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutTimingInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyTimingInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderNotificationScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderNotificationUpdateWithWhereUniqueWithoutTimingInput>>;
  updateMany?: Maybe<Array<ServiceReminderNotificationUpdateManyWithWhereWithoutTimingInput>>;
  upsert?: Maybe<Array<ServiceReminderNotificationUpsertWithWhereUniqueWithoutTimingInput>>;
};

export type ServiceReminderNotificationUncheckedUpdateWithoutBundledNotificationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedUpdateWithoutFormSubmissionInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutParentNotificationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedUpdateWithoutParentNotificationInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutParentNotificationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedUpdateWithoutServiceReminderInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutParentNotificationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  timingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUncheckedUpdateWithoutTimingInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutParentNotificationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmissionId?: Maybe<Scalars['String']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotificationId?: Maybe<Scalars['String']>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminderId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUpdateInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutParentNotificationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutServiceReminderNotificationsNestedInput>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotification?: Maybe<ServiceReminderNotificationUpdateOneWithoutBundledNotificationsNestedInput>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneRequiredWithoutNotificationsNestedInput>;
  timing?: Maybe<ServiceReminderTimingUpdateOneWithoutNotificationsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUpdateManyWithWhereWithoutFormSubmissionInput = {
  data: ServiceReminderNotificationUpdateManyMutationInput;
  where: ServiceReminderNotificationScalarWhereInput;
};

export type ServiceReminderNotificationUpdateManyWithWhereWithoutParentNotificationInput = {
  data: ServiceReminderNotificationUpdateManyMutationInput;
  where: ServiceReminderNotificationScalarWhereInput;
};

export type ServiceReminderNotificationUpdateManyWithWhereWithoutServiceReminderInput = {
  data: ServiceReminderNotificationUpdateManyMutationInput;
  where: ServiceReminderNotificationScalarWhereInput;
};

export type ServiceReminderNotificationUpdateManyWithWhereWithoutTimingInput = {
  data: ServiceReminderNotificationUpdateManyMutationInput;
  where: ServiceReminderNotificationScalarWhereInput;
};

export type ServiceReminderNotificationUpdateManyWithoutFormSubmissionNestedInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutFormSubmissionInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutFormSubmissionInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyFormSubmissionInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderNotificationScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderNotificationUpdateWithWhereUniqueWithoutFormSubmissionInput>>;
  updateMany?: Maybe<Array<ServiceReminderNotificationUpdateManyWithWhereWithoutFormSubmissionInput>>;
  upsert?: Maybe<Array<ServiceReminderNotificationUpsertWithWhereUniqueWithoutFormSubmissionInput>>;
};

export type ServiceReminderNotificationUpdateManyWithoutParentNotificationNestedInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutParentNotificationInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutParentNotificationInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyParentNotificationInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderNotificationScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderNotificationUpdateWithWhereUniqueWithoutParentNotificationInput>>;
  updateMany?: Maybe<Array<ServiceReminderNotificationUpdateManyWithWhereWithoutParentNotificationInput>>;
  upsert?: Maybe<Array<ServiceReminderNotificationUpsertWithWhereUniqueWithoutParentNotificationInput>>;
};

export type ServiceReminderNotificationUpdateManyWithoutServiceReminderNestedInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutServiceReminderInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutServiceReminderInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyServiceReminderInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderNotificationScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderNotificationUpdateWithWhereUniqueWithoutServiceReminderInput>>;
  updateMany?: Maybe<Array<ServiceReminderNotificationUpdateManyWithWhereWithoutServiceReminderInput>>;
  upsert?: Maybe<Array<ServiceReminderNotificationUpsertWithWhereUniqueWithoutServiceReminderInput>>;
};

export type ServiceReminderNotificationUpdateManyWithoutTimingNestedInput = {
  connect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderNotificationCreateOrConnectWithoutTimingInput>>;
  create?: Maybe<Array<ServiceReminderNotificationCreateWithoutTimingInput>>;
  createMany?: Maybe<ServiceReminderNotificationCreateManyTimingInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderNotificationScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderNotificationWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderNotificationUpdateWithWhereUniqueWithoutTimingInput>>;
  updateMany?: Maybe<Array<ServiceReminderNotificationUpdateManyWithWhereWithoutTimingInput>>;
  upsert?: Maybe<Array<ServiceReminderNotificationUpsertWithWhereUniqueWithoutTimingInput>>;
};

export type ServiceReminderNotificationUpdateOneWithoutBundledNotificationsNestedInput = {
  connect?: Maybe<ServiceReminderNotificationWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceReminderNotificationCreateOrConnectWithoutBundledNotificationsInput>;
  create?: Maybe<ServiceReminderNotificationCreateWithoutBundledNotificationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServiceReminderNotificationUpdateToOneWithWhereWithoutBundledNotificationsInput>;
  upsert?: Maybe<ServiceReminderNotificationUpsertWithoutBundledNotificationsInput>;
};

export type ServiceReminderNotificationUpdateToOneWithWhereWithoutBundledNotificationsInput = {
  data: ServiceReminderNotificationUpdateWithoutBundledNotificationsInput;
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};

export type ServiceReminderNotificationUpdateWithWhereUniqueWithoutFormSubmissionInput = {
  data: ServiceReminderNotificationUpdateWithoutFormSubmissionInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationUpdateWithWhereUniqueWithoutParentNotificationInput = {
  data: ServiceReminderNotificationUpdateWithoutParentNotificationInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationUpdateWithWhereUniqueWithoutServiceReminderInput = {
  data: ServiceReminderNotificationUpdateWithoutServiceReminderInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationUpdateWithWhereUniqueWithoutTimingInput = {
  data: ServiceReminderNotificationUpdateWithoutTimingInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationUpdateWithoutBundledNotificationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutServiceReminderNotificationsNestedInput>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotification?: Maybe<ServiceReminderNotificationUpdateOneWithoutBundledNotificationsNestedInput>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneRequiredWithoutNotificationsNestedInput>;
  timing?: Maybe<ServiceReminderTimingUpdateOneWithoutNotificationsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUpdateWithoutFormSubmissionInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutParentNotificationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotification?: Maybe<ServiceReminderNotificationUpdateOneWithoutBundledNotificationsNestedInput>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneRequiredWithoutNotificationsNestedInput>;
  timing?: Maybe<ServiceReminderTimingUpdateOneWithoutNotificationsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUpdateWithoutParentNotificationInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutParentNotificationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutServiceReminderNotificationsNestedInput>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneRequiredWithoutNotificationsNestedInput>;
  timing?: Maybe<ServiceReminderTimingUpdateOneWithoutNotificationsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUpdateWithoutServiceReminderInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutParentNotificationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutServiceReminderNotificationsNestedInput>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotification?: Maybe<ServiceReminderNotificationUpdateOneWithoutBundledNotificationsNestedInput>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  timing?: Maybe<ServiceReminderTimingUpdateOneWithoutNotificationsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUpdateWithoutTimingInput = {
  bundledNotifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutParentNotificationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formSubmission?: Maybe<FormSubmissionUpdateOneWithoutServiceReminderNotificationsNestedInput>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<ServiceReminderNotificationType>;
  parentNotification?: Maybe<ServiceReminderNotificationUpdateOneWithoutBundledNotificationsNestedInput>;
  queueAt?: Maybe<Scalars['DateTime']>;
  queued?: Maybe<Scalars['Boolean']>;
  serviceReminder?: Maybe<ServiceReminderUpdateOneRequiredWithoutNotificationsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderNotificationUpsertWithWhereUniqueWithoutFormSubmissionInput = {
  create: ServiceReminderNotificationCreateWithoutFormSubmissionInput;
  update: ServiceReminderNotificationUpdateWithoutFormSubmissionInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationUpsertWithWhereUniqueWithoutParentNotificationInput = {
  create: ServiceReminderNotificationCreateWithoutParentNotificationInput;
  update: ServiceReminderNotificationUpdateWithoutParentNotificationInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationUpsertWithWhereUniqueWithoutServiceReminderInput = {
  create: ServiceReminderNotificationCreateWithoutServiceReminderInput;
  update: ServiceReminderNotificationUpdateWithoutServiceReminderInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationUpsertWithWhereUniqueWithoutTimingInput = {
  create: ServiceReminderNotificationCreateWithoutTimingInput;
  update: ServiceReminderNotificationUpdateWithoutTimingInput;
  where: ServiceReminderNotificationWhereUniqueInput;
};

export type ServiceReminderNotificationUpsertWithoutBundledNotificationsInput = {
  create: ServiceReminderNotificationCreateWithoutBundledNotificationsInput;
  update: ServiceReminderNotificationUpdateWithoutBundledNotificationsInput;
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};

export type ServiceReminderNotificationWhereInput = {
  AND?: Maybe<Array<ServiceReminderNotificationWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderNotificationWhereInput>>;
  OR?: Maybe<Array<ServiceReminderNotificationWhereInput>>;
  bundledNotifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  hasResponded?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  notificationType?: Maybe<EnumServiceReminderNotificationTypeFilter>;
  parentNotification?: Maybe<ServiceReminderNotificationNullableScalarRelationFilter>;
  parentNotificationId?: Maybe<StringNullableFilter>;
  queueAt?: Maybe<DateTimeFilter>;
  queued?: Maybe<BoolFilter>;
  serviceReminder?: Maybe<ServiceReminderScalarRelationFilter>;
  serviceReminderId?: Maybe<StringFilter>;
  timing?: Maybe<ServiceReminderTimingNullableScalarRelationFilter>;
  timingId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServiceReminderNotificationWhereUniqueInput = {
  AND?: Maybe<Array<ServiceReminderNotificationWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderNotificationWhereInput>>;
  OR?: Maybe<Array<ServiceReminderNotificationWhereInput>>;
  bundledNotifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formSubmission?: Maybe<FormSubmissionNullableScalarRelationFilter>;
  formSubmissionId?: Maybe<StringNullableFilter>;
  hasResponded?: Maybe<BoolFilter>;
  id?: Maybe<Scalars['String']>;
  notificationType?: Maybe<EnumServiceReminderNotificationTypeFilter>;
  parentNotification?: Maybe<ServiceReminderNotificationNullableScalarRelationFilter>;
  parentNotificationId?: Maybe<StringNullableFilter>;
  queueAt?: Maybe<DateTimeFilter>;
  queued?: Maybe<BoolFilter>;
  serviceReminder?: Maybe<ServiceReminderScalarRelationFilter>;
  serviceReminderId?: Maybe<StringFilter>;
  timing?: Maybe<ServiceReminderTimingNullableScalarRelationFilter>;
  timingId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServiceReminderNullableScalarRelationFilter = {
  AND?: Maybe<Array<ServiceReminderWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderWhereInput>>;
  OR?: Maybe<Array<ServiceReminderWhereInput>>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dateLastGiven?: Maybe<DateTimeNullableFilter>;
  dueDate?: Maybe<DateTimeFilter>;
  hasResponded?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isCompleted?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  notifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServiceReminderOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ServiceReminderOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ServiceReminderOrderByRelevanceInput>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dateLastGiven?: Maybe<SortOrder>;
  dueDate?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isCompleted?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  notifications?: Maybe<ServiceReminderNotificationOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ServiceReminderOrderByRelevanceFieldEnum {
  ClinicPetId = 'clinicPetId',
  ClinicPetParentId = 'clinicPetParentId',
  Id = 'id',
  IntegrationId = 'integrationId',
  PimsId = 'pimsId',
  ResourceUid = 'resourceUid',
  ServiceId = 'serviceId'
}

export type ServiceReminderOrderByRelevanceInput = {
  fields: Array<ServiceReminderOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ServiceReminderOrderByWithAggregationInput = {
  _count?: Maybe<ServiceReminderCountOrderByAggregateInput>;
  _max?: Maybe<ServiceReminderMaxOrderByAggregateInput>;
  _min?: Maybe<ServiceReminderMinOrderByAggregateInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dateLastGiven?: Maybe<SortOrder>;
  dueDate?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isCompleted?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ServiceReminderOrderByRelevanceInput>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dateLastGiven?: Maybe<SortOrder>;
  dueDate?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isCompleted?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  notifications?: Maybe<ServiceReminderNotificationOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderOrderByWithRelationInput = {
  _relevance?: Maybe<ServiceReminderOrderByRelevanceInput>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dateLastGiven?: Maybe<SortOrder>;
  dueDate?: Maybe<SortOrder>;
  hasResponded?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isCompleted?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  notifications?: Maybe<ServiceReminderNotificationOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  resourceUid?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderPimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export enum ServiceReminderScalarFieldEnum {
  ClinicPetId = 'clinicPetId',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  DateLastGiven = 'dateLastGiven',
  DueDate = 'dueDate',
  HasResponded = 'hasResponded',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsCompleted = 'isCompleted',
  IsDeleted = 'isDeleted',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  ResourceUid = 'resourceUid',
  ServiceId = 'serviceId',
  UpdatedAt = 'updatedAt'
}

export type ServiceReminderScalarRelationFilter = {
  AND?: Maybe<Array<ServiceReminderWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderWhereInput>>;
  OR?: Maybe<Array<ServiceReminderWhereInput>>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dateLastGiven?: Maybe<DateTimeNullableFilter>;
  dueDate?: Maybe<DateTimeFilter>;
  hasResponded?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isCompleted?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  notifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServiceReminderScalarWhereInput = {
  AND?: Maybe<Array<ServiceReminderScalarWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderScalarWhereInput>>;
  OR?: Maybe<Array<ServiceReminderScalarWhereInput>>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dateLastGiven?: Maybe<DateTimeNullableFilter>;
  dueDate?: Maybe<DateTimeFilter>;
  hasResponded?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  isCompleted?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  serviceId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServiceReminderScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ServiceReminderScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ServiceReminderScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ServiceReminderScalarWhereWithAggregatesInput>>;
  clinicPetId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  dateLastGiven?: Maybe<DateTimeNullableWithAggregatesFilter>;
  dueDate?: Maybe<DateTimeWithAggregatesFilter>;
  hasResponded?: Maybe<BoolWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isCompleted?: Maybe<BoolWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  pimsId?: Maybe<StringWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  resourceUid?: Maybe<StringNullableWithAggregatesFilter>;
  serviceId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ServiceReminderTiming = {
  __typename?: 'ServiceReminderTiming';
  _count: ServiceReminderTimingCountOutputType;
  createdAt: Scalars['DateTime'];
  hourOfDay: Scalars['Int'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isEmail: Scalars['Boolean'];
  isPush: Scalars['Boolean'];
  isSms: Scalars['Boolean'];
  minuteOfHour: Scalars['Int'];
  notifications: Array<ServiceReminderNotification>;
  offset: Scalars['Float'];
  offsetUnit: ServiceReminderTimingOffsetUnit;
  service: Service;
  serviceId: Scalars['String'];
  timingType: ServiceReminderTimingType;
  updatedAt: Scalars['DateTime'];
};


export type ServiceReminderTimingNotificationsArgs = {
  cursor?: Maybe<ServiceReminderNotificationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceReminderNotificationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceReminderNotificationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceReminderNotificationWhereInput>;
};

export type ServiceReminderTimingAvgAggregateOutputType = {
  __typename?: 'ServiceReminderTimingAvgAggregateOutputType';
  hourOfDay?: Maybe<Scalars['Float']>;
  minuteOfHour?: Maybe<Scalars['Float']>;
  offset?: Maybe<Scalars['Float']>;
};

export type ServiceReminderTimingAvgOrderByAggregateInput = {
  hourOfDay?: Maybe<SortOrder>;
  minuteOfHour?: Maybe<SortOrder>;
  offset?: Maybe<SortOrder>;
};

export type ServiceReminderTimingCountAggregateOutputType = {
  __typename?: 'ServiceReminderTimingCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  hourOfDay: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isEmail: Scalars['Int'];
  isPush: Scalars['Int'];
  isSms: Scalars['Int'];
  minuteOfHour: Scalars['Int'];
  offset: Scalars['Int'];
  offsetUnit: Scalars['Int'];
  serviceId: Scalars['Int'];
  timingType: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ServiceReminderTimingCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  hourOfDay?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isEmail?: Maybe<SortOrder>;
  isPush?: Maybe<SortOrder>;
  isSms?: Maybe<SortOrder>;
  minuteOfHour?: Maybe<SortOrder>;
  offset?: Maybe<SortOrder>;
  offsetUnit?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  timingType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderTimingCountOutputType = {
  __typename?: 'ServiceReminderTimingCountOutputType';
  notifications: Scalars['Int'];
};

export type ServiceReminderTimingCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  notifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutTimingInput>;
  offset: Scalars['Float'];
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  service: ServiceCreateNestedOneWithoutReminderTimingsInput;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  offset: Scalars['Float'];
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  serviceId: Scalars['String'];
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingCreateManyServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  offset: Scalars['Float'];
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingCreateManyServiceInputEnvelope = {
  data: Array<ServiceReminderTimingCreateManyServiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ServiceReminderTimingCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<ServiceReminderTimingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderTimingCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<ServiceReminderTimingCreateWithoutServiceInput>>;
  createMany?: Maybe<ServiceReminderTimingCreateManyServiceInputEnvelope>;
};

export type ServiceReminderTimingCreateNestedOneWithoutNotificationsInput = {
  connect?: Maybe<ServiceReminderTimingWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceReminderTimingCreateOrConnectWithoutNotificationsInput>;
  create?: Maybe<ServiceReminderTimingCreateWithoutNotificationsInput>;
};

export type ServiceReminderTimingCreateOrConnectWithoutNotificationsInput = {
  create: ServiceReminderTimingCreateWithoutNotificationsInput;
  where: ServiceReminderTimingWhereUniqueInput;
};

export type ServiceReminderTimingCreateOrConnectWithoutServiceInput = {
  create: ServiceReminderTimingCreateWithoutServiceInput;
  where: ServiceReminderTimingWhereUniqueInput;
};

export type ServiceReminderTimingCreateWithoutNotificationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  offset: Scalars['Float'];
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  service: ServiceCreateNestedOneWithoutReminderTimingsInput;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingCreateWithoutServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  notifications?: Maybe<ServiceReminderNotificationCreateNestedManyWithoutTimingInput>;
  offset: Scalars['Float'];
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingDeliveryOptionInput = {
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
};

export type ServiceReminderTimingGroupByOutputType = {
  __typename?: 'ServiceReminderTimingGroupByOutputType';
  _avg?: Maybe<ServiceReminderTimingAvgAggregateOutputType>;
  _count?: Maybe<ServiceReminderTimingCountAggregateOutputType>;
  _max?: Maybe<ServiceReminderTimingMaxAggregateOutputType>;
  _min?: Maybe<ServiceReminderTimingMinAggregateOutputType>;
  _sum?: Maybe<ServiceReminderTimingSumAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  hourOfDay: Scalars['Int'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isEmail: Scalars['Boolean'];
  isPush: Scalars['Boolean'];
  isSms: Scalars['Boolean'];
  minuteOfHour: Scalars['Int'];
  offset: Scalars['Float'];
  offsetUnit: ServiceReminderTimingOffsetUnit;
  serviceId: Scalars['String'];
  timingType: ServiceReminderTimingType;
  updatedAt: Scalars['DateTime'];
};

export type ServiceReminderTimingInput = {
  hourOfDay: Scalars['Int'];
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour: Scalars['Int'];
  offset: Scalars['Float'];
  offsetUnit: Scalars['String'];
  timingType: ServiceReminderTimingType;
};

export type ServiceReminderTimingListRelationFilter = {
  every?: Maybe<ServiceReminderTimingWhereInput>;
  none?: Maybe<ServiceReminderTimingWhereInput>;
  some?: Maybe<ServiceReminderTimingWhereInput>;
};

export type ServiceReminderTimingMaxAggregateOutputType = {
  __typename?: 'ServiceReminderTimingMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Float']>;
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  serviceId?: Maybe<Scalars['String']>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  hourOfDay?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isEmail?: Maybe<SortOrder>;
  isPush?: Maybe<SortOrder>;
  isSms?: Maybe<SortOrder>;
  minuteOfHour?: Maybe<SortOrder>;
  offset?: Maybe<SortOrder>;
  offsetUnit?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  timingType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderTimingMinAggregateOutputType = {
  __typename?: 'ServiceReminderTimingMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Float']>;
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  serviceId?: Maybe<Scalars['String']>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  hourOfDay?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isEmail?: Maybe<SortOrder>;
  isPush?: Maybe<SortOrder>;
  isSms?: Maybe<SortOrder>;
  minuteOfHour?: Maybe<SortOrder>;
  offset?: Maybe<SortOrder>;
  offsetUnit?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  timingType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderTimingNullableScalarRelationFilter = {
  AND?: Maybe<Array<ServiceReminderTimingWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderTimingWhereInput>>;
  OR?: Maybe<Array<ServiceReminderTimingWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  hourOfDay?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isEmail?: Maybe<BoolFilter>;
  isPush?: Maybe<BoolFilter>;
  isSms?: Maybe<BoolFilter>;
  minuteOfHour?: Maybe<IntFilter>;
  notifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  offset?: Maybe<FloatFilter>;
  offsetUnit?: Maybe<EnumServiceReminderTimingOffsetUnitFilter>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
  timingType?: Maybe<EnumServiceReminderTimingTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum ServiceReminderTimingOffsetUnit {
  Days = 'Days',
  Months = 'Months',
  Weeks = 'Weeks'
}

export type ServiceReminderTimingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ServiceReminderTimingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ServiceReminderTimingOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  hourOfDay?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isEmail?: Maybe<SortOrder>;
  isPush?: Maybe<SortOrder>;
  isSms?: Maybe<SortOrder>;
  minuteOfHour?: Maybe<SortOrder>;
  notifications?: Maybe<ServiceReminderNotificationOrderByRelationAggregateInput>;
  offset?: Maybe<SortOrder>;
  offsetUnit?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  timingType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ServiceReminderTimingOrderByRelevanceFieldEnum {
  Id = 'id',
  ServiceId = 'serviceId'
}

export type ServiceReminderTimingOrderByRelevanceInput = {
  fields: Array<ServiceReminderTimingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ServiceReminderTimingOrderByWithAggregationInput = {
  _avg?: Maybe<ServiceReminderTimingAvgOrderByAggregateInput>;
  _count?: Maybe<ServiceReminderTimingCountOrderByAggregateInput>;
  _max?: Maybe<ServiceReminderTimingMaxOrderByAggregateInput>;
  _min?: Maybe<ServiceReminderTimingMinOrderByAggregateInput>;
  _sum?: Maybe<ServiceReminderTimingSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  hourOfDay?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isEmail?: Maybe<SortOrder>;
  isPush?: Maybe<SortOrder>;
  isSms?: Maybe<SortOrder>;
  minuteOfHour?: Maybe<SortOrder>;
  offset?: Maybe<SortOrder>;
  offsetUnit?: Maybe<SortOrder>;
  serviceId?: Maybe<SortOrder>;
  timingType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderTimingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<ServiceReminderTimingOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  hourOfDay?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isEmail?: Maybe<SortOrder>;
  isPush?: Maybe<SortOrder>;
  isSms?: Maybe<SortOrder>;
  minuteOfHour?: Maybe<SortOrder>;
  notifications?: Maybe<ServiceReminderNotificationOrderByRelationAggregateInput>;
  offset?: Maybe<SortOrder>;
  offsetUnit?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  timingType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ServiceReminderTimingOrderByWithRelationInput = {
  _relevance?: Maybe<ServiceReminderTimingOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  hourOfDay?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isEmail?: Maybe<SortOrder>;
  isPush?: Maybe<SortOrder>;
  isSms?: Maybe<SortOrder>;
  minuteOfHour?: Maybe<SortOrder>;
  notifications?: Maybe<ServiceReminderNotificationOrderByRelationAggregateInput>;
  offset?: Maybe<SortOrder>;
  offsetUnit?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByWithRelationInput>;
  serviceId?: Maybe<SortOrder>;
  timingType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ServiceReminderTimingScalarFieldEnum {
  CreatedAt = 'createdAt',
  HourOfDay = 'hourOfDay',
  Id = 'id',
  IsDeleted = 'isDeleted',
  IsEmail = 'isEmail',
  IsPush = 'isPush',
  IsSms = 'isSms',
  MinuteOfHour = 'minuteOfHour',
  Offset = 'offset',
  OffsetUnit = 'offsetUnit',
  ServiceId = 'serviceId',
  TimingType = 'timingType',
  UpdatedAt = 'updatedAt'
}

export type ServiceReminderTimingScalarWhereInput = {
  AND?: Maybe<Array<ServiceReminderTimingScalarWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderTimingScalarWhereInput>>;
  OR?: Maybe<Array<ServiceReminderTimingScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  hourOfDay?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isEmail?: Maybe<BoolFilter>;
  isPush?: Maybe<BoolFilter>;
  isSms?: Maybe<BoolFilter>;
  minuteOfHour?: Maybe<IntFilter>;
  offset?: Maybe<FloatFilter>;
  offsetUnit?: Maybe<EnumServiceReminderTimingOffsetUnitFilter>;
  serviceId?: Maybe<StringFilter>;
  timingType?: Maybe<EnumServiceReminderTimingTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServiceReminderTimingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ServiceReminderTimingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ServiceReminderTimingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ServiceReminderTimingScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  hourOfDay?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  isEmail?: Maybe<BoolWithAggregatesFilter>;
  isPush?: Maybe<BoolWithAggregatesFilter>;
  isSms?: Maybe<BoolWithAggregatesFilter>;
  minuteOfHour?: Maybe<IntWithAggregatesFilter>;
  offset?: Maybe<FloatWithAggregatesFilter>;
  offsetUnit?: Maybe<EnumServiceReminderTimingOffsetUnitWithAggregatesFilter>;
  serviceId?: Maybe<StringWithAggregatesFilter>;
  timingType?: Maybe<EnumServiceReminderTimingTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type ServiceReminderTimingSumAggregateOutputType = {
  __typename?: 'ServiceReminderTimingSumAggregateOutputType';
  hourOfDay?: Maybe<Scalars['Int']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Float']>;
};

export type ServiceReminderTimingSumOrderByAggregateInput = {
  hourOfDay?: Maybe<SortOrder>;
  minuteOfHour?: Maybe<SortOrder>;
  offset?: Maybe<SortOrder>;
};

export enum ServiceReminderTimingType {
  BeforeDue = 'BeforeDue',
  PastDue = 'PastDue'
}

export type ServiceReminderTimingUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutTimingInput>;
  offset: Scalars['Float'];
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  serviceId: Scalars['String'];
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<ServiceReminderTimingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderTimingCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<ServiceReminderTimingCreateWithoutServiceInput>>;
  createMany?: Maybe<ServiceReminderTimingCreateManyServiceInputEnvelope>;
};

export type ServiceReminderTimingUncheckedCreateWithoutNotificationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  offset: Scalars['Float'];
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  serviceId: Scalars['String'];
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingUncheckedCreateWithoutServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutTimingInput>;
  offset: Scalars['Float'];
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutTimingNestedInput>;
  offset?: Maybe<Scalars['Float']>;
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  serviceId?: Maybe<Scalars['String']>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Float']>;
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  serviceId?: Maybe<Scalars['String']>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingUncheckedUpdateManyWithoutServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Float']>;
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<ServiceReminderTimingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderTimingCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<ServiceReminderTimingCreateWithoutServiceInput>>;
  createMany?: Maybe<ServiceReminderTimingCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderTimingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderTimingScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderTimingWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderTimingWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderTimingUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<ServiceReminderTimingUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<ServiceReminderTimingUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type ServiceReminderTimingUncheckedUpdateWithoutNotificationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Float']>;
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  serviceId?: Maybe<Scalars['String']>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingUncheckedUpdateWithoutServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutTimingNestedInput>;
  offset?: Maybe<Scalars['Float']>;
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  notifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutTimingNestedInput>;
  offset?: Maybe<Scalars['Float']>;
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutReminderTimingsNestedInput>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Float']>;
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingUpdateManyWithWhereWithoutServiceInput = {
  data: ServiceReminderTimingUpdateManyMutationInput;
  where: ServiceReminderTimingScalarWhereInput;
};

export type ServiceReminderTimingUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<ServiceReminderTimingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderTimingCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<ServiceReminderTimingCreateWithoutServiceInput>>;
  createMany?: Maybe<ServiceReminderTimingCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderTimingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderTimingScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderTimingWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderTimingWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderTimingUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<ServiceReminderTimingUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<ServiceReminderTimingUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type ServiceReminderTimingUpdateOneWithoutNotificationsNestedInput = {
  connect?: Maybe<ServiceReminderTimingWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceReminderTimingCreateOrConnectWithoutNotificationsInput>;
  create?: Maybe<ServiceReminderTimingCreateWithoutNotificationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServiceReminderTimingUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: Maybe<ServiceReminderTimingUpsertWithoutNotificationsInput>;
};

export type ServiceReminderTimingUpdateToOneWithWhereWithoutNotificationsInput = {
  data: ServiceReminderTimingUpdateWithoutNotificationsInput;
  where?: Maybe<ServiceReminderTimingWhereInput>;
};

export type ServiceReminderTimingUpdateWithWhereUniqueWithoutServiceInput = {
  data: ServiceReminderTimingUpdateWithoutServiceInput;
  where: ServiceReminderTimingWhereUniqueInput;
};

export type ServiceReminderTimingUpdateWithoutNotificationsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Float']>;
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutReminderTimingsNestedInput>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingUpdateWithoutServiceInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hourOfDay?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isPush?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  minuteOfHour?: Maybe<Scalars['Int']>;
  notifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutTimingNestedInput>;
  offset?: Maybe<Scalars['Float']>;
  offsetUnit?: Maybe<ServiceReminderTimingOffsetUnit>;
  timingType?: Maybe<ServiceReminderTimingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderTimingUpsertWithWhereUniqueWithoutServiceInput = {
  create: ServiceReminderTimingCreateWithoutServiceInput;
  update: ServiceReminderTimingUpdateWithoutServiceInput;
  where: ServiceReminderTimingWhereUniqueInput;
};

export type ServiceReminderTimingUpsertWithoutNotificationsInput = {
  create: ServiceReminderTimingCreateWithoutNotificationsInput;
  update: ServiceReminderTimingUpdateWithoutNotificationsInput;
  where?: Maybe<ServiceReminderTimingWhereInput>;
};

export type ServiceReminderTimingWhereInput = {
  AND?: Maybe<Array<ServiceReminderTimingWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderTimingWhereInput>>;
  OR?: Maybe<Array<ServiceReminderTimingWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  hourOfDay?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isEmail?: Maybe<BoolFilter>;
  isPush?: Maybe<BoolFilter>;
  isSms?: Maybe<BoolFilter>;
  minuteOfHour?: Maybe<IntFilter>;
  notifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  offset?: Maybe<FloatFilter>;
  offsetUnit?: Maybe<EnumServiceReminderTimingOffsetUnitFilter>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
  timingType?: Maybe<EnumServiceReminderTimingTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServiceReminderTimingWhereUniqueInput = {
  AND?: Maybe<Array<ServiceReminderTimingWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderTimingWhereInput>>;
  OR?: Maybe<Array<ServiceReminderTimingWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  hourOfDay?: Maybe<IntFilter>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<BoolFilter>;
  isEmail?: Maybe<BoolFilter>;
  isPush?: Maybe<BoolFilter>;
  isSms?: Maybe<BoolFilter>;
  minuteOfHour?: Maybe<IntFilter>;
  notifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  offset?: Maybe<FloatFilter>;
  offsetUnit?: Maybe<EnumServiceReminderTimingOffsetUnitFilter>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
  timingType?: Maybe<EnumServiceReminderTimingTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServiceReminderUncheckedCreateInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutServiceReminderInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ServiceReminderCreateManyClinicPetInputEnvelope>;
};

export type ServiceReminderUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ServiceReminderCreateManyClinicPetParentInputEnvelope>;
};

export type ServiceReminderUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ServiceReminderCreateManyIntegrationInputEnvelope>;
};

export type ServiceReminderUncheckedCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutServiceInput>>;
  createMany?: Maybe<ServiceReminderCreateManyServiceInputEnvelope>;
};

export type ServiceReminderUncheckedCreateWithoutAutomationRunsInput = {
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutServiceReminderInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedCreateWithoutChannelAutomationStatusesInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutServiceReminderInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedCreateWithoutChannelCreationSourcesInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutServiceReminderInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedCreateWithoutClinicPetInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutServiceReminderInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedCreateWithoutClinicPetParentInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutServiceReminderInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedCreateWithoutIntegrationInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutServiceReminderInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedCreateWithoutNotificationsInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutServiceReminderInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedCreateWithoutServiceInput = {
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutServiceReminderInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutServiceReminderInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedCreateNestedManyWithoutServiceReminderInput>;
  pimsId: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateManyInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateManyWithoutClinicPetInput = {
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ServiceReminderCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<ServiceReminderUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<ServiceReminderUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type ServiceReminderUncheckedUpdateManyWithoutClinicPetParentInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ServiceReminderCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ServiceReminderUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ServiceReminderUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ServiceReminderUncheckedUpdateManyWithoutIntegrationInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ServiceReminderCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ServiceReminderUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ServiceReminderUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ServiceReminderUncheckedUpdateManyWithoutServiceInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutServiceInput>>;
  createMany?: Maybe<ServiceReminderCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<ServiceReminderUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<ServiceReminderUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type ServiceReminderUncheckedUpdateWithoutAutomationRunsInput = {
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateWithoutChannelAutomationStatusesInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateWithoutChannelCreationSourcesInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateWithoutClinicPetInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateWithoutClinicPetParentInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateWithoutIntegrationInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateWithoutNotificationsInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUncheckedUpdateWithoutServiceInput = {
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUncheckedUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUpdateInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutServiceReminderNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutServiceRemindersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutServiceRemindersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceRemindersNestedInput>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutRemindersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUpdateManyWithWhereWithoutClinicPetInput = {
  data: ServiceReminderUpdateManyMutationInput;
  where: ServiceReminderScalarWhereInput;
};

export type ServiceReminderUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: ServiceReminderUpdateManyMutationInput;
  where: ServiceReminderScalarWhereInput;
};

export type ServiceReminderUpdateManyWithWhereWithoutIntegrationInput = {
  data: ServiceReminderUpdateManyMutationInput;
  where: ServiceReminderScalarWhereInput;
};

export type ServiceReminderUpdateManyWithWhereWithoutServiceInput = {
  data: ServiceReminderUpdateManyMutationInput;
  where: ServiceReminderScalarWhereInput;
};

export type ServiceReminderUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutClinicPetInput>>;
  createMany?: Maybe<ServiceReminderCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<ServiceReminderUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<ServiceReminderUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type ServiceReminderUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<ServiceReminderCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<ServiceReminderUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<ServiceReminderUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type ServiceReminderUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ServiceReminderCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ServiceReminderUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ServiceReminderUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ServiceReminderUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceReminderCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<ServiceReminderCreateWithoutServiceInput>>;
  createMany?: Maybe<ServiceReminderCreateManyServiceInputEnvelope>;
  delete?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceReminderScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  set?: Maybe<Array<ServiceReminderWhereUniqueInput>>;
  update?: Maybe<Array<ServiceReminderUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<ServiceReminderUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<ServiceReminderUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type ServiceReminderUpdateOneRequiredWithoutNotificationsNestedInput = {
  connect?: Maybe<ServiceReminderWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceReminderCreateOrConnectWithoutNotificationsInput>;
  create?: Maybe<ServiceReminderCreateWithoutNotificationsInput>;
  update?: Maybe<ServiceReminderUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: Maybe<ServiceReminderUpsertWithoutNotificationsInput>;
};

export type ServiceReminderUpdateOneWithoutAutomationRunsNestedInput = {
  connect?: Maybe<ServiceReminderWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceReminderCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<ServiceReminderCreateWithoutAutomationRunsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServiceReminderUpdateToOneWithWhereWithoutAutomationRunsInput>;
  upsert?: Maybe<ServiceReminderUpsertWithoutAutomationRunsInput>;
};

export type ServiceReminderUpdateOneWithoutChannelAutomationStatusesNestedInput = {
  connect?: Maybe<ServiceReminderWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceReminderCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<ServiceReminderCreateWithoutChannelAutomationStatusesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServiceReminderUpdateToOneWithWhereWithoutChannelAutomationStatusesInput>;
  upsert?: Maybe<ServiceReminderUpsertWithoutChannelAutomationStatusesInput>;
};

export type ServiceReminderUpdateOneWithoutChannelCreationSourcesNestedInput = {
  connect?: Maybe<ServiceReminderWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceReminderCreateOrConnectWithoutChannelCreationSourcesInput>;
  create?: Maybe<ServiceReminderCreateWithoutChannelCreationSourcesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServiceReminderUpdateToOneWithWhereWithoutChannelCreationSourcesInput>;
  upsert?: Maybe<ServiceReminderUpsertWithoutChannelCreationSourcesInput>;
};

export type ServiceReminderUpdateToOneWithWhereWithoutAutomationRunsInput = {
  data: ServiceReminderUpdateWithoutAutomationRunsInput;
  where?: Maybe<ServiceReminderWhereInput>;
};

export type ServiceReminderUpdateToOneWithWhereWithoutChannelAutomationStatusesInput = {
  data: ServiceReminderUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<ServiceReminderWhereInput>;
};

export type ServiceReminderUpdateToOneWithWhereWithoutChannelCreationSourcesInput = {
  data: ServiceReminderUpdateWithoutChannelCreationSourcesInput;
  where?: Maybe<ServiceReminderWhereInput>;
};

export type ServiceReminderUpdateToOneWithWhereWithoutNotificationsInput = {
  data: ServiceReminderUpdateWithoutNotificationsInput;
  where?: Maybe<ServiceReminderWhereInput>;
};

export type ServiceReminderUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: ServiceReminderUpdateWithoutClinicPetInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: ServiceReminderUpdateWithoutClinicPetParentInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: ServiceReminderUpdateWithoutIntegrationInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderUpdateWithWhereUniqueWithoutServiceInput = {
  data: ServiceReminderUpdateWithoutServiceInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderUpdateWithoutAutomationRunsInput = {
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutServiceReminderNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutServiceRemindersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutServiceRemindersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceRemindersNestedInput>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutRemindersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUpdateWithoutChannelAutomationStatusesInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutServiceReminderNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutServiceRemindersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutServiceRemindersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceRemindersNestedInput>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutRemindersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUpdateWithoutChannelCreationSourcesInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutServiceReminderNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutServiceRemindersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutServiceRemindersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceRemindersNestedInput>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutRemindersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUpdateWithoutClinicPetInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutServiceReminderNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutServiceRemindersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceRemindersNestedInput>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutRemindersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUpdateWithoutClinicPetParentInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutServiceReminderNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutServiceRemindersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceRemindersNestedInput>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutRemindersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUpdateWithoutIntegrationInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutServiceReminderNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutServiceRemindersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutServiceRemindersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutRemindersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUpdateWithoutNotificationsInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutServiceReminderNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutServiceRemindersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutServiceRemindersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceRemindersNestedInput>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutRemindersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUpdateWithoutServiceInput = {
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutServiceReminderNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutServiceReminderNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutServiceReminderNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneWithoutServiceRemindersNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutServiceRemindersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateLastGiven?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasResponded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServiceRemindersNestedInput>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<ServiceReminderNotificationUpdateManyWithoutServiceReminderNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  resourceUid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceReminderUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: ServiceReminderCreateWithoutClinicPetInput;
  update: ServiceReminderUpdateWithoutClinicPetInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: ServiceReminderCreateWithoutClinicPetParentInput;
  update: ServiceReminderUpdateWithoutClinicPetParentInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: ServiceReminderCreateWithoutIntegrationInput;
  update: ServiceReminderUpdateWithoutIntegrationInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderUpsertWithWhereUniqueWithoutServiceInput = {
  create: ServiceReminderCreateWithoutServiceInput;
  update: ServiceReminderUpdateWithoutServiceInput;
  where: ServiceReminderWhereUniqueInput;
};

export type ServiceReminderUpsertWithoutAutomationRunsInput = {
  create: ServiceReminderCreateWithoutAutomationRunsInput;
  update: ServiceReminderUpdateWithoutAutomationRunsInput;
  where?: Maybe<ServiceReminderWhereInput>;
};

export type ServiceReminderUpsertWithoutChannelAutomationStatusesInput = {
  create: ServiceReminderCreateWithoutChannelAutomationStatusesInput;
  update: ServiceReminderUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<ServiceReminderWhereInput>;
};

export type ServiceReminderUpsertWithoutChannelCreationSourcesInput = {
  create: ServiceReminderCreateWithoutChannelCreationSourcesInput;
  update: ServiceReminderUpdateWithoutChannelCreationSourcesInput;
  where?: Maybe<ServiceReminderWhereInput>;
};

export type ServiceReminderUpsertWithoutNotificationsInput = {
  create: ServiceReminderCreateWithoutNotificationsInput;
  update: ServiceReminderUpdateWithoutNotificationsInput;
  where?: Maybe<ServiceReminderWhereInput>;
};

export type ServiceReminderWhereInput = {
  AND?: Maybe<Array<ServiceReminderWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderWhereInput>>;
  OR?: Maybe<Array<ServiceReminderWhereInput>>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dateLastGiven?: Maybe<DateTimeNullableFilter>;
  dueDate?: Maybe<DateTimeFilter>;
  hasResponded?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isCompleted?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  notifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  pimsId?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  resourceUid?: Maybe<StringNullableFilter>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type ServiceReminderWhereUniqueInput = {
  AND?: Maybe<Array<ServiceReminderWhereInput>>;
  NOT?: Maybe<Array<ServiceReminderWhereInput>>;
  OR?: Maybe<Array<ServiceReminderWhereInput>>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  clinicPet?: Maybe<ClinicPetNullableScalarRelationFilter>;
  clinicPetId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dateLastGiven?: Maybe<DateTimeNullableFilter>;
  dueDate?: Maybe<DateTimeFilter>;
  hasResponded?: Maybe<BoolFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isCompleted?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  notifications?: Maybe<ServiceReminderNotificationListRelationFilter>;
  pimsId?: Maybe<StringFilter>;
  pimsIdAndIntegrationId?: Maybe<ServiceReminderPimsIdAndIntegrationIdCompoundUniqueInput>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  resourceUid?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceScalarRelationFilter>;
  serviceId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum ServiceScalarFieldEnum {
  CanonicalServiceId = 'canonicalServiceId',
  Code = 'code',
  CreatedAt = 'createdAt',
  FormTemplateId = 'formTemplateId',
  HasConfiguredReminders = 'hasConfiguredReminders',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsDeleted = 'isDeleted',
  IsPetPortal = 'isPetPortal',
  IsPostcard = 'isPostcard',
  IsReminderActive = 'isReminderActive',
  Name = 'name',
  PimsId = 'pimsId',
  PimsName = 'pimsName',
  PimsType = 'pimsType',
  RawPimsValue = 'rawPimsValue',
  ReminderActivationDate = 'reminderActivationDate',
  ServiceCategoryId = 'serviceCategoryId',
  TaxonomyId = 'taxonomyId',
  UpdatedAt = 'updatedAt',
  VetsourceFreeDoses = 'vetsourceFreeDoses',
  VetsourcePaidDoses = 'vetsourcePaidDoses',
  VetsourceQuantityOverride = 'vetsourceQuantityOverride',
  VetsourceRevenueCategoryName = 'vetsourceRevenueCategoryName'
}

export type ServiceScalarRelationFilter = {
  AND?: Maybe<Array<ServiceWhereInput>>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ServiceWhereInput>>;
  OR?: Maybe<Array<ServiceWhereInput>>;
  canonicalService?: Maybe<CanonicalServiceNullableScalarRelationFilter>;
  canonicalServiceId?: Maybe<StringNullableFilter>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  formTemplate?: Maybe<FormTemplateNullableScalarRelationFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  hasConfiguredReminders?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isPetPortal?: Maybe<BoolFilter>;
  isPostcard?: Maybe<BoolFilter>;
  isReminderActive?: Maybe<BoolFilter>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceListRelationFilter>;
  name?: Maybe<StringFilter>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceListRelationFilter>;
  pimsId?: Maybe<StringFilter>;
  pimsName?: Maybe<StringFilter>;
  pimsType?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  reminderActivationDate?: Maybe<DateTimeNullableFilter>;
  reminderTimings?: Maybe<ServiceReminderTimingListRelationFilter>;
  reminders?: Maybe<ServiceReminderListRelationFilter>;
  serviceCategory?: Maybe<ServiceCategoryNullableScalarRelationFilter>;
  serviceCategoryId?: Maybe<StringNullableFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagListRelationFilter>;
  vetsourceFreeDoses?: Maybe<IntNullableFilter>;
  vetsourcePaidDoses?: Maybe<IntNullableFilter>;
  vetsourceQuantityOverride?: Maybe<FloatNullableFilter>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryNullableScalarRelationFilter>;
  vetsourceRevenueCategoryName?: Maybe<StringNullableFilter>;
};

export type ServiceScalarWhereInput = {
  AND?: Maybe<Array<ServiceScalarWhereInput>>;
  NOT?: Maybe<Array<ServiceScalarWhereInput>>;
  OR?: Maybe<Array<ServiceScalarWhereInput>>;
  canonicalServiceId?: Maybe<StringNullableFilter>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  hasConfiguredReminders?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isPetPortal?: Maybe<BoolFilter>;
  isPostcard?: Maybe<BoolFilter>;
  isReminderActive?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringFilter>;
  pimsName?: Maybe<StringFilter>;
  pimsType?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  reminderActivationDate?: Maybe<DateTimeNullableFilter>;
  serviceCategoryId?: Maybe<StringNullableFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetsourceFreeDoses?: Maybe<IntNullableFilter>;
  vetsourcePaidDoses?: Maybe<IntNullableFilter>;
  vetsourceQuantityOverride?: Maybe<FloatNullableFilter>;
  vetsourceRevenueCategoryName?: Maybe<StringNullableFilter>;
};

export type ServiceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ServiceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ServiceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ServiceScalarWhereWithAggregatesInput>>;
  canonicalServiceId?: Maybe<StringNullableWithAggregatesFilter>;
  code?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  formTemplateId?: Maybe<StringNullableWithAggregatesFilter>;
  hasConfiguredReminders?: Maybe<BoolWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  isPetPortal?: Maybe<BoolWithAggregatesFilter>;
  isPostcard?: Maybe<BoolWithAggregatesFilter>;
  isReminderActive?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  pimsId?: Maybe<StringWithAggregatesFilter>;
  pimsName?: Maybe<StringWithAggregatesFilter>;
  pimsType?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  reminderActivationDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  serviceCategoryId?: Maybe<StringNullableWithAggregatesFilter>;
  taxonomyId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  vetsourceFreeDoses?: Maybe<IntNullableWithAggregatesFilter>;
  vetsourcePaidDoses?: Maybe<IntNullableWithAggregatesFilter>;
  vetsourceQuantityOverride?: Maybe<FloatNullableWithAggregatesFilter>;
  vetsourceRevenueCategoryName?: Maybe<StringNullableWithAggregatesFilter>;
};

export type ServiceServiceCodeAndIntegrationIdCompoundUniqueInput = {
  code: Scalars['String'];
  integrationId: Scalars['String'];
};

export type ServiceServicePimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type ServiceSumAggregateOutputType = {
  __typename?: 'ServiceSumAggregateOutputType';
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
};

export type ServiceSumOrderByAggregateInput = {
  vetsourceFreeDoses?: Maybe<SortOrder>;
  vetsourcePaidDoses?: Maybe<SortOrder>;
  vetsourceQuantityOverride?: Maybe<SortOrder>;
};

export type ServiceUncheckedCreateInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateNestedManyWithoutCanonicalServiceInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutCanonicalServiceInput>>;
  create?: Maybe<Array<ServiceCreateWithoutCanonicalServiceInput>>;
  createMany?: Maybe<ServiceCreateManyCanonicalServiceInputEnvelope>;
};

export type ServiceUncheckedCreateNestedManyWithoutFormTemplateInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutFormTemplateInput>>;
  create?: Maybe<Array<ServiceCreateWithoutFormTemplateInput>>;
  createMany?: Maybe<ServiceCreateManyFormTemplateInputEnvelope>;
};

export type ServiceUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ServiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ServiceCreateManyIntegrationInputEnvelope>;
};

export type ServiceUncheckedCreateNestedManyWithoutServiceCategoryInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutServiceCategoryInput>>;
  create?: Maybe<Array<ServiceCreateWithoutServiceCategoryInput>>;
  createMany?: Maybe<ServiceCreateManyServiceCategoryInputEnvelope>;
};

export type ServiceUncheckedCreateNestedManyWithoutTaxonomyInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<ServiceCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<ServiceCreateManyTaxonomyInputEnvelope>;
};

export type ServiceUncheckedCreateNestedManyWithoutVetsourceCodeTagsInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutVetsourceCodeTagsInput>>;
  create?: Maybe<Array<ServiceCreateWithoutVetsourceCodeTagsInput>>;
};

export type ServiceUncheckedCreateNestedManyWithoutVetsourceRevenueCategoryInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutVetsourceRevenueCategoryInput>>;
  create?: Maybe<Array<ServiceCreateWithoutVetsourceRevenueCategoryInput>>;
  createMany?: Maybe<ServiceCreateManyVetsourceRevenueCategoryInputEnvelope>;
};

export type ServiceUncheckedCreateWithoutCanonicalServiceInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutDraftCareBenefitUsageToInvoiceLineItemsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutFormTemplateInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutIntegrationInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutInvoiceLineItemsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutLoyaltyPointGrantingServicesInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutMedicalHistoryInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutOrganizationCareBenefitToClinicServiceInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutPrescriptionsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutReminderTimingsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutRemindersInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutServiceCategoryInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutServicePurchaseSummariesInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutTaxonomyInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutVetsourceCodeTagsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedCreateWithoutVetsourceRevenueCategoryInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedCreateNestedManyWithoutServiceInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutDraftServiceInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedCreateNestedManyWithoutServiceInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedCreateNestedManyWithoutServiceInput>;
  name: Scalars['String'];
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedCreateNestedManyWithoutServiceInput>;
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedCreateNestedManyWithoutServiceInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedCreateNestedManyWithoutServiceInput>;
  reminders?: Maybe<ServiceReminderUncheckedCreateNestedManyWithoutServiceInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedCreateNestedManyWithoutServiceInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
};

export type ServiceUncheckedUpdateInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateManyInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateManyWithoutCanonicalServiceInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateManyWithoutCanonicalServiceNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutCanonicalServiceInput>>;
  create?: Maybe<Array<ServiceCreateWithoutCanonicalServiceInput>>;
  createMany?: Maybe<ServiceCreateManyCanonicalServiceInputEnvelope>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutCanonicalServiceInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutCanonicalServiceInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutCanonicalServiceInput>>;
};

export type ServiceUncheckedUpdateManyWithoutFormTemplateInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateManyWithoutFormTemplateNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutFormTemplateInput>>;
  create?: Maybe<Array<ServiceCreateWithoutFormTemplateInput>>;
  createMany?: Maybe<ServiceCreateManyFormTemplateInputEnvelope>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutFormTemplateInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutFormTemplateInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutFormTemplateInput>>;
};

export type ServiceUncheckedUpdateManyWithoutIntegrationInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ServiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ServiceCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ServiceUncheckedUpdateManyWithoutServiceCategoryInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateManyWithoutServiceCategoryNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutServiceCategoryInput>>;
  create?: Maybe<Array<ServiceCreateWithoutServiceCategoryInput>>;
  createMany?: Maybe<ServiceCreateManyServiceCategoryInputEnvelope>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutServiceCategoryInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutServiceCategoryInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutServiceCategoryInput>>;
};

export type ServiceUncheckedUpdateManyWithoutTaxonomyInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateManyWithoutTaxonomyNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<ServiceCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<ServiceCreateManyTaxonomyInputEnvelope>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutTaxonomyInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutTaxonomyInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutTaxonomyInput>>;
};

export type ServiceUncheckedUpdateManyWithoutVetsourceCodeTagsInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateManyWithoutVetsourceCodeTagsNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutVetsourceCodeTagsInput>>;
  create?: Maybe<Array<ServiceCreateWithoutVetsourceCodeTagsInput>>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutVetsourceCodeTagsInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutVetsourceCodeTagsInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutVetsourceCodeTagsInput>>;
};

export type ServiceUncheckedUpdateManyWithoutVetsourceRevenueCategoryInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
};

export type ServiceUncheckedUpdateManyWithoutVetsourceRevenueCategoryNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutVetsourceRevenueCategoryInput>>;
  create?: Maybe<Array<ServiceCreateWithoutVetsourceRevenueCategoryInput>>;
  createMany?: Maybe<ServiceCreateManyVetsourceRevenueCategoryInputEnvelope>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutVetsourceRevenueCategoryInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutVetsourceRevenueCategoryInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutVetsourceRevenueCategoryInput>>;
};

export type ServiceUncheckedUpdateWithoutCanonicalServiceInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutDraftCareBenefitUsageToInvoiceLineItemsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutFormTemplateInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutIntegrationInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutInvoiceLineItemsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutLoyaltyPointGrantingServicesInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutMedicalHistoryInput = {
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutOrganizationCareBenefitToClinicServiceInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutPrescriptionsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutReminderTimingsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutRemindersInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutServiceCategoryInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutServicePurchaseSummariesInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutTaxonomyInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutVetsourceCodeTagsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategoryName?: Maybe<Scalars['String']>;
};

export type ServiceUncheckedUpdateWithoutVetsourceRevenueCategoryInput = {
  MedicalHistory?: Maybe<MedicalHistoryUncheckedUpdateManyWithoutServiceNestedInput>;
  canonicalServiceId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutDraftServiceNestedInput>;
  formTemplateId?: Maybe<Scalars['String']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUncheckedUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUncheckedUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUncheckedUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUncheckedUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUncheckedUpdateManyWithoutServiceNestedInput>;
  serviceCategoryId?: Maybe<Scalars['String']>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUncheckedUpdateManyWithoutServiceNestedInput>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
};

export type ServiceUpdateInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateManyMutationInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
};

export type ServiceUpdateManyWithWhereWithoutCanonicalServiceInput = {
  data: ServiceUpdateManyMutationInput;
  where: ServiceScalarWhereInput;
};

export type ServiceUpdateManyWithWhereWithoutFormTemplateInput = {
  data: ServiceUpdateManyMutationInput;
  where: ServiceScalarWhereInput;
};

export type ServiceUpdateManyWithWhereWithoutIntegrationInput = {
  data: ServiceUpdateManyMutationInput;
  where: ServiceScalarWhereInput;
};

export type ServiceUpdateManyWithWhereWithoutServiceCategoryInput = {
  data: ServiceUpdateManyMutationInput;
  where: ServiceScalarWhereInput;
};

export type ServiceUpdateManyWithWhereWithoutTaxonomyInput = {
  data: ServiceUpdateManyMutationInput;
  where: ServiceScalarWhereInput;
};

export type ServiceUpdateManyWithWhereWithoutVetsourceCodeTagsInput = {
  data: ServiceUpdateManyMutationInput;
  where: ServiceScalarWhereInput;
};

export type ServiceUpdateManyWithWhereWithoutVetsourceRevenueCategoryInput = {
  data: ServiceUpdateManyMutationInput;
  where: ServiceScalarWhereInput;
};

export type ServiceUpdateManyWithoutCanonicalServiceNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutCanonicalServiceInput>>;
  create?: Maybe<Array<ServiceCreateWithoutCanonicalServiceInput>>;
  createMany?: Maybe<ServiceCreateManyCanonicalServiceInputEnvelope>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutCanonicalServiceInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutCanonicalServiceInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutCanonicalServiceInput>>;
};

export type ServiceUpdateManyWithoutFormTemplateNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutFormTemplateInput>>;
  create?: Maybe<Array<ServiceCreateWithoutFormTemplateInput>>;
  createMany?: Maybe<ServiceCreateManyFormTemplateInputEnvelope>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutFormTemplateInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutFormTemplateInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutFormTemplateInput>>;
};

export type ServiceUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<ServiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<ServiceCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type ServiceUpdateManyWithoutServiceCategoryNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutServiceCategoryInput>>;
  create?: Maybe<Array<ServiceCreateWithoutServiceCategoryInput>>;
  createMany?: Maybe<ServiceCreateManyServiceCategoryInputEnvelope>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutServiceCategoryInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutServiceCategoryInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutServiceCategoryInput>>;
};

export type ServiceUpdateManyWithoutTaxonomyNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<ServiceCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<ServiceCreateManyTaxonomyInputEnvelope>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutTaxonomyInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutTaxonomyInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutTaxonomyInput>>;
};

export type ServiceUpdateManyWithoutVetsourceCodeTagsNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutVetsourceCodeTagsInput>>;
  create?: Maybe<Array<ServiceCreateWithoutVetsourceCodeTagsInput>>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutVetsourceCodeTagsInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutVetsourceCodeTagsInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutVetsourceCodeTagsInput>>;
};

export type ServiceUpdateManyWithoutVetsourceRevenueCategoryNestedInput = {
  connect?: Maybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ServiceCreateOrConnectWithoutVetsourceRevenueCategoryInput>>;
  create?: Maybe<Array<ServiceCreateWithoutVetsourceRevenueCategoryInput>>;
  createMany?: Maybe<ServiceCreateManyVetsourceRevenueCategoryInputEnvelope>;
  delete?: Maybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<ServiceWhereUniqueInput>>;
  set?: Maybe<Array<ServiceWhereUniqueInput>>;
  update?: Maybe<Array<ServiceUpdateWithWhereUniqueWithoutVetsourceRevenueCategoryInput>>;
  updateMany?: Maybe<Array<ServiceUpdateManyWithWhereWithoutVetsourceRevenueCategoryInput>>;
  upsert?: Maybe<Array<ServiceUpsertWithWhereUniqueWithoutVetsourceRevenueCategoryInput>>;
};

export type ServiceUpdateOneRequiredWithoutLoyaltyPointGrantingServicesNestedInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutLoyaltyPointGrantingServicesInput>;
  create?: Maybe<ServiceCreateWithoutLoyaltyPointGrantingServicesInput>;
  update?: Maybe<ServiceUpdateToOneWithWhereWithoutLoyaltyPointGrantingServicesInput>;
  upsert?: Maybe<ServiceUpsertWithoutLoyaltyPointGrantingServicesInput>;
};

export type ServiceUpdateOneRequiredWithoutOrganizationCareBenefitToClinicServiceNestedInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutOrganizationCareBenefitToClinicServiceInput>;
  create?: Maybe<ServiceCreateWithoutOrganizationCareBenefitToClinicServiceInput>;
  update?: Maybe<ServiceUpdateToOneWithWhereWithoutOrganizationCareBenefitToClinicServiceInput>;
  upsert?: Maybe<ServiceUpsertWithoutOrganizationCareBenefitToClinicServiceInput>;
};

export type ServiceUpdateOneRequiredWithoutReminderTimingsNestedInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutReminderTimingsInput>;
  create?: Maybe<ServiceCreateWithoutReminderTimingsInput>;
  update?: Maybe<ServiceUpdateToOneWithWhereWithoutReminderTimingsInput>;
  upsert?: Maybe<ServiceUpsertWithoutReminderTimingsInput>;
};

export type ServiceUpdateOneRequiredWithoutRemindersNestedInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutRemindersInput>;
  create?: Maybe<ServiceCreateWithoutRemindersInput>;
  update?: Maybe<ServiceUpdateToOneWithWhereWithoutRemindersInput>;
  upsert?: Maybe<ServiceUpsertWithoutRemindersInput>;
};

export type ServiceUpdateOneRequiredWithoutServicePurchaseSummariesNestedInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutServicePurchaseSummariesInput>;
  create?: Maybe<ServiceCreateWithoutServicePurchaseSummariesInput>;
  update?: Maybe<ServiceUpdateToOneWithWhereWithoutServicePurchaseSummariesInput>;
  upsert?: Maybe<ServiceUpsertWithoutServicePurchaseSummariesInput>;
};

export type ServiceUpdateOneWithoutDraftCareBenefitUsageToInvoiceLineItemsNestedInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutDraftCareBenefitUsageToInvoiceLineItemsInput>;
  create?: Maybe<ServiceCreateWithoutDraftCareBenefitUsageToInvoiceLineItemsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServiceUpdateToOneWithWhereWithoutDraftCareBenefitUsageToInvoiceLineItemsInput>;
  upsert?: Maybe<ServiceUpsertWithoutDraftCareBenefitUsageToInvoiceLineItemsInput>;
};

export type ServiceUpdateOneWithoutInvoiceLineItemsNestedInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutInvoiceLineItemsInput>;
  create?: Maybe<ServiceCreateWithoutInvoiceLineItemsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServiceUpdateToOneWithWhereWithoutInvoiceLineItemsInput>;
  upsert?: Maybe<ServiceUpsertWithoutInvoiceLineItemsInput>;
};

export type ServiceUpdateOneWithoutMedicalHistoryNestedInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutMedicalHistoryInput>;
  create?: Maybe<ServiceCreateWithoutMedicalHistoryInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServiceUpdateToOneWithWhereWithoutMedicalHistoryInput>;
  upsert?: Maybe<ServiceUpsertWithoutMedicalHistoryInput>;
};

export type ServiceUpdateOneWithoutPrescriptionsNestedInput = {
  connect?: Maybe<ServiceWhereUniqueInput>;
  connectOrCreate?: Maybe<ServiceCreateOrConnectWithoutPrescriptionsInput>;
  create?: Maybe<ServiceCreateWithoutPrescriptionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServiceUpdateToOneWithWhereWithoutPrescriptionsInput>;
  upsert?: Maybe<ServiceUpsertWithoutPrescriptionsInput>;
};

export type ServiceUpdateToOneWithWhereWithoutDraftCareBenefitUsageToInvoiceLineItemsInput = {
  data: ServiceUpdateWithoutDraftCareBenefitUsageToInvoiceLineItemsInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpdateToOneWithWhereWithoutInvoiceLineItemsInput = {
  data: ServiceUpdateWithoutInvoiceLineItemsInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpdateToOneWithWhereWithoutLoyaltyPointGrantingServicesInput = {
  data: ServiceUpdateWithoutLoyaltyPointGrantingServicesInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpdateToOneWithWhereWithoutMedicalHistoryInput = {
  data: ServiceUpdateWithoutMedicalHistoryInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpdateToOneWithWhereWithoutOrganizationCareBenefitToClinicServiceInput = {
  data: ServiceUpdateWithoutOrganizationCareBenefitToClinicServiceInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpdateToOneWithWhereWithoutPrescriptionsInput = {
  data: ServiceUpdateWithoutPrescriptionsInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpdateToOneWithWhereWithoutReminderTimingsInput = {
  data: ServiceUpdateWithoutReminderTimingsInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpdateToOneWithWhereWithoutRemindersInput = {
  data: ServiceUpdateWithoutRemindersInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpdateToOneWithWhereWithoutServicePurchaseSummariesInput = {
  data: ServiceUpdateWithoutServicePurchaseSummariesInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpdateWithWhereUniqueWithoutCanonicalServiceInput = {
  data: ServiceUpdateWithoutCanonicalServiceInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpdateWithWhereUniqueWithoutFormTemplateInput = {
  data: ServiceUpdateWithoutFormTemplateInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: ServiceUpdateWithoutIntegrationInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpdateWithWhereUniqueWithoutServiceCategoryInput = {
  data: ServiceUpdateWithoutServiceCategoryInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpdateWithWhereUniqueWithoutTaxonomyInput = {
  data: ServiceUpdateWithoutTaxonomyInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpdateWithWhereUniqueWithoutVetsourceCodeTagsInput = {
  data: ServiceUpdateWithoutVetsourceCodeTagsInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpdateWithWhereUniqueWithoutVetsourceRevenueCategoryInput = {
  data: ServiceUpdateWithoutVetsourceRevenueCategoryInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpdateWithoutCanonicalServiceInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutDraftCareBenefitUsageToInvoiceLineItemsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutFormTemplateInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutIntegrationInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutInvoiceLineItemsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutLoyaltyPointGrantingServicesInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutMedicalHistoryInput = {
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutOrganizationCareBenefitToClinicServiceInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutPrescriptionsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutReminderTimingsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutRemindersInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutServiceCategoryInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutServicePurchaseSummariesInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutTaxonomyInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutVetsourceCodeTagsInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutVetsourceRevenueCategoryInput = {
  MedicalHistory?: Maybe<MedicalHistoryUpdateManyWithoutServiceNestedInput>;
  canonicalService?: Maybe<CanonicalServiceUpdateOneWithoutServicesNestedInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutDraftServiceNestedInput>;
  formTemplate?: Maybe<FormTemplateUpdateOneWithoutServicesNestedInput>;
  hasConfiguredReminders?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutServicesNestedInput>;
  invoiceLineItems?: Maybe<InvoiceLineItemUpdateManyWithoutServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPetPortal?: Maybe<Scalars['Boolean']>;
  isPostcard?: Maybe<Scalars['Boolean']>;
  isReminderActive?: Maybe<Scalars['Boolean']>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceUpdateManyWithoutServiceNestedInput>;
  name?: Maybe<Scalars['String']>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceUpdateManyWithoutServiceNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  pimsType?: Maybe<Scalars['String']>;
  prescriptions?: Maybe<PrescriptionUpdateManyWithoutServiceNestedInput>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reminderActivationDate?: Maybe<Scalars['DateTime']>;
  reminderTimings?: Maybe<ServiceReminderTimingUpdateManyWithoutServiceNestedInput>;
  reminders?: Maybe<ServiceReminderUpdateManyWithoutServiceNestedInput>;
  serviceCategory?: Maybe<ServiceCategoryUpdateOneWithoutChildServicesNestedInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryUpdateManyWithoutServiceNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneWithoutServiceNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagUpdateManyWithoutServiceNestedInput>;
  vetsourceFreeDoses?: Maybe<Scalars['Int']>;
  vetsourcePaidDoses?: Maybe<Scalars['Int']>;
  vetsourceQuantityOverride?: Maybe<Scalars['Float']>;
};

export type ServiceUpsertWithWhereUniqueWithoutCanonicalServiceInput = {
  create: ServiceCreateWithoutCanonicalServiceInput;
  update: ServiceUpdateWithoutCanonicalServiceInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpsertWithWhereUniqueWithoutFormTemplateInput = {
  create: ServiceCreateWithoutFormTemplateInput;
  update: ServiceUpdateWithoutFormTemplateInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: ServiceCreateWithoutIntegrationInput;
  update: ServiceUpdateWithoutIntegrationInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpsertWithWhereUniqueWithoutServiceCategoryInput = {
  create: ServiceCreateWithoutServiceCategoryInput;
  update: ServiceUpdateWithoutServiceCategoryInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpsertWithWhereUniqueWithoutTaxonomyInput = {
  create: ServiceCreateWithoutTaxonomyInput;
  update: ServiceUpdateWithoutTaxonomyInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpsertWithWhereUniqueWithoutVetsourceCodeTagsInput = {
  create: ServiceCreateWithoutVetsourceCodeTagsInput;
  update: ServiceUpdateWithoutVetsourceCodeTagsInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpsertWithWhereUniqueWithoutVetsourceRevenueCategoryInput = {
  create: ServiceCreateWithoutVetsourceRevenueCategoryInput;
  update: ServiceUpdateWithoutVetsourceRevenueCategoryInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpsertWithoutDraftCareBenefitUsageToInvoiceLineItemsInput = {
  create: ServiceCreateWithoutDraftCareBenefitUsageToInvoiceLineItemsInput;
  update: ServiceUpdateWithoutDraftCareBenefitUsageToInvoiceLineItemsInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpsertWithoutInvoiceLineItemsInput = {
  create: ServiceCreateWithoutInvoiceLineItemsInput;
  update: ServiceUpdateWithoutInvoiceLineItemsInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpsertWithoutLoyaltyPointGrantingServicesInput = {
  create: ServiceCreateWithoutLoyaltyPointGrantingServicesInput;
  update: ServiceUpdateWithoutLoyaltyPointGrantingServicesInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpsertWithoutMedicalHistoryInput = {
  create: ServiceCreateWithoutMedicalHistoryInput;
  update: ServiceUpdateWithoutMedicalHistoryInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpsertWithoutOrganizationCareBenefitToClinicServiceInput = {
  create: ServiceCreateWithoutOrganizationCareBenefitToClinicServiceInput;
  update: ServiceUpdateWithoutOrganizationCareBenefitToClinicServiceInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpsertWithoutPrescriptionsInput = {
  create: ServiceCreateWithoutPrescriptionsInput;
  update: ServiceUpdateWithoutPrescriptionsInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpsertWithoutReminderTimingsInput = {
  create: ServiceCreateWithoutReminderTimingsInput;
  update: ServiceUpdateWithoutReminderTimingsInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpsertWithoutRemindersInput = {
  create: ServiceCreateWithoutRemindersInput;
  update: ServiceUpdateWithoutRemindersInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceUpsertWithoutServicePurchaseSummariesInput = {
  create: ServiceCreateWithoutServicePurchaseSummariesInput;
  update: ServiceUpdateWithoutServicePurchaseSummariesInput;
  where?: Maybe<ServiceWhereInput>;
};

export type ServiceWhereInput = {
  AND?: Maybe<Array<ServiceWhereInput>>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ServiceWhereInput>>;
  OR?: Maybe<Array<ServiceWhereInput>>;
  canonicalService?: Maybe<CanonicalServiceNullableScalarRelationFilter>;
  canonicalServiceId?: Maybe<StringNullableFilter>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  formTemplate?: Maybe<FormTemplateNullableScalarRelationFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  hasConfiguredReminders?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isPetPortal?: Maybe<BoolFilter>;
  isPostcard?: Maybe<BoolFilter>;
  isReminderActive?: Maybe<BoolFilter>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceListRelationFilter>;
  name?: Maybe<StringFilter>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceListRelationFilter>;
  pimsId?: Maybe<StringFilter>;
  pimsName?: Maybe<StringFilter>;
  pimsType?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  reminderActivationDate?: Maybe<DateTimeNullableFilter>;
  reminderTimings?: Maybe<ServiceReminderTimingListRelationFilter>;
  reminders?: Maybe<ServiceReminderListRelationFilter>;
  serviceCategory?: Maybe<ServiceCategoryNullableScalarRelationFilter>;
  serviceCategoryId?: Maybe<StringNullableFilter>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagListRelationFilter>;
  vetsourceFreeDoses?: Maybe<IntNullableFilter>;
  vetsourcePaidDoses?: Maybe<IntNullableFilter>;
  vetsourceQuantityOverride?: Maybe<FloatNullableFilter>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryNullableScalarRelationFilter>;
  vetsourceRevenueCategoryName?: Maybe<StringNullableFilter>;
};

export type ServiceWhereUniqueInput = {
  AND?: Maybe<Array<ServiceWhereInput>>;
  MedicalHistory?: Maybe<MedicalHistoryListRelationFilter>;
  NOT?: Maybe<Array<ServiceWhereInput>>;
  OR?: Maybe<Array<ServiceWhereInput>>;
  canonicalService?: Maybe<CanonicalServiceNullableScalarRelationFilter>;
  canonicalServiceId?: Maybe<StringNullableFilter>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  draftCareBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  formTemplate?: Maybe<FormTemplateNullableScalarRelationFilter>;
  formTemplateId?: Maybe<StringNullableFilter>;
  hasConfiguredReminders?: Maybe<BoolFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  invoiceLineItems?: Maybe<InvoiceLineItemListRelationFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isPetPortal?: Maybe<BoolFilter>;
  isPostcard?: Maybe<BoolFilter>;
  isReminderActive?: Maybe<BoolFilter>;
  loyaltyPointGrantingServices?: Maybe<LoyaltyPointGrantingServiceListRelationFilter>;
  name?: Maybe<StringFilter>;
  organizationCareBenefitToClinicService?: Maybe<OrganizationCareBenefitToClinicServiceListRelationFilter>;
  pimsId?: Maybe<StringFilter>;
  pimsName?: Maybe<StringFilter>;
  pimsType?: Maybe<StringNullableFilter>;
  prescriptions?: Maybe<PrescriptionListRelationFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  reminderActivationDate?: Maybe<DateTimeNullableFilter>;
  reminderTimings?: Maybe<ServiceReminderTimingListRelationFilter>;
  reminders?: Maybe<ServiceReminderListRelationFilter>;
  serviceCategory?: Maybe<ServiceCategoryNullableScalarRelationFilter>;
  serviceCategoryId?: Maybe<StringNullableFilter>;
  serviceCodeAndIntegrationId?: Maybe<ServiceServiceCodeAndIntegrationIdCompoundUniqueInput>;
  servicePimsIdAndIntegrationId?: Maybe<ServiceServicePimsIdAndIntegrationIdCompoundUniqueInput>;
  servicePurchaseSummaries?: Maybe<ServicePurchaseSummaryListRelationFilter>;
  taxonomy?: Maybe<TaxonomyNullableScalarRelationFilter>;
  taxonomyId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetsourceCodeTags?: Maybe<VetsourceCodeTagListRelationFilter>;
  vetsourceFreeDoses?: Maybe<IntNullableFilter>;
  vetsourcePaidDoses?: Maybe<IntNullableFilter>;
  vetsourceQuantityOverride?: Maybe<FloatNullableFilter>;
  vetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryNullableScalarRelationFilter>;
  vetsourceRevenueCategoryName?: Maybe<StringNullableFilter>;
};

export type Sex = {
  __typename?: 'Sex';
  _count: SexCountOutputType;
  abbreviation?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets: Array<ClinicPet>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<Species>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type SexPetsArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type SexSpeciesArgs = {
  where?: Maybe<SpeciesWhereInput>;
};

export type SexCountAggregateOutputType = {
  __typename?: 'SexCountAggregateOutputType';
  _all: Scalars['Int'];
  abbreviation: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isDesexed: Scalars['Int'];
  name: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  speciesId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SexCountOrderByAggregateInput = {
  abbreviation?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isDesexed?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SexCountOutputType = {
  __typename?: 'SexCountOutputType';
  pets: Scalars['Int'];
};

export type SexCreateInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutSexesInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetCreateNestedManyWithoutSexModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesCreateNestedOneWithoutSexesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexCreateManyInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexCreateManyIntegrationInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexCreateManyIntegrationInputEnvelope = {
  data: Array<SexCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SexCreateManySpeciesInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexCreateManySpeciesInputEnvelope = {
  data: Array<SexCreateManySpeciesInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SexCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<SexWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SexCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<SexCreateWithoutIntegrationInput>>;
  createMany?: Maybe<SexCreateManyIntegrationInputEnvelope>;
};

export type SexCreateNestedManyWithoutSpeciesInput = {
  connect?: Maybe<Array<SexWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SexCreateOrConnectWithoutSpeciesInput>>;
  create?: Maybe<Array<SexCreateWithoutSpeciesInput>>;
  createMany?: Maybe<SexCreateManySpeciesInputEnvelope>;
};

export type SexCreateNestedOneWithoutPetsInput = {
  connect?: Maybe<SexWhereUniqueInput>;
  connectOrCreate?: Maybe<SexCreateOrConnectWithoutPetsInput>;
  create?: Maybe<SexCreateWithoutPetsInput>;
};

export type SexCreateOrConnectWithoutIntegrationInput = {
  create: SexCreateWithoutIntegrationInput;
  where: SexWhereUniqueInput;
};

export type SexCreateOrConnectWithoutPetsInput = {
  create: SexCreateWithoutPetsInput;
  where: SexWhereUniqueInput;
};

export type SexCreateOrConnectWithoutSpeciesInput = {
  create: SexCreateWithoutSpeciesInput;
  where: SexWhereUniqueInput;
};

export type SexCreateWithoutIntegrationInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetCreateNestedManyWithoutSexModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesCreateNestedOneWithoutSexesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexCreateWithoutPetsInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutSexesInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesCreateNestedOneWithoutSexesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexCreateWithoutSpeciesInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutSexesInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetCreateNestedManyWithoutSexModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexGroupByOutputType = {
  __typename?: 'SexGroupByOutputType';
  _count?: Maybe<SexCountAggregateOutputType>;
  _max?: Maybe<SexMaxAggregateOutputType>;
  _min?: Maybe<SexMinAggregateOutputType>;
  abbreviation?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SexIntegrationIdPimsIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type SexListRelationFilter = {
  every?: Maybe<SexWhereInput>;
  none?: Maybe<SexWhereInput>;
  some?: Maybe<SexWhereInput>;
};

export type SexMaxAggregateOutputType = {
  __typename?: 'SexMaxAggregateOutputType';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexMaxOrderByAggregateInput = {
  abbreviation?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isDesexed?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SexMinAggregateOutputType = {
  __typename?: 'SexMinAggregateOutputType';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexMinOrderByAggregateInput = {
  abbreviation?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isDesexed?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SexNullableScalarRelationFilter = {
  AND?: Maybe<Array<SexWhereInput>>;
  NOT?: Maybe<Array<SexWhereInput>>;
  OR?: Maybe<Array<SexWhereInput>>;
  abbreviation?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isDesexed?: Maybe<BoolNullableFilter>;
  name?: Maybe<StringFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  species?: Maybe<SpeciesNullableScalarRelationFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SexOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SexOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SexOrderByRelevanceInput>;
  abbreviation?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isDesexed?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  species?: Maybe<SpeciesOrderByWithRelationInput>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SexOrderByRelevanceFieldEnum {
  Abbreviation = 'abbreviation',
  Id = 'id',
  IntegrationId = 'integrationId',
  Name = 'name',
  PimsId = 'pimsId',
  SpeciesId = 'speciesId'
}

export type SexOrderByRelevanceInput = {
  fields: Array<SexOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type SexOrderByWithAggregationInput = {
  _count?: Maybe<SexCountOrderByAggregateInput>;
  _max?: Maybe<SexMaxOrderByAggregateInput>;
  _min?: Maybe<SexMinOrderByAggregateInput>;
  abbreviation?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isDesexed?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SexOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SexOrderByRelevanceInput>;
  abbreviation?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isDesexed?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  species?: Maybe<SpeciesOrderByWithRelationInput>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SexOrderByWithRelationInput = {
  _relevance?: Maybe<SexOrderByRelevanceInput>;
  abbreviation?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isDesexed?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  species?: Maybe<SpeciesOrderByWithRelationInput>;
  speciesId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SexScalarFieldEnum {
  Abbreviation = 'abbreviation',
  CreatedAt = 'createdAt',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  IsDesexed = 'isDesexed',
  Name = 'name',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  SpeciesId = 'speciesId',
  UpdatedAt = 'updatedAt'
}

export type SexScalarWhereInput = {
  AND?: Maybe<Array<SexScalarWhereInput>>;
  NOT?: Maybe<Array<SexScalarWhereInput>>;
  OR?: Maybe<Array<SexScalarWhereInput>>;
  abbreviation?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isDesexed?: Maybe<BoolNullableFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SexScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SexScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SexScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SexScalarWhereWithAggregatesInput>>;
  abbreviation?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  isDesexed?: Maybe<BoolNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  speciesId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type SexUncheckedCreateInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutSexModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<SexWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SexCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<SexCreateWithoutIntegrationInput>>;
  createMany?: Maybe<SexCreateManyIntegrationInputEnvelope>;
};

export type SexUncheckedCreateNestedManyWithoutSpeciesInput = {
  connect?: Maybe<Array<SexWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SexCreateOrConnectWithoutSpeciesInput>>;
  create?: Maybe<Array<SexCreateWithoutSpeciesInput>>;
  createMany?: Maybe<SexCreateManySpeciesInputEnvelope>;
};

export type SexUncheckedCreateWithoutIntegrationInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutSexModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUncheckedCreateWithoutPetsInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUncheckedCreateWithoutSpeciesInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutSexModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUncheckedUpdateInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutSexModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUncheckedUpdateManyInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUncheckedUpdateManyWithoutIntegrationInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<SexWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SexCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<SexCreateWithoutIntegrationInput>>;
  createMany?: Maybe<SexCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<SexWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SexScalarWhereInput>>;
  disconnect?: Maybe<Array<SexWhereUniqueInput>>;
  set?: Maybe<Array<SexWhereUniqueInput>>;
  update?: Maybe<Array<SexUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<SexUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<SexUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type SexUncheckedUpdateManyWithoutSpeciesInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUncheckedUpdateManyWithoutSpeciesNestedInput = {
  connect?: Maybe<Array<SexWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SexCreateOrConnectWithoutSpeciesInput>>;
  create?: Maybe<Array<SexCreateWithoutSpeciesInput>>;
  createMany?: Maybe<SexCreateManySpeciesInputEnvelope>;
  delete?: Maybe<Array<SexWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SexScalarWhereInput>>;
  disconnect?: Maybe<Array<SexWhereUniqueInput>>;
  set?: Maybe<Array<SexWhereUniqueInput>>;
  update?: Maybe<Array<SexUpdateWithWhereUniqueWithoutSpeciesInput>>;
  updateMany?: Maybe<Array<SexUpdateManyWithWhereWithoutSpeciesInput>>;
  upsert?: Maybe<Array<SexUpsertWithWhereUniqueWithoutSpeciesInput>>;
};

export type SexUncheckedUpdateWithoutIntegrationInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutSexModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUncheckedUpdateWithoutPetsInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  speciesId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUncheckedUpdateWithoutSpeciesInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutSexModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUpdateInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutSexesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutSexModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesUpdateOneWithoutSexesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUpdateManyMutationInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUpdateManyWithWhereWithoutIntegrationInput = {
  data: SexUpdateManyMutationInput;
  where: SexScalarWhereInput;
};

export type SexUpdateManyWithWhereWithoutSpeciesInput = {
  data: SexUpdateManyMutationInput;
  where: SexScalarWhereInput;
};

export type SexUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<SexWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SexCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<SexCreateWithoutIntegrationInput>>;
  createMany?: Maybe<SexCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<SexWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SexScalarWhereInput>>;
  disconnect?: Maybe<Array<SexWhereUniqueInput>>;
  set?: Maybe<Array<SexWhereUniqueInput>>;
  update?: Maybe<Array<SexUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<SexUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<SexUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type SexUpdateManyWithoutSpeciesNestedInput = {
  connect?: Maybe<Array<SexWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SexCreateOrConnectWithoutSpeciesInput>>;
  create?: Maybe<Array<SexCreateWithoutSpeciesInput>>;
  createMany?: Maybe<SexCreateManySpeciesInputEnvelope>;
  delete?: Maybe<Array<SexWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SexScalarWhereInput>>;
  disconnect?: Maybe<Array<SexWhereUniqueInput>>;
  set?: Maybe<Array<SexWhereUniqueInput>>;
  update?: Maybe<Array<SexUpdateWithWhereUniqueWithoutSpeciesInput>>;
  updateMany?: Maybe<Array<SexUpdateManyWithWhereWithoutSpeciesInput>>;
  upsert?: Maybe<Array<SexUpsertWithWhereUniqueWithoutSpeciesInput>>;
};

export type SexUpdateOneWithoutPetsNestedInput = {
  connect?: Maybe<SexWhereUniqueInput>;
  connectOrCreate?: Maybe<SexCreateOrConnectWithoutPetsInput>;
  create?: Maybe<SexCreateWithoutPetsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<SexUpdateToOneWithWhereWithoutPetsInput>;
  upsert?: Maybe<SexUpsertWithoutPetsInput>;
};

export type SexUpdateToOneWithWhereWithoutPetsInput = {
  data: SexUpdateWithoutPetsInput;
  where?: Maybe<SexWhereInput>;
};

export type SexUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: SexUpdateWithoutIntegrationInput;
  where: SexWhereUniqueInput;
};

export type SexUpdateWithWhereUniqueWithoutSpeciesInput = {
  data: SexUpdateWithoutSpeciesInput;
  where: SexWhereUniqueInput;
};

export type SexUpdateWithoutIntegrationInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutSexModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesUpdateOneWithoutSexesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUpdateWithoutPetsInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutSexesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  species?: Maybe<SpeciesUpdateOneWithoutSexesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUpdateWithoutSpeciesInput = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutSexesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDesexed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutSexModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SexUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: SexCreateWithoutIntegrationInput;
  update: SexUpdateWithoutIntegrationInput;
  where: SexWhereUniqueInput;
};

export type SexUpsertWithWhereUniqueWithoutSpeciesInput = {
  create: SexCreateWithoutSpeciesInput;
  update: SexUpdateWithoutSpeciesInput;
  where: SexWhereUniqueInput;
};

export type SexUpsertWithoutPetsInput = {
  create: SexCreateWithoutPetsInput;
  update: SexUpdateWithoutPetsInput;
  where?: Maybe<SexWhereInput>;
};

export type SexWhereInput = {
  AND?: Maybe<Array<SexWhereInput>>;
  NOT?: Maybe<Array<SexWhereInput>>;
  OR?: Maybe<Array<SexWhereInput>>;
  abbreviation?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isDesexed?: Maybe<BoolNullableFilter>;
  name?: Maybe<StringFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  species?: Maybe<SpeciesNullableScalarRelationFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SexWhereUniqueInput = {
  AND?: Maybe<Array<SexWhereInput>>;
  NOT?: Maybe<Array<SexWhereInput>>;
  OR?: Maybe<Array<SexWhereInput>>;
  abbreviation?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  integrationId_pimsId?: Maybe<SexIntegrationIdPimsIdCompoundUniqueInput>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isDesexed?: Maybe<BoolNullableFilter>;
  name?: Maybe<StringFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  species?: Maybe<SpeciesNullableScalarRelationFilter>;
  speciesId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum SmsEntityType {
  AutomationRun = 'AutomationRun',
  ChannelMessage = 'ChannelMessage',
  MassTextAlertEntry = 'MassTextAlertEntry',
  ServiceReminderNotification = 'ServiceReminderNotification'
}

export enum SmsNotificationDeliveryErrorType {
  CannotReceiveMessageType = 'CannotReceiveMessageType',
  ConnectionError = 'ConnectionError',
  ErrorSendingMessageToProvider = 'ErrorSendingMessageToProvider',
  InvalidContactInfo = 'InvalidContactInfo',
  MessageFilteredByCarrier = 'MessageFilteredByCarrier',
  NotificationRefused = 'NotificationRefused',
  Unknown = 'Unknown'
}

export enum SmsNotificationProvider {
  Bandwidth = 'Bandwidth',
  Twilio = 'Twilio'
}

export type SmsNotificationStatus = {
  __typename?: 'SmsNotificationStatus';
  clinicPhoneNumber?: Maybe<ClinicPhoneNumber>;
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  /** Our categorization of the error */
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id: Scalars['String'];
  /** who is delivering our message (e.g. Twilio) */
  provider: SmsNotificationProvider;
  /** the error message given by the provider */
  providerErrorData?: Maybe<Scalars['String']>;
  /** the unique id the deliverer gives us to track the message (e.g. message_sId) */
  providerMessageId: Scalars['String'];
  /** (e.g. the phone number or email of the message) */
  receivingNumber: Scalars['String'];
  sentChannelMessage?: Maybe<ChannelMessage>;
  /** optionally included: the channel associated with this notification */
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId: Scalars['String'];
  /** the kind of entity the sourceContactEntityId references */
  sourceContactEntityType: ContactEntityType;
  status: SmsNotificationStatusType;
  updatedAt: Scalars['DateTime'];
};


export type SmsNotificationStatusClinicPhoneNumberArgs = {
  where?: Maybe<ClinicPhoneNumberWhereInput>;
};


export type SmsNotificationStatusSentChannelMessageArgs = {
  where?: Maybe<ChannelMessageWhereInput>;
};

export type SmsNotificationStatusCountAggregateOutputType = {
  __typename?: 'SmsNotificationStatusCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPhoneNumberId: Scalars['Int'];
  createdAt: Scalars['Int'];
  entityId: Scalars['Int'];
  entityType: Scalars['Int'];
  errorType: Scalars['Int'];
  id: Scalars['Int'];
  provider: Scalars['Int'];
  providerErrorData: Scalars['Int'];
  providerMessageId: Scalars['Int'];
  receivingNumber: Scalars['Int'];
  sentChannelMessageId: Scalars['Int'];
  sourceContactEntityId: Scalars['Int'];
  sourceContactEntityType: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SmsNotificationStatusCountOrderByAggregateInput = {
  clinicPhoneNumberId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  receivingNumber?: Maybe<SortOrder>;
  sentChannelMessageId?: Maybe<SortOrder>;
  sourceContactEntityId?: Maybe<SortOrder>;
  sourceContactEntityType?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SmsNotificationStatusCreateInput = {
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedOneWithoutSmsNotificationStatusesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider: SmsNotificationProvider;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId: Scalars['String'];
  receivingNumber: Scalars['String'];
  sentChannelMessage?: Maybe<ChannelMessageCreateNestedOneWithoutSmsNotifificationStatusesInput>;
  sourceContactEntityId: Scalars['String'];
  sourceContactEntityType: ContactEntityType;
  status: SmsNotificationStatusType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusCreateManyClinicPhoneNumberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider: SmsNotificationProvider;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId: Scalars['String'];
  receivingNumber: Scalars['String'];
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId: Scalars['String'];
  sourceContactEntityType: ContactEntityType;
  status: SmsNotificationStatusType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusCreateManyClinicPhoneNumberInputEnvelope = {
  data: Array<SmsNotificationStatusCreateManyClinicPhoneNumberInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SmsNotificationStatusCreateManyInput = {
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider: SmsNotificationProvider;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId: Scalars['String'];
  receivingNumber: Scalars['String'];
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId: Scalars['String'];
  sourceContactEntityType: ContactEntityType;
  status: SmsNotificationStatusType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusCreateManySentChannelMessageInput = {
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider: SmsNotificationProvider;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId: Scalars['String'];
  receivingNumber: Scalars['String'];
  sourceContactEntityId: Scalars['String'];
  sourceContactEntityType: ContactEntityType;
  status: SmsNotificationStatusType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusCreateManySentChannelMessageInputEnvelope = {
  data: Array<SmsNotificationStatusCreateManySentChannelMessageInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SmsNotificationStatusCreateNestedManyWithoutClinicPhoneNumberInput = {
  connect?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SmsNotificationStatusCreateOrConnectWithoutClinicPhoneNumberInput>>;
  create?: Maybe<Array<SmsNotificationStatusCreateWithoutClinicPhoneNumberInput>>;
  createMany?: Maybe<SmsNotificationStatusCreateManyClinicPhoneNumberInputEnvelope>;
};

export type SmsNotificationStatusCreateNestedManyWithoutSentChannelMessageInput = {
  connect?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SmsNotificationStatusCreateOrConnectWithoutSentChannelMessageInput>>;
  create?: Maybe<Array<SmsNotificationStatusCreateWithoutSentChannelMessageInput>>;
  createMany?: Maybe<SmsNotificationStatusCreateManySentChannelMessageInputEnvelope>;
};

export type SmsNotificationStatusCreateOrConnectWithoutClinicPhoneNumberInput = {
  create: SmsNotificationStatusCreateWithoutClinicPhoneNumberInput;
  where: SmsNotificationStatusWhereUniqueInput;
};

export type SmsNotificationStatusCreateOrConnectWithoutSentChannelMessageInput = {
  create: SmsNotificationStatusCreateWithoutSentChannelMessageInput;
  where: SmsNotificationStatusWhereUniqueInput;
};

export type SmsNotificationStatusCreateWithoutClinicPhoneNumberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider: SmsNotificationProvider;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId: Scalars['String'];
  receivingNumber: Scalars['String'];
  sentChannelMessage?: Maybe<ChannelMessageCreateNestedOneWithoutSmsNotifificationStatusesInput>;
  sourceContactEntityId: Scalars['String'];
  sourceContactEntityType: ContactEntityType;
  status: SmsNotificationStatusType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusCreateWithoutSentChannelMessageInput = {
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberCreateNestedOneWithoutSmsNotificationStatusesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider: SmsNotificationProvider;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId: Scalars['String'];
  receivingNumber: Scalars['String'];
  sourceContactEntityId: Scalars['String'];
  sourceContactEntityType: ContactEntityType;
  status: SmsNotificationStatusType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusGroupByOutputType = {
  __typename?: 'SmsNotificationStatusGroupByOutputType';
  _count?: Maybe<SmsNotificationStatusCountAggregateOutputType>;
  _max?: Maybe<SmsNotificationStatusMaxAggregateOutputType>;
  _min?: Maybe<SmsNotificationStatusMinAggregateOutputType>;
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id: Scalars['String'];
  provider: SmsNotificationProvider;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId: Scalars['String'];
  receivingNumber: Scalars['String'];
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId: Scalars['String'];
  sourceContactEntityType: ContactEntityType;
  status: SmsNotificationStatusType;
  updatedAt: Scalars['DateTime'];
};

export type SmsNotificationStatusListRelationFilter = {
  every?: Maybe<SmsNotificationStatusWhereInput>;
  none?: Maybe<SmsNotificationStatusWhereInput>;
  some?: Maybe<SmsNotificationStatusWhereInput>;
};

export type SmsNotificationStatusMaxAggregateOutputType = {
  __typename?: 'SmsNotificationStatusMaxAggregateOutputType';
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<SmsNotificationProvider>;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  receivingNumber?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId?: Maybe<Scalars['String']>;
  sourceContactEntityType?: Maybe<ContactEntityType>;
  status?: Maybe<SmsNotificationStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusMaxOrderByAggregateInput = {
  clinicPhoneNumberId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  receivingNumber?: Maybe<SortOrder>;
  sentChannelMessageId?: Maybe<SortOrder>;
  sourceContactEntityId?: Maybe<SortOrder>;
  sourceContactEntityType?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SmsNotificationStatusMinAggregateOutputType = {
  __typename?: 'SmsNotificationStatusMinAggregateOutputType';
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<SmsNotificationProvider>;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  receivingNumber?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId?: Maybe<Scalars['String']>;
  sourceContactEntityType?: Maybe<ContactEntityType>;
  status?: Maybe<SmsNotificationStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusMinOrderByAggregateInput = {
  clinicPhoneNumberId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  receivingNumber?: Maybe<SortOrder>;
  sentChannelMessageId?: Maybe<SortOrder>;
  sourceContactEntityId?: Maybe<SortOrder>;
  sourceContactEntityType?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SmsNotificationStatusOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SmsNotificationStatusOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SmsNotificationStatusOrderByRelevanceInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberOrderByWithRelationInput>;
  clinicPhoneNumberId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  receivingNumber?: Maybe<SortOrder>;
  sentChannelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  sentChannelMessageId?: Maybe<SortOrder>;
  sourceContactEntityId?: Maybe<SortOrder>;
  sourceContactEntityType?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SmsNotificationStatusOrderByRelevanceFieldEnum {
  ClinicPhoneNumberId = 'clinicPhoneNumberId',
  EntityId = 'entityId',
  Id = 'id',
  ProviderErrorData = 'providerErrorData',
  ProviderMessageId = 'providerMessageId',
  ReceivingNumber = 'receivingNumber',
  SentChannelMessageId = 'sentChannelMessageId',
  SourceContactEntityId = 'sourceContactEntityId'
}

export type SmsNotificationStatusOrderByRelevanceInput = {
  fields: Array<SmsNotificationStatusOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type SmsNotificationStatusOrderByWithAggregationInput = {
  _count?: Maybe<SmsNotificationStatusCountOrderByAggregateInput>;
  _max?: Maybe<SmsNotificationStatusMaxOrderByAggregateInput>;
  _min?: Maybe<SmsNotificationStatusMinOrderByAggregateInput>;
  clinicPhoneNumberId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  receivingNumber?: Maybe<SortOrder>;
  sentChannelMessageId?: Maybe<SortOrder>;
  sourceContactEntityId?: Maybe<SortOrder>;
  sourceContactEntityType?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SmsNotificationStatusOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SmsNotificationStatusOrderByRelevanceInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberOrderByWithRelationInput>;
  clinicPhoneNumberId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  receivingNumber?: Maybe<SortOrder>;
  sentChannelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  sentChannelMessageId?: Maybe<SortOrder>;
  sourceContactEntityId?: Maybe<SortOrder>;
  sourceContactEntityType?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SmsNotificationStatusOrderByWithRelationInput = {
  _relevance?: Maybe<SmsNotificationStatusOrderByRelevanceInput>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberOrderByWithRelationInput>;
  clinicPhoneNumberId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  entityId?: Maybe<SortOrder>;
  entityType?: Maybe<SortOrder>;
  errorType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  provider?: Maybe<SortOrder>;
  providerErrorData?: Maybe<SortOrder>;
  providerMessageId?: Maybe<SortOrder>;
  receivingNumber?: Maybe<SortOrder>;
  sentChannelMessage?: Maybe<ChannelMessageOrderByWithRelationInput>;
  sentChannelMessageId?: Maybe<SortOrder>;
  sourceContactEntityId?: Maybe<SortOrder>;
  sourceContactEntityType?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SmsNotificationStatusScalarFieldEnum {
  ClinicPhoneNumberId = 'clinicPhoneNumberId',
  CreatedAt = 'createdAt',
  EntityId = 'entityId',
  EntityType = 'entityType',
  ErrorType = 'errorType',
  Id = 'id',
  Provider = 'provider',
  ProviderErrorData = 'providerErrorData',
  ProviderMessageId = 'providerMessageId',
  ReceivingNumber = 'receivingNumber',
  SentChannelMessageId = 'sentChannelMessageId',
  SourceContactEntityId = 'sourceContactEntityId',
  SourceContactEntityType = 'sourceContactEntityType',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type SmsNotificationStatusScalarWhereInput = {
  AND?: Maybe<Array<SmsNotificationStatusScalarWhereInput>>;
  NOT?: Maybe<Array<SmsNotificationStatusScalarWhereInput>>;
  OR?: Maybe<Array<SmsNotificationStatusScalarWhereInput>>;
  clinicPhoneNumberId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entityId?: Maybe<StringNullableFilter>;
  entityType?: Maybe<EnumSmsEntityTypeNullableFilter>;
  errorType?: Maybe<EnumSmsNotificationDeliveryErrorTypeNullableFilter>;
  id?: Maybe<StringFilter>;
  provider?: Maybe<EnumSmsNotificationProviderFilter>;
  providerErrorData?: Maybe<StringNullableFilter>;
  providerMessageId?: Maybe<StringFilter>;
  receivingNumber?: Maybe<StringFilter>;
  sentChannelMessageId?: Maybe<StringNullableFilter>;
  sourceContactEntityId?: Maybe<StringFilter>;
  sourceContactEntityType?: Maybe<EnumContactEntityTypeFilter>;
  status?: Maybe<EnumSmsNotificationStatusTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SmsNotificationStatusScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SmsNotificationStatusScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SmsNotificationStatusScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SmsNotificationStatusScalarWhereWithAggregatesInput>>;
  clinicPhoneNumberId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  entityId?: Maybe<StringNullableWithAggregatesFilter>;
  entityType?: Maybe<EnumSmsEntityTypeNullableWithAggregatesFilter>;
  errorType?: Maybe<EnumSmsNotificationDeliveryErrorTypeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  provider?: Maybe<EnumSmsNotificationProviderWithAggregatesFilter>;
  providerErrorData?: Maybe<StringNullableWithAggregatesFilter>;
  providerMessageId?: Maybe<StringWithAggregatesFilter>;
  receivingNumber?: Maybe<StringWithAggregatesFilter>;
  sentChannelMessageId?: Maybe<StringNullableWithAggregatesFilter>;
  sourceContactEntityId?: Maybe<StringWithAggregatesFilter>;
  sourceContactEntityType?: Maybe<EnumContactEntityTypeWithAggregatesFilter>;
  status?: Maybe<EnumSmsNotificationStatusTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type SmsNotificationStatusSubscription = {
  __typename?: 'SmsNotificationStatusSubscription';
  mutation: MutationType;
  node: SmsNotificationStatus;
};

export enum SmsNotificationStatusType {
  Delivered = 'Delivered',
  Error = 'Error',
  SendError = 'Send_Error',
  Sent = 'Sent'
}

export type SmsNotificationStatusUncheckedCreateInput = {
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider: SmsNotificationProvider;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId: Scalars['String'];
  receivingNumber: Scalars['String'];
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId: Scalars['String'];
  sourceContactEntityType: ContactEntityType;
  status: SmsNotificationStatusType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUncheckedCreateNestedManyWithoutClinicPhoneNumberInput = {
  connect?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SmsNotificationStatusCreateOrConnectWithoutClinicPhoneNumberInput>>;
  create?: Maybe<Array<SmsNotificationStatusCreateWithoutClinicPhoneNumberInput>>;
  createMany?: Maybe<SmsNotificationStatusCreateManyClinicPhoneNumberInputEnvelope>;
};

export type SmsNotificationStatusUncheckedCreateNestedManyWithoutSentChannelMessageInput = {
  connect?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SmsNotificationStatusCreateOrConnectWithoutSentChannelMessageInput>>;
  create?: Maybe<Array<SmsNotificationStatusCreateWithoutSentChannelMessageInput>>;
  createMany?: Maybe<SmsNotificationStatusCreateManySentChannelMessageInputEnvelope>;
};

export type SmsNotificationStatusUncheckedCreateWithoutClinicPhoneNumberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider: SmsNotificationProvider;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId: Scalars['String'];
  receivingNumber: Scalars['String'];
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId: Scalars['String'];
  sourceContactEntityType: ContactEntityType;
  status: SmsNotificationStatusType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUncheckedCreateWithoutSentChannelMessageInput = {
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider: SmsNotificationProvider;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId: Scalars['String'];
  receivingNumber: Scalars['String'];
  sourceContactEntityId: Scalars['String'];
  sourceContactEntityType: ContactEntityType;
  status: SmsNotificationStatusType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUncheckedUpdateInput = {
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<SmsNotificationProvider>;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  receivingNumber?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId?: Maybe<Scalars['String']>;
  sourceContactEntityType?: Maybe<ContactEntityType>;
  status?: Maybe<SmsNotificationStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUncheckedUpdateManyInput = {
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<SmsNotificationProvider>;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  receivingNumber?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId?: Maybe<Scalars['String']>;
  sourceContactEntityType?: Maybe<ContactEntityType>;
  status?: Maybe<SmsNotificationStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUncheckedUpdateManyWithoutClinicPhoneNumberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<SmsNotificationProvider>;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  receivingNumber?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId?: Maybe<Scalars['String']>;
  sourceContactEntityType?: Maybe<ContactEntityType>;
  status?: Maybe<SmsNotificationStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUncheckedUpdateManyWithoutClinicPhoneNumberNestedInput = {
  connect?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SmsNotificationStatusCreateOrConnectWithoutClinicPhoneNumberInput>>;
  create?: Maybe<Array<SmsNotificationStatusCreateWithoutClinicPhoneNumberInput>>;
  createMany?: Maybe<SmsNotificationStatusCreateManyClinicPhoneNumberInputEnvelope>;
  delete?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SmsNotificationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  set?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  update?: Maybe<Array<SmsNotificationStatusUpdateWithWhereUniqueWithoutClinicPhoneNumberInput>>;
  updateMany?: Maybe<Array<SmsNotificationStatusUpdateManyWithWhereWithoutClinicPhoneNumberInput>>;
  upsert?: Maybe<Array<SmsNotificationStatusUpsertWithWhereUniqueWithoutClinicPhoneNumberInput>>;
};

export type SmsNotificationStatusUncheckedUpdateManyWithoutSentChannelMessageInput = {
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<SmsNotificationProvider>;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  receivingNumber?: Maybe<Scalars['String']>;
  sourceContactEntityId?: Maybe<Scalars['String']>;
  sourceContactEntityType?: Maybe<ContactEntityType>;
  status?: Maybe<SmsNotificationStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUncheckedUpdateManyWithoutSentChannelMessageNestedInput = {
  connect?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SmsNotificationStatusCreateOrConnectWithoutSentChannelMessageInput>>;
  create?: Maybe<Array<SmsNotificationStatusCreateWithoutSentChannelMessageInput>>;
  createMany?: Maybe<SmsNotificationStatusCreateManySentChannelMessageInputEnvelope>;
  delete?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SmsNotificationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  set?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  update?: Maybe<Array<SmsNotificationStatusUpdateWithWhereUniqueWithoutSentChannelMessageInput>>;
  updateMany?: Maybe<Array<SmsNotificationStatusUpdateManyWithWhereWithoutSentChannelMessageInput>>;
  upsert?: Maybe<Array<SmsNotificationStatusUpsertWithWhereUniqueWithoutSentChannelMessageInput>>;
};

export type SmsNotificationStatusUncheckedUpdateWithoutClinicPhoneNumberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<SmsNotificationProvider>;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  receivingNumber?: Maybe<Scalars['String']>;
  sentChannelMessageId?: Maybe<Scalars['String']>;
  sourceContactEntityId?: Maybe<Scalars['String']>;
  sourceContactEntityType?: Maybe<ContactEntityType>;
  status?: Maybe<SmsNotificationStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUncheckedUpdateWithoutSentChannelMessageInput = {
  clinicPhoneNumberId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<SmsNotificationProvider>;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  receivingNumber?: Maybe<Scalars['String']>;
  sourceContactEntityId?: Maybe<Scalars['String']>;
  sourceContactEntityType?: Maybe<ContactEntityType>;
  status?: Maybe<SmsNotificationStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUpdateInput = {
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateOneWithoutSmsNotificationStatusesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<SmsNotificationProvider>;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  receivingNumber?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessageUpdateOneWithoutSmsNotifificationStatusesNestedInput>;
  sourceContactEntityId?: Maybe<Scalars['String']>;
  sourceContactEntityType?: Maybe<ContactEntityType>;
  status?: Maybe<SmsNotificationStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<SmsNotificationProvider>;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  receivingNumber?: Maybe<Scalars['String']>;
  sourceContactEntityId?: Maybe<Scalars['String']>;
  sourceContactEntityType?: Maybe<ContactEntityType>;
  status?: Maybe<SmsNotificationStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUpdateManyWithWhereWithoutClinicPhoneNumberInput = {
  data: SmsNotificationStatusUpdateManyMutationInput;
  where: SmsNotificationStatusScalarWhereInput;
};

export type SmsNotificationStatusUpdateManyWithWhereWithoutSentChannelMessageInput = {
  data: SmsNotificationStatusUpdateManyMutationInput;
  where: SmsNotificationStatusScalarWhereInput;
};

export type SmsNotificationStatusUpdateManyWithoutClinicPhoneNumberNestedInput = {
  connect?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SmsNotificationStatusCreateOrConnectWithoutClinicPhoneNumberInput>>;
  create?: Maybe<Array<SmsNotificationStatusCreateWithoutClinicPhoneNumberInput>>;
  createMany?: Maybe<SmsNotificationStatusCreateManyClinicPhoneNumberInputEnvelope>;
  delete?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SmsNotificationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  set?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  update?: Maybe<Array<SmsNotificationStatusUpdateWithWhereUniqueWithoutClinicPhoneNumberInput>>;
  updateMany?: Maybe<Array<SmsNotificationStatusUpdateManyWithWhereWithoutClinicPhoneNumberInput>>;
  upsert?: Maybe<Array<SmsNotificationStatusUpsertWithWhereUniqueWithoutClinicPhoneNumberInput>>;
};

export type SmsNotificationStatusUpdateManyWithoutSentChannelMessageNestedInput = {
  connect?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SmsNotificationStatusCreateOrConnectWithoutSentChannelMessageInput>>;
  create?: Maybe<Array<SmsNotificationStatusCreateWithoutSentChannelMessageInput>>;
  createMany?: Maybe<SmsNotificationStatusCreateManySentChannelMessageInputEnvelope>;
  delete?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SmsNotificationStatusScalarWhereInput>>;
  disconnect?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  set?: Maybe<Array<SmsNotificationStatusWhereUniqueInput>>;
  update?: Maybe<Array<SmsNotificationStatusUpdateWithWhereUniqueWithoutSentChannelMessageInput>>;
  updateMany?: Maybe<Array<SmsNotificationStatusUpdateManyWithWhereWithoutSentChannelMessageInput>>;
  upsert?: Maybe<Array<SmsNotificationStatusUpsertWithWhereUniqueWithoutSentChannelMessageInput>>;
};

export type SmsNotificationStatusUpdateWithWhereUniqueWithoutClinicPhoneNumberInput = {
  data: SmsNotificationStatusUpdateWithoutClinicPhoneNumberInput;
  where: SmsNotificationStatusWhereUniqueInput;
};

export type SmsNotificationStatusUpdateWithWhereUniqueWithoutSentChannelMessageInput = {
  data: SmsNotificationStatusUpdateWithoutSentChannelMessageInput;
  where: SmsNotificationStatusWhereUniqueInput;
};

export type SmsNotificationStatusUpdateWithoutClinicPhoneNumberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<SmsNotificationProvider>;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  receivingNumber?: Maybe<Scalars['String']>;
  sentChannelMessage?: Maybe<ChannelMessageUpdateOneWithoutSmsNotifificationStatusesNestedInput>;
  sourceContactEntityId?: Maybe<Scalars['String']>;
  sourceContactEntityType?: Maybe<ContactEntityType>;
  status?: Maybe<SmsNotificationStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUpdateWithoutSentChannelMessageInput = {
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberUpdateOneWithoutSmsNotificationStatusesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<SmsEntityType>;
  errorType?: Maybe<SmsNotificationDeliveryErrorType>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<SmsNotificationProvider>;
  providerErrorData?: Maybe<Scalars['String']>;
  providerMessageId?: Maybe<Scalars['String']>;
  receivingNumber?: Maybe<Scalars['String']>;
  sourceContactEntityId?: Maybe<Scalars['String']>;
  sourceContactEntityType?: Maybe<ContactEntityType>;
  status?: Maybe<SmsNotificationStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SmsNotificationStatusUpsertWithWhereUniqueWithoutClinicPhoneNumberInput = {
  create: SmsNotificationStatusCreateWithoutClinicPhoneNumberInput;
  update: SmsNotificationStatusUpdateWithoutClinicPhoneNumberInput;
  where: SmsNotificationStatusWhereUniqueInput;
};

export type SmsNotificationStatusUpsertWithWhereUniqueWithoutSentChannelMessageInput = {
  create: SmsNotificationStatusCreateWithoutSentChannelMessageInput;
  update: SmsNotificationStatusUpdateWithoutSentChannelMessageInput;
  where: SmsNotificationStatusWhereUniqueInput;
};

export type SmsNotificationStatusWhereInput = {
  AND?: Maybe<Array<SmsNotificationStatusWhereInput>>;
  NOT?: Maybe<Array<SmsNotificationStatusWhereInput>>;
  OR?: Maybe<Array<SmsNotificationStatusWhereInput>>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberNullableScalarRelationFilter>;
  clinicPhoneNumberId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entityId?: Maybe<StringNullableFilter>;
  entityType?: Maybe<EnumSmsEntityTypeNullableFilter>;
  errorType?: Maybe<EnumSmsNotificationDeliveryErrorTypeNullableFilter>;
  id?: Maybe<StringFilter>;
  provider?: Maybe<EnumSmsNotificationProviderFilter>;
  providerErrorData?: Maybe<StringNullableFilter>;
  providerMessageId?: Maybe<StringFilter>;
  receivingNumber?: Maybe<StringFilter>;
  sentChannelMessage?: Maybe<ChannelMessageNullableScalarRelationFilter>;
  sentChannelMessageId?: Maybe<StringNullableFilter>;
  sourceContactEntityId?: Maybe<StringFilter>;
  sourceContactEntityType?: Maybe<EnumContactEntityTypeFilter>;
  status?: Maybe<EnumSmsNotificationStatusTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SmsNotificationStatusWhereUniqueInput = {
  AND?: Maybe<Array<SmsNotificationStatusWhereInput>>;
  NOT?: Maybe<Array<SmsNotificationStatusWhereInput>>;
  OR?: Maybe<Array<SmsNotificationStatusWhereInput>>;
  clinicPhoneNumber?: Maybe<ClinicPhoneNumberNullableScalarRelationFilter>;
  clinicPhoneNumberId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entityId?: Maybe<StringNullableFilter>;
  entityType?: Maybe<EnumSmsEntityTypeNullableFilter>;
  errorType?: Maybe<EnumSmsNotificationDeliveryErrorTypeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  provider?: Maybe<EnumSmsNotificationProviderFilter>;
  providerErrorData?: Maybe<StringNullableFilter>;
  providerMessageId?: Maybe<StringFilter>;
  receivingNumber?: Maybe<StringFilter>;
  sentChannelMessage?: Maybe<ChannelMessageNullableScalarRelationFilter>;
  sentChannelMessageId?: Maybe<StringNullableFilter>;
  sourceContactEntityId?: Maybe<StringFilter>;
  sourceContactEntityType?: Maybe<EnumContactEntityTypeFilter>;
  status?: Maybe<EnumSmsNotificationStatusTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SortBy = {
  column: Scalars['String'];
  direction?: Maybe<SortOrder>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: Maybe<NullsOrder>;
  sort: SortOrder;
};

export type Species = {
  __typename?: 'Species';
  _count: SpeciesCountOutputType;
  breeds: Array<Breed>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption: DirectBookingSpeciesOption;
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  pets: Array<ClinicPet>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes: Array<Sex>;
  updatedAt: Scalars['DateTime'];
};


export type SpeciesBreedsArgs = {
  cursor?: Maybe<BreedWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BreedScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BreedOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BreedWhereInput>;
};


export type SpeciesPetsArgs = {
  cursor?: Maybe<ClinicPetWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetWhereInput>;
};


export type SpeciesSexesArgs = {
  cursor?: Maybe<SexWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SexScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SexOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SexWhereInput>;
};

export type SpeciesCountAggregateOutputType = {
  __typename?: 'SpeciesCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  directBookingSpeciesOption: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  name: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SpeciesCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingSpeciesOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SpeciesCountOutputType = {
  __typename?: 'SpeciesCountOutputType';
  breeds: Scalars['Int'];
  pets: Scalars['Int'];
  sexes: Scalars['Int'];
};

export type SpeciesCreateInput = {
  breeds?: Maybe<BreedCreateNestedManyWithoutSpeciesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutSpeciesInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetCreateNestedManyWithoutSpeciesModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexCreateNestedManyWithoutSpeciesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesCreateManyIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesCreateManyIntegrationInputEnvelope = {
  data: Array<SpeciesCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SpeciesCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<SpeciesWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SpeciesCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<SpeciesCreateWithoutIntegrationInput>>;
  createMany?: Maybe<SpeciesCreateManyIntegrationInputEnvelope>;
};

export type SpeciesCreateNestedOneWithoutBreedsInput = {
  connect?: Maybe<SpeciesWhereUniqueInput>;
  connectOrCreate?: Maybe<SpeciesCreateOrConnectWithoutBreedsInput>;
  create?: Maybe<SpeciesCreateWithoutBreedsInput>;
};

export type SpeciesCreateNestedOneWithoutPetsInput = {
  connect?: Maybe<SpeciesWhereUniqueInput>;
  connectOrCreate?: Maybe<SpeciesCreateOrConnectWithoutPetsInput>;
  create?: Maybe<SpeciesCreateWithoutPetsInput>;
};

export type SpeciesCreateNestedOneWithoutSexesInput = {
  connect?: Maybe<SpeciesWhereUniqueInput>;
  connectOrCreate?: Maybe<SpeciesCreateOrConnectWithoutSexesInput>;
  create?: Maybe<SpeciesCreateWithoutSexesInput>;
};

export type SpeciesCreateOrConnectWithoutBreedsInput = {
  create: SpeciesCreateWithoutBreedsInput;
  where: SpeciesWhereUniqueInput;
};

export type SpeciesCreateOrConnectWithoutIntegrationInput = {
  create: SpeciesCreateWithoutIntegrationInput;
  where: SpeciesWhereUniqueInput;
};

export type SpeciesCreateOrConnectWithoutPetsInput = {
  create: SpeciesCreateWithoutPetsInput;
  where: SpeciesWhereUniqueInput;
};

export type SpeciesCreateOrConnectWithoutSexesInput = {
  create: SpeciesCreateWithoutSexesInput;
  where: SpeciesWhereUniqueInput;
};

export type SpeciesCreateWithoutBreedsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutSpeciesInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetCreateNestedManyWithoutSpeciesModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexCreateNestedManyWithoutSpeciesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesCreateWithoutIntegrationInput = {
  breeds?: Maybe<BreedCreateNestedManyWithoutSpeciesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetCreateNestedManyWithoutSpeciesModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexCreateNestedManyWithoutSpeciesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesCreateWithoutPetsInput = {
  breeds?: Maybe<BreedCreateNestedManyWithoutSpeciesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutSpeciesInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexCreateNestedManyWithoutSpeciesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesCreateWithoutSexesInput = {
  breeds?: Maybe<BreedCreateNestedManyWithoutSpeciesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutSpeciesInput;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetCreateNestedManyWithoutSpeciesModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesGroupByOutputType = {
  __typename?: 'SpeciesGroupByOutputType';
  _count?: Maybe<SpeciesCountAggregateOutputType>;
  _max?: Maybe<SpeciesMaxAggregateOutputType>;
  _min?: Maybe<SpeciesMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption: DirectBookingSpeciesOption;
  id: Scalars['String'];
  integrationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type SpeciesIntegrationIdPimsIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type SpeciesListRelationFilter = {
  every?: Maybe<SpeciesWhereInput>;
  none?: Maybe<SpeciesWhereInput>;
  some?: Maybe<SpeciesWhereInput>;
};

export type SpeciesMaxAggregateOutputType = {
  __typename?: 'SpeciesMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingSpeciesOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SpeciesMinAggregateOutputType = {
  __typename?: 'SpeciesMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingSpeciesOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SpeciesNullableScalarRelationFilter = {
  AND?: Maybe<Array<SpeciesWhereInput>>;
  NOT?: Maybe<Array<SpeciesWhereInput>>;
  OR?: Maybe<Array<SpeciesWhereInput>>;
  breeds?: Maybe<BreedListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  directBookingSpeciesOption?: Maybe<EnumDirectBookingSpeciesOptionFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  sexes?: Maybe<SexListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SpeciesOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SpeciesOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SpeciesOrderByRelevanceInput>;
  breeds?: Maybe<BreedOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingSpeciesOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  sexes?: Maybe<SexOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SpeciesOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  IntegrationId = 'integrationId',
  Name = 'name',
  PimsId = 'pimsId'
}

export type SpeciesOrderByRelevanceInput = {
  fields: Array<SpeciesOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type SpeciesOrderByWithAggregationInput = {
  _count?: Maybe<SpeciesCountOrderByAggregateInput>;
  _max?: Maybe<SpeciesMaxOrderByAggregateInput>;
  _min?: Maybe<SpeciesMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingSpeciesOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SpeciesOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SpeciesOrderByRelevanceInput>;
  breeds?: Maybe<BreedOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingSpeciesOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  sexes?: Maybe<SexOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type SpeciesOrderByWithRelationInput = {
  _relevance?: Maybe<SpeciesOrderByRelevanceInput>;
  breeds?: Maybe<BreedOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  directBookingSpeciesOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pets?: Maybe<ClinicPetOrderByRelationAggregateInput>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  sexes?: Maybe<SexOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SpeciesScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  DirectBookingSpeciesOption = 'directBookingSpeciesOption',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Name = 'name',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  UpdatedAt = 'updatedAt'
}

export type SpeciesScalarWhereInput = {
  AND?: Maybe<Array<SpeciesScalarWhereInput>>;
  NOT?: Maybe<Array<SpeciesScalarWhereInput>>;
  OR?: Maybe<Array<SpeciesScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  directBookingSpeciesOption?: Maybe<EnumDirectBookingSpeciesOptionFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SpeciesScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SpeciesScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SpeciesScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SpeciesScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  directBookingSpeciesOption?: Maybe<EnumDirectBookingSpeciesOptionWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum SpeciesType {
  Avian = 'Avian',
  Bovine = 'Bovine',
  Canine = 'Canine',
  Equine = 'Equine',
  Feline = 'Feline',
  Leporine = 'Leporine',
  Other = 'Other'
}

export type SpeciesUncheckedCreateInput = {
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutSpeciesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutSpeciesModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutSpeciesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<SpeciesWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SpeciesCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<SpeciesCreateWithoutIntegrationInput>>;
  createMany?: Maybe<SpeciesCreateManyIntegrationInputEnvelope>;
};

export type SpeciesUncheckedCreateWithoutBreedsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutSpeciesModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutSpeciesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUncheckedCreateWithoutIntegrationInput = {
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutSpeciesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutSpeciesModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutSpeciesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUncheckedCreateWithoutPetsInput = {
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutSpeciesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexUncheckedCreateNestedManyWithoutSpeciesInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUncheckedCreateWithoutSexesInput = {
  breeds?: Maybe<BreedUncheckedCreateNestedManyWithoutSpeciesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pets?: Maybe<ClinicPetUncheckedCreateNestedManyWithoutSpeciesModelInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUncheckedUpdateInput = {
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutSpeciesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutSpeciesModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutSpeciesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUncheckedUpdateManyWithoutIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<SpeciesWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SpeciesCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<SpeciesCreateWithoutIntegrationInput>>;
  createMany?: Maybe<SpeciesCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<SpeciesWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SpeciesScalarWhereInput>>;
  disconnect?: Maybe<Array<SpeciesWhereUniqueInput>>;
  set?: Maybe<Array<SpeciesWhereUniqueInput>>;
  update?: Maybe<Array<SpeciesUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<SpeciesUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<SpeciesUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type SpeciesUncheckedUpdateWithoutBreedsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutSpeciesModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutSpeciesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUncheckedUpdateWithoutIntegrationInput = {
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutSpeciesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutSpeciesModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutSpeciesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUncheckedUpdateWithoutPetsInput = {
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutSpeciesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexUncheckedUpdateManyWithoutSpeciesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUncheckedUpdateWithoutSexesInput = {
  breeds?: Maybe<BreedUncheckedUpdateManyWithoutSpeciesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUncheckedUpdateManyWithoutSpeciesModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUpdateInput = {
  breeds?: Maybe<BreedUpdateManyWithoutSpeciesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutSpeciesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutSpeciesModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexUpdateManyWithoutSpeciesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUpdateManyWithWhereWithoutIntegrationInput = {
  data: SpeciesUpdateManyMutationInput;
  where: SpeciesScalarWhereInput;
};

export type SpeciesUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<SpeciesWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SpeciesCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<SpeciesCreateWithoutIntegrationInput>>;
  createMany?: Maybe<SpeciesCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<SpeciesWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SpeciesScalarWhereInput>>;
  disconnect?: Maybe<Array<SpeciesWhereUniqueInput>>;
  set?: Maybe<Array<SpeciesWhereUniqueInput>>;
  update?: Maybe<Array<SpeciesUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<SpeciesUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<SpeciesUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type SpeciesUpdateOneWithoutBreedsNestedInput = {
  connect?: Maybe<SpeciesWhereUniqueInput>;
  connectOrCreate?: Maybe<SpeciesCreateOrConnectWithoutBreedsInput>;
  create?: Maybe<SpeciesCreateWithoutBreedsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<SpeciesUpdateToOneWithWhereWithoutBreedsInput>;
  upsert?: Maybe<SpeciesUpsertWithoutBreedsInput>;
};

export type SpeciesUpdateOneWithoutPetsNestedInput = {
  connect?: Maybe<SpeciesWhereUniqueInput>;
  connectOrCreate?: Maybe<SpeciesCreateOrConnectWithoutPetsInput>;
  create?: Maybe<SpeciesCreateWithoutPetsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<SpeciesUpdateToOneWithWhereWithoutPetsInput>;
  upsert?: Maybe<SpeciesUpsertWithoutPetsInput>;
};

export type SpeciesUpdateOneWithoutSexesNestedInput = {
  connect?: Maybe<SpeciesWhereUniqueInput>;
  connectOrCreate?: Maybe<SpeciesCreateOrConnectWithoutSexesInput>;
  create?: Maybe<SpeciesCreateWithoutSexesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<SpeciesUpdateToOneWithWhereWithoutSexesInput>;
  upsert?: Maybe<SpeciesUpsertWithoutSexesInput>;
};

export type SpeciesUpdateToOneWithWhereWithoutBreedsInput = {
  data: SpeciesUpdateWithoutBreedsInput;
  where?: Maybe<SpeciesWhereInput>;
};

export type SpeciesUpdateToOneWithWhereWithoutPetsInput = {
  data: SpeciesUpdateWithoutPetsInput;
  where?: Maybe<SpeciesWhereInput>;
};

export type SpeciesUpdateToOneWithWhereWithoutSexesInput = {
  data: SpeciesUpdateWithoutSexesInput;
  where?: Maybe<SpeciesWhereInput>;
};

export type SpeciesUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: SpeciesUpdateWithoutIntegrationInput;
  where: SpeciesWhereUniqueInput;
};

export type SpeciesUpdateWithoutBreedsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutSpeciesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutSpeciesModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexUpdateManyWithoutSpeciesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUpdateWithoutIntegrationInput = {
  breeds?: Maybe<BreedUpdateManyWithoutSpeciesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutSpeciesModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexUpdateManyWithoutSpeciesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUpdateWithoutPetsInput = {
  breeds?: Maybe<BreedUpdateManyWithoutSpeciesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutSpeciesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  sexes?: Maybe<SexUpdateManyWithoutSpeciesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUpdateWithoutSexesInput = {
  breeds?: Maybe<BreedUpdateManyWithoutSpeciesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  directBookingSpeciesOption?: Maybe<DirectBookingSpeciesOption>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutSpeciesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<ClinicPetUpdateManyWithoutSpeciesModelNestedInput>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SpeciesUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: SpeciesCreateWithoutIntegrationInput;
  update: SpeciesUpdateWithoutIntegrationInput;
  where: SpeciesWhereUniqueInput;
};

export type SpeciesUpsertWithoutBreedsInput = {
  create: SpeciesCreateWithoutBreedsInput;
  update: SpeciesUpdateWithoutBreedsInput;
  where?: Maybe<SpeciesWhereInput>;
};

export type SpeciesUpsertWithoutPetsInput = {
  create: SpeciesCreateWithoutPetsInput;
  update: SpeciesUpdateWithoutPetsInput;
  where?: Maybe<SpeciesWhereInput>;
};

export type SpeciesUpsertWithoutSexesInput = {
  create: SpeciesCreateWithoutSexesInput;
  update: SpeciesUpdateWithoutSexesInput;
  where?: Maybe<SpeciesWhereInput>;
};

export type SpeciesWhereInput = {
  AND?: Maybe<Array<SpeciesWhereInput>>;
  NOT?: Maybe<Array<SpeciesWhereInput>>;
  OR?: Maybe<Array<SpeciesWhereInput>>;
  breeds?: Maybe<BreedListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  directBookingSpeciesOption?: Maybe<EnumDirectBookingSpeciesOptionFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  sexes?: Maybe<SexListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SpeciesWhereUniqueInput = {
  AND?: Maybe<Array<SpeciesWhereInput>>;
  NOT?: Maybe<Array<SpeciesWhereInput>>;
  OR?: Maybe<Array<SpeciesWhereInput>>;
  breeds?: Maybe<BreedListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  directBookingSpeciesOption?: Maybe<EnumDirectBookingSpeciesOptionFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  integrationId_pimsId?: Maybe<SpeciesIntegrationIdPimsIdCompoundUniqueInput>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pets?: Maybe<ClinicPetListRelationFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  sexes?: Maybe<SexListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum SqsQueueNames {
  ConditionEngineJobs = 'ConditionEngineJobs',
  CoreQueue = 'CoreQueue',
  EmailCampaignEmailSend = 'EmailCampaignEmailSend',
  GenericModelChangeQueue = 'GenericModelChangeQueue',
  InformCampaignJobs = 'InformCampaignJobs',
  InformJobs = 'InformJobs',
  InformPartnerIntegrationRequestJobs = 'InformPartnerIntegrationRequestJobs',
  LoyaltyProgram = 'LoyaltyProgram',
  MediaJobs = 'MediaJobs',
  NotificationJobs = 'NotificationJobs',
  PimsEtlIntegrationSync = 'PimsEtlIntegrationSync',
  PimsEtlModelChanges = 'PimsEtlModelChanges',
  PimsEtlModelDataSync = 'PimsEtlModelDataSync',
  PimsEtlOnboardingIntegrationSync = 'PimsEtlOnboardingIntegrationSync',
  PimsEtlOnboardingModelChanges = 'PimsEtlOnboardingModelChanges',
  PimsEtlOnboardingModelDataSync = 'PimsEtlOnboardingModelDataSync',
  PimsEtlOnboardingRetryModelChanges = 'PimsEtlOnboardingRetryModelChanges',
  PimsEtlRetryModelChanges = 'PimsEtlRetryModelChanges',
  PimsSyncJobs = 'PimsSyncJobs',
  PimsWriteback = 'PimsWriteback',
  RealTimeGenericModelChangeQueue = 'RealTimeGenericModelChangeQueue',
  SearchIndexing = 'SearchIndexing',
  SearchIndexingPimsCreate = 'SearchIndexingPimsCreate'
}

export type StaffRole = {
  __typename?: 'StaffRole';
  _count: StaffRoleCountOutputType;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  permissions: Array<Permission>;
  role: Role;
  updatedAt: Scalars['DateTime'];
  users: Array<VetInfo>;
};


export type StaffRoleClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type StaffRolePermissionsArgs = {
  cursor?: Maybe<PermissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PermissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PermissionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PermissionWhereInput>;
};


export type StaffRoleUsersArgs = {
  cursor?: Maybe<VetInfoWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetInfoScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetInfoOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetInfoWhereInput>;
};

export type StaffRoleCountAggregateOutputType = {
  __typename?: 'StaffRoleCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  role: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StaffRoleCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  role?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StaffRoleCountOutputType = {
  __typename?: 'StaffRoleCountOutputType';
  permissions: Scalars['Int'];
  users: Scalars['Int'];
};

export type StaffRoleCreateInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutRolesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionCreateNestedManyWithoutRolesInput>;
  role: Role;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<VetInfoCreateNestedManyWithoutRolesInput>;
};

export type StaffRoleCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role: Role;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleCreateManyClinicInputEnvelope = {
  data: Array<StaffRoleCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StaffRoleCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role: Role;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StaffRoleCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<StaffRoleCreateWithoutClinicInput>>;
  createMany?: Maybe<StaffRoleCreateManyClinicInputEnvelope>;
};

export type StaffRoleCreateNestedManyWithoutPermissionsInput = {
  connect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StaffRoleCreateOrConnectWithoutPermissionsInput>>;
  create?: Maybe<Array<StaffRoleCreateWithoutPermissionsInput>>;
};

export type StaffRoleCreateNestedManyWithoutUsersInput = {
  connect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StaffRoleCreateOrConnectWithoutUsersInput>>;
  create?: Maybe<Array<StaffRoleCreateWithoutUsersInput>>;
};

export type StaffRoleCreateOrConnectWithoutClinicInput = {
  create: StaffRoleCreateWithoutClinicInput;
  where: StaffRoleWhereUniqueInput;
};

export type StaffRoleCreateOrConnectWithoutPermissionsInput = {
  create: StaffRoleCreateWithoutPermissionsInput;
  where: StaffRoleWhereUniqueInput;
};

export type StaffRoleCreateOrConnectWithoutUsersInput = {
  create: StaffRoleCreateWithoutUsersInput;
  where: StaffRoleWhereUniqueInput;
};

export type StaffRoleCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionCreateNestedManyWithoutRolesInput>;
  role: Role;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<VetInfoCreateNestedManyWithoutRolesInput>;
};

export type StaffRoleCreateWithoutPermissionsInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutRolesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role: Role;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<VetInfoCreateNestedManyWithoutRolesInput>;
};

export type StaffRoleCreateWithoutUsersInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutRolesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionCreateNestedManyWithoutRolesInput>;
  role: Role;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleGroupByOutputType = {
  __typename?: 'StaffRoleGroupByOutputType';
  _count?: Maybe<StaffRoleCountAggregateOutputType>;
  _max?: Maybe<StaffRoleMaxAggregateOutputType>;
  _min?: Maybe<StaffRoleMinAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  role: Role;
  updatedAt: Scalars['DateTime'];
};

export type StaffRoleListRelationFilter = {
  every?: Maybe<StaffRoleWhereInput>;
  none?: Maybe<StaffRoleWhereInput>;
  some?: Maybe<StaffRoleWhereInput>;
};

export type StaffRoleMaxAggregateOutputType = {
  __typename?: 'StaffRoleMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  role?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StaffRoleMinAggregateOutputType = {
  __typename?: 'StaffRoleMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  role?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StaffRoleOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StaffRoleOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StaffRoleOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  permissions?: Maybe<PermissionOrderByRelationAggregateInput>;
  role?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  users?: Maybe<VetInfoOrderByRelationAggregateInput>;
};

export enum StaffRoleOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id'
}

export type StaffRoleOrderByRelevanceInput = {
  fields: Array<StaffRoleOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StaffRoleOrderByWithAggregationInput = {
  _count?: Maybe<StaffRoleCountOrderByAggregateInput>;
  _max?: Maybe<StaffRoleMaxOrderByAggregateInput>;
  _min?: Maybe<StaffRoleMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  role?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StaffRoleOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StaffRoleOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  permissions?: Maybe<PermissionOrderByRelationAggregateInput>;
  role?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  users?: Maybe<VetInfoOrderByRelationAggregateInput>;
};

export type StaffRoleOrderByWithRelationInput = {
  _relevance?: Maybe<StaffRoleOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  permissions?: Maybe<PermissionOrderByRelationAggregateInput>;
  role?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  users?: Maybe<VetInfoOrderByRelationAggregateInput>;
};

export enum StaffRoleScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Role = 'role',
  UpdatedAt = 'updatedAt'
}

export type StaffRoleScalarWhereInput = {
  AND?: Maybe<Array<StaffRoleScalarWhereInput>>;
  NOT?: Maybe<Array<StaffRoleScalarWhereInput>>;
  OR?: Maybe<Array<StaffRoleScalarWhereInput>>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  role?: Maybe<EnumRoleFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StaffRoleScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StaffRoleScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StaffRoleScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StaffRoleScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  role?: Maybe<EnumRoleWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type StaffRoleUncheckedCreateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionUncheckedCreateNestedManyWithoutRolesInput>;
  role: Role;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<VetInfoUncheckedCreateNestedManyWithoutRolesInput>;
};

export type StaffRoleUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StaffRoleCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<StaffRoleCreateWithoutClinicInput>>;
  createMany?: Maybe<StaffRoleCreateManyClinicInputEnvelope>;
};

export type StaffRoleUncheckedCreateNestedManyWithoutPermissionsInput = {
  connect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StaffRoleCreateOrConnectWithoutPermissionsInput>>;
  create?: Maybe<Array<StaffRoleCreateWithoutPermissionsInput>>;
};

export type StaffRoleUncheckedCreateNestedManyWithoutUsersInput = {
  connect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StaffRoleCreateOrConnectWithoutUsersInput>>;
  create?: Maybe<Array<StaffRoleCreateWithoutUsersInput>>;
};

export type StaffRoleUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionUncheckedCreateNestedManyWithoutRolesInput>;
  role: Role;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<VetInfoUncheckedCreateNestedManyWithoutRolesInput>;
};

export type StaffRoleUncheckedCreateWithoutPermissionsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role: Role;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<VetInfoUncheckedCreateNestedManyWithoutRolesInput>;
};

export type StaffRoleUncheckedCreateWithoutUsersInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionUncheckedCreateNestedManyWithoutRolesInput>;
  role: Role;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionUncheckedUpdateManyWithoutRolesNestedInput>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<VetInfoUncheckedUpdateManyWithoutRolesNestedInput>;
};

export type StaffRoleUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StaffRoleCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<StaffRoleCreateWithoutClinicInput>>;
  createMany?: Maybe<StaffRoleCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StaffRoleScalarWhereInput>>;
  disconnect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  set?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  update?: Maybe<Array<StaffRoleUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<StaffRoleUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<StaffRoleUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type StaffRoleUncheckedUpdateManyWithoutPermissionsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleUncheckedUpdateManyWithoutPermissionsNestedInput = {
  connect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StaffRoleCreateOrConnectWithoutPermissionsInput>>;
  create?: Maybe<Array<StaffRoleCreateWithoutPermissionsInput>>;
  delete?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StaffRoleScalarWhereInput>>;
  disconnect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  set?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  update?: Maybe<Array<StaffRoleUpdateWithWhereUniqueWithoutPermissionsInput>>;
  updateMany?: Maybe<Array<StaffRoleUpdateManyWithWhereWithoutPermissionsInput>>;
  upsert?: Maybe<Array<StaffRoleUpsertWithWhereUniqueWithoutPermissionsInput>>;
};

export type StaffRoleUncheckedUpdateManyWithoutUsersInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleUncheckedUpdateManyWithoutUsersNestedInput = {
  connect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StaffRoleCreateOrConnectWithoutUsersInput>>;
  create?: Maybe<Array<StaffRoleCreateWithoutUsersInput>>;
  delete?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StaffRoleScalarWhereInput>>;
  disconnect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  set?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  update?: Maybe<Array<StaffRoleUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: Maybe<Array<StaffRoleUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: Maybe<Array<StaffRoleUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type StaffRoleUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionUncheckedUpdateManyWithoutRolesNestedInput>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<VetInfoUncheckedUpdateManyWithoutRolesNestedInput>;
};

export type StaffRoleUncheckedUpdateWithoutPermissionsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<VetInfoUncheckedUpdateManyWithoutRolesNestedInput>;
};

export type StaffRoleUncheckedUpdateWithoutUsersInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionUncheckedUpdateManyWithoutRolesNestedInput>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutRolesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionUpdateManyWithoutRolesNestedInput>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<VetInfoUpdateManyWithoutRolesNestedInput>;
};

export type StaffRoleUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleUpdateManyWithWhereWithoutClinicInput = {
  data: StaffRoleUpdateManyMutationInput;
  where: StaffRoleScalarWhereInput;
};

export type StaffRoleUpdateManyWithWhereWithoutPermissionsInput = {
  data: StaffRoleUpdateManyMutationInput;
  where: StaffRoleScalarWhereInput;
};

export type StaffRoleUpdateManyWithWhereWithoutUsersInput = {
  data: StaffRoleUpdateManyMutationInput;
  where: StaffRoleScalarWhereInput;
};

export type StaffRoleUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StaffRoleCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<StaffRoleCreateWithoutClinicInput>>;
  createMany?: Maybe<StaffRoleCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StaffRoleScalarWhereInput>>;
  disconnect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  set?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  update?: Maybe<Array<StaffRoleUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<StaffRoleUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<StaffRoleUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type StaffRoleUpdateManyWithoutPermissionsNestedInput = {
  connect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StaffRoleCreateOrConnectWithoutPermissionsInput>>;
  create?: Maybe<Array<StaffRoleCreateWithoutPermissionsInput>>;
  delete?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StaffRoleScalarWhereInput>>;
  disconnect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  set?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  update?: Maybe<Array<StaffRoleUpdateWithWhereUniqueWithoutPermissionsInput>>;
  updateMany?: Maybe<Array<StaffRoleUpdateManyWithWhereWithoutPermissionsInput>>;
  upsert?: Maybe<Array<StaffRoleUpsertWithWhereUniqueWithoutPermissionsInput>>;
};

export type StaffRoleUpdateManyWithoutUsersNestedInput = {
  connect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StaffRoleCreateOrConnectWithoutUsersInput>>;
  create?: Maybe<Array<StaffRoleCreateWithoutUsersInput>>;
  delete?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StaffRoleScalarWhereInput>>;
  disconnect?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  set?: Maybe<Array<StaffRoleWhereUniqueInput>>;
  update?: Maybe<Array<StaffRoleUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: Maybe<Array<StaffRoleUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: Maybe<Array<StaffRoleUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type StaffRoleUpdateWithWhereUniqueWithoutClinicInput = {
  data: StaffRoleUpdateWithoutClinicInput;
  where: StaffRoleWhereUniqueInput;
};

export type StaffRoleUpdateWithWhereUniqueWithoutPermissionsInput = {
  data: StaffRoleUpdateWithoutPermissionsInput;
  where: StaffRoleWhereUniqueInput;
};

export type StaffRoleUpdateWithWhereUniqueWithoutUsersInput = {
  data: StaffRoleUpdateWithoutUsersInput;
  where: StaffRoleWhereUniqueInput;
};

export type StaffRoleUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionUpdateManyWithoutRolesNestedInput>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<VetInfoUpdateManyWithoutRolesNestedInput>;
};

export type StaffRoleUpdateWithoutPermissionsInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutRolesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<VetInfoUpdateManyWithoutRolesNestedInput>;
};

export type StaffRoleUpdateWithoutUsersInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutRolesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionUpdateManyWithoutRolesNestedInput>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StaffRoleUpsertWithWhereUniqueWithoutClinicInput = {
  create: StaffRoleCreateWithoutClinicInput;
  update: StaffRoleUpdateWithoutClinicInput;
  where: StaffRoleWhereUniqueInput;
};

export type StaffRoleUpsertWithWhereUniqueWithoutPermissionsInput = {
  create: StaffRoleCreateWithoutPermissionsInput;
  update: StaffRoleUpdateWithoutPermissionsInput;
  where: StaffRoleWhereUniqueInput;
};

export type StaffRoleUpsertWithWhereUniqueWithoutUsersInput = {
  create: StaffRoleCreateWithoutUsersInput;
  update: StaffRoleUpdateWithoutUsersInput;
  where: StaffRoleWhereUniqueInput;
};

export type StaffRoleWhereInput = {
  AND?: Maybe<Array<StaffRoleWhereInput>>;
  NOT?: Maybe<Array<StaffRoleWhereInput>>;
  OR?: Maybe<Array<StaffRoleWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  permissions?: Maybe<PermissionListRelationFilter>;
  role?: Maybe<EnumRoleFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  users?: Maybe<VetInfoListRelationFilter>;
};

export type StaffRoleWhereUniqueInput = {
  AND?: Maybe<Array<StaffRoleWhereInput>>;
  NOT?: Maybe<Array<StaffRoleWhereInput>>;
  OR?: Maybe<Array<StaffRoleWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  permissions?: Maybe<PermissionListRelationFilter>;
  role?: Maybe<EnumRoleFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  users?: Maybe<VetInfoListRelationFilter>;
};

export type StartChecksOnRecapChunksContinuityInput = {
  recapId: Scalars['String'];
};

export type StartChecksOnRecapChunksContinuityOutput = {
  __typename?: 'StartChecksOnRecapChunksContinuityOutput';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum State {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type StringFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringNullableFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringNullableListFilter = {
  equals?: Maybe<Array<Scalars['String']>>;
  has?: Maybe<Scalars['String']>;
  hasEvery?: Maybe<Array<Scalars['String']>>;
  hasSome?: Maybe<Array<Scalars['String']>>;
  isEmpty?: Maybe<Scalars['Boolean']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedStringNullableFilter>;
  _min?: Maybe<NestedStringNullableFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedStringFilter>;
  _min?: Maybe<NestedStringFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StripeAccount = {
  __typename?: 'StripeAccount';
  capabilities: StripeCapabilities;
  chargesEnabled: Scalars['Boolean'];
  defaultAccount?: Maybe<StripePayoutAccount>;
  id: Scalars['String'];
  payoutAccounts?: Maybe<Array<StripePayoutAccount>>;
  payoutSchedule: StripePayoutSchedule;
  payoutsEnabled: Scalars['Boolean'];
  requirements: StripeRequirements;
};

export type StripeAccountOutput = {
  __typename?: 'StripeAccountOutput';
  account: StripeAccount;
};

export type StripeCapabilities = {
  __typename?: 'StripeCapabilities';
  card_payments?: Maybe<StripeCapabilityState>;
  transfers: StripeCapabilityState;
};

export enum StripeCapabilityState {
  Active = 'active',
  Inactive = 'inactive'
}

export enum StripeCaptureType {
  Automatic = 'automatic',
  Manual = 'manual'
}

export enum StripeCollectionMethod {
  ChargeAutomatically = 'charge_automatically',
  SendInvoice = 'send_invoice'
}

export type StripeConnectOauthInput = {
  oauthCode: Scalars['String'];
};

export type StripeCreateAccountInput = {
  redirectUrl: Scalars['String'];
};

export type StripeCreateAccountOutput = {
  __typename?: 'StripeCreateAccountOutput';
  account: StripeAccount;
  onboarding: LoginLinkOutput;
};

export type StripeCreateAccountSessionInput = {
  stripeAccountId: Scalars['String'];
};

export type StripeCreateAccountSessionOutput = {
  __typename?: 'StripeCreateAccountSessionOutput';
  account: Scalars['String'];
  clientSecret: Scalars['String'];
  expiresAt: Scalars['Date'];
};

export type StripeCreatePaymentInput = {
  amount: Scalars['Int'];
  captureType?: Maybe<StripeCaptureType>;
  cardType?: Maybe<CardFunding>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  customer?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptorSuffix?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentMethodType?: Maybe<StripePaymentMethodType>;
  receiptEmail?: Maybe<Scalars['String']>;
};

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  _count: StripeCustomerCountOutputType;
  clinicPetParents: Array<ClinicPetParent>;
  id: Scalars['String'];
  invoices: Array<StripeInvoice>;
  organizationPetParents: Array<OrganizationPetParent>;
  paymentMethods: Array<StripePaymentMethod>;
  stripeId: Scalars['String'];
};


export type StripeCustomerClinicPetParentsArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type StripeCustomerInvoicesArgs = {
  cursor?: Maybe<StripeInvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeInvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeInvoiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type StripeCustomerOrganizationPetParentsArgs = {
  cursor?: Maybe<OrganizationPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<OrganizationPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<OrganizationPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationPetParentWhereInput>;
};


export type StripeCustomerPaymentMethodsArgs = {
  cursor?: Maybe<StripePaymentMethodWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentMethodScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentMethodOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentMethodWhereInput>;
};

export type StripeCustomerCountAggregateOutputType = {
  __typename?: 'StripeCustomerCountAggregateOutputType';
  _all: Scalars['Int'];
  id: Scalars['Int'];
  stripeId: Scalars['Int'];
};

export type StripeCustomerCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
};

export type StripeCustomerCountOutputType = {
  __typename?: 'StripeCustomerCountOutputType';
  clinicPetParents: Scalars['Int'];
  invoices: Scalars['Int'];
  organizationPetParents: Scalars['Int'];
  paymentMethods: Scalars['Int'];
};

export type StripeCustomerCreateInput = {
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutStripeCustomerInput>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutStripeCustomerInput>;
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutStripeCustomerInput>;
  paymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutStripeCustomerInput>;
  stripeId: Scalars['String'];
};

export type StripeCustomerCreateManyInput = {
  id?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
};

export type StripeCustomerCreateNestedOneWithoutClinicPetParentsInput = {
  connect?: Maybe<StripeCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeCustomerCreateOrConnectWithoutClinicPetParentsInput>;
  create?: Maybe<StripeCustomerCreateWithoutClinicPetParentsInput>;
};

export type StripeCustomerCreateNestedOneWithoutInvoicesInput = {
  connect?: Maybe<StripeCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeCustomerCreateOrConnectWithoutInvoicesInput>;
  create?: Maybe<StripeCustomerCreateWithoutInvoicesInput>;
};

export type StripeCustomerCreateNestedOneWithoutOrganizationPetParentsInput = {
  connect?: Maybe<StripeCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeCustomerCreateOrConnectWithoutOrganizationPetParentsInput>;
  create?: Maybe<StripeCustomerCreateWithoutOrganizationPetParentsInput>;
};

export type StripeCustomerCreateNestedOneWithoutPaymentMethodsInput = {
  connect?: Maybe<StripeCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeCustomerCreateOrConnectWithoutPaymentMethodsInput>;
  create?: Maybe<StripeCustomerCreateWithoutPaymentMethodsInput>;
};

export type StripeCustomerCreateOrConnectWithoutClinicPetParentsInput = {
  create: StripeCustomerCreateWithoutClinicPetParentsInput;
  where: StripeCustomerWhereUniqueInput;
};

export type StripeCustomerCreateOrConnectWithoutInvoicesInput = {
  create: StripeCustomerCreateWithoutInvoicesInput;
  where: StripeCustomerWhereUniqueInput;
};

export type StripeCustomerCreateOrConnectWithoutOrganizationPetParentsInput = {
  create: StripeCustomerCreateWithoutOrganizationPetParentsInput;
  where: StripeCustomerWhereUniqueInput;
};

export type StripeCustomerCreateOrConnectWithoutPaymentMethodsInput = {
  create: StripeCustomerCreateWithoutPaymentMethodsInput;
  where: StripeCustomerWhereUniqueInput;
};

export type StripeCustomerCreateWithoutClinicPetParentsInput = {
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutStripeCustomerInput>;
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutStripeCustomerInput>;
  paymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutStripeCustomerInput>;
  stripeId: Scalars['String'];
};

export type StripeCustomerCreateWithoutInvoicesInput = {
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutStripeCustomerInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutStripeCustomerInput>;
  paymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutStripeCustomerInput>;
  stripeId: Scalars['String'];
};

export type StripeCustomerCreateWithoutOrganizationPetParentsInput = {
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutStripeCustomerInput>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutStripeCustomerInput>;
  paymentMethods?: Maybe<StripePaymentMethodCreateNestedManyWithoutStripeCustomerInput>;
  stripeId: Scalars['String'];
};

export type StripeCustomerCreateWithoutPaymentMethodsInput = {
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutStripeCustomerInput>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceCreateNestedManyWithoutStripeCustomerInput>;
  organizationPetParents?: Maybe<OrganizationPetParentCreateNestedManyWithoutStripeCustomerInput>;
  stripeId: Scalars['String'];
};

export type StripeCustomerGroupByOutputType = {
  __typename?: 'StripeCustomerGroupByOutputType';
  _count?: Maybe<StripeCustomerCountAggregateOutputType>;
  _max?: Maybe<StripeCustomerMaxAggregateOutputType>;
  _min?: Maybe<StripeCustomerMinAggregateOutputType>;
  id: Scalars['String'];
  stripeId: Scalars['String'];
};

export type StripeCustomerMaxAggregateOutputType = {
  __typename?: 'StripeCustomerMaxAggregateOutputType';
  id?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
};

export type StripeCustomerMinAggregateOutputType = {
  __typename?: 'StripeCustomerMinAggregateOutputType';
  id?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
};

export type StripeCustomerNullableScalarRelationFilter = {
  AND?: Maybe<Array<StripeCustomerWhereInput>>;
  NOT?: Maybe<Array<StripeCustomerWhereInput>>;
  OR?: Maybe<Array<StripeCustomerWhereInput>>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  id?: Maybe<StringFilter>;
  invoices?: Maybe<StripeInvoiceListRelationFilter>;
  organizationPetParents?: Maybe<OrganizationPetParentListRelationFilter>;
  paymentMethods?: Maybe<StripePaymentMethodListRelationFilter>;
  stripeId?: Maybe<StringFilter>;
};

export type StripeCustomerOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeCustomerOrderByRelevanceInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  invoices?: Maybe<StripeInvoiceOrderByRelationAggregateInput>;
  organizationPetParents?: Maybe<OrganizationPetParentOrderByRelationAggregateInput>;
  paymentMethods?: Maybe<StripePaymentMethodOrderByRelationAggregateInput>;
  stripeId?: Maybe<SortOrder>;
};

export enum StripeCustomerOrderByRelevanceFieldEnum {
  Id = 'id',
  StripeId = 'stripeId'
}

export type StripeCustomerOrderByRelevanceInput = {
  fields: Array<StripeCustomerOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripeCustomerOrderByWithAggregationInput = {
  _count?: Maybe<StripeCustomerCountOrderByAggregateInput>;
  _max?: Maybe<StripeCustomerMaxOrderByAggregateInput>;
  _min?: Maybe<StripeCustomerMinOrderByAggregateInput>;
  id?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
};

export type StripeCustomerOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeCustomerOrderByRelevanceInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  invoices?: Maybe<StripeInvoiceOrderByRelationAggregateInput>;
  organizationPetParents?: Maybe<OrganizationPetParentOrderByRelationAggregateInput>;
  paymentMethods?: Maybe<StripePaymentMethodOrderByRelationAggregateInput>;
  stripeId?: Maybe<SortOrder>;
};

export type StripeCustomerOrderByWithRelationInput = {
  _relevance?: Maybe<StripeCustomerOrderByRelevanceInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  invoices?: Maybe<StripeInvoiceOrderByRelationAggregateInput>;
  organizationPetParents?: Maybe<OrganizationPetParentOrderByRelationAggregateInput>;
  paymentMethods?: Maybe<StripePaymentMethodOrderByRelationAggregateInput>;
  stripeId?: Maybe<SortOrder>;
};

export type StripeCustomerPortalInput = {
  returnUrl?: Maybe<Scalars['String']>;
};

export type StripeCustomerPortalOutput = {
  __typename?: 'StripeCustomerPortalOutput';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type StripeCustomerPortalWhereUniqueInput = {
  customerId: Scalars['String'];
};

export enum StripeCustomerScalarFieldEnum {
  Id = 'id',
  StripeId = 'stripeId'
}

export type StripeCustomerScalarRelationFilter = {
  AND?: Maybe<Array<StripeCustomerWhereInput>>;
  NOT?: Maybe<Array<StripeCustomerWhereInput>>;
  OR?: Maybe<Array<StripeCustomerWhereInput>>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  id?: Maybe<StringFilter>;
  invoices?: Maybe<StripeInvoiceListRelationFilter>;
  organizationPetParents?: Maybe<OrganizationPetParentListRelationFilter>;
  paymentMethods?: Maybe<StripePaymentMethodListRelationFilter>;
  stripeId?: Maybe<StringFilter>;
};

export type StripeCustomerScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripeCustomerScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripeCustomerScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripeCustomerScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  stripeId?: Maybe<StringWithAggregatesFilter>;
};

export type StripeCustomerUncheckedCreateInput = {
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  paymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  stripeId: Scalars['String'];
};

export type StripeCustomerUncheckedCreateWithoutClinicPetParentsInput = {
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  paymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  stripeId: Scalars['String'];
};

export type StripeCustomerUncheckedCreateWithoutInvoicesInput = {
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  paymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  stripeId: Scalars['String'];
};

export type StripeCustomerUncheckedCreateWithoutOrganizationPetParentsInput = {
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  paymentMethods?: Maybe<StripePaymentMethodUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  stripeId: Scalars['String'];
};

export type StripeCustomerUncheckedCreateWithoutPaymentMethodsInput = {
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedCreateNestedManyWithoutStripeCustomerInput>;
  stripeId: Scalars['String'];
};

export type StripeCustomerUncheckedUpdateInput = {
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  paymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerUncheckedUpdateManyInput = {
  id?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerUncheckedUpdateWithoutClinicPetParentsInput = {
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  paymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerUncheckedUpdateWithoutInvoicesInput = {
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  paymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerUncheckedUpdateWithoutOrganizationPetParentsInput = {
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  paymentMethods?: Maybe<StripePaymentMethodUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerUncheckedUpdateWithoutPaymentMethodsInput = {
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  organizationPetParents?: Maybe<OrganizationPetParentUncheckedUpdateManyWithoutStripeCustomerNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerUpdateInput = {
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutStripeCustomerNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutStripeCustomerNestedInput>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutStripeCustomerNestedInput>;
  paymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutStripeCustomerNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerUpdateManyMutationInput = {
  id?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerUpdateOneRequiredWithoutInvoicesNestedInput = {
  connect?: Maybe<StripeCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeCustomerCreateOrConnectWithoutInvoicesInput>;
  create?: Maybe<StripeCustomerCreateWithoutInvoicesInput>;
  update?: Maybe<StripeCustomerUpdateToOneWithWhereWithoutInvoicesInput>;
  upsert?: Maybe<StripeCustomerUpsertWithoutInvoicesInput>;
};

export type StripeCustomerUpdateOneWithoutClinicPetParentsNestedInput = {
  connect?: Maybe<StripeCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeCustomerCreateOrConnectWithoutClinicPetParentsInput>;
  create?: Maybe<StripeCustomerCreateWithoutClinicPetParentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeCustomerUpdateToOneWithWhereWithoutClinicPetParentsInput>;
  upsert?: Maybe<StripeCustomerUpsertWithoutClinicPetParentsInput>;
};

export type StripeCustomerUpdateOneWithoutOrganizationPetParentsNestedInput = {
  connect?: Maybe<StripeCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeCustomerCreateOrConnectWithoutOrganizationPetParentsInput>;
  create?: Maybe<StripeCustomerCreateWithoutOrganizationPetParentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeCustomerUpdateToOneWithWhereWithoutOrganizationPetParentsInput>;
  upsert?: Maybe<StripeCustomerUpsertWithoutOrganizationPetParentsInput>;
};

export type StripeCustomerUpdateOneWithoutPaymentMethodsNestedInput = {
  connect?: Maybe<StripeCustomerWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeCustomerCreateOrConnectWithoutPaymentMethodsInput>;
  create?: Maybe<StripeCustomerCreateWithoutPaymentMethodsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeCustomerUpdateToOneWithWhereWithoutPaymentMethodsInput>;
  upsert?: Maybe<StripeCustomerUpsertWithoutPaymentMethodsInput>;
};

export type StripeCustomerUpdateToOneWithWhereWithoutClinicPetParentsInput = {
  data: StripeCustomerUpdateWithoutClinicPetParentsInput;
  where?: Maybe<StripeCustomerWhereInput>;
};

export type StripeCustomerUpdateToOneWithWhereWithoutInvoicesInput = {
  data: StripeCustomerUpdateWithoutInvoicesInput;
  where?: Maybe<StripeCustomerWhereInput>;
};

export type StripeCustomerUpdateToOneWithWhereWithoutOrganizationPetParentsInput = {
  data: StripeCustomerUpdateWithoutOrganizationPetParentsInput;
  where?: Maybe<StripeCustomerWhereInput>;
};

export type StripeCustomerUpdateToOneWithWhereWithoutPaymentMethodsInput = {
  data: StripeCustomerUpdateWithoutPaymentMethodsInput;
  where?: Maybe<StripeCustomerWhereInput>;
};

export type StripeCustomerUpdateWithoutClinicPetParentsInput = {
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutStripeCustomerNestedInput>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutStripeCustomerNestedInput>;
  paymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutStripeCustomerNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerUpdateWithoutInvoicesInput = {
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutStripeCustomerNestedInput>;
  id?: Maybe<Scalars['String']>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutStripeCustomerNestedInput>;
  paymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutStripeCustomerNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerUpdateWithoutOrganizationPetParentsInput = {
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutStripeCustomerNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutStripeCustomerNestedInput>;
  paymentMethods?: Maybe<StripePaymentMethodUpdateManyWithoutStripeCustomerNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerUpdateWithoutPaymentMethodsInput = {
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutStripeCustomerNestedInput>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceUpdateManyWithoutStripeCustomerNestedInput>;
  organizationPetParents?: Maybe<OrganizationPetParentUpdateManyWithoutStripeCustomerNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeCustomerUpsertWithoutClinicPetParentsInput = {
  create: StripeCustomerCreateWithoutClinicPetParentsInput;
  update: StripeCustomerUpdateWithoutClinicPetParentsInput;
  where?: Maybe<StripeCustomerWhereInput>;
};

export type StripeCustomerUpsertWithoutInvoicesInput = {
  create: StripeCustomerCreateWithoutInvoicesInput;
  update: StripeCustomerUpdateWithoutInvoicesInput;
  where?: Maybe<StripeCustomerWhereInput>;
};

export type StripeCustomerUpsertWithoutOrganizationPetParentsInput = {
  create: StripeCustomerCreateWithoutOrganizationPetParentsInput;
  update: StripeCustomerUpdateWithoutOrganizationPetParentsInput;
  where?: Maybe<StripeCustomerWhereInput>;
};

export type StripeCustomerUpsertWithoutPaymentMethodsInput = {
  create: StripeCustomerCreateWithoutPaymentMethodsInput;
  update: StripeCustomerUpdateWithoutPaymentMethodsInput;
  where?: Maybe<StripeCustomerWhereInput>;
};

export type StripeCustomerWhereInput = {
  AND?: Maybe<Array<StripeCustomerWhereInput>>;
  NOT?: Maybe<Array<StripeCustomerWhereInput>>;
  OR?: Maybe<Array<StripeCustomerWhereInput>>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  id?: Maybe<StringFilter>;
  invoices?: Maybe<StripeInvoiceListRelationFilter>;
  organizationPetParents?: Maybe<OrganizationPetParentListRelationFilter>;
  paymentMethods?: Maybe<StripePaymentMethodListRelationFilter>;
  stripeId?: Maybe<StringFilter>;
};

export type StripeCustomerWhereUniqueInput = {
  AND?: Maybe<Array<StripeCustomerWhereInput>>;
  NOT?: Maybe<Array<StripeCustomerWhereInput>>;
  OR?: Maybe<Array<StripeCustomerWhereInput>>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<StripeInvoiceListRelationFilter>;
  organizationPetParents?: Maybe<OrganizationPetParentListRelationFilter>;
  paymentMethods?: Maybe<StripePaymentMethodListRelationFilter>;
  stripeId?: Maybe<Scalars['String']>;
};

export type StripeDispute = {
  __typename?: 'StripeDispute';
  amount: Scalars['Int'];
  /** used by the frontend when surfacing disputes */
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPayment>;
  createdAt: Scalars['DateTime'];
  /** This will be the amount we charge the clinic for the dispute if they lose it */
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransaction>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  /** This is how much we refunded to them for the processing fees if they lose the dispute */
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntent>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayout?: Maybe<StripePayout>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type StripeDisputeCareEnrollmentPaymentArgs = {
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};


export type StripeDisputeFinancialTransactionArgs = {
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type StripeDisputeStripePaymentIntentArgs = {
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type StripeDisputeStripePayoutArgs = {
  where?: Maybe<StripePayoutWhereInput>;
};

export type StripeDisputeAvgAggregateOutputType = {
  __typename?: 'StripeDisputeAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  disputeFee?: Maybe<Scalars['Float']>;
  processingFeesRefunded?: Maybe<Scalars['Float']>;
};

export type StripeDisputeAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  disputeFee?: Maybe<SortOrder>;
  processingFeesRefunded?: Maybe<SortOrder>;
};

export type StripeDisputeCountAggregateOutputType = {
  __typename?: 'StripeDisputeCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  associatedTransferStripePaymentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  disputeFee: Scalars['Int'];
  fundsAvailableAt: Scalars['Int'];
  id: Scalars['Int'];
  processingFeesRefunded: Scalars['Int'];
  status: Scalars['Int'];
  stripeDisputeFeeChargeId: Scalars['Int'];
  stripeDisputeReason: Scalars['Int'];
  stripeId: Scalars['Int'];
  stripePaymentIntentId: Scalars['Int'];
  stripePayoutId: Scalars['Int'];
  stripeTransferReversalId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StripeDisputeCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  associatedTransferStripePaymentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputeFee?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  processingFeesRefunded?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeDisputeFeeChargeId?: Maybe<SortOrder>;
  stripeDisputeReason?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeTransferReversalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeDisputeCreateInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedOneWithoutStripeDisputeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeDisputeInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeDisputeInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripeDisputesInput>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeCreateManyInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeCreateManyStripePaymentIntentInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeCreateManyStripePaymentIntentInputEnvelope = {
  data: Array<StripeDisputeCreateManyStripePaymentIntentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeDisputeCreateManyStripePayoutInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeCreateManyStripePayoutInputEnvelope = {
  data: Array<StripeDisputeCreateManyStripePayoutInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput = {
  connect?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeDisputeCreateOrConnectWithoutStripePaymentIntentInput>>;
  create?: Maybe<Array<StripeDisputeCreateWithoutStripePaymentIntentInput>>;
  createMany?: Maybe<StripeDisputeCreateManyStripePaymentIntentInputEnvelope>;
};

export type StripeDisputeCreateNestedManyWithoutStripePayoutInput = {
  connect?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeDisputeCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<StripeDisputeCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<StripeDisputeCreateManyStripePayoutInputEnvelope>;
};

export type StripeDisputeCreateNestedOneWithoutCareEnrollmentPaymentInput = {
  connect?: Maybe<StripeDisputeWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeDisputeCreateOrConnectWithoutCareEnrollmentPaymentInput>;
  create?: Maybe<StripeDisputeCreateWithoutCareEnrollmentPaymentInput>;
};

export type StripeDisputeCreateNestedOneWithoutFinancialTransactionInput = {
  connect?: Maybe<StripeDisputeWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeDisputeCreateOrConnectWithoutFinancialTransactionInput>;
  create?: Maybe<StripeDisputeCreateWithoutFinancialTransactionInput>;
};

export type StripeDisputeCreateOrConnectWithoutCareEnrollmentPaymentInput = {
  create: StripeDisputeCreateWithoutCareEnrollmentPaymentInput;
  where: StripeDisputeWhereUniqueInput;
};

export type StripeDisputeCreateOrConnectWithoutFinancialTransactionInput = {
  create: StripeDisputeCreateWithoutFinancialTransactionInput;
  where: StripeDisputeWhereUniqueInput;
};

export type StripeDisputeCreateOrConnectWithoutStripePaymentIntentInput = {
  create: StripeDisputeCreateWithoutStripePaymentIntentInput;
  where: StripeDisputeWhereUniqueInput;
};

export type StripeDisputeCreateOrConnectWithoutStripePayoutInput = {
  create: StripeDisputeCreateWithoutStripePayoutInput;
  where: StripeDisputeWhereUniqueInput;
};

export type StripeDisputeCreateWithoutCareEnrollmentPaymentInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeDisputeInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeDisputeInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripeDisputesInput>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeCreateWithoutFinancialTransactionInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedOneWithoutStripeDisputeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeDisputeInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripeDisputesInput>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeCreateWithoutStripePaymentIntentInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedOneWithoutStripeDisputeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeDisputeInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripeDisputesInput>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeCreateWithoutStripePayoutInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedOneWithoutStripeDisputeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeDisputeInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeDisputeInput>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeGroupByOutputType = {
  __typename?: 'StripeDisputeGroupByOutputType';
  _avg?: Maybe<StripeDisputeAvgAggregateOutputType>;
  _count?: Maybe<StripeDisputeCountAggregateOutputType>;
  _max?: Maybe<StripeDisputeMaxAggregateOutputType>;
  _min?: Maybe<StripeDisputeMinAggregateOutputType>;
  _sum?: Maybe<StripeDisputeSumAggregateOutputType>;
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type StripeDisputeListRelationFilter = {
  every?: Maybe<StripeDisputeWhereInput>;
  none?: Maybe<StripeDisputeWhereInput>;
  some?: Maybe<StripeDisputeWhereInput>;
};

export type StripeDisputeMaxAggregateOutputType = {
  __typename?: 'StripeDisputeMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  associatedTransferStripePaymentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputeFee?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  processingFeesRefunded?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeDisputeFeeChargeId?: Maybe<SortOrder>;
  stripeDisputeReason?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeTransferReversalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeDisputeMinAggregateOutputType = {
  __typename?: 'StripeDisputeMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  associatedTransferStripePaymentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputeFee?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  processingFeesRefunded?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeDisputeFeeChargeId?: Maybe<SortOrder>;
  stripeDisputeReason?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeTransferReversalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeDisputeNullableScalarRelationFilter = {
  AND?: Maybe<Array<StripeDisputeWhereInput>>;
  NOT?: Maybe<Array<StripeDisputeWhereInput>>;
  OR?: Maybe<Array<StripeDisputeWhereInput>>;
  amount?: Maybe<IntFilter>;
  associatedTransferStripePaymentId?: Maybe<StringNullableFilter>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disputeFee?: Maybe<IntNullableFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  processingFeesRefunded?: Maybe<IntNullableFilter>;
  status?: Maybe<EnumStripeDisputeStatusFilter>;
  stripeDisputeFeeChargeId?: Maybe<StringNullableFilter>;
  stripeDisputeReason?: Maybe<EnumStripeDisputeReasonNullableFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeTransferReversalId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeDisputeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StripeDisputeOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeDisputeOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  associatedTransferStripePaymentId?: Maybe<SortOrder>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  disputeFee?: Maybe<SortOrder>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  processingFeesRefunded?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeDisputeFeeChargeId?: Maybe<SortOrder>;
  stripeDisputeReason?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeTransferReversalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeDisputeOrderByRelevanceFieldEnum {
  AssociatedTransferStripePaymentId = 'associatedTransferStripePaymentId',
  Id = 'id',
  StripeDisputeFeeChargeId = 'stripeDisputeFeeChargeId',
  StripeId = 'stripeId',
  StripePaymentIntentId = 'stripePaymentIntentId',
  StripePayoutId = 'stripePayoutId',
  StripeTransferReversalId = 'stripeTransferReversalId'
}

export type StripeDisputeOrderByRelevanceInput = {
  fields: Array<StripeDisputeOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripeDisputeOrderByWithAggregationInput = {
  _avg?: Maybe<StripeDisputeAvgOrderByAggregateInput>;
  _count?: Maybe<StripeDisputeCountOrderByAggregateInput>;
  _max?: Maybe<StripeDisputeMaxOrderByAggregateInput>;
  _min?: Maybe<StripeDisputeMinOrderByAggregateInput>;
  _sum?: Maybe<StripeDisputeSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  associatedTransferStripePaymentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disputeFee?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  processingFeesRefunded?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeDisputeFeeChargeId?: Maybe<SortOrder>;
  stripeDisputeReason?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeTransferReversalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeDisputeOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeDisputeOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  associatedTransferStripePaymentId?: Maybe<SortOrder>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  disputeFee?: Maybe<SortOrder>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  processingFeesRefunded?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeDisputeFeeChargeId?: Maybe<SortOrder>;
  stripeDisputeReason?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeTransferReversalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeDisputeOrderByWithRelationInput = {
  _relevance?: Maybe<StripeDisputeOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  associatedTransferStripePaymentId?: Maybe<SortOrder>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  disputeFee?: Maybe<SortOrder>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  processingFeesRefunded?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeDisputeFeeChargeId?: Maybe<SortOrder>;
  stripeDisputeReason?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeTransferReversalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeDisputeReason {
  BankCannotProcess = 'BankCannotProcess',
  CheckReturned = 'CheckReturned',
  CreditNotProcessed = 'CreditNotProcessed',
  CustomerInitiated = 'CustomerInitiated',
  DebitNotAuthorized = 'DebitNotAuthorized',
  Duplicate = 'Duplicate',
  Fraudulent = 'Fraudulent',
  General = 'General',
  IncorrectAccountDetails = 'IncorrectAccountDetails',
  InsufficientFunds = 'InsufficientFunds',
  ProductNotReceived = 'ProductNotReceived',
  ProductUnacceptable = 'ProductUnacceptable',
  SubscriptionCanceled = 'SubscriptionCanceled',
  Unknown = 'Unknown',
  Unrecognized = 'Unrecognized'
}

export enum StripeDisputeScalarFieldEnum {
  Amount = 'amount',
  AssociatedTransferStripePaymentId = 'associatedTransferStripePaymentId',
  CreatedAt = 'createdAt',
  DisputeFee = 'disputeFee',
  FundsAvailableAt = 'fundsAvailableAt',
  Id = 'id',
  ProcessingFeesRefunded = 'processingFeesRefunded',
  Status = 'status',
  StripeDisputeFeeChargeId = 'stripeDisputeFeeChargeId',
  StripeDisputeReason = 'stripeDisputeReason',
  StripeId = 'stripeId',
  StripePaymentIntentId = 'stripePaymentIntentId',
  StripePayoutId = 'stripePayoutId',
  StripeTransferReversalId = 'stripeTransferReversalId',
  UpdatedAt = 'updatedAt'
}

export type StripeDisputeScalarWhereInput = {
  AND?: Maybe<Array<StripeDisputeScalarWhereInput>>;
  NOT?: Maybe<Array<StripeDisputeScalarWhereInput>>;
  OR?: Maybe<Array<StripeDisputeScalarWhereInput>>;
  amount?: Maybe<IntFilter>;
  associatedTransferStripePaymentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disputeFee?: Maybe<IntNullableFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  processingFeesRefunded?: Maybe<IntNullableFilter>;
  status?: Maybe<EnumStripeDisputeStatusFilter>;
  stripeDisputeFeeChargeId?: Maybe<StringNullableFilter>;
  stripeDisputeReason?: Maybe<EnumStripeDisputeReasonNullableFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeTransferReversalId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeDisputeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripeDisputeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripeDisputeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripeDisputeScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntWithAggregatesFilter>;
  associatedTransferStripePaymentId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  disputeFee?: Maybe<IntNullableWithAggregatesFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  processingFeesRefunded?: Maybe<IntNullableWithAggregatesFilter>;
  status?: Maybe<EnumStripeDisputeStatusWithAggregatesFilter>;
  stripeDisputeFeeChargeId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeDisputeReason?: Maybe<EnumStripeDisputeReasonNullableWithAggregatesFilter>;
  stripeId?: Maybe<StringWithAggregatesFilter>;
  stripePaymentIntentId?: Maybe<StringNullableWithAggregatesFilter>;
  stripePayoutId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeTransferReversalId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum StripeDisputeStatus {
  ChargeRefunded = 'Charge_Refunded',
  Lost = 'Lost',
  NeedsResponse = 'Needs_Response',
  UnderReview = 'Under_Review',
  WarningClosed = 'Warning_Closed',
  WarningNeedsResponse = 'Warning_Needs_Response',
  WarningUnderReview = 'Warning_Under_Review',
  Won = 'Won'
}

export type StripeDisputeSubscription = {
  __typename?: 'StripeDisputeSubscription';
  model: Scalars['String'];
  mutation: MutationType;
  node: StripeDispute;
};

export type StripeDisputeSumAggregateOutputType = {
  __typename?: 'StripeDisputeSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  disputeFee?: Maybe<Scalars['Int']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
};

export type StripeDisputeSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  disputeFee?: Maybe<SortOrder>;
  processingFeesRefunded?: Maybe<SortOrder>;
};

export type StripeDisputeUncheckedCreateInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeDisputeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeDisputeInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput = {
  connect?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeDisputeCreateOrConnectWithoutStripePaymentIntentInput>>;
  create?: Maybe<Array<StripeDisputeCreateWithoutStripePaymentIntentInput>>;
  createMany?: Maybe<StripeDisputeCreateManyStripePaymentIntentInputEnvelope>;
};

export type StripeDisputeUncheckedCreateNestedManyWithoutStripePayoutInput = {
  connect?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeDisputeCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<StripeDisputeCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<StripeDisputeCreateManyStripePayoutInputEnvelope>;
};

export type StripeDisputeUncheckedCreateWithoutCareEnrollmentPaymentInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeDisputeInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUncheckedCreateWithoutFinancialTransactionInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeDisputeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUncheckedCreateWithoutStripePaymentIntentInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeDisputeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeDisputeInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUncheckedCreateWithoutStripePayoutInput = {
  amount: Scalars['Int'];
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeDisputeInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeDisputeInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status: StripeDisputeStatus;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeDisputeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeDisputeNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput = {
  connect?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeDisputeCreateOrConnectWithoutStripePaymentIntentInput>>;
  create?: Maybe<Array<StripeDisputeCreateWithoutStripePaymentIntentInput>>;
  createMany?: Maybe<StripeDisputeCreateManyStripePaymentIntentInputEnvelope>;
  delete?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeDisputeScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  set?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  update?: Maybe<Array<StripeDisputeUpdateWithWhereUniqueWithoutStripePaymentIntentInput>>;
  updateMany?: Maybe<Array<StripeDisputeUpdateManyWithWhereWithoutStripePaymentIntentInput>>;
  upsert?: Maybe<Array<StripeDisputeUpsertWithWhereUniqueWithoutStripePaymentIntentInput>>;
};

export type StripeDisputeUncheckedUpdateManyWithoutStripePayoutInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUncheckedUpdateManyWithoutStripePayoutNestedInput = {
  connect?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeDisputeCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<StripeDisputeCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<StripeDisputeCreateManyStripePayoutInputEnvelope>;
  delete?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeDisputeScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  set?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  update?: Maybe<Array<StripeDisputeUpdateWithWhereUniqueWithoutStripePayoutInput>>;
  updateMany?: Maybe<Array<StripeDisputeUpdateManyWithWhereWithoutStripePayoutInput>>;
  upsert?: Maybe<Array<StripeDisputeUpsertWithWhereUniqueWithoutStripePayoutInput>>;
};

export type StripeDisputeUncheckedUpdateWithoutCareEnrollmentPaymentInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeDisputeNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUncheckedUpdateWithoutFinancialTransactionInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeDisputeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUncheckedUpdateWithoutStripePaymentIntentInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeDisputeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeDisputeNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUncheckedUpdateWithoutStripePayoutInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeDisputeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeDisputeNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateOneWithoutStripeDisputeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeDisputeNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutStripeDisputeNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripeDisputesNestedInput>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUpdateManyWithWhereWithoutStripePaymentIntentInput = {
  data: StripeDisputeUpdateManyMutationInput;
  where: StripeDisputeScalarWhereInput;
};

export type StripeDisputeUpdateManyWithWhereWithoutStripePayoutInput = {
  data: StripeDisputeUpdateManyMutationInput;
  where: StripeDisputeScalarWhereInput;
};

export type StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput = {
  connect?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeDisputeCreateOrConnectWithoutStripePaymentIntentInput>>;
  create?: Maybe<Array<StripeDisputeCreateWithoutStripePaymentIntentInput>>;
  createMany?: Maybe<StripeDisputeCreateManyStripePaymentIntentInputEnvelope>;
  delete?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeDisputeScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  set?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  update?: Maybe<Array<StripeDisputeUpdateWithWhereUniqueWithoutStripePaymentIntentInput>>;
  updateMany?: Maybe<Array<StripeDisputeUpdateManyWithWhereWithoutStripePaymentIntentInput>>;
  upsert?: Maybe<Array<StripeDisputeUpsertWithWhereUniqueWithoutStripePaymentIntentInput>>;
};

export type StripeDisputeUpdateManyWithoutStripePayoutNestedInput = {
  connect?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeDisputeCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<StripeDisputeCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<StripeDisputeCreateManyStripePayoutInputEnvelope>;
  delete?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeDisputeScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  set?: Maybe<Array<StripeDisputeWhereUniqueInput>>;
  update?: Maybe<Array<StripeDisputeUpdateWithWhereUniqueWithoutStripePayoutInput>>;
  updateMany?: Maybe<Array<StripeDisputeUpdateManyWithWhereWithoutStripePayoutInput>>;
  upsert?: Maybe<Array<StripeDisputeUpsertWithWhereUniqueWithoutStripePayoutInput>>;
};

export type StripeDisputeUpdateOneWithoutCareEnrollmentPaymentNestedInput = {
  connect?: Maybe<StripeDisputeWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeDisputeCreateOrConnectWithoutCareEnrollmentPaymentInput>;
  create?: Maybe<StripeDisputeCreateWithoutCareEnrollmentPaymentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeDisputeUpdateToOneWithWhereWithoutCareEnrollmentPaymentInput>;
  upsert?: Maybe<StripeDisputeUpsertWithoutCareEnrollmentPaymentInput>;
};

export type StripeDisputeUpdateOneWithoutFinancialTransactionNestedInput = {
  connect?: Maybe<StripeDisputeWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeDisputeCreateOrConnectWithoutFinancialTransactionInput>;
  create?: Maybe<StripeDisputeCreateWithoutFinancialTransactionInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeDisputeUpdateToOneWithWhereWithoutFinancialTransactionInput>;
  upsert?: Maybe<StripeDisputeUpsertWithoutFinancialTransactionInput>;
};

export type StripeDisputeUpdateToOneWithWhereWithoutCareEnrollmentPaymentInput = {
  data: StripeDisputeUpdateWithoutCareEnrollmentPaymentInput;
  where?: Maybe<StripeDisputeWhereInput>;
};

export type StripeDisputeUpdateToOneWithWhereWithoutFinancialTransactionInput = {
  data: StripeDisputeUpdateWithoutFinancialTransactionInput;
  where?: Maybe<StripeDisputeWhereInput>;
};

export type StripeDisputeUpdateWithWhereUniqueWithoutStripePaymentIntentInput = {
  data: StripeDisputeUpdateWithoutStripePaymentIntentInput;
  where: StripeDisputeWhereUniqueInput;
};

export type StripeDisputeUpdateWithWhereUniqueWithoutStripePayoutInput = {
  data: StripeDisputeUpdateWithoutStripePayoutInput;
  where: StripeDisputeWhereUniqueInput;
};

export type StripeDisputeUpdateWithoutCareEnrollmentPaymentInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeDisputeNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutStripeDisputeNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripeDisputesNestedInput>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUpdateWithoutFinancialTransactionInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateOneWithoutStripeDisputeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutStripeDisputeNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripeDisputesNestedInput>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUpdateWithoutStripePaymentIntentInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateOneWithoutStripeDisputeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeDisputeNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripeDisputesNestedInput>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUpdateWithoutStripePayoutInput = {
  amount?: Maybe<Scalars['Int']>;
  associatedTransferStripePaymentId?: Maybe<Scalars['String']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateOneWithoutStripeDisputeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disputeFee?: Maybe<Scalars['Int']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeDisputeNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeDisputeStatus>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<StripeDisputeReason>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutStripeDisputeNestedInput>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeDisputeUpsertWithWhereUniqueWithoutStripePaymentIntentInput = {
  create: StripeDisputeCreateWithoutStripePaymentIntentInput;
  update: StripeDisputeUpdateWithoutStripePaymentIntentInput;
  where: StripeDisputeWhereUniqueInput;
};

export type StripeDisputeUpsertWithWhereUniqueWithoutStripePayoutInput = {
  create: StripeDisputeCreateWithoutStripePayoutInput;
  update: StripeDisputeUpdateWithoutStripePayoutInput;
  where: StripeDisputeWhereUniqueInput;
};

export type StripeDisputeUpsertWithoutCareEnrollmentPaymentInput = {
  create: StripeDisputeCreateWithoutCareEnrollmentPaymentInput;
  update: StripeDisputeUpdateWithoutCareEnrollmentPaymentInput;
  where?: Maybe<StripeDisputeWhereInput>;
};

export type StripeDisputeUpsertWithoutFinancialTransactionInput = {
  create: StripeDisputeCreateWithoutFinancialTransactionInput;
  update: StripeDisputeUpdateWithoutFinancialTransactionInput;
  where?: Maybe<StripeDisputeWhereInput>;
};

export type StripeDisputeWhereInput = {
  AND?: Maybe<Array<StripeDisputeWhereInput>>;
  NOT?: Maybe<Array<StripeDisputeWhereInput>>;
  OR?: Maybe<Array<StripeDisputeWhereInput>>;
  amount?: Maybe<IntFilter>;
  associatedTransferStripePaymentId?: Maybe<StringNullableFilter>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disputeFee?: Maybe<IntNullableFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  processingFeesRefunded?: Maybe<IntNullableFilter>;
  status?: Maybe<EnumStripeDisputeStatusFilter>;
  stripeDisputeFeeChargeId?: Maybe<StringNullableFilter>;
  stripeDisputeReason?: Maybe<EnumStripeDisputeReasonNullableFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeTransferReversalId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeDisputeWhereUniqueInput = {
  AND?: Maybe<Array<StripeDisputeWhereInput>>;
  NOT?: Maybe<Array<StripeDisputeWhereInput>>;
  OR?: Maybe<Array<StripeDisputeWhereInput>>;
  amount?: Maybe<IntFilter>;
  associatedTransferStripePaymentId?: Maybe<StringNullableFilter>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disputeFee?: Maybe<IntNullableFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  processingFeesRefunded?: Maybe<IntNullableFilter>;
  status?: Maybe<EnumStripeDisputeStatusFilter>;
  stripeDisputeFeeChargeId?: Maybe<Scalars['String']>;
  stripeDisputeReason?: Maybe<EnumStripeDisputeReasonNullableFilter>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  _count: StripeInvoiceCountOutputType;
  amount: Scalars['Int'];
  careStripeSubscription: CareStripeSubscription;
  careStripeSubscriptionId: Scalars['String'];
  careSubscriptionTrueUps: Array<CareSubscriptionTrueUp>;
  collectionMethod: StripeCollectionMethod;
  createdAt: Scalars['DateTime'];
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment: Array<CareEnrollmentPayment>;
  financialTransaction?: Maybe<FinancialTransaction>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  lapsedPayment?: Maybe<CareLapsedPayment>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents: Array<EnrollmentSupportEvent>;
  relatedStripeInvoiceItems: Array<StripeInvoiceItem>;
  serviceFeeAmount: Scalars['Int'];
  /** example 71.66% would be 0.7166 */
  serviceFeePercent: Scalars['Float'];
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer: StripeCustomer;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type StripeInvoiceCareSubscriptionTrueUpsArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareSubscriptionTrueUpScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
};


export type StripeInvoiceEnrollmentPaymentArgs = {
  cursor?: Maybe<CareEnrollmentPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareEnrollmentPaymentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentPaymentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};


export type StripeInvoiceFinancialTransactionArgs = {
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type StripeInvoiceLapsedPaymentArgs = {
  where?: Maybe<CareLapsedPaymentWhereInput>;
};


export type StripeInvoiceRelatedEnrollmentSupportEventsArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type StripeInvoiceRelatedStripeInvoiceItemsArgs = {
  cursor?: Maybe<StripeInvoiceItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeInvoiceItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeInvoiceItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeInvoiceItemWhereInput>;
};


export type StripeInvoiceStripePaymentMethodArgs = {
  where?: Maybe<StripePaymentMethodWhereInput>;
};

export type StripeInvoiceAvgAggregateOutputType = {
  __typename?: 'StripeInvoiceAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type StripeInvoiceAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  serviceFeePercent?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
};

export type StripeInvoiceCountAggregateOutputType = {
  __typename?: 'StripeInvoiceCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['Int'];
  collectionMethod: Scalars['Int'];
  createdAt: Scalars['Int'];
  currency: Scalars['Int'];
  dueAt: Scalars['Int'];
  fundsAvailableAt: Scalars['Int'];
  id: Scalars['Int'];
  paidAt: Scalars['Int'];
  serviceFeeAmount: Scalars['Int'];
  serviceFeePercent: Scalars['Int'];
  status: Scalars['Int'];
  stripeChargeId: Scalars['Int'];
  stripeCustomerId: Scalars['Int'];
  stripeId: Scalars['Int'];
  stripePaymentMethodId: Scalars['Int'];
  total: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StripeInvoiceCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  collectionMethod?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  serviceFeePercent?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeChargeId?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeInvoiceCountOutputType = {
  __typename?: 'StripeInvoiceCountOutputType';
  careSubscriptionTrueUps: Scalars['Int'];
  enrollmentPayment: Scalars['Int'];
  relatedEnrollmentSupportEvents: Scalars['Int'];
  relatedStripeInvoiceItems: Scalars['Int'];
};

export type StripeInvoiceCreateInput = {
  amount: Scalars['Int'];
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutInvoicesInput;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer: StripeCustomerCreateNestedOneWithoutInvoicesInput;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripeInvoicesInput>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateManyCareStripeSubscriptionInput = {
  amount: Scalars['Int'];
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateManyCareStripeSubscriptionInputEnvelope = {
  data: Array<StripeInvoiceCreateManyCareStripeSubscriptionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeInvoiceCreateManyInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateManyStripeCustomerInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateManyStripeCustomerInputEnvelope = {
  data: Array<StripeInvoiceCreateManyStripeCustomerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeInvoiceCreateManyStripePaymentMethodInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateManyStripePaymentMethodInputEnvelope = {
  data: Array<StripeInvoiceCreateManyStripePaymentMethodInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeInvoiceCreateNestedManyWithoutCareStripeSubscriptionInput = {
  connect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<StripeInvoiceCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<StripeInvoiceCreateManyCareStripeSubscriptionInputEnvelope>;
};

export type StripeInvoiceCreateNestedManyWithoutStripeCustomerInput = {
  connect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<StripeInvoiceCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<StripeInvoiceCreateManyStripeCustomerInputEnvelope>;
};

export type StripeInvoiceCreateNestedManyWithoutStripePaymentMethodInput = {
  connect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<StripeInvoiceCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<StripeInvoiceCreateManyStripePaymentMethodInputEnvelope>;
};

export type StripeInvoiceCreateNestedOneWithoutCareSubscriptionTrueUpsInput = {
  connect?: Maybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceCreateOrConnectWithoutCareSubscriptionTrueUpsInput>;
  create?: Maybe<StripeInvoiceCreateWithoutCareSubscriptionTrueUpsInput>;
};

export type StripeInvoiceCreateNestedOneWithoutEnrollmentPaymentInput = {
  connect?: Maybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceCreateOrConnectWithoutEnrollmentPaymentInput>;
  create?: Maybe<StripeInvoiceCreateWithoutEnrollmentPaymentInput>;
};

export type StripeInvoiceCreateNestedOneWithoutFinancialTransactionInput = {
  connect?: Maybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceCreateOrConnectWithoutFinancialTransactionInput>;
  create?: Maybe<StripeInvoiceCreateWithoutFinancialTransactionInput>;
};

export type StripeInvoiceCreateNestedOneWithoutLapsedPaymentInput = {
  connect?: Maybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceCreateOrConnectWithoutLapsedPaymentInput>;
  create?: Maybe<StripeInvoiceCreateWithoutLapsedPaymentInput>;
};

export type StripeInvoiceCreateNestedOneWithoutRelatedEnrollmentSupportEventsInput = {
  connect?: Maybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceCreateOrConnectWithoutRelatedEnrollmentSupportEventsInput>;
  create?: Maybe<StripeInvoiceCreateWithoutRelatedEnrollmentSupportEventsInput>;
};

export type StripeInvoiceCreateNestedOneWithoutRelatedStripeInvoiceItemsInput = {
  connect?: Maybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceCreateOrConnectWithoutRelatedStripeInvoiceItemsInput>;
  create?: Maybe<StripeInvoiceCreateWithoutRelatedStripeInvoiceItemsInput>;
};

export type StripeInvoiceCreateOrConnectWithoutCareStripeSubscriptionInput = {
  create: StripeInvoiceCreateWithoutCareStripeSubscriptionInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateOrConnectWithoutCareSubscriptionTrueUpsInput = {
  create: StripeInvoiceCreateWithoutCareSubscriptionTrueUpsInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateOrConnectWithoutEnrollmentPaymentInput = {
  create: StripeInvoiceCreateWithoutEnrollmentPaymentInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateOrConnectWithoutFinancialTransactionInput = {
  create: StripeInvoiceCreateWithoutFinancialTransactionInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateOrConnectWithoutLapsedPaymentInput = {
  create: StripeInvoiceCreateWithoutLapsedPaymentInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateOrConnectWithoutRelatedEnrollmentSupportEventsInput = {
  create: StripeInvoiceCreateWithoutRelatedEnrollmentSupportEventsInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateOrConnectWithoutRelatedStripeInvoiceItemsInput = {
  create: StripeInvoiceCreateWithoutRelatedStripeInvoiceItemsInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateOrConnectWithoutStripeCustomerInput = {
  create: StripeInvoiceCreateWithoutStripeCustomerInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateOrConnectWithoutStripePaymentMethodInput = {
  create: StripeInvoiceCreateWithoutStripePaymentMethodInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateWithoutCareStripeSubscriptionInput = {
  amount: Scalars['Int'];
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer: StripeCustomerCreateNestedOneWithoutInvoicesInput;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripeInvoicesInput>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateWithoutCareSubscriptionTrueUpsInput = {
  amount: Scalars['Int'];
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutInvoicesInput;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer: StripeCustomerCreateNestedOneWithoutInvoicesInput;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripeInvoicesInput>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateWithoutEnrollmentPaymentInput = {
  amount: Scalars['Int'];
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutInvoicesInput;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer: StripeCustomerCreateNestedOneWithoutInvoicesInput;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripeInvoicesInput>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateWithoutFinancialTransactionInput = {
  amount: Scalars['Int'];
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutInvoicesInput;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer: StripeCustomerCreateNestedOneWithoutInvoicesInput;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripeInvoicesInput>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateWithoutLapsedPaymentInput = {
  amount: Scalars['Int'];
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutInvoicesInput;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer: StripeCustomerCreateNestedOneWithoutInvoicesInput;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripeInvoicesInput>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateWithoutRelatedEnrollmentSupportEventsInput = {
  amount: Scalars['Int'];
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutInvoicesInput;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer: StripeCustomerCreateNestedOneWithoutInvoicesInput;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripeInvoicesInput>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateWithoutRelatedStripeInvoiceItemsInput = {
  amount: Scalars['Int'];
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutInvoicesInput;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRelatedInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer: StripeCustomerCreateNestedOneWithoutInvoicesInput;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripeInvoicesInput>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateWithoutStripeCustomerInput = {
  amount: Scalars['Int'];
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutInvoicesInput;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripeInvoicesInput>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceCreateWithoutStripePaymentMethodInput = {
  amount: Scalars['Int'];
  careStripeSubscription: CareStripeSubscriptionCreateNestedOneWithoutInvoicesInput;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer: StripeCustomerCreateNestedOneWithoutInvoicesInput;
  stripeId: Scalars['String'];
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceGroupByOutputType = {
  __typename?: 'StripeInvoiceGroupByOutputType';
  _avg?: Maybe<StripeInvoiceAvgAggregateOutputType>;
  _count?: Maybe<StripeInvoiceCountAggregateOutputType>;
  _max?: Maybe<StripeInvoiceMaxAggregateOutputType>;
  _min?: Maybe<StripeInvoiceMinAggregateOutputType>;
  _sum?: Maybe<StripeInvoiceSumAggregateOutputType>;
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  collectionMethod: StripeCollectionMethod;
  createdAt: Scalars['DateTime'];
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount: Scalars['Int'];
  serviceFeePercent: Scalars['Float'];
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type StripeInvoiceItem = {
  __typename?: 'StripeInvoiceItem';
  _count: StripeInvoiceItemCountOutputType;
  amount: Scalars['Int'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  enrollmentToStripeInvoiceItems: Array<CareEnrollmentToStripeInvoiceItem>;
  id: Scalars['String'];
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  quantity: Scalars['Int'];
  stripeId: Scalars['String'];
  stripeInvoice: StripeInvoice;
  stripeInvoiceId: Scalars['String'];
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount: Scalars['Int'];
};


export type StripeInvoiceItemEnrollmentToStripeInvoiceItemsArgs = {
  cursor?: Maybe<CareEnrollmentToStripeInvoiceItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareEnrollmentToStripeInvoiceItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareEnrollmentToStripeInvoiceItemWhereInput>;
};

export type StripeInvoiceItemAvgAggregateOutputType = {
  __typename?: 'StripeInvoiceItemAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  unitAmount?: Maybe<Scalars['Float']>;
};

export type StripeInvoiceItemAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  unitAmount?: Maybe<SortOrder>;
};

export type StripeInvoiceItemCountAggregateOutputType = {
  __typename?: 'StripeInvoiceItemCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  date: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  periodEnd: Scalars['Int'];
  periodStart: Scalars['Int'];
  quantity: Scalars['Int'];
  stripeId: Scalars['Int'];
  stripeInvoiceId: Scalars['Int'];
  stripeSubscriptionItemId: Scalars['Int'];
  unitAmount: Scalars['Int'];
};

export type StripeInvoiceItemCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  periodEnd?: Maybe<SortOrder>;
  periodStart?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  unitAmount?: Maybe<SortOrder>;
};

export type StripeInvoiceItemCountOutputType = {
  __typename?: 'StripeInvoiceItemCountOutputType';
  enrollmentToStripeInvoiceItems: Scalars['Int'];
};

export type StripeInvoiceItemCreateInput = {
  amount: Scalars['Int'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutStripeInvoiceItemInput>;
  id?: Maybe<Scalars['String']>;
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  quantity: Scalars['Int'];
  stripeId: Scalars['String'];
  stripeInvoice: StripeInvoiceCreateNestedOneWithoutRelatedStripeInvoiceItemsInput;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount: Scalars['Int'];
};

export type StripeInvoiceItemCreateManyInput = {
  amount: Scalars['Int'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  quantity: Scalars['Int'];
  stripeId: Scalars['String'];
  stripeInvoiceId: Scalars['String'];
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount: Scalars['Int'];
};

export type StripeInvoiceItemCreateManyStripeInvoiceInput = {
  amount: Scalars['Int'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  quantity: Scalars['Int'];
  stripeId: Scalars['String'];
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount: Scalars['Int'];
};

export type StripeInvoiceItemCreateManyStripeInvoiceInputEnvelope = {
  data: Array<StripeInvoiceItemCreateManyStripeInvoiceInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeInvoiceItemCreateNestedManyWithoutStripeInvoiceInput = {
  connect?: Maybe<Array<StripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceItemCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: Maybe<Array<StripeInvoiceItemCreateWithoutStripeInvoiceInput>>;
  createMany?: Maybe<StripeInvoiceItemCreateManyStripeInvoiceInputEnvelope>;
};

export type StripeInvoiceItemCreateNestedOneWithoutEnrollmentToStripeInvoiceItemsInput = {
  connect?: Maybe<StripeInvoiceItemWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceItemCreateOrConnectWithoutEnrollmentToStripeInvoiceItemsInput>;
  create?: Maybe<StripeInvoiceItemCreateWithoutEnrollmentToStripeInvoiceItemsInput>;
};

export type StripeInvoiceItemCreateOrConnectWithoutEnrollmentToStripeInvoiceItemsInput = {
  create: StripeInvoiceItemCreateWithoutEnrollmentToStripeInvoiceItemsInput;
  where: StripeInvoiceItemWhereUniqueInput;
};

export type StripeInvoiceItemCreateOrConnectWithoutStripeInvoiceInput = {
  create: StripeInvoiceItemCreateWithoutStripeInvoiceInput;
  where: StripeInvoiceItemWhereUniqueInput;
};

export type StripeInvoiceItemCreateWithoutEnrollmentToStripeInvoiceItemsInput = {
  amount: Scalars['Int'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  quantity: Scalars['Int'];
  stripeId: Scalars['String'];
  stripeInvoice: StripeInvoiceCreateNestedOneWithoutRelatedStripeInvoiceItemsInput;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount: Scalars['Int'];
};

export type StripeInvoiceItemCreateWithoutStripeInvoiceInput = {
  amount: Scalars['Int'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemCreateNestedManyWithoutStripeInvoiceItemInput>;
  id?: Maybe<Scalars['String']>;
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  quantity: Scalars['Int'];
  stripeId: Scalars['String'];
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount: Scalars['Int'];
};

export type StripeInvoiceItemGroupByOutputType = {
  __typename?: 'StripeInvoiceItemGroupByOutputType';
  _avg?: Maybe<StripeInvoiceItemAvgAggregateOutputType>;
  _count?: Maybe<StripeInvoiceItemCountAggregateOutputType>;
  _max?: Maybe<StripeInvoiceItemMaxAggregateOutputType>;
  _min?: Maybe<StripeInvoiceItemMinAggregateOutputType>;
  _sum?: Maybe<StripeInvoiceItemSumAggregateOutputType>;
  amount: Scalars['Int'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  quantity: Scalars['Int'];
  stripeId: Scalars['String'];
  stripeInvoiceId: Scalars['String'];
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount: Scalars['Int'];
};

export type StripeInvoiceItemListRelationFilter = {
  every?: Maybe<StripeInvoiceItemWhereInput>;
  none?: Maybe<StripeInvoiceItemWhereInput>;
  some?: Maybe<StripeInvoiceItemWhereInput>;
};

export type StripeInvoiceItemMaxAggregateOutputType = {
  __typename?: 'StripeInvoiceItemMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['DateTime']>;
  periodStart?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceItemMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  periodEnd?: Maybe<SortOrder>;
  periodStart?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  unitAmount?: Maybe<SortOrder>;
};

export type StripeInvoiceItemMinAggregateOutputType = {
  __typename?: 'StripeInvoiceItemMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['DateTime']>;
  periodStart?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceItemMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  periodEnd?: Maybe<SortOrder>;
  periodStart?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  unitAmount?: Maybe<SortOrder>;
};

export type StripeInvoiceItemOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StripeInvoiceItemOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeInvoiceItemOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  periodEnd?: Maybe<SortOrder>;
  periodStart?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  unitAmount?: Maybe<SortOrder>;
};

export enum StripeInvoiceItemOrderByRelevanceFieldEnum {
  Description = 'description',
  Id = 'id',
  StripeId = 'stripeId',
  StripeInvoiceId = 'stripeInvoiceId',
  StripeSubscriptionItemId = 'stripeSubscriptionItemId'
}

export type StripeInvoiceItemOrderByRelevanceInput = {
  fields: Array<StripeInvoiceItemOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripeInvoiceItemOrderByWithAggregationInput = {
  _avg?: Maybe<StripeInvoiceItemAvgOrderByAggregateInput>;
  _count?: Maybe<StripeInvoiceItemCountOrderByAggregateInput>;
  _max?: Maybe<StripeInvoiceItemMaxOrderByAggregateInput>;
  _min?: Maybe<StripeInvoiceItemMinOrderByAggregateInput>;
  _sum?: Maybe<StripeInvoiceItemSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  periodEnd?: Maybe<SortOrder>;
  periodStart?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  unitAmount?: Maybe<SortOrder>;
};

export type StripeInvoiceItemOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeInvoiceItemOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  periodEnd?: Maybe<SortOrder>;
  periodStart?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  unitAmount?: Maybe<SortOrder>;
};

export type StripeInvoiceItemOrderByWithRelationInput = {
  _relevance?: Maybe<StripeInvoiceItemOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  periodEnd?: Maybe<SortOrder>;
  periodStart?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripeInvoice?: Maybe<StripeInvoiceOrderByWithRelationInput>;
  stripeInvoiceId?: Maybe<SortOrder>;
  stripeSubscriptionItemId?: Maybe<SortOrder>;
  unitAmount?: Maybe<SortOrder>;
};

export enum StripeInvoiceItemScalarFieldEnum {
  Amount = 'amount',
  Date = 'date',
  Description = 'description',
  Id = 'id',
  PeriodEnd = 'periodEnd',
  PeriodStart = 'periodStart',
  Quantity = 'quantity',
  StripeId = 'stripeId',
  StripeInvoiceId = 'stripeInvoiceId',
  StripeSubscriptionItemId = 'stripeSubscriptionItemId',
  UnitAmount = 'unitAmount'
}

export type StripeInvoiceItemScalarRelationFilter = {
  AND?: Maybe<Array<StripeInvoiceItemWhereInput>>;
  NOT?: Maybe<Array<StripeInvoiceItemWhereInput>>;
  OR?: Maybe<Array<StripeInvoiceItemWhereInput>>;
  amount?: Maybe<IntFilter>;
  date?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemListRelationFilter>;
  id?: Maybe<StringFilter>;
  periodEnd?: Maybe<DateTimeFilter>;
  periodStart?: Maybe<DateTimeFilter>;
  quantity?: Maybe<IntFilter>;
  stripeId?: Maybe<StringFilter>;
  stripeInvoice?: Maybe<StripeInvoiceScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  unitAmount?: Maybe<IntFilter>;
};

export type StripeInvoiceItemScalarWhereInput = {
  AND?: Maybe<Array<StripeInvoiceItemScalarWhereInput>>;
  NOT?: Maybe<Array<StripeInvoiceItemScalarWhereInput>>;
  OR?: Maybe<Array<StripeInvoiceItemScalarWhereInput>>;
  amount?: Maybe<IntFilter>;
  date?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  periodEnd?: Maybe<DateTimeFilter>;
  periodStart?: Maybe<DateTimeFilter>;
  quantity?: Maybe<IntFilter>;
  stripeId?: Maybe<StringFilter>;
  stripeInvoiceId?: Maybe<StringFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  unitAmount?: Maybe<IntFilter>;
};

export type StripeInvoiceItemScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripeInvoiceItemScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripeInvoiceItemScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripeInvoiceItemScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntWithAggregatesFilter>;
  date?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  periodEnd?: Maybe<DateTimeWithAggregatesFilter>;
  periodStart?: Maybe<DateTimeWithAggregatesFilter>;
  quantity?: Maybe<IntWithAggregatesFilter>;
  stripeId?: Maybe<StringWithAggregatesFilter>;
  stripeInvoiceId?: Maybe<StringWithAggregatesFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableWithAggregatesFilter>;
  unitAmount?: Maybe<IntWithAggregatesFilter>;
};

export type StripeInvoiceItemSumAggregateOutputType = {
  __typename?: 'StripeInvoiceItemSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceItemSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  unitAmount?: Maybe<SortOrder>;
};

export type StripeInvoiceItemUncheckedCreateInput = {
  amount: Scalars['Int'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceItemInput>;
  id?: Maybe<Scalars['String']>;
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  quantity: Scalars['Int'];
  stripeId: Scalars['String'];
  stripeInvoiceId: Scalars['String'];
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount: Scalars['Int'];
};

export type StripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceInput = {
  connect?: Maybe<Array<StripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceItemCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: Maybe<Array<StripeInvoiceItemCreateWithoutStripeInvoiceInput>>;
  createMany?: Maybe<StripeInvoiceItemCreateManyStripeInvoiceInputEnvelope>;
};

export type StripeInvoiceItemUncheckedCreateWithoutEnrollmentToStripeInvoiceItemsInput = {
  amount: Scalars['Int'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  quantity: Scalars['Int'];
  stripeId: Scalars['String'];
  stripeInvoiceId: Scalars['String'];
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount: Scalars['Int'];
};

export type StripeInvoiceItemUncheckedCreateWithoutStripeInvoiceInput = {
  amount: Scalars['Int'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceItemInput>;
  id?: Maybe<Scalars['String']>;
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  quantity: Scalars['Int'];
  stripeId: Scalars['String'];
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount: Scalars['Int'];
};

export type StripeInvoiceItemUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceItemNestedInput>;
  id?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['DateTime']>;
  periodStart?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceItemUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['DateTime']>;
  periodStart?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceInput = {
  amount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['DateTime']>;
  periodStart?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceNestedInput = {
  connect?: Maybe<Array<StripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceItemCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: Maybe<Array<StripeInvoiceItemCreateWithoutStripeInvoiceInput>>;
  createMany?: Maybe<StripeInvoiceItemCreateManyStripeInvoiceInputEnvelope>;
  delete?: Maybe<Array<StripeInvoiceItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeInvoiceItemScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeInvoiceItemWhereUniqueInput>>;
  set?: Maybe<Array<StripeInvoiceItemWhereUniqueInput>>;
  update?: Maybe<Array<StripeInvoiceItemUpdateWithWhereUniqueWithoutStripeInvoiceInput>>;
  updateMany?: Maybe<Array<StripeInvoiceItemUpdateManyWithWhereWithoutStripeInvoiceInput>>;
  upsert?: Maybe<Array<StripeInvoiceItemUpsertWithWhereUniqueWithoutStripeInvoiceInput>>;
};

export type StripeInvoiceItemUncheckedUpdateWithoutEnrollmentToStripeInvoiceItemsInput = {
  amount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['DateTime']>;
  periodStart?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceItemUncheckedUpdateWithoutStripeInvoiceInput = {
  amount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceItemNestedInput>;
  id?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['DateTime']>;
  periodStart?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceItemUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutStripeInvoiceItemNestedInput>;
  id?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['DateTime']>;
  periodStart?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneRequiredWithoutRelatedStripeInvoiceItemsNestedInput>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceItemUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['DateTime']>;
  periodStart?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceItemUpdateManyWithWhereWithoutStripeInvoiceInput = {
  data: StripeInvoiceItemUpdateManyMutationInput;
  where: StripeInvoiceItemScalarWhereInput;
};

export type StripeInvoiceItemUpdateManyWithoutStripeInvoiceNestedInput = {
  connect?: Maybe<Array<StripeInvoiceItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceItemCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: Maybe<Array<StripeInvoiceItemCreateWithoutStripeInvoiceInput>>;
  createMany?: Maybe<StripeInvoiceItemCreateManyStripeInvoiceInputEnvelope>;
  delete?: Maybe<Array<StripeInvoiceItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeInvoiceItemScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeInvoiceItemWhereUniqueInput>>;
  set?: Maybe<Array<StripeInvoiceItemWhereUniqueInput>>;
  update?: Maybe<Array<StripeInvoiceItemUpdateWithWhereUniqueWithoutStripeInvoiceInput>>;
  updateMany?: Maybe<Array<StripeInvoiceItemUpdateManyWithWhereWithoutStripeInvoiceInput>>;
  upsert?: Maybe<Array<StripeInvoiceItemUpsertWithWhereUniqueWithoutStripeInvoiceInput>>;
};

export type StripeInvoiceItemUpdateOneRequiredWithoutEnrollmentToStripeInvoiceItemsNestedInput = {
  connect?: Maybe<StripeInvoiceItemWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceItemCreateOrConnectWithoutEnrollmentToStripeInvoiceItemsInput>;
  create?: Maybe<StripeInvoiceItemCreateWithoutEnrollmentToStripeInvoiceItemsInput>;
  update?: Maybe<StripeInvoiceItemUpdateToOneWithWhereWithoutEnrollmentToStripeInvoiceItemsInput>;
  upsert?: Maybe<StripeInvoiceItemUpsertWithoutEnrollmentToStripeInvoiceItemsInput>;
};

export type StripeInvoiceItemUpdateToOneWithWhereWithoutEnrollmentToStripeInvoiceItemsInput = {
  data: StripeInvoiceItemUpdateWithoutEnrollmentToStripeInvoiceItemsInput;
  where?: Maybe<StripeInvoiceItemWhereInput>;
};

export type StripeInvoiceItemUpdateWithWhereUniqueWithoutStripeInvoiceInput = {
  data: StripeInvoiceItemUpdateWithoutStripeInvoiceInput;
  where: StripeInvoiceItemWhereUniqueInput;
};

export type StripeInvoiceItemUpdateWithoutEnrollmentToStripeInvoiceItemsInput = {
  amount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['DateTime']>;
  periodStart?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceUpdateOneRequiredWithoutRelatedStripeInvoiceItemsNestedInput>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceItemUpdateWithoutStripeInvoiceInput = {
  amount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemUpdateManyWithoutStripeInvoiceItemNestedInput>;
  id?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['DateTime']>;
  periodStart?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceItemUpsertWithWhereUniqueWithoutStripeInvoiceInput = {
  create: StripeInvoiceItemCreateWithoutStripeInvoiceInput;
  update: StripeInvoiceItemUpdateWithoutStripeInvoiceInput;
  where: StripeInvoiceItemWhereUniqueInput;
};

export type StripeInvoiceItemUpsertWithoutEnrollmentToStripeInvoiceItemsInput = {
  create: StripeInvoiceItemCreateWithoutEnrollmentToStripeInvoiceItemsInput;
  update: StripeInvoiceItemUpdateWithoutEnrollmentToStripeInvoiceItemsInput;
  where?: Maybe<StripeInvoiceItemWhereInput>;
};

export type StripeInvoiceItemWhereInput = {
  AND?: Maybe<Array<StripeInvoiceItemWhereInput>>;
  NOT?: Maybe<Array<StripeInvoiceItemWhereInput>>;
  OR?: Maybe<Array<StripeInvoiceItemWhereInput>>;
  amount?: Maybe<IntFilter>;
  date?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemListRelationFilter>;
  id?: Maybe<StringFilter>;
  periodEnd?: Maybe<DateTimeFilter>;
  periodStart?: Maybe<DateTimeFilter>;
  quantity?: Maybe<IntFilter>;
  stripeId?: Maybe<StringFilter>;
  stripeInvoice?: Maybe<StripeInvoiceScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  unitAmount?: Maybe<IntFilter>;
};

export type StripeInvoiceItemWhereUniqueInput = {
  AND?: Maybe<Array<StripeInvoiceItemWhereInput>>;
  NOT?: Maybe<Array<StripeInvoiceItemWhereInput>>;
  OR?: Maybe<Array<StripeInvoiceItemWhereInput>>;
  amount?: Maybe<IntFilter>;
  date?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  enrollmentToStripeInvoiceItems?: Maybe<CareEnrollmentToStripeInvoiceItemListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<DateTimeFilter>;
  periodStart?: Maybe<DateTimeFilter>;
  quantity?: Maybe<IntFilter>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoice?: Maybe<StripeInvoiceScalarRelationFilter>;
  stripeInvoiceId?: Maybe<StringFilter>;
  stripeSubscriptionItemId?: Maybe<StringNullableFilter>;
  unitAmount?: Maybe<IntFilter>;
};

export type StripeInvoiceListRelationFilter = {
  every?: Maybe<StripeInvoiceWhereInput>;
  none?: Maybe<StripeInvoiceWhereInput>;
  some?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceMaxAggregateOutputType = {
  __typename?: 'StripeInvoiceMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  collectionMethod?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  serviceFeePercent?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeChargeId?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeInvoiceMinAggregateOutputType = {
  __typename?: 'StripeInvoiceMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  collectionMethod?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  serviceFeePercent?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeChargeId?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeInvoiceNullableScalarRelationFilter = {
  AND?: Maybe<Array<StripeInvoiceWhereInput>>;
  NOT?: Maybe<Array<StripeInvoiceWhereInput>>;
  OR?: Maybe<Array<StripeInvoiceWhereInput>>;
  amount?: Maybe<IntFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  collectionMethod?: Maybe<EnumStripeCollectionMethodFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  dueAt?: Maybe<DateTimeNullableFilter>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentListRelationFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  lapsedPayment?: Maybe<CareLapsedPaymentNullableScalarRelationFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemListRelationFilter>;
  serviceFeeAmount?: Maybe<IntFilter>;
  serviceFeePercent?: Maybe<FloatFilter>;
  status?: Maybe<EnumStripeInvoiceStatusFilter>;
  stripeChargeId?: Maybe<StringNullableFilter>;
  stripeCustomer?: Maybe<StripeCustomerScalarRelationFilter>;
  stripeCustomerId?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  total?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeInvoiceOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StripeInvoiceOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeInvoiceOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpOrderByRelationAggregateInput>;
  collectionMethod?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentOrderByRelationAggregateInput>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lapsedPayment?: Maybe<CareLapsedPaymentOrderByWithRelationInput>;
  paidAt?: Maybe<SortOrder>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemOrderByRelationAggregateInput>;
  serviceFeeAmount?: Maybe<SortOrder>;
  serviceFeePercent?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeChargeId?: Maybe<SortOrder>;
  stripeCustomer?: Maybe<StripeCustomerOrderByWithRelationInput>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethod?: Maybe<StripePaymentMethodOrderByWithRelationInput>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeInvoiceOrderByRelevanceFieldEnum {
  CareStripeSubscriptionId = 'careStripeSubscriptionId',
  Id = 'id',
  StripeChargeId = 'stripeChargeId',
  StripeCustomerId = 'stripeCustomerId',
  StripeId = 'stripeId',
  StripePaymentMethodId = 'stripePaymentMethodId'
}

export type StripeInvoiceOrderByRelevanceInput = {
  fields: Array<StripeInvoiceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripeInvoiceOrderByWithAggregationInput = {
  _avg?: Maybe<StripeInvoiceAvgOrderByAggregateInput>;
  _count?: Maybe<StripeInvoiceCountOrderByAggregateInput>;
  _max?: Maybe<StripeInvoiceMaxOrderByAggregateInput>;
  _min?: Maybe<StripeInvoiceMinOrderByAggregateInput>;
  _sum?: Maybe<StripeInvoiceSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  collectionMethod?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  serviceFeePercent?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeChargeId?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeInvoiceOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeInvoiceOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpOrderByRelationAggregateInput>;
  collectionMethod?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentOrderByRelationAggregateInput>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lapsedPayment?: Maybe<CareLapsedPaymentOrderByWithRelationInput>;
  paidAt?: Maybe<SortOrder>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemOrderByRelationAggregateInput>;
  serviceFeeAmount?: Maybe<SortOrder>;
  serviceFeePercent?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeChargeId?: Maybe<SortOrder>;
  stripeCustomer?: Maybe<StripeCustomerOrderByWithRelationInput>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethod?: Maybe<StripePaymentMethodOrderByWithRelationInput>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeInvoiceOrderByWithRelationInput = {
  _relevance?: Maybe<StripeInvoiceOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionOrderByWithRelationInput>;
  careStripeSubscriptionId?: Maybe<SortOrder>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpOrderByRelationAggregateInput>;
  collectionMethod?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  dueAt?: Maybe<SortOrder>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentOrderByRelationAggregateInput>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lapsedPayment?: Maybe<CareLapsedPaymentOrderByWithRelationInput>;
  paidAt?: Maybe<SortOrder>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemOrderByRelationAggregateInput>;
  serviceFeeAmount?: Maybe<SortOrder>;
  serviceFeePercent?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeChargeId?: Maybe<SortOrder>;
  stripeCustomer?: Maybe<StripeCustomerOrderByWithRelationInput>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethod?: Maybe<StripePaymentMethodOrderByWithRelationInput>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeInvoiceScalarFieldEnum {
  Amount = 'amount',
  CareStripeSubscriptionId = 'careStripeSubscriptionId',
  CollectionMethod = 'collectionMethod',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  DueAt = 'dueAt',
  FundsAvailableAt = 'fundsAvailableAt',
  Id = 'id',
  PaidAt = 'paidAt',
  ServiceFeeAmount = 'serviceFeeAmount',
  ServiceFeePercent = 'serviceFeePercent',
  Status = 'status',
  StripeChargeId = 'stripeChargeId',
  StripeCustomerId = 'stripeCustomerId',
  StripeId = 'stripeId',
  StripePaymentMethodId = 'stripePaymentMethodId',
  Total = 'total',
  UpdatedAt = 'updatedAt'
}

export type StripeInvoiceScalarRelationFilter = {
  AND?: Maybe<Array<StripeInvoiceWhereInput>>;
  NOT?: Maybe<Array<StripeInvoiceWhereInput>>;
  OR?: Maybe<Array<StripeInvoiceWhereInput>>;
  amount?: Maybe<IntFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  collectionMethod?: Maybe<EnumStripeCollectionMethodFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  dueAt?: Maybe<DateTimeNullableFilter>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentListRelationFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  lapsedPayment?: Maybe<CareLapsedPaymentNullableScalarRelationFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemListRelationFilter>;
  serviceFeeAmount?: Maybe<IntFilter>;
  serviceFeePercent?: Maybe<FloatFilter>;
  status?: Maybe<EnumStripeInvoiceStatusFilter>;
  stripeChargeId?: Maybe<StringNullableFilter>;
  stripeCustomer?: Maybe<StripeCustomerScalarRelationFilter>;
  stripeCustomerId?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  total?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeInvoiceScalarWhereInput = {
  AND?: Maybe<Array<StripeInvoiceScalarWhereInput>>;
  NOT?: Maybe<Array<StripeInvoiceScalarWhereInput>>;
  OR?: Maybe<Array<StripeInvoiceScalarWhereInput>>;
  amount?: Maybe<IntFilter>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  collectionMethod?: Maybe<EnumStripeCollectionMethodFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  dueAt?: Maybe<DateTimeNullableFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  serviceFeeAmount?: Maybe<IntFilter>;
  serviceFeePercent?: Maybe<FloatFilter>;
  status?: Maybe<EnumStripeInvoiceStatusFilter>;
  stripeChargeId?: Maybe<StringNullableFilter>;
  stripeCustomerId?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  total?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeInvoiceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripeInvoiceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripeInvoiceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripeInvoiceScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntWithAggregatesFilter>;
  careStripeSubscriptionId?: Maybe<StringWithAggregatesFilter>;
  collectionMethod?: Maybe<EnumStripeCollectionMethodWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  currency?: Maybe<EnumCurrencyWithAggregatesFilter>;
  dueAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  paidAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  serviceFeeAmount?: Maybe<IntWithAggregatesFilter>;
  serviceFeePercent?: Maybe<FloatWithAggregatesFilter>;
  status?: Maybe<EnumStripeInvoiceStatusWithAggregatesFilter>;
  stripeChargeId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeCustomerId?: Maybe<StringWithAggregatesFilter>;
  stripeId?: Maybe<StringWithAggregatesFilter>;
  stripePaymentMethodId?: Maybe<StringNullableWithAggregatesFilter>;
  total?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum StripeInvoiceStatus {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export type StripeInvoiceSumAggregateOutputType = {
  __typename?: 'StripeInvoiceSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Int']>;
};

export type StripeInvoiceSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  serviceFeePercent?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
};

export type StripeInvoiceUncheckedCreateInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedCreateNestedManyWithoutCareStripeSubscriptionInput = {
  connect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<StripeInvoiceCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<StripeInvoiceCreateManyCareStripeSubscriptionInputEnvelope>;
};

export type StripeInvoiceUncheckedCreateNestedManyWithoutStripeCustomerInput = {
  connect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<StripeInvoiceCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<StripeInvoiceCreateManyStripeCustomerInputEnvelope>;
};

export type StripeInvoiceUncheckedCreateNestedManyWithoutStripePaymentMethodInput = {
  connect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<StripeInvoiceCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<StripeInvoiceCreateManyStripePaymentMethodInputEnvelope>;
};

export type StripeInvoiceUncheckedCreateWithoutCareStripeSubscriptionInput = {
  amount: Scalars['Int'];
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedCreateWithoutCareSubscriptionTrueUpsInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedCreateWithoutEnrollmentPaymentInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedCreateWithoutFinancialTransactionInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedCreateWithoutLapsedPaymentInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedCreateWithoutRelatedEnrollmentSupportEventsInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedCreateWithoutRelatedStripeInvoiceItemsInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRelatedInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedCreateWithoutStripeCustomerInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedCreateWithoutStripePaymentMethodInput = {
  amount: Scalars['Int'];
  careStripeSubscriptionId: Scalars['String'];
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  collectionMethod: StripeCollectionMethod;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Currency;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedCreateNestedOneWithoutStripeInvoiceInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRelatedInvoiceInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedCreateNestedManyWithoutStripeInvoiceInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status: StripeInvoiceStatus;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeId: Scalars['String'];
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateManyWithoutCareStripeSubscriptionInput = {
  amount?: Maybe<Scalars['Int']>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateManyWithoutCareStripeSubscriptionNestedInput = {
  connect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<StripeInvoiceCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<StripeInvoiceCreateManyCareStripeSubscriptionInputEnvelope>;
  delete?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeInvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  set?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  update?: Maybe<Array<StripeInvoiceUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
  updateMany?: Maybe<Array<StripeInvoiceUpdateManyWithWhereWithoutCareStripeSubscriptionInput>>;
  upsert?: Maybe<Array<StripeInvoiceUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
};

export type StripeInvoiceUncheckedUpdateManyWithoutStripeCustomerInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateManyWithoutStripeCustomerNestedInput = {
  connect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<StripeInvoiceCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<StripeInvoiceCreateManyStripeCustomerInputEnvelope>;
  delete?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeInvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  set?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  update?: Maybe<Array<StripeInvoiceUpdateWithWhereUniqueWithoutStripeCustomerInput>>;
  updateMany?: Maybe<Array<StripeInvoiceUpdateManyWithWhereWithoutStripeCustomerInput>>;
  upsert?: Maybe<Array<StripeInvoiceUpsertWithWhereUniqueWithoutStripeCustomerInput>>;
};

export type StripeInvoiceUncheckedUpdateManyWithoutStripePaymentMethodInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateManyWithoutStripePaymentMethodNestedInput = {
  connect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<StripeInvoiceCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<StripeInvoiceCreateManyStripePaymentMethodInputEnvelope>;
  delete?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeInvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  set?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  update?: Maybe<Array<StripeInvoiceUpdateWithWhereUniqueWithoutStripePaymentMethodInput>>;
  updateMany?: Maybe<Array<StripeInvoiceUpdateManyWithWhereWithoutStripePaymentMethodInput>>;
  upsert?: Maybe<Array<StripeInvoiceUpsertWithWhereUniqueWithoutStripePaymentMethodInput>>;
};

export type StripeInvoiceUncheckedUpdateWithoutCareStripeSubscriptionInput = {
  amount?: Maybe<Scalars['Int']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateWithoutCareSubscriptionTrueUpsInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateWithoutEnrollmentPaymentInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateWithoutFinancialTransactionInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateWithoutLapsedPaymentInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateWithoutRelatedEnrollmentSupportEventsInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateWithoutRelatedStripeInvoiceItemsInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRelatedInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateWithoutStripeCustomerInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUncheckedUpdateWithoutStripePaymentMethodInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscriptionId?: Maybe<Scalars['String']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUncheckedUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUncheckedUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutInvoicesNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneRequiredWithoutInvoicesNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripeInvoicesNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUpdateManyWithWhereWithoutCareStripeSubscriptionInput = {
  data: StripeInvoiceUpdateManyMutationInput;
  where: StripeInvoiceScalarWhereInput;
};

export type StripeInvoiceUpdateManyWithWhereWithoutStripeCustomerInput = {
  data: StripeInvoiceUpdateManyMutationInput;
  where: StripeInvoiceScalarWhereInput;
};

export type StripeInvoiceUpdateManyWithWhereWithoutStripePaymentMethodInput = {
  data: StripeInvoiceUpdateManyMutationInput;
  where: StripeInvoiceScalarWhereInput;
};

export type StripeInvoiceUpdateManyWithoutCareStripeSubscriptionNestedInput = {
  connect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceCreateOrConnectWithoutCareStripeSubscriptionInput>>;
  create?: Maybe<Array<StripeInvoiceCreateWithoutCareStripeSubscriptionInput>>;
  createMany?: Maybe<StripeInvoiceCreateManyCareStripeSubscriptionInputEnvelope>;
  delete?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeInvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  set?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  update?: Maybe<Array<StripeInvoiceUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
  updateMany?: Maybe<Array<StripeInvoiceUpdateManyWithWhereWithoutCareStripeSubscriptionInput>>;
  upsert?: Maybe<Array<StripeInvoiceUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput>>;
};

export type StripeInvoiceUpdateManyWithoutStripeCustomerNestedInput = {
  connect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<StripeInvoiceCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<StripeInvoiceCreateManyStripeCustomerInputEnvelope>;
  delete?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeInvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  set?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  update?: Maybe<Array<StripeInvoiceUpdateWithWhereUniqueWithoutStripeCustomerInput>>;
  updateMany?: Maybe<Array<StripeInvoiceUpdateManyWithWhereWithoutStripeCustomerInput>>;
  upsert?: Maybe<Array<StripeInvoiceUpsertWithWhereUniqueWithoutStripeCustomerInput>>;
};

export type StripeInvoiceUpdateManyWithoutStripePaymentMethodNestedInput = {
  connect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeInvoiceCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<StripeInvoiceCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<StripeInvoiceCreateManyStripePaymentMethodInputEnvelope>;
  delete?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeInvoiceScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  set?: Maybe<Array<StripeInvoiceWhereUniqueInput>>;
  update?: Maybe<Array<StripeInvoiceUpdateWithWhereUniqueWithoutStripePaymentMethodInput>>;
  updateMany?: Maybe<Array<StripeInvoiceUpdateManyWithWhereWithoutStripePaymentMethodInput>>;
  upsert?: Maybe<Array<StripeInvoiceUpsertWithWhereUniqueWithoutStripePaymentMethodInput>>;
};

export type StripeInvoiceUpdateOneRequiredWithoutLapsedPaymentNestedInput = {
  connect?: Maybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceCreateOrConnectWithoutLapsedPaymentInput>;
  create?: Maybe<StripeInvoiceCreateWithoutLapsedPaymentInput>;
  update?: Maybe<StripeInvoiceUpdateToOneWithWhereWithoutLapsedPaymentInput>;
  upsert?: Maybe<StripeInvoiceUpsertWithoutLapsedPaymentInput>;
};

export type StripeInvoiceUpdateOneRequiredWithoutRelatedStripeInvoiceItemsNestedInput = {
  connect?: Maybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceCreateOrConnectWithoutRelatedStripeInvoiceItemsInput>;
  create?: Maybe<StripeInvoiceCreateWithoutRelatedStripeInvoiceItemsInput>;
  update?: Maybe<StripeInvoiceUpdateToOneWithWhereWithoutRelatedStripeInvoiceItemsInput>;
  upsert?: Maybe<StripeInvoiceUpsertWithoutRelatedStripeInvoiceItemsInput>;
};

export type StripeInvoiceUpdateOneWithoutCareSubscriptionTrueUpsNestedInput = {
  connect?: Maybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceCreateOrConnectWithoutCareSubscriptionTrueUpsInput>;
  create?: Maybe<StripeInvoiceCreateWithoutCareSubscriptionTrueUpsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeInvoiceUpdateToOneWithWhereWithoutCareSubscriptionTrueUpsInput>;
  upsert?: Maybe<StripeInvoiceUpsertWithoutCareSubscriptionTrueUpsInput>;
};

export type StripeInvoiceUpdateOneWithoutEnrollmentPaymentNestedInput = {
  connect?: Maybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceCreateOrConnectWithoutEnrollmentPaymentInput>;
  create?: Maybe<StripeInvoiceCreateWithoutEnrollmentPaymentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeInvoiceUpdateToOneWithWhereWithoutEnrollmentPaymentInput>;
  upsert?: Maybe<StripeInvoiceUpsertWithoutEnrollmentPaymentInput>;
};

export type StripeInvoiceUpdateOneWithoutFinancialTransactionNestedInput = {
  connect?: Maybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceCreateOrConnectWithoutFinancialTransactionInput>;
  create?: Maybe<StripeInvoiceCreateWithoutFinancialTransactionInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeInvoiceUpdateToOneWithWhereWithoutFinancialTransactionInput>;
  upsert?: Maybe<StripeInvoiceUpsertWithoutFinancialTransactionInput>;
};

export type StripeInvoiceUpdateOneWithoutRelatedEnrollmentSupportEventsNestedInput = {
  connect?: Maybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeInvoiceCreateOrConnectWithoutRelatedEnrollmentSupportEventsInput>;
  create?: Maybe<StripeInvoiceCreateWithoutRelatedEnrollmentSupportEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeInvoiceUpdateToOneWithWhereWithoutRelatedEnrollmentSupportEventsInput>;
  upsert?: Maybe<StripeInvoiceUpsertWithoutRelatedEnrollmentSupportEventsInput>;
};

export type StripeInvoiceUpdateToOneWithWhereWithoutCareSubscriptionTrueUpsInput = {
  data: StripeInvoiceUpdateWithoutCareSubscriptionTrueUpsInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceUpdateToOneWithWhereWithoutEnrollmentPaymentInput = {
  data: StripeInvoiceUpdateWithoutEnrollmentPaymentInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceUpdateToOneWithWhereWithoutFinancialTransactionInput = {
  data: StripeInvoiceUpdateWithoutFinancialTransactionInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceUpdateToOneWithWhereWithoutLapsedPaymentInput = {
  data: StripeInvoiceUpdateWithoutLapsedPaymentInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceUpdateToOneWithWhereWithoutRelatedEnrollmentSupportEventsInput = {
  data: StripeInvoiceUpdateWithoutRelatedEnrollmentSupportEventsInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceUpdateToOneWithWhereWithoutRelatedStripeInvoiceItemsInput = {
  data: StripeInvoiceUpdateWithoutRelatedStripeInvoiceItemsInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceUpdateWithWhereUniqueWithoutCareStripeSubscriptionInput = {
  data: StripeInvoiceUpdateWithoutCareStripeSubscriptionInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpdateWithWhereUniqueWithoutStripeCustomerInput = {
  data: StripeInvoiceUpdateWithoutStripeCustomerInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpdateWithWhereUniqueWithoutStripePaymentMethodInput = {
  data: StripeInvoiceUpdateWithoutStripePaymentMethodInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpdateWithoutCareStripeSubscriptionInput = {
  amount?: Maybe<Scalars['Int']>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneRequiredWithoutInvoicesNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripeInvoicesNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUpdateWithoutCareSubscriptionTrueUpsInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutInvoicesNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneRequiredWithoutInvoicesNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripeInvoicesNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUpdateWithoutEnrollmentPaymentInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutInvoicesNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneRequiredWithoutInvoicesNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripeInvoicesNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUpdateWithoutFinancialTransactionInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutInvoicesNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateManyWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneRequiredWithoutInvoicesNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripeInvoicesNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUpdateWithoutLapsedPaymentInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutInvoicesNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneRequiredWithoutInvoicesNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripeInvoicesNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUpdateWithoutRelatedEnrollmentSupportEventsInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutInvoicesNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneRequiredWithoutInvoicesNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripeInvoicesNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUpdateWithoutRelatedStripeInvoiceItemsInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutInvoicesNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRelatedInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneRequiredWithoutInvoicesNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripeInvoicesNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUpdateWithoutStripeCustomerInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutInvoicesNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripeInvoicesNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUpdateWithoutStripePaymentMethodInput = {
  amount?: Maybe<Scalars['Int']>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionUpdateOneRequiredWithoutInvoicesNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripeInvoiceNestedInput>;
  collectionMethod?: Maybe<StripeCollectionMethod>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  dueAt?: Maybe<Scalars['DateTime']>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateManyWithoutStripeInvoiceNestedInput>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeInvoiceNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentUpdateOneWithoutStripeInvoiceNestedInput>;
  paidAt?: Maybe<Scalars['DateTime']>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRelatedInvoiceNestedInput>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemUpdateManyWithoutStripeInvoiceNestedInput>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  status?: Maybe<StripeInvoiceStatus>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneRequiredWithoutInvoicesNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeInvoiceUpsertWithWhereUniqueWithoutCareStripeSubscriptionInput = {
  create: StripeInvoiceCreateWithoutCareStripeSubscriptionInput;
  update: StripeInvoiceUpdateWithoutCareStripeSubscriptionInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpsertWithWhereUniqueWithoutStripeCustomerInput = {
  create: StripeInvoiceCreateWithoutStripeCustomerInput;
  update: StripeInvoiceUpdateWithoutStripeCustomerInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpsertWithWhereUniqueWithoutStripePaymentMethodInput = {
  create: StripeInvoiceCreateWithoutStripePaymentMethodInput;
  update: StripeInvoiceUpdateWithoutStripePaymentMethodInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpsertWithoutCareSubscriptionTrueUpsInput = {
  create: StripeInvoiceCreateWithoutCareSubscriptionTrueUpsInput;
  update: StripeInvoiceUpdateWithoutCareSubscriptionTrueUpsInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceUpsertWithoutEnrollmentPaymentInput = {
  create: StripeInvoiceCreateWithoutEnrollmentPaymentInput;
  update: StripeInvoiceUpdateWithoutEnrollmentPaymentInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceUpsertWithoutFinancialTransactionInput = {
  create: StripeInvoiceCreateWithoutFinancialTransactionInput;
  update: StripeInvoiceUpdateWithoutFinancialTransactionInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceUpsertWithoutLapsedPaymentInput = {
  create: StripeInvoiceCreateWithoutLapsedPaymentInput;
  update: StripeInvoiceUpdateWithoutLapsedPaymentInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceUpsertWithoutRelatedEnrollmentSupportEventsInput = {
  create: StripeInvoiceCreateWithoutRelatedEnrollmentSupportEventsInput;
  update: StripeInvoiceUpdateWithoutRelatedEnrollmentSupportEventsInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceUpsertWithoutRelatedStripeInvoiceItemsInput = {
  create: StripeInvoiceCreateWithoutRelatedStripeInvoiceItemsInput;
  update: StripeInvoiceUpdateWithoutRelatedStripeInvoiceItemsInput;
  where?: Maybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceWhereInput = {
  AND?: Maybe<Array<StripeInvoiceWhereInput>>;
  NOT?: Maybe<Array<StripeInvoiceWhereInput>>;
  OR?: Maybe<Array<StripeInvoiceWhereInput>>;
  amount?: Maybe<IntFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  collectionMethod?: Maybe<EnumStripeCollectionMethodFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  dueAt?: Maybe<DateTimeNullableFilter>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentListRelationFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  lapsedPayment?: Maybe<CareLapsedPaymentNullableScalarRelationFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemListRelationFilter>;
  serviceFeeAmount?: Maybe<IntFilter>;
  serviceFeePercent?: Maybe<FloatFilter>;
  status?: Maybe<EnumStripeInvoiceStatusFilter>;
  stripeChargeId?: Maybe<StringNullableFilter>;
  stripeCustomer?: Maybe<StripeCustomerScalarRelationFilter>;
  stripeCustomerId?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  total?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeInvoiceWhereUniqueInput = {
  AND?: Maybe<Array<StripeInvoiceWhereInput>>;
  NOT?: Maybe<Array<StripeInvoiceWhereInput>>;
  OR?: Maybe<Array<StripeInvoiceWhereInput>>;
  amount?: Maybe<IntFilter>;
  careStripeSubscription?: Maybe<CareStripeSubscriptionScalarRelationFilter>;
  careStripeSubscriptionId?: Maybe<StringFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  collectionMethod?: Maybe<EnumStripeCollectionMethodFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currency?: Maybe<EnumCurrencyFilter>;
  dueAt?: Maybe<DateTimeNullableFilter>;
  enrollmentPayment?: Maybe<CareEnrollmentPaymentListRelationFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  lapsedPayment?: Maybe<CareLapsedPaymentNullableScalarRelationFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  relatedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  relatedStripeInvoiceItems?: Maybe<StripeInvoiceItemListRelationFilter>;
  serviceFeeAmount?: Maybe<IntFilter>;
  serviceFeePercent?: Maybe<FloatFilter>;
  status?: Maybe<EnumStripeInvoiceStatusFilter>;
  stripeChargeId?: Maybe<StringNullableFilter>;
  stripeCustomer?: Maybe<StripeCustomerScalarRelationFilter>;
  stripeCustomerId?: Maybe<StringFilter>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  total?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePayment = {
  __typename?: 'StripePayment';
  amount: Scalars['Int'];
  amountCaptured?: Maybe<Scalars['Int']>;
  amountRefunded?: Maybe<Scalars['Int']>;
  fees?: Maybe<StripePaymentFees>;
  id: Scalars['String'];
  receiptUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  total?: Maybe<Scalars['Int']>;
  transferType?: Maybe<Scalars['String']>;
};

export enum StripePaymentError {
  Blocked = 'Blocked',
  CardNotSupported = 'CardNotSupported',
  CurrencyNotSupported = 'CurrencyNotSupported',
  DuplicateTransaction = 'DuplicateTransaction',
  ExpiredCard = 'ExpiredCard',
  Fraudulent = 'Fraudulent',
  GenericDecline = 'GenericDecline',
  IncorrectCvc = 'IncorrectCVC',
  IncorrectNumber = 'IncorrectNumber',
  IncorrectPin = 'IncorrectPIN',
  IncorrectPostalCode = 'IncorrectPostalCode',
  InsufficientFunds = 'InsufficientFunds',
  InvalidAccount = 'InvalidAccount',
  InvalidExpiry = 'InvalidExpiry',
  LostStolenCard = 'LostStolenCard'
}

export type StripePaymentFees = {
  __typename?: 'StripePaymentFees';
  clientServiceFeeAmount: Scalars['Int'];
  clientServiceFeePercent: Scalars['Float'];
  clinicServiceFeeAmount: Scalars['Int'];
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
};

export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  StripeDispute: Array<StripeDispute>;
  _count: StripePaymentIntentCountOutputType;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunAction>;
  captureType: ChargeCaptureType;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntent>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransaction>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  invoices: Array<Invoice>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<User>;
  sentByAutomation: Scalars['Boolean'];
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status: StripePaymentIntentStatus;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayout?: Maybe<StripePayout>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceipt?: Maybe<StripeReceipt>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds: Array<StripeRefund>;
  stripeTerminal?: Maybe<StripeTerminal>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks: Array<Task>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType: StripePaymentTransferType;
  updatedAt: Scalars['DateTime'];
  writebackLogEntries: Array<PaymentPimsWritebackLogEntry>;
};


export type StripePaymentIntentStripeDisputeArgs = {
  cursor?: Maybe<StripeDisputeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeDisputeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeDisputeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeDisputeWhereInput>;
};


export type StripePaymentIntentAutomationRunActionArgs = {
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type StripePaymentIntentCareAccountCreditIntentArgs = {
  where?: Maybe<CareAccountCreditIntentWhereInput>;
};


export type StripePaymentIntentClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type StripePaymentIntentClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type StripePaymentIntentFinancialTransactionArgs = {
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type StripePaymentIntentInvoicesArgs = {
  cursor?: Maybe<InvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceWhereInput>;
};


export type StripePaymentIntentSentByArgs = {
  where?: Maybe<UserWhereInput>;
};


export type StripePaymentIntentStripePaymentMethodArgs = {
  where?: Maybe<StripePaymentMethodWhereInput>;
};


export type StripePaymentIntentStripePayoutArgs = {
  where?: Maybe<StripePayoutWhereInput>;
};


export type StripePaymentIntentStripeReceiptArgs = {
  where?: Maybe<StripeReceiptWhereInput>;
};


export type StripePaymentIntentStripeRefundsArgs = {
  cursor?: Maybe<StripeRefundWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeRefundScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeRefundOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeRefundWhereInput>;
};


export type StripePaymentIntentStripeTerminalArgs = {
  where?: Maybe<StripeTerminalWhereInput>;
};


export type StripePaymentIntentTasksArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaskScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaskOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaskWhereInput>;
};


export type StripePaymentIntentWritebackLogEntriesArgs = {
  cursor?: Maybe<PaymentPimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PaymentPimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PaymentPimsWritebackLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PaymentPimsWritebackLogEntryWhereInput>;
};

export type StripePaymentIntentAvgAggregateOutputType = {
  __typename?: 'StripePaymentIntentAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  amountCaptured?: Maybe<Scalars['Float']>;
  clientServiceFee?: Maybe<Scalars['Float']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Float']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalCaptured?: Maybe<Scalars['Float']>;
};

export type StripePaymentIntentAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  amountCaptured?: Maybe<SortOrder>;
  clientServiceFee?: Maybe<SortOrder>;
  clientServiceFeePercent?: Maybe<SortOrder>;
  clinicServiceFeeFlat?: Maybe<SortOrder>;
  clinicServiceFeePercent?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  totalCaptured?: Maybe<SortOrder>;
};

export type StripePaymentIntentCountAggregateOutputType = {
  __typename?: 'StripePaymentIntentCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType: Scalars['Int'];
  cardType: Scalars['Int'];
  careAccountCreditIntentId: Scalars['Int'];
  clientServiceFee: Scalars['Int'];
  clientServiceFeePercent: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  clinicServiceFeeFlat: Scalars['Int'];
  clinicServiceFeePercent: Scalars['Int'];
  createdAt: Scalars['Int'];
  emailOverride: Scalars['Int'];
  fundsAvailableAt: Scalars['Int'];
  id: Scalars['Int'];
  lastPaymentError: Scalars['Int'];
  paidAt: Scalars['Int'];
  paymentIdentifier: Scalars['Int'];
  paymentMedium: Scalars['Int'];
  paymentRelationship: Scalars['Int'];
  sentByAutomation: Scalars['Int'];
  sentByUserId: Scalars['Int'];
  serviceFeeAmount: Scalars['Int'];
  settledAt: Scalars['Int'];
  status: Scalars['Int'];
  stripeId: Scalars['Int'];
  stripePaymentMethodId: Scalars['Int'];
  stripePayoutId: Scalars['Int'];
  stripeReceiptId: Scalars['Int'];
  stripeTerminalId: Scalars['Int'];
  total: Scalars['Int'];
  totalCaptured: Scalars['Int'];
  transferType: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StripePaymentIntentCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  amountCaptured?: Maybe<SortOrder>;
  captureType?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  clientServiceFee?: Maybe<SortOrder>;
  clientServiceFeePercent?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicServiceFeeFlat?: Maybe<SortOrder>;
  clinicServiceFeePercent?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailOverride?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  sentByAutomation?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settledAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeTerminalId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  totalCaptured?: Maybe<SortOrder>;
  transferType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePaymentIntentCountOutputType = {
  __typename?: 'StripePaymentIntentCountOutputType';
  StripeDispute: Scalars['Int'];
  invoices: Scalars['Int'];
  stripeRefunds: Scalars['Int'];
  tasks: Scalars['Int'];
  writebackLogEntries: Scalars['Int'];
};

export type StripePaymentIntentCreateInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateManyCareAccountCreditIntentInput = {
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentCreateManyCareAccountCreditIntentInputEnvelope = {
  data: Array<StripePaymentIntentCreateManyCareAccountCreditIntentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripePaymentIntentCreateManyClinicInput = {
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentCreateManyClinicInputEnvelope = {
  data: Array<StripePaymentIntentCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripePaymentIntentCreateManyClinicPetParentInput = {
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentCreateManyClinicPetParentInputEnvelope = {
  data: Array<StripePaymentIntentCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripePaymentIntentCreateManyInput = {
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentCreateManySentByInput = {
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentCreateManySentByInputEnvelope = {
  data: Array<StripePaymentIntentCreateManySentByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripePaymentIntentCreateManyStripePaymentMethodInput = {
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentCreateManyStripePaymentMethodInputEnvelope = {
  data: Array<StripePaymentIntentCreateManyStripePaymentMethodInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripePaymentIntentCreateManyStripePayoutInput = {
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentCreateManyStripePayoutInputEnvelope = {
  data: Array<StripePaymentIntentCreateManyStripePayoutInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripePaymentIntentCreateManyStripeTerminalInput = {
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentCreateManyStripeTerminalInputEnvelope = {
  data: Array<StripePaymentIntentCreateManyStripeTerminalInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripePaymentIntentCreateNestedManyWithoutCareAccountCreditIntentInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutCareAccountCreditIntentInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutCareAccountCreditIntentInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyCareAccountCreditIntentInputEnvelope>;
};

export type StripePaymentIntentCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutClinicInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyClinicInputEnvelope>;
};

export type StripePaymentIntentCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyClinicPetParentInputEnvelope>;
};

export type StripePaymentIntentCreateNestedManyWithoutInvoicesInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutInvoicesInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutInvoicesInput>>;
};

export type StripePaymentIntentCreateNestedManyWithoutSentByInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutSentByInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutSentByInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManySentByInputEnvelope>;
};

export type StripePaymentIntentCreateNestedManyWithoutStripePaymentMethodInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyStripePaymentMethodInputEnvelope>;
};

export type StripePaymentIntentCreateNestedManyWithoutStripePayoutInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyStripePayoutInputEnvelope>;
};

export type StripePaymentIntentCreateNestedManyWithoutStripeTerminalInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutStripeTerminalInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutStripeTerminalInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyStripeTerminalInputEnvelope>;
};

export type StripePaymentIntentCreateNestedOneWithoutAutomationRunActionInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutAutomationRunActionInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutAutomationRunActionInput>;
};

export type StripePaymentIntentCreateNestedOneWithoutFinancialTransactionInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutFinancialTransactionInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutFinancialTransactionInput>;
};

export type StripePaymentIntentCreateNestedOneWithoutStripeDisputeInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutStripeDisputeInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutStripeDisputeInput>;
};

export type StripePaymentIntentCreateNestedOneWithoutStripeReceiptInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutStripeReceiptInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutStripeReceiptInput>;
};

export type StripePaymentIntentCreateNestedOneWithoutStripeRefundsInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutStripeRefundsInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutStripeRefundsInput>;
};

export type StripePaymentIntentCreateNestedOneWithoutTasksInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutTasksInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutTasksInput>;
};

export type StripePaymentIntentCreateNestedOneWithoutWritebackLogEntriesInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutWritebackLogEntriesInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutWritebackLogEntriesInput>;
};

export type StripePaymentIntentCreateOrConnectWithoutAutomationRunActionInput = {
  create: StripePaymentIntentCreateWithoutAutomationRunActionInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutCareAccountCreditIntentInput = {
  create: StripePaymentIntentCreateWithoutCareAccountCreditIntentInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutClinicInput = {
  create: StripePaymentIntentCreateWithoutClinicInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutClinicPetParentInput = {
  create: StripePaymentIntentCreateWithoutClinicPetParentInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutFinancialTransactionInput = {
  create: StripePaymentIntentCreateWithoutFinancialTransactionInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutInvoicesInput = {
  create: StripePaymentIntentCreateWithoutInvoicesInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutSentByInput = {
  create: StripePaymentIntentCreateWithoutSentByInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutStripeDisputeInput = {
  create: StripePaymentIntentCreateWithoutStripeDisputeInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutStripePaymentMethodInput = {
  create: StripePaymentIntentCreateWithoutStripePaymentMethodInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutStripePayoutInput = {
  create: StripePaymentIntentCreateWithoutStripePayoutInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutStripeReceiptInput = {
  create: StripePaymentIntentCreateWithoutStripeReceiptInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutStripeRefundsInput = {
  create: StripePaymentIntentCreateWithoutStripeRefundsInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutStripeTerminalInput = {
  create: StripePaymentIntentCreateWithoutStripeTerminalInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutTasksInput = {
  create: StripePaymentIntentCreateWithoutTasksInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateOrConnectWithoutWritebackLogEntriesInput = {
  create: StripePaymentIntentCreateWithoutWritebackLogEntriesInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateWithoutAutomationRunActionInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutCareAccountCreditIntentInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutClinicInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutClinicPetParentInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutFinancialTransactionInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutInvoicesInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutSentByInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutStripeDisputeInput = {
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutStripePaymentMethodInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutStripePayoutInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutStripeReceiptInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutStripeRefundsInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutStripeTerminalInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutTasksInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentCreateWithoutWritebackLogEntriesInput = {
  StripeDispute?: Maybe<StripeDisputeCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentIntentsInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserCreateNestedOneWithoutSentStripePaymentIntentsInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethod?: Maybe<StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutPaymentInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminal?: Maybe<StripeTerminalCreateNestedOneWithoutPaymentsInput>;
  tasks?: Maybe<TaskCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentGroupByOutputType = {
  __typename?: 'StripePaymentIntentGroupByOutputType';
  _avg?: Maybe<StripePaymentIntentAvgAggregateOutputType>;
  _count?: Maybe<StripePaymentIntentCountAggregateOutputType>;
  _max?: Maybe<StripePaymentIntentMaxAggregateOutputType>;
  _min?: Maybe<StripePaymentIntentMinAggregateOutputType>;
  _sum?: Maybe<StripePaymentIntentSumAggregateOutputType>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType: ChargeCaptureType;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation: Scalars['Boolean'];
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status: StripePaymentIntentStatus;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType: StripePaymentTransferType;
  updatedAt: Scalars['DateTime'];
};

export type StripePaymentIntentListRelationFilter = {
  every?: Maybe<StripePaymentIntentWhereInput>;
  none?: Maybe<StripePaymentIntentWhereInput>;
  some?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentMaxAggregateOutputType = {
  __typename?: 'StripePaymentIntentMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  amountCaptured?: Maybe<SortOrder>;
  captureType?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  clientServiceFee?: Maybe<SortOrder>;
  clientServiceFeePercent?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicServiceFeeFlat?: Maybe<SortOrder>;
  clinicServiceFeePercent?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailOverride?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  sentByAutomation?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settledAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeTerminalId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  totalCaptured?: Maybe<SortOrder>;
  transferType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePaymentIntentMinAggregateOutputType = {
  __typename?: 'StripePaymentIntentMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  amountCaptured?: Maybe<SortOrder>;
  captureType?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  clientServiceFee?: Maybe<SortOrder>;
  clientServiceFeePercent?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicServiceFeeFlat?: Maybe<SortOrder>;
  clinicServiceFeePercent?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailOverride?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  sentByAutomation?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settledAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeTerminalId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  totalCaptured?: Maybe<SortOrder>;
  transferType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePaymentIntentNullableScalarRelationFilter = {
  AND?: Maybe<Array<StripePaymentIntentWhereInput>>;
  NOT?: Maybe<Array<StripePaymentIntentWhereInput>>;
  OR?: Maybe<Array<StripePaymentIntentWhereInput>>;
  StripeDispute?: Maybe<StripeDisputeListRelationFilter>;
  amount?: Maybe<IntFilter>;
  amountCaptured?: Maybe<IntFilter>;
  automationRunAction?: Maybe<AutomationRunActionNullableScalarRelationFilter>;
  captureType?: Maybe<EnumChargeCaptureTypeFilter>;
  cardType?: Maybe<EnumCardFundingNullableFilter>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentNullableScalarRelationFilter>;
  careAccountCreditIntentId?: Maybe<StringNullableFilter>;
  clientServiceFee?: Maybe<IntNullableFilter>;
  clientServiceFeePercent?: Maybe<FloatNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicServiceFeeFlat?: Maybe<IntNullableFilter>;
  clinicServiceFeePercent?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailOverride?: Maybe<StringNullableFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  invoices?: Maybe<InvoiceListRelationFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  paymentIdentifier?: Maybe<StringNullableFilter>;
  paymentMedium?: Maybe<EnumPaymentMediumNullableFilter>;
  paymentRelationship?: Maybe<EnumPaymentRelationshipNullableFilter>;
  sentBy?: Maybe<UserNullableScalarRelationFilter>;
  sentByAutomation?: Maybe<BoolFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  serviceFeeAmount?: Maybe<IntFilter>;
  settledAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumStripePaymentIntentStatusFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeReceipt?: Maybe<StripeReceiptNullableScalarRelationFilter>;
  stripeReceiptId?: Maybe<StringNullableFilter>;
  stripeRefunds?: Maybe<StripeRefundListRelationFilter>;
  stripeTerminal?: Maybe<StripeTerminalNullableScalarRelationFilter>;
  stripeTerminalId?: Maybe<StringNullableFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  total?: Maybe<IntFilter>;
  totalCaptured?: Maybe<IntNullableFilter>;
  transferType?: Maybe<EnumStripePaymentTransferTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryListRelationFilter>;
};

export type StripePaymentIntentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StripePaymentIntentOrderByRelationAndSearchRelevanceInput = {
  StripeDispute?: Maybe<StripeDisputeOrderByRelationAggregateInput>;
  _relevance?: Maybe<StripePaymentIntentOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  amountCaptured?: Maybe<SortOrder>;
  automationRunAction?: Maybe<AutomationRunActionOrderByWithRelationInput>;
  captureType?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentOrderByWithRelationInput>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  clientServiceFee?: Maybe<SortOrder>;
  clientServiceFeePercent?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicServiceFeeFlat?: Maybe<SortOrder>;
  clinicServiceFeePercent?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailOverride?: Maybe<SortOrder>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoices?: Maybe<InvoiceOrderByRelationAggregateInput>;
  lastPaymentError?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  sentBy?: Maybe<UserOrderByWithRelationInput>;
  sentByAutomation?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settledAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethod?: Maybe<StripePaymentMethodOrderByWithRelationInput>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceipt?: Maybe<StripeReceiptOrderByWithRelationInput>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeRefunds?: Maybe<StripeRefundOrderByRelationAggregateInput>;
  stripeTerminal?: Maybe<StripeTerminalOrderByWithRelationInput>;
  stripeTerminalId?: Maybe<SortOrder>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  total?: Maybe<SortOrder>;
  totalCaptured?: Maybe<SortOrder>;
  transferType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryOrderByRelationAggregateInput>;
};

export enum StripePaymentIntentOrderByRelevanceFieldEnum {
  CareAccountCreditIntentId = 'careAccountCreditIntentId',
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  EmailOverride = 'emailOverride',
  Id = 'id',
  PaymentIdentifier = 'paymentIdentifier',
  SentByUserId = 'sentByUserId',
  StripeId = 'stripeId',
  StripePaymentMethodId = 'stripePaymentMethodId',
  StripePayoutId = 'stripePayoutId',
  StripeReceiptId = 'stripeReceiptId',
  StripeTerminalId = 'stripeTerminalId'
}

export type StripePaymentIntentOrderByRelevanceInput = {
  fields: Array<StripePaymentIntentOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripePaymentIntentOrderByWithAggregationInput = {
  _avg?: Maybe<StripePaymentIntentAvgOrderByAggregateInput>;
  _count?: Maybe<StripePaymentIntentCountOrderByAggregateInput>;
  _max?: Maybe<StripePaymentIntentMaxOrderByAggregateInput>;
  _min?: Maybe<StripePaymentIntentMinOrderByAggregateInput>;
  _sum?: Maybe<StripePaymentIntentSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  amountCaptured?: Maybe<SortOrder>;
  captureType?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  clientServiceFee?: Maybe<SortOrder>;
  clientServiceFeePercent?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicServiceFeeFlat?: Maybe<SortOrder>;
  clinicServiceFeePercent?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailOverride?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastPaymentError?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  sentByAutomation?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settledAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeTerminalId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  totalCaptured?: Maybe<SortOrder>;
  transferType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePaymentIntentOrderByWithRelationAndSearchRelevanceInput = {
  StripeDispute?: Maybe<StripeDisputeOrderByRelationAggregateInput>;
  _relevance?: Maybe<StripePaymentIntentOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  amountCaptured?: Maybe<SortOrder>;
  automationRunAction?: Maybe<AutomationRunActionOrderByWithRelationInput>;
  captureType?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentOrderByWithRelationInput>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  clientServiceFee?: Maybe<SortOrder>;
  clientServiceFeePercent?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicServiceFeeFlat?: Maybe<SortOrder>;
  clinicServiceFeePercent?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailOverride?: Maybe<SortOrder>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoices?: Maybe<InvoiceOrderByRelationAggregateInput>;
  lastPaymentError?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  sentBy?: Maybe<UserOrderByWithRelationInput>;
  sentByAutomation?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settledAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethod?: Maybe<StripePaymentMethodOrderByWithRelationInput>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceipt?: Maybe<StripeReceiptOrderByWithRelationInput>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeRefunds?: Maybe<StripeRefundOrderByRelationAggregateInput>;
  stripeTerminal?: Maybe<StripeTerminalOrderByWithRelationInput>;
  stripeTerminalId?: Maybe<SortOrder>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  total?: Maybe<SortOrder>;
  totalCaptured?: Maybe<SortOrder>;
  transferType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryOrderByRelationAggregateInput>;
};

export type StripePaymentIntentOrderByWithRelationInput = {
  StripeDispute?: Maybe<StripeDisputeOrderByRelationAggregateInput>;
  _relevance?: Maybe<StripePaymentIntentOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  amountCaptured?: Maybe<SortOrder>;
  automationRunAction?: Maybe<AutomationRunActionOrderByWithRelationInput>;
  captureType?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentOrderByWithRelationInput>;
  careAccountCreditIntentId?: Maybe<SortOrder>;
  clientServiceFee?: Maybe<SortOrder>;
  clientServiceFeePercent?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  clinicServiceFeeFlat?: Maybe<SortOrder>;
  clinicServiceFeePercent?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailOverride?: Maybe<SortOrder>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invoices?: Maybe<InvoiceOrderByRelationAggregateInput>;
  lastPaymentError?: Maybe<SortOrder>;
  paidAt?: Maybe<SortOrder>;
  paymentIdentifier?: Maybe<SortOrder>;
  paymentMedium?: Maybe<SortOrder>;
  paymentRelationship?: Maybe<SortOrder>;
  sentBy?: Maybe<UserOrderByWithRelationInput>;
  sentByAutomation?: Maybe<SortOrder>;
  sentByUserId?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settledAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentMethod?: Maybe<StripePaymentMethodOrderByWithRelationInput>;
  stripePaymentMethodId?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceipt?: Maybe<StripeReceiptOrderByWithRelationInput>;
  stripeReceiptId?: Maybe<SortOrder>;
  stripeRefunds?: Maybe<StripeRefundOrderByRelationAggregateInput>;
  stripeTerminal?: Maybe<StripeTerminalOrderByWithRelationInput>;
  stripeTerminalId?: Maybe<SortOrder>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  total?: Maybe<SortOrder>;
  totalCaptured?: Maybe<SortOrder>;
  transferType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryOrderByRelationAggregateInput>;
};

export enum StripePaymentIntentScalarFieldEnum {
  Amount = 'amount',
  AmountCaptured = 'amountCaptured',
  CaptureType = 'captureType',
  CardType = 'cardType',
  CareAccountCreditIntentId = 'careAccountCreditIntentId',
  ClientServiceFee = 'clientServiceFee',
  ClientServiceFeePercent = 'clientServiceFeePercent',
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  ClinicServiceFeeFlat = 'clinicServiceFeeFlat',
  ClinicServiceFeePercent = 'clinicServiceFeePercent',
  CreatedAt = 'createdAt',
  EmailOverride = 'emailOverride',
  FundsAvailableAt = 'fundsAvailableAt',
  Id = 'id',
  LastPaymentError = 'lastPaymentError',
  PaidAt = 'paidAt',
  PaymentIdentifier = 'paymentIdentifier',
  PaymentMedium = 'paymentMedium',
  PaymentRelationship = 'paymentRelationship',
  SentByAutomation = 'sentByAutomation',
  SentByUserId = 'sentByUserId',
  ServiceFeeAmount = 'serviceFeeAmount',
  SettledAt = 'settledAt',
  Status = 'status',
  StripeId = 'stripeId',
  StripePaymentMethodId = 'stripePaymentMethodId',
  StripePayoutId = 'stripePayoutId',
  StripeReceiptId = 'stripeReceiptId',
  StripeTerminalId = 'stripeTerminalId',
  Total = 'total',
  TotalCaptured = 'totalCaptured',
  TransferType = 'transferType',
  UpdatedAt = 'updatedAt'
}

export type StripePaymentIntentScalarRelationFilter = {
  AND?: Maybe<Array<StripePaymentIntentWhereInput>>;
  NOT?: Maybe<Array<StripePaymentIntentWhereInput>>;
  OR?: Maybe<Array<StripePaymentIntentWhereInput>>;
  StripeDispute?: Maybe<StripeDisputeListRelationFilter>;
  amount?: Maybe<IntFilter>;
  amountCaptured?: Maybe<IntFilter>;
  automationRunAction?: Maybe<AutomationRunActionNullableScalarRelationFilter>;
  captureType?: Maybe<EnumChargeCaptureTypeFilter>;
  cardType?: Maybe<EnumCardFundingNullableFilter>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentNullableScalarRelationFilter>;
  careAccountCreditIntentId?: Maybe<StringNullableFilter>;
  clientServiceFee?: Maybe<IntNullableFilter>;
  clientServiceFeePercent?: Maybe<FloatNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicServiceFeeFlat?: Maybe<IntNullableFilter>;
  clinicServiceFeePercent?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailOverride?: Maybe<StringNullableFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  invoices?: Maybe<InvoiceListRelationFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  paymentIdentifier?: Maybe<StringNullableFilter>;
  paymentMedium?: Maybe<EnumPaymentMediumNullableFilter>;
  paymentRelationship?: Maybe<EnumPaymentRelationshipNullableFilter>;
  sentBy?: Maybe<UserNullableScalarRelationFilter>;
  sentByAutomation?: Maybe<BoolFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  serviceFeeAmount?: Maybe<IntFilter>;
  settledAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumStripePaymentIntentStatusFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeReceipt?: Maybe<StripeReceiptNullableScalarRelationFilter>;
  stripeReceiptId?: Maybe<StringNullableFilter>;
  stripeRefunds?: Maybe<StripeRefundListRelationFilter>;
  stripeTerminal?: Maybe<StripeTerminalNullableScalarRelationFilter>;
  stripeTerminalId?: Maybe<StringNullableFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  total?: Maybe<IntFilter>;
  totalCaptured?: Maybe<IntNullableFilter>;
  transferType?: Maybe<EnumStripePaymentTransferTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryListRelationFilter>;
};

export type StripePaymentIntentScalarWhereInput = {
  AND?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  NOT?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  OR?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  amount?: Maybe<IntFilter>;
  amountCaptured?: Maybe<IntFilter>;
  captureType?: Maybe<EnumChargeCaptureTypeFilter>;
  cardType?: Maybe<EnumCardFundingNullableFilter>;
  careAccountCreditIntentId?: Maybe<StringNullableFilter>;
  clientServiceFee?: Maybe<IntNullableFilter>;
  clientServiceFeePercent?: Maybe<FloatNullableFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicServiceFeeFlat?: Maybe<IntNullableFilter>;
  clinicServiceFeePercent?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailOverride?: Maybe<StringNullableFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  paymentIdentifier?: Maybe<StringNullableFilter>;
  paymentMedium?: Maybe<EnumPaymentMediumNullableFilter>;
  paymentRelationship?: Maybe<EnumPaymentRelationshipNullableFilter>;
  sentByAutomation?: Maybe<BoolFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  serviceFeeAmount?: Maybe<IntFilter>;
  settledAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumStripePaymentIntentStatusFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeReceiptId?: Maybe<StringNullableFilter>;
  stripeTerminalId?: Maybe<StringNullableFilter>;
  total?: Maybe<IntFilter>;
  totalCaptured?: Maybe<IntNullableFilter>;
  transferType?: Maybe<EnumStripePaymentTransferTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePaymentIntentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripePaymentIntentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripePaymentIntentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripePaymentIntentScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntWithAggregatesFilter>;
  amountCaptured?: Maybe<IntWithAggregatesFilter>;
  captureType?: Maybe<EnumChargeCaptureTypeWithAggregatesFilter>;
  cardType?: Maybe<EnumCardFundingNullableWithAggregatesFilter>;
  careAccountCreditIntentId?: Maybe<StringNullableWithAggregatesFilter>;
  clientServiceFee?: Maybe<IntNullableWithAggregatesFilter>;
  clientServiceFeePercent?: Maybe<FloatNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicServiceFeeFlat?: Maybe<IntNullableWithAggregatesFilter>;
  clinicServiceFeePercent?: Maybe<FloatNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  emailOverride?: Maybe<StringNullableWithAggregatesFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableWithAggregatesFilter>;
  paidAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  paymentIdentifier?: Maybe<StringNullableWithAggregatesFilter>;
  paymentMedium?: Maybe<EnumPaymentMediumNullableWithAggregatesFilter>;
  paymentRelationship?: Maybe<EnumPaymentRelationshipNullableWithAggregatesFilter>;
  sentByAutomation?: Maybe<BoolWithAggregatesFilter>;
  sentByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  serviceFeeAmount?: Maybe<IntWithAggregatesFilter>;
  settledAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  status?: Maybe<EnumStripePaymentIntentStatusWithAggregatesFilter>;
  stripeId?: Maybe<StringWithAggregatesFilter>;
  stripePaymentMethodId?: Maybe<StringNullableWithAggregatesFilter>;
  stripePayoutId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeReceiptId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeTerminalId?: Maybe<StringNullableWithAggregatesFilter>;
  total?: Maybe<IntWithAggregatesFilter>;
  totalCaptured?: Maybe<IntNullableWithAggregatesFilter>;
  transferType?: Maybe<EnumStripePaymentTransferTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum StripePaymentIntentStatus {
  Canceled = 'Canceled',
  Created = 'Created',
  Processing = 'Processing',
  RequiresAction = 'Requires_Action',
  RequiresCapture = 'Requires_Capture',
  RequiresConfirmation = 'Requires_Confirmation',
  RequiresPaymentMethod = 'Requires_Payment_Method',
  Succeeded = 'Succeeded'
}

export type StripePaymentIntentSubscription = {
  __typename?: 'StripePaymentIntentSubscription';
  model: Scalars['String'];
  mutation: MutationType;
  node: StripePaymentIntent;
};

export type StripePaymentIntentSumAggregateOutputType = {
  __typename?: 'StripePaymentIntentSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
};

export type StripePaymentIntentSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  amountCaptured?: Maybe<SortOrder>;
  clientServiceFee?: Maybe<SortOrder>;
  clientServiceFeePercent?: Maybe<SortOrder>;
  clinicServiceFeeFlat?: Maybe<SortOrder>;
  clinicServiceFeePercent?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  totalCaptured?: Maybe<SortOrder>;
};

export type StripePaymentIntentUncheckedCreateInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateNestedManyWithoutCareAccountCreditIntentInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutCareAccountCreditIntentInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutCareAccountCreditIntentInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyCareAccountCreditIntentInputEnvelope>;
};

export type StripePaymentIntentUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutClinicInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyClinicInputEnvelope>;
};

export type StripePaymentIntentUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyClinicPetParentInputEnvelope>;
};

export type StripePaymentIntentUncheckedCreateNestedManyWithoutInvoicesInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutInvoicesInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutInvoicesInput>>;
};

export type StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutSentByInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutSentByInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManySentByInputEnvelope>;
};

export type StripePaymentIntentUncheckedCreateNestedManyWithoutStripePaymentMethodInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyStripePaymentMethodInputEnvelope>;
};

export type StripePaymentIntentUncheckedCreateNestedManyWithoutStripePayoutInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyStripePayoutInputEnvelope>;
};

export type StripePaymentIntentUncheckedCreateNestedManyWithoutStripeTerminalInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutStripeTerminalInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutStripeTerminalInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyStripeTerminalInputEnvelope>;
};

export type StripePaymentIntentUncheckedCreateNestedOneWithoutStripeReceiptInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutStripeReceiptInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutStripeReceiptInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutAutomationRunActionInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutCareAccountCreditIntentInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutClinicInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutClinicPetParentInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutFinancialTransactionInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutInvoicesInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutSentByInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutStripeDisputeInput = {
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutStripePaymentMethodInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutStripePayoutInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutStripeReceiptInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutStripeRefundsInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutStripeTerminalInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutTasksInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedCreateNestedManyWithoutPaymentInput>;
};

export type StripePaymentIntentUncheckedCreateWithoutWritebackLogEntriesInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  automationRunAction?: Maybe<AutomationRunActionUncheckedCreateNestedOneWithoutPaymentIntentInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripePaymentIntentInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutStripePaymentIntentsInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Int'];
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId: Scalars['String'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutPaymentIntentInput>;
  total: Scalars['Int'];
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUncheckedUpdateInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutCareAccountCreditIntentInput = {
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutCareAccountCreditIntentNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutCareAccountCreditIntentInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutCareAccountCreditIntentInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyCareAccountCreditIntentInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutCareAccountCreditIntentInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutCareAccountCreditIntentInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutCareAccountCreditIntentInput>>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutClinicInput = {
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutClinicInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentInput = {
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutInvoicesInput = {
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutInvoicesNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutInvoicesInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutInvoicesInput>>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutInvoicesInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutInvoicesInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutInvoicesInput>>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutSentByInput = {
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutSentByInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutSentByInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManySentByInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutSentByInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutSentByInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutSentByInput>>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutStripePaymentMethodInput = {
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutStripePaymentMethodNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyStripePaymentMethodInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutStripePaymentMethodInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutStripePaymentMethodInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutStripePaymentMethodInput>>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutStripePayoutInput = {
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutStripePayoutNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyStripePayoutInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutStripePayoutInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutStripePayoutInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutStripePayoutInput>>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutStripeTerminalInput = {
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUncheckedUpdateManyWithoutStripeTerminalNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutStripeTerminalInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutStripeTerminalInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyStripeTerminalInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutStripeTerminalInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutStripeTerminalInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutStripeTerminalInput>>;
};

export type StripePaymentIntentUncheckedUpdateOneWithoutStripeReceiptNestedInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutStripeReceiptInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutStripeReceiptInput>;
  delete?: Maybe<StripePaymentIntentWhereInput>;
  disconnect?: Maybe<StripePaymentIntentWhereInput>;
  update?: Maybe<StripePaymentIntentUpdateToOneWithWhereWithoutStripeReceiptInput>;
  upsert?: Maybe<StripePaymentIntentUpsertWithoutStripeReceiptInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutAutomationRunActionInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutCareAccountCreditIntentInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutClinicInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutClinicPetParentInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutFinancialTransactionInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutInvoicesInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutSentByInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutStripeDisputeInput = {
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutStripePaymentMethodInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutStripePayoutInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutStripeReceiptInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutStripeRefundsInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutStripeTerminalInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutTasksInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUncheckedUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUncheckedUpdateWithoutWritebackLogEntriesInput = {
  StripeDispute?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUncheckedUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUncheckedUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  sentByUserId?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminalId?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUpdateInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUpdateManyWithWhereWithoutCareAccountCreditIntentInput = {
  data: StripePaymentIntentUpdateManyMutationInput;
  where: StripePaymentIntentScalarWhereInput;
};

export type StripePaymentIntentUpdateManyWithWhereWithoutClinicInput = {
  data: StripePaymentIntentUpdateManyMutationInput;
  where: StripePaymentIntentScalarWhereInput;
};

export type StripePaymentIntentUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: StripePaymentIntentUpdateManyMutationInput;
  where: StripePaymentIntentScalarWhereInput;
};

export type StripePaymentIntentUpdateManyWithWhereWithoutInvoicesInput = {
  data: StripePaymentIntentUpdateManyMutationInput;
  where: StripePaymentIntentScalarWhereInput;
};

export type StripePaymentIntentUpdateManyWithWhereWithoutSentByInput = {
  data: StripePaymentIntentUpdateManyMutationInput;
  where: StripePaymentIntentScalarWhereInput;
};

export type StripePaymentIntentUpdateManyWithWhereWithoutStripePaymentMethodInput = {
  data: StripePaymentIntentUpdateManyMutationInput;
  where: StripePaymentIntentScalarWhereInput;
};

export type StripePaymentIntentUpdateManyWithWhereWithoutStripePayoutInput = {
  data: StripePaymentIntentUpdateManyMutationInput;
  where: StripePaymentIntentScalarWhereInput;
};

export type StripePaymentIntentUpdateManyWithWhereWithoutStripeTerminalInput = {
  data: StripePaymentIntentUpdateManyMutationInput;
  where: StripePaymentIntentScalarWhereInput;
};

export type StripePaymentIntentUpdateManyWithoutCareAccountCreditIntentNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutCareAccountCreditIntentInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutCareAccountCreditIntentInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyCareAccountCreditIntentInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutCareAccountCreditIntentInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutCareAccountCreditIntentInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutCareAccountCreditIntentInput>>;
};

export type StripePaymentIntentUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutClinicInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type StripePaymentIntentUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type StripePaymentIntentUpdateManyWithoutInvoicesNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutInvoicesInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutInvoicesInput>>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutInvoicesInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutInvoicesInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutInvoicesInput>>;
};

export type StripePaymentIntentUpdateManyWithoutSentByNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutSentByInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutSentByInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManySentByInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutSentByInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutSentByInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutSentByInput>>;
};

export type StripePaymentIntentUpdateManyWithoutStripePaymentMethodNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutStripePaymentMethodInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutStripePaymentMethodInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyStripePaymentMethodInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutStripePaymentMethodInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutStripePaymentMethodInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutStripePaymentMethodInput>>;
};

export type StripePaymentIntentUpdateManyWithoutStripePayoutNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyStripePayoutInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutStripePayoutInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutStripePayoutInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutStripePayoutInput>>;
};

export type StripePaymentIntentUpdateManyWithoutStripeTerminalNestedInput = {
  connect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentIntentCreateOrConnectWithoutStripeTerminalInput>>;
  create?: Maybe<Array<StripePaymentIntentCreateWithoutStripeTerminalInput>>;
  createMany?: Maybe<StripePaymentIntentCreateManyStripeTerminalInputEnvelope>;
  delete?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutStripeTerminalInput>>;
  updateMany?: Maybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutStripeTerminalInput>>;
  upsert?: Maybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutStripeTerminalInput>>;
};

export type StripePaymentIntentUpdateOneRequiredWithoutWritebackLogEntriesNestedInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutWritebackLogEntriesInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutWritebackLogEntriesInput>;
  update?: Maybe<StripePaymentIntentUpdateToOneWithWhereWithoutWritebackLogEntriesInput>;
  upsert?: Maybe<StripePaymentIntentUpsertWithoutWritebackLogEntriesInput>;
};

export type StripePaymentIntentUpdateOneWithoutAutomationRunActionNestedInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutAutomationRunActionInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutAutomationRunActionInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePaymentIntentUpdateToOneWithWhereWithoutAutomationRunActionInput>;
  upsert?: Maybe<StripePaymentIntentUpsertWithoutAutomationRunActionInput>;
};

export type StripePaymentIntentUpdateOneWithoutFinancialTransactionNestedInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutFinancialTransactionInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutFinancialTransactionInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePaymentIntentUpdateToOneWithWhereWithoutFinancialTransactionInput>;
  upsert?: Maybe<StripePaymentIntentUpsertWithoutFinancialTransactionInput>;
};

export type StripePaymentIntentUpdateOneWithoutStripeDisputeNestedInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutStripeDisputeInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutStripeDisputeInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePaymentIntentUpdateToOneWithWhereWithoutStripeDisputeInput>;
  upsert?: Maybe<StripePaymentIntentUpsertWithoutStripeDisputeInput>;
};

export type StripePaymentIntentUpdateOneWithoutStripeReceiptNestedInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutStripeReceiptInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutStripeReceiptInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePaymentIntentUpdateToOneWithWhereWithoutStripeReceiptInput>;
  upsert?: Maybe<StripePaymentIntentUpsertWithoutStripeReceiptInput>;
};

export type StripePaymentIntentUpdateOneWithoutStripeRefundsNestedInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutStripeRefundsInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutStripeRefundsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePaymentIntentUpdateToOneWithWhereWithoutStripeRefundsInput>;
  upsert?: Maybe<StripePaymentIntentUpsertWithoutStripeRefundsInput>;
};

export type StripePaymentIntentUpdateOneWithoutTasksNestedInput = {
  connect?: Maybe<StripePaymentIntentWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentIntentCreateOrConnectWithoutTasksInput>;
  create?: Maybe<StripePaymentIntentCreateWithoutTasksInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePaymentIntentUpdateToOneWithWhereWithoutTasksInput>;
  upsert?: Maybe<StripePaymentIntentUpsertWithoutTasksInput>;
};

export type StripePaymentIntentUpdateToOneWithWhereWithoutAutomationRunActionInput = {
  data: StripePaymentIntentUpdateWithoutAutomationRunActionInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpdateToOneWithWhereWithoutFinancialTransactionInput = {
  data: StripePaymentIntentUpdateWithoutFinancialTransactionInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpdateToOneWithWhereWithoutStripeDisputeInput = {
  data: StripePaymentIntentUpdateWithoutStripeDisputeInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpdateToOneWithWhereWithoutStripeReceiptInput = {
  data: StripePaymentIntentUpdateWithoutStripeReceiptInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpdateToOneWithWhereWithoutStripeRefundsInput = {
  data: StripePaymentIntentUpdateWithoutStripeRefundsInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpdateToOneWithWhereWithoutTasksInput = {
  data: StripePaymentIntentUpdateWithoutTasksInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpdateToOneWithWhereWithoutWritebackLogEntriesInput = {
  data: StripePaymentIntentUpdateWithoutWritebackLogEntriesInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpdateWithWhereUniqueWithoutCareAccountCreditIntentInput = {
  data: StripePaymentIntentUpdateWithoutCareAccountCreditIntentInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpdateWithWhereUniqueWithoutClinicInput = {
  data: StripePaymentIntentUpdateWithoutClinicInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: StripePaymentIntentUpdateWithoutClinicPetParentInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpdateWithWhereUniqueWithoutInvoicesInput = {
  data: StripePaymentIntentUpdateWithoutInvoicesInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpdateWithWhereUniqueWithoutSentByInput = {
  data: StripePaymentIntentUpdateWithoutSentByInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpdateWithWhereUniqueWithoutStripePaymentMethodInput = {
  data: StripePaymentIntentUpdateWithoutStripePaymentMethodInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpdateWithWhereUniqueWithoutStripePayoutInput = {
  data: StripePaymentIntentUpdateWithoutStripePayoutInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpdateWithWhereUniqueWithoutStripeTerminalInput = {
  data: StripePaymentIntentUpdateWithoutStripeTerminalInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpdateWithoutAutomationRunActionInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutCareAccountCreditIntentInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutClinicInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutClinicPetParentInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutFinancialTransactionInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutInvoicesInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutSentByInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutStripeDisputeInput = {
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutStripePaymentMethodInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutStripePayoutInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutStripeReceiptInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutStripeRefundsInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutStripeTerminalInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutTasksInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryUpdateManyWithoutPaymentNestedInput>;
};

export type StripePaymentIntentUpdateWithoutWritebackLogEntriesInput = {
  StripeDispute?: Maybe<StripeDisputeUpdateManyWithoutStripePaymentIntentNestedInput>;
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  automationRunAction?: Maybe<AutomationRunActionUpdateOneWithoutPaymentIntentNestedInput>;
  captureType?: Maybe<ChargeCaptureType>;
  cardType?: Maybe<CardFunding>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clientServiceFee?: Maybe<Scalars['Int']>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinic?: Maybe<ClinicUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentIntentsNestedInput>;
  clinicServiceFeeFlat?: Maybe<Scalars['Int']>;
  clinicServiceFeePercent?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailOverride?: Maybe<Scalars['String']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripePaymentIntentNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceUpdateManyWithoutStripePaymentIntentsNestedInput>;
  lastPaymentError?: Maybe<StripePaymentError>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  sentBy?: Maybe<UserUpdateOneWithoutSentStripePaymentIntentsNestedInput>;
  sentByAutomation?: Maybe<Scalars['Boolean']>;
  serviceFeeAmount?: Maybe<Scalars['Int']>;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<StripePaymentIntentStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutPaymentNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput>;
  stripeTerminal?: Maybe<StripeTerminalUpdateOneWithoutPaymentsNestedInput>;
  tasks?: Maybe<TaskUpdateManyWithoutPaymentIntentNestedInput>;
  total?: Maybe<Scalars['Int']>;
  totalCaptured?: Maybe<Scalars['Int']>;
  transferType?: Maybe<StripePaymentTransferType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentIntentUpsertWithWhereUniqueWithoutCareAccountCreditIntentInput = {
  create: StripePaymentIntentCreateWithoutCareAccountCreditIntentInput;
  update: StripePaymentIntentUpdateWithoutCareAccountCreditIntentInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpsertWithWhereUniqueWithoutClinicInput = {
  create: StripePaymentIntentCreateWithoutClinicInput;
  update: StripePaymentIntentUpdateWithoutClinicInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: StripePaymentIntentCreateWithoutClinicPetParentInput;
  update: StripePaymentIntentUpdateWithoutClinicPetParentInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpsertWithWhereUniqueWithoutInvoicesInput = {
  create: StripePaymentIntentCreateWithoutInvoicesInput;
  update: StripePaymentIntentUpdateWithoutInvoicesInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpsertWithWhereUniqueWithoutSentByInput = {
  create: StripePaymentIntentCreateWithoutSentByInput;
  update: StripePaymentIntentUpdateWithoutSentByInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpsertWithWhereUniqueWithoutStripePaymentMethodInput = {
  create: StripePaymentIntentCreateWithoutStripePaymentMethodInput;
  update: StripePaymentIntentUpdateWithoutStripePaymentMethodInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpsertWithWhereUniqueWithoutStripePayoutInput = {
  create: StripePaymentIntentCreateWithoutStripePayoutInput;
  update: StripePaymentIntentUpdateWithoutStripePayoutInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpsertWithWhereUniqueWithoutStripeTerminalInput = {
  create: StripePaymentIntentCreateWithoutStripeTerminalInput;
  update: StripePaymentIntentUpdateWithoutStripeTerminalInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpsertWithoutAutomationRunActionInput = {
  create: StripePaymentIntentCreateWithoutAutomationRunActionInput;
  update: StripePaymentIntentUpdateWithoutAutomationRunActionInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpsertWithoutFinancialTransactionInput = {
  create: StripePaymentIntentCreateWithoutFinancialTransactionInput;
  update: StripePaymentIntentUpdateWithoutFinancialTransactionInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpsertWithoutStripeDisputeInput = {
  create: StripePaymentIntentCreateWithoutStripeDisputeInput;
  update: StripePaymentIntentUpdateWithoutStripeDisputeInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpsertWithoutStripeReceiptInput = {
  create: StripePaymentIntentCreateWithoutStripeReceiptInput;
  update: StripePaymentIntentUpdateWithoutStripeReceiptInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpsertWithoutStripeRefundsInput = {
  create: StripePaymentIntentCreateWithoutStripeRefundsInput;
  update: StripePaymentIntentUpdateWithoutStripeRefundsInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpsertWithoutTasksInput = {
  create: StripePaymentIntentCreateWithoutTasksInput;
  update: StripePaymentIntentUpdateWithoutTasksInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentUpsertWithoutWritebackLogEntriesInput = {
  create: StripePaymentIntentCreateWithoutWritebackLogEntriesInput;
  update: StripePaymentIntentUpdateWithoutWritebackLogEntriesInput;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentWhereInput = {
  AND?: Maybe<Array<StripePaymentIntentWhereInput>>;
  NOT?: Maybe<Array<StripePaymentIntentWhereInput>>;
  OR?: Maybe<Array<StripePaymentIntentWhereInput>>;
  StripeDispute?: Maybe<StripeDisputeListRelationFilter>;
  amount?: Maybe<IntFilter>;
  amountCaptured?: Maybe<IntFilter>;
  automationRunAction?: Maybe<AutomationRunActionNullableScalarRelationFilter>;
  captureType?: Maybe<EnumChargeCaptureTypeFilter>;
  cardType?: Maybe<EnumCardFundingNullableFilter>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentNullableScalarRelationFilter>;
  careAccountCreditIntentId?: Maybe<StringNullableFilter>;
  clientServiceFee?: Maybe<IntNullableFilter>;
  clientServiceFeePercent?: Maybe<FloatNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicServiceFeeFlat?: Maybe<IntNullableFilter>;
  clinicServiceFeePercent?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailOverride?: Maybe<StringNullableFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  invoices?: Maybe<InvoiceListRelationFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  paymentIdentifier?: Maybe<StringNullableFilter>;
  paymentMedium?: Maybe<EnumPaymentMediumNullableFilter>;
  paymentRelationship?: Maybe<EnumPaymentRelationshipNullableFilter>;
  sentBy?: Maybe<UserNullableScalarRelationFilter>;
  sentByAutomation?: Maybe<BoolFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  serviceFeeAmount?: Maybe<IntFilter>;
  settledAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumStripePaymentIntentStatusFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeReceipt?: Maybe<StripeReceiptNullableScalarRelationFilter>;
  stripeReceiptId?: Maybe<StringNullableFilter>;
  stripeRefunds?: Maybe<StripeRefundListRelationFilter>;
  stripeTerminal?: Maybe<StripeTerminalNullableScalarRelationFilter>;
  stripeTerminalId?: Maybe<StringNullableFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  total?: Maybe<IntFilter>;
  totalCaptured?: Maybe<IntNullableFilter>;
  transferType?: Maybe<EnumStripePaymentTransferTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryListRelationFilter>;
};

export type StripePaymentIntentWhereUniqueInput = {
  AND?: Maybe<Array<StripePaymentIntentWhereInput>>;
  NOT?: Maybe<Array<StripePaymentIntentWhereInput>>;
  OR?: Maybe<Array<StripePaymentIntentWhereInput>>;
  StripeDispute?: Maybe<StripeDisputeListRelationFilter>;
  amount?: Maybe<IntFilter>;
  amountCaptured?: Maybe<IntFilter>;
  automationRunAction?: Maybe<AutomationRunActionNullableScalarRelationFilter>;
  captureType?: Maybe<EnumChargeCaptureTypeFilter>;
  cardType?: Maybe<EnumCardFundingNullableFilter>;
  careAccountCreditIntent?: Maybe<CareAccountCreditIntentNullableScalarRelationFilter>;
  careAccountCreditIntentId?: Maybe<StringNullableFilter>;
  clientServiceFee?: Maybe<IntNullableFilter>;
  clientServiceFeePercent?: Maybe<FloatNullableFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  clinicServiceFeeFlat?: Maybe<IntNullableFilter>;
  clinicServiceFeePercent?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailOverride?: Maybe<StringNullableFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceListRelationFilter>;
  lastPaymentError?: Maybe<EnumStripePaymentErrorNullableFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<EnumPaymentMediumNullableFilter>;
  paymentRelationship?: Maybe<EnumPaymentRelationshipNullableFilter>;
  sentBy?: Maybe<UserNullableScalarRelationFilter>;
  sentByAutomation?: Maybe<BoolFilter>;
  sentByUserId?: Maybe<StringNullableFilter>;
  serviceFeeAmount?: Maybe<IntFilter>;
  settledAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<EnumStripePaymentIntentStatusFilter>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<StripePaymentMethodNullableScalarRelationFilter>;
  stripePaymentMethodId?: Maybe<StringNullableFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeReceipt?: Maybe<StripeReceiptNullableScalarRelationFilter>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundListRelationFilter>;
  stripeTerminal?: Maybe<StripeTerminalNullableScalarRelationFilter>;
  stripeTerminalId?: Maybe<StringNullableFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  total?: Maybe<IntFilter>;
  totalCaptured?: Maybe<IntNullableFilter>;
  transferType?: Maybe<EnumStripePaymentTransferTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  writebackLogEntries?: Maybe<PaymentPimsWritebackLogEntryListRelationFilter>;
};

export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod';
  _count: StripePaymentMethodCountOutputType;
  cardBrand: CardBrand;
  careStripeSubscriptions: Array<CareStripeSubscription>;
  careSubscriptionTrueUps: Array<CareSubscriptionTrueUp>;
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isExpired: Scalars['Boolean'];
  isReusable: Scalars['Boolean'];
  last4: Scalars['String'];
  permitsFutureUsage: Scalars['Boolean'];
  stripeCustomer?: Maybe<StripeCustomer>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripeInvoices: Array<StripeInvoice>;
  stripePaymentIntents: Array<StripePaymentIntent>;
  type: StripePaymentMethodType;
  updatedAt: Scalars['DateTime'];
};


export type StripePaymentMethodCareStripeSubscriptionsArgs = {
  cursor?: Maybe<CareStripeSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareStripeSubscriptionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareStripeSubscriptionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareStripeSubscriptionWhereInput>;
};


export type StripePaymentMethodCareSubscriptionTrueUpsArgs = {
  cursor?: Maybe<CareSubscriptionTrueUpWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareSubscriptionTrueUpScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareSubscriptionTrueUpOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
};


export type StripePaymentMethodClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type StripePaymentMethodStripeCustomerArgs = {
  where?: Maybe<StripeCustomerWhereInput>;
};


export type StripePaymentMethodStripeInvoicesArgs = {
  cursor?: Maybe<StripeInvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeInvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeInvoiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeInvoiceWhereInput>;
};


export type StripePaymentMethodStripePaymentIntentsArgs = {
  cursor?: Maybe<StripePaymentIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentMethodAvgAggregateOutputType = {
  __typename?: 'StripePaymentMethodAvgAggregateOutputType';
  expirationMonth?: Maybe<Scalars['Float']>;
  expirationYear?: Maybe<Scalars['Float']>;
};

export type StripePaymentMethodAvgOrderByAggregateInput = {
  expirationMonth?: Maybe<SortOrder>;
  expirationYear?: Maybe<SortOrder>;
};

export type StripePaymentMethodCountAggregateOutputType = {
  __typename?: 'StripePaymentMethodCountAggregateOutputType';
  _all: Scalars['Int'];
  cardBrand: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint: Scalars['Int'];
  funding: Scalars['Int'];
  id: Scalars['Int'];
  isDefault: Scalars['Int'];
  isDeleted: Scalars['Int'];
  isExpired: Scalars['Int'];
  isReusable: Scalars['Int'];
  last4: Scalars['Int'];
  permitsFutureUsage: Scalars['Int'];
  stripeCustomerId: Scalars['Int'];
  stripeId: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StripePaymentMethodCountOrderByAggregateInput = {
  cardBrand?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationMonth?: Maybe<SortOrder>;
  expirationYear?: Maybe<SortOrder>;
  fingerprint?: Maybe<SortOrder>;
  funding?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExpired?: Maybe<SortOrder>;
  isReusable?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  permitsFutureUsage?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePaymentMethodCountOutputType = {
  __typename?: 'StripePaymentMethodCountOutputType';
  careStripeSubscriptions: Scalars['Int'];
  careSubscriptionTrueUps: Scalars['Int'];
  stripeInvoices: Scalars['Int'];
  stripePaymentIntents: Scalars['Int'];
};

export type StripePaymentMethodCreateInput = {
  cardBrand: CardBrand;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutStripePaymentMethodInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripePaymentMethodInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentMethodsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutPaymentMethodsInput>;
  stripeId: Scalars['String'];
  stripeInvoices?: Maybe<StripeInvoiceCreateNestedManyWithoutStripePaymentMethodInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodCreateManyClinicPetParentInput = {
  cardBrand: CardBrand;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodCreateManyClinicPetParentInputEnvelope = {
  data: Array<StripePaymentMethodCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripePaymentMethodCreateManyInput = {
  cardBrand: CardBrand;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodCreateManyStripeCustomerInput = {
  cardBrand: CardBrand;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeId: Scalars['String'];
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodCreateManyStripeCustomerInputEnvelope = {
  data: Array<StripePaymentMethodCreateManyStripeCustomerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripePaymentMethodCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentMethodCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<StripePaymentMethodCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<StripePaymentMethodCreateManyClinicPetParentInputEnvelope>;
};

export type StripePaymentMethodCreateNestedManyWithoutStripeCustomerInput = {
  connect?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentMethodCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<StripePaymentMethodCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<StripePaymentMethodCreateManyStripeCustomerInputEnvelope>;
};

export type StripePaymentMethodCreateNestedOneWithoutCareStripeSubscriptionsInput = {
  connect?: Maybe<StripePaymentMethodWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentMethodCreateOrConnectWithoutCareStripeSubscriptionsInput>;
  create?: Maybe<StripePaymentMethodCreateWithoutCareStripeSubscriptionsInput>;
};

export type StripePaymentMethodCreateNestedOneWithoutCareSubscriptionTrueUpsInput = {
  connect?: Maybe<StripePaymentMethodWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentMethodCreateOrConnectWithoutCareSubscriptionTrueUpsInput>;
  create?: Maybe<StripePaymentMethodCreateWithoutCareSubscriptionTrueUpsInput>;
};

export type StripePaymentMethodCreateNestedOneWithoutStripeInvoicesInput = {
  connect?: Maybe<StripePaymentMethodWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentMethodCreateOrConnectWithoutStripeInvoicesInput>;
  create?: Maybe<StripePaymentMethodCreateWithoutStripeInvoicesInput>;
};

export type StripePaymentMethodCreateNestedOneWithoutStripePaymentIntentsInput = {
  connect?: Maybe<StripePaymentMethodWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentMethodCreateOrConnectWithoutStripePaymentIntentsInput>;
  create?: Maybe<StripePaymentMethodCreateWithoutStripePaymentIntentsInput>;
};

export type StripePaymentMethodCreateOrConnectWithoutCareStripeSubscriptionsInput = {
  create: StripePaymentMethodCreateWithoutCareStripeSubscriptionsInput;
  where: StripePaymentMethodWhereUniqueInput;
};

export type StripePaymentMethodCreateOrConnectWithoutCareSubscriptionTrueUpsInput = {
  create: StripePaymentMethodCreateWithoutCareSubscriptionTrueUpsInput;
  where: StripePaymentMethodWhereUniqueInput;
};

export type StripePaymentMethodCreateOrConnectWithoutClinicPetParentInput = {
  create: StripePaymentMethodCreateWithoutClinicPetParentInput;
  where: StripePaymentMethodWhereUniqueInput;
};

export type StripePaymentMethodCreateOrConnectWithoutStripeCustomerInput = {
  create: StripePaymentMethodCreateWithoutStripeCustomerInput;
  where: StripePaymentMethodWhereUniqueInput;
};

export type StripePaymentMethodCreateOrConnectWithoutStripeInvoicesInput = {
  create: StripePaymentMethodCreateWithoutStripeInvoicesInput;
  where: StripePaymentMethodWhereUniqueInput;
};

export type StripePaymentMethodCreateOrConnectWithoutStripePaymentIntentsInput = {
  create: StripePaymentMethodCreateWithoutStripePaymentIntentsInput;
  where: StripePaymentMethodWhereUniqueInput;
};

export type StripePaymentMethodCreateWithoutCareStripeSubscriptionsInput = {
  cardBrand: CardBrand;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripePaymentMethodInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentMethodsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutPaymentMethodsInput>;
  stripeId: Scalars['String'];
  stripeInvoices?: Maybe<StripeInvoiceCreateNestedManyWithoutStripePaymentMethodInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodCreateWithoutCareSubscriptionTrueUpsInput = {
  cardBrand: CardBrand;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutStripePaymentMethodInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentMethodsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutPaymentMethodsInput>;
  stripeId: Scalars['String'];
  stripeInvoices?: Maybe<StripeInvoiceCreateNestedManyWithoutStripePaymentMethodInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodCreateWithoutClinicPetParentInput = {
  cardBrand: CardBrand;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutStripePaymentMethodInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripePaymentMethodInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutPaymentMethodsInput>;
  stripeId: Scalars['String'];
  stripeInvoices?: Maybe<StripeInvoiceCreateNestedManyWithoutStripePaymentMethodInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodCreateWithoutStripeCustomerInput = {
  cardBrand: CardBrand;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutStripePaymentMethodInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripePaymentMethodInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentMethodsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeId: Scalars['String'];
  stripeInvoices?: Maybe<StripeInvoiceCreateNestedManyWithoutStripePaymentMethodInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodCreateWithoutStripeInvoicesInput = {
  cardBrand: CardBrand;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutStripePaymentMethodInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripePaymentMethodInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentMethodsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutPaymentMethodsInput>;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodCreateWithoutStripePaymentIntentsInput = {
  cardBrand: CardBrand;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionCreateNestedManyWithoutStripePaymentMethodInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpCreateNestedManyWithoutStripePaymentMethodInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutStripePaymentMethodsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomer?: Maybe<StripeCustomerCreateNestedOneWithoutPaymentMethodsInput>;
  stripeId: Scalars['String'];
  stripeInvoices?: Maybe<StripeInvoiceCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodFingerprintAndCustomerIdCompoundUniqueInput = {
  fingerprint: Scalars['String'];
  stripeCustomerId: Scalars['String'];
};

export type StripePaymentMethodGroupByOutputType = {
  __typename?: 'StripePaymentMethodGroupByOutputType';
  _avg?: Maybe<StripePaymentMethodAvgAggregateOutputType>;
  _count?: Maybe<StripePaymentMethodCountAggregateOutputType>;
  _max?: Maybe<StripePaymentMethodMaxAggregateOutputType>;
  _min?: Maybe<StripePaymentMethodMinAggregateOutputType>;
  _sum?: Maybe<StripePaymentMethodSumAggregateOutputType>;
  cardBrand: CardBrand;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isExpired: Scalars['Boolean'];
  isReusable: Scalars['Boolean'];
  last4: Scalars['String'];
  permitsFutureUsage: Scalars['Boolean'];
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  type: StripePaymentMethodType;
  updatedAt: Scalars['DateTime'];
};

export type StripePaymentMethodListRelationFilter = {
  every?: Maybe<StripePaymentMethodWhereInput>;
  none?: Maybe<StripePaymentMethodWhereInput>;
  some?: Maybe<StripePaymentMethodWhereInput>;
};

export type StripePaymentMethodMaxAggregateOutputType = {
  __typename?: 'StripePaymentMethodMaxAggregateOutputType';
  cardBrand?: Maybe<CardBrand>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodMaxOrderByAggregateInput = {
  cardBrand?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationMonth?: Maybe<SortOrder>;
  expirationYear?: Maybe<SortOrder>;
  fingerprint?: Maybe<SortOrder>;
  funding?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExpired?: Maybe<SortOrder>;
  isReusable?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  permitsFutureUsage?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePaymentMethodMinAggregateOutputType = {
  __typename?: 'StripePaymentMethodMinAggregateOutputType';
  cardBrand?: Maybe<CardBrand>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodMinOrderByAggregateInput = {
  cardBrand?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationMonth?: Maybe<SortOrder>;
  expirationYear?: Maybe<SortOrder>;
  fingerprint?: Maybe<SortOrder>;
  funding?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExpired?: Maybe<SortOrder>;
  isReusable?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  permitsFutureUsage?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePaymentMethodNullableScalarRelationFilter = {
  AND?: Maybe<Array<StripePaymentMethodWhereInput>>;
  NOT?: Maybe<Array<StripePaymentMethodWhereInput>>;
  OR?: Maybe<Array<StripePaymentMethodWhereInput>>;
  cardBrand?: Maybe<EnumCardBrandFilter>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expirationMonth?: Maybe<IntFilter>;
  expirationYear?: Maybe<IntFilter>;
  fingerprint?: Maybe<StringNullableFilter>;
  funding?: Maybe<EnumCardFundingNullableFilter>;
  id?: Maybe<StringFilter>;
  isDefault?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isExpired?: Maybe<BoolFilter>;
  isReusable?: Maybe<BoolFilter>;
  last4?: Maybe<StringFilter>;
  permitsFutureUsage?: Maybe<BoolFilter>;
  stripeCustomer?: Maybe<StripeCustomerNullableScalarRelationFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripeId?: Maybe<StringFilter>;
  stripeInvoices?: Maybe<StripeInvoiceListRelationFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  type?: Maybe<EnumStripePaymentMethodTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePaymentMethodOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StripePaymentMethodOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripePaymentMethodOrderByRelevanceInput>;
  cardBrand?: Maybe<SortOrder>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionOrderByRelationAggregateInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpOrderByRelationAggregateInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationMonth?: Maybe<SortOrder>;
  expirationYear?: Maybe<SortOrder>;
  fingerprint?: Maybe<SortOrder>;
  funding?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExpired?: Maybe<SortOrder>;
  isReusable?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  permitsFutureUsage?: Maybe<SortOrder>;
  stripeCustomer?: Maybe<StripeCustomerOrderByWithRelationInput>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripeInvoices?: Maybe<StripeInvoiceOrderByRelationAggregateInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripePaymentMethodOrderByRelevanceFieldEnum {
  ClinicPetParentId = 'clinicPetParentId',
  Fingerprint = 'fingerprint',
  Id = 'id',
  Last4 = 'last4',
  StripeCustomerId = 'stripeCustomerId',
  StripeId = 'stripeId'
}

export type StripePaymentMethodOrderByRelevanceInput = {
  fields: Array<StripePaymentMethodOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripePaymentMethodOrderByWithAggregationInput = {
  _avg?: Maybe<StripePaymentMethodAvgOrderByAggregateInput>;
  _count?: Maybe<StripePaymentMethodCountOrderByAggregateInput>;
  _max?: Maybe<StripePaymentMethodMaxOrderByAggregateInput>;
  _min?: Maybe<StripePaymentMethodMinOrderByAggregateInput>;
  _sum?: Maybe<StripePaymentMethodSumOrderByAggregateInput>;
  cardBrand?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationMonth?: Maybe<SortOrder>;
  expirationYear?: Maybe<SortOrder>;
  fingerprint?: Maybe<SortOrder>;
  funding?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExpired?: Maybe<SortOrder>;
  isReusable?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  permitsFutureUsage?: Maybe<SortOrder>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePaymentMethodOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripePaymentMethodOrderByRelevanceInput>;
  cardBrand?: Maybe<SortOrder>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionOrderByRelationAggregateInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpOrderByRelationAggregateInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationMonth?: Maybe<SortOrder>;
  expirationYear?: Maybe<SortOrder>;
  fingerprint?: Maybe<SortOrder>;
  funding?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExpired?: Maybe<SortOrder>;
  isReusable?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  permitsFutureUsage?: Maybe<SortOrder>;
  stripeCustomer?: Maybe<StripeCustomerOrderByWithRelationInput>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripeInvoices?: Maybe<StripeInvoiceOrderByRelationAggregateInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePaymentMethodOrderByWithRelationInput = {
  _relevance?: Maybe<StripePaymentMethodOrderByRelevanceInput>;
  cardBrand?: Maybe<SortOrder>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionOrderByRelationAggregateInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpOrderByRelationAggregateInput>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expirationMonth?: Maybe<SortOrder>;
  expirationYear?: Maybe<SortOrder>;
  fingerprint?: Maybe<SortOrder>;
  funding?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDefault?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  isExpired?: Maybe<SortOrder>;
  isReusable?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  permitsFutureUsage?: Maybe<SortOrder>;
  stripeCustomer?: Maybe<StripeCustomerOrderByWithRelationInput>;
  stripeCustomerId?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripeInvoices?: Maybe<StripeInvoiceOrderByRelationAggregateInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripePaymentMethodScalarFieldEnum {
  CardBrand = 'cardBrand',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  ExpirationMonth = 'expirationMonth',
  ExpirationYear = 'expirationYear',
  Fingerprint = 'fingerprint',
  Funding = 'funding',
  Id = 'id',
  IsDefault = 'isDefault',
  IsDeleted = 'isDeleted',
  IsExpired = 'isExpired',
  IsReusable = 'isReusable',
  Last4 = 'last4',
  PermitsFutureUsage = 'permitsFutureUsage',
  StripeCustomerId = 'stripeCustomerId',
  StripeId = 'stripeId',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type StripePaymentMethodScalarWhereInput = {
  AND?: Maybe<Array<StripePaymentMethodScalarWhereInput>>;
  NOT?: Maybe<Array<StripePaymentMethodScalarWhereInput>>;
  OR?: Maybe<Array<StripePaymentMethodScalarWhereInput>>;
  cardBrand?: Maybe<EnumCardBrandFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expirationMonth?: Maybe<IntFilter>;
  expirationYear?: Maybe<IntFilter>;
  fingerprint?: Maybe<StringNullableFilter>;
  funding?: Maybe<EnumCardFundingNullableFilter>;
  id?: Maybe<StringFilter>;
  isDefault?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isExpired?: Maybe<BoolFilter>;
  isReusable?: Maybe<BoolFilter>;
  last4?: Maybe<StringFilter>;
  permitsFutureUsage?: Maybe<BoolFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripeId?: Maybe<StringFilter>;
  type?: Maybe<EnumStripePaymentMethodTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePaymentMethodScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripePaymentMethodScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripePaymentMethodScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripePaymentMethodScalarWhereWithAggregatesInput>>;
  cardBrand?: Maybe<EnumCardBrandWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  expirationMonth?: Maybe<IntWithAggregatesFilter>;
  expirationYear?: Maybe<IntWithAggregatesFilter>;
  fingerprint?: Maybe<StringNullableWithAggregatesFilter>;
  funding?: Maybe<EnumCardFundingNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDefault?: Maybe<BoolWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  isExpired?: Maybe<BoolWithAggregatesFilter>;
  isReusable?: Maybe<BoolWithAggregatesFilter>;
  last4?: Maybe<StringWithAggregatesFilter>;
  permitsFutureUsage?: Maybe<BoolWithAggregatesFilter>;
  stripeCustomerId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeId?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumStripePaymentMethodTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type StripePaymentMethodSumAggregateOutputType = {
  __typename?: 'StripePaymentMethodSumAggregateOutputType';
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
};

export type StripePaymentMethodSumOrderByAggregateInput = {
  expirationMonth?: Maybe<SortOrder>;
  expirationYear?: Maybe<SortOrder>;
};

export enum StripePaymentMethodType {
  CardNotPresent = 'CardNotPresent',
  CardPresent = 'CardPresent'
}

export type StripePaymentMethodUncheckedCreateInput = {
  cardBrand: CardBrand;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripeInvoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentMethodCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<StripePaymentMethodCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<StripePaymentMethodCreateManyClinicPetParentInputEnvelope>;
};

export type StripePaymentMethodUncheckedCreateNestedManyWithoutStripeCustomerInput = {
  connect?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentMethodCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<StripePaymentMethodCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<StripePaymentMethodCreateManyStripeCustomerInputEnvelope>;
};

export type StripePaymentMethodUncheckedCreateWithoutCareStripeSubscriptionsInput = {
  cardBrand: CardBrand;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripeInvoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedCreateWithoutCareSubscriptionTrueUpsInput = {
  cardBrand: CardBrand;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripeInvoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedCreateWithoutClinicPetParentInput = {
  cardBrand: CardBrand;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripeInvoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedCreateWithoutStripeCustomerInput = {
  cardBrand: CardBrand;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeId: Scalars['String'];
  stripeInvoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedCreateWithoutStripeInvoicesInput = {
  cardBrand: CardBrand;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedCreateWithoutStripePaymentIntentsInput = {
  cardBrand: CardBrand;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripeInvoices?: Maybe<StripeInvoiceUncheckedCreateNestedManyWithoutStripePaymentMethodInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedUpdateInput = {
  cardBrand?: Maybe<CardBrand>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedUpdateManyInput = {
  cardBrand?: Maybe<CardBrand>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentInput = {
  cardBrand?: Maybe<CardBrand>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentMethodCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<StripePaymentMethodCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<StripePaymentMethodCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentMethodScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentMethodUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<StripePaymentMethodUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<StripePaymentMethodUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type StripePaymentMethodUncheckedUpdateManyWithoutStripeCustomerInput = {
  cardBrand?: Maybe<CardBrand>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedUpdateManyWithoutStripeCustomerNestedInput = {
  connect?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentMethodCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<StripePaymentMethodCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<StripePaymentMethodCreateManyStripeCustomerInputEnvelope>;
  delete?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentMethodScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentMethodUpdateWithWhereUniqueWithoutStripeCustomerInput>>;
  updateMany?: Maybe<Array<StripePaymentMethodUpdateManyWithWhereWithoutStripeCustomerInput>>;
  upsert?: Maybe<Array<StripePaymentMethodUpsertWithWhereUniqueWithoutStripeCustomerInput>>;
};

export type StripePaymentMethodUncheckedUpdateWithoutCareStripeSubscriptionsInput = {
  cardBrand?: Maybe<CardBrand>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedUpdateWithoutCareSubscriptionTrueUpsInput = {
  cardBrand?: Maybe<CardBrand>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedUpdateWithoutClinicPetParentInput = {
  cardBrand?: Maybe<CardBrand>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedUpdateWithoutStripeCustomerInput = {
  cardBrand?: Maybe<CardBrand>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedUpdateWithoutStripeInvoicesInput = {
  cardBrand?: Maybe<CardBrand>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUncheckedUpdateWithoutStripePaymentIntentsInput = {
  cardBrand?: Maybe<CardBrand>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceUncheckedUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUpdateInput = {
  cardBrand?: Maybe<CardBrand>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutStripePaymentMethodNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripePaymentMethodNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentMethodsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutPaymentMethodsNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceUpdateManyWithoutStripePaymentMethodNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUpdateManyMutationInput = {
  cardBrand?: Maybe<CardBrand>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: StripePaymentMethodUpdateManyMutationInput;
  where: StripePaymentMethodScalarWhereInput;
};

export type StripePaymentMethodUpdateManyWithWhereWithoutStripeCustomerInput = {
  data: StripePaymentMethodUpdateManyMutationInput;
  where: StripePaymentMethodScalarWhereInput;
};

export type StripePaymentMethodUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentMethodCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<StripePaymentMethodCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<StripePaymentMethodCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentMethodScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentMethodUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<StripePaymentMethodUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<StripePaymentMethodUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type StripePaymentMethodUpdateManyWithoutStripeCustomerNestedInput = {
  connect?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePaymentMethodCreateOrConnectWithoutStripeCustomerInput>>;
  create?: Maybe<Array<StripePaymentMethodCreateWithoutStripeCustomerInput>>;
  createMany?: Maybe<StripePaymentMethodCreateManyStripeCustomerInputEnvelope>;
  delete?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePaymentMethodScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  set?: Maybe<Array<StripePaymentMethodWhereUniqueInput>>;
  update?: Maybe<Array<StripePaymentMethodUpdateWithWhereUniqueWithoutStripeCustomerInput>>;
  updateMany?: Maybe<Array<StripePaymentMethodUpdateManyWithWhereWithoutStripeCustomerInput>>;
  upsert?: Maybe<Array<StripePaymentMethodUpsertWithWhereUniqueWithoutStripeCustomerInput>>;
};

export type StripePaymentMethodUpdateOneWithoutCareStripeSubscriptionsNestedInput = {
  connect?: Maybe<StripePaymentMethodWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentMethodCreateOrConnectWithoutCareStripeSubscriptionsInput>;
  create?: Maybe<StripePaymentMethodCreateWithoutCareStripeSubscriptionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePaymentMethodUpdateToOneWithWhereWithoutCareStripeSubscriptionsInput>;
  upsert?: Maybe<StripePaymentMethodUpsertWithoutCareStripeSubscriptionsInput>;
};

export type StripePaymentMethodUpdateOneWithoutCareSubscriptionTrueUpsNestedInput = {
  connect?: Maybe<StripePaymentMethodWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentMethodCreateOrConnectWithoutCareSubscriptionTrueUpsInput>;
  create?: Maybe<StripePaymentMethodCreateWithoutCareSubscriptionTrueUpsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePaymentMethodUpdateToOneWithWhereWithoutCareSubscriptionTrueUpsInput>;
  upsert?: Maybe<StripePaymentMethodUpsertWithoutCareSubscriptionTrueUpsInput>;
};

export type StripePaymentMethodUpdateOneWithoutStripeInvoicesNestedInput = {
  connect?: Maybe<StripePaymentMethodWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentMethodCreateOrConnectWithoutStripeInvoicesInput>;
  create?: Maybe<StripePaymentMethodCreateWithoutStripeInvoicesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePaymentMethodUpdateToOneWithWhereWithoutStripeInvoicesInput>;
  upsert?: Maybe<StripePaymentMethodUpsertWithoutStripeInvoicesInput>;
};

export type StripePaymentMethodUpdateOneWithoutStripePaymentIntentsNestedInput = {
  connect?: Maybe<StripePaymentMethodWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePaymentMethodCreateOrConnectWithoutStripePaymentIntentsInput>;
  create?: Maybe<StripePaymentMethodCreateWithoutStripePaymentIntentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePaymentMethodUpdateToOneWithWhereWithoutStripePaymentIntentsInput>;
  upsert?: Maybe<StripePaymentMethodUpsertWithoutStripePaymentIntentsInput>;
};

export type StripePaymentMethodUpdateToOneWithWhereWithoutCareStripeSubscriptionsInput = {
  data: StripePaymentMethodUpdateWithoutCareStripeSubscriptionsInput;
  where?: Maybe<StripePaymentMethodWhereInput>;
};

export type StripePaymentMethodUpdateToOneWithWhereWithoutCareSubscriptionTrueUpsInput = {
  data: StripePaymentMethodUpdateWithoutCareSubscriptionTrueUpsInput;
  where?: Maybe<StripePaymentMethodWhereInput>;
};

export type StripePaymentMethodUpdateToOneWithWhereWithoutStripeInvoicesInput = {
  data: StripePaymentMethodUpdateWithoutStripeInvoicesInput;
  where?: Maybe<StripePaymentMethodWhereInput>;
};

export type StripePaymentMethodUpdateToOneWithWhereWithoutStripePaymentIntentsInput = {
  data: StripePaymentMethodUpdateWithoutStripePaymentIntentsInput;
  where?: Maybe<StripePaymentMethodWhereInput>;
};

export type StripePaymentMethodUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: StripePaymentMethodUpdateWithoutClinicPetParentInput;
  where: StripePaymentMethodWhereUniqueInput;
};

export type StripePaymentMethodUpdateWithWhereUniqueWithoutStripeCustomerInput = {
  data: StripePaymentMethodUpdateWithoutStripeCustomerInput;
  where: StripePaymentMethodWhereUniqueInput;
};

export type StripePaymentMethodUpdateWithoutCareStripeSubscriptionsInput = {
  cardBrand?: Maybe<CardBrand>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripePaymentMethodNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentMethodsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutPaymentMethodsNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceUpdateManyWithoutStripePaymentMethodNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUpdateWithoutCareSubscriptionTrueUpsInput = {
  cardBrand?: Maybe<CardBrand>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutStripePaymentMethodNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentMethodsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutPaymentMethodsNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceUpdateManyWithoutStripePaymentMethodNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUpdateWithoutClinicPetParentInput = {
  cardBrand?: Maybe<CardBrand>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutStripePaymentMethodNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripePaymentMethodNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutPaymentMethodsNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceUpdateManyWithoutStripePaymentMethodNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUpdateWithoutStripeCustomerInput = {
  cardBrand?: Maybe<CardBrand>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutStripePaymentMethodNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripePaymentMethodNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentMethodsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceUpdateManyWithoutStripePaymentMethodNestedInput>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUpdateWithoutStripeInvoicesInput = {
  cardBrand?: Maybe<CardBrand>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutStripePaymentMethodNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripePaymentMethodNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentMethodsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutPaymentMethodsNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUpdateWithoutStripePaymentIntentsInput = {
  cardBrand?: Maybe<CardBrand>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionUpdateManyWithoutStripePaymentMethodNestedInput>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpUpdateManyWithoutStripePaymentMethodNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutStripePaymentMethodsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<CardFunding>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isReusable?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  permitsFutureUsage?: Maybe<Scalars['Boolean']>;
  stripeCustomer?: Maybe<StripeCustomerUpdateOneWithoutPaymentMethodsNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceUpdateManyWithoutStripePaymentMethodNestedInput>;
  type?: Maybe<StripePaymentMethodType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePaymentMethodUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: StripePaymentMethodCreateWithoutClinicPetParentInput;
  update: StripePaymentMethodUpdateWithoutClinicPetParentInput;
  where: StripePaymentMethodWhereUniqueInput;
};

export type StripePaymentMethodUpsertWithWhereUniqueWithoutStripeCustomerInput = {
  create: StripePaymentMethodCreateWithoutStripeCustomerInput;
  update: StripePaymentMethodUpdateWithoutStripeCustomerInput;
  where: StripePaymentMethodWhereUniqueInput;
};

export type StripePaymentMethodUpsertWithoutCareStripeSubscriptionsInput = {
  create: StripePaymentMethodCreateWithoutCareStripeSubscriptionsInput;
  update: StripePaymentMethodUpdateWithoutCareStripeSubscriptionsInput;
  where?: Maybe<StripePaymentMethodWhereInput>;
};

export type StripePaymentMethodUpsertWithoutCareSubscriptionTrueUpsInput = {
  create: StripePaymentMethodCreateWithoutCareSubscriptionTrueUpsInput;
  update: StripePaymentMethodUpdateWithoutCareSubscriptionTrueUpsInput;
  where?: Maybe<StripePaymentMethodWhereInput>;
};

export type StripePaymentMethodUpsertWithoutStripeInvoicesInput = {
  create: StripePaymentMethodCreateWithoutStripeInvoicesInput;
  update: StripePaymentMethodUpdateWithoutStripeInvoicesInput;
  where?: Maybe<StripePaymentMethodWhereInput>;
};

export type StripePaymentMethodUpsertWithoutStripePaymentIntentsInput = {
  create: StripePaymentMethodCreateWithoutStripePaymentIntentsInput;
  update: StripePaymentMethodUpdateWithoutStripePaymentIntentsInput;
  where?: Maybe<StripePaymentMethodWhereInput>;
};

export type StripePaymentMethodWhereInput = {
  AND?: Maybe<Array<StripePaymentMethodWhereInput>>;
  NOT?: Maybe<Array<StripePaymentMethodWhereInput>>;
  OR?: Maybe<Array<StripePaymentMethodWhereInput>>;
  cardBrand?: Maybe<EnumCardBrandFilter>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expirationMonth?: Maybe<IntFilter>;
  expirationYear?: Maybe<IntFilter>;
  fingerprint?: Maybe<StringNullableFilter>;
  funding?: Maybe<EnumCardFundingNullableFilter>;
  id?: Maybe<StringFilter>;
  isDefault?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isExpired?: Maybe<BoolFilter>;
  isReusable?: Maybe<BoolFilter>;
  last4?: Maybe<StringFilter>;
  permitsFutureUsage?: Maybe<BoolFilter>;
  stripeCustomer?: Maybe<StripeCustomerNullableScalarRelationFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripeId?: Maybe<StringFilter>;
  stripeInvoices?: Maybe<StripeInvoiceListRelationFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  type?: Maybe<EnumStripePaymentMethodTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePaymentMethodWhereUniqueInput = {
  AND?: Maybe<Array<StripePaymentMethodWhereInput>>;
  NOT?: Maybe<Array<StripePaymentMethodWhereInput>>;
  OR?: Maybe<Array<StripePaymentMethodWhereInput>>;
  cardBrand?: Maybe<EnumCardBrandFilter>;
  careStripeSubscriptions?: Maybe<CareStripeSubscriptionListRelationFilter>;
  careSubscriptionTrueUps?: Maybe<CareSubscriptionTrueUpListRelationFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expirationMonth?: Maybe<IntFilter>;
  expirationYear?: Maybe<IntFilter>;
  fingerprint?: Maybe<StringNullableFilter>;
  fingerprintAndCustomerId?: Maybe<StripePaymentMethodFingerprintAndCustomerIdCompoundUniqueInput>;
  funding?: Maybe<EnumCardFundingNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  isExpired?: Maybe<BoolFilter>;
  isReusable?: Maybe<BoolFilter>;
  last4?: Maybe<StringFilter>;
  permitsFutureUsage?: Maybe<BoolFilter>;
  stripeCustomer?: Maybe<StripeCustomerNullableScalarRelationFilter>;
  stripeCustomerId?: Maybe<StringNullableFilter>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInvoices?: Maybe<StripeInvoiceListRelationFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  type?: Maybe<EnumStripePaymentMethodTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePaymentOutput = {
  __typename?: 'StripePaymentOutput';
  payment: StripePayment;
  paymentIntentClientSecret?: Maybe<Scalars['String']>;
  requiresAction?: Maybe<Scalars['Boolean']>;
};

export enum StripePaymentTransferType {
  ApplicationFee = 'Application_Fee',
  TransferData = 'Transfer_Data'
}

export type StripePayout = {
  __typename?: 'StripePayout';
  _count: StripePayoutCountOutputType;
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  financialTransactions: Array<FinancialTransaction>;
  id: Scalars['String'];
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriod>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes: Array<StripeDispute>;
  stripeId: Scalars['String'];
  stripePaymentIntents: Array<StripePaymentIntent>;
  stripePayoutAccount?: Maybe<StripePayoutAccount>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  stripeRefunds: Array<StripeRefund>;
  updatedAt: Scalars['DateTime'];
};


export type StripePayoutFinancialTransactionsArgs = {
  cursor?: Maybe<FinancialTransactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FinancialTransactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FinancialTransactionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type StripePayoutPayoutBatchingPeriodArgs = {
  where?: Maybe<PayoutBatchingPeriodWhereInput>;
};


export type StripePayoutStripeDisputesArgs = {
  cursor?: Maybe<StripeDisputeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeDisputeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeDisputeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeDisputeWhereInput>;
};


export type StripePayoutStripePaymentIntentsArgs = {
  cursor?: Maybe<StripePaymentIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type StripePayoutStripePayoutAccountArgs = {
  where?: Maybe<StripePayoutAccountWhereInput>;
};


export type StripePayoutStripeRefundsArgs = {
  cursor?: Maybe<StripeRefundWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeRefundScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeRefundOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeRefundWhereInput>;
};

export type StripePayoutAccount = {
  __typename?: 'StripePayoutAccount';
  _count: StripePayoutAccountCountOutputType;
  bankName?: Maybe<Scalars['String']>;
  clinics: Array<Clinic>;
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  default: Scalars['Boolean'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  last4: Scalars['String'];
  stripeId: Scalars['String'];
  stripePayouts: Array<StripePayout>;
  type: StripePayoutAccountType;
  updatedAt: Scalars['DateTime'];
};


export type StripePayoutAccountClinicsArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type StripePayoutAccountStripePayoutsArgs = {
  cursor?: Maybe<StripePayoutWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePayoutScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePayoutOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePayoutWhereInput>;
};

export type StripePayoutAccountCountAggregateOutputType = {
  __typename?: 'StripePayoutAccountCountAggregateOutputType';
  _all: Scalars['Int'];
  bankName: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  last4: Scalars['Int'];
  stripeId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StripePayoutAccountCountOrderByAggregateInput = {
  bankName?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePayoutAccountCountOutputType = {
  __typename?: 'StripePayoutAccountCountOutputType';
  clinics: Scalars['Int'];
  stripePayouts: Scalars['Int'];
};

export type StripePayoutAccountCreateInput = {
  bankName?: Maybe<Scalars['String']>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutStripePayoutAccountsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  stripeId: Scalars['String'];
  stripePayouts?: Maybe<StripePayoutCreateNestedManyWithoutStripePayoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountCreateManyInput = {
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountCreateNestedManyWithoutClinicsInput = {
  connect?: Maybe<Array<StripePayoutAccountWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePayoutAccountCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<StripePayoutAccountCreateWithoutClinicsInput>>;
};

export type StripePayoutAccountCreateNestedOneWithoutStripePayoutsInput = {
  connect?: Maybe<StripePayoutAccountWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutAccountCreateOrConnectWithoutStripePayoutsInput>;
  create?: Maybe<StripePayoutAccountCreateWithoutStripePayoutsInput>;
};

export type StripePayoutAccountCreateOrConnectWithoutClinicsInput = {
  create: StripePayoutAccountCreateWithoutClinicsInput;
  where: StripePayoutAccountWhereUniqueInput;
};

export type StripePayoutAccountCreateOrConnectWithoutStripePayoutsInput = {
  create: StripePayoutAccountCreateWithoutStripePayoutsInput;
  where: StripePayoutAccountWhereUniqueInput;
};

export type StripePayoutAccountCreateWithoutClinicsInput = {
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  stripeId: Scalars['String'];
  stripePayouts?: Maybe<StripePayoutCreateNestedManyWithoutStripePayoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountCreateWithoutStripePayoutsInput = {
  bankName?: Maybe<Scalars['String']>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutStripePayoutAccountsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountGroupByOutputType = {
  __typename?: 'StripePayoutAccountGroupByOutputType';
  _count?: Maybe<StripePayoutAccountCountAggregateOutputType>;
  _max?: Maybe<StripePayoutAccountMaxAggregateOutputType>;
  _min?: Maybe<StripePayoutAccountMinAggregateOutputType>;
  bankName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  last4: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type StripePayoutAccountListRelationFilter = {
  every?: Maybe<StripePayoutAccountWhereInput>;
  none?: Maybe<StripePayoutAccountWhereInput>;
  some?: Maybe<StripePayoutAccountWhereInput>;
};

export type StripePayoutAccountMaxAggregateOutputType = {
  __typename?: 'StripePayoutAccountMaxAggregateOutputType';
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountMaxOrderByAggregateInput = {
  bankName?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePayoutAccountMinAggregateOutputType = {
  __typename?: 'StripePayoutAccountMinAggregateOutputType';
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountMinOrderByAggregateInput = {
  bankName?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePayoutAccountNullableScalarRelationFilter = {
  AND?: Maybe<Array<StripePayoutAccountWhereInput>>;
  NOT?: Maybe<Array<StripePayoutAccountWhereInput>>;
  OR?: Maybe<Array<StripePayoutAccountWhereInput>>;
  bankName?: Maybe<StringNullableFilter>;
  clinics?: Maybe<ClinicListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  last4?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePayouts?: Maybe<StripePayoutListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePayoutAccountOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StripePayoutAccountOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripePayoutAccountOrderByRelevanceInput>;
  bankName?: Maybe<SortOrder>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePayouts?: Maybe<StripePayoutOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripePayoutAccountOrderByRelevanceFieldEnum {
  BankName = 'bankName',
  Id = 'id',
  Last4 = 'last4',
  StripeId = 'stripeId'
}

export type StripePayoutAccountOrderByRelevanceInput = {
  fields: Array<StripePayoutAccountOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripePayoutAccountOrderByWithAggregationInput = {
  _count?: Maybe<StripePayoutAccountCountOrderByAggregateInput>;
  _max?: Maybe<StripePayoutAccountMaxOrderByAggregateInput>;
  _min?: Maybe<StripePayoutAccountMinOrderByAggregateInput>;
  bankName?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePayoutAccountOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripePayoutAccountOrderByRelevanceInput>;
  bankName?: Maybe<SortOrder>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePayouts?: Maybe<StripePayoutOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePayoutAccountOrderByWithRelationInput = {
  _relevance?: Maybe<StripePayoutAccountOrderByRelevanceInput>;
  bankName?: Maybe<SortOrder>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  last4?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePayouts?: Maybe<StripePayoutOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripePayoutAccountScalarFieldEnum {
  BankName = 'bankName',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Last4 = 'last4',
  StripeId = 'stripeId',
  UpdatedAt = 'updatedAt'
}

export type StripePayoutAccountScalarWhereInput = {
  AND?: Maybe<Array<StripePayoutAccountScalarWhereInput>>;
  NOT?: Maybe<Array<StripePayoutAccountScalarWhereInput>>;
  OR?: Maybe<Array<StripePayoutAccountScalarWhereInput>>;
  bankName?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  last4?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePayoutAccountScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripePayoutAccountScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripePayoutAccountScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripePayoutAccountScalarWhereWithAggregatesInput>>;
  bankName?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  last4?: Maybe<StringWithAggregatesFilter>;
  stripeId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum StripePayoutAccountType {
  BankAccount = 'bank_account',
  Card = 'card'
}

export type StripePayoutAccountUncheckedCreateInput = {
  bankName?: Maybe<Scalars['String']>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutStripePayoutAccountsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  stripeId: Scalars['String'];
  stripePayouts?: Maybe<StripePayoutUncheckedCreateNestedManyWithoutStripePayoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountUncheckedCreateNestedManyWithoutClinicsInput = {
  connect?: Maybe<Array<StripePayoutAccountWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePayoutAccountCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<StripePayoutAccountCreateWithoutClinicsInput>>;
};

export type StripePayoutAccountUncheckedCreateWithoutClinicsInput = {
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  stripeId: Scalars['String'];
  stripePayouts?: Maybe<StripePayoutUncheckedCreateNestedManyWithoutStripePayoutAccountInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountUncheckedCreateWithoutStripePayoutsInput = {
  bankName?: Maybe<Scalars['String']>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutStripePayoutAccountsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountUncheckedUpdateInput = {
  bankName?: Maybe<Scalars['String']>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutStripePayoutAccountsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayouts?: Maybe<StripePayoutUncheckedUpdateManyWithoutStripePayoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountUncheckedUpdateManyInput = {
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountUncheckedUpdateManyWithoutClinicsInput = {
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountUncheckedUpdateManyWithoutClinicsNestedInput = {
  connect?: Maybe<Array<StripePayoutAccountWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePayoutAccountCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<StripePayoutAccountCreateWithoutClinicsInput>>;
  delete?: Maybe<Array<StripePayoutAccountWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePayoutAccountScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePayoutAccountWhereUniqueInput>>;
  set?: Maybe<Array<StripePayoutAccountWhereUniqueInput>>;
  update?: Maybe<Array<StripePayoutAccountUpdateWithWhereUniqueWithoutClinicsInput>>;
  updateMany?: Maybe<Array<StripePayoutAccountUpdateManyWithWhereWithoutClinicsInput>>;
  upsert?: Maybe<Array<StripePayoutAccountUpsertWithWhereUniqueWithoutClinicsInput>>;
};

export type StripePayoutAccountUncheckedUpdateWithoutClinicsInput = {
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayouts?: Maybe<StripePayoutUncheckedUpdateManyWithoutStripePayoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountUncheckedUpdateWithoutStripePayoutsInput = {
  bankName?: Maybe<Scalars['String']>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutStripePayoutAccountsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountUpdateInput = {
  bankName?: Maybe<Scalars['String']>;
  clinics?: Maybe<ClinicUpdateManyWithoutStripePayoutAccountsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayouts?: Maybe<StripePayoutUpdateManyWithoutStripePayoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountUpdateManyMutationInput = {
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountUpdateManyWithWhereWithoutClinicsInput = {
  data: StripePayoutAccountUpdateManyMutationInput;
  where: StripePayoutAccountScalarWhereInput;
};

export type StripePayoutAccountUpdateManyWithoutClinicsNestedInput = {
  connect?: Maybe<Array<StripePayoutAccountWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePayoutAccountCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<StripePayoutAccountCreateWithoutClinicsInput>>;
  delete?: Maybe<Array<StripePayoutAccountWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePayoutAccountScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePayoutAccountWhereUniqueInput>>;
  set?: Maybe<Array<StripePayoutAccountWhereUniqueInput>>;
  update?: Maybe<Array<StripePayoutAccountUpdateWithWhereUniqueWithoutClinicsInput>>;
  updateMany?: Maybe<Array<StripePayoutAccountUpdateManyWithWhereWithoutClinicsInput>>;
  upsert?: Maybe<Array<StripePayoutAccountUpsertWithWhereUniqueWithoutClinicsInput>>;
};

export type StripePayoutAccountUpdateOneWithoutStripePayoutsNestedInput = {
  connect?: Maybe<StripePayoutAccountWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutAccountCreateOrConnectWithoutStripePayoutsInput>;
  create?: Maybe<StripePayoutAccountCreateWithoutStripePayoutsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePayoutAccountUpdateToOneWithWhereWithoutStripePayoutsInput>;
  upsert?: Maybe<StripePayoutAccountUpsertWithoutStripePayoutsInput>;
};

export type StripePayoutAccountUpdateToOneWithWhereWithoutStripePayoutsInput = {
  data: StripePayoutAccountUpdateWithoutStripePayoutsInput;
  where?: Maybe<StripePayoutAccountWhereInput>;
};

export type StripePayoutAccountUpdateWithWhereUniqueWithoutClinicsInput = {
  data: StripePayoutAccountUpdateWithoutClinicsInput;
  where: StripePayoutAccountWhereUniqueInput;
};

export type StripePayoutAccountUpdateWithoutClinicsInput = {
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayouts?: Maybe<StripePayoutUpdateManyWithoutStripePayoutAccountNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountUpdateWithoutStripePayoutsInput = {
  bankName?: Maybe<Scalars['String']>;
  clinics?: Maybe<ClinicUpdateManyWithoutStripePayoutAccountsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutAccountUpsertWithWhereUniqueWithoutClinicsInput = {
  create: StripePayoutAccountCreateWithoutClinicsInput;
  update: StripePayoutAccountUpdateWithoutClinicsInput;
  where: StripePayoutAccountWhereUniqueInput;
};

export type StripePayoutAccountUpsertWithoutStripePayoutsInput = {
  create: StripePayoutAccountCreateWithoutStripePayoutsInput;
  update: StripePayoutAccountUpdateWithoutStripePayoutsInput;
  where?: Maybe<StripePayoutAccountWhereInput>;
};

export type StripePayoutAccountWhereInput = {
  AND?: Maybe<Array<StripePayoutAccountWhereInput>>;
  NOT?: Maybe<Array<StripePayoutAccountWhereInput>>;
  OR?: Maybe<Array<StripePayoutAccountWhereInput>>;
  bankName?: Maybe<StringNullableFilter>;
  clinics?: Maybe<ClinicListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  last4?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePayouts?: Maybe<StripePayoutListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePayoutAccountWhereUniqueInput = {
  AND?: Maybe<Array<StripePayoutAccountWhereInput>>;
  NOT?: Maybe<Array<StripePayoutAccountWhereInput>>;
  OR?: Maybe<Array<StripePayoutAccountWhereInput>>;
  bankName?: Maybe<StringNullableFilter>;
  clinics?: Maybe<ClinicListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<BoolFilter>;
  last4?: Maybe<StringFilter>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayouts?: Maybe<StripePayoutListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePayoutAvgAggregateOutputType = {
  __typename?: 'StripePayoutAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
};

export type StripePayoutAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type StripePayoutCountAggregateOutputType = {
  __typename?: 'StripePayoutCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  arrivalDate: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  initiatedAt: Scalars['Int'];
  payoutBatchingPeriodId: Scalars['Int'];
  statementDescriptor: Scalars['Int'];
  status: Scalars['Int'];
  stripeId: Scalars['Int'];
  stripePayoutAccountId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StripePayoutCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initiatedAt?: Maybe<SortOrder>;
  payoutBatchingPeriodId?: Maybe<SortOrder>;
  statementDescriptor?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePayoutAccountId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePayoutCountOutputType = {
  __typename?: 'StripePayoutCountOutputType';
  financialTransactions: Scalars['Int'];
  stripeDisputes: Scalars['Int'];
  stripePaymentIntents: Scalars['Int'];
  stripeRefunds: Scalars['Int'];
};

export type StripePayoutCreateInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutStripePayoutInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodCreateNestedOneWithoutStripePayoutInput>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes?: Maybe<StripeDisputeCreateNestedManyWithoutStripePayoutInput>;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripePayoutInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountCreateNestedOneWithoutStripePayoutsInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePayoutInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutCreateManyInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeId: Scalars['String'];
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutCreateManyStripePayoutAccountInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutCreateManyStripePayoutAccountInputEnvelope = {
  data: Array<StripePayoutCreateManyStripePayoutAccountInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripePayoutCreateNestedManyWithoutStripePayoutAccountInput = {
  connect?: Maybe<Array<StripePayoutWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePayoutCreateOrConnectWithoutStripePayoutAccountInput>>;
  create?: Maybe<Array<StripePayoutCreateWithoutStripePayoutAccountInput>>;
  createMany?: Maybe<StripePayoutCreateManyStripePayoutAccountInputEnvelope>;
};

export type StripePayoutCreateNestedOneWithoutFinancialTransactionsInput = {
  connect?: Maybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutCreateOrConnectWithoutFinancialTransactionsInput>;
  create?: Maybe<StripePayoutCreateWithoutFinancialTransactionsInput>;
};

export type StripePayoutCreateNestedOneWithoutPayoutBatchingPeriodInput = {
  connect?: Maybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutCreateOrConnectWithoutPayoutBatchingPeriodInput>;
  create?: Maybe<StripePayoutCreateWithoutPayoutBatchingPeriodInput>;
};

export type StripePayoutCreateNestedOneWithoutStripeDisputesInput = {
  connect?: Maybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutCreateOrConnectWithoutStripeDisputesInput>;
  create?: Maybe<StripePayoutCreateWithoutStripeDisputesInput>;
};

export type StripePayoutCreateNestedOneWithoutStripePaymentIntentsInput = {
  connect?: Maybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutCreateOrConnectWithoutStripePaymentIntentsInput>;
  create?: Maybe<StripePayoutCreateWithoutStripePaymentIntentsInput>;
};

export type StripePayoutCreateNestedOneWithoutStripeRefundsInput = {
  connect?: Maybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutCreateOrConnectWithoutStripeRefundsInput>;
  create?: Maybe<StripePayoutCreateWithoutStripeRefundsInput>;
};

export type StripePayoutCreateOrConnectWithoutFinancialTransactionsInput = {
  create: StripePayoutCreateWithoutFinancialTransactionsInput;
  where: StripePayoutWhereUniqueInput;
};

export type StripePayoutCreateOrConnectWithoutPayoutBatchingPeriodInput = {
  create: StripePayoutCreateWithoutPayoutBatchingPeriodInput;
  where: StripePayoutWhereUniqueInput;
};

export type StripePayoutCreateOrConnectWithoutStripeDisputesInput = {
  create: StripePayoutCreateWithoutStripeDisputesInput;
  where: StripePayoutWhereUniqueInput;
};

export type StripePayoutCreateOrConnectWithoutStripePaymentIntentsInput = {
  create: StripePayoutCreateWithoutStripePaymentIntentsInput;
  where: StripePayoutWhereUniqueInput;
};

export type StripePayoutCreateOrConnectWithoutStripePayoutAccountInput = {
  create: StripePayoutCreateWithoutStripePayoutAccountInput;
  where: StripePayoutWhereUniqueInput;
};

export type StripePayoutCreateOrConnectWithoutStripeRefundsInput = {
  create: StripePayoutCreateWithoutStripeRefundsInput;
  where: StripePayoutWhereUniqueInput;
};

export type StripePayoutCreateWithoutFinancialTransactionsInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodCreateNestedOneWithoutStripePayoutInput>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes?: Maybe<StripeDisputeCreateNestedManyWithoutStripePayoutInput>;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripePayoutInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountCreateNestedOneWithoutStripePayoutsInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePayoutInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutCreateWithoutPayoutBatchingPeriodInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutStripePayoutInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes?: Maybe<StripeDisputeCreateNestedManyWithoutStripePayoutInput>;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripePayoutInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountCreateNestedOneWithoutStripePayoutsInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePayoutInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutCreateWithoutStripeDisputesInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutStripePayoutInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodCreateNestedOneWithoutStripePayoutInput>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripePayoutInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountCreateNestedOneWithoutStripePayoutsInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePayoutInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutCreateWithoutStripePaymentIntentsInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutStripePayoutInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodCreateNestedOneWithoutStripePayoutInput>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes?: Maybe<StripeDisputeCreateNestedManyWithoutStripePayoutInput>;
  stripeId: Scalars['String'];
  stripePayoutAccount?: Maybe<StripePayoutAccountCreateNestedOneWithoutStripePayoutsInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePayoutInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutCreateWithoutStripePayoutAccountInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutStripePayoutInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodCreateNestedOneWithoutStripePayoutInput>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes?: Maybe<StripeDisputeCreateNestedManyWithoutStripePayoutInput>;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripePayoutInput>;
  stripeRefunds?: Maybe<StripeRefundCreateNestedManyWithoutStripePayoutInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutCreateWithoutStripeRefundsInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionCreateNestedManyWithoutStripePayoutInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodCreateNestedOneWithoutStripePayoutInput>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes?: Maybe<StripeDisputeCreateNestedManyWithoutStripePayoutInput>;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripePayoutInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountCreateNestedOneWithoutStripePayoutsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutGroupByOutputType = {
  __typename?: 'StripePayoutGroupByOutputType';
  _avg?: Maybe<StripePayoutAvgAggregateOutputType>;
  _count?: Maybe<StripePayoutCountAggregateOutputType>;
  _max?: Maybe<StripePayoutMaxAggregateOutputType>;
  _min?: Maybe<StripePayoutMinAggregateOutputType>;
  _sum?: Maybe<StripePayoutSumAggregateOutputType>;
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeId: Scalars['String'];
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type StripePayoutListRelationFilter = {
  every?: Maybe<StripePayoutWhereInput>;
  none?: Maybe<StripePayoutWhereInput>;
  some?: Maybe<StripePayoutWhereInput>;
};

export type StripePayoutMaxAggregateOutputType = {
  __typename?: 'StripePayoutMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initiatedAt?: Maybe<SortOrder>;
  payoutBatchingPeriodId?: Maybe<SortOrder>;
  statementDescriptor?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePayoutAccountId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePayoutMinAggregateOutputType = {
  __typename?: 'StripePayoutMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initiatedAt?: Maybe<SortOrder>;
  payoutBatchingPeriodId?: Maybe<SortOrder>;
  statementDescriptor?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePayoutAccountId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePayoutNullableScalarRelationFilter = {
  AND?: Maybe<Array<StripePayoutWhereInput>>;
  NOT?: Maybe<Array<StripePayoutWhereInput>>;
  OR?: Maybe<Array<StripePayoutWhereInput>>;
  amount?: Maybe<IntFilter>;
  arrivalDate?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  financialTransactions?: Maybe<FinancialTransactionListRelationFilter>;
  id?: Maybe<StringFilter>;
  initiatedAt?: Maybe<DateTimeNullableFilter>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodNullableScalarRelationFilter>;
  payoutBatchingPeriodId?: Maybe<StringNullableFilter>;
  statementDescriptor?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumStripePayoutStatusFilter>;
  stripeDisputes?: Maybe<StripeDisputeListRelationFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  stripePayoutAccount?: Maybe<StripePayoutAccountNullableScalarRelationFilter>;
  stripePayoutAccountId?: Maybe<StringNullableFilter>;
  stripeRefunds?: Maybe<StripeRefundListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePayoutOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StripePayoutOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripePayoutOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  financialTransactions?: Maybe<FinancialTransactionOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  initiatedAt?: Maybe<SortOrder>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodOrderByWithRelationInput>;
  payoutBatchingPeriodId?: Maybe<SortOrder>;
  statementDescriptor?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeDisputes?: Maybe<StripeDisputeOrderByRelationAggregateInput>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountOrderByWithRelationInput>;
  stripePayoutAccountId?: Maybe<SortOrder>;
  stripeRefunds?: Maybe<StripeRefundOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripePayoutOrderByRelevanceFieldEnum {
  Id = 'id',
  PayoutBatchingPeriodId = 'payoutBatchingPeriodId',
  StatementDescriptor = 'statementDescriptor',
  StripeId = 'stripeId',
  StripePayoutAccountId = 'stripePayoutAccountId'
}

export type StripePayoutOrderByRelevanceInput = {
  fields: Array<StripePayoutOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripePayoutOrderByWithAggregationInput = {
  _avg?: Maybe<StripePayoutAvgOrderByAggregateInput>;
  _count?: Maybe<StripePayoutCountOrderByAggregateInput>;
  _max?: Maybe<StripePayoutMaxOrderByAggregateInput>;
  _min?: Maybe<StripePayoutMinOrderByAggregateInput>;
  _sum?: Maybe<StripePayoutSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initiatedAt?: Maybe<SortOrder>;
  payoutBatchingPeriodId?: Maybe<SortOrder>;
  statementDescriptor?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePayoutAccountId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePayoutOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripePayoutOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  financialTransactions?: Maybe<FinancialTransactionOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  initiatedAt?: Maybe<SortOrder>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodOrderByWithRelationInput>;
  payoutBatchingPeriodId?: Maybe<SortOrder>;
  statementDescriptor?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeDisputes?: Maybe<StripeDisputeOrderByRelationAggregateInput>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountOrderByWithRelationInput>;
  stripePayoutAccountId?: Maybe<SortOrder>;
  stripeRefunds?: Maybe<StripeRefundOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripePayoutOrderByWithRelationInput = {
  _relevance?: Maybe<StripePayoutOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  arrivalDate?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  financialTransactions?: Maybe<FinancialTransactionOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  initiatedAt?: Maybe<SortOrder>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodOrderByWithRelationInput>;
  payoutBatchingPeriodId?: Maybe<SortOrder>;
  statementDescriptor?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  stripeDisputes?: Maybe<StripeDisputeOrderByRelationAggregateInput>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountOrderByWithRelationInput>;
  stripePayoutAccountId?: Maybe<SortOrder>;
  stripeRefunds?: Maybe<StripeRefundOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripePayoutScalarFieldEnum {
  Amount = 'amount',
  ArrivalDate = 'arrivalDate',
  CreatedAt = 'createdAt',
  Id = 'id',
  InitiatedAt = 'initiatedAt',
  PayoutBatchingPeriodId = 'payoutBatchingPeriodId',
  StatementDescriptor = 'statementDescriptor',
  Status = 'status',
  StripeId = 'stripeId',
  StripePayoutAccountId = 'stripePayoutAccountId',
  UpdatedAt = 'updatedAt'
}

export type StripePayoutScalarWhereInput = {
  AND?: Maybe<Array<StripePayoutScalarWhereInput>>;
  NOT?: Maybe<Array<StripePayoutScalarWhereInput>>;
  OR?: Maybe<Array<StripePayoutScalarWhereInput>>;
  amount?: Maybe<IntFilter>;
  arrivalDate?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  initiatedAt?: Maybe<DateTimeNullableFilter>;
  payoutBatchingPeriodId?: Maybe<StringNullableFilter>;
  statementDescriptor?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumStripePayoutStatusFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePayoutAccountId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePayoutScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripePayoutScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripePayoutScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripePayoutScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntWithAggregatesFilter>;
  arrivalDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  initiatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  payoutBatchingPeriodId?: Maybe<StringNullableWithAggregatesFilter>;
  statementDescriptor?: Maybe<StringNullableWithAggregatesFilter>;
  status?: Maybe<EnumStripePayoutStatusWithAggregatesFilter>;
  stripeId?: Maybe<StringWithAggregatesFilter>;
  stripePayoutAccountId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type StripePayoutSchedule = {
  __typename?: 'StripePayoutSchedule';
  automatic: Scalars['Boolean'];
  daysDelayed: Scalars['Int'];
  interval: Scalars['String'];
};

export enum StripePayoutStatus {
  Canceled = 'Canceled',
  Failed = 'Failed',
  InTransit = 'In_Transit',
  Paid = 'Paid',
  Pending = 'Pending'
}

export type StripePayoutSumAggregateOutputType = {
  __typename?: 'StripePayoutSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
};

export type StripePayoutSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type StripePayoutUncheckedCreateInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutStripePayoutInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePayoutInput>;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripePayoutInput>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePayoutInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedCreateNestedManyWithoutStripePayoutAccountInput = {
  connect?: Maybe<Array<StripePayoutWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePayoutCreateOrConnectWithoutStripePayoutAccountInput>>;
  create?: Maybe<Array<StripePayoutCreateWithoutStripePayoutAccountInput>>;
  createMany?: Maybe<StripePayoutCreateManyStripePayoutAccountInputEnvelope>;
};

export type StripePayoutUncheckedCreateNestedOneWithoutPayoutBatchingPeriodInput = {
  connect?: Maybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutCreateOrConnectWithoutPayoutBatchingPeriodInput>;
  create?: Maybe<StripePayoutCreateWithoutPayoutBatchingPeriodInput>;
};

export type StripePayoutUncheckedCreateWithoutFinancialTransactionsInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePayoutInput>;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripePayoutInput>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePayoutInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedCreateWithoutPayoutBatchingPeriodInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutStripePayoutInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePayoutInput>;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripePayoutInput>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePayoutInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedCreateWithoutStripeDisputesInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutStripePayoutInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripePayoutInput>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePayoutInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedCreateWithoutStripePaymentIntentsInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutStripePayoutInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePayoutInput>;
  stripeId: Scalars['String'];
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePayoutInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedCreateWithoutStripePayoutAccountInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutStripePayoutInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePayoutInput>;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripePayoutInput>;
  stripeRefunds?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutStripePayoutInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedCreateWithoutStripeRefundsInput = {
  amount: Scalars['Int'];
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedCreateNestedManyWithoutStripePayoutInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: StripePayoutStatus;
  stripeDisputes?: Maybe<StripeDisputeUncheckedCreateNestedManyWithoutStripePayoutInput>;
  stripeId: Scalars['String'];
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripePayoutInput>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeDisputes?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedUpdateManyWithoutStripePayoutAccountInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedUpdateManyWithoutStripePayoutAccountNestedInput = {
  connect?: Maybe<Array<StripePayoutWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePayoutCreateOrConnectWithoutStripePayoutAccountInput>>;
  create?: Maybe<Array<StripePayoutCreateWithoutStripePayoutAccountInput>>;
  createMany?: Maybe<StripePayoutCreateManyStripePayoutAccountInputEnvelope>;
  delete?: Maybe<Array<StripePayoutWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePayoutScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePayoutWhereUniqueInput>>;
  set?: Maybe<Array<StripePayoutWhereUniqueInput>>;
  update?: Maybe<Array<StripePayoutUpdateWithWhereUniqueWithoutStripePayoutAccountInput>>;
  updateMany?: Maybe<Array<StripePayoutUpdateManyWithWhereWithoutStripePayoutAccountInput>>;
  upsert?: Maybe<Array<StripePayoutUpsertWithWhereUniqueWithoutStripePayoutAccountInput>>;
};

export type StripePayoutUncheckedUpdateOneWithoutPayoutBatchingPeriodNestedInput = {
  connect?: Maybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutCreateOrConnectWithoutPayoutBatchingPeriodInput>;
  create?: Maybe<StripePayoutCreateWithoutPayoutBatchingPeriodInput>;
  delete?: Maybe<StripePayoutWhereInput>;
  disconnect?: Maybe<StripePayoutWhereInput>;
  update?: Maybe<StripePayoutUpdateToOneWithWhereWithoutPayoutBatchingPeriodInput>;
  upsert?: Maybe<StripePayoutUpsertWithoutPayoutBatchingPeriodInput>;
};

export type StripePayoutUncheckedUpdateWithoutFinancialTransactionsInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeDisputes?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedUpdateWithoutPayoutBatchingPeriodInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeDisputes?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedUpdateWithoutStripeDisputesInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedUpdateWithoutStripePaymentIntentsInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeDisputes?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedUpdateWithoutStripePayoutAccountInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeDisputes?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUncheckedUpdateWithoutStripeRefundsInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeDisputes?: Maybe<StripeDisputeUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripePayoutNestedInput>;
  stripePayoutAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutStripePayoutNestedInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodUpdateOneWithoutStripePayoutNestedInput>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeDisputes?: Maybe<StripeDisputeUpdateManyWithoutStripePayoutNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutStripePayoutNestedInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountUpdateOneWithoutStripePayoutsNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePayoutNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUpdateManyWithWhereWithoutStripePayoutAccountInput = {
  data: StripePayoutUpdateManyMutationInput;
  where: StripePayoutScalarWhereInput;
};

export type StripePayoutUpdateManyWithoutStripePayoutAccountNestedInput = {
  connect?: Maybe<Array<StripePayoutWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripePayoutCreateOrConnectWithoutStripePayoutAccountInput>>;
  create?: Maybe<Array<StripePayoutCreateWithoutStripePayoutAccountInput>>;
  createMany?: Maybe<StripePayoutCreateManyStripePayoutAccountInputEnvelope>;
  delete?: Maybe<Array<StripePayoutWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripePayoutScalarWhereInput>>;
  disconnect?: Maybe<Array<StripePayoutWhereUniqueInput>>;
  set?: Maybe<Array<StripePayoutWhereUniqueInput>>;
  update?: Maybe<Array<StripePayoutUpdateWithWhereUniqueWithoutStripePayoutAccountInput>>;
  updateMany?: Maybe<Array<StripePayoutUpdateManyWithWhereWithoutStripePayoutAccountInput>>;
  upsert?: Maybe<Array<StripePayoutUpsertWithWhereUniqueWithoutStripePayoutAccountInput>>;
};

export type StripePayoutUpdateOneWithoutFinancialTransactionsNestedInput = {
  connect?: Maybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutCreateOrConnectWithoutFinancialTransactionsInput>;
  create?: Maybe<StripePayoutCreateWithoutFinancialTransactionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePayoutUpdateToOneWithWhereWithoutFinancialTransactionsInput>;
  upsert?: Maybe<StripePayoutUpsertWithoutFinancialTransactionsInput>;
};

export type StripePayoutUpdateOneWithoutPayoutBatchingPeriodNestedInput = {
  connect?: Maybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutCreateOrConnectWithoutPayoutBatchingPeriodInput>;
  create?: Maybe<StripePayoutCreateWithoutPayoutBatchingPeriodInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePayoutUpdateToOneWithWhereWithoutPayoutBatchingPeriodInput>;
  upsert?: Maybe<StripePayoutUpsertWithoutPayoutBatchingPeriodInput>;
};

export type StripePayoutUpdateOneWithoutStripeDisputesNestedInput = {
  connect?: Maybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutCreateOrConnectWithoutStripeDisputesInput>;
  create?: Maybe<StripePayoutCreateWithoutStripeDisputesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePayoutUpdateToOneWithWhereWithoutStripeDisputesInput>;
  upsert?: Maybe<StripePayoutUpsertWithoutStripeDisputesInput>;
};

export type StripePayoutUpdateOneWithoutStripePaymentIntentsNestedInput = {
  connect?: Maybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutCreateOrConnectWithoutStripePaymentIntentsInput>;
  create?: Maybe<StripePayoutCreateWithoutStripePaymentIntentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePayoutUpdateToOneWithWhereWithoutStripePaymentIntentsInput>;
  upsert?: Maybe<StripePayoutUpsertWithoutStripePaymentIntentsInput>;
};

export type StripePayoutUpdateOneWithoutStripeRefundsNestedInput = {
  connect?: Maybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: Maybe<StripePayoutCreateOrConnectWithoutStripeRefundsInput>;
  create?: Maybe<StripePayoutCreateWithoutStripeRefundsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripePayoutUpdateToOneWithWhereWithoutStripeRefundsInput>;
  upsert?: Maybe<StripePayoutUpsertWithoutStripeRefundsInput>;
};

export type StripePayoutUpdateToOneWithWhereWithoutFinancialTransactionsInput = {
  data: StripePayoutUpdateWithoutFinancialTransactionsInput;
  where?: Maybe<StripePayoutWhereInput>;
};

export type StripePayoutUpdateToOneWithWhereWithoutPayoutBatchingPeriodInput = {
  data: StripePayoutUpdateWithoutPayoutBatchingPeriodInput;
  where?: Maybe<StripePayoutWhereInput>;
};

export type StripePayoutUpdateToOneWithWhereWithoutStripeDisputesInput = {
  data: StripePayoutUpdateWithoutStripeDisputesInput;
  where?: Maybe<StripePayoutWhereInput>;
};

export type StripePayoutUpdateToOneWithWhereWithoutStripePaymentIntentsInput = {
  data: StripePayoutUpdateWithoutStripePaymentIntentsInput;
  where?: Maybe<StripePayoutWhereInput>;
};

export type StripePayoutUpdateToOneWithWhereWithoutStripeRefundsInput = {
  data: StripePayoutUpdateWithoutStripeRefundsInput;
  where?: Maybe<StripePayoutWhereInput>;
};

export type StripePayoutUpdateWithWhereUniqueWithoutStripePayoutAccountInput = {
  data: StripePayoutUpdateWithoutStripePayoutAccountInput;
  where: StripePayoutWhereUniqueInput;
};

export type StripePayoutUpdateWithoutFinancialTransactionsInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodUpdateOneWithoutStripePayoutNestedInput>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeDisputes?: Maybe<StripeDisputeUpdateManyWithoutStripePayoutNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutStripePayoutNestedInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountUpdateOneWithoutStripePayoutsNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePayoutNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUpdateWithoutPayoutBatchingPeriodInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutStripePayoutNestedInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeDisputes?: Maybe<StripeDisputeUpdateManyWithoutStripePayoutNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutStripePayoutNestedInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountUpdateOneWithoutStripePayoutsNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePayoutNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUpdateWithoutStripeDisputesInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutStripePayoutNestedInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodUpdateOneWithoutStripePayoutNestedInput>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutStripePayoutNestedInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountUpdateOneWithoutStripePayoutsNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePayoutNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUpdateWithoutStripePaymentIntentsInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutStripePayoutNestedInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodUpdateOneWithoutStripePayoutNestedInput>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeDisputes?: Maybe<StripeDisputeUpdateManyWithoutStripePayoutNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayoutAccount?: Maybe<StripePayoutAccountUpdateOneWithoutStripePayoutsNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePayoutNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUpdateWithoutStripePayoutAccountInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutStripePayoutNestedInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodUpdateOneWithoutStripePayoutNestedInput>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeDisputes?: Maybe<StripeDisputeUpdateManyWithoutStripePayoutNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutStripePayoutNestedInput>;
  stripeRefunds?: Maybe<StripeRefundUpdateManyWithoutStripePayoutNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUpdateWithoutStripeRefundsInput = {
  amount?: Maybe<Scalars['Int']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransactions?: Maybe<FinancialTransactionUpdateManyWithoutStripePayoutNestedInput>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodUpdateOneWithoutStripePayoutNestedInput>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<StripePayoutStatus>;
  stripeDisputes?: Maybe<StripeDisputeUpdateManyWithoutStripePayoutNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutStripePayoutNestedInput>;
  stripePayoutAccount?: Maybe<StripePayoutAccountUpdateOneWithoutStripePayoutsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePayoutUpsertWithWhereUniqueWithoutStripePayoutAccountInput = {
  create: StripePayoutCreateWithoutStripePayoutAccountInput;
  update: StripePayoutUpdateWithoutStripePayoutAccountInput;
  where: StripePayoutWhereUniqueInput;
};

export type StripePayoutUpsertWithoutFinancialTransactionsInput = {
  create: StripePayoutCreateWithoutFinancialTransactionsInput;
  update: StripePayoutUpdateWithoutFinancialTransactionsInput;
  where?: Maybe<StripePayoutWhereInput>;
};

export type StripePayoutUpsertWithoutPayoutBatchingPeriodInput = {
  create: StripePayoutCreateWithoutPayoutBatchingPeriodInput;
  update: StripePayoutUpdateWithoutPayoutBatchingPeriodInput;
  where?: Maybe<StripePayoutWhereInput>;
};

export type StripePayoutUpsertWithoutStripeDisputesInput = {
  create: StripePayoutCreateWithoutStripeDisputesInput;
  update: StripePayoutUpdateWithoutStripeDisputesInput;
  where?: Maybe<StripePayoutWhereInput>;
};

export type StripePayoutUpsertWithoutStripePaymentIntentsInput = {
  create: StripePayoutCreateWithoutStripePaymentIntentsInput;
  update: StripePayoutUpdateWithoutStripePaymentIntentsInput;
  where?: Maybe<StripePayoutWhereInput>;
};

export type StripePayoutUpsertWithoutStripeRefundsInput = {
  create: StripePayoutCreateWithoutStripeRefundsInput;
  update: StripePayoutUpdateWithoutStripeRefundsInput;
  where?: Maybe<StripePayoutWhereInput>;
};

export type StripePayoutWhereInput = {
  AND?: Maybe<Array<StripePayoutWhereInput>>;
  NOT?: Maybe<Array<StripePayoutWhereInput>>;
  OR?: Maybe<Array<StripePayoutWhereInput>>;
  amount?: Maybe<IntFilter>;
  arrivalDate?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  financialTransactions?: Maybe<FinancialTransactionListRelationFilter>;
  id?: Maybe<StringFilter>;
  initiatedAt?: Maybe<DateTimeNullableFilter>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodNullableScalarRelationFilter>;
  payoutBatchingPeriodId?: Maybe<StringNullableFilter>;
  statementDescriptor?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumStripePayoutStatusFilter>;
  stripeDisputes?: Maybe<StripeDisputeListRelationFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  stripePayoutAccount?: Maybe<StripePayoutAccountNullableScalarRelationFilter>;
  stripePayoutAccountId?: Maybe<StringNullableFilter>;
  stripeRefunds?: Maybe<StripeRefundListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripePayoutWhereUniqueInput = {
  AND?: Maybe<Array<StripePayoutWhereInput>>;
  NOT?: Maybe<Array<StripePayoutWhereInput>>;
  OR?: Maybe<Array<StripePayoutWhereInput>>;
  amount?: Maybe<IntFilter>;
  arrivalDate?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  financialTransactions?: Maybe<FinancialTransactionListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  initiatedAt?: Maybe<DateTimeNullableFilter>;
  payoutBatchingPeriod?: Maybe<PayoutBatchingPeriodNullableScalarRelationFilter>;
  payoutBatchingPeriodId?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumStripePayoutStatusFilter>;
  stripeDisputes?: Maybe<StripeDisputeListRelationFilter>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  stripePayoutAccount?: Maybe<StripePayoutAccountNullableScalarRelationFilter>;
  stripePayoutAccountId?: Maybe<StringNullableFilter>;
  stripeRefunds?: Maybe<StripeRefundListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeReceipt = {
  __typename?: 'StripeReceipt';
  _count: StripeReceiptCountOutputType;
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dedicatedFileName?: Maybe<Scalars['String']>;
  history: Array<StripeReceiptHistory>;
  id: Scalars['String'];
  payment?: Maybe<StripePaymentIntent>;
  refund?: Maybe<StripeRefund>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};


export type StripeReceiptHistoryArgs = {
  cursor?: Maybe<StripeReceiptHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeReceiptHistoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeReceiptHistoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeReceiptHistoryWhereInput>;
};


export type StripeReceiptPaymentArgs = {
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type StripeReceiptRefundArgs = {
  where?: Maybe<StripeRefundWhereInput>;
};

export type StripeReceiptCountAggregateOutputType = {
  __typename?: 'StripeReceiptCountAggregateOutputType';
  _all: Scalars['Int'];
  accountType: Scalars['Int'];
  applicationCryptogram: Scalars['Int'];
  applicationName: Scalars['Int'];
  authorizationCode: Scalars['Int'];
  createdAt: Scalars['Int'];
  dedicatedFileName: Scalars['Int'];
  id: Scalars['Int'];
  stripeId: Scalars['Int'];
  terminalVerificationResults: Scalars['Int'];
  transactionStatusInformation: Scalars['Int'];
};

export type StripeReceiptCountOrderByAggregateInput = {
  accountType?: Maybe<SortOrder>;
  applicationCryptogram?: Maybe<SortOrder>;
  applicationName?: Maybe<SortOrder>;
  authorizationCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dedicatedFileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  terminalVerificationResults?: Maybe<SortOrder>;
  transactionStatusInformation?: Maybe<SortOrder>;
};

export type StripeReceiptCountOutputType = {
  __typename?: 'StripeReceiptCountOutputType';
  history: Scalars['Int'];
};

export type StripeReceiptCreateInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  history?: Maybe<StripeReceiptHistoryCreateNestedManyWithoutReceiptInput>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeReceiptInput>;
  refund?: Maybe<StripeRefundCreateNestedOneWithoutStripeReceiptInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptCreateManyInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptCreateNestedOneWithoutHistoryInput = {
  connect?: Maybe<StripeReceiptWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeReceiptCreateOrConnectWithoutHistoryInput>;
  create?: Maybe<StripeReceiptCreateWithoutHistoryInput>;
};

export type StripeReceiptCreateNestedOneWithoutPaymentInput = {
  connect?: Maybe<StripeReceiptWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeReceiptCreateOrConnectWithoutPaymentInput>;
  create?: Maybe<StripeReceiptCreateWithoutPaymentInput>;
};

export type StripeReceiptCreateNestedOneWithoutRefundInput = {
  connect?: Maybe<StripeReceiptWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeReceiptCreateOrConnectWithoutRefundInput>;
  create?: Maybe<StripeReceiptCreateWithoutRefundInput>;
};

export type StripeReceiptCreateOrConnectWithoutHistoryInput = {
  create: StripeReceiptCreateWithoutHistoryInput;
  where: StripeReceiptWhereUniqueInput;
};

export type StripeReceiptCreateOrConnectWithoutPaymentInput = {
  create: StripeReceiptCreateWithoutPaymentInput;
  where: StripeReceiptWhereUniqueInput;
};

export type StripeReceiptCreateOrConnectWithoutRefundInput = {
  create: StripeReceiptCreateWithoutRefundInput;
  where: StripeReceiptWhereUniqueInput;
};

export type StripeReceiptCreateWithoutHistoryInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeReceiptInput>;
  refund?: Maybe<StripeRefundCreateNestedOneWithoutStripeReceiptInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptCreateWithoutPaymentInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  history?: Maybe<StripeReceiptHistoryCreateNestedManyWithoutReceiptInput>;
  id?: Maybe<Scalars['String']>;
  refund?: Maybe<StripeRefundCreateNestedOneWithoutStripeReceiptInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptCreateWithoutRefundInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  history?: Maybe<StripeReceiptHistoryCreateNestedManyWithoutReceiptInput>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeReceiptInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptGroupByOutputType = {
  __typename?: 'StripeReceiptGroupByOutputType';
  _count?: Maybe<StripeReceiptCountAggregateOutputType>;
  _max?: Maybe<StripeReceiptMaxAggregateOutputType>;
  _min?: Maybe<StripeReceiptMinAggregateOutputType>;
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dedicatedFileName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptHistory = {
  __typename?: 'StripeReceiptHistory';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  medium: StripeReceiptMedium;
  receipt: StripeReceipt;
  stripeReceiptId: Scalars['String'];
};

export type StripeReceiptHistoryCountAggregateOutputType = {
  __typename?: 'StripeReceiptHistoryCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  medium: Scalars['Int'];
  stripeReceiptId: Scalars['Int'];
};

export type StripeReceiptHistoryCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  medium?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
};

export type StripeReceiptHistoryCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
  receipt: StripeReceiptCreateNestedOneWithoutHistoryInput;
};

export type StripeReceiptHistoryCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
  stripeReceiptId: Scalars['String'];
};

export type StripeReceiptHistoryCreateManyReceiptInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
};

export type StripeReceiptHistoryCreateManyReceiptInputEnvelope = {
  data: Array<StripeReceiptHistoryCreateManyReceiptInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeReceiptHistoryCreateNestedManyWithoutReceiptInput = {
  connect?: Maybe<Array<StripeReceiptHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeReceiptHistoryCreateOrConnectWithoutReceiptInput>>;
  create?: Maybe<Array<StripeReceiptHistoryCreateWithoutReceiptInput>>;
  createMany?: Maybe<StripeReceiptHistoryCreateManyReceiptInputEnvelope>;
};

export type StripeReceiptHistoryCreateOrConnectWithoutReceiptInput = {
  create: StripeReceiptHistoryCreateWithoutReceiptInput;
  where: StripeReceiptHistoryWhereUniqueInput;
};

export type StripeReceiptHistoryCreateWithoutReceiptInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
};

export type StripeReceiptHistoryGroupByOutputType = {
  __typename?: 'StripeReceiptHistoryGroupByOutputType';
  _count?: Maybe<StripeReceiptHistoryCountAggregateOutputType>;
  _max?: Maybe<StripeReceiptHistoryMaxAggregateOutputType>;
  _min?: Maybe<StripeReceiptHistoryMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  medium: StripeReceiptMedium;
  stripeReceiptId: Scalars['String'];
};

export type StripeReceiptHistoryListRelationFilter = {
  every?: Maybe<StripeReceiptHistoryWhereInput>;
  none?: Maybe<StripeReceiptHistoryWhereInput>;
  some?: Maybe<StripeReceiptHistoryWhereInput>;
};

export type StripeReceiptHistoryMaxAggregateOutputType = {
  __typename?: 'StripeReceiptHistoryMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
  stripeReceiptId?: Maybe<Scalars['String']>;
};

export type StripeReceiptHistoryMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  medium?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
};

export type StripeReceiptHistoryMinAggregateOutputType = {
  __typename?: 'StripeReceiptHistoryMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
  stripeReceiptId?: Maybe<Scalars['String']>;
};

export type StripeReceiptHistoryMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  medium?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
};

export type StripeReceiptHistoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StripeReceiptHistoryOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeReceiptHistoryOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  medium?: Maybe<SortOrder>;
  receipt?: Maybe<StripeReceiptOrderByWithRelationInput>;
  stripeReceiptId?: Maybe<SortOrder>;
};

export enum StripeReceiptHistoryOrderByRelevanceFieldEnum {
  Id = 'id',
  StripeReceiptId = 'stripeReceiptId'
}

export type StripeReceiptHistoryOrderByRelevanceInput = {
  fields: Array<StripeReceiptHistoryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripeReceiptHistoryOrderByWithAggregationInput = {
  _count?: Maybe<StripeReceiptHistoryCountOrderByAggregateInput>;
  _max?: Maybe<StripeReceiptHistoryMaxOrderByAggregateInput>;
  _min?: Maybe<StripeReceiptHistoryMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  medium?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
};

export type StripeReceiptHistoryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeReceiptHistoryOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  medium?: Maybe<SortOrder>;
  receipt?: Maybe<StripeReceiptOrderByWithRelationInput>;
  stripeReceiptId?: Maybe<SortOrder>;
};

export type StripeReceiptHistoryOrderByWithRelationInput = {
  _relevance?: Maybe<StripeReceiptHistoryOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  medium?: Maybe<SortOrder>;
  receipt?: Maybe<StripeReceiptOrderByWithRelationInput>;
  stripeReceiptId?: Maybe<SortOrder>;
};

export enum StripeReceiptHistoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Medium = 'medium',
  StripeReceiptId = 'stripeReceiptId'
}

export type StripeReceiptHistoryScalarWhereInput = {
  AND?: Maybe<Array<StripeReceiptHistoryScalarWhereInput>>;
  NOT?: Maybe<Array<StripeReceiptHistoryScalarWhereInput>>;
  OR?: Maybe<Array<StripeReceiptHistoryScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  medium?: Maybe<EnumStripeReceiptMediumFilter>;
  stripeReceiptId?: Maybe<StringFilter>;
};

export type StripeReceiptHistoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripeReceiptHistoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripeReceiptHistoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripeReceiptHistoryScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  medium?: Maybe<EnumStripeReceiptMediumWithAggregatesFilter>;
  stripeReceiptId?: Maybe<StringWithAggregatesFilter>;
};

export type StripeReceiptHistoryUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
  stripeReceiptId: Scalars['String'];
};

export type StripeReceiptHistoryUncheckedCreateNestedManyWithoutReceiptInput = {
  connect?: Maybe<Array<StripeReceiptHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeReceiptHistoryCreateOrConnectWithoutReceiptInput>>;
  create?: Maybe<Array<StripeReceiptHistoryCreateWithoutReceiptInput>>;
  createMany?: Maybe<StripeReceiptHistoryCreateManyReceiptInputEnvelope>;
};

export type StripeReceiptHistoryUncheckedCreateWithoutReceiptInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
};

export type StripeReceiptHistoryUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
  stripeReceiptId?: Maybe<Scalars['String']>;
};

export type StripeReceiptHistoryUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
  stripeReceiptId?: Maybe<Scalars['String']>;
};

export type StripeReceiptHistoryUncheckedUpdateManyWithoutReceiptInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
};

export type StripeReceiptHistoryUncheckedUpdateManyWithoutReceiptNestedInput = {
  connect?: Maybe<Array<StripeReceiptHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeReceiptHistoryCreateOrConnectWithoutReceiptInput>>;
  create?: Maybe<Array<StripeReceiptHistoryCreateWithoutReceiptInput>>;
  createMany?: Maybe<StripeReceiptHistoryCreateManyReceiptInputEnvelope>;
  delete?: Maybe<Array<StripeReceiptHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeReceiptHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeReceiptHistoryWhereUniqueInput>>;
  set?: Maybe<Array<StripeReceiptHistoryWhereUniqueInput>>;
  update?: Maybe<Array<StripeReceiptHistoryUpdateWithWhereUniqueWithoutReceiptInput>>;
  updateMany?: Maybe<Array<StripeReceiptHistoryUpdateManyWithWhereWithoutReceiptInput>>;
  upsert?: Maybe<Array<StripeReceiptHistoryUpsertWithWhereUniqueWithoutReceiptInput>>;
};

export type StripeReceiptHistoryUncheckedUpdateWithoutReceiptInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
};

export type StripeReceiptHistoryUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
  receipt?: Maybe<StripeReceiptUpdateOneRequiredWithoutHistoryNestedInput>;
};

export type StripeReceiptHistoryUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
};

export type StripeReceiptHistoryUpdateManyWithWhereWithoutReceiptInput = {
  data: StripeReceiptHistoryUpdateManyMutationInput;
  where: StripeReceiptHistoryScalarWhereInput;
};

export type StripeReceiptHistoryUpdateManyWithoutReceiptNestedInput = {
  connect?: Maybe<Array<StripeReceiptHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeReceiptHistoryCreateOrConnectWithoutReceiptInput>>;
  create?: Maybe<Array<StripeReceiptHistoryCreateWithoutReceiptInput>>;
  createMany?: Maybe<StripeReceiptHistoryCreateManyReceiptInputEnvelope>;
  delete?: Maybe<Array<StripeReceiptHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeReceiptHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeReceiptHistoryWhereUniqueInput>>;
  set?: Maybe<Array<StripeReceiptHistoryWhereUniqueInput>>;
  update?: Maybe<Array<StripeReceiptHistoryUpdateWithWhereUniqueWithoutReceiptInput>>;
  updateMany?: Maybe<Array<StripeReceiptHistoryUpdateManyWithWhereWithoutReceiptInput>>;
  upsert?: Maybe<Array<StripeReceiptHistoryUpsertWithWhereUniqueWithoutReceiptInput>>;
};

export type StripeReceiptHistoryUpdateWithWhereUniqueWithoutReceiptInput = {
  data: StripeReceiptHistoryUpdateWithoutReceiptInput;
  where: StripeReceiptHistoryWhereUniqueInput;
};

export type StripeReceiptHistoryUpdateWithoutReceiptInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<StripeReceiptMedium>;
};

export type StripeReceiptHistoryUpsertWithWhereUniqueWithoutReceiptInput = {
  create: StripeReceiptHistoryCreateWithoutReceiptInput;
  update: StripeReceiptHistoryUpdateWithoutReceiptInput;
  where: StripeReceiptHistoryWhereUniqueInput;
};

export type StripeReceiptHistoryWhereInput = {
  AND?: Maybe<Array<StripeReceiptHistoryWhereInput>>;
  NOT?: Maybe<Array<StripeReceiptHistoryWhereInput>>;
  OR?: Maybe<Array<StripeReceiptHistoryWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  medium?: Maybe<EnumStripeReceiptMediumFilter>;
  receipt?: Maybe<StripeReceiptScalarRelationFilter>;
  stripeReceiptId?: Maybe<StringFilter>;
};

export type StripeReceiptHistoryWhereUniqueInput = {
  AND?: Maybe<Array<StripeReceiptHistoryWhereInput>>;
  NOT?: Maybe<Array<StripeReceiptHistoryWhereInput>>;
  OR?: Maybe<Array<StripeReceiptHistoryWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  medium?: Maybe<EnumStripeReceiptMediumFilter>;
  receipt?: Maybe<StripeReceiptScalarRelationFilter>;
  stripeReceiptId?: Maybe<StringFilter>;
};

export type StripeReceiptMaxAggregateOutputType = {
  __typename?: 'StripeReceiptMaxAggregateOutputType';
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptMaxOrderByAggregateInput = {
  accountType?: Maybe<SortOrder>;
  applicationCryptogram?: Maybe<SortOrder>;
  applicationName?: Maybe<SortOrder>;
  authorizationCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dedicatedFileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  terminalVerificationResults?: Maybe<SortOrder>;
  transactionStatusInformation?: Maybe<SortOrder>;
};

export enum StripeReceiptMedium {
  Email = 'Email',
  Printed = 'Printed'
}

export type StripeReceiptMinAggregateOutputType = {
  __typename?: 'StripeReceiptMinAggregateOutputType';
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptMinOrderByAggregateInput = {
  accountType?: Maybe<SortOrder>;
  applicationCryptogram?: Maybe<SortOrder>;
  applicationName?: Maybe<SortOrder>;
  authorizationCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dedicatedFileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  terminalVerificationResults?: Maybe<SortOrder>;
  transactionStatusInformation?: Maybe<SortOrder>;
};

export type StripeReceiptNullableScalarRelationFilter = {
  AND?: Maybe<Array<StripeReceiptWhereInput>>;
  NOT?: Maybe<Array<StripeReceiptWhereInput>>;
  OR?: Maybe<Array<StripeReceiptWhereInput>>;
  accountType?: Maybe<StringNullableFilter>;
  applicationCryptogram?: Maybe<StringNullableFilter>;
  applicationName?: Maybe<StringNullableFilter>;
  authorizationCode?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dedicatedFileName?: Maybe<StringNullableFilter>;
  history?: Maybe<StripeReceiptHistoryListRelationFilter>;
  id?: Maybe<StringFilter>;
  payment?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  refund?: Maybe<StripeRefundNullableScalarRelationFilter>;
  stripeId?: Maybe<StringNullableFilter>;
  terminalVerificationResults?: Maybe<StringNullableFilter>;
  transactionStatusInformation?: Maybe<StringNullableFilter>;
};

export type StripeReceiptOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeReceiptOrderByRelevanceInput>;
  accountType?: Maybe<SortOrder>;
  applicationCryptogram?: Maybe<SortOrder>;
  applicationName?: Maybe<SortOrder>;
  authorizationCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dedicatedFileName?: Maybe<SortOrder>;
  history?: Maybe<StripeReceiptHistoryOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  payment?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  refund?: Maybe<StripeRefundOrderByWithRelationInput>;
  stripeId?: Maybe<SortOrder>;
  terminalVerificationResults?: Maybe<SortOrder>;
  transactionStatusInformation?: Maybe<SortOrder>;
};

export enum StripeReceiptOrderByRelevanceFieldEnum {
  AccountType = 'accountType',
  ApplicationCryptogram = 'applicationCryptogram',
  ApplicationName = 'applicationName',
  AuthorizationCode = 'authorizationCode',
  DedicatedFileName = 'dedicatedFileName',
  Id = 'id',
  StripeId = 'stripeId',
  TerminalVerificationResults = 'terminalVerificationResults',
  TransactionStatusInformation = 'transactionStatusInformation'
}

export type StripeReceiptOrderByRelevanceInput = {
  fields: Array<StripeReceiptOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripeReceiptOrderByWithAggregationInput = {
  _count?: Maybe<StripeReceiptCountOrderByAggregateInput>;
  _max?: Maybe<StripeReceiptMaxOrderByAggregateInput>;
  _min?: Maybe<StripeReceiptMinOrderByAggregateInput>;
  accountType?: Maybe<SortOrder>;
  applicationCryptogram?: Maybe<SortOrder>;
  applicationName?: Maybe<SortOrder>;
  authorizationCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dedicatedFileName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  terminalVerificationResults?: Maybe<SortOrder>;
  transactionStatusInformation?: Maybe<SortOrder>;
};

export type StripeReceiptOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeReceiptOrderByRelevanceInput>;
  accountType?: Maybe<SortOrder>;
  applicationCryptogram?: Maybe<SortOrder>;
  applicationName?: Maybe<SortOrder>;
  authorizationCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dedicatedFileName?: Maybe<SortOrder>;
  history?: Maybe<StripeReceiptHistoryOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  payment?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  refund?: Maybe<StripeRefundOrderByWithRelationInput>;
  stripeId?: Maybe<SortOrder>;
  terminalVerificationResults?: Maybe<SortOrder>;
  transactionStatusInformation?: Maybe<SortOrder>;
};

export type StripeReceiptOrderByWithRelationInput = {
  _relevance?: Maybe<StripeReceiptOrderByRelevanceInput>;
  accountType?: Maybe<SortOrder>;
  applicationCryptogram?: Maybe<SortOrder>;
  applicationName?: Maybe<SortOrder>;
  authorizationCode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dedicatedFileName?: Maybe<SortOrder>;
  history?: Maybe<StripeReceiptHistoryOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  payment?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  refund?: Maybe<StripeRefundOrderByWithRelationInput>;
  stripeId?: Maybe<SortOrder>;
  terminalVerificationResults?: Maybe<SortOrder>;
  transactionStatusInformation?: Maybe<SortOrder>;
};

export enum StripeReceiptScalarFieldEnum {
  AccountType = 'accountType',
  ApplicationCryptogram = 'applicationCryptogram',
  ApplicationName = 'applicationName',
  AuthorizationCode = 'authorizationCode',
  CreatedAt = 'createdAt',
  DedicatedFileName = 'dedicatedFileName',
  Id = 'id',
  StripeId = 'stripeId',
  TerminalVerificationResults = 'terminalVerificationResults',
  TransactionStatusInformation = 'transactionStatusInformation'
}

export type StripeReceiptScalarRelationFilter = {
  AND?: Maybe<Array<StripeReceiptWhereInput>>;
  NOT?: Maybe<Array<StripeReceiptWhereInput>>;
  OR?: Maybe<Array<StripeReceiptWhereInput>>;
  accountType?: Maybe<StringNullableFilter>;
  applicationCryptogram?: Maybe<StringNullableFilter>;
  applicationName?: Maybe<StringNullableFilter>;
  authorizationCode?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dedicatedFileName?: Maybe<StringNullableFilter>;
  history?: Maybe<StripeReceiptHistoryListRelationFilter>;
  id?: Maybe<StringFilter>;
  payment?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  refund?: Maybe<StripeRefundNullableScalarRelationFilter>;
  stripeId?: Maybe<StringNullableFilter>;
  terminalVerificationResults?: Maybe<StringNullableFilter>;
  transactionStatusInformation?: Maybe<StringNullableFilter>;
};

export type StripeReceiptScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripeReceiptScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripeReceiptScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripeReceiptScalarWhereWithAggregatesInput>>;
  accountType?: Maybe<StringNullableWithAggregatesFilter>;
  applicationCryptogram?: Maybe<StringNullableWithAggregatesFilter>;
  applicationName?: Maybe<StringNullableWithAggregatesFilter>;
  authorizationCode?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  dedicatedFileName?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  stripeId?: Maybe<StringNullableWithAggregatesFilter>;
  terminalVerificationResults?: Maybe<StringNullableWithAggregatesFilter>;
  transactionStatusInformation?: Maybe<StringNullableWithAggregatesFilter>;
};

export type StripeReceiptUncheckedCreateInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  history?: Maybe<StripeReceiptHistoryUncheckedCreateNestedManyWithoutReceiptInput>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentUncheckedCreateNestedOneWithoutStripeReceiptInput>;
  refund?: Maybe<StripeRefundUncheckedCreateNestedOneWithoutStripeReceiptInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUncheckedCreateWithoutHistoryInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentUncheckedCreateNestedOneWithoutStripeReceiptInput>;
  refund?: Maybe<StripeRefundUncheckedCreateNestedOneWithoutStripeReceiptInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUncheckedCreateWithoutPaymentInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  history?: Maybe<StripeReceiptHistoryUncheckedCreateNestedManyWithoutReceiptInput>;
  id?: Maybe<Scalars['String']>;
  refund?: Maybe<StripeRefundUncheckedCreateNestedOneWithoutStripeReceiptInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUncheckedCreateWithoutRefundInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  history?: Maybe<StripeReceiptHistoryUncheckedCreateNestedManyWithoutReceiptInput>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentUncheckedCreateNestedOneWithoutStripeReceiptInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUncheckedUpdateInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  history?: Maybe<StripeReceiptHistoryUncheckedUpdateManyWithoutReceiptNestedInput>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentUncheckedUpdateOneWithoutStripeReceiptNestedInput>;
  refund?: Maybe<StripeRefundUncheckedUpdateOneWithoutStripeReceiptNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUncheckedUpdateManyInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUncheckedUpdateWithoutHistoryInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentUncheckedUpdateOneWithoutStripeReceiptNestedInput>;
  refund?: Maybe<StripeRefundUncheckedUpdateOneWithoutStripeReceiptNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUncheckedUpdateWithoutPaymentInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  history?: Maybe<StripeReceiptHistoryUncheckedUpdateManyWithoutReceiptNestedInput>;
  id?: Maybe<Scalars['String']>;
  refund?: Maybe<StripeRefundUncheckedUpdateOneWithoutStripeReceiptNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUncheckedUpdateWithoutRefundInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  history?: Maybe<StripeReceiptHistoryUncheckedUpdateManyWithoutReceiptNestedInput>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentUncheckedUpdateOneWithoutStripeReceiptNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUpdateInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  history?: Maybe<StripeReceiptHistoryUpdateManyWithoutReceiptNestedInput>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentUpdateOneWithoutStripeReceiptNestedInput>;
  refund?: Maybe<StripeRefundUpdateOneWithoutStripeReceiptNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUpdateManyMutationInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUpdateOneRequiredWithoutHistoryNestedInput = {
  connect?: Maybe<StripeReceiptWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeReceiptCreateOrConnectWithoutHistoryInput>;
  create?: Maybe<StripeReceiptCreateWithoutHistoryInput>;
  update?: Maybe<StripeReceiptUpdateToOneWithWhereWithoutHistoryInput>;
  upsert?: Maybe<StripeReceiptUpsertWithoutHistoryInput>;
};

export type StripeReceiptUpdateOneWithoutPaymentNestedInput = {
  connect?: Maybe<StripeReceiptWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeReceiptCreateOrConnectWithoutPaymentInput>;
  create?: Maybe<StripeReceiptCreateWithoutPaymentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeReceiptUpdateToOneWithWhereWithoutPaymentInput>;
  upsert?: Maybe<StripeReceiptUpsertWithoutPaymentInput>;
};

export type StripeReceiptUpdateOneWithoutRefundNestedInput = {
  connect?: Maybe<StripeReceiptWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeReceiptCreateOrConnectWithoutRefundInput>;
  create?: Maybe<StripeReceiptCreateWithoutRefundInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeReceiptUpdateToOneWithWhereWithoutRefundInput>;
  upsert?: Maybe<StripeReceiptUpsertWithoutRefundInput>;
};

export type StripeReceiptUpdateToOneWithWhereWithoutHistoryInput = {
  data: StripeReceiptUpdateWithoutHistoryInput;
  where?: Maybe<StripeReceiptWhereInput>;
};

export type StripeReceiptUpdateToOneWithWhereWithoutPaymentInput = {
  data: StripeReceiptUpdateWithoutPaymentInput;
  where?: Maybe<StripeReceiptWhereInput>;
};

export type StripeReceiptUpdateToOneWithWhereWithoutRefundInput = {
  data: StripeReceiptUpdateWithoutRefundInput;
  where?: Maybe<StripeReceiptWhereInput>;
};

export type StripeReceiptUpdateWithoutHistoryInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentUpdateOneWithoutStripeReceiptNestedInput>;
  refund?: Maybe<StripeRefundUpdateOneWithoutStripeReceiptNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUpdateWithoutPaymentInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  history?: Maybe<StripeReceiptHistoryUpdateManyWithoutReceiptNestedInput>;
  id?: Maybe<Scalars['String']>;
  refund?: Maybe<StripeRefundUpdateOneWithoutStripeReceiptNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUpdateWithoutRefundInput = {
  accountType?: Maybe<Scalars['String']>;
  applicationCryptogram?: Maybe<Scalars['String']>;
  applicationName?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dedicatedFileName?: Maybe<Scalars['String']>;
  history?: Maybe<StripeReceiptHistoryUpdateManyWithoutReceiptNestedInput>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentUpdateOneWithoutStripeReceiptNestedInput>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<Scalars['String']>;
  transactionStatusInformation?: Maybe<Scalars['String']>;
};

export type StripeReceiptUpsertWithoutHistoryInput = {
  create: StripeReceiptCreateWithoutHistoryInput;
  update: StripeReceiptUpdateWithoutHistoryInput;
  where?: Maybe<StripeReceiptWhereInput>;
};

export type StripeReceiptUpsertWithoutPaymentInput = {
  create: StripeReceiptCreateWithoutPaymentInput;
  update: StripeReceiptUpdateWithoutPaymentInput;
  where?: Maybe<StripeReceiptWhereInput>;
};

export type StripeReceiptUpsertWithoutRefundInput = {
  create: StripeReceiptCreateWithoutRefundInput;
  update: StripeReceiptUpdateWithoutRefundInput;
  where?: Maybe<StripeReceiptWhereInput>;
};

export type StripeReceiptWhereInput = {
  AND?: Maybe<Array<StripeReceiptWhereInput>>;
  NOT?: Maybe<Array<StripeReceiptWhereInput>>;
  OR?: Maybe<Array<StripeReceiptWhereInput>>;
  accountType?: Maybe<StringNullableFilter>;
  applicationCryptogram?: Maybe<StringNullableFilter>;
  applicationName?: Maybe<StringNullableFilter>;
  authorizationCode?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dedicatedFileName?: Maybe<StringNullableFilter>;
  history?: Maybe<StripeReceiptHistoryListRelationFilter>;
  id?: Maybe<StringFilter>;
  payment?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  refund?: Maybe<StripeRefundNullableScalarRelationFilter>;
  stripeId?: Maybe<StringNullableFilter>;
  terminalVerificationResults?: Maybe<StringNullableFilter>;
  transactionStatusInformation?: Maybe<StringNullableFilter>;
};

export type StripeReceiptWhereUniqueInput = {
  AND?: Maybe<Array<StripeReceiptWhereInput>>;
  NOT?: Maybe<Array<StripeReceiptWhereInput>>;
  OR?: Maybe<Array<StripeReceiptWhereInput>>;
  accountType?: Maybe<StringNullableFilter>;
  applicationCryptogram?: Maybe<StringNullableFilter>;
  applicationName?: Maybe<StringNullableFilter>;
  authorizationCode?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dedicatedFileName?: Maybe<StringNullableFilter>;
  history?: Maybe<StripeReceiptHistoryListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  payment?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  refund?: Maybe<StripeRefundNullableScalarRelationFilter>;
  stripeId?: Maybe<Scalars['String']>;
  terminalVerificationResults?: Maybe<StringNullableFilter>;
  transactionStatusInformation?: Maybe<StringNullableFilter>;
};

export type StripeRefund = {
  __typename?: 'StripeRefund';
  _count: StripeRefundCountOutputType;
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPayment>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  financialTransaction?: Maybe<FinancialTransaction>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  issuedBy?: Maybe<User>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs: Array<PushNotificationLog>;
  reason: RefundReason;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntent>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayout?: Maybe<StripePayout>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceipt?: Maybe<StripeReceipt>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};


export type StripeRefundCareEnrollmentPaymentArgs = {
  where?: Maybe<CareEnrollmentPaymentWhereInput>;
};


export type StripeRefundFinancialTransactionArgs = {
  where?: Maybe<FinancialTransactionWhereInput>;
};


export type StripeRefundIssuedByArgs = {
  where?: Maybe<UserWhereInput>;
};


export type StripeRefundPushNotificationLogsArgs = {
  cursor?: Maybe<PushNotificationLogWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PushNotificationLogScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PushNotificationLogOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PushNotificationLogWhereInput>;
};


export type StripeRefundStripePaymentIntentArgs = {
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type StripeRefundStripePayoutArgs = {
  where?: Maybe<StripePayoutWhereInput>;
};


export type StripeRefundStripeReceiptArgs = {
  where?: Maybe<StripeReceiptWhereInput>;
};

export type StripeRefundAvgAggregateOutputType = {
  __typename?: 'StripeRefundAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  clientFeeRefunded?: Maybe<Scalars['Float']>;
  clinicFeeRefunded?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type StripeRefundAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  clientFeeRefunded?: Maybe<SortOrder>;
  clinicFeeRefunded?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
};

export type StripeRefundCountAggregateOutputType = {
  __typename?: 'StripeRefundCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  clientFeeRefunded: Scalars['Int'];
  clinicFeeRefunded: Scalars['Int'];
  createdAt: Scalars['Int'];
  fundsAvailableAt: Scalars['Int'];
  id: Scalars['Int'];
  issuedByUserId: Scalars['Int'];
  reason: Scalars['Int'];
  reasonOther: Scalars['Int'];
  stripeId: Scalars['Int'];
  stripePaymentIntentId: Scalars['Int'];
  stripePayoutId: Scalars['Int'];
  stripeReceiptId: Scalars['Int'];
  total: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StripeRefundCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  clientFeeRefunded?: Maybe<SortOrder>;
  clinicFeeRefunded?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuedByUserId?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  reasonOther?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeRefundCountOutputType = {
  __typename?: 'StripeRefundCountOutputType';
  pushNotificationLogs: Scalars['Int'];
};

export type StripeRefundCreateInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserCreateNestedOneWithoutRefundsIssuedInput>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeRefundsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripeRefundsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutRefundInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundCreateManyInput = {
  amount: Scalars['Int'];
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundCreateManyIssuedByInput = {
  amount: Scalars['Int'];
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundCreateManyIssuedByInputEnvelope = {
  data: Array<StripeRefundCreateManyIssuedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeRefundCreateManyStripePaymentIntentInput = {
  amount: Scalars['Int'];
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundCreateManyStripePaymentIntentInputEnvelope = {
  data: Array<StripeRefundCreateManyStripePaymentIntentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeRefundCreateManyStripePayoutInput = {
  amount: Scalars['Int'];
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundCreateManyStripePayoutInputEnvelope = {
  data: Array<StripeRefundCreateManyStripePayoutInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeRefundCreateNestedManyWithoutIssuedByInput = {
  connect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeRefundCreateOrConnectWithoutIssuedByInput>>;
  create?: Maybe<Array<StripeRefundCreateWithoutIssuedByInput>>;
  createMany?: Maybe<StripeRefundCreateManyIssuedByInputEnvelope>;
};

export type StripeRefundCreateNestedManyWithoutStripePaymentIntentInput = {
  connect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeRefundCreateOrConnectWithoutStripePaymentIntentInput>>;
  create?: Maybe<Array<StripeRefundCreateWithoutStripePaymentIntentInput>>;
  createMany?: Maybe<StripeRefundCreateManyStripePaymentIntentInputEnvelope>;
};

export type StripeRefundCreateNestedManyWithoutStripePayoutInput = {
  connect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeRefundCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<StripeRefundCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<StripeRefundCreateManyStripePayoutInputEnvelope>;
};

export type StripeRefundCreateNestedOneWithoutCareEnrollmentPaymentInput = {
  connect?: Maybe<StripeRefundWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeRefundCreateOrConnectWithoutCareEnrollmentPaymentInput>;
  create?: Maybe<StripeRefundCreateWithoutCareEnrollmentPaymentInput>;
};

export type StripeRefundCreateNestedOneWithoutFinancialTransactionInput = {
  connect?: Maybe<StripeRefundWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeRefundCreateOrConnectWithoutFinancialTransactionInput>;
  create?: Maybe<StripeRefundCreateWithoutFinancialTransactionInput>;
};

export type StripeRefundCreateNestedOneWithoutPushNotificationLogsInput = {
  connect?: Maybe<StripeRefundWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeRefundCreateOrConnectWithoutPushNotificationLogsInput>;
  create?: Maybe<StripeRefundCreateWithoutPushNotificationLogsInput>;
};

export type StripeRefundCreateNestedOneWithoutStripeReceiptInput = {
  connect?: Maybe<StripeRefundWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeRefundCreateOrConnectWithoutStripeReceiptInput>;
  create?: Maybe<StripeRefundCreateWithoutStripeReceiptInput>;
};

export type StripeRefundCreateOrConnectWithoutCareEnrollmentPaymentInput = {
  create: StripeRefundCreateWithoutCareEnrollmentPaymentInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundCreateOrConnectWithoutFinancialTransactionInput = {
  create: StripeRefundCreateWithoutFinancialTransactionInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundCreateOrConnectWithoutIssuedByInput = {
  create: StripeRefundCreateWithoutIssuedByInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundCreateOrConnectWithoutPushNotificationLogsInput = {
  create: StripeRefundCreateWithoutPushNotificationLogsInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundCreateOrConnectWithoutStripePaymentIntentInput = {
  create: StripeRefundCreateWithoutStripePaymentIntentInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundCreateOrConnectWithoutStripePayoutInput = {
  create: StripeRefundCreateWithoutStripePayoutInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundCreateOrConnectWithoutStripeReceiptInput = {
  create: StripeRefundCreateWithoutStripeReceiptInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundCreateWithoutCareEnrollmentPaymentInput = {
  amount: Scalars['Int'];
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserCreateNestedOneWithoutRefundsIssuedInput>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeRefundsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripeRefundsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutRefundInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundCreateWithoutFinancialTransactionInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserCreateNestedOneWithoutRefundsIssuedInput>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeRefundsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripeRefundsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutRefundInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundCreateWithoutIssuedByInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeRefundsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripeRefundsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutRefundInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundCreateWithoutPushNotificationLogsInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserCreateNestedOneWithoutRefundsIssuedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeRefundsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripeRefundsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutRefundInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundCreateWithoutStripePaymentIntentInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserCreateNestedOneWithoutRefundsIssuedInput>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripeRefundsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutRefundInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundCreateWithoutStripePayoutInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserCreateNestedOneWithoutRefundsIssuedInput>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeRefundsInput>;
  stripeReceipt?: Maybe<StripeReceiptCreateNestedOneWithoutRefundInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundCreateWithoutStripeReceiptInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserCreateNestedOneWithoutRefundsIssuedInput>;
  pushNotificationLogs?: Maybe<PushNotificationLogCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutStripeRefundsInput>;
  stripePayout?: Maybe<StripePayoutCreateNestedOneWithoutStripeRefundsInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundGroupByOutputType = {
  __typename?: 'StripeRefundGroupByOutputType';
  _avg?: Maybe<StripeRefundAvgAggregateOutputType>;
  _count?: Maybe<StripeRefundCountAggregateOutputType>;
  _max?: Maybe<StripeRefundMaxAggregateOutputType>;
  _min?: Maybe<StripeRefundMinAggregateOutputType>;
  _sum?: Maybe<StripeRefundSumAggregateOutputType>;
  amount: Scalars['Int'];
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  issuedByUserId?: Maybe<Scalars['String']>;
  reason: RefundReason;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type StripeRefundListRelationFilter = {
  every?: Maybe<StripeRefundWhereInput>;
  none?: Maybe<StripeRefundWhereInput>;
  some?: Maybe<StripeRefundWhereInput>;
};

export type StripeRefundMaxAggregateOutputType = {
  __typename?: 'StripeRefundMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  clientFeeRefunded?: Maybe<SortOrder>;
  clinicFeeRefunded?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuedByUserId?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  reasonOther?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeRefundMinAggregateOutputType = {
  __typename?: 'StripeRefundMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  clientFeeRefunded?: Maybe<SortOrder>;
  clinicFeeRefunded?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuedByUserId?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  reasonOther?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeRefundNullableScalarRelationFilter = {
  AND?: Maybe<Array<StripeRefundWhereInput>>;
  NOT?: Maybe<Array<StripeRefundWhereInput>>;
  OR?: Maybe<Array<StripeRefundWhereInput>>;
  amount?: Maybe<IntFilter>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentNullableScalarRelationFilter>;
  clientFeeRefunded?: Maybe<IntNullableFilter>;
  clinicFeeRefunded?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  issuedBy?: Maybe<UserNullableScalarRelationFilter>;
  issuedByUserId?: Maybe<StringNullableFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  reason?: Maybe<EnumRefundReasonFilter>;
  reasonOther?: Maybe<StringNullableFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeReceipt?: Maybe<StripeReceiptNullableScalarRelationFilter>;
  stripeReceiptId?: Maybe<StringNullableFilter>;
  total?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeRefundOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StripeRefundOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeRefundOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentOrderByWithRelationInput>;
  clientFeeRefunded?: Maybe<SortOrder>;
  clinicFeeRefunded?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuedBy?: Maybe<UserOrderByWithRelationInput>;
  issuedByUserId?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  reason?: Maybe<SortOrder>;
  reasonOther?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceipt?: Maybe<StripeReceiptOrderByWithRelationInput>;
  stripeReceiptId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeRefundOrderByRelevanceFieldEnum {
  Id = 'id',
  IssuedByUserId = 'issuedByUserId',
  ReasonOther = 'reasonOther',
  StripeId = 'stripeId',
  StripePaymentIntentId = 'stripePaymentIntentId',
  StripePayoutId = 'stripePayoutId',
  StripeReceiptId = 'stripeReceiptId'
}

export type StripeRefundOrderByRelevanceInput = {
  fields: Array<StripeRefundOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripeRefundOrderByWithAggregationInput = {
  _avg?: Maybe<StripeRefundAvgOrderByAggregateInput>;
  _count?: Maybe<StripeRefundCountOrderByAggregateInput>;
  _max?: Maybe<StripeRefundMaxOrderByAggregateInput>;
  _min?: Maybe<StripeRefundMinOrderByAggregateInput>;
  _sum?: Maybe<StripeRefundSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  clientFeeRefunded?: Maybe<SortOrder>;
  clinicFeeRefunded?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuedByUserId?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  reasonOther?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceiptId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeRefundOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeRefundOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentOrderByWithRelationInput>;
  clientFeeRefunded?: Maybe<SortOrder>;
  clinicFeeRefunded?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuedBy?: Maybe<UserOrderByWithRelationInput>;
  issuedByUserId?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  reason?: Maybe<SortOrder>;
  reasonOther?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceipt?: Maybe<StripeReceiptOrderByWithRelationInput>;
  stripeReceiptId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeRefundOrderByWithRelationInput = {
  _relevance?: Maybe<StripeRefundOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentOrderByWithRelationInput>;
  clientFeeRefunded?: Maybe<SortOrder>;
  clinicFeeRefunded?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  financialTransaction?: Maybe<FinancialTransactionOrderByWithRelationInput>;
  fundsAvailableAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuedBy?: Maybe<UserOrderByWithRelationInput>;
  issuedByUserId?: Maybe<SortOrder>;
  pushNotificationLogs?: Maybe<PushNotificationLogOrderByRelationAggregateInput>;
  reason?: Maybe<SortOrder>;
  reasonOther?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  stripePaymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  stripePaymentIntentId?: Maybe<SortOrder>;
  stripePayout?: Maybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: Maybe<SortOrder>;
  stripeReceipt?: Maybe<StripeReceiptOrderByWithRelationInput>;
  stripeReceiptId?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeRefundReason {
  Duplicate = 'Duplicate',
  Fraudulent = 'Fraudulent',
  Other = 'Other',
  PartialRefund = 'Partial_Refund',
  RequestedByCustomer = 'Requested_By_Customer'
}

export enum StripeRefundScalarFieldEnum {
  Amount = 'amount',
  ClientFeeRefunded = 'clientFeeRefunded',
  ClinicFeeRefunded = 'clinicFeeRefunded',
  CreatedAt = 'createdAt',
  FundsAvailableAt = 'fundsAvailableAt',
  Id = 'id',
  IssuedByUserId = 'issuedByUserId',
  Reason = 'reason',
  ReasonOther = 'reasonOther',
  StripeId = 'stripeId',
  StripePaymentIntentId = 'stripePaymentIntentId',
  StripePayoutId = 'stripePayoutId',
  StripeReceiptId = 'stripeReceiptId',
  Total = 'total',
  UpdatedAt = 'updatedAt'
}

export type StripeRefundScalarWhereInput = {
  AND?: Maybe<Array<StripeRefundScalarWhereInput>>;
  NOT?: Maybe<Array<StripeRefundScalarWhereInput>>;
  OR?: Maybe<Array<StripeRefundScalarWhereInput>>;
  amount?: Maybe<IntFilter>;
  clientFeeRefunded?: Maybe<IntNullableFilter>;
  clinicFeeRefunded?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  issuedByUserId?: Maybe<StringNullableFilter>;
  reason?: Maybe<EnumRefundReasonFilter>;
  reasonOther?: Maybe<StringNullableFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeReceiptId?: Maybe<StringNullableFilter>;
  total?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeRefundScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripeRefundScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripeRefundScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripeRefundScalarWhereWithAggregatesInput>>;
  amount?: Maybe<IntWithAggregatesFilter>;
  clientFeeRefunded?: Maybe<IntNullableWithAggregatesFilter>;
  clinicFeeRefunded?: Maybe<IntNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  issuedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  reason?: Maybe<EnumRefundReasonWithAggregatesFilter>;
  reasonOther?: Maybe<StringNullableWithAggregatesFilter>;
  stripeId?: Maybe<StringWithAggregatesFilter>;
  stripePaymentIntentId?: Maybe<StringNullableWithAggregatesFilter>;
  stripePayoutId?: Maybe<StringNullableWithAggregatesFilter>;
  stripeReceiptId?: Maybe<StringNullableWithAggregatesFilter>;
  total?: Maybe<IntNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type StripeRefundSumAggregateOutputType = {
  __typename?: 'StripeRefundSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type StripeRefundSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  clientFeeRefunded?: Maybe<SortOrder>;
  clinicFeeRefunded?: Maybe<SortOrder>;
  total?: Maybe<SortOrder>;
};

export type StripeRefundUncheckedCreateInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput = {
  connect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeRefundCreateOrConnectWithoutIssuedByInput>>;
  create?: Maybe<Array<StripeRefundCreateWithoutIssuedByInput>>;
  createMany?: Maybe<StripeRefundCreateManyIssuedByInputEnvelope>;
};

export type StripeRefundUncheckedCreateNestedManyWithoutStripePaymentIntentInput = {
  connect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeRefundCreateOrConnectWithoutStripePaymentIntentInput>>;
  create?: Maybe<Array<StripeRefundCreateWithoutStripePaymentIntentInput>>;
  createMany?: Maybe<StripeRefundCreateManyStripePaymentIntentInputEnvelope>;
};

export type StripeRefundUncheckedCreateNestedManyWithoutStripePayoutInput = {
  connect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeRefundCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<StripeRefundCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<StripeRefundCreateManyStripePayoutInputEnvelope>;
};

export type StripeRefundUncheckedCreateNestedOneWithoutStripeReceiptInput = {
  connect?: Maybe<StripeRefundWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeRefundCreateOrConnectWithoutStripeReceiptInput>;
  create?: Maybe<StripeRefundCreateWithoutStripeReceiptInput>;
};

export type StripeRefundUncheckedCreateWithoutCareEnrollmentPaymentInput = {
  amount: Scalars['Int'];
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedCreateWithoutFinancialTransactionInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedCreateWithoutIssuedByInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedCreateWithoutPushNotificationLogsInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedCreateWithoutStripePaymentIntentInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedCreateWithoutStripePayoutInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedCreateWithoutStripeReceiptInput = {
  amount: Scalars['Int'];
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedCreateNestedOneWithoutStripeRefundInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedCreateNestedOneWithoutStripeRefundInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedCreateNestedManyWithoutStripeRefundInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Int']>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedUpdateManyWithoutIssuedByInput = {
  amount?: Maybe<Scalars['Int']>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput = {
  connect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeRefundCreateOrConnectWithoutIssuedByInput>>;
  create?: Maybe<Array<StripeRefundCreateWithoutIssuedByInput>>;
  createMany?: Maybe<StripeRefundCreateManyIssuedByInputEnvelope>;
  delete?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeRefundScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  set?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  update?: Maybe<Array<StripeRefundUpdateWithWhereUniqueWithoutIssuedByInput>>;
  updateMany?: Maybe<Array<StripeRefundUpdateManyWithWhereWithoutIssuedByInput>>;
  upsert?: Maybe<Array<StripeRefundUpsertWithWhereUniqueWithoutIssuedByInput>>;
};

export type StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentInput = {
  amount?: Maybe<Scalars['Int']>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedUpdateManyWithoutStripePaymentIntentNestedInput = {
  connect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeRefundCreateOrConnectWithoutStripePaymentIntentInput>>;
  create?: Maybe<Array<StripeRefundCreateWithoutStripePaymentIntentInput>>;
  createMany?: Maybe<StripeRefundCreateManyStripePaymentIntentInputEnvelope>;
  delete?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeRefundScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  set?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  update?: Maybe<Array<StripeRefundUpdateWithWhereUniqueWithoutStripePaymentIntentInput>>;
  updateMany?: Maybe<Array<StripeRefundUpdateManyWithWhereWithoutStripePaymentIntentInput>>;
  upsert?: Maybe<Array<StripeRefundUpsertWithWhereUniqueWithoutStripePaymentIntentInput>>;
};

export type StripeRefundUncheckedUpdateManyWithoutStripePayoutInput = {
  amount?: Maybe<Scalars['Int']>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedUpdateManyWithoutStripePayoutNestedInput = {
  connect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeRefundCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<StripeRefundCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<StripeRefundCreateManyStripePayoutInputEnvelope>;
  delete?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeRefundScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  set?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  update?: Maybe<Array<StripeRefundUpdateWithWhereUniqueWithoutStripePayoutInput>>;
  updateMany?: Maybe<Array<StripeRefundUpdateManyWithWhereWithoutStripePayoutInput>>;
  upsert?: Maybe<Array<StripeRefundUpsertWithWhereUniqueWithoutStripePayoutInput>>;
};

export type StripeRefundUncheckedUpdateOneWithoutStripeReceiptNestedInput = {
  connect?: Maybe<StripeRefundWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeRefundCreateOrConnectWithoutStripeReceiptInput>;
  create?: Maybe<StripeRefundCreateWithoutStripeReceiptInput>;
  delete?: Maybe<StripeRefundWhereInput>;
  disconnect?: Maybe<StripeRefundWhereInput>;
  update?: Maybe<StripeRefundUpdateToOneWithWhereWithoutStripeReceiptInput>;
  upsert?: Maybe<StripeRefundUpsertWithoutStripeReceiptInput>;
};

export type StripeRefundUncheckedUpdateWithoutCareEnrollmentPaymentInput = {
  amount?: Maybe<Scalars['Int']>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedUpdateWithoutFinancialTransactionInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedUpdateWithoutIssuedByInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedUpdateWithoutPushNotificationLogsInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedUpdateWithoutStripePaymentIntentInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedUpdateWithoutStripePayoutInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUncheckedUpdateWithoutStripeReceiptInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUncheckedUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedByUserId?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUncheckedUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserUpdateOneWithoutRefundsIssuedNestedInput>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutStripeRefundsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripeRefundsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutRefundNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Int']>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUpdateManyWithWhereWithoutIssuedByInput = {
  data: StripeRefundUpdateManyMutationInput;
  where: StripeRefundScalarWhereInput;
};

export type StripeRefundUpdateManyWithWhereWithoutStripePaymentIntentInput = {
  data: StripeRefundUpdateManyMutationInput;
  where: StripeRefundScalarWhereInput;
};

export type StripeRefundUpdateManyWithWhereWithoutStripePayoutInput = {
  data: StripeRefundUpdateManyMutationInput;
  where: StripeRefundScalarWhereInput;
};

export type StripeRefundUpdateManyWithoutIssuedByNestedInput = {
  connect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeRefundCreateOrConnectWithoutIssuedByInput>>;
  create?: Maybe<Array<StripeRefundCreateWithoutIssuedByInput>>;
  createMany?: Maybe<StripeRefundCreateManyIssuedByInputEnvelope>;
  delete?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeRefundScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  set?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  update?: Maybe<Array<StripeRefundUpdateWithWhereUniqueWithoutIssuedByInput>>;
  updateMany?: Maybe<Array<StripeRefundUpdateManyWithWhereWithoutIssuedByInput>>;
  upsert?: Maybe<Array<StripeRefundUpsertWithWhereUniqueWithoutIssuedByInput>>;
};

export type StripeRefundUpdateManyWithoutStripePaymentIntentNestedInput = {
  connect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeRefundCreateOrConnectWithoutStripePaymentIntentInput>>;
  create?: Maybe<Array<StripeRefundCreateWithoutStripePaymentIntentInput>>;
  createMany?: Maybe<StripeRefundCreateManyStripePaymentIntentInputEnvelope>;
  delete?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeRefundScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  set?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  update?: Maybe<Array<StripeRefundUpdateWithWhereUniqueWithoutStripePaymentIntentInput>>;
  updateMany?: Maybe<Array<StripeRefundUpdateManyWithWhereWithoutStripePaymentIntentInput>>;
  upsert?: Maybe<Array<StripeRefundUpsertWithWhereUniqueWithoutStripePaymentIntentInput>>;
};

export type StripeRefundUpdateManyWithoutStripePayoutNestedInput = {
  connect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeRefundCreateOrConnectWithoutStripePayoutInput>>;
  create?: Maybe<Array<StripeRefundCreateWithoutStripePayoutInput>>;
  createMany?: Maybe<StripeRefundCreateManyStripePayoutInputEnvelope>;
  delete?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeRefundScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  set?: Maybe<Array<StripeRefundWhereUniqueInput>>;
  update?: Maybe<Array<StripeRefundUpdateWithWhereUniqueWithoutStripePayoutInput>>;
  updateMany?: Maybe<Array<StripeRefundUpdateManyWithWhereWithoutStripePayoutInput>>;
  upsert?: Maybe<Array<StripeRefundUpsertWithWhereUniqueWithoutStripePayoutInput>>;
};

export type StripeRefundUpdateOneWithoutCareEnrollmentPaymentNestedInput = {
  connect?: Maybe<StripeRefundWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeRefundCreateOrConnectWithoutCareEnrollmentPaymentInput>;
  create?: Maybe<StripeRefundCreateWithoutCareEnrollmentPaymentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeRefundUpdateToOneWithWhereWithoutCareEnrollmentPaymentInput>;
  upsert?: Maybe<StripeRefundUpsertWithoutCareEnrollmentPaymentInput>;
};

export type StripeRefundUpdateOneWithoutFinancialTransactionNestedInput = {
  connect?: Maybe<StripeRefundWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeRefundCreateOrConnectWithoutFinancialTransactionInput>;
  create?: Maybe<StripeRefundCreateWithoutFinancialTransactionInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeRefundUpdateToOneWithWhereWithoutFinancialTransactionInput>;
  upsert?: Maybe<StripeRefundUpsertWithoutFinancialTransactionInput>;
};

export type StripeRefundUpdateOneWithoutPushNotificationLogsNestedInput = {
  connect?: Maybe<StripeRefundWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeRefundCreateOrConnectWithoutPushNotificationLogsInput>;
  create?: Maybe<StripeRefundCreateWithoutPushNotificationLogsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeRefundUpdateToOneWithWhereWithoutPushNotificationLogsInput>;
  upsert?: Maybe<StripeRefundUpsertWithoutPushNotificationLogsInput>;
};

export type StripeRefundUpdateOneWithoutStripeReceiptNestedInput = {
  connect?: Maybe<StripeRefundWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeRefundCreateOrConnectWithoutStripeReceiptInput>;
  create?: Maybe<StripeRefundCreateWithoutStripeReceiptInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeRefundUpdateToOneWithWhereWithoutStripeReceiptInput>;
  upsert?: Maybe<StripeRefundUpsertWithoutStripeReceiptInput>;
};

export type StripeRefundUpdateToOneWithWhereWithoutCareEnrollmentPaymentInput = {
  data: StripeRefundUpdateWithoutCareEnrollmentPaymentInput;
  where?: Maybe<StripeRefundWhereInput>;
};

export type StripeRefundUpdateToOneWithWhereWithoutFinancialTransactionInput = {
  data: StripeRefundUpdateWithoutFinancialTransactionInput;
  where?: Maybe<StripeRefundWhereInput>;
};

export type StripeRefundUpdateToOneWithWhereWithoutPushNotificationLogsInput = {
  data: StripeRefundUpdateWithoutPushNotificationLogsInput;
  where?: Maybe<StripeRefundWhereInput>;
};

export type StripeRefundUpdateToOneWithWhereWithoutStripeReceiptInput = {
  data: StripeRefundUpdateWithoutStripeReceiptInput;
  where?: Maybe<StripeRefundWhereInput>;
};

export type StripeRefundUpdateWithWhereUniqueWithoutIssuedByInput = {
  data: StripeRefundUpdateWithoutIssuedByInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundUpdateWithWhereUniqueWithoutStripePaymentIntentInput = {
  data: StripeRefundUpdateWithoutStripePaymentIntentInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundUpdateWithWhereUniqueWithoutStripePayoutInput = {
  data: StripeRefundUpdateWithoutStripePayoutInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundUpdateWithoutCareEnrollmentPaymentInput = {
  amount?: Maybe<Scalars['Int']>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserUpdateOneWithoutRefundsIssuedNestedInput>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutStripeRefundsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripeRefundsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutRefundNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUpdateWithoutFinancialTransactionInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserUpdateOneWithoutRefundsIssuedNestedInput>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutStripeRefundsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripeRefundsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutRefundNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUpdateWithoutIssuedByInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutStripeRefundsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripeRefundsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutRefundNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUpdateWithoutPushNotificationLogsInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserUpdateOneWithoutRefundsIssuedNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutStripeRefundsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripeRefundsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutRefundNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUpdateWithoutStripePaymentIntentInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserUpdateOneWithoutRefundsIssuedNestedInput>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripeRefundsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutRefundNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUpdateWithoutStripePayoutInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserUpdateOneWithoutRefundsIssuedNestedInput>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutStripeRefundsNestedInput>;
  stripeReceipt?: Maybe<StripeReceiptUpdateOneWithoutRefundNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUpdateWithoutStripeReceiptInput = {
  amount?: Maybe<Scalars['Int']>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentUpdateOneWithoutStripeRefundNestedInput>;
  clientFeeRefunded?: Maybe<Scalars['Int']>;
  clinicFeeRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financialTransaction?: Maybe<FinancialTransactionUpdateOneWithoutStripeRefundNestedInput>;
  fundsAvailableAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserUpdateOneWithoutRefundsIssuedNestedInput>;
  pushNotificationLogs?: Maybe<PushNotificationLogUpdateManyWithoutStripeRefundNestedInput>;
  reason?: Maybe<RefundReason>;
  reasonOther?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutStripeRefundsNestedInput>;
  stripePayout?: Maybe<StripePayoutUpdateOneWithoutStripeRefundsNestedInput>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeRefundUpsertWithWhereUniqueWithoutIssuedByInput = {
  create: StripeRefundCreateWithoutIssuedByInput;
  update: StripeRefundUpdateWithoutIssuedByInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundUpsertWithWhereUniqueWithoutStripePaymentIntentInput = {
  create: StripeRefundCreateWithoutStripePaymentIntentInput;
  update: StripeRefundUpdateWithoutStripePaymentIntentInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundUpsertWithWhereUniqueWithoutStripePayoutInput = {
  create: StripeRefundCreateWithoutStripePayoutInput;
  update: StripeRefundUpdateWithoutStripePayoutInput;
  where: StripeRefundWhereUniqueInput;
};

export type StripeRefundUpsertWithoutCareEnrollmentPaymentInput = {
  create: StripeRefundCreateWithoutCareEnrollmentPaymentInput;
  update: StripeRefundUpdateWithoutCareEnrollmentPaymentInput;
  where?: Maybe<StripeRefundWhereInput>;
};

export type StripeRefundUpsertWithoutFinancialTransactionInput = {
  create: StripeRefundCreateWithoutFinancialTransactionInput;
  update: StripeRefundUpdateWithoutFinancialTransactionInput;
  where?: Maybe<StripeRefundWhereInput>;
};

export type StripeRefundUpsertWithoutPushNotificationLogsInput = {
  create: StripeRefundCreateWithoutPushNotificationLogsInput;
  update: StripeRefundUpdateWithoutPushNotificationLogsInput;
  where?: Maybe<StripeRefundWhereInput>;
};

export type StripeRefundUpsertWithoutStripeReceiptInput = {
  create: StripeRefundCreateWithoutStripeReceiptInput;
  update: StripeRefundUpdateWithoutStripeReceiptInput;
  where?: Maybe<StripeRefundWhereInput>;
};

export type StripeRefundWhereInput = {
  AND?: Maybe<Array<StripeRefundWhereInput>>;
  NOT?: Maybe<Array<StripeRefundWhereInput>>;
  OR?: Maybe<Array<StripeRefundWhereInput>>;
  amount?: Maybe<IntFilter>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentNullableScalarRelationFilter>;
  clientFeeRefunded?: Maybe<IntNullableFilter>;
  clinicFeeRefunded?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  issuedBy?: Maybe<UserNullableScalarRelationFilter>;
  issuedByUserId?: Maybe<StringNullableFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  reason?: Maybe<EnumRefundReasonFilter>;
  reasonOther?: Maybe<StringNullableFilter>;
  stripeId?: Maybe<StringFilter>;
  stripePaymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeReceipt?: Maybe<StripeReceiptNullableScalarRelationFilter>;
  stripeReceiptId?: Maybe<StringNullableFilter>;
  total?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeRefundWhereUniqueInput = {
  AND?: Maybe<Array<StripeRefundWhereInput>>;
  NOT?: Maybe<Array<StripeRefundWhereInput>>;
  OR?: Maybe<Array<StripeRefundWhereInput>>;
  amount?: Maybe<IntFilter>;
  careEnrollmentPayment?: Maybe<CareEnrollmentPaymentNullableScalarRelationFilter>;
  clientFeeRefunded?: Maybe<IntNullableFilter>;
  clinicFeeRefunded?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  financialTransaction?: Maybe<FinancialTransactionNullableScalarRelationFilter>;
  fundsAvailableAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<UserNullableScalarRelationFilter>;
  issuedByUserId?: Maybe<StringNullableFilter>;
  pushNotificationLogs?: Maybe<PushNotificationLogListRelationFilter>;
  reason?: Maybe<EnumRefundReasonFilter>;
  reasonOther?: Maybe<StringNullableFilter>;
  stripeId?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  stripePaymentIntentId?: Maybe<StringNullableFilter>;
  stripePayout?: Maybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: Maybe<StringNullableFilter>;
  stripeReceipt?: Maybe<StripeReceiptNullableScalarRelationFilter>;
  stripeReceiptId?: Maybe<Scalars['String']>;
  total?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeRequirements = {
  __typename?: 'StripeRequirements';
  currentlyDue?: Maybe<Array<Scalars['String']>>;
  deadline?: Maybe<Scalars['Date']>;
  disabledReason?: Maybe<Scalars['String']>;
  eventuallyDue?: Maybe<Array<Scalars['String']>>;
  pastDue?: Maybe<Array<Scalars['String']>>;
  pendingVerification?: Maybe<Array<Scalars['String']>>;
};

export type StripeTerminal = {
  __typename?: 'StripeTerminal';
  _count: StripeTerminalCountOutputType;
  createdAt: Scalars['DateTime'];
  healthchecks: Array<StripeTerminalHealthcheck>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  location: StripeTerminalLocation;
  locationId: Scalars['String'];
  model: StripeTerminalModel;
  name: Scalars['String'];
  payments: Array<StripePaymentIntent>;
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type StripeTerminalHealthchecksArgs = {
  cursor?: Maybe<StripeTerminalHealthcheckWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeTerminalHealthcheckScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeTerminalHealthcheckOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeTerminalHealthcheckWhereInput>;
};


export type StripeTerminalPaymentsArgs = {
  cursor?: Maybe<StripePaymentIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentIntentWhereInput>;
};

export type StripeTerminalCountAggregateOutputType = {
  __typename?: 'StripeTerminalCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  locationId: Scalars['Int'];
  model: Scalars['Int'];
  name: Scalars['Int'];
  serialNumber: Scalars['Int'];
  stripeId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StripeTerminalCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  serialNumber?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalCountOutputType = {
  __typename?: 'StripeTerminalCountOutputType';
  healthchecks: Scalars['Int'];
  payments: Scalars['Int'];
};

export type StripeTerminalCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  healthchecks?: Maybe<StripeTerminalHealthcheckCreateNestedManyWithoutTerminalInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  location: StripeTerminalLocationCreateNestedOneWithoutTerminalsInput;
  model: StripeTerminalModel;
  name: Scalars['String'];
  payments?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripeTerminalInput>;
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  model: StripeTerminalModel;
  name: Scalars['String'];
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalCreateManyLocationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  model: StripeTerminalModel;
  name: Scalars['String'];
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalCreateManyLocationInputEnvelope = {
  data: Array<StripeTerminalCreateManyLocationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeTerminalCreateNestedManyWithoutLocationInput = {
  connect?: Maybe<Array<StripeTerminalWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeTerminalCreateOrConnectWithoutLocationInput>>;
  create?: Maybe<Array<StripeTerminalCreateWithoutLocationInput>>;
  createMany?: Maybe<StripeTerminalCreateManyLocationInputEnvelope>;
};

export type StripeTerminalCreateNestedOneWithoutHealthchecksInput = {
  connect?: Maybe<StripeTerminalWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeTerminalCreateOrConnectWithoutHealthchecksInput>;
  create?: Maybe<StripeTerminalCreateWithoutHealthchecksInput>;
};

export type StripeTerminalCreateNestedOneWithoutPaymentsInput = {
  connect?: Maybe<StripeTerminalWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeTerminalCreateOrConnectWithoutPaymentsInput>;
  create?: Maybe<StripeTerminalCreateWithoutPaymentsInput>;
};

export type StripeTerminalCreateOrConnectWithoutHealthchecksInput = {
  create: StripeTerminalCreateWithoutHealthchecksInput;
  where: StripeTerminalWhereUniqueInput;
};

export type StripeTerminalCreateOrConnectWithoutLocationInput = {
  create: StripeTerminalCreateWithoutLocationInput;
  where: StripeTerminalWhereUniqueInput;
};

export type StripeTerminalCreateOrConnectWithoutPaymentsInput = {
  create: StripeTerminalCreateWithoutPaymentsInput;
  where: StripeTerminalWhereUniqueInput;
};

export type StripeTerminalCreateWithoutHealthchecksInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  location: StripeTerminalLocationCreateNestedOneWithoutTerminalsInput;
  model: StripeTerminalModel;
  name: Scalars['String'];
  payments?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripeTerminalInput>;
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalCreateWithoutLocationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  healthchecks?: Maybe<StripeTerminalHealthcheckCreateNestedManyWithoutTerminalInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  model: StripeTerminalModel;
  name: Scalars['String'];
  payments?: Maybe<StripePaymentIntentCreateNestedManyWithoutStripeTerminalInput>;
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalCreateWithoutPaymentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  healthchecks?: Maybe<StripeTerminalHealthcheckCreateNestedManyWithoutTerminalInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  location: StripeTerminalLocationCreateNestedOneWithoutTerminalsInput;
  model: StripeTerminalModel;
  name: Scalars['String'];
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalGroupByOutputType = {
  __typename?: 'StripeTerminalGroupByOutputType';
  _count?: Maybe<StripeTerminalCountAggregateOutputType>;
  _max?: Maybe<StripeTerminalMaxAggregateOutputType>;
  _min?: Maybe<StripeTerminalMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  locationId: Scalars['String'];
  model: StripeTerminalModel;
  name: Scalars['String'];
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type StripeTerminalHealthcheck = {
  __typename?: 'StripeTerminalHealthcheck';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  ipAddress?: Maybe<Scalars['String']>;
  status: StripeTerminalStatus;
  tapVersion?: Maybe<Scalars['String']>;
  terminal: StripeTerminal;
  terminalId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type StripeTerminalHealthcheckCountAggregateOutputType = {
  __typename?: 'StripeTerminalHealthcheckCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  ipAddress: Scalars['Int'];
  status: Scalars['Int'];
  tapVersion: Scalars['Int'];
  terminalId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StripeTerminalHealthcheckCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ipAddress?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  tapVersion?: Maybe<SortOrder>;
  terminalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalHealthcheckCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status: StripeTerminalStatus;
  tapVersion?: Maybe<Scalars['String']>;
  terminal: StripeTerminalCreateNestedOneWithoutHealthchecksInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status: StripeTerminalStatus;
  tapVersion?: Maybe<Scalars['String']>;
  terminalId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckCreateManyTerminalInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status: StripeTerminalStatus;
  tapVersion?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckCreateManyTerminalInputEnvelope = {
  data: Array<StripeTerminalHealthcheckCreateManyTerminalInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeTerminalHealthcheckCreateNestedManyWithoutTerminalInput = {
  connect?: Maybe<Array<StripeTerminalHealthcheckWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeTerminalHealthcheckCreateOrConnectWithoutTerminalInput>>;
  create?: Maybe<Array<StripeTerminalHealthcheckCreateWithoutTerminalInput>>;
  createMany?: Maybe<StripeTerminalHealthcheckCreateManyTerminalInputEnvelope>;
};

export type StripeTerminalHealthcheckCreateOrConnectWithoutTerminalInput = {
  create: StripeTerminalHealthcheckCreateWithoutTerminalInput;
  where: StripeTerminalHealthcheckWhereUniqueInput;
};

export type StripeTerminalHealthcheckCreateWithoutTerminalInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status: StripeTerminalStatus;
  tapVersion?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckGroupByOutputType = {
  __typename?: 'StripeTerminalHealthcheckGroupByOutputType';
  _count?: Maybe<StripeTerminalHealthcheckCountAggregateOutputType>;
  _max?: Maybe<StripeTerminalHealthcheckMaxAggregateOutputType>;
  _min?: Maybe<StripeTerminalHealthcheckMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  ipAddress?: Maybe<Scalars['String']>;
  status: StripeTerminalStatus;
  tapVersion?: Maybe<Scalars['String']>;
  terminalId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type StripeTerminalHealthcheckListRelationFilter = {
  every?: Maybe<StripeTerminalHealthcheckWhereInput>;
  none?: Maybe<StripeTerminalHealthcheckWhereInput>;
  some?: Maybe<StripeTerminalHealthcheckWhereInput>;
};

export type StripeTerminalHealthcheckMaxAggregateOutputType = {
  __typename?: 'StripeTerminalHealthcheckMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status?: Maybe<StripeTerminalStatus>;
  tapVersion?: Maybe<Scalars['String']>;
  terminalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ipAddress?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  tapVersion?: Maybe<SortOrder>;
  terminalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalHealthcheckMinAggregateOutputType = {
  __typename?: 'StripeTerminalHealthcheckMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status?: Maybe<StripeTerminalStatus>;
  tapVersion?: Maybe<Scalars['String']>;
  terminalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ipAddress?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  tapVersion?: Maybe<SortOrder>;
  terminalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalHealthcheckOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StripeTerminalHealthcheckOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeTerminalHealthcheckOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ipAddress?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  tapVersion?: Maybe<SortOrder>;
  terminal?: Maybe<StripeTerminalOrderByWithRelationInput>;
  terminalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeTerminalHealthcheckOrderByRelevanceFieldEnum {
  Id = 'id',
  IpAddress = 'ipAddress',
  TapVersion = 'tapVersion',
  TerminalId = 'terminalId'
}

export type StripeTerminalHealthcheckOrderByRelevanceInput = {
  fields: Array<StripeTerminalHealthcheckOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripeTerminalHealthcheckOrderByWithAggregationInput = {
  _count?: Maybe<StripeTerminalHealthcheckCountOrderByAggregateInput>;
  _max?: Maybe<StripeTerminalHealthcheckMaxOrderByAggregateInput>;
  _min?: Maybe<StripeTerminalHealthcheckMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ipAddress?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  tapVersion?: Maybe<SortOrder>;
  terminalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalHealthcheckOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeTerminalHealthcheckOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ipAddress?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  tapVersion?: Maybe<SortOrder>;
  terminal?: Maybe<StripeTerminalOrderByWithRelationInput>;
  terminalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalHealthcheckOrderByWithRelationInput = {
  _relevance?: Maybe<StripeTerminalHealthcheckOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ipAddress?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  tapVersion?: Maybe<SortOrder>;
  terminal?: Maybe<StripeTerminalOrderByWithRelationInput>;
  terminalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeTerminalHealthcheckScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IpAddress = 'ipAddress',
  Status = 'status',
  TapVersion = 'tapVersion',
  TerminalId = 'terminalId',
  UpdatedAt = 'updatedAt'
}

export type StripeTerminalHealthcheckScalarWhereInput = {
  AND?: Maybe<Array<StripeTerminalHealthcheckScalarWhereInput>>;
  NOT?: Maybe<Array<StripeTerminalHealthcheckScalarWhereInput>>;
  OR?: Maybe<Array<StripeTerminalHealthcheckScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  ipAddress?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumStripeTerminalStatusFilter>;
  tapVersion?: Maybe<StringNullableFilter>;
  terminalId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeTerminalHealthcheckScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripeTerminalHealthcheckScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripeTerminalHealthcheckScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripeTerminalHealthcheckScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  ipAddress?: Maybe<StringNullableWithAggregatesFilter>;
  status?: Maybe<EnumStripeTerminalStatusWithAggregatesFilter>;
  tapVersion?: Maybe<StringNullableWithAggregatesFilter>;
  terminalId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type StripeTerminalHealthcheckUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status: StripeTerminalStatus;
  tapVersion?: Maybe<Scalars['String']>;
  terminalId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckUncheckedCreateNestedManyWithoutTerminalInput = {
  connect?: Maybe<Array<StripeTerminalHealthcheckWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeTerminalHealthcheckCreateOrConnectWithoutTerminalInput>>;
  create?: Maybe<Array<StripeTerminalHealthcheckCreateWithoutTerminalInput>>;
  createMany?: Maybe<StripeTerminalHealthcheckCreateManyTerminalInputEnvelope>;
};

export type StripeTerminalHealthcheckUncheckedCreateWithoutTerminalInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status: StripeTerminalStatus;
  tapVersion?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status?: Maybe<StripeTerminalStatus>;
  tapVersion?: Maybe<Scalars['String']>;
  terminalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status?: Maybe<StripeTerminalStatus>;
  tapVersion?: Maybe<Scalars['String']>;
  terminalId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckUncheckedUpdateManyWithoutTerminalInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status?: Maybe<StripeTerminalStatus>;
  tapVersion?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckUncheckedUpdateManyWithoutTerminalNestedInput = {
  connect?: Maybe<Array<StripeTerminalHealthcheckWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeTerminalHealthcheckCreateOrConnectWithoutTerminalInput>>;
  create?: Maybe<Array<StripeTerminalHealthcheckCreateWithoutTerminalInput>>;
  createMany?: Maybe<StripeTerminalHealthcheckCreateManyTerminalInputEnvelope>;
  delete?: Maybe<Array<StripeTerminalHealthcheckWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeTerminalHealthcheckScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeTerminalHealthcheckWhereUniqueInput>>;
  set?: Maybe<Array<StripeTerminalHealthcheckWhereUniqueInput>>;
  update?: Maybe<Array<StripeTerminalHealthcheckUpdateWithWhereUniqueWithoutTerminalInput>>;
  updateMany?: Maybe<Array<StripeTerminalHealthcheckUpdateManyWithWhereWithoutTerminalInput>>;
  upsert?: Maybe<Array<StripeTerminalHealthcheckUpsertWithWhereUniqueWithoutTerminalInput>>;
};

export type StripeTerminalHealthcheckUncheckedUpdateWithoutTerminalInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status?: Maybe<StripeTerminalStatus>;
  tapVersion?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status?: Maybe<StripeTerminalStatus>;
  tapVersion?: Maybe<Scalars['String']>;
  terminal?: Maybe<StripeTerminalUpdateOneRequiredWithoutHealthchecksNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status?: Maybe<StripeTerminalStatus>;
  tapVersion?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckUpdateManyWithWhereWithoutTerminalInput = {
  data: StripeTerminalHealthcheckUpdateManyMutationInput;
  where: StripeTerminalHealthcheckScalarWhereInput;
};

export type StripeTerminalHealthcheckUpdateManyWithoutTerminalNestedInput = {
  connect?: Maybe<Array<StripeTerminalHealthcheckWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeTerminalHealthcheckCreateOrConnectWithoutTerminalInput>>;
  create?: Maybe<Array<StripeTerminalHealthcheckCreateWithoutTerminalInput>>;
  createMany?: Maybe<StripeTerminalHealthcheckCreateManyTerminalInputEnvelope>;
  delete?: Maybe<Array<StripeTerminalHealthcheckWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeTerminalHealthcheckScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeTerminalHealthcheckWhereUniqueInput>>;
  set?: Maybe<Array<StripeTerminalHealthcheckWhereUniqueInput>>;
  update?: Maybe<Array<StripeTerminalHealthcheckUpdateWithWhereUniqueWithoutTerminalInput>>;
  updateMany?: Maybe<Array<StripeTerminalHealthcheckUpdateManyWithWhereWithoutTerminalInput>>;
  upsert?: Maybe<Array<StripeTerminalHealthcheckUpsertWithWhereUniqueWithoutTerminalInput>>;
};

export type StripeTerminalHealthcheckUpdateWithWhereUniqueWithoutTerminalInput = {
  data: StripeTerminalHealthcheckUpdateWithoutTerminalInput;
  where: StripeTerminalHealthcheckWhereUniqueInput;
};

export type StripeTerminalHealthcheckUpdateWithoutTerminalInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  status?: Maybe<StripeTerminalStatus>;
  tapVersion?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalHealthcheckUpsertWithWhereUniqueWithoutTerminalInput = {
  create: StripeTerminalHealthcheckCreateWithoutTerminalInput;
  update: StripeTerminalHealthcheckUpdateWithoutTerminalInput;
  where: StripeTerminalHealthcheckWhereUniqueInput;
};

export type StripeTerminalHealthcheckWhereInput = {
  AND?: Maybe<Array<StripeTerminalHealthcheckWhereInput>>;
  NOT?: Maybe<Array<StripeTerminalHealthcheckWhereInput>>;
  OR?: Maybe<Array<StripeTerminalHealthcheckWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  ipAddress?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumStripeTerminalStatusFilter>;
  tapVersion?: Maybe<StringNullableFilter>;
  terminal?: Maybe<StripeTerminalScalarRelationFilter>;
  terminalId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeTerminalHealthcheckWhereUniqueInput = {
  AND?: Maybe<Array<StripeTerminalHealthcheckWhereInput>>;
  NOT?: Maybe<Array<StripeTerminalHealthcheckWhereInput>>;
  OR?: Maybe<Array<StripeTerminalHealthcheckWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumStripeTerminalStatusFilter>;
  tapVersion?: Maybe<StringNullableFilter>;
  terminal?: Maybe<StripeTerminalScalarRelationFilter>;
  terminalId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeTerminalListRelationFilter = {
  every?: Maybe<StripeTerminalWhereInput>;
  none?: Maybe<StripeTerminalWhereInput>;
  some?: Maybe<StripeTerminalWhereInput>;
};

export type StripeTerminalLocation = {
  __typename?: 'StripeTerminalLocation';
  _count: StripeTerminalLocationCountOutputType;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  stripeId: Scalars['String'];
  terminals: Array<StripeTerminal>;
  type: StripeTerminalLocationType;
  updatedAt: Scalars['DateTime'];
};


export type StripeTerminalLocationTerminalsArgs = {
  cursor?: Maybe<StripeTerminalWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeTerminalScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeTerminalOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeTerminalWhereInput>;
};

export type StripeTerminalLocationCountAggregateOutputType = {
  __typename?: 'StripeTerminalLocationCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  name: Scalars['Int'];
  stripeId: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StripeTerminalLocationCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalLocationCountOutputType = {
  __typename?: 'StripeTerminalLocationCountOutputType';
  terminals: Scalars['Int'];
};

export type StripeTerminalLocationCreateInput = {
  clinic: ClinicCreateNestedOneWithoutStripeTerminalLocationsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  stripeId: Scalars['String'];
  terminals?: Maybe<StripeTerminalCreateNestedManyWithoutLocationInput>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  stripeId: Scalars['String'];
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationCreateManyClinicInputEnvelope = {
  data: Array<StripeTerminalLocationCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type StripeTerminalLocationCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  stripeId: Scalars['String'];
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<StripeTerminalLocationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeTerminalLocationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<StripeTerminalLocationCreateWithoutClinicInput>>;
  createMany?: Maybe<StripeTerminalLocationCreateManyClinicInputEnvelope>;
};

export type StripeTerminalLocationCreateNestedOneWithoutTerminalsInput = {
  connect?: Maybe<StripeTerminalLocationWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeTerminalLocationCreateOrConnectWithoutTerminalsInput>;
  create?: Maybe<StripeTerminalLocationCreateWithoutTerminalsInput>;
};

export type StripeTerminalLocationCreateOrConnectWithoutClinicInput = {
  create: StripeTerminalLocationCreateWithoutClinicInput;
  where: StripeTerminalLocationWhereUniqueInput;
};

export type StripeTerminalLocationCreateOrConnectWithoutTerminalsInput = {
  create: StripeTerminalLocationCreateWithoutTerminalsInput;
  where: StripeTerminalLocationWhereUniqueInput;
};

export type StripeTerminalLocationCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  stripeId: Scalars['String'];
  terminals?: Maybe<StripeTerminalCreateNestedManyWithoutLocationInput>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationCreateWithoutTerminalsInput = {
  clinic: ClinicCreateNestedOneWithoutStripeTerminalLocationsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  stripeId: Scalars['String'];
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationGroupByOutputType = {
  __typename?: 'StripeTerminalLocationGroupByOutputType';
  _count?: Maybe<StripeTerminalLocationCountAggregateOutputType>;
  _max?: Maybe<StripeTerminalLocationMaxAggregateOutputType>;
  _min?: Maybe<StripeTerminalLocationMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  stripeId: Scalars['String'];
  type: StripeTerminalLocationType;
  updatedAt: Scalars['DateTime'];
};

export type StripeTerminalLocationListRelationFilter = {
  every?: Maybe<StripeTerminalLocationWhereInput>;
  none?: Maybe<StripeTerminalLocationWhereInput>;
  some?: Maybe<StripeTerminalLocationWhereInput>;
};

export type StripeTerminalLocationMaxAggregateOutputType = {
  __typename?: 'StripeTerminalLocationMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalLocationMinAggregateOutputType = {
  __typename?: 'StripeTerminalLocationMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalLocationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StripeTerminalLocationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeTerminalLocationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  terminals?: Maybe<StripeTerminalOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeTerminalLocationOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  Name = 'name',
  StripeId = 'stripeId'
}

export type StripeTerminalLocationOrderByRelevanceInput = {
  fields: Array<StripeTerminalLocationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripeTerminalLocationOrderByWithAggregationInput = {
  _count?: Maybe<StripeTerminalLocationCountOrderByAggregateInput>;
  _max?: Maybe<StripeTerminalLocationMaxOrderByAggregateInput>;
  _min?: Maybe<StripeTerminalLocationMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalLocationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeTerminalLocationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  terminals?: Maybe<StripeTerminalOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalLocationOrderByWithRelationInput = {
  _relevance?: Maybe<StripeTerminalLocationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  terminals?: Maybe<StripeTerminalOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeTerminalLocationScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  Name = 'name',
  StripeId = 'stripeId',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type StripeTerminalLocationScalarRelationFilter = {
  AND?: Maybe<Array<StripeTerminalLocationWhereInput>>;
  NOT?: Maybe<Array<StripeTerminalLocationWhereInput>>;
  OR?: Maybe<Array<StripeTerminalLocationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  terminals?: Maybe<StripeTerminalListRelationFilter>;
  type?: Maybe<EnumStripeTerminalLocationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeTerminalLocationScalarWhereInput = {
  AND?: Maybe<Array<StripeTerminalLocationScalarWhereInput>>;
  NOT?: Maybe<Array<StripeTerminalLocationScalarWhereInput>>;
  OR?: Maybe<Array<StripeTerminalLocationScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  type?: Maybe<EnumStripeTerminalLocationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeTerminalLocationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripeTerminalLocationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripeTerminalLocationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripeTerminalLocationScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  stripeId?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumStripeTerminalLocationTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum StripeTerminalLocationType {
  StripeApp = 'StripeApp',
  Tap = 'TAP'
}

export type StripeTerminalLocationUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  stripeId: Scalars['String'];
  terminals?: Maybe<StripeTerminalUncheckedCreateNestedManyWithoutLocationInput>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<StripeTerminalLocationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeTerminalLocationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<StripeTerminalLocationCreateWithoutClinicInput>>;
  createMany?: Maybe<StripeTerminalLocationCreateManyClinicInputEnvelope>;
};

export type StripeTerminalLocationUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  stripeId: Scalars['String'];
  terminals?: Maybe<StripeTerminalUncheckedCreateNestedManyWithoutLocationInput>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationUncheckedCreateWithoutTerminalsInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  stripeId: Scalars['String'];
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  terminals?: Maybe<StripeTerminalUncheckedUpdateManyWithoutLocationNestedInput>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<StripeTerminalLocationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeTerminalLocationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<StripeTerminalLocationCreateWithoutClinicInput>>;
  createMany?: Maybe<StripeTerminalLocationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<StripeTerminalLocationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeTerminalLocationScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeTerminalLocationWhereUniqueInput>>;
  set?: Maybe<Array<StripeTerminalLocationWhereUniqueInput>>;
  update?: Maybe<Array<StripeTerminalLocationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<StripeTerminalLocationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<StripeTerminalLocationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type StripeTerminalLocationUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  terminals?: Maybe<StripeTerminalUncheckedUpdateManyWithoutLocationNestedInput>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationUncheckedUpdateWithoutTerminalsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationUniqueInput = {
  locationId: Scalars['String'];
};

export type StripeTerminalLocationUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutStripeTerminalLocationsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  terminals?: Maybe<StripeTerminalUpdateManyWithoutLocationNestedInput>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationUpdateManyWithWhereWithoutClinicInput = {
  data: StripeTerminalLocationUpdateManyMutationInput;
  where: StripeTerminalLocationScalarWhereInput;
};

export type StripeTerminalLocationUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<StripeTerminalLocationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeTerminalLocationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<StripeTerminalLocationCreateWithoutClinicInput>>;
  createMany?: Maybe<StripeTerminalLocationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<StripeTerminalLocationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeTerminalLocationScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeTerminalLocationWhereUniqueInput>>;
  set?: Maybe<Array<StripeTerminalLocationWhereUniqueInput>>;
  update?: Maybe<Array<StripeTerminalLocationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<StripeTerminalLocationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<StripeTerminalLocationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type StripeTerminalLocationUpdateOneRequiredWithoutTerminalsNestedInput = {
  connect?: Maybe<StripeTerminalLocationWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeTerminalLocationCreateOrConnectWithoutTerminalsInput>;
  create?: Maybe<StripeTerminalLocationCreateWithoutTerminalsInput>;
  update?: Maybe<StripeTerminalLocationUpdateToOneWithWhereWithoutTerminalsInput>;
  upsert?: Maybe<StripeTerminalLocationUpsertWithoutTerminalsInput>;
};

export type StripeTerminalLocationUpdateToOneWithWhereWithoutTerminalsInput = {
  data: StripeTerminalLocationUpdateWithoutTerminalsInput;
  where?: Maybe<StripeTerminalLocationWhereInput>;
};

export type StripeTerminalLocationUpdateWithWhereUniqueWithoutClinicInput = {
  data: StripeTerminalLocationUpdateWithoutClinicInput;
  where: StripeTerminalLocationWhereUniqueInput;
};

export type StripeTerminalLocationUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  terminals?: Maybe<StripeTerminalUpdateManyWithoutLocationNestedInput>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationUpdateWithoutTerminalsInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutStripeTerminalLocationsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  type?: Maybe<StripeTerminalLocationType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalLocationUpsertWithWhereUniqueWithoutClinicInput = {
  create: StripeTerminalLocationCreateWithoutClinicInput;
  update: StripeTerminalLocationUpdateWithoutClinicInput;
  where: StripeTerminalLocationWhereUniqueInput;
};

export type StripeTerminalLocationUpsertWithoutTerminalsInput = {
  create: StripeTerminalLocationCreateWithoutTerminalsInput;
  update: StripeTerminalLocationUpdateWithoutTerminalsInput;
  where?: Maybe<StripeTerminalLocationWhereInput>;
};

export type StripeTerminalLocationWhereInput = {
  AND?: Maybe<Array<StripeTerminalLocationWhereInput>>;
  NOT?: Maybe<Array<StripeTerminalLocationWhereInput>>;
  OR?: Maybe<Array<StripeTerminalLocationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  terminals?: Maybe<StripeTerminalListRelationFilter>;
  type?: Maybe<EnumStripeTerminalLocationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeTerminalLocationWhereUniqueInput = {
  AND?: Maybe<Array<StripeTerminalLocationWhereInput>>;
  NOT?: Maybe<Array<StripeTerminalLocationWhereInput>>;
  OR?: Maybe<Array<StripeTerminalLocationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  stripeId?: Maybe<Scalars['String']>;
  terminals?: Maybe<StripeTerminalListRelationFilter>;
  type?: Maybe<EnumStripeTerminalLocationTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeTerminalMaxAggregateOutputType = {
  __typename?: 'StripeTerminalMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  serialNumber?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalMinAggregateOutputType = {
  __typename?: 'StripeTerminalMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  serialNumber?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeTerminalModel {
  BbposWisePosE = 'BBPOS_WisePOS_E',
  StripeS700 = 'Stripe_S700',
  VerifoneP400 = 'Verifone_P400'
}

export type StripeTerminalNullableScalarRelationFilter = {
  AND?: Maybe<Array<StripeTerminalWhereInput>>;
  NOT?: Maybe<Array<StripeTerminalWhereInput>>;
  OR?: Maybe<Array<StripeTerminalWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  healthchecks?: Maybe<StripeTerminalHealthcheckListRelationFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  location?: Maybe<StripeTerminalLocationScalarRelationFilter>;
  locationId?: Maybe<StringFilter>;
  model?: Maybe<EnumStripeTerminalModelFilter>;
  name?: Maybe<StringFilter>;
  payments?: Maybe<StripePaymentIntentListRelationFilter>;
  serialNumber?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeTerminalOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type StripeTerminalOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeTerminalOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  healthchecks?: Maybe<StripeTerminalHealthcheckOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  location?: Maybe<StripeTerminalLocationOrderByWithRelationInput>;
  locationId?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  payments?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  serialNumber?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeTerminalOrderByRelevanceFieldEnum {
  Id = 'id',
  LocationId = 'locationId',
  Name = 'name',
  SerialNumber = 'serialNumber',
  StripeId = 'stripeId'
}

export type StripeTerminalOrderByRelevanceInput = {
  fields: Array<StripeTerminalOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type StripeTerminalOrderByWithAggregationInput = {
  _count?: Maybe<StripeTerminalCountOrderByAggregateInput>;
  _max?: Maybe<StripeTerminalMaxOrderByAggregateInput>;
  _min?: Maybe<StripeTerminalMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  serialNumber?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<StripeTerminalOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  healthchecks?: Maybe<StripeTerminalHealthcheckOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  location?: Maybe<StripeTerminalLocationOrderByWithRelationInput>;
  locationId?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  payments?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  serialNumber?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type StripeTerminalOrderByWithRelationInput = {
  _relevance?: Maybe<StripeTerminalOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  healthchecks?: Maybe<StripeTerminalHealthcheckOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  location?: Maybe<StripeTerminalLocationOrderByWithRelationInput>;
  locationId?: Maybe<SortOrder>;
  model?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  payments?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  serialNumber?: Maybe<SortOrder>;
  stripeId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum StripeTerminalScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  LocationId = 'locationId',
  Model = 'model',
  Name = 'name',
  SerialNumber = 'serialNumber',
  StripeId = 'stripeId',
  UpdatedAt = 'updatedAt'
}

export type StripeTerminalScalarRelationFilter = {
  AND?: Maybe<Array<StripeTerminalWhereInput>>;
  NOT?: Maybe<Array<StripeTerminalWhereInput>>;
  OR?: Maybe<Array<StripeTerminalWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  healthchecks?: Maybe<StripeTerminalHealthcheckListRelationFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  location?: Maybe<StripeTerminalLocationScalarRelationFilter>;
  locationId?: Maybe<StringFilter>;
  model?: Maybe<EnumStripeTerminalModelFilter>;
  name?: Maybe<StringFilter>;
  payments?: Maybe<StripePaymentIntentListRelationFilter>;
  serialNumber?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeTerminalScalarWhereInput = {
  AND?: Maybe<Array<StripeTerminalScalarWhereInput>>;
  NOT?: Maybe<Array<StripeTerminalScalarWhereInput>>;
  OR?: Maybe<Array<StripeTerminalScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  locationId?: Maybe<StringFilter>;
  model?: Maybe<EnumStripeTerminalModelFilter>;
  name?: Maybe<StringFilter>;
  serialNumber?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeTerminalScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<StripeTerminalScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<StripeTerminalScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<StripeTerminalScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  locationId?: Maybe<StringWithAggregatesFilter>;
  model?: Maybe<EnumStripeTerminalModelWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  serialNumber?: Maybe<StringWithAggregatesFilter>;
  stripeId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum StripeTerminalStatus {
  Offline = 'Offline',
  Online = 'Online'
}

export type StripeTerminalTokenOutput = {
  __typename?: 'StripeTerminalTokenOutput';
  secret: Scalars['String'];
};

export type StripeTerminalUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  healthchecks?: Maybe<StripeTerminalHealthcheckUncheckedCreateNestedManyWithoutTerminalInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  model: StripeTerminalModel;
  name: Scalars['String'];
  payments?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripeTerminalInput>;
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUncheckedCreateNestedManyWithoutLocationInput = {
  connect?: Maybe<Array<StripeTerminalWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeTerminalCreateOrConnectWithoutLocationInput>>;
  create?: Maybe<Array<StripeTerminalCreateWithoutLocationInput>>;
  createMany?: Maybe<StripeTerminalCreateManyLocationInputEnvelope>;
};

export type StripeTerminalUncheckedCreateWithoutHealthchecksInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  model: StripeTerminalModel;
  name: Scalars['String'];
  payments?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripeTerminalInput>;
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUncheckedCreateWithoutLocationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  healthchecks?: Maybe<StripeTerminalHealthcheckUncheckedCreateNestedManyWithoutTerminalInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  model: StripeTerminalModel;
  name: Scalars['String'];
  payments?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutStripeTerminalInput>;
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUncheckedCreateWithoutPaymentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  healthchecks?: Maybe<StripeTerminalHealthcheckUncheckedCreateNestedManyWithoutTerminalInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  model: StripeTerminalModel;
  name: Scalars['String'];
  serialNumber: Scalars['String'];
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  healthchecks?: Maybe<StripeTerminalHealthcheckUncheckedUpdateManyWithoutTerminalNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  payments?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripeTerminalNestedInput>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUncheckedUpdateManyWithoutLocationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUncheckedUpdateManyWithoutLocationNestedInput = {
  connect?: Maybe<Array<StripeTerminalWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeTerminalCreateOrConnectWithoutLocationInput>>;
  create?: Maybe<Array<StripeTerminalCreateWithoutLocationInput>>;
  createMany?: Maybe<StripeTerminalCreateManyLocationInputEnvelope>;
  delete?: Maybe<Array<StripeTerminalWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeTerminalScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeTerminalWhereUniqueInput>>;
  set?: Maybe<Array<StripeTerminalWhereUniqueInput>>;
  update?: Maybe<Array<StripeTerminalUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: Maybe<Array<StripeTerminalUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: Maybe<Array<StripeTerminalUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type StripeTerminalUncheckedUpdateWithoutHealthchecksInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  payments?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripeTerminalNestedInput>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUncheckedUpdateWithoutLocationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  healthchecks?: Maybe<StripeTerminalHealthcheckUncheckedUpdateManyWithoutTerminalNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  payments?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutStripeTerminalNestedInput>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUncheckedUpdateWithoutPaymentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  healthchecks?: Maybe<StripeTerminalHealthcheckUncheckedUpdateManyWithoutTerminalNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  healthchecks?: Maybe<StripeTerminalHealthcheckUpdateManyWithoutTerminalNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  location?: Maybe<StripeTerminalLocationUpdateOneRequiredWithoutTerminalsNestedInput>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  payments?: Maybe<StripePaymentIntentUpdateManyWithoutStripeTerminalNestedInput>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUpdateManyWithWhereWithoutLocationInput = {
  data: StripeTerminalUpdateManyMutationInput;
  where: StripeTerminalScalarWhereInput;
};

export type StripeTerminalUpdateManyWithoutLocationNestedInput = {
  connect?: Maybe<Array<StripeTerminalWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<StripeTerminalCreateOrConnectWithoutLocationInput>>;
  create?: Maybe<Array<StripeTerminalCreateWithoutLocationInput>>;
  createMany?: Maybe<StripeTerminalCreateManyLocationInputEnvelope>;
  delete?: Maybe<Array<StripeTerminalWhereUniqueInput>>;
  deleteMany?: Maybe<Array<StripeTerminalScalarWhereInput>>;
  disconnect?: Maybe<Array<StripeTerminalWhereUniqueInput>>;
  set?: Maybe<Array<StripeTerminalWhereUniqueInput>>;
  update?: Maybe<Array<StripeTerminalUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: Maybe<Array<StripeTerminalUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: Maybe<Array<StripeTerminalUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type StripeTerminalUpdateOneRequiredWithoutHealthchecksNestedInput = {
  connect?: Maybe<StripeTerminalWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeTerminalCreateOrConnectWithoutHealthchecksInput>;
  create?: Maybe<StripeTerminalCreateWithoutHealthchecksInput>;
  update?: Maybe<StripeTerminalUpdateToOneWithWhereWithoutHealthchecksInput>;
  upsert?: Maybe<StripeTerminalUpsertWithoutHealthchecksInput>;
};

export type StripeTerminalUpdateOneWithoutPaymentsNestedInput = {
  connect?: Maybe<StripeTerminalWhereUniqueInput>;
  connectOrCreate?: Maybe<StripeTerminalCreateOrConnectWithoutPaymentsInput>;
  create?: Maybe<StripeTerminalCreateWithoutPaymentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<StripeTerminalUpdateToOneWithWhereWithoutPaymentsInput>;
  upsert?: Maybe<StripeTerminalUpsertWithoutPaymentsInput>;
};

export type StripeTerminalUpdateToOneWithWhereWithoutHealthchecksInput = {
  data: StripeTerminalUpdateWithoutHealthchecksInput;
  where?: Maybe<StripeTerminalWhereInput>;
};

export type StripeTerminalUpdateToOneWithWhereWithoutPaymentsInput = {
  data: StripeTerminalUpdateWithoutPaymentsInput;
  where?: Maybe<StripeTerminalWhereInput>;
};

export type StripeTerminalUpdateWithWhereUniqueWithoutLocationInput = {
  data: StripeTerminalUpdateWithoutLocationInput;
  where: StripeTerminalWhereUniqueInput;
};

export type StripeTerminalUpdateWithoutHealthchecksInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  location?: Maybe<StripeTerminalLocationUpdateOneRequiredWithoutTerminalsNestedInput>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  payments?: Maybe<StripePaymentIntentUpdateManyWithoutStripeTerminalNestedInput>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUpdateWithoutLocationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  healthchecks?: Maybe<StripeTerminalHealthcheckUpdateManyWithoutTerminalNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  payments?: Maybe<StripePaymentIntentUpdateManyWithoutStripeTerminalNestedInput>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUpdateWithoutPaymentsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  healthchecks?: Maybe<StripeTerminalHealthcheckUpdateManyWithoutTerminalNestedInput>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  location?: Maybe<StripeTerminalLocationUpdateOneRequiredWithoutTerminalsNestedInput>;
  model?: Maybe<StripeTerminalModel>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeTerminalUpsertWithWhereUniqueWithoutLocationInput = {
  create: StripeTerminalCreateWithoutLocationInput;
  update: StripeTerminalUpdateWithoutLocationInput;
  where: StripeTerminalWhereUniqueInput;
};

export type StripeTerminalUpsertWithoutHealthchecksInput = {
  create: StripeTerminalCreateWithoutHealthchecksInput;
  update: StripeTerminalUpdateWithoutHealthchecksInput;
  where?: Maybe<StripeTerminalWhereInput>;
};

export type StripeTerminalUpsertWithoutPaymentsInput = {
  create: StripeTerminalCreateWithoutPaymentsInput;
  update: StripeTerminalUpdateWithoutPaymentsInput;
  where?: Maybe<StripeTerminalWhereInput>;
};

export type StripeTerminalWhereInput = {
  AND?: Maybe<Array<StripeTerminalWhereInput>>;
  NOT?: Maybe<Array<StripeTerminalWhereInput>>;
  OR?: Maybe<Array<StripeTerminalWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  healthchecks?: Maybe<StripeTerminalHealthcheckListRelationFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  location?: Maybe<StripeTerminalLocationScalarRelationFilter>;
  locationId?: Maybe<StringFilter>;
  model?: Maybe<EnumStripeTerminalModelFilter>;
  name?: Maybe<StringFilter>;
  payments?: Maybe<StripePaymentIntentListRelationFilter>;
  serialNumber?: Maybe<StringFilter>;
  stripeId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeTerminalWhereUniqueInput = {
  AND?: Maybe<Array<StripeTerminalWhereInput>>;
  NOT?: Maybe<Array<StripeTerminalWhereInput>>;
  OR?: Maybe<Array<StripeTerminalWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  healthchecks?: Maybe<StripeTerminalHealthcheckListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolFilter>;
  location?: Maybe<StripeTerminalLocationScalarRelationFilter>;
  locationId?: Maybe<StringFilter>;
  model?: Maybe<EnumStripeTerminalModelFilter>;
  name?: Maybe<StringFilter>;
  payments?: Maybe<StripePaymentIntentListRelationFilter>;
  serialNumber?: Maybe<StringFilter>;
  stripeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type StripeUpdatePaymentInput = {
  amount: Scalars['Int'];
  captureType?: Maybe<StripeCaptureType>;
  cardType?: Maybe<CardFunding>;
  clientServiceFeePercent?: Maybe<Scalars['Float']>;
  clinicId: Scalars['String'];
  customer?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptorSuffix?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  paymentIntentId: Scalars['String'];
  paymentMedium?: Maybe<PaymentMedium>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentMethodType?: Maybe<StripePaymentMethodType>;
  receiptEmail?: Maybe<Scalars['String']>;
};

export type SubmitFormResponse = {
  __typename?: 'SubmitFormResponse';
  channelId?: Maybe<Scalars['String']>;
  formSubmission: FormSubmission;
};

export type SubmitPetParentRequestInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  clinicWidgetRequestTypeId: Scalars['String'];
  completedContent: Scalars['Json'];
  formTemplateId: Scalars['String'];
};

export type SubmitPrescriptionRefillRequestInput = {
  clinicId?: Maybe<Scalars['String']>;
  clinicWidgetRequestTypeId: Scalars['String'];
  formSubmission: Scalars['Json'];
  petParentId: Scalars['String'];
  prescriptionsIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SubmitPrescriptionRefillRequestResponse = {
  __typename?: 'SubmitPrescriptionRefillRequestResponse';
  channelId?: Maybe<Scalars['String']>;
  clinicWidgetRequestId: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Subscription = {
  __typename?: 'Subscription';
  automationRunActionChanged: AutomationRunActionSubscription;
  automationRunChanged: AutomationRunSubscription;
  callHistoryChanged: CallHistorySubscription;
  channelChanged: ChannelSubscription;
  channelMemberChanged: ChannelMemberSubscription;
  channelMessageAttachmentChanged: ChannelMessageAttachmentSubscription;
  channelMessageChanged: ChannelMessageSubscription;
  channelSyncedToSearch: Channel;
  checkPetEnrollment: CareEnrollmentOutput;
  checkPetEnrollmentsByClinic: CareEnrollmentsByClinicOutput;
  checkPetParentHasEnrolledPet: HasCarePetWithEnrollmentOutput;
  clinicChanged: ClinicSubscription;
  clinicPhoneNumberChanged: ClinicPhoneNumberSubscription;
  clinicWidgetRequestChanged: ClinicWidgetRequestSubscription;
  enrollmentActivityLogUpdated: EnrollmentActivityLogSubscription;
  formSubmissionChanged?: Maybe<FormSubmissionSubscription>;
  integrationOutageHistoryEntryChanged: IntegrationOutageHistoryEntrySubscription;
  jobChainCompleted?: Maybe<JobChainSubscritptionPayload>;
  loyaltyAccountUpdated: LoyaltyAccountSubscription;
  loyaltyProgramUpdated: LoyaltyProgramSubscription;
  loyaltyRewardRedemptionUpdated: LoyaltyRewardRedemptionSubscription;
  massTextAlertChanged: MassTextAlertSubscription;
  pendingTasksChanged: TaskSubscription;
  recapChanged: RecapSubscription;
  recapSummaryGenerated: RecapSummaryGeneratedSubscription;
  recordingStatusChanged: TwilioCallRecordingSubscription;
  smsNotificationStatusChanged?: Maybe<SmsNotificationStatusSubscription>;
  stripeDisputeChanged: StripeDisputeSubscription;
  stripePaymentIntentChanged: StripePaymentIntentSubscription;
  taskAssigneeRemoved: TaskSubscription;
  teletriageChannelMessageChanged: TeletriageChannelMessageSubscription;
  teletriageChannelSyncedToSearch: Channel;
  teletriageUnreadMessageCountChanged: TeletriageChannelSubscription;
  twilioVerificationChanged: TwilioVerificationSubscription;
  uiRefresh?: Maybe<UiRefresh>;
  unreadMessageCountChanged: ChannelSubscription;
};


export type SubscriptionAutomationRunActionChangedArgs = {
  where: SubscriptionAutomationRunActionWhereInput;
};


export type SubscriptionAutomationRunChangedArgs = {
  where: SubscriptionAutomationRunActionWhereInput;
};


export type SubscriptionCallHistoryChangedArgs = {
  where: SubscriptionCallHistoryWhereInput;
};


export type SubscriptionChannelChangedArgs = {
  where: SubscriptionChannelWhereInput;
};


export type SubscriptionChannelMemberChangedArgs = {
  where: SubscriptionChannelMemberWhereInput;
};


export type SubscriptionChannelMessageAttachmentChangedArgs = {
  where: SubscriptionChannelMessageAttachmentWhereInput;
};


export type SubscriptionChannelMessageChangedArgs = {
  where: SubscriptionChannelMessageWhereInput;
};


export type SubscriptionChannelSyncedToSearchArgs = {
  where?: Maybe<ChannelSyncedToSearchWhereInput>;
};


export type SubscriptionCheckPetEnrollmentArgs = {
  where: CareEnrollmentWhereInput;
};


export type SubscriptionCheckPetEnrollmentsByClinicArgs = {
  where: CareEnrollmentsByClinicWhereInput;
};


export type SubscriptionCheckPetParentHasEnrolledPetArgs = {
  where: HasCarePetWithEnrollmentWhereInput;
};


export type SubscriptionClinicChangedArgs = {
  where: SubscriptionClinicWhereInput;
};


export type SubscriptionClinicPhoneNumberChangedArgs = {
  where: ClinicPhoneNumberWhereInput;
};


export type SubscriptionClinicWidgetRequestChangedArgs = {
  where: SubscriptionClinicWidgetRequestWhereInput;
};


export type SubscriptionEnrollmentActivityLogUpdatedArgs = {
  where: EnrollmentActivityLogWhereUniqueInput;
};


export type SubscriptionFormSubmissionChangedArgs = {
  where?: Maybe<SubscriptionFormSubmissionWhereInput>;
};


export type SubscriptionIntegrationOutageHistoryEntryChangedArgs = {
  where: IntegrationOutageHistoryEntryWhereInput;
};


export type SubscriptionJobChainCompletedArgs = {
  where: JobChainSubscritptionWhereInput;
};


export type SubscriptionLoyaltyAccountUpdatedArgs = {
  where: LoyaltyAccountWhereUniqueInput;
};


export type SubscriptionLoyaltyProgramUpdatedArgs = {
  where: LoyaltyProgramWhereUniqueInput;
};


export type SubscriptionLoyaltyRewardRedemptionUpdatedArgs = {
  where: LoyaltyRewardRedemptionWhereUniqueInput;
};


export type SubscriptionMassTextAlertChangedArgs = {
  where: SubscriptionMassTextAlertWhereInput;
};


export type SubscriptionPendingTasksChangedArgs = {
  where: SubscriptionPendingTasksWhereInput;
};


export type SubscriptionRecapChangedArgs = {
  where: SubscriptionRecapWhereInput;
};


export type SubscriptionRecapSummaryGeneratedArgs = {
  where: SubscriptionRecapSummaryGeneratedWhereInput;
};


export type SubscriptionRecordingStatusChangedArgs = {
  where: SubscriptionTwilioCallRecordingWhereInput;
};


export type SubscriptionSmsNotificationStatusChangedArgs = {
  where: SubscriptionSmsNotificationStatusWhereInput;
};


export type SubscriptionStripeDisputeChangedArgs = {
  where: SubscriptionStripeDisputeWhereInput;
};


export type SubscriptionStripePaymentIntentChangedArgs = {
  where: SubscriptionStripePaymentIntentWhereInput;
};


export type SubscriptionTaskAssigneeRemovedArgs = {
  where: SubscriptionPendingTasksWhereInput;
};


export type SubscriptionTeletriageChannelMessageChangedArgs = {
  where: SubscriptionTeletriageChannelMessageWhereInput;
};


export type SubscriptionTeletriageChannelSyncedToSearchArgs = {
  where?: Maybe<TeletriageChannelSyncedToSearchWhereInput>;
};


export type SubscriptionTeletriageUnreadMessageCountChangedArgs = {
  where: SubscriptionTeletriageChannelWhereInput;
};


export type SubscriptionTwilioVerificationChangedArgs = {
  where: SubscriptionTwilioVerificationWhereInput;
};


export type SubscriptionUnreadMessageCountChangedArgs = {
  where: SubscriptionChannelWhereInput;
};

export type SubscriptionAutomationRunActionWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: AutomationRunActionWhereInput;
};

export type SubscriptionAutomationRunWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: AutomationRunWhereInput;
};

export type SubscriptionCallHistoryWhereInput = {
  clinicId: Scalars['String'];
  extension?: Maybe<Scalars['String']>;
  mutation?: Maybe<Array<MutationType>>;
};

export type SubscriptionChannelMemberWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: ChannelMemberWhereInput;
};

export type SubscriptionChannelMessageAttachmentWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: ChannelMessageAttachmentWhereInput;
};

export type SubscriptionChannelMessageWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: ChannelMessageWhereInput;
};

export type SubscriptionChannelWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: ChannelWhereInput;
};

export type SubscriptionClinicWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: ClinicWhereInput;
};

export type SubscriptionClinicWidgetRequestWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: ClinicWidgetRequestWhereInput;
};

export type SubscriptionFormSubmissionWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: FormSubmissionWhereInput;
};

export type SubscriptionMassTextAlertWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: MassTextAlertWhereInput;
};

export type SubscriptionPendingTasksWhereInput = {
  clinicId: Scalars['String'];
  mutation?: Maybe<Array<MutationType>>;
  userId: Scalars['String'];
};

export type SubscriptionRecapSummaryGeneratedWhereInput = {
  appointmentId: Scalars['String'];
};

export type SubscriptionRecapWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: RecapWhereInput;
};

export type SubscriptionSmsNotificationStatusWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: SmsNotificationStatusWhereInput;
};

export type SubscriptionStripeDisputeWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: StripeDisputeWhereUniqueInput;
};

export type SubscriptionStripePaymentIntentWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: StripePaymentIntentWhereUniqueInput;
};

export type SubscriptionTeletriageChannelMessageWhereInput = {
  channelStatusNames: Array<Scalars['String']>;
  mutation?: Maybe<Array<MutationType>>;
  node: ChannelMessageWhereInput;
};

export type SubscriptionTeletriageChannelWhereInput = {
  channelStatusNames: Array<Scalars['String']>;
  mutation?: Maybe<Array<MutationType>>;
  node: ChannelWhereInput;
};

export type SubscriptionTwilioCallRecordingWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: TwilioCallRecordingWhereInput;
};

export type SubscriptionTwilioVerificationWhereInput = {
  mutation?: Maybe<Array<MutationType>>;
  node: TwilioVerificationWhereInput;
};

export enum SupportEventStatus {
  Canceled = 'Canceled',
  Closed = 'Closed',
  Completed = 'Completed',
  InProgress = 'InProgress',
  Submitted = 'Submitted',
  System = 'System'
}

export type SurveyAppointmentTypeSetting = {
  __typename?: 'SurveyAppointmentTypeSetting';
  appointmentType: AppointmentType;
  appointmentTypeId: Scalars['String'];
  automatedTriggerInMinutes: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  surveySetting: SurveySetting;
  surveySettingId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SurveyAppointmentTypeSettingAvgAggregateOutputType = {
  __typename?: 'SurveyAppointmentTypeSettingAvgAggregateOutputType';
  automatedTriggerInMinutes?: Maybe<Scalars['Float']>;
};

export type SurveyAppointmentTypeSettingAvgOrderByAggregateInput = {
  automatedTriggerInMinutes?: Maybe<SortOrder>;
};

export type SurveyAppointmentTypeSettingCountAggregateOutputType = {
  __typename?: 'SurveyAppointmentTypeSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentTypeId: Scalars['Int'];
  automatedTriggerInMinutes: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  surveySettingId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SurveyAppointmentTypeSettingCountOrderByAggregateInput = {
  appointmentTypeId?: Maybe<SortOrder>;
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  surveySettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveyAppointmentTypeSettingCreateInput = {
  appointmentType: AppointmentTypeCreateNestedOneWithoutSurveyAppointmentTypeSettingsInput;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySetting: SurveySettingCreateNestedOneWithoutAppointmentTypeSettingsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingCreateManyAppointmentTypeInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySettingId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingCreateManyAppointmentTypeInputEnvelope = {
  data: Array<SurveyAppointmentTypeSettingCreateManyAppointmentTypeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SurveyAppointmentTypeSettingCreateManyInput = {
  appointmentTypeId: Scalars['String'];
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySettingId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingCreateManySurveySettingInput = {
  appointmentTypeId: Scalars['String'];
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingCreateManySurveySettingInputEnvelope = {
  data: Array<SurveyAppointmentTypeSettingCreateManySurveySettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SurveyAppointmentTypeSettingCreateNestedManyWithoutAppointmentTypeInput = {
  connect?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<SurveyAppointmentTypeSettingCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<SurveyAppointmentTypeSettingCreateManyAppointmentTypeInputEnvelope>;
};

export type SurveyAppointmentTypeSettingCreateNestedManyWithoutSurveySettingInput = {
  connect?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyAppointmentTypeSettingCreateOrConnectWithoutSurveySettingInput>>;
  create?: Maybe<Array<SurveyAppointmentTypeSettingCreateWithoutSurveySettingInput>>;
  createMany?: Maybe<SurveyAppointmentTypeSettingCreateManySurveySettingInputEnvelope>;
};

export type SurveyAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput = {
  create: SurveyAppointmentTypeSettingCreateWithoutAppointmentTypeInput;
  where: SurveyAppointmentTypeSettingWhereUniqueInput;
};

export type SurveyAppointmentTypeSettingCreateOrConnectWithoutSurveySettingInput = {
  create: SurveyAppointmentTypeSettingCreateWithoutSurveySettingInput;
  where: SurveyAppointmentTypeSettingWhereUniqueInput;
};

export type SurveyAppointmentTypeSettingCreateWithoutAppointmentTypeInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySetting: SurveySettingCreateNestedOneWithoutAppointmentTypeSettingsInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingCreateWithoutSurveySettingInput = {
  appointmentType: AppointmentTypeCreateNestedOneWithoutSurveyAppointmentTypeSettingsInput;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingGroupByOutputType = {
  __typename?: 'SurveyAppointmentTypeSettingGroupByOutputType';
  _avg?: Maybe<SurveyAppointmentTypeSettingAvgAggregateOutputType>;
  _count?: Maybe<SurveyAppointmentTypeSettingCountAggregateOutputType>;
  _max?: Maybe<SurveyAppointmentTypeSettingMaxAggregateOutputType>;
  _min?: Maybe<SurveyAppointmentTypeSettingMinAggregateOutputType>;
  _sum?: Maybe<SurveyAppointmentTypeSettingSumAggregateOutputType>;
  appointmentTypeId: Scalars['String'];
  automatedTriggerInMinutes: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  surveySettingId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SurveyAppointmentTypeSettingListRelationFilter = {
  every?: Maybe<SurveyAppointmentTypeSettingWhereInput>;
  none?: Maybe<SurveyAppointmentTypeSettingWhereInput>;
  some?: Maybe<SurveyAppointmentTypeSettingWhereInput>;
};

export type SurveyAppointmentTypeSettingMaxAggregateOutputType = {
  __typename?: 'SurveyAppointmentTypeSettingMaxAggregateOutputType';
  appointmentTypeId?: Maybe<Scalars['String']>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySettingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingMaxOrderByAggregateInput = {
  appointmentTypeId?: Maybe<SortOrder>;
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  surveySettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveyAppointmentTypeSettingMinAggregateOutputType = {
  __typename?: 'SurveyAppointmentTypeSettingMinAggregateOutputType';
  appointmentTypeId?: Maybe<Scalars['String']>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySettingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingMinOrderByAggregateInput = {
  appointmentTypeId?: Maybe<SortOrder>;
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  surveySettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveyAppointmentTypeSettingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SurveyAppointmentTypeSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SurveyAppointmentTypeSettingOrderByRelevanceInput>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  surveySetting?: Maybe<SurveySettingOrderByWithRelationInput>;
  surveySettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SurveyAppointmentTypeSettingOrderByRelevanceFieldEnum {
  AppointmentTypeId = 'appointmentTypeId',
  Id = 'id',
  SurveySettingId = 'surveySettingId'
}

export type SurveyAppointmentTypeSettingOrderByRelevanceInput = {
  fields: Array<SurveyAppointmentTypeSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type SurveyAppointmentTypeSettingOrderByWithAggregationInput = {
  _avg?: Maybe<SurveyAppointmentTypeSettingAvgOrderByAggregateInput>;
  _count?: Maybe<SurveyAppointmentTypeSettingCountOrderByAggregateInput>;
  _max?: Maybe<SurveyAppointmentTypeSettingMaxOrderByAggregateInput>;
  _min?: Maybe<SurveyAppointmentTypeSettingMinOrderByAggregateInput>;
  _sum?: Maybe<SurveyAppointmentTypeSettingSumOrderByAggregateInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  surveySettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveyAppointmentTypeSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SurveyAppointmentTypeSettingOrderByRelevanceInput>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  surveySetting?: Maybe<SurveySettingOrderByWithRelationInput>;
  surveySettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveyAppointmentTypeSettingOrderByWithRelationInput = {
  _relevance?: Maybe<SurveyAppointmentTypeSettingOrderByRelevanceInput>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  surveySetting?: Maybe<SurveySettingOrderByWithRelationInput>;
  surveySettingId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SurveyAppointmentTypeSettingScalarFieldEnum {
  AppointmentTypeId = 'appointmentTypeId',
  AutomatedTriggerInMinutes = 'automatedTriggerInMinutes',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  SurveySettingId = 'surveySettingId',
  UpdatedAt = 'updatedAt'
}

export type SurveyAppointmentTypeSettingScalarWhereInput = {
  AND?: Maybe<Array<SurveyAppointmentTypeSettingScalarWhereInput>>;
  NOT?: Maybe<Array<SurveyAppointmentTypeSettingScalarWhereInput>>;
  OR?: Maybe<Array<SurveyAppointmentTypeSettingScalarWhereInput>>;
  appointmentTypeId?: Maybe<StringFilter>;
  automatedTriggerInMinutes?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  surveySettingId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SurveyAppointmentTypeSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SurveyAppointmentTypeSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SurveyAppointmentTypeSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SurveyAppointmentTypeSettingScalarWhereWithAggregatesInput>>;
  appointmentTypeId?: Maybe<StringWithAggregatesFilter>;
  automatedTriggerInMinutes?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  surveySettingId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type SurveyAppointmentTypeSettingSumAggregateOutputType = {
  __typename?: 'SurveyAppointmentTypeSettingSumAggregateOutputType';
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
};

export type SurveyAppointmentTypeSettingSumOrderByAggregateInput = {
  automatedTriggerInMinutes?: Maybe<SortOrder>;
};

export type SurveyAppointmentTypeSettingUncheckedCreateInput = {
  appointmentTypeId: Scalars['String'];
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySettingId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutAppointmentTypeInput = {
  connect?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<SurveyAppointmentTypeSettingCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<SurveyAppointmentTypeSettingCreateManyAppointmentTypeInputEnvelope>;
};

export type SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutSurveySettingInput = {
  connect?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyAppointmentTypeSettingCreateOrConnectWithoutSurveySettingInput>>;
  create?: Maybe<Array<SurveyAppointmentTypeSettingCreateWithoutSurveySettingInput>>;
  createMany?: Maybe<SurveyAppointmentTypeSettingCreateManySurveySettingInputEnvelope>;
};

export type SurveyAppointmentTypeSettingUncheckedCreateWithoutAppointmentTypeInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySettingId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUncheckedCreateWithoutSurveySettingInput = {
  appointmentTypeId: Scalars['String'];
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUncheckedUpdateInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySettingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUncheckedUpdateManyInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySettingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySettingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<SurveyAppointmentTypeSettingCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<SurveyAppointmentTypeSettingCreateManyAppointmentTypeInputEnvelope>;
  delete?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SurveyAppointmentTypeSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  set?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  update?: Maybe<Array<SurveyAppointmentTypeSettingUpdateWithWhereUniqueWithoutAppointmentTypeInput>>;
  updateMany?: Maybe<Array<SurveyAppointmentTypeSettingUpdateManyWithWhereWithoutAppointmentTypeInput>>;
  upsert?: Maybe<Array<SurveyAppointmentTypeSettingUpsertWithWhereUniqueWithoutAppointmentTypeInput>>;
};

export type SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutSurveySettingInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutSurveySettingNestedInput = {
  connect?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyAppointmentTypeSettingCreateOrConnectWithoutSurveySettingInput>>;
  create?: Maybe<Array<SurveyAppointmentTypeSettingCreateWithoutSurveySettingInput>>;
  createMany?: Maybe<SurveyAppointmentTypeSettingCreateManySurveySettingInputEnvelope>;
  delete?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SurveyAppointmentTypeSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  set?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  update?: Maybe<Array<SurveyAppointmentTypeSettingUpdateWithWhereUniqueWithoutSurveySettingInput>>;
  updateMany?: Maybe<Array<SurveyAppointmentTypeSettingUpdateManyWithWhereWithoutSurveySettingInput>>;
  upsert?: Maybe<Array<SurveyAppointmentTypeSettingUpsertWithWhereUniqueWithoutSurveySettingInput>>;
};

export type SurveyAppointmentTypeSettingUncheckedUpdateWithoutAppointmentTypeInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySettingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUncheckedUpdateWithoutSurveySettingInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUpdateInput = {
  appointmentType?: Maybe<AppointmentTypeUpdateOneRequiredWithoutSurveyAppointmentTypeSettingsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySetting?: Maybe<SurveySettingUpdateOneRequiredWithoutAppointmentTypeSettingsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUpdateManyMutationInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUpdateManyWithWhereWithoutAppointmentTypeInput = {
  data: SurveyAppointmentTypeSettingUpdateManyMutationInput;
  where: SurveyAppointmentTypeSettingScalarWhereInput;
};

export type SurveyAppointmentTypeSettingUpdateManyWithWhereWithoutSurveySettingInput = {
  data: SurveyAppointmentTypeSettingUpdateManyMutationInput;
  where: SurveyAppointmentTypeSettingScalarWhereInput;
};

export type SurveyAppointmentTypeSettingUpdateManyWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyAppointmentTypeSettingCreateOrConnectWithoutAppointmentTypeInput>>;
  create?: Maybe<Array<SurveyAppointmentTypeSettingCreateWithoutAppointmentTypeInput>>;
  createMany?: Maybe<SurveyAppointmentTypeSettingCreateManyAppointmentTypeInputEnvelope>;
  delete?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SurveyAppointmentTypeSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  set?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  update?: Maybe<Array<SurveyAppointmentTypeSettingUpdateWithWhereUniqueWithoutAppointmentTypeInput>>;
  updateMany?: Maybe<Array<SurveyAppointmentTypeSettingUpdateManyWithWhereWithoutAppointmentTypeInput>>;
  upsert?: Maybe<Array<SurveyAppointmentTypeSettingUpsertWithWhereUniqueWithoutAppointmentTypeInput>>;
};

export type SurveyAppointmentTypeSettingUpdateManyWithoutSurveySettingNestedInput = {
  connect?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyAppointmentTypeSettingCreateOrConnectWithoutSurveySettingInput>>;
  create?: Maybe<Array<SurveyAppointmentTypeSettingCreateWithoutSurveySettingInput>>;
  createMany?: Maybe<SurveyAppointmentTypeSettingCreateManySurveySettingInputEnvelope>;
  delete?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SurveyAppointmentTypeSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  set?: Maybe<Array<SurveyAppointmentTypeSettingWhereUniqueInput>>;
  update?: Maybe<Array<SurveyAppointmentTypeSettingUpdateWithWhereUniqueWithoutSurveySettingInput>>;
  updateMany?: Maybe<Array<SurveyAppointmentTypeSettingUpdateManyWithWhereWithoutSurveySettingInput>>;
  upsert?: Maybe<Array<SurveyAppointmentTypeSettingUpsertWithWhereUniqueWithoutSurveySettingInput>>;
};

export type SurveyAppointmentTypeSettingUpdateWithWhereUniqueWithoutAppointmentTypeInput = {
  data: SurveyAppointmentTypeSettingUpdateWithoutAppointmentTypeInput;
  where: SurveyAppointmentTypeSettingWhereUniqueInput;
};

export type SurveyAppointmentTypeSettingUpdateWithWhereUniqueWithoutSurveySettingInput = {
  data: SurveyAppointmentTypeSettingUpdateWithoutSurveySettingInput;
  where: SurveyAppointmentTypeSettingWhereUniqueInput;
};

export type SurveyAppointmentTypeSettingUpdateWithoutAppointmentTypeInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  surveySetting?: Maybe<SurveySettingUpdateOneRequiredWithoutAppointmentTypeSettingsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUpdateWithoutSurveySettingInput = {
  appointmentType?: Maybe<AppointmentTypeUpdateOneRequiredWithoutSurveyAppointmentTypeSettingsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyAppointmentTypeSettingUpsertWithWhereUniqueWithoutAppointmentTypeInput = {
  create: SurveyAppointmentTypeSettingCreateWithoutAppointmentTypeInput;
  update: SurveyAppointmentTypeSettingUpdateWithoutAppointmentTypeInput;
  where: SurveyAppointmentTypeSettingWhereUniqueInput;
};

export type SurveyAppointmentTypeSettingUpsertWithWhereUniqueWithoutSurveySettingInput = {
  create: SurveyAppointmentTypeSettingCreateWithoutSurveySettingInput;
  update: SurveyAppointmentTypeSettingUpdateWithoutSurveySettingInput;
  where: SurveyAppointmentTypeSettingWhereUniqueInput;
};

export type SurveyAppointmentTypeSettingWhereInput = {
  AND?: Maybe<Array<SurveyAppointmentTypeSettingWhereInput>>;
  NOT?: Maybe<Array<SurveyAppointmentTypeSettingWhereInput>>;
  OR?: Maybe<Array<SurveyAppointmentTypeSettingWhereInput>>;
  appointmentType?: Maybe<AppointmentTypeScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringFilter>;
  automatedTriggerInMinutes?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  surveySetting?: Maybe<SurveySettingScalarRelationFilter>;
  surveySettingId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SurveyAppointmentTypeSettingWhereUniqueInput = {
  AND?: Maybe<Array<SurveyAppointmentTypeSettingWhereInput>>;
  NOT?: Maybe<Array<SurveyAppointmentTypeSettingWhereInput>>;
  OR?: Maybe<Array<SurveyAppointmentTypeSettingWhereInput>>;
  appointmentType?: Maybe<AppointmentTypeScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringFilter>;
  automatedTriggerInMinutes?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  surveySetting?: Maybe<SurveySettingScalarRelationFilter>;
  surveySettingId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SurveyResult = {
  __typename?: 'SurveyResult';
  appointment: Appointment;
  appointmentId: Scalars['String'];
  automationRun?: Maybe<AutomationRun>;
  automationRunId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPetParent: ClinicPetParent;
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type: SurveyType;
  updatedAt: Scalars['DateTime'];
};


export type SurveyResultAutomationRunArgs = {
  where?: Maybe<AutomationRunWhereInput>;
};

export type SurveyResultAvgAggregateOutputType = {
  __typename?: 'SurveyResultAvgAggregateOutputType';
  score?: Maybe<Scalars['Float']>;
};

export type SurveyResultAvgOrderByAggregateInput = {
  score?: Maybe<SortOrder>;
};

export type SurveyResultCountAggregateOutputType = {
  __typename?: 'SurveyResultCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentId: Scalars['Int'];
  automationRunId: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetParentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  feedback: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  score: Scalars['Int'];
  surveySentAt: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SurveyResultCountOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  feedback?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  score?: Maybe<SortOrder>;
  surveySentAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveyResultCreateInput = {
  appointment: AppointmentCreateNestedOneWithoutSurveyResultsInput;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutSurveyResultsInput>;
  clinic: ClinicCreateNestedOneWithoutSurveyResultsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutSurveyResultsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultCreateManyAppointmentInput = {
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultCreateManyAppointmentInputEnvelope = {
  data: Array<SurveyResultCreateManyAppointmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SurveyResultCreateManyAutomationRunInput = {
  appointmentId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultCreateManyAutomationRunInputEnvelope = {
  data: Array<SurveyResultCreateManyAutomationRunInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SurveyResultCreateManyClinicInput = {
  appointmentId: Scalars['String'];
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultCreateManyClinicInputEnvelope = {
  data: Array<SurveyResultCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SurveyResultCreateManyClinicPetParentInput = {
  appointmentId: Scalars['String'];
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultCreateManyClinicPetParentInputEnvelope = {
  data: Array<SurveyResultCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SurveyResultCreateManyInput = {
  appointmentId: Scalars['String'];
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutAppointmentInput>>;
  createMany?: Maybe<SurveyResultCreateManyAppointmentInputEnvelope>;
};

export type SurveyResultCreateNestedManyWithoutAutomationRunInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<SurveyResultCreateManyAutomationRunInputEnvelope>;
};

export type SurveyResultCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutClinicInput>>;
  createMany?: Maybe<SurveyResultCreateManyClinicInputEnvelope>;
};

export type SurveyResultCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<SurveyResultCreateManyClinicPetParentInputEnvelope>;
};

export type SurveyResultCreateOrConnectWithoutAppointmentInput = {
  create: SurveyResultCreateWithoutAppointmentInput;
  where: SurveyResultWhereUniqueInput;
};

export type SurveyResultCreateOrConnectWithoutAutomationRunInput = {
  create: SurveyResultCreateWithoutAutomationRunInput;
  where: SurveyResultWhereUniqueInput;
};

export type SurveyResultCreateOrConnectWithoutClinicInput = {
  create: SurveyResultCreateWithoutClinicInput;
  where: SurveyResultWhereUniqueInput;
};

export type SurveyResultCreateOrConnectWithoutClinicPetParentInput = {
  create: SurveyResultCreateWithoutClinicPetParentInput;
  where: SurveyResultWhereUniqueInput;
};

export type SurveyResultCreateWithoutAppointmentInput = {
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutSurveyResultsInput>;
  clinic: ClinicCreateNestedOneWithoutSurveyResultsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutSurveyResultsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultCreateWithoutAutomationRunInput = {
  appointment: AppointmentCreateNestedOneWithoutSurveyResultsInput;
  clinic: ClinicCreateNestedOneWithoutSurveyResultsInput;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutSurveyResultsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultCreateWithoutClinicInput = {
  appointment: AppointmentCreateNestedOneWithoutSurveyResultsInput;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutSurveyResultsInput>;
  clinicPetParent: ClinicPetParentCreateNestedOneWithoutSurveyResultsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultCreateWithoutClinicPetParentInput = {
  appointment: AppointmentCreateNestedOneWithoutSurveyResultsInput;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutSurveyResultsInput>;
  clinic: ClinicCreateNestedOneWithoutSurveyResultsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultGroupByOutputType = {
  __typename?: 'SurveyResultGroupByOutputType';
  _avg?: Maybe<SurveyResultAvgAggregateOutputType>;
  _count?: Maybe<SurveyResultCountAggregateOutputType>;
  _max?: Maybe<SurveyResultMaxAggregateOutputType>;
  _min?: Maybe<SurveyResultMinAggregateOutputType>;
  _sum?: Maybe<SurveyResultSumAggregateOutputType>;
  appointmentId: Scalars['String'];
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type: SurveyType;
  updatedAt: Scalars['DateTime'];
};

export type SurveyResultListRelationFilter = {
  every?: Maybe<SurveyResultWhereInput>;
  none?: Maybe<SurveyResultWhereInput>;
  some?: Maybe<SurveyResultWhereInput>;
};

export type SurveyResultMaxAggregateOutputType = {
  __typename?: 'SurveyResultMaxAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultMaxOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  feedback?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  score?: Maybe<SortOrder>;
  surveySentAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveyResultMinAggregateOutputType = {
  __typename?: 'SurveyResultMinAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultMinOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  feedback?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  score?: Maybe<SortOrder>;
  surveySentAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveyResultOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SurveyResultOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SurveyResultOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  feedback?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  score?: Maybe<SortOrder>;
  surveySentAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SurveyResultOrderByRelevanceFieldEnum {
  AppointmentId = 'appointmentId',
  AutomationRunId = 'automationRunId',
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  Feedback = 'feedback',
  Id = 'id'
}

export type SurveyResultOrderByRelevanceInput = {
  fields: Array<SurveyResultOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type SurveyResultOrderByWithAggregationInput = {
  _avg?: Maybe<SurveyResultAvgOrderByAggregateInput>;
  _count?: Maybe<SurveyResultCountOrderByAggregateInput>;
  _max?: Maybe<SurveyResultMaxOrderByAggregateInput>;
  _min?: Maybe<SurveyResultMinOrderByAggregateInput>;
  _sum?: Maybe<SurveyResultSumOrderByAggregateInput>;
  appointmentId?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  feedback?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  score?: Maybe<SortOrder>;
  surveySentAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveyResultOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SurveyResultOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  feedback?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  score?: Maybe<SortOrder>;
  surveySentAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveyResultOrderByWithRelationInput = {
  _relevance?: Maybe<SurveyResultOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinicPetParentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  feedback?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  score?: Maybe<SortOrder>;
  surveySentAt?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SurveyResultScalarFieldEnum {
  AppointmentId = 'appointmentId',
  AutomationRunId = 'automationRunId',
  ClinicId = 'clinicId',
  ClinicPetParentId = 'clinicPetParentId',
  CreatedAt = 'createdAt',
  Feedback = 'feedback',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Score = 'score',
  SurveySentAt = 'surveySentAt',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type SurveyResultScalarWhereInput = {
  AND?: Maybe<Array<SurveyResultScalarWhereInput>>;
  NOT?: Maybe<Array<SurveyResultScalarWhereInput>>;
  OR?: Maybe<Array<SurveyResultScalarWhereInput>>;
  appointmentId?: Maybe<StringFilter>;
  automationRunId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  feedback?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  score?: Maybe<IntFilter>;
  surveySentAt?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumSurveyTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SurveyResultScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SurveyResultScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SurveyResultScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SurveyResultScalarWhereWithAggregatesInput>>;
  appointmentId?: Maybe<StringWithAggregatesFilter>;
  automationRunId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  clinicPetParentId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  feedback?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  score?: Maybe<IntWithAggregatesFilter>;
  surveySentAt?: Maybe<DateTimeWithAggregatesFilter>;
  type?: Maybe<EnumSurveyTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type SurveyResultSumAggregateOutputType = {
  __typename?: 'SurveyResultSumAggregateOutputType';
  score?: Maybe<Scalars['Int']>;
};

export type SurveyResultSumOrderByAggregateInput = {
  score?: Maybe<SortOrder>;
};

export type SurveyResultUncheckedCreateInput = {
  appointmentId: Scalars['String'];
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutAppointmentInput>>;
  createMany?: Maybe<SurveyResultCreateManyAppointmentInputEnvelope>;
};

export type SurveyResultUncheckedCreateNestedManyWithoutAutomationRunInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<SurveyResultCreateManyAutomationRunInputEnvelope>;
};

export type SurveyResultUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutClinicInput>>;
  createMany?: Maybe<SurveyResultCreateManyClinicInputEnvelope>;
};

export type SurveyResultUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<SurveyResultCreateManyClinicPetParentInputEnvelope>;
};

export type SurveyResultUncheckedCreateWithoutAppointmentInput = {
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedCreateWithoutAutomationRunInput = {
  appointmentId: Scalars['String'];
  clinicId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedCreateWithoutClinicInput = {
  appointmentId: Scalars['String'];
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedCreateWithoutClinicPetParentInput = {
  appointmentId: Scalars['String'];
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  surveySentAt: Scalars['DateTime'];
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedUpdateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedUpdateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedUpdateManyWithoutAppointmentInput = {
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutAppointmentInput>>;
  createMany?: Maybe<SurveyResultCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SurveyResultScalarWhereInput>>;
  disconnect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  set?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  update?: Maybe<Array<SurveyResultUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<SurveyResultUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<SurveyResultUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type SurveyResultUncheckedUpdateManyWithoutAutomationRunInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedUpdateManyWithoutAutomationRunNestedInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<SurveyResultCreateManyAutomationRunInputEnvelope>;
  delete?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SurveyResultScalarWhereInput>>;
  disconnect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  set?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  update?: Maybe<Array<SurveyResultUpdateWithWhereUniqueWithoutAutomationRunInput>>;
  updateMany?: Maybe<Array<SurveyResultUpdateManyWithWhereWithoutAutomationRunInput>>;
  upsert?: Maybe<Array<SurveyResultUpsertWithWhereUniqueWithoutAutomationRunInput>>;
};

export type SurveyResultUncheckedUpdateManyWithoutClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutClinicInput>>;
  createMany?: Maybe<SurveyResultCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SurveyResultScalarWhereInput>>;
  disconnect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  set?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  update?: Maybe<Array<SurveyResultUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<SurveyResultUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<SurveyResultUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type SurveyResultUncheckedUpdateManyWithoutClinicPetParentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<SurveyResultCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SurveyResultScalarWhereInput>>;
  disconnect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  set?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  update?: Maybe<Array<SurveyResultUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<SurveyResultUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<SurveyResultUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type SurveyResultUncheckedUpdateWithoutAppointmentInput = {
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedUpdateWithoutAutomationRunInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedUpdateWithoutClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicPetParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUncheckedUpdateWithoutClinicPetParentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUpdateInput = {
  appointment?: Maybe<AppointmentUpdateOneRequiredWithoutSurveyResultsNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutSurveyResultsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutSurveyResultsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutSurveyResultsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUpdateManyWithWhereWithoutAppointmentInput = {
  data: SurveyResultUpdateManyMutationInput;
  where: SurveyResultScalarWhereInput;
};

export type SurveyResultUpdateManyWithWhereWithoutAutomationRunInput = {
  data: SurveyResultUpdateManyMutationInput;
  where: SurveyResultScalarWhereInput;
};

export type SurveyResultUpdateManyWithWhereWithoutClinicInput = {
  data: SurveyResultUpdateManyMutationInput;
  where: SurveyResultScalarWhereInput;
};

export type SurveyResultUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: SurveyResultUpdateManyMutationInput;
  where: SurveyResultScalarWhereInput;
};

export type SurveyResultUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutAppointmentInput>>;
  createMany?: Maybe<SurveyResultCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SurveyResultScalarWhereInput>>;
  disconnect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  set?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  update?: Maybe<Array<SurveyResultUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<SurveyResultUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<SurveyResultUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type SurveyResultUpdateManyWithoutAutomationRunNestedInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<SurveyResultCreateManyAutomationRunInputEnvelope>;
  delete?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SurveyResultScalarWhereInput>>;
  disconnect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  set?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  update?: Maybe<Array<SurveyResultUpdateWithWhereUniqueWithoutAutomationRunInput>>;
  updateMany?: Maybe<Array<SurveyResultUpdateManyWithWhereWithoutAutomationRunInput>>;
  upsert?: Maybe<Array<SurveyResultUpsertWithWhereUniqueWithoutAutomationRunInput>>;
};

export type SurveyResultUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutClinicInput>>;
  createMany?: Maybe<SurveyResultCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SurveyResultScalarWhereInput>>;
  disconnect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  set?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  update?: Maybe<Array<SurveyResultUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<SurveyResultUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<SurveyResultUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type SurveyResultUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SurveyResultCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<SurveyResultCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<SurveyResultCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SurveyResultScalarWhereInput>>;
  disconnect?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  set?: Maybe<Array<SurveyResultWhereUniqueInput>>;
  update?: Maybe<Array<SurveyResultUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<SurveyResultUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<SurveyResultUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type SurveyResultUpdateWithWhereUniqueWithoutAppointmentInput = {
  data: SurveyResultUpdateWithoutAppointmentInput;
  where: SurveyResultWhereUniqueInput;
};

export type SurveyResultUpdateWithWhereUniqueWithoutAutomationRunInput = {
  data: SurveyResultUpdateWithoutAutomationRunInput;
  where: SurveyResultWhereUniqueInput;
};

export type SurveyResultUpdateWithWhereUniqueWithoutClinicInput = {
  data: SurveyResultUpdateWithoutClinicInput;
  where: SurveyResultWhereUniqueInput;
};

export type SurveyResultUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: SurveyResultUpdateWithoutClinicPetParentInput;
  where: SurveyResultWhereUniqueInput;
};

export type SurveyResultUpdateWithoutAppointmentInput = {
  automationRun?: Maybe<AutomationRunUpdateOneWithoutSurveyResultsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutSurveyResultsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutSurveyResultsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUpdateWithoutAutomationRunInput = {
  appointment?: Maybe<AppointmentUpdateOneRequiredWithoutSurveyResultsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutSurveyResultsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutSurveyResultsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUpdateWithoutClinicInput = {
  appointment?: Maybe<AppointmentUpdateOneRequiredWithoutSurveyResultsNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutSurveyResultsNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneRequiredWithoutSurveyResultsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUpdateWithoutClinicPetParentInput = {
  appointment?: Maybe<AppointmentUpdateOneRequiredWithoutSurveyResultsNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutSurveyResultsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutSurveyResultsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  surveySentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResultUpsertWithWhereUniqueWithoutAppointmentInput = {
  create: SurveyResultCreateWithoutAppointmentInput;
  update: SurveyResultUpdateWithoutAppointmentInput;
  where: SurveyResultWhereUniqueInput;
};

export type SurveyResultUpsertWithWhereUniqueWithoutAutomationRunInput = {
  create: SurveyResultCreateWithoutAutomationRunInput;
  update: SurveyResultUpdateWithoutAutomationRunInput;
  where: SurveyResultWhereUniqueInput;
};

export type SurveyResultUpsertWithWhereUniqueWithoutClinicInput = {
  create: SurveyResultCreateWithoutClinicInput;
  update: SurveyResultUpdateWithoutClinicInput;
  where: SurveyResultWhereUniqueInput;
};

export type SurveyResultUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: SurveyResultCreateWithoutClinicPetParentInput;
  update: SurveyResultUpdateWithoutClinicPetParentInput;
  where: SurveyResultWhereUniqueInput;
};

export type SurveyResultWhereInput = {
  AND?: Maybe<Array<SurveyResultWhereInput>>;
  NOT?: Maybe<Array<SurveyResultWhereInput>>;
  OR?: Maybe<Array<SurveyResultWhereInput>>;
  appointment?: Maybe<AppointmentScalarRelationFilter>;
  appointmentId?: Maybe<StringFilter>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  automationRunId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  feedback?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  score?: Maybe<IntFilter>;
  surveySentAt?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumSurveyTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SurveyResultWhereUniqueInput = {
  AND?: Maybe<Array<SurveyResultWhereInput>>;
  NOT?: Maybe<Array<SurveyResultWhereInput>>;
  OR?: Maybe<Array<SurveyResultWhereInput>>;
  appointment?: Maybe<AppointmentScalarRelationFilter>;
  appointmentId?: Maybe<StringFilter>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  automationRunId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentScalarRelationFilter>;
  clinicPetParentId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  feedback?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<BoolFilter>;
  score?: Maybe<IntFilter>;
  surveySentAt?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumSurveyTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SurveySetting = {
  __typename?: 'SurveySetting';
  _count: SurveySettingCountOutputType;
  appointmentTypeSettings: Array<SurveyAppointmentTypeSetting>;
  createdAt: Scalars['DateTime'];
  frequencyInDays: Scalars['Int'];
  id: Scalars['String'];
  isAutomatedTriggerForAllAppointmentTypes: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview: Scalars['Boolean'];
  showLinkToLeaveReviewNeutral: Scalars['Boolean'];
  showLinkToLeaveReviewSatisfied: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  workflowEventSettings: Array<WorkflowEventSetting>;
};


export type SurveySettingAppointmentTypeSettingsArgs = {
  cursor?: Maybe<SurveyAppointmentTypeSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SurveyAppointmentTypeSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SurveyAppointmentTypeSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SurveyAppointmentTypeSettingWhereInput>;
};


export type SurveySettingWorkflowEventSettingsArgs = {
  cursor?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type SurveySettingAvgAggregateOutputType = {
  __typename?: 'SurveySettingAvgAggregateOutputType';
  frequencyInDays?: Maybe<Scalars['Float']>;
};

export type SurveySettingAvgOrderByAggregateInput = {
  frequencyInDays?: Maybe<SortOrder>;
};

export type SurveySettingCountAggregateOutputType = {
  __typename?: 'SurveySettingCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  frequencyInDays: Scalars['Int'];
  id: Scalars['Int'];
  isAutomatedTriggerForAllAppointmentTypes: Scalars['Int'];
  isDeleted: Scalars['Int'];
  linkToLeaveReview: Scalars['Int'];
  showLinkToLeaveReview: Scalars['Int'];
  showLinkToLeaveReviewNeutral: Scalars['Int'];
  showLinkToLeaveReviewSatisfied: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SurveySettingCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  frequencyInDays?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  linkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReviewNeutral?: Maybe<SortOrder>;
  showLinkToLeaveReviewSatisfied?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveySettingCountOutputType = {
  __typename?: 'SurveySettingCountOutputType';
  appointmentTypeSettings: Scalars['Int'];
  workflowEventSettings: Scalars['Int'];
};

export type SurveySettingCreateInput = {
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutSurveySettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutSurveySettingInput>;
};

export type SurveySettingCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveySettingCreateNestedOneWithoutAppointmentTypeSettingsInput = {
  connect?: Maybe<SurveySettingWhereUniqueInput>;
  connectOrCreate?: Maybe<SurveySettingCreateOrConnectWithoutAppointmentTypeSettingsInput>;
  create?: Maybe<SurveySettingCreateWithoutAppointmentTypeSettingsInput>;
};

export type SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput = {
  connect?: Maybe<SurveySettingWhereUniqueInput>;
  connectOrCreate?: Maybe<SurveySettingCreateOrConnectWithoutWorkflowEventSettingsInput>;
  create?: Maybe<SurveySettingCreateWithoutWorkflowEventSettingsInput>;
};

export type SurveySettingCreateOrConnectWithoutAppointmentTypeSettingsInput = {
  create: SurveySettingCreateWithoutAppointmentTypeSettingsInput;
  where: SurveySettingWhereUniqueInput;
};

export type SurveySettingCreateOrConnectWithoutWorkflowEventSettingsInput = {
  create: SurveySettingCreateWithoutWorkflowEventSettingsInput;
  where: SurveySettingWhereUniqueInput;
};

export type SurveySettingCreateWithoutAppointmentTypeSettingsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingCreateNestedManyWithoutSurveySettingInput>;
};

export type SurveySettingCreateWithoutWorkflowEventSettingsInput = {
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingCreateNestedManyWithoutSurveySettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveySettingGroupByOutputType = {
  __typename?: 'SurveySettingGroupByOutputType';
  _avg?: Maybe<SurveySettingAvgAggregateOutputType>;
  _count?: Maybe<SurveySettingCountAggregateOutputType>;
  _max?: Maybe<SurveySettingMaxAggregateOutputType>;
  _min?: Maybe<SurveySettingMinAggregateOutputType>;
  _sum?: Maybe<SurveySettingSumAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  frequencyInDays: Scalars['Int'];
  id: Scalars['String'];
  isAutomatedTriggerForAllAppointmentTypes: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview: Scalars['Boolean'];
  showLinkToLeaveReviewNeutral: Scalars['Boolean'];
  showLinkToLeaveReviewSatisfied: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type SurveySettingMaxAggregateOutputType = {
  __typename?: 'SurveySettingMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveySettingMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  frequencyInDays?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  linkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReviewNeutral?: Maybe<SortOrder>;
  showLinkToLeaveReviewSatisfied?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveySettingMinAggregateOutputType = {
  __typename?: 'SurveySettingMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveySettingMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  frequencyInDays?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  linkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReviewNeutral?: Maybe<SortOrder>;
  showLinkToLeaveReviewSatisfied?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveySettingNullableScalarRelationFilter = {
  AND?: Maybe<Array<SurveySettingWhereInput>>;
  NOT?: Maybe<Array<SurveySettingWhereInput>>;
  OR?: Maybe<Array<SurveySettingWhereInput>>;
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  frequencyInDays?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  linkToLeaveReview?: Maybe<StringNullableFilter>;
  showLinkToLeaveReview?: Maybe<BoolFilter>;
  showLinkToLeaveReviewNeutral?: Maybe<BoolFilter>;
  showLinkToLeaveReviewSatisfied?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type SurveySettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SurveySettingOrderByRelevanceInput>;
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  frequencyInDays?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  linkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReviewNeutral?: Maybe<SortOrder>;
  showLinkToLeaveReviewSatisfied?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettings?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum SurveySettingOrderByRelevanceFieldEnum {
  Id = 'id',
  LinkToLeaveReview = 'linkToLeaveReview'
}

export type SurveySettingOrderByRelevanceInput = {
  fields: Array<SurveySettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type SurveySettingOrderByWithAggregationInput = {
  _avg?: Maybe<SurveySettingAvgOrderByAggregateInput>;
  _count?: Maybe<SurveySettingCountOrderByAggregateInput>;
  _max?: Maybe<SurveySettingMaxOrderByAggregateInput>;
  _min?: Maybe<SurveySettingMinOrderByAggregateInput>;
  _sum?: Maybe<SurveySettingSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  frequencyInDays?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  linkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReviewNeutral?: Maybe<SortOrder>;
  showLinkToLeaveReviewSatisfied?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SurveySettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SurveySettingOrderByRelevanceInput>;
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  frequencyInDays?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  linkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReviewNeutral?: Maybe<SortOrder>;
  showLinkToLeaveReviewSatisfied?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettings?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export type SurveySettingOrderByWithRelationInput = {
  _relevance?: Maybe<SurveySettingOrderByRelevanceInput>;
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  frequencyInDays?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  linkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReview?: Maybe<SortOrder>;
  showLinkToLeaveReviewNeutral?: Maybe<SortOrder>;
  showLinkToLeaveReviewSatisfied?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettings?: Maybe<WorkflowEventSettingOrderByRelationAggregateInput>;
};

export enum SurveySettingScalarFieldEnum {
  CreatedAt = 'createdAt',
  FrequencyInDays = 'frequencyInDays',
  Id = 'id',
  IsAutomatedTriggerForAllAppointmentTypes = 'isAutomatedTriggerForAllAppointmentTypes',
  IsDeleted = 'isDeleted',
  LinkToLeaveReview = 'linkToLeaveReview',
  ShowLinkToLeaveReview = 'showLinkToLeaveReview',
  ShowLinkToLeaveReviewNeutral = 'showLinkToLeaveReviewNeutral',
  ShowLinkToLeaveReviewSatisfied = 'showLinkToLeaveReviewSatisfied',
  UpdatedAt = 'updatedAt'
}

export type SurveySettingScalarRelationFilter = {
  AND?: Maybe<Array<SurveySettingWhereInput>>;
  NOT?: Maybe<Array<SurveySettingWhereInput>>;
  OR?: Maybe<Array<SurveySettingWhereInput>>;
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  frequencyInDays?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  linkToLeaveReview?: Maybe<StringNullableFilter>;
  showLinkToLeaveReview?: Maybe<BoolFilter>;
  showLinkToLeaveReviewNeutral?: Maybe<BoolFilter>;
  showLinkToLeaveReviewSatisfied?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type SurveySettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SurveySettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SurveySettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SurveySettingScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  frequencyInDays?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<BoolWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  linkToLeaveReview?: Maybe<StringNullableWithAggregatesFilter>;
  showLinkToLeaveReview?: Maybe<BoolWithAggregatesFilter>;
  showLinkToLeaveReviewNeutral?: Maybe<BoolWithAggregatesFilter>;
  showLinkToLeaveReviewSatisfied?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type SurveySettingSumAggregateOutputType = {
  __typename?: 'SurveySettingSumAggregateOutputType';
  frequencyInDays?: Maybe<Scalars['Int']>;
};

export type SurveySettingSumOrderByAggregateInput = {
  frequencyInDays?: Maybe<SortOrder>;
};

export type SurveySettingUncheckedCreateInput = {
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutSurveySettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutSurveySettingInput>;
};

export type SurveySettingUncheckedCreateWithoutAppointmentTypeSettingsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedCreateNestedManyWithoutSurveySettingInput>;
};

export type SurveySettingUncheckedCreateWithoutWorkflowEventSettingsInput = {
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedCreateNestedManyWithoutSurveySettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveySettingUncheckedUpdateInput = {
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutSurveySettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutSurveySettingNestedInput>;
};

export type SurveySettingUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveySettingUncheckedUpdateWithoutAppointmentTypeSettingsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUncheckedUpdateManyWithoutSurveySettingNestedInput>;
};

export type SurveySettingUncheckedUpdateWithoutWorkflowEventSettingsInput = {
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUncheckedUpdateManyWithoutSurveySettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveySettingUpdateInput = {
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutSurveySettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutSurveySettingNestedInput>;
};

export type SurveySettingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveySettingUpdateOneRequiredWithoutAppointmentTypeSettingsNestedInput = {
  connect?: Maybe<SurveySettingWhereUniqueInput>;
  connectOrCreate?: Maybe<SurveySettingCreateOrConnectWithoutAppointmentTypeSettingsInput>;
  create?: Maybe<SurveySettingCreateWithoutAppointmentTypeSettingsInput>;
  update?: Maybe<SurveySettingUpdateToOneWithWhereWithoutAppointmentTypeSettingsInput>;
  upsert?: Maybe<SurveySettingUpsertWithoutAppointmentTypeSettingsInput>;
};

export type SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput = {
  connect?: Maybe<SurveySettingWhereUniqueInput>;
  connectOrCreate?: Maybe<SurveySettingCreateOrConnectWithoutWorkflowEventSettingsInput>;
  create?: Maybe<SurveySettingCreateWithoutWorkflowEventSettingsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<SurveySettingUpdateToOneWithWhereWithoutWorkflowEventSettingsInput>;
  upsert?: Maybe<SurveySettingUpsertWithoutWorkflowEventSettingsInput>;
};

export type SurveySettingUpdateToOneWithWhereWithoutAppointmentTypeSettingsInput = {
  data: SurveySettingUpdateWithoutAppointmentTypeSettingsInput;
  where?: Maybe<SurveySettingWhereInput>;
};

export type SurveySettingUpdateToOneWithWhereWithoutWorkflowEventSettingsInput = {
  data: SurveySettingUpdateWithoutWorkflowEventSettingsInput;
  where?: Maybe<SurveySettingWhereInput>;
};

export type SurveySettingUpdateWithoutAppointmentTypeSettingsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettings?: Maybe<WorkflowEventSettingUpdateManyWithoutSurveySettingNestedInput>;
};

export type SurveySettingUpdateWithoutWorkflowEventSettingsInput = {
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingUpdateManyWithoutSurveySettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frequencyInDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  linkToLeaveReview?: Maybe<Scalars['String']>;
  showLinkToLeaveReview?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewNeutral?: Maybe<Scalars['Boolean']>;
  showLinkToLeaveReviewSatisfied?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveySettingUpsertWithoutAppointmentTypeSettingsInput = {
  create: SurveySettingCreateWithoutAppointmentTypeSettingsInput;
  update: SurveySettingUpdateWithoutAppointmentTypeSettingsInput;
  where?: Maybe<SurveySettingWhereInput>;
};

export type SurveySettingUpsertWithoutWorkflowEventSettingsInput = {
  create: SurveySettingCreateWithoutWorkflowEventSettingsInput;
  update: SurveySettingUpdateWithoutWorkflowEventSettingsInput;
  where?: Maybe<SurveySettingWhereInput>;
};

export type SurveySettingWhereInput = {
  AND?: Maybe<Array<SurveySettingWhereInput>>;
  NOT?: Maybe<Array<SurveySettingWhereInput>>;
  OR?: Maybe<Array<SurveySettingWhereInput>>;
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  frequencyInDays?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  linkToLeaveReview?: Maybe<StringNullableFilter>;
  showLinkToLeaveReview?: Maybe<BoolFilter>;
  showLinkToLeaveReviewNeutral?: Maybe<BoolFilter>;
  showLinkToLeaveReviewSatisfied?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export type SurveySettingWhereUniqueInput = {
  AND?: Maybe<Array<SurveySettingWhereInput>>;
  NOT?: Maybe<Array<SurveySettingWhereInput>>;
  OR?: Maybe<Array<SurveySettingWhereInput>>;
  appointmentTypeSettings?: Maybe<SurveyAppointmentTypeSettingListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  frequencyInDays?: Maybe<IntFilter>;
  id?: Maybe<Scalars['String']>;
  isAutomatedTriggerForAllAppointmentTypes?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  linkToLeaveReview?: Maybe<StringNullableFilter>;
  showLinkToLeaveReview?: Maybe<BoolFilter>;
  showLinkToLeaveReviewNeutral?: Maybe<BoolFilter>;
  showLinkToLeaveReviewSatisfied?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSettings?: Maybe<WorkflowEventSettingListRelationFilter>;
};

export enum SurveyStep {
  DetractorFeedback = 'DetractorFeedback',
  DissatisfiedFeedback = 'DissatisfiedFeedback',
  PassivePromoterFeedback = 'PassivePromoterFeedback',
  Rating = 'Rating',
  SatisfiedFeedback = 'SatisfiedFeedback'
}

export enum SurveyType {
  Csat = 'CSAT',
  Nps = 'NPS'
}

export type SyncManyPimsIntegrationModelInput = {
  clinicId: Scalars['String'];
  integrationTypes?: Maybe<Array<Maybe<ClinicPimsIntegrationType>>>;
  models?: Maybe<Array<PimsIntegrationCapability>>;
  syncFrom?: Maybe<Scalars['String']>;
};

export type SyncPimsIntegrationModelInput = {
  clinicId: Scalars['String'];
  integrationTypes?: Maybe<Array<Maybe<ClinicPimsIntegrationType>>>;
  model: PimsIntegrationCapability;
  syncFrom?: Maybe<Scalars['String']>;
};

export type SyncVetIntegration = {
  __typename?: 'SyncVetIntegration';
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName: Scalars['String'];
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId: Scalars['String'];
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt: Scalars['DateTime'];
};


export type SyncVetIntegrationClinicPimsIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type SyncVetIntegrationCountAggregateOutputType = {
  __typename?: 'SyncVetIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  abandonedEmailSentAt: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  integrationStatus: Scalars['Int'];
  lastRefetchedAt: Scalars['Int'];
  originalSystem: Scalars['Int'];
  pimsName: Scalars['Int'];
  practiceId: Scalars['Int'];
  siteId: Scalars['Int'];
  syncvetId: Scalars['Int'];
  system: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SyncVetIntegrationCountOrderByAggregateInput = {
  abandonedEmailSentAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  lastRefetchedAt?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  syncvetId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SyncVetIntegrationCreateInput = {
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutSyncvetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName: Scalars['String'];
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId: Scalars['String'];
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationCreateManyInput = {
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName: Scalars['String'];
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId: Scalars['String'];
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<SyncVetIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<SyncVetIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<SyncVetIntegrationCreateWithoutClinicPimsIntegrationInput>;
};

export type SyncVetIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput = {
  create: SyncVetIntegrationCreateWithoutClinicPimsIntegrationInput;
  where: SyncVetIntegrationWhereUniqueInput;
};

export type SyncVetIntegrationCreateWithoutClinicPimsIntegrationInput = {
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName: Scalars['String'];
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId: Scalars['String'];
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationGroupByOutputType = {
  __typename?: 'SyncVetIntegrationGroupByOutputType';
  _count?: Maybe<SyncVetIntegrationCountAggregateOutputType>;
  _max?: Maybe<SyncVetIntegrationMaxAggregateOutputType>;
  _min?: Maybe<SyncVetIntegrationMinAggregateOutputType>;
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName: Scalars['String'];
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId: Scalars['String'];
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt: Scalars['DateTime'];
};

export type SyncVetIntegrationMaxAggregateOutputType = {
  __typename?: 'SyncVetIntegrationMaxAggregateOutputType';
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationMaxOrderByAggregateInput = {
  abandonedEmailSentAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  lastRefetchedAt?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  syncvetId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SyncVetIntegrationMinAggregateOutputType = {
  __typename?: 'SyncVetIntegrationMinAggregateOutputType';
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationMinOrderByAggregateInput = {
  abandonedEmailSentAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  lastRefetchedAt?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  syncvetId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SyncVetIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<SyncVetIntegrationWhereInput>>;
  NOT?: Maybe<Array<SyncVetIntegrationWhereInput>>;
  OR?: Maybe<Array<SyncVetIntegrationWhereInput>>;
  abandonedEmailSentAt?: Maybe<DateTimeNullableFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationStatus?: Maybe<EnumIntegrationStatusNullableFilter>;
  lastRefetchedAt?: Maybe<DateTimeNullableFilter>;
  originalSystem?: Maybe<StringNullableFilter>;
  pimsName?: Maybe<StringFilter>;
  practiceId?: Maybe<StringNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  syncvetId?: Maybe<StringFilter>;
  system?: Maybe<EnumSyncVetIntegrationSystemNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SyncVetIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SyncVetIntegrationOrderByRelevanceInput>;
  abandonedEmailSentAt?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  lastRefetchedAt?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  syncvetId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SyncVetIntegrationOrderByRelevanceFieldEnum {
  Id = 'id',
  OriginalSystem = 'originalSystem',
  PimsName = 'pimsName',
  PracticeId = 'practiceId',
  SiteId = 'siteId',
  SyncvetId = 'syncvetId'
}

export type SyncVetIntegrationOrderByRelevanceInput = {
  fields: Array<SyncVetIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type SyncVetIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<SyncVetIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<SyncVetIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<SyncVetIntegrationMinOrderByAggregateInput>;
  abandonedEmailSentAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  lastRefetchedAt?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  syncvetId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SyncVetIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SyncVetIntegrationOrderByRelevanceInput>;
  abandonedEmailSentAt?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  lastRefetchedAt?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  syncvetId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SyncVetIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<SyncVetIntegrationOrderByRelevanceInput>;
  abandonedEmailSentAt?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  lastRefetchedAt?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  practiceId?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  syncvetId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SyncVetIntegrationScalarFieldEnum {
  AbandonedEmailSentAt = 'abandonedEmailSentAt',
  CreatedAt = 'createdAt',
  Id = 'id',
  IntegrationStatus = 'integrationStatus',
  LastRefetchedAt = 'lastRefetchedAt',
  OriginalSystem = 'originalSystem',
  PimsName = 'pimsName',
  PracticeId = 'practiceId',
  SiteId = 'siteId',
  SyncvetId = 'syncvetId',
  System = 'system',
  UpdatedAt = 'updatedAt'
}

export type SyncVetIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SyncVetIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SyncVetIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SyncVetIntegrationScalarWhereWithAggregatesInput>>;
  abandonedEmailSentAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationStatus?: Maybe<EnumIntegrationStatusNullableWithAggregatesFilter>;
  lastRefetchedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  originalSystem?: Maybe<StringNullableWithAggregatesFilter>;
  pimsName?: Maybe<StringWithAggregatesFilter>;
  practiceId?: Maybe<StringNullableWithAggregatesFilter>;
  siteId?: Maybe<StringNullableWithAggregatesFilter>;
  syncvetId?: Maybe<StringWithAggregatesFilter>;
  system?: Maybe<EnumSyncVetIntegrationSystemNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum SyncVetIntegrationSystem {
  Avimark = 'AVIMARK',
  Cornerstone = 'CORNERSTONE',
  Cornerstonecloud = 'CORNERSTONECLOUD',
  Dataservices = 'DATASERVICES',
  Daysmart = 'DAYSMART',
  Digitail = 'DIGITAIL',
  Epet = 'EPET',
  Gingr = 'GINGR',
  Goosepet = 'GOOSEPET',
  Hippomanager = 'HIPPOMANAGER',
  Impromed = 'IMPROMED',
  Instinct = 'INSTINCT',
  Intravet = 'INTRAVET',
  Intravetsql = 'INTRAVETSQL',
  Logivet = 'LOGIVET',
  Neo = 'NEO',
  Petware = 'PETWARE',
  Provetcloud = 'PROVETCLOUD',
  Rhapsody = 'RHAPSODY',
  Shepherd = 'SHEPHERD',
  Vetspire = 'VETSPIRE',
  Woofware = 'WOOFWARE'
}

export type SyncVetIntegrationUncheckedCreateInput = {
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedOneWithoutSyncvetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName: Scalars['String'];
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId: Scalars['String'];
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationUncheckedCreateWithoutClinicPimsIntegrationInput = {
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName: Scalars['String'];
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId: Scalars['String'];
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationUncheckedUpdateInput = {
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedUpdateOneWithoutSyncvetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationUncheckedUpdateManyInput = {
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationUncheckedUpdateWithoutClinicPimsIntegrationInput = {
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationUpdateInput = {
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutSyncvetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationUpdateManyMutationInput = {
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<SyncVetIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<SyncVetIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<SyncVetIntegrationCreateWithoutClinicPimsIntegrationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<SyncVetIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput>;
  upsert?: Maybe<SyncVetIntegrationUpsertWithoutClinicPimsIntegrationInput>;
};

export type SyncVetIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput = {
  data: SyncVetIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<SyncVetIntegrationWhereInput>;
};

export type SyncVetIntegrationUpdateWithoutClinicPimsIntegrationInput = {
  abandonedEmailSentAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  lastRefetchedAt?: Maybe<Scalars['DateTime']>;
  originalSystem?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  syncvetId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetIntegrationUpsertWithoutClinicPimsIntegrationInput = {
  create: SyncVetIntegrationCreateWithoutClinicPimsIntegrationInput;
  update: SyncVetIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<SyncVetIntegrationWhereInput>;
};

export type SyncVetIntegrationWhereInput = {
  AND?: Maybe<Array<SyncVetIntegrationWhereInput>>;
  NOT?: Maybe<Array<SyncVetIntegrationWhereInput>>;
  OR?: Maybe<Array<SyncVetIntegrationWhereInput>>;
  abandonedEmailSentAt?: Maybe<DateTimeNullableFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationStatus?: Maybe<EnumIntegrationStatusNullableFilter>;
  lastRefetchedAt?: Maybe<DateTimeNullableFilter>;
  originalSystem?: Maybe<StringNullableFilter>;
  pimsName?: Maybe<StringFilter>;
  practiceId?: Maybe<StringNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  syncvetId?: Maybe<StringFilter>;
  system?: Maybe<EnumSyncVetIntegrationSystemNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SyncVetIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<SyncVetIntegrationWhereInput>>;
  NOT?: Maybe<Array<SyncVetIntegrationWhereInput>>;
  OR?: Maybe<Array<SyncVetIntegrationWhereInput>>;
  abandonedEmailSentAt?: Maybe<DateTimeNullableFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<EnumIntegrationStatusNullableFilter>;
  lastRefetchedAt?: Maybe<DateTimeNullableFilter>;
  originalSystem?: Maybe<StringNullableFilter>;
  pimsName?: Maybe<StringFilter>;
  practiceId?: Maybe<StringNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  syncvetId?: Maybe<StringFilter>;
  system?: Maybe<EnumSyncVetIntegrationSystemNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SyncVetService = {
  __typename?: 'SyncVetService';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integration: ClinicPimsIntegration;
  integrationId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type SyncVetServiceCodeIntegrationIdCompoundUniqueInput = {
  code: Scalars['String'];
  integrationId: Scalars['String'];
};

export type SyncVetServiceCountAggregateOutputType = {
  __typename?: 'SyncVetServiceCountAggregateOutputType';
  _all: Scalars['Int'];
  code: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isDeleted: Scalars['Int'];
  name: Scalars['Int'];
  pimsId: Scalars['Int'];
  pimsName: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SyncVetServiceCountOrderByAggregateInput = {
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SyncVetServiceCreateInput = {
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration: ClinicPimsIntegrationCreateNestedOneWithoutSyncVetServiceInput;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceCreateManyInput = {
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceCreateManyIntegrationInput = {
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceCreateManyIntegrationInputEnvelope = {
  data: Array<SyncVetServiceCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SyncVetServiceCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<SyncVetServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SyncVetServiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<SyncVetServiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<SyncVetServiceCreateManyIntegrationInputEnvelope>;
};

export type SyncVetServiceCreateOrConnectWithoutIntegrationInput = {
  create: SyncVetServiceCreateWithoutIntegrationInput;
  where: SyncVetServiceWhereUniqueInput;
};

export type SyncVetServiceCreateWithoutIntegrationInput = {
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceGroupByOutputType = {
  __typename?: 'SyncVetServiceGroupByOutputType';
  _count?: Maybe<SyncVetServiceCountAggregateOutputType>;
  _max?: Maybe<SyncVetServiceMaxAggregateOutputType>;
  _min?: Maybe<SyncVetServiceMinAggregateOutputType>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type SyncVetServiceListRelationFilter = {
  every?: Maybe<SyncVetServiceWhereInput>;
  none?: Maybe<SyncVetServiceWhereInput>;
  some?: Maybe<SyncVetServiceWhereInput>;
};

export type SyncVetServiceMaxAggregateOutputType = {
  __typename?: 'SyncVetServiceMaxAggregateOutputType';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceMaxOrderByAggregateInput = {
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SyncVetServiceMinAggregateOutputType = {
  __typename?: 'SyncVetServiceMinAggregateOutputType';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceMinOrderByAggregateInput = {
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SyncVetServiceOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SyncVetServiceOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SyncVetServiceOrderByRelevanceInput>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SyncVetServiceOrderByRelevanceFieldEnum {
  Code = 'code',
  Id = 'id',
  IntegrationId = 'integrationId',
  Name = 'name',
  PimsId = 'pimsId',
  PimsName = 'pimsName'
}

export type SyncVetServiceOrderByRelevanceInput = {
  fields: Array<SyncVetServiceOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type SyncVetServiceOrderByWithAggregationInput = {
  _count?: Maybe<SyncVetServiceCountOrderByAggregateInput>;
  _max?: Maybe<SyncVetServiceMaxOrderByAggregateInput>;
  _min?: Maybe<SyncVetServiceMinOrderByAggregateInput>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SyncVetServiceOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SyncVetServiceOrderByRelevanceInput>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SyncVetServiceOrderByWithRelationInput = {
  _relevance?: Maybe<SyncVetServiceOrderByRelevanceInput>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  pimsName?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SyncVetServicePimsIdIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export enum SyncVetServiceScalarFieldEnum {
  Code = 'code',
  CreatedAt = 'createdAt',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsDeleted = 'isDeleted',
  Name = 'name',
  PimsId = 'pimsId',
  PimsName = 'pimsName',
  RawPimsValue = 'rawPimsValue',
  UpdatedAt = 'updatedAt'
}

export type SyncVetServiceScalarWhereInput = {
  AND?: Maybe<Array<SyncVetServiceScalarWhereInput>>;
  NOT?: Maybe<Array<SyncVetServiceScalarWhereInput>>;
  OR?: Maybe<Array<SyncVetServiceScalarWhereInput>>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringFilter>;
  pimsName?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SyncVetServiceScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SyncVetServiceScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SyncVetServiceScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SyncVetServiceScalarWhereWithAggregatesInput>>;
  code?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  pimsId?: Maybe<StringWithAggregatesFilter>;
  pimsName?: Maybe<StringWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type SyncVetServiceUncheckedCreateInput = {
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<SyncVetServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SyncVetServiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<SyncVetServiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<SyncVetServiceCreateManyIntegrationInputEnvelope>;
};

export type SyncVetServiceUncheckedCreateWithoutIntegrationInput = {
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pimsId: Scalars['String'];
  pimsName: Scalars['String'];
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceUncheckedUpdateInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceUncheckedUpdateManyInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceUncheckedUpdateManyWithoutIntegrationInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<SyncVetServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SyncVetServiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<SyncVetServiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<SyncVetServiceCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<SyncVetServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SyncVetServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<SyncVetServiceWhereUniqueInput>>;
  set?: Maybe<Array<SyncVetServiceWhereUniqueInput>>;
  update?: Maybe<Array<SyncVetServiceUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<SyncVetServiceUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<SyncVetServiceUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type SyncVetServiceUncheckedUpdateWithoutIntegrationInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceUpdateInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneRequiredWithoutSyncVetServiceNestedInput>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceUpdateManyMutationInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceUpdateManyWithWhereWithoutIntegrationInput = {
  data: SyncVetServiceUpdateManyMutationInput;
  where: SyncVetServiceScalarWhereInput;
};

export type SyncVetServiceUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<SyncVetServiceWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SyncVetServiceCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<SyncVetServiceCreateWithoutIntegrationInput>>;
  createMany?: Maybe<SyncVetServiceCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<SyncVetServiceWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SyncVetServiceScalarWhereInput>>;
  disconnect?: Maybe<Array<SyncVetServiceWhereUniqueInput>>;
  set?: Maybe<Array<SyncVetServiceWhereUniqueInput>>;
  update?: Maybe<Array<SyncVetServiceUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<SyncVetServiceUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<SyncVetServiceUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type SyncVetServiceUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: SyncVetServiceUpdateWithoutIntegrationInput;
  where: SyncVetServiceWhereUniqueInput;
};

export type SyncVetServiceUpdateWithoutIntegrationInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  pimsName?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SyncVetServiceUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: SyncVetServiceCreateWithoutIntegrationInput;
  update: SyncVetServiceUpdateWithoutIntegrationInput;
  where: SyncVetServiceWhereUniqueInput;
};

export type SyncVetServiceWhereInput = {
  AND?: Maybe<Array<SyncVetServiceWhereInput>>;
  NOT?: Maybe<Array<SyncVetServiceWhereInput>>;
  OR?: Maybe<Array<SyncVetServiceWhereInput>>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringFilter>;
  pimsName?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SyncVetServiceWhereUniqueInput = {
  AND?: Maybe<Array<SyncVetServiceWhereInput>>;
  NOT?: Maybe<Array<SyncVetServiceWhereInput>>;
  OR?: Maybe<Array<SyncVetServiceWhereInput>>;
  code?: Maybe<StringFilter>;
  code_integrationId?: Maybe<SyncVetServiceCodeIntegrationIdCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationScalarRelationFilter>;
  integrationId?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  pimsId?: Maybe<StringFilter>;
  pimsId_integrationId?: Maybe<SyncVetServicePimsIdIntegrationIdCompoundUniqueInput>;
  pimsName?: Maybe<StringFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SynchronyClinicConfiguration = {
  __typename?: 'SynchronyClinicConfiguration';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  merchantNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SynchronyClinicConfigurationCountAggregateOutputType = {
  __typename?: 'SynchronyClinicConfigurationCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  merchantNumber: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SynchronyClinicConfigurationCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SynchronyClinicConfigurationCreateInput = {
  clinic: ClinicCreateNestedOneWithoutSynchronyClinicConfigurationInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<SynchronyClinicConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<SynchronyClinicConfigurationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<SynchronyClinicConfigurationCreateWithoutClinicInput>;
};

export type SynchronyClinicConfigurationCreateOrConnectWithoutClinicInput = {
  create: SynchronyClinicConfigurationCreateWithoutClinicInput;
  where: SynchronyClinicConfigurationWhereUniqueInput;
};

export type SynchronyClinicConfigurationCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationGroupByOutputType = {
  __typename?: 'SynchronyClinicConfigurationGroupByOutputType';
  _count?: Maybe<SynchronyClinicConfigurationCountAggregateOutputType>;
  _max?: Maybe<SynchronyClinicConfigurationMaxAggregateOutputType>;
  _min?: Maybe<SynchronyClinicConfigurationMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  merchantNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SynchronyClinicConfigurationMaxAggregateOutputType = {
  __typename?: 'SynchronyClinicConfigurationMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SynchronyClinicConfigurationMinAggregateOutputType = {
  __typename?: 'SynchronyClinicConfigurationMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SynchronyClinicConfigurationNullableScalarRelationFilter = {
  AND?: Maybe<Array<SynchronyClinicConfigurationWhereInput>>;
  NOT?: Maybe<Array<SynchronyClinicConfigurationWhereInput>>;
  OR?: Maybe<Array<SynchronyClinicConfigurationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  merchantNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SynchronyClinicConfigurationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SynchronyClinicConfigurationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SynchronyClinicConfigurationOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  MerchantNumber = 'merchantNumber'
}

export type SynchronyClinicConfigurationOrderByRelevanceInput = {
  fields: Array<SynchronyClinicConfigurationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type SynchronyClinicConfigurationOrderByWithAggregationInput = {
  _count?: Maybe<SynchronyClinicConfigurationCountOrderByAggregateInput>;
  _max?: Maybe<SynchronyClinicConfigurationMaxOrderByAggregateInput>;
  _min?: Maybe<SynchronyClinicConfigurationMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SynchronyClinicConfigurationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SynchronyClinicConfigurationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SynchronyClinicConfigurationOrderByWithRelationInput = {
  _relevance?: Maybe<SynchronyClinicConfigurationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SynchronyClinicConfigurationScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  MerchantNumber = 'merchantNumber',
  UpdatedAt = 'updatedAt'
}

export type SynchronyClinicConfigurationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SynchronyClinicConfigurationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SynchronyClinicConfigurationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SynchronyClinicConfigurationScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  merchantNumber?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type SynchronyClinicConfigurationUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationUncheckedCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<SynchronyClinicConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<SynchronyClinicConfigurationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<SynchronyClinicConfigurationCreateWithoutClinicInput>;
};

export type SynchronyClinicConfigurationUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationUncheckedUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<SynchronyClinicConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<SynchronyClinicConfigurationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<SynchronyClinicConfigurationCreateWithoutClinicInput>;
  delete?: Maybe<SynchronyClinicConfigurationWhereInput>;
  disconnect?: Maybe<SynchronyClinicConfigurationWhereInput>;
  update?: Maybe<SynchronyClinicConfigurationUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<SynchronyClinicConfigurationUpsertWithoutClinicInput>;
};

export type SynchronyClinicConfigurationUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutSynchronyClinicConfigurationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<SynchronyClinicConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<SynchronyClinicConfigurationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<SynchronyClinicConfigurationCreateWithoutClinicInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<SynchronyClinicConfigurationUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<SynchronyClinicConfigurationUpsertWithoutClinicInput>;
};

export type SynchronyClinicConfigurationUpdateToOneWithWhereWithoutClinicInput = {
  data: SynchronyClinicConfigurationUpdateWithoutClinicInput;
  where?: Maybe<SynchronyClinicConfigurationWhereInput>;
};

export type SynchronyClinicConfigurationUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyClinicConfigurationUpsertWithoutClinicInput = {
  create: SynchronyClinicConfigurationCreateWithoutClinicInput;
  update: SynchronyClinicConfigurationUpdateWithoutClinicInput;
  where?: Maybe<SynchronyClinicConfigurationWhereInput>;
};

export type SynchronyClinicConfigurationWhereInput = {
  AND?: Maybe<Array<SynchronyClinicConfigurationWhereInput>>;
  NOT?: Maybe<Array<SynchronyClinicConfigurationWhereInput>>;
  OR?: Maybe<Array<SynchronyClinicConfigurationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  merchantNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SynchronyClinicConfigurationWhereUniqueInput = {
  AND?: Maybe<Array<SynchronyClinicConfigurationWhereInput>>;
  NOT?: Maybe<Array<SynchronyClinicConfigurationWhereInput>>;
  OR?: Maybe<Array<SynchronyClinicConfigurationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SynchronyEvent = {
  __typename?: 'SynchronyEvent';
  body: Scalars['Json'];
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheck>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  eventType: SynchronyEventType;
  id: Scalars['String'];
  merchantNumber: Scalars['String'];
  /** Synchrony Patient Data Service reference ID */
  referenceExternalId: Scalars['String'];
  status: SynchronyEventStatus;
  updatedAt: Scalars['DateTime'];
};


export type SynchronyEventCareCreditPreapprovalCheckArgs = {
  where?: Maybe<CareCreditPreapprovalCheckWhereInput>;
};

export type SynchronyEventCountAggregateOutputType = {
  __typename?: 'SynchronyEventCountAggregateOutputType';
  _all: Scalars['Int'];
  body: Scalars['Int'];
  careCreditPreapprovalCheckId: Scalars['Int'];
  createdAt: Scalars['Int'];
  eventType: Scalars['Int'];
  id: Scalars['Int'];
  merchantNumber: Scalars['Int'];
  referenceExternalId: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SynchronyEventCountOrderByAggregateInput = {
  body?: Maybe<SortOrder>;
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  eventType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SynchronyEventCreateInput = {
  body?: Maybe<Scalars['Json']>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckCreateNestedOneWithoutEventsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType: SynchronyEventType;
  id?: Maybe<Scalars['String']>;
  merchantNumber: Scalars['String'];
  referenceExternalId: Scalars['String'];
  status: SynchronyEventStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventCreateManyCareCreditPreapprovalCheckInput = {
  body?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType: SynchronyEventType;
  id?: Maybe<Scalars['String']>;
  merchantNumber: Scalars['String'];
  referenceExternalId: Scalars['String'];
  status: SynchronyEventStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventCreateManyCareCreditPreapprovalCheckInputEnvelope = {
  data: Array<SynchronyEventCreateManyCareCreditPreapprovalCheckInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SynchronyEventCreateManyInput = {
  body?: Maybe<Scalars['Json']>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType: SynchronyEventType;
  id?: Maybe<Scalars['String']>;
  merchantNumber: Scalars['String'];
  referenceExternalId: Scalars['String'];
  status: SynchronyEventStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventCreateNestedManyWithoutCareCreditPreapprovalCheckInput = {
  connect?: Maybe<Array<SynchronyEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SynchronyEventCreateOrConnectWithoutCareCreditPreapprovalCheckInput>>;
  create?: Maybe<Array<SynchronyEventCreateWithoutCareCreditPreapprovalCheckInput>>;
  createMany?: Maybe<SynchronyEventCreateManyCareCreditPreapprovalCheckInputEnvelope>;
};

export type SynchronyEventCreateOrConnectWithoutCareCreditPreapprovalCheckInput = {
  create: SynchronyEventCreateWithoutCareCreditPreapprovalCheckInput;
  where: SynchronyEventWhereUniqueInput;
};

export type SynchronyEventCreateWithoutCareCreditPreapprovalCheckInput = {
  body?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType: SynchronyEventType;
  id?: Maybe<Scalars['String']>;
  merchantNumber: Scalars['String'];
  referenceExternalId: Scalars['String'];
  status: SynchronyEventStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventGroupByOutputType = {
  __typename?: 'SynchronyEventGroupByOutputType';
  _count?: Maybe<SynchronyEventCountAggregateOutputType>;
  _max?: Maybe<SynchronyEventMaxAggregateOutputType>;
  _min?: Maybe<SynchronyEventMinAggregateOutputType>;
  body: Scalars['Json'];
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  eventType: SynchronyEventType;
  id: Scalars['String'];
  merchantNumber: Scalars['String'];
  referenceExternalId: Scalars['String'];
  status: SynchronyEventStatus;
  updatedAt: Scalars['DateTime'];
};

export type SynchronyEventListRelationFilter = {
  every?: Maybe<SynchronyEventWhereInput>;
  none?: Maybe<SynchronyEventWhereInput>;
  some?: Maybe<SynchronyEventWhereInput>;
};

export type SynchronyEventMaxAggregateOutputType = {
  __typename?: 'SynchronyEventMaxAggregateOutputType';
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<SynchronyEventType>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  status?: Maybe<SynchronyEventStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventMaxOrderByAggregateInput = {
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  eventType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SynchronyEventMinAggregateOutputType = {
  __typename?: 'SynchronyEventMinAggregateOutputType';
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<SynchronyEventType>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  status?: Maybe<SynchronyEventStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventMinOrderByAggregateInput = {
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  eventType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SynchronyEventOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SynchronyEventOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SynchronyEventOrderByRelevanceInput>;
  body?: Maybe<SortOrder>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckOrderByWithRelationInput>;
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  eventType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SynchronyEventOrderByRelevanceFieldEnum {
  CareCreditPreapprovalCheckId = 'careCreditPreapprovalCheckId',
  Id = 'id',
  MerchantNumber = 'merchantNumber',
  ReferenceExternalId = 'referenceExternalId'
}

export type SynchronyEventOrderByRelevanceInput = {
  fields: Array<SynchronyEventOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type SynchronyEventOrderByWithAggregationInput = {
  _count?: Maybe<SynchronyEventCountOrderByAggregateInput>;
  _max?: Maybe<SynchronyEventMaxOrderByAggregateInput>;
  _min?: Maybe<SynchronyEventMinOrderByAggregateInput>;
  body?: Maybe<SortOrder>;
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  eventType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SynchronyEventOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<SynchronyEventOrderByRelevanceInput>;
  body?: Maybe<SortOrder>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckOrderByWithRelationInput>;
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  eventType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SynchronyEventOrderByWithRelationInput = {
  _relevance?: Maybe<SynchronyEventOrderByRelevanceInput>;
  body?: Maybe<SortOrder>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckOrderByWithRelationInput>;
  careCreditPreapprovalCheckId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  eventType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  merchantNumber?: Maybe<SortOrder>;
  referenceExternalId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SynchronyEventScalarFieldEnum {
  Body = 'body',
  CareCreditPreapprovalCheckId = 'careCreditPreapprovalCheckId',
  CreatedAt = 'createdAt',
  EventType = 'eventType',
  Id = 'id',
  MerchantNumber = 'merchantNumber',
  ReferenceExternalId = 'referenceExternalId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type SynchronyEventScalarWhereInput = {
  AND?: Maybe<Array<SynchronyEventScalarWhereInput>>;
  NOT?: Maybe<Array<SynchronyEventScalarWhereInput>>;
  OR?: Maybe<Array<SynchronyEventScalarWhereInput>>;
  body?: Maybe<JsonFilter>;
  careCreditPreapprovalCheckId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  eventType?: Maybe<EnumSynchronyEventTypeFilter>;
  id?: Maybe<StringFilter>;
  merchantNumber?: Maybe<StringFilter>;
  referenceExternalId?: Maybe<StringFilter>;
  status?: Maybe<EnumSynchronyEventStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SynchronyEventScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SynchronyEventScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SynchronyEventScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SynchronyEventScalarWhereWithAggregatesInput>>;
  body?: Maybe<JsonWithAggregatesFilter>;
  careCreditPreapprovalCheckId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  eventType?: Maybe<EnumSynchronyEventTypeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  merchantNumber?: Maybe<StringWithAggregatesFilter>;
  referenceExternalId?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumSynchronyEventStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum SynchronyEventStatus {
  Approved = 'Approved',
  Declined = 'Declined',
  Pending = 'Pending'
}

export enum SynchronyEventType {
  Apply = 'Apply',
  Purchase = 'Purchase',
  Quickscreen = 'Quickscreen',
  Refund = 'Refund'
}

export type SynchronyEventUncheckedCreateInput = {
  body?: Maybe<Scalars['Json']>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType: SynchronyEventType;
  id?: Maybe<Scalars['String']>;
  merchantNumber: Scalars['String'];
  referenceExternalId: Scalars['String'];
  status: SynchronyEventStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventUncheckedCreateNestedManyWithoutCareCreditPreapprovalCheckInput = {
  connect?: Maybe<Array<SynchronyEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SynchronyEventCreateOrConnectWithoutCareCreditPreapprovalCheckInput>>;
  create?: Maybe<Array<SynchronyEventCreateWithoutCareCreditPreapprovalCheckInput>>;
  createMany?: Maybe<SynchronyEventCreateManyCareCreditPreapprovalCheckInputEnvelope>;
};

export type SynchronyEventUncheckedCreateWithoutCareCreditPreapprovalCheckInput = {
  body?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType: SynchronyEventType;
  id?: Maybe<Scalars['String']>;
  merchantNumber: Scalars['String'];
  referenceExternalId: Scalars['String'];
  status: SynchronyEventStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventUncheckedUpdateInput = {
  body?: Maybe<Scalars['Json']>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<SynchronyEventType>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  status?: Maybe<SynchronyEventStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventUncheckedUpdateManyInput = {
  body?: Maybe<Scalars['Json']>;
  careCreditPreapprovalCheckId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<SynchronyEventType>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  status?: Maybe<SynchronyEventStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventUncheckedUpdateManyWithoutCareCreditPreapprovalCheckInput = {
  body?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<SynchronyEventType>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  status?: Maybe<SynchronyEventStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventUncheckedUpdateManyWithoutCareCreditPreapprovalCheckNestedInput = {
  connect?: Maybe<Array<SynchronyEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SynchronyEventCreateOrConnectWithoutCareCreditPreapprovalCheckInput>>;
  create?: Maybe<Array<SynchronyEventCreateWithoutCareCreditPreapprovalCheckInput>>;
  createMany?: Maybe<SynchronyEventCreateManyCareCreditPreapprovalCheckInputEnvelope>;
  delete?: Maybe<Array<SynchronyEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SynchronyEventScalarWhereInput>>;
  disconnect?: Maybe<Array<SynchronyEventWhereUniqueInput>>;
  set?: Maybe<Array<SynchronyEventWhereUniqueInput>>;
  update?: Maybe<Array<SynchronyEventUpdateWithWhereUniqueWithoutCareCreditPreapprovalCheckInput>>;
  updateMany?: Maybe<Array<SynchronyEventUpdateManyWithWhereWithoutCareCreditPreapprovalCheckInput>>;
  upsert?: Maybe<Array<SynchronyEventUpsertWithWhereUniqueWithoutCareCreditPreapprovalCheckInput>>;
};

export type SynchronyEventUncheckedUpdateWithoutCareCreditPreapprovalCheckInput = {
  body?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<SynchronyEventType>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  status?: Maybe<SynchronyEventStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventUpdateInput = {
  body?: Maybe<Scalars['Json']>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckUpdateOneWithoutEventsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<SynchronyEventType>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  status?: Maybe<SynchronyEventStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventUpdateManyMutationInput = {
  body?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<SynchronyEventType>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  status?: Maybe<SynchronyEventStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventUpdateManyWithWhereWithoutCareCreditPreapprovalCheckInput = {
  data: SynchronyEventUpdateManyMutationInput;
  where: SynchronyEventScalarWhereInput;
};

export type SynchronyEventUpdateManyWithoutCareCreditPreapprovalCheckNestedInput = {
  connect?: Maybe<Array<SynchronyEventWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SynchronyEventCreateOrConnectWithoutCareCreditPreapprovalCheckInput>>;
  create?: Maybe<Array<SynchronyEventCreateWithoutCareCreditPreapprovalCheckInput>>;
  createMany?: Maybe<SynchronyEventCreateManyCareCreditPreapprovalCheckInputEnvelope>;
  delete?: Maybe<Array<SynchronyEventWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SynchronyEventScalarWhereInput>>;
  disconnect?: Maybe<Array<SynchronyEventWhereUniqueInput>>;
  set?: Maybe<Array<SynchronyEventWhereUniqueInput>>;
  update?: Maybe<Array<SynchronyEventUpdateWithWhereUniqueWithoutCareCreditPreapprovalCheckInput>>;
  updateMany?: Maybe<Array<SynchronyEventUpdateManyWithWhereWithoutCareCreditPreapprovalCheckInput>>;
  upsert?: Maybe<Array<SynchronyEventUpsertWithWhereUniqueWithoutCareCreditPreapprovalCheckInput>>;
};

export type SynchronyEventUpdateWithWhereUniqueWithoutCareCreditPreapprovalCheckInput = {
  data: SynchronyEventUpdateWithoutCareCreditPreapprovalCheckInput;
  where: SynchronyEventWhereUniqueInput;
};

export type SynchronyEventUpdateWithoutCareCreditPreapprovalCheckInput = {
  body?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<SynchronyEventType>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<Scalars['String']>;
  referenceExternalId?: Maybe<Scalars['String']>;
  status?: Maybe<SynchronyEventStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SynchronyEventUpsertWithWhereUniqueWithoutCareCreditPreapprovalCheckInput = {
  create: SynchronyEventCreateWithoutCareCreditPreapprovalCheckInput;
  update: SynchronyEventUpdateWithoutCareCreditPreapprovalCheckInput;
  where: SynchronyEventWhereUniqueInput;
};

export type SynchronyEventWhereInput = {
  AND?: Maybe<Array<SynchronyEventWhereInput>>;
  NOT?: Maybe<Array<SynchronyEventWhereInput>>;
  OR?: Maybe<Array<SynchronyEventWhereInput>>;
  body?: Maybe<JsonFilter>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckNullableScalarRelationFilter>;
  careCreditPreapprovalCheckId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  eventType?: Maybe<EnumSynchronyEventTypeFilter>;
  id?: Maybe<StringFilter>;
  merchantNumber?: Maybe<StringFilter>;
  referenceExternalId?: Maybe<StringFilter>;
  status?: Maybe<EnumSynchronyEventStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SynchronyEventWhereUniqueInput = {
  AND?: Maybe<Array<SynchronyEventWhereInput>>;
  NOT?: Maybe<Array<SynchronyEventWhereInput>>;
  OR?: Maybe<Array<SynchronyEventWhereInput>>;
  body?: Maybe<JsonFilter>;
  careCreditPreapprovalCheck?: Maybe<CareCreditPreapprovalCheckNullableScalarRelationFilter>;
  careCreditPreapprovalCheckId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  eventType?: Maybe<EnumSynchronyEventTypeFilter>;
  id?: Maybe<Scalars['String']>;
  merchantNumber?: Maybe<StringFilter>;
  referenceExternalId?: Maybe<StringFilter>;
  status?: Maybe<EnumSynchronyEventStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SystemMessageCreateInput = {
  attributes?: Maybe<Scalars['Json']>;
  body?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  messageType?: Maybe<MessageType>;
  petParentIds?: Maybe<Array<Scalars['String']>>;
};

export type TagEntity = {
  id: Scalars['String'];
  label: Scalars['String'];
  type: TagEntityType;
};

export enum TagEntityType {
  ClinicPet = 'ClinicPet',
  FormSubmission = 'FormSubmission'
}

export type TagInput = {
  colorBackground?: Maybe<Scalars['String']>;
  colorText?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tagEntities?: Maybe<Array<TagEntity>>;
  tagType?: Maybe<TagType>;
};

export enum TagType {
  CareCandidate = 'CareCandidate',
  CareCreditCandidate = 'CareCreditCandidate',
  Custom = 'Custom',
  FormRequested = 'FormRequested',
  FormSubmitted = 'FormSubmitted',
  HillsDietIssue = 'HillsDietIssue',
  HillsIdPurchaseRequest = 'HillsIDPurchaseRequest',
  PaymentReceived = 'PaymentReceived',
  PaymentRequested = 'PaymentRequested',
  SwitchingVets = 'SwitchingVets',
  TrupanionCandidate = 'TrupanionCandidate'
}

export type Task = {
  __typename?: 'Task';
  _count: TaskCountOutputType;
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  assignees: Array<User>;
  automationRun?: Maybe<AutomationRun>;
  automationRunId?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPetParent?: Maybe<ClinicPetParent>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  paymentIntent?: Maybe<StripePaymentIntent>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt: Scalars['DateTime'];
  widgetRequest?: Maybe<ClinicWidgetRequest>;
  widgetRequestId?: Maybe<Scalars['String']>;
};


export type TaskAppointmentArgs = {
  where?: Maybe<AppointmentWhereInput>;
};


export type TaskAssigneesArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type TaskAutomationRunArgs = {
  where?: Maybe<AutomationRunWhereInput>;
};


export type TaskClinicPetParentArgs = {
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type TaskPaymentIntentArgs = {
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type TaskWidgetRequestArgs = {
  where?: Maybe<ClinicWidgetRequestWhereInput>;
};

export type TaskCountAggregateOutputType = {
  __typename?: 'TaskCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentId: Scalars['Int'];
  automationRunId: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinincPetParentId: Scalars['Int'];
  completedAt: Scalars['Int'];
  completedByUserId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  paymentIntentId: Scalars['Int'];
  repeatIntervalDefinition: Scalars['Int'];
  status: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  widgetRequestId: Scalars['Int'];
};

export type TaskCountOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinincPetParentId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  paymentIntentId?: Maybe<SortOrder>;
  repeatIntervalDefinition?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  widgetRequestId?: Maybe<SortOrder>;
};

export type TaskCountOutputType = {
  __typename?: 'TaskCountOutputType';
  assignees: Scalars['Int'];
};

export type TaskCreateInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutTasksInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutTasksInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutTasksInput>;
  clinic: ClinicCreateNestedOneWithoutTasksInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutTasksInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutTasksInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutTasksInput>;
};

export type TaskCreateManyAppointmentInput = {
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskCreateManyAppointmentInputEnvelope = {
  data: Array<TaskCreateManyAppointmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TaskCreateManyAutomationRunInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskCreateManyAutomationRunInputEnvelope = {
  data: Array<TaskCreateManyAutomationRunInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TaskCreateManyClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskCreateManyClinicInputEnvelope = {
  data: Array<TaskCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TaskCreateManyClinicPetParentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskCreateManyClinicPetParentInputEnvelope = {
  data: Array<TaskCreateManyClinicPetParentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TaskCreateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskCreateManyPaymentIntentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskCreateManyPaymentIntentInputEnvelope = {
  data: Array<TaskCreateManyPaymentIntentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TaskCreateManyWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskCreateManyWidgetRequestInputEnvelope = {
  data: Array<TaskCreateManyWidgetRequestInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TaskCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<TaskCreateWithoutAppointmentInput>>;
  createMany?: Maybe<TaskCreateManyAppointmentInputEnvelope>;
};

export type TaskCreateNestedManyWithoutAssigneesInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<TaskCreateWithoutAssigneesInput>>;
};

export type TaskCreateNestedManyWithoutAutomationRunInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<TaskCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<TaskCreateManyAutomationRunInputEnvelope>;
};

export type TaskCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<TaskCreateWithoutClinicInput>>;
  createMany?: Maybe<TaskCreateManyClinicInputEnvelope>;
};

export type TaskCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<TaskCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<TaskCreateManyClinicPetParentInputEnvelope>;
};

export type TaskCreateNestedManyWithoutPaymentIntentInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutPaymentIntentInput>>;
  create?: Maybe<Array<TaskCreateWithoutPaymentIntentInput>>;
  createMany?: Maybe<TaskCreateManyPaymentIntentInputEnvelope>;
};

export type TaskCreateNestedManyWithoutWidgetRequestInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutWidgetRequestInput>>;
  create?: Maybe<Array<TaskCreateWithoutWidgetRequestInput>>;
  createMany?: Maybe<TaskCreateManyWidgetRequestInputEnvelope>;
};

export type TaskCreateOrConnectWithoutAppointmentInput = {
  create: TaskCreateWithoutAppointmentInput;
  where: TaskWhereUniqueInput;
};

export type TaskCreateOrConnectWithoutAssigneesInput = {
  create: TaskCreateWithoutAssigneesInput;
  where: TaskWhereUniqueInput;
};

export type TaskCreateOrConnectWithoutAutomationRunInput = {
  create: TaskCreateWithoutAutomationRunInput;
  where: TaskWhereUniqueInput;
};

export type TaskCreateOrConnectWithoutClinicInput = {
  create: TaskCreateWithoutClinicInput;
  where: TaskWhereUniqueInput;
};

export type TaskCreateOrConnectWithoutClinicPetParentInput = {
  create: TaskCreateWithoutClinicPetParentInput;
  where: TaskWhereUniqueInput;
};

export type TaskCreateOrConnectWithoutPaymentIntentInput = {
  create: TaskCreateWithoutPaymentIntentInput;
  where: TaskWhereUniqueInput;
};

export type TaskCreateOrConnectWithoutWidgetRequestInput = {
  create: TaskCreateWithoutWidgetRequestInput;
  where: TaskWhereUniqueInput;
};

export type TaskCreateWithoutAppointmentInput = {
  assignees?: Maybe<UserCreateNestedManyWithoutTasksInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutTasksInput>;
  clinic: ClinicCreateNestedOneWithoutTasksInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutTasksInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutTasksInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutTasksInput>;
};

export type TaskCreateWithoutAssigneesInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutTasksInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutTasksInput>;
  clinic: ClinicCreateNestedOneWithoutTasksInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutTasksInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutTasksInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutTasksInput>;
};

export type TaskCreateWithoutAutomationRunInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutTasksInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutTasksInput>;
  clinic: ClinicCreateNestedOneWithoutTasksInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutTasksInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutTasksInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutTasksInput>;
};

export type TaskCreateWithoutClinicInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutTasksInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutTasksInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutTasksInput>;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutTasksInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutTasksInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutTasksInput>;
};

export type TaskCreateWithoutClinicPetParentInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutTasksInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutTasksInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutTasksInput>;
  clinic: ClinicCreateNestedOneWithoutTasksInput;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutTasksInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutTasksInput>;
};

export type TaskCreateWithoutPaymentIntentInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutTasksInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutTasksInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutTasksInput>;
  clinic: ClinicCreateNestedOneWithoutTasksInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutTasksInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestCreateNestedOneWithoutTasksInput>;
};

export type TaskCreateWithoutWidgetRequestInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutTasksInput>;
  assignees?: Maybe<UserCreateNestedManyWithoutTasksInput>;
  automationRun?: Maybe<AutomationRunCreateNestedOneWithoutTasksInput>;
  clinic: ClinicCreateNestedOneWithoutTasksInput;
  clinicPetParent?: Maybe<ClinicPetParentCreateNestedOneWithoutTasksInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntent?: Maybe<StripePaymentIntentCreateNestedOneWithoutTasksInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskGroupByOutputType = {
  __typename?: 'TaskGroupByOutputType';
  _count?: Maybe<TaskCountAggregateOutputType>;
  _max?: Maybe<TaskMaxAggregateOutputType>;
  _min?: Maybe<TaskMinAggregateOutputType>;
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt: Scalars['DateTime'];
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskListRelationFilter = {
  every?: Maybe<TaskWhereInput>;
  none?: Maybe<TaskWhereInput>;
  some?: Maybe<TaskWhereInput>;
};

export type TaskMaxAggregateOutputType = {
  __typename?: 'TaskMaxAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskMaxOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinincPetParentId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  paymentIntentId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  widgetRequestId?: Maybe<SortOrder>;
};

export type TaskMinAggregateOutputType = {
  __typename?: 'TaskMinAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskMinOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinincPetParentId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  paymentIntentId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  widgetRequestId?: Maybe<SortOrder>;
};

export type TaskOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type TaskOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TaskOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  assignees?: Maybe<UserOrderByRelationAggregateInput>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinincPetParentId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  paymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  paymentIntentId?: Maybe<SortOrder>;
  repeatIntervalDefinition?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  widgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  widgetRequestId?: Maybe<SortOrder>;
};

export enum TaskOrderByRelevanceFieldEnum {
  AppointmentId = 'appointmentId',
  AutomationRunId = 'automationRunId',
  ClinicId = 'clinicId',
  ClinincPetParentId = 'clinincPetParentId',
  CompletedByUserId = 'completedByUserId',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  PaymentIntentId = 'paymentIntentId',
  WidgetRequestId = 'widgetRequestId'
}

export type TaskOrderByRelevanceInput = {
  fields: Array<TaskOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type TaskOrderByWithAggregationInput = {
  _count?: Maybe<TaskCountOrderByAggregateInput>;
  _max?: Maybe<TaskMaxOrderByAggregateInput>;
  _min?: Maybe<TaskMinOrderByAggregateInput>;
  appointmentId?: Maybe<SortOrder>;
  automationRunId?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinincPetParentId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  paymentIntentId?: Maybe<SortOrder>;
  repeatIntervalDefinition?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  widgetRequestId?: Maybe<SortOrder>;
};

export type TaskOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TaskOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  assignees?: Maybe<UserOrderByRelationAggregateInput>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinincPetParentId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  paymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  paymentIntentId?: Maybe<SortOrder>;
  repeatIntervalDefinition?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  widgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  widgetRequestId?: Maybe<SortOrder>;
};

export type TaskOrderByWithRelationInput = {
  _relevance?: Maybe<TaskOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  assignees?: Maybe<UserOrderByRelationAggregateInput>;
  automationRun?: Maybe<AutomationRunOrderByWithRelationInput>;
  automationRunId?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPetParent?: Maybe<ClinicPetParentOrderByWithRelationInput>;
  clinincPetParentId?: Maybe<SortOrder>;
  completedAt?: Maybe<SortOrder>;
  completedByUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  paymentIntent?: Maybe<StripePaymentIntentOrderByWithRelationInput>;
  paymentIntentId?: Maybe<SortOrder>;
  repeatIntervalDefinition?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  widgetRequest?: Maybe<ClinicWidgetRequestOrderByWithRelationInput>;
  widgetRequestId?: Maybe<SortOrder>;
};

export enum TaskScalarFieldEnum {
  AppointmentId = 'appointmentId',
  AutomationRunId = 'automationRunId',
  ClinicId = 'clinicId',
  ClinincPetParentId = 'clinincPetParentId',
  CompletedAt = 'completedAt',
  CompletedByUserId = 'completedByUserId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  PaymentIntentId = 'paymentIntentId',
  RepeatIntervalDefinition = 'repeatIntervalDefinition',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  WidgetRequestId = 'widgetRequestId'
}

export type TaskScalarWhereInput = {
  AND?: Maybe<Array<TaskScalarWhereInput>>;
  NOT?: Maybe<Array<TaskScalarWhereInput>>;
  OR?: Maybe<Array<TaskScalarWhereInput>>;
  appointmentId?: Maybe<StringNullableFilter>;
  automationRunId?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  clinincPetParentId?: Maybe<StringNullableFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  completedByUserId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  paymentIntentId?: Maybe<StringNullableFilter>;
  repeatIntervalDefinition?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumTaskStatusFilter>;
  type?: Maybe<EnumTaskTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  widgetRequestId?: Maybe<StringNullableFilter>;
};

export type TaskScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TaskScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TaskScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TaskScalarWhereWithAggregatesInput>>;
  appointmentId?: Maybe<StringNullableWithAggregatesFilter>;
  automationRunId?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  clinincPetParentId?: Maybe<StringNullableWithAggregatesFilter>;
  completedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  completedByUserId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  paymentIntentId?: Maybe<StringNullableWithAggregatesFilter>;
  repeatIntervalDefinition?: Maybe<JsonNullableWithAggregatesFilter>;
  status?: Maybe<EnumTaskStatusWithAggregatesFilter>;
  type?: Maybe<EnumTaskTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  widgetRequestId?: Maybe<StringNullableWithAggregatesFilter>;
};

export enum TaskStatus {
  Canceled = 'Canceled',
  Completed = 'Completed',
  InProgress = 'InProgress',
  Open = 'Open'
}

export type TaskSubscription = {
  __typename?: 'TaskSubscription';
  mutation: MutationType;
  node: Task;
};

export enum TaskType {
  Automation = 'Automation',
  Custom = 'Custom',
  DirectBookingWritebackFailure = 'DirectBookingWritebackFailure',
  Form = 'Form',
  PaymentWritebackFailure = 'PaymentWritebackFailure',
  WidgetRequest = 'WidgetRequest'
}

export type TaskUncheckedCreateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutTasksInput>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<TaskCreateWithoutAppointmentInput>>;
  createMany?: Maybe<TaskCreateManyAppointmentInputEnvelope>;
};

export type TaskUncheckedCreateNestedManyWithoutAssigneesInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<TaskCreateWithoutAssigneesInput>>;
};

export type TaskUncheckedCreateNestedManyWithoutAutomationRunInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<TaskCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<TaskCreateManyAutomationRunInputEnvelope>;
};

export type TaskUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<TaskCreateWithoutClinicInput>>;
  createMany?: Maybe<TaskCreateManyClinicInputEnvelope>;
};

export type TaskUncheckedCreateNestedManyWithoutClinicPetParentInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<TaskCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<TaskCreateManyClinicPetParentInputEnvelope>;
};

export type TaskUncheckedCreateNestedManyWithoutPaymentIntentInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutPaymentIntentInput>>;
  create?: Maybe<Array<TaskCreateWithoutPaymentIntentInput>>;
  createMany?: Maybe<TaskCreateManyPaymentIntentInputEnvelope>;
};

export type TaskUncheckedCreateNestedManyWithoutWidgetRequestInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutWidgetRequestInput>>;
  create?: Maybe<Array<TaskCreateWithoutWidgetRequestInput>>;
  createMany?: Maybe<TaskCreateManyWidgetRequestInputEnvelope>;
};

export type TaskUncheckedCreateWithoutAppointmentInput = {
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutTasksInput>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedCreateWithoutAssigneesInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedCreateWithoutAutomationRunInput = {
  appointmentId?: Maybe<Scalars['String']>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutTasksInput>;
  clinicId: Scalars['String'];
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedCreateWithoutClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutTasksInput>;
  automationRunId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedCreateWithoutClinicPetParentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutTasksInput>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedCreateWithoutPaymentIntentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutTasksInput>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedCreateWithoutWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  assignees?: Maybe<UserUncheckedCreateNestedManyWithoutTasksInput>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskUncheckedUpdateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutTasksNestedInput>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateManyWithoutAppointmentInput = {
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<TaskCreateWithoutAppointmentInput>>;
  createMany?: Maybe<TaskCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type TaskUncheckedUpdateManyWithoutAssigneesInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateManyWithoutAssigneesNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<TaskCreateWithoutAssigneesInput>>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutAssigneesInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutAssigneesInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutAssigneesInput>>;
};

export type TaskUncheckedUpdateManyWithoutAutomationRunInput = {
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateManyWithoutAutomationRunNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<TaskCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<TaskCreateManyAutomationRunInputEnvelope>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutAutomationRunInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutAutomationRunInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutAutomationRunInput>>;
};

export type TaskUncheckedUpdateManyWithoutClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<TaskCreateWithoutClinicInput>>;
  createMany?: Maybe<TaskCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type TaskUncheckedUpdateManyWithoutClinicPetParentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<TaskCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<TaskCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type TaskUncheckedUpdateManyWithoutPaymentIntentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateManyWithoutPaymentIntentNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutPaymentIntentInput>>;
  create?: Maybe<Array<TaskCreateWithoutPaymentIntentInput>>;
  createMany?: Maybe<TaskCreateManyPaymentIntentInputEnvelope>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutPaymentIntentInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutPaymentIntentInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutPaymentIntentInput>>;
};

export type TaskUncheckedUpdateManyWithoutWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskUncheckedUpdateManyWithoutWidgetRequestNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutWidgetRequestInput>>;
  create?: Maybe<Array<TaskCreateWithoutWidgetRequestInput>>;
  createMany?: Maybe<TaskCreateManyWidgetRequestInputEnvelope>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutWidgetRequestInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutWidgetRequestInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutWidgetRequestInput>>;
};

export type TaskUncheckedUpdateWithoutAppointmentInput = {
  assignees?: Maybe<UserUncheckedUpdateManyWithoutTasksNestedInput>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateWithoutAssigneesInput = {
  appointmentId?: Maybe<Scalars['String']>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateWithoutAutomationRunInput = {
  appointmentId?: Maybe<Scalars['String']>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutTasksNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateWithoutClinicInput = {
  appointmentId?: Maybe<Scalars['String']>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutTasksNestedInput>;
  automationRunId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateWithoutClinicPetParentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutTasksNestedInput>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateWithoutPaymentIntentInput = {
  appointmentId?: Maybe<Scalars['String']>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutTasksNestedInput>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequestId?: Maybe<Scalars['String']>;
};

export type TaskUncheckedUpdateWithoutWidgetRequestInput = {
  appointmentId?: Maybe<Scalars['String']>;
  assignees?: Maybe<UserUncheckedUpdateManyWithoutTasksNestedInput>;
  automationRunId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  clinincPetParentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskUpdateInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutTasksNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutTasksNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutTasksNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutTasksNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutTasksNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutTasksNestedInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutTasksNestedInput>;
};

export type TaskUpdateManyMutationInput = {
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskUpdateManyWithWhereWithoutAppointmentInput = {
  data: TaskUpdateManyMutationInput;
  where: TaskScalarWhereInput;
};

export type TaskUpdateManyWithWhereWithoutAssigneesInput = {
  data: TaskUpdateManyMutationInput;
  where: TaskScalarWhereInput;
};

export type TaskUpdateManyWithWhereWithoutAutomationRunInput = {
  data: TaskUpdateManyMutationInput;
  where: TaskScalarWhereInput;
};

export type TaskUpdateManyWithWhereWithoutClinicInput = {
  data: TaskUpdateManyMutationInput;
  where: TaskScalarWhereInput;
};

export type TaskUpdateManyWithWhereWithoutClinicPetParentInput = {
  data: TaskUpdateManyMutationInput;
  where: TaskScalarWhereInput;
};

export type TaskUpdateManyWithWhereWithoutPaymentIntentInput = {
  data: TaskUpdateManyMutationInput;
  where: TaskScalarWhereInput;
};

export type TaskUpdateManyWithWhereWithoutWidgetRequestInput = {
  data: TaskUpdateManyMutationInput;
  where: TaskScalarWhereInput;
};

export type TaskUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<TaskCreateWithoutAppointmentInput>>;
  createMany?: Maybe<TaskCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type TaskUpdateManyWithoutAssigneesNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutAssigneesInput>>;
  create?: Maybe<Array<TaskCreateWithoutAssigneesInput>>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutAssigneesInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutAssigneesInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutAssigneesInput>>;
};

export type TaskUpdateManyWithoutAutomationRunNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutAutomationRunInput>>;
  create?: Maybe<Array<TaskCreateWithoutAutomationRunInput>>;
  createMany?: Maybe<TaskCreateManyAutomationRunInputEnvelope>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutAutomationRunInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutAutomationRunInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutAutomationRunInput>>;
};

export type TaskUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<TaskCreateWithoutClinicInput>>;
  createMany?: Maybe<TaskCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type TaskUpdateManyWithoutClinicPetParentNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutClinicPetParentInput>>;
  create?: Maybe<Array<TaskCreateWithoutClinicPetParentInput>>;
  createMany?: Maybe<TaskCreateManyClinicPetParentInputEnvelope>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutClinicPetParentInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutClinicPetParentInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutClinicPetParentInput>>;
};

export type TaskUpdateManyWithoutPaymentIntentNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutPaymentIntentInput>>;
  create?: Maybe<Array<TaskCreateWithoutPaymentIntentInput>>;
  createMany?: Maybe<TaskCreateManyPaymentIntentInputEnvelope>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutPaymentIntentInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutPaymentIntentInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutPaymentIntentInput>>;
};

export type TaskUpdateManyWithoutWidgetRequestNestedInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaskCreateOrConnectWithoutWidgetRequestInput>>;
  create?: Maybe<Array<TaskCreateWithoutWidgetRequestInput>>;
  createMany?: Maybe<TaskCreateManyWidgetRequestInputEnvelope>;
  delete?: Maybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaskScalarWhereInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
  update?: Maybe<Array<TaskUpdateWithWhereUniqueWithoutWidgetRequestInput>>;
  updateMany?: Maybe<Array<TaskUpdateManyWithWhereWithoutWidgetRequestInput>>;
  upsert?: Maybe<Array<TaskUpsertWithWhereUniqueWithoutWidgetRequestInput>>;
};

export type TaskUpdateWithWhereUniqueWithoutAppointmentInput = {
  data: TaskUpdateWithoutAppointmentInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpdateWithWhereUniqueWithoutAssigneesInput = {
  data: TaskUpdateWithoutAssigneesInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpdateWithWhereUniqueWithoutAutomationRunInput = {
  data: TaskUpdateWithoutAutomationRunInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpdateWithWhereUniqueWithoutClinicInput = {
  data: TaskUpdateWithoutClinicInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpdateWithWhereUniqueWithoutClinicPetParentInput = {
  data: TaskUpdateWithoutClinicPetParentInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpdateWithWhereUniqueWithoutPaymentIntentInput = {
  data: TaskUpdateWithoutPaymentIntentInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpdateWithWhereUniqueWithoutWidgetRequestInput = {
  data: TaskUpdateWithoutWidgetRequestInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpdateWithoutAppointmentInput = {
  assignees?: Maybe<UserUpdateManyWithoutTasksNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutTasksNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutTasksNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutTasksNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutTasksNestedInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutTasksNestedInput>;
};

export type TaskUpdateWithoutAssigneesInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutTasksNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutTasksNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutTasksNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutTasksNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutTasksNestedInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutTasksNestedInput>;
};

export type TaskUpdateWithoutAutomationRunInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutTasksNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutTasksNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutTasksNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutTasksNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutTasksNestedInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutTasksNestedInput>;
};

export type TaskUpdateWithoutClinicInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutTasksNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutTasksNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutTasksNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutTasksNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutTasksNestedInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutTasksNestedInput>;
};

export type TaskUpdateWithoutClinicPetParentInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutTasksNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutTasksNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutTasksNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutTasksNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutTasksNestedInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutTasksNestedInput>;
};

export type TaskUpdateWithoutPaymentIntentInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutTasksNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutTasksNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutTasksNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutTasksNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutTasksNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  widgetRequest?: Maybe<ClinicWidgetRequestUpdateOneWithoutTasksNestedInput>;
};

export type TaskUpdateWithoutWidgetRequestInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutTasksNestedInput>;
  assignees?: Maybe<UserUpdateManyWithoutTasksNestedInput>;
  automationRun?: Maybe<AutomationRunUpdateOneWithoutTasksNestedInput>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutTasksNestedInput>;
  clinicPetParent?: Maybe<ClinicPetParentUpdateOneWithoutTasksNestedInput>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentIntent?: Maybe<StripePaymentIntentUpdateOneWithoutTasksNestedInput>;
  repeatIntervalDefinition?: Maybe<Scalars['Json']>;
  status?: Maybe<TaskStatus>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskUpsertWithWhereUniqueWithoutAppointmentInput = {
  create: TaskCreateWithoutAppointmentInput;
  update: TaskUpdateWithoutAppointmentInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpsertWithWhereUniqueWithoutAssigneesInput = {
  create: TaskCreateWithoutAssigneesInput;
  update: TaskUpdateWithoutAssigneesInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpsertWithWhereUniqueWithoutAutomationRunInput = {
  create: TaskCreateWithoutAutomationRunInput;
  update: TaskUpdateWithoutAutomationRunInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpsertWithWhereUniqueWithoutClinicInput = {
  create: TaskCreateWithoutClinicInput;
  update: TaskUpdateWithoutClinicInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpsertWithWhereUniqueWithoutClinicPetParentInput = {
  create: TaskCreateWithoutClinicPetParentInput;
  update: TaskUpdateWithoutClinicPetParentInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpsertWithWhereUniqueWithoutPaymentIntentInput = {
  create: TaskCreateWithoutPaymentIntentInput;
  update: TaskUpdateWithoutPaymentIntentInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpsertWithWhereUniqueWithoutWidgetRequestInput = {
  create: TaskCreateWithoutWidgetRequestInput;
  update: TaskUpdateWithoutWidgetRequestInput;
  where: TaskWhereUniqueInput;
};

export type TaskWhereInput = {
  AND?: Maybe<Array<TaskWhereInput>>;
  NOT?: Maybe<Array<TaskWhereInput>>;
  OR?: Maybe<Array<TaskWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  assignees?: Maybe<UserListRelationFilter>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  automationRunId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinincPetParentId?: Maybe<StringNullableFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  completedByUserId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  paymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  paymentIntentId?: Maybe<StringNullableFilter>;
  repeatIntervalDefinition?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumTaskStatusFilter>;
  type?: Maybe<EnumTaskTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  widgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  widgetRequestId?: Maybe<StringNullableFilter>;
};

export type TaskWhereUniqueInput = {
  AND?: Maybe<Array<TaskWhereInput>>;
  NOT?: Maybe<Array<TaskWhereInput>>;
  OR?: Maybe<Array<TaskWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  assignees?: Maybe<UserListRelationFilter>;
  automationRun?: Maybe<AutomationRunNullableScalarRelationFilter>;
  automationRunId?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetParent?: Maybe<ClinicPetParentNullableScalarRelationFilter>;
  clinincPetParentId?: Maybe<StringNullableFilter>;
  completedAt?: Maybe<DateTimeNullableFilter>;
  completedByUserId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<StringFilter>;
  paymentIntent?: Maybe<StripePaymentIntentNullableScalarRelationFilter>;
  paymentIntentId?: Maybe<StringNullableFilter>;
  repeatIntervalDefinition?: Maybe<JsonNullableFilter>;
  status?: Maybe<EnumTaskStatusFilter>;
  type?: Maybe<EnumTaskTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  widgetRequest?: Maybe<ClinicWidgetRequestNullableScalarRelationFilter>;
  widgetRequestId?: Maybe<StringNullableFilter>;
};

export type Taxonomy = {
  __typename?: 'Taxonomy';
  _count: TaxonomyCountOutputType;
  appointmentTypes: Array<AppointmentType>;
  appointments: Array<Appointment>;
  bedrockInferences: Array<BedrockInference>;
  createdAt: Scalars['DateTime'];
  entity: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  service: Array<Service>;
  taxonomyToInformAudienceDefinition: Array<TaxonomyToInformAudienceDefinition>;
  updatedAt: Scalars['DateTime'];
};


export type TaxonomyAppointmentTypesArgs = {
  cursor?: Maybe<AppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type TaxonomyAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type TaxonomyBedrockInferencesArgs = {
  cursor?: Maybe<BedrockInferenceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BedrockInferenceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BedrockInferenceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BedrockInferenceWhereInput>;
};


export type TaxonomyServiceArgs = {
  cursor?: Maybe<ServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceWhereInput>;
};


export type TaxonomyTaxonomyToInformAudienceDefinitionArgs = {
  cursor?: Maybe<TaxonomyToInformAudienceDefinitionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaxonomyToInformAudienceDefinitionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaxonomyToInformAudienceDefinitionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaxonomyToInformAudienceDefinitionWhereInput>;
};

export type TaxonomyCountAggregateOutputType = {
  __typename?: 'TaxonomyCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  entity: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  parentId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type TaxonomyCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  entity?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TaxonomyCountOutputType = {
  __typename?: 'TaxonomyCountOutputType';
  appointmentTypes: Scalars['Int'];
  appointments: Scalars['Int'];
  bedrockInferences: Scalars['Int'];
  service: Scalars['Int'];
  taxonomyToInformAudienceDefinition: Scalars['Int'];
};

export type TaxonomyCreateInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutTaxonomyInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutTaxonomyInput>;
  bedrockInferences?: Maybe<BedrockInferenceCreateNestedManyWithoutTaxonomyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceCreateNestedManyWithoutTaxonomyInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutTaxonomyInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyCreateNestedOneWithoutAppointmentTypesInput = {
  connect?: Maybe<TaxonomyWhereUniqueInput>;
  connectOrCreate?: Maybe<TaxonomyCreateOrConnectWithoutAppointmentTypesInput>;
  create?: Maybe<TaxonomyCreateWithoutAppointmentTypesInput>;
};

export type TaxonomyCreateNestedOneWithoutAppointmentsInput = {
  connect?: Maybe<TaxonomyWhereUniqueInput>;
  connectOrCreate?: Maybe<TaxonomyCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<TaxonomyCreateWithoutAppointmentsInput>;
};

export type TaxonomyCreateNestedOneWithoutBedrockInferencesInput = {
  connect?: Maybe<TaxonomyWhereUniqueInput>;
  connectOrCreate?: Maybe<TaxonomyCreateOrConnectWithoutBedrockInferencesInput>;
  create?: Maybe<TaxonomyCreateWithoutBedrockInferencesInput>;
};

export type TaxonomyCreateNestedOneWithoutServiceInput = {
  connect?: Maybe<TaxonomyWhereUniqueInput>;
  connectOrCreate?: Maybe<TaxonomyCreateOrConnectWithoutServiceInput>;
  create?: Maybe<TaxonomyCreateWithoutServiceInput>;
};

export type TaxonomyCreateNestedOneWithoutTaxonomyToInformAudienceDefinitionInput = {
  connect?: Maybe<TaxonomyWhereUniqueInput>;
  connectOrCreate?: Maybe<TaxonomyCreateOrConnectWithoutTaxonomyToInformAudienceDefinitionInput>;
  create?: Maybe<TaxonomyCreateWithoutTaxonomyToInformAudienceDefinitionInput>;
};

export type TaxonomyCreateOrConnectWithoutAppointmentTypesInput = {
  create: TaxonomyCreateWithoutAppointmentTypesInput;
  where: TaxonomyWhereUniqueInput;
};

export type TaxonomyCreateOrConnectWithoutAppointmentsInput = {
  create: TaxonomyCreateWithoutAppointmentsInput;
  where: TaxonomyWhereUniqueInput;
};

export type TaxonomyCreateOrConnectWithoutBedrockInferencesInput = {
  create: TaxonomyCreateWithoutBedrockInferencesInput;
  where: TaxonomyWhereUniqueInput;
};

export type TaxonomyCreateOrConnectWithoutServiceInput = {
  create: TaxonomyCreateWithoutServiceInput;
  where: TaxonomyWhereUniqueInput;
};

export type TaxonomyCreateOrConnectWithoutTaxonomyToInformAudienceDefinitionInput = {
  create: TaxonomyCreateWithoutTaxonomyToInformAudienceDefinitionInput;
  where: TaxonomyWhereUniqueInput;
};

export type TaxonomyCreateWithoutAppointmentTypesInput = {
  appointments?: Maybe<AppointmentCreateNestedManyWithoutTaxonomyInput>;
  bedrockInferences?: Maybe<BedrockInferenceCreateNestedManyWithoutTaxonomyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceCreateNestedManyWithoutTaxonomyInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutTaxonomyInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyCreateWithoutAppointmentsInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutTaxonomyInput>;
  bedrockInferences?: Maybe<BedrockInferenceCreateNestedManyWithoutTaxonomyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceCreateNestedManyWithoutTaxonomyInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutTaxonomyInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyCreateWithoutBedrockInferencesInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutTaxonomyInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutTaxonomyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceCreateNestedManyWithoutTaxonomyInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutTaxonomyInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyCreateWithoutServiceInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutTaxonomyInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutTaxonomyInput>;
  bedrockInferences?: Maybe<BedrockInferenceCreateNestedManyWithoutTaxonomyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutTaxonomyInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyCreateWithoutTaxonomyToInformAudienceDefinitionInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutTaxonomyInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutTaxonomyInput>;
  bedrockInferences?: Maybe<BedrockInferenceCreateNestedManyWithoutTaxonomyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceCreateNestedManyWithoutTaxonomyInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyGroupByOutputType = {
  __typename?: 'TaxonomyGroupByOutputType';
  _count?: Maybe<TaxonomyCountAggregateOutputType>;
  _max?: Maybe<TaxonomyMaxAggregateOutputType>;
  _min?: Maybe<TaxonomyMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  entity: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type TaxonomyMaxAggregateOutputType = {
  __typename?: 'TaxonomyMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  entity?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TaxonomyMinAggregateOutputType = {
  __typename?: 'TaxonomyMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  entity?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TaxonomyNameEntityCompoundUniqueInput = {
  entity: Scalars['String'];
  name: Scalars['String'];
};

export type TaxonomyNullableScalarRelationFilter = {
  AND?: Maybe<Array<TaxonomyWhereInput>>;
  NOT?: Maybe<Array<TaxonomyWhereInput>>;
  OR?: Maybe<Array<TaxonomyWhereInput>>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  bedrockInferences?: Maybe<BedrockInferenceListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entity?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  parentId?: Maybe<StringNullableFilter>;
  service?: Maybe<ServiceListRelationFilter>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TaxonomyOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TaxonomyOrderByRelevanceInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  bedrockInferences?: Maybe<BedrockInferenceOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  entity?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentId?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByRelationAggregateInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TaxonomyOrderByRelevanceFieldEnum {
  Entity = 'entity',
  Id = 'id',
  Name = 'name',
  ParentId = 'parentId'
}

export type TaxonomyOrderByRelevanceInput = {
  fields: Array<TaxonomyOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type TaxonomyOrderByWithAggregationInput = {
  _count?: Maybe<TaxonomyCountOrderByAggregateInput>;
  _max?: Maybe<TaxonomyMaxOrderByAggregateInput>;
  _min?: Maybe<TaxonomyMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  entity?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TaxonomyOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TaxonomyOrderByRelevanceInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  bedrockInferences?: Maybe<BedrockInferenceOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  entity?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentId?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByRelationAggregateInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type TaxonomyOrderByWithRelationInput = {
  _relevance?: Maybe<TaxonomyOrderByRelevanceInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  bedrockInferences?: Maybe<BedrockInferenceOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  entity?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentId?: Maybe<SortOrder>;
  service?: Maybe<ServiceOrderByRelationAggregateInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TaxonomyScalarFieldEnum {
  CreatedAt = 'createdAt',
  Entity = 'entity',
  Id = 'id',
  Name = 'name',
  ParentId = 'parentId',
  UpdatedAt = 'updatedAt'
}

export type TaxonomyScalarRelationFilter = {
  AND?: Maybe<Array<TaxonomyWhereInput>>;
  NOT?: Maybe<Array<TaxonomyWhereInput>>;
  OR?: Maybe<Array<TaxonomyWhereInput>>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  bedrockInferences?: Maybe<BedrockInferenceListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entity?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  parentId?: Maybe<StringNullableFilter>;
  service?: Maybe<ServiceListRelationFilter>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TaxonomyScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TaxonomyScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TaxonomyScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TaxonomyScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  entity?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  parentId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type TaxonomyToInformAudienceDefinition = {
  __typename?: 'TaxonomyToInformAudienceDefinition';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informAudienceDefinition: InformAudienceDefinition;
  informAudienceDefinitionId: Scalars['String'];
  taxonomy: Taxonomy;
  taxonomyId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TaxonomyToInformAudienceDefinitionCountAggregateOutputType = {
  __typename?: 'TaxonomyToInformAudienceDefinitionCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  informAudienceDefinitionId: Scalars['Int'];
  taxonomyId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type TaxonomyToInformAudienceDefinitionCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TaxonomyToInformAudienceDefinitionCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition: InformAudienceDefinitionCreateNestedOneWithoutTaxonomyToInformAudienceDefinitionInput;
  taxonomy: TaxonomyCreateNestedOneWithoutTaxonomyToInformAudienceDefinitionInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionCreateManyInformAudienceDefinitionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  taxonomyId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionCreateManyInformAudienceDefinitionInputEnvelope = {
  data: Array<TaxonomyToInformAudienceDefinitionCreateManyInformAudienceDefinitionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TaxonomyToInformAudienceDefinitionCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  taxonomyId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionCreateManyTaxonomyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionCreateManyTaxonomyInputEnvelope = {
  data: Array<TaxonomyToInformAudienceDefinitionCreateManyTaxonomyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutInformAudienceDefinitionInput = {
  connect?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateOrConnectWithoutInformAudienceDefinitionInput>>;
  create?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateWithoutInformAudienceDefinitionInput>>;
  createMany?: Maybe<TaxonomyToInformAudienceDefinitionCreateManyInformAudienceDefinitionInputEnvelope>;
};

export type TaxonomyToInformAudienceDefinitionCreateNestedManyWithoutTaxonomyInput = {
  connect?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<TaxonomyToInformAudienceDefinitionCreateManyTaxonomyInputEnvelope>;
};

export type TaxonomyToInformAudienceDefinitionCreateOrConnectWithoutInformAudienceDefinitionInput = {
  create: TaxonomyToInformAudienceDefinitionCreateWithoutInformAudienceDefinitionInput;
  where: TaxonomyToInformAudienceDefinitionWhereUniqueInput;
};

export type TaxonomyToInformAudienceDefinitionCreateOrConnectWithoutTaxonomyInput = {
  create: TaxonomyToInformAudienceDefinitionCreateWithoutTaxonomyInput;
  where: TaxonomyToInformAudienceDefinitionWhereUniqueInput;
};

export type TaxonomyToInformAudienceDefinitionCreateWithoutInformAudienceDefinitionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  taxonomy: TaxonomyCreateNestedOneWithoutTaxonomyToInformAudienceDefinitionInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionCreateWithoutTaxonomyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition: InformAudienceDefinitionCreateNestedOneWithoutTaxonomyToInformAudienceDefinitionInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionGroupByOutputType = {
  __typename?: 'TaxonomyToInformAudienceDefinitionGroupByOutputType';
  _count?: Maybe<TaxonomyToInformAudienceDefinitionCountAggregateOutputType>;
  _max?: Maybe<TaxonomyToInformAudienceDefinitionMaxAggregateOutputType>;
  _min?: Maybe<TaxonomyToInformAudienceDefinitionMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  informAudienceDefinitionId: Scalars['String'];
  taxonomyId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TaxonomyToInformAudienceDefinitionListRelationFilter = {
  every?: Maybe<TaxonomyToInformAudienceDefinitionWhereInput>;
  none?: Maybe<TaxonomyToInformAudienceDefinitionWhereInput>;
  some?: Maybe<TaxonomyToInformAudienceDefinitionWhereInput>;
};

export type TaxonomyToInformAudienceDefinitionMaxAggregateOutputType = {
  __typename?: 'TaxonomyToInformAudienceDefinitionMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TaxonomyToInformAudienceDefinitionMinAggregateOutputType = {
  __typename?: 'TaxonomyToInformAudienceDefinitionMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TaxonomyToInformAudienceDefinitionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type TaxonomyToInformAudienceDefinitionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TaxonomyToInformAudienceDefinitionOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionOrderByWithRelationInput>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TaxonomyToInformAudienceDefinitionOrderByRelevanceFieldEnum {
  Id = 'id',
  InformAudienceDefinitionId = 'informAudienceDefinitionId',
  TaxonomyId = 'taxonomyId'
}

export type TaxonomyToInformAudienceDefinitionOrderByRelevanceInput = {
  fields: Array<TaxonomyToInformAudienceDefinitionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type TaxonomyToInformAudienceDefinitionOrderByWithAggregationInput = {
  _count?: Maybe<TaxonomyToInformAudienceDefinitionCountOrderByAggregateInput>;
  _max?: Maybe<TaxonomyToInformAudienceDefinitionMaxOrderByAggregateInput>;
  _min?: Maybe<TaxonomyToInformAudienceDefinitionMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TaxonomyToInformAudienceDefinitionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TaxonomyToInformAudienceDefinitionOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionOrderByWithRelationInput>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TaxonomyToInformAudienceDefinitionOrderByWithRelationInput = {
  _relevance?: Maybe<TaxonomyToInformAudienceDefinitionOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionOrderByWithRelationInput>;
  informAudienceDefinitionId?: Maybe<SortOrder>;
  taxonomy?: Maybe<TaxonomyOrderByWithRelationInput>;
  taxonomyId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TaxonomyToInformAudienceDefinitionScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  InformAudienceDefinitionId = 'informAudienceDefinitionId',
  TaxonomyId = 'taxonomyId',
  UpdatedAt = 'updatedAt'
}

export type TaxonomyToInformAudienceDefinitionScalarWhereInput = {
  AND?: Maybe<Array<TaxonomyToInformAudienceDefinitionScalarWhereInput>>;
  NOT?: Maybe<Array<TaxonomyToInformAudienceDefinitionScalarWhereInput>>;
  OR?: Maybe<Array<TaxonomyToInformAudienceDefinitionScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinitionId?: Maybe<StringFilter>;
  taxonomyId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TaxonomyToInformAudienceDefinitionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TaxonomyToInformAudienceDefinitionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TaxonomyToInformAudienceDefinitionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TaxonomyToInformAudienceDefinitionScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  informAudienceDefinitionId?: Maybe<StringWithAggregatesFilter>;
  taxonomyId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type TaxonomyToInformAudienceDefinitionTaxonomyIdInformAudienceDefinitionIdCompoundUniqueInput = {
  informAudienceDefinitionId: Scalars['String'];
  taxonomyId: Scalars['String'];
};

export type TaxonomyToInformAudienceDefinitionUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  taxonomyId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutInformAudienceDefinitionInput = {
  connect?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateOrConnectWithoutInformAudienceDefinitionInput>>;
  create?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateWithoutInformAudienceDefinitionInput>>;
  createMany?: Maybe<TaxonomyToInformAudienceDefinitionCreateManyInformAudienceDefinitionInputEnvelope>;
};

export type TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutTaxonomyInput = {
  connect?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<TaxonomyToInformAudienceDefinitionCreateManyTaxonomyInputEnvelope>;
};

export type TaxonomyToInformAudienceDefinitionUncheckedCreateWithoutInformAudienceDefinitionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  taxonomyId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUncheckedCreateWithoutTaxonomyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutInformAudienceDefinitionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutInformAudienceDefinitionNestedInput = {
  connect?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateOrConnectWithoutInformAudienceDefinitionInput>>;
  create?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateWithoutInformAudienceDefinitionInput>>;
  createMany?: Maybe<TaxonomyToInformAudienceDefinitionCreateManyInformAudienceDefinitionInputEnvelope>;
  delete?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaxonomyToInformAudienceDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<TaxonomyToInformAudienceDefinitionUpdateWithWhereUniqueWithoutInformAudienceDefinitionInput>>;
  updateMany?: Maybe<Array<TaxonomyToInformAudienceDefinitionUpdateManyWithWhereWithoutInformAudienceDefinitionInput>>;
  upsert?: Maybe<Array<TaxonomyToInformAudienceDefinitionUpsertWithWhereUniqueWithoutInformAudienceDefinitionInput>>;
};

export type TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutTaxonomyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutTaxonomyNestedInput = {
  connect?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<TaxonomyToInformAudienceDefinitionCreateManyTaxonomyInputEnvelope>;
  delete?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaxonomyToInformAudienceDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<TaxonomyToInformAudienceDefinitionUpdateWithWhereUniqueWithoutTaxonomyInput>>;
  updateMany?: Maybe<Array<TaxonomyToInformAudienceDefinitionUpdateManyWithWhereWithoutTaxonomyInput>>;
  upsert?: Maybe<Array<TaxonomyToInformAudienceDefinitionUpsertWithWhereUniqueWithoutTaxonomyInput>>;
};

export type TaxonomyToInformAudienceDefinitionUncheckedUpdateWithoutInformAudienceDefinitionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  taxonomyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUncheckedUpdateWithoutTaxonomyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinitionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionUpdateOneRequiredWithoutTaxonomyToInformAudienceDefinitionNestedInput>;
  taxonomy?: Maybe<TaxonomyUpdateOneRequiredWithoutTaxonomyToInformAudienceDefinitionNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUpdateManyWithWhereWithoutInformAudienceDefinitionInput = {
  data: TaxonomyToInformAudienceDefinitionUpdateManyMutationInput;
  where: TaxonomyToInformAudienceDefinitionScalarWhereInput;
};

export type TaxonomyToInformAudienceDefinitionUpdateManyWithWhereWithoutTaxonomyInput = {
  data: TaxonomyToInformAudienceDefinitionUpdateManyMutationInput;
  where: TaxonomyToInformAudienceDefinitionScalarWhereInput;
};

export type TaxonomyToInformAudienceDefinitionUpdateManyWithoutInformAudienceDefinitionNestedInput = {
  connect?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateOrConnectWithoutInformAudienceDefinitionInput>>;
  create?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateWithoutInformAudienceDefinitionInput>>;
  createMany?: Maybe<TaxonomyToInformAudienceDefinitionCreateManyInformAudienceDefinitionInputEnvelope>;
  delete?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaxonomyToInformAudienceDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<TaxonomyToInformAudienceDefinitionUpdateWithWhereUniqueWithoutInformAudienceDefinitionInput>>;
  updateMany?: Maybe<Array<TaxonomyToInformAudienceDefinitionUpdateManyWithWhereWithoutInformAudienceDefinitionInput>>;
  upsert?: Maybe<Array<TaxonomyToInformAudienceDefinitionUpsertWithWhereUniqueWithoutInformAudienceDefinitionInput>>;
};

export type TaxonomyToInformAudienceDefinitionUpdateManyWithoutTaxonomyNestedInput = {
  connect?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateOrConnectWithoutTaxonomyInput>>;
  create?: Maybe<Array<TaxonomyToInformAudienceDefinitionCreateWithoutTaxonomyInput>>;
  createMany?: Maybe<TaxonomyToInformAudienceDefinitionCreateManyTaxonomyInputEnvelope>;
  delete?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TaxonomyToInformAudienceDefinitionScalarWhereInput>>;
  disconnect?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  set?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereUniqueInput>>;
  update?: Maybe<Array<TaxonomyToInformAudienceDefinitionUpdateWithWhereUniqueWithoutTaxonomyInput>>;
  updateMany?: Maybe<Array<TaxonomyToInformAudienceDefinitionUpdateManyWithWhereWithoutTaxonomyInput>>;
  upsert?: Maybe<Array<TaxonomyToInformAudienceDefinitionUpsertWithWhereUniqueWithoutTaxonomyInput>>;
};

export type TaxonomyToInformAudienceDefinitionUpdateWithWhereUniqueWithoutInformAudienceDefinitionInput = {
  data: TaxonomyToInformAudienceDefinitionUpdateWithoutInformAudienceDefinitionInput;
  where: TaxonomyToInformAudienceDefinitionWhereUniqueInput;
};

export type TaxonomyToInformAudienceDefinitionUpdateWithWhereUniqueWithoutTaxonomyInput = {
  data: TaxonomyToInformAudienceDefinitionUpdateWithoutTaxonomyInput;
  where: TaxonomyToInformAudienceDefinitionWhereUniqueInput;
};

export type TaxonomyToInformAudienceDefinitionUpdateWithoutInformAudienceDefinitionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  taxonomy?: Maybe<TaxonomyUpdateOneRequiredWithoutTaxonomyToInformAudienceDefinitionNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUpdateWithoutTaxonomyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionUpdateOneRequiredWithoutTaxonomyToInformAudienceDefinitionNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyToInformAudienceDefinitionUpsertWithWhereUniqueWithoutInformAudienceDefinitionInput = {
  create: TaxonomyToInformAudienceDefinitionCreateWithoutInformAudienceDefinitionInput;
  update: TaxonomyToInformAudienceDefinitionUpdateWithoutInformAudienceDefinitionInput;
  where: TaxonomyToInformAudienceDefinitionWhereUniqueInput;
};

export type TaxonomyToInformAudienceDefinitionUpsertWithWhereUniqueWithoutTaxonomyInput = {
  create: TaxonomyToInformAudienceDefinitionCreateWithoutTaxonomyInput;
  update: TaxonomyToInformAudienceDefinitionUpdateWithoutTaxonomyInput;
  where: TaxonomyToInformAudienceDefinitionWhereUniqueInput;
};

export type TaxonomyToInformAudienceDefinitionWhereInput = {
  AND?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereInput>>;
  NOT?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereInput>>;
  OR?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionScalarRelationFilter>;
  informAudienceDefinitionId?: Maybe<StringFilter>;
  taxonomy?: Maybe<TaxonomyScalarRelationFilter>;
  taxonomyId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TaxonomyToInformAudienceDefinitionWhereUniqueInput = {
  AND?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereInput>>;
  NOT?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereInput>>;
  OR?: Maybe<Array<TaxonomyToInformAudienceDefinitionWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  informAudienceDefinition?: Maybe<InformAudienceDefinitionScalarRelationFilter>;
  informAudienceDefinitionId?: Maybe<StringFilter>;
  taxonomy?: Maybe<TaxonomyScalarRelationFilter>;
  taxonomyId?: Maybe<StringFilter>;
  taxonomyId_informAudienceDefinitionId?: Maybe<TaxonomyToInformAudienceDefinitionTaxonomyIdInformAudienceDefinitionIdCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TaxonomyUncheckedCreateInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutTaxonomyInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutTaxonomyInput>;
  bedrockInferences?: Maybe<BedrockInferenceUncheckedCreateNestedManyWithoutTaxonomyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUncheckedCreateNestedManyWithoutTaxonomyInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutTaxonomyInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUncheckedCreateWithoutAppointmentTypesInput = {
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutTaxonomyInput>;
  bedrockInferences?: Maybe<BedrockInferenceUncheckedCreateNestedManyWithoutTaxonomyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUncheckedCreateNestedManyWithoutTaxonomyInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutTaxonomyInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUncheckedCreateWithoutAppointmentsInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutTaxonomyInput>;
  bedrockInferences?: Maybe<BedrockInferenceUncheckedCreateNestedManyWithoutTaxonomyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUncheckedCreateNestedManyWithoutTaxonomyInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutTaxonomyInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUncheckedCreateWithoutBedrockInferencesInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutTaxonomyInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutTaxonomyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUncheckedCreateNestedManyWithoutTaxonomyInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutTaxonomyInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUncheckedCreateWithoutServiceInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutTaxonomyInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutTaxonomyInput>;
  bedrockInferences?: Maybe<BedrockInferenceUncheckedCreateNestedManyWithoutTaxonomyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedCreateNestedManyWithoutTaxonomyInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUncheckedCreateWithoutTaxonomyToInformAudienceDefinitionInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutTaxonomyInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutTaxonomyInput>;
  bedrockInferences?: Maybe<BedrockInferenceUncheckedCreateNestedManyWithoutTaxonomyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUncheckedCreateNestedManyWithoutTaxonomyInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUncheckedUpdateInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  bedrockInferences?: Maybe<BedrockInferenceUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUncheckedUpdateWithoutAppointmentTypesInput = {
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  bedrockInferences?: Maybe<BedrockInferenceUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUncheckedUpdateWithoutAppointmentsInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  bedrockInferences?: Maybe<BedrockInferenceUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUncheckedUpdateWithoutBedrockInferencesInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUncheckedUpdateWithoutServiceInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  bedrockInferences?: Maybe<BedrockInferenceUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUncheckedUpdateWithoutTaxonomyToInformAudienceDefinitionInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  bedrockInferences?: Maybe<BedrockInferenceUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUncheckedUpdateManyWithoutTaxonomyNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUpdateInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutTaxonomyNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutTaxonomyNestedInput>;
  bedrockInferences?: Maybe<BedrockInferenceUpdateManyWithoutTaxonomyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateManyWithoutTaxonomyNestedInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUpdateManyWithoutTaxonomyNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUpdateOneRequiredWithoutTaxonomyToInformAudienceDefinitionNestedInput = {
  connect?: Maybe<TaxonomyWhereUniqueInput>;
  connectOrCreate?: Maybe<TaxonomyCreateOrConnectWithoutTaxonomyToInformAudienceDefinitionInput>;
  create?: Maybe<TaxonomyCreateWithoutTaxonomyToInformAudienceDefinitionInput>;
  update?: Maybe<TaxonomyUpdateToOneWithWhereWithoutTaxonomyToInformAudienceDefinitionInput>;
  upsert?: Maybe<TaxonomyUpsertWithoutTaxonomyToInformAudienceDefinitionInput>;
};

export type TaxonomyUpdateOneWithoutAppointmentTypesNestedInput = {
  connect?: Maybe<TaxonomyWhereUniqueInput>;
  connectOrCreate?: Maybe<TaxonomyCreateOrConnectWithoutAppointmentTypesInput>;
  create?: Maybe<TaxonomyCreateWithoutAppointmentTypesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<TaxonomyUpdateToOneWithWhereWithoutAppointmentTypesInput>;
  upsert?: Maybe<TaxonomyUpsertWithoutAppointmentTypesInput>;
};

export type TaxonomyUpdateOneWithoutAppointmentsNestedInput = {
  connect?: Maybe<TaxonomyWhereUniqueInput>;
  connectOrCreate?: Maybe<TaxonomyCreateOrConnectWithoutAppointmentsInput>;
  create?: Maybe<TaxonomyCreateWithoutAppointmentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<TaxonomyUpdateToOneWithWhereWithoutAppointmentsInput>;
  upsert?: Maybe<TaxonomyUpsertWithoutAppointmentsInput>;
};

export type TaxonomyUpdateOneWithoutBedrockInferencesNestedInput = {
  connect?: Maybe<TaxonomyWhereUniqueInput>;
  connectOrCreate?: Maybe<TaxonomyCreateOrConnectWithoutBedrockInferencesInput>;
  create?: Maybe<TaxonomyCreateWithoutBedrockInferencesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<TaxonomyUpdateToOneWithWhereWithoutBedrockInferencesInput>;
  upsert?: Maybe<TaxonomyUpsertWithoutBedrockInferencesInput>;
};

export type TaxonomyUpdateOneWithoutServiceNestedInput = {
  connect?: Maybe<TaxonomyWhereUniqueInput>;
  connectOrCreate?: Maybe<TaxonomyCreateOrConnectWithoutServiceInput>;
  create?: Maybe<TaxonomyCreateWithoutServiceInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<TaxonomyUpdateToOneWithWhereWithoutServiceInput>;
  upsert?: Maybe<TaxonomyUpsertWithoutServiceInput>;
};

export type TaxonomyUpdateToOneWithWhereWithoutAppointmentTypesInput = {
  data: TaxonomyUpdateWithoutAppointmentTypesInput;
  where?: Maybe<TaxonomyWhereInput>;
};

export type TaxonomyUpdateToOneWithWhereWithoutAppointmentsInput = {
  data: TaxonomyUpdateWithoutAppointmentsInput;
  where?: Maybe<TaxonomyWhereInput>;
};

export type TaxonomyUpdateToOneWithWhereWithoutBedrockInferencesInput = {
  data: TaxonomyUpdateWithoutBedrockInferencesInput;
  where?: Maybe<TaxonomyWhereInput>;
};

export type TaxonomyUpdateToOneWithWhereWithoutServiceInput = {
  data: TaxonomyUpdateWithoutServiceInput;
  where?: Maybe<TaxonomyWhereInput>;
};

export type TaxonomyUpdateToOneWithWhereWithoutTaxonomyToInformAudienceDefinitionInput = {
  data: TaxonomyUpdateWithoutTaxonomyToInformAudienceDefinitionInput;
  where?: Maybe<TaxonomyWhereInput>;
};

export type TaxonomyUpdateWithoutAppointmentTypesInput = {
  appointments?: Maybe<AppointmentUpdateManyWithoutTaxonomyNestedInput>;
  bedrockInferences?: Maybe<BedrockInferenceUpdateManyWithoutTaxonomyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateManyWithoutTaxonomyNestedInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUpdateManyWithoutTaxonomyNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUpdateWithoutAppointmentsInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutTaxonomyNestedInput>;
  bedrockInferences?: Maybe<BedrockInferenceUpdateManyWithoutTaxonomyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateManyWithoutTaxonomyNestedInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUpdateManyWithoutTaxonomyNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUpdateWithoutBedrockInferencesInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutTaxonomyNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutTaxonomyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateManyWithoutTaxonomyNestedInput>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUpdateManyWithoutTaxonomyNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUpdateWithoutServiceInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutTaxonomyNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutTaxonomyNestedInput>;
  bedrockInferences?: Maybe<BedrockInferenceUpdateManyWithoutTaxonomyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionUpdateManyWithoutTaxonomyNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUpdateWithoutTaxonomyToInformAudienceDefinitionInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutTaxonomyNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutTaxonomyNestedInput>;
  bedrockInferences?: Maybe<BedrockInferenceUpdateManyWithoutTaxonomyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceUpdateManyWithoutTaxonomyNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxonomyUpsertWithoutAppointmentTypesInput = {
  create: TaxonomyCreateWithoutAppointmentTypesInput;
  update: TaxonomyUpdateWithoutAppointmentTypesInput;
  where?: Maybe<TaxonomyWhereInput>;
};

export type TaxonomyUpsertWithoutAppointmentsInput = {
  create: TaxonomyCreateWithoutAppointmentsInput;
  update: TaxonomyUpdateWithoutAppointmentsInput;
  where?: Maybe<TaxonomyWhereInput>;
};

export type TaxonomyUpsertWithoutBedrockInferencesInput = {
  create: TaxonomyCreateWithoutBedrockInferencesInput;
  update: TaxonomyUpdateWithoutBedrockInferencesInput;
  where?: Maybe<TaxonomyWhereInput>;
};

export type TaxonomyUpsertWithoutServiceInput = {
  create: TaxonomyCreateWithoutServiceInput;
  update: TaxonomyUpdateWithoutServiceInput;
  where?: Maybe<TaxonomyWhereInput>;
};

export type TaxonomyUpsertWithoutTaxonomyToInformAudienceDefinitionInput = {
  create: TaxonomyCreateWithoutTaxonomyToInformAudienceDefinitionInput;
  update: TaxonomyUpdateWithoutTaxonomyToInformAudienceDefinitionInput;
  where?: Maybe<TaxonomyWhereInput>;
};

export type TaxonomyWhereInput = {
  AND?: Maybe<Array<TaxonomyWhereInput>>;
  NOT?: Maybe<Array<TaxonomyWhereInput>>;
  OR?: Maybe<Array<TaxonomyWhereInput>>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  bedrockInferences?: Maybe<BedrockInferenceListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entity?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  parentId?: Maybe<StringNullableFilter>;
  service?: Maybe<ServiceListRelationFilter>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TaxonomyWhereUniqueInput = {
  AND?: Maybe<Array<TaxonomyWhereInput>>;
  NOT?: Maybe<Array<TaxonomyWhereInput>>;
  OR?: Maybe<Array<TaxonomyWhereInput>>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  bedrockInferences?: Maybe<BedrockInferenceListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  entity?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<StringFilter>;
  name_entity?: Maybe<TaxonomyNameEntityCompoundUniqueInput>;
  parentId?: Maybe<StringNullableFilter>;
  service?: Maybe<ServiceListRelationFilter>;
  taxonomyToInformAudienceDefinition?: Maybe<TaxonomyToInformAudienceDefinitionListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TeletriageChannelCountResult = {
  __typename?: 'TeletriageChannelCountResult';
  total: Scalars['Int'];
  unreadChannels: Array<TeletriageUnreadMessageChannel>;
};

export type TeletriageChannelMessageSubscription = {
  __typename?: 'TeletriageChannelMessageSubscription';
  mutation: MutationType;
  node: ChannelMessage;
};

export type TeletriageChannelSearchOutput = {
  __typename?: 'TeletriageChannelSearchOutput';
  channels: Array<Channel>;
  total: Scalars['Int'];
};

export type TeletriageChannelStatus = {
  __typename?: 'TeletriageChannelStatus';
  channelStatusAction: Scalars['String'];
  color: Scalars['String'];
  name: Scalars['String'];
};

export type TeletriageChannelSubscription = {
  __typename?: 'TeletriageChannelSubscription';
  mutation: MutationType;
  node: Channel;
};

export type TeletriageChannelSyncedToSearchWhereInput = {
  channelStatusNames: Array<Scalars['String']>;
  channelType?: Maybe<Scalars['String']>;
  clinicIds: Array<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type TeletriageChannelUnreadMessageCountResult = {
  __typename?: 'TeletriageChannelUnreadMessageCountResult';
  client?: Maybe<TeletriageChannelCountResult>;
  team?: Maybe<TeletriageChannelCountResult>;
  total: Scalars['Int'];
  unreadChannels: Array<TeletriageUnreadMessageChannel>;
};

export type TeletriageSearchChannelInput = {
  and?: Maybe<Array<Maybe<SearchChannelInput>>>;
  channelStatusAction?: Maybe<Scalars['String']>;
  channelStatusNames?: Maybe<Array<Scalars['String']>>;
  channelType?: Maybe<Scalars['String']>;
  clinicIds?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isUnassigned?: Maybe<Scalars['Boolean']>;
  messageBodies?: Maybe<Scalars['String']>;
  or?: Maybe<Array<Maybe<SearchChannelInput>>>;
  petNames?: Maybe<Scalars['String']>;
  petParentNames?: Maybe<Scalars['String']>;
  userNames?: Maybe<Scalars['String']>;
};

export type TeletriageUnreadMessageChannel = {
  __typename?: 'TeletriageUnreadMessageChannel';
  channelId: Scalars['String'];
  channelLastMessageIndex?: Maybe<Scalars['Int']>;
  channelType?: Maybe<ChannelType>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  unreadMessageCount: Scalars['Int'];
};

export enum TemplateAvailability {
  Care = 'Care',
  Clinic = 'Clinic',
  Global = 'Global',
  Organization = 'Organization'
}

export type TerminalAppPaymentResponse = {
  __typename?: 'TerminalAppPaymentResponse';
  clientSecret: Scalars['String'];
  paymentIntent: StripePaymentIntent;
};

export enum TimeUnit {
  Days = 'Days',
  Hours = 'Hours',
  Minutes = 'Minutes',
  Months = 'Months',
  Seconds = 'Seconds',
  Weeks = 'Weeks',
  Years = 'Years'
}

export type TinyUrl = {
  __typename?: 'TinyUrl';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type TinyUrlCountAggregateOutputType = {
  __typename?: 'TinyUrlCountAggregateOutputType';
  _all: Scalars['Int'];
  code: Scalars['Int'];
  createdAt: Scalars['Int'];
  expiresAt: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  token: Scalars['Int'];
  updatedAt: Scalars['Int'];
  url: Scalars['Int'];
};

export type TinyUrlCountOrderByAggregateInput = {
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type TinyUrlCreateInput = {
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type TinyUrlCreateManyInput = {
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type TinyUrlGroupByOutputType = {
  __typename?: 'TinyUrlGroupByOutputType';
  _count?: Maybe<TinyUrlCountAggregateOutputType>;
  _max?: Maybe<TinyUrlMaxAggregateOutputType>;
  _min?: Maybe<TinyUrlMinAggregateOutputType>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type TinyUrlMaxAggregateOutputType = {
  __typename?: 'TinyUrlMaxAggregateOutputType';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type TinyUrlMaxOrderByAggregateInput = {
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type TinyUrlMinAggregateOutputType = {
  __typename?: 'TinyUrlMinAggregateOutputType';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type TinyUrlMinOrderByAggregateInput = {
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type TinyUrlOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TinyUrlOrderByRelevanceInput>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export enum TinyUrlOrderByRelevanceFieldEnum {
  Code = 'code',
  Id = 'id',
  Token = 'token',
  Url = 'url'
}

export type TinyUrlOrderByRelevanceInput = {
  fields: Array<TinyUrlOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type TinyUrlOrderByWithAggregationInput = {
  _count?: Maybe<TinyUrlCountOrderByAggregateInput>;
  _max?: Maybe<TinyUrlMaxOrderByAggregateInput>;
  _min?: Maybe<TinyUrlMinOrderByAggregateInput>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type TinyUrlOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TinyUrlOrderByRelevanceInput>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type TinyUrlOrderByWithRelationInput = {
  _relevance?: Maybe<TinyUrlOrderByRelevanceInput>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  expiresAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export enum TinyUrlScalarFieldEnum {
  Code = 'code',
  CreatedAt = 'createdAt',
  ExpiresAt = 'expiresAt',
  Id = 'id',
  IsActive = 'isActive',
  Token = 'token',
  UpdatedAt = 'updatedAt',
  Url = 'url'
}

export type TinyUrlScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TinyUrlScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TinyUrlScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TinyUrlScalarWhereWithAggregatesInput>>;
  code?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  expiresAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isActive?: Maybe<BoolNullableWithAggregatesFilter>;
  token?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  url?: Maybe<StringWithAggregatesFilter>;
};

export type TinyUrlUncheckedCreateInput = {
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type TinyUrlUncheckedUpdateInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type TinyUrlUncheckedUpdateManyInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type TinyUrlUpdateInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type TinyUrlUpdateManyMutationInput = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type TinyUrlWhereInput = {
  AND?: Maybe<Array<TinyUrlWhereInput>>;
  NOT?: Maybe<Array<TinyUrlWhereInput>>;
  OR?: Maybe<Array<TinyUrlWhereInput>>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  expiresAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  isActive?: Maybe<BoolNullableFilter>;
  token?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
};

export type TinyUrlWhereUniqueInput = {
  AND?: Maybe<Array<TinyUrlWhereInput>>;
  NOT?: Maybe<Array<TinyUrlWhereInput>>;
  OR?: Maybe<Array<TinyUrlWhereInput>>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  expiresAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<BoolNullableFilter>;
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
};

export type TokenOutput = {
  __typename?: 'TokenOutput';
  token: Scalars['String'];
};

export type TokenValidationInput = {
  clinicPetParentId: Scalars['String'];
};

/** @deprecated - 1.0 */
export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Float'];
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4: Scalars['String'];
  cardType: Scalars['String'];
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultation?: Maybe<Consultation>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disbursement?: Maybe<Disbursement>;
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source: PaymentSource;
  status: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


/** @deprecated - 1.0 */
export type TransactionConsultationArgs = {
  where?: Maybe<ConsultationWhereInput>;
};


/** @deprecated - 1.0 */
export type TransactionDisbursementArgs = {
  where?: Maybe<DisbursementWhereInput>;
};

export type TransactionAvgAggregateOutputType = {
  __typename?: 'TransactionAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
};

export type TransactionAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  amountForSettlement?: Maybe<SortOrder>;
  amountSettled?: Maybe<SortOrder>;
  clinicEarnings?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
};

export type TransactionCountAggregateOutputType = {
  __typename?: 'TransactionCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  amountForSettlement: Scalars['Int'];
  amountSettled: Scalars['Int'];
  braintreeGraphqlId: Scalars['Int'];
  cardLast4: Scalars['Int'];
  cardType: Scalars['Int'];
  clinicEarnings: Scalars['Int'];
  consultationId: Scalars['Int'];
  createdAt: Scalars['Int'];
  disbursementDate: Scalars['Int'];
  disbursementId: Scalars['Int'];
  id: Scalars['Int'];
  serviceFeeAmount: Scalars['Int'];
  settlementDate: Scalars['Int'];
  source: Scalars['Int'];
  status: Scalars['Int'];
  transactionId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type TransactionCountOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  amountForSettlement?: Maybe<SortOrder>;
  amountSettled?: Maybe<SortOrder>;
  braintreeGraphqlId?: Maybe<SortOrder>;
  cardLast4?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  clinicEarnings?: Maybe<SortOrder>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settlementDate?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TransactionCreateInput = {
  amount: Scalars['Float'];
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4: Scalars['String'];
  cardType: Scalars['String'];
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutTransactionsInput>;
  createdAt: Scalars['DateTime'];
  disbursement?: Maybe<DisbursementCreateNestedOneWithoutTransactionsInput>;
  disbursementDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionCreateManyConsultationInput = {
  amount: Scalars['Float'];
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4: Scalars['String'];
  cardType: Scalars['String'];
  clinicEarnings?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionCreateManyConsultationInputEnvelope = {
  data: Array<TransactionCreateManyConsultationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TransactionCreateManyDisbursementInput = {
  amount: Scalars['Float'];
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4: Scalars['String'];
  cardType: Scalars['String'];
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disbursementDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionCreateManyDisbursementInputEnvelope = {
  data: Array<TransactionCreateManyDisbursementInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TransactionCreateManyInput = {
  amount: Scalars['Float'];
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4: Scalars['String'];
  cardType: Scalars['String'];
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionCreateNestedManyWithoutConsultationInput = {
  connect?: Maybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TransactionCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<TransactionCreateWithoutConsultationInput>>;
  createMany?: Maybe<TransactionCreateManyConsultationInputEnvelope>;
};

export type TransactionCreateNestedManyWithoutDisbursementInput = {
  connect?: Maybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TransactionCreateOrConnectWithoutDisbursementInput>>;
  create?: Maybe<Array<TransactionCreateWithoutDisbursementInput>>;
  createMany?: Maybe<TransactionCreateManyDisbursementInputEnvelope>;
};

export type TransactionCreateOrConnectWithoutConsultationInput = {
  create: TransactionCreateWithoutConsultationInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionCreateOrConnectWithoutDisbursementInput = {
  create: TransactionCreateWithoutDisbursementInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionCreateWithoutConsultationInput = {
  amount: Scalars['Float'];
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4: Scalars['String'];
  cardType: Scalars['String'];
  clinicEarnings?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  disbursement?: Maybe<DisbursementCreateNestedOneWithoutTransactionsInput>;
  disbursementDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionCreateWithoutDisbursementInput = {
  amount: Scalars['Float'];
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4: Scalars['String'];
  cardType: Scalars['String'];
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultation?: Maybe<ConsultationCreateNestedOneWithoutTransactionsInput>;
  createdAt: Scalars['DateTime'];
  disbursementDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionGroupByOutputType = {
  __typename?: 'TransactionGroupByOutputType';
  _avg?: Maybe<TransactionAvgAggregateOutputType>;
  _count?: Maybe<TransactionCountAggregateOutputType>;
  _max?: Maybe<TransactionMaxAggregateOutputType>;
  _min?: Maybe<TransactionMinAggregateOutputType>;
  _sum?: Maybe<TransactionSumAggregateOutputType>;
  amount: Scalars['Float'];
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4: Scalars['String'];
  cardType: Scalars['String'];
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source: PaymentSource;
  status: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum TransactionIsolationLevel {
  ReadCommitted = 'ReadCommitted',
  ReadUncommitted = 'ReadUncommitted',
  RepeatableRead = 'RepeatableRead',
  Serializable = 'Serializable'
}

export type TransactionListRelationFilter = {
  every?: Maybe<TransactionWhereInput>;
  none?: Maybe<TransactionWhereInput>;
  some?: Maybe<TransactionWhereInput>;
};

export type TransactionMaxAggregateOutputType = {
  __typename?: 'TransactionMaxAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionMaxOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  amountForSettlement?: Maybe<SortOrder>;
  amountSettled?: Maybe<SortOrder>;
  braintreeGraphqlId?: Maybe<SortOrder>;
  cardLast4?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  clinicEarnings?: Maybe<SortOrder>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settlementDate?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TransactionMinAggregateOutputType = {
  __typename?: 'TransactionMinAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionMinOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  amountForSettlement?: Maybe<SortOrder>;
  amountSettled?: Maybe<SortOrder>;
  braintreeGraphqlId?: Maybe<SortOrder>;
  cardLast4?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  clinicEarnings?: Maybe<SortOrder>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settlementDate?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TransactionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type TransactionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TransactionOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  amountForSettlement?: Maybe<SortOrder>;
  amountSettled?: Maybe<SortOrder>;
  braintreeGraphqlId?: Maybe<SortOrder>;
  cardLast4?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  clinicEarnings?: Maybe<SortOrder>;
  consultation?: Maybe<ConsultationOrderByWithRelationInput>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disbursement?: Maybe<DisbursementOrderByWithRelationInput>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settlementDate?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TransactionOrderByRelevanceFieldEnum {
  BraintreeGraphqlId = 'braintreeGraphqlId',
  CardLast4 = 'cardLast4',
  CardType = 'cardType',
  ConsultationId = 'consultationId',
  DisbursementDate = 'disbursementDate',
  DisbursementId = 'disbursementId',
  Id = 'id',
  Status = 'status',
  TransactionId = 'transactionId'
}

export type TransactionOrderByRelevanceInput = {
  fields: Array<TransactionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type TransactionOrderByWithAggregationInput = {
  _avg?: Maybe<TransactionAvgOrderByAggregateInput>;
  _count?: Maybe<TransactionCountOrderByAggregateInput>;
  _max?: Maybe<TransactionMaxOrderByAggregateInput>;
  _min?: Maybe<TransactionMinOrderByAggregateInput>;
  _sum?: Maybe<TransactionSumOrderByAggregateInput>;
  amount?: Maybe<SortOrder>;
  amountForSettlement?: Maybe<SortOrder>;
  amountSettled?: Maybe<SortOrder>;
  braintreeGraphqlId?: Maybe<SortOrder>;
  cardLast4?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  clinicEarnings?: Maybe<SortOrder>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settlementDate?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TransactionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TransactionOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  amountForSettlement?: Maybe<SortOrder>;
  amountSettled?: Maybe<SortOrder>;
  braintreeGraphqlId?: Maybe<SortOrder>;
  cardLast4?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  clinicEarnings?: Maybe<SortOrder>;
  consultation?: Maybe<ConsultationOrderByWithRelationInput>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disbursement?: Maybe<DisbursementOrderByWithRelationInput>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settlementDate?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TransactionOrderByWithRelationInput = {
  _relevance?: Maybe<TransactionOrderByRelevanceInput>;
  amount?: Maybe<SortOrder>;
  amountForSettlement?: Maybe<SortOrder>;
  amountSettled?: Maybe<SortOrder>;
  braintreeGraphqlId?: Maybe<SortOrder>;
  cardLast4?: Maybe<SortOrder>;
  cardType?: Maybe<SortOrder>;
  clinicEarnings?: Maybe<SortOrder>;
  consultation?: Maybe<ConsultationOrderByWithRelationInput>;
  consultationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  disbursement?: Maybe<DisbursementOrderByWithRelationInput>;
  disbursementDate?: Maybe<SortOrder>;
  disbursementId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
  settlementDate?: Maybe<SortOrder>;
  source?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TransactionScalarFieldEnum {
  Amount = 'amount',
  AmountForSettlement = 'amountForSettlement',
  AmountSettled = 'amountSettled',
  BraintreeGraphqlId = 'braintreeGraphqlId',
  CardLast4 = 'cardLast4',
  CardType = 'cardType',
  ClinicEarnings = 'clinicEarnings',
  ConsultationId = 'consultationId',
  CreatedAt = 'createdAt',
  DisbursementDate = 'disbursementDate',
  DisbursementId = 'disbursementId',
  Id = 'id',
  ServiceFeeAmount = 'serviceFeeAmount',
  SettlementDate = 'settlementDate',
  Source = 'source',
  Status = 'status',
  TransactionId = 'transactionId',
  UpdatedAt = 'updatedAt'
}

export type TransactionScalarWhereInput = {
  AND?: Maybe<Array<TransactionScalarWhereInput>>;
  NOT?: Maybe<Array<TransactionScalarWhereInput>>;
  OR?: Maybe<Array<TransactionScalarWhereInput>>;
  amount?: Maybe<FloatFilter>;
  amountForSettlement?: Maybe<FloatNullableFilter>;
  amountSettled?: Maybe<FloatNullableFilter>;
  braintreeGraphqlId?: Maybe<StringNullableFilter>;
  cardLast4?: Maybe<StringFilter>;
  cardType?: Maybe<StringFilter>;
  clinicEarnings?: Maybe<FloatNullableFilter>;
  consultationId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disbursementDate?: Maybe<StringNullableFilter>;
  disbursementId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  serviceFeeAmount?: Maybe<FloatNullableFilter>;
  settlementDate?: Maybe<DateTimeNullableFilter>;
  source?: Maybe<EnumPaymentSourceFilter>;
  status?: Maybe<StringFilter>;
  transactionId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TransactionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TransactionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TransactionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TransactionScalarWhereWithAggregatesInput>>;
  amount?: Maybe<FloatWithAggregatesFilter>;
  amountForSettlement?: Maybe<FloatNullableWithAggregatesFilter>;
  amountSettled?: Maybe<FloatNullableWithAggregatesFilter>;
  braintreeGraphqlId?: Maybe<StringNullableWithAggregatesFilter>;
  cardLast4?: Maybe<StringWithAggregatesFilter>;
  cardType?: Maybe<StringWithAggregatesFilter>;
  clinicEarnings?: Maybe<FloatNullableWithAggregatesFilter>;
  consultationId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  disbursementDate?: Maybe<StringNullableWithAggregatesFilter>;
  disbursementId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  serviceFeeAmount?: Maybe<FloatNullableWithAggregatesFilter>;
  settlementDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  source?: Maybe<EnumPaymentSourceWithAggregatesFilter>;
  status?: Maybe<StringWithAggregatesFilter>;
  transactionId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type TransactionSumAggregateOutputType = {
  __typename?: 'TransactionSumAggregateOutputType';
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
};

export type TransactionSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
  amountForSettlement?: Maybe<SortOrder>;
  amountSettled?: Maybe<SortOrder>;
  clinicEarnings?: Maybe<SortOrder>;
  serviceFeeAmount?: Maybe<SortOrder>;
};

export type TransactionUncheckedCreateInput = {
  amount: Scalars['Float'];
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4: Scalars['String'];
  cardType: Scalars['String'];
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUncheckedCreateNestedManyWithoutConsultationInput = {
  connect?: Maybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TransactionCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<TransactionCreateWithoutConsultationInput>>;
  createMany?: Maybe<TransactionCreateManyConsultationInputEnvelope>;
};

export type TransactionUncheckedCreateNestedManyWithoutDisbursementInput = {
  connect?: Maybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TransactionCreateOrConnectWithoutDisbursementInput>>;
  create?: Maybe<Array<TransactionCreateWithoutDisbursementInput>>;
  createMany?: Maybe<TransactionCreateManyDisbursementInputEnvelope>;
};

export type TransactionUncheckedCreateWithoutConsultationInput = {
  amount: Scalars['Float'];
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4: Scalars['String'];
  cardType: Scalars['String'];
  clinicEarnings?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUncheckedCreateWithoutDisbursementInput = {
  amount: Scalars['Float'];
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4: Scalars['String'];
  cardType: Scalars['String'];
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disbursementDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUncheckedUpdateInput = {
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUncheckedUpdateManyInput = {
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUncheckedUpdateManyWithoutConsultationInput = {
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUncheckedUpdateManyWithoutConsultationNestedInput = {
  connect?: Maybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TransactionCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<TransactionCreateWithoutConsultationInput>>;
  createMany?: Maybe<TransactionCreateManyConsultationInputEnvelope>;
  delete?: Maybe<Array<TransactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TransactionScalarWhereInput>>;
  disconnect?: Maybe<Array<TransactionWhereUniqueInput>>;
  set?: Maybe<Array<TransactionWhereUniqueInput>>;
  update?: Maybe<Array<TransactionUpdateWithWhereUniqueWithoutConsultationInput>>;
  updateMany?: Maybe<Array<TransactionUpdateManyWithWhereWithoutConsultationInput>>;
  upsert?: Maybe<Array<TransactionUpsertWithWhereUniqueWithoutConsultationInput>>;
};

export type TransactionUncheckedUpdateManyWithoutDisbursementInput = {
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disbursementDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUncheckedUpdateManyWithoutDisbursementNestedInput = {
  connect?: Maybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TransactionCreateOrConnectWithoutDisbursementInput>>;
  create?: Maybe<Array<TransactionCreateWithoutDisbursementInput>>;
  createMany?: Maybe<TransactionCreateManyDisbursementInputEnvelope>;
  delete?: Maybe<Array<TransactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TransactionScalarWhereInput>>;
  disconnect?: Maybe<Array<TransactionWhereUniqueInput>>;
  set?: Maybe<Array<TransactionWhereUniqueInput>>;
  update?: Maybe<Array<TransactionUpdateWithWhereUniqueWithoutDisbursementInput>>;
  updateMany?: Maybe<Array<TransactionUpdateManyWithWhereWithoutDisbursementInput>>;
  upsert?: Maybe<Array<TransactionUpsertWithWhereUniqueWithoutDisbursementInput>>;
};

export type TransactionUncheckedUpdateWithoutConsultationInput = {
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disbursementDate?: Maybe<Scalars['String']>;
  disbursementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUncheckedUpdateWithoutDisbursementInput = {
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disbursementDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUpdateInput = {
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultation?: Maybe<ConsultationUpdateOneWithoutTransactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disbursement?: Maybe<DisbursementUpdateOneWithoutTransactionsNestedInput>;
  disbursementDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUpdateManyMutationInput = {
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disbursementDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUpdateManyWithWhereWithoutConsultationInput = {
  data: TransactionUpdateManyMutationInput;
  where: TransactionScalarWhereInput;
};

export type TransactionUpdateManyWithWhereWithoutDisbursementInput = {
  data: TransactionUpdateManyMutationInput;
  where: TransactionScalarWhereInput;
};

export type TransactionUpdateManyWithoutConsultationNestedInput = {
  connect?: Maybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TransactionCreateOrConnectWithoutConsultationInput>>;
  create?: Maybe<Array<TransactionCreateWithoutConsultationInput>>;
  createMany?: Maybe<TransactionCreateManyConsultationInputEnvelope>;
  delete?: Maybe<Array<TransactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TransactionScalarWhereInput>>;
  disconnect?: Maybe<Array<TransactionWhereUniqueInput>>;
  set?: Maybe<Array<TransactionWhereUniqueInput>>;
  update?: Maybe<Array<TransactionUpdateWithWhereUniqueWithoutConsultationInput>>;
  updateMany?: Maybe<Array<TransactionUpdateManyWithWhereWithoutConsultationInput>>;
  upsert?: Maybe<Array<TransactionUpsertWithWhereUniqueWithoutConsultationInput>>;
};

export type TransactionUpdateManyWithoutDisbursementNestedInput = {
  connect?: Maybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TransactionCreateOrConnectWithoutDisbursementInput>>;
  create?: Maybe<Array<TransactionCreateWithoutDisbursementInput>>;
  createMany?: Maybe<TransactionCreateManyDisbursementInputEnvelope>;
  delete?: Maybe<Array<TransactionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TransactionScalarWhereInput>>;
  disconnect?: Maybe<Array<TransactionWhereUniqueInput>>;
  set?: Maybe<Array<TransactionWhereUniqueInput>>;
  update?: Maybe<Array<TransactionUpdateWithWhereUniqueWithoutDisbursementInput>>;
  updateMany?: Maybe<Array<TransactionUpdateManyWithWhereWithoutDisbursementInput>>;
  upsert?: Maybe<Array<TransactionUpsertWithWhereUniqueWithoutDisbursementInput>>;
};

export type TransactionUpdateWithWhereUniqueWithoutConsultationInput = {
  data: TransactionUpdateWithoutConsultationInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpdateWithWhereUniqueWithoutDisbursementInput = {
  data: TransactionUpdateWithoutDisbursementInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpdateWithoutConsultationInput = {
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disbursement?: Maybe<DisbursementUpdateOneWithoutTransactionsNestedInput>;
  disbursementDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUpdateWithoutDisbursementInput = {
  amount?: Maybe<Scalars['Float']>;
  amountForSettlement?: Maybe<Scalars['Float']>;
  amountSettled?: Maybe<Scalars['Float']>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  clinicEarnings?: Maybe<Scalars['Float']>;
  consultation?: Maybe<ConsultationUpdateOneWithoutTransactionsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disbursementDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<PaymentSource>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionUpsertWithWhereUniqueWithoutConsultationInput = {
  create: TransactionCreateWithoutConsultationInput;
  update: TransactionUpdateWithoutConsultationInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpsertWithWhereUniqueWithoutDisbursementInput = {
  create: TransactionCreateWithoutDisbursementInput;
  update: TransactionUpdateWithoutDisbursementInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionWhereInput = {
  AND?: Maybe<Array<TransactionWhereInput>>;
  NOT?: Maybe<Array<TransactionWhereInput>>;
  OR?: Maybe<Array<TransactionWhereInput>>;
  amount?: Maybe<FloatFilter>;
  amountForSettlement?: Maybe<FloatNullableFilter>;
  amountSettled?: Maybe<FloatNullableFilter>;
  braintreeGraphqlId?: Maybe<StringNullableFilter>;
  cardLast4?: Maybe<StringFilter>;
  cardType?: Maybe<StringFilter>;
  clinicEarnings?: Maybe<FloatNullableFilter>;
  consultation?: Maybe<ConsultationNullableScalarRelationFilter>;
  consultationId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disbursement?: Maybe<DisbursementNullableScalarRelationFilter>;
  disbursementDate?: Maybe<StringNullableFilter>;
  disbursementId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  serviceFeeAmount?: Maybe<FloatNullableFilter>;
  settlementDate?: Maybe<DateTimeNullableFilter>;
  source?: Maybe<EnumPaymentSourceFilter>;
  status?: Maybe<StringFilter>;
  transactionId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TransactionWhereUniqueInput = {
  AND?: Maybe<Array<TransactionWhereInput>>;
  NOT?: Maybe<Array<TransactionWhereInput>>;
  OR?: Maybe<Array<TransactionWhereInput>>;
  amount?: Maybe<FloatFilter>;
  amountForSettlement?: Maybe<FloatNullableFilter>;
  amountSettled?: Maybe<FloatNullableFilter>;
  braintreeGraphqlId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<StringFilter>;
  cardType?: Maybe<StringFilter>;
  clinicEarnings?: Maybe<FloatNullableFilter>;
  consultation?: Maybe<ConsultationNullableScalarRelationFilter>;
  consultationId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  disbursement?: Maybe<DisbursementNullableScalarRelationFilter>;
  disbursementDate?: Maybe<StringNullableFilter>;
  disbursementId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  serviceFeeAmount?: Maybe<FloatNullableFilter>;
  settlementDate?: Maybe<DateTimeNullableFilter>;
  source?: Maybe<EnumPaymentSourceFilter>;
  status?: Maybe<StringFilter>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum TranscriptionServices {
  AwsTranscribe = 'AWS_TRANSCRIBE',
  Deepgram = 'DEEPGRAM'
}

export type TransferSubscriptionInput = {
  carePlanEnrollmentId: Scalars['String'];
  careStripeSubscriptionId: Scalars['String'];
  currentClinicPetId: Scalars['String'];
  newClinicPetId: Scalars['String'];
};

export type TransferSubscriptionOutput = {
  __typename?: 'TransferSubscriptionOutput';
  success: Scalars['Boolean'];
};

export type TransferTwilioNumberInput = {
  fromSubaccountSid?: Maybe<Scalars['String']>;
  phoneNumberSid: Scalars['String'];
};

export type TriggerMessageEventInput = {
  data?: Maybe<Scalars['Json']>;
  event?: Maybe<Scalars['String']>;
  queueName?: Maybe<SqsQueueNames>;
  useSubscription?: Maybe<Scalars['Boolean']>;
};

export type TriggerWorkflowEventInput = {
  actionId?: Maybe<Scalars['String']>;
  actionNumber?: Maybe<Scalars['Int']>;
  channelId?: Maybe<Scalars['String']>;
  delay?: Maybe<Scalars['Int']>;
  entityId: Scalars['String'];
  event: Scalars['String'];
  workflowId?: Maybe<Scalars['String']>;
};

export type TrupanionAvailability = {
  __typename?: 'TrupanionAvailability';
  clinicPetId: Scalars['String'];
  clinicPetName?: Maybe<Scalars['String']>;
  errorMessages?: Maybe<Array<Maybe<Scalars['String']>>>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  pimsBreed?: Maybe<Scalars['String']>;
  speciesType?: Maybe<SpeciesType>;
  trupanionClosestBreed?: Maybe<Scalars['String']>;
  unavailableReasons?: Maybe<UnavailableReasons>;
};

export type TrupanionCertificateAvailability = {
  __typename?: 'TrupanionCertificateAvailability';
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody: Scalars['Json'];
  responseStatusCode: Scalars['Int'];
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityAvgAggregateOutputType = {
  __typename?: 'TrupanionCertificateAvailabilityAvgAggregateOutputType';
  responseStatusCode?: Maybe<Scalars['Float']>;
};

export type TrupanionCertificateAvailabilityAvgOrderByAggregateInput = {
  responseStatusCode?: Maybe<SortOrder>;
};

export type TrupanionCertificateAvailabilityCountAggregateOutputType = {
  __typename?: 'TrupanionCertificateAvailabilityCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isAvailable: Scalars['Int'];
  requestBody: Scalars['Int'];
  responseStatusCode: Scalars['Int'];
  unavailableReasons: Scalars['Int'];
};

export type TrupanionCertificateAvailabilityCountOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
  unavailableReasons?: Maybe<SortOrder>;
};

export type TrupanionCertificateAvailabilityCreateInput = {
  clinicPet: ClinicPetCreateNestedOneWithoutTrupanionCertificateAvailabilitiesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody: Scalars['Json'];
  responseStatusCode: Scalars['Int'];
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityCreateManyClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody: Scalars['Json'];
  responseStatusCode: Scalars['Int'];
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityCreateManyClinicPetInputEnvelope = {
  data: Array<TrupanionCertificateAvailabilityCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TrupanionCertificateAvailabilityCreateManyInput = {
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody: Scalars['Json'];
  responseStatusCode: Scalars['Int'];
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<TrupanionCertificateAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TrupanionCertificateAvailabilityCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<TrupanionCertificateAvailabilityCreateWithoutClinicPetInput>>;
  createMany?: Maybe<TrupanionCertificateAvailabilityCreateManyClinicPetInputEnvelope>;
};

export type TrupanionCertificateAvailabilityCreateOrConnectWithoutClinicPetInput = {
  create: TrupanionCertificateAvailabilityCreateWithoutClinicPetInput;
  where: TrupanionCertificateAvailabilityWhereUniqueInput;
};

export type TrupanionCertificateAvailabilityCreateWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody: Scalars['Json'];
  responseStatusCode: Scalars['Int'];
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityGroupByOutputType = {
  __typename?: 'TrupanionCertificateAvailabilityGroupByOutputType';
  _avg?: Maybe<TrupanionCertificateAvailabilityAvgAggregateOutputType>;
  _count?: Maybe<TrupanionCertificateAvailabilityCountAggregateOutputType>;
  _max?: Maybe<TrupanionCertificateAvailabilityMaxAggregateOutputType>;
  _min?: Maybe<TrupanionCertificateAvailabilityMinAggregateOutputType>;
  _sum?: Maybe<TrupanionCertificateAvailabilitySumAggregateOutputType>;
  clinicPetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody: Scalars['Json'];
  responseStatusCode: Scalars['Int'];
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityInput = {
  clinicPetParentId: Scalars['String'];
};

export type TrupanionCertificateAvailabilityListRelationFilter = {
  every?: Maybe<TrupanionCertificateAvailabilityWhereInput>;
  none?: Maybe<TrupanionCertificateAvailabilityWhereInput>;
  some?: Maybe<TrupanionCertificateAvailabilityWhereInput>;
};

export type TrupanionCertificateAvailabilityMaxAggregateOutputType = {
  __typename?: 'TrupanionCertificateAvailabilityMaxAggregateOutputType';
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
};

export type TrupanionCertificateAvailabilityMaxOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
};

export type TrupanionCertificateAvailabilityMinAggregateOutputType = {
  __typename?: 'TrupanionCertificateAvailabilityMinAggregateOutputType';
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
};

export type TrupanionCertificateAvailabilityMinOrderByAggregateInput = {
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
};

export type TrupanionCertificateAvailabilityOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type TrupanionCertificateAvailabilityOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TrupanionCertificateAvailabilityOrderByRelevanceInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
  unavailableReasons?: Maybe<SortOrder>;
};

export enum TrupanionCertificateAvailabilityOrderByRelevanceFieldEnum {
  ClinicPetId = 'clinicPetId',
  Id = 'id'
}

export type TrupanionCertificateAvailabilityOrderByRelevanceInput = {
  fields: Array<TrupanionCertificateAvailabilityOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type TrupanionCertificateAvailabilityOrderByWithAggregationInput = {
  _avg?: Maybe<TrupanionCertificateAvailabilityAvgOrderByAggregateInput>;
  _count?: Maybe<TrupanionCertificateAvailabilityCountOrderByAggregateInput>;
  _max?: Maybe<TrupanionCertificateAvailabilityMaxOrderByAggregateInput>;
  _min?: Maybe<TrupanionCertificateAvailabilityMinOrderByAggregateInput>;
  _sum?: Maybe<TrupanionCertificateAvailabilitySumOrderByAggregateInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
  unavailableReasons?: Maybe<SortOrder>;
};

export type TrupanionCertificateAvailabilityOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TrupanionCertificateAvailabilityOrderByRelevanceInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
  unavailableReasons?: Maybe<SortOrder>;
};

export type TrupanionCertificateAvailabilityOrderByWithRelationInput = {
  _relevance?: Maybe<TrupanionCertificateAvailabilityOrderByRelevanceInput>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  requestBody?: Maybe<SortOrder>;
  responseStatusCode?: Maybe<SortOrder>;
  unavailableReasons?: Maybe<SortOrder>;
};

export enum TrupanionCertificateAvailabilityScalarFieldEnum {
  ClinicPetId = 'clinicPetId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsAvailable = 'isAvailable',
  RequestBody = 'requestBody',
  ResponseStatusCode = 'responseStatusCode',
  UnavailableReasons = 'unavailableReasons'
}

export type TrupanionCertificateAvailabilityScalarWhereInput = {
  AND?: Maybe<Array<TrupanionCertificateAvailabilityScalarWhereInput>>;
  NOT?: Maybe<Array<TrupanionCertificateAvailabilityScalarWhereInput>>;
  OR?: Maybe<Array<TrupanionCertificateAvailabilityScalarWhereInput>>;
  clinicPetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isAvailable?: Maybe<BoolNullableFilter>;
  requestBody?: Maybe<JsonFilter>;
  responseStatusCode?: Maybe<IntFilter>;
  unavailableReasons?: Maybe<JsonNullableFilter>;
};

export type TrupanionCertificateAvailabilityScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TrupanionCertificateAvailabilityScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TrupanionCertificateAvailabilityScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TrupanionCertificateAvailabilityScalarWhereWithAggregatesInput>>;
  clinicPetId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isAvailable?: Maybe<BoolNullableWithAggregatesFilter>;
  requestBody?: Maybe<JsonWithAggregatesFilter>;
  responseStatusCode?: Maybe<IntWithAggregatesFilter>;
  unavailableReasons?: Maybe<JsonNullableWithAggregatesFilter>;
};

export type TrupanionCertificateAvailabilitySumAggregateOutputType = {
  __typename?: 'TrupanionCertificateAvailabilitySumAggregateOutputType';
  responseStatusCode?: Maybe<Scalars['Int']>;
};

export type TrupanionCertificateAvailabilitySumOrderByAggregateInput = {
  responseStatusCode?: Maybe<SortOrder>;
};

export type TrupanionCertificateAvailabilityUncheckedCreateInput = {
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody: Scalars['Json'];
  responseStatusCode: Scalars['Int'];
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<TrupanionCertificateAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TrupanionCertificateAvailabilityCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<TrupanionCertificateAvailabilityCreateWithoutClinicPetInput>>;
  createMany?: Maybe<TrupanionCertificateAvailabilityCreateManyClinicPetInputEnvelope>;
};

export type TrupanionCertificateAvailabilityUncheckedCreateWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody: Scalars['Json'];
  responseStatusCode: Scalars['Int'];
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityUncheckedUpdateInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityUncheckedUpdateManyInput = {
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<TrupanionCertificateAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TrupanionCertificateAvailabilityCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<TrupanionCertificateAvailabilityCreateWithoutClinicPetInput>>;
  createMany?: Maybe<TrupanionCertificateAvailabilityCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<TrupanionCertificateAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TrupanionCertificateAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<TrupanionCertificateAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<TrupanionCertificateAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<TrupanionCertificateAvailabilityUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<TrupanionCertificateAvailabilityUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<TrupanionCertificateAvailabilityUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type TrupanionCertificateAvailabilityUncheckedUpdateWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityUpdateInput = {
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutTrupanionCertificateAvailabilitiesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityUpdateManyWithWhereWithoutClinicPetInput = {
  data: TrupanionCertificateAvailabilityUpdateManyMutationInput;
  where: TrupanionCertificateAvailabilityScalarWhereInput;
};

export type TrupanionCertificateAvailabilityUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<TrupanionCertificateAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TrupanionCertificateAvailabilityCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<TrupanionCertificateAvailabilityCreateWithoutClinicPetInput>>;
  createMany?: Maybe<TrupanionCertificateAvailabilityCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<TrupanionCertificateAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TrupanionCertificateAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<TrupanionCertificateAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<TrupanionCertificateAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<TrupanionCertificateAvailabilityUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<TrupanionCertificateAvailabilityUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<TrupanionCertificateAvailabilityUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type TrupanionCertificateAvailabilityUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: TrupanionCertificateAvailabilityUpdateWithoutClinicPetInput;
  where: TrupanionCertificateAvailabilityWhereUniqueInput;
};

export type TrupanionCertificateAvailabilityUpdateWithoutClinicPetInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  requestBody?: Maybe<Scalars['Json']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  unavailableReasons?: Maybe<Scalars['Json']>;
};

export type TrupanionCertificateAvailabilityUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: TrupanionCertificateAvailabilityCreateWithoutClinicPetInput;
  update: TrupanionCertificateAvailabilityUpdateWithoutClinicPetInput;
  where: TrupanionCertificateAvailabilityWhereUniqueInput;
};

export type TrupanionCertificateAvailabilityWhereInput = {
  AND?: Maybe<Array<TrupanionCertificateAvailabilityWhereInput>>;
  NOT?: Maybe<Array<TrupanionCertificateAvailabilityWhereInput>>;
  OR?: Maybe<Array<TrupanionCertificateAvailabilityWhereInput>>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isAvailable?: Maybe<BoolNullableFilter>;
  requestBody?: Maybe<JsonFilter>;
  responseStatusCode?: Maybe<IntFilter>;
  unavailableReasons?: Maybe<JsonNullableFilter>;
};

export type TrupanionCertificateAvailabilityWhereUniqueInput = {
  AND?: Maybe<Array<TrupanionCertificateAvailabilityWhereInput>>;
  NOT?: Maybe<Array<TrupanionCertificateAvailabilityWhereInput>>;
  OR?: Maybe<Array<TrupanionCertificateAvailabilityWhereInput>>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<BoolNullableFilter>;
  requestBody?: Maybe<JsonFilter>;
  responseStatusCode?: Maybe<IntFilter>;
  unavailableReasons?: Maybe<JsonNullableFilter>;
};

export type TrupanionHospital = {
  __typename?: 'TrupanionHospital';
  Address1?: Maybe<Scalars['String']>;
  Address2?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Distance?: Maybe<Scalars['Float']>;
  Id: Scalars['String'];
  IsCertificateOptedIn?: Maybe<Scalars['Boolean']>;
  IsoAlpha3CountryCode?: Maybe<Scalars['String']>;
  Lat?: Maybe<Scalars['Float']>;
  LegacyId?: Maybe<Scalars['String']>;
  Lon?: Maybe<Scalars['Float']>;
  Name?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  StateCode?: Maybe<Scalars['String']>;
  VetDirectPayAccepted?: Maybe<Scalars['Boolean']>;
};

export type TrupanionHospitalSearchInput = {
  clinicId: Scalars['String'];
  count?: Maybe<Scalars['Int']>;
  radius?: Maybe<Scalars['Int']>;
};

export type TrupanionIntegratedAppointmentType = {
  __typename?: 'TrupanionIntegratedAppointmentType';
  appointmentType: AppointmentType;
  appointmentTypeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  trupanionIntegration: TrupanionIntegration;
  trupanionIntegrationId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TrupanionIntegratedAppointmentTypeCountAggregateOutputType = {
  __typename?: 'TrupanionIntegratedAppointmentTypeCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentTypeId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  trupanionIntegrationId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type TrupanionIntegratedAppointmentTypeCountOrderByAggregateInput = {
  appointmentTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TrupanionIntegratedAppointmentTypeCreateInput = {
  appointmentType: AppointmentTypeCreateNestedOneWithoutTrupanionIntegratedAppointmentTypeInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegration: TrupanionIntegrationCreateNestedOneWithoutTrupanionIntegratedAppointmentTypesInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeCreateManyInput = {
  appointmentTypeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeCreateManyTrupanionIntegrationInput = {
  appointmentTypeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeCreateManyTrupanionIntegrationInputEnvelope = {
  data: Array<TrupanionIntegratedAppointmentTypeCreateManyTrupanionIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TrupanionIntegratedAppointmentTypeCreateNestedManyWithoutTrupanionIntegrationInput = {
  connect?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TrupanionIntegratedAppointmentTypeCreateOrConnectWithoutTrupanionIntegrationInput>>;
  create?: Maybe<Array<TrupanionIntegratedAppointmentTypeCreateWithoutTrupanionIntegrationInput>>;
  createMany?: Maybe<TrupanionIntegratedAppointmentTypeCreateManyTrupanionIntegrationInputEnvelope>;
};

export type TrupanionIntegratedAppointmentTypeCreateNestedOneWithoutAppointmentTypeInput = {
  connect?: Maybe<TrupanionIntegratedAppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<TrupanionIntegratedAppointmentTypeCreateOrConnectWithoutAppointmentTypeInput>;
  create?: Maybe<TrupanionIntegratedAppointmentTypeCreateWithoutAppointmentTypeInput>;
};

export type TrupanionIntegratedAppointmentTypeCreateOrConnectWithoutAppointmentTypeInput = {
  create: TrupanionIntegratedAppointmentTypeCreateWithoutAppointmentTypeInput;
  where: TrupanionIntegratedAppointmentTypeWhereUniqueInput;
};

export type TrupanionIntegratedAppointmentTypeCreateOrConnectWithoutTrupanionIntegrationInput = {
  create: TrupanionIntegratedAppointmentTypeCreateWithoutTrupanionIntegrationInput;
  where: TrupanionIntegratedAppointmentTypeWhereUniqueInput;
};

export type TrupanionIntegratedAppointmentTypeCreateWithoutAppointmentTypeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegration: TrupanionIntegrationCreateNestedOneWithoutTrupanionIntegratedAppointmentTypesInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeCreateWithoutTrupanionIntegrationInput = {
  appointmentType: AppointmentTypeCreateNestedOneWithoutTrupanionIntegratedAppointmentTypeInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeGroupByOutputType = {
  __typename?: 'TrupanionIntegratedAppointmentTypeGroupByOutputType';
  _count?: Maybe<TrupanionIntegratedAppointmentTypeCountAggregateOutputType>;
  _max?: Maybe<TrupanionIntegratedAppointmentTypeMaxAggregateOutputType>;
  _min?: Maybe<TrupanionIntegratedAppointmentTypeMinAggregateOutputType>;
  appointmentTypeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  trupanionIntegrationId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TrupanionIntegratedAppointmentTypeListRelationFilter = {
  every?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
  none?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
  some?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
};

export type TrupanionIntegratedAppointmentTypeMaxAggregateOutputType = {
  __typename?: 'TrupanionIntegratedAppointmentTypeMaxAggregateOutputType';
  appointmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeMaxOrderByAggregateInput = {
  appointmentTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TrupanionIntegratedAppointmentTypeMinAggregateOutputType = {
  __typename?: 'TrupanionIntegratedAppointmentTypeMinAggregateOutputType';
  appointmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeMinOrderByAggregateInput = {
  appointmentTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TrupanionIntegratedAppointmentTypeNullableScalarRelationFilter = {
  AND?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereInput>>;
  NOT?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereInput>>;
  OR?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereInput>>;
  appointmentType?: Maybe<AppointmentTypeScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  trupanionIntegration?: Maybe<TrupanionIntegrationScalarRelationFilter>;
  trupanionIntegrationId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TrupanionIntegratedAppointmentTypeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type TrupanionIntegratedAppointmentTypeOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TrupanionIntegratedAppointmentTypeOrderByRelevanceInput>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  trupanionIntegration?: Maybe<TrupanionIntegrationOrderByWithRelationInput>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TrupanionIntegratedAppointmentTypeOrderByRelevanceFieldEnum {
  AppointmentTypeId = 'appointmentTypeId',
  Id = 'id',
  TrupanionIntegrationId = 'trupanionIntegrationId'
}

export type TrupanionIntegratedAppointmentTypeOrderByRelevanceInput = {
  fields: Array<TrupanionIntegratedAppointmentTypeOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type TrupanionIntegratedAppointmentTypeOrderByWithAggregationInput = {
  _count?: Maybe<TrupanionIntegratedAppointmentTypeCountOrderByAggregateInput>;
  _max?: Maybe<TrupanionIntegratedAppointmentTypeMaxOrderByAggregateInput>;
  _min?: Maybe<TrupanionIntegratedAppointmentTypeMinOrderByAggregateInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TrupanionIntegratedAppointmentTypeOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TrupanionIntegratedAppointmentTypeOrderByRelevanceInput>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  trupanionIntegration?: Maybe<TrupanionIntegrationOrderByWithRelationInput>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TrupanionIntegratedAppointmentTypeOrderByWithRelationInput = {
  _relevance?: Maybe<TrupanionIntegratedAppointmentTypeOrderByRelevanceInput>;
  appointmentType?: Maybe<AppointmentTypeOrderByWithRelationInput>;
  appointmentTypeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  trupanionIntegration?: Maybe<TrupanionIntegrationOrderByWithRelationInput>;
  trupanionIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TrupanionIntegratedAppointmentTypeScalarFieldEnum {
  AppointmentTypeId = 'appointmentTypeId',
  CreatedAt = 'createdAt',
  Id = 'id',
  TrupanionIntegrationId = 'trupanionIntegrationId',
  UpdatedAt = 'updatedAt'
}

export type TrupanionIntegratedAppointmentTypeScalarWhereInput = {
  AND?: Maybe<Array<TrupanionIntegratedAppointmentTypeScalarWhereInput>>;
  NOT?: Maybe<Array<TrupanionIntegratedAppointmentTypeScalarWhereInput>>;
  OR?: Maybe<Array<TrupanionIntegratedAppointmentTypeScalarWhereInput>>;
  appointmentTypeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  trupanionIntegrationId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TrupanionIntegratedAppointmentTypeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TrupanionIntegratedAppointmentTypeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TrupanionIntegratedAppointmentTypeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TrupanionIntegratedAppointmentTypeScalarWhereWithAggregatesInput>>;
  appointmentTypeId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  trupanionIntegrationId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type TrupanionIntegratedAppointmentTypeUncheckedCreateInput = {
  appointmentTypeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeUncheckedCreateNestedManyWithoutTrupanionIntegrationInput = {
  connect?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TrupanionIntegratedAppointmentTypeCreateOrConnectWithoutTrupanionIntegrationInput>>;
  create?: Maybe<Array<TrupanionIntegratedAppointmentTypeCreateWithoutTrupanionIntegrationInput>>;
  createMany?: Maybe<TrupanionIntegratedAppointmentTypeCreateManyTrupanionIntegrationInputEnvelope>;
};

export type TrupanionIntegratedAppointmentTypeUncheckedCreateNestedOneWithoutAppointmentTypeInput = {
  connect?: Maybe<TrupanionIntegratedAppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<TrupanionIntegratedAppointmentTypeCreateOrConnectWithoutAppointmentTypeInput>;
  create?: Maybe<TrupanionIntegratedAppointmentTypeCreateWithoutAppointmentTypeInput>;
};

export type TrupanionIntegratedAppointmentTypeUncheckedCreateWithoutAppointmentTypeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeUncheckedCreateWithoutTrupanionIntegrationInput = {
  appointmentTypeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeUncheckedUpdateInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeUncheckedUpdateManyInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeUncheckedUpdateManyWithoutTrupanionIntegrationInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeUncheckedUpdateManyWithoutTrupanionIntegrationNestedInput = {
  connect?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TrupanionIntegratedAppointmentTypeCreateOrConnectWithoutTrupanionIntegrationInput>>;
  create?: Maybe<Array<TrupanionIntegratedAppointmentTypeCreateWithoutTrupanionIntegrationInput>>;
  createMany?: Maybe<TrupanionIntegratedAppointmentTypeCreateManyTrupanionIntegrationInputEnvelope>;
  delete?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TrupanionIntegratedAppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<TrupanionIntegratedAppointmentTypeUpdateWithWhereUniqueWithoutTrupanionIntegrationInput>>;
  updateMany?: Maybe<Array<TrupanionIntegratedAppointmentTypeUpdateManyWithWhereWithoutTrupanionIntegrationInput>>;
  upsert?: Maybe<Array<TrupanionIntegratedAppointmentTypeUpsertWithWhereUniqueWithoutTrupanionIntegrationInput>>;
};

export type TrupanionIntegratedAppointmentTypeUncheckedUpdateOneWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<TrupanionIntegratedAppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<TrupanionIntegratedAppointmentTypeCreateOrConnectWithoutAppointmentTypeInput>;
  create?: Maybe<TrupanionIntegratedAppointmentTypeCreateWithoutAppointmentTypeInput>;
  delete?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
  disconnect?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
  update?: Maybe<TrupanionIntegratedAppointmentTypeUpdateToOneWithWhereWithoutAppointmentTypeInput>;
  upsert?: Maybe<TrupanionIntegratedAppointmentTypeUpsertWithoutAppointmentTypeInput>;
};

export type TrupanionIntegratedAppointmentTypeUncheckedUpdateWithoutAppointmentTypeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeUncheckedUpdateWithoutTrupanionIntegrationInput = {
  appointmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeUpdateInput = {
  appointmentType?: Maybe<AppointmentTypeUpdateOneRequiredWithoutTrupanionIntegratedAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUpdateOneRequiredWithoutTrupanionIntegratedAppointmentTypesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeUpdateManyWithWhereWithoutTrupanionIntegrationInput = {
  data: TrupanionIntegratedAppointmentTypeUpdateManyMutationInput;
  where: TrupanionIntegratedAppointmentTypeScalarWhereInput;
};

export type TrupanionIntegratedAppointmentTypeUpdateManyWithoutTrupanionIntegrationNestedInput = {
  connect?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TrupanionIntegratedAppointmentTypeCreateOrConnectWithoutTrupanionIntegrationInput>>;
  create?: Maybe<Array<TrupanionIntegratedAppointmentTypeCreateWithoutTrupanionIntegrationInput>>;
  createMany?: Maybe<TrupanionIntegratedAppointmentTypeCreateManyTrupanionIntegrationInputEnvelope>;
  delete?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TrupanionIntegratedAppointmentTypeScalarWhereInput>>;
  disconnect?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereUniqueInput>>;
  set?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereUniqueInput>>;
  update?: Maybe<Array<TrupanionIntegratedAppointmentTypeUpdateWithWhereUniqueWithoutTrupanionIntegrationInput>>;
  updateMany?: Maybe<Array<TrupanionIntegratedAppointmentTypeUpdateManyWithWhereWithoutTrupanionIntegrationInput>>;
  upsert?: Maybe<Array<TrupanionIntegratedAppointmentTypeUpsertWithWhereUniqueWithoutTrupanionIntegrationInput>>;
};

export type TrupanionIntegratedAppointmentTypeUpdateOneWithoutAppointmentTypeNestedInput = {
  connect?: Maybe<TrupanionIntegratedAppointmentTypeWhereUniqueInput>;
  connectOrCreate?: Maybe<TrupanionIntegratedAppointmentTypeCreateOrConnectWithoutAppointmentTypeInput>;
  create?: Maybe<TrupanionIntegratedAppointmentTypeCreateWithoutAppointmentTypeInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<TrupanionIntegratedAppointmentTypeUpdateToOneWithWhereWithoutAppointmentTypeInput>;
  upsert?: Maybe<TrupanionIntegratedAppointmentTypeUpsertWithoutAppointmentTypeInput>;
};

export type TrupanionIntegratedAppointmentTypeUpdateToOneWithWhereWithoutAppointmentTypeInput = {
  data: TrupanionIntegratedAppointmentTypeUpdateWithoutAppointmentTypeInput;
  where?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
};

export type TrupanionIntegratedAppointmentTypeUpdateWithWhereUniqueWithoutTrupanionIntegrationInput = {
  data: TrupanionIntegratedAppointmentTypeUpdateWithoutTrupanionIntegrationInput;
  where: TrupanionIntegratedAppointmentTypeWhereUniqueInput;
};

export type TrupanionIntegratedAppointmentTypeUpdateWithoutAppointmentTypeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationUpdateOneRequiredWithoutTrupanionIntegratedAppointmentTypesNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeUpdateWithoutTrupanionIntegrationInput = {
  appointmentType?: Maybe<AppointmentTypeUpdateOneRequiredWithoutTrupanionIntegratedAppointmentTypeNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegratedAppointmentTypeUpsertWithWhereUniqueWithoutTrupanionIntegrationInput = {
  create: TrupanionIntegratedAppointmentTypeCreateWithoutTrupanionIntegrationInput;
  update: TrupanionIntegratedAppointmentTypeUpdateWithoutTrupanionIntegrationInput;
  where: TrupanionIntegratedAppointmentTypeWhereUniqueInput;
};

export type TrupanionIntegratedAppointmentTypeUpsertWithoutAppointmentTypeInput = {
  create: TrupanionIntegratedAppointmentTypeCreateWithoutAppointmentTypeInput;
  update: TrupanionIntegratedAppointmentTypeUpdateWithoutAppointmentTypeInput;
  where?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
};

export type TrupanionIntegratedAppointmentTypeWhereInput = {
  AND?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereInput>>;
  NOT?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereInput>>;
  OR?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereInput>>;
  appointmentType?: Maybe<AppointmentTypeScalarRelationFilter>;
  appointmentTypeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  trupanionIntegration?: Maybe<TrupanionIntegrationScalarRelationFilter>;
  trupanionIntegrationId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TrupanionIntegratedAppointmentTypeWhereUniqueInput = {
  AND?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereInput>>;
  NOT?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereInput>>;
  OR?: Maybe<Array<TrupanionIntegratedAppointmentTypeWhereInput>>;
  appointmentType?: Maybe<AppointmentTypeScalarRelationFilter>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  trupanionIntegration?: Maybe<TrupanionIntegrationScalarRelationFilter>;
  trupanionIntegrationId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TrupanionIntegration = {
  __typename?: 'TrupanionIntegration';
  _count: TrupanionIntegrationCountOutputType;
  createdAt: Scalars['DateTime'];
  hospitalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insuranceIntegration: InsuranceIntegration;
  insuranceIntegrationId: Scalars['String'];
  sentTrupanionExamDayOffers: Array<SentTrupanionExamDayOffer>;
  trupanionIntegratedAppointmentTypes: Array<TrupanionIntegratedAppointmentType>;
  updatedAt: Scalars['DateTime'];
};


export type TrupanionIntegrationSentTrupanionExamDayOffersArgs = {
  cursor?: Maybe<SentTrupanionExamDayOfferWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SentTrupanionExamDayOfferScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SentTrupanionExamDayOfferOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};


export type TrupanionIntegrationTrupanionIntegratedAppointmentTypesArgs = {
  cursor?: Maybe<TrupanionIntegratedAppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TrupanionIntegratedAppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TrupanionIntegratedAppointmentTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TrupanionIntegratedAppointmentTypeWhereInput>;
};

export type TrupanionIntegrationCountAggregateOutputType = {
  __typename?: 'TrupanionIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  hospitalId: Scalars['Int'];
  id: Scalars['Int'];
  insuranceIntegrationId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type TrupanionIntegrationCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  hospitalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  insuranceIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TrupanionIntegrationCountOutputType = {
  __typename?: 'TrupanionIntegrationCountOutputType';
  sentTrupanionExamDayOffers: Scalars['Int'];
  trupanionIntegratedAppointmentTypes: Scalars['Int'];
};

export type TrupanionIntegrationCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegration: InsuranceIntegrationCreateNestedOneWithoutTrupanionIntegrationInput;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutTrupanionIntegrationInput>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedManyWithoutTrupanionIntegrationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegrationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationCreateNestedOneWithoutInsuranceIntegrationInput = {
  connect?: Maybe<TrupanionIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<TrupanionIntegrationCreateOrConnectWithoutInsuranceIntegrationInput>;
  create?: Maybe<TrupanionIntegrationCreateWithoutInsuranceIntegrationInput>;
};

export type TrupanionIntegrationCreateNestedOneWithoutSentTrupanionExamDayOffersInput = {
  connect?: Maybe<TrupanionIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<TrupanionIntegrationCreateOrConnectWithoutSentTrupanionExamDayOffersInput>;
  create?: Maybe<TrupanionIntegrationCreateWithoutSentTrupanionExamDayOffersInput>;
};

export type TrupanionIntegrationCreateNestedOneWithoutTrupanionIntegratedAppointmentTypesInput = {
  connect?: Maybe<TrupanionIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<TrupanionIntegrationCreateOrConnectWithoutTrupanionIntegratedAppointmentTypesInput>;
  create?: Maybe<TrupanionIntegrationCreateWithoutTrupanionIntegratedAppointmentTypesInput>;
};

export type TrupanionIntegrationCreateOrConnectWithoutInsuranceIntegrationInput = {
  create: TrupanionIntegrationCreateWithoutInsuranceIntegrationInput;
  where: TrupanionIntegrationWhereUniqueInput;
};

export type TrupanionIntegrationCreateOrConnectWithoutSentTrupanionExamDayOffersInput = {
  create: TrupanionIntegrationCreateWithoutSentTrupanionExamDayOffersInput;
  where: TrupanionIntegrationWhereUniqueInput;
};

export type TrupanionIntegrationCreateOrConnectWithoutTrupanionIntegratedAppointmentTypesInput = {
  create: TrupanionIntegrationCreateWithoutTrupanionIntegratedAppointmentTypesInput;
  where: TrupanionIntegrationWhereUniqueInput;
};

export type TrupanionIntegrationCreateWithoutInsuranceIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutTrupanionIntegrationInput>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedManyWithoutTrupanionIntegrationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationCreateWithoutSentTrupanionExamDayOffersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegration: InsuranceIntegrationCreateNestedOneWithoutTrupanionIntegrationInput;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeCreateNestedManyWithoutTrupanionIntegrationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationCreateWithoutTrupanionIntegratedAppointmentTypesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegration: InsuranceIntegrationCreateNestedOneWithoutTrupanionIntegrationInput;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutTrupanionIntegrationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationGroupByOutputType = {
  __typename?: 'TrupanionIntegrationGroupByOutputType';
  _count?: Maybe<TrupanionIntegrationCountAggregateOutputType>;
  _max?: Maybe<TrupanionIntegrationMaxAggregateOutputType>;
  _min?: Maybe<TrupanionIntegrationMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  hospitalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insuranceIntegrationId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TrupanionIntegrationMaxAggregateOutputType = {
  __typename?: 'TrupanionIntegrationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  hospitalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  insuranceIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TrupanionIntegrationMinAggregateOutputType = {
  __typename?: 'TrupanionIntegrationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  hospitalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  insuranceIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TrupanionIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<TrupanionIntegrationWhereInput>>;
  NOT?: Maybe<Array<TrupanionIntegrationWhereInput>>;
  OR?: Maybe<Array<TrupanionIntegrationWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  hospitalId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  insuranceIntegration?: Maybe<InsuranceIntegrationScalarRelationFilter>;
  insuranceIntegrationId?: Maybe<StringFilter>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TrupanionIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TrupanionIntegrationOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  hospitalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  insuranceIntegration?: Maybe<InsuranceIntegrationOrderByWithRelationInput>;
  insuranceIntegrationId?: Maybe<SortOrder>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TrupanionIntegrationOrderByRelevanceFieldEnum {
  HospitalId = 'hospitalId',
  Id = 'id',
  InsuranceIntegrationId = 'insuranceIntegrationId'
}

export type TrupanionIntegrationOrderByRelevanceInput = {
  fields: Array<TrupanionIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type TrupanionIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<TrupanionIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<TrupanionIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<TrupanionIntegrationMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  hospitalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  insuranceIntegrationId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TrupanionIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TrupanionIntegrationOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  hospitalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  insuranceIntegration?: Maybe<InsuranceIntegrationOrderByWithRelationInput>;
  insuranceIntegrationId?: Maybe<SortOrder>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export type TrupanionIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<TrupanionIntegrationOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  hospitalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  insuranceIntegration?: Maybe<InsuranceIntegrationOrderByWithRelationInput>;
  insuranceIntegrationId?: Maybe<SortOrder>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TrupanionIntegrationScalarFieldEnum {
  CreatedAt = 'createdAt',
  HospitalId = 'hospitalId',
  Id = 'id',
  InsuranceIntegrationId = 'insuranceIntegrationId',
  UpdatedAt = 'updatedAt'
}

export type TrupanionIntegrationScalarRelationFilter = {
  AND?: Maybe<Array<TrupanionIntegrationWhereInput>>;
  NOT?: Maybe<Array<TrupanionIntegrationWhereInput>>;
  OR?: Maybe<Array<TrupanionIntegrationWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  hospitalId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  insuranceIntegration?: Maybe<InsuranceIntegrationScalarRelationFilter>;
  insuranceIntegrationId?: Maybe<StringFilter>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TrupanionIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TrupanionIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TrupanionIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TrupanionIntegrationScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  hospitalId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  insuranceIntegrationId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type TrupanionIntegrationUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegrationId: Scalars['String'];
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutTrupanionIntegrationInput>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedManyWithoutTrupanionIntegrationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUncheckedCreateNestedOneWithoutInsuranceIntegrationInput = {
  connect?: Maybe<TrupanionIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<TrupanionIntegrationCreateOrConnectWithoutInsuranceIntegrationInput>;
  create?: Maybe<TrupanionIntegrationCreateWithoutInsuranceIntegrationInput>;
};

export type TrupanionIntegrationUncheckedCreateWithoutInsuranceIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutTrupanionIntegrationInput>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedManyWithoutTrupanionIntegrationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUncheckedCreateWithoutSentTrupanionExamDayOffersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegrationId: Scalars['String'];
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedCreateNestedManyWithoutTrupanionIntegrationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUncheckedCreateWithoutTrupanionIntegratedAppointmentTypesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegrationId: Scalars['String'];
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutTrupanionIntegrationInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegrationId?: Maybe<Scalars['String']>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutTrupanionIntegrationNestedInput>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateManyWithoutTrupanionIntegrationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegrationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUncheckedUpdateOneWithoutInsuranceIntegrationNestedInput = {
  connect?: Maybe<TrupanionIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<TrupanionIntegrationCreateOrConnectWithoutInsuranceIntegrationInput>;
  create?: Maybe<TrupanionIntegrationCreateWithoutInsuranceIntegrationInput>;
  delete?: Maybe<TrupanionIntegrationWhereInput>;
  disconnect?: Maybe<TrupanionIntegrationWhereInput>;
  update?: Maybe<TrupanionIntegrationUpdateToOneWithWhereWithoutInsuranceIntegrationInput>;
  upsert?: Maybe<TrupanionIntegrationUpsertWithoutInsuranceIntegrationInput>;
};

export type TrupanionIntegrationUncheckedUpdateWithoutInsuranceIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutTrupanionIntegrationNestedInput>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateManyWithoutTrupanionIntegrationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUncheckedUpdateWithoutSentTrupanionExamDayOffersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegrationId?: Maybe<Scalars['String']>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeUncheckedUpdateManyWithoutTrupanionIntegrationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUncheckedUpdateWithoutTrupanionIntegratedAppointmentTypesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegrationId?: Maybe<Scalars['String']>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutTrupanionIntegrationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegration?: Maybe<InsuranceIntegrationUpdateOneRequiredWithoutTrupanionIntegrationNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutTrupanionIntegrationNestedInput>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeUpdateManyWithoutTrupanionIntegrationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUpdateOneRequiredWithoutSentTrupanionExamDayOffersNestedInput = {
  connect?: Maybe<TrupanionIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<TrupanionIntegrationCreateOrConnectWithoutSentTrupanionExamDayOffersInput>;
  create?: Maybe<TrupanionIntegrationCreateWithoutSentTrupanionExamDayOffersInput>;
  update?: Maybe<TrupanionIntegrationUpdateToOneWithWhereWithoutSentTrupanionExamDayOffersInput>;
  upsert?: Maybe<TrupanionIntegrationUpsertWithoutSentTrupanionExamDayOffersInput>;
};

export type TrupanionIntegrationUpdateOneRequiredWithoutTrupanionIntegratedAppointmentTypesNestedInput = {
  connect?: Maybe<TrupanionIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<TrupanionIntegrationCreateOrConnectWithoutTrupanionIntegratedAppointmentTypesInput>;
  create?: Maybe<TrupanionIntegrationCreateWithoutTrupanionIntegratedAppointmentTypesInput>;
  update?: Maybe<TrupanionIntegrationUpdateToOneWithWhereWithoutTrupanionIntegratedAppointmentTypesInput>;
  upsert?: Maybe<TrupanionIntegrationUpsertWithoutTrupanionIntegratedAppointmentTypesInput>;
};

export type TrupanionIntegrationUpdateOneWithoutInsuranceIntegrationNestedInput = {
  connect?: Maybe<TrupanionIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<TrupanionIntegrationCreateOrConnectWithoutInsuranceIntegrationInput>;
  create?: Maybe<TrupanionIntegrationCreateWithoutInsuranceIntegrationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<TrupanionIntegrationUpdateToOneWithWhereWithoutInsuranceIntegrationInput>;
  upsert?: Maybe<TrupanionIntegrationUpsertWithoutInsuranceIntegrationInput>;
};

export type TrupanionIntegrationUpdateToOneWithWhereWithoutInsuranceIntegrationInput = {
  data: TrupanionIntegrationUpdateWithoutInsuranceIntegrationInput;
  where?: Maybe<TrupanionIntegrationWhereInput>;
};

export type TrupanionIntegrationUpdateToOneWithWhereWithoutSentTrupanionExamDayOffersInput = {
  data: TrupanionIntegrationUpdateWithoutSentTrupanionExamDayOffersInput;
  where?: Maybe<TrupanionIntegrationWhereInput>;
};

export type TrupanionIntegrationUpdateToOneWithWhereWithoutTrupanionIntegratedAppointmentTypesInput = {
  data: TrupanionIntegrationUpdateWithoutTrupanionIntegratedAppointmentTypesInput;
  where?: Maybe<TrupanionIntegrationWhereInput>;
};

export type TrupanionIntegrationUpdateWithoutInsuranceIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutTrupanionIntegrationNestedInput>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeUpdateManyWithoutTrupanionIntegrationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUpdateWithoutSentTrupanionExamDayOffersInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegration?: Maybe<InsuranceIntegrationUpdateOneRequiredWithoutTrupanionIntegrationNestedInput>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeUpdateManyWithoutTrupanionIntegrationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUpdateWithoutTrupanionIntegratedAppointmentTypesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hospitalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegration?: Maybe<InsuranceIntegrationUpdateOneRequiredWithoutTrupanionIntegrationNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutTrupanionIntegrationNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TrupanionIntegrationUpsertWithoutInsuranceIntegrationInput = {
  create: TrupanionIntegrationCreateWithoutInsuranceIntegrationInput;
  update: TrupanionIntegrationUpdateWithoutInsuranceIntegrationInput;
  where?: Maybe<TrupanionIntegrationWhereInput>;
};

export type TrupanionIntegrationUpsertWithoutSentTrupanionExamDayOffersInput = {
  create: TrupanionIntegrationCreateWithoutSentTrupanionExamDayOffersInput;
  update: TrupanionIntegrationUpdateWithoutSentTrupanionExamDayOffersInput;
  where?: Maybe<TrupanionIntegrationWhereInput>;
};

export type TrupanionIntegrationUpsertWithoutTrupanionIntegratedAppointmentTypesInput = {
  create: TrupanionIntegrationCreateWithoutTrupanionIntegratedAppointmentTypesInput;
  update: TrupanionIntegrationUpdateWithoutTrupanionIntegratedAppointmentTypesInput;
  where?: Maybe<TrupanionIntegrationWhereInput>;
};

export type TrupanionIntegrationWhereInput = {
  AND?: Maybe<Array<TrupanionIntegrationWhereInput>>;
  NOT?: Maybe<Array<TrupanionIntegrationWhereInput>>;
  OR?: Maybe<Array<TrupanionIntegrationWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  hospitalId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  insuranceIntegration?: Maybe<InsuranceIntegrationScalarRelationFilter>;
  insuranceIntegrationId?: Maybe<StringFilter>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TrupanionIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<TrupanionIntegrationWhereInput>>;
  NOT?: Maybe<Array<TrupanionIntegrationWhereInput>>;
  OR?: Maybe<Array<TrupanionIntegrationWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  hospitalId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  insuranceIntegration?: Maybe<InsuranceIntegrationScalarRelationFilter>;
  insuranceIntegrationId?: Maybe<Scalars['String']>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  trupanionIntegratedAppointmentTypes?: Maybe<TrupanionIntegratedAppointmentTypeListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TrupanionIssueCertificateDataInput = {
  isSmsOptedIn?: Maybe<Scalars['Boolean']>;
  trupanionBreed?: Maybe<Scalars['String']>;
};

export type TrupanionIssueCertificateResponse = {
  __typename?: 'TrupanionIssueCertificateResponse';
  errorMessages?: Maybe<Array<Maybe<Scalars['String']>>>;
  referenceNumber?: Maybe<Scalars['String']>;
};

export type TrupanionIssueCertificateWhereInput = {
  clinicPetId: Scalars['String'];
  clinicPetParentId: Scalars['String'];
};

export type TwilioCallRecording = {
  __typename?: 'TwilioCallRecording';
  callRecording: CallRecording;
  callRecordingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  errorCode?: Maybe<Scalars['Int']>;
  sid: Scalars['String'];
  status: TwilioRecordingStatus;
  updatedAt: Scalars['DateTime'];
  uri: Scalars['String'];
};

export type TwilioCallRecordingAvgAggregateOutputType = {
  __typename?: 'TwilioCallRecordingAvgAggregateOutputType';
  errorCode?: Maybe<Scalars['Float']>;
};

export type TwilioCallRecordingAvgOrderByAggregateInput = {
  errorCode?: Maybe<SortOrder>;
};

export type TwilioCallRecordingCountAggregateOutputType = {
  __typename?: 'TwilioCallRecordingCountAggregateOutputType';
  _all: Scalars['Int'];
  callRecordingId: Scalars['Int'];
  createdAt: Scalars['Int'];
  errorCode: Scalars['Int'];
  sid: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
  uri: Scalars['Int'];
};

export type TwilioCallRecordingCountOrderByAggregateInput = {
  callRecordingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorCode?: Maybe<SortOrder>;
  sid?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uri?: Maybe<SortOrder>;
};

export type TwilioCallRecordingCreateInput = {
  callRecording: CallRecordingCreateNestedOneWithoutTwilioCallRecordingInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid: Scalars['String'];
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri: Scalars['String'];
};

export type TwilioCallRecordingCreateManyInput = {
  callRecordingId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid: Scalars['String'];
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri: Scalars['String'];
};

export type TwilioCallRecordingCreateNestedOneWithoutCallRecordingInput = {
  connect?: Maybe<TwilioCallRecordingWhereUniqueInput>;
  connectOrCreate?: Maybe<TwilioCallRecordingCreateOrConnectWithoutCallRecordingInput>;
  create?: Maybe<TwilioCallRecordingCreateWithoutCallRecordingInput>;
};

export type TwilioCallRecordingCreateOrConnectWithoutCallRecordingInput = {
  create: TwilioCallRecordingCreateWithoutCallRecordingInput;
  where: TwilioCallRecordingWhereUniqueInput;
};

export type TwilioCallRecordingCreateWithoutCallRecordingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid: Scalars['String'];
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri: Scalars['String'];
};

export type TwilioCallRecordingGroupByOutputType = {
  __typename?: 'TwilioCallRecordingGroupByOutputType';
  _avg?: Maybe<TwilioCallRecordingAvgAggregateOutputType>;
  _count?: Maybe<TwilioCallRecordingCountAggregateOutputType>;
  _max?: Maybe<TwilioCallRecordingMaxAggregateOutputType>;
  _min?: Maybe<TwilioCallRecordingMinAggregateOutputType>;
  _sum?: Maybe<TwilioCallRecordingSumAggregateOutputType>;
  callRecordingId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  errorCode?: Maybe<Scalars['Int']>;
  sid: Scalars['String'];
  status: TwilioRecordingStatus;
  updatedAt: Scalars['DateTime'];
  uri: Scalars['String'];
};

export type TwilioCallRecordingMaxAggregateOutputType = {
  __typename?: 'TwilioCallRecordingMaxAggregateOutputType';
  callRecordingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri?: Maybe<Scalars['String']>;
};

export type TwilioCallRecordingMaxOrderByAggregateInput = {
  callRecordingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorCode?: Maybe<SortOrder>;
  sid?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uri?: Maybe<SortOrder>;
};

export type TwilioCallRecordingMinAggregateOutputType = {
  __typename?: 'TwilioCallRecordingMinAggregateOutputType';
  callRecordingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri?: Maybe<Scalars['String']>;
};

export type TwilioCallRecordingMinOrderByAggregateInput = {
  callRecordingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorCode?: Maybe<SortOrder>;
  sid?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uri?: Maybe<SortOrder>;
};

export type TwilioCallRecordingNullableScalarRelationFilter = {
  AND?: Maybe<Array<TwilioCallRecordingWhereInput>>;
  NOT?: Maybe<Array<TwilioCallRecordingWhereInput>>;
  OR?: Maybe<Array<TwilioCallRecordingWhereInput>>;
  callRecording?: Maybe<CallRecordingScalarRelationFilter>;
  callRecordingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  errorCode?: Maybe<IntNullableFilter>;
  sid?: Maybe<StringFilter>;
  status?: Maybe<EnumTwilioRecordingStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uri?: Maybe<StringFilter>;
};

export type TwilioCallRecordingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TwilioCallRecordingOrderByRelevanceInput>;
  callRecording?: Maybe<CallRecordingOrderByWithRelationInput>;
  callRecordingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorCode?: Maybe<SortOrder>;
  sid?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uri?: Maybe<SortOrder>;
};

export enum TwilioCallRecordingOrderByRelevanceFieldEnum {
  CallRecordingId = 'callRecordingId',
  Sid = 'sid',
  Uri = 'uri'
}

export type TwilioCallRecordingOrderByRelevanceInput = {
  fields: Array<TwilioCallRecordingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type TwilioCallRecordingOrderByWithAggregationInput = {
  _avg?: Maybe<TwilioCallRecordingAvgOrderByAggregateInput>;
  _count?: Maybe<TwilioCallRecordingCountOrderByAggregateInput>;
  _max?: Maybe<TwilioCallRecordingMaxOrderByAggregateInput>;
  _min?: Maybe<TwilioCallRecordingMinOrderByAggregateInput>;
  _sum?: Maybe<TwilioCallRecordingSumOrderByAggregateInput>;
  callRecordingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorCode?: Maybe<SortOrder>;
  sid?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uri?: Maybe<SortOrder>;
};

export type TwilioCallRecordingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TwilioCallRecordingOrderByRelevanceInput>;
  callRecording?: Maybe<CallRecordingOrderByWithRelationInput>;
  callRecordingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorCode?: Maybe<SortOrder>;
  sid?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uri?: Maybe<SortOrder>;
};

export type TwilioCallRecordingOrderByWithRelationInput = {
  _relevance?: Maybe<TwilioCallRecordingOrderByRelevanceInput>;
  callRecording?: Maybe<CallRecordingOrderByWithRelationInput>;
  callRecordingId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  errorCode?: Maybe<SortOrder>;
  sid?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  uri?: Maybe<SortOrder>;
};

export enum TwilioCallRecordingScalarFieldEnum {
  CallRecordingId = 'callRecordingId',
  CreatedAt = 'createdAt',
  ErrorCode = 'errorCode',
  Sid = 'sid',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  Uri = 'uri'
}

export type TwilioCallRecordingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TwilioCallRecordingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TwilioCallRecordingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TwilioCallRecordingScalarWhereWithAggregatesInput>>;
  callRecordingId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  errorCode?: Maybe<IntNullableWithAggregatesFilter>;
  sid?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumTwilioRecordingStatusWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  uri?: Maybe<StringWithAggregatesFilter>;
};

export type TwilioCallRecordingSubscription = {
  __typename?: 'TwilioCallRecordingSubscription';
  mutation: MutationType;
  node: TwilioCallRecording;
};

export type TwilioCallRecordingSumAggregateOutputType = {
  __typename?: 'TwilioCallRecordingSumAggregateOutputType';
  errorCode?: Maybe<Scalars['Int']>;
};

export type TwilioCallRecordingSumOrderByAggregateInput = {
  errorCode?: Maybe<SortOrder>;
};

export type TwilioCallRecordingUncheckedCreateInput = {
  callRecordingId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid: Scalars['String'];
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri: Scalars['String'];
};

export type TwilioCallRecordingUncheckedCreateNestedOneWithoutCallRecordingInput = {
  connect?: Maybe<TwilioCallRecordingWhereUniqueInput>;
  connectOrCreate?: Maybe<TwilioCallRecordingCreateOrConnectWithoutCallRecordingInput>;
  create?: Maybe<TwilioCallRecordingCreateWithoutCallRecordingInput>;
};

export type TwilioCallRecordingUncheckedCreateWithoutCallRecordingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid: Scalars['String'];
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri: Scalars['String'];
};

export type TwilioCallRecordingUncheckedUpdateInput = {
  callRecordingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri?: Maybe<Scalars['String']>;
};

export type TwilioCallRecordingUncheckedUpdateManyInput = {
  callRecordingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri?: Maybe<Scalars['String']>;
};

export type TwilioCallRecordingUncheckedUpdateOneWithoutCallRecordingNestedInput = {
  connect?: Maybe<TwilioCallRecordingWhereUniqueInput>;
  connectOrCreate?: Maybe<TwilioCallRecordingCreateOrConnectWithoutCallRecordingInput>;
  create?: Maybe<TwilioCallRecordingCreateWithoutCallRecordingInput>;
  delete?: Maybe<TwilioCallRecordingWhereInput>;
  disconnect?: Maybe<TwilioCallRecordingWhereInput>;
  update?: Maybe<TwilioCallRecordingUpdateToOneWithWhereWithoutCallRecordingInput>;
  upsert?: Maybe<TwilioCallRecordingUpsertWithoutCallRecordingInput>;
};

export type TwilioCallRecordingUncheckedUpdateWithoutCallRecordingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri?: Maybe<Scalars['String']>;
};

export type TwilioCallRecordingUpdateInput = {
  callRecording?: Maybe<CallRecordingUpdateOneRequiredWithoutTwilioCallRecordingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri?: Maybe<Scalars['String']>;
};

export type TwilioCallRecordingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri?: Maybe<Scalars['String']>;
};

export type TwilioCallRecordingUpdateOneWithoutCallRecordingNestedInput = {
  connect?: Maybe<TwilioCallRecordingWhereUniqueInput>;
  connectOrCreate?: Maybe<TwilioCallRecordingCreateOrConnectWithoutCallRecordingInput>;
  create?: Maybe<TwilioCallRecordingCreateWithoutCallRecordingInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<TwilioCallRecordingUpdateToOneWithWhereWithoutCallRecordingInput>;
  upsert?: Maybe<TwilioCallRecordingUpsertWithoutCallRecordingInput>;
};

export type TwilioCallRecordingUpdateToOneWithWhereWithoutCallRecordingInput = {
  data: TwilioCallRecordingUpdateWithoutCallRecordingInput;
  where?: Maybe<TwilioCallRecordingWhereInput>;
};

export type TwilioCallRecordingUpdateWithoutCallRecordingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioRecordingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri?: Maybe<Scalars['String']>;
};

export type TwilioCallRecordingUpsertWithoutCallRecordingInput = {
  create: TwilioCallRecordingCreateWithoutCallRecordingInput;
  update: TwilioCallRecordingUpdateWithoutCallRecordingInput;
  where?: Maybe<TwilioCallRecordingWhereInput>;
};

export type TwilioCallRecordingWhereInput = {
  AND?: Maybe<Array<TwilioCallRecordingWhereInput>>;
  NOT?: Maybe<Array<TwilioCallRecordingWhereInput>>;
  OR?: Maybe<Array<TwilioCallRecordingWhereInput>>;
  callRecording?: Maybe<CallRecordingScalarRelationFilter>;
  callRecordingId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  errorCode?: Maybe<IntNullableFilter>;
  sid?: Maybe<StringFilter>;
  status?: Maybe<EnumTwilioRecordingStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uri?: Maybe<StringFilter>;
};

export type TwilioCallRecordingWhereUniqueInput = {
  AND?: Maybe<Array<TwilioCallRecordingWhereInput>>;
  NOT?: Maybe<Array<TwilioCallRecordingWhereInput>>;
  OR?: Maybe<Array<TwilioCallRecordingWhereInput>>;
  callRecording?: Maybe<CallRecordingScalarRelationFilter>;
  callRecordingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  errorCode?: Maybe<IntNullableFilter>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<EnumTwilioRecordingStatusFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  uri?: Maybe<StringFilter>;
};

export type TwilioCallerIdVerification = {
  __typename?: 'TwilioCallerIdVerification';
  callSid: Scalars['String'];
  validationCode: Scalars['String'];
};

export type TwilioCapabilityToken = {
  __typename?: 'TwilioCapabilityToken';
  token: Scalars['String'];
};

export enum TwilioCapabilityType {
  Phone = 'Phone',
  Video = 'Video'
}

export type TwilioConfiguration = {
  __typename?: 'TwilioConfiguration';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type TwilioConfigurationCountAggregateOutputType = {
  __typename?: 'TwilioConfigurationCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  messagingServiceSid: Scalars['Int'];
  subaccountSid: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type TwilioConfigurationCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingServiceSid?: Maybe<SortOrder>;
  subaccountSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TwilioConfigurationCreateInput = {
  clinic: ClinicCreateNestedOneWithoutTwilioConfigurationInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<TwilioConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<TwilioConfigurationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<TwilioConfigurationCreateWithoutClinicInput>;
};

export type TwilioConfigurationCreateOrConnectWithoutClinicInput = {
  create: TwilioConfigurationCreateWithoutClinicInput;
  where: TwilioConfigurationWhereUniqueInput;
};

export type TwilioConfigurationCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationGroupByOutputType = {
  __typename?: 'TwilioConfigurationGroupByOutputType';
  _count?: Maybe<TwilioConfigurationCountAggregateOutputType>;
  _max?: Maybe<TwilioConfigurationMaxAggregateOutputType>;
  _min?: Maybe<TwilioConfigurationMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type TwilioConfigurationMaxAggregateOutputType = {
  __typename?: 'TwilioConfigurationMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingServiceSid?: Maybe<SortOrder>;
  subaccountSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TwilioConfigurationMinAggregateOutputType = {
  __typename?: 'TwilioConfigurationMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingServiceSid?: Maybe<SortOrder>;
  subaccountSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TwilioConfigurationNullableScalarRelationFilter = {
  AND?: Maybe<Array<TwilioConfigurationWhereInput>>;
  NOT?: Maybe<Array<TwilioConfigurationWhereInput>>;
  OR?: Maybe<Array<TwilioConfigurationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  messagingServiceSid?: Maybe<StringNullableFilter>;
  subaccountSid?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TwilioConfigurationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TwilioConfigurationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingServiceSid?: Maybe<SortOrder>;
  subaccountSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TwilioConfigurationOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  MessagingServiceSid = 'messagingServiceSid',
  SubaccountSid = 'subaccountSid'
}

export type TwilioConfigurationOrderByRelevanceInput = {
  fields: Array<TwilioConfigurationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type TwilioConfigurationOrderByWithAggregationInput = {
  _count?: Maybe<TwilioConfigurationCountOrderByAggregateInput>;
  _max?: Maybe<TwilioConfigurationMaxOrderByAggregateInput>;
  _min?: Maybe<TwilioConfigurationMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingServiceSid?: Maybe<SortOrder>;
  subaccountSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TwilioConfigurationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TwilioConfigurationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingServiceSid?: Maybe<SortOrder>;
  subaccountSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TwilioConfigurationOrderByWithRelationInput = {
  _relevance?: Maybe<TwilioConfigurationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  messagingServiceSid?: Maybe<SortOrder>;
  subaccountSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TwilioConfigurationScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  MessagingServiceSid = 'messagingServiceSid',
  SubaccountSid = 'subaccountSid',
  UpdatedAt = 'updatedAt'
}

export type TwilioConfigurationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TwilioConfigurationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TwilioConfigurationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TwilioConfigurationScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  messagingServiceSid?: Maybe<StringNullableWithAggregatesFilter>;
  subaccountSid?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type TwilioConfigurationUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationUncheckedCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<TwilioConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<TwilioConfigurationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<TwilioConfigurationCreateWithoutClinicInput>;
};

export type TwilioConfigurationUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationUncheckedUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<TwilioConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<TwilioConfigurationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<TwilioConfigurationCreateWithoutClinicInput>;
  delete?: Maybe<TwilioConfigurationWhereInput>;
  disconnect?: Maybe<TwilioConfigurationWhereInput>;
  update?: Maybe<TwilioConfigurationUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<TwilioConfigurationUpsertWithoutClinicInput>;
};

export type TwilioConfigurationUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutTwilioConfigurationNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<TwilioConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<TwilioConfigurationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<TwilioConfigurationCreateWithoutClinicInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<TwilioConfigurationUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<TwilioConfigurationUpsertWithoutClinicInput>;
};

export type TwilioConfigurationUpdateToOneWithWhereWithoutClinicInput = {
  data: TwilioConfigurationUpdateWithoutClinicInput;
  where?: Maybe<TwilioConfigurationWhereInput>;
};

export type TwilioConfigurationUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  subaccountSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioConfigurationUpsertWithoutClinicInput = {
  create: TwilioConfigurationCreateWithoutClinicInput;
  update: TwilioConfigurationUpdateWithoutClinicInput;
  where?: Maybe<TwilioConfigurationWhereInput>;
};

export type TwilioConfigurationWhereInput = {
  AND?: Maybe<Array<TwilioConfigurationWhereInput>>;
  NOT?: Maybe<Array<TwilioConfigurationWhereInput>>;
  OR?: Maybe<Array<TwilioConfigurationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  messagingServiceSid?: Maybe<StringNullableFilter>;
  subaccountSid?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TwilioConfigurationWhereUniqueInput = {
  AND?: Maybe<Array<TwilioConfigurationWhereInput>>;
  NOT?: Maybe<Array<TwilioConfigurationWhereInput>>;
  OR?: Maybe<Array<TwilioConfigurationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<StringNullableFilter>;
  subaccountSid?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TwilioEligibilityCheckInput = {
  clinicId?: Maybe<Scalars['String']>;
  customResponseTestValue?: Maybe<TwilioEligibilityCustomResponseTestValue>;
  phoneNumber: Scalars['String'];
};

export type TwilioEligibilityCustomResponseTestValue = {
  eligibility_status?: Maybe<Scalars['String']>;
  eligibility_sub_status?: Maybe<Scalars['String']>;
  hosting_account_sid?: Maybe<Scalars['String']>;
  ineligibility_reason?: Maybe<Scalars['String']>;
  iso_country_code?: Maybe<Scalars['String']>;
  next_step?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  phone_number_type?: Maybe<Scalars['String']>;
};

export type TwilioGetOrCreateHostedNumberOrderInput = {
  clinicPhoneNumberId: Scalars['String'];
};

export type TwilioGetOrCreateHostedNumberOrderOutput = {
  __typename?: 'TwilioGetOrCreateHostedNumberOrderOutput';
  orderId: Scalars['String'];
  status: TwilioHostedNumberOrderStatus;
};

export type TwilioGetOrGenerateLoaInput = {
  clinicPhoneNumberId: Scalars['String'];
  userId: Scalars['String'];
};

export type TwilioGetOrGenerateLoaResponse = {
  __typename?: 'TwilioGetOrGenerateLOAResponse';
  email: Scalars['String'];
  signedAt?: Maybe<Scalars['String']>;
  status: LoaStatus;
  url: Scalars['String'];
};

export enum TwilioHostedNumberOrderStatus {
  ActionRequired = 'ACTION_REQUIRED',
  CarrierProcessing = 'CARRIER_PROCESSING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  PendingLoa = 'PENDING_LOA',
  PendingVerification = 'PENDING_VERIFICATION',
  Received = 'RECEIVED',
  Testing = 'TESTING',
  TwilioProcessing = 'TWILIO_PROCESSING',
  Verified = 'VERIFIED'
}

export enum TwilioRecordingStatus {
  Absent = 'Absent',
  Completed = 'Completed',
  InProgress = 'InProgress',
  Paused = 'Paused',
  Processing = 'Processing',
  Stopped = 'Stopped'
}

export type TwilioVerification = {
  __typename?: 'TwilioVerification';
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  phoneNumber: Scalars['String'];
  status: TwilioVerificationStatus;
  twilioCallSid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TwilioVerificationCountAggregateOutputType = {
  __typename?: 'TwilioVerificationCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  phoneNumber: Scalars['Int'];
  status: Scalars['Int'];
  twilioCallSid: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type TwilioVerificationCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  twilioCallSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TwilioVerificationCreateInput = {
  clinic: ClinicCreateNestedOneWithoutTwilioVerificationsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationCreateManyClinicInputEnvelope = {
  data: Array<TwilioVerificationCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TwilioVerificationCreateManyInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<TwilioVerificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TwilioVerificationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<TwilioVerificationCreateWithoutClinicInput>>;
  createMany?: Maybe<TwilioVerificationCreateManyClinicInputEnvelope>;
};

export type TwilioVerificationCreateOrConnectWithoutClinicInput = {
  create: TwilioVerificationCreateWithoutClinicInput;
  where: TwilioVerificationWhereUniqueInput;
};

export type TwilioVerificationCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationGroupByOutputType = {
  __typename?: 'TwilioVerificationGroupByOutputType';
  _count?: Maybe<TwilioVerificationCountAggregateOutputType>;
  _max?: Maybe<TwilioVerificationMaxAggregateOutputType>;
  _min?: Maybe<TwilioVerificationMinAggregateOutputType>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  phoneNumber: Scalars['String'];
  status: TwilioVerificationStatus;
  twilioCallSid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TwilioVerificationListRelationFilter = {
  every?: Maybe<TwilioVerificationWhereInput>;
  none?: Maybe<TwilioVerificationWhereInput>;
  some?: Maybe<TwilioVerificationWhereInput>;
};

export type TwilioVerificationMaxAggregateOutputType = {
  __typename?: 'TwilioVerificationMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  twilioCallSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TwilioVerificationMinAggregateOutputType = {
  __typename?: 'TwilioVerificationMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  twilioCallSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TwilioVerificationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type TwilioVerificationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TwilioVerificationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  twilioCallSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TwilioVerificationOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  PhoneNumber = 'phoneNumber',
  TwilioCallSid = 'twilioCallSid'
}

export type TwilioVerificationOrderByRelevanceInput = {
  fields: Array<TwilioVerificationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type TwilioVerificationOrderByWithAggregationInput = {
  _count?: Maybe<TwilioVerificationCountOrderByAggregateInput>;
  _max?: Maybe<TwilioVerificationMaxOrderByAggregateInput>;
  _min?: Maybe<TwilioVerificationMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  twilioCallSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TwilioVerificationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<TwilioVerificationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  twilioCallSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TwilioVerificationOrderByWithRelationInput = {
  _relevance?: Maybe<TwilioVerificationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  twilioCallSid?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TwilioVerificationScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  PhoneNumber = 'phoneNumber',
  Status = 'status',
  TwilioCallSid = 'twilioCallSid',
  UpdatedAt = 'updatedAt'
}

export type TwilioVerificationScalarWhereInput = {
  AND?: Maybe<Array<TwilioVerificationScalarWhereInput>>;
  NOT?: Maybe<Array<TwilioVerificationScalarWhereInput>>;
  OR?: Maybe<Array<TwilioVerificationScalarWhereInput>>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  phoneNumber?: Maybe<StringFilter>;
  status?: Maybe<EnumTwilioVerificationStatusFilter>;
  twilioCallSid?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TwilioVerificationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TwilioVerificationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TwilioVerificationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TwilioVerificationScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  phoneNumber?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumTwilioVerificationStatusWithAggregatesFilter>;
  twilioCallSid?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum TwilioVerificationStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Success = 'Success'
}

export type TwilioVerificationSubscription = {
  __typename?: 'TwilioVerificationSubscription';
  mutation: MutationType;
  node: TwilioVerification;
};

export type TwilioVerificationUncheckedCreateInput = {
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<TwilioVerificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TwilioVerificationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<TwilioVerificationCreateWithoutClinicInput>>;
  createMany?: Maybe<TwilioVerificationCreateManyClinicInputEnvelope>;
};

export type TwilioVerificationUncheckedCreateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<TwilioVerificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TwilioVerificationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<TwilioVerificationCreateWithoutClinicInput>>;
  createMany?: Maybe<TwilioVerificationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<TwilioVerificationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TwilioVerificationScalarWhereInput>>;
  disconnect?: Maybe<Array<TwilioVerificationWhereUniqueInput>>;
  set?: Maybe<Array<TwilioVerificationWhereUniqueInput>>;
  update?: Maybe<Array<TwilioVerificationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<TwilioVerificationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<TwilioVerificationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type TwilioVerificationUncheckedUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutTwilioVerificationsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationUpdateManyWithWhereWithoutClinicInput = {
  data: TwilioVerificationUpdateManyMutationInput;
  where: TwilioVerificationScalarWhereInput;
};

export type TwilioVerificationUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<TwilioVerificationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TwilioVerificationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<TwilioVerificationCreateWithoutClinicInput>>;
  createMany?: Maybe<TwilioVerificationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<TwilioVerificationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TwilioVerificationScalarWhereInput>>;
  disconnect?: Maybe<Array<TwilioVerificationWhereUniqueInput>>;
  set?: Maybe<Array<TwilioVerificationWhereUniqueInput>>;
  update?: Maybe<Array<TwilioVerificationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<TwilioVerificationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<TwilioVerificationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type TwilioVerificationUpdateWithWhereUniqueWithoutClinicInput = {
  data: TwilioVerificationUpdateWithoutClinicInput;
  where: TwilioVerificationWhereUniqueInput;
};

export type TwilioVerificationUpdateWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  status?: Maybe<TwilioVerificationStatus>;
  twilioCallSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioVerificationUpsertWithWhereUniqueWithoutClinicInput = {
  create: TwilioVerificationCreateWithoutClinicInput;
  update: TwilioVerificationUpdateWithoutClinicInput;
  where: TwilioVerificationWhereUniqueInput;
};

export type TwilioVerificationWhereInput = {
  AND?: Maybe<Array<TwilioVerificationWhereInput>>;
  NOT?: Maybe<Array<TwilioVerificationWhereInput>>;
  OR?: Maybe<Array<TwilioVerificationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  phoneNumber?: Maybe<StringFilter>;
  status?: Maybe<EnumTwilioVerificationStatusFilter>;
  twilioCallSid?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TwilioVerificationWhereUniqueInput = {
  AND?: Maybe<Array<TwilioVerificationWhereInput>>;
  NOT?: Maybe<Array<TwilioVerificationWhereInput>>;
  OR?: Maybe<Array<TwilioVerificationWhereInput>>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<StringFilter>;
  status?: Maybe<EnumTwilioVerificationStatusFilter>;
  twilioCallSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type TwilioVerifyCallerIdInput = {
  callDelay?: Maybe<Scalars['Int']>;
  extension?: Maybe<Scalars['String']>;
  friendlyName: Scalars['String'];
  isCallerId?: Maybe<Scalars['Boolean']>;
  phoneNumber: Scalars['String'];
};

export type TwilioVerifySubAccountCallerIdInput = {
  callDelay?: Maybe<Scalars['Int']>;
  extension?: Maybe<Scalars['String']>;
  friendlyName: Scalars['String'];
  isCallerId?: Maybe<Scalars['Boolean']>;
  phoneNumber: Scalars['String'];
};

export type UiRefresh = {
  __typename?: 'UiRefresh';
  message: Scalars['String'];
  metadata?: Maybe<Scalars['Json']>;
  refreshType: UiRefreshType;
};

export type UiRefreshInput = {
  message: Scalars['String'];
  metadata?: Maybe<Scalars['Json']>;
  refreshType: UiRefreshType;
};

export enum UiRefreshType {
  HardRefresh = 'HardRefresh',
  SuggestRefresh = 'SuggestRefresh'
}

export type UnavailableReasons = {
  __typename?: 'UnavailableReasons';
  IsActiveOrPendingCertificateFound?: Maybe<Scalars['Boolean']>;
  IsAdoptionDateOutsideOfActivationWindow?: Maybe<Scalars['Boolean']>;
  IsEmailAssociatedToManyPolicies?: Maybe<Scalars['Boolean']>;
  IsExamDateOutsideOfActivationWindow?: Maybe<Scalars['Boolean']>;
  IsPetAlreadyEnrolled?: Maybe<Scalars['Boolean']>;
  IsPetPolicyCancelled?: Maybe<Scalars['Boolean']>;
};

export type UniqueSalesforceAccount = {
  __typename?: 'UniqueSalesforceAccount';
  billingCity?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingCountryCode?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  billingStateCode?: Maybe<Scalars['String']>;
  billingStreet?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  isBad?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  lastModifiedAt: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  salesforceAccountId: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type UnlayerSetting = {
  __typename?: 'UnlayerSetting';
  _count: UnlayerSettingCountOutputType;
  clinics: Array<Clinic>;
  createdAt: Scalars['DateTime'];
  emailTemplates: Array<EmailTemplate>;
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type UnlayerSettingClinicsArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type UnlayerSettingEmailTemplatesArgs = {
  cursor?: Maybe<EmailTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailTemplateWhereInput>;
};

export type UnlayerSettingAvgAggregateOutputType = {
  __typename?: 'UnlayerSettingAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type UnlayerSettingAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type UnlayerSettingCountAggregateOutputType = {
  __typename?: 'UnlayerSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type UnlayerSettingCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UnlayerSettingCountOutputType = {
  __typename?: 'UnlayerSettingCountOutputType';
  clinics: Scalars['Int'];
  emailTemplates: Scalars['Int'];
};

export type UnlayerSettingCreateInput = {
  clinics?: Maybe<ClinicCreateNestedManyWithoutUnlayerSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailTemplates?: Maybe<EmailTemplateCreateNestedManyWithoutUnlayerSettingInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingCreateNestedOneWithoutClinicsInput = {
  connect?: Maybe<UnlayerSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<UnlayerSettingCreateOrConnectWithoutClinicsInput>;
  create?: Maybe<UnlayerSettingCreateWithoutClinicsInput>;
};

export type UnlayerSettingCreateNestedOneWithoutEmailTemplatesInput = {
  connect?: Maybe<UnlayerSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<UnlayerSettingCreateOrConnectWithoutEmailTemplatesInput>;
  create?: Maybe<UnlayerSettingCreateWithoutEmailTemplatesInput>;
};

export type UnlayerSettingCreateOrConnectWithoutClinicsInput = {
  create: UnlayerSettingCreateWithoutClinicsInput;
  where: UnlayerSettingWhereUniqueInput;
};

export type UnlayerSettingCreateOrConnectWithoutEmailTemplatesInput = {
  create: UnlayerSettingCreateWithoutEmailTemplatesInput;
  where: UnlayerSettingWhereUniqueInput;
};

export type UnlayerSettingCreateWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailTemplates?: Maybe<EmailTemplateCreateNestedManyWithoutUnlayerSettingInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingCreateWithoutEmailTemplatesInput = {
  clinics?: Maybe<ClinicCreateNestedManyWithoutUnlayerSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingGroupByOutputType = {
  __typename?: 'UnlayerSettingGroupByOutputType';
  _avg?: Maybe<UnlayerSettingAvgAggregateOutputType>;
  _count?: Maybe<UnlayerSettingCountAggregateOutputType>;
  _max?: Maybe<UnlayerSettingMaxAggregateOutputType>;
  _min?: Maybe<UnlayerSettingMinAggregateOutputType>;
  _sum?: Maybe<UnlayerSettingSumAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type UnlayerSettingMaxAggregateOutputType = {
  __typename?: 'UnlayerSettingMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UnlayerSettingMinAggregateOutputType = {
  __typename?: 'UnlayerSettingMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UnlayerSettingNullableScalarRelationFilter = {
  AND?: Maybe<Array<UnlayerSettingWhereInput>>;
  NOT?: Maybe<Array<UnlayerSettingWhereInput>>;
  OR?: Maybe<Array<UnlayerSettingWhereInput>>;
  clinics?: Maybe<ClinicListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailTemplates?: Maybe<EmailTemplateListRelationFilter>;
  id?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type UnlayerSettingOrderByRelationAndSearchRelevanceInput = {
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  emailTemplates?: Maybe<EmailTemplateOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UnlayerSettingOrderByWithAggregationInput = {
  _avg?: Maybe<UnlayerSettingAvgOrderByAggregateInput>;
  _count?: Maybe<UnlayerSettingCountOrderByAggregateInput>;
  _max?: Maybe<UnlayerSettingMaxOrderByAggregateInput>;
  _min?: Maybe<UnlayerSettingMinOrderByAggregateInput>;
  _sum?: Maybe<UnlayerSettingSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UnlayerSettingOrderByWithRelationAndSearchRelevanceInput = {
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  emailTemplates?: Maybe<EmailTemplateOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UnlayerSettingOrderByWithRelationInput = {
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  emailTemplates?: Maybe<EmailTemplateOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum UnlayerSettingScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type UnlayerSettingScalarRelationFilter = {
  AND?: Maybe<Array<UnlayerSettingWhereInput>>;
  NOT?: Maybe<Array<UnlayerSettingWhereInput>>;
  OR?: Maybe<Array<UnlayerSettingWhereInput>>;
  clinics?: Maybe<ClinicListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailTemplates?: Maybe<EmailTemplateListRelationFilter>;
  id?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type UnlayerSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UnlayerSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UnlayerSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UnlayerSettingScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type UnlayerSettingSumAggregateOutputType = {
  __typename?: 'UnlayerSettingSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type UnlayerSettingSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type UnlayerSettingUncheckedCreateInput = {
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUnlayerSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailTemplates?: Maybe<EmailTemplateUncheckedCreateNestedManyWithoutUnlayerSettingInput>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingUncheckedCreateWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailTemplates?: Maybe<EmailTemplateUncheckedCreateNestedManyWithoutUnlayerSettingInput>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingUncheckedCreateWithoutEmailTemplatesInput = {
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUnlayerSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingUncheckedUpdateInput = {
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUnlayerSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailTemplates?: Maybe<EmailTemplateUncheckedUpdateManyWithoutUnlayerSettingNestedInput>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingUncheckedUpdateWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailTemplates?: Maybe<EmailTemplateUncheckedUpdateManyWithoutUnlayerSettingNestedInput>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingUncheckedUpdateWithoutEmailTemplatesInput = {
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUnlayerSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingUpdateInput = {
  clinics?: Maybe<ClinicUpdateManyWithoutUnlayerSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailTemplates?: Maybe<EmailTemplateUpdateManyWithoutUnlayerSettingNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingUpdateOneRequiredWithoutEmailTemplatesNestedInput = {
  connect?: Maybe<UnlayerSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<UnlayerSettingCreateOrConnectWithoutEmailTemplatesInput>;
  create?: Maybe<UnlayerSettingCreateWithoutEmailTemplatesInput>;
  update?: Maybe<UnlayerSettingUpdateToOneWithWhereWithoutEmailTemplatesInput>;
  upsert?: Maybe<UnlayerSettingUpsertWithoutEmailTemplatesInput>;
};

export type UnlayerSettingUpdateOneWithoutClinicsNestedInput = {
  connect?: Maybe<UnlayerSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<UnlayerSettingCreateOrConnectWithoutClinicsInput>;
  create?: Maybe<UnlayerSettingCreateWithoutClinicsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UnlayerSettingUpdateToOneWithWhereWithoutClinicsInput>;
  upsert?: Maybe<UnlayerSettingUpsertWithoutClinicsInput>;
};

export type UnlayerSettingUpdateToOneWithWhereWithoutClinicsInput = {
  data: UnlayerSettingUpdateWithoutClinicsInput;
  where?: Maybe<UnlayerSettingWhereInput>;
};

export type UnlayerSettingUpdateToOneWithWhereWithoutEmailTemplatesInput = {
  data: UnlayerSettingUpdateWithoutEmailTemplatesInput;
  where?: Maybe<UnlayerSettingWhereInput>;
};

export type UnlayerSettingUpdateWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailTemplates?: Maybe<EmailTemplateUpdateManyWithoutUnlayerSettingNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingUpdateWithoutEmailTemplatesInput = {
  clinics?: Maybe<ClinicUpdateManyWithoutUnlayerSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UnlayerSettingUpsertWithoutClinicsInput = {
  create: UnlayerSettingCreateWithoutClinicsInput;
  update: UnlayerSettingUpdateWithoutClinicsInput;
  where?: Maybe<UnlayerSettingWhereInput>;
};

export type UnlayerSettingUpsertWithoutEmailTemplatesInput = {
  create: UnlayerSettingCreateWithoutEmailTemplatesInput;
  update: UnlayerSettingUpdateWithoutEmailTemplatesInput;
  where?: Maybe<UnlayerSettingWhereInput>;
};

export type UnlayerSettingWhereInput = {
  AND?: Maybe<Array<UnlayerSettingWhereInput>>;
  NOT?: Maybe<Array<UnlayerSettingWhereInput>>;
  OR?: Maybe<Array<UnlayerSettingWhereInput>>;
  clinics?: Maybe<ClinicListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailTemplates?: Maybe<EmailTemplateListRelationFilter>;
  id?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type UnlayerSettingWhereUniqueInput = {
  AND?: Maybe<Array<UnlayerSettingWhereInput>>;
  NOT?: Maybe<Array<UnlayerSettingWhereInput>>;
  OR?: Maybe<Array<UnlayerSettingWhereInput>>;
  clinics?: Maybe<ClinicListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailTemplates?: Maybe<EmailTemplateListRelationFilter>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type UnlayerUser = {
  __typename?: 'UnlayerUser';
  signature: Scalars['String'];
  userId: Scalars['Int'];
};

export type UnreadMessageChannel = {
  __typename?: 'UnreadMessageChannel';
  channelId: Scalars['String'];
  channelLastMessageIndex?: Maybe<Scalars['Int']>;
  channelType?: Maybe<ChannelType>;
  lastConsumedMessageIndex?: Maybe<Scalars['Int']>;
  unreadMessageCount: Scalars['Int'];
};

export type UpdateAppointmentTypeProviderRoomMapsInput = {
  appointmentTypeId: Scalars['String'];
  providerRoomMaps: Scalars['Json'];
};

export type UpdateAppointmentTypeProviderRoomMapsResponse = {
  __typename?: 'UpdateAppointmentTypeProviderRoomMapsResponse';
  count?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type UpdateCareSubscriptionInput = {
  addedEnrollments: Array<Maybe<OrganizationPetEnrollmentInput>>;
  cancelledAddonEnrollmentIds?: Maybe<Array<Scalars['String']>>;
  cancelledPlanEnrollmentIds?: Maybe<Array<Scalars['String']>>;
};

export type UpdateCareSubscriptionResult = {
  __typename?: 'UpdateCareSubscriptionResult';
  success: Scalars['Boolean'];
};

export type UpdateChannelFilterSelectionInput = {
  filterSelectionType?: Maybe<FilterSelectionType>;
  filters?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type UpdateClinicPostcardSettingDataInput = {
  isRemindersEnabled?: Maybe<Scalars['Boolean']>;
};

export type UpdateClinicPostcardSettingWhereInput = {
  id: Scalars['String'];
};

export type UpdateOneAxionCallInput = {
  action: AxionAction;
  callId: Scalars['String'];
  userId: Scalars['String'];
};

export type UpdatePayoutBatchingSettingInput = {
  clinicId: Scalars['String'];
  isAutomated: Scalars['Boolean'];
  schedules: Array<Maybe<Schedule>>;
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type UpdatePayoutBatchingSettingResponse = {
  __typename?: 'UpdatePayoutBatchingSettingResponse';
  success: Scalars['Boolean'];
};

export type UploadEmailCampaignCustomListInput = {
  awsFileKey: Scalars['String'];
  emailCampaignId: Scalars['String'];
  fileName: Scalars['String'];
};

export type UpsertUserToClinicInput = {
  clinicId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
};

export type UsageByBenefit = {
  __typename?: 'UsageByBenefit';
  benefit: CareBenefit;
  carryover?: Maybe<Scalars['Int']>;
  costCovered?: Maybe<Scalars['Int']>;
  displayOrder?: Maybe<Scalars['Int']>;
  exhausted: Scalars['Boolean'];
  provided: Scalars['Int'];
  recentActivity: Array<CareBenefitUsage>;
  sources: BenefitSource;
  used: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  AppointmentNoteTemplate: Array<AppointmentNoteTemplate>;
  AppointmentRecapNotesUpdated: Array<Appointment>;
  EmailCampaign: Array<EmailCampaign>;
  EmailCampaignTemplate: Array<EmailCampaignTemplate>;
  EmailCampaignUpdated: Array<EmailCampaign>;
  EmailCampaignsCreated: Array<EmailCampaign>;
  EmailCampaignsSent: Array<EmailCampaign>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id: Array<UserImpersonation>;
  UserImpersonation_UserToUserImpersonation_user_id: Array<UserImpersonation>;
  UserTaskList: Array<UserTaskList>;
  _count: UserCountOutputType;
  axionClinicUserConfigurations: Array<AxionClinicUserConfiguration>;
  blockedNumbers: Array<ClinicBlockedPhoneNumber>;
  boardFilters: Array<UserBoardFilter>;
  calls: Array<CallParticipant>;
  careBenefitUsageToInvoiceLineItems: Array<CareBenefitUsageToInvoiceLineItem>;
  channelCreationSources: Array<ChannelCreationSource>;
  channelMembers: Array<ChannelMember>;
  channelMessageReactions: Array<ChannelMessageReaction>;
  channelMessagesWithMentions: Array<ChannelMessage>;
  channelSelections: Array<ChannelSelection>;
  channelStatusChannelAssignees: Array<ChannelStatusChannelAssignee>;
  channelStatuses: Array<ChannelStatus>;
  channels: Array<Channel>;
  /** Test pet parents */
  clinicPetParents: Array<ClinicPetParent>;
  clinicUserFilters: Array<ClinicUserFilter>;
  clinicWidgetRequestTypes: Array<ClinicWidgetRequestType>;
  clinics: Array<Clinic>;
  /** @deprecated - 1.0 */
  clinicsId: Array<Clinic>;
  completedBenefitUsageFollowupSteps: Array<CareBenefitUsageFollowupStep>;
  computed_optimizedProfilePic?: Maybe<Scalars['String']>;
  /** @deprecated - 1.0 */
  consultationChats: Array<ConsultationChat>;
  createdAt: Scalars['DateTime'];
  createdPayoutBatchingPeriods: Array<PayoutBatchingPeriod>;
  crmId?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  email: Scalars['String'];
  emailTemplateVersions: Array<EmailTemplateVersion>;
  encryptedClinicUploads: Array<EncryptedClinicUpload>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions: Array<FormSubmission>;
  id: Scalars['String'];
  informNotificationRecipients: Array<InformNotificationRecipient>;
  informPartnerProgramEnrollmentTermsAcceptances: Array<InformPartnerProgramEnrollment>;
  informPrimaryContactClinicSettings: Array<ClinicSetting>;
  intitiatedLoyaltyAccountMerges: Array<LoyaltyAccountMerger>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations: Array<User>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<User>;
  invitedById?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired: Scalars['Boolean'];
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers: Array<ClinicPhoneNumber>;
  loyaltyPointUserGrants: Array<LoyaltyPointUserGrant>;
  loyaltyRewardRedemptionActions: Array<LoyaltyRewardRedemptionHistoryEntry>;
  manuallySentAutomationRuns: Array<AutomationRun>;
  massTextAlerts: Array<MassTextAlert>;
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates: Array<MessageTemplate>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfo>;
  /** @deprecated - 1.0 */
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting: Array<PayoutBatchingSetting>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels: Array<ChannelPin>;
  pointOfContactEnrollmentSupportEvents: Array<EnrollmentSupportEvent>;
  profilePic?: Maybe<Scalars['String']>;
  recaps: Array<Recap>;
  refundsIssued: Array<StripeRefund>;
  requestedEnrollmentSupportEvents: Array<EnrollmentSupportEvent>;
  responderEnrollmentSupportEvents: Array<EnrollmentSupportEvent>;
  /** @deprecated - 1.0 */
  reviews: Array<Review>;
  sentInvoices: Array<Invoice>;
  sentStripePaymentIntents: Array<StripePaymentIntent>;
  sentTrupanionExamDayOffers: Array<SentTrupanionExamDayOffer>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks: Array<Task>;
  triggeredWritebacks: Array<PimsWritebackLogEntry>;
  type: UserType;
  unblockedNumbers: Array<ClinicBlockedPhoneNumber>;
  updatedAt: Scalars['DateTime'];
  usagesRecorded: Array<CareBenefitUsage>;
  userAppointmentGroupings: Array<UserAppointmentGrouping>;
  userChannelFilterSelections: Array<UserChannelFilterSelection>;
  userSetting?: Maybe<UserSetting>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices: Array<CanonicalService>;
  vetInfo?: Maybe<VetInfo>;
  vetInfoId?: Maybe<Scalars['String']>;
};


export type UserAppointmentNoteTemplateArgs = {
  cursor?: Maybe<AppointmentNoteTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentNoteTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentNoteTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentNoteTemplateWhereInput>;
};


export type UserAppointmentRecapNotesUpdatedArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type UserEmailCampaignArgs = {
  cursor?: Maybe<EmailCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignWhereInput>;
};


export type UserEmailCampaignTemplateArgs = {
  cursor?: Maybe<EmailCampaignTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignTemplateWhereInput>;
};


export type UserEmailCampaignUpdatedArgs = {
  cursor?: Maybe<EmailCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignWhereInput>;
};


export type UserEmailCampaignsCreatedArgs = {
  cursor?: Maybe<EmailCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignWhereInput>;
};


export type UserEmailCampaignsSentArgs = {
  cursor?: Maybe<EmailCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailCampaignWhereInput>;
};


export type UserUserImpersonation_UserToUserImpersonation_Impersonated_User_IdArgs = {
  cursor?: Maybe<UserImpersonationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserImpersonationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserImpersonationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserImpersonationWhereInput>;
};


export type UserUserImpersonation_UserToUserImpersonation_User_IdArgs = {
  cursor?: Maybe<UserImpersonationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserImpersonationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserImpersonationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserImpersonationWhereInput>;
};


export type UserUserTaskListArgs = {
  cursor?: Maybe<UserTaskListWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserTaskListScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserTaskListOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserTaskListWhereInput>;
};


export type UserAxionClinicUserConfigurationsArgs = {
  cursor?: Maybe<AxionClinicUserConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AxionClinicUserConfigurationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AxionClinicUserConfigurationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AxionClinicUserConfigurationWhereInput>;
};


export type UserBlockedNumbersArgs = {
  cursor?: Maybe<ClinicBlockedPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
};


export type UserBoardFiltersArgs = {
  cursor?: Maybe<UserBoardFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserBoardFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserBoardFilterOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserBoardFilterWhereInput>;
};


export type UserCallsArgs = {
  cursor?: Maybe<CallParticipantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CallParticipantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CallParticipantOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CallParticipantWhereInput>;
};


export type UserCareBenefitUsageToInvoiceLineItemsArgs = {
  cursor?: Maybe<CareBenefitUsageToInvoiceLineItemWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageToInvoiceLineItemOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageToInvoiceLineItemWhereInput>;
};


export type UserChannelCreationSourcesArgs = {
  cursor?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelCreationSourceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelCreationSourceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type UserChannelMembersArgs = {
  cursor?: Maybe<ChannelMemberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMemberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMemberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMemberWhereInput>;
};


export type UserChannelMessageReactionsArgs = {
  cursor?: Maybe<ChannelMessageReactionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageReactionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageReactionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageReactionWhereInput>;
};


export type UserChannelMessagesWithMentionsArgs = {
  cursor?: Maybe<ChannelMessageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelMessageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelMessageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelMessageWhereInput>;
};


export type UserChannelSelectionsArgs = {
  cursor?: Maybe<ChannelSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelSelectionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelSelectionWhereInput>;
};


export type UserChannelStatusChannelAssigneesArgs = {
  cursor?: Maybe<ChannelStatusChannelAssigneeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusChannelAssigneeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusChannelAssigneeWhereInput>;
};


export type UserChannelStatusesArgs = {
  cursor?: Maybe<ChannelStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelStatusWhereInput>;
};


export type UserChannelsArgs = {
  cursor?: Maybe<ChannelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelWhereInput>;
};


export type UserClinicPetParentsArgs = {
  cursor?: Maybe<ClinicPetParentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPetParentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPetParentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPetParentWhereInput>;
};


export type UserClinicUserFiltersArgs = {
  cursor?: Maybe<ClinicUserFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicUserFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicUserFilterOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicUserFilterWhereInput>;
};


export type UserClinicWidgetRequestTypesArgs = {
  cursor?: Maybe<ClinicWidgetRequestTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};


export type UserClinicsArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type UserClinicsIdArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type UserCompletedBenefitUsageFollowupStepsArgs = {
  cursor?: Maybe<CareBenefitUsageFollowupStepWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageFollowupStepScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageFollowupStepOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageFollowupStepWhereInput>;
};


export type UserConsultationChatsArgs = {
  cursor?: Maybe<ConsultationChatWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationChatScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationChatOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationChatWhereInput>;
};


export type UserCreatedPayoutBatchingPeriodsArgs = {
  cursor?: Maybe<PayoutBatchingPeriodWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingPeriodScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingPeriodOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingPeriodWhereInput>;
};


export type UserEmailTemplateVersionsArgs = {
  cursor?: Maybe<EmailTemplateVersionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EmailTemplateVersionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EmailTemplateVersionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EmailTemplateVersionWhereInput>;
};


export type UserEncryptedClinicUploadsArgs = {
  cursor?: Maybe<EncryptedClinicUploadWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EncryptedClinicUploadScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EncryptedClinicUploadOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EncryptedClinicUploadWhereInput>;
};


export type UserFormSubmissionsArgs = {
  cursor?: Maybe<FormSubmissionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormSubmissionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormSubmissionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormSubmissionWhereInput>;
};


export type UserInformNotificationRecipientsArgs = {
  cursor?: Maybe<InformNotificationRecipientWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformNotificationRecipientScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformNotificationRecipientOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformNotificationRecipientWhereInput>;
};


export type UserInformPartnerProgramEnrollmentTermsAcceptancesArgs = {
  cursor?: Maybe<InformPartnerProgramEnrollmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformPartnerProgramEnrollmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformPartnerProgramEnrollmentWhereInput>;
};


export type UserInformPrimaryContactClinicSettingsArgs = {
  cursor?: Maybe<ClinicSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicSettingWhereInput>;
};


export type UserIntitiatedLoyaltyAccountMergesArgs = {
  cursor?: Maybe<LoyaltyAccountMergerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyAccountMergerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyAccountMergerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyAccountMergerWhereInput>;
};


export type UserInvitationsArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type UserInvitedByArgs = {
  where?: Maybe<UserWhereInput>;
};


export type UserLoaSignedClinicPhoneNumbersArgs = {
  cursor?: Maybe<ClinicPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicPhoneNumberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicPhoneNumberWhereInput>;
};


export type UserLoyaltyPointUserGrantsArgs = {
  cursor?: Maybe<LoyaltyPointUserGrantWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyPointUserGrantScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyPointUserGrantOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyPointUserGrantWhereInput>;
};


export type UserLoyaltyRewardRedemptionActionsArgs = {
  cursor?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LoyaltyRewardRedemptionHistoryEntryWhereInput>;
};


export type UserManuallySentAutomationRunsArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type UserMassTextAlertsArgs = {
  cursor?: Maybe<MassTextAlertWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MassTextAlertScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MassTextAlertWhereInput>;
};


export type UserMediaArgs = {
  where?: Maybe<MediaWhereInput>;
};


export type UserMessageTemplatesArgs = {
  cursor?: Maybe<MessageTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<MessageTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<MessageTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MessageTemplateWhereInput>;
};


export type UserOwnerInfoArgs = {
  where?: Maybe<OwnerInfoWhereInput>;
};


export type UserPayoutBatchingSettingArgs = {
  cursor?: Maybe<PayoutBatchingSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PayoutBatchingSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PayoutBatchingSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PayoutBatchingSettingWhereInput>;
};


export type UserPinnedChannelsArgs = {
  cursor?: Maybe<ChannelPinWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelPinScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelPinOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelPinWhereInput>;
};


export type UserPointOfContactEnrollmentSupportEventsArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type UserRecapsArgs = {
  cursor?: Maybe<RecapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<RecapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<RecapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RecapWhereInput>;
};


export type UserRefundsIssuedArgs = {
  cursor?: Maybe<StripeRefundWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripeRefundScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripeRefundOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripeRefundWhereInput>;
};


export type UserRequestedEnrollmentSupportEventsArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type UserResponderEnrollmentSupportEventsArgs = {
  cursor?: Maybe<EnrollmentSupportEventWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<EnrollmentSupportEventScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<EnrollmentSupportEventOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnrollmentSupportEventWhereInput>;
};


export type UserReviewsArgs = {
  cursor?: Maybe<ReviewWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ReviewScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ReviewOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReviewWhereInput>;
};


export type UserSentInvoicesArgs = {
  cursor?: Maybe<InvoiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InvoiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InvoiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InvoiceWhereInput>;
};


export type UserSentStripePaymentIntentsArgs = {
  cursor?: Maybe<StripePaymentIntentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StripePaymentIntentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StripePaymentIntentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StripePaymentIntentWhereInput>;
};


export type UserSentTrupanionExamDayOffersArgs = {
  cursor?: Maybe<SentTrupanionExamDayOfferWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<SentTrupanionExamDayOfferScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<SentTrupanionExamDayOfferOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SentTrupanionExamDayOfferWhereInput>;
};


export type UserTasksArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<TaskScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<TaskOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TaskWhereInput>;
};


export type UserTriggeredWritebacksArgs = {
  cursor?: Maybe<PimsWritebackLogEntryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<PimsWritebackLogEntryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<PimsWritebackLogEntryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PimsWritebackLogEntryWhereInput>;
};


export type UserUnblockedNumbersArgs = {
  cursor?: Maybe<ClinicBlockedPhoneNumberWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicBlockedPhoneNumberOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
};


export type UserUsagesRecordedArgs = {
  cursor?: Maybe<CareBenefitUsageWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CareBenefitUsageScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CareBenefitUsageOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CareBenefitUsageWhereInput>;
};


export type UserUserAppointmentGroupingsArgs = {
  cursor?: Maybe<UserAppointmentGroupingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserAppointmentGroupingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserAppointmentGroupingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAppointmentGroupingWhereInput>;
};


export type UserUserChannelFilterSelectionsArgs = {
  cursor?: Maybe<UserChannelFilterSelectionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserChannelFilterSelectionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserChannelFilterSelectionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserChannelFilterSelectionWhereInput>;
};


export type UserUserSettingArgs = {
  where?: Maybe<UserSettingWhereInput>;
};


export type UserValidatedCanonicalServicesArgs = {
  cursor?: Maybe<CanonicalServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<CanonicalServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<CanonicalServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CanonicalServiceWhereInput>;
};


export type UserVetInfoArgs = {
  where?: Maybe<VetInfoWhereInput>;
};

export type UserAppointmentGrouping = {
  __typename?: 'UserAppointmentGrouping';
  _count: UserAppointmentGroupingCountOutputType;
  appointmentTypes: Array<AppointmentType>;
  clinic?: Maybe<Clinic>;
  clinicEmployees: Array<ClinicEmployee>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  label: Scalars['String'];
  rooms: Array<ClinicRoom>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};


export type UserAppointmentGroupingAppointmentTypesArgs = {
  cursor?: Maybe<AppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type UserAppointmentGroupingClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type UserAppointmentGroupingClinicEmployeesArgs = {
  cursor?: Maybe<ClinicEmployeeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeWhereInput>;
};


export type UserAppointmentGroupingRoomsArgs = {
  cursor?: Maybe<ClinicRoomWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicRoomScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicRoomOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicRoomWhereInput>;
};


export type UserAppointmentGroupingUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type UserAppointmentGroupingCountAggregateOutputType = {
  __typename?: 'UserAppointmentGroupingCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  label: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UserAppointmentGroupingCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserAppointmentGroupingCountOutputType = {
  __typename?: 'UserAppointmentGroupingCountOutputType';
  appointmentTypes: Scalars['Int'];
  clinicEmployees: Scalars['Int'];
  rooms: Scalars['Int'];
};

export type UserAppointmentGroupingCreateInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutUserAppointmentGroupingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutUserAppointmentGroupingsInput>;
};

export type UserAppointmentGroupingCreateManyClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingCreateManyClinicInputEnvelope = {
  data: Array<UserAppointmentGroupingCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserAppointmentGroupingCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingCreateManyUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserAppointmentGroupingCreateManyUserInputEnvelope = {
  data: Array<UserAppointmentGroupingCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserAppointmentGroupingCreateNestedManyWithoutAppointmentTypesInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutAppointmentTypesInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutAppointmentTypesInput>>;
};

export type UserAppointmentGroupingCreateNestedManyWithoutClinicEmployeesInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutClinicEmployeesInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutClinicEmployeesInput>>;
};

export type UserAppointmentGroupingCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutClinicInput>>;
  createMany?: Maybe<UserAppointmentGroupingCreateManyClinicInputEnvelope>;
};

export type UserAppointmentGroupingCreateNestedManyWithoutRoomsInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutRoomsInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutRoomsInput>>;
};

export type UserAppointmentGroupingCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutUserInput>>;
  createMany?: Maybe<UserAppointmentGroupingCreateManyUserInputEnvelope>;
};

export type UserAppointmentGroupingCreateOrConnectWithoutAppointmentTypesInput = {
  create: UserAppointmentGroupingCreateWithoutAppointmentTypesInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingCreateOrConnectWithoutClinicEmployeesInput = {
  create: UserAppointmentGroupingCreateWithoutClinicEmployeesInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingCreateOrConnectWithoutClinicInput = {
  create: UserAppointmentGroupingCreateWithoutClinicInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingCreateOrConnectWithoutRoomsInput = {
  create: UserAppointmentGroupingCreateWithoutRoomsInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingCreateOrConnectWithoutUserInput = {
  create: UserAppointmentGroupingCreateWithoutUserInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingCreateWithoutAppointmentTypesInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutUserAppointmentGroupingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutUserAppointmentGroupingsInput>;
};

export type UserAppointmentGroupingCreateWithoutClinicEmployeesInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutUserAppointmentGroupingsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutUserAppointmentGroupingsInput>;
};

export type UserAppointmentGroupingCreateWithoutClinicInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutUserAppointmentGroupingsInput>;
};

export type UserAppointmentGroupingCreateWithoutRoomsInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutUserAppointmentGroupingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutUserAppointmentGroupingsInput>;
};

export type UserAppointmentGroupingCreateWithoutUserInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutUserAppointmentGroupingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  rooms?: Maybe<ClinicRoomCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserAppointmentGroupingGroupByOutputType = {
  __typename?: 'UserAppointmentGroupingGroupByOutputType';
  _count?: Maybe<UserAppointmentGroupingCountAggregateOutputType>;
  _max?: Maybe<UserAppointmentGroupingMaxAggregateOutputType>;
  _min?: Maybe<UserAppointmentGroupingMinAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  label: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingListRelationFilter = {
  every?: Maybe<UserAppointmentGroupingWhereInput>;
  none?: Maybe<UserAppointmentGroupingWhereInput>;
  some?: Maybe<UserAppointmentGroupingWhereInput>;
};

export type UserAppointmentGroupingMaxAggregateOutputType = {
  __typename?: 'UserAppointmentGroupingMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserAppointmentGroupingMinAggregateOutputType = {
  __typename?: 'UserAppointmentGroupingMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserAppointmentGroupingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserAppointmentGroupingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserAppointmentGroupingOrderByRelevanceInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployees?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  rooms?: Maybe<ClinicRoomOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum UserAppointmentGroupingOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  Label = 'label',
  UserId = 'userId'
}

export type UserAppointmentGroupingOrderByRelevanceInput = {
  fields: Array<UserAppointmentGroupingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UserAppointmentGroupingOrderByWithAggregationInput = {
  _count?: Maybe<UserAppointmentGroupingCountOrderByAggregateInput>;
  _max?: Maybe<UserAppointmentGroupingMaxOrderByAggregateInput>;
  _min?: Maybe<UserAppointmentGroupingMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserAppointmentGroupingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserAppointmentGroupingOrderByRelevanceInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployees?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  rooms?: Maybe<ClinicRoomOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type UserAppointmentGroupingOrderByWithRelationInput = {
  _relevance?: Maybe<UserAppointmentGroupingOrderByRelevanceInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployees?: Maybe<ClinicEmployeeOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  rooms?: Maybe<ClinicRoomOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum UserAppointmentGroupingScalarFieldEnum {
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Label = 'label',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type UserAppointmentGroupingScalarWhereInput = {
  AND?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  NOT?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  OR?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  label?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type UserAppointmentGroupingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserAppointmentGroupingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UserAppointmentGroupingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserAppointmentGroupingScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  label?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type UserAppointmentGroupingUncheckedCreateInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedCreateNestedManyWithoutAppointmentTypesInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutAppointmentTypesInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutAppointmentTypesInput>>;
};

export type UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicEmployeesInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutClinicEmployeesInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutClinicEmployeesInput>>;
};

export type UserAppointmentGroupingUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutClinicInput>>;
  createMany?: Maybe<UserAppointmentGroupingCreateManyClinicInputEnvelope>;
};

export type UserAppointmentGroupingUncheckedCreateNestedManyWithoutRoomsInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutRoomsInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutRoomsInput>>;
};

export type UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutUserInput>>;
  createMany?: Maybe<UserAppointmentGroupingCreateManyUserInputEnvelope>;
};

export type UserAppointmentGroupingUncheckedCreateWithoutAppointmentTypesInput = {
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedCreateWithoutClinicEmployeesInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedCreateWithoutClinicInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedCreateWithoutRoomsInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedCreateWithoutUserInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  rooms?: Maybe<ClinicRoomUncheckedCreateNestedManyWithoutUserAppointmentGroupingsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserAppointmentGroupingUncheckedUpdateInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedUpdateManyWithoutAppointmentTypesNestedInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutAppointmentTypesInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutAppointmentTypesInput>>;
  delete?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  set?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  update?: Maybe<Array<UserAppointmentGroupingUpdateWithWhereUniqueWithoutAppointmentTypesInput>>;
  updateMany?: Maybe<Array<UserAppointmentGroupingUpdateManyWithWhereWithoutAppointmentTypesInput>>;
  upsert?: Maybe<Array<UserAppointmentGroupingUpsertWithWhereUniqueWithoutAppointmentTypesInput>>;
};

export type UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedUpdateManyWithoutClinicEmployeesNestedInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutClinicEmployeesInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutClinicEmployeesInput>>;
  delete?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  set?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  update?: Maybe<Array<UserAppointmentGroupingUpdateWithWhereUniqueWithoutClinicEmployeesInput>>;
  updateMany?: Maybe<Array<UserAppointmentGroupingUpdateManyWithWhereWithoutClinicEmployeesInput>>;
  upsert?: Maybe<Array<UserAppointmentGroupingUpsertWithWhereUniqueWithoutClinicEmployeesInput>>;
};

export type UserAppointmentGroupingUncheckedUpdateManyWithoutClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutClinicInput>>;
  createMany?: Maybe<UserAppointmentGroupingCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  set?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  update?: Maybe<Array<UserAppointmentGroupingUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<UserAppointmentGroupingUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<UserAppointmentGroupingUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type UserAppointmentGroupingUncheckedUpdateManyWithoutRoomsInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedUpdateManyWithoutRoomsNestedInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutRoomsInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutRoomsInput>>;
  delete?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  set?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  update?: Maybe<Array<UserAppointmentGroupingUpdateWithWhereUniqueWithoutRoomsInput>>;
  updateMany?: Maybe<Array<UserAppointmentGroupingUpdateManyWithWhereWithoutRoomsInput>>;
  upsert?: Maybe<Array<UserAppointmentGroupingUpsertWithWhereUniqueWithoutRoomsInput>>;
};

export type UserAppointmentGroupingUncheckedUpdateManyWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutUserInput>>;
  createMany?: Maybe<UserAppointmentGroupingCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  set?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  update?: Maybe<Array<UserAppointmentGroupingUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<UserAppointmentGroupingUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<UserAppointmentGroupingUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserAppointmentGroupingUncheckedUpdateWithoutAppointmentTypesInput = {
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedUpdateWithoutClinicEmployeesInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedUpdateWithoutClinicInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedUpdateWithoutRoomsInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserAppointmentGroupingUncheckedUpdateWithoutUserInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  rooms?: Maybe<ClinicRoomUncheckedUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserAppointmentGroupingUpdateInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutUserAppointmentGroupingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutUserAppointmentGroupingsNestedInput>;
};

export type UserAppointmentGroupingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserAppointmentGroupingUpdateManyWithWhereWithoutAppointmentTypesInput = {
  data: UserAppointmentGroupingUpdateManyMutationInput;
  where: UserAppointmentGroupingScalarWhereInput;
};

export type UserAppointmentGroupingUpdateManyWithWhereWithoutClinicEmployeesInput = {
  data: UserAppointmentGroupingUpdateManyMutationInput;
  where: UserAppointmentGroupingScalarWhereInput;
};

export type UserAppointmentGroupingUpdateManyWithWhereWithoutClinicInput = {
  data: UserAppointmentGroupingUpdateManyMutationInput;
  where: UserAppointmentGroupingScalarWhereInput;
};

export type UserAppointmentGroupingUpdateManyWithWhereWithoutRoomsInput = {
  data: UserAppointmentGroupingUpdateManyMutationInput;
  where: UserAppointmentGroupingScalarWhereInput;
};

export type UserAppointmentGroupingUpdateManyWithWhereWithoutUserInput = {
  data: UserAppointmentGroupingUpdateManyMutationInput;
  where: UserAppointmentGroupingScalarWhereInput;
};

export type UserAppointmentGroupingUpdateManyWithoutAppointmentTypesNestedInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutAppointmentTypesInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutAppointmentTypesInput>>;
  delete?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  set?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  update?: Maybe<Array<UserAppointmentGroupingUpdateWithWhereUniqueWithoutAppointmentTypesInput>>;
  updateMany?: Maybe<Array<UserAppointmentGroupingUpdateManyWithWhereWithoutAppointmentTypesInput>>;
  upsert?: Maybe<Array<UserAppointmentGroupingUpsertWithWhereUniqueWithoutAppointmentTypesInput>>;
};

export type UserAppointmentGroupingUpdateManyWithoutClinicEmployeesNestedInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutClinicEmployeesInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutClinicEmployeesInput>>;
  delete?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  set?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  update?: Maybe<Array<UserAppointmentGroupingUpdateWithWhereUniqueWithoutClinicEmployeesInput>>;
  updateMany?: Maybe<Array<UserAppointmentGroupingUpdateManyWithWhereWithoutClinicEmployeesInput>>;
  upsert?: Maybe<Array<UserAppointmentGroupingUpsertWithWhereUniqueWithoutClinicEmployeesInput>>;
};

export type UserAppointmentGroupingUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutClinicInput>>;
  createMany?: Maybe<UserAppointmentGroupingCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  set?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  update?: Maybe<Array<UserAppointmentGroupingUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<UserAppointmentGroupingUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<UserAppointmentGroupingUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type UserAppointmentGroupingUpdateManyWithoutRoomsNestedInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutRoomsInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutRoomsInput>>;
  delete?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  set?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  update?: Maybe<Array<UserAppointmentGroupingUpdateWithWhereUniqueWithoutRoomsInput>>;
  updateMany?: Maybe<Array<UserAppointmentGroupingUpdateManyWithWhereWithoutRoomsInput>>;
  upsert?: Maybe<Array<UserAppointmentGroupingUpsertWithWhereUniqueWithoutRoomsInput>>;
};

export type UserAppointmentGroupingUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAppointmentGroupingCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserAppointmentGroupingCreateWithoutUserInput>>;
  createMany?: Maybe<UserAppointmentGroupingCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAppointmentGroupingScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  set?: Maybe<Array<UserAppointmentGroupingWhereUniqueInput>>;
  update?: Maybe<Array<UserAppointmentGroupingUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<UserAppointmentGroupingUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<UserAppointmentGroupingUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserAppointmentGroupingUpdateWithWhereUniqueWithoutAppointmentTypesInput = {
  data: UserAppointmentGroupingUpdateWithoutAppointmentTypesInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingUpdateWithWhereUniqueWithoutClinicEmployeesInput = {
  data: UserAppointmentGroupingUpdateWithoutClinicEmployeesInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingUpdateWithWhereUniqueWithoutClinicInput = {
  data: UserAppointmentGroupingUpdateWithoutClinicInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingUpdateWithWhereUniqueWithoutRoomsInput = {
  data: UserAppointmentGroupingUpdateWithoutRoomsInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingUpdateWithWhereUniqueWithoutUserInput = {
  data: UserAppointmentGroupingUpdateWithoutUserInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingUpdateWithoutAppointmentTypesInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutUserAppointmentGroupingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutUserAppointmentGroupingsNestedInput>;
};

export type UserAppointmentGroupingUpdateWithoutClinicEmployeesInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutUserAppointmentGroupingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutUserAppointmentGroupingsNestedInput>;
};

export type UserAppointmentGroupingUpdateWithoutClinicInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutUserAppointmentGroupingsNestedInput>;
};

export type UserAppointmentGroupingUpdateWithoutRoomsInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutUserAppointmentGroupingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutUserAppointmentGroupingsNestedInput>;
};

export type UserAppointmentGroupingUpdateWithoutUserInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  clinic?: Maybe<ClinicUpdateOneWithoutUserAppointmentGroupingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  rooms?: Maybe<ClinicRoomUpdateManyWithoutUserAppointmentGroupingsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserAppointmentGroupingUpsertWithWhereUniqueWithoutAppointmentTypesInput = {
  create: UserAppointmentGroupingCreateWithoutAppointmentTypesInput;
  update: UserAppointmentGroupingUpdateWithoutAppointmentTypesInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingUpsertWithWhereUniqueWithoutClinicEmployeesInput = {
  create: UserAppointmentGroupingCreateWithoutClinicEmployeesInput;
  update: UserAppointmentGroupingUpdateWithoutClinicEmployeesInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingUpsertWithWhereUniqueWithoutClinicInput = {
  create: UserAppointmentGroupingCreateWithoutClinicInput;
  update: UserAppointmentGroupingUpdateWithoutClinicInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingUpsertWithWhereUniqueWithoutRoomsInput = {
  create: UserAppointmentGroupingCreateWithoutRoomsInput;
  update: UserAppointmentGroupingUpdateWithoutRoomsInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingUpsertWithWhereUniqueWithoutUserInput = {
  create: UserAppointmentGroupingCreateWithoutUserInput;
  update: UserAppointmentGroupingUpdateWithoutUserInput;
  where: UserAppointmentGroupingWhereUniqueInput;
};

export type UserAppointmentGroupingWhereInput = {
  AND?: Maybe<Array<UserAppointmentGroupingWhereInput>>;
  NOT?: Maybe<Array<UserAppointmentGroupingWhereInput>>;
  OR?: Maybe<Array<UserAppointmentGroupingWhereInput>>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  label?: Maybe<StringFilter>;
  rooms?: Maybe<ClinicRoomListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type UserAppointmentGroupingWhereUniqueInput = {
  AND?: Maybe<Array<UserAppointmentGroupingWhereInput>>;
  NOT?: Maybe<Array<UserAppointmentGroupingWhereInput>>;
  OR?: Maybe<Array<UserAppointmentGroupingWhereInput>>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<StringFilter>;
  rooms?: Maybe<ClinicRoomListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type UserBoardFilter = {
  __typename?: 'UserBoardFilter';
  _count: UserBoardFilterCountOutputType;
  columns: Array<BoardFilterColumn>;
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id: Scalars['String'];
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRange>;
  user: User;
  userId: Scalars['String'];
};


export type UserBoardFilterColumnsArgs = {
  cursor?: Maybe<BoardFilterColumnWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<BoardFilterColumnScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<BoardFilterColumnOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BoardFilterColumnWhereInput>;
};


export type UserBoardFilterSpecificDateRangeArgs = {
  where?: Maybe<BoardFilterSpecificDateRangeWhereInput>;
};

export type UserBoardFilterCountAggregateOutputType = {
  __typename?: 'UserBoardFilterCountAggregateOutputType';
  _all: Scalars['Int'];
  currentView: Scalars['Int'];
  dateRangeOption: Scalars['Int'];
  id: Scalars['Int'];
  shouldCollapseNoStatusColumn: Scalars['Int'];
  shouldHideEmptyColumns: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UserBoardFilterCountOrderByAggregateInput = {
  currentView?: Maybe<SortOrder>;
  dateRangeOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  shouldCollapseNoStatusColumn?: Maybe<SortOrder>;
  shouldHideEmptyColumns?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserBoardFilterCountOutputType = {
  __typename?: 'UserBoardFilterCountOutputType';
  columns: Scalars['Int'];
};

export type UserBoardFilterCreateInput = {
  columns?: Maybe<BoardFilterColumnCreateNestedManyWithoutUserBoardFilterInput>;
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeCreateNestedOneWithoutUserBoardFilterInput>;
  user: UserCreateNestedOneWithoutBoardFiltersInput;
};

export type UserBoardFilterCreateManyInput = {
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type UserBoardFilterCreateManyUserInput = {
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
};

export type UserBoardFilterCreateManyUserInputEnvelope = {
  data: Array<UserBoardFilterCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserBoardFilterCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<UserBoardFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserBoardFilterCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserBoardFilterCreateWithoutUserInput>>;
  createMany?: Maybe<UserBoardFilterCreateManyUserInputEnvelope>;
};

export type UserBoardFilterCreateNestedOneWithoutColumnsInput = {
  connect?: Maybe<UserBoardFilterWhereUniqueInput>;
  connectOrCreate?: Maybe<UserBoardFilterCreateOrConnectWithoutColumnsInput>;
  create?: Maybe<UserBoardFilterCreateWithoutColumnsInput>;
};

export type UserBoardFilterCreateNestedOneWithoutSpecificDateRangeInput = {
  connect?: Maybe<UserBoardFilterWhereUniqueInput>;
  connectOrCreate?: Maybe<UserBoardFilterCreateOrConnectWithoutSpecificDateRangeInput>;
  create?: Maybe<UserBoardFilterCreateWithoutSpecificDateRangeInput>;
};

export type UserBoardFilterCreateOrConnectWithoutColumnsInput = {
  create: UserBoardFilterCreateWithoutColumnsInput;
  where: UserBoardFilterWhereUniqueInput;
};

export type UserBoardFilterCreateOrConnectWithoutSpecificDateRangeInput = {
  create: UserBoardFilterCreateWithoutSpecificDateRangeInput;
  where: UserBoardFilterWhereUniqueInput;
};

export type UserBoardFilterCreateOrConnectWithoutUserInput = {
  create: UserBoardFilterCreateWithoutUserInput;
  where: UserBoardFilterWhereUniqueInput;
};

export type UserBoardFilterCreateWithoutColumnsInput = {
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeCreateNestedOneWithoutUserBoardFilterInput>;
  user: UserCreateNestedOneWithoutBoardFiltersInput;
};

export type UserBoardFilterCreateWithoutSpecificDateRangeInput = {
  columns?: Maybe<BoardFilterColumnCreateNestedManyWithoutUserBoardFilterInput>;
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  user: UserCreateNestedOneWithoutBoardFiltersInput;
};

export type UserBoardFilterCreateWithoutUserInput = {
  columns?: Maybe<BoardFilterColumnCreateNestedManyWithoutUserBoardFilterInput>;
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeCreateNestedOneWithoutUserBoardFilterInput>;
};

export type UserBoardFilterGroupByOutputType = {
  __typename?: 'UserBoardFilterGroupByOutputType';
  _count?: Maybe<UserBoardFilterCountAggregateOutputType>;
  _max?: Maybe<UserBoardFilterMaxAggregateOutputType>;
  _min?: Maybe<UserBoardFilterMinAggregateOutputType>;
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id: Scalars['String'];
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type UserBoardFilterListRelationFilter = {
  every?: Maybe<UserBoardFilterWhereInput>;
  none?: Maybe<UserBoardFilterWhereInput>;
  some?: Maybe<UserBoardFilterWhereInput>;
};

export type UserBoardFilterMaxAggregateOutputType = {
  __typename?: 'UserBoardFilterMaxAggregateOutputType';
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserBoardFilterMaxOrderByAggregateInput = {
  currentView?: Maybe<SortOrder>;
  dateRangeOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  shouldCollapseNoStatusColumn?: Maybe<SortOrder>;
  shouldHideEmptyColumns?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserBoardFilterMinAggregateOutputType = {
  __typename?: 'UserBoardFilterMinAggregateOutputType';
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserBoardFilterMinOrderByAggregateInput = {
  currentView?: Maybe<SortOrder>;
  dateRangeOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  shouldCollapseNoStatusColumn?: Maybe<SortOrder>;
  shouldHideEmptyColumns?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserBoardFilterNullableScalarRelationFilter = {
  AND?: Maybe<Array<UserBoardFilterWhereInput>>;
  NOT?: Maybe<Array<UserBoardFilterWhereInput>>;
  OR?: Maybe<Array<UserBoardFilterWhereInput>>;
  columns?: Maybe<BoardFilterColumnListRelationFilter>;
  currentView?: Maybe<EnumBoardFilterViewFilter>;
  dateRangeOption?: Maybe<EnumBoardFilterDateRangeNullableFilter>;
  id?: Maybe<StringFilter>;
  shouldCollapseNoStatusColumn?: Maybe<BoolNullableFilter>;
  shouldHideEmptyColumns?: Maybe<BoolNullableFilter>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeNullableScalarRelationFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type UserBoardFilterOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserBoardFilterOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserBoardFilterOrderByRelevanceInput>;
  columns?: Maybe<BoardFilterColumnOrderByRelationAggregateInput>;
  currentView?: Maybe<SortOrder>;
  dateRangeOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  shouldCollapseNoStatusColumn?: Maybe<SortOrder>;
  shouldHideEmptyColumns?: Maybe<SortOrder>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeOrderByWithRelationInput>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum UserBoardFilterOrderByRelevanceFieldEnum {
  Id = 'id',
  UserId = 'userId'
}

export type UserBoardFilterOrderByRelevanceInput = {
  fields: Array<UserBoardFilterOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UserBoardFilterOrderByWithAggregationInput = {
  _count?: Maybe<UserBoardFilterCountOrderByAggregateInput>;
  _max?: Maybe<UserBoardFilterMaxOrderByAggregateInput>;
  _min?: Maybe<UserBoardFilterMinOrderByAggregateInput>;
  currentView?: Maybe<SortOrder>;
  dateRangeOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  shouldCollapseNoStatusColumn?: Maybe<SortOrder>;
  shouldHideEmptyColumns?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserBoardFilterOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserBoardFilterOrderByRelevanceInput>;
  columns?: Maybe<BoardFilterColumnOrderByRelationAggregateInput>;
  currentView?: Maybe<SortOrder>;
  dateRangeOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  shouldCollapseNoStatusColumn?: Maybe<SortOrder>;
  shouldHideEmptyColumns?: Maybe<SortOrder>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeOrderByWithRelationInput>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type UserBoardFilterOrderByWithRelationInput = {
  _relevance?: Maybe<UserBoardFilterOrderByRelevanceInput>;
  columns?: Maybe<BoardFilterColumnOrderByRelationAggregateInput>;
  currentView?: Maybe<SortOrder>;
  dateRangeOption?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  shouldCollapseNoStatusColumn?: Maybe<SortOrder>;
  shouldHideEmptyColumns?: Maybe<SortOrder>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeOrderByWithRelationInput>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum UserBoardFilterScalarFieldEnum {
  CurrentView = 'currentView',
  DateRangeOption = 'dateRangeOption',
  Id = 'id',
  ShouldCollapseNoStatusColumn = 'shouldCollapseNoStatusColumn',
  ShouldHideEmptyColumns = 'shouldHideEmptyColumns',
  UserId = 'userId'
}

export type UserBoardFilterScalarWhereInput = {
  AND?: Maybe<Array<UserBoardFilterScalarWhereInput>>;
  NOT?: Maybe<Array<UserBoardFilterScalarWhereInput>>;
  OR?: Maybe<Array<UserBoardFilterScalarWhereInput>>;
  currentView?: Maybe<EnumBoardFilterViewFilter>;
  dateRangeOption?: Maybe<EnumBoardFilterDateRangeNullableFilter>;
  id?: Maybe<StringFilter>;
  shouldCollapseNoStatusColumn?: Maybe<BoolNullableFilter>;
  shouldHideEmptyColumns?: Maybe<BoolNullableFilter>;
  userId?: Maybe<StringFilter>;
};

export type UserBoardFilterScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserBoardFilterScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UserBoardFilterScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserBoardFilterScalarWhereWithAggregatesInput>>;
  currentView?: Maybe<EnumBoardFilterViewWithAggregatesFilter>;
  dateRangeOption?: Maybe<EnumBoardFilterDateRangeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  shouldCollapseNoStatusColumn?: Maybe<BoolNullableWithAggregatesFilter>;
  shouldHideEmptyColumns?: Maybe<BoolNullableWithAggregatesFilter>;
  userId?: Maybe<StringWithAggregatesFilter>;
};

export type UserBoardFilterUncheckedCreateInput = {
  columns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutUserBoardFilterInput>;
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeUncheckedCreateNestedOneWithoutUserBoardFilterInput>;
  userId: Scalars['String'];
};

export type UserBoardFilterUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<UserBoardFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserBoardFilterCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserBoardFilterCreateWithoutUserInput>>;
  createMany?: Maybe<UserBoardFilterCreateManyUserInputEnvelope>;
};

export type UserBoardFilterUncheckedCreateWithoutColumnsInput = {
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeUncheckedCreateNestedOneWithoutUserBoardFilterInput>;
  userId: Scalars['String'];
};

export type UserBoardFilterUncheckedCreateWithoutSpecificDateRangeInput = {
  columns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutUserBoardFilterInput>;
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type UserBoardFilterUncheckedCreateWithoutUserInput = {
  columns?: Maybe<BoardFilterColumnUncheckedCreateNestedManyWithoutUserBoardFilterInput>;
  currentView: BoardFilterView;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeUncheckedCreateNestedOneWithoutUserBoardFilterInput>;
};

export type UserBoardFilterUncheckedUpdateInput = {
  columns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutUserBoardFilterNestedInput>;
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeUncheckedUpdateOneWithoutUserBoardFilterNestedInput>;
  userId?: Maybe<Scalars['String']>;
};

export type UserBoardFilterUncheckedUpdateManyInput = {
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserBoardFilterUncheckedUpdateManyWithoutUserInput = {
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
};

export type UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<UserBoardFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserBoardFilterCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserBoardFilterCreateWithoutUserInput>>;
  createMany?: Maybe<UserBoardFilterCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<UserBoardFilterWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserBoardFilterScalarWhereInput>>;
  disconnect?: Maybe<Array<UserBoardFilterWhereUniqueInput>>;
  set?: Maybe<Array<UserBoardFilterWhereUniqueInput>>;
  update?: Maybe<Array<UserBoardFilterUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<UserBoardFilterUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<UserBoardFilterUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserBoardFilterUncheckedUpdateWithoutColumnsInput = {
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeUncheckedUpdateOneWithoutUserBoardFilterNestedInput>;
  userId?: Maybe<Scalars['String']>;
};

export type UserBoardFilterUncheckedUpdateWithoutSpecificDateRangeInput = {
  columns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutUserBoardFilterNestedInput>;
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserBoardFilterUncheckedUpdateWithoutUserInput = {
  columns?: Maybe<BoardFilterColumnUncheckedUpdateManyWithoutUserBoardFilterNestedInput>;
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeUncheckedUpdateOneWithoutUserBoardFilterNestedInput>;
};

export type UserBoardFilterUpdateInput = {
  columns?: Maybe<BoardFilterColumnUpdateManyWithoutUserBoardFilterNestedInput>;
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeUpdateOneWithoutUserBoardFilterNestedInput>;
  user?: Maybe<UserUpdateOneRequiredWithoutBoardFiltersNestedInput>;
};

export type UserBoardFilterUpdateManyMutationInput = {
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
};

export type UserBoardFilterUpdateManyWithWhereWithoutUserInput = {
  data: UserBoardFilterUpdateManyMutationInput;
  where: UserBoardFilterScalarWhereInput;
};

export type UserBoardFilterUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<UserBoardFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserBoardFilterCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserBoardFilterCreateWithoutUserInput>>;
  createMany?: Maybe<UserBoardFilterCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<UserBoardFilterWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserBoardFilterScalarWhereInput>>;
  disconnect?: Maybe<Array<UserBoardFilterWhereUniqueInput>>;
  set?: Maybe<Array<UserBoardFilterWhereUniqueInput>>;
  update?: Maybe<Array<UserBoardFilterUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<UserBoardFilterUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<UserBoardFilterUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserBoardFilterUpdateOneWithoutColumnsNestedInput = {
  connect?: Maybe<UserBoardFilterWhereUniqueInput>;
  connectOrCreate?: Maybe<UserBoardFilterCreateOrConnectWithoutColumnsInput>;
  create?: Maybe<UserBoardFilterCreateWithoutColumnsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserBoardFilterUpdateToOneWithWhereWithoutColumnsInput>;
  upsert?: Maybe<UserBoardFilterUpsertWithoutColumnsInput>;
};

export type UserBoardFilterUpdateOneWithoutSpecificDateRangeNestedInput = {
  connect?: Maybe<UserBoardFilterWhereUniqueInput>;
  connectOrCreate?: Maybe<UserBoardFilterCreateOrConnectWithoutSpecificDateRangeInput>;
  create?: Maybe<UserBoardFilterCreateWithoutSpecificDateRangeInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserBoardFilterUpdateToOneWithWhereWithoutSpecificDateRangeInput>;
  upsert?: Maybe<UserBoardFilterUpsertWithoutSpecificDateRangeInput>;
};

export type UserBoardFilterUpdateToOneWithWhereWithoutColumnsInput = {
  data: UserBoardFilterUpdateWithoutColumnsInput;
  where?: Maybe<UserBoardFilterWhereInput>;
};

export type UserBoardFilterUpdateToOneWithWhereWithoutSpecificDateRangeInput = {
  data: UserBoardFilterUpdateWithoutSpecificDateRangeInput;
  where?: Maybe<UserBoardFilterWhereInput>;
};

export type UserBoardFilterUpdateWithWhereUniqueWithoutUserInput = {
  data: UserBoardFilterUpdateWithoutUserInput;
  where: UserBoardFilterWhereUniqueInput;
};

export type UserBoardFilterUpdateWithoutColumnsInput = {
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeUpdateOneWithoutUserBoardFilterNestedInput>;
  user?: Maybe<UserUpdateOneRequiredWithoutBoardFiltersNestedInput>;
};

export type UserBoardFilterUpdateWithoutSpecificDateRangeInput = {
  columns?: Maybe<BoardFilterColumnUpdateManyWithoutUserBoardFilterNestedInput>;
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateOneRequiredWithoutBoardFiltersNestedInput>;
};

export type UserBoardFilterUpdateWithoutUserInput = {
  columns?: Maybe<BoardFilterColumnUpdateManyWithoutUserBoardFilterNestedInput>;
  currentView?: Maybe<BoardFilterView>;
  dateRangeOption?: Maybe<BoardFilterDateRange>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<Scalars['Boolean']>;
  shouldHideEmptyColumns?: Maybe<Scalars['Boolean']>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeUpdateOneWithoutUserBoardFilterNestedInput>;
};

export type UserBoardFilterUpsertWithWhereUniqueWithoutUserInput = {
  create: UserBoardFilterCreateWithoutUserInput;
  update: UserBoardFilterUpdateWithoutUserInput;
  where: UserBoardFilterWhereUniqueInput;
};

export type UserBoardFilterUpsertWithoutColumnsInput = {
  create: UserBoardFilterCreateWithoutColumnsInput;
  update: UserBoardFilterUpdateWithoutColumnsInput;
  where?: Maybe<UserBoardFilterWhereInput>;
};

export type UserBoardFilterUpsertWithoutSpecificDateRangeInput = {
  create: UserBoardFilterCreateWithoutSpecificDateRangeInput;
  update: UserBoardFilterUpdateWithoutSpecificDateRangeInput;
  where?: Maybe<UserBoardFilterWhereInput>;
};

export type UserBoardFilterWhereInput = {
  AND?: Maybe<Array<UserBoardFilterWhereInput>>;
  NOT?: Maybe<Array<UserBoardFilterWhereInput>>;
  OR?: Maybe<Array<UserBoardFilterWhereInput>>;
  columns?: Maybe<BoardFilterColumnListRelationFilter>;
  currentView?: Maybe<EnumBoardFilterViewFilter>;
  dateRangeOption?: Maybe<EnumBoardFilterDateRangeNullableFilter>;
  id?: Maybe<StringFilter>;
  shouldCollapseNoStatusColumn?: Maybe<BoolNullableFilter>;
  shouldHideEmptyColumns?: Maybe<BoolNullableFilter>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeNullableScalarRelationFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type UserBoardFilterWhereUniqueInput = {
  AND?: Maybe<Array<UserBoardFilterWhereInput>>;
  NOT?: Maybe<Array<UserBoardFilterWhereInput>>;
  OR?: Maybe<Array<UserBoardFilterWhereInput>>;
  columns?: Maybe<BoardFilterColumnListRelationFilter>;
  currentView?: Maybe<EnumBoardFilterViewFilter>;
  dateRangeOption?: Maybe<EnumBoardFilterDateRangeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  shouldCollapseNoStatusColumn?: Maybe<BoolNullableFilter>;
  shouldHideEmptyColumns?: Maybe<BoolNullableFilter>;
  specificDateRange?: Maybe<BoardFilterSpecificDateRangeNullableScalarRelationFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type UserChannelFilterSelection = {
  __typename?: 'UserChannelFilterSelection';
  filterSelection: ChannelFilterSelection;
  filterSelectionId: Scalars['String'];
  id: Scalars['String'];
  isFilterOwner: Scalars['Boolean'];
  user: User;
  userId: Scalars['String'];
};

export type UserChannelFilterSelectionCountAggregateOutputType = {
  __typename?: 'UserChannelFilterSelectionCountAggregateOutputType';
  _all: Scalars['Int'];
  filterSelectionId: Scalars['Int'];
  id: Scalars['Int'];
  isFilterOwner: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UserChannelFilterSelectionCountOrderByAggregateInput = {
  filterSelectionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isFilterOwner?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserChannelFilterSelectionCreateInput = {
  filterSelection: ChannelFilterSelectionCreateNestedOneWithoutUserChannelFilterSelectionsInput;
  id?: Maybe<Scalars['String']>;
  isFilterOwner: Scalars['Boolean'];
  user: UserCreateNestedOneWithoutUserChannelFilterSelectionsInput;
};

export type UserChannelFilterSelectionCreateManyFilterSelectionInput = {
  id?: Maybe<Scalars['String']>;
  isFilterOwner: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type UserChannelFilterSelectionCreateManyFilterSelectionInputEnvelope = {
  data: Array<UserChannelFilterSelectionCreateManyFilterSelectionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserChannelFilterSelectionCreateManyInput = {
  filterSelectionId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isFilterOwner: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type UserChannelFilterSelectionCreateManyUserInput = {
  filterSelectionId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isFilterOwner: Scalars['Boolean'];
};

export type UserChannelFilterSelectionCreateManyUserInputEnvelope = {
  data: Array<UserChannelFilterSelectionCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserChannelFilterSelectionCreateNestedManyWithoutFilterSelectionInput = {
  connect?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserChannelFilterSelectionCreateOrConnectWithoutFilterSelectionInput>>;
  create?: Maybe<Array<UserChannelFilterSelectionCreateWithoutFilterSelectionInput>>;
  createMany?: Maybe<UserChannelFilterSelectionCreateManyFilterSelectionInputEnvelope>;
};

export type UserChannelFilterSelectionCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserChannelFilterSelectionCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserChannelFilterSelectionCreateWithoutUserInput>>;
  createMany?: Maybe<UserChannelFilterSelectionCreateManyUserInputEnvelope>;
};

export type UserChannelFilterSelectionCreateOrConnectWithoutFilterSelectionInput = {
  create: UserChannelFilterSelectionCreateWithoutFilterSelectionInput;
  where: UserChannelFilterSelectionWhereUniqueInput;
};

export type UserChannelFilterSelectionCreateOrConnectWithoutUserInput = {
  create: UserChannelFilterSelectionCreateWithoutUserInput;
  where: UserChannelFilterSelectionWhereUniqueInput;
};

export type UserChannelFilterSelectionCreateWithoutFilterSelectionInput = {
  id?: Maybe<Scalars['String']>;
  isFilterOwner: Scalars['Boolean'];
  user: UserCreateNestedOneWithoutUserChannelFilterSelectionsInput;
};

export type UserChannelFilterSelectionCreateWithoutUserInput = {
  filterSelection: ChannelFilterSelectionCreateNestedOneWithoutUserChannelFilterSelectionsInput;
  id?: Maybe<Scalars['String']>;
  isFilterOwner: Scalars['Boolean'];
};

export type UserChannelFilterSelectionGroupByOutputType = {
  __typename?: 'UserChannelFilterSelectionGroupByOutputType';
  _count?: Maybe<UserChannelFilterSelectionCountAggregateOutputType>;
  _max?: Maybe<UserChannelFilterSelectionMaxAggregateOutputType>;
  _min?: Maybe<UserChannelFilterSelectionMinAggregateOutputType>;
  filterSelectionId: Scalars['String'];
  id: Scalars['String'];
  isFilterOwner: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type UserChannelFilterSelectionListRelationFilter = {
  every?: Maybe<UserChannelFilterSelectionWhereInput>;
  none?: Maybe<UserChannelFilterSelectionWhereInput>;
  some?: Maybe<UserChannelFilterSelectionWhereInput>;
};

export type UserChannelFilterSelectionMaxAggregateOutputType = {
  __typename?: 'UserChannelFilterSelectionMaxAggregateOutputType';
  filterSelectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserChannelFilterSelectionMaxOrderByAggregateInput = {
  filterSelectionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isFilterOwner?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserChannelFilterSelectionMinAggregateOutputType = {
  __typename?: 'UserChannelFilterSelectionMinAggregateOutputType';
  filterSelectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserChannelFilterSelectionMinOrderByAggregateInput = {
  filterSelectionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isFilterOwner?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserChannelFilterSelectionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserChannelFilterSelectionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserChannelFilterSelectionOrderByRelevanceInput>;
  filterSelection?: Maybe<ChannelFilterSelectionOrderByWithRelationInput>;
  filterSelectionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isFilterOwner?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum UserChannelFilterSelectionOrderByRelevanceFieldEnum {
  FilterSelectionId = 'filterSelectionId',
  Id = 'id',
  UserId = 'userId'
}

export type UserChannelFilterSelectionOrderByRelevanceInput = {
  fields: Array<UserChannelFilterSelectionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UserChannelFilterSelectionOrderByWithAggregationInput = {
  _count?: Maybe<UserChannelFilterSelectionCountOrderByAggregateInput>;
  _max?: Maybe<UserChannelFilterSelectionMaxOrderByAggregateInput>;
  _min?: Maybe<UserChannelFilterSelectionMinOrderByAggregateInput>;
  filterSelectionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isFilterOwner?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserChannelFilterSelectionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserChannelFilterSelectionOrderByRelevanceInput>;
  filterSelection?: Maybe<ChannelFilterSelectionOrderByWithRelationInput>;
  filterSelectionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isFilterOwner?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type UserChannelFilterSelectionOrderByWithRelationInput = {
  _relevance?: Maybe<UserChannelFilterSelectionOrderByRelevanceInput>;
  filterSelection?: Maybe<ChannelFilterSelectionOrderByWithRelationInput>;
  filterSelectionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isFilterOwner?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum UserChannelFilterSelectionScalarFieldEnum {
  FilterSelectionId = 'filterSelectionId',
  Id = 'id',
  IsFilterOwner = 'isFilterOwner',
  UserId = 'userId'
}

export type UserChannelFilterSelectionScalarWhereInput = {
  AND?: Maybe<Array<UserChannelFilterSelectionScalarWhereInput>>;
  NOT?: Maybe<Array<UserChannelFilterSelectionScalarWhereInput>>;
  OR?: Maybe<Array<UserChannelFilterSelectionScalarWhereInput>>;
  filterSelectionId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  isFilterOwner?: Maybe<BoolFilter>;
  userId?: Maybe<StringFilter>;
};

export type UserChannelFilterSelectionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserChannelFilterSelectionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UserChannelFilterSelectionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserChannelFilterSelectionScalarWhereWithAggregatesInput>>;
  filterSelectionId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isFilterOwner?: Maybe<BoolWithAggregatesFilter>;
  userId?: Maybe<StringWithAggregatesFilter>;
};

export type UserChannelFilterSelectionUncheckedCreateInput = {
  filterSelectionId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isFilterOwner: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type UserChannelFilterSelectionUncheckedCreateNestedManyWithoutFilterSelectionInput = {
  connect?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserChannelFilterSelectionCreateOrConnectWithoutFilterSelectionInput>>;
  create?: Maybe<Array<UserChannelFilterSelectionCreateWithoutFilterSelectionInput>>;
  createMany?: Maybe<UserChannelFilterSelectionCreateManyFilterSelectionInputEnvelope>;
};

export type UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserChannelFilterSelectionCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserChannelFilterSelectionCreateWithoutUserInput>>;
  createMany?: Maybe<UserChannelFilterSelectionCreateManyUserInputEnvelope>;
};

export type UserChannelFilterSelectionUncheckedCreateWithoutFilterSelectionInput = {
  id?: Maybe<Scalars['String']>;
  isFilterOwner: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type UserChannelFilterSelectionUncheckedCreateWithoutUserInput = {
  filterSelectionId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isFilterOwner: Scalars['Boolean'];
};

export type UserChannelFilterSelectionUncheckedUpdateInput = {
  filterSelectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserChannelFilterSelectionUncheckedUpdateManyInput = {
  filterSelectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserChannelFilterSelectionUncheckedUpdateManyWithoutFilterSelectionInput = {
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserChannelFilterSelectionUncheckedUpdateManyWithoutFilterSelectionNestedInput = {
  connect?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserChannelFilterSelectionCreateOrConnectWithoutFilterSelectionInput>>;
  create?: Maybe<Array<UserChannelFilterSelectionCreateWithoutFilterSelectionInput>>;
  createMany?: Maybe<UserChannelFilterSelectionCreateManyFilterSelectionInputEnvelope>;
  delete?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserChannelFilterSelectionScalarWhereInput>>;
  disconnect?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  set?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  update?: Maybe<Array<UserChannelFilterSelectionUpdateWithWhereUniqueWithoutFilterSelectionInput>>;
  updateMany?: Maybe<Array<UserChannelFilterSelectionUpdateManyWithWhereWithoutFilterSelectionInput>>;
  upsert?: Maybe<Array<UserChannelFilterSelectionUpsertWithWhereUniqueWithoutFilterSelectionInput>>;
};

export type UserChannelFilterSelectionUncheckedUpdateManyWithoutUserInput = {
  filterSelectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<Scalars['Boolean']>;
};

export type UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserChannelFilterSelectionCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserChannelFilterSelectionCreateWithoutUserInput>>;
  createMany?: Maybe<UserChannelFilterSelectionCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserChannelFilterSelectionScalarWhereInput>>;
  disconnect?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  set?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  update?: Maybe<Array<UserChannelFilterSelectionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<UserChannelFilterSelectionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<UserChannelFilterSelectionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserChannelFilterSelectionUncheckedUpdateWithoutFilterSelectionInput = {
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserChannelFilterSelectionUncheckedUpdateWithoutUserInput = {
  filterSelectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<Scalars['Boolean']>;
};

export type UserChannelFilterSelectionUpdateInput = {
  filterSelection?: Maybe<ChannelFilterSelectionUpdateOneRequiredWithoutUserChannelFilterSelectionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateOneRequiredWithoutUserChannelFilterSelectionsNestedInput>;
};

export type UserChannelFilterSelectionUpdateManyMutationInput = {
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<Scalars['Boolean']>;
};

export type UserChannelFilterSelectionUpdateManyWithWhereWithoutFilterSelectionInput = {
  data: UserChannelFilterSelectionUpdateManyMutationInput;
  where: UserChannelFilterSelectionScalarWhereInput;
};

export type UserChannelFilterSelectionUpdateManyWithWhereWithoutUserInput = {
  data: UserChannelFilterSelectionUpdateManyMutationInput;
  where: UserChannelFilterSelectionScalarWhereInput;
};

export type UserChannelFilterSelectionUpdateManyWithoutFilterSelectionNestedInput = {
  connect?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserChannelFilterSelectionCreateOrConnectWithoutFilterSelectionInput>>;
  create?: Maybe<Array<UserChannelFilterSelectionCreateWithoutFilterSelectionInput>>;
  createMany?: Maybe<UserChannelFilterSelectionCreateManyFilterSelectionInputEnvelope>;
  delete?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserChannelFilterSelectionScalarWhereInput>>;
  disconnect?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  set?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  update?: Maybe<Array<UserChannelFilterSelectionUpdateWithWhereUniqueWithoutFilterSelectionInput>>;
  updateMany?: Maybe<Array<UserChannelFilterSelectionUpdateManyWithWhereWithoutFilterSelectionInput>>;
  upsert?: Maybe<Array<UserChannelFilterSelectionUpsertWithWhereUniqueWithoutFilterSelectionInput>>;
};

export type UserChannelFilterSelectionUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserChannelFilterSelectionCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserChannelFilterSelectionCreateWithoutUserInput>>;
  createMany?: Maybe<UserChannelFilterSelectionCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserChannelFilterSelectionScalarWhereInput>>;
  disconnect?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  set?: Maybe<Array<UserChannelFilterSelectionWhereUniqueInput>>;
  update?: Maybe<Array<UserChannelFilterSelectionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<UserChannelFilterSelectionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<UserChannelFilterSelectionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserChannelFilterSelectionUpdateWithWhereUniqueWithoutFilterSelectionInput = {
  data: UserChannelFilterSelectionUpdateWithoutFilterSelectionInput;
  where: UserChannelFilterSelectionWhereUniqueInput;
};

export type UserChannelFilterSelectionUpdateWithWhereUniqueWithoutUserInput = {
  data: UserChannelFilterSelectionUpdateWithoutUserInput;
  where: UserChannelFilterSelectionWhereUniqueInput;
};

export type UserChannelFilterSelectionUpdateWithoutFilterSelectionInput = {
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateOneRequiredWithoutUserChannelFilterSelectionsNestedInput>;
};

export type UserChannelFilterSelectionUpdateWithoutUserInput = {
  filterSelection?: Maybe<ChannelFilterSelectionUpdateOneRequiredWithoutUserChannelFilterSelectionsNestedInput>;
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<Scalars['Boolean']>;
};

export type UserChannelFilterSelectionUpsertWithWhereUniqueWithoutFilterSelectionInput = {
  create: UserChannelFilterSelectionCreateWithoutFilterSelectionInput;
  update: UserChannelFilterSelectionUpdateWithoutFilterSelectionInput;
  where: UserChannelFilterSelectionWhereUniqueInput;
};

export type UserChannelFilterSelectionUpsertWithWhereUniqueWithoutUserInput = {
  create: UserChannelFilterSelectionCreateWithoutUserInput;
  update: UserChannelFilterSelectionUpdateWithoutUserInput;
  where: UserChannelFilterSelectionWhereUniqueInput;
};

export type UserChannelFilterSelectionUserIdAndFilterSelectionIdCompoundUniqueInput = {
  filterSelectionId: Scalars['String'];
  userId: Scalars['String'];
};

export type UserChannelFilterSelectionWhereInput = {
  AND?: Maybe<Array<UserChannelFilterSelectionWhereInput>>;
  NOT?: Maybe<Array<UserChannelFilterSelectionWhereInput>>;
  OR?: Maybe<Array<UserChannelFilterSelectionWhereInput>>;
  filterSelection?: Maybe<ChannelFilterSelectionScalarRelationFilter>;
  filterSelectionId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  isFilterOwner?: Maybe<BoolFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type UserChannelFilterSelectionWhereUniqueInput = {
  AND?: Maybe<Array<UserChannelFilterSelectionWhereInput>>;
  NOT?: Maybe<Array<UserChannelFilterSelectionWhereInput>>;
  OR?: Maybe<Array<UserChannelFilterSelectionWhereInput>>;
  filterSelection?: Maybe<ChannelFilterSelectionScalarRelationFilter>;
  filterSelectionId?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  isFilterOwner?: Maybe<BoolFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
  userIdAndFilterSelectionId?: Maybe<UserChannelFilterSelectionUserIdAndFilterSelectionIdCompoundUniqueInput>;
};

export type UserCountAggregateOutputType = {
  __typename?: 'UserCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  crmId: Scalars['Int'];
  email: Scalars['Int'];
  firebaseId: Scalars['Int'];
  firstName: Scalars['Int'];
  id: Scalars['Int'];
  invitationCode: Scalars['Int'];
  invitedAt: Scalars['Int'];
  invitedById: Scalars['Int'];
  isActive: Scalars['Int'];
  isAdmin: Scalars['Int'];
  isNewPasswordRequired: Scalars['Int'];
  lastName: Scalars['Int'];
  mediaId: Scalars['Int'];
  nameDisplay: Scalars['Int'];
  namePrefix: Scalars['Int'];
  nameSuffix: Scalars['Int'];
  ownerInfoId: Scalars['Int'];
  phone: Scalars['Int'];
  profilePic: Scalars['Int'];
  signUpDate: Scalars['Int'];
  signupDetails: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userSettingId: Scalars['Int'];
  vetInfoId: Scalars['Int'];
};

export type UserCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invitationCode?: Maybe<SortOrder>;
  invitedAt?: Maybe<SortOrder>;
  invitedById?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAdmin?: Maybe<SortOrder>;
  isNewPasswordRequired?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  mediaId?: Maybe<SortOrder>;
  nameDisplay?: Maybe<SortOrder>;
  namePrefix?: Maybe<SortOrder>;
  nameSuffix?: Maybe<SortOrder>;
  ownerInfoId?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  profilePic?: Maybe<SortOrder>;
  signUpDate?: Maybe<SortOrder>;
  signupDetails?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userSettingId?: Maybe<SortOrder>;
  vetInfoId?: Maybe<SortOrder>;
};

export type UserCountOutputType = {
  __typename?: 'UserCountOutputType';
  AppointmentNoteTemplate: Scalars['Int'];
  AppointmentRecapNotesUpdated: Scalars['Int'];
  EmailCampaign: Scalars['Int'];
  EmailCampaignTemplate: Scalars['Int'];
  EmailCampaignUpdated: Scalars['Int'];
  EmailCampaignsCreated: Scalars['Int'];
  EmailCampaignsSent: Scalars['Int'];
  UserImpersonation_UserToUserImpersonation_impersonated_user_id: Scalars['Int'];
  UserImpersonation_UserToUserImpersonation_user_id: Scalars['Int'];
  UserTaskList: Scalars['Int'];
  axionClinicUserConfigurations: Scalars['Int'];
  blockedNumbers: Scalars['Int'];
  boardFilters: Scalars['Int'];
  calls: Scalars['Int'];
  careBenefitUsageToInvoiceLineItems: Scalars['Int'];
  channelCreationSources: Scalars['Int'];
  channelMembers: Scalars['Int'];
  channelMessageReactions: Scalars['Int'];
  channelMessagesWithMentions: Scalars['Int'];
  channelSelections: Scalars['Int'];
  channelStatusChannelAssignees: Scalars['Int'];
  channelStatuses: Scalars['Int'];
  channels: Scalars['Int'];
  clinicPetParents: Scalars['Int'];
  clinicUserFilters: Scalars['Int'];
  clinicWidgetRequestTypes: Scalars['Int'];
  clinics: Scalars['Int'];
  clinicsId: Scalars['Int'];
  completedBenefitUsageFollowupSteps: Scalars['Int'];
  consultationChats: Scalars['Int'];
  createdPayoutBatchingPeriods: Scalars['Int'];
  emailTemplateVersions: Scalars['Int'];
  encryptedClinicUploads: Scalars['Int'];
  formSubmissions: Scalars['Int'];
  informNotificationRecipients: Scalars['Int'];
  informPartnerProgramEnrollmentTermsAcceptances: Scalars['Int'];
  informPrimaryContactClinicSettings: Scalars['Int'];
  intitiatedLoyaltyAccountMerges: Scalars['Int'];
  invitations: Scalars['Int'];
  loaSignedClinicPhoneNumbers: Scalars['Int'];
  loyaltyPointUserGrants: Scalars['Int'];
  loyaltyRewardRedemptionActions: Scalars['Int'];
  manuallySentAutomationRuns: Scalars['Int'];
  massTextAlerts: Scalars['Int'];
  messageTemplates: Scalars['Int'];
  payoutBatchingSetting: Scalars['Int'];
  pinnedChannels: Scalars['Int'];
  pointOfContactEnrollmentSupportEvents: Scalars['Int'];
  recaps: Scalars['Int'];
  refundsIssued: Scalars['Int'];
  requestedEnrollmentSupportEvents: Scalars['Int'];
  responderEnrollmentSupportEvents: Scalars['Int'];
  reviews: Scalars['Int'];
  sentInvoices: Scalars['Int'];
  sentStripePaymentIntents: Scalars['Int'];
  sentTrupanionExamDayOffers: Scalars['Int'];
  tasks: Scalars['Int'];
  triggeredWritebacks: Scalars['Int'];
  unblockedNumbers: Scalars['Int'];
  usagesRecorded: Scalars['Int'];
  userAppointmentGroupings: Scalars['Int'];
  userChannelFilterSelections: Scalars['Int'];
  validatedCanonicalServices: Scalars['Int'];
};

export type UserCreateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserCreateManyInvitedByInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserCreateManyInvitedByInputEnvelope = {
  data: Array<UserCreateManyInvitedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserCreateManyMediaInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserCreateManyMediaInputEnvelope = {
  data: Array<UserCreateManyMediaInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserCreateManyUserSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserCreateManyUserSettingInputEnvelope = {
  data: Array<UserCreateManyUserSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserCreateNestedManyWithoutChannelMessagesWithMentionsInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutChannelMessagesWithMentionsInput>>;
  create?: Maybe<Array<UserCreateWithoutChannelMessagesWithMentionsInput>>;
};

export type UserCreateNestedManyWithoutChannelSelectionsInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutChannelSelectionsInput>>;
  create?: Maybe<Array<UserCreateWithoutChannelSelectionsInput>>;
};

export type UserCreateNestedManyWithoutChannelsInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutChannelsInput>>;
  create?: Maybe<Array<UserCreateWithoutChannelsInput>>;
};

export type UserCreateNestedManyWithoutClinicWidgetRequestTypesInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutClinicWidgetRequestTypesInput>>;
  create?: Maybe<Array<UserCreateWithoutClinicWidgetRequestTypesInput>>;
};

export type UserCreateNestedManyWithoutClinicsInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<UserCreateWithoutClinicsInput>>;
};

export type UserCreateNestedManyWithoutFormSubmissionsInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutFormSubmissionsInput>>;
  create?: Maybe<Array<UserCreateWithoutFormSubmissionsInput>>;
};

export type UserCreateNestedManyWithoutInvitedByInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutInvitedByInput>>;
  create?: Maybe<Array<UserCreateWithoutInvitedByInput>>;
  createMany?: Maybe<UserCreateManyInvitedByInputEnvelope>;
};

export type UserCreateNestedManyWithoutMediaInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<UserCreateWithoutMediaInput>>;
  createMany?: Maybe<UserCreateManyMediaInputEnvelope>;
};

export type UserCreateNestedManyWithoutTasksInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutTasksInput>>;
  create?: Maybe<Array<UserCreateWithoutTasksInput>>;
};

export type UserCreateNestedManyWithoutUserSettingInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutUserSettingInput>>;
  create?: Maybe<Array<UserCreateWithoutUserSettingInput>>;
  createMany?: Maybe<UserCreateManyUserSettingInputEnvelope>;
};

export type UserCreateNestedOneWithoutAppointmentNoteTemplateInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutAppointmentNoteTemplateInput>;
  create?: Maybe<UserCreateWithoutAppointmentNoteTemplateInput>;
};

export type UserCreateNestedOneWithoutAppointmentRecapNotesUpdatedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutAppointmentRecapNotesUpdatedInput>;
  create?: Maybe<UserCreateWithoutAppointmentRecapNotesUpdatedInput>;
};

export type UserCreateNestedOneWithoutAxionClinicUserConfigurationsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutAxionClinicUserConfigurationsInput>;
  create?: Maybe<UserCreateWithoutAxionClinicUserConfigurationsInput>;
};

export type UserCreateNestedOneWithoutBlockedNumbersInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutBlockedNumbersInput>;
  create?: Maybe<UserCreateWithoutBlockedNumbersInput>;
};

export type UserCreateNestedOneWithoutBoardFiltersInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutBoardFiltersInput>;
  create?: Maybe<UserCreateWithoutBoardFiltersInput>;
};

export type UserCreateNestedOneWithoutCallsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutCallsInput>;
  create?: Maybe<UserCreateWithoutCallsInput>;
};

export type UserCreateNestedOneWithoutCareBenefitUsageToInvoiceLineItemsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutCareBenefitUsageToInvoiceLineItemsInput>;
  create?: Maybe<UserCreateWithoutCareBenefitUsageToInvoiceLineItemsInput>;
};

export type UserCreateNestedOneWithoutChannelCreationSourcesInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutChannelCreationSourcesInput>;
  create?: Maybe<UserCreateWithoutChannelCreationSourcesInput>;
};

export type UserCreateNestedOneWithoutChannelMembersInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutChannelMembersInput>;
  create?: Maybe<UserCreateWithoutChannelMembersInput>;
};

export type UserCreateNestedOneWithoutChannelMessageReactionsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutChannelMessageReactionsInput>;
  create?: Maybe<UserCreateWithoutChannelMessageReactionsInput>;
};

export type UserCreateNestedOneWithoutChannelStatusChannelAssigneesInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutChannelStatusChannelAssigneesInput>;
  create?: Maybe<UserCreateWithoutChannelStatusChannelAssigneesInput>;
};

export type UserCreateNestedOneWithoutChannelStatusesInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutChannelStatusesInput>;
  create?: Maybe<UserCreateWithoutChannelStatusesInput>;
};

export type UserCreateNestedOneWithoutClinicPetParentsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutClinicPetParentsInput>;
  create?: Maybe<UserCreateWithoutClinicPetParentsInput>;
};

export type UserCreateNestedOneWithoutClinicUserFiltersInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutClinicUserFiltersInput>;
  create?: Maybe<UserCreateWithoutClinicUserFiltersInput>;
};

export type UserCreateNestedOneWithoutClinicsIdInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutClinicsIdInput>;
  create?: Maybe<UserCreateWithoutClinicsIdInput>;
};

export type UserCreateNestedOneWithoutCompletedBenefitUsageFollowupStepsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutCompletedBenefitUsageFollowupStepsInput>;
  create?: Maybe<UserCreateWithoutCompletedBenefitUsageFollowupStepsInput>;
};

export type UserCreateNestedOneWithoutConsultationChatsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutConsultationChatsInput>;
  create?: Maybe<UserCreateWithoutConsultationChatsInput>;
};

export type UserCreateNestedOneWithoutCreatedPayoutBatchingPeriodsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutCreatedPayoutBatchingPeriodsInput>;
  create?: Maybe<UserCreateWithoutCreatedPayoutBatchingPeriodsInput>;
};

export type UserCreateNestedOneWithoutEmailCampaignInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEmailCampaignInput>;
  create?: Maybe<UserCreateWithoutEmailCampaignInput>;
};

export type UserCreateNestedOneWithoutEmailCampaignTemplateInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEmailCampaignTemplateInput>;
  create?: Maybe<UserCreateWithoutEmailCampaignTemplateInput>;
};

export type UserCreateNestedOneWithoutEmailCampaignUpdatedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEmailCampaignUpdatedInput>;
  create?: Maybe<UserCreateWithoutEmailCampaignUpdatedInput>;
};

export type UserCreateNestedOneWithoutEmailCampaignsCreatedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEmailCampaignsCreatedInput>;
  create?: Maybe<UserCreateWithoutEmailCampaignsCreatedInput>;
};

export type UserCreateNestedOneWithoutEmailCampaignsSentInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEmailCampaignsSentInput>;
  create?: Maybe<UserCreateWithoutEmailCampaignsSentInput>;
};

export type UserCreateNestedOneWithoutEmailTemplateVersionsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEmailTemplateVersionsInput>;
  create?: Maybe<UserCreateWithoutEmailTemplateVersionsInput>;
};

export type UserCreateNestedOneWithoutEncryptedClinicUploadsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEncryptedClinicUploadsInput>;
  create?: Maybe<UserCreateWithoutEncryptedClinicUploadsInput>;
};

export type UserCreateNestedOneWithoutInformNotificationRecipientsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutInformNotificationRecipientsInput>;
  create?: Maybe<UserCreateWithoutInformNotificationRecipientsInput>;
};

export type UserCreateNestedOneWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput>;
  create?: Maybe<UserCreateWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput>;
};

export type UserCreateNestedOneWithoutInformPrimaryContactClinicSettingsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutInformPrimaryContactClinicSettingsInput>;
  create?: Maybe<UserCreateWithoutInformPrimaryContactClinicSettingsInput>;
};

export type UserCreateNestedOneWithoutIntitiatedLoyaltyAccountMergesInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutIntitiatedLoyaltyAccountMergesInput>;
  create?: Maybe<UserCreateWithoutIntitiatedLoyaltyAccountMergesInput>;
};

export type UserCreateNestedOneWithoutInvitationsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutInvitationsInput>;
  create?: Maybe<UserCreateWithoutInvitationsInput>;
};

export type UserCreateNestedOneWithoutLoaSignedClinicPhoneNumbersInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutLoaSignedClinicPhoneNumbersInput>;
  create?: Maybe<UserCreateWithoutLoaSignedClinicPhoneNumbersInput>;
};

export type UserCreateNestedOneWithoutLoyaltyPointUserGrantsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutLoyaltyPointUserGrantsInput>;
  create?: Maybe<UserCreateWithoutLoyaltyPointUserGrantsInput>;
};

export type UserCreateNestedOneWithoutLoyaltyRewardRedemptionActionsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutLoyaltyRewardRedemptionActionsInput>;
  create?: Maybe<UserCreateWithoutLoyaltyRewardRedemptionActionsInput>;
};

export type UserCreateNestedOneWithoutManuallySentAutomationRunsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutManuallySentAutomationRunsInput>;
  create?: Maybe<UserCreateWithoutManuallySentAutomationRunsInput>;
};

export type UserCreateNestedOneWithoutMassTextAlertsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutMassTextAlertsInput>;
  create?: Maybe<UserCreateWithoutMassTextAlertsInput>;
};

export type UserCreateNestedOneWithoutMessageTemplatesInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutMessageTemplatesInput>;
  create?: Maybe<UserCreateWithoutMessageTemplatesInput>;
};

export type UserCreateNestedOneWithoutOwnerInfoInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutOwnerInfoInput>;
  create?: Maybe<UserCreateWithoutOwnerInfoInput>;
};

export type UserCreateNestedOneWithoutPayoutBatchingSettingInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutPayoutBatchingSettingInput>;
  create?: Maybe<UserCreateWithoutPayoutBatchingSettingInput>;
};

export type UserCreateNestedOneWithoutPinnedChannelsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutPinnedChannelsInput>;
  create?: Maybe<UserCreateWithoutPinnedChannelsInput>;
};

export type UserCreateNestedOneWithoutPointOfContactEnrollmentSupportEventsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutPointOfContactEnrollmentSupportEventsInput>;
  create?: Maybe<UserCreateWithoutPointOfContactEnrollmentSupportEventsInput>;
};

export type UserCreateNestedOneWithoutRecapsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutRecapsInput>;
  create?: Maybe<UserCreateWithoutRecapsInput>;
};

export type UserCreateNestedOneWithoutRefundsIssuedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutRefundsIssuedInput>;
  create?: Maybe<UserCreateWithoutRefundsIssuedInput>;
};

export type UserCreateNestedOneWithoutRequestedEnrollmentSupportEventsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutRequestedEnrollmentSupportEventsInput>;
  create?: Maybe<UserCreateWithoutRequestedEnrollmentSupportEventsInput>;
};

export type UserCreateNestedOneWithoutResponderEnrollmentSupportEventsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutResponderEnrollmentSupportEventsInput>;
  create?: Maybe<UserCreateWithoutResponderEnrollmentSupportEventsInput>;
};

export type UserCreateNestedOneWithoutReviewsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutReviewsInput>;
  create?: Maybe<UserCreateWithoutReviewsInput>;
};

export type UserCreateNestedOneWithoutSentInvoicesInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutSentInvoicesInput>;
  create?: Maybe<UserCreateWithoutSentInvoicesInput>;
};

export type UserCreateNestedOneWithoutSentStripePaymentIntentsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutSentStripePaymentIntentsInput>;
  create?: Maybe<UserCreateWithoutSentStripePaymentIntentsInput>;
};

export type UserCreateNestedOneWithoutSentTrupanionExamDayOffersInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutSentTrupanionExamDayOffersInput>;
  create?: Maybe<UserCreateWithoutSentTrupanionExamDayOffersInput>;
};

export type UserCreateNestedOneWithoutTriggeredWritebacksInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutTriggeredWritebacksInput>;
  create?: Maybe<UserCreateWithoutTriggeredWritebacksInput>;
};

export type UserCreateNestedOneWithoutUnblockedNumbersInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUnblockedNumbersInput>;
  create?: Maybe<UserCreateWithoutUnblockedNumbersInput>;
};

export type UserCreateNestedOneWithoutUsagesRecordedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUsagesRecordedInput>;
  create?: Maybe<UserCreateWithoutUsagesRecordedInput>;
};

export type UserCreateNestedOneWithoutUserAppointmentGroupingsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserAppointmentGroupingsInput>;
  create?: Maybe<UserCreateWithoutUserAppointmentGroupingsInput>;
};

export type UserCreateNestedOneWithoutUserChannelFilterSelectionsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserChannelFilterSelectionsInput>;
  create?: Maybe<UserCreateWithoutUserChannelFilterSelectionsInput>;
};

export type UserCreateNestedOneWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput>;
  create?: Maybe<UserCreateWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput>;
};

export type UserCreateNestedOneWithoutUserImpersonation_UserToUserImpersonation_User_IdInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserImpersonation_UserToUserImpersonation_User_IdInput>;
  create?: Maybe<UserCreateWithoutUserImpersonation_UserToUserImpersonation_User_IdInput>;
};

export type UserCreateNestedOneWithoutUserTaskListInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserTaskListInput>;
  create?: Maybe<UserCreateWithoutUserTaskListInput>;
};

export type UserCreateNestedOneWithoutValidatedCanonicalServicesInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutValidatedCanonicalServicesInput>;
  create?: Maybe<UserCreateWithoutValidatedCanonicalServicesInput>;
};

export type UserCreateNestedOneWithoutVetInfoInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutVetInfoInput>;
  create?: Maybe<UserCreateWithoutVetInfoInput>;
};

export type UserCreateOrConnectWithoutAppointmentNoteTemplateInput = {
  create: UserCreateWithoutAppointmentNoteTemplateInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutAppointmentRecapNotesUpdatedInput = {
  create: UserCreateWithoutAppointmentRecapNotesUpdatedInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutAxionClinicUserConfigurationsInput = {
  create: UserCreateWithoutAxionClinicUserConfigurationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutBlockedNumbersInput = {
  create: UserCreateWithoutBlockedNumbersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutBoardFiltersInput = {
  create: UserCreateWithoutBoardFiltersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCallsInput = {
  create: UserCreateWithoutCallsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCareBenefitUsageToInvoiceLineItemsInput = {
  create: UserCreateWithoutCareBenefitUsageToInvoiceLineItemsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutChannelCreationSourcesInput = {
  create: UserCreateWithoutChannelCreationSourcesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutChannelMembersInput = {
  create: UserCreateWithoutChannelMembersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutChannelMessageReactionsInput = {
  create: UserCreateWithoutChannelMessageReactionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutChannelMessagesWithMentionsInput = {
  create: UserCreateWithoutChannelMessagesWithMentionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutChannelSelectionsInput = {
  create: UserCreateWithoutChannelSelectionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutChannelStatusChannelAssigneesInput = {
  create: UserCreateWithoutChannelStatusChannelAssigneesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutChannelStatusesInput = {
  create: UserCreateWithoutChannelStatusesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutChannelsInput = {
  create: UserCreateWithoutChannelsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutClinicPetParentsInput = {
  create: UserCreateWithoutClinicPetParentsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutClinicUserFiltersInput = {
  create: UserCreateWithoutClinicUserFiltersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutClinicWidgetRequestTypesInput = {
  create: UserCreateWithoutClinicWidgetRequestTypesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutClinicsIdInput = {
  create: UserCreateWithoutClinicsIdInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutClinicsInput = {
  create: UserCreateWithoutClinicsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCompletedBenefitUsageFollowupStepsInput = {
  create: UserCreateWithoutCompletedBenefitUsageFollowupStepsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutConsultationChatsInput = {
  create: UserCreateWithoutConsultationChatsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCreatedPayoutBatchingPeriodsInput = {
  create: UserCreateWithoutCreatedPayoutBatchingPeriodsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEmailCampaignInput = {
  create: UserCreateWithoutEmailCampaignInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEmailCampaignTemplateInput = {
  create: UserCreateWithoutEmailCampaignTemplateInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEmailCampaignUpdatedInput = {
  create: UserCreateWithoutEmailCampaignUpdatedInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEmailCampaignsCreatedInput = {
  create: UserCreateWithoutEmailCampaignsCreatedInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEmailCampaignsSentInput = {
  create: UserCreateWithoutEmailCampaignsSentInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEmailTemplateVersionsInput = {
  create: UserCreateWithoutEmailTemplateVersionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEncryptedClinicUploadsInput = {
  create: UserCreateWithoutEncryptedClinicUploadsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutFormSubmissionsInput = {
  create: UserCreateWithoutFormSubmissionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutInformNotificationRecipientsInput = {
  create: UserCreateWithoutInformNotificationRecipientsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput = {
  create: UserCreateWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutInformPrimaryContactClinicSettingsInput = {
  create: UserCreateWithoutInformPrimaryContactClinicSettingsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutIntitiatedLoyaltyAccountMergesInput = {
  create: UserCreateWithoutIntitiatedLoyaltyAccountMergesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutInvitationsInput = {
  create: UserCreateWithoutInvitationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutInvitedByInput = {
  create: UserCreateWithoutInvitedByInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutLoaSignedClinicPhoneNumbersInput = {
  create: UserCreateWithoutLoaSignedClinicPhoneNumbersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutLoyaltyPointUserGrantsInput = {
  create: UserCreateWithoutLoyaltyPointUserGrantsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutLoyaltyRewardRedemptionActionsInput = {
  create: UserCreateWithoutLoyaltyRewardRedemptionActionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutManuallySentAutomationRunsInput = {
  create: UserCreateWithoutManuallySentAutomationRunsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMassTextAlertsInput = {
  create: UserCreateWithoutMassTextAlertsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMediaInput = {
  create: UserCreateWithoutMediaInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMessageTemplatesInput = {
  create: UserCreateWithoutMessageTemplatesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutOwnerInfoInput = {
  create: UserCreateWithoutOwnerInfoInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPayoutBatchingSettingInput = {
  create: UserCreateWithoutPayoutBatchingSettingInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPinnedChannelsInput = {
  create: UserCreateWithoutPinnedChannelsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPointOfContactEnrollmentSupportEventsInput = {
  create: UserCreateWithoutPointOfContactEnrollmentSupportEventsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutRecapsInput = {
  create: UserCreateWithoutRecapsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutRefundsIssuedInput = {
  create: UserCreateWithoutRefundsIssuedInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutRequestedEnrollmentSupportEventsInput = {
  create: UserCreateWithoutRequestedEnrollmentSupportEventsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutResponderEnrollmentSupportEventsInput = {
  create: UserCreateWithoutResponderEnrollmentSupportEventsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutReviewsInput = {
  create: UserCreateWithoutReviewsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSentInvoicesInput = {
  create: UserCreateWithoutSentInvoicesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSentStripePaymentIntentsInput = {
  create: UserCreateWithoutSentStripePaymentIntentsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSentTrupanionExamDayOffersInput = {
  create: UserCreateWithoutSentTrupanionExamDayOffersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTasksInput = {
  create: UserCreateWithoutTasksInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTriggeredWritebacksInput = {
  create: UserCreateWithoutTriggeredWritebacksInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUnblockedNumbersInput = {
  create: UserCreateWithoutUnblockedNumbersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUsagesRecordedInput = {
  create: UserCreateWithoutUsagesRecordedInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserAppointmentGroupingsInput = {
  create: UserCreateWithoutUserAppointmentGroupingsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserChannelFilterSelectionsInput = {
  create: UserCreateWithoutUserChannelFilterSelectionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput = {
  create: UserCreateWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserImpersonation_UserToUserImpersonation_User_IdInput = {
  create: UserCreateWithoutUserImpersonation_UserToUserImpersonation_User_IdInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserSettingInput = {
  create: UserCreateWithoutUserSettingInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserTaskListInput = {
  create: UserCreateWithoutUserTaskListInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutValidatedCanonicalServicesInput = {
  create: UserCreateWithoutValidatedCanonicalServicesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutVetInfoInput = {
  create: UserCreateWithoutVetInfoInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutAppointmentNoteTemplateInput = {
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutAppointmentRecapNotesUpdatedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutAxionClinicUserConfigurationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutBlockedNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutBoardFiltersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutCallsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutCareBenefitUsageToInvoiceLineItemsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutChannelCreationSourcesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutChannelMembersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutChannelMessageReactionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutChannelMessagesWithMentionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutChannelSelectionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutChannelStatusChannelAssigneesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutChannelStatusesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutChannelsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutClinicPetParentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutClinicUserFiltersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutClinicWidgetRequestTypesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutClinicsIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutClinicsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutCompletedBenefitUsageFollowupStepsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutConsultationChatsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutCreatedPayoutBatchingPeriodsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutEmailCampaignInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutEmailCampaignTemplateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutEmailCampaignUpdatedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutEmailCampaignsCreatedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutEmailCampaignsSentInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutEmailTemplateVersionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutEncryptedClinicUploadsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutFormSubmissionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutInformNotificationRecipientsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutInformPrimaryContactClinicSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutIntitiatedLoyaltyAccountMergesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutInvitationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutInvitedByInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutLoaSignedClinicPhoneNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutLoyaltyPointUserGrantsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutLoyaltyRewardRedemptionActionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutManuallySentAutomationRunsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutMassTextAlertsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutMediaInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutMessageTemplatesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutOwnerInfoInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutPayoutBatchingSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutPinnedChannelsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutPointOfContactEnrollmentSupportEventsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutRecapsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutRefundsIssuedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutRequestedEnrollmentSupportEventsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutResponderEnrollmentSupportEventsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutReviewsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutSentInvoicesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutSentStripePaymentIntentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutSentTrupanionExamDayOffersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutTasksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutTriggeredWritebacksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutUnblockedNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutUsagesRecordedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutUserAppointmentGroupingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutUserChannelFilterSelectionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutUserImpersonation_UserToUserImpersonation_User_IdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutUserSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutUserTaskListInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutValidatedCanonicalServicesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutVetInfoInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserCreateNestedOneWithoutInvitationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertCreateNestedManyWithoutCreatedByUserInput>;
  media?: Maybe<MediaCreateNestedOneWithoutUsersInput>;
  messageTemplates?: Maybe<MessageTemplateCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoCreateNestedOneWithoutUserInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionCreateNestedManyWithoutUserInput>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceCreateNestedManyWithoutValidatedByUserInput>;
};

export type UserGroupByOutputType = {
  __typename?: 'UserGroupByOutputType';
  _count?: Maybe<UserCountAggregateOutputType>;
  _max?: Maybe<UserMaxAggregateOutputType>;
  _min?: Maybe<UserMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['String'];
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired: Scalars['Boolean'];
  lastName: Scalars['String'];
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type: UserType;
  updatedAt: Scalars['DateTime'];
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserImpersonation = {
  __typename?: 'UserImpersonation';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  impersonatedInformPartnerUser?: Maybe<InformPartnerUser>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUser?: Maybe<User>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUser?: Maybe<InformPartnerUser>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type UserImpersonationImpersonatedInformPartnerUserArgs = {
  where?: Maybe<InformPartnerUserWhereInput>;
};


export type UserImpersonationImpersonatedUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type UserImpersonationInformPartnerUserArgs = {
  where?: Maybe<InformPartnerUserWhereInput>;
};


export type UserImpersonationUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type UserImpersonationCountAggregateOutputType = {
  __typename?: 'UserImpersonationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  impersonatedInformPartnerUserId: Scalars['Int'];
  impersonatedUserId: Scalars['Int'];
  informPartnerUserId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userFirebaseId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UserImpersonationCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  impersonatedInformPartnerUserId?: Maybe<SortOrder>;
  impersonatedUserId?: Maybe<SortOrder>;
  informPartnerUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userFirebaseId?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserImpersonationCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserCreateNestedOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput>;
  impersonatedUser?: Maybe<UserCreateNestedOneWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput>;
  informPartnerUser?: Maybe<InformPartnerUserCreateNestedOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutUserImpersonation_UserToUserImpersonation_User_IdInput>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationCreateManyImpersonatedInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationCreateManyImpersonatedInformPartnerUserInputEnvelope = {
  data: Array<UserImpersonationCreateManyImpersonatedInformPartnerUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserImpersonationCreateManyImpersonatedUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationCreateManyImpersonatedUserInputEnvelope = {
  data: Array<UserImpersonationCreateManyImpersonatedUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserImpersonationCreateManyInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationCreateManyInformPartnerUserInputEnvelope = {
  data: Array<UserImpersonationCreateManyInformPartnerUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserImpersonationCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationCreateManyUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationCreateManyUserInputEnvelope = {
  data: Array<UserImpersonationCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserImpersonationCreateNestedManyWithoutImpersonatedInformPartnerUserInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutImpersonatedInformPartnerUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutImpersonatedInformPartnerUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyImpersonatedInformPartnerUserInputEnvelope>;
};

export type UserImpersonationCreateNestedManyWithoutImpersonatedUserInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutImpersonatedUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutImpersonatedUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyImpersonatedUserInputEnvelope>;
};

export type UserImpersonationCreateNestedManyWithoutInformPartnerUserInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutInformPartnerUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutInformPartnerUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyInformPartnerUserInputEnvelope>;
};

export type UserImpersonationCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyUserInputEnvelope>;
};

export type UserImpersonationCreateOrConnectWithoutImpersonatedInformPartnerUserInput = {
  create: UserImpersonationCreateWithoutImpersonatedInformPartnerUserInput;
  where: UserImpersonationWhereUniqueInput;
};

export type UserImpersonationCreateOrConnectWithoutImpersonatedUserInput = {
  create: UserImpersonationCreateWithoutImpersonatedUserInput;
  where: UserImpersonationWhereUniqueInput;
};

export type UserImpersonationCreateOrConnectWithoutInformPartnerUserInput = {
  create: UserImpersonationCreateWithoutInformPartnerUserInput;
  where: UserImpersonationWhereUniqueInput;
};

export type UserImpersonationCreateOrConnectWithoutUserInput = {
  create: UserImpersonationCreateWithoutUserInput;
  where: UserImpersonationWhereUniqueInput;
};

export type UserImpersonationCreateWithoutImpersonatedInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedUser?: Maybe<UserCreateNestedOneWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput>;
  informPartnerUser?: Maybe<InformPartnerUserCreateNestedOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutUserImpersonation_UserToUserImpersonation_User_IdInput>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationCreateWithoutImpersonatedUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserCreateNestedOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput>;
  informPartnerUser?: Maybe<InformPartnerUserCreateNestedOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutUserImpersonation_UserToUserImpersonation_User_IdInput>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationCreateWithoutInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserCreateNestedOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput>;
  impersonatedUser?: Maybe<UserCreateNestedOneWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutUserImpersonation_UserToUserImpersonation_User_IdInput>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationCreateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserCreateNestedOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdInput>;
  impersonatedUser?: Maybe<UserCreateNestedOneWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput>;
  informPartnerUser?: Maybe<InformPartnerUserCreateNestedOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationGroupByOutputType = {
  __typename?: 'UserImpersonationGroupByOutputType';
  _count?: Maybe<UserImpersonationCountAggregateOutputType>;
  _max?: Maybe<UserImpersonationMaxAggregateOutputType>;
  _min?: Maybe<UserImpersonationMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationListRelationFilter = {
  every?: Maybe<UserImpersonationWhereInput>;
  none?: Maybe<UserImpersonationWhereInput>;
  some?: Maybe<UserImpersonationWhereInput>;
};

export type UserImpersonationMaxAggregateOutputType = {
  __typename?: 'UserImpersonationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  impersonatedInformPartnerUserId?: Maybe<SortOrder>;
  impersonatedUserId?: Maybe<SortOrder>;
  informPartnerUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userFirebaseId?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserImpersonationMinAggregateOutputType = {
  __typename?: 'UserImpersonationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  impersonatedInformPartnerUserId?: Maybe<SortOrder>;
  impersonatedUserId?: Maybe<SortOrder>;
  informPartnerUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userFirebaseId?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserImpersonationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserImpersonationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserImpersonationOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserOrderByWithRelationInput>;
  impersonatedInformPartnerUserId?: Maybe<SortOrder>;
  impersonatedUser?: Maybe<UserOrderByWithRelationInput>;
  impersonatedUserId?: Maybe<SortOrder>;
  informPartnerUser?: Maybe<InformPartnerUserOrderByWithRelationInput>;
  informPartnerUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userFirebaseId?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export enum UserImpersonationOrderByRelevanceFieldEnum {
  Id = 'id',
  ImpersonatedInformPartnerUserId = 'impersonatedInformPartnerUserId',
  ImpersonatedUserId = 'impersonatedUserId',
  InformPartnerUserId = 'informPartnerUserId',
  UserFirebaseId = 'userFirebaseId',
  UserId = 'userId'
}

export type UserImpersonationOrderByRelevanceInput = {
  fields: Array<UserImpersonationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UserImpersonationOrderByWithAggregationInput = {
  _count?: Maybe<UserImpersonationCountOrderByAggregateInput>;
  _max?: Maybe<UserImpersonationMaxOrderByAggregateInput>;
  _min?: Maybe<UserImpersonationMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  impersonatedInformPartnerUserId?: Maybe<SortOrder>;
  impersonatedUserId?: Maybe<SortOrder>;
  informPartnerUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userFirebaseId?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserImpersonationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserImpersonationOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserOrderByWithRelationInput>;
  impersonatedInformPartnerUserId?: Maybe<SortOrder>;
  impersonatedUser?: Maybe<UserOrderByWithRelationInput>;
  impersonatedUserId?: Maybe<SortOrder>;
  informPartnerUser?: Maybe<InformPartnerUserOrderByWithRelationInput>;
  informPartnerUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userFirebaseId?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserImpersonationOrderByWithRelationInput = {
  _relevance?: Maybe<UserImpersonationOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserOrderByWithRelationInput>;
  impersonatedInformPartnerUserId?: Maybe<SortOrder>;
  impersonatedUser?: Maybe<UserOrderByWithRelationInput>;
  impersonatedUserId?: Maybe<SortOrder>;
  informPartnerUser?: Maybe<InformPartnerUserOrderByWithRelationInput>;
  informPartnerUserId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userFirebaseId?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export enum UserImpersonationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ImpersonatedInformPartnerUserId = 'impersonatedInformPartnerUserId',
  ImpersonatedUserId = 'impersonatedUserId',
  InformPartnerUserId = 'informPartnerUserId',
  UpdatedAt = 'updatedAt',
  UserFirebaseId = 'userFirebaseId',
  UserId = 'userId'
}

export type UserImpersonationScalarWhereInput = {
  AND?: Maybe<Array<UserImpersonationScalarWhereInput>>;
  NOT?: Maybe<Array<UserImpersonationScalarWhereInput>>;
  OR?: Maybe<Array<UserImpersonationScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  impersonatedInformPartnerUserId?: Maybe<StringNullableFilter>;
  impersonatedUserId?: Maybe<StringNullableFilter>;
  informPartnerUserId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userFirebaseId?: Maybe<StringNullableFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type UserImpersonationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserImpersonationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UserImpersonationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserImpersonationScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  impersonatedInformPartnerUserId?: Maybe<StringNullableWithAggregatesFilter>;
  impersonatedUserId?: Maybe<StringNullableWithAggregatesFilter>;
  informPartnerUserId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userFirebaseId?: Maybe<StringNullableWithAggregatesFilter>;
  userId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type UserImpersonationUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedInformPartnerUserInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutImpersonatedInformPartnerUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutImpersonatedInformPartnerUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyImpersonatedInformPartnerUserInputEnvelope>;
};

export type UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutImpersonatedUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutImpersonatedUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyImpersonatedUserInputEnvelope>;
};

export type UserImpersonationUncheckedCreateNestedManyWithoutInformPartnerUserInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutInformPartnerUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutInformPartnerUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyInformPartnerUserInputEnvelope>;
};

export type UserImpersonationUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyUserInputEnvelope>;
};

export type UserImpersonationUncheckedCreateWithoutImpersonatedInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedCreateWithoutImpersonatedUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedCreateWithoutInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedCreateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedUpdateManyWithoutImpersonatedInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedUpdateManyWithoutImpersonatedInformPartnerUserNestedInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutImpersonatedInformPartnerUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutImpersonatedInformPartnerUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyImpersonatedInformPartnerUserInputEnvelope>;
  delete?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserImpersonationScalarWhereInput>>;
  disconnect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  set?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  update?: Maybe<Array<UserImpersonationUpdateWithWhereUniqueWithoutImpersonatedInformPartnerUserInput>>;
  updateMany?: Maybe<Array<UserImpersonationUpdateManyWithWhereWithoutImpersonatedInformPartnerUserInput>>;
  upsert?: Maybe<Array<UserImpersonationUpsertWithWhereUniqueWithoutImpersonatedInformPartnerUserInput>>;
};

export type UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutImpersonatedUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutImpersonatedUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyImpersonatedUserInputEnvelope>;
  delete?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserImpersonationScalarWhereInput>>;
  disconnect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  set?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  update?: Maybe<Array<UserImpersonationUpdateWithWhereUniqueWithoutImpersonatedUserInput>>;
  updateMany?: Maybe<Array<UserImpersonationUpdateManyWithWhereWithoutImpersonatedUserInput>>;
  upsert?: Maybe<Array<UserImpersonationUpsertWithWhereUniqueWithoutImpersonatedUserInput>>;
};

export type UserImpersonationUncheckedUpdateManyWithoutInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedUpdateManyWithoutInformPartnerUserNestedInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutInformPartnerUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutInformPartnerUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyInformPartnerUserInputEnvelope>;
  delete?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserImpersonationScalarWhereInput>>;
  disconnect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  set?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  update?: Maybe<Array<UserImpersonationUpdateWithWhereUniqueWithoutInformPartnerUserInput>>;
  updateMany?: Maybe<Array<UserImpersonationUpdateManyWithWhereWithoutInformPartnerUserInput>>;
  upsert?: Maybe<Array<UserImpersonationUpsertWithWhereUniqueWithoutInformPartnerUserInput>>;
};

export type UserImpersonationUncheckedUpdateManyWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserImpersonationScalarWhereInput>>;
  disconnect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  set?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  update?: Maybe<Array<UserImpersonationUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<UserImpersonationUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<UserImpersonationUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserImpersonationUncheckedUpdateWithoutImpersonatedInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedUpdateWithoutImpersonatedUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedUpdateWithoutInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUncheckedUpdateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUserId?: Maybe<Scalars['String']>;
  impersonatedUserId?: Maybe<Scalars['String']>;
  informPartnerUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserUpdateOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdNestedInput>;
  impersonatedUser?: Maybe<UserUpdateOneWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdNestedInput>;
  informPartnerUser?: Maybe<InformPartnerUserUpdateOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutUserImpersonation_UserToUserImpersonation_User_IdNestedInput>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUpdateManyWithWhereWithoutImpersonatedInformPartnerUserInput = {
  data: UserImpersonationUpdateManyMutationInput;
  where: UserImpersonationScalarWhereInput;
};

export type UserImpersonationUpdateManyWithWhereWithoutImpersonatedUserInput = {
  data: UserImpersonationUpdateManyMutationInput;
  where: UserImpersonationScalarWhereInput;
};

export type UserImpersonationUpdateManyWithWhereWithoutInformPartnerUserInput = {
  data: UserImpersonationUpdateManyMutationInput;
  where: UserImpersonationScalarWhereInput;
};

export type UserImpersonationUpdateManyWithWhereWithoutUserInput = {
  data: UserImpersonationUpdateManyMutationInput;
  where: UserImpersonationScalarWhereInput;
};

export type UserImpersonationUpdateManyWithoutImpersonatedInformPartnerUserNestedInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutImpersonatedInformPartnerUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutImpersonatedInformPartnerUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyImpersonatedInformPartnerUserInputEnvelope>;
  delete?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserImpersonationScalarWhereInput>>;
  disconnect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  set?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  update?: Maybe<Array<UserImpersonationUpdateWithWhereUniqueWithoutImpersonatedInformPartnerUserInput>>;
  updateMany?: Maybe<Array<UserImpersonationUpdateManyWithWhereWithoutImpersonatedInformPartnerUserInput>>;
  upsert?: Maybe<Array<UserImpersonationUpsertWithWhereUniqueWithoutImpersonatedInformPartnerUserInput>>;
};

export type UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutImpersonatedUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutImpersonatedUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyImpersonatedUserInputEnvelope>;
  delete?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserImpersonationScalarWhereInput>>;
  disconnect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  set?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  update?: Maybe<Array<UserImpersonationUpdateWithWhereUniqueWithoutImpersonatedUserInput>>;
  updateMany?: Maybe<Array<UserImpersonationUpdateManyWithWhereWithoutImpersonatedUserInput>>;
  upsert?: Maybe<Array<UserImpersonationUpsertWithWhereUniqueWithoutImpersonatedUserInput>>;
};

export type UserImpersonationUpdateManyWithoutInformPartnerUserNestedInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutInformPartnerUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutInformPartnerUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyInformPartnerUserInputEnvelope>;
  delete?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserImpersonationScalarWhereInput>>;
  disconnect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  set?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  update?: Maybe<Array<UserImpersonationUpdateWithWhereUniqueWithoutInformPartnerUserInput>>;
  updateMany?: Maybe<Array<UserImpersonationUpdateManyWithWhereWithoutInformPartnerUserInput>>;
  upsert?: Maybe<Array<UserImpersonationUpsertWithWhereUniqueWithoutInformPartnerUserInput>>;
};

export type UserImpersonationUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserImpersonationCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserImpersonationCreateWithoutUserInput>>;
  createMany?: Maybe<UserImpersonationCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserImpersonationScalarWhereInput>>;
  disconnect?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  set?: Maybe<Array<UserImpersonationWhereUniqueInput>>;
  update?: Maybe<Array<UserImpersonationUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<UserImpersonationUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<UserImpersonationUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserImpersonationUpdateWithWhereUniqueWithoutImpersonatedInformPartnerUserInput = {
  data: UserImpersonationUpdateWithoutImpersonatedInformPartnerUserInput;
  where: UserImpersonationWhereUniqueInput;
};

export type UserImpersonationUpdateWithWhereUniqueWithoutImpersonatedUserInput = {
  data: UserImpersonationUpdateWithoutImpersonatedUserInput;
  where: UserImpersonationWhereUniqueInput;
};

export type UserImpersonationUpdateWithWhereUniqueWithoutInformPartnerUserInput = {
  data: UserImpersonationUpdateWithoutInformPartnerUserInput;
  where: UserImpersonationWhereUniqueInput;
};

export type UserImpersonationUpdateWithWhereUniqueWithoutUserInput = {
  data: UserImpersonationUpdateWithoutUserInput;
  where: UserImpersonationWhereUniqueInput;
};

export type UserImpersonationUpdateWithoutImpersonatedInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedUser?: Maybe<UserUpdateOneWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdNestedInput>;
  informPartnerUser?: Maybe<InformPartnerUserUpdateOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutUserImpersonation_UserToUserImpersonation_User_IdNestedInput>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUpdateWithoutImpersonatedUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserUpdateOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdNestedInput>;
  informPartnerUser?: Maybe<InformPartnerUserUpdateOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutUserImpersonation_UserToUserImpersonation_User_IdNestedInput>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUpdateWithoutInformPartnerUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserUpdateOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdNestedInput>;
  impersonatedUser?: Maybe<UserUpdateOneWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutUserImpersonation_UserToUserImpersonation_User_IdNestedInput>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUpdateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserUpdateOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Impersonated_Inform_Partner_User_IdNestedInput>;
  impersonatedUser?: Maybe<UserUpdateOneWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdNestedInput>;
  informPartnerUser?: Maybe<InformPartnerUserUpdateOneWithoutUserImpersonation_InformPartnerUserToUserImpersonation_Inform_Partner_User_IdNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userFirebaseId?: Maybe<Scalars['String']>;
};

export type UserImpersonationUpsertWithWhereUniqueWithoutImpersonatedInformPartnerUserInput = {
  create: UserImpersonationCreateWithoutImpersonatedInformPartnerUserInput;
  update: UserImpersonationUpdateWithoutImpersonatedInformPartnerUserInput;
  where: UserImpersonationWhereUniqueInput;
};

export type UserImpersonationUpsertWithWhereUniqueWithoutImpersonatedUserInput = {
  create: UserImpersonationCreateWithoutImpersonatedUserInput;
  update: UserImpersonationUpdateWithoutImpersonatedUserInput;
  where: UserImpersonationWhereUniqueInput;
};

export type UserImpersonationUpsertWithWhereUniqueWithoutInformPartnerUserInput = {
  create: UserImpersonationCreateWithoutInformPartnerUserInput;
  update: UserImpersonationUpdateWithoutInformPartnerUserInput;
  where: UserImpersonationWhereUniqueInput;
};

export type UserImpersonationUpsertWithWhereUniqueWithoutUserInput = {
  create: UserImpersonationCreateWithoutUserInput;
  update: UserImpersonationUpdateWithoutUserInput;
  where: UserImpersonationWhereUniqueInput;
};

export type UserImpersonationWhereInput = {
  AND?: Maybe<Array<UserImpersonationWhereInput>>;
  NOT?: Maybe<Array<UserImpersonationWhereInput>>;
  OR?: Maybe<Array<UserImpersonationWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserNullableScalarRelationFilter>;
  impersonatedInformPartnerUserId?: Maybe<StringNullableFilter>;
  impersonatedUser?: Maybe<UserNullableScalarRelationFilter>;
  impersonatedUserId?: Maybe<StringNullableFilter>;
  informPartnerUser?: Maybe<InformPartnerUserNullableScalarRelationFilter>;
  informPartnerUserId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userFirebaseId?: Maybe<StringNullableFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type UserImpersonationWhereUniqueInput = {
  AND?: Maybe<Array<UserImpersonationWhereInput>>;
  NOT?: Maybe<Array<UserImpersonationWhereInput>>;
  OR?: Maybe<Array<UserImpersonationWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  impersonatedInformPartnerUser?: Maybe<InformPartnerUserNullableScalarRelationFilter>;
  impersonatedInformPartnerUserId?: Maybe<StringNullableFilter>;
  impersonatedUser?: Maybe<UserNullableScalarRelationFilter>;
  impersonatedUserId?: Maybe<StringNullableFilter>;
  informPartnerUser?: Maybe<InformPartnerUserNullableScalarRelationFilter>;
  informPartnerUserId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  userFirebaseId?: Maybe<StringNullableFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type UserListRelationFilter = {
  every?: Maybe<UserWhereInput>;
  none?: Maybe<UserWhereInput>;
  some?: Maybe<UserWhereInput>;
};

export type UserMaxAggregateOutputType = {
  __typename?: 'UserMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invitationCode?: Maybe<SortOrder>;
  invitedAt?: Maybe<SortOrder>;
  invitedById?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAdmin?: Maybe<SortOrder>;
  isNewPasswordRequired?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  mediaId?: Maybe<SortOrder>;
  nameDisplay?: Maybe<SortOrder>;
  namePrefix?: Maybe<SortOrder>;
  nameSuffix?: Maybe<SortOrder>;
  ownerInfoId?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  profilePic?: Maybe<SortOrder>;
  signUpDate?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userSettingId?: Maybe<SortOrder>;
  vetInfoId?: Maybe<SortOrder>;
};

export type UserMinAggregateOutputType = {
  __typename?: 'UserMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invitationCode?: Maybe<SortOrder>;
  invitedAt?: Maybe<SortOrder>;
  invitedById?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAdmin?: Maybe<SortOrder>;
  isNewPasswordRequired?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  mediaId?: Maybe<SortOrder>;
  nameDisplay?: Maybe<SortOrder>;
  namePrefix?: Maybe<SortOrder>;
  nameSuffix?: Maybe<SortOrder>;
  ownerInfoId?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  profilePic?: Maybe<SortOrder>;
  signUpDate?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userSettingId?: Maybe<SortOrder>;
  vetInfoId?: Maybe<SortOrder>;
};

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  emailEnabled: Scalars['Boolean'];
  id: Scalars['String'];
  pushNotificationEnabled: Scalars['Boolean'];
  settingType: NotificationSettingType;
  smsEnabled: Scalars['Boolean'];
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userSetting?: Maybe<UserSetting>;
  userSettingId?: Maybe<Scalars['String']>;
};


export type UserNotificationSettingUserSettingArgs = {
  where?: Maybe<UserSettingWhereInput>;
};

export type UserNotificationSettingCountAggregateOutputType = {
  __typename?: 'UserNotificationSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  browserNotificationEnabled: Scalars['Int'];
  createdAt: Scalars['Int'];
  emailEnabled: Scalars['Int'];
  id: Scalars['Int'];
  pushNotificationEnabled: Scalars['Int'];
  settingType: Scalars['Int'];
  smsEnabled: Scalars['Int'];
  soundNotificationUrl: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userSettingId: Scalars['Int'];
};

export type UserNotificationSettingCountOrderByAggregateInput = {
  browserNotificationEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pushNotificationEnabled?: Maybe<SortOrder>;
  settingType?: Maybe<SortOrder>;
  smsEnabled?: Maybe<SortOrder>;
  soundNotificationUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userSettingId?: Maybe<SortOrder>;
};

export type UserNotificationSettingCreateInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType: NotificationSettingType;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingCreateNestedOneWithoutNotificationSettingsInput>;
};

export type UserNotificationSettingCreateManyInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType: NotificationSettingType;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
};

export type UserNotificationSettingCreateManyUserSettingInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType: NotificationSettingType;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserNotificationSettingCreateManyUserSettingInputEnvelope = {
  data: Array<UserNotificationSettingCreateManyUserSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserNotificationSettingCreateNestedManyWithoutUserSettingInput = {
  connect?: Maybe<Array<UserNotificationSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserNotificationSettingCreateOrConnectWithoutUserSettingInput>>;
  create?: Maybe<Array<UserNotificationSettingCreateWithoutUserSettingInput>>;
  createMany?: Maybe<UserNotificationSettingCreateManyUserSettingInputEnvelope>;
};

export type UserNotificationSettingCreateOrConnectWithoutUserSettingInput = {
  create: UserNotificationSettingCreateWithoutUserSettingInput;
  where: UserNotificationSettingWhereUniqueInput;
};

export type UserNotificationSettingCreateWithoutUserSettingInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType: NotificationSettingType;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserNotificationSettingGroupByOutputType = {
  __typename?: 'UserNotificationSettingGroupByOutputType';
  _count?: Maybe<UserNotificationSettingCountAggregateOutputType>;
  _max?: Maybe<UserNotificationSettingMaxAggregateOutputType>;
  _min?: Maybe<UserNotificationSettingMinAggregateOutputType>;
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  emailEnabled: Scalars['Boolean'];
  id: Scalars['String'];
  pushNotificationEnabled: Scalars['Boolean'];
  settingType: NotificationSettingType;
  smsEnabled: Scalars['Boolean'];
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userSettingId?: Maybe<Scalars['String']>;
};

export type UserNotificationSettingListRelationFilter = {
  every?: Maybe<UserNotificationSettingWhereInput>;
  none?: Maybe<UserNotificationSettingWhereInput>;
  some?: Maybe<UserNotificationSettingWhereInput>;
};

export type UserNotificationSettingMaxAggregateOutputType = {
  __typename?: 'UserNotificationSettingMaxAggregateOutputType';
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType?: Maybe<NotificationSettingType>;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
};

export type UserNotificationSettingMaxOrderByAggregateInput = {
  browserNotificationEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pushNotificationEnabled?: Maybe<SortOrder>;
  settingType?: Maybe<SortOrder>;
  smsEnabled?: Maybe<SortOrder>;
  soundNotificationUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userSettingId?: Maybe<SortOrder>;
};

export type UserNotificationSettingMinAggregateOutputType = {
  __typename?: 'UserNotificationSettingMinAggregateOutputType';
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType?: Maybe<NotificationSettingType>;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
};

export type UserNotificationSettingMinOrderByAggregateInput = {
  browserNotificationEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pushNotificationEnabled?: Maybe<SortOrder>;
  settingType?: Maybe<SortOrder>;
  smsEnabled?: Maybe<SortOrder>;
  soundNotificationUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userSettingId?: Maybe<SortOrder>;
};

export type UserNotificationSettingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserNotificationSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserNotificationSettingOrderByRelevanceInput>;
  browserNotificationEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pushNotificationEnabled?: Maybe<SortOrder>;
  settingType?: Maybe<SortOrder>;
  smsEnabled?: Maybe<SortOrder>;
  soundNotificationUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userSetting?: Maybe<UserSettingOrderByWithRelationInput>;
  userSettingId?: Maybe<SortOrder>;
};

export enum UserNotificationSettingOrderByRelevanceFieldEnum {
  Id = 'id',
  SoundNotificationUrl = 'soundNotificationUrl',
  UserSettingId = 'userSettingId'
}

export type UserNotificationSettingOrderByRelevanceInput = {
  fields: Array<UserNotificationSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UserNotificationSettingOrderByWithAggregationInput = {
  _count?: Maybe<UserNotificationSettingCountOrderByAggregateInput>;
  _max?: Maybe<UserNotificationSettingMaxOrderByAggregateInput>;
  _min?: Maybe<UserNotificationSettingMinOrderByAggregateInput>;
  browserNotificationEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pushNotificationEnabled?: Maybe<SortOrder>;
  settingType?: Maybe<SortOrder>;
  smsEnabled?: Maybe<SortOrder>;
  soundNotificationUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userSettingId?: Maybe<SortOrder>;
};

export type UserNotificationSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserNotificationSettingOrderByRelevanceInput>;
  browserNotificationEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pushNotificationEnabled?: Maybe<SortOrder>;
  settingType?: Maybe<SortOrder>;
  smsEnabled?: Maybe<SortOrder>;
  soundNotificationUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userSetting?: Maybe<UserSettingOrderByWithRelationInput>;
  userSettingId?: Maybe<SortOrder>;
};

export type UserNotificationSettingOrderByWithRelationInput = {
  _relevance?: Maybe<UserNotificationSettingOrderByRelevanceInput>;
  browserNotificationEnabled?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailEnabled?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  pushNotificationEnabled?: Maybe<SortOrder>;
  settingType?: Maybe<SortOrder>;
  smsEnabled?: Maybe<SortOrder>;
  soundNotificationUrl?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userSetting?: Maybe<UserSettingOrderByWithRelationInput>;
  userSettingId?: Maybe<SortOrder>;
};

export enum UserNotificationSettingScalarFieldEnum {
  BrowserNotificationEnabled = 'browserNotificationEnabled',
  CreatedAt = 'createdAt',
  EmailEnabled = 'emailEnabled',
  Id = 'id',
  PushNotificationEnabled = 'pushNotificationEnabled',
  SettingType = 'settingType',
  SmsEnabled = 'smsEnabled',
  SoundNotificationUrl = 'soundNotificationUrl',
  UpdatedAt = 'updatedAt',
  UserSettingId = 'userSettingId'
}

export type UserNotificationSettingScalarWhereInput = {
  AND?: Maybe<Array<UserNotificationSettingScalarWhereInput>>;
  NOT?: Maybe<Array<UserNotificationSettingScalarWhereInput>>;
  OR?: Maybe<Array<UserNotificationSettingScalarWhereInput>>;
  browserNotificationEnabled?: Maybe<BoolNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailEnabled?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  pushNotificationEnabled?: Maybe<BoolFilter>;
  settingType?: Maybe<EnumNotificationSettingTypeFilter>;
  smsEnabled?: Maybe<BoolFilter>;
  soundNotificationUrl?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userSettingId?: Maybe<StringNullableFilter>;
};

export type UserNotificationSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserNotificationSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UserNotificationSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserNotificationSettingScalarWhereWithAggregatesInput>>;
  browserNotificationEnabled?: Maybe<BoolNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  emailEnabled?: Maybe<BoolWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  pushNotificationEnabled?: Maybe<BoolWithAggregatesFilter>;
  settingType?: Maybe<EnumNotificationSettingTypeWithAggregatesFilter>;
  smsEnabled?: Maybe<BoolWithAggregatesFilter>;
  soundNotificationUrl?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userSettingId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type UserNotificationSettingUncheckedCreateInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType: NotificationSettingType;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
};

export type UserNotificationSettingUncheckedCreateNestedManyWithoutUserSettingInput = {
  connect?: Maybe<Array<UserNotificationSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserNotificationSettingCreateOrConnectWithoutUserSettingInput>>;
  create?: Maybe<Array<UserNotificationSettingCreateWithoutUserSettingInput>>;
  createMany?: Maybe<UserNotificationSettingCreateManyUserSettingInputEnvelope>;
};

export type UserNotificationSettingUncheckedCreateWithoutUserSettingInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType: NotificationSettingType;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserNotificationSettingUncheckedUpdateInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType?: Maybe<NotificationSettingType>;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
};

export type UserNotificationSettingUncheckedUpdateManyInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType?: Maybe<NotificationSettingType>;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
};

export type UserNotificationSettingUncheckedUpdateManyWithoutUserSettingInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType?: Maybe<NotificationSettingType>;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserNotificationSettingUncheckedUpdateManyWithoutUserSettingNestedInput = {
  connect?: Maybe<Array<UserNotificationSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserNotificationSettingCreateOrConnectWithoutUserSettingInput>>;
  create?: Maybe<Array<UserNotificationSettingCreateWithoutUserSettingInput>>;
  createMany?: Maybe<UserNotificationSettingCreateManyUserSettingInputEnvelope>;
  delete?: Maybe<Array<UserNotificationSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserNotificationSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<UserNotificationSettingWhereUniqueInput>>;
  set?: Maybe<Array<UserNotificationSettingWhereUniqueInput>>;
  update?: Maybe<Array<UserNotificationSettingUpdateWithWhereUniqueWithoutUserSettingInput>>;
  updateMany?: Maybe<Array<UserNotificationSettingUpdateManyWithWhereWithoutUserSettingInput>>;
  upsert?: Maybe<Array<UserNotificationSettingUpsertWithWhereUniqueWithoutUserSettingInput>>;
};

export type UserNotificationSettingUncheckedUpdateWithoutUserSettingInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType?: Maybe<NotificationSettingType>;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserNotificationSettingUpdateInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType?: Maybe<NotificationSettingType>;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutNotificationSettingsNestedInput>;
};

export type UserNotificationSettingUpdateManyMutationInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType?: Maybe<NotificationSettingType>;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserNotificationSettingUpdateManyWithWhereWithoutUserSettingInput = {
  data: UserNotificationSettingUpdateManyMutationInput;
  where: UserNotificationSettingScalarWhereInput;
};

export type UserNotificationSettingUpdateManyWithoutUserSettingNestedInput = {
  connect?: Maybe<Array<UserNotificationSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserNotificationSettingCreateOrConnectWithoutUserSettingInput>>;
  create?: Maybe<Array<UserNotificationSettingCreateWithoutUserSettingInput>>;
  createMany?: Maybe<UserNotificationSettingCreateManyUserSettingInputEnvelope>;
  delete?: Maybe<Array<UserNotificationSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserNotificationSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<UserNotificationSettingWhereUniqueInput>>;
  set?: Maybe<Array<UserNotificationSettingWhereUniqueInput>>;
  update?: Maybe<Array<UserNotificationSettingUpdateWithWhereUniqueWithoutUserSettingInput>>;
  updateMany?: Maybe<Array<UserNotificationSettingUpdateManyWithWhereWithoutUserSettingInput>>;
  upsert?: Maybe<Array<UserNotificationSettingUpsertWithWhereUniqueWithoutUserSettingInput>>;
};

export type UserNotificationSettingUpdateWithWhereUniqueWithoutUserSettingInput = {
  data: UserNotificationSettingUpdateWithoutUserSettingInput;
  where: UserNotificationSettingWhereUniqueInput;
};

export type UserNotificationSettingUpdateWithoutUserSettingInput = {
  browserNotificationEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  settingType?: Maybe<NotificationSettingType>;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  soundNotificationUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserNotificationSettingUpsertWithWhereUniqueWithoutUserSettingInput = {
  create: UserNotificationSettingCreateWithoutUserSettingInput;
  update: UserNotificationSettingUpdateWithoutUserSettingInput;
  where: UserNotificationSettingWhereUniqueInput;
};

export type UserNotificationSettingWhereInput = {
  AND?: Maybe<Array<UserNotificationSettingWhereInput>>;
  NOT?: Maybe<Array<UserNotificationSettingWhereInput>>;
  OR?: Maybe<Array<UserNotificationSettingWhereInput>>;
  browserNotificationEnabled?: Maybe<BoolNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailEnabled?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  pushNotificationEnabled?: Maybe<BoolFilter>;
  settingType?: Maybe<EnumNotificationSettingTypeFilter>;
  smsEnabled?: Maybe<BoolFilter>;
  soundNotificationUrl?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userSetting?: Maybe<UserSettingNullableScalarRelationFilter>;
  userSettingId?: Maybe<StringNullableFilter>;
};

export type UserNotificationSettingWhereUniqueInput = {
  AND?: Maybe<Array<UserNotificationSettingWhereInput>>;
  NOT?: Maybe<Array<UserNotificationSettingWhereInput>>;
  OR?: Maybe<Array<UserNotificationSettingWhereInput>>;
  browserNotificationEnabled?: Maybe<BoolNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailEnabled?: Maybe<BoolFilter>;
  id?: Maybe<Scalars['String']>;
  pushNotificationEnabled?: Maybe<BoolFilter>;
  settingType?: Maybe<EnumNotificationSettingTypeFilter>;
  smsEnabled?: Maybe<BoolFilter>;
  soundNotificationUrl?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userSetting?: Maybe<UserSettingNullableScalarRelationFilter>;
  userSettingId?: Maybe<StringNullableFilter>;
};

export type UserNullableScalarRelationFilter = {
  AND?: Maybe<Array<UserWhereInput>>;
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateListRelationFilter>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentListRelationFilter>;
  EmailCampaign?: Maybe<EmailCampaignListRelationFilter>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateListRelationFilter>;
  EmailCampaignUpdated?: Maybe<EmailCampaignListRelationFilter>;
  EmailCampaignsCreated?: Maybe<EmailCampaignListRelationFilter>;
  EmailCampaignsSent?: Maybe<EmailCampaignListRelationFilter>;
  NOT?: Maybe<Array<UserWhereInput>>;
  OR?: Maybe<Array<UserWhereInput>>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationListRelationFilter>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationListRelationFilter>;
  UserTaskList?: Maybe<UserTaskListListRelationFilter>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationListRelationFilter>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberListRelationFilter>;
  boardFilters?: Maybe<UserBoardFilterListRelationFilter>;
  calls?: Maybe<CallParticipantListRelationFilter>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  channelMembers?: Maybe<ChannelMemberListRelationFilter>;
  channelMessageReactions?: Maybe<ChannelMessageReactionListRelationFilter>;
  channelMessagesWithMentions?: Maybe<ChannelMessageListRelationFilter>;
  channelSelections?: Maybe<ChannelSelectionListRelationFilter>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeListRelationFilter>;
  channelStatuses?: Maybe<ChannelStatusListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  clinicUserFilters?: Maybe<ClinicUserFilterListRelationFilter>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  clinics?: Maybe<ClinicListRelationFilter>;
  clinicsId?: Maybe<ClinicListRelationFilter>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepListRelationFilter>;
  consultationChats?: Maybe<ConsultationChatListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodListRelationFilter>;
  crmId?: Maybe<StringNullableFilter>;
  email?: Maybe<StringFilter>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionListRelationFilter>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadListRelationFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firstName?: Maybe<StringFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  id?: Maybe<StringFilter>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientListRelationFilter>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentListRelationFilter>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingListRelationFilter>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerListRelationFilter>;
  invitationCode?: Maybe<StringNullableFilter>;
  invitations?: Maybe<UserListRelationFilter>;
  invitedAt?: Maybe<DateTimeNullableFilter>;
  invitedBy?: Maybe<UserNullableScalarRelationFilter>;
  invitedById?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isAdmin?: Maybe<BoolNullableFilter>;
  isNewPasswordRequired?: Maybe<BoolFilter>;
  lastName?: Maybe<StringFilter>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberListRelationFilter>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantListRelationFilter>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  manuallySentAutomationRuns?: Maybe<AutomationRunListRelationFilter>;
  massTextAlerts?: Maybe<MassTextAlertListRelationFilter>;
  media?: Maybe<MediaNullableScalarRelationFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  messageTemplates?: Maybe<MessageTemplateListRelationFilter>;
  nameDisplay?: Maybe<StringNullableFilter>;
  namePrefix?: Maybe<StringNullableFilter>;
  nameSuffix?: Maybe<StringNullableFilter>;
  ownerInfo?: Maybe<OwnerInfoNullableScalarRelationFilter>;
  ownerInfoId?: Maybe<StringNullableFilter>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingListRelationFilter>;
  phone?: Maybe<StringNullableFilter>;
  pinnedChannels?: Maybe<ChannelPinListRelationFilter>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  profilePic?: Maybe<StringNullableFilter>;
  recaps?: Maybe<RecapListRelationFilter>;
  refundsIssued?: Maybe<StripeRefundListRelationFilter>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  reviews?: Maybe<ReviewListRelationFilter>;
  sentInvoices?: Maybe<InvoiceListRelationFilter>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  signUpDate?: Maybe<DateTimeNullableFilter>;
  signupDetails?: Maybe<JsonNullableFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryListRelationFilter>;
  type?: Maybe<EnumUserTypeFilter>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  usagesRecorded?: Maybe<CareBenefitUsageListRelationFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionListRelationFilter>;
  userSetting?: Maybe<UserSettingNullableScalarRelationFilter>;
  userSettingId?: Maybe<StringNullableFilter>;
  validatedCanonicalServices?: Maybe<CanonicalServiceListRelationFilter>;
  vetInfo?: Maybe<VetInfoNullableScalarRelationFilter>;
  vetInfoId?: Maybe<StringNullableFilter>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserOrderByRelationAndSearchRelevanceInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateOrderByRelationAggregateInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentOrderByRelationAggregateInput>;
  EmailCampaign?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateOrderByRelationAggregateInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationOrderByRelationAggregateInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationOrderByRelationAggregateInput>;
  UserTaskList?: Maybe<UserTaskListOrderByRelationAggregateInput>;
  _relevance?: Maybe<UserOrderByRelevanceInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationOrderByRelationAggregateInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberOrderByRelationAggregateInput>;
  boardFilters?: Maybe<UserBoardFilterOrderByRelationAggregateInput>;
  calls?: Maybe<CallParticipantOrderByRelationAggregateInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  channelMembers?: Maybe<ChannelMemberOrderByRelationAggregateInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionOrderByRelationAggregateInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageOrderByRelationAggregateInput>;
  channelSelections?: Maybe<ChannelSelectionOrderByRelationAggregateInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeOrderByRelationAggregateInput>;
  channelStatuses?: Maybe<ChannelStatusOrderByRelationAggregateInput>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterOrderByRelationAggregateInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  clinicsId?: Maybe<ClinicOrderByRelationAggregateInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepOrderByRelationAggregateInput>;
  consultationChats?: Maybe<ConsultationChatOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodOrderByRelationAggregateInput>;
  crmId?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionOrderByRelationAggregateInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadOrderByRelationAggregateInput>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientOrderByRelationAggregateInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentOrderByRelationAggregateInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingOrderByRelationAggregateInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerOrderByRelationAggregateInput>;
  invitationCode?: Maybe<SortOrder>;
  invitations?: Maybe<UserOrderByRelationAggregateInput>;
  invitedAt?: Maybe<SortOrder>;
  invitedBy?: Maybe<UserOrderByWithRelationInput>;
  invitedById?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAdmin?: Maybe<SortOrder>;
  isNewPasswordRequired?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberOrderByRelationAggregateInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantOrderByRelationAggregateInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  massTextAlerts?: Maybe<MassTextAlertOrderByRelationAggregateInput>;
  media?: Maybe<MediaOrderByWithRelationInput>;
  mediaId?: Maybe<SortOrder>;
  messageTemplates?: Maybe<MessageTemplateOrderByRelationAggregateInput>;
  nameDisplay?: Maybe<SortOrder>;
  namePrefix?: Maybe<SortOrder>;
  nameSuffix?: Maybe<SortOrder>;
  ownerInfo?: Maybe<OwnerInfoOrderByWithRelationInput>;
  ownerInfoId?: Maybe<SortOrder>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingOrderByRelationAggregateInput>;
  phone?: Maybe<SortOrder>;
  pinnedChannels?: Maybe<ChannelPinOrderByRelationAggregateInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  profilePic?: Maybe<SortOrder>;
  recaps?: Maybe<RecapOrderByRelationAggregateInput>;
  refundsIssued?: Maybe<StripeRefundOrderByRelationAggregateInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  reviews?: Maybe<ReviewOrderByRelationAggregateInput>;
  sentInvoices?: Maybe<InvoiceOrderByRelationAggregateInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  signUpDate?: Maybe<SortOrder>;
  signupDetails?: Maybe<SortOrder>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  usagesRecorded?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionOrderByRelationAggregateInput>;
  userSetting?: Maybe<UserSettingOrderByWithRelationInput>;
  userSettingId?: Maybe<SortOrder>;
  validatedCanonicalServices?: Maybe<CanonicalServiceOrderByRelationAggregateInput>;
  vetInfo?: Maybe<VetInfoOrderByWithRelationInput>;
  vetInfoId?: Maybe<SortOrder>;
};

export enum UserOrderByRelevanceFieldEnum {
  CrmId = 'crmId',
  Email = 'email',
  FirebaseId = 'firebaseId',
  FirstName = 'firstName',
  Id = 'id',
  InvitationCode = 'invitationCode',
  InvitedById = 'invitedById',
  LastName = 'lastName',
  MediaId = 'mediaId',
  NameDisplay = 'nameDisplay',
  NamePrefix = 'namePrefix',
  NameSuffix = 'nameSuffix',
  OwnerInfoId = 'ownerInfoId',
  Phone = 'phone',
  ProfilePic = 'profilePic',
  UserSettingId = 'userSettingId',
  VetInfoId = 'vetInfoId'
}

export type UserOrderByRelevanceInput = {
  fields: Array<UserOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UserOrderByWithAggregationInput = {
  _count?: Maybe<UserCountOrderByAggregateInput>;
  _max?: Maybe<UserMaxOrderByAggregateInput>;
  _min?: Maybe<UserMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  crmId?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  invitationCode?: Maybe<SortOrder>;
  invitedAt?: Maybe<SortOrder>;
  invitedById?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAdmin?: Maybe<SortOrder>;
  isNewPasswordRequired?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  mediaId?: Maybe<SortOrder>;
  nameDisplay?: Maybe<SortOrder>;
  namePrefix?: Maybe<SortOrder>;
  nameSuffix?: Maybe<SortOrder>;
  ownerInfoId?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  profilePic?: Maybe<SortOrder>;
  signUpDate?: Maybe<SortOrder>;
  signupDetails?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userSettingId?: Maybe<SortOrder>;
  vetInfoId?: Maybe<SortOrder>;
};

export type UserOrderByWithRelationAndSearchRelevanceInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateOrderByRelationAggregateInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentOrderByRelationAggregateInput>;
  EmailCampaign?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateOrderByRelationAggregateInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationOrderByRelationAggregateInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationOrderByRelationAggregateInput>;
  UserTaskList?: Maybe<UserTaskListOrderByRelationAggregateInput>;
  _relevance?: Maybe<UserOrderByRelevanceInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationOrderByRelationAggregateInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberOrderByRelationAggregateInput>;
  boardFilters?: Maybe<UserBoardFilterOrderByRelationAggregateInput>;
  calls?: Maybe<CallParticipantOrderByRelationAggregateInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  channelMembers?: Maybe<ChannelMemberOrderByRelationAggregateInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionOrderByRelationAggregateInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageOrderByRelationAggregateInput>;
  channelSelections?: Maybe<ChannelSelectionOrderByRelationAggregateInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeOrderByRelationAggregateInput>;
  channelStatuses?: Maybe<ChannelStatusOrderByRelationAggregateInput>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterOrderByRelationAggregateInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  clinicsId?: Maybe<ClinicOrderByRelationAggregateInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepOrderByRelationAggregateInput>;
  consultationChats?: Maybe<ConsultationChatOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodOrderByRelationAggregateInput>;
  crmId?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionOrderByRelationAggregateInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadOrderByRelationAggregateInput>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientOrderByRelationAggregateInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentOrderByRelationAggregateInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingOrderByRelationAggregateInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerOrderByRelationAggregateInput>;
  invitationCode?: Maybe<SortOrder>;
  invitations?: Maybe<UserOrderByRelationAggregateInput>;
  invitedAt?: Maybe<SortOrder>;
  invitedBy?: Maybe<UserOrderByWithRelationInput>;
  invitedById?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAdmin?: Maybe<SortOrder>;
  isNewPasswordRequired?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberOrderByRelationAggregateInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantOrderByRelationAggregateInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  massTextAlerts?: Maybe<MassTextAlertOrderByRelationAggregateInput>;
  media?: Maybe<MediaOrderByWithRelationInput>;
  mediaId?: Maybe<SortOrder>;
  messageTemplates?: Maybe<MessageTemplateOrderByRelationAggregateInput>;
  nameDisplay?: Maybe<SortOrder>;
  namePrefix?: Maybe<SortOrder>;
  nameSuffix?: Maybe<SortOrder>;
  ownerInfo?: Maybe<OwnerInfoOrderByWithRelationInput>;
  ownerInfoId?: Maybe<SortOrder>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingOrderByRelationAggregateInput>;
  phone?: Maybe<SortOrder>;
  pinnedChannels?: Maybe<ChannelPinOrderByRelationAggregateInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  profilePic?: Maybe<SortOrder>;
  recaps?: Maybe<RecapOrderByRelationAggregateInput>;
  refundsIssued?: Maybe<StripeRefundOrderByRelationAggregateInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  reviews?: Maybe<ReviewOrderByRelationAggregateInput>;
  sentInvoices?: Maybe<InvoiceOrderByRelationAggregateInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  signUpDate?: Maybe<SortOrder>;
  signupDetails?: Maybe<SortOrder>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  usagesRecorded?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionOrderByRelationAggregateInput>;
  userSetting?: Maybe<UserSettingOrderByWithRelationInput>;
  userSettingId?: Maybe<SortOrder>;
  validatedCanonicalServices?: Maybe<CanonicalServiceOrderByRelationAggregateInput>;
  vetInfo?: Maybe<VetInfoOrderByWithRelationInput>;
  vetInfoId?: Maybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateOrderByRelationAggregateInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentOrderByRelationAggregateInput>;
  EmailCampaign?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateOrderByRelationAggregateInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignOrderByRelationAggregateInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationOrderByRelationAggregateInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationOrderByRelationAggregateInput>;
  UserTaskList?: Maybe<UserTaskListOrderByRelationAggregateInput>;
  _relevance?: Maybe<UserOrderByRelevanceInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationOrderByRelationAggregateInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberOrderByRelationAggregateInput>;
  boardFilters?: Maybe<UserBoardFilterOrderByRelationAggregateInput>;
  calls?: Maybe<CallParticipantOrderByRelationAggregateInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  channelMembers?: Maybe<ChannelMemberOrderByRelationAggregateInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionOrderByRelationAggregateInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageOrderByRelationAggregateInput>;
  channelSelections?: Maybe<ChannelSelectionOrderByRelationAggregateInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeOrderByRelationAggregateInput>;
  channelStatuses?: Maybe<ChannelStatusOrderByRelationAggregateInput>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  clinicPetParents?: Maybe<ClinicPetParentOrderByRelationAggregateInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterOrderByRelationAggregateInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  clinicsId?: Maybe<ClinicOrderByRelationAggregateInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepOrderByRelationAggregateInput>;
  consultationChats?: Maybe<ConsultationChatOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodOrderByRelationAggregateInput>;
  crmId?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionOrderByRelationAggregateInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadOrderByRelationAggregateInput>;
  firebaseId?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  formSubmissions?: Maybe<FormSubmissionOrderByRelationAggregateInput>;
  id?: Maybe<SortOrder>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientOrderByRelationAggregateInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentOrderByRelationAggregateInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingOrderByRelationAggregateInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerOrderByRelationAggregateInput>;
  invitationCode?: Maybe<SortOrder>;
  invitations?: Maybe<UserOrderByRelationAggregateInput>;
  invitedAt?: Maybe<SortOrder>;
  invitedBy?: Maybe<UserOrderByWithRelationInput>;
  invitedById?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAdmin?: Maybe<SortOrder>;
  isNewPasswordRequired?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberOrderByRelationAggregateInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantOrderByRelationAggregateInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryOrderByRelationAggregateInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  massTextAlerts?: Maybe<MassTextAlertOrderByRelationAggregateInput>;
  media?: Maybe<MediaOrderByWithRelationInput>;
  mediaId?: Maybe<SortOrder>;
  messageTemplates?: Maybe<MessageTemplateOrderByRelationAggregateInput>;
  nameDisplay?: Maybe<SortOrder>;
  namePrefix?: Maybe<SortOrder>;
  nameSuffix?: Maybe<SortOrder>;
  ownerInfo?: Maybe<OwnerInfoOrderByWithRelationInput>;
  ownerInfoId?: Maybe<SortOrder>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingOrderByRelationAggregateInput>;
  phone?: Maybe<SortOrder>;
  pinnedChannels?: Maybe<ChannelPinOrderByRelationAggregateInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  profilePic?: Maybe<SortOrder>;
  recaps?: Maybe<RecapOrderByRelationAggregateInput>;
  refundsIssued?: Maybe<StripeRefundOrderByRelationAggregateInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventOrderByRelationAggregateInput>;
  reviews?: Maybe<ReviewOrderByRelationAggregateInput>;
  sentInvoices?: Maybe<InvoiceOrderByRelationAggregateInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentOrderByRelationAggregateInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferOrderByRelationAggregateInput>;
  signUpDate?: Maybe<SortOrder>;
  signupDetails?: Maybe<SortOrder>;
  tasks?: Maybe<TaskOrderByRelationAggregateInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryOrderByRelationAggregateInput>;
  type?: Maybe<SortOrder>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  usagesRecorded?: Maybe<CareBenefitUsageOrderByRelationAggregateInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingOrderByRelationAggregateInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionOrderByRelationAggregateInput>;
  userSetting?: Maybe<UserSettingOrderByWithRelationInput>;
  userSettingId?: Maybe<SortOrder>;
  validatedCanonicalServices?: Maybe<CanonicalServiceOrderByRelationAggregateInput>;
  vetInfo?: Maybe<VetInfoOrderByWithRelationInput>;
  vetInfoId?: Maybe<SortOrder>;
};

export enum UserScalarFieldEnum {
  CreatedAt = 'createdAt',
  CrmId = 'crmId',
  Email = 'email',
  FirebaseId = 'firebaseId',
  FirstName = 'firstName',
  Id = 'id',
  InvitationCode = 'invitationCode',
  InvitedAt = 'invitedAt',
  InvitedById = 'invitedById',
  IsActive = 'isActive',
  IsAdmin = 'isAdmin',
  IsNewPasswordRequired = 'isNewPasswordRequired',
  LastName = 'lastName',
  MediaId = 'mediaId',
  NameDisplay = 'nameDisplay',
  NamePrefix = 'namePrefix',
  NameSuffix = 'nameSuffix',
  OwnerInfoId = 'ownerInfoId',
  Phone = 'phone',
  ProfilePic = 'profilePic',
  SignUpDate = 'signUpDate',
  SignupDetails = 'signupDetails',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserSettingId = 'userSettingId',
  VetInfoId = 'vetInfoId'
}

export type UserScalarRelationFilter = {
  AND?: Maybe<Array<UserWhereInput>>;
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateListRelationFilter>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentListRelationFilter>;
  EmailCampaign?: Maybe<EmailCampaignListRelationFilter>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateListRelationFilter>;
  EmailCampaignUpdated?: Maybe<EmailCampaignListRelationFilter>;
  EmailCampaignsCreated?: Maybe<EmailCampaignListRelationFilter>;
  EmailCampaignsSent?: Maybe<EmailCampaignListRelationFilter>;
  NOT?: Maybe<Array<UserWhereInput>>;
  OR?: Maybe<Array<UserWhereInput>>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationListRelationFilter>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationListRelationFilter>;
  UserTaskList?: Maybe<UserTaskListListRelationFilter>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationListRelationFilter>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberListRelationFilter>;
  boardFilters?: Maybe<UserBoardFilterListRelationFilter>;
  calls?: Maybe<CallParticipantListRelationFilter>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  channelMembers?: Maybe<ChannelMemberListRelationFilter>;
  channelMessageReactions?: Maybe<ChannelMessageReactionListRelationFilter>;
  channelMessagesWithMentions?: Maybe<ChannelMessageListRelationFilter>;
  channelSelections?: Maybe<ChannelSelectionListRelationFilter>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeListRelationFilter>;
  channelStatuses?: Maybe<ChannelStatusListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  clinicUserFilters?: Maybe<ClinicUserFilterListRelationFilter>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  clinics?: Maybe<ClinicListRelationFilter>;
  clinicsId?: Maybe<ClinicListRelationFilter>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepListRelationFilter>;
  consultationChats?: Maybe<ConsultationChatListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodListRelationFilter>;
  crmId?: Maybe<StringNullableFilter>;
  email?: Maybe<StringFilter>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionListRelationFilter>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadListRelationFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firstName?: Maybe<StringFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  id?: Maybe<StringFilter>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientListRelationFilter>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentListRelationFilter>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingListRelationFilter>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerListRelationFilter>;
  invitationCode?: Maybe<StringNullableFilter>;
  invitations?: Maybe<UserListRelationFilter>;
  invitedAt?: Maybe<DateTimeNullableFilter>;
  invitedBy?: Maybe<UserNullableScalarRelationFilter>;
  invitedById?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isAdmin?: Maybe<BoolNullableFilter>;
  isNewPasswordRequired?: Maybe<BoolFilter>;
  lastName?: Maybe<StringFilter>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberListRelationFilter>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantListRelationFilter>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  manuallySentAutomationRuns?: Maybe<AutomationRunListRelationFilter>;
  massTextAlerts?: Maybe<MassTextAlertListRelationFilter>;
  media?: Maybe<MediaNullableScalarRelationFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  messageTemplates?: Maybe<MessageTemplateListRelationFilter>;
  nameDisplay?: Maybe<StringNullableFilter>;
  namePrefix?: Maybe<StringNullableFilter>;
  nameSuffix?: Maybe<StringNullableFilter>;
  ownerInfo?: Maybe<OwnerInfoNullableScalarRelationFilter>;
  ownerInfoId?: Maybe<StringNullableFilter>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingListRelationFilter>;
  phone?: Maybe<StringNullableFilter>;
  pinnedChannels?: Maybe<ChannelPinListRelationFilter>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  profilePic?: Maybe<StringNullableFilter>;
  recaps?: Maybe<RecapListRelationFilter>;
  refundsIssued?: Maybe<StripeRefundListRelationFilter>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  reviews?: Maybe<ReviewListRelationFilter>;
  sentInvoices?: Maybe<InvoiceListRelationFilter>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  signUpDate?: Maybe<DateTimeNullableFilter>;
  signupDetails?: Maybe<JsonNullableFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryListRelationFilter>;
  type?: Maybe<EnumUserTypeFilter>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  usagesRecorded?: Maybe<CareBenefitUsageListRelationFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionListRelationFilter>;
  userSetting?: Maybe<UserSettingNullableScalarRelationFilter>;
  userSettingId?: Maybe<StringNullableFilter>;
  validatedCanonicalServices?: Maybe<CanonicalServiceListRelationFilter>;
  vetInfo?: Maybe<VetInfoNullableScalarRelationFilter>;
  vetInfoId?: Maybe<StringNullableFilter>;
};

export type UserScalarWhereInput = {
  AND?: Maybe<Array<UserScalarWhereInput>>;
  NOT?: Maybe<Array<UserScalarWhereInput>>;
  OR?: Maybe<Array<UserScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  crmId?: Maybe<StringNullableFilter>;
  email?: Maybe<StringFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firstName?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  invitationCode?: Maybe<StringNullableFilter>;
  invitedAt?: Maybe<DateTimeNullableFilter>;
  invitedById?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isAdmin?: Maybe<BoolNullableFilter>;
  isNewPasswordRequired?: Maybe<BoolFilter>;
  lastName?: Maybe<StringFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  nameDisplay?: Maybe<StringNullableFilter>;
  namePrefix?: Maybe<StringNullableFilter>;
  nameSuffix?: Maybe<StringNullableFilter>;
  ownerInfoId?: Maybe<StringNullableFilter>;
  phone?: Maybe<StringNullableFilter>;
  profilePic?: Maybe<StringNullableFilter>;
  signUpDate?: Maybe<DateTimeNullableFilter>;
  signupDetails?: Maybe<JsonNullableFilter>;
  type?: Maybe<EnumUserTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userSettingId?: Maybe<StringNullableFilter>;
  vetInfoId?: Maybe<StringNullableFilter>;
};

export type UserScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UserScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  crmId?: Maybe<StringNullableWithAggregatesFilter>;
  email?: Maybe<StringWithAggregatesFilter>;
  firebaseId?: Maybe<StringNullableWithAggregatesFilter>;
  firstName?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  invitationCode?: Maybe<StringNullableWithAggregatesFilter>;
  invitedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  invitedById?: Maybe<StringNullableWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  isAdmin?: Maybe<BoolNullableWithAggregatesFilter>;
  isNewPasswordRequired?: Maybe<BoolWithAggregatesFilter>;
  lastName?: Maybe<StringWithAggregatesFilter>;
  mediaId?: Maybe<StringNullableWithAggregatesFilter>;
  nameDisplay?: Maybe<StringNullableWithAggregatesFilter>;
  namePrefix?: Maybe<StringNullableWithAggregatesFilter>;
  nameSuffix?: Maybe<StringNullableWithAggregatesFilter>;
  ownerInfoId?: Maybe<StringNullableWithAggregatesFilter>;
  phone?: Maybe<StringNullableWithAggregatesFilter>;
  profilePic?: Maybe<StringNullableWithAggregatesFilter>;
  signUpDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  signupDetails?: Maybe<JsonNullableWithAggregatesFilter>;
  type?: Maybe<EnumUserTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userSettingId?: Maybe<StringNullableWithAggregatesFilter>;
  vetInfoId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type UserSetting = {
  __typename?: 'UserSetting';
  _count: UserSettingCountOutputType;
  browserNotificationFilter?: Maybe<ChannelSelection>;
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emailNotifications: Scalars['Boolean'];
  enterAddsNewLine: Scalars['Boolean'];
  hideSummaryButton: Scalars['Boolean'];
  id: Scalars['String'];
  leftNavPanel: Scalars['Boolean'];
  notificationSettings: Array<UserNotificationSetting>;
  pushNotifications: Scalars['Boolean'];
  skipLoadingAnimation: Scalars['Boolean'];
  smsNotifications: Scalars['Boolean'];
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  user: Array<User>;
};


export type UserSettingBrowserNotificationFilterArgs = {
  where?: Maybe<ChannelSelectionWhereInput>;
};


export type UserSettingNotificationSettingsArgs = {
  cursor?: Maybe<UserNotificationSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserNotificationSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserNotificationSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserNotificationSettingWhereInput>;
};


export type UserSettingUserArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};

export type UserSettingCountAggregateOutputType = {
  __typename?: 'UserSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  browserNotificationFilterId: Scalars['Int'];
  createdAt: Scalars['Int'];
  emailNotifications: Scalars['Int'];
  enterAddsNewLine: Scalars['Int'];
  hideSummaryButton: Scalars['Int'];
  id: Scalars['Int'];
  leftNavPanel: Scalars['Int'];
  pushNotifications: Scalars['Int'];
  skipLoadingAnimation: Scalars['Int'];
  smsNotifications: Scalars['Int'];
  snoozeNotificationsUntil: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type UserSettingCountOrderByAggregateInput = {
  browserNotificationFilterId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  enterAddsNewLine?: Maybe<SortOrder>;
  hideSummaryButton?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  leftNavPanel?: Maybe<SortOrder>;
  pushNotifications?: Maybe<SortOrder>;
  skipLoadingAnimation?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  snoozeNotificationsUntil?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UserSettingCountOutputType = {
  __typename?: 'UserSettingCountOutputType';
  notificationSettings: Scalars['Int'];
  user: Scalars['Int'];
};

export type UserSettingCreateInput = {
  browserNotificationFilter?: Maybe<ChannelSelectionCreateNestedOneWithoutUserSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  notificationSettings?: Maybe<UserNotificationSettingCreateNestedManyWithoutUserSettingInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedManyWithoutUserSettingInput>;
};

export type UserSettingCreateManyInput = {
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserSettingCreateNestedOneWithoutBrowserNotificationFilterInput = {
  connect?: Maybe<UserSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<UserSettingCreateOrConnectWithoutBrowserNotificationFilterInput>;
  create?: Maybe<UserSettingCreateWithoutBrowserNotificationFilterInput>;
};

export type UserSettingCreateNestedOneWithoutNotificationSettingsInput = {
  connect?: Maybe<UserSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<UserSettingCreateOrConnectWithoutNotificationSettingsInput>;
  create?: Maybe<UserSettingCreateWithoutNotificationSettingsInput>;
};

export type UserSettingCreateNestedOneWithoutUserInput = {
  connect?: Maybe<UserSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<UserSettingCreateOrConnectWithoutUserInput>;
  create?: Maybe<UserSettingCreateWithoutUserInput>;
};

export type UserSettingCreateOrConnectWithoutBrowserNotificationFilterInput = {
  create: UserSettingCreateWithoutBrowserNotificationFilterInput;
  where: UserSettingWhereUniqueInput;
};

export type UserSettingCreateOrConnectWithoutNotificationSettingsInput = {
  create: UserSettingCreateWithoutNotificationSettingsInput;
  where: UserSettingWhereUniqueInput;
};

export type UserSettingCreateOrConnectWithoutUserInput = {
  create: UserSettingCreateWithoutUserInput;
  where: UserSettingWhereUniqueInput;
};

export type UserSettingCreateWithoutBrowserNotificationFilterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  notificationSettings?: Maybe<UserNotificationSettingCreateNestedManyWithoutUserSettingInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedManyWithoutUserSettingInput>;
};

export type UserSettingCreateWithoutNotificationSettingsInput = {
  browserNotificationFilter?: Maybe<ChannelSelectionCreateNestedOneWithoutUserSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedManyWithoutUserSettingInput>;
};

export type UserSettingCreateWithoutUserInput = {
  browserNotificationFilter?: Maybe<ChannelSelectionCreateNestedOneWithoutUserSettingInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  notificationSettings?: Maybe<UserNotificationSettingCreateNestedManyWithoutUserSettingInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserSettingGroupByOutputType = {
  __typename?: 'UserSettingGroupByOutputType';
  _count?: Maybe<UserSettingCountAggregateOutputType>;
  _max?: Maybe<UserSettingMaxAggregateOutputType>;
  _min?: Maybe<UserSettingMinAggregateOutputType>;
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emailNotifications: Scalars['Boolean'];
  enterAddsNewLine: Scalars['Boolean'];
  hideSummaryButton: Scalars['Boolean'];
  id: Scalars['String'];
  leftNavPanel: Scalars['Boolean'];
  pushNotifications: Scalars['Boolean'];
  skipLoadingAnimation: Scalars['Boolean'];
  smsNotifications: Scalars['Boolean'];
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type UserSettingMaxAggregateOutputType = {
  __typename?: 'UserSettingMaxAggregateOutputType';
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserSettingMaxOrderByAggregateInput = {
  browserNotificationFilterId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  enterAddsNewLine?: Maybe<SortOrder>;
  hideSummaryButton?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  leftNavPanel?: Maybe<SortOrder>;
  pushNotifications?: Maybe<SortOrder>;
  skipLoadingAnimation?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  snoozeNotificationsUntil?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UserSettingMinAggregateOutputType = {
  __typename?: 'UserSettingMinAggregateOutputType';
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserSettingMinOrderByAggregateInput = {
  browserNotificationFilterId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  enterAddsNewLine?: Maybe<SortOrder>;
  hideSummaryButton?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  leftNavPanel?: Maybe<SortOrder>;
  pushNotifications?: Maybe<SortOrder>;
  skipLoadingAnimation?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  snoozeNotificationsUntil?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UserSettingNullableScalarRelationFilter = {
  AND?: Maybe<Array<UserSettingWhereInput>>;
  NOT?: Maybe<Array<UserSettingWhereInput>>;
  OR?: Maybe<Array<UserSettingWhereInput>>;
  browserNotificationFilter?: Maybe<ChannelSelectionNullableScalarRelationFilter>;
  browserNotificationFilterId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailNotifications?: Maybe<BoolFilter>;
  enterAddsNewLine?: Maybe<BoolFilter>;
  hideSummaryButton?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  leftNavPanel?: Maybe<BoolFilter>;
  notificationSettings?: Maybe<UserNotificationSettingListRelationFilter>;
  pushNotifications?: Maybe<BoolFilter>;
  skipLoadingAnimation?: Maybe<BoolFilter>;
  smsNotifications?: Maybe<BoolFilter>;
  snoozeNotificationsUntil?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserListRelationFilter>;
};

export type UserSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserSettingOrderByRelevanceInput>;
  browserNotificationFilter?: Maybe<ChannelSelectionOrderByWithRelationInput>;
  browserNotificationFilterId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  enterAddsNewLine?: Maybe<SortOrder>;
  hideSummaryButton?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  leftNavPanel?: Maybe<SortOrder>;
  notificationSettings?: Maybe<UserNotificationSettingOrderByRelationAggregateInput>;
  pushNotifications?: Maybe<SortOrder>;
  skipLoadingAnimation?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  snoozeNotificationsUntil?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByRelationAggregateInput>;
};

export enum UserSettingOrderByRelevanceFieldEnum {
  BrowserNotificationFilterId = 'browserNotificationFilterId',
  Id = 'id'
}

export type UserSettingOrderByRelevanceInput = {
  fields: Array<UserSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UserSettingOrderByWithAggregationInput = {
  _count?: Maybe<UserSettingCountOrderByAggregateInput>;
  _max?: Maybe<UserSettingMaxOrderByAggregateInput>;
  _min?: Maybe<UserSettingMinOrderByAggregateInput>;
  browserNotificationFilterId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  enterAddsNewLine?: Maybe<SortOrder>;
  hideSummaryButton?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  leftNavPanel?: Maybe<SortOrder>;
  pushNotifications?: Maybe<SortOrder>;
  skipLoadingAnimation?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  snoozeNotificationsUntil?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UserSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserSettingOrderByRelevanceInput>;
  browserNotificationFilter?: Maybe<ChannelSelectionOrderByWithRelationInput>;
  browserNotificationFilterId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  enterAddsNewLine?: Maybe<SortOrder>;
  hideSummaryButton?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  leftNavPanel?: Maybe<SortOrder>;
  notificationSettings?: Maybe<UserNotificationSettingOrderByRelationAggregateInput>;
  pushNotifications?: Maybe<SortOrder>;
  skipLoadingAnimation?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  snoozeNotificationsUntil?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByRelationAggregateInput>;
};

export type UserSettingOrderByWithRelationInput = {
  _relevance?: Maybe<UserSettingOrderByRelevanceInput>;
  browserNotificationFilter?: Maybe<ChannelSelectionOrderByWithRelationInput>;
  browserNotificationFilterId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  emailNotifications?: Maybe<SortOrder>;
  enterAddsNewLine?: Maybe<SortOrder>;
  hideSummaryButton?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  leftNavPanel?: Maybe<SortOrder>;
  notificationSettings?: Maybe<UserNotificationSettingOrderByRelationAggregateInput>;
  pushNotifications?: Maybe<SortOrder>;
  skipLoadingAnimation?: Maybe<SortOrder>;
  smsNotifications?: Maybe<SortOrder>;
  snoozeNotificationsUntil?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByRelationAggregateInput>;
};

export enum UserSettingScalarFieldEnum {
  BrowserNotificationFilterId = 'browserNotificationFilterId',
  CreatedAt = 'createdAt',
  EmailNotifications = 'emailNotifications',
  EnterAddsNewLine = 'enterAddsNewLine',
  HideSummaryButton = 'hideSummaryButton',
  Id = 'id',
  LeftNavPanel = 'leftNavPanel',
  PushNotifications = 'pushNotifications',
  SkipLoadingAnimation = 'skipLoadingAnimation',
  SmsNotifications = 'smsNotifications',
  SnoozeNotificationsUntil = 'snoozeNotificationsUntil',
  UpdatedAt = 'updatedAt'
}

export type UserSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UserSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserSettingScalarWhereWithAggregatesInput>>;
  browserNotificationFilterId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  emailNotifications?: Maybe<BoolWithAggregatesFilter>;
  enterAddsNewLine?: Maybe<BoolWithAggregatesFilter>;
  hideSummaryButton?: Maybe<BoolWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  leftNavPanel?: Maybe<BoolWithAggregatesFilter>;
  pushNotifications?: Maybe<BoolWithAggregatesFilter>;
  skipLoadingAnimation?: Maybe<BoolWithAggregatesFilter>;
  smsNotifications?: Maybe<BoolWithAggregatesFilter>;
  snoozeNotificationsUntil?: Maybe<DateTimeNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type UserSettingUncheckedCreateInput = {
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  notificationSettings?: Maybe<UserNotificationSettingUncheckedCreateNestedManyWithoutUserSettingInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedManyWithoutUserSettingInput>;
};

export type UserSettingUncheckedCreateNestedOneWithoutBrowserNotificationFilterInput = {
  connect?: Maybe<UserSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<UserSettingCreateOrConnectWithoutBrowserNotificationFilterInput>;
  create?: Maybe<UserSettingCreateWithoutBrowserNotificationFilterInput>;
};

export type UserSettingUncheckedCreateWithoutBrowserNotificationFilterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  notificationSettings?: Maybe<UserNotificationSettingUncheckedCreateNestedManyWithoutUserSettingInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedManyWithoutUserSettingInput>;
};

export type UserSettingUncheckedCreateWithoutNotificationSettingsInput = {
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedManyWithoutUserSettingInput>;
};

export type UserSettingUncheckedCreateWithoutUserInput = {
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  notificationSettings?: Maybe<UserNotificationSettingUncheckedCreateNestedManyWithoutUserSettingInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserSettingUncheckedUpdateInput = {
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  notificationSettings?: Maybe<UserNotificationSettingUncheckedUpdateManyWithoutUserSettingNestedInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateManyWithoutUserSettingNestedInput>;
};

export type UserSettingUncheckedUpdateManyInput = {
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserSettingUncheckedUpdateOneWithoutBrowserNotificationFilterNestedInput = {
  connect?: Maybe<UserSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<UserSettingCreateOrConnectWithoutBrowserNotificationFilterInput>;
  create?: Maybe<UserSettingCreateWithoutBrowserNotificationFilterInput>;
  delete?: Maybe<UserSettingWhereInput>;
  disconnect?: Maybe<UserSettingWhereInput>;
  update?: Maybe<UserSettingUpdateToOneWithWhereWithoutBrowserNotificationFilterInput>;
  upsert?: Maybe<UserSettingUpsertWithoutBrowserNotificationFilterInput>;
};

export type UserSettingUncheckedUpdateWithoutBrowserNotificationFilterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  notificationSettings?: Maybe<UserNotificationSettingUncheckedUpdateManyWithoutUserSettingNestedInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateManyWithoutUserSettingNestedInput>;
};

export type UserSettingUncheckedUpdateWithoutNotificationSettingsInput = {
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateManyWithoutUserSettingNestedInput>;
};

export type UserSettingUncheckedUpdateWithoutUserInput = {
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  notificationSettings?: Maybe<UserNotificationSettingUncheckedUpdateManyWithoutUserSettingNestedInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserSettingUpdateInput = {
  browserNotificationFilter?: Maybe<ChannelSelectionUpdateOneWithoutUserSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  notificationSettings?: Maybe<UserNotificationSettingUpdateManyWithoutUserSettingNestedInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateManyWithoutUserSettingNestedInput>;
};

export type UserSettingUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserSettingUpdateOneWithoutBrowserNotificationFilterNestedInput = {
  connect?: Maybe<UserSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<UserSettingCreateOrConnectWithoutBrowserNotificationFilterInput>;
  create?: Maybe<UserSettingCreateWithoutBrowserNotificationFilterInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserSettingUpdateToOneWithWhereWithoutBrowserNotificationFilterInput>;
  upsert?: Maybe<UserSettingUpsertWithoutBrowserNotificationFilterInput>;
};

export type UserSettingUpdateOneWithoutNotificationSettingsNestedInput = {
  connect?: Maybe<UserSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<UserSettingCreateOrConnectWithoutNotificationSettingsInput>;
  create?: Maybe<UserSettingCreateWithoutNotificationSettingsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserSettingUpdateToOneWithWhereWithoutNotificationSettingsInput>;
  upsert?: Maybe<UserSettingUpsertWithoutNotificationSettingsInput>;
};

export type UserSettingUpdateOneWithoutUserNestedInput = {
  connect?: Maybe<UserSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<UserSettingCreateOrConnectWithoutUserInput>;
  create?: Maybe<UserSettingCreateWithoutUserInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserSettingUpdateToOneWithWhereWithoutUserInput>;
  upsert?: Maybe<UserSettingUpsertWithoutUserInput>;
};

export type UserSettingUpdateToOneWithWhereWithoutBrowserNotificationFilterInput = {
  data: UserSettingUpdateWithoutBrowserNotificationFilterInput;
  where?: Maybe<UserSettingWhereInput>;
};

export type UserSettingUpdateToOneWithWhereWithoutNotificationSettingsInput = {
  data: UserSettingUpdateWithoutNotificationSettingsInput;
  where?: Maybe<UserSettingWhereInput>;
};

export type UserSettingUpdateToOneWithWhereWithoutUserInput = {
  data: UserSettingUpdateWithoutUserInput;
  where?: Maybe<UserSettingWhereInput>;
};

export type UserSettingUpdateWithoutBrowserNotificationFilterInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  notificationSettings?: Maybe<UserNotificationSettingUpdateManyWithoutUserSettingNestedInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateManyWithoutUserSettingNestedInput>;
};

export type UserSettingUpdateWithoutNotificationSettingsInput = {
  browserNotificationFilter?: Maybe<ChannelSelectionUpdateOneWithoutUserSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateManyWithoutUserSettingNestedInput>;
};

export type UserSettingUpdateWithoutUserInput = {
  browserNotificationFilter?: Maybe<ChannelSelectionUpdateOneWithoutUserSettingNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotifications?: Maybe<Scalars['Boolean']>;
  enterAddsNewLine?: Maybe<Scalars['Boolean']>;
  hideSummaryButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<Scalars['Boolean']>;
  notificationSettings?: Maybe<UserNotificationSettingUpdateManyWithoutUserSettingNestedInput>;
  pushNotifications?: Maybe<Scalars['Boolean']>;
  skipLoadingAnimation?: Maybe<Scalars['Boolean']>;
  smsNotifications?: Maybe<Scalars['Boolean']>;
  snoozeNotificationsUntil?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserSettingUpsertWithoutBrowserNotificationFilterInput = {
  create: UserSettingCreateWithoutBrowserNotificationFilterInput;
  update: UserSettingUpdateWithoutBrowserNotificationFilterInput;
  where?: Maybe<UserSettingWhereInput>;
};

export type UserSettingUpsertWithoutNotificationSettingsInput = {
  create: UserSettingCreateWithoutNotificationSettingsInput;
  update: UserSettingUpdateWithoutNotificationSettingsInput;
  where?: Maybe<UserSettingWhereInput>;
};

export type UserSettingUpsertWithoutUserInput = {
  create: UserSettingCreateWithoutUserInput;
  update: UserSettingUpdateWithoutUserInput;
  where?: Maybe<UserSettingWhereInput>;
};

export type UserSettingWhereInput = {
  AND?: Maybe<Array<UserSettingWhereInput>>;
  NOT?: Maybe<Array<UserSettingWhereInput>>;
  OR?: Maybe<Array<UserSettingWhereInput>>;
  browserNotificationFilter?: Maybe<ChannelSelectionNullableScalarRelationFilter>;
  browserNotificationFilterId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  emailNotifications?: Maybe<BoolFilter>;
  enterAddsNewLine?: Maybe<BoolFilter>;
  hideSummaryButton?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  leftNavPanel?: Maybe<BoolFilter>;
  notificationSettings?: Maybe<UserNotificationSettingListRelationFilter>;
  pushNotifications?: Maybe<BoolFilter>;
  skipLoadingAnimation?: Maybe<BoolFilter>;
  smsNotifications?: Maybe<BoolFilter>;
  snoozeNotificationsUntil?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserListRelationFilter>;
};

export type UserSettingWhereUniqueInput = {
  AND?: Maybe<Array<UserSettingWhereInput>>;
  NOT?: Maybe<Array<UserSettingWhereInput>>;
  OR?: Maybe<Array<UserSettingWhereInput>>;
  browserNotificationFilter?: Maybe<ChannelSelectionNullableScalarRelationFilter>;
  browserNotificationFilterId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  emailNotifications?: Maybe<BoolFilter>;
  enterAddsNewLine?: Maybe<BoolFilter>;
  hideSummaryButton?: Maybe<BoolFilter>;
  id?: Maybe<Scalars['String']>;
  leftNavPanel?: Maybe<BoolFilter>;
  notificationSettings?: Maybe<UserNotificationSettingListRelationFilter>;
  pushNotifications?: Maybe<BoolFilter>;
  skipLoadingAnimation?: Maybe<BoolFilter>;
  smsNotifications?: Maybe<BoolFilter>;
  snoozeNotificationsUntil?: Maybe<DateTimeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserListRelationFilter>;
};

export type UserTaskList = {
  __typename?: 'UserTaskList';
  _count: UserTaskListCountOutputType;
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  taskFilters: Array<UserTaskListFilter>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};


export type UserTaskListClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type UserTaskListTaskFiltersArgs = {
  cursor?: Maybe<UserTaskListFilterWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<UserTaskListFilterScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<UserTaskListFilterOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserTaskListFilterWhereInput>;
};

export type UserTaskListCountAggregateOutputType = {
  __typename?: 'UserTaskListCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  color: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UserTaskListCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserTaskListCountOutputType = {
  __typename?: 'UserTaskListCountOutputType';
  taskFilters: Scalars['Int'];
};

export type UserTaskListCreateInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutUserTaskListsInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  taskFilters?: Maybe<UserTaskListFilterCreateNestedManyWithoutUserTaskListInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutUserTaskListInput;
};

export type UserTaskListCreateManyClinicInput = {
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type UserTaskListCreateManyClinicInputEnvelope = {
  data: Array<UserTaskListCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserTaskListCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type UserTaskListCreateManyUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListCreateManyUserInputEnvelope = {
  data: Array<UserTaskListCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserTaskListCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserTaskListCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<UserTaskListCreateWithoutClinicInput>>;
  createMany?: Maybe<UserTaskListCreateManyClinicInputEnvelope>;
};

export type UserTaskListCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserTaskListCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserTaskListCreateWithoutUserInput>>;
  createMany?: Maybe<UserTaskListCreateManyUserInputEnvelope>;
};

export type UserTaskListCreateNestedOneWithoutTaskFiltersInput = {
  connect?: Maybe<UserTaskListWhereUniqueInput>;
  connectOrCreate?: Maybe<UserTaskListCreateOrConnectWithoutTaskFiltersInput>;
  create?: Maybe<UserTaskListCreateWithoutTaskFiltersInput>;
};

export type UserTaskListCreateOrConnectWithoutClinicInput = {
  create: UserTaskListCreateWithoutClinicInput;
  where: UserTaskListWhereUniqueInput;
};

export type UserTaskListCreateOrConnectWithoutTaskFiltersInput = {
  create: UserTaskListCreateWithoutTaskFiltersInput;
  where: UserTaskListWhereUniqueInput;
};

export type UserTaskListCreateOrConnectWithoutUserInput = {
  create: UserTaskListCreateWithoutUserInput;
  where: UserTaskListWhereUniqueInput;
};

export type UserTaskListCreateWithoutClinicInput = {
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  taskFilters?: Maybe<UserTaskListFilterCreateNestedManyWithoutUserTaskListInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutUserTaskListInput;
};

export type UserTaskListCreateWithoutTaskFiltersInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutUserTaskListsInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutUserTaskListInput;
};

export type UserTaskListCreateWithoutUserInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutUserTaskListsInput>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  taskFilters?: Maybe<UserTaskListFilterCreateNestedManyWithoutUserTaskListInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListFilter = {
  __typename?: 'UserTaskListFilter';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  metadata: Scalars['Json'];
  taskType?: Maybe<TaskType>;
  updatedAt: Scalars['DateTime'];
  userTaskList: UserTaskList;
  userTaskListId: Scalars['String'];
};

export type UserTaskListFilterCountAggregateOutputType = {
  __typename?: 'UserTaskListFilterCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  metadata: Scalars['Int'];
  taskType: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userTaskListId: Scalars['Int'];
};

export type UserTaskListFilterCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  metadata?: Maybe<SortOrder>;
  taskType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userTaskListId?: Maybe<SortOrder>;
};

export type UserTaskListFilterCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userTaskList: UserTaskListCreateNestedOneWithoutTaskFiltersInput;
};

export type UserTaskListFilterCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userTaskListId: Scalars['String'];
};

export type UserTaskListFilterCreateManyUserTaskListInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListFilterCreateManyUserTaskListInputEnvelope = {
  data: Array<UserTaskListFilterCreateManyUserTaskListInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserTaskListFilterCreateNestedManyWithoutUserTaskListInput = {
  connect?: Maybe<Array<UserTaskListFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserTaskListFilterCreateOrConnectWithoutUserTaskListInput>>;
  create?: Maybe<Array<UserTaskListFilterCreateWithoutUserTaskListInput>>;
  createMany?: Maybe<UserTaskListFilterCreateManyUserTaskListInputEnvelope>;
};

export type UserTaskListFilterCreateOrConnectWithoutUserTaskListInput = {
  create: UserTaskListFilterCreateWithoutUserTaskListInput;
  where: UserTaskListFilterWhereUniqueInput;
};

export type UserTaskListFilterCreateWithoutUserTaskListInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListFilterGroupByOutputType = {
  __typename?: 'UserTaskListFilterGroupByOutputType';
  _count?: Maybe<UserTaskListFilterCountAggregateOutputType>;
  _max?: Maybe<UserTaskListFilterMaxAggregateOutputType>;
  _min?: Maybe<UserTaskListFilterMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  metadata: Scalars['Json'];
  taskType?: Maybe<TaskType>;
  updatedAt: Scalars['DateTime'];
  userTaskListId: Scalars['String'];
};

export type UserTaskListFilterListRelationFilter = {
  every?: Maybe<UserTaskListFilterWhereInput>;
  none?: Maybe<UserTaskListFilterWhereInput>;
  some?: Maybe<UserTaskListFilterWhereInput>;
};

export type UserTaskListFilterMaxAggregateOutputType = {
  __typename?: 'UserTaskListFilterMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userTaskListId?: Maybe<Scalars['String']>;
};

export type UserTaskListFilterMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  taskType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userTaskListId?: Maybe<SortOrder>;
};

export type UserTaskListFilterMinAggregateOutputType = {
  __typename?: 'UserTaskListFilterMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userTaskListId?: Maybe<Scalars['String']>;
};

export type UserTaskListFilterMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  taskType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userTaskListId?: Maybe<SortOrder>;
};

export type UserTaskListFilterOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserTaskListFilterOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserTaskListFilterOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  metadata?: Maybe<SortOrder>;
  taskType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userTaskList?: Maybe<UserTaskListOrderByWithRelationInput>;
  userTaskListId?: Maybe<SortOrder>;
};

export enum UserTaskListFilterOrderByRelevanceFieldEnum {
  Id = 'id',
  UserTaskListId = 'userTaskListId'
}

export type UserTaskListFilterOrderByRelevanceInput = {
  fields: Array<UserTaskListFilterOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UserTaskListFilterOrderByWithAggregationInput = {
  _count?: Maybe<UserTaskListFilterCountOrderByAggregateInput>;
  _max?: Maybe<UserTaskListFilterMaxOrderByAggregateInput>;
  _min?: Maybe<UserTaskListFilterMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  metadata?: Maybe<SortOrder>;
  taskType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userTaskListId?: Maybe<SortOrder>;
};

export type UserTaskListFilterOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserTaskListFilterOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  metadata?: Maybe<SortOrder>;
  taskType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userTaskList?: Maybe<UserTaskListOrderByWithRelationInput>;
  userTaskListId?: Maybe<SortOrder>;
};

export type UserTaskListFilterOrderByWithRelationInput = {
  _relevance?: Maybe<UserTaskListFilterOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  metadata?: Maybe<SortOrder>;
  taskType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userTaskList?: Maybe<UserTaskListOrderByWithRelationInput>;
  userTaskListId?: Maybe<SortOrder>;
};

export enum UserTaskListFilterScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Metadata = 'metadata',
  TaskType = 'taskType',
  UpdatedAt = 'updatedAt',
  UserTaskListId = 'userTaskListId'
}

export type UserTaskListFilterScalarWhereInput = {
  AND?: Maybe<Array<UserTaskListFilterScalarWhereInput>>;
  NOT?: Maybe<Array<UserTaskListFilterScalarWhereInput>>;
  OR?: Maybe<Array<UserTaskListFilterScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  metadata?: Maybe<JsonFilter>;
  taskType?: Maybe<EnumTaskTypeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userTaskListId?: Maybe<StringFilter>;
};

export type UserTaskListFilterScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserTaskListFilterScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UserTaskListFilterScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserTaskListFilterScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  metadata?: Maybe<JsonWithAggregatesFilter>;
  taskType?: Maybe<EnumTaskTypeNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userTaskListId?: Maybe<StringWithAggregatesFilter>;
};

export type UserTaskListFilterUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userTaskListId: Scalars['String'];
};

export type UserTaskListFilterUncheckedCreateNestedManyWithoutUserTaskListInput = {
  connect?: Maybe<Array<UserTaskListFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserTaskListFilterCreateOrConnectWithoutUserTaskListInput>>;
  create?: Maybe<Array<UserTaskListFilterCreateWithoutUserTaskListInput>>;
  createMany?: Maybe<UserTaskListFilterCreateManyUserTaskListInputEnvelope>;
};

export type UserTaskListFilterUncheckedCreateWithoutUserTaskListInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListFilterUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userTaskListId?: Maybe<Scalars['String']>;
};

export type UserTaskListFilterUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userTaskListId?: Maybe<Scalars['String']>;
};

export type UserTaskListFilterUncheckedUpdateManyWithoutUserTaskListInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListFilterUncheckedUpdateManyWithoutUserTaskListNestedInput = {
  connect?: Maybe<Array<UserTaskListFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserTaskListFilterCreateOrConnectWithoutUserTaskListInput>>;
  create?: Maybe<Array<UserTaskListFilterCreateWithoutUserTaskListInput>>;
  createMany?: Maybe<UserTaskListFilterCreateManyUserTaskListInputEnvelope>;
  delete?: Maybe<Array<UserTaskListFilterWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserTaskListFilterScalarWhereInput>>;
  disconnect?: Maybe<Array<UserTaskListFilterWhereUniqueInput>>;
  set?: Maybe<Array<UserTaskListFilterWhereUniqueInput>>;
  update?: Maybe<Array<UserTaskListFilterUpdateWithWhereUniqueWithoutUserTaskListInput>>;
  updateMany?: Maybe<Array<UserTaskListFilterUpdateManyWithWhereWithoutUserTaskListInput>>;
  upsert?: Maybe<Array<UserTaskListFilterUpsertWithWhereUniqueWithoutUserTaskListInput>>;
};

export type UserTaskListFilterUncheckedUpdateWithoutUserTaskListInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListFilterUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userTaskList?: Maybe<UserTaskListUpdateOneRequiredWithoutTaskFiltersNestedInput>;
};

export type UserTaskListFilterUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListFilterUpdateManyWithWhereWithoutUserTaskListInput = {
  data: UserTaskListFilterUpdateManyMutationInput;
  where: UserTaskListFilterScalarWhereInput;
};

export type UserTaskListFilterUpdateManyWithoutUserTaskListNestedInput = {
  connect?: Maybe<Array<UserTaskListFilterWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserTaskListFilterCreateOrConnectWithoutUserTaskListInput>>;
  create?: Maybe<Array<UserTaskListFilterCreateWithoutUserTaskListInput>>;
  createMany?: Maybe<UserTaskListFilterCreateManyUserTaskListInputEnvelope>;
  delete?: Maybe<Array<UserTaskListFilterWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserTaskListFilterScalarWhereInput>>;
  disconnect?: Maybe<Array<UserTaskListFilterWhereUniqueInput>>;
  set?: Maybe<Array<UserTaskListFilterWhereUniqueInput>>;
  update?: Maybe<Array<UserTaskListFilterUpdateWithWhereUniqueWithoutUserTaskListInput>>;
  updateMany?: Maybe<Array<UserTaskListFilterUpdateManyWithWhereWithoutUserTaskListInput>>;
  upsert?: Maybe<Array<UserTaskListFilterUpsertWithWhereUniqueWithoutUserTaskListInput>>;
};

export type UserTaskListFilterUpdateWithWhereUniqueWithoutUserTaskListInput = {
  data: UserTaskListFilterUpdateWithoutUserTaskListInput;
  where: UserTaskListFilterWhereUniqueInput;
};

export type UserTaskListFilterUpdateWithoutUserTaskListInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  taskType?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListFilterUpsertWithWhereUniqueWithoutUserTaskListInput = {
  create: UserTaskListFilterCreateWithoutUserTaskListInput;
  update: UserTaskListFilterUpdateWithoutUserTaskListInput;
  where: UserTaskListFilterWhereUniqueInput;
};

export type UserTaskListFilterWhereInput = {
  AND?: Maybe<Array<UserTaskListFilterWhereInput>>;
  NOT?: Maybe<Array<UserTaskListFilterWhereInput>>;
  OR?: Maybe<Array<UserTaskListFilterWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  metadata?: Maybe<JsonFilter>;
  taskType?: Maybe<EnumTaskTypeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userTaskList?: Maybe<UserTaskListScalarRelationFilter>;
  userTaskListId?: Maybe<StringFilter>;
};

export type UserTaskListFilterWhereUniqueInput = {
  AND?: Maybe<Array<UserTaskListFilterWhereInput>>;
  NOT?: Maybe<Array<UserTaskListFilterWhereInput>>;
  OR?: Maybe<Array<UserTaskListFilterWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<JsonFilter>;
  taskType?: Maybe<EnumTaskTypeNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userTaskList?: Maybe<UserTaskListScalarRelationFilter>;
  userTaskListId?: Maybe<StringFilter>;
};

export type UserTaskListGroupByOutputType = {
  __typename?: 'UserTaskListGroupByOutputType';
  _count?: Maybe<UserTaskListCountAggregateOutputType>;
  _max?: Maybe<UserTaskListMaxAggregateOutputType>;
  _min?: Maybe<UserTaskListMinAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type UserTaskListListRelationFilter = {
  every?: Maybe<UserTaskListWhereInput>;
  none?: Maybe<UserTaskListWhereInput>;
  some?: Maybe<UserTaskListWhereInput>;
};

export type UserTaskListMaxAggregateOutputType = {
  __typename?: 'UserTaskListMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserTaskListMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserTaskListMinAggregateOutputType = {
  __typename?: 'UserTaskListMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserTaskListMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserTaskListOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserTaskListOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserTaskListOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  taskFilters?: Maybe<UserTaskListFilterOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum UserTaskListOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Color = 'color',
  Id = 'id',
  Name = 'name',
  UserId = 'userId'
}

export type UserTaskListOrderByRelevanceInput = {
  fields: Array<UserTaskListOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UserTaskListOrderByWithAggregationInput = {
  _count?: Maybe<UserTaskListCountOrderByAggregateInput>;
  _max?: Maybe<UserTaskListMaxOrderByAggregateInput>;
  _min?: Maybe<UserTaskListMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserTaskListOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<UserTaskListOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  taskFilters?: Maybe<UserTaskListFilterOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export type UserTaskListOrderByWithRelationInput = {
  _relevance?: Maybe<UserTaskListOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  color?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  taskFilters?: Maybe<UserTaskListFilterOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum UserTaskListScalarFieldEnum {
  ClinicId = 'clinicId',
  Color = 'color',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type UserTaskListScalarRelationFilter = {
  AND?: Maybe<Array<UserTaskListWhereInput>>;
  NOT?: Maybe<Array<UserTaskListWhereInput>>;
  OR?: Maybe<Array<UserTaskListWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  color?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  taskFilters?: Maybe<UserTaskListFilterListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type UserTaskListScalarWhereInput = {
  AND?: Maybe<Array<UserTaskListScalarWhereInput>>;
  NOT?: Maybe<Array<UserTaskListScalarWhereInput>>;
  OR?: Maybe<Array<UserTaskListScalarWhereInput>>;
  clinicId?: Maybe<StringNullableFilter>;
  color?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  userId?: Maybe<StringFilter>;
};

export type UserTaskListScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserTaskListScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UserTaskListScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserTaskListScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  color?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  userId?: Maybe<StringWithAggregatesFilter>;
};

export type UserTaskListUncheckedCreateInput = {
  clinicId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  taskFilters?: Maybe<UserTaskListFilterUncheckedCreateNestedManyWithoutUserTaskListInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type UserTaskListUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserTaskListCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<UserTaskListCreateWithoutClinicInput>>;
  createMany?: Maybe<UserTaskListCreateManyClinicInputEnvelope>;
};

export type UserTaskListUncheckedCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserTaskListCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserTaskListCreateWithoutUserInput>>;
  createMany?: Maybe<UserTaskListCreateManyUserInputEnvelope>;
};

export type UserTaskListUncheckedCreateWithoutClinicInput = {
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  taskFilters?: Maybe<UserTaskListFilterUncheckedCreateNestedManyWithoutUserTaskListInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type UserTaskListUncheckedCreateWithoutTaskFiltersInput = {
  clinicId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type UserTaskListUncheckedCreateWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  taskFilters?: Maybe<UserTaskListFilterUncheckedCreateNestedManyWithoutUserTaskListInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  taskFilters?: Maybe<UserTaskListFilterUncheckedUpdateManyWithoutUserTaskListNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserTaskListUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserTaskListUncheckedUpdateManyWithoutClinicInput = {
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserTaskListUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserTaskListCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<UserTaskListCreateWithoutClinicInput>>;
  createMany?: Maybe<UserTaskListCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserTaskListScalarWhereInput>>;
  disconnect?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  set?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  update?: Maybe<Array<UserTaskListUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<UserTaskListUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<UserTaskListUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type UserTaskListUncheckedUpdateManyWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserTaskListCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserTaskListCreateWithoutUserInput>>;
  createMany?: Maybe<UserTaskListCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserTaskListScalarWhereInput>>;
  disconnect?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  set?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  update?: Maybe<Array<UserTaskListUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<UserTaskListUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<UserTaskListUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserTaskListUncheckedUpdateWithoutClinicInput = {
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  taskFilters?: Maybe<UserTaskListFilterUncheckedUpdateManyWithoutUserTaskListNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserTaskListUncheckedUpdateWithoutTaskFiltersInput = {
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserTaskListUncheckedUpdateWithoutUserInput = {
  clinicId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  taskFilters?: Maybe<UserTaskListFilterUncheckedUpdateManyWithoutUserTaskListNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutUserTaskListsNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  taskFilters?: Maybe<UserTaskListFilterUpdateManyWithoutUserTaskListNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneRequiredWithoutUserTaskListNestedInput>;
};

export type UserTaskListUpdateManyMutationInput = {
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListUpdateManyWithWhereWithoutClinicInput = {
  data: UserTaskListUpdateManyMutationInput;
  where: UserTaskListScalarWhereInput;
};

export type UserTaskListUpdateManyWithWhereWithoutUserInput = {
  data: UserTaskListUpdateManyMutationInput;
  where: UserTaskListScalarWhereInput;
};

export type UserTaskListUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserTaskListCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<UserTaskListCreateWithoutClinicInput>>;
  createMany?: Maybe<UserTaskListCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserTaskListScalarWhereInput>>;
  disconnect?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  set?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  update?: Maybe<Array<UserTaskListUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<UserTaskListUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<UserTaskListUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type UserTaskListUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserTaskListCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserTaskListCreateWithoutUserInput>>;
  createMany?: Maybe<UserTaskListCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserTaskListScalarWhereInput>>;
  disconnect?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  set?: Maybe<Array<UserTaskListWhereUniqueInput>>;
  update?: Maybe<Array<UserTaskListUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<UserTaskListUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<UserTaskListUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserTaskListUpdateOneRequiredWithoutTaskFiltersNestedInput = {
  connect?: Maybe<UserTaskListWhereUniqueInput>;
  connectOrCreate?: Maybe<UserTaskListCreateOrConnectWithoutTaskFiltersInput>;
  create?: Maybe<UserTaskListCreateWithoutTaskFiltersInput>;
  update?: Maybe<UserTaskListUpdateToOneWithWhereWithoutTaskFiltersInput>;
  upsert?: Maybe<UserTaskListUpsertWithoutTaskFiltersInput>;
};

export type UserTaskListUpdateToOneWithWhereWithoutTaskFiltersInput = {
  data: UserTaskListUpdateWithoutTaskFiltersInput;
  where?: Maybe<UserTaskListWhereInput>;
};

export type UserTaskListUpdateWithWhereUniqueWithoutClinicInput = {
  data: UserTaskListUpdateWithoutClinicInput;
  where: UserTaskListWhereUniqueInput;
};

export type UserTaskListUpdateWithWhereUniqueWithoutUserInput = {
  data: UserTaskListUpdateWithoutUserInput;
  where: UserTaskListWhereUniqueInput;
};

export type UserTaskListUpdateWithoutClinicInput = {
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  taskFilters?: Maybe<UserTaskListFilterUpdateManyWithoutUserTaskListNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneRequiredWithoutUserTaskListNestedInput>;
};

export type UserTaskListUpdateWithoutTaskFiltersInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutUserTaskListsNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneRequiredWithoutUserTaskListNestedInput>;
};

export type UserTaskListUpdateWithoutUserInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutUserTaskListsNestedInput>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  taskFilters?: Maybe<UserTaskListFilterUpdateManyWithoutUserTaskListNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserTaskListUpsertWithWhereUniqueWithoutClinicInput = {
  create: UserTaskListCreateWithoutClinicInput;
  update: UserTaskListUpdateWithoutClinicInput;
  where: UserTaskListWhereUniqueInput;
};

export type UserTaskListUpsertWithWhereUniqueWithoutUserInput = {
  create: UserTaskListCreateWithoutUserInput;
  update: UserTaskListUpdateWithoutUserInput;
  where: UserTaskListWhereUniqueInput;
};

export type UserTaskListUpsertWithoutTaskFiltersInput = {
  create: UserTaskListCreateWithoutTaskFiltersInput;
  update: UserTaskListUpdateWithoutTaskFiltersInput;
  where?: Maybe<UserTaskListWhereInput>;
};

export type UserTaskListWhereInput = {
  AND?: Maybe<Array<UserTaskListWhereInput>>;
  NOT?: Maybe<Array<UserTaskListWhereInput>>;
  OR?: Maybe<Array<UserTaskListWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  color?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  taskFilters?: Maybe<UserTaskListFilterListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export type UserTaskListWhereUniqueInput = {
  AND?: Maybe<Array<UserTaskListWhereInput>>;
  NOT?: Maybe<Array<UserTaskListWhereInput>>;
  OR?: Maybe<Array<UserTaskListWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  color?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  taskFilters?: Maybe<UserTaskListFilterListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserScalarRelationFilter>;
  userId?: Maybe<StringFilter>;
};

export enum UserType {
  Owner = 'OWNER',
  Vet = 'VET'
}

export type UserUncheckedCreateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateNestedManyWithoutChannelMessagesWithMentionsInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutChannelMessagesWithMentionsInput>>;
  create?: Maybe<Array<UserCreateWithoutChannelMessagesWithMentionsInput>>;
};

export type UserUncheckedCreateNestedManyWithoutChannelSelectionsInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutChannelSelectionsInput>>;
  create?: Maybe<Array<UserCreateWithoutChannelSelectionsInput>>;
};

export type UserUncheckedCreateNestedManyWithoutChannelsInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutChannelsInput>>;
  create?: Maybe<Array<UserCreateWithoutChannelsInput>>;
};

export type UserUncheckedCreateNestedManyWithoutClinicWidgetRequestTypesInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutClinicWidgetRequestTypesInput>>;
  create?: Maybe<Array<UserCreateWithoutClinicWidgetRequestTypesInput>>;
};

export type UserUncheckedCreateNestedManyWithoutClinicsInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<UserCreateWithoutClinicsInput>>;
};

export type UserUncheckedCreateNestedManyWithoutFormSubmissionsInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutFormSubmissionsInput>>;
  create?: Maybe<Array<UserCreateWithoutFormSubmissionsInput>>;
};

export type UserUncheckedCreateNestedManyWithoutInvitedByInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutInvitedByInput>>;
  create?: Maybe<Array<UserCreateWithoutInvitedByInput>>;
  createMany?: Maybe<UserCreateManyInvitedByInputEnvelope>;
};

export type UserUncheckedCreateNestedManyWithoutMediaInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<UserCreateWithoutMediaInput>>;
  createMany?: Maybe<UserCreateManyMediaInputEnvelope>;
};

export type UserUncheckedCreateNestedManyWithoutTasksInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutTasksInput>>;
  create?: Maybe<Array<UserCreateWithoutTasksInput>>;
};

export type UserUncheckedCreateNestedManyWithoutUserSettingInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutUserSettingInput>>;
  create?: Maybe<Array<UserCreateWithoutUserSettingInput>>;
  createMany?: Maybe<UserCreateManyUserSettingInputEnvelope>;
};

export type UserUncheckedCreateNestedOneWithoutOwnerInfoInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutOwnerInfoInput>;
  create?: Maybe<UserCreateWithoutOwnerInfoInput>;
};

export type UserUncheckedCreateNestedOneWithoutVetInfoInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutVetInfoInput>;
  create?: Maybe<UserCreateWithoutVetInfoInput>;
};

export type UserUncheckedCreateWithoutAppointmentNoteTemplateInput = {
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutAppointmentRecapNotesUpdatedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutAxionClinicUserConfigurationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutBlockedNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutBoardFiltersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutCallsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutCareBenefitUsageToInvoiceLineItemsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutChannelCreationSourcesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutChannelMembersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutChannelMessageReactionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutChannelMessagesWithMentionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutChannelSelectionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutChannelStatusChannelAssigneesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutChannelStatusesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutChannelsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutClinicPetParentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutClinicUserFiltersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutClinicWidgetRequestTypesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutClinicsIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutClinicsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutCompletedBenefitUsageFollowupStepsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutConsultationChatsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutCreatedPayoutBatchingPeriodsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutEmailCampaignInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutEmailCampaignTemplateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutEmailCampaignUpdatedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutEmailCampaignsCreatedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutEmailCampaignsSentInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutEmailTemplateVersionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutEncryptedClinicUploadsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutFormSubmissionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutInformNotificationRecipientsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutInformPrimaryContactClinicSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutIntitiatedLoyaltyAccountMergesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutInvitationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutInvitedByInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutLoaSignedClinicPhoneNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutLoyaltyPointUserGrantsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutLoyaltyRewardRedemptionActionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutManuallySentAutomationRunsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutMassTextAlertsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutMediaInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutMessageTemplatesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutOwnerInfoInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutPayoutBatchingSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutPinnedChannelsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutPointOfContactEnrollmentSupportEventsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutRecapsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutRefundsIssuedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutRequestedEnrollmentSupportEventsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutResponderEnrollmentSupportEventsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutReviewsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutSentInvoicesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutSentStripePaymentIntentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutSentTrupanionExamDayOffersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutTasksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutTriggeredWritebacksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutUnblockedNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutUsagesRecordedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutUserAppointmentGroupingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutUserChannelFilterSelectionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutUserImpersonation_UserToUserImpersonation_User_IdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutUserSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutUserTaskListInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutValidatedCanonicalServicesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutVetInfoInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedCreateNestedManyWithoutRecapNotesUpdatedByInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedCreateNestedManyWithoutUserInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutLastUpdatedByUserInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedCreateNestedManyWithoutSentByUserInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutImpersonatedUserInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedCreateNestedManyWithoutUserInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedCreateNestedManyWithoutUserInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedCreateNestedManyWithoutUserInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutBlockedByInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedCreateNestedManyWithoutUserInput>;
  calls?: Maybe<CallParticipantUncheckedCreateNestedManyWithoutUserInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedCreateNestedManyWithoutConfirmedByInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutUserInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedCreateNestedManyWithoutUserInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedCreateNestedManyWithoutUserInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedCreateNestedManyWithoutMentionedUsersInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedCreateNestedManyWithoutAssigneesInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedCreateNestedManyWithoutUserInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedCreateNestedManyWithoutDeletedByInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedCreateNestedManyWithoutUserInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedCreateNestedManyWithoutUserInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutAssigneesInput>;
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersInput>;
  clinicsId?: Maybe<ClinicUncheckedCreateNestedManyWithoutUsersIdInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedCreateNestedManyWithoutCompletedByUserInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedCreateNestedManyWithoutCreatorInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  crmId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedCreateNestedManyWithoutLastEditedByInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedCreateNestedManyWithoutUploaderUserInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  formSubmissions?: Maybe<FormSubmissionUncheckedCreateNestedManyWithoutUsersInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedCreateNestedManyWithoutUserInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedCreateNestedManyWithoutAcceptedTermsByUserInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedCreateNestedManyWithoutInformPrimaryContactUserInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedCreateNestedManyWithoutInitiatedByInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedCreateNestedManyWithoutInvitedByInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedCreateNestedManyWithoutLoaSignedByUserInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedCreateNestedManyWithoutGrantingUserInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedCreateNestedManyWithoutActingUserInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutManuallySentByInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedCreateNestedManyWithoutCreatedByUserInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedCreateNestedManyWithoutUpdatedByInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedCreateNestedManyWithoutUpdatedByUserInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedCreateNestedManyWithoutUserInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutPointOfContactInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedCreateNestedManyWithoutCreatedByInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedCreateNestedManyWithoutIssuedByInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutRequesterInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedCreateNestedManyWithoutResponderInput>;
  reviews?: Maybe<ReviewUncheckedCreateNestedManyWithoutUserInput>;
  sentInvoices?: Maybe<InvoiceUncheckedCreateNestedManyWithoutSentByInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedCreateNestedManyWithoutSentByInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedCreateNestedManyWithoutClinicUserInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedCreateNestedManyWithoutAssigneesInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedCreateNestedManyWithoutTriggeredByInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedCreateNestedManyWithoutUnblockedByInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedCreateNestedManyWithoutRecordedByUserInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedCreateNestedManyWithoutUserInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedCreateNestedManyWithoutUserInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedCreateNestedManyWithoutValidatedByUserInput>;
};

export type UserUncheckedUpdateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateManyWithoutChannelMessagesWithMentionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateManyWithoutChannelMessagesWithMentionsNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutChannelMessagesWithMentionsInput>>;
  create?: Maybe<Array<UserCreateWithoutChannelMessagesWithMentionsInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutChannelMessagesWithMentionsInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutChannelMessagesWithMentionsInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutChannelMessagesWithMentionsInput>>;
};

export type UserUncheckedUpdateManyWithoutChannelSelectionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateManyWithoutChannelSelectionsNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutChannelSelectionsInput>>;
  create?: Maybe<Array<UserCreateWithoutChannelSelectionsInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutChannelSelectionsInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutChannelSelectionsInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutChannelSelectionsInput>>;
};

export type UserUncheckedUpdateManyWithoutChannelsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateManyWithoutChannelsNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutChannelsInput>>;
  create?: Maybe<Array<UserCreateWithoutChannelsInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutChannelsInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutChannelsInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutChannelsInput>>;
};

export type UserUncheckedUpdateManyWithoutClinicWidgetRequestTypesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateManyWithoutClinicWidgetRequestTypesNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutClinicWidgetRequestTypesInput>>;
  create?: Maybe<Array<UserCreateWithoutClinicWidgetRequestTypesInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutClinicWidgetRequestTypesInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutClinicWidgetRequestTypesInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutClinicWidgetRequestTypesInput>>;
};

export type UserUncheckedUpdateManyWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateManyWithoutClinicsNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<UserCreateWithoutClinicsInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutClinicsInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutClinicsInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutClinicsInput>>;
};

export type UserUncheckedUpdateManyWithoutFormSubmissionsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateManyWithoutFormSubmissionsNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutFormSubmissionsInput>>;
  create?: Maybe<Array<UserCreateWithoutFormSubmissionsInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutFormSubmissionsInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutFormSubmissionsInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutFormSubmissionsInput>>;
};

export type UserUncheckedUpdateManyWithoutInvitedByInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateManyWithoutInvitedByNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutInvitedByInput>>;
  create?: Maybe<Array<UserCreateWithoutInvitedByInput>>;
  createMany?: Maybe<UserCreateManyInvitedByInputEnvelope>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutInvitedByInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutInvitedByInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutInvitedByInput>>;
};

export type UserUncheckedUpdateManyWithoutMediaInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateManyWithoutMediaNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<UserCreateWithoutMediaInput>>;
  createMany?: Maybe<UserCreateManyMediaInputEnvelope>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutMediaInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutMediaInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutMediaInput>>;
};

export type UserUncheckedUpdateManyWithoutTasksInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateManyWithoutTasksNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutTasksInput>>;
  create?: Maybe<Array<UserCreateWithoutTasksInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutTasksInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutTasksInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutTasksInput>>;
};

export type UserUncheckedUpdateManyWithoutUserSettingInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateManyWithoutUserSettingNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutUserSettingInput>>;
  create?: Maybe<Array<UserCreateWithoutUserSettingInput>>;
  createMany?: Maybe<UserCreateManyUserSettingInputEnvelope>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutUserSettingInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutUserSettingInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutUserSettingInput>>;
};

export type UserUncheckedUpdateOneWithoutOwnerInfoNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutOwnerInfoInput>;
  create?: Maybe<UserCreateWithoutOwnerInfoInput>;
  delete?: Maybe<UserWhereInput>;
  disconnect?: Maybe<UserWhereInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutOwnerInfoInput>;
  upsert?: Maybe<UserUpsertWithoutOwnerInfoInput>;
};

export type UserUncheckedUpdateOneWithoutVetInfoNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutVetInfoInput>;
  create?: Maybe<UserCreateWithoutVetInfoInput>;
  delete?: Maybe<UserWhereInput>;
  disconnect?: Maybe<UserWhereInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutVetInfoInput>;
  upsert?: Maybe<UserUpsertWithoutVetInfoInput>;
};

export type UserUncheckedUpdateWithoutAppointmentNoteTemplateInput = {
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutAppointmentRecapNotesUpdatedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutAxionClinicUserConfigurationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutBlockedNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutBoardFiltersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutCallsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutCareBenefitUsageToInvoiceLineItemsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutChannelCreationSourcesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutChannelMembersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutChannelMessageReactionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutChannelMessagesWithMentionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutChannelSelectionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutChannelStatusChannelAssigneesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutChannelStatusesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutChannelsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutClinicPetParentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutClinicUserFiltersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutClinicWidgetRequestTypesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutClinicsIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutClinicsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutCompletedBenefitUsageFollowupStepsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutConsultationChatsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutCreatedPayoutBatchingPeriodsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutEmailCampaignInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutEmailCampaignTemplateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutEmailCampaignUpdatedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutEmailCampaignsCreatedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutEmailCampaignsSentInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutEmailTemplateVersionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutEncryptedClinicUploadsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutFormSubmissionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutInformNotificationRecipientsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutInformPrimaryContactClinicSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutIntitiatedLoyaltyAccountMergesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutInvitationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutInvitedByInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutLoaSignedClinicPhoneNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutLoyaltyPointUserGrantsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutLoyaltyRewardRedemptionActionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutManuallySentAutomationRunsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutMassTextAlertsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutMediaInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutMessageTemplatesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutOwnerInfoInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutPayoutBatchingSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutPinnedChannelsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutPointOfContactEnrollmentSupportEventsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutRecapsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutRefundsIssuedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutRequestedEnrollmentSupportEventsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutResponderEnrollmentSupportEventsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutReviewsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutSentInvoicesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutSentStripePaymentIntentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutSentTrupanionExamDayOffersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutTasksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutTriggeredWritebacksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutUnblockedNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutUsagesRecordedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutUserAppointmentGroupingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutUserChannelFilterSelectionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutUserImpersonation_UserToUserImpersonation_User_IdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutUserSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutUserTaskListInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutValidatedCanonicalServicesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type UserUncheckedUpdateWithoutVetInfoInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUncheckedUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUncheckedUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUncheckedUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUncheckedUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUncheckedUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUncheckedUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUncheckedUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUncheckedUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUncheckedUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUncheckedUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUncheckedUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUncheckedUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUncheckedUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUncheckedUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUncheckedUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUncheckedUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUncheckedUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUncheckedUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUncheckedUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUncheckedUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUncheckedUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUncheckedUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUncheckedUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUncheckedUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUncheckedUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUncheckedUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUncheckedUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUncheckedUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUncheckedUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUncheckedUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUncheckedUpdateManyWithoutCreatedByUserNestedInput>;
  mediaId?: Maybe<Scalars['String']>;
  messageTemplates?: Maybe<MessageTemplateUncheckedUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUncheckedUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUncheckedUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUncheckedUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUncheckedUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUncheckedUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUncheckedUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUncheckedUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUncheckedUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUncheckedUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUncheckedUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUncheckedUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUncheckedUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUncheckedUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUncheckedUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUncheckedUpdateManyWithoutUserNestedInput>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUncheckedUpdateManyWithoutValidatedByUserNestedInput>;
};

export type UserUpdateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePic?: Maybe<Scalars['String']>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserUpdateManyWithWhereWithoutChannelMessagesWithMentionsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutChannelSelectionsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutChannelsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutClinicWidgetRequestTypesInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutClinicsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutFormSubmissionsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutInvitedByInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutMediaInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutTasksInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutUserSettingInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithoutChannelMessagesWithMentionsNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutChannelMessagesWithMentionsInput>>;
  create?: Maybe<Array<UserCreateWithoutChannelMessagesWithMentionsInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutChannelMessagesWithMentionsInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutChannelMessagesWithMentionsInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutChannelMessagesWithMentionsInput>>;
};

export type UserUpdateManyWithoutChannelSelectionsNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutChannelSelectionsInput>>;
  create?: Maybe<Array<UserCreateWithoutChannelSelectionsInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutChannelSelectionsInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutChannelSelectionsInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutChannelSelectionsInput>>;
};

export type UserUpdateManyWithoutChannelsNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutChannelsInput>>;
  create?: Maybe<Array<UserCreateWithoutChannelsInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutChannelsInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutChannelsInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutChannelsInput>>;
};

export type UserUpdateManyWithoutClinicWidgetRequestTypesNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutClinicWidgetRequestTypesInput>>;
  create?: Maybe<Array<UserCreateWithoutClinicWidgetRequestTypesInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutClinicWidgetRequestTypesInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutClinicWidgetRequestTypesInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutClinicWidgetRequestTypesInput>>;
};

export type UserUpdateManyWithoutClinicsNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<UserCreateWithoutClinicsInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutClinicsInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutClinicsInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutClinicsInput>>;
};

export type UserUpdateManyWithoutFormSubmissionsNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutFormSubmissionsInput>>;
  create?: Maybe<Array<UserCreateWithoutFormSubmissionsInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutFormSubmissionsInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutFormSubmissionsInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutFormSubmissionsInput>>;
};

export type UserUpdateManyWithoutInvitedByNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutInvitedByInput>>;
  create?: Maybe<Array<UserCreateWithoutInvitedByInput>>;
  createMany?: Maybe<UserCreateManyInvitedByInputEnvelope>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutInvitedByInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutInvitedByInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutInvitedByInput>>;
};

export type UserUpdateManyWithoutMediaNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutMediaInput>>;
  create?: Maybe<Array<UserCreateWithoutMediaInput>>;
  createMany?: Maybe<UserCreateManyMediaInputEnvelope>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutMediaInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutMediaInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutMediaInput>>;
};

export type UserUpdateManyWithoutTasksNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutTasksInput>>;
  create?: Maybe<Array<UserCreateWithoutTasksInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutTasksInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutTasksInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutTasksInput>>;
};

export type UserUpdateManyWithoutUserSettingNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutUserSettingInput>>;
  create?: Maybe<Array<UserCreateWithoutUserSettingInput>>;
  createMany?: Maybe<UserCreateManyUserSettingInputEnvelope>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutUserSettingInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutUserSettingInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutUserSettingInput>>;
};

export type UserUpdateOneRequiredWithoutAxionClinicUserConfigurationsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutAxionClinicUserConfigurationsInput>;
  create?: Maybe<UserCreateWithoutAxionClinicUserConfigurationsInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutAxionClinicUserConfigurationsInput>;
  upsert?: Maybe<UserUpsertWithoutAxionClinicUserConfigurationsInput>;
};

export type UserUpdateOneRequiredWithoutBoardFiltersNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutBoardFiltersInput>;
  create?: Maybe<UserCreateWithoutBoardFiltersInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutBoardFiltersInput>;
  upsert?: Maybe<UserUpsertWithoutBoardFiltersInput>;
};

export type UserUpdateOneRequiredWithoutChannelMessageReactionsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutChannelMessageReactionsInput>;
  create?: Maybe<UserCreateWithoutChannelMessageReactionsInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutChannelMessageReactionsInput>;
  upsert?: Maybe<UserUpsertWithoutChannelMessageReactionsInput>;
};

export type UserUpdateOneRequiredWithoutChannelStatusChannelAssigneesNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutChannelStatusChannelAssigneesInput>;
  create?: Maybe<UserCreateWithoutChannelStatusChannelAssigneesInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutChannelStatusChannelAssigneesInput>;
  upsert?: Maybe<UserUpsertWithoutChannelStatusChannelAssigneesInput>;
};

export type UserUpdateOneRequiredWithoutClinicUserFiltersNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutClinicUserFiltersInput>;
  create?: Maybe<UserCreateWithoutClinicUserFiltersInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutClinicUserFiltersInput>;
  upsert?: Maybe<UserUpsertWithoutClinicUserFiltersInput>;
};

export type UserUpdateOneRequiredWithoutInformNotificationRecipientsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutInformNotificationRecipientsInput>;
  create?: Maybe<UserCreateWithoutInformNotificationRecipientsInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutInformNotificationRecipientsInput>;
  upsert?: Maybe<UserUpsertWithoutInformNotificationRecipientsInput>;
};

export type UserUpdateOneRequiredWithoutIntitiatedLoyaltyAccountMergesNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutIntitiatedLoyaltyAccountMergesInput>;
  create?: Maybe<UserCreateWithoutIntitiatedLoyaltyAccountMergesInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutIntitiatedLoyaltyAccountMergesInput>;
  upsert?: Maybe<UserUpsertWithoutIntitiatedLoyaltyAccountMergesInput>;
};

export type UserUpdateOneRequiredWithoutLoyaltyPointUserGrantsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutLoyaltyPointUserGrantsInput>;
  create?: Maybe<UserCreateWithoutLoyaltyPointUserGrantsInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutLoyaltyPointUserGrantsInput>;
  upsert?: Maybe<UserUpsertWithoutLoyaltyPointUserGrantsInput>;
};

export type UserUpdateOneRequiredWithoutMassTextAlertsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutMassTextAlertsInput>;
  create?: Maybe<UserCreateWithoutMassTextAlertsInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutMassTextAlertsInput>;
  upsert?: Maybe<UserUpsertWithoutMassTextAlertsInput>;
};

export type UserUpdateOneRequiredWithoutPinnedChannelsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutPinnedChannelsInput>;
  create?: Maybe<UserCreateWithoutPinnedChannelsInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutPinnedChannelsInput>;
  upsert?: Maybe<UserUpsertWithoutPinnedChannelsInput>;
};

export type UserUpdateOneRequiredWithoutRecapsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutRecapsInput>;
  create?: Maybe<UserCreateWithoutRecapsInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutRecapsInput>;
  upsert?: Maybe<UserUpsertWithoutRecapsInput>;
};

export type UserUpdateOneRequiredWithoutUserChannelFilterSelectionsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserChannelFilterSelectionsInput>;
  create?: Maybe<UserCreateWithoutUserChannelFilterSelectionsInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutUserChannelFilterSelectionsInput>;
  upsert?: Maybe<UserUpsertWithoutUserChannelFilterSelectionsInput>;
};

export type UserUpdateOneRequiredWithoutUserTaskListNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserTaskListInput>;
  create?: Maybe<UserCreateWithoutUserTaskListInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutUserTaskListInput>;
  upsert?: Maybe<UserUpsertWithoutUserTaskListInput>;
};

export type UserUpdateOneWithoutAppointmentNoteTemplateNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutAppointmentNoteTemplateInput>;
  create?: Maybe<UserCreateWithoutAppointmentNoteTemplateInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutAppointmentNoteTemplateInput>;
  upsert?: Maybe<UserUpsertWithoutAppointmentNoteTemplateInput>;
};

export type UserUpdateOneWithoutAppointmentRecapNotesUpdatedNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutAppointmentRecapNotesUpdatedInput>;
  create?: Maybe<UserCreateWithoutAppointmentRecapNotesUpdatedInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutAppointmentRecapNotesUpdatedInput>;
  upsert?: Maybe<UserUpsertWithoutAppointmentRecapNotesUpdatedInput>;
};

export type UserUpdateOneWithoutBlockedNumbersNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutBlockedNumbersInput>;
  create?: Maybe<UserCreateWithoutBlockedNumbersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutBlockedNumbersInput>;
  upsert?: Maybe<UserUpsertWithoutBlockedNumbersInput>;
};

export type UserUpdateOneWithoutCallsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutCallsInput>;
  create?: Maybe<UserCreateWithoutCallsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutCallsInput>;
  upsert?: Maybe<UserUpsertWithoutCallsInput>;
};

export type UserUpdateOneWithoutCareBenefitUsageToInvoiceLineItemsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutCareBenefitUsageToInvoiceLineItemsInput>;
  create?: Maybe<UserCreateWithoutCareBenefitUsageToInvoiceLineItemsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutCareBenefitUsageToInvoiceLineItemsInput>;
  upsert?: Maybe<UserUpsertWithoutCareBenefitUsageToInvoiceLineItemsInput>;
};

export type UserUpdateOneWithoutChannelCreationSourcesNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutChannelCreationSourcesInput>;
  create?: Maybe<UserCreateWithoutChannelCreationSourcesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutChannelCreationSourcesInput>;
  upsert?: Maybe<UserUpsertWithoutChannelCreationSourcesInput>;
};

export type UserUpdateOneWithoutChannelMembersNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutChannelMembersInput>;
  create?: Maybe<UserCreateWithoutChannelMembersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutChannelMembersInput>;
  upsert?: Maybe<UserUpsertWithoutChannelMembersInput>;
};

export type UserUpdateOneWithoutChannelStatusesNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutChannelStatusesInput>;
  create?: Maybe<UserCreateWithoutChannelStatusesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutChannelStatusesInput>;
  upsert?: Maybe<UserUpsertWithoutChannelStatusesInput>;
};

export type UserUpdateOneWithoutClinicPetParentsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutClinicPetParentsInput>;
  create?: Maybe<UserCreateWithoutClinicPetParentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutClinicPetParentsInput>;
  upsert?: Maybe<UserUpsertWithoutClinicPetParentsInput>;
};

export type UserUpdateOneWithoutClinicsIdNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutClinicsIdInput>;
  create?: Maybe<UserCreateWithoutClinicsIdInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutClinicsIdInput>;
  upsert?: Maybe<UserUpsertWithoutClinicsIdInput>;
};

export type UserUpdateOneWithoutCompletedBenefitUsageFollowupStepsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutCompletedBenefitUsageFollowupStepsInput>;
  create?: Maybe<UserCreateWithoutCompletedBenefitUsageFollowupStepsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutCompletedBenefitUsageFollowupStepsInput>;
  upsert?: Maybe<UserUpsertWithoutCompletedBenefitUsageFollowupStepsInput>;
};

export type UserUpdateOneWithoutConsultationChatsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutConsultationChatsInput>;
  create?: Maybe<UserCreateWithoutConsultationChatsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutConsultationChatsInput>;
  upsert?: Maybe<UserUpsertWithoutConsultationChatsInput>;
};

export type UserUpdateOneWithoutCreatedPayoutBatchingPeriodsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutCreatedPayoutBatchingPeriodsInput>;
  create?: Maybe<UserCreateWithoutCreatedPayoutBatchingPeriodsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutCreatedPayoutBatchingPeriodsInput>;
  upsert?: Maybe<UserUpsertWithoutCreatedPayoutBatchingPeriodsInput>;
};

export type UserUpdateOneWithoutEmailCampaignNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEmailCampaignInput>;
  create?: Maybe<UserCreateWithoutEmailCampaignInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutEmailCampaignInput>;
  upsert?: Maybe<UserUpsertWithoutEmailCampaignInput>;
};

export type UserUpdateOneWithoutEmailCampaignTemplateNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEmailCampaignTemplateInput>;
  create?: Maybe<UserCreateWithoutEmailCampaignTemplateInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutEmailCampaignTemplateInput>;
  upsert?: Maybe<UserUpsertWithoutEmailCampaignTemplateInput>;
};

export type UserUpdateOneWithoutEmailCampaignUpdatedNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEmailCampaignUpdatedInput>;
  create?: Maybe<UserCreateWithoutEmailCampaignUpdatedInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutEmailCampaignUpdatedInput>;
  upsert?: Maybe<UserUpsertWithoutEmailCampaignUpdatedInput>;
};

export type UserUpdateOneWithoutEmailCampaignsCreatedNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEmailCampaignsCreatedInput>;
  create?: Maybe<UserCreateWithoutEmailCampaignsCreatedInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutEmailCampaignsCreatedInput>;
  upsert?: Maybe<UserUpsertWithoutEmailCampaignsCreatedInput>;
};

export type UserUpdateOneWithoutEmailCampaignsSentNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEmailCampaignsSentInput>;
  create?: Maybe<UserCreateWithoutEmailCampaignsSentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutEmailCampaignsSentInput>;
  upsert?: Maybe<UserUpsertWithoutEmailCampaignsSentInput>;
};

export type UserUpdateOneWithoutEmailTemplateVersionsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEmailTemplateVersionsInput>;
  create?: Maybe<UserCreateWithoutEmailTemplateVersionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutEmailTemplateVersionsInput>;
  upsert?: Maybe<UserUpsertWithoutEmailTemplateVersionsInput>;
};

export type UserUpdateOneWithoutEncryptedClinicUploadsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEncryptedClinicUploadsInput>;
  create?: Maybe<UserCreateWithoutEncryptedClinicUploadsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutEncryptedClinicUploadsInput>;
  upsert?: Maybe<UserUpsertWithoutEncryptedClinicUploadsInput>;
};

export type UserUpdateOneWithoutInformPartnerProgramEnrollmentTermsAcceptancesNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput>;
  create?: Maybe<UserCreateWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput>;
  upsert?: Maybe<UserUpsertWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput>;
};

export type UserUpdateOneWithoutInformPrimaryContactClinicSettingsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutInformPrimaryContactClinicSettingsInput>;
  create?: Maybe<UserCreateWithoutInformPrimaryContactClinicSettingsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutInformPrimaryContactClinicSettingsInput>;
  upsert?: Maybe<UserUpsertWithoutInformPrimaryContactClinicSettingsInput>;
};

export type UserUpdateOneWithoutInvitationsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutInvitationsInput>;
  create?: Maybe<UserCreateWithoutInvitationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutInvitationsInput>;
  upsert?: Maybe<UserUpsertWithoutInvitationsInput>;
};

export type UserUpdateOneWithoutLoaSignedClinicPhoneNumbersNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutLoaSignedClinicPhoneNumbersInput>;
  create?: Maybe<UserCreateWithoutLoaSignedClinicPhoneNumbersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutLoaSignedClinicPhoneNumbersInput>;
  upsert?: Maybe<UserUpsertWithoutLoaSignedClinicPhoneNumbersInput>;
};

export type UserUpdateOneWithoutLoyaltyRewardRedemptionActionsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutLoyaltyRewardRedemptionActionsInput>;
  create?: Maybe<UserCreateWithoutLoyaltyRewardRedemptionActionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutLoyaltyRewardRedemptionActionsInput>;
  upsert?: Maybe<UserUpsertWithoutLoyaltyRewardRedemptionActionsInput>;
};

export type UserUpdateOneWithoutManuallySentAutomationRunsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutManuallySentAutomationRunsInput>;
  create?: Maybe<UserCreateWithoutManuallySentAutomationRunsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutManuallySentAutomationRunsInput>;
  upsert?: Maybe<UserUpsertWithoutManuallySentAutomationRunsInput>;
};

export type UserUpdateOneWithoutMessageTemplatesNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutMessageTemplatesInput>;
  create?: Maybe<UserCreateWithoutMessageTemplatesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutMessageTemplatesInput>;
  upsert?: Maybe<UserUpsertWithoutMessageTemplatesInput>;
};

export type UserUpdateOneWithoutOwnerInfoNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutOwnerInfoInput>;
  create?: Maybe<UserCreateWithoutOwnerInfoInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutOwnerInfoInput>;
  upsert?: Maybe<UserUpsertWithoutOwnerInfoInput>;
};

export type UserUpdateOneWithoutPayoutBatchingSettingNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutPayoutBatchingSettingInput>;
  create?: Maybe<UserCreateWithoutPayoutBatchingSettingInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutPayoutBatchingSettingInput>;
  upsert?: Maybe<UserUpsertWithoutPayoutBatchingSettingInput>;
};

export type UserUpdateOneWithoutPointOfContactEnrollmentSupportEventsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutPointOfContactEnrollmentSupportEventsInput>;
  create?: Maybe<UserCreateWithoutPointOfContactEnrollmentSupportEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutPointOfContactEnrollmentSupportEventsInput>;
  upsert?: Maybe<UserUpsertWithoutPointOfContactEnrollmentSupportEventsInput>;
};

export type UserUpdateOneWithoutRefundsIssuedNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutRefundsIssuedInput>;
  create?: Maybe<UserCreateWithoutRefundsIssuedInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutRefundsIssuedInput>;
  upsert?: Maybe<UserUpsertWithoutRefundsIssuedInput>;
};

export type UserUpdateOneWithoutRequestedEnrollmentSupportEventsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutRequestedEnrollmentSupportEventsInput>;
  create?: Maybe<UserCreateWithoutRequestedEnrollmentSupportEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutRequestedEnrollmentSupportEventsInput>;
  upsert?: Maybe<UserUpsertWithoutRequestedEnrollmentSupportEventsInput>;
};

export type UserUpdateOneWithoutResponderEnrollmentSupportEventsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutResponderEnrollmentSupportEventsInput>;
  create?: Maybe<UserCreateWithoutResponderEnrollmentSupportEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutResponderEnrollmentSupportEventsInput>;
  upsert?: Maybe<UserUpsertWithoutResponderEnrollmentSupportEventsInput>;
};

export type UserUpdateOneWithoutReviewsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutReviewsInput>;
  create?: Maybe<UserCreateWithoutReviewsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutReviewsInput>;
  upsert?: Maybe<UserUpsertWithoutReviewsInput>;
};

export type UserUpdateOneWithoutSentInvoicesNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutSentInvoicesInput>;
  create?: Maybe<UserCreateWithoutSentInvoicesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutSentInvoicesInput>;
  upsert?: Maybe<UserUpsertWithoutSentInvoicesInput>;
};

export type UserUpdateOneWithoutSentStripePaymentIntentsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutSentStripePaymentIntentsInput>;
  create?: Maybe<UserCreateWithoutSentStripePaymentIntentsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutSentStripePaymentIntentsInput>;
  upsert?: Maybe<UserUpsertWithoutSentStripePaymentIntentsInput>;
};

export type UserUpdateOneWithoutSentTrupanionExamDayOffersNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutSentTrupanionExamDayOffersInput>;
  create?: Maybe<UserCreateWithoutSentTrupanionExamDayOffersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutSentTrupanionExamDayOffersInput>;
  upsert?: Maybe<UserUpsertWithoutSentTrupanionExamDayOffersInput>;
};

export type UserUpdateOneWithoutTriggeredWritebacksNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutTriggeredWritebacksInput>;
  create?: Maybe<UserCreateWithoutTriggeredWritebacksInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutTriggeredWritebacksInput>;
  upsert?: Maybe<UserUpsertWithoutTriggeredWritebacksInput>;
};

export type UserUpdateOneWithoutUnblockedNumbersNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUnblockedNumbersInput>;
  create?: Maybe<UserCreateWithoutUnblockedNumbersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutUnblockedNumbersInput>;
  upsert?: Maybe<UserUpsertWithoutUnblockedNumbersInput>;
};

export type UserUpdateOneWithoutUsagesRecordedNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUsagesRecordedInput>;
  create?: Maybe<UserCreateWithoutUsagesRecordedInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutUsagesRecordedInput>;
  upsert?: Maybe<UserUpsertWithoutUsagesRecordedInput>;
};

export type UserUpdateOneWithoutUserAppointmentGroupingsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserAppointmentGroupingsInput>;
  create?: Maybe<UserCreateWithoutUserAppointmentGroupingsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutUserAppointmentGroupingsInput>;
  upsert?: Maybe<UserUpsertWithoutUserAppointmentGroupingsInput>;
};

export type UserUpdateOneWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput>;
  create?: Maybe<UserCreateWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput>;
  delete?: Maybe<UserWhereInput>;
  disconnect?: Maybe<UserWhereInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput>;
  upsert?: Maybe<UserUpsertWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput>;
};

export type UserUpdateOneWithoutUserImpersonation_UserToUserImpersonation_User_IdNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserImpersonation_UserToUserImpersonation_User_IdInput>;
  create?: Maybe<UserCreateWithoutUserImpersonation_UserToUserImpersonation_User_IdInput>;
  delete?: Maybe<UserWhereInput>;
  disconnect?: Maybe<UserWhereInput>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutUserImpersonation_UserToUserImpersonation_User_IdInput>;
  upsert?: Maybe<UserUpsertWithoutUserImpersonation_UserToUserImpersonation_User_IdInput>;
};

export type UserUpdateOneWithoutValidatedCanonicalServicesNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutValidatedCanonicalServicesInput>;
  create?: Maybe<UserCreateWithoutValidatedCanonicalServicesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutValidatedCanonicalServicesInput>;
  upsert?: Maybe<UserUpsertWithoutValidatedCanonicalServicesInput>;
};

export type UserUpdateOneWithoutVetInfoNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutVetInfoInput>;
  create?: Maybe<UserCreateWithoutVetInfoInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateToOneWithWhereWithoutVetInfoInput>;
  upsert?: Maybe<UserUpsertWithoutVetInfoInput>;
};

export type UserUpdateToOneWithWhereWithoutAppointmentNoteTemplateInput = {
  data: UserUpdateWithoutAppointmentNoteTemplateInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutAppointmentRecapNotesUpdatedInput = {
  data: UserUpdateWithoutAppointmentRecapNotesUpdatedInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutAxionClinicUserConfigurationsInput = {
  data: UserUpdateWithoutAxionClinicUserConfigurationsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutBlockedNumbersInput = {
  data: UserUpdateWithoutBlockedNumbersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutBoardFiltersInput = {
  data: UserUpdateWithoutBoardFiltersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCallsInput = {
  data: UserUpdateWithoutCallsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCareBenefitUsageToInvoiceLineItemsInput = {
  data: UserUpdateWithoutCareBenefitUsageToInvoiceLineItemsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutChannelCreationSourcesInput = {
  data: UserUpdateWithoutChannelCreationSourcesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutChannelMembersInput = {
  data: UserUpdateWithoutChannelMembersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutChannelMessageReactionsInput = {
  data: UserUpdateWithoutChannelMessageReactionsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutChannelStatusChannelAssigneesInput = {
  data: UserUpdateWithoutChannelStatusChannelAssigneesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutChannelStatusesInput = {
  data: UserUpdateWithoutChannelStatusesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutClinicPetParentsInput = {
  data: UserUpdateWithoutClinicPetParentsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutClinicUserFiltersInput = {
  data: UserUpdateWithoutClinicUserFiltersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutClinicsIdInput = {
  data: UserUpdateWithoutClinicsIdInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCompletedBenefitUsageFollowupStepsInput = {
  data: UserUpdateWithoutCompletedBenefitUsageFollowupStepsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutConsultationChatsInput = {
  data: UserUpdateWithoutConsultationChatsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCreatedPayoutBatchingPeriodsInput = {
  data: UserUpdateWithoutCreatedPayoutBatchingPeriodsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutEmailCampaignInput = {
  data: UserUpdateWithoutEmailCampaignInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutEmailCampaignTemplateInput = {
  data: UserUpdateWithoutEmailCampaignTemplateInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutEmailCampaignUpdatedInput = {
  data: UserUpdateWithoutEmailCampaignUpdatedInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutEmailCampaignsCreatedInput = {
  data: UserUpdateWithoutEmailCampaignsCreatedInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutEmailCampaignsSentInput = {
  data: UserUpdateWithoutEmailCampaignsSentInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutEmailTemplateVersionsInput = {
  data: UserUpdateWithoutEmailTemplateVersionsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutEncryptedClinicUploadsInput = {
  data: UserUpdateWithoutEncryptedClinicUploadsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutInformNotificationRecipientsInput = {
  data: UserUpdateWithoutInformNotificationRecipientsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput = {
  data: UserUpdateWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutInformPrimaryContactClinicSettingsInput = {
  data: UserUpdateWithoutInformPrimaryContactClinicSettingsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutIntitiatedLoyaltyAccountMergesInput = {
  data: UserUpdateWithoutIntitiatedLoyaltyAccountMergesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutInvitationsInput = {
  data: UserUpdateWithoutInvitationsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutLoaSignedClinicPhoneNumbersInput = {
  data: UserUpdateWithoutLoaSignedClinicPhoneNumbersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutLoyaltyPointUserGrantsInput = {
  data: UserUpdateWithoutLoyaltyPointUserGrantsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutLoyaltyRewardRedemptionActionsInput = {
  data: UserUpdateWithoutLoyaltyRewardRedemptionActionsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutManuallySentAutomationRunsInput = {
  data: UserUpdateWithoutManuallySentAutomationRunsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutMassTextAlertsInput = {
  data: UserUpdateWithoutMassTextAlertsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutMessageTemplatesInput = {
  data: UserUpdateWithoutMessageTemplatesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutOwnerInfoInput = {
  data: UserUpdateWithoutOwnerInfoInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPayoutBatchingSettingInput = {
  data: UserUpdateWithoutPayoutBatchingSettingInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPinnedChannelsInput = {
  data: UserUpdateWithoutPinnedChannelsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPointOfContactEnrollmentSupportEventsInput = {
  data: UserUpdateWithoutPointOfContactEnrollmentSupportEventsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutRecapsInput = {
  data: UserUpdateWithoutRecapsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutRefundsIssuedInput = {
  data: UserUpdateWithoutRefundsIssuedInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutRequestedEnrollmentSupportEventsInput = {
  data: UserUpdateWithoutRequestedEnrollmentSupportEventsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutResponderEnrollmentSupportEventsInput = {
  data: UserUpdateWithoutResponderEnrollmentSupportEventsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutReviewsInput = {
  data: UserUpdateWithoutReviewsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutSentInvoicesInput = {
  data: UserUpdateWithoutSentInvoicesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutSentStripePaymentIntentsInput = {
  data: UserUpdateWithoutSentStripePaymentIntentsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutSentTrupanionExamDayOffersInput = {
  data: UserUpdateWithoutSentTrupanionExamDayOffersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutTriggeredWritebacksInput = {
  data: UserUpdateWithoutTriggeredWritebacksInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUnblockedNumbersInput = {
  data: UserUpdateWithoutUnblockedNumbersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUsagesRecordedInput = {
  data: UserUpdateWithoutUsagesRecordedInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserAppointmentGroupingsInput = {
  data: UserUpdateWithoutUserAppointmentGroupingsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserChannelFilterSelectionsInput = {
  data: UserUpdateWithoutUserChannelFilterSelectionsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput = {
  data: UserUpdateWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserImpersonation_UserToUserImpersonation_User_IdInput = {
  data: UserUpdateWithoutUserImpersonation_UserToUserImpersonation_User_IdInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserTaskListInput = {
  data: UserUpdateWithoutUserTaskListInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutValidatedCanonicalServicesInput = {
  data: UserUpdateWithoutValidatedCanonicalServicesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutVetInfoInput = {
  data: UserUpdateWithoutVetInfoInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpdateWithWhereUniqueWithoutChannelMessagesWithMentionsInput = {
  data: UserUpdateWithoutChannelMessagesWithMentionsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutChannelSelectionsInput = {
  data: UserUpdateWithoutChannelSelectionsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutChannelsInput = {
  data: UserUpdateWithoutChannelsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutClinicWidgetRequestTypesInput = {
  data: UserUpdateWithoutClinicWidgetRequestTypesInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutClinicsInput = {
  data: UserUpdateWithoutClinicsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutFormSubmissionsInput = {
  data: UserUpdateWithoutFormSubmissionsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutInvitedByInput = {
  data: UserUpdateWithoutInvitedByInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutMediaInput = {
  data: UserUpdateWithoutMediaInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutTasksInput = {
  data: UserUpdateWithoutTasksInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutUserSettingInput = {
  data: UserUpdateWithoutUserSettingInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithoutAppointmentNoteTemplateInput = {
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutAppointmentRecapNotesUpdatedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutAxionClinicUserConfigurationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutBlockedNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutBoardFiltersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutCallsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutCareBenefitUsageToInvoiceLineItemsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutChannelCreationSourcesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutChannelMembersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutChannelMessageReactionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutChannelMessagesWithMentionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutChannelSelectionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutChannelStatusChannelAssigneesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutChannelStatusesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutChannelsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutClinicPetParentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutClinicUserFiltersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutClinicWidgetRequestTypesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutClinicsIdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutClinicsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutCompletedBenefitUsageFollowupStepsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutConsultationChatsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutCreatedPayoutBatchingPeriodsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutEmailCampaignInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutEmailCampaignTemplateInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutEmailCampaignUpdatedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutEmailCampaignsCreatedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutEmailCampaignsSentInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutEmailTemplateVersionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutEncryptedClinicUploadsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutFormSubmissionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutInformNotificationRecipientsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutInformPrimaryContactClinicSettingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutIntitiatedLoyaltyAccountMergesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutInvitationsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutInvitedByInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutLoaSignedClinicPhoneNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutLoyaltyPointUserGrantsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutLoyaltyRewardRedemptionActionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutManuallySentAutomationRunsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutMassTextAlertsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutMediaInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutMessageTemplatesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutOwnerInfoInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutPayoutBatchingSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutPinnedChannelsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutPointOfContactEnrollmentSupportEventsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutRecapsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutRefundsIssuedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutRequestedEnrollmentSupportEventsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutResponderEnrollmentSupportEventsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutReviewsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutSentInvoicesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutSentStripePaymentIntentsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutSentTrupanionExamDayOffersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutTasksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutTriggeredWritebacksInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutUnblockedNumbersInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutUsagesRecordedInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserAppointmentGroupingsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserChannelFilterSelectionsInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserImpersonation_UserToUserImpersonation_User_IdInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserSettingInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserTaskListInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutValidatedCanonicalServicesInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutVetInfoInput = {
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateUpdateManyWithoutUpdatedByNestedInput>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentUpdateManyWithoutRecapNotesUpdatedByNestedInput>;
  EmailCampaign?: Maybe<EmailCampaignUpdateManyWithoutUserNestedInput>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateUpdateManyWithoutUserNestedInput>;
  EmailCampaignUpdated?: Maybe<EmailCampaignUpdateManyWithoutLastUpdatedByUserNestedInput>;
  EmailCampaignsCreated?: Maybe<EmailCampaignUpdateManyWithoutCreatedByUserNestedInput>;
  EmailCampaignsSent?: Maybe<EmailCampaignUpdateManyWithoutSentByUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationUpdateManyWithoutImpersonatedUserNestedInput>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationUpdateManyWithoutUserNestedInput>;
  UserTaskList?: Maybe<UserTaskListUpdateManyWithoutUserNestedInput>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationUpdateManyWithoutUserNestedInput>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutBlockedByNestedInput>;
  boardFilters?: Maybe<UserBoardFilterUpdateManyWithoutUserNestedInput>;
  calls?: Maybe<CallParticipantUpdateManyWithoutUserNestedInput>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemUpdateManyWithoutConfirmedByNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutUserNestedInput>;
  channelMembers?: Maybe<ChannelMemberUpdateManyWithoutUserNestedInput>;
  channelMessageReactions?: Maybe<ChannelMessageReactionUpdateManyWithoutUserNestedInput>;
  channelMessagesWithMentions?: Maybe<ChannelMessageUpdateManyWithoutMentionedUsersNestedInput>;
  channelSelections?: Maybe<ChannelSelectionUpdateManyWithoutAssigneesNestedInput>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeUpdateManyWithoutUserNestedInput>;
  channelStatuses?: Maybe<ChannelStatusUpdateManyWithoutDeletedByNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutAssigneesNestedInput>;
  clinicPetParents?: Maybe<ClinicPetParentUpdateManyWithoutUserNestedInput>;
  clinicUserFilters?: Maybe<ClinicUserFilterUpdateManyWithoutUserNestedInput>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutAssigneesNestedInput>;
  clinics?: Maybe<ClinicUpdateManyWithoutUsersNestedInput>;
  clinicsId?: Maybe<ClinicUpdateManyWithoutUsersIdNestedInput>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepUpdateManyWithoutCompletedByUserNestedInput>;
  consultationChats?: Maybe<ConsultationChatUpdateManyWithoutCreatorNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodUpdateManyWithoutCreatedByUserNestedInput>;
  crmId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionUpdateManyWithoutLastEditedByNestedInput>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadUpdateManyWithoutUploaderUserNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formSubmissions?: Maybe<FormSubmissionUpdateManyWithoutUsersNestedInput>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientUpdateManyWithoutUserNestedInput>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentUpdateManyWithoutAcceptedTermsByUserNestedInput>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingUpdateManyWithoutInformPrimaryContactUserNestedInput>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerUpdateManyWithoutInitiatedByNestedInput>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserUpdateManyWithoutInvitedByNestedInput>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<UserUpdateOneWithoutInvitationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isNewPasswordRequired?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberUpdateManyWithoutLoaSignedByUserNestedInput>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantUpdateManyWithoutGrantingUserNestedInput>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryUpdateManyWithoutActingUserNestedInput>;
  manuallySentAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutManuallySentByNestedInput>;
  massTextAlerts?: Maybe<MassTextAlertUpdateManyWithoutCreatedByUserNestedInput>;
  media?: Maybe<MediaUpdateOneWithoutUsersNestedInput>;
  messageTemplates?: Maybe<MessageTemplateUpdateManyWithoutUpdatedByNestedInput>;
  nameDisplay?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  ownerInfo?: Maybe<OwnerInfoUpdateOneWithoutUserNestedInput>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingUpdateManyWithoutUpdatedByUserNestedInput>;
  phone?: Maybe<Scalars['String']>;
  pinnedChannels?: Maybe<ChannelPinUpdateManyWithoutUserNestedInput>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutPointOfContactNestedInput>;
  profilePic?: Maybe<Scalars['String']>;
  recaps?: Maybe<RecapUpdateManyWithoutCreatedByNestedInput>;
  refundsIssued?: Maybe<StripeRefundUpdateManyWithoutIssuedByNestedInput>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutRequesterNestedInput>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventUpdateManyWithoutResponderNestedInput>;
  reviews?: Maybe<ReviewUpdateManyWithoutUserNestedInput>;
  sentInvoices?: Maybe<InvoiceUpdateManyWithoutSentByNestedInput>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentUpdateManyWithoutSentByNestedInput>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferUpdateManyWithoutClinicUserNestedInput>;
  signUpDate?: Maybe<Scalars['DateTime']>;
  signupDetails?: Maybe<Scalars['Json']>;
  tasks?: Maybe<TaskUpdateManyWithoutAssigneesNestedInput>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryUpdateManyWithoutTriggeredByNestedInput>;
  type?: Maybe<UserType>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberUpdateManyWithoutUnblockedByNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usagesRecorded?: Maybe<CareBenefitUsageUpdateManyWithoutRecordedByUserNestedInput>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingUpdateManyWithoutUserNestedInput>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionUpdateManyWithoutUserNestedInput>;
  userSetting?: Maybe<UserSettingUpdateOneWithoutUserNestedInput>;
  validatedCanonicalServices?: Maybe<CanonicalServiceUpdateManyWithoutValidatedByUserNestedInput>;
};

export type UserUpsertWithWhereUniqueWithoutChannelMessagesWithMentionsInput = {
  create: UserCreateWithoutChannelMessagesWithMentionsInput;
  update: UserUpdateWithoutChannelMessagesWithMentionsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutChannelSelectionsInput = {
  create: UserCreateWithoutChannelSelectionsInput;
  update: UserUpdateWithoutChannelSelectionsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutChannelsInput = {
  create: UserCreateWithoutChannelsInput;
  update: UserUpdateWithoutChannelsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutClinicWidgetRequestTypesInput = {
  create: UserCreateWithoutClinicWidgetRequestTypesInput;
  update: UserUpdateWithoutClinicWidgetRequestTypesInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutClinicsInput = {
  create: UserCreateWithoutClinicsInput;
  update: UserUpdateWithoutClinicsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutFormSubmissionsInput = {
  create: UserCreateWithoutFormSubmissionsInput;
  update: UserUpdateWithoutFormSubmissionsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutInvitedByInput = {
  create: UserCreateWithoutInvitedByInput;
  update: UserUpdateWithoutInvitedByInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutMediaInput = {
  create: UserCreateWithoutMediaInput;
  update: UserUpdateWithoutMediaInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutTasksInput = {
  create: UserCreateWithoutTasksInput;
  update: UserUpdateWithoutTasksInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutUserSettingInput = {
  create: UserCreateWithoutUserSettingInput;
  update: UserUpdateWithoutUserSettingInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithoutAppointmentNoteTemplateInput = {
  create: UserCreateWithoutAppointmentNoteTemplateInput;
  update: UserUpdateWithoutAppointmentNoteTemplateInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutAppointmentRecapNotesUpdatedInput = {
  create: UserCreateWithoutAppointmentRecapNotesUpdatedInput;
  update: UserUpdateWithoutAppointmentRecapNotesUpdatedInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutAxionClinicUserConfigurationsInput = {
  create: UserCreateWithoutAxionClinicUserConfigurationsInput;
  update: UserUpdateWithoutAxionClinicUserConfigurationsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutBlockedNumbersInput = {
  create: UserCreateWithoutBlockedNumbersInput;
  update: UserUpdateWithoutBlockedNumbersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutBoardFiltersInput = {
  create: UserCreateWithoutBoardFiltersInput;
  update: UserUpdateWithoutBoardFiltersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutCallsInput = {
  create: UserCreateWithoutCallsInput;
  update: UserUpdateWithoutCallsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutCareBenefitUsageToInvoiceLineItemsInput = {
  create: UserCreateWithoutCareBenefitUsageToInvoiceLineItemsInput;
  update: UserUpdateWithoutCareBenefitUsageToInvoiceLineItemsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutChannelCreationSourcesInput = {
  create: UserCreateWithoutChannelCreationSourcesInput;
  update: UserUpdateWithoutChannelCreationSourcesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutChannelMembersInput = {
  create: UserCreateWithoutChannelMembersInput;
  update: UserUpdateWithoutChannelMembersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutChannelMessageReactionsInput = {
  create: UserCreateWithoutChannelMessageReactionsInput;
  update: UserUpdateWithoutChannelMessageReactionsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutChannelStatusChannelAssigneesInput = {
  create: UserCreateWithoutChannelStatusChannelAssigneesInput;
  update: UserUpdateWithoutChannelStatusChannelAssigneesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutChannelStatusesInput = {
  create: UserCreateWithoutChannelStatusesInput;
  update: UserUpdateWithoutChannelStatusesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutClinicPetParentsInput = {
  create: UserCreateWithoutClinicPetParentsInput;
  update: UserUpdateWithoutClinicPetParentsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutClinicUserFiltersInput = {
  create: UserCreateWithoutClinicUserFiltersInput;
  update: UserUpdateWithoutClinicUserFiltersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutClinicsIdInput = {
  create: UserCreateWithoutClinicsIdInput;
  update: UserUpdateWithoutClinicsIdInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutCompletedBenefitUsageFollowupStepsInput = {
  create: UserCreateWithoutCompletedBenefitUsageFollowupStepsInput;
  update: UserUpdateWithoutCompletedBenefitUsageFollowupStepsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutConsultationChatsInput = {
  create: UserCreateWithoutConsultationChatsInput;
  update: UserUpdateWithoutConsultationChatsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutCreatedPayoutBatchingPeriodsInput = {
  create: UserCreateWithoutCreatedPayoutBatchingPeriodsInput;
  update: UserUpdateWithoutCreatedPayoutBatchingPeriodsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutEmailCampaignInput = {
  create: UserCreateWithoutEmailCampaignInput;
  update: UserUpdateWithoutEmailCampaignInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutEmailCampaignTemplateInput = {
  create: UserCreateWithoutEmailCampaignTemplateInput;
  update: UserUpdateWithoutEmailCampaignTemplateInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutEmailCampaignUpdatedInput = {
  create: UserCreateWithoutEmailCampaignUpdatedInput;
  update: UserUpdateWithoutEmailCampaignUpdatedInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutEmailCampaignsCreatedInput = {
  create: UserCreateWithoutEmailCampaignsCreatedInput;
  update: UserUpdateWithoutEmailCampaignsCreatedInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutEmailCampaignsSentInput = {
  create: UserCreateWithoutEmailCampaignsSentInput;
  update: UserUpdateWithoutEmailCampaignsSentInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutEmailTemplateVersionsInput = {
  create: UserCreateWithoutEmailTemplateVersionsInput;
  update: UserUpdateWithoutEmailTemplateVersionsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutEncryptedClinicUploadsInput = {
  create: UserCreateWithoutEncryptedClinicUploadsInput;
  update: UserUpdateWithoutEncryptedClinicUploadsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutInformNotificationRecipientsInput = {
  create: UserCreateWithoutInformNotificationRecipientsInput;
  update: UserUpdateWithoutInformNotificationRecipientsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput = {
  create: UserCreateWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput;
  update: UserUpdateWithoutInformPartnerProgramEnrollmentTermsAcceptancesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutInformPrimaryContactClinicSettingsInput = {
  create: UserCreateWithoutInformPrimaryContactClinicSettingsInput;
  update: UserUpdateWithoutInformPrimaryContactClinicSettingsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutIntitiatedLoyaltyAccountMergesInput = {
  create: UserCreateWithoutIntitiatedLoyaltyAccountMergesInput;
  update: UserUpdateWithoutIntitiatedLoyaltyAccountMergesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutInvitationsInput = {
  create: UserCreateWithoutInvitationsInput;
  update: UserUpdateWithoutInvitationsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutLoaSignedClinicPhoneNumbersInput = {
  create: UserCreateWithoutLoaSignedClinicPhoneNumbersInput;
  update: UserUpdateWithoutLoaSignedClinicPhoneNumbersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutLoyaltyPointUserGrantsInput = {
  create: UserCreateWithoutLoyaltyPointUserGrantsInput;
  update: UserUpdateWithoutLoyaltyPointUserGrantsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutLoyaltyRewardRedemptionActionsInput = {
  create: UserCreateWithoutLoyaltyRewardRedemptionActionsInput;
  update: UserUpdateWithoutLoyaltyRewardRedemptionActionsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutManuallySentAutomationRunsInput = {
  create: UserCreateWithoutManuallySentAutomationRunsInput;
  update: UserUpdateWithoutManuallySentAutomationRunsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutMassTextAlertsInput = {
  create: UserCreateWithoutMassTextAlertsInput;
  update: UserUpdateWithoutMassTextAlertsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutMessageTemplatesInput = {
  create: UserCreateWithoutMessageTemplatesInput;
  update: UserUpdateWithoutMessageTemplatesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutOwnerInfoInput = {
  create: UserCreateWithoutOwnerInfoInput;
  update: UserUpdateWithoutOwnerInfoInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutPayoutBatchingSettingInput = {
  create: UserCreateWithoutPayoutBatchingSettingInput;
  update: UserUpdateWithoutPayoutBatchingSettingInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutPinnedChannelsInput = {
  create: UserCreateWithoutPinnedChannelsInput;
  update: UserUpdateWithoutPinnedChannelsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutPointOfContactEnrollmentSupportEventsInput = {
  create: UserCreateWithoutPointOfContactEnrollmentSupportEventsInput;
  update: UserUpdateWithoutPointOfContactEnrollmentSupportEventsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutRecapsInput = {
  create: UserCreateWithoutRecapsInput;
  update: UserUpdateWithoutRecapsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutRefundsIssuedInput = {
  create: UserCreateWithoutRefundsIssuedInput;
  update: UserUpdateWithoutRefundsIssuedInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutRequestedEnrollmentSupportEventsInput = {
  create: UserCreateWithoutRequestedEnrollmentSupportEventsInput;
  update: UserUpdateWithoutRequestedEnrollmentSupportEventsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutResponderEnrollmentSupportEventsInput = {
  create: UserCreateWithoutResponderEnrollmentSupportEventsInput;
  update: UserUpdateWithoutResponderEnrollmentSupportEventsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutReviewsInput = {
  create: UserCreateWithoutReviewsInput;
  update: UserUpdateWithoutReviewsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutSentInvoicesInput = {
  create: UserCreateWithoutSentInvoicesInput;
  update: UserUpdateWithoutSentInvoicesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutSentStripePaymentIntentsInput = {
  create: UserCreateWithoutSentStripePaymentIntentsInput;
  update: UserUpdateWithoutSentStripePaymentIntentsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutSentTrupanionExamDayOffersInput = {
  create: UserCreateWithoutSentTrupanionExamDayOffersInput;
  update: UserUpdateWithoutSentTrupanionExamDayOffersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutTriggeredWritebacksInput = {
  create: UserCreateWithoutTriggeredWritebacksInput;
  update: UserUpdateWithoutTriggeredWritebacksInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutUnblockedNumbersInput = {
  create: UserCreateWithoutUnblockedNumbersInput;
  update: UserUpdateWithoutUnblockedNumbersInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutUsagesRecordedInput = {
  create: UserCreateWithoutUsagesRecordedInput;
  update: UserUpdateWithoutUsagesRecordedInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutUserAppointmentGroupingsInput = {
  create: UserCreateWithoutUserAppointmentGroupingsInput;
  update: UserUpdateWithoutUserAppointmentGroupingsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutUserChannelFilterSelectionsInput = {
  create: UserCreateWithoutUserChannelFilterSelectionsInput;
  update: UserUpdateWithoutUserChannelFilterSelectionsInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput = {
  create: UserCreateWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput;
  update: UserUpdateWithoutUserImpersonation_UserToUserImpersonation_Impersonated_User_IdInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutUserImpersonation_UserToUserImpersonation_User_IdInput = {
  create: UserCreateWithoutUserImpersonation_UserToUserImpersonation_User_IdInput;
  update: UserUpdateWithoutUserImpersonation_UserToUserImpersonation_User_IdInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutUserTaskListInput = {
  create: UserCreateWithoutUserTaskListInput;
  update: UserUpdateWithoutUserTaskListInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutValidatedCanonicalServicesInput = {
  create: UserCreateWithoutValidatedCanonicalServicesInput;
  update: UserUpdateWithoutValidatedCanonicalServicesInput;
  where?: Maybe<UserWhereInput>;
};

export type UserUpsertWithoutVetInfoInput = {
  create: UserCreateWithoutVetInfoInput;
  update: UserUpdateWithoutVetInfoInput;
  where?: Maybe<UserWhereInput>;
};

export type UserWhereInput = {
  AND?: Maybe<Array<UserWhereInput>>;
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateListRelationFilter>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentListRelationFilter>;
  EmailCampaign?: Maybe<EmailCampaignListRelationFilter>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateListRelationFilter>;
  EmailCampaignUpdated?: Maybe<EmailCampaignListRelationFilter>;
  EmailCampaignsCreated?: Maybe<EmailCampaignListRelationFilter>;
  EmailCampaignsSent?: Maybe<EmailCampaignListRelationFilter>;
  NOT?: Maybe<Array<UserWhereInput>>;
  OR?: Maybe<Array<UserWhereInput>>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationListRelationFilter>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationListRelationFilter>;
  UserTaskList?: Maybe<UserTaskListListRelationFilter>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationListRelationFilter>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberListRelationFilter>;
  boardFilters?: Maybe<UserBoardFilterListRelationFilter>;
  calls?: Maybe<CallParticipantListRelationFilter>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  channelMembers?: Maybe<ChannelMemberListRelationFilter>;
  channelMessageReactions?: Maybe<ChannelMessageReactionListRelationFilter>;
  channelMessagesWithMentions?: Maybe<ChannelMessageListRelationFilter>;
  channelSelections?: Maybe<ChannelSelectionListRelationFilter>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeListRelationFilter>;
  channelStatuses?: Maybe<ChannelStatusListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  clinicUserFilters?: Maybe<ClinicUserFilterListRelationFilter>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  clinics?: Maybe<ClinicListRelationFilter>;
  clinicsId?: Maybe<ClinicListRelationFilter>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepListRelationFilter>;
  consultationChats?: Maybe<ConsultationChatListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodListRelationFilter>;
  crmId?: Maybe<StringNullableFilter>;
  email?: Maybe<StringFilter>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionListRelationFilter>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadListRelationFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  firstName?: Maybe<StringFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  id?: Maybe<StringFilter>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientListRelationFilter>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentListRelationFilter>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingListRelationFilter>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerListRelationFilter>;
  invitationCode?: Maybe<StringNullableFilter>;
  invitations?: Maybe<UserListRelationFilter>;
  invitedAt?: Maybe<DateTimeNullableFilter>;
  invitedBy?: Maybe<UserNullableScalarRelationFilter>;
  invitedById?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isAdmin?: Maybe<BoolNullableFilter>;
  isNewPasswordRequired?: Maybe<BoolFilter>;
  lastName?: Maybe<StringFilter>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberListRelationFilter>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantListRelationFilter>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  manuallySentAutomationRuns?: Maybe<AutomationRunListRelationFilter>;
  massTextAlerts?: Maybe<MassTextAlertListRelationFilter>;
  media?: Maybe<MediaNullableScalarRelationFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  messageTemplates?: Maybe<MessageTemplateListRelationFilter>;
  nameDisplay?: Maybe<StringNullableFilter>;
  namePrefix?: Maybe<StringNullableFilter>;
  nameSuffix?: Maybe<StringNullableFilter>;
  ownerInfo?: Maybe<OwnerInfoNullableScalarRelationFilter>;
  ownerInfoId?: Maybe<StringNullableFilter>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingListRelationFilter>;
  phone?: Maybe<StringNullableFilter>;
  pinnedChannels?: Maybe<ChannelPinListRelationFilter>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  profilePic?: Maybe<StringNullableFilter>;
  recaps?: Maybe<RecapListRelationFilter>;
  refundsIssued?: Maybe<StripeRefundListRelationFilter>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  reviews?: Maybe<ReviewListRelationFilter>;
  sentInvoices?: Maybe<InvoiceListRelationFilter>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  signUpDate?: Maybe<DateTimeNullableFilter>;
  signupDetails?: Maybe<JsonNullableFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryListRelationFilter>;
  type?: Maybe<EnumUserTypeFilter>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  usagesRecorded?: Maybe<CareBenefitUsageListRelationFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionListRelationFilter>;
  userSetting?: Maybe<UserSettingNullableScalarRelationFilter>;
  userSettingId?: Maybe<StringNullableFilter>;
  validatedCanonicalServices?: Maybe<CanonicalServiceListRelationFilter>;
  vetInfo?: Maybe<VetInfoNullableScalarRelationFilter>;
  vetInfoId?: Maybe<StringNullableFilter>;
};

export type UserWhereUniqueInput = {
  AND?: Maybe<Array<UserWhereInput>>;
  AppointmentNoteTemplate?: Maybe<AppointmentNoteTemplateListRelationFilter>;
  AppointmentRecapNotesUpdated?: Maybe<AppointmentListRelationFilter>;
  EmailCampaign?: Maybe<EmailCampaignListRelationFilter>;
  EmailCampaignTemplate?: Maybe<EmailCampaignTemplateListRelationFilter>;
  EmailCampaignUpdated?: Maybe<EmailCampaignListRelationFilter>;
  EmailCampaignsCreated?: Maybe<EmailCampaignListRelationFilter>;
  EmailCampaignsSent?: Maybe<EmailCampaignListRelationFilter>;
  NOT?: Maybe<Array<UserWhereInput>>;
  OR?: Maybe<Array<UserWhereInput>>;
  UserImpersonation_UserToUserImpersonation_impersonated_user_id?: Maybe<UserImpersonationListRelationFilter>;
  UserImpersonation_UserToUserImpersonation_user_id?: Maybe<UserImpersonationListRelationFilter>;
  UserTaskList?: Maybe<UserTaskListListRelationFilter>;
  axionClinicUserConfigurations?: Maybe<AxionClinicUserConfigurationListRelationFilter>;
  blockedNumbers?: Maybe<ClinicBlockedPhoneNumberListRelationFilter>;
  boardFilters?: Maybe<UserBoardFilterListRelationFilter>;
  calls?: Maybe<CallParticipantListRelationFilter>;
  careBenefitUsageToInvoiceLineItems?: Maybe<CareBenefitUsageToInvoiceLineItemListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  channelMembers?: Maybe<ChannelMemberListRelationFilter>;
  channelMessageReactions?: Maybe<ChannelMessageReactionListRelationFilter>;
  channelMessagesWithMentions?: Maybe<ChannelMessageListRelationFilter>;
  channelSelections?: Maybe<ChannelSelectionListRelationFilter>;
  channelStatusChannelAssignees?: Maybe<ChannelStatusChannelAssigneeListRelationFilter>;
  channelStatuses?: Maybe<ChannelStatusListRelationFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  clinicPetParents?: Maybe<ClinicPetParentListRelationFilter>;
  clinicUserFilters?: Maybe<ClinicUserFilterListRelationFilter>;
  clinicWidgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  clinics?: Maybe<ClinicListRelationFilter>;
  clinicsId?: Maybe<ClinicListRelationFilter>;
  completedBenefitUsageFollowupSteps?: Maybe<CareBenefitUsageFollowupStepListRelationFilter>;
  consultationChats?: Maybe<ConsultationChatListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdPayoutBatchingPeriods?: Maybe<PayoutBatchingPeriodListRelationFilter>;
  crmId?: Maybe<StringNullableFilter>;
  email?: Maybe<Scalars['String']>;
  emailTemplateVersions?: Maybe<EmailTemplateVersionListRelationFilter>;
  encryptedClinicUploads?: Maybe<EncryptedClinicUploadListRelationFilter>;
  firebaseId?: Maybe<Scalars['String']>;
  firstName?: Maybe<StringFilter>;
  formSubmissions?: Maybe<FormSubmissionListRelationFilter>;
  id?: Maybe<Scalars['String']>;
  informNotificationRecipients?: Maybe<InformNotificationRecipientListRelationFilter>;
  informPartnerProgramEnrollmentTermsAcceptances?: Maybe<InformPartnerProgramEnrollmentListRelationFilter>;
  informPrimaryContactClinicSettings?: Maybe<ClinicSettingListRelationFilter>;
  intitiatedLoyaltyAccountMerges?: Maybe<LoyaltyAccountMergerListRelationFilter>;
  invitationCode?: Maybe<Scalars['String']>;
  invitations?: Maybe<UserListRelationFilter>;
  invitedAt?: Maybe<DateTimeNullableFilter>;
  invitedBy?: Maybe<UserNullableScalarRelationFilter>;
  invitedById?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isAdmin?: Maybe<BoolNullableFilter>;
  isNewPasswordRequired?: Maybe<BoolFilter>;
  lastName?: Maybe<StringFilter>;
  loaSignedClinicPhoneNumbers?: Maybe<ClinicPhoneNumberListRelationFilter>;
  loyaltyPointUserGrants?: Maybe<LoyaltyPointUserGrantListRelationFilter>;
  loyaltyRewardRedemptionActions?: Maybe<LoyaltyRewardRedemptionHistoryEntryListRelationFilter>;
  manuallySentAutomationRuns?: Maybe<AutomationRunListRelationFilter>;
  massTextAlerts?: Maybe<MassTextAlertListRelationFilter>;
  media?: Maybe<MediaNullableScalarRelationFilter>;
  mediaId?: Maybe<StringNullableFilter>;
  messageTemplates?: Maybe<MessageTemplateListRelationFilter>;
  nameDisplay?: Maybe<StringNullableFilter>;
  namePrefix?: Maybe<StringNullableFilter>;
  nameSuffix?: Maybe<StringNullableFilter>;
  ownerInfo?: Maybe<OwnerInfoNullableScalarRelationFilter>;
  ownerInfoId?: Maybe<Scalars['String']>;
  payoutBatchingSetting?: Maybe<PayoutBatchingSettingListRelationFilter>;
  phone?: Maybe<StringNullableFilter>;
  pinnedChannels?: Maybe<ChannelPinListRelationFilter>;
  pointOfContactEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  profilePic?: Maybe<StringNullableFilter>;
  recaps?: Maybe<RecapListRelationFilter>;
  refundsIssued?: Maybe<StripeRefundListRelationFilter>;
  requestedEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  responderEnrollmentSupportEvents?: Maybe<EnrollmentSupportEventListRelationFilter>;
  reviews?: Maybe<ReviewListRelationFilter>;
  sentInvoices?: Maybe<InvoiceListRelationFilter>;
  sentStripePaymentIntents?: Maybe<StripePaymentIntentListRelationFilter>;
  sentTrupanionExamDayOffers?: Maybe<SentTrupanionExamDayOfferListRelationFilter>;
  signUpDate?: Maybe<DateTimeNullableFilter>;
  signupDetails?: Maybe<JsonNullableFilter>;
  tasks?: Maybe<TaskListRelationFilter>;
  triggeredWritebacks?: Maybe<PimsWritebackLogEntryListRelationFilter>;
  type?: Maybe<EnumUserTypeFilter>;
  unblockedNumbers?: Maybe<ClinicBlockedPhoneNumberListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  usagesRecorded?: Maybe<CareBenefitUsageListRelationFilter>;
  userAppointmentGroupings?: Maybe<UserAppointmentGroupingListRelationFilter>;
  userChannelFilterSelections?: Maybe<UserChannelFilterSelectionListRelationFilter>;
  userSetting?: Maybe<UserSettingNullableScalarRelationFilter>;
  userSettingId?: Maybe<Scalars['String']>;
  validatedCanonicalServices?: Maybe<CanonicalServiceListRelationFilter>;
  vetInfo?: Maybe<VetInfoNullableScalarRelationFilter>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type Vaccination = {
  __typename?: 'Vaccination';
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  clinicPet: ClinicPet;
  clinicPetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  virusType?: Maybe<Scalars['String']>;
};


export type VaccinationIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type VaccinationCountAggregateOutputType = {
  __typename?: 'VaccinationCountAggregateOutputType';
  _all: Scalars['Int'];
  administeredAt: Scalars['Int'];
  clinicId: Scalars['Int'];
  clinicPetId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  expiredAt: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  isDeleted: Scalars['Int'];
  manufacturer: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  serialNumber: Scalars['Int'];
  siteId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  virusType: Scalars['Int'];
};

export type VaccinationCountOrderByAggregateInput = {
  administeredAt?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  serialNumber?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  virusType?: Maybe<SortOrder>;
};

export type VaccinationCreateInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinic: ClinicCreateNestedOneWithoutVaccinationsInput;
  clinicPet: ClinicPetCreateNestedOneWithoutVaccinationsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutVaccinationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationCreateManyClinicInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationCreateManyClinicInputEnvelope = {
  data: Array<VaccinationCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type VaccinationCreateManyClinicPetInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationCreateManyClinicPetInputEnvelope = {
  data: Array<VaccinationCreateManyClinicPetInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type VaccinationCreateManyInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationCreateManyIntegrationInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationCreateManyIntegrationInputEnvelope = {
  data: Array<VaccinationCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type VaccinationCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VaccinationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<VaccinationCreateWithoutClinicInput>>;
  createMany?: Maybe<VaccinationCreateManyClinicInputEnvelope>;
};

export type VaccinationCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VaccinationCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<VaccinationCreateWithoutClinicPetInput>>;
  createMany?: Maybe<VaccinationCreateManyClinicPetInputEnvelope>;
};

export type VaccinationCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VaccinationCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<VaccinationCreateWithoutIntegrationInput>>;
  createMany?: Maybe<VaccinationCreateManyIntegrationInputEnvelope>;
};

export type VaccinationCreateOrConnectWithoutClinicInput = {
  create: VaccinationCreateWithoutClinicInput;
  where: VaccinationWhereUniqueInput;
};

export type VaccinationCreateOrConnectWithoutClinicPetInput = {
  create: VaccinationCreateWithoutClinicPetInput;
  where: VaccinationWhereUniqueInput;
};

export type VaccinationCreateOrConnectWithoutIntegrationInput = {
  create: VaccinationCreateWithoutIntegrationInput;
  where: VaccinationWhereUniqueInput;
};

export type VaccinationCreateWithoutClinicInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicPet: ClinicPetCreateNestedOneWithoutVaccinationsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutVaccinationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationCreateWithoutClinicPetInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinic: ClinicCreateNestedOneWithoutVaccinationsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutVaccinationsInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationCreateWithoutIntegrationInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinic: ClinicCreateNestedOneWithoutVaccinationsInput;
  clinicPet: ClinicPetCreateNestedOneWithoutVaccinationsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationGroupByOutputType = {
  __typename?: 'VaccinationGroupByOutputType';
  _count?: Maybe<VaccinationCountAggregateOutputType>;
  _max?: Maybe<VaccinationMaxAggregateOutputType>;
  _min?: Maybe<VaccinationMinAggregateOutputType>;
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  integrationId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationListRelationFilter = {
  every?: Maybe<VaccinationWhereInput>;
  none?: Maybe<VaccinationWhereInput>;
  some?: Maybe<VaccinationWhereInput>;
};

export type VaccinationMaxAggregateOutputType = {
  __typename?: 'VaccinationMaxAggregateOutputType';
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationMaxOrderByAggregateInput = {
  administeredAt?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  serialNumber?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  virusType?: Maybe<SortOrder>;
};

export type VaccinationMinAggregateOutputType = {
  __typename?: 'VaccinationMinAggregateOutputType';
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationMinOrderByAggregateInput = {
  administeredAt?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  serialNumber?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  virusType?: Maybe<SortOrder>;
};

export type VaccinationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type VaccinationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VaccinationOrderByRelevanceInput>;
  administeredAt?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  serialNumber?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  virusType?: Maybe<SortOrder>;
};

export enum VaccinationOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  ClinicPetId = 'clinicPetId',
  Description = 'description',
  Id = 'id',
  IntegrationId = 'integrationId',
  Manufacturer = 'manufacturer',
  PimsId = 'pimsId',
  SerialNumber = 'serialNumber',
  SiteId = 'siteId',
  VirusType = 'virusType'
}

export type VaccinationOrderByRelevanceInput = {
  fields: Array<VaccinationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type VaccinationOrderByWithAggregationInput = {
  _count?: Maybe<VaccinationCountOrderByAggregateInput>;
  _max?: Maybe<VaccinationMaxOrderByAggregateInput>;
  _min?: Maybe<VaccinationMinOrderByAggregateInput>;
  administeredAt?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  serialNumber?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  virusType?: Maybe<SortOrder>;
};

export type VaccinationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VaccinationOrderByRelevanceInput>;
  administeredAt?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  serialNumber?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  virusType?: Maybe<SortOrder>;
};

export type VaccinationOrderByWithRelationInput = {
  _relevance?: Maybe<VaccinationOrderByRelevanceInput>;
  administeredAt?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  clinicPet?: Maybe<ClinicPetOrderByWithRelationInput>;
  clinicPetId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  expiredAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  manufacturer?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  serialNumber?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  virusType?: Maybe<SortOrder>;
};

export enum VaccinationScalarFieldEnum {
  AdministeredAt = 'administeredAt',
  ClinicId = 'clinicId',
  ClinicPetId = 'clinicPetId',
  CreatedAt = 'createdAt',
  Description = 'description',
  ExpiredAt = 'expiredAt',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Manufacturer = 'manufacturer',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  SerialNumber = 'serialNumber',
  SiteId = 'siteId',
  UpdatedAt = 'updatedAt',
  VirusType = 'virusType'
}

export type VaccinationScalarWhereInput = {
  AND?: Maybe<Array<VaccinationScalarWhereInput>>;
  NOT?: Maybe<Array<VaccinationScalarWhereInput>>;
  OR?: Maybe<Array<VaccinationScalarWhereInput>>;
  administeredAt?: Maybe<DateTimeNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  expiredAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  manufacturer?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  serialNumber?: Maybe<StringNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  virusType?: Maybe<StringNullableFilter>;
};

export type VaccinationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<VaccinationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<VaccinationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<VaccinationScalarWhereWithAggregatesInput>>;
  administeredAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  clinicPetId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  expiredAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  manufacturer?: Maybe<StringNullableWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  serialNumber?: Maybe<StringNullableWithAggregatesFilter>;
  siteId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  virusType?: Maybe<StringNullableWithAggregatesFilter>;
};

export type VaccinationUncheckedCreateInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VaccinationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<VaccinationCreateWithoutClinicInput>>;
  createMany?: Maybe<VaccinationCreateManyClinicInputEnvelope>;
};

export type VaccinationUncheckedCreateNestedManyWithoutClinicPetInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VaccinationCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<VaccinationCreateWithoutClinicPetInput>>;
  createMany?: Maybe<VaccinationCreateManyClinicPetInputEnvelope>;
};

export type VaccinationUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VaccinationCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<VaccinationCreateWithoutIntegrationInput>>;
  createMany?: Maybe<VaccinationCreateManyIntegrationInputEnvelope>;
};

export type VaccinationUncheckedCreateWithoutClinicInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUncheckedCreateWithoutClinicPetInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUncheckedCreateWithoutIntegrationInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId: Scalars['String'];
  clinicPetId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUncheckedUpdateInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUncheckedUpdateManyInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUncheckedUpdateManyWithoutClinicInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VaccinationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<VaccinationCreateWithoutClinicInput>>;
  createMany?: Maybe<VaccinationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<VaccinationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VaccinationScalarWhereInput>>;
  disconnect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  set?: Maybe<Array<VaccinationWhereUniqueInput>>;
  update?: Maybe<Array<VaccinationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<VaccinationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<VaccinationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type VaccinationUncheckedUpdateManyWithoutClinicPetInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUncheckedUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VaccinationCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<VaccinationCreateWithoutClinicPetInput>>;
  createMany?: Maybe<VaccinationCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<VaccinationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VaccinationScalarWhereInput>>;
  disconnect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  set?: Maybe<Array<VaccinationWhereUniqueInput>>;
  update?: Maybe<Array<VaccinationUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<VaccinationUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<VaccinationUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type VaccinationUncheckedUpdateManyWithoutIntegrationInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VaccinationCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<VaccinationCreateWithoutIntegrationInput>>;
  createMany?: Maybe<VaccinationCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<VaccinationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VaccinationScalarWhereInput>>;
  disconnect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  set?: Maybe<Array<VaccinationWhereUniqueInput>>;
  update?: Maybe<Array<VaccinationUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<VaccinationUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<VaccinationUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type VaccinationUncheckedUpdateWithoutClinicInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUncheckedUpdateWithoutClinicPetInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUncheckedUpdateWithoutIntegrationInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicId?: Maybe<Scalars['String']>;
  clinicPetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUpdateInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutVaccinationsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutVaccinationsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutVaccinationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUpdateManyMutationInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUpdateManyWithWhereWithoutClinicInput = {
  data: VaccinationUpdateManyMutationInput;
  where: VaccinationScalarWhereInput;
};

export type VaccinationUpdateManyWithWhereWithoutClinicPetInput = {
  data: VaccinationUpdateManyMutationInput;
  where: VaccinationScalarWhereInput;
};

export type VaccinationUpdateManyWithWhereWithoutIntegrationInput = {
  data: VaccinationUpdateManyMutationInput;
  where: VaccinationScalarWhereInput;
};

export type VaccinationUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VaccinationCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<VaccinationCreateWithoutClinicInput>>;
  createMany?: Maybe<VaccinationCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<VaccinationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VaccinationScalarWhereInput>>;
  disconnect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  set?: Maybe<Array<VaccinationWhereUniqueInput>>;
  update?: Maybe<Array<VaccinationUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<VaccinationUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<VaccinationUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type VaccinationUpdateManyWithoutClinicPetNestedInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VaccinationCreateOrConnectWithoutClinicPetInput>>;
  create?: Maybe<Array<VaccinationCreateWithoutClinicPetInput>>;
  createMany?: Maybe<VaccinationCreateManyClinicPetInputEnvelope>;
  delete?: Maybe<Array<VaccinationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VaccinationScalarWhereInput>>;
  disconnect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  set?: Maybe<Array<VaccinationWhereUniqueInput>>;
  update?: Maybe<Array<VaccinationUpdateWithWhereUniqueWithoutClinicPetInput>>;
  updateMany?: Maybe<Array<VaccinationUpdateManyWithWhereWithoutClinicPetInput>>;
  upsert?: Maybe<Array<VaccinationUpsertWithWhereUniqueWithoutClinicPetInput>>;
};

export type VaccinationUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VaccinationCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<VaccinationCreateWithoutIntegrationInput>>;
  createMany?: Maybe<VaccinationCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<VaccinationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VaccinationScalarWhereInput>>;
  disconnect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  set?: Maybe<Array<VaccinationWhereUniqueInput>>;
  update?: Maybe<Array<VaccinationUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<VaccinationUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<VaccinationUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type VaccinationUpdateWithWhereUniqueWithoutClinicInput = {
  data: VaccinationUpdateWithoutClinicInput;
  where: VaccinationWhereUniqueInput;
};

export type VaccinationUpdateWithWhereUniqueWithoutClinicPetInput = {
  data: VaccinationUpdateWithoutClinicPetInput;
  where: VaccinationWhereUniqueInput;
};

export type VaccinationUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: VaccinationUpdateWithoutIntegrationInput;
  where: VaccinationWhereUniqueInput;
};

export type VaccinationUpdateWithoutClinicInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutVaccinationsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutVaccinationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUpdateWithoutClinicPetInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutVaccinationsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutVaccinationsNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUpdateWithoutIntegrationInput = {
  administeredAt?: Maybe<Scalars['DateTime']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutVaccinationsNestedInput>;
  clinicPet?: Maybe<ClinicPetUpdateOneRequiredWithoutVaccinationsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  serialNumber?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  virusType?: Maybe<Scalars['String']>;
};

export type VaccinationUpsertWithWhereUniqueWithoutClinicInput = {
  create: VaccinationCreateWithoutClinicInput;
  update: VaccinationUpdateWithoutClinicInput;
  where: VaccinationWhereUniqueInput;
};

export type VaccinationUpsertWithWhereUniqueWithoutClinicPetInput = {
  create: VaccinationCreateWithoutClinicPetInput;
  update: VaccinationUpdateWithoutClinicPetInput;
  where: VaccinationWhereUniqueInput;
};

export type VaccinationUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: VaccinationCreateWithoutIntegrationInput;
  update: VaccinationUpdateWithoutIntegrationInput;
  where: VaccinationWhereUniqueInput;
};

export type VaccinationVaccinationsPimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type VaccinationWhereInput = {
  AND?: Maybe<Array<VaccinationWhereInput>>;
  NOT?: Maybe<Array<VaccinationWhereInput>>;
  OR?: Maybe<Array<VaccinationWhereInput>>;
  administeredAt?: Maybe<DateTimeNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  expiredAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  manufacturer?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  serialNumber?: Maybe<StringNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  virusType?: Maybe<StringNullableFilter>;
};

export type VaccinationWhereUniqueInput = {
  AND?: Maybe<Array<VaccinationWhereInput>>;
  NOT?: Maybe<Array<VaccinationWhereInput>>;
  OR?: Maybe<Array<VaccinationWhereInput>>;
  administeredAt?: Maybe<DateTimeNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  clinicPet?: Maybe<ClinicPetScalarRelationFilter>;
  clinicPetId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  expiredAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isDeleted?: Maybe<BoolFilter>;
  manufacturer?: Maybe<StringNullableFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  serialNumber?: Maybe<StringNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vaccinationsPimsIdAndIntegrationId?: Maybe<VaccinationVaccinationsPimsIdAndIntegrationIdCompoundUniqueInput>;
  virusType?: Maybe<StringNullableFilter>;
};

export type VerificationCheckInput = {
  code: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type: VerificationType;
};

export type VerificationRequestInput = {
  clinicId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type: VerificationType;
};

export enum VerificationType {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type VerifyClinicWidgetRequestInput = {
  clinicWidgetRequestId: Scalars['ID'];
};

export type VerifyTerminalSetupPinResponse = {
  __typename?: 'VerifyTerminalSetupPinResponse';
  clinicId: Scalars['String'];
  connectionToken: Scalars['String'];
  locationId: Scalars['String'];
};

export type VerifyWidgetAuthenticationRequestInput = {
  code: Scalars['String'];
};

export type VerifyWidgetAuthenticationRequestResponse = {
  __typename?: 'VerifyWidgetAuthenticationRequestResponse';
  success?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
};

export type VetAvailability = {
  __typename?: 'VetAvailability';
  _count: VetAvailabilityCountOutputType;
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  integration?: Maybe<ClinicPimsIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isAvailable: Scalars['Boolean'];
  isRecurring: Scalars['Boolean'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds: Array<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  vetAvailabilityClinicRoomMaps: Array<VetAvailabilityClinicRoomMap>;
  vetAvailabilityMaps: Array<VetAvailabilityMap>;
};


export type VetAvailabilityIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};


export type VetAvailabilityVetAvailabilityClinicRoomMapsArgs = {
  cursor?: Maybe<VetAvailabilityClinicRoomMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityClinicRoomMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityClinicRoomMapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityClinicRoomMapWhereInput>;
};


export type VetAvailabilityVetAvailabilityMapsArgs = {
  cursor?: Maybe<VetAvailabilityMapWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetAvailabilityMapScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetAvailabilityMapOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetAvailabilityMapWhereInput>;
};

export type VetAvailabilityClinicRoomMap = {
  __typename?: 'VetAvailabilityClinicRoomMap';
  clinicRoom: ClinicRoom;
  clinicRoomId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  vetAvailability: VetAvailability;
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityClinicRoomMapClinicRoomIdVetAvailabilityIdCompoundUniqueInput = {
  clinicRoomId: Scalars['String'];
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityClinicRoomMapCountAggregateOutputType = {
  __typename?: 'VetAvailabilityClinicRoomMapCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicRoomId: Scalars['Int'];
  createdAt: Scalars['Int'];
  vetAvailabilityId: Scalars['Int'];
};

export type VetAvailabilityClinicRoomMapCountOrderByAggregateInput = {
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export type VetAvailabilityClinicRoomMapCreateInput = {
  clinicRoom: ClinicRoomCreateNestedOneWithoutVetAvailabilityClinicRoomMapsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailability: VetAvailabilityCreateNestedOneWithoutVetAvailabilityClinicRoomMapsInput;
};

export type VetAvailabilityClinicRoomMapCreateManyClinicRoomInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityClinicRoomMapCreateManyClinicRoomInputEnvelope = {
  data: Array<VetAvailabilityClinicRoomMapCreateManyClinicRoomInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type VetAvailabilityClinicRoomMapCreateManyInput = {
  clinicRoomId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityClinicRoomMapCreateManyVetAvailabilityInput = {
  clinicRoomId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityClinicRoomMapCreateManyVetAvailabilityInputEnvelope = {
  data: Array<VetAvailabilityClinicRoomMapCreateManyVetAvailabilityInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type VetAvailabilityClinicRoomMapCreateNestedManyWithoutClinicRoomInput = {
  connect?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityClinicRoomMapCreateOrConnectWithoutClinicRoomInput>>;
  create?: Maybe<Array<VetAvailabilityClinicRoomMapCreateWithoutClinicRoomInput>>;
  createMany?: Maybe<VetAvailabilityClinicRoomMapCreateManyClinicRoomInputEnvelope>;
};

export type VetAvailabilityClinicRoomMapCreateNestedManyWithoutVetAvailabilityInput = {
  connect?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityClinicRoomMapCreateOrConnectWithoutVetAvailabilityInput>>;
  create?: Maybe<Array<VetAvailabilityClinicRoomMapCreateWithoutVetAvailabilityInput>>;
  createMany?: Maybe<VetAvailabilityClinicRoomMapCreateManyVetAvailabilityInputEnvelope>;
};

export type VetAvailabilityClinicRoomMapCreateOrConnectWithoutClinicRoomInput = {
  create: VetAvailabilityClinicRoomMapCreateWithoutClinicRoomInput;
  where: VetAvailabilityClinicRoomMapWhereUniqueInput;
};

export type VetAvailabilityClinicRoomMapCreateOrConnectWithoutVetAvailabilityInput = {
  create: VetAvailabilityClinicRoomMapCreateWithoutVetAvailabilityInput;
  where: VetAvailabilityClinicRoomMapWhereUniqueInput;
};

export type VetAvailabilityClinicRoomMapCreateWithoutClinicRoomInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailability: VetAvailabilityCreateNestedOneWithoutVetAvailabilityClinicRoomMapsInput;
};

export type VetAvailabilityClinicRoomMapCreateWithoutVetAvailabilityInput = {
  clinicRoom: ClinicRoomCreateNestedOneWithoutVetAvailabilityClinicRoomMapsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityClinicRoomMapGroupByOutputType = {
  __typename?: 'VetAvailabilityClinicRoomMapGroupByOutputType';
  _count?: Maybe<VetAvailabilityClinicRoomMapCountAggregateOutputType>;
  _max?: Maybe<VetAvailabilityClinicRoomMapMaxAggregateOutputType>;
  _min?: Maybe<VetAvailabilityClinicRoomMapMinAggregateOutputType>;
  clinicRoomId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityClinicRoomMapListRelationFilter = {
  every?: Maybe<VetAvailabilityClinicRoomMapWhereInput>;
  none?: Maybe<VetAvailabilityClinicRoomMapWhereInput>;
  some?: Maybe<VetAvailabilityClinicRoomMapWhereInput>;
};

export type VetAvailabilityClinicRoomMapMaxAggregateOutputType = {
  __typename?: 'VetAvailabilityClinicRoomMapMaxAggregateOutputType';
  clinicRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId?: Maybe<Scalars['String']>;
};

export type VetAvailabilityClinicRoomMapMaxOrderByAggregateInput = {
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export type VetAvailabilityClinicRoomMapMinAggregateOutputType = {
  __typename?: 'VetAvailabilityClinicRoomMapMinAggregateOutputType';
  clinicRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId?: Maybe<Scalars['String']>;
};

export type VetAvailabilityClinicRoomMapMinOrderByAggregateInput = {
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export type VetAvailabilityClinicRoomMapOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type VetAvailabilityClinicRoomMapOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetAvailabilityClinicRoomMapOrderByRelevanceInput>;
  clinicRoom?: Maybe<ClinicRoomOrderByWithRelationInput>;
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailability?: Maybe<VetAvailabilityOrderByWithRelationInput>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export enum VetAvailabilityClinicRoomMapOrderByRelevanceFieldEnum {
  ClinicRoomId = 'clinicRoomId',
  VetAvailabilityId = 'vetAvailabilityId'
}

export type VetAvailabilityClinicRoomMapOrderByRelevanceInput = {
  fields: Array<VetAvailabilityClinicRoomMapOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type VetAvailabilityClinicRoomMapOrderByWithAggregationInput = {
  _count?: Maybe<VetAvailabilityClinicRoomMapCountOrderByAggregateInput>;
  _max?: Maybe<VetAvailabilityClinicRoomMapMaxOrderByAggregateInput>;
  _min?: Maybe<VetAvailabilityClinicRoomMapMinOrderByAggregateInput>;
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export type VetAvailabilityClinicRoomMapOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetAvailabilityClinicRoomMapOrderByRelevanceInput>;
  clinicRoom?: Maybe<ClinicRoomOrderByWithRelationInput>;
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailability?: Maybe<VetAvailabilityOrderByWithRelationInput>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export type VetAvailabilityClinicRoomMapOrderByWithRelationInput = {
  _relevance?: Maybe<VetAvailabilityClinicRoomMapOrderByRelevanceInput>;
  clinicRoom?: Maybe<ClinicRoomOrderByWithRelationInput>;
  clinicRoomId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailability?: Maybe<VetAvailabilityOrderByWithRelationInput>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export enum VetAvailabilityClinicRoomMapScalarFieldEnum {
  ClinicRoomId = 'clinicRoomId',
  CreatedAt = 'createdAt',
  VetAvailabilityId = 'vetAvailabilityId'
}

export type VetAvailabilityClinicRoomMapScalarWhereInput = {
  AND?: Maybe<Array<VetAvailabilityClinicRoomMapScalarWhereInput>>;
  NOT?: Maybe<Array<VetAvailabilityClinicRoomMapScalarWhereInput>>;
  OR?: Maybe<Array<VetAvailabilityClinicRoomMapScalarWhereInput>>;
  clinicRoomId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  vetAvailabilityId?: Maybe<StringFilter>;
};

export type VetAvailabilityClinicRoomMapScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<VetAvailabilityClinicRoomMapScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<VetAvailabilityClinicRoomMapScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<VetAvailabilityClinicRoomMapScalarWhereWithAggregatesInput>>;
  clinicRoomId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  vetAvailabilityId?: Maybe<StringWithAggregatesFilter>;
};

export type VetAvailabilityClinicRoomMapUncheckedCreateInput = {
  clinicRoomId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutClinicRoomInput = {
  connect?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityClinicRoomMapCreateOrConnectWithoutClinicRoomInput>>;
  create?: Maybe<Array<VetAvailabilityClinicRoomMapCreateWithoutClinicRoomInput>>;
  createMany?: Maybe<VetAvailabilityClinicRoomMapCreateManyClinicRoomInputEnvelope>;
};

export type VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutVetAvailabilityInput = {
  connect?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityClinicRoomMapCreateOrConnectWithoutVetAvailabilityInput>>;
  create?: Maybe<Array<VetAvailabilityClinicRoomMapCreateWithoutVetAvailabilityInput>>;
  createMany?: Maybe<VetAvailabilityClinicRoomMapCreateManyVetAvailabilityInputEnvelope>;
};

export type VetAvailabilityClinicRoomMapUncheckedCreateWithoutClinicRoomInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityClinicRoomMapUncheckedCreateWithoutVetAvailabilityInput = {
  clinicRoomId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityClinicRoomMapUncheckedUpdateInput = {
  clinicRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId?: Maybe<Scalars['String']>;
};

export type VetAvailabilityClinicRoomMapUncheckedUpdateManyInput = {
  clinicRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId?: Maybe<Scalars['String']>;
};

export type VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutClinicRoomInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId?: Maybe<Scalars['String']>;
};

export type VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutClinicRoomNestedInput = {
  connect?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityClinicRoomMapCreateOrConnectWithoutClinicRoomInput>>;
  create?: Maybe<Array<VetAvailabilityClinicRoomMapCreateWithoutClinicRoomInput>>;
  createMany?: Maybe<VetAvailabilityClinicRoomMapCreateManyClinicRoomInputEnvelope>;
  delete?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetAvailabilityClinicRoomMapScalarWhereInput>>;
  disconnect?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  set?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  update?: Maybe<Array<VetAvailabilityClinicRoomMapUpdateWithWhereUniqueWithoutClinicRoomInput>>;
  updateMany?: Maybe<Array<VetAvailabilityClinicRoomMapUpdateManyWithWhereWithoutClinicRoomInput>>;
  upsert?: Maybe<Array<VetAvailabilityClinicRoomMapUpsertWithWhereUniqueWithoutClinicRoomInput>>;
};

export type VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutVetAvailabilityInput = {
  clinicRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutVetAvailabilityNestedInput = {
  connect?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityClinicRoomMapCreateOrConnectWithoutVetAvailabilityInput>>;
  create?: Maybe<Array<VetAvailabilityClinicRoomMapCreateWithoutVetAvailabilityInput>>;
  createMany?: Maybe<VetAvailabilityClinicRoomMapCreateManyVetAvailabilityInputEnvelope>;
  delete?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetAvailabilityClinicRoomMapScalarWhereInput>>;
  disconnect?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  set?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  update?: Maybe<Array<VetAvailabilityClinicRoomMapUpdateWithWhereUniqueWithoutVetAvailabilityInput>>;
  updateMany?: Maybe<Array<VetAvailabilityClinicRoomMapUpdateManyWithWhereWithoutVetAvailabilityInput>>;
  upsert?: Maybe<Array<VetAvailabilityClinicRoomMapUpsertWithWhereUniqueWithoutVetAvailabilityInput>>;
};

export type VetAvailabilityClinicRoomMapUncheckedUpdateWithoutClinicRoomInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId?: Maybe<Scalars['String']>;
};

export type VetAvailabilityClinicRoomMapUncheckedUpdateWithoutVetAvailabilityInput = {
  clinicRoomId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityClinicRoomMapUpdateInput = {
  clinicRoom?: Maybe<ClinicRoomUpdateOneRequiredWithoutVetAvailabilityClinicRoomMapsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailability?: Maybe<VetAvailabilityUpdateOneRequiredWithoutVetAvailabilityClinicRoomMapsNestedInput>;
};

export type VetAvailabilityClinicRoomMapUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityClinicRoomMapUpdateManyWithWhereWithoutClinicRoomInput = {
  data: VetAvailabilityClinicRoomMapUpdateManyMutationInput;
  where: VetAvailabilityClinicRoomMapScalarWhereInput;
};

export type VetAvailabilityClinicRoomMapUpdateManyWithWhereWithoutVetAvailabilityInput = {
  data: VetAvailabilityClinicRoomMapUpdateManyMutationInput;
  where: VetAvailabilityClinicRoomMapScalarWhereInput;
};

export type VetAvailabilityClinicRoomMapUpdateManyWithoutClinicRoomNestedInput = {
  connect?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityClinicRoomMapCreateOrConnectWithoutClinicRoomInput>>;
  create?: Maybe<Array<VetAvailabilityClinicRoomMapCreateWithoutClinicRoomInput>>;
  createMany?: Maybe<VetAvailabilityClinicRoomMapCreateManyClinicRoomInputEnvelope>;
  delete?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetAvailabilityClinicRoomMapScalarWhereInput>>;
  disconnect?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  set?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  update?: Maybe<Array<VetAvailabilityClinicRoomMapUpdateWithWhereUniqueWithoutClinicRoomInput>>;
  updateMany?: Maybe<Array<VetAvailabilityClinicRoomMapUpdateManyWithWhereWithoutClinicRoomInput>>;
  upsert?: Maybe<Array<VetAvailabilityClinicRoomMapUpsertWithWhereUniqueWithoutClinicRoomInput>>;
};

export type VetAvailabilityClinicRoomMapUpdateManyWithoutVetAvailabilityNestedInput = {
  connect?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityClinicRoomMapCreateOrConnectWithoutVetAvailabilityInput>>;
  create?: Maybe<Array<VetAvailabilityClinicRoomMapCreateWithoutVetAvailabilityInput>>;
  createMany?: Maybe<VetAvailabilityClinicRoomMapCreateManyVetAvailabilityInputEnvelope>;
  delete?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetAvailabilityClinicRoomMapScalarWhereInput>>;
  disconnect?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  set?: Maybe<Array<VetAvailabilityClinicRoomMapWhereUniqueInput>>;
  update?: Maybe<Array<VetAvailabilityClinicRoomMapUpdateWithWhereUniqueWithoutVetAvailabilityInput>>;
  updateMany?: Maybe<Array<VetAvailabilityClinicRoomMapUpdateManyWithWhereWithoutVetAvailabilityInput>>;
  upsert?: Maybe<Array<VetAvailabilityClinicRoomMapUpsertWithWhereUniqueWithoutVetAvailabilityInput>>;
};

export type VetAvailabilityClinicRoomMapUpdateWithWhereUniqueWithoutClinicRoomInput = {
  data: VetAvailabilityClinicRoomMapUpdateWithoutClinicRoomInput;
  where: VetAvailabilityClinicRoomMapWhereUniqueInput;
};

export type VetAvailabilityClinicRoomMapUpdateWithWhereUniqueWithoutVetAvailabilityInput = {
  data: VetAvailabilityClinicRoomMapUpdateWithoutVetAvailabilityInput;
  where: VetAvailabilityClinicRoomMapWhereUniqueInput;
};

export type VetAvailabilityClinicRoomMapUpdateWithoutClinicRoomInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailability?: Maybe<VetAvailabilityUpdateOneRequiredWithoutVetAvailabilityClinicRoomMapsNestedInput>;
};

export type VetAvailabilityClinicRoomMapUpdateWithoutVetAvailabilityInput = {
  clinicRoom?: Maybe<ClinicRoomUpdateOneRequiredWithoutVetAvailabilityClinicRoomMapsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityClinicRoomMapUpsertWithWhereUniqueWithoutClinicRoomInput = {
  create: VetAvailabilityClinicRoomMapCreateWithoutClinicRoomInput;
  update: VetAvailabilityClinicRoomMapUpdateWithoutClinicRoomInput;
  where: VetAvailabilityClinicRoomMapWhereUniqueInput;
};

export type VetAvailabilityClinicRoomMapUpsertWithWhereUniqueWithoutVetAvailabilityInput = {
  create: VetAvailabilityClinicRoomMapCreateWithoutVetAvailabilityInput;
  update: VetAvailabilityClinicRoomMapUpdateWithoutVetAvailabilityInput;
  where: VetAvailabilityClinicRoomMapWhereUniqueInput;
};

export type VetAvailabilityClinicRoomMapWhereInput = {
  AND?: Maybe<Array<VetAvailabilityClinicRoomMapWhereInput>>;
  NOT?: Maybe<Array<VetAvailabilityClinicRoomMapWhereInput>>;
  OR?: Maybe<Array<VetAvailabilityClinicRoomMapWhereInput>>;
  clinicRoom?: Maybe<ClinicRoomScalarRelationFilter>;
  clinicRoomId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  vetAvailability?: Maybe<VetAvailabilityScalarRelationFilter>;
  vetAvailabilityId?: Maybe<StringFilter>;
};

export type VetAvailabilityClinicRoomMapWhereUniqueInput = {
  AND?: Maybe<Array<VetAvailabilityClinicRoomMapWhereInput>>;
  NOT?: Maybe<Array<VetAvailabilityClinicRoomMapWhereInput>>;
  OR?: Maybe<Array<VetAvailabilityClinicRoomMapWhereInput>>;
  clinicRoom?: Maybe<ClinicRoomScalarRelationFilter>;
  clinicRoomId?: Maybe<StringFilter>;
  clinicRoomIdVetAvailabilityId?: Maybe<VetAvailabilityClinicRoomMapClinicRoomIdVetAvailabilityIdCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  vetAvailability?: Maybe<VetAvailabilityScalarRelationFilter>;
  vetAvailabilityId?: Maybe<StringFilter>;
};

export type VetAvailabilityCountAggregateOutputType = {
  __typename?: 'VetAvailabilityCountAggregateOutputType';
  _all: Scalars['Int'];
  availabilityPimsType: Scalars['Int'];
  availabilityType: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  endDate: Scalars['Int'];
  id: Scalars['Int'];
  integrationId: Scalars['Int'];
  isActive: Scalars['Int'];
  isAvailable: Scalars['Int'];
  isRecurring: Scalars['Int'];
  pimsId: Scalars['Int'];
  rawPimsValue: Scalars['Int'];
  reason: Scalars['Int'];
  recurringRules: Scalars['Int'];
  resourceIds: Scalars['Int'];
  siteId: Scalars['Int'];
  startDate: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type VetAvailabilityCountOrderByAggregateInput = {
  availabilityPimsType?: Maybe<SortOrder>;
  availabilityType?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  isRecurring?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recurringRules?: Maybe<SortOrder>;
  resourceIds?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetAvailabilityCountOutputType = {
  __typename?: 'VetAvailabilityCountOutputType';
  vetAvailabilityClinicRoomMaps: Scalars['Int'];
  vetAvailabilityMaps: Scalars['Int'];
};

export type VetAvailabilityCreateInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinic: ClinicCreateNestedOneWithoutVetAvailabilitiesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutVetAvailabilitiesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapCreateNestedManyWithoutVetAvailabilityInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutVetAvailabilityInput>;
};

export type VetAvailabilityCreateManyClinicInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityCreateManyClinicInputEnvelope = {
  data: Array<VetAvailabilityCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type VetAvailabilityCreateManyInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityCreateManyIntegrationInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityCreateManyIntegrationInputEnvelope = {
  data: Array<VetAvailabilityCreateManyIntegrationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type VetAvailabilityCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<VetAvailabilityCreateWithoutClinicInput>>;
  createMany?: Maybe<VetAvailabilityCreateManyClinicInputEnvelope>;
};

export type VetAvailabilityCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<VetAvailabilityCreateWithoutIntegrationInput>>;
  createMany?: Maybe<VetAvailabilityCreateManyIntegrationInputEnvelope>;
};

export type VetAvailabilityCreateNestedOneWithoutVetAvailabilityClinicRoomMapsInput = {
  connect?: Maybe<VetAvailabilityWhereUniqueInput>;
  connectOrCreate?: Maybe<VetAvailabilityCreateOrConnectWithoutVetAvailabilityClinicRoomMapsInput>;
  create?: Maybe<VetAvailabilityCreateWithoutVetAvailabilityClinicRoomMapsInput>;
};

export type VetAvailabilityCreateNestedOneWithoutVetAvailabilityMapsInput = {
  connect?: Maybe<VetAvailabilityWhereUniqueInput>;
  connectOrCreate?: Maybe<VetAvailabilityCreateOrConnectWithoutVetAvailabilityMapsInput>;
  create?: Maybe<VetAvailabilityCreateWithoutVetAvailabilityMapsInput>;
};

export type VetAvailabilityCreateOrConnectWithoutClinicInput = {
  create: VetAvailabilityCreateWithoutClinicInput;
  where: VetAvailabilityWhereUniqueInput;
};

export type VetAvailabilityCreateOrConnectWithoutIntegrationInput = {
  create: VetAvailabilityCreateWithoutIntegrationInput;
  where: VetAvailabilityWhereUniqueInput;
};

export type VetAvailabilityCreateOrConnectWithoutVetAvailabilityClinicRoomMapsInput = {
  create: VetAvailabilityCreateWithoutVetAvailabilityClinicRoomMapsInput;
  where: VetAvailabilityWhereUniqueInput;
};

export type VetAvailabilityCreateOrConnectWithoutVetAvailabilityMapsInput = {
  create: VetAvailabilityCreateWithoutVetAvailabilityMapsInput;
  where: VetAvailabilityWhereUniqueInput;
};

export type VetAvailabilityCreateWithoutClinicInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutVetAvailabilitiesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapCreateNestedManyWithoutVetAvailabilityInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutVetAvailabilityInput>;
};

export type VetAvailabilityCreateWithoutIntegrationInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinic: ClinicCreateNestedOneWithoutVetAvailabilitiesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapCreateNestedManyWithoutVetAvailabilityInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutVetAvailabilityInput>;
};

export type VetAvailabilityCreateWithoutVetAvailabilityClinicRoomMapsInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinic: ClinicCreateNestedOneWithoutVetAvailabilitiesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutVetAvailabilitiesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapCreateNestedManyWithoutVetAvailabilityInput>;
};

export type VetAvailabilityCreateWithoutVetAvailabilityMapsInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinic: ClinicCreateNestedOneWithoutVetAvailabilitiesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutVetAvailabilitiesInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapCreateNestedManyWithoutVetAvailabilityInput>;
};

export type VetAvailabilityCreateresourceIdsInput = {
  set: Array<Scalars['String']>;
};

export type VetAvailabilityGroupByOutputType = {
  __typename?: 'VetAvailabilityGroupByOutputType';
  _count?: Maybe<VetAvailabilityCountAggregateOutputType>;
  _max?: Maybe<VetAvailabilityMaxAggregateOutputType>;
  _min?: Maybe<VetAvailabilityMinAggregateOutputType>;
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  integrationId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isAvailable: Scalars['Boolean'];
  isRecurring: Scalars['Boolean'];
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type VetAvailabilityListRelationFilter = {
  every?: Maybe<VetAvailabilityWhereInput>;
  none?: Maybe<VetAvailabilityWhereInput>;
  some?: Maybe<VetAvailabilityWhereInput>;
};

export type VetAvailabilityMap = {
  __typename?: 'VetAvailabilityMap';
  clinicEmployee: ClinicEmployee;
  clinicEmployeeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  vetAvailability: VetAvailability;
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityMapClinicEmployeeIdVetAvailabilityIdCompoundUniqueInput = {
  clinicEmployeeId: Scalars['String'];
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityMapCountAggregateOutputType = {
  __typename?: 'VetAvailabilityMapCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicEmployeeId: Scalars['Int'];
  createdAt: Scalars['Int'];
  vetAvailabilityId: Scalars['Int'];
};

export type VetAvailabilityMapCountOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export type VetAvailabilityMapCreateInput = {
  clinicEmployee: ClinicEmployeeCreateNestedOneWithoutVetAvailabilityMapsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailability: VetAvailabilityCreateNestedOneWithoutVetAvailabilityMapsInput;
};

export type VetAvailabilityMapCreateManyClinicEmployeeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityMapCreateManyClinicEmployeeInputEnvelope = {
  data: Array<VetAvailabilityMapCreateManyClinicEmployeeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type VetAvailabilityMapCreateManyInput = {
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityMapCreateManyVetAvailabilityInput = {
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityMapCreateManyVetAvailabilityInputEnvelope = {
  data: Array<VetAvailabilityMapCreateManyVetAvailabilityInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type VetAvailabilityMapCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityMapCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<VetAvailabilityMapCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<VetAvailabilityMapCreateManyClinicEmployeeInputEnvelope>;
};

export type VetAvailabilityMapCreateNestedManyWithoutVetAvailabilityInput = {
  connect?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityMapCreateOrConnectWithoutVetAvailabilityInput>>;
  create?: Maybe<Array<VetAvailabilityMapCreateWithoutVetAvailabilityInput>>;
  createMany?: Maybe<VetAvailabilityMapCreateManyVetAvailabilityInputEnvelope>;
};

export type VetAvailabilityMapCreateOrConnectWithoutClinicEmployeeInput = {
  create: VetAvailabilityMapCreateWithoutClinicEmployeeInput;
  where: VetAvailabilityMapWhereUniqueInput;
};

export type VetAvailabilityMapCreateOrConnectWithoutVetAvailabilityInput = {
  create: VetAvailabilityMapCreateWithoutVetAvailabilityInput;
  where: VetAvailabilityMapWhereUniqueInput;
};

export type VetAvailabilityMapCreateWithoutClinicEmployeeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailability: VetAvailabilityCreateNestedOneWithoutVetAvailabilityMapsInput;
};

export type VetAvailabilityMapCreateWithoutVetAvailabilityInput = {
  clinicEmployee: ClinicEmployeeCreateNestedOneWithoutVetAvailabilityMapsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityMapGroupByOutputType = {
  __typename?: 'VetAvailabilityMapGroupByOutputType';
  _count?: Maybe<VetAvailabilityMapCountAggregateOutputType>;
  _max?: Maybe<VetAvailabilityMapMaxAggregateOutputType>;
  _min?: Maybe<VetAvailabilityMapMinAggregateOutputType>;
  clinicEmployeeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityMapListRelationFilter = {
  every?: Maybe<VetAvailabilityMapWhereInput>;
  none?: Maybe<VetAvailabilityMapWhereInput>;
  some?: Maybe<VetAvailabilityMapWhereInput>;
};

export type VetAvailabilityMapMaxAggregateOutputType = {
  __typename?: 'VetAvailabilityMapMaxAggregateOutputType';
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId?: Maybe<Scalars['String']>;
};

export type VetAvailabilityMapMaxOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export type VetAvailabilityMapMinAggregateOutputType = {
  __typename?: 'VetAvailabilityMapMinAggregateOutputType';
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId?: Maybe<Scalars['String']>;
};

export type VetAvailabilityMapMinOrderByAggregateInput = {
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export type VetAvailabilityMapOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type VetAvailabilityMapOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetAvailabilityMapOrderByRelevanceInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailability?: Maybe<VetAvailabilityOrderByWithRelationInput>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export enum VetAvailabilityMapOrderByRelevanceFieldEnum {
  ClinicEmployeeId = 'clinicEmployeeId',
  VetAvailabilityId = 'vetAvailabilityId'
}

export type VetAvailabilityMapOrderByRelevanceInput = {
  fields: Array<VetAvailabilityMapOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type VetAvailabilityMapOrderByWithAggregationInput = {
  _count?: Maybe<VetAvailabilityMapCountOrderByAggregateInput>;
  _max?: Maybe<VetAvailabilityMapMaxOrderByAggregateInput>;
  _min?: Maybe<VetAvailabilityMapMinOrderByAggregateInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export type VetAvailabilityMapOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetAvailabilityMapOrderByRelevanceInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailability?: Maybe<VetAvailabilityOrderByWithRelationInput>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export type VetAvailabilityMapOrderByWithRelationInput = {
  _relevance?: Maybe<VetAvailabilityMapOrderByRelevanceInput>;
  clinicEmployee?: Maybe<ClinicEmployeeOrderByWithRelationInput>;
  clinicEmployeeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  vetAvailability?: Maybe<VetAvailabilityOrderByWithRelationInput>;
  vetAvailabilityId?: Maybe<SortOrder>;
};

export enum VetAvailabilityMapScalarFieldEnum {
  ClinicEmployeeId = 'clinicEmployeeId',
  CreatedAt = 'createdAt',
  VetAvailabilityId = 'vetAvailabilityId'
}

export type VetAvailabilityMapScalarWhereInput = {
  AND?: Maybe<Array<VetAvailabilityMapScalarWhereInput>>;
  NOT?: Maybe<Array<VetAvailabilityMapScalarWhereInput>>;
  OR?: Maybe<Array<VetAvailabilityMapScalarWhereInput>>;
  clinicEmployeeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  vetAvailabilityId?: Maybe<StringFilter>;
};

export type VetAvailabilityMapScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<VetAvailabilityMapScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<VetAvailabilityMapScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<VetAvailabilityMapScalarWhereWithAggregatesInput>>;
  clinicEmployeeId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  vetAvailabilityId?: Maybe<StringWithAggregatesFilter>;
};

export type VetAvailabilityMapUncheckedCreateInput = {
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityMapUncheckedCreateNestedManyWithoutClinicEmployeeInput = {
  connect?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityMapCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<VetAvailabilityMapCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<VetAvailabilityMapCreateManyClinicEmployeeInputEnvelope>;
};

export type VetAvailabilityMapUncheckedCreateNestedManyWithoutVetAvailabilityInput = {
  connect?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityMapCreateOrConnectWithoutVetAvailabilityInput>>;
  create?: Maybe<Array<VetAvailabilityMapCreateWithoutVetAvailabilityInput>>;
  createMany?: Maybe<VetAvailabilityMapCreateManyVetAvailabilityInputEnvelope>;
};

export type VetAvailabilityMapUncheckedCreateWithoutClinicEmployeeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId: Scalars['String'];
};

export type VetAvailabilityMapUncheckedCreateWithoutVetAvailabilityInput = {
  clinicEmployeeId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityMapUncheckedUpdateInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId?: Maybe<Scalars['String']>;
};

export type VetAvailabilityMapUncheckedUpdateManyInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId?: Maybe<Scalars['String']>;
};

export type VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId?: Maybe<Scalars['String']>;
};

export type VetAvailabilityMapUncheckedUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityMapCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<VetAvailabilityMapCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<VetAvailabilityMapCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetAvailabilityMapScalarWhereInput>>;
  disconnect?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  set?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  update?: Maybe<Array<VetAvailabilityMapUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<VetAvailabilityMapUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<VetAvailabilityMapUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type VetAvailabilityMapUncheckedUpdateManyWithoutVetAvailabilityInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityMapUncheckedUpdateManyWithoutVetAvailabilityNestedInput = {
  connect?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityMapCreateOrConnectWithoutVetAvailabilityInput>>;
  create?: Maybe<Array<VetAvailabilityMapCreateWithoutVetAvailabilityInput>>;
  createMany?: Maybe<VetAvailabilityMapCreateManyVetAvailabilityInputEnvelope>;
  delete?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetAvailabilityMapScalarWhereInput>>;
  disconnect?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  set?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  update?: Maybe<Array<VetAvailabilityMapUpdateWithWhereUniqueWithoutVetAvailabilityInput>>;
  updateMany?: Maybe<Array<VetAvailabilityMapUpdateManyWithWhereWithoutVetAvailabilityInput>>;
  upsert?: Maybe<Array<VetAvailabilityMapUpsertWithWhereUniqueWithoutVetAvailabilityInput>>;
};

export type VetAvailabilityMapUncheckedUpdateWithoutClinicEmployeeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityId?: Maybe<Scalars['String']>;
};

export type VetAvailabilityMapUncheckedUpdateWithoutVetAvailabilityInput = {
  clinicEmployeeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityMapUpdateInput = {
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneRequiredWithoutVetAvailabilityMapsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailability?: Maybe<VetAvailabilityUpdateOneRequiredWithoutVetAvailabilityMapsNestedInput>;
};

export type VetAvailabilityMapUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityMapUpdateManyWithWhereWithoutClinicEmployeeInput = {
  data: VetAvailabilityMapUpdateManyMutationInput;
  where: VetAvailabilityMapScalarWhereInput;
};

export type VetAvailabilityMapUpdateManyWithWhereWithoutVetAvailabilityInput = {
  data: VetAvailabilityMapUpdateManyMutationInput;
  where: VetAvailabilityMapScalarWhereInput;
};

export type VetAvailabilityMapUpdateManyWithoutClinicEmployeeNestedInput = {
  connect?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityMapCreateOrConnectWithoutClinicEmployeeInput>>;
  create?: Maybe<Array<VetAvailabilityMapCreateWithoutClinicEmployeeInput>>;
  createMany?: Maybe<VetAvailabilityMapCreateManyClinicEmployeeInputEnvelope>;
  delete?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetAvailabilityMapScalarWhereInput>>;
  disconnect?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  set?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  update?: Maybe<Array<VetAvailabilityMapUpdateWithWhereUniqueWithoutClinicEmployeeInput>>;
  updateMany?: Maybe<Array<VetAvailabilityMapUpdateManyWithWhereWithoutClinicEmployeeInput>>;
  upsert?: Maybe<Array<VetAvailabilityMapUpsertWithWhereUniqueWithoutClinicEmployeeInput>>;
};

export type VetAvailabilityMapUpdateManyWithoutVetAvailabilityNestedInput = {
  connect?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityMapCreateOrConnectWithoutVetAvailabilityInput>>;
  create?: Maybe<Array<VetAvailabilityMapCreateWithoutVetAvailabilityInput>>;
  createMany?: Maybe<VetAvailabilityMapCreateManyVetAvailabilityInputEnvelope>;
  delete?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetAvailabilityMapScalarWhereInput>>;
  disconnect?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  set?: Maybe<Array<VetAvailabilityMapWhereUniqueInput>>;
  update?: Maybe<Array<VetAvailabilityMapUpdateWithWhereUniqueWithoutVetAvailabilityInput>>;
  updateMany?: Maybe<Array<VetAvailabilityMapUpdateManyWithWhereWithoutVetAvailabilityInput>>;
  upsert?: Maybe<Array<VetAvailabilityMapUpsertWithWhereUniqueWithoutVetAvailabilityInput>>;
};

export type VetAvailabilityMapUpdateWithWhereUniqueWithoutClinicEmployeeInput = {
  data: VetAvailabilityMapUpdateWithoutClinicEmployeeInput;
  where: VetAvailabilityMapWhereUniqueInput;
};

export type VetAvailabilityMapUpdateWithWhereUniqueWithoutVetAvailabilityInput = {
  data: VetAvailabilityMapUpdateWithoutVetAvailabilityInput;
  where: VetAvailabilityMapWhereUniqueInput;
};

export type VetAvailabilityMapUpdateWithoutClinicEmployeeInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  vetAvailability?: Maybe<VetAvailabilityUpdateOneRequiredWithoutVetAvailabilityMapsNestedInput>;
};

export type VetAvailabilityMapUpdateWithoutVetAvailabilityInput = {
  clinicEmployee?: Maybe<ClinicEmployeeUpdateOneRequiredWithoutVetAvailabilityMapsNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityMapUpsertWithWhereUniqueWithoutClinicEmployeeInput = {
  create: VetAvailabilityMapCreateWithoutClinicEmployeeInput;
  update: VetAvailabilityMapUpdateWithoutClinicEmployeeInput;
  where: VetAvailabilityMapWhereUniqueInput;
};

export type VetAvailabilityMapUpsertWithWhereUniqueWithoutVetAvailabilityInput = {
  create: VetAvailabilityMapCreateWithoutVetAvailabilityInput;
  update: VetAvailabilityMapUpdateWithoutVetAvailabilityInput;
  where: VetAvailabilityMapWhereUniqueInput;
};

export type VetAvailabilityMapWhereInput = {
  AND?: Maybe<Array<VetAvailabilityMapWhereInput>>;
  NOT?: Maybe<Array<VetAvailabilityMapWhereInput>>;
  OR?: Maybe<Array<VetAvailabilityMapWhereInput>>;
  clinicEmployee?: Maybe<ClinicEmployeeScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  vetAvailability?: Maybe<VetAvailabilityScalarRelationFilter>;
  vetAvailabilityId?: Maybe<StringFilter>;
};

export type VetAvailabilityMapWhereUniqueInput = {
  AND?: Maybe<Array<VetAvailabilityMapWhereInput>>;
  NOT?: Maybe<Array<VetAvailabilityMapWhereInput>>;
  OR?: Maybe<Array<VetAvailabilityMapWhereInput>>;
  clinicEmployee?: Maybe<ClinicEmployeeScalarRelationFilter>;
  clinicEmployeeId?: Maybe<StringFilter>;
  clinicEmployeeIdVetAvailabilityId?: Maybe<VetAvailabilityMapClinicEmployeeIdVetAvailabilityIdCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  vetAvailability?: Maybe<VetAvailabilityScalarRelationFilter>;
  vetAvailabilityId?: Maybe<StringFilter>;
};

export type VetAvailabilityMaxAggregateOutputType = {
  __typename?: 'VetAvailabilityMaxAggregateOutputType';
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityMaxOrderByAggregateInput = {
  availabilityPimsType?: Maybe<SortOrder>;
  availabilityType?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  isRecurring?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recurringRules?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetAvailabilityMinAggregateOutputType = {
  __typename?: 'VetAvailabilityMinAggregateOutputType';
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityMinOrderByAggregateInput = {
  availabilityPimsType?: Maybe<SortOrder>;
  availabilityType?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  isRecurring?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recurringRules?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetAvailabilityOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type VetAvailabilityOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetAvailabilityOrderByRelevanceInput>;
  availabilityPimsType?: Maybe<SortOrder>;
  availabilityType?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  isRecurring?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recurringRules?: Maybe<SortOrder>;
  resourceIds?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapOrderByRelationAggregateInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapOrderByRelationAggregateInput>;
};

export enum VetAvailabilityOrderByRelevanceFieldEnum {
  AvailabilityPimsType = 'availabilityPimsType',
  AvailabilityType = 'availabilityType',
  ClinicId = 'clinicId',
  Id = 'id',
  IntegrationId = 'integrationId',
  PimsId = 'pimsId',
  Reason = 'reason',
  RecurringRules = 'recurringRules',
  ResourceIds = 'resourceIds',
  SiteId = 'siteId'
}

export type VetAvailabilityOrderByRelevanceInput = {
  fields: Array<VetAvailabilityOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type VetAvailabilityOrderByWithAggregationInput = {
  _count?: Maybe<VetAvailabilityCountOrderByAggregateInput>;
  _max?: Maybe<VetAvailabilityMaxOrderByAggregateInput>;
  _min?: Maybe<VetAvailabilityMinOrderByAggregateInput>;
  availabilityPimsType?: Maybe<SortOrder>;
  availabilityType?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  isRecurring?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recurringRules?: Maybe<SortOrder>;
  resourceIds?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetAvailabilityOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetAvailabilityOrderByRelevanceInput>;
  availabilityPimsType?: Maybe<SortOrder>;
  availabilityType?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  isRecurring?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recurringRules?: Maybe<SortOrder>;
  resourceIds?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapOrderByRelationAggregateInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapOrderByRelationAggregateInput>;
};

export type VetAvailabilityOrderByWithRelationInput = {
  _relevance?: Maybe<VetAvailabilityOrderByRelevanceInput>;
  availabilityPimsType?: Maybe<SortOrder>;
  availabilityType?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  integrationId?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isAvailable?: Maybe<SortOrder>;
  isRecurring?: Maybe<SortOrder>;
  pimsId?: Maybe<SortOrder>;
  rawPimsValue?: Maybe<SortOrder>;
  reason?: Maybe<SortOrder>;
  recurringRules?: Maybe<SortOrder>;
  resourceIds?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapOrderByRelationAggregateInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapOrderByRelationAggregateInput>;
};

export enum VetAvailabilityScalarFieldEnum {
  AvailabilityPimsType = 'availabilityPimsType',
  AvailabilityType = 'availabilityType',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  Id = 'id',
  IntegrationId = 'integrationId',
  IsActive = 'isActive',
  IsAvailable = 'isAvailable',
  IsRecurring = 'isRecurring',
  PimsId = 'pimsId',
  RawPimsValue = 'rawPimsValue',
  Reason = 'reason',
  RecurringRules = 'recurringRules',
  ResourceIds = 'resourceIds',
  SiteId = 'siteId',
  StartDate = 'startDate',
  UpdatedAt = 'updatedAt'
}

export type VetAvailabilityScalarRelationFilter = {
  AND?: Maybe<Array<VetAvailabilityWhereInput>>;
  NOT?: Maybe<Array<VetAvailabilityWhereInput>>;
  OR?: Maybe<Array<VetAvailabilityWhereInput>>;
  availabilityPimsType?: Maybe<StringNullableFilter>;
  availabilityType?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endDate?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isAvailable?: Maybe<BoolFilter>;
  isRecurring?: Maybe<BoolFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  reason?: Maybe<StringNullableFilter>;
  recurringRules?: Maybe<StringNullableFilter>;
  resourceIds?: Maybe<StringNullableListFilter>;
  siteId?: Maybe<StringNullableFilter>;
  startDate?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapListRelationFilter>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapListRelationFilter>;
};

export type VetAvailabilityScalarWhereInput = {
  AND?: Maybe<Array<VetAvailabilityScalarWhereInput>>;
  NOT?: Maybe<Array<VetAvailabilityScalarWhereInput>>;
  OR?: Maybe<Array<VetAvailabilityScalarWhereInput>>;
  availabilityPimsType?: Maybe<StringNullableFilter>;
  availabilityType?: Maybe<StringNullableFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endDate?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isAvailable?: Maybe<BoolFilter>;
  isRecurring?: Maybe<BoolFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  reason?: Maybe<StringNullableFilter>;
  recurringRules?: Maybe<StringNullableFilter>;
  resourceIds?: Maybe<StringNullableListFilter>;
  siteId?: Maybe<StringNullableFilter>;
  startDate?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetAvailabilityScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<VetAvailabilityScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<VetAvailabilityScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<VetAvailabilityScalarWhereWithAggregatesInput>>;
  availabilityPimsType?: Maybe<StringNullableWithAggregatesFilter>;
  availabilityType?: Maybe<StringNullableWithAggregatesFilter>;
  clinicId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  endDate?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationId?: Maybe<StringNullableWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  isAvailable?: Maybe<BoolWithAggregatesFilter>;
  isRecurring?: Maybe<BoolWithAggregatesFilter>;
  pimsId?: Maybe<StringNullableWithAggregatesFilter>;
  rawPimsValue?: Maybe<JsonNullableWithAggregatesFilter>;
  reason?: Maybe<StringNullableWithAggregatesFilter>;
  recurringRules?: Maybe<StringNullableWithAggregatesFilter>;
  resourceIds?: Maybe<StringNullableListFilter>;
  siteId?: Maybe<StringNullableWithAggregatesFilter>;
  startDate?: Maybe<DateTimeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type VetAvailabilityUncheckedCreateInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutVetAvailabilityInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutVetAvailabilityInput>;
};

export type VetAvailabilityUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<VetAvailabilityCreateWithoutClinicInput>>;
  createMany?: Maybe<VetAvailabilityCreateManyClinicInputEnvelope>;
};

export type VetAvailabilityUncheckedCreateNestedManyWithoutIntegrationInput = {
  connect?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<VetAvailabilityCreateWithoutIntegrationInput>>;
  createMany?: Maybe<VetAvailabilityCreateManyIntegrationInputEnvelope>;
};

export type VetAvailabilityUncheckedCreateWithoutClinicInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutVetAvailabilityInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutVetAvailabilityInput>;
};

export type VetAvailabilityUncheckedCreateWithoutIntegrationInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutVetAvailabilityInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutVetAvailabilityInput>;
};

export type VetAvailabilityUncheckedCreateWithoutVetAvailabilityClinicRoomMapsInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedCreateNestedManyWithoutVetAvailabilityInput>;
};

export type VetAvailabilityUncheckedCreateWithoutVetAvailabilityMapsInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedCreateNestedManyWithoutVetAvailabilityInput>;
};

export type VetAvailabilityUncheckedUpdateInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutVetAvailabilityNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutVetAvailabilityNestedInput>;
};

export type VetAvailabilityUncheckedUpdateManyInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityUncheckedUpdateManyWithoutClinicInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<VetAvailabilityCreateWithoutClinicInput>>;
  createMany?: Maybe<VetAvailabilityCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<VetAvailabilityUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<VetAvailabilityUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<VetAvailabilityUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type VetAvailabilityUncheckedUpdateManyWithoutIntegrationInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityUncheckedUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<VetAvailabilityCreateWithoutIntegrationInput>>;
  createMany?: Maybe<VetAvailabilityCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<VetAvailabilityUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<VetAvailabilityUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<VetAvailabilityUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type VetAvailabilityUncheckedUpdateWithoutClinicInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutVetAvailabilityNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutVetAvailabilityNestedInput>;
};

export type VetAvailabilityUncheckedUpdateWithoutIntegrationInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutVetAvailabilityNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutVetAvailabilityNestedInput>;
};

export type VetAvailabilityUncheckedUpdateWithoutVetAvailabilityClinicRoomMapsInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUncheckedUpdateManyWithoutVetAvailabilityNestedInput>;
};

export type VetAvailabilityUncheckedUpdateWithoutVetAvailabilityMapsInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUncheckedUpdateManyWithoutVetAvailabilityNestedInput>;
};

export type VetAvailabilityUpdateInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutVetAvailabilitiesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutVetAvailabilitiesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUpdateManyWithoutVetAvailabilityNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutVetAvailabilityNestedInput>;
};

export type VetAvailabilityUpdateManyMutationInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetAvailabilityUpdateManyWithWhereWithoutClinicInput = {
  data: VetAvailabilityUpdateManyMutationInput;
  where: VetAvailabilityScalarWhereInput;
};

export type VetAvailabilityUpdateManyWithWhereWithoutIntegrationInput = {
  data: VetAvailabilityUpdateManyMutationInput;
  where: VetAvailabilityScalarWhereInput;
};

export type VetAvailabilityUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<VetAvailabilityCreateWithoutClinicInput>>;
  createMany?: Maybe<VetAvailabilityCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<VetAvailabilityUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<VetAvailabilityUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<VetAvailabilityUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type VetAvailabilityUpdateManyWithoutIntegrationNestedInput = {
  connect?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetAvailabilityCreateOrConnectWithoutIntegrationInput>>;
  create?: Maybe<Array<VetAvailabilityCreateWithoutIntegrationInput>>;
  createMany?: Maybe<VetAvailabilityCreateManyIntegrationInputEnvelope>;
  delete?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetAvailabilityScalarWhereInput>>;
  disconnect?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  set?: Maybe<Array<VetAvailabilityWhereUniqueInput>>;
  update?: Maybe<Array<VetAvailabilityUpdateWithWhereUniqueWithoutIntegrationInput>>;
  updateMany?: Maybe<Array<VetAvailabilityUpdateManyWithWhereWithoutIntegrationInput>>;
  upsert?: Maybe<Array<VetAvailabilityUpsertWithWhereUniqueWithoutIntegrationInput>>;
};

export type VetAvailabilityUpdateOneRequiredWithoutVetAvailabilityClinicRoomMapsNestedInput = {
  connect?: Maybe<VetAvailabilityWhereUniqueInput>;
  connectOrCreate?: Maybe<VetAvailabilityCreateOrConnectWithoutVetAvailabilityClinicRoomMapsInput>;
  create?: Maybe<VetAvailabilityCreateWithoutVetAvailabilityClinicRoomMapsInput>;
  update?: Maybe<VetAvailabilityUpdateToOneWithWhereWithoutVetAvailabilityClinicRoomMapsInput>;
  upsert?: Maybe<VetAvailabilityUpsertWithoutVetAvailabilityClinicRoomMapsInput>;
};

export type VetAvailabilityUpdateOneRequiredWithoutVetAvailabilityMapsNestedInput = {
  connect?: Maybe<VetAvailabilityWhereUniqueInput>;
  connectOrCreate?: Maybe<VetAvailabilityCreateOrConnectWithoutVetAvailabilityMapsInput>;
  create?: Maybe<VetAvailabilityCreateWithoutVetAvailabilityMapsInput>;
  update?: Maybe<VetAvailabilityUpdateToOneWithWhereWithoutVetAvailabilityMapsInput>;
  upsert?: Maybe<VetAvailabilityUpsertWithoutVetAvailabilityMapsInput>;
};

export type VetAvailabilityUpdateToOneWithWhereWithoutVetAvailabilityClinicRoomMapsInput = {
  data: VetAvailabilityUpdateWithoutVetAvailabilityClinicRoomMapsInput;
  where?: Maybe<VetAvailabilityWhereInput>;
};

export type VetAvailabilityUpdateToOneWithWhereWithoutVetAvailabilityMapsInput = {
  data: VetAvailabilityUpdateWithoutVetAvailabilityMapsInput;
  where?: Maybe<VetAvailabilityWhereInput>;
};

export type VetAvailabilityUpdateWithWhereUniqueWithoutClinicInput = {
  data: VetAvailabilityUpdateWithoutClinicInput;
  where: VetAvailabilityWhereUniqueInput;
};

export type VetAvailabilityUpdateWithWhereUniqueWithoutIntegrationInput = {
  data: VetAvailabilityUpdateWithoutIntegrationInput;
  where: VetAvailabilityWhereUniqueInput;
};

export type VetAvailabilityUpdateWithoutClinicInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutVetAvailabilitiesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUpdateManyWithoutVetAvailabilityNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutVetAvailabilityNestedInput>;
};

export type VetAvailabilityUpdateWithoutIntegrationInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutVetAvailabilitiesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUpdateManyWithoutVetAvailabilityNestedInput>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutVetAvailabilityNestedInput>;
};

export type VetAvailabilityUpdateWithoutVetAvailabilityClinicRoomMapsInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutVetAvailabilitiesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutVetAvailabilitiesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapUpdateManyWithoutVetAvailabilityNestedInput>;
};

export type VetAvailabilityUpdateWithoutVetAvailabilityMapsInput = {
  availabilityPimsType?: Maybe<Scalars['String']>;
  availabilityType?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicUpdateOneRequiredWithoutVetAvailabilitiesNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutVetAvailabilitiesNestedInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  pimsId?: Maybe<Scalars['String']>;
  rawPimsValue?: Maybe<Scalars['Json']>;
  reason?: Maybe<Scalars['String']>;
  recurringRules?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['String']>>;
  siteId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapUpdateManyWithoutVetAvailabilityNestedInput>;
};

export type VetAvailabilityUpdateresourceIdsInput = {
  push?: Maybe<Array<Scalars['String']>>;
  set?: Maybe<Array<Scalars['String']>>;
};

export type VetAvailabilityUpsertWithWhereUniqueWithoutClinicInput = {
  create: VetAvailabilityCreateWithoutClinicInput;
  update: VetAvailabilityUpdateWithoutClinicInput;
  where: VetAvailabilityWhereUniqueInput;
};

export type VetAvailabilityUpsertWithWhereUniqueWithoutIntegrationInput = {
  create: VetAvailabilityCreateWithoutIntegrationInput;
  update: VetAvailabilityUpdateWithoutIntegrationInput;
  where: VetAvailabilityWhereUniqueInput;
};

export type VetAvailabilityUpsertWithoutVetAvailabilityClinicRoomMapsInput = {
  create: VetAvailabilityCreateWithoutVetAvailabilityClinicRoomMapsInput;
  update: VetAvailabilityUpdateWithoutVetAvailabilityClinicRoomMapsInput;
  where?: Maybe<VetAvailabilityWhereInput>;
};

export type VetAvailabilityUpsertWithoutVetAvailabilityMapsInput = {
  create: VetAvailabilityCreateWithoutVetAvailabilityMapsInput;
  update: VetAvailabilityUpdateWithoutVetAvailabilityMapsInput;
  where?: Maybe<VetAvailabilityWhereInput>;
};

export type VetAvailabilityVetAvailabilityPimsIdAndIntegrationIdCompoundUniqueInput = {
  integrationId: Scalars['String'];
  pimsId: Scalars['String'];
};

export type VetAvailabilityWhereInput = {
  AND?: Maybe<Array<VetAvailabilityWhereInput>>;
  NOT?: Maybe<Array<VetAvailabilityWhereInput>>;
  OR?: Maybe<Array<VetAvailabilityWhereInput>>;
  availabilityPimsType?: Maybe<StringNullableFilter>;
  availabilityType?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endDate?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isAvailable?: Maybe<BoolFilter>;
  isRecurring?: Maybe<BoolFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  reason?: Maybe<StringNullableFilter>;
  recurringRules?: Maybe<StringNullableFilter>;
  resourceIds?: Maybe<StringNullableListFilter>;
  siteId?: Maybe<StringNullableFilter>;
  startDate?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapListRelationFilter>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapListRelationFilter>;
};

export type VetAvailabilityWhereUniqueInput = {
  AND?: Maybe<Array<VetAvailabilityWhereInput>>;
  NOT?: Maybe<Array<VetAvailabilityWhereInput>>;
  OR?: Maybe<Array<VetAvailabilityWhereInput>>;
  availabilityPimsType?: Maybe<StringNullableFilter>;
  availabilityType?: Maybe<StringNullableFilter>;
  clinic?: Maybe<ClinicScalarRelationFilter>;
  clinicId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  endDate?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  integration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  integrationId?: Maybe<StringNullableFilter>;
  isActive?: Maybe<BoolFilter>;
  isAvailable?: Maybe<BoolFilter>;
  isRecurring?: Maybe<BoolFilter>;
  pimsId?: Maybe<StringNullableFilter>;
  rawPimsValue?: Maybe<JsonNullableFilter>;
  reason?: Maybe<StringNullableFilter>;
  recurringRules?: Maybe<StringNullableFilter>;
  resourceIds?: Maybe<StringNullableListFilter>;
  siteId?: Maybe<StringNullableFilter>;
  startDate?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetAvailabilityClinicRoomMaps?: Maybe<VetAvailabilityClinicRoomMapListRelationFilter>;
  vetAvailabilityMaps?: Maybe<VetAvailabilityMapListRelationFilter>;
  vetAvailabilityPimsIdAndIntegrationId?: Maybe<VetAvailabilityVetAvailabilityPimsIdAndIntegrationIdCompoundUniqueInput>;
};

export type VetDataIntegration = {
  __typename?: 'VetDataIntegration';
  clinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  createdAt: Scalars['DateTime'];
  defaultProviderId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  installationId: Scalars['String'];
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite: Scalars['Boolean'];
  siteId?: Maybe<Scalars['String']>;
  system: VetDataIntegrationSystem;
  updatedAt: Scalars['DateTime'];
};


export type VetDataIntegrationClinicPimsIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type VetDataIntegrationCountAggregateOutputType = {
  __typename?: 'VetDataIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  defaultProviderId: Scalars['Int'];
  id: Scalars['Int'];
  installationId: Scalars['Int'];
  invoiceCodeId: Scalars['Int'];
  isMultiSite: Scalars['Int'];
  siteId: Scalars['Int'];
  system: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type VetDataIntegrationCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  defaultProviderId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  installationId?: Maybe<SortOrder>;
  invoiceCodeId?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetDataIntegrationCreateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutVetdataInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId: Scalars['String'];
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system: VetDataIntegrationSystem;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId: Scalars['String'];
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system: VetDataIntegrationSystem;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<VetDataIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<VetDataIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<VetDataIntegrationCreateWithoutClinicPimsIntegrationInput>;
};

export type VetDataIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput = {
  create: VetDataIntegrationCreateWithoutClinicPimsIntegrationInput;
  where: VetDataIntegrationWhereUniqueInput;
};

export type VetDataIntegrationCreateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId: Scalars['String'];
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system: VetDataIntegrationSystem;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationGroupByOutputType = {
  __typename?: 'VetDataIntegrationGroupByOutputType';
  _count?: Maybe<VetDataIntegrationCountAggregateOutputType>;
  _max?: Maybe<VetDataIntegrationMaxAggregateOutputType>;
  _min?: Maybe<VetDataIntegrationMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  defaultProviderId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  installationId: Scalars['String'];
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite: Scalars['Boolean'];
  siteId?: Maybe<Scalars['String']>;
  system: VetDataIntegrationSystem;
  updatedAt: Scalars['DateTime'];
};

export type VetDataIntegrationMaxAggregateOutputType = {
  __typename?: 'VetDataIntegrationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId?: Maybe<Scalars['String']>;
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<VetDataIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  defaultProviderId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  installationId?: Maybe<SortOrder>;
  invoiceCodeId?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetDataIntegrationMinAggregateOutputType = {
  __typename?: 'VetDataIntegrationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId?: Maybe<Scalars['String']>;
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<VetDataIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  defaultProviderId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  installationId?: Maybe<SortOrder>;
  invoiceCodeId?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetDataIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<VetDataIntegrationWhereInput>>;
  NOT?: Maybe<Array<VetDataIntegrationWhereInput>>;
  OR?: Maybe<Array<VetDataIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultProviderId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  installationId?: Maybe<StringFilter>;
  invoiceCodeId?: Maybe<StringNullableFilter>;
  isMultiSite?: Maybe<BoolFilter>;
  siteId?: Maybe<StringNullableFilter>;
  system?: Maybe<EnumVetDataIntegrationSystemFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetDataIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetDataIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  defaultProviderId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  installationId?: Maybe<SortOrder>;
  invoiceCodeId?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum VetDataIntegrationOrderByRelevanceFieldEnum {
  DefaultProviderId = 'defaultProviderId',
  Id = 'id',
  InstallationId = 'installationId',
  InvoiceCodeId = 'invoiceCodeId',
  SiteId = 'siteId'
}

export type VetDataIntegrationOrderByRelevanceInput = {
  fields: Array<VetDataIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type VetDataIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<VetDataIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<VetDataIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<VetDataIntegrationMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  defaultProviderId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  installationId?: Maybe<SortOrder>;
  invoiceCodeId?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetDataIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetDataIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  defaultProviderId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  installationId?: Maybe<SortOrder>;
  invoiceCodeId?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetDataIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<VetDataIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  defaultProviderId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  installationId?: Maybe<SortOrder>;
  invoiceCodeId?: Maybe<SortOrder>;
  isMultiSite?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum VetDataIntegrationScalarFieldEnum {
  CreatedAt = 'createdAt',
  DefaultProviderId = 'defaultProviderId',
  Id = 'id',
  InstallationId = 'installationId',
  InvoiceCodeId = 'invoiceCodeId',
  IsMultiSite = 'isMultiSite',
  SiteId = 'siteId',
  System = 'system',
  UpdatedAt = 'updatedAt'
}

export type VetDataIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<VetDataIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<VetDataIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<VetDataIntegrationScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  defaultProviderId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  installationId?: Maybe<StringWithAggregatesFilter>;
  invoiceCodeId?: Maybe<StringNullableWithAggregatesFilter>;
  isMultiSite?: Maybe<BoolWithAggregatesFilter>;
  siteId?: Maybe<StringNullableWithAggregatesFilter>;
  system?: Maybe<EnumVetDataIntegrationSystemWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export enum VetDataIntegrationSystem {
  Advantage = 'ADVANTAGE',
  Avimark = 'AVIMARK',
  Clientrax = 'CLIENTRAX',
  Cornerstone = 'CORNERSTONE',
  DvmaxSql = 'DVMAX_SQL',
  DvmManager = 'DVM_MANAGER',
  Evetpractice = 'EVETPRACTICE',
  HippoManager = 'HIPPO_MANAGER',
  Hvms = 'HVMS',
  Impromed = 'IMPROMED',
  ImpromedTriplecrown = 'IMPROMED_TRIPLECROWN',
  Intravet = 'INTRAVET',
  Stringsoft = 'STRINGSOFT',
  Via = 'VIA',
  Vtp = 'VTP'
}

export type VetDataIntegrationUncheckedCreateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedOneWithoutVetdataInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId: Scalars['String'];
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system: VetDataIntegrationSystem;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationUncheckedCreateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId: Scalars['String'];
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system: VetDataIntegrationSystem;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationUncheckedUpdateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedUpdateOneWithoutVetdataNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId?: Maybe<Scalars['String']>;
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<VetDataIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId?: Maybe<Scalars['String']>;
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<VetDataIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationUncheckedUpdateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId?: Maybe<Scalars['String']>;
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<VetDataIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationUpdateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutVetdataNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId?: Maybe<Scalars['String']>;
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<VetDataIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId?: Maybe<Scalars['String']>;
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<VetDataIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<VetDataIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<VetDataIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<VetDataIntegrationCreateWithoutClinicPimsIntegrationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<VetDataIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput>;
  upsert?: Maybe<VetDataIntegrationUpsertWithoutClinicPimsIntegrationInput>;
};

export type VetDataIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput = {
  data: VetDataIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<VetDataIntegrationWhereInput>;
};

export type VetDataIntegrationUpdateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultProviderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installationId?: Maybe<Scalars['String']>;
  invoiceCodeId?: Maybe<Scalars['String']>;
  isMultiSite?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<VetDataIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetDataIntegrationUpsertWithoutClinicPimsIntegrationInput = {
  create: VetDataIntegrationCreateWithoutClinicPimsIntegrationInput;
  update: VetDataIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<VetDataIntegrationWhereInput>;
};

export type VetDataIntegrationWhereInput = {
  AND?: Maybe<Array<VetDataIntegrationWhereInput>>;
  NOT?: Maybe<Array<VetDataIntegrationWhereInput>>;
  OR?: Maybe<Array<VetDataIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultProviderId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  installationId?: Maybe<StringFilter>;
  invoiceCodeId?: Maybe<StringNullableFilter>;
  isMultiSite?: Maybe<BoolFilter>;
  siteId?: Maybe<StringNullableFilter>;
  system?: Maybe<EnumVetDataIntegrationSystemFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetDataIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<VetDataIntegrationWhereInput>>;
  NOT?: Maybe<Array<VetDataIntegrationWhereInput>>;
  OR?: Maybe<Array<VetDataIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultProviderId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  installationId?: Maybe<StringFilter>;
  invoiceCodeId?: Maybe<StringNullableFilter>;
  isMultiSite?: Maybe<BoolFilter>;
  siteId?: Maybe<StringNullableFilter>;
  system?: Maybe<EnumVetDataIntegrationSystemFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetInfo = {
  __typename?: 'VetInfo';
  _count: VetInfoCountOutputType;
  clinics: Array<Clinic>;
  consultations: Array<Consultation>;
  consultationsId: Array<Consultation>;
  createdAt: Scalars['DateTime'];
  currentClinic?: Maybe<Clinic>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  roles: Array<StaffRole>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  vetLicenses: Array<VetLicense>;
};


export type VetInfoClinicsArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWhereInput>;
};


export type VetInfoConsultationsArgs = {
  cursor?: Maybe<ConsultationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationWhereInput>;
};


export type VetInfoConsultationsIdArgs = {
  cursor?: Maybe<ConsultationWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ConsultationScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ConsultationOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ConsultationWhereInput>;
};


export type VetInfoCurrentClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type VetInfoRolesArgs = {
  cursor?: Maybe<StaffRoleWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<StaffRoleScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<StaffRoleOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<StaffRoleWhereInput>;
};


export type VetInfoUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type VetInfoVetLicensesArgs = {
  cursor?: Maybe<VetLicenseWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetLicenseScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetLicenseOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetLicenseWhereInput>;
};

export type VetInfoCountAggregateOutputType = {
  __typename?: 'VetInfoCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  currentClinicId: Scalars['Int'];
  firebaseId: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type VetInfoCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  currentClinicId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetInfoCountOutputType = {
  __typename?: 'VetInfoCountOutputType';
  clinics: Scalars['Int'];
  consultations: Scalars['Int'];
  consultationsId: Scalars['Int'];
  roles: Scalars['Int'];
  vetLicenses: Scalars['Int'];
};

export type VetInfoCreateInput = {
  clinics?: Maybe<ClinicCreateNestedManyWithoutStaffInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutVetInput>;
  consultationsId?: Maybe<ConsultationCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicCreateNestedOneWithoutStaffIdInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutVetInfoInput>;
  vetLicenses?: Maybe<VetLicenseCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoCreateManyCurrentClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetInfoCreateManyCurrentClinicInputEnvelope = {
  data: Array<VetInfoCreateManyCurrentClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type VetInfoCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetInfoCreateNestedManyWithoutClinicsInput = {
  connect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetInfoCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<VetInfoCreateWithoutClinicsInput>>;
};

export type VetInfoCreateNestedManyWithoutCurrentClinicInput = {
  connect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetInfoCreateOrConnectWithoutCurrentClinicInput>>;
  create?: Maybe<Array<VetInfoCreateWithoutCurrentClinicInput>>;
  createMany?: Maybe<VetInfoCreateManyCurrentClinicInputEnvelope>;
};

export type VetInfoCreateNestedManyWithoutRolesInput = {
  connect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetInfoCreateOrConnectWithoutRolesInput>>;
  create?: Maybe<Array<VetInfoCreateWithoutRolesInput>>;
};

export type VetInfoCreateNestedOneWithoutConsultationsIdInput = {
  connect?: Maybe<VetInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<VetInfoCreateOrConnectWithoutConsultationsIdInput>;
  create?: Maybe<VetInfoCreateWithoutConsultationsIdInput>;
};

export type VetInfoCreateNestedOneWithoutConsultationsInput = {
  connect?: Maybe<VetInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<VetInfoCreateOrConnectWithoutConsultationsInput>;
  create?: Maybe<VetInfoCreateWithoutConsultationsInput>;
};

export type VetInfoCreateNestedOneWithoutUserInput = {
  connect?: Maybe<VetInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<VetInfoCreateOrConnectWithoutUserInput>;
  create?: Maybe<VetInfoCreateWithoutUserInput>;
};

export type VetInfoCreateNestedOneWithoutVetLicensesInput = {
  connect?: Maybe<VetInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<VetInfoCreateOrConnectWithoutVetLicensesInput>;
  create?: Maybe<VetInfoCreateWithoutVetLicensesInput>;
};

export type VetInfoCreateOrConnectWithoutClinicsInput = {
  create: VetInfoCreateWithoutClinicsInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoCreateOrConnectWithoutConsultationsIdInput = {
  create: VetInfoCreateWithoutConsultationsIdInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoCreateOrConnectWithoutConsultationsInput = {
  create: VetInfoCreateWithoutConsultationsInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoCreateOrConnectWithoutCurrentClinicInput = {
  create: VetInfoCreateWithoutCurrentClinicInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoCreateOrConnectWithoutRolesInput = {
  create: VetInfoCreateWithoutRolesInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoCreateOrConnectWithoutUserInput = {
  create: VetInfoCreateWithoutUserInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoCreateOrConnectWithoutVetLicensesInput = {
  create: VetInfoCreateWithoutVetLicensesInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoCreateWithoutClinicsInput = {
  consultations?: Maybe<ConsultationCreateNestedManyWithoutVetInput>;
  consultationsId?: Maybe<ConsultationCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicCreateNestedOneWithoutStaffIdInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutVetInfoInput>;
  vetLicenses?: Maybe<VetLicenseCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoCreateWithoutConsultationsIdInput = {
  clinics?: Maybe<ClinicCreateNestedManyWithoutStaffInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutVetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicCreateNestedOneWithoutStaffIdInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutVetInfoInput>;
  vetLicenses?: Maybe<VetLicenseCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoCreateWithoutConsultationsInput = {
  clinics?: Maybe<ClinicCreateNestedManyWithoutStaffInput>;
  consultationsId?: Maybe<ConsultationCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicCreateNestedOneWithoutStaffIdInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutVetInfoInput>;
  vetLicenses?: Maybe<VetLicenseCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoCreateWithoutCurrentClinicInput = {
  clinics?: Maybe<ClinicCreateNestedManyWithoutStaffInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutVetInput>;
  consultationsId?: Maybe<ConsultationCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutVetInfoInput>;
  vetLicenses?: Maybe<VetLicenseCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoCreateWithoutRolesInput = {
  clinics?: Maybe<ClinicCreateNestedManyWithoutStaffInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutVetInput>;
  consultationsId?: Maybe<ConsultationCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicCreateNestedOneWithoutStaffIdInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutVetInfoInput>;
  vetLicenses?: Maybe<VetLicenseCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoCreateWithoutUserInput = {
  clinics?: Maybe<ClinicCreateNestedManyWithoutStaffInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutVetInput>;
  consultationsId?: Maybe<ConsultationCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicCreateNestedOneWithoutStaffIdInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetLicenses?: Maybe<VetLicenseCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoCreateWithoutVetLicensesInput = {
  clinics?: Maybe<ClinicCreateNestedManyWithoutStaffInput>;
  consultations?: Maybe<ConsultationCreateNestedManyWithoutVetInput>;
  consultationsId?: Maybe<ConsultationCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicCreateNestedOneWithoutStaffIdInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateNestedOneWithoutVetInfoInput>;
};

export type VetInfoGroupByOutputType = {
  __typename?: 'VetInfoGroupByOutputType';
  _count?: Maybe<VetInfoCountAggregateOutputType>;
  _max?: Maybe<VetInfoMaxAggregateOutputType>;
  _min?: Maybe<VetInfoMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type VetInfoListRelationFilter = {
  every?: Maybe<VetInfoWhereInput>;
  none?: Maybe<VetInfoWhereInput>;
  some?: Maybe<VetInfoWhereInput>;
};

export type VetInfoMaxAggregateOutputType = {
  __typename?: 'VetInfoMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetInfoMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  currentClinicId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetInfoMinAggregateOutputType = {
  __typename?: 'VetInfoMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetInfoMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  currentClinicId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetInfoNullableScalarRelationFilter = {
  AND?: Maybe<Array<VetInfoWhereInput>>;
  NOT?: Maybe<Array<VetInfoWhereInput>>;
  OR?: Maybe<Array<VetInfoWhereInput>>;
  clinics?: Maybe<ClinicListRelationFilter>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  consultationsId?: Maybe<ConsultationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  currentClinicId?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  roles?: Maybe<StaffRoleListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  vetLicenses?: Maybe<VetLicenseListRelationFilter>;
};

export type VetInfoOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type VetInfoOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetInfoOrderByRelevanceInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  consultations?: Maybe<ConsultationOrderByRelationAggregateInput>;
  consultationsId?: Maybe<ConsultationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  currentClinic?: Maybe<ClinicOrderByWithRelationInput>;
  currentClinicId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  roles?: Maybe<StaffRoleOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  vetLicenses?: Maybe<VetLicenseOrderByRelationAggregateInput>;
};

export enum VetInfoOrderByRelevanceFieldEnum {
  CurrentClinicId = 'currentClinicId',
  FirebaseId = 'firebaseId',
  Id = 'id'
}

export type VetInfoOrderByRelevanceInput = {
  fields: Array<VetInfoOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type VetInfoOrderByWithAggregationInput = {
  _count?: Maybe<VetInfoCountOrderByAggregateInput>;
  _max?: Maybe<VetInfoMaxOrderByAggregateInput>;
  _min?: Maybe<VetInfoMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  currentClinicId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetInfoOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetInfoOrderByRelevanceInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  consultations?: Maybe<ConsultationOrderByRelationAggregateInput>;
  consultationsId?: Maybe<ConsultationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  currentClinic?: Maybe<ClinicOrderByWithRelationInput>;
  currentClinicId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  roles?: Maybe<StaffRoleOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  vetLicenses?: Maybe<VetLicenseOrderByRelationAggregateInput>;
};

export type VetInfoOrderByWithRelationInput = {
  _relevance?: Maybe<VetInfoOrderByRelevanceInput>;
  clinics?: Maybe<ClinicOrderByRelationAggregateInput>;
  consultations?: Maybe<ConsultationOrderByRelationAggregateInput>;
  consultationsId?: Maybe<ConsultationOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  currentClinic?: Maybe<ClinicOrderByWithRelationInput>;
  currentClinicId?: Maybe<SortOrder>;
  firebaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  roles?: Maybe<StaffRoleOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  vetLicenses?: Maybe<VetLicenseOrderByRelationAggregateInput>;
};

export enum VetInfoScalarFieldEnum {
  CreatedAt = 'createdAt',
  CurrentClinicId = 'currentClinicId',
  FirebaseId = 'firebaseId',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type VetInfoScalarWhereInput = {
  AND?: Maybe<Array<VetInfoScalarWhereInput>>;
  NOT?: Maybe<Array<VetInfoScalarWhereInput>>;
  OR?: Maybe<Array<VetInfoScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  currentClinicId?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetInfoScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<VetInfoScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<VetInfoScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<VetInfoScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  currentClinicId?: Maybe<StringNullableWithAggregatesFilter>;
  firebaseId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type VetInfoUncheckedCreateInput = {
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutStaffInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutVetInput>;
  consultationsId?: Maybe<ConsultationUncheckedCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedOneWithoutVetInfoInput>;
  vetLicenses?: Maybe<VetLicenseUncheckedCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoUncheckedCreateNestedManyWithoutClinicsInput = {
  connect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetInfoCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<VetInfoCreateWithoutClinicsInput>>;
};

export type VetInfoUncheckedCreateNestedManyWithoutCurrentClinicInput = {
  connect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetInfoCreateOrConnectWithoutCurrentClinicInput>>;
  create?: Maybe<Array<VetInfoCreateWithoutCurrentClinicInput>>;
  createMany?: Maybe<VetInfoCreateManyCurrentClinicInputEnvelope>;
};

export type VetInfoUncheckedCreateNestedManyWithoutRolesInput = {
  connect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetInfoCreateOrConnectWithoutRolesInput>>;
  create?: Maybe<Array<VetInfoCreateWithoutRolesInput>>;
};

export type VetInfoUncheckedCreateWithoutClinicsInput = {
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutVetInput>;
  consultationsId?: Maybe<ConsultationUncheckedCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedOneWithoutVetInfoInput>;
  vetLicenses?: Maybe<VetLicenseUncheckedCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoUncheckedCreateWithoutConsultationsIdInput = {
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutStaffInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutVetInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedOneWithoutVetInfoInput>;
  vetLicenses?: Maybe<VetLicenseUncheckedCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoUncheckedCreateWithoutConsultationsInput = {
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutStaffInput>;
  consultationsId?: Maybe<ConsultationUncheckedCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedOneWithoutVetInfoInput>;
  vetLicenses?: Maybe<VetLicenseUncheckedCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoUncheckedCreateWithoutCurrentClinicInput = {
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutStaffInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutVetInput>;
  consultationsId?: Maybe<ConsultationUncheckedCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedOneWithoutVetInfoInput>;
  vetLicenses?: Maybe<VetLicenseUncheckedCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoUncheckedCreateWithoutRolesInput = {
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutStaffInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutVetInput>;
  consultationsId?: Maybe<ConsultationUncheckedCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedOneWithoutVetInfoInput>;
  vetLicenses?: Maybe<VetLicenseUncheckedCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoUncheckedCreateWithoutUserInput = {
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutStaffInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutVetInput>;
  consultationsId?: Maybe<ConsultationUncheckedCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicCreateNestedOneWithoutStaffIdInput>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetLicenses?: Maybe<VetLicenseUncheckedCreateNestedManyWithoutVetInfoInput>;
};

export type VetInfoUncheckedCreateWithoutVetLicensesInput = {
  clinics?: Maybe<ClinicUncheckedCreateNestedManyWithoutStaffInput>;
  consultations?: Maybe<ConsultationUncheckedCreateNestedManyWithoutVetInput>;
  consultationsId?: Maybe<ConsultationUncheckedCreateNestedManyWithoutNurseInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedCreateNestedManyWithoutUsersInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedCreateNestedOneWithoutVetInfoInput>;
};

export type VetInfoUncheckedUpdateInput = {
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutStaffNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutVetNestedInput>;
  consultationsId?: Maybe<ConsultationUncheckedUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateOneWithoutVetInfoNestedInput>;
  vetLicenses?: Maybe<VetLicenseUncheckedUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetInfoUncheckedUpdateManyWithoutClinicsInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetInfoUncheckedUpdateManyWithoutClinicsNestedInput = {
  connect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetInfoCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<VetInfoCreateWithoutClinicsInput>>;
  delete?: Maybe<Array<VetInfoWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetInfoScalarWhereInput>>;
  disconnect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  set?: Maybe<Array<VetInfoWhereUniqueInput>>;
  update?: Maybe<Array<VetInfoUpdateWithWhereUniqueWithoutClinicsInput>>;
  updateMany?: Maybe<Array<VetInfoUpdateManyWithWhereWithoutClinicsInput>>;
  upsert?: Maybe<Array<VetInfoUpsertWithWhereUniqueWithoutClinicsInput>>;
};

export type VetInfoUncheckedUpdateManyWithoutCurrentClinicInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetInfoUncheckedUpdateManyWithoutCurrentClinicNestedInput = {
  connect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetInfoCreateOrConnectWithoutCurrentClinicInput>>;
  create?: Maybe<Array<VetInfoCreateWithoutCurrentClinicInput>>;
  createMany?: Maybe<VetInfoCreateManyCurrentClinicInputEnvelope>;
  delete?: Maybe<Array<VetInfoWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetInfoScalarWhereInput>>;
  disconnect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  set?: Maybe<Array<VetInfoWhereUniqueInput>>;
  update?: Maybe<Array<VetInfoUpdateWithWhereUniqueWithoutCurrentClinicInput>>;
  updateMany?: Maybe<Array<VetInfoUpdateManyWithWhereWithoutCurrentClinicInput>>;
  upsert?: Maybe<Array<VetInfoUpsertWithWhereUniqueWithoutCurrentClinicInput>>;
};

export type VetInfoUncheckedUpdateManyWithoutRolesInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetInfoUncheckedUpdateManyWithoutRolesNestedInput = {
  connect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetInfoCreateOrConnectWithoutRolesInput>>;
  create?: Maybe<Array<VetInfoCreateWithoutRolesInput>>;
  delete?: Maybe<Array<VetInfoWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetInfoScalarWhereInput>>;
  disconnect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  set?: Maybe<Array<VetInfoWhereUniqueInput>>;
  update?: Maybe<Array<VetInfoUpdateWithWhereUniqueWithoutRolesInput>>;
  updateMany?: Maybe<Array<VetInfoUpdateManyWithWhereWithoutRolesInput>>;
  upsert?: Maybe<Array<VetInfoUpsertWithWhereUniqueWithoutRolesInput>>;
};

export type VetInfoUncheckedUpdateWithoutClinicsInput = {
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutVetNestedInput>;
  consultationsId?: Maybe<ConsultationUncheckedUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateOneWithoutVetInfoNestedInput>;
  vetLicenses?: Maybe<VetLicenseUncheckedUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUncheckedUpdateWithoutConsultationsIdInput = {
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutStaffNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutVetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateOneWithoutVetInfoNestedInput>;
  vetLicenses?: Maybe<VetLicenseUncheckedUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUncheckedUpdateWithoutConsultationsInput = {
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutStaffNestedInput>;
  consultationsId?: Maybe<ConsultationUncheckedUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateOneWithoutVetInfoNestedInput>;
  vetLicenses?: Maybe<VetLicenseUncheckedUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUncheckedUpdateWithoutCurrentClinicInput = {
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutStaffNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutVetNestedInput>;
  consultationsId?: Maybe<ConsultationUncheckedUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateOneWithoutVetInfoNestedInput>;
  vetLicenses?: Maybe<VetLicenseUncheckedUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUncheckedUpdateWithoutRolesInput = {
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutStaffNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutVetNestedInput>;
  consultationsId?: Maybe<ConsultationUncheckedUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateOneWithoutVetInfoNestedInput>;
  vetLicenses?: Maybe<VetLicenseUncheckedUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUncheckedUpdateWithoutUserInput = {
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutStaffNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutVetNestedInput>;
  consultationsId?: Maybe<ConsultationUncheckedUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicUpdateWithoutStaffIdInput>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetLicenses?: Maybe<VetLicenseUncheckedUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUncheckedUpdateWithoutVetLicensesInput = {
  clinics?: Maybe<ClinicUncheckedUpdateManyWithoutStaffNestedInput>;
  consultations?: Maybe<ConsultationUncheckedUpdateManyWithoutVetNestedInput>;
  consultationsId?: Maybe<ConsultationUncheckedUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinicId?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUncheckedUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUncheckedUpdateOneWithoutVetInfoNestedInput>;
};

export type VetInfoUpdateInput = {
  clinics?: Maybe<ClinicUpdateManyWithoutStaffNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutVetNestedInput>;
  consultationsId?: Maybe<ConsultationUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicUpdateOneWithoutStaffIdNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutVetInfoNestedInput>;
  vetLicenses?: Maybe<VetLicenseUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetInfoUpdateManyWithWhereWithoutClinicsInput = {
  data: VetInfoUpdateManyMutationInput;
  where: VetInfoScalarWhereInput;
};

export type VetInfoUpdateManyWithWhereWithoutCurrentClinicInput = {
  data: VetInfoUpdateManyMutationInput;
  where: VetInfoScalarWhereInput;
};

export type VetInfoUpdateManyWithWhereWithoutRolesInput = {
  data: VetInfoUpdateManyMutationInput;
  where: VetInfoScalarWhereInput;
};

export type VetInfoUpdateManyWithoutClinicsNestedInput = {
  connect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetInfoCreateOrConnectWithoutClinicsInput>>;
  create?: Maybe<Array<VetInfoCreateWithoutClinicsInput>>;
  delete?: Maybe<Array<VetInfoWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetInfoScalarWhereInput>>;
  disconnect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  set?: Maybe<Array<VetInfoWhereUniqueInput>>;
  update?: Maybe<Array<VetInfoUpdateWithWhereUniqueWithoutClinicsInput>>;
  updateMany?: Maybe<Array<VetInfoUpdateManyWithWhereWithoutClinicsInput>>;
  upsert?: Maybe<Array<VetInfoUpsertWithWhereUniqueWithoutClinicsInput>>;
};

export type VetInfoUpdateManyWithoutCurrentClinicNestedInput = {
  connect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetInfoCreateOrConnectWithoutCurrentClinicInput>>;
  create?: Maybe<Array<VetInfoCreateWithoutCurrentClinicInput>>;
  createMany?: Maybe<VetInfoCreateManyCurrentClinicInputEnvelope>;
  delete?: Maybe<Array<VetInfoWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetInfoScalarWhereInput>>;
  disconnect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  set?: Maybe<Array<VetInfoWhereUniqueInput>>;
  update?: Maybe<Array<VetInfoUpdateWithWhereUniqueWithoutCurrentClinicInput>>;
  updateMany?: Maybe<Array<VetInfoUpdateManyWithWhereWithoutCurrentClinicInput>>;
  upsert?: Maybe<Array<VetInfoUpsertWithWhereUniqueWithoutCurrentClinicInput>>;
};

export type VetInfoUpdateManyWithoutRolesNestedInput = {
  connect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetInfoCreateOrConnectWithoutRolesInput>>;
  create?: Maybe<Array<VetInfoCreateWithoutRolesInput>>;
  delete?: Maybe<Array<VetInfoWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetInfoScalarWhereInput>>;
  disconnect?: Maybe<Array<VetInfoWhereUniqueInput>>;
  set?: Maybe<Array<VetInfoWhereUniqueInput>>;
  update?: Maybe<Array<VetInfoUpdateWithWhereUniqueWithoutRolesInput>>;
  updateMany?: Maybe<Array<VetInfoUpdateManyWithWhereWithoutRolesInput>>;
  upsert?: Maybe<Array<VetInfoUpsertWithWhereUniqueWithoutRolesInput>>;
};

export type VetInfoUpdateOneWithoutConsultationsIdNestedInput = {
  connect?: Maybe<VetInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<VetInfoCreateOrConnectWithoutConsultationsIdInput>;
  create?: Maybe<VetInfoCreateWithoutConsultationsIdInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<VetInfoUpdateToOneWithWhereWithoutConsultationsIdInput>;
  upsert?: Maybe<VetInfoUpsertWithoutConsultationsIdInput>;
};

export type VetInfoUpdateOneWithoutConsultationsNestedInput = {
  connect?: Maybe<VetInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<VetInfoCreateOrConnectWithoutConsultationsInput>;
  create?: Maybe<VetInfoCreateWithoutConsultationsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<VetInfoUpdateToOneWithWhereWithoutConsultationsInput>;
  upsert?: Maybe<VetInfoUpsertWithoutConsultationsInput>;
};

export type VetInfoUpdateOneWithoutUserNestedInput = {
  connect?: Maybe<VetInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<VetInfoCreateOrConnectWithoutUserInput>;
  create?: Maybe<VetInfoCreateWithoutUserInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<VetInfoUpdateToOneWithWhereWithoutUserInput>;
  upsert?: Maybe<VetInfoUpsertWithoutUserInput>;
};

export type VetInfoUpdateOneWithoutVetLicensesNestedInput = {
  connect?: Maybe<VetInfoWhereUniqueInput>;
  connectOrCreate?: Maybe<VetInfoCreateOrConnectWithoutVetLicensesInput>;
  create?: Maybe<VetInfoCreateWithoutVetLicensesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<VetInfoUpdateToOneWithWhereWithoutVetLicensesInput>;
  upsert?: Maybe<VetInfoUpsertWithoutVetLicensesInput>;
};

export type VetInfoUpdateToOneWithWhereWithoutConsultationsIdInput = {
  data: VetInfoUpdateWithoutConsultationsIdInput;
  where?: Maybe<VetInfoWhereInput>;
};

export type VetInfoUpdateToOneWithWhereWithoutConsultationsInput = {
  data: VetInfoUpdateWithoutConsultationsInput;
  where?: Maybe<VetInfoWhereInput>;
};

export type VetInfoUpdateToOneWithWhereWithoutUserInput = {
  data: VetInfoUpdateWithoutUserInput;
  where?: Maybe<VetInfoWhereInput>;
};

export type VetInfoUpdateToOneWithWhereWithoutVetLicensesInput = {
  data: VetInfoUpdateWithoutVetLicensesInput;
  where?: Maybe<VetInfoWhereInput>;
};

export type VetInfoUpdateWithWhereUniqueWithoutClinicsInput = {
  data: VetInfoUpdateWithoutClinicsInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoUpdateWithWhereUniqueWithoutCurrentClinicInput = {
  data: VetInfoUpdateWithoutCurrentClinicInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoUpdateWithWhereUniqueWithoutRolesInput = {
  data: VetInfoUpdateWithoutRolesInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoUpdateWithoutClinicsInput = {
  consultations?: Maybe<ConsultationUpdateManyWithoutVetNestedInput>;
  consultationsId?: Maybe<ConsultationUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicUpdateOneWithoutStaffIdNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutVetInfoNestedInput>;
  vetLicenses?: Maybe<VetLicenseUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUpdateWithoutConsultationsIdInput = {
  clinics?: Maybe<ClinicUpdateManyWithoutStaffNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutVetNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicUpdateOneWithoutStaffIdNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutVetInfoNestedInput>;
  vetLicenses?: Maybe<VetLicenseUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUpdateWithoutConsultationsInput = {
  clinics?: Maybe<ClinicUpdateManyWithoutStaffNestedInput>;
  consultationsId?: Maybe<ConsultationUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicUpdateOneWithoutStaffIdNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutVetInfoNestedInput>;
  vetLicenses?: Maybe<VetLicenseUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUpdateWithoutCurrentClinicInput = {
  clinics?: Maybe<ClinicUpdateManyWithoutStaffNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutVetNestedInput>;
  consultationsId?: Maybe<ConsultationUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutVetInfoNestedInput>;
  vetLicenses?: Maybe<VetLicenseUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUpdateWithoutRolesInput = {
  clinics?: Maybe<ClinicUpdateManyWithoutStaffNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutVetNestedInput>;
  consultationsId?: Maybe<ConsultationUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicUpdateOneWithoutStaffIdNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutVetInfoNestedInput>;
  vetLicenses?: Maybe<VetLicenseUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUpdateWithoutUserInput = {
  clinics?: Maybe<ClinicUpdateManyWithoutStaffNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutVetNestedInput>;
  consultationsId?: Maybe<ConsultationUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicUpdateOneWithoutStaffIdNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetLicenses?: Maybe<VetLicenseUpdateManyWithoutVetInfoNestedInput>;
};

export type VetInfoUpdateWithoutVetLicensesInput = {
  clinics?: Maybe<ClinicUpdateManyWithoutStaffNestedInput>;
  consultations?: Maybe<ConsultationUpdateManyWithoutVetNestedInput>;
  consultationsId?: Maybe<ConsultationUpdateManyWithoutNurseNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentClinic?: Maybe<ClinicUpdateOneWithoutStaffIdNestedInput>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleUpdateManyWithoutUsersNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutVetInfoNestedInput>;
};

export type VetInfoUpsertWithWhereUniqueWithoutClinicsInput = {
  create: VetInfoCreateWithoutClinicsInput;
  update: VetInfoUpdateWithoutClinicsInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoUpsertWithWhereUniqueWithoutCurrentClinicInput = {
  create: VetInfoCreateWithoutCurrentClinicInput;
  update: VetInfoUpdateWithoutCurrentClinicInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoUpsertWithWhereUniqueWithoutRolesInput = {
  create: VetInfoCreateWithoutRolesInput;
  update: VetInfoUpdateWithoutRolesInput;
  where: VetInfoWhereUniqueInput;
};

export type VetInfoUpsertWithoutConsultationsIdInput = {
  create: VetInfoCreateWithoutConsultationsIdInput;
  update: VetInfoUpdateWithoutConsultationsIdInput;
  where?: Maybe<VetInfoWhereInput>;
};

export type VetInfoUpsertWithoutConsultationsInput = {
  create: VetInfoCreateWithoutConsultationsInput;
  update: VetInfoUpdateWithoutConsultationsInput;
  where?: Maybe<VetInfoWhereInput>;
};

export type VetInfoUpsertWithoutUserInput = {
  create: VetInfoCreateWithoutUserInput;
  update: VetInfoUpdateWithoutUserInput;
  where?: Maybe<VetInfoWhereInput>;
};

export type VetInfoUpsertWithoutVetLicensesInput = {
  create: VetInfoCreateWithoutVetLicensesInput;
  update: VetInfoUpdateWithoutVetLicensesInput;
  where?: Maybe<VetInfoWhereInput>;
};

export type VetInfoWhereInput = {
  AND?: Maybe<Array<VetInfoWhereInput>>;
  NOT?: Maybe<Array<VetInfoWhereInput>>;
  OR?: Maybe<Array<VetInfoWhereInput>>;
  clinics?: Maybe<ClinicListRelationFilter>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  consultationsId?: Maybe<ConsultationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  currentClinicId?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  roles?: Maybe<StaffRoleListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  vetLicenses?: Maybe<VetLicenseListRelationFilter>;
};

export type VetInfoWhereUniqueInput = {
  AND?: Maybe<Array<VetInfoWhereInput>>;
  NOT?: Maybe<Array<VetInfoWhereInput>>;
  OR?: Maybe<Array<VetInfoWhereInput>>;
  clinics?: Maybe<ClinicListRelationFilter>;
  consultations?: Maybe<ConsultationListRelationFilter>;
  consultationsId?: Maybe<ConsultationListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  currentClinic?: Maybe<ClinicNullableScalarRelationFilter>;
  currentClinicId?: Maybe<StringNullableFilter>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roles?: Maybe<StaffRoleListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user?: Maybe<UserNullableScalarRelationFilter>;
  vetLicenses?: Maybe<VetLicenseListRelationFilter>;
};

export type VetLicense = {
  __typename?: 'VetLicense';
  createdAt: Scalars['DateTime'];
  expirationDate: Scalars['DateTime'];
  id: Scalars['String'];
  issuingAuthority: State;
  licenseNumber: Scalars['String'];
  licenseType: VetLicenseType;
  updatedAt: Scalars['DateTime'];
  vetInfo?: Maybe<VetInfo>;
  vetInfoId?: Maybe<Scalars['String']>;
};


export type VetLicenseVetInfoArgs = {
  where?: Maybe<VetInfoWhereInput>;
};

export type VetLicenseCountAggregateOutputType = {
  __typename?: 'VetLicenseCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  expirationDate: Scalars['Int'];
  id: Scalars['Int'];
  issuingAuthority: Scalars['Int'];
  licenseNumber: Scalars['Int'];
  licenseType: Scalars['Int'];
  updatedAt: Scalars['Int'];
  vetInfoId: Scalars['Int'];
};

export type VetLicenseCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuingAuthority?: Maybe<SortOrder>;
  licenseNumber?: Maybe<SortOrder>;
  licenseType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetInfoId?: Maybe<SortOrder>;
};

export type VetLicenseCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  issuingAuthority: State;
  licenseNumber: Scalars['String'];
  licenseType: VetLicenseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetInfo?: Maybe<VetInfoCreateNestedOneWithoutVetLicensesInput>;
};

export type VetLicenseCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  issuingAuthority: State;
  licenseNumber: Scalars['String'];
  licenseType: VetLicenseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type VetLicenseCreateManyVetInfoInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  issuingAuthority: State;
  licenseNumber: Scalars['String'];
  licenseType: VetLicenseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetLicenseCreateManyVetInfoInputEnvelope = {
  data: Array<VetLicenseCreateManyVetInfoInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type VetLicenseCreateNestedManyWithoutVetInfoInput = {
  connect?: Maybe<Array<VetLicenseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetLicenseCreateOrConnectWithoutVetInfoInput>>;
  create?: Maybe<Array<VetLicenseCreateWithoutVetInfoInput>>;
  createMany?: Maybe<VetLicenseCreateManyVetInfoInputEnvelope>;
};

export type VetLicenseCreateOrConnectWithoutVetInfoInput = {
  create: VetLicenseCreateWithoutVetInfoInput;
  where: VetLicenseWhereUniqueInput;
};

export type VetLicenseCreateWithoutVetInfoInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  issuingAuthority: State;
  licenseNumber: Scalars['String'];
  licenseType: VetLicenseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetLicenseGroupByOutputType = {
  __typename?: 'VetLicenseGroupByOutputType';
  _count?: Maybe<VetLicenseCountAggregateOutputType>;
  _max?: Maybe<VetLicenseMaxAggregateOutputType>;
  _min?: Maybe<VetLicenseMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  expirationDate: Scalars['DateTime'];
  id: Scalars['String'];
  issuingAuthority: State;
  licenseNumber: Scalars['String'];
  licenseType: VetLicenseType;
  updatedAt: Scalars['DateTime'];
  vetInfoId?: Maybe<Scalars['String']>;
};

export type VetLicenseListRelationFilter = {
  every?: Maybe<VetLicenseWhereInput>;
  none?: Maybe<VetLicenseWhereInput>;
  some?: Maybe<VetLicenseWhereInput>;
};

export type VetLicenseMaxAggregateOutputType = {
  __typename?: 'VetLicenseMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuingAuthority?: Maybe<State>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseType?: Maybe<VetLicenseType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type VetLicenseMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuingAuthority?: Maybe<SortOrder>;
  licenseNumber?: Maybe<SortOrder>;
  licenseType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetInfoId?: Maybe<SortOrder>;
};

export type VetLicenseMinAggregateOutputType = {
  __typename?: 'VetLicenseMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuingAuthority?: Maybe<State>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseType?: Maybe<VetLicenseType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type VetLicenseMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuingAuthority?: Maybe<SortOrder>;
  licenseNumber?: Maybe<SortOrder>;
  licenseType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetInfoId?: Maybe<SortOrder>;
};

export type VetLicenseOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type VetLicenseOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetLicenseOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuingAuthority?: Maybe<SortOrder>;
  licenseNumber?: Maybe<SortOrder>;
  licenseType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetInfo?: Maybe<VetInfoOrderByWithRelationInput>;
  vetInfoId?: Maybe<SortOrder>;
};

export enum VetLicenseOrderByRelevanceFieldEnum {
  Id = 'id',
  LicenseNumber = 'licenseNumber',
  VetInfoId = 'vetInfoId'
}

export type VetLicenseOrderByRelevanceInput = {
  fields: Array<VetLicenseOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type VetLicenseOrderByWithAggregationInput = {
  _count?: Maybe<VetLicenseCountOrderByAggregateInput>;
  _max?: Maybe<VetLicenseMaxOrderByAggregateInput>;
  _min?: Maybe<VetLicenseMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuingAuthority?: Maybe<SortOrder>;
  licenseNumber?: Maybe<SortOrder>;
  licenseType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetInfoId?: Maybe<SortOrder>;
};

export type VetLicenseOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetLicenseOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuingAuthority?: Maybe<SortOrder>;
  licenseNumber?: Maybe<SortOrder>;
  licenseType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetInfo?: Maybe<VetInfoOrderByWithRelationInput>;
  vetInfoId?: Maybe<SortOrder>;
};

export type VetLicenseOrderByWithRelationInput = {
  _relevance?: Maybe<VetLicenseOrderByRelevanceInput>;
  createdAt?: Maybe<SortOrder>;
  expirationDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  issuingAuthority?: Maybe<SortOrder>;
  licenseNumber?: Maybe<SortOrder>;
  licenseType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetInfo?: Maybe<VetInfoOrderByWithRelationInput>;
  vetInfoId?: Maybe<SortOrder>;
};

export enum VetLicenseScalarFieldEnum {
  CreatedAt = 'createdAt',
  ExpirationDate = 'expirationDate',
  Id = 'id',
  IssuingAuthority = 'issuingAuthority',
  LicenseNumber = 'licenseNumber',
  LicenseType = 'licenseType',
  UpdatedAt = 'updatedAt',
  VetInfoId = 'vetInfoId'
}

export type VetLicenseScalarWhereInput = {
  AND?: Maybe<Array<VetLicenseScalarWhereInput>>;
  NOT?: Maybe<Array<VetLicenseScalarWhereInput>>;
  OR?: Maybe<Array<VetLicenseScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  expirationDate?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  issuingAuthority?: Maybe<EnumStateFilter>;
  licenseNumber?: Maybe<StringFilter>;
  licenseType?: Maybe<EnumVetLicenseTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetInfoId?: Maybe<StringNullableFilter>;
};

export type VetLicenseScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<VetLicenseScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<VetLicenseScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<VetLicenseScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  expirationDate?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  issuingAuthority?: Maybe<EnumStateWithAggregatesFilter>;
  licenseNumber?: Maybe<StringWithAggregatesFilter>;
  licenseType?: Maybe<EnumVetLicenseTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  vetInfoId?: Maybe<StringNullableWithAggregatesFilter>;
};

export enum VetLicenseType {
  Dea = 'DEA',
  Technician = 'Technician',
  Veterinary = 'Veterinary'
}

export type VetLicenseUncheckedCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  issuingAuthority: State;
  licenseNumber: Scalars['String'];
  licenseType: VetLicenseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type VetLicenseUncheckedCreateNestedManyWithoutVetInfoInput = {
  connect?: Maybe<Array<VetLicenseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetLicenseCreateOrConnectWithoutVetInfoInput>>;
  create?: Maybe<Array<VetLicenseCreateWithoutVetInfoInput>>;
  createMany?: Maybe<VetLicenseCreateManyVetInfoInputEnvelope>;
};

export type VetLicenseUncheckedCreateWithoutVetInfoInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  issuingAuthority: State;
  licenseNumber: Scalars['String'];
  licenseType: VetLicenseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetLicenseUncheckedUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuingAuthority?: Maybe<State>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseType?: Maybe<VetLicenseType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type VetLicenseUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuingAuthority?: Maybe<State>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseType?: Maybe<VetLicenseType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetInfoId?: Maybe<Scalars['String']>;
};

export type VetLicenseUncheckedUpdateManyWithoutVetInfoInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuingAuthority?: Maybe<State>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseType?: Maybe<VetLicenseType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetLicenseUncheckedUpdateManyWithoutVetInfoNestedInput = {
  connect?: Maybe<Array<VetLicenseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetLicenseCreateOrConnectWithoutVetInfoInput>>;
  create?: Maybe<Array<VetLicenseCreateWithoutVetInfoInput>>;
  createMany?: Maybe<VetLicenseCreateManyVetInfoInputEnvelope>;
  delete?: Maybe<Array<VetLicenseWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetLicenseScalarWhereInput>>;
  disconnect?: Maybe<Array<VetLicenseWhereUniqueInput>>;
  set?: Maybe<Array<VetLicenseWhereUniqueInput>>;
  update?: Maybe<Array<VetLicenseUpdateWithWhereUniqueWithoutVetInfoInput>>;
  updateMany?: Maybe<Array<VetLicenseUpdateManyWithWhereWithoutVetInfoInput>>;
  upsert?: Maybe<Array<VetLicenseUpsertWithWhereUniqueWithoutVetInfoInput>>;
};

export type VetLicenseUncheckedUpdateWithoutVetInfoInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuingAuthority?: Maybe<State>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseType?: Maybe<VetLicenseType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetLicenseUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuingAuthority?: Maybe<State>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseType?: Maybe<VetLicenseType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetInfo?: Maybe<VetInfoUpdateOneWithoutVetLicensesNestedInput>;
};

export type VetLicenseUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuingAuthority?: Maybe<State>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseType?: Maybe<VetLicenseType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetLicenseUpdateManyWithWhereWithoutVetInfoInput = {
  data: VetLicenseUpdateManyMutationInput;
  where: VetLicenseScalarWhereInput;
};

export type VetLicenseUpdateManyWithoutVetInfoNestedInput = {
  connect?: Maybe<Array<VetLicenseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetLicenseCreateOrConnectWithoutVetInfoInput>>;
  create?: Maybe<Array<VetLicenseCreateWithoutVetInfoInput>>;
  createMany?: Maybe<VetLicenseCreateManyVetInfoInputEnvelope>;
  delete?: Maybe<Array<VetLicenseWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetLicenseScalarWhereInput>>;
  disconnect?: Maybe<Array<VetLicenseWhereUniqueInput>>;
  set?: Maybe<Array<VetLicenseWhereUniqueInput>>;
  update?: Maybe<Array<VetLicenseUpdateWithWhereUniqueWithoutVetInfoInput>>;
  updateMany?: Maybe<Array<VetLicenseUpdateManyWithWhereWithoutVetInfoInput>>;
  upsert?: Maybe<Array<VetLicenseUpsertWithWhereUniqueWithoutVetInfoInput>>;
};

export type VetLicenseUpdateWithWhereUniqueWithoutVetInfoInput = {
  data: VetLicenseUpdateWithoutVetInfoInput;
  where: VetLicenseWhereUniqueInput;
};

export type VetLicenseUpdateWithoutVetInfoInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuingAuthority?: Maybe<State>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseType?: Maybe<VetLicenseType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetLicenseUpsertWithWhereUniqueWithoutVetInfoInput = {
  create: VetLicenseCreateWithoutVetInfoInput;
  update: VetLicenseUpdateWithoutVetInfoInput;
  where: VetLicenseWhereUniqueInput;
};

export type VetLicenseWhereInput = {
  AND?: Maybe<Array<VetLicenseWhereInput>>;
  NOT?: Maybe<Array<VetLicenseWhereInput>>;
  OR?: Maybe<Array<VetLicenseWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  expirationDate?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  issuingAuthority?: Maybe<EnumStateFilter>;
  licenseNumber?: Maybe<StringFilter>;
  licenseType?: Maybe<EnumVetLicenseTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetInfo?: Maybe<VetInfoNullableScalarRelationFilter>;
  vetInfoId?: Maybe<StringNullableFilter>;
};

export type VetLicenseWhereUniqueInput = {
  AND?: Maybe<Array<VetLicenseWhereInput>>;
  NOT?: Maybe<Array<VetLicenseWhereInput>>;
  OR?: Maybe<Array<VetLicenseWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  expirationDate?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  issuingAuthority?: Maybe<EnumStateFilter>;
  licenseNumber?: Maybe<StringFilter>;
  licenseType?: Maybe<EnumVetLicenseTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetInfo?: Maybe<VetInfoNullableScalarRelationFilter>;
  vetInfoId?: Maybe<StringNullableFilter>;
};

export type VetsourceCodeTag = {
  __typename?: 'VetsourceCodeTag';
  Service: Array<Service>;
  _count: VetsourceCodeTagCountOutputType;
  externalId: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: VetsourceCodeTagType;
};


export type VetsourceCodeTagServiceArgs = {
  cursor?: Maybe<ServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceWhereInput>;
};

export type VetsourceCodeTagAvgAggregateOutputType = {
  __typename?: 'VetsourceCodeTagAvgAggregateOutputType';
  externalId?: Maybe<Scalars['Float']>;
};

export type VetsourceCodeTagAvgOrderByAggregateInput = {
  externalId?: Maybe<SortOrder>;
};

export type VetsourceCodeTagCountAggregateOutputType = {
  __typename?: 'VetsourceCodeTagCountAggregateOutputType';
  _all: Scalars['Int'];
  externalId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  type: Scalars['Int'];
};

export type VetsourceCodeTagCountOrderByAggregateInput = {
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type VetsourceCodeTagCountOutputType = {
  __typename?: 'VetsourceCodeTagCountOutputType';
  Service: Scalars['Int'];
};

export type VetsourceCodeTagCreateInput = {
  Service?: Maybe<ServiceCreateNestedManyWithoutVetsourceCodeTagsInput>;
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: VetsourceCodeTagType;
};

export type VetsourceCodeTagCreateManyInput = {
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: VetsourceCodeTagType;
};

export type VetsourceCodeTagCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<VetsourceCodeTagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetsourceCodeTagCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<VetsourceCodeTagCreateWithoutServiceInput>>;
};

export type VetsourceCodeTagCreateOrConnectWithoutServiceInput = {
  create: VetsourceCodeTagCreateWithoutServiceInput;
  where: VetsourceCodeTagWhereUniqueInput;
};

export type VetsourceCodeTagCreateWithoutServiceInput = {
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: VetsourceCodeTagType;
};

export type VetsourceCodeTagGroupByOutputType = {
  __typename?: 'VetsourceCodeTagGroupByOutputType';
  _avg?: Maybe<VetsourceCodeTagAvgAggregateOutputType>;
  _count?: Maybe<VetsourceCodeTagCountAggregateOutputType>;
  _max?: Maybe<VetsourceCodeTagMaxAggregateOutputType>;
  _min?: Maybe<VetsourceCodeTagMinAggregateOutputType>;
  _sum?: Maybe<VetsourceCodeTagSumAggregateOutputType>;
  externalId: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: VetsourceCodeTagType;
};

export type VetsourceCodeTagListRelationFilter = {
  every?: Maybe<VetsourceCodeTagWhereInput>;
  none?: Maybe<VetsourceCodeTagWhereInput>;
  some?: Maybe<VetsourceCodeTagWhereInput>;
};

export type VetsourceCodeTagMaxAggregateOutputType = {
  __typename?: 'VetsourceCodeTagMaxAggregateOutputType';
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<VetsourceCodeTagType>;
};

export type VetsourceCodeTagMaxOrderByAggregateInput = {
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type VetsourceCodeTagMinAggregateOutputType = {
  __typename?: 'VetsourceCodeTagMinAggregateOutputType';
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<VetsourceCodeTagType>;
};

export type VetsourceCodeTagMinOrderByAggregateInput = {
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type VetsourceCodeTagOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type VetsourceCodeTagOrderByRelationAndSearchRelevanceInput = {
  Service?: Maybe<ServiceOrderByRelationAggregateInput>;
  _relevance?: Maybe<VetsourceCodeTagOrderByRelevanceInput>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export enum VetsourceCodeTagOrderByRelevanceFieldEnum {
  Id = 'id',
  Name = 'name'
}

export type VetsourceCodeTagOrderByRelevanceInput = {
  fields: Array<VetsourceCodeTagOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type VetsourceCodeTagOrderByWithAggregationInput = {
  _avg?: Maybe<VetsourceCodeTagAvgOrderByAggregateInput>;
  _count?: Maybe<VetsourceCodeTagCountOrderByAggregateInput>;
  _max?: Maybe<VetsourceCodeTagMaxOrderByAggregateInput>;
  _min?: Maybe<VetsourceCodeTagMinOrderByAggregateInput>;
  _sum?: Maybe<VetsourceCodeTagSumOrderByAggregateInput>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type VetsourceCodeTagOrderByWithRelationAndSearchRelevanceInput = {
  Service?: Maybe<ServiceOrderByRelationAggregateInput>;
  _relevance?: Maybe<VetsourceCodeTagOrderByRelevanceInput>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type VetsourceCodeTagOrderByWithRelationInput = {
  Service?: Maybe<ServiceOrderByRelationAggregateInput>;
  _relevance?: Maybe<VetsourceCodeTagOrderByRelevanceInput>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export enum VetsourceCodeTagScalarFieldEnum {
  ExternalId = 'externalId',
  Id = 'id',
  Name = 'name',
  Type = 'type'
}

export type VetsourceCodeTagScalarWhereInput = {
  AND?: Maybe<Array<VetsourceCodeTagScalarWhereInput>>;
  NOT?: Maybe<Array<VetsourceCodeTagScalarWhereInput>>;
  OR?: Maybe<Array<VetsourceCodeTagScalarWhereInput>>;
  externalId?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<EnumVetsourceCodeTagTypeFilter>;
};

export type VetsourceCodeTagScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<VetsourceCodeTagScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<VetsourceCodeTagScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<VetsourceCodeTagScalarWhereWithAggregatesInput>>;
  externalId?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumVetsourceCodeTagTypeWithAggregatesFilter>;
};

export type VetsourceCodeTagSumAggregateOutputType = {
  __typename?: 'VetsourceCodeTagSumAggregateOutputType';
  externalId?: Maybe<Scalars['Int']>;
};

export type VetsourceCodeTagSumOrderByAggregateInput = {
  externalId?: Maybe<SortOrder>;
};

export enum VetsourceCodeTagType {
  Dental = 'Dental',
  Diagnostic = 'Diagnostic',
  Diet = 'Diet',
  Vaccine = 'Vaccine',
  WellnessPlan = 'WellnessPlan'
}

export type VetsourceCodeTagUncheckedCreateInput = {
  Service?: Maybe<ServiceUncheckedCreateNestedManyWithoutVetsourceCodeTagsInput>;
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: VetsourceCodeTagType;
};

export type VetsourceCodeTagUncheckedCreateNestedManyWithoutServiceInput = {
  connect?: Maybe<Array<VetsourceCodeTagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetsourceCodeTagCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<VetsourceCodeTagCreateWithoutServiceInput>>;
};

export type VetsourceCodeTagUncheckedCreateWithoutServiceInput = {
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: VetsourceCodeTagType;
};

export type VetsourceCodeTagUncheckedUpdateInput = {
  Service?: Maybe<ServiceUncheckedUpdateManyWithoutVetsourceCodeTagsNestedInput>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<VetsourceCodeTagType>;
};

export type VetsourceCodeTagUncheckedUpdateManyInput = {
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<VetsourceCodeTagType>;
};

export type VetsourceCodeTagUncheckedUpdateManyWithoutServiceInput = {
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<VetsourceCodeTagType>;
};

export type VetsourceCodeTagUncheckedUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<VetsourceCodeTagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetsourceCodeTagCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<VetsourceCodeTagCreateWithoutServiceInput>>;
  delete?: Maybe<Array<VetsourceCodeTagWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetsourceCodeTagScalarWhereInput>>;
  disconnect?: Maybe<Array<VetsourceCodeTagWhereUniqueInput>>;
  set?: Maybe<Array<VetsourceCodeTagWhereUniqueInput>>;
  update?: Maybe<Array<VetsourceCodeTagUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<VetsourceCodeTagUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<VetsourceCodeTagUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type VetsourceCodeTagUncheckedUpdateWithoutServiceInput = {
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<VetsourceCodeTagType>;
};

export type VetsourceCodeTagUpdateInput = {
  Service?: Maybe<ServiceUpdateManyWithoutVetsourceCodeTagsNestedInput>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<VetsourceCodeTagType>;
};

export type VetsourceCodeTagUpdateManyMutationInput = {
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<VetsourceCodeTagType>;
};

export type VetsourceCodeTagUpdateManyWithWhereWithoutServiceInput = {
  data: VetsourceCodeTagUpdateManyMutationInput;
  where: VetsourceCodeTagScalarWhereInput;
};

export type VetsourceCodeTagUpdateManyWithoutServiceNestedInput = {
  connect?: Maybe<Array<VetsourceCodeTagWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetsourceCodeTagCreateOrConnectWithoutServiceInput>>;
  create?: Maybe<Array<VetsourceCodeTagCreateWithoutServiceInput>>;
  delete?: Maybe<Array<VetsourceCodeTagWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetsourceCodeTagScalarWhereInput>>;
  disconnect?: Maybe<Array<VetsourceCodeTagWhereUniqueInput>>;
  set?: Maybe<Array<VetsourceCodeTagWhereUniqueInput>>;
  update?: Maybe<Array<VetsourceCodeTagUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<VetsourceCodeTagUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: Maybe<Array<VetsourceCodeTagUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type VetsourceCodeTagUpdateWithWhereUniqueWithoutServiceInput = {
  data: VetsourceCodeTagUpdateWithoutServiceInput;
  where: VetsourceCodeTagWhereUniqueInput;
};

export type VetsourceCodeTagUpdateWithoutServiceInput = {
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<VetsourceCodeTagType>;
};

export type VetsourceCodeTagUpsertWithWhereUniqueWithoutServiceInput = {
  create: VetsourceCodeTagCreateWithoutServiceInput;
  update: VetsourceCodeTagUpdateWithoutServiceInput;
  where: VetsourceCodeTagWhereUniqueInput;
};

export type VetsourceCodeTagWhereInput = {
  AND?: Maybe<Array<VetsourceCodeTagWhereInput>>;
  NOT?: Maybe<Array<VetsourceCodeTagWhereInput>>;
  OR?: Maybe<Array<VetsourceCodeTagWhereInput>>;
  Service?: Maybe<ServiceListRelationFilter>;
  externalId?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<EnumVetsourceCodeTagTypeFilter>;
};

export type VetsourceCodeTagWhereUniqueInput = {
  AND?: Maybe<Array<VetsourceCodeTagWhereInput>>;
  NOT?: Maybe<Array<VetsourceCodeTagWhereInput>>;
  OR?: Maybe<Array<VetsourceCodeTagWhereInput>>;
  Service?: Maybe<ServiceListRelationFilter>;
  externalId?: Maybe<IntFilter>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EnumVetsourceCodeTagTypeFilter>;
};

export type VetsourceInstallation = {
  __typename?: 'VetsourceInstallation';
  clinic?: Maybe<Clinic>;
  clinicId?: Maybe<Scalars['String']>;
  connectivityState: VetsourceInstallationConnectivityState;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims: Scalars['String'];
  segment: Scalars['String'];
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type VetsourceInstallationClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};

export enum VetsourceInstallationConnectivityState {
  AlreadyConnected = 'AlreadyConnected',
  NeedsConnection = 'NeedsConnection'
}

export type VetsourceInstallationCountAggregateOutputType = {
  __typename?: 'VetsourceInstallationCountAggregateOutputType';
  _all: Scalars['Int'];
  clinicId: Scalars['Int'];
  connectivityState: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isVetDataInstalled: Scalars['Int'];
  newConnectionPartner: Scalars['Int'];
  pims: Scalars['Int'];
  segment: Scalars['Int'];
  syncVetEulaUrl: Scalars['Int'];
  syncVetId: Scalars['Int'];
  syncVetRegistrationKey: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type VetsourceInstallationCountOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  connectivityState?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVetDataInstalled?: Maybe<SortOrder>;
  newConnectionPartner?: Maybe<SortOrder>;
  pims?: Maybe<SortOrder>;
  segment?: Maybe<SortOrder>;
  syncVetEulaUrl?: Maybe<SortOrder>;
  syncVetId?: Maybe<SortOrder>;
  syncVetRegistrationKey?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetsourceInstallationCreateInput = {
  clinic?: Maybe<ClinicCreateNestedOneWithoutVetsourceInstallationInput>;
  connectivityState: VetsourceInstallationConnectivityState;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims: Scalars['String'];
  segment: Scalars['String'];
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationCreateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  connectivityState: VetsourceInstallationConnectivityState;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims: Scalars['String'];
  segment: Scalars['String'];
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<VetsourceInstallationWhereUniqueInput>;
  connectOrCreate?: Maybe<VetsourceInstallationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<VetsourceInstallationCreateWithoutClinicInput>;
};

export type VetsourceInstallationCreateOrConnectWithoutClinicInput = {
  create: VetsourceInstallationCreateWithoutClinicInput;
  where: VetsourceInstallationWhereUniqueInput;
};

export type VetsourceInstallationCreateWithoutClinicInput = {
  connectivityState: VetsourceInstallationConnectivityState;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims: Scalars['String'];
  segment: Scalars['String'];
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationGroupByOutputType = {
  __typename?: 'VetsourceInstallationGroupByOutputType';
  _count?: Maybe<VetsourceInstallationCountAggregateOutputType>;
  _max?: Maybe<VetsourceInstallationMaxAggregateOutputType>;
  _min?: Maybe<VetsourceInstallationMinAggregateOutputType>;
  clinicId?: Maybe<Scalars['String']>;
  connectivityState: VetsourceInstallationConnectivityState;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims: Scalars['String'];
  segment: Scalars['String'];
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type VetsourceInstallationMaxAggregateOutputType = {
  __typename?: 'VetsourceInstallationMaxAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  connectivityState?: Maybe<VetsourceInstallationConnectivityState>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims?: Maybe<Scalars['String']>;
  segment?: Maybe<Scalars['String']>;
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationMaxOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  connectivityState?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVetDataInstalled?: Maybe<SortOrder>;
  newConnectionPartner?: Maybe<SortOrder>;
  pims?: Maybe<SortOrder>;
  segment?: Maybe<SortOrder>;
  syncVetEulaUrl?: Maybe<SortOrder>;
  syncVetId?: Maybe<SortOrder>;
  syncVetRegistrationKey?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetsourceInstallationMinAggregateOutputType = {
  __typename?: 'VetsourceInstallationMinAggregateOutputType';
  clinicId?: Maybe<Scalars['String']>;
  connectivityState?: Maybe<VetsourceInstallationConnectivityState>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims?: Maybe<Scalars['String']>;
  segment?: Maybe<Scalars['String']>;
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationMinOrderByAggregateInput = {
  clinicId?: Maybe<SortOrder>;
  connectivityState?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVetDataInstalled?: Maybe<SortOrder>;
  newConnectionPartner?: Maybe<SortOrder>;
  pims?: Maybe<SortOrder>;
  segment?: Maybe<SortOrder>;
  syncVetEulaUrl?: Maybe<SortOrder>;
  syncVetId?: Maybe<SortOrder>;
  syncVetRegistrationKey?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetsourceInstallationNullableScalarRelationFilter = {
  AND?: Maybe<Array<VetsourceInstallationWhereInput>>;
  NOT?: Maybe<Array<VetsourceInstallationWhereInput>>;
  OR?: Maybe<Array<VetsourceInstallationWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  connectivityState?: Maybe<EnumVetsourceInstallationConnectivityStateFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isVetDataInstalled?: Maybe<BoolNullableFilter>;
  newConnectionPartner?: Maybe<StringNullableFilter>;
  pims?: Maybe<StringFilter>;
  segment?: Maybe<StringFilter>;
  syncVetEulaUrl?: Maybe<StringNullableFilter>;
  syncVetId?: Maybe<StringNullableFilter>;
  syncVetRegistrationKey?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetsourceInstallationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetsourceInstallationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  connectivityState?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVetDataInstalled?: Maybe<SortOrder>;
  newConnectionPartner?: Maybe<SortOrder>;
  pims?: Maybe<SortOrder>;
  segment?: Maybe<SortOrder>;
  syncVetEulaUrl?: Maybe<SortOrder>;
  syncVetId?: Maybe<SortOrder>;
  syncVetRegistrationKey?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum VetsourceInstallationOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  NewConnectionPartner = 'newConnectionPartner',
  Pims = 'pims',
  Segment = 'segment',
  SyncVetEulaUrl = 'syncVetEulaUrl',
  SyncVetId = 'syncVetId',
  SyncVetRegistrationKey = 'syncVetRegistrationKey'
}

export type VetsourceInstallationOrderByRelevanceInput = {
  fields: Array<VetsourceInstallationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type VetsourceInstallationOrderByWithAggregationInput = {
  _count?: Maybe<VetsourceInstallationCountOrderByAggregateInput>;
  _max?: Maybe<VetsourceInstallationMaxOrderByAggregateInput>;
  _min?: Maybe<VetsourceInstallationMinOrderByAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  connectivityState?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVetDataInstalled?: Maybe<SortOrder>;
  newConnectionPartner?: Maybe<SortOrder>;
  pims?: Maybe<SortOrder>;
  segment?: Maybe<SortOrder>;
  syncVetEulaUrl?: Maybe<SortOrder>;
  syncVetId?: Maybe<SortOrder>;
  syncVetRegistrationKey?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetsourceInstallationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetsourceInstallationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  connectivityState?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVetDataInstalled?: Maybe<SortOrder>;
  newConnectionPartner?: Maybe<SortOrder>;
  pims?: Maybe<SortOrder>;
  segment?: Maybe<SortOrder>;
  syncVetEulaUrl?: Maybe<SortOrder>;
  syncVetId?: Maybe<SortOrder>;
  syncVetRegistrationKey?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetsourceInstallationOrderByWithRelationInput = {
  _relevance?: Maybe<VetsourceInstallationOrderByRelevanceInput>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicId?: Maybe<SortOrder>;
  connectivityState?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isVetDataInstalled?: Maybe<SortOrder>;
  newConnectionPartner?: Maybe<SortOrder>;
  pims?: Maybe<SortOrder>;
  segment?: Maybe<SortOrder>;
  syncVetEulaUrl?: Maybe<SortOrder>;
  syncVetId?: Maybe<SortOrder>;
  syncVetRegistrationKey?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum VetsourceInstallationScalarFieldEnum {
  ClinicId = 'clinicId',
  ConnectivityState = 'connectivityState',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsVetDataInstalled = 'isVetDataInstalled',
  NewConnectionPartner = 'newConnectionPartner',
  Pims = 'pims',
  Segment = 'segment',
  SyncVetEulaUrl = 'syncVetEulaUrl',
  SyncVetId = 'syncVetId',
  SyncVetRegistrationKey = 'syncVetRegistrationKey',
  UpdatedAt = 'updatedAt'
}

export type VetsourceInstallationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<VetsourceInstallationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<VetsourceInstallationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<VetsourceInstallationScalarWhereWithAggregatesInput>>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  connectivityState?: Maybe<EnumVetsourceInstallationConnectivityStateWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isVetDataInstalled?: Maybe<BoolNullableWithAggregatesFilter>;
  newConnectionPartner?: Maybe<StringNullableWithAggregatesFilter>;
  pims?: Maybe<StringWithAggregatesFilter>;
  segment?: Maybe<StringWithAggregatesFilter>;
  syncVetEulaUrl?: Maybe<StringNullableWithAggregatesFilter>;
  syncVetId?: Maybe<StringNullableWithAggregatesFilter>;
  syncVetRegistrationKey?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type VetsourceInstallationUncheckedCreateInput = {
  clinicId?: Maybe<Scalars['String']>;
  connectivityState: VetsourceInstallationConnectivityState;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims: Scalars['String'];
  segment: Scalars['String'];
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationUncheckedCreateNestedOneWithoutClinicInput = {
  connect?: Maybe<VetsourceInstallationWhereUniqueInput>;
  connectOrCreate?: Maybe<VetsourceInstallationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<VetsourceInstallationCreateWithoutClinicInput>;
};

export type VetsourceInstallationUncheckedCreateWithoutClinicInput = {
  connectivityState: VetsourceInstallationConnectivityState;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims: Scalars['String'];
  segment: Scalars['String'];
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationUncheckedUpdateInput = {
  clinicId?: Maybe<Scalars['String']>;
  connectivityState?: Maybe<VetsourceInstallationConnectivityState>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims?: Maybe<Scalars['String']>;
  segment?: Maybe<Scalars['String']>;
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationUncheckedUpdateManyInput = {
  clinicId?: Maybe<Scalars['String']>;
  connectivityState?: Maybe<VetsourceInstallationConnectivityState>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims?: Maybe<Scalars['String']>;
  segment?: Maybe<Scalars['String']>;
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationUncheckedUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<VetsourceInstallationWhereUniqueInput>;
  connectOrCreate?: Maybe<VetsourceInstallationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<VetsourceInstallationCreateWithoutClinicInput>;
  delete?: Maybe<VetsourceInstallationWhereInput>;
  disconnect?: Maybe<VetsourceInstallationWhereInput>;
  update?: Maybe<VetsourceInstallationUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<VetsourceInstallationUpsertWithoutClinicInput>;
};

export type VetsourceInstallationUncheckedUpdateWithoutClinicInput = {
  connectivityState?: Maybe<VetsourceInstallationConnectivityState>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims?: Maybe<Scalars['String']>;
  segment?: Maybe<Scalars['String']>;
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationUpdateInput = {
  clinic?: Maybe<ClinicUpdateOneWithoutVetsourceInstallationNestedInput>;
  connectivityState?: Maybe<VetsourceInstallationConnectivityState>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims?: Maybe<Scalars['String']>;
  segment?: Maybe<Scalars['String']>;
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationUpdateManyMutationInput = {
  connectivityState?: Maybe<VetsourceInstallationConnectivityState>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims?: Maybe<Scalars['String']>;
  segment?: Maybe<Scalars['String']>;
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationUpdateOneWithoutClinicNestedInput = {
  connect?: Maybe<VetsourceInstallationWhereUniqueInput>;
  connectOrCreate?: Maybe<VetsourceInstallationCreateOrConnectWithoutClinicInput>;
  create?: Maybe<VetsourceInstallationCreateWithoutClinicInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<VetsourceInstallationUpdateToOneWithWhereWithoutClinicInput>;
  upsert?: Maybe<VetsourceInstallationUpsertWithoutClinicInput>;
};

export type VetsourceInstallationUpdateToOneWithWhereWithoutClinicInput = {
  data: VetsourceInstallationUpdateWithoutClinicInput;
  where?: Maybe<VetsourceInstallationWhereInput>;
};

export type VetsourceInstallationUpdateWithoutClinicInput = {
  connectivityState?: Maybe<VetsourceInstallationConnectivityState>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<Scalars['Boolean']>;
  newConnectionPartner?: Maybe<Scalars['String']>;
  pims?: Maybe<Scalars['String']>;
  segment?: Maybe<Scalars['String']>;
  syncVetEulaUrl?: Maybe<Scalars['String']>;
  syncVetId?: Maybe<Scalars['String']>;
  syncVetRegistrationKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceInstallationUpsertWithoutClinicInput = {
  create: VetsourceInstallationCreateWithoutClinicInput;
  update: VetsourceInstallationUpdateWithoutClinicInput;
  where?: Maybe<VetsourceInstallationWhereInput>;
};

export type VetsourceInstallationWhereInput = {
  AND?: Maybe<Array<VetsourceInstallationWhereInput>>;
  NOT?: Maybe<Array<VetsourceInstallationWhereInput>>;
  OR?: Maybe<Array<VetsourceInstallationWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  connectivityState?: Maybe<EnumVetsourceInstallationConnectivityStateFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  isVetDataInstalled?: Maybe<BoolNullableFilter>;
  newConnectionPartner?: Maybe<StringNullableFilter>;
  pims?: Maybe<StringFilter>;
  segment?: Maybe<StringFilter>;
  syncVetEulaUrl?: Maybe<StringNullableFilter>;
  syncVetId?: Maybe<StringNullableFilter>;
  syncVetRegistrationKey?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetsourceInstallationWhereUniqueInput = {
  AND?: Maybe<Array<VetsourceInstallationWhereInput>>;
  NOT?: Maybe<Array<VetsourceInstallationWhereInput>>;
  OR?: Maybe<Array<VetsourceInstallationWhereInput>>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicId?: Maybe<Scalars['String']>;
  connectivityState?: Maybe<EnumVetsourceInstallationConnectivityStateFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  isVetDataInstalled?: Maybe<BoolNullableFilter>;
  newConnectionPartner?: Maybe<StringNullableFilter>;
  pims?: Maybe<StringFilter>;
  segment?: Maybe<StringFilter>;
  syncVetEulaUrl?: Maybe<StringNullableFilter>;
  syncVetId?: Maybe<StringNullableFilter>;
  syncVetRegistrationKey?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetsourcePharmacyIntegration = {
  __typename?: 'VetsourcePharmacyIntegration';
  clinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt: Scalars['DateTime'];
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};


export type VetsourcePharmacyIntegrationClinicPimsIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type VetsourcePharmacyIntegrationCountAggregateOutputType = {
  __typename?: 'VetsourcePharmacyIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  integrationStatus: Scalars['Int'];
  originalSystem: Scalars['Int'];
  siteId: Scalars['Int'];
  system: Scalars['Int'];
  updatedAt: Scalars['Int'];
  vetsourcePracticeId: Scalars['Int'];
};

export type VetsourcePharmacyIntegrationCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourcePracticeId?: Maybe<SortOrder>;
};

export type VetsourcePharmacyIntegrationCreateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutVetsourcePharmacyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<VetsourcePharmacyIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<VetsourcePharmacyIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<VetsourcePharmacyIntegrationCreateWithoutClinicPimsIntegrationInput>;
};

export type VetsourcePharmacyIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput = {
  create: VetsourcePharmacyIntegrationCreateWithoutClinicPimsIntegrationInput;
  where: VetsourcePharmacyIntegrationWhereUniqueInput;
};

export type VetsourcePharmacyIntegrationCreateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationGroupByOutputType = {
  __typename?: 'VetsourcePharmacyIntegrationGroupByOutputType';
  _count?: Maybe<VetsourcePharmacyIntegrationCountAggregateOutputType>;
  _max?: Maybe<VetsourcePharmacyIntegrationMaxAggregateOutputType>;
  _min?: Maybe<VetsourcePharmacyIntegrationMinAggregateOutputType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt: Scalars['DateTime'];
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationMaxAggregateOutputType = {
  __typename?: 'VetsourcePharmacyIntegrationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourcePracticeId?: Maybe<SortOrder>;
};

export type VetsourcePharmacyIntegrationMinAggregateOutputType = {
  __typename?: 'VetsourcePharmacyIntegrationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourcePracticeId?: Maybe<SortOrder>;
};

export type VetsourcePharmacyIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<VetsourcePharmacyIntegrationWhereInput>>;
  NOT?: Maybe<Array<VetsourcePharmacyIntegrationWhereInput>>;
  OR?: Maybe<Array<VetsourcePharmacyIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationStatus?: Maybe<EnumIntegrationStatusNullableFilter>;
  originalSystem?: Maybe<StringNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  system?: Maybe<EnumSyncVetIntegrationSystemNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetsourcePracticeId?: Maybe<StringNullableFilter>;
};

export type VetsourcePharmacyIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetsourcePharmacyIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourcePracticeId?: Maybe<SortOrder>;
};

export enum VetsourcePharmacyIntegrationOrderByRelevanceFieldEnum {
  Id = 'id',
  OriginalSystem = 'originalSystem',
  SiteId = 'siteId',
  VetsourcePracticeId = 'vetsourcePracticeId'
}

export type VetsourcePharmacyIntegrationOrderByRelevanceInput = {
  fields: Array<VetsourcePharmacyIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type VetsourcePharmacyIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<VetsourcePharmacyIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<VetsourcePharmacyIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<VetsourcePharmacyIntegrationMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourcePracticeId?: Maybe<SortOrder>;
};

export type VetsourcePharmacyIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetsourcePharmacyIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourcePracticeId?: Maybe<SortOrder>;
};

export type VetsourcePharmacyIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<VetsourcePharmacyIntegrationOrderByRelevanceInput>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  integrationStatus?: Maybe<SortOrder>;
  originalSystem?: Maybe<SortOrder>;
  siteId?: Maybe<SortOrder>;
  system?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  vetsourcePracticeId?: Maybe<SortOrder>;
};

export enum VetsourcePharmacyIntegrationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IntegrationStatus = 'integrationStatus',
  OriginalSystem = 'originalSystem',
  SiteId = 'siteId',
  System = 'system',
  UpdatedAt = 'updatedAt',
  VetsourcePracticeId = 'vetsourcePracticeId'
}

export type VetsourcePharmacyIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<VetsourcePharmacyIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<VetsourcePharmacyIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<VetsourcePharmacyIntegrationScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  integrationStatus?: Maybe<EnumIntegrationStatusNullableWithAggregatesFilter>;
  originalSystem?: Maybe<StringNullableWithAggregatesFilter>;
  siteId?: Maybe<StringNullableWithAggregatesFilter>;
  system?: Maybe<EnumSyncVetIntegrationSystemNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  vetsourcePracticeId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type VetsourcePharmacyIntegrationUncheckedCreateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedOneWithoutVetsourcePharmacyInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationUncheckedCreateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationUncheckedUpdateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedUpdateOneWithoutVetsourcePharmacyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationUncheckedUpdateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationUncheckedUpdateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationUpdateInput = {
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutVetsourcePharmacyNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<VetsourcePharmacyIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<VetsourcePharmacyIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<VetsourcePharmacyIntegrationCreateWithoutClinicPimsIntegrationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<VetsourcePharmacyIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput>;
  upsert?: Maybe<VetsourcePharmacyIntegrationUpsertWithoutClinicPimsIntegrationInput>;
};

export type VetsourcePharmacyIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput = {
  data: VetsourcePharmacyIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<VetsourcePharmacyIntegrationWhereInput>;
};

export type VetsourcePharmacyIntegrationUpdateWithoutClinicPimsIntegrationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<IntegrationStatus>;
  originalSystem?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  system?: Maybe<SyncVetIntegrationSystem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vetsourcePracticeId?: Maybe<Scalars['String']>;
};

export type VetsourcePharmacyIntegrationUpsertWithoutClinicPimsIntegrationInput = {
  create: VetsourcePharmacyIntegrationCreateWithoutClinicPimsIntegrationInput;
  update: VetsourcePharmacyIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<VetsourcePharmacyIntegrationWhereInput>;
};

export type VetsourcePharmacyIntegrationWhereInput = {
  AND?: Maybe<Array<VetsourcePharmacyIntegrationWhereInput>>;
  NOT?: Maybe<Array<VetsourcePharmacyIntegrationWhereInput>>;
  OR?: Maybe<Array<VetsourcePharmacyIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  integrationStatus?: Maybe<EnumIntegrationStatusNullableFilter>;
  originalSystem?: Maybe<StringNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  system?: Maybe<EnumSyncVetIntegrationSystemNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetsourcePracticeId?: Maybe<StringNullableFilter>;
};

export type VetsourcePharmacyIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<VetsourcePharmacyIntegrationWhereInput>>;
  NOT?: Maybe<Array<VetsourcePharmacyIntegrationWhereInput>>;
  OR?: Maybe<Array<VetsourcePharmacyIntegrationWhereInput>>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  integrationStatus?: Maybe<EnumIntegrationStatusNullableFilter>;
  originalSystem?: Maybe<StringNullableFilter>;
  siteId?: Maybe<StringNullableFilter>;
  system?: Maybe<EnumSyncVetIntegrationSystemNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  vetsourcePracticeId?: Maybe<StringNullableFilter>;
};

export type VetsourceRevenueCategory = {
  __typename?: 'VetsourceRevenueCategory';
  Service: Array<Service>;
  _count: VetsourceRevenueCategoryCountOutputType;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory: Array<VetsourceRevenueCategory>;
  createdAt: Scalars['DateTime'];
  externalId: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategory>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};


export type VetsourceRevenueCategoryServiceArgs = {
  cursor?: Maybe<ServiceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ServiceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ServiceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceWhereInput>;
};


export type VetsourceRevenueCategoryChildrenVetsourceRevenueCategoryArgs = {
  cursor?: Maybe<VetsourceRevenueCategoryWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<VetsourceRevenueCategoryScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<VetsourceRevenueCategoryOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};


export type VetsourceRevenueCategoryParentVetsourceRevenueCategoryArgs = {
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};

export type VetsourceRevenueCategoryAvgAggregateOutputType = {
  __typename?: 'VetsourceRevenueCategoryAvgAggregateOutputType';
  accountNumber?: Maybe<Scalars['Float']>;
  externalId?: Maybe<Scalars['Float']>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Float']>;
};

export type VetsourceRevenueCategoryAvgOrderByAggregateInput = {
  accountNumber?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<SortOrder>;
};

export type VetsourceRevenueCategoryCountAggregateOutputType = {
  __typename?: 'VetsourceRevenueCategoryCountAggregateOutputType';
  _all: Scalars['Int'];
  accountName: Scalars['Int'];
  accountNumber: Scalars['Int'];
  createdAt: Scalars['Int'];
  externalId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  parentVetsourceRevenueCategoryExternalId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type VetsourceRevenueCategoryCountOrderByAggregateInput = {
  accountName?: Maybe<SortOrder>;
  accountNumber?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetsourceRevenueCategoryCountOutputType = {
  __typename?: 'VetsourceRevenueCategoryCountOutputType';
  Service: Scalars['Int'];
  childrenVetsourceRevenueCategory: Scalars['Int'];
};

export type VetsourceRevenueCategoryCreateInput = {
  Service?: Maybe<ServiceCreateNestedManyWithoutVetsourceRevenueCategoryInput>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedManyWithoutParentVetsourceRevenueCategoryInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutChildrenVetsourceRevenueCategoryInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryCreateManyInput = {
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryCreateManyParentVetsourceRevenueCategoryInput = {
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryCreateManyParentVetsourceRevenueCategoryInputEnvelope = {
  data: Array<VetsourceRevenueCategoryCreateManyParentVetsourceRevenueCategoryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type VetsourceRevenueCategoryCreateNestedManyWithoutParentVetsourceRevenueCategoryInput = {
  connect?: Maybe<Array<VetsourceRevenueCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetsourceRevenueCategoryCreateOrConnectWithoutParentVetsourceRevenueCategoryInput>>;
  create?: Maybe<Array<VetsourceRevenueCategoryCreateWithoutParentVetsourceRevenueCategoryInput>>;
  createMany?: Maybe<VetsourceRevenueCategoryCreateManyParentVetsourceRevenueCategoryInputEnvelope>;
};

export type VetsourceRevenueCategoryCreateNestedOneWithoutChildrenVetsourceRevenueCategoryInput = {
  connect?: Maybe<VetsourceRevenueCategoryWhereUniqueInput>;
  connectOrCreate?: Maybe<VetsourceRevenueCategoryCreateOrConnectWithoutChildrenVetsourceRevenueCategoryInput>;
  create?: Maybe<VetsourceRevenueCategoryCreateWithoutChildrenVetsourceRevenueCategoryInput>;
};

export type VetsourceRevenueCategoryCreateNestedOneWithoutServiceInput = {
  connect?: Maybe<VetsourceRevenueCategoryWhereUniqueInput>;
  connectOrCreate?: Maybe<VetsourceRevenueCategoryCreateOrConnectWithoutServiceInput>;
  create?: Maybe<VetsourceRevenueCategoryCreateWithoutServiceInput>;
};

export type VetsourceRevenueCategoryCreateOrConnectWithoutChildrenVetsourceRevenueCategoryInput = {
  create: VetsourceRevenueCategoryCreateWithoutChildrenVetsourceRevenueCategoryInput;
  where: VetsourceRevenueCategoryWhereUniqueInput;
};

export type VetsourceRevenueCategoryCreateOrConnectWithoutParentVetsourceRevenueCategoryInput = {
  create: VetsourceRevenueCategoryCreateWithoutParentVetsourceRevenueCategoryInput;
  where: VetsourceRevenueCategoryWhereUniqueInput;
};

export type VetsourceRevenueCategoryCreateOrConnectWithoutServiceInput = {
  create: VetsourceRevenueCategoryCreateWithoutServiceInput;
  where: VetsourceRevenueCategoryWhereUniqueInput;
};

export type VetsourceRevenueCategoryCreateWithoutChildrenVetsourceRevenueCategoryInput = {
  Service?: Maybe<ServiceCreateNestedManyWithoutVetsourceRevenueCategoryInput>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutChildrenVetsourceRevenueCategoryInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryCreateWithoutParentVetsourceRevenueCategoryInput = {
  Service?: Maybe<ServiceCreateNestedManyWithoutVetsourceRevenueCategoryInput>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedManyWithoutParentVetsourceRevenueCategoryInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryCreateWithoutServiceInput = {
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedManyWithoutParentVetsourceRevenueCategoryInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryCreateNestedOneWithoutChildrenVetsourceRevenueCategoryInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryGroupByOutputType = {
  __typename?: 'VetsourceRevenueCategoryGroupByOutputType';
  _avg?: Maybe<VetsourceRevenueCategoryAvgAggregateOutputType>;
  _count?: Maybe<VetsourceRevenueCategoryCountAggregateOutputType>;
  _max?: Maybe<VetsourceRevenueCategoryMaxAggregateOutputType>;
  _min?: Maybe<VetsourceRevenueCategoryMinAggregateOutputType>;
  _sum?: Maybe<VetsourceRevenueCategorySumAggregateOutputType>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  externalId: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type VetsourceRevenueCategoryListRelationFilter = {
  every?: Maybe<VetsourceRevenueCategoryWhereInput>;
  none?: Maybe<VetsourceRevenueCategoryWhereInput>;
  some?: Maybe<VetsourceRevenueCategoryWhereInput>;
};

export type VetsourceRevenueCategoryMaxAggregateOutputType = {
  __typename?: 'VetsourceRevenueCategoryMaxAggregateOutputType';
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryMaxOrderByAggregateInput = {
  accountName?: Maybe<SortOrder>;
  accountNumber?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetsourceRevenueCategoryMinAggregateOutputType = {
  __typename?: 'VetsourceRevenueCategoryMinAggregateOutputType';
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryMinOrderByAggregateInput = {
  accountName?: Maybe<SortOrder>;
  accountNumber?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetsourceRevenueCategoryNullableScalarRelationFilter = {
  AND?: Maybe<Array<VetsourceRevenueCategoryWhereInput>>;
  NOT?: Maybe<Array<VetsourceRevenueCategoryWhereInput>>;
  OR?: Maybe<Array<VetsourceRevenueCategoryWhereInput>>;
  Service?: Maybe<ServiceListRelationFilter>;
  accountName?: Maybe<StringNullableFilter>;
  accountNumber?: Maybe<IntNullableFilter>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  externalId?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryNullableScalarRelationFilter>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetsourceRevenueCategoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type VetsourceRevenueCategoryOrderByRelationAndSearchRelevanceInput = {
  Service?: Maybe<ServiceOrderByRelationAggregateInput>;
  _relevance?: Maybe<VetsourceRevenueCategoryOrderByRelevanceInput>;
  accountName?: Maybe<SortOrder>;
  accountNumber?: Maybe<SortOrder>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryOrderByWithRelationInput>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum VetsourceRevenueCategoryOrderByRelevanceFieldEnum {
  AccountName = 'accountName',
  Id = 'id',
  Name = 'name'
}

export type VetsourceRevenueCategoryOrderByRelevanceInput = {
  fields: Array<VetsourceRevenueCategoryOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type VetsourceRevenueCategoryOrderByWithAggregationInput = {
  _avg?: Maybe<VetsourceRevenueCategoryAvgOrderByAggregateInput>;
  _count?: Maybe<VetsourceRevenueCategoryCountOrderByAggregateInput>;
  _max?: Maybe<VetsourceRevenueCategoryMaxOrderByAggregateInput>;
  _min?: Maybe<VetsourceRevenueCategoryMinOrderByAggregateInput>;
  _sum?: Maybe<VetsourceRevenueCategorySumOrderByAggregateInput>;
  accountName?: Maybe<SortOrder>;
  accountNumber?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetsourceRevenueCategoryOrderByWithRelationAndSearchRelevanceInput = {
  Service?: Maybe<ServiceOrderByRelationAggregateInput>;
  _relevance?: Maybe<VetsourceRevenueCategoryOrderByRelevanceInput>;
  accountName?: Maybe<SortOrder>;
  accountNumber?: Maybe<SortOrder>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryOrderByWithRelationInput>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetsourceRevenueCategoryOrderByWithRelationInput = {
  Service?: Maybe<ServiceOrderByRelationAggregateInput>;
  _relevance?: Maybe<VetsourceRevenueCategoryOrderByRelevanceInput>;
  accountName?: Maybe<SortOrder>;
  accountNumber?: Maybe<SortOrder>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryOrderByWithRelationInput>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum VetsourceRevenueCategoryScalarFieldEnum {
  AccountName = 'accountName',
  AccountNumber = 'accountNumber',
  CreatedAt = 'createdAt',
  ExternalId = 'externalId',
  Id = 'id',
  Name = 'name',
  ParentVetsourceRevenueCategoryExternalId = 'parentVetsourceRevenueCategoryExternalId',
  UpdatedAt = 'updatedAt'
}

export type VetsourceRevenueCategoryScalarWhereInput = {
  AND?: Maybe<Array<VetsourceRevenueCategoryScalarWhereInput>>;
  NOT?: Maybe<Array<VetsourceRevenueCategoryScalarWhereInput>>;
  OR?: Maybe<Array<VetsourceRevenueCategoryScalarWhereInput>>;
  accountName?: Maybe<StringNullableFilter>;
  accountNumber?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  externalId?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetsourceRevenueCategoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<VetsourceRevenueCategoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<VetsourceRevenueCategoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<VetsourceRevenueCategoryScalarWhereWithAggregatesInput>>;
  accountName?: Maybe<StringNullableWithAggregatesFilter>;
  accountNumber?: Maybe<IntNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  externalId?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<IntNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type VetsourceRevenueCategorySumAggregateOutputType = {
  __typename?: 'VetsourceRevenueCategorySumAggregateOutputType';
  accountNumber?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['Int']>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
};

export type VetsourceRevenueCategorySumOrderByAggregateInput = {
  accountNumber?: Maybe<SortOrder>;
  externalId?: Maybe<SortOrder>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<SortOrder>;
};

export type VetsourceRevenueCategoryUncheckedCreateInput = {
  Service?: Maybe<ServiceUncheckedCreateNestedManyWithoutVetsourceRevenueCategoryInput>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUncheckedCreateNestedManyWithoutParentVetsourceRevenueCategoryInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUncheckedCreateNestedManyWithoutParentVetsourceRevenueCategoryInput = {
  connect?: Maybe<Array<VetsourceRevenueCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetsourceRevenueCategoryCreateOrConnectWithoutParentVetsourceRevenueCategoryInput>>;
  create?: Maybe<Array<VetsourceRevenueCategoryCreateWithoutParentVetsourceRevenueCategoryInput>>;
  createMany?: Maybe<VetsourceRevenueCategoryCreateManyParentVetsourceRevenueCategoryInputEnvelope>;
};

export type VetsourceRevenueCategoryUncheckedCreateWithoutChildrenVetsourceRevenueCategoryInput = {
  Service?: Maybe<ServiceUncheckedCreateNestedManyWithoutVetsourceRevenueCategoryInput>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUncheckedCreateWithoutParentVetsourceRevenueCategoryInput = {
  Service?: Maybe<ServiceUncheckedCreateNestedManyWithoutVetsourceRevenueCategoryInput>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUncheckedCreateNestedManyWithoutParentVetsourceRevenueCategoryInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUncheckedCreateWithoutServiceInput = {
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUncheckedCreateNestedManyWithoutParentVetsourceRevenueCategoryInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUncheckedUpdateInput = {
  Service?: Maybe<ServiceUncheckedUpdateManyWithoutVetsourceRevenueCategoryNestedInput>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUncheckedUpdateManyWithoutParentVetsourceRevenueCategoryNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUncheckedUpdateManyInput = {
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUncheckedUpdateManyWithoutParentVetsourceRevenueCategoryInput = {
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUncheckedUpdateManyWithoutParentVetsourceRevenueCategoryNestedInput = {
  connect?: Maybe<Array<VetsourceRevenueCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetsourceRevenueCategoryCreateOrConnectWithoutParentVetsourceRevenueCategoryInput>>;
  create?: Maybe<Array<VetsourceRevenueCategoryCreateWithoutParentVetsourceRevenueCategoryInput>>;
  createMany?: Maybe<VetsourceRevenueCategoryCreateManyParentVetsourceRevenueCategoryInputEnvelope>;
  delete?: Maybe<Array<VetsourceRevenueCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetsourceRevenueCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<VetsourceRevenueCategoryWhereUniqueInput>>;
  set?: Maybe<Array<VetsourceRevenueCategoryWhereUniqueInput>>;
  update?: Maybe<Array<VetsourceRevenueCategoryUpdateWithWhereUniqueWithoutParentVetsourceRevenueCategoryInput>>;
  updateMany?: Maybe<Array<VetsourceRevenueCategoryUpdateManyWithWhereWithoutParentVetsourceRevenueCategoryInput>>;
  upsert?: Maybe<Array<VetsourceRevenueCategoryUpsertWithWhereUniqueWithoutParentVetsourceRevenueCategoryInput>>;
};

export type VetsourceRevenueCategoryUncheckedUpdateWithoutChildrenVetsourceRevenueCategoryInput = {
  Service?: Maybe<ServiceUncheckedUpdateManyWithoutVetsourceRevenueCategoryNestedInput>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUncheckedUpdateWithoutParentVetsourceRevenueCategoryInput = {
  Service?: Maybe<ServiceUncheckedUpdateManyWithoutVetsourceRevenueCategoryNestedInput>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUncheckedUpdateManyWithoutParentVetsourceRevenueCategoryNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUncheckedUpdateWithoutServiceInput = {
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUncheckedUpdateManyWithoutParentVetsourceRevenueCategoryNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUpdateInput = {
  Service?: Maybe<ServiceUpdateManyWithoutVetsourceRevenueCategoryNestedInput>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateManyWithoutParentVetsourceRevenueCategoryNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutChildrenVetsourceRevenueCategoryNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUpdateManyMutationInput = {
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUpdateManyWithWhereWithoutParentVetsourceRevenueCategoryInput = {
  data: VetsourceRevenueCategoryUpdateManyMutationInput;
  where: VetsourceRevenueCategoryScalarWhereInput;
};

export type VetsourceRevenueCategoryUpdateManyWithoutParentVetsourceRevenueCategoryNestedInput = {
  connect?: Maybe<Array<VetsourceRevenueCategoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<VetsourceRevenueCategoryCreateOrConnectWithoutParentVetsourceRevenueCategoryInput>>;
  create?: Maybe<Array<VetsourceRevenueCategoryCreateWithoutParentVetsourceRevenueCategoryInput>>;
  createMany?: Maybe<VetsourceRevenueCategoryCreateManyParentVetsourceRevenueCategoryInputEnvelope>;
  delete?: Maybe<Array<VetsourceRevenueCategoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<VetsourceRevenueCategoryScalarWhereInput>>;
  disconnect?: Maybe<Array<VetsourceRevenueCategoryWhereUniqueInput>>;
  set?: Maybe<Array<VetsourceRevenueCategoryWhereUniqueInput>>;
  update?: Maybe<Array<VetsourceRevenueCategoryUpdateWithWhereUniqueWithoutParentVetsourceRevenueCategoryInput>>;
  updateMany?: Maybe<Array<VetsourceRevenueCategoryUpdateManyWithWhereWithoutParentVetsourceRevenueCategoryInput>>;
  upsert?: Maybe<Array<VetsourceRevenueCategoryUpsertWithWhereUniqueWithoutParentVetsourceRevenueCategoryInput>>;
};

export type VetsourceRevenueCategoryUpdateOneWithoutChildrenVetsourceRevenueCategoryNestedInput = {
  connect?: Maybe<VetsourceRevenueCategoryWhereUniqueInput>;
  connectOrCreate?: Maybe<VetsourceRevenueCategoryCreateOrConnectWithoutChildrenVetsourceRevenueCategoryInput>;
  create?: Maybe<VetsourceRevenueCategoryCreateWithoutChildrenVetsourceRevenueCategoryInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<VetsourceRevenueCategoryUpdateToOneWithWhereWithoutChildrenVetsourceRevenueCategoryInput>;
  upsert?: Maybe<VetsourceRevenueCategoryUpsertWithoutChildrenVetsourceRevenueCategoryInput>;
};

export type VetsourceRevenueCategoryUpdateOneWithoutServiceNestedInput = {
  connect?: Maybe<VetsourceRevenueCategoryWhereUniqueInput>;
  connectOrCreate?: Maybe<VetsourceRevenueCategoryCreateOrConnectWithoutServiceInput>;
  create?: Maybe<VetsourceRevenueCategoryCreateWithoutServiceInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<VetsourceRevenueCategoryUpdateToOneWithWhereWithoutServiceInput>;
  upsert?: Maybe<VetsourceRevenueCategoryUpsertWithoutServiceInput>;
};

export type VetsourceRevenueCategoryUpdateToOneWithWhereWithoutChildrenVetsourceRevenueCategoryInput = {
  data: VetsourceRevenueCategoryUpdateWithoutChildrenVetsourceRevenueCategoryInput;
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};

export type VetsourceRevenueCategoryUpdateToOneWithWhereWithoutServiceInput = {
  data: VetsourceRevenueCategoryUpdateWithoutServiceInput;
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};

export type VetsourceRevenueCategoryUpdateWithWhereUniqueWithoutParentVetsourceRevenueCategoryInput = {
  data: VetsourceRevenueCategoryUpdateWithoutParentVetsourceRevenueCategoryInput;
  where: VetsourceRevenueCategoryWhereUniqueInput;
};

export type VetsourceRevenueCategoryUpdateWithoutChildrenVetsourceRevenueCategoryInput = {
  Service?: Maybe<ServiceUpdateManyWithoutVetsourceRevenueCategoryNestedInput>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutChildrenVetsourceRevenueCategoryNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUpdateWithoutParentVetsourceRevenueCategoryInput = {
  Service?: Maybe<ServiceUpdateManyWithoutVetsourceRevenueCategoryNestedInput>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateManyWithoutParentVetsourceRevenueCategoryNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUpdateWithoutServiceInput = {
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['Int']>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateManyWithoutParentVetsourceRevenueCategoryNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryUpdateOneWithoutChildrenVetsourceRevenueCategoryNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetsourceRevenueCategoryUpsertWithWhereUniqueWithoutParentVetsourceRevenueCategoryInput = {
  create: VetsourceRevenueCategoryCreateWithoutParentVetsourceRevenueCategoryInput;
  update: VetsourceRevenueCategoryUpdateWithoutParentVetsourceRevenueCategoryInput;
  where: VetsourceRevenueCategoryWhereUniqueInput;
};

export type VetsourceRevenueCategoryUpsertWithoutChildrenVetsourceRevenueCategoryInput = {
  create: VetsourceRevenueCategoryCreateWithoutChildrenVetsourceRevenueCategoryInput;
  update: VetsourceRevenueCategoryUpdateWithoutChildrenVetsourceRevenueCategoryInput;
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};

export type VetsourceRevenueCategoryUpsertWithoutServiceInput = {
  create: VetsourceRevenueCategoryCreateWithoutServiceInput;
  update: VetsourceRevenueCategoryUpdateWithoutServiceInput;
  where?: Maybe<VetsourceRevenueCategoryWhereInput>;
};

export type VetsourceRevenueCategoryWhereInput = {
  AND?: Maybe<Array<VetsourceRevenueCategoryWhereInput>>;
  NOT?: Maybe<Array<VetsourceRevenueCategoryWhereInput>>;
  OR?: Maybe<Array<VetsourceRevenueCategoryWhereInput>>;
  Service?: Maybe<ServiceListRelationFilter>;
  accountName?: Maybe<StringNullableFilter>;
  accountNumber?: Maybe<IntNullableFilter>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  externalId?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryNullableScalarRelationFilter>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetsourceRevenueCategoryWhereUniqueInput = {
  AND?: Maybe<Array<VetsourceRevenueCategoryWhereInput>>;
  NOT?: Maybe<Array<VetsourceRevenueCategoryWhereInput>>;
  OR?: Maybe<Array<VetsourceRevenueCategoryWhereInput>>;
  Service?: Maybe<ServiceListRelationFilter>;
  accountName?: Maybe<StringNullableFilter>;
  accountNumber?: Maybe<IntNullableFilter>;
  childrenVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentVetsourceRevenueCategory?: Maybe<VetsourceRevenueCategoryNullableScalarRelationFilter>;
  parentVetsourceRevenueCategoryExternalId?: Maybe<IntNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetterIntegration = {
  __typename?: 'VetterIntegration';
  apiKey: Scalars['String'];
  clinicPimsIntegration?: Maybe<ClinicPimsIntegration>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type VetterIntegrationClinicPimsIntegrationArgs = {
  where?: Maybe<ClinicPimsIntegrationWhereInput>;
};

export type VetterIntegrationCountAggregateOutputType = {
  __typename?: 'VetterIntegrationCountAggregateOutputType';
  _all: Scalars['Int'];
  apiKey: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type VetterIntegrationCountOrderByAggregateInput = {
  apiKey?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetterIntegrationCreateInput = {
  apiKey: Scalars['String'];
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationCreateNestedOneWithoutVetterInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationCreateManyInput = {
  apiKey: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationCreateNestedOneWithoutClinicPimsIntegrationInput = {
  connect?: Maybe<VetterIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<VetterIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<VetterIntegrationCreateWithoutClinicPimsIntegrationInput>;
};

export type VetterIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput = {
  create: VetterIntegrationCreateWithoutClinicPimsIntegrationInput;
  where: VetterIntegrationWhereUniqueInput;
};

export type VetterIntegrationCreateWithoutClinicPimsIntegrationInput = {
  apiKey: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationGroupByOutputType = {
  __typename?: 'VetterIntegrationGroupByOutputType';
  _count?: Maybe<VetterIntegrationCountAggregateOutputType>;
  _max?: Maybe<VetterIntegrationMaxAggregateOutputType>;
  _min?: Maybe<VetterIntegrationMinAggregateOutputType>;
  apiKey: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type VetterIntegrationMaxAggregateOutputType = {
  __typename?: 'VetterIntegrationMaxAggregateOutputType';
  apiKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationMaxOrderByAggregateInput = {
  apiKey?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetterIntegrationMinAggregateOutputType = {
  __typename?: 'VetterIntegrationMinAggregateOutputType';
  apiKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationMinOrderByAggregateInput = {
  apiKey?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetterIntegrationNullableScalarRelationFilter = {
  AND?: Maybe<Array<VetterIntegrationWhereInput>>;
  NOT?: Maybe<Array<VetterIntegrationWhereInput>>;
  OR?: Maybe<Array<VetterIntegrationWhereInput>>;
  apiKey?: Maybe<StringFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetterIntegrationOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetterIntegrationOrderByRelevanceInput>;
  apiKey?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum VetterIntegrationOrderByRelevanceFieldEnum {
  ApiKey = 'apiKey',
  Id = 'id'
}

export type VetterIntegrationOrderByRelevanceInput = {
  fields: Array<VetterIntegrationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type VetterIntegrationOrderByWithAggregationInput = {
  _count?: Maybe<VetterIntegrationCountOrderByAggregateInput>;
  _max?: Maybe<VetterIntegrationMaxOrderByAggregateInput>;
  _min?: Maybe<VetterIntegrationMinOrderByAggregateInput>;
  apiKey?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetterIntegrationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<VetterIntegrationOrderByRelevanceInput>;
  apiKey?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type VetterIntegrationOrderByWithRelationInput = {
  _relevance?: Maybe<VetterIntegrationOrderByRelevanceInput>;
  apiKey?: Maybe<SortOrder>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum VetterIntegrationScalarFieldEnum {
  ApiKey = 'apiKey',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type VetterIntegrationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<VetterIntegrationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<VetterIntegrationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<VetterIntegrationScalarWhereWithAggregatesInput>>;
  apiKey?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type VetterIntegrationUncheckedCreateInput = {
  apiKey: Scalars['String'];
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedCreateNestedOneWithoutVetterInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationUncheckedCreateWithoutClinicPimsIntegrationInput = {
  apiKey: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationUncheckedUpdateInput = {
  apiKey?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUncheckedUpdateOneWithoutVetterNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationUncheckedUpdateManyInput = {
  apiKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationUncheckedUpdateWithoutClinicPimsIntegrationInput = {
  apiKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationUpdateInput = {
  apiKey?: Maybe<Scalars['String']>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationUpdateOneWithoutVetterNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationUpdateManyMutationInput = {
  apiKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationUpdateOneWithoutClinicPimsIntegrationNestedInput = {
  connect?: Maybe<VetterIntegrationWhereUniqueInput>;
  connectOrCreate?: Maybe<VetterIntegrationCreateOrConnectWithoutClinicPimsIntegrationInput>;
  create?: Maybe<VetterIntegrationCreateWithoutClinicPimsIntegrationInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<VetterIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput>;
  upsert?: Maybe<VetterIntegrationUpsertWithoutClinicPimsIntegrationInput>;
};

export type VetterIntegrationUpdateToOneWithWhereWithoutClinicPimsIntegrationInput = {
  data: VetterIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<VetterIntegrationWhereInput>;
};

export type VetterIntegrationUpdateWithoutClinicPimsIntegrationInput = {
  apiKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VetterIntegrationUpsertWithoutClinicPimsIntegrationInput = {
  create: VetterIntegrationCreateWithoutClinicPimsIntegrationInput;
  update: VetterIntegrationUpdateWithoutClinicPimsIntegrationInput;
  where?: Maybe<VetterIntegrationWhereInput>;
};

export type VetterIntegrationWhereInput = {
  AND?: Maybe<Array<VetterIntegrationWhereInput>>;
  NOT?: Maybe<Array<VetterIntegrationWhereInput>>;
  OR?: Maybe<Array<VetterIntegrationWhereInput>>;
  apiKey?: Maybe<StringFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VetterIntegrationWhereUniqueInput = {
  AND?: Maybe<Array<VetterIntegrationWhereInput>>;
  NOT?: Maybe<Array<VetterIntegrationWhereInput>>;
  OR?: Maybe<Array<VetterIntegrationWhereInput>>;
  apiKey?: Maybe<StringFilter>;
  clinicPimsIntegration?: Maybe<ClinicPimsIntegrationNullableScalarRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type VideoCallRecordingToggleInput = {
  roomSid: Scalars['String'];
  status: RecordingControlStatus;
};

export type WidgetClinicPetParentLookupInput = {
  clinicId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  petName?: Maybe<Scalars['String']>;
  petParentFirstName?: Maybe<Scalars['String']>;
  petParentId?: Maybe<Scalars['String']>;
  petParentLastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type WidgetClinicPetParentLookupResponse = {
  __typename?: 'WidgetClinicPetParentLookupResponse';
  createdAt?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<ClinicEntityCreationSource>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  pets: Array<ClinicPet>;
  phoneNumbers: Array<ClinicEntityPhoneNumber>;
  pimsId?: Maybe<Scalars['String']>;
};

export enum WidgetRequestType {
  AdvancedRequestRxRefill = 'AdvancedRequestRxRefill',
  DirectBooking = 'DirectBooking',
  InboundSms = 'InboundSms',
  LiveAgent = 'LiveAgent',
  RequestAppointment = 'RequestAppointment',
  RequestBoarding = 'RequestBoarding',
  RequestGroomingAppoinment = 'RequestGroomingAppoinment',
  RequestMedicalRecords = 'RequestMedicalRecords',
  RequestRxRefill = 'RequestRxRefill',
  RequestVirtualConsult = 'RequestVirtualConsult',
  TalkToStaff = 'TalkToStaff',
  Teletriage = 'Teletriage'
}

export enum WidgetVisibility {
  Always = 'Always',
  ClinicClosed = 'ClinicClosed',
  ClinicOpen = 'ClinicOpen'
}

export enum WorkflowActionType {
  ConversationMessageTemplate = 'Conversation_MessageTemplate',
  ConversationStatusChange = 'Conversation_StatusChange',
  ConversationSystemMessage = 'Conversation_SystemMessage',
  WorkflowEventTrigger = 'WorkflowEvent_Trigger'
}

export enum WorkflowEvent {
  AppointmentClientArrival = 'Appointment_ClientArrival',
  AppointmentConfirmReminder = 'Appointment_ConfirmReminder',
  AppointmentFollowup = 'Appointment_Followup',
  AppointmentPimsSync = 'Appointment_Pims_Sync',
  AppointmentReminder = 'Appointment_Reminder',
  AppointmentScheduled = 'Appointment_Scheduled',
  CallDeflectionFormSubmitted = 'CallDeflection_FormSubmitted',
  InvoiceLineItemCreated = 'InvoiceLineItem_Created',
  LapsedPetParent = 'LapsedPetParent',
  ServiceReminderFormSubmitted = 'ServiceReminder_FormSubmitted',
  WidgetRequestFormSubmitted = 'WidgetRequest_FormSubmitted'
}

export type WorkflowEventAction = {
  __typename?: 'WorkflowEventAction';
  _count: WorkflowEventActionCountOutputType;
  actionType: WorkflowActionType;
  automationRunActions: Array<AutomationRunAction>;
  channelAutomationStatuses: Array<ChannelAutomationStatus>;
  channelStatusChange?: Maybe<ChannelStatus>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels: Array<Channel>;
  config: Scalars['Json'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  order: Scalars['Int'];
  promptType: AutomationRunActionPromptType;
  responseChannelStatusChange?: Maybe<ChannelStatus>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns: Array<AutomationRun>;
  triggerWorkflow?: Maybe<WorkflowEventSetting>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  workflowEventSetting?: Maybe<WorkflowEventSetting>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};


export type WorkflowEventActionAutomationRunActionsArgs = {
  cursor?: Maybe<AutomationRunActionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunActionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunActionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunActionWhereInput>;
};


export type WorkflowEventActionChannelAutomationStatusesArgs = {
  cursor?: Maybe<ChannelAutomationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelAutomationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelAutomationStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type WorkflowEventActionChannelStatusChangeArgs = {
  where?: Maybe<ChannelStatusWhereInput>;
};


export type WorkflowEventActionChannelsArgs = {
  cursor?: Maybe<ChannelWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelWhereInput>;
};


export type WorkflowEventActionResponseChannelStatusChangeArgs = {
  where?: Maybe<ChannelStatusWhereInput>;
};


export type WorkflowEventActionReturnedAutomationRunsArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type WorkflowEventActionTriggerWorkflowArgs = {
  where?: Maybe<WorkflowEventSettingWhereInput>;
};


export type WorkflowEventActionWorkflowEventSettingArgs = {
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventActionAvgAggregateOutputType = {
  __typename?: 'WorkflowEventActionAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Float']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Float']>;
};

export type WorkflowEventActionAvgOrderByAggregateInput = {
  order?: Maybe<SortOrder>;
  workflowEventTriggerActionNumber?: Maybe<SortOrder>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<SortOrder>;
};

export type WorkflowEventActionCountAggregateOutputType = {
  __typename?: 'WorkflowEventActionCountAggregateOutputType';
  _all: Scalars['Int'];
  actionType: Scalars['Int'];
  channelStatusChangeId: Scalars['Int'];
  config: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  promptType: Scalars['Int'];
  responseChannelStatusChangeId: Scalars['Int'];
  triggerWorkflowId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  workflowEventSettingId: Scalars['Int'];
  workflowEventTrigger: Scalars['Int'];
  workflowEventTriggerActionNumber: Scalars['Int'];
  workflowEventTriggerDelayInMilliseconds: Scalars['Int'];
};

export type WorkflowEventActionCountOrderByAggregateInput = {
  actionType?: Maybe<SortOrder>;
  channelStatusChangeId?: Maybe<SortOrder>;
  config?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  responseChannelStatusChangeId?: Maybe<SortOrder>;
  triggerWorkflowId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
  workflowEventTrigger?: Maybe<SortOrder>;
  workflowEventTriggerActionNumber?: Maybe<SortOrder>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<SortOrder>;
};

export type WorkflowEventActionCountOutputType = {
  __typename?: 'WorkflowEventActionCountOutputType';
  automationRunActions: Scalars['Int'];
  channelAutomationStatuses: Scalars['Int'];
  channels: Scalars['Int'];
  returnedAutomationRuns: Scalars['Int'];
};

export type WorkflowEventActionCreateInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventActionInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutResponseWorkflowEventActionsInput>;
  returnedAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingCreateNestedOneWithoutWorkflowEventActionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutActionsInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateManyChannelStatusChangeInput = {
  actionType: WorkflowActionType;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateManyChannelStatusChangeInputEnvelope = {
  data: Array<WorkflowEventActionCreateManyChannelStatusChangeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type WorkflowEventActionCreateManyInput = {
  actionType: WorkflowActionType;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateManyResponseChannelStatusChangeInput = {
  actionType: WorkflowActionType;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateManyResponseChannelStatusChangeInputEnvelope = {
  data: Array<WorkflowEventActionCreateManyResponseChannelStatusChangeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type WorkflowEventActionCreateManyTriggerWorkflowInput = {
  actionType: WorkflowActionType;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateManyTriggerWorkflowInputEnvelope = {
  data: Array<WorkflowEventActionCreateManyTriggerWorkflowInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type WorkflowEventActionCreateManyWorkflowEventSettingInput = {
  actionType: WorkflowActionType;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateManyWorkflowEventSettingInputEnvelope = {
  data: Array<WorkflowEventActionCreateManyWorkflowEventSettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type WorkflowEventActionCreateNestedManyWithoutChannelStatusChangeInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutChannelStatusChangeInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutChannelStatusChangeInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyChannelStatusChangeInputEnvelope>;
};

export type WorkflowEventActionCreateNestedManyWithoutResponseChannelStatusChangeInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutResponseChannelStatusChangeInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutResponseChannelStatusChangeInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyResponseChannelStatusChangeInputEnvelope>;
};

export type WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutTriggerWorkflowInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutTriggerWorkflowInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyTriggerWorkflowInputEnvelope>;
};

export type WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyWorkflowEventSettingInputEnvelope>;
};

export type WorkflowEventActionCreateNestedOneWithoutAutomationRunActionsInput = {
  connect?: Maybe<WorkflowEventActionWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventActionCreateOrConnectWithoutAutomationRunActionsInput>;
  create?: Maybe<WorkflowEventActionCreateWithoutAutomationRunActionsInput>;
};

export type WorkflowEventActionCreateNestedOneWithoutChannelAutomationStatusesInput = {
  connect?: Maybe<WorkflowEventActionWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventActionCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<WorkflowEventActionCreateWithoutChannelAutomationStatusesInput>;
};

export type WorkflowEventActionCreateNestedOneWithoutChannelsInput = {
  connect?: Maybe<WorkflowEventActionWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventActionCreateOrConnectWithoutChannelsInput>;
  create?: Maybe<WorkflowEventActionCreateWithoutChannelsInput>;
};

export type WorkflowEventActionCreateNestedOneWithoutReturnedAutomationRunsInput = {
  connect?: Maybe<WorkflowEventActionWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventActionCreateOrConnectWithoutReturnedAutomationRunsInput>;
  create?: Maybe<WorkflowEventActionCreateWithoutReturnedAutomationRunsInput>;
};

export type WorkflowEventActionCreateOrConnectWithoutAutomationRunActionsInput = {
  create: WorkflowEventActionCreateWithoutAutomationRunActionsInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionCreateOrConnectWithoutChannelAutomationStatusesInput = {
  create: WorkflowEventActionCreateWithoutChannelAutomationStatusesInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionCreateOrConnectWithoutChannelStatusChangeInput = {
  create: WorkflowEventActionCreateWithoutChannelStatusChangeInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionCreateOrConnectWithoutChannelsInput = {
  create: WorkflowEventActionCreateWithoutChannelsInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionCreateOrConnectWithoutResponseChannelStatusChangeInput = {
  create: WorkflowEventActionCreateWithoutResponseChannelStatusChangeInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionCreateOrConnectWithoutReturnedAutomationRunsInput = {
  create: WorkflowEventActionCreateWithoutReturnedAutomationRunsInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionCreateOrConnectWithoutTriggerWorkflowInput = {
  create: WorkflowEventActionCreateWithoutTriggerWorkflowInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionCreateOrConnectWithoutWorkflowEventSettingInput = {
  create: WorkflowEventActionCreateWithoutWorkflowEventSettingInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionCreateWithoutAutomationRunActionsInput = {
  actionType: WorkflowActionType;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventActionInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutResponseWorkflowEventActionsInput>;
  returnedAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingCreateNestedOneWithoutWorkflowEventActionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutActionsInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateWithoutChannelAutomationStatusesInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationActionInput>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventActionInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutResponseWorkflowEventActionsInput>;
  returnedAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingCreateNestedOneWithoutWorkflowEventActionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutActionsInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateWithoutChannelStatusChangeInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutResponseWorkflowEventActionsInput>;
  returnedAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingCreateNestedOneWithoutWorkflowEventActionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutActionsInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateWithoutChannelsInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutResponseWorkflowEventActionsInput>;
  returnedAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingCreateNestedOneWithoutWorkflowEventActionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutActionsInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateWithoutResponseChannelStatusChangeInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventActionInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  returnedAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingCreateNestedOneWithoutWorkflowEventActionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutActionsInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateWithoutReturnedAutomationRunsInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventActionInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutResponseWorkflowEventActionsInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingCreateNestedOneWithoutWorkflowEventActionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutActionsInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateWithoutTriggerWorkflowInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventActionInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutResponseWorkflowEventActionsInput>;
  returnedAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutReturnToAutomationActionInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingCreateNestedOneWithoutActionsInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionCreateWithoutWorkflowEventSettingInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventActionInput>;
  channels?: Maybe<ChannelCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutResponseWorkflowEventActionsInput>;
  returnedAutomationRuns?: Maybe<AutomationRunCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingCreateNestedOneWithoutWorkflowEventActionsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionGroupByOutputType = {
  __typename?: 'WorkflowEventActionGroupByOutputType';
  _avg?: Maybe<WorkflowEventActionAvgAggregateOutputType>;
  _count?: Maybe<WorkflowEventActionCountAggregateOutputType>;
  _max?: Maybe<WorkflowEventActionMaxAggregateOutputType>;
  _min?: Maybe<WorkflowEventActionMinAggregateOutputType>;
  _sum?: Maybe<WorkflowEventActionSumAggregateOutputType>;
  actionType: WorkflowActionType;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  config: Scalars['Json'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  order: Scalars['Int'];
  promptType: AutomationRunActionPromptType;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionListRelationFilter = {
  every?: Maybe<WorkflowEventActionWhereInput>;
  none?: Maybe<WorkflowEventActionWhereInput>;
  some?: Maybe<WorkflowEventActionWhereInput>;
};

export type WorkflowEventActionMaxAggregateOutputType = {
  __typename?: 'WorkflowEventActionMaxAggregateOutputType';
  actionType?: Maybe<WorkflowActionType>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionMaxOrderByAggregateInput = {
  actionType?: Maybe<SortOrder>;
  channelStatusChangeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  responseChannelStatusChangeId?: Maybe<SortOrder>;
  triggerWorkflowId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
  workflowEventTrigger?: Maybe<SortOrder>;
  workflowEventTriggerActionNumber?: Maybe<SortOrder>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<SortOrder>;
};

export type WorkflowEventActionMinAggregateOutputType = {
  __typename?: 'WorkflowEventActionMinAggregateOutputType';
  actionType?: Maybe<WorkflowActionType>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionMinOrderByAggregateInput = {
  actionType?: Maybe<SortOrder>;
  channelStatusChangeId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  responseChannelStatusChangeId?: Maybe<SortOrder>;
  triggerWorkflowId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
  workflowEventTrigger?: Maybe<SortOrder>;
  workflowEventTriggerActionNumber?: Maybe<SortOrder>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<SortOrder>;
};

export type WorkflowEventActionNullableScalarRelationFilter = {
  AND?: Maybe<Array<WorkflowEventActionWhereInput>>;
  NOT?: Maybe<Array<WorkflowEventActionWhereInput>>;
  OR?: Maybe<Array<WorkflowEventActionWhereInput>>;
  actionType?: Maybe<EnumWorkflowActionTypeFilter>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusChangeId?: Maybe<StringNullableFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  config?: Maybe<JsonFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  order?: Maybe<IntFilter>;
  promptType?: Maybe<EnumAutomationRunActionPromptTypeFilter>;
  responseChannelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  responseChannelStatusChangeId?: Maybe<StringNullableFilter>;
  returnedAutomationRuns?: Maybe<AutomationRunListRelationFilter>;
  triggerWorkflow?: Maybe<WorkflowEventSettingNullableScalarRelationFilter>;
  triggerWorkflowId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSetting?: Maybe<WorkflowEventSettingNullableScalarRelationFilter>;
  workflowEventSettingId?: Maybe<StringNullableFilter>;
  workflowEventTrigger?: Maybe<StringNullableFilter>;
  workflowEventTriggerActionNumber?: Maybe<IntNullableFilter>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<IntNullableFilter>;
};

export type WorkflowEventActionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type WorkflowEventActionOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<WorkflowEventActionOrderByRelevanceInput>;
  actionType?: Maybe<SortOrder>;
  automationRunActions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelStatusChange?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusChangeId?: Maybe<SortOrder>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  config?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  responseChannelStatusChange?: Maybe<ChannelStatusOrderByWithRelationInput>;
  responseChannelStatusChangeId?: Maybe<SortOrder>;
  returnedAutomationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  triggerWorkflowId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSetting?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowEventSettingId?: Maybe<SortOrder>;
  workflowEventTrigger?: Maybe<SortOrder>;
  workflowEventTriggerActionNumber?: Maybe<SortOrder>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<SortOrder>;
};

export enum WorkflowEventActionOrderByRelevanceFieldEnum {
  ChannelStatusChangeId = 'channelStatusChangeId',
  Id = 'id',
  ResponseChannelStatusChangeId = 'responseChannelStatusChangeId',
  TriggerWorkflowId = 'triggerWorkflowId',
  WorkflowEventSettingId = 'workflowEventSettingId',
  WorkflowEventTrigger = 'workflowEventTrigger'
}

export type WorkflowEventActionOrderByRelevanceInput = {
  fields: Array<WorkflowEventActionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type WorkflowEventActionOrderByWithAggregationInput = {
  _avg?: Maybe<WorkflowEventActionAvgOrderByAggregateInput>;
  _count?: Maybe<WorkflowEventActionCountOrderByAggregateInput>;
  _max?: Maybe<WorkflowEventActionMaxOrderByAggregateInput>;
  _min?: Maybe<WorkflowEventActionMinOrderByAggregateInput>;
  _sum?: Maybe<WorkflowEventActionSumOrderByAggregateInput>;
  actionType?: Maybe<SortOrder>;
  channelStatusChangeId?: Maybe<SortOrder>;
  config?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  responseChannelStatusChangeId?: Maybe<SortOrder>;
  triggerWorkflowId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSettingId?: Maybe<SortOrder>;
  workflowEventTrigger?: Maybe<SortOrder>;
  workflowEventTriggerActionNumber?: Maybe<SortOrder>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<SortOrder>;
};

export type WorkflowEventActionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<WorkflowEventActionOrderByRelevanceInput>;
  actionType?: Maybe<SortOrder>;
  automationRunActions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelStatusChange?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusChangeId?: Maybe<SortOrder>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  config?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  responseChannelStatusChange?: Maybe<ChannelStatusOrderByWithRelationInput>;
  responseChannelStatusChangeId?: Maybe<SortOrder>;
  returnedAutomationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  triggerWorkflowId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSetting?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowEventSettingId?: Maybe<SortOrder>;
  workflowEventTrigger?: Maybe<SortOrder>;
  workflowEventTriggerActionNumber?: Maybe<SortOrder>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<SortOrder>;
};

export type WorkflowEventActionOrderByWithRelationInput = {
  _relevance?: Maybe<WorkflowEventActionOrderByRelevanceInput>;
  actionType?: Maybe<SortOrder>;
  automationRunActions?: Maybe<AutomationRunActionOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelStatusChange?: Maybe<ChannelStatusOrderByWithRelationInput>;
  channelStatusChangeId?: Maybe<SortOrder>;
  channels?: Maybe<ChannelOrderByRelationAggregateInput>;
  config?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
  promptType?: Maybe<SortOrder>;
  responseChannelStatusChange?: Maybe<ChannelStatusOrderByWithRelationInput>;
  responseChannelStatusChangeId?: Maybe<SortOrder>;
  returnedAutomationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  triggerWorkflowId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowEventSetting?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowEventSettingId?: Maybe<SortOrder>;
  workflowEventTrigger?: Maybe<SortOrder>;
  workflowEventTriggerActionNumber?: Maybe<SortOrder>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<SortOrder>;
};

export enum WorkflowEventActionScalarFieldEnum {
  ActionType = 'actionType',
  ChannelStatusChangeId = 'channelStatusChangeId',
  Config = 'config',
  CreatedAt = 'createdAt',
  Id = 'id',
  Order = 'order',
  PromptType = 'promptType',
  ResponseChannelStatusChangeId = 'responseChannelStatusChangeId',
  TriggerWorkflowId = 'triggerWorkflowId',
  UpdatedAt = 'updatedAt',
  WorkflowEventSettingId = 'workflowEventSettingId',
  WorkflowEventTrigger = 'workflowEventTrigger',
  WorkflowEventTriggerActionNumber = 'workflowEventTriggerActionNumber',
  WorkflowEventTriggerDelayInMilliseconds = 'workflowEventTriggerDelayInMilliseconds'
}

export type WorkflowEventActionScalarWhereInput = {
  AND?: Maybe<Array<WorkflowEventActionScalarWhereInput>>;
  NOT?: Maybe<Array<WorkflowEventActionScalarWhereInput>>;
  OR?: Maybe<Array<WorkflowEventActionScalarWhereInput>>;
  actionType?: Maybe<EnumWorkflowActionTypeFilter>;
  channelStatusChangeId?: Maybe<StringNullableFilter>;
  config?: Maybe<JsonFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  order?: Maybe<IntFilter>;
  promptType?: Maybe<EnumAutomationRunActionPromptTypeFilter>;
  responseChannelStatusChangeId?: Maybe<StringNullableFilter>;
  triggerWorkflowId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSettingId?: Maybe<StringNullableFilter>;
  workflowEventTrigger?: Maybe<StringNullableFilter>;
  workflowEventTriggerActionNumber?: Maybe<IntNullableFilter>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<IntNullableFilter>;
};

export type WorkflowEventActionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<WorkflowEventActionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<WorkflowEventActionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<WorkflowEventActionScalarWhereWithAggregatesInput>>;
  actionType?: Maybe<EnumWorkflowActionTypeWithAggregatesFilter>;
  channelStatusChangeId?: Maybe<StringNullableWithAggregatesFilter>;
  config?: Maybe<JsonWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  order?: Maybe<IntWithAggregatesFilter>;
  promptType?: Maybe<EnumAutomationRunActionPromptTypeWithAggregatesFilter>;
  responseChannelStatusChangeId?: Maybe<StringNullableWithAggregatesFilter>;
  triggerWorkflowId?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  workflowEventSettingId?: Maybe<StringNullableWithAggregatesFilter>;
  workflowEventTrigger?: Maybe<StringNullableWithAggregatesFilter>;
  workflowEventTriggerActionNumber?: Maybe<IntNullableWithAggregatesFilter>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<IntNullableWithAggregatesFilter>;
};

export type WorkflowEventActionSumAggregateOutputType = {
  __typename?: 'WorkflowEventActionSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionSumOrderByAggregateInput = {
  order?: Maybe<SortOrder>;
  workflowEventTriggerActionNumber?: Maybe<SortOrder>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<SortOrder>;
};

export type WorkflowEventActionUncheckedCreateInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedCreateNestedManyWithoutChannelStatusChangeInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutChannelStatusChangeInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutChannelStatusChangeInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyChannelStatusChangeInputEnvelope>;
};

export type WorkflowEventActionUncheckedCreateNestedManyWithoutResponseChannelStatusChangeInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutResponseChannelStatusChangeInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutResponseChannelStatusChangeInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyResponseChannelStatusChangeInputEnvelope>;
};

export type WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutTriggerWorkflowInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutTriggerWorkflowInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyTriggerWorkflowInputEnvelope>;
};

export type WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyWorkflowEventSettingInputEnvelope>;
};

export type WorkflowEventActionUncheckedCreateWithoutAutomationRunActionsInput = {
  actionType: WorkflowActionType;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedCreateWithoutChannelAutomationStatusesInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationActionInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedCreateWithoutChannelStatusChangeInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedCreateWithoutChannelsInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedCreateWithoutResponseChannelStatusChangeInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedCreateWithoutReturnedAutomationRunsInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedCreateWithoutTriggerWorkflowInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutReturnToAutomationActionInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedCreateWithoutWorkflowEventSettingInput = {
  actionType: WorkflowActionType;
  automationRunActions?: Maybe<AutomationRunActionUncheckedCreateNestedManyWithoutAutomationActionInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutCurrentWorkflowEventActionInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedCreateNestedManyWithoutCurrentWorkflowActionInput>;
  config: Scalars['Json'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutReturnToAutomationActionInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateManyInput = {
  actionType?: Maybe<WorkflowActionType>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeInput = {
  actionType?: Maybe<WorkflowActionType>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateManyWithoutChannelStatusChangeNestedInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutChannelStatusChangeInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutChannelStatusChangeInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyChannelStatusChangeInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventActionScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventActionUpdateWithWhereUniqueWithoutChannelStatusChangeInput>>;
  updateMany?: Maybe<Array<WorkflowEventActionUpdateManyWithWhereWithoutChannelStatusChangeInput>>;
  upsert?: Maybe<Array<WorkflowEventActionUpsertWithWhereUniqueWithoutChannelStatusChangeInput>>;
};

export type WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeInput = {
  actionType?: Maybe<WorkflowActionType>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateManyWithoutResponseChannelStatusChangeNestedInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutResponseChannelStatusChangeInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutResponseChannelStatusChangeInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyResponseChannelStatusChangeInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventActionScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventActionUpdateWithWhereUniqueWithoutResponseChannelStatusChangeInput>>;
  updateMany?: Maybe<Array<WorkflowEventActionUpdateManyWithWhereWithoutResponseChannelStatusChangeInput>>;
  upsert?: Maybe<Array<WorkflowEventActionUpsertWithWhereUniqueWithoutResponseChannelStatusChangeInput>>;
};

export type WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowInput = {
  actionType?: Maybe<WorkflowActionType>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutTriggerWorkflowInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutTriggerWorkflowInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyTriggerWorkflowInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventActionScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventActionUpdateWithWhereUniqueWithoutTriggerWorkflowInput>>;
  updateMany?: Maybe<Array<WorkflowEventActionUpdateManyWithWhereWithoutTriggerWorkflowInput>>;
  upsert?: Maybe<Array<WorkflowEventActionUpsertWithWhereUniqueWithoutTriggerWorkflowInput>>;
};

export type WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingInput = {
  actionType?: Maybe<WorkflowActionType>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyWorkflowEventSettingInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventActionScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventActionUpdateWithWhereUniqueWithoutWorkflowEventSettingInput>>;
  updateMany?: Maybe<Array<WorkflowEventActionUpdateManyWithWhereWithoutWorkflowEventSettingInput>>;
  upsert?: Maybe<Array<WorkflowEventActionUpsertWithWhereUniqueWithoutWorkflowEventSettingInput>>;
};

export type WorkflowEventActionUncheckedUpdateWithoutAutomationRunActionsInput = {
  actionType?: Maybe<WorkflowActionType>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateWithoutChannelAutomationStatusesInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationActionNestedInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateWithoutChannelStatusChangeInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateWithoutChannelsInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateWithoutResponseChannelStatusChangeInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateWithoutReturnedAutomationRunsInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateWithoutTriggerWorkflowInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutReturnToAutomationActionNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSettingId?: Maybe<Scalars['String']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUncheckedUpdateWithoutWorkflowEventSettingInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUncheckedUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChangeId?: Maybe<Scalars['String']>;
  channels?: Maybe<ChannelUncheckedUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChangeId?: Maybe<Scalars['String']>;
  returnedAutomationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflowId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUpdateInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventActionNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutResponseWorkflowEventActionsNestedInput>;
  returnedAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingUpdateOneWithoutWorkflowEventActionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutActionsNestedInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUpdateManyMutationInput = {
  actionType?: Maybe<WorkflowActionType>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUpdateManyWithWhereWithoutChannelStatusChangeInput = {
  data: WorkflowEventActionUpdateManyMutationInput;
  where: WorkflowEventActionScalarWhereInput;
};

export type WorkflowEventActionUpdateManyWithWhereWithoutResponseChannelStatusChangeInput = {
  data: WorkflowEventActionUpdateManyMutationInput;
  where: WorkflowEventActionScalarWhereInput;
};

export type WorkflowEventActionUpdateManyWithWhereWithoutTriggerWorkflowInput = {
  data: WorkflowEventActionUpdateManyMutationInput;
  where: WorkflowEventActionScalarWhereInput;
};

export type WorkflowEventActionUpdateManyWithWhereWithoutWorkflowEventSettingInput = {
  data: WorkflowEventActionUpdateManyMutationInput;
  where: WorkflowEventActionScalarWhereInput;
};

export type WorkflowEventActionUpdateManyWithoutChannelStatusChangeNestedInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutChannelStatusChangeInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutChannelStatusChangeInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyChannelStatusChangeInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventActionScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventActionUpdateWithWhereUniqueWithoutChannelStatusChangeInput>>;
  updateMany?: Maybe<Array<WorkflowEventActionUpdateManyWithWhereWithoutChannelStatusChangeInput>>;
  upsert?: Maybe<Array<WorkflowEventActionUpsertWithWhereUniqueWithoutChannelStatusChangeInput>>;
};

export type WorkflowEventActionUpdateManyWithoutResponseChannelStatusChangeNestedInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutResponseChannelStatusChangeInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutResponseChannelStatusChangeInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyResponseChannelStatusChangeInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventActionScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventActionUpdateWithWhereUniqueWithoutResponseChannelStatusChangeInput>>;
  updateMany?: Maybe<Array<WorkflowEventActionUpdateManyWithWhereWithoutResponseChannelStatusChangeInput>>;
  upsert?: Maybe<Array<WorkflowEventActionUpsertWithWhereUniqueWithoutResponseChannelStatusChangeInput>>;
};

export type WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutTriggerWorkflowInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutTriggerWorkflowInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyTriggerWorkflowInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventActionScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventActionUpdateWithWhereUniqueWithoutTriggerWorkflowInput>>;
  updateMany?: Maybe<Array<WorkflowEventActionUpdateManyWithWhereWithoutTriggerWorkflowInput>>;
  upsert?: Maybe<Array<WorkflowEventActionUpsertWithWhereUniqueWithoutTriggerWorkflowInput>>;
};

export type WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput = {
  connect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventActionCreateOrConnectWithoutWorkflowEventSettingInput>>;
  create?: Maybe<Array<WorkflowEventActionCreateWithoutWorkflowEventSettingInput>>;
  createMany?: Maybe<WorkflowEventActionCreateManyWorkflowEventSettingInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventActionScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventActionWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventActionUpdateWithWhereUniqueWithoutWorkflowEventSettingInput>>;
  updateMany?: Maybe<Array<WorkflowEventActionUpdateManyWithWhereWithoutWorkflowEventSettingInput>>;
  upsert?: Maybe<Array<WorkflowEventActionUpsertWithWhereUniqueWithoutWorkflowEventSettingInput>>;
};

export type WorkflowEventActionUpdateOneWithoutAutomationRunActionsNestedInput = {
  connect?: Maybe<WorkflowEventActionWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventActionCreateOrConnectWithoutAutomationRunActionsInput>;
  create?: Maybe<WorkflowEventActionCreateWithoutAutomationRunActionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<WorkflowEventActionUpdateToOneWithWhereWithoutAutomationRunActionsInput>;
  upsert?: Maybe<WorkflowEventActionUpsertWithoutAutomationRunActionsInput>;
};

export type WorkflowEventActionUpdateOneWithoutChannelAutomationStatusesNestedInput = {
  connect?: Maybe<WorkflowEventActionWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventActionCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<WorkflowEventActionCreateWithoutChannelAutomationStatusesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<WorkflowEventActionUpdateToOneWithWhereWithoutChannelAutomationStatusesInput>;
  upsert?: Maybe<WorkflowEventActionUpsertWithoutChannelAutomationStatusesInput>;
};

export type WorkflowEventActionUpdateOneWithoutChannelsNestedInput = {
  connect?: Maybe<WorkflowEventActionWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventActionCreateOrConnectWithoutChannelsInput>;
  create?: Maybe<WorkflowEventActionCreateWithoutChannelsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<WorkflowEventActionUpdateToOneWithWhereWithoutChannelsInput>;
  upsert?: Maybe<WorkflowEventActionUpsertWithoutChannelsInput>;
};

export type WorkflowEventActionUpdateOneWithoutReturnedAutomationRunsNestedInput = {
  connect?: Maybe<WorkflowEventActionWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventActionCreateOrConnectWithoutReturnedAutomationRunsInput>;
  create?: Maybe<WorkflowEventActionCreateWithoutReturnedAutomationRunsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<WorkflowEventActionUpdateToOneWithWhereWithoutReturnedAutomationRunsInput>;
  upsert?: Maybe<WorkflowEventActionUpsertWithoutReturnedAutomationRunsInput>;
};

export type WorkflowEventActionUpdateToOneWithWhereWithoutAutomationRunActionsInput = {
  data: WorkflowEventActionUpdateWithoutAutomationRunActionsInput;
  where?: Maybe<WorkflowEventActionWhereInput>;
};

export type WorkflowEventActionUpdateToOneWithWhereWithoutChannelAutomationStatusesInput = {
  data: WorkflowEventActionUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<WorkflowEventActionWhereInput>;
};

export type WorkflowEventActionUpdateToOneWithWhereWithoutChannelsInput = {
  data: WorkflowEventActionUpdateWithoutChannelsInput;
  where?: Maybe<WorkflowEventActionWhereInput>;
};

export type WorkflowEventActionUpdateToOneWithWhereWithoutReturnedAutomationRunsInput = {
  data: WorkflowEventActionUpdateWithoutReturnedAutomationRunsInput;
  where?: Maybe<WorkflowEventActionWhereInput>;
};

export type WorkflowEventActionUpdateWithWhereUniqueWithoutChannelStatusChangeInput = {
  data: WorkflowEventActionUpdateWithoutChannelStatusChangeInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionUpdateWithWhereUniqueWithoutResponseChannelStatusChangeInput = {
  data: WorkflowEventActionUpdateWithoutResponseChannelStatusChangeInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionUpdateWithWhereUniqueWithoutTriggerWorkflowInput = {
  data: WorkflowEventActionUpdateWithoutTriggerWorkflowInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionUpdateWithWhereUniqueWithoutWorkflowEventSettingInput = {
  data: WorkflowEventActionUpdateWithoutWorkflowEventSettingInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionUpdateWithoutAutomationRunActionsInput = {
  actionType?: Maybe<WorkflowActionType>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventActionNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutResponseWorkflowEventActionsNestedInput>;
  returnedAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingUpdateOneWithoutWorkflowEventActionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutActionsNestedInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUpdateWithoutChannelAutomationStatusesInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationActionNestedInput>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventActionNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutResponseWorkflowEventActionsNestedInput>;
  returnedAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingUpdateOneWithoutWorkflowEventActionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutActionsNestedInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUpdateWithoutChannelStatusChangeInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutResponseWorkflowEventActionsNestedInput>;
  returnedAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingUpdateOneWithoutWorkflowEventActionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutActionsNestedInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUpdateWithoutChannelsInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutResponseWorkflowEventActionsNestedInput>;
  returnedAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingUpdateOneWithoutWorkflowEventActionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutActionsNestedInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUpdateWithoutResponseChannelStatusChangeInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventActionNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  returnedAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingUpdateOneWithoutWorkflowEventActionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutActionsNestedInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUpdateWithoutReturnedAutomationRunsInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventActionNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutResponseWorkflowEventActionsNestedInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingUpdateOneWithoutWorkflowEventActionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutActionsNestedInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUpdateWithoutTriggerWorkflowInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventActionNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutResponseWorkflowEventActionsNestedInput>;
  returnedAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutReturnToAutomationActionNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventSetting?: Maybe<WorkflowEventSettingUpdateOneWithoutActionsNestedInput>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUpdateWithoutWorkflowEventSettingInput = {
  actionType?: Maybe<WorkflowActionType>;
  automationRunActions?: Maybe<AutomationRunActionUpdateManyWithoutAutomationActionNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutCurrentWorkflowEventActionNestedInput>;
  channelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventActionNestedInput>;
  channels?: Maybe<ChannelUpdateManyWithoutCurrentWorkflowActionNestedInput>;
  config?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  promptType?: Maybe<AutomationRunActionPromptType>;
  responseChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutResponseWorkflowEventActionsNestedInput>;
  returnedAutomationRuns?: Maybe<AutomationRunUpdateManyWithoutReturnToAutomationActionNestedInput>;
  triggerWorkflow?: Maybe<WorkflowEventSettingUpdateOneWithoutWorkflowEventActionsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowEventTrigger?: Maybe<Scalars['String']>;
  workflowEventTriggerActionNumber?: Maybe<Scalars['Int']>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<Scalars['Int']>;
};

export type WorkflowEventActionUpsertWithWhereUniqueWithoutChannelStatusChangeInput = {
  create: WorkflowEventActionCreateWithoutChannelStatusChangeInput;
  update: WorkflowEventActionUpdateWithoutChannelStatusChangeInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionUpsertWithWhereUniqueWithoutResponseChannelStatusChangeInput = {
  create: WorkflowEventActionCreateWithoutResponseChannelStatusChangeInput;
  update: WorkflowEventActionUpdateWithoutResponseChannelStatusChangeInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionUpsertWithWhereUniqueWithoutTriggerWorkflowInput = {
  create: WorkflowEventActionCreateWithoutTriggerWorkflowInput;
  update: WorkflowEventActionUpdateWithoutTriggerWorkflowInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionUpsertWithWhereUniqueWithoutWorkflowEventSettingInput = {
  create: WorkflowEventActionCreateWithoutWorkflowEventSettingInput;
  update: WorkflowEventActionUpdateWithoutWorkflowEventSettingInput;
  where: WorkflowEventActionWhereUniqueInput;
};

export type WorkflowEventActionUpsertWithoutAutomationRunActionsInput = {
  create: WorkflowEventActionCreateWithoutAutomationRunActionsInput;
  update: WorkflowEventActionUpdateWithoutAutomationRunActionsInput;
  where?: Maybe<WorkflowEventActionWhereInput>;
};

export type WorkflowEventActionUpsertWithoutChannelAutomationStatusesInput = {
  create: WorkflowEventActionCreateWithoutChannelAutomationStatusesInput;
  update: WorkflowEventActionUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<WorkflowEventActionWhereInput>;
};

export type WorkflowEventActionUpsertWithoutChannelsInput = {
  create: WorkflowEventActionCreateWithoutChannelsInput;
  update: WorkflowEventActionUpdateWithoutChannelsInput;
  where?: Maybe<WorkflowEventActionWhereInput>;
};

export type WorkflowEventActionUpsertWithoutReturnedAutomationRunsInput = {
  create: WorkflowEventActionCreateWithoutReturnedAutomationRunsInput;
  update: WorkflowEventActionUpdateWithoutReturnedAutomationRunsInput;
  where?: Maybe<WorkflowEventActionWhereInput>;
};

export type WorkflowEventActionWhereInput = {
  AND?: Maybe<Array<WorkflowEventActionWhereInput>>;
  NOT?: Maybe<Array<WorkflowEventActionWhereInput>>;
  OR?: Maybe<Array<WorkflowEventActionWhereInput>>;
  actionType?: Maybe<EnumWorkflowActionTypeFilter>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusChangeId?: Maybe<StringNullableFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  config?: Maybe<JsonFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  order?: Maybe<IntFilter>;
  promptType?: Maybe<EnumAutomationRunActionPromptTypeFilter>;
  responseChannelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  responseChannelStatusChangeId?: Maybe<StringNullableFilter>;
  returnedAutomationRuns?: Maybe<AutomationRunListRelationFilter>;
  triggerWorkflow?: Maybe<WorkflowEventSettingNullableScalarRelationFilter>;
  triggerWorkflowId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSetting?: Maybe<WorkflowEventSettingNullableScalarRelationFilter>;
  workflowEventSettingId?: Maybe<StringNullableFilter>;
  workflowEventTrigger?: Maybe<StringNullableFilter>;
  workflowEventTriggerActionNumber?: Maybe<IntNullableFilter>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<IntNullableFilter>;
};

export type WorkflowEventActionWhereUniqueInput = {
  AND?: Maybe<Array<WorkflowEventActionWhereInput>>;
  NOT?: Maybe<Array<WorkflowEventActionWhereInput>>;
  OR?: Maybe<Array<WorkflowEventActionWhereInput>>;
  actionType?: Maybe<EnumWorkflowActionTypeFilter>;
  automationRunActions?: Maybe<AutomationRunActionListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  channelStatusChangeId?: Maybe<StringNullableFilter>;
  channels?: Maybe<ChannelListRelationFilter>;
  config?: Maybe<JsonFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<IntFilter>;
  promptType?: Maybe<EnumAutomationRunActionPromptTypeFilter>;
  responseChannelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  responseChannelStatusChangeId?: Maybe<StringNullableFilter>;
  returnedAutomationRuns?: Maybe<AutomationRunListRelationFilter>;
  triggerWorkflow?: Maybe<WorkflowEventSettingNullableScalarRelationFilter>;
  triggerWorkflowId?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowEventSetting?: Maybe<WorkflowEventSettingNullableScalarRelationFilter>;
  workflowEventSettingId?: Maybe<StringNullableFilter>;
  workflowEventTrigger?: Maybe<StringNullableFilter>;
  workflowEventTriggerActionNumber?: Maybe<IntNullableFilter>;
  workflowEventTriggerDelayInMilliseconds?: Maybe<IntNullableFilter>;
};

export type WorkflowEventSetting = {
  __typename?: 'WorkflowEventSetting';
  _count: WorkflowEventSettingCountOutputType;
  actions: Array<WorkflowEventAction>;
  appointmentTypes: Array<AppointmentType>;
  appointments: Array<Appointment>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns: Array<AutomationRun>;
  channelAutomationStatuses: Array<ChannelAutomationStatus>;
  channelCreationSources: Array<ChannelCreationSource>;
  childRunEvaluationStatus: ConditionEvaluationStatus;
  clinic?: Maybe<Clinic>;
  clinicEmployees: Array<ClinicEmployeeToWorkflowEventSetting>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms: Array<ClinicRoomToWorkflowEventSetting>;
  conditionSets: Array<ConditionSet>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours: Scalars['Int'];
  id: Scalars['String'];
  informAutomationCampaigns: Array<InformAutomationCampaign>;
  initialChannelStatusChange?: Maybe<ChannelStatus>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers: Array<LapsedPetParentTriggers>;
  messagingCampaign?: Maybe<MessagingCampaign>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours: WorkflowSendingHours;
  surveySetting?: Maybe<SurveySetting>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType: WorkflowEventTriggerType;
  triggeringFormTemplates: Array<FormTemplate>;
  updatedAt: Scalars['DateTime'];
  visitType: WorkflowVisitType;
  widgetRequestTypes: Array<ClinicWidgetRequestType>;
  workflowEventActions: Array<WorkflowEventAction>;
  workflowTriggers: Array<WorkflowTrigger>;
  workflowType: WorkflowType;
};


export type WorkflowEventSettingActionsArgs = {
  cursor?: Maybe<WorkflowEventActionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventActionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventActionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventActionWhereInput>;
};


export type WorkflowEventSettingAppointmentTypesArgs = {
  cursor?: Maybe<AppointmentTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentTypeWhereInput>;
};


export type WorkflowEventSettingAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AppointmentScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AppointmentWhereInput>;
};


export type WorkflowEventSettingAutomationRunsArgs = {
  cursor?: Maybe<AutomationRunWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<AutomationRunScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<AutomationRunOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AutomationRunWhereInput>;
};


export type WorkflowEventSettingChannelAutomationStatusesArgs = {
  cursor?: Maybe<ChannelAutomationStatusWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelAutomationStatusScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelAutomationStatusOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelAutomationStatusWhereInput>;
};


export type WorkflowEventSettingChannelCreationSourcesArgs = {
  cursor?: Maybe<ChannelCreationSourceWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ChannelCreationSourceScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ChannelCreationSourceOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ChannelCreationSourceWhereInput>;
};


export type WorkflowEventSettingClinicArgs = {
  where?: Maybe<ClinicWhereInput>;
};


export type WorkflowEventSettingClinicEmployeesArgs = {
  cursor?: Maybe<ClinicEmployeeToWorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicEmployeeToWorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicEmployeeToWorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicEmployeeToWorkflowEventSettingWhereInput>;
};


export type WorkflowEventSettingClinicRoomsArgs = {
  cursor?: Maybe<ClinicRoomToWorkflowEventSettingWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicRoomToWorkflowEventSettingScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicRoomToWorkflowEventSettingOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicRoomToWorkflowEventSettingWhereInput>;
};


export type WorkflowEventSettingInformAutomationCampaignsArgs = {
  cursor?: Maybe<InformAutomationCampaignWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<InformAutomationCampaignScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<InformAutomationCampaignOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<InformAutomationCampaignWhereInput>;
};


export type WorkflowEventSettingInitialChannelStatusChangeArgs = {
  where?: Maybe<ChannelStatusWhereInput>;
};


export type WorkflowEventSettingLapsedPetParentTriggersArgs = {
  cursor?: Maybe<LapsedPetParentTriggersWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<LapsedPetParentTriggersScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<LapsedPetParentTriggersOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<LapsedPetParentTriggersWhereInput>;
};


export type WorkflowEventSettingMessagingCampaignArgs = {
  where?: Maybe<MessagingCampaignWhereInput>;
};


export type WorkflowEventSettingSurveySettingArgs = {
  where?: Maybe<SurveySettingWhereInput>;
};


export type WorkflowEventSettingTriggeringFormTemplatesArgs = {
  cursor?: Maybe<FormTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<FormTemplateScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<FormTemplateOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FormTemplateWhereInput>;
};


export type WorkflowEventSettingWidgetRequestTypesArgs = {
  cursor?: Maybe<ClinicWidgetRequestTypeWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<ClinicWidgetRequestTypeScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
};


export type WorkflowEventSettingWorkflowEventActionsArgs = {
  cursor?: Maybe<WorkflowEventActionWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowEventActionScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowEventActionOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowEventActionWhereInput>;
};


export type WorkflowEventSettingWorkflowTriggersArgs = {
  cursor?: Maybe<WorkflowTriggerWhereUniqueInput>;
  distinct?: Maybe<Array<Maybe<WorkflowTriggerScalarFieldEnum>>>;
  orderBy?: Maybe<Array<Maybe<WorkflowTriggerOrderByWithRelationInput>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<WorkflowTriggerWhereInput>;
};

export type WorkflowEventSettingAvgAggregateOutputType = {
  __typename?: 'WorkflowEventSettingAvgAggregateOutputType';
  automatedTriggerInMinutes?: Maybe<Scalars['Float']>;
  groupByWindowInHours?: Maybe<Scalars['Float']>;
};

export type WorkflowEventSettingAvgOrderByAggregateInput = {
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  groupByWindowInHours?: Maybe<SortOrder>;
};

export type WorkflowEventSettingCountAggregateOutputType = {
  __typename?: 'WorkflowEventSettingCountAggregateOutputType';
  _all: Scalars['Int'];
  automatedTriggerInMinutes: Scalars['Int'];
  automatedTriggerTimeOfDay: Scalars['Int'];
  automatedTriggerType: Scalars['Int'];
  childRunEvaluationStatus: Scalars['Int'];
  clinicId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  event: Scalars['Int'];
  groupByWindowInHours: Scalars['Int'];
  id: Scalars['Int'];
  initialChannelStatusChangeId: Scalars['Int'];
  isPublished: Scalars['Int'];
  messagingCampaignId: Scalars['Int'];
  name: Scalars['Int'];
  notificationBody: Scalars['Int'];
  sendingHours: Scalars['Int'];
  surveySettingId: Scalars['Int'];
  surveyStep: Scalars['Int'];
  surveyType: Scalars['Int'];
  timeFormat: Scalars['Int'];
  triggerType: Scalars['Int'];
  updatedAt: Scalars['Int'];
  visitType: Scalars['Int'];
  workflowType: Scalars['Int'];
};

export type WorkflowEventSettingCountOrderByAggregateInput = {
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  automatedTriggerTimeOfDay?: Maybe<SortOrder>;
  automatedTriggerType?: Maybe<SortOrder>;
  childRunEvaluationStatus?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  groupByWindowInHours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initialChannelStatusChangeId?: Maybe<SortOrder>;
  isPublished?: Maybe<SortOrder>;
  messagingCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notificationBody?: Maybe<SortOrder>;
  sendingHours?: Maybe<SortOrder>;
  surveySettingId?: Maybe<SortOrder>;
  surveyStep?: Maybe<SortOrder>;
  surveyType?: Maybe<SortOrder>;
  timeFormat?: Maybe<SortOrder>;
  triggerType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visitType?: Maybe<SortOrder>;
  workflowType?: Maybe<SortOrder>;
};

export type WorkflowEventSettingCountOutputType = {
  __typename?: 'WorkflowEventSettingCountOutputType';
  actions: Scalars['Int'];
  appointmentTypes: Scalars['Int'];
  appointments: Scalars['Int'];
  automationRuns: Scalars['Int'];
  channelAutomationStatuses: Scalars['Int'];
  channelCreationSources: Scalars['Int'];
  clinicEmployees: Scalars['Int'];
  clinicRooms: Scalars['Int'];
  informAutomationCampaigns: Scalars['Int'];
  lapsedPetParentTriggers: Scalars['Int'];
  triggeringFormTemplates: Scalars['Int'];
  widgetRequestTypes: Scalars['Int'];
  workflowEventActions: Scalars['Int'];
  workflowTriggers: Scalars['Int'];
};

export type WorkflowEventSettingCreateInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateManyClinicInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateManyClinicInputEnvelope = {
  data: Array<WorkflowEventSettingCreateManyClinicInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type WorkflowEventSettingCreateManyInitialChannelStatusChangeInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateManyInitialChannelStatusChangeInputEnvelope = {
  data: Array<WorkflowEventSettingCreateManyInitialChannelStatusChangeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type WorkflowEventSettingCreateManyInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateManyMessagingCampaignInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateManyMessagingCampaignInputEnvelope = {
  data: Array<WorkflowEventSettingCreateManyMessagingCampaignInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type WorkflowEventSettingCreateManySurveySettingInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateManySurveySettingInputEnvelope = {
  data: Array<WorkflowEventSettingCreateManySurveySettingInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type WorkflowEventSettingCreateNestedManyWithoutAppointmentTypesInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutAppointmentTypesInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutAppointmentTypesInput>>;
};

export type WorkflowEventSettingCreateNestedManyWithoutAppointmentsInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutAppointmentsInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutAppointmentsInput>>;
};

export type WorkflowEventSettingCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManyClinicInputEnvelope>;
};

export type WorkflowEventSettingCreateNestedManyWithoutInitialChannelStatusChangeInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutInitialChannelStatusChangeInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutInitialChannelStatusChangeInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManyInitialChannelStatusChangeInputEnvelope>;
};

export type WorkflowEventSettingCreateNestedManyWithoutMessagingCampaignInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutMessagingCampaignInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutMessagingCampaignInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManyMessagingCampaignInputEnvelope>;
};

export type WorkflowEventSettingCreateNestedManyWithoutSurveySettingInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutSurveySettingInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutSurveySettingInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManySurveySettingInputEnvelope>;
};

export type WorkflowEventSettingCreateNestedManyWithoutTriggeringFormTemplatesInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutTriggeringFormTemplatesInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutTriggeringFormTemplatesInput>>;
};

export type WorkflowEventSettingCreateNestedManyWithoutWidgetRequestTypesInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutWidgetRequestTypesInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutWidgetRequestTypesInput>>;
};

export type WorkflowEventSettingCreateNestedOneWithoutActionsInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutActionsInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutActionsInput>;
};

export type WorkflowEventSettingCreateNestedOneWithoutAutomationRunsInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutAutomationRunsInput>;
};

export type WorkflowEventSettingCreateNestedOneWithoutChannelAutomationStatusesInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutChannelAutomationStatusesInput>;
};

export type WorkflowEventSettingCreateNestedOneWithoutChannelCreationSourcesInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutChannelCreationSourcesInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutChannelCreationSourcesInput>;
};

export type WorkflowEventSettingCreateNestedOneWithoutClinicEmployeesInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutClinicEmployeesInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutClinicEmployeesInput>;
};

export type WorkflowEventSettingCreateNestedOneWithoutClinicRoomsInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutClinicRoomsInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutClinicRoomsInput>;
};

export type WorkflowEventSettingCreateNestedOneWithoutInformAutomationCampaignsInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutInformAutomationCampaignsInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutInformAutomationCampaignsInput>;
};

export type WorkflowEventSettingCreateNestedOneWithoutLapsedPetParentTriggersInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutLapsedPetParentTriggersInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutLapsedPetParentTriggersInput>;
};

export type WorkflowEventSettingCreateNestedOneWithoutWorkflowEventActionsInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutWorkflowEventActionsInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutWorkflowEventActionsInput>;
};

export type WorkflowEventSettingCreateNestedOneWithoutWorkflowTriggersInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutWorkflowTriggersInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutWorkflowTriggersInput>;
};

export type WorkflowEventSettingCreateOrConnectWithoutActionsInput = {
  create: WorkflowEventSettingCreateWithoutActionsInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutAppointmentTypesInput = {
  create: WorkflowEventSettingCreateWithoutAppointmentTypesInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutAppointmentsInput = {
  create: WorkflowEventSettingCreateWithoutAppointmentsInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutAutomationRunsInput = {
  create: WorkflowEventSettingCreateWithoutAutomationRunsInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutChannelAutomationStatusesInput = {
  create: WorkflowEventSettingCreateWithoutChannelAutomationStatusesInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutChannelCreationSourcesInput = {
  create: WorkflowEventSettingCreateWithoutChannelCreationSourcesInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutClinicEmployeesInput = {
  create: WorkflowEventSettingCreateWithoutClinicEmployeesInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutClinicInput = {
  create: WorkflowEventSettingCreateWithoutClinicInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutClinicRoomsInput = {
  create: WorkflowEventSettingCreateWithoutClinicRoomsInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutInformAutomationCampaignsInput = {
  create: WorkflowEventSettingCreateWithoutInformAutomationCampaignsInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutInitialChannelStatusChangeInput = {
  create: WorkflowEventSettingCreateWithoutInitialChannelStatusChangeInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutLapsedPetParentTriggersInput = {
  create: WorkflowEventSettingCreateWithoutLapsedPetParentTriggersInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutMessagingCampaignInput = {
  create: WorkflowEventSettingCreateWithoutMessagingCampaignInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutSurveySettingInput = {
  create: WorkflowEventSettingCreateWithoutSurveySettingInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutTriggeringFormTemplatesInput = {
  create: WorkflowEventSettingCreateWithoutTriggeringFormTemplatesInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutWidgetRequestTypesInput = {
  create: WorkflowEventSettingCreateWithoutWidgetRequestTypesInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutWorkflowEventActionsInput = {
  create: WorkflowEventSettingCreateWithoutWorkflowEventActionsInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateOrConnectWithoutWorkflowTriggersInput = {
  create: WorkflowEventSettingCreateWithoutWorkflowTriggersInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingCreateWithoutActionsInput = {
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutAppointmentTypesInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutAppointmentsInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutAutomationRunsInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutChannelAutomationStatusesInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutChannelCreationSourcesInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutClinicEmployeesInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutClinicInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutClinicRoomsInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutInformAutomationCampaignsInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutInitialChannelStatusChangeInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutLapsedPetParentTriggersInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutMessagingCampaignInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutSurveySettingInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutTriggeringFormTemplatesInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutWidgetRequestTypesInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutWorkflowEventActionsInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowTriggers?: Maybe<WorkflowTriggerCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingCreateWithoutWorkflowTriggersInput = {
  actions?: Maybe<WorkflowEventActionCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicCreateNestedOneWithoutWorkflowEventSettingsInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusCreateNestedOneWithoutWorkflowEventSettingsInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersCreateNestedManyWithoutAutomationInput>;
  messagingCampaign?: Maybe<MessagingCampaignCreateNestedOneWithoutWorkflowEventSettingsInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingCreateNestedOneWithoutWorkflowEventSettingsInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingGroupByOutputType = {
  __typename?: 'WorkflowEventSettingGroupByOutputType';
  _avg?: Maybe<WorkflowEventSettingAvgAggregateOutputType>;
  _count?: Maybe<WorkflowEventSettingCountAggregateOutputType>;
  _max?: Maybe<WorkflowEventSettingMaxAggregateOutputType>;
  _min?: Maybe<WorkflowEventSettingMinAggregateOutputType>;
  _sum?: Maybe<WorkflowEventSettingSumAggregateOutputType>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus: ConditionEvaluationStatus;
  clinicId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours: Scalars['Int'];
  id: Scalars['String'];
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours: WorkflowSendingHours;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType: WorkflowEventTriggerType;
  updatedAt: Scalars['DateTime'];
  visitType: WorkflowVisitType;
  workflowType: WorkflowType;
};

export type WorkflowEventSettingListRelationFilter = {
  every?: Maybe<WorkflowEventSettingWhereInput>;
  none?: Maybe<WorkflowEventSettingWhereInput>;
  some?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingMaxAggregateOutputType = {
  __typename?: 'WorkflowEventSettingMaxAggregateOutputType';
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingMaxOrderByAggregateInput = {
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  automatedTriggerTimeOfDay?: Maybe<SortOrder>;
  automatedTriggerType?: Maybe<SortOrder>;
  childRunEvaluationStatus?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  groupByWindowInHours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initialChannelStatusChangeId?: Maybe<SortOrder>;
  isPublished?: Maybe<SortOrder>;
  messagingCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notificationBody?: Maybe<SortOrder>;
  sendingHours?: Maybe<SortOrder>;
  surveySettingId?: Maybe<SortOrder>;
  surveyStep?: Maybe<SortOrder>;
  surveyType?: Maybe<SortOrder>;
  timeFormat?: Maybe<SortOrder>;
  triggerType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visitType?: Maybe<SortOrder>;
  workflowType?: Maybe<SortOrder>;
};

export type WorkflowEventSettingMinAggregateOutputType = {
  __typename?: 'WorkflowEventSettingMinAggregateOutputType';
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingMinOrderByAggregateInput = {
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  automatedTriggerTimeOfDay?: Maybe<SortOrder>;
  automatedTriggerType?: Maybe<SortOrder>;
  childRunEvaluationStatus?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  groupByWindowInHours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initialChannelStatusChangeId?: Maybe<SortOrder>;
  isPublished?: Maybe<SortOrder>;
  messagingCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notificationBody?: Maybe<SortOrder>;
  sendingHours?: Maybe<SortOrder>;
  surveySettingId?: Maybe<SortOrder>;
  surveyStep?: Maybe<SortOrder>;
  surveyType?: Maybe<SortOrder>;
  timeFormat?: Maybe<SortOrder>;
  triggerType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visitType?: Maybe<SortOrder>;
  workflowType?: Maybe<SortOrder>;
};

export type WorkflowEventSettingNullableScalarRelationFilter = {
  AND?: Maybe<Array<WorkflowEventSettingWhereInput>>;
  NOT?: Maybe<Array<WorkflowEventSettingWhereInput>>;
  OR?: Maybe<Array<WorkflowEventSettingWhereInput>>;
  actions?: Maybe<WorkflowEventActionListRelationFilter>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  automatedTriggerInMinutes?: Maybe<IntNullableFilter>;
  automatedTriggerTimeOfDay?: Maybe<DateTimeNullableFilter>;
  automatedTriggerType?: Maybe<EnumAutomatedTriggerTypeNullableFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  childRunEvaluationStatus?: Maybe<EnumConditionEvaluationStatusFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  event?: Maybe<EnumWorkflowEventFilter>;
  groupByWindowInHours?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignListRelationFilter>;
  initialChannelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  initialChannelStatusChangeId?: Maybe<StringNullableFilter>;
  isPublished?: Maybe<BoolNullableFilter>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersListRelationFilter>;
  messagingCampaign?: Maybe<MessagingCampaignNullableScalarRelationFilter>;
  messagingCampaignId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  notificationBody?: Maybe<StringNullableFilter>;
  sendingHours?: Maybe<EnumWorkflowSendingHoursFilter>;
  surveySetting?: Maybe<SurveySettingNullableScalarRelationFilter>;
  surveySettingId?: Maybe<StringNullableFilter>;
  surveyStep?: Maybe<EnumSurveyStepNullableFilter>;
  surveyType?: Maybe<EnumSurveyTypeNullableFilter>;
  timeFormat?: Maybe<StringNullableFilter>;
  triggerType?: Maybe<EnumWorkflowEventTriggerTypeFilter>;
  triggeringFormTemplates?: Maybe<FormTemplateListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visitType?: Maybe<EnumWorkflowVisitTypeFilter>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  workflowEventActions?: Maybe<WorkflowEventActionListRelationFilter>;
  workflowTriggers?: Maybe<WorkflowTriggerListRelationFilter>;
  workflowType?: Maybe<EnumWorkflowTypeFilter>;
};

export type WorkflowEventSettingOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type WorkflowEventSettingOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<WorkflowEventSettingOrderByRelevanceInput>;
  actions?: Maybe<WorkflowEventActionOrderByRelationAggregateInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  automatedTriggerTimeOfDay?: Maybe<SortOrder>;
  automatedTriggerType?: Maybe<SortOrder>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  childRunEvaluationStatus?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  groupByWindowInHours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignOrderByRelationAggregateInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusOrderByWithRelationInput>;
  initialChannelStatusChangeId?: Maybe<SortOrder>;
  isPublished?: Maybe<SortOrder>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersOrderByRelationAggregateInput>;
  messagingCampaign?: Maybe<MessagingCampaignOrderByWithRelationInput>;
  messagingCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notificationBody?: Maybe<SortOrder>;
  sendingHours?: Maybe<SortOrder>;
  surveySetting?: Maybe<SurveySettingOrderByWithRelationInput>;
  surveySettingId?: Maybe<SortOrder>;
  surveyStep?: Maybe<SortOrder>;
  surveyType?: Maybe<SortOrder>;
  timeFormat?: Maybe<SortOrder>;
  triggerType?: Maybe<SortOrder>;
  triggeringFormTemplates?: Maybe<FormTemplateOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  visitType?: Maybe<SortOrder>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  workflowEventActions?: Maybe<WorkflowEventActionOrderByRelationAggregateInput>;
  workflowTriggers?: Maybe<WorkflowTriggerOrderByRelationAggregateInput>;
  workflowType?: Maybe<SortOrder>;
};

export enum WorkflowEventSettingOrderByRelevanceFieldEnum {
  ClinicId = 'clinicId',
  Id = 'id',
  InitialChannelStatusChangeId = 'initialChannelStatusChangeId',
  MessagingCampaignId = 'messagingCampaignId',
  Name = 'name',
  NotificationBody = 'notificationBody',
  SurveySettingId = 'surveySettingId',
  TimeFormat = 'timeFormat'
}

export type WorkflowEventSettingOrderByRelevanceInput = {
  fields: Array<WorkflowEventSettingOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type WorkflowEventSettingOrderByWithAggregationInput = {
  _avg?: Maybe<WorkflowEventSettingAvgOrderByAggregateInput>;
  _count?: Maybe<WorkflowEventSettingCountOrderByAggregateInput>;
  _max?: Maybe<WorkflowEventSettingMaxOrderByAggregateInput>;
  _min?: Maybe<WorkflowEventSettingMinOrderByAggregateInput>;
  _sum?: Maybe<WorkflowEventSettingSumOrderByAggregateInput>;
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  automatedTriggerTimeOfDay?: Maybe<SortOrder>;
  automatedTriggerType?: Maybe<SortOrder>;
  childRunEvaluationStatus?: Maybe<SortOrder>;
  clinicId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  groupByWindowInHours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initialChannelStatusChangeId?: Maybe<SortOrder>;
  isPublished?: Maybe<SortOrder>;
  messagingCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notificationBody?: Maybe<SortOrder>;
  sendingHours?: Maybe<SortOrder>;
  surveySettingId?: Maybe<SortOrder>;
  surveyStep?: Maybe<SortOrder>;
  surveyType?: Maybe<SortOrder>;
  timeFormat?: Maybe<SortOrder>;
  triggerType?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  visitType?: Maybe<SortOrder>;
  workflowType?: Maybe<SortOrder>;
};

export type WorkflowEventSettingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<WorkflowEventSettingOrderByRelevanceInput>;
  actions?: Maybe<WorkflowEventActionOrderByRelationAggregateInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  automatedTriggerTimeOfDay?: Maybe<SortOrder>;
  automatedTriggerType?: Maybe<SortOrder>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  childRunEvaluationStatus?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  groupByWindowInHours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignOrderByRelationAggregateInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusOrderByWithRelationInput>;
  initialChannelStatusChangeId?: Maybe<SortOrder>;
  isPublished?: Maybe<SortOrder>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersOrderByRelationAggregateInput>;
  messagingCampaign?: Maybe<MessagingCampaignOrderByWithRelationInput>;
  messagingCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notificationBody?: Maybe<SortOrder>;
  sendingHours?: Maybe<SortOrder>;
  surveySetting?: Maybe<SurveySettingOrderByWithRelationInput>;
  surveySettingId?: Maybe<SortOrder>;
  surveyStep?: Maybe<SortOrder>;
  surveyType?: Maybe<SortOrder>;
  timeFormat?: Maybe<SortOrder>;
  triggerType?: Maybe<SortOrder>;
  triggeringFormTemplates?: Maybe<FormTemplateOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  visitType?: Maybe<SortOrder>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  workflowEventActions?: Maybe<WorkflowEventActionOrderByRelationAggregateInput>;
  workflowTriggers?: Maybe<WorkflowTriggerOrderByRelationAggregateInput>;
  workflowType?: Maybe<SortOrder>;
};

export type WorkflowEventSettingOrderByWithRelationInput = {
  _relevance?: Maybe<WorkflowEventSettingOrderByRelevanceInput>;
  actions?: Maybe<WorkflowEventActionOrderByRelationAggregateInput>;
  appointmentTypes?: Maybe<AppointmentTypeOrderByRelationAggregateInput>;
  appointments?: Maybe<AppointmentOrderByRelationAggregateInput>;
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  automatedTriggerTimeOfDay?: Maybe<SortOrder>;
  automatedTriggerType?: Maybe<SortOrder>;
  automationRuns?: Maybe<AutomationRunOrderByRelationAggregateInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusOrderByRelationAggregateInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceOrderByRelationAggregateInput>;
  childRunEvaluationStatus?: Maybe<SortOrder>;
  clinic?: Maybe<ClinicOrderByWithRelationInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingOrderByRelationAggregateInput>;
  clinicId?: Maybe<SortOrder>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  event?: Maybe<SortOrder>;
  groupByWindowInHours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignOrderByRelationAggregateInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusOrderByWithRelationInput>;
  initialChannelStatusChangeId?: Maybe<SortOrder>;
  isPublished?: Maybe<SortOrder>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersOrderByRelationAggregateInput>;
  messagingCampaign?: Maybe<MessagingCampaignOrderByWithRelationInput>;
  messagingCampaignId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  notificationBody?: Maybe<SortOrder>;
  sendingHours?: Maybe<SortOrder>;
  surveySetting?: Maybe<SurveySettingOrderByWithRelationInput>;
  surveySettingId?: Maybe<SortOrder>;
  surveyStep?: Maybe<SortOrder>;
  surveyType?: Maybe<SortOrder>;
  timeFormat?: Maybe<SortOrder>;
  triggerType?: Maybe<SortOrder>;
  triggeringFormTemplates?: Maybe<FormTemplateOrderByRelationAggregateInput>;
  updatedAt?: Maybe<SortOrder>;
  visitType?: Maybe<SortOrder>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeOrderByRelationAggregateInput>;
  workflowEventActions?: Maybe<WorkflowEventActionOrderByRelationAggregateInput>;
  workflowTriggers?: Maybe<WorkflowTriggerOrderByRelationAggregateInput>;
  workflowType?: Maybe<SortOrder>;
};

export enum WorkflowEventSettingScalarFieldEnum {
  AutomatedTriggerInMinutes = 'automatedTriggerInMinutes',
  AutomatedTriggerTimeOfDay = 'automatedTriggerTimeOfDay',
  AutomatedTriggerType = 'automatedTriggerType',
  ChildRunEvaluationStatus = 'childRunEvaluationStatus',
  ClinicId = 'clinicId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Event = 'event',
  GroupByWindowInHours = 'groupByWindowInHours',
  Id = 'id',
  InitialChannelStatusChangeId = 'initialChannelStatusChangeId',
  IsPublished = 'isPublished',
  MessagingCampaignId = 'messagingCampaignId',
  Name = 'name',
  NotificationBody = 'notificationBody',
  SendingHours = 'sendingHours',
  SurveySettingId = 'surveySettingId',
  SurveyStep = 'surveyStep',
  SurveyType = 'surveyType',
  TimeFormat = 'timeFormat',
  TriggerType = 'triggerType',
  UpdatedAt = 'updatedAt',
  VisitType = 'visitType',
  WorkflowType = 'workflowType'
}

export type WorkflowEventSettingScalarRelationFilter = {
  AND?: Maybe<Array<WorkflowEventSettingWhereInput>>;
  NOT?: Maybe<Array<WorkflowEventSettingWhereInput>>;
  OR?: Maybe<Array<WorkflowEventSettingWhereInput>>;
  actions?: Maybe<WorkflowEventActionListRelationFilter>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  automatedTriggerInMinutes?: Maybe<IntNullableFilter>;
  automatedTriggerTimeOfDay?: Maybe<DateTimeNullableFilter>;
  automatedTriggerType?: Maybe<EnumAutomatedTriggerTypeNullableFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  childRunEvaluationStatus?: Maybe<EnumConditionEvaluationStatusFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  event?: Maybe<EnumWorkflowEventFilter>;
  groupByWindowInHours?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignListRelationFilter>;
  initialChannelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  initialChannelStatusChangeId?: Maybe<StringNullableFilter>;
  isPublished?: Maybe<BoolNullableFilter>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersListRelationFilter>;
  messagingCampaign?: Maybe<MessagingCampaignNullableScalarRelationFilter>;
  messagingCampaignId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  notificationBody?: Maybe<StringNullableFilter>;
  sendingHours?: Maybe<EnumWorkflowSendingHoursFilter>;
  surveySetting?: Maybe<SurveySettingNullableScalarRelationFilter>;
  surveySettingId?: Maybe<StringNullableFilter>;
  surveyStep?: Maybe<EnumSurveyStepNullableFilter>;
  surveyType?: Maybe<EnumSurveyTypeNullableFilter>;
  timeFormat?: Maybe<StringNullableFilter>;
  triggerType?: Maybe<EnumWorkflowEventTriggerTypeFilter>;
  triggeringFormTemplates?: Maybe<FormTemplateListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visitType?: Maybe<EnumWorkflowVisitTypeFilter>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  workflowEventActions?: Maybe<WorkflowEventActionListRelationFilter>;
  workflowTriggers?: Maybe<WorkflowTriggerListRelationFilter>;
  workflowType?: Maybe<EnumWorkflowTypeFilter>;
};

export type WorkflowEventSettingScalarWhereInput = {
  AND?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  NOT?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  OR?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  automatedTriggerInMinutes?: Maybe<IntNullableFilter>;
  automatedTriggerTimeOfDay?: Maybe<DateTimeNullableFilter>;
  automatedTriggerType?: Maybe<EnumAutomatedTriggerTypeNullableFilter>;
  childRunEvaluationStatus?: Maybe<EnumConditionEvaluationStatusFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  event?: Maybe<EnumWorkflowEventFilter>;
  groupByWindowInHours?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  initialChannelStatusChangeId?: Maybe<StringNullableFilter>;
  isPublished?: Maybe<BoolNullableFilter>;
  messagingCampaignId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  notificationBody?: Maybe<StringNullableFilter>;
  sendingHours?: Maybe<EnumWorkflowSendingHoursFilter>;
  surveySettingId?: Maybe<StringNullableFilter>;
  surveyStep?: Maybe<EnumSurveyStepNullableFilter>;
  surveyType?: Maybe<EnumSurveyTypeNullableFilter>;
  timeFormat?: Maybe<StringNullableFilter>;
  triggerType?: Maybe<EnumWorkflowEventTriggerTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visitType?: Maybe<EnumWorkflowVisitTypeFilter>;
  workflowType?: Maybe<EnumWorkflowTypeFilter>;
};

export type WorkflowEventSettingScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<WorkflowEventSettingScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<WorkflowEventSettingScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<WorkflowEventSettingScalarWhereWithAggregatesInput>>;
  automatedTriggerInMinutes?: Maybe<IntNullableWithAggregatesFilter>;
  automatedTriggerTimeOfDay?: Maybe<DateTimeNullableWithAggregatesFilter>;
  automatedTriggerType?: Maybe<EnumAutomatedTriggerTypeNullableWithAggregatesFilter>;
  childRunEvaluationStatus?: Maybe<EnumConditionEvaluationStatusWithAggregatesFilter>;
  clinicId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  event?: Maybe<EnumWorkflowEventWithAggregatesFilter>;
  groupByWindowInHours?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  initialChannelStatusChangeId?: Maybe<StringNullableWithAggregatesFilter>;
  isPublished?: Maybe<BoolNullableWithAggregatesFilter>;
  messagingCampaignId?: Maybe<StringNullableWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  notificationBody?: Maybe<StringNullableWithAggregatesFilter>;
  sendingHours?: Maybe<EnumWorkflowSendingHoursWithAggregatesFilter>;
  surveySettingId?: Maybe<StringNullableWithAggregatesFilter>;
  surveyStep?: Maybe<EnumSurveyStepNullableWithAggregatesFilter>;
  surveyType?: Maybe<EnumSurveyTypeNullableWithAggregatesFilter>;
  timeFormat?: Maybe<StringNullableWithAggregatesFilter>;
  triggerType?: Maybe<EnumWorkflowEventTriggerTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  visitType?: Maybe<EnumWorkflowVisitTypeWithAggregatesFilter>;
  workflowType?: Maybe<EnumWorkflowTypeWithAggregatesFilter>;
};

export type WorkflowEventSettingSumAggregateOutputType = {
  __typename?: 'WorkflowEventSettingSumAggregateOutputType';
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
};

export type WorkflowEventSettingSumOrderByAggregateInput = {
  automatedTriggerInMinutes?: Maybe<SortOrder>;
  groupByWindowInHours?: Maybe<SortOrder>;
};

export type WorkflowEventSettingUncheckedCreateInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentTypesInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutAppointmentTypesInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutAppointmentTypesInput>>;
};

export type WorkflowEventSettingUncheckedCreateNestedManyWithoutAppointmentsInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutAppointmentsInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutAppointmentsInput>>;
};

export type WorkflowEventSettingUncheckedCreateNestedManyWithoutClinicInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManyClinicInputEnvelope>;
};

export type WorkflowEventSettingUncheckedCreateNestedManyWithoutInitialChannelStatusChangeInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutInitialChannelStatusChangeInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutInitialChannelStatusChangeInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManyInitialChannelStatusChangeInputEnvelope>;
};

export type WorkflowEventSettingUncheckedCreateNestedManyWithoutMessagingCampaignInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutMessagingCampaignInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutMessagingCampaignInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManyMessagingCampaignInputEnvelope>;
};

export type WorkflowEventSettingUncheckedCreateNestedManyWithoutSurveySettingInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutSurveySettingInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutSurveySettingInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManySurveySettingInputEnvelope>;
};

export type WorkflowEventSettingUncheckedCreateNestedManyWithoutTriggeringFormTemplatesInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutTriggeringFormTemplatesInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutTriggeringFormTemplatesInput>>;
};

export type WorkflowEventSettingUncheckedCreateNestedManyWithoutWidgetRequestTypesInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutWidgetRequestTypesInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutWidgetRequestTypesInput>>;
};

export type WorkflowEventSettingUncheckedCreateWithoutActionsInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutAppointmentTypesInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutAppointmentsInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutAutomationRunsInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutChannelAutomationStatusesInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutChannelCreationSourcesInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutClinicEmployeesInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutClinicInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutClinicRoomsInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutInformAutomationCampaignsInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutInitialChannelStatusChangeInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutLapsedPetParentTriggersInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutMessagingCampaignInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutSurveySettingInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutTriggeringFormTemplatesInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutWidgetRequestTypesInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutWorkflowEventActionsInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedCreateWithoutWorkflowTriggersInput = {
  actions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  appointments?: Maybe<AppointmentUncheckedCreateNestedManyWithoutWorkflowsInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedCreateNestedManyWithoutOriginAutomationInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedCreateNestedManyWithoutWorkflowInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: WorkflowEvent;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedCreateNestedManyWithoutWorkflowEventSettingInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedCreateNestedManyWithoutAutomationInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedCreateNestedManyWithoutTriggeredWorkflowsInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedCreateNestedManyWithoutWorkflowsInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedCreateNestedManyWithoutTriggerWorkflowInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateManyInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentTypesNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutAppointmentTypesInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutAppointmentTypesInput>>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutAppointmentTypesInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutAppointmentTypesInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutAppointmentTypesInput>>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutAppointmentsNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutAppointmentsInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutAppointmentsInput>>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutAppointmentsInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutAppointmentsInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutAppointmentsInput>>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutClinicInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutInitialChannelStatusChangeNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutInitialChannelStatusChangeInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutInitialChannelStatusChangeInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManyInitialChannelStatusChangeInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutInitialChannelStatusChangeInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutInitialChannelStatusChangeInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutInitialChannelStatusChangeInput>>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutMessagingCampaignInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutMessagingCampaignNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutMessagingCampaignInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutMessagingCampaignInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManyMessagingCampaignInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutMessagingCampaignInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutMessagingCampaignInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutMessagingCampaignInput>>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutSurveySettingInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutSurveySettingNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutSurveySettingInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutSurveySettingInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManySurveySettingInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutSurveySettingInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutSurveySettingInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutSurveySettingInput>>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutTriggeringFormTemplatesInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutTriggeringFormTemplatesNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutTriggeringFormTemplatesInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutTriggeringFormTemplatesInput>>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutTriggeringFormTemplatesInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutTriggeringFormTemplatesInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutTriggeringFormTemplatesInput>>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutWidgetRequestTypesInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateManyWithoutWidgetRequestTypesNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutWidgetRequestTypesInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutWidgetRequestTypesInput>>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutWidgetRequestTypesInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutWidgetRequestTypesInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutWidgetRequestTypesInput>>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutActionsInput = {
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutAppointmentTypesInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutAppointmentsInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutAutomationRunsInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutChannelAutomationStatusesInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutChannelCreationSourcesInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutClinicEmployeesInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutClinicInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutClinicRoomsInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutInformAutomationCampaignsInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutInitialChannelStatusChangeInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutLapsedPetParentTriggersInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutMessagingCampaignInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutSurveySettingInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutTriggeringFormTemplatesInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutWidgetRequestTypesInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutWorkflowEventActionsInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUncheckedUpdateWithoutWorkflowTriggersInput = {
  actions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUncheckedUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  clinicId?: Maybe<Scalars['String']>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUncheckedUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUncheckedUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChangeId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUncheckedUpdateManyWithoutAutomationNestedInput>;
  messagingCampaignId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySettingId?: Maybe<Scalars['String']>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUncheckedUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUncheckedUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUncheckedUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateManyMutationInput = {
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateManyWithWhereWithoutAppointmentTypesInput = {
  data: WorkflowEventSettingUpdateManyMutationInput;
  where: WorkflowEventSettingScalarWhereInput;
};

export type WorkflowEventSettingUpdateManyWithWhereWithoutAppointmentsInput = {
  data: WorkflowEventSettingUpdateManyMutationInput;
  where: WorkflowEventSettingScalarWhereInput;
};

export type WorkflowEventSettingUpdateManyWithWhereWithoutClinicInput = {
  data: WorkflowEventSettingUpdateManyMutationInput;
  where: WorkflowEventSettingScalarWhereInput;
};

export type WorkflowEventSettingUpdateManyWithWhereWithoutInitialChannelStatusChangeInput = {
  data: WorkflowEventSettingUpdateManyMutationInput;
  where: WorkflowEventSettingScalarWhereInput;
};

export type WorkflowEventSettingUpdateManyWithWhereWithoutMessagingCampaignInput = {
  data: WorkflowEventSettingUpdateManyMutationInput;
  where: WorkflowEventSettingScalarWhereInput;
};

export type WorkflowEventSettingUpdateManyWithWhereWithoutSurveySettingInput = {
  data: WorkflowEventSettingUpdateManyMutationInput;
  where: WorkflowEventSettingScalarWhereInput;
};

export type WorkflowEventSettingUpdateManyWithWhereWithoutTriggeringFormTemplatesInput = {
  data: WorkflowEventSettingUpdateManyMutationInput;
  where: WorkflowEventSettingScalarWhereInput;
};

export type WorkflowEventSettingUpdateManyWithWhereWithoutWidgetRequestTypesInput = {
  data: WorkflowEventSettingUpdateManyMutationInput;
  where: WorkflowEventSettingScalarWhereInput;
};

export type WorkflowEventSettingUpdateManyWithoutAppointmentTypesNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutAppointmentTypesInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutAppointmentTypesInput>>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutAppointmentTypesInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutAppointmentTypesInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutAppointmentTypesInput>>;
};

export type WorkflowEventSettingUpdateManyWithoutAppointmentsNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutAppointmentsInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutAppointmentsInput>>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutAppointmentsInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutAppointmentsInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutAppointmentsInput>>;
};

export type WorkflowEventSettingUpdateManyWithoutClinicNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutClinicInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutClinicInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManyClinicInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type WorkflowEventSettingUpdateManyWithoutInitialChannelStatusChangeNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutInitialChannelStatusChangeInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutInitialChannelStatusChangeInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManyInitialChannelStatusChangeInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutInitialChannelStatusChangeInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutInitialChannelStatusChangeInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutInitialChannelStatusChangeInput>>;
};

export type WorkflowEventSettingUpdateManyWithoutMessagingCampaignNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutMessagingCampaignInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutMessagingCampaignInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManyMessagingCampaignInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutMessagingCampaignInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutMessagingCampaignInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutMessagingCampaignInput>>;
};

export type WorkflowEventSettingUpdateManyWithoutSurveySettingNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutSurveySettingInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutSurveySettingInput>>;
  createMany?: Maybe<WorkflowEventSettingCreateManySurveySettingInputEnvelope>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutSurveySettingInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutSurveySettingInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutSurveySettingInput>>;
};

export type WorkflowEventSettingUpdateManyWithoutTriggeringFormTemplatesNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutTriggeringFormTemplatesInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutTriggeringFormTemplatesInput>>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutTriggeringFormTemplatesInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutTriggeringFormTemplatesInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutTriggeringFormTemplatesInput>>;
};

export type WorkflowEventSettingUpdateManyWithoutWidgetRequestTypesNestedInput = {
  connect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowEventSettingCreateOrConnectWithoutWidgetRequestTypesInput>>;
  create?: Maybe<Array<WorkflowEventSettingCreateWithoutWidgetRequestTypesInput>>;
  delete?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowEventSettingScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowEventSettingWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowEventSettingUpdateWithWhereUniqueWithoutWidgetRequestTypesInput>>;
  updateMany?: Maybe<Array<WorkflowEventSettingUpdateManyWithWhereWithoutWidgetRequestTypesInput>>;
  upsert?: Maybe<Array<WorkflowEventSettingUpsertWithWhereUniqueWithoutWidgetRequestTypesInput>>;
};

export type WorkflowEventSettingUpdateOneRequiredWithoutAutomationRunsNestedInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutAutomationRunsInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutAutomationRunsInput>;
  update?: Maybe<WorkflowEventSettingUpdateToOneWithWhereWithoutAutomationRunsInput>;
  upsert?: Maybe<WorkflowEventSettingUpsertWithoutAutomationRunsInput>;
};

export type WorkflowEventSettingUpdateOneRequiredWithoutChannelAutomationStatusesNestedInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutChannelAutomationStatusesInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutChannelAutomationStatusesInput>;
  update?: Maybe<WorkflowEventSettingUpdateToOneWithWhereWithoutChannelAutomationStatusesInput>;
  upsert?: Maybe<WorkflowEventSettingUpsertWithoutChannelAutomationStatusesInput>;
};

export type WorkflowEventSettingUpdateOneRequiredWithoutClinicEmployeesNestedInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutClinicEmployeesInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutClinicEmployeesInput>;
  update?: Maybe<WorkflowEventSettingUpdateToOneWithWhereWithoutClinicEmployeesInput>;
  upsert?: Maybe<WorkflowEventSettingUpsertWithoutClinicEmployeesInput>;
};

export type WorkflowEventSettingUpdateOneRequiredWithoutClinicRoomsNestedInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutClinicRoomsInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutClinicRoomsInput>;
  update?: Maybe<WorkflowEventSettingUpdateToOneWithWhereWithoutClinicRoomsInput>;
  upsert?: Maybe<WorkflowEventSettingUpsertWithoutClinicRoomsInput>;
};

export type WorkflowEventSettingUpdateOneRequiredWithoutInformAutomationCampaignsNestedInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutInformAutomationCampaignsInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutInformAutomationCampaignsInput>;
  update?: Maybe<WorkflowEventSettingUpdateToOneWithWhereWithoutInformAutomationCampaignsInput>;
  upsert?: Maybe<WorkflowEventSettingUpsertWithoutInformAutomationCampaignsInput>;
};

export type WorkflowEventSettingUpdateOneRequiredWithoutLapsedPetParentTriggersNestedInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutLapsedPetParentTriggersInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutLapsedPetParentTriggersInput>;
  update?: Maybe<WorkflowEventSettingUpdateToOneWithWhereWithoutLapsedPetParentTriggersInput>;
  upsert?: Maybe<WorkflowEventSettingUpsertWithoutLapsedPetParentTriggersInput>;
};

export type WorkflowEventSettingUpdateOneRequiredWithoutWorkflowTriggersNestedInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutWorkflowTriggersInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutWorkflowTriggersInput>;
  update?: Maybe<WorkflowEventSettingUpdateToOneWithWhereWithoutWorkflowTriggersInput>;
  upsert?: Maybe<WorkflowEventSettingUpsertWithoutWorkflowTriggersInput>;
};

export type WorkflowEventSettingUpdateOneWithoutActionsNestedInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutActionsInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutActionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<WorkflowEventSettingUpdateToOneWithWhereWithoutActionsInput>;
  upsert?: Maybe<WorkflowEventSettingUpsertWithoutActionsInput>;
};

export type WorkflowEventSettingUpdateOneWithoutChannelCreationSourcesNestedInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutChannelCreationSourcesInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutChannelCreationSourcesInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<WorkflowEventSettingUpdateToOneWithWhereWithoutChannelCreationSourcesInput>;
  upsert?: Maybe<WorkflowEventSettingUpsertWithoutChannelCreationSourcesInput>;
};

export type WorkflowEventSettingUpdateOneWithoutWorkflowEventActionsNestedInput = {
  connect?: Maybe<WorkflowEventSettingWhereUniqueInput>;
  connectOrCreate?: Maybe<WorkflowEventSettingCreateOrConnectWithoutWorkflowEventActionsInput>;
  create?: Maybe<WorkflowEventSettingCreateWithoutWorkflowEventActionsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<WorkflowEventSettingUpdateToOneWithWhereWithoutWorkflowEventActionsInput>;
  upsert?: Maybe<WorkflowEventSettingUpsertWithoutWorkflowEventActionsInput>;
};

export type WorkflowEventSettingUpdateToOneWithWhereWithoutActionsInput = {
  data: WorkflowEventSettingUpdateWithoutActionsInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpdateToOneWithWhereWithoutAutomationRunsInput = {
  data: WorkflowEventSettingUpdateWithoutAutomationRunsInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpdateToOneWithWhereWithoutChannelAutomationStatusesInput = {
  data: WorkflowEventSettingUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpdateToOneWithWhereWithoutChannelCreationSourcesInput = {
  data: WorkflowEventSettingUpdateWithoutChannelCreationSourcesInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpdateToOneWithWhereWithoutClinicEmployeesInput = {
  data: WorkflowEventSettingUpdateWithoutClinicEmployeesInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpdateToOneWithWhereWithoutClinicRoomsInput = {
  data: WorkflowEventSettingUpdateWithoutClinicRoomsInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpdateToOneWithWhereWithoutInformAutomationCampaignsInput = {
  data: WorkflowEventSettingUpdateWithoutInformAutomationCampaignsInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpdateToOneWithWhereWithoutLapsedPetParentTriggersInput = {
  data: WorkflowEventSettingUpdateWithoutLapsedPetParentTriggersInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpdateToOneWithWhereWithoutWorkflowEventActionsInput = {
  data: WorkflowEventSettingUpdateWithoutWorkflowEventActionsInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpdateToOneWithWhereWithoutWorkflowTriggersInput = {
  data: WorkflowEventSettingUpdateWithoutWorkflowTriggersInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpdateWithWhereUniqueWithoutAppointmentTypesInput = {
  data: WorkflowEventSettingUpdateWithoutAppointmentTypesInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpdateWithWhereUniqueWithoutAppointmentsInput = {
  data: WorkflowEventSettingUpdateWithoutAppointmentsInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpdateWithWhereUniqueWithoutClinicInput = {
  data: WorkflowEventSettingUpdateWithoutClinicInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpdateWithWhereUniqueWithoutInitialChannelStatusChangeInput = {
  data: WorkflowEventSettingUpdateWithoutInitialChannelStatusChangeInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpdateWithWhereUniqueWithoutMessagingCampaignInput = {
  data: WorkflowEventSettingUpdateWithoutMessagingCampaignInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpdateWithWhereUniqueWithoutSurveySettingInput = {
  data: WorkflowEventSettingUpdateWithoutSurveySettingInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpdateWithWhereUniqueWithoutTriggeringFormTemplatesInput = {
  data: WorkflowEventSettingUpdateWithoutTriggeringFormTemplatesInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpdateWithWhereUniqueWithoutWidgetRequestTypesInput = {
  data: WorkflowEventSettingUpdateWithoutWidgetRequestTypesInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpdateWithoutActionsInput = {
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutAppointmentTypesInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutAppointmentsInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutAutomationRunsInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutChannelAutomationStatusesInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutChannelCreationSourcesInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutClinicEmployeesInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutClinicInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutClinicRoomsInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutInformAutomationCampaignsInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutInitialChannelStatusChangeInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutLapsedPetParentTriggersInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutMessagingCampaignInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutSurveySettingInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutTriggeringFormTemplatesInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutWidgetRequestTypesInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutWorkflowEventActionsInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowTriggers?: Maybe<WorkflowTriggerUpdateManyWithoutWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpdateWithoutWorkflowTriggersInput = {
  actions?: Maybe<WorkflowEventActionUpdateManyWithoutWorkflowEventSettingNestedInput>;
  appointmentTypes?: Maybe<AppointmentTypeUpdateManyWithoutWorkflowsNestedInput>;
  appointments?: Maybe<AppointmentUpdateManyWithoutWorkflowsNestedInput>;
  automatedTriggerInMinutes?: Maybe<Scalars['Int']>;
  automatedTriggerTimeOfDay?: Maybe<Scalars['DateTime']>;
  automatedTriggerType?: Maybe<AutomatedTriggerType>;
  automationRuns?: Maybe<AutomationRunUpdateManyWithoutOriginAutomationNestedInput>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusUpdateManyWithoutWorkflowEventSettingNestedInput>;
  channelCreationSources?: Maybe<ChannelCreationSourceUpdateManyWithoutWorkflowEventSettingNestedInput>;
  childRunEvaluationStatus?: Maybe<ConditionEvaluationStatus>;
  clinic?: Maybe<ClinicUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingUpdateManyWithoutWorkflowNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<WorkflowEvent>;
  groupByWindowInHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignUpdateManyWithoutWorkflowEventSettingNestedInput>;
  initialChannelStatusChange?: Maybe<ChannelStatusUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersUpdateManyWithoutAutomationNestedInput>;
  messagingCampaign?: Maybe<MessagingCampaignUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  sendingHours?: Maybe<WorkflowSendingHours>;
  surveySetting?: Maybe<SurveySettingUpdateOneWithoutWorkflowEventSettingsNestedInput>;
  surveyStep?: Maybe<SurveyStep>;
  surveyType?: Maybe<SurveyType>;
  timeFormat?: Maybe<Scalars['String']>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
  triggeringFormTemplates?: Maybe<FormTemplateUpdateManyWithoutTriggeredWorkflowsNestedInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visitType?: Maybe<WorkflowVisitType>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeUpdateManyWithoutWorkflowsNestedInput>;
  workflowEventActions?: Maybe<WorkflowEventActionUpdateManyWithoutTriggerWorkflowNestedInput>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowEventSettingUpsertWithWhereUniqueWithoutAppointmentTypesInput = {
  create: WorkflowEventSettingCreateWithoutAppointmentTypesInput;
  update: WorkflowEventSettingUpdateWithoutAppointmentTypesInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpsertWithWhereUniqueWithoutAppointmentsInput = {
  create: WorkflowEventSettingCreateWithoutAppointmentsInput;
  update: WorkflowEventSettingUpdateWithoutAppointmentsInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpsertWithWhereUniqueWithoutClinicInput = {
  create: WorkflowEventSettingCreateWithoutClinicInput;
  update: WorkflowEventSettingUpdateWithoutClinicInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpsertWithWhereUniqueWithoutInitialChannelStatusChangeInput = {
  create: WorkflowEventSettingCreateWithoutInitialChannelStatusChangeInput;
  update: WorkflowEventSettingUpdateWithoutInitialChannelStatusChangeInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpsertWithWhereUniqueWithoutMessagingCampaignInput = {
  create: WorkflowEventSettingCreateWithoutMessagingCampaignInput;
  update: WorkflowEventSettingUpdateWithoutMessagingCampaignInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpsertWithWhereUniqueWithoutSurveySettingInput = {
  create: WorkflowEventSettingCreateWithoutSurveySettingInput;
  update: WorkflowEventSettingUpdateWithoutSurveySettingInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpsertWithWhereUniqueWithoutTriggeringFormTemplatesInput = {
  create: WorkflowEventSettingCreateWithoutTriggeringFormTemplatesInput;
  update: WorkflowEventSettingUpdateWithoutTriggeringFormTemplatesInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpsertWithWhereUniqueWithoutWidgetRequestTypesInput = {
  create: WorkflowEventSettingCreateWithoutWidgetRequestTypesInput;
  update: WorkflowEventSettingUpdateWithoutWidgetRequestTypesInput;
  where: WorkflowEventSettingWhereUniqueInput;
};

export type WorkflowEventSettingUpsertWithoutActionsInput = {
  create: WorkflowEventSettingCreateWithoutActionsInput;
  update: WorkflowEventSettingUpdateWithoutActionsInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpsertWithoutAutomationRunsInput = {
  create: WorkflowEventSettingCreateWithoutAutomationRunsInput;
  update: WorkflowEventSettingUpdateWithoutAutomationRunsInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpsertWithoutChannelAutomationStatusesInput = {
  create: WorkflowEventSettingCreateWithoutChannelAutomationStatusesInput;
  update: WorkflowEventSettingUpdateWithoutChannelAutomationStatusesInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpsertWithoutChannelCreationSourcesInput = {
  create: WorkflowEventSettingCreateWithoutChannelCreationSourcesInput;
  update: WorkflowEventSettingUpdateWithoutChannelCreationSourcesInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpsertWithoutClinicEmployeesInput = {
  create: WorkflowEventSettingCreateWithoutClinicEmployeesInput;
  update: WorkflowEventSettingUpdateWithoutClinicEmployeesInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpsertWithoutClinicRoomsInput = {
  create: WorkflowEventSettingCreateWithoutClinicRoomsInput;
  update: WorkflowEventSettingUpdateWithoutClinicRoomsInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpsertWithoutInformAutomationCampaignsInput = {
  create: WorkflowEventSettingCreateWithoutInformAutomationCampaignsInput;
  update: WorkflowEventSettingUpdateWithoutInformAutomationCampaignsInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpsertWithoutLapsedPetParentTriggersInput = {
  create: WorkflowEventSettingCreateWithoutLapsedPetParentTriggersInput;
  update: WorkflowEventSettingUpdateWithoutLapsedPetParentTriggersInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpsertWithoutWorkflowEventActionsInput = {
  create: WorkflowEventSettingCreateWithoutWorkflowEventActionsInput;
  update: WorkflowEventSettingUpdateWithoutWorkflowEventActionsInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingUpsertWithoutWorkflowTriggersInput = {
  create: WorkflowEventSettingCreateWithoutWorkflowTriggersInput;
  update: WorkflowEventSettingUpdateWithoutWorkflowTriggersInput;
  where?: Maybe<WorkflowEventSettingWhereInput>;
};

export type WorkflowEventSettingWhereInput = {
  AND?: Maybe<Array<WorkflowEventSettingWhereInput>>;
  NOT?: Maybe<Array<WorkflowEventSettingWhereInput>>;
  OR?: Maybe<Array<WorkflowEventSettingWhereInput>>;
  actions?: Maybe<WorkflowEventActionListRelationFilter>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  automatedTriggerInMinutes?: Maybe<IntNullableFilter>;
  automatedTriggerTimeOfDay?: Maybe<DateTimeNullableFilter>;
  automatedTriggerType?: Maybe<EnumAutomatedTriggerTypeNullableFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  childRunEvaluationStatus?: Maybe<EnumConditionEvaluationStatusFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  event?: Maybe<EnumWorkflowEventFilter>;
  groupByWindowInHours?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignListRelationFilter>;
  initialChannelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  initialChannelStatusChangeId?: Maybe<StringNullableFilter>;
  isPublished?: Maybe<BoolNullableFilter>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersListRelationFilter>;
  messagingCampaign?: Maybe<MessagingCampaignNullableScalarRelationFilter>;
  messagingCampaignId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  notificationBody?: Maybe<StringNullableFilter>;
  sendingHours?: Maybe<EnumWorkflowSendingHoursFilter>;
  surveySetting?: Maybe<SurveySettingNullableScalarRelationFilter>;
  surveySettingId?: Maybe<StringNullableFilter>;
  surveyStep?: Maybe<EnumSurveyStepNullableFilter>;
  surveyType?: Maybe<EnumSurveyTypeNullableFilter>;
  timeFormat?: Maybe<StringNullableFilter>;
  triggerType?: Maybe<EnumWorkflowEventTriggerTypeFilter>;
  triggeringFormTemplates?: Maybe<FormTemplateListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visitType?: Maybe<EnumWorkflowVisitTypeFilter>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  workflowEventActions?: Maybe<WorkflowEventActionListRelationFilter>;
  workflowTriggers?: Maybe<WorkflowTriggerListRelationFilter>;
  workflowType?: Maybe<EnumWorkflowTypeFilter>;
};

export type WorkflowEventSettingWhereUniqueInput = {
  AND?: Maybe<Array<WorkflowEventSettingWhereInput>>;
  NOT?: Maybe<Array<WorkflowEventSettingWhereInput>>;
  OR?: Maybe<Array<WorkflowEventSettingWhereInput>>;
  actions?: Maybe<WorkflowEventActionListRelationFilter>;
  appointmentTypes?: Maybe<AppointmentTypeListRelationFilter>;
  appointments?: Maybe<AppointmentListRelationFilter>;
  automatedTriggerInMinutes?: Maybe<IntNullableFilter>;
  automatedTriggerTimeOfDay?: Maybe<DateTimeNullableFilter>;
  automatedTriggerType?: Maybe<EnumAutomatedTriggerTypeNullableFilter>;
  automationRuns?: Maybe<AutomationRunListRelationFilter>;
  channelAutomationStatuses?: Maybe<ChannelAutomationStatusListRelationFilter>;
  channelCreationSources?: Maybe<ChannelCreationSourceListRelationFilter>;
  childRunEvaluationStatus?: Maybe<EnumConditionEvaluationStatusFilter>;
  clinic?: Maybe<ClinicNullableScalarRelationFilter>;
  clinicEmployees?: Maybe<ClinicEmployeeToWorkflowEventSettingListRelationFilter>;
  clinicId?: Maybe<StringNullableFilter>;
  clinicRooms?: Maybe<ClinicRoomToWorkflowEventSettingListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  event?: Maybe<EnumWorkflowEventFilter>;
  groupByWindowInHours?: Maybe<IntFilter>;
  id?: Maybe<Scalars['String']>;
  informAutomationCampaigns?: Maybe<InformAutomationCampaignListRelationFilter>;
  initialChannelStatusChange?: Maybe<ChannelStatusNullableScalarRelationFilter>;
  initialChannelStatusChangeId?: Maybe<StringNullableFilter>;
  isPublished?: Maybe<BoolNullableFilter>;
  lapsedPetParentTriggers?: Maybe<LapsedPetParentTriggersListRelationFilter>;
  messagingCampaign?: Maybe<MessagingCampaignNullableScalarRelationFilter>;
  messagingCampaignId?: Maybe<StringNullableFilter>;
  name?: Maybe<StringFilter>;
  notificationBody?: Maybe<StringNullableFilter>;
  sendingHours?: Maybe<EnumWorkflowSendingHoursFilter>;
  surveySetting?: Maybe<SurveySettingNullableScalarRelationFilter>;
  surveySettingId?: Maybe<StringNullableFilter>;
  surveyStep?: Maybe<EnumSurveyStepNullableFilter>;
  surveyType?: Maybe<EnumSurveyTypeNullableFilter>;
  timeFormat?: Maybe<StringNullableFilter>;
  triggerType?: Maybe<EnumWorkflowEventTriggerTypeFilter>;
  triggeringFormTemplates?: Maybe<FormTemplateListRelationFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  visitType?: Maybe<EnumWorkflowVisitTypeFilter>;
  widgetRequestTypes?: Maybe<ClinicWidgetRequestTypeListRelationFilter>;
  workflowEventActions?: Maybe<WorkflowEventActionListRelationFilter>;
  workflowTriggers?: Maybe<WorkflowTriggerListRelationFilter>;
  workflowType?: Maybe<EnumWorkflowTypeFilter>;
};

export enum WorkflowEventTriggerType {
  Automated = 'Automated',
  Manual = 'Manual'
}

export enum WorkflowSendingHours {
  All24Hours = 'All24Hours',
  AutomationHours = 'AutomationHours',
  BusinessHours = 'BusinessHours'
}

export type WorkflowTrigger = {
  __typename?: 'WorkflowTrigger';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  hasTriggered: Scalars['Boolean'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  triggerAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  workflow: WorkflowEventSetting;
  workflowId: Scalars['String'];
};


export type WorkflowTriggerAppointmentArgs = {
  where?: Maybe<AppointmentWhereInput>;
};

export type WorkflowTriggerAppointmentIdWorkflowIdCompoundUniqueInput = {
  appointmentId: Scalars['String'];
  workflowId: Scalars['String'];
};

export type WorkflowTriggerCountAggregateOutputType = {
  __typename?: 'WorkflowTriggerCountAggregateOutputType';
  _all: Scalars['Int'];
  appointmentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  hasTriggered: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted: Scalars['Int'];
  triggerAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
  workflowId: Scalars['Int'];
};

export type WorkflowTriggerCountOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  hasTriggered?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowId?: Maybe<SortOrder>;
};

export type WorkflowTriggerCreateInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutWorkflowTriggersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow: WorkflowEventSettingCreateNestedOneWithoutWorkflowTriggersInput;
};

export type WorkflowTriggerCreateManyAppointmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['String'];
};

export type WorkflowTriggerCreateManyAppointmentInputEnvelope = {
  data: Array<WorkflowTriggerCreateManyAppointmentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type WorkflowTriggerCreateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['String'];
};

export type WorkflowTriggerCreateManyWorkflowInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WorkflowTriggerCreateManyWorkflowInputEnvelope = {
  data: Array<WorkflowTriggerCreateManyWorkflowInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type WorkflowTriggerCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowTriggerCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<WorkflowTriggerCreateWithoutAppointmentInput>>;
  createMany?: Maybe<WorkflowTriggerCreateManyAppointmentInputEnvelope>;
};

export type WorkflowTriggerCreateNestedManyWithoutWorkflowInput = {
  connect?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowTriggerCreateOrConnectWithoutWorkflowInput>>;
  create?: Maybe<Array<WorkflowTriggerCreateWithoutWorkflowInput>>;
  createMany?: Maybe<WorkflowTriggerCreateManyWorkflowInputEnvelope>;
};

export type WorkflowTriggerCreateOrConnectWithoutAppointmentInput = {
  create: WorkflowTriggerCreateWithoutAppointmentInput;
  where: WorkflowTriggerWhereUniqueInput;
};

export type WorkflowTriggerCreateOrConnectWithoutWorkflowInput = {
  create: WorkflowTriggerCreateWithoutWorkflowInput;
  where: WorkflowTriggerWhereUniqueInput;
};

export type WorkflowTriggerCreateWithoutAppointmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow: WorkflowEventSettingCreateNestedOneWithoutWorkflowTriggersInput;
};

export type WorkflowTriggerCreateWithoutWorkflowInput = {
  appointment?: Maybe<AppointmentCreateNestedOneWithoutWorkflowTriggersInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WorkflowTriggerGroupByOutputType = {
  __typename?: 'WorkflowTriggerGroupByOutputType';
  _count?: Maybe<WorkflowTriggerCountAggregateOutputType>;
  _max?: Maybe<WorkflowTriggerMaxAggregateOutputType>;
  _min?: Maybe<WorkflowTriggerMinAggregateOutputType>;
  appointmentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  hasTriggered: Scalars['Boolean'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  triggerAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  workflowId: Scalars['String'];
};

export type WorkflowTriggerListRelationFilter = {
  every?: Maybe<WorkflowTriggerWhereInput>;
  none?: Maybe<WorkflowTriggerWhereInput>;
  some?: Maybe<WorkflowTriggerWhereInput>;
};

export type WorkflowTriggerMaxAggregateOutputType = {
  __typename?: 'WorkflowTriggerMaxAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type WorkflowTriggerMaxOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  hasTriggered?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowId?: Maybe<SortOrder>;
};

export type WorkflowTriggerMinAggregateOutputType = {
  __typename?: 'WorkflowTriggerMinAggregateOutputType';
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type WorkflowTriggerMinOrderByAggregateInput = {
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  hasTriggered?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowId?: Maybe<SortOrder>;
};

export type WorkflowTriggerOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type WorkflowTriggerOrderByRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<WorkflowTriggerOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  hasTriggered?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflow?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowId?: Maybe<SortOrder>;
};

export enum WorkflowTriggerOrderByRelevanceFieldEnum {
  AppointmentId = 'appointmentId',
  Id = 'id',
  WorkflowId = 'workflowId'
}

export type WorkflowTriggerOrderByRelevanceInput = {
  fields: Array<WorkflowTriggerOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type WorkflowTriggerOrderByWithAggregationInput = {
  _count?: Maybe<WorkflowTriggerCountOrderByAggregateInput>;
  _max?: Maybe<WorkflowTriggerMaxOrderByAggregateInput>;
  _min?: Maybe<WorkflowTriggerMinOrderByAggregateInput>;
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  hasTriggered?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflowId?: Maybe<SortOrder>;
};

export type WorkflowTriggerOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: Maybe<WorkflowTriggerOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  hasTriggered?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflow?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowId?: Maybe<SortOrder>;
};

export type WorkflowTriggerOrderByWithRelationInput = {
  _relevance?: Maybe<WorkflowTriggerOrderByRelevanceInput>;
  appointment?: Maybe<AppointmentOrderByWithRelationInput>;
  appointmentId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  hasTriggered?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isDeleted?: Maybe<SortOrder>;
  triggerAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  workflow?: Maybe<WorkflowEventSettingOrderByWithRelationInput>;
  workflowId?: Maybe<SortOrder>;
};

export enum WorkflowTriggerScalarFieldEnum {
  AppointmentId = 'appointmentId',
  CreatedAt = 'createdAt',
  HasTriggered = 'hasTriggered',
  Id = 'id',
  IsDeleted = 'isDeleted',
  TriggerAt = 'triggerAt',
  UpdatedAt = 'updatedAt',
  WorkflowId = 'workflowId'
}

export type WorkflowTriggerScalarWhereInput = {
  AND?: Maybe<Array<WorkflowTriggerScalarWhereInput>>;
  NOT?: Maybe<Array<WorkflowTriggerScalarWhereInput>>;
  OR?: Maybe<Array<WorkflowTriggerScalarWhereInput>>;
  appointmentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  hasTriggered?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  triggerAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflowId?: Maybe<StringFilter>;
};

export type WorkflowTriggerScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<WorkflowTriggerScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<WorkflowTriggerScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<WorkflowTriggerScalarWhereWithAggregatesInput>>;
  appointmentId?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  hasTriggered?: Maybe<BoolWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isDeleted?: Maybe<BoolWithAggregatesFilter>;
  triggerAt?: Maybe<DateTimeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
  workflowId?: Maybe<StringWithAggregatesFilter>;
};

export type WorkflowTriggerUncheckedCreateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['String'];
};

export type WorkflowTriggerUncheckedCreateNestedManyWithoutAppointmentInput = {
  connect?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowTriggerCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<WorkflowTriggerCreateWithoutAppointmentInput>>;
  createMany?: Maybe<WorkflowTriggerCreateManyAppointmentInputEnvelope>;
};

export type WorkflowTriggerUncheckedCreateNestedManyWithoutWorkflowInput = {
  connect?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowTriggerCreateOrConnectWithoutWorkflowInput>>;
  create?: Maybe<Array<WorkflowTriggerCreateWithoutWorkflowInput>>;
  createMany?: Maybe<WorkflowTriggerCreateManyWorkflowInputEnvelope>;
};

export type WorkflowTriggerUncheckedCreateWithoutAppointmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['String'];
};

export type WorkflowTriggerUncheckedCreateWithoutWorkflowInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WorkflowTriggerUncheckedUpdateInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type WorkflowTriggerUncheckedUpdateManyInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type WorkflowTriggerUncheckedUpdateManyWithoutAppointmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type WorkflowTriggerUncheckedUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowTriggerCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<WorkflowTriggerCreateWithoutAppointmentInput>>;
  createMany?: Maybe<WorkflowTriggerCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowTriggerScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowTriggerUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<WorkflowTriggerUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<WorkflowTriggerUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type WorkflowTriggerUncheckedUpdateManyWithoutWorkflowInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WorkflowTriggerUncheckedUpdateManyWithoutWorkflowNestedInput = {
  connect?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowTriggerCreateOrConnectWithoutWorkflowInput>>;
  create?: Maybe<Array<WorkflowTriggerCreateWithoutWorkflowInput>>;
  createMany?: Maybe<WorkflowTriggerCreateManyWorkflowInputEnvelope>;
  delete?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowTriggerScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowTriggerUpdateWithWhereUniqueWithoutWorkflowInput>>;
  updateMany?: Maybe<Array<WorkflowTriggerUpdateManyWithWhereWithoutWorkflowInput>>;
  upsert?: Maybe<Array<WorkflowTriggerUpsertWithWhereUniqueWithoutWorkflowInput>>;
};

export type WorkflowTriggerUncheckedUpdateWithoutAppointmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type WorkflowTriggerUncheckedUpdateWithoutWorkflowInput = {
  appointmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WorkflowTriggerUpdateInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutWorkflowTriggersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutWorkflowTriggersNestedInput>;
};

export type WorkflowTriggerUpdateManyMutationInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WorkflowTriggerUpdateManyWithWhereWithoutAppointmentInput = {
  data: WorkflowTriggerUpdateManyMutationInput;
  where: WorkflowTriggerScalarWhereInput;
};

export type WorkflowTriggerUpdateManyWithWhereWithoutWorkflowInput = {
  data: WorkflowTriggerUpdateManyMutationInput;
  where: WorkflowTriggerScalarWhereInput;
};

export type WorkflowTriggerUpdateManyWithoutAppointmentNestedInput = {
  connect?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowTriggerCreateOrConnectWithoutAppointmentInput>>;
  create?: Maybe<Array<WorkflowTriggerCreateWithoutAppointmentInput>>;
  createMany?: Maybe<WorkflowTriggerCreateManyAppointmentInputEnvelope>;
  delete?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowTriggerScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowTriggerUpdateWithWhereUniqueWithoutAppointmentInput>>;
  updateMany?: Maybe<Array<WorkflowTriggerUpdateManyWithWhereWithoutAppointmentInput>>;
  upsert?: Maybe<Array<WorkflowTriggerUpsertWithWhereUniqueWithoutAppointmentInput>>;
};

export type WorkflowTriggerUpdateManyWithoutWorkflowNestedInput = {
  connect?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<WorkflowTriggerCreateOrConnectWithoutWorkflowInput>>;
  create?: Maybe<Array<WorkflowTriggerCreateWithoutWorkflowInput>>;
  createMany?: Maybe<WorkflowTriggerCreateManyWorkflowInputEnvelope>;
  delete?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  deleteMany?: Maybe<Array<WorkflowTriggerScalarWhereInput>>;
  disconnect?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  set?: Maybe<Array<WorkflowTriggerWhereUniqueInput>>;
  update?: Maybe<Array<WorkflowTriggerUpdateWithWhereUniqueWithoutWorkflowInput>>;
  updateMany?: Maybe<Array<WorkflowTriggerUpdateManyWithWhereWithoutWorkflowInput>>;
  upsert?: Maybe<Array<WorkflowTriggerUpsertWithWhereUniqueWithoutWorkflowInput>>;
};

export type WorkflowTriggerUpdateWithWhereUniqueWithoutAppointmentInput = {
  data: WorkflowTriggerUpdateWithoutAppointmentInput;
  where: WorkflowTriggerWhereUniqueInput;
};

export type WorkflowTriggerUpdateWithWhereUniqueWithoutWorkflowInput = {
  data: WorkflowTriggerUpdateWithoutWorkflowInput;
  where: WorkflowTriggerWhereUniqueInput;
};

export type WorkflowTriggerUpdateWithoutAppointmentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<WorkflowEventSettingUpdateOneRequiredWithoutWorkflowTriggersNestedInput>;
};

export type WorkflowTriggerUpdateWithoutWorkflowInput = {
  appointment?: Maybe<AppointmentUpdateOneWithoutWorkflowTriggersNestedInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTriggered?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  triggerAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WorkflowTriggerUpsertWithWhereUniqueWithoutAppointmentInput = {
  create: WorkflowTriggerCreateWithoutAppointmentInput;
  update: WorkflowTriggerUpdateWithoutAppointmentInput;
  where: WorkflowTriggerWhereUniqueInput;
};

export type WorkflowTriggerUpsertWithWhereUniqueWithoutWorkflowInput = {
  create: WorkflowTriggerCreateWithoutWorkflowInput;
  update: WorkflowTriggerUpdateWithoutWorkflowInput;
  where: WorkflowTriggerWhereUniqueInput;
};

export type WorkflowTriggerWhereInput = {
  AND?: Maybe<Array<WorkflowTriggerWhereInput>>;
  NOT?: Maybe<Array<WorkflowTriggerWhereInput>>;
  OR?: Maybe<Array<WorkflowTriggerWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  hasTriggered?: Maybe<BoolFilter>;
  id?: Maybe<StringFilter>;
  isDeleted?: Maybe<BoolFilter>;
  triggerAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflow?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  workflowId?: Maybe<StringFilter>;
};

export type WorkflowTriggerWhereUniqueInput = {
  AND?: Maybe<Array<WorkflowTriggerWhereInput>>;
  NOT?: Maybe<Array<WorkflowTriggerWhereInput>>;
  OR?: Maybe<Array<WorkflowTriggerWhereInput>>;
  appointment?: Maybe<AppointmentNullableScalarRelationFilter>;
  appointmentId?: Maybe<StringNullableFilter>;
  appointmentId_workflowId?: Maybe<WorkflowTriggerAppointmentIdWorkflowIdCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  hasTriggered?: Maybe<BoolFilter>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<BoolFilter>;
  triggerAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workflow?: Maybe<WorkflowEventSettingScalarRelationFilter>;
  workflowId?: Maybe<StringFilter>;
};

export enum WorkflowType {
  Boarding = 'Boarding',
  Curbside = 'Curbside',
  Diagnostics = 'Diagnostics',
  Emergency = 'Emergency',
  InHouse = 'InHouse',
  MobileVisit = 'MobileVisit',
  NoWorkflow = 'NoWorkflow',
  Specialty = 'Specialty',
  Surgery = 'Surgery',
  Telemedicine = 'Telemedicine',
  Wellness = 'Wellness'
}

export enum WorkflowVisitType {
  Client = 'Client',
  Patient = 'Patient'
}

export type WritebackCareInvoiceAccountCreditToPimsInput = {
  invoiceId: Scalars['String'];
  paymentAmount: Scalars['Int'];
};

export type WritebackCareInvoiceAccountCreditToPimsResponse = {
  __typename?: 'WritebackCareInvoiceAccountCreditToPimsResponse';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type GetQuickSightEmbedUrlInput = {
  dashboardId: Scalars['String'];
};

export type SendEmailCampaignNowInput = {
  emailCampaignId: Scalars['String'];
};

export type SendVetSubscriptionReceiptInput = {
  clinicId: Scalars['String'];
  emails?: Maybe<Array<Maybe<Scalars['String']>>>;
  firebaseId: Scalars['String'];
};

export type SentEmailCampaign = {
  __typename?: 'sentEmailCampaign';
  id?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
};

export type GetAppointmentModalAppointmentQueryVariables = Exact<{
  where: AppointmentWhereUniqueInput;
}>;


export type GetAppointmentModalAppointmentQuery = (
  { __typename?: 'Query' }
  & { findUniqueAppointment?: Maybe<(
    { __typename?: 'Appointment' }
    & Pick<Appointment, 'id' | 'description' | 'recapNotes' | 'durationInMinutes' | 'pimsId' | 'startAt' | 'createdAt' | 'integrationId' | 'clinicPetId' | 'status'>
    & { workflows: Array<(
      { __typename?: 'WorkflowEventSetting' }
      & Pick<WorkflowEventSetting, 'id'>
    )>, room?: Maybe<(
      { __typename?: 'ClinicRoom' }
      & Pick<ClinicRoom, 'id' | 'name'>
    )>, appointmentType?: Maybe<(
      { __typename?: 'AppointmentType' }
      & Pick<AppointmentType, 'id' | 'name'>
    )>, clinicEmployees: Array<(
      { __typename?: 'ClinicEmployee' }
      & Pick<ClinicEmployee, 'id' | 'firstName' | 'lastName'>
    )>, clinicPetParents: Array<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
    )>, clinicPet?: Maybe<(
      { __typename?: 'ClinicPet' }
      & AppointmentPetFragment
    )>, aiRecapPimsWritebackLogEntry: Array<(
      { __typename?: 'AiRecapPimsWritebackLogEntry' }
      & { writebackLog: (
        { __typename?: 'PimsWritebackLogEntry' }
        & Pick<PimsWritebackLogEntry, 'id' | 'status' | 'updatedAt'>
      ) }
    )>, channel?: Maybe<(
      { __typename?: 'Channel' }
      & Pick<Channel, 'id' | 'tags'>
      & { channelStatus?: Maybe<(
        { __typename?: 'ChannelStatus' }
        & Pick<ChannelStatus, 'id' | 'name' | 'color' | 'channelStatusAction'>
      )> }
    )> }
  )> }
);

export type GetAppointmentModalAppointmentProvidersQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetAppointmentModalAppointmentProvidersQuery = (
  { __typename?: 'Query' }
  & { clinicEmployees: Array<(
    { __typename?: 'ClinicEmployee' }
    & ClinicEmployeeBaseSelectionFragment
  )> }
);

export type GetAppointmentModalAppointmentRoomsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetAppointmentModalAppointmentRoomsQuery = (
  { __typename?: 'Query' }
  & { clinicRooms: Array<(
    { __typename?: 'ClinicRoom' }
    & ClinicRoomBaseSelectionFragment
  )> }
);

export type GetAppointmentModalAppointmentTypesQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetAppointmentModalAppointmentTypesQuery = (
  { __typename?: 'Query' }
  & { appointmentTypes: Array<(
    { __typename?: 'AppointmentType' }
    & AppointmentTypeWorkflowsSelectionFragment
  )> }
);

export type GetAppointmentModalAutomationsQueryVariables = Exact<{
  clinicId: Scalars['String'];
  triggerType?: Maybe<WorkflowEventTriggerType>;
}>;


export type GetAppointmentModalAutomationsQuery = (
  { __typename?: 'Query' }
  & { automations: Array<(
    { __typename?: 'WorkflowEventSetting' }
    & Pick<WorkflowEventSetting, 'id' | 'name' | 'surveySettingId'>
  )> }
);

export type GetAppointmentModalRecapsQueryVariables = Exact<{
  where?: Maybe<RecapWhereInput>;
}>;


export type GetAppointmentModalRecapsQuery = (
  { __typename?: 'Query' }
  & { findManyRecap: Array<(
    { __typename?: 'Recap' }
    & Pick<Recap, 'createdAt' | 'transcriptionText'>
  )> }
);

export type SearchAppointmentPetsQueryVariables = Exact<{
  whereInput?: Maybe<SearchClinicPetInput>;
  pageSize?: Maybe<Scalars['Int']>;
}>;


export type SearchAppointmentPetsQuery = (
  { __typename?: 'Query' }
  & { clinicPetSearch: Array<(
    { __typename?: 'ClinicPet' }
    & AppointmentPetFragment
  )> }
);

export type TriggerAiRecapExportToPimsMutationVariables = Exact<{
  where: AppointmentWhereUniqueInput;
}>;


export type TriggerAiRecapExportToPimsMutation = (
  { __typename?: 'Mutation' }
  & { aiRecapExportToPims: (
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'success' | 'payload'>
  ) }
);

export type GetNewAppointmentModalRecapsQueryVariables = Exact<{
  appointmentId: Scalars['String'];
}>;


export type GetNewAppointmentModalRecapsQuery = (
  { __typename?: 'Query' }
  & { findManyRecap: Array<(
    { __typename?: 'Recap' }
    & Pick<Recap, 'id' | 'createdAt' | 'generatedText'>
    & { createdBy: (
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    ) }
  )>, findUniqueAppointment?: Maybe<(
    { __typename?: 'Appointment' }
    & Pick<Appointment, 'recapNotes'>
  )> }
);

export type SubscribeToAppointmentRecapSubscriptionVariables = Exact<{
  where: RecapWhereInput;
}>;


export type SubscribeToAppointmentRecapSubscription = (
  { __typename?: 'Subscription' }
  & { recapChanged: (
    { __typename?: 'RecapSubscription' }
    & { node: (
      { __typename?: 'Recap' }
      & Pick<Recap, 'id'>
    ) }
  ) }
);

export type AppointmentBaseFragment = (
  { __typename?: 'Appointment' }
  & Pick<Appointment, 'id' | 'createdAt' | 'updatedAt' | 'description' | 'recapNotes' | 'durationInMinutes' | 'pimsId' | 'startAt' | 'consultationId' | 'integrationId' | 'appointmentTypeId' | 'isActive' | 'isDeleted' | 'title' | 'clinicPetId' | 'clinicId' | 'roomId' | 'status' | 'pimsStatus' | 'channelId' | 'recapNotesUpdatedAt'>
  & { recapNotesUpdatedBy?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
  )> }
);

export type AppointmentFullSelectionFragment = (
  { __typename?: 'Appointment' }
  & { workflows: Array<(
    { __typename?: 'WorkflowEventSetting' }
    & Pick<WorkflowEventSetting, 'id' | 'name'>
  )>, channel?: Maybe<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id'>
    & { channelStatus?: Maybe<(
      { __typename?: 'ChannelStatus' }
      & Pick<ChannelStatus, 'id' | 'name' | 'color' | 'channelStatusAction'>
    )> }
  )>, appointmentType?: Maybe<(
    { __typename?: 'AppointmentType' }
    & AppointmentTypeBaseSelectionFragment
  )>, room?: Maybe<(
    { __typename?: 'ClinicRoom' }
    & ClinicRoomBaseSelectionFragment
  )>, clinicEmployees: Array<(
    { __typename?: 'ClinicEmployee' }
    & ClinicEmployeeBaseSelectionFragment
  )>, clinicPet?: Maybe<(
    { __typename?: 'ClinicPet' }
    & ClinicPetNestedSelectionFragment
  )>, clinicPetParents: Array<(
    { __typename?: 'ClinicPetParent' }
    & ClinicPetParentSelectionFragment
  )> }
  & AppointmentBaseFragment
);

export type AppointmentPetFragment = (
  { __typename?: 'ClinicPet' }
  & Pick<ClinicPet, 'id' | 'breed' | 'dateOfBirth' | 'gender'>
  & { petParents: Array<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName' | 'clinicId' | 'email' | 'updatedAt'>
    & { phoneNumbers: Array<(
      { __typename?: 'ClinicEntityPhoneNumber' }
      & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'isPrimary' | 'isMobile' | 'isDeleted' | 'updatedAt'>
    )> }
  )> }
  & PetAvatarFragment
);

export type AppointmentTypeBaseSelectionFragment = (
  { __typename?: 'AppointmentType' }
  & Pick<AppointmentType, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'isVisible'>
);

export type AppointmentTypeWorkflowsSelectionFragment = (
  { __typename?: 'AppointmentType' }
  & { workflows: Array<(
    { __typename?: 'WorkflowEventSetting' }
    & Pick<WorkflowEventSetting, 'id' | 'name' | 'workflowType' | 'event'>
  )> }
  & AppointmentTypeBaseSelectionFragment
);

export type ClinicEmployeeBaseSelectionFragment = (
  { __typename?: 'ClinicEmployee' }
  & Pick<ClinicEmployee, 'id' | 'createdAt' | 'updatedAt' | 'firstName' | 'lastName' | 'isVisible'>
);

export type ClinicRoomBaseSelectionFragment = (
  { __typename?: 'ClinicRoom' }
  & Pick<ClinicRoom, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'isVisible'>
);

export type CreateOneAppointmentMutationVariables = Exact<{
  data: AppointmentCreateInput;
}>;


export type CreateOneAppointmentMutation = (
  { __typename?: 'Mutation' }
  & { createOneAppointment: (
    { __typename?: 'Appointment' }
    & AppointmentFullSelectionFragment
  ) }
);

export type UpdateOneAppointmentMutationVariables = Exact<{
  where: AppointmentWhereUniqueInput;
  data: AppointmentUpdateInput;
}>;


export type UpdateOneAppointmentMutation = (
  { __typename?: 'Mutation' }
  & { updateOneAppointment: (
    { __typename?: 'Appointment' }
    & AppointmentFullSelectionFragment
  ) }
);

export type FindManyAppointmentQueryVariables = Exact<{
  where?: Maybe<AppointmentWhereInput>;
  orderBy?: Maybe<Array<AppointmentOrderByWithRelationInput> | AppointmentOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type FindManyAppointmentQuery = (
  { __typename?: 'Query' }
  & { findManyAppointment: Array<(
    { __typename?: 'Appointment' }
    & AppointmentFullSelectionFragment
  )> }
);

export type FindManyAppointmentCountQueryVariables = Exact<{
  where?: Maybe<AppointmentWhereInput>;
  orderBy?: Maybe<Array<AppointmentOrderByWithRelationInput> | AppointmentOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type FindManyAppointmentCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyAppointmentCount'>
);

export type FindUniqueAppointmentQueryVariables = Exact<{
  where: AppointmentWhereUniqueInput;
}>;


export type FindUniqueAppointmentQuery = (
  { __typename?: 'Query' }
  & { findUniqueAppointment?: Maybe<(
    { __typename?: 'Appointment' }
    & AppointmentFullSelectionFragment
  )> }
);

export type GetAppointmentAiRecapInfoQueryVariables = Exact<{
  appointmentId: Scalars['String'];
  orderBy?: Maybe<Array<Maybe<RecapOrderByWithRelationInput>> | Maybe<RecapOrderByWithRelationInput>>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetAppointmentAiRecapInfoQuery = (
  { __typename?: 'Query' }
  & { findUniqueAppointment?: Maybe<(
    { __typename?: 'Appointment' }
    & Pick<Appointment, 'id' | 'recapNotes' | 'startAt' | 'clinicId' | 'recapNotesUpdatedAt'>
    & { appointmentType?: Maybe<(
      { __typename?: 'AppointmentType' }
      & Pick<AppointmentType, 'id' | 'name'>
    )>, clinicPetParents: Array<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
    )>, clinicPet?: Maybe<(
      { __typename?: 'ClinicPet' }
      & AppointmentPetFragment
    )>, recapNotesUpdatedBy?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    )> }
  )>, findManyRecap: Array<(
    { __typename?: 'Recap' }
    & Pick<Recap, 'id' | 'createdAt' | 'durationSeconds' | 'status' | 'templateId' | 'transcriptionText' | 'generatedText' | 'transcriptionS3Uri' | 'recordingS3Uri'>
    & { createdBy: (
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    ) }
  )> }
);

export type GetAppointmentOptionsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetAppointmentOptionsQuery = (
  { __typename?: 'Query' }
  & { clinicEmployees: Array<(
    { __typename?: 'ClinicEmployee' }
    & ClinicEmployeeBaseSelectionFragment
  )>, clinicRooms: Array<(
    { __typename?: 'ClinicRoom' }
    & ClinicRoomBaseSelectionFragment
  )>, appointmentTypes: Array<(
    { __typename?: 'AppointmentType' }
    & AppointmentTypeWorkflowsSelectionFragment
  )> }
);

export type GetAppointmentPetsQueryVariables = Exact<{
  whereInput?: Maybe<SearchClinicPetInput>;
  pageSize?: Maybe<Scalars['Int']>;
}>;


export type GetAppointmentPetsQuery = (
  { __typename?: 'Query' }
  & { clinicPetSearch: Array<(
    { __typename?: 'ClinicPet' }
    & AppointmentPetFragment
  )> }
);

export type GetAppointmentRecapUrlQueryVariables = Exact<{
  data: GetAppointmentRecapUrlInput;
}>;


export type GetAppointmentRecapUrlQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getAppointmentRecapUrl'>
);

export type GetFilterUserAppointmentGroupsOptionsQueryVariables = Exact<{
  where: UserAppointmentGroupingWhereInput;
}>;


export type GetFilterUserAppointmentGroupsOptionsQuery = (
  { __typename?: 'Query' }
  & { userAppointmentGroupings: Array<(
    { __typename?: 'UserAppointmentGrouping' }
    & Pick<UserAppointmentGrouping, 'id' | 'clinicId' | 'label'>
  )> }
);

export type GetUserAppointmentGroupingsQueryVariables = Exact<{
  where: UserAppointmentGroupingWhereInput;
  take: Scalars['Int'];
  skip: Scalars['Int'];
}>;


export type GetUserAppointmentGroupingsQuery = (
  { __typename?: 'Query' }
  & { count: Query['findManyUserAppointmentGroupingCount'] }
  & { userAppointmentGroupings: Array<(
    { __typename?: 'UserAppointmentGrouping' }
    & Pick<UserAppointmentGrouping, 'id' | 'clinicId' | 'label'>
    & { clinicEmployees: Array<(
      { __typename?: 'ClinicEmployee' }
      & Pick<ClinicEmployee, 'id' | 'firstName' | 'lastName'>
    )>, rooms: Array<(
      { __typename?: 'ClinicRoom' }
      & Pick<ClinicRoom, 'id' | 'name'>
    )>, appointmentTypes: Array<(
      { __typename?: 'AppointmentType' }
      & Pick<AppointmentType, 'id' | 'name'>
    )> }
  )> }
);

export type GetUserAppointmentGroupingsFiltersQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetUserAppointmentGroupingsFiltersQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'userAppointmentGroupingsFilters'>
);

export type SubscribeToRecapSummaryGeneratedSubscriptionVariables = Exact<{
  where: SubscriptionRecapSummaryGeneratedWhereInput;
}>;


export type SubscribeToRecapSummaryGeneratedSubscription = (
  { __typename?: 'Subscription' }
  & { recapSummaryGenerated: (
    { __typename?: 'RecapSummaryGeneratedSubscription' }
    & Pick<RecapSummaryGeneratedSubscription, 'mutation'>
    & { node: (
      { __typename?: 'Appointment' }
      & Pick<Appointment, 'id' | 'recapNotes' | 'recapNotesUpdatedAt'>
      & { recapNotesUpdatedBy?: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName'>
      )> }
    ) }
  ) }
);

export type AutomationEditorAutomationFragment = (
  { __typename?: 'WorkflowEventSetting' }
  & Pick<WorkflowEventSetting, 'id' | 'name' | 'isPublished' | 'triggerType' | 'visitType' | 'sendingHours' | 'automatedTriggerType' | 'automatedTriggerInMinutes' | 'automatedTriggerTimeOfDay' | 'event' | 'notificationBody' | 'timeFormat'>
  & { triggeringFormTemplates: Array<(
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id' | 'title'>
  )>, widgetRequestTypes: Array<(
    { __typename?: 'ClinicWidgetRequestType' }
    & Pick<ClinicWidgetRequestType, 'id' | 'displayName'>
  )>, appointmentTypes: Array<(
    { __typename?: 'AppointmentType' }
    & Pick<AppointmentType, 'id' | 'displayName' | 'name'>
  )>, clinicRooms: Array<(
    { __typename?: 'ClinicRoomToWorkflowEventSetting' }
    & Pick<ClinicRoomToWorkflowEventSetting, 'clinicRoomId'>
    & { clinicRoom: (
      { __typename?: 'ClinicRoom' }
      & Pick<ClinicRoom, 'id' | 'name'>
    ) }
  )>, clinicEmployees: Array<(
    { __typename?: 'ClinicEmployeeToWorkflowEventSetting' }
    & Pick<ClinicEmployeeToWorkflowEventSetting, 'clinicEmployeeId'>
    & { clinicEmployee: (
      { __typename?: 'ClinicEmployee' }
      & Pick<ClinicEmployee, 'id' | 'firstName' | 'lastName'>
    ) }
  )>, actions: Array<(
    { __typename?: 'WorkflowEventAction' }
    & Pick<WorkflowEventAction, 'id' | 'config' | 'promptType' | 'order' | 'channelStatusChangeId' | 'workflowEventTriggerDelayInMilliseconds' | 'workflowEventTriggerActionNumber' | 'triggerWorkflowId'>
  )>, conditionSets: Array<(
    { __typename?: 'ConditionSet' }
    & Pick<ConditionSet, 'id'>
  )> }
);

export type AutomationsListItemFragment = (
  { __typename?: 'WorkflowEventSetting' }
  & Pick<WorkflowEventSetting, 'id' | 'name' | 'isPublished' | 'sendingHours' | 'triggerType' | 'event' | 'childRunEvaluationStatus' | 'messagingCampaignId'>
  & { conditionSets: Array<(
    { __typename?: 'ConditionSet' }
    & Pick<ConditionSet, 'id'>
    & { conditions: Array<(
      { __typename?: 'Condition' }
      & Pick<Condition, 'id'>
    )> }
  )> }
);

export type AutomationsParentItemFragment = (
  { __typename?: 'WorkflowEventSetting' }
  & Pick<WorkflowEventSetting, 'id' | 'name' | 'isPublished'>
);

export type CreateAutomationAndSendConditionsMutationVariables = Exact<{
  workflowEventSettingData: WorkflowEventSettingCreateInput;
  conditionsData: Array<ConditionCreateWithoutSetInput> | ConditionCreateWithoutSetInput;
}>;


export type CreateAutomationAndSendConditionsMutation = (
  { __typename?: 'Mutation' }
  & { createWorkflowEventSettingAndConditions: (
    { __typename?: 'WorkflowEventSetting' }
    & AutomationEditorAutomationFragment
  ) }
);

export type DeleteOneAutomationMutationVariables = Exact<{
  workflowEventSettingId: Scalars['String'];
}>;


export type DeleteOneAutomationMutation = (
  { __typename?: 'Mutation' }
  & { deleteOneWorkflowEventSetting?: Maybe<(
    { __typename?: 'WorkflowEventSetting' }
    & Pick<WorkflowEventSetting, 'id'>
  )> }
);

export type DuplicateOneAutomationMutationVariables = Exact<{
  where: WorkflowEventSettingWhereUniqueInput;
}>;


export type DuplicateOneAutomationMutation = (
  { __typename?: 'Mutation' }
  & { copyOneWorkflowEventSetting: (
    { __typename?: 'WorkflowEventSetting' }
    & Pick<WorkflowEventSetting, 'id'>
  ) }
);

export type ToggleManyAutomationPublishedStateMutationVariables = Exact<{
  workflowEventSettingIds: Array<Scalars['String']> | Scalars['String'];
  isPublished: Scalars['Boolean'];
}>;


export type ToggleManyAutomationPublishedStateMutation = (
  { __typename?: 'Mutation' }
  & { bulkPublishWorkflowEventSettings: (
    { __typename?: 'BulkPublishWorkflowEventSettingsResponse' }
    & Pick<BulkPublishWorkflowEventSettingsResponse, 'count'>
  ) }
);

export type UpdateOneAutomationMutationVariables = Exact<{
  workflowEventSettingId: Scalars['String'];
  workflowEventSettingData: WorkflowEventSettingUpdateInput;
}>;


export type UpdateOneAutomationMutation = (
  { __typename?: 'Mutation' }
  & { updateOneWorkflowEventSetting: (
    { __typename?: 'WorkflowEventSetting' }
    & AutomationEditorAutomationFragment
  ) }
);

export type UpdateOneAutomationAndConditionSetMutationVariables = Exact<{
  workflowEventSettingId: Scalars['String'];
  workflowEventSettingData: WorkflowEventSettingUpdateInput;
  conditionSetId: Scalars['String'];
  conditionSetData: ConditionSetUpdateInput;
}>;


export type UpdateOneAutomationAndConditionSetMutation = (
  { __typename?: 'Mutation' }
  & { updateOneWorkflowEventSetting: (
    { __typename?: 'WorkflowEventSetting' }
    & AutomationEditorAutomationFragment
  ), updateOneConditionSet: (
    { __typename?: 'ConditionSet' }
    & AutomationEditorConditionSetFragment
  ) }
);

export type AutomationEditorConditionFragment = (
  { __typename?: 'Condition' }
  & Pick<Condition, 'id' | 'createdAt' | 'attribute' | 'operator' | 'operand' | 'checksum'>
);

export type AutomationEditorConditionSetFragment = (
  { __typename?: 'ConditionSet' }
  & Pick<ConditionSet, 'id' | 'conditionalEntityType' | 'conditionalEntityId' | 'parentConditionSetId' | 'operator' | 'negate'>
  & { conditions: Array<(
    { __typename?: 'Condition' }
    & AutomationEditorConditionFragment
  )> }
);

export type GetAutomationEditorDataQueryVariables = Exact<{
  workflowEventSettingId?: Maybe<Scalars['String']>;
}>;


export type GetAutomationEditorDataQuery = (
  { __typename?: 'Query' }
  & { findUniqueWorkflowEventSetting?: Maybe<(
    { __typename?: 'WorkflowEventSetting' }
    & AutomationEditorAutomationFragment
  )>, findManyConditionSet: Array<(
    { __typename?: 'ConditionSet' }
    & AutomationEditorConditionSetFragment
  )> }
);

export type GetAutomationFormTemplateOptionsQueryVariables = Exact<{
  where: FormTemplateWhereInput;
}>;


export type GetAutomationFormTemplateOptionsQuery = (
  { __typename?: 'Query' }
  & { findManyFormTemplate: Array<(
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id' | 'title' | 'isActive' | 'isDeleted'>
  )> }
);

export type GetAutomationParentAutomationsQueryVariables = Exact<{
  workflowId: Scalars['String'];
}>;


export type GetAutomationParentAutomationsQuery = (
  { __typename?: 'Query' }
  & { findManyParentWorkflowEventSetting: Array<Maybe<(
    { __typename?: 'WorkflowEventSetting' }
    & AutomationsParentItemFragment
  )>> }
);

export type GetAutomationSendConditionOptionsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetAutomationSendConditionOptionsQuery = (
  { __typename?: 'Query' }
  & { clinicEmployees: Array<(
    { __typename?: 'ClinicEmployee' }
    & Pick<ClinicEmployee, 'id' | 'firstName' | 'lastName' | 'isActive' | 'isDeleted' | 'isVisible'>
  )>, clinicRooms: Array<(
    { __typename?: 'ClinicRoom' }
    & Pick<ClinicRoom, 'id' | 'name' | 'isActive' | 'isVisible' | 'isDeleted'>
  )>, appointmentTypes: Array<(
    { __typename?: 'AppointmentType' }
    & Pick<AppointmentType, 'id' | 'name' | 'displayName' | 'isVisible'>
  )> }
);

export type GetAutomationWidgetRequestTypeOptionsQueryVariables = Exact<{
  where: ClinicWhereUniqueInput;
}>;


export type GetAutomationWidgetRequestTypeOptionsQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinic?: Maybe<(
    { __typename?: 'Clinic' }
    & { clinicWidgetSetting?: Maybe<(
      { __typename?: 'ClinicWidgetSetting' }
      & { clinicWidgetRequestTypes: Array<(
        { __typename?: 'ClinicWidgetRequestType' }
        & Pick<ClinicWidgetRequestType, 'id' | 'displayName' | 'requestType' | 'isDeleted' | 'isActive'>
      )> }
    )> }
  )> }
);

export type GetAutomationsConversationStatusOptionsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetAutomationsConversationStatusOptionsQuery = (
  { __typename?: 'Query' }
  & { findManyChannelStatus: Array<(
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id' | 'color' | 'name' | 'channelStatusAction'>
  )> }
);

export type GetAutomationsListQueryVariables = Exact<{
  clinicId: Scalars['String'];
  inEventType?: Maybe<Array<WorkflowEvent> | WorkflowEvent>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
}>;


export type GetAutomationsListQuery = (
  { __typename?: 'Query' }
  & { findManyWorkflowEventSetting: Array<(
    { __typename?: 'WorkflowEventSetting' }
    & AutomationsListItemFragment
  )> }
);

export type AutomationsSelectionListAutomationFragment = (
  { __typename?: 'WorkflowEventSetting' }
  & { conditionSets: Array<(
    { __typename?: 'ConditionSet' }
    & AutomationEditorConditionSetFragment
  )> }
  & AutomationEditorAutomationFragment
);

export type GetAutomationsSelectionListQueryVariables = Exact<{
  clinicId: Scalars['String'];
  inEventType?: Maybe<Array<WorkflowEvent> | WorkflowEvent>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
}>;


export type GetAutomationsSelectionListQuery = (
  { __typename?: 'Query' }
  & { findManyWorkflowEventSetting: Array<(
    { __typename?: 'WorkflowEventSetting' }
    & AutomationsSelectionListAutomationFragment
  )> }
);

export type GetGlobalAutomationsListQueryVariables = Exact<{
  inEventType?: Maybe<Array<WorkflowEvent> | WorkflowEvent>;
  triggerType?: Maybe<WorkflowEventTriggerType>;
}>;


export type GetGlobalAutomationsListQuery = (
  { __typename?: 'Query' }
  & { findManyWorkflowEventSetting: Array<(
    { __typename?: 'WorkflowEventSetting' }
    & AutomationsListItemFragment
  )> }
);

export type BoardPetParentFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id'>
  & { phoneNumbers: Array<(
    { __typename?: 'ClinicEntityPhoneNumber' }
    & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'updatedAt' | 'isPrimary' | 'isDeleted'>
  )> }
  & PetParentAvatarFragment
);

export type UpdateUserBoardFilterSettingsMutationVariables = Exact<{
  data: CustomUpsertOneUserBoardFilterDataInput;
  where: CustomUpsertOneUserBoardFilterWhereInput;
}>;


export type UpdateUserBoardFilterSettingsMutation = (
  { __typename?: 'Mutation' }
  & { customUpsertOneUserBoardFilter?: Maybe<(
    { __typename?: 'CustomUpsertOneUserBoardFilterResponse' }
    & Pick<CustomUpsertOneUserBoardFilterResponse, 'success' | 'error'>
  )> }
);

export type GetEmptyChannelStatusIdsQueryVariables = Exact<{
  where: GetChannelStatusIdsWithEntityCountOfZeroWhere;
}>;


export type GetEmptyChannelStatusIdsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getChannelStatusIdsWithEntityCountOfZero'>
);

export type GetPaginatedAutomationRunsQueryVariables = Exact<{
  where: AutomationRunWhereInput;
  orderBy?: Maybe<Array<AutomationRunOrderByWithRelationInput> | AutomationRunOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetPaginatedAutomationRunsQuery = (
  { __typename?: 'Query' }
  & { count: Query['findManyAutomationRunCount'] }
  & { automationRuns: Array<(
    { __typename?: 'AutomationRun' }
    & Pick<AutomationRun, 'id' | 'status'>
    & { originAutomation: (
      { __typename?: 'WorkflowEventSetting' }
      & Pick<WorkflowEventSetting, 'id' | 'name'>
    ), appointment?: Maybe<(
      { __typename?: 'Appointment' }
      & Pick<Appointment, 'id' | 'startAt' | 'durationInMinutes'>
      & { clinicPetParents: Array<(
        { __typename?: 'ClinicPetParent' }
        & Pick<ClinicPetParent, 'id'>
        & BoardPetParentFragment
      )>, clinicPet?: Maybe<(
        { __typename?: 'ClinicPet' }
        & Pick<ClinicPet, 'id'>
        & PetAvatarFragment
      )>, channel?: Maybe<(
        { __typename?: 'Channel' }
        & Pick<Channel, 'id' | 'updatedAt'>
        & { lastMessage?: Maybe<(
          { __typename?: 'ChannelMessage' }
          & Pick<ChannelMessage, 'id' | 'createdAt'>
        )>, channelStatus?: Maybe<(
          { __typename?: 'ChannelStatus' }
          & Pick<ChannelStatus, 'id'>
          & ChannelListChannelStatusFragment
        )> }
      )> }
    )> }
  )> }
);

export type GetPaginatedChannelStatusesQueryVariables = Exact<{
  where?: Maybe<ChannelStatusWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetPaginatedChannelStatusesQuery = (
  { __typename?: 'Query' }
  & { count: Query['findManyChannelStatusCount'] }
  & { channelStatuses: Array<(
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id' | 'channelStatusAction' | 'color' | 'name'>
  )> }
);

export type GetPaginatedChannelsQueryVariables = Exact<{
  where: ChannelWhereInput;
  orderBy?: Maybe<Array<ChannelOrderByWithRelationInput> | ChannelOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  countOnly: Scalars['Boolean'];
}>;


export type GetPaginatedChannelsQuery = (
  { __typename?: 'Query' }
  & { count: Query['findManyChannelCount'] }
  & { channels: Maybe<Array<(
    { __typename?: 'Channel' }
    & ChannelListChannelFragment
  )>> }
);

export type GetUserBoardFilterSettingsQueryVariables = Exact<{
  where: CustomFindUniqueUserBoardFilterWhereInput;
}>;


export type GetUserBoardFilterSettingsQuery = (
  { __typename?: 'Query' }
  & { customFindUniqueUserBoardFilter?: Maybe<(
    { __typename?: 'CustomFindUniqueUserBoardFilterResponse' }
    & Pick<CustomFindUniqueUserBoardFilterResponse, 'currentView' | 'collapsedColumnsMap' | 'selectedChannelStatusIdsMap' | 'shouldHideEmptyColumns' | 'shouldCollapseNoStatusColumn' | 'dateRangeOption'>
    & { specificDateRange?: Maybe<(
      { __typename?: 'DateRangeOutput' }
      & Pick<DateRangeOutput, 'gte' | 'lte'>
    )> }
  )> }
);

export type ChannelFilterSelectionFragment = (
  { __typename?: 'ChannelFilterSelection' }
  & Pick<ChannelFilterSelection, 'id' | 'isDeleted' | 'name' | 'filters' | 'filterSelectionType'>
  & { userChannelFilterSelections: Array<(
    { __typename?: 'UserChannelFilterSelection' }
    & Pick<UserChannelFilterSelection, 'id' | 'isFilterOwner'>
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    ) }
  )> }
);

export type CreateChannelFilterSelectionMutationVariables = Exact<{
  data: CreateChannelFilterSelectionInput;
}>;


export type CreateChannelFilterSelectionMutation = (
  { __typename?: 'Mutation' }
  & { createChannelFilterSelection: (
    { __typename?: 'ChannelFilterSelection' }
    & ChannelFilterSelectionFragment
  ) }
);

export type DeleteChannelFilterSelectionMutationVariables = Exact<{
  channelFilterSelectionId: Scalars['String'];
}>;


export type DeleteChannelFilterSelectionMutation = (
  { __typename?: 'Mutation' }
  & { deleteChannelFilterSelection?: Maybe<(
    { __typename?: 'ChannelFilterSelection' }
    & ChannelFilterSelectionFragment
  )> }
);

export type UpdateChannelFilterSelectionMutationVariables = Exact<{
  data: UpdateChannelFilterSelectionInput;
}>;


export type UpdateChannelFilterSelectionMutation = (
  { __typename?: 'Mutation' }
  & { updateChannelFilterSelection: (
    { __typename?: 'ChannelFilterSelection' }
    & ChannelFilterSelectionFragment
  ) }
);

export type GetChannelFilterSelectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChannelFilterSelectionsQuery = (
  { __typename?: 'Query' }
  & { savedChannelFilterSelections: Array<(
    { __typename?: 'ChannelFilterSelection' }
    & ChannelFilterSelectionFragment
  )> }
);

export type DeleteChannelMessageMutationVariables = Exact<{
  where: ChannelMessageWhereUniqueInput;
}>;


export type DeleteChannelMessageMutation = (
  { __typename?: 'Mutation' }
  & { deleteOneChannelMessage?: Maybe<(
    { __typename?: 'ChannelMessage' }
    & Pick<ChannelMessage, 'id'>
  )> }
);

export type GetServiceReminderNotificationQueryVariables = Exact<{
  serviceReminderNotificationId: Scalars['String'];
}>;


export type GetServiceReminderNotificationQuery = (
  { __typename?: 'Query' }
  & { findManyServiceReminderNotification: Array<(
    { __typename?: 'ServiceReminderNotification' }
    & Pick<ServiceReminderNotification, 'id' | 'queueAt' | 'hasResponded'>
    & { bundledNotifications: Array<(
      { __typename?: 'ServiceReminderNotification' }
      & Pick<ServiceReminderNotification, 'id' | 'hasResponded'>
      & { serviceReminder: (
        { __typename?: 'ServiceReminder' }
        & Pick<ServiceReminder, 'id' | 'dueDate'>
        & { clinicPet?: Maybe<(
          { __typename?: 'ClinicPet' }
          & PetAvatarFragment
        )>, service: (
          { __typename?: 'Service' }
          & Pick<Service, 'id' | 'name'>
        ) }
      ) }
    )>, serviceReminder: (
      { __typename?: 'ServiceReminder' }
      & Pick<ServiceReminder, 'id' | 'dueDate'>
      & { service: (
        { __typename?: 'Service' }
        & Pick<Service, 'id' | 'name'>
      ), clinicPet?: Maybe<(
        { __typename?: 'ClinicPet' }
        & PetAvatarFragment
      )> }
    ) }
  )> }
);

export type ChatEntityAppointmentFragment = (
  { __typename?: 'Appointment' }
  & Pick<Appointment, 'id' | 'createdAt' | 'description' | 'startAt' | 'durationInMinutes'>
  & { clinicEmployees: Array<(
    { __typename?: 'ClinicEmployee' }
    & Pick<ClinicEmployee, 'id' | 'firstName' | 'lastName'>
  )>, appointmentType?: Maybe<(
    { __typename?: 'AppointmentType' }
    & Pick<AppointmentType, 'id' | 'name'>
  )> }
);

export type ChatEntityFormSubmissionFragment = (
  { __typename?: 'FormSubmission' }
  & Pick<FormSubmission, 'id' | 'createdAt' | 'submittedAt' | 'clinicPetParentId'>
  & { formTemplate?: Maybe<(
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'title'>
  )> }
);

export type GetChatEntitiesQueryVariables = Exact<{
  appointmentWhereInput?: Maybe<AppointmentWhereInput>;
  formSubmissionsWhereInput?: Maybe<FormSubmissionWhereInput>;
}>;


export type GetChatEntitiesQuery = (
  { __typename?: 'Query' }
  & { appointments: Array<(
    { __typename?: 'Appointment' }
    & ChatEntityAppointmentFragment
  )>, formSubmissions: Array<(
    { __typename?: 'FormSubmission' }
    & ChatEntityFormSubmissionFragment
  )> }
);

export type GetArchivedOverlayChannelStatusesQueryVariables = Exact<{
  where?: Maybe<ChannelStatusWhereInput>;
}>;


export type GetArchivedOverlayChannelStatusesQuery = (
  { __typename?: 'Query' }
  & { findManyChannelStatus: Array<(
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id' | 'channelStatusAction' | 'order'>
  )> }
);

export type GetPetParentActiveChannelMembersQueryVariables = Exact<{
  clinicPetParentIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetPetParentActiveChannelMembersQuery = (
  { __typename?: 'Query' }
  & { findManyChannelMember: Array<(
    { __typename?: 'ChannelMember' }
    & Pick<ChannelMember, 'id' | 'channelId'>
  )> }
);

export type UpdateArchivedOverlayChannelStatusMutationVariables = Exact<{
  where: ChannelWhereUniqueInput;
  data: ChannelUpdateInput;
}>;


export type UpdateArchivedOverlayChannelStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateOneChannel: (
    { __typename?: 'Channel' }
    & Pick<Channel, 'id'>
    & { channelStatus?: Maybe<(
      { __typename?: 'ChannelStatus' }
      & Pick<ChannelStatus, 'id'>
    )> }
  ) }
);

export type FindDocumentationQueryVariables = Exact<{
  where?: Maybe<DocumentationWhereInput>;
}>;


export type FindDocumentationQuery = (
  { __typename?: 'Query' }
  & { findManyDocumentation: Array<(
    { __typename?: 'Documentation' }
    & DocumentationFragment
  )> }
);

export type DocumentationFragment = (
  { __typename?: 'Documentation' }
  & Pick<Documentation, 'id' | 'createdAt' | 'updatedAt' | 'provider' | 'category' | 'title' | 'url'>
);

export type TeamMemberMentionsListFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id'>
  & ClinicUserAvatarFragment
);

export type GetTeamMembersMentionListQueryVariables = Exact<{
  where?: Maybe<UserWhereInput>;
}>;


export type GetTeamMembersMentionListQuery = (
  { __typename?: 'Query' }
  & { findManyUser: Array<(
    { __typename?: 'User' }
    & TeamMemberMentionsListFragment
  )> }
);

export type CreateChannelMessageAutoResponseMutationVariables = Exact<{
  data: ChannelMessageAutoResponseCreateInput;
}>;


export type CreateChannelMessageAutoResponseMutation = (
  { __typename?: 'Mutation' }
  & { createOneChannelMessageAutoResponse: (
    { __typename?: 'ChannelMessageAutoResponse' }
    & Pick<ChannelMessageAutoResponse, 'id'>
  ) }
);

export type GetConversationsQuickReplyQueryVariables = Exact<{
  where: ChannelSuggestedMessageWhereInput;
  alternatePrompt?: Maybe<Scalars['String']>;
  maxTokensToSample?: Maybe<Scalars['Int']>;
}>;


export type GetConversationsQuickReplyQuery = (
  { __typename?: 'Query' }
  & { aiChannelSuggestedMessage?: Maybe<(
    { __typename?: 'ChannelSuggestedMessageResponse' }
    & Pick<ChannelSuggestedMessageResponse, 'response' | 'parsedJson'>
  )> }
);

export type UpdateChannelMessageAutoResponseMutationVariables = Exact<{
  where: ChannelMessageAutoResponseWhereUniqueInput;
  data: ChannelMessageAutoResponseUpdateInput;
}>;


export type UpdateChannelMessageAutoResponseMutation = (
  { __typename?: 'Mutation' }
  & { updateOneChannelMessageAutoResponse: (
    { __typename?: 'ChannelMessageAutoResponse' }
    & Pick<ChannelMessageAutoResponse, 'id'>
  ) }
);

export type GetConversationSummaryQueryVariables = Exact<{
  where: ChannelSummaryWhereInput;
  alternatePrompt?: Maybe<Scalars['String']>;
  maxTokensToSample?: Maybe<Scalars['Int']>;
}>;


export type GetConversationSummaryQuery = (
  { __typename?: 'Query' }
  & { aiChannelSummary?: Maybe<(
    { __typename?: 'ChannelSummaryResponse' }
    & Pick<ChannelSummaryResponse, 'response' | 'parsedJson'>
  )> }
);

export type TeletriageConversationFragment = (
  { __typename?: 'Channel' }
  & { clinic?: Maybe<(
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id' | 'name'>
  )> }
  & ChannelListChannelFragment
);

export type GetTeletriageConversationsQueryVariables = Exact<{
  where: TeletriageSearchChannelInput;
  take: Scalars['Int'];
  skip: Scalars['Int'];
  orderBy?: Maybe<ChannelOrderByWithRelationInput>;
}>;


export type GetTeletriageConversationsQuery = (
  { __typename?: 'Query' }
  & { teletriageChannelSearch: (
    { __typename?: 'TeletriageChannelSearchOutput' }
    & Pick<TeletriageChannelSearchOutput, 'total'>
    & { channels: Array<(
      { __typename?: 'Channel' }
      & TeletriageConversationFragment
    )> }
  ) }
);

export type TeletriageStatusFragment = (
  { __typename?: 'TeletriageChannelStatus' }
  & Pick<TeletriageChannelStatus, 'channelStatusAction' | 'color' | 'name'>
);

export type GetTeletriageStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeletriageStatusesQuery = (
  { __typename?: 'Query' }
  & { getTeletriageStatuses: Array<(
    { __typename?: 'TeletriageChannelStatus' }
    & TeletriageStatusFragment
  )> }
);

export type GetTeletriageUnreadMessageCountQueryVariables = Exact<{
  clinicIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetTeletriageUnreadMessageCountQuery = (
  { __typename?: 'Query' }
  & { teletriageChannelUnreadMessageCount: (
    { __typename?: 'TeletriageChannelUnreadMessageCountResult' }
    & { client?: Maybe<(
      { __typename?: 'TeletriageChannelCountResult' }
      & Pick<TeletriageChannelCountResult, 'total'>
      & { unreadChannels: Array<(
        { __typename?: 'TeletriageUnreadMessageChannel' }
        & Pick<TeletriageUnreadMessageChannel, 'channelId' | 'unreadMessageCount'>
      )> }
    )> }
  ) }
);

export type TeletriageClinicFragment = (
  { __typename?: 'Clinic' }
  & Pick<Clinic, 'id' | 'name'>
);

export type GetTeletriageUserClinicsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeletriageUserClinicsQuery = (
  { __typename?: 'Query' }
  & { getTeletriageUserClinics: Array<Maybe<(
    { __typename?: 'Clinic' }
    & TeletriageClinicFragment
  )>> }
);

export type SubscribeToTeletriageConversationsSubscriptionVariables = Exact<{
  where: TeletriageChannelSyncedToSearchWhereInput;
}>;


export type SubscribeToTeletriageConversationsSubscription = (
  { __typename?: 'Subscription' }
  & { teletriageChannelSyncedToSearch: (
    { __typename?: 'Channel' }
    & Pick<Channel, 'id'>
  ) }
);

export type SubscribeToTeletriageMessageChannelChangedSubscriptionVariables = Exact<{
  where: SubscriptionTeletriageChannelMessageWhereInput;
}>;


export type SubscribeToTeletriageMessageChannelChangedSubscription = (
  { __typename?: 'Subscription' }
  & { teletriageChannelMessageChanged: (
    { __typename?: 'TeletriageChannelMessageSubscription' }
    & Pick<TeletriageChannelMessageSubscription, 'mutation'>
    & { node: (
      { __typename?: 'ChannelMessage' }
      & SubscriptionChannelMessageFragment
    ) }
  ) }
);

export type SubscribeToTeletriageUnreadMessageCountChangedSubscriptionVariables = Exact<{
  where: SubscriptionTeletriageChannelWhereInput;
}>;


export type SubscribeToTeletriageUnreadMessageCountChangedSubscription = (
  { __typename?: 'Subscription' }
  & { teletriageUnreadMessageCountChanged: (
    { __typename?: 'TeletriageChannelSubscription' }
    & { node: (
      { __typename?: 'Channel' }
      & Pick<Channel, 'id'>
    ) }
  ) }
);

export type SmsNotificationStatusFragment = (
  { __typename?: 'SmsNotificationStatus' }
  & Pick<SmsNotificationStatus, 'id' | 'createdAt' | 'updatedAt' | 'status' | 'receivingNumber' | 'sourceContactEntityId' | 'sourceContactEntityType' | 'provider' | 'providerMessageId' | 'errorType' | 'providerErrorData' | 'sentChannelMessageId'>
);

export type OrganizationPetCareBadgePlanEnrollmentFragment = (
  { __typename?: 'ClinicPet' }
  & Pick<ClinicPet, 'id'>
  & { organizationPet?: Maybe<(
    { __typename?: 'OrganizationPet' }
    & SidePanelOrganizationPetFragment
  )> }
);

export type ChannelListChannelMemberPetParentFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName' | 'pimsId'>
  & PetParentAvatarFragment
);

export type ChannelListChannelMemberFragment = (
  { __typename?: 'ChannelMember' }
  & Pick<ChannelMember, 'id' | 'lastConsumedMessageIndex' | 'twilioMemberSid' | 'twilioIdentity' | 'removedAt'>
  & { clinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id'>
    & ChannelListChannelMemberPetParentFragment
  )> }
);

export type ChannelListChannelStatusFragment = (
  { __typename?: 'ChannelStatus' }
  & Pick<ChannelStatus, 'id' | 'name' | 'color' | 'channelStatusAction'>
);

export type ChannelListChannelPetFragment = (
  { __typename?: 'ClinicPet' }
  & Pick<ClinicPet, 'id' | 'pimsId'>
  & PetAvatarFragment
);

export type ChannelListChannelLastMessageFragment = (
  { __typename?: 'ChannelMessage' }
  & Pick<ChannelMessage, 'id' | 'createdAt' | 'deletedAt' | 'index' | 'body'>
  & { attachments: Array<(
    { __typename?: 'ChannelMessageAttachment' }
    & Pick<ChannelMessageAttachment, 'id' | 'attachmentType' | 'entityType'>
  )> }
);

export type ChannelListChannelFragment = (
  { __typename?: 'Channel' }
  & Pick<Channel, 'id' | 'updatedAt' | 'lastExportAt' | 'tags'>
  & { pets: Array<(
    { __typename?: 'ClinicPet' }
    & ChannelListChannelPetFragment
  )>, channelStatus?: Maybe<(
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id'>
    & ChannelListChannelStatusFragment
  )>, channelMembers: Array<(
    { __typename?: 'ChannelMember' }
    & ChannelListChannelMemberFragment
  )>, lastMessage?: Maybe<(
    { __typename?: 'ChannelMessage' }
    & ChannelListChannelLastMessageFragment
  )>, creationSource?: Maybe<(
    { __typename?: 'ChannelCreationSource' }
    & Pick<ChannelCreationSource, 'id' | 'creationSource'>
  )>, channelPins: Array<(
    { __typename?: 'ChannelPin' }
    & ChannelPinFragment
  )> }
);

export type ChannelPinFragment = (
  { __typename?: 'ChannelPin' }
  & Pick<ChannelPin, 'id' | 'userId' | 'createdAt'>
);

export type ChannelViewClinicPetFragment = (
  { __typename?: 'ClinicPet' }
  & Pick<ClinicPet, 'id' | 'pimsId'>
  & PetAvatarFragment
);

export type ChannelViewChannelStatusFragment = (
  { __typename?: 'ChannelStatus' }
  & Pick<ChannelStatus, 'id' | 'name' | 'color' | 'channelStatusAction'>
);

export type ChannelViewClinicPetParentFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id' | 'pimsId' | 'firstName' | 'lastName' | 'email' | 'isActive' | 'isDeleted'>
  & { pets: Array<(
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'id'>
    & ChannelViewClinicPetFragment
  )>, phoneNumbers: Array<(
    { __typename?: 'ClinicEntityPhoneNumber' }
    & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'isPrimary' | 'isMobile' | 'isDeleted' | 'updatedAt' | 'smsStatus'>
  )>, petParentSetting?: Maybe<(
    { __typename?: 'PetParentSetting' }
    & Pick<PetParentSetting, 'id' | 'smsNotifications' | 'emailNotifications' | 'emailOptedOutByPetParent' | 'pushNotifications'>
  )> }
  & PetParentAvatarFragment
);

export type ChannelViewChannelMemberFragment = (
  { __typename?: 'ChannelMember' }
  & Pick<ChannelMember, 'id' | 'lastConsumedMessageIndex' | 'twilioMemberSid' | 'twilioIdentity' | 'removedAt'>
  & { clinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id'>
    & ChannelViewClinicPetParentFragment
  )>, user?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'profilePic' | 'email' | 'type'>
    & { vetInfo?: Maybe<(
      { __typename?: 'VetInfo' }
      & Pick<VetInfo, 'id'>
      & { roles: Array<(
        { __typename?: 'StaffRole' }
        & Pick<StaffRole, 'id' | 'role'>
      )> }
    )> }
  )> }
);

export type ChannelViewChannelPetFragment = (
  { __typename?: 'ClinicPet' }
  & Pick<ClinicPet, 'id' | 'pimsId'>
  & { petParents: Array<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id'>
  )> }
  & PetAvatarFragment
  & OrganizationPetCareBadgePlanEnrollmentFragment
);

export type ChannelViewChannelFragment = (
  { __typename?: 'Channel' }
  & Pick<Channel, 'id' | 'createdAt' | 'updatedAt' | 'isActive' | 'attributes' | 'twilioChannelSid' | 'friendlyName' | 'channelType' | 'channelVisibility' | 'clinicId'>
  & { creationSource?: Maybe<(
    { __typename?: 'ChannelCreationSource' }
    & Pick<ChannelCreationSource, 'id' | 'creationSource'>
  )>, channelMembers: Array<(
    { __typename?: 'ChannelMember' }
    & ChannelViewChannelMemberFragment
  )>, channelStatus?: Maybe<(
    { __typename?: 'ChannelStatus' }
    & ChannelViewChannelStatusFragment
  )>, assignees: Array<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
  )>, pets: Array<(
    { __typename?: 'ClinicPet' }
    & ChannelViewChannelPetFragment
  )> }
);

export type ChannelExportToPimsMutationVariables = Exact<{
  where: ChannelExportWhereInput;
}>;


export type ChannelExportToPimsMutation = (
  { __typename?: 'Mutation' }
  & { channelExportToPims?: Maybe<(
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'success' | 'payload'>
  )> }
);

export type ClearUnreadMessagesMutationVariables = Exact<{
  userId: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
}>;


export type ClearUnreadMessagesMutation = (
  { __typename?: 'Mutation' }
  & { clearUnreadMessages: (
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'success' | 'payload'>
  ) }
);

export type ConfirmAppointmentMutationVariables = Exact<{
  where?: Maybe<AppointmentWhereUniqueInput>;
}>;


export type ConfirmAppointmentMutation = (
  { __typename?: 'Mutation' }
  & { confirmAppointment: (
    { __typename?: 'Appointment' }
    & Pick<Appointment, 'id' | 'status'>
  ) }
);

export type CreateChannelMessageMutationVariables = Exact<{
  data: ChannelMessageCreateInput;
}>;


export type CreateChannelMessageMutation = (
  { __typename?: 'Mutation' }
  & { createChannelMessage2: (
    { __typename?: 'ChannelMessage' }
    & ChannelViewChannelMessageFragment
  ) }
);

export type CreateChannelPinMutationVariables = Exact<{
  userId: Scalars['String'];
  channelId: Scalars['String'];
}>;


export type CreateChannelPinMutation = (
  { __typename?: 'Mutation' }
  & { createOneChannelPin: (
    { __typename?: 'ChannelPin' }
    & ChannelPinFragment
  ) }
);

export type DeleteChannelPinByUserAndChannelMutationVariables = Exact<{
  userId: Scalars['String'];
  channelId: Scalars['String'];
}>;


export type DeleteChannelPinByUserAndChannelMutation = (
  { __typename?: 'Mutation' }
  & { deleteManyChannelPin?: Maybe<(
    { __typename?: 'BatchPayload' }
    & Pick<BatchPayload, 'count'>
  )> }
);

export type GetPaymentReceiptPdfQueryVariables = Exact<{
  data: ExportItemizedInvoiceToReceiptPdfInput;
}>;


export type GetPaymentReceiptPdfQuery = (
  { __typename?: 'Query' }
  & { exportItemizedInvoiceAsReceiptPDF: (
    { __typename?: 'ExportItemizedInvoiceToReceiptPDFResponse' }
    & Pick<ExportItemizedInvoiceToReceiptPdfResponse, 'success' | 'base64PDF'>
  ) }
);

export type UpdateCareBenefitUsageMutationVariables = Exact<{
  where: CareBenefitUsageWhereUniqueInput;
  data: CareBenefitUsageUpdateInput;
}>;


export type UpdateCareBenefitUsageMutation = (
  { __typename?: 'Mutation' }
  & { updateOneCareBenefitUsage: (
    { __typename?: 'CareBenefitUsage' }
    & Pick<CareBenefitUsage, 'id' | 'quantityUsed' | 'exhaustsBenefit'>
  ) }
);

export type UpdateOneCareBenefitUsageToInvoiceLineItemMutationVariables = Exact<{
  where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput;
  data: CareBenefitUsageToInvoiceLineItemUpdateInput;
}>;


export type UpdateOneCareBenefitUsageToInvoiceLineItemMutation = (
  { __typename?: 'Mutation' }
  & { updateOneCareBenefitUsageToInvoiceLineItem: (
    { __typename?: 'CareBenefitUsageToInvoiceLineItem' }
    & Pick<CareBenefitUsageToInvoiceLineItem, 'id' | 'adjustedAmount'>
  ) }
);

export type UpdateChannelAssigneesMutationVariables = Exact<{
  where: ChannelWhereUniqueInput;
  data: ChannelUpdateInput;
}>;


export type UpdateChannelAssigneesMutation = (
  { __typename?: 'Mutation' }
  & { updateOneChannel: (
    { __typename?: 'Channel' }
    & Pick<Channel, 'id'>
    & { channelStatus?: Maybe<(
      { __typename?: 'ChannelStatus' }
      & Pick<ChannelStatus, 'id'>
    )>, assignees: Array<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )> }
  ) }
);

export type UpdateChannelMemberMutationVariables = Exact<{
  where: ChannelMemberWhereUniqueInput;
  data: ChannelMemberUpdateInput;
}>;


export type UpdateChannelMemberMutation = (
  { __typename?: 'Mutation' }
  & { updateOneChannelMember: (
    { __typename?: 'ChannelMember' }
    & Pick<ChannelMember, 'id' | 'lastConsumedMessageIndex' | 'removedAt'>
  ) }
);

export type UpdateChannelMessageAttributesMutationVariables = Exact<{
  where: ChannelMessageWhereUniqueInput;
  data: ChannelMessageUpdateInput;
}>;


export type UpdateChannelMessageAttributesMutation = (
  { __typename?: 'Mutation' }
  & { updateChannelMessage: (
    { __typename?: 'ChannelMessage' }
    & Pick<ChannelMessage, 'id' | 'attributes'>
    & { reactions: Array<(
      { __typename?: 'ChannelMessageReaction' }
      & ReactionFragment
    )> }
  ) }
);

export type UpdateChannelPetsMutationVariables = Exact<{
  where: ChannelWhereUniqueInput;
  data: ChannelUpdateInput;
}>;


export type UpdateChannelPetsMutation = (
  { __typename?: 'Mutation' }
  & { updateOneChannel: (
    { __typename?: 'Channel' }
    & Pick<Channel, 'id'>
    & { pets: Array<(
      { __typename?: 'ClinicPet' }
      & Pick<ClinicPet, 'id'>
      & ChannelViewChannelPetFragment
    )> }
  ) }
);

export type UpdateLineItemMutationVariables = Exact<{
  where: InvoiceLineItemWhereUniqueInput;
  data: InvoiceLineItemUpdateInput;
}>;


export type UpdateLineItemMutation = (
  { __typename?: 'Mutation' }
  & { updateOneInvoiceLineItem: (
    { __typename?: 'InvoiceLineItem' }
    & Pick<InvoiceLineItem, 'id'>
    & { connectedCareBenefits: Array<(
      { __typename?: 'CareBenefitUsageToInvoiceLineItem' }
      & Pick<CareBenefitUsageToInvoiceLineItem, 'id' | 'adjustedAmount'>
      & { careBenefitUsage: (
        { __typename?: 'CareBenefitUsage' }
        & Pick<CareBenefitUsage, 'id' | 'quantityUsed'>
      ) }
    )> }
  ) }
);

export type CalculateMultiplePetsBenefitsUsageQueryVariables = Exact<{
  where?: Maybe<CalculateMultiplePetsBenefitUsageInput>;
}>;


export type CalculateMultiplePetsBenefitsUsageQuery = (
  { __typename?: 'Query' }
  & { calculateMultiplePetsBenefitUsage?: Maybe<(
    { __typename?: 'CalculateMultiplePetsBenefitUsageOutput' }
    & CalculateMultiplePetsBenefitUsageFragment
  )> }
);

export type CalculateMultiplePetsBenefitUsageFragment = (
  { __typename?: 'CalculateMultiplePetsBenefitUsageOutput' }
  & { petUsages: Array<(
    { __typename?: 'PetBenefitUsage' }
    & PetUsageFragment
  )> }
);

export type PetUsageFragment = (
  { __typename?: 'PetBenefitUsage' }
  & Pick<PetBenefitUsage, 'organizationPetId'>
  & { usages: Array<(
    { __typename?: 'UsageByBenefit' }
    & PetUsageByBenefitFragment
  )> }
);

export type PetUsageByBenefitFragment = (
  { __typename?: 'UsageByBenefit' }
  & Pick<UsageByBenefit, 'provided' | 'used' | 'exhausted' | 'displayOrder'>
  & { sources: (
    { __typename?: 'BenefitSource' }
    & Pick<BenefitSource, 'planIds' | 'addonIds'>
  ), benefit: (
    { __typename?: 'CareBenefit' }
    & Pick<CareBenefit, 'id' | 'title' | 'tangible' | 'exhaustible' | 'providedDiscountPercentage' | 'usageUnitOfMeasure'>
  ) }
);

export type GetAssigneeChannelMembersQueryVariables = Exact<{
  channelId: Scalars['String'];
  assigneeUserIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetAssigneeChannelMembersQuery = (
  { __typename?: 'Query' }
  & { findManyChannelMember: Array<(
    { __typename?: 'ChannelMember' }
    & Pick<ChannelMember, 'id' | 'lastConsumedMessageIndex'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'email' | 'type'>
    )> }
  )> }
);

export type GetChannelAssigneeMenuDataQueryVariables = Exact<{
  channelId: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
}>;


export type GetChannelAssigneeMenuDataQuery = (
  { __typename?: 'Query' }
  & { findUniqueChannel?: Maybe<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id'>
    & { assignees: Array<(
      { __typename?: 'User' }
      & ClinicUserAvatarFragment
    )> }
  )>, users: Array<(
    { __typename?: 'User' }
    & ClinicUserAvatarFragment
  )> }
);

export type GetChannelListChannelsQueryVariables = Exact<{
  where: SearchChannelInput;
  take: Scalars['Int'];
  skip: Scalars['Int'];
  orderBy?: Maybe<ChannelOrderByWithRelationInput>;
}>;


export type GetChannelListChannelsQuery = (
  { __typename?: 'Query' }
  & { channelSearch: (
    { __typename?: 'ChannelSearchOutput' }
    & Pick<ChannelSearchOutput, 'total'>
    & { channels: Array<(
      { __typename?: 'Channel' }
      & ChannelListChannelFragment
    )> }
  ) }
);

export type GetChannelMembersConsumptionHorizonQueryVariables = Exact<{
  where: ChannelMemberWhereInput;
}>;


export type GetChannelMembersConsumptionHorizonQuery = (
  { __typename?: 'Query' }
  & { channelMembers: Array<(
    { __typename?: 'ChannelMember' }
    & Pick<ChannelMember, 'id' | 'lastConsumedMessageIndex'>
  )> }
);

export type GetChannelPdfDownloadDataQueryVariables = Exact<{
  where: ChannelExportWhereInput;
}>;


export type GetChannelPdfDownloadDataQuery = (
  { __typename?: 'Query' }
  & { channelExport?: Maybe<(
    { __typename?: 'FileExportData' }
    & Pick<FileExportData, 'fileType' | 'base64Encoding'>
  )> }
);

export type ChannelPetFragment = (
  { __typename?: 'ClinicPet' }
  & Pick<ClinicPet, 'id' | 'pimsId' | 'speciesType'>
  & PetAvatarFragment
);

export type GetChannelPetsQueryVariables = Exact<{
  where?: Maybe<ClinicPetParentWhereInput>;
  petsWhere: ClinicPetWhereInput;
  petsTake?: Maybe<Scalars['Int']>;
}>;


export type GetChannelPetsQuery = (
  { __typename?: 'Query' }
  & { findManyClinicPetParent: Array<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id'>
    & { pets: Array<(
      { __typename?: 'ClinicPet' }
      & Pick<ClinicPet, 'id'>
      & ChannelPetFragment
    )> }
  )> }
);

export type ChannelViewChannelMessageAttachmentFragment = (
  { __typename?: 'ChannelMessageAttachment' }
  & Pick<ChannelMessageAttachment, 'id' | 'attachmentType' | 'entityType' | 'entityId' | 'filename' | 'uploadStatus' | 'url'>
);

export type ChannelViewChannelMessageFragment = (
  { __typename?: 'ChannelMessage' }
  & Pick<ChannelMessage, 'id' | 'createdAt' | 'updatedAt' | 'deletedAt' | 'index' | 'body' | 'messageType' | 'forceReadReceipt' | 'source' | 'attributes' | 'sourcePhoneNumber'>
  & { mentionedUsers: Array<(
    { __typename?: 'User' }
    & Pick<User, 'firstName' | 'lastName' | 'nameDisplay'>
  )>, attachments: Array<(
    { __typename?: 'ChannelMessageAttachment' }
    & ChannelViewChannelMessageAttachmentFragment
  )>, smsNotifificationStatuses: Array<(
    { __typename?: 'SmsNotificationStatus' }
    & SmsNotificationStatusFragment
  )>, author?: Maybe<(
    { __typename?: 'ChannelMember' }
    & Pick<ChannelMember, 'id' | 'twilioIdentity'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'profilePic' | 'nameDisplay' | 'type'>
    )>, clinicPetParent?: Maybe<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
      & { phoneNumbers: Array<(
        { __typename?: 'ClinicEntityPhoneNumber' }
        & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'isPrimary' | 'isMobile' | 'isDeleted' | 'updatedAt'>
      )>, petParentSetting?: Maybe<(
        { __typename?: 'PetParentSetting' }
        & Pick<PetParentSetting, 'id' | 'smsNotifications'>
      )> }
      & PetParentAvatarFragment
    )> }
  )>, channel?: Maybe<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id'>
  )>, reactions: Array<(
    { __typename?: 'ChannelMessageReaction' }
    & ReactionFragment
  )> }
);

export type ReactionFragment = (
  { __typename?: 'ChannelMessageReaction' }
  & Pick<ChannelMessageReaction, 'id' | 'createdAt' | 'deletedAt' | 'reaction' | 'userId'>
  & { user: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'namePrefix' | 'nameDisplay' | 'firstName' | 'lastName' | 'nameSuffix'>
  ) }
);

export type GetChannelViewChannelMessagesQueryVariables = Exact<{
  where: ChannelMessageWhereInput;
  orderBy?: Maybe<Array<ChannelMessageOrderByWithRelationInput> | ChannelMessageOrderByWithRelationInput>;
  cursor?: Maybe<ChannelMessageWhereUniqueInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetChannelViewChannelMessagesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyChannelMessageCount'>
  & { findManyChannelMessage: Array<(
    { __typename?: 'ChannelMessage' }
    & ChannelViewChannelMessageFragment
  )> }
);

export type ChannelViewClientDropdownClinicPetParentFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName' | 'isActive' | 'isDeleted'>
  & { pets: Array<(
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'id' | 'name' | 'speciesType' | 'isActive' | 'isDeceased'>
  )>, channelMembers: Array<(
    { __typename?: 'ChannelMember' }
    & Pick<ChannelMember, 'id' | 'removedAt'>
    & { channel?: Maybe<(
      { __typename?: 'Channel' }
      & Pick<Channel, 'id'>
      & { channelStatus?: Maybe<(
        { __typename?: 'ChannelStatus' }
        & Pick<ChannelStatus, 'id' | 'channelStatusAction'>
      )> }
    )> }
  )> }
  & PetParentAvatarFragment
);

export type GetChannelViewClientDropdownPetParentsQueryVariables = Exact<{
  petIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetChannelViewClientDropdownPetParentsQuery = (
  { __typename?: 'Query' }
  & { findManyClinicPetParent: Array<(
    { __typename?: 'ClinicPetParent' }
    & ChannelViewClientDropdownClinicPetParentFragment
  )> }
);

export type GetClinicChannelViewChannelQueryVariables = Exact<{
  channelId: Scalars['String'];
  clinicId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type GetClinicChannelViewChannelQuery = (
  { __typename?: 'Query' }
  & { findUniqueChannel?: Maybe<(
    { __typename?: 'Channel' }
    & ChannelViewChannelFragment
  )> }
);

export type GetClinicWidgetRequestQueryVariables = Exact<{
  where: ClinicWidgetRequestWhereUniqueInput;
}>;


export type GetClinicWidgetRequestQuery = (
  { __typename?: 'Query' }
  & { clinicWidgetRequest?: Maybe<(
    { __typename?: 'ClinicWidgetRequest' }
    & Pick<ClinicWidgetRequest, 'id' | 'url' | 'isVerified' | 'requestFormSubmission'>
    & { tasks: Array<(
      { __typename?: 'Task' }
      & Pick<Task, 'id' | 'status'>
    )>, clinicPetParent?: Maybe<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName' | 'pimsId'>
      & { phoneNumbers: Array<(
        { __typename?: 'ClinicEntityPhoneNumber' }
        & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'isPrimary' | 'isMobile' | 'isDeleted' | 'updatedAt'>
      )> }
      & PetParentAvatarFragment
    )>, clinicWidgetRequestType?: Maybe<(
      { __typename?: 'ClinicWidgetRequestType' }
      & Pick<ClinicWidgetRequestType, 'id' | 'displayName' | 'requestType'>
    )>, formSubmission?: Maybe<(
      { __typename?: 'FormSubmission' }
      & Pick<FormSubmission, 'id' | 'completedContent'>
    )> }
  )> }
);

export type ExportabilityCheckChannelFragment = (
  { __typename?: 'Channel' }
  & Pick<Channel, 'id'>
  & { pets: Array<(
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'id' | 'pimsId' | 'speciesType'>
  )>, channelMembers: Array<(
    { __typename?: 'ChannelMember' }
    & Pick<ChannelMember, 'id'>
    & { clinicPetParent?: Maybe<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id' | 'pimsId'>
      & { pets: Array<(
        { __typename?: 'ClinicPet' }
        & Pick<ClinicPet, 'id' | 'pimsId' | 'speciesType'>
      )> }
    )> }
  )> }
);

export type GetExportabilityCheckChannelQueryVariables = Exact<{
  channelId: Scalars['String'];
  clinicId?: Maybe<Scalars['String']>;
}>;


export type GetExportabilityCheckChannelQuery = (
  { __typename?: 'Query' }
  & { findUniqueChannel?: Maybe<(
    { __typename?: 'Channel' }
    & ExportabilityCheckChannelFragment
  )> }
);

export type GetMessageComposerAttachmentFormTemplateQueryVariables = Exact<{
  where?: Maybe<FormTemplateWhereInput>;
}>;


export type GetMessageComposerAttachmentFormTemplateQuery = (
  { __typename?: 'Query' }
  & { findFirstFormTemplate?: Maybe<(
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id' | 'title' | 'content'>
  )> }
);

export type MessageComposerFormTemplateFragment = (
  { __typename?: 'FormTemplate' }
  & Pick<FormTemplate, 'id' | 'title' | 'isActive' | 'isDeleted' | 'formTemplateType' | 'content'>
);

export type GetMessageComposerFormTemplatesQueryVariables = Exact<{
  where: FormTemplateWhereInput;
  orderBy?: Maybe<Array<FormTemplateOrderByWithRelationInput> | FormTemplateOrderByWithRelationInput>;
}>;


export type GetMessageComposerFormTemplatesQuery = (
  { __typename?: 'Query' }
  & { findManyFormTemplate: Array<(
    { __typename?: 'FormTemplate' }
    & MessageComposerFormTemplateFragment
  )> }
);

export type MessageComposerMessageTemplateFragment = (
  { __typename?: 'MessageTemplate' }
  & Pick<MessageTemplate, 'id' | 'name' | 'type' | 'body' | 'isArchived' | 'attachments'>
);

export type GetMessageComposerMessageTemplatesQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetMessageComposerMessageTemplatesQuery = (
  { __typename?: 'Query' }
  & { findManyMessageTemplate: Array<(
    { __typename?: 'MessageTemplate' }
    & MessageComposerMessageTemplateFragment
  )> }
);

export type GetPetParentPhoneNumbersQueryVariables = Exact<{
  clinicPetParentIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetPetParentPhoneNumbersQuery = (
  { __typename?: 'Query' }
  & { findManyClinicPetParent: Array<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id'>
    & { phoneNumbers: Array<(
      { __typename?: 'ClinicEntityPhoneNumber' }
      & Pick<ClinicEntityPhoneNumber, 'id' | 'updatedAt' | 'number' | 'isPrimary' | 'isDeleted'>
    )> }
  )> }
);

export type GetPinnedChannelListChannelsQueryVariables = Exact<{
  where: SearchChannelInput;
  orderBy?: Maybe<ChannelOrderByWithRelationInput>;
}>;


export type GetPinnedChannelListChannelsQuery = (
  { __typename?: 'Query' }
  & { channelSearch: (
    { __typename?: 'ChannelSearchOutput' }
    & Pick<ChannelSearchOutput, 'total'>
    & { channels: Array<(
      { __typename?: 'Channel' }
      & ChannelListChannelFragment
    )> }
  ) }
);

export type GetClinicServicesForInvoiceLineItemsQueryVariables = Exact<{
  where?: Maybe<ServiceWhereInput>;
  orderBy?: Maybe<Array<ServiceOrderByWithRelationInput> | ServiceOrderByWithRelationInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type GetClinicServicesForInvoiceLineItemsQuery = (
  { __typename?: 'Query' }
  & { findManyService: Array<(
    { __typename?: 'Service' }
    & Pick<Service, 'id' | 'name' | 'code'>
    & { organizationCareBenefitToClinicService: Array<(
      { __typename?: 'OrganizationCareBenefitToClinicService' }
      & { benefit: (
        { __typename?: 'CareBenefit' }
        & Pick<CareBenefit, 'id' | 'title' | 'description' | 'tangible' | 'providedDiscountPercentage' | 'usageUnitOfMeasure'>
        & { planBenefits: Array<(
          { __typename?: 'CarePlanBenefit' }
          & Pick<CarePlanBenefit, 'id' | 'includedUses'>
        )> }
      ) }
    )> }
  )> }
);

export type GetSmsNotificationStatusQueryVariables = Exact<{
  where: SmsNotificationStatusWhereInput;
}>;


export type GetSmsNotificationStatusQuery = (
  { __typename?: 'Query' }
  & { findFirstSmsNotificationStatus?: Maybe<(
    { __typename?: 'SmsNotificationStatus' }
    & SmsNotificationStatusFragment
  )> }
);

export type SubscribeToAutomationRunActionSubscriptionVariables = Exact<{
  automationRunId: Scalars['String'];
}>;


export type SubscribeToAutomationRunActionSubscription = (
  { __typename?: 'Subscription' }
  & { automationRunActionChanged: (
    { __typename?: 'AutomationRunActionSubscription' }
    & { node: (
      { __typename?: 'AutomationRunAction' }
      & AutomationRunActionFragment
    ) }
  ) }
);

export type SubscribeToChannelListChannelsSubscriptionVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type SubscribeToChannelListChannelsSubscription = (
  { __typename?: 'Subscription' }
  & { channelSyncedToSearch: (
    { __typename?: 'Channel' }
    & Pick<Channel, 'id'>
  ) }
);

export type SubscribeToChannelMessageAttachmentSubscriptionVariables = Exact<{
  channelMessageAttachmentId: Scalars['String'];
}>;


export type SubscribeToChannelMessageAttachmentSubscription = (
  { __typename?: 'Subscription' }
  & { channelMessageAttachmentChanged: (
    { __typename?: 'ChannelMessageAttachmentSubscription' }
    & { node: (
      { __typename?: 'ChannelMessageAttachment' }
      & Pick<ChannelMessageAttachment, 'id' | 'filename' | 'url' | 'uploadStatus' | 'entityId' | 'attachmentType'>
    ) }
  ) }
);

export type SubscribeToChannelViewChannelSubscriptionVariables = Exact<{
  channelId: Scalars['String'];
  clinicId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type SubscribeToChannelViewChannelSubscription = (
  { __typename?: 'Subscription' }
  & { channelChanged: (
    { __typename?: 'ChannelSubscription' }
    & { node: (
      { __typename?: 'Channel' }
      & ChannelViewChannelFragment
    ) }
  ) }
);

export type SubscribeToChannelViewChannelMembersSubscriptionVariables = Exact<{
  channelId: Scalars['String'];
}>;


export type SubscribeToChannelViewChannelMembersSubscription = (
  { __typename?: 'Subscription' }
  & { channelMemberChanged: (
    { __typename?: 'ChannelMemberSubscription' }
    & { node: (
      { __typename?: 'ChannelMember' }
      & Pick<ChannelMember, 'id' | 'removedAt' | 'lastConsumedMessageIndex'>
      & { clinicPetParent?: Maybe<(
        { __typename?: 'ClinicPetParent' }
        & Pick<ClinicPetParent, 'id'>
        & { phoneNumbers: Array<(
          { __typename?: 'ClinicEntityPhoneNumber' }
          & Pick<ClinicEntityPhoneNumber, 'id' | 'isPrimary' | 'number' | 'smsStatus' | 'lastSmsSendDate'>
        )> }
      )> }
    ) }
  ) }
);

export type SubscribeToChannelViewChannelMessagesSubscriptionVariables = Exact<{
  channelId: Scalars['String'];
}>;


export type SubscribeToChannelViewChannelMessagesSubscription = (
  { __typename?: 'Subscription' }
  & { channelMessageChanged: (
    { __typename?: 'ChannelMessageSubscription' }
    & Pick<ChannelMessageSubscription, 'mutation'>
    & { node: (
      { __typename?: 'ChannelMessage' }
      & Pick<ChannelMessage, 'id'>
    ) }
  ) }
);

export type SubscribeToClinicWidgetRequestSubscriptionVariables = Exact<{
  where: SubscriptionClinicWidgetRequestWhereInput;
}>;


export type SubscribeToClinicWidgetRequestSubscription = (
  { __typename?: 'Subscription' }
  & { clinicWidgetRequestChanged: (
    { __typename?: 'ClinicWidgetRequestSubscription' }
    & { node: (
      { __typename?: 'ClinicWidgetRequest' }
      & Pick<ClinicWidgetRequest, 'id' | 'isVerified'>
    ) }
  ) }
);

export type SubscribeToPendingFulfillmentRewardUpdateSubscriptionVariables = Exact<{
  where: LoyaltyRewardRedemptionWhereUniqueInput;
}>;


export type SubscribeToPendingFulfillmentRewardUpdateSubscription = (
  { __typename?: 'Subscription' }
  & { loyaltyRewardRedemptionUpdated: (
    { __typename?: 'LoyaltyRewardRedemptionSubscription' }
    & { node: (
      { __typename?: 'LoyaltyRewardRedemption' }
      & Pick<LoyaltyRewardRedemption, 'id' | 'status'>
      & { account: (
        { __typename?: 'LoyaltyAccount' }
        & Pick<LoyaltyAccount, 'id'>
      ) }
    ) }
  ) }
);

export type SubscribeToSmsNotificationStatusSubscriptionVariables = Exact<{
  where: SubscriptionSmsNotificationStatusWhereInput;
}>;


export type SubscribeToSmsNotificationStatusSubscription = (
  { __typename?: 'Subscription' }
  & { smsNotificationStatusChanged?: Maybe<(
    { __typename?: 'SmsNotificationStatusSubscription' }
    & { node: (
      { __typename?: 'SmsNotificationStatus' }
      & SmsNotificationStatusFragment
    ) }
  )> }
);

export type DemoWorkflowAppintmentWorkflowFragment = (
  { __typename?: 'WorkflowEventSetting' }
  & Pick<WorkflowEventSetting, 'id' | 'name' | 'event' | 'isPublished' | 'createdAt' | 'surveySettingId' | 'surveyStep' | 'surveyType'>
);

export type DemoWorkflowAppointmentFragment = (
  { __typename?: 'Appointment' }
  & Pick<Appointment, 'id' | 'description' | 'isDeleted' | 'createdAt' | 'startAt'>
  & { workflows: Array<(
    { __typename?: 'WorkflowEventSetting' }
    & DemoWorkflowAppintmentWorkflowFragment
  )>, clinicPet?: Maybe<(
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'speciesType' | 'name'>
  )> }
);

export type TriggerDemoWorkflowEventMutationVariables = Exact<{
  data: TriggerWorkflowEventInput;
}>;


export type TriggerDemoWorkflowEventMutation = (
  { __typename?: 'Mutation' }
  & { triggerWorkflowEvent?: Maybe<(
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'success'>
  )> }
);

export type GetDemoWorkflowClinicAppointmentsQueryVariables = Exact<{
  where?: Maybe<AppointmentWhereInput>;
}>;


export type GetDemoWorkflowClinicAppointmentsQuery = (
  { __typename?: 'Query' }
  & { findManyAppointment: Array<(
    { __typename?: 'Appointment' }
    & DemoWorkflowAppointmentFragment
  )> }
);

export type SoftDeleteFormsMenuFormTemplateMutationVariables = Exact<{
  where: FormTemplateWhereUniqueInput;
}>;


export type SoftDeleteFormsMenuFormTemplateMutation = (
  { __typename?: 'Mutation' }
  & { updateOneFormTemplate: (
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id'>
  ) }
);

export type CreateFormTemplateMutationVariables = Exact<{
  clinicId: Scalars['String'];
  title: Scalars['String'];
  content?: Maybe<Scalars['Json']>;
}>;


export type CreateFormTemplateMutation = (
  { __typename?: 'Mutation' }
  & { createOneFormTemplate: (
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id'>
  ) }
);

export type ImportFormTemplateMutationVariables = Exact<{
  data: FormTemplateCreateInput;
}>;


export type ImportFormTemplateMutation = (
  { __typename?: 'Mutation' }
  & { createOneFormTemplate: (
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id'>
  ) }
);

export type ToggleActiveFormTemplateMutationVariables = Exact<{
  formId: Scalars['String'];
  isActive: Scalars['Boolean'];
}>;


export type ToggleActiveFormTemplateMutation = (
  { __typename?: 'Mutation' }
  & { updateOneFormTemplate: (
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id' | 'isActive'>
  ) }
);

export type UpdateFormTemplateMutationVariables = Exact<{
  where: FormTemplateWhereUniqueInput;
  data: FormTemplateUpdateInput;
}>;


export type UpdateFormTemplateMutation = (
  { __typename?: 'Mutation' }
  & { updateOneFormTemplate: (
    { __typename?: 'FormTemplate' }
    & ClinicFormTemplateFragment
  ) }
);

export type AcceptUserInvitationMutationVariables = Exact<{
  data: AcceptUserInvitationInput;
}>;


export type AcceptUserInvitationMutation = (
  { __typename?: 'Mutation' }
  & { acceptUserInvitation?: Maybe<(
    { __typename?: 'AcceptUserInvitationResponse' }
    & Pick<AcceptUserInvitationResponse, 'token'>
  )> }
);

export type LoyaltyProgramRewardFragment = (
  { __typename?: 'LoyaltyReward' }
  & Pick<LoyaltyReward, 'id' | 'title' | 'description' | 'pointCost' | 'availability'>
);

export type CreateLoyaltyProgramRewardMutationVariables = Exact<{
  data: LoyaltyRewardCreateInput;
}>;


export type CreateLoyaltyProgramRewardMutation = (
  { __typename?: 'Mutation' }
  & { createOneLoyaltyReward: (
    { __typename?: 'LoyaltyReward' }
    & Pick<LoyaltyReward, 'id'>
  ) }
);

export type FindOrCreateLoyaltyProgramMutationVariables = Exact<{ [key: string]: never; }>;


export type FindOrCreateLoyaltyProgramMutation = (
  { __typename?: 'Mutation' }
  & { findOrCreateLoyaltyProgram: (
    { __typename?: 'LoyaltyProgram' }
    & Pick<LoyaltyProgram, 'id' | 'status' | 'centsPerPoint' | 'allowSpendCarryOver' | 'minimumTransactionCents' | 'description'>
  ) }
);

export type UpdateLoyaltyProgramRewardMutationVariables = Exact<{
  data: LoyaltyRewardUpdateInput;
  where: LoyaltyRewardWhereUniqueInput;
}>;


export type UpdateLoyaltyProgramRewardMutation = (
  { __typename?: 'Mutation' }
  & { updateOneLoyaltyReward: (
    { __typename?: 'LoyaltyReward' }
    & Pick<LoyaltyReward, 'id'>
  ) }
);

export type UpdateLoyaltyProgramRewardsAvailabilityMutationVariables = Exact<{
  data: LoyaltyRewardUpdateManyMutationInput;
  where: LoyaltyRewardWhereInput;
}>;


export type UpdateLoyaltyProgramRewardsAvailabilityMutation = (
  { __typename?: 'Mutation' }
  & { updateManyLoyaltyReward?: Maybe<(
    { __typename?: 'BatchPayload' }
    & Pick<BatchPayload, 'count'>
  )> }
);

export type UpdateLoyaltyProgramSettingsMutationVariables = Exact<{
  data: LoyaltyProgramUpdateInput;
  where: LoyaltyProgramWhereUniqueInput;
}>;


export type UpdateLoyaltyProgramSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateOneLoyaltyProgram: (
    { __typename?: 'LoyaltyProgram' }
    & Pick<LoyaltyProgram, 'id'>
  ) }
);

export type UpdateOneLoyaltyInvoicePointGranterMutationVariables = Exact<{
  data: LoyaltyInvoicePointGranterUpdateInput;
  where: LoyaltyInvoicePointGranterWhereUniqueInput;
}>;


export type UpdateOneLoyaltyInvoicePointGranterMutation = (
  { __typename?: 'Mutation' }
  & { updateOneLoyaltyInvoicePointGranter: (
    { __typename?: 'LoyaltyInvoicePointGranter' }
    & Pick<LoyaltyInvoicePointGranter, 'id'>
  ) }
);

export type GetLoyaltyProgramBasicInfoQueryVariables = Exact<{
  where?: Maybe<LoyaltyProgramWhereInput>;
}>;


export type GetLoyaltyProgramBasicInfoQuery = (
  { __typename?: 'Query' }
  & { findFirstLoyaltyProgram?: Maybe<(
    { __typename?: 'LoyaltyProgram' }
    & Pick<LoyaltyProgram, 'id' | 'status'>
  )> }
);

export type GetLoyaltyProgramPointGrantingServicesQueryVariables = Exact<{
  where?: Maybe<LoyaltyProgramWhereInput>;
}>;


export type GetLoyaltyProgramPointGrantingServicesQuery = (
  { __typename?: 'Query' }
  & { findFirstLoyaltyProgram?: Maybe<(
    { __typename?: 'LoyaltyProgram' }
    & PointGranterServiceFragment
  )> }
);

export type PointGranterServiceFragment = (
  { __typename?: 'LoyaltyProgram' }
  & Pick<LoyaltyProgram, 'id' | 'status'>
  & { pointGranters: Array<(
    { __typename?: 'LoyaltyInvoicePointGranter' }
    & Pick<LoyaltyInvoicePointGranter, 'id' | 'enabled' | 'allowAllServices'>
    & { grantingServices: Array<(
      { __typename?: 'LoyaltyPointGrantingService' }
      & Pick<LoyaltyPointGrantingService, 'serviceId'>
      & { service: (
        { __typename?: 'Service' }
        & ServiceFromIntegrationIdFragment
      ) }
    )> }
  )> }
);

export type GetLoyaltyProgramRewardsQueryVariables = Exact<{
  where?: Maybe<LoyaltyRewardWhereInput>;
  orderBy?: Maybe<Array<Maybe<LoyaltyRewardOrderByWithRelationInput>> | Maybe<LoyaltyRewardOrderByWithRelationInput>>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type GetLoyaltyProgramRewardsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyLoyaltyRewardCount'>
  & { findManyLoyaltyReward: Array<(
    { __typename?: 'LoyaltyReward' }
    & LoyaltyProgramRewardFragment
  )> }
);

export type GetServicesByIntegrationIdQueryVariables = Exact<{
  where?: Maybe<ServiceWhereInput>;
  orderBy?: Maybe<Array<ServiceOrderByWithRelationInput> | ServiceOrderByWithRelationInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type GetServicesByIntegrationIdQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyServiceCount'>
  & { findManyService: Array<(
    { __typename?: 'Service' }
    & ServiceFromIntegrationIdFragment
  )> }
);

export type ServiceFromIntegrationIdFragment = (
  { __typename?: 'Service' }
  & Pick<Service, 'id' | 'name' | 'code' | 'pimsName'>
);

export type GetServicesIdsByIntegrationIdQueryVariables = Exact<{
  where?: Maybe<ServiceWhereInput>;
}>;


export type GetServicesIdsByIntegrationIdQuery = (
  { __typename?: 'Query' }
  & { servicesIds: Array<(
    { __typename?: 'Service' }
    & Pick<Service, 'id'>
  )> }
);

export type FullMessageTemplateFragment = (
  { __typename?: 'MessageTemplate' }
  & Pick<MessageTemplate, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'type' | 'body' | 'isArchived' | 'attachments'>
  & { updatedBy?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
  )> }
);

export type ArchiveMessageTemplateMutationVariables = Exact<{
  messageTemplateId: Scalars['String'];
  isArchived: Scalars['Boolean'];
}>;


export type ArchiveMessageTemplateMutation = (
  { __typename?: 'Mutation' }
  & { updateOneMessageTemplate: (
    { __typename?: 'MessageTemplate' }
    & Pick<MessageTemplate, 'id' | 'updatedAt' | 'isArchived'>
    & { updatedBy?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    )> }
  ) }
);

export type CreateMessageTemplateMutationVariables = Exact<{
  data: MessageTemplateCreateInput;
}>;


export type CreateMessageTemplateMutation = (
  { __typename?: 'Mutation' }
  & { createOneMessageTemplate: (
    { __typename?: 'MessageTemplate' }
    & FullMessageTemplateFragment
  ) }
);

export type SaveMessageTemplateMutationVariables = Exact<{
  where: MessageTemplateWhereUniqueInput;
  data: MessageTemplateUpdateInput;
}>;


export type SaveMessageTemplateMutation = (
  { __typename?: 'Mutation' }
  & { updateOneMessageTemplate: (
    { __typename?: 'MessageTemplate' }
    & Pick<MessageTemplate, 'id' | 'updatedAt' | 'name' | 'body' | 'isArchived'>
    & { updatedBy?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    )> }
  ) }
);

export type GetMessageTemplatesQueryVariables = Exact<{
  clinicId: Scalars['String'];
  types: Array<MessageTemplateType> | MessageTemplateType;
}>;


export type GetMessageTemplatesQuery = (
  { __typename?: 'Query' }
  & { findManyMessageTemplate: Array<(
    { __typename?: 'MessageTemplate' }
    & FullMessageTemplateFragment
  )> }
);

export type CreateOneEmailCampaignMutationVariables = Exact<{
  data: EmailCampaignCreateInput;
}>;


export type CreateOneEmailCampaignMutation = (
  { __typename?: 'Mutation' }
  & { createOneEmailCampaign: (
    { __typename?: 'EmailCampaign' }
    & EmailCampaignFragment
  ) }
);

export type DeleteEmailCampaignCustomListMutationVariables = Exact<{
  data: DeleteEmailCampaignCustomListInput;
}>;


export type DeleteEmailCampaignCustomListMutation = (
  { __typename?: 'Mutation' }
  & { deleteEmailCampaignCustomList?: Maybe<(
    { __typename?: 'EmailCampaignCustomList' }
    & Pick<EmailCampaignCustomList, 'id'>
  )> }
);

export type DuplicateEmailCampaignMutationVariables = Exact<{
  data: DuplicateEmailCampaignInput;
}>;


export type DuplicateEmailCampaignMutation = (
  { __typename?: 'Mutation' }
  & { duplicateEmailCampaign?: Maybe<(
    { __typename?: 'EmailCampaign' }
    & Pick<EmailCampaign, 'id'>
  )> }
);

export type FindManyAppointmentTypeQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type FindManyAppointmentTypeQuery = (
  { __typename?: 'Query' }
  & { findManyAppointmentType: Array<(
    { __typename?: 'AppointmentType' }
    & AppointmentTypeWorkflowsSelectionFragment
  )> }
);

export type FindManyClinicPetParentCountQueryVariables = Exact<{
  where: ClinicPetParentWhereInput;
}>;


export type FindManyClinicPetParentCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyClinicPetParentCount'>
);

export type FindManyEmailCampaignQueryVariables = Exact<{
  where?: Maybe<EmailCampaignWhereInput>;
}>;


export type FindManyEmailCampaignQuery = (
  { __typename?: 'Query' }
  & { findManyEmailCampaign: Array<(
    { __typename?: 'EmailCampaign' }
    & EmailCampaignFragment
  )> }
);

export type EmailCampaignFragment = (
  { __typename?: 'EmailCampaign' }
  & Pick<EmailCampaign, 'id' | 'createdAt' | 'updatedAt' | 'deletedAt' | 'name' | 'subject' | 'from' | 'status' | 'htmlContent' | 'unlayerJson' | 'segmentArgs' | 'totalSegmentContacts' | 'replyToJson' | 'segmentationType'>
  & { createdByUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'nameDisplay' | 'email'>
  )>, sentByUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'nameDisplay' | 'email'>
  )>, lastUpdatedByUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'nameDisplay' | 'email'>
  )>, customList?: Maybe<(
    { __typename?: 'EmailCampaignCustomList' }
    & Pick<EmailCampaignCustomList, 'id' | 'awsFileKey' | 'fileName' | 'validRecipients' | 'invalidRecipients'>
  )>, uploads: Array<(
    { __typename?: 'EmailCampaignCustomListUploadHistory' }
    & Pick<EmailCampaignCustomListUploadHistory, 'id' | 'expiresAt' | 'fileName' | 'awsFileKey'>
  )> }
);

export type CanSendEmailCampaignQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type CanSendEmailCampaignQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'canSendEmailCampaign'>
);

export type GetClinicEmailCampaignTemplatesQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetClinicEmailCampaignTemplatesQuery = (
  { __typename?: 'Query' }
  & { getClinicEmailCampaignTemplates: Array<(
    { __typename?: 'EmailCampaignTemplate' }
    & EmailCampaignTemplateFragment
  )> }
);

export type EmailCampaignTemplateFragment = (
  { __typename?: 'EmailCampaignTemplate' }
  & Pick<EmailCampaignTemplate, 'id' | 'name' | 'htmlContent' | 'unlayerJson'>
);

export type GetEmailCampaignCustomListUrlQueryVariables = Exact<{
  data: EmailCampaignCustomListUrlInput;
}>;


export type GetEmailCampaignCustomListUrlQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getEmailCampaignCustomListUrl'>
);

export type GetEmailCampaignSegmentCountQueryVariables = Exact<{
  clinicId: Scalars['String'];
  emailCampaignId?: Maybe<Scalars['String']>;
}>;


export type GetEmailCampaignSegmentCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getEmailCampaignSegmentCount'>
);

export type SendEmailCampaignNowMutationVariables = Exact<{
  data: SendEmailCampaignNowInput;
}>;


export type SendEmailCampaignNowMutation = (
  { __typename?: 'Mutation' }
  & { sendEmailCampaignNow?: Maybe<(
    { __typename?: 'sentEmailCampaign' }
    & Pick<SentEmailCampaign, 'id' | 'time'>
  )> }
);

export type UpdateOneEmailCampaignMutationVariables = Exact<{
  data: EmailCampaignUpdateInput;
  where: EmailCampaignWhereUniqueInput;
}>;


export type UpdateOneEmailCampaignMutation = (
  { __typename?: 'Mutation' }
  & { updateOneEmailCampaign: (
    { __typename?: 'EmailCampaign' }
    & EmailCampaignFragment
  ) }
);

export type UploadEmailCampaignCustomListMutationVariables = Exact<{
  data: UploadEmailCampaignCustomListInput;
}>;


export type UploadEmailCampaignCustomListMutation = (
  { __typename?: 'Mutation' }
  & { uploadEmailCampaignCustomList?: Maybe<(
    { __typename?: 'EmailCampaignCustomListResponse' }
    & { customList?: Maybe<(
      { __typename?: 'EmailCampaignCustomList' }
      & Pick<EmailCampaignCustomList, 'id' | 'awsFileKey' | 'fileName' | 'validRecipients' | 'invalidRecipients'>
    )>, customListHistory?: Maybe<(
      { __typename?: 'EmailCampaignCustomListUploadHistory' }
      & Pick<EmailCampaignCustomListUploadHistory, 'id' | 'expiresAt' | 'fileName' | 'awsFileKey'>
    )> }
  )> }
);

export type FindFirstCallRecordingQueryVariables = Exact<{
  where: CallRecordingWhereInput;
}>;


export type FindFirstCallRecordingQuery = (
  { __typename?: 'Query' }
  & { findFirstCallRecording?: Maybe<(
    { __typename?: 'CallRecording' }
    & Pick<CallRecording, 'id' | 'transcription' | 'summary'>
    & { callHistory: (
      { __typename?: 'CallHistory' }
      & Pick<CallHistory, 'createdAt' | 'from' | 'to'>
    ) }
  )> }
);

export type GetQuickSightDashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickSightDashboardsQuery = (
  { __typename?: 'Query' }
  & { getQuickSightDashboards?: Maybe<Array<Maybe<(
    { __typename?: 'DashboardSummary' }
    & Pick<DashboardSummary, 'Name' | 'PublishedVersionNumber' | 'DashboardId'>
  )>>> }
);

export type GetQuickSightEmbedUrlQueryVariables = Exact<{
  where: GetQuickSightEmbedUrlInput;
}>;


export type GetQuickSightEmbedUrlQuery = (
  { __typename?: 'Query' }
  & { getQuickSightEmbedURL?: Maybe<(
    { __typename?: 'EmbedURL' }
    & Pick<EmbedUrl, 'Status' | 'EmbedUrl' | 'RequestId'>
  )> }
);

export type GetSignedDownloadUrlMutationVariables = Exact<{
  assetUrl: Scalars['String'];
}>;


export type GetSignedDownloadUrlMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'getSignedDownloadUrl'>
);

export type PaymentReportFinancialTransactionFragment = (
  { __typename?: 'PaymentsReportTransaction' }
  & Pick<PaymentsReportTransaction, 'transactionId' | 'clinicId' | 'stripePaymentIntentId' | 'stripeInvoiceId' | 'stripeDisputeId' | 'stripeRefundId' | 'stripePayoutId' | 'financialAdjustmentId' | 'clientName' | 'stripePaymentIntentStripeId' | 'paymentRelationship' | 'invoiceIdentifiers' | 'writebackStatus' | 'writebackError' | 'clientPimsId' | 'clientPetParentId' | 'clientPetParentEmail' | 'type' | 'paymentStatus' | 'timestamp' | 'arrivalDate' | 'amount' | 'clientFee' | 'totalInvoiced' | 'transactionFees' | 'netProceeds' | 'sentBy' | 'terminalId' | 'terminalName' | 'paymentMedium' | 'cardBrand' | 'cardType' | 'last4' | 'channelId' | 'refundReason' | 'stripeRefundPaymentIntentAmount' | 'financialAdjustmentDescription' | 'stripePaymentIntentAmountCaptured' | 'paymentIdentifier' | 'stripeReceiptId' | 'stripePaymentIntentPaidAt' | 'stripePaymentIntentTotalRefunded' | 'invoiceId'>
);

export type CreateOnePayoutBatchingPeriodMutationVariables = Exact<{
  data: PayoutBatchingPeriodCreateInput;
}>;


export type CreateOnePayoutBatchingPeriodMutation = (
  { __typename?: 'Mutation' }
  & { createOnePayoutBatchingPeriod: (
    { __typename?: 'PayoutBatchingPeriod' }
    & Pick<PayoutBatchingPeriod, 'id' | 'createdAt' | 'updatedAt' | 'startsAt' | 'endsAt'>
  ) }
);

export type CreateOnePimsWritebackLogEntryMutationVariables = Exact<{
  data: PimsWritebackLogEntryCreateInput;
}>;


export type CreateOnePimsWritebackLogEntryMutation = (
  { __typename?: 'Mutation' }
  & { createOnePimsWritebackLogEntry: (
    { __typename?: 'PimsWritebackLogEntry' }
    & Pick<PimsWritebackLogEntry, 'id' | 'createdAt'>
  ) }
);

export type ResendReceiptEmailMutationVariables = Exact<{
  intentId: Scalars['String'];
  emailOverride?: Maybe<Scalars['String']>;
}>;


export type ResendReceiptEmailMutation = (
  { __typename?: 'Mutation' }
  & { resendReceiptEmail: (
    { __typename?: 'ResendReceiptEmailOutput' }
    & Pick<ResendReceiptEmailOutput, 'success' | 'error' | 'jobChainId'>
  ) }
);

export type RetryPaymentWritebackMutationVariables = Exact<{
  stripePaymentIntentId: Scalars['String'];
}>;


export type RetryPaymentWritebackMutation = (
  { __typename?: 'Mutation' }
  & { retryPaymentWriteback?: Maybe<(
    { __typename?: 'RetryPaymentWritebackOutput' }
    & Pick<RetryPaymentWritebackOutput, 'success' | 'error' | 'jobChainId'>
  )> }
);

export type UpdatePayoutBatchingSettingMutationVariables = Exact<{
  data: UpdatePayoutBatchingSettingInput;
}>;


export type UpdatePayoutBatchingSettingMutation = (
  { __typename?: 'Mutation' }
  & { updatePayoutBatchingSetting: (
    { __typename?: 'UpdatePayoutBatchingSettingResponse' }
    & Pick<UpdatePayoutBatchingSettingResponse, 'success'>
  ) }
);

export type CheckCanManuallyRetryPaymentWritebackQueryVariables = Exact<{
  paymentIntentId: Scalars['String'];
}>;


export type CheckCanManuallyRetryPaymentWritebackQuery = (
  { __typename?: 'Query' }
  & { canManuallyRetryPaymentWriteback: (
    { __typename?: 'CanManuallyRetryPaymentWritebackOutput' }
    & Pick<CanManuallyRetryPaymentWritebackOutput, 'retryable' | 'reason' | 'retryAvailableAfter'>
  ) }
);

export type FindFirstPayoutBatchingPeriodQueryVariables = Exact<{
  where?: Maybe<PayoutBatchingPeriodWhereInput>;
}>;


export type FindFirstPayoutBatchingPeriodQuery = (
  { __typename?: 'Query' }
  & { findManyPayoutBatchingPeriod: Array<(
    { __typename?: 'PayoutBatchingPeriod' }
    & PayoutBatchingPeriodFragment
  )> }
);

export type PayoutBatchingPeriodFragment = (
  { __typename?: 'PayoutBatchingPeriod' }
  & Pick<PayoutBatchingPeriod, 'id' | 'createdAt' | 'updatedAt' | 'startsAt' | 'endsAt' | 'createdByUserId' | 'clinicId'>
);

export type FindMissingPayoutBatchingPeriodDatesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindMissingPayoutBatchingPeriodDatesQuery = (
  { __typename?: 'Query' }
  & { findMissingPayoutBatchingPeriodDates: (
    { __typename?: 'FindMissingBatchingPeriodDatesOutput' }
    & Pick<FindMissingBatchingPeriodDatesOutput, 'success' | 'error' | 'dates'>
  ) }
);

export type GetDisbursementsQueryVariables = Exact<{
  data: GetDisbursementsInput;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<SortBy>;
}>;


export type GetDisbursementsQuery = (
  { __typename?: 'Query' }
  & { getDisbursements: (
    { __typename?: 'GetDisbursementsOutput' }
    & Pick<GetDisbursementsOutput, 'total'>
    & { data: Array<Maybe<(
      { __typename?: 'StripePayout' }
      & StripePayoutSelectionFragment
    )>> }
  ) }
);

export type StripeDisputeSelectionFragment = (
  { __typename?: 'StripeDispute' }
  & Pick<StripeDispute, 'id' | 'createdAt' | 'amount' | 'status' | 'stripeDisputeReason' | 'associatedTransferStripePaymentId'>
  & { financialTransaction?: Maybe<(
    { __typename?: 'FinancialTransaction' }
    & Pick<FinancialTransaction, 'id' | 'channelId'>
  )>, stripePaymentIntent?: Maybe<(
    { __typename?: 'StripePaymentIntent' }
    & Pick<StripePaymentIntent, 'id' | 'stripeId' | 'paidAt'>
    & { invoices: Array<(
      { __typename?: 'Invoice' }
      & Pick<Invoice, 'id'>
    )>, clinicPetParent?: Maybe<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
    )>, financialTransaction?: Maybe<(
      { __typename?: 'FinancialTransaction' }
      & Pick<FinancialTransaction, 'id' | 'type'>
    )> }
  )>, careEnrollmentPayment?: Maybe<(
    { __typename?: 'CareEnrollmentPayment' }
    & Pick<CareEnrollmentPayment, 'id' | 'paidAt'>
    & { stripeInvoice?: Maybe<(
      { __typename?: 'StripeInvoice' }
      & Pick<StripeInvoice, 'id'>
      & { stripeCustomer: (
        { __typename?: 'StripeCustomer' }
        & Pick<StripeCustomer, 'id'>
        & { organizationPetParents: Array<(
          { __typename?: 'OrganizationPetParent' }
          & Pick<OrganizationPetParent, 'id'>
          & { clinicPetParents: Array<(
            { __typename?: 'ClinicPetParent' }
            & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
          )> }
        )> }
      ) }
    )> }
  )> }
);

export type GetDisputesQueryVariables = Exact<{
  data: GetDisputesInput;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<SortBy>;
}>;


export type GetDisputesQuery = (
  { __typename?: 'Query' }
  & { getDisputes: (
    { __typename?: 'GetDisputesOutput' }
    & Pick<GetDisputesOutput, 'total'>
    & { data: Array<Maybe<(
      { __typename?: 'StripeDispute' }
      & StripeDisputeSelectionFragment
    )>> }
  ) }
);

export type GetFinancialTransactionTotalsQueryVariables = Exact<{
  data: GetFinancialTransactionTotalsInput;
}>;


export type GetFinancialTransactionTotalsQuery = (
  { __typename?: 'Query' }
  & { getFinancialTransactionTotals: (
    { __typename?: 'GetFinancialTransactionTotalsOutput' }
    & Pick<GetFinancialTransactionTotalsOutput, 'amount' | 'clientFees' | 'invoiced' | 'transactionFees' | 'netProceeds'>
  ) }
);

export type GetFinancialTransactionsQueryVariables = Exact<{
  data: GetFinancialTransactionsInput;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<SortBy>;
}>;


export type GetFinancialTransactionsQuery = (
  { __typename?: 'Query' }
  & { getFinancialTransactions: (
    { __typename?: 'GetFinancialTransactionsOutput' }
    & Pick<GetFinancialTransactionsOutput, 'total'>
    & { data: Array<Maybe<(
      { __typename?: 'PaymentsReportTransaction' }
      & PaymentReportFinancialTransactionFragment
    )>> }
  ) }
);

export type PayoutBatchingSettingsFragment = (
  { __typename?: 'PayoutBatchingSetting' }
  & Pick<PayoutBatchingSetting, 'id' | 'updatedAt' | 'isAutomated'>
  & { schedules: Array<(
    { __typename?: 'PayoutBatchingSchedule' }
    & Pick<PayoutBatchingSchedule, 'id' | 'dayOfWeek' | 'endTime'>
  )>, updatedByUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'namePrefix' | 'firstName' | 'lastName'>
  )> }
);

export type GetPayoutBatchingSettingQueryVariables = Exact<{
  where?: Maybe<PayoutBatchingSettingWhereInput>;
}>;


export type GetPayoutBatchingSettingQuery = (
  { __typename?: 'Query' }
  & { findFirstPayoutBatchingSetting?: Maybe<(
    { __typename?: 'PayoutBatchingSetting' }
    & PayoutBatchingSettingsFragment
  )> }
);

export type GetStripeDisputesByPaymentIntentQueryVariables = Exact<{
  where: StripeDisputeWhereInput;
}>;


export type GetStripeDisputesByPaymentIntentQuery = (
  { __typename?: 'Query' }
  & { findManyStripeDispute: Array<(
    { __typename?: 'StripeDispute' }
    & Pick<StripeDispute, 'id'>
  )> }
);

export type RefundModalPaymentIntentFragment = (
  { __typename?: 'StripePaymentIntent' }
  & Pick<StripePaymentIntent, 'id' | 'stripeId' | 'amount' | 'total' | 'status' | 'createdAt' | 'paidAt' | 'clientServiceFee' | 'clientServiceFeePercent'>
  & { stripeRefunds: Array<(
    { __typename?: 'StripeRefund' }
    & Pick<StripeRefund, 'id' | 'amount' | 'clientFeeRefunded'>
  )>, clinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
  )> }
);

export type GetPaymentReportStripePaymentIntentQueryVariables = Exact<{
  where: StripePaymentIntentWhereUniqueInput;
}>;


export type GetPaymentReportStripePaymentIntentQuery = (
  { __typename?: 'Query' }
  & { findUniqueStripePaymentIntent?: Maybe<(
    { __typename?: 'StripePaymentIntent' }
    & RefundModalPaymentIntentFragment
  )> }
);

export type GetStripeReceiptUrlQueryVariables = Exact<{
  intentId: Scalars['String'];
}>;


export type GetStripeReceiptUrlQuery = (
  { __typename?: 'Query' }
  & { getStripePaymentIntentData?: Maybe<(
    { __typename?: 'StripePaymentOutput' }
    & { payment: (
      { __typename?: 'StripePayment' }
      & Pick<StripePayment, 'receiptUrl'>
    ) }
  )> }
);

export type RequestBitwerxIntegrationMutationVariables = Exact<{
  data: RequestBitwerxIntegrationInput;
}>;


export type RequestBitwerxIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { requestBitwerxIntegration?: Maybe<(
    { __typename?: 'ClinicPimsIntegration' }
    & Pick<ClinicPimsIntegration, 'id'>
  )> }
);

export type UpsertPetPortalSettingsMutationVariables = Exact<{
  where: PetPortalSettingWhereUniqueInput;
  create: PetPortalSettingCreateInput;
  update: PetPortalSettingUpdateInput;
}>;


export type UpsertPetPortalSettingsMutation = (
  { __typename?: 'Mutation' }
  & { upsertOnePetPortalSetting?: Maybe<(
    { __typename?: 'PetPortalSetting' }
    & Pick<PetPortalSetting, 'id' | 'clinicSettingId' | 'showAppointments'>
  )> }
);

export type JobChainCompletedSubscriptionVariables = Exact<{
  jobChainId: Scalars['String'];
}>;


export type JobChainCompletedSubscription = (
  { __typename?: 'Subscription' }
  & { jobChainCompleted?: Maybe<(
    { __typename?: 'JobChainSubscritptionPayload' }
    & Pick<JobChainSubscritptionPayload, 'jobChainId' | 'payload' | 'error' | 'success'>
  )> }
);

export type JobChainStatusQueryVariables = Exact<{
  jobChainId: Scalars['String'];
}>;


export type JobChainStatusQuery = (
  { __typename?: 'Query' }
  & { jobChainStatus?: Maybe<(
    { __typename?: 'JobChainStatus' }
    & Pick<JobChainStatus, 'status' | 'payload' | 'error' | 'queuedAt' | 'completedAt' | 'erroredAt'>
  )> }
);

export type StripeCreateCustomerPortalQueryVariables = Exact<{
  data?: Maybe<StripeCustomerPortalInput>;
}>;


export type StripeCreateCustomerPortalQuery = (
  { __typename?: 'Query' }
  & { stripeCreateCustomerPortal?: Maybe<(
    { __typename?: 'StripeCustomerPortalOutput' }
    & Pick<StripeCustomerPortalOutput, 'id' | 'url'>
  )> }
);

export type TriggerMessageEventMutationVariables = Exact<{
  useSubscription?: Maybe<Scalars['Boolean']>;
  event: Scalars['String'];
  queueName?: Maybe<SqsQueueNames>;
  data?: Maybe<Scalars['Json']>;
}>;


export type TriggerMessageEventMutation = (
  { __typename?: 'Mutation' }
  & { triggerMessageEvent?: Maybe<(
    { __typename?: 'MessageEventResponse' }
    & Pick<MessageEventResponse, 'success' | 'jobChainId'>
  )> }
);

export type FailedWritebackAppointmentFragment = (
  { __typename?: 'Appointment' }
  & Pick<Appointment, 'id'>
  & { aiRecapPimsWritebackLogEntry: Array<(
    { __typename?: 'AiRecapPimsWritebackLogEntry' }
    & { writebackLog: (
      { __typename?: 'PimsWritebackLogEntry' }
      & Pick<PimsWritebackLogEntry, 'id' | 'status' | 'updatedAt'>
    ) }
  )>, clinicPet?: Maybe<(
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'name'>
  )>, clinicPetParents: Array<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'firstName' | 'lastName'>
  )> }
);

export type GetFailedWritebackAppointmentsQueryVariables = Exact<{
  where: AppointmentWhereInput;
}>;


export type GetFailedWritebackAppointmentsQuery = (
  { __typename?: 'Query' }
  & { appointments: Array<(
    { __typename?: 'Appointment' }
    & FailedWritebackAppointmentFragment
  )> }
);

export type ExclusionRuleSelectionFragment = (
  { __typename?: 'DirectBookingExclusionRule' }
  & Pick<DirectBookingExclusionRule, 'id' | 'name' | 'isActive'>
  & { appointmentTypes: Array<(
    { __typename?: 'AppointmentType' }
    & Pick<AppointmentType, 'id' | 'name' | 'displayName'>
  )>, providers: Array<(
    { __typename?: 'ClinicEmployee' }
    & Pick<ClinicEmployee, 'id' | 'firstName' | 'lastName'>
  )>, timeSlots: Array<(
    { __typename?: 'DirectBookingExclusionTimeSlot' }
    & Pick<DirectBookingExclusionTimeSlot, 'id' | 'updatedAt' | 'dayOfWeek' | 'startTime' | 'endTime'>
  )> }
);

export type DeleteDirectBookingExclusionRuleMutationVariables = Exact<{
  ruleId: Scalars['String'];
}>;


export type DeleteDirectBookingExclusionRuleMutation = (
  { __typename?: 'Mutation' }
  & { deleteOneDirectBookingExclusionRule?: Maybe<(
    { __typename?: 'DirectBookingExclusionRule' }
    & Pick<DirectBookingExclusionRule, 'id'>
  )> }
);

export type UpdateDirectBookingExclusionRuleMutationVariables = Exact<{
  ruleId: Scalars['String'];
  data: DirectBookingExclusionRuleUpdateInput;
}>;


export type UpdateDirectBookingExclusionRuleMutation = (
  { __typename?: 'Mutation' }
  & { updateOneDirectBookingExclusionRule: (
    { __typename?: 'DirectBookingExclusionRule' }
    & ExclusionRuleSelectionFragment
  ) }
);

export type UpsertDirectBookingSettingsMutationVariables = Exact<{
  where: ClinicDirectBookingSettingWhereUniqueInput;
  create: ClinicDirectBookingSettingCreateInput;
  update: ClinicDirectBookingSettingUpdateInput;
}>;


export type UpsertDirectBookingSettingsMutation = (
  { __typename?: 'Mutation' }
  & { upsertOneClinicDirectBookingSetting?: Maybe<(
    { __typename?: 'ClinicDirectBookingSetting' }
    & Pick<ClinicDirectBookingSetting, 'id' | 'exclusionRulesEnabled' | 'appointmentIntervalInMinutesDisplay'>
  )> }
);

export type UpsertDirectBookingExclusionRuleMutationVariables = Exact<{
  where: DirectBookingExclusionRuleWhereUniqueInput;
  create: DirectBookingExclusionRuleCreateInput;
  update: DirectBookingExclusionRuleUpdateInput;
}>;


export type UpsertDirectBookingExclusionRuleMutation = (
  { __typename?: 'Mutation' }
  & { upsertOneDirectBookingExclusionRule?: Maybe<(
    { __typename?: 'DirectBookingExclusionRule' }
    & ExclusionRuleSelectionFragment
  )> }
);

export type GetClinicTimezoneNameQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetClinicTimezoneNameQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinic?: Maybe<(
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id' | 'timezoneName'>
  )> }
);

export type GetDirectBookingAppointmentTypesQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetDirectBookingAppointmentTypesQuery = (
  { __typename?: 'Query' }
  & { findManyAppointmentType: Array<(
    { __typename?: 'AppointmentType' }
    & Pick<AppointmentType, 'id' | 'name'>
  )> }
);

export type GetDirectBookingExclusionsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetDirectBookingExclusionsQuery = (
  { __typename?: 'Query' }
  & { findManyDirectBookingExclusionRule: Array<(
    { __typename?: 'DirectBookingExclusionRule' }
    & ExclusionRuleSelectionFragment
  )> }
);

export type GetDirectBookingProvidersQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetDirectBookingProvidersQuery = (
  { __typename?: 'Query' }
  & { findManyClinicEmployee: Array<(
    { __typename?: 'ClinicEmployee' }
    & Pick<ClinicEmployee, 'id' | 'firstName' | 'lastName'>
  )> }
);

export type GetClinicDirectBookingSettingsQueryVariables = Exact<{
  where: ClinicDirectBookingSettingWhereInput;
}>;


export type GetClinicDirectBookingSettingsQuery = (
  { __typename?: 'Query' }
  & { findFirstClinicDirectBookingSetting?: Maybe<(
    { __typename?: 'ClinicDirectBookingSetting' }
    & Pick<ClinicDirectBookingSetting, 'id' | 'exclusionRulesEnabled' | 'appointmentIntervalInMinutesDisplay' | 'maxTimeInAdvanceValue' | 'maxTimeInAdvanceUnit'>
  )> }
);

export type UpdateAppointmentTypeOrderMutationVariables = Exact<{
  data?: Maybe<Array<AppointmentTypeWithOrder> | AppointmentTypeWithOrder>;
}>;


export type UpdateAppointmentTypeOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateManyAppointmentTypeSortOrder: (
    { __typename?: 'AppointmentTypeWithOrderResponse' }
    & Pick<AppointmentTypeWithOrderResponse, 'success' | 'error'>
  ) }
);

export type UpdateAppointmentTypeProviderRoomMapsMutationVariables = Exact<{
  data: UpdateAppointmentTypeProviderRoomMapsInput;
}>;


export type UpdateAppointmentTypeProviderRoomMapsMutation = (
  { __typename?: 'Mutation' }
  & { updateAppointmentTypeProviderRoomMaps: (
    { __typename?: 'UpdateAppointmentTypeProviderRoomMapsResponse' }
    & Pick<UpdateAppointmentTypeProviderRoomMapsResponse, 'success' | 'count'>
  ) }
);

export type UpdateOneAppointmentTypeMutationVariables = Exact<{
  where: AppointmentTypeWhereUniqueInput;
  data: AppointmentTypeUpdateInput;
}>;


export type UpdateOneAppointmentTypeMutation = (
  { __typename?: 'Mutation' }
  & { updateOneAppointmentType: (
    { __typename?: 'AppointmentType' }
    & Pick<AppointmentType, 'id'>
  ) }
);

export type ProviderFragment = (
  { __typename?: 'ClinicEmployee' }
  & Pick<ClinicEmployee, 'id' | 'firstName' | 'lastName' | 'pimsId'>
);

export type AppointmentTypeFragment = (
  { __typename?: 'AppointmentType' }
  & Pick<AppointmentType, 'id' | 'name' | 'displayName' | 'displayOrder' | 'showInPetPortal' | 'description' | 'isAvailableForDirectBooking' | 'defaultDurationInMinutes' | 'defaultSoonestAvailableBookingInHours' | 'delayedStartTime' | 'hasDeposit' | 'depositAmount' | 'markPaymentAsDeposit'>
  & { directBookingAppointmentTypeSetting?: Maybe<(
    { __typename?: 'DirectBookingAppointmentTypeSetting' }
    & Pick<DirectBookingAppointmentTypeSetting, 'id' | 'clientType'>
  )>, clinicEmployeeAppointmentTypeSettings: Array<(
    { __typename?: 'ClinicEmployeeAppointmentTypeSetting' }
    & { clinicEmployee: (
      { __typename?: 'ClinicEmployee' }
      & ProviderFragment
    ) }
  )> }
);

export type RoomFragment = (
  { __typename?: 'ClinicRoom' }
  & Pick<ClinicRoom, 'id' | 'name' | 'type' | 'pimsId'>
);

export type GetAppointmentSettingsQueryVariables = Exact<{
  clinicSettingId: Scalars['String'];
  clinicId: Scalars['String'];
}>;


export type GetAppointmentSettingsQuery = (
  { __typename?: 'Query' }
  & { findUniquePetPortalSetting?: Maybe<(
    { __typename?: 'PetPortalSetting' }
    & Pick<PetPortalSetting, 'id' | 'clinicSettingId' | 'showAppointments'>
  )>, findManyAppointmentType: Array<(
    { __typename?: 'AppointmentType' }
    & AppointmentTypeFragment
  )>, findManyClinicEmployee: Array<(
    { __typename?: 'ClinicEmployee' }
    & ProviderFragment
  )>, findManyClinicRoom: Array<(
    { __typename?: 'ClinicRoom' }
    & RoomFragment
  )> }
);

export type GetProviderAppointmentTypeRoomMapQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetProviderAppointmentTypeRoomMapQuery = (
  { __typename?: 'Query' }
  & { findManyProviderAppointmentTypeRoomMap: Array<(
    { __typename?: 'ProviderAppointmentTypeRoomMap' }
    & Pick<ProviderAppointmentTypeRoomMap, 'id' | 'clinicEmployeeId' | 'appoinmentTypeId' | 'roomId'>
  )> }
);

export type ClinicSettingsConversationsChannelStatusFragment = (
  { __typename?: 'ChannelStatus' }
  & Pick<ChannelStatus, 'id' | 'createdAt' | 'updatedAt' | 'channelStatusAction' | 'color' | 'deletedOn' | 'isDefault' | 'name' | 'order' | 'isExportedToPims'>
  & { channelStatusChannelAssignees: Array<(
    { __typename?: 'ChannelStatusChannelAssignee' }
    & ClinicSettingsConversationsChannelStatusChannelAssigneeFragment
  )> }
);

export type ClinicSettingsConversationsChannelStatusChannelAssigneeFragment = (
  { __typename?: 'ChannelStatusChannelAssignee' }
  & Pick<ChannelStatusChannelAssignee, 'id'>
  & { user: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type ClinicSettingsConversationsRuleFragment = (
  { __typename?: 'Rules' }
  & Pick<Rules, 'action' | 'clinicId' | 'createdAt' | 'id' | 'options' | 'updatedAt'>
);

export type CreateClinicSettingsConversationsChannelStatusMutationVariables = Exact<{
  clinicSettingId: Scalars['String'];
  channelStatusAction: ChannelStatusAction;
  color: Scalars['String'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
}>;


export type CreateClinicSettingsConversationsChannelStatusMutation = (
  { __typename?: 'Mutation' }
  & { createOneChannelStatus: (
    { __typename?: 'ChannelStatus' }
    & ClinicSettingsConversationsChannelStatusFragment
  ) }
);

export type CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables = Exact<{
  data: RulesCreateInput;
}>;


export type CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation = (
  { __typename?: 'Mutation' }
  & { createOneRules: (
    { __typename?: 'Rules' }
    & ClinicSettingsConversationsRuleFragment
  ) }
);

export type CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutationVariables = Exact<{
  data: ChannelStatusChannelAssigneeCreateInput;
}>;


export type CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutation = (
  { __typename?: 'Mutation' }
  & { createOneChannelStatusChannelAssignee: (
    { __typename?: 'ChannelStatusChannelAssignee' }
    & ClinicSettingsConversationsChannelStatusChannelAssigneeFragment
  ) }
);

export type DeleteClinicSettingsConversationsChannelStatusMutationVariables = Exact<{
  data: ChannelStatusUpdateInput;
  channelStatusId: Scalars['String'];
}>;


export type DeleteClinicSettingsConversationsChannelStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateOneChannelStatus: (
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id'>
  ) }
);

export type DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables = Exact<{
  ruleId: Scalars['String'];
}>;


export type DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation = (
  { __typename?: 'Mutation' }
  & { deleteOneRules?: Maybe<(
    { __typename?: 'Rules' }
    & Pick<Rules, 'id'>
  )> }
);

export type DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation = (
  { __typename?: 'Mutation' }
  & { deleteOneChannelStatusChannelAssignee?: Maybe<(
    { __typename?: 'ChannelStatusChannelAssignee' }
    & Pick<ChannelStatusChannelAssignee, 'id'>
    & ClinicSettingsConversationsChannelStatusChannelAssigneeFragment
  )> }
);

export type OrderClinicSettingsConversationsChannelStatusMutationVariables = Exact<{
  data: ChannelStatusUpdateInput;
  channelStatusId: Scalars['String'];
}>;


export type OrderClinicSettingsConversationsChannelStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateOneChannelStatus: (
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id' | 'order' | 'name'>
  ) }
);

export type UpdateClinicSettingsConversationsChannelStatusMutationVariables = Exact<{
  data: ChannelStatusUpdateInput;
  channelStatusId: Scalars['String'];
}>;


export type UpdateClinicSettingsConversationsChannelStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateOneChannelStatus: (
    { __typename?: 'ChannelStatus' }
    & ClinicSettingsConversationsChannelStatusFragment
  ) }
);

export type UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables = Exact<{
  data: RulesUpdateInput;
  ruleId: Scalars['String'];
}>;


export type UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation = (
  { __typename?: 'Mutation' }
  & { updateOneRules: (
    { __typename?: 'Rules' }
    & ClinicSettingsConversationsRuleFragment
  ) }
);

export type UpdateClinicSettingsConversationsChannelStatusSortOrderMutationVariables = Exact<{
  data?: Maybe<Array<ChannelStatusWithOrder> | ChannelStatusWithOrder>;
}>;


export type UpdateClinicSettingsConversationsChannelStatusSortOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateManyChannelStatusSortOrder: (
    { __typename?: 'ChannelStatusWithOrderResponse' }
    & Pick<ChannelStatusWithOrderResponse, 'success' | 'error'>
  ) }
);

export type GetClinicSettingsClinicSettingIdQueryVariables = Exact<{
  where: ClinicWhereUniqueInput;
}>;


export type GetClinicSettingsClinicSettingIdQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinic?: Maybe<(
    { __typename?: 'Clinic' }
    & { clinicSetting?: Maybe<(
      { __typename?: 'ClinicSetting' }
      & Pick<ClinicSetting, 'id'>
    )> }
  )> }
);

export type GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery = (
  { __typename?: 'Query' }
  & { findManyRules: Array<(
    { __typename?: 'Rules' }
    & ClinicSettingsConversationsRuleFragment
  )> }
);

export type GetClinicSettingsConversationsChannelStatusesQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetClinicSettingsConversationsChannelStatusesQuery = (
  { __typename?: 'Query' }
  & { findManyChannelStatus: Array<(
    { __typename?: 'ChannelStatus' }
    & ClinicSettingsConversationsChannelStatusFragment
  )> }
);

export type GetClinicSettingsConversationsChannelsWithStatusesQueryVariables = Exact<{
  where?: Maybe<ChannelWhereInput>;
}>;


export type GetClinicSettingsConversationsChannelsWithStatusesQuery = (
  { __typename?: 'Query' }
  & { findManyChannel: Array<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id' | 'updatedAt'>
    & { lastMessage?: Maybe<(
      { __typename?: 'ChannelMessage' }
      & Pick<ChannelMessage, 'createdAt'>
    )> }
  )> }
);

export type GetAutomationOverviewQueryVariables = Exact<{
  clinicId?: Maybe<Scalars['String']>;
}>;


export type GetAutomationOverviewQuery = (
  { __typename?: 'Query' }
  & { findManyWorkflowEventSetting: Array<(
    { __typename?: 'WorkflowEventSetting' }
    & Pick<WorkflowEventSetting, 'id' | 'name' | 'isPublished' | 'event' | 'visitType' | 'automatedTriggerType' | 'automatedTriggerInMinutes' | 'sendingHours' | 'notificationBody'>
    & { appointmentTypes: Array<(
      { __typename?: 'AppointmentType' }
      & Pick<AppointmentType, 'id' | 'name'>
    )>, clinicEmployees: Array<(
      { __typename?: 'ClinicEmployeeToWorkflowEventSetting' }
      & { clinicEmployee: (
        { __typename?: 'ClinicEmployee' }
        & Pick<ClinicEmployee, 'id' | 'firstName' | 'lastName'>
      ) }
    )>, clinicRooms: Array<(
      { __typename?: 'ClinicRoomToWorkflowEventSetting' }
      & { clinicRoom: (
        { __typename?: 'ClinicRoom' }
        & Pick<ClinicRoom, 'id' | 'name'>
      ) }
    )>, conditionSets: Array<(
      { __typename?: 'ConditionSet' }
      & { conditions: Array<(
        { __typename?: 'Condition' }
        & Pick<Condition, 'id' | 'attribute' | 'operand'>
      )> }
    )>, actions: Array<(
      { __typename?: 'WorkflowEventAction' }
      & Pick<WorkflowEventAction, 'id' | 'order' | 'promptType' | 'config'>
      & { channelStatusChange?: Maybe<(
        { __typename?: 'ChannelStatus' }
        & Pick<ChannelStatus, 'id' | 'name'>
      )> }
    )> }
  )> }
);

export type FindAutomationsForVisualizerQueryVariables = Exact<{
  where?: Maybe<WorkflowEventSettingWhereInput>;
}>;


export type FindAutomationsForVisualizerQuery = (
  { __typename?: 'Query' }
  & { findManyWorkflowEventSetting: Array<(
    { __typename?: 'WorkflowEventSetting' }
    & VisualizerAutomationFragment
  )> }
);

export type VisualizerAutomationFragment = (
  { __typename?: 'WorkflowEventSetting' }
  & Pick<WorkflowEventSetting, 'id' | 'name'>
  & { actions: Array<(
    { __typename?: 'WorkflowEventAction' }
    & VisualizerAutomationActionFragment
  )> }
);

export type VisualizerAutomationActionFragment = (
  { __typename?: 'WorkflowEventAction' }
  & Pick<WorkflowEventAction, 'id' | 'createdAt' | 'updatedAt' | 'actionType' | 'config' | 'order' | 'triggerWorkflowId' | 'workflowEventTriggerActionNumber' | 'workflowEventSettingId' | 'channelStatusChangeId' | 'responseChannelStatusChangeId' | 'promptType'>
);

export type FindFormTemplatesForVisualizerQueryVariables = Exact<{
  where?: Maybe<FormTemplateWhereInput>;
}>;


export type FindFormTemplatesForVisualizerQuery = (
  { __typename?: 'Query' }
  & { findManyFormTemplate: Array<(
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id' | 'title'>
  )> }
);

export type FindChannelStatusForVisualizerQueryVariables = Exact<{
  where?: Maybe<ChannelStatusWhereInput>;
}>;


export type FindChannelStatusForVisualizerQuery = (
  { __typename?: 'Query' }
  & { findManyChannelStatus: Array<(
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id' | 'name'>
  )> }
);

export type EmergencyClinicsFragment = (
  { __typename?: 'EmergencyClinics' }
  & Pick<EmergencyClinics, 'id' | 'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'postalCode' | 'phone' | 'clinicSettingId' | 'isDeleted' | 'fullAddress' | 'displayOrder'>
);

export type VerifyTwilioSubAccountCallerIdMutationVariables = Exact<{
  data: TwilioVerifySubAccountCallerIdInput;
}>;


export type VerifyTwilioSubAccountCallerIdMutation = (
  { __typename?: 'Mutation' }
  & { twilioVerifySubAccountCallerId?: Maybe<(
    { __typename?: 'TwilioCallerIdVerification' }
    & Pick<TwilioCallerIdVerification, 'callSid' | 'validationCode'>
  )> }
);

export type CreateEmergencyClinicMutationVariables = Exact<{
  data: EmergencyClinicsCreateInput;
}>;


export type CreateEmergencyClinicMutation = (
  { __typename?: 'Mutation' }
  & { createOneEmergencyClinics: (
    { __typename?: 'EmergencyClinics' }
    & EmergencyClinicsFragment
  ) }
);

export type SoftDeleteEmergencyClinicMutationVariables = Exact<{
  where: EmergencyClinicsWhereUniqueInput;
}>;


export type SoftDeleteEmergencyClinicMutation = (
  { __typename?: 'Mutation' }
  & { updateOneEmergencyClinics: (
    { __typename?: 'EmergencyClinics' }
    & Pick<EmergencyClinics, 'id'>
  ) }
);

export type UpdateClinicSettingsClinicMutationVariables = Exact<{
  data: ClinicUpdateInput;
  id: Scalars['String'];
}>;


export type UpdateClinicSettingsClinicMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinic: (
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id' | 'timezoneName' | 'name' | 'logo' | 'phone' | 'fullAddress' | 'websiteUrl' | 'addressLine1' | 'addressLine2' | 'postalCode' | 'country' | 'city' | 'state'>
  ) }
);

export type UpdateClinicSettingsOutOfOfficeInformationMutationVariables = Exact<{
  data: ClinicSettingUpdateInput;
  id?: Maybe<Scalars['String']>;
}>;


export type UpdateClinicSettingsOutOfOfficeInformationMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinicSetting: (
    { __typename?: 'ClinicSetting' }
    & Pick<ClinicSetting, 'id' | 'outOfOfficeHeadline' | 'outOfOfficeEnabled' | 'outOfOfficeShowScheduleEnabled' | 'emergencyContactsEnabled'>
  ) }
);

export type UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutationVariables = Exact<{
  data: TwilioVerifyCallerIdInput;
}>;


export type UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutation = (
  { __typename?: 'Mutation' }
  & { twilioVerifyCallerId?: Maybe<(
    { __typename?: 'TwilioCallerIdVerification' }
    & Pick<TwilioCallerIdVerification, 'callSid' | 'validationCode'>
  )> }
);

export type UpdateEmergencyClinicMutationVariables = Exact<{
  where: EmergencyClinicsWhereUniqueInput;
  data: EmergencyClinicsUpdateInput;
}>;


export type UpdateEmergencyClinicMutation = (
  { __typename?: 'Mutation' }
  & { updateOneEmergencyClinics: (
    { __typename?: 'EmergencyClinics' }
    & EmergencyClinicsFragment
  ) }
);

export type UpdateEmergencyClinicDisplayOrderMutationVariables = Exact<{
  where: EmergencyClinicsWhereUniqueInput;
  data: Scalars['Int'];
}>;


export type UpdateEmergencyClinicDisplayOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateOneEmergencyClinics: (
    { __typename?: 'EmergencyClinics' }
    & Pick<EmergencyClinics, 'id'>
  ) }
);

export type FindEmployerIdentificationNumberQueryVariables = Exact<{
  data: FindEmployerIdentificationNumberInput;
}>;


export type FindEmployerIdentificationNumberQuery = (
  { __typename?: 'Query' }
  & { findEmployerIdentificationNumber?: Maybe<Array<Maybe<(
    { __typename?: 'FindEmployerIdentificationNumberResponse' }
    & Pick<FindEmployerIdentificationNumberResponse, 'ein' | 'companyName' | 'address' | 'companyPhone' | 'url' | 'businessName' | 'error'>
  )>>> }
);

export type ClinicOfficeHourSelectionFragment = (
  { __typename?: 'ClinicOfficeHour' }
  & Pick<ClinicOfficeHour, 'id' | 'closeAt' | 'dayOfWeek' | 'isEnabled' | 'isOpenTwentyFourHours' | 'openAt' | 'type'>
);

export type GetClinicSettingsGeneralQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetClinicSettingsGeneralQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinic?: Maybe<(
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id' | 'addressLine1' | 'addressLine2' | 'city' | 'country' | 'fullAddress' | 'logo' | 'name' | 'phone' | 'clinicEmail' | 'postalCode' | 'state' | 'timezoneName' | 'websiteUrl' | 'isCallerIdVerified'>
    & { clinicOfficeHours: Array<(
      { __typename?: 'ClinicOfficeHour' }
      & ClinicOfficeHourSelectionFragment
    )>, clinicSetting?: Maybe<(
      { __typename?: 'ClinicSetting' }
      & Pick<ClinicSetting, 'id' | 'outOfOfficeEnabled' | 'outOfOfficeHeadline' | 'outOfOfficeShowScheduleEnabled' | 'emergencyContactsEnabled'>
      & { emergencyClinics: Array<(
        { __typename?: 'EmergencyClinics' }
        & EmergencyClinicsFragment
      )> }
    )>, twilioVerifications: Array<(
      { __typename?: 'TwilioVerification' }
      & Pick<TwilioVerification, 'id' | 'phoneNumber' | 'status'>
    )> }
  )> }
);

export type FindClinicLegalEntityQueryVariables = Exact<{
  where: ClinicWhereUniqueInput;
}>;


export type FindClinicLegalEntityQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinic?: Maybe<(
    { __typename?: 'Clinic' }
    & { legalEntity?: Maybe<(
      { __typename?: 'LegalEntity' }
      & LegalEntityFragment
    )> }
  )> }
);

export type LegalEntityFragment = (
  { __typename?: 'LegalEntity' }
  & Pick<LegalEntity, 'id' | 'ein' | 'type' | 'name'>
  & { clinics: Array<(
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id'>
  )> }
);

export type UpsertOneLegalEntityMutationVariables = Exact<{
  where: LegalEntityWhereUniqueInput;
  create: LegalEntityCreateInput;
  update: LegalEntityUpdateInput;
}>;


export type UpsertOneLegalEntityMutation = (
  { __typename?: 'Mutation' }
  & { upsertOneLegalEntity?: Maybe<(
    { __typename?: 'LegalEntity' }
    & LegalEntityFragment
  )> }
);

export type SubscribeToClinicSettingsGeneralTwilioVerificationSubscriptionVariables = Exact<{
  where: SubscriptionTwilioVerificationWhereInput;
}>;


export type SubscribeToClinicSettingsGeneralTwilioVerificationSubscription = (
  { __typename?: 'Subscription' }
  & { twilioVerificationChanged: (
    { __typename?: 'TwilioVerificationSubscription' }
    & { node: (
      { __typename?: 'TwilioVerification' }
      & Pick<TwilioVerification, 'status'>
    ) }
  ) }
);

export type ClinicSettingsNotificationsUserSettingsFragment = (
  { __typename?: 'UserSetting' }
  & Pick<UserSetting, 'id' | 'snoozeNotificationsUntil'>
  & { browserNotificationFilter?: Maybe<(
    { __typename?: 'ChannelSelection' }
    & Pick<ChannelSelection, 'id' | 'includeUnassigned'>
    & { assignees: Array<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )> }
  )>, notificationSettings: Array<(
    { __typename?: 'UserNotificationSetting' }
    & Pick<UserNotificationSetting, 'id' | 'emailEnabled' | 'smsEnabled' | 'soundNotificationUrl' | 'browserNotificationEnabled' | 'pushNotificationEnabled'>
  )> }
);

export type UpdateClinicSettingsNotificationsUserSettingMutationVariables = Exact<{
  data: UserSettingUpdateInput;
  where: UserSettingWhereUniqueInput;
}>;


export type UpdateClinicSettingsNotificationsUserSettingMutation = (
  { __typename?: 'Mutation' }
  & { updateOneUserSetting: (
    { __typename?: 'UserSetting' }
    & Pick<UserSetting, 'id' | 'snoozeNotificationsUntil'>
    & { browserNotificationFilter?: Maybe<(
      { __typename?: 'ChannelSelection' }
      & Pick<ChannelSelection, 'id' | 'includeUnassigned'>
      & { assignees: Array<(
        { __typename?: 'User' }
        & Pick<User, 'id'>
      )> }
    )>, notificationSettings: Array<(
      { __typename?: 'UserNotificationSetting' }
      & Pick<UserNotificationSetting, 'id' | 'emailEnabled' | 'smsEnabled' | 'soundNotificationUrl' | 'browserNotificationEnabled' | 'pushNotificationEnabled'>
    )> }
  ) }
);

export type GetClinicSettingsNotificationsUserSettingsQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type GetClinicSettingsNotificationsUserSettingsQuery = (
  { __typename?: 'Query' }
  & { findUniqueUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firebaseId' | 'firstName' | 'lastName' | 'profilePic' | 'email'>
    & { userSetting?: Maybe<(
      { __typename?: 'UserSetting' }
      & Pick<UserSetting, 'id' | 'emailNotifications' | 'smsNotifications' | 'snoozeNotificationsUntil'>
      & { browserNotificationFilter?: Maybe<(
        { __typename?: 'ChannelSelection' }
        & Pick<ChannelSelection, 'id' | 'includeUnassigned'>
        & { assignees: Array<(
          { __typename?: 'User' }
          & Pick<User, 'id'>
        )> }
      )>, notificationSettings: Array<(
        { __typename?: 'UserNotificationSetting' }
        & Pick<UserNotificationSetting, 'id' | 'settingType' | 'emailEnabled' | 'smsEnabled' | 'pushNotificationEnabled' | 'soundNotificationUrl' | 'browserNotificationEnabled' | 'createdAt' | 'updatedAt'>
      )> }
    )> }
  )> }
);

export type UpdateUserPreferencesMutationVariables = Exact<{
  data: UserSettingUpdateInput;
  where: UserSettingWhereUniqueInput;
}>;


export type UpdateUserPreferencesMutation = (
  { __typename?: 'Mutation' }
  & { updateOneUserSetting: (
    { __typename?: 'UserSetting' }
    & Pick<UserSetting, 'id' | 'enterAddsNewLine' | 'skipLoadingAnimation'>
  ) }
);

export type UserSettingsDataFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'namePrefix' | 'nameSuffix' | 'phone' | 'email' | 'firebaseId'>
  & { vetInfo?: Maybe<(
    { __typename?: 'VetInfo' }
    & Pick<VetInfo, 'id'>
  )> }
  & ClinicUserAvatarFragment
);

export type UpdateChangePasswordModalUserMutationVariables = Exact<{
  where: UserWhereUniqueInput;
  data: UserUpdateInput;
}>;


export type UpdateChangePasswordModalUserMutation = (
  { __typename?: 'Mutation' }
  & { updateOneUser: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'namePrefix' | 'nameSuffix' | 'email' | 'phone' | 'isNewPasswordRequired'>
  ) }
);

export type UpdateClinicSettingsUserMutationVariables = Exact<{
  where: UserWhereUniqueInput;
  data: UserUpdateInput;
}>;


export type UpdateClinicSettingsUserMutation = (
  { __typename?: 'Mutation' }
  & { updateOneUser: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'profilePic'>
  ) }
);

export type GetClinicSettingsUserQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type GetClinicSettingsUserQuery = (
  { __typename?: 'Query' }
  & { findUniqueUser?: Maybe<(
    { __typename?: 'User' }
    & UserSettingsDataFragment
  )> }
);

export type EncryptAndUploadDataMutationVariables = Exact<{
  body: Scalars['String'];
  purpose: EncryptedSignedUploadPurpose;
  extension: Scalars['String'];
}>;


export type EncryptAndUploadDataMutation = (
  { __typename?: 'Mutation' }
  & { encryptAndUploadData: (
    { __typename?: 'EncryptedUploadResponse' }
    & Pick<EncryptedUploadResponse, 'success'>
  ) }
);

export type GenerateTerminalSetupPinMutationVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GenerateTerminalSetupPinMutation = (
  { __typename?: 'Mutation' }
  & { generateTerminalSetupPin?: Maybe<(
    { __typename?: 'GenerateTerminalSetupPinResponse' }
    & Pick<GenerateTerminalSetupPinResponse, 'pin'>
  )> }
);

export type UpsertOneBitwerxPaymentWritebackConfigurationMutationVariables = Exact<{
  where: BitwerxPaymentWritebackConfigurationWhereUniqueInput;
  create: BitwerxPaymentWritebackConfigurationCreateInput;
  update: BitwerxPaymentWritebackConfigurationUpdateInput;
}>;


export type UpsertOneBitwerxPaymentWritebackConfigurationMutation = (
  { __typename?: 'Mutation' }
  & { upsertOneBitwerxPaymentWritebackConfiguration?: Maybe<(
    { __typename?: 'BitwerxPaymentWritebackConfiguration' }
    & Pick<BitwerxPaymentWritebackConfiguration, 'id' | 'integrationId' | 'enteredById' | 'defaultPimsPaymentTypeId' | 'visaPimsPaymentTypeId' | 'mastercardPimsPaymentTypeId' | 'amexPimsPaymentTypeId' | 'discoverPimsPaymentTypeId' | 'writebackManualPayment'>
  )> }
);

export type GetBitwerxPaymentWritebackConfigQueryVariables = Exact<{
  integrationId: Scalars['String'];
}>;


export type GetBitwerxPaymentWritebackConfigQuery = (
  { __typename?: 'Query' }
  & { findUniqueBitwerxPaymentWritebackConfiguration?: Maybe<(
    { __typename?: 'BitwerxPaymentWritebackConfiguration' }
    & Pick<BitwerxPaymentWritebackConfiguration, 'id' | 'integrationId' | 'enteredById' | 'defaultPimsPaymentTypeId' | 'visaPimsPaymentTypeId' | 'mastercardPimsPaymentTypeId' | 'amexPimsPaymentTypeId' | 'discoverPimsPaymentTypeId' | 'writebackManualPayment'>
  )> }
);

export type GetClinicEmployeesForPaymentSettingsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetClinicEmployeesForPaymentSettingsQuery = (
  { __typename?: 'Query' }
  & { findManyClinicEmployee: Array<(
    { __typename?: 'ClinicEmployee' }
    & Pick<ClinicEmployee, 'pimsId' | 'isDeleted'>
    & ClinicEmployeeBaseSelectionFragment
  )> }
);

export type PimsPaymentTypeSelectionFragment = (
  { __typename?: 'PimsPaymentType' }
  & Pick<PimsPaymentType, 'id' | 'pimsId' | 'isInactive' | 'isDeleted' | 'description'>
);

export type GetPimsPaymentTypesQueryVariables = Exact<{
  integrationId: Scalars['String'];
}>;


export type GetPimsPaymentTypesQuery = (
  { __typename?: 'Query' }
  & { findManyPimsPaymentType: Array<(
    { __typename?: 'PimsPaymentType' }
    & PimsPaymentTypeSelectionFragment
  )> }
);

export type GetTerminalLocationCountQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetTerminalLocationCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyStripeTerminalLocationCount'>
);

export type ReminderSettingsServiceFragment = (
  { __typename?: 'Service' }
  & Pick<Service, 'id' | 'code' | 'name' | 'formTemplateId' | 'pimsName' | 'pimsId' | 'isPetPortal' | 'isPostcard' | 'reminderActivationDate'>
  & { reminderTimings: Array<(
    { __typename?: 'ServiceReminderTiming' }
    & ReminderSettingsServiceTimingFragment
  )> }
);

export type ReminderSettingsServiceTimingFragment = (
  { __typename?: 'ServiceReminderTiming' }
  & Pick<ServiceReminderTiming, 'id' | 'timingType' | 'offset' | 'offsetUnit' | 'hourOfDay' | 'minuteOfHour' | 'isEmail' | 'isSms' | 'isPush'>
);

export type ReminderSettingsWorkflowEventSettingFragment = (
  { __typename?: 'WorkflowEventSetting' }
  & Pick<WorkflowEventSetting, 'id'>
  & { actions: Array<(
    { __typename?: 'WorkflowEventAction' }
    & Pick<WorkflowEventAction, 'id' | 'config'>
    & { channelStatusChange?: Maybe<(
      { __typename?: 'ChannelStatus' }
      & Pick<ChannelStatus, 'id' | 'name' | 'color'>
    )> }
  )> }
);

export type ToggleClinicIsServiceRemindersActiveMutationVariables = Exact<{
  clinicId: Scalars['String'];
  isServiceRemindersActive: Scalars['Boolean'];
}>;


export type ToggleClinicIsServiceRemindersActiveMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinic: (
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id' | 'isServiceRemindersActive'>
  ) }
);

export type UpdateClinicPostcardSettingMutationVariables = Exact<{
  where?: Maybe<UpdateClinicPostcardSettingWhereInput>;
  data: UpdateClinicPostcardSettingDataInput;
}>;


export type UpdateClinicPostcardSettingMutation = (
  { __typename?: 'Mutation' }
  & { updateClinicPostcardSetting: (
    { __typename?: 'ClinicPostcardSetting' }
    & Pick<ClinicPostcardSetting, 'id'>
  ) }
);

export type UpdateReminderSettingsServiceMutationVariables = Exact<{
  where?: Maybe<ServiceWhereInput>;
  data: ServiceUpdateManyMutationInput;
}>;


export type UpdateReminderSettingsServiceMutation = (
  { __typename?: 'Mutation' }
  & { updateManyService?: Maybe<(
    { __typename?: 'BatchPayload' }
    & Pick<BatchPayload, 'count'>
  )> }
);

export type UpdateReminderSettingsWorkflowEventSettingMutationVariables = Exact<{
  where: WorkflowEventSettingWhereUniqueInput;
  data: WorkflowEventSettingUpdateInput;
}>;


export type UpdateReminderSettingsWorkflowEventSettingMutation = (
  { __typename?: 'Mutation' }
  & { updateOneWorkflowEventSetting: (
    { __typename?: 'WorkflowEventSetting' }
    & ReminderSettingsWorkflowEventSettingFragment
  ) }
);

export type UpdateServicesTimingsMutationVariables = Exact<{
  where: ServiceWhereInput;
  data: Array<ServiceReminderTimingInput> | ServiceReminderTimingInput;
}>;


export type UpdateServicesTimingsMutation = (
  { __typename?: 'Mutation' }
  & { updateManyServicesAndTimings: Array<(
    { __typename?: 'Service' }
    & Pick<Service, 'id'>
  )> }
);

export type ToggleServicesTimingsDeliveryOptionsMutationVariables = Exact<{
  where: ServiceWhereInput;
  data: ServiceReminderTimingDeliveryOptionInput;
}>;


export type ToggleServicesTimingsDeliveryOptionsMutation = (
  { __typename?: 'Mutation' }
  & { updateManyTimingsDeliveryOptions: Array<(
    { __typename?: 'Service' }
    & Pick<Service, 'id'>
  )> }
);

export type GetClinicIsServiceRemindersActiveQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetClinicIsServiceRemindersActiveQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinic?: Maybe<(
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id' | 'isServiceRemindersActive'>
  )> }
);

export type GetClinicPostcardsSettingsQueryVariables = Exact<{
  where: ClinicPostcardSettingWhereUniqueInput;
}>;


export type GetClinicPostcardsSettingsQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinicPostcardSetting?: Maybe<(
    { __typename?: 'ClinicPostcardSetting' }
    & Pick<ClinicPostcardSetting, 'id' | 'isRemindersEnabled' | 'apiKey' | 'apiSecret'>
  )> }
);

export type GetClinicStripeInfoQueryVariables = Exact<{
  where: ClinicWhereUniqueInput;
}>;


export type GetClinicStripeInfoQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinic?: Maybe<(
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id' | 'stripeCustomerId' | 'stripeSubscriptionId'>
  )> }
);

export type GetReminderSettingsClinicServicesQueryVariables = Exact<{
  where?: Maybe<ServiceWhereInput>;
  orderBy?: Maybe<Array<ServiceOrderByWithRelationInput> | ServiceOrderByWithRelationInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type GetReminderSettingsClinicServicesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyServiceCount'>
  & { findManyService: Array<(
    { __typename?: 'Service' }
    & ReminderSettingsServiceFragment
  )> }
);

export type GetReminderSettingsClinicServicesFormTemplateIdQueryVariables = Exact<{
  clinicId?: Maybe<Scalars['String']>;
}>;


export type GetReminderSettingsClinicServicesFormTemplateIdQuery = (
  { __typename?: 'Query' }
  & { findFirstFormTemplate?: Maybe<(
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id' | 'isDeleted' | 'isActive'>
  )> }
);

export type GetReminderSettingsClinicServicesTimingsQueryVariables = Exact<{
  where?: Maybe<ServiceReminderTimingWhereInput>;
}>;


export type GetReminderSettingsClinicServicesTimingsQuery = (
  { __typename?: 'Query' }
  & { findManyServiceReminderTiming: Array<(
    { __typename?: 'ServiceReminderTiming' }
    & ReminderSettingsServiceTimingFragment
  )> }
);

export type GetReminderSettingsWorkflowEventSettingQueryVariables = Exact<{
  where: WorkflowEventSettingWhereInput;
}>;


export type GetReminderSettingsWorkflowEventSettingQuery = (
  { __typename?: 'Query' }
  & { findManyWorkflowEventSetting: Array<(
    { __typename?: 'WorkflowEventSetting' }
    & ReminderSettingsWorkflowEventSettingFragment
  )> }
);

export type GetWidgetRequestTypesTableQueryVariables = Exact<{
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>> | Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>>;
}>;


export type GetWidgetRequestTypesTableQuery = (
  { __typename?: 'Query' }
  & { findManyClinicWidgetRequestType: Array<(
    { __typename?: 'ClinicWidgetRequestType' }
    & Pick<ClinicWidgetRequestType, 'id' | 'createdAt' | 'updatedAt' | 'displayName' | 'order' | 'requestType' | 'shouldCreateTask'>
    & { assignees: Array<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )> }
  )> }
);

export type UpdateOneClinicWidgetRequestTypeMutationVariables = Exact<{
  data: ClinicWidgetRequestTypeUpdateInput;
  where: ClinicWidgetRequestTypeWhereUniqueInput;
}>;


export type UpdateOneClinicWidgetRequestTypeMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinicWidgetRequestType: (
    { __typename?: 'ClinicWidgetRequestType' }
    & Pick<ClinicWidgetRequestType, 'id' | 'shouldCreateTask'>
    & { assignees: Array<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )> }
  ) }
);

export type ClinicSettingsTeamUserFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'namePrefix' | 'nameSuffix' | 'invitedAt' | 'invitationCode' | 'email' | 'phone' | 'type'>
  & { vetInfo?: Maybe<(
    { __typename?: 'VetInfo' }
    & Pick<VetInfo, 'id'>
    & { roles: Array<(
      { __typename?: 'StaffRole' }
      & Pick<StaffRole, 'id' | 'role'>
    )> }
  )> }
  & ClinicUserAvatarFragment
);

export type DeleteClinicSettingsTeamUserMutationVariables = Exact<{
  data: RemoveUserFromClinicInput;
}>;


export type DeleteClinicSettingsTeamUserMutation = (
  { __typename?: 'Mutation' }
  & { removeUserFromClinic: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type ResendUserInvitationMutationVariables = Exact<{
  email: Scalars['String'];
  clinicId: Scalars['String'];
}>;


export type ResendUserInvitationMutation = (
  { __typename?: 'Mutation' }
  & { resendUserInvitation: (
    { __typename?: 'User' }
    & ClinicSettingsTeamUserFragment
  ) }
);

export type UpdateClinicSettingsTeamUserMutationVariables = Exact<{
  where: UserWhereUniqueInput;
  data: UserUpdateInput;
}>;


export type UpdateClinicSettingsTeamUserMutation = (
  { __typename?: 'Mutation' }
  & { updateOneUser: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'namePrefix' | 'nameSuffix' | 'email' | 'phone' | 'isNewPasswordRequired'>
  ) }
);

export type UpsertUserToClinicMutationVariables = Exact<{
  data: UpsertUserToClinicInput;
}>;


export type UpsertUserToClinicMutation = (
  { __typename?: 'Mutation' }
  & { upsertUserToClinic: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type GetClinicSettingsTeamUsersQueryVariables = Exact<{
  where: UserWhereInput;
  clinicId: Scalars['String'];
}>;


export type GetClinicSettingsTeamUsersQuery = (
  { __typename?: 'Query' }
  & { findManyUser: Array<(
    { __typename?: 'User' }
    & ClinicSettingsTeamUserFragment
  )> }
);

export type CreateOneClinicBlockedPhoneNumberMutationVariables = Exact<{
  data: ClinicBlockedPhoneNumberCreateInput;
}>;


export type CreateOneClinicBlockedPhoneNumberMutation = (
  { __typename?: 'Mutation' }
  & { createOneClinicBlockedPhoneNumber: (
    { __typename?: 'ClinicBlockedPhoneNumber' }
    & ClinicBlockedPhoneNumberFragment
  ) }
);

export type ClinicBlockedPhoneNumberFragment = (
  { __typename?: 'ClinicBlockedPhoneNumber' }
  & Pick<ClinicBlockedPhoneNumber, 'id' | 'clinicId' | 'phoneNumber' | 'createdAt' | 'updatedAt' | 'notes'>
  & { blockedBy?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'nameDisplay' | 'firstName' | 'lastName'>
  )>, unblockedBy?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'nameDisplay' | 'firstName' | 'lastName'>
  )> }
);

export type FindManyClinicBlockedPhoneNumberQueryVariables = Exact<{
  where?: Maybe<ClinicBlockedPhoneNumberWhereInput>;
}>;


export type FindManyClinicBlockedPhoneNumberQuery = (
  { __typename?: 'Query' }
  & { findManyClinicBlockedPhoneNumber: Array<(
    { __typename?: 'ClinicBlockedPhoneNumber' }
    & ClinicBlockedPhoneNumberFragment
  )> }
);

export type UpdateOneClinicBlockedPhoneNumberMutationVariables = Exact<{
  data: ClinicBlockedPhoneNumberUpdateInput;
  where: ClinicBlockedPhoneNumberWhereUniqueInput;
}>;


export type UpdateOneClinicBlockedPhoneNumberMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinicBlockedPhoneNumber: (
    { __typename?: 'ClinicBlockedPhoneNumber' }
    & ClinicBlockedPhoneNumberFragment
  ) }
);

export type CreateOneClinicPhoneNumberMutationVariables = Exact<{
  data: ClinicPhoneNumberCreateInput;
}>;


export type CreateOneClinicPhoneNumberMutation = (
  { __typename?: 'Mutation' }
  & { createOneClinicPhoneNumber: (
    { __typename?: 'ClinicPhoneNumber' }
    & ClinicPhoneNumberFragment
  ) }
);

export type OrderBandwidthPhoneNumberMutationVariables = Exact<{
  data: OrderPhoneNumberInput;
}>;


export type OrderBandwidthPhoneNumberMutation = (
  { __typename?: 'Mutation' }
  & { orderPhoneNumber?: Maybe<(
    { __typename?: 'ClinicPhoneNumber' }
    & ClinicPhoneNumberFragment
  )> }
);

export type TwilioPurchaseNumberMutationVariables = Exact<{
  data?: Maybe<GenericClinicIdInput>;
}>;


export type TwilioPurchaseNumberMutation = (
  { __typename?: 'Mutation' }
  & { twilioPurchaseNumber?: Maybe<(
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'payload' | 'success'>
  )> }
);

export type RegisterTwilioSubaccountMutationVariables = Exact<{
  clinicId: Scalars['String'];
  accountOwnerEmail: Scalars['String'];
  accountOwnerPhone: Scalars['String'];
  accountOwnerFirstName: Scalars['String'];
  accountOwnerLastName: Scalars['String'];
}>;


export type RegisterTwilioSubaccountMutation = (
  { __typename?: 'Mutation' }
  & { registerTwilioSubaccount?: Maybe<(
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'payload' | 'success'>
  )> }
);

export type RetryCampaignRegistrationMutationVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type RetryCampaignRegistrationMutation = (
  { __typename?: 'Mutation' }
  & { retryTwilioCampaignRegistration?: Maybe<(
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'payload' | 'success'>
  )> }
);

export type TwilioGetOrCreateHostedNumberOrderMutationVariables = Exact<{
  data: TwilioGetOrCreateHostedNumberOrderInput;
}>;


export type TwilioGetOrCreateHostedNumberOrderMutation = (
  { __typename?: 'Mutation' }
  & { twilioGetOrCreateHostedNumberOrder?: Maybe<(
    { __typename?: 'TwilioGetOrCreateHostedNumberOrderOutput' }
    & Pick<TwilioGetOrCreateHostedNumberOrderOutput, 'orderId' | 'status'>
  )> }
);

export type TwilioGetOrGenerateLoaMutationVariables = Exact<{
  data: TwilioGetOrGenerateLoaInput;
}>;


export type TwilioGetOrGenerateLoaMutation = (
  { __typename?: 'Mutation' }
  & { twilioGetOrGenerateLOA?: Maybe<(
    { __typename?: 'TwilioGetOrGenerateLOAResponse' }
    & Pick<TwilioGetOrGenerateLoaResponse, 'url' | 'status' | 'email'>
  )> }
);

export type UpdateClinicSettingsConversationsSmsMutationVariables = Exact<{
  where: ClinicWhereUniqueInput;
  data: ClinicUpdateInput;
}>;


export type UpdateClinicSettingsConversationsSmsMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinic: (
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id' | 'hasSmsConversations'>
  ) }
);

export type UpdateClinicSettingsConversationsSmsAutoResponseMutationVariables = Exact<{
  where: ClinicSettingWhereUniqueInput;
  data: ClinicSettingUpdateInput;
}>;


export type UpdateClinicSettingsConversationsSmsAutoResponseMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinicSetting: (
    { __typename?: 'ClinicSetting' }
    & Pick<ClinicSetting, 'id' | 'smsAutoResponseWhenOpen' | 'smsAutoResponseWhenClosed'>
  ) }
);

export type UpdateClinicSettingsConversationsTransferTwilioNumberMutationVariables = Exact<{
  phoneNumberSid: Scalars['String'];
  fromSubaccountSid?: Maybe<Scalars['String']>;
}>;


export type UpdateClinicSettingsConversationsTransferTwilioNumberMutation = (
  { __typename?: 'Mutation' }
  & { transferTwilioNumber?: Maybe<(
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'success' | 'payload'>
  )> }
);

export type GetClinicPhoneNumbersQueryVariables = Exact<{
  where?: Maybe<ClinicPhoneNumberWhereInput>;
}>;


export type GetClinicPhoneNumbersQuery = (
  { __typename?: 'Query' }
  & { findManyClinicPhoneNumber: Array<(
    { __typename?: 'ClinicPhoneNumber' }
    & ClinicPhoneNumberFragment
  )> }
);

export type ClinicPhoneNumberFragment = (
  { __typename?: 'ClinicPhoneNumber' }
  & Pick<ClinicPhoneNumber, 'id' | 'capability' | 'provider' | 'isPrimary' | 'isActive' | 'isVerified' | 'isDeleted' | 'number' | 'status' | 'loaSignedAt' | 'loaSignedByUserId' | 'loaUrl' | 'incomingCarrier' | 'portingOrderId'>
);

export type GetClinicSettingsConversationsAllActiveTwilioNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClinicSettingsConversationsAllActiveTwilioNumbersQuery = (
  { __typename?: 'Query' }
  & { getTwilioNumbers?: Maybe<(
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'success' | 'payload'>
  )> }
);

export type GetClinicSettingsConversationsSmsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  clinicId: Scalars['ID'];
}>;


export type GetClinicSettingsConversationsSmsQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinic?: Maybe<(
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id' | 'hasSmsConversations'>
    & { twilioConfiguration?: Maybe<(
      { __typename?: 'TwilioConfiguration' }
      & Pick<TwilioConfiguration, 'id' | 'subaccountSid' | 'messagingServiceSid'>
    )>, clinicSetting?: Maybe<(
      { __typename?: 'ClinicSetting' }
      & Pick<ClinicSetting, 'id' | 'smsAutoResponseWhenOpen' | 'smsAutoResponseWhenClosed'>
    )> }
  )>, getTwilioNumbers?: Maybe<(
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'success' | 'payload'>
  )> }
);

export type SearchAvailableBandwidthNumbersQueryVariables = Exact<{
  data?: Maybe<SearchPhoneNumberInput>;
}>;


export type SearchAvailableBandwidthNumbersQuery = (
  { __typename?: 'Query' }
  & { searchPhoneNumber?: Maybe<(
    { __typename?: 'SearchPhoneNumberResponse' }
    & Pick<SearchPhoneNumberResponse, 'total' | 'phoneNumbers'>
  )> }
);

export type TwilioA2PRegistrationStatusQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type TwilioA2PRegistrationStatusQuery = (
  { __typename?: 'Query' }
  & { twilioA2PRegistrationStatus?: Maybe<(
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'payload' | 'success'>
  )> }
);

export type TwilioEligibilityCheckQueryVariables = Exact<{
  data: TwilioEligibilityCheckInput;
}>;


export type TwilioEligibilityCheckQuery = (
  { __typename?: 'Query' }
  & { twilioEligibilityCheck?: Maybe<(
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'success' | 'payload'>
  )> }
);

export type UpdateOneClinicPhoneNumberMutationVariables = Exact<{
  where: ClinicPhoneNumberWhereUniqueInput;
  data: ClinicPhoneNumberUpdateInput;
}>;


export type UpdateOneClinicPhoneNumberMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinicPhoneNumber: (
    { __typename?: 'ClinicPhoneNumber' }
    & ClinicPhoneNumberFragment
  ) }
);

export type SubscribeToClinicPhoneNumbersSubscriptionVariables = Exact<{
  where: ClinicPhoneNumberWhereInput;
}>;


export type SubscribeToClinicPhoneNumbersSubscription = (
  { __typename?: 'Subscription' }
  & { clinicPhoneNumberChanged: (
    { __typename?: 'ClinicPhoneNumberSubscription' }
    & Pick<ClinicPhoneNumberSubscription, 'mutation'>
    & { node: (
      { __typename?: 'ClinicPhoneNumber' }
      & ClinicPhoneNumberFragment
    ) }
  ) }
);

export type ConnectSettingsClinicWidgetRequestTypeFragment = (
  { __typename?: 'ClinicWidgetRequestType' }
  & Pick<ClinicWidgetRequestType, 'id' | 'order' | 'isActive' | 'isDeleted' | 'displayName' | 'requestType' | 'requestVisibility' | 'shouldCreateTask'>
  & { formTemplate?: Maybe<(
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id' | 'title'>
    & { clinicWidgetRequestTypes: Array<(
      { __typename?: 'ClinicWidgetRequestType' }
      & Pick<ClinicWidgetRequestType, 'id'>
    )> }
  )>, assignees: Array<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & ClinicUserAvatarFragment
  )>, channelStatus?: Maybe<(
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id' | 'name'>
  )> }
);

export type ConnectSettingsClinicWidgetSettingFragment = (
  { __typename?: 'ClinicWidgetSetting' }
  & { clinicWidgetRequestTypes: Array<(
    { __typename?: 'ClinicWidgetRequestType' }
    & ConnectSettingsClinicWidgetRequestTypeFragment
  )> }
);

export type SendWidgetCodeToDeveloperMutationVariables = Exact<{
  data: SendWidgetCodeToDeveloperInput;
}>;


export type SendWidgetCodeToDeveloperMutation = (
  { __typename?: 'Mutation' }
  & { sendWidgetCodeToDeveloper?: Maybe<(
    { __typename?: 'GenericResponse' }
    & Pick<GenericResponse, 'success'>
  )> }
);

export type SoftDeleteClinicSettingsConnectWidgetFormTemplateMutationVariables = Exact<{
  where: FormTemplateWhereUniqueInput;
}>;


export type SoftDeleteClinicSettingsConnectWidgetFormTemplateMutation = (
  { __typename?: 'Mutation' }
  & { updateOneFormTemplate: (
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id'>
  ) }
);

export type UpdateClinicSettingsConnectWidgetMutationVariables = Exact<{
  where: ClinicWhereUniqueInput;
  data: ClinicUpdateInput;
}>;


export type UpdateClinicSettingsConnectWidgetMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinic: (
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id'>
  ) }
);

export type GetClinicSettingsConnectWidgetQueryVariables = Exact<{
  where: ClinicWhereUniqueInput;
}>;


export type GetClinicSettingsConnectWidgetQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinic?: Maybe<(
    { __typename?: 'Clinic' }
    & { clinicWidgetSetting?: Maybe<(
      { __typename?: 'ClinicWidgetSetting' }
      & Pick<ClinicWidgetSetting, 'id' | 'isEnabled' | 'welcomeMessage' | 'primaryColor' | 'secondaryColor' | 'whiteLabelUrls'>
      & ConnectSettingsClinicWidgetSettingFragment
    )> }
  )> }
);

export type GetClinicSettingsConnectWidgetRequestOptionsQueryVariables = Exact<{
  where: ClinicWhereUniqueInput;
}>;


export type GetClinicSettingsConnectWidgetRequestOptionsQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinic?: Maybe<(
    { __typename?: 'Clinic' }
    & { clinicWidgetSetting?: Maybe<(
      { __typename?: 'ClinicWidgetSetting' }
      & Pick<ClinicWidgetSetting, 'id'>
      & ConnectSettingsClinicWidgetSettingFragment
    )> }
  )> }
);

export type GetFormTemplateContentQueryVariables = Exact<{
  formTemplateId: Scalars['String'];
}>;


export type GetFormTemplateContentQuery = (
  { __typename?: 'Query' }
  & { findUniqueFormTemplate?: Maybe<(
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id' | 'content'>
  )> }
);

export type RetrieveAuthTokenForContactQueryVariables = Exact<{ [key: string]: never; }>;


export type RetrieveAuthTokenForContactQuery = (
  { __typename?: 'Query' }
  & { retrieveAuthTokenForContact?: Maybe<(
    { __typename?: 'ChurnZeroResponse' }
    & Pick<ChurnZeroResponse, 'authToken'>
  )> }
);

export type CreateSurveyChannelStatusMutationVariables = Exact<{
  data: ChannelStatusCreateInput;
}>;


export type CreateSurveyChannelStatusMutation = (
  { __typename?: 'Mutation' }
  & { createOneChannelStatus: (
    { __typename?: 'ChannelStatus' }
    & ClinicSettingsConversationsChannelStatusFragment
  ) }
);

export type InitSurveySettingMutationVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type InitSurveySettingMutation = (
  { __typename?: 'Mutation' }
  & { initSurveySetting: (
    { __typename?: 'SurveySetting' }
    & Pick<SurveySetting, 'id'>
  ) }
);

export type UpdateSurveyGeneralSettingsMutationVariables = Exact<{
  where: SurveySettingWhereUniqueInput;
  data: SurveySettingUpdateInput;
}>;


export type UpdateSurveyGeneralSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateOneSurveySetting: (
    { __typename?: 'SurveySetting' }
    & Pick<SurveySetting, 'id' | 'isAutomatedTriggerForAllAppointmentTypes' | 'frequencyInDays' | 'showLinkToLeaveReviewNeutral' | 'showLinkToLeaveReviewSatisfied' | 'linkToLeaveReview'>
  ) }
);

export type UpsertSurveyAppointmentTypeSettingsMutationVariables = Exact<{
  where: SurveyAppointmentTypeSettingWhereUniqueInput;
  create: SurveyAppointmentTypeSettingCreateInput;
  update: SurveyAppointmentTypeSettingUpdateInput;
}>;


export type UpsertSurveyAppointmentTypeSettingsMutation = (
  { __typename?: 'Mutation' }
  & { upsertOneSurveyAppointmentTypeSetting?: Maybe<(
    { __typename?: 'SurveyAppointmentTypeSetting' }
    & Pick<SurveyAppointmentTypeSetting, 'id' | 'isActive' | 'automatedTriggerInMinutes' | 'surveySettingId'>
  )> }
);

export type GetDefaultSurveyStatusesQueryVariables = Exact<{
  clinicSettingId: Scalars['String'];
  positiveStatusNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  negativeStatusNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  sentStatusNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetDefaultSurveyStatusesQuery = (
  { __typename?: 'Query' }
  & { positiveStatus?: Maybe<(
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id' | 'name'>
  )>, negativeStatus?: Maybe<(
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id' | 'name'>
  )>, sentStatus?: Maybe<(
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id' | 'name'>
  )> }
);

export type GetSurveyAppointmentTypeSettingsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetSurveyAppointmentTypeSettingsQuery = (
  { __typename?: 'Query' }
  & { findManyAppointmentType: Array<(
    { __typename?: 'AppointmentType' }
    & Pick<AppointmentType, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'displayName' | 'description'>
    & { surveyAppointmentTypeSettings: Array<(
      { __typename?: 'SurveyAppointmentTypeSetting' }
      & Pick<SurveyAppointmentTypeSetting, 'id' | 'createdAt' | 'updatedAt' | 'isActive' | 'automatedTriggerInMinutes' | 'surveySettingId'>
    )> }
  )> }
);

export type GetSurveyGeneralSettingsQueryVariables = Exact<{
  settingId: Scalars['String'];
}>;


export type GetSurveyGeneralSettingsQuery = (
  { __typename?: 'Query' }
  & { findUniqueSurveySetting?: Maybe<(
    { __typename?: 'SurveySetting' }
    & Pick<SurveySetting, 'id' | 'createdAt' | 'updatedAt' | 'isAutomatedTriggerForAllAppointmentTypes' | 'frequencyInDays' | 'showLinkToLeaveReviewNeutral' | 'showLinkToLeaveReviewSatisfied' | 'linkToLeaveReview'>
  )> }
);

export type GetSurveyWorkflowEventSettingsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetSurveyWorkflowEventSettingsQuery = (
  { __typename?: 'Query' }
  & { findManyWorkflowEventSetting: Array<(
    { __typename?: 'WorkflowEventSetting' }
    & Pick<WorkflowEventSetting, 'id' | 'name' | 'surveySettingId' | 'surveyStep' | 'surveyType' | 'isPublished' | 'sendingHours' | 'notificationBody' | 'event'>
    & { actions: Array<(
      { __typename?: 'WorkflowEventAction' }
      & Pick<WorkflowEventAction, 'id' | 'actionType' | 'order' | 'config' | 'channelStatusChangeId'>
      & { channelStatusChange?: Maybe<(
        { __typename?: 'ChannelStatus' }
        & Pick<ChannelStatus, 'id' | 'name'>
      )> }
    )> }
  )> }
);

export type ClinicHasAutomationsThatCreateTasksQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type ClinicHasAutomationsThatCreateTasksQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'clinicHasAutomationsThatCreateTasks'>
);

export type CreateOneClinicUserFilterMutationVariables = Exact<{
  data: ClinicUserFilterCreateInput;
}>;


export type CreateOneClinicUserFilterMutation = (
  { __typename?: 'Mutation' }
  & { createOneClinicUserFilter: (
    { __typename?: 'ClinicUserFilter' }
    & Pick<ClinicUserFilter, 'id' | 'createdAt' | 'updatedAt' | 'clinicId' | 'userId' | 'filter' | 'type'>
    & { clinic: (
      { __typename?: 'Clinic' }
      & Pick<Clinic, 'id'>
    ), user: (
      { __typename?: 'User' }
      & Pick<User, 'id'>
    ) }
  ) }
);

export type CreateOneTaskMutationVariables = Exact<{
  data: TaskCreateInput;
}>;


export type CreateOneTaskMutation = (
  { __typename?: 'Mutation' }
  & { createOneTask: (
    { __typename?: 'Task' }
    & Pick<Task, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'type' | 'status' | 'completedAt' | 'clinicId' | 'completedByUserId' | 'clinincPetParentId' | 'widgetRequestId' | 'automationRunId' | 'paymentIntentId' | 'appointmentId' | 'description' | 'repeatIntervalDefinition'>
    & { assignees: Array<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )> }
  ) }
);

export type DeleteOneTaskMutationVariables = Exact<{
  where: TaskWhereUniqueInput;
}>;


export type DeleteOneTaskMutation = (
  { __typename?: 'Mutation' }
  & { deleteOneTask?: Maybe<(
    { __typename?: 'Task' }
    & Pick<Task, 'id' | 'clinicId' | 'type' | 'status'>
    & { assignees: Array<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )> }
  )> }
);

export type FindManyClinicWidgetRequestTypeQueryVariables = Exact<{
  where?: Maybe<ClinicWidgetRequestTypeWhereInput>;
  orderBy?: Maybe<Array<Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>> | Maybe<ClinicWidgetRequestTypeOrderByWithRelationInput>>;
}>;


export type FindManyClinicWidgetRequestTypeQuery = (
  { __typename?: 'Query' }
  & { findManyClinicWidgetRequestType: Array<(
    { __typename?: 'ClinicWidgetRequestType' }
    & Pick<ClinicWidgetRequestType, 'id' | 'createdAt' | 'updatedAt' | 'displayName' | 'isDeleted' | 'isActive' | 'order' | 'requestType' | 'clinicWidgetSettingId' | 'channelStatusId' | 'formTemplateId' | 'shouldCreateTask'>
  )> }
);

export type FindManyTaskQueryVariables = Exact<{
  where?: Maybe<TaskWhereInput>;
  orderBy?: Maybe<Array<Maybe<TaskOrderByWithRelationInput>> | Maybe<TaskOrderByWithRelationInput>>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type FindManyTaskQuery = (
  { __typename?: 'Query' }
  & { findManyTask: Array<(
    { __typename?: 'Task' }
    & Pick<Task, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'type' | 'status' | 'completedAt' | 'clinicId' | 'completedByUserId' | 'clinincPetParentId' | 'widgetRequestId' | 'automationRunId' | 'paymentIntentId' | 'appointmentId' | 'description' | 'repeatIntervalDefinition'>
    & { assignees: Array<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )>, clinicPetParent?: Maybe<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id' | 'email' | 'firstName' | 'lastName' | 'phoneNumber'>
    )>, widgetRequest?: Maybe<(
      { __typename?: 'ClinicWidgetRequest' }
      & Pick<ClinicWidgetRequest, 'id'>
      & { clinicWidgetRequestType?: Maybe<(
        { __typename?: 'ClinicWidgetRequestType' }
        & Pick<ClinicWidgetRequestType, 'id'>
      )> }
    )> }
  )> }
);

export type FindManyTaskCountQueryVariables = Exact<{
  where?: Maybe<TaskWhereInput>;
}>;


export type FindManyTaskCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyTaskCount'>
);

export type FindTaskCountIdsAndStatusesQueryVariables = Exact<{
  where?: Maybe<TaskWhereInput>;
}>;


export type FindTaskCountIdsAndStatusesQuery = (
  { __typename?: 'Query' }
  & { findManyTask: Array<(
    { __typename?: 'Task' }
    & Pick<Task, 'id' | 'status'>
  )> }
);

export type FindUniqueAutomationRunWithApptQueryVariables = Exact<{
  where: AutomationRunWhereUniqueInput;
}>;


export type FindUniqueAutomationRunWithApptQuery = (
  { __typename?: 'Query' }
  & { findUniqueAutomationRun?: Maybe<(
    { __typename?: 'AutomationRun' }
    & Pick<AutomationRun, 'id'>
    & { appointment?: Maybe<(
      { __typename?: 'Appointment' }
      & Pick<Appointment, 'id' | 'startAt' | 'status' | 'isActive' | 'isDeleted' | 'durationInMinutes'>
      & { appointmentType?: Maybe<(
        { __typename?: 'AppointmentType' }
        & Pick<AppointmentType, 'id' | 'displayName' | 'description' | 'name'>
      )>, clinicEmployees: Array<(
        { __typename?: 'ClinicEmployee' }
        & Pick<ClinicEmployee, 'id' | 'firstName' | 'lastName'>
      )>, clinicPet?: Maybe<(
        { __typename?: 'ClinicPet' }
        & Pick<ClinicPet, 'id' | 'name' | 'species' | 'speciesType'>
      )>, room?: Maybe<(
        { __typename?: 'ClinicRoom' }
        & Pick<ClinicRoom, 'id' | 'name'>
      )> }
    )>, actions: Array<(
      { __typename?: 'AutomationRunAction' }
      & Pick<AutomationRunAction, 'id'>
      & { automationAction?: Maybe<(
        { __typename?: 'WorkflowEventAction' }
        & Pick<WorkflowEventAction, 'id'>
        & { workflowEventSetting?: Maybe<(
          { __typename?: 'WorkflowEventSetting' }
          & Pick<WorkflowEventSetting, 'id' | 'name'>
        )> }
      )> }
    )> }
  )> }
);

export type FindUniqueClinicPetParentSearchResultQueryVariables = Exact<{
  where: ClinicPetParentWhereUniqueInput;
}>;


export type FindUniqueClinicPetParentSearchResultQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName' | 'isActive' | 'pimsId'>
    & { pets: Array<(
      { __typename?: 'ClinicPet' }
      & Pick<ClinicPet, 'id' | 'name'>
    )> }
  )> }
);

export type FindUniqueClinicUserFilterQueryVariables = Exact<{
  where: ClinicUserFilterWhereUniqueInput;
}>;


export type FindUniqueClinicUserFilterQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinicUserFilter?: Maybe<(
    { __typename?: 'ClinicUserFilter' }
    & Pick<ClinicUserFilter, 'id' | 'createdAt' | 'updatedAt' | 'clinicId' | 'userId' | 'filter' | 'type'>
  )> }
);

export type SearchPetParentAndPetsQueryVariables = Exact<{
  whereInput?: Maybe<SearchClinicPetParentInput>;
  pageSize?: Maybe<Scalars['Int']>;
  clinicId: Scalars['String'];
}>;


export type SearchPetParentAndPetsQuery = (
  { __typename?: 'Query' }
  & { clinicPetParentSearch: Array<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'updatedAt' | 'firstName' | 'lastName' | 'email' | 'isActive' | 'pimsId'>
    & { pets: Array<(
      { __typename?: 'ClinicPet' }
      & Pick<ClinicPet, 'id' | 'pimsId' | 'speciesType' | 'breed' | 'gender' | 'isActive' | 'isDeleted'>
      & PetAvatarFragment
    )> }
    & PetParentAvatarFragment
  )> }
);

export type UpdateOneClinicUserFilterMutationVariables = Exact<{
  data: ClinicUserFilterUpdateInput;
  where: ClinicUserFilterWhereUniqueInput;
}>;


export type UpdateOneClinicUserFilterMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinicUserFilter: (
    { __typename?: 'ClinicUserFilter' }
    & Pick<ClinicUserFilter, 'id' | 'createdAt' | 'updatedAt' | 'clinicId' | 'userId' | 'filter' | 'type'>
    & { clinic: (
      { __typename?: 'Clinic' }
      & Pick<Clinic, 'id'>
    ), user: (
      { __typename?: 'User' }
      & Pick<User, 'id'>
    ) }
  ) }
);

export type UpdateOneTaskMutationVariables = Exact<{
  data: TaskUpdateInput;
  where: TaskWhereUniqueInput;
}>;


export type UpdateOneTaskMutation = (
  { __typename?: 'Mutation' }
  & { updateOneTask: (
    { __typename?: 'Task' }
    & Pick<Task, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'type' | 'status' | 'completedAt' | 'clinicId' | 'completedByUserId' | 'clinincPetParentId' | 'widgetRequestId' | 'automationRunId' | 'paymentIntentId' | 'appointmentId' | 'description' | 'repeatIntervalDefinition'>
    & { assignees: Array<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )> }
  ) }
);

export type SubscribeToPendingTasksSubscriptionVariables = Exact<{
  where: SubscriptionPendingTasksWhereInput;
}>;


export type SubscribeToPendingTasksSubscription = (
  { __typename?: 'Subscription' }
  & { pendingTasksChanged: (
    { __typename?: 'TaskSubscription' }
    & Pick<TaskSubscription, 'mutation'>
    & { node: (
      { __typename?: 'Task' }
      & Pick<Task, 'id' | 'name' | 'status' | 'type'>
      & { assignees: Array<(
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName'>
      )>, widgetRequest?: Maybe<(
        { __typename?: 'ClinicWidgetRequest' }
        & Pick<ClinicWidgetRequest, 'id'>
        & { clinicWidgetRequestType?: Maybe<(
          { __typename?: 'ClinicWidgetRequestType' }
          & Pick<ClinicWidgetRequestType, 'id' | 'requestType'>
        )> }
      )>, automationRun?: Maybe<(
        { __typename?: 'AutomationRun' }
        & Pick<AutomationRun, 'id'>
      )> }
    ) }
  ) }
);

export type SubscribeToTaskAssigneeRemovedSubscriptionVariables = Exact<{
  where: SubscriptionPendingTasksWhereInput;
}>;


export type SubscribeToTaskAssigneeRemovedSubscription = (
  { __typename?: 'Subscription' }
  & { taskAssigneeRemoved: (
    { __typename?: 'TaskSubscription' }
    & Pick<TaskSubscription, 'mutation'>
    & { node: (
      { __typename?: 'Task' }
      & Pick<Task, 'id' | 'name' | 'status' | 'type'>
      & { assignees: Array<(
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName'>
      )>, widgetRequest?: Maybe<(
        { __typename?: 'ClinicWidgetRequest' }
        & Pick<ClinicWidgetRequest, 'id'>
        & { clinicWidgetRequestType?: Maybe<(
          { __typename?: 'ClinicWidgetRequestType' }
          & Pick<ClinicWidgetRequestType, 'id' | 'requestType'>
        )> }
      )>, automationRun?: Maybe<(
        { __typename?: 'AutomationRun' }
        & Pick<AutomationRun, 'id'>
      )> }
    ) }
  ) }
);

export type SubscribeToDeletedTasksSubscriptionVariables = Exact<{
  where: SubscriptionPendingTasksWhereInput;
}>;


export type SubscribeToDeletedTasksSubscription = (
  { __typename?: 'Subscription' }
  & { pendingTasksChanged: (
    { __typename?: 'TaskSubscription' }
    & Pick<TaskSubscription, 'mutation'>
    & { node: (
      { __typename?: 'Task' }
      & Pick<Task, 'id' | 'status' | 'type'>
    ) }
  ) }
);

export type CreateTeamChannelMutationVariables = Exact<{
  data: CreateTeamChannelInput;
}>;


export type CreateTeamChannelMutation = (
  { __typename?: 'Mutation' }
  & { createTeamChannel2?: Maybe<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id' | 'friendlyName' | 'channelVisibility'>
  )> }
);

export type GetTeamChannelsQueryVariables = Exact<{
  wherePublic: ChannelWhereInput;
  orderBy?: Maybe<Array<ChannelOrderByWithRelationInput> | ChannelOrderByWithRelationInput>;
  wherePrivate: ChannelWhereInput;
  whereDirectMessages: ChannelWhereInput;
}>;


export type GetTeamChannelsQuery = (
  { __typename?: 'Query' }
  & { publicChannels: Array<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id' | 'isActive' | 'friendlyName' | 'channelVisibility'>
  )>, privateChannels: Array<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id' | 'isActive' | 'friendlyName' | 'channelVisibility'>
  )>, directMessages: Array<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id' | 'isActive' | 'friendlyName' | 'channelVisibility'>
    & { assignees: Array<(
      { __typename?: 'User' }
      & ClinicUserAvatarFragment
    )> }
  )> }
);

export type SubscribeToTeamChannelsSubscriptionVariables = Exact<{
  where: SubscriptionChannelWhereInput;
}>;


export type SubscribeToTeamChannelsSubscription = (
  { __typename?: 'Subscription' }
  & { channelChanged: (
    { __typename?: 'ChannelSubscription' }
    & Pick<ChannelSubscription, 'mutation'>
    & { node: (
      { __typename?: 'Channel' }
      & Pick<Channel, 'id' | 'isActive' | 'friendlyName' | 'channelType' | 'channelVisibility'>
    ) }
  ) }
);

export type FindManyAppointmentAutomationsQueryVariables = Exact<{
  where?: Maybe<AppointmentWhereInput>;
}>;


export type FindManyAppointmentAutomationsQuery = (
  { __typename?: 'Query' }
  & { findManyAppointment: Array<(
    { __typename?: 'Appointment' }
    & Pick<Appointment, 'id' | 'description' | 'startAt'>
    & { appointmentType?: Maybe<(
      { __typename?: 'AppointmentType' }
      & Pick<AppointmentType, 'displayName' | 'name'>
    )>, clinicPet?: Maybe<(
      { __typename?: 'ClinicPet' }
      & Pick<ClinicPet, 'speciesType' | 'name'>
    )>, workflows: Array<(
      { __typename?: 'WorkflowEventSetting' }
      & Pick<WorkflowEventSetting, 'id' | 'name' | 'event' | 'surveySettingId' | 'surveyStep' | 'surveyType' | 'isPublished'>
    )> }
  )> }
);

export type GetAutomationRunQueryVariables = Exact<{
  where: AutomationRunWhereUniqueInput;
}>;


export type GetAutomationRunQuery = (
  { __typename?: 'Query' }
  & { findUniqueAutomationRun?: Maybe<(
    { __typename?: 'AutomationRun' }
    & AutomationRunFragment
  )> }
);

export type GetManyAutomationRunsQueryVariables = Exact<{
  where: AutomationRunWhereInput;
}>;


export type GetManyAutomationRunsQuery = (
  { __typename?: 'Query' }
  & { findManyAutomationRun: Array<(
    { __typename?: 'AutomationRun' }
    & AutomationRunFragment
  )> }
);

export type GetAutomationRunActionQueryVariables = Exact<{
  where?: Maybe<AutomationRunActionWhereInput>;
  orderBy?: Maybe<Array<Maybe<AutomationRunActionOrderByWithRelationInput>> | Maybe<AutomationRunActionOrderByWithRelationInput>>;
}>;


export type GetAutomationRunActionQuery = (
  { __typename?: 'Query' }
  & { findManyAutomationRunAction: Array<(
    { __typename?: 'AutomationRunAction' }
    & AutomationRunActionFragment
  )> }
);

export type AutomationRunFragment = (
  { __typename?: 'AutomationRun' }
  & Pick<AutomationRun, 'id' | 'status' | 'channelMessageId' | 'originAutomationId' | 'runType' | 'manuallySentById' | 'startedAt' | 'completedAt' | 'appointmentId' | 'formSubmissionId' | 'serviceReminderId' | 'clinicWidgetRequestId' | 'clinicPetParentId'>
  & { actions: Array<(
    { __typename?: 'AutomationRunAction' }
    & AutomationRunActionFragment
  )>, originAutomation: (
    { __typename?: 'WorkflowEventSetting' }
    & Pick<WorkflowEventSetting, 'id' | 'name'>
  ), channelMessage: (
    { __typename?: 'ChannelMessage' }
    & Pick<ChannelMessage, 'channelId'>
  ), tasks: Array<(
    { __typename?: 'Task' }
    & Pick<Task, 'id' | 'status'>
  )> }
);

export type AutomationRunActionFragment = (
  { __typename?: 'AutomationRunAction' }
  & Pick<AutomationRunAction, 'id' | 'createdAt' | 'updatedAt' | 'automationRunId' | 'promptType' | 'automationActionId' | 'body' | 'attachments' | 'actionType' | 'petParentId' | 'petId' | 'buttons' | 'channelStatusChangeId' | 'order'>
  & { automationRun: (
    { __typename?: 'AutomationRun' }
    & Pick<AutomationRun, 'id' | 'status'>
    & { channelMessage: (
      { __typename?: 'ChannelMessage' }
      & { channel?: Maybe<(
        { __typename?: 'Channel' }
        & Pick<Channel, 'id'>
      )> }
    ) }
  ), automationAction?: Maybe<(
    { __typename?: 'WorkflowEventAction' }
    & Pick<WorkflowEventAction, 'id' | 'config'>
    & { workflowEventSetting?: Maybe<(
      { __typename?: 'WorkflowEventSetting' }
      & Pick<WorkflowEventSetting, 'id' | 'name' | 'surveyStep' | 'event'>
    )> }
  )>, petParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'isDeleted' | 'isActive'>
  )>, formSubmission?: Maybe<(
    { __typename?: 'FormSubmission' }
    & Pick<FormSubmission, 'id' | 'submittedAt'>
    & { clinicPetParent?: Maybe<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id' | 'isDeleted' | 'isActive'>
    )> }
  )>, paymentIntent?: Maybe<(
    { __typename?: 'StripePaymentIntent' }
    & Pick<StripePaymentIntent, 'total' | 'amount' | 'serviceFeeAmount' | 'paidAt'>
    & StripePaymentIntentSelectionFragment
  )> }
);

export type DeleteManyAutomationRunActionMutationVariables = Exact<{
  where: AutomationRunActionWhereInput;
}>;


export type DeleteManyAutomationRunActionMutation = (
  { __typename?: 'Mutation' }
  & { deleteManyAutomationRunAction?: Maybe<(
    { __typename?: 'BatchPayload' }
    & Pick<BatchPayload, 'count'>
  )> }
);

export type UpdateAutomationRunActionMutationVariables = Exact<{
  where: AutomationRunActionWhereUniqueInput;
  data: AutomationRunActionUpdateInput;
}>;


export type UpdateAutomationRunActionMutation = (
  { __typename?: 'Mutation' }
  & { updateOneAutomationRunAction: (
    { __typename?: 'AutomationRunAction' }
    & AutomationRunActionFragment
  ) }
);

export type UpdateAutomationRunMutationVariables = Exact<{
  where: AutomationRunWhereUniqueInput;
  data: AutomationRunUpdateInput;
}>;


export type UpdateAutomationRunMutation = (
  { __typename?: 'Mutation' }
  & { updateOneAutomationRun: (
    { __typename?: 'AutomationRun' }
    & AutomationRunFragment
  ) }
);

export type ResetAutomationRunMutationVariables = Exact<{
  where: AutomationRunWhereUniqueInput;
}>;


export type ResetAutomationRunMutation = (
  { __typename?: 'Mutation' }
  & { resetAutomationRun?: Maybe<(
    { __typename?: 'AutomationRun' }
    & AutomationRunFragment
  )> }
);

export type CalculatePetBenefitUsageQueryVariables = Exact<{
  where?: Maybe<CalculatePetBenefitUsageInput>;
}>;


export type CalculatePetBenefitUsageQuery = (
  { __typename?: 'Query' }
  & { calculatePetBenefitUsage?: Maybe<(
    { __typename?: 'CalculatePetBenefitUsageOutput' }
    & { usages: Array<(
      { __typename?: 'UsageByBenefit' }
      & Pick<UsageByBenefit, 'provided' | 'used' | 'exhausted' | 'displayOrder' | 'carryover' | 'costCovered'>
      & { benefit: (
        { __typename?: 'CareBenefit' }
        & Pick<CareBenefit, 'id' | 'title' | 'description' | 'tangible' | 'exhaustible' | 'usageUnitOfMeasure' | 'providedDiscountPercentage' | 'type'>
        & { planBenefits: Array<(
          { __typename?: 'CarePlanBenefit' }
          & CarePlanBenefitUsageFragment
        )> }
      ), sources: (
        { __typename?: 'BenefitSource' }
        & CarePlanBenefitSourceFragment
      ) }
    )> }
  )> }
);

export type CarePlanBenefitUsageFragment = (
  { __typename?: 'CarePlanBenefit' }
  & Pick<CarePlanBenefit, 'id' | 'providedDiscountPercentage' | 'benefitId' | 'planId'>
);

export type CarePlanBenefitSourceFragment = (
  { __typename?: 'BenefitSource' }
  & Pick<BenefitSource, 'addonIds' | 'planIds'>
);

export type ClinicPetSelectionFragment = (
  { __typename?: 'ClinicPet' }
  & Pick<ClinicPet, 'id' | 'breed' | 'gender' | 'isActive' | 'isDeleted' | 'dateOfBirth' | 'speciesType' | 'weight' | 'weightUnit'>
  & { alerts: Array<(
    { __typename?: 'ClinicPetAlert' }
    & Pick<ClinicPetAlert, 'value' | 'pimsDate' | 'pimsId' | 'isMedical'>
  )> }
  & PetAvatarFragment
  & OrganizationPetCareBadgePlanEnrollmentFragment
);

export type ClinicPetNestedSelectionFragment = (
  { __typename?: 'ClinicPet' }
  & { petParents: Array<(
    { __typename?: 'ClinicPetParent' }
    & ClinicPetParentSelectionFragment
  )> }
  & ClinicPetSelectionFragment
);

export type CreateOneClinicPetMutationVariables = Exact<{
  data: ClinicPetCreateInput;
}>;


export type CreateOneClinicPetMutation = (
  { __typename?: 'Mutation' }
  & { createOneClinicPet: (
    { __typename?: 'ClinicPet' }
    & ClinicPetSelectionFragment
  ) }
);

export type ClinicPetParentSelectionFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id' | 'email' | 'firstName' | 'lastName' | 'isActive' | 'updatedAt' | 'pimsId'>
  & { phoneNumbers: Array<(
    { __typename?: 'ClinicEntityPhoneNumber' }
    & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'isPrimary' | 'isMobile' | 'isDeleted' | 'updatedAt'>
  )> }
  & PetParentAvatarFragment
);

export type CreateOneClinicPetParentMutationVariables = Exact<{
  data: ClinicPetParentCreateInput;
}>;


export type CreateOneClinicPetParentMutation = (
  { __typename?: 'Mutation' }
  & { createOneClinicPetParent: (
    { __typename?: 'ClinicPetParent' }
    & ClinicPetParentSelectionFragment
  ) }
);

export type CreateCareBenefitUsageToInvoiceLineItemMutationVariables = Exact<{
  data: CareBenefitUsageToInvoiceLineItemCreateInput;
}>;


export type CreateCareBenefitUsageToInvoiceLineItemMutation = (
  { __typename?: 'Mutation' }
  & { createOneCareBenefitUsageToInvoiceLineItem: (
    { __typename?: 'CareBenefitUsageToInvoiceLineItem' }
    & Pick<CareBenefitUsageToInvoiceLineItem, 'id'>
  ) }
);

export type GetClinicChannelPetParentsQueryVariables = Exact<{
  where: ChannelWhereUniqueInput;
}>;


export type GetClinicChannelPetParentsQuery = (
  { __typename?: 'Query' }
  & { findUniqueChannel?: Maybe<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id' | 'channelType' | 'friendlyName'>
    & { channelMembers: Array<(
      { __typename?: 'ChannelMember' }
      & Pick<ChannelMember, 'id' | 'removedAt'>
      & { clinicPetParent?: Maybe<(
        { __typename?: 'ClinicPetParent' }
        & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
      )> }
    )> }
  )> }
);

export type GetClinicPetEnrollmentsByParentQueryVariables = Exact<{
  where: ClinicPetParentWhereUniqueInput;
  clinicId: Scalars['String'];
}>;


export type GetClinicPetEnrollmentsByParentQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'organizationPetParentId'>
    & { pets: Array<(
      { __typename?: 'ClinicPet' }
      & SidePanelParentPetDataFragment
    )> }
    & PetParentAvatarFragment
  )> }
);

export type GetClinicTagsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetClinicTagsQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinic?: Maybe<(
    { __typename?: 'Clinic' }
    & { clinicSetting?: Maybe<(
      { __typename?: 'ClinicSetting' }
      & Pick<ClinicSetting, 'tags'>
    )> }
  )> }
);

export type GetDirectedCareLoginLinkMutationVariables = Exact<{
  data: DirectedAuthLinkInput;
}>;


export type GetDirectedCareLoginLinkMutation = (
  { __typename?: 'Mutation' }
  & { getDirectedCareLoginLink: (
    { __typename?: 'GetDirectedAuthLinkResult' }
    & Pick<GetDirectedAuthLinkResult, 'link'>
  ) }
);

export type GetExistingChannelMembersQueryVariables = Exact<{
  clinicPetParentIds: Array<Scalars['String']> | Scalars['String'];
  channelStatusAction?: Maybe<EnumChannelStatusActionFilter>;
}>;


export type GetExistingChannelMembersQuery = (
  { __typename?: 'Query' }
  & { findManyChannelMember: Array<(
    { __typename?: 'ChannelMember' }
    & Pick<ChannelMember, 'id' | 'channelId'>
    & { channel?: Maybe<(
      { __typename?: 'Channel' }
      & Pick<Channel, 'id'>
    )> }
  )> }
);

export type FormSubmissionFragment = (
  { __typename?: 'FormSubmission' }
  & Pick<FormSubmission, 'id' | 'submittedAt' | 'draftContent' | 'completedContent' | 'isCallDeflectionForm'>
  & { clinicPet?: Maybe<(
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'id' | 'name' | 'createdAt' | 'updatedAt' | 'speciesType'>
    & PetAvatarFragment
  )>, clinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
    & { pets: Array<(
      { __typename?: 'ClinicPet' }
      & Pick<ClinicPet, 'id' | 'name' | 'pimsId' | 'species' | 'speciesType' | 'createdAt' | 'updatedAt' | 'isDeceased'>
    )> }
  )>, formTemplate?: Maybe<(
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'title'>
  )> }
);

export type GetFormSubmissionQueryVariables = Exact<{
  formSubmissionId: Scalars['String'];
  clinicId: Scalars['String'];
}>;


export type GetFormSubmissionQuery = (
  { __typename?: 'Query' }
  & { findUniqueFormSubmission?: Maybe<(
    { __typename?: 'FormSubmission' }
    & FormSubmissionFragment
  )> }
);

export type GetSignedUploadUrlMutationVariables = Exact<{
  data: GetSignedUploadInput;
}>;


export type GetSignedUploadUrlMutation = (
  { __typename?: 'Mutation' }
  & { getSignedUploadUrl: (
    { __typename?: 'GetSignedUploadUrlOutput' }
    & Pick<GetSignedUploadUrlOutput, 'key' | 'uploadUrl' | 'finalUrl'>
  ) }
);

export type RemoveChannelTagMutationVariables = Exact<{
  channelId: Scalars['String'];
  tagName: Scalars['String'];
}>;


export type RemoveChannelTagMutation = (
  { __typename?: 'Mutation' }
  & { removeChannelTag?: Maybe<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id' | 'tags'>
  )> }
);

export type SaveWorkflowEventSettingsMutationVariables = Exact<{
  data: WorkflowEventSettingUpdateInput;
  where: WorkflowEventSettingWhereUniqueInput;
}>;


export type SaveWorkflowEventSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateOneWorkflowEventSetting: (
    { __typename?: 'WorkflowEventSetting' }
    & Pick<WorkflowEventSetting, 'id' | 'name' | 'surveySettingId' | 'surveyStep' | 'surveyType' | 'notificationBody' | 'event'>
    & { actions: Array<(
      { __typename?: 'WorkflowEventAction' }
      & Pick<WorkflowEventAction, 'id' | 'actionType' | 'order' | 'config' | 'channelStatusChangeId'>
      & { channelStatusChange?: Maybe<(
        { __typename?: 'ChannelStatus' }
        & Pick<ChannelStatus, 'id' | 'name'>
      )> }
    )> }
  ) }
);

export type UpdateChannelStatusMutationVariables = Exact<{
  where: ChannelWhereUniqueInput;
  data: ChannelUpdateInput;
}>;


export type UpdateChannelStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateOneChannel: (
    { __typename?: 'Channel' }
    & Pick<Channel, 'id' | 'clinicId' | 'channelStatusId'>
    & { channelStatus?: Maybe<(
      { __typename?: 'ChannelStatus' }
      & ChannelListChannelStatusFragment
    )> }
  ) }
);

export type UserAppointmentGroupingFullSelectionFragment = (
  { __typename?: 'UserAppointmentGrouping' }
  & Pick<UserAppointmentGrouping, 'id' | 'label'>
  & { clinicEmployees: Array<(
    { __typename?: 'ClinicEmployee' }
    & Pick<ClinicEmployee, 'id'>
  )>, rooms: Array<(
    { __typename?: 'ClinicRoom' }
    & Pick<ClinicRoom, 'id'>
  )>, appointmentTypes: Array<(
    { __typename?: 'AppointmentType' }
    & Pick<AppointmentType, 'id'>
  )> }
);

export type CreateOneUserAppointmentGroupingMutationVariables = Exact<{
  data: UserAppointmentGroupingCreateInput;
}>;


export type CreateOneUserAppointmentGroupingMutation = (
  { __typename?: 'Mutation' }
  & { createOneUserAppointmentGrouping: (
    { __typename?: 'UserAppointmentGrouping' }
    & UserAppointmentGroupingFullSelectionFragment
  ) }
);

export type UpdateOneUserAppointmentGroupingMutationVariables = Exact<{
  data: UserAppointmentGroupingUpdateInput;
  where: UserAppointmentGroupingWhereUniqueInput;
}>;


export type UpdateOneUserAppointmentGroupingMutation = (
  { __typename?: 'Mutation' }
  & { updateOneUserAppointmentGrouping: (
    { __typename?: 'UserAppointmentGrouping' }
    & UserAppointmentGroupingFullSelectionFragment
  ) }
);

export type DeleteOneUserAppointmentGroupingMutationVariables = Exact<{
  where: UserAppointmentGroupingWhereUniqueInput;
}>;


export type DeleteOneUserAppointmentGroupingMutation = (
  { __typename?: 'Mutation' }
  & { deleteOneUserAppointmentGrouping?: Maybe<(
    { __typename?: 'UserAppointmentGrouping' }
    & UserAppointmentGroupingFullSelectionFragment
  )> }
);

export type FindManyUserAppointmentGroupingQueryVariables = Exact<{
  where?: Maybe<UserAppointmentGroupingWhereInput>;
  orderBy?: Maybe<Array<UserAppointmentGroupingOrderByWithRelationInput> | UserAppointmentGroupingOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type FindManyUserAppointmentGroupingQuery = (
  { __typename?: 'Query' }
  & { findManyUserAppointmentGrouping: Array<(
    { __typename?: 'UserAppointmentGrouping' }
    & UserAppointmentGroupingFullSelectionFragment
  )> }
);

export type ClinicUserAvatarFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'firstName' | 'lastName' | 'displayName' | 'nameDisplay' | 'profilePic'>
);

export type PetAvatarFragment = (
  { __typename?: 'ClinicPet' }
  & Pick<ClinicPet, 'id' | 'computed_rawPimsIsDeceased' | 'computed_rawPimsIsActive' | 'computedIsDeceased' | 'computedIsActive' | 'isDeceased' | 'isActive' | 'name' | 'photoUrl' | 'rawPimsValue' | 'species' | 'speciesType'>
  & { organizationPet?: Maybe<(
    { __typename?: 'OrganizationPet' }
    & SidePanelOrganizationPetFragment
  )> }
);

export type PetParentAvatarFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName' | 'creationSource' | 'isTest'>
);

export type GetClinicPetParentAvatarPhoneNumbersQueryVariables = Exact<{
  clinicPetParentId: Scalars['String'];
}>;


export type GetClinicPetParentAvatarPhoneNumbersQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id'>
    & { phoneNumbers: Array<(
      { __typename?: 'ClinicEntityPhoneNumber' }
      & Pick<ClinicEntityPhoneNumber, 'id' | 'updatedAt' | 'number' | 'isPrimary' | 'isDeleted'>
    )> }
  )> }
);

export type GetConversationStatusOptionsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetConversationStatusOptionsQuery = (
  { __typename?: 'Query' }
  & { findManyChannelStatus: Array<(
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id' | 'color' | 'name' | 'channelStatusAction'>
  )> }
);

export type UpdateCreatePasswordModalUserMutationVariables = Exact<{
  where: UserWhereUniqueInput;
  data: UserUpdateInput;
}>;


export type UpdateCreatePasswordModalUserMutation = (
  { __typename?: 'Mutation' }
  & { updateOneUser: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'namePrefix' | 'nameSuffix' | 'email' | 'phone' | 'isNewPasswordRequired'>
  ) }
);

export type EmailTemplateVersionFragment = (
  { __typename?: 'EmailTemplateVersion' }
  & Pick<EmailTemplateVersion, 'id' | 'html' | 'design' | 'previewImageUrl' | 'emailTemplateId' | 'isCurrent' | 'version' | 'lastEditedById' | 'createdAt' | 'updatedAt' | 'deletedAt' | 'publishedAt'>
  & { lastEditedBy?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'firstName' | 'lastName'>
  )> }
);

export type CreateEmailTemplateVersionMutationVariables = Exact<{
  data: CreateEmailTemplateVersionInput;
}>;


export type CreateEmailTemplateVersionMutation = (
  { __typename?: 'Mutation' }
  & { createEmailTemplateVersion: (
    { __typename?: 'EmailTemplateVersion' }
    & EmailTemplateVersionFragment
  ) }
);

export type SaveEmailTemplateVersionMutationVariables = Exact<{
  data: SaveEmailTemplateVersionInput;
}>;


export type SaveEmailTemplateVersionMutation = (
  { __typename?: 'Mutation' }
  & { saveEmailTemplateVersion: (
    { __typename?: 'EmailTemplateVersion' }
    & EmailTemplateVersionFragment
  ) }
);

export type UpdateOneEmailTemplateVersionMutationVariables = Exact<{
  data: EmailTemplateVersionUpdateInput;
  where: EmailTemplateVersionWhereUniqueInput;
}>;


export type UpdateOneEmailTemplateVersionMutation = (
  { __typename?: 'Mutation' }
  & { updateOneEmailTemplateVersion: (
    { __typename?: 'EmailTemplateVersion' }
    & Pick<EmailTemplateVersion, 'id'>
  ) }
);

export type FindCurrentEmailTemplateVersionsQueryVariables = Exact<{
  data: FindCurrentEmailTemplateVersionInput;
}>;


export type FindCurrentEmailTemplateVersionsQuery = (
  { __typename?: 'Query' }
  & { findCurrentEmailTemplateVersions: (
    { __typename?: 'CurrentEmailTemplateVersionsFindResponse' }
    & { unlayer: (
      { __typename?: 'UnlayerUser' }
      & Pick<UnlayerUser, 'userId' | 'signature'>
    ), draft?: Maybe<(
      { __typename?: 'EmailTemplateVersion' }
      & EmailTemplateVersionFragment
    )>, published?: Maybe<(
      { __typename?: 'EmailTemplateVersion' }
      & EmailTemplateVersionFragment
    )> }
  ) }
);

export type FindManyRecapQueryVariables = Exact<{
  where?: Maybe<RecapWhereInput>;
  orderBy?: Maybe<Array<Maybe<RecapOrderByWithRelationInput>> | Maybe<RecapOrderByWithRelationInput>>;
  take?: Maybe<Scalars['Int']>;
}>;


export type FindManyRecapQuery = (
  { __typename?: 'Query' }
  & { findManyRecap: Array<(
    { __typename?: 'Recap' }
    & RecapBaseFragment
  )> }
);

export type RecapBaseFragment = (
  { __typename?: 'Recap' }
  & Pick<Recap, 'id' | 'createdAt' | 'updatedAt' | 'transcriptionS3Uri' | 'recordingS3Uri' | 'transcriptionText' | 'generatedText' | 'templateId' | 'status' | 'durationSeconds'>
  & { createdBy: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'nameDisplay'>
  ), appointment?: Maybe<(
    { __typename?: 'Appointment' }
    & Pick<Appointment, 'id'>
    & { clinicPet?: Maybe<(
      { __typename?: 'ClinicPet' }
      & Pick<ClinicPet, 'id' | 'name'>
    )> }
  )> }
);

export type RecapChangedSubscriptionVariables = Exact<{
  where: SubscriptionRecapWhereInput;
}>;


export type RecapChangedSubscription = (
  { __typename?: 'Subscription' }
  & { recapChanged: (
    { __typename?: 'RecapSubscription' }
    & Pick<RecapSubscription, 'mutation'>
    & { node: (
      { __typename?: 'Recap' }
      & Pick<Recap, 'id' | 'clinicId'>
    ) }
  ) }
);

export type MergePetParentProfilesMutationVariables = Exact<{
  data?: Maybe<MergePetParentInput>;
}>;


export type MergePetParentProfilesMutation = (
  { __typename?: 'Mutation' }
  & { mergePetParent: (
    { __typename?: 'MergePetParentResult' }
    & Pick<MergePetParentResult, 'success' | 'messages'>
  ) }
);

export type MergeProfileClientSearchQueryVariables = Exact<{
  where?: Maybe<SearchClinicPetParentInput>;
  clinicId: Scalars['String'];
  take?: Maybe<Scalars['Int']>;
}>;


export type MergeProfileClientSearchQuery = (
  { __typename?: 'Query' }
  & { clinicPetParentSearch: Array<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'isTest' | 'pimsId' | 'firstName' | 'lastName'>
    & { pets: Array<(
      { __typename?: 'ClinicPet' }
      & Pick<ClinicPet, 'id' | 'pimsId' | 'speciesType' | 'name'>
      & { organizationPet?: Maybe<(
        { __typename?: 'OrganizationPet' }
        & Pick<OrganizationPet, 'id'>
        & { carePlanEnrollments: Array<(
          { __typename?: 'CarePlanEnrollment' }
          & Pick<CarePlanEnrollment, 'id'>
        )> }
      )> }
    )>, loyaltyAccountHolder?: Maybe<(
      { __typename?: 'LoyaltyAccountHolder' }
      & Pick<LoyaltyAccountHolder, 'id'>
      & { account: (
        { __typename?: 'LoyaltyAccount' }
        & Pick<LoyaltyAccount, 'pointBalance'>
        & { rewardRedemptions: Array<(
          { __typename?: 'LoyaltyRewardRedemption' }
          & Pick<LoyaltyRewardRedemption, 'id'>
        )> }
      ) }
    )>, channelMembers: Array<(
      { __typename?: 'ChannelMember' }
      & Pick<ChannelMember, 'id'>
      & { channel?: Maybe<(
        { __typename?: 'Channel' }
        & { channelStatus?: Maybe<(
          { __typename?: 'ChannelStatus' }
          & Pick<ChannelStatus, 'channelStatusAction'>
        )> }
      )> }
    )> }
  )> }
);

export type GetNonItemizedReceiptPdfQueryVariables = Exact<{
  intentId: Scalars['String'];
}>;


export type GetNonItemizedReceiptPdfQuery = (
  { __typename?: 'Query' }
  & { exportNonItemizedReceiptAsPdf: (
    { __typename?: 'ExportNonItemizedReceiptAsPdfResponse' }
    & Pick<ExportNonItemizedReceiptAsPdfResponse, 'success' | 'base64PDF'>
  ) }
);

export type GetReceiptPetParentQueryVariables = Exact<{
  clinicPetParentId: Scalars['String'];
}>;


export type GetReceiptPetParentQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName' | 'email'>
    & { phoneNumbers: Array<(
      { __typename?: 'ClinicEntityPhoneNumber' }
      & Pick<ClinicEntityPhoneNumber, 'id' | 'number'>
    )> }
  )> }
);

export type GetStripeReceiptQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetStripeReceiptQuery = (
  { __typename?: 'Query' }
  & { findUniqueStripeReceipt?: Maybe<(
    { __typename?: 'StripeReceipt' }
    & Pick<StripeReceipt, 'id' | 'stripeId' | 'applicationName' | 'dedicatedFileName' | 'accountType'>
  )> }
);

export type SyncPimsIntegrationModelMutationVariables = Exact<{
  data: SyncManyPimsIntegrationModelInput;
}>;


export type SyncPimsIntegrationModelMutation = (
  { __typename?: 'Mutation' }
  & { syncManyPimsIntegrationModel?: Maybe<Array<(
    { __typename?: 'ClinicPimsIntegrationCapability' }
    & Pick<ClinicPimsIntegrationCapability, 'lastSyncedAt'>
  )>> }
);

export type GetClinicPimsIntegrationCapabilitySyncQueryVariables = Exact<{
  where?: Maybe<ClinicPimsIntegrationCapabilityWhereInput>;
}>;


export type GetClinicPimsIntegrationCapabilitySyncQuery = (
  { __typename?: 'Query' }
  & { findManyClinicPimsIntegrationCapability: Array<(
    { __typename?: 'ClinicPimsIntegrationCapability' }
    & Pick<ClinicPimsIntegrationCapability, 'lastSyncedAt'>
  )> }
);

export type AppointmentNoteTemplateFragmentFragment = (
  { __typename?: 'AppointmentNoteTemplate' }
  & Pick<AppointmentNoteTemplate, 'id' | 'name' | 'body' | 'clinicId' | 'updatedAt'>
  & { updatedBy?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'nameDisplay' | 'firstName' | 'lastName'>
  )> }
);

export type CreateOneAppointmentNoteTemplateMutationVariables = Exact<{
  data: AppointmentNoteTemplateCreateInput;
}>;


export type CreateOneAppointmentNoteTemplateMutation = (
  { __typename?: 'Mutation' }
  & { createOneAppointmentNoteTemplate: (
    { __typename?: 'AppointmentNoteTemplate' }
    & Pick<AppointmentNoteTemplate, 'id'>
    & AppointmentNoteTemplateFragmentFragment
  ) }
);

export type CreateOneRecapMutationVariables = Exact<{
  data: RecapCreateInput;
}>;


export type CreateOneRecapMutation = (
  { __typename?: 'Mutation' }
  & { createOneRecap: (
    { __typename?: 'Recap' }
    & Pick<Recap, 'id'>
  ) }
);

export type FindManyAppointmentNoteTemplateQueryVariables = Exact<{
  where?: Maybe<AppointmentNoteTemplateWhereInput>;
}>;


export type FindManyAppointmentNoteTemplateQuery = (
  { __typename?: 'Query' }
  & { findManyAppointmentNoteTemplate: Array<(
    { __typename?: 'AppointmentNoteTemplate' }
    & AppointmentNoteTemplateFragmentFragment
  )> }
);

export type FindUniqueAppointmentNoteTemplateQueryVariables = Exact<{
  where: AppointmentNoteTemplateWhereUniqueInput;
}>;


export type FindUniqueAppointmentNoteTemplateQuery = (
  { __typename?: 'Query' }
  & { findUniqueAppointmentNoteTemplate?: Maybe<(
    { __typename?: 'AppointmentNoteTemplate' }
    & AppointmentNoteTemplateFragmentFragment
  )> }
);

export type ProcessAppointmentRecapMutationVariables = Exact<{
  data: ProcessAppointmentRecapInput;
}>;


export type ProcessAppointmentRecapMutation = (
  { __typename?: 'Mutation' }
  & { processAppointmentRecap: (
    { __typename?: 'ProcessAppointmentRecapOutput' }
    & Pick<ProcessAppointmentRecapOutput, 'success' | 'message'>
  ) }
);

export type ProcessAppointmentRecapChunksMutationVariables = Exact<{
  data: ProcessAppointmentRecapChunksInput;
}>;


export type ProcessAppointmentRecapChunksMutation = (
  { __typename?: 'Mutation' }
  & { processAppointmentRecapChunks: (
    { __typename?: 'ProcessAppointmentRecapChunksOutput' }
    & Pick<ProcessAppointmentRecapChunksOutput, 'success' | 'message'>
  ) }
);

export type RetryProcessAppointmentRecapMutationVariables = Exact<{
  data: RetryProcessAppointmentRecapInput;
}>;


export type RetryProcessAppointmentRecapMutation = (
  { __typename?: 'Mutation' }
  & { retryProcessAppointmentRecap: (
    { __typename?: 'RetryProcessAppointmentRecapOutput' }
    & Pick<RetryProcessAppointmentRecapOutput, 'success' | 'message'>
  ) }
);

export type StartChecksOnRecapChunksContinuityMutationVariables = Exact<{
  data: StartChecksOnRecapChunksContinuityInput;
}>;


export type StartChecksOnRecapChunksContinuityMutation = (
  { __typename?: 'Mutation' }
  & { startChecksOnRecapChunksContinuity: (
    { __typename?: 'StartChecksOnRecapChunksContinuityOutput' }
    & Pick<StartChecksOnRecapChunksContinuityOutput, 'success' | 'message'>
  ) }
);

export type UpdateOneAppointmentNoteTemplateMutationVariables = Exact<{
  data: AppointmentNoteTemplateUpdateInput;
  where: AppointmentNoteTemplateWhereUniqueInput;
}>;


export type UpdateOneAppointmentNoteTemplateMutation = (
  { __typename?: 'Mutation' }
  & { updateOneAppointmentNoteTemplate: (
    { __typename?: 'AppointmentNoteTemplate' }
    & AppointmentNoteTemplateFragmentFragment
  ) }
);

export type UpdateOneRecapMutationVariables = Exact<{
  data: RecapUpdateInput;
  where: RecapWhereUniqueInput;
}>;


export type UpdateOneRecapMutation = (
  { __typename?: 'Mutation' }
  & { updateOneRecap: (
    { __typename?: 'Recap' }
    & Pick<Recap, 'id'>
  ) }
);

export type GetEnrollmentsCountQueryVariables = Exact<{
  where?: Maybe<CarePlanEnrollmentWhereInput>;
}>;


export type GetEnrollmentsCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyCarePlanEnrollmentCount'>
);

export type SubscribeToNewCareEnrollmentsSubscriptionVariables = Exact<{
  where: CareEnrollmentsByClinicWhereInput;
}>;


export type SubscribeToNewCareEnrollmentsSubscription = (
  { __typename?: 'Subscription' }
  & { checkPetEnrollmentsByClinic: (
    { __typename?: 'CareEnrollmentsByClinicOutput' }
    & Pick<CareEnrollmentsByClinicOutput, 'dailyTotal' | 'monthlyTotal'>
    & { enrollmentData: (
      { __typename?: 'CareEnrollmentData' }
      & Pick<CareEnrollmentData, 'clientName' | 'petName' | 'planName' | 'isRenewal'>
    ) }
  ) }
);

export type FindUniqueClinicPetParentQueryVariables = Exact<{
  where: ClinicPetParentWhereUniqueInput;
}>;


export type FindUniqueClinicPetParentQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'firstName'>
  )> }
);

export type InvoicePetParentFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id' | 'email' | 'firstName' | 'lastName' | 'isActive' | 'updatedAt' | 'creationSource' | 'pimsId'>
  & { phoneNumbers: Array<(
    { __typename?: 'ClinicEntityPhoneNumber' }
    & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'isPrimary' | 'isMobile' | 'isDeleted' | 'updatedAt'>
  )>, pets: Array<(
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'breed' | 'gender' | 'isDeleted' | 'speciesType' | 'weight' | 'clinicId' | 'dateOfBirth' | 'weightUnit' | 'pimsId'>
    & { petParents: Array<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'firstName' | 'id' | 'lastName' | 'email' | 'pimsId'>
      & { phoneNumbers: Array<(
        { __typename?: 'ClinicEntityPhoneNumber' }
        & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'isPrimary' | 'isMobile' | 'isDeleted' | 'updatedAt'>
      )> }
    )>, alerts: Array<(
      { __typename?: 'ClinicPetAlert' }
      & Pick<ClinicPetAlert, 'value' | 'pimsDate' | 'pimsId' | 'isMedical'>
    )> }
    & PetAvatarFragment
  )> }
);

export type PostCareInvoiceAccountCreditToPimsMutationVariables = Exact<{
  data: WritebackCareInvoiceAccountCreditToPimsInput;
}>;


export type PostCareInvoiceAccountCreditToPimsMutation = (
  { __typename?: 'Mutation' }
  & { postCareInvoiceAccountCreditToPims: (
    { __typename?: 'WritebackCareInvoiceAccountCreditToPimsResponse' }
    & Pick<WritebackCareInvoiceAccountCreditToPimsResponse, 'success' | 'error'>
  ) }
);

export type IssueTrupanionCertificateMutationVariables = Exact<{
  where: TrupanionIssueCertificateWhereInput;
  data: TrupanionIssueCertificateDataInput;
}>;


export type IssueTrupanionCertificateMutation = (
  { __typename?: 'Mutation' }
  & { trupanionIssueCertificate?: Maybe<(
    { __typename?: 'TrupanionIssueCertificateResponse' }
    & Pick<TrupanionIssueCertificateResponse, 'referenceNumber' | 'errorMessages'>
  )> }
);

export type GetInvoicePetParentsQueryVariables = Exact<{
  whereInput?: Maybe<SearchClinicPetParentInput>;
  pageSize?: Maybe<Scalars['Int']>;
  petWhere?: Maybe<ClinicPetWhereInput>;
}>;


export type GetInvoicePetParentsQuery = (
  { __typename?: 'Query' }
  & { clinicPetParentSearch: Array<(
    { __typename?: 'ClinicPetParent' }
    & InvoicePetParentFragment
  )> }
);

export type GetPaymentIntentStatusQueryVariables = Exact<{
  where: StripePaymentIntentWhereUniqueInput;
}>;


export type GetPaymentIntentStatusQuery = (
  { __typename?: 'Query' }
  & { findUniqueStripePaymentIntent?: Maybe<(
    { __typename?: 'StripePaymentIntent' }
    & Pick<StripePaymentIntent, 'id' | 'status' | 'lastPaymentError' | 'paymentRelationship'>
  )> }
);

export type TrupanionCertificateAvailabilityQueryVariables = Exact<{
  where: TrupanionCertificateAvailabilityInput;
}>;


export type TrupanionCertificateAvailabilityQuery = (
  { __typename?: 'Query' }
  & { trupanionCertificateAvailability?: Maybe<Array<Maybe<(
    { __typename?: 'TrupanionAvailability' }
    & Pick<TrupanionAvailability, 'clinicPetId' | 'clinicPetName' | 'isAvailable' | 'trupanionClosestBreed' | 'pimsBreed' | 'speciesType' | 'errorMessages'>
    & { unavailableReasons?: Maybe<(
      { __typename?: 'UnavailableReasons' }
      & Pick<UnavailableReasons, 'IsPetAlreadyEnrolled' | 'IsPetPolicyCancelled' | 'IsActiveOrPendingCertificateFound' | 'IsExamDateOutsideOfActivationWindow' | 'IsAdoptionDateOutsideOfActivationWindow' | 'IsEmailAssociatedToManyPolicies'>
    )> }
  )>>> }
);

export type CreateMassTextAlertMutationVariables = Exact<{
  data: MassTextAlertCreateInput;
}>;


export type CreateMassTextAlertMutation = (
  { __typename?: 'Mutation' }
  & { createOneMassTextAlert: (
    { __typename?: 'MassTextAlert' }
    & Pick<MassTextAlert, 'id' | 'appointmentDateTimeTo' | 'appointmentDateTimeFrom' | 'alertBody'>
  ) }
);

export type MassTextAleryActivityLogFragment = (
  { __typename?: 'MassTextAlert' }
  & Pick<MassTextAlert, 'id' | 'createdAt' | 'alertBody' | 'appointmentDateRangeType' | 'appointmentDateTimeFrom' | 'appointmentDateTimeTo' | 'status'>
  & { createdByUser: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & ClinicUserAvatarFragment
  ) }
);

export type GetActivityLogForMassTextAlertsQueryVariables = Exact<{
  where?: Maybe<MassTextAlertWhereInput>;
  orderBy?: Maybe<Array<Maybe<MassTextAlertOrderByWithRelationInput>> | Maybe<MassTextAlertOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetActivityLogForMassTextAlertsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyMassTextAlertCount'>
  & { findManyMassTextAlert: Array<(
    { __typename?: 'MassTextAlert' }
    & MassTextAleryActivityLogFragment
  )> }
);

export type GetDeliveryReportForMassTextAlertQueryVariables = Exact<{
  massTextAlertId: Scalars['String'];
}>;


export type GetDeliveryReportForMassTextAlertQuery = (
  { __typename?: 'Query' }
  & { massTextAlertReport?: Maybe<Array<Maybe<(
    { __typename?: 'MassTextAlertReportEntry' }
    & Pick<MassTextAlertReportEntry, 'phoneNumber' | 'petParentFullName' | 'smsStatus' | 'errorDetails'>
  )>>> }
);

export type GetEstimatedSendTimeForMassTextAlertQueryVariables = Exact<{
  clinicId: Scalars['String'];
  appointmentDateTimeFrom: Scalars['String'];
  appointmentDateTimeTo: Scalars['String'];
  alertBody: Scalars['String'];
}>;


export type GetEstimatedSendTimeForMassTextAlertQuery = (
  { __typename?: 'Query' }
  & { estimateNumberOfPetParentsReached?: Maybe<(
    { __typename?: 'NumberOfPetParentsReached' }
    & Pick<NumberOfPetParentsReached, 'numberOfPetPerents' | 'timeEstimateInSeconds'>
  )> }
);

export type SubscribeToMassTextAlertStatusSubscriptionVariables = Exact<{
  where: SubscriptionMassTextAlertWhereInput;
}>;


export type SubscribeToMassTextAlertStatusSubscription = (
  { __typename?: 'Subscription' }
  & { massTextAlertChanged: (
    { __typename?: 'MassTextAlertSubscription' }
    & { node: (
      { __typename?: 'MassTextAlert' }
      & Pick<MassTextAlert, 'id' | 'status'>
    ) }
  ) }
);

export type GetAppointmentFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppointmentFiltersQuery = (
  { __typename?: 'Query' }
  & { appointmentFilters?: Maybe<(
    { __typename?: 'AppointmentFilter' }
    & Pick<AppointmentFilter, 'currentDay' | 'startDate' | 'endDate' | 'daysAheadInterval' | 'defaultAppointmentDurationInMinutes'>
  )> }
);

export type CompleteCareBenefitUsageFollowupMutationVariables = Exact<{
  followupId: Scalars['String'];
  completedAt: Scalars['DateTime'];
}>;


export type CompleteCareBenefitUsageFollowupMutation = (
  { __typename?: 'Mutation' }
  & { updateOneCareBenefitUsageFollowup: (
    { __typename?: 'CareBenefitUsageFollowup' }
    & Pick<CareBenefitUsageFollowup, 'id' | 'completed'>
  ) }
);

export type CompleteCareBenefitUsageFollowupStepMutationVariables = Exact<{
  stepId: Scalars['String'];
  completedAt: Scalars['DateTime'];
  completedByUserId: Scalars['String'];
}>;


export type CompleteCareBenefitUsageFollowupStepMutation = (
  { __typename?: 'Mutation' }
  & { updateOneCareBenefitUsageFollowupStep: (
    { __typename?: 'CareBenefitUsageFollowupStep' }
    & Pick<CareBenefitUsageFollowupStep, 'id' | 'completed'>
  ) }
);

export type GetCareBenefitUsageFollowupQueryVariables = Exact<{
  organizationPetId: Scalars['String'];
}>;


export type GetCareBenefitUsageFollowupQuery = (
  { __typename?: 'Query' }
  & { findManyCareBenefitUsageFollowup: Array<(
    { __typename?: 'CareBenefitUsageFollowup' }
    & CareBenefitUsageFollowUpFragment
  )> }
);

export type CareAccountCreditIntentFragment = (
  { __typename?: 'CareAccountCreditIntent' }
  & Pick<CareAccountCreditIntent, 'id' | 'invoiceId' | 'paymentDue'>
  & { careAccountCreditPimsWritebackLogEntries: Array<(
    { __typename?: 'CareAccountCreditPimsWritebackLogEntry' }
    & Pick<CareAccountCreditPimsWritebackLogEntry, 'writebackLogId'>
  )> }
);

export type CareBenefitUsageFollowUpFragment = (
  { __typename?: 'CareBenefitUsageFollowup' }
  & Pick<CareBenefitUsageFollowup, 'id' | 'careStripeSubscriptionId' | 'completed'>
  & { followupSteps: Array<(
    { __typename?: 'CareBenefitUsageFollowupStep' }
    & Pick<CareBenefitUsageFollowupStep, 'id' | 'description' | 'completed' | 'displayOrder'>
    & { careAccountCreditIntents: Array<(
      { __typename?: 'CareAccountCreditIntent' }
      & CareAccountCreditIntentFragment
    )> }
  )> }
);

export type GetConnectedServicesQueryVariables = Exact<{
  where?: Maybe<OrganizationCareBenefitToClinicServiceWhereInput>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetConnectedServicesQuery = (
  { __typename?: 'Query' }
  & { findManyOrganizationCareBenefitToClinicService: Array<(
    { __typename?: 'OrganizationCareBenefitToClinicService' }
    & { service: (
      { __typename?: 'Service' }
      & Pick<Service, 'id' | 'name' | 'integrationId'>
    ) }
  )> }
);

export type CancelCareSubscriptionMutationVariables = Exact<{
  data?: Maybe<CancelCareSubscriptionInput>;
}>;


export type CancelCareSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & { cancelCareSubscription?: Maybe<(
    { __typename?: 'CancelCareSubscriptionResult' }
    & Pick<CancelCareSubscriptionResult, 'success' | 'messages'>
  )> }
);

export type CreateCarePaymentMethodSetupMutationVariables = Exact<{
  data?: Maybe<CreateCarePaymentMethodSetupInput>;
}>;


export type CreateCarePaymentMethodSetupMutation = (
  { __typename?: 'Mutation' }
  & { createCarePaymentMethodSetup: (
    { __typename?: 'CreatePaymentMethodSetupInputResult' }
    & Pick<CreatePaymentMethodSetupInputResult, 'setupIntentSecret'>
  ) }
);

export type CreateEnrollmentSupportEventMutationVariables = Exact<{
  data: EnrollmentSupportEventCreateInput;
}>;


export type CreateEnrollmentSupportEventMutation = (
  { __typename?: 'Mutation' }
  & { createOneEnrollmentSupportEvent: (
    { __typename?: 'EnrollmentSupportEvent' }
    & Pick<EnrollmentSupportEvent, 'id' | 'createdAt' | 'carePlanEnrollmentId' | 'requesterId' | 'pointOfContactId' | 'manageMembershipRequestType' | 'cancelReason' | 'manageMembershipDescription' | 'relatedInvoiceId'>
  ) }
);

export type EnsurePetsArePromotedMutationVariables = Exact<{
  data?: Maybe<EnsurePetsPromotedInput>;
}>;


export type EnsurePetsArePromotedMutation = (
  { __typename?: 'Mutation' }
  & { ensurePetsPromoted?: Maybe<(
    { __typename?: 'EnsurePetsPromotedResult' }
    & Pick<EnsurePetsPromotedResult, 'success'>
  )> }
);

export type PerformCarePlanEnrollmentUpgradeMutationVariables = Exact<{
  data: PerformCarePlanEnrollmentUpgradeInput;
}>;


export type PerformCarePlanEnrollmentUpgradeMutation = (
  { __typename?: 'Mutation' }
  & { performCarePlanEnrollmentUpgrade?: Maybe<(
    { __typename?: 'PerformCarePlanEnrollmentUpgradeOutput' }
    & Pick<PerformCarePlanEnrollmentUpgradeOutput, 'success' | 'message' | 'upgradeInvoiceId'>
  )> }
);

export type TransferCareSubscriptionMutationVariables = Exact<{
  data?: Maybe<TransferSubscriptionInput>;
}>;


export type TransferCareSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & { transferCareSubscription?: Maybe<(
    { __typename?: 'TransferSubscriptionOutput' }
    & Pick<TransferSubscriptionOutput, 'success'>
  )> }
);

export type UpdateCarePlanEnrollmentMutationVariables = Exact<{
  where: CarePlanEnrollmentWhereUniqueInput;
  data: CarePlanEnrollmentUpdateInput;
}>;


export type UpdateCarePlanEnrollmentMutation = (
  { __typename?: 'Mutation' }
  & { updateOneCarePlanEnrollment: (
    { __typename?: 'CarePlanEnrollment' }
    & Pick<CarePlanEnrollment, 'id' | 'autoRenews'>
  ) }
);

export type UpdateEnrollmentSupportEventMutationVariables = Exact<{
  where: EnrollmentSupportEventWhereUniqueInput;
  data: EnrollmentSupportEventUpdateInput;
}>;


export type UpdateEnrollmentSupportEventMutation = (
  { __typename?: 'Mutation' }
  & { updateOneEnrollmentSupportEvent: (
    { __typename?: 'EnrollmentSupportEvent' }
    & Pick<EnrollmentSupportEvent, 'id' | 'updatedAt'>
  ) }
);

export type ExportCancellationSummaryAsPdfQueryVariables = Exact<{
  data: ExportCancellationSummaryAsPdfInput;
}>;


export type ExportCancellationSummaryAsPdfQuery = (
  { __typename?: 'Query' }
  & { exportCancellationSummaryAsPdf: (
    { __typename?: 'ExportCancellationSummaryAsPdfResponse' }
    & Pick<ExportCancellationSummaryAsPdfResponse, 'success' | 'base64PDF'>
  ) }
);

export type FindLastUsageByBenefitQueryVariables = Exact<{
  usageClinicPetId?: Maybe<Scalars['String']>;
  benefitId?: Maybe<Scalars['String']>;
}>;


export type FindLastUsageByBenefitQuery = (
  { __typename?: 'Query' }
  & { findManyCareBenefitUsage: Array<(
    { __typename?: 'CareBenefitUsage' }
    & Pick<CareBenefitUsage, 'id'>
  )> }
);

export type FindManyCareBenefitUsageQueryVariables = Exact<{
  orgPetId?: Maybe<Scalars['String']>;
  orgPetParentId?: Maybe<Scalars['String']>;
  take?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CareBenefitUsageOrderByWithRelationInput> | CareBenefitUsageOrderByWithRelationInput>;
}>;


export type FindManyCareBenefitUsageQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyCareBenefitUsageCount'>
  & { findManyCareBenefitUsage: Array<(
    { __typename?: 'CareBenefitUsage' }
    & CareBenefitActivityUsageFragment
  )> }
);

export type RecordingUserFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'namePrefix' | 'firstName' | 'lastName'>
);

export type CareBenefitActivityUsageFragment = (
  { __typename?: 'CareBenefitUsage' }
  & Pick<CareBenefitUsage, 'id' | 'createdAt' | 'updatedAt' | 'usedAt' | 'quantityUsed' | 'exhaustsBenefit'>
  & { recordedByUser?: Maybe<(
    { __typename?: 'User' }
    & RecordingUserFragment
  )>, usageClinic: (
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id' | 'name'>
  ), benefit: (
    { __typename?: 'CareBenefit' }
    & Pick<CareBenefit, 'id' | 'title' | 'description' | 'tangible' | 'exhaustible' | 'usageUnitOfMeasure' | 'type'>
  ), invoiceLineItemConnections: Array<(
    { __typename?: 'CareBenefitUsageToInvoiceLineItem' }
    & Pick<CareBenefitUsageToInvoiceLineItem, 'id' | 'adjustedAmount'>
  )> }
);

export type ActivityLogCareEnrollmentFragment = (
  { __typename?: 'CarePlanEnrollment' }
  & Pick<CarePlanEnrollment, 'id' | 'startDate' | 'expirationDate' | 'cancelledAt' | 'renewalRejectionReason' | 'renewalEmailNoticeSentAt'>
  & { renewalSuccessorEnrollment?: Maybe<(
    { __typename?: 'CarePlanEnrollment' }
    & Pick<CarePlanEnrollment, 'id'>
  )>, renewalPredecessorEnrollment?: Maybe<(
    { __typename?: 'CarePlanEnrollment' }
    & Pick<CarePlanEnrollment, 'id'>
    & { plan: (
      { __typename?: 'CarePlan' }
      & Pick<CarePlan, 'id' | 'title' | 'flowAlias'>
    ) }
  )>, plan: (
    { __typename?: 'CarePlan' }
    & Pick<CarePlan, 'id' | 'title' | 'flowAlias'>
  ) }
);

export type ActivityLogEnrollmentSupportEventFragment = (
  { __typename?: 'EnrollmentSupportEvent' }
  & Pick<EnrollmentSupportEvent, 'id' | 'createdAt' | 'carePlanEnrollmentId' | 'manageMembershipRequestType' | 'cancelReason' | 'amount' | 'paymentSchedule' | 'manageMembershipDescription'>
  & { requester?: Maybe<(
    { __typename?: 'User' }
    & RecordingUserFragment
  )>, currentPlan?: Maybe<(
    { __typename?: 'CarePlan' }
    & Pick<CarePlan, 'id' | 'flowAlias' | 'title'>
  )>, newPlan?: Maybe<(
    { __typename?: 'CarePlan' }
    & Pick<CarePlan, 'id' | 'flowAlias' | 'title'>
  )>, transferFromPet?: Maybe<(
    { __typename?: 'OrganizationPet' }
    & Pick<OrganizationPet, 'id' | 'preferredName'>
  )>, transferToPet?: Maybe<(
    { __typename?: 'OrganizationPet' }
    & Pick<OrganizationPet, 'id' | 'preferredName'>
  )>, carePlanEnrollment: (
    { __typename?: 'CarePlanEnrollment' }
    & Pick<CarePlanEnrollment, 'id'>
    & { careSubscriptionTrueUps: Array<(
      { __typename?: 'CareSubscriptionTrueUp' }
      & Pick<CareSubscriptionTrueUp, 'id'>
    )> }
  ) }
);

export type ActivityLogCareEnrollmentPaymentFragment = (
  { __typename?: 'CareEnrollmentPayment' }
  & Pick<CareEnrollmentPayment, 'id' | 'amount' | 'lastPaymentAttempt' | 'nextPaymentAttempt' | 'paidAt' | 'createdAt'>
  & { stripeInvoice?: Maybe<(
    { __typename?: 'StripeInvoice' }
    & Pick<StripeInvoice, 'id'>
    & { lapsedPayment?: Maybe<(
      { __typename?: 'CareLapsedPayment' }
      & Pick<CareLapsedPayment, 'id' | 'createdAt'>
    )>, stripePaymentMethod?: Maybe<(
      { __typename?: 'StripePaymentMethod' }
      & Pick<StripePaymentMethod, 'last4' | 'cardBrand' | 'expirationMonth' | 'expirationYear'>
    )> }
  )>, stripeDispute?: Maybe<(
    { __typename?: 'StripeDispute' }
    & Pick<StripeDispute, 'id' | 'status' | 'createdAt'>
  )>, stripeRefund?: Maybe<(
    { __typename?: 'StripeRefund' }
    & Pick<StripeRefund, 'id' | 'createdAt' | 'amount'>
  )> }
);

export type GetActivityLogCarePlanEnrollmentsQueryVariables = Exact<{
  enrollmentWhere?: Maybe<CarePlanEnrollmentWhereInput>;
  enrollmentPaymentWhere?: Maybe<CareEnrollmentPaymentWhereInput>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetActivityLogCarePlanEnrollmentsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyCareEnrollmentPaymentCount'>
  & { findManyCarePlanEnrollment: Array<(
    { __typename?: 'CarePlanEnrollment' }
    & ActivityLogCareEnrollmentFragment
  )>, findManyCareEnrollmentPayment: Array<(
    { __typename?: 'CareEnrollmentPayment' }
    & ActivityLogCareEnrollmentPaymentFragment
  )> }
);

export type GetActivityLogEnrollmentSupportEventsQueryVariables = Exact<{
  supportEventWhere?: Maybe<EnrollmentSupportEventWhereInput>;
  supportEventCountWhere?: Maybe<EnrollmentSupportEventWhereInput>;
  noteEventCountWhere?: Maybe<EnrollmentSupportEventWhereInput>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetActivityLogEnrollmentSupportEventsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyEnrollmentSupportEventCount'>
  & { findManyEnrollmentSupportEventNotesCount: Query['findManyEnrollmentSupportEventCount'] }
  & { findManyEnrollmentSupportEvent: Array<(
    { __typename?: 'EnrollmentSupportEvent' }
    & ActivityLogEnrollmentSupportEventFragment
  )> }
);

export type GetActivityLogCareBenefitUsagesQueryVariables = Exact<{
  benefitUsageWhere?: Maybe<CareBenefitUsageWhereInput>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetActivityLogCareBenefitUsagesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyCareBenefitUsageCount'>
  & { findManyCareBenefitUsage: Array<(
    { __typename?: 'CareBenefitUsage' }
    & CareBenefitActivityUsageFragment
  )> }
);

export type CarePlanInfoFragment = (
  { __typename?: 'CarePlan' }
  & Pick<CarePlan, 'id' | 'title' | 'flowAlias'>
  & { planBenefits: Array<(
    { __typename?: 'CarePlanBenefit' }
    & Pick<CarePlanBenefit, 'id'>
    & { benefit: (
      { __typename?: 'CareBenefit' }
      & Pick<CareBenefit, 'id' | 'type' | 'reportingExpectedValue'>
    ) }
  )> }
);

export type CarePlanPricingInfoFragment = (
  { __typename?: 'CarePlanPricing' }
  & Pick<CarePlanPricing, 'id' | 'pricePerRenewal' | 'renewalCycle' | 'billingCycle' | 'planDiscount'>
);

export type CareEnrollmentPaymentInfoFragment = (
  { __typename?: 'CareEnrollmentPayment' }
  & Pick<CareEnrollmentPayment, 'id' | 'amount' | 'applicationFeeAmount' | 'paidAt'>
  & { stripeDispute?: Maybe<(
    { __typename?: 'StripeDispute' }
    & Pick<StripeDispute, 'id' | 'status'>
  )>, stripeRefund?: Maybe<(
    { __typename?: 'StripeRefund' }
    & Pick<StripeRefund, 'id' | 'amount'>
  )> }
);

export type GetCareEnrollmentInfoQueryVariables = Exact<{
  enrollmentId?: Maybe<Scalars['String']>;
}>;


export type GetCareEnrollmentInfoQuery = (
  { __typename?: 'Query' }
  & { findUniqueCarePlanEnrollment?: Maybe<(
    { __typename?: 'CarePlanEnrollment' }
    & Pick<CarePlanEnrollment, 'id' | 'startDate'>
    & { plan: (
      { __typename?: 'CarePlan' }
      & CarePlanInfoFragment
    ), planPricing?: Maybe<(
      { __typename?: 'CarePlanPricing' }
      & CarePlanPricingInfoFragment
    )>, enrollmentPayments: Array<(
      { __typename?: 'CareEnrollmentPayment' }
      & CareEnrollmentPaymentInfoFragment
    )> }
  )> }
);

export type GetCareEnrollmentTrueUpHistoryQueryVariables = Exact<{
  where?: Maybe<CareSubscriptionTrueUpWhereInput>;
}>;


export type GetCareEnrollmentTrueUpHistoryQuery = (
  { __typename?: 'Query' }
  & { findManyCareSubscriptionTrueUp: Array<(
    { __typename?: 'CareSubscriptionTrueUp' }
    & Pick<CareSubscriptionTrueUp, 'id' | 'dueAt' | 'completedAt' | 'retryAt' | 'amount' | 'shouldCancelEnrollment'>
  )> }
);

export type GetCareSavedPaymentMethodsQueryVariables = Exact<{
  where?: Maybe<StripePaymentMethodWhereInput>;
}>;


export type GetCareSavedPaymentMethodsQuery = (
  { __typename?: 'Query' }
  & { findManyStripePaymentMethod: Array<(
    { __typename?: 'StripePaymentMethod' }
    & Pick<StripePaymentMethod, 'id' | 'isDefault' | 'isExpired' | 'last4' | 'cardBrand' | 'expirationMonth' | 'expirationYear' | 'stripeId'>
  )> }
);

export type GetBalanceForClientQueryVariables = Exact<{
  where: GetBalanceForClientInput;
}>;


export type GetBalanceForClientQuery = (
  { __typename?: 'Query' }
  & { getBalanceForClient?: Maybe<(
    { __typename?: 'BitwerxClientBalance' }
    & BalanceForClientFragment
  )> }
);

export type BalanceForClientFragment = (
  { __typename?: 'BitwerxClientBalance' }
  & Pick<BitwerxClientBalance, 'currentBalance' | 'agingCurrent' | 'aging30D' | 'aging60D' | 'aging90D' | 'aging120D'>
);

export type GetInvoicesForClientQueryVariables = Exact<{
  where: InvoiceWhereInput;
}>;


export type GetInvoicesForClientQuery = (
  { __typename?: 'Query' }
  & { getInvoicesForClient: Array<(
    { __typename?: 'Invoice' }
    & InvoiceForClientFragment
  )> }
);

export type InvoiceForClientFragment = (
  { __typename?: 'Invoice' }
  & Pick<Invoice, 'id' | 'status' | 'createdAt' | 'updatedAt' | 'subtotal' | 'taxes' | 'total' | 'date' | 'outstandingBalance' | 'currency' | 'identifier'>
  & { sentBy?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'nameDisplay' | 'firstName' | 'lastName'>
  )>, clinicPetParent: (
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName' | 'email' | 'phoneNumber'>
  ), stripePaymentIntents: Array<(
    { __typename?: 'StripePaymentIntent' }
    & StripePaymentIntentStatusFragment
  )>, relatedInvoiceWritebacks: Array<(
    { __typename?: 'InvoicePimsWritebackLogEntry' }
    & Pick<InvoicePimsWritebackLogEntry, 'action'>
  )> }
);

export type StripePaymentIntentStatusFragment = (
  { __typename?: 'StripePaymentIntent' }
  & Pick<StripePaymentIntent, 'status'>
);

export type ClinicCarePlanFragment = (
  { __typename?: 'CarePlan' }
  & Pick<CarePlan, 'id' | 'title' | 'flowAlias' | 'description' | 'published'>
  & { planPricings: Array<(
    { __typename?: 'CarePlanPricing' }
    & Pick<CarePlanPricing, 'id' | 'pricePerRenewal' | 'renewalCycle' | 'billingCycle' | 'published'>
  )> }
);

export type ClinicCarePlanProviderGroupFragment = (
  { __typename?: 'CarePlanProviderGroup' }
  & Pick<CarePlanProviderGroup, 'id'>
  & { associatedPlans: Array<(
    { __typename?: 'CarePlan' }
    & ClinicCarePlanFragment
  )> }
);

export type GetClinicCarePlansQueryVariables = Exact<{
  where?: Maybe<CarePlanProviderGroupWhereInput>;
}>;


export type GetClinicCarePlansQuery = (
  { __typename?: 'Query' }
  & { findFirstCarePlanProviderGroup?: Maybe<(
    { __typename?: 'CarePlanProviderGroup' }
    & ClinicCarePlanProviderGroupFragment
  )> }
);

export type GetCustomerStripePortalUrlQueryVariables = Exact<{
  data?: Maybe<StripeCustomerPortalInput>;
  clinicPetParentId?: Maybe<Scalars['String']>;
}>;


export type GetCustomerStripePortalUrlQuery = (
  { __typename?: 'Query' }
  & { stripeRetrievePetParentPortalUrl?: Maybe<(
    { __typename?: 'StripeCustomerPortalOutput' }
    & Pick<StripeCustomerPortalOutput, 'id' | 'url'>
  )> }
);

export type CareBenefitPetParentFragment = (
  { __typename?: 'ClinicPetParent' }
  & { organizationPetParent?: Maybe<(
    { __typename?: 'OrganizationPetParent' }
    & Pick<OrganizationPetParent, 'id' | 'stripeCustomerTableId'>
  )> }
  & StripeTerminalClinicPetParentFragment
  & PetParentAvatarFragment
);

export type StripeTerminalClinicPetParentFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName' | 'email' | 'pimsId'>
);

export type GetSidePanelBenefitsClinicPetParentQueryVariables = Exact<{
  clinicPetParentId: Scalars['String'];
}>;


export type GetSidePanelBenefitsClinicPetParentQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & CareBenefitPetParentFragment
  )> }
);

export type SubscribeToActivityLogUpdatedSubscriptionVariables = Exact<{
  enrollmentId: Scalars['String'];
}>;


export type SubscribeToActivityLogUpdatedSubscription = (
  { __typename?: 'Subscription' }
  & { enrollmentActivityLogUpdated: (
    { __typename?: 'EnrollmentActivityLogSubscription' }
    & Pick<EnrollmentActivityLogSubscription, 'model'>
    & { node: (
      { __typename?: 'GenericActivityLog' }
      & Pick<GenericActivityLog, 'id'>
    ) }
  ) }
);

export type LoyaltyProgramRewardRedemptionFragment = (
  { __typename?: 'LoyaltyRewardRedemption' }
  & Pick<LoyaltyRewardRedemption, 'id' | 'createdAt'>
  & { reward: (
    { __typename?: 'LoyaltyReward' }
    & Pick<LoyaltyReward, 'id' | 'title' | 'description' | 'pointCost'>
  ) }
);

export type RedemptionHistoryFragment = (
  { __typename?: 'LoyaltyRewardRedemptionHistoryEntry' }
  & Pick<LoyaltyRewardRedemptionHistoryEntry, 'id' | 'createdAt' | 'status' | 'actorType'>
  & { actingUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
  )> }
);

export type RewardHistoryFragment = (
  { __typename?: 'LoyaltyPointDelta' }
  & Pick<LoyaltyPointDelta, 'id' | 'createdAt' | 'source' | 'points'>
  & { userGrant?: Maybe<(
    { __typename?: 'LoyaltyPointUserGrant' }
    & Pick<LoyaltyPointUserGrant, 'id' | 'amount' | 'publicNotes' | 'internalNotes'>
    & { grantingUser: (
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    ) }
  )>, relatedRedemptionHistoryEntry?: Maybe<(
    { __typename?: 'LoyaltyRewardRedemptionHistoryEntry' }
    & Pick<LoyaltyRewardRedemptionHistoryEntry, 'id'>
    & { redemption: (
      { __typename?: 'LoyaltyRewardRedemption' }
      & Pick<LoyaltyRewardRedemption, 'id' | 'updatedAt' | 'status'>
      & { reward: (
        { __typename?: 'LoyaltyReward' }
        & Pick<LoyaltyReward, 'id' | 'title' | 'pointCost'>
      ), redemptionHistories: Array<(
        { __typename?: 'LoyaltyRewardRedemptionHistoryEntry' }
        & RedemptionHistoryFragment
      )> }
    ) }
  )> }
);

export type ClaimRewardMutationVariables = Exact<{
  data: RequestLoyaltyRewardInput;
}>;


export type ClaimRewardMutation = (
  { __typename?: 'Mutation' }
  & { requestLoyaltyReward: (
    { __typename?: 'LoyaltyRewardRedemption' }
    & Pick<LoyaltyRewardRedemption, 'id'>
  ) }
);

export type FindOrCreateLoyaltyAccountForClinicPetParentMutationVariables = Exact<{
  clinicPetParentId: Scalars['String'];
}>;


export type FindOrCreateLoyaltyAccountForClinicPetParentMutation = (
  { __typename?: 'Mutation' }
  & { findOrCreateLoyaltyAccountForClinicPetParent: (
    { __typename?: 'LoyaltyAccount' }
    & Pick<LoyaltyAccount, 'id' | 'pointBalance'>
    & { program: (
      { __typename?: 'LoyaltyProgram' }
      & Pick<LoyaltyProgram, 'id' | 'status'>
    ), rewardRedemptions: Array<(
      { __typename?: 'LoyaltyRewardRedemption' }
      & LoyaltyProgramRewardRedemptionFragment
    )> }
  ) }
);

export type FulfillRewardMutationVariables = Exact<{
  data: LoyaltyRewardRedemptionInput;
}>;


export type FulfillRewardMutation = (
  { __typename?: 'Mutation' }
  & { fulfillLoyaltyRewardRedemption: (
    { __typename?: 'LoyaltyRewardRedemption' }
    & Pick<LoyaltyRewardRedemption, 'id'>
  ) }
);

export type GrantPointsMutationVariables = Exact<{
  data: LoyaltyPointGrantByUser;
}>;


export type GrantPointsMutation = (
  { __typename?: 'Mutation' }
  & { submitLoyaltyPointGrantToAccountByUser: (
    { __typename?: 'OperationResult' }
    & Pick<OperationResult, 'success'>
  ) }
);

export type GetFirstLoyaltyRewardRedemptionQueryVariables = Exact<{
  where?: Maybe<LoyaltyRewardRedemptionWhereInput>;
}>;


export type GetFirstLoyaltyRewardRedemptionQuery = (
  { __typename?: 'Query' }
  & { findFirstLoyaltyRewardRedemption?: Maybe<(
    { __typename?: 'LoyaltyRewardRedemption' }
    & Pick<LoyaltyRewardRedemption, 'id'>
  )> }
);

export type GetPetParentLoyaltyAccountHolderQueryVariables = Exact<{
  where?: Maybe<LoyaltyAccountHolderWhereInput>;
}>;


export type GetPetParentLoyaltyAccountHolderQuery = (
  { __typename?: 'Query' }
  & { findFirstLoyaltyAccountHolder?: Maybe<(
    { __typename?: 'LoyaltyAccountHolder' }
    & Pick<LoyaltyAccountHolder, 'id'>
    & { account: (
      { __typename?: 'LoyaltyAccount' }
      & Pick<LoyaltyAccount, 'id' | 'pointBalance'>
      & { rewardRedemptions: Array<(
        { __typename?: 'LoyaltyRewardRedemption' }
        & LoyaltyProgramRewardRedemptionFragment
      )> }
    ) }
  )> }
);

export type GetPetParentLoyaltyProgramDataQueryVariables = Exact<{
  where?: Maybe<ClinicPetParentWhereInput>;
}>;


export type GetPetParentLoyaltyProgramDataQuery = (
  { __typename?: 'Query' }
  & { findFirstClinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
    & { loyaltyAccountHolder?: Maybe<(
      { __typename?: 'LoyaltyAccountHolder' }
      & Pick<LoyaltyAccountHolder, 'id' | 'programId'>
      & { account: (
        { __typename?: 'LoyaltyAccount' }
        & Pick<LoyaltyAccount, 'id' | 'pointBalance'>
      ) }
    )> }
  )> }
);

export type GetRewardsHistoryQueryVariables = Exact<{
  where?: Maybe<LoyaltyPointDeltaWhereInput>;
  take: Scalars['Int'];
}>;


export type GetRewardsHistoryQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyLoyaltyPointDeltaCount'>
  & { findManyLoyaltyPointDelta: Array<(
    { __typename?: 'LoyaltyPointDelta' }
    & RewardHistoryFragment
  )> }
);

export type CheckPetEnrollmentSubscriptionVariables = Exact<{
  where: CareEnrollmentWhereInput;
}>;


export type CheckPetEnrollmentSubscription = (
  { __typename?: 'Subscription' }
  & { checkPetEnrollment: (
    { __typename?: 'CareEnrollmentOutput' }
    & Pick<CareEnrollmentOutput, 'isEnrolled'>
  ) }
);

export type CheckPetParentHasEnrolledPetSubscriptionVariables = Exact<{
  where: HasCarePetWithEnrollmentWhereInput;
}>;


export type CheckPetParentHasEnrolledPetSubscription = (
  { __typename?: 'Subscription' }
  & { checkPetParentHasEnrolledPet: (
    { __typename?: 'HasCarePetWithEnrollmentOutput' }
    & Pick<HasCarePetWithEnrollmentOutput, 'hasEnrolledPet'>
  ) }
);

export type SubscribeToLoyaltyAccountSubscriptionVariables = Exact<{
  where: LoyaltyAccountWhereUniqueInput;
}>;


export type SubscribeToLoyaltyAccountSubscription = (
  { __typename?: 'Subscription' }
  & { loyaltyAccountUpdated: (
    { __typename?: 'LoyaltyAccountSubscription' }
    & Pick<LoyaltyAccountSubscription, 'mutation'>
    & { node: (
      { __typename?: 'LoyaltyAccount' }
      & Pick<LoyaltyAccount, 'id' | 'pointBalance'>
    ) }
  ) }
);

export type SubscribeToLoyaltyProgramUpdateSubscriptionVariables = Exact<{
  where: LoyaltyProgramWhereUniqueInput;
}>;


export type SubscribeToLoyaltyProgramUpdateSubscription = (
  { __typename?: 'Subscription' }
  & { loyaltyProgramUpdated: (
    { __typename?: 'LoyaltyProgramSubscription' }
    & Pick<LoyaltyProgramSubscription, 'mutation'>
    & { node: (
      { __typename?: 'LoyaltyProgram' }
      & Pick<LoyaltyProgram, 'id' | 'status'>
    ) }
  ) }
);

export type SubscribeToLoyaltyRewardRedemptionUpdatedSubscriptionVariables = Exact<{
  where: LoyaltyRewardRedemptionWhereUniqueInput;
}>;


export type SubscribeToLoyaltyRewardRedemptionUpdatedSubscription = (
  { __typename?: 'Subscription' }
  & { loyaltyRewardRedemptionUpdated: (
    { __typename?: 'LoyaltyRewardRedemptionSubscription' }
    & Pick<LoyaltyRewardRedemptionSubscription, 'mutation'>
    & { node: (
      { __typename?: 'LoyaltyRewardRedemption' }
      & Pick<LoyaltyRewardRedemption, 'id' | 'status'>
    ) }
  ) }
);

export type CareSubscriptionFragment = (
  { __typename?: 'CareStripeSubscription' }
  & Pick<CareStripeSubscription, 'id' | 'paymentStatus' | 'nextBillingDate'>
  & { stripePaymentMethod?: Maybe<(
    { __typename?: 'StripePaymentMethod' }
    & Pick<StripePaymentMethod, 'id' | 'last4' | 'stripeId' | 'cardBrand' | 'expirationMonth' | 'expirationYear' | 'isExpired'>
  )> }
);

export type CareEnrollmentFragment = (
  { __typename?: 'CarePlanEnrollment' }
  & Pick<CarePlanEnrollment, 'id' | 'planId' | 'status' | 'startDate' | 'autoRenews' | 'expirationDate' | 'careStripeSubscriptionId'>
  & { careStripeSubscription?: Maybe<(
    { __typename?: 'CareStripeSubscription' }
    & Pick<CareStripeSubscription, 'paymentStatus'>
  )>, renewalSuccessorEnrollment?: Maybe<(
    { __typename?: 'CarePlanEnrollment' }
    & Pick<CarePlanEnrollment, 'id'>
  )>, plan: (
    { __typename?: 'CarePlan' }
    & Pick<CarePlan, 'id' | 'title' | 'flowAlias'>
    & { planBenefits: Array<(
      { __typename?: 'CarePlanBenefit' }
      & Pick<CarePlanBenefit, 'id' | 'benefitId' | 'displayOrder'>
    )> }
  ), planPricing?: Maybe<(
    { __typename?: 'CarePlanPricing' }
    & Pick<CarePlanPricing, 'id' | 'pricePerRenewal' | 'billingCycle'>
  )>, careSubscriptionTrueUps: Array<(
    { __typename?: 'CareSubscriptionTrueUp' }
    & EnrollmentTrueUpsFragment
  )>, enrollmentPayments: Array<(
    { __typename?: 'CareEnrollmentPayment' }
    & Pick<CareEnrollmentPayment, 'id' | 'amount' | 'applicationFeeAmount' | 'paidAt'>
    & { stripeDispute?: Maybe<(
      { __typename?: 'StripeDispute' }
      & Pick<StripeDispute, 'status'>
    )> }
  )> }
);

export type EnrollmentTrueUpsFragment = (
  { __typename?: 'CareSubscriptionTrueUp' }
  & Pick<CareSubscriptionTrueUp, 'id' | 'dueAt' | 'completedAt' | 'retryAt' | 'amount' | 'shouldCancelEnrollment'>
);

export type SidePanelOrganizationPetFragment = (
  { __typename?: 'OrganizationPet' }
  & Pick<OrganizationPet, 'id'>
  & { associatedSubscriptions: Array<(
    { __typename?: 'CareStripeSubscription' }
    & CareSubscriptionFragment
  )>, carePlanEnrollments: Array<(
    { __typename?: 'CarePlanEnrollment' }
    & CareEnrollmentFragment
  )> }
);

export type SidePanelParentPetDataFragment = (
  { __typename?: 'ClinicPet' }
  & Pick<ClinicPet, 'id' | 'pimsId' | 'weight' | 'clinicId'>
  & { organizationPet?: Maybe<(
    { __typename?: 'OrganizationPet' }
    & SidePanelOrganizationPetFragment
  )> }
  & PetAvatarFragment
);

export type UpdatePetParentSettingMutationVariables = Exact<{
  data: PetParentSettingUpdateInput;
  where: PetParentSettingWhereUniqueInput;
}>;


export type UpdatePetParentSettingMutation = (
  { __typename?: 'Mutation' }
  & { updateOnePetParentSetting: (
    { __typename?: 'PetParentSetting' }
    & SidePanelProfilePetParentSettingFragment
  ) }
);

export type HasDeviceThatCanRecievePushQueryVariables = Exact<{
  clinicPetParentIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type HasDeviceThatCanRecievePushQuery = (
  { __typename?: 'Query' }
  & { findFirstClinicPetParentDevice?: Maybe<(
    { __typename?: 'ClinicPetParentDevice' }
    & Pick<ClinicPetParentDevice, 'id' | 'pushNotificationStatus'>
  )> }
);

export type GetSidePanelParentPetsQueryVariables = Exact<{
  where?: Maybe<ClinicPetWhereInput>;
  take: Scalars['Int'];
  orderBy?: Maybe<Array<ClinicPetOrderByWithRelationInput> | ClinicPetOrderByWithRelationInput>;
}>;


export type GetSidePanelParentPetsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyClinicPetCount'>
  & { findManyClinicPet: Array<(
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'id'>
    & SidePanelParentPetDataFragment
  )> }
);

export type SidePanelProfilePetParentSettingFragment = (
  { __typename?: 'PetParentSetting' }
  & Pick<PetParentSetting, 'id' | 'createdAt' | 'updatedAt' | 'emailNotifications' | 'emailOptedOutByPetParent' | 'smsNotifications' | 'smsOptedOutByPetParent' | 'sendSurvey' | 'pushNotifications'>
);

export type SidePanelPetParentProfilePhoneNumberFragment = (
  { __typename?: 'ClinicEntityPhoneNumber' }
  & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'isPrimary' | 'isMobile' | 'isDeleted' | 'updatedAt'>
  & { phoneNumberLookupResult?: Maybe<(
    { __typename?: 'PhoneNumberLookupResult' }
    & Pick<PhoneNumberLookupResult, 'id' | 'lineType'>
  )>, phoneNumberLookupRequest?: Maybe<(
    { __typename?: 'PhoneNumberLookupRequest' }
    & Pick<PhoneNumberLookupRequest, 'id' | 'status'>
  )> }
);

export type SidePanelProfileClinicPetParentFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id' | 'email' | 'firstName' | 'lastName' | 'isActive' | 'createdAt' | 'updatedAt' | 'clinicId' | 'pimsId'>
  & { phoneNumbers: Array<(
    { __typename?: 'ClinicEntityPhoneNumber' }
    & SidePanelPetParentProfilePhoneNumberFragment
  )>, petParentSetting?: Maybe<(
    { __typename?: 'PetParentSetting' }
    & SidePanelProfilePetParentSettingFragment
  )>, pets: Array<(
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'id' | 'breed' | 'gender' | 'isActive' | 'isDeleted' | 'isDeceased' | 'dateOfBirth' | 'name' | 'species' | 'speciesType' | 'weight' | 'weightUnit' | 'photoUrl'>
    & { alerts: Array<(
      { __typename?: 'ClinicPetAlert' }
      & Pick<ClinicPetAlert, 'value' | 'pimsDate' | 'pimsId' | 'isMedical'>
    )> }
    & OrganizationPetCareBadgePlanEnrollmentFragment
  )>, loyaltyAccountHolder?: Maybe<(
    { __typename?: 'LoyaltyAccountHolder' }
    & Pick<LoyaltyAccountHolder, 'id'>
    & { program: (
      { __typename?: 'LoyaltyProgram' }
      & Pick<LoyaltyProgram, 'id' | 'status'>
    ), account: (
      { __typename?: 'LoyaltyAccount' }
      & Pick<LoyaltyAccount, 'pointBalance'>
      & { rewardRedemptions: Array<(
        { __typename?: 'LoyaltyRewardRedemption' }
        & Pick<LoyaltyRewardRedemption, 'id'>
      )> }
    ) }
  )> }
  & PetParentAvatarFragment
);

export type GetSidePanelPetParentProfileQueryVariables = Exact<{
  clinicPetParentId: Scalars['String'];
  clinicId: Scalars['String'];
}>;


export type GetSidePanelPetParentProfileQuery = (
  { __typename?: 'Query' }
  & { clinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & SidePanelProfileClinicPetParentFragment
  )> }
);

export type UpdateClinicPetWithoutPimsMutationVariables = Exact<{
  where: ClinicPetWhereUniqueInput;
  data: ClinicPetUpdateInput;
}>;


export type UpdateClinicPetWithoutPimsMutation = (
  { __typename?: 'Mutation' }
  & { updateClinicPetWithoutPims?: Maybe<(
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'id' | 'dateOfDeath'>
    & PetAvatarFragment
  )> }
);

export type UpdateOneClinicPetMutationVariables = Exact<{
  where: ClinicPetWhereUniqueInput;
  data: ClinicPetUpdateInput;
}>;


export type UpdateOneClinicPetMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinicPet: (
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'dateOfDeath'>
    & PetAvatarFragment
  ) }
);

export type SidePanelPetServiceRemindersFragment = (
  { __typename?: 'ServiceReminder' }
  & Pick<ServiceReminder, 'id' | 'dueDate' | 'isCompleted' | 'dateLastGiven'>
  & { service: (
    { __typename?: 'Service' }
    & Pick<Service, 'id' | 'name' | 'reminderActivationDate'>
  ) }
);

export type GetSidePanelPetProfileQueryVariables = Exact<{
  clinicPetId: Scalars['String'];
  clinicId: Scalars['String'];
}>;


export type GetSidePanelPetProfileQuery = (
  { __typename?: 'Query' }
  & { clinicPet?: Maybe<(
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'id' | 'clinicId' | 'dateOfBirth' | 'dateOfDeath' | 'breed' | 'color' | 'gender' | 'weight' | 'weightUnit' | 'pimsId' | 'isDeleted' | 'speciesType'>
    & { alerts: Array<(
      { __typename?: 'ClinicPetAlert' }
      & Pick<ClinicPetAlert, 'value' | 'pimsDate' | 'pimsId' | 'isMedical'>
    )>, petParents: Array<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
      & PetParentAvatarFragment
    )>, serviceReminders: Array<(
      { __typename?: 'ServiceReminder' }
      & SidePanelPetServiceRemindersFragment
    )> }
    & PetAvatarFragment
    & OrganizationPetCareBadgePlanEnrollmentFragment
  )> }
);

export type SidePanelSearchClinicEntityPhoneNumberFragment = (
  { __typename?: 'ClinicEntityPhoneNumber' }
  & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'isPrimary' | 'isMobile' | 'isDeleted' | 'updatedAt'>
);

export type SidePanelSearchClinicPetFragment = (
  { __typename?: 'ClinicPet' }
  & Pick<ClinicPet, 'id' | 'pimsId' | 'speciesType' | 'breed' | 'gender' | 'isActive' | 'isDeleted'>
  & PetAvatarFragment
);

export type SidePanelSearchClinicPetParentFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id' | 'updatedAt' | 'firstName' | 'lastName' | 'email' | 'isActive' | 'pimsId'>
  & { phoneNumbers: Array<(
    { __typename?: 'ClinicEntityPhoneNumber' }
    & SidePanelSearchClinicEntityPhoneNumberFragment
  )>, pets: Array<(
    { __typename?: 'ClinicPet' }
    & SidePanelSearchClinicPetFragment
  )> }
  & PetParentAvatarFragment
);

export type SidePanelSearchQueryVariables = Exact<{
  whereInput?: Maybe<SearchClinicPetParentInput>;
  pageSize?: Maybe<Scalars['Int']>;
  petWhere?: Maybe<ClinicPetWhereInput>;
}>;


export type SidePanelSearchQuery = (
  { __typename?: 'Query' }
  & { clinicPetParentSearch: Array<(
    { __typename?: 'ClinicPetParent' }
    & SidePanelSearchClinicPetParentFragment
  )> }
);

export type SidePanelPetFragment = (
  { __typename?: 'ClinicPet' }
  & Pick<ClinicPet, 'id' | 'breed' | 'gender'>
  & PetAvatarFragment
);

export type SidePanelPetParentFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id'>
  & { phoneNumbers: Array<(
    { __typename?: 'ClinicEntityPhoneNumber' }
    & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'isPrimary' | 'isMobile' | 'isDeleted' | 'updatedAt'>
  )> }
  & PetParentAvatarFragment
);

export type ExistingClinicPetParentMatchFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'creationSource'>
  & { phoneNumbers: Array<(
    { __typename?: 'ClinicEntityPhoneNumber' }
    & Pick<ClinicEntityPhoneNumber, 'id' | 'updatedAt' | 'number' | 'isPrimary' | 'isMobile' | 'isDeleted'>
  )>, pets: Array<(
    { __typename?: 'ClinicPet' }
    & PetAvatarFragment
  )> }
);

export type CheckForExistingClinicPetParentQueryVariables = Exact<{
  where: ClinicPetParentWhereInput;
}>;


export type CheckForExistingClinicPetParentQuery = (
  { __typename?: 'Query' }
  & { findManyClinicPetParent: Array<(
    { __typename?: 'ClinicPetParent' }
    & ExistingClinicPetParentMatchFragment
  )> }
);

export type ChannelStatusFragment = (
  { __typename?: 'ChannelStatus' }
  & Pick<ChannelStatus, 'id' | 'createdAt' | 'updatedAt' | 'channelStatusAction' | 'color' | 'deletedOn' | 'isDefault' | 'name' | 'order' | 'isExportedToPims'>
);

export type ChannelStatusChannelAssigneeFragmentFragment = (
  { __typename?: 'ChannelStatusChannelAssignee' }
  & Pick<ChannelStatusChannelAssignee, 'id'>
  & { user: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type FullChannelStatusFragment = (
  { __typename?: 'ChannelStatus' }
  & Pick<ChannelStatus, 'id' | 'createdAt' | 'updatedAt' | 'channelStatusAction' | 'color' | 'deletedOn' | 'isDefault' | 'name' | 'order' | 'isExportedToPims'>
  & { channelStatusChannelAssignees: Array<(
    { __typename?: 'ChannelStatusChannelAssignee' }
    & ChannelStatusChannelAssigneeFragmentFragment
  )> }
);

export type SharedUserNotificationSettingsFragment = (
  { __typename?: 'UserSetting' }
  & Pick<UserSetting, 'id' | 'snoozeNotificationsUntil'>
  & { browserNotificationFilter?: Maybe<(
    { __typename?: 'ChannelSelection' }
    & Pick<ChannelSelection, 'id' | 'includeUnassigned'>
    & { assignees: Array<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )> }
  )>, notificationSettings: Array<(
    { __typename?: 'UserNotificationSetting' }
    & Pick<UserNotificationSetting, 'id' | 'emailEnabled' | 'smsEnabled' | 'soundNotificationUrl' | 'browserNotificationEnabled' | 'pushNotificationEnabled'>
  )> }
);

export type StripePaymentIntentFragment = (
  { __typename?: 'StripePaymentIntent' }
  & Pick<StripePaymentIntent, 'id' | 'createdAt' | 'updatedAt' | 'stripeId' | 'status' | 'amount' | 'clientServiceFee' | 'total' | 'amountCaptured' | 'serviceFeeAmount' | 'clientServiceFeePercent' | 'lastPaymentError'>
  & { clinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
  )>, stripePaymentMethod?: Maybe<(
    { __typename?: 'StripePaymentMethod' }
    & Pick<StripePaymentMethod, 'last4' | 'cardBrand' | 'funding'>
  )>, stripeRefunds: Array<(
    { __typename?: 'StripeRefund' }
    & Pick<StripeRefund, 'id' | 'amount' | 'clientFeeRefunded' | 'updatedAt'>
  )> }
);

export type StripePaymentOutputFragment = (
  { __typename?: 'StripePaymentOutput' }
  & Pick<StripePaymentOutput, 'paymentIntentClientSecret' | 'requiresAction'>
  & { payment: (
    { __typename?: 'StripePayment' }
    & Pick<StripePayment, 'id' | 'status' | 'amount' | 'total' | 'amountCaptured' | 'amountRefunded' | 'transferType' | 'receiptUrl'>
  ) }
);

export type AddChannelMemberMutationVariables = Exact<{
  channelId: Scalars['String'];
  clinicPetParentId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}>;


export type AddChannelMemberMutation = (
  { __typename?: 'Mutation' }
  & { addChannelMember?: Maybe<(
    { __typename?: 'ChannelMember' }
    & Pick<ChannelMember, 'id' | 'removedAt'>
    & { clinicPetParent?: Maybe<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id'>
    )>, user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )> }
  )> }
);

export type AddClinicFeatureFlagMutationVariables = Exact<{
  clinicId: Scalars['String'];
  featureFlagKey: Scalars['String'];
}>;


export type AddClinicFeatureFlagMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinic: (
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id'>
    & { featureFlags: Array<(
      { __typename?: 'FeatureFlag' }
      & Pick<FeatureFlag, 'id' | 'key'>
    )> }
  ) }
);

export type CancelStripePaymentIntentMutationVariables = Exact<{
  where: StripePaymentIntentWhereUniqueInput;
}>;


export type CancelStripePaymentIntentMutation = (
  { __typename?: 'Mutation' }
  & { cancelStripePaymentIntent2?: Maybe<(
    { __typename?: 'StripePaymentIntent' }
    & Pick<StripePaymentIntent, 'id' | 'status'>
  )> }
);

export type ClearTerminalDisplayMutationVariables = Exact<{
  stripeTerminalId: Scalars['String'];
}>;


export type ClearTerminalDisplayMutation = (
  { __typename?: 'Mutation' }
  & { clearTerminalDisplay?: Maybe<(
    { __typename?: 'ClearTerminalDisplayResponse' }
    & Pick<ClearTerminalDisplayResponse, 'success' | 'error'>
  )> }
);

export type ClearUserInvitationMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ClearUserInvitationMutation = (
  { __typename?: 'Mutation' }
  & { updateOneUser: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'invitationCode'>
  ) }
);

export type CreateFormSubmissionMutationVariables = Exact<{
  data: FormSubmissionCreateInput;
}>;


export type CreateFormSubmissionMutation = (
  { __typename?: 'Mutation' }
  & { createOneFormSubmission: (
    { __typename?: 'FormSubmission' }
    & Pick<FormSubmission, 'id'>
  ) }
);

export type StripePaymentIntentSelectionFragment = (
  { __typename?: 'StripePaymentIntent' }
  & Pick<StripePaymentIntent, 'id' | 'status' | 'amount' | 'amountCaptured' | 'serviceFeeAmount' | 'stripeId'>
  & { stripePaymentMethod?: Maybe<(
    { __typename?: 'StripePaymentMethod' }
    & Pick<StripePaymentMethod, 'cardBrand' | 'last4' | 'type'>
  )> }
);

export type CreateStripePaymentIntentMutationVariables = Exact<{
  data: StripeCreatePaymentInput;
  clinicPetParentId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  paymentMedium?: Maybe<PaymentMedium>;
  stripeTerminalStripeId?: Maybe<Scalars['String']>;
  invoiceIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  paymentRelationship?: Maybe<PaymentRelationship>;
  emailOverride?: Maybe<Scalars['String']>;
  careAccountCreditIntentId?: Maybe<Scalars['String']>;
  cardType?: Maybe<CardFunding>;
}>;


export type CreateStripePaymentIntentMutation = (
  { __typename?: 'Mutation' }
  & { createStripePaymentIntent2?: Maybe<(
    { __typename?: 'StripePaymentIntent' }
    & StripePaymentIntentSelectionFragment
  )> }
);

export type CreateSystemChannelMessageMutationVariables = Exact<{
  data: SystemMessageCreateInput;
}>;


export type CreateSystemChannelMessageMutation = (
  { __typename?: 'Mutation' }
  & { createSystemChannelMessage?: Maybe<(
    { __typename?: 'ChannelMessage' }
    & Pick<ChannelMessage, 'id' | 'createdAt' | 'updatedAt' | 'index' | 'body' | 'messageType'>
    & { attachments: Array<(
      { __typename?: 'ChannelMessageAttachment' }
      & Pick<ChannelMessageAttachment, 'id' | 'attachmentType' | 'entityType' | 'entityId' | 'filename' | 'url'>
    )>, author?: Maybe<(
      { __typename?: 'ChannelMember' }
      & Pick<ChannelMember, 'id' | 'twilioIdentity'>
      & { user?: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName' | 'profilePic'>
      )>, clinicPetParent?: Maybe<(
        { __typename?: 'ClinicPetParent' }
        & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
      )> }
    )>, channel?: Maybe<(
      { __typename?: 'Channel' }
      & Pick<Channel, 'id'>
    )> }
  )> }
);

export type GenerateIntercomJwtMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateIntercomJwtMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'generateIntercomJwt'>
);

export type GetOrCreateActiveClientChannelMutationVariables = Exact<{
  data: GetOrCreateActiveClientChannelInput;
}>;


export type GetOrCreateActiveClientChannelMutation = (
  { __typename?: 'Mutation' }
  & { getOrCreateActiveClientChannel?: Maybe<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id'>
    & { channelMembers: Array<(
      { __typename?: 'ChannelMember' }
      & Pick<ChannelMember, 'id' | 'userId'>
    )> }
  )> }
);

export type ProcessTerminalPaymentMutationVariables = Exact<{
  stripeTerminalId: Scalars['String'];
  paymentIntent: PaymentIntentInput;
  isSurchargeClinic?: Maybe<Scalars['Boolean']>;
}>;


export type ProcessTerminalPaymentMutation = (
  { __typename?: 'Mutation' }
  & { processTerminalPayment?: Maybe<(
    { __typename?: 'ProcessTerminalPaymentResponse' }
    & Pick<ProcessTerminalPaymentResponse, 'success' | 'stripePaymentIntentId' | 'error'>
  )> }
);

export type RefundStripePaymentIntentMutationVariables = Exact<{
  where: StripePaymentIntentWhereUniqueInput;
  data: EnhancedStripeRefundPaymentInput;
}>;


export type RefundStripePaymentIntentMutation = (
  { __typename?: 'Mutation' }
  & { refundStripePaymentIntent2?: Maybe<(
    { __typename?: 'StripePaymentIntent' }
    & Pick<StripePaymentIntent, 'id'>
  )> }
);

export type RemoveChannelMemberMutationVariables = Exact<{
  channelMemberId: Scalars['String'];
}>;


export type RemoveChannelMemberMutation = (
  { __typename?: 'Mutation' }
  & { removeChannelMember?: Maybe<(
    { __typename?: 'ChannelMember' }
    & Pick<ChannelMember, 'id' | 'removedAt'>
    & { clinicPetParent?: Maybe<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id'>
    )>, user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )> }
  )> }
);

export type RemoveClinicFeatureFlagMutationVariables = Exact<{
  clinicId: Scalars['String'];
  featureFlagKey: Scalars['String'];
}>;


export type RemoveClinicFeatureFlagMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinic: (
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id'>
    & { featureFlags: Array<(
      { __typename?: 'FeatureFlag' }
      & Pick<FeatureFlag, 'id' | 'key'>
    )> }
  ) }
);

export type UpdateCurrentClinicMutationVariables = Exact<{
  vetInfoId: Scalars['String'];
  clinicId: Scalars['String'];
}>;


export type UpdateCurrentClinicMutation = (
  { __typename?: 'Mutation' }
  & { updateOneVetInfo: (
    { __typename?: 'VetInfo' }
    & ClinicUserVetInfoFragment
  ) }
);

export type UpdateLeftNavPanelToggleMutationVariables = Exact<{
  data: UserSettingUpdateInput;
  where: UserSettingWhereUniqueInput;
}>;


export type UpdateLeftNavPanelToggleMutation = (
  { __typename?: 'Mutation' }
  & { updateOneUserSetting: (
    { __typename?: 'UserSetting' }
    & Pick<UserSetting, 'leftNavPanel'>
  ) }
);

export type UpdateOneClinicPetParentMutationVariables = Exact<{
  where: ClinicPetParentWhereUniqueInput;
  data: ClinicPetParentUpdateInput;
}>;


export type UpdateOneClinicPetParentMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinicPetParent: (
    { __typename?: 'ClinicPetParent' }
    & ClinicPetParentSelectionFragment
  ) }
);

export type ClinicPetParentSelectionWithEnqueuePhoneNumberLookupMutationFragment = (
  { __typename?: 'ClinicPetParentWithJobChainsResponse' }
  & { clinicPetParent: (
    { __typename?: 'ClinicPetParent' }
    & Pick<ClinicPetParent, 'id' | 'email' | 'firstName' | 'lastName' | 'isActive' | 'updatedAt' | 'pimsId'>
    & { phoneNumbers: Array<(
      { __typename?: 'ClinicEntityPhoneNumber' }
      & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'isPrimary' | 'isMobile' | 'isDeleted' | 'updatedAt'>
    )> }
    & PetParentAvatarFragment
  ), jobChains?: Maybe<Array<Maybe<(
    { __typename?: 'JobChain' }
    & Pick<JobChain, 'id' | 'name'>
  )>>> }
);

export type UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutationVariables = Exact<{
  where: ClinicPetParentWhereUniqueInput;
  data: ClinicPetParentUpdateInput;
}>;


export type UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation = (
  { __typename?: 'Mutation' }
  & { updateOneClinicPetParentAndEnqueuePhoneNumberLookup: (
    { __typename?: 'ClinicPetParentWithJobChainsResponse' }
    & ClinicPetParentSelectionWithEnqueuePhoneNumberLookupMutationFragment
  ) }
);

export type CreateStripeAccountSessionQueryVariables = Exact<{
  data: StripeCreateAccountSessionInput;
}>;


export type CreateStripeAccountSessionQuery = (
  { __typename?: 'Query' }
  & { stripeCreateAccountSession?: Maybe<(
    { __typename?: 'StripeCreateAccountSessionOutput' }
    & Pick<StripeCreateAccountSessionOutput, 'account' | 'clientSecret' | 'expiresAt'>
  )> }
);

export type FindManyChannelQueryVariables = Exact<{
  where?: Maybe<ChannelWhereInput>;
  orderBy?: Maybe<Array<Maybe<ChannelOrderByWithRelationInput>> | Maybe<ChannelOrderByWithRelationInput>>;
}>;


export type FindManyChannelQuery = (
  { __typename?: 'Query' }
  & { findManyChannel: Array<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id'>
  )> }
);

export type FindManyDisputesCountQueryVariables = Exact<{
  where?: Maybe<StripeDisputeWhereInput>;
}>;


export type FindManyDisputesCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyStripeDisputeCount'>
);

export type GetAllClinicChannelStatusesQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetAllClinicChannelStatusesQuery = (
  { __typename?: 'Query' }
  & { findManyChannelStatus: Array<(
    { __typename?: 'ChannelStatus' }
    & FullChannelStatusFragment
  )> }
);

export type GetCareCreditMessageTemplateQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetCareCreditMessageTemplateQuery = (
  { __typename?: 'Query' }
  & { findFirstMessageTemplate?: Maybe<(
    { __typename?: 'MessageTemplate' }
    & FullMessageTemplateFragment
  )> }
);

export type GetCareCreditPreapprovalChecksQueryVariables = Exact<{
  clinicPetParentIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetCareCreditPreapprovalChecksQuery = (
  { __typename?: 'Query' }
  & { findManyCareCreditPreapprovalCheck: Array<(
    { __typename?: 'CareCreditPreapprovalCheck' }
    & Pick<CareCreditPreapprovalCheck, 'id' | 'createdAt' | 'decision' | 'preapprovalUrl' | 'offerExpiresAt' | 'applicationStatus'>
  )> }
);

export type WorkflowEventSettingSelectionFragment = (
  { __typename?: 'WorkflowEventSetting' }
  & Pick<WorkflowEventSetting, 'id' | 'isPublished' | 'visitType' | 'sendingHours' | 'automatedTriggerType' | 'automatedTriggerInMinutes' | 'event' | 'groupByWindowInHours' | 'name' | 'workflowType' | 'triggerType' | 'createdAt' | 'notificationBody' | 'timeFormat' | 'surveySettingId' | 'surveyStep'>
  & { appointmentTypes: Array<(
    { __typename?: 'AppointmentType' }
    & Pick<AppointmentType, 'id' | 'name'>
  )>, clinicEmployees: Array<(
    { __typename?: 'ClinicEmployeeToWorkflowEventSetting' }
    & Pick<ClinicEmployeeToWorkflowEventSetting, 'clinicEmployeeId'>
    & { clinicEmployee: (
      { __typename?: 'ClinicEmployee' }
      & Pick<ClinicEmployee, 'id' | 'firstName' | 'lastName'>
    ) }
  )>, clinicRooms: Array<(
    { __typename?: 'ClinicRoomToWorkflowEventSetting' }
    & Pick<ClinicRoomToWorkflowEventSetting, 'clinicRoomId'>
    & { clinicRoom: (
      { __typename?: 'ClinicRoom' }
      & Pick<ClinicRoom, 'id' | 'name'>
    ) }
  )>, actions: Array<(
    { __typename?: 'WorkflowEventAction' }
    & Pick<WorkflowEventAction, 'id' | 'actionType' | 'promptType' | 'config' | 'order' | 'channelStatusChangeId' | 'workflowEventTriggerDelayInMilliseconds' | 'workflowEventTrigger' | 'workflowEventTriggerActionNumber'>
    & { channelStatusChange?: Maybe<(
      { __typename?: 'ChannelStatus' }
      & Pick<ChannelStatus, 'id'>
    )> }
  )>, clinic?: Maybe<(
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id'>
  )>, widgetRequestTypes: Array<(
    { __typename?: 'ClinicWidgetRequestType' }
    & Pick<ClinicWidgetRequestType, 'id' | 'order' | 'displayName' | 'requestType'>
  )>, triggeringFormTemplates: Array<(
    { __typename?: 'FormTemplate' }
    & Pick<FormTemplate, 'id' | 'title'>
  )> }
);

export type GetClinicAutomationsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetClinicAutomationsQuery = (
  { __typename?: 'Query' }
  & { findManyWorkflowEventSetting: Array<(
    { __typename?: 'WorkflowEventSetting' }
    & WorkflowEventSettingSelectionFragment
  )> }
);

export type ClinicFormTemplateFragment = (
  { __typename?: 'FormTemplate' }
  & Pick<FormTemplate, 'id' | 'isActive' | 'isDeleted' | 'content' | 'draftContent' | 'title' | 'createdAt' | 'updatedAt' | 'formTemplateType' | 'autoExportEnabled'>
  & { services: Array<(
    { __typename?: 'Service' }
    & Pick<Service, 'id' | 'name'>
  )>, clinicWidgetRequestTypes: Array<(
    { __typename?: 'ClinicWidgetRequestType' }
    & Pick<ClinicWidgetRequestType, 'id' | 'displayName' | 'requestType'>
  )>, clinic?: Maybe<(
    { __typename?: 'Clinic' }
    & Pick<Clinic, 'id' | 'hasServiceReminders'>
  )> }
);

export type GetClinicFormTemplatesQueryVariables = Exact<{
  where: FormTemplateWhereInput;
}>;


export type GetClinicFormTemplatesQuery = (
  { __typename?: 'Query' }
  & { findManyFormTemplate: Array<(
    { __typename?: 'FormTemplate' }
    & ClinicFormTemplateFragment
  )> }
);

export type ClinicPimsIntegrationFragment = (
  { __typename?: 'ClinicPimsIntegration' }
  & Pick<ClinicPimsIntegration, 'id' | 'type' | 'isActive' | 'lastSyncedAt' | 'status'>
  & { vetdata?: Maybe<(
    { __typename?: 'VetDataIntegration' }
    & Pick<VetDataIntegration, 'id' | 'system' | 'isMultiSite'>
  )>, bitwerx?: Maybe<(
    { __typename?: 'BitwerxIntegration' }
    & Pick<BitwerxIntegration, 'id' | 'practiceId' | 'system'>
  )>, syncvet?: Maybe<(
    { __typename?: 'SyncVetIntegration' }
    & Pick<SyncVetIntegration, 'id' | 'system' | 'originalSystem'>
  )>, capabilities: Array<(
    { __typename?: 'ClinicPimsIntegrationCapability' }
    & Pick<ClinicPimsIntegrationCapability, 'id' | 'capability' | 'isActive' | 'lastSyncedAt'>
  )> }
);

export type ClinicUserClinicFragment = (
  { __typename?: 'Clinic' }
  & Pick<Clinic, 'id' | 'createdAt' | 'name' | 'phone' | 'submerchantStripeId' | 'submerchantStripeChargesEnabled' | 'submerchantStripePayoutsEnabled' | 'isClinicEligibleForPayments' | 'timezoneName' | 'logo' | 'fullAddress' | 'websiteUrl' | 'clinicEmail' | 'addressLine1' | 'addressLine2' | 'postalCode' | 'country' | 'city' | 'state' | 'isCallerIdVerified' | 'hasSmsConversations' | 'hasServiceReminders' | 'activationDate' | 'isClinicActive' | 'crmId' | 'organizationId' | 'isAddAppointmentDisabled' | 'carePlanProviderGroupId'>
  & { roles: Array<(
    { __typename?: 'StaffRole' }
    & Pick<StaffRole, 'id' | 'role'>
    & { permissions: Array<(
      { __typename?: 'Permission' }
      & Pick<Permission, 'id' | 'type'>
    )> }
  )>, productPackageSubscriptions: Array<(
    { __typename?: 'ProductPackageSubscription' }
    & Pick<ProductPackageSubscription, 'id' | 'startAt' | 'endAt'>
    & { productPackage: (
      { __typename?: 'ProductPackage' }
      & Pick<ProductPackage, 'id' | 'name'>
    ) }
  )>, clinicModules: Array<(
    { __typename?: 'ClinicModule' }
    & Pick<ClinicModule, 'id'>
    & { module: (
      { __typename?: 'Module' }
      & Pick<Module, 'id' | 'name'>
    ) }
  )>, integrations: Array<(
    { __typename?: 'ClinicPimsIntegration' }
    & ClinicPimsIntegrationFragment
  )>, clinicOfficeHours: Array<(
    { __typename?: 'ClinicOfficeHour' }
    & Pick<ClinicOfficeHour, 'id' | 'type' | 'dayOfWeek' | 'openAt' | 'closeAt' | 'isEnabled' | 'isOpenTwentyFourHours'>
  )>, clinicSetting?: Maybe<(
    { __typename?: 'ClinicSetting' }
    & Pick<ClinicSetting, 'id' | 'appointmentTimeSlotIncrementInMinutes' | 'hasCustomizableFees' | 'hideAppointmentsWithoutPetOwner' | 'outOfOfficeHeadline' | 'outOfOfficeEnabled' | 'outOfOfficeShowScheduleEnabled' | 'aiRecapWritebackEnabled'>
    & { paymentFeeConfig?: Maybe<(
      { __typename?: 'ClinicPaymentFeeConfiguration' }
      & Pick<ClinicPaymentFeeConfiguration, 'id' | 'onlineProcessingFeeFlat' | 'onlineProcessingFeePercent' | 'onlineClientServiceFeePercent' | 'terminalProcessingFeeFlat' | 'terminalProcessingFeePercent' | 'terminalClientServiceFeePercent'>
    )> }
  )>, stripeTerminalLocations: Array<(
    { __typename?: 'StripeTerminalLocation' }
    & Pick<StripeTerminalLocation, 'id' | 'stripeId' | 'isActive'>
    & { terminals: Array<(
      { __typename?: 'StripeTerminal' }
      & Pick<StripeTerminal, 'id' | 'name' | 'model'>
    )> }
  )>, axionClinicConfiguration?: Maybe<(
    { __typename?: 'AxionClinicConfiguration' }
    & Pick<AxionClinicConfiguration, 'id' | 'domain' | 'status'>
  )>, carePlanProviderGroup?: Maybe<(
    { __typename?: 'CarePlanProviderGroup' }
    & Pick<CarePlanProviderGroup, 'id' | 'launchStatus' | 'paymentProcessorClinicId'>
  )>, twilioConfiguration?: Maybe<(
    { __typename?: 'TwilioConfiguration' }
    & Pick<TwilioConfiguration, 'messagingServiceSid' | 'subaccountSid'>
  )>, payoutBatchingSetting?: Maybe<(
    { __typename?: 'PayoutBatchingSetting' }
    & Pick<PayoutBatchingSetting, 'id' | 'isAutomated'>
  )> }
);

export type ClinicUserVetInfoFragment = (
  { __typename?: 'VetInfo' }
  & Pick<VetInfo, 'id' | 'createdAt' | 'updatedAt'>
  & { roles: Array<(
    { __typename?: 'StaffRole' }
    & Pick<StaffRole, 'id' | 'role'>
    & { clinic?: Maybe<(
      { __typename?: 'Clinic' }
      & Pick<Clinic, 'id' | 'name'>
    )>, permissions: Array<(
      { __typename?: 'Permission' }
      & Pick<Permission, 'id' | 'type'>
    )> }
  )>, currentClinic?: Maybe<(
    { __typename?: 'Clinic' }
    & ClinicUserClinicFragment
  )> }
);

export type ClinicUserFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'firstName' | 'lastName' | 'displayName' | 'nameDisplay' | 'profilePic' | 'email' | 'phone' | 'type' | 'invitationCode' | 'isNewPasswordRequired' | 'isAdmin'>
  & { userSetting?: Maybe<(
    { __typename?: 'UserSetting' }
    & Pick<UserSetting, 'id' | 'pushNotifications' | 'smsNotifications' | 'emailNotifications' | 'leftNavPanel' | 'snoozeNotificationsUntil' | 'enterAddsNewLine' | 'skipLoadingAnimation' | 'hideSummaryButton'>
    & { browserNotificationFilter?: Maybe<(
      { __typename?: 'ChannelSelection' }
      & Pick<ChannelSelection, 'id' | 'includeUnassigned'>
      & { assignees: Array<(
        { __typename?: 'User' }
        & Pick<User, 'id'>
      )> }
    )>, notificationSettings: Array<(
      { __typename?: 'UserNotificationSetting' }
      & Pick<UserNotificationSetting, 'id' | 'soundNotificationUrl' | 'browserNotificationEnabled'>
    )> }
  )>, clinics: Array<(
    { __typename?: 'Clinic' }
    & ClinicUserClinicFragment
  )>, vetInfo?: Maybe<(
    { __typename?: 'VetInfo' }
    & ClinicUserVetInfoFragment
  )>, axionClinicUserConfigurations: Array<(
    { __typename?: 'AxionClinicUserConfiguration' }
    & Pick<AxionClinicUserConfiguration, 'id' | 'clinicId' | 'extension'>
  )> }
);

export type GetClinicUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClinicUserQuery = (
  { __typename?: 'Query' }
  & { clinicUser?: Maybe<(
    { __typename?: 'User' }
    & ClinicUserFragment
  )> }
);

export type GetClinicUsersQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetClinicUsersQuery = (
  { __typename?: 'Query' }
  & { users: Array<(
    { __typename?: 'User' }
    & Pick<User, 'firebaseId' | 'email'>
    & ClinicUserAvatarFragment
  )> }
);

export type GetPaginatedAppointmentsQueryVariables = Exact<{
  where: AppointmentWhereInput;
  take: Scalars['Int'];
  skip: Scalars['Int'];
  orderBy?: Maybe<Array<Maybe<AppointmentOrderByWithRelationInput>> | Maybe<AppointmentOrderByWithRelationInput>>;
  countOnly: Scalars['Boolean'];
}>;


export type GetPaginatedAppointmentsQuery = (
  { __typename?: 'Query' }
  & { count: Query['findManyAppointmentCount'] }
  & { appointments: Maybe<Array<(
    { __typename?: 'Appointment' }
    & Pick<Appointment, 'id' | 'pimsId' | 'startAt' | 'description' | 'durationInMinutes' | 'title' | 'status' | 'pimsStatus' | 'channelId'>
    & { integration?: Maybe<(
      { __typename?: 'ClinicPimsIntegration' }
      & Pick<ClinicPimsIntegration, 'type'>
    )>, appointmentType?: Maybe<(
      { __typename?: 'AppointmentType' }
      & Pick<AppointmentType, 'id' | 'name' | 'displayName'>
    )>, channel?: Maybe<(
      { __typename?: 'Channel' }
      & Pick<Channel, 'id' | 'updatedAt'>
      & { lastMessage?: Maybe<(
        { __typename?: 'ChannelMessage' }
        & Pick<ChannelMessage, 'id' | 'createdAt'>
      )>, channelStatus?: Maybe<(
        { __typename?: 'ChannelStatus' }
        & ChannelListChannelStatusFragment
      )> }
    )>, clinicPet?: Maybe<(
      { __typename?: 'ClinicPet' }
      & Pick<ClinicPet, 'id' | 'computed_rawPimsIsDeceased' | 'computed_rawPimsIsActive' | 'computedIsDeceased' | 'computedIsActive' | 'isDeceased' | 'isActive' | 'name' | 'breed' | 'species' | 'speciesType' | 'photoUrl'>
    )>, clinicPetParents: Array<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
      & { phoneNumbers: Array<(
        { __typename?: 'ClinicEntityPhoneNumber' }
        & Pick<ClinicEntityPhoneNumber, 'id' | 'number' | 'updatedAt' | 'isPrimary' | 'isDeleted'>
      )> }
    )> }
  )>> }
);

export type PetParentChannelFragment = (
  { __typename?: 'Channel' }
  & Pick<Channel, 'id' | 'updatedAt'>
  & { channelStatus?: Maybe<(
    { __typename?: 'ChannelStatus' }
    & Pick<ChannelStatus, 'id' | 'name' | 'color' | 'channelStatusAction'>
  )>, lastMessage?: Maybe<(
    { __typename?: 'ChannelMessage' }
    & Pick<ChannelMessage, 'id' | 'createdAt' | 'index' | 'body'>
    & { attachments: Array<(
      { __typename?: 'ChannelMessageAttachment' }
      & Pick<ChannelMessageAttachment, 'id' | 'attachmentType' | 'entityType'>
    )> }
  )> }
);

export type GetPetParentChannelsQueryVariables = Exact<{
  clinicPetParentId: Scalars['String'];
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type GetPetParentChannelsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyChannelCount'>
  & { findManyChannel: Array<(
    { __typename?: 'Channel' }
    & PetParentChannelFragment
  )> }
);

export type GetStripePaymentIntentQueryVariables = Exact<{
  where: StripePaymentIntentWhereUniqueInput;
}>;


export type GetStripePaymentIntentQuery = (
  { __typename?: 'Query' }
  & { stripePaymentIntent?: Maybe<(
    { __typename?: 'StripePaymentIntent' }
    & StripePaymentIntentFragment
  )>, stripePaymentOutput?: Maybe<(
    { __typename?: 'StripePaymentOutput' }
    & StripePaymentOutputFragment
  )> }
);

export type SubscribeToStripePaymentIntentChangedSubscriptionVariables = Exact<{
  where: SubscriptionStripePaymentIntentWhereInput;
}>;


export type SubscribeToStripePaymentIntentChangedSubscription = (
  { __typename?: 'Subscription' }
  & { stripePaymentIntentChanged: (
    { __typename?: 'StripePaymentIntentSubscription' }
    & { node: (
      { __typename?: 'StripePaymentIntent' }
      & StripePaymentIntentFragment
    ) }
  ) }
);

export type SubscriptionChannelMessageFragment = (
  { __typename?: 'ChannelMessage' }
  & Pick<ChannelMessage, 'id' | 'body' | 'messageType'>
  & { attachments: Array<(
    { __typename?: 'ChannelMessageAttachment' }
    & Pick<ChannelMessageAttachment, 'id' | 'attachmentType'>
  )>, mentionedUsers: Array<(
    { __typename?: 'User' }
    & Pick<User, 'firstName' | 'lastName' | 'id'>
  )>, channel?: Maybe<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'id' | 'channelType'>
    & { assignees: Array<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )>, lastMessage?: Maybe<(
      { __typename?: 'ChannelMessage' }
      & Pick<ChannelMessage, 'id'>
    )>, channelStatus?: Maybe<(
      { __typename?: 'ChannelStatus' }
      & Pick<ChannelStatus, 'id' | 'channelStatusAction'>
    )> }
  )>, author?: Maybe<(
    { __typename?: 'ChannelMember' }
    & Pick<ChannelMember, 'id' | 'twilioIdentity'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    )>, clinicPetParent?: Maybe<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
    )> }
  )> }
);

export type SubscribeToClinicUserChannelMessagesSubscriptionVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type SubscribeToClinicUserChannelMessagesSubscription = (
  { __typename?: 'Subscription' }
  & { channelMessageChanged: (
    { __typename?: 'ChannelMessageSubscription' }
    & Pick<ChannelMessageSubscription, 'mutation'>
    & { node: (
      { __typename?: 'ChannelMessage' }
      & SubscriptionChannelMessageFragment
    ) }
  ) }
);

export type SubscribeToClinicUserChannelsSubscriptionVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type SubscribeToClinicUserChannelsSubscription = (
  { __typename?: 'Subscription' }
  & { channelChanged: (
    { __typename?: 'ChannelSubscription' }
    & { node: (
      { __typename?: 'Channel' }
      & Pick<Channel, 'id' | 'friendlyName'>
      & { assignees: Array<(
        { __typename?: 'User' }
        & Pick<User, 'id'>
      )>, channelStatus?: Maybe<(
        { __typename?: 'ChannelStatus' }
        & Pick<ChannelStatus, 'id' | 'color' | 'name' | 'channelStatusAction'>
      )> }
    ) }
  ) }
);

export type SubscribeToFormSubmissionSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;


export type SubscribeToFormSubmissionSubscription = (
  { __typename?: 'Subscription' }
  & { formSubmissionChanged?: Maybe<(
    { __typename?: 'FormSubmissionSubscription' }
    & { node: (
      { __typename?: 'FormSubmission' }
      & Pick<FormSubmission, 'id' | 'submittedAt'>
    ) }
  )> }
);

export type SubscribeToUiRefreshSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToUiRefreshSubscription = (
  { __typename?: 'Subscription' }
  & { uiRefresh?: Maybe<(
    { __typename?: 'UiRefresh' }
    & Pick<UiRefresh, 'refreshType' | 'message' | 'metadata'>
  )> }
);

export type SubscribeToUnreadMessageCountChangedSubscriptionVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type SubscribeToUnreadMessageCountChangedSubscription = (
  { __typename?: 'Subscription' }
  & { unreadMessageCountChanged: (
    { __typename?: 'ChannelSubscription' }
    & { node: (
      { __typename?: 'Channel' }
      & Pick<Channel, 'id'>
      & { assignees: Array<(
        { __typename?: 'User' }
        & Pick<User, 'id'>
      )>, channelStatus?: Maybe<(
        { __typename?: 'ChannelStatus' }
        & Pick<ChannelStatus, 'id' | 'channelStatusAction'>
      )> }
    ) }
  ) }
);

export type SharedUpdateUserSettingMutationVariables = Exact<{
  data: UserSettingUpdateInput;
  where: UserSettingWhereUniqueInput;
}>;


export type SharedUpdateUserSettingMutation = (
  { __typename?: 'Mutation' }
  & { updateOneUserSetting: (
    { __typename?: 'UserSetting' }
    & Pick<UserSetting, 'id' | 'snoozeNotificationsUntil'>
    & { browserNotificationFilter?: Maybe<(
      { __typename?: 'ChannelSelection' }
      & Pick<ChannelSelection, 'id' | 'includeUnassigned'>
      & { assignees: Array<(
        { __typename?: 'User' }
        & Pick<User, 'id'>
      )> }
    )>, notificationSettings: Array<(
      { __typename?: 'UserNotificationSetting' }
      & Pick<UserNotificationSetting, 'id' | 'emailEnabled' | 'smsEnabled' | 'soundNotificationUrl' | 'browserNotificationEnabled' | 'pushNotificationEnabled'>
    )> }
  ) }
);

export type GetMostRecentSyncDataQueryVariables = Exact<{
  where?: Maybe<IntegrationOutageHistoryEntryWhereInput>;
}>;


export type GetMostRecentSyncDataQuery = (
  { __typename?: 'Query' }
  & { findFirstIntegrationOutageHistoryEntry?: Maybe<(
    { __typename?: 'IntegrationOutageHistoryEntry' }
    & Pick<IntegrationOutageHistoryEntry, 'status' | 'id' | 'createdAt'>
  )> }
);

export type SubscribeToSyncOutagesSubscriptionVariables = Exact<{
  where: IntegrationOutageHistoryEntryWhereInput;
}>;


export type SubscribeToSyncOutagesSubscription = (
  { __typename?: 'Subscription' }
  & { integrationOutageHistoryEntryChanged: (
    { __typename?: 'IntegrationOutageHistoryEntrySubscription' }
    & { node: (
      { __typename?: 'IntegrationOutageHistoryEntry' }
      & Pick<IntegrationOutageHistoryEntry, 'id' | 'createdAt' | 'status'>
    ) }
  ) }
);

export type CreateCallHistoryAndParticipantsMutationVariables = Exact<{
  data: CreateCallHistoryInput;
}>;


export type CreateCallHistoryAndParticipantsMutation = (
  { __typename?: 'Mutation' }
  & { createCallHistory?: Maybe<(
    { __typename?: 'CallHistory' }
    & Pick<CallHistory, 'id' | 'sourceId' | 'type' | 'from' | 'direction' | 'status' | 'provider'>
    & { clinic: (
      { __typename?: 'Clinic' }
      & Pick<Clinic, 'name'>
    ) }
  )> }
);

export type CreateOneCallParticipantMutationVariables = Exact<{
  data: CallParticipantCreateInput;
}>;


export type CreateOneCallParticipantMutation = (
  { __typename?: 'Mutation' }
  & { createOneCallParticipant: (
    { __typename?: 'CallParticipant' }
    & Pick<CallParticipant, 'id' | 'number'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id'>
    )>, clinicPetParent?: Maybe<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id'>
    )>, callHistory: (
      { __typename?: 'CallHistory' }
      & Pick<CallHistory, 'id'>
    ) }
  ) }
);

export type CreateOneCallRecordingMutationVariables = Exact<{
  callSid: Scalars['String'];
}>;


export type CreateOneCallRecordingMutation = (
  { __typename?: 'Mutation' }
  & { createOneCallRecording?: Maybe<(
    { __typename?: 'CallRecording' }
    & Pick<CallRecording, 'id'>
  )> }
);

export type CreateTwilioTokenMutationVariables = Exact<{
  identity: Scalars['String'];
}>;


export type CreateTwilioTokenMutation = (
  { __typename?: 'Mutation' }
  & { createTwilioToken: (
    { __typename?: 'CreateTwilioTokenResponse' }
    & Pick<CreateTwilioTokenResponse, 'token'>
  ) }
);

export type EndAxionPhoneCallMutationVariables = Exact<{
  callId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type EndAxionPhoneCallMutation = (
  { __typename?: 'Mutation' }
  & { endOneAxionCall?: Maybe<(
    { __typename?: 'AxionCallOutput' }
    & Pick<AxionCallOutput, 'result'>
  )> }
);

export type IgnoreAxionPhoneCallMutationVariables = Exact<{
  callId: Scalars['String'];
  userId: Scalars['String'];
  action: IgnoreCallAction;
}>;


export type IgnoreAxionPhoneCallMutation = (
  { __typename?: 'Mutation' }
  & { ignoreOneAxionCall?: Maybe<(
    { __typename?: 'AxionCallOutput' }
    & Pick<AxionCallOutput, 'result'>
  )> }
);

export type UpdateOneCallHistoryMutationVariables = Exact<{
  where: CallHistoryWhereUniqueInput;
  data: CallHistoryUpdateInput;
}>;


export type UpdateOneCallHistoryMutation = (
  { __typename?: 'Mutation' }
  & { updateOneCallHistory: (
    { __typename?: 'CallHistory' }
    & Pick<CallHistory, 'id' | 'status' | 'duration'>
  ) }
);

export type UpdateOneCallRecordingMutationVariables = Exact<{
  where: CallRecordingWhereUniqueInput;
  data: CallRecordingUpdateInput;
}>;


export type UpdateOneCallRecordingMutation = (
  { __typename?: 'Mutation' }
  & { updateOneCallRecording?: Maybe<(
    { __typename?: 'CallRecording' }
    & Pick<CallRecording, 'id'>
  )> }
);

export type PhoneCallParticipantFragment = (
  { __typename?: 'ClinicPetParent' }
  & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName' | 'email'>
  & { phoneNumbers: Array<(
    { __typename?: 'ClinicEntityPhoneNumber' }
    & Pick<ClinicEntityPhoneNumber, 'id' | 'updatedAt' | 'number' | 'isPrimary' | 'isMobile'>
  )>, pets: Array<(
    { __typename?: 'ClinicPet' }
    & Pick<ClinicPet, 'id' | 'name' | 'species' | 'speciesType' | 'gender' | 'dateOfBirth'>
    & { appointments: Array<(
      { __typename?: 'Appointment' }
      & Pick<Appointment, 'id' | 'startAt' | 'durationInMinutes'>
      & { appointmentType?: Maybe<(
        { __typename?: 'AppointmentType' }
        & Pick<AppointmentType, 'id' | 'name'>
      )> }
    )>, serviceReminders: Array<(
      { __typename?: 'ServiceReminder' }
      & SidePanelPetServiceRemindersFragment
    )> }
  )>, channelMembers: Array<(
    { __typename?: 'ChannelMember' }
    & Pick<ChannelMember, 'id'>
    & { channel?: Maybe<(
      { __typename?: 'Channel' }
      & PetParentChannelFragment
    )> }
  )> }
);

export type GetPhoneCallParticipantQueryVariables = Exact<{
  clinicPetParentId: Scalars['String'];
  eventsAfter: Scalars['DateTime'];
  eventsBefore: Scalars['DateTime'];
  clinicId: Scalars['String'];
}>;


export type GetPhoneCallParticipantQuery = (
  { __typename?: 'Query' }
  & { findUniqueClinicPetParent?: Maybe<(
    { __typename?: 'ClinicPetParent' }
    & PhoneCallParticipantFragment
  )> }
);

export type GetTwilioPhoneTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTwilioPhoneTokenQuery = (
  { __typename?: 'Query' }
  & { twilioCapabilityToken?: Maybe<(
    { __typename?: 'TwilioCapabilityToken' }
    & Pick<TwilioCapabilityToken, 'token'>
  )> }
);

export type CallHistorySelectionFragment = (
  { __typename?: 'CallHistory' }
  & Pick<CallHistory, 'id' | 'sourceId' | 'provider' | 'type' | 'status' | 'from' | 'to' | 'direction'>
  & { participants: Array<(
    { __typename?: 'CallParticipant' }
    & Pick<CallParticipant, 'id' | 'number' | 'extension' | 'result'>
    & { clinicPetParent?: Maybe<(
      { __typename?: 'ClinicPetParent' }
      & Pick<ClinicPetParent, 'id' | 'firstName' | 'lastName'>
    )>, user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    )> }
  )> }
);

export type SubscribeToCallHistoryChangedSubscriptionVariables = Exact<{
  clinicId: Scalars['String'];
  extension?: Maybe<Scalars['String']>;
}>;


export type SubscribeToCallHistoryChangedSubscription = (
  { __typename?: 'Subscription' }
  & { callHistoryChanged: (
    { __typename?: 'CallHistorySubscription' }
    & Pick<CallHistorySubscription, 'mutation'>
    & { node: (
      { __typename?: 'CallHistory' }
      & CallHistorySelectionFragment
    ) }
  ) }
);

export type GetTerminalTokenQueryVariables = Exact<{
  where: StripeTerminalLocationUniqueInput;
}>;


export type GetTerminalTokenQuery = (
  { __typename?: 'Query' }
  & { getTerminalToken?: Maybe<(
    { __typename?: 'StripeTerminalTokenOutput' }
    & Pick<StripeTerminalTokenOutput, 'secret'>
  )> }
);

export type StripePayoutSelectionFragment = (
  { __typename?: 'StripePayout' }
  & Pick<StripePayout, 'id' | 'amount' | 'arrivalDate' | 'initiatedAt' | 'status'>
  & { payoutBatchingPeriod?: Maybe<(
    { __typename?: 'PayoutBatchingPeriod' }
    & Pick<PayoutBatchingPeriod, 'id' | 'endsAt'>
  )> }
);

export type FindManyStripePayoutQueryVariables = Exact<{
  where: StripePayoutWhereInput;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type FindManyStripePayoutQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'findManyStripePayoutCount'>
  & { findManyStripePayout: Array<(
    { __typename?: 'StripePayout' }
    & StripePayoutSelectionFragment
  )> }
);

export type GetClinicChannelStatusesQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type GetClinicChannelStatusesQuery = (
  { __typename?: 'Query' }
  & { findManyChannelStatus: Array<(
    { __typename?: 'ChannelStatus' }
    & FullChannelStatusFragment
  )> }
);

export type GetUniqueChannelStatusQueryVariables = Exact<{
  where: ChannelStatusWhereUniqueInput;
}>;


export type GetUniqueChannelStatusQuery = (
  { __typename?: 'Query' }
  & { findUniqueChannelStatus?: Maybe<(
    { __typename?: 'ChannelStatus' }
    & FullChannelStatusFragment
  )> }
);

export type GetClinicPaymentActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClinicPaymentActivityQuery = (
  { __typename?: 'Query' }
  & { clinicPaymentActivity?: Maybe<(
    { __typename?: 'ClinicPaymentActivityOutput' }
    & Pick<ClinicPaymentActivityOutput, 'success' | 'error' | 'totalRecentTransactions' | 'totalRecentCentsProcessed'>
  )> }
);

export type GetUnreadMessageCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadMessageCountQuery = (
  { __typename?: 'Query' }
  & { channelUnreadMessageCount?: Maybe<(
    { __typename?: 'ChannelUnreadMessageCountResult' }
    & Pick<ChannelUnreadMessageCountResult, 'total'>
    & { unreadChannels: Array<(
      { __typename?: 'UnreadMessageChannel' }
      & Pick<UnreadMessageChannel, 'channelId' | 'channelLastMessageIndex' | 'lastConsumedMessageIndex' | 'unreadMessageCount' | 'channelType'>
    )>, client?: Maybe<(
      { __typename?: 'ChannelCountResult' }
      & Pick<ChannelCountResult, 'total'>
      & { unreadChannels: Array<(
        { __typename?: 'UnreadMessageChannel' }
        & Pick<UnreadMessageChannel, 'channelId' | 'channelLastMessageIndex' | 'lastConsumedMessageIndex' | 'unreadMessageCount' | 'channelType'>
      )> }
    )>, team?: Maybe<(
      { __typename?: 'ChannelCountResult' }
      & Pick<ChannelCountResult, 'total'>
      & { unreadChannels: Array<(
        { __typename?: 'UnreadMessageChannel' }
        & Pick<UnreadMessageChannel, 'channelId' | 'channelLastMessageIndex' | 'lastConsumedMessageIndex' | 'unreadMessageCount' | 'channelType'>
      )> }
    )> }
  )> }
);

export const AppointmentBaseFragmentDoc = gql`
    fragment AppointmentBase on Appointment {
  id
  createdAt
  updatedAt
  description
  recapNotes
  durationInMinutes
  pimsId
  startAt
  consultationId
  integrationId
  appointmentTypeId
  isActive
  isDeleted
  title
  clinicPetId
  clinicId
  roomId
  status
  pimsStatus
  channelId
  recapNotesUpdatedAt
  recapNotesUpdatedBy {
    id
    firstName
    lastName
  }
}
    `;
export const AppointmentTypeBaseSelectionFragmentDoc = gql`
    fragment AppointmentTypeBaseSelection on AppointmentType {
  id
  createdAt
  updatedAt
  name
  isVisible
}
    `;
export const ClinicRoomBaseSelectionFragmentDoc = gql`
    fragment ClinicRoomBaseSelection on ClinicRoom {
  id
  createdAt
  updatedAt
  name
  isVisible
}
    `;
export const ClinicEmployeeBaseSelectionFragmentDoc = gql`
    fragment ClinicEmployeeBaseSelection on ClinicEmployee {
  id
  createdAt
  updatedAt
  firstName
  lastName
  isVisible
}
    `;
export const CareSubscriptionFragmentDoc = gql`
    fragment CareSubscription on CareStripeSubscription {
  id
  paymentStatus
  nextBillingDate
  stripePaymentMethod {
    id
    last4
    stripeId
    cardBrand
    expirationMonth
    expirationYear
    isExpired
  }
}
    `;
export const EnrollmentTrueUpsFragmentDoc = gql`
    fragment EnrollmentTrueUps on CareSubscriptionTrueUp {
  id
  dueAt
  completedAt
  retryAt
  amount
  shouldCancelEnrollment
}
    `;
export const CareEnrollmentFragmentDoc = gql`
    fragment CareEnrollment on CarePlanEnrollment {
  id
  planId
  status
  startDate
  autoRenews
  expirationDate
  careStripeSubscriptionId
  careStripeSubscription {
    paymentStatus
  }
  renewalSuccessorEnrollment {
    id
  }
  plan {
    id
    title
    flowAlias
    planBenefits {
      id
      benefitId
      displayOrder
    }
  }
  planPricing {
    id
    pricePerRenewal
    billingCycle
  }
  careSubscriptionTrueUps(
    where: {type: {equals: Internal}}
    orderBy: {dueAt: asc}
  ) {
    ...EnrollmentTrueUps
  }
  enrollmentPayments(where: {paidAt: {not: null}}) {
    id
    amount
    applicationFeeAmount
    paidAt
    stripeDispute {
      status
    }
  }
}
    ${EnrollmentTrueUpsFragmentDoc}`;
export const SidePanelOrganizationPetFragmentDoc = gql`
    fragment SidePanelOrganizationPet on OrganizationPet {
  id
  associatedSubscriptions(
    where: {paymentStatus: {notIn: [Open, Draft]}}
    orderBy: {createdAt: desc}
  ) {
    ...CareSubscription
  }
  carePlanEnrollments(orderBy: {expirationDate: desc}) {
    ...CareEnrollment
  }
}
    ${CareSubscriptionFragmentDoc}
${CareEnrollmentFragmentDoc}`;
export const PetAvatarFragmentDoc = gql`
    fragment PetAvatar on ClinicPet {
  id
  computed_rawPimsIsDeceased
  computed_rawPimsIsActive
  computedIsDeceased @client
  computedIsActive @client
  isDeceased
  isActive
  name
  photoUrl
  rawPimsValue
  species
  speciesType
  organizationPet {
    ...SidePanelOrganizationPet
  }
}
    ${SidePanelOrganizationPetFragmentDoc}`;
export const OrganizationPetCareBadgePlanEnrollmentFragmentDoc = gql`
    fragment OrganizationPetCareBadgePlanEnrollment on ClinicPet {
  id
  organizationPet {
    ...SidePanelOrganizationPet
  }
}
    ${SidePanelOrganizationPetFragmentDoc}`;
export const ClinicPetSelectionFragmentDoc = gql`
    fragment ClinicPetSelection on ClinicPet {
  id
  breed
  gender
  isActive
  isDeleted
  dateOfBirth
  speciesType
  weight
  weightUnit
  ...PetAvatar
  ...OrganizationPetCareBadgePlanEnrollment
  alerts {
    value
    pimsDate
    pimsId
    isMedical
  }
}
    ${PetAvatarFragmentDoc}
${OrganizationPetCareBadgePlanEnrollmentFragmentDoc}`;
export const PetParentAvatarFragmentDoc = gql`
    fragment PetParentAvatar on ClinicPetParent {
  id
  firstName
  lastName
  creationSource
  isTest
}
    `;
export const ClinicPetParentSelectionFragmentDoc = gql`
    fragment ClinicPetParentSelection on ClinicPetParent {
  id
  email
  firstName
  lastName
  isActive
  updatedAt
  ...PetParentAvatar
  pimsId
  phoneNumbers {
    id
    number
    isPrimary
    isMobile
    isDeleted
    updatedAt
  }
}
    ${PetParentAvatarFragmentDoc}`;
export const ClinicPetNestedSelectionFragmentDoc = gql`
    fragment ClinicPetNestedSelection on ClinicPet {
  ...ClinicPetSelection
  petParents(where: {isActive: {equals: true}, isDeleted: {equals: false}}) {
    ...ClinicPetParentSelection
  }
}
    ${ClinicPetSelectionFragmentDoc}
${ClinicPetParentSelectionFragmentDoc}`;
export const AppointmentFullSelectionFragmentDoc = gql`
    fragment AppointmentFullSelection on Appointment {
  ...AppointmentBase
  workflows {
    id
    name
  }
  channel {
    id
    channelStatus {
      id
      name
      color
      channelStatusAction
    }
  }
  appointmentType {
    ...AppointmentTypeBaseSelection
  }
  room {
    ...ClinicRoomBaseSelection
  }
  clinicEmployees {
    ...ClinicEmployeeBaseSelection
  }
  clinicPet {
    ...ClinicPetNestedSelection
  }
  clinicPetParents(where: {isActive: {equals: true}, isDeleted: {equals: false}}) {
    ...ClinicPetParentSelection
  }
}
    ${AppointmentBaseFragmentDoc}
${AppointmentTypeBaseSelectionFragmentDoc}
${ClinicRoomBaseSelectionFragmentDoc}
${ClinicEmployeeBaseSelectionFragmentDoc}
${ClinicPetNestedSelectionFragmentDoc}
${ClinicPetParentSelectionFragmentDoc}`;
export const AppointmentPetFragmentDoc = gql`
    fragment AppointmentPet on ClinicPet {
  id
  breed
  dateOfBirth
  gender
  ...PetAvatar
  petParents(where: {isDeleted: {not: {equals: true}}}) {
    id
    firstName
    lastName
    clinicId
    phoneNumbers {
      id
      number
      isPrimary
      isMobile
      isDeleted
      updatedAt
    }
    email
    updatedAt
  }
}
    ${PetAvatarFragmentDoc}`;
export const AppointmentTypeWorkflowsSelectionFragmentDoc = gql`
    fragment AppointmentTypeWorkflowsSelection on AppointmentType {
  ...AppointmentTypeBaseSelection
  workflows {
    id
    name
    workflowType
    event
  }
}
    ${AppointmentTypeBaseSelectionFragmentDoc}`;
export const AutomationsListItemFragmentDoc = gql`
    fragment AutomationsListItem on WorkflowEventSetting {
  id
  name
  isPublished
  sendingHours
  triggerType
  event
  childRunEvaluationStatus
  messagingCampaignId
  conditionSets {
    id
    conditions {
      id
    }
  }
}
    `;
export const AutomationsParentItemFragmentDoc = gql`
    fragment AutomationsParentItem on WorkflowEventSetting {
  id
  name
  isPublished
}
    `;
export const AutomationEditorAutomationFragmentDoc = gql`
    fragment AutomationEditorAutomation on WorkflowEventSetting {
  id
  name
  isPublished
  triggerType
  visitType
  sendingHours
  automatedTriggerType
  automatedTriggerInMinutes
  automatedTriggerTimeOfDay
  event
  notificationBody
  timeFormat
  triggeringFormTemplates {
    id
    title
  }
  widgetRequestTypes {
    id
    displayName
  }
  appointmentTypes {
    id
    displayName
    name
  }
  clinicRooms {
    clinicRoomId
    clinicRoom {
      id
      name
    }
  }
  clinicEmployees {
    clinicEmployeeId
    clinicEmployee {
      id
      firstName
      lastName
    }
  }
  actions(orderBy: {order: asc}) {
    id
    config
    promptType
    order
    channelStatusChangeId
    workflowEventTriggerDelayInMilliseconds
    workflowEventTriggerActionNumber
    triggerWorkflowId
  }
  conditionSets {
    id
  }
}
    `;
export const AutomationEditorConditionFragmentDoc = gql`
    fragment AutomationEditorCondition on Condition {
  id
  createdAt
  attribute
  operator
  operand
  checksum
}
    `;
export const AutomationEditorConditionSetFragmentDoc = gql`
    fragment AutomationEditorConditionSet on ConditionSet {
  id
  conditionalEntityType
  conditionalEntityId
  parentConditionSetId
  operator
  negate
  conditions {
    ...AutomationEditorCondition
  }
}
    ${AutomationEditorConditionFragmentDoc}`;
export const AutomationsSelectionListAutomationFragmentDoc = gql`
    fragment AutomationsSelectionListAutomation on WorkflowEventSetting {
  ...AutomationEditorAutomation
  conditionSets {
    ...AutomationEditorConditionSet
  }
}
    ${AutomationEditorAutomationFragmentDoc}
${AutomationEditorConditionSetFragmentDoc}`;
export const BoardPetParentFragmentDoc = gql`
    fragment BoardPetParent on ClinicPetParent {
  id
  ...PetParentAvatar
  phoneNumbers {
    id
    number
    updatedAt
    isPrimary
    isDeleted
  }
}
    ${PetParentAvatarFragmentDoc}`;
export const ChannelFilterSelectionFragmentDoc = gql`
    fragment ChannelFilterSelection on ChannelFilterSelection {
  id
  isDeleted
  name
  filters
  filterSelectionType
  userChannelFilterSelections(where: {isFilterOwner: {equals: true}}) {
    id
    isFilterOwner
    user {
      id
      firstName
      lastName
    }
  }
}
    `;
export const ChatEntityAppointmentFragmentDoc = gql`
    fragment ChatEntityAppointment on Appointment {
  id
  createdAt
  description
  startAt
  durationInMinutes
  clinicEmployees {
    id
    firstName
    lastName
  }
  appointmentType {
    id
    name
  }
}
    `;
export const ChatEntityFormSubmissionFragmentDoc = gql`
    fragment ChatEntityFormSubmission on FormSubmission {
  id
  createdAt
  submittedAt
  formTemplate {
    title
  }
  clinicPetParentId
}
    `;
export const DocumentationFragmentDoc = gql`
    fragment Documentation on Documentation {
  id
  createdAt
  updatedAt
  provider
  category
  title
  url
}
    `;
export const ClinicUserAvatarFragmentDoc = gql`
    fragment ClinicUserAvatar on User {
  id
  firstName
  lastName
  displayName @client
  nameDisplay
  profilePic
}
    `;
export const TeamMemberMentionsListFragmentDoc = gql`
    fragment TeamMemberMentionsList on User {
  id
  ...ClinicUserAvatar
}
    ${ClinicUserAvatarFragmentDoc}`;
export const ChannelListChannelPetFragmentDoc = gql`
    fragment ChannelListChannelPet on ClinicPet {
  id
  ...PetAvatar
  pimsId
}
    ${PetAvatarFragmentDoc}`;
export const ChannelListChannelStatusFragmentDoc = gql`
    fragment ChannelListChannelStatus on ChannelStatus {
  id
  name
  color
  channelStatusAction
}
    `;
export const ChannelListChannelMemberPetParentFragmentDoc = gql`
    fragment ChannelListChannelMemberPetParent on ClinicPetParent {
  id
  firstName
  lastName
  pimsId
  ...PetParentAvatar
}
    ${PetParentAvatarFragmentDoc}`;
export const ChannelListChannelMemberFragmentDoc = gql`
    fragment ChannelListChannelMember on ChannelMember {
  id
  lastConsumedMessageIndex
  twilioMemberSid
  twilioIdentity
  removedAt
  clinicPetParent {
    id
    ...ChannelListChannelMemberPetParent
  }
}
    ${ChannelListChannelMemberPetParentFragmentDoc}`;
export const ChannelListChannelLastMessageFragmentDoc = gql`
    fragment ChannelListChannelLastMessage on ChannelMessage {
  id
  createdAt
  deletedAt
  index
  body
  attachments {
    id
    attachmentType
    entityType
  }
}
    `;
export const ChannelPinFragmentDoc = gql`
    fragment ChannelPin on ChannelPin {
  id
  userId
  createdAt
}
    `;
export const ChannelListChannelFragmentDoc = gql`
    fragment ChannelListChannel on Channel {
  id
  updatedAt
  lastExportAt
  tags
  pets {
    ...ChannelListChannelPet
  }
  channelStatus {
    id
    ...ChannelListChannelStatus
  }
  channelMembers(
    where: {clinicPetParentId: {not: {equals: null}}, removedAt: {equals: null}}
  ) {
    ...ChannelListChannelMember
  }
  lastMessage {
    ...ChannelListChannelLastMessage
  }
  creationSource {
    id
    creationSource
  }
  channelPins {
    ...ChannelPin
  }
}
    ${ChannelListChannelPetFragmentDoc}
${ChannelListChannelStatusFragmentDoc}
${ChannelListChannelMemberFragmentDoc}
${ChannelListChannelLastMessageFragmentDoc}
${ChannelPinFragmentDoc}`;
export const TeletriageConversationFragmentDoc = gql`
    fragment TeletriageConversation on Channel {
  ...ChannelListChannel
  clinic {
    id
    name
  }
}
    ${ChannelListChannelFragmentDoc}`;
export const TeletriageStatusFragmentDoc = gql`
    fragment TeletriageStatus on TeletriageChannelStatus {
  channelStatusAction
  color
  name
}
    `;
export const TeletriageClinicFragmentDoc = gql`
    fragment TeletriageClinic on Clinic {
  id
  name
}
    `;
export const ChannelViewClinicPetFragmentDoc = gql`
    fragment ChannelViewClinicPet on ClinicPet {
  id
  pimsId
  ...PetAvatar
}
    ${PetAvatarFragmentDoc}`;
export const ChannelViewClinicPetParentFragmentDoc = gql`
    fragment ChannelViewClinicPetParent on ClinicPetParent {
  id
  pimsId
  firstName
  lastName
  email
  isActive
  isDeleted
  ...PetParentAvatar
  pets(
    take: 30
    where: {clinicId: {equals: $clinicId}, isActive: {equals: true}, isDeleted: {equals: false}, OR: [{NOT: {isDeceased: {equals: true}}}, {isDeceased: null}]}
  ) {
    id
    ...ChannelViewClinicPet
  }
  phoneNumbers {
    id
    number
    isPrimary
    isMobile
    isDeleted
    updatedAt
    smsStatus
  }
  petParentSetting {
    id
    smsNotifications
    emailNotifications
    emailOptedOutByPetParent
    pushNotifications
  }
}
    ${PetParentAvatarFragmentDoc}
${ChannelViewClinicPetFragmentDoc}`;
export const ChannelViewChannelMemberFragmentDoc = gql`
    fragment ChannelViewChannelMember on ChannelMember {
  id
  lastConsumedMessageIndex
  twilioMemberSid
  twilioIdentity
  removedAt
  clinicPetParent {
    id
    ...ChannelViewClinicPetParent
  }
  user {
    id
    firstName
    lastName
    profilePic
    email
    vetInfo {
      id
      roles(orderBy: {id: asc}) {
        id
        role
      }
    }
    type
  }
}
    ${ChannelViewClinicPetParentFragmentDoc}`;
export const ChannelViewChannelStatusFragmentDoc = gql`
    fragment ChannelViewChannelStatus on ChannelStatus {
  id
  name
  color
  channelStatusAction
}
    `;
export const ChannelViewChannelPetFragmentDoc = gql`
    fragment ChannelViewChannelPet on ClinicPet {
  id
  pimsId
  petParents {
    id
  }
  ...PetAvatar
  ...OrganizationPetCareBadgePlanEnrollment
}
    ${PetAvatarFragmentDoc}
${OrganizationPetCareBadgePlanEnrollmentFragmentDoc}`;
export const ChannelViewChannelFragmentDoc = gql`
    fragment ChannelViewChannel on Channel {
  id
  createdAt
  creationSource {
    id
    creationSource
  }
  updatedAt
  isActive
  attributes
  twilioChannelSid
  friendlyName
  channelType
  channelVisibility
  channelMembers(
    where: {channelId: {equals: $channelId}, OR: [{clinicPetParentId: {not: {equals: null}}}, {userId: {equals: $userId}}]}
  ) {
    ...ChannelViewChannelMember
  }
  channelStatus {
    ...ChannelViewChannelStatus
  }
  assignees {
    id
  }
  clinicId
  pets {
    ...ChannelViewChannelPet
  }
}
    ${ChannelViewChannelMemberFragmentDoc}
${ChannelViewChannelStatusFragmentDoc}
${ChannelViewChannelPetFragmentDoc}`;
export const PetUsageByBenefitFragmentDoc = gql`
    fragment PetUsageByBenefit on UsageByBenefit {
  provided
  used
  exhausted
  displayOrder
  sources {
    planIds
    addonIds
  }
  benefit {
    id
    title
    tangible
    exhaustible
    providedDiscountPercentage
    usageUnitOfMeasure
  }
}
    `;
export const PetUsageFragmentDoc = gql`
    fragment PetUsage on PetBenefitUsage {
  organizationPetId
  usages {
    ...PetUsageByBenefit
  }
}
    ${PetUsageByBenefitFragmentDoc}`;
export const CalculateMultiplePetsBenefitUsageFragmentDoc = gql`
    fragment CalculateMultiplePetsBenefitUsage on CalculateMultiplePetsBenefitUsageOutput {
  petUsages {
    ...PetUsage
  }
}
    ${PetUsageFragmentDoc}`;
export const ChannelPetFragmentDoc = gql`
    fragment ChannelPet on ClinicPet {
  id
  pimsId
  speciesType
  ...PetAvatar
}
    ${PetAvatarFragmentDoc}`;
export const ChannelViewChannelMessageAttachmentFragmentDoc = gql`
    fragment ChannelViewChannelMessageAttachment on ChannelMessageAttachment {
  id
  attachmentType
  entityType
  entityId
  filename
  uploadStatus
  url
}
    `;
export const SmsNotificationStatusFragmentDoc = gql`
    fragment SmsNotificationStatus on SmsNotificationStatus {
  id
  createdAt
  updatedAt
  status
  receivingNumber
  sourceContactEntityId
  sourceContactEntityType
  provider
  providerMessageId
  errorType
  providerErrorData
  sentChannelMessageId
}
    `;
export const ReactionFragmentDoc = gql`
    fragment Reaction on ChannelMessageReaction {
  id
  createdAt
  deletedAt
  reaction
  userId
  user {
    id
    namePrefix
    nameDisplay
    firstName
    lastName
    nameSuffix
  }
}
    `;
export const ChannelViewChannelMessageFragmentDoc = gql`
    fragment ChannelViewChannelMessage on ChannelMessage {
  id
  createdAt
  updatedAt
  deletedAt
  index
  body
  messageType
  forceReadReceipt
  mentionedUsers {
    firstName
    lastName
    nameDisplay
  }
  source
  attachments {
    ...ChannelViewChannelMessageAttachment
  }
  smsNotifificationStatuses {
    ...SmsNotificationStatus
  }
  author {
    id
    twilioIdentity
    user {
      id
      firstName
      lastName
      profilePic
      nameDisplay
      type
    }
    clinicPetParent {
      id
      firstName
      lastName
      ...PetParentAvatar
      phoneNumbers {
        id
        number
        isPrimary
        isMobile
        isDeleted
        updatedAt
      }
      petParentSetting {
        id
        smsNotifications
      }
    }
  }
  channel {
    id
  }
  attributes
  reactions(orderBy: {createdAt: asc}) {
    ...Reaction
  }
  sourcePhoneNumber
}
    ${ChannelViewChannelMessageAttachmentFragmentDoc}
${SmsNotificationStatusFragmentDoc}
${PetParentAvatarFragmentDoc}
${ReactionFragmentDoc}`;
export const ChannelViewClientDropdownClinicPetParentFragmentDoc = gql`
    fragment ChannelViewClientDropdownClinicPetParent on ClinicPetParent {
  id
  firstName
  lastName
  isActive
  isDeleted
  ...PetParentAvatar
  pets {
    id
    name
    speciesType
    isActive
    isDeceased
  }
  channelMembers {
    id
    removedAt
    channel {
      id
      channelStatus {
        id
        channelStatusAction
      }
    }
  }
}
    ${PetParentAvatarFragmentDoc}`;
export const ExportabilityCheckChannelFragmentDoc = gql`
    fragment ExportabilityCheckChannel on Channel {
  id
  pets {
    id
    pimsId
    speciesType
  }
  channelMembers {
    id
    clinicPetParent {
      id
      pimsId
      pets(where: {clinicId: {equals: $clinicId}}) {
        id
        pimsId
        speciesType
      }
    }
  }
}
    `;
export const MessageComposerFormTemplateFragmentDoc = gql`
    fragment MessageComposerFormTemplate on FormTemplate {
  id
  title
  isActive
  isDeleted
  formTemplateType
  content
}
    `;
export const MessageComposerMessageTemplateFragmentDoc = gql`
    fragment MessageComposerMessageTemplate on MessageTemplate {
  id
  name
  type
  body
  isArchived
  attachments
}
    `;
export const DemoWorkflowAppintmentWorkflowFragmentDoc = gql`
    fragment DemoWorkflowAppintmentWorkflow on WorkflowEventSetting {
  id
  name
  event
  isPublished
  createdAt
  surveySettingId
  surveyStep
  surveyType
}
    `;
export const DemoWorkflowAppointmentFragmentDoc = gql`
    fragment DemoWorkflowAppointment on Appointment {
  id
  description
  workflows {
    ...DemoWorkflowAppintmentWorkflow
  }
  isDeleted
  createdAt
  startAt
  clinicPet {
    speciesType
    name
  }
}
    ${DemoWorkflowAppintmentWorkflowFragmentDoc}`;
export const LoyaltyProgramRewardFragmentDoc = gql`
    fragment LoyaltyProgramReward on LoyaltyReward {
  id
  title
  description
  pointCost
  availability
}
    `;
export const ServiceFromIntegrationIdFragmentDoc = gql`
    fragment ServiceFromIntegrationId on Service {
  id
  name
  code
  pimsName
}
    `;
export const PointGranterServiceFragmentDoc = gql`
    fragment PointGranterService on LoyaltyProgram {
  id
  status
  pointGranters {
    id
    enabled
    allowAllServices
    grantingServices {
      serviceId
      service {
        ...ServiceFromIntegrationId
      }
    }
  }
}
    ${ServiceFromIntegrationIdFragmentDoc}`;
export const FullMessageTemplateFragmentDoc = gql`
    fragment FullMessageTemplate on MessageTemplate {
  id
  createdAt
  updatedAt
  updatedBy {
    id
    firstName
    lastName
  }
  name
  type
  body
  isArchived
  attachments
}
    `;
export const EmailCampaignFragmentDoc = gql`
    fragment EmailCampaign on EmailCampaign {
  id
  createdAt
  updatedAt
  deletedAt
  name
  subject
  from
  status
  htmlContent
  unlayerJson
  segmentArgs
  createdByUser {
    id
    firstName
    lastName
    nameDisplay
    email
  }
  sentByUser {
    id
    firstName
    lastName
    nameDisplay
    email
  }
  lastUpdatedByUser {
    id
    firstName
    lastName
    nameDisplay
    email
  }
  totalSegmentContacts
  replyToJson
  segmentationType
  customList {
    id
    awsFileKey
    fileName
    validRecipients
    invalidRecipients
  }
  uploads {
    id
    expiresAt
    fileName
    awsFileKey
  }
}
    `;
export const EmailCampaignTemplateFragmentDoc = gql`
    fragment EmailCampaignTemplate on EmailCampaignTemplate {
  id
  name
  htmlContent
  unlayerJson
}
    `;
export const PaymentReportFinancialTransactionFragmentDoc = gql`
    fragment PaymentReportFinancialTransaction on PaymentsReportTransaction {
  transactionId
  clinicId
  stripePaymentIntentId
  stripeInvoiceId
  stripeDisputeId
  stripeRefundId
  stripePayoutId
  financialAdjustmentId
  clientName
  stripePaymentIntentStripeId
  paymentRelationship
  invoiceIdentifiers
  writebackStatus
  writebackError
  clientPimsId
  clientPetParentId
  clientPetParentEmail
  type
  paymentStatus
  timestamp
  arrivalDate
  amount
  clientFee
  totalInvoiced
  transactionFees
  netProceeds
  sentBy
  terminalId
  terminalName
  paymentMedium
  cardBrand
  cardType
  last4
  channelId
  refundReason
  stripeRefundPaymentIntentAmount
  financialAdjustmentDescription
  stripePaymentIntentAmountCaptured
  paymentIdentifier
  stripeReceiptId
  stripePaymentIntentPaidAt
  stripePaymentIntentTotalRefunded
  invoiceId
}
    `;
export const PayoutBatchingPeriodFragmentDoc = gql`
    fragment PayoutBatchingPeriod on PayoutBatchingPeriod {
  id
  createdAt
  updatedAt
  startsAt
  endsAt
  createdByUserId
  clinicId
}
    `;
export const StripeDisputeSelectionFragmentDoc = gql`
    fragment StripeDisputeSelection on StripeDispute {
  id
  createdAt
  amount
  status
  stripeDisputeReason
  associatedTransferStripePaymentId
  financialTransaction {
    id
    channelId
  }
  stripePaymentIntent {
    id
    stripeId
    paidAt
    invoices(orderBy: {createdAt: desc}, take: 1) {
      id
    }
    clinicPetParent {
      id
      firstName
      lastName
    }
    financialTransaction {
      id
      type
    }
  }
  careEnrollmentPayment {
    id
    paidAt
    stripeInvoice {
      id
      stripeCustomer {
        id
        organizationPetParents {
          id
          clinicPetParents {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `;
export const PayoutBatchingSettingsFragmentDoc = gql`
    fragment PayoutBatchingSettings on PayoutBatchingSetting {
  id
  updatedAt
  isAutomated
  schedules {
    id
    dayOfWeek
    endTime
  }
  updatedByUser {
    id
    namePrefix
    firstName
    lastName
  }
}
    `;
export const RefundModalPaymentIntentFragmentDoc = gql`
    fragment RefundModalPaymentIntent on StripePaymentIntent {
  id
  stripeId
  amount
  total
  status
  createdAt
  paidAt
  clientServiceFee
  clientServiceFeePercent
  stripeRefunds {
    id
    amount
    clientFeeRefunded
  }
  clinicPetParent {
    id
    firstName
    lastName
  }
}
    `;
export const FailedWritebackAppointmentFragmentDoc = gql`
    fragment FailedWritebackAppointment on Appointment {
  id
  aiRecapPimsWritebackLogEntry(
    orderBy: {writebackLog: {createdAt: desc}}
    take: 1
  ) {
    writebackLog {
      id
      status
      updatedAt
    }
  }
  clinicPet {
    name
  }
  clinicPetParents {
    firstName
    lastName
  }
}
    `;
export const ExclusionRuleSelectionFragmentDoc = gql`
    fragment ExclusionRuleSelection on DirectBookingExclusionRule {
  id
  name
  isActive
  appointmentTypes {
    id
    name
    displayName
  }
  providers {
    id
    firstName
    lastName
  }
  timeSlots {
    id
    updatedAt
    dayOfWeek
    startTime
    endTime
  }
}
    `;
export const ProviderFragmentDoc = gql`
    fragment Provider on ClinicEmployee {
  id
  firstName
  lastName
  pimsId
}
    `;
export const AppointmentTypeFragmentDoc = gql`
    fragment AppointmentType on AppointmentType {
  id
  name
  displayName
  displayOrder
  showInPetPortal
  description
  isAvailableForDirectBooking
  defaultDurationInMinutes
  defaultSoonestAvailableBookingInHours
  delayedStartTime
  hasDeposit
  depositAmount
  markPaymentAsDeposit
  directBookingAppointmentTypeSetting {
    id
    clientType
  }
  clinicEmployeeAppointmentTypeSettings {
    clinicEmployee {
      ...Provider
    }
  }
}
    ${ProviderFragmentDoc}`;
export const RoomFragmentDoc = gql`
    fragment Room on ClinicRoom {
  id
  name
  type
  pimsId
}
    `;
export const ClinicSettingsConversationsChannelStatusChannelAssigneeFragmentDoc = gql`
    fragment ClinicSettingsConversationsChannelStatusChannelAssignee on ChannelStatusChannelAssignee {
  id
  user {
    id
  }
}
    `;
export const ClinicSettingsConversationsChannelStatusFragmentDoc = gql`
    fragment ClinicSettingsConversationsChannelStatus on ChannelStatus {
  id
  createdAt
  updatedAt
  channelStatusAction
  color
  deletedOn
  isDefault
  name
  order
  isExportedToPims
  channelStatusChannelAssignees {
    ...ClinicSettingsConversationsChannelStatusChannelAssignee
  }
}
    ${ClinicSettingsConversationsChannelStatusChannelAssigneeFragmentDoc}`;
export const ClinicSettingsConversationsRuleFragmentDoc = gql`
    fragment ClinicSettingsConversationsRule on Rules {
  action
  clinicId
  createdAt
  id
  options
  updatedAt
}
    `;
export const VisualizerAutomationActionFragmentDoc = gql`
    fragment VisualizerAutomationAction on WorkflowEventAction {
  id
  createdAt
  updatedAt
  actionType
  config
  order
  triggerWorkflowId
  workflowEventTriggerActionNumber
  workflowEventSettingId
  channelStatusChangeId
  responseChannelStatusChangeId
  promptType
}
    `;
export const VisualizerAutomationFragmentDoc = gql`
    fragment VisualizerAutomation on WorkflowEventSetting {
  id
  name
  actions {
    ...VisualizerAutomationAction
  }
}
    ${VisualizerAutomationActionFragmentDoc}`;
export const EmergencyClinicsFragmentDoc = gql`
    fragment EmergencyClinics on EmergencyClinics {
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  phone
  clinicSettingId
  isDeleted
  fullAddress
  displayOrder
}
    `;
export const ClinicOfficeHourSelectionFragmentDoc = gql`
    fragment ClinicOfficeHourSelection on ClinicOfficeHour {
  id
  closeAt
  dayOfWeek
  isEnabled
  isOpenTwentyFourHours
  openAt
  type
}
    `;
export const LegalEntityFragmentDoc = gql`
    fragment LegalEntity on LegalEntity {
  id
  ein
  type
  name
  clinics {
    id
  }
}
    `;
export const ClinicSettingsNotificationsUserSettingsFragmentDoc = gql`
    fragment ClinicSettingsNotificationsUserSettings on UserSetting {
  id
  browserNotificationFilter {
    id
    assignees {
      id
    }
    includeUnassigned
  }
  snoozeNotificationsUntil
  notificationSettings {
    id
    emailEnabled
    smsEnabled
    soundNotificationUrl
    browserNotificationEnabled
    pushNotificationEnabled
  }
}
    `;
export const UserSettingsDataFragmentDoc = gql`
    fragment UserSettingsData on User {
  id
  namePrefix
  nameSuffix
  phone
  email
  firebaseId
  ...ClinicUserAvatar
  vetInfo {
    id
  }
}
    ${ClinicUserAvatarFragmentDoc}`;
export const PimsPaymentTypeSelectionFragmentDoc = gql`
    fragment PimsPaymentTypeSelection on PimsPaymentType {
  id
  pimsId
  isInactive
  isDeleted
  description
}
    `;
export const ReminderSettingsServiceTimingFragmentDoc = gql`
    fragment ReminderSettingsServiceTiming on ServiceReminderTiming {
  id
  timingType
  offset
  offsetUnit
  hourOfDay
  minuteOfHour
  isEmail
  isSms
  isPush
}
    `;
export const ReminderSettingsServiceFragmentDoc = gql`
    fragment ReminderSettingsService on Service {
  id
  code
  name
  formTemplateId
  pimsName
  pimsId
  formTemplateId
  isPetPortal
  isPostcard
  reminderActivationDate
  reminderTimings(where: {isDeleted: {equals: false}}) {
    ...ReminderSettingsServiceTiming
  }
}
    ${ReminderSettingsServiceTimingFragmentDoc}`;
export const ReminderSettingsWorkflowEventSettingFragmentDoc = gql`
    fragment ReminderSettingsWorkflowEventSetting on WorkflowEventSetting {
  id
  actions {
    id
    config
    channelStatusChange {
      id
      name
      color
    }
  }
}
    `;
export const ClinicSettingsTeamUserFragmentDoc = gql`
    fragment ClinicSettingsTeamUser on User {
  id
  ...ClinicUserAvatar
  namePrefix
  nameSuffix
  invitedAt
  invitationCode
  email
  phone
  type
  vetInfo {
    id
    roles(where: {clinicId: {equals: $clinicId}}) {
      id
      role
    }
  }
}
    ${ClinicUserAvatarFragmentDoc}`;
export const ClinicBlockedPhoneNumberFragmentDoc = gql`
    fragment ClinicBlockedPhoneNumber on ClinicBlockedPhoneNumber {
  id
  clinicId
  phoneNumber
  createdAt
  updatedAt
  blockedBy {
    id
    nameDisplay
    firstName
    lastName
  }
  unblockedBy {
    id
    nameDisplay
    firstName
    lastName
  }
  notes
}
    `;
export const ClinicPhoneNumberFragmentDoc = gql`
    fragment ClinicPhoneNumber on ClinicPhoneNumber {
  id
  capability
  provider
  isPrimary
  isActive
  isVerified
  isDeleted
  number
  status
  loaSignedAt
  loaSignedByUserId
  loaUrl
  incomingCarrier
  portingOrderId
}
    `;
export const ConnectSettingsClinicWidgetRequestTypeFragmentDoc = gql`
    fragment ConnectSettingsClinicWidgetRequestType on ClinicWidgetRequestType {
  id
  order
  isActive
  isDeleted
  displayName
  requestType
  requestVisibility
  shouldCreateTask
  formTemplate {
    id
    title
    clinicWidgetRequestTypes {
      id
    }
  }
  assignees {
    id
    ...ClinicUserAvatar
  }
  channelStatus {
    id
    name
  }
}
    ${ClinicUserAvatarFragmentDoc}`;
export const ConnectSettingsClinicWidgetSettingFragmentDoc = gql`
    fragment ConnectSettingsClinicWidgetSetting on ClinicWidgetSetting {
  clinicWidgetRequestTypes(where: {isDeleted: {equals: false}}) {
    ...ConnectSettingsClinicWidgetRequestType
  }
}
    ${ConnectSettingsClinicWidgetRequestTypeFragmentDoc}`;
export const StripePaymentIntentSelectionFragmentDoc = gql`
    fragment StripePaymentIntentSelection on StripePaymentIntent {
  id
  status
  amount
  amountCaptured
  serviceFeeAmount
  stripeId
  stripePaymentMethod {
    cardBrand
    last4
    type
  }
}
    `;
export const AutomationRunActionFragmentDoc = gql`
    fragment AutomationRunAction on AutomationRunAction {
  id
  createdAt
  updatedAt
  automationRunId
  automationRun {
    id
    status
    channelMessage {
      channel {
        id
      }
    }
  }
  automationAction {
    workflowEventSetting {
      id
      name
      surveyStep
      event
    }
    id
    config
  }
  petParent {
    id
    isDeleted
    isActive
  }
  promptType
  automationActionId
  body
  attachments
  actionType
  petParentId
  petId
  buttons
  channelStatusChangeId
  order
  automationAction {
    id
    config
  }
  formSubmission {
    id
    submittedAt
    clinicPetParent {
      id
      isDeleted
      isActive
    }
  }
  paymentIntent {
    total
    amount
    serviceFeeAmount
    paidAt
    ...StripePaymentIntentSelection
  }
  automationAction {
    workflowEventSetting {
      id
      name
    }
  }
}
    ${StripePaymentIntentSelectionFragmentDoc}`;
export const AutomationRunFragmentDoc = gql`
    fragment AutomationRun on AutomationRun {
  id
  status
  channelMessageId
  originAutomationId
  runType
  manuallySentById
  startedAt
  completedAt
  appointmentId
  formSubmissionId
  serviceReminderId
  clinicWidgetRequestId
  clinicPetParentId
  actions(orderBy: {createdAt: asc}) {
    ...AutomationRunAction
  }
  originAutomation {
    id
    name
  }
  channelMessage {
    channelId
  }
  tasks(orderBy: {createdAt: desc}) {
    id
    status
  }
}
    ${AutomationRunActionFragmentDoc}`;
export const CarePlanBenefitUsageFragmentDoc = gql`
    fragment CarePlanBenefitUsage on CarePlanBenefit {
  id
  providedDiscountPercentage
  benefitId
  planId
}
    `;
export const CarePlanBenefitSourceFragmentDoc = gql`
    fragment CarePlanBenefitSource on BenefitSource {
  addonIds
  planIds
}
    `;
export const FormSubmissionFragmentDoc = gql`
    fragment FormSubmission on FormSubmission {
  id
  clinicPet {
    id
    name
    createdAt
    updatedAt
    speciesType
    ...PetAvatar
  }
  clinicPetParent {
    id
    firstName
    lastName
    pets(
      where: {clinicId: {equals: $clinicId}, isActive: {equals: true}, isDeleted: {equals: false}, OR: [{NOT: {isDeceased: {equals: true}}}, {isDeceased: {equals: null}}]}
    ) {
      id
      name
      pimsId
      species
      speciesType
      createdAt
      updatedAt
      isDeceased
    }
  }
  submittedAt
  formTemplate {
    title
  }
  draftContent
  completedContent
  isCallDeflectionForm
}
    ${PetAvatarFragmentDoc}`;
export const UserAppointmentGroupingFullSelectionFragmentDoc = gql`
    fragment UserAppointmentGroupingFullSelection on UserAppointmentGrouping {
  id
  label
  clinicEmployees {
    id
  }
  rooms {
    id
  }
  appointmentTypes {
    id
  }
}
    `;
export const EmailTemplateVersionFragmentDoc = gql`
    fragment EmailTemplateVersion on EmailTemplateVersion {
  id
  html
  design
  previewImageUrl
  emailTemplateId
  isCurrent
  version
  lastEditedById
  lastEditedBy {
    firstName
    lastName
  }
  createdAt
  updatedAt
  deletedAt
  publishedAt
}
    `;
export const RecapBaseFragmentDoc = gql`
    fragment RecapBase on Recap {
  id
  createdAt
  updatedAt
  transcriptionS3Uri
  recordingS3Uri
  transcriptionText
  generatedText
  templateId
  status
  durationSeconds
  createdBy {
    id
    firstName
    lastName
    nameDisplay
  }
  appointment {
    id
    clinicPet {
      id
      name
    }
  }
}
    `;
export const AppointmentNoteTemplateFragmentFragmentDoc = gql`
    fragment AppointmentNoteTemplateFragment on AppointmentNoteTemplate {
  id
  name
  body
  clinicId
  updatedAt
  updatedBy {
    nameDisplay
    firstName
    lastName
  }
}
    `;
export const InvoicePetParentFragmentDoc = gql`
    fragment InvoicePetParent on ClinicPetParent {
  id
  email
  firstName
  lastName
  isActive
  lastName
  updatedAt
  creationSource
  phoneNumbers {
    id
    number
    isPrimary
    isMobile
    isDeleted
    updatedAt
  }
  pimsId
  pets(take: 20, where: $petWhere) {
    breed
    gender
    isDeleted
    speciesType
    weight
    clinicId
    dateOfBirth
    weightUnit
    ...PetAvatar
    pimsId
    petParents(where: {isActive: {equals: true}, isDeleted: {equals: false}}) {
      firstName
      id
      lastName
      phoneNumbers {
        id
        number
        isPrimary
        isMobile
        isDeleted
        updatedAt
      }
      email
      pimsId
    }
    alerts {
      value
      pimsDate
      pimsId
      isMedical
    }
  }
}
    ${PetAvatarFragmentDoc}`;
export const MassTextAleryActivityLogFragmentDoc = gql`
    fragment MassTextAleryActivityLog on MassTextAlert {
  id
  createdAt
  alertBody
  appointmentDateRangeType
  appointmentDateTimeFrom
  appointmentDateTimeTo
  createdByUser {
    id
    ...ClinicUserAvatar
  }
  status
}
    ${ClinicUserAvatarFragmentDoc}`;
export const CareAccountCreditIntentFragmentDoc = gql`
    fragment CareAccountCreditIntent on CareAccountCreditIntent {
  id
  invoiceId
  paymentDue
  careAccountCreditPimsWritebackLogEntries {
    writebackLogId
  }
}
    `;
export const CareBenefitUsageFollowUpFragmentDoc = gql`
    fragment CareBenefitUsageFollowUp on CareBenefitUsageFollowup {
  id
  careStripeSubscriptionId
  completed
  followupSteps(orderBy: {displayOrder: asc}) {
    id
    description
    completed
    displayOrder
    careAccountCreditIntents {
      ...CareAccountCreditIntent
    }
  }
}
    ${CareAccountCreditIntentFragmentDoc}`;
export const RecordingUserFragmentDoc = gql`
    fragment RecordingUser on User {
  id
  namePrefix
  firstName
  lastName
}
    `;
export const CareBenefitActivityUsageFragmentDoc = gql`
    fragment CareBenefitActivityUsage on CareBenefitUsage {
  id
  createdAt
  updatedAt
  usedAt
  quantityUsed
  exhaustsBenefit
  recordedByUser {
    ...RecordingUser
  }
  usageClinic {
    id
    name
  }
  benefit {
    id
    title
    description
    tangible
    exhaustible
    usageUnitOfMeasure
    type
  }
  invoiceLineItemConnections {
    id
    adjustedAmount
  }
}
    ${RecordingUserFragmentDoc}`;
export const ActivityLogCareEnrollmentFragmentDoc = gql`
    fragment ActivityLogCareEnrollment on CarePlanEnrollment {
  id
  startDate
  expirationDate
  cancelledAt
  renewalRejectionReason
  renewalEmailNoticeSentAt
  renewalSuccessorEnrollment {
    id
  }
  renewalPredecessorEnrollment {
    id
    plan {
      id
      title
      flowAlias
    }
  }
  plan {
    id
    title
    flowAlias
  }
}
    `;
export const ActivityLogEnrollmentSupportEventFragmentDoc = gql`
    fragment ActivityLogEnrollmentSupportEvent on EnrollmentSupportEvent {
  id
  createdAt
  requester {
    ...RecordingUser
  }
  carePlanEnrollmentId
  manageMembershipRequestType
  cancelReason
  amount
  paymentSchedule
  currentPlan {
    id
    flowAlias
    title
  }
  newPlan {
    id
    flowAlias
    title
  }
  transferFromPet {
    id
    preferredName
  }
  transferToPet {
    id
    preferredName
  }
  carePlanEnrollment {
    id
    careSubscriptionTrueUps(where: {type: {not: {equals: Internal}}}) {
      id
    }
  }
  manageMembershipDescription
}
    ${RecordingUserFragmentDoc}`;
export const ActivityLogCareEnrollmentPaymentFragmentDoc = gql`
    fragment ActivityLogCareEnrollmentPayment on CareEnrollmentPayment {
  id
  amount
  lastPaymentAttempt
  nextPaymentAttempt
  paidAt
  createdAt
  stripeInvoice {
    id
    lapsedPayment {
      id
      createdAt
    }
    stripePaymentMethod {
      last4
      cardBrand
      expirationMonth
      expirationYear
    }
  }
  stripeDispute {
    id
    status
    createdAt
  }
  stripeRefund {
    id
    createdAt
    amount
  }
}
    `;
export const CarePlanInfoFragmentDoc = gql`
    fragment CarePlanInfo on CarePlan {
  id
  title
  flowAlias
  planBenefits {
    id
    benefit {
      id
      type
      reportingExpectedValue
    }
  }
}
    `;
export const CarePlanPricingInfoFragmentDoc = gql`
    fragment CarePlanPricingInfo on CarePlanPricing {
  id
  pricePerRenewal
  renewalCycle
  billingCycle
  planDiscount
}
    `;
export const CareEnrollmentPaymentInfoFragmentDoc = gql`
    fragment CareEnrollmentPaymentInfo on CareEnrollmentPayment {
  id
  amount
  applicationFeeAmount
  paidAt
  stripeDispute {
    id
    status
  }
  stripeRefund {
    id
    amount
  }
}
    `;
export const BalanceForClientFragmentDoc = gql`
    fragment BalanceForClient on BitwerxClientBalance {
  currentBalance
  agingCurrent
  aging30D
  aging60D
  aging90D
  aging120D
}
    `;
export const StripePaymentIntentStatusFragmentDoc = gql`
    fragment StripePaymentIntentStatus on StripePaymentIntent {
  status
}
    `;
export const InvoiceForClientFragmentDoc = gql`
    fragment InvoiceForClient on Invoice {
  id
  status
  createdAt
  updatedAt
  subtotal
  taxes
  total
  date
  outstandingBalance
  currency
  sentBy {
    id
    nameDisplay
    firstName
    lastName
  }
  clinicPetParent {
    id
    firstName
    lastName
    email
    phoneNumber
  }
  identifier
  clinicPetParent {
    id
    email
    phoneNumber
    firstName
    lastName
  }
  stripePaymentIntents {
    ...StripePaymentIntentStatus
  }
  relatedInvoiceWritebacks {
    action
  }
}
    ${StripePaymentIntentStatusFragmentDoc}`;
export const ClinicCarePlanFragmentDoc = gql`
    fragment ClinicCarePlan on CarePlan {
  id
  title
  flowAlias
  description
  published
  planPricings {
    id
    pricePerRenewal
    renewalCycle
    billingCycle
    published
  }
}
    `;
export const ClinicCarePlanProviderGroupFragmentDoc = gql`
    fragment ClinicCarePlanProviderGroup on CarePlanProviderGroup {
  id
  associatedPlans(where: {published: {equals: true}}) {
    ...ClinicCarePlan
  }
}
    ${ClinicCarePlanFragmentDoc}`;
export const StripeTerminalClinicPetParentFragmentDoc = gql`
    fragment StripeTerminalClinicPetParent on ClinicPetParent {
  id
  firstName
  lastName
  email
  pimsId
}
    `;
export const CareBenefitPetParentFragmentDoc = gql`
    fragment CareBenefitPetParent on ClinicPetParent {
  ...StripeTerminalClinicPetParent
  ...PetParentAvatar
  organizationPetParent {
    id
    stripeCustomerTableId
  }
}
    ${StripeTerminalClinicPetParentFragmentDoc}
${PetParentAvatarFragmentDoc}`;
export const LoyaltyProgramRewardRedemptionFragmentDoc = gql`
    fragment LoyaltyProgramRewardRedemption on LoyaltyRewardRedemption {
  id
  createdAt
  reward {
    id
    title
    description
    pointCost
  }
}
    `;
export const RedemptionHistoryFragmentDoc = gql`
    fragment RedemptionHistory on LoyaltyRewardRedemptionHistoryEntry {
  id
  createdAt
  status
  actorType
  actingUser {
    id
    firstName
    lastName
  }
}
    `;
export const RewardHistoryFragmentDoc = gql`
    fragment RewardHistory on LoyaltyPointDelta {
  id
  createdAt
  source
  userGrant {
    id
    amount
    publicNotes
    internalNotes
    grantingUser {
      id
      firstName
      lastName
    }
  }
  points
  relatedRedemptionHistoryEntry {
    id
    redemption {
      id
      updatedAt
      status
      reward {
        id
        title
        pointCost
      }
      redemptionHistories {
        ...RedemptionHistory
      }
    }
  }
}
    ${RedemptionHistoryFragmentDoc}`;
export const SidePanelParentPetDataFragmentDoc = gql`
    fragment SidePanelParentPetData on ClinicPet {
  id
  pimsId
  weight
  clinicId
  ...PetAvatar
  organizationPet {
    ...SidePanelOrganizationPet
  }
}
    ${PetAvatarFragmentDoc}
${SidePanelOrganizationPetFragmentDoc}`;
export const SidePanelPetParentProfilePhoneNumberFragmentDoc = gql`
    fragment SidePanelPetParentProfilePhoneNumber on ClinicEntityPhoneNumber {
  id
  number
  isPrimary
  isMobile
  isDeleted
  updatedAt
  phoneNumberLookupResult {
    id
    lineType
  }
  phoneNumberLookupRequest {
    id
    status
  }
}
    `;
export const SidePanelProfilePetParentSettingFragmentDoc = gql`
    fragment SidePanelProfilePetParentSetting on PetParentSetting {
  id
  createdAt
  updatedAt
  emailNotifications
  emailOptedOutByPetParent
  smsNotifications
  smsOptedOutByPetParent
  sendSurvey
  pushNotifications
}
    `;
export const SidePanelProfileClinicPetParentFragmentDoc = gql`
    fragment SidePanelProfileClinicPetParent on ClinicPetParent {
  id
  email
  firstName
  lastName
  isActive
  createdAt
  updatedAt
  clinicId
  pimsId
  ...PetParentAvatar
  phoneNumbers {
    ...SidePanelPetParentProfilePhoneNumber
  }
  petParentSetting {
    ...SidePanelProfilePetParentSetting
  }
  pets(
    take: 30
    where: {clinicId: {equals: $clinicId}, isActive: {equals: true}, isDeleted: {equals: false}, OR: [{NOT: {isDeceased: {equals: true}}}, {isDeceased: {equals: null}}]}
  ) {
    id
    breed
    gender
    isActive
    isDeleted
    isDeceased
    dateOfBirth
    name
    species
    speciesType
    weight
    weightUnit
    isDeceased
    isActive
    photoUrl
    ...OrganizationPetCareBadgePlanEnrollment
    alerts {
      value
      pimsDate
      pimsId
      isMedical
    }
  }
  loyaltyAccountHolder {
    id
    program {
      id
      status
    }
    account {
      pointBalance
      rewardRedemptions {
        id
      }
    }
  }
}
    ${PetParentAvatarFragmentDoc}
${SidePanelPetParentProfilePhoneNumberFragmentDoc}
${SidePanelProfilePetParentSettingFragmentDoc}
${OrganizationPetCareBadgePlanEnrollmentFragmentDoc}`;
export const SidePanelSearchClinicEntityPhoneNumberFragmentDoc = gql`
    fragment SidePanelSearchClinicEntityPhoneNumber on ClinicEntityPhoneNumber {
  id
  number
  isPrimary
  isMobile
  isDeleted
  updatedAt
}
    `;
export const SidePanelSearchClinicPetFragmentDoc = gql`
    fragment SidePanelSearchClinicPet on ClinicPet {
  id
  pimsId
  speciesType
  breed
  gender
  isActive
  isDeleted
  ...PetAvatar
}
    ${PetAvatarFragmentDoc}`;
export const SidePanelSearchClinicPetParentFragmentDoc = gql`
    fragment SidePanelSearchClinicPetParent on ClinicPetParent {
  id
  updatedAt
  firstName
  lastName
  email
  isActive
  ...PetParentAvatar
  phoneNumbers(where: {isPrimary: {equals: true}}) {
    ...SidePanelSearchClinicEntityPhoneNumber
  }
  pimsId
  pets(take: 5, where: $petWhere) {
    ...SidePanelSearchClinicPet
  }
}
    ${PetParentAvatarFragmentDoc}
${SidePanelSearchClinicEntityPhoneNumberFragmentDoc}
${SidePanelSearchClinicPetFragmentDoc}`;
export const SidePanelPetFragmentDoc = gql`
    fragment SidePanelPet on ClinicPet {
  id
  breed
  gender
  ...PetAvatar
}
    ${PetAvatarFragmentDoc}`;
export const SidePanelPetParentFragmentDoc = gql`
    fragment SidePanelPetParent on ClinicPetParent {
  id
  phoneNumbers {
    id
    number
    isPrimary
    isMobile
    isDeleted
    updatedAt
  }
  ...PetParentAvatar
}
    ${PetParentAvatarFragmentDoc}`;
export const ExistingClinicPetParentMatchFragmentDoc = gql`
    fragment ExistingClinicPetParentMatch on ClinicPetParent {
  id
  firstName
  lastName
  email
  phoneNumber
  phoneNumbers {
    id
    updatedAt
    number
    isPrimary
    isMobile
    isDeleted
  }
  creationSource
  pets {
    ...PetAvatar
  }
}
    ${PetAvatarFragmentDoc}`;
export const ChannelStatusFragmentDoc = gql`
    fragment ChannelStatus on ChannelStatus {
  id
  createdAt
  updatedAt
  channelStatusAction
  color
  deletedOn
  isDefault
  name
  order
  isExportedToPims
}
    `;
export const ChannelStatusChannelAssigneeFragmentFragmentDoc = gql`
    fragment ChannelStatusChannelAssigneeFragment on ChannelStatusChannelAssignee {
  id
  user {
    id
  }
}
    `;
export const FullChannelStatusFragmentDoc = gql`
    fragment FullChannelStatus on ChannelStatus {
  id
  createdAt
  updatedAt
  channelStatusAction
  color
  deletedOn
  isDefault
  name
  order
  isExportedToPims
  channelStatusChannelAssignees {
    ...ChannelStatusChannelAssigneeFragment
  }
}
    ${ChannelStatusChannelAssigneeFragmentFragmentDoc}`;
export const SharedUserNotificationSettingsFragmentDoc = gql`
    fragment SharedUserNotificationSettings on UserSetting {
  id
  browserNotificationFilter {
    id
    assignees {
      id
    }
    includeUnassigned
  }
  snoozeNotificationsUntil
  notificationSettings {
    id
    emailEnabled
    smsEnabled
    soundNotificationUrl
    browserNotificationEnabled
    pushNotificationEnabled
  }
}
    `;
export const StripePaymentIntentFragmentDoc = gql`
    fragment StripePaymentIntent on StripePaymentIntent {
  id
  createdAt
  updatedAt
  stripeId
  status
  amount
  clientServiceFee
  total
  amountCaptured
  serviceFeeAmount
  clientServiceFeePercent
  lastPaymentError
  clinicPetParent {
    id
    firstName
    lastName
  }
  stripePaymentMethod {
    last4
    cardBrand
    funding
  }
  stripeRefunds {
    id
    amount
    clientFeeRefunded
    updatedAt
  }
}
    `;
export const StripePaymentOutputFragmentDoc = gql`
    fragment StripePaymentOutput on StripePaymentOutput {
  paymentIntentClientSecret
  requiresAction
  payment {
    id
    status
    amount
    total
    amountCaptured
    amountRefunded
    transferType
    receiptUrl
  }
}
    `;
export const ClinicPetParentSelectionWithEnqueuePhoneNumberLookupMutationFragmentDoc = gql`
    fragment ClinicPetParentSelectionWithEnqueuePhoneNumberLookupMutation on ClinicPetParentWithJobChainsResponse {
  clinicPetParent {
    id
    email
    firstName
    lastName
    isActive
    updatedAt
    ...PetParentAvatar
    pimsId
    phoneNumbers {
      id
      number
      isPrimary
      isMobile
      isDeleted
      updatedAt
    }
  }
  jobChains {
    id
    name
  }
}
    ${PetParentAvatarFragmentDoc}`;
export const WorkflowEventSettingSelectionFragmentDoc = gql`
    fragment WorkflowEventSettingSelection on WorkflowEventSetting {
  id
  isPublished
  visitType
  sendingHours
  appointmentTypes {
    id
    name
  }
  clinicEmployees {
    clinicEmployeeId
    clinicEmployee {
      id
      firstName
      lastName
    }
  }
  clinicRooms {
    clinicRoomId
    clinicRoom {
      id
      name
    }
  }
  actions {
    id
    actionType
    promptType
    config
    order
    channelStatusChangeId
    channelStatusChange {
      id
    }
    workflowEventTriggerDelayInMilliseconds
    workflowEventTrigger
    workflowEventTriggerActionNumber
  }
  automatedTriggerType
  automatedTriggerInMinutes
  clinic {
    id
  }
  event
  groupByWindowInHours
  name
  workflowType
  triggerType
  createdAt
  widgetRequestTypes {
    id
    order
    displayName
    requestType
  }
  triggeringFormTemplates {
    id
    title
  }
  notificationBody
  timeFormat
  surveySettingId
  surveyStep
}
    `;
export const ClinicFormTemplateFragmentDoc = gql`
    fragment ClinicFormTemplate on FormTemplate {
  id
  isActive
  isDeleted
  content
  draftContent
  title
  createdAt
  updatedAt
  formTemplateType
  autoExportEnabled
  services {
    id
    name
  }
  clinicWidgetRequestTypes {
    id
    displayName
    requestType
  }
  clinic {
    id
    hasServiceReminders
  }
}
    `;
export const ClinicPimsIntegrationFragmentDoc = gql`
    fragment ClinicPimsIntegration on ClinicPimsIntegration {
  id
  type
  isActive
  lastSyncedAt
  status
  vetdata {
    id
    system
    isMultiSite
  }
  bitwerx {
    id
    practiceId
    system
  }
  syncvet {
    id
    system
    originalSystem
  }
  capabilities {
    id
    capability
    isActive
    lastSyncedAt
  }
}
    `;
export const ClinicUserClinicFragmentDoc = gql`
    fragment ClinicUserClinic on Clinic {
  id
  createdAt
  name
  phone
  submerchantStripeId
  submerchantStripeChargesEnabled
  submerchantStripePayoutsEnabled
  isClinicEligibleForPayments
  timezoneName
  logo
  fullAddress
  websiteUrl
  clinicEmail
  addressLine1
  addressLine2
  postalCode
  country
  city
  state
  isCallerIdVerified
  hasSmsConversations
  hasServiceReminders
  activationDate
  isClinicActive
  crmId
  organizationId
  roles {
    id
    role
    permissions {
      id
      type
    }
  }
  productPackageSubscriptions(orderBy: {createdAt: desc}) {
    id
    startAt
    endAt
    productPackage {
      id
      name
    }
  }
  clinicModules {
    id
    module {
      id
      name
    }
  }
  integrations {
    ...ClinicPimsIntegration
  }
  isAddAppointmentDisabled
  clinicOfficeHours {
    id
    type
    dayOfWeek
    openAt
    closeAt
    isEnabled
    isOpenTwentyFourHours
  }
  clinicSetting {
    id
    appointmentTimeSlotIncrementInMinutes
    hasCustomizableFees
    hideAppointmentsWithoutPetOwner
    outOfOfficeHeadline
    outOfOfficeEnabled
    outOfOfficeShowScheduleEnabled
    paymentFeeConfig {
      id
      onlineProcessingFeeFlat
      onlineProcessingFeePercent
      onlineClientServiceFeePercent
      terminalProcessingFeeFlat
      terminalProcessingFeePercent
      terminalClientServiceFeePercent
    }
    aiRecapWritebackEnabled
  }
  stripeTerminalLocations {
    id
    stripeId
    isActive
    terminals {
      id
      name
      model
    }
  }
  axionClinicConfiguration {
    id
    domain
    status
  }
  carePlanProviderGroupId
  carePlanProviderGroup {
    id
    launchStatus
    paymentProcessorClinicId
  }
  twilioConfiguration {
    messagingServiceSid
    subaccountSid
  }
  payoutBatchingSetting {
    id
    isAutomated
  }
}
    ${ClinicPimsIntegrationFragmentDoc}`;
export const ClinicUserVetInfoFragmentDoc = gql`
    fragment ClinicUserVetInfo on VetInfo {
  id
  createdAt
  updatedAt
  roles(orderBy: {id: asc}) {
    id
    role
    clinic {
      id
      name
    }
    permissions {
      id
      type
    }
  }
  currentClinic {
    ...ClinicUserClinic
  }
}
    ${ClinicUserClinicFragmentDoc}`;
export const ClinicUserFragmentDoc = gql`
    fragment ClinicUser on User {
  id
  firstName
  lastName
  displayName @client
  nameDisplay
  profilePic
  email
  phone
  type
  invitationCode
  isNewPasswordRequired
  isAdmin
  userSetting {
    id
    pushNotifications
    smsNotifications
    emailNotifications
    leftNavPanel
    browserNotificationFilter {
      id
      assignees {
        id
      }
      includeUnassigned
    }
    snoozeNotificationsUntil
    notificationSettings {
      id
      soundNotificationUrl
      browserNotificationEnabled
    }
    enterAddsNewLine
    skipLoadingAnimation
    hideSummaryButton
  }
  clinics {
    ...ClinicUserClinic
  }
  vetInfo {
    ...ClinicUserVetInfo
  }
  axionClinicUserConfigurations {
    id
    clinicId
    extension
  }
}
    ${ClinicUserClinicFragmentDoc}
${ClinicUserVetInfoFragmentDoc}`;
export const SubscriptionChannelMessageFragmentDoc = gql`
    fragment SubscriptionChannelMessage on ChannelMessage {
  id
  body
  messageType
  attachments {
    id
    attachmentType
  }
  mentionedUsers {
    firstName
    lastName
    id
  }
  channel {
    id
    channelType
    assignees {
      id
    }
    lastMessage {
      id
    }
    channelStatus {
      id
      channelStatusAction
    }
  }
  author {
    id
    twilioIdentity
    user {
      id
      firstName
      lastName
    }
    clinicPetParent {
      id
      firstName
      lastName
    }
  }
}
    `;
export const SidePanelPetServiceRemindersFragmentDoc = gql`
    fragment SidePanelPetServiceReminders on ServiceReminder {
  id
  dueDate
  isCompleted
  dateLastGiven
  service {
    id
    name
    reminderActivationDate
  }
}
    `;
export const PetParentChannelFragmentDoc = gql`
    fragment PetParentChannel on Channel {
  id
  updatedAt
  channelStatus {
    id
    name
    color
    channelStatusAction
  }
  lastMessage {
    id
    createdAt
    index
    body
    attachments {
      id
      attachmentType
      entityType
    }
  }
}
    `;
export const PhoneCallParticipantFragmentDoc = gql`
    fragment PhoneCallParticipant on ClinicPetParent {
  id
  firstName
  lastName
  phoneNumbers(where: {isDeleted: {equals: false}}) {
    id
    updatedAt
    number
    isPrimary
    isMobile
  }
  email
  pets(
    take: 30
    where: {clinicId: {equals: $clinicId}, isActive: {equals: true}, isDeleted: {equals: false}, OR: [{NOT: {isDeceased: {equals: true}}}, {isDeceased: {equals: null}}]}
  ) {
    id
    name
    species
    speciesType
    gender
    dateOfBirth
    appointments(
      where: {AND: [{startAt: {gt: $eventsAfter}}, {startAt: {lt: $eventsBefore}}]}
    ) {
      id
      startAt
      durationInMinutes
      appointmentType {
        id
        name
      }
    }
    serviceReminders(
      where: {AND: [{dueDate: {gt: $eventsAfter}}, {dueDate: {lt: $eventsBefore}}], isDeleted: {equals: false}, service: {isDeleted: {equals: false}}}
    ) {
      ...SidePanelPetServiceReminders
    }
  }
  channelMembers(
    where: {channel: {isActive: {equals: true}}, removedAt: {equals: null}}
    orderBy: {channel: {updatedAt: desc}}
    take: 1
  ) {
    id
    channel {
      ...PetParentChannel
    }
  }
}
    ${SidePanelPetServiceRemindersFragmentDoc}
${PetParentChannelFragmentDoc}`;
export const CallHistorySelectionFragmentDoc = gql`
    fragment CallHistorySelection on CallHistory {
  id
  sourceId
  provider
  type
  status
  from
  to
  direction
  participants {
    id
    number
    extension
    result
    clinicPetParent {
      id
      firstName
      lastName
    }
    user {
      id
      firstName
      lastName
    }
  }
}
    `;
export const StripePayoutSelectionFragmentDoc = gql`
    fragment StripePayoutSelection on StripePayout {
  id
  amount
  arrivalDate
  initiatedAt
  status
  payoutBatchingPeriod {
    id
    endsAt
  }
}
    `;
export const GetAppointmentModalAppointmentDocument = gql`
    query getAppointmentModalAppointment($where: AppointmentWhereUniqueInput!) {
  findUniqueAppointment(where: $where) {
    id
    description
    recapNotes
    durationInMinutes
    pimsId
    startAt
    createdAt
    integrationId
    clinicPetId
    status
    workflows {
      id
    }
    room {
      id
      name
    }
    appointmentType {
      id
      name
    }
    clinicEmployees {
      id
      firstName
      lastName
    }
    clinicPetParents(where: {isActive: {equals: true}, isDeleted: {equals: false}}) {
      id
      firstName
      lastName
    }
    clinicPet {
      ...AppointmentPet
    }
    aiRecapPimsWritebackLogEntry(
      orderBy: {writebackLog: {createdAt: desc}}
      take: 1
    ) {
      writebackLog {
        id
        status
        updatedAt
      }
    }
    channel {
      id
      channelStatus {
        id
        name
        color
        channelStatusAction
      }
      tags
    }
  }
}
    ${AppointmentPetFragmentDoc}`;

/**
 * __useGetAppointmentModalAppointmentQuery__
 *
 * To run a query within a React component, call `useGetAppointmentModalAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentModalAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentModalAppointmentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAppointmentModalAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentModalAppointmentQuery, GetAppointmentModalAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentModalAppointmentQuery, GetAppointmentModalAppointmentQueryVariables>(GetAppointmentModalAppointmentDocument, options);
      }
export function useGetAppointmentModalAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentModalAppointmentQuery, GetAppointmentModalAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentModalAppointmentQuery, GetAppointmentModalAppointmentQueryVariables>(GetAppointmentModalAppointmentDocument, options);
        }
export type GetAppointmentModalAppointmentQueryHookResult = ReturnType<typeof useGetAppointmentModalAppointmentQuery>;
export type GetAppointmentModalAppointmentLazyQueryHookResult = ReturnType<typeof useGetAppointmentModalAppointmentLazyQuery>;
export type GetAppointmentModalAppointmentQueryResult = Apollo.QueryResult<GetAppointmentModalAppointmentQuery, GetAppointmentModalAppointmentQueryVariables>;
export function refetchGetAppointmentModalAppointmentQuery(variables?: GetAppointmentModalAppointmentQueryVariables) {
      return { query: GetAppointmentModalAppointmentDocument, variables: variables }
    }
export const GetAppointmentModalAppointmentProvidersDocument = gql`
    query getAppointmentModalAppointmentProviders($clinicId: String!) {
  clinicEmployees: findManyClinicEmployee(
    where: {isActive: {equals: true}, isVisible: {equals: true}, isDeleted: {equals: false}, clinic: {id: {equals: $clinicId}}}
    orderBy: [{lastName: asc}, {firstName: asc}]
  ) {
    ...ClinicEmployeeBaseSelection
  }
}
    ${ClinicEmployeeBaseSelectionFragmentDoc}`;

/**
 * __useGetAppointmentModalAppointmentProvidersQuery__
 *
 * To run a query within a React component, call `useGetAppointmentModalAppointmentProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentModalAppointmentProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentModalAppointmentProvidersQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAppointmentModalAppointmentProvidersQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentModalAppointmentProvidersQuery, GetAppointmentModalAppointmentProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentModalAppointmentProvidersQuery, GetAppointmentModalAppointmentProvidersQueryVariables>(GetAppointmentModalAppointmentProvidersDocument, options);
      }
export function useGetAppointmentModalAppointmentProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentModalAppointmentProvidersQuery, GetAppointmentModalAppointmentProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentModalAppointmentProvidersQuery, GetAppointmentModalAppointmentProvidersQueryVariables>(GetAppointmentModalAppointmentProvidersDocument, options);
        }
export type GetAppointmentModalAppointmentProvidersQueryHookResult = ReturnType<typeof useGetAppointmentModalAppointmentProvidersQuery>;
export type GetAppointmentModalAppointmentProvidersLazyQueryHookResult = ReturnType<typeof useGetAppointmentModalAppointmentProvidersLazyQuery>;
export type GetAppointmentModalAppointmentProvidersQueryResult = Apollo.QueryResult<GetAppointmentModalAppointmentProvidersQuery, GetAppointmentModalAppointmentProvidersQueryVariables>;
export function refetchGetAppointmentModalAppointmentProvidersQuery(variables?: GetAppointmentModalAppointmentProvidersQueryVariables) {
      return { query: GetAppointmentModalAppointmentProvidersDocument, variables: variables }
    }
export const GetAppointmentModalAppointmentRoomsDocument = gql`
    query getAppointmentModalAppointmentRooms($clinicId: String!) {
  clinicRooms: findManyClinicRoom(
    where: {isActive: {equals: true}, isVisible: {equals: true}, isDeleted: {equals: false}, clinic: {id: {equals: $clinicId}}}
    orderBy: {name: asc}
  ) {
    ...ClinicRoomBaseSelection
  }
}
    ${ClinicRoomBaseSelectionFragmentDoc}`;

/**
 * __useGetAppointmentModalAppointmentRoomsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentModalAppointmentRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentModalAppointmentRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentModalAppointmentRoomsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAppointmentModalAppointmentRoomsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentModalAppointmentRoomsQuery, GetAppointmentModalAppointmentRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentModalAppointmentRoomsQuery, GetAppointmentModalAppointmentRoomsQueryVariables>(GetAppointmentModalAppointmentRoomsDocument, options);
      }
export function useGetAppointmentModalAppointmentRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentModalAppointmentRoomsQuery, GetAppointmentModalAppointmentRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentModalAppointmentRoomsQuery, GetAppointmentModalAppointmentRoomsQueryVariables>(GetAppointmentModalAppointmentRoomsDocument, options);
        }
export type GetAppointmentModalAppointmentRoomsQueryHookResult = ReturnType<typeof useGetAppointmentModalAppointmentRoomsQuery>;
export type GetAppointmentModalAppointmentRoomsLazyQueryHookResult = ReturnType<typeof useGetAppointmentModalAppointmentRoomsLazyQuery>;
export type GetAppointmentModalAppointmentRoomsQueryResult = Apollo.QueryResult<GetAppointmentModalAppointmentRoomsQuery, GetAppointmentModalAppointmentRoomsQueryVariables>;
export function refetchGetAppointmentModalAppointmentRoomsQuery(variables?: GetAppointmentModalAppointmentRoomsQueryVariables) {
      return { query: GetAppointmentModalAppointmentRoomsDocument, variables: variables }
    }
export const GetAppointmentModalAppointmentTypesDocument = gql`
    query getAppointmentModalAppointmentTypes($clinicId: String!) {
  appointmentTypes: findManyAppointmentType(
    where: {clinic: {id: {equals: $clinicId}}, isVisible: {equals: true}}
    orderBy: {displayOrder: asc}
  ) {
    ...AppointmentTypeWorkflowsSelection
  }
}
    ${AppointmentTypeWorkflowsSelectionFragmentDoc}`;

/**
 * __useGetAppointmentModalAppointmentTypesQuery__
 *
 * To run a query within a React component, call `useGetAppointmentModalAppointmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentModalAppointmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentModalAppointmentTypesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAppointmentModalAppointmentTypesQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentModalAppointmentTypesQuery, GetAppointmentModalAppointmentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentModalAppointmentTypesQuery, GetAppointmentModalAppointmentTypesQueryVariables>(GetAppointmentModalAppointmentTypesDocument, options);
      }
export function useGetAppointmentModalAppointmentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentModalAppointmentTypesQuery, GetAppointmentModalAppointmentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentModalAppointmentTypesQuery, GetAppointmentModalAppointmentTypesQueryVariables>(GetAppointmentModalAppointmentTypesDocument, options);
        }
export type GetAppointmentModalAppointmentTypesQueryHookResult = ReturnType<typeof useGetAppointmentModalAppointmentTypesQuery>;
export type GetAppointmentModalAppointmentTypesLazyQueryHookResult = ReturnType<typeof useGetAppointmentModalAppointmentTypesLazyQuery>;
export type GetAppointmentModalAppointmentTypesQueryResult = Apollo.QueryResult<GetAppointmentModalAppointmentTypesQuery, GetAppointmentModalAppointmentTypesQueryVariables>;
export function refetchGetAppointmentModalAppointmentTypesQuery(variables?: GetAppointmentModalAppointmentTypesQueryVariables) {
      return { query: GetAppointmentModalAppointmentTypesDocument, variables: variables }
    }
export const GetAppointmentModalAutomationsDocument = gql`
    query getAppointmentModalAutomations($clinicId: String!, $triggerType: WorkflowEventTriggerType) {
  automations: findManyWorkflowEventSetting(
    where: {clinic: {id: {equals: $clinicId}}, triggerType: {equals: $triggerType}, event: {notIn: [ServiceReminder_FormSubmitted, InvoiceLineItem_Created]}, deletedAt: null, isPublished: {equals: true}}
    orderBy: {name: asc}
  ) {
    id
    name
    surveySettingId
  }
}
    `;

/**
 * __useGetAppointmentModalAutomationsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentModalAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentModalAutomationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentModalAutomationsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      triggerType: // value for 'triggerType'
 *   },
 * });
 */
export function useGetAppointmentModalAutomationsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentModalAutomationsQuery, GetAppointmentModalAutomationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentModalAutomationsQuery, GetAppointmentModalAutomationsQueryVariables>(GetAppointmentModalAutomationsDocument, options);
      }
export function useGetAppointmentModalAutomationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentModalAutomationsQuery, GetAppointmentModalAutomationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentModalAutomationsQuery, GetAppointmentModalAutomationsQueryVariables>(GetAppointmentModalAutomationsDocument, options);
        }
export type GetAppointmentModalAutomationsQueryHookResult = ReturnType<typeof useGetAppointmentModalAutomationsQuery>;
export type GetAppointmentModalAutomationsLazyQueryHookResult = ReturnType<typeof useGetAppointmentModalAutomationsLazyQuery>;
export type GetAppointmentModalAutomationsQueryResult = Apollo.QueryResult<GetAppointmentModalAutomationsQuery, GetAppointmentModalAutomationsQueryVariables>;
export function refetchGetAppointmentModalAutomationsQuery(variables?: GetAppointmentModalAutomationsQueryVariables) {
      return { query: GetAppointmentModalAutomationsDocument, variables: variables }
    }
export const GetAppointmentModalRecapsDocument = gql`
    query getAppointmentModalRecaps($where: RecapWhereInput) {
  findManyRecap(where: $where) {
    createdAt
    transcriptionText
  }
}
    `;

/**
 * __useGetAppointmentModalRecapsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentModalRecapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentModalRecapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentModalRecapsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAppointmentModalRecapsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentModalRecapsQuery, GetAppointmentModalRecapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentModalRecapsQuery, GetAppointmentModalRecapsQueryVariables>(GetAppointmentModalRecapsDocument, options);
      }
export function useGetAppointmentModalRecapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentModalRecapsQuery, GetAppointmentModalRecapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentModalRecapsQuery, GetAppointmentModalRecapsQueryVariables>(GetAppointmentModalRecapsDocument, options);
        }
export type GetAppointmentModalRecapsQueryHookResult = ReturnType<typeof useGetAppointmentModalRecapsQuery>;
export type GetAppointmentModalRecapsLazyQueryHookResult = ReturnType<typeof useGetAppointmentModalRecapsLazyQuery>;
export type GetAppointmentModalRecapsQueryResult = Apollo.QueryResult<GetAppointmentModalRecapsQuery, GetAppointmentModalRecapsQueryVariables>;
export function refetchGetAppointmentModalRecapsQuery(variables?: GetAppointmentModalRecapsQueryVariables) {
      return { query: GetAppointmentModalRecapsDocument, variables: variables }
    }
export const SearchAppointmentPetsDocument = gql`
    query searchAppointmentPets($whereInput: SearchClinicPetInput, $pageSize: Int) {
  clinicPetSearch(where: $whereInput, take: $pageSize) {
    ...AppointmentPet
  }
}
    ${AppointmentPetFragmentDoc}`;

/**
 * __useSearchAppointmentPetsQuery__
 *
 * To run a query within a React component, call `useSearchAppointmentPetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAppointmentPetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAppointmentPetsQuery({
 *   variables: {
 *      whereInput: // value for 'whereInput'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useSearchAppointmentPetsQuery(baseOptions?: Apollo.QueryHookOptions<SearchAppointmentPetsQuery, SearchAppointmentPetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAppointmentPetsQuery, SearchAppointmentPetsQueryVariables>(SearchAppointmentPetsDocument, options);
      }
export function useSearchAppointmentPetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAppointmentPetsQuery, SearchAppointmentPetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAppointmentPetsQuery, SearchAppointmentPetsQueryVariables>(SearchAppointmentPetsDocument, options);
        }
export type SearchAppointmentPetsQueryHookResult = ReturnType<typeof useSearchAppointmentPetsQuery>;
export type SearchAppointmentPetsLazyQueryHookResult = ReturnType<typeof useSearchAppointmentPetsLazyQuery>;
export type SearchAppointmentPetsQueryResult = Apollo.QueryResult<SearchAppointmentPetsQuery, SearchAppointmentPetsQueryVariables>;
export function refetchSearchAppointmentPetsQuery(variables?: SearchAppointmentPetsQueryVariables) {
      return { query: SearchAppointmentPetsDocument, variables: variables }
    }
export const TriggerAiRecapExportToPimsDocument = gql`
    mutation triggerAiRecapExportToPims($where: AppointmentWhereUniqueInput!) {
  aiRecapExportToPims(where: $where) {
    success
    payload
  }
}
    `;
export type TriggerAiRecapExportToPimsMutationFn = Apollo.MutationFunction<TriggerAiRecapExportToPimsMutation, TriggerAiRecapExportToPimsMutationVariables>;

/**
 * __useTriggerAiRecapExportToPimsMutation__
 *
 * To run a mutation, you first call `useTriggerAiRecapExportToPimsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerAiRecapExportToPimsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerAiRecapExportToPimsMutation, { data, loading, error }] = useTriggerAiRecapExportToPimsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTriggerAiRecapExportToPimsMutation(baseOptions?: Apollo.MutationHookOptions<TriggerAiRecapExportToPimsMutation, TriggerAiRecapExportToPimsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerAiRecapExportToPimsMutation, TriggerAiRecapExportToPimsMutationVariables>(TriggerAiRecapExportToPimsDocument, options);
      }
export type TriggerAiRecapExportToPimsMutationHookResult = ReturnType<typeof useTriggerAiRecapExportToPimsMutation>;
export type TriggerAiRecapExportToPimsMutationResult = Apollo.MutationResult<TriggerAiRecapExportToPimsMutation>;
export type TriggerAiRecapExportToPimsMutationOptions = Apollo.BaseMutationOptions<TriggerAiRecapExportToPimsMutation, TriggerAiRecapExportToPimsMutationVariables>;
export const GetNewAppointmentModalRecapsDocument = gql`
    query getNewAppointmentModalRecaps($appointmentId: String!) {
  findManyRecap(
    where: {appointmentId: {equals: $appointmentId}}
    orderBy: {createdAt: desc}
  ) {
    id
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
    generatedText
  }
  findUniqueAppointment(where: {id: $appointmentId}) {
    recapNotes
  }
}
    `;

/**
 * __useGetNewAppointmentModalRecapsQuery__
 *
 * To run a query within a React component, call `useGetNewAppointmentModalRecapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewAppointmentModalRecapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewAppointmentModalRecapsQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetNewAppointmentModalRecapsQuery(baseOptions: Apollo.QueryHookOptions<GetNewAppointmentModalRecapsQuery, GetNewAppointmentModalRecapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewAppointmentModalRecapsQuery, GetNewAppointmentModalRecapsQueryVariables>(GetNewAppointmentModalRecapsDocument, options);
      }
export function useGetNewAppointmentModalRecapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewAppointmentModalRecapsQuery, GetNewAppointmentModalRecapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewAppointmentModalRecapsQuery, GetNewAppointmentModalRecapsQueryVariables>(GetNewAppointmentModalRecapsDocument, options);
        }
export type GetNewAppointmentModalRecapsQueryHookResult = ReturnType<typeof useGetNewAppointmentModalRecapsQuery>;
export type GetNewAppointmentModalRecapsLazyQueryHookResult = ReturnType<typeof useGetNewAppointmentModalRecapsLazyQuery>;
export type GetNewAppointmentModalRecapsQueryResult = Apollo.QueryResult<GetNewAppointmentModalRecapsQuery, GetNewAppointmentModalRecapsQueryVariables>;
export function refetchGetNewAppointmentModalRecapsQuery(variables?: GetNewAppointmentModalRecapsQueryVariables) {
      return { query: GetNewAppointmentModalRecapsDocument, variables: variables }
    }
export const SubscribeToAppointmentRecapDocument = gql`
    subscription subscribeToAppointmentRecap($where: RecapWhereInput!) {
  recapChanged(where: {node: $where}) {
    node {
      id
    }
  }
}
    `;

/**
 * __useSubscribeToAppointmentRecapSubscription__
 *
 * To run a query within a React component, call `useSubscribeToAppointmentRecapSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToAppointmentRecapSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToAppointmentRecapSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToAppointmentRecapSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToAppointmentRecapSubscription, SubscribeToAppointmentRecapSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToAppointmentRecapSubscription, SubscribeToAppointmentRecapSubscriptionVariables>(SubscribeToAppointmentRecapDocument, options);
      }
export type SubscribeToAppointmentRecapSubscriptionHookResult = ReturnType<typeof useSubscribeToAppointmentRecapSubscription>;
export type SubscribeToAppointmentRecapSubscriptionResult = Apollo.SubscriptionResult<SubscribeToAppointmentRecapSubscription>;
export const CreateOneAppointmentDocument = gql`
    mutation createOneAppointment($data: AppointmentCreateInput!) {
  createOneAppointment(data: $data) {
    ...AppointmentFullSelection
  }
}
    ${AppointmentFullSelectionFragmentDoc}`;
export type CreateOneAppointmentMutationFn = Apollo.MutationFunction<CreateOneAppointmentMutation, CreateOneAppointmentMutationVariables>;

/**
 * __useCreateOneAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateOneAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneAppointmentMutation, { data, loading, error }] = useCreateOneAppointmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneAppointmentMutation, CreateOneAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneAppointmentMutation, CreateOneAppointmentMutationVariables>(CreateOneAppointmentDocument, options);
      }
export type CreateOneAppointmentMutationHookResult = ReturnType<typeof useCreateOneAppointmentMutation>;
export type CreateOneAppointmentMutationResult = Apollo.MutationResult<CreateOneAppointmentMutation>;
export type CreateOneAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateOneAppointmentMutation, CreateOneAppointmentMutationVariables>;
export const UpdateOneAppointmentDocument = gql`
    mutation updateOneAppointment($where: AppointmentWhereUniqueInput!, $data: AppointmentUpdateInput!) {
  updateOneAppointment(where: $where, data: $data) {
    ...AppointmentFullSelection
  }
}
    ${AppointmentFullSelectionFragmentDoc}`;
export type UpdateOneAppointmentMutationFn = Apollo.MutationFunction<UpdateOneAppointmentMutation, UpdateOneAppointmentMutationVariables>;

/**
 * __useUpdateOneAppointmentMutation__
 *
 * To run a mutation, you first call `useUpdateOneAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneAppointmentMutation, { data, loading, error }] = useUpdateOneAppointmentMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneAppointmentMutation, UpdateOneAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneAppointmentMutation, UpdateOneAppointmentMutationVariables>(UpdateOneAppointmentDocument, options);
      }
export type UpdateOneAppointmentMutationHookResult = ReturnType<typeof useUpdateOneAppointmentMutation>;
export type UpdateOneAppointmentMutationResult = Apollo.MutationResult<UpdateOneAppointmentMutation>;
export type UpdateOneAppointmentMutationOptions = Apollo.BaseMutationOptions<UpdateOneAppointmentMutation, UpdateOneAppointmentMutationVariables>;
export const FindManyAppointmentDocument = gql`
    query findManyAppointment($where: AppointmentWhereInput, $orderBy: [AppointmentOrderByWithRelationInput!], $skip: Int, $take: Int) {
  findManyAppointment(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
    ...AppointmentFullSelection
  }
}
    ${AppointmentFullSelectionFragmentDoc}`;

/**
 * __useFindManyAppointmentQuery__
 *
 * To run a query within a React component, call `useFindManyAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyAppointmentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useFindManyAppointmentQuery(baseOptions?: Apollo.QueryHookOptions<FindManyAppointmentQuery, FindManyAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyAppointmentQuery, FindManyAppointmentQueryVariables>(FindManyAppointmentDocument, options);
      }
export function useFindManyAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyAppointmentQuery, FindManyAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyAppointmentQuery, FindManyAppointmentQueryVariables>(FindManyAppointmentDocument, options);
        }
export type FindManyAppointmentQueryHookResult = ReturnType<typeof useFindManyAppointmentQuery>;
export type FindManyAppointmentLazyQueryHookResult = ReturnType<typeof useFindManyAppointmentLazyQuery>;
export type FindManyAppointmentQueryResult = Apollo.QueryResult<FindManyAppointmentQuery, FindManyAppointmentQueryVariables>;
export function refetchFindManyAppointmentQuery(variables?: FindManyAppointmentQueryVariables) {
      return { query: FindManyAppointmentDocument, variables: variables }
    }
export const FindManyAppointmentCountDocument = gql`
    query findManyAppointmentCount($where: AppointmentWhereInput, $orderBy: [AppointmentOrderByWithRelationInput!], $skip: Int, $take: Int) {
  findManyAppointmentCount(
    where: $where
    orderBy: $orderBy
    skip: $skip
    take: $take
  )
}
    `;

/**
 * __useFindManyAppointmentCountQuery__
 *
 * To run a query within a React component, call `useFindManyAppointmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyAppointmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyAppointmentCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useFindManyAppointmentCountQuery(baseOptions?: Apollo.QueryHookOptions<FindManyAppointmentCountQuery, FindManyAppointmentCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyAppointmentCountQuery, FindManyAppointmentCountQueryVariables>(FindManyAppointmentCountDocument, options);
      }
export function useFindManyAppointmentCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyAppointmentCountQuery, FindManyAppointmentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyAppointmentCountQuery, FindManyAppointmentCountQueryVariables>(FindManyAppointmentCountDocument, options);
        }
export type FindManyAppointmentCountQueryHookResult = ReturnType<typeof useFindManyAppointmentCountQuery>;
export type FindManyAppointmentCountLazyQueryHookResult = ReturnType<typeof useFindManyAppointmentCountLazyQuery>;
export type FindManyAppointmentCountQueryResult = Apollo.QueryResult<FindManyAppointmentCountQuery, FindManyAppointmentCountQueryVariables>;
export function refetchFindManyAppointmentCountQuery(variables?: FindManyAppointmentCountQueryVariables) {
      return { query: FindManyAppointmentCountDocument, variables: variables }
    }
export const FindUniqueAppointmentDocument = gql`
    query findUniqueAppointment($where: AppointmentWhereUniqueInput!) {
  findUniqueAppointment(where: $where) {
    ...AppointmentFullSelection
  }
}
    ${AppointmentFullSelectionFragmentDoc}`;

/**
 * __useFindUniqueAppointmentQuery__
 *
 * To run a query within a React component, call `useFindUniqueAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueAppointmentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueAppointmentQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueAppointmentQuery, FindUniqueAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueAppointmentQuery, FindUniqueAppointmentQueryVariables>(FindUniqueAppointmentDocument, options);
      }
export function useFindUniqueAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueAppointmentQuery, FindUniqueAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueAppointmentQuery, FindUniqueAppointmentQueryVariables>(FindUniqueAppointmentDocument, options);
        }
export type FindUniqueAppointmentQueryHookResult = ReturnType<typeof useFindUniqueAppointmentQuery>;
export type FindUniqueAppointmentLazyQueryHookResult = ReturnType<typeof useFindUniqueAppointmentLazyQuery>;
export type FindUniqueAppointmentQueryResult = Apollo.QueryResult<FindUniqueAppointmentQuery, FindUniqueAppointmentQueryVariables>;
export function refetchFindUniqueAppointmentQuery(variables?: FindUniqueAppointmentQueryVariables) {
      return { query: FindUniqueAppointmentDocument, variables: variables }
    }
export const GetAppointmentAiRecapInfoDocument = gql`
    query getAppointmentAiRecapInfo($appointmentId: String!, $orderBy: [RecapOrderByWithRelationInput], $take: Int) {
  findUniqueAppointment(where: {id: $appointmentId}) {
    id
    recapNotes
    startAt
    appointmentType {
      id
      name
    }
    clinicPetParents(where: {isActive: {equals: true}, isDeleted: {equals: false}}) {
      id
      firstName
      lastName
    }
    clinicPet {
      ...AppointmentPet
    }
    clinicId
    recapNotesUpdatedAt
    recapNotesUpdatedBy {
      id
      firstName
      lastName
    }
  }
  findManyRecap(
    where: {appointmentId: {equals: $appointmentId}}
    orderBy: $orderBy
    take: $take
  ) {
    id
    createdAt
    durationSeconds
    status
    templateId
    transcriptionText
    generatedText
    transcriptionS3Uri
    recordingS3Uri
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    ${AppointmentPetFragmentDoc}`;

/**
 * __useGetAppointmentAiRecapInfoQuery__
 *
 * To run a query within a React component, call `useGetAppointmentAiRecapInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentAiRecapInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentAiRecapInfoQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAppointmentAiRecapInfoQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentAiRecapInfoQuery, GetAppointmentAiRecapInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentAiRecapInfoQuery, GetAppointmentAiRecapInfoQueryVariables>(GetAppointmentAiRecapInfoDocument, options);
      }
export function useGetAppointmentAiRecapInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentAiRecapInfoQuery, GetAppointmentAiRecapInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentAiRecapInfoQuery, GetAppointmentAiRecapInfoQueryVariables>(GetAppointmentAiRecapInfoDocument, options);
        }
export type GetAppointmentAiRecapInfoQueryHookResult = ReturnType<typeof useGetAppointmentAiRecapInfoQuery>;
export type GetAppointmentAiRecapInfoLazyQueryHookResult = ReturnType<typeof useGetAppointmentAiRecapInfoLazyQuery>;
export type GetAppointmentAiRecapInfoQueryResult = Apollo.QueryResult<GetAppointmentAiRecapInfoQuery, GetAppointmentAiRecapInfoQueryVariables>;
export function refetchGetAppointmentAiRecapInfoQuery(variables?: GetAppointmentAiRecapInfoQueryVariables) {
      return { query: GetAppointmentAiRecapInfoDocument, variables: variables }
    }
export const GetAppointmentOptionsDocument = gql`
    query getAppointmentOptions($clinicId: String!) {
  clinicEmployees: findManyClinicEmployee(
    where: {isActive: {equals: true}, isVisible: {equals: true}, isDeleted: {equals: false}, clinic: {id: {equals: $clinicId}}}
  ) {
    ...ClinicEmployeeBaseSelection
  }
  clinicRooms: findManyClinicRoom(
    where: {isActive: {equals: true}, isVisible: {equals: true}, isDeleted: {equals: false}, clinic: {id: {equals: $clinicId}}}
  ) {
    ...ClinicRoomBaseSelection
  }
  appointmentTypes: findManyAppointmentType(
    where: {clinic: {id: {equals: $clinicId}}, isVisible: {equals: true}}
    orderBy: {displayOrder: asc}
  ) {
    ...AppointmentTypeWorkflowsSelection
  }
}
    ${ClinicEmployeeBaseSelectionFragmentDoc}
${ClinicRoomBaseSelectionFragmentDoc}
${AppointmentTypeWorkflowsSelectionFragmentDoc}`;

/**
 * __useGetAppointmentOptionsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentOptionsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAppointmentOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentOptionsQuery, GetAppointmentOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentOptionsQuery, GetAppointmentOptionsQueryVariables>(GetAppointmentOptionsDocument, options);
      }
export function useGetAppointmentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentOptionsQuery, GetAppointmentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentOptionsQuery, GetAppointmentOptionsQueryVariables>(GetAppointmentOptionsDocument, options);
        }
export type GetAppointmentOptionsQueryHookResult = ReturnType<typeof useGetAppointmentOptionsQuery>;
export type GetAppointmentOptionsLazyQueryHookResult = ReturnType<typeof useGetAppointmentOptionsLazyQuery>;
export type GetAppointmentOptionsQueryResult = Apollo.QueryResult<GetAppointmentOptionsQuery, GetAppointmentOptionsQueryVariables>;
export function refetchGetAppointmentOptionsQuery(variables?: GetAppointmentOptionsQueryVariables) {
      return { query: GetAppointmentOptionsDocument, variables: variables }
    }
export const GetAppointmentPetsDocument = gql`
    query getAppointmentPets($whereInput: SearchClinicPetInput, $pageSize: Int) {
  clinicPetSearch(where: $whereInput, take: $pageSize) {
    ...AppointmentPet
  }
}
    ${AppointmentPetFragmentDoc}`;

/**
 * __useGetAppointmentPetsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentPetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentPetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentPetsQuery({
 *   variables: {
 *      whereInput: // value for 'whereInput'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetAppointmentPetsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentPetsQuery, GetAppointmentPetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentPetsQuery, GetAppointmentPetsQueryVariables>(GetAppointmentPetsDocument, options);
      }
export function useGetAppointmentPetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentPetsQuery, GetAppointmentPetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentPetsQuery, GetAppointmentPetsQueryVariables>(GetAppointmentPetsDocument, options);
        }
export type GetAppointmentPetsQueryHookResult = ReturnType<typeof useGetAppointmentPetsQuery>;
export type GetAppointmentPetsLazyQueryHookResult = ReturnType<typeof useGetAppointmentPetsLazyQuery>;
export type GetAppointmentPetsQueryResult = Apollo.QueryResult<GetAppointmentPetsQuery, GetAppointmentPetsQueryVariables>;
export function refetchGetAppointmentPetsQuery(variables?: GetAppointmentPetsQueryVariables) {
      return { query: GetAppointmentPetsDocument, variables: variables }
    }
export const GetAppointmentRecapUrlDocument = gql`
    query getAppointmentRecapUrl($data: GetAppointmentRecapUrlInput!) {
  getAppointmentRecapUrl(data: $data)
}
    `;

/**
 * __useGetAppointmentRecapUrlQuery__
 *
 * To run a query within a React component, call `useGetAppointmentRecapUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentRecapUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentRecapUrlQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetAppointmentRecapUrlQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentRecapUrlQuery, GetAppointmentRecapUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentRecapUrlQuery, GetAppointmentRecapUrlQueryVariables>(GetAppointmentRecapUrlDocument, options);
      }
export function useGetAppointmentRecapUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentRecapUrlQuery, GetAppointmentRecapUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentRecapUrlQuery, GetAppointmentRecapUrlQueryVariables>(GetAppointmentRecapUrlDocument, options);
        }
export type GetAppointmentRecapUrlQueryHookResult = ReturnType<typeof useGetAppointmentRecapUrlQuery>;
export type GetAppointmentRecapUrlLazyQueryHookResult = ReturnType<typeof useGetAppointmentRecapUrlLazyQuery>;
export type GetAppointmentRecapUrlQueryResult = Apollo.QueryResult<GetAppointmentRecapUrlQuery, GetAppointmentRecapUrlQueryVariables>;
export function refetchGetAppointmentRecapUrlQuery(variables?: GetAppointmentRecapUrlQueryVariables) {
      return { query: GetAppointmentRecapUrlDocument, variables: variables }
    }
export const GetFilterUserAppointmentGroupsOptionsDocument = gql`
    query getFilterUserAppointmentGroupsOptions($where: UserAppointmentGroupingWhereInput!) {
  userAppointmentGroupings: findManyUserAppointmentGrouping(
    where: $where
    orderBy: {createdAt: asc}
  ) {
    id
    clinicId
    label
  }
}
    `;

/**
 * __useGetFilterUserAppointmentGroupsOptionsQuery__
 *
 * To run a query within a React component, call `useGetFilterUserAppointmentGroupsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterUserAppointmentGroupsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterUserAppointmentGroupsOptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFilterUserAppointmentGroupsOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetFilterUserAppointmentGroupsOptionsQuery, GetFilterUserAppointmentGroupsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterUserAppointmentGroupsOptionsQuery, GetFilterUserAppointmentGroupsOptionsQueryVariables>(GetFilterUserAppointmentGroupsOptionsDocument, options);
      }
export function useGetFilterUserAppointmentGroupsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterUserAppointmentGroupsOptionsQuery, GetFilterUserAppointmentGroupsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterUserAppointmentGroupsOptionsQuery, GetFilterUserAppointmentGroupsOptionsQueryVariables>(GetFilterUserAppointmentGroupsOptionsDocument, options);
        }
export type GetFilterUserAppointmentGroupsOptionsQueryHookResult = ReturnType<typeof useGetFilterUserAppointmentGroupsOptionsQuery>;
export type GetFilterUserAppointmentGroupsOptionsLazyQueryHookResult = ReturnType<typeof useGetFilterUserAppointmentGroupsOptionsLazyQuery>;
export type GetFilterUserAppointmentGroupsOptionsQueryResult = Apollo.QueryResult<GetFilterUserAppointmentGroupsOptionsQuery, GetFilterUserAppointmentGroupsOptionsQueryVariables>;
export function refetchGetFilterUserAppointmentGroupsOptionsQuery(variables?: GetFilterUserAppointmentGroupsOptionsQueryVariables) {
      return { query: GetFilterUserAppointmentGroupsOptionsDocument, variables: variables }
    }
export const GetUserAppointmentGroupingsDocument = gql`
    query getUserAppointmentGroupings($where: UserAppointmentGroupingWhereInput!, $take: Int!, $skip: Int!) {
  count: findManyUserAppointmentGroupingCount(where: $where)
  userAppointmentGroupings: findManyUserAppointmentGrouping(
    where: $where
    take: $take
    skip: $skip
    orderBy: {createdAt: asc}
  ) {
    id
    clinicId
    label
    clinicEmployees {
      id
      firstName
      lastName
    }
    rooms {
      id
      name
    }
    appointmentTypes {
      id
      name
    }
  }
}
    `;

/**
 * __useGetUserAppointmentGroupingsQuery__
 *
 * To run a query within a React component, call `useGetUserAppointmentGroupingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAppointmentGroupingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAppointmentGroupingsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetUserAppointmentGroupingsQuery(baseOptions: Apollo.QueryHookOptions<GetUserAppointmentGroupingsQuery, GetUserAppointmentGroupingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAppointmentGroupingsQuery, GetUserAppointmentGroupingsQueryVariables>(GetUserAppointmentGroupingsDocument, options);
      }
export function useGetUserAppointmentGroupingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAppointmentGroupingsQuery, GetUserAppointmentGroupingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAppointmentGroupingsQuery, GetUserAppointmentGroupingsQueryVariables>(GetUserAppointmentGroupingsDocument, options);
        }
export type GetUserAppointmentGroupingsQueryHookResult = ReturnType<typeof useGetUserAppointmentGroupingsQuery>;
export type GetUserAppointmentGroupingsLazyQueryHookResult = ReturnType<typeof useGetUserAppointmentGroupingsLazyQuery>;
export type GetUserAppointmentGroupingsQueryResult = Apollo.QueryResult<GetUserAppointmentGroupingsQuery, GetUserAppointmentGroupingsQueryVariables>;
export function refetchGetUserAppointmentGroupingsQuery(variables?: GetUserAppointmentGroupingsQueryVariables) {
      return { query: GetUserAppointmentGroupingsDocument, variables: variables }
    }
export const GetUserAppointmentGroupingsFiltersDocument = gql`
    query getUserAppointmentGroupingsFilters($clinicId: String!) {
  userAppointmentGroupingsFilters @client
}
    `;

/**
 * __useGetUserAppointmentGroupingsFiltersQuery__
 *
 * To run a query within a React component, call `useGetUserAppointmentGroupingsFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAppointmentGroupingsFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAppointmentGroupingsFiltersQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetUserAppointmentGroupingsFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetUserAppointmentGroupingsFiltersQuery, GetUserAppointmentGroupingsFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAppointmentGroupingsFiltersQuery, GetUserAppointmentGroupingsFiltersQueryVariables>(GetUserAppointmentGroupingsFiltersDocument, options);
      }
export function useGetUserAppointmentGroupingsFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAppointmentGroupingsFiltersQuery, GetUserAppointmentGroupingsFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAppointmentGroupingsFiltersQuery, GetUserAppointmentGroupingsFiltersQueryVariables>(GetUserAppointmentGroupingsFiltersDocument, options);
        }
export type GetUserAppointmentGroupingsFiltersQueryHookResult = ReturnType<typeof useGetUserAppointmentGroupingsFiltersQuery>;
export type GetUserAppointmentGroupingsFiltersLazyQueryHookResult = ReturnType<typeof useGetUserAppointmentGroupingsFiltersLazyQuery>;
export type GetUserAppointmentGroupingsFiltersQueryResult = Apollo.QueryResult<GetUserAppointmentGroupingsFiltersQuery, GetUserAppointmentGroupingsFiltersQueryVariables>;
export function refetchGetUserAppointmentGroupingsFiltersQuery(variables?: GetUserAppointmentGroupingsFiltersQueryVariables) {
      return { query: GetUserAppointmentGroupingsFiltersDocument, variables: variables }
    }
export const SubscribeToRecapSummaryGeneratedDocument = gql`
    subscription subscribeToRecapSummaryGenerated($where: SubscriptionRecapSummaryGeneratedWhereInput!) {
  recapSummaryGenerated(where: $where) {
    mutation
    node {
      id
      recapNotes
      recapNotesUpdatedAt
      recapNotesUpdatedBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useSubscribeToRecapSummaryGeneratedSubscription__
 *
 * To run a query within a React component, call `useSubscribeToRecapSummaryGeneratedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToRecapSummaryGeneratedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToRecapSummaryGeneratedSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToRecapSummaryGeneratedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToRecapSummaryGeneratedSubscription, SubscribeToRecapSummaryGeneratedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToRecapSummaryGeneratedSubscription, SubscribeToRecapSummaryGeneratedSubscriptionVariables>(SubscribeToRecapSummaryGeneratedDocument, options);
      }
export type SubscribeToRecapSummaryGeneratedSubscriptionHookResult = ReturnType<typeof useSubscribeToRecapSummaryGeneratedSubscription>;
export type SubscribeToRecapSummaryGeneratedSubscriptionResult = Apollo.SubscriptionResult<SubscribeToRecapSummaryGeneratedSubscription>;
export const CreateAutomationAndSendConditionsDocument = gql`
    mutation createAutomationAndSendConditions($workflowEventSettingData: WorkflowEventSettingCreateInput!, $conditionsData: [ConditionCreateWithoutSetInput!]!) {
  createWorkflowEventSettingAndConditions(
    data: {workflowEventSetting: $workflowEventSettingData, conditions: $conditionsData}
  ) {
    ...AutomationEditorAutomation
  }
}
    ${AutomationEditorAutomationFragmentDoc}`;
export type CreateAutomationAndSendConditionsMutationFn = Apollo.MutationFunction<CreateAutomationAndSendConditionsMutation, CreateAutomationAndSendConditionsMutationVariables>;

/**
 * __useCreateAutomationAndSendConditionsMutation__
 *
 * To run a mutation, you first call `useCreateAutomationAndSendConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomationAndSendConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomationAndSendConditionsMutation, { data, loading, error }] = useCreateAutomationAndSendConditionsMutation({
 *   variables: {
 *      workflowEventSettingData: // value for 'workflowEventSettingData'
 *      conditionsData: // value for 'conditionsData'
 *   },
 * });
 */
export function useCreateAutomationAndSendConditionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomationAndSendConditionsMutation, CreateAutomationAndSendConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomationAndSendConditionsMutation, CreateAutomationAndSendConditionsMutationVariables>(CreateAutomationAndSendConditionsDocument, options);
      }
export type CreateAutomationAndSendConditionsMutationHookResult = ReturnType<typeof useCreateAutomationAndSendConditionsMutation>;
export type CreateAutomationAndSendConditionsMutationResult = Apollo.MutationResult<CreateAutomationAndSendConditionsMutation>;
export type CreateAutomationAndSendConditionsMutationOptions = Apollo.BaseMutationOptions<CreateAutomationAndSendConditionsMutation, CreateAutomationAndSendConditionsMutationVariables>;
export const DeleteOneAutomationDocument = gql`
    mutation deleteOneAutomation($workflowEventSettingId: String!) {
  deleteOneWorkflowEventSetting(where: {id: $workflowEventSettingId}) {
    id
  }
}
    `;
export type DeleteOneAutomationMutationFn = Apollo.MutationFunction<DeleteOneAutomationMutation, DeleteOneAutomationMutationVariables>;

/**
 * __useDeleteOneAutomationMutation__
 *
 * To run a mutation, you first call `useDeleteOneAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneAutomationMutation, { data, loading, error }] = useDeleteOneAutomationMutation({
 *   variables: {
 *      workflowEventSettingId: // value for 'workflowEventSettingId'
 *   },
 * });
 */
export function useDeleteOneAutomationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneAutomationMutation, DeleteOneAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneAutomationMutation, DeleteOneAutomationMutationVariables>(DeleteOneAutomationDocument, options);
      }
export type DeleteOneAutomationMutationHookResult = ReturnType<typeof useDeleteOneAutomationMutation>;
export type DeleteOneAutomationMutationResult = Apollo.MutationResult<DeleteOneAutomationMutation>;
export type DeleteOneAutomationMutationOptions = Apollo.BaseMutationOptions<DeleteOneAutomationMutation, DeleteOneAutomationMutationVariables>;
export const DuplicateOneAutomationDocument = gql`
    mutation duplicateOneAutomation($where: WorkflowEventSettingWhereUniqueInput!) {
  copyOneWorkflowEventSetting(where: $where) {
    id
  }
}
    `;
export type DuplicateOneAutomationMutationFn = Apollo.MutationFunction<DuplicateOneAutomationMutation, DuplicateOneAutomationMutationVariables>;

/**
 * __useDuplicateOneAutomationMutation__
 *
 * To run a mutation, you first call `useDuplicateOneAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOneAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOneAutomationMutation, { data, loading, error }] = useDuplicateOneAutomationMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDuplicateOneAutomationMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateOneAutomationMutation, DuplicateOneAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateOneAutomationMutation, DuplicateOneAutomationMutationVariables>(DuplicateOneAutomationDocument, options);
      }
export type DuplicateOneAutomationMutationHookResult = ReturnType<typeof useDuplicateOneAutomationMutation>;
export type DuplicateOneAutomationMutationResult = Apollo.MutationResult<DuplicateOneAutomationMutation>;
export type DuplicateOneAutomationMutationOptions = Apollo.BaseMutationOptions<DuplicateOneAutomationMutation, DuplicateOneAutomationMutationVariables>;
export const ToggleManyAutomationPublishedStateDocument = gql`
    mutation toggleManyAutomationPublishedState($workflowEventSettingIds: [String!]!, $isPublished: Boolean!) {
  bulkPublishWorkflowEventSettings(
    data: {workflowEventSettingIds: $workflowEventSettingIds, isPublished: $isPublished}
  ) {
    count
  }
}
    `;
export type ToggleManyAutomationPublishedStateMutationFn = Apollo.MutationFunction<ToggleManyAutomationPublishedStateMutation, ToggleManyAutomationPublishedStateMutationVariables>;

/**
 * __useToggleManyAutomationPublishedStateMutation__
 *
 * To run a mutation, you first call `useToggleManyAutomationPublishedStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleManyAutomationPublishedStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleManyAutomationPublishedStateMutation, { data, loading, error }] = useToggleManyAutomationPublishedStateMutation({
 *   variables: {
 *      workflowEventSettingIds: // value for 'workflowEventSettingIds'
 *      isPublished: // value for 'isPublished'
 *   },
 * });
 */
export function useToggleManyAutomationPublishedStateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleManyAutomationPublishedStateMutation, ToggleManyAutomationPublishedStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleManyAutomationPublishedStateMutation, ToggleManyAutomationPublishedStateMutationVariables>(ToggleManyAutomationPublishedStateDocument, options);
      }
export type ToggleManyAutomationPublishedStateMutationHookResult = ReturnType<typeof useToggleManyAutomationPublishedStateMutation>;
export type ToggleManyAutomationPublishedStateMutationResult = Apollo.MutationResult<ToggleManyAutomationPublishedStateMutation>;
export type ToggleManyAutomationPublishedStateMutationOptions = Apollo.BaseMutationOptions<ToggleManyAutomationPublishedStateMutation, ToggleManyAutomationPublishedStateMutationVariables>;
export const UpdateOneAutomationDocument = gql`
    mutation updateOneAutomation($workflowEventSettingId: String!, $workflowEventSettingData: WorkflowEventSettingUpdateInput!) {
  updateOneWorkflowEventSetting(
    where: {id: $workflowEventSettingId}
    data: $workflowEventSettingData
  ) {
    ...AutomationEditorAutomation
  }
}
    ${AutomationEditorAutomationFragmentDoc}`;
export type UpdateOneAutomationMutationFn = Apollo.MutationFunction<UpdateOneAutomationMutation, UpdateOneAutomationMutationVariables>;

/**
 * __useUpdateOneAutomationMutation__
 *
 * To run a mutation, you first call `useUpdateOneAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneAutomationMutation, { data, loading, error }] = useUpdateOneAutomationMutation({
 *   variables: {
 *      workflowEventSettingId: // value for 'workflowEventSettingId'
 *      workflowEventSettingData: // value for 'workflowEventSettingData'
 *   },
 * });
 */
export function useUpdateOneAutomationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneAutomationMutation, UpdateOneAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneAutomationMutation, UpdateOneAutomationMutationVariables>(UpdateOneAutomationDocument, options);
      }
export type UpdateOneAutomationMutationHookResult = ReturnType<typeof useUpdateOneAutomationMutation>;
export type UpdateOneAutomationMutationResult = Apollo.MutationResult<UpdateOneAutomationMutation>;
export type UpdateOneAutomationMutationOptions = Apollo.BaseMutationOptions<UpdateOneAutomationMutation, UpdateOneAutomationMutationVariables>;
export const UpdateOneAutomationAndConditionSetDocument = gql`
    mutation updateOneAutomationAndConditionSet($workflowEventSettingId: String!, $workflowEventSettingData: WorkflowEventSettingUpdateInput!, $conditionSetId: String!, $conditionSetData: ConditionSetUpdateInput!) {
  updateOneWorkflowEventSetting(
    where: {id: $workflowEventSettingId}
    data: $workflowEventSettingData
  ) {
    ...AutomationEditorAutomation
  }
  updateOneConditionSet(where: {id: $conditionSetId}, data: $conditionSetData) {
    ...AutomationEditorConditionSet
  }
}
    ${AutomationEditorAutomationFragmentDoc}
${AutomationEditorConditionSetFragmentDoc}`;
export type UpdateOneAutomationAndConditionSetMutationFn = Apollo.MutationFunction<UpdateOneAutomationAndConditionSetMutation, UpdateOneAutomationAndConditionSetMutationVariables>;

/**
 * __useUpdateOneAutomationAndConditionSetMutation__
 *
 * To run a mutation, you first call `useUpdateOneAutomationAndConditionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneAutomationAndConditionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneAutomationAndConditionSetMutation, { data, loading, error }] = useUpdateOneAutomationAndConditionSetMutation({
 *   variables: {
 *      workflowEventSettingId: // value for 'workflowEventSettingId'
 *      workflowEventSettingData: // value for 'workflowEventSettingData'
 *      conditionSetId: // value for 'conditionSetId'
 *      conditionSetData: // value for 'conditionSetData'
 *   },
 * });
 */
export function useUpdateOneAutomationAndConditionSetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneAutomationAndConditionSetMutation, UpdateOneAutomationAndConditionSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneAutomationAndConditionSetMutation, UpdateOneAutomationAndConditionSetMutationVariables>(UpdateOneAutomationAndConditionSetDocument, options);
      }
export type UpdateOneAutomationAndConditionSetMutationHookResult = ReturnType<typeof useUpdateOneAutomationAndConditionSetMutation>;
export type UpdateOneAutomationAndConditionSetMutationResult = Apollo.MutationResult<UpdateOneAutomationAndConditionSetMutation>;
export type UpdateOneAutomationAndConditionSetMutationOptions = Apollo.BaseMutationOptions<UpdateOneAutomationAndConditionSetMutation, UpdateOneAutomationAndConditionSetMutationVariables>;
export const GetAutomationEditorDataDocument = gql`
    query getAutomationEditorData($workflowEventSettingId: String) {
  findUniqueWorkflowEventSetting(where: {id: $workflowEventSettingId}) {
    ...AutomationEditorAutomation
  }
  findManyConditionSet(
    where: {conditionalEntityType: {equals: WorkflowEventSetting}, conditionalEntityId: {equals: $workflowEventSettingId}}
  ) {
    ...AutomationEditorConditionSet
  }
}
    ${AutomationEditorAutomationFragmentDoc}
${AutomationEditorConditionSetFragmentDoc}`;

/**
 * __useGetAutomationEditorDataQuery__
 *
 * To run a query within a React component, call `useGetAutomationEditorDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationEditorDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationEditorDataQuery({
 *   variables: {
 *      workflowEventSettingId: // value for 'workflowEventSettingId'
 *   },
 * });
 */
export function useGetAutomationEditorDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAutomationEditorDataQuery, GetAutomationEditorDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationEditorDataQuery, GetAutomationEditorDataQueryVariables>(GetAutomationEditorDataDocument, options);
      }
export function useGetAutomationEditorDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationEditorDataQuery, GetAutomationEditorDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationEditorDataQuery, GetAutomationEditorDataQueryVariables>(GetAutomationEditorDataDocument, options);
        }
export type GetAutomationEditorDataQueryHookResult = ReturnType<typeof useGetAutomationEditorDataQuery>;
export type GetAutomationEditorDataLazyQueryHookResult = ReturnType<typeof useGetAutomationEditorDataLazyQuery>;
export type GetAutomationEditorDataQueryResult = Apollo.QueryResult<GetAutomationEditorDataQuery, GetAutomationEditorDataQueryVariables>;
export function refetchGetAutomationEditorDataQuery(variables?: GetAutomationEditorDataQueryVariables) {
      return { query: GetAutomationEditorDataDocument, variables: variables }
    }
export const GetAutomationFormTemplateOptionsDocument = gql`
    query getAutomationFormTemplateOptions($where: FormTemplateWhereInput!) {
  findManyFormTemplate(where: $where, orderBy: {title: asc}) {
    id
    title
    isActive
    isDeleted
  }
}
    `;

/**
 * __useGetAutomationFormTemplateOptionsQuery__
 *
 * To run a query within a React component, call `useGetAutomationFormTemplateOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationFormTemplateOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationFormTemplateOptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAutomationFormTemplateOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetAutomationFormTemplateOptionsQuery, GetAutomationFormTemplateOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationFormTemplateOptionsQuery, GetAutomationFormTemplateOptionsQueryVariables>(GetAutomationFormTemplateOptionsDocument, options);
      }
export function useGetAutomationFormTemplateOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationFormTemplateOptionsQuery, GetAutomationFormTemplateOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationFormTemplateOptionsQuery, GetAutomationFormTemplateOptionsQueryVariables>(GetAutomationFormTemplateOptionsDocument, options);
        }
export type GetAutomationFormTemplateOptionsQueryHookResult = ReturnType<typeof useGetAutomationFormTemplateOptionsQuery>;
export type GetAutomationFormTemplateOptionsLazyQueryHookResult = ReturnType<typeof useGetAutomationFormTemplateOptionsLazyQuery>;
export type GetAutomationFormTemplateOptionsQueryResult = Apollo.QueryResult<GetAutomationFormTemplateOptionsQuery, GetAutomationFormTemplateOptionsQueryVariables>;
export function refetchGetAutomationFormTemplateOptionsQuery(variables?: GetAutomationFormTemplateOptionsQueryVariables) {
      return { query: GetAutomationFormTemplateOptionsDocument, variables: variables }
    }
export const GetAutomationParentAutomationsDocument = gql`
    query getAutomationParentAutomations($workflowId: String!) {
  findManyParentWorkflowEventSetting(workflowId: $workflowId) {
    ...AutomationsParentItem
  }
}
    ${AutomationsParentItemFragmentDoc}`;

/**
 * __useGetAutomationParentAutomationsQuery__
 *
 * To run a query within a React component, call `useGetAutomationParentAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationParentAutomationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationParentAutomationsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetAutomationParentAutomationsQuery(baseOptions: Apollo.QueryHookOptions<GetAutomationParentAutomationsQuery, GetAutomationParentAutomationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationParentAutomationsQuery, GetAutomationParentAutomationsQueryVariables>(GetAutomationParentAutomationsDocument, options);
      }
export function useGetAutomationParentAutomationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationParentAutomationsQuery, GetAutomationParentAutomationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationParentAutomationsQuery, GetAutomationParentAutomationsQueryVariables>(GetAutomationParentAutomationsDocument, options);
        }
export type GetAutomationParentAutomationsQueryHookResult = ReturnType<typeof useGetAutomationParentAutomationsQuery>;
export type GetAutomationParentAutomationsLazyQueryHookResult = ReturnType<typeof useGetAutomationParentAutomationsLazyQuery>;
export type GetAutomationParentAutomationsQueryResult = Apollo.QueryResult<GetAutomationParentAutomationsQuery, GetAutomationParentAutomationsQueryVariables>;
export function refetchGetAutomationParentAutomationsQuery(variables?: GetAutomationParentAutomationsQueryVariables) {
      return { query: GetAutomationParentAutomationsDocument, variables: variables }
    }
export const GetAutomationSendConditionOptionsDocument = gql`
    query getAutomationSendConditionOptions($clinicId: String!) {
  clinicEmployees: findManyClinicEmployee(where: {clinicId: {equals: $clinicId}}) {
    id
    firstName
    lastName
    isActive
    isDeleted
    isVisible
  }
  clinicRooms: findManyClinicRoom(where: {clinicId: {equals: $clinicId}}) {
    id
    name
    isActive
    isVisible
    isDeleted
  }
  appointmentTypes: findManyAppointmentType(
    where: {clinicId: {equals: $clinicId}}
  ) {
    id
    name
    displayName
    isVisible
  }
}
    `;

/**
 * __useGetAutomationSendConditionOptionsQuery__
 *
 * To run a query within a React component, call `useGetAutomationSendConditionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationSendConditionOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationSendConditionOptionsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAutomationSendConditionOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetAutomationSendConditionOptionsQuery, GetAutomationSendConditionOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationSendConditionOptionsQuery, GetAutomationSendConditionOptionsQueryVariables>(GetAutomationSendConditionOptionsDocument, options);
      }
export function useGetAutomationSendConditionOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationSendConditionOptionsQuery, GetAutomationSendConditionOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationSendConditionOptionsQuery, GetAutomationSendConditionOptionsQueryVariables>(GetAutomationSendConditionOptionsDocument, options);
        }
export type GetAutomationSendConditionOptionsQueryHookResult = ReturnType<typeof useGetAutomationSendConditionOptionsQuery>;
export type GetAutomationSendConditionOptionsLazyQueryHookResult = ReturnType<typeof useGetAutomationSendConditionOptionsLazyQuery>;
export type GetAutomationSendConditionOptionsQueryResult = Apollo.QueryResult<GetAutomationSendConditionOptionsQuery, GetAutomationSendConditionOptionsQueryVariables>;
export function refetchGetAutomationSendConditionOptionsQuery(variables?: GetAutomationSendConditionOptionsQueryVariables) {
      return { query: GetAutomationSendConditionOptionsDocument, variables: variables }
    }
export const GetAutomationWidgetRequestTypeOptionsDocument = gql`
    query getAutomationWidgetRequestTypeOptions($where: ClinicWhereUniqueInput!) {
  findUniqueClinic(where: $where) {
    clinicWidgetSetting {
      clinicWidgetRequestTypes {
        id
        displayName
        requestType
        isDeleted
        isActive
      }
    }
  }
}
    `;

/**
 * __useGetAutomationWidgetRequestTypeOptionsQuery__
 *
 * To run a query within a React component, call `useGetAutomationWidgetRequestTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationWidgetRequestTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationWidgetRequestTypeOptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAutomationWidgetRequestTypeOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetAutomationWidgetRequestTypeOptionsQuery, GetAutomationWidgetRequestTypeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationWidgetRequestTypeOptionsQuery, GetAutomationWidgetRequestTypeOptionsQueryVariables>(GetAutomationWidgetRequestTypeOptionsDocument, options);
      }
export function useGetAutomationWidgetRequestTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationWidgetRequestTypeOptionsQuery, GetAutomationWidgetRequestTypeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationWidgetRequestTypeOptionsQuery, GetAutomationWidgetRequestTypeOptionsQueryVariables>(GetAutomationWidgetRequestTypeOptionsDocument, options);
        }
export type GetAutomationWidgetRequestTypeOptionsQueryHookResult = ReturnType<typeof useGetAutomationWidgetRequestTypeOptionsQuery>;
export type GetAutomationWidgetRequestTypeOptionsLazyQueryHookResult = ReturnType<typeof useGetAutomationWidgetRequestTypeOptionsLazyQuery>;
export type GetAutomationWidgetRequestTypeOptionsQueryResult = Apollo.QueryResult<GetAutomationWidgetRequestTypeOptionsQuery, GetAutomationWidgetRequestTypeOptionsQueryVariables>;
export function refetchGetAutomationWidgetRequestTypeOptionsQuery(variables?: GetAutomationWidgetRequestTypeOptionsQueryVariables) {
      return { query: GetAutomationWidgetRequestTypeOptionsDocument, variables: variables }
    }
export const GetAutomationsConversationStatusOptionsDocument = gql`
    query getAutomationsConversationStatusOptions($clinicId: String!) {
  findManyChannelStatus(
    where: {clinicSetting: {clinic: {id: {equals: $clinicId}}}, deletedOn: {equals: null}}
    orderBy: {name: asc}
  ) {
    id
    color
    name
    channelStatusAction
  }
}
    `;

/**
 * __useGetAutomationsConversationStatusOptionsQuery__
 *
 * To run a query within a React component, call `useGetAutomationsConversationStatusOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationsConversationStatusOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationsConversationStatusOptionsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAutomationsConversationStatusOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetAutomationsConversationStatusOptionsQuery, GetAutomationsConversationStatusOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationsConversationStatusOptionsQuery, GetAutomationsConversationStatusOptionsQueryVariables>(GetAutomationsConversationStatusOptionsDocument, options);
      }
export function useGetAutomationsConversationStatusOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationsConversationStatusOptionsQuery, GetAutomationsConversationStatusOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationsConversationStatusOptionsQuery, GetAutomationsConversationStatusOptionsQueryVariables>(GetAutomationsConversationStatusOptionsDocument, options);
        }
export type GetAutomationsConversationStatusOptionsQueryHookResult = ReturnType<typeof useGetAutomationsConversationStatusOptionsQuery>;
export type GetAutomationsConversationStatusOptionsLazyQueryHookResult = ReturnType<typeof useGetAutomationsConversationStatusOptionsLazyQuery>;
export type GetAutomationsConversationStatusOptionsQueryResult = Apollo.QueryResult<GetAutomationsConversationStatusOptionsQuery, GetAutomationsConversationStatusOptionsQueryVariables>;
export function refetchGetAutomationsConversationStatusOptionsQuery(variables?: GetAutomationsConversationStatusOptionsQueryVariables) {
      return { query: GetAutomationsConversationStatusOptionsDocument, variables: variables }
    }
export const GetAutomationsListDocument = gql`
    query getAutomationsList($clinicId: String!, $inEventType: [WorkflowEvent!], $triggerType: WorkflowEventTriggerType) {
  findManyWorkflowEventSetting(
    where: {clinic: {id: {equals: $clinicId}}, triggerType: {equals: $triggerType}, event: {not: {equals: ServiceReminder_FormSubmitted}, in: $inEventType}, surveySettingId: null, deletedAt: null}
    orderBy: {name: asc}
  ) {
    ...AutomationsListItem
  }
}
    ${AutomationsListItemFragmentDoc}`;

/**
 * __useGetAutomationsListQuery__
 *
 * To run a query within a React component, call `useGetAutomationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationsListQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      inEventType: // value for 'inEventType'
 *      triggerType: // value for 'triggerType'
 *   },
 * });
 */
export function useGetAutomationsListQuery(baseOptions: Apollo.QueryHookOptions<GetAutomationsListQuery, GetAutomationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationsListQuery, GetAutomationsListQueryVariables>(GetAutomationsListDocument, options);
      }
export function useGetAutomationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationsListQuery, GetAutomationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationsListQuery, GetAutomationsListQueryVariables>(GetAutomationsListDocument, options);
        }
export type GetAutomationsListQueryHookResult = ReturnType<typeof useGetAutomationsListQuery>;
export type GetAutomationsListLazyQueryHookResult = ReturnType<typeof useGetAutomationsListLazyQuery>;
export type GetAutomationsListQueryResult = Apollo.QueryResult<GetAutomationsListQuery, GetAutomationsListQueryVariables>;
export function refetchGetAutomationsListQuery(variables?: GetAutomationsListQueryVariables) {
      return { query: GetAutomationsListDocument, variables: variables }
    }
export const GetAutomationsSelectionListDocument = gql`
    query getAutomationsSelectionList($clinicId: String!, $inEventType: [WorkflowEvent!], $triggerType: WorkflowEventTriggerType) {
  findManyWorkflowEventSetting(
    where: {clinic: {id: {equals: $clinicId}}, triggerType: {equals: $triggerType}, event: {not: {equals: ServiceReminder_FormSubmitted}, in: $inEventType}, surveySettingId: null, deletedAt: null}
    orderBy: {name: asc}
  ) {
    ...AutomationsSelectionListAutomation
  }
}
    ${AutomationsSelectionListAutomationFragmentDoc}`;

/**
 * __useGetAutomationsSelectionListQuery__
 *
 * To run a query within a React component, call `useGetAutomationsSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationsSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationsSelectionListQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      inEventType: // value for 'inEventType'
 *      triggerType: // value for 'triggerType'
 *   },
 * });
 */
export function useGetAutomationsSelectionListQuery(baseOptions: Apollo.QueryHookOptions<GetAutomationsSelectionListQuery, GetAutomationsSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationsSelectionListQuery, GetAutomationsSelectionListQueryVariables>(GetAutomationsSelectionListDocument, options);
      }
export function useGetAutomationsSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationsSelectionListQuery, GetAutomationsSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationsSelectionListQuery, GetAutomationsSelectionListQueryVariables>(GetAutomationsSelectionListDocument, options);
        }
export type GetAutomationsSelectionListQueryHookResult = ReturnType<typeof useGetAutomationsSelectionListQuery>;
export type GetAutomationsSelectionListLazyQueryHookResult = ReturnType<typeof useGetAutomationsSelectionListLazyQuery>;
export type GetAutomationsSelectionListQueryResult = Apollo.QueryResult<GetAutomationsSelectionListQuery, GetAutomationsSelectionListQueryVariables>;
export function refetchGetAutomationsSelectionListQuery(variables?: GetAutomationsSelectionListQueryVariables) {
      return { query: GetAutomationsSelectionListDocument, variables: variables }
    }
export const GetGlobalAutomationsListDocument = gql`
    query getGlobalAutomationsList($inEventType: [WorkflowEvent!], $triggerType: WorkflowEventTriggerType) {
  findManyWorkflowEventSetting(
    where: {clinic: null, triggerType: {equals: $triggerType}, event: {not: {equals: ServiceReminder_FormSubmitted}, in: $inEventType}, surveySettingId: null, deletedAt: null}
    orderBy: {name: asc}
  ) {
    ...AutomationsListItem
  }
}
    ${AutomationsListItemFragmentDoc}`;

/**
 * __useGetGlobalAutomationsListQuery__
 *
 * To run a query within a React component, call `useGetGlobalAutomationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalAutomationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalAutomationsListQuery({
 *   variables: {
 *      inEventType: // value for 'inEventType'
 *      triggerType: // value for 'triggerType'
 *   },
 * });
 */
export function useGetGlobalAutomationsListQuery(baseOptions?: Apollo.QueryHookOptions<GetGlobalAutomationsListQuery, GetGlobalAutomationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalAutomationsListQuery, GetGlobalAutomationsListQueryVariables>(GetGlobalAutomationsListDocument, options);
      }
export function useGetGlobalAutomationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalAutomationsListQuery, GetGlobalAutomationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalAutomationsListQuery, GetGlobalAutomationsListQueryVariables>(GetGlobalAutomationsListDocument, options);
        }
export type GetGlobalAutomationsListQueryHookResult = ReturnType<typeof useGetGlobalAutomationsListQuery>;
export type GetGlobalAutomationsListLazyQueryHookResult = ReturnType<typeof useGetGlobalAutomationsListLazyQuery>;
export type GetGlobalAutomationsListQueryResult = Apollo.QueryResult<GetGlobalAutomationsListQuery, GetGlobalAutomationsListQueryVariables>;
export function refetchGetGlobalAutomationsListQuery(variables?: GetGlobalAutomationsListQueryVariables) {
      return { query: GetGlobalAutomationsListDocument, variables: variables }
    }
export const UpdateUserBoardFilterSettingsDocument = gql`
    mutation updateUserBoardFilterSettings($data: CustomUpsertOneUserBoardFilterDataInput!, $where: CustomUpsertOneUserBoardFilterWhereInput!) {
  customUpsertOneUserBoardFilter(data: $data, where: $where) {
    success
    error
  }
}
    `;
export type UpdateUserBoardFilterSettingsMutationFn = Apollo.MutationFunction<UpdateUserBoardFilterSettingsMutation, UpdateUserBoardFilterSettingsMutationVariables>;

/**
 * __useUpdateUserBoardFilterSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserBoardFilterSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserBoardFilterSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserBoardFilterSettingsMutation, { data, loading, error }] = useUpdateUserBoardFilterSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateUserBoardFilterSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserBoardFilterSettingsMutation, UpdateUserBoardFilterSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserBoardFilterSettingsMutation, UpdateUserBoardFilterSettingsMutationVariables>(UpdateUserBoardFilterSettingsDocument, options);
      }
export type UpdateUserBoardFilterSettingsMutationHookResult = ReturnType<typeof useUpdateUserBoardFilterSettingsMutation>;
export type UpdateUserBoardFilterSettingsMutationResult = Apollo.MutationResult<UpdateUserBoardFilterSettingsMutation>;
export type UpdateUserBoardFilterSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserBoardFilterSettingsMutation, UpdateUserBoardFilterSettingsMutationVariables>;
export const GetEmptyChannelStatusIdsDocument = gql`
    query getEmptyChannelStatusIds($where: GetChannelStatusIdsWithEntityCountOfZeroWhere!) {
  getChannelStatusIdsWithEntityCountOfZero(where: $where)
}
    `;

/**
 * __useGetEmptyChannelStatusIdsQuery__
 *
 * To run a query within a React component, call `useGetEmptyChannelStatusIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmptyChannelStatusIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmptyChannelStatusIdsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetEmptyChannelStatusIdsQuery(baseOptions: Apollo.QueryHookOptions<GetEmptyChannelStatusIdsQuery, GetEmptyChannelStatusIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmptyChannelStatusIdsQuery, GetEmptyChannelStatusIdsQueryVariables>(GetEmptyChannelStatusIdsDocument, options);
      }
export function useGetEmptyChannelStatusIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmptyChannelStatusIdsQuery, GetEmptyChannelStatusIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmptyChannelStatusIdsQuery, GetEmptyChannelStatusIdsQueryVariables>(GetEmptyChannelStatusIdsDocument, options);
        }
export type GetEmptyChannelStatusIdsQueryHookResult = ReturnType<typeof useGetEmptyChannelStatusIdsQuery>;
export type GetEmptyChannelStatusIdsLazyQueryHookResult = ReturnType<typeof useGetEmptyChannelStatusIdsLazyQuery>;
export type GetEmptyChannelStatusIdsQueryResult = Apollo.QueryResult<GetEmptyChannelStatusIdsQuery, GetEmptyChannelStatusIdsQueryVariables>;
export function refetchGetEmptyChannelStatusIdsQuery(variables?: GetEmptyChannelStatusIdsQueryVariables) {
      return { query: GetEmptyChannelStatusIdsDocument, variables: variables }
    }
export const GetPaginatedAutomationRunsDocument = gql`
    query getPaginatedAutomationRuns($where: AutomationRunWhereInput!, $orderBy: [AutomationRunOrderByWithRelationInput!], $skip: Int, $take: Int) {
  count: findManyAutomationRunCount(where: $where)
  automationRuns: findManyAutomationRun(
    where: $where
    orderBy: $orderBy
    skip: $skip
    take: $take
  ) {
    id
    status
    originAutomation {
      id
      name
    }
    appointment {
      id
      startAt
      durationInMinutes
      clinicPetParents {
        id
        ...BoardPetParent
      }
      clinicPet {
        id
        ...PetAvatar
      }
      channel {
        id
        lastMessage {
          id
          createdAt
        }
        updatedAt
        channelStatus {
          id
          ...ChannelListChannelStatus
        }
      }
    }
  }
}
    ${BoardPetParentFragmentDoc}
${PetAvatarFragmentDoc}
${ChannelListChannelStatusFragmentDoc}`;

/**
 * __useGetPaginatedAutomationRunsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedAutomationRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedAutomationRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedAutomationRunsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPaginatedAutomationRunsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedAutomationRunsQuery, GetPaginatedAutomationRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedAutomationRunsQuery, GetPaginatedAutomationRunsQueryVariables>(GetPaginatedAutomationRunsDocument, options);
      }
export function useGetPaginatedAutomationRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedAutomationRunsQuery, GetPaginatedAutomationRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedAutomationRunsQuery, GetPaginatedAutomationRunsQueryVariables>(GetPaginatedAutomationRunsDocument, options);
        }
export type GetPaginatedAutomationRunsQueryHookResult = ReturnType<typeof useGetPaginatedAutomationRunsQuery>;
export type GetPaginatedAutomationRunsLazyQueryHookResult = ReturnType<typeof useGetPaginatedAutomationRunsLazyQuery>;
export type GetPaginatedAutomationRunsQueryResult = Apollo.QueryResult<GetPaginatedAutomationRunsQuery, GetPaginatedAutomationRunsQueryVariables>;
export function refetchGetPaginatedAutomationRunsQuery(variables?: GetPaginatedAutomationRunsQueryVariables) {
      return { query: GetPaginatedAutomationRunsDocument, variables: variables }
    }
export const GetPaginatedChannelStatusesDocument = gql`
    query getPaginatedChannelStatuses($where: ChannelStatusWhereInput, $skip: Int, $take: Int) {
  count: findManyChannelStatusCount(where: $where)
  channelStatuses: findManyChannelStatus(
    where: $where
    take: $take
    skip: $skip
    orderBy: {order: asc}
  ) {
    id
    channelStatusAction
    color
    name
  }
}
    `;

/**
 * __useGetPaginatedChannelStatusesQuery__
 *
 * To run a query within a React component, call `useGetPaginatedChannelStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedChannelStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedChannelStatusesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPaginatedChannelStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetPaginatedChannelStatusesQuery, GetPaginatedChannelStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedChannelStatusesQuery, GetPaginatedChannelStatusesQueryVariables>(GetPaginatedChannelStatusesDocument, options);
      }
export function useGetPaginatedChannelStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedChannelStatusesQuery, GetPaginatedChannelStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedChannelStatusesQuery, GetPaginatedChannelStatusesQueryVariables>(GetPaginatedChannelStatusesDocument, options);
        }
export type GetPaginatedChannelStatusesQueryHookResult = ReturnType<typeof useGetPaginatedChannelStatusesQuery>;
export type GetPaginatedChannelStatusesLazyQueryHookResult = ReturnType<typeof useGetPaginatedChannelStatusesLazyQuery>;
export type GetPaginatedChannelStatusesQueryResult = Apollo.QueryResult<GetPaginatedChannelStatusesQuery, GetPaginatedChannelStatusesQueryVariables>;
export function refetchGetPaginatedChannelStatusesQuery(variables?: GetPaginatedChannelStatusesQueryVariables) {
      return { query: GetPaginatedChannelStatusesDocument, variables: variables }
    }
export const GetPaginatedChannelsDocument = gql`
    query getPaginatedChannels($where: ChannelWhereInput!, $orderBy: [ChannelOrderByWithRelationInput!], $skip: Int, $take: Int, $countOnly: Boolean!) {
  count: findManyChannelCount(where: $where)
  channels: findManyChannel(
    where: $where
    orderBy: $orderBy
    skip: $skip
    take: $take
  ) @skip(if: $countOnly) {
    ...ChannelListChannel
  }
}
    ${ChannelListChannelFragmentDoc}`;

/**
 * __useGetPaginatedChannelsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedChannelsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      countOnly: // value for 'countOnly'
 *   },
 * });
 */
export function useGetPaginatedChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedChannelsQuery, GetPaginatedChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedChannelsQuery, GetPaginatedChannelsQueryVariables>(GetPaginatedChannelsDocument, options);
      }
export function useGetPaginatedChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedChannelsQuery, GetPaginatedChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedChannelsQuery, GetPaginatedChannelsQueryVariables>(GetPaginatedChannelsDocument, options);
        }
export type GetPaginatedChannelsQueryHookResult = ReturnType<typeof useGetPaginatedChannelsQuery>;
export type GetPaginatedChannelsLazyQueryHookResult = ReturnType<typeof useGetPaginatedChannelsLazyQuery>;
export type GetPaginatedChannelsQueryResult = Apollo.QueryResult<GetPaginatedChannelsQuery, GetPaginatedChannelsQueryVariables>;
export function refetchGetPaginatedChannelsQuery(variables?: GetPaginatedChannelsQueryVariables) {
      return { query: GetPaginatedChannelsDocument, variables: variables }
    }
export const GetUserBoardFilterSettingsDocument = gql`
    query getUserBoardFilterSettings($where: CustomFindUniqueUserBoardFilterWhereInput!) {
  customFindUniqueUserBoardFilter(where: $where) {
    currentView
    collapsedColumnsMap
    selectedChannelStatusIdsMap
    shouldHideEmptyColumns
    shouldCollapseNoStatusColumn
    dateRangeOption
    specificDateRange {
      gte
      lte
    }
  }
}
    `;

/**
 * __useGetUserBoardFilterSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserBoardFilterSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBoardFilterSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBoardFilterSettingsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUserBoardFilterSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetUserBoardFilterSettingsQuery, GetUserBoardFilterSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserBoardFilterSettingsQuery, GetUserBoardFilterSettingsQueryVariables>(GetUserBoardFilterSettingsDocument, options);
      }
export function useGetUserBoardFilterSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserBoardFilterSettingsQuery, GetUserBoardFilterSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserBoardFilterSettingsQuery, GetUserBoardFilterSettingsQueryVariables>(GetUserBoardFilterSettingsDocument, options);
        }
export type GetUserBoardFilterSettingsQueryHookResult = ReturnType<typeof useGetUserBoardFilterSettingsQuery>;
export type GetUserBoardFilterSettingsLazyQueryHookResult = ReturnType<typeof useGetUserBoardFilterSettingsLazyQuery>;
export type GetUserBoardFilterSettingsQueryResult = Apollo.QueryResult<GetUserBoardFilterSettingsQuery, GetUserBoardFilterSettingsQueryVariables>;
export function refetchGetUserBoardFilterSettingsQuery(variables?: GetUserBoardFilterSettingsQueryVariables) {
      return { query: GetUserBoardFilterSettingsDocument, variables: variables }
    }
export const CreateChannelFilterSelectionDocument = gql`
    mutation createChannelFilterSelection($data: CreateChannelFilterSelectionInput!) {
  createChannelFilterSelection(data: $data) {
    ...ChannelFilterSelection
  }
}
    ${ChannelFilterSelectionFragmentDoc}`;
export type CreateChannelFilterSelectionMutationFn = Apollo.MutationFunction<CreateChannelFilterSelectionMutation, CreateChannelFilterSelectionMutationVariables>;

/**
 * __useCreateChannelFilterSelectionMutation__
 *
 * To run a mutation, you first call `useCreateChannelFilterSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelFilterSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelFilterSelectionMutation, { data, loading, error }] = useCreateChannelFilterSelectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChannelFilterSelectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateChannelFilterSelectionMutation, CreateChannelFilterSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChannelFilterSelectionMutation, CreateChannelFilterSelectionMutationVariables>(CreateChannelFilterSelectionDocument, options);
      }
export type CreateChannelFilterSelectionMutationHookResult = ReturnType<typeof useCreateChannelFilterSelectionMutation>;
export type CreateChannelFilterSelectionMutationResult = Apollo.MutationResult<CreateChannelFilterSelectionMutation>;
export type CreateChannelFilterSelectionMutationOptions = Apollo.BaseMutationOptions<CreateChannelFilterSelectionMutation, CreateChannelFilterSelectionMutationVariables>;
export const DeleteChannelFilterSelectionDocument = gql`
    mutation deleteChannelFilterSelection($channelFilterSelectionId: String!) {
  deleteChannelFilterSelection(id: $channelFilterSelectionId) {
    ...ChannelFilterSelection
  }
}
    ${ChannelFilterSelectionFragmentDoc}`;
export type DeleteChannelFilterSelectionMutationFn = Apollo.MutationFunction<DeleteChannelFilterSelectionMutation, DeleteChannelFilterSelectionMutationVariables>;

/**
 * __useDeleteChannelFilterSelectionMutation__
 *
 * To run a mutation, you first call `useDeleteChannelFilterSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelFilterSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelFilterSelectionMutation, { data, loading, error }] = useDeleteChannelFilterSelectionMutation({
 *   variables: {
 *      channelFilterSelectionId: // value for 'channelFilterSelectionId'
 *   },
 * });
 */
export function useDeleteChannelFilterSelectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChannelFilterSelectionMutation, DeleteChannelFilterSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChannelFilterSelectionMutation, DeleteChannelFilterSelectionMutationVariables>(DeleteChannelFilterSelectionDocument, options);
      }
export type DeleteChannelFilterSelectionMutationHookResult = ReturnType<typeof useDeleteChannelFilterSelectionMutation>;
export type DeleteChannelFilterSelectionMutationResult = Apollo.MutationResult<DeleteChannelFilterSelectionMutation>;
export type DeleteChannelFilterSelectionMutationOptions = Apollo.BaseMutationOptions<DeleteChannelFilterSelectionMutation, DeleteChannelFilterSelectionMutationVariables>;
export const UpdateChannelFilterSelectionDocument = gql`
    mutation updateChannelFilterSelection($data: UpdateChannelFilterSelectionInput!) {
  updateChannelFilterSelection(data: $data) {
    ...ChannelFilterSelection
  }
}
    ${ChannelFilterSelectionFragmentDoc}`;
export type UpdateChannelFilterSelectionMutationFn = Apollo.MutationFunction<UpdateChannelFilterSelectionMutation, UpdateChannelFilterSelectionMutationVariables>;

/**
 * __useUpdateChannelFilterSelectionMutation__
 *
 * To run a mutation, you first call `useUpdateChannelFilterSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelFilterSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelFilterSelectionMutation, { data, loading, error }] = useUpdateChannelFilterSelectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChannelFilterSelectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelFilterSelectionMutation, UpdateChannelFilterSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelFilterSelectionMutation, UpdateChannelFilterSelectionMutationVariables>(UpdateChannelFilterSelectionDocument, options);
      }
export type UpdateChannelFilterSelectionMutationHookResult = ReturnType<typeof useUpdateChannelFilterSelectionMutation>;
export type UpdateChannelFilterSelectionMutationResult = Apollo.MutationResult<UpdateChannelFilterSelectionMutation>;
export type UpdateChannelFilterSelectionMutationOptions = Apollo.BaseMutationOptions<UpdateChannelFilterSelectionMutation, UpdateChannelFilterSelectionMutationVariables>;
export const GetChannelFilterSelectionsDocument = gql`
    query getChannelFilterSelections {
  savedChannelFilterSelections(orderBy: {id: asc}) {
    ...ChannelFilterSelection
  }
}
    ${ChannelFilterSelectionFragmentDoc}`;

/**
 * __useGetChannelFilterSelectionsQuery__
 *
 * To run a query within a React component, call `useGetChannelFilterSelectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelFilterSelectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelFilterSelectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChannelFilterSelectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelFilterSelectionsQuery, GetChannelFilterSelectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelFilterSelectionsQuery, GetChannelFilterSelectionsQueryVariables>(GetChannelFilterSelectionsDocument, options);
      }
export function useGetChannelFilterSelectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelFilterSelectionsQuery, GetChannelFilterSelectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelFilterSelectionsQuery, GetChannelFilterSelectionsQueryVariables>(GetChannelFilterSelectionsDocument, options);
        }
export type GetChannelFilterSelectionsQueryHookResult = ReturnType<typeof useGetChannelFilterSelectionsQuery>;
export type GetChannelFilterSelectionsLazyQueryHookResult = ReturnType<typeof useGetChannelFilterSelectionsLazyQuery>;
export type GetChannelFilterSelectionsQueryResult = Apollo.QueryResult<GetChannelFilterSelectionsQuery, GetChannelFilterSelectionsQueryVariables>;
export function refetchGetChannelFilterSelectionsQuery(variables?: GetChannelFilterSelectionsQueryVariables) {
      return { query: GetChannelFilterSelectionsDocument, variables: variables }
    }
export const DeleteChannelMessageDocument = gql`
    mutation deleteChannelMessage($where: ChannelMessageWhereUniqueInput!) {
  deleteOneChannelMessage(where: $where) {
    id
  }
}
    `;
export type DeleteChannelMessageMutationFn = Apollo.MutationFunction<DeleteChannelMessageMutation, DeleteChannelMessageMutationVariables>;

/**
 * __useDeleteChannelMessageMutation__
 *
 * To run a mutation, you first call `useDeleteChannelMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelMessageMutation, { data, loading, error }] = useDeleteChannelMessageMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteChannelMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChannelMessageMutation, DeleteChannelMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChannelMessageMutation, DeleteChannelMessageMutationVariables>(DeleteChannelMessageDocument, options);
      }
export type DeleteChannelMessageMutationHookResult = ReturnType<typeof useDeleteChannelMessageMutation>;
export type DeleteChannelMessageMutationResult = Apollo.MutationResult<DeleteChannelMessageMutation>;
export type DeleteChannelMessageMutationOptions = Apollo.BaseMutationOptions<DeleteChannelMessageMutation, DeleteChannelMessageMutationVariables>;
export const GetServiceReminderNotificationDocument = gql`
    query getServiceReminderNotification($serviceReminderNotificationId: String!) {
  findManyServiceReminderNotification(
    where: {id: {equals: $serviceReminderNotificationId}}
  ) {
    id
    queueAt
    hasResponded
    bundledNotifications {
      id
      hasResponded
      serviceReminder {
        id
        dueDate
        clinicPet {
          ...PetAvatar
        }
        service {
          id
          name
        }
      }
    }
    serviceReminder {
      id
      dueDate
      service {
        id
        name
      }
      clinicPet {
        ...PetAvatar
      }
    }
  }
}
    ${PetAvatarFragmentDoc}`;

/**
 * __useGetServiceReminderNotificationQuery__
 *
 * To run a query within a React component, call `useGetServiceReminderNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceReminderNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceReminderNotificationQuery({
 *   variables: {
 *      serviceReminderNotificationId: // value for 'serviceReminderNotificationId'
 *   },
 * });
 */
export function useGetServiceReminderNotificationQuery(baseOptions: Apollo.QueryHookOptions<GetServiceReminderNotificationQuery, GetServiceReminderNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceReminderNotificationQuery, GetServiceReminderNotificationQueryVariables>(GetServiceReminderNotificationDocument, options);
      }
export function useGetServiceReminderNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceReminderNotificationQuery, GetServiceReminderNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceReminderNotificationQuery, GetServiceReminderNotificationQueryVariables>(GetServiceReminderNotificationDocument, options);
        }
export type GetServiceReminderNotificationQueryHookResult = ReturnType<typeof useGetServiceReminderNotificationQuery>;
export type GetServiceReminderNotificationLazyQueryHookResult = ReturnType<typeof useGetServiceReminderNotificationLazyQuery>;
export type GetServiceReminderNotificationQueryResult = Apollo.QueryResult<GetServiceReminderNotificationQuery, GetServiceReminderNotificationQueryVariables>;
export function refetchGetServiceReminderNotificationQuery(variables?: GetServiceReminderNotificationQueryVariables) {
      return { query: GetServiceReminderNotificationDocument, variables: variables }
    }
export const GetChatEntitiesDocument = gql`
    query getChatEntities($appointmentWhereInput: AppointmentWhereInput, $formSubmissionsWhereInput: FormSubmissionWhereInput) {
  appointments: findManyAppointment(
    where: $appointmentWhereInput
    orderBy: {startAt: desc}
  ) {
    ...ChatEntityAppointment
  }
  formSubmissions: findManyFormSubmission(
    where: $formSubmissionsWhereInput
    orderBy: {createdAt: desc}
  ) {
    ...ChatEntityFormSubmission
  }
}
    ${ChatEntityAppointmentFragmentDoc}
${ChatEntityFormSubmissionFragmentDoc}`;

/**
 * __useGetChatEntitiesQuery__
 *
 * To run a query within a React component, call `useGetChatEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatEntitiesQuery({
 *   variables: {
 *      appointmentWhereInput: // value for 'appointmentWhereInput'
 *      formSubmissionsWhereInput: // value for 'formSubmissionsWhereInput'
 *   },
 * });
 */
export function useGetChatEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetChatEntitiesQuery, GetChatEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatEntitiesQuery, GetChatEntitiesQueryVariables>(GetChatEntitiesDocument, options);
      }
export function useGetChatEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatEntitiesQuery, GetChatEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatEntitiesQuery, GetChatEntitiesQueryVariables>(GetChatEntitiesDocument, options);
        }
export type GetChatEntitiesQueryHookResult = ReturnType<typeof useGetChatEntitiesQuery>;
export type GetChatEntitiesLazyQueryHookResult = ReturnType<typeof useGetChatEntitiesLazyQuery>;
export type GetChatEntitiesQueryResult = Apollo.QueryResult<GetChatEntitiesQuery, GetChatEntitiesQueryVariables>;
export function refetchGetChatEntitiesQuery(variables?: GetChatEntitiesQueryVariables) {
      return { query: GetChatEntitiesDocument, variables: variables }
    }
export const GetArchivedOverlayChannelStatusesDocument = gql`
    query getArchivedOverlayChannelStatuses($where: ChannelStatusWhereInput) {
  findManyChannelStatus(where: $where, orderBy: {order: asc}) {
    id
    channelStatusAction
    order
  }
}
    `;

/**
 * __useGetArchivedOverlayChannelStatusesQuery__
 *
 * To run a query within a React component, call `useGetArchivedOverlayChannelStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivedOverlayChannelStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivedOverlayChannelStatusesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetArchivedOverlayChannelStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetArchivedOverlayChannelStatusesQuery, GetArchivedOverlayChannelStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchivedOverlayChannelStatusesQuery, GetArchivedOverlayChannelStatusesQueryVariables>(GetArchivedOverlayChannelStatusesDocument, options);
      }
export function useGetArchivedOverlayChannelStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchivedOverlayChannelStatusesQuery, GetArchivedOverlayChannelStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchivedOverlayChannelStatusesQuery, GetArchivedOverlayChannelStatusesQueryVariables>(GetArchivedOverlayChannelStatusesDocument, options);
        }
export type GetArchivedOverlayChannelStatusesQueryHookResult = ReturnType<typeof useGetArchivedOverlayChannelStatusesQuery>;
export type GetArchivedOverlayChannelStatusesLazyQueryHookResult = ReturnType<typeof useGetArchivedOverlayChannelStatusesLazyQuery>;
export type GetArchivedOverlayChannelStatusesQueryResult = Apollo.QueryResult<GetArchivedOverlayChannelStatusesQuery, GetArchivedOverlayChannelStatusesQueryVariables>;
export function refetchGetArchivedOverlayChannelStatusesQuery(variables?: GetArchivedOverlayChannelStatusesQueryVariables) {
      return { query: GetArchivedOverlayChannelStatusesDocument, variables: variables }
    }
export const GetPetParentActiveChannelMembersDocument = gql`
    query getPetParentActiveChannelMembers($clinicPetParentIds: [String!]!) {
  findManyChannelMember(
    where: {channel: {channelStatus: {channelStatusAction: {equals: Active}}}, removedAt: {equals: null}, clinicPetParentId: {in: $clinicPetParentIds}}
  ) {
    id
    channelId
  }
}
    `;

/**
 * __useGetPetParentActiveChannelMembersQuery__
 *
 * To run a query within a React component, call `useGetPetParentActiveChannelMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPetParentActiveChannelMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPetParentActiveChannelMembersQuery({
 *   variables: {
 *      clinicPetParentIds: // value for 'clinicPetParentIds'
 *   },
 * });
 */
export function useGetPetParentActiveChannelMembersQuery(baseOptions: Apollo.QueryHookOptions<GetPetParentActiveChannelMembersQuery, GetPetParentActiveChannelMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPetParentActiveChannelMembersQuery, GetPetParentActiveChannelMembersQueryVariables>(GetPetParentActiveChannelMembersDocument, options);
      }
export function useGetPetParentActiveChannelMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPetParentActiveChannelMembersQuery, GetPetParentActiveChannelMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPetParentActiveChannelMembersQuery, GetPetParentActiveChannelMembersQueryVariables>(GetPetParentActiveChannelMembersDocument, options);
        }
export type GetPetParentActiveChannelMembersQueryHookResult = ReturnType<typeof useGetPetParentActiveChannelMembersQuery>;
export type GetPetParentActiveChannelMembersLazyQueryHookResult = ReturnType<typeof useGetPetParentActiveChannelMembersLazyQuery>;
export type GetPetParentActiveChannelMembersQueryResult = Apollo.QueryResult<GetPetParentActiveChannelMembersQuery, GetPetParentActiveChannelMembersQueryVariables>;
export function refetchGetPetParentActiveChannelMembersQuery(variables?: GetPetParentActiveChannelMembersQueryVariables) {
      return { query: GetPetParentActiveChannelMembersDocument, variables: variables }
    }
export const UpdateArchivedOverlayChannelStatusDocument = gql`
    mutation updateArchivedOverlayChannelStatus($where: ChannelWhereUniqueInput!, $data: ChannelUpdateInput!) {
  updateOneChannel(where: $where, data: $data) {
    id
    channelStatus {
      id
    }
  }
}
    `;
export type UpdateArchivedOverlayChannelStatusMutationFn = Apollo.MutationFunction<UpdateArchivedOverlayChannelStatusMutation, UpdateArchivedOverlayChannelStatusMutationVariables>;

/**
 * __useUpdateArchivedOverlayChannelStatusMutation__
 *
 * To run a mutation, you first call `useUpdateArchivedOverlayChannelStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArchivedOverlayChannelStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArchivedOverlayChannelStatusMutation, { data, loading, error }] = useUpdateArchivedOverlayChannelStatusMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateArchivedOverlayChannelStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArchivedOverlayChannelStatusMutation, UpdateArchivedOverlayChannelStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArchivedOverlayChannelStatusMutation, UpdateArchivedOverlayChannelStatusMutationVariables>(UpdateArchivedOverlayChannelStatusDocument, options);
      }
export type UpdateArchivedOverlayChannelStatusMutationHookResult = ReturnType<typeof useUpdateArchivedOverlayChannelStatusMutation>;
export type UpdateArchivedOverlayChannelStatusMutationResult = Apollo.MutationResult<UpdateArchivedOverlayChannelStatusMutation>;
export type UpdateArchivedOverlayChannelStatusMutationOptions = Apollo.BaseMutationOptions<UpdateArchivedOverlayChannelStatusMutation, UpdateArchivedOverlayChannelStatusMutationVariables>;
export const FindDocumentationDocument = gql`
    query findDocumentation($where: DocumentationWhereInput) {
  findManyDocumentation(where: $where) {
    ...Documentation
  }
}
    ${DocumentationFragmentDoc}`;

/**
 * __useFindDocumentationQuery__
 *
 * To run a query within a React component, call `useFindDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDocumentationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindDocumentationQuery(baseOptions?: Apollo.QueryHookOptions<FindDocumentationQuery, FindDocumentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDocumentationQuery, FindDocumentationQueryVariables>(FindDocumentationDocument, options);
      }
export function useFindDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDocumentationQuery, FindDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDocumentationQuery, FindDocumentationQueryVariables>(FindDocumentationDocument, options);
        }
export type FindDocumentationQueryHookResult = ReturnType<typeof useFindDocumentationQuery>;
export type FindDocumentationLazyQueryHookResult = ReturnType<typeof useFindDocumentationLazyQuery>;
export type FindDocumentationQueryResult = Apollo.QueryResult<FindDocumentationQuery, FindDocumentationQueryVariables>;
export function refetchFindDocumentationQuery(variables?: FindDocumentationQueryVariables) {
      return { query: FindDocumentationDocument, variables: variables }
    }
export const GetTeamMembersMentionListDocument = gql`
    query getTeamMembersMentionList($where: UserWhereInput) {
  findManyUser(where: $where, orderBy: {firstName: asc}) {
    ...TeamMemberMentionsList
  }
}
    ${TeamMemberMentionsListFragmentDoc}`;

/**
 * __useGetTeamMembersMentionListQuery__
 *
 * To run a query within a React component, call `useGetTeamMembersMentionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMembersMentionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMembersMentionListQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTeamMembersMentionListQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamMembersMentionListQuery, GetTeamMembersMentionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMembersMentionListQuery, GetTeamMembersMentionListQueryVariables>(GetTeamMembersMentionListDocument, options);
      }
export function useGetTeamMembersMentionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMembersMentionListQuery, GetTeamMembersMentionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMembersMentionListQuery, GetTeamMembersMentionListQueryVariables>(GetTeamMembersMentionListDocument, options);
        }
export type GetTeamMembersMentionListQueryHookResult = ReturnType<typeof useGetTeamMembersMentionListQuery>;
export type GetTeamMembersMentionListLazyQueryHookResult = ReturnType<typeof useGetTeamMembersMentionListLazyQuery>;
export type GetTeamMembersMentionListQueryResult = Apollo.QueryResult<GetTeamMembersMentionListQuery, GetTeamMembersMentionListQueryVariables>;
export function refetchGetTeamMembersMentionListQuery(variables?: GetTeamMembersMentionListQueryVariables) {
      return { query: GetTeamMembersMentionListDocument, variables: variables }
    }
export const CreateChannelMessageAutoResponseDocument = gql`
    mutation createChannelMessageAutoResponse($data: ChannelMessageAutoResponseCreateInput!) {
  createOneChannelMessageAutoResponse(data: $data) {
    id
  }
}
    `;
export type CreateChannelMessageAutoResponseMutationFn = Apollo.MutationFunction<CreateChannelMessageAutoResponseMutation, CreateChannelMessageAutoResponseMutationVariables>;

/**
 * __useCreateChannelMessageAutoResponseMutation__
 *
 * To run a mutation, you first call `useCreateChannelMessageAutoResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelMessageAutoResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelMessageAutoResponseMutation, { data, loading, error }] = useCreateChannelMessageAutoResponseMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChannelMessageAutoResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateChannelMessageAutoResponseMutation, CreateChannelMessageAutoResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChannelMessageAutoResponseMutation, CreateChannelMessageAutoResponseMutationVariables>(CreateChannelMessageAutoResponseDocument, options);
      }
export type CreateChannelMessageAutoResponseMutationHookResult = ReturnType<typeof useCreateChannelMessageAutoResponseMutation>;
export type CreateChannelMessageAutoResponseMutationResult = Apollo.MutationResult<CreateChannelMessageAutoResponseMutation>;
export type CreateChannelMessageAutoResponseMutationOptions = Apollo.BaseMutationOptions<CreateChannelMessageAutoResponseMutation, CreateChannelMessageAutoResponseMutationVariables>;
export const GetConversationsQuickReplyDocument = gql`
    query getConversationsQuickReply($where: ChannelSuggestedMessageWhereInput!, $alternatePrompt: String, $maxTokensToSample: Int) {
  aiChannelSuggestedMessage(
    where: $where
    alternatePrompt: $alternatePrompt
    maxTokensToSample: $maxTokensToSample
  ) {
    response
    parsedJson
  }
}
    `;

/**
 * __useGetConversationsQuickReplyQuery__
 *
 * To run a query within a React component, call `useGetConversationsQuickReplyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsQuickReplyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsQuickReplyQuery({
 *   variables: {
 *      where: // value for 'where'
 *      alternatePrompt: // value for 'alternatePrompt'
 *      maxTokensToSample: // value for 'maxTokensToSample'
 *   },
 * });
 */
export function useGetConversationsQuickReplyQuery(baseOptions: Apollo.QueryHookOptions<GetConversationsQuickReplyQuery, GetConversationsQuickReplyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationsQuickReplyQuery, GetConversationsQuickReplyQueryVariables>(GetConversationsQuickReplyDocument, options);
      }
export function useGetConversationsQuickReplyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationsQuickReplyQuery, GetConversationsQuickReplyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationsQuickReplyQuery, GetConversationsQuickReplyQueryVariables>(GetConversationsQuickReplyDocument, options);
        }
export type GetConversationsQuickReplyQueryHookResult = ReturnType<typeof useGetConversationsQuickReplyQuery>;
export type GetConversationsQuickReplyLazyQueryHookResult = ReturnType<typeof useGetConversationsQuickReplyLazyQuery>;
export type GetConversationsQuickReplyQueryResult = Apollo.QueryResult<GetConversationsQuickReplyQuery, GetConversationsQuickReplyQueryVariables>;
export function refetchGetConversationsQuickReplyQuery(variables?: GetConversationsQuickReplyQueryVariables) {
      return { query: GetConversationsQuickReplyDocument, variables: variables }
    }
export const UpdateChannelMessageAutoResponseDocument = gql`
    mutation updateChannelMessageAutoResponse($where: ChannelMessageAutoResponseWhereUniqueInput!, $data: ChannelMessageAutoResponseUpdateInput!) {
  updateOneChannelMessageAutoResponse(where: $where, data: $data) {
    id
  }
}
    `;
export type UpdateChannelMessageAutoResponseMutationFn = Apollo.MutationFunction<UpdateChannelMessageAutoResponseMutation, UpdateChannelMessageAutoResponseMutationVariables>;

/**
 * __useUpdateChannelMessageAutoResponseMutation__
 *
 * To run a mutation, you first call `useUpdateChannelMessageAutoResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelMessageAutoResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelMessageAutoResponseMutation, { data, loading, error }] = useUpdateChannelMessageAutoResponseMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChannelMessageAutoResponseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelMessageAutoResponseMutation, UpdateChannelMessageAutoResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelMessageAutoResponseMutation, UpdateChannelMessageAutoResponseMutationVariables>(UpdateChannelMessageAutoResponseDocument, options);
      }
export type UpdateChannelMessageAutoResponseMutationHookResult = ReturnType<typeof useUpdateChannelMessageAutoResponseMutation>;
export type UpdateChannelMessageAutoResponseMutationResult = Apollo.MutationResult<UpdateChannelMessageAutoResponseMutation>;
export type UpdateChannelMessageAutoResponseMutationOptions = Apollo.BaseMutationOptions<UpdateChannelMessageAutoResponseMutation, UpdateChannelMessageAutoResponseMutationVariables>;
export const GetConversationSummaryDocument = gql`
    query getConversationSummary($where: ChannelSummaryWhereInput!, $alternatePrompt: String, $maxTokensToSample: Int) {
  aiChannelSummary(
    where: $where
    alternatePrompt: $alternatePrompt
    maxTokensToSample: $maxTokensToSample
  ) {
    response
    parsedJson
  }
}
    `;

/**
 * __useGetConversationSummaryQuery__
 *
 * To run a query within a React component, call `useGetConversationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationSummaryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      alternatePrompt: // value for 'alternatePrompt'
 *      maxTokensToSample: // value for 'maxTokensToSample'
 *   },
 * });
 */
export function useGetConversationSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetConversationSummaryQuery, GetConversationSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationSummaryQuery, GetConversationSummaryQueryVariables>(GetConversationSummaryDocument, options);
      }
export function useGetConversationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationSummaryQuery, GetConversationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationSummaryQuery, GetConversationSummaryQueryVariables>(GetConversationSummaryDocument, options);
        }
export type GetConversationSummaryQueryHookResult = ReturnType<typeof useGetConversationSummaryQuery>;
export type GetConversationSummaryLazyQueryHookResult = ReturnType<typeof useGetConversationSummaryLazyQuery>;
export type GetConversationSummaryQueryResult = Apollo.QueryResult<GetConversationSummaryQuery, GetConversationSummaryQueryVariables>;
export function refetchGetConversationSummaryQuery(variables?: GetConversationSummaryQueryVariables) {
      return { query: GetConversationSummaryDocument, variables: variables }
    }
export const GetTeletriageConversationsDocument = gql`
    query getTeletriageConversations($where: TeletriageSearchChannelInput!, $take: Int!, $skip: Int!, $orderBy: ChannelOrderByWithRelationInput) {
  teletriageChannelSearch(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    total
    channels {
      ...TeletriageConversation
    }
  }
}
    ${TeletriageConversationFragmentDoc}`;

/**
 * __useGetTeletriageConversationsQuery__
 *
 * To run a query within a React component, call `useGetTeletriageConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeletriageConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeletriageConversationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetTeletriageConversationsQuery(baseOptions: Apollo.QueryHookOptions<GetTeletriageConversationsQuery, GetTeletriageConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeletriageConversationsQuery, GetTeletriageConversationsQueryVariables>(GetTeletriageConversationsDocument, options);
      }
export function useGetTeletriageConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeletriageConversationsQuery, GetTeletriageConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeletriageConversationsQuery, GetTeletriageConversationsQueryVariables>(GetTeletriageConversationsDocument, options);
        }
export type GetTeletriageConversationsQueryHookResult = ReturnType<typeof useGetTeletriageConversationsQuery>;
export type GetTeletriageConversationsLazyQueryHookResult = ReturnType<typeof useGetTeletriageConversationsLazyQuery>;
export type GetTeletriageConversationsQueryResult = Apollo.QueryResult<GetTeletriageConversationsQuery, GetTeletriageConversationsQueryVariables>;
export function refetchGetTeletriageConversationsQuery(variables?: GetTeletriageConversationsQueryVariables) {
      return { query: GetTeletriageConversationsDocument, variables: variables }
    }
export const GetTeletriageStatusesDocument = gql`
    query getTeletriageStatuses {
  getTeletriageStatuses {
    ...TeletriageStatus
  }
}
    ${TeletriageStatusFragmentDoc}`;

/**
 * __useGetTeletriageStatusesQuery__
 *
 * To run a query within a React component, call `useGetTeletriageStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeletriageStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeletriageStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeletriageStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetTeletriageStatusesQuery, GetTeletriageStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeletriageStatusesQuery, GetTeletriageStatusesQueryVariables>(GetTeletriageStatusesDocument, options);
      }
export function useGetTeletriageStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeletriageStatusesQuery, GetTeletriageStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeletriageStatusesQuery, GetTeletriageStatusesQueryVariables>(GetTeletriageStatusesDocument, options);
        }
export type GetTeletriageStatusesQueryHookResult = ReturnType<typeof useGetTeletriageStatusesQuery>;
export type GetTeletriageStatusesLazyQueryHookResult = ReturnType<typeof useGetTeletriageStatusesLazyQuery>;
export type GetTeletriageStatusesQueryResult = Apollo.QueryResult<GetTeletriageStatusesQuery, GetTeletriageStatusesQueryVariables>;
export function refetchGetTeletriageStatusesQuery(variables?: GetTeletriageStatusesQueryVariables) {
      return { query: GetTeletriageStatusesDocument, variables: variables }
    }
export const GetTeletriageUnreadMessageCountDocument = gql`
    query getTeletriageUnreadMessageCount($clinicIds: [String!]) {
  teletriageChannelUnreadMessageCount(clinicIds: $clinicIds) {
    client {
      total
      unreadChannels {
        channelId
        unreadMessageCount
      }
    }
  }
}
    `;

/**
 * __useGetTeletriageUnreadMessageCountQuery__
 *
 * To run a query within a React component, call `useGetTeletriageUnreadMessageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeletriageUnreadMessageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeletriageUnreadMessageCountQuery({
 *   variables: {
 *      clinicIds: // value for 'clinicIds'
 *   },
 * });
 */
export function useGetTeletriageUnreadMessageCountQuery(baseOptions?: Apollo.QueryHookOptions<GetTeletriageUnreadMessageCountQuery, GetTeletriageUnreadMessageCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeletriageUnreadMessageCountQuery, GetTeletriageUnreadMessageCountQueryVariables>(GetTeletriageUnreadMessageCountDocument, options);
      }
export function useGetTeletriageUnreadMessageCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeletriageUnreadMessageCountQuery, GetTeletriageUnreadMessageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeletriageUnreadMessageCountQuery, GetTeletriageUnreadMessageCountQueryVariables>(GetTeletriageUnreadMessageCountDocument, options);
        }
export type GetTeletriageUnreadMessageCountQueryHookResult = ReturnType<typeof useGetTeletriageUnreadMessageCountQuery>;
export type GetTeletriageUnreadMessageCountLazyQueryHookResult = ReturnType<typeof useGetTeletriageUnreadMessageCountLazyQuery>;
export type GetTeletriageUnreadMessageCountQueryResult = Apollo.QueryResult<GetTeletriageUnreadMessageCountQuery, GetTeletriageUnreadMessageCountQueryVariables>;
export function refetchGetTeletriageUnreadMessageCountQuery(variables?: GetTeletriageUnreadMessageCountQueryVariables) {
      return { query: GetTeletriageUnreadMessageCountDocument, variables: variables }
    }
export const GetTeletriageUserClinicsDocument = gql`
    query getTeletriageUserClinics {
  getTeletriageUserClinics {
    ...TeletriageClinic
  }
}
    ${TeletriageClinicFragmentDoc}`;

/**
 * __useGetTeletriageUserClinicsQuery__
 *
 * To run a query within a React component, call `useGetTeletriageUserClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeletriageUserClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeletriageUserClinicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeletriageUserClinicsQuery(baseOptions?: Apollo.QueryHookOptions<GetTeletriageUserClinicsQuery, GetTeletriageUserClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeletriageUserClinicsQuery, GetTeletriageUserClinicsQueryVariables>(GetTeletriageUserClinicsDocument, options);
      }
export function useGetTeletriageUserClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeletriageUserClinicsQuery, GetTeletriageUserClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeletriageUserClinicsQuery, GetTeletriageUserClinicsQueryVariables>(GetTeletriageUserClinicsDocument, options);
        }
export type GetTeletriageUserClinicsQueryHookResult = ReturnType<typeof useGetTeletriageUserClinicsQuery>;
export type GetTeletriageUserClinicsLazyQueryHookResult = ReturnType<typeof useGetTeletriageUserClinicsLazyQuery>;
export type GetTeletriageUserClinicsQueryResult = Apollo.QueryResult<GetTeletriageUserClinicsQuery, GetTeletriageUserClinicsQueryVariables>;
export function refetchGetTeletriageUserClinicsQuery(variables?: GetTeletriageUserClinicsQueryVariables) {
      return { query: GetTeletriageUserClinicsDocument, variables: variables }
    }
export const SubscribeToTeletriageConversationsDocument = gql`
    subscription subscribeToTeletriageConversations($where: TeletriageChannelSyncedToSearchWhereInput!) {
  teletriageChannelSyncedToSearch(where: $where) {
    id
  }
}
    `;

/**
 * __useSubscribeToTeletriageConversationsSubscription__
 *
 * To run a query within a React component, call `useSubscribeToTeletriageConversationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToTeletriageConversationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToTeletriageConversationsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToTeletriageConversationsSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToTeletriageConversationsSubscription, SubscribeToTeletriageConversationsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToTeletriageConversationsSubscription, SubscribeToTeletriageConversationsSubscriptionVariables>(SubscribeToTeletriageConversationsDocument, options);
      }
export type SubscribeToTeletriageConversationsSubscriptionHookResult = ReturnType<typeof useSubscribeToTeletriageConversationsSubscription>;
export type SubscribeToTeletriageConversationsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToTeletriageConversationsSubscription>;
export const SubscribeToTeletriageMessageChannelChangedDocument = gql`
    subscription subscribeToTeletriageMessageChannelChanged($where: SubscriptionTeletriageChannelMessageWhereInput!) {
  teletriageChannelMessageChanged(where: $where) {
    node {
      ...SubscriptionChannelMessage
    }
    mutation
  }
}
    ${SubscriptionChannelMessageFragmentDoc}`;

/**
 * __useSubscribeToTeletriageMessageChannelChangedSubscription__
 *
 * To run a query within a React component, call `useSubscribeToTeletriageMessageChannelChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToTeletriageMessageChannelChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToTeletriageMessageChannelChangedSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToTeletriageMessageChannelChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToTeletriageMessageChannelChangedSubscription, SubscribeToTeletriageMessageChannelChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToTeletriageMessageChannelChangedSubscription, SubscribeToTeletriageMessageChannelChangedSubscriptionVariables>(SubscribeToTeletriageMessageChannelChangedDocument, options);
      }
export type SubscribeToTeletriageMessageChannelChangedSubscriptionHookResult = ReturnType<typeof useSubscribeToTeletriageMessageChannelChangedSubscription>;
export type SubscribeToTeletriageMessageChannelChangedSubscriptionResult = Apollo.SubscriptionResult<SubscribeToTeletriageMessageChannelChangedSubscription>;
export const SubscribeToTeletriageUnreadMessageCountChangedDocument = gql`
    subscription subscribeToTeletriageUnreadMessageCountChanged($where: SubscriptionTeletriageChannelWhereInput!) {
  teletriageUnreadMessageCountChanged(where: $where) {
    node {
      id
    }
  }
}
    `;

/**
 * __useSubscribeToTeletriageUnreadMessageCountChangedSubscription__
 *
 * To run a query within a React component, call `useSubscribeToTeletriageUnreadMessageCountChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToTeletriageUnreadMessageCountChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToTeletriageUnreadMessageCountChangedSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToTeletriageUnreadMessageCountChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToTeletriageUnreadMessageCountChangedSubscription, SubscribeToTeletriageUnreadMessageCountChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToTeletriageUnreadMessageCountChangedSubscription, SubscribeToTeletriageUnreadMessageCountChangedSubscriptionVariables>(SubscribeToTeletriageUnreadMessageCountChangedDocument, options);
      }
export type SubscribeToTeletriageUnreadMessageCountChangedSubscriptionHookResult = ReturnType<typeof useSubscribeToTeletriageUnreadMessageCountChangedSubscription>;
export type SubscribeToTeletriageUnreadMessageCountChangedSubscriptionResult = Apollo.SubscriptionResult<SubscribeToTeletriageUnreadMessageCountChangedSubscription>;
export const ChannelExportToPimsDocument = gql`
    mutation channelExportToPims($where: ChannelExportWhereInput!) {
  channelExportToPims(where: $where) {
    success
    payload
  }
}
    `;
export type ChannelExportToPimsMutationFn = Apollo.MutationFunction<ChannelExportToPimsMutation, ChannelExportToPimsMutationVariables>;

/**
 * __useChannelExportToPimsMutation__
 *
 * To run a mutation, you first call `useChannelExportToPimsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChannelExportToPimsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [channelExportToPimsMutation, { data, loading, error }] = useChannelExportToPimsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useChannelExportToPimsMutation(baseOptions?: Apollo.MutationHookOptions<ChannelExportToPimsMutation, ChannelExportToPimsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChannelExportToPimsMutation, ChannelExportToPimsMutationVariables>(ChannelExportToPimsDocument, options);
      }
export type ChannelExportToPimsMutationHookResult = ReturnType<typeof useChannelExportToPimsMutation>;
export type ChannelExportToPimsMutationResult = Apollo.MutationResult<ChannelExportToPimsMutation>;
export type ChannelExportToPimsMutationOptions = Apollo.BaseMutationOptions<ChannelExportToPimsMutation, ChannelExportToPimsMutationVariables>;
export const ClearUnreadMessagesDocument = gql`
    mutation clearUnreadMessages($userId: String!, $clinicId: String) {
  clearUnreadMessages: clearUnreadMessages2(
    data: {userId: $userId, clinicId: $clinicId}
  ) {
    success
    payload
  }
}
    `;
export type ClearUnreadMessagesMutationFn = Apollo.MutationFunction<ClearUnreadMessagesMutation, ClearUnreadMessagesMutationVariables>;

/**
 * __useClearUnreadMessagesMutation__
 *
 * To run a mutation, you first call `useClearUnreadMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearUnreadMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearUnreadMessagesMutation, { data, loading, error }] = useClearUnreadMessagesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useClearUnreadMessagesMutation(baseOptions?: Apollo.MutationHookOptions<ClearUnreadMessagesMutation, ClearUnreadMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearUnreadMessagesMutation, ClearUnreadMessagesMutationVariables>(ClearUnreadMessagesDocument, options);
      }
export type ClearUnreadMessagesMutationHookResult = ReturnType<typeof useClearUnreadMessagesMutation>;
export type ClearUnreadMessagesMutationResult = Apollo.MutationResult<ClearUnreadMessagesMutation>;
export type ClearUnreadMessagesMutationOptions = Apollo.BaseMutationOptions<ClearUnreadMessagesMutation, ClearUnreadMessagesMutationVariables>;
export const ConfirmAppointmentDocument = gql`
    mutation confirmAppointment($where: AppointmentWhereUniqueInput) {
  confirmAppointment: confirmAppointment2(where: $where) {
    id
    status
  }
}
    `;
export type ConfirmAppointmentMutationFn = Apollo.MutationFunction<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>;

/**
 * __useConfirmAppointmentMutation__
 *
 * To run a mutation, you first call `useConfirmAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAppointmentMutation, { data, loading, error }] = useConfirmAppointmentMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useConfirmAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>(ConfirmAppointmentDocument, options);
      }
export type ConfirmAppointmentMutationHookResult = ReturnType<typeof useConfirmAppointmentMutation>;
export type ConfirmAppointmentMutationResult = Apollo.MutationResult<ConfirmAppointmentMutation>;
export type ConfirmAppointmentMutationOptions = Apollo.BaseMutationOptions<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>;
export const CreateChannelMessageDocument = gql`
    mutation createChannelMessage($data: ChannelMessageCreateInput!) {
  createChannelMessage2(data: $data) {
    ...ChannelViewChannelMessage
  }
}
    ${ChannelViewChannelMessageFragmentDoc}`;
export type CreateChannelMessageMutationFn = Apollo.MutationFunction<CreateChannelMessageMutation, CreateChannelMessageMutationVariables>;

/**
 * __useCreateChannelMessageMutation__
 *
 * To run a mutation, you first call `useCreateChannelMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelMessageMutation, { data, loading, error }] = useCreateChannelMessageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChannelMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateChannelMessageMutation, CreateChannelMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChannelMessageMutation, CreateChannelMessageMutationVariables>(CreateChannelMessageDocument, options);
      }
export type CreateChannelMessageMutationHookResult = ReturnType<typeof useCreateChannelMessageMutation>;
export type CreateChannelMessageMutationResult = Apollo.MutationResult<CreateChannelMessageMutation>;
export type CreateChannelMessageMutationOptions = Apollo.BaseMutationOptions<CreateChannelMessageMutation, CreateChannelMessageMutationVariables>;
export const CreateChannelPinDocument = gql`
    mutation createChannelPin($userId: String!, $channelId: String!) {
  createOneChannelPin(
    data: {user: {connect: {id: $userId}}, channel: {connect: {id: $channelId}}}
  ) {
    ...ChannelPin
  }
}
    ${ChannelPinFragmentDoc}`;
export type CreateChannelPinMutationFn = Apollo.MutationFunction<CreateChannelPinMutation, CreateChannelPinMutationVariables>;

/**
 * __useCreateChannelPinMutation__
 *
 * To run a mutation, you first call `useCreateChannelPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelPinMutation, { data, loading, error }] = useCreateChannelPinMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useCreateChannelPinMutation(baseOptions?: Apollo.MutationHookOptions<CreateChannelPinMutation, CreateChannelPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChannelPinMutation, CreateChannelPinMutationVariables>(CreateChannelPinDocument, options);
      }
export type CreateChannelPinMutationHookResult = ReturnType<typeof useCreateChannelPinMutation>;
export type CreateChannelPinMutationResult = Apollo.MutationResult<CreateChannelPinMutation>;
export type CreateChannelPinMutationOptions = Apollo.BaseMutationOptions<CreateChannelPinMutation, CreateChannelPinMutationVariables>;
export const DeleteChannelPinByUserAndChannelDocument = gql`
    mutation deleteChannelPinByUserAndChannel($userId: String!, $channelId: String!) {
  deleteManyChannelPin(
    where: {AND: [{userId: {equals: $userId}}, {channelId: {equals: $channelId}}]}
  ) {
    count
  }
}
    `;
export type DeleteChannelPinByUserAndChannelMutationFn = Apollo.MutationFunction<DeleteChannelPinByUserAndChannelMutation, DeleteChannelPinByUserAndChannelMutationVariables>;

/**
 * __useDeleteChannelPinByUserAndChannelMutation__
 *
 * To run a mutation, you first call `useDeleteChannelPinByUserAndChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelPinByUserAndChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelPinByUserAndChannelMutation, { data, loading, error }] = useDeleteChannelPinByUserAndChannelMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useDeleteChannelPinByUserAndChannelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChannelPinByUserAndChannelMutation, DeleteChannelPinByUserAndChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChannelPinByUserAndChannelMutation, DeleteChannelPinByUserAndChannelMutationVariables>(DeleteChannelPinByUserAndChannelDocument, options);
      }
export type DeleteChannelPinByUserAndChannelMutationHookResult = ReturnType<typeof useDeleteChannelPinByUserAndChannelMutation>;
export type DeleteChannelPinByUserAndChannelMutationResult = Apollo.MutationResult<DeleteChannelPinByUserAndChannelMutation>;
export type DeleteChannelPinByUserAndChannelMutationOptions = Apollo.BaseMutationOptions<DeleteChannelPinByUserAndChannelMutation, DeleteChannelPinByUserAndChannelMutationVariables>;
export const GetPaymentReceiptPdfDocument = gql`
    query getPaymentReceiptPdf($data: ExportItemizedInvoiceToReceiptPDFInput!) {
  exportItemizedInvoiceAsReceiptPDF(data: $data) {
    success
    base64PDF
  }
}
    `;

/**
 * __useGetPaymentReceiptPdfQuery__
 *
 * To run a query within a React component, call `useGetPaymentReceiptPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentReceiptPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentReceiptPdfQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetPaymentReceiptPdfQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentReceiptPdfQuery, GetPaymentReceiptPdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentReceiptPdfQuery, GetPaymentReceiptPdfQueryVariables>(GetPaymentReceiptPdfDocument, options);
      }
export function useGetPaymentReceiptPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentReceiptPdfQuery, GetPaymentReceiptPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentReceiptPdfQuery, GetPaymentReceiptPdfQueryVariables>(GetPaymentReceiptPdfDocument, options);
        }
export type GetPaymentReceiptPdfQueryHookResult = ReturnType<typeof useGetPaymentReceiptPdfQuery>;
export type GetPaymentReceiptPdfLazyQueryHookResult = ReturnType<typeof useGetPaymentReceiptPdfLazyQuery>;
export type GetPaymentReceiptPdfQueryResult = Apollo.QueryResult<GetPaymentReceiptPdfQuery, GetPaymentReceiptPdfQueryVariables>;
export function refetchGetPaymentReceiptPdfQuery(variables?: GetPaymentReceiptPdfQueryVariables) {
      return { query: GetPaymentReceiptPdfDocument, variables: variables }
    }
export const UpdateCareBenefitUsageDocument = gql`
    mutation updateCareBenefitUsage($where: CareBenefitUsageWhereUniqueInput!, $data: CareBenefitUsageUpdateInput!) {
  updateOneCareBenefitUsage(where: $where, data: $data) {
    id
    quantityUsed
    exhaustsBenefit
  }
}
    `;
export type UpdateCareBenefitUsageMutationFn = Apollo.MutationFunction<UpdateCareBenefitUsageMutation, UpdateCareBenefitUsageMutationVariables>;

/**
 * __useUpdateCareBenefitUsageMutation__
 *
 * To run a mutation, you first call `useUpdateCareBenefitUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCareBenefitUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCareBenefitUsageMutation, { data, loading, error }] = useUpdateCareBenefitUsageMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCareBenefitUsageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCareBenefitUsageMutation, UpdateCareBenefitUsageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCareBenefitUsageMutation, UpdateCareBenefitUsageMutationVariables>(UpdateCareBenefitUsageDocument, options);
      }
export type UpdateCareBenefitUsageMutationHookResult = ReturnType<typeof useUpdateCareBenefitUsageMutation>;
export type UpdateCareBenefitUsageMutationResult = Apollo.MutationResult<UpdateCareBenefitUsageMutation>;
export type UpdateCareBenefitUsageMutationOptions = Apollo.BaseMutationOptions<UpdateCareBenefitUsageMutation, UpdateCareBenefitUsageMutationVariables>;
export const UpdateOneCareBenefitUsageToInvoiceLineItemDocument = gql`
    mutation updateOneCareBenefitUsageToInvoiceLineItem($where: CareBenefitUsageToInvoiceLineItemWhereUniqueInput!, $data: CareBenefitUsageToInvoiceLineItemUpdateInput!) {
  updateOneCareBenefitUsageToInvoiceLineItem(where: $where, data: $data) {
    id
    adjustedAmount
  }
}
    `;
export type UpdateOneCareBenefitUsageToInvoiceLineItemMutationFn = Apollo.MutationFunction<UpdateOneCareBenefitUsageToInvoiceLineItemMutation, UpdateOneCareBenefitUsageToInvoiceLineItemMutationVariables>;

/**
 * __useUpdateOneCareBenefitUsageToInvoiceLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateOneCareBenefitUsageToInvoiceLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCareBenefitUsageToInvoiceLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCareBenefitUsageToInvoiceLineItemMutation, { data, loading, error }] = useUpdateOneCareBenefitUsageToInvoiceLineItemMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneCareBenefitUsageToInvoiceLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneCareBenefitUsageToInvoiceLineItemMutation, UpdateOneCareBenefitUsageToInvoiceLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneCareBenefitUsageToInvoiceLineItemMutation, UpdateOneCareBenefitUsageToInvoiceLineItemMutationVariables>(UpdateOneCareBenefitUsageToInvoiceLineItemDocument, options);
      }
export type UpdateOneCareBenefitUsageToInvoiceLineItemMutationHookResult = ReturnType<typeof useUpdateOneCareBenefitUsageToInvoiceLineItemMutation>;
export type UpdateOneCareBenefitUsageToInvoiceLineItemMutationResult = Apollo.MutationResult<UpdateOneCareBenefitUsageToInvoiceLineItemMutation>;
export type UpdateOneCareBenefitUsageToInvoiceLineItemMutationOptions = Apollo.BaseMutationOptions<UpdateOneCareBenefitUsageToInvoiceLineItemMutation, UpdateOneCareBenefitUsageToInvoiceLineItemMutationVariables>;
export const UpdateChannelAssigneesDocument = gql`
    mutation updateChannelAssignees($where: ChannelWhereUniqueInput!, $data: ChannelUpdateInput!) {
  updateOneChannel(where: $where, data: $data) {
    id
    channelStatus {
      id
    }
    assignees {
      id
    }
  }
}
    `;
export type UpdateChannelAssigneesMutationFn = Apollo.MutationFunction<UpdateChannelAssigneesMutation, UpdateChannelAssigneesMutationVariables>;

/**
 * __useUpdateChannelAssigneesMutation__
 *
 * To run a mutation, you first call `useUpdateChannelAssigneesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelAssigneesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelAssigneesMutation, { data, loading, error }] = useUpdateChannelAssigneesMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChannelAssigneesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelAssigneesMutation, UpdateChannelAssigneesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelAssigneesMutation, UpdateChannelAssigneesMutationVariables>(UpdateChannelAssigneesDocument, options);
      }
export type UpdateChannelAssigneesMutationHookResult = ReturnType<typeof useUpdateChannelAssigneesMutation>;
export type UpdateChannelAssigneesMutationResult = Apollo.MutationResult<UpdateChannelAssigneesMutation>;
export type UpdateChannelAssigneesMutationOptions = Apollo.BaseMutationOptions<UpdateChannelAssigneesMutation, UpdateChannelAssigneesMutationVariables>;
export const UpdateChannelMemberDocument = gql`
    mutation updateChannelMember($where: ChannelMemberWhereUniqueInput!, $data: ChannelMemberUpdateInput!) {
  updateOneChannelMember(where: $where, data: $data) {
    id
    lastConsumedMessageIndex
    removedAt
  }
}
    `;
export type UpdateChannelMemberMutationFn = Apollo.MutationFunction<UpdateChannelMemberMutation, UpdateChannelMemberMutationVariables>;

/**
 * __useUpdateChannelMemberMutation__
 *
 * To run a mutation, you first call `useUpdateChannelMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelMemberMutation, { data, loading, error }] = useUpdateChannelMemberMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChannelMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelMemberMutation, UpdateChannelMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelMemberMutation, UpdateChannelMemberMutationVariables>(UpdateChannelMemberDocument, options);
      }
export type UpdateChannelMemberMutationHookResult = ReturnType<typeof useUpdateChannelMemberMutation>;
export type UpdateChannelMemberMutationResult = Apollo.MutationResult<UpdateChannelMemberMutation>;
export type UpdateChannelMemberMutationOptions = Apollo.BaseMutationOptions<UpdateChannelMemberMutation, UpdateChannelMemberMutationVariables>;
export const UpdateChannelMessageAttributesDocument = gql`
    mutation updateChannelMessageAttributes($where: ChannelMessageWhereUniqueInput!, $data: ChannelMessageUpdateInput!) {
  updateChannelMessage: updateOneChannelMessage(where: $where, data: $data) {
    id
    attributes
    reactions {
      ...Reaction
    }
  }
}
    ${ReactionFragmentDoc}`;
export type UpdateChannelMessageAttributesMutationFn = Apollo.MutationFunction<UpdateChannelMessageAttributesMutation, UpdateChannelMessageAttributesMutationVariables>;

/**
 * __useUpdateChannelMessageAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateChannelMessageAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelMessageAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelMessageAttributesMutation, { data, loading, error }] = useUpdateChannelMessageAttributesMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChannelMessageAttributesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelMessageAttributesMutation, UpdateChannelMessageAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelMessageAttributesMutation, UpdateChannelMessageAttributesMutationVariables>(UpdateChannelMessageAttributesDocument, options);
      }
export type UpdateChannelMessageAttributesMutationHookResult = ReturnType<typeof useUpdateChannelMessageAttributesMutation>;
export type UpdateChannelMessageAttributesMutationResult = Apollo.MutationResult<UpdateChannelMessageAttributesMutation>;
export type UpdateChannelMessageAttributesMutationOptions = Apollo.BaseMutationOptions<UpdateChannelMessageAttributesMutation, UpdateChannelMessageAttributesMutationVariables>;
export const UpdateChannelPetsDocument = gql`
    mutation updateChannelPets($where: ChannelWhereUniqueInput!, $data: ChannelUpdateInput!) {
  updateOneChannel(where: $where, data: $data) {
    id
    pets {
      id
      ...ChannelViewChannelPet
    }
  }
}
    ${ChannelViewChannelPetFragmentDoc}`;
export type UpdateChannelPetsMutationFn = Apollo.MutationFunction<UpdateChannelPetsMutation, UpdateChannelPetsMutationVariables>;

/**
 * __useUpdateChannelPetsMutation__
 *
 * To run a mutation, you first call `useUpdateChannelPetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelPetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelPetsMutation, { data, loading, error }] = useUpdateChannelPetsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChannelPetsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelPetsMutation, UpdateChannelPetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelPetsMutation, UpdateChannelPetsMutationVariables>(UpdateChannelPetsDocument, options);
      }
export type UpdateChannelPetsMutationHookResult = ReturnType<typeof useUpdateChannelPetsMutation>;
export type UpdateChannelPetsMutationResult = Apollo.MutationResult<UpdateChannelPetsMutation>;
export type UpdateChannelPetsMutationOptions = Apollo.BaseMutationOptions<UpdateChannelPetsMutation, UpdateChannelPetsMutationVariables>;
export const UpdateLineItemDocument = gql`
    mutation updateLineItem($where: InvoiceLineItemWhereUniqueInput!, $data: InvoiceLineItemUpdateInput!) {
  updateOneInvoiceLineItem(where: $where, data: $data) {
    id
    connectedCareBenefits {
      id
      adjustedAmount
      careBenefitUsage {
        id
        quantityUsed
      }
    }
  }
}
    `;
export type UpdateLineItemMutationFn = Apollo.MutationFunction<UpdateLineItemMutation, UpdateLineItemMutationVariables>;

/**
 * __useUpdateLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLineItemMutation, { data, loading, error }] = useUpdateLineItemMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLineItemMutation, UpdateLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLineItemMutation, UpdateLineItemMutationVariables>(UpdateLineItemDocument, options);
      }
export type UpdateLineItemMutationHookResult = ReturnType<typeof useUpdateLineItemMutation>;
export type UpdateLineItemMutationResult = Apollo.MutationResult<UpdateLineItemMutation>;
export type UpdateLineItemMutationOptions = Apollo.BaseMutationOptions<UpdateLineItemMutation, UpdateLineItemMutationVariables>;
export const CalculateMultiplePetsBenefitsUsageDocument = gql`
    query calculateMultiplePetsBenefitsUsage($where: CalculateMultiplePetsBenefitUsageInput) {
  calculateMultiplePetsBenefitUsage(where: $where) {
    ...CalculateMultiplePetsBenefitUsage
  }
}
    ${CalculateMultiplePetsBenefitUsageFragmentDoc}`;

/**
 * __useCalculateMultiplePetsBenefitsUsageQuery__
 *
 * To run a query within a React component, call `useCalculateMultiplePetsBenefitsUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateMultiplePetsBenefitsUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateMultiplePetsBenefitsUsageQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCalculateMultiplePetsBenefitsUsageQuery(baseOptions?: Apollo.QueryHookOptions<CalculateMultiplePetsBenefitsUsageQuery, CalculateMultiplePetsBenefitsUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateMultiplePetsBenefitsUsageQuery, CalculateMultiplePetsBenefitsUsageQueryVariables>(CalculateMultiplePetsBenefitsUsageDocument, options);
      }
export function useCalculateMultiplePetsBenefitsUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateMultiplePetsBenefitsUsageQuery, CalculateMultiplePetsBenefitsUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateMultiplePetsBenefitsUsageQuery, CalculateMultiplePetsBenefitsUsageQueryVariables>(CalculateMultiplePetsBenefitsUsageDocument, options);
        }
export type CalculateMultiplePetsBenefitsUsageQueryHookResult = ReturnType<typeof useCalculateMultiplePetsBenefitsUsageQuery>;
export type CalculateMultiplePetsBenefitsUsageLazyQueryHookResult = ReturnType<typeof useCalculateMultiplePetsBenefitsUsageLazyQuery>;
export type CalculateMultiplePetsBenefitsUsageQueryResult = Apollo.QueryResult<CalculateMultiplePetsBenefitsUsageQuery, CalculateMultiplePetsBenefitsUsageQueryVariables>;
export function refetchCalculateMultiplePetsBenefitsUsageQuery(variables?: CalculateMultiplePetsBenefitsUsageQueryVariables) {
      return { query: CalculateMultiplePetsBenefitsUsageDocument, variables: variables }
    }
export const GetAssigneeChannelMembersDocument = gql`
    query getAssigneeChannelMembers($channelId: String!, $assigneeUserIds: [String!]!) {
  findManyChannelMember(
    where: {channelId: {equals: $channelId}, userId: {in: $assigneeUserIds}}
  ) {
    id
    lastConsumedMessageIndex
    user {
      id
      firstName
      lastName
      email
      type
    }
  }
}
    `;

/**
 * __useGetAssigneeChannelMembersQuery__
 *
 * To run a query within a React component, call `useGetAssigneeChannelMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssigneeChannelMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssigneeChannelMembersQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      assigneeUserIds: // value for 'assigneeUserIds'
 *   },
 * });
 */
export function useGetAssigneeChannelMembersQuery(baseOptions: Apollo.QueryHookOptions<GetAssigneeChannelMembersQuery, GetAssigneeChannelMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssigneeChannelMembersQuery, GetAssigneeChannelMembersQueryVariables>(GetAssigneeChannelMembersDocument, options);
      }
export function useGetAssigneeChannelMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssigneeChannelMembersQuery, GetAssigneeChannelMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssigneeChannelMembersQuery, GetAssigneeChannelMembersQueryVariables>(GetAssigneeChannelMembersDocument, options);
        }
export type GetAssigneeChannelMembersQueryHookResult = ReturnType<typeof useGetAssigneeChannelMembersQuery>;
export type GetAssigneeChannelMembersLazyQueryHookResult = ReturnType<typeof useGetAssigneeChannelMembersLazyQuery>;
export type GetAssigneeChannelMembersQueryResult = Apollo.QueryResult<GetAssigneeChannelMembersQuery, GetAssigneeChannelMembersQueryVariables>;
export function refetchGetAssigneeChannelMembersQuery(variables?: GetAssigneeChannelMembersQueryVariables) {
      return { query: GetAssigneeChannelMembersDocument, variables: variables }
    }
export const GetChannelAssigneeMenuDataDocument = gql`
    query getChannelAssigneeMenuData($channelId: String!, $clinicId: String) {
  findUniqueChannel(where: {id: $channelId}) {
    id
    assignees(
      where: {isActive: {equals: true}, vetInfo: {clinics: {some: {id: {equals: $clinicId}}}}}
    ) {
      ...ClinicUserAvatar
    }
  }
  users: findManyUser(
    where: {vetInfo: {clinics: {some: {id: {equals: $clinicId}}}}, isActive: {equals: true}}
  ) {
    ...ClinicUserAvatar
  }
}
    ${ClinicUserAvatarFragmentDoc}`;

/**
 * __useGetChannelAssigneeMenuDataQuery__
 *
 * To run a query within a React component, call `useGetChannelAssigneeMenuDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelAssigneeMenuDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelAssigneeMenuDataQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetChannelAssigneeMenuDataQuery(baseOptions: Apollo.QueryHookOptions<GetChannelAssigneeMenuDataQuery, GetChannelAssigneeMenuDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelAssigneeMenuDataQuery, GetChannelAssigneeMenuDataQueryVariables>(GetChannelAssigneeMenuDataDocument, options);
      }
export function useGetChannelAssigneeMenuDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelAssigneeMenuDataQuery, GetChannelAssigneeMenuDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelAssigneeMenuDataQuery, GetChannelAssigneeMenuDataQueryVariables>(GetChannelAssigneeMenuDataDocument, options);
        }
export type GetChannelAssigneeMenuDataQueryHookResult = ReturnType<typeof useGetChannelAssigneeMenuDataQuery>;
export type GetChannelAssigneeMenuDataLazyQueryHookResult = ReturnType<typeof useGetChannelAssigneeMenuDataLazyQuery>;
export type GetChannelAssigneeMenuDataQueryResult = Apollo.QueryResult<GetChannelAssigneeMenuDataQuery, GetChannelAssigneeMenuDataQueryVariables>;
export function refetchGetChannelAssigneeMenuDataQuery(variables?: GetChannelAssigneeMenuDataQueryVariables) {
      return { query: GetChannelAssigneeMenuDataDocument, variables: variables }
    }
export const GetChannelListChannelsDocument = gql`
    query getChannelListChannels($where: SearchChannelInput!, $take: Int!, $skip: Int!, $orderBy: ChannelOrderByWithRelationInput) {
  channelSearch(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    total
    channels {
      ...ChannelListChannel
    }
  }
}
    ${ChannelListChannelFragmentDoc}`;

/**
 * __useGetChannelListChannelsQuery__
 *
 * To run a query within a React component, call `useGetChannelListChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelListChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelListChannelsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetChannelListChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetChannelListChannelsQuery, GetChannelListChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelListChannelsQuery, GetChannelListChannelsQueryVariables>(GetChannelListChannelsDocument, options);
      }
export function useGetChannelListChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelListChannelsQuery, GetChannelListChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelListChannelsQuery, GetChannelListChannelsQueryVariables>(GetChannelListChannelsDocument, options);
        }
export type GetChannelListChannelsQueryHookResult = ReturnType<typeof useGetChannelListChannelsQuery>;
export type GetChannelListChannelsLazyQueryHookResult = ReturnType<typeof useGetChannelListChannelsLazyQuery>;
export type GetChannelListChannelsQueryResult = Apollo.QueryResult<GetChannelListChannelsQuery, GetChannelListChannelsQueryVariables>;
export function refetchGetChannelListChannelsQuery(variables?: GetChannelListChannelsQueryVariables) {
      return { query: GetChannelListChannelsDocument, variables: variables }
    }
export const GetChannelMembersConsumptionHorizonDocument = gql`
    query getChannelMembersConsumptionHorizon($where: ChannelMemberWhereInput!) {
  channelMembers: findManyChannelMember(where: $where) {
    id
    lastConsumedMessageIndex
  }
}
    `;

/**
 * __useGetChannelMembersConsumptionHorizonQuery__
 *
 * To run a query within a React component, call `useGetChannelMembersConsumptionHorizonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelMembersConsumptionHorizonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelMembersConsumptionHorizonQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetChannelMembersConsumptionHorizonQuery(baseOptions: Apollo.QueryHookOptions<GetChannelMembersConsumptionHorizonQuery, GetChannelMembersConsumptionHorizonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelMembersConsumptionHorizonQuery, GetChannelMembersConsumptionHorizonQueryVariables>(GetChannelMembersConsumptionHorizonDocument, options);
      }
export function useGetChannelMembersConsumptionHorizonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelMembersConsumptionHorizonQuery, GetChannelMembersConsumptionHorizonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelMembersConsumptionHorizonQuery, GetChannelMembersConsumptionHorizonQueryVariables>(GetChannelMembersConsumptionHorizonDocument, options);
        }
export type GetChannelMembersConsumptionHorizonQueryHookResult = ReturnType<typeof useGetChannelMembersConsumptionHorizonQuery>;
export type GetChannelMembersConsumptionHorizonLazyQueryHookResult = ReturnType<typeof useGetChannelMembersConsumptionHorizonLazyQuery>;
export type GetChannelMembersConsumptionHorizonQueryResult = Apollo.QueryResult<GetChannelMembersConsumptionHorizonQuery, GetChannelMembersConsumptionHorizonQueryVariables>;
export function refetchGetChannelMembersConsumptionHorizonQuery(variables?: GetChannelMembersConsumptionHorizonQueryVariables) {
      return { query: GetChannelMembersConsumptionHorizonDocument, variables: variables }
    }
export const GetChannelPdfDownloadDataDocument = gql`
    query getChannelPdfDownloadData($where: ChannelExportWhereInput!) {
  channelExport(where: $where) {
    fileType
    base64Encoding
  }
}
    `;

/**
 * __useGetChannelPdfDownloadDataQuery__
 *
 * To run a query within a React component, call `useGetChannelPdfDownloadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelPdfDownloadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelPdfDownloadDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetChannelPdfDownloadDataQuery(baseOptions: Apollo.QueryHookOptions<GetChannelPdfDownloadDataQuery, GetChannelPdfDownloadDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelPdfDownloadDataQuery, GetChannelPdfDownloadDataQueryVariables>(GetChannelPdfDownloadDataDocument, options);
      }
export function useGetChannelPdfDownloadDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelPdfDownloadDataQuery, GetChannelPdfDownloadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelPdfDownloadDataQuery, GetChannelPdfDownloadDataQueryVariables>(GetChannelPdfDownloadDataDocument, options);
        }
export type GetChannelPdfDownloadDataQueryHookResult = ReturnType<typeof useGetChannelPdfDownloadDataQuery>;
export type GetChannelPdfDownloadDataLazyQueryHookResult = ReturnType<typeof useGetChannelPdfDownloadDataLazyQuery>;
export type GetChannelPdfDownloadDataQueryResult = Apollo.QueryResult<GetChannelPdfDownloadDataQuery, GetChannelPdfDownloadDataQueryVariables>;
export function refetchGetChannelPdfDownloadDataQuery(variables?: GetChannelPdfDownloadDataQueryVariables) {
      return { query: GetChannelPdfDownloadDataDocument, variables: variables }
    }
export const GetChannelPetsDocument = gql`
    query getChannelPets($where: ClinicPetParentWhereInput, $petsWhere: ClinicPetWhereInput!, $petsTake: Int) {
  findManyClinicPetParent(where: $where) {
    id
    pets(where: $petsWhere, take: $petsTake) {
      id
      ...ChannelPet
    }
  }
}
    ${ChannelPetFragmentDoc}`;

/**
 * __useGetChannelPetsQuery__
 *
 * To run a query within a React component, call `useGetChannelPetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelPetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelPetsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      petsWhere: // value for 'petsWhere'
 *      petsTake: // value for 'petsTake'
 *   },
 * });
 */
export function useGetChannelPetsQuery(baseOptions: Apollo.QueryHookOptions<GetChannelPetsQuery, GetChannelPetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelPetsQuery, GetChannelPetsQueryVariables>(GetChannelPetsDocument, options);
      }
export function useGetChannelPetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelPetsQuery, GetChannelPetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelPetsQuery, GetChannelPetsQueryVariables>(GetChannelPetsDocument, options);
        }
export type GetChannelPetsQueryHookResult = ReturnType<typeof useGetChannelPetsQuery>;
export type GetChannelPetsLazyQueryHookResult = ReturnType<typeof useGetChannelPetsLazyQuery>;
export type GetChannelPetsQueryResult = Apollo.QueryResult<GetChannelPetsQuery, GetChannelPetsQueryVariables>;
export function refetchGetChannelPetsQuery(variables?: GetChannelPetsQueryVariables) {
      return { query: GetChannelPetsDocument, variables: variables }
    }
export const GetChannelViewChannelMessagesDocument = gql`
    query getChannelViewChannelMessages($where: ChannelMessageWhereInput!, $orderBy: [ChannelMessageOrderByWithRelationInput!], $cursor: ChannelMessageWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelMessage(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ChannelViewChannelMessage
  }
  findManyChannelMessageCount(where: $where)
}
    ${ChannelViewChannelMessageFragmentDoc}`;

/**
 * __useGetChannelViewChannelMessagesQuery__
 *
 * To run a query within a React component, call `useGetChannelViewChannelMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelViewChannelMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelViewChannelMessagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      cursor: // value for 'cursor'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetChannelViewChannelMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetChannelViewChannelMessagesQuery, GetChannelViewChannelMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelViewChannelMessagesQuery, GetChannelViewChannelMessagesQueryVariables>(GetChannelViewChannelMessagesDocument, options);
      }
export function useGetChannelViewChannelMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelViewChannelMessagesQuery, GetChannelViewChannelMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelViewChannelMessagesQuery, GetChannelViewChannelMessagesQueryVariables>(GetChannelViewChannelMessagesDocument, options);
        }
export type GetChannelViewChannelMessagesQueryHookResult = ReturnType<typeof useGetChannelViewChannelMessagesQuery>;
export type GetChannelViewChannelMessagesLazyQueryHookResult = ReturnType<typeof useGetChannelViewChannelMessagesLazyQuery>;
export type GetChannelViewChannelMessagesQueryResult = Apollo.QueryResult<GetChannelViewChannelMessagesQuery, GetChannelViewChannelMessagesQueryVariables>;
export function refetchGetChannelViewChannelMessagesQuery(variables?: GetChannelViewChannelMessagesQueryVariables) {
      return { query: GetChannelViewChannelMessagesDocument, variables: variables }
    }
export const GetChannelViewClientDropdownPetParentsDocument = gql`
    query getChannelViewClientDropdownPetParents($petIds: [String!]!) {
  findManyClinicPetParent(where: {pets: {some: {id: {in: $petIds}}}}) {
    ...ChannelViewClientDropdownClinicPetParent
  }
}
    ${ChannelViewClientDropdownClinicPetParentFragmentDoc}`;

/**
 * __useGetChannelViewClientDropdownPetParentsQuery__
 *
 * To run a query within a React component, call `useGetChannelViewClientDropdownPetParentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelViewClientDropdownPetParentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelViewClientDropdownPetParentsQuery({
 *   variables: {
 *      petIds: // value for 'petIds'
 *   },
 * });
 */
export function useGetChannelViewClientDropdownPetParentsQuery(baseOptions: Apollo.QueryHookOptions<GetChannelViewClientDropdownPetParentsQuery, GetChannelViewClientDropdownPetParentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelViewClientDropdownPetParentsQuery, GetChannelViewClientDropdownPetParentsQueryVariables>(GetChannelViewClientDropdownPetParentsDocument, options);
      }
export function useGetChannelViewClientDropdownPetParentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelViewClientDropdownPetParentsQuery, GetChannelViewClientDropdownPetParentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelViewClientDropdownPetParentsQuery, GetChannelViewClientDropdownPetParentsQueryVariables>(GetChannelViewClientDropdownPetParentsDocument, options);
        }
export type GetChannelViewClientDropdownPetParentsQueryHookResult = ReturnType<typeof useGetChannelViewClientDropdownPetParentsQuery>;
export type GetChannelViewClientDropdownPetParentsLazyQueryHookResult = ReturnType<typeof useGetChannelViewClientDropdownPetParentsLazyQuery>;
export type GetChannelViewClientDropdownPetParentsQueryResult = Apollo.QueryResult<GetChannelViewClientDropdownPetParentsQuery, GetChannelViewClientDropdownPetParentsQueryVariables>;
export function refetchGetChannelViewClientDropdownPetParentsQuery(variables?: GetChannelViewClientDropdownPetParentsQueryVariables) {
      return { query: GetChannelViewClientDropdownPetParentsDocument, variables: variables }
    }
export const GetClinicChannelViewChannelDocument = gql`
    query getClinicChannelViewChannel($channelId: String!, $clinicId: String!, $userId: String!) {
  findUniqueChannel(where: {id: $channelId}) {
    ...ChannelViewChannel
  }
}
    ${ChannelViewChannelFragmentDoc}`;

/**
 * __useGetClinicChannelViewChannelQuery__
 *
 * To run a query within a React component, call `useGetClinicChannelViewChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicChannelViewChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicChannelViewChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      clinicId: // value for 'clinicId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClinicChannelViewChannelQuery(baseOptions: Apollo.QueryHookOptions<GetClinicChannelViewChannelQuery, GetClinicChannelViewChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicChannelViewChannelQuery, GetClinicChannelViewChannelQueryVariables>(GetClinicChannelViewChannelDocument, options);
      }
export function useGetClinicChannelViewChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicChannelViewChannelQuery, GetClinicChannelViewChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicChannelViewChannelQuery, GetClinicChannelViewChannelQueryVariables>(GetClinicChannelViewChannelDocument, options);
        }
export type GetClinicChannelViewChannelQueryHookResult = ReturnType<typeof useGetClinicChannelViewChannelQuery>;
export type GetClinicChannelViewChannelLazyQueryHookResult = ReturnType<typeof useGetClinicChannelViewChannelLazyQuery>;
export type GetClinicChannelViewChannelQueryResult = Apollo.QueryResult<GetClinicChannelViewChannelQuery, GetClinicChannelViewChannelQueryVariables>;
export function refetchGetClinicChannelViewChannelQuery(variables?: GetClinicChannelViewChannelQueryVariables) {
      return { query: GetClinicChannelViewChannelDocument, variables: variables }
    }
export const GetClinicWidgetRequestDocument = gql`
    query getClinicWidgetRequest($where: ClinicWidgetRequestWhereUniqueInput!) {
  clinicWidgetRequest: findUniqueClinicWidgetRequest(where: $where) {
    id
    tasks {
      id
      status
    }
    clinicPetParent {
      id
      firstName
      lastName
      pimsId
      ...PetParentAvatar
      phoneNumbers {
        id
        number
        isPrimary
        isMobile
        isDeleted
        updatedAt
      }
    }
    clinicWidgetRequestType {
      id
      displayName
      requestType
    }
    formSubmission {
      id
      completedContent
    }
    url
    isVerified
    requestFormSubmission
  }
}
    ${PetParentAvatarFragmentDoc}`;

/**
 * __useGetClinicWidgetRequestQuery__
 *
 * To run a query within a React component, call `useGetClinicWidgetRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicWidgetRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicWidgetRequestQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicWidgetRequestQuery(baseOptions: Apollo.QueryHookOptions<GetClinicWidgetRequestQuery, GetClinicWidgetRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicWidgetRequestQuery, GetClinicWidgetRequestQueryVariables>(GetClinicWidgetRequestDocument, options);
      }
export function useGetClinicWidgetRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicWidgetRequestQuery, GetClinicWidgetRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicWidgetRequestQuery, GetClinicWidgetRequestQueryVariables>(GetClinicWidgetRequestDocument, options);
        }
export type GetClinicWidgetRequestQueryHookResult = ReturnType<typeof useGetClinicWidgetRequestQuery>;
export type GetClinicWidgetRequestLazyQueryHookResult = ReturnType<typeof useGetClinicWidgetRequestLazyQuery>;
export type GetClinicWidgetRequestQueryResult = Apollo.QueryResult<GetClinicWidgetRequestQuery, GetClinicWidgetRequestQueryVariables>;
export function refetchGetClinicWidgetRequestQuery(variables?: GetClinicWidgetRequestQueryVariables) {
      return { query: GetClinicWidgetRequestDocument, variables: variables }
    }
export const GetExportabilityCheckChannelDocument = gql`
    query getExportabilityCheckChannel($channelId: String!, $clinicId: String) {
  findUniqueChannel(where: {id: $channelId}) {
    ...ExportabilityCheckChannel
  }
}
    ${ExportabilityCheckChannelFragmentDoc}`;

/**
 * __useGetExportabilityCheckChannelQuery__
 *
 * To run a query within a React component, call `useGetExportabilityCheckChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportabilityCheckChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportabilityCheckChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetExportabilityCheckChannelQuery(baseOptions: Apollo.QueryHookOptions<GetExportabilityCheckChannelQuery, GetExportabilityCheckChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExportabilityCheckChannelQuery, GetExportabilityCheckChannelQueryVariables>(GetExportabilityCheckChannelDocument, options);
      }
export function useGetExportabilityCheckChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExportabilityCheckChannelQuery, GetExportabilityCheckChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExportabilityCheckChannelQuery, GetExportabilityCheckChannelQueryVariables>(GetExportabilityCheckChannelDocument, options);
        }
export type GetExportabilityCheckChannelQueryHookResult = ReturnType<typeof useGetExportabilityCheckChannelQuery>;
export type GetExportabilityCheckChannelLazyQueryHookResult = ReturnType<typeof useGetExportabilityCheckChannelLazyQuery>;
export type GetExportabilityCheckChannelQueryResult = Apollo.QueryResult<GetExportabilityCheckChannelQuery, GetExportabilityCheckChannelQueryVariables>;
export function refetchGetExportabilityCheckChannelQuery(variables?: GetExportabilityCheckChannelQueryVariables) {
      return { query: GetExportabilityCheckChannelDocument, variables: variables }
    }
export const GetMessageComposerAttachmentFormTemplateDocument = gql`
    query getMessageComposerAttachmentFormTemplate($where: FormTemplateWhereInput) {
  findFirstFormTemplate(where: $where) {
    id
    title
    content
  }
}
    `;

/**
 * __useGetMessageComposerAttachmentFormTemplateQuery__
 *
 * To run a query within a React component, call `useGetMessageComposerAttachmentFormTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageComposerAttachmentFormTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageComposerAttachmentFormTemplateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMessageComposerAttachmentFormTemplateQuery(baseOptions?: Apollo.QueryHookOptions<GetMessageComposerAttachmentFormTemplateQuery, GetMessageComposerAttachmentFormTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageComposerAttachmentFormTemplateQuery, GetMessageComposerAttachmentFormTemplateQueryVariables>(GetMessageComposerAttachmentFormTemplateDocument, options);
      }
export function useGetMessageComposerAttachmentFormTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageComposerAttachmentFormTemplateQuery, GetMessageComposerAttachmentFormTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageComposerAttachmentFormTemplateQuery, GetMessageComposerAttachmentFormTemplateQueryVariables>(GetMessageComposerAttachmentFormTemplateDocument, options);
        }
export type GetMessageComposerAttachmentFormTemplateQueryHookResult = ReturnType<typeof useGetMessageComposerAttachmentFormTemplateQuery>;
export type GetMessageComposerAttachmentFormTemplateLazyQueryHookResult = ReturnType<typeof useGetMessageComposerAttachmentFormTemplateLazyQuery>;
export type GetMessageComposerAttachmentFormTemplateQueryResult = Apollo.QueryResult<GetMessageComposerAttachmentFormTemplateQuery, GetMessageComposerAttachmentFormTemplateQueryVariables>;
export function refetchGetMessageComposerAttachmentFormTemplateQuery(variables?: GetMessageComposerAttachmentFormTemplateQueryVariables) {
      return { query: GetMessageComposerAttachmentFormTemplateDocument, variables: variables }
    }
export const GetMessageComposerFormTemplatesDocument = gql`
    query getMessageComposerFormTemplates($where: FormTemplateWhereInput!, $orderBy: [FormTemplateOrderByWithRelationInput!]) {
  findManyFormTemplate(where: $where, orderBy: $orderBy) {
    ...MessageComposerFormTemplate
  }
}
    ${MessageComposerFormTemplateFragmentDoc}`;

/**
 * __useGetMessageComposerFormTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMessageComposerFormTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageComposerFormTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageComposerFormTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetMessageComposerFormTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetMessageComposerFormTemplatesQuery, GetMessageComposerFormTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageComposerFormTemplatesQuery, GetMessageComposerFormTemplatesQueryVariables>(GetMessageComposerFormTemplatesDocument, options);
      }
export function useGetMessageComposerFormTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageComposerFormTemplatesQuery, GetMessageComposerFormTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageComposerFormTemplatesQuery, GetMessageComposerFormTemplatesQueryVariables>(GetMessageComposerFormTemplatesDocument, options);
        }
export type GetMessageComposerFormTemplatesQueryHookResult = ReturnType<typeof useGetMessageComposerFormTemplatesQuery>;
export type GetMessageComposerFormTemplatesLazyQueryHookResult = ReturnType<typeof useGetMessageComposerFormTemplatesLazyQuery>;
export type GetMessageComposerFormTemplatesQueryResult = Apollo.QueryResult<GetMessageComposerFormTemplatesQuery, GetMessageComposerFormTemplatesQueryVariables>;
export function refetchGetMessageComposerFormTemplatesQuery(variables?: GetMessageComposerFormTemplatesQueryVariables) {
      return { query: GetMessageComposerFormTemplatesDocument, variables: variables }
    }
export const GetMessageComposerMessageTemplatesDocument = gql`
    query getMessageComposerMessageTemplates($clinicId: String!) {
  findManyMessageTemplate(
    where: {clinicId: {equals: $clinicId}, isArchived: {equals: false}, type: {equals: Default}}
    orderBy: [{name: asc}, {createdAt: asc}]
  ) {
    ...MessageComposerMessageTemplate
  }
}
    ${MessageComposerMessageTemplateFragmentDoc}`;

/**
 * __useGetMessageComposerMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMessageComposerMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageComposerMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageComposerMessageTemplatesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetMessageComposerMessageTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetMessageComposerMessageTemplatesQuery, GetMessageComposerMessageTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageComposerMessageTemplatesQuery, GetMessageComposerMessageTemplatesQueryVariables>(GetMessageComposerMessageTemplatesDocument, options);
      }
export function useGetMessageComposerMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageComposerMessageTemplatesQuery, GetMessageComposerMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageComposerMessageTemplatesQuery, GetMessageComposerMessageTemplatesQueryVariables>(GetMessageComposerMessageTemplatesDocument, options);
        }
export type GetMessageComposerMessageTemplatesQueryHookResult = ReturnType<typeof useGetMessageComposerMessageTemplatesQuery>;
export type GetMessageComposerMessageTemplatesLazyQueryHookResult = ReturnType<typeof useGetMessageComposerMessageTemplatesLazyQuery>;
export type GetMessageComposerMessageTemplatesQueryResult = Apollo.QueryResult<GetMessageComposerMessageTemplatesQuery, GetMessageComposerMessageTemplatesQueryVariables>;
export function refetchGetMessageComposerMessageTemplatesQuery(variables?: GetMessageComposerMessageTemplatesQueryVariables) {
      return { query: GetMessageComposerMessageTemplatesDocument, variables: variables }
    }
export const GetPetParentPhoneNumbersDocument = gql`
    query getPetParentPhoneNumbers($clinicPetParentIds: [String!]!) {
  findManyClinicPetParent(where: {id: {in: $clinicPetParentIds}}) {
    id
    phoneNumbers {
      id
      updatedAt
      number
      isPrimary
      isDeleted
    }
  }
}
    `;

/**
 * __useGetPetParentPhoneNumbersQuery__
 *
 * To run a query within a React component, call `useGetPetParentPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPetParentPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPetParentPhoneNumbersQuery({
 *   variables: {
 *      clinicPetParentIds: // value for 'clinicPetParentIds'
 *   },
 * });
 */
export function useGetPetParentPhoneNumbersQuery(baseOptions: Apollo.QueryHookOptions<GetPetParentPhoneNumbersQuery, GetPetParentPhoneNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPetParentPhoneNumbersQuery, GetPetParentPhoneNumbersQueryVariables>(GetPetParentPhoneNumbersDocument, options);
      }
export function useGetPetParentPhoneNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPetParentPhoneNumbersQuery, GetPetParentPhoneNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPetParentPhoneNumbersQuery, GetPetParentPhoneNumbersQueryVariables>(GetPetParentPhoneNumbersDocument, options);
        }
export type GetPetParentPhoneNumbersQueryHookResult = ReturnType<typeof useGetPetParentPhoneNumbersQuery>;
export type GetPetParentPhoneNumbersLazyQueryHookResult = ReturnType<typeof useGetPetParentPhoneNumbersLazyQuery>;
export type GetPetParentPhoneNumbersQueryResult = Apollo.QueryResult<GetPetParentPhoneNumbersQuery, GetPetParentPhoneNumbersQueryVariables>;
export function refetchGetPetParentPhoneNumbersQuery(variables?: GetPetParentPhoneNumbersQueryVariables) {
      return { query: GetPetParentPhoneNumbersDocument, variables: variables }
    }
export const GetPinnedChannelListChannelsDocument = gql`
    query getPinnedChannelListChannels($where: SearchChannelInput!, $orderBy: ChannelOrderByWithRelationInput) {
  channelSearch(where: $where, orderBy: $orderBy) {
    total
    channels {
      ...ChannelListChannel
    }
  }
}
    ${ChannelListChannelFragmentDoc}`;

/**
 * __useGetPinnedChannelListChannelsQuery__
 *
 * To run a query within a React component, call `useGetPinnedChannelListChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPinnedChannelListChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPinnedChannelListChannelsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetPinnedChannelListChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetPinnedChannelListChannelsQuery, GetPinnedChannelListChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPinnedChannelListChannelsQuery, GetPinnedChannelListChannelsQueryVariables>(GetPinnedChannelListChannelsDocument, options);
      }
export function useGetPinnedChannelListChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPinnedChannelListChannelsQuery, GetPinnedChannelListChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPinnedChannelListChannelsQuery, GetPinnedChannelListChannelsQueryVariables>(GetPinnedChannelListChannelsDocument, options);
        }
export type GetPinnedChannelListChannelsQueryHookResult = ReturnType<typeof useGetPinnedChannelListChannelsQuery>;
export type GetPinnedChannelListChannelsLazyQueryHookResult = ReturnType<typeof useGetPinnedChannelListChannelsLazyQuery>;
export type GetPinnedChannelListChannelsQueryResult = Apollo.QueryResult<GetPinnedChannelListChannelsQuery, GetPinnedChannelListChannelsQueryVariables>;
export function refetchGetPinnedChannelListChannelsQuery(variables?: GetPinnedChannelListChannelsQueryVariables) {
      return { query: GetPinnedChannelListChannelsDocument, variables: variables }
    }
export const GetClinicServicesForInvoiceLineItemsDocument = gql`
    query getClinicServicesForInvoiceLineItems($where: ServiceWhereInput, $orderBy: [ServiceOrderByWithRelationInput!], $take: Int, $skip: Int) {
  findManyService(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    name
    code
    organizationCareBenefitToClinicService {
      benefit {
        id
        title
        description
        tangible
        providedDiscountPercentage
        usageUnitOfMeasure
        planBenefits {
          id
          includedUses
        }
      }
    }
  }
}
    `;

/**
 * __useGetClinicServicesForInvoiceLineItemsQuery__
 *
 * To run a query within a React component, call `useGetClinicServicesForInvoiceLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicServicesForInvoiceLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicServicesForInvoiceLineItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetClinicServicesForInvoiceLineItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicServicesForInvoiceLineItemsQuery, GetClinicServicesForInvoiceLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicServicesForInvoiceLineItemsQuery, GetClinicServicesForInvoiceLineItemsQueryVariables>(GetClinicServicesForInvoiceLineItemsDocument, options);
      }
export function useGetClinicServicesForInvoiceLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicServicesForInvoiceLineItemsQuery, GetClinicServicesForInvoiceLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicServicesForInvoiceLineItemsQuery, GetClinicServicesForInvoiceLineItemsQueryVariables>(GetClinicServicesForInvoiceLineItemsDocument, options);
        }
export type GetClinicServicesForInvoiceLineItemsQueryHookResult = ReturnType<typeof useGetClinicServicesForInvoiceLineItemsQuery>;
export type GetClinicServicesForInvoiceLineItemsLazyQueryHookResult = ReturnType<typeof useGetClinicServicesForInvoiceLineItemsLazyQuery>;
export type GetClinicServicesForInvoiceLineItemsQueryResult = Apollo.QueryResult<GetClinicServicesForInvoiceLineItemsQuery, GetClinicServicesForInvoiceLineItemsQueryVariables>;
export function refetchGetClinicServicesForInvoiceLineItemsQuery(variables?: GetClinicServicesForInvoiceLineItemsQueryVariables) {
      return { query: GetClinicServicesForInvoiceLineItemsDocument, variables: variables }
    }
export const GetSmsNotificationStatusDocument = gql`
    query getSmsNotificationStatus($where: SmsNotificationStatusWhereInput!) {
  findFirstSmsNotificationStatus(where: $where, orderBy: {createdAt: desc}) {
    ...SmsNotificationStatus
  }
}
    ${SmsNotificationStatusFragmentDoc}`;

/**
 * __useGetSmsNotificationStatusQuery__
 *
 * To run a query within a React component, call `useGetSmsNotificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsNotificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsNotificationStatusQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSmsNotificationStatusQuery(baseOptions: Apollo.QueryHookOptions<GetSmsNotificationStatusQuery, GetSmsNotificationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsNotificationStatusQuery, GetSmsNotificationStatusQueryVariables>(GetSmsNotificationStatusDocument, options);
      }
export function useGetSmsNotificationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsNotificationStatusQuery, GetSmsNotificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsNotificationStatusQuery, GetSmsNotificationStatusQueryVariables>(GetSmsNotificationStatusDocument, options);
        }
export type GetSmsNotificationStatusQueryHookResult = ReturnType<typeof useGetSmsNotificationStatusQuery>;
export type GetSmsNotificationStatusLazyQueryHookResult = ReturnType<typeof useGetSmsNotificationStatusLazyQuery>;
export type GetSmsNotificationStatusQueryResult = Apollo.QueryResult<GetSmsNotificationStatusQuery, GetSmsNotificationStatusQueryVariables>;
export function refetchGetSmsNotificationStatusQuery(variables?: GetSmsNotificationStatusQueryVariables) {
      return { query: GetSmsNotificationStatusDocument, variables: variables }
    }
export const SubscribeToAutomationRunActionDocument = gql`
    subscription subscribeToAutomationRunAction($automationRunId: String!) {
  automationRunActionChanged(
    where: {node: {automationRunId: {equals: $automationRunId}}}
  ) {
    node {
      ...AutomationRunAction
    }
  }
}
    ${AutomationRunActionFragmentDoc}`;

/**
 * __useSubscribeToAutomationRunActionSubscription__
 *
 * To run a query within a React component, call `useSubscribeToAutomationRunActionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToAutomationRunActionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToAutomationRunActionSubscription({
 *   variables: {
 *      automationRunId: // value for 'automationRunId'
 *   },
 * });
 */
export function useSubscribeToAutomationRunActionSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToAutomationRunActionSubscription, SubscribeToAutomationRunActionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToAutomationRunActionSubscription, SubscribeToAutomationRunActionSubscriptionVariables>(SubscribeToAutomationRunActionDocument, options);
      }
export type SubscribeToAutomationRunActionSubscriptionHookResult = ReturnType<typeof useSubscribeToAutomationRunActionSubscription>;
export type SubscribeToAutomationRunActionSubscriptionResult = Apollo.SubscriptionResult<SubscribeToAutomationRunActionSubscription>;
export const SubscribeToChannelListChannelsDocument = gql`
    subscription subscribeToChannelListChannels($clinicId: String!) {
  channelSyncedToSearch(where: {clinicId: $clinicId}) {
    id
  }
}
    `;

/**
 * __useSubscribeToChannelListChannelsSubscription__
 *
 * To run a query within a React component, call `useSubscribeToChannelListChannelsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToChannelListChannelsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToChannelListChannelsSubscription({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useSubscribeToChannelListChannelsSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToChannelListChannelsSubscription, SubscribeToChannelListChannelsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToChannelListChannelsSubscription, SubscribeToChannelListChannelsSubscriptionVariables>(SubscribeToChannelListChannelsDocument, options);
      }
export type SubscribeToChannelListChannelsSubscriptionHookResult = ReturnType<typeof useSubscribeToChannelListChannelsSubscription>;
export type SubscribeToChannelListChannelsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToChannelListChannelsSubscription>;
export const SubscribeToChannelMessageAttachmentDocument = gql`
    subscription subscribeToChannelMessageAttachment($channelMessageAttachmentId: String!) {
  channelMessageAttachmentChanged(
    where: {node: {id: {equals: $channelMessageAttachmentId}}}
  ) {
    node {
      id
      filename
      url
      uploadStatus
      entityId
      attachmentType
    }
  }
}
    `;

/**
 * __useSubscribeToChannelMessageAttachmentSubscription__
 *
 * To run a query within a React component, call `useSubscribeToChannelMessageAttachmentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToChannelMessageAttachmentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToChannelMessageAttachmentSubscription({
 *   variables: {
 *      channelMessageAttachmentId: // value for 'channelMessageAttachmentId'
 *   },
 * });
 */
export function useSubscribeToChannelMessageAttachmentSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToChannelMessageAttachmentSubscription, SubscribeToChannelMessageAttachmentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToChannelMessageAttachmentSubscription, SubscribeToChannelMessageAttachmentSubscriptionVariables>(SubscribeToChannelMessageAttachmentDocument, options);
      }
export type SubscribeToChannelMessageAttachmentSubscriptionHookResult = ReturnType<typeof useSubscribeToChannelMessageAttachmentSubscription>;
export type SubscribeToChannelMessageAttachmentSubscriptionResult = Apollo.SubscriptionResult<SubscribeToChannelMessageAttachmentSubscription>;
export const SubscribeToChannelViewChannelDocument = gql`
    subscription subscribeToChannelViewChannel($channelId: String!, $clinicId: String!, $userId: String!) {
  channelChanged(where: {node: {id: {equals: $channelId}}}) {
    node {
      ...ChannelViewChannel
    }
  }
}
    ${ChannelViewChannelFragmentDoc}`;

/**
 * __useSubscribeToChannelViewChannelSubscription__
 *
 * To run a query within a React component, call `useSubscribeToChannelViewChannelSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToChannelViewChannelSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToChannelViewChannelSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      clinicId: // value for 'clinicId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSubscribeToChannelViewChannelSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToChannelViewChannelSubscription, SubscribeToChannelViewChannelSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToChannelViewChannelSubscription, SubscribeToChannelViewChannelSubscriptionVariables>(SubscribeToChannelViewChannelDocument, options);
      }
export type SubscribeToChannelViewChannelSubscriptionHookResult = ReturnType<typeof useSubscribeToChannelViewChannelSubscription>;
export type SubscribeToChannelViewChannelSubscriptionResult = Apollo.SubscriptionResult<SubscribeToChannelViewChannelSubscription>;
export const SubscribeToChannelViewChannelMembersDocument = gql`
    subscription subscribeToChannelViewChannelMembers($channelId: String!) {
  channelMemberChanged(where: {node: {channelId: {equals: $channelId}}}) {
    node {
      id
      removedAt
      lastConsumedMessageIndex
      clinicPetParent {
        id
        phoneNumbers {
          id
          isPrimary
          number
          smsStatus
          lastSmsSendDate
        }
      }
    }
  }
}
    `;

/**
 * __useSubscribeToChannelViewChannelMembersSubscription__
 *
 * To run a query within a React component, call `useSubscribeToChannelViewChannelMembersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToChannelViewChannelMembersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToChannelViewChannelMembersSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useSubscribeToChannelViewChannelMembersSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToChannelViewChannelMembersSubscription, SubscribeToChannelViewChannelMembersSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToChannelViewChannelMembersSubscription, SubscribeToChannelViewChannelMembersSubscriptionVariables>(SubscribeToChannelViewChannelMembersDocument, options);
      }
export type SubscribeToChannelViewChannelMembersSubscriptionHookResult = ReturnType<typeof useSubscribeToChannelViewChannelMembersSubscription>;
export type SubscribeToChannelViewChannelMembersSubscriptionResult = Apollo.SubscriptionResult<SubscribeToChannelViewChannelMembersSubscription>;
export const SubscribeToChannelViewChannelMessagesDocument = gql`
    subscription subscribeToChannelViewChannelMessages($channelId: String!) {
  channelMessageChanged(where: {node: {channelId: {equals: $channelId}}}) {
    node {
      id
    }
    mutation
  }
}
    `;

/**
 * __useSubscribeToChannelViewChannelMessagesSubscription__
 *
 * To run a query within a React component, call `useSubscribeToChannelViewChannelMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToChannelViewChannelMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToChannelViewChannelMessagesSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useSubscribeToChannelViewChannelMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToChannelViewChannelMessagesSubscription, SubscribeToChannelViewChannelMessagesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToChannelViewChannelMessagesSubscription, SubscribeToChannelViewChannelMessagesSubscriptionVariables>(SubscribeToChannelViewChannelMessagesDocument, options);
      }
export type SubscribeToChannelViewChannelMessagesSubscriptionHookResult = ReturnType<typeof useSubscribeToChannelViewChannelMessagesSubscription>;
export type SubscribeToChannelViewChannelMessagesSubscriptionResult = Apollo.SubscriptionResult<SubscribeToChannelViewChannelMessagesSubscription>;
export const SubscribeToClinicWidgetRequestDocument = gql`
    subscription subscribeToClinicWidgetRequest($where: SubscriptionClinicWidgetRequestWhereInput!) {
  clinicWidgetRequestChanged(where: $where) {
    node {
      id
      isVerified
    }
  }
}
    `;

/**
 * __useSubscribeToClinicWidgetRequestSubscription__
 *
 * To run a query within a React component, call `useSubscribeToClinicWidgetRequestSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToClinicWidgetRequestSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToClinicWidgetRequestSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToClinicWidgetRequestSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToClinicWidgetRequestSubscription, SubscribeToClinicWidgetRequestSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToClinicWidgetRequestSubscription, SubscribeToClinicWidgetRequestSubscriptionVariables>(SubscribeToClinicWidgetRequestDocument, options);
      }
export type SubscribeToClinicWidgetRequestSubscriptionHookResult = ReturnType<typeof useSubscribeToClinicWidgetRequestSubscription>;
export type SubscribeToClinicWidgetRequestSubscriptionResult = Apollo.SubscriptionResult<SubscribeToClinicWidgetRequestSubscription>;
export const SubscribeToPendingFulfillmentRewardUpdateDocument = gql`
    subscription subscribeToPendingFulfillmentRewardUpdate($where: LoyaltyRewardRedemptionWhereUniqueInput!) {
  loyaltyRewardRedemptionUpdated(where: $where) {
    node {
      id
      account {
        id
      }
      status
    }
  }
}
    `;

/**
 * __useSubscribeToPendingFulfillmentRewardUpdateSubscription__
 *
 * To run a query within a React component, call `useSubscribeToPendingFulfillmentRewardUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToPendingFulfillmentRewardUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToPendingFulfillmentRewardUpdateSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToPendingFulfillmentRewardUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToPendingFulfillmentRewardUpdateSubscription, SubscribeToPendingFulfillmentRewardUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToPendingFulfillmentRewardUpdateSubscription, SubscribeToPendingFulfillmentRewardUpdateSubscriptionVariables>(SubscribeToPendingFulfillmentRewardUpdateDocument, options);
      }
export type SubscribeToPendingFulfillmentRewardUpdateSubscriptionHookResult = ReturnType<typeof useSubscribeToPendingFulfillmentRewardUpdateSubscription>;
export type SubscribeToPendingFulfillmentRewardUpdateSubscriptionResult = Apollo.SubscriptionResult<SubscribeToPendingFulfillmentRewardUpdateSubscription>;
export const SubscribeToSmsNotificationStatusDocument = gql`
    subscription subscribeToSmsNotificationStatus($where: SubscriptionSmsNotificationStatusWhereInput!) {
  smsNotificationStatusChanged(where: $where) {
    node {
      ...SmsNotificationStatus
    }
  }
}
    ${SmsNotificationStatusFragmentDoc}`;

/**
 * __useSubscribeToSmsNotificationStatusSubscription__
 *
 * To run a query within a React component, call `useSubscribeToSmsNotificationStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToSmsNotificationStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToSmsNotificationStatusSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToSmsNotificationStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToSmsNotificationStatusSubscription, SubscribeToSmsNotificationStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToSmsNotificationStatusSubscription, SubscribeToSmsNotificationStatusSubscriptionVariables>(SubscribeToSmsNotificationStatusDocument, options);
      }
export type SubscribeToSmsNotificationStatusSubscriptionHookResult = ReturnType<typeof useSubscribeToSmsNotificationStatusSubscription>;
export type SubscribeToSmsNotificationStatusSubscriptionResult = Apollo.SubscriptionResult<SubscribeToSmsNotificationStatusSubscription>;
export const TriggerDemoWorkflowEventDocument = gql`
    mutation triggerDemoWorkflowEvent($data: TriggerWorkflowEventInput!) {
  triggerWorkflowEvent(data: $data) {
    success
  }
}
    `;
export type TriggerDemoWorkflowEventMutationFn = Apollo.MutationFunction<TriggerDemoWorkflowEventMutation, TriggerDemoWorkflowEventMutationVariables>;

/**
 * __useTriggerDemoWorkflowEventMutation__
 *
 * To run a mutation, you first call `useTriggerDemoWorkflowEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerDemoWorkflowEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerDemoWorkflowEventMutation, { data, loading, error }] = useTriggerDemoWorkflowEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTriggerDemoWorkflowEventMutation(baseOptions?: Apollo.MutationHookOptions<TriggerDemoWorkflowEventMutation, TriggerDemoWorkflowEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerDemoWorkflowEventMutation, TriggerDemoWorkflowEventMutationVariables>(TriggerDemoWorkflowEventDocument, options);
      }
export type TriggerDemoWorkflowEventMutationHookResult = ReturnType<typeof useTriggerDemoWorkflowEventMutation>;
export type TriggerDemoWorkflowEventMutationResult = Apollo.MutationResult<TriggerDemoWorkflowEventMutation>;
export type TriggerDemoWorkflowEventMutationOptions = Apollo.BaseMutationOptions<TriggerDemoWorkflowEventMutation, TriggerDemoWorkflowEventMutationVariables>;
export const GetDemoWorkflowClinicAppointmentsDocument = gql`
    query getDemoWorkflowClinicAppointments($where: AppointmentWhereInput) {
  findManyAppointment(where: $where, orderBy: {createdAt: desc}, take: 100) {
    ...DemoWorkflowAppointment
  }
}
    ${DemoWorkflowAppointmentFragmentDoc}`;

/**
 * __useGetDemoWorkflowClinicAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetDemoWorkflowClinicAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDemoWorkflowClinicAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDemoWorkflowClinicAppointmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDemoWorkflowClinicAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetDemoWorkflowClinicAppointmentsQuery, GetDemoWorkflowClinicAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDemoWorkflowClinicAppointmentsQuery, GetDemoWorkflowClinicAppointmentsQueryVariables>(GetDemoWorkflowClinicAppointmentsDocument, options);
      }
export function useGetDemoWorkflowClinicAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDemoWorkflowClinicAppointmentsQuery, GetDemoWorkflowClinicAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDemoWorkflowClinicAppointmentsQuery, GetDemoWorkflowClinicAppointmentsQueryVariables>(GetDemoWorkflowClinicAppointmentsDocument, options);
        }
export type GetDemoWorkflowClinicAppointmentsQueryHookResult = ReturnType<typeof useGetDemoWorkflowClinicAppointmentsQuery>;
export type GetDemoWorkflowClinicAppointmentsLazyQueryHookResult = ReturnType<typeof useGetDemoWorkflowClinicAppointmentsLazyQuery>;
export type GetDemoWorkflowClinicAppointmentsQueryResult = Apollo.QueryResult<GetDemoWorkflowClinicAppointmentsQuery, GetDemoWorkflowClinicAppointmentsQueryVariables>;
export function refetchGetDemoWorkflowClinicAppointmentsQuery(variables?: GetDemoWorkflowClinicAppointmentsQueryVariables) {
      return { query: GetDemoWorkflowClinicAppointmentsDocument, variables: variables }
    }
export const SoftDeleteFormsMenuFormTemplateDocument = gql`
    mutation softDeleteFormsMenuFormTemplate($where: FormTemplateWhereUniqueInput!) {
  updateOneFormTemplate(where: $where, data: {isDeleted: true, isActive: false}) {
    id
  }
}
    `;
export type SoftDeleteFormsMenuFormTemplateMutationFn = Apollo.MutationFunction<SoftDeleteFormsMenuFormTemplateMutation, SoftDeleteFormsMenuFormTemplateMutationVariables>;

/**
 * __useSoftDeleteFormsMenuFormTemplateMutation__
 *
 * To run a mutation, you first call `useSoftDeleteFormsMenuFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteFormsMenuFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteFormsMenuFormTemplateMutation, { data, loading, error }] = useSoftDeleteFormsMenuFormTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSoftDeleteFormsMenuFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteFormsMenuFormTemplateMutation, SoftDeleteFormsMenuFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteFormsMenuFormTemplateMutation, SoftDeleteFormsMenuFormTemplateMutationVariables>(SoftDeleteFormsMenuFormTemplateDocument, options);
      }
export type SoftDeleteFormsMenuFormTemplateMutationHookResult = ReturnType<typeof useSoftDeleteFormsMenuFormTemplateMutation>;
export type SoftDeleteFormsMenuFormTemplateMutationResult = Apollo.MutationResult<SoftDeleteFormsMenuFormTemplateMutation>;
export type SoftDeleteFormsMenuFormTemplateMutationOptions = Apollo.BaseMutationOptions<SoftDeleteFormsMenuFormTemplateMutation, SoftDeleteFormsMenuFormTemplateMutationVariables>;
export const CreateFormTemplateDocument = gql`
    mutation createFormTemplate($clinicId: String!, $title: String!, $content: Json) {
  createOneFormTemplate(
    data: {clinic: {connect: {id: $clinicId}}, title: $title, content: $content}
  ) {
    id
  }
}
    `;
export type CreateFormTemplateMutationFn = Apollo.MutationFunction<CreateFormTemplateMutation, CreateFormTemplateMutationVariables>;

/**
 * __useCreateFormTemplateMutation__
 *
 * To run a mutation, you first call `useCreateFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormTemplateMutation, { data, loading, error }] = useCreateFormTemplateMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      title: // value for 'title'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormTemplateMutation, CreateFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormTemplateMutation, CreateFormTemplateMutationVariables>(CreateFormTemplateDocument, options);
      }
export type CreateFormTemplateMutationHookResult = ReturnType<typeof useCreateFormTemplateMutation>;
export type CreateFormTemplateMutationResult = Apollo.MutationResult<CreateFormTemplateMutation>;
export type CreateFormTemplateMutationOptions = Apollo.BaseMutationOptions<CreateFormTemplateMutation, CreateFormTemplateMutationVariables>;
export const ImportFormTemplateDocument = gql`
    mutation importFormTemplate($data: FormTemplateCreateInput!) {
  createOneFormTemplate(data: $data) {
    id
  }
}
    `;
export type ImportFormTemplateMutationFn = Apollo.MutationFunction<ImportFormTemplateMutation, ImportFormTemplateMutationVariables>;

/**
 * __useImportFormTemplateMutation__
 *
 * To run a mutation, you first call `useImportFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importFormTemplateMutation, { data, loading, error }] = useImportFormTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useImportFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ImportFormTemplateMutation, ImportFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportFormTemplateMutation, ImportFormTemplateMutationVariables>(ImportFormTemplateDocument, options);
      }
export type ImportFormTemplateMutationHookResult = ReturnType<typeof useImportFormTemplateMutation>;
export type ImportFormTemplateMutationResult = Apollo.MutationResult<ImportFormTemplateMutation>;
export type ImportFormTemplateMutationOptions = Apollo.BaseMutationOptions<ImportFormTemplateMutation, ImportFormTemplateMutationVariables>;
export const ToggleActiveFormTemplateDocument = gql`
    mutation toggleActiveFormTemplate($formId: String!, $isActive: Boolean!) {
  updateOneFormTemplate(where: {id: $formId}, data: {isActive: $isActive}) {
    id
    isActive
  }
}
    `;
export type ToggleActiveFormTemplateMutationFn = Apollo.MutationFunction<ToggleActiveFormTemplateMutation, ToggleActiveFormTemplateMutationVariables>;

/**
 * __useToggleActiveFormTemplateMutation__
 *
 * To run a mutation, you first call `useToggleActiveFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleActiveFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleActiveFormTemplateMutation, { data, loading, error }] = useToggleActiveFormTemplateMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useToggleActiveFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleActiveFormTemplateMutation, ToggleActiveFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleActiveFormTemplateMutation, ToggleActiveFormTemplateMutationVariables>(ToggleActiveFormTemplateDocument, options);
      }
export type ToggleActiveFormTemplateMutationHookResult = ReturnType<typeof useToggleActiveFormTemplateMutation>;
export type ToggleActiveFormTemplateMutationResult = Apollo.MutationResult<ToggleActiveFormTemplateMutation>;
export type ToggleActiveFormTemplateMutationOptions = Apollo.BaseMutationOptions<ToggleActiveFormTemplateMutation, ToggleActiveFormTemplateMutationVariables>;
export const UpdateFormTemplateDocument = gql`
    mutation updateFormTemplate($where: FormTemplateWhereUniqueInput!, $data: FormTemplateUpdateInput!) {
  updateOneFormTemplate(where: $where, data: $data) {
    ...ClinicFormTemplate
  }
}
    ${ClinicFormTemplateFragmentDoc}`;
export type UpdateFormTemplateMutationFn = Apollo.MutationFunction<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>;

/**
 * __useUpdateFormTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormTemplateMutation, { data, loading, error }] = useUpdateFormTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>(UpdateFormTemplateDocument, options);
      }
export type UpdateFormTemplateMutationHookResult = ReturnType<typeof useUpdateFormTemplateMutation>;
export type UpdateFormTemplateMutationResult = Apollo.MutationResult<UpdateFormTemplateMutation>;
export type UpdateFormTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>;
export const AcceptUserInvitationDocument = gql`
    mutation acceptUserInvitation($data: AcceptUserInvitationInput!) {
  acceptUserInvitation: acceptUserInvitation2(data: $data) {
    token
  }
}
    `;
export type AcceptUserInvitationMutationFn = Apollo.MutationFunction<AcceptUserInvitationMutation, AcceptUserInvitationMutationVariables>;

/**
 * __useAcceptUserInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptUserInvitationMutation, { data, loading, error }] = useAcceptUserInvitationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAcceptUserInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptUserInvitationMutation, AcceptUserInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptUserInvitationMutation, AcceptUserInvitationMutationVariables>(AcceptUserInvitationDocument, options);
      }
export type AcceptUserInvitationMutationHookResult = ReturnType<typeof useAcceptUserInvitationMutation>;
export type AcceptUserInvitationMutationResult = Apollo.MutationResult<AcceptUserInvitationMutation>;
export type AcceptUserInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptUserInvitationMutation, AcceptUserInvitationMutationVariables>;
export const CreateLoyaltyProgramRewardDocument = gql`
    mutation createLoyaltyProgramReward($data: LoyaltyRewardCreateInput!) {
  createOneLoyaltyReward(data: $data) {
    id
  }
}
    `;
export type CreateLoyaltyProgramRewardMutationFn = Apollo.MutationFunction<CreateLoyaltyProgramRewardMutation, CreateLoyaltyProgramRewardMutationVariables>;

/**
 * __useCreateLoyaltyProgramRewardMutation__
 *
 * To run a mutation, you first call `useCreateLoyaltyProgramRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoyaltyProgramRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoyaltyProgramRewardMutation, { data, loading, error }] = useCreateLoyaltyProgramRewardMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLoyaltyProgramRewardMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoyaltyProgramRewardMutation, CreateLoyaltyProgramRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoyaltyProgramRewardMutation, CreateLoyaltyProgramRewardMutationVariables>(CreateLoyaltyProgramRewardDocument, options);
      }
export type CreateLoyaltyProgramRewardMutationHookResult = ReturnType<typeof useCreateLoyaltyProgramRewardMutation>;
export type CreateLoyaltyProgramRewardMutationResult = Apollo.MutationResult<CreateLoyaltyProgramRewardMutation>;
export type CreateLoyaltyProgramRewardMutationOptions = Apollo.BaseMutationOptions<CreateLoyaltyProgramRewardMutation, CreateLoyaltyProgramRewardMutationVariables>;
export const FindOrCreateLoyaltyProgramDocument = gql`
    mutation findOrCreateLoyaltyProgram {
  findOrCreateLoyaltyProgram {
    id
    status
    centsPerPoint
    allowSpendCarryOver
    minimumTransactionCents
    description
  }
}
    `;
export type FindOrCreateLoyaltyProgramMutationFn = Apollo.MutationFunction<FindOrCreateLoyaltyProgramMutation, FindOrCreateLoyaltyProgramMutationVariables>;

/**
 * __useFindOrCreateLoyaltyProgramMutation__
 *
 * To run a mutation, you first call `useFindOrCreateLoyaltyProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindOrCreateLoyaltyProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findOrCreateLoyaltyProgramMutation, { data, loading, error }] = useFindOrCreateLoyaltyProgramMutation({
 *   variables: {
 *   },
 * });
 */
export function useFindOrCreateLoyaltyProgramMutation(baseOptions?: Apollo.MutationHookOptions<FindOrCreateLoyaltyProgramMutation, FindOrCreateLoyaltyProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FindOrCreateLoyaltyProgramMutation, FindOrCreateLoyaltyProgramMutationVariables>(FindOrCreateLoyaltyProgramDocument, options);
      }
export type FindOrCreateLoyaltyProgramMutationHookResult = ReturnType<typeof useFindOrCreateLoyaltyProgramMutation>;
export type FindOrCreateLoyaltyProgramMutationResult = Apollo.MutationResult<FindOrCreateLoyaltyProgramMutation>;
export type FindOrCreateLoyaltyProgramMutationOptions = Apollo.BaseMutationOptions<FindOrCreateLoyaltyProgramMutation, FindOrCreateLoyaltyProgramMutationVariables>;
export const UpdateLoyaltyProgramRewardDocument = gql`
    mutation updateLoyaltyProgramReward($data: LoyaltyRewardUpdateInput!, $where: LoyaltyRewardWhereUniqueInput!) {
  updateOneLoyaltyReward(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateLoyaltyProgramRewardMutationFn = Apollo.MutationFunction<UpdateLoyaltyProgramRewardMutation, UpdateLoyaltyProgramRewardMutationVariables>;

/**
 * __useUpdateLoyaltyProgramRewardMutation__
 *
 * To run a mutation, you first call `useUpdateLoyaltyProgramRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoyaltyProgramRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoyaltyProgramRewardMutation, { data, loading, error }] = useUpdateLoyaltyProgramRewardMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateLoyaltyProgramRewardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoyaltyProgramRewardMutation, UpdateLoyaltyProgramRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoyaltyProgramRewardMutation, UpdateLoyaltyProgramRewardMutationVariables>(UpdateLoyaltyProgramRewardDocument, options);
      }
export type UpdateLoyaltyProgramRewardMutationHookResult = ReturnType<typeof useUpdateLoyaltyProgramRewardMutation>;
export type UpdateLoyaltyProgramRewardMutationResult = Apollo.MutationResult<UpdateLoyaltyProgramRewardMutation>;
export type UpdateLoyaltyProgramRewardMutationOptions = Apollo.BaseMutationOptions<UpdateLoyaltyProgramRewardMutation, UpdateLoyaltyProgramRewardMutationVariables>;
export const UpdateLoyaltyProgramRewardsAvailabilityDocument = gql`
    mutation updateLoyaltyProgramRewardsAvailability($data: LoyaltyRewardUpdateManyMutationInput!, $where: LoyaltyRewardWhereInput!) {
  updateManyLoyaltyReward(data: $data, where: $where) {
    count
  }
}
    `;
export type UpdateLoyaltyProgramRewardsAvailabilityMutationFn = Apollo.MutationFunction<UpdateLoyaltyProgramRewardsAvailabilityMutation, UpdateLoyaltyProgramRewardsAvailabilityMutationVariables>;

/**
 * __useUpdateLoyaltyProgramRewardsAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateLoyaltyProgramRewardsAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoyaltyProgramRewardsAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoyaltyProgramRewardsAvailabilityMutation, { data, loading, error }] = useUpdateLoyaltyProgramRewardsAvailabilityMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateLoyaltyProgramRewardsAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoyaltyProgramRewardsAvailabilityMutation, UpdateLoyaltyProgramRewardsAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoyaltyProgramRewardsAvailabilityMutation, UpdateLoyaltyProgramRewardsAvailabilityMutationVariables>(UpdateLoyaltyProgramRewardsAvailabilityDocument, options);
      }
export type UpdateLoyaltyProgramRewardsAvailabilityMutationHookResult = ReturnType<typeof useUpdateLoyaltyProgramRewardsAvailabilityMutation>;
export type UpdateLoyaltyProgramRewardsAvailabilityMutationResult = Apollo.MutationResult<UpdateLoyaltyProgramRewardsAvailabilityMutation>;
export type UpdateLoyaltyProgramRewardsAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdateLoyaltyProgramRewardsAvailabilityMutation, UpdateLoyaltyProgramRewardsAvailabilityMutationVariables>;
export const UpdateLoyaltyProgramSettingsDocument = gql`
    mutation updateLoyaltyProgramSettings($data: LoyaltyProgramUpdateInput!, $where: LoyaltyProgramWhereUniqueInput!) {
  updateOneLoyaltyProgram(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateLoyaltyProgramSettingsMutationFn = Apollo.MutationFunction<UpdateLoyaltyProgramSettingsMutation, UpdateLoyaltyProgramSettingsMutationVariables>;

/**
 * __useUpdateLoyaltyProgramSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateLoyaltyProgramSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoyaltyProgramSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoyaltyProgramSettingsMutation, { data, loading, error }] = useUpdateLoyaltyProgramSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateLoyaltyProgramSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoyaltyProgramSettingsMutation, UpdateLoyaltyProgramSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoyaltyProgramSettingsMutation, UpdateLoyaltyProgramSettingsMutationVariables>(UpdateLoyaltyProgramSettingsDocument, options);
      }
export type UpdateLoyaltyProgramSettingsMutationHookResult = ReturnType<typeof useUpdateLoyaltyProgramSettingsMutation>;
export type UpdateLoyaltyProgramSettingsMutationResult = Apollo.MutationResult<UpdateLoyaltyProgramSettingsMutation>;
export type UpdateLoyaltyProgramSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateLoyaltyProgramSettingsMutation, UpdateLoyaltyProgramSettingsMutationVariables>;
export const UpdateOneLoyaltyInvoicePointGranterDocument = gql`
    mutation updateOneLoyaltyInvoicePointGranter($data: LoyaltyInvoicePointGranterUpdateInput!, $where: LoyaltyInvoicePointGranterWhereUniqueInput!) {
  updateOneLoyaltyInvoicePointGranter(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateOneLoyaltyInvoicePointGranterMutationFn = Apollo.MutationFunction<UpdateOneLoyaltyInvoicePointGranterMutation, UpdateOneLoyaltyInvoicePointGranterMutationVariables>;

/**
 * __useUpdateOneLoyaltyInvoicePointGranterMutation__
 *
 * To run a mutation, you first call `useUpdateOneLoyaltyInvoicePointGranterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneLoyaltyInvoicePointGranterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneLoyaltyInvoicePointGranterMutation, { data, loading, error }] = useUpdateOneLoyaltyInvoicePointGranterMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneLoyaltyInvoicePointGranterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneLoyaltyInvoicePointGranterMutation, UpdateOneLoyaltyInvoicePointGranterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneLoyaltyInvoicePointGranterMutation, UpdateOneLoyaltyInvoicePointGranterMutationVariables>(UpdateOneLoyaltyInvoicePointGranterDocument, options);
      }
export type UpdateOneLoyaltyInvoicePointGranterMutationHookResult = ReturnType<typeof useUpdateOneLoyaltyInvoicePointGranterMutation>;
export type UpdateOneLoyaltyInvoicePointGranterMutationResult = Apollo.MutationResult<UpdateOneLoyaltyInvoicePointGranterMutation>;
export type UpdateOneLoyaltyInvoicePointGranterMutationOptions = Apollo.BaseMutationOptions<UpdateOneLoyaltyInvoicePointGranterMutation, UpdateOneLoyaltyInvoicePointGranterMutationVariables>;
export const GetLoyaltyProgramBasicInfoDocument = gql`
    query getLoyaltyProgramBasicInfo($where: LoyaltyProgramWhereInput) {
  findFirstLoyaltyProgram(where: $where) {
    id
    status
  }
}
    `;

/**
 * __useGetLoyaltyProgramBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyProgramBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyProgramBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyProgramBasicInfoQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetLoyaltyProgramBasicInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetLoyaltyProgramBasicInfoQuery, GetLoyaltyProgramBasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyProgramBasicInfoQuery, GetLoyaltyProgramBasicInfoQueryVariables>(GetLoyaltyProgramBasicInfoDocument, options);
      }
export function useGetLoyaltyProgramBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyProgramBasicInfoQuery, GetLoyaltyProgramBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyProgramBasicInfoQuery, GetLoyaltyProgramBasicInfoQueryVariables>(GetLoyaltyProgramBasicInfoDocument, options);
        }
export type GetLoyaltyProgramBasicInfoQueryHookResult = ReturnType<typeof useGetLoyaltyProgramBasicInfoQuery>;
export type GetLoyaltyProgramBasicInfoLazyQueryHookResult = ReturnType<typeof useGetLoyaltyProgramBasicInfoLazyQuery>;
export type GetLoyaltyProgramBasicInfoQueryResult = Apollo.QueryResult<GetLoyaltyProgramBasicInfoQuery, GetLoyaltyProgramBasicInfoQueryVariables>;
export function refetchGetLoyaltyProgramBasicInfoQuery(variables?: GetLoyaltyProgramBasicInfoQueryVariables) {
      return { query: GetLoyaltyProgramBasicInfoDocument, variables: variables }
    }
export const GetLoyaltyProgramPointGrantingServicesDocument = gql`
    query getLoyaltyProgramPointGrantingServices($where: LoyaltyProgramWhereInput) {
  findFirstLoyaltyProgram(where: $where) {
    ...PointGranterService
  }
}
    ${PointGranterServiceFragmentDoc}`;

/**
 * __useGetLoyaltyProgramPointGrantingServicesQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyProgramPointGrantingServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyProgramPointGrantingServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyProgramPointGrantingServicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetLoyaltyProgramPointGrantingServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetLoyaltyProgramPointGrantingServicesQuery, GetLoyaltyProgramPointGrantingServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyProgramPointGrantingServicesQuery, GetLoyaltyProgramPointGrantingServicesQueryVariables>(GetLoyaltyProgramPointGrantingServicesDocument, options);
      }
export function useGetLoyaltyProgramPointGrantingServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyProgramPointGrantingServicesQuery, GetLoyaltyProgramPointGrantingServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyProgramPointGrantingServicesQuery, GetLoyaltyProgramPointGrantingServicesQueryVariables>(GetLoyaltyProgramPointGrantingServicesDocument, options);
        }
export type GetLoyaltyProgramPointGrantingServicesQueryHookResult = ReturnType<typeof useGetLoyaltyProgramPointGrantingServicesQuery>;
export type GetLoyaltyProgramPointGrantingServicesLazyQueryHookResult = ReturnType<typeof useGetLoyaltyProgramPointGrantingServicesLazyQuery>;
export type GetLoyaltyProgramPointGrantingServicesQueryResult = Apollo.QueryResult<GetLoyaltyProgramPointGrantingServicesQuery, GetLoyaltyProgramPointGrantingServicesQueryVariables>;
export function refetchGetLoyaltyProgramPointGrantingServicesQuery(variables?: GetLoyaltyProgramPointGrantingServicesQueryVariables) {
      return { query: GetLoyaltyProgramPointGrantingServicesDocument, variables: variables }
    }
export const GetLoyaltyProgramRewardsDocument = gql`
    query getLoyaltyProgramRewards($where: LoyaltyRewardWhereInput, $orderBy: [LoyaltyRewardOrderByWithRelationInput], $take: Int, $skip: Int) {
  findManyLoyaltyReward(
    where: $where
    orderBy: $orderBy
    take: $take
    skip: $skip
  ) {
    ...LoyaltyProgramReward
  }
  findManyLoyaltyRewardCount(where: $where)
}
    ${LoyaltyProgramRewardFragmentDoc}`;

/**
 * __useGetLoyaltyProgramRewardsQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyProgramRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyProgramRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyProgramRewardsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetLoyaltyProgramRewardsQuery(baseOptions?: Apollo.QueryHookOptions<GetLoyaltyProgramRewardsQuery, GetLoyaltyProgramRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyProgramRewardsQuery, GetLoyaltyProgramRewardsQueryVariables>(GetLoyaltyProgramRewardsDocument, options);
      }
export function useGetLoyaltyProgramRewardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyProgramRewardsQuery, GetLoyaltyProgramRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyProgramRewardsQuery, GetLoyaltyProgramRewardsQueryVariables>(GetLoyaltyProgramRewardsDocument, options);
        }
export type GetLoyaltyProgramRewardsQueryHookResult = ReturnType<typeof useGetLoyaltyProgramRewardsQuery>;
export type GetLoyaltyProgramRewardsLazyQueryHookResult = ReturnType<typeof useGetLoyaltyProgramRewardsLazyQuery>;
export type GetLoyaltyProgramRewardsQueryResult = Apollo.QueryResult<GetLoyaltyProgramRewardsQuery, GetLoyaltyProgramRewardsQueryVariables>;
export function refetchGetLoyaltyProgramRewardsQuery(variables?: GetLoyaltyProgramRewardsQueryVariables) {
      return { query: GetLoyaltyProgramRewardsDocument, variables: variables }
    }
export const GetServicesByIntegrationIdDocument = gql`
    query getServicesByIntegrationId($where: ServiceWhereInput, $orderBy: [ServiceOrderByWithRelationInput!], $take: Int, $skip: Int) {
  findManyService(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    ...ServiceFromIntegrationId
  }
  findManyServiceCount(where: $where)
}
    ${ServiceFromIntegrationIdFragmentDoc}`;

/**
 * __useGetServicesByIntegrationIdQuery__
 *
 * To run a query within a React component, call `useGetServicesByIntegrationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesByIntegrationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesByIntegrationIdQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetServicesByIntegrationIdQuery(baseOptions?: Apollo.QueryHookOptions<GetServicesByIntegrationIdQuery, GetServicesByIntegrationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServicesByIntegrationIdQuery, GetServicesByIntegrationIdQueryVariables>(GetServicesByIntegrationIdDocument, options);
      }
export function useGetServicesByIntegrationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServicesByIntegrationIdQuery, GetServicesByIntegrationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServicesByIntegrationIdQuery, GetServicesByIntegrationIdQueryVariables>(GetServicesByIntegrationIdDocument, options);
        }
export type GetServicesByIntegrationIdQueryHookResult = ReturnType<typeof useGetServicesByIntegrationIdQuery>;
export type GetServicesByIntegrationIdLazyQueryHookResult = ReturnType<typeof useGetServicesByIntegrationIdLazyQuery>;
export type GetServicesByIntegrationIdQueryResult = Apollo.QueryResult<GetServicesByIntegrationIdQuery, GetServicesByIntegrationIdQueryVariables>;
export function refetchGetServicesByIntegrationIdQuery(variables?: GetServicesByIntegrationIdQueryVariables) {
      return { query: GetServicesByIntegrationIdDocument, variables: variables }
    }
export const GetServicesIdsByIntegrationIdDocument = gql`
    query getServicesIdsByIntegrationId($where: ServiceWhereInput) {
  servicesIds: findManyService(where: $where) {
    id
  }
}
    `;

/**
 * __useGetServicesIdsByIntegrationIdQuery__
 *
 * To run a query within a React component, call `useGetServicesIdsByIntegrationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesIdsByIntegrationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesIdsByIntegrationIdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetServicesIdsByIntegrationIdQuery(baseOptions?: Apollo.QueryHookOptions<GetServicesIdsByIntegrationIdQuery, GetServicesIdsByIntegrationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServicesIdsByIntegrationIdQuery, GetServicesIdsByIntegrationIdQueryVariables>(GetServicesIdsByIntegrationIdDocument, options);
      }
export function useGetServicesIdsByIntegrationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServicesIdsByIntegrationIdQuery, GetServicesIdsByIntegrationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServicesIdsByIntegrationIdQuery, GetServicesIdsByIntegrationIdQueryVariables>(GetServicesIdsByIntegrationIdDocument, options);
        }
export type GetServicesIdsByIntegrationIdQueryHookResult = ReturnType<typeof useGetServicesIdsByIntegrationIdQuery>;
export type GetServicesIdsByIntegrationIdLazyQueryHookResult = ReturnType<typeof useGetServicesIdsByIntegrationIdLazyQuery>;
export type GetServicesIdsByIntegrationIdQueryResult = Apollo.QueryResult<GetServicesIdsByIntegrationIdQuery, GetServicesIdsByIntegrationIdQueryVariables>;
export function refetchGetServicesIdsByIntegrationIdQuery(variables?: GetServicesIdsByIntegrationIdQueryVariables) {
      return { query: GetServicesIdsByIntegrationIdDocument, variables: variables }
    }
export const ArchiveMessageTemplateDocument = gql`
    mutation archiveMessageTemplate($messageTemplateId: String!, $isArchived: Boolean!) {
  updateOneMessageTemplate(
    where: {id: $messageTemplateId}
    data: {isArchived: $isArchived}
  ) {
    id
    updatedAt
    updatedBy {
      id
      firstName
      lastName
    }
    isArchived
  }
}
    `;
export type ArchiveMessageTemplateMutationFn = Apollo.MutationFunction<ArchiveMessageTemplateMutation, ArchiveMessageTemplateMutationVariables>;

/**
 * __useArchiveMessageTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveMessageTemplateMutation, { data, loading, error }] = useArchiveMessageTemplateMutation({
 *   variables: {
 *      messageTemplateId: // value for 'messageTemplateId'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useArchiveMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveMessageTemplateMutation, ArchiveMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveMessageTemplateMutation, ArchiveMessageTemplateMutationVariables>(ArchiveMessageTemplateDocument, options);
      }
export type ArchiveMessageTemplateMutationHookResult = ReturnType<typeof useArchiveMessageTemplateMutation>;
export type ArchiveMessageTemplateMutationResult = Apollo.MutationResult<ArchiveMessageTemplateMutation>;
export type ArchiveMessageTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveMessageTemplateMutation, ArchiveMessageTemplateMutationVariables>;
export const CreateMessageTemplateDocument = gql`
    mutation createMessageTemplate($data: MessageTemplateCreateInput!) {
  createOneMessageTemplate(data: $data) {
    ...FullMessageTemplate
  }
}
    ${FullMessageTemplateFragmentDoc}`;
export type CreateMessageTemplateMutationFn = Apollo.MutationFunction<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;

/**
 * __useCreateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageTemplateMutation, { data, loading, error }] = useCreateMessageTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>(CreateMessageTemplateDocument, options);
      }
export type CreateMessageTemplateMutationHookResult = ReturnType<typeof useCreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationResult = Apollo.MutationResult<CreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;
export const SaveMessageTemplateDocument = gql`
    mutation saveMessageTemplate($where: MessageTemplateWhereUniqueInput!, $data: MessageTemplateUpdateInput!) {
  updateOneMessageTemplate(where: $where, data: $data) {
    id
    updatedAt
    updatedBy {
      id
      firstName
      lastName
    }
    name
    body
    isArchived
  }
}
    `;
export type SaveMessageTemplateMutationFn = Apollo.MutationFunction<SaveMessageTemplateMutation, SaveMessageTemplateMutationVariables>;

/**
 * __useSaveMessageTemplateMutation__
 *
 * To run a mutation, you first call `useSaveMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMessageTemplateMutation, { data, loading, error }] = useSaveMessageTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveMessageTemplateMutation, SaveMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMessageTemplateMutation, SaveMessageTemplateMutationVariables>(SaveMessageTemplateDocument, options);
      }
export type SaveMessageTemplateMutationHookResult = ReturnType<typeof useSaveMessageTemplateMutation>;
export type SaveMessageTemplateMutationResult = Apollo.MutationResult<SaveMessageTemplateMutation>;
export type SaveMessageTemplateMutationOptions = Apollo.BaseMutationOptions<SaveMessageTemplateMutation, SaveMessageTemplateMutationVariables>;
export const GetMessageTemplatesDocument = gql`
    query getMessageTemplates($clinicId: String!, $types: [MessageTemplateType!]!) {
  findManyMessageTemplate(
    where: {clinicId: {equals: $clinicId}, type: {in: $types}}
    orderBy: {createdAt: asc}
  ) {
    ...FullMessageTemplate
  }
}
    ${FullMessageTemplateFragmentDoc}`;

/**
 * __useGetMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplatesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetMessageTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>(GetMessageTemplatesDocument, options);
      }
export function useGetMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>(GetMessageTemplatesDocument, options);
        }
export type GetMessageTemplatesQueryHookResult = ReturnType<typeof useGetMessageTemplatesQuery>;
export type GetMessageTemplatesLazyQueryHookResult = ReturnType<typeof useGetMessageTemplatesLazyQuery>;
export type GetMessageTemplatesQueryResult = Apollo.QueryResult<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>;
export function refetchGetMessageTemplatesQuery(variables?: GetMessageTemplatesQueryVariables) {
      return { query: GetMessageTemplatesDocument, variables: variables }
    }
export const CreateOneEmailCampaignDocument = gql`
    mutation createOneEmailCampaign($data: EmailCampaignCreateInput!) {
  createOneEmailCampaign(data: $data) {
    ...EmailCampaign
  }
}
    ${EmailCampaignFragmentDoc}`;
export type CreateOneEmailCampaignMutationFn = Apollo.MutationFunction<CreateOneEmailCampaignMutation, CreateOneEmailCampaignMutationVariables>;

/**
 * __useCreateOneEmailCampaignMutation__
 *
 * To run a mutation, you first call `useCreateOneEmailCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneEmailCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneEmailCampaignMutation, { data, loading, error }] = useCreateOneEmailCampaignMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneEmailCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneEmailCampaignMutation, CreateOneEmailCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneEmailCampaignMutation, CreateOneEmailCampaignMutationVariables>(CreateOneEmailCampaignDocument, options);
      }
export type CreateOneEmailCampaignMutationHookResult = ReturnType<typeof useCreateOneEmailCampaignMutation>;
export type CreateOneEmailCampaignMutationResult = Apollo.MutationResult<CreateOneEmailCampaignMutation>;
export type CreateOneEmailCampaignMutationOptions = Apollo.BaseMutationOptions<CreateOneEmailCampaignMutation, CreateOneEmailCampaignMutationVariables>;
export const DeleteEmailCampaignCustomListDocument = gql`
    mutation deleteEmailCampaignCustomList($data: DeleteEmailCampaignCustomListInput!) {
  deleteEmailCampaignCustomList(data: $data) {
    id
  }
}
    `;
export type DeleteEmailCampaignCustomListMutationFn = Apollo.MutationFunction<DeleteEmailCampaignCustomListMutation, DeleteEmailCampaignCustomListMutationVariables>;

/**
 * __useDeleteEmailCampaignCustomListMutation__
 *
 * To run a mutation, you first call `useDeleteEmailCampaignCustomListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailCampaignCustomListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailCampaignCustomListMutation, { data, loading, error }] = useDeleteEmailCampaignCustomListMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteEmailCampaignCustomListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailCampaignCustomListMutation, DeleteEmailCampaignCustomListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailCampaignCustomListMutation, DeleteEmailCampaignCustomListMutationVariables>(DeleteEmailCampaignCustomListDocument, options);
      }
export type DeleteEmailCampaignCustomListMutationHookResult = ReturnType<typeof useDeleteEmailCampaignCustomListMutation>;
export type DeleteEmailCampaignCustomListMutationResult = Apollo.MutationResult<DeleteEmailCampaignCustomListMutation>;
export type DeleteEmailCampaignCustomListMutationOptions = Apollo.BaseMutationOptions<DeleteEmailCampaignCustomListMutation, DeleteEmailCampaignCustomListMutationVariables>;
export const DuplicateEmailCampaignDocument = gql`
    mutation duplicateEmailCampaign($data: DuplicateEmailCampaignInput!) {
  duplicateEmailCampaign(data: $data) {
    id
  }
}
    `;
export type DuplicateEmailCampaignMutationFn = Apollo.MutationFunction<DuplicateEmailCampaignMutation, DuplicateEmailCampaignMutationVariables>;

/**
 * __useDuplicateEmailCampaignMutation__
 *
 * To run a mutation, you first call `useDuplicateEmailCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateEmailCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateEmailCampaignMutation, { data, loading, error }] = useDuplicateEmailCampaignMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDuplicateEmailCampaignMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateEmailCampaignMutation, DuplicateEmailCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateEmailCampaignMutation, DuplicateEmailCampaignMutationVariables>(DuplicateEmailCampaignDocument, options);
      }
export type DuplicateEmailCampaignMutationHookResult = ReturnType<typeof useDuplicateEmailCampaignMutation>;
export type DuplicateEmailCampaignMutationResult = Apollo.MutationResult<DuplicateEmailCampaignMutation>;
export type DuplicateEmailCampaignMutationOptions = Apollo.BaseMutationOptions<DuplicateEmailCampaignMutation, DuplicateEmailCampaignMutationVariables>;
export const FindManyAppointmentTypeDocument = gql`
    query findManyAppointmentType($clinicId: String!) {
  findManyAppointmentType(
    where: {clinic: {id: {equals: $clinicId}}, isVisible: {equals: true}}
    orderBy: {displayOrder: asc}
  ) {
    ...AppointmentTypeWorkflowsSelection
  }
}
    ${AppointmentTypeWorkflowsSelectionFragmentDoc}`;

/**
 * __useFindManyAppointmentTypeQuery__
 *
 * To run a query within a React component, call `useFindManyAppointmentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyAppointmentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyAppointmentTypeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useFindManyAppointmentTypeQuery(baseOptions: Apollo.QueryHookOptions<FindManyAppointmentTypeQuery, FindManyAppointmentTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyAppointmentTypeQuery, FindManyAppointmentTypeQueryVariables>(FindManyAppointmentTypeDocument, options);
      }
export function useFindManyAppointmentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyAppointmentTypeQuery, FindManyAppointmentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyAppointmentTypeQuery, FindManyAppointmentTypeQueryVariables>(FindManyAppointmentTypeDocument, options);
        }
export type FindManyAppointmentTypeQueryHookResult = ReturnType<typeof useFindManyAppointmentTypeQuery>;
export type FindManyAppointmentTypeLazyQueryHookResult = ReturnType<typeof useFindManyAppointmentTypeLazyQuery>;
export type FindManyAppointmentTypeQueryResult = Apollo.QueryResult<FindManyAppointmentTypeQuery, FindManyAppointmentTypeQueryVariables>;
export function refetchFindManyAppointmentTypeQuery(variables?: FindManyAppointmentTypeQueryVariables) {
      return { query: FindManyAppointmentTypeDocument, variables: variables }
    }
export const FindManyClinicPetParentCountDocument = gql`
    query findManyClinicPetParentCount($where: ClinicPetParentWhereInput!) {
  findManyClinicPetParentCount(where: $where)
}
    `;

/**
 * __useFindManyClinicPetParentCountQuery__
 *
 * To run a query within a React component, call `useFindManyClinicPetParentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyClinicPetParentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyClinicPetParentCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyClinicPetParentCountQuery(baseOptions: Apollo.QueryHookOptions<FindManyClinicPetParentCountQuery, FindManyClinicPetParentCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyClinicPetParentCountQuery, FindManyClinicPetParentCountQueryVariables>(FindManyClinicPetParentCountDocument, options);
      }
export function useFindManyClinicPetParentCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyClinicPetParentCountQuery, FindManyClinicPetParentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyClinicPetParentCountQuery, FindManyClinicPetParentCountQueryVariables>(FindManyClinicPetParentCountDocument, options);
        }
export type FindManyClinicPetParentCountQueryHookResult = ReturnType<typeof useFindManyClinicPetParentCountQuery>;
export type FindManyClinicPetParentCountLazyQueryHookResult = ReturnType<typeof useFindManyClinicPetParentCountLazyQuery>;
export type FindManyClinicPetParentCountQueryResult = Apollo.QueryResult<FindManyClinicPetParentCountQuery, FindManyClinicPetParentCountQueryVariables>;
export function refetchFindManyClinicPetParentCountQuery(variables?: FindManyClinicPetParentCountQueryVariables) {
      return { query: FindManyClinicPetParentCountDocument, variables: variables }
    }
export const FindManyEmailCampaignDocument = gql`
    query findManyEmailCampaign($where: EmailCampaignWhereInput) {
  findManyEmailCampaign(where: $where) {
    ...EmailCampaign
  }
}
    ${EmailCampaignFragmentDoc}`;

/**
 * __useFindManyEmailCampaignQuery__
 *
 * To run a query within a React component, call `useFindManyEmailCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyEmailCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyEmailCampaignQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyEmailCampaignQuery(baseOptions?: Apollo.QueryHookOptions<FindManyEmailCampaignQuery, FindManyEmailCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyEmailCampaignQuery, FindManyEmailCampaignQueryVariables>(FindManyEmailCampaignDocument, options);
      }
export function useFindManyEmailCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyEmailCampaignQuery, FindManyEmailCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyEmailCampaignQuery, FindManyEmailCampaignQueryVariables>(FindManyEmailCampaignDocument, options);
        }
export type FindManyEmailCampaignQueryHookResult = ReturnType<typeof useFindManyEmailCampaignQuery>;
export type FindManyEmailCampaignLazyQueryHookResult = ReturnType<typeof useFindManyEmailCampaignLazyQuery>;
export type FindManyEmailCampaignQueryResult = Apollo.QueryResult<FindManyEmailCampaignQuery, FindManyEmailCampaignQueryVariables>;
export function refetchFindManyEmailCampaignQuery(variables?: FindManyEmailCampaignQueryVariables) {
      return { query: FindManyEmailCampaignDocument, variables: variables }
    }
export const CanSendEmailCampaignDocument = gql`
    query canSendEmailCampaign($clinicId: String!) {
  canSendEmailCampaign(clinicId: $clinicId)
}
    `;

/**
 * __useCanSendEmailCampaignQuery__
 *
 * To run a query within a React component, call `useCanSendEmailCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanSendEmailCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanSendEmailCampaignQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useCanSendEmailCampaignQuery(baseOptions: Apollo.QueryHookOptions<CanSendEmailCampaignQuery, CanSendEmailCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanSendEmailCampaignQuery, CanSendEmailCampaignQueryVariables>(CanSendEmailCampaignDocument, options);
      }
export function useCanSendEmailCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanSendEmailCampaignQuery, CanSendEmailCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanSendEmailCampaignQuery, CanSendEmailCampaignQueryVariables>(CanSendEmailCampaignDocument, options);
        }
export type CanSendEmailCampaignQueryHookResult = ReturnType<typeof useCanSendEmailCampaignQuery>;
export type CanSendEmailCampaignLazyQueryHookResult = ReturnType<typeof useCanSendEmailCampaignLazyQuery>;
export type CanSendEmailCampaignQueryResult = Apollo.QueryResult<CanSendEmailCampaignQuery, CanSendEmailCampaignQueryVariables>;
export function refetchCanSendEmailCampaignQuery(variables?: CanSendEmailCampaignQueryVariables) {
      return { query: CanSendEmailCampaignDocument, variables: variables }
    }
export const GetClinicEmailCampaignTemplatesDocument = gql`
    query getClinicEmailCampaignTemplates($clinicId: String!) {
  getClinicEmailCampaignTemplates(clinicId: $clinicId) {
    ...EmailCampaignTemplate
  }
}
    ${EmailCampaignTemplateFragmentDoc}`;

/**
 * __useGetClinicEmailCampaignTemplatesQuery__
 *
 * To run a query within a React component, call `useGetClinicEmailCampaignTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicEmailCampaignTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicEmailCampaignTemplatesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicEmailCampaignTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetClinicEmailCampaignTemplatesQuery, GetClinicEmailCampaignTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicEmailCampaignTemplatesQuery, GetClinicEmailCampaignTemplatesQueryVariables>(GetClinicEmailCampaignTemplatesDocument, options);
      }
export function useGetClinicEmailCampaignTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicEmailCampaignTemplatesQuery, GetClinicEmailCampaignTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicEmailCampaignTemplatesQuery, GetClinicEmailCampaignTemplatesQueryVariables>(GetClinicEmailCampaignTemplatesDocument, options);
        }
export type GetClinicEmailCampaignTemplatesQueryHookResult = ReturnType<typeof useGetClinicEmailCampaignTemplatesQuery>;
export type GetClinicEmailCampaignTemplatesLazyQueryHookResult = ReturnType<typeof useGetClinicEmailCampaignTemplatesLazyQuery>;
export type GetClinicEmailCampaignTemplatesQueryResult = Apollo.QueryResult<GetClinicEmailCampaignTemplatesQuery, GetClinicEmailCampaignTemplatesQueryVariables>;
export function refetchGetClinicEmailCampaignTemplatesQuery(variables?: GetClinicEmailCampaignTemplatesQueryVariables) {
      return { query: GetClinicEmailCampaignTemplatesDocument, variables: variables }
    }
export const GetEmailCampaignCustomListUrlDocument = gql`
    query getEmailCampaignCustomListUrl($data: EmailCampaignCustomListUrlInput!) {
  getEmailCampaignCustomListUrl(data: $data)
}
    `;

/**
 * __useGetEmailCampaignCustomListUrlQuery__
 *
 * To run a query within a React component, call `useGetEmailCampaignCustomListUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailCampaignCustomListUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailCampaignCustomListUrlQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetEmailCampaignCustomListUrlQuery(baseOptions: Apollo.QueryHookOptions<GetEmailCampaignCustomListUrlQuery, GetEmailCampaignCustomListUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailCampaignCustomListUrlQuery, GetEmailCampaignCustomListUrlQueryVariables>(GetEmailCampaignCustomListUrlDocument, options);
      }
export function useGetEmailCampaignCustomListUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailCampaignCustomListUrlQuery, GetEmailCampaignCustomListUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailCampaignCustomListUrlQuery, GetEmailCampaignCustomListUrlQueryVariables>(GetEmailCampaignCustomListUrlDocument, options);
        }
export type GetEmailCampaignCustomListUrlQueryHookResult = ReturnType<typeof useGetEmailCampaignCustomListUrlQuery>;
export type GetEmailCampaignCustomListUrlLazyQueryHookResult = ReturnType<typeof useGetEmailCampaignCustomListUrlLazyQuery>;
export type GetEmailCampaignCustomListUrlQueryResult = Apollo.QueryResult<GetEmailCampaignCustomListUrlQuery, GetEmailCampaignCustomListUrlQueryVariables>;
export function refetchGetEmailCampaignCustomListUrlQuery(variables?: GetEmailCampaignCustomListUrlQueryVariables) {
      return { query: GetEmailCampaignCustomListUrlDocument, variables: variables }
    }
export const GetEmailCampaignSegmentCountDocument = gql`
    query getEmailCampaignSegmentCount($clinicId: String!, $emailCampaignId: String) {
  getEmailCampaignSegmentCount(
    clinicId: $clinicId
    emailCampaignId: $emailCampaignId
  )
}
    `;

/**
 * __useGetEmailCampaignSegmentCountQuery__
 *
 * To run a query within a React component, call `useGetEmailCampaignSegmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailCampaignSegmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailCampaignSegmentCountQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      emailCampaignId: // value for 'emailCampaignId'
 *   },
 * });
 */
export function useGetEmailCampaignSegmentCountQuery(baseOptions: Apollo.QueryHookOptions<GetEmailCampaignSegmentCountQuery, GetEmailCampaignSegmentCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailCampaignSegmentCountQuery, GetEmailCampaignSegmentCountQueryVariables>(GetEmailCampaignSegmentCountDocument, options);
      }
export function useGetEmailCampaignSegmentCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailCampaignSegmentCountQuery, GetEmailCampaignSegmentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailCampaignSegmentCountQuery, GetEmailCampaignSegmentCountQueryVariables>(GetEmailCampaignSegmentCountDocument, options);
        }
export type GetEmailCampaignSegmentCountQueryHookResult = ReturnType<typeof useGetEmailCampaignSegmentCountQuery>;
export type GetEmailCampaignSegmentCountLazyQueryHookResult = ReturnType<typeof useGetEmailCampaignSegmentCountLazyQuery>;
export type GetEmailCampaignSegmentCountQueryResult = Apollo.QueryResult<GetEmailCampaignSegmentCountQuery, GetEmailCampaignSegmentCountQueryVariables>;
export function refetchGetEmailCampaignSegmentCountQuery(variables?: GetEmailCampaignSegmentCountQueryVariables) {
      return { query: GetEmailCampaignSegmentCountDocument, variables: variables }
    }
export const SendEmailCampaignNowDocument = gql`
    mutation sendEmailCampaignNow($data: sendEmailCampaignNowInput!) {
  sendEmailCampaignNow(data: $data) {
    id
    time
  }
}
    `;
export type SendEmailCampaignNowMutationFn = Apollo.MutationFunction<SendEmailCampaignNowMutation, SendEmailCampaignNowMutationVariables>;

/**
 * __useSendEmailCampaignNowMutation__
 *
 * To run a mutation, you first call `useSendEmailCampaignNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailCampaignNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailCampaignNowMutation, { data, loading, error }] = useSendEmailCampaignNowMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendEmailCampaignNowMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailCampaignNowMutation, SendEmailCampaignNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailCampaignNowMutation, SendEmailCampaignNowMutationVariables>(SendEmailCampaignNowDocument, options);
      }
export type SendEmailCampaignNowMutationHookResult = ReturnType<typeof useSendEmailCampaignNowMutation>;
export type SendEmailCampaignNowMutationResult = Apollo.MutationResult<SendEmailCampaignNowMutation>;
export type SendEmailCampaignNowMutationOptions = Apollo.BaseMutationOptions<SendEmailCampaignNowMutation, SendEmailCampaignNowMutationVariables>;
export const UpdateOneEmailCampaignDocument = gql`
    mutation updateOneEmailCampaign($data: EmailCampaignUpdateInput!, $where: EmailCampaignWhereUniqueInput!) {
  updateOneEmailCampaign(data: $data, where: $where) {
    ...EmailCampaign
  }
}
    ${EmailCampaignFragmentDoc}`;
export type UpdateOneEmailCampaignMutationFn = Apollo.MutationFunction<UpdateOneEmailCampaignMutation, UpdateOneEmailCampaignMutationVariables>;

/**
 * __useUpdateOneEmailCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateOneEmailCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneEmailCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneEmailCampaignMutation, { data, loading, error }] = useUpdateOneEmailCampaignMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneEmailCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneEmailCampaignMutation, UpdateOneEmailCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneEmailCampaignMutation, UpdateOneEmailCampaignMutationVariables>(UpdateOneEmailCampaignDocument, options);
      }
export type UpdateOneEmailCampaignMutationHookResult = ReturnType<typeof useUpdateOneEmailCampaignMutation>;
export type UpdateOneEmailCampaignMutationResult = Apollo.MutationResult<UpdateOneEmailCampaignMutation>;
export type UpdateOneEmailCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateOneEmailCampaignMutation, UpdateOneEmailCampaignMutationVariables>;
export const UploadEmailCampaignCustomListDocument = gql`
    mutation uploadEmailCampaignCustomList($data: UploadEmailCampaignCustomListInput!) {
  uploadEmailCampaignCustomList(data: $data) {
    customList {
      id
      awsFileKey
      fileName
      validRecipients
      invalidRecipients
    }
    customListHistory {
      id
      expiresAt
      fileName
      awsFileKey
    }
  }
}
    `;
export type UploadEmailCampaignCustomListMutationFn = Apollo.MutationFunction<UploadEmailCampaignCustomListMutation, UploadEmailCampaignCustomListMutationVariables>;

/**
 * __useUploadEmailCampaignCustomListMutation__
 *
 * To run a mutation, you first call `useUploadEmailCampaignCustomListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEmailCampaignCustomListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEmailCampaignCustomListMutation, { data, loading, error }] = useUploadEmailCampaignCustomListMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUploadEmailCampaignCustomListMutation(baseOptions?: Apollo.MutationHookOptions<UploadEmailCampaignCustomListMutation, UploadEmailCampaignCustomListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadEmailCampaignCustomListMutation, UploadEmailCampaignCustomListMutationVariables>(UploadEmailCampaignCustomListDocument, options);
      }
export type UploadEmailCampaignCustomListMutationHookResult = ReturnType<typeof useUploadEmailCampaignCustomListMutation>;
export type UploadEmailCampaignCustomListMutationResult = Apollo.MutationResult<UploadEmailCampaignCustomListMutation>;
export type UploadEmailCampaignCustomListMutationOptions = Apollo.BaseMutationOptions<UploadEmailCampaignCustomListMutation, UploadEmailCampaignCustomListMutationVariables>;
export const FindFirstCallRecordingDocument = gql`
    query findFirstCallRecording($where: CallRecordingWhereInput!) {
  findFirstCallRecording(where: $where) {
    id
    transcription
    summary
    callHistory {
      createdAt
      from
      to
    }
  }
}
    `;

/**
 * __useFindFirstCallRecordingQuery__
 *
 * To run a query within a React component, call `useFindFirstCallRecordingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstCallRecordingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstCallRecordingQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFirstCallRecordingQuery(baseOptions: Apollo.QueryHookOptions<FindFirstCallRecordingQuery, FindFirstCallRecordingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFirstCallRecordingQuery, FindFirstCallRecordingQueryVariables>(FindFirstCallRecordingDocument, options);
      }
export function useFindFirstCallRecordingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFirstCallRecordingQuery, FindFirstCallRecordingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFirstCallRecordingQuery, FindFirstCallRecordingQueryVariables>(FindFirstCallRecordingDocument, options);
        }
export type FindFirstCallRecordingQueryHookResult = ReturnType<typeof useFindFirstCallRecordingQuery>;
export type FindFirstCallRecordingLazyQueryHookResult = ReturnType<typeof useFindFirstCallRecordingLazyQuery>;
export type FindFirstCallRecordingQueryResult = Apollo.QueryResult<FindFirstCallRecordingQuery, FindFirstCallRecordingQueryVariables>;
export function refetchFindFirstCallRecordingQuery(variables?: FindFirstCallRecordingQueryVariables) {
      return { query: FindFirstCallRecordingDocument, variables: variables }
    }
export const GetQuickSightDashboardsDocument = gql`
    query getQuickSightDashboards {
  getQuickSightDashboards {
    Name
    PublishedVersionNumber
    DashboardId
  }
}
    `;

/**
 * __useGetQuickSightDashboardsQuery__
 *
 * To run a query within a React component, call `useGetQuickSightDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickSightDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickSightDashboardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickSightDashboardsQuery(baseOptions?: Apollo.QueryHookOptions<GetQuickSightDashboardsQuery, GetQuickSightDashboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickSightDashboardsQuery, GetQuickSightDashboardsQueryVariables>(GetQuickSightDashboardsDocument, options);
      }
export function useGetQuickSightDashboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickSightDashboardsQuery, GetQuickSightDashboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickSightDashboardsQuery, GetQuickSightDashboardsQueryVariables>(GetQuickSightDashboardsDocument, options);
        }
export type GetQuickSightDashboardsQueryHookResult = ReturnType<typeof useGetQuickSightDashboardsQuery>;
export type GetQuickSightDashboardsLazyQueryHookResult = ReturnType<typeof useGetQuickSightDashboardsLazyQuery>;
export type GetQuickSightDashboardsQueryResult = Apollo.QueryResult<GetQuickSightDashboardsQuery, GetQuickSightDashboardsQueryVariables>;
export function refetchGetQuickSightDashboardsQuery(variables?: GetQuickSightDashboardsQueryVariables) {
      return { query: GetQuickSightDashboardsDocument, variables: variables }
    }
export const GetQuickSightEmbedUrlDocument = gql`
    query getQuickSightEmbedURL($where: getQuickSightEmbedURLInput!) {
  getQuickSightEmbedURL(where: $where) {
    Status
    EmbedUrl
    RequestId
  }
}
    `;

/**
 * __useGetQuickSightEmbedUrlQuery__
 *
 * To run a query within a React component, call `useGetQuickSightEmbedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickSightEmbedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickSightEmbedUrlQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetQuickSightEmbedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetQuickSightEmbedUrlQuery, GetQuickSightEmbedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickSightEmbedUrlQuery, GetQuickSightEmbedUrlQueryVariables>(GetQuickSightEmbedUrlDocument, options);
      }
export function useGetQuickSightEmbedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickSightEmbedUrlQuery, GetQuickSightEmbedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickSightEmbedUrlQuery, GetQuickSightEmbedUrlQueryVariables>(GetQuickSightEmbedUrlDocument, options);
        }
export type GetQuickSightEmbedUrlQueryHookResult = ReturnType<typeof useGetQuickSightEmbedUrlQuery>;
export type GetQuickSightEmbedUrlLazyQueryHookResult = ReturnType<typeof useGetQuickSightEmbedUrlLazyQuery>;
export type GetQuickSightEmbedUrlQueryResult = Apollo.QueryResult<GetQuickSightEmbedUrlQuery, GetQuickSightEmbedUrlQueryVariables>;
export function refetchGetQuickSightEmbedUrlQuery(variables?: GetQuickSightEmbedUrlQueryVariables) {
      return { query: GetQuickSightEmbedUrlDocument, variables: variables }
    }
export const GetSignedDownloadUrlDocument = gql`
    mutation getSignedDownloadUrl($assetUrl: String!) {
  getSignedDownloadUrl(assetUrl: $assetUrl)
}
    `;
export type GetSignedDownloadUrlMutationFn = Apollo.MutationFunction<GetSignedDownloadUrlMutation, GetSignedDownloadUrlMutationVariables>;

/**
 * __useGetSignedDownloadUrlMutation__
 *
 * To run a mutation, you first call `useGetSignedDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSignedDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSignedDownloadUrlMutation, { data, loading, error }] = useGetSignedDownloadUrlMutation({
 *   variables: {
 *      assetUrl: // value for 'assetUrl'
 *   },
 * });
 */
export function useGetSignedDownloadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetSignedDownloadUrlMutation, GetSignedDownloadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetSignedDownloadUrlMutation, GetSignedDownloadUrlMutationVariables>(GetSignedDownloadUrlDocument, options);
      }
export type GetSignedDownloadUrlMutationHookResult = ReturnType<typeof useGetSignedDownloadUrlMutation>;
export type GetSignedDownloadUrlMutationResult = Apollo.MutationResult<GetSignedDownloadUrlMutation>;
export type GetSignedDownloadUrlMutationOptions = Apollo.BaseMutationOptions<GetSignedDownloadUrlMutation, GetSignedDownloadUrlMutationVariables>;
export const CreateOnePayoutBatchingPeriodDocument = gql`
    mutation createOnePayoutBatchingPeriod($data: PayoutBatchingPeriodCreateInput!) {
  createOnePayoutBatchingPeriod(data: $data) {
    id
    createdAt
    updatedAt
    startsAt
    endsAt
  }
}
    `;
export type CreateOnePayoutBatchingPeriodMutationFn = Apollo.MutationFunction<CreateOnePayoutBatchingPeriodMutation, CreateOnePayoutBatchingPeriodMutationVariables>;

/**
 * __useCreateOnePayoutBatchingPeriodMutation__
 *
 * To run a mutation, you first call `useCreateOnePayoutBatchingPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOnePayoutBatchingPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOnePayoutBatchingPeriodMutation, { data, loading, error }] = useCreateOnePayoutBatchingPeriodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOnePayoutBatchingPeriodMutation(baseOptions?: Apollo.MutationHookOptions<CreateOnePayoutBatchingPeriodMutation, CreateOnePayoutBatchingPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOnePayoutBatchingPeriodMutation, CreateOnePayoutBatchingPeriodMutationVariables>(CreateOnePayoutBatchingPeriodDocument, options);
      }
export type CreateOnePayoutBatchingPeriodMutationHookResult = ReturnType<typeof useCreateOnePayoutBatchingPeriodMutation>;
export type CreateOnePayoutBatchingPeriodMutationResult = Apollo.MutationResult<CreateOnePayoutBatchingPeriodMutation>;
export type CreateOnePayoutBatchingPeriodMutationOptions = Apollo.BaseMutationOptions<CreateOnePayoutBatchingPeriodMutation, CreateOnePayoutBatchingPeriodMutationVariables>;
export const CreateOnePimsWritebackLogEntryDocument = gql`
    mutation createOnePimsWritebackLogEntry($data: PimsWritebackLogEntryCreateInput!) {
  createOnePimsWritebackLogEntry(data: $data) {
    id
    createdAt
  }
}
    `;
export type CreateOnePimsWritebackLogEntryMutationFn = Apollo.MutationFunction<CreateOnePimsWritebackLogEntryMutation, CreateOnePimsWritebackLogEntryMutationVariables>;

/**
 * __useCreateOnePimsWritebackLogEntryMutation__
 *
 * To run a mutation, you first call `useCreateOnePimsWritebackLogEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOnePimsWritebackLogEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOnePimsWritebackLogEntryMutation, { data, loading, error }] = useCreateOnePimsWritebackLogEntryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOnePimsWritebackLogEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateOnePimsWritebackLogEntryMutation, CreateOnePimsWritebackLogEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOnePimsWritebackLogEntryMutation, CreateOnePimsWritebackLogEntryMutationVariables>(CreateOnePimsWritebackLogEntryDocument, options);
      }
export type CreateOnePimsWritebackLogEntryMutationHookResult = ReturnType<typeof useCreateOnePimsWritebackLogEntryMutation>;
export type CreateOnePimsWritebackLogEntryMutationResult = Apollo.MutationResult<CreateOnePimsWritebackLogEntryMutation>;
export type CreateOnePimsWritebackLogEntryMutationOptions = Apollo.BaseMutationOptions<CreateOnePimsWritebackLogEntryMutation, CreateOnePimsWritebackLogEntryMutationVariables>;
export const ResendReceiptEmailDocument = gql`
    mutation resendReceiptEmail($intentId: String!, $emailOverride: String) {
  resendReceiptEmail(
    stripePaymentIntentId: $intentId
    emailOverride: $emailOverride
  ) {
    success
    error
    jobChainId
  }
}
    `;
export type ResendReceiptEmailMutationFn = Apollo.MutationFunction<ResendReceiptEmailMutation, ResendReceiptEmailMutationVariables>;

/**
 * __useResendReceiptEmailMutation__
 *
 * To run a mutation, you first call `useResendReceiptEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendReceiptEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendReceiptEmailMutation, { data, loading, error }] = useResendReceiptEmailMutation({
 *   variables: {
 *      intentId: // value for 'intentId'
 *      emailOverride: // value for 'emailOverride'
 *   },
 * });
 */
export function useResendReceiptEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendReceiptEmailMutation, ResendReceiptEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendReceiptEmailMutation, ResendReceiptEmailMutationVariables>(ResendReceiptEmailDocument, options);
      }
export type ResendReceiptEmailMutationHookResult = ReturnType<typeof useResendReceiptEmailMutation>;
export type ResendReceiptEmailMutationResult = Apollo.MutationResult<ResendReceiptEmailMutation>;
export type ResendReceiptEmailMutationOptions = Apollo.BaseMutationOptions<ResendReceiptEmailMutation, ResendReceiptEmailMutationVariables>;
export const RetryPaymentWritebackDocument = gql`
    mutation retryPaymentWriteback($stripePaymentIntentId: String!) {
  retryPaymentWriteback(stripePaymentIntentId: $stripePaymentIntentId) {
    success
    error
    jobChainId
  }
}
    `;
export type RetryPaymentWritebackMutationFn = Apollo.MutationFunction<RetryPaymentWritebackMutation, RetryPaymentWritebackMutationVariables>;

/**
 * __useRetryPaymentWritebackMutation__
 *
 * To run a mutation, you first call `useRetryPaymentWritebackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryPaymentWritebackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryPaymentWritebackMutation, { data, loading, error }] = useRetryPaymentWritebackMutation({
 *   variables: {
 *      stripePaymentIntentId: // value for 'stripePaymentIntentId'
 *   },
 * });
 */
export function useRetryPaymentWritebackMutation(baseOptions?: Apollo.MutationHookOptions<RetryPaymentWritebackMutation, RetryPaymentWritebackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryPaymentWritebackMutation, RetryPaymentWritebackMutationVariables>(RetryPaymentWritebackDocument, options);
      }
export type RetryPaymentWritebackMutationHookResult = ReturnType<typeof useRetryPaymentWritebackMutation>;
export type RetryPaymentWritebackMutationResult = Apollo.MutationResult<RetryPaymentWritebackMutation>;
export type RetryPaymentWritebackMutationOptions = Apollo.BaseMutationOptions<RetryPaymentWritebackMutation, RetryPaymentWritebackMutationVariables>;
export const UpdatePayoutBatchingSettingDocument = gql`
    mutation updatePayoutBatchingSetting($data: UpdatePayoutBatchingSettingInput!) {
  updatePayoutBatchingSetting(data: $data) {
    success
  }
}
    `;
export type UpdatePayoutBatchingSettingMutationFn = Apollo.MutationFunction<UpdatePayoutBatchingSettingMutation, UpdatePayoutBatchingSettingMutationVariables>;

/**
 * __useUpdatePayoutBatchingSettingMutation__
 *
 * To run a mutation, you first call `useUpdatePayoutBatchingSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayoutBatchingSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayoutBatchingSettingMutation, { data, loading, error }] = useUpdatePayoutBatchingSettingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePayoutBatchingSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePayoutBatchingSettingMutation, UpdatePayoutBatchingSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePayoutBatchingSettingMutation, UpdatePayoutBatchingSettingMutationVariables>(UpdatePayoutBatchingSettingDocument, options);
      }
export type UpdatePayoutBatchingSettingMutationHookResult = ReturnType<typeof useUpdatePayoutBatchingSettingMutation>;
export type UpdatePayoutBatchingSettingMutationResult = Apollo.MutationResult<UpdatePayoutBatchingSettingMutation>;
export type UpdatePayoutBatchingSettingMutationOptions = Apollo.BaseMutationOptions<UpdatePayoutBatchingSettingMutation, UpdatePayoutBatchingSettingMutationVariables>;
export const CheckCanManuallyRetryPaymentWritebackDocument = gql`
    query checkCanManuallyRetryPaymentWriteback($paymentIntentId: String!) {
  canManuallyRetryPaymentWriteback(stripePaymentIntentId: $paymentIntentId) {
    retryable
    reason
    retryAvailableAfter
  }
}
    `;

/**
 * __useCheckCanManuallyRetryPaymentWritebackQuery__
 *
 * To run a query within a React component, call `useCheckCanManuallyRetryPaymentWritebackQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCanManuallyRetryPaymentWritebackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCanManuallyRetryPaymentWritebackQuery({
 *   variables: {
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useCheckCanManuallyRetryPaymentWritebackQuery(baseOptions: Apollo.QueryHookOptions<CheckCanManuallyRetryPaymentWritebackQuery, CheckCanManuallyRetryPaymentWritebackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCanManuallyRetryPaymentWritebackQuery, CheckCanManuallyRetryPaymentWritebackQueryVariables>(CheckCanManuallyRetryPaymentWritebackDocument, options);
      }
export function useCheckCanManuallyRetryPaymentWritebackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCanManuallyRetryPaymentWritebackQuery, CheckCanManuallyRetryPaymentWritebackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCanManuallyRetryPaymentWritebackQuery, CheckCanManuallyRetryPaymentWritebackQueryVariables>(CheckCanManuallyRetryPaymentWritebackDocument, options);
        }
export type CheckCanManuallyRetryPaymentWritebackQueryHookResult = ReturnType<typeof useCheckCanManuallyRetryPaymentWritebackQuery>;
export type CheckCanManuallyRetryPaymentWritebackLazyQueryHookResult = ReturnType<typeof useCheckCanManuallyRetryPaymentWritebackLazyQuery>;
export type CheckCanManuallyRetryPaymentWritebackQueryResult = Apollo.QueryResult<CheckCanManuallyRetryPaymentWritebackQuery, CheckCanManuallyRetryPaymentWritebackQueryVariables>;
export function refetchCheckCanManuallyRetryPaymentWritebackQuery(variables?: CheckCanManuallyRetryPaymentWritebackQueryVariables) {
      return { query: CheckCanManuallyRetryPaymentWritebackDocument, variables: variables }
    }
export const FindFirstPayoutBatchingPeriodDocument = gql`
    query findFirstPayoutBatchingPeriod($where: PayoutBatchingPeriodWhereInput) {
  findManyPayoutBatchingPeriod(where: $where, orderBy: {endsAt: desc}, take: 1) {
    ...PayoutBatchingPeriod
  }
}
    ${PayoutBatchingPeriodFragmentDoc}`;

/**
 * __useFindFirstPayoutBatchingPeriodQuery__
 *
 * To run a query within a React component, call `useFindFirstPayoutBatchingPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstPayoutBatchingPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstPayoutBatchingPeriodQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFirstPayoutBatchingPeriodQuery(baseOptions?: Apollo.QueryHookOptions<FindFirstPayoutBatchingPeriodQuery, FindFirstPayoutBatchingPeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFirstPayoutBatchingPeriodQuery, FindFirstPayoutBatchingPeriodQueryVariables>(FindFirstPayoutBatchingPeriodDocument, options);
      }
export function useFindFirstPayoutBatchingPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFirstPayoutBatchingPeriodQuery, FindFirstPayoutBatchingPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFirstPayoutBatchingPeriodQuery, FindFirstPayoutBatchingPeriodQueryVariables>(FindFirstPayoutBatchingPeriodDocument, options);
        }
export type FindFirstPayoutBatchingPeriodQueryHookResult = ReturnType<typeof useFindFirstPayoutBatchingPeriodQuery>;
export type FindFirstPayoutBatchingPeriodLazyQueryHookResult = ReturnType<typeof useFindFirstPayoutBatchingPeriodLazyQuery>;
export type FindFirstPayoutBatchingPeriodQueryResult = Apollo.QueryResult<FindFirstPayoutBatchingPeriodQuery, FindFirstPayoutBatchingPeriodQueryVariables>;
export function refetchFindFirstPayoutBatchingPeriodQuery(variables?: FindFirstPayoutBatchingPeriodQueryVariables) {
      return { query: FindFirstPayoutBatchingPeriodDocument, variables: variables }
    }
export const FindMissingPayoutBatchingPeriodDatesDocument = gql`
    query findMissingPayoutBatchingPeriodDates {
  findMissingPayoutBatchingPeriodDates {
    success
    error
    dates
  }
}
    `;

/**
 * __useFindMissingPayoutBatchingPeriodDatesQuery__
 *
 * To run a query within a React component, call `useFindMissingPayoutBatchingPeriodDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMissingPayoutBatchingPeriodDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMissingPayoutBatchingPeriodDatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindMissingPayoutBatchingPeriodDatesQuery(baseOptions?: Apollo.QueryHookOptions<FindMissingPayoutBatchingPeriodDatesQuery, FindMissingPayoutBatchingPeriodDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMissingPayoutBatchingPeriodDatesQuery, FindMissingPayoutBatchingPeriodDatesQueryVariables>(FindMissingPayoutBatchingPeriodDatesDocument, options);
      }
export function useFindMissingPayoutBatchingPeriodDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMissingPayoutBatchingPeriodDatesQuery, FindMissingPayoutBatchingPeriodDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMissingPayoutBatchingPeriodDatesQuery, FindMissingPayoutBatchingPeriodDatesQueryVariables>(FindMissingPayoutBatchingPeriodDatesDocument, options);
        }
export type FindMissingPayoutBatchingPeriodDatesQueryHookResult = ReturnType<typeof useFindMissingPayoutBatchingPeriodDatesQuery>;
export type FindMissingPayoutBatchingPeriodDatesLazyQueryHookResult = ReturnType<typeof useFindMissingPayoutBatchingPeriodDatesLazyQuery>;
export type FindMissingPayoutBatchingPeriodDatesQueryResult = Apollo.QueryResult<FindMissingPayoutBatchingPeriodDatesQuery, FindMissingPayoutBatchingPeriodDatesQueryVariables>;
export function refetchFindMissingPayoutBatchingPeriodDatesQuery(variables?: FindMissingPayoutBatchingPeriodDatesQueryVariables) {
      return { query: FindMissingPayoutBatchingPeriodDatesDocument, variables: variables }
    }
export const GetDisbursementsDocument = gql`
    query getDisbursements($data: GetDisbursementsInput!, $skip: Int, $take: Int, $sortBy: SortBy) {
  getDisbursements(data: $data, skip: $skip, take: $take, sortBy: $sortBy) {
    total
    data {
      ...StripePayoutSelection
    }
  }
}
    ${StripePayoutSelectionFragmentDoc}`;

/**
 * __useGetDisbursementsQuery__
 *
 * To run a query within a React component, call `useGetDisbursementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisbursementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisbursementsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetDisbursementsQuery(baseOptions: Apollo.QueryHookOptions<GetDisbursementsQuery, GetDisbursementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisbursementsQuery, GetDisbursementsQueryVariables>(GetDisbursementsDocument, options);
      }
export function useGetDisbursementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisbursementsQuery, GetDisbursementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisbursementsQuery, GetDisbursementsQueryVariables>(GetDisbursementsDocument, options);
        }
export type GetDisbursementsQueryHookResult = ReturnType<typeof useGetDisbursementsQuery>;
export type GetDisbursementsLazyQueryHookResult = ReturnType<typeof useGetDisbursementsLazyQuery>;
export type GetDisbursementsQueryResult = Apollo.QueryResult<GetDisbursementsQuery, GetDisbursementsQueryVariables>;
export function refetchGetDisbursementsQuery(variables?: GetDisbursementsQueryVariables) {
      return { query: GetDisbursementsDocument, variables: variables }
    }
export const GetDisputesDocument = gql`
    query getDisputes($data: GetDisputesInput!, $skip: Int, $take: Int, $sortBy: SortBy) {
  getDisputes(data: $data, skip: $skip, take: $take, sortBy: $sortBy) {
    total
    data {
      ...StripeDisputeSelection
    }
  }
}
    ${StripeDisputeSelectionFragmentDoc}`;

/**
 * __useGetDisputesQuery__
 *
 * To run a query within a React component, call `useGetDisputesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisputesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisputesQuery({
 *   variables: {
 *      data: // value for 'data'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetDisputesQuery(baseOptions: Apollo.QueryHookOptions<GetDisputesQuery, GetDisputesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisputesQuery, GetDisputesQueryVariables>(GetDisputesDocument, options);
      }
export function useGetDisputesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisputesQuery, GetDisputesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisputesQuery, GetDisputesQueryVariables>(GetDisputesDocument, options);
        }
export type GetDisputesQueryHookResult = ReturnType<typeof useGetDisputesQuery>;
export type GetDisputesLazyQueryHookResult = ReturnType<typeof useGetDisputesLazyQuery>;
export type GetDisputesQueryResult = Apollo.QueryResult<GetDisputesQuery, GetDisputesQueryVariables>;
export function refetchGetDisputesQuery(variables?: GetDisputesQueryVariables) {
      return { query: GetDisputesDocument, variables: variables }
    }
export const GetFinancialTransactionTotalsDocument = gql`
    query getFinancialTransactionTotals($data: GetFinancialTransactionTotalsInput!) {
  getFinancialTransactionTotals(data: $data) {
    amount
    clientFees
    invoiced
    transactionFees
    netProceeds
  }
}
    `;

/**
 * __useGetFinancialTransactionTotalsQuery__
 *
 * To run a query within a React component, call `useGetFinancialTransactionTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialTransactionTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialTransactionTotalsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetFinancialTransactionTotalsQuery(baseOptions: Apollo.QueryHookOptions<GetFinancialTransactionTotalsQuery, GetFinancialTransactionTotalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialTransactionTotalsQuery, GetFinancialTransactionTotalsQueryVariables>(GetFinancialTransactionTotalsDocument, options);
      }
export function useGetFinancialTransactionTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialTransactionTotalsQuery, GetFinancialTransactionTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialTransactionTotalsQuery, GetFinancialTransactionTotalsQueryVariables>(GetFinancialTransactionTotalsDocument, options);
        }
export type GetFinancialTransactionTotalsQueryHookResult = ReturnType<typeof useGetFinancialTransactionTotalsQuery>;
export type GetFinancialTransactionTotalsLazyQueryHookResult = ReturnType<typeof useGetFinancialTransactionTotalsLazyQuery>;
export type GetFinancialTransactionTotalsQueryResult = Apollo.QueryResult<GetFinancialTransactionTotalsQuery, GetFinancialTransactionTotalsQueryVariables>;
export function refetchGetFinancialTransactionTotalsQuery(variables?: GetFinancialTransactionTotalsQueryVariables) {
      return { query: GetFinancialTransactionTotalsDocument, variables: variables }
    }
export const GetFinancialTransactionsDocument = gql`
    query getFinancialTransactions($data: GetFinancialTransactionsInput!, $skip: Int, $take: Int, $sortBy: SortBy) {
  getFinancialTransactions(data: $data, skip: $skip, take: $take, sortBy: $sortBy) {
    total
    data {
      ...PaymentReportFinancialTransaction
    }
  }
}
    ${PaymentReportFinancialTransactionFragmentDoc}`;

/**
 * __useGetFinancialTransactionsQuery__
 *
 * To run a query within a React component, call `useGetFinancialTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialTransactionsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetFinancialTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetFinancialTransactionsQuery, GetFinancialTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialTransactionsQuery, GetFinancialTransactionsQueryVariables>(GetFinancialTransactionsDocument, options);
      }
export function useGetFinancialTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialTransactionsQuery, GetFinancialTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialTransactionsQuery, GetFinancialTransactionsQueryVariables>(GetFinancialTransactionsDocument, options);
        }
export type GetFinancialTransactionsQueryHookResult = ReturnType<typeof useGetFinancialTransactionsQuery>;
export type GetFinancialTransactionsLazyQueryHookResult = ReturnType<typeof useGetFinancialTransactionsLazyQuery>;
export type GetFinancialTransactionsQueryResult = Apollo.QueryResult<GetFinancialTransactionsQuery, GetFinancialTransactionsQueryVariables>;
export function refetchGetFinancialTransactionsQuery(variables?: GetFinancialTransactionsQueryVariables) {
      return { query: GetFinancialTransactionsDocument, variables: variables }
    }
export const GetPayoutBatchingSettingDocument = gql`
    query getPayoutBatchingSetting($where: PayoutBatchingSettingWhereInput) {
  findFirstPayoutBatchingSetting(where: $where) {
    ...PayoutBatchingSettings
  }
}
    ${PayoutBatchingSettingsFragmentDoc}`;

/**
 * __useGetPayoutBatchingSettingQuery__
 *
 * To run a query within a React component, call `useGetPayoutBatchingSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutBatchingSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutBatchingSettingQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPayoutBatchingSettingQuery(baseOptions?: Apollo.QueryHookOptions<GetPayoutBatchingSettingQuery, GetPayoutBatchingSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayoutBatchingSettingQuery, GetPayoutBatchingSettingQueryVariables>(GetPayoutBatchingSettingDocument, options);
      }
export function useGetPayoutBatchingSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayoutBatchingSettingQuery, GetPayoutBatchingSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayoutBatchingSettingQuery, GetPayoutBatchingSettingQueryVariables>(GetPayoutBatchingSettingDocument, options);
        }
export type GetPayoutBatchingSettingQueryHookResult = ReturnType<typeof useGetPayoutBatchingSettingQuery>;
export type GetPayoutBatchingSettingLazyQueryHookResult = ReturnType<typeof useGetPayoutBatchingSettingLazyQuery>;
export type GetPayoutBatchingSettingQueryResult = Apollo.QueryResult<GetPayoutBatchingSettingQuery, GetPayoutBatchingSettingQueryVariables>;
export function refetchGetPayoutBatchingSettingQuery(variables?: GetPayoutBatchingSettingQueryVariables) {
      return { query: GetPayoutBatchingSettingDocument, variables: variables }
    }
export const GetStripeDisputesByPaymentIntentDocument = gql`
    query getStripeDisputesByPaymentIntent($where: StripeDisputeWhereInput!) {
  findManyStripeDispute(where: $where) {
    id
  }
}
    `;

/**
 * __useGetStripeDisputesByPaymentIntentQuery__
 *
 * To run a query within a React component, call `useGetStripeDisputesByPaymentIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeDisputesByPaymentIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeDisputesByPaymentIntentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetStripeDisputesByPaymentIntentQuery(baseOptions: Apollo.QueryHookOptions<GetStripeDisputesByPaymentIntentQuery, GetStripeDisputesByPaymentIntentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeDisputesByPaymentIntentQuery, GetStripeDisputesByPaymentIntentQueryVariables>(GetStripeDisputesByPaymentIntentDocument, options);
      }
export function useGetStripeDisputesByPaymentIntentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeDisputesByPaymentIntentQuery, GetStripeDisputesByPaymentIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeDisputesByPaymentIntentQuery, GetStripeDisputesByPaymentIntentQueryVariables>(GetStripeDisputesByPaymentIntentDocument, options);
        }
export type GetStripeDisputesByPaymentIntentQueryHookResult = ReturnType<typeof useGetStripeDisputesByPaymentIntentQuery>;
export type GetStripeDisputesByPaymentIntentLazyQueryHookResult = ReturnType<typeof useGetStripeDisputesByPaymentIntentLazyQuery>;
export type GetStripeDisputesByPaymentIntentQueryResult = Apollo.QueryResult<GetStripeDisputesByPaymentIntentQuery, GetStripeDisputesByPaymentIntentQueryVariables>;
export function refetchGetStripeDisputesByPaymentIntentQuery(variables?: GetStripeDisputesByPaymentIntentQueryVariables) {
      return { query: GetStripeDisputesByPaymentIntentDocument, variables: variables }
    }
export const GetPaymentReportStripePaymentIntentDocument = gql`
    query getPaymentReportStripePaymentIntent($where: StripePaymentIntentWhereUniqueInput!) {
  findUniqueStripePaymentIntent(where: $where) {
    ...RefundModalPaymentIntent
  }
}
    ${RefundModalPaymentIntentFragmentDoc}`;

/**
 * __useGetPaymentReportStripePaymentIntentQuery__
 *
 * To run a query within a React component, call `useGetPaymentReportStripePaymentIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentReportStripePaymentIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentReportStripePaymentIntentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPaymentReportStripePaymentIntentQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentReportStripePaymentIntentQuery, GetPaymentReportStripePaymentIntentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentReportStripePaymentIntentQuery, GetPaymentReportStripePaymentIntentQueryVariables>(GetPaymentReportStripePaymentIntentDocument, options);
      }
export function useGetPaymentReportStripePaymentIntentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentReportStripePaymentIntentQuery, GetPaymentReportStripePaymentIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentReportStripePaymentIntentQuery, GetPaymentReportStripePaymentIntentQueryVariables>(GetPaymentReportStripePaymentIntentDocument, options);
        }
export type GetPaymentReportStripePaymentIntentQueryHookResult = ReturnType<typeof useGetPaymentReportStripePaymentIntentQuery>;
export type GetPaymentReportStripePaymentIntentLazyQueryHookResult = ReturnType<typeof useGetPaymentReportStripePaymentIntentLazyQuery>;
export type GetPaymentReportStripePaymentIntentQueryResult = Apollo.QueryResult<GetPaymentReportStripePaymentIntentQuery, GetPaymentReportStripePaymentIntentQueryVariables>;
export function refetchGetPaymentReportStripePaymentIntentQuery(variables?: GetPaymentReportStripePaymentIntentQueryVariables) {
      return { query: GetPaymentReportStripePaymentIntentDocument, variables: variables }
    }
export const GetStripeReceiptUrlDocument = gql`
    query getStripeReceiptUrl($intentId: String!) {
  getStripePaymentIntentData(where: {id: $intentId}) {
    payment {
      receiptUrl
    }
  }
}
    `;

/**
 * __useGetStripeReceiptUrlQuery__
 *
 * To run a query within a React component, call `useGetStripeReceiptUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeReceiptUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeReceiptUrlQuery({
 *   variables: {
 *      intentId: // value for 'intentId'
 *   },
 * });
 */
export function useGetStripeReceiptUrlQuery(baseOptions: Apollo.QueryHookOptions<GetStripeReceiptUrlQuery, GetStripeReceiptUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeReceiptUrlQuery, GetStripeReceiptUrlQueryVariables>(GetStripeReceiptUrlDocument, options);
      }
export function useGetStripeReceiptUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeReceiptUrlQuery, GetStripeReceiptUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeReceiptUrlQuery, GetStripeReceiptUrlQueryVariables>(GetStripeReceiptUrlDocument, options);
        }
export type GetStripeReceiptUrlQueryHookResult = ReturnType<typeof useGetStripeReceiptUrlQuery>;
export type GetStripeReceiptUrlLazyQueryHookResult = ReturnType<typeof useGetStripeReceiptUrlLazyQuery>;
export type GetStripeReceiptUrlQueryResult = Apollo.QueryResult<GetStripeReceiptUrlQuery, GetStripeReceiptUrlQueryVariables>;
export function refetchGetStripeReceiptUrlQuery(variables?: GetStripeReceiptUrlQueryVariables) {
      return { query: GetStripeReceiptUrlDocument, variables: variables }
    }
export const RequestBitwerxIntegrationDocument = gql`
    mutation requestBitwerxIntegration($data: RequestBitwerxIntegrationInput!) {
  requestBitwerxIntegration(data: $data) {
    id
  }
}
    `;
export type RequestBitwerxIntegrationMutationFn = Apollo.MutationFunction<RequestBitwerxIntegrationMutation, RequestBitwerxIntegrationMutationVariables>;

/**
 * __useRequestBitwerxIntegrationMutation__
 *
 * To run a mutation, you first call `useRequestBitwerxIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBitwerxIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBitwerxIntegrationMutation, { data, loading, error }] = useRequestBitwerxIntegrationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRequestBitwerxIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<RequestBitwerxIntegrationMutation, RequestBitwerxIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBitwerxIntegrationMutation, RequestBitwerxIntegrationMutationVariables>(RequestBitwerxIntegrationDocument, options);
      }
export type RequestBitwerxIntegrationMutationHookResult = ReturnType<typeof useRequestBitwerxIntegrationMutation>;
export type RequestBitwerxIntegrationMutationResult = Apollo.MutationResult<RequestBitwerxIntegrationMutation>;
export type RequestBitwerxIntegrationMutationOptions = Apollo.BaseMutationOptions<RequestBitwerxIntegrationMutation, RequestBitwerxIntegrationMutationVariables>;
export const UpsertPetPortalSettingsDocument = gql`
    mutation upsertPetPortalSettings($where: PetPortalSettingWhereUniqueInput!, $create: PetPortalSettingCreateInput!, $update: PetPortalSettingUpdateInput!) {
  upsertOnePetPortalSetting(where: $where, create: $create, update: $update) {
    id
    clinicSettingId
    showAppointments
  }
}
    `;
export type UpsertPetPortalSettingsMutationFn = Apollo.MutationFunction<UpsertPetPortalSettingsMutation, UpsertPetPortalSettingsMutationVariables>;

/**
 * __useUpsertPetPortalSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertPetPortalSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPetPortalSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPetPortalSettingsMutation, { data, loading, error }] = useUpsertPetPortalSettingsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      create: // value for 'create'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpsertPetPortalSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPetPortalSettingsMutation, UpsertPetPortalSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPetPortalSettingsMutation, UpsertPetPortalSettingsMutationVariables>(UpsertPetPortalSettingsDocument, options);
      }
export type UpsertPetPortalSettingsMutationHookResult = ReturnType<typeof useUpsertPetPortalSettingsMutation>;
export type UpsertPetPortalSettingsMutationResult = Apollo.MutationResult<UpsertPetPortalSettingsMutation>;
export type UpsertPetPortalSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertPetPortalSettingsMutation, UpsertPetPortalSettingsMutationVariables>;
export const JobChainCompletedDocument = gql`
    subscription jobChainCompleted($jobChainId: String!) {
  jobChainCompleted(where: {id: {equals: $jobChainId}}) {
    jobChainId
    payload
    error
    success
  }
}
    `;

/**
 * __useJobChainCompletedSubscription__
 *
 * To run a query within a React component, call `useJobChainCompletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useJobChainCompletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobChainCompletedSubscription({
 *   variables: {
 *      jobChainId: // value for 'jobChainId'
 *   },
 * });
 */
export function useJobChainCompletedSubscription(baseOptions: Apollo.SubscriptionHookOptions<JobChainCompletedSubscription, JobChainCompletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<JobChainCompletedSubscription, JobChainCompletedSubscriptionVariables>(JobChainCompletedDocument, options);
      }
export type JobChainCompletedSubscriptionHookResult = ReturnType<typeof useJobChainCompletedSubscription>;
export type JobChainCompletedSubscriptionResult = Apollo.SubscriptionResult<JobChainCompletedSubscription>;
export const JobChainStatusDocument = gql`
    query jobChainStatus($jobChainId: String!) {
  jobChainStatus(where: {jobChainId: $jobChainId}) {
    status
    payload
    error
    queuedAt
    completedAt
    erroredAt
  }
}
    `;

/**
 * __useJobChainStatusQuery__
 *
 * To run a query within a React component, call `useJobChainStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobChainStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobChainStatusQuery({
 *   variables: {
 *      jobChainId: // value for 'jobChainId'
 *   },
 * });
 */
export function useJobChainStatusQuery(baseOptions: Apollo.QueryHookOptions<JobChainStatusQuery, JobChainStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobChainStatusQuery, JobChainStatusQueryVariables>(JobChainStatusDocument, options);
      }
export function useJobChainStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobChainStatusQuery, JobChainStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobChainStatusQuery, JobChainStatusQueryVariables>(JobChainStatusDocument, options);
        }
export type JobChainStatusQueryHookResult = ReturnType<typeof useJobChainStatusQuery>;
export type JobChainStatusLazyQueryHookResult = ReturnType<typeof useJobChainStatusLazyQuery>;
export type JobChainStatusQueryResult = Apollo.QueryResult<JobChainStatusQuery, JobChainStatusQueryVariables>;
export function refetchJobChainStatusQuery(variables?: JobChainStatusQueryVariables) {
      return { query: JobChainStatusDocument, variables: variables }
    }
export const StripeCreateCustomerPortalDocument = gql`
    query stripeCreateCustomerPortal($data: StripeCustomerPortalInput) {
  stripeCreateCustomerPortal(data: $data) {
    id
    url
  }
}
    `;

/**
 * __useStripeCreateCustomerPortalQuery__
 *
 * To run a query within a React component, call `useStripeCreateCustomerPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeCreateCustomerPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeCreateCustomerPortalQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStripeCreateCustomerPortalQuery(baseOptions?: Apollo.QueryHookOptions<StripeCreateCustomerPortalQuery, StripeCreateCustomerPortalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeCreateCustomerPortalQuery, StripeCreateCustomerPortalQueryVariables>(StripeCreateCustomerPortalDocument, options);
      }
export function useStripeCreateCustomerPortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeCreateCustomerPortalQuery, StripeCreateCustomerPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeCreateCustomerPortalQuery, StripeCreateCustomerPortalQueryVariables>(StripeCreateCustomerPortalDocument, options);
        }
export type StripeCreateCustomerPortalQueryHookResult = ReturnType<typeof useStripeCreateCustomerPortalQuery>;
export type StripeCreateCustomerPortalLazyQueryHookResult = ReturnType<typeof useStripeCreateCustomerPortalLazyQuery>;
export type StripeCreateCustomerPortalQueryResult = Apollo.QueryResult<StripeCreateCustomerPortalQuery, StripeCreateCustomerPortalQueryVariables>;
export function refetchStripeCreateCustomerPortalQuery(variables?: StripeCreateCustomerPortalQueryVariables) {
      return { query: StripeCreateCustomerPortalDocument, variables: variables }
    }
export const TriggerMessageEventDocument = gql`
    mutation triggerMessageEvent($useSubscription: Boolean, $event: String!, $queueName: SqsQueueNames, $data: Json) {
  triggerMessageEvent(
    data: {data: $data, event: $event, queueName: $queueName, useSubscription: $useSubscription}
  ) {
    success
    jobChainId
  }
}
    `;
export type TriggerMessageEventMutationFn = Apollo.MutationFunction<TriggerMessageEventMutation, TriggerMessageEventMutationVariables>;

/**
 * __useTriggerMessageEventMutation__
 *
 * To run a mutation, you first call `useTriggerMessageEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerMessageEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerMessageEventMutation, { data, loading, error }] = useTriggerMessageEventMutation({
 *   variables: {
 *      useSubscription: // value for 'useSubscription'
 *      event: // value for 'event'
 *      queueName: // value for 'queueName'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTriggerMessageEventMutation(baseOptions?: Apollo.MutationHookOptions<TriggerMessageEventMutation, TriggerMessageEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerMessageEventMutation, TriggerMessageEventMutationVariables>(TriggerMessageEventDocument, options);
      }
export type TriggerMessageEventMutationHookResult = ReturnType<typeof useTriggerMessageEventMutation>;
export type TriggerMessageEventMutationResult = Apollo.MutationResult<TriggerMessageEventMutation>;
export type TriggerMessageEventMutationOptions = Apollo.BaseMutationOptions<TriggerMessageEventMutation, TriggerMessageEventMutationVariables>;
export const GetFailedWritebackAppointmentsDocument = gql`
    query getFailedWritebackAppointments($where: AppointmentWhereInput!) {
  appointments: findManyAppointment(where: $where) {
    ...FailedWritebackAppointment
  }
}
    ${FailedWritebackAppointmentFragmentDoc}`;

/**
 * __useGetFailedWritebackAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetFailedWritebackAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFailedWritebackAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFailedWritebackAppointmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFailedWritebackAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetFailedWritebackAppointmentsQuery, GetFailedWritebackAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFailedWritebackAppointmentsQuery, GetFailedWritebackAppointmentsQueryVariables>(GetFailedWritebackAppointmentsDocument, options);
      }
export function useGetFailedWritebackAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFailedWritebackAppointmentsQuery, GetFailedWritebackAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFailedWritebackAppointmentsQuery, GetFailedWritebackAppointmentsQueryVariables>(GetFailedWritebackAppointmentsDocument, options);
        }
export type GetFailedWritebackAppointmentsQueryHookResult = ReturnType<typeof useGetFailedWritebackAppointmentsQuery>;
export type GetFailedWritebackAppointmentsLazyQueryHookResult = ReturnType<typeof useGetFailedWritebackAppointmentsLazyQuery>;
export type GetFailedWritebackAppointmentsQueryResult = Apollo.QueryResult<GetFailedWritebackAppointmentsQuery, GetFailedWritebackAppointmentsQueryVariables>;
export function refetchGetFailedWritebackAppointmentsQuery(variables?: GetFailedWritebackAppointmentsQueryVariables) {
      return { query: GetFailedWritebackAppointmentsDocument, variables: variables }
    }
export const DeleteDirectBookingExclusionRuleDocument = gql`
    mutation deleteDirectBookingExclusionRule($ruleId: String!) {
  deleteOneDirectBookingExclusionRule(where: {id: $ruleId}) {
    id
  }
}
    `;
export type DeleteDirectBookingExclusionRuleMutationFn = Apollo.MutationFunction<DeleteDirectBookingExclusionRuleMutation, DeleteDirectBookingExclusionRuleMutationVariables>;

/**
 * __useDeleteDirectBookingExclusionRuleMutation__
 *
 * To run a mutation, you first call `useDeleteDirectBookingExclusionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDirectBookingExclusionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDirectBookingExclusionRuleMutation, { data, loading, error }] = useDeleteDirectBookingExclusionRuleMutation({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useDeleteDirectBookingExclusionRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDirectBookingExclusionRuleMutation, DeleteDirectBookingExclusionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDirectBookingExclusionRuleMutation, DeleteDirectBookingExclusionRuleMutationVariables>(DeleteDirectBookingExclusionRuleDocument, options);
      }
export type DeleteDirectBookingExclusionRuleMutationHookResult = ReturnType<typeof useDeleteDirectBookingExclusionRuleMutation>;
export type DeleteDirectBookingExclusionRuleMutationResult = Apollo.MutationResult<DeleteDirectBookingExclusionRuleMutation>;
export type DeleteDirectBookingExclusionRuleMutationOptions = Apollo.BaseMutationOptions<DeleteDirectBookingExclusionRuleMutation, DeleteDirectBookingExclusionRuleMutationVariables>;
export const UpdateDirectBookingExclusionRuleDocument = gql`
    mutation updateDirectBookingExclusionRule($ruleId: String!, $data: DirectBookingExclusionRuleUpdateInput!) {
  updateOneDirectBookingExclusionRule(where: {id: $ruleId}, data: $data) {
    ...ExclusionRuleSelection
  }
}
    ${ExclusionRuleSelectionFragmentDoc}`;
export type UpdateDirectBookingExclusionRuleMutationFn = Apollo.MutationFunction<UpdateDirectBookingExclusionRuleMutation, UpdateDirectBookingExclusionRuleMutationVariables>;

/**
 * __useUpdateDirectBookingExclusionRuleMutation__
 *
 * To run a mutation, you first call `useUpdateDirectBookingExclusionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDirectBookingExclusionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDirectBookingExclusionRuleMutation, { data, loading, error }] = useUpdateDirectBookingExclusionRuleMutation({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDirectBookingExclusionRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDirectBookingExclusionRuleMutation, UpdateDirectBookingExclusionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDirectBookingExclusionRuleMutation, UpdateDirectBookingExclusionRuleMutationVariables>(UpdateDirectBookingExclusionRuleDocument, options);
      }
export type UpdateDirectBookingExclusionRuleMutationHookResult = ReturnType<typeof useUpdateDirectBookingExclusionRuleMutation>;
export type UpdateDirectBookingExclusionRuleMutationResult = Apollo.MutationResult<UpdateDirectBookingExclusionRuleMutation>;
export type UpdateDirectBookingExclusionRuleMutationOptions = Apollo.BaseMutationOptions<UpdateDirectBookingExclusionRuleMutation, UpdateDirectBookingExclusionRuleMutationVariables>;
export const UpsertDirectBookingSettingsDocument = gql`
    mutation upsertDirectBookingSettings($where: ClinicDirectBookingSettingWhereUniqueInput!, $create: ClinicDirectBookingSettingCreateInput!, $update: ClinicDirectBookingSettingUpdateInput!) {
  upsertOneClinicDirectBookingSetting(
    where: $where
    create: $create
    update: $update
  ) {
    id
    exclusionRulesEnabled
    appointmentIntervalInMinutesDisplay
  }
}
    `;
export type UpsertDirectBookingSettingsMutationFn = Apollo.MutationFunction<UpsertDirectBookingSettingsMutation, UpsertDirectBookingSettingsMutationVariables>;

/**
 * __useUpsertDirectBookingSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertDirectBookingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDirectBookingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDirectBookingSettingsMutation, { data, loading, error }] = useUpsertDirectBookingSettingsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      create: // value for 'create'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpsertDirectBookingSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDirectBookingSettingsMutation, UpsertDirectBookingSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDirectBookingSettingsMutation, UpsertDirectBookingSettingsMutationVariables>(UpsertDirectBookingSettingsDocument, options);
      }
export type UpsertDirectBookingSettingsMutationHookResult = ReturnType<typeof useUpsertDirectBookingSettingsMutation>;
export type UpsertDirectBookingSettingsMutationResult = Apollo.MutationResult<UpsertDirectBookingSettingsMutation>;
export type UpsertDirectBookingSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertDirectBookingSettingsMutation, UpsertDirectBookingSettingsMutationVariables>;
export const UpsertDirectBookingExclusionRuleDocument = gql`
    mutation upsertDirectBookingExclusionRule($where: DirectBookingExclusionRuleWhereUniqueInput!, $create: DirectBookingExclusionRuleCreateInput!, $update: DirectBookingExclusionRuleUpdateInput!) {
  upsertOneDirectBookingExclusionRule(
    where: $where
    create: $create
    update: $update
  ) {
    ...ExclusionRuleSelection
  }
}
    ${ExclusionRuleSelectionFragmentDoc}`;
export type UpsertDirectBookingExclusionRuleMutationFn = Apollo.MutationFunction<UpsertDirectBookingExclusionRuleMutation, UpsertDirectBookingExclusionRuleMutationVariables>;

/**
 * __useUpsertDirectBookingExclusionRuleMutation__
 *
 * To run a mutation, you first call `useUpsertDirectBookingExclusionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDirectBookingExclusionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDirectBookingExclusionRuleMutation, { data, loading, error }] = useUpsertDirectBookingExclusionRuleMutation({
 *   variables: {
 *      where: // value for 'where'
 *      create: // value for 'create'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpsertDirectBookingExclusionRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDirectBookingExclusionRuleMutation, UpsertDirectBookingExclusionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDirectBookingExclusionRuleMutation, UpsertDirectBookingExclusionRuleMutationVariables>(UpsertDirectBookingExclusionRuleDocument, options);
      }
export type UpsertDirectBookingExclusionRuleMutationHookResult = ReturnType<typeof useUpsertDirectBookingExclusionRuleMutation>;
export type UpsertDirectBookingExclusionRuleMutationResult = Apollo.MutationResult<UpsertDirectBookingExclusionRuleMutation>;
export type UpsertDirectBookingExclusionRuleMutationOptions = Apollo.BaseMutationOptions<UpsertDirectBookingExclusionRuleMutation, UpsertDirectBookingExclusionRuleMutationVariables>;
export const GetClinicTimezoneNameDocument = gql`
    query getClinicTimezoneName($clinicId: String!) {
  findUniqueClinic(where: {id: $clinicId}) {
    id
    timezoneName
  }
}
    `;

/**
 * __useGetClinicTimezoneNameQuery__
 *
 * To run a query within a React component, call `useGetClinicTimezoneNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicTimezoneNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicTimezoneNameQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicTimezoneNameQuery(baseOptions: Apollo.QueryHookOptions<GetClinicTimezoneNameQuery, GetClinicTimezoneNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicTimezoneNameQuery, GetClinicTimezoneNameQueryVariables>(GetClinicTimezoneNameDocument, options);
      }
export function useGetClinicTimezoneNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicTimezoneNameQuery, GetClinicTimezoneNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicTimezoneNameQuery, GetClinicTimezoneNameQueryVariables>(GetClinicTimezoneNameDocument, options);
        }
export type GetClinicTimezoneNameQueryHookResult = ReturnType<typeof useGetClinicTimezoneNameQuery>;
export type GetClinicTimezoneNameLazyQueryHookResult = ReturnType<typeof useGetClinicTimezoneNameLazyQuery>;
export type GetClinicTimezoneNameQueryResult = Apollo.QueryResult<GetClinicTimezoneNameQuery, GetClinicTimezoneNameQueryVariables>;
export function refetchGetClinicTimezoneNameQuery(variables?: GetClinicTimezoneNameQueryVariables) {
      return { query: GetClinicTimezoneNameDocument, variables: variables }
    }
export const GetDirectBookingAppointmentTypesDocument = gql`
    query getDirectBookingAppointmentTypes($clinicId: String!) {
  findManyAppointmentType(
    where: {clinicId: {equals: $clinicId}, isVisible: {equals: true}, name: {not: {equals: ""}}}
    orderBy: {name: asc}
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetDirectBookingAppointmentTypesQuery__
 *
 * To run a query within a React component, call `useGetDirectBookingAppointmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectBookingAppointmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectBookingAppointmentTypesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetDirectBookingAppointmentTypesQuery(baseOptions: Apollo.QueryHookOptions<GetDirectBookingAppointmentTypesQuery, GetDirectBookingAppointmentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectBookingAppointmentTypesQuery, GetDirectBookingAppointmentTypesQueryVariables>(GetDirectBookingAppointmentTypesDocument, options);
      }
export function useGetDirectBookingAppointmentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectBookingAppointmentTypesQuery, GetDirectBookingAppointmentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectBookingAppointmentTypesQuery, GetDirectBookingAppointmentTypesQueryVariables>(GetDirectBookingAppointmentTypesDocument, options);
        }
export type GetDirectBookingAppointmentTypesQueryHookResult = ReturnType<typeof useGetDirectBookingAppointmentTypesQuery>;
export type GetDirectBookingAppointmentTypesLazyQueryHookResult = ReturnType<typeof useGetDirectBookingAppointmentTypesLazyQuery>;
export type GetDirectBookingAppointmentTypesQueryResult = Apollo.QueryResult<GetDirectBookingAppointmentTypesQuery, GetDirectBookingAppointmentTypesQueryVariables>;
export function refetchGetDirectBookingAppointmentTypesQuery(variables?: GetDirectBookingAppointmentTypesQueryVariables) {
      return { query: GetDirectBookingAppointmentTypesDocument, variables: variables }
    }
export const GetDirectBookingExclusionsDocument = gql`
    query getDirectBookingExclusions($clinicId: String!) {
  findManyDirectBookingExclusionRule(
    where: {clinicId: {equals: $clinicId}}
    orderBy: {createdAt: asc}
  ) {
    ...ExclusionRuleSelection
  }
}
    ${ExclusionRuleSelectionFragmentDoc}`;

/**
 * __useGetDirectBookingExclusionsQuery__
 *
 * To run a query within a React component, call `useGetDirectBookingExclusionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectBookingExclusionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectBookingExclusionsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetDirectBookingExclusionsQuery(baseOptions: Apollo.QueryHookOptions<GetDirectBookingExclusionsQuery, GetDirectBookingExclusionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectBookingExclusionsQuery, GetDirectBookingExclusionsQueryVariables>(GetDirectBookingExclusionsDocument, options);
      }
export function useGetDirectBookingExclusionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectBookingExclusionsQuery, GetDirectBookingExclusionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectBookingExclusionsQuery, GetDirectBookingExclusionsQueryVariables>(GetDirectBookingExclusionsDocument, options);
        }
export type GetDirectBookingExclusionsQueryHookResult = ReturnType<typeof useGetDirectBookingExclusionsQuery>;
export type GetDirectBookingExclusionsLazyQueryHookResult = ReturnType<typeof useGetDirectBookingExclusionsLazyQuery>;
export type GetDirectBookingExclusionsQueryResult = Apollo.QueryResult<GetDirectBookingExclusionsQuery, GetDirectBookingExclusionsQueryVariables>;
export function refetchGetDirectBookingExclusionsQuery(variables?: GetDirectBookingExclusionsQueryVariables) {
      return { query: GetDirectBookingExclusionsDocument, variables: variables }
    }
export const GetDirectBookingProvidersDocument = gql`
    query getDirectBookingProviders($clinicId: String!) {
  findManyClinicEmployee(
    where: {isDeleted: {equals: false}, isActive: {equals: true}, isVisible: {equals: true}, clinic: {id: {equals: $clinicId}}}
    orderBy: {firstName: asc}
  ) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useGetDirectBookingProvidersQuery__
 *
 * To run a query within a React component, call `useGetDirectBookingProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectBookingProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectBookingProvidersQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetDirectBookingProvidersQuery(baseOptions: Apollo.QueryHookOptions<GetDirectBookingProvidersQuery, GetDirectBookingProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectBookingProvidersQuery, GetDirectBookingProvidersQueryVariables>(GetDirectBookingProvidersDocument, options);
      }
export function useGetDirectBookingProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectBookingProvidersQuery, GetDirectBookingProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectBookingProvidersQuery, GetDirectBookingProvidersQueryVariables>(GetDirectBookingProvidersDocument, options);
        }
export type GetDirectBookingProvidersQueryHookResult = ReturnType<typeof useGetDirectBookingProvidersQuery>;
export type GetDirectBookingProvidersLazyQueryHookResult = ReturnType<typeof useGetDirectBookingProvidersLazyQuery>;
export type GetDirectBookingProvidersQueryResult = Apollo.QueryResult<GetDirectBookingProvidersQuery, GetDirectBookingProvidersQueryVariables>;
export function refetchGetDirectBookingProvidersQuery(variables?: GetDirectBookingProvidersQueryVariables) {
      return { query: GetDirectBookingProvidersDocument, variables: variables }
    }
export const GetClinicDirectBookingSettingsDocument = gql`
    query getClinicDirectBookingSettings($where: ClinicDirectBookingSettingWhereInput!) {
  findFirstClinicDirectBookingSetting(where: $where) {
    id
    exclusionRulesEnabled
    appointmentIntervalInMinutesDisplay
    maxTimeInAdvanceValue
    maxTimeInAdvanceUnit
  }
}
    `;

/**
 * __useGetClinicDirectBookingSettingsQuery__
 *
 * To run a query within a React component, call `useGetClinicDirectBookingSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicDirectBookingSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicDirectBookingSettingsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicDirectBookingSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicDirectBookingSettingsQuery, GetClinicDirectBookingSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicDirectBookingSettingsQuery, GetClinicDirectBookingSettingsQueryVariables>(GetClinicDirectBookingSettingsDocument, options);
      }
export function useGetClinicDirectBookingSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicDirectBookingSettingsQuery, GetClinicDirectBookingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicDirectBookingSettingsQuery, GetClinicDirectBookingSettingsQueryVariables>(GetClinicDirectBookingSettingsDocument, options);
        }
export type GetClinicDirectBookingSettingsQueryHookResult = ReturnType<typeof useGetClinicDirectBookingSettingsQuery>;
export type GetClinicDirectBookingSettingsLazyQueryHookResult = ReturnType<typeof useGetClinicDirectBookingSettingsLazyQuery>;
export type GetClinicDirectBookingSettingsQueryResult = Apollo.QueryResult<GetClinicDirectBookingSettingsQuery, GetClinicDirectBookingSettingsQueryVariables>;
export function refetchGetClinicDirectBookingSettingsQuery(variables?: GetClinicDirectBookingSettingsQueryVariables) {
      return { query: GetClinicDirectBookingSettingsDocument, variables: variables }
    }
export const UpdateAppointmentTypeOrderDocument = gql`
    mutation updateAppointmentTypeOrder($data: [AppointmentTypeWithOrder!]) {
  updateManyAppointmentTypeSortOrder(data: $data) {
    success
    error
  }
}
    `;
export type UpdateAppointmentTypeOrderMutationFn = Apollo.MutationFunction<UpdateAppointmentTypeOrderMutation, UpdateAppointmentTypeOrderMutationVariables>;

/**
 * __useUpdateAppointmentTypeOrderMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentTypeOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentTypeOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentTypeOrderMutation, { data, loading, error }] = useUpdateAppointmentTypeOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAppointmentTypeOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentTypeOrderMutation, UpdateAppointmentTypeOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentTypeOrderMutation, UpdateAppointmentTypeOrderMutationVariables>(UpdateAppointmentTypeOrderDocument, options);
      }
export type UpdateAppointmentTypeOrderMutationHookResult = ReturnType<typeof useUpdateAppointmentTypeOrderMutation>;
export type UpdateAppointmentTypeOrderMutationResult = Apollo.MutationResult<UpdateAppointmentTypeOrderMutation>;
export type UpdateAppointmentTypeOrderMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentTypeOrderMutation, UpdateAppointmentTypeOrderMutationVariables>;
export const UpdateAppointmentTypeProviderRoomMapsDocument = gql`
    mutation updateAppointmentTypeProviderRoomMaps($data: UpdateAppointmentTypeProviderRoomMapsInput!) {
  updateAppointmentTypeProviderRoomMaps(data: $data) {
    success
    count
  }
}
    `;
export type UpdateAppointmentTypeProviderRoomMapsMutationFn = Apollo.MutationFunction<UpdateAppointmentTypeProviderRoomMapsMutation, UpdateAppointmentTypeProviderRoomMapsMutationVariables>;

/**
 * __useUpdateAppointmentTypeProviderRoomMapsMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentTypeProviderRoomMapsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentTypeProviderRoomMapsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentTypeProviderRoomMapsMutation, { data, loading, error }] = useUpdateAppointmentTypeProviderRoomMapsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAppointmentTypeProviderRoomMapsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentTypeProviderRoomMapsMutation, UpdateAppointmentTypeProviderRoomMapsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentTypeProviderRoomMapsMutation, UpdateAppointmentTypeProviderRoomMapsMutationVariables>(UpdateAppointmentTypeProviderRoomMapsDocument, options);
      }
export type UpdateAppointmentTypeProviderRoomMapsMutationHookResult = ReturnType<typeof useUpdateAppointmentTypeProviderRoomMapsMutation>;
export type UpdateAppointmentTypeProviderRoomMapsMutationResult = Apollo.MutationResult<UpdateAppointmentTypeProviderRoomMapsMutation>;
export type UpdateAppointmentTypeProviderRoomMapsMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentTypeProviderRoomMapsMutation, UpdateAppointmentTypeProviderRoomMapsMutationVariables>;
export const UpdateOneAppointmentTypeDocument = gql`
    mutation updateOneAppointmentType($where: AppointmentTypeWhereUniqueInput!, $data: AppointmentTypeUpdateInput!) {
  updateOneAppointmentType(where: $where, data: $data) {
    id
  }
}
    `;
export type UpdateOneAppointmentTypeMutationFn = Apollo.MutationFunction<UpdateOneAppointmentTypeMutation, UpdateOneAppointmentTypeMutationVariables>;

/**
 * __useUpdateOneAppointmentTypeMutation__
 *
 * To run a mutation, you first call `useUpdateOneAppointmentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneAppointmentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneAppointmentTypeMutation, { data, loading, error }] = useUpdateOneAppointmentTypeMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneAppointmentTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneAppointmentTypeMutation, UpdateOneAppointmentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneAppointmentTypeMutation, UpdateOneAppointmentTypeMutationVariables>(UpdateOneAppointmentTypeDocument, options);
      }
export type UpdateOneAppointmentTypeMutationHookResult = ReturnType<typeof useUpdateOneAppointmentTypeMutation>;
export type UpdateOneAppointmentTypeMutationResult = Apollo.MutationResult<UpdateOneAppointmentTypeMutation>;
export type UpdateOneAppointmentTypeMutationOptions = Apollo.BaseMutationOptions<UpdateOneAppointmentTypeMutation, UpdateOneAppointmentTypeMutationVariables>;
export const GetAppointmentSettingsDocument = gql`
    query getAppointmentSettings($clinicSettingId: String!, $clinicId: String!) {
  findUniquePetPortalSetting(where: {clinicSettingId: $clinicSettingId}) {
    id
    clinicSettingId
    showAppointments
  }
  findManyAppointmentType(
    where: {clinicId: {equals: $clinicId}, isVisible: {equals: true}}
    orderBy: {displayOrder: asc}
  ) {
    ...AppointmentType
  }
  findManyClinicEmployee(
    where: {clinicId: {equals: $clinicId}, isActive: {equals: true}, isVisible: {equals: true}, isDeleted: {equals: false}}
  ) {
    ...Provider
  }
  findManyClinicRoom(
    where: {clinicId: {equals: $clinicId}, isActive: {equals: true}, isVisible: {equals: true}, isDeleted: {equals: false}, isSchedulable: {equals: true}}
  ) {
    ...Room
  }
}
    ${AppointmentTypeFragmentDoc}
${ProviderFragmentDoc}
${RoomFragmentDoc}`;

/**
 * __useGetAppointmentSettingsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentSettingsQuery({
 *   variables: {
 *      clinicSettingId: // value for 'clinicSettingId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAppointmentSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentSettingsQuery, GetAppointmentSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentSettingsQuery, GetAppointmentSettingsQueryVariables>(GetAppointmentSettingsDocument, options);
      }
export function useGetAppointmentSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentSettingsQuery, GetAppointmentSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentSettingsQuery, GetAppointmentSettingsQueryVariables>(GetAppointmentSettingsDocument, options);
        }
export type GetAppointmentSettingsQueryHookResult = ReturnType<typeof useGetAppointmentSettingsQuery>;
export type GetAppointmentSettingsLazyQueryHookResult = ReturnType<typeof useGetAppointmentSettingsLazyQuery>;
export type GetAppointmentSettingsQueryResult = Apollo.QueryResult<GetAppointmentSettingsQuery, GetAppointmentSettingsQueryVariables>;
export function refetchGetAppointmentSettingsQuery(variables?: GetAppointmentSettingsQueryVariables) {
      return { query: GetAppointmentSettingsDocument, variables: variables }
    }
export const GetProviderAppointmentTypeRoomMapDocument = gql`
    query getProviderAppointmentTypeRoomMap($clinicId: String!) {
  findManyProviderAppointmentTypeRoomMap(
    where: {appointmentType: {clinicId: {equals: $clinicId}}}
  ) {
    id
    clinicEmployeeId
    appoinmentTypeId
    roomId
  }
}
    `;

/**
 * __useGetProviderAppointmentTypeRoomMapQuery__
 *
 * To run a query within a React component, call `useGetProviderAppointmentTypeRoomMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderAppointmentTypeRoomMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderAppointmentTypeRoomMapQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetProviderAppointmentTypeRoomMapQuery(baseOptions: Apollo.QueryHookOptions<GetProviderAppointmentTypeRoomMapQuery, GetProviderAppointmentTypeRoomMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderAppointmentTypeRoomMapQuery, GetProviderAppointmentTypeRoomMapQueryVariables>(GetProviderAppointmentTypeRoomMapDocument, options);
      }
export function useGetProviderAppointmentTypeRoomMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderAppointmentTypeRoomMapQuery, GetProviderAppointmentTypeRoomMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderAppointmentTypeRoomMapQuery, GetProviderAppointmentTypeRoomMapQueryVariables>(GetProviderAppointmentTypeRoomMapDocument, options);
        }
export type GetProviderAppointmentTypeRoomMapQueryHookResult = ReturnType<typeof useGetProviderAppointmentTypeRoomMapQuery>;
export type GetProviderAppointmentTypeRoomMapLazyQueryHookResult = ReturnType<typeof useGetProviderAppointmentTypeRoomMapLazyQuery>;
export type GetProviderAppointmentTypeRoomMapQueryResult = Apollo.QueryResult<GetProviderAppointmentTypeRoomMapQuery, GetProviderAppointmentTypeRoomMapQueryVariables>;
export function refetchGetProviderAppointmentTypeRoomMapQuery(variables?: GetProviderAppointmentTypeRoomMapQueryVariables) {
      return { query: GetProviderAppointmentTypeRoomMapDocument, variables: variables }
    }
export const CreateClinicSettingsConversationsChannelStatusDocument = gql`
    mutation createClinicSettingsConversationsChannelStatus($clinicSettingId: String!, $channelStatusAction: ChannelStatusAction!, $color: String!, $name: String!, $order: Int) {
  createOneChannelStatus(
    data: {channelStatusAction: $channelStatusAction, clinicSetting: {connect: {id: $clinicSettingId}}, color: $color, name: $name, order: $order}
  ) {
    ...ClinicSettingsConversationsChannelStatus
  }
}
    ${ClinicSettingsConversationsChannelStatusFragmentDoc}`;
export type CreateClinicSettingsConversationsChannelStatusMutationFn = Apollo.MutationFunction<CreateClinicSettingsConversationsChannelStatusMutation, CreateClinicSettingsConversationsChannelStatusMutationVariables>;

/**
 * __useCreateClinicSettingsConversationsChannelStatusMutation__
 *
 * To run a mutation, you first call `useCreateClinicSettingsConversationsChannelStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicSettingsConversationsChannelStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicSettingsConversationsChannelStatusMutation, { data, loading, error }] = useCreateClinicSettingsConversationsChannelStatusMutation({
 *   variables: {
 *      clinicSettingId: // value for 'clinicSettingId'
 *      channelStatusAction: // value for 'channelStatusAction'
 *      color: // value for 'color'
 *      name: // value for 'name'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCreateClinicSettingsConversationsChannelStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicSettingsConversationsChannelStatusMutation, CreateClinicSettingsConversationsChannelStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicSettingsConversationsChannelStatusMutation, CreateClinicSettingsConversationsChannelStatusMutationVariables>(CreateClinicSettingsConversationsChannelStatusDocument, options);
      }
export type CreateClinicSettingsConversationsChannelStatusMutationHookResult = ReturnType<typeof useCreateClinicSettingsConversationsChannelStatusMutation>;
export type CreateClinicSettingsConversationsChannelStatusMutationResult = Apollo.MutationResult<CreateClinicSettingsConversationsChannelStatusMutation>;
export type CreateClinicSettingsConversationsChannelStatusMutationOptions = Apollo.BaseMutationOptions<CreateClinicSettingsConversationsChannelStatusMutation, CreateClinicSettingsConversationsChannelStatusMutationVariables>;
export const CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleDocument = gql`
    mutation createClinicSettingsConversationsChannelStatusAutoUpdateRule($data: RulesCreateInput!) {
  createOneRules(data: $data) {
    ...ClinicSettingsConversationsRule
  }
}
    ${ClinicSettingsConversationsRuleFragmentDoc}`;
export type CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationFn = Apollo.MutationFunction<CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables>;

/**
 * __useCreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation__
 *
 * To run a mutation, you first call `useCreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, { data, loading, error }] = useCreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables>(CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleDocument, options);
      }
export type CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationHookResult = ReturnType<typeof useCreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation>;
export type CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationResult = Apollo.MutationResult<CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation>;
export type CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationOptions = Apollo.BaseMutationOptions<CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, CreateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables>;
export const CreateClinicSettingsConversationsChannelStatusChannelAssigneeDocument = gql`
    mutation createClinicSettingsConversationsChannelStatusChannelAssignee($data: ChannelStatusChannelAssigneeCreateInput!) {
  createOneChannelStatusChannelAssignee(data: $data) {
    ...ClinicSettingsConversationsChannelStatusChannelAssignee
  }
}
    ${ClinicSettingsConversationsChannelStatusChannelAssigneeFragmentDoc}`;
export type CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutationFn = Apollo.MutationFunction<CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutation, CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutationVariables>;

/**
 * __useCreateClinicSettingsConversationsChannelStatusChannelAssigneeMutation__
 *
 * To run a mutation, you first call `useCreateClinicSettingsConversationsChannelStatusChannelAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicSettingsConversationsChannelStatusChannelAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicSettingsConversationsChannelStatusChannelAssigneeMutation, { data, loading, error }] = useCreateClinicSettingsConversationsChannelStatusChannelAssigneeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicSettingsConversationsChannelStatusChannelAssigneeMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutation, CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutation, CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutationVariables>(CreateClinicSettingsConversationsChannelStatusChannelAssigneeDocument, options);
      }
export type CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutationHookResult = ReturnType<typeof useCreateClinicSettingsConversationsChannelStatusChannelAssigneeMutation>;
export type CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutationResult = Apollo.MutationResult<CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutation>;
export type CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutationOptions = Apollo.BaseMutationOptions<CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutation, CreateClinicSettingsConversationsChannelStatusChannelAssigneeMutationVariables>;
export const DeleteClinicSettingsConversationsChannelStatusDocument = gql`
    mutation deleteClinicSettingsConversationsChannelStatus($data: ChannelStatusUpdateInput!, $channelStatusId: String!) {
  updateOneChannelStatus(data: $data, where: {id: $channelStatusId}) {
    id
  }
}
    `;
export type DeleteClinicSettingsConversationsChannelStatusMutationFn = Apollo.MutationFunction<DeleteClinicSettingsConversationsChannelStatusMutation, DeleteClinicSettingsConversationsChannelStatusMutationVariables>;

/**
 * __useDeleteClinicSettingsConversationsChannelStatusMutation__
 *
 * To run a mutation, you first call `useDeleteClinicSettingsConversationsChannelStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicSettingsConversationsChannelStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicSettingsConversationsChannelStatusMutation, { data, loading, error }] = useDeleteClinicSettingsConversationsChannelStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *      channelStatusId: // value for 'channelStatusId'
 *   },
 * });
 */
export function useDeleteClinicSettingsConversationsChannelStatusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicSettingsConversationsChannelStatusMutation, DeleteClinicSettingsConversationsChannelStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicSettingsConversationsChannelStatusMutation, DeleteClinicSettingsConversationsChannelStatusMutationVariables>(DeleteClinicSettingsConversationsChannelStatusDocument, options);
      }
export type DeleteClinicSettingsConversationsChannelStatusMutationHookResult = ReturnType<typeof useDeleteClinicSettingsConversationsChannelStatusMutation>;
export type DeleteClinicSettingsConversationsChannelStatusMutationResult = Apollo.MutationResult<DeleteClinicSettingsConversationsChannelStatusMutation>;
export type DeleteClinicSettingsConversationsChannelStatusMutationOptions = Apollo.BaseMutationOptions<DeleteClinicSettingsConversationsChannelStatusMutation, DeleteClinicSettingsConversationsChannelStatusMutationVariables>;
export const DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleDocument = gql`
    mutation deleteClinicSettingsConversationsChannelStatusAutoUpdateRule($ruleId: String!) {
  deleteOneRules(where: {id: $ruleId}) {
    id
  }
}
    `;
export type DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationFn = Apollo.MutationFunction<DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables>;

/**
 * __useDeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation__
 *
 * To run a mutation, you first call `useDeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, { data, loading, error }] = useDeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useDeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables>(DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleDocument, options);
      }
export type DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationHookResult = ReturnType<typeof useDeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation>;
export type DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationResult = Apollo.MutationResult<DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation>;
export type DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationOptions = Apollo.BaseMutationOptions<DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, DeleteClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables>;
export const DeleteClinicSettingsConversationsChannelStatusChannelAssigneeDocument = gql`
    mutation deleteClinicSettingsConversationsChannelStatusChannelAssignee($id: String) {
  deleteOneChannelStatusChannelAssignee(where: {id: $id}) {
    id
    ...ClinicSettingsConversationsChannelStatusChannelAssignee
  }
}
    ${ClinicSettingsConversationsChannelStatusChannelAssigneeFragmentDoc}`;
export type DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutationFn = Apollo.MutationFunction<DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation, DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutationVariables>;

/**
 * __useDeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation__
 *
 * To run a mutation, you first call `useDeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation, { data, loading, error }] = useDeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation, DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation, DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutationVariables>(DeleteClinicSettingsConversationsChannelStatusChannelAssigneeDocument, options);
      }
export type DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutationHookResult = ReturnType<typeof useDeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation>;
export type DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutationResult = Apollo.MutationResult<DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation>;
export type DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutationOptions = Apollo.BaseMutationOptions<DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutation, DeleteClinicSettingsConversationsChannelStatusChannelAssigneeMutationVariables>;
export const OrderClinicSettingsConversationsChannelStatusDocument = gql`
    mutation orderClinicSettingsConversationsChannelStatus($data: ChannelStatusUpdateInput!, $channelStatusId: String!) {
  updateOneChannelStatus(data: $data, where: {id: $channelStatusId}) {
    id
    order
    name
  }
}
    `;
export type OrderClinicSettingsConversationsChannelStatusMutationFn = Apollo.MutationFunction<OrderClinicSettingsConversationsChannelStatusMutation, OrderClinicSettingsConversationsChannelStatusMutationVariables>;

/**
 * __useOrderClinicSettingsConversationsChannelStatusMutation__
 *
 * To run a mutation, you first call `useOrderClinicSettingsConversationsChannelStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderClinicSettingsConversationsChannelStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderClinicSettingsConversationsChannelStatusMutation, { data, loading, error }] = useOrderClinicSettingsConversationsChannelStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *      channelStatusId: // value for 'channelStatusId'
 *   },
 * });
 */
export function useOrderClinicSettingsConversationsChannelStatusMutation(baseOptions?: Apollo.MutationHookOptions<OrderClinicSettingsConversationsChannelStatusMutation, OrderClinicSettingsConversationsChannelStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderClinicSettingsConversationsChannelStatusMutation, OrderClinicSettingsConversationsChannelStatusMutationVariables>(OrderClinicSettingsConversationsChannelStatusDocument, options);
      }
export type OrderClinicSettingsConversationsChannelStatusMutationHookResult = ReturnType<typeof useOrderClinicSettingsConversationsChannelStatusMutation>;
export type OrderClinicSettingsConversationsChannelStatusMutationResult = Apollo.MutationResult<OrderClinicSettingsConversationsChannelStatusMutation>;
export type OrderClinicSettingsConversationsChannelStatusMutationOptions = Apollo.BaseMutationOptions<OrderClinicSettingsConversationsChannelStatusMutation, OrderClinicSettingsConversationsChannelStatusMutationVariables>;
export const UpdateClinicSettingsConversationsChannelStatusDocument = gql`
    mutation updateClinicSettingsConversationsChannelStatus($data: ChannelStatusUpdateInput!, $channelStatusId: String!) {
  updateOneChannelStatus(data: $data, where: {id: $channelStatusId}) {
    ...ClinicSettingsConversationsChannelStatus
  }
}
    ${ClinicSettingsConversationsChannelStatusFragmentDoc}`;
export type UpdateClinicSettingsConversationsChannelStatusMutationFn = Apollo.MutationFunction<UpdateClinicSettingsConversationsChannelStatusMutation, UpdateClinicSettingsConversationsChannelStatusMutationVariables>;

/**
 * __useUpdateClinicSettingsConversationsChannelStatusMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsConversationsChannelStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsConversationsChannelStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsConversationsChannelStatusMutation, { data, loading, error }] = useUpdateClinicSettingsConversationsChannelStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *      channelStatusId: // value for 'channelStatusId'
 *   },
 * });
 */
export function useUpdateClinicSettingsConversationsChannelStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsConversationsChannelStatusMutation, UpdateClinicSettingsConversationsChannelStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsConversationsChannelStatusMutation, UpdateClinicSettingsConversationsChannelStatusMutationVariables>(UpdateClinicSettingsConversationsChannelStatusDocument, options);
      }
export type UpdateClinicSettingsConversationsChannelStatusMutationHookResult = ReturnType<typeof useUpdateClinicSettingsConversationsChannelStatusMutation>;
export type UpdateClinicSettingsConversationsChannelStatusMutationResult = Apollo.MutationResult<UpdateClinicSettingsConversationsChannelStatusMutation>;
export type UpdateClinicSettingsConversationsChannelStatusMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsConversationsChannelStatusMutation, UpdateClinicSettingsConversationsChannelStatusMutationVariables>;
export const UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleDocument = gql`
    mutation updateClinicSettingsConversationsChannelStatusAutoUpdateRule($data: RulesUpdateInput!, $ruleId: String!) {
  updateOneRules(data: $data, where: {id: $ruleId}) {
    ...ClinicSettingsConversationsRule
  }
}
    ${ClinicSettingsConversationsRuleFragmentDoc}`;
export type UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationFn = Apollo.MutationFunction<UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables>;

/**
 * __useUpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, { data, loading, error }] = useUpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation({
 *   variables: {
 *      data: // value for 'data'
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useUpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables>(UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleDocument, options);
      }
export type UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationHookResult = ReturnType<typeof useUpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation>;
export type UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationResult = Apollo.MutationResult<UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation>;
export type UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutation, UpdateClinicSettingsConversationsChannelStatusAutoUpdateRuleMutationVariables>;
export const UpdateClinicSettingsConversationsChannelStatusSortOrderDocument = gql`
    mutation updateClinicSettingsConversationsChannelStatusSortOrder($data: [ChannelStatusWithOrder!]) {
  updateManyChannelStatusSortOrder(data: $data) {
    success
    error
  }
}
    `;
export type UpdateClinicSettingsConversationsChannelStatusSortOrderMutationFn = Apollo.MutationFunction<UpdateClinicSettingsConversationsChannelStatusSortOrderMutation, UpdateClinicSettingsConversationsChannelStatusSortOrderMutationVariables>;

/**
 * __useUpdateClinicSettingsConversationsChannelStatusSortOrderMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsConversationsChannelStatusSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsConversationsChannelStatusSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsConversationsChannelStatusSortOrderMutation, { data, loading, error }] = useUpdateClinicSettingsConversationsChannelStatusSortOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicSettingsConversationsChannelStatusSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsConversationsChannelStatusSortOrderMutation, UpdateClinicSettingsConversationsChannelStatusSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsConversationsChannelStatusSortOrderMutation, UpdateClinicSettingsConversationsChannelStatusSortOrderMutationVariables>(UpdateClinicSettingsConversationsChannelStatusSortOrderDocument, options);
      }
export type UpdateClinicSettingsConversationsChannelStatusSortOrderMutationHookResult = ReturnType<typeof useUpdateClinicSettingsConversationsChannelStatusSortOrderMutation>;
export type UpdateClinicSettingsConversationsChannelStatusSortOrderMutationResult = Apollo.MutationResult<UpdateClinicSettingsConversationsChannelStatusSortOrderMutation>;
export type UpdateClinicSettingsConversationsChannelStatusSortOrderMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsConversationsChannelStatusSortOrderMutation, UpdateClinicSettingsConversationsChannelStatusSortOrderMutationVariables>;
export const GetClinicSettingsClinicSettingIdDocument = gql`
    query getClinicSettingsClinicSettingId($where: ClinicWhereUniqueInput!) {
  findUniqueClinic(where: $where) {
    clinicSetting {
      id
    }
  }
}
    `;

/**
 * __useGetClinicSettingsClinicSettingIdQuery__
 *
 * To run a query within a React component, call `useGetClinicSettingsClinicSettingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSettingsClinicSettingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSettingsClinicSettingIdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicSettingsClinicSettingIdQuery(baseOptions: Apollo.QueryHookOptions<GetClinicSettingsClinicSettingIdQuery, GetClinicSettingsClinicSettingIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSettingsClinicSettingIdQuery, GetClinicSettingsClinicSettingIdQueryVariables>(GetClinicSettingsClinicSettingIdDocument, options);
      }
export function useGetClinicSettingsClinicSettingIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSettingsClinicSettingIdQuery, GetClinicSettingsClinicSettingIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSettingsClinicSettingIdQuery, GetClinicSettingsClinicSettingIdQueryVariables>(GetClinicSettingsClinicSettingIdDocument, options);
        }
export type GetClinicSettingsClinicSettingIdQueryHookResult = ReturnType<typeof useGetClinicSettingsClinicSettingIdQuery>;
export type GetClinicSettingsClinicSettingIdLazyQueryHookResult = ReturnType<typeof useGetClinicSettingsClinicSettingIdLazyQuery>;
export type GetClinicSettingsClinicSettingIdQueryResult = Apollo.QueryResult<GetClinicSettingsClinicSettingIdQuery, GetClinicSettingsClinicSettingIdQueryVariables>;
export function refetchGetClinicSettingsClinicSettingIdQuery(variables?: GetClinicSettingsClinicSettingIdQueryVariables) {
      return { query: GetClinicSettingsClinicSettingIdDocument, variables: variables }
    }
export const GetClinicSettingsConversationsChannelStatusAutoUpdateRulesDocument = gql`
    query getClinicSettingsConversationsChannelStatusAutoUpdateRules($clinicId: String!) {
  findManyRules(
    where: {clinicId: {equals: $clinicId}, action: {equals: UpdateInactiveChannelStatus}}
    orderBy: {updatedAt: asc}
  ) {
    ...ClinicSettingsConversationsRule
  }
}
    ${ClinicSettingsConversationsRuleFragmentDoc}`;

/**
 * __useGetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery__
 *
 * To run a query within a React component, call `useGetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery(baseOptions: Apollo.QueryHookOptions<GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery, GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery, GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQueryVariables>(GetClinicSettingsConversationsChannelStatusAutoUpdateRulesDocument, options);
      }
export function useGetClinicSettingsConversationsChannelStatusAutoUpdateRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery, GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery, GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQueryVariables>(GetClinicSettingsConversationsChannelStatusAutoUpdateRulesDocument, options);
        }
export type GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQueryHookResult = ReturnType<typeof useGetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery>;
export type GetClinicSettingsConversationsChannelStatusAutoUpdateRulesLazyQueryHookResult = ReturnType<typeof useGetClinicSettingsConversationsChannelStatusAutoUpdateRulesLazyQuery>;
export type GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQueryResult = Apollo.QueryResult<GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery, GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQueryVariables>;
export function refetchGetClinicSettingsConversationsChannelStatusAutoUpdateRulesQuery(variables?: GetClinicSettingsConversationsChannelStatusAutoUpdateRulesQueryVariables) {
      return { query: GetClinicSettingsConversationsChannelStatusAutoUpdateRulesDocument, variables: variables }
    }
export const GetClinicSettingsConversationsChannelStatusesDocument = gql`
    query getClinicSettingsConversationsChannelStatuses($clinicId: String!) {
  findManyChannelStatus(
    where: {clinicSetting: {clinic: {id: {equals: $clinicId}}}, deletedOn: {equals: null}}
    orderBy: {order: asc}
  ) {
    ...ClinicSettingsConversationsChannelStatus
  }
}
    ${ClinicSettingsConversationsChannelStatusFragmentDoc}`;

/**
 * __useGetClinicSettingsConversationsChannelStatusesQuery__
 *
 * To run a query within a React component, call `useGetClinicSettingsConversationsChannelStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSettingsConversationsChannelStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSettingsConversationsChannelStatusesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicSettingsConversationsChannelStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetClinicSettingsConversationsChannelStatusesQuery, GetClinicSettingsConversationsChannelStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSettingsConversationsChannelStatusesQuery, GetClinicSettingsConversationsChannelStatusesQueryVariables>(GetClinicSettingsConversationsChannelStatusesDocument, options);
      }
export function useGetClinicSettingsConversationsChannelStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSettingsConversationsChannelStatusesQuery, GetClinicSettingsConversationsChannelStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSettingsConversationsChannelStatusesQuery, GetClinicSettingsConversationsChannelStatusesQueryVariables>(GetClinicSettingsConversationsChannelStatusesDocument, options);
        }
export type GetClinicSettingsConversationsChannelStatusesQueryHookResult = ReturnType<typeof useGetClinicSettingsConversationsChannelStatusesQuery>;
export type GetClinicSettingsConversationsChannelStatusesLazyQueryHookResult = ReturnType<typeof useGetClinicSettingsConversationsChannelStatusesLazyQuery>;
export type GetClinicSettingsConversationsChannelStatusesQueryResult = Apollo.QueryResult<GetClinicSettingsConversationsChannelStatusesQuery, GetClinicSettingsConversationsChannelStatusesQueryVariables>;
export function refetchGetClinicSettingsConversationsChannelStatusesQuery(variables?: GetClinicSettingsConversationsChannelStatusesQueryVariables) {
      return { query: GetClinicSettingsConversationsChannelStatusesDocument, variables: variables }
    }
export const GetClinicSettingsConversationsChannelsWithStatusesDocument = gql`
    query getClinicSettingsConversationsChannelsWithStatuses($where: ChannelWhereInput) {
  findManyChannel(where: $where) {
    id
    lastMessage {
      createdAt
    }
    updatedAt
  }
}
    `;

/**
 * __useGetClinicSettingsConversationsChannelsWithStatusesQuery__
 *
 * To run a query within a React component, call `useGetClinicSettingsConversationsChannelsWithStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSettingsConversationsChannelsWithStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSettingsConversationsChannelsWithStatusesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicSettingsConversationsChannelsWithStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicSettingsConversationsChannelsWithStatusesQuery, GetClinicSettingsConversationsChannelsWithStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSettingsConversationsChannelsWithStatusesQuery, GetClinicSettingsConversationsChannelsWithStatusesQueryVariables>(GetClinicSettingsConversationsChannelsWithStatusesDocument, options);
      }
export function useGetClinicSettingsConversationsChannelsWithStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSettingsConversationsChannelsWithStatusesQuery, GetClinicSettingsConversationsChannelsWithStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSettingsConversationsChannelsWithStatusesQuery, GetClinicSettingsConversationsChannelsWithStatusesQueryVariables>(GetClinicSettingsConversationsChannelsWithStatusesDocument, options);
        }
export type GetClinicSettingsConversationsChannelsWithStatusesQueryHookResult = ReturnType<typeof useGetClinicSettingsConversationsChannelsWithStatusesQuery>;
export type GetClinicSettingsConversationsChannelsWithStatusesLazyQueryHookResult = ReturnType<typeof useGetClinicSettingsConversationsChannelsWithStatusesLazyQuery>;
export type GetClinicSettingsConversationsChannelsWithStatusesQueryResult = Apollo.QueryResult<GetClinicSettingsConversationsChannelsWithStatusesQuery, GetClinicSettingsConversationsChannelsWithStatusesQueryVariables>;
export function refetchGetClinicSettingsConversationsChannelsWithStatusesQuery(variables?: GetClinicSettingsConversationsChannelsWithStatusesQueryVariables) {
      return { query: GetClinicSettingsConversationsChannelsWithStatusesDocument, variables: variables }
    }
export const GetAutomationOverviewDocument = gql`
    query getAutomationOverview($clinicId: String) {
  findManyWorkflowEventSetting(
    where: {clinicId: {equals: $clinicId}, deletedAt: null}
    orderBy: {name: asc}
  ) {
    id
    name
    isPublished
    event
    visitType
    automatedTriggerType
    automatedTriggerInMinutes
    appointmentTypes {
      id
      name
    }
    clinicEmployees {
      clinicEmployee {
        id
        firstName
        lastName
      }
    }
    clinicRooms {
      clinicRoom {
        id
        name
      }
    }
    conditionSets {
      conditions {
        id
        attribute
        operand
      }
    }
    automatedTriggerInMinutes
    sendingHours
    notificationBody
    actions {
      id
      order
      promptType
      config
      channelStatusChange {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAutomationOverviewQuery__
 *
 * To run a query within a React component, call `useGetAutomationOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationOverviewQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAutomationOverviewQuery(baseOptions?: Apollo.QueryHookOptions<GetAutomationOverviewQuery, GetAutomationOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationOverviewQuery, GetAutomationOverviewQueryVariables>(GetAutomationOverviewDocument, options);
      }
export function useGetAutomationOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationOverviewQuery, GetAutomationOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationOverviewQuery, GetAutomationOverviewQueryVariables>(GetAutomationOverviewDocument, options);
        }
export type GetAutomationOverviewQueryHookResult = ReturnType<typeof useGetAutomationOverviewQuery>;
export type GetAutomationOverviewLazyQueryHookResult = ReturnType<typeof useGetAutomationOverviewLazyQuery>;
export type GetAutomationOverviewQueryResult = Apollo.QueryResult<GetAutomationOverviewQuery, GetAutomationOverviewQueryVariables>;
export function refetchGetAutomationOverviewQuery(variables?: GetAutomationOverviewQueryVariables) {
      return { query: GetAutomationOverviewDocument, variables: variables }
    }
export const FindAutomationsForVisualizerDocument = gql`
    query findAutomationsForVisualizer($where: WorkflowEventSettingWhereInput) {
  findManyWorkflowEventSetting(where: $where, orderBy: {name: asc}) {
    ...VisualizerAutomation
  }
}
    ${VisualizerAutomationFragmentDoc}`;

/**
 * __useFindAutomationsForVisualizerQuery__
 *
 * To run a query within a React component, call `useFindAutomationsForVisualizerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAutomationsForVisualizerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAutomationsForVisualizerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindAutomationsForVisualizerQuery(baseOptions?: Apollo.QueryHookOptions<FindAutomationsForVisualizerQuery, FindAutomationsForVisualizerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAutomationsForVisualizerQuery, FindAutomationsForVisualizerQueryVariables>(FindAutomationsForVisualizerDocument, options);
      }
export function useFindAutomationsForVisualizerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAutomationsForVisualizerQuery, FindAutomationsForVisualizerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAutomationsForVisualizerQuery, FindAutomationsForVisualizerQueryVariables>(FindAutomationsForVisualizerDocument, options);
        }
export type FindAutomationsForVisualizerQueryHookResult = ReturnType<typeof useFindAutomationsForVisualizerQuery>;
export type FindAutomationsForVisualizerLazyQueryHookResult = ReturnType<typeof useFindAutomationsForVisualizerLazyQuery>;
export type FindAutomationsForVisualizerQueryResult = Apollo.QueryResult<FindAutomationsForVisualizerQuery, FindAutomationsForVisualizerQueryVariables>;
export function refetchFindAutomationsForVisualizerQuery(variables?: FindAutomationsForVisualizerQueryVariables) {
      return { query: FindAutomationsForVisualizerDocument, variables: variables }
    }
export const FindFormTemplatesForVisualizerDocument = gql`
    query findFormTemplatesForVisualizer($where: FormTemplateWhereInput) {
  findManyFormTemplate(where: $where) {
    id
    title
  }
}
    `;

/**
 * __useFindFormTemplatesForVisualizerQuery__
 *
 * To run a query within a React component, call `useFindFormTemplatesForVisualizerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFormTemplatesForVisualizerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFormTemplatesForVisualizerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFormTemplatesForVisualizerQuery(baseOptions?: Apollo.QueryHookOptions<FindFormTemplatesForVisualizerQuery, FindFormTemplatesForVisualizerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFormTemplatesForVisualizerQuery, FindFormTemplatesForVisualizerQueryVariables>(FindFormTemplatesForVisualizerDocument, options);
      }
export function useFindFormTemplatesForVisualizerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFormTemplatesForVisualizerQuery, FindFormTemplatesForVisualizerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFormTemplatesForVisualizerQuery, FindFormTemplatesForVisualizerQueryVariables>(FindFormTemplatesForVisualizerDocument, options);
        }
export type FindFormTemplatesForVisualizerQueryHookResult = ReturnType<typeof useFindFormTemplatesForVisualizerQuery>;
export type FindFormTemplatesForVisualizerLazyQueryHookResult = ReturnType<typeof useFindFormTemplatesForVisualizerLazyQuery>;
export type FindFormTemplatesForVisualizerQueryResult = Apollo.QueryResult<FindFormTemplatesForVisualizerQuery, FindFormTemplatesForVisualizerQueryVariables>;
export function refetchFindFormTemplatesForVisualizerQuery(variables?: FindFormTemplatesForVisualizerQueryVariables) {
      return { query: FindFormTemplatesForVisualizerDocument, variables: variables }
    }
export const FindChannelStatusForVisualizerDocument = gql`
    query findChannelStatusForVisualizer($where: ChannelStatusWhereInput) {
  findManyChannelStatus(where: $where) {
    id
    name
  }
}
    `;

/**
 * __useFindChannelStatusForVisualizerQuery__
 *
 * To run a query within a React component, call `useFindChannelStatusForVisualizerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindChannelStatusForVisualizerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindChannelStatusForVisualizerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindChannelStatusForVisualizerQuery(baseOptions?: Apollo.QueryHookOptions<FindChannelStatusForVisualizerQuery, FindChannelStatusForVisualizerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindChannelStatusForVisualizerQuery, FindChannelStatusForVisualizerQueryVariables>(FindChannelStatusForVisualizerDocument, options);
      }
export function useFindChannelStatusForVisualizerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindChannelStatusForVisualizerQuery, FindChannelStatusForVisualizerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindChannelStatusForVisualizerQuery, FindChannelStatusForVisualizerQueryVariables>(FindChannelStatusForVisualizerDocument, options);
        }
export type FindChannelStatusForVisualizerQueryHookResult = ReturnType<typeof useFindChannelStatusForVisualizerQuery>;
export type FindChannelStatusForVisualizerLazyQueryHookResult = ReturnType<typeof useFindChannelStatusForVisualizerLazyQuery>;
export type FindChannelStatusForVisualizerQueryResult = Apollo.QueryResult<FindChannelStatusForVisualizerQuery, FindChannelStatusForVisualizerQueryVariables>;
export function refetchFindChannelStatusForVisualizerQuery(variables?: FindChannelStatusForVisualizerQueryVariables) {
      return { query: FindChannelStatusForVisualizerDocument, variables: variables }
    }
export const VerifyTwilioSubAccountCallerIdDocument = gql`
    mutation verifyTwilioSubAccountCallerId($data: TwilioVerifySubAccountCallerIdInput!) {
  twilioVerifySubAccountCallerId(data: $data) {
    callSid
    validationCode
  }
}
    `;
export type VerifyTwilioSubAccountCallerIdMutationFn = Apollo.MutationFunction<VerifyTwilioSubAccountCallerIdMutation, VerifyTwilioSubAccountCallerIdMutationVariables>;

/**
 * __useVerifyTwilioSubAccountCallerIdMutation__
 *
 * To run a mutation, you first call `useVerifyTwilioSubAccountCallerIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTwilioSubAccountCallerIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTwilioSubAccountCallerIdMutation, { data, loading, error }] = useVerifyTwilioSubAccountCallerIdMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useVerifyTwilioSubAccountCallerIdMutation(baseOptions?: Apollo.MutationHookOptions<VerifyTwilioSubAccountCallerIdMutation, VerifyTwilioSubAccountCallerIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyTwilioSubAccountCallerIdMutation, VerifyTwilioSubAccountCallerIdMutationVariables>(VerifyTwilioSubAccountCallerIdDocument, options);
      }
export type VerifyTwilioSubAccountCallerIdMutationHookResult = ReturnType<typeof useVerifyTwilioSubAccountCallerIdMutation>;
export type VerifyTwilioSubAccountCallerIdMutationResult = Apollo.MutationResult<VerifyTwilioSubAccountCallerIdMutation>;
export type VerifyTwilioSubAccountCallerIdMutationOptions = Apollo.BaseMutationOptions<VerifyTwilioSubAccountCallerIdMutation, VerifyTwilioSubAccountCallerIdMutationVariables>;
export const CreateEmergencyClinicDocument = gql`
    mutation createEmergencyClinic($data: EmergencyClinicsCreateInput!) {
  createOneEmergencyClinics(data: $data) {
    ...EmergencyClinics
  }
}
    ${EmergencyClinicsFragmentDoc}`;
export type CreateEmergencyClinicMutationFn = Apollo.MutationFunction<CreateEmergencyClinicMutation, CreateEmergencyClinicMutationVariables>;

/**
 * __useCreateEmergencyClinicMutation__
 *
 * To run a mutation, you first call `useCreateEmergencyClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmergencyClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmergencyClinicMutation, { data, loading, error }] = useCreateEmergencyClinicMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEmergencyClinicMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmergencyClinicMutation, CreateEmergencyClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmergencyClinicMutation, CreateEmergencyClinicMutationVariables>(CreateEmergencyClinicDocument, options);
      }
export type CreateEmergencyClinicMutationHookResult = ReturnType<typeof useCreateEmergencyClinicMutation>;
export type CreateEmergencyClinicMutationResult = Apollo.MutationResult<CreateEmergencyClinicMutation>;
export type CreateEmergencyClinicMutationOptions = Apollo.BaseMutationOptions<CreateEmergencyClinicMutation, CreateEmergencyClinicMutationVariables>;
export const SoftDeleteEmergencyClinicDocument = gql`
    mutation softDeleteEmergencyClinic($where: EmergencyClinicsWhereUniqueInput!) {
  updateOneEmergencyClinics(where: $where, data: {isDeleted: true}) {
    id
  }
}
    `;
export type SoftDeleteEmergencyClinicMutationFn = Apollo.MutationFunction<SoftDeleteEmergencyClinicMutation, SoftDeleteEmergencyClinicMutationVariables>;

/**
 * __useSoftDeleteEmergencyClinicMutation__
 *
 * To run a mutation, you first call `useSoftDeleteEmergencyClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteEmergencyClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteEmergencyClinicMutation, { data, loading, error }] = useSoftDeleteEmergencyClinicMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSoftDeleteEmergencyClinicMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteEmergencyClinicMutation, SoftDeleteEmergencyClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteEmergencyClinicMutation, SoftDeleteEmergencyClinicMutationVariables>(SoftDeleteEmergencyClinicDocument, options);
      }
export type SoftDeleteEmergencyClinicMutationHookResult = ReturnType<typeof useSoftDeleteEmergencyClinicMutation>;
export type SoftDeleteEmergencyClinicMutationResult = Apollo.MutationResult<SoftDeleteEmergencyClinicMutation>;
export type SoftDeleteEmergencyClinicMutationOptions = Apollo.BaseMutationOptions<SoftDeleteEmergencyClinicMutation, SoftDeleteEmergencyClinicMutationVariables>;
export const UpdateClinicSettingsClinicDocument = gql`
    mutation updateClinicSettingsClinic($data: ClinicUpdateInput!, $id: String!) {
  updateOneClinic(data: $data, where: {id: $id}) {
    id
    timezoneName
    name
    logo
    phone
    fullAddress
    websiteUrl
    addressLine1
    addressLine2
    postalCode
    country
    city
    state
  }
}
    `;
export type UpdateClinicSettingsClinicMutationFn = Apollo.MutationFunction<UpdateClinicSettingsClinicMutation, UpdateClinicSettingsClinicMutationVariables>;

/**
 * __useUpdateClinicSettingsClinicMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsClinicMutation, { data, loading, error }] = useUpdateClinicSettingsClinicMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateClinicSettingsClinicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsClinicMutation, UpdateClinicSettingsClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsClinicMutation, UpdateClinicSettingsClinicMutationVariables>(UpdateClinicSettingsClinicDocument, options);
      }
export type UpdateClinicSettingsClinicMutationHookResult = ReturnType<typeof useUpdateClinicSettingsClinicMutation>;
export type UpdateClinicSettingsClinicMutationResult = Apollo.MutationResult<UpdateClinicSettingsClinicMutation>;
export type UpdateClinicSettingsClinicMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsClinicMutation, UpdateClinicSettingsClinicMutationVariables>;
export const UpdateClinicSettingsOutOfOfficeInformationDocument = gql`
    mutation updateClinicSettingsOutOfOfficeInformation($data: ClinicSettingUpdateInput!, $id: String) {
  updateOneClinicSetting(data: $data, where: {id: $id}) {
    id
    outOfOfficeHeadline
    outOfOfficeEnabled
    outOfOfficeShowScheduleEnabled
    emergencyContactsEnabled
  }
}
    `;
export type UpdateClinicSettingsOutOfOfficeInformationMutationFn = Apollo.MutationFunction<UpdateClinicSettingsOutOfOfficeInformationMutation, UpdateClinicSettingsOutOfOfficeInformationMutationVariables>;

/**
 * __useUpdateClinicSettingsOutOfOfficeInformationMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsOutOfOfficeInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsOutOfOfficeInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsOutOfOfficeInformationMutation, { data, loading, error }] = useUpdateClinicSettingsOutOfOfficeInformationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateClinicSettingsOutOfOfficeInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsOutOfOfficeInformationMutation, UpdateClinicSettingsOutOfOfficeInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsOutOfOfficeInformationMutation, UpdateClinicSettingsOutOfOfficeInformationMutationVariables>(UpdateClinicSettingsOutOfOfficeInformationDocument, options);
      }
export type UpdateClinicSettingsOutOfOfficeInformationMutationHookResult = ReturnType<typeof useUpdateClinicSettingsOutOfOfficeInformationMutation>;
export type UpdateClinicSettingsOutOfOfficeInformationMutationResult = Apollo.MutationResult<UpdateClinicSettingsOutOfOfficeInformationMutation>;
export type UpdateClinicSettingsOutOfOfficeInformationMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsOutOfOfficeInformationMutation, UpdateClinicSettingsOutOfOfficeInformationMutationVariables>;
export const UpdateClinicSettingsGeneralVerifyTwilioCallerIdDocument = gql`
    mutation updateClinicSettingsGeneralVerifyTwilioCallerId($data: TwilioVerifyCallerIdInput!) {
  twilioVerifyCallerId(data: $data) {
    callSid
    validationCode
  }
}
    `;
export type UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutationFn = Apollo.MutationFunction<UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutation, UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutationVariables>;

/**
 * __useUpdateClinicSettingsGeneralVerifyTwilioCallerIdMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsGeneralVerifyTwilioCallerIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsGeneralVerifyTwilioCallerIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsGeneralVerifyTwilioCallerIdMutation, { data, loading, error }] = useUpdateClinicSettingsGeneralVerifyTwilioCallerIdMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicSettingsGeneralVerifyTwilioCallerIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutation, UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutation, UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutationVariables>(UpdateClinicSettingsGeneralVerifyTwilioCallerIdDocument, options);
      }
export type UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutationHookResult = ReturnType<typeof useUpdateClinicSettingsGeneralVerifyTwilioCallerIdMutation>;
export type UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutationResult = Apollo.MutationResult<UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutation>;
export type UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutation, UpdateClinicSettingsGeneralVerifyTwilioCallerIdMutationVariables>;
export const UpdateEmergencyClinicDocument = gql`
    mutation updateEmergencyClinic($where: EmergencyClinicsWhereUniqueInput!, $data: EmergencyClinicsUpdateInput!) {
  updateOneEmergencyClinics(where: $where, data: $data) {
    ...EmergencyClinics
  }
}
    ${EmergencyClinicsFragmentDoc}`;
export type UpdateEmergencyClinicMutationFn = Apollo.MutationFunction<UpdateEmergencyClinicMutation, UpdateEmergencyClinicMutationVariables>;

/**
 * __useUpdateEmergencyClinicMutation__
 *
 * To run a mutation, you first call `useUpdateEmergencyClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmergencyClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmergencyClinicMutation, { data, loading, error }] = useUpdateEmergencyClinicMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEmergencyClinicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmergencyClinicMutation, UpdateEmergencyClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmergencyClinicMutation, UpdateEmergencyClinicMutationVariables>(UpdateEmergencyClinicDocument, options);
      }
export type UpdateEmergencyClinicMutationHookResult = ReturnType<typeof useUpdateEmergencyClinicMutation>;
export type UpdateEmergencyClinicMutationResult = Apollo.MutationResult<UpdateEmergencyClinicMutation>;
export type UpdateEmergencyClinicMutationOptions = Apollo.BaseMutationOptions<UpdateEmergencyClinicMutation, UpdateEmergencyClinicMutationVariables>;
export const UpdateEmergencyClinicDisplayOrderDocument = gql`
    mutation updateEmergencyClinicDisplayOrder($where: EmergencyClinicsWhereUniqueInput!, $data: Int!) {
  updateOneEmergencyClinics(where: $where, data: {displayOrder: $data}) {
    id
  }
}
    `;
export type UpdateEmergencyClinicDisplayOrderMutationFn = Apollo.MutationFunction<UpdateEmergencyClinicDisplayOrderMutation, UpdateEmergencyClinicDisplayOrderMutationVariables>;

/**
 * __useUpdateEmergencyClinicDisplayOrderMutation__
 *
 * To run a mutation, you first call `useUpdateEmergencyClinicDisplayOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmergencyClinicDisplayOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmergencyClinicDisplayOrderMutation, { data, loading, error }] = useUpdateEmergencyClinicDisplayOrderMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEmergencyClinicDisplayOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmergencyClinicDisplayOrderMutation, UpdateEmergencyClinicDisplayOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmergencyClinicDisplayOrderMutation, UpdateEmergencyClinicDisplayOrderMutationVariables>(UpdateEmergencyClinicDisplayOrderDocument, options);
      }
export type UpdateEmergencyClinicDisplayOrderMutationHookResult = ReturnType<typeof useUpdateEmergencyClinicDisplayOrderMutation>;
export type UpdateEmergencyClinicDisplayOrderMutationResult = Apollo.MutationResult<UpdateEmergencyClinicDisplayOrderMutation>;
export type UpdateEmergencyClinicDisplayOrderMutationOptions = Apollo.BaseMutationOptions<UpdateEmergencyClinicDisplayOrderMutation, UpdateEmergencyClinicDisplayOrderMutationVariables>;
export const FindEmployerIdentificationNumberDocument = gql`
    query FindEmployerIdentificationNumber($data: FindEmployerIdentificationNumberInput!) {
  findEmployerIdentificationNumber(data: $data) {
    ein
    companyName
    address
    companyPhone
    url
    businessName
    error
  }
}
    `;

/**
 * __useFindEmployerIdentificationNumberQuery__
 *
 * To run a query within a React component, call `useFindEmployerIdentificationNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindEmployerIdentificationNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindEmployerIdentificationNumberQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFindEmployerIdentificationNumberQuery(baseOptions: Apollo.QueryHookOptions<FindEmployerIdentificationNumberQuery, FindEmployerIdentificationNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindEmployerIdentificationNumberQuery, FindEmployerIdentificationNumberQueryVariables>(FindEmployerIdentificationNumberDocument, options);
      }
export function useFindEmployerIdentificationNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindEmployerIdentificationNumberQuery, FindEmployerIdentificationNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindEmployerIdentificationNumberQuery, FindEmployerIdentificationNumberQueryVariables>(FindEmployerIdentificationNumberDocument, options);
        }
export type FindEmployerIdentificationNumberQueryHookResult = ReturnType<typeof useFindEmployerIdentificationNumberQuery>;
export type FindEmployerIdentificationNumberLazyQueryHookResult = ReturnType<typeof useFindEmployerIdentificationNumberLazyQuery>;
export type FindEmployerIdentificationNumberQueryResult = Apollo.QueryResult<FindEmployerIdentificationNumberQuery, FindEmployerIdentificationNumberQueryVariables>;
export function refetchFindEmployerIdentificationNumberQuery(variables?: FindEmployerIdentificationNumberQueryVariables) {
      return { query: FindEmployerIdentificationNumberDocument, variables: variables }
    }
export const GetClinicSettingsGeneralDocument = gql`
    query getClinicSettingsGeneral($id: String) {
  findUniqueClinic(where: {id: $id}) {
    id
    addressLine1
    addressLine2
    city
    clinicOfficeHours(orderBy: {dayOfWeek: asc}) {
      ...ClinicOfficeHourSelection
    }
    clinicSetting {
      id
      outOfOfficeEnabled
      outOfOfficeHeadline
      outOfOfficeShowScheduleEnabled
      emergencyContactsEnabled
      emergencyClinics {
        ...EmergencyClinics
      }
    }
    country
    fullAddress
    logo
    name
    phone
    clinicEmail
    postalCode
    state
    timezoneName
    websiteUrl
    isCallerIdVerified
    twilioVerifications {
      id
      phoneNumber
      status
    }
  }
}
    ${ClinicOfficeHourSelectionFragmentDoc}
${EmergencyClinicsFragmentDoc}`;

/**
 * __useGetClinicSettingsGeneralQuery__
 *
 * To run a query within a React component, call `useGetClinicSettingsGeneralQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSettingsGeneralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSettingsGeneralQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClinicSettingsGeneralQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicSettingsGeneralQuery, GetClinicSettingsGeneralQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSettingsGeneralQuery, GetClinicSettingsGeneralQueryVariables>(GetClinicSettingsGeneralDocument, options);
      }
export function useGetClinicSettingsGeneralLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSettingsGeneralQuery, GetClinicSettingsGeneralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSettingsGeneralQuery, GetClinicSettingsGeneralQueryVariables>(GetClinicSettingsGeneralDocument, options);
        }
export type GetClinicSettingsGeneralQueryHookResult = ReturnType<typeof useGetClinicSettingsGeneralQuery>;
export type GetClinicSettingsGeneralLazyQueryHookResult = ReturnType<typeof useGetClinicSettingsGeneralLazyQuery>;
export type GetClinicSettingsGeneralQueryResult = Apollo.QueryResult<GetClinicSettingsGeneralQuery, GetClinicSettingsGeneralQueryVariables>;
export function refetchGetClinicSettingsGeneralQuery(variables?: GetClinicSettingsGeneralQueryVariables) {
      return { query: GetClinicSettingsGeneralDocument, variables: variables }
    }
export const FindClinicLegalEntityDocument = gql`
    query findClinicLegalEntity($where: ClinicWhereUniqueInput!) {
  findUniqueClinic(where: $where) {
    legalEntity {
      ...LegalEntity
    }
  }
}
    ${LegalEntityFragmentDoc}`;

/**
 * __useFindClinicLegalEntityQuery__
 *
 * To run a query within a React component, call `useFindClinicLegalEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindClinicLegalEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindClinicLegalEntityQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindClinicLegalEntityQuery(baseOptions: Apollo.QueryHookOptions<FindClinicLegalEntityQuery, FindClinicLegalEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindClinicLegalEntityQuery, FindClinicLegalEntityQueryVariables>(FindClinicLegalEntityDocument, options);
      }
export function useFindClinicLegalEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindClinicLegalEntityQuery, FindClinicLegalEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindClinicLegalEntityQuery, FindClinicLegalEntityQueryVariables>(FindClinicLegalEntityDocument, options);
        }
export type FindClinicLegalEntityQueryHookResult = ReturnType<typeof useFindClinicLegalEntityQuery>;
export type FindClinicLegalEntityLazyQueryHookResult = ReturnType<typeof useFindClinicLegalEntityLazyQuery>;
export type FindClinicLegalEntityQueryResult = Apollo.QueryResult<FindClinicLegalEntityQuery, FindClinicLegalEntityQueryVariables>;
export function refetchFindClinicLegalEntityQuery(variables?: FindClinicLegalEntityQueryVariables) {
      return { query: FindClinicLegalEntityDocument, variables: variables }
    }
export const UpsertOneLegalEntityDocument = gql`
    mutation upsertOneLegalEntity($where: LegalEntityWhereUniqueInput!, $create: LegalEntityCreateInput!, $update: LegalEntityUpdateInput!) {
  upsertOneLegalEntity(where: $where, create: $create, update: $update) {
    ...LegalEntity
  }
}
    ${LegalEntityFragmentDoc}`;
export type UpsertOneLegalEntityMutationFn = Apollo.MutationFunction<UpsertOneLegalEntityMutation, UpsertOneLegalEntityMutationVariables>;

/**
 * __useUpsertOneLegalEntityMutation__
 *
 * To run a mutation, you first call `useUpsertOneLegalEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOneLegalEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOneLegalEntityMutation, { data, loading, error }] = useUpsertOneLegalEntityMutation({
 *   variables: {
 *      where: // value for 'where'
 *      create: // value for 'create'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpsertOneLegalEntityMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOneLegalEntityMutation, UpsertOneLegalEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOneLegalEntityMutation, UpsertOneLegalEntityMutationVariables>(UpsertOneLegalEntityDocument, options);
      }
export type UpsertOneLegalEntityMutationHookResult = ReturnType<typeof useUpsertOneLegalEntityMutation>;
export type UpsertOneLegalEntityMutationResult = Apollo.MutationResult<UpsertOneLegalEntityMutation>;
export type UpsertOneLegalEntityMutationOptions = Apollo.BaseMutationOptions<UpsertOneLegalEntityMutation, UpsertOneLegalEntityMutationVariables>;
export const SubscribeToClinicSettingsGeneralTwilioVerificationDocument = gql`
    subscription subscribeToClinicSettingsGeneralTwilioVerification($where: SubscriptionTwilioVerificationWhereInput!) {
  twilioVerificationChanged(where: $where) {
    node {
      status
    }
  }
}
    `;

/**
 * __useSubscribeToClinicSettingsGeneralTwilioVerificationSubscription__
 *
 * To run a query within a React component, call `useSubscribeToClinicSettingsGeneralTwilioVerificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToClinicSettingsGeneralTwilioVerificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToClinicSettingsGeneralTwilioVerificationSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToClinicSettingsGeneralTwilioVerificationSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToClinicSettingsGeneralTwilioVerificationSubscription, SubscribeToClinicSettingsGeneralTwilioVerificationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToClinicSettingsGeneralTwilioVerificationSubscription, SubscribeToClinicSettingsGeneralTwilioVerificationSubscriptionVariables>(SubscribeToClinicSettingsGeneralTwilioVerificationDocument, options);
      }
export type SubscribeToClinicSettingsGeneralTwilioVerificationSubscriptionHookResult = ReturnType<typeof useSubscribeToClinicSettingsGeneralTwilioVerificationSubscription>;
export type SubscribeToClinicSettingsGeneralTwilioVerificationSubscriptionResult = Apollo.SubscriptionResult<SubscribeToClinicSettingsGeneralTwilioVerificationSubscription>;
export const UpdateClinicSettingsNotificationsUserSettingDocument = gql`
    mutation updateClinicSettingsNotificationsUserSetting($data: UserSettingUpdateInput!, $where: UserSettingWhereUniqueInput!) {
  updateOneUserSetting(data: $data, where: $where) {
    id
    browserNotificationFilter {
      id
      assignees {
        id
      }
      includeUnassigned
    }
    snoozeNotificationsUntil
    notificationSettings {
      id
      emailEnabled
      smsEnabled
      soundNotificationUrl
      browserNotificationEnabled
      pushNotificationEnabled
    }
  }
}
    `;
export type UpdateClinicSettingsNotificationsUserSettingMutationFn = Apollo.MutationFunction<UpdateClinicSettingsNotificationsUserSettingMutation, UpdateClinicSettingsNotificationsUserSettingMutationVariables>;

/**
 * __useUpdateClinicSettingsNotificationsUserSettingMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsNotificationsUserSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsNotificationsUserSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsNotificationsUserSettingMutation, { data, loading, error }] = useUpdateClinicSettingsNotificationsUserSettingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateClinicSettingsNotificationsUserSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsNotificationsUserSettingMutation, UpdateClinicSettingsNotificationsUserSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsNotificationsUserSettingMutation, UpdateClinicSettingsNotificationsUserSettingMutationVariables>(UpdateClinicSettingsNotificationsUserSettingDocument, options);
      }
export type UpdateClinicSettingsNotificationsUserSettingMutationHookResult = ReturnType<typeof useUpdateClinicSettingsNotificationsUserSettingMutation>;
export type UpdateClinicSettingsNotificationsUserSettingMutationResult = Apollo.MutationResult<UpdateClinicSettingsNotificationsUserSettingMutation>;
export type UpdateClinicSettingsNotificationsUserSettingMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsNotificationsUserSettingMutation, UpdateClinicSettingsNotificationsUserSettingMutationVariables>;
export const GetClinicSettingsNotificationsUserSettingsDocument = gql`
    query getClinicSettingsNotificationsUserSettings($where: UserWhereUniqueInput!) {
  findUniqueUser(where: $where) {
    id
    firebaseId
    firstName
    lastName
    profilePic
    email
    userSetting {
      id
      emailNotifications
      smsNotifications
      browserNotificationFilter {
        id
        assignees {
          id
        }
        includeUnassigned
      }
      snoozeNotificationsUntil
      notificationSettings {
        id
        settingType
        emailEnabled
        smsEnabled
        pushNotificationEnabled
        soundNotificationUrl
        browserNotificationEnabled
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetClinicSettingsNotificationsUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetClinicSettingsNotificationsUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSettingsNotificationsUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSettingsNotificationsUserSettingsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicSettingsNotificationsUserSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicSettingsNotificationsUserSettingsQuery, GetClinicSettingsNotificationsUserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSettingsNotificationsUserSettingsQuery, GetClinicSettingsNotificationsUserSettingsQueryVariables>(GetClinicSettingsNotificationsUserSettingsDocument, options);
      }
export function useGetClinicSettingsNotificationsUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSettingsNotificationsUserSettingsQuery, GetClinicSettingsNotificationsUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSettingsNotificationsUserSettingsQuery, GetClinicSettingsNotificationsUserSettingsQueryVariables>(GetClinicSettingsNotificationsUserSettingsDocument, options);
        }
export type GetClinicSettingsNotificationsUserSettingsQueryHookResult = ReturnType<typeof useGetClinicSettingsNotificationsUserSettingsQuery>;
export type GetClinicSettingsNotificationsUserSettingsLazyQueryHookResult = ReturnType<typeof useGetClinicSettingsNotificationsUserSettingsLazyQuery>;
export type GetClinicSettingsNotificationsUserSettingsQueryResult = Apollo.QueryResult<GetClinicSettingsNotificationsUserSettingsQuery, GetClinicSettingsNotificationsUserSettingsQueryVariables>;
export function refetchGetClinicSettingsNotificationsUserSettingsQuery(variables?: GetClinicSettingsNotificationsUserSettingsQueryVariables) {
      return { query: GetClinicSettingsNotificationsUserSettingsDocument, variables: variables }
    }
export const UpdateUserPreferencesDocument = gql`
    mutation updateUserPreferences($data: UserSettingUpdateInput!, $where: UserSettingWhereUniqueInput!) {
  updateOneUserSetting(data: $data, where: $where) {
    id
    enterAddsNewLine
    skipLoadingAnimation
  }
}
    `;
export type UpdateUserPreferencesMutationFn = Apollo.MutationFunction<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>;

/**
 * __useUpdateUserPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferencesMutation, { data, loading, error }] = useUpdateUserPreferencesMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateUserPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>(UpdateUserPreferencesDocument, options);
      }
export type UpdateUserPreferencesMutationHookResult = ReturnType<typeof useUpdateUserPreferencesMutation>;
export type UpdateUserPreferencesMutationResult = Apollo.MutationResult<UpdateUserPreferencesMutation>;
export type UpdateUserPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>;
export const UpdateChangePasswordModalUserDocument = gql`
    mutation updateChangePasswordModalUser($where: UserWhereUniqueInput!, $data: UserUpdateInput!) {
  updateOneUser(where: $where, data: $data) {
    id
    firstName
    lastName
    namePrefix
    nameSuffix
    email
    phone
    isNewPasswordRequired
  }
}
    `;
export type UpdateChangePasswordModalUserMutationFn = Apollo.MutationFunction<UpdateChangePasswordModalUserMutation, UpdateChangePasswordModalUserMutationVariables>;

/**
 * __useUpdateChangePasswordModalUserMutation__
 *
 * To run a mutation, you first call `useUpdateChangePasswordModalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChangePasswordModalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChangePasswordModalUserMutation, { data, loading, error }] = useUpdateChangePasswordModalUserMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChangePasswordModalUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChangePasswordModalUserMutation, UpdateChangePasswordModalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChangePasswordModalUserMutation, UpdateChangePasswordModalUserMutationVariables>(UpdateChangePasswordModalUserDocument, options);
      }
export type UpdateChangePasswordModalUserMutationHookResult = ReturnType<typeof useUpdateChangePasswordModalUserMutation>;
export type UpdateChangePasswordModalUserMutationResult = Apollo.MutationResult<UpdateChangePasswordModalUserMutation>;
export type UpdateChangePasswordModalUserMutationOptions = Apollo.BaseMutationOptions<UpdateChangePasswordModalUserMutation, UpdateChangePasswordModalUserMutationVariables>;
export const UpdateClinicSettingsUserDocument = gql`
    mutation updateClinicSettingsUser($where: UserWhereUniqueInput!, $data: UserUpdateInput!) {
  updateOneUser(where: $where, data: $data) {
    id
    firstName
    lastName
    email
    phone
    profilePic
  }
}
    `;
export type UpdateClinicSettingsUserMutationFn = Apollo.MutationFunction<UpdateClinicSettingsUserMutation, UpdateClinicSettingsUserMutationVariables>;

/**
 * __useUpdateClinicSettingsUserMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsUserMutation, { data, loading, error }] = useUpdateClinicSettingsUserMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicSettingsUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsUserMutation, UpdateClinicSettingsUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsUserMutation, UpdateClinicSettingsUserMutationVariables>(UpdateClinicSettingsUserDocument, options);
      }
export type UpdateClinicSettingsUserMutationHookResult = ReturnType<typeof useUpdateClinicSettingsUserMutation>;
export type UpdateClinicSettingsUserMutationResult = Apollo.MutationResult<UpdateClinicSettingsUserMutation>;
export type UpdateClinicSettingsUserMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsUserMutation, UpdateClinicSettingsUserMutationVariables>;
export const GetClinicSettingsUserDocument = gql`
    query getClinicSettingsUser($where: UserWhereUniqueInput!) {
  findUniqueUser(where: $where) {
    ...UserSettingsData
  }
}
    ${UserSettingsDataFragmentDoc}`;

/**
 * __useGetClinicSettingsUserQuery__
 *
 * To run a query within a React component, call `useGetClinicSettingsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSettingsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSettingsUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicSettingsUserQuery(baseOptions: Apollo.QueryHookOptions<GetClinicSettingsUserQuery, GetClinicSettingsUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSettingsUserQuery, GetClinicSettingsUserQueryVariables>(GetClinicSettingsUserDocument, options);
      }
export function useGetClinicSettingsUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSettingsUserQuery, GetClinicSettingsUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSettingsUserQuery, GetClinicSettingsUserQueryVariables>(GetClinicSettingsUserDocument, options);
        }
export type GetClinicSettingsUserQueryHookResult = ReturnType<typeof useGetClinicSettingsUserQuery>;
export type GetClinicSettingsUserLazyQueryHookResult = ReturnType<typeof useGetClinicSettingsUserLazyQuery>;
export type GetClinicSettingsUserQueryResult = Apollo.QueryResult<GetClinicSettingsUserQuery, GetClinicSettingsUserQueryVariables>;
export function refetchGetClinicSettingsUserQuery(variables?: GetClinicSettingsUserQueryVariables) {
      return { query: GetClinicSettingsUserDocument, variables: variables }
    }
export const EncryptAndUploadDataDocument = gql`
    mutation encryptAndUploadData($body: String!, $purpose: EncryptedSignedUploadPurpose!, $extension: String!) {
  encryptAndUploadData(body: $body, purpose: $purpose, extension: $extension) {
    success
  }
}
    `;
export type EncryptAndUploadDataMutationFn = Apollo.MutationFunction<EncryptAndUploadDataMutation, EncryptAndUploadDataMutationVariables>;

/**
 * __useEncryptAndUploadDataMutation__
 *
 * To run a mutation, you first call `useEncryptAndUploadDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEncryptAndUploadDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [encryptAndUploadDataMutation, { data, loading, error }] = useEncryptAndUploadDataMutation({
 *   variables: {
 *      body: // value for 'body'
 *      purpose: // value for 'purpose'
 *      extension: // value for 'extension'
 *   },
 * });
 */
export function useEncryptAndUploadDataMutation(baseOptions?: Apollo.MutationHookOptions<EncryptAndUploadDataMutation, EncryptAndUploadDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EncryptAndUploadDataMutation, EncryptAndUploadDataMutationVariables>(EncryptAndUploadDataDocument, options);
      }
export type EncryptAndUploadDataMutationHookResult = ReturnType<typeof useEncryptAndUploadDataMutation>;
export type EncryptAndUploadDataMutationResult = Apollo.MutationResult<EncryptAndUploadDataMutation>;
export type EncryptAndUploadDataMutationOptions = Apollo.BaseMutationOptions<EncryptAndUploadDataMutation, EncryptAndUploadDataMutationVariables>;
export const GenerateTerminalSetupPinDocument = gql`
    mutation generateTerminalSetupPin($clinicId: String!) {
  generateTerminalSetupPin(clinicId: $clinicId) {
    pin
  }
}
    `;
export type GenerateTerminalSetupPinMutationFn = Apollo.MutationFunction<GenerateTerminalSetupPinMutation, GenerateTerminalSetupPinMutationVariables>;

/**
 * __useGenerateTerminalSetupPinMutation__
 *
 * To run a mutation, you first call `useGenerateTerminalSetupPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTerminalSetupPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTerminalSetupPinMutation, { data, loading, error }] = useGenerateTerminalSetupPinMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGenerateTerminalSetupPinMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTerminalSetupPinMutation, GenerateTerminalSetupPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTerminalSetupPinMutation, GenerateTerminalSetupPinMutationVariables>(GenerateTerminalSetupPinDocument, options);
      }
export type GenerateTerminalSetupPinMutationHookResult = ReturnType<typeof useGenerateTerminalSetupPinMutation>;
export type GenerateTerminalSetupPinMutationResult = Apollo.MutationResult<GenerateTerminalSetupPinMutation>;
export type GenerateTerminalSetupPinMutationOptions = Apollo.BaseMutationOptions<GenerateTerminalSetupPinMutation, GenerateTerminalSetupPinMutationVariables>;
export const UpsertOneBitwerxPaymentWritebackConfigurationDocument = gql`
    mutation upsertOneBitwerxPaymentWritebackConfiguration($where: BitwerxPaymentWritebackConfigurationWhereUniqueInput!, $create: BitwerxPaymentWritebackConfigurationCreateInput!, $update: BitwerxPaymentWritebackConfigurationUpdateInput!) {
  upsertOneBitwerxPaymentWritebackConfiguration(
    where: $where
    create: $create
    update: $update
  ) {
    id
    integrationId
    enteredById
    defaultPimsPaymentTypeId
    visaPimsPaymentTypeId
    mastercardPimsPaymentTypeId
    amexPimsPaymentTypeId
    discoverPimsPaymentTypeId
    writebackManualPayment
  }
}
    `;
export type UpsertOneBitwerxPaymentWritebackConfigurationMutationFn = Apollo.MutationFunction<UpsertOneBitwerxPaymentWritebackConfigurationMutation, UpsertOneBitwerxPaymentWritebackConfigurationMutationVariables>;

/**
 * __useUpsertOneBitwerxPaymentWritebackConfigurationMutation__
 *
 * To run a mutation, you first call `useUpsertOneBitwerxPaymentWritebackConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOneBitwerxPaymentWritebackConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOneBitwerxPaymentWritebackConfigurationMutation, { data, loading, error }] = useUpsertOneBitwerxPaymentWritebackConfigurationMutation({
 *   variables: {
 *      where: // value for 'where'
 *      create: // value for 'create'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpsertOneBitwerxPaymentWritebackConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOneBitwerxPaymentWritebackConfigurationMutation, UpsertOneBitwerxPaymentWritebackConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOneBitwerxPaymentWritebackConfigurationMutation, UpsertOneBitwerxPaymentWritebackConfigurationMutationVariables>(UpsertOneBitwerxPaymentWritebackConfigurationDocument, options);
      }
export type UpsertOneBitwerxPaymentWritebackConfigurationMutationHookResult = ReturnType<typeof useUpsertOneBitwerxPaymentWritebackConfigurationMutation>;
export type UpsertOneBitwerxPaymentWritebackConfigurationMutationResult = Apollo.MutationResult<UpsertOneBitwerxPaymentWritebackConfigurationMutation>;
export type UpsertOneBitwerxPaymentWritebackConfigurationMutationOptions = Apollo.BaseMutationOptions<UpsertOneBitwerxPaymentWritebackConfigurationMutation, UpsertOneBitwerxPaymentWritebackConfigurationMutationVariables>;
export const GetBitwerxPaymentWritebackConfigDocument = gql`
    query getBitwerxPaymentWritebackConfig($integrationId: String!) {
  findUniqueBitwerxPaymentWritebackConfiguration(
    where: {integrationId: $integrationId}
  ) {
    id
    integrationId
    enteredById
    defaultPimsPaymentTypeId
    visaPimsPaymentTypeId
    mastercardPimsPaymentTypeId
    amexPimsPaymentTypeId
    discoverPimsPaymentTypeId
    writebackManualPayment
  }
}
    `;

/**
 * __useGetBitwerxPaymentWritebackConfigQuery__
 *
 * To run a query within a React component, call `useGetBitwerxPaymentWritebackConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBitwerxPaymentWritebackConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBitwerxPaymentWritebackConfigQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGetBitwerxPaymentWritebackConfigQuery(baseOptions: Apollo.QueryHookOptions<GetBitwerxPaymentWritebackConfigQuery, GetBitwerxPaymentWritebackConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBitwerxPaymentWritebackConfigQuery, GetBitwerxPaymentWritebackConfigQueryVariables>(GetBitwerxPaymentWritebackConfigDocument, options);
      }
export function useGetBitwerxPaymentWritebackConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBitwerxPaymentWritebackConfigQuery, GetBitwerxPaymentWritebackConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBitwerxPaymentWritebackConfigQuery, GetBitwerxPaymentWritebackConfigQueryVariables>(GetBitwerxPaymentWritebackConfigDocument, options);
        }
export type GetBitwerxPaymentWritebackConfigQueryHookResult = ReturnType<typeof useGetBitwerxPaymentWritebackConfigQuery>;
export type GetBitwerxPaymentWritebackConfigLazyQueryHookResult = ReturnType<typeof useGetBitwerxPaymentWritebackConfigLazyQuery>;
export type GetBitwerxPaymentWritebackConfigQueryResult = Apollo.QueryResult<GetBitwerxPaymentWritebackConfigQuery, GetBitwerxPaymentWritebackConfigQueryVariables>;
export function refetchGetBitwerxPaymentWritebackConfigQuery(variables?: GetBitwerxPaymentWritebackConfigQueryVariables) {
      return { query: GetBitwerxPaymentWritebackConfigDocument, variables: variables }
    }
export const GetClinicEmployeesForPaymentSettingsDocument = gql`
    query getClinicEmployeesForPaymentSettings($clinicId: String!) {
  findManyClinicEmployee(
    where: {isDeleted: {equals: false}, isActive: {equals: true}, isVisible: {equals: true}, clinic: {id: {equals: $clinicId}}}
  ) {
    ...ClinicEmployeeBaseSelection
    pimsId
    isDeleted
  }
}
    ${ClinicEmployeeBaseSelectionFragmentDoc}`;

/**
 * __useGetClinicEmployeesForPaymentSettingsQuery__
 *
 * To run a query within a React component, call `useGetClinicEmployeesForPaymentSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicEmployeesForPaymentSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicEmployeesForPaymentSettingsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicEmployeesForPaymentSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicEmployeesForPaymentSettingsQuery, GetClinicEmployeesForPaymentSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicEmployeesForPaymentSettingsQuery, GetClinicEmployeesForPaymentSettingsQueryVariables>(GetClinicEmployeesForPaymentSettingsDocument, options);
      }
export function useGetClinicEmployeesForPaymentSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicEmployeesForPaymentSettingsQuery, GetClinicEmployeesForPaymentSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicEmployeesForPaymentSettingsQuery, GetClinicEmployeesForPaymentSettingsQueryVariables>(GetClinicEmployeesForPaymentSettingsDocument, options);
        }
export type GetClinicEmployeesForPaymentSettingsQueryHookResult = ReturnType<typeof useGetClinicEmployeesForPaymentSettingsQuery>;
export type GetClinicEmployeesForPaymentSettingsLazyQueryHookResult = ReturnType<typeof useGetClinicEmployeesForPaymentSettingsLazyQuery>;
export type GetClinicEmployeesForPaymentSettingsQueryResult = Apollo.QueryResult<GetClinicEmployeesForPaymentSettingsQuery, GetClinicEmployeesForPaymentSettingsQueryVariables>;
export function refetchGetClinicEmployeesForPaymentSettingsQuery(variables?: GetClinicEmployeesForPaymentSettingsQueryVariables) {
      return { query: GetClinicEmployeesForPaymentSettingsDocument, variables: variables }
    }
export const GetPimsPaymentTypesDocument = gql`
    query getPimsPaymentTypes($integrationId: String!) {
  findManyPimsPaymentType(where: {integrationId: {equals: $integrationId}}) {
    ...PimsPaymentTypeSelection
  }
}
    ${PimsPaymentTypeSelectionFragmentDoc}`;

/**
 * __useGetPimsPaymentTypesQuery__
 *
 * To run a query within a React component, call `useGetPimsPaymentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPimsPaymentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPimsPaymentTypesQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGetPimsPaymentTypesQuery(baseOptions: Apollo.QueryHookOptions<GetPimsPaymentTypesQuery, GetPimsPaymentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPimsPaymentTypesQuery, GetPimsPaymentTypesQueryVariables>(GetPimsPaymentTypesDocument, options);
      }
export function useGetPimsPaymentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPimsPaymentTypesQuery, GetPimsPaymentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPimsPaymentTypesQuery, GetPimsPaymentTypesQueryVariables>(GetPimsPaymentTypesDocument, options);
        }
export type GetPimsPaymentTypesQueryHookResult = ReturnType<typeof useGetPimsPaymentTypesQuery>;
export type GetPimsPaymentTypesLazyQueryHookResult = ReturnType<typeof useGetPimsPaymentTypesLazyQuery>;
export type GetPimsPaymentTypesQueryResult = Apollo.QueryResult<GetPimsPaymentTypesQuery, GetPimsPaymentTypesQueryVariables>;
export function refetchGetPimsPaymentTypesQuery(variables?: GetPimsPaymentTypesQueryVariables) {
      return { query: GetPimsPaymentTypesDocument, variables: variables }
    }
export const GetTerminalLocationCountDocument = gql`
    query getTerminalLocationCount($clinicId: String!) {
  findManyStripeTerminalLocationCount(where: {clinicId: {equals: $clinicId}})
}
    `;

/**
 * __useGetTerminalLocationCountQuery__
 *
 * To run a query within a React component, call `useGetTerminalLocationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerminalLocationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTerminalLocationCountQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetTerminalLocationCountQuery(baseOptions: Apollo.QueryHookOptions<GetTerminalLocationCountQuery, GetTerminalLocationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTerminalLocationCountQuery, GetTerminalLocationCountQueryVariables>(GetTerminalLocationCountDocument, options);
      }
export function useGetTerminalLocationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTerminalLocationCountQuery, GetTerminalLocationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTerminalLocationCountQuery, GetTerminalLocationCountQueryVariables>(GetTerminalLocationCountDocument, options);
        }
export type GetTerminalLocationCountQueryHookResult = ReturnType<typeof useGetTerminalLocationCountQuery>;
export type GetTerminalLocationCountLazyQueryHookResult = ReturnType<typeof useGetTerminalLocationCountLazyQuery>;
export type GetTerminalLocationCountQueryResult = Apollo.QueryResult<GetTerminalLocationCountQuery, GetTerminalLocationCountQueryVariables>;
export function refetchGetTerminalLocationCountQuery(variables?: GetTerminalLocationCountQueryVariables) {
      return { query: GetTerminalLocationCountDocument, variables: variables }
    }
export const ToggleClinicIsServiceRemindersActiveDocument = gql`
    mutation toggleClinicIsServiceRemindersActive($clinicId: String!, $isServiceRemindersActive: Boolean!) {
  updateOneClinic(
    where: {id: $clinicId}
    data: {isServiceRemindersActive: $isServiceRemindersActive}
  ) {
    id
    isServiceRemindersActive
  }
}
    `;
export type ToggleClinicIsServiceRemindersActiveMutationFn = Apollo.MutationFunction<ToggleClinicIsServiceRemindersActiveMutation, ToggleClinicIsServiceRemindersActiveMutationVariables>;

/**
 * __useToggleClinicIsServiceRemindersActiveMutation__
 *
 * To run a mutation, you first call `useToggleClinicIsServiceRemindersActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleClinicIsServiceRemindersActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleClinicIsServiceRemindersActiveMutation, { data, loading, error }] = useToggleClinicIsServiceRemindersActiveMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      isServiceRemindersActive: // value for 'isServiceRemindersActive'
 *   },
 * });
 */
export function useToggleClinicIsServiceRemindersActiveMutation(baseOptions?: Apollo.MutationHookOptions<ToggleClinicIsServiceRemindersActiveMutation, ToggleClinicIsServiceRemindersActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleClinicIsServiceRemindersActiveMutation, ToggleClinicIsServiceRemindersActiveMutationVariables>(ToggleClinicIsServiceRemindersActiveDocument, options);
      }
export type ToggleClinicIsServiceRemindersActiveMutationHookResult = ReturnType<typeof useToggleClinicIsServiceRemindersActiveMutation>;
export type ToggleClinicIsServiceRemindersActiveMutationResult = Apollo.MutationResult<ToggleClinicIsServiceRemindersActiveMutation>;
export type ToggleClinicIsServiceRemindersActiveMutationOptions = Apollo.BaseMutationOptions<ToggleClinicIsServiceRemindersActiveMutation, ToggleClinicIsServiceRemindersActiveMutationVariables>;
export const UpdateClinicPostcardSettingDocument = gql`
    mutation updateClinicPostcardSetting($where: UpdateClinicPostcardSettingWhereInput, $data: UpdateClinicPostcardSettingDataInput!) {
  updateClinicPostcardSetting(where: $where, data: $data) {
    id
  }
}
    `;
export type UpdateClinicPostcardSettingMutationFn = Apollo.MutationFunction<UpdateClinicPostcardSettingMutation, UpdateClinicPostcardSettingMutationVariables>;

/**
 * __useUpdateClinicPostcardSettingMutation__
 *
 * To run a mutation, you first call `useUpdateClinicPostcardSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicPostcardSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicPostcardSettingMutation, { data, loading, error }] = useUpdateClinicPostcardSettingMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicPostcardSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicPostcardSettingMutation, UpdateClinicPostcardSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicPostcardSettingMutation, UpdateClinicPostcardSettingMutationVariables>(UpdateClinicPostcardSettingDocument, options);
      }
export type UpdateClinicPostcardSettingMutationHookResult = ReturnType<typeof useUpdateClinicPostcardSettingMutation>;
export type UpdateClinicPostcardSettingMutationResult = Apollo.MutationResult<UpdateClinicPostcardSettingMutation>;
export type UpdateClinicPostcardSettingMutationOptions = Apollo.BaseMutationOptions<UpdateClinicPostcardSettingMutation, UpdateClinicPostcardSettingMutationVariables>;
export const UpdateReminderSettingsServiceDocument = gql`
    mutation updateReminderSettingsService($where: ServiceWhereInput, $data: ServiceUpdateManyMutationInput!) {
  updateManyService(where: $where, data: $data) {
    count
  }
}
    `;
export type UpdateReminderSettingsServiceMutationFn = Apollo.MutationFunction<UpdateReminderSettingsServiceMutation, UpdateReminderSettingsServiceMutationVariables>;

/**
 * __useUpdateReminderSettingsServiceMutation__
 *
 * To run a mutation, you first call `useUpdateReminderSettingsServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReminderSettingsServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReminderSettingsServiceMutation, { data, loading, error }] = useUpdateReminderSettingsServiceMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReminderSettingsServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReminderSettingsServiceMutation, UpdateReminderSettingsServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReminderSettingsServiceMutation, UpdateReminderSettingsServiceMutationVariables>(UpdateReminderSettingsServiceDocument, options);
      }
export type UpdateReminderSettingsServiceMutationHookResult = ReturnType<typeof useUpdateReminderSettingsServiceMutation>;
export type UpdateReminderSettingsServiceMutationResult = Apollo.MutationResult<UpdateReminderSettingsServiceMutation>;
export type UpdateReminderSettingsServiceMutationOptions = Apollo.BaseMutationOptions<UpdateReminderSettingsServiceMutation, UpdateReminderSettingsServiceMutationVariables>;
export const UpdateReminderSettingsWorkflowEventSettingDocument = gql`
    mutation updateReminderSettingsWorkflowEventSetting($where: WorkflowEventSettingWhereUniqueInput!, $data: WorkflowEventSettingUpdateInput!) {
  updateOneWorkflowEventSetting(where: $where, data: $data) {
    ...ReminderSettingsWorkflowEventSetting
  }
}
    ${ReminderSettingsWorkflowEventSettingFragmentDoc}`;
export type UpdateReminderSettingsWorkflowEventSettingMutationFn = Apollo.MutationFunction<UpdateReminderSettingsWorkflowEventSettingMutation, UpdateReminderSettingsWorkflowEventSettingMutationVariables>;

/**
 * __useUpdateReminderSettingsWorkflowEventSettingMutation__
 *
 * To run a mutation, you first call `useUpdateReminderSettingsWorkflowEventSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReminderSettingsWorkflowEventSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReminderSettingsWorkflowEventSettingMutation, { data, loading, error }] = useUpdateReminderSettingsWorkflowEventSettingMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReminderSettingsWorkflowEventSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReminderSettingsWorkflowEventSettingMutation, UpdateReminderSettingsWorkflowEventSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReminderSettingsWorkflowEventSettingMutation, UpdateReminderSettingsWorkflowEventSettingMutationVariables>(UpdateReminderSettingsWorkflowEventSettingDocument, options);
      }
export type UpdateReminderSettingsWorkflowEventSettingMutationHookResult = ReturnType<typeof useUpdateReminderSettingsWorkflowEventSettingMutation>;
export type UpdateReminderSettingsWorkflowEventSettingMutationResult = Apollo.MutationResult<UpdateReminderSettingsWorkflowEventSettingMutation>;
export type UpdateReminderSettingsWorkflowEventSettingMutationOptions = Apollo.BaseMutationOptions<UpdateReminderSettingsWorkflowEventSettingMutation, UpdateReminderSettingsWorkflowEventSettingMutationVariables>;
export const UpdateServicesTimingsDocument = gql`
    mutation updateServicesTimings($where: ServiceWhereInput!, $data: [ServiceReminderTimingInput!]!) {
  updateManyServicesAndTimings(where: $where, data: $data) {
    id
  }
}
    `;
export type UpdateServicesTimingsMutationFn = Apollo.MutationFunction<UpdateServicesTimingsMutation, UpdateServicesTimingsMutationVariables>;

/**
 * __useUpdateServicesTimingsMutation__
 *
 * To run a mutation, you first call `useUpdateServicesTimingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServicesTimingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServicesTimingsMutation, { data, loading, error }] = useUpdateServicesTimingsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateServicesTimingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServicesTimingsMutation, UpdateServicesTimingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServicesTimingsMutation, UpdateServicesTimingsMutationVariables>(UpdateServicesTimingsDocument, options);
      }
export type UpdateServicesTimingsMutationHookResult = ReturnType<typeof useUpdateServicesTimingsMutation>;
export type UpdateServicesTimingsMutationResult = Apollo.MutationResult<UpdateServicesTimingsMutation>;
export type UpdateServicesTimingsMutationOptions = Apollo.BaseMutationOptions<UpdateServicesTimingsMutation, UpdateServicesTimingsMutationVariables>;
export const ToggleServicesTimingsDeliveryOptionsDocument = gql`
    mutation toggleServicesTimingsDeliveryOptions($where: ServiceWhereInput!, $data: ServiceReminderTimingDeliveryOptionInput!) {
  updateManyTimingsDeliveryOptions(where: $where, data: $data) {
    id
  }
}
    `;
export type ToggleServicesTimingsDeliveryOptionsMutationFn = Apollo.MutationFunction<ToggleServicesTimingsDeliveryOptionsMutation, ToggleServicesTimingsDeliveryOptionsMutationVariables>;

/**
 * __useToggleServicesTimingsDeliveryOptionsMutation__
 *
 * To run a mutation, you first call `useToggleServicesTimingsDeliveryOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleServicesTimingsDeliveryOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleServicesTimingsDeliveryOptionsMutation, { data, loading, error }] = useToggleServicesTimingsDeliveryOptionsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useToggleServicesTimingsDeliveryOptionsMutation(baseOptions?: Apollo.MutationHookOptions<ToggleServicesTimingsDeliveryOptionsMutation, ToggleServicesTimingsDeliveryOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleServicesTimingsDeliveryOptionsMutation, ToggleServicesTimingsDeliveryOptionsMutationVariables>(ToggleServicesTimingsDeliveryOptionsDocument, options);
      }
export type ToggleServicesTimingsDeliveryOptionsMutationHookResult = ReturnType<typeof useToggleServicesTimingsDeliveryOptionsMutation>;
export type ToggleServicesTimingsDeliveryOptionsMutationResult = Apollo.MutationResult<ToggleServicesTimingsDeliveryOptionsMutation>;
export type ToggleServicesTimingsDeliveryOptionsMutationOptions = Apollo.BaseMutationOptions<ToggleServicesTimingsDeliveryOptionsMutation, ToggleServicesTimingsDeliveryOptionsMutationVariables>;
export const GetClinicIsServiceRemindersActiveDocument = gql`
    query getClinicIsServiceRemindersActive($clinicId: String!) {
  findUniqueClinic(where: {id: $clinicId}) {
    id
    isServiceRemindersActive
  }
}
    `;

/**
 * __useGetClinicIsServiceRemindersActiveQuery__
 *
 * To run a query within a React component, call `useGetClinicIsServiceRemindersActiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicIsServiceRemindersActiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicIsServiceRemindersActiveQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicIsServiceRemindersActiveQuery(baseOptions: Apollo.QueryHookOptions<GetClinicIsServiceRemindersActiveQuery, GetClinicIsServiceRemindersActiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicIsServiceRemindersActiveQuery, GetClinicIsServiceRemindersActiveQueryVariables>(GetClinicIsServiceRemindersActiveDocument, options);
      }
export function useGetClinicIsServiceRemindersActiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicIsServiceRemindersActiveQuery, GetClinicIsServiceRemindersActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicIsServiceRemindersActiveQuery, GetClinicIsServiceRemindersActiveQueryVariables>(GetClinicIsServiceRemindersActiveDocument, options);
        }
export type GetClinicIsServiceRemindersActiveQueryHookResult = ReturnType<typeof useGetClinicIsServiceRemindersActiveQuery>;
export type GetClinicIsServiceRemindersActiveLazyQueryHookResult = ReturnType<typeof useGetClinicIsServiceRemindersActiveLazyQuery>;
export type GetClinicIsServiceRemindersActiveQueryResult = Apollo.QueryResult<GetClinicIsServiceRemindersActiveQuery, GetClinicIsServiceRemindersActiveQueryVariables>;
export function refetchGetClinicIsServiceRemindersActiveQuery(variables?: GetClinicIsServiceRemindersActiveQueryVariables) {
      return { query: GetClinicIsServiceRemindersActiveDocument, variables: variables }
    }
export const GetClinicPostcardsSettingsDocument = gql`
    query getClinicPostcardsSettings($where: ClinicPostcardSettingWhereUniqueInput!) {
  findUniqueClinicPostcardSetting(where: $where) {
    id
    isRemindersEnabled
    apiKey
    apiSecret
  }
}
    `;

/**
 * __useGetClinicPostcardsSettingsQuery__
 *
 * To run a query within a React component, call `useGetClinicPostcardsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicPostcardsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicPostcardsSettingsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicPostcardsSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicPostcardsSettingsQuery, GetClinicPostcardsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicPostcardsSettingsQuery, GetClinicPostcardsSettingsQueryVariables>(GetClinicPostcardsSettingsDocument, options);
      }
export function useGetClinicPostcardsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicPostcardsSettingsQuery, GetClinicPostcardsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicPostcardsSettingsQuery, GetClinicPostcardsSettingsQueryVariables>(GetClinicPostcardsSettingsDocument, options);
        }
export type GetClinicPostcardsSettingsQueryHookResult = ReturnType<typeof useGetClinicPostcardsSettingsQuery>;
export type GetClinicPostcardsSettingsLazyQueryHookResult = ReturnType<typeof useGetClinicPostcardsSettingsLazyQuery>;
export type GetClinicPostcardsSettingsQueryResult = Apollo.QueryResult<GetClinicPostcardsSettingsQuery, GetClinicPostcardsSettingsQueryVariables>;
export function refetchGetClinicPostcardsSettingsQuery(variables?: GetClinicPostcardsSettingsQueryVariables) {
      return { query: GetClinicPostcardsSettingsDocument, variables: variables }
    }
export const GetClinicStripeInfoDocument = gql`
    query getClinicStripeInfo($where: ClinicWhereUniqueInput!) {
  findUniqueClinic(where: $where) {
    id
    stripeCustomerId
    stripeSubscriptionId
  }
}
    `;

/**
 * __useGetClinicStripeInfoQuery__
 *
 * To run a query within a React component, call `useGetClinicStripeInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicStripeInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicStripeInfoQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicStripeInfoQuery(baseOptions: Apollo.QueryHookOptions<GetClinicStripeInfoQuery, GetClinicStripeInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicStripeInfoQuery, GetClinicStripeInfoQueryVariables>(GetClinicStripeInfoDocument, options);
      }
export function useGetClinicStripeInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicStripeInfoQuery, GetClinicStripeInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicStripeInfoQuery, GetClinicStripeInfoQueryVariables>(GetClinicStripeInfoDocument, options);
        }
export type GetClinicStripeInfoQueryHookResult = ReturnType<typeof useGetClinicStripeInfoQuery>;
export type GetClinicStripeInfoLazyQueryHookResult = ReturnType<typeof useGetClinicStripeInfoLazyQuery>;
export type GetClinicStripeInfoQueryResult = Apollo.QueryResult<GetClinicStripeInfoQuery, GetClinicStripeInfoQueryVariables>;
export function refetchGetClinicStripeInfoQuery(variables?: GetClinicStripeInfoQueryVariables) {
      return { query: GetClinicStripeInfoDocument, variables: variables }
    }
export const GetReminderSettingsClinicServicesDocument = gql`
    query getReminderSettingsClinicServices($where: ServiceWhereInput, $orderBy: [ServiceOrderByWithRelationInput!], $take: Int, $skip: Int) {
  findManyService(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    ...ReminderSettingsService
  }
  findManyServiceCount(where: $where)
}
    ${ReminderSettingsServiceFragmentDoc}`;

/**
 * __useGetReminderSettingsClinicServicesQuery__
 *
 * To run a query within a React component, call `useGetReminderSettingsClinicServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReminderSettingsClinicServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReminderSettingsClinicServicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetReminderSettingsClinicServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetReminderSettingsClinicServicesQuery, GetReminderSettingsClinicServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReminderSettingsClinicServicesQuery, GetReminderSettingsClinicServicesQueryVariables>(GetReminderSettingsClinicServicesDocument, options);
      }
export function useGetReminderSettingsClinicServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReminderSettingsClinicServicesQuery, GetReminderSettingsClinicServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReminderSettingsClinicServicesQuery, GetReminderSettingsClinicServicesQueryVariables>(GetReminderSettingsClinicServicesDocument, options);
        }
export type GetReminderSettingsClinicServicesQueryHookResult = ReturnType<typeof useGetReminderSettingsClinicServicesQuery>;
export type GetReminderSettingsClinicServicesLazyQueryHookResult = ReturnType<typeof useGetReminderSettingsClinicServicesLazyQuery>;
export type GetReminderSettingsClinicServicesQueryResult = Apollo.QueryResult<GetReminderSettingsClinicServicesQuery, GetReminderSettingsClinicServicesQueryVariables>;
export function refetchGetReminderSettingsClinicServicesQuery(variables?: GetReminderSettingsClinicServicesQueryVariables) {
      return { query: GetReminderSettingsClinicServicesDocument, variables: variables }
    }
export const GetReminderSettingsClinicServicesFormTemplateIdDocument = gql`
    query getReminderSettingsClinicServicesFormTemplateId($clinicId: String) {
  findFirstFormTemplate(
    where: {clinicId: {equals: $clinicId}, formTemplateType: {equals: ServiceReminder}}
  ) {
    id
    isDeleted
    isActive
  }
}
    `;

/**
 * __useGetReminderSettingsClinicServicesFormTemplateIdQuery__
 *
 * To run a query within a React component, call `useGetReminderSettingsClinicServicesFormTemplateIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReminderSettingsClinicServicesFormTemplateIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReminderSettingsClinicServicesFormTemplateIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetReminderSettingsClinicServicesFormTemplateIdQuery(baseOptions?: Apollo.QueryHookOptions<GetReminderSettingsClinicServicesFormTemplateIdQuery, GetReminderSettingsClinicServicesFormTemplateIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReminderSettingsClinicServicesFormTemplateIdQuery, GetReminderSettingsClinicServicesFormTemplateIdQueryVariables>(GetReminderSettingsClinicServicesFormTemplateIdDocument, options);
      }
export function useGetReminderSettingsClinicServicesFormTemplateIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReminderSettingsClinicServicesFormTemplateIdQuery, GetReminderSettingsClinicServicesFormTemplateIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReminderSettingsClinicServicesFormTemplateIdQuery, GetReminderSettingsClinicServicesFormTemplateIdQueryVariables>(GetReminderSettingsClinicServicesFormTemplateIdDocument, options);
        }
export type GetReminderSettingsClinicServicesFormTemplateIdQueryHookResult = ReturnType<typeof useGetReminderSettingsClinicServicesFormTemplateIdQuery>;
export type GetReminderSettingsClinicServicesFormTemplateIdLazyQueryHookResult = ReturnType<typeof useGetReminderSettingsClinicServicesFormTemplateIdLazyQuery>;
export type GetReminderSettingsClinicServicesFormTemplateIdQueryResult = Apollo.QueryResult<GetReminderSettingsClinicServicesFormTemplateIdQuery, GetReminderSettingsClinicServicesFormTemplateIdQueryVariables>;
export function refetchGetReminderSettingsClinicServicesFormTemplateIdQuery(variables?: GetReminderSettingsClinicServicesFormTemplateIdQueryVariables) {
      return { query: GetReminderSettingsClinicServicesFormTemplateIdDocument, variables: variables }
    }
export const GetReminderSettingsClinicServicesTimingsDocument = gql`
    query getReminderSettingsClinicServicesTimings($where: ServiceReminderTimingWhereInput) {
  findManyServiceReminderTiming(where: $where) {
    ...ReminderSettingsServiceTiming
  }
}
    ${ReminderSettingsServiceTimingFragmentDoc}`;

/**
 * __useGetReminderSettingsClinicServicesTimingsQuery__
 *
 * To run a query within a React component, call `useGetReminderSettingsClinicServicesTimingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReminderSettingsClinicServicesTimingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReminderSettingsClinicServicesTimingsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetReminderSettingsClinicServicesTimingsQuery(baseOptions?: Apollo.QueryHookOptions<GetReminderSettingsClinicServicesTimingsQuery, GetReminderSettingsClinicServicesTimingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReminderSettingsClinicServicesTimingsQuery, GetReminderSettingsClinicServicesTimingsQueryVariables>(GetReminderSettingsClinicServicesTimingsDocument, options);
      }
export function useGetReminderSettingsClinicServicesTimingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReminderSettingsClinicServicesTimingsQuery, GetReminderSettingsClinicServicesTimingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReminderSettingsClinicServicesTimingsQuery, GetReminderSettingsClinicServicesTimingsQueryVariables>(GetReminderSettingsClinicServicesTimingsDocument, options);
        }
export type GetReminderSettingsClinicServicesTimingsQueryHookResult = ReturnType<typeof useGetReminderSettingsClinicServicesTimingsQuery>;
export type GetReminderSettingsClinicServicesTimingsLazyQueryHookResult = ReturnType<typeof useGetReminderSettingsClinicServicesTimingsLazyQuery>;
export type GetReminderSettingsClinicServicesTimingsQueryResult = Apollo.QueryResult<GetReminderSettingsClinicServicesTimingsQuery, GetReminderSettingsClinicServicesTimingsQueryVariables>;
export function refetchGetReminderSettingsClinicServicesTimingsQuery(variables?: GetReminderSettingsClinicServicesTimingsQueryVariables) {
      return { query: GetReminderSettingsClinicServicesTimingsDocument, variables: variables }
    }
export const GetReminderSettingsWorkflowEventSettingDocument = gql`
    query getReminderSettingsWorkflowEventSetting($where: WorkflowEventSettingWhereInput!) {
  findManyWorkflowEventSetting(where: $where) {
    ...ReminderSettingsWorkflowEventSetting
  }
}
    ${ReminderSettingsWorkflowEventSettingFragmentDoc}`;

/**
 * __useGetReminderSettingsWorkflowEventSettingQuery__
 *
 * To run a query within a React component, call `useGetReminderSettingsWorkflowEventSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReminderSettingsWorkflowEventSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReminderSettingsWorkflowEventSettingQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetReminderSettingsWorkflowEventSettingQuery(baseOptions: Apollo.QueryHookOptions<GetReminderSettingsWorkflowEventSettingQuery, GetReminderSettingsWorkflowEventSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReminderSettingsWorkflowEventSettingQuery, GetReminderSettingsWorkflowEventSettingQueryVariables>(GetReminderSettingsWorkflowEventSettingDocument, options);
      }
export function useGetReminderSettingsWorkflowEventSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReminderSettingsWorkflowEventSettingQuery, GetReminderSettingsWorkflowEventSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReminderSettingsWorkflowEventSettingQuery, GetReminderSettingsWorkflowEventSettingQueryVariables>(GetReminderSettingsWorkflowEventSettingDocument, options);
        }
export type GetReminderSettingsWorkflowEventSettingQueryHookResult = ReturnType<typeof useGetReminderSettingsWorkflowEventSettingQuery>;
export type GetReminderSettingsWorkflowEventSettingLazyQueryHookResult = ReturnType<typeof useGetReminderSettingsWorkflowEventSettingLazyQuery>;
export type GetReminderSettingsWorkflowEventSettingQueryResult = Apollo.QueryResult<GetReminderSettingsWorkflowEventSettingQuery, GetReminderSettingsWorkflowEventSettingQueryVariables>;
export function refetchGetReminderSettingsWorkflowEventSettingQuery(variables?: GetReminderSettingsWorkflowEventSettingQueryVariables) {
      return { query: GetReminderSettingsWorkflowEventSettingDocument, variables: variables }
    }
export const GetWidgetRequestTypesTableDocument = gql`
    query getWidgetRequestTypesTable($where: ClinicWidgetRequestTypeWhereInput, $orderBy: [ClinicWidgetRequestTypeOrderByWithRelationInput]) {
  findManyClinicWidgetRequestType(where: $where, orderBy: $orderBy) {
    id
    createdAt
    updatedAt
    displayName
    order
    requestType
    shouldCreateTask
    assignees {
      id
    }
  }
}
    `;

/**
 * __useGetWidgetRequestTypesTableQuery__
 *
 * To run a query within a React component, call `useGetWidgetRequestTypesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetRequestTypesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetRequestTypesTableQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetWidgetRequestTypesTableQuery(baseOptions?: Apollo.QueryHookOptions<GetWidgetRequestTypesTableQuery, GetWidgetRequestTypesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetRequestTypesTableQuery, GetWidgetRequestTypesTableQueryVariables>(GetWidgetRequestTypesTableDocument, options);
      }
export function useGetWidgetRequestTypesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetRequestTypesTableQuery, GetWidgetRequestTypesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetRequestTypesTableQuery, GetWidgetRequestTypesTableQueryVariables>(GetWidgetRequestTypesTableDocument, options);
        }
export type GetWidgetRequestTypesTableQueryHookResult = ReturnType<typeof useGetWidgetRequestTypesTableQuery>;
export type GetWidgetRequestTypesTableLazyQueryHookResult = ReturnType<typeof useGetWidgetRequestTypesTableLazyQuery>;
export type GetWidgetRequestTypesTableQueryResult = Apollo.QueryResult<GetWidgetRequestTypesTableQuery, GetWidgetRequestTypesTableQueryVariables>;
export function refetchGetWidgetRequestTypesTableQuery(variables?: GetWidgetRequestTypesTableQueryVariables) {
      return { query: GetWidgetRequestTypesTableDocument, variables: variables }
    }
export const UpdateOneClinicWidgetRequestTypeDocument = gql`
    mutation updateOneClinicWidgetRequestType($data: ClinicWidgetRequestTypeUpdateInput!, $where: ClinicWidgetRequestTypeWhereUniqueInput!) {
  updateOneClinicWidgetRequestType(data: $data, where: $where) {
    id
    shouldCreateTask
    assignees {
      id
    }
  }
}
    `;
export type UpdateOneClinicWidgetRequestTypeMutationFn = Apollo.MutationFunction<UpdateOneClinicWidgetRequestTypeMutation, UpdateOneClinicWidgetRequestTypeMutationVariables>;

/**
 * __useUpdateOneClinicWidgetRequestTypeMutation__
 *
 * To run a mutation, you first call `useUpdateOneClinicWidgetRequestTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneClinicWidgetRequestTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneClinicWidgetRequestTypeMutation, { data, loading, error }] = useUpdateOneClinicWidgetRequestTypeMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneClinicWidgetRequestTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneClinicWidgetRequestTypeMutation, UpdateOneClinicWidgetRequestTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneClinicWidgetRequestTypeMutation, UpdateOneClinicWidgetRequestTypeMutationVariables>(UpdateOneClinicWidgetRequestTypeDocument, options);
      }
export type UpdateOneClinicWidgetRequestTypeMutationHookResult = ReturnType<typeof useUpdateOneClinicWidgetRequestTypeMutation>;
export type UpdateOneClinicWidgetRequestTypeMutationResult = Apollo.MutationResult<UpdateOneClinicWidgetRequestTypeMutation>;
export type UpdateOneClinicWidgetRequestTypeMutationOptions = Apollo.BaseMutationOptions<UpdateOneClinicWidgetRequestTypeMutation, UpdateOneClinicWidgetRequestTypeMutationVariables>;
export const DeleteClinicSettingsTeamUserDocument = gql`
    mutation deleteClinicSettingsTeamUser($data: RemoveUserFromClinicInput!) {
  removeUserFromClinic(data: $data) {
    id
  }
}
    `;
export type DeleteClinicSettingsTeamUserMutationFn = Apollo.MutationFunction<DeleteClinicSettingsTeamUserMutation, DeleteClinicSettingsTeamUserMutationVariables>;

/**
 * __useDeleteClinicSettingsTeamUserMutation__
 *
 * To run a mutation, you first call `useDeleteClinicSettingsTeamUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicSettingsTeamUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicSettingsTeamUserMutation, { data, loading, error }] = useDeleteClinicSettingsTeamUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteClinicSettingsTeamUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicSettingsTeamUserMutation, DeleteClinicSettingsTeamUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicSettingsTeamUserMutation, DeleteClinicSettingsTeamUserMutationVariables>(DeleteClinicSettingsTeamUserDocument, options);
      }
export type DeleteClinicSettingsTeamUserMutationHookResult = ReturnType<typeof useDeleteClinicSettingsTeamUserMutation>;
export type DeleteClinicSettingsTeamUserMutationResult = Apollo.MutationResult<DeleteClinicSettingsTeamUserMutation>;
export type DeleteClinicSettingsTeamUserMutationOptions = Apollo.BaseMutationOptions<DeleteClinicSettingsTeamUserMutation, DeleteClinicSettingsTeamUserMutationVariables>;
export const ResendUserInvitationDocument = gql`
    mutation resendUserInvitation($email: String!, $clinicId: String!) {
  resendUserInvitation(data: {email: $email}) {
    ...ClinicSettingsTeamUser
  }
}
    ${ClinicSettingsTeamUserFragmentDoc}`;
export type ResendUserInvitationMutationFn = Apollo.MutationFunction<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>;

/**
 * __useResendUserInvitationMutation__
 *
 * To run a mutation, you first call `useResendUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserInvitationMutation, { data, loading, error }] = useResendUserInvitationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useResendUserInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>(ResendUserInvitationDocument, options);
      }
export type ResendUserInvitationMutationHookResult = ReturnType<typeof useResendUserInvitationMutation>;
export type ResendUserInvitationMutationResult = Apollo.MutationResult<ResendUserInvitationMutation>;
export type ResendUserInvitationMutationOptions = Apollo.BaseMutationOptions<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>;
export const UpdateClinicSettingsTeamUserDocument = gql`
    mutation updateClinicSettingsTeamUser($where: UserWhereUniqueInput!, $data: UserUpdateInput!) {
  updateOneUser(where: $where, data: $data) {
    id
    firstName
    lastName
    namePrefix
    nameSuffix
    email
    phone
    isNewPasswordRequired
  }
}
    `;
export type UpdateClinicSettingsTeamUserMutationFn = Apollo.MutationFunction<UpdateClinicSettingsTeamUserMutation, UpdateClinicSettingsTeamUserMutationVariables>;

/**
 * __useUpdateClinicSettingsTeamUserMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsTeamUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsTeamUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsTeamUserMutation, { data, loading, error }] = useUpdateClinicSettingsTeamUserMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicSettingsTeamUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsTeamUserMutation, UpdateClinicSettingsTeamUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsTeamUserMutation, UpdateClinicSettingsTeamUserMutationVariables>(UpdateClinicSettingsTeamUserDocument, options);
      }
export type UpdateClinicSettingsTeamUserMutationHookResult = ReturnType<typeof useUpdateClinicSettingsTeamUserMutation>;
export type UpdateClinicSettingsTeamUserMutationResult = Apollo.MutationResult<UpdateClinicSettingsTeamUserMutation>;
export type UpdateClinicSettingsTeamUserMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsTeamUserMutation, UpdateClinicSettingsTeamUserMutationVariables>;
export const UpsertUserToClinicDocument = gql`
    mutation upsertUserToClinic($data: UpsertUserToClinicInput!) {
  upsertUserToClinic(data: $data) {
    id
  }
}
    `;
export type UpsertUserToClinicMutationFn = Apollo.MutationFunction<UpsertUserToClinicMutation, UpsertUserToClinicMutationVariables>;

/**
 * __useUpsertUserToClinicMutation__
 *
 * To run a mutation, you first call `useUpsertUserToClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserToClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserToClinicMutation, { data, loading, error }] = useUpsertUserToClinicMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertUserToClinicMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserToClinicMutation, UpsertUserToClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserToClinicMutation, UpsertUserToClinicMutationVariables>(UpsertUserToClinicDocument, options);
      }
export type UpsertUserToClinicMutationHookResult = ReturnType<typeof useUpsertUserToClinicMutation>;
export type UpsertUserToClinicMutationResult = Apollo.MutationResult<UpsertUserToClinicMutation>;
export type UpsertUserToClinicMutationOptions = Apollo.BaseMutationOptions<UpsertUserToClinicMutation, UpsertUserToClinicMutationVariables>;
export const GetClinicSettingsTeamUsersDocument = gql`
    query getClinicSettingsTeamUsers($where: UserWhereInput!, $clinicId: String!) {
  findManyUser(where: $where, orderBy: {createdAt: asc}) {
    ...ClinicSettingsTeamUser
  }
}
    ${ClinicSettingsTeamUserFragmentDoc}`;

/**
 * __useGetClinicSettingsTeamUsersQuery__
 *
 * To run a query within a React component, call `useGetClinicSettingsTeamUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSettingsTeamUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSettingsTeamUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicSettingsTeamUsersQuery(baseOptions: Apollo.QueryHookOptions<GetClinicSettingsTeamUsersQuery, GetClinicSettingsTeamUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSettingsTeamUsersQuery, GetClinicSettingsTeamUsersQueryVariables>(GetClinicSettingsTeamUsersDocument, options);
      }
export function useGetClinicSettingsTeamUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSettingsTeamUsersQuery, GetClinicSettingsTeamUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSettingsTeamUsersQuery, GetClinicSettingsTeamUsersQueryVariables>(GetClinicSettingsTeamUsersDocument, options);
        }
export type GetClinicSettingsTeamUsersQueryHookResult = ReturnType<typeof useGetClinicSettingsTeamUsersQuery>;
export type GetClinicSettingsTeamUsersLazyQueryHookResult = ReturnType<typeof useGetClinicSettingsTeamUsersLazyQuery>;
export type GetClinicSettingsTeamUsersQueryResult = Apollo.QueryResult<GetClinicSettingsTeamUsersQuery, GetClinicSettingsTeamUsersQueryVariables>;
export function refetchGetClinicSettingsTeamUsersQuery(variables?: GetClinicSettingsTeamUsersQueryVariables) {
      return { query: GetClinicSettingsTeamUsersDocument, variables: variables }
    }
export const CreateOneClinicBlockedPhoneNumberDocument = gql`
    mutation createOneClinicBlockedPhoneNumber($data: ClinicBlockedPhoneNumberCreateInput!) {
  createOneClinicBlockedPhoneNumber(data: $data) {
    ...ClinicBlockedPhoneNumber
  }
}
    ${ClinicBlockedPhoneNumberFragmentDoc}`;
export type CreateOneClinicBlockedPhoneNumberMutationFn = Apollo.MutationFunction<CreateOneClinicBlockedPhoneNumberMutation, CreateOneClinicBlockedPhoneNumberMutationVariables>;

/**
 * __useCreateOneClinicBlockedPhoneNumberMutation__
 *
 * To run a mutation, you first call `useCreateOneClinicBlockedPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneClinicBlockedPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneClinicBlockedPhoneNumberMutation, { data, loading, error }] = useCreateOneClinicBlockedPhoneNumberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneClinicBlockedPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneClinicBlockedPhoneNumberMutation, CreateOneClinicBlockedPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneClinicBlockedPhoneNumberMutation, CreateOneClinicBlockedPhoneNumberMutationVariables>(CreateOneClinicBlockedPhoneNumberDocument, options);
      }
export type CreateOneClinicBlockedPhoneNumberMutationHookResult = ReturnType<typeof useCreateOneClinicBlockedPhoneNumberMutation>;
export type CreateOneClinicBlockedPhoneNumberMutationResult = Apollo.MutationResult<CreateOneClinicBlockedPhoneNumberMutation>;
export type CreateOneClinicBlockedPhoneNumberMutationOptions = Apollo.BaseMutationOptions<CreateOneClinicBlockedPhoneNumberMutation, CreateOneClinicBlockedPhoneNumberMutationVariables>;
export const FindManyClinicBlockedPhoneNumberDocument = gql`
    query findManyClinicBlockedPhoneNumber($where: ClinicBlockedPhoneNumberWhereInput) {
  findManyClinicBlockedPhoneNumber(where: $where) {
    ...ClinicBlockedPhoneNumber
  }
}
    ${ClinicBlockedPhoneNumberFragmentDoc}`;

/**
 * __useFindManyClinicBlockedPhoneNumberQuery__
 *
 * To run a query within a React component, call `useFindManyClinicBlockedPhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyClinicBlockedPhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyClinicBlockedPhoneNumberQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyClinicBlockedPhoneNumberQuery(baseOptions?: Apollo.QueryHookOptions<FindManyClinicBlockedPhoneNumberQuery, FindManyClinicBlockedPhoneNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyClinicBlockedPhoneNumberQuery, FindManyClinicBlockedPhoneNumberQueryVariables>(FindManyClinicBlockedPhoneNumberDocument, options);
      }
export function useFindManyClinicBlockedPhoneNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyClinicBlockedPhoneNumberQuery, FindManyClinicBlockedPhoneNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyClinicBlockedPhoneNumberQuery, FindManyClinicBlockedPhoneNumberQueryVariables>(FindManyClinicBlockedPhoneNumberDocument, options);
        }
export type FindManyClinicBlockedPhoneNumberQueryHookResult = ReturnType<typeof useFindManyClinicBlockedPhoneNumberQuery>;
export type FindManyClinicBlockedPhoneNumberLazyQueryHookResult = ReturnType<typeof useFindManyClinicBlockedPhoneNumberLazyQuery>;
export type FindManyClinicBlockedPhoneNumberQueryResult = Apollo.QueryResult<FindManyClinicBlockedPhoneNumberQuery, FindManyClinicBlockedPhoneNumberQueryVariables>;
export function refetchFindManyClinicBlockedPhoneNumberQuery(variables?: FindManyClinicBlockedPhoneNumberQueryVariables) {
      return { query: FindManyClinicBlockedPhoneNumberDocument, variables: variables }
    }
export const UpdateOneClinicBlockedPhoneNumberDocument = gql`
    mutation updateOneClinicBlockedPhoneNumber($data: ClinicBlockedPhoneNumberUpdateInput!, $where: ClinicBlockedPhoneNumberWhereUniqueInput!) {
  updateOneClinicBlockedPhoneNumber(data: $data, where: $where) {
    ...ClinicBlockedPhoneNumber
  }
}
    ${ClinicBlockedPhoneNumberFragmentDoc}`;
export type UpdateOneClinicBlockedPhoneNumberMutationFn = Apollo.MutationFunction<UpdateOneClinicBlockedPhoneNumberMutation, UpdateOneClinicBlockedPhoneNumberMutationVariables>;

/**
 * __useUpdateOneClinicBlockedPhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdateOneClinicBlockedPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneClinicBlockedPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneClinicBlockedPhoneNumberMutation, { data, loading, error }] = useUpdateOneClinicBlockedPhoneNumberMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneClinicBlockedPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneClinicBlockedPhoneNumberMutation, UpdateOneClinicBlockedPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneClinicBlockedPhoneNumberMutation, UpdateOneClinicBlockedPhoneNumberMutationVariables>(UpdateOneClinicBlockedPhoneNumberDocument, options);
      }
export type UpdateOneClinicBlockedPhoneNumberMutationHookResult = ReturnType<typeof useUpdateOneClinicBlockedPhoneNumberMutation>;
export type UpdateOneClinicBlockedPhoneNumberMutationResult = Apollo.MutationResult<UpdateOneClinicBlockedPhoneNumberMutation>;
export type UpdateOneClinicBlockedPhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdateOneClinicBlockedPhoneNumberMutation, UpdateOneClinicBlockedPhoneNumberMutationVariables>;
export const CreateOneClinicPhoneNumberDocument = gql`
    mutation createOneClinicPhoneNumber($data: ClinicPhoneNumberCreateInput!) {
  createOneClinicPhoneNumber(data: $data) {
    ...ClinicPhoneNumber
  }
}
    ${ClinicPhoneNumberFragmentDoc}`;
export type CreateOneClinicPhoneNumberMutationFn = Apollo.MutationFunction<CreateOneClinicPhoneNumberMutation, CreateOneClinicPhoneNumberMutationVariables>;

/**
 * __useCreateOneClinicPhoneNumberMutation__
 *
 * To run a mutation, you first call `useCreateOneClinicPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneClinicPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneClinicPhoneNumberMutation, { data, loading, error }] = useCreateOneClinicPhoneNumberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneClinicPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneClinicPhoneNumberMutation, CreateOneClinicPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneClinicPhoneNumberMutation, CreateOneClinicPhoneNumberMutationVariables>(CreateOneClinicPhoneNumberDocument, options);
      }
export type CreateOneClinicPhoneNumberMutationHookResult = ReturnType<typeof useCreateOneClinicPhoneNumberMutation>;
export type CreateOneClinicPhoneNumberMutationResult = Apollo.MutationResult<CreateOneClinicPhoneNumberMutation>;
export type CreateOneClinicPhoneNumberMutationOptions = Apollo.BaseMutationOptions<CreateOneClinicPhoneNumberMutation, CreateOneClinicPhoneNumberMutationVariables>;
export const OrderBandwidthPhoneNumberDocument = gql`
    mutation orderBandwidthPhoneNumber($data: OrderPhoneNumberInput!) {
  orderPhoneNumber(data: $data) {
    ...ClinicPhoneNumber
  }
}
    ${ClinicPhoneNumberFragmentDoc}`;
export type OrderBandwidthPhoneNumberMutationFn = Apollo.MutationFunction<OrderBandwidthPhoneNumberMutation, OrderBandwidthPhoneNumberMutationVariables>;

/**
 * __useOrderBandwidthPhoneNumberMutation__
 *
 * To run a mutation, you first call `useOrderBandwidthPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderBandwidthPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderBandwidthPhoneNumberMutation, { data, loading, error }] = useOrderBandwidthPhoneNumberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOrderBandwidthPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<OrderBandwidthPhoneNumberMutation, OrderBandwidthPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderBandwidthPhoneNumberMutation, OrderBandwidthPhoneNumberMutationVariables>(OrderBandwidthPhoneNumberDocument, options);
      }
export type OrderBandwidthPhoneNumberMutationHookResult = ReturnType<typeof useOrderBandwidthPhoneNumberMutation>;
export type OrderBandwidthPhoneNumberMutationResult = Apollo.MutationResult<OrderBandwidthPhoneNumberMutation>;
export type OrderBandwidthPhoneNumberMutationOptions = Apollo.BaseMutationOptions<OrderBandwidthPhoneNumberMutation, OrderBandwidthPhoneNumberMutationVariables>;
export const TwilioPurchaseNumberDocument = gql`
    mutation twilioPurchaseNumber($data: GenericClinicIdInput) {
  twilioPurchaseNumber(data: $data) {
    payload
    success
  }
}
    `;
export type TwilioPurchaseNumberMutationFn = Apollo.MutationFunction<TwilioPurchaseNumberMutation, TwilioPurchaseNumberMutationVariables>;

/**
 * __useTwilioPurchaseNumberMutation__
 *
 * To run a mutation, you first call `useTwilioPurchaseNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTwilioPurchaseNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [twilioPurchaseNumberMutation, { data, loading, error }] = useTwilioPurchaseNumberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTwilioPurchaseNumberMutation(baseOptions?: Apollo.MutationHookOptions<TwilioPurchaseNumberMutation, TwilioPurchaseNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TwilioPurchaseNumberMutation, TwilioPurchaseNumberMutationVariables>(TwilioPurchaseNumberDocument, options);
      }
export type TwilioPurchaseNumberMutationHookResult = ReturnType<typeof useTwilioPurchaseNumberMutation>;
export type TwilioPurchaseNumberMutationResult = Apollo.MutationResult<TwilioPurchaseNumberMutation>;
export type TwilioPurchaseNumberMutationOptions = Apollo.BaseMutationOptions<TwilioPurchaseNumberMutation, TwilioPurchaseNumberMutationVariables>;
export const RegisterTwilioSubaccountDocument = gql`
    mutation registerTwilioSubaccount($clinicId: String!, $accountOwnerEmail: String!, $accountOwnerPhone: String!, $accountOwnerFirstName: String!, $accountOwnerLastName: String!) {
  registerTwilioSubaccount(
    clinicId: $clinicId
    accountOwnerEmail: $accountOwnerEmail
    accountOwnerPhone: $accountOwnerPhone
    accountOwnerFirstName: $accountOwnerFirstName
    accountOwnerLastName: $accountOwnerLastName
  ) {
    payload
    success
  }
}
    `;
export type RegisterTwilioSubaccountMutationFn = Apollo.MutationFunction<RegisterTwilioSubaccountMutation, RegisterTwilioSubaccountMutationVariables>;

/**
 * __useRegisterTwilioSubaccountMutation__
 *
 * To run a mutation, you first call `useRegisterTwilioSubaccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterTwilioSubaccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerTwilioSubaccountMutation, { data, loading, error }] = useRegisterTwilioSubaccountMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      accountOwnerEmail: // value for 'accountOwnerEmail'
 *      accountOwnerPhone: // value for 'accountOwnerPhone'
 *      accountOwnerFirstName: // value for 'accountOwnerFirstName'
 *      accountOwnerLastName: // value for 'accountOwnerLastName'
 *   },
 * });
 */
export function useRegisterTwilioSubaccountMutation(baseOptions?: Apollo.MutationHookOptions<RegisterTwilioSubaccountMutation, RegisterTwilioSubaccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterTwilioSubaccountMutation, RegisterTwilioSubaccountMutationVariables>(RegisterTwilioSubaccountDocument, options);
      }
export type RegisterTwilioSubaccountMutationHookResult = ReturnType<typeof useRegisterTwilioSubaccountMutation>;
export type RegisterTwilioSubaccountMutationResult = Apollo.MutationResult<RegisterTwilioSubaccountMutation>;
export type RegisterTwilioSubaccountMutationOptions = Apollo.BaseMutationOptions<RegisterTwilioSubaccountMutation, RegisterTwilioSubaccountMutationVariables>;
export const RetryCampaignRegistrationDocument = gql`
    mutation retryCampaignRegistration($clinicId: String!) {
  retryTwilioCampaignRegistration(clinicId: $clinicId) {
    payload
    success
  }
}
    `;
export type RetryCampaignRegistrationMutationFn = Apollo.MutationFunction<RetryCampaignRegistrationMutation, RetryCampaignRegistrationMutationVariables>;

/**
 * __useRetryCampaignRegistrationMutation__
 *
 * To run a mutation, you first call `useRetryCampaignRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryCampaignRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryCampaignRegistrationMutation, { data, loading, error }] = useRetryCampaignRegistrationMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useRetryCampaignRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<RetryCampaignRegistrationMutation, RetryCampaignRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryCampaignRegistrationMutation, RetryCampaignRegistrationMutationVariables>(RetryCampaignRegistrationDocument, options);
      }
export type RetryCampaignRegistrationMutationHookResult = ReturnType<typeof useRetryCampaignRegistrationMutation>;
export type RetryCampaignRegistrationMutationResult = Apollo.MutationResult<RetryCampaignRegistrationMutation>;
export type RetryCampaignRegistrationMutationOptions = Apollo.BaseMutationOptions<RetryCampaignRegistrationMutation, RetryCampaignRegistrationMutationVariables>;
export const TwilioGetOrCreateHostedNumberOrderDocument = gql`
    mutation twilioGetOrCreateHostedNumberOrder($data: TwilioGetOrCreateHostedNumberOrderInput!) {
  twilioGetOrCreateHostedNumberOrder(data: $data) {
    orderId
    status
  }
}
    `;
export type TwilioGetOrCreateHostedNumberOrderMutationFn = Apollo.MutationFunction<TwilioGetOrCreateHostedNumberOrderMutation, TwilioGetOrCreateHostedNumberOrderMutationVariables>;

/**
 * __useTwilioGetOrCreateHostedNumberOrderMutation__
 *
 * To run a mutation, you first call `useTwilioGetOrCreateHostedNumberOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTwilioGetOrCreateHostedNumberOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [twilioGetOrCreateHostedNumberOrderMutation, { data, loading, error }] = useTwilioGetOrCreateHostedNumberOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTwilioGetOrCreateHostedNumberOrderMutation(baseOptions?: Apollo.MutationHookOptions<TwilioGetOrCreateHostedNumberOrderMutation, TwilioGetOrCreateHostedNumberOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TwilioGetOrCreateHostedNumberOrderMutation, TwilioGetOrCreateHostedNumberOrderMutationVariables>(TwilioGetOrCreateHostedNumberOrderDocument, options);
      }
export type TwilioGetOrCreateHostedNumberOrderMutationHookResult = ReturnType<typeof useTwilioGetOrCreateHostedNumberOrderMutation>;
export type TwilioGetOrCreateHostedNumberOrderMutationResult = Apollo.MutationResult<TwilioGetOrCreateHostedNumberOrderMutation>;
export type TwilioGetOrCreateHostedNumberOrderMutationOptions = Apollo.BaseMutationOptions<TwilioGetOrCreateHostedNumberOrderMutation, TwilioGetOrCreateHostedNumberOrderMutationVariables>;
export const TwilioGetOrGenerateLoaDocument = gql`
    mutation twilioGetOrGenerateLOA($data: TwilioGetOrGenerateLOAInput!) {
  twilioGetOrGenerateLOA(data: $data) {
    url
    status
    email
  }
}
    `;
export type TwilioGetOrGenerateLoaMutationFn = Apollo.MutationFunction<TwilioGetOrGenerateLoaMutation, TwilioGetOrGenerateLoaMutationVariables>;

/**
 * __useTwilioGetOrGenerateLoaMutation__
 *
 * To run a mutation, you first call `useTwilioGetOrGenerateLoaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTwilioGetOrGenerateLoaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [twilioGetOrGenerateLoaMutation, { data, loading, error }] = useTwilioGetOrGenerateLoaMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTwilioGetOrGenerateLoaMutation(baseOptions?: Apollo.MutationHookOptions<TwilioGetOrGenerateLoaMutation, TwilioGetOrGenerateLoaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TwilioGetOrGenerateLoaMutation, TwilioGetOrGenerateLoaMutationVariables>(TwilioGetOrGenerateLoaDocument, options);
      }
export type TwilioGetOrGenerateLoaMutationHookResult = ReturnType<typeof useTwilioGetOrGenerateLoaMutation>;
export type TwilioGetOrGenerateLoaMutationResult = Apollo.MutationResult<TwilioGetOrGenerateLoaMutation>;
export type TwilioGetOrGenerateLoaMutationOptions = Apollo.BaseMutationOptions<TwilioGetOrGenerateLoaMutation, TwilioGetOrGenerateLoaMutationVariables>;
export const UpdateClinicSettingsConversationsSmsDocument = gql`
    mutation updateClinicSettingsConversationsSms($where: ClinicWhereUniqueInput!, $data: ClinicUpdateInput!) {
  updateOneClinic(where: $where, data: $data) {
    id
    hasSmsConversations
  }
}
    `;
export type UpdateClinicSettingsConversationsSmsMutationFn = Apollo.MutationFunction<UpdateClinicSettingsConversationsSmsMutation, UpdateClinicSettingsConversationsSmsMutationVariables>;

/**
 * __useUpdateClinicSettingsConversationsSmsMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsConversationsSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsConversationsSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsConversationsSmsMutation, { data, loading, error }] = useUpdateClinicSettingsConversationsSmsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicSettingsConversationsSmsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsConversationsSmsMutation, UpdateClinicSettingsConversationsSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsConversationsSmsMutation, UpdateClinicSettingsConversationsSmsMutationVariables>(UpdateClinicSettingsConversationsSmsDocument, options);
      }
export type UpdateClinicSettingsConversationsSmsMutationHookResult = ReturnType<typeof useUpdateClinicSettingsConversationsSmsMutation>;
export type UpdateClinicSettingsConversationsSmsMutationResult = Apollo.MutationResult<UpdateClinicSettingsConversationsSmsMutation>;
export type UpdateClinicSettingsConversationsSmsMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsConversationsSmsMutation, UpdateClinicSettingsConversationsSmsMutationVariables>;
export const UpdateClinicSettingsConversationsSmsAutoResponseDocument = gql`
    mutation updateClinicSettingsConversationsSmsAutoResponse($where: ClinicSettingWhereUniqueInput!, $data: ClinicSettingUpdateInput!) {
  updateOneClinicSetting(where: $where, data: $data) {
    id
    smsAutoResponseWhenOpen
    smsAutoResponseWhenClosed
  }
}
    `;
export type UpdateClinicSettingsConversationsSmsAutoResponseMutationFn = Apollo.MutationFunction<UpdateClinicSettingsConversationsSmsAutoResponseMutation, UpdateClinicSettingsConversationsSmsAutoResponseMutationVariables>;

/**
 * __useUpdateClinicSettingsConversationsSmsAutoResponseMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsConversationsSmsAutoResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsConversationsSmsAutoResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsConversationsSmsAutoResponseMutation, { data, loading, error }] = useUpdateClinicSettingsConversationsSmsAutoResponseMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicSettingsConversationsSmsAutoResponseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsConversationsSmsAutoResponseMutation, UpdateClinicSettingsConversationsSmsAutoResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsConversationsSmsAutoResponseMutation, UpdateClinicSettingsConversationsSmsAutoResponseMutationVariables>(UpdateClinicSettingsConversationsSmsAutoResponseDocument, options);
      }
export type UpdateClinicSettingsConversationsSmsAutoResponseMutationHookResult = ReturnType<typeof useUpdateClinicSettingsConversationsSmsAutoResponseMutation>;
export type UpdateClinicSettingsConversationsSmsAutoResponseMutationResult = Apollo.MutationResult<UpdateClinicSettingsConversationsSmsAutoResponseMutation>;
export type UpdateClinicSettingsConversationsSmsAutoResponseMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsConversationsSmsAutoResponseMutation, UpdateClinicSettingsConversationsSmsAutoResponseMutationVariables>;
export const UpdateClinicSettingsConversationsTransferTwilioNumberDocument = gql`
    mutation updateClinicSettingsConversationsTransferTwilioNumber($phoneNumberSid: String!, $fromSubaccountSid: String) {
  transferTwilioNumber(
    data: {phoneNumberSid: $phoneNumberSid, fromSubaccountSid: $fromSubaccountSid}
  ) {
    success
    payload
  }
}
    `;
export type UpdateClinicSettingsConversationsTransferTwilioNumberMutationFn = Apollo.MutationFunction<UpdateClinicSettingsConversationsTransferTwilioNumberMutation, UpdateClinicSettingsConversationsTransferTwilioNumberMutationVariables>;

/**
 * __useUpdateClinicSettingsConversationsTransferTwilioNumberMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsConversationsTransferTwilioNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsConversationsTransferTwilioNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsConversationsTransferTwilioNumberMutation, { data, loading, error }] = useUpdateClinicSettingsConversationsTransferTwilioNumberMutation({
 *   variables: {
 *      phoneNumberSid: // value for 'phoneNumberSid'
 *      fromSubaccountSid: // value for 'fromSubaccountSid'
 *   },
 * });
 */
export function useUpdateClinicSettingsConversationsTransferTwilioNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsConversationsTransferTwilioNumberMutation, UpdateClinicSettingsConversationsTransferTwilioNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsConversationsTransferTwilioNumberMutation, UpdateClinicSettingsConversationsTransferTwilioNumberMutationVariables>(UpdateClinicSettingsConversationsTransferTwilioNumberDocument, options);
      }
export type UpdateClinicSettingsConversationsTransferTwilioNumberMutationHookResult = ReturnType<typeof useUpdateClinicSettingsConversationsTransferTwilioNumberMutation>;
export type UpdateClinicSettingsConversationsTransferTwilioNumberMutationResult = Apollo.MutationResult<UpdateClinicSettingsConversationsTransferTwilioNumberMutation>;
export type UpdateClinicSettingsConversationsTransferTwilioNumberMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsConversationsTransferTwilioNumberMutation, UpdateClinicSettingsConversationsTransferTwilioNumberMutationVariables>;
export const GetClinicPhoneNumbersDocument = gql`
    query getClinicPhoneNumbers($where: ClinicPhoneNumberWhereInput) {
  findManyClinicPhoneNumber(where: $where, orderBy: {createdAt: desc}) {
    ...ClinicPhoneNumber
  }
}
    ${ClinicPhoneNumberFragmentDoc}`;

/**
 * __useGetClinicPhoneNumbersQuery__
 *
 * To run a query within a React component, call `useGetClinicPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicPhoneNumbersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicPhoneNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicPhoneNumbersQuery, GetClinicPhoneNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicPhoneNumbersQuery, GetClinicPhoneNumbersQueryVariables>(GetClinicPhoneNumbersDocument, options);
      }
export function useGetClinicPhoneNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicPhoneNumbersQuery, GetClinicPhoneNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicPhoneNumbersQuery, GetClinicPhoneNumbersQueryVariables>(GetClinicPhoneNumbersDocument, options);
        }
export type GetClinicPhoneNumbersQueryHookResult = ReturnType<typeof useGetClinicPhoneNumbersQuery>;
export type GetClinicPhoneNumbersLazyQueryHookResult = ReturnType<typeof useGetClinicPhoneNumbersLazyQuery>;
export type GetClinicPhoneNumbersQueryResult = Apollo.QueryResult<GetClinicPhoneNumbersQuery, GetClinicPhoneNumbersQueryVariables>;
export function refetchGetClinicPhoneNumbersQuery(variables?: GetClinicPhoneNumbersQueryVariables) {
      return { query: GetClinicPhoneNumbersDocument, variables: variables }
    }
export const GetClinicSettingsConversationsAllActiveTwilioNumbersDocument = gql`
    query getClinicSettingsConversationsAllActiveTwilioNumbers {
  getTwilioNumbers {
    success
    payload
  }
}
    `;

/**
 * __useGetClinicSettingsConversationsAllActiveTwilioNumbersQuery__
 *
 * To run a query within a React component, call `useGetClinicSettingsConversationsAllActiveTwilioNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSettingsConversationsAllActiveTwilioNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSettingsConversationsAllActiveTwilioNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClinicSettingsConversationsAllActiveTwilioNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicSettingsConversationsAllActiveTwilioNumbersQuery, GetClinicSettingsConversationsAllActiveTwilioNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSettingsConversationsAllActiveTwilioNumbersQuery, GetClinicSettingsConversationsAllActiveTwilioNumbersQueryVariables>(GetClinicSettingsConversationsAllActiveTwilioNumbersDocument, options);
      }
export function useGetClinicSettingsConversationsAllActiveTwilioNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSettingsConversationsAllActiveTwilioNumbersQuery, GetClinicSettingsConversationsAllActiveTwilioNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSettingsConversationsAllActiveTwilioNumbersQuery, GetClinicSettingsConversationsAllActiveTwilioNumbersQueryVariables>(GetClinicSettingsConversationsAllActiveTwilioNumbersDocument, options);
        }
export type GetClinicSettingsConversationsAllActiveTwilioNumbersQueryHookResult = ReturnType<typeof useGetClinicSettingsConversationsAllActiveTwilioNumbersQuery>;
export type GetClinicSettingsConversationsAllActiveTwilioNumbersLazyQueryHookResult = ReturnType<typeof useGetClinicSettingsConversationsAllActiveTwilioNumbersLazyQuery>;
export type GetClinicSettingsConversationsAllActiveTwilioNumbersQueryResult = Apollo.QueryResult<GetClinicSettingsConversationsAllActiveTwilioNumbersQuery, GetClinicSettingsConversationsAllActiveTwilioNumbersQueryVariables>;
export function refetchGetClinicSettingsConversationsAllActiveTwilioNumbersQuery(variables?: GetClinicSettingsConversationsAllActiveTwilioNumbersQueryVariables) {
      return { query: GetClinicSettingsConversationsAllActiveTwilioNumbersDocument, variables: variables }
    }
export const GetClinicSettingsConversationsSmsDocument = gql`
    query getClinicSettingsConversationsSms($id: String, $clinicId: ID!) {
  findUniqueClinic(where: {id: $id}) {
    id
    hasSmsConversations
    twilioConfiguration {
      id
      subaccountSid
      messagingServiceSid
    }
    clinicSetting {
      id
      smsAutoResponseWhenOpen
      smsAutoResponseWhenClosed
    }
  }
  getTwilioNumbers(data: {clinicId: $clinicId}) {
    success
    payload
  }
}
    `;

/**
 * __useGetClinicSettingsConversationsSmsQuery__
 *
 * To run a query within a React component, call `useGetClinicSettingsConversationsSmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSettingsConversationsSmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSettingsConversationsSmsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicSettingsConversationsSmsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicSettingsConversationsSmsQuery, GetClinicSettingsConversationsSmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSettingsConversationsSmsQuery, GetClinicSettingsConversationsSmsQueryVariables>(GetClinicSettingsConversationsSmsDocument, options);
      }
export function useGetClinicSettingsConversationsSmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSettingsConversationsSmsQuery, GetClinicSettingsConversationsSmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSettingsConversationsSmsQuery, GetClinicSettingsConversationsSmsQueryVariables>(GetClinicSettingsConversationsSmsDocument, options);
        }
export type GetClinicSettingsConversationsSmsQueryHookResult = ReturnType<typeof useGetClinicSettingsConversationsSmsQuery>;
export type GetClinicSettingsConversationsSmsLazyQueryHookResult = ReturnType<typeof useGetClinicSettingsConversationsSmsLazyQuery>;
export type GetClinicSettingsConversationsSmsQueryResult = Apollo.QueryResult<GetClinicSettingsConversationsSmsQuery, GetClinicSettingsConversationsSmsQueryVariables>;
export function refetchGetClinicSettingsConversationsSmsQuery(variables?: GetClinicSettingsConversationsSmsQueryVariables) {
      return { query: GetClinicSettingsConversationsSmsDocument, variables: variables }
    }
export const SearchAvailableBandwidthNumbersDocument = gql`
    query searchAvailableBandwidthNumbers($data: SearchPhoneNumberInput) {
  searchPhoneNumber(data: $data) {
    total
    phoneNumbers
  }
}
    `;

/**
 * __useSearchAvailableBandwidthNumbersQuery__
 *
 * To run a query within a React component, call `useSearchAvailableBandwidthNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAvailableBandwidthNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAvailableBandwidthNumbersQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSearchAvailableBandwidthNumbersQuery(baseOptions?: Apollo.QueryHookOptions<SearchAvailableBandwidthNumbersQuery, SearchAvailableBandwidthNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAvailableBandwidthNumbersQuery, SearchAvailableBandwidthNumbersQueryVariables>(SearchAvailableBandwidthNumbersDocument, options);
      }
export function useSearchAvailableBandwidthNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAvailableBandwidthNumbersQuery, SearchAvailableBandwidthNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAvailableBandwidthNumbersQuery, SearchAvailableBandwidthNumbersQueryVariables>(SearchAvailableBandwidthNumbersDocument, options);
        }
export type SearchAvailableBandwidthNumbersQueryHookResult = ReturnType<typeof useSearchAvailableBandwidthNumbersQuery>;
export type SearchAvailableBandwidthNumbersLazyQueryHookResult = ReturnType<typeof useSearchAvailableBandwidthNumbersLazyQuery>;
export type SearchAvailableBandwidthNumbersQueryResult = Apollo.QueryResult<SearchAvailableBandwidthNumbersQuery, SearchAvailableBandwidthNumbersQueryVariables>;
export function refetchSearchAvailableBandwidthNumbersQuery(variables?: SearchAvailableBandwidthNumbersQueryVariables) {
      return { query: SearchAvailableBandwidthNumbersDocument, variables: variables }
    }
export const TwilioA2PRegistrationStatusDocument = gql`
    query twilioA2PRegistrationStatus($clinicId: String!) {
  twilioA2PRegistrationStatus(clinicId: $clinicId) {
    payload
    success
  }
}
    `;

/**
 * __useTwilioA2PRegistrationStatusQuery__
 *
 * To run a query within a React component, call `useTwilioA2PRegistrationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTwilioA2PRegistrationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTwilioA2PRegistrationStatusQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useTwilioA2PRegistrationStatusQuery(baseOptions: Apollo.QueryHookOptions<TwilioA2PRegistrationStatusQuery, TwilioA2PRegistrationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TwilioA2PRegistrationStatusQuery, TwilioA2PRegistrationStatusQueryVariables>(TwilioA2PRegistrationStatusDocument, options);
      }
export function useTwilioA2PRegistrationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TwilioA2PRegistrationStatusQuery, TwilioA2PRegistrationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TwilioA2PRegistrationStatusQuery, TwilioA2PRegistrationStatusQueryVariables>(TwilioA2PRegistrationStatusDocument, options);
        }
export type TwilioA2PRegistrationStatusQueryHookResult = ReturnType<typeof useTwilioA2PRegistrationStatusQuery>;
export type TwilioA2PRegistrationStatusLazyQueryHookResult = ReturnType<typeof useTwilioA2PRegistrationStatusLazyQuery>;
export type TwilioA2PRegistrationStatusQueryResult = Apollo.QueryResult<TwilioA2PRegistrationStatusQuery, TwilioA2PRegistrationStatusQueryVariables>;
export function refetchTwilioA2PRegistrationStatusQuery(variables?: TwilioA2PRegistrationStatusQueryVariables) {
      return { query: TwilioA2PRegistrationStatusDocument, variables: variables }
    }
export const TwilioEligibilityCheckDocument = gql`
    query twilioEligibilityCheck($data: TwilioEligibilityCheckInput!) {
  twilioEligibilityCheck(data: $data) {
    success
    payload
  }
}
    `;

/**
 * __useTwilioEligibilityCheckQuery__
 *
 * To run a query within a React component, call `useTwilioEligibilityCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useTwilioEligibilityCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTwilioEligibilityCheckQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTwilioEligibilityCheckQuery(baseOptions: Apollo.QueryHookOptions<TwilioEligibilityCheckQuery, TwilioEligibilityCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TwilioEligibilityCheckQuery, TwilioEligibilityCheckQueryVariables>(TwilioEligibilityCheckDocument, options);
      }
export function useTwilioEligibilityCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TwilioEligibilityCheckQuery, TwilioEligibilityCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TwilioEligibilityCheckQuery, TwilioEligibilityCheckQueryVariables>(TwilioEligibilityCheckDocument, options);
        }
export type TwilioEligibilityCheckQueryHookResult = ReturnType<typeof useTwilioEligibilityCheckQuery>;
export type TwilioEligibilityCheckLazyQueryHookResult = ReturnType<typeof useTwilioEligibilityCheckLazyQuery>;
export type TwilioEligibilityCheckQueryResult = Apollo.QueryResult<TwilioEligibilityCheckQuery, TwilioEligibilityCheckQueryVariables>;
export function refetchTwilioEligibilityCheckQuery(variables?: TwilioEligibilityCheckQueryVariables) {
      return { query: TwilioEligibilityCheckDocument, variables: variables }
    }
export const UpdateOneClinicPhoneNumberDocument = gql`
    mutation updateOneClinicPhoneNumber($where: ClinicPhoneNumberWhereUniqueInput!, $data: ClinicPhoneNumberUpdateInput!) {
  updateOneClinicPhoneNumber(where: $where, data: $data) {
    ...ClinicPhoneNumber
  }
}
    ${ClinicPhoneNumberFragmentDoc}`;
export type UpdateOneClinicPhoneNumberMutationFn = Apollo.MutationFunction<UpdateOneClinicPhoneNumberMutation, UpdateOneClinicPhoneNumberMutationVariables>;

/**
 * __useUpdateOneClinicPhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdateOneClinicPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneClinicPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneClinicPhoneNumberMutation, { data, loading, error }] = useUpdateOneClinicPhoneNumberMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneClinicPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneClinicPhoneNumberMutation, UpdateOneClinicPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneClinicPhoneNumberMutation, UpdateOneClinicPhoneNumberMutationVariables>(UpdateOneClinicPhoneNumberDocument, options);
      }
export type UpdateOneClinicPhoneNumberMutationHookResult = ReturnType<typeof useUpdateOneClinicPhoneNumberMutation>;
export type UpdateOneClinicPhoneNumberMutationResult = Apollo.MutationResult<UpdateOneClinicPhoneNumberMutation>;
export type UpdateOneClinicPhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdateOneClinicPhoneNumberMutation, UpdateOneClinicPhoneNumberMutationVariables>;
export const SubscribeToClinicPhoneNumbersDocument = gql`
    subscription subscribeToClinicPhoneNumbers($where: ClinicPhoneNumberWhereInput!) {
  clinicPhoneNumberChanged(where: $where) {
    node {
      ...ClinicPhoneNumber
    }
    mutation
  }
}
    ${ClinicPhoneNumberFragmentDoc}`;

/**
 * __useSubscribeToClinicPhoneNumbersSubscription__
 *
 * To run a query within a React component, call `useSubscribeToClinicPhoneNumbersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToClinicPhoneNumbersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToClinicPhoneNumbersSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToClinicPhoneNumbersSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToClinicPhoneNumbersSubscription, SubscribeToClinicPhoneNumbersSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToClinicPhoneNumbersSubscription, SubscribeToClinicPhoneNumbersSubscriptionVariables>(SubscribeToClinicPhoneNumbersDocument, options);
      }
export type SubscribeToClinicPhoneNumbersSubscriptionHookResult = ReturnType<typeof useSubscribeToClinicPhoneNumbersSubscription>;
export type SubscribeToClinicPhoneNumbersSubscriptionResult = Apollo.SubscriptionResult<SubscribeToClinicPhoneNumbersSubscription>;
export const SendWidgetCodeToDeveloperDocument = gql`
    mutation sendWidgetCodeToDeveloper($data: SendWidgetCodeToDeveloperInput!) {
  sendWidgetCodeToDeveloper(data: $data) {
    success
  }
}
    `;
export type SendWidgetCodeToDeveloperMutationFn = Apollo.MutationFunction<SendWidgetCodeToDeveloperMutation, SendWidgetCodeToDeveloperMutationVariables>;

/**
 * __useSendWidgetCodeToDeveloperMutation__
 *
 * To run a mutation, you first call `useSendWidgetCodeToDeveloperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendWidgetCodeToDeveloperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendWidgetCodeToDeveloperMutation, { data, loading, error }] = useSendWidgetCodeToDeveloperMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendWidgetCodeToDeveloperMutation(baseOptions?: Apollo.MutationHookOptions<SendWidgetCodeToDeveloperMutation, SendWidgetCodeToDeveloperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendWidgetCodeToDeveloperMutation, SendWidgetCodeToDeveloperMutationVariables>(SendWidgetCodeToDeveloperDocument, options);
      }
export type SendWidgetCodeToDeveloperMutationHookResult = ReturnType<typeof useSendWidgetCodeToDeveloperMutation>;
export type SendWidgetCodeToDeveloperMutationResult = Apollo.MutationResult<SendWidgetCodeToDeveloperMutation>;
export type SendWidgetCodeToDeveloperMutationOptions = Apollo.BaseMutationOptions<SendWidgetCodeToDeveloperMutation, SendWidgetCodeToDeveloperMutationVariables>;
export const SoftDeleteClinicSettingsConnectWidgetFormTemplateDocument = gql`
    mutation softDeleteClinicSettingsConnectWidgetFormTemplate($where: FormTemplateWhereUniqueInput!) {
  updateOneFormTemplate(where: $where, data: {isDeleted: true, isActive: false}) {
    id
  }
}
    `;
export type SoftDeleteClinicSettingsConnectWidgetFormTemplateMutationFn = Apollo.MutationFunction<SoftDeleteClinicSettingsConnectWidgetFormTemplateMutation, SoftDeleteClinicSettingsConnectWidgetFormTemplateMutationVariables>;

/**
 * __useSoftDeleteClinicSettingsConnectWidgetFormTemplateMutation__
 *
 * To run a mutation, you first call `useSoftDeleteClinicSettingsConnectWidgetFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteClinicSettingsConnectWidgetFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteClinicSettingsConnectWidgetFormTemplateMutation, { data, loading, error }] = useSoftDeleteClinicSettingsConnectWidgetFormTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSoftDeleteClinicSettingsConnectWidgetFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteClinicSettingsConnectWidgetFormTemplateMutation, SoftDeleteClinicSettingsConnectWidgetFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteClinicSettingsConnectWidgetFormTemplateMutation, SoftDeleteClinicSettingsConnectWidgetFormTemplateMutationVariables>(SoftDeleteClinicSettingsConnectWidgetFormTemplateDocument, options);
      }
export type SoftDeleteClinicSettingsConnectWidgetFormTemplateMutationHookResult = ReturnType<typeof useSoftDeleteClinicSettingsConnectWidgetFormTemplateMutation>;
export type SoftDeleteClinicSettingsConnectWidgetFormTemplateMutationResult = Apollo.MutationResult<SoftDeleteClinicSettingsConnectWidgetFormTemplateMutation>;
export type SoftDeleteClinicSettingsConnectWidgetFormTemplateMutationOptions = Apollo.BaseMutationOptions<SoftDeleteClinicSettingsConnectWidgetFormTemplateMutation, SoftDeleteClinicSettingsConnectWidgetFormTemplateMutationVariables>;
export const UpdateClinicSettingsConnectWidgetDocument = gql`
    mutation updateClinicSettingsConnectWidget($where: ClinicWhereUniqueInput!, $data: ClinicUpdateInput!) {
  updateOneClinic(where: $where, data: $data) {
    id
  }
}
    `;
export type UpdateClinicSettingsConnectWidgetMutationFn = Apollo.MutationFunction<UpdateClinicSettingsConnectWidgetMutation, UpdateClinicSettingsConnectWidgetMutationVariables>;

/**
 * __useUpdateClinicSettingsConnectWidgetMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSettingsConnectWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSettingsConnectWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSettingsConnectWidgetMutation, { data, loading, error }] = useUpdateClinicSettingsConnectWidgetMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicSettingsConnectWidgetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSettingsConnectWidgetMutation, UpdateClinicSettingsConnectWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSettingsConnectWidgetMutation, UpdateClinicSettingsConnectWidgetMutationVariables>(UpdateClinicSettingsConnectWidgetDocument, options);
      }
export type UpdateClinicSettingsConnectWidgetMutationHookResult = ReturnType<typeof useUpdateClinicSettingsConnectWidgetMutation>;
export type UpdateClinicSettingsConnectWidgetMutationResult = Apollo.MutationResult<UpdateClinicSettingsConnectWidgetMutation>;
export type UpdateClinicSettingsConnectWidgetMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSettingsConnectWidgetMutation, UpdateClinicSettingsConnectWidgetMutationVariables>;
export const GetClinicSettingsConnectWidgetDocument = gql`
    query getClinicSettingsConnectWidget($where: ClinicWhereUniqueInput!) {
  findUniqueClinic(where: $where) {
    clinicWidgetSetting {
      id
      isEnabled
      welcomeMessage
      primaryColor
      secondaryColor
      whiteLabelUrls
      ...ConnectSettingsClinicWidgetSetting
    }
  }
}
    ${ConnectSettingsClinicWidgetSettingFragmentDoc}`;

/**
 * __useGetClinicSettingsConnectWidgetQuery__
 *
 * To run a query within a React component, call `useGetClinicSettingsConnectWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSettingsConnectWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSettingsConnectWidgetQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicSettingsConnectWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetClinicSettingsConnectWidgetQuery, GetClinicSettingsConnectWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSettingsConnectWidgetQuery, GetClinicSettingsConnectWidgetQueryVariables>(GetClinicSettingsConnectWidgetDocument, options);
      }
export function useGetClinicSettingsConnectWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSettingsConnectWidgetQuery, GetClinicSettingsConnectWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSettingsConnectWidgetQuery, GetClinicSettingsConnectWidgetQueryVariables>(GetClinicSettingsConnectWidgetDocument, options);
        }
export type GetClinicSettingsConnectWidgetQueryHookResult = ReturnType<typeof useGetClinicSettingsConnectWidgetQuery>;
export type GetClinicSettingsConnectWidgetLazyQueryHookResult = ReturnType<typeof useGetClinicSettingsConnectWidgetLazyQuery>;
export type GetClinicSettingsConnectWidgetQueryResult = Apollo.QueryResult<GetClinicSettingsConnectWidgetQuery, GetClinicSettingsConnectWidgetQueryVariables>;
export function refetchGetClinicSettingsConnectWidgetQuery(variables?: GetClinicSettingsConnectWidgetQueryVariables) {
      return { query: GetClinicSettingsConnectWidgetDocument, variables: variables }
    }
export const GetClinicSettingsConnectWidgetRequestOptionsDocument = gql`
    query getClinicSettingsConnectWidgetRequestOptions($where: ClinicWhereUniqueInput!) {
  findUniqueClinic(where: $where) {
    clinicWidgetSetting {
      id
      ...ConnectSettingsClinicWidgetSetting
    }
  }
}
    ${ConnectSettingsClinicWidgetSettingFragmentDoc}`;

/**
 * __useGetClinicSettingsConnectWidgetRequestOptionsQuery__
 *
 * To run a query within a React component, call `useGetClinicSettingsConnectWidgetRequestOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSettingsConnectWidgetRequestOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSettingsConnectWidgetRequestOptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicSettingsConnectWidgetRequestOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicSettingsConnectWidgetRequestOptionsQuery, GetClinicSettingsConnectWidgetRequestOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSettingsConnectWidgetRequestOptionsQuery, GetClinicSettingsConnectWidgetRequestOptionsQueryVariables>(GetClinicSettingsConnectWidgetRequestOptionsDocument, options);
      }
export function useGetClinicSettingsConnectWidgetRequestOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSettingsConnectWidgetRequestOptionsQuery, GetClinicSettingsConnectWidgetRequestOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSettingsConnectWidgetRequestOptionsQuery, GetClinicSettingsConnectWidgetRequestOptionsQueryVariables>(GetClinicSettingsConnectWidgetRequestOptionsDocument, options);
        }
export type GetClinicSettingsConnectWidgetRequestOptionsQueryHookResult = ReturnType<typeof useGetClinicSettingsConnectWidgetRequestOptionsQuery>;
export type GetClinicSettingsConnectWidgetRequestOptionsLazyQueryHookResult = ReturnType<typeof useGetClinicSettingsConnectWidgetRequestOptionsLazyQuery>;
export type GetClinicSettingsConnectWidgetRequestOptionsQueryResult = Apollo.QueryResult<GetClinicSettingsConnectWidgetRequestOptionsQuery, GetClinicSettingsConnectWidgetRequestOptionsQueryVariables>;
export function refetchGetClinicSettingsConnectWidgetRequestOptionsQuery(variables?: GetClinicSettingsConnectWidgetRequestOptionsQueryVariables) {
      return { query: GetClinicSettingsConnectWidgetRequestOptionsDocument, variables: variables }
    }
export const GetFormTemplateContentDocument = gql`
    query getFormTemplateContent($formTemplateId: String!) {
  findUniqueFormTemplate(where: {id: $formTemplateId}) {
    id
    content
  }
}
    `;

/**
 * __useGetFormTemplateContentQuery__
 *
 * To run a query within a React component, call `useGetFormTemplateContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormTemplateContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormTemplateContentQuery({
 *   variables: {
 *      formTemplateId: // value for 'formTemplateId'
 *   },
 * });
 */
export function useGetFormTemplateContentQuery(baseOptions: Apollo.QueryHookOptions<GetFormTemplateContentQuery, GetFormTemplateContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormTemplateContentQuery, GetFormTemplateContentQueryVariables>(GetFormTemplateContentDocument, options);
      }
export function useGetFormTemplateContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormTemplateContentQuery, GetFormTemplateContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormTemplateContentQuery, GetFormTemplateContentQueryVariables>(GetFormTemplateContentDocument, options);
        }
export type GetFormTemplateContentQueryHookResult = ReturnType<typeof useGetFormTemplateContentQuery>;
export type GetFormTemplateContentLazyQueryHookResult = ReturnType<typeof useGetFormTemplateContentLazyQuery>;
export type GetFormTemplateContentQueryResult = Apollo.QueryResult<GetFormTemplateContentQuery, GetFormTemplateContentQueryVariables>;
export function refetchGetFormTemplateContentQuery(variables?: GetFormTemplateContentQueryVariables) {
      return { query: GetFormTemplateContentDocument, variables: variables }
    }
export const RetrieveAuthTokenForContactDocument = gql`
    query retrieveAuthTokenForContact {
  retrieveAuthTokenForContact {
    authToken
  }
}
    `;

/**
 * __useRetrieveAuthTokenForContactQuery__
 *
 * To run a query within a React component, call `useRetrieveAuthTokenForContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAuthTokenForContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveAuthTokenForContactQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetrieveAuthTokenForContactQuery(baseOptions?: Apollo.QueryHookOptions<RetrieveAuthTokenForContactQuery, RetrieveAuthTokenForContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetrieveAuthTokenForContactQuery, RetrieveAuthTokenForContactQueryVariables>(RetrieveAuthTokenForContactDocument, options);
      }
export function useRetrieveAuthTokenForContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetrieveAuthTokenForContactQuery, RetrieveAuthTokenForContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetrieveAuthTokenForContactQuery, RetrieveAuthTokenForContactQueryVariables>(RetrieveAuthTokenForContactDocument, options);
        }
export type RetrieveAuthTokenForContactQueryHookResult = ReturnType<typeof useRetrieveAuthTokenForContactQuery>;
export type RetrieveAuthTokenForContactLazyQueryHookResult = ReturnType<typeof useRetrieveAuthTokenForContactLazyQuery>;
export type RetrieveAuthTokenForContactQueryResult = Apollo.QueryResult<RetrieveAuthTokenForContactQuery, RetrieveAuthTokenForContactQueryVariables>;
export function refetchRetrieveAuthTokenForContactQuery(variables?: RetrieveAuthTokenForContactQueryVariables) {
      return { query: RetrieveAuthTokenForContactDocument, variables: variables }
    }
export const CreateSurveyChannelStatusDocument = gql`
    mutation createSurveyChannelStatus($data: ChannelStatusCreateInput!) {
  createOneChannelStatus(data: $data) {
    ...ClinicSettingsConversationsChannelStatus
  }
}
    ${ClinicSettingsConversationsChannelStatusFragmentDoc}`;
export type CreateSurveyChannelStatusMutationFn = Apollo.MutationFunction<CreateSurveyChannelStatusMutation, CreateSurveyChannelStatusMutationVariables>;

/**
 * __useCreateSurveyChannelStatusMutation__
 *
 * To run a mutation, you first call `useCreateSurveyChannelStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyChannelStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyChannelStatusMutation, { data, loading, error }] = useCreateSurveyChannelStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSurveyChannelStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveyChannelStatusMutation, CreateSurveyChannelStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveyChannelStatusMutation, CreateSurveyChannelStatusMutationVariables>(CreateSurveyChannelStatusDocument, options);
      }
export type CreateSurveyChannelStatusMutationHookResult = ReturnType<typeof useCreateSurveyChannelStatusMutation>;
export type CreateSurveyChannelStatusMutationResult = Apollo.MutationResult<CreateSurveyChannelStatusMutation>;
export type CreateSurveyChannelStatusMutationOptions = Apollo.BaseMutationOptions<CreateSurveyChannelStatusMutation, CreateSurveyChannelStatusMutationVariables>;
export const InitSurveySettingDocument = gql`
    mutation initSurveySetting($clinicId: String!) {
  initSurveySetting(clinicId: $clinicId) {
    id
  }
}
    `;
export type InitSurveySettingMutationFn = Apollo.MutationFunction<InitSurveySettingMutation, InitSurveySettingMutationVariables>;

/**
 * __useInitSurveySettingMutation__
 *
 * To run a mutation, you first call `useInitSurveySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitSurveySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initSurveySettingMutation, { data, loading, error }] = useInitSurveySettingMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useInitSurveySettingMutation(baseOptions?: Apollo.MutationHookOptions<InitSurveySettingMutation, InitSurveySettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitSurveySettingMutation, InitSurveySettingMutationVariables>(InitSurveySettingDocument, options);
      }
export type InitSurveySettingMutationHookResult = ReturnType<typeof useInitSurveySettingMutation>;
export type InitSurveySettingMutationResult = Apollo.MutationResult<InitSurveySettingMutation>;
export type InitSurveySettingMutationOptions = Apollo.BaseMutationOptions<InitSurveySettingMutation, InitSurveySettingMutationVariables>;
export const UpdateSurveyGeneralSettingsDocument = gql`
    mutation updateSurveyGeneralSettings($where: SurveySettingWhereUniqueInput!, $data: SurveySettingUpdateInput!) {
  updateOneSurveySetting(data: $data, where: $where) {
    id
    isAutomatedTriggerForAllAppointmentTypes
    frequencyInDays
    showLinkToLeaveReviewNeutral
    showLinkToLeaveReviewSatisfied
    linkToLeaveReview
  }
}
    `;
export type UpdateSurveyGeneralSettingsMutationFn = Apollo.MutationFunction<UpdateSurveyGeneralSettingsMutation, UpdateSurveyGeneralSettingsMutationVariables>;

/**
 * __useUpdateSurveyGeneralSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyGeneralSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyGeneralSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyGeneralSettingsMutation, { data, loading, error }] = useUpdateSurveyGeneralSettingsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSurveyGeneralSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyGeneralSettingsMutation, UpdateSurveyGeneralSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyGeneralSettingsMutation, UpdateSurveyGeneralSettingsMutationVariables>(UpdateSurveyGeneralSettingsDocument, options);
      }
export type UpdateSurveyGeneralSettingsMutationHookResult = ReturnType<typeof useUpdateSurveyGeneralSettingsMutation>;
export type UpdateSurveyGeneralSettingsMutationResult = Apollo.MutationResult<UpdateSurveyGeneralSettingsMutation>;
export type UpdateSurveyGeneralSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyGeneralSettingsMutation, UpdateSurveyGeneralSettingsMutationVariables>;
export const UpsertSurveyAppointmentTypeSettingsDocument = gql`
    mutation upsertSurveyAppointmentTypeSettings($where: SurveyAppointmentTypeSettingWhereUniqueInput!, $create: SurveyAppointmentTypeSettingCreateInput!, $update: SurveyAppointmentTypeSettingUpdateInput!) {
  upsertOneSurveyAppointmentTypeSetting(
    create: $create
    update: $update
    where: $where
  ) {
    id
    isActive
    automatedTriggerInMinutes
    surveySettingId
  }
}
    `;
export type UpsertSurveyAppointmentTypeSettingsMutationFn = Apollo.MutationFunction<UpsertSurveyAppointmentTypeSettingsMutation, UpsertSurveyAppointmentTypeSettingsMutationVariables>;

/**
 * __useUpsertSurveyAppointmentTypeSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertSurveyAppointmentTypeSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSurveyAppointmentTypeSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSurveyAppointmentTypeSettingsMutation, { data, loading, error }] = useUpsertSurveyAppointmentTypeSettingsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      create: // value for 'create'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpsertSurveyAppointmentTypeSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSurveyAppointmentTypeSettingsMutation, UpsertSurveyAppointmentTypeSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSurveyAppointmentTypeSettingsMutation, UpsertSurveyAppointmentTypeSettingsMutationVariables>(UpsertSurveyAppointmentTypeSettingsDocument, options);
      }
export type UpsertSurveyAppointmentTypeSettingsMutationHookResult = ReturnType<typeof useUpsertSurveyAppointmentTypeSettingsMutation>;
export type UpsertSurveyAppointmentTypeSettingsMutationResult = Apollo.MutationResult<UpsertSurveyAppointmentTypeSettingsMutation>;
export type UpsertSurveyAppointmentTypeSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertSurveyAppointmentTypeSettingsMutation, UpsertSurveyAppointmentTypeSettingsMutationVariables>;
export const GetDefaultSurveyStatusesDocument = gql`
    query getDefaultSurveyStatuses($clinicSettingId: String!, $positiveStatusNames: [String!], $negativeStatusNames: [String!], $sentStatusNames: [String!]) {
  positiveStatus: findFirstChannelStatus(
    where: {name: {in: $positiveStatusNames}, clinicSettingId: {equals: $clinicSettingId}}
  ) {
    id
    name
  }
  negativeStatus: findFirstChannelStatus(
    where: {name: {in: $negativeStatusNames}, clinicSettingId: {equals: $clinicSettingId}}
  ) {
    id
    name
  }
  sentStatus: findFirstChannelStatus(
    where: {name: {in: $sentStatusNames}, clinicSettingId: {equals: $clinicSettingId}}
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetDefaultSurveyStatusesQuery__
 *
 * To run a query within a React component, call `useGetDefaultSurveyStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultSurveyStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultSurveyStatusesQuery({
 *   variables: {
 *      clinicSettingId: // value for 'clinicSettingId'
 *      positiveStatusNames: // value for 'positiveStatusNames'
 *      negativeStatusNames: // value for 'negativeStatusNames'
 *      sentStatusNames: // value for 'sentStatusNames'
 *   },
 * });
 */
export function useGetDefaultSurveyStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetDefaultSurveyStatusesQuery, GetDefaultSurveyStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultSurveyStatusesQuery, GetDefaultSurveyStatusesQueryVariables>(GetDefaultSurveyStatusesDocument, options);
      }
export function useGetDefaultSurveyStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultSurveyStatusesQuery, GetDefaultSurveyStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultSurveyStatusesQuery, GetDefaultSurveyStatusesQueryVariables>(GetDefaultSurveyStatusesDocument, options);
        }
export type GetDefaultSurveyStatusesQueryHookResult = ReturnType<typeof useGetDefaultSurveyStatusesQuery>;
export type GetDefaultSurveyStatusesLazyQueryHookResult = ReturnType<typeof useGetDefaultSurveyStatusesLazyQuery>;
export type GetDefaultSurveyStatusesQueryResult = Apollo.QueryResult<GetDefaultSurveyStatusesQuery, GetDefaultSurveyStatusesQueryVariables>;
export function refetchGetDefaultSurveyStatusesQuery(variables?: GetDefaultSurveyStatusesQueryVariables) {
      return { query: GetDefaultSurveyStatusesDocument, variables: variables }
    }
export const GetSurveyAppointmentTypeSettingsDocument = gql`
    query getSurveyAppointmentTypeSettings($clinicId: String!) {
  findManyAppointmentType(
    where: {clinicId: {equals: $clinicId}, isVisible: {equals: true}}
  ) {
    id
    createdAt
    updatedAt
    name
    displayName
    description
    surveyAppointmentTypeSettings {
      id
      createdAt
      updatedAt
      isActive
      automatedTriggerInMinutes
      surveySettingId
    }
  }
}
    `;

/**
 * __useGetSurveyAppointmentTypeSettingsQuery__
 *
 * To run a query within a React component, call `useGetSurveyAppointmentTypeSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyAppointmentTypeSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyAppointmentTypeSettingsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetSurveyAppointmentTypeSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyAppointmentTypeSettingsQuery, GetSurveyAppointmentTypeSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyAppointmentTypeSettingsQuery, GetSurveyAppointmentTypeSettingsQueryVariables>(GetSurveyAppointmentTypeSettingsDocument, options);
      }
export function useGetSurveyAppointmentTypeSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyAppointmentTypeSettingsQuery, GetSurveyAppointmentTypeSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyAppointmentTypeSettingsQuery, GetSurveyAppointmentTypeSettingsQueryVariables>(GetSurveyAppointmentTypeSettingsDocument, options);
        }
export type GetSurveyAppointmentTypeSettingsQueryHookResult = ReturnType<typeof useGetSurveyAppointmentTypeSettingsQuery>;
export type GetSurveyAppointmentTypeSettingsLazyQueryHookResult = ReturnType<typeof useGetSurveyAppointmentTypeSettingsLazyQuery>;
export type GetSurveyAppointmentTypeSettingsQueryResult = Apollo.QueryResult<GetSurveyAppointmentTypeSettingsQuery, GetSurveyAppointmentTypeSettingsQueryVariables>;
export function refetchGetSurveyAppointmentTypeSettingsQuery(variables?: GetSurveyAppointmentTypeSettingsQueryVariables) {
      return { query: GetSurveyAppointmentTypeSettingsDocument, variables: variables }
    }
export const GetSurveyGeneralSettingsDocument = gql`
    query getSurveyGeneralSettings($settingId: String!) {
  findUniqueSurveySetting(where: {id: $settingId}) {
    id
    createdAt
    updatedAt
    isAutomatedTriggerForAllAppointmentTypes
    frequencyInDays
    showLinkToLeaveReviewNeutral
    showLinkToLeaveReviewSatisfied
    linkToLeaveReview
  }
}
    `;

/**
 * __useGetSurveyGeneralSettingsQuery__
 *
 * To run a query within a React component, call `useGetSurveyGeneralSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyGeneralSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyGeneralSettingsQuery({
 *   variables: {
 *      settingId: // value for 'settingId'
 *   },
 * });
 */
export function useGetSurveyGeneralSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyGeneralSettingsQuery, GetSurveyGeneralSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyGeneralSettingsQuery, GetSurveyGeneralSettingsQueryVariables>(GetSurveyGeneralSettingsDocument, options);
      }
export function useGetSurveyGeneralSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyGeneralSettingsQuery, GetSurveyGeneralSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyGeneralSettingsQuery, GetSurveyGeneralSettingsQueryVariables>(GetSurveyGeneralSettingsDocument, options);
        }
export type GetSurveyGeneralSettingsQueryHookResult = ReturnType<typeof useGetSurveyGeneralSettingsQuery>;
export type GetSurveyGeneralSettingsLazyQueryHookResult = ReturnType<typeof useGetSurveyGeneralSettingsLazyQuery>;
export type GetSurveyGeneralSettingsQueryResult = Apollo.QueryResult<GetSurveyGeneralSettingsQuery, GetSurveyGeneralSettingsQueryVariables>;
export function refetchGetSurveyGeneralSettingsQuery(variables?: GetSurveyGeneralSettingsQueryVariables) {
      return { query: GetSurveyGeneralSettingsDocument, variables: variables }
    }
export const GetSurveyWorkflowEventSettingsDocument = gql`
    query getSurveyWorkflowEventSettings($clinicId: String!) {
  findManyWorkflowEventSetting(
    where: {surveySettingId: {not: {equals: null}}, clinicId: {equals: $clinicId}, deletedAt: null}
  ) {
    id
    name
    surveySettingId
    surveyStep
    surveyType
    isPublished
    sendingHours
    actions {
      id
      actionType
      order
      config
      channelStatusChangeId
      channelStatusChange {
        id
        name
      }
    }
    notificationBody
    event
  }
}
    `;

/**
 * __useGetSurveyWorkflowEventSettingsQuery__
 *
 * To run a query within a React component, call `useGetSurveyWorkflowEventSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyWorkflowEventSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyWorkflowEventSettingsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetSurveyWorkflowEventSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyWorkflowEventSettingsQuery, GetSurveyWorkflowEventSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyWorkflowEventSettingsQuery, GetSurveyWorkflowEventSettingsQueryVariables>(GetSurveyWorkflowEventSettingsDocument, options);
      }
export function useGetSurveyWorkflowEventSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyWorkflowEventSettingsQuery, GetSurveyWorkflowEventSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyWorkflowEventSettingsQuery, GetSurveyWorkflowEventSettingsQueryVariables>(GetSurveyWorkflowEventSettingsDocument, options);
        }
export type GetSurveyWorkflowEventSettingsQueryHookResult = ReturnType<typeof useGetSurveyWorkflowEventSettingsQuery>;
export type GetSurveyWorkflowEventSettingsLazyQueryHookResult = ReturnType<typeof useGetSurveyWorkflowEventSettingsLazyQuery>;
export type GetSurveyWorkflowEventSettingsQueryResult = Apollo.QueryResult<GetSurveyWorkflowEventSettingsQuery, GetSurveyWorkflowEventSettingsQueryVariables>;
export function refetchGetSurveyWorkflowEventSettingsQuery(variables?: GetSurveyWorkflowEventSettingsQueryVariables) {
      return { query: GetSurveyWorkflowEventSettingsDocument, variables: variables }
    }
export const ClinicHasAutomationsThatCreateTasksDocument = gql`
    query clinicHasAutomationsThatCreateTasks($clinicId: String!) {
  clinicHasAutomationsThatCreateTasks(clinicId: $clinicId)
}
    `;

/**
 * __useClinicHasAutomationsThatCreateTasksQuery__
 *
 * To run a query within a React component, call `useClinicHasAutomationsThatCreateTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicHasAutomationsThatCreateTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicHasAutomationsThatCreateTasksQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useClinicHasAutomationsThatCreateTasksQuery(baseOptions: Apollo.QueryHookOptions<ClinicHasAutomationsThatCreateTasksQuery, ClinicHasAutomationsThatCreateTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicHasAutomationsThatCreateTasksQuery, ClinicHasAutomationsThatCreateTasksQueryVariables>(ClinicHasAutomationsThatCreateTasksDocument, options);
      }
export function useClinicHasAutomationsThatCreateTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicHasAutomationsThatCreateTasksQuery, ClinicHasAutomationsThatCreateTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicHasAutomationsThatCreateTasksQuery, ClinicHasAutomationsThatCreateTasksQueryVariables>(ClinicHasAutomationsThatCreateTasksDocument, options);
        }
export type ClinicHasAutomationsThatCreateTasksQueryHookResult = ReturnType<typeof useClinicHasAutomationsThatCreateTasksQuery>;
export type ClinicHasAutomationsThatCreateTasksLazyQueryHookResult = ReturnType<typeof useClinicHasAutomationsThatCreateTasksLazyQuery>;
export type ClinicHasAutomationsThatCreateTasksQueryResult = Apollo.QueryResult<ClinicHasAutomationsThatCreateTasksQuery, ClinicHasAutomationsThatCreateTasksQueryVariables>;
export function refetchClinicHasAutomationsThatCreateTasksQuery(variables?: ClinicHasAutomationsThatCreateTasksQueryVariables) {
      return { query: ClinicHasAutomationsThatCreateTasksDocument, variables: variables }
    }
export const CreateOneClinicUserFilterDocument = gql`
    mutation createOneClinicUserFilter($data: ClinicUserFilterCreateInput!) {
  createOneClinicUserFilter(data: $data) {
    id
    createdAt
    updatedAt
    clinicId
    userId
    filter
    type
    clinic {
      id
    }
    user {
      id
    }
  }
}
    `;
export type CreateOneClinicUserFilterMutationFn = Apollo.MutationFunction<CreateOneClinicUserFilterMutation, CreateOneClinicUserFilterMutationVariables>;

/**
 * __useCreateOneClinicUserFilterMutation__
 *
 * To run a mutation, you first call `useCreateOneClinicUserFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneClinicUserFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneClinicUserFilterMutation, { data, loading, error }] = useCreateOneClinicUserFilterMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneClinicUserFilterMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneClinicUserFilterMutation, CreateOneClinicUserFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneClinicUserFilterMutation, CreateOneClinicUserFilterMutationVariables>(CreateOneClinicUserFilterDocument, options);
      }
export type CreateOneClinicUserFilterMutationHookResult = ReturnType<typeof useCreateOneClinicUserFilterMutation>;
export type CreateOneClinicUserFilterMutationResult = Apollo.MutationResult<CreateOneClinicUserFilterMutation>;
export type CreateOneClinicUserFilterMutationOptions = Apollo.BaseMutationOptions<CreateOneClinicUserFilterMutation, CreateOneClinicUserFilterMutationVariables>;
export const CreateOneTaskDocument = gql`
    mutation createOneTask($data: TaskCreateInput!) {
  createOneTask(data: $data) {
    id
    createdAt
    updatedAt
    name
    type
    status
    completedAt
    clinicId
    completedByUserId
    clinincPetParentId
    widgetRequestId
    automationRunId
    paymentIntentId
    appointmentId
    description
    repeatIntervalDefinition
    assignees {
      id
    }
  }
}
    `;
export type CreateOneTaskMutationFn = Apollo.MutationFunction<CreateOneTaskMutation, CreateOneTaskMutationVariables>;

/**
 * __useCreateOneTaskMutation__
 *
 * To run a mutation, you first call `useCreateOneTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneTaskMutation, { data, loading, error }] = useCreateOneTaskMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneTaskMutation, CreateOneTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneTaskMutation, CreateOneTaskMutationVariables>(CreateOneTaskDocument, options);
      }
export type CreateOneTaskMutationHookResult = ReturnType<typeof useCreateOneTaskMutation>;
export type CreateOneTaskMutationResult = Apollo.MutationResult<CreateOneTaskMutation>;
export type CreateOneTaskMutationOptions = Apollo.BaseMutationOptions<CreateOneTaskMutation, CreateOneTaskMutationVariables>;
export const DeleteOneTaskDocument = gql`
    mutation deleteOneTask($where: TaskWhereUniqueInput!) {
  deleteOneTask(where: $where) {
    id
    clinicId
    type
    status
    assignees {
      id
    }
  }
}
    `;
export type DeleteOneTaskMutationFn = Apollo.MutationFunction<DeleteOneTaskMutation, DeleteOneTaskMutationVariables>;

/**
 * __useDeleteOneTaskMutation__
 *
 * To run a mutation, you first call `useDeleteOneTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneTaskMutation, { data, loading, error }] = useDeleteOneTaskMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneTaskMutation, DeleteOneTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneTaskMutation, DeleteOneTaskMutationVariables>(DeleteOneTaskDocument, options);
      }
export type DeleteOneTaskMutationHookResult = ReturnType<typeof useDeleteOneTaskMutation>;
export type DeleteOneTaskMutationResult = Apollo.MutationResult<DeleteOneTaskMutation>;
export type DeleteOneTaskMutationOptions = Apollo.BaseMutationOptions<DeleteOneTaskMutation, DeleteOneTaskMutationVariables>;
export const FindManyClinicWidgetRequestTypeDocument = gql`
    query findManyClinicWidgetRequestType($where: ClinicWidgetRequestTypeWhereInput, $orderBy: [ClinicWidgetRequestTypeOrderByWithRelationInput]) {
  findManyClinicWidgetRequestType(where: $where, orderBy: $orderBy) {
    id
    createdAt
    updatedAt
    displayName
    isDeleted
    isActive
    order
    requestType
    clinicWidgetSettingId
    channelStatusId
    formTemplateId
    shouldCreateTask
  }
}
    `;

/**
 * __useFindManyClinicWidgetRequestTypeQuery__
 *
 * To run a query within a React component, call `useFindManyClinicWidgetRequestTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyClinicWidgetRequestTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyClinicWidgetRequestTypeQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyClinicWidgetRequestTypeQuery(baseOptions?: Apollo.QueryHookOptions<FindManyClinicWidgetRequestTypeQuery, FindManyClinicWidgetRequestTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyClinicWidgetRequestTypeQuery, FindManyClinicWidgetRequestTypeQueryVariables>(FindManyClinicWidgetRequestTypeDocument, options);
      }
export function useFindManyClinicWidgetRequestTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyClinicWidgetRequestTypeQuery, FindManyClinicWidgetRequestTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyClinicWidgetRequestTypeQuery, FindManyClinicWidgetRequestTypeQueryVariables>(FindManyClinicWidgetRequestTypeDocument, options);
        }
export type FindManyClinicWidgetRequestTypeQueryHookResult = ReturnType<typeof useFindManyClinicWidgetRequestTypeQuery>;
export type FindManyClinicWidgetRequestTypeLazyQueryHookResult = ReturnType<typeof useFindManyClinicWidgetRequestTypeLazyQuery>;
export type FindManyClinicWidgetRequestTypeQueryResult = Apollo.QueryResult<FindManyClinicWidgetRequestTypeQuery, FindManyClinicWidgetRequestTypeQueryVariables>;
export function refetchFindManyClinicWidgetRequestTypeQuery(variables?: FindManyClinicWidgetRequestTypeQueryVariables) {
      return { query: FindManyClinicWidgetRequestTypeDocument, variables: variables }
    }
export const FindManyTaskDocument = gql`
    query findManyTask($where: TaskWhereInput, $orderBy: [TaskOrderByWithRelationInput], $take: Int, $skip: Int) {
  findManyTask(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    createdAt
    updatedAt
    name
    type
    status
    completedAt
    clinicId
    completedByUserId
    clinincPetParentId
    widgetRequestId
    automationRunId
    paymentIntentId
    appointmentId
    description
    repeatIntervalDefinition
    assignees {
      id
    }
    clinicPetParent {
      id
      email
      firstName
      lastName
      phoneNumber
    }
    widgetRequest {
      id
      clinicWidgetRequestType {
        id
      }
    }
  }
}
    `;

/**
 * __useFindManyTaskQuery__
 *
 * To run a query within a React component, call `useFindManyTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyTaskQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useFindManyTaskQuery(baseOptions?: Apollo.QueryHookOptions<FindManyTaskQuery, FindManyTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyTaskQuery, FindManyTaskQueryVariables>(FindManyTaskDocument, options);
      }
export function useFindManyTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyTaskQuery, FindManyTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyTaskQuery, FindManyTaskQueryVariables>(FindManyTaskDocument, options);
        }
export type FindManyTaskQueryHookResult = ReturnType<typeof useFindManyTaskQuery>;
export type FindManyTaskLazyQueryHookResult = ReturnType<typeof useFindManyTaskLazyQuery>;
export type FindManyTaskQueryResult = Apollo.QueryResult<FindManyTaskQuery, FindManyTaskQueryVariables>;
export function refetchFindManyTaskQuery(variables?: FindManyTaskQueryVariables) {
      return { query: FindManyTaskDocument, variables: variables }
    }
export const FindManyTaskCountDocument = gql`
    query findManyTaskCount($where: TaskWhereInput) {
  findManyTaskCount(where: $where)
}
    `;

/**
 * __useFindManyTaskCountQuery__
 *
 * To run a query within a React component, call `useFindManyTaskCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyTaskCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyTaskCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyTaskCountQuery(baseOptions?: Apollo.QueryHookOptions<FindManyTaskCountQuery, FindManyTaskCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyTaskCountQuery, FindManyTaskCountQueryVariables>(FindManyTaskCountDocument, options);
      }
export function useFindManyTaskCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyTaskCountQuery, FindManyTaskCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyTaskCountQuery, FindManyTaskCountQueryVariables>(FindManyTaskCountDocument, options);
        }
export type FindManyTaskCountQueryHookResult = ReturnType<typeof useFindManyTaskCountQuery>;
export type FindManyTaskCountLazyQueryHookResult = ReturnType<typeof useFindManyTaskCountLazyQuery>;
export type FindManyTaskCountQueryResult = Apollo.QueryResult<FindManyTaskCountQuery, FindManyTaskCountQueryVariables>;
export function refetchFindManyTaskCountQuery(variables?: FindManyTaskCountQueryVariables) {
      return { query: FindManyTaskCountDocument, variables: variables }
    }
export const FindTaskCountIdsAndStatusesDocument = gql`
    query findTaskCountIdsAndStatuses($where: TaskWhereInput) {
  findManyTask(where: $where) {
    id
    status
  }
}
    `;

/**
 * __useFindTaskCountIdsAndStatusesQuery__
 *
 * To run a query within a React component, call `useFindTaskCountIdsAndStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTaskCountIdsAndStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTaskCountIdsAndStatusesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindTaskCountIdsAndStatusesQuery(baseOptions?: Apollo.QueryHookOptions<FindTaskCountIdsAndStatusesQuery, FindTaskCountIdsAndStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTaskCountIdsAndStatusesQuery, FindTaskCountIdsAndStatusesQueryVariables>(FindTaskCountIdsAndStatusesDocument, options);
      }
export function useFindTaskCountIdsAndStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTaskCountIdsAndStatusesQuery, FindTaskCountIdsAndStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTaskCountIdsAndStatusesQuery, FindTaskCountIdsAndStatusesQueryVariables>(FindTaskCountIdsAndStatusesDocument, options);
        }
export type FindTaskCountIdsAndStatusesQueryHookResult = ReturnType<typeof useFindTaskCountIdsAndStatusesQuery>;
export type FindTaskCountIdsAndStatusesLazyQueryHookResult = ReturnType<typeof useFindTaskCountIdsAndStatusesLazyQuery>;
export type FindTaskCountIdsAndStatusesQueryResult = Apollo.QueryResult<FindTaskCountIdsAndStatusesQuery, FindTaskCountIdsAndStatusesQueryVariables>;
export function refetchFindTaskCountIdsAndStatusesQuery(variables?: FindTaskCountIdsAndStatusesQueryVariables) {
      return { query: FindTaskCountIdsAndStatusesDocument, variables: variables }
    }
export const FindUniqueAutomationRunWithApptDocument = gql`
    query findUniqueAutomationRunWithAppt($where: AutomationRunWhereUniqueInput!) {
  findUniqueAutomationRun(where: $where) {
    appointment {
      id
      startAt
      status
      isActive
      isDeleted
      appointmentType {
        id
        displayName
        description
        name
      }
      clinicEmployees {
        id
        firstName
        lastName
      }
      clinicPet {
        id
        name
        species
        speciesType
      }
      durationInMinutes
      room {
        id
        name
      }
    }
    id
    actions(where: {automationAction: {promptType: {equals: Buttons}}}) {
      id
      automationAction {
        id
        workflowEventSetting {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFindUniqueAutomationRunWithApptQuery__
 *
 * To run a query within a React component, call `useFindUniqueAutomationRunWithApptQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueAutomationRunWithApptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueAutomationRunWithApptQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueAutomationRunWithApptQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueAutomationRunWithApptQuery, FindUniqueAutomationRunWithApptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueAutomationRunWithApptQuery, FindUniqueAutomationRunWithApptQueryVariables>(FindUniqueAutomationRunWithApptDocument, options);
      }
export function useFindUniqueAutomationRunWithApptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueAutomationRunWithApptQuery, FindUniqueAutomationRunWithApptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueAutomationRunWithApptQuery, FindUniqueAutomationRunWithApptQueryVariables>(FindUniqueAutomationRunWithApptDocument, options);
        }
export type FindUniqueAutomationRunWithApptQueryHookResult = ReturnType<typeof useFindUniqueAutomationRunWithApptQuery>;
export type FindUniqueAutomationRunWithApptLazyQueryHookResult = ReturnType<typeof useFindUniqueAutomationRunWithApptLazyQuery>;
export type FindUniqueAutomationRunWithApptQueryResult = Apollo.QueryResult<FindUniqueAutomationRunWithApptQuery, FindUniqueAutomationRunWithApptQueryVariables>;
export function refetchFindUniqueAutomationRunWithApptQuery(variables?: FindUniqueAutomationRunWithApptQueryVariables) {
      return { query: FindUniqueAutomationRunWithApptDocument, variables: variables }
    }
export const FindUniqueClinicPetParentSearchResultDocument = gql`
    query findUniqueClinicPetParentSearchResult($where: ClinicPetParentWhereUniqueInput!) {
  findUniqueClinicPetParent(where: $where) {
    id
    firstName
    lastName
    isActive
    pimsId
    pets {
      id
      name
    }
  }
}
    `;

/**
 * __useFindUniqueClinicPetParentSearchResultQuery__
 *
 * To run a query within a React component, call `useFindUniqueClinicPetParentSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueClinicPetParentSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueClinicPetParentSearchResultQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueClinicPetParentSearchResultQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueClinicPetParentSearchResultQuery, FindUniqueClinicPetParentSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueClinicPetParentSearchResultQuery, FindUniqueClinicPetParentSearchResultQueryVariables>(FindUniqueClinicPetParentSearchResultDocument, options);
      }
export function useFindUniqueClinicPetParentSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueClinicPetParentSearchResultQuery, FindUniqueClinicPetParentSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueClinicPetParentSearchResultQuery, FindUniqueClinicPetParentSearchResultQueryVariables>(FindUniqueClinicPetParentSearchResultDocument, options);
        }
export type FindUniqueClinicPetParentSearchResultQueryHookResult = ReturnType<typeof useFindUniqueClinicPetParentSearchResultQuery>;
export type FindUniqueClinicPetParentSearchResultLazyQueryHookResult = ReturnType<typeof useFindUniqueClinicPetParentSearchResultLazyQuery>;
export type FindUniqueClinicPetParentSearchResultQueryResult = Apollo.QueryResult<FindUniqueClinicPetParentSearchResultQuery, FindUniqueClinicPetParentSearchResultQueryVariables>;
export function refetchFindUniqueClinicPetParentSearchResultQuery(variables?: FindUniqueClinicPetParentSearchResultQueryVariables) {
      return { query: FindUniqueClinicPetParentSearchResultDocument, variables: variables }
    }
export const FindUniqueClinicUserFilterDocument = gql`
    query findUniqueClinicUserFilter($where: ClinicUserFilterWhereUniqueInput!) {
  findUniqueClinicUserFilter(where: $where) {
    id
    createdAt
    updatedAt
    clinicId
    userId
    filter
    type
  }
}
    `;

/**
 * __useFindUniqueClinicUserFilterQuery__
 *
 * To run a query within a React component, call `useFindUniqueClinicUserFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueClinicUserFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueClinicUserFilterQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueClinicUserFilterQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueClinicUserFilterQuery, FindUniqueClinicUserFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueClinicUserFilterQuery, FindUniqueClinicUserFilterQueryVariables>(FindUniqueClinicUserFilterDocument, options);
      }
export function useFindUniqueClinicUserFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueClinicUserFilterQuery, FindUniqueClinicUserFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueClinicUserFilterQuery, FindUniqueClinicUserFilterQueryVariables>(FindUniqueClinicUserFilterDocument, options);
        }
export type FindUniqueClinicUserFilterQueryHookResult = ReturnType<typeof useFindUniqueClinicUserFilterQuery>;
export type FindUniqueClinicUserFilterLazyQueryHookResult = ReturnType<typeof useFindUniqueClinicUserFilterLazyQuery>;
export type FindUniqueClinicUserFilterQueryResult = Apollo.QueryResult<FindUniqueClinicUserFilterQuery, FindUniqueClinicUserFilterQueryVariables>;
export function refetchFindUniqueClinicUserFilterQuery(variables?: FindUniqueClinicUserFilterQueryVariables) {
      return { query: FindUniqueClinicUserFilterDocument, variables: variables }
    }
export const SearchPetParentAndPetsDocument = gql`
    query searchPetParentAndPets($whereInput: SearchClinicPetParentInput, $pageSize: Int, $clinicId: String!) {
  clinicPetParentSearch(where: $whereInput, take: $pageSize) {
    id
    updatedAt
    firstName
    lastName
    email
    isActive
    pimsId
    ...PetParentAvatar
    pets(
      take: 5
      where: {isActive: {equals: true}, isDeleted: {equals: false}, isDeceased: {not: {equals: true}}, clinicId: {equals: $clinicId}}
    ) {
      id
      pimsId
      speciesType
      breed
      gender
      isActive
      isDeleted
      ...PetAvatar
    }
  }
}
    ${PetParentAvatarFragmentDoc}
${PetAvatarFragmentDoc}`;

/**
 * __useSearchPetParentAndPetsQuery__
 *
 * To run a query within a React component, call `useSearchPetParentAndPetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPetParentAndPetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPetParentAndPetsQuery({
 *   variables: {
 *      whereInput: // value for 'whereInput'
 *      pageSize: // value for 'pageSize'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useSearchPetParentAndPetsQuery(baseOptions: Apollo.QueryHookOptions<SearchPetParentAndPetsQuery, SearchPetParentAndPetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPetParentAndPetsQuery, SearchPetParentAndPetsQueryVariables>(SearchPetParentAndPetsDocument, options);
      }
export function useSearchPetParentAndPetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPetParentAndPetsQuery, SearchPetParentAndPetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPetParentAndPetsQuery, SearchPetParentAndPetsQueryVariables>(SearchPetParentAndPetsDocument, options);
        }
export type SearchPetParentAndPetsQueryHookResult = ReturnType<typeof useSearchPetParentAndPetsQuery>;
export type SearchPetParentAndPetsLazyQueryHookResult = ReturnType<typeof useSearchPetParentAndPetsLazyQuery>;
export type SearchPetParentAndPetsQueryResult = Apollo.QueryResult<SearchPetParentAndPetsQuery, SearchPetParentAndPetsQueryVariables>;
export function refetchSearchPetParentAndPetsQuery(variables?: SearchPetParentAndPetsQueryVariables) {
      return { query: SearchPetParentAndPetsDocument, variables: variables }
    }
export const UpdateOneClinicUserFilterDocument = gql`
    mutation updateOneClinicUserFilter($data: ClinicUserFilterUpdateInput!, $where: ClinicUserFilterWhereUniqueInput!) {
  updateOneClinicUserFilter(data: $data, where: $where) {
    id
    createdAt
    updatedAt
    clinicId
    userId
    filter
    type
    clinic {
      id
    }
    user {
      id
    }
  }
}
    `;
export type UpdateOneClinicUserFilterMutationFn = Apollo.MutationFunction<UpdateOneClinicUserFilterMutation, UpdateOneClinicUserFilterMutationVariables>;

/**
 * __useUpdateOneClinicUserFilterMutation__
 *
 * To run a mutation, you first call `useUpdateOneClinicUserFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneClinicUserFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneClinicUserFilterMutation, { data, loading, error }] = useUpdateOneClinicUserFilterMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneClinicUserFilterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneClinicUserFilterMutation, UpdateOneClinicUserFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneClinicUserFilterMutation, UpdateOneClinicUserFilterMutationVariables>(UpdateOneClinicUserFilterDocument, options);
      }
export type UpdateOneClinicUserFilterMutationHookResult = ReturnType<typeof useUpdateOneClinicUserFilterMutation>;
export type UpdateOneClinicUserFilterMutationResult = Apollo.MutationResult<UpdateOneClinicUserFilterMutation>;
export type UpdateOneClinicUserFilterMutationOptions = Apollo.BaseMutationOptions<UpdateOneClinicUserFilterMutation, UpdateOneClinicUserFilterMutationVariables>;
export const UpdateOneTaskDocument = gql`
    mutation updateOneTask($data: TaskUpdateInput!, $where: TaskWhereUniqueInput!) {
  updateOneTask(data: $data, where: $where) {
    id
    createdAt
    updatedAt
    name
    type
    status
    completedAt
    clinicId
    completedByUserId
    clinincPetParentId
    widgetRequestId
    automationRunId
    paymentIntentId
    appointmentId
    description
    repeatIntervalDefinition
    assignees {
      id
    }
  }
}
    `;
export type UpdateOneTaskMutationFn = Apollo.MutationFunction<UpdateOneTaskMutation, UpdateOneTaskMutationVariables>;

/**
 * __useUpdateOneTaskMutation__
 *
 * To run a mutation, you first call `useUpdateOneTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneTaskMutation, { data, loading, error }] = useUpdateOneTaskMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneTaskMutation, UpdateOneTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneTaskMutation, UpdateOneTaskMutationVariables>(UpdateOneTaskDocument, options);
      }
export type UpdateOneTaskMutationHookResult = ReturnType<typeof useUpdateOneTaskMutation>;
export type UpdateOneTaskMutationResult = Apollo.MutationResult<UpdateOneTaskMutation>;
export type UpdateOneTaskMutationOptions = Apollo.BaseMutationOptions<UpdateOneTaskMutation, UpdateOneTaskMutationVariables>;
export const SubscribeToPendingTasksDocument = gql`
    subscription subscribeToPendingTasks($where: SubscriptionPendingTasksWhereInput!) {
  pendingTasksChanged(where: $where) {
    mutation
    node {
      id
      name
      status
      type
      assignees {
        id
        firstName
        lastName
      }
      widgetRequest {
        id
        clinicWidgetRequestType {
          id
          requestType
        }
      }
      automationRun {
        id
      }
    }
  }
}
    `;

/**
 * __useSubscribeToPendingTasksSubscription__
 *
 * To run a query within a React component, call `useSubscribeToPendingTasksSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToPendingTasksSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToPendingTasksSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToPendingTasksSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToPendingTasksSubscription, SubscribeToPendingTasksSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToPendingTasksSubscription, SubscribeToPendingTasksSubscriptionVariables>(SubscribeToPendingTasksDocument, options);
      }
export type SubscribeToPendingTasksSubscriptionHookResult = ReturnType<typeof useSubscribeToPendingTasksSubscription>;
export type SubscribeToPendingTasksSubscriptionResult = Apollo.SubscriptionResult<SubscribeToPendingTasksSubscription>;
export const SubscribeToTaskAssigneeRemovedDocument = gql`
    subscription subscribeToTaskAssigneeRemoved($where: SubscriptionPendingTasksWhereInput!) {
  taskAssigneeRemoved(where: $where) {
    mutation
    node {
      id
      name
      status
      type
      assignees {
        id
        firstName
        lastName
      }
      widgetRequest {
        id
        clinicWidgetRequestType {
          id
          requestType
        }
      }
      automationRun {
        id
      }
    }
  }
}
    `;

/**
 * __useSubscribeToTaskAssigneeRemovedSubscription__
 *
 * To run a query within a React component, call `useSubscribeToTaskAssigneeRemovedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToTaskAssigneeRemovedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToTaskAssigneeRemovedSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToTaskAssigneeRemovedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToTaskAssigneeRemovedSubscription, SubscribeToTaskAssigneeRemovedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToTaskAssigneeRemovedSubscription, SubscribeToTaskAssigneeRemovedSubscriptionVariables>(SubscribeToTaskAssigneeRemovedDocument, options);
      }
export type SubscribeToTaskAssigneeRemovedSubscriptionHookResult = ReturnType<typeof useSubscribeToTaskAssigneeRemovedSubscription>;
export type SubscribeToTaskAssigneeRemovedSubscriptionResult = Apollo.SubscriptionResult<SubscribeToTaskAssigneeRemovedSubscription>;
export const SubscribeToDeletedTasksDocument = gql`
    subscription subscribeToDeletedTasks($where: SubscriptionPendingTasksWhereInput!) {
  pendingTasksChanged(where: $where) {
    mutation
    node {
      id
      status
      type
    }
  }
}
    `;

/**
 * __useSubscribeToDeletedTasksSubscription__
 *
 * To run a query within a React component, call `useSubscribeToDeletedTasksSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToDeletedTasksSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToDeletedTasksSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToDeletedTasksSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToDeletedTasksSubscription, SubscribeToDeletedTasksSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToDeletedTasksSubscription, SubscribeToDeletedTasksSubscriptionVariables>(SubscribeToDeletedTasksDocument, options);
      }
export type SubscribeToDeletedTasksSubscriptionHookResult = ReturnType<typeof useSubscribeToDeletedTasksSubscription>;
export type SubscribeToDeletedTasksSubscriptionResult = Apollo.SubscriptionResult<SubscribeToDeletedTasksSubscription>;
export const CreateTeamChannelDocument = gql`
    mutation createTeamChannel($data: CreateTeamChannelInput!) {
  createTeamChannel2(data: $data) {
    id
    friendlyName
    channelVisibility
  }
}
    `;
export type CreateTeamChannelMutationFn = Apollo.MutationFunction<CreateTeamChannelMutation, CreateTeamChannelMutationVariables>;

/**
 * __useCreateTeamChannelMutation__
 *
 * To run a mutation, you first call `useCreateTeamChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamChannelMutation, { data, loading, error }] = useCreateTeamChannelMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTeamChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamChannelMutation, CreateTeamChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamChannelMutation, CreateTeamChannelMutationVariables>(CreateTeamChannelDocument, options);
      }
export type CreateTeamChannelMutationHookResult = ReturnType<typeof useCreateTeamChannelMutation>;
export type CreateTeamChannelMutationResult = Apollo.MutationResult<CreateTeamChannelMutation>;
export type CreateTeamChannelMutationOptions = Apollo.BaseMutationOptions<CreateTeamChannelMutation, CreateTeamChannelMutationVariables>;
export const GetTeamChannelsDocument = gql`
    query getTeamChannels($wherePublic: ChannelWhereInput!, $orderBy: [ChannelOrderByWithRelationInput!], $wherePrivate: ChannelWhereInput!, $whereDirectMessages: ChannelWhereInput!) {
  publicChannels: findManyChannel(where: $wherePublic, orderBy: $orderBy) {
    id
    isActive
    friendlyName
    channelVisibility
  }
  privateChannels: findManyChannel(where: $wherePrivate, orderBy: $orderBy) {
    id
    isActive
    friendlyName
    channelVisibility
  }
  directMessages: findManyChannel(where: $whereDirectMessages, orderBy: $orderBy) {
    id
    isActive
    friendlyName
    channelVisibility
    assignees {
      ...ClinicUserAvatar
    }
  }
}
    ${ClinicUserAvatarFragmentDoc}`;

/**
 * __useGetTeamChannelsQuery__
 *
 * To run a query within a React component, call `useGetTeamChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamChannelsQuery({
 *   variables: {
 *      wherePublic: // value for 'wherePublic'
 *      orderBy: // value for 'orderBy'
 *      wherePrivate: // value for 'wherePrivate'
 *      whereDirectMessages: // value for 'whereDirectMessages'
 *   },
 * });
 */
export function useGetTeamChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamChannelsQuery, GetTeamChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamChannelsQuery, GetTeamChannelsQueryVariables>(GetTeamChannelsDocument, options);
      }
export function useGetTeamChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamChannelsQuery, GetTeamChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamChannelsQuery, GetTeamChannelsQueryVariables>(GetTeamChannelsDocument, options);
        }
export type GetTeamChannelsQueryHookResult = ReturnType<typeof useGetTeamChannelsQuery>;
export type GetTeamChannelsLazyQueryHookResult = ReturnType<typeof useGetTeamChannelsLazyQuery>;
export type GetTeamChannelsQueryResult = Apollo.QueryResult<GetTeamChannelsQuery, GetTeamChannelsQueryVariables>;
export function refetchGetTeamChannelsQuery(variables?: GetTeamChannelsQueryVariables) {
      return { query: GetTeamChannelsDocument, variables: variables }
    }
export const SubscribeToTeamChannelsDocument = gql`
    subscription subscribeToTeamChannels($where: SubscriptionChannelWhereInput!) {
  channelChanged(where: $where) {
    mutation
    node {
      id
      isActive
      friendlyName
      channelType
      channelVisibility
    }
  }
}
    `;

/**
 * __useSubscribeToTeamChannelsSubscription__
 *
 * To run a query within a React component, call `useSubscribeToTeamChannelsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToTeamChannelsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToTeamChannelsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToTeamChannelsSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToTeamChannelsSubscription, SubscribeToTeamChannelsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToTeamChannelsSubscription, SubscribeToTeamChannelsSubscriptionVariables>(SubscribeToTeamChannelsDocument, options);
      }
export type SubscribeToTeamChannelsSubscriptionHookResult = ReturnType<typeof useSubscribeToTeamChannelsSubscription>;
export type SubscribeToTeamChannelsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToTeamChannelsSubscription>;
export const FindManyAppointmentAutomationsDocument = gql`
    query findManyAppointmentAutomations($where: AppointmentWhereInput) {
  findManyAppointment(where: $where) {
    id
    description
    startAt
    appointmentType {
      displayName
      name
    }
    clinicPet {
      speciesType
      name
    }
    workflows {
      id
      name
      event
      surveySettingId
      surveyStep
      surveyType
      isPublished
    }
  }
}
    `;

/**
 * __useFindManyAppointmentAutomationsQuery__
 *
 * To run a query within a React component, call `useFindManyAppointmentAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyAppointmentAutomationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyAppointmentAutomationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyAppointmentAutomationsQuery(baseOptions?: Apollo.QueryHookOptions<FindManyAppointmentAutomationsQuery, FindManyAppointmentAutomationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyAppointmentAutomationsQuery, FindManyAppointmentAutomationsQueryVariables>(FindManyAppointmentAutomationsDocument, options);
      }
export function useFindManyAppointmentAutomationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyAppointmentAutomationsQuery, FindManyAppointmentAutomationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyAppointmentAutomationsQuery, FindManyAppointmentAutomationsQueryVariables>(FindManyAppointmentAutomationsDocument, options);
        }
export type FindManyAppointmentAutomationsQueryHookResult = ReturnType<typeof useFindManyAppointmentAutomationsQuery>;
export type FindManyAppointmentAutomationsLazyQueryHookResult = ReturnType<typeof useFindManyAppointmentAutomationsLazyQuery>;
export type FindManyAppointmentAutomationsQueryResult = Apollo.QueryResult<FindManyAppointmentAutomationsQuery, FindManyAppointmentAutomationsQueryVariables>;
export function refetchFindManyAppointmentAutomationsQuery(variables?: FindManyAppointmentAutomationsQueryVariables) {
      return { query: FindManyAppointmentAutomationsDocument, variables: variables }
    }
export const GetAutomationRunDocument = gql`
    query getAutomationRun($where: AutomationRunWhereUniqueInput!) {
  findUniqueAutomationRun(where: $where) {
    ...AutomationRun
  }
}
    ${AutomationRunFragmentDoc}`;

/**
 * __useGetAutomationRunQuery__
 *
 * To run a query within a React component, call `useGetAutomationRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationRunQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAutomationRunQuery(baseOptions: Apollo.QueryHookOptions<GetAutomationRunQuery, GetAutomationRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationRunQuery, GetAutomationRunQueryVariables>(GetAutomationRunDocument, options);
      }
export function useGetAutomationRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationRunQuery, GetAutomationRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationRunQuery, GetAutomationRunQueryVariables>(GetAutomationRunDocument, options);
        }
export type GetAutomationRunQueryHookResult = ReturnType<typeof useGetAutomationRunQuery>;
export type GetAutomationRunLazyQueryHookResult = ReturnType<typeof useGetAutomationRunLazyQuery>;
export type GetAutomationRunQueryResult = Apollo.QueryResult<GetAutomationRunQuery, GetAutomationRunQueryVariables>;
export function refetchGetAutomationRunQuery(variables?: GetAutomationRunQueryVariables) {
      return { query: GetAutomationRunDocument, variables: variables }
    }
export const GetManyAutomationRunsDocument = gql`
    query getManyAutomationRuns($where: AutomationRunWhereInput!) {
  findManyAutomationRun(where: $where) {
    ...AutomationRun
  }
}
    ${AutomationRunFragmentDoc}`;

/**
 * __useGetManyAutomationRunsQuery__
 *
 * To run a query within a React component, call `useGetManyAutomationRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManyAutomationRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManyAutomationRunsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetManyAutomationRunsQuery(baseOptions: Apollo.QueryHookOptions<GetManyAutomationRunsQuery, GetManyAutomationRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManyAutomationRunsQuery, GetManyAutomationRunsQueryVariables>(GetManyAutomationRunsDocument, options);
      }
export function useGetManyAutomationRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManyAutomationRunsQuery, GetManyAutomationRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManyAutomationRunsQuery, GetManyAutomationRunsQueryVariables>(GetManyAutomationRunsDocument, options);
        }
export type GetManyAutomationRunsQueryHookResult = ReturnType<typeof useGetManyAutomationRunsQuery>;
export type GetManyAutomationRunsLazyQueryHookResult = ReturnType<typeof useGetManyAutomationRunsLazyQuery>;
export type GetManyAutomationRunsQueryResult = Apollo.QueryResult<GetManyAutomationRunsQuery, GetManyAutomationRunsQueryVariables>;
export function refetchGetManyAutomationRunsQuery(variables?: GetManyAutomationRunsQueryVariables) {
      return { query: GetManyAutomationRunsDocument, variables: variables }
    }
export const GetAutomationRunActionDocument = gql`
    query getAutomationRunAction($where: AutomationRunActionWhereInput, $orderBy: [AutomationRunActionOrderByWithRelationInput]) {
  findManyAutomationRunAction(where: $where, orderBy: $orderBy) {
    ...AutomationRunAction
  }
}
    ${AutomationRunActionFragmentDoc}`;

/**
 * __useGetAutomationRunActionQuery__
 *
 * To run a query within a React component, call `useGetAutomationRunActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationRunActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationRunActionQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetAutomationRunActionQuery(baseOptions?: Apollo.QueryHookOptions<GetAutomationRunActionQuery, GetAutomationRunActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationRunActionQuery, GetAutomationRunActionQueryVariables>(GetAutomationRunActionDocument, options);
      }
export function useGetAutomationRunActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationRunActionQuery, GetAutomationRunActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationRunActionQuery, GetAutomationRunActionQueryVariables>(GetAutomationRunActionDocument, options);
        }
export type GetAutomationRunActionQueryHookResult = ReturnType<typeof useGetAutomationRunActionQuery>;
export type GetAutomationRunActionLazyQueryHookResult = ReturnType<typeof useGetAutomationRunActionLazyQuery>;
export type GetAutomationRunActionQueryResult = Apollo.QueryResult<GetAutomationRunActionQuery, GetAutomationRunActionQueryVariables>;
export function refetchGetAutomationRunActionQuery(variables?: GetAutomationRunActionQueryVariables) {
      return { query: GetAutomationRunActionDocument, variables: variables }
    }
export const DeleteManyAutomationRunActionDocument = gql`
    mutation deleteManyAutomationRunAction($where: AutomationRunActionWhereInput!) {
  deleteManyAutomationRunAction(where: $where) {
    count
  }
}
    `;
export type DeleteManyAutomationRunActionMutationFn = Apollo.MutationFunction<DeleteManyAutomationRunActionMutation, DeleteManyAutomationRunActionMutationVariables>;

/**
 * __useDeleteManyAutomationRunActionMutation__
 *
 * To run a mutation, you first call `useDeleteManyAutomationRunActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyAutomationRunActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyAutomationRunActionMutation, { data, loading, error }] = useDeleteManyAutomationRunActionMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteManyAutomationRunActionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManyAutomationRunActionMutation, DeleteManyAutomationRunActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManyAutomationRunActionMutation, DeleteManyAutomationRunActionMutationVariables>(DeleteManyAutomationRunActionDocument, options);
      }
export type DeleteManyAutomationRunActionMutationHookResult = ReturnType<typeof useDeleteManyAutomationRunActionMutation>;
export type DeleteManyAutomationRunActionMutationResult = Apollo.MutationResult<DeleteManyAutomationRunActionMutation>;
export type DeleteManyAutomationRunActionMutationOptions = Apollo.BaseMutationOptions<DeleteManyAutomationRunActionMutation, DeleteManyAutomationRunActionMutationVariables>;
export const UpdateAutomationRunActionDocument = gql`
    mutation updateAutomationRunAction($where: AutomationRunActionWhereUniqueInput!, $data: AutomationRunActionUpdateInput!) {
  updateOneAutomationRunAction(where: $where, data: $data) {
    ...AutomationRunAction
  }
}
    ${AutomationRunActionFragmentDoc}`;
export type UpdateAutomationRunActionMutationFn = Apollo.MutationFunction<UpdateAutomationRunActionMutation, UpdateAutomationRunActionMutationVariables>;

/**
 * __useUpdateAutomationRunActionMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationRunActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationRunActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationRunActionMutation, { data, loading, error }] = useUpdateAutomationRunActionMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAutomationRunActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationRunActionMutation, UpdateAutomationRunActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationRunActionMutation, UpdateAutomationRunActionMutationVariables>(UpdateAutomationRunActionDocument, options);
      }
export type UpdateAutomationRunActionMutationHookResult = ReturnType<typeof useUpdateAutomationRunActionMutation>;
export type UpdateAutomationRunActionMutationResult = Apollo.MutationResult<UpdateAutomationRunActionMutation>;
export type UpdateAutomationRunActionMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationRunActionMutation, UpdateAutomationRunActionMutationVariables>;
export const UpdateAutomationRunDocument = gql`
    mutation updateAutomationRun($where: AutomationRunWhereUniqueInput!, $data: AutomationRunUpdateInput!) {
  updateOneAutomationRun(where: $where, data: $data) {
    ...AutomationRun
  }
}
    ${AutomationRunFragmentDoc}`;
export type UpdateAutomationRunMutationFn = Apollo.MutationFunction<UpdateAutomationRunMutation, UpdateAutomationRunMutationVariables>;

/**
 * __useUpdateAutomationRunMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationRunMutation, { data, loading, error }] = useUpdateAutomationRunMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAutomationRunMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationRunMutation, UpdateAutomationRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationRunMutation, UpdateAutomationRunMutationVariables>(UpdateAutomationRunDocument, options);
      }
export type UpdateAutomationRunMutationHookResult = ReturnType<typeof useUpdateAutomationRunMutation>;
export type UpdateAutomationRunMutationResult = Apollo.MutationResult<UpdateAutomationRunMutation>;
export type UpdateAutomationRunMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationRunMutation, UpdateAutomationRunMutationVariables>;
export const ResetAutomationRunDocument = gql`
    mutation resetAutomationRun($where: AutomationRunWhereUniqueInput!) {
  resetAutomationRun(where: $where) {
    ...AutomationRun
  }
}
    ${AutomationRunFragmentDoc}`;
export type ResetAutomationRunMutationFn = Apollo.MutationFunction<ResetAutomationRunMutation, ResetAutomationRunMutationVariables>;

/**
 * __useResetAutomationRunMutation__
 *
 * To run a mutation, you first call `useResetAutomationRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAutomationRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAutomationRunMutation, { data, loading, error }] = useResetAutomationRunMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useResetAutomationRunMutation(baseOptions?: Apollo.MutationHookOptions<ResetAutomationRunMutation, ResetAutomationRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAutomationRunMutation, ResetAutomationRunMutationVariables>(ResetAutomationRunDocument, options);
      }
export type ResetAutomationRunMutationHookResult = ReturnType<typeof useResetAutomationRunMutation>;
export type ResetAutomationRunMutationResult = Apollo.MutationResult<ResetAutomationRunMutation>;
export type ResetAutomationRunMutationOptions = Apollo.BaseMutationOptions<ResetAutomationRunMutation, ResetAutomationRunMutationVariables>;
export const CalculatePetBenefitUsageDocument = gql`
    query calculatePetBenefitUsage($where: CalculatePetBenefitUsageInput) {
  calculatePetBenefitUsage(where: $where) {
    usages {
      provided
      used
      exhausted
      displayOrder
      carryover
      costCovered
      benefit {
        id
        title
        description
        tangible
        exhaustible
        usageUnitOfMeasure
        providedDiscountPercentage
        type
        planBenefits {
          ...CarePlanBenefitUsage
        }
      }
      sources {
        ...CarePlanBenefitSource
      }
    }
  }
}
    ${CarePlanBenefitUsageFragmentDoc}
${CarePlanBenefitSourceFragmentDoc}`;

/**
 * __useCalculatePetBenefitUsageQuery__
 *
 * To run a query within a React component, call `useCalculatePetBenefitUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculatePetBenefitUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculatePetBenefitUsageQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCalculatePetBenefitUsageQuery(baseOptions?: Apollo.QueryHookOptions<CalculatePetBenefitUsageQuery, CalculatePetBenefitUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculatePetBenefitUsageQuery, CalculatePetBenefitUsageQueryVariables>(CalculatePetBenefitUsageDocument, options);
      }
export function useCalculatePetBenefitUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculatePetBenefitUsageQuery, CalculatePetBenefitUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculatePetBenefitUsageQuery, CalculatePetBenefitUsageQueryVariables>(CalculatePetBenefitUsageDocument, options);
        }
export type CalculatePetBenefitUsageQueryHookResult = ReturnType<typeof useCalculatePetBenefitUsageQuery>;
export type CalculatePetBenefitUsageLazyQueryHookResult = ReturnType<typeof useCalculatePetBenefitUsageLazyQuery>;
export type CalculatePetBenefitUsageQueryResult = Apollo.QueryResult<CalculatePetBenefitUsageQuery, CalculatePetBenefitUsageQueryVariables>;
export function refetchCalculatePetBenefitUsageQuery(variables?: CalculatePetBenefitUsageQueryVariables) {
      return { query: CalculatePetBenefitUsageDocument, variables: variables }
    }
export const CreateOneClinicPetDocument = gql`
    mutation createOneClinicPet($data: ClinicPetCreateInput!) {
  createOneClinicPet(data: $data) {
    ...ClinicPetSelection
  }
}
    ${ClinicPetSelectionFragmentDoc}`;
export type CreateOneClinicPetMutationFn = Apollo.MutationFunction<CreateOneClinicPetMutation, CreateOneClinicPetMutationVariables>;

/**
 * __useCreateOneClinicPetMutation__
 *
 * To run a mutation, you first call `useCreateOneClinicPetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneClinicPetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneClinicPetMutation, { data, loading, error }] = useCreateOneClinicPetMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneClinicPetMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneClinicPetMutation, CreateOneClinicPetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneClinicPetMutation, CreateOneClinicPetMutationVariables>(CreateOneClinicPetDocument, options);
      }
export type CreateOneClinicPetMutationHookResult = ReturnType<typeof useCreateOneClinicPetMutation>;
export type CreateOneClinicPetMutationResult = Apollo.MutationResult<CreateOneClinicPetMutation>;
export type CreateOneClinicPetMutationOptions = Apollo.BaseMutationOptions<CreateOneClinicPetMutation, CreateOneClinicPetMutationVariables>;
export const CreateOneClinicPetParentDocument = gql`
    mutation createOneClinicPetParent($data: ClinicPetParentCreateInput!) {
  createOneClinicPetParent(data: $data) {
    ...ClinicPetParentSelection
  }
}
    ${ClinicPetParentSelectionFragmentDoc}`;
export type CreateOneClinicPetParentMutationFn = Apollo.MutationFunction<CreateOneClinicPetParentMutation, CreateOneClinicPetParentMutationVariables>;

/**
 * __useCreateOneClinicPetParentMutation__
 *
 * To run a mutation, you first call `useCreateOneClinicPetParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneClinicPetParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneClinicPetParentMutation, { data, loading, error }] = useCreateOneClinicPetParentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneClinicPetParentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneClinicPetParentMutation, CreateOneClinicPetParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneClinicPetParentMutation, CreateOneClinicPetParentMutationVariables>(CreateOneClinicPetParentDocument, options);
      }
export type CreateOneClinicPetParentMutationHookResult = ReturnType<typeof useCreateOneClinicPetParentMutation>;
export type CreateOneClinicPetParentMutationResult = Apollo.MutationResult<CreateOneClinicPetParentMutation>;
export type CreateOneClinicPetParentMutationOptions = Apollo.BaseMutationOptions<CreateOneClinicPetParentMutation, CreateOneClinicPetParentMutationVariables>;
export const CreateCareBenefitUsageToInvoiceLineItemDocument = gql`
    mutation createCareBenefitUsageToInvoiceLineItem($data: CareBenefitUsageToInvoiceLineItemCreateInput!) {
  createOneCareBenefitUsageToInvoiceLineItem(data: $data) {
    id
  }
}
    `;
export type CreateCareBenefitUsageToInvoiceLineItemMutationFn = Apollo.MutationFunction<CreateCareBenefitUsageToInvoiceLineItemMutation, CreateCareBenefitUsageToInvoiceLineItemMutationVariables>;

/**
 * __useCreateCareBenefitUsageToInvoiceLineItemMutation__
 *
 * To run a mutation, you first call `useCreateCareBenefitUsageToInvoiceLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCareBenefitUsageToInvoiceLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCareBenefitUsageToInvoiceLineItemMutation, { data, loading, error }] = useCreateCareBenefitUsageToInvoiceLineItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCareBenefitUsageToInvoiceLineItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateCareBenefitUsageToInvoiceLineItemMutation, CreateCareBenefitUsageToInvoiceLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCareBenefitUsageToInvoiceLineItemMutation, CreateCareBenefitUsageToInvoiceLineItemMutationVariables>(CreateCareBenefitUsageToInvoiceLineItemDocument, options);
      }
export type CreateCareBenefitUsageToInvoiceLineItemMutationHookResult = ReturnType<typeof useCreateCareBenefitUsageToInvoiceLineItemMutation>;
export type CreateCareBenefitUsageToInvoiceLineItemMutationResult = Apollo.MutationResult<CreateCareBenefitUsageToInvoiceLineItemMutation>;
export type CreateCareBenefitUsageToInvoiceLineItemMutationOptions = Apollo.BaseMutationOptions<CreateCareBenefitUsageToInvoiceLineItemMutation, CreateCareBenefitUsageToInvoiceLineItemMutationVariables>;
export const GetClinicChannelPetParentsDocument = gql`
    query getClinicChannelPetParents($where: ChannelWhereUniqueInput!) {
  findUniqueChannel(where: $where) {
    id
    channelType
    friendlyName
    channelMembers {
      id
      removedAt
      clinicPetParent {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetClinicChannelPetParentsQuery__
 *
 * To run a query within a React component, call `useGetClinicChannelPetParentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicChannelPetParentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicChannelPetParentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicChannelPetParentsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicChannelPetParentsQuery, GetClinicChannelPetParentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicChannelPetParentsQuery, GetClinicChannelPetParentsQueryVariables>(GetClinicChannelPetParentsDocument, options);
      }
export function useGetClinicChannelPetParentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicChannelPetParentsQuery, GetClinicChannelPetParentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicChannelPetParentsQuery, GetClinicChannelPetParentsQueryVariables>(GetClinicChannelPetParentsDocument, options);
        }
export type GetClinicChannelPetParentsQueryHookResult = ReturnType<typeof useGetClinicChannelPetParentsQuery>;
export type GetClinicChannelPetParentsLazyQueryHookResult = ReturnType<typeof useGetClinicChannelPetParentsLazyQuery>;
export type GetClinicChannelPetParentsQueryResult = Apollo.QueryResult<GetClinicChannelPetParentsQuery, GetClinicChannelPetParentsQueryVariables>;
export function refetchGetClinicChannelPetParentsQuery(variables?: GetClinicChannelPetParentsQueryVariables) {
      return { query: GetClinicChannelPetParentsDocument, variables: variables }
    }
export const GetClinicPetEnrollmentsByParentDocument = gql`
    query getClinicPetEnrollmentsByParent($where: ClinicPetParentWhereUniqueInput!, $clinicId: String!) {
  findUniqueClinicPetParent(where: $where) {
    id
    organizationPetParentId
    ...PetParentAvatar
    pets(where: {clinicId: {equals: $clinicId}, isDeleted: {equals: false}}) {
      ...SidePanelParentPetData
    }
  }
}
    ${PetParentAvatarFragmentDoc}
${SidePanelParentPetDataFragmentDoc}`;

/**
 * __useGetClinicPetEnrollmentsByParentQuery__
 *
 * To run a query within a React component, call `useGetClinicPetEnrollmentsByParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicPetEnrollmentsByParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicPetEnrollmentsByParentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicPetEnrollmentsByParentQuery(baseOptions: Apollo.QueryHookOptions<GetClinicPetEnrollmentsByParentQuery, GetClinicPetEnrollmentsByParentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicPetEnrollmentsByParentQuery, GetClinicPetEnrollmentsByParentQueryVariables>(GetClinicPetEnrollmentsByParentDocument, options);
      }
export function useGetClinicPetEnrollmentsByParentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicPetEnrollmentsByParentQuery, GetClinicPetEnrollmentsByParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicPetEnrollmentsByParentQuery, GetClinicPetEnrollmentsByParentQueryVariables>(GetClinicPetEnrollmentsByParentDocument, options);
        }
export type GetClinicPetEnrollmentsByParentQueryHookResult = ReturnType<typeof useGetClinicPetEnrollmentsByParentQuery>;
export type GetClinicPetEnrollmentsByParentLazyQueryHookResult = ReturnType<typeof useGetClinicPetEnrollmentsByParentLazyQuery>;
export type GetClinicPetEnrollmentsByParentQueryResult = Apollo.QueryResult<GetClinicPetEnrollmentsByParentQuery, GetClinicPetEnrollmentsByParentQueryVariables>;
export function refetchGetClinicPetEnrollmentsByParentQuery(variables?: GetClinicPetEnrollmentsByParentQueryVariables) {
      return { query: GetClinicPetEnrollmentsByParentDocument, variables: variables }
    }
export const GetClinicTagsDocument = gql`
    query getClinicTags($clinicId: String!) {
  findUniqueClinic(where: {id: $clinicId}) {
    clinicSetting {
      tags
    }
  }
}
    `;

/**
 * __useGetClinicTagsQuery__
 *
 * To run a query within a React component, call `useGetClinicTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicTagsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicTagsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicTagsQuery, GetClinicTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicTagsQuery, GetClinicTagsQueryVariables>(GetClinicTagsDocument, options);
      }
export function useGetClinicTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicTagsQuery, GetClinicTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicTagsQuery, GetClinicTagsQueryVariables>(GetClinicTagsDocument, options);
        }
export type GetClinicTagsQueryHookResult = ReturnType<typeof useGetClinicTagsQuery>;
export type GetClinicTagsLazyQueryHookResult = ReturnType<typeof useGetClinicTagsLazyQuery>;
export type GetClinicTagsQueryResult = Apollo.QueryResult<GetClinicTagsQuery, GetClinicTagsQueryVariables>;
export function refetchGetClinicTagsQuery(variables?: GetClinicTagsQueryVariables) {
      return { query: GetClinicTagsDocument, variables: variables }
    }
export const GetDirectedCareLoginLinkDocument = gql`
    mutation getDirectedCareLoginLink($data: DirectedAuthLinkInput!) {
  getDirectedCareLoginLink(data: $data) {
    link
  }
}
    `;
export type GetDirectedCareLoginLinkMutationFn = Apollo.MutationFunction<GetDirectedCareLoginLinkMutation, GetDirectedCareLoginLinkMutationVariables>;

/**
 * __useGetDirectedCareLoginLinkMutation__
 *
 * To run a mutation, you first call `useGetDirectedCareLoginLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetDirectedCareLoginLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getDirectedCareLoginLinkMutation, { data, loading, error }] = useGetDirectedCareLoginLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetDirectedCareLoginLinkMutation(baseOptions?: Apollo.MutationHookOptions<GetDirectedCareLoginLinkMutation, GetDirectedCareLoginLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetDirectedCareLoginLinkMutation, GetDirectedCareLoginLinkMutationVariables>(GetDirectedCareLoginLinkDocument, options);
      }
export type GetDirectedCareLoginLinkMutationHookResult = ReturnType<typeof useGetDirectedCareLoginLinkMutation>;
export type GetDirectedCareLoginLinkMutationResult = Apollo.MutationResult<GetDirectedCareLoginLinkMutation>;
export type GetDirectedCareLoginLinkMutationOptions = Apollo.BaseMutationOptions<GetDirectedCareLoginLinkMutation, GetDirectedCareLoginLinkMutationVariables>;
export const GetExistingChannelMembersDocument = gql`
    query getExistingChannelMembers($clinicPetParentIds: [String!]!, $channelStatusAction: EnumChannelStatusActionFilter) {
  findManyChannelMember(
    where: {clinicPetParent: {id: {in: $clinicPetParentIds}}, channel: {channelStatus: {channelStatusAction: $channelStatusAction}}, removedAt: {equals: null}}
  ) {
    id
    channelId
    channel {
      id
    }
  }
}
    `;

/**
 * __useGetExistingChannelMembersQuery__
 *
 * To run a query within a React component, call `useGetExistingChannelMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingChannelMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingChannelMembersQuery({
 *   variables: {
 *      clinicPetParentIds: // value for 'clinicPetParentIds'
 *      channelStatusAction: // value for 'channelStatusAction'
 *   },
 * });
 */
export function useGetExistingChannelMembersQuery(baseOptions: Apollo.QueryHookOptions<GetExistingChannelMembersQuery, GetExistingChannelMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExistingChannelMembersQuery, GetExistingChannelMembersQueryVariables>(GetExistingChannelMembersDocument, options);
      }
export function useGetExistingChannelMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExistingChannelMembersQuery, GetExistingChannelMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExistingChannelMembersQuery, GetExistingChannelMembersQueryVariables>(GetExistingChannelMembersDocument, options);
        }
export type GetExistingChannelMembersQueryHookResult = ReturnType<typeof useGetExistingChannelMembersQuery>;
export type GetExistingChannelMembersLazyQueryHookResult = ReturnType<typeof useGetExistingChannelMembersLazyQuery>;
export type GetExistingChannelMembersQueryResult = Apollo.QueryResult<GetExistingChannelMembersQuery, GetExistingChannelMembersQueryVariables>;
export function refetchGetExistingChannelMembersQuery(variables?: GetExistingChannelMembersQueryVariables) {
      return { query: GetExistingChannelMembersDocument, variables: variables }
    }
export const GetFormSubmissionDocument = gql`
    query getFormSubmission($formSubmissionId: String!, $clinicId: String!) {
  findUniqueFormSubmission(where: {id: $formSubmissionId}) {
    ...FormSubmission
  }
}
    ${FormSubmissionFragmentDoc}`;

/**
 * __useGetFormSubmissionQuery__
 *
 * To run a query within a React component, call `useGetFormSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormSubmissionQuery({
 *   variables: {
 *      formSubmissionId: // value for 'formSubmissionId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetFormSubmissionQuery(baseOptions: Apollo.QueryHookOptions<GetFormSubmissionQuery, GetFormSubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormSubmissionQuery, GetFormSubmissionQueryVariables>(GetFormSubmissionDocument, options);
      }
export function useGetFormSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormSubmissionQuery, GetFormSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormSubmissionQuery, GetFormSubmissionQueryVariables>(GetFormSubmissionDocument, options);
        }
export type GetFormSubmissionQueryHookResult = ReturnType<typeof useGetFormSubmissionQuery>;
export type GetFormSubmissionLazyQueryHookResult = ReturnType<typeof useGetFormSubmissionLazyQuery>;
export type GetFormSubmissionQueryResult = Apollo.QueryResult<GetFormSubmissionQuery, GetFormSubmissionQueryVariables>;
export function refetchGetFormSubmissionQuery(variables?: GetFormSubmissionQueryVariables) {
      return { query: GetFormSubmissionDocument, variables: variables }
    }
export const GetSignedUploadUrlDocument = gql`
    mutation getSignedUploadUrl($data: GetSignedUploadInput!) {
  getSignedUploadUrl(data: $data) {
    key
    uploadUrl
    finalUrl
  }
}
    `;
export type GetSignedUploadUrlMutationFn = Apollo.MutationFunction<GetSignedUploadUrlMutation, GetSignedUploadUrlMutationVariables>;

/**
 * __useGetSignedUploadUrlMutation__
 *
 * To run a mutation, you first call `useGetSignedUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSignedUploadUrlMutation, { data, loading, error }] = useGetSignedUploadUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSignedUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetSignedUploadUrlMutation, GetSignedUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetSignedUploadUrlMutation, GetSignedUploadUrlMutationVariables>(GetSignedUploadUrlDocument, options);
      }
export type GetSignedUploadUrlMutationHookResult = ReturnType<typeof useGetSignedUploadUrlMutation>;
export type GetSignedUploadUrlMutationResult = Apollo.MutationResult<GetSignedUploadUrlMutation>;
export type GetSignedUploadUrlMutationOptions = Apollo.BaseMutationOptions<GetSignedUploadUrlMutation, GetSignedUploadUrlMutationVariables>;
export const RemoveChannelTagDocument = gql`
    mutation removeChannelTag($channelId: String!, $tagName: String!) {
  removeChannelTag(channelId: $channelId, tagName: $tagName) {
    id
    tags
  }
}
    `;
export type RemoveChannelTagMutationFn = Apollo.MutationFunction<RemoveChannelTagMutation, RemoveChannelTagMutationVariables>;

/**
 * __useRemoveChannelTagMutation__
 *
 * To run a mutation, you first call `useRemoveChannelTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChannelTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChannelTagMutation, { data, loading, error }] = useRemoveChannelTagMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      tagName: // value for 'tagName'
 *   },
 * });
 */
export function useRemoveChannelTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChannelTagMutation, RemoveChannelTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChannelTagMutation, RemoveChannelTagMutationVariables>(RemoveChannelTagDocument, options);
      }
export type RemoveChannelTagMutationHookResult = ReturnType<typeof useRemoveChannelTagMutation>;
export type RemoveChannelTagMutationResult = Apollo.MutationResult<RemoveChannelTagMutation>;
export type RemoveChannelTagMutationOptions = Apollo.BaseMutationOptions<RemoveChannelTagMutation, RemoveChannelTagMutationVariables>;
export const SaveWorkflowEventSettingsDocument = gql`
    mutation saveWorkflowEventSettings($data: WorkflowEventSettingUpdateInput!, $where: WorkflowEventSettingWhereUniqueInput!) {
  updateOneWorkflowEventSetting(data: $data, where: $where) {
    id
    name
    surveySettingId
    surveyStep
    surveyType
    actions {
      id
      actionType
      order
      config
      channelStatusChangeId
      channelStatusChange {
        id
        name
      }
    }
    notificationBody
    event
  }
}
    `;
export type SaveWorkflowEventSettingsMutationFn = Apollo.MutationFunction<SaveWorkflowEventSettingsMutation, SaveWorkflowEventSettingsMutationVariables>;

/**
 * __useSaveWorkflowEventSettingsMutation__
 *
 * To run a mutation, you first call `useSaveWorkflowEventSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorkflowEventSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWorkflowEventSettingsMutation, { data, loading, error }] = useSaveWorkflowEventSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSaveWorkflowEventSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveWorkflowEventSettingsMutation, SaveWorkflowEventSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveWorkflowEventSettingsMutation, SaveWorkflowEventSettingsMutationVariables>(SaveWorkflowEventSettingsDocument, options);
      }
export type SaveWorkflowEventSettingsMutationHookResult = ReturnType<typeof useSaveWorkflowEventSettingsMutation>;
export type SaveWorkflowEventSettingsMutationResult = Apollo.MutationResult<SaveWorkflowEventSettingsMutation>;
export type SaveWorkflowEventSettingsMutationOptions = Apollo.BaseMutationOptions<SaveWorkflowEventSettingsMutation, SaveWorkflowEventSettingsMutationVariables>;
export const UpdateChannelStatusDocument = gql`
    mutation updateChannelStatus($where: ChannelWhereUniqueInput!, $data: ChannelUpdateInput!) {
  updateOneChannel(where: $where, data: $data) {
    id
    clinicId
    channelStatusId
    channelStatus {
      ...ChannelListChannelStatus
    }
  }
}
    ${ChannelListChannelStatusFragmentDoc}`;
export type UpdateChannelStatusMutationFn = Apollo.MutationFunction<UpdateChannelStatusMutation, UpdateChannelStatusMutationVariables>;

/**
 * __useUpdateChannelStatusMutation__
 *
 * To run a mutation, you first call `useUpdateChannelStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelStatusMutation, { data, loading, error }] = useUpdateChannelStatusMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChannelStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelStatusMutation, UpdateChannelStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelStatusMutation, UpdateChannelStatusMutationVariables>(UpdateChannelStatusDocument, options);
      }
export type UpdateChannelStatusMutationHookResult = ReturnType<typeof useUpdateChannelStatusMutation>;
export type UpdateChannelStatusMutationResult = Apollo.MutationResult<UpdateChannelStatusMutation>;
export type UpdateChannelStatusMutationOptions = Apollo.BaseMutationOptions<UpdateChannelStatusMutation, UpdateChannelStatusMutationVariables>;
export const CreateOneUserAppointmentGroupingDocument = gql`
    mutation createOneUserAppointmentGrouping($data: UserAppointmentGroupingCreateInput!) {
  createOneUserAppointmentGrouping(data: $data) {
    ...UserAppointmentGroupingFullSelection
  }
}
    ${UserAppointmentGroupingFullSelectionFragmentDoc}`;
export type CreateOneUserAppointmentGroupingMutationFn = Apollo.MutationFunction<CreateOneUserAppointmentGroupingMutation, CreateOneUserAppointmentGroupingMutationVariables>;

/**
 * __useCreateOneUserAppointmentGroupingMutation__
 *
 * To run a mutation, you first call `useCreateOneUserAppointmentGroupingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneUserAppointmentGroupingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneUserAppointmentGroupingMutation, { data, loading, error }] = useCreateOneUserAppointmentGroupingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneUserAppointmentGroupingMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneUserAppointmentGroupingMutation, CreateOneUserAppointmentGroupingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneUserAppointmentGroupingMutation, CreateOneUserAppointmentGroupingMutationVariables>(CreateOneUserAppointmentGroupingDocument, options);
      }
export type CreateOneUserAppointmentGroupingMutationHookResult = ReturnType<typeof useCreateOneUserAppointmentGroupingMutation>;
export type CreateOneUserAppointmentGroupingMutationResult = Apollo.MutationResult<CreateOneUserAppointmentGroupingMutation>;
export type CreateOneUserAppointmentGroupingMutationOptions = Apollo.BaseMutationOptions<CreateOneUserAppointmentGroupingMutation, CreateOneUserAppointmentGroupingMutationVariables>;
export const UpdateOneUserAppointmentGroupingDocument = gql`
    mutation updateOneUserAppointmentGrouping($data: UserAppointmentGroupingUpdateInput!, $where: UserAppointmentGroupingWhereUniqueInput!) {
  updateOneUserAppointmentGrouping(data: $data, where: $where) {
    ...UserAppointmentGroupingFullSelection
  }
}
    ${UserAppointmentGroupingFullSelectionFragmentDoc}`;
export type UpdateOneUserAppointmentGroupingMutationFn = Apollo.MutationFunction<UpdateOneUserAppointmentGroupingMutation, UpdateOneUserAppointmentGroupingMutationVariables>;

/**
 * __useUpdateOneUserAppointmentGroupingMutation__
 *
 * To run a mutation, you first call `useUpdateOneUserAppointmentGroupingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneUserAppointmentGroupingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneUserAppointmentGroupingMutation, { data, loading, error }] = useUpdateOneUserAppointmentGroupingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneUserAppointmentGroupingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneUserAppointmentGroupingMutation, UpdateOneUserAppointmentGroupingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneUserAppointmentGroupingMutation, UpdateOneUserAppointmentGroupingMutationVariables>(UpdateOneUserAppointmentGroupingDocument, options);
      }
export type UpdateOneUserAppointmentGroupingMutationHookResult = ReturnType<typeof useUpdateOneUserAppointmentGroupingMutation>;
export type UpdateOneUserAppointmentGroupingMutationResult = Apollo.MutationResult<UpdateOneUserAppointmentGroupingMutation>;
export type UpdateOneUserAppointmentGroupingMutationOptions = Apollo.BaseMutationOptions<UpdateOneUserAppointmentGroupingMutation, UpdateOneUserAppointmentGroupingMutationVariables>;
export const DeleteOneUserAppointmentGroupingDocument = gql`
    mutation deleteOneUserAppointmentGrouping($where: UserAppointmentGroupingWhereUniqueInput!) {
  deleteOneUserAppointmentGrouping(where: $where) {
    ...UserAppointmentGroupingFullSelection
  }
}
    ${UserAppointmentGroupingFullSelectionFragmentDoc}`;
export type DeleteOneUserAppointmentGroupingMutationFn = Apollo.MutationFunction<DeleteOneUserAppointmentGroupingMutation, DeleteOneUserAppointmentGroupingMutationVariables>;

/**
 * __useDeleteOneUserAppointmentGroupingMutation__
 *
 * To run a mutation, you first call `useDeleteOneUserAppointmentGroupingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneUserAppointmentGroupingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneUserAppointmentGroupingMutation, { data, loading, error }] = useDeleteOneUserAppointmentGroupingMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneUserAppointmentGroupingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneUserAppointmentGroupingMutation, DeleteOneUserAppointmentGroupingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneUserAppointmentGroupingMutation, DeleteOneUserAppointmentGroupingMutationVariables>(DeleteOneUserAppointmentGroupingDocument, options);
      }
export type DeleteOneUserAppointmentGroupingMutationHookResult = ReturnType<typeof useDeleteOneUserAppointmentGroupingMutation>;
export type DeleteOneUserAppointmentGroupingMutationResult = Apollo.MutationResult<DeleteOneUserAppointmentGroupingMutation>;
export type DeleteOneUserAppointmentGroupingMutationOptions = Apollo.BaseMutationOptions<DeleteOneUserAppointmentGroupingMutation, DeleteOneUserAppointmentGroupingMutationVariables>;
export const FindManyUserAppointmentGroupingDocument = gql`
    query findManyUserAppointmentGrouping($where: UserAppointmentGroupingWhereInput, $orderBy: [UserAppointmentGroupingOrderByWithRelationInput!], $skip: Int, $take: Int) {
  findManyUserAppointmentGrouping(
    where: $where
    orderBy: $orderBy
    skip: $skip
    take: $take
  ) {
    ...UserAppointmentGroupingFullSelection
  }
}
    ${UserAppointmentGroupingFullSelectionFragmentDoc}`;

/**
 * __useFindManyUserAppointmentGroupingQuery__
 *
 * To run a query within a React component, call `useFindManyUserAppointmentGroupingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyUserAppointmentGroupingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyUserAppointmentGroupingQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useFindManyUserAppointmentGroupingQuery(baseOptions?: Apollo.QueryHookOptions<FindManyUserAppointmentGroupingQuery, FindManyUserAppointmentGroupingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyUserAppointmentGroupingQuery, FindManyUserAppointmentGroupingQueryVariables>(FindManyUserAppointmentGroupingDocument, options);
      }
export function useFindManyUserAppointmentGroupingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyUserAppointmentGroupingQuery, FindManyUserAppointmentGroupingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyUserAppointmentGroupingQuery, FindManyUserAppointmentGroupingQueryVariables>(FindManyUserAppointmentGroupingDocument, options);
        }
export type FindManyUserAppointmentGroupingQueryHookResult = ReturnType<typeof useFindManyUserAppointmentGroupingQuery>;
export type FindManyUserAppointmentGroupingLazyQueryHookResult = ReturnType<typeof useFindManyUserAppointmentGroupingLazyQuery>;
export type FindManyUserAppointmentGroupingQueryResult = Apollo.QueryResult<FindManyUserAppointmentGroupingQuery, FindManyUserAppointmentGroupingQueryVariables>;
export function refetchFindManyUserAppointmentGroupingQuery(variables?: FindManyUserAppointmentGroupingQueryVariables) {
      return { query: FindManyUserAppointmentGroupingDocument, variables: variables }
    }
export const GetClinicPetParentAvatarPhoneNumbersDocument = gql`
    query getClinicPetParentAvatarPhoneNumbers($clinicPetParentId: String!) {
  findUniqueClinicPetParent(where: {id: $clinicPetParentId}) {
    id
    phoneNumbers {
      id
      updatedAt
      number
      isPrimary
      isDeleted
    }
  }
}
    `;

/**
 * __useGetClinicPetParentAvatarPhoneNumbersQuery__
 *
 * To run a query within a React component, call `useGetClinicPetParentAvatarPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicPetParentAvatarPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicPetParentAvatarPhoneNumbersQuery({
 *   variables: {
 *      clinicPetParentId: // value for 'clinicPetParentId'
 *   },
 * });
 */
export function useGetClinicPetParentAvatarPhoneNumbersQuery(baseOptions: Apollo.QueryHookOptions<GetClinicPetParentAvatarPhoneNumbersQuery, GetClinicPetParentAvatarPhoneNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicPetParentAvatarPhoneNumbersQuery, GetClinicPetParentAvatarPhoneNumbersQueryVariables>(GetClinicPetParentAvatarPhoneNumbersDocument, options);
      }
export function useGetClinicPetParentAvatarPhoneNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicPetParentAvatarPhoneNumbersQuery, GetClinicPetParentAvatarPhoneNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicPetParentAvatarPhoneNumbersQuery, GetClinicPetParentAvatarPhoneNumbersQueryVariables>(GetClinicPetParentAvatarPhoneNumbersDocument, options);
        }
export type GetClinicPetParentAvatarPhoneNumbersQueryHookResult = ReturnType<typeof useGetClinicPetParentAvatarPhoneNumbersQuery>;
export type GetClinicPetParentAvatarPhoneNumbersLazyQueryHookResult = ReturnType<typeof useGetClinicPetParentAvatarPhoneNumbersLazyQuery>;
export type GetClinicPetParentAvatarPhoneNumbersQueryResult = Apollo.QueryResult<GetClinicPetParentAvatarPhoneNumbersQuery, GetClinicPetParentAvatarPhoneNumbersQueryVariables>;
export function refetchGetClinicPetParentAvatarPhoneNumbersQuery(variables?: GetClinicPetParentAvatarPhoneNumbersQueryVariables) {
      return { query: GetClinicPetParentAvatarPhoneNumbersDocument, variables: variables }
    }
export const GetConversationStatusOptionsDocument = gql`
    query getConversationStatusOptions($clinicId: String!) {
  findManyChannelStatus(
    where: {clinicSetting: {clinic: {id: {equals: $clinicId}}}, deletedOn: {equals: null}}
    orderBy: {order: asc}
  ) {
    id
    color
    name
    channelStatusAction
  }
}
    `;

/**
 * __useGetConversationStatusOptionsQuery__
 *
 * To run a query within a React component, call `useGetConversationStatusOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationStatusOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationStatusOptionsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetConversationStatusOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetConversationStatusOptionsQuery, GetConversationStatusOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationStatusOptionsQuery, GetConversationStatusOptionsQueryVariables>(GetConversationStatusOptionsDocument, options);
      }
export function useGetConversationStatusOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationStatusOptionsQuery, GetConversationStatusOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationStatusOptionsQuery, GetConversationStatusOptionsQueryVariables>(GetConversationStatusOptionsDocument, options);
        }
export type GetConversationStatusOptionsQueryHookResult = ReturnType<typeof useGetConversationStatusOptionsQuery>;
export type GetConversationStatusOptionsLazyQueryHookResult = ReturnType<typeof useGetConversationStatusOptionsLazyQuery>;
export type GetConversationStatusOptionsQueryResult = Apollo.QueryResult<GetConversationStatusOptionsQuery, GetConversationStatusOptionsQueryVariables>;
export function refetchGetConversationStatusOptionsQuery(variables?: GetConversationStatusOptionsQueryVariables) {
      return { query: GetConversationStatusOptionsDocument, variables: variables }
    }
export const UpdateCreatePasswordModalUserDocument = gql`
    mutation updateCreatePasswordModalUser($where: UserWhereUniqueInput!, $data: UserUpdateInput!) {
  updateOneUser(where: $where, data: $data) {
    id
    firstName
    lastName
    namePrefix
    nameSuffix
    email
    phone
    isNewPasswordRequired
  }
}
    `;
export type UpdateCreatePasswordModalUserMutationFn = Apollo.MutationFunction<UpdateCreatePasswordModalUserMutation, UpdateCreatePasswordModalUserMutationVariables>;

/**
 * __useUpdateCreatePasswordModalUserMutation__
 *
 * To run a mutation, you first call `useUpdateCreatePasswordModalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreatePasswordModalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreatePasswordModalUserMutation, { data, loading, error }] = useUpdateCreatePasswordModalUserMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCreatePasswordModalUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreatePasswordModalUserMutation, UpdateCreatePasswordModalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreatePasswordModalUserMutation, UpdateCreatePasswordModalUserMutationVariables>(UpdateCreatePasswordModalUserDocument, options);
      }
export type UpdateCreatePasswordModalUserMutationHookResult = ReturnType<typeof useUpdateCreatePasswordModalUserMutation>;
export type UpdateCreatePasswordModalUserMutationResult = Apollo.MutationResult<UpdateCreatePasswordModalUserMutation>;
export type UpdateCreatePasswordModalUserMutationOptions = Apollo.BaseMutationOptions<UpdateCreatePasswordModalUserMutation, UpdateCreatePasswordModalUserMutationVariables>;
export const CreateEmailTemplateVersionDocument = gql`
    mutation createEmailTemplateVersion($data: CreateEmailTemplateVersionInput!) {
  createEmailTemplateVersion(data: $data) {
    ...EmailTemplateVersion
  }
}
    ${EmailTemplateVersionFragmentDoc}`;
export type CreateEmailTemplateVersionMutationFn = Apollo.MutationFunction<CreateEmailTemplateVersionMutation, CreateEmailTemplateVersionMutationVariables>;

/**
 * __useCreateEmailTemplateVersionMutation__
 *
 * To run a mutation, you first call `useCreateEmailTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailTemplateVersionMutation, { data, loading, error }] = useCreateEmailTemplateVersionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEmailTemplateVersionMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailTemplateVersionMutation, CreateEmailTemplateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailTemplateVersionMutation, CreateEmailTemplateVersionMutationVariables>(CreateEmailTemplateVersionDocument, options);
      }
export type CreateEmailTemplateVersionMutationHookResult = ReturnType<typeof useCreateEmailTemplateVersionMutation>;
export type CreateEmailTemplateVersionMutationResult = Apollo.MutationResult<CreateEmailTemplateVersionMutation>;
export type CreateEmailTemplateVersionMutationOptions = Apollo.BaseMutationOptions<CreateEmailTemplateVersionMutation, CreateEmailTemplateVersionMutationVariables>;
export const SaveEmailTemplateVersionDocument = gql`
    mutation saveEmailTemplateVersion($data: SaveEmailTemplateVersionInput!) {
  saveEmailTemplateVersion(data: $data) {
    ...EmailTemplateVersion
  }
}
    ${EmailTemplateVersionFragmentDoc}`;
export type SaveEmailTemplateVersionMutationFn = Apollo.MutationFunction<SaveEmailTemplateVersionMutation, SaveEmailTemplateVersionMutationVariables>;

/**
 * __useSaveEmailTemplateVersionMutation__
 *
 * To run a mutation, you first call `useSaveEmailTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEmailTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEmailTemplateVersionMutation, { data, loading, error }] = useSaveEmailTemplateVersionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveEmailTemplateVersionMutation(baseOptions?: Apollo.MutationHookOptions<SaveEmailTemplateVersionMutation, SaveEmailTemplateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEmailTemplateVersionMutation, SaveEmailTemplateVersionMutationVariables>(SaveEmailTemplateVersionDocument, options);
      }
export type SaveEmailTemplateVersionMutationHookResult = ReturnType<typeof useSaveEmailTemplateVersionMutation>;
export type SaveEmailTemplateVersionMutationResult = Apollo.MutationResult<SaveEmailTemplateVersionMutation>;
export type SaveEmailTemplateVersionMutationOptions = Apollo.BaseMutationOptions<SaveEmailTemplateVersionMutation, SaveEmailTemplateVersionMutationVariables>;
export const UpdateOneEmailTemplateVersionDocument = gql`
    mutation updateOneEmailTemplateVersion($data: EmailTemplateVersionUpdateInput!, $where: EmailTemplateVersionWhereUniqueInput!) {
  updateOneEmailTemplateVersion(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateOneEmailTemplateVersionMutationFn = Apollo.MutationFunction<UpdateOneEmailTemplateVersionMutation, UpdateOneEmailTemplateVersionMutationVariables>;

/**
 * __useUpdateOneEmailTemplateVersionMutation__
 *
 * To run a mutation, you first call `useUpdateOneEmailTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneEmailTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneEmailTemplateVersionMutation, { data, loading, error }] = useUpdateOneEmailTemplateVersionMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneEmailTemplateVersionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneEmailTemplateVersionMutation, UpdateOneEmailTemplateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneEmailTemplateVersionMutation, UpdateOneEmailTemplateVersionMutationVariables>(UpdateOneEmailTemplateVersionDocument, options);
      }
export type UpdateOneEmailTemplateVersionMutationHookResult = ReturnType<typeof useUpdateOneEmailTemplateVersionMutation>;
export type UpdateOneEmailTemplateVersionMutationResult = Apollo.MutationResult<UpdateOneEmailTemplateVersionMutation>;
export type UpdateOneEmailTemplateVersionMutationOptions = Apollo.BaseMutationOptions<UpdateOneEmailTemplateVersionMutation, UpdateOneEmailTemplateVersionMutationVariables>;
export const FindCurrentEmailTemplateVersionsDocument = gql`
    query findCurrentEmailTemplateVersions($data: FindCurrentEmailTemplateVersionInput!) {
  findCurrentEmailTemplateVersions(data: $data) {
    unlayer {
      userId
      signature
    }
    draft {
      ...EmailTemplateVersion
    }
    published {
      ...EmailTemplateVersion
    }
  }
}
    ${EmailTemplateVersionFragmentDoc}`;

/**
 * __useFindCurrentEmailTemplateVersionsQuery__
 *
 * To run a query within a React component, call `useFindCurrentEmailTemplateVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCurrentEmailTemplateVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCurrentEmailTemplateVersionsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFindCurrentEmailTemplateVersionsQuery(baseOptions: Apollo.QueryHookOptions<FindCurrentEmailTemplateVersionsQuery, FindCurrentEmailTemplateVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCurrentEmailTemplateVersionsQuery, FindCurrentEmailTemplateVersionsQueryVariables>(FindCurrentEmailTemplateVersionsDocument, options);
      }
export function useFindCurrentEmailTemplateVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCurrentEmailTemplateVersionsQuery, FindCurrentEmailTemplateVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCurrentEmailTemplateVersionsQuery, FindCurrentEmailTemplateVersionsQueryVariables>(FindCurrentEmailTemplateVersionsDocument, options);
        }
export type FindCurrentEmailTemplateVersionsQueryHookResult = ReturnType<typeof useFindCurrentEmailTemplateVersionsQuery>;
export type FindCurrentEmailTemplateVersionsLazyQueryHookResult = ReturnType<typeof useFindCurrentEmailTemplateVersionsLazyQuery>;
export type FindCurrentEmailTemplateVersionsQueryResult = Apollo.QueryResult<FindCurrentEmailTemplateVersionsQuery, FindCurrentEmailTemplateVersionsQueryVariables>;
export function refetchFindCurrentEmailTemplateVersionsQuery(variables?: FindCurrentEmailTemplateVersionsQueryVariables) {
      return { query: FindCurrentEmailTemplateVersionsDocument, variables: variables }
    }
export const FindManyRecapDocument = gql`
    query findManyRecap($where: RecapWhereInput, $orderBy: [RecapOrderByWithRelationInput], $take: Int) {
  findManyRecap(where: $where, orderBy: $orderBy, take: $take) {
    ...RecapBase
  }
}
    ${RecapBaseFragmentDoc}`;

/**
 * __useFindManyRecapQuery__
 *
 * To run a query within a React component, call `useFindManyRecapQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyRecapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyRecapQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useFindManyRecapQuery(baseOptions?: Apollo.QueryHookOptions<FindManyRecapQuery, FindManyRecapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyRecapQuery, FindManyRecapQueryVariables>(FindManyRecapDocument, options);
      }
export function useFindManyRecapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyRecapQuery, FindManyRecapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyRecapQuery, FindManyRecapQueryVariables>(FindManyRecapDocument, options);
        }
export type FindManyRecapQueryHookResult = ReturnType<typeof useFindManyRecapQuery>;
export type FindManyRecapLazyQueryHookResult = ReturnType<typeof useFindManyRecapLazyQuery>;
export type FindManyRecapQueryResult = Apollo.QueryResult<FindManyRecapQuery, FindManyRecapQueryVariables>;
export function refetchFindManyRecapQuery(variables?: FindManyRecapQueryVariables) {
      return { query: FindManyRecapDocument, variables: variables }
    }
export const RecapChangedDocument = gql`
    subscription recapChanged($where: SubscriptionRecapWhereInput!) {
  recapChanged(where: $where) {
    node {
      id
      clinicId
    }
    mutation
  }
}
    `;

/**
 * __useRecapChangedSubscription__
 *
 * To run a query within a React component, call `useRecapChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRecapChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecapChangedSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRecapChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<RecapChangedSubscription, RecapChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RecapChangedSubscription, RecapChangedSubscriptionVariables>(RecapChangedDocument, options);
      }
export type RecapChangedSubscriptionHookResult = ReturnType<typeof useRecapChangedSubscription>;
export type RecapChangedSubscriptionResult = Apollo.SubscriptionResult<RecapChangedSubscription>;
export const MergePetParentProfilesDocument = gql`
    mutation mergePetParentProfiles($data: MergePetParentInput) {
  mergePetParent(data: $data) {
    success
    messages
  }
}
    `;
export type MergePetParentProfilesMutationFn = Apollo.MutationFunction<MergePetParentProfilesMutation, MergePetParentProfilesMutationVariables>;

/**
 * __useMergePetParentProfilesMutation__
 *
 * To run a mutation, you first call `useMergePetParentProfilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergePetParentProfilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergePetParentProfilesMutation, { data, loading, error }] = useMergePetParentProfilesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMergePetParentProfilesMutation(baseOptions?: Apollo.MutationHookOptions<MergePetParentProfilesMutation, MergePetParentProfilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergePetParentProfilesMutation, MergePetParentProfilesMutationVariables>(MergePetParentProfilesDocument, options);
      }
export type MergePetParentProfilesMutationHookResult = ReturnType<typeof useMergePetParentProfilesMutation>;
export type MergePetParentProfilesMutationResult = Apollo.MutationResult<MergePetParentProfilesMutation>;
export type MergePetParentProfilesMutationOptions = Apollo.BaseMutationOptions<MergePetParentProfilesMutation, MergePetParentProfilesMutationVariables>;
export const MergeProfileClientSearchDocument = gql`
    query mergeProfileClientSearch($where: SearchClinicPetParentInput, $clinicId: String!, $take: Int) {
  clinicPetParentSearch(where: $where, take: $take) {
    id
    isTest
    pimsId
    firstName
    lastName
    pets(
      where: {clinicId: {equals: $clinicId}, isActive: {equals: true}, isDeceased: {equals: false}, isDeleted: {equals: false}}
    ) {
      id
      pimsId
      speciesType
      name
      organizationPet {
        id
        carePlanEnrollments(
          where: {status: {notIn: [Pending, Cancelling, Expired, PaymentFailed]}}
        ) {
          id
        }
      }
    }
    loyaltyAccountHolder {
      id
      account {
        pointBalance
        rewardRedemptions {
          id
        }
      }
    }
    channelMembers(where: {removedAt: {equals: null}}) {
      id
      channel {
        channelStatus {
          channelStatusAction
        }
      }
    }
  }
}
    `;

/**
 * __useMergeProfileClientSearchQuery__
 *
 * To run a query within a React component, call `useMergeProfileClientSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeProfileClientSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMergeProfileClientSearchQuery({
 *   variables: {
 *      where: // value for 'where'
 *      clinicId: // value for 'clinicId'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useMergeProfileClientSearchQuery(baseOptions: Apollo.QueryHookOptions<MergeProfileClientSearchQuery, MergeProfileClientSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MergeProfileClientSearchQuery, MergeProfileClientSearchQueryVariables>(MergeProfileClientSearchDocument, options);
      }
export function useMergeProfileClientSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MergeProfileClientSearchQuery, MergeProfileClientSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MergeProfileClientSearchQuery, MergeProfileClientSearchQueryVariables>(MergeProfileClientSearchDocument, options);
        }
export type MergeProfileClientSearchQueryHookResult = ReturnType<typeof useMergeProfileClientSearchQuery>;
export type MergeProfileClientSearchLazyQueryHookResult = ReturnType<typeof useMergeProfileClientSearchLazyQuery>;
export type MergeProfileClientSearchQueryResult = Apollo.QueryResult<MergeProfileClientSearchQuery, MergeProfileClientSearchQueryVariables>;
export function refetchMergeProfileClientSearchQuery(variables?: MergeProfileClientSearchQueryVariables) {
      return { query: MergeProfileClientSearchDocument, variables: variables }
    }
export const GetNonItemizedReceiptPdfDocument = gql`
    query getNonItemizedReceiptPdf($intentId: String!) {
  exportNonItemizedReceiptAsPdf(data: {stripePaymentIntentId: $intentId}) {
    success
    base64PDF
  }
}
    `;

/**
 * __useGetNonItemizedReceiptPdfQuery__
 *
 * To run a query within a React component, call `useGetNonItemizedReceiptPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonItemizedReceiptPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonItemizedReceiptPdfQuery({
 *   variables: {
 *      intentId: // value for 'intentId'
 *   },
 * });
 */
export function useGetNonItemizedReceiptPdfQuery(baseOptions: Apollo.QueryHookOptions<GetNonItemizedReceiptPdfQuery, GetNonItemizedReceiptPdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonItemizedReceiptPdfQuery, GetNonItemizedReceiptPdfQueryVariables>(GetNonItemizedReceiptPdfDocument, options);
      }
export function useGetNonItemizedReceiptPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonItemizedReceiptPdfQuery, GetNonItemizedReceiptPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonItemizedReceiptPdfQuery, GetNonItemizedReceiptPdfQueryVariables>(GetNonItemizedReceiptPdfDocument, options);
        }
export type GetNonItemizedReceiptPdfQueryHookResult = ReturnType<typeof useGetNonItemizedReceiptPdfQuery>;
export type GetNonItemizedReceiptPdfLazyQueryHookResult = ReturnType<typeof useGetNonItemizedReceiptPdfLazyQuery>;
export type GetNonItemizedReceiptPdfQueryResult = Apollo.QueryResult<GetNonItemizedReceiptPdfQuery, GetNonItemizedReceiptPdfQueryVariables>;
export function refetchGetNonItemizedReceiptPdfQuery(variables?: GetNonItemizedReceiptPdfQueryVariables) {
      return { query: GetNonItemizedReceiptPdfDocument, variables: variables }
    }
export const GetReceiptPetParentDocument = gql`
    query getReceiptPetParent($clinicPetParentId: String!) {
  findUniqueClinicPetParent(where: {id: $clinicPetParentId}) {
    id
    firstName
    lastName
    phoneNumbers(where: {isPrimary: {equals: true}}) {
      id
      number
    }
    email
  }
}
    `;

/**
 * __useGetReceiptPetParentQuery__
 *
 * To run a query within a React component, call `useGetReceiptPetParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiptPetParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiptPetParentQuery({
 *   variables: {
 *      clinicPetParentId: // value for 'clinicPetParentId'
 *   },
 * });
 */
export function useGetReceiptPetParentQuery(baseOptions: Apollo.QueryHookOptions<GetReceiptPetParentQuery, GetReceiptPetParentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiptPetParentQuery, GetReceiptPetParentQueryVariables>(GetReceiptPetParentDocument, options);
      }
export function useGetReceiptPetParentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiptPetParentQuery, GetReceiptPetParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiptPetParentQuery, GetReceiptPetParentQueryVariables>(GetReceiptPetParentDocument, options);
        }
export type GetReceiptPetParentQueryHookResult = ReturnType<typeof useGetReceiptPetParentQuery>;
export type GetReceiptPetParentLazyQueryHookResult = ReturnType<typeof useGetReceiptPetParentLazyQuery>;
export type GetReceiptPetParentQueryResult = Apollo.QueryResult<GetReceiptPetParentQuery, GetReceiptPetParentQueryVariables>;
export function refetchGetReceiptPetParentQuery(variables?: GetReceiptPetParentQueryVariables) {
      return { query: GetReceiptPetParentDocument, variables: variables }
    }
export const GetStripeReceiptDocument = gql`
    query getStripeReceipt($id: String!) {
  findUniqueStripeReceipt(where: {id: $id}) {
    id
    stripeId
    applicationName
    dedicatedFileName
    accountType
  }
}
    `;

/**
 * __useGetStripeReceiptQuery__
 *
 * To run a query within a React component, call `useGetStripeReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeReceiptQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStripeReceiptQuery(baseOptions: Apollo.QueryHookOptions<GetStripeReceiptQuery, GetStripeReceiptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeReceiptQuery, GetStripeReceiptQueryVariables>(GetStripeReceiptDocument, options);
      }
export function useGetStripeReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeReceiptQuery, GetStripeReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeReceiptQuery, GetStripeReceiptQueryVariables>(GetStripeReceiptDocument, options);
        }
export type GetStripeReceiptQueryHookResult = ReturnType<typeof useGetStripeReceiptQuery>;
export type GetStripeReceiptLazyQueryHookResult = ReturnType<typeof useGetStripeReceiptLazyQuery>;
export type GetStripeReceiptQueryResult = Apollo.QueryResult<GetStripeReceiptQuery, GetStripeReceiptQueryVariables>;
export function refetchGetStripeReceiptQuery(variables?: GetStripeReceiptQueryVariables) {
      return { query: GetStripeReceiptDocument, variables: variables }
    }
export const SyncPimsIntegrationModelDocument = gql`
    mutation syncPimsIntegrationModel($data: SyncManyPimsIntegrationModelInput!) {
  syncManyPimsIntegrationModel(data: $data) {
    lastSyncedAt
  }
}
    `;
export type SyncPimsIntegrationModelMutationFn = Apollo.MutationFunction<SyncPimsIntegrationModelMutation, SyncPimsIntegrationModelMutationVariables>;

/**
 * __useSyncPimsIntegrationModelMutation__
 *
 * To run a mutation, you first call `useSyncPimsIntegrationModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPimsIntegrationModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPimsIntegrationModelMutation, { data, loading, error }] = useSyncPimsIntegrationModelMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSyncPimsIntegrationModelMutation(baseOptions?: Apollo.MutationHookOptions<SyncPimsIntegrationModelMutation, SyncPimsIntegrationModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPimsIntegrationModelMutation, SyncPimsIntegrationModelMutationVariables>(SyncPimsIntegrationModelDocument, options);
      }
export type SyncPimsIntegrationModelMutationHookResult = ReturnType<typeof useSyncPimsIntegrationModelMutation>;
export type SyncPimsIntegrationModelMutationResult = Apollo.MutationResult<SyncPimsIntegrationModelMutation>;
export type SyncPimsIntegrationModelMutationOptions = Apollo.BaseMutationOptions<SyncPimsIntegrationModelMutation, SyncPimsIntegrationModelMutationVariables>;
export const GetClinicPimsIntegrationCapabilitySyncDocument = gql`
    query getClinicPimsIntegrationCapabilitySync($where: ClinicPimsIntegrationCapabilityWhereInput) {
  findManyClinicPimsIntegrationCapability(where: $where) {
    lastSyncedAt
  }
}
    `;

/**
 * __useGetClinicPimsIntegrationCapabilitySyncQuery__
 *
 * To run a query within a React component, call `useGetClinicPimsIntegrationCapabilitySyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicPimsIntegrationCapabilitySyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicPimsIntegrationCapabilitySyncQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicPimsIntegrationCapabilitySyncQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicPimsIntegrationCapabilitySyncQuery, GetClinicPimsIntegrationCapabilitySyncQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicPimsIntegrationCapabilitySyncQuery, GetClinicPimsIntegrationCapabilitySyncQueryVariables>(GetClinicPimsIntegrationCapabilitySyncDocument, options);
      }
export function useGetClinicPimsIntegrationCapabilitySyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicPimsIntegrationCapabilitySyncQuery, GetClinicPimsIntegrationCapabilitySyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicPimsIntegrationCapabilitySyncQuery, GetClinicPimsIntegrationCapabilitySyncQueryVariables>(GetClinicPimsIntegrationCapabilitySyncDocument, options);
        }
export type GetClinicPimsIntegrationCapabilitySyncQueryHookResult = ReturnType<typeof useGetClinicPimsIntegrationCapabilitySyncQuery>;
export type GetClinicPimsIntegrationCapabilitySyncLazyQueryHookResult = ReturnType<typeof useGetClinicPimsIntegrationCapabilitySyncLazyQuery>;
export type GetClinicPimsIntegrationCapabilitySyncQueryResult = Apollo.QueryResult<GetClinicPimsIntegrationCapabilitySyncQuery, GetClinicPimsIntegrationCapabilitySyncQueryVariables>;
export function refetchGetClinicPimsIntegrationCapabilitySyncQuery(variables?: GetClinicPimsIntegrationCapabilitySyncQueryVariables) {
      return { query: GetClinicPimsIntegrationCapabilitySyncDocument, variables: variables }
    }
export const CreateOneAppointmentNoteTemplateDocument = gql`
    mutation CreateOneAppointmentNoteTemplate($data: AppointmentNoteTemplateCreateInput!) {
  createOneAppointmentNoteTemplate(data: $data) {
    id
    ...AppointmentNoteTemplateFragment
  }
}
    ${AppointmentNoteTemplateFragmentFragmentDoc}`;
export type CreateOneAppointmentNoteTemplateMutationFn = Apollo.MutationFunction<CreateOneAppointmentNoteTemplateMutation, CreateOneAppointmentNoteTemplateMutationVariables>;

/**
 * __useCreateOneAppointmentNoteTemplateMutation__
 *
 * To run a mutation, you first call `useCreateOneAppointmentNoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneAppointmentNoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneAppointmentNoteTemplateMutation, { data, loading, error }] = useCreateOneAppointmentNoteTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneAppointmentNoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneAppointmentNoteTemplateMutation, CreateOneAppointmentNoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneAppointmentNoteTemplateMutation, CreateOneAppointmentNoteTemplateMutationVariables>(CreateOneAppointmentNoteTemplateDocument, options);
      }
export type CreateOneAppointmentNoteTemplateMutationHookResult = ReturnType<typeof useCreateOneAppointmentNoteTemplateMutation>;
export type CreateOneAppointmentNoteTemplateMutationResult = Apollo.MutationResult<CreateOneAppointmentNoteTemplateMutation>;
export type CreateOneAppointmentNoteTemplateMutationOptions = Apollo.BaseMutationOptions<CreateOneAppointmentNoteTemplateMutation, CreateOneAppointmentNoteTemplateMutationVariables>;
export const CreateOneRecapDocument = gql`
    mutation CreateOneRecap($data: RecapCreateInput!) {
  createOneRecap(data: $data) {
    id
  }
}
    `;
export type CreateOneRecapMutationFn = Apollo.MutationFunction<CreateOneRecapMutation, CreateOneRecapMutationVariables>;

/**
 * __useCreateOneRecapMutation__
 *
 * To run a mutation, you first call `useCreateOneRecapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneRecapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneRecapMutation, { data, loading, error }] = useCreateOneRecapMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneRecapMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneRecapMutation, CreateOneRecapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneRecapMutation, CreateOneRecapMutationVariables>(CreateOneRecapDocument, options);
      }
export type CreateOneRecapMutationHookResult = ReturnType<typeof useCreateOneRecapMutation>;
export type CreateOneRecapMutationResult = Apollo.MutationResult<CreateOneRecapMutation>;
export type CreateOneRecapMutationOptions = Apollo.BaseMutationOptions<CreateOneRecapMutation, CreateOneRecapMutationVariables>;
export const FindManyAppointmentNoteTemplateDocument = gql`
    query FindManyAppointmentNoteTemplate($where: AppointmentNoteTemplateWhereInput) {
  findManyAppointmentNoteTemplate(where: $where, orderBy: {name: asc}) {
    ...AppointmentNoteTemplateFragment
  }
}
    ${AppointmentNoteTemplateFragmentFragmentDoc}`;

/**
 * __useFindManyAppointmentNoteTemplateQuery__
 *
 * To run a query within a React component, call `useFindManyAppointmentNoteTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyAppointmentNoteTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyAppointmentNoteTemplateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyAppointmentNoteTemplateQuery(baseOptions?: Apollo.QueryHookOptions<FindManyAppointmentNoteTemplateQuery, FindManyAppointmentNoteTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyAppointmentNoteTemplateQuery, FindManyAppointmentNoteTemplateQueryVariables>(FindManyAppointmentNoteTemplateDocument, options);
      }
export function useFindManyAppointmentNoteTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyAppointmentNoteTemplateQuery, FindManyAppointmentNoteTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyAppointmentNoteTemplateQuery, FindManyAppointmentNoteTemplateQueryVariables>(FindManyAppointmentNoteTemplateDocument, options);
        }
export type FindManyAppointmentNoteTemplateQueryHookResult = ReturnType<typeof useFindManyAppointmentNoteTemplateQuery>;
export type FindManyAppointmentNoteTemplateLazyQueryHookResult = ReturnType<typeof useFindManyAppointmentNoteTemplateLazyQuery>;
export type FindManyAppointmentNoteTemplateQueryResult = Apollo.QueryResult<FindManyAppointmentNoteTemplateQuery, FindManyAppointmentNoteTemplateQueryVariables>;
export function refetchFindManyAppointmentNoteTemplateQuery(variables?: FindManyAppointmentNoteTemplateQueryVariables) {
      return { query: FindManyAppointmentNoteTemplateDocument, variables: variables }
    }
export const FindUniqueAppointmentNoteTemplateDocument = gql`
    query FindUniqueAppointmentNoteTemplate($where: AppointmentNoteTemplateWhereUniqueInput!) {
  findUniqueAppointmentNoteTemplate(where: $where) {
    ...AppointmentNoteTemplateFragment
  }
}
    ${AppointmentNoteTemplateFragmentFragmentDoc}`;

/**
 * __useFindUniqueAppointmentNoteTemplateQuery__
 *
 * To run a query within a React component, call `useFindUniqueAppointmentNoteTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueAppointmentNoteTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueAppointmentNoteTemplateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueAppointmentNoteTemplateQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueAppointmentNoteTemplateQuery, FindUniqueAppointmentNoteTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueAppointmentNoteTemplateQuery, FindUniqueAppointmentNoteTemplateQueryVariables>(FindUniqueAppointmentNoteTemplateDocument, options);
      }
export function useFindUniqueAppointmentNoteTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueAppointmentNoteTemplateQuery, FindUniqueAppointmentNoteTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueAppointmentNoteTemplateQuery, FindUniqueAppointmentNoteTemplateQueryVariables>(FindUniqueAppointmentNoteTemplateDocument, options);
        }
export type FindUniqueAppointmentNoteTemplateQueryHookResult = ReturnType<typeof useFindUniqueAppointmentNoteTemplateQuery>;
export type FindUniqueAppointmentNoteTemplateLazyQueryHookResult = ReturnType<typeof useFindUniqueAppointmentNoteTemplateLazyQuery>;
export type FindUniqueAppointmentNoteTemplateQueryResult = Apollo.QueryResult<FindUniqueAppointmentNoteTemplateQuery, FindUniqueAppointmentNoteTemplateQueryVariables>;
export function refetchFindUniqueAppointmentNoteTemplateQuery(variables?: FindUniqueAppointmentNoteTemplateQueryVariables) {
      return { query: FindUniqueAppointmentNoteTemplateDocument, variables: variables }
    }
export const ProcessAppointmentRecapDocument = gql`
    mutation processAppointmentRecap($data: ProcessAppointmentRecapInput!) {
  processAppointmentRecap(data: $data) {
    success
    message
  }
}
    `;
export type ProcessAppointmentRecapMutationFn = Apollo.MutationFunction<ProcessAppointmentRecapMutation, ProcessAppointmentRecapMutationVariables>;

/**
 * __useProcessAppointmentRecapMutation__
 *
 * To run a mutation, you first call `useProcessAppointmentRecapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessAppointmentRecapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processAppointmentRecapMutation, { data, loading, error }] = useProcessAppointmentRecapMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProcessAppointmentRecapMutation(baseOptions?: Apollo.MutationHookOptions<ProcessAppointmentRecapMutation, ProcessAppointmentRecapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessAppointmentRecapMutation, ProcessAppointmentRecapMutationVariables>(ProcessAppointmentRecapDocument, options);
      }
export type ProcessAppointmentRecapMutationHookResult = ReturnType<typeof useProcessAppointmentRecapMutation>;
export type ProcessAppointmentRecapMutationResult = Apollo.MutationResult<ProcessAppointmentRecapMutation>;
export type ProcessAppointmentRecapMutationOptions = Apollo.BaseMutationOptions<ProcessAppointmentRecapMutation, ProcessAppointmentRecapMutationVariables>;
export const ProcessAppointmentRecapChunksDocument = gql`
    mutation ProcessAppointmentRecapChunks($data: ProcessAppointmentRecapChunksInput!) {
  processAppointmentRecapChunks(data: $data) {
    success
    message
  }
}
    `;
export type ProcessAppointmentRecapChunksMutationFn = Apollo.MutationFunction<ProcessAppointmentRecapChunksMutation, ProcessAppointmentRecapChunksMutationVariables>;

/**
 * __useProcessAppointmentRecapChunksMutation__
 *
 * To run a mutation, you first call `useProcessAppointmentRecapChunksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessAppointmentRecapChunksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processAppointmentRecapChunksMutation, { data, loading, error }] = useProcessAppointmentRecapChunksMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProcessAppointmentRecapChunksMutation(baseOptions?: Apollo.MutationHookOptions<ProcessAppointmentRecapChunksMutation, ProcessAppointmentRecapChunksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessAppointmentRecapChunksMutation, ProcessAppointmentRecapChunksMutationVariables>(ProcessAppointmentRecapChunksDocument, options);
      }
export type ProcessAppointmentRecapChunksMutationHookResult = ReturnType<typeof useProcessAppointmentRecapChunksMutation>;
export type ProcessAppointmentRecapChunksMutationResult = Apollo.MutationResult<ProcessAppointmentRecapChunksMutation>;
export type ProcessAppointmentRecapChunksMutationOptions = Apollo.BaseMutationOptions<ProcessAppointmentRecapChunksMutation, ProcessAppointmentRecapChunksMutationVariables>;
export const RetryProcessAppointmentRecapDocument = gql`
    mutation retryProcessAppointmentRecap($data: RetryProcessAppointmentRecapInput!) {
  retryProcessAppointmentRecap(data: $data) {
    success
    message
  }
}
    `;
export type RetryProcessAppointmentRecapMutationFn = Apollo.MutationFunction<RetryProcessAppointmentRecapMutation, RetryProcessAppointmentRecapMutationVariables>;

/**
 * __useRetryProcessAppointmentRecapMutation__
 *
 * To run a mutation, you first call `useRetryProcessAppointmentRecapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryProcessAppointmentRecapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryProcessAppointmentRecapMutation, { data, loading, error }] = useRetryProcessAppointmentRecapMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRetryProcessAppointmentRecapMutation(baseOptions?: Apollo.MutationHookOptions<RetryProcessAppointmentRecapMutation, RetryProcessAppointmentRecapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryProcessAppointmentRecapMutation, RetryProcessAppointmentRecapMutationVariables>(RetryProcessAppointmentRecapDocument, options);
      }
export type RetryProcessAppointmentRecapMutationHookResult = ReturnType<typeof useRetryProcessAppointmentRecapMutation>;
export type RetryProcessAppointmentRecapMutationResult = Apollo.MutationResult<RetryProcessAppointmentRecapMutation>;
export type RetryProcessAppointmentRecapMutationOptions = Apollo.BaseMutationOptions<RetryProcessAppointmentRecapMutation, RetryProcessAppointmentRecapMutationVariables>;
export const StartChecksOnRecapChunksContinuityDocument = gql`
    mutation StartChecksOnRecapChunksContinuity($data: StartChecksOnRecapChunksContinuityInput!) {
  startChecksOnRecapChunksContinuity(data: $data) {
    success
    message
  }
}
    `;
export type StartChecksOnRecapChunksContinuityMutationFn = Apollo.MutationFunction<StartChecksOnRecapChunksContinuityMutation, StartChecksOnRecapChunksContinuityMutationVariables>;

/**
 * __useStartChecksOnRecapChunksContinuityMutation__
 *
 * To run a mutation, you first call `useStartChecksOnRecapChunksContinuityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartChecksOnRecapChunksContinuityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startChecksOnRecapChunksContinuityMutation, { data, loading, error }] = useStartChecksOnRecapChunksContinuityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStartChecksOnRecapChunksContinuityMutation(baseOptions?: Apollo.MutationHookOptions<StartChecksOnRecapChunksContinuityMutation, StartChecksOnRecapChunksContinuityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartChecksOnRecapChunksContinuityMutation, StartChecksOnRecapChunksContinuityMutationVariables>(StartChecksOnRecapChunksContinuityDocument, options);
      }
export type StartChecksOnRecapChunksContinuityMutationHookResult = ReturnType<typeof useStartChecksOnRecapChunksContinuityMutation>;
export type StartChecksOnRecapChunksContinuityMutationResult = Apollo.MutationResult<StartChecksOnRecapChunksContinuityMutation>;
export type StartChecksOnRecapChunksContinuityMutationOptions = Apollo.BaseMutationOptions<StartChecksOnRecapChunksContinuityMutation, StartChecksOnRecapChunksContinuityMutationVariables>;
export const UpdateOneAppointmentNoteTemplateDocument = gql`
    mutation UpdateOneAppointmentNoteTemplate($data: AppointmentNoteTemplateUpdateInput!, $where: AppointmentNoteTemplateWhereUniqueInput!) {
  updateOneAppointmentNoteTemplate(data: $data, where: $where) {
    ...AppointmentNoteTemplateFragment
  }
}
    ${AppointmentNoteTemplateFragmentFragmentDoc}`;
export type UpdateOneAppointmentNoteTemplateMutationFn = Apollo.MutationFunction<UpdateOneAppointmentNoteTemplateMutation, UpdateOneAppointmentNoteTemplateMutationVariables>;

/**
 * __useUpdateOneAppointmentNoteTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateOneAppointmentNoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneAppointmentNoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneAppointmentNoteTemplateMutation, { data, loading, error }] = useUpdateOneAppointmentNoteTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneAppointmentNoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneAppointmentNoteTemplateMutation, UpdateOneAppointmentNoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneAppointmentNoteTemplateMutation, UpdateOneAppointmentNoteTemplateMutationVariables>(UpdateOneAppointmentNoteTemplateDocument, options);
      }
export type UpdateOneAppointmentNoteTemplateMutationHookResult = ReturnType<typeof useUpdateOneAppointmentNoteTemplateMutation>;
export type UpdateOneAppointmentNoteTemplateMutationResult = Apollo.MutationResult<UpdateOneAppointmentNoteTemplateMutation>;
export type UpdateOneAppointmentNoteTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateOneAppointmentNoteTemplateMutation, UpdateOneAppointmentNoteTemplateMutationVariables>;
export const UpdateOneRecapDocument = gql`
    mutation UpdateOneRecap($data: RecapUpdateInput!, $where: RecapWhereUniqueInput!) {
  updateOneRecap(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateOneRecapMutationFn = Apollo.MutationFunction<UpdateOneRecapMutation, UpdateOneRecapMutationVariables>;

/**
 * __useUpdateOneRecapMutation__
 *
 * To run a mutation, you first call `useUpdateOneRecapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneRecapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneRecapMutation, { data, loading, error }] = useUpdateOneRecapMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneRecapMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneRecapMutation, UpdateOneRecapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneRecapMutation, UpdateOneRecapMutationVariables>(UpdateOneRecapDocument, options);
      }
export type UpdateOneRecapMutationHookResult = ReturnType<typeof useUpdateOneRecapMutation>;
export type UpdateOneRecapMutationResult = Apollo.MutationResult<UpdateOneRecapMutation>;
export type UpdateOneRecapMutationOptions = Apollo.BaseMutationOptions<UpdateOneRecapMutation, UpdateOneRecapMutationVariables>;
export const GetEnrollmentsCountDocument = gql`
    query getEnrollmentsCount($where: CarePlanEnrollmentWhereInput) {
  findManyCarePlanEnrollmentCount(where: $where)
}
    `;

/**
 * __useGetEnrollmentsCountQuery__
 *
 * To run a query within a React component, call `useGetEnrollmentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrollmentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrollmentsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetEnrollmentsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetEnrollmentsCountQuery, GetEnrollmentsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnrollmentsCountQuery, GetEnrollmentsCountQueryVariables>(GetEnrollmentsCountDocument, options);
      }
export function useGetEnrollmentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnrollmentsCountQuery, GetEnrollmentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnrollmentsCountQuery, GetEnrollmentsCountQueryVariables>(GetEnrollmentsCountDocument, options);
        }
export type GetEnrollmentsCountQueryHookResult = ReturnType<typeof useGetEnrollmentsCountQuery>;
export type GetEnrollmentsCountLazyQueryHookResult = ReturnType<typeof useGetEnrollmentsCountLazyQuery>;
export type GetEnrollmentsCountQueryResult = Apollo.QueryResult<GetEnrollmentsCountQuery, GetEnrollmentsCountQueryVariables>;
export function refetchGetEnrollmentsCountQuery(variables?: GetEnrollmentsCountQueryVariables) {
      return { query: GetEnrollmentsCountDocument, variables: variables }
    }
export const SubscribeToNewCareEnrollmentsDocument = gql`
    subscription subscribeToNewCareEnrollments($where: CareEnrollmentsByClinicWhereInput!) {
  checkPetEnrollmentsByClinic(where: $where) {
    dailyTotal
    monthlyTotal
    enrollmentData {
      clientName
      petName
      planName
      isRenewal
    }
  }
}
    `;

/**
 * __useSubscribeToNewCareEnrollmentsSubscription__
 *
 * To run a query within a React component, call `useSubscribeToNewCareEnrollmentsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToNewCareEnrollmentsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToNewCareEnrollmentsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToNewCareEnrollmentsSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToNewCareEnrollmentsSubscription, SubscribeToNewCareEnrollmentsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToNewCareEnrollmentsSubscription, SubscribeToNewCareEnrollmentsSubscriptionVariables>(SubscribeToNewCareEnrollmentsDocument, options);
      }
export type SubscribeToNewCareEnrollmentsSubscriptionHookResult = ReturnType<typeof useSubscribeToNewCareEnrollmentsSubscription>;
export type SubscribeToNewCareEnrollmentsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToNewCareEnrollmentsSubscription>;
export const FindUniqueClinicPetParentDocument = gql`
    query findUniqueClinicPetParent($where: ClinicPetParentWhereUniqueInput!) {
  findUniqueClinicPetParent(where: $where) {
    firstName
  }
}
    `;

/**
 * __useFindUniqueClinicPetParentQuery__
 *
 * To run a query within a React component, call `useFindUniqueClinicPetParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueClinicPetParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueClinicPetParentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueClinicPetParentQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueClinicPetParentQuery, FindUniqueClinicPetParentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueClinicPetParentQuery, FindUniqueClinicPetParentQueryVariables>(FindUniqueClinicPetParentDocument, options);
      }
export function useFindUniqueClinicPetParentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueClinicPetParentQuery, FindUniqueClinicPetParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueClinicPetParentQuery, FindUniqueClinicPetParentQueryVariables>(FindUniqueClinicPetParentDocument, options);
        }
export type FindUniqueClinicPetParentQueryHookResult = ReturnType<typeof useFindUniqueClinicPetParentQuery>;
export type FindUniqueClinicPetParentLazyQueryHookResult = ReturnType<typeof useFindUniqueClinicPetParentLazyQuery>;
export type FindUniqueClinicPetParentQueryResult = Apollo.QueryResult<FindUniqueClinicPetParentQuery, FindUniqueClinicPetParentQueryVariables>;
export function refetchFindUniqueClinicPetParentQuery(variables?: FindUniqueClinicPetParentQueryVariables) {
      return { query: FindUniqueClinicPetParentDocument, variables: variables }
    }
export const PostCareInvoiceAccountCreditToPimsDocument = gql`
    mutation postCareInvoiceAccountCreditToPims($data: WritebackCareInvoiceAccountCreditToPimsInput!) {
  postCareInvoiceAccountCreditToPims(data: $data) {
    success
    error
  }
}
    `;
export type PostCareInvoiceAccountCreditToPimsMutationFn = Apollo.MutationFunction<PostCareInvoiceAccountCreditToPimsMutation, PostCareInvoiceAccountCreditToPimsMutationVariables>;

/**
 * __usePostCareInvoiceAccountCreditToPimsMutation__
 *
 * To run a mutation, you first call `usePostCareInvoiceAccountCreditToPimsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostCareInvoiceAccountCreditToPimsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postCareInvoiceAccountCreditToPimsMutation, { data, loading, error }] = usePostCareInvoiceAccountCreditToPimsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePostCareInvoiceAccountCreditToPimsMutation(baseOptions?: Apollo.MutationHookOptions<PostCareInvoiceAccountCreditToPimsMutation, PostCareInvoiceAccountCreditToPimsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostCareInvoiceAccountCreditToPimsMutation, PostCareInvoiceAccountCreditToPimsMutationVariables>(PostCareInvoiceAccountCreditToPimsDocument, options);
      }
export type PostCareInvoiceAccountCreditToPimsMutationHookResult = ReturnType<typeof usePostCareInvoiceAccountCreditToPimsMutation>;
export type PostCareInvoiceAccountCreditToPimsMutationResult = Apollo.MutationResult<PostCareInvoiceAccountCreditToPimsMutation>;
export type PostCareInvoiceAccountCreditToPimsMutationOptions = Apollo.BaseMutationOptions<PostCareInvoiceAccountCreditToPimsMutation, PostCareInvoiceAccountCreditToPimsMutationVariables>;
export const IssueTrupanionCertificateDocument = gql`
    mutation issueTrupanionCertificate($where: TrupanionIssueCertificateWhereInput!, $data: TrupanionIssueCertificateDataInput!) {
  trupanionIssueCertificate(where: $where, data: $data) {
    referenceNumber
    errorMessages
  }
}
    `;
export type IssueTrupanionCertificateMutationFn = Apollo.MutationFunction<IssueTrupanionCertificateMutation, IssueTrupanionCertificateMutationVariables>;

/**
 * __useIssueTrupanionCertificateMutation__
 *
 * To run a mutation, you first call `useIssueTrupanionCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueTrupanionCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueTrupanionCertificateMutation, { data, loading, error }] = useIssueTrupanionCertificateMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useIssueTrupanionCertificateMutation(baseOptions?: Apollo.MutationHookOptions<IssueTrupanionCertificateMutation, IssueTrupanionCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueTrupanionCertificateMutation, IssueTrupanionCertificateMutationVariables>(IssueTrupanionCertificateDocument, options);
      }
export type IssueTrupanionCertificateMutationHookResult = ReturnType<typeof useIssueTrupanionCertificateMutation>;
export type IssueTrupanionCertificateMutationResult = Apollo.MutationResult<IssueTrupanionCertificateMutation>;
export type IssueTrupanionCertificateMutationOptions = Apollo.BaseMutationOptions<IssueTrupanionCertificateMutation, IssueTrupanionCertificateMutationVariables>;
export const GetInvoicePetParentsDocument = gql`
    query getInvoicePetParents($whereInput: SearchClinicPetParentInput, $pageSize: Int, $petWhere: ClinicPetWhereInput) {
  clinicPetParentSearch(where: $whereInput, take: $pageSize) {
    ...InvoicePetParent
  }
}
    ${InvoicePetParentFragmentDoc}`;

/**
 * __useGetInvoicePetParentsQuery__
 *
 * To run a query within a React component, call `useGetInvoicePetParentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePetParentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePetParentsQuery({
 *   variables: {
 *      whereInput: // value for 'whereInput'
 *      pageSize: // value for 'pageSize'
 *      petWhere: // value for 'petWhere'
 *   },
 * });
 */
export function useGetInvoicePetParentsQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoicePetParentsQuery, GetInvoicePetParentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePetParentsQuery, GetInvoicePetParentsQueryVariables>(GetInvoicePetParentsDocument, options);
      }
export function useGetInvoicePetParentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePetParentsQuery, GetInvoicePetParentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePetParentsQuery, GetInvoicePetParentsQueryVariables>(GetInvoicePetParentsDocument, options);
        }
export type GetInvoicePetParentsQueryHookResult = ReturnType<typeof useGetInvoicePetParentsQuery>;
export type GetInvoicePetParentsLazyQueryHookResult = ReturnType<typeof useGetInvoicePetParentsLazyQuery>;
export type GetInvoicePetParentsQueryResult = Apollo.QueryResult<GetInvoicePetParentsQuery, GetInvoicePetParentsQueryVariables>;
export function refetchGetInvoicePetParentsQuery(variables?: GetInvoicePetParentsQueryVariables) {
      return { query: GetInvoicePetParentsDocument, variables: variables }
    }
export const GetPaymentIntentStatusDocument = gql`
    query getPaymentIntentStatus($where: StripePaymentIntentWhereUniqueInput!) {
  findUniqueStripePaymentIntent(where: $where) {
    id
    status
    lastPaymentError
    paymentRelationship
  }
}
    `;

/**
 * __useGetPaymentIntentStatusQuery__
 *
 * To run a query within a React component, call `useGetPaymentIntentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentIntentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentIntentStatusQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPaymentIntentStatusQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentIntentStatusQuery, GetPaymentIntentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentIntentStatusQuery, GetPaymentIntentStatusQueryVariables>(GetPaymentIntentStatusDocument, options);
      }
export function useGetPaymentIntentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentIntentStatusQuery, GetPaymentIntentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentIntentStatusQuery, GetPaymentIntentStatusQueryVariables>(GetPaymentIntentStatusDocument, options);
        }
export type GetPaymentIntentStatusQueryHookResult = ReturnType<typeof useGetPaymentIntentStatusQuery>;
export type GetPaymentIntentStatusLazyQueryHookResult = ReturnType<typeof useGetPaymentIntentStatusLazyQuery>;
export type GetPaymentIntentStatusQueryResult = Apollo.QueryResult<GetPaymentIntentStatusQuery, GetPaymentIntentStatusQueryVariables>;
export function refetchGetPaymentIntentStatusQuery(variables?: GetPaymentIntentStatusQueryVariables) {
      return { query: GetPaymentIntentStatusDocument, variables: variables }
    }
export const TrupanionCertificateAvailabilityDocument = gql`
    query trupanionCertificateAvailability($where: TrupanionCertificateAvailabilityInput!) {
  trupanionCertificateAvailability(where: $where) {
    clinicPetId
    clinicPetName
    isAvailable
    trupanionClosestBreed
    pimsBreed
    speciesType
    unavailableReasons {
      IsPetAlreadyEnrolled
      IsPetPolicyCancelled
      IsActiveOrPendingCertificateFound
      IsExamDateOutsideOfActivationWindow
      IsAdoptionDateOutsideOfActivationWindow
      IsEmailAssociatedToManyPolicies
    }
    errorMessages
  }
}
    `;

/**
 * __useTrupanionCertificateAvailabilityQuery__
 *
 * To run a query within a React component, call `useTrupanionCertificateAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrupanionCertificateAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrupanionCertificateAvailabilityQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTrupanionCertificateAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<TrupanionCertificateAvailabilityQuery, TrupanionCertificateAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrupanionCertificateAvailabilityQuery, TrupanionCertificateAvailabilityQueryVariables>(TrupanionCertificateAvailabilityDocument, options);
      }
export function useTrupanionCertificateAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrupanionCertificateAvailabilityQuery, TrupanionCertificateAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrupanionCertificateAvailabilityQuery, TrupanionCertificateAvailabilityQueryVariables>(TrupanionCertificateAvailabilityDocument, options);
        }
export type TrupanionCertificateAvailabilityQueryHookResult = ReturnType<typeof useTrupanionCertificateAvailabilityQuery>;
export type TrupanionCertificateAvailabilityLazyQueryHookResult = ReturnType<typeof useTrupanionCertificateAvailabilityLazyQuery>;
export type TrupanionCertificateAvailabilityQueryResult = Apollo.QueryResult<TrupanionCertificateAvailabilityQuery, TrupanionCertificateAvailabilityQueryVariables>;
export function refetchTrupanionCertificateAvailabilityQuery(variables?: TrupanionCertificateAvailabilityQueryVariables) {
      return { query: TrupanionCertificateAvailabilityDocument, variables: variables }
    }
export const CreateMassTextAlertDocument = gql`
    mutation createMassTextAlert($data: MassTextAlertCreateInput!) {
  createOneMassTextAlert(data: $data) {
    id
    appointmentDateTimeTo
    appointmentDateTimeFrom
    alertBody
  }
}
    `;
export type CreateMassTextAlertMutationFn = Apollo.MutationFunction<CreateMassTextAlertMutation, CreateMassTextAlertMutationVariables>;

/**
 * __useCreateMassTextAlertMutation__
 *
 * To run a mutation, you first call `useCreateMassTextAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMassTextAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMassTextAlertMutation, { data, loading, error }] = useCreateMassTextAlertMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMassTextAlertMutation(baseOptions?: Apollo.MutationHookOptions<CreateMassTextAlertMutation, CreateMassTextAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMassTextAlertMutation, CreateMassTextAlertMutationVariables>(CreateMassTextAlertDocument, options);
      }
export type CreateMassTextAlertMutationHookResult = ReturnType<typeof useCreateMassTextAlertMutation>;
export type CreateMassTextAlertMutationResult = Apollo.MutationResult<CreateMassTextAlertMutation>;
export type CreateMassTextAlertMutationOptions = Apollo.BaseMutationOptions<CreateMassTextAlertMutation, CreateMassTextAlertMutationVariables>;
export const GetActivityLogForMassTextAlertsDocument = gql`
    query getActivityLogForMassTextAlerts($where: MassTextAlertWhereInput, $orderBy: [MassTextAlertOrderByWithRelationInput], $skip: Int, $take: Int) {
  findManyMassTextAlertCount(where: $where)
  findManyMassTextAlert(
    where: $where
    orderBy: $orderBy
    skip: $skip
    take: $take
  ) {
    ...MassTextAleryActivityLog
  }
}
    ${MassTextAleryActivityLogFragmentDoc}`;

/**
 * __useGetActivityLogForMassTextAlertsQuery__
 *
 * To run a query within a React component, call `useGetActivityLogForMassTextAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogForMassTextAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogForMassTextAlertsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetActivityLogForMassTextAlertsQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityLogForMassTextAlertsQuery, GetActivityLogForMassTextAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogForMassTextAlertsQuery, GetActivityLogForMassTextAlertsQueryVariables>(GetActivityLogForMassTextAlertsDocument, options);
      }
export function useGetActivityLogForMassTextAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogForMassTextAlertsQuery, GetActivityLogForMassTextAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogForMassTextAlertsQuery, GetActivityLogForMassTextAlertsQueryVariables>(GetActivityLogForMassTextAlertsDocument, options);
        }
export type GetActivityLogForMassTextAlertsQueryHookResult = ReturnType<typeof useGetActivityLogForMassTextAlertsQuery>;
export type GetActivityLogForMassTextAlertsLazyQueryHookResult = ReturnType<typeof useGetActivityLogForMassTextAlertsLazyQuery>;
export type GetActivityLogForMassTextAlertsQueryResult = Apollo.QueryResult<GetActivityLogForMassTextAlertsQuery, GetActivityLogForMassTextAlertsQueryVariables>;
export function refetchGetActivityLogForMassTextAlertsQuery(variables?: GetActivityLogForMassTextAlertsQueryVariables) {
      return { query: GetActivityLogForMassTextAlertsDocument, variables: variables }
    }
export const GetDeliveryReportForMassTextAlertDocument = gql`
    query getDeliveryReportForMassTextAlert($massTextAlertId: String!) {
  massTextAlertReport(massTextAlertId: $massTextAlertId) {
    phoneNumber
    petParentFullName
    smsStatus
    errorDetails
  }
}
    `;

/**
 * __useGetDeliveryReportForMassTextAlertQuery__
 *
 * To run a query within a React component, call `useGetDeliveryReportForMassTextAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryReportForMassTextAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryReportForMassTextAlertQuery({
 *   variables: {
 *      massTextAlertId: // value for 'massTextAlertId'
 *   },
 * });
 */
export function useGetDeliveryReportForMassTextAlertQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryReportForMassTextAlertQuery, GetDeliveryReportForMassTextAlertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryReportForMassTextAlertQuery, GetDeliveryReportForMassTextAlertQueryVariables>(GetDeliveryReportForMassTextAlertDocument, options);
      }
export function useGetDeliveryReportForMassTextAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryReportForMassTextAlertQuery, GetDeliveryReportForMassTextAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryReportForMassTextAlertQuery, GetDeliveryReportForMassTextAlertQueryVariables>(GetDeliveryReportForMassTextAlertDocument, options);
        }
export type GetDeliveryReportForMassTextAlertQueryHookResult = ReturnType<typeof useGetDeliveryReportForMassTextAlertQuery>;
export type GetDeliveryReportForMassTextAlertLazyQueryHookResult = ReturnType<typeof useGetDeliveryReportForMassTextAlertLazyQuery>;
export type GetDeliveryReportForMassTextAlertQueryResult = Apollo.QueryResult<GetDeliveryReportForMassTextAlertQuery, GetDeliveryReportForMassTextAlertQueryVariables>;
export function refetchGetDeliveryReportForMassTextAlertQuery(variables?: GetDeliveryReportForMassTextAlertQueryVariables) {
      return { query: GetDeliveryReportForMassTextAlertDocument, variables: variables }
    }
export const GetEstimatedSendTimeForMassTextAlertDocument = gql`
    query getEstimatedSendTimeForMassTextAlert($clinicId: String!, $appointmentDateTimeFrom: String!, $appointmentDateTimeTo: String!, $alertBody: String!) {
  estimateNumberOfPetParentsReached(
    clinicId: $clinicId
    appointmentDateTimeTo: $appointmentDateTimeTo
    appointmentDateTimeFrom: $appointmentDateTimeFrom
    alertBody: $alertBody
  ) {
    numberOfPetPerents
    timeEstimateInSeconds
  }
}
    `;

/**
 * __useGetEstimatedSendTimeForMassTextAlertQuery__
 *
 * To run a query within a React component, call `useGetEstimatedSendTimeForMassTextAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstimatedSendTimeForMassTextAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstimatedSendTimeForMassTextAlertQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      appointmentDateTimeFrom: // value for 'appointmentDateTimeFrom'
 *      appointmentDateTimeTo: // value for 'appointmentDateTimeTo'
 *      alertBody: // value for 'alertBody'
 *   },
 * });
 */
export function useGetEstimatedSendTimeForMassTextAlertQuery(baseOptions: Apollo.QueryHookOptions<GetEstimatedSendTimeForMassTextAlertQuery, GetEstimatedSendTimeForMassTextAlertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstimatedSendTimeForMassTextAlertQuery, GetEstimatedSendTimeForMassTextAlertQueryVariables>(GetEstimatedSendTimeForMassTextAlertDocument, options);
      }
export function useGetEstimatedSendTimeForMassTextAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstimatedSendTimeForMassTextAlertQuery, GetEstimatedSendTimeForMassTextAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstimatedSendTimeForMassTextAlertQuery, GetEstimatedSendTimeForMassTextAlertQueryVariables>(GetEstimatedSendTimeForMassTextAlertDocument, options);
        }
export type GetEstimatedSendTimeForMassTextAlertQueryHookResult = ReturnType<typeof useGetEstimatedSendTimeForMassTextAlertQuery>;
export type GetEstimatedSendTimeForMassTextAlertLazyQueryHookResult = ReturnType<typeof useGetEstimatedSendTimeForMassTextAlertLazyQuery>;
export type GetEstimatedSendTimeForMassTextAlertQueryResult = Apollo.QueryResult<GetEstimatedSendTimeForMassTextAlertQuery, GetEstimatedSendTimeForMassTextAlertQueryVariables>;
export function refetchGetEstimatedSendTimeForMassTextAlertQuery(variables?: GetEstimatedSendTimeForMassTextAlertQueryVariables) {
      return { query: GetEstimatedSendTimeForMassTextAlertDocument, variables: variables }
    }
export const SubscribeToMassTextAlertStatusDocument = gql`
    subscription subscribeToMassTextAlertStatus($where: SubscriptionMassTextAlertWhereInput!) {
  massTextAlertChanged(where: $where) {
    node {
      id
      status
    }
  }
}
    `;

/**
 * __useSubscribeToMassTextAlertStatusSubscription__
 *
 * To run a query within a React component, call `useSubscribeToMassTextAlertStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToMassTextAlertStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToMassTextAlertStatusSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToMassTextAlertStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToMassTextAlertStatusSubscription, SubscribeToMassTextAlertStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToMassTextAlertStatusSubscription, SubscribeToMassTextAlertStatusSubscriptionVariables>(SubscribeToMassTextAlertStatusDocument, options);
      }
export type SubscribeToMassTextAlertStatusSubscriptionHookResult = ReturnType<typeof useSubscribeToMassTextAlertStatusSubscription>;
export type SubscribeToMassTextAlertStatusSubscriptionResult = Apollo.SubscriptionResult<SubscribeToMassTextAlertStatusSubscription>;
export const GetAppointmentFiltersDocument = gql`
    query getAppointmentFilters {
  appointmentFilters @client {
    currentDay
    startDate
    endDate
    daysAheadInterval
    defaultAppointmentDurationInMinutes
  }
}
    `;

/**
 * __useGetAppointmentFiltersQuery__
 *
 * To run a query within a React component, call `useGetAppointmentFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentFiltersQuery, GetAppointmentFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentFiltersQuery, GetAppointmentFiltersQueryVariables>(GetAppointmentFiltersDocument, options);
      }
export function useGetAppointmentFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentFiltersQuery, GetAppointmentFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentFiltersQuery, GetAppointmentFiltersQueryVariables>(GetAppointmentFiltersDocument, options);
        }
export type GetAppointmentFiltersQueryHookResult = ReturnType<typeof useGetAppointmentFiltersQuery>;
export type GetAppointmentFiltersLazyQueryHookResult = ReturnType<typeof useGetAppointmentFiltersLazyQuery>;
export type GetAppointmentFiltersQueryResult = Apollo.QueryResult<GetAppointmentFiltersQuery, GetAppointmentFiltersQueryVariables>;
export function refetchGetAppointmentFiltersQuery(variables?: GetAppointmentFiltersQueryVariables) {
      return { query: GetAppointmentFiltersDocument, variables: variables }
    }
export const CompleteCareBenefitUsageFollowupDocument = gql`
    mutation completeCareBenefitUsageFollowup($followupId: String!, $completedAt: DateTime!) {
  updateOneCareBenefitUsageFollowup(
    where: {id: $followupId}
    data: {completed: true, completedAt: $completedAt}
  ) {
    id
    completed
  }
}
    `;
export type CompleteCareBenefitUsageFollowupMutationFn = Apollo.MutationFunction<CompleteCareBenefitUsageFollowupMutation, CompleteCareBenefitUsageFollowupMutationVariables>;

/**
 * __useCompleteCareBenefitUsageFollowupMutation__
 *
 * To run a mutation, you first call `useCompleteCareBenefitUsageFollowupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCareBenefitUsageFollowupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCareBenefitUsageFollowupMutation, { data, loading, error }] = useCompleteCareBenefitUsageFollowupMutation({
 *   variables: {
 *      followupId: // value for 'followupId'
 *      completedAt: // value for 'completedAt'
 *   },
 * });
 */
export function useCompleteCareBenefitUsageFollowupMutation(baseOptions?: Apollo.MutationHookOptions<CompleteCareBenefitUsageFollowupMutation, CompleteCareBenefitUsageFollowupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteCareBenefitUsageFollowupMutation, CompleteCareBenefitUsageFollowupMutationVariables>(CompleteCareBenefitUsageFollowupDocument, options);
      }
export type CompleteCareBenefitUsageFollowupMutationHookResult = ReturnType<typeof useCompleteCareBenefitUsageFollowupMutation>;
export type CompleteCareBenefitUsageFollowupMutationResult = Apollo.MutationResult<CompleteCareBenefitUsageFollowupMutation>;
export type CompleteCareBenefitUsageFollowupMutationOptions = Apollo.BaseMutationOptions<CompleteCareBenefitUsageFollowupMutation, CompleteCareBenefitUsageFollowupMutationVariables>;
export const CompleteCareBenefitUsageFollowupStepDocument = gql`
    mutation completeCareBenefitUsageFollowupStep($stepId: String!, $completedAt: DateTime!, $completedByUserId: String!) {
  updateOneCareBenefitUsageFollowupStep(
    where: {id: $stepId}
    data: {completed: true, completedAt: $completedAt, completedByUser: {connect: {id: $completedByUserId}}}
  ) {
    id
    completed
  }
}
    `;
export type CompleteCareBenefitUsageFollowupStepMutationFn = Apollo.MutationFunction<CompleteCareBenefitUsageFollowupStepMutation, CompleteCareBenefitUsageFollowupStepMutationVariables>;

/**
 * __useCompleteCareBenefitUsageFollowupStepMutation__
 *
 * To run a mutation, you first call `useCompleteCareBenefitUsageFollowupStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCareBenefitUsageFollowupStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCareBenefitUsageFollowupStepMutation, { data, loading, error }] = useCompleteCareBenefitUsageFollowupStepMutation({
 *   variables: {
 *      stepId: // value for 'stepId'
 *      completedAt: // value for 'completedAt'
 *      completedByUserId: // value for 'completedByUserId'
 *   },
 * });
 */
export function useCompleteCareBenefitUsageFollowupStepMutation(baseOptions?: Apollo.MutationHookOptions<CompleteCareBenefitUsageFollowupStepMutation, CompleteCareBenefitUsageFollowupStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteCareBenefitUsageFollowupStepMutation, CompleteCareBenefitUsageFollowupStepMutationVariables>(CompleteCareBenefitUsageFollowupStepDocument, options);
      }
export type CompleteCareBenefitUsageFollowupStepMutationHookResult = ReturnType<typeof useCompleteCareBenefitUsageFollowupStepMutation>;
export type CompleteCareBenefitUsageFollowupStepMutationResult = Apollo.MutationResult<CompleteCareBenefitUsageFollowupStepMutation>;
export type CompleteCareBenefitUsageFollowupStepMutationOptions = Apollo.BaseMutationOptions<CompleteCareBenefitUsageFollowupStepMutation, CompleteCareBenefitUsageFollowupStepMutationVariables>;
export const GetCareBenefitUsageFollowupDocument = gql`
    query getCareBenefitUsageFollowup($organizationPetId: String!) {
  findManyCareBenefitUsageFollowup(
    where: {relatedOrganizationPetId: {equals: $organizationPetId}, completed: {equals: false}}
  ) {
    ...CareBenefitUsageFollowUp
  }
}
    ${CareBenefitUsageFollowUpFragmentDoc}`;

/**
 * __useGetCareBenefitUsageFollowupQuery__
 *
 * To run a query within a React component, call `useGetCareBenefitUsageFollowupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareBenefitUsageFollowupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareBenefitUsageFollowupQuery({
 *   variables: {
 *      organizationPetId: // value for 'organizationPetId'
 *   },
 * });
 */
export function useGetCareBenefitUsageFollowupQuery(baseOptions: Apollo.QueryHookOptions<GetCareBenefitUsageFollowupQuery, GetCareBenefitUsageFollowupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareBenefitUsageFollowupQuery, GetCareBenefitUsageFollowupQueryVariables>(GetCareBenefitUsageFollowupDocument, options);
      }
export function useGetCareBenefitUsageFollowupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareBenefitUsageFollowupQuery, GetCareBenefitUsageFollowupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareBenefitUsageFollowupQuery, GetCareBenefitUsageFollowupQueryVariables>(GetCareBenefitUsageFollowupDocument, options);
        }
export type GetCareBenefitUsageFollowupQueryHookResult = ReturnType<typeof useGetCareBenefitUsageFollowupQuery>;
export type GetCareBenefitUsageFollowupLazyQueryHookResult = ReturnType<typeof useGetCareBenefitUsageFollowupLazyQuery>;
export type GetCareBenefitUsageFollowupQueryResult = Apollo.QueryResult<GetCareBenefitUsageFollowupQuery, GetCareBenefitUsageFollowupQueryVariables>;
export function refetchGetCareBenefitUsageFollowupQuery(variables?: GetCareBenefitUsageFollowupQueryVariables) {
      return { query: GetCareBenefitUsageFollowupDocument, variables: variables }
    }
export const GetConnectedServicesDocument = gql`
    query getConnectedServices($where: OrganizationCareBenefitToClinicServiceWhereInput, $take: Int) {
  findManyOrganizationCareBenefitToClinicService(where: $where, take: $take) {
    service {
      id
      name
      integrationId
    }
  }
}
    `;

/**
 * __useGetConnectedServicesQuery__
 *
 * To run a query within a React component, call `useGetConnectedServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectedServicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetConnectedServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetConnectedServicesQuery, GetConnectedServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectedServicesQuery, GetConnectedServicesQueryVariables>(GetConnectedServicesDocument, options);
      }
export function useGetConnectedServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectedServicesQuery, GetConnectedServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectedServicesQuery, GetConnectedServicesQueryVariables>(GetConnectedServicesDocument, options);
        }
export type GetConnectedServicesQueryHookResult = ReturnType<typeof useGetConnectedServicesQuery>;
export type GetConnectedServicesLazyQueryHookResult = ReturnType<typeof useGetConnectedServicesLazyQuery>;
export type GetConnectedServicesQueryResult = Apollo.QueryResult<GetConnectedServicesQuery, GetConnectedServicesQueryVariables>;
export function refetchGetConnectedServicesQuery(variables?: GetConnectedServicesQueryVariables) {
      return { query: GetConnectedServicesDocument, variables: variables }
    }
export const CancelCareSubscriptionDocument = gql`
    mutation cancelCareSubscription($data: CancelCareSubscriptionInput) {
  cancelCareSubscription(data: $data) {
    success
    messages
  }
}
    `;
export type CancelCareSubscriptionMutationFn = Apollo.MutationFunction<CancelCareSubscriptionMutation, CancelCareSubscriptionMutationVariables>;

/**
 * __useCancelCareSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelCareSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCareSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCareSubscriptionMutation, { data, loading, error }] = useCancelCareSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCancelCareSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelCareSubscriptionMutation, CancelCareSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCareSubscriptionMutation, CancelCareSubscriptionMutationVariables>(CancelCareSubscriptionDocument, options);
      }
export type CancelCareSubscriptionMutationHookResult = ReturnType<typeof useCancelCareSubscriptionMutation>;
export type CancelCareSubscriptionMutationResult = Apollo.MutationResult<CancelCareSubscriptionMutation>;
export type CancelCareSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelCareSubscriptionMutation, CancelCareSubscriptionMutationVariables>;
export const CreateCarePaymentMethodSetupDocument = gql`
    mutation createCarePaymentMethodSetup($data: CreateCarePaymentMethodSetupInput) {
  createCarePaymentMethodSetup(data: $data) {
    setupIntentSecret
  }
}
    `;
export type CreateCarePaymentMethodSetupMutationFn = Apollo.MutationFunction<CreateCarePaymentMethodSetupMutation, CreateCarePaymentMethodSetupMutationVariables>;

/**
 * __useCreateCarePaymentMethodSetupMutation__
 *
 * To run a mutation, you first call `useCreateCarePaymentMethodSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarePaymentMethodSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarePaymentMethodSetupMutation, { data, loading, error }] = useCreateCarePaymentMethodSetupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCarePaymentMethodSetupMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarePaymentMethodSetupMutation, CreateCarePaymentMethodSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarePaymentMethodSetupMutation, CreateCarePaymentMethodSetupMutationVariables>(CreateCarePaymentMethodSetupDocument, options);
      }
export type CreateCarePaymentMethodSetupMutationHookResult = ReturnType<typeof useCreateCarePaymentMethodSetupMutation>;
export type CreateCarePaymentMethodSetupMutationResult = Apollo.MutationResult<CreateCarePaymentMethodSetupMutation>;
export type CreateCarePaymentMethodSetupMutationOptions = Apollo.BaseMutationOptions<CreateCarePaymentMethodSetupMutation, CreateCarePaymentMethodSetupMutationVariables>;
export const CreateEnrollmentSupportEventDocument = gql`
    mutation createEnrollmentSupportEvent($data: EnrollmentSupportEventCreateInput!) {
  createOneEnrollmentSupportEvent(data: $data) {
    id
    createdAt
    carePlanEnrollmentId
    requesterId
    pointOfContactId
    manageMembershipRequestType
    cancelReason
    manageMembershipDescription
    relatedInvoiceId
  }
}
    `;
export type CreateEnrollmentSupportEventMutationFn = Apollo.MutationFunction<CreateEnrollmentSupportEventMutation, CreateEnrollmentSupportEventMutationVariables>;

/**
 * __useCreateEnrollmentSupportEventMutation__
 *
 * To run a mutation, you first call `useCreateEnrollmentSupportEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnrollmentSupportEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnrollmentSupportEventMutation, { data, loading, error }] = useCreateEnrollmentSupportEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEnrollmentSupportEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEnrollmentSupportEventMutation, CreateEnrollmentSupportEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEnrollmentSupportEventMutation, CreateEnrollmentSupportEventMutationVariables>(CreateEnrollmentSupportEventDocument, options);
      }
export type CreateEnrollmentSupportEventMutationHookResult = ReturnType<typeof useCreateEnrollmentSupportEventMutation>;
export type CreateEnrollmentSupportEventMutationResult = Apollo.MutationResult<CreateEnrollmentSupportEventMutation>;
export type CreateEnrollmentSupportEventMutationOptions = Apollo.BaseMutationOptions<CreateEnrollmentSupportEventMutation, CreateEnrollmentSupportEventMutationVariables>;
export const EnsurePetsArePromotedDocument = gql`
    mutation ensurePetsArePromoted($data: EnsurePetsPromotedInput) {
  ensurePetsPromoted(data: $data) {
    success
  }
}
    `;
export type EnsurePetsArePromotedMutationFn = Apollo.MutationFunction<EnsurePetsArePromotedMutation, EnsurePetsArePromotedMutationVariables>;

/**
 * __useEnsurePetsArePromotedMutation__
 *
 * To run a mutation, you first call `useEnsurePetsArePromotedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnsurePetsArePromotedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ensurePetsArePromotedMutation, { data, loading, error }] = useEnsurePetsArePromotedMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEnsurePetsArePromotedMutation(baseOptions?: Apollo.MutationHookOptions<EnsurePetsArePromotedMutation, EnsurePetsArePromotedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnsurePetsArePromotedMutation, EnsurePetsArePromotedMutationVariables>(EnsurePetsArePromotedDocument, options);
      }
export type EnsurePetsArePromotedMutationHookResult = ReturnType<typeof useEnsurePetsArePromotedMutation>;
export type EnsurePetsArePromotedMutationResult = Apollo.MutationResult<EnsurePetsArePromotedMutation>;
export type EnsurePetsArePromotedMutationOptions = Apollo.BaseMutationOptions<EnsurePetsArePromotedMutation, EnsurePetsArePromotedMutationVariables>;
export const PerformCarePlanEnrollmentUpgradeDocument = gql`
    mutation performCarePlanEnrollmentUpgrade($data: PerformCarePlanEnrollmentUpgradeInput!) {
  performCarePlanEnrollmentUpgrade(data: $data) {
    success
    message
    upgradeInvoiceId
  }
}
    `;
export type PerformCarePlanEnrollmentUpgradeMutationFn = Apollo.MutationFunction<PerformCarePlanEnrollmentUpgradeMutation, PerformCarePlanEnrollmentUpgradeMutationVariables>;

/**
 * __usePerformCarePlanEnrollmentUpgradeMutation__
 *
 * To run a mutation, you first call `usePerformCarePlanEnrollmentUpgradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePerformCarePlanEnrollmentUpgradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [performCarePlanEnrollmentUpgradeMutation, { data, loading, error }] = usePerformCarePlanEnrollmentUpgradeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePerformCarePlanEnrollmentUpgradeMutation(baseOptions?: Apollo.MutationHookOptions<PerformCarePlanEnrollmentUpgradeMutation, PerformCarePlanEnrollmentUpgradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PerformCarePlanEnrollmentUpgradeMutation, PerformCarePlanEnrollmentUpgradeMutationVariables>(PerformCarePlanEnrollmentUpgradeDocument, options);
      }
export type PerformCarePlanEnrollmentUpgradeMutationHookResult = ReturnType<typeof usePerformCarePlanEnrollmentUpgradeMutation>;
export type PerformCarePlanEnrollmentUpgradeMutationResult = Apollo.MutationResult<PerformCarePlanEnrollmentUpgradeMutation>;
export type PerformCarePlanEnrollmentUpgradeMutationOptions = Apollo.BaseMutationOptions<PerformCarePlanEnrollmentUpgradeMutation, PerformCarePlanEnrollmentUpgradeMutationVariables>;
export const TransferCareSubscriptionDocument = gql`
    mutation transferCareSubscription($data: TransferSubscriptionInput) {
  transferCareSubscription(data: $data) {
    success
  }
}
    `;
export type TransferCareSubscriptionMutationFn = Apollo.MutationFunction<TransferCareSubscriptionMutation, TransferCareSubscriptionMutationVariables>;

/**
 * __useTransferCareSubscriptionMutation__
 *
 * To run a mutation, you first call `useTransferCareSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferCareSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferCareSubscriptionMutation, { data, loading, error }] = useTransferCareSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTransferCareSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<TransferCareSubscriptionMutation, TransferCareSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferCareSubscriptionMutation, TransferCareSubscriptionMutationVariables>(TransferCareSubscriptionDocument, options);
      }
export type TransferCareSubscriptionMutationHookResult = ReturnType<typeof useTransferCareSubscriptionMutation>;
export type TransferCareSubscriptionMutationResult = Apollo.MutationResult<TransferCareSubscriptionMutation>;
export type TransferCareSubscriptionMutationOptions = Apollo.BaseMutationOptions<TransferCareSubscriptionMutation, TransferCareSubscriptionMutationVariables>;
export const UpdateCarePlanEnrollmentDocument = gql`
    mutation updateCarePlanEnrollment($where: CarePlanEnrollmentWhereUniqueInput!, $data: CarePlanEnrollmentUpdateInput!) {
  updateOneCarePlanEnrollment(where: $where, data: $data) {
    id
    autoRenews
  }
}
    `;
export type UpdateCarePlanEnrollmentMutationFn = Apollo.MutationFunction<UpdateCarePlanEnrollmentMutation, UpdateCarePlanEnrollmentMutationVariables>;

/**
 * __useUpdateCarePlanEnrollmentMutation__
 *
 * To run a mutation, you first call `useUpdateCarePlanEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarePlanEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarePlanEnrollmentMutation, { data, loading, error }] = useUpdateCarePlanEnrollmentMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCarePlanEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarePlanEnrollmentMutation, UpdateCarePlanEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarePlanEnrollmentMutation, UpdateCarePlanEnrollmentMutationVariables>(UpdateCarePlanEnrollmentDocument, options);
      }
export type UpdateCarePlanEnrollmentMutationHookResult = ReturnType<typeof useUpdateCarePlanEnrollmentMutation>;
export type UpdateCarePlanEnrollmentMutationResult = Apollo.MutationResult<UpdateCarePlanEnrollmentMutation>;
export type UpdateCarePlanEnrollmentMutationOptions = Apollo.BaseMutationOptions<UpdateCarePlanEnrollmentMutation, UpdateCarePlanEnrollmentMutationVariables>;
export const UpdateEnrollmentSupportEventDocument = gql`
    mutation updateEnrollmentSupportEvent($where: EnrollmentSupportEventWhereUniqueInput!, $data: EnrollmentSupportEventUpdateInput!) {
  updateOneEnrollmentSupportEvent(where: $where, data: $data) {
    id
    updatedAt
  }
}
    `;
export type UpdateEnrollmentSupportEventMutationFn = Apollo.MutationFunction<UpdateEnrollmentSupportEventMutation, UpdateEnrollmentSupportEventMutationVariables>;

/**
 * __useUpdateEnrollmentSupportEventMutation__
 *
 * To run a mutation, you first call `useUpdateEnrollmentSupportEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnrollmentSupportEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnrollmentSupportEventMutation, { data, loading, error }] = useUpdateEnrollmentSupportEventMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEnrollmentSupportEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnrollmentSupportEventMutation, UpdateEnrollmentSupportEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEnrollmentSupportEventMutation, UpdateEnrollmentSupportEventMutationVariables>(UpdateEnrollmentSupportEventDocument, options);
      }
export type UpdateEnrollmentSupportEventMutationHookResult = ReturnType<typeof useUpdateEnrollmentSupportEventMutation>;
export type UpdateEnrollmentSupportEventMutationResult = Apollo.MutationResult<UpdateEnrollmentSupportEventMutation>;
export type UpdateEnrollmentSupportEventMutationOptions = Apollo.BaseMutationOptions<UpdateEnrollmentSupportEventMutation, UpdateEnrollmentSupportEventMutationVariables>;
export const ExportCancellationSummaryAsPdfDocument = gql`
    query exportCancellationSummaryAsPdf($data: ExportCancellationSummaryAsPdfInput!) {
  exportCancellationSummaryAsPdf(data: $data) {
    success
    base64PDF
  }
}
    `;

/**
 * __useExportCancellationSummaryAsPdfQuery__
 *
 * To run a query within a React component, call `useExportCancellationSummaryAsPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCancellationSummaryAsPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCancellationSummaryAsPdfQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExportCancellationSummaryAsPdfQuery(baseOptions: Apollo.QueryHookOptions<ExportCancellationSummaryAsPdfQuery, ExportCancellationSummaryAsPdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportCancellationSummaryAsPdfQuery, ExportCancellationSummaryAsPdfQueryVariables>(ExportCancellationSummaryAsPdfDocument, options);
      }
export function useExportCancellationSummaryAsPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportCancellationSummaryAsPdfQuery, ExportCancellationSummaryAsPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportCancellationSummaryAsPdfQuery, ExportCancellationSummaryAsPdfQueryVariables>(ExportCancellationSummaryAsPdfDocument, options);
        }
export type ExportCancellationSummaryAsPdfQueryHookResult = ReturnType<typeof useExportCancellationSummaryAsPdfQuery>;
export type ExportCancellationSummaryAsPdfLazyQueryHookResult = ReturnType<typeof useExportCancellationSummaryAsPdfLazyQuery>;
export type ExportCancellationSummaryAsPdfQueryResult = Apollo.QueryResult<ExportCancellationSummaryAsPdfQuery, ExportCancellationSummaryAsPdfQueryVariables>;
export function refetchExportCancellationSummaryAsPdfQuery(variables?: ExportCancellationSummaryAsPdfQueryVariables) {
      return { query: ExportCancellationSummaryAsPdfDocument, variables: variables }
    }
export const FindLastUsageByBenefitDocument = gql`
    query findLastUsageByBenefit($usageClinicPetId: String, $benefitId: String) {
  findManyCareBenefitUsage(
    where: {usageClinicPetId: {equals: $usageClinicPetId}, benefitId: {equals: $benefitId}}
    take: 1
    orderBy: {usedAt: desc}
  ) {
    id
  }
}
    `;

/**
 * __useFindLastUsageByBenefitQuery__
 *
 * To run a query within a React component, call `useFindLastUsageByBenefitQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindLastUsageByBenefitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLastUsageByBenefitQuery({
 *   variables: {
 *      usageClinicPetId: // value for 'usageClinicPetId'
 *      benefitId: // value for 'benefitId'
 *   },
 * });
 */
export function useFindLastUsageByBenefitQuery(baseOptions?: Apollo.QueryHookOptions<FindLastUsageByBenefitQuery, FindLastUsageByBenefitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindLastUsageByBenefitQuery, FindLastUsageByBenefitQueryVariables>(FindLastUsageByBenefitDocument, options);
      }
export function useFindLastUsageByBenefitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindLastUsageByBenefitQuery, FindLastUsageByBenefitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindLastUsageByBenefitQuery, FindLastUsageByBenefitQueryVariables>(FindLastUsageByBenefitDocument, options);
        }
export type FindLastUsageByBenefitQueryHookResult = ReturnType<typeof useFindLastUsageByBenefitQuery>;
export type FindLastUsageByBenefitLazyQueryHookResult = ReturnType<typeof useFindLastUsageByBenefitLazyQuery>;
export type FindLastUsageByBenefitQueryResult = Apollo.QueryResult<FindLastUsageByBenefitQuery, FindLastUsageByBenefitQueryVariables>;
export function refetchFindLastUsageByBenefitQuery(variables?: FindLastUsageByBenefitQueryVariables) {
      return { query: FindLastUsageByBenefitDocument, variables: variables }
    }
export const FindManyCareBenefitUsageDocument = gql`
    query findManyCareBenefitUsage($orgPetId: String, $orgPetParentId: String, $take: Int, $orderBy: [CareBenefitUsageOrderByWithRelationInput!]) {
  findManyCareBenefitUsage(
    where: {usageClinicPet: {petParents: {some: {organizationPetParentId: {equals: $orgPetParentId}}}, organizationPetId: {equals: $orgPetId}}}
    take: $take
    orderBy: $orderBy
  ) {
    ...CareBenefitActivityUsage
  }
  findManyCareBenefitUsageCount(
    where: {usageClinicPet: {petParents: {some: {organizationPetParentId: {equals: $orgPetParentId}}}, organizationPetId: {equals: $orgPetId}}}
  )
}
    ${CareBenefitActivityUsageFragmentDoc}`;

/**
 * __useFindManyCareBenefitUsageQuery__
 *
 * To run a query within a React component, call `useFindManyCareBenefitUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCareBenefitUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCareBenefitUsageQuery({
 *   variables: {
 *      orgPetId: // value for 'orgPetId'
 *      orgPetParentId: // value for 'orgPetParentId'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCareBenefitUsageQuery(baseOptions?: Apollo.QueryHookOptions<FindManyCareBenefitUsageQuery, FindManyCareBenefitUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyCareBenefitUsageQuery, FindManyCareBenefitUsageQueryVariables>(FindManyCareBenefitUsageDocument, options);
      }
export function useFindManyCareBenefitUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyCareBenefitUsageQuery, FindManyCareBenefitUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyCareBenefitUsageQuery, FindManyCareBenefitUsageQueryVariables>(FindManyCareBenefitUsageDocument, options);
        }
export type FindManyCareBenefitUsageQueryHookResult = ReturnType<typeof useFindManyCareBenefitUsageQuery>;
export type FindManyCareBenefitUsageLazyQueryHookResult = ReturnType<typeof useFindManyCareBenefitUsageLazyQuery>;
export type FindManyCareBenefitUsageQueryResult = Apollo.QueryResult<FindManyCareBenefitUsageQuery, FindManyCareBenefitUsageQueryVariables>;
export function refetchFindManyCareBenefitUsageQuery(variables?: FindManyCareBenefitUsageQueryVariables) {
      return { query: FindManyCareBenefitUsageDocument, variables: variables }
    }
export const GetActivityLogCarePlanEnrollmentsDocument = gql`
    query getActivityLogCarePlanEnrollments($enrollmentWhere: CarePlanEnrollmentWhereInput, $enrollmentPaymentWhere: CareEnrollmentPaymentWhereInput, $take: Int) {
  findManyCarePlanEnrollment(where: $enrollmentWhere) {
    ...ActivityLogCareEnrollment
  }
  findManyCareEnrollmentPayment(
    where: $enrollmentPaymentWhere
    take: $take
    orderBy: {stripeInvoice: {createdAt: desc}}
  ) {
    ...ActivityLogCareEnrollmentPayment
  }
  findManyCareEnrollmentPaymentCount(where: $enrollmentPaymentWhere)
}
    ${ActivityLogCareEnrollmentFragmentDoc}
${ActivityLogCareEnrollmentPaymentFragmentDoc}`;

/**
 * __useGetActivityLogCarePlanEnrollmentsQuery__
 *
 * To run a query within a React component, call `useGetActivityLogCarePlanEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogCarePlanEnrollmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogCarePlanEnrollmentsQuery({
 *   variables: {
 *      enrollmentWhere: // value for 'enrollmentWhere'
 *      enrollmentPaymentWhere: // value for 'enrollmentPaymentWhere'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetActivityLogCarePlanEnrollmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityLogCarePlanEnrollmentsQuery, GetActivityLogCarePlanEnrollmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogCarePlanEnrollmentsQuery, GetActivityLogCarePlanEnrollmentsQueryVariables>(GetActivityLogCarePlanEnrollmentsDocument, options);
      }
export function useGetActivityLogCarePlanEnrollmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogCarePlanEnrollmentsQuery, GetActivityLogCarePlanEnrollmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogCarePlanEnrollmentsQuery, GetActivityLogCarePlanEnrollmentsQueryVariables>(GetActivityLogCarePlanEnrollmentsDocument, options);
        }
export type GetActivityLogCarePlanEnrollmentsQueryHookResult = ReturnType<typeof useGetActivityLogCarePlanEnrollmentsQuery>;
export type GetActivityLogCarePlanEnrollmentsLazyQueryHookResult = ReturnType<typeof useGetActivityLogCarePlanEnrollmentsLazyQuery>;
export type GetActivityLogCarePlanEnrollmentsQueryResult = Apollo.QueryResult<GetActivityLogCarePlanEnrollmentsQuery, GetActivityLogCarePlanEnrollmentsQueryVariables>;
export function refetchGetActivityLogCarePlanEnrollmentsQuery(variables?: GetActivityLogCarePlanEnrollmentsQueryVariables) {
      return { query: GetActivityLogCarePlanEnrollmentsDocument, variables: variables }
    }
export const GetActivityLogEnrollmentSupportEventsDocument = gql`
    query getActivityLogEnrollmentSupportEvents($supportEventWhere: EnrollmentSupportEventWhereInput, $supportEventCountWhere: EnrollmentSupportEventWhereInput, $noteEventCountWhere: EnrollmentSupportEventWhereInput, $take: Int) {
  findManyEnrollmentSupportEvent(
    where: $supportEventWhere
    take: $take
    orderBy: {createdAt: desc}
  ) {
    ...ActivityLogEnrollmentSupportEvent
  }
  findManyEnrollmentSupportEventCount(where: $supportEventCountWhere)
  findManyEnrollmentSupportEventNotesCount: findManyEnrollmentSupportEventCount(
    where: $noteEventCountWhere
  )
}
    ${ActivityLogEnrollmentSupportEventFragmentDoc}`;

/**
 * __useGetActivityLogEnrollmentSupportEventsQuery__
 *
 * To run a query within a React component, call `useGetActivityLogEnrollmentSupportEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogEnrollmentSupportEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogEnrollmentSupportEventsQuery({
 *   variables: {
 *      supportEventWhere: // value for 'supportEventWhere'
 *      supportEventCountWhere: // value for 'supportEventCountWhere'
 *      noteEventCountWhere: // value for 'noteEventCountWhere'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetActivityLogEnrollmentSupportEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityLogEnrollmentSupportEventsQuery, GetActivityLogEnrollmentSupportEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogEnrollmentSupportEventsQuery, GetActivityLogEnrollmentSupportEventsQueryVariables>(GetActivityLogEnrollmentSupportEventsDocument, options);
      }
export function useGetActivityLogEnrollmentSupportEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogEnrollmentSupportEventsQuery, GetActivityLogEnrollmentSupportEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogEnrollmentSupportEventsQuery, GetActivityLogEnrollmentSupportEventsQueryVariables>(GetActivityLogEnrollmentSupportEventsDocument, options);
        }
export type GetActivityLogEnrollmentSupportEventsQueryHookResult = ReturnType<typeof useGetActivityLogEnrollmentSupportEventsQuery>;
export type GetActivityLogEnrollmentSupportEventsLazyQueryHookResult = ReturnType<typeof useGetActivityLogEnrollmentSupportEventsLazyQuery>;
export type GetActivityLogEnrollmentSupportEventsQueryResult = Apollo.QueryResult<GetActivityLogEnrollmentSupportEventsQuery, GetActivityLogEnrollmentSupportEventsQueryVariables>;
export function refetchGetActivityLogEnrollmentSupportEventsQuery(variables?: GetActivityLogEnrollmentSupportEventsQueryVariables) {
      return { query: GetActivityLogEnrollmentSupportEventsDocument, variables: variables }
    }
export const GetActivityLogCareBenefitUsagesDocument = gql`
    query getActivityLogCareBenefitUsages($benefitUsageWhere: CareBenefitUsageWhereInput, $take: Int) {
  findManyCareBenefitUsage(
    where: $benefitUsageWhere
    take: $take
    orderBy: {usedAt: desc}
  ) {
    ...CareBenefitActivityUsage
  }
  findManyCareBenefitUsageCount(where: $benefitUsageWhere)
}
    ${CareBenefitActivityUsageFragmentDoc}`;

/**
 * __useGetActivityLogCareBenefitUsagesQuery__
 *
 * To run a query within a React component, call `useGetActivityLogCareBenefitUsagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogCareBenefitUsagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogCareBenefitUsagesQuery({
 *   variables: {
 *      benefitUsageWhere: // value for 'benefitUsageWhere'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetActivityLogCareBenefitUsagesQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityLogCareBenefitUsagesQuery, GetActivityLogCareBenefitUsagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogCareBenefitUsagesQuery, GetActivityLogCareBenefitUsagesQueryVariables>(GetActivityLogCareBenefitUsagesDocument, options);
      }
export function useGetActivityLogCareBenefitUsagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogCareBenefitUsagesQuery, GetActivityLogCareBenefitUsagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogCareBenefitUsagesQuery, GetActivityLogCareBenefitUsagesQueryVariables>(GetActivityLogCareBenefitUsagesDocument, options);
        }
export type GetActivityLogCareBenefitUsagesQueryHookResult = ReturnType<typeof useGetActivityLogCareBenefitUsagesQuery>;
export type GetActivityLogCareBenefitUsagesLazyQueryHookResult = ReturnType<typeof useGetActivityLogCareBenefitUsagesLazyQuery>;
export type GetActivityLogCareBenefitUsagesQueryResult = Apollo.QueryResult<GetActivityLogCareBenefitUsagesQuery, GetActivityLogCareBenefitUsagesQueryVariables>;
export function refetchGetActivityLogCareBenefitUsagesQuery(variables?: GetActivityLogCareBenefitUsagesQueryVariables) {
      return { query: GetActivityLogCareBenefitUsagesDocument, variables: variables }
    }
export const GetCareEnrollmentInfoDocument = gql`
    query getCareEnrollmentInfo($enrollmentId: String) {
  findUniqueCarePlanEnrollment(where: {id: $enrollmentId}) {
    id
    startDate
    plan {
      ...CarePlanInfo
    }
    planPricing {
      ...CarePlanPricingInfo
    }
    enrollmentPayments(where: {paidAt: {not: null}}) {
      ...CareEnrollmentPaymentInfo
    }
  }
}
    ${CarePlanInfoFragmentDoc}
${CarePlanPricingInfoFragmentDoc}
${CareEnrollmentPaymentInfoFragmentDoc}`;

/**
 * __useGetCareEnrollmentInfoQuery__
 *
 * To run a query within a React component, call `useGetCareEnrollmentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareEnrollmentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareEnrollmentInfoQuery({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *   },
 * });
 */
export function useGetCareEnrollmentInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetCareEnrollmentInfoQuery, GetCareEnrollmentInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareEnrollmentInfoQuery, GetCareEnrollmentInfoQueryVariables>(GetCareEnrollmentInfoDocument, options);
      }
export function useGetCareEnrollmentInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareEnrollmentInfoQuery, GetCareEnrollmentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareEnrollmentInfoQuery, GetCareEnrollmentInfoQueryVariables>(GetCareEnrollmentInfoDocument, options);
        }
export type GetCareEnrollmentInfoQueryHookResult = ReturnType<typeof useGetCareEnrollmentInfoQuery>;
export type GetCareEnrollmentInfoLazyQueryHookResult = ReturnType<typeof useGetCareEnrollmentInfoLazyQuery>;
export type GetCareEnrollmentInfoQueryResult = Apollo.QueryResult<GetCareEnrollmentInfoQuery, GetCareEnrollmentInfoQueryVariables>;
export function refetchGetCareEnrollmentInfoQuery(variables?: GetCareEnrollmentInfoQueryVariables) {
      return { query: GetCareEnrollmentInfoDocument, variables: variables }
    }
export const GetCareEnrollmentTrueUpHistoryDocument = gql`
    query getCareEnrollmentTrueUpHistory($where: CareSubscriptionTrueUpWhereInput) {
  findManyCareSubscriptionTrueUp(where: $where, orderBy: {dueAt: asc}) {
    id
    dueAt
    completedAt
    retryAt
    amount
    shouldCancelEnrollment
  }
}
    `;

/**
 * __useGetCareEnrollmentTrueUpHistoryQuery__
 *
 * To run a query within a React component, call `useGetCareEnrollmentTrueUpHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareEnrollmentTrueUpHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareEnrollmentTrueUpHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCareEnrollmentTrueUpHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetCareEnrollmentTrueUpHistoryQuery, GetCareEnrollmentTrueUpHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareEnrollmentTrueUpHistoryQuery, GetCareEnrollmentTrueUpHistoryQueryVariables>(GetCareEnrollmentTrueUpHistoryDocument, options);
      }
export function useGetCareEnrollmentTrueUpHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareEnrollmentTrueUpHistoryQuery, GetCareEnrollmentTrueUpHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareEnrollmentTrueUpHistoryQuery, GetCareEnrollmentTrueUpHistoryQueryVariables>(GetCareEnrollmentTrueUpHistoryDocument, options);
        }
export type GetCareEnrollmentTrueUpHistoryQueryHookResult = ReturnType<typeof useGetCareEnrollmentTrueUpHistoryQuery>;
export type GetCareEnrollmentTrueUpHistoryLazyQueryHookResult = ReturnType<typeof useGetCareEnrollmentTrueUpHistoryLazyQuery>;
export type GetCareEnrollmentTrueUpHistoryQueryResult = Apollo.QueryResult<GetCareEnrollmentTrueUpHistoryQuery, GetCareEnrollmentTrueUpHistoryQueryVariables>;
export function refetchGetCareEnrollmentTrueUpHistoryQuery(variables?: GetCareEnrollmentTrueUpHistoryQueryVariables) {
      return { query: GetCareEnrollmentTrueUpHistoryDocument, variables: variables }
    }
export const GetCareSavedPaymentMethodsDocument = gql`
    query getCareSavedPaymentMethods($where: StripePaymentMethodWhereInput) {
  findManyStripePaymentMethod(where: $where) {
    id
    isDefault
    isExpired
    last4
    cardBrand
    expirationMonth
    expirationYear
    stripeId
  }
}
    `;

/**
 * __useGetCareSavedPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetCareSavedPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareSavedPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareSavedPaymentMethodsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCareSavedPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetCareSavedPaymentMethodsQuery, GetCareSavedPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareSavedPaymentMethodsQuery, GetCareSavedPaymentMethodsQueryVariables>(GetCareSavedPaymentMethodsDocument, options);
      }
export function useGetCareSavedPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareSavedPaymentMethodsQuery, GetCareSavedPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareSavedPaymentMethodsQuery, GetCareSavedPaymentMethodsQueryVariables>(GetCareSavedPaymentMethodsDocument, options);
        }
export type GetCareSavedPaymentMethodsQueryHookResult = ReturnType<typeof useGetCareSavedPaymentMethodsQuery>;
export type GetCareSavedPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetCareSavedPaymentMethodsLazyQuery>;
export type GetCareSavedPaymentMethodsQueryResult = Apollo.QueryResult<GetCareSavedPaymentMethodsQuery, GetCareSavedPaymentMethodsQueryVariables>;
export function refetchGetCareSavedPaymentMethodsQuery(variables?: GetCareSavedPaymentMethodsQueryVariables) {
      return { query: GetCareSavedPaymentMethodsDocument, variables: variables }
    }
export const GetBalanceForClientDocument = gql`
    query getBalanceForClient($where: GetBalanceForClientInput!) {
  getBalanceForClient(where: $where) {
    ...BalanceForClient
  }
}
    ${BalanceForClientFragmentDoc}`;

/**
 * __useGetBalanceForClientQuery__
 *
 * To run a query within a React component, call `useGetBalanceForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBalanceForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBalanceForClientQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetBalanceForClientQuery(baseOptions: Apollo.QueryHookOptions<GetBalanceForClientQuery, GetBalanceForClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBalanceForClientQuery, GetBalanceForClientQueryVariables>(GetBalanceForClientDocument, options);
      }
export function useGetBalanceForClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBalanceForClientQuery, GetBalanceForClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBalanceForClientQuery, GetBalanceForClientQueryVariables>(GetBalanceForClientDocument, options);
        }
export type GetBalanceForClientQueryHookResult = ReturnType<typeof useGetBalanceForClientQuery>;
export type GetBalanceForClientLazyQueryHookResult = ReturnType<typeof useGetBalanceForClientLazyQuery>;
export type GetBalanceForClientQueryResult = Apollo.QueryResult<GetBalanceForClientQuery, GetBalanceForClientQueryVariables>;
export function refetchGetBalanceForClientQuery(variables?: GetBalanceForClientQueryVariables) {
      return { query: GetBalanceForClientDocument, variables: variables }
    }
export const GetInvoicesForClientDocument = gql`
    query getInvoicesForClient($where: InvoiceWhereInput!) {
  getInvoicesForClient(where: $where, orderBy: {date: desc}) {
    ...InvoiceForClient
  }
}
    ${InvoiceForClientFragmentDoc}`;

/**
 * __useGetInvoicesForClientQuery__
 *
 * To run a query within a React component, call `useGetInvoicesForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesForClientQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetInvoicesForClientQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesForClientQuery, GetInvoicesForClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesForClientQuery, GetInvoicesForClientQueryVariables>(GetInvoicesForClientDocument, options);
      }
export function useGetInvoicesForClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesForClientQuery, GetInvoicesForClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesForClientQuery, GetInvoicesForClientQueryVariables>(GetInvoicesForClientDocument, options);
        }
export type GetInvoicesForClientQueryHookResult = ReturnType<typeof useGetInvoicesForClientQuery>;
export type GetInvoicesForClientLazyQueryHookResult = ReturnType<typeof useGetInvoicesForClientLazyQuery>;
export type GetInvoicesForClientQueryResult = Apollo.QueryResult<GetInvoicesForClientQuery, GetInvoicesForClientQueryVariables>;
export function refetchGetInvoicesForClientQuery(variables?: GetInvoicesForClientQueryVariables) {
      return { query: GetInvoicesForClientDocument, variables: variables }
    }
export const GetClinicCarePlansDocument = gql`
    query getClinicCarePlans($where: CarePlanProviderGroupWhereInput) {
  findFirstCarePlanProviderGroup(where: $where) {
    ...ClinicCarePlanProviderGroup
  }
}
    ${ClinicCarePlanProviderGroupFragmentDoc}`;

/**
 * __useGetClinicCarePlansQuery__
 *
 * To run a query within a React component, call `useGetClinicCarePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicCarePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicCarePlansQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicCarePlansQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicCarePlansQuery, GetClinicCarePlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicCarePlansQuery, GetClinicCarePlansQueryVariables>(GetClinicCarePlansDocument, options);
      }
export function useGetClinicCarePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicCarePlansQuery, GetClinicCarePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicCarePlansQuery, GetClinicCarePlansQueryVariables>(GetClinicCarePlansDocument, options);
        }
export type GetClinicCarePlansQueryHookResult = ReturnType<typeof useGetClinicCarePlansQuery>;
export type GetClinicCarePlansLazyQueryHookResult = ReturnType<typeof useGetClinicCarePlansLazyQuery>;
export type GetClinicCarePlansQueryResult = Apollo.QueryResult<GetClinicCarePlansQuery, GetClinicCarePlansQueryVariables>;
export function refetchGetClinicCarePlansQuery(variables?: GetClinicCarePlansQueryVariables) {
      return { query: GetClinicCarePlansDocument, variables: variables }
    }
export const GetCustomerStripePortalUrlDocument = gql`
    query getCustomerStripePortalUrl($data: StripeCustomerPortalInput, $clinicPetParentId: String) {
  stripeRetrievePetParentPortalUrl(
    data: $data
    clinicPetParentId: $clinicPetParentId
  ) {
    id
    url
  }
}
    `;

/**
 * __useGetCustomerStripePortalUrlQuery__
 *
 * To run a query within a React component, call `useGetCustomerStripePortalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerStripePortalUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerStripePortalUrlQuery({
 *   variables: {
 *      data: // value for 'data'
 *      clinicPetParentId: // value for 'clinicPetParentId'
 *   },
 * });
 */
export function useGetCustomerStripePortalUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerStripePortalUrlQuery, GetCustomerStripePortalUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerStripePortalUrlQuery, GetCustomerStripePortalUrlQueryVariables>(GetCustomerStripePortalUrlDocument, options);
      }
export function useGetCustomerStripePortalUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerStripePortalUrlQuery, GetCustomerStripePortalUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerStripePortalUrlQuery, GetCustomerStripePortalUrlQueryVariables>(GetCustomerStripePortalUrlDocument, options);
        }
export type GetCustomerStripePortalUrlQueryHookResult = ReturnType<typeof useGetCustomerStripePortalUrlQuery>;
export type GetCustomerStripePortalUrlLazyQueryHookResult = ReturnType<typeof useGetCustomerStripePortalUrlLazyQuery>;
export type GetCustomerStripePortalUrlQueryResult = Apollo.QueryResult<GetCustomerStripePortalUrlQuery, GetCustomerStripePortalUrlQueryVariables>;
export function refetchGetCustomerStripePortalUrlQuery(variables?: GetCustomerStripePortalUrlQueryVariables) {
      return { query: GetCustomerStripePortalUrlDocument, variables: variables }
    }
export const GetSidePanelBenefitsClinicPetParentDocument = gql`
    query getSidePanelBenefitsClinicPetParent($clinicPetParentId: String!) {
  findUniqueClinicPetParent(where: {id: $clinicPetParentId}) {
    ...CareBenefitPetParent
  }
}
    ${CareBenefitPetParentFragmentDoc}`;

/**
 * __useGetSidePanelBenefitsClinicPetParentQuery__
 *
 * To run a query within a React component, call `useGetSidePanelBenefitsClinicPetParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSidePanelBenefitsClinicPetParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSidePanelBenefitsClinicPetParentQuery({
 *   variables: {
 *      clinicPetParentId: // value for 'clinicPetParentId'
 *   },
 * });
 */
export function useGetSidePanelBenefitsClinicPetParentQuery(baseOptions: Apollo.QueryHookOptions<GetSidePanelBenefitsClinicPetParentQuery, GetSidePanelBenefitsClinicPetParentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSidePanelBenefitsClinicPetParentQuery, GetSidePanelBenefitsClinicPetParentQueryVariables>(GetSidePanelBenefitsClinicPetParentDocument, options);
      }
export function useGetSidePanelBenefitsClinicPetParentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSidePanelBenefitsClinicPetParentQuery, GetSidePanelBenefitsClinicPetParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSidePanelBenefitsClinicPetParentQuery, GetSidePanelBenefitsClinicPetParentQueryVariables>(GetSidePanelBenefitsClinicPetParentDocument, options);
        }
export type GetSidePanelBenefitsClinicPetParentQueryHookResult = ReturnType<typeof useGetSidePanelBenefitsClinicPetParentQuery>;
export type GetSidePanelBenefitsClinicPetParentLazyQueryHookResult = ReturnType<typeof useGetSidePanelBenefitsClinicPetParentLazyQuery>;
export type GetSidePanelBenefitsClinicPetParentQueryResult = Apollo.QueryResult<GetSidePanelBenefitsClinicPetParentQuery, GetSidePanelBenefitsClinicPetParentQueryVariables>;
export function refetchGetSidePanelBenefitsClinicPetParentQuery(variables?: GetSidePanelBenefitsClinicPetParentQueryVariables) {
      return { query: GetSidePanelBenefitsClinicPetParentDocument, variables: variables }
    }
export const SubscribeToActivityLogUpdatedDocument = gql`
    subscription subscribeToActivityLogUpdated($enrollmentId: String!) {
  enrollmentActivityLogUpdated(where: {enrollmentId: $enrollmentId}) {
    node {
      id
    }
    model
  }
}
    `;

/**
 * __useSubscribeToActivityLogUpdatedSubscription__
 *
 * To run a query within a React component, call `useSubscribeToActivityLogUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToActivityLogUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToActivityLogUpdatedSubscription({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *   },
 * });
 */
export function useSubscribeToActivityLogUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToActivityLogUpdatedSubscription, SubscribeToActivityLogUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToActivityLogUpdatedSubscription, SubscribeToActivityLogUpdatedSubscriptionVariables>(SubscribeToActivityLogUpdatedDocument, options);
      }
export type SubscribeToActivityLogUpdatedSubscriptionHookResult = ReturnType<typeof useSubscribeToActivityLogUpdatedSubscription>;
export type SubscribeToActivityLogUpdatedSubscriptionResult = Apollo.SubscriptionResult<SubscribeToActivityLogUpdatedSubscription>;
export const ClaimRewardDocument = gql`
    mutation claimReward($data: RequestLoyaltyRewardInput!) {
  requestLoyaltyReward(data: $data) {
    id
  }
}
    `;
export type ClaimRewardMutationFn = Apollo.MutationFunction<ClaimRewardMutation, ClaimRewardMutationVariables>;

/**
 * __useClaimRewardMutation__
 *
 * To run a mutation, you first call `useClaimRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimRewardMutation, { data, loading, error }] = useClaimRewardMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useClaimRewardMutation(baseOptions?: Apollo.MutationHookOptions<ClaimRewardMutation, ClaimRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimRewardMutation, ClaimRewardMutationVariables>(ClaimRewardDocument, options);
      }
export type ClaimRewardMutationHookResult = ReturnType<typeof useClaimRewardMutation>;
export type ClaimRewardMutationResult = Apollo.MutationResult<ClaimRewardMutation>;
export type ClaimRewardMutationOptions = Apollo.BaseMutationOptions<ClaimRewardMutation, ClaimRewardMutationVariables>;
export const FindOrCreateLoyaltyAccountForClinicPetParentDocument = gql`
    mutation findOrCreateLoyaltyAccountForClinicPetParent($clinicPetParentId: String!) {
  findOrCreateLoyaltyAccountForClinicPetParent(
    clinicPetParentId: $clinicPetParentId
  ) {
    id
    program {
      id
      status
    }
    pointBalance
    rewardRedemptions(
      where: {status: {equals: PendingFulfillment}}
      orderBy: {createdAt: desc}
      take: 1
    ) {
      ...LoyaltyProgramRewardRedemption
    }
  }
}
    ${LoyaltyProgramRewardRedemptionFragmentDoc}`;
export type FindOrCreateLoyaltyAccountForClinicPetParentMutationFn = Apollo.MutationFunction<FindOrCreateLoyaltyAccountForClinicPetParentMutation, FindOrCreateLoyaltyAccountForClinicPetParentMutationVariables>;

/**
 * __useFindOrCreateLoyaltyAccountForClinicPetParentMutation__
 *
 * To run a mutation, you first call `useFindOrCreateLoyaltyAccountForClinicPetParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindOrCreateLoyaltyAccountForClinicPetParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findOrCreateLoyaltyAccountForClinicPetParentMutation, { data, loading, error }] = useFindOrCreateLoyaltyAccountForClinicPetParentMutation({
 *   variables: {
 *      clinicPetParentId: // value for 'clinicPetParentId'
 *   },
 * });
 */
export function useFindOrCreateLoyaltyAccountForClinicPetParentMutation(baseOptions?: Apollo.MutationHookOptions<FindOrCreateLoyaltyAccountForClinicPetParentMutation, FindOrCreateLoyaltyAccountForClinicPetParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FindOrCreateLoyaltyAccountForClinicPetParentMutation, FindOrCreateLoyaltyAccountForClinicPetParentMutationVariables>(FindOrCreateLoyaltyAccountForClinicPetParentDocument, options);
      }
export type FindOrCreateLoyaltyAccountForClinicPetParentMutationHookResult = ReturnType<typeof useFindOrCreateLoyaltyAccountForClinicPetParentMutation>;
export type FindOrCreateLoyaltyAccountForClinicPetParentMutationResult = Apollo.MutationResult<FindOrCreateLoyaltyAccountForClinicPetParentMutation>;
export type FindOrCreateLoyaltyAccountForClinicPetParentMutationOptions = Apollo.BaseMutationOptions<FindOrCreateLoyaltyAccountForClinicPetParentMutation, FindOrCreateLoyaltyAccountForClinicPetParentMutationVariables>;
export const FulfillRewardDocument = gql`
    mutation fulfillReward($data: LoyaltyRewardRedemptionInput!) {
  fulfillLoyaltyRewardRedemption(data: $data) {
    id
  }
}
    `;
export type FulfillRewardMutationFn = Apollo.MutationFunction<FulfillRewardMutation, FulfillRewardMutationVariables>;

/**
 * __useFulfillRewardMutation__
 *
 * To run a mutation, you first call `useFulfillRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFulfillRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fulfillRewardMutation, { data, loading, error }] = useFulfillRewardMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFulfillRewardMutation(baseOptions?: Apollo.MutationHookOptions<FulfillRewardMutation, FulfillRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FulfillRewardMutation, FulfillRewardMutationVariables>(FulfillRewardDocument, options);
      }
export type FulfillRewardMutationHookResult = ReturnType<typeof useFulfillRewardMutation>;
export type FulfillRewardMutationResult = Apollo.MutationResult<FulfillRewardMutation>;
export type FulfillRewardMutationOptions = Apollo.BaseMutationOptions<FulfillRewardMutation, FulfillRewardMutationVariables>;
export const GrantPointsDocument = gql`
    mutation grantPoints($data: LoyaltyPointGrantByUser!) {
  submitLoyaltyPointGrantToAccountByUser(data: $data) {
    success
  }
}
    `;
export type GrantPointsMutationFn = Apollo.MutationFunction<GrantPointsMutation, GrantPointsMutationVariables>;

/**
 * __useGrantPointsMutation__
 *
 * To run a mutation, you first call `useGrantPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantPointsMutation, { data, loading, error }] = useGrantPointsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGrantPointsMutation(baseOptions?: Apollo.MutationHookOptions<GrantPointsMutation, GrantPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantPointsMutation, GrantPointsMutationVariables>(GrantPointsDocument, options);
      }
export type GrantPointsMutationHookResult = ReturnType<typeof useGrantPointsMutation>;
export type GrantPointsMutationResult = Apollo.MutationResult<GrantPointsMutation>;
export type GrantPointsMutationOptions = Apollo.BaseMutationOptions<GrantPointsMutation, GrantPointsMutationVariables>;
export const GetFirstLoyaltyRewardRedemptionDocument = gql`
    query getFirstLoyaltyRewardRedemption($where: LoyaltyRewardRedemptionWhereInput) {
  findFirstLoyaltyRewardRedemption(where: $where) {
    id
  }
}
    `;

/**
 * __useGetFirstLoyaltyRewardRedemptionQuery__
 *
 * To run a query within a React component, call `useGetFirstLoyaltyRewardRedemptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstLoyaltyRewardRedemptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstLoyaltyRewardRedemptionQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFirstLoyaltyRewardRedemptionQuery(baseOptions?: Apollo.QueryHookOptions<GetFirstLoyaltyRewardRedemptionQuery, GetFirstLoyaltyRewardRedemptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirstLoyaltyRewardRedemptionQuery, GetFirstLoyaltyRewardRedemptionQueryVariables>(GetFirstLoyaltyRewardRedemptionDocument, options);
      }
export function useGetFirstLoyaltyRewardRedemptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirstLoyaltyRewardRedemptionQuery, GetFirstLoyaltyRewardRedemptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirstLoyaltyRewardRedemptionQuery, GetFirstLoyaltyRewardRedemptionQueryVariables>(GetFirstLoyaltyRewardRedemptionDocument, options);
        }
export type GetFirstLoyaltyRewardRedemptionQueryHookResult = ReturnType<typeof useGetFirstLoyaltyRewardRedemptionQuery>;
export type GetFirstLoyaltyRewardRedemptionLazyQueryHookResult = ReturnType<typeof useGetFirstLoyaltyRewardRedemptionLazyQuery>;
export type GetFirstLoyaltyRewardRedemptionQueryResult = Apollo.QueryResult<GetFirstLoyaltyRewardRedemptionQuery, GetFirstLoyaltyRewardRedemptionQueryVariables>;
export function refetchGetFirstLoyaltyRewardRedemptionQuery(variables?: GetFirstLoyaltyRewardRedemptionQueryVariables) {
      return { query: GetFirstLoyaltyRewardRedemptionDocument, variables: variables }
    }
export const GetPetParentLoyaltyAccountHolderDocument = gql`
    query getPetParentLoyaltyAccountHolder($where: LoyaltyAccountHolderWhereInput) {
  findFirstLoyaltyAccountHolder(where: $where) {
    id
    account {
      id
      pointBalance
      rewardRedemptions(
        where: {status: {equals: PendingFulfillment}}
        orderBy: {createdAt: desc}
      ) {
        ...LoyaltyProgramRewardRedemption
      }
    }
  }
}
    ${LoyaltyProgramRewardRedemptionFragmentDoc}`;

/**
 * __useGetPetParentLoyaltyAccountHolderQuery__
 *
 * To run a query within a React component, call `useGetPetParentLoyaltyAccountHolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPetParentLoyaltyAccountHolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPetParentLoyaltyAccountHolderQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPetParentLoyaltyAccountHolderQuery(baseOptions?: Apollo.QueryHookOptions<GetPetParentLoyaltyAccountHolderQuery, GetPetParentLoyaltyAccountHolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPetParentLoyaltyAccountHolderQuery, GetPetParentLoyaltyAccountHolderQueryVariables>(GetPetParentLoyaltyAccountHolderDocument, options);
      }
export function useGetPetParentLoyaltyAccountHolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPetParentLoyaltyAccountHolderQuery, GetPetParentLoyaltyAccountHolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPetParentLoyaltyAccountHolderQuery, GetPetParentLoyaltyAccountHolderQueryVariables>(GetPetParentLoyaltyAccountHolderDocument, options);
        }
export type GetPetParentLoyaltyAccountHolderQueryHookResult = ReturnType<typeof useGetPetParentLoyaltyAccountHolderQuery>;
export type GetPetParentLoyaltyAccountHolderLazyQueryHookResult = ReturnType<typeof useGetPetParentLoyaltyAccountHolderLazyQuery>;
export type GetPetParentLoyaltyAccountHolderQueryResult = Apollo.QueryResult<GetPetParentLoyaltyAccountHolderQuery, GetPetParentLoyaltyAccountHolderQueryVariables>;
export function refetchGetPetParentLoyaltyAccountHolderQuery(variables?: GetPetParentLoyaltyAccountHolderQueryVariables) {
      return { query: GetPetParentLoyaltyAccountHolderDocument, variables: variables }
    }
export const GetPetParentLoyaltyProgramDataDocument = gql`
    query getPetParentLoyaltyProgramData($where: ClinicPetParentWhereInput) {
  findFirstClinicPetParent(where: $where) {
    id
    firstName
    lastName
    loyaltyAccountHolder {
      id
      programId
      account {
        id
        pointBalance
      }
    }
  }
}
    `;

/**
 * __useGetPetParentLoyaltyProgramDataQuery__
 *
 * To run a query within a React component, call `useGetPetParentLoyaltyProgramDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPetParentLoyaltyProgramDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPetParentLoyaltyProgramDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPetParentLoyaltyProgramDataQuery(baseOptions?: Apollo.QueryHookOptions<GetPetParentLoyaltyProgramDataQuery, GetPetParentLoyaltyProgramDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPetParentLoyaltyProgramDataQuery, GetPetParentLoyaltyProgramDataQueryVariables>(GetPetParentLoyaltyProgramDataDocument, options);
      }
export function useGetPetParentLoyaltyProgramDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPetParentLoyaltyProgramDataQuery, GetPetParentLoyaltyProgramDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPetParentLoyaltyProgramDataQuery, GetPetParentLoyaltyProgramDataQueryVariables>(GetPetParentLoyaltyProgramDataDocument, options);
        }
export type GetPetParentLoyaltyProgramDataQueryHookResult = ReturnType<typeof useGetPetParentLoyaltyProgramDataQuery>;
export type GetPetParentLoyaltyProgramDataLazyQueryHookResult = ReturnType<typeof useGetPetParentLoyaltyProgramDataLazyQuery>;
export type GetPetParentLoyaltyProgramDataQueryResult = Apollo.QueryResult<GetPetParentLoyaltyProgramDataQuery, GetPetParentLoyaltyProgramDataQueryVariables>;
export function refetchGetPetParentLoyaltyProgramDataQuery(variables?: GetPetParentLoyaltyProgramDataQueryVariables) {
      return { query: GetPetParentLoyaltyProgramDataDocument, variables: variables }
    }
export const GetRewardsHistoryDocument = gql`
    query getRewardsHistory($where: LoyaltyPointDeltaWhereInput, $take: Int!) {
  findManyLoyaltyPointDelta(
    where: $where
    orderBy: {createdAt: desc}
    take: $take
  ) {
    ...RewardHistory
  }
  findManyLoyaltyPointDeltaCount(where: $where)
}
    ${RewardHistoryFragmentDoc}`;

/**
 * __useGetRewardsHistoryQuery__
 *
 * To run a query within a React component, call `useGetRewardsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardsHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetRewardsHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetRewardsHistoryQuery, GetRewardsHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRewardsHistoryQuery, GetRewardsHistoryQueryVariables>(GetRewardsHistoryDocument, options);
      }
export function useGetRewardsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRewardsHistoryQuery, GetRewardsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRewardsHistoryQuery, GetRewardsHistoryQueryVariables>(GetRewardsHistoryDocument, options);
        }
export type GetRewardsHistoryQueryHookResult = ReturnType<typeof useGetRewardsHistoryQuery>;
export type GetRewardsHistoryLazyQueryHookResult = ReturnType<typeof useGetRewardsHistoryLazyQuery>;
export type GetRewardsHistoryQueryResult = Apollo.QueryResult<GetRewardsHistoryQuery, GetRewardsHistoryQueryVariables>;
export function refetchGetRewardsHistoryQuery(variables?: GetRewardsHistoryQueryVariables) {
      return { query: GetRewardsHistoryDocument, variables: variables }
    }
export const CheckPetEnrollmentDocument = gql`
    subscription checkPetEnrollment($where: CareEnrollmentWhereInput!) {
  checkPetEnrollment(where: $where) {
    isEnrolled
  }
}
    `;

/**
 * __useCheckPetEnrollmentSubscription__
 *
 * To run a query within a React component, call `useCheckPetEnrollmentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCheckPetEnrollmentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPetEnrollmentSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCheckPetEnrollmentSubscription(baseOptions: Apollo.SubscriptionHookOptions<CheckPetEnrollmentSubscription, CheckPetEnrollmentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CheckPetEnrollmentSubscription, CheckPetEnrollmentSubscriptionVariables>(CheckPetEnrollmentDocument, options);
      }
export type CheckPetEnrollmentSubscriptionHookResult = ReturnType<typeof useCheckPetEnrollmentSubscription>;
export type CheckPetEnrollmentSubscriptionResult = Apollo.SubscriptionResult<CheckPetEnrollmentSubscription>;
export const CheckPetParentHasEnrolledPetDocument = gql`
    subscription checkPetParentHasEnrolledPet($where: HasCarePetWithEnrollmentWhereInput!) {
  checkPetParentHasEnrolledPet(where: $where) {
    hasEnrolledPet
  }
}
    `;

/**
 * __useCheckPetParentHasEnrolledPetSubscription__
 *
 * To run a query within a React component, call `useCheckPetParentHasEnrolledPetSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCheckPetParentHasEnrolledPetSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPetParentHasEnrolledPetSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCheckPetParentHasEnrolledPetSubscription(baseOptions: Apollo.SubscriptionHookOptions<CheckPetParentHasEnrolledPetSubscription, CheckPetParentHasEnrolledPetSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CheckPetParentHasEnrolledPetSubscription, CheckPetParentHasEnrolledPetSubscriptionVariables>(CheckPetParentHasEnrolledPetDocument, options);
      }
export type CheckPetParentHasEnrolledPetSubscriptionHookResult = ReturnType<typeof useCheckPetParentHasEnrolledPetSubscription>;
export type CheckPetParentHasEnrolledPetSubscriptionResult = Apollo.SubscriptionResult<CheckPetParentHasEnrolledPetSubscription>;
export const SubscribeToLoyaltyAccountDocument = gql`
    subscription subscribeToLoyaltyAccount($where: LoyaltyAccountWhereUniqueInput!) {
  loyaltyAccountUpdated(where: $where) {
    node {
      id
      pointBalance
    }
    mutation
  }
}
    `;

/**
 * __useSubscribeToLoyaltyAccountSubscription__
 *
 * To run a query within a React component, call `useSubscribeToLoyaltyAccountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToLoyaltyAccountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToLoyaltyAccountSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToLoyaltyAccountSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToLoyaltyAccountSubscription, SubscribeToLoyaltyAccountSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToLoyaltyAccountSubscription, SubscribeToLoyaltyAccountSubscriptionVariables>(SubscribeToLoyaltyAccountDocument, options);
      }
export type SubscribeToLoyaltyAccountSubscriptionHookResult = ReturnType<typeof useSubscribeToLoyaltyAccountSubscription>;
export type SubscribeToLoyaltyAccountSubscriptionResult = Apollo.SubscriptionResult<SubscribeToLoyaltyAccountSubscription>;
export const SubscribeToLoyaltyProgramUpdateDocument = gql`
    subscription subscribeToLoyaltyProgramUpdate($where: LoyaltyProgramWhereUniqueInput!) {
  loyaltyProgramUpdated(where: $where) {
    node {
      id
      status
    }
    mutation
  }
}
    `;

/**
 * __useSubscribeToLoyaltyProgramUpdateSubscription__
 *
 * To run a query within a React component, call `useSubscribeToLoyaltyProgramUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToLoyaltyProgramUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToLoyaltyProgramUpdateSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToLoyaltyProgramUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToLoyaltyProgramUpdateSubscription, SubscribeToLoyaltyProgramUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToLoyaltyProgramUpdateSubscription, SubscribeToLoyaltyProgramUpdateSubscriptionVariables>(SubscribeToLoyaltyProgramUpdateDocument, options);
      }
export type SubscribeToLoyaltyProgramUpdateSubscriptionHookResult = ReturnType<typeof useSubscribeToLoyaltyProgramUpdateSubscription>;
export type SubscribeToLoyaltyProgramUpdateSubscriptionResult = Apollo.SubscriptionResult<SubscribeToLoyaltyProgramUpdateSubscription>;
export const SubscribeToLoyaltyRewardRedemptionUpdatedDocument = gql`
    subscription subscribeToLoyaltyRewardRedemptionUpdated($where: LoyaltyRewardRedemptionWhereUniqueInput!) {
  loyaltyRewardRedemptionUpdated(where: $where) {
    node {
      id
      status
    }
    mutation
  }
}
    `;

/**
 * __useSubscribeToLoyaltyRewardRedemptionUpdatedSubscription__
 *
 * To run a query within a React component, call `useSubscribeToLoyaltyRewardRedemptionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToLoyaltyRewardRedemptionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToLoyaltyRewardRedemptionUpdatedSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToLoyaltyRewardRedemptionUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToLoyaltyRewardRedemptionUpdatedSubscription, SubscribeToLoyaltyRewardRedemptionUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToLoyaltyRewardRedemptionUpdatedSubscription, SubscribeToLoyaltyRewardRedemptionUpdatedSubscriptionVariables>(SubscribeToLoyaltyRewardRedemptionUpdatedDocument, options);
      }
export type SubscribeToLoyaltyRewardRedemptionUpdatedSubscriptionHookResult = ReturnType<typeof useSubscribeToLoyaltyRewardRedemptionUpdatedSubscription>;
export type SubscribeToLoyaltyRewardRedemptionUpdatedSubscriptionResult = Apollo.SubscriptionResult<SubscribeToLoyaltyRewardRedemptionUpdatedSubscription>;
export const UpdatePetParentSettingDocument = gql`
    mutation updatePetParentSetting($data: PetParentSettingUpdateInput!, $where: PetParentSettingWhereUniqueInput!) {
  updateOnePetParentSetting(data: $data, where: $where) {
    ...SidePanelProfilePetParentSetting
  }
}
    ${SidePanelProfilePetParentSettingFragmentDoc}`;
export type UpdatePetParentSettingMutationFn = Apollo.MutationFunction<UpdatePetParentSettingMutation, UpdatePetParentSettingMutationVariables>;

/**
 * __useUpdatePetParentSettingMutation__
 *
 * To run a mutation, you first call `useUpdatePetParentSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePetParentSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePetParentSettingMutation, { data, loading, error }] = useUpdatePetParentSettingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdatePetParentSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePetParentSettingMutation, UpdatePetParentSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePetParentSettingMutation, UpdatePetParentSettingMutationVariables>(UpdatePetParentSettingDocument, options);
      }
export type UpdatePetParentSettingMutationHookResult = ReturnType<typeof useUpdatePetParentSettingMutation>;
export type UpdatePetParentSettingMutationResult = Apollo.MutationResult<UpdatePetParentSettingMutation>;
export type UpdatePetParentSettingMutationOptions = Apollo.BaseMutationOptions<UpdatePetParentSettingMutation, UpdatePetParentSettingMutationVariables>;
export const HasDeviceThatCanRecievePushDocument = gql`
    query hasDeviceThatCanRecievePush($clinicPetParentIds: [String!]) {
  findFirstClinicPetParentDevice(
    where: {clinicPetParentId: {in: $clinicPetParentIds}, isDeleted: {equals: false}, pushNotificationStatus: {equals: GRANTED}, snsEndpointArn: {not: {equals: null}}}
  ) {
    id
    pushNotificationStatus
  }
}
    `;

/**
 * __useHasDeviceThatCanRecievePushQuery__
 *
 * To run a query within a React component, call `useHasDeviceThatCanRecievePushQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasDeviceThatCanRecievePushQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasDeviceThatCanRecievePushQuery({
 *   variables: {
 *      clinicPetParentIds: // value for 'clinicPetParentIds'
 *   },
 * });
 */
export function useHasDeviceThatCanRecievePushQuery(baseOptions?: Apollo.QueryHookOptions<HasDeviceThatCanRecievePushQuery, HasDeviceThatCanRecievePushQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasDeviceThatCanRecievePushQuery, HasDeviceThatCanRecievePushQueryVariables>(HasDeviceThatCanRecievePushDocument, options);
      }
export function useHasDeviceThatCanRecievePushLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasDeviceThatCanRecievePushQuery, HasDeviceThatCanRecievePushQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasDeviceThatCanRecievePushQuery, HasDeviceThatCanRecievePushQueryVariables>(HasDeviceThatCanRecievePushDocument, options);
        }
export type HasDeviceThatCanRecievePushQueryHookResult = ReturnType<typeof useHasDeviceThatCanRecievePushQuery>;
export type HasDeviceThatCanRecievePushLazyQueryHookResult = ReturnType<typeof useHasDeviceThatCanRecievePushLazyQuery>;
export type HasDeviceThatCanRecievePushQueryResult = Apollo.QueryResult<HasDeviceThatCanRecievePushQuery, HasDeviceThatCanRecievePushQueryVariables>;
export function refetchHasDeviceThatCanRecievePushQuery(variables?: HasDeviceThatCanRecievePushQueryVariables) {
      return { query: HasDeviceThatCanRecievePushDocument, variables: variables }
    }
export const GetSidePanelParentPetsDocument = gql`
    query getSidePanelParentPets($where: ClinicPetWhereInput, $take: Int!, $orderBy: [ClinicPetOrderByWithRelationInput!]) {
  findManyClinicPet(where: $where, take: $take, orderBy: $orderBy) {
    id
    ...SidePanelParentPetData
  }
  findManyClinicPetCount(where: $where)
}
    ${SidePanelParentPetDataFragmentDoc}`;

/**
 * __useGetSidePanelParentPetsQuery__
 *
 * To run a query within a React component, call `useGetSidePanelParentPetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSidePanelParentPetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSidePanelParentPetsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetSidePanelParentPetsQuery(baseOptions: Apollo.QueryHookOptions<GetSidePanelParentPetsQuery, GetSidePanelParentPetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSidePanelParentPetsQuery, GetSidePanelParentPetsQueryVariables>(GetSidePanelParentPetsDocument, options);
      }
export function useGetSidePanelParentPetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSidePanelParentPetsQuery, GetSidePanelParentPetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSidePanelParentPetsQuery, GetSidePanelParentPetsQueryVariables>(GetSidePanelParentPetsDocument, options);
        }
export type GetSidePanelParentPetsQueryHookResult = ReturnType<typeof useGetSidePanelParentPetsQuery>;
export type GetSidePanelParentPetsLazyQueryHookResult = ReturnType<typeof useGetSidePanelParentPetsLazyQuery>;
export type GetSidePanelParentPetsQueryResult = Apollo.QueryResult<GetSidePanelParentPetsQuery, GetSidePanelParentPetsQueryVariables>;
export function refetchGetSidePanelParentPetsQuery(variables?: GetSidePanelParentPetsQueryVariables) {
      return { query: GetSidePanelParentPetsDocument, variables: variables }
    }
export const GetSidePanelPetParentProfileDocument = gql`
    query getSidePanelPetParentProfile($clinicPetParentId: String!, $clinicId: String!) {
  clinicPetParent: findFirstClinicPetParent(
    where: {id: {equals: $clinicPetParentId}, clinicId: {equals: $clinicId}}
  ) {
    ...SidePanelProfileClinicPetParent
  }
}
    ${SidePanelProfileClinicPetParentFragmentDoc}`;

/**
 * __useGetSidePanelPetParentProfileQuery__
 *
 * To run a query within a React component, call `useGetSidePanelPetParentProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSidePanelPetParentProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSidePanelPetParentProfileQuery({
 *   variables: {
 *      clinicPetParentId: // value for 'clinicPetParentId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetSidePanelPetParentProfileQuery(baseOptions: Apollo.QueryHookOptions<GetSidePanelPetParentProfileQuery, GetSidePanelPetParentProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSidePanelPetParentProfileQuery, GetSidePanelPetParentProfileQueryVariables>(GetSidePanelPetParentProfileDocument, options);
      }
export function useGetSidePanelPetParentProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSidePanelPetParentProfileQuery, GetSidePanelPetParentProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSidePanelPetParentProfileQuery, GetSidePanelPetParentProfileQueryVariables>(GetSidePanelPetParentProfileDocument, options);
        }
export type GetSidePanelPetParentProfileQueryHookResult = ReturnType<typeof useGetSidePanelPetParentProfileQuery>;
export type GetSidePanelPetParentProfileLazyQueryHookResult = ReturnType<typeof useGetSidePanelPetParentProfileLazyQuery>;
export type GetSidePanelPetParentProfileQueryResult = Apollo.QueryResult<GetSidePanelPetParentProfileQuery, GetSidePanelPetParentProfileQueryVariables>;
export function refetchGetSidePanelPetParentProfileQuery(variables?: GetSidePanelPetParentProfileQueryVariables) {
      return { query: GetSidePanelPetParentProfileDocument, variables: variables }
    }
export const UpdateClinicPetWithoutPimsDocument = gql`
    mutation updateClinicPetWithoutPims($where: ClinicPetWhereUniqueInput!, $data: ClinicPetUpdateInput!) {
  updateClinicPetWithoutPims(where: $where, data: $data) {
    id
    dateOfDeath
    ...PetAvatar
  }
}
    ${PetAvatarFragmentDoc}`;
export type UpdateClinicPetWithoutPimsMutationFn = Apollo.MutationFunction<UpdateClinicPetWithoutPimsMutation, UpdateClinicPetWithoutPimsMutationVariables>;

/**
 * __useUpdateClinicPetWithoutPimsMutation__
 *
 * To run a mutation, you first call `useUpdateClinicPetWithoutPimsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicPetWithoutPimsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicPetWithoutPimsMutation, { data, loading, error }] = useUpdateClinicPetWithoutPimsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicPetWithoutPimsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicPetWithoutPimsMutation, UpdateClinicPetWithoutPimsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicPetWithoutPimsMutation, UpdateClinicPetWithoutPimsMutationVariables>(UpdateClinicPetWithoutPimsDocument, options);
      }
export type UpdateClinicPetWithoutPimsMutationHookResult = ReturnType<typeof useUpdateClinicPetWithoutPimsMutation>;
export type UpdateClinicPetWithoutPimsMutationResult = Apollo.MutationResult<UpdateClinicPetWithoutPimsMutation>;
export type UpdateClinicPetWithoutPimsMutationOptions = Apollo.BaseMutationOptions<UpdateClinicPetWithoutPimsMutation, UpdateClinicPetWithoutPimsMutationVariables>;
export const UpdateOneClinicPetDocument = gql`
    mutation updateOneClinicPet($where: ClinicPetWhereUniqueInput!, $data: ClinicPetUpdateInput!) {
  updateOneClinicPet(where: $where, data: $data) {
    dateOfDeath
    ...PetAvatar
  }
}
    ${PetAvatarFragmentDoc}`;
export type UpdateOneClinicPetMutationFn = Apollo.MutationFunction<UpdateOneClinicPetMutation, UpdateOneClinicPetMutationVariables>;

/**
 * __useUpdateOneClinicPetMutation__
 *
 * To run a mutation, you first call `useUpdateOneClinicPetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneClinicPetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneClinicPetMutation, { data, loading, error }] = useUpdateOneClinicPetMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneClinicPetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneClinicPetMutation, UpdateOneClinicPetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneClinicPetMutation, UpdateOneClinicPetMutationVariables>(UpdateOneClinicPetDocument, options);
      }
export type UpdateOneClinicPetMutationHookResult = ReturnType<typeof useUpdateOneClinicPetMutation>;
export type UpdateOneClinicPetMutationResult = Apollo.MutationResult<UpdateOneClinicPetMutation>;
export type UpdateOneClinicPetMutationOptions = Apollo.BaseMutationOptions<UpdateOneClinicPetMutation, UpdateOneClinicPetMutationVariables>;
export const GetSidePanelPetProfileDocument = gql`
    query getSidePanelPetProfile($clinicPetId: String!, $clinicId: String!) {
  clinicPet: findFirstClinicPet(
    where: {id: {equals: $clinicPetId}, clinicId: {equals: $clinicId}}
  ) {
    id
    clinicId
    dateOfBirth
    dateOfDeath
    breed
    color
    gender
    weight
    weightUnit
    pimsId
    isDeleted
    speciesType
    ...PetAvatar
    alerts {
      value
      pimsDate
      pimsId
      isMedical
    }
    petParents(where: {isActive: {equals: true}, isDeleted: {equals: false}}) {
      id
      firstName
      lastName
      ...PetParentAvatar
    }
    serviceReminders(
      where: {AND: [{isDeleted: {equals: false}}, {service: {isDeleted: {equals: false}}}]}
    ) {
      ...SidePanelPetServiceReminders
    }
    ...OrganizationPetCareBadgePlanEnrollment
  }
}
    ${PetAvatarFragmentDoc}
${PetParentAvatarFragmentDoc}
${SidePanelPetServiceRemindersFragmentDoc}
${OrganizationPetCareBadgePlanEnrollmentFragmentDoc}`;

/**
 * __useGetSidePanelPetProfileQuery__
 *
 * To run a query within a React component, call `useGetSidePanelPetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSidePanelPetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSidePanelPetProfileQuery({
 *   variables: {
 *      clinicPetId: // value for 'clinicPetId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetSidePanelPetProfileQuery(baseOptions: Apollo.QueryHookOptions<GetSidePanelPetProfileQuery, GetSidePanelPetProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSidePanelPetProfileQuery, GetSidePanelPetProfileQueryVariables>(GetSidePanelPetProfileDocument, options);
      }
export function useGetSidePanelPetProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSidePanelPetProfileQuery, GetSidePanelPetProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSidePanelPetProfileQuery, GetSidePanelPetProfileQueryVariables>(GetSidePanelPetProfileDocument, options);
        }
export type GetSidePanelPetProfileQueryHookResult = ReturnType<typeof useGetSidePanelPetProfileQuery>;
export type GetSidePanelPetProfileLazyQueryHookResult = ReturnType<typeof useGetSidePanelPetProfileLazyQuery>;
export type GetSidePanelPetProfileQueryResult = Apollo.QueryResult<GetSidePanelPetProfileQuery, GetSidePanelPetProfileQueryVariables>;
export function refetchGetSidePanelPetProfileQuery(variables?: GetSidePanelPetProfileQueryVariables) {
      return { query: GetSidePanelPetProfileDocument, variables: variables }
    }
export const SidePanelSearchDocument = gql`
    query sidePanelSearch($whereInput: SearchClinicPetParentInput, $pageSize: Int, $petWhere: ClinicPetWhereInput) {
  clinicPetParentSearch(where: $whereInput, take: $pageSize) {
    ...SidePanelSearchClinicPetParent
  }
}
    ${SidePanelSearchClinicPetParentFragmentDoc}`;

/**
 * __useSidePanelSearchQuery__
 *
 * To run a query within a React component, call `useSidePanelSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSidePanelSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSidePanelSearchQuery({
 *   variables: {
 *      whereInput: // value for 'whereInput'
 *      pageSize: // value for 'pageSize'
 *      petWhere: // value for 'petWhere'
 *   },
 * });
 */
export function useSidePanelSearchQuery(baseOptions?: Apollo.QueryHookOptions<SidePanelSearchQuery, SidePanelSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SidePanelSearchQuery, SidePanelSearchQueryVariables>(SidePanelSearchDocument, options);
      }
export function useSidePanelSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SidePanelSearchQuery, SidePanelSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SidePanelSearchQuery, SidePanelSearchQueryVariables>(SidePanelSearchDocument, options);
        }
export type SidePanelSearchQueryHookResult = ReturnType<typeof useSidePanelSearchQuery>;
export type SidePanelSearchLazyQueryHookResult = ReturnType<typeof useSidePanelSearchLazyQuery>;
export type SidePanelSearchQueryResult = Apollo.QueryResult<SidePanelSearchQuery, SidePanelSearchQueryVariables>;
export function refetchSidePanelSearchQuery(variables?: SidePanelSearchQueryVariables) {
      return { query: SidePanelSearchDocument, variables: variables }
    }
export const CheckForExistingClinicPetParentDocument = gql`
    query checkForExistingClinicPetParent($where: ClinicPetParentWhereInput!) {
  findManyClinicPetParent(where: $where) {
    ...ExistingClinicPetParentMatch
  }
}
    ${ExistingClinicPetParentMatchFragmentDoc}`;

/**
 * __useCheckForExistingClinicPetParentQuery__
 *
 * To run a query within a React component, call `useCheckForExistingClinicPetParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckForExistingClinicPetParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckForExistingClinicPetParentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCheckForExistingClinicPetParentQuery(baseOptions: Apollo.QueryHookOptions<CheckForExistingClinicPetParentQuery, CheckForExistingClinicPetParentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckForExistingClinicPetParentQuery, CheckForExistingClinicPetParentQueryVariables>(CheckForExistingClinicPetParentDocument, options);
      }
export function useCheckForExistingClinicPetParentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckForExistingClinicPetParentQuery, CheckForExistingClinicPetParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckForExistingClinicPetParentQuery, CheckForExistingClinicPetParentQueryVariables>(CheckForExistingClinicPetParentDocument, options);
        }
export type CheckForExistingClinicPetParentQueryHookResult = ReturnType<typeof useCheckForExistingClinicPetParentQuery>;
export type CheckForExistingClinicPetParentLazyQueryHookResult = ReturnType<typeof useCheckForExistingClinicPetParentLazyQuery>;
export type CheckForExistingClinicPetParentQueryResult = Apollo.QueryResult<CheckForExistingClinicPetParentQuery, CheckForExistingClinicPetParentQueryVariables>;
export function refetchCheckForExistingClinicPetParentQuery(variables?: CheckForExistingClinicPetParentQueryVariables) {
      return { query: CheckForExistingClinicPetParentDocument, variables: variables }
    }
export const AddChannelMemberDocument = gql`
    mutation addChannelMember($channelId: String!, $clinicPetParentId: String, $userId: String) {
  addChannelMember: addChannelMember2(
    channelId: $channelId
    clinicPetParentId: $clinicPetParentId
    userId: $userId
  ) {
    id
    removedAt
    clinicPetParent {
      id
    }
    user {
      id
    }
  }
}
    `;
export type AddChannelMemberMutationFn = Apollo.MutationFunction<AddChannelMemberMutation, AddChannelMemberMutationVariables>;

/**
 * __useAddChannelMemberMutation__
 *
 * To run a mutation, you first call `useAddChannelMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChannelMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChannelMemberMutation, { data, loading, error }] = useAddChannelMemberMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      clinicPetParentId: // value for 'clinicPetParentId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddChannelMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddChannelMemberMutation, AddChannelMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddChannelMemberMutation, AddChannelMemberMutationVariables>(AddChannelMemberDocument, options);
      }
export type AddChannelMemberMutationHookResult = ReturnType<typeof useAddChannelMemberMutation>;
export type AddChannelMemberMutationResult = Apollo.MutationResult<AddChannelMemberMutation>;
export type AddChannelMemberMutationOptions = Apollo.BaseMutationOptions<AddChannelMemberMutation, AddChannelMemberMutationVariables>;
export const AddClinicFeatureFlagDocument = gql`
    mutation addClinicFeatureFlag($clinicId: String!, $featureFlagKey: String!) {
  updateOneClinic(
    where: {id: $clinicId}
    data: {featureFlags: {connect: {key: $featureFlagKey}}}
  ) {
    id
    featureFlags {
      id
      key
    }
  }
}
    `;
export type AddClinicFeatureFlagMutationFn = Apollo.MutationFunction<AddClinicFeatureFlagMutation, AddClinicFeatureFlagMutationVariables>;

/**
 * __useAddClinicFeatureFlagMutation__
 *
 * To run a mutation, you first call `useAddClinicFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClinicFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClinicFeatureFlagMutation, { data, loading, error }] = useAddClinicFeatureFlagMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      featureFlagKey: // value for 'featureFlagKey'
 *   },
 * });
 */
export function useAddClinicFeatureFlagMutation(baseOptions?: Apollo.MutationHookOptions<AddClinicFeatureFlagMutation, AddClinicFeatureFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClinicFeatureFlagMutation, AddClinicFeatureFlagMutationVariables>(AddClinicFeatureFlagDocument, options);
      }
export type AddClinicFeatureFlagMutationHookResult = ReturnType<typeof useAddClinicFeatureFlagMutation>;
export type AddClinicFeatureFlagMutationResult = Apollo.MutationResult<AddClinicFeatureFlagMutation>;
export type AddClinicFeatureFlagMutationOptions = Apollo.BaseMutationOptions<AddClinicFeatureFlagMutation, AddClinicFeatureFlagMutationVariables>;
export const CancelStripePaymentIntentDocument = gql`
    mutation cancelStripePaymentIntent($where: StripePaymentIntentWhereUniqueInput!) {
  cancelStripePaymentIntent2(where: $where) {
    id
    status
  }
}
    `;
export type CancelStripePaymentIntentMutationFn = Apollo.MutationFunction<CancelStripePaymentIntentMutation, CancelStripePaymentIntentMutationVariables>;

/**
 * __useCancelStripePaymentIntentMutation__
 *
 * To run a mutation, you first call `useCancelStripePaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelStripePaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelStripePaymentIntentMutation, { data, loading, error }] = useCancelStripePaymentIntentMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCancelStripePaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<CancelStripePaymentIntentMutation, CancelStripePaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelStripePaymentIntentMutation, CancelStripePaymentIntentMutationVariables>(CancelStripePaymentIntentDocument, options);
      }
export type CancelStripePaymentIntentMutationHookResult = ReturnType<typeof useCancelStripePaymentIntentMutation>;
export type CancelStripePaymentIntentMutationResult = Apollo.MutationResult<CancelStripePaymentIntentMutation>;
export type CancelStripePaymentIntentMutationOptions = Apollo.BaseMutationOptions<CancelStripePaymentIntentMutation, CancelStripePaymentIntentMutationVariables>;
export const ClearTerminalDisplayDocument = gql`
    mutation clearTerminalDisplay($stripeTerminalId: String!) {
  clearTerminalDisplay(stripeTerminalId: $stripeTerminalId) {
    success
    error
  }
}
    `;
export type ClearTerminalDisplayMutationFn = Apollo.MutationFunction<ClearTerminalDisplayMutation, ClearTerminalDisplayMutationVariables>;

/**
 * __useClearTerminalDisplayMutation__
 *
 * To run a mutation, you first call `useClearTerminalDisplayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearTerminalDisplayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearTerminalDisplayMutation, { data, loading, error }] = useClearTerminalDisplayMutation({
 *   variables: {
 *      stripeTerminalId: // value for 'stripeTerminalId'
 *   },
 * });
 */
export function useClearTerminalDisplayMutation(baseOptions?: Apollo.MutationHookOptions<ClearTerminalDisplayMutation, ClearTerminalDisplayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearTerminalDisplayMutation, ClearTerminalDisplayMutationVariables>(ClearTerminalDisplayDocument, options);
      }
export type ClearTerminalDisplayMutationHookResult = ReturnType<typeof useClearTerminalDisplayMutation>;
export type ClearTerminalDisplayMutationResult = Apollo.MutationResult<ClearTerminalDisplayMutation>;
export type ClearTerminalDisplayMutationOptions = Apollo.BaseMutationOptions<ClearTerminalDisplayMutation, ClearTerminalDisplayMutationVariables>;
export const ClearUserInvitationDocument = gql`
    mutation clearUserInvitation($userId: String!) {
  updateOneUser(where: {id: $userId}, data: {invitationCode: null}) {
    id
    invitationCode
  }
}
    `;
export type ClearUserInvitationMutationFn = Apollo.MutationFunction<ClearUserInvitationMutation, ClearUserInvitationMutationVariables>;

/**
 * __useClearUserInvitationMutation__
 *
 * To run a mutation, you first call `useClearUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearUserInvitationMutation, { data, loading, error }] = useClearUserInvitationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useClearUserInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ClearUserInvitationMutation, ClearUserInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearUserInvitationMutation, ClearUserInvitationMutationVariables>(ClearUserInvitationDocument, options);
      }
export type ClearUserInvitationMutationHookResult = ReturnType<typeof useClearUserInvitationMutation>;
export type ClearUserInvitationMutationResult = Apollo.MutationResult<ClearUserInvitationMutation>;
export type ClearUserInvitationMutationOptions = Apollo.BaseMutationOptions<ClearUserInvitationMutation, ClearUserInvitationMutationVariables>;
export const CreateFormSubmissionDocument = gql`
    mutation createFormSubmission($data: FormSubmissionCreateInput!) {
  createOneFormSubmission(data: $data) {
    id
  }
}
    `;
export type CreateFormSubmissionMutationFn = Apollo.MutationFunction<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>;

/**
 * __useCreateFormSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateFormSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormSubmissionMutation, { data, loading, error }] = useCreateFormSubmissionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFormSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>(CreateFormSubmissionDocument, options);
      }
export type CreateFormSubmissionMutationHookResult = ReturnType<typeof useCreateFormSubmissionMutation>;
export type CreateFormSubmissionMutationResult = Apollo.MutationResult<CreateFormSubmissionMutation>;
export type CreateFormSubmissionMutationOptions = Apollo.BaseMutationOptions<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>;
export const CreateStripePaymentIntentDocument = gql`
    mutation createStripePaymentIntent($data: StripeCreatePaymentInput!, $clinicPetParentId: String, $channelId: String, $paymentMedium: PaymentMedium, $stripeTerminalStripeId: String, $invoiceIds: [String!], $paymentRelationship: PaymentRelationship, $emailOverride: String, $careAccountCreditIntentId: String, $cardType: CardFunding) {
  createStripePaymentIntent2(
    data: $data
    clinicPetParentId: $clinicPetParentId
    channelId: $channelId
    paymentMedium: $paymentMedium
    invoiceIds: $invoiceIds
    paymentRelationship: $paymentRelationship
    stripeTerminalStripeId: $stripeTerminalStripeId
    emailOverride: $emailOverride
    careAccountCreditIntentId: $careAccountCreditIntentId
    cardType: $cardType
  ) {
    ...StripePaymentIntentSelection
  }
}
    ${StripePaymentIntentSelectionFragmentDoc}`;
export type CreateStripePaymentIntentMutationFn = Apollo.MutationFunction<CreateStripePaymentIntentMutation, CreateStripePaymentIntentMutationVariables>;

/**
 * __useCreateStripePaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreateStripePaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripePaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripePaymentIntentMutation, { data, loading, error }] = useCreateStripePaymentIntentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      clinicPetParentId: // value for 'clinicPetParentId'
 *      channelId: // value for 'channelId'
 *      paymentMedium: // value for 'paymentMedium'
 *      stripeTerminalStripeId: // value for 'stripeTerminalStripeId'
 *      invoiceIds: // value for 'invoiceIds'
 *      paymentRelationship: // value for 'paymentRelationship'
 *      emailOverride: // value for 'emailOverride'
 *      careAccountCreditIntentId: // value for 'careAccountCreditIntentId'
 *      cardType: // value for 'cardType'
 *   },
 * });
 */
export function useCreateStripePaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripePaymentIntentMutation, CreateStripePaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripePaymentIntentMutation, CreateStripePaymentIntentMutationVariables>(CreateStripePaymentIntentDocument, options);
      }
export type CreateStripePaymentIntentMutationHookResult = ReturnType<typeof useCreateStripePaymentIntentMutation>;
export type CreateStripePaymentIntentMutationResult = Apollo.MutationResult<CreateStripePaymentIntentMutation>;
export type CreateStripePaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreateStripePaymentIntentMutation, CreateStripePaymentIntentMutationVariables>;
export const CreateSystemChannelMessageDocument = gql`
    mutation createSystemChannelMessage($data: SystemMessageCreateInput!) {
  createSystemChannelMessage: createSystemChannelMessage2(data: $data) {
    id
    createdAt
    updatedAt
    index
    body
    messageType
    attachments {
      id
      attachmentType
      entityType
      entityId
      filename
      url
    }
    author {
      id
      twilioIdentity
      user {
        id
        firstName
        lastName
        profilePic
      }
      clinicPetParent {
        id
        firstName
        lastName
      }
    }
    channel {
      id
    }
  }
}
    `;
export type CreateSystemChannelMessageMutationFn = Apollo.MutationFunction<CreateSystemChannelMessageMutation, CreateSystemChannelMessageMutationVariables>;

/**
 * __useCreateSystemChannelMessageMutation__
 *
 * To run a mutation, you first call `useCreateSystemChannelMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSystemChannelMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSystemChannelMessageMutation, { data, loading, error }] = useCreateSystemChannelMessageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSystemChannelMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateSystemChannelMessageMutation, CreateSystemChannelMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSystemChannelMessageMutation, CreateSystemChannelMessageMutationVariables>(CreateSystemChannelMessageDocument, options);
      }
export type CreateSystemChannelMessageMutationHookResult = ReturnType<typeof useCreateSystemChannelMessageMutation>;
export type CreateSystemChannelMessageMutationResult = Apollo.MutationResult<CreateSystemChannelMessageMutation>;
export type CreateSystemChannelMessageMutationOptions = Apollo.BaseMutationOptions<CreateSystemChannelMessageMutation, CreateSystemChannelMessageMutationVariables>;
export const GenerateIntercomJwtDocument = gql`
    mutation generateIntercomJwt {
  generateIntercomJwt
}
    `;
export type GenerateIntercomJwtMutationFn = Apollo.MutationFunction<GenerateIntercomJwtMutation, GenerateIntercomJwtMutationVariables>;

/**
 * __useGenerateIntercomJwtMutation__
 *
 * To run a mutation, you first call `useGenerateIntercomJwtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateIntercomJwtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateIntercomJwtMutation, { data, loading, error }] = useGenerateIntercomJwtMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateIntercomJwtMutation(baseOptions?: Apollo.MutationHookOptions<GenerateIntercomJwtMutation, GenerateIntercomJwtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateIntercomJwtMutation, GenerateIntercomJwtMutationVariables>(GenerateIntercomJwtDocument, options);
      }
export type GenerateIntercomJwtMutationHookResult = ReturnType<typeof useGenerateIntercomJwtMutation>;
export type GenerateIntercomJwtMutationResult = Apollo.MutationResult<GenerateIntercomJwtMutation>;
export type GenerateIntercomJwtMutationOptions = Apollo.BaseMutationOptions<GenerateIntercomJwtMutation, GenerateIntercomJwtMutationVariables>;
export const GetOrCreateActiveClientChannelDocument = gql`
    mutation getOrCreateActiveClientChannel($data: GetOrCreateActiveClientChannelInput!) {
  getOrCreateActiveClientChannel(data: $data) {
    id
    channelMembers {
      id
      userId
    }
  }
}
    `;
export type GetOrCreateActiveClientChannelMutationFn = Apollo.MutationFunction<GetOrCreateActiveClientChannelMutation, GetOrCreateActiveClientChannelMutationVariables>;

/**
 * __useGetOrCreateActiveClientChannelMutation__
 *
 * To run a mutation, you first call `useGetOrCreateActiveClientChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateActiveClientChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateActiveClientChannelMutation, { data, loading, error }] = useGetOrCreateActiveClientChannelMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetOrCreateActiveClientChannelMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateActiveClientChannelMutation, GetOrCreateActiveClientChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateActiveClientChannelMutation, GetOrCreateActiveClientChannelMutationVariables>(GetOrCreateActiveClientChannelDocument, options);
      }
export type GetOrCreateActiveClientChannelMutationHookResult = ReturnType<typeof useGetOrCreateActiveClientChannelMutation>;
export type GetOrCreateActiveClientChannelMutationResult = Apollo.MutationResult<GetOrCreateActiveClientChannelMutation>;
export type GetOrCreateActiveClientChannelMutationOptions = Apollo.BaseMutationOptions<GetOrCreateActiveClientChannelMutation, GetOrCreateActiveClientChannelMutationVariables>;
export const ProcessTerminalPaymentDocument = gql`
    mutation processTerminalPayment($stripeTerminalId: String!, $paymentIntent: PaymentIntentInput!, $isSurchargeClinic: Boolean) {
  processTerminalPayment(
    stripeTerminalId: $stripeTerminalId
    paymentIntent: $paymentIntent
    isSurchargeClinic: $isSurchargeClinic
  ) {
    success
    stripePaymentIntentId
    error
  }
}
    `;
export type ProcessTerminalPaymentMutationFn = Apollo.MutationFunction<ProcessTerminalPaymentMutation, ProcessTerminalPaymentMutationVariables>;

/**
 * __useProcessTerminalPaymentMutation__
 *
 * To run a mutation, you first call `useProcessTerminalPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessTerminalPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processTerminalPaymentMutation, { data, loading, error }] = useProcessTerminalPaymentMutation({
 *   variables: {
 *      stripeTerminalId: // value for 'stripeTerminalId'
 *      paymentIntent: // value for 'paymentIntent'
 *      isSurchargeClinic: // value for 'isSurchargeClinic'
 *   },
 * });
 */
export function useProcessTerminalPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ProcessTerminalPaymentMutation, ProcessTerminalPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessTerminalPaymentMutation, ProcessTerminalPaymentMutationVariables>(ProcessTerminalPaymentDocument, options);
      }
export type ProcessTerminalPaymentMutationHookResult = ReturnType<typeof useProcessTerminalPaymentMutation>;
export type ProcessTerminalPaymentMutationResult = Apollo.MutationResult<ProcessTerminalPaymentMutation>;
export type ProcessTerminalPaymentMutationOptions = Apollo.BaseMutationOptions<ProcessTerminalPaymentMutation, ProcessTerminalPaymentMutationVariables>;
export const RefundStripePaymentIntentDocument = gql`
    mutation refundStripePaymentIntent($where: StripePaymentIntentWhereUniqueInput!, $data: EnhancedStripeRefundPaymentInput!) {
  refundStripePaymentIntent2(data: $data, where: $where) {
    id
  }
}
    `;
export type RefundStripePaymentIntentMutationFn = Apollo.MutationFunction<RefundStripePaymentIntentMutation, RefundStripePaymentIntentMutationVariables>;

/**
 * __useRefundStripePaymentIntentMutation__
 *
 * To run a mutation, you first call `useRefundStripePaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundStripePaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundStripePaymentIntentMutation, { data, loading, error }] = useRefundStripePaymentIntentMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRefundStripePaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<RefundStripePaymentIntentMutation, RefundStripePaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundStripePaymentIntentMutation, RefundStripePaymentIntentMutationVariables>(RefundStripePaymentIntentDocument, options);
      }
export type RefundStripePaymentIntentMutationHookResult = ReturnType<typeof useRefundStripePaymentIntentMutation>;
export type RefundStripePaymentIntentMutationResult = Apollo.MutationResult<RefundStripePaymentIntentMutation>;
export type RefundStripePaymentIntentMutationOptions = Apollo.BaseMutationOptions<RefundStripePaymentIntentMutation, RefundStripePaymentIntentMutationVariables>;
export const RemoveChannelMemberDocument = gql`
    mutation removeChannelMember($channelMemberId: String!) {
  removeChannelMember: removeChannelMember2(channelMemberId: $channelMemberId) {
    id
    removedAt
    clinicPetParent {
      id
    }
    user {
      id
    }
  }
}
    `;
export type RemoveChannelMemberMutationFn = Apollo.MutationFunction<RemoveChannelMemberMutation, RemoveChannelMemberMutationVariables>;

/**
 * __useRemoveChannelMemberMutation__
 *
 * To run a mutation, you first call `useRemoveChannelMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChannelMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChannelMemberMutation, { data, loading, error }] = useRemoveChannelMemberMutation({
 *   variables: {
 *      channelMemberId: // value for 'channelMemberId'
 *   },
 * });
 */
export function useRemoveChannelMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChannelMemberMutation, RemoveChannelMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChannelMemberMutation, RemoveChannelMemberMutationVariables>(RemoveChannelMemberDocument, options);
      }
export type RemoveChannelMemberMutationHookResult = ReturnType<typeof useRemoveChannelMemberMutation>;
export type RemoveChannelMemberMutationResult = Apollo.MutationResult<RemoveChannelMemberMutation>;
export type RemoveChannelMemberMutationOptions = Apollo.BaseMutationOptions<RemoveChannelMemberMutation, RemoveChannelMemberMutationVariables>;
export const RemoveClinicFeatureFlagDocument = gql`
    mutation removeClinicFeatureFlag($clinicId: String!, $featureFlagKey: String!) {
  updateOneClinic(
    where: {id: $clinicId}
    data: {featureFlags: {disconnect: {key: $featureFlagKey}}}
  ) {
    id
    featureFlags {
      id
      key
    }
  }
}
    `;
export type RemoveClinicFeatureFlagMutationFn = Apollo.MutationFunction<RemoveClinicFeatureFlagMutation, RemoveClinicFeatureFlagMutationVariables>;

/**
 * __useRemoveClinicFeatureFlagMutation__
 *
 * To run a mutation, you first call `useRemoveClinicFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClinicFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClinicFeatureFlagMutation, { data, loading, error }] = useRemoveClinicFeatureFlagMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      featureFlagKey: // value for 'featureFlagKey'
 *   },
 * });
 */
export function useRemoveClinicFeatureFlagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveClinicFeatureFlagMutation, RemoveClinicFeatureFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveClinicFeatureFlagMutation, RemoveClinicFeatureFlagMutationVariables>(RemoveClinicFeatureFlagDocument, options);
      }
export type RemoveClinicFeatureFlagMutationHookResult = ReturnType<typeof useRemoveClinicFeatureFlagMutation>;
export type RemoveClinicFeatureFlagMutationResult = Apollo.MutationResult<RemoveClinicFeatureFlagMutation>;
export type RemoveClinicFeatureFlagMutationOptions = Apollo.BaseMutationOptions<RemoveClinicFeatureFlagMutation, RemoveClinicFeatureFlagMutationVariables>;
export const UpdateCurrentClinicDocument = gql`
    mutation updateCurrentClinic($vetInfoId: String!, $clinicId: String!) {
  updateOneVetInfo(
    where: {id: $vetInfoId}
    data: {currentClinic: {connect: {id: $clinicId}}}
  ) {
    ...ClinicUserVetInfo
  }
}
    ${ClinicUserVetInfoFragmentDoc}`;
export type UpdateCurrentClinicMutationFn = Apollo.MutationFunction<UpdateCurrentClinicMutation, UpdateCurrentClinicMutationVariables>;

/**
 * __useUpdateCurrentClinicMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentClinicMutation, { data, loading, error }] = useUpdateCurrentClinicMutation({
 *   variables: {
 *      vetInfoId: // value for 'vetInfoId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useUpdateCurrentClinicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentClinicMutation, UpdateCurrentClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentClinicMutation, UpdateCurrentClinicMutationVariables>(UpdateCurrentClinicDocument, options);
      }
export type UpdateCurrentClinicMutationHookResult = ReturnType<typeof useUpdateCurrentClinicMutation>;
export type UpdateCurrentClinicMutationResult = Apollo.MutationResult<UpdateCurrentClinicMutation>;
export type UpdateCurrentClinicMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentClinicMutation, UpdateCurrentClinicMutationVariables>;
export const UpdateLeftNavPanelToggleDocument = gql`
    mutation updateLeftNavPanelToggle($data: UserSettingUpdateInput!, $where: UserSettingWhereUniqueInput!) {
  updateOneUserSetting(data: $data, where: $where) {
    leftNavPanel
  }
}
    `;
export type UpdateLeftNavPanelToggleMutationFn = Apollo.MutationFunction<UpdateLeftNavPanelToggleMutation, UpdateLeftNavPanelToggleMutationVariables>;

/**
 * __useUpdateLeftNavPanelToggleMutation__
 *
 * To run a mutation, you first call `useUpdateLeftNavPanelToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeftNavPanelToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeftNavPanelToggleMutation, { data, loading, error }] = useUpdateLeftNavPanelToggleMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateLeftNavPanelToggleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeftNavPanelToggleMutation, UpdateLeftNavPanelToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeftNavPanelToggleMutation, UpdateLeftNavPanelToggleMutationVariables>(UpdateLeftNavPanelToggleDocument, options);
      }
export type UpdateLeftNavPanelToggleMutationHookResult = ReturnType<typeof useUpdateLeftNavPanelToggleMutation>;
export type UpdateLeftNavPanelToggleMutationResult = Apollo.MutationResult<UpdateLeftNavPanelToggleMutation>;
export type UpdateLeftNavPanelToggleMutationOptions = Apollo.BaseMutationOptions<UpdateLeftNavPanelToggleMutation, UpdateLeftNavPanelToggleMutationVariables>;
export const UpdateOneClinicPetParentDocument = gql`
    mutation updateOneClinicPetParent($where: ClinicPetParentWhereUniqueInput!, $data: ClinicPetParentUpdateInput!) {
  updateOneClinicPetParent(where: $where, data: $data) {
    ...ClinicPetParentSelection
  }
}
    ${ClinicPetParentSelectionFragmentDoc}`;
export type UpdateOneClinicPetParentMutationFn = Apollo.MutationFunction<UpdateOneClinicPetParentMutation, UpdateOneClinicPetParentMutationVariables>;

/**
 * __useUpdateOneClinicPetParentMutation__
 *
 * To run a mutation, you first call `useUpdateOneClinicPetParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneClinicPetParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneClinicPetParentMutation, { data, loading, error }] = useUpdateOneClinicPetParentMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneClinicPetParentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneClinicPetParentMutation, UpdateOneClinicPetParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneClinicPetParentMutation, UpdateOneClinicPetParentMutationVariables>(UpdateOneClinicPetParentDocument, options);
      }
export type UpdateOneClinicPetParentMutationHookResult = ReturnType<typeof useUpdateOneClinicPetParentMutation>;
export type UpdateOneClinicPetParentMutationResult = Apollo.MutationResult<UpdateOneClinicPetParentMutation>;
export type UpdateOneClinicPetParentMutationOptions = Apollo.BaseMutationOptions<UpdateOneClinicPetParentMutation, UpdateOneClinicPetParentMutationVariables>;
export const UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupDocument = gql`
    mutation updateOneClinicPetParentAndEnqueuePhoneNumberLookup($where: ClinicPetParentWhereUniqueInput!, $data: ClinicPetParentUpdateInput!) {
  updateOneClinicPetParentAndEnqueuePhoneNumberLookup(where: $where, data: $data) {
    ...ClinicPetParentSelectionWithEnqueuePhoneNumberLookupMutation
  }
}
    ${ClinicPetParentSelectionWithEnqueuePhoneNumberLookupMutationFragmentDoc}`;
export type UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutationFn = Apollo.MutationFunction<UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation, UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutationVariables>;

/**
 * __useUpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation__
 *
 * To run a mutation, you first call `useUpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation, { data, loading, error }] = useUpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation, UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation, UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutationVariables>(UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupDocument, options);
      }
export type UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutationHookResult = ReturnType<typeof useUpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation>;
export type UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutationResult = Apollo.MutationResult<UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation>;
export type UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutationOptions = Apollo.BaseMutationOptions<UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutation, UpdateOneClinicPetParentAndEnqueuePhoneNumberLookupMutationVariables>;
export const CreateStripeAccountSessionDocument = gql`
    query createStripeAccountSession($data: StripeCreateAccountSessionInput!) {
  stripeCreateAccountSession(data: $data) {
    account
    clientSecret
    expiresAt
  }
}
    `;

/**
 * __useCreateStripeAccountSessionQuery__
 *
 * To run a query within a React component, call `useCreateStripeAccountSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeAccountSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateStripeAccountSessionQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStripeAccountSessionQuery(baseOptions: Apollo.QueryHookOptions<CreateStripeAccountSessionQuery, CreateStripeAccountSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateStripeAccountSessionQuery, CreateStripeAccountSessionQueryVariables>(CreateStripeAccountSessionDocument, options);
      }
export function useCreateStripeAccountSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateStripeAccountSessionQuery, CreateStripeAccountSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateStripeAccountSessionQuery, CreateStripeAccountSessionQueryVariables>(CreateStripeAccountSessionDocument, options);
        }
export type CreateStripeAccountSessionQueryHookResult = ReturnType<typeof useCreateStripeAccountSessionQuery>;
export type CreateStripeAccountSessionLazyQueryHookResult = ReturnType<typeof useCreateStripeAccountSessionLazyQuery>;
export type CreateStripeAccountSessionQueryResult = Apollo.QueryResult<CreateStripeAccountSessionQuery, CreateStripeAccountSessionQueryVariables>;
export function refetchCreateStripeAccountSessionQuery(variables?: CreateStripeAccountSessionQueryVariables) {
      return { query: CreateStripeAccountSessionDocument, variables: variables }
    }
export const FindManyChannelDocument = gql`
    query FindManyChannel($where: ChannelWhereInput, $orderBy: [ChannelOrderByWithRelationInput]) {
  findManyChannel(where: $where, orderBy: $orderBy) {
    id
  }
}
    `;

/**
 * __useFindManyChannelQuery__
 *
 * To run a query within a React component, call `useFindManyChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyChannelQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyChannelQuery(baseOptions?: Apollo.QueryHookOptions<FindManyChannelQuery, FindManyChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyChannelQuery, FindManyChannelQueryVariables>(FindManyChannelDocument, options);
      }
export function useFindManyChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyChannelQuery, FindManyChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyChannelQuery, FindManyChannelQueryVariables>(FindManyChannelDocument, options);
        }
export type FindManyChannelQueryHookResult = ReturnType<typeof useFindManyChannelQuery>;
export type FindManyChannelLazyQueryHookResult = ReturnType<typeof useFindManyChannelLazyQuery>;
export type FindManyChannelQueryResult = Apollo.QueryResult<FindManyChannelQuery, FindManyChannelQueryVariables>;
export function refetchFindManyChannelQuery(variables?: FindManyChannelQueryVariables) {
      return { query: FindManyChannelDocument, variables: variables }
    }
export const FindManyDisputesCountDocument = gql`
    query findManyDisputesCount($where: StripeDisputeWhereInput) {
  findManyStripeDisputeCount(where: $where)
}
    `;

/**
 * __useFindManyDisputesCountQuery__
 *
 * To run a query within a React component, call `useFindManyDisputesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDisputesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDisputesCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyDisputesCountQuery(baseOptions?: Apollo.QueryHookOptions<FindManyDisputesCountQuery, FindManyDisputesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyDisputesCountQuery, FindManyDisputesCountQueryVariables>(FindManyDisputesCountDocument, options);
      }
export function useFindManyDisputesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyDisputesCountQuery, FindManyDisputesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyDisputesCountQuery, FindManyDisputesCountQueryVariables>(FindManyDisputesCountDocument, options);
        }
export type FindManyDisputesCountQueryHookResult = ReturnType<typeof useFindManyDisputesCountQuery>;
export type FindManyDisputesCountLazyQueryHookResult = ReturnType<typeof useFindManyDisputesCountLazyQuery>;
export type FindManyDisputesCountQueryResult = Apollo.QueryResult<FindManyDisputesCountQuery, FindManyDisputesCountQueryVariables>;
export function refetchFindManyDisputesCountQuery(variables?: FindManyDisputesCountQueryVariables) {
      return { query: FindManyDisputesCountDocument, variables: variables }
    }
export const GetAllClinicChannelStatusesDocument = gql`
    query getAllClinicChannelStatuses($clinicId: String!) {
  findManyChannelStatus(
    where: {clinicSetting: {clinic: {id: {equals: $clinicId}}}}
    orderBy: {order: asc}
  ) {
    ...FullChannelStatus
  }
}
    ${FullChannelStatusFragmentDoc}`;

/**
 * __useGetAllClinicChannelStatusesQuery__
 *
 * To run a query within a React component, call `useGetAllClinicChannelStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClinicChannelStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClinicChannelStatusesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAllClinicChannelStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetAllClinicChannelStatusesQuery, GetAllClinicChannelStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllClinicChannelStatusesQuery, GetAllClinicChannelStatusesQueryVariables>(GetAllClinicChannelStatusesDocument, options);
      }
export function useGetAllClinicChannelStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClinicChannelStatusesQuery, GetAllClinicChannelStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllClinicChannelStatusesQuery, GetAllClinicChannelStatusesQueryVariables>(GetAllClinicChannelStatusesDocument, options);
        }
export type GetAllClinicChannelStatusesQueryHookResult = ReturnType<typeof useGetAllClinicChannelStatusesQuery>;
export type GetAllClinicChannelStatusesLazyQueryHookResult = ReturnType<typeof useGetAllClinicChannelStatusesLazyQuery>;
export type GetAllClinicChannelStatusesQueryResult = Apollo.QueryResult<GetAllClinicChannelStatusesQuery, GetAllClinicChannelStatusesQueryVariables>;
export function refetchGetAllClinicChannelStatusesQuery(variables?: GetAllClinicChannelStatusesQueryVariables) {
      return { query: GetAllClinicChannelStatusesDocument, variables: variables }
    }
export const GetCareCreditMessageTemplateDocument = gql`
    query getCareCreditMessageTemplate($clinicId: String!) {
  findFirstMessageTemplate(
    where: {clinicId: {equals: $clinicId}, isArchived: {equals: false}, type: {equals: CareCreditPreapproval}}
  ) {
    ...FullMessageTemplate
  }
}
    ${FullMessageTemplateFragmentDoc}`;

/**
 * __useGetCareCreditMessageTemplateQuery__
 *
 * To run a query within a React component, call `useGetCareCreditMessageTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareCreditMessageTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareCreditMessageTemplateQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetCareCreditMessageTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetCareCreditMessageTemplateQuery, GetCareCreditMessageTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareCreditMessageTemplateQuery, GetCareCreditMessageTemplateQueryVariables>(GetCareCreditMessageTemplateDocument, options);
      }
export function useGetCareCreditMessageTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareCreditMessageTemplateQuery, GetCareCreditMessageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareCreditMessageTemplateQuery, GetCareCreditMessageTemplateQueryVariables>(GetCareCreditMessageTemplateDocument, options);
        }
export type GetCareCreditMessageTemplateQueryHookResult = ReturnType<typeof useGetCareCreditMessageTemplateQuery>;
export type GetCareCreditMessageTemplateLazyQueryHookResult = ReturnType<typeof useGetCareCreditMessageTemplateLazyQuery>;
export type GetCareCreditMessageTemplateQueryResult = Apollo.QueryResult<GetCareCreditMessageTemplateQuery, GetCareCreditMessageTemplateQueryVariables>;
export function refetchGetCareCreditMessageTemplateQuery(variables?: GetCareCreditMessageTemplateQueryVariables) {
      return { query: GetCareCreditMessageTemplateDocument, variables: variables }
    }
export const GetCareCreditPreapprovalChecksDocument = gql`
    query getCareCreditPreapprovalChecks($clinicPetParentIds: [String!]!) {
  findManyCareCreditPreapprovalCheck(
    where: {clinicPetParentId: {in: $clinicPetParentIds}, decision: {equals: Approved}}
    orderBy: {createdAt: desc}
  ) {
    id
    createdAt
    decision
    preapprovalUrl
    offerExpiresAt
    applicationStatus
  }
}
    `;

/**
 * __useGetCareCreditPreapprovalChecksQuery__
 *
 * To run a query within a React component, call `useGetCareCreditPreapprovalChecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareCreditPreapprovalChecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareCreditPreapprovalChecksQuery({
 *   variables: {
 *      clinicPetParentIds: // value for 'clinicPetParentIds'
 *   },
 * });
 */
export function useGetCareCreditPreapprovalChecksQuery(baseOptions: Apollo.QueryHookOptions<GetCareCreditPreapprovalChecksQuery, GetCareCreditPreapprovalChecksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareCreditPreapprovalChecksQuery, GetCareCreditPreapprovalChecksQueryVariables>(GetCareCreditPreapprovalChecksDocument, options);
      }
export function useGetCareCreditPreapprovalChecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareCreditPreapprovalChecksQuery, GetCareCreditPreapprovalChecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareCreditPreapprovalChecksQuery, GetCareCreditPreapprovalChecksQueryVariables>(GetCareCreditPreapprovalChecksDocument, options);
        }
export type GetCareCreditPreapprovalChecksQueryHookResult = ReturnType<typeof useGetCareCreditPreapprovalChecksQuery>;
export type GetCareCreditPreapprovalChecksLazyQueryHookResult = ReturnType<typeof useGetCareCreditPreapprovalChecksLazyQuery>;
export type GetCareCreditPreapprovalChecksQueryResult = Apollo.QueryResult<GetCareCreditPreapprovalChecksQuery, GetCareCreditPreapprovalChecksQueryVariables>;
export function refetchGetCareCreditPreapprovalChecksQuery(variables?: GetCareCreditPreapprovalChecksQueryVariables) {
      return { query: GetCareCreditPreapprovalChecksDocument, variables: variables }
    }
export const GetClinicAutomationsDocument = gql`
    query getClinicAutomations($clinicId: String!) {
  findManyWorkflowEventSetting(where: {clinicId: {equals: $clinicId}}) {
    ...WorkflowEventSettingSelection
  }
}
    ${WorkflowEventSettingSelectionFragmentDoc}`;

/**
 * __useGetClinicAutomationsQuery__
 *
 * To run a query within a React component, call `useGetClinicAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAutomationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAutomationsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicAutomationsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAutomationsQuery, GetClinicAutomationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAutomationsQuery, GetClinicAutomationsQueryVariables>(GetClinicAutomationsDocument, options);
      }
export function useGetClinicAutomationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAutomationsQuery, GetClinicAutomationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAutomationsQuery, GetClinicAutomationsQueryVariables>(GetClinicAutomationsDocument, options);
        }
export type GetClinicAutomationsQueryHookResult = ReturnType<typeof useGetClinicAutomationsQuery>;
export type GetClinicAutomationsLazyQueryHookResult = ReturnType<typeof useGetClinicAutomationsLazyQuery>;
export type GetClinicAutomationsQueryResult = Apollo.QueryResult<GetClinicAutomationsQuery, GetClinicAutomationsQueryVariables>;
export function refetchGetClinicAutomationsQuery(variables?: GetClinicAutomationsQueryVariables) {
      return { query: GetClinicAutomationsDocument, variables: variables }
    }
export const GetClinicFormTemplatesDocument = gql`
    query getClinicFormTemplates($where: FormTemplateWhereInput!) {
  findManyFormTemplate(where: $where) {
    ...ClinicFormTemplate
  }
}
    ${ClinicFormTemplateFragmentDoc}`;

/**
 * __useGetClinicFormTemplatesQuery__
 *
 * To run a query within a React component, call `useGetClinicFormTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicFormTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicFormTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClinicFormTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetClinicFormTemplatesQuery, GetClinicFormTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicFormTemplatesQuery, GetClinicFormTemplatesQueryVariables>(GetClinicFormTemplatesDocument, options);
      }
export function useGetClinicFormTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicFormTemplatesQuery, GetClinicFormTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicFormTemplatesQuery, GetClinicFormTemplatesQueryVariables>(GetClinicFormTemplatesDocument, options);
        }
export type GetClinicFormTemplatesQueryHookResult = ReturnType<typeof useGetClinicFormTemplatesQuery>;
export type GetClinicFormTemplatesLazyQueryHookResult = ReturnType<typeof useGetClinicFormTemplatesLazyQuery>;
export type GetClinicFormTemplatesQueryResult = Apollo.QueryResult<GetClinicFormTemplatesQuery, GetClinicFormTemplatesQueryVariables>;
export function refetchGetClinicFormTemplatesQuery(variables?: GetClinicFormTemplatesQueryVariables) {
      return { query: GetClinicFormTemplatesDocument, variables: variables }
    }
export const GetClinicUserDocument = gql`
    query getClinicUser {
  clinicUser: getCurrentUser {
    ...ClinicUser
  }
}
    ${ClinicUserFragmentDoc}`;

/**
 * __useGetClinicUserQuery__
 *
 * To run a query within a React component, call `useGetClinicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClinicUserQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicUserQuery, GetClinicUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicUserQuery, GetClinicUserQueryVariables>(GetClinicUserDocument, options);
      }
export function useGetClinicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicUserQuery, GetClinicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicUserQuery, GetClinicUserQueryVariables>(GetClinicUserDocument, options);
        }
export type GetClinicUserQueryHookResult = ReturnType<typeof useGetClinicUserQuery>;
export type GetClinicUserLazyQueryHookResult = ReturnType<typeof useGetClinicUserLazyQuery>;
export type GetClinicUserQueryResult = Apollo.QueryResult<GetClinicUserQuery, GetClinicUserQueryVariables>;
export function refetchGetClinicUserQuery(variables?: GetClinicUserQueryVariables) {
      return { query: GetClinicUserDocument, variables: variables }
    }
export const GetClinicUsersDocument = gql`
    query getClinicUsers($clinicId: String!) {
  users: findManyUser(
    where: {vetInfo: {clinics: {some: {id: {equals: $clinicId}}}}, isActive: {equals: true}}
  ) {
    firebaseId
    email
    ...ClinicUserAvatar
  }
}
    ${ClinicUserAvatarFragmentDoc}`;

/**
 * __useGetClinicUsersQuery__
 *
 * To run a query within a React component, call `useGetClinicUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicUsersQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicUsersQuery(baseOptions: Apollo.QueryHookOptions<GetClinicUsersQuery, GetClinicUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicUsersQuery, GetClinicUsersQueryVariables>(GetClinicUsersDocument, options);
      }
export function useGetClinicUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicUsersQuery, GetClinicUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicUsersQuery, GetClinicUsersQueryVariables>(GetClinicUsersDocument, options);
        }
export type GetClinicUsersQueryHookResult = ReturnType<typeof useGetClinicUsersQuery>;
export type GetClinicUsersLazyQueryHookResult = ReturnType<typeof useGetClinicUsersLazyQuery>;
export type GetClinicUsersQueryResult = Apollo.QueryResult<GetClinicUsersQuery, GetClinicUsersQueryVariables>;
export function refetchGetClinicUsersQuery(variables?: GetClinicUsersQueryVariables) {
      return { query: GetClinicUsersDocument, variables: variables }
    }
export const GetPaginatedAppointmentsDocument = gql`
    query getPaginatedAppointments($where: AppointmentWhereInput!, $take: Int!, $skip: Int!, $orderBy: [AppointmentOrderByWithRelationInput], $countOnly: Boolean!) {
  count: findManyAppointmentCount(where: $where)
  appointments: findManyAppointment(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) @skip(if: $countOnly) {
    id
    pimsId
    startAt
    description
    durationInMinutes
    title
    status
    pimsStatus
    channelId
    integration {
      type
    }
    appointmentType {
      id
      name
      displayName
    }
    channelId
    channel {
      id
      lastMessage {
        id
        createdAt
      }
      updatedAt
      channelStatus {
        ...ChannelListChannelStatus
      }
    }
    clinicPet {
      id
      computed_rawPimsIsDeceased
      computed_rawPimsIsActive
      computedIsDeceased @client
      computedIsActive @client
      isDeceased
      isActive
      name
      breed
      species
      speciesType
      photoUrl
    }
    clinicPetParents {
      id
      firstName
      lastName
      phoneNumbers {
        id
        number
        updatedAt
        isPrimary
        isDeleted
      }
    }
  }
}
    ${ChannelListChannelStatusFragmentDoc}`;

/**
 * __useGetPaginatedAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedAppointmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      countOnly: // value for 'countOnly'
 *   },
 * });
 */
export function useGetPaginatedAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedAppointmentsQuery, GetPaginatedAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedAppointmentsQuery, GetPaginatedAppointmentsQueryVariables>(GetPaginatedAppointmentsDocument, options);
      }
export function useGetPaginatedAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedAppointmentsQuery, GetPaginatedAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedAppointmentsQuery, GetPaginatedAppointmentsQueryVariables>(GetPaginatedAppointmentsDocument, options);
        }
export type GetPaginatedAppointmentsQueryHookResult = ReturnType<typeof useGetPaginatedAppointmentsQuery>;
export type GetPaginatedAppointmentsLazyQueryHookResult = ReturnType<typeof useGetPaginatedAppointmentsLazyQuery>;
export type GetPaginatedAppointmentsQueryResult = Apollo.QueryResult<GetPaginatedAppointmentsQuery, GetPaginatedAppointmentsQueryVariables>;
export function refetchGetPaginatedAppointmentsQuery(variables?: GetPaginatedAppointmentsQueryVariables) {
      return { query: GetPaginatedAppointmentsDocument, variables: variables }
    }
export const GetPetParentChannelsDocument = gql`
    query getPetParentChannels($clinicPetParentId: String!, $take: Int, $skip: Int) {
  findManyChannel(
    where: {isActive: {equals: true}, channelMembers: {some: {clinicPetParentId: {equals: $clinicPetParentId}, removedAt: {equals: null}}}}
    orderBy: {updatedAt: desc}
    take: $take
    skip: $skip
  ) {
    ...PetParentChannel
  }
  findManyChannelCount(
    where: {isActive: {equals: true}, channelMembers: {some: {clinicPetParentId: {equals: $clinicPetParentId}, removedAt: {equals: null}}}}
  )
}
    ${PetParentChannelFragmentDoc}`;

/**
 * __useGetPetParentChannelsQuery__
 *
 * To run a query within a React component, call `useGetPetParentChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPetParentChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPetParentChannelsQuery({
 *   variables: {
 *      clinicPetParentId: // value for 'clinicPetParentId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetPetParentChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetPetParentChannelsQuery, GetPetParentChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPetParentChannelsQuery, GetPetParentChannelsQueryVariables>(GetPetParentChannelsDocument, options);
      }
export function useGetPetParentChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPetParentChannelsQuery, GetPetParentChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPetParentChannelsQuery, GetPetParentChannelsQueryVariables>(GetPetParentChannelsDocument, options);
        }
export type GetPetParentChannelsQueryHookResult = ReturnType<typeof useGetPetParentChannelsQuery>;
export type GetPetParentChannelsLazyQueryHookResult = ReturnType<typeof useGetPetParentChannelsLazyQuery>;
export type GetPetParentChannelsQueryResult = Apollo.QueryResult<GetPetParentChannelsQuery, GetPetParentChannelsQueryVariables>;
export function refetchGetPetParentChannelsQuery(variables?: GetPetParentChannelsQueryVariables) {
      return { query: GetPetParentChannelsDocument, variables: variables }
    }
export const GetStripePaymentIntentDocument = gql`
    query getStripePaymentIntent($where: StripePaymentIntentWhereUniqueInput!) {
  stripePaymentIntent: findUniqueStripePaymentIntent(where: $where) {
    ...StripePaymentIntent
  }
  stripePaymentOutput: getStripePaymentIntentData(where: $where) {
    ...StripePaymentOutput
  }
}
    ${StripePaymentIntentFragmentDoc}
${StripePaymentOutputFragmentDoc}`;

/**
 * __useGetStripePaymentIntentQuery__
 *
 * To run a query within a React component, call `useGetStripePaymentIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripePaymentIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripePaymentIntentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetStripePaymentIntentQuery(baseOptions: Apollo.QueryHookOptions<GetStripePaymentIntentQuery, GetStripePaymentIntentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripePaymentIntentQuery, GetStripePaymentIntentQueryVariables>(GetStripePaymentIntentDocument, options);
      }
export function useGetStripePaymentIntentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripePaymentIntentQuery, GetStripePaymentIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripePaymentIntentQuery, GetStripePaymentIntentQueryVariables>(GetStripePaymentIntentDocument, options);
        }
export type GetStripePaymentIntentQueryHookResult = ReturnType<typeof useGetStripePaymentIntentQuery>;
export type GetStripePaymentIntentLazyQueryHookResult = ReturnType<typeof useGetStripePaymentIntentLazyQuery>;
export type GetStripePaymentIntentQueryResult = Apollo.QueryResult<GetStripePaymentIntentQuery, GetStripePaymentIntentQueryVariables>;
export function refetchGetStripePaymentIntentQuery(variables?: GetStripePaymentIntentQueryVariables) {
      return { query: GetStripePaymentIntentDocument, variables: variables }
    }
export const SubscribeToStripePaymentIntentChangedDocument = gql`
    subscription subscribeToStripePaymentIntentChanged($where: SubscriptionStripePaymentIntentWhereInput!) {
  stripePaymentIntentChanged(where: $where) {
    node {
      ...StripePaymentIntent
    }
  }
}
    ${StripePaymentIntentFragmentDoc}`;

/**
 * __useSubscribeToStripePaymentIntentChangedSubscription__
 *
 * To run a query within a React component, call `useSubscribeToStripePaymentIntentChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToStripePaymentIntentChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToStripePaymentIntentChangedSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToStripePaymentIntentChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToStripePaymentIntentChangedSubscription, SubscribeToStripePaymentIntentChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToStripePaymentIntentChangedSubscription, SubscribeToStripePaymentIntentChangedSubscriptionVariables>(SubscribeToStripePaymentIntentChangedDocument, options);
      }
export type SubscribeToStripePaymentIntentChangedSubscriptionHookResult = ReturnType<typeof useSubscribeToStripePaymentIntentChangedSubscription>;
export type SubscribeToStripePaymentIntentChangedSubscriptionResult = Apollo.SubscriptionResult<SubscribeToStripePaymentIntentChangedSubscription>;
export const SubscribeToClinicUserChannelMessagesDocument = gql`
    subscription subscribeToClinicUserChannelMessages($clinicId: String!) {
  channelMessageChanged(
    where: {mutation: [create, delete], node: {channel: {clinicId: {equals: $clinicId}}}}
  ) {
    node {
      ...SubscriptionChannelMessage
    }
    mutation
  }
}
    ${SubscriptionChannelMessageFragmentDoc}`;

/**
 * __useSubscribeToClinicUserChannelMessagesSubscription__
 *
 * To run a query within a React component, call `useSubscribeToClinicUserChannelMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToClinicUserChannelMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToClinicUserChannelMessagesSubscription({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useSubscribeToClinicUserChannelMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToClinicUserChannelMessagesSubscription, SubscribeToClinicUserChannelMessagesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToClinicUserChannelMessagesSubscription, SubscribeToClinicUserChannelMessagesSubscriptionVariables>(SubscribeToClinicUserChannelMessagesDocument, options);
      }
export type SubscribeToClinicUserChannelMessagesSubscriptionHookResult = ReturnType<typeof useSubscribeToClinicUserChannelMessagesSubscription>;
export type SubscribeToClinicUserChannelMessagesSubscriptionResult = Apollo.SubscriptionResult<SubscribeToClinicUserChannelMessagesSubscription>;
export const SubscribeToClinicUserChannelsDocument = gql`
    subscription subscribeToClinicUserChannels($clinicId: String!) {
  channelChanged(where: {node: {clinicId: {equals: $clinicId}}}) {
    node {
      id
      friendlyName
      assignees {
        id
      }
      channelStatus {
        id
        color
        name
        channelStatusAction
      }
    }
  }
}
    `;

/**
 * __useSubscribeToClinicUserChannelsSubscription__
 *
 * To run a query within a React component, call `useSubscribeToClinicUserChannelsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToClinicUserChannelsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToClinicUserChannelsSubscription({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useSubscribeToClinicUserChannelsSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToClinicUserChannelsSubscription, SubscribeToClinicUserChannelsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToClinicUserChannelsSubscription, SubscribeToClinicUserChannelsSubscriptionVariables>(SubscribeToClinicUserChannelsDocument, options);
      }
export type SubscribeToClinicUserChannelsSubscriptionHookResult = ReturnType<typeof useSubscribeToClinicUserChannelsSubscription>;
export type SubscribeToClinicUserChannelsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToClinicUserChannelsSubscription>;
export const SubscribeToFormSubmissionDocument = gql`
    subscription subscribeToFormSubmission($id: String!) {
  formSubmissionChanged(where: {node: {id: {equals: $id}}}) {
    node {
      id
      submittedAt
    }
  }
}
    `;

/**
 * __useSubscribeToFormSubmissionSubscription__
 *
 * To run a query within a React component, call `useSubscribeToFormSubmissionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToFormSubmissionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToFormSubmissionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscribeToFormSubmissionSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToFormSubmissionSubscription, SubscribeToFormSubmissionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToFormSubmissionSubscription, SubscribeToFormSubmissionSubscriptionVariables>(SubscribeToFormSubmissionDocument, options);
      }
export type SubscribeToFormSubmissionSubscriptionHookResult = ReturnType<typeof useSubscribeToFormSubmissionSubscription>;
export type SubscribeToFormSubmissionSubscriptionResult = Apollo.SubscriptionResult<SubscribeToFormSubmissionSubscription>;
export const SubscribeToUiRefreshDocument = gql`
    subscription subscribeToUiRefresh {
  uiRefresh {
    refreshType
    message
    metadata
  }
}
    `;

/**
 * __useSubscribeToUiRefreshSubscription__
 *
 * To run a query within a React component, call `useSubscribeToUiRefreshSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToUiRefreshSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToUiRefreshSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubscribeToUiRefreshSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeToUiRefreshSubscription, SubscribeToUiRefreshSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToUiRefreshSubscription, SubscribeToUiRefreshSubscriptionVariables>(SubscribeToUiRefreshDocument, options);
      }
export type SubscribeToUiRefreshSubscriptionHookResult = ReturnType<typeof useSubscribeToUiRefreshSubscription>;
export type SubscribeToUiRefreshSubscriptionResult = Apollo.SubscriptionResult<SubscribeToUiRefreshSubscription>;
export const SubscribeToUnreadMessageCountChangedDocument = gql`
    subscription subscribeToUnreadMessageCountChanged($clinicId: String!) {
  unreadMessageCountChanged(where: {node: {clinicId: {equals: $clinicId}}}) {
    node {
      id
      assignees {
        id
      }
      channelStatus {
        id
        channelStatusAction
      }
    }
  }
}
    `;

/**
 * __useSubscribeToUnreadMessageCountChangedSubscription__
 *
 * To run a query within a React component, call `useSubscribeToUnreadMessageCountChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToUnreadMessageCountChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToUnreadMessageCountChangedSubscription({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useSubscribeToUnreadMessageCountChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToUnreadMessageCountChangedSubscription, SubscribeToUnreadMessageCountChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToUnreadMessageCountChangedSubscription, SubscribeToUnreadMessageCountChangedSubscriptionVariables>(SubscribeToUnreadMessageCountChangedDocument, options);
      }
export type SubscribeToUnreadMessageCountChangedSubscriptionHookResult = ReturnType<typeof useSubscribeToUnreadMessageCountChangedSubscription>;
export type SubscribeToUnreadMessageCountChangedSubscriptionResult = Apollo.SubscriptionResult<SubscribeToUnreadMessageCountChangedSubscription>;
export const SharedUpdateUserSettingDocument = gql`
    mutation sharedUpdateUserSetting($data: UserSettingUpdateInput!, $where: UserSettingWhereUniqueInput!) {
  updateOneUserSetting(data: $data, where: $where) {
    id
    browserNotificationFilter {
      id
      assignees {
        id
      }
      includeUnassigned
    }
    snoozeNotificationsUntil
    notificationSettings {
      id
      emailEnabled
      smsEnabled
      soundNotificationUrl
      browserNotificationEnabled
      pushNotificationEnabled
    }
  }
}
    `;
export type SharedUpdateUserSettingMutationFn = Apollo.MutationFunction<SharedUpdateUserSettingMutation, SharedUpdateUserSettingMutationVariables>;

/**
 * __useSharedUpdateUserSettingMutation__
 *
 * To run a mutation, you first call `useSharedUpdateUserSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharedUpdateUserSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharedUpdateUserSettingMutation, { data, loading, error }] = useSharedUpdateUserSettingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSharedUpdateUserSettingMutation(baseOptions?: Apollo.MutationHookOptions<SharedUpdateUserSettingMutation, SharedUpdateUserSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SharedUpdateUserSettingMutation, SharedUpdateUserSettingMutationVariables>(SharedUpdateUserSettingDocument, options);
      }
export type SharedUpdateUserSettingMutationHookResult = ReturnType<typeof useSharedUpdateUserSettingMutation>;
export type SharedUpdateUserSettingMutationResult = Apollo.MutationResult<SharedUpdateUserSettingMutation>;
export type SharedUpdateUserSettingMutationOptions = Apollo.BaseMutationOptions<SharedUpdateUserSettingMutation, SharedUpdateUserSettingMutationVariables>;
export const GetMostRecentSyncDataDocument = gql`
    query getMostRecentSyncData($where: IntegrationOutageHistoryEntryWhereInput) {
  findFirstIntegrationOutageHistoryEntry(
    where: $where
    orderBy: {createdAt: desc}
    take: 1
  ) {
    status
    id
    createdAt
  }
}
    `;

/**
 * __useGetMostRecentSyncDataQuery__
 *
 * To run a query within a React component, call `useGetMostRecentSyncDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMostRecentSyncDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMostRecentSyncDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMostRecentSyncDataQuery(baseOptions?: Apollo.QueryHookOptions<GetMostRecentSyncDataQuery, GetMostRecentSyncDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMostRecentSyncDataQuery, GetMostRecentSyncDataQueryVariables>(GetMostRecentSyncDataDocument, options);
      }
export function useGetMostRecentSyncDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMostRecentSyncDataQuery, GetMostRecentSyncDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMostRecentSyncDataQuery, GetMostRecentSyncDataQueryVariables>(GetMostRecentSyncDataDocument, options);
        }
export type GetMostRecentSyncDataQueryHookResult = ReturnType<typeof useGetMostRecentSyncDataQuery>;
export type GetMostRecentSyncDataLazyQueryHookResult = ReturnType<typeof useGetMostRecentSyncDataLazyQuery>;
export type GetMostRecentSyncDataQueryResult = Apollo.QueryResult<GetMostRecentSyncDataQuery, GetMostRecentSyncDataQueryVariables>;
export function refetchGetMostRecentSyncDataQuery(variables?: GetMostRecentSyncDataQueryVariables) {
      return { query: GetMostRecentSyncDataDocument, variables: variables }
    }
export const SubscribeToSyncOutagesDocument = gql`
    subscription subscribeToSyncOutages($where: IntegrationOutageHistoryEntryWhereInput!) {
  integrationOutageHistoryEntryChanged(where: $where) {
    node {
      id
      createdAt
      status
    }
  }
}
    `;

/**
 * __useSubscribeToSyncOutagesSubscription__
 *
 * To run a query within a React component, call `useSubscribeToSyncOutagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToSyncOutagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToSyncOutagesSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscribeToSyncOutagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToSyncOutagesSubscription, SubscribeToSyncOutagesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToSyncOutagesSubscription, SubscribeToSyncOutagesSubscriptionVariables>(SubscribeToSyncOutagesDocument, options);
      }
export type SubscribeToSyncOutagesSubscriptionHookResult = ReturnType<typeof useSubscribeToSyncOutagesSubscription>;
export type SubscribeToSyncOutagesSubscriptionResult = Apollo.SubscriptionResult<SubscribeToSyncOutagesSubscription>;
export const CreateCallHistoryAndParticipantsDocument = gql`
    mutation createCallHistoryAndParticipants($data: CreateCallHistoryInput!) {
  createCallHistory(data: $data) {
    id
    sourceId
    type
    from
    direction
    status
    provider
    clinic {
      name
    }
  }
}
    `;
export type CreateCallHistoryAndParticipantsMutationFn = Apollo.MutationFunction<CreateCallHistoryAndParticipantsMutation, CreateCallHistoryAndParticipantsMutationVariables>;

/**
 * __useCreateCallHistoryAndParticipantsMutation__
 *
 * To run a mutation, you first call `useCreateCallHistoryAndParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCallHistoryAndParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCallHistoryAndParticipantsMutation, { data, loading, error }] = useCreateCallHistoryAndParticipantsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCallHistoryAndParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCallHistoryAndParticipantsMutation, CreateCallHistoryAndParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCallHistoryAndParticipantsMutation, CreateCallHistoryAndParticipantsMutationVariables>(CreateCallHistoryAndParticipantsDocument, options);
      }
export type CreateCallHistoryAndParticipantsMutationHookResult = ReturnType<typeof useCreateCallHistoryAndParticipantsMutation>;
export type CreateCallHistoryAndParticipantsMutationResult = Apollo.MutationResult<CreateCallHistoryAndParticipantsMutation>;
export type CreateCallHistoryAndParticipantsMutationOptions = Apollo.BaseMutationOptions<CreateCallHistoryAndParticipantsMutation, CreateCallHistoryAndParticipantsMutationVariables>;
export const CreateOneCallParticipantDocument = gql`
    mutation createOneCallParticipant($data: CallParticipantCreateInput!) {
  createOneCallParticipant(data: $data) {
    id
    number
    user {
      id
    }
    clinicPetParent {
      id
    }
    callHistory {
      id
    }
  }
}
    `;
export type CreateOneCallParticipantMutationFn = Apollo.MutationFunction<CreateOneCallParticipantMutation, CreateOneCallParticipantMutationVariables>;

/**
 * __useCreateOneCallParticipantMutation__
 *
 * To run a mutation, you first call `useCreateOneCallParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCallParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCallParticipantMutation, { data, loading, error }] = useCreateOneCallParticipantMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneCallParticipantMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneCallParticipantMutation, CreateOneCallParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneCallParticipantMutation, CreateOneCallParticipantMutationVariables>(CreateOneCallParticipantDocument, options);
      }
export type CreateOneCallParticipantMutationHookResult = ReturnType<typeof useCreateOneCallParticipantMutation>;
export type CreateOneCallParticipantMutationResult = Apollo.MutationResult<CreateOneCallParticipantMutation>;
export type CreateOneCallParticipantMutationOptions = Apollo.BaseMutationOptions<CreateOneCallParticipantMutation, CreateOneCallParticipantMutationVariables>;
export const CreateOneCallRecordingDocument = gql`
    mutation createOneCallRecording($callSid: String!) {
  createOneCallRecording(callSid: $callSid) {
    id
  }
}
    `;
export type CreateOneCallRecordingMutationFn = Apollo.MutationFunction<CreateOneCallRecordingMutation, CreateOneCallRecordingMutationVariables>;

/**
 * __useCreateOneCallRecordingMutation__
 *
 * To run a mutation, you first call `useCreateOneCallRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCallRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCallRecordingMutation, { data, loading, error }] = useCreateOneCallRecordingMutation({
 *   variables: {
 *      callSid: // value for 'callSid'
 *   },
 * });
 */
export function useCreateOneCallRecordingMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneCallRecordingMutation, CreateOneCallRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneCallRecordingMutation, CreateOneCallRecordingMutationVariables>(CreateOneCallRecordingDocument, options);
      }
export type CreateOneCallRecordingMutationHookResult = ReturnType<typeof useCreateOneCallRecordingMutation>;
export type CreateOneCallRecordingMutationResult = Apollo.MutationResult<CreateOneCallRecordingMutation>;
export type CreateOneCallRecordingMutationOptions = Apollo.BaseMutationOptions<CreateOneCallRecordingMutation, CreateOneCallRecordingMutationVariables>;
export const CreateTwilioTokenDocument = gql`
    mutation createTwilioToken($identity: String!) {
  createTwilioToken(data: {identity: $identity}) {
    token
  }
}
    `;
export type CreateTwilioTokenMutationFn = Apollo.MutationFunction<CreateTwilioTokenMutation, CreateTwilioTokenMutationVariables>;

/**
 * __useCreateTwilioTokenMutation__
 *
 * To run a mutation, you first call `useCreateTwilioTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTwilioTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTwilioTokenMutation, { data, loading, error }] = useCreateTwilioTokenMutation({
 *   variables: {
 *      identity: // value for 'identity'
 *   },
 * });
 */
export function useCreateTwilioTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateTwilioTokenMutation, CreateTwilioTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTwilioTokenMutation, CreateTwilioTokenMutationVariables>(CreateTwilioTokenDocument, options);
      }
export type CreateTwilioTokenMutationHookResult = ReturnType<typeof useCreateTwilioTokenMutation>;
export type CreateTwilioTokenMutationResult = Apollo.MutationResult<CreateTwilioTokenMutation>;
export type CreateTwilioTokenMutationOptions = Apollo.BaseMutationOptions<CreateTwilioTokenMutation, CreateTwilioTokenMutationVariables>;
export const EndAxionPhoneCallDocument = gql`
    mutation endAxionPhoneCall($callId: String!, $userId: String!) {
  endOneAxionCall(data: {callId: $callId, userId: $userId}) {
    result
  }
}
    `;
export type EndAxionPhoneCallMutationFn = Apollo.MutationFunction<EndAxionPhoneCallMutation, EndAxionPhoneCallMutationVariables>;

/**
 * __useEndAxionPhoneCallMutation__
 *
 * To run a mutation, you first call `useEndAxionPhoneCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndAxionPhoneCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endAxionPhoneCallMutation, { data, loading, error }] = useEndAxionPhoneCallMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEndAxionPhoneCallMutation(baseOptions?: Apollo.MutationHookOptions<EndAxionPhoneCallMutation, EndAxionPhoneCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndAxionPhoneCallMutation, EndAxionPhoneCallMutationVariables>(EndAxionPhoneCallDocument, options);
      }
export type EndAxionPhoneCallMutationHookResult = ReturnType<typeof useEndAxionPhoneCallMutation>;
export type EndAxionPhoneCallMutationResult = Apollo.MutationResult<EndAxionPhoneCallMutation>;
export type EndAxionPhoneCallMutationOptions = Apollo.BaseMutationOptions<EndAxionPhoneCallMutation, EndAxionPhoneCallMutationVariables>;
export const IgnoreAxionPhoneCallDocument = gql`
    mutation ignoreAxionPhoneCall($callId: String!, $userId: String!, $action: IgnoreCallAction!) {
  ignoreOneAxionCall(data: {callId: $callId, userId: $userId, action: $action}) {
    result
  }
}
    `;
export type IgnoreAxionPhoneCallMutationFn = Apollo.MutationFunction<IgnoreAxionPhoneCallMutation, IgnoreAxionPhoneCallMutationVariables>;

/**
 * __useIgnoreAxionPhoneCallMutation__
 *
 * To run a mutation, you first call `useIgnoreAxionPhoneCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreAxionPhoneCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreAxionPhoneCallMutation, { data, loading, error }] = useIgnoreAxionPhoneCallMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      userId: // value for 'userId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useIgnoreAxionPhoneCallMutation(baseOptions?: Apollo.MutationHookOptions<IgnoreAxionPhoneCallMutation, IgnoreAxionPhoneCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnoreAxionPhoneCallMutation, IgnoreAxionPhoneCallMutationVariables>(IgnoreAxionPhoneCallDocument, options);
      }
export type IgnoreAxionPhoneCallMutationHookResult = ReturnType<typeof useIgnoreAxionPhoneCallMutation>;
export type IgnoreAxionPhoneCallMutationResult = Apollo.MutationResult<IgnoreAxionPhoneCallMutation>;
export type IgnoreAxionPhoneCallMutationOptions = Apollo.BaseMutationOptions<IgnoreAxionPhoneCallMutation, IgnoreAxionPhoneCallMutationVariables>;
export const UpdateOneCallHistoryDocument = gql`
    mutation updateOneCallHistory($where: CallHistoryWhereUniqueInput!, $data: CallHistoryUpdateInput!) {
  updateOneCallHistory(where: $where, data: $data) {
    id
    status
    duration
  }
}
    `;
export type UpdateOneCallHistoryMutationFn = Apollo.MutationFunction<UpdateOneCallHistoryMutation, UpdateOneCallHistoryMutationVariables>;

/**
 * __useUpdateOneCallHistoryMutation__
 *
 * To run a mutation, you first call `useUpdateOneCallHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCallHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCallHistoryMutation, { data, loading, error }] = useUpdateOneCallHistoryMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneCallHistoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneCallHistoryMutation, UpdateOneCallHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneCallHistoryMutation, UpdateOneCallHistoryMutationVariables>(UpdateOneCallHistoryDocument, options);
      }
export type UpdateOneCallHistoryMutationHookResult = ReturnType<typeof useUpdateOneCallHistoryMutation>;
export type UpdateOneCallHistoryMutationResult = Apollo.MutationResult<UpdateOneCallHistoryMutation>;
export type UpdateOneCallHistoryMutationOptions = Apollo.BaseMutationOptions<UpdateOneCallHistoryMutation, UpdateOneCallHistoryMutationVariables>;
export const UpdateOneCallRecordingDocument = gql`
    mutation updateOneCallRecording($where: CallRecordingWhereUniqueInput!, $data: CallRecordingUpdateInput!) {
  updateOneCallRecording(where: $where, data: $data) {
    id
  }
}
    `;
export type UpdateOneCallRecordingMutationFn = Apollo.MutationFunction<UpdateOneCallRecordingMutation, UpdateOneCallRecordingMutationVariables>;

/**
 * __useUpdateOneCallRecordingMutation__
 *
 * To run a mutation, you first call `useUpdateOneCallRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCallRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCallRecordingMutation, { data, loading, error }] = useUpdateOneCallRecordingMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneCallRecordingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneCallRecordingMutation, UpdateOneCallRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneCallRecordingMutation, UpdateOneCallRecordingMutationVariables>(UpdateOneCallRecordingDocument, options);
      }
export type UpdateOneCallRecordingMutationHookResult = ReturnType<typeof useUpdateOneCallRecordingMutation>;
export type UpdateOneCallRecordingMutationResult = Apollo.MutationResult<UpdateOneCallRecordingMutation>;
export type UpdateOneCallRecordingMutationOptions = Apollo.BaseMutationOptions<UpdateOneCallRecordingMutation, UpdateOneCallRecordingMutationVariables>;
export const GetPhoneCallParticipantDocument = gql`
    query getPhoneCallParticipant($clinicPetParentId: String!, $eventsAfter: DateTime!, $eventsBefore: DateTime!, $clinicId: String!) {
  findUniqueClinicPetParent(where: {id: $clinicPetParentId}) {
    ...PhoneCallParticipant
  }
}
    ${PhoneCallParticipantFragmentDoc}`;

/**
 * __useGetPhoneCallParticipantQuery__
 *
 * To run a query within a React component, call `useGetPhoneCallParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneCallParticipantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneCallParticipantQuery({
 *   variables: {
 *      clinicPetParentId: // value for 'clinicPetParentId'
 *      eventsAfter: // value for 'eventsAfter'
 *      eventsBefore: // value for 'eventsBefore'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetPhoneCallParticipantQuery(baseOptions: Apollo.QueryHookOptions<GetPhoneCallParticipantQuery, GetPhoneCallParticipantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhoneCallParticipantQuery, GetPhoneCallParticipantQueryVariables>(GetPhoneCallParticipantDocument, options);
      }
export function useGetPhoneCallParticipantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhoneCallParticipantQuery, GetPhoneCallParticipantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhoneCallParticipantQuery, GetPhoneCallParticipantQueryVariables>(GetPhoneCallParticipantDocument, options);
        }
export type GetPhoneCallParticipantQueryHookResult = ReturnType<typeof useGetPhoneCallParticipantQuery>;
export type GetPhoneCallParticipantLazyQueryHookResult = ReturnType<typeof useGetPhoneCallParticipantLazyQuery>;
export type GetPhoneCallParticipantQueryResult = Apollo.QueryResult<GetPhoneCallParticipantQuery, GetPhoneCallParticipantQueryVariables>;
export function refetchGetPhoneCallParticipantQuery(variables?: GetPhoneCallParticipantQueryVariables) {
      return { query: GetPhoneCallParticipantDocument, variables: variables }
    }
export const GetTwilioPhoneTokenDocument = gql`
    query getTwilioPhoneToken {
  twilioCapabilityToken(type: Phone) {
    token
  }
}
    `;

/**
 * __useGetTwilioPhoneTokenQuery__
 *
 * To run a query within a React component, call `useGetTwilioPhoneTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwilioPhoneTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwilioPhoneTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTwilioPhoneTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetTwilioPhoneTokenQuery, GetTwilioPhoneTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwilioPhoneTokenQuery, GetTwilioPhoneTokenQueryVariables>(GetTwilioPhoneTokenDocument, options);
      }
export function useGetTwilioPhoneTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwilioPhoneTokenQuery, GetTwilioPhoneTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwilioPhoneTokenQuery, GetTwilioPhoneTokenQueryVariables>(GetTwilioPhoneTokenDocument, options);
        }
export type GetTwilioPhoneTokenQueryHookResult = ReturnType<typeof useGetTwilioPhoneTokenQuery>;
export type GetTwilioPhoneTokenLazyQueryHookResult = ReturnType<typeof useGetTwilioPhoneTokenLazyQuery>;
export type GetTwilioPhoneTokenQueryResult = Apollo.QueryResult<GetTwilioPhoneTokenQuery, GetTwilioPhoneTokenQueryVariables>;
export function refetchGetTwilioPhoneTokenQuery(variables?: GetTwilioPhoneTokenQueryVariables) {
      return { query: GetTwilioPhoneTokenDocument, variables: variables }
    }
export const SubscribeToCallHistoryChangedDocument = gql`
    subscription subscribeToCallHistoryChanged($clinicId: String!, $extension: String) {
  callHistoryChanged(where: {clinicId: $clinicId, extension: $extension}) {
    mutation
    node {
      ...CallHistorySelection
    }
  }
}
    ${CallHistorySelectionFragmentDoc}`;

/**
 * __useSubscribeToCallHistoryChangedSubscription__
 *
 * To run a query within a React component, call `useSubscribeToCallHistoryChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToCallHistoryChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToCallHistoryChangedSubscription({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      extension: // value for 'extension'
 *   },
 * });
 */
export function useSubscribeToCallHistoryChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToCallHistoryChangedSubscription, SubscribeToCallHistoryChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToCallHistoryChangedSubscription, SubscribeToCallHistoryChangedSubscriptionVariables>(SubscribeToCallHistoryChangedDocument, options);
      }
export type SubscribeToCallHistoryChangedSubscriptionHookResult = ReturnType<typeof useSubscribeToCallHistoryChangedSubscription>;
export type SubscribeToCallHistoryChangedSubscriptionResult = Apollo.SubscriptionResult<SubscribeToCallHistoryChangedSubscription>;
export const GetTerminalTokenDocument = gql`
    query getTerminalToken($where: StripeTerminalLocationUniqueInput!) {
  getTerminalToken(where: $where) {
    secret
  }
}
    `;

/**
 * __useGetTerminalTokenQuery__
 *
 * To run a query within a React component, call `useGetTerminalTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerminalTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTerminalTokenQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTerminalTokenQuery(baseOptions: Apollo.QueryHookOptions<GetTerminalTokenQuery, GetTerminalTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTerminalTokenQuery, GetTerminalTokenQueryVariables>(GetTerminalTokenDocument, options);
      }
export function useGetTerminalTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTerminalTokenQuery, GetTerminalTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTerminalTokenQuery, GetTerminalTokenQueryVariables>(GetTerminalTokenDocument, options);
        }
export type GetTerminalTokenQueryHookResult = ReturnType<typeof useGetTerminalTokenQuery>;
export type GetTerminalTokenLazyQueryHookResult = ReturnType<typeof useGetTerminalTokenLazyQuery>;
export type GetTerminalTokenQueryResult = Apollo.QueryResult<GetTerminalTokenQuery, GetTerminalTokenQueryVariables>;
export function refetchGetTerminalTokenQuery(variables?: GetTerminalTokenQueryVariables) {
      return { query: GetTerminalTokenDocument, variables: variables }
    }
export const FindManyStripePayoutDocument = gql`
    query findManyStripePayout($where: StripePayoutWhereInput!, $skip: Int, $take: Int) {
  findManyStripePayoutCount(where: $where)
  findManyStripePayout(where: $where, skip: $skip, take: $take) {
    ...StripePayoutSelection
  }
}
    ${StripePayoutSelectionFragmentDoc}`;

/**
 * __useFindManyStripePayoutQuery__
 *
 * To run a query within a React component, call `useFindManyStripePayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyStripePayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyStripePayoutQuery({
 *   variables: {
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useFindManyStripePayoutQuery(baseOptions: Apollo.QueryHookOptions<FindManyStripePayoutQuery, FindManyStripePayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyStripePayoutQuery, FindManyStripePayoutQueryVariables>(FindManyStripePayoutDocument, options);
      }
export function useFindManyStripePayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyStripePayoutQuery, FindManyStripePayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyStripePayoutQuery, FindManyStripePayoutQueryVariables>(FindManyStripePayoutDocument, options);
        }
export type FindManyStripePayoutQueryHookResult = ReturnType<typeof useFindManyStripePayoutQuery>;
export type FindManyStripePayoutLazyQueryHookResult = ReturnType<typeof useFindManyStripePayoutLazyQuery>;
export type FindManyStripePayoutQueryResult = Apollo.QueryResult<FindManyStripePayoutQuery, FindManyStripePayoutQueryVariables>;
export function refetchFindManyStripePayoutQuery(variables?: FindManyStripePayoutQueryVariables) {
      return { query: FindManyStripePayoutDocument, variables: variables }
    }
export const GetClinicChannelStatusesDocument = gql`
    query getClinicChannelStatuses($clinicId: String!) {
  findManyChannelStatus(
    where: {clinicSetting: {clinic: {id: {equals: $clinicId}}}, deletedOn: {equals: null}}
    orderBy: {order: asc}
  ) {
    ...FullChannelStatus
  }
}
    ${FullChannelStatusFragmentDoc}`;

/**
 * __useGetClinicChannelStatusesQuery__
 *
 * To run a query within a React component, call `useGetClinicChannelStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicChannelStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicChannelStatusesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicChannelStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetClinicChannelStatusesQuery, GetClinicChannelStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicChannelStatusesQuery, GetClinicChannelStatusesQueryVariables>(GetClinicChannelStatusesDocument, options);
      }
export function useGetClinicChannelStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicChannelStatusesQuery, GetClinicChannelStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicChannelStatusesQuery, GetClinicChannelStatusesQueryVariables>(GetClinicChannelStatusesDocument, options);
        }
export type GetClinicChannelStatusesQueryHookResult = ReturnType<typeof useGetClinicChannelStatusesQuery>;
export type GetClinicChannelStatusesLazyQueryHookResult = ReturnType<typeof useGetClinicChannelStatusesLazyQuery>;
export type GetClinicChannelStatusesQueryResult = Apollo.QueryResult<GetClinicChannelStatusesQuery, GetClinicChannelStatusesQueryVariables>;
export function refetchGetClinicChannelStatusesQuery(variables?: GetClinicChannelStatusesQueryVariables) {
      return { query: GetClinicChannelStatusesDocument, variables: variables }
    }
export const GetUniqueChannelStatusDocument = gql`
    query getUniqueChannelStatus($where: ChannelStatusWhereUniqueInput!) {
  findUniqueChannelStatus(where: $where) {
    ...FullChannelStatus
  }
}
    ${FullChannelStatusFragmentDoc}`;

/**
 * __useGetUniqueChannelStatusQuery__
 *
 * To run a query within a React component, call `useGetUniqueChannelStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqueChannelStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqueChannelStatusQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUniqueChannelStatusQuery(baseOptions: Apollo.QueryHookOptions<GetUniqueChannelStatusQuery, GetUniqueChannelStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniqueChannelStatusQuery, GetUniqueChannelStatusQueryVariables>(GetUniqueChannelStatusDocument, options);
      }
export function useGetUniqueChannelStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniqueChannelStatusQuery, GetUniqueChannelStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniqueChannelStatusQuery, GetUniqueChannelStatusQueryVariables>(GetUniqueChannelStatusDocument, options);
        }
export type GetUniqueChannelStatusQueryHookResult = ReturnType<typeof useGetUniqueChannelStatusQuery>;
export type GetUniqueChannelStatusLazyQueryHookResult = ReturnType<typeof useGetUniqueChannelStatusLazyQuery>;
export type GetUniqueChannelStatusQueryResult = Apollo.QueryResult<GetUniqueChannelStatusQuery, GetUniqueChannelStatusQueryVariables>;
export function refetchGetUniqueChannelStatusQuery(variables?: GetUniqueChannelStatusQueryVariables) {
      return { query: GetUniqueChannelStatusDocument, variables: variables }
    }
export const GetClinicPaymentActivityDocument = gql`
    query getClinicPaymentActivity {
  clinicPaymentActivity {
    success
    error
    totalRecentTransactions
    totalRecentCentsProcessed
  }
}
    `;

/**
 * __useGetClinicPaymentActivityQuery__
 *
 * To run a query within a React component, call `useGetClinicPaymentActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicPaymentActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicPaymentActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClinicPaymentActivityQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicPaymentActivityQuery, GetClinicPaymentActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicPaymentActivityQuery, GetClinicPaymentActivityQueryVariables>(GetClinicPaymentActivityDocument, options);
      }
export function useGetClinicPaymentActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicPaymentActivityQuery, GetClinicPaymentActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicPaymentActivityQuery, GetClinicPaymentActivityQueryVariables>(GetClinicPaymentActivityDocument, options);
        }
export type GetClinicPaymentActivityQueryHookResult = ReturnType<typeof useGetClinicPaymentActivityQuery>;
export type GetClinicPaymentActivityLazyQueryHookResult = ReturnType<typeof useGetClinicPaymentActivityLazyQuery>;
export type GetClinicPaymentActivityQueryResult = Apollo.QueryResult<GetClinicPaymentActivityQuery, GetClinicPaymentActivityQueryVariables>;
export function refetchGetClinicPaymentActivityQuery(variables?: GetClinicPaymentActivityQueryVariables) {
      return { query: GetClinicPaymentActivityDocument, variables: variables }
    }
export const GetUnreadMessageCountDocument = gql`
    query getUnreadMessageCount {
  channelUnreadMessageCount {
    total
    unreadChannels {
      channelId
      channelLastMessageIndex
      lastConsumedMessageIndex
      unreadMessageCount
      channelType
    }
    client {
      total
      unreadChannels {
        channelId
        channelLastMessageIndex
        lastConsumedMessageIndex
        unreadMessageCount
        channelType
      }
    }
    team {
      total
      unreadChannels {
        channelId
        channelLastMessageIndex
        lastConsumedMessageIndex
        unreadMessageCount
        channelType
      }
    }
  }
}
    `;

/**
 * __useGetUnreadMessageCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadMessageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadMessageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadMessageCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadMessageCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUnreadMessageCountQuery, GetUnreadMessageCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadMessageCountQuery, GetUnreadMessageCountQueryVariables>(GetUnreadMessageCountDocument, options);
      }
export function useGetUnreadMessageCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadMessageCountQuery, GetUnreadMessageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadMessageCountQuery, GetUnreadMessageCountQueryVariables>(GetUnreadMessageCountDocument, options);
        }
export type GetUnreadMessageCountQueryHookResult = ReturnType<typeof useGetUnreadMessageCountQuery>;
export type GetUnreadMessageCountLazyQueryHookResult = ReturnType<typeof useGetUnreadMessageCountLazyQuery>;
export type GetUnreadMessageCountQueryResult = Apollo.QueryResult<GetUnreadMessageCountQuery, GetUnreadMessageCountQueryVariables>;
export function refetchGetUnreadMessageCountQuery(variables?: GetUnreadMessageCountQueryVariables) {
      return { query: GetUnreadMessageCountDocument, variables: variables }
    }